var OAe = Object.defineProperty;
var PAe = (e, t, n) => t in e ? OAe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var fr = (e, t, n) => (PAe(e, typeof t != "symbol" ? t + "" : t, n), n), $O = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var Oe = (e, t, n) => ($O(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Vt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, It = (e, t, n, o) => ($O(e, t, "write to private field"), o ? o.call(e, n) : t.set(e, n), n);
var W1 = (e, t, n, o) => ({
  set _(r) {
    It(e, t, r, n);
  },
  get _() {
    return Oe(e, t, o);
  }
}), bn = (e, t, n) => ($O(e, t, "access private method"), n);
import PT, { jsx as m, Fragment as Ce, jsxs as Y } from "react/jsx-runtime";
import * as $e from "react";
import ve, { useCallback as at, createContext as No, useMemo as Tt, createElement as Pe, useContext as Pn, forwardRef as it, Children as Dp, isValidElement as bl, cloneElement as w_, Fragment as Oi, useEffect as Le, useRef as Ue, useState as ze, useLayoutEffect as ts, useReducer as R0, Component as xie, useId as N0, useImperativeHandle as Eie, useInsertionEffect as Tie, createRef as IAe, Suspense as IT, memo as Aie, useDebugValue as RAe } from "react";
import * as NAe from "react-dom";
import Uv, { flushSync as Cie, createPortal as Wv, unstable_batchedUpdates as zie } from "react-dom";
var rg = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, xv = typeof window > "u" || "Deno" in window;
function sl() {
}
function DAe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kN(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Oie(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function wB(e, t) {
  const {
    type: n = "all",
    exact: o,
    fetchStatus: r,
    predicate: i,
    queryKey: a,
    stale: s
  } = e;
  if (a) {
    if (o) {
      if (t.queryHash !== $q(a, t.options))
        return !1;
    } else if (!aw(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || typeof r < "u" && r !== t.state.fetchStatus || i && !i(t));
}
function kB(e, t) {
  const { exact: n, status: o, predicate: r, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Hp(t.options.mutationKey) !== Hp(i))
        return !1;
    } else if (!aw(t.options.mutationKey, i))
      return !1;
  }
  return !(o && t.state.status !== o || r && !r(t));
}
function $q(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Hp)(e);
}
function Hp(e) {
  return JSON.stringify(
    e,
    (t, n) => SN(n) ? Object.keys(n).sort().reduce((o, r) => (o[r] = n[r], o), {}) : n
  );
}
function aw(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !aw(e[n], t[n])) : !1;
}
function wq(e, t) {
  if (e === t)
    return e;
  const n = SB(e) && SB(t);
  if (n || SN(e) && SN(t)) {
    const o = n ? e : Object.keys(e), r = o.length, i = n ? t : Object.keys(t), a = i.length, s = n ? [] : {};
    let c = 0;
    for (let l = 0; l < a; l++) {
      const d = n ? l : i[l];
      !n && e[d] === void 0 && t[d] === void 0 && o.includes(d) ? (s[d] = void 0, c++) : (s[d] = wq(e[d], t[d]), s[d] === e[d] && e[d] !== void 0 && c++);
    }
    return r === a && c === r ? e : s;
  }
  return t;
}
function bx(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function SB(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function SN(e) {
  if (!xB(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!xB(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function xB(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function MAe(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function xN(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? wq(e, t) : t;
}
function LAe(e, t, n = 0) {
  const o = [...e, t];
  return n && o.length > n ? o.slice(1) : o;
}
function qAe(e, t, n = 0) {
  const o = [t, ...e];
  return n && o.length > n ? o.slice(0, -1) : o;
}
var ff, bp, iv, eie, jAe = (eie = class extends rg {
  constructor() {
    super();
    Vt(this, ff, void 0);
    Vt(this, bp, void 0);
    Vt(this, iv, void 0);
    It(this, iv, (t) => {
      if (!xv && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    Oe(this, bp) || this.setEventListener(Oe(this, iv));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = Oe(this, bp)) == null || t.call(this), It(this, bp, void 0));
  }
  setEventListener(t) {
    var n;
    It(this, iv, t), (n = Oe(this, bp)) == null || n.call(this), It(this, bp, t((o) => {
      typeof o == "boolean" ? this.setFocused(o) : this.onFocus();
    }));
  }
  setFocused(t) {
    Oe(this, ff) !== t && (It(this, ff, t), this.onFocus());
  }
  onFocus() {
    this.listeners.forEach((t) => {
      t();
    });
  }
  isFocused() {
    var t;
    return typeof Oe(this, ff) == "boolean" ? Oe(this, ff) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, ff = new WeakMap(), bp = new WeakMap(), iv = new WeakMap(), eie), yx = new jAe(), av, yp, sv, tie, FAe = (tie = class extends rg {
  constructor() {
    super();
    Vt(this, av, !0);
    Vt(this, yp, void 0);
    Vt(this, sv, void 0);
    It(this, sv, (t) => {
      if (!xv && window.addEventListener) {
        const n = () => t(!0), o = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", o, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", o);
        };
      }
    });
  }
  onSubscribe() {
    Oe(this, yp) || this.setEventListener(Oe(this, sv));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = Oe(this, yp)) == null || t.call(this), It(this, yp, void 0));
  }
  setEventListener(t) {
    var n;
    It(this, sv, t), (n = Oe(this, yp)) == null || n.call(this), It(this, yp, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    Oe(this, av) !== t && (It(this, av, t), this.listeners.forEach((o) => {
      o(t);
    }));
  }
  isOnline() {
    return Oe(this, av);
  }
}, av = new WeakMap(), yp = new WeakMap(), sv = new WeakMap(), tie), $x = new FAe();
function VAe(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function RT(e) {
  return (e ?? "online") === "online" ? $x.isOnline() : !0;
}
var Pie = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function wO(e) {
  return e instanceof Pie;
}
function Iie(e) {
  let t = !1, n = 0, o = !1, r, i, a;
  const s = new Promise((h, b) => {
    i = h, a = b;
  }), c = (h) => {
    var b;
    o || (p(new Pie(h)), (b = e.abort) == null || b.call(e));
  }, l = () => {
    t = !0;
  }, d = () => {
    t = !1;
  }, u = () => !yx.isFocused() || e.networkMode !== "always" && !$x.isOnline(), _ = (h) => {
    var b;
    o || (o = !0, (b = e.onSuccess) == null || b.call(e, h), r == null || r(), i(h));
  }, p = (h) => {
    var b;
    o || (o = !0, (b = e.onError) == null || b.call(e, h), r == null || r(), a(h));
  }, f = () => new Promise((h) => {
    var b;
    r = (v) => {
      const $ = o || !u();
      return $ && h(v), $;
    }, (b = e.onPause) == null || b.call(e);
  }).then(() => {
    var h;
    r = void 0, o || (h = e.onContinue) == null || h.call(e);
  }), g = () => {
    if (o)
      return;
    let h;
    try {
      h = e.fn();
    } catch (b) {
      h = Promise.reject(b);
    }
    Promise.resolve(h).then(_).catch((b) => {
      var O;
      if (o)
        return;
      const v = e.retry ?? (xv ? 0 : 3), $ = e.retryDelay ?? VAe, k = typeof $ == "function" ? $(n, b) : $, S = v === !0 || typeof v == "number" && n < v || typeof v == "function" && v(n, b);
      if (t || !S) {
        p(b);
        return;
      }
      n++, (O = e.onFail) == null || O.call(e, n, b), MAe(k).then(() => {
        if (u())
          return f();
      }).then(() => {
        t ? p(b) : g();
      });
    });
  };
  return RT(e.networkMode) ? g() : f().then(g), {
    promise: s,
    cancel: c,
    continue: () => (r == null ? void 0 : r()) ? s : Promise.resolve(),
    cancelRetry: l,
    continueRetry: d
  };
}
function BAe() {
  let e = [], t = 0, n = (_) => {
    _();
  }, o = (_) => {
    _();
  }, r = (_) => setTimeout(_, 0);
  const i = (_) => {
    r = _;
  }, a = (_) => {
    let p;
    t++;
    try {
      p = _();
    } finally {
      t--, t || l();
    }
    return p;
  }, s = (_) => {
    t ? e.push(_) : r(() => {
      n(_);
    });
  }, c = (_) => (...p) => {
    s(() => {
      _(...p);
    });
  }, l = () => {
    const _ = e;
    e = [], _.length && r(() => {
      o(() => {
        _.forEach((p) => {
          n(p);
        });
      });
    });
  };
  return {
    batch: a,
    batchCalls: c,
    schedule: s,
    setNotifyFunction: (_) => {
      n = _;
    },
    setBatchNotifyFunction: (_) => {
      o = _;
    },
    setScheduler: i
  };
}
var gi = BAe(), gf, nie, Rie = (nie = class {
  constructor() {
    Vt(this, gf, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), kN(this.gcTime) && It(this, gf, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (xv ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    Oe(this, gf) && (clearTimeout(Oe(this, gf)), It(this, gf, void 0));
  }
}, gf = new WeakMap(), nie), cv, lv, rl, $p, il, Xi, g0, hf, dv, fS, Hl, Ju, oie, UAe = (oie = class extends Rie {
  constructor(n) {
    super();
    Vt(this, dv);
    Vt(this, Hl);
    Vt(this, cv, void 0);
    Vt(this, lv, void 0);
    Vt(this, rl, void 0);
    Vt(this, $p, void 0);
    Vt(this, il, void 0);
    Vt(this, Xi, void 0);
    Vt(this, g0, void 0);
    Vt(this, hf, void 0);
    It(this, hf, !1), It(this, g0, n.defaultOptions), bn(this, dv, fS).call(this, n.options), It(this, Xi, []), It(this, rl, n.cache), this.queryKey = n.queryKey, this.queryHash = n.queryHash, It(this, cv, n.state || WAe(this.options)), this.state = Oe(this, cv), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  optionalRemove() {
    !Oe(this, Xi).length && this.state.fetchStatus === "idle" && Oe(this, rl).remove(this);
  }
  setData(n, o) {
    const r = xN(this.state.data, n, this.options);
    return bn(this, Hl, Ju).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: o == null ? void 0 : o.updatedAt,
      manual: o == null ? void 0 : o.manual
    }), r;
  }
  setState(n, o) {
    bn(this, Hl, Ju).call(this, { type: "setState", state: n, setStateOptions: o });
  }
  cancel(n) {
    var r;
    const o = Oe(this, $p);
    return (r = Oe(this, il)) == null || r.cancel(n), o ? o.then(sl).catch(sl) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(Oe(this, cv));
  }
  isActive() {
    return Oe(this, Xi).some(
      (n) => n.options.enabled !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || Oe(this, Xi).some((n) => n.getCurrentResult().isStale);
  }
  isStaleByTime(n = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !Oie(this.state.dataUpdatedAt, n);
  }
  onFocus() {
    var o;
    const n = Oe(this, Xi).find((r) => r.shouldFetchOnWindowFocus());
    n == null || n.refetch({ cancelRefetch: !1 }), (o = Oe(this, il)) == null || o.continue();
  }
  onOnline() {
    var o;
    const n = Oe(this, Xi).find((r) => r.shouldFetchOnReconnect());
    n == null || n.refetch({ cancelRefetch: !1 }), (o = Oe(this, il)) == null || o.continue();
  }
  addObserver(n) {
    Oe(this, Xi).includes(n) || (Oe(this, Xi).push(n), this.clearGcTimeout(), Oe(this, rl).notify({ type: "observerAdded", query: this, observer: n }));
  }
  removeObserver(n) {
    Oe(this, Xi).includes(n) && (It(this, Xi, Oe(this, Xi).filter((o) => o !== n)), Oe(this, Xi).length || (Oe(this, il) && (Oe(this, hf) ? Oe(this, il).cancel({ revert: !0 }) : Oe(this, il).cancelRetry()), this.scheduleGc()), Oe(this, rl).notify({ type: "observerRemoved", query: this, observer: n }));
  }
  getObserversCount() {
    return Oe(this, Xi).length;
  }
  invalidate() {
    this.state.isInvalidated || bn(this, Hl, Ju).call(this, { type: "invalidate" });
  }
  fetch(n, o) {
    var d, u, _, p;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && (o != null && o.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (Oe(this, $p))
        return (d = Oe(this, il)) == null || d.continueRetry(), Oe(this, $p);
    }
    if (n && bn(this, dv, fS).call(this, n), !this.options.queryFn) {
      const f = Oe(this, Xi).find((g) => g.options.queryFn);
      f && bn(this, dv, fS).call(this, f.options);
    }
    const r = new AbortController(), i = {
      queryKey: this.queryKey,
      meta: this.meta
    }, a = (f) => {
      Object.defineProperty(f, "signal", {
        enumerable: !0,
        get: () => (It(this, hf, !0), r.signal)
      });
    };
    a(i);
    const s = () => this.options.queryFn ? (It(this, hf, !1), this.options.persister ? this.options.persister(
      this.options.queryFn,
      i,
      this
    ) : this.options.queryFn(
      i
    )) : Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ), c = {
      fetchOptions: o,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: s
    };
    a(c), (u = this.options.behavior) == null || u.onFetch(
      c,
      this
    ), It(this, lv, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_ = c.fetchOptions) == null ? void 0 : _.meta)) && bn(this, Hl, Ju).call(this, { type: "fetch", meta: (p = c.fetchOptions) == null ? void 0 : p.meta });
    const l = (f) => {
      var g, h, b, v;
      wO(f) && f.silent || bn(this, Hl, Ju).call(this, {
        type: "error",
        error: f
      }), wO(f) || ((h = (g = Oe(this, rl).config).onError) == null || h.call(
        g,
        f,
        this
      ), (v = (b = Oe(this, rl).config).onSettled) == null || v.call(
        b,
        this.state.data,
        f,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return It(this, il, Iie({
      fn: c.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (f) => {
        var g, h, b, v;
        if (typeof f > "u") {
          l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(f), (h = (g = Oe(this, rl).config).onSuccess) == null || h.call(g, f, this), (v = (b = Oe(this, rl).config).onSettled) == null || v.call(
          b,
          f,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: l,
      onFail: (f, g) => {
        bn(this, Hl, Ju).call(this, { type: "failed", failureCount: f, error: g });
      },
      onPause: () => {
        bn(this, Hl, Ju).call(this, { type: "pause" });
      },
      onContinue: () => {
        bn(this, Hl, Ju).call(this, { type: "continue" });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode
    })), It(this, $p, Oe(this, il).promise), Oe(this, $p);
  }
}, cv = new WeakMap(), lv = new WeakMap(), rl = new WeakMap(), $p = new WeakMap(), il = new WeakMap(), Xi = new WeakMap(), g0 = new WeakMap(), hf = new WeakMap(), dv = new WeakSet(), fS = function(n) {
  this.options = { ...Oe(this, g0), ...n }, this.updateGcTime(this.options.gcTime);
}, Hl = new WeakSet(), Ju = function(n) {
  const o = (r) => {
    switch (n.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: n.failureCount,
          fetchFailureReason: n.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          fetchFailureCount: 0,
          fetchFailureReason: null,
          fetchMeta: n.meta ?? null,
          fetchStatus: RT(this.options.networkMode) ? "fetching" : "paused",
          ...!r.dataUpdatedAt && {
            error: null,
            status: "pending"
          }
        };
      case "success":
        return {
          ...r,
          data: n.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: n.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!n.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = n.error;
        return wO(i) && i.revert && Oe(this, lv) ? { ...Oe(this, lv), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...n.state
        };
    }
  };
  this.state = o(this.state), gi.batch(() => {
    Oe(this, Xi).forEach((r) => {
      r.onQueryUpdate();
    }), Oe(this, rl).notify({ query: this, type: "updated", action: n });
  });
}, oie);
function WAe(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = typeof t < "u", o = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? o ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Id, rie, GAe = (rie = class extends rg {
  constructor(t = {}) {
    super();
    Vt(this, Id, void 0);
    this.config = t, It(this, Id, /* @__PURE__ */ new Map());
  }
  build(t, n, o) {
    const r = n.queryKey, i = n.queryHash ?? $q(r, n);
    let a = this.get(i);
    return a || (a = new UAe({
      cache: this,
      queryKey: r,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: o,
      defaultOptions: t.getQueryDefaults(r)
    }), this.add(a)), a;
  }
  add(t) {
    Oe(this, Id).has(t.queryHash) || (Oe(this, Id).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = Oe(this, Id).get(t.queryHash);
    n && (t.destroy(), n === t && Oe(this, Id).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    gi.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return Oe(this, Id).get(t);
  }
  getAll() {
    return [...Oe(this, Id).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (o) => wB(n, o)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((o) => wB(t, o)) : n;
  }
  notify(t) {
    gi.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    gi.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    gi.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Id = new WeakMap(), rie), Rd, h0, bc, uv, Nd, lp, iie, HAe = (iie = class extends Rie {
  constructor(t) {
    super();
    Vt(this, Nd);
    Vt(this, Rd, void 0);
    Vt(this, h0, void 0);
    Vt(this, bc, void 0);
    Vt(this, uv, void 0);
    this.mutationId = t.mutationId, It(this, h0, t.defaultOptions), It(this, bc, t.mutationCache), It(this, Rd, []), this.state = t.state || Nie(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = { ...Oe(this, h0), ...t }, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    Oe(this, Rd).includes(t) || (Oe(this, Rd).push(t), this.clearGcTimeout(), Oe(this, bc).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    It(this, Rd, Oe(this, Rd).filter((n) => n !== t)), this.scheduleGc(), Oe(this, bc).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    Oe(this, Rd).length || (this.state.status === "pending" ? this.scheduleGc() : Oe(this, bc).remove(this));
  }
  continue() {
    var t;
    return ((t = Oe(this, uv)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var r, i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O, I;
    const n = () => (It(this, uv, Iie({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (D, M) => {
        bn(this, Nd, lp).call(this, { type: "failed", failureCount: D, error: M });
      },
      onPause: () => {
        bn(this, Nd, lp).call(this, { type: "pause" });
      },
      onContinue: () => {
        bn(this, Nd, lp).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode
    })), Oe(this, uv).promise), o = this.state.status === "pending";
    try {
      if (!o) {
        bn(this, Nd, lp).call(this, { type: "pending", variables: t }), await ((i = (r = Oe(this, bc).config).onMutate) == null ? void 0 : i.call(
          r,
          t,
          this
        ));
        const M = await ((s = (a = this.options).onMutate) == null ? void 0 : s.call(a, t));
        M !== this.state.context && bn(this, Nd, lp).call(this, {
          type: "pending",
          context: M,
          variables: t
        });
      }
      const D = await n();
      return await ((l = (c = Oe(this, bc).config).onSuccess) == null ? void 0 : l.call(
        c,
        D,
        t,
        this.state.context,
        this
      )), await ((u = (d = this.options).onSuccess) == null ? void 0 : u.call(d, D, t, this.state.context)), await ((p = (_ = Oe(this, bc).config).onSettled) == null ? void 0 : p.call(
        _,
        D,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((g = (f = this.options).onSettled) == null ? void 0 : g.call(f, D, null, t, this.state.context)), bn(this, Nd, lp).call(this, { type: "success", data: D }), D;
    } catch (D) {
      try {
        throw await ((b = (h = Oe(this, bc).config).onError) == null ? void 0 : b.call(
          h,
          D,
          t,
          this.state.context,
          this
        )), await (($ = (v = this.options).onError) == null ? void 0 : $.call(
          v,
          D,
          t,
          this.state.context
        )), await ((S = (k = Oe(this, bc).config).onSettled) == null ? void 0 : S.call(
          k,
          void 0,
          D,
          this.state.variables,
          this.state.context,
          this
        )), await ((I = (O = this.options).onSettled) == null ? void 0 : I.call(
          O,
          void 0,
          D,
          t,
          this.state.context
        )), D;
      } finally {
        bn(this, Nd, lp).call(this, { type: "error", error: D });
      }
    }
  }
}, Rd = new WeakMap(), h0 = new WeakMap(), bc = new WeakMap(), uv = new WeakMap(), Nd = new WeakSet(), lp = function(t) {
  const n = (o) => {
    switch (t.type) {
      case "failed":
        return {
          ...o,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...o,
          isPaused: !0
        };
      case "continue":
        return {
          ...o,
          isPaused: !1
        };
      case "pending":
        return {
          ...o,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: !RT(this.options.networkMode),
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...o,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...o,
          data: void 0,
          error: t.error,
          failureCount: o.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), gi.batch(() => {
    Oe(this, Rd).forEach((o) => {
      o.onMutationUpdate(t);
    }), Oe(this, bc).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, iie);
function Nie() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var al, v0, vf, aie, KAe = (aie = class extends rg {
  constructor(t = {}) {
    super();
    Vt(this, al, void 0);
    Vt(this, v0, void 0);
    Vt(this, vf, void 0);
    this.config = t, It(this, al, []), It(this, v0, 0);
  }
  build(t, n, o) {
    const r = new HAe({
      mutationCache: this,
      mutationId: ++W1(this, v0)._,
      options: t.defaultMutationOptions(n),
      state: o
    });
    return this.add(r), r;
  }
  add(t) {
    Oe(this, al).push(t), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    It(this, al, Oe(this, al).filter((n) => n !== t)), this.notify({ type: "removed", mutation: t });
  }
  clear() {
    gi.batch(() => {
      Oe(this, al).forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return Oe(this, al);
  }
  find(t) {
    const n = { exact: !0, ...t };
    return Oe(this, al).find(
      (o) => kB(n, o)
    );
  }
  findAll(t = {}) {
    return Oe(this, al).filter(
      (n) => kB(t, n)
    );
  }
  notify(t) {
    gi.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    return It(this, vf, (Oe(this, vf) ?? Promise.resolve()).then(() => {
      const t = Oe(this, al).filter((n) => n.state.isPaused);
      return gi.batch(
        () => t.reduce(
          (n, o) => n.then(() => o.continue().catch(sl)),
          Promise.resolve()
        )
      );
    }).then(() => {
      It(this, vf, void 0);
    })), Oe(this, vf);
  }
}, al = new WeakMap(), v0 = new WeakMap(), vf = new WeakMap(), aie);
function EN(e) {
  return {
    onFetch: (t, n) => {
      const o = async () => {
        var f, g, h, b, v;
        const r = t.options, i = (h = (g = (f = t.fetchOptions) == null ? void 0 : f.meta) == null ? void 0 : g.fetchMore) == null ? void 0 : h.direction, a = ((b = t.state.data) == null ? void 0 : b.pages) || [], s = ((v = t.state.data) == null ? void 0 : v.pageParams) || [], c = { pages: [], pageParams: [] };
        let l = !1;
        const d = ($) => {
          Object.defineProperty($, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? l = !0 : t.signal.addEventListener("abort", () => {
              l = !0;
            }), t.signal)
          });
        }, u = t.options.queryFn || (() => Promise.reject(
          new Error(`Missing queryFn: '${t.options.queryHash}'`)
        )), _ = async ($, k, S) => {
          if (l)
            return Promise.reject();
          if (k == null && $.pages.length)
            return Promise.resolve($);
          const O = {
            queryKey: t.queryKey,
            pageParam: k,
            direction: S ? "backward" : "forward",
            meta: t.options.meta
          };
          d(O);
          const I = await u(
            O
          ), { maxPages: D } = t.options, M = S ? qAe : LAe;
          return {
            pages: M($.pages, I, D),
            pageParams: M($.pageParams, k, D)
          };
        };
        let p;
        if (i && a.length) {
          const $ = i === "backward", k = $ ? Die : TN, S = {
            pages: a,
            pageParams: s
          }, O = k(r, S);
          p = await _(S, O, $);
        } else {
          p = await _(
            c,
            s[0] ?? r.initialPageParam
          );
          const $ = e ?? a.length;
          for (let k = 1; k < $; k++) {
            const S = TN(r, p);
            p = await _(p, S);
          }
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var r, i;
        return (i = (r = t.options).persister) == null ? void 0 : i.call(
          r,
          o,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = o;
    }
  };
}
function TN(e, { pages: t, pageParams: n }) {
  const o = t.length - 1;
  return e.getNextPageParam(
    t[o],
    t,
    n[o],
    n
  );
}
function Die(e, { pages: t, pageParams: n }) {
  var o;
  return (o = e.getPreviousPageParam) == null ? void 0 : o.call(
    e,
    t[0],
    t,
    n[0],
    n
  );
}
function YAe(e, t) {
  return t ? TN(e, t) != null : !1;
}
function ZAe(e, t) {
  return !t || !e.getPreviousPageParam ? !1 : Die(e, t) != null;
}
var Fi, wp, kp, _v, pv, Sp, mv, fv, sie, Mie = (sie = class {
  constructor(e = {}) {
    Vt(this, Fi, void 0);
    Vt(this, wp, void 0);
    Vt(this, kp, void 0);
    Vt(this, _v, void 0);
    Vt(this, pv, void 0);
    Vt(this, Sp, void 0);
    Vt(this, mv, void 0);
    Vt(this, fv, void 0);
    It(this, Fi, e.queryCache || new GAe()), It(this, wp, e.mutationCache || new KAe()), It(this, kp, e.defaultOptions || {}), It(this, _v, /* @__PURE__ */ new Map()), It(this, pv, /* @__PURE__ */ new Map()), It(this, Sp, 0);
  }
  mount() {
    W1(this, Sp)._++, Oe(this, Sp) === 1 && (It(this, mv, yx.subscribe(() => {
      yx.isFocused() && (this.resumePausedMutations(), Oe(this, Fi).onFocus());
    })), It(this, fv, $x.subscribe(() => {
      $x.isOnline() && (this.resumePausedMutations(), Oe(this, Fi).onOnline());
    })));
  }
  unmount() {
    var e, t;
    W1(this, Sp)._--, Oe(this, Sp) === 0 && ((e = Oe(this, mv)) == null || e.call(this), It(this, mv, void 0), (t = Oe(this, fv)) == null || t.call(this), It(this, fv, void 0));
  }
  isFetching(e) {
    return Oe(this, Fi).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return Oe(this, wp).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var t;
    return (t = Oe(this, Fi).find({ queryKey: e })) == null ? void 0 : t.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    return t !== void 0 ? Promise.resolve(t) : this.fetchQuery(e);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({ queryKey: t, state: n }) => {
      const o = n.data;
      return [t, o];
    });
  }
  setQueryData(e, t, n) {
    const o = Oe(this, Fi).find({ queryKey: e }), r = o == null ? void 0 : o.state.data, i = DAe(t, r);
    if (typeof i > "u")
      return;
    const a = this.defaultQueryOptions({ queryKey: e });
    return Oe(this, Fi).build(this, a).setData(i, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return gi.batch(
      () => this.getQueryCache().findAll(e).map(({ queryKey: o }) => [
        o,
        this.setQueryData(o, t, n)
      ])
    );
  }
  getQueryState(e) {
    var t;
    return (t = Oe(this, Fi).find({ queryKey: e })) == null ? void 0 : t.state;
  }
  removeQueries(e) {
    const t = Oe(this, Fi);
    gi.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = Oe(this, Fi), o = {
      type: "active",
      ...e
    };
    return gi.batch(() => (n.findAll(e).forEach((r) => {
      r.reset();
    }), this.refetchQueries(o, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, o = gi.batch(
      () => Oe(this, Fi).findAll(e).map((r) => r.cancel(n))
    );
    return Promise.all(o).then(sl).catch(sl);
  }
  invalidateQueries(e = {}, t = {}) {
    return gi.batch(() => {
      if (Oe(this, Fi).findAll(e).forEach((o) => {
        o.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, o = gi.batch(
      () => Oe(this, Fi).findAll(e).filter((r) => !r.isDisabled()).map((r) => {
        let i = r.fetch(void 0, n);
        return n.throwOnError || (i = i.catch(sl)), r.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(o).then(sl);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    typeof t.retry > "u" && (t.retry = !1);
    const n = Oe(this, Fi).build(this, t);
    return n.isStaleByTime(t.staleTime) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(sl).catch(sl);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = EN(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(sl).catch(sl);
  }
  resumePausedMutations() {
    return Oe(this, wp).resumePausedMutations();
  }
  getQueryCache() {
    return Oe(this, Fi);
  }
  getMutationCache() {
    return Oe(this, wp);
  }
  getDefaultOptions() {
    return Oe(this, kp);
  }
  setDefaultOptions(e) {
    It(this, kp, e);
  }
  setQueryDefaults(e, t) {
    Oe(this, _v).set(Hp(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...Oe(this, _v).values()];
    let n = {};
    return t.forEach((o) => {
      aw(e, o.queryKey) && (n = { ...n, ...o.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    Oe(this, pv).set(Hp(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...Oe(this, pv).values()];
    let n = {};
    return t.forEach((o) => {
      aw(e, o.mutationKey) && (n = { ...n, ...o.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const t = {
      ...Oe(this, kp).queries,
      ...(e == null ? void 0 : e.queryKey) && this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = $q(
      t.queryKey,
      t
    )), typeof t.refetchOnReconnect > "u" && (t.refetchOnReconnect = t.networkMode !== "always"), typeof t.throwOnError > "u" && (t.throwOnError = !!t.suspense), typeof t.networkMode > "u" && t.persister && (t.networkMode = "offlineFirst"), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...Oe(this, kp).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    Oe(this, Fi).clear(), Oe(this, wp).clear();
  }
}, Fi = new WeakMap(), wp = new WeakMap(), kp = new WeakMap(), _v = new WeakMap(), pv = new WeakMap(), Sp = new WeakMap(), mv = new WeakMap(), fv = new WeakMap(), sie), Gs, Wr, b0, ms, bf, gv, Dd, y0, hv, vv, yf, $f, xp, bv, wf, c$, $0, AN, w0, CN, k0, zN, S0, ON, x0, PN, E0, IN, T0, RN, OT, Lie, cie, D0 = (cie = class extends rg {
  constructor(t, n) {
    super();
    Vt(this, wf);
    Vt(this, $0);
    Vt(this, w0);
    Vt(this, k0);
    Vt(this, S0);
    Vt(this, x0);
    Vt(this, E0);
    Vt(this, T0);
    Vt(this, OT);
    Vt(this, Gs, void 0);
    Vt(this, Wr, void 0);
    Vt(this, b0, void 0);
    Vt(this, ms, void 0);
    Vt(this, bf, void 0);
    Vt(this, gv, void 0);
    Vt(this, Dd, void 0);
    Vt(this, y0, void 0);
    Vt(this, hv, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    Vt(this, vv, void 0);
    Vt(this, yf, void 0);
    Vt(this, $f, void 0);
    Vt(this, xp, void 0);
    Vt(this, bv, /* @__PURE__ */ new Set());
    this.options = n, It(this, Gs, t), It(this, Dd, null), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (Oe(this, Wr).addObserver(this), EB(Oe(this, Wr), this.options) ? bn(this, wf, c$).call(this) : this.updateResult(), bn(this, S0, ON).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return NN(
      Oe(this, Wr),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return NN(
      Oe(this, Wr),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), bn(this, x0, PN).call(this), bn(this, E0, IN).call(this), Oe(this, Wr).removeObserver(this);
  }
  setOptions(t, n) {
    const o = this.options, r = Oe(this, Wr);
    if (this.options = Oe(this, Gs).defaultQueryOptions(t), bx(o, this.options) || Oe(this, Gs).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: Oe(this, Wr),
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = o.queryKey), bn(this, T0, RN).call(this);
    const i = this.hasListeners();
    i && TB(
      Oe(this, Wr),
      r,
      this.options,
      o
    ) && bn(this, wf, c$).call(this), this.updateResult(n), i && (Oe(this, Wr) !== r || this.options.enabled !== o.enabled || this.options.staleTime !== o.staleTime) && bn(this, $0, AN).call(this);
    const a = bn(this, w0, CN).call(this);
    i && (Oe(this, Wr) !== r || this.options.enabled !== o.enabled || a !== Oe(this, xp)) && bn(this, k0, zN).call(this, a);
  }
  getOptimisticResult(t) {
    const n = Oe(this, Gs).getQueryCache().build(Oe(this, Gs), t), o = this.createResult(n, t);
    return JAe(this, o) && (It(this, ms, o), It(this, gv, this.options), It(this, bf, Oe(this, Wr).state)), o;
  }
  getCurrentResult() {
    return Oe(this, ms);
  }
  trackResult(t) {
    const n = {};
    return Object.keys(t).forEach((o) => {
      Object.defineProperty(n, o, {
        configurable: !1,
        enumerable: !0,
        get: () => (Oe(this, bv).add(o), t[o])
      });
    }), n;
  }
  getCurrentQuery() {
    return Oe(this, Wr);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = Oe(this, Gs).defaultQueryOptions(t), o = Oe(this, Gs).getQueryCache().build(Oe(this, Gs), n);
    return o.isFetchingOptimistic = !0, o.fetch().then(() => this.createResult(o, n));
  }
  fetch(t) {
    return bn(this, wf, c$).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), Oe(this, ms)));
  }
  createResult(t, n) {
    var O;
    const o = Oe(this, Wr), r = this.options, i = Oe(this, ms), a = Oe(this, bf), s = Oe(this, gv), l = t !== o ? t.state : Oe(this, b0), { state: d } = t;
    let { error: u, errorUpdatedAt: _, fetchStatus: p, status: f } = d, g = !1, h;
    if (n._optimisticResults) {
      const I = this.hasListeners(), D = !I && EB(t, n), M = I && TB(t, o, n, r);
      (D || M) && (p = RT(t.options.networkMode) ? "fetching" : "paused", d.dataUpdatedAt || (f = "pending")), n._optimisticResults === "isRestoring" && (p = "idle");
    }
    if (n.select && typeof d.data < "u")
      if (i && d.data === (a == null ? void 0 : a.data) && n.select === Oe(this, y0))
        h = Oe(this, hv);
      else
        try {
          It(this, y0, n.select), h = n.select(d.data), h = xN(i == null ? void 0 : i.data, h, n), It(this, hv, h), It(this, Dd, null);
        } catch (I) {
          It(this, Dd, I);
        }
    else
      h = d.data;
    if (typeof n.placeholderData < "u" && typeof h > "u" && f === "pending") {
      let I;
      if (i != null && i.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData))
        I = i.data;
      else if (I = typeof n.placeholderData == "function" ? n.placeholderData(
        (O = Oe(this, vv)) == null ? void 0 : O.state.data,
        Oe(this, vv)
      ) : n.placeholderData, n.select && typeof I < "u")
        try {
          I = n.select(I), It(this, Dd, null);
        } catch (D) {
          It(this, Dd, D);
        }
      typeof I < "u" && (f = "success", h = xN(
        i == null ? void 0 : i.data,
        I,
        n
      ), g = !0);
    }
    Oe(this, Dd) && (u = Oe(this, Dd), h = Oe(this, hv), _ = Date.now(), f = "error");
    const b = p === "fetching", v = f === "pending", $ = f === "error", k = v && b;
    return {
      status: f,
      fetchStatus: p,
      isPending: v,
      isSuccess: f === "success",
      isError: $,
      isInitialLoading: k,
      isLoading: k,
      data: h,
      dataUpdatedAt: d.dataUpdatedAt,
      error: u,
      errorUpdatedAt: _,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > l.dataUpdateCount || d.errorUpdateCount > l.errorUpdateCount,
      isFetching: b,
      isRefetching: b && !v,
      isLoadingError: $ && d.dataUpdatedAt === 0,
      isPaused: p === "paused",
      isPlaceholderData: g,
      isRefetchError: $ && d.dataUpdatedAt !== 0,
      isStale: kq(t, n),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const n = Oe(this, ms), o = this.createResult(Oe(this, Wr), this.options);
    if (It(this, bf, Oe(this, Wr).state), It(this, gv, this.options), Oe(this, bf).data !== void 0 && It(this, vv, Oe(this, Wr)), bx(o, n))
      return;
    It(this, ms, o);
    const r = {}, i = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: a } = this.options, s = typeof a == "function" ? a() : a;
      if (s === "all" || !s && !Oe(this, bv).size)
        return !0;
      const c = new Set(
        s ?? Oe(this, bv)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(Oe(this, ms)).some((l) => {
        const d = l;
        return Oe(this, ms)[d] !== n[d] && c.has(d);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (r.listeners = !0), bn(this, OT, Lie).call(this, { ...r, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && bn(this, S0, ON).call(this);
  }
}, Gs = new WeakMap(), Wr = new WeakMap(), b0 = new WeakMap(), ms = new WeakMap(), bf = new WeakMap(), gv = new WeakMap(), Dd = new WeakMap(), y0 = new WeakMap(), hv = new WeakMap(), vv = new WeakMap(), yf = new WeakMap(), $f = new WeakMap(), xp = new WeakMap(), bv = new WeakMap(), wf = new WeakSet(), c$ = function(t) {
  bn(this, T0, RN).call(this);
  let n = Oe(this, Wr).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(sl)), n;
}, $0 = new WeakSet(), AN = function() {
  if (bn(this, x0, PN).call(this), xv || Oe(this, ms).isStale || !kN(this.options.staleTime))
    return;
  const n = Oie(
    Oe(this, ms).dataUpdatedAt,
    this.options.staleTime
  ) + 1;
  It(this, yf, setTimeout(() => {
    Oe(this, ms).isStale || this.updateResult();
  }, n));
}, w0 = new WeakSet(), CN = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(Oe(this, Wr)) : this.options.refetchInterval) ?? !1;
}, k0 = new WeakSet(), zN = function(t) {
  bn(this, E0, IN).call(this), It(this, xp, t), !(xv || this.options.enabled === !1 || !kN(Oe(this, xp)) || Oe(this, xp) === 0) && It(this, $f, setInterval(() => {
    (this.options.refetchIntervalInBackground || yx.isFocused()) && bn(this, wf, c$).call(this);
  }, Oe(this, xp)));
}, S0 = new WeakSet(), ON = function() {
  bn(this, $0, AN).call(this), bn(this, k0, zN).call(this, bn(this, w0, CN).call(this));
}, x0 = new WeakSet(), PN = function() {
  Oe(this, yf) && (clearTimeout(Oe(this, yf)), It(this, yf, void 0));
}, E0 = new WeakSet(), IN = function() {
  Oe(this, $f) && (clearInterval(Oe(this, $f)), It(this, $f, void 0));
}, T0 = new WeakSet(), RN = function() {
  const t = Oe(this, Gs).getQueryCache().build(Oe(this, Gs), this.options);
  if (t === Oe(this, Wr))
    return;
  const n = Oe(this, Wr);
  It(this, Wr, t), It(this, b0, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, OT = new WeakSet(), Lie = function(t) {
  gi.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(Oe(this, ms));
    }), Oe(this, Gs).getQueryCache().notify({
      query: Oe(this, Wr),
      type: "observerResultsUpdated"
    });
  });
}, cie);
function QAe(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function EB(e, t) {
  return QAe(e, t) || e.state.dataUpdatedAt > 0 && NN(e, t, t.refetchOnMount);
}
function NN(e, t, n) {
  if (t.enabled !== !1) {
    const o = typeof n == "function" ? n(e) : n;
    return o === "always" || o !== !1 && kq(e, t);
  }
  return !1;
}
function TB(e, t, n, o) {
  return n.enabled !== !1 && (e !== t || o.enabled === !1) && (!n.suspense || e.state.status !== "error") && kq(e, n);
}
function kq(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function JAe(e, t) {
  return !bx(e.getCurrentResult(), t);
}
function AB(e, t) {
  return e.filter((n) => !t.includes(n));
}
function XAe(e, t, n) {
  const o = e.slice(0);
  return o[t] = n, o;
}
var kf, yv, $v, yc, A0, wv, kv, gS, C0, DN, z0, MN, O0, LN, P0, qN, lie, eCe = (lie = class extends rg {
  constructor(t, n, o) {
    super();
    Vt(this, kv);
    Vt(this, C0);
    Vt(this, z0);
    Vt(this, O0);
    Vt(this, P0);
    Vt(this, kf, void 0);
    Vt(this, yv, void 0);
    Vt(this, $v, void 0);
    Vt(this, yc, void 0);
    Vt(this, A0, void 0);
    Vt(this, wv, void 0);
    It(this, kf, t), It(this, $v, []), It(this, yc, []), bn(this, kv, gS).call(this, []), this.setQueries(n, o);
  }
  onSubscribe() {
    this.listeners.size === 1 && Oe(this, yc).forEach((t) => {
      t.subscribe((n) => {
        bn(this, O0, LN).call(this, t, n);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Oe(this, yc).forEach((t) => {
      t.destroy();
    });
  }
  setQueries(t, n, o) {
    It(this, $v, t), It(this, A0, n), gi.batch(() => {
      const r = Oe(this, yc), i = bn(this, z0, MN).call(this, Oe(this, $v));
      i.forEach(
        (l) => l.observer.setOptions(l.defaultedQueryOptions, o)
      );
      const a = i.map((l) => l.observer), s = a.map(
        (l) => l.getCurrentResult()
      ), c = a.some(
        (l, d) => l !== r[d]
      );
      r.length === a.length && !c || (It(this, yc, a), bn(this, kv, gS).call(this, s), this.hasListeners() && (AB(r, a).forEach((l) => {
        l.destroy();
      }), AB(a, r).forEach((l) => {
        l.subscribe((d) => {
          bn(this, O0, LN).call(this, l, d);
        });
      }), bn(this, P0, qN).call(this)));
    });
  }
  getCurrentResult() {
    return Oe(this, wv);
  }
  getQueries() {
    return Oe(this, yc).map((t) => t.getCurrentQuery());
  }
  getObservers() {
    return Oe(this, yc);
  }
  getOptimisticResult(t, n) {
    const o = bn(this, z0, MN).call(this, t), r = o.map(
      (i) => i.observer.getOptimisticResult(i.defaultedQueryOptions)
    );
    return [
      r,
      (i) => bn(this, C0, DN).call(this, i ?? r, n),
      () => o.map((i, a) => {
        const s = r[a];
        return i.defaultedQueryOptions.notifyOnChangeProps ? s : i.observer.trackResult(s);
      })
    ];
  }
}, kf = new WeakMap(), yv = new WeakMap(), $v = new WeakMap(), yc = new WeakMap(), A0 = new WeakMap(), wv = new WeakMap(), kv = new WeakSet(), gS = function(t) {
  var n;
  It(this, yv, t), It(this, wv, bn(this, C0, DN).call(this, t, (n = Oe(this, A0)) == null ? void 0 : n.combine));
}, C0 = new WeakSet(), DN = function(t, n) {
  return n ? wq(Oe(this, wv), n(t)) : t;
}, z0 = new WeakSet(), MN = function(t) {
  const n = Oe(this, yc), o = new Map(
    n.map((u) => [u.options.queryHash, u])
  ), r = t.map(
    (u) => Oe(this, kf).defaultQueryOptions(u)
  ), i = r.flatMap((u) => {
    const _ = o.get(u.queryHash);
    return _ != null ? [{ defaultedQueryOptions: u, observer: _ }] : [];
  }), a = new Set(
    i.map((u) => u.defaultedQueryOptions.queryHash)
  ), s = r.filter(
    (u) => !a.has(u.queryHash)
  ), c = (u) => {
    const _ = Oe(this, kf).defaultQueryOptions(u);
    return Oe(this, yc).find(
      (f) => f.options.queryHash === _.queryHash
    ) ?? new D0(Oe(this, kf), _);
  }, l = s.map((u) => ({
    defaultedQueryOptions: u,
    observer: c(u)
  })), d = (u, _) => r.indexOf(u.defaultedQueryOptions) - r.indexOf(_.defaultedQueryOptions);
  return i.concat(l).sort(d);
}, O0 = new WeakSet(), LN = function(t, n) {
  const o = Oe(this, yc).indexOf(t);
  o !== -1 && (bn(this, kv, gS).call(this, XAe(Oe(this, yv), o, n)), bn(this, P0, qN).call(this));
}, P0 = new WeakSet(), qN = function() {
  gi.batch(() => {
    this.listeners.forEach((t) => {
      t(Oe(this, yv));
    });
  });
}, lie), qie = class extends D0 {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(e, t) {
    super(e, t);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(e, t) {
    super.setOptions(
      {
        ...e,
        behavior: EN()
      },
      t
    );
  }
  getOptimisticResult(e) {
    return e.behavior = EN(), super.getOptimisticResult(e);
  }
  fetchNextPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(e, t) {
    var c, l, d, u;
    const { state: n } = e, o = super.createResult(e, t), { isFetching: r, isRefetching: i } = o, a = r && ((l = (c = n.fetchMeta) == null ? void 0 : c.fetchMore) == null ? void 0 : l.direction) === "forward", s = r && ((u = (d = n.fetchMeta) == null ? void 0 : d.fetchMore) == null ? void 0 : u.direction) === "backward";
    return {
      ...o,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: YAe(t, n.data),
      hasPreviousPage: ZAe(t, n.data),
      isFetchingNextPage: a,
      isFetchingPreviousPage: s,
      isRefetching: i && !a && !s
    };
  }
}, Ep, a_, $c, s_, Sv, hS, I0, jN, die, tCe = (die = class extends rg {
  constructor(n, o) {
    super();
    Vt(this, Sv);
    Vt(this, I0);
    Vt(this, Ep, void 0);
    Vt(this, a_, void 0);
    Vt(this, $c, void 0);
    Vt(this, s_, void 0);
    It(this, a_, void 0), It(this, Ep, n), this.setOptions(o), this.bindMethods(), bn(this, Sv, hS).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    var r;
    const o = this.options;
    this.options = Oe(this, Ep).defaultMutationOptions(n), bx(o, this.options) || Oe(this, Ep).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: Oe(this, $c),
      observer: this
    }), (r = Oe(this, $c)) == null || r.setOptions(this.options), o != null && o.mutationKey && this.options.mutationKey && Hp(o.mutationKey) !== Hp(this.options.mutationKey) && this.reset();
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || (n = Oe(this, $c)) == null || n.removeObserver(this);
  }
  onMutationUpdate(n) {
    bn(this, Sv, hS).call(this), bn(this, I0, jN).call(this, n);
  }
  getCurrentResult() {
    return Oe(this, a_);
  }
  reset() {
    var n;
    (n = Oe(this, $c)) == null || n.removeObserver(this), It(this, $c, void 0), bn(this, Sv, hS).call(this), bn(this, I0, jN).call(this);
  }
  mutate(n, o) {
    var r;
    return It(this, s_, o), (r = Oe(this, $c)) == null || r.removeObserver(this), It(this, $c, Oe(this, Ep).getMutationCache().build(Oe(this, Ep), this.options)), Oe(this, $c).addObserver(this), Oe(this, $c).execute(n);
  }
}, Ep = new WeakMap(), a_ = new WeakMap(), $c = new WeakMap(), s_ = new WeakMap(), Sv = new WeakSet(), hS = function() {
  var o;
  const n = ((o = Oe(this, $c)) == null ? void 0 : o.state) ?? Nie();
  It(this, a_, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, I0 = new WeakSet(), jN = function(n) {
  gi.batch(() => {
    var o, r, i, a, s, c, l, d;
    if (Oe(this, s_) && this.hasListeners()) {
      const u = Oe(this, a_).variables, _ = Oe(this, a_).context;
      (n == null ? void 0 : n.type) === "success" ? ((r = (o = Oe(this, s_)).onSuccess) == null || r.call(o, n.data, u, _), (a = (i = Oe(this, s_)).onSettled) == null || a.call(i, n.data, null, u, _)) : (n == null ? void 0 : n.type) === "error" && ((c = (s = Oe(this, s_)).onError) == null || c.call(s, n.error, u, _), (d = (l = Oe(this, s_)).onSettled) == null || d.call(
        l,
        void 0,
        n.error,
        u,
        _
      ));
    }
    this.listeners.forEach((u) => {
      u(Oe(this, a_));
    });
  });
}, die);
function nCe(e) {
  return {
    mutationKey: e.options.mutationKey,
    state: e.state,
    ...e.meta && { meta: e.meta }
  };
}
function oCe(e) {
  return {
    state: e.state,
    queryKey: e.queryKey,
    queryHash: e.queryHash,
    ...e.meta && { meta: e.meta }
  };
}
function rCe(e) {
  return e.state.isPaused;
}
function iCe(e) {
  return e.state.status === "success";
}
function aCe(e, t = {}) {
  const n = t.shouldDehydrateMutation ?? rCe, o = e.getMutationCache().getAll().flatMap(
    (a) => n(a) ? [nCe(a)] : []
  ), r = t.shouldDehydrateQuery ?? iCe, i = e.getQueryCache().getAll().flatMap((a) => r(a) ? [oCe(a)] : []);
  return { mutations: o, queries: i };
}
function CB(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const o = e.getMutationCache(), r = e.getQueryCache(), i = t.mutations || [], a = t.queries || [];
  i.forEach((s) => {
    var c;
    o.build(
      e,
      {
        ...(c = n == null ? void 0 : n.defaultOptions) == null ? void 0 : c.mutations,
        mutationKey: s.mutationKey,
        meta: s.meta
      },
      s.state
    );
  }), a.forEach(({ queryKey: s, state: c, queryHash: l, meta: d }) => {
    var _;
    const u = r.get(l);
    if (u) {
      if (u.state.dataUpdatedAt < c.dataUpdatedAt) {
        const { fetchStatus: p, ...f } = c;
        u.setState(f);
      }
      return;
    }
    r.build(
      e,
      {
        ...(_ = n == null ? void 0 : n.defaultOptions) == null ? void 0 : _.queries,
        queryKey: s,
        queryHash: l,
        meta: d
      },
      // Reset fetch status to idle to avoid
      // query being stuck in fetching state upon hydration
      {
        ...c,
        fetchStatus: "idle"
      }
    );
  });
}
var jie = $e.createContext(
  void 0
), ns = (e) => {
  const t = $e.useContext(jie);
  if (e)
    return e;
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Fie = ({
  client: e,
  children: t
}) => ($e.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ $e.createElement(jie.Provider, { value: e }, t)), Vie = $e.createContext(!1), Bie = () => $e.useContext(Vie);
Vie.Provider;
function sCe() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var cCe = $e.createContext(sCe()), Uie = () => $e.useContext(cCe);
function Wie(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var Gie = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, Hie = (e) => {
  $e.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Kie = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: o
}) => e.isError && !t.isReset() && !e.isFetching && o && Wie(n, [e.error, o]), Sq = (e, t) => typeof t.state.data > "u", Yie = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, lCe = (e, t) => e.isLoading && e.isFetching && !t, FN = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, VN = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function Zie({
  queries: e,
  ...t
}, n) {
  const o = ns(n), r = Bie(), i = Uie(), a = $e.useMemo(
    () => e.map((f) => {
      const g = o.defaultQueryOptions(f);
      return g._optimisticResults = r ? "isRestoring" : "optimistic", g;
    }),
    [e, o, r]
  );
  a.forEach((f) => {
    Yie(f), Gie(f, i);
  }), Hie(i);
  const [s] = $e.useState(
    () => new eCe(
      o,
      a,
      t
    )
  ), [c, l, d] = s.getOptimisticResult(
    a,
    t.combine
  );
  $e.useSyncExternalStore(
    $e.useCallback(
      (f) => r ? () => {
      } : s.subscribe(gi.batchCalls(f)),
      [s, r]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), $e.useEffect(() => {
    s.setQueries(
      a,
      t,
      {
        listeners: !1
      }
    );
  }, [a, t, s]);
  const _ = c.some(
    (f, g) => FN(a[g], f)
  ) ? c.flatMap((f, g) => {
    const h = a[g];
    if (h) {
      const b = new D0(o, h);
      if (FN(h, f))
        return VN(h, b, i);
      lCe(f, r) && VN(h, b, i);
    }
    return [];
  }) : [];
  if (_.length > 0)
    throw Promise.all(_);
  const p = c.find(
    (f, g) => {
      const h = a[g];
      return h && Kie({
        result: f,
        errorResetBoundary: i,
        throwOnError: h.throwOnError,
        query: o.getQueryCache().get(h.queryHash)
      });
    }
  );
  if (p != null && p.error)
    throw p.error;
  return l(d());
}
function NT(e, t, n) {
  const o = ns(n), r = Bie(), i = Uie(), a = o.defaultQueryOptions(e);
  a._optimisticResults = r ? "isRestoring" : "optimistic", Yie(a), Gie(a, i), Hie(i);
  const [s] = $e.useState(
    () => new t(
      o,
      a
    )
  ), c = s.getOptimisticResult(a);
  if ($e.useSyncExternalStore(
    $e.useCallback(
      (l) => {
        const d = r ? () => {
        } : s.subscribe(gi.batchCalls(l));
        return s.updateResult(), d;
      },
      [s, r]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), $e.useEffect(() => {
    s.setOptions(a, { listeners: !1 });
  }, [a, s]), FN(a, c))
    throw VN(a, s, i);
  if (Kie({
    result: c,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: o.getQueryCache().get(a.queryHash)
  }))
    throw c.error;
  return a.notifyOnChangeProps ? c : s.trackResult(c);
}
function go(e, t) {
  return NT(e, D0, t);
}
function dCe(e, t) {
  return NT(
    {
      ...e,
      enabled: !0,
      suspense: !0,
      throwOnError: Sq
    },
    D0,
    t
  );
}
function uCe(e, t) {
  return NT(
    {
      ...e,
      enabled: !0,
      suspense: !0,
      throwOnError: Sq
    },
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    qie,
    t
  );
}
function _Ce(e, t) {
  return Zie(
    {
      ...e,
      queries: e.queries.map((n) => ({
        ...n,
        suspense: !0,
        throwOnError: Sq,
        enabled: !0
      }))
    },
    t
  );
}
var pCe = ({
  children: e,
  options: t = {},
  state: n,
  queryClient: o
}) => {
  const r = ns(o), [i, a] = $e.useState(), s = $e.useRef(t);
  return s.current = t, $e.useMemo(() => {
    if (n) {
      if (typeof n != "object")
        return;
      const c = r.getQueryCache(), l = n.queries || [], d = [], u = [];
      for (const _ of l) {
        const p = c.get(_.queryHash);
        if (!p)
          d.push(_);
        else {
          const f = _.state.dataUpdatedAt > p.state.dataUpdatedAt, g = i == null ? void 0 : i.find(
            (h) => h.queryHash === _.queryHash
          );
          f && (!g || _.state.dataUpdatedAt > g.state.dataUpdatedAt) && u.push(_);
        }
      }
      d.length > 0 && CB(r, { queries: d }, s.current), u.length > 0 && a(
        (_) => _ ? [..._, ...u] : u
      );
    }
  }, [r, i, n]), $e.useEffect(() => {
    i && (CB(r, { queries: i }, s.current), a(void 0));
  }, [r, i]), e;
};
function Yo(e, t) {
  const n = ns(t), [o] = $e.useState(
    () => new tCe(
      n,
      e
    )
  );
  $e.useEffect(() => {
    o.setOptions(e);
  }, [o, e]);
  const r = $e.useSyncExternalStore(
    $e.useCallback(
      (a) => o.subscribe(gi.batchCalls(a)),
      [o]
    ),
    () => o.getCurrentResult(),
    () => o.getCurrentResult()
  ), i = $e.useCallback(
    (a, s) => {
      o.mutate(a, s).catch(mCe);
    },
    [o]
  );
  if (r.error && Wie(o.options.throwOnError, [r.error]))
    throw r.error;
  return { ...r, mutate: i, mutateAsync: r.mutate };
}
function mCe() {
}
function fCe(e, t) {
  return NT(
    e,
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    qie,
    t
  );
}
const Pi = {
  me: "me",
  availability: "schedules",
  eventTypes: "event-types",
  bookings: "bookings"
}, qt = "success", Kp = "error", kO = "x-cal-client-id", zB = "x-cal-platform-embed", xq = "2024-06-14", gCe = "2024-06-11", Qie = "2024-08-13", Gv = "cal-api-version", hCe = "google_calendar", vCe = "google", bCe = "office365", vS = "google-meet", Oh = "zoom", Ph = "msteams";
var Je = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Oa(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var r = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var Eq = { exports: {} }, Jie = function(t, n) {
  return function() {
    for (var r = new Array(arguments.length), i = 0; i < r.length; i++)
      r[i] = arguments[i];
    return t.apply(n, r);
  };
}, yCe = Jie, am = Object.prototype.toString;
function Tq(e) {
  return Array.isArray(e);
}
function BN(e) {
  return typeof e > "u";
}
function $Ce(e) {
  return e !== null && !BN(e) && e.constructor !== null && !BN(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Xie(e) {
  return am.call(e) === "[object ArrayBuffer]";
}
function wCe(e) {
  return am.call(e) === "[object FormData]";
}
function kCe(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Xie(e.buffer), t;
}
function SCe(e) {
  return typeof e == "string";
}
function xCe(e) {
  return typeof e == "number";
}
function eae(e) {
  return e !== null && typeof e == "object";
}
function bS(e) {
  if (am.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function ECe(e) {
  return am.call(e) === "[object Date]";
}
function TCe(e) {
  return am.call(e) === "[object File]";
}
function ACe(e) {
  return am.call(e) === "[object Blob]";
}
function tae(e) {
  return am.call(e) === "[object Function]";
}
function CCe(e) {
  return eae(e) && tae(e.pipe);
}
function zCe(e) {
  return am.call(e) === "[object URLSearchParams]";
}
function OCe(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function PCe() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Aq(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), Tq(e))
      for (var n = 0, o = e.length; n < o; n++)
        t.call(null, e[n], n, e);
    else
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && t.call(null, e[r], r, e);
}
function UN() {
  var e = {};
  function t(r, i) {
    bS(e[i]) && bS(r) ? e[i] = UN(e[i], r) : bS(r) ? e[i] = UN({}, r) : Tq(r) ? e[i] = r.slice() : e[i] = r;
  }
  for (var n = 0, o = arguments.length; n < o; n++)
    Aq(arguments[n], t);
  return e;
}
function ICe(e, t, n) {
  return Aq(t, function(r, i) {
    n && typeof r == "function" ? e[i] = yCe(r, n) : e[i] = r;
  }), e;
}
function RCe(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var ac = {
  isArray: Tq,
  isArrayBuffer: Xie,
  isBuffer: $Ce,
  isFormData: wCe,
  isArrayBufferView: kCe,
  isString: SCe,
  isNumber: xCe,
  isObject: eae,
  isPlainObject: bS,
  isUndefined: BN,
  isDate: ECe,
  isFile: TCe,
  isBlob: ACe,
  isFunction: tae,
  isStream: CCe,
  isURLSearchParams: zCe,
  isStandardBrowserEnv: PCe,
  forEach: Aq,
  merge: UN,
  extend: ICe,
  trim: OCe,
  stripBOM: RCe
}, Gg = ac;
function OB(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var nae = function(t, n, o) {
  if (!n)
    return t;
  var r;
  if (o)
    r = o(n);
  else if (Gg.isURLSearchParams(n))
    r = n.toString();
  else {
    var i = [];
    Gg.forEach(n, function(c, l) {
      c === null || typeof c > "u" || (Gg.isArray(c) ? l = l + "[]" : c = [c], Gg.forEach(c, function(u) {
        Gg.isDate(u) ? u = u.toISOString() : Gg.isObject(u) && (u = JSON.stringify(u)), i.push(OB(l) + "=" + OB(u));
      }));
    }), r = i.join("&");
  }
  if (r) {
    var a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return t;
}, NCe = ac;
function DT() {
  this.handlers = [];
}
DT.prototype.use = function(t, n, o) {
  return this.handlers.push({
    fulfilled: t,
    rejected: n,
    synchronous: o ? o.synchronous : !1,
    runWhen: o ? o.runWhen : null
  }), this.handlers.length - 1;
};
DT.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
DT.prototype.forEach = function(t) {
  NCe.forEach(this.handlers, function(o) {
    o !== null && t(o);
  });
};
var DCe = DT, MCe = ac, LCe = function(t, n) {
  MCe.forEach(t, function(r, i) {
    i !== n && i.toUpperCase() === n.toUpperCase() && (t[n] = r, delete t[i]);
  });
}, oae = function(t, n, o, r, i) {
  return t.config = n, o && (t.code = o), t.request = r, t.response = i, t.isAxiosError = !0, t.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, t;
}, rae = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, SO, PB;
function iae() {
  if (PB)
    return SO;
  PB = 1;
  var e = oae;
  return SO = function(n, o, r, i, a) {
    var s = new Error(n);
    return e(s, o, r, i, a);
  }, SO;
}
var xO, IB;
function qCe() {
  if (IB)
    return xO;
  IB = 1;
  var e = iae();
  return xO = function(n, o, r) {
    var i = r.config.validateStatus;
    !r.status || !i || i(r.status) ? n(r) : o(e(
      "Request failed with status code " + r.status,
      r.config,
      null,
      r.request,
      r
    ));
  }, xO;
}
var EO, RB;
function jCe() {
  if (RB)
    return EO;
  RB = 1;
  var e = ac;
  return EO = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(o, r, i, a, s, c) {
          var l = [];
          l.push(o + "=" + encodeURIComponent(r)), e.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), e.isString(a) && l.push("path=" + a), e.isString(s) && l.push("domain=" + s), c === !0 && l.push("secure"), document.cookie = l.join("; ");
        },
        read: function(o) {
          var r = document.cookie.match(new RegExp("(^|;\\s*)(" + o + ")=([^;]*)"));
          return r ? decodeURIComponent(r[3]) : null;
        },
        remove: function(o) {
          this.write(o, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), EO;
}
var TO, NB;
function FCe() {
  return NB || (NB = 1, TO = function(t) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  }), TO;
}
var AO, DB;
function VCe() {
  return DB || (DB = 1, AO = function(t, n) {
    return n ? t.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : t;
  }), AO;
}
var CO, MB;
function BCe() {
  if (MB)
    return CO;
  MB = 1;
  var e = FCe(), t = VCe();
  return CO = function(o, r) {
    return o && !e(r) ? t(o, r) : r;
  }, CO;
}
var zO, LB;
function UCe() {
  if (LB)
    return zO;
  LB = 1;
  var e = ac, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return zO = function(o) {
    var r = {}, i, a, s;
    return o && e.forEach(o.split(`
`), function(l) {
      if (s = l.indexOf(":"), i = e.trim(l.substr(0, s)).toLowerCase(), a = e.trim(l.substr(s + 1)), i) {
        if (r[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? r[i] = (r[i] ? r[i] : []).concat([a]) : r[i] = r[i] ? r[i] + ", " + a : a;
      }
    }), r;
  }, zO;
}
var OO, qB;
function WCe() {
  if (qB)
    return OO;
  qB = 1;
  var e = ac;
  return OO = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var n = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a"), r;
      function i(a) {
        var s = a;
        return n && (o.setAttribute("href", s), s = o.href), o.setAttribute("href", s), {
          href: o.href,
          protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
          host: o.host,
          search: o.search ? o.search.replace(/^\?/, "") : "",
          hash: o.hash ? o.hash.replace(/^#/, "") : "",
          hostname: o.hostname,
          port: o.port,
          pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
        };
      }
      return r = i(window.location.href), function(s) {
        var c = e.isString(s) ? i(s) : s;
        return c.protocol === r.protocol && c.host === r.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), OO;
}
var PO, jB;
function MT() {
  if (jB)
    return PO;
  jB = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, PO = e, PO;
}
var IO, FB;
function VB() {
  if (FB)
    return IO;
  FB = 1;
  var e = ac, t = qCe(), n = jCe(), o = nae, r = BCe(), i = UCe(), a = WCe(), s = iae(), c = rae, l = MT();
  return IO = function(u) {
    return new Promise(function(p, f) {
      var g = u.data, h = u.headers, b = u.responseType, v;
      function $() {
        u.cancelToken && u.cancelToken.unsubscribe(v), u.signal && u.signal.removeEventListener("abort", v);
      }
      e.isFormData(g) && delete h["Content-Type"];
      var k = new XMLHttpRequest();
      if (u.auth) {
        var S = u.auth.username || "", O = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
        h.Authorization = "Basic " + btoa(S + ":" + O);
      }
      var I = r(u.baseURL, u.url);
      k.open(u.method.toUpperCase(), o(I, u.params, u.paramsSerializer), !0), k.timeout = u.timeout;
      function D() {
        if (k) {
          var N = "getAllResponseHeaders" in k ? i(k.getAllResponseHeaders()) : null, C = !b || b === "text" || b === "json" ? k.responseText : k.response, P = {
            data: C,
            status: k.status,
            statusText: k.statusText,
            headers: N,
            config: u,
            request: k
          };
          t(function(w) {
            p(w), $();
          }, function(w) {
            f(w), $();
          }, P), k = null;
        }
      }
      if ("onloadend" in k ? k.onloadend = D : k.onreadystatechange = function() {
        !k || k.readyState !== 4 || k.status === 0 && !(k.responseURL && k.responseURL.indexOf("file:") === 0) || setTimeout(D);
      }, k.onabort = function() {
        k && (f(s("Request aborted", u, "ECONNABORTED", k)), k = null);
      }, k.onerror = function() {
        f(s("Network Error", u, null, k)), k = null;
      }, k.ontimeout = function() {
        var C = u.timeout ? "timeout of " + u.timeout + "ms exceeded" : "timeout exceeded", P = u.transitional || c;
        u.timeoutErrorMessage && (C = u.timeoutErrorMessage), f(s(
          C,
          u,
          P.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          k
        )), k = null;
      }, e.isStandardBrowserEnv()) {
        var M = (u.withCredentials || a(I)) && u.xsrfCookieName ? n.read(u.xsrfCookieName) : void 0;
        M && (h[u.xsrfHeaderName] = M);
      }
      "setRequestHeader" in k && e.forEach(h, function(C, P) {
        typeof g > "u" && P.toLowerCase() === "content-type" ? delete h[P] : k.setRequestHeader(P, C);
      }), e.isUndefined(u.withCredentials) || (k.withCredentials = !!u.withCredentials), b && b !== "json" && (k.responseType = u.responseType), typeof u.onDownloadProgress == "function" && k.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && k.upload && k.upload.addEventListener("progress", u.onUploadProgress), (u.cancelToken || u.signal) && (v = function(N) {
        k && (f(!N || N && N.type ? new l("canceled") : N), k.abort(), k = null);
      }, u.cancelToken && u.cancelToken.subscribe(v), u.signal && (u.signal.aborted ? v() : u.signal.addEventListener("abort", v))), g || (g = null), k.send(g);
    });
  }, IO;
}
var $a = ac, BB = LCe, GCe = oae, HCe = rae, KCe = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function UB(e, t) {
  !$a.isUndefined(e) && $a.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function YCe() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = VB()), e;
}
function ZCe(e, t, n) {
  if ($a.isString(e))
    try {
      return (t || JSON.parse)(e), $a.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
var LT = {
  transitional: HCe,
  adapter: YCe(),
  transformRequest: [function(t, n) {
    return BB(n, "Accept"), BB(n, "Content-Type"), $a.isFormData(t) || $a.isArrayBuffer(t) || $a.isBuffer(t) || $a.isStream(t) || $a.isFile(t) || $a.isBlob(t) ? t : $a.isArrayBufferView(t) ? t.buffer : $a.isURLSearchParams(t) ? (UB(n, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : $a.isObject(t) || n && n["Content-Type"] === "application/json" ? (UB(n, "application/json"), ZCe(t)) : t;
  }],
  transformResponse: [function(t) {
    var n = this.transitional || LT.transitional, o = n && n.silentJSONParsing, r = n && n.forcedJSONParsing, i = !o && this.responseType === "json";
    if (i || r && $a.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (a) {
        if (i)
          throw a.name === "SyntaxError" ? GCe(a, this, "E_JSON_PARSE") : a;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
$a.forEach(["delete", "get", "head"], function(t) {
  LT.headers[t] = {};
});
$a.forEach(["post", "put", "patch"], function(t) {
  LT.headers[t] = $a.merge(KCe);
});
var Cq = LT, QCe = ac, JCe = Cq, XCe = function(t, n, o) {
  var r = this || JCe;
  return QCe.forEach(o, function(a) {
    t = a.call(r, t, n);
  }), t;
}, RO, WB;
function aae() {
  return WB || (WB = 1, RO = function(t) {
    return !!(t && t.__CANCEL__);
  }), RO;
}
var GB = ac, NO = XCe, eze = aae(), tze = Cq, nze = MT();
function DO(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new nze("canceled");
}
var oze = function(t) {
  DO(t), t.headers = t.headers || {}, t.data = NO.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = GB.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), GB.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(r) {
      delete t.headers[r];
    }
  );
  var n = t.adapter || tze.adapter;
  return n(t).then(function(r) {
    return DO(t), r.data = NO.call(
      t,
      r.data,
      r.headers,
      t.transformResponse
    ), r;
  }, function(r) {
    return eze(r) || (DO(t), r && r.response && (r.response.data = NO.call(
      t,
      r.response.data,
      r.response.headers,
      t.transformResponse
    ))), Promise.reject(r);
  });
}, pc = ac, sae = function(t, n) {
  n = n || {};
  var o = {};
  function r(d, u) {
    return pc.isPlainObject(d) && pc.isPlainObject(u) ? pc.merge(d, u) : pc.isPlainObject(u) ? pc.merge({}, u) : pc.isArray(u) ? u.slice() : u;
  }
  function i(d) {
    if (pc.isUndefined(n[d])) {
      if (!pc.isUndefined(t[d]))
        return r(void 0, t[d]);
    } else
      return r(t[d], n[d]);
  }
  function a(d) {
    if (!pc.isUndefined(n[d]))
      return r(void 0, n[d]);
  }
  function s(d) {
    if (pc.isUndefined(n[d])) {
      if (!pc.isUndefined(t[d]))
        return r(void 0, t[d]);
    } else
      return r(void 0, n[d]);
  }
  function c(d) {
    if (d in n)
      return r(t[d], n[d]);
    if (d in t)
      return r(void 0, t[d]);
  }
  var l = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: c
  };
  return pc.forEach(Object.keys(t).concat(Object.keys(n)), function(u) {
    var _ = l[u] || i, p = _(u);
    pc.isUndefined(p) && _ !== c || (o[u] = p);
  }), o;
}, MO, HB;
function cae() {
  return HB || (HB = 1, MO = {
    version: "0.26.1"
  }), MO;
}
var rze = cae().version, zq = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  zq[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var KB = {};
zq.transitional = function(t, n, o) {
  function r(i, a) {
    return "[Axios v" + rze + "] Transitional option '" + i + "'" + a + (o ? ". " + o : "");
  }
  return function(i, a, s) {
    if (t === !1)
      throw new Error(r(a, " has been removed" + (n ? " in " + n : "")));
    return n && !KB[a] && (KB[a] = !0, console.warn(
      r(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function ize(e, t, n) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var o = Object.keys(e), r = o.length; r-- > 0; ) {
    var i = o[r], a = t[i];
    if (a) {
      var s = e[i], c = s === void 0 || a(s, i, e);
      if (c !== !0)
        throw new TypeError("option " + i + " must be " + c);
      continue;
    }
    if (n !== !0)
      throw Error("Unknown option " + i);
  }
}
var aze = {
  assertOptions: ize,
  validators: zq
}, lae = ac, sze = nae, YB = DCe, ZB = oze, qT = sae, dae = aze, Hg = dae.validators;
function M0(e) {
  this.defaults = e, this.interceptors = {
    request: new YB(),
    response: new YB()
  };
}
M0.prototype.request = function(t, n) {
  typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = qT(this.defaults, n), n.method ? n.method = n.method.toLowerCase() : this.defaults.method ? n.method = this.defaults.method.toLowerCase() : n.method = "get";
  var o = n.transitional;
  o !== void 0 && dae.assertOptions(o, {
    silentJSONParsing: Hg.transitional(Hg.boolean),
    forcedJSONParsing: Hg.transitional(Hg.boolean),
    clarifyTimeoutError: Hg.transitional(Hg.boolean)
  }, !1);
  var r = [], i = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(n) === !1 || (i = i && p.synchronous, r.unshift(p.fulfilled, p.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(p) {
    a.push(p.fulfilled, p.rejected);
  });
  var s;
  if (!i) {
    var c = [ZB, void 0];
    for (Array.prototype.unshift.apply(c, r), c = c.concat(a), s = Promise.resolve(n); c.length; )
      s = s.then(c.shift(), c.shift());
    return s;
  }
  for (var l = n; r.length; ) {
    var d = r.shift(), u = r.shift();
    try {
      l = d(l);
    } catch (_) {
      u(_);
      break;
    }
  }
  try {
    s = ZB(l);
  } catch (_) {
    return Promise.reject(_);
  }
  for (; a.length; )
    s = s.then(a.shift(), a.shift());
  return s;
};
M0.prototype.getUri = function(t) {
  return t = qT(this.defaults, t), sze(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
lae.forEach(["delete", "get", "head", "options"], function(t) {
  M0.prototype[t] = function(n, o) {
    return this.request(qT(o || {}, {
      method: t,
      url: n,
      data: (o || {}).data
    }));
  };
});
lae.forEach(["post", "put", "patch"], function(t) {
  M0.prototype[t] = function(n, o, r) {
    return this.request(qT(r || {}, {
      method: t,
      url: n,
      data: o
    }));
  };
});
var cze = M0, LO, QB;
function lze() {
  if (QB)
    return LO;
  QB = 1;
  var e = MT();
  function t(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    var o;
    this.promise = new Promise(function(a) {
      o = a;
    });
    var r = this;
    this.promise.then(function(i) {
      if (r._listeners) {
        var a, s = r._listeners.length;
        for (a = 0; a < s; a++)
          r._listeners[a](i);
        r._listeners = null;
      }
    }), this.promise.then = function(i) {
      var a, s = new Promise(function(c) {
        r.subscribe(c), a = c;
      }).then(i);
      return s.cancel = function() {
        r.unsubscribe(a);
      }, s;
    }, n(function(a) {
      r.reason || (r.reason = new e(a), o(r.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.prototype.subscribe = function(o) {
    if (this.reason) {
      o(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(o) : this._listeners = [o];
  }, t.prototype.unsubscribe = function(o) {
    if (this._listeners) {
      var r = this._listeners.indexOf(o);
      r !== -1 && this._listeners.splice(r, 1);
    }
  }, t.source = function() {
    var o, r = new t(function(a) {
      o = a;
    });
    return {
      token: r,
      cancel: o
    };
  }, LO = t, LO;
}
var qO, JB;
function dze() {
  return JB || (JB = 1, qO = function(t) {
    return function(o) {
      return t.apply(null, o);
    };
  }), qO;
}
var jO, XB;
function uze() {
  if (XB)
    return jO;
  XB = 1;
  var e = ac;
  return jO = function(n) {
    return e.isObject(n) && n.isAxiosError === !0;
  }, jO;
}
var eU = ac, _ze = Jie, yS = cze, pze = sae, mze = Cq;
function uae(e) {
  var t = new yS(e), n = _ze(yS.prototype.request, t);
  return eU.extend(n, yS.prototype, t), eU.extend(n, t), n.create = function(r) {
    return uae(pze(e, r));
  }, n;
}
var mu = uae(mze);
mu.Axios = yS;
mu.Cancel = MT();
mu.CancelToken = lze();
mu.isCancel = aae();
mu.VERSION = cae().version;
mu.all = function(t) {
  return Promise.all(t);
};
mu.spread = dze();
mu.isAxiosError = uze();
Eq.exports = mu;
Eq.exports.default = mu;
var fze = Eq.exports, gze = fze;
const _ae = /* @__PURE__ */ Zr(gze), WN = function() {
  const e = _ae.create({
    timeout: 1e4,
    headers: {}
  });
  let t = "";
  return {
    instance: e,
    get: e.get,
    post: e.post,
    put: e.put,
    patch: e.patch,
    delete: e.delete,
    responseInterceptor: e.interceptors.response,
    setRefreshUrl: (n) => {
      t = n;
    },
    getRefreshUrl: () => t,
    setUrl: (n) => {
      e.defaults.baseURL = n;
    },
    getUrl: () => e.defaults.baseURL,
    setAuthorizationHeader: (n) => {
      e.defaults.headers.common.Authorization = `Bearer ${n}`;
    },
    getAuthorizationHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n.Authorization) == null ? void 0 : o.toString()) ?? "";
    },
    setClientIdHeader: (n) => {
      e.defaults.headers.common[kO] = n;
    },
    getClientIdHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[kO]) == null ? void 0 : o.toString()) ?? "";
    },
    setPlatformEmbedHeader: (n) => {
      e.defaults.headers.common[zB] = n.toString();
    },
    getPlatformEmbedHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[zB]) == null ? void 0 : o.toString()) ?? "";
    },
    setVersionHeader: (n) => {
      e.defaults.headers.common[Gv] = n;
    },
    getVersionHeader: () => {
      var n, o;
      return ((o = (n = e.defaults.headers.common) == null ? void 0 : n[kO]) == null ? void 0 : o.toString()) ?? "";
    },
    refreshTokens: async (n) => {
      const r = await (await fetch(`${n}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: WN.getAuthorizationHeader()
        }
      })).json();
      return r.accessToken ? (WN.setAuthorizationHeader(r.accessToken), r.accessToken) : "";
    }
  };
}(), He = WN;
function We() {
  return We = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, We.apply(this, arguments);
}
const hze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: We
}, Symbol.toStringTag, { value: "Module" }));
function Bt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function vze(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Oq(...e) {
  return (t) => e.forEach(
    (n) => vze(n, t)
  );
}
function or(...e) {
  return at(Oq(...e), e);
}
function os(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = /* @__PURE__ */ No(a), c = n.length;
    n = [
      ...n,
      a
    ];
    function l(u) {
      const { scope: _, children: p, ...f } = u, g = (_ == null ? void 0 : _[e][c]) || s, h = Tt(
        () => f,
        Object.values(f)
      );
      return /* @__PURE__ */ Pe(g.Provider, {
        value: h
      }, p);
    }
    function d(u, _) {
      const p = (_ == null ? void 0 : _[e][c]) || s, f = Pn(p);
      if (f)
        return f;
      if (a !== void 0)
        return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      d
    ];
  }
  const r = () => {
    const i = n.map((a) => /* @__PURE__ */ No(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return Tt(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    bze(r, ...t)
  ];
}
function bze(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(i)[`__scope${l}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return Tt(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Df = /* @__PURE__ */ it((e, t) => {
  const { children: n, ...o } = e, r = Dp.toArray(n), i = r.find(yze);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? Dp.count(a) > 1 ? Dp.only(null) : /* @__PURE__ */ bl(a) ? a.props.children : null : c);
    return /* @__PURE__ */ Pe(GN, We({}, o, {
      ref: t
    }), /* @__PURE__ */ bl(a) ? /* @__PURE__ */ w_(a, void 0, s) : null);
  }
  return /* @__PURE__ */ Pe(GN, We({}, o, {
    ref: t
  }), n);
});
Df.displayName = "Slot";
const GN = /* @__PURE__ */ it((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ bl(n) ? /* @__PURE__ */ w_(n, {
    ...$ze(o, n.props),
    ref: t ? Oq(t, n.ref) : n.ref
  }) : Dp.count(n) > 1 ? Dp.only(null) : null;
});
GN.displayName = "SlotClone";
const pae = ({ children: e }) => /* @__PURE__ */ Pe(Oi, null, e);
function yze(e) {
  return /* @__PURE__ */ bl(e) && e.type === pae;
}
function $ze(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = {
      ...r,
      ...i
    } : o === "className" && (n[o] = [
      r,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const wze = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], io = wze.reduce((e, t) => {
  const n = /* @__PURE__ */ it((o, r) => {
    const { asChild: i, ...a } = o, s = i ? Df : t;
    return Le(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Pe(s, We({}, a, {
      ref: r
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function L0(e, t) {
  e && Cie(
    () => e.dispatchEvent(t)
  );
}
function Ui(e) {
  const t = Ue(e);
  return Le(() => {
    t.current = e;
  }), Tt(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function Pq(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e);
  Le(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    n,
    t
  ]);
}
const HN = "dismissableLayer.update", kze = "dismissableLayer.pointerDownOutside", Sze = "dismissableLayer.focusOutside";
let tU;
const xze = /* @__PURE__ */ No({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), jT = /* @__PURE__ */ it((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, d = Pn(xze), [u, _] = ze(null), p = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, f] = ze({}), g = or(
    t,
    (D) => _(D)
  ), h = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf(b), $ = u ? h.indexOf(u) : -1, k = d.layersWithOutsidePointerEventsDisabled.size > 0, S = $ >= v, O = Eze((D) => {
    const M = D.target, N = [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    );
    !S || N || (i == null || i(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p), I = Tze((D) => {
    const M = D.target;
    [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    ) || (a == null || a(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p);
  return Pq((D) => {
    $ === d.layers.size - 1 && (r == null || r(D), !D.defaultPrevented && c && (D.preventDefault(), c()));
  }, p), Le(() => {
    if (u)
      return o && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (tU = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), nU(), () => {
        o && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = tU);
      };
  }, [
    u,
    p,
    o,
    d
  ]), Le(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), nU());
  }, [
    u,
    d
  ]), Le(() => {
    const D = () => f({});
    return document.addEventListener(HN, D), () => document.removeEventListener(HN, D);
  }, []), /* @__PURE__ */ Pe(io.div, We({}, l, {
    ref: g,
    style: {
      pointerEvents: k ? S ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Bt(e.onFocusCapture, I.onFocusCapture),
    onBlurCapture: Bt(e.onBlurCapture, I.onBlurCapture),
    onPointerDownCapture: Bt(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
});
function Eze(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1), r = Ue(() => {
  });
  return Le(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          mae(kze, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      }
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Tze(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1);
  return Le(() => {
    const r = (i) => {
      i.target && !o.current && mae(Sze, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function nU() {
  const e = new CustomEvent(HN);
  document.dispatchEvent(e);
}
function mae(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? L0(r, i) : r.dispatchEvent(i);
}
const Aze = globalThis != null && globalThis.document ? ts : () => {
}, Cze = $e.useId || (() => {
});
let zze = 0;
function Cc(e) {
  const [t, n] = $e.useState(Cze());
  return Aze(() => {
    e || n(
      (o) => o ?? String(zze++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Hv(e) {
  return e.split("-")[1];
}
function Iq(e) {
  return e === "y" ? "height" : "width";
}
function p_(e) {
  return e.split("-")[0];
}
function ig(e) {
  return ["top", "bottom"].includes(p_(e)) ? "x" : "y";
}
function oU(e, t, n) {
  let { reference: o, floating: r } = e;
  const i = o.x + o.width / 2 - r.width / 2, a = o.y + o.height / 2 - r.height / 2, s = ig(t), c = Iq(s), l = o[c] / 2 - r[c] / 2, d = s === "x";
  let u;
  switch (p_(t)) {
    case "top":
      u = { x: i, y: o.y - r.height };
      break;
    case "bottom":
      u = { x: i, y: o.y + o.height };
      break;
    case "right":
      u = { x: o.x + o.width, y: a };
      break;
    case "left":
      u = { x: o.x - r.width, y: a };
      break;
    default:
      u = { x: o.x, y: o.y };
  }
  switch (Hv(t)) {
    case "start":
      u[s] -= l * (n && d ? -1 : 1);
      break;
    case "end":
      u[s] += l * (n && d ? -1 : 1);
  }
  return u;
}
const Oze = async (e, t, n) => {
  const { placement: o = "bottom", strategy: r = "absolute", middleware: i = [], platform: a } = n, s = i.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({ reference: e, floating: t, strategy: r }), { x: d, y: u } = oU(l, o, c), _ = o, p = {}, f = 0;
  for (let g = 0; g < s.length; g++) {
    const { name: h, fn: b } = s[g], { x: v, y: $, data: k, reset: S } = await b({ x: d, y: u, initialPlacement: o, placement: _, strategy: r, middlewareData: p, rects: l, platform: a, elements: { reference: e, floating: t } });
    d = v ?? d, u = $ ?? u, p = { ...p, [h]: { ...p[h], ...k } }, S && f <= 50 && (f++, typeof S == "object" && (S.placement && (_ = S.placement), S.rects && (l = S.rects === !0 ? await a.getElementRects({ reference: e, floating: t, strategy: r }) : S.rects), { x: d, y: u } = oU(l, _, c)), g = -1);
  }
  return { x: d, y: u, placement: _, strategy: r, middlewareData: p };
};
function k_(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function fae(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function wx(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function sw(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: r, platform: i, rects: a, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: d = "viewport", elementContext: u = "floating", altBoundary: _ = !1, padding: p = 0 } = k_(t, e), f = fae(p), g = s[_ ? u === "floating" ? "reference" : "floating" : u], h = wx(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(g))) == null || n ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)), boundary: l, rootBoundary: d, strategy: c })), b = u === "floating" ? { ...a.floating, x: o, y: r } : a.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), $ = await (i.isElement == null ? void 0 : i.isElement(v)) && await (i.getScale == null ? void 0 : i.getScale(v)) || { x: 1, y: 1 }, k = wx(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: b, offsetParent: v, strategy: c }) : b);
  return { top: (h.top - k.top + f.top) / $.y, bottom: (k.bottom - h.bottom + f.bottom) / $.y, left: (h.left - k.left + f.left) / $.x, right: (k.right - h.right + f.right) / $.x };
}
const cw = Math.min, Bm = Math.max;
function KN(e, t, n) {
  return Bm(e, cw(t, n));
}
const rU = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { x: n, y: o, placement: r, rects: i, platform: a, elements: s } = t, { element: c, padding: l = 0 } = k_(e, t) || {};
  if (c == null)
    return {};
  const d = fae(l), u = { x: n, y: o }, _ = ig(r), p = Iq(_), f = await a.getDimensions(c), g = _ === "y", h = g ? "top" : "left", b = g ? "bottom" : "right", v = g ? "clientHeight" : "clientWidth", $ = i.reference[p] + i.reference[_] - u[_] - i.floating[p], k = u[_] - i.reference[_], S = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
  let O = S ? S[v] : 0;
  O && await (a.isElement == null ? void 0 : a.isElement(S)) || (O = s.floating[v] || i.floating[p]);
  const I = $ / 2 - k / 2, D = O / 2 - f[p] / 2 - 1, M = cw(d[h], D), N = cw(d[b], D), C = M, P = O - f[p] - N, x = O / 2 - f[p] / 2 + I, w = KN(C, x, P), E = Hv(r) != null && x != w && i.reference[p] / 2 - (x < C ? M : N) - f[p] / 2 < 0;
  return { [_]: u[_] - (E ? x < C ? C - x : P - x : 0), data: { [_]: w, centerOffset: x - w } };
} }), gae = ["top", "right", "bottom", "left"];
gae.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
const Pze = { left: "right", right: "left", bottom: "top", top: "bottom" };
function kx(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Pze[t]);
}
function Ize(e, t, n) {
  n === void 0 && (n = !1);
  const o = Hv(e), r = ig(e), i = Iq(r);
  let a = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = kx(a)), { main: a, cross: kx(a) };
}
const Rze = { start: "end", end: "start" };
function FO(e) {
  return e.replace(/start|end/g, (t) => Rze[t]);
}
const hae = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: o, middlewareData: r, rects: i, initialPlacement: a, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: d = !0, fallbackPlacements: u, fallbackStrategy: _ = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: f = !0, ...g } = k_(e, t), h = p_(o), b = p_(a) === a, v = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), $ = u || (b || !f ? [kx(a)] : function(C) {
      const P = kx(C);
      return [FO(C), P, FO(P)];
    }(a));
    u || p === "none" || $.push(...function(C, P, x, w) {
      const E = Hv(C);
      let T = function(z, j, q) {
        const V = ["left", "right"], F = ["right", "left"], L = ["top", "bottom"], U = ["bottom", "top"];
        switch (z) {
          case "top":
          case "bottom":
            return q ? j ? F : V : j ? V : F;
          case "left":
          case "right":
            return j ? L : U;
          default:
            return [];
        }
      }(p_(C), x === "start", w);
      return E && (T = T.map((z) => z + "-" + E), P && (T = T.concat(T.map(FO)))), T;
    }(a, f, p, v));
    const k = [a, ...$], S = await sw(t, g), O = [];
    let I = ((n = r.flip) == null ? void 0 : n.overflows) || [];
    if (l && O.push(S[h]), d) {
      const { main: C, cross: P } = Ize(o, i, v);
      O.push(S[C], S[P]);
    }
    if (I = [...I, { placement: o, overflows: O }], !O.every((C) => C <= 0)) {
      var D, M;
      const C = (((D = r.flip) == null ? void 0 : D.index) || 0) + 1, P = k[C];
      if (P)
        return { data: { index: C, overflows: I }, reset: { placement: P } };
      let x = (M = I.filter((w) => w.overflows[0] <= 0).sort((w, E) => w.overflows[1] - E.overflows[1])[0]) == null ? void 0 : M.placement;
      if (!x)
        switch (_) {
          case "bestFit": {
            var N;
            const w = (N = I.map((E) => [E.placement, E.overflows.filter((T) => T > 0).reduce((T, z) => T + z, 0)]).sort((E, T) => E[1] - T[1])[0]) == null ? void 0 : N[0];
            w && (x = w);
            break;
          }
          case "initialPlacement":
            x = a;
        }
      if (o !== x)
        return { reset: { placement: x } };
    }
    return {};
  } };
};
function iU(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function aU(e) {
  return gae.some((t) => e[t] >= 0);
}
const vae = function(e) {
  return e === void 0 && (e = {}), { name: "hide", options: e, async fn(t) {
    const { rects: n } = t, { strategy: o = "referenceHidden", ...r } = k_(e, t);
    switch (o) {
      case "referenceHidden": {
        const i = iU(await sw(t, { ...r, elementContext: "reference" }), n.reference);
        return { data: { referenceHiddenOffsets: i, referenceHidden: aU(i) } };
      }
      case "escaped": {
        const i = iU(await sw(t, { ...r, altBoundary: !0 }), n.floating);
        return { data: { escapedOffsets: i, escaped: aU(i) } };
      }
      default:
        return {};
    }
  } };
}, bae = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: o } = t, r = await async function(i, a) {
      const { placement: s, platform: c, elements: l } = i, d = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), u = p_(s), _ = Hv(s), p = ig(s) === "x", f = ["left", "top"].includes(u) ? -1 : 1, g = d && p ? -1 : 1, h = k_(a, i);
      let { mainAxis: b, crossAxis: v, alignmentAxis: $ } = typeof h == "number" ? { mainAxis: h, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...h };
      return _ && typeof $ == "number" && (v = _ === "end" ? -1 * $ : $), p ? { x: v * g, y: b * f } : { x: b * f, y: v * g };
    }(t, e);
    return { x: n + r.x, y: o + r.y, data: r };
  } };
};
function yae(e) {
  return e === "x" ? "y" : "x";
}
const $ae = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: o, placement: r } = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: s = { fn: (h) => {
      let { x: b, y: v } = h;
      return { x: b, y: v };
    } }, ...c } = k_(e, t), l = { x: n, y: o }, d = await sw(t, c), u = ig(p_(r)), _ = yae(u);
    let p = l[u], f = l[_];
    if (i) {
      const h = u === "y" ? "bottom" : "right";
      p = KN(p + d[u === "y" ? "top" : "left"], p, p - d[h]);
    }
    if (a) {
      const h = _ === "y" ? "bottom" : "right";
      f = KN(f + d[_ === "y" ? "top" : "left"], f, f - d[h]);
    }
    const g = s.fn({ ...t, [u]: p, [_]: f });
    return { ...g, data: { x: g.x - n, y: g.y - o } };
  } };
}, wae = function(e) {
  return e === void 0 && (e = {}), { options: e, fn(t) {
    const { x: n, y: o, placement: r, rects: i, middlewareData: a } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = k_(e, t), d = { x: n, y: o }, u = ig(r), _ = yae(u);
    let p = d[u], f = d[_];
    const g = k_(s, t), h = typeof g == "number" ? { mainAxis: g, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...g };
    if (c) {
      const $ = u === "y" ? "height" : "width", k = i.reference[u] - i.floating[$] + h.mainAxis, S = i.reference[u] + i.reference[$] - h.mainAxis;
      p < k ? p = k : p > S && (p = S);
    }
    if (l) {
      var b, v;
      const $ = u === "y" ? "width" : "height", k = ["top", "left"].includes(p_(r)), S = i.reference[_] - i.floating[$] + (k && ((b = a.offset) == null ? void 0 : b[_]) || 0) + (k ? 0 : h.crossAxis), O = i.reference[_] + i.reference[$] + (k ? 0 : ((v = a.offset) == null ? void 0 : v[_]) || 0) - (k ? h.crossAxis : 0);
      f < S ? f = S : f > O && (f = O);
    }
    return { [u]: p, [_]: f };
  } };
}, kae = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: o, platform: r, elements: i } = t, { apply: a = () => {
    }, ...s } = k_(e, t), c = await sw(t, s), l = p_(n), d = Hv(n), u = ig(n) === "x", { width: _, height: p } = o.floating;
    let f, g;
    l === "top" || l === "bottom" ? (f = l, g = d === (await (r.isRTL == null ? void 0 : r.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = l, f = d === "end" ? "top" : "bottom");
    const h = p - c[f], b = _ - c[g], v = !t.middlewareData.shift;
    let $ = h, k = b;
    if (u) {
      const O = _ - c.left - c.right;
      k = d || v ? cw(b, O) : O;
    } else {
      const O = p - c.top - c.bottom;
      $ = d || v ? cw(h, O) : O;
    }
    if (v && !d) {
      const O = Bm(c.left, 0), I = Bm(c.right, 0), D = Bm(c.top, 0), M = Bm(c.bottom, 0);
      u ? k = _ - 2 * (O !== 0 || I !== 0 ? O + I : Bm(c.left, c.right)) : $ = p - 2 * (D !== 0 || M !== 0 ? D + M : Bm(c.top, c.bottom));
    }
    await a({ ...t, availableWidth: k, availableHeight: $ });
    const S = await r.getDimensions(i.floating);
    return _ !== S.width || p !== S.height ? { reset: { rects: !0 } } : {};
  } };
};
function yl(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nd(e) {
  return yl(e).getComputedStyle(e);
}
function Sae(e) {
  return e instanceof yl(e).Node;
}
function Yp(e) {
  return Sae(e) ? (e.nodeName || "").toLowerCase() : "";
}
function id(e) {
  return e instanceof yl(e).HTMLElement;
}
function Ec(e) {
  return e instanceof yl(e).Element;
}
function sU(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof yl(e).ShadowRoot || e instanceof ShadowRoot;
}
function lw(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = nd(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Nze(e) {
  return ["table", "td", "th"].includes(Yp(e));
}
function YN(e) {
  const t = Rq(), n = nd(e);
  return n.transform !== "none" || n.perspective !== "none" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Rq() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function FT(e) {
  return ["html", "body", "#document"].includes(Yp(e));
}
const cU = Math.min, E$ = Math.max, Sx = Math.round;
function xae(e) {
  const t = nd(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = id(e), i = r ? e.offsetWidth : n, a = r ? e.offsetHeight : o, s = Sx(n) !== i || Sx(o) !== a;
  return s && (n = i, o = a), { width: n, height: o, fallback: s };
}
function Eae(e) {
  return Ec(e) ? e : e.contextElement;
}
const Tae = { x: 1, y: 1 };
function Ih(e) {
  const t = Eae(e);
  if (!id(t))
    return Tae;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = xae(t);
  let a = (i ? Sx(n.width) : n.width) / o, s = (i ? Sx(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
const lU = { x: 0, y: 0 };
function Aae(e, t, n) {
  var o, r;
  if (t === void 0 && (t = !0), !Rq())
    return lU;
  const i = e ? yl(e) : window;
  return !n || t && n !== i ? lU : { x: ((o = i.visualViewport) == null ? void 0 : o.offsetLeft) || 0, y: ((r = i.visualViewport) == null ? void 0 : r.offsetTop) || 0 };
}
function Mf(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = Eae(e);
  let a = Tae;
  t && (o ? Ec(o) && (a = Ih(o)) : a = Ih(e));
  const s = Aae(i, n, o);
  let c = (r.left + s.x) / a.x, l = (r.top + s.y) / a.y, d = r.width / a.x, u = r.height / a.y;
  if (i) {
    const _ = yl(i), p = o && Ec(o) ? yl(o) : o;
    let f = _.frameElement;
    for (; f && o && p !== _; ) {
      const g = Ih(f), h = f.getBoundingClientRect(), b = getComputedStyle(f);
      h.x += (f.clientLeft + parseFloat(b.paddingLeft)) * g.x, h.y += (f.clientTop + parseFloat(b.paddingTop)) * g.y, c *= g.x, l *= g.y, d *= g.x, u *= g.y, c += h.x, l += h.y, f = yl(f).frameElement;
    }
  }
  return wx({ width: d, height: u, x: c, y: l });
}
function Mp(e) {
  return ((Sae(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function VT(e) {
  return Ec(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Cae(e) {
  return Mf(Mp(e)).left + VT(e).scrollLeft;
}
function Ev(e) {
  if (Yp(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || sU(e) && e.host || Mp(e);
  return sU(t) ? t.host : t;
}
function zae(e) {
  const t = Ev(e);
  return FT(t) ? t.ownerDocument.body : id(t) && lw(t) ? t : zae(t);
}
function T$(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = zae(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = yl(o);
  return r ? t.concat(i, i.visualViewport || [], lw(o) ? o : []) : t.concat(o, T$(o));
}
function dU(e, t, n) {
  let o;
  if (t === "viewport")
    o = function(r, i) {
      const a = yl(r), s = Mp(r), c = a.visualViewport;
      let l = s.clientWidth, d = s.clientHeight, u = 0, _ = 0;
      if (c) {
        l = c.width, d = c.height;
        const p = Rq();
        (!p || p && i === "fixed") && (u = c.offsetLeft, _ = c.offsetTop);
      }
      return { width: l, height: d, x: u, y: _ };
    }(e, n);
  else if (t === "document")
    o = function(r) {
      const i = Mp(r), a = VT(r), s = r.ownerDocument.body, c = E$(i.scrollWidth, i.clientWidth, s.scrollWidth, s.clientWidth), l = E$(i.scrollHeight, i.clientHeight, s.scrollHeight, s.clientHeight);
      let d = -a.scrollLeft + Cae(r);
      const u = -a.scrollTop;
      return nd(s).direction === "rtl" && (d += E$(i.clientWidth, s.clientWidth) - c), { width: c, height: l, x: d, y: u };
    }(Mp(e));
  else if (Ec(t))
    o = function(r, i) {
      const a = Mf(r, !0, i === "fixed"), s = a.top + r.clientTop, c = a.left + r.clientLeft, l = id(r) ? Ih(r) : { x: 1, y: 1 };
      return { width: r.clientWidth * l.x, height: r.clientHeight * l.y, x: c * l.x, y: s * l.y };
    }(t, n);
  else {
    const r = Aae(e);
    o = { ...t, x: t.x - r.x, y: t.y - r.y };
  }
  return wx(o);
}
function Oae(e, t) {
  const n = Ev(e);
  return !(n === t || !Ec(n) || FT(n)) && (nd(n).position === "fixed" || Oae(n, t));
}
function uU(e, t) {
  return id(e) && nd(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function _U(e, t) {
  const n = yl(e);
  if (!id(e))
    return n;
  let o = uU(e, t);
  for (; o && Nze(o) && nd(o).position === "static"; )
    o = uU(o, t);
  return o && (Yp(o) === "html" || Yp(o) === "body" && nd(o).position === "static" && !YN(o)) ? n : o || function(r) {
    let i = Ev(r);
    for (; id(i) && !FT(i); ) {
      if (YN(i))
        return i;
      i = Ev(i);
    }
    return null;
  }(e) || n;
}
function Dze(e, t, n) {
  const o = id(t), r = Mp(t), i = n === "fixed", a = Mf(e, !0, i, t);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const c = { x: 0, y: 0 };
  if (o || !o && !i)
    if ((Yp(t) !== "body" || lw(r)) && (s = VT(t)), id(t)) {
      const l = Mf(t, !0, i, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      r && (c.x = Cae(r));
  return { x: a.left + s.scrollLeft - c.x, y: a.top + s.scrollTop - c.y, width: a.width, height: a.height };
}
const Mze = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: r } = e;
  const i = n === "clippingAncestors" ? function(l, d) {
    const u = d.get(l);
    if (u)
      return u;
    let _ = T$(l).filter((h) => Ec(h) && Yp(h) !== "body"), p = null;
    const f = nd(l).position === "fixed";
    let g = f ? Ev(l) : l;
    for (; Ec(g) && !FT(g); ) {
      const h = nd(g), b = YN(g);
      b || h.position !== "fixed" || (p = null), (f ? !b && !p : !b && h.position === "static" && p && ["absolute", "fixed"].includes(p.position) || lw(g) && !b && Oae(l, g)) ? _ = _.filter((v) => v !== g) : p = h, g = Ev(g);
    }
    return d.set(l, _), _;
  }(t, this._c) : [].concat(n), a = [...i, o], s = a[0], c = a.reduce((l, d) => {
    const u = dU(t, d, r);
    return l.top = E$(u.top, l.top), l.right = cU(u.right, l.right), l.bottom = cU(u.bottom, l.bottom), l.left = E$(u.left, l.left), l;
  }, dU(t, s, r));
  return { width: c.right - c.left, height: c.bottom - c.top, x: c.left, y: c.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: o } = e;
  const r = id(n), i = Mp(n);
  if (n === i)
    return t;
  let a = { scrollLeft: 0, scrollTop: 0 }, s = { x: 1, y: 1 };
  const c = { x: 0, y: 0 };
  if ((r || !r && o !== "fixed") && ((Yp(n) !== "body" || lw(i)) && (a = VT(n)), id(n))) {
    const l = Mf(n);
    s = Ih(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return { width: t.width * s.x, height: t.height * s.y, x: t.x * s.x - a.scrollLeft * s.x + c.x, y: t.y * s.y - a.scrollTop * s.y + c.y };
}, isElement: Ec, getDimensions: function(e) {
  return xae(e);
}, getOffsetParent: _U, getDocumentElement: Mp, getScale: Ih, async getElementRects(e) {
  let { reference: t, floating: n, strategy: o } = e;
  const r = this.getOffsetParent || _U, i = this.getDimensions;
  return { reference: Dze(t, await r(n), o), floating: { x: 0, y: 0, ...await i(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => nd(e).direction === "rtl" };
function Pae(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: a = !0, animationFrame: s = !1 } = o, c = r || i ? [...Ec(e) ? T$(e) : e.contextElement ? T$(e.contextElement) : [], ...T$(t)] : [];
  c.forEach((_) => {
    const p = !Ec(_) && _.toString().includes("V");
    !r || s && !p || _.addEventListener("scroll", n, { passive: !0 }), i && _.addEventListener("resize", n);
  });
  let l, d = null;
  a && (d = new ResizeObserver(() => {
    n();
  }), Ec(e) && !s && d.observe(e), Ec(e) || !e.contextElement || s || d.observe(e.contextElement), d.observe(t));
  let u = s ? Mf(e) : null;
  return s && function _() {
    const p = Mf(e);
    !u || p.x === u.x && p.y === u.y && p.width === u.width && p.height === u.height || n(), u = p, l = requestAnimationFrame(_);
  }(), n(), () => {
    var _;
    c.forEach((p) => {
      r && p.removeEventListener("scroll", n), i && p.removeEventListener("resize", n);
    }), (_ = d) == null || _.disconnect(), d = null, s && cancelAnimationFrame(l);
  };
}
const Lze = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = { platform: Mze, ...n }, i = { ...r.platform, _c: o };
  return Oze(e, t, { ...r, platform: i });
}, Iae = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? rU({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? rU({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
};
var $S = typeof document < "u" ? ts : Le;
function xx(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (o = n; o-- !== 0; )
        if (!xx(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !xx(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Rae(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pU(e, t) {
  const n = Rae(e);
  return Math.round(t * n) / n;
}
function mU(e) {
  const t = $e.useRef(e);
  return $S(() => {
    t.current = e;
  }), t;
}
function Nae(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [d, u] = $e.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [_, p] = $e.useState(o);
  xx(_, o) || p(o);
  const [f, g] = $e.useState(null), [h, b] = $e.useState(null), v = $e.useCallback((T) => {
    T != O.current && (O.current = T, g(T));
  }, [g]), $ = $e.useCallback((T) => {
    T !== I.current && (I.current = T, b(T));
  }, [b]), k = i || f, S = a || h, O = $e.useRef(null), I = $e.useRef(null), D = $e.useRef(d), M = mU(c), N = mU(r), C = $e.useCallback(() => {
    if (!O.current || !I.current)
      return;
    const T = {
      placement: t,
      strategy: n,
      middleware: _
    };
    N.current && (T.platform = N.current), Lze(O.current, I.current, T).then((z) => {
      const j = {
        ...z,
        isPositioned: !0
      };
      P.current && !xx(D.current, j) && (D.current = j, NAe.flushSync(() => {
        u(j);
      }));
    });
  }, [_, t, n, N]);
  $S(() => {
    l === !1 && D.current.isPositioned && (D.current.isPositioned = !1, u((T) => ({
      ...T,
      isPositioned: !1
    })));
  }, [l]);
  const P = $e.useRef(!1);
  $S(() => (P.current = !0, () => {
    P.current = !1;
  }), []), $S(() => {
    if (k && (O.current = k), S && (I.current = S), k && S) {
      if (M.current)
        return M.current(k, S, C);
      C();
    }
  }, [k, S, C, M]);
  const x = $e.useMemo(() => ({
    reference: O,
    floating: I,
    setReference: v,
    setFloating: $
  }), [v, $]), w = $e.useMemo(() => ({
    reference: k,
    floating: S
  }), [k, S]), E = $e.useMemo(() => {
    const T = {
      position: n,
      left: 0,
      top: 0
    };
    if (!w.floating)
      return T;
    const z = pU(w.floating, d.x), j = pU(w.floating, d.y);
    return s ? {
      ...T,
      transform: "translate(" + z + "px, " + j + "px)",
      ...Rae(w.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: z,
      top: j
    };
  }, [n, s, w.floating, d.x, d.y]);
  return $e.useMemo(() => ({
    ...d,
    update: C,
    refs: x,
    elements: w,
    floatingStyles: E
  }), [d, C, x, w, E]);
}
const fU = globalThis != null && globalThis.document ? ts : () => {
}, qze = globalThis != null && globalThis.document ? ts : () => {
};
function BT(e) {
  const [t, n] = ze(void 0);
  return qze(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Dae = "Popper", [Mae, Kv] = os(Dae), [jze, Lae] = Mae(Dae), Fze = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = ze(null);
  return /* @__PURE__ */ Pe(jze, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, Vze = "PopperAnchor", Bze = /* @__PURE__ */ it((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = Lae(Vze, n), a = Ue(null), s = or(t, a);
  return Le(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || a.current);
  }), o ? null : /* @__PURE__ */ Pe(io.div, We({}, r, {
    ref: s
  }));
}), qae = "PopperContent", [Uze, Hmd] = Mae(qae), Wze = /* @__PURE__ */ it((e, t) => {
  var n, o, r, i, a, s, c, l;
  const { __scopePopper: d, side: u = "bottom", sideOffset: _ = 0, align: p = "center", alignOffset: f = 0, arrowPadding: g = 0, collisionBoundary: h = [], collisionPadding: b = 0, sticky: v = "partial", hideWhenDetached: $ = !1, avoidCollisions: k = !0, onPlaced: S, ...O } = e, I = Lae(qae, d), [D, M] = ze(null), N = or(
    t,
    (de) => M(de)
  ), [C, P] = ze(null), x = BT(C), w = (n = x == null ? void 0 : x.width) !== null && n !== void 0 ? n : 0, E = (o = x == null ? void 0 : x.height) !== null && o !== void 0 ? o : 0, T = u + (p !== "center" ? "-" + p : ""), z = typeof b == "number" ? b : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...b
  }, j = Array.isArray(h) ? h : [
    h
  ], q = j.length > 0, V = {
    padding: z,
    boundary: j.filter(Gze),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: q
  }, { refs: F, floatingStyles: L, placement: U, isPositioned: W, middlewareData: H } = Nae({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: T,
    whileElementsMounted: Pae,
    elements: {
      reference: I.anchor
    },
    middleware: [
      bae({
        mainAxis: _ + E,
        alignmentAxis: f
      }),
      k && $ae({
        mainAxis: !0,
        crossAxis: !1,
        limiter: v === "partial" ? wae() : void 0,
        ...V
      }),
      k && hae({
        ...V
      }),
      kae({
        ...V,
        apply: ({ elements: de, rects: te, availableWidth: ue, availableHeight: le }) => {
          const { width: se, height: me } = te.reference, pe = de.floating.style;
          pe.setProperty("--radix-popper-available-width", `${ue}px`), pe.setProperty("--radix-popper-available-height", `${le}px`), pe.setProperty("--radix-popper-anchor-width", `${se}px`), pe.setProperty("--radix-popper-anchor-height", `${me}px`);
        }
      }),
      C && Iae({
        element: C,
        padding: g
      }),
      Hze({
        arrowWidth: w,
        arrowHeight: E
      }),
      $ && vae({
        strategy: "referenceHidden"
      })
    ]
  }), [Q, X] = jae(U), re = Ui(S);
  fU(() => {
    W && (re == null || re());
  }, [
    W,
    re
  ]);
  const Z = (r = H.arrow) === null || r === void 0 ? void 0 : r.x, ee = (i = H.arrow) === null || i === void 0 ? void 0 : i.y, J = ((a = H.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [oe, ce] = ze();
  return fU(() => {
    D && ce(window.getComputedStyle(D).zIndex);
  }, [
    D
  ]), /* @__PURE__ */ Pe("div", {
    ref: F.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...L,
      transform: W ? L.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: oe,
      "--radix-popper-transform-origin": [
        (s = H.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = H.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Pe(Uze, {
    scope: d,
    placedSide: Q,
    onArrowChange: P,
    arrowX: Z,
    arrowY: ee,
    shouldHideArrow: J
  }, /* @__PURE__ */ Pe(io.div, We({
    "data-side": Q,
    "data-align": X
  }, O, {
    ref: N,
    style: {
      ...O.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: W ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = H.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function Gze(e) {
  return e !== null;
}
const Hze = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, a;
    const { placement: s, rects: c, middlewareData: l } = t, u = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, _ = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [f, g] = jae(s), h = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], b = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + _ / 2, v = ((i = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let $ = "", k = "";
    return f === "bottom" ? ($ = u ? h : `${b}px`, k = `${-p}px`) : f === "top" ? ($ = u ? h : `${b}px`, k = `${c.floating.height + p}px`) : f === "right" ? ($ = `${-p}px`, k = u ? h : `${v}px`) : f === "left" && ($ = `${c.floating.width + p}px`, k = u ? h : `${v}px`), {
      data: {
        x: $,
        y: k
      }
    };
  }
});
function jae(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Nq = Fze, Dq = Bze, Mq = Wze, Lq = /* @__PURE__ */ it((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ Uv.createPortal(/* @__PURE__ */ Pe(io.div, We({}, r, {
    ref: t
  })), o) : null;
}), gU = globalThis != null && globalThis.document ? ts : () => {
};
function Kze(e, t) {
  return R0((n, o) => {
    const r = t[n][o];
    return r ?? n;
  }, e);
}
const rs = (e) => {
  const { present: t, children: n } = e, o = Yze(t), r = typeof n == "function" ? n({
    present: o.isPresent
  }) : Dp.only(n), i = or(o.ref, r.ref);
  return typeof n == "function" || o.isPresent ? /* @__PURE__ */ w_(r, {
    ref: i
  }) : null;
};
rs.displayName = "Presence";
function Yze(e) {
  const [t, n] = ze(), o = Ue({}), r = Ue(e), i = Ue("none"), a = e ? "mounted" : "unmounted", [s, c] = Kze(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Le(() => {
    const l = G1(o.current);
    i.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), gU(() => {
    const l = o.current, d = r.current;
    if (d !== e) {
      const _ = i.current, p = G1(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && _ !== p ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [
    e,
    c
  ]), gU(() => {
    if (t) {
      const l = (u) => {
        const p = G1(o.current).includes(u.animationName);
        u.target === t && p && Cie(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (i.current = G1(o.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: at((l) => {
      l && (o.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function G1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function jc({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, r] = Zze({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : o, s = Ui(n), c = at((l) => {
    if (i) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      r(l);
  }, [
    i,
    e,
    r,
    s
  ]);
  return [
    a,
    c
  ];
}
function Zze({ defaultProp: e, onChange: t }) {
  const n = ze(e), [o] = n, r = Ue(o), i = Ui(t);
  return Le(() => {
    r.current !== o && (i(o), r.current = o);
  }, [
    o,
    r,
    i
  ]), n;
}
const qq = /* @__PURE__ */ it((e, t) => /* @__PURE__ */ Pe(io.span, We({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), Qze = qq, [UT, Kmd] = os("Tooltip", [
  Kv
]), jq = Kv(), Jze = "TooltipProvider", Xze = 700, ZN = "tooltip.open", [eOe, Fq] = UT(Jze), Fae = (e) => {
  const { __scopeTooltip: t, delayDuration: n = Xze, skipDelayDuration: o = 300, disableHoverableContent: r = !1, children: i } = e, [a, s] = ze(!0), c = Ue(!1), l = Ue(0);
  return Le(() => {
    const d = l.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ Pe(eOe, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: at(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: at(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        o
      );
    }, [
      o
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: at((d) => {
      c.current = d;
    }, []),
    disableHoverableContent: r
  }, i);
}, Vq = "Tooltip", [tOe, WT] = UT(Vq), nOe = (e) => {
  const { __scopeTooltip: t, children: n, open: o, defaultOpen: r = !1, onOpenChange: i, disableHoverableContent: a, delayDuration: s } = e, c = Fq(Vq, e.__scopeTooltip), l = jq(t), [d, u] = ze(null), _ = Cc(), p = Ue(0), f = a ?? c.disableHoverableContent, g = s ?? c.delayDuration, h = Ue(!1), [b = !1, v] = jc({
    prop: o,
    defaultProp: r,
    onChange: (I) => {
      I ? (c.onOpen(), document.dispatchEvent(new CustomEvent(ZN))) : c.onClose(), i == null || i(I);
    }
  }), $ = Tt(() => b ? h.current ? "delayed-open" : "instant-open" : "closed", [
    b
  ]), k = at(() => {
    window.clearTimeout(p.current), h.current = !1, v(!0);
  }, [
    v
  ]), S = at(() => {
    window.clearTimeout(p.current), v(!1);
  }, [
    v
  ]), O = at(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      h.current = !0, v(!0);
    }, g);
  }, [
    g,
    v
  ]);
  return Le(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ Pe(Nq, l, /* @__PURE__ */ Pe(tOe, {
    scope: t,
    contentId: _,
    open: b,
    stateAttribute: $,
    trigger: d,
    onTriggerChange: u,
    onTriggerEnter: at(() => {
      c.isOpenDelayed ? O() : k();
    }, [
      c.isOpenDelayed,
      O,
      k
    ]),
    onTriggerLeave: at(() => {
      f ? S() : window.clearTimeout(p.current);
    }, [
      S,
      f
    ]),
    onOpen: k,
    onClose: S,
    disableHoverableContent: f
  }, n));
}, hU = "TooltipTrigger", oOe = /* @__PURE__ */ it((e, t) => {
  const { __scopeTooltip: n, ...o } = e, r = WT(hU, n), i = Fq(hU, n), a = jq(n), s = Ue(null), c = or(t, s, r.onTriggerChange), l = Ue(!1), d = Ue(!1), u = at(
    () => l.current = !1,
    []
  );
  return Le(() => () => document.removeEventListener("pointerup", u), [
    u
  ]), /* @__PURE__ */ Pe(Dq, We({
    asChild: !0
  }, a), /* @__PURE__ */ Pe(io.button, We({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": r.open ? r.contentId : void 0,
    "data-state": r.stateAttribute
  }, o, {
    ref: c,
    onPointerMove: Bt(e.onPointerMove, (_) => {
      _.pointerType !== "touch" && !d.current && !i.isPointerInTransitRef.current && (r.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: Bt(e.onPointerLeave, () => {
      r.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: Bt(e.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", u, {
        once: !0
      });
    }),
    onFocus: Bt(e.onFocus, () => {
      l.current || r.onOpen();
    }),
    onBlur: Bt(e.onBlur, r.onClose),
    onClick: Bt(e.onClick, r.onClose)
  })));
}), rOe = "TooltipPortal", [Ymd, iOe] = UT(rOe, {
  forceMount: void 0
}), dw = "TooltipContent", aOe = /* @__PURE__ */ it((e, t) => {
  const n = iOe(dw, e.__scopeTooltip), { forceMount: o = n.forceMount, side: r = "top", ...i } = e, a = WT(dw, e.__scopeTooltip);
  return /* @__PURE__ */ Pe(rs, {
    present: o || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ Pe(Vae, We({
    side: r
  }, i, {
    ref: t
  })) : /* @__PURE__ */ Pe(sOe, We({
    side: r
  }, i, {
    ref: t
  })));
}), sOe = /* @__PURE__ */ it((e, t) => {
  const n = WT(dw, e.__scopeTooltip), o = Fq(dw, e.__scopeTooltip), r = Ue(null), i = or(t, r), [a, s] = ze(null), { trigger: c, onClose: l } = n, d = r.current, { onPointerInTransitChange: u } = o, _ = at(() => {
    s(null), u(!1);
  }, [
    u
  ]), p = at((f, g) => {
    const h = f.currentTarget, b = {
      x: f.clientX,
      y: f.clientY
    }, v = lOe(b, h.getBoundingClientRect()), $ = dOe(b, v), k = uOe(g.getBoundingClientRect()), S = pOe([
      ...$,
      ...k
    ]);
    s(S), u(!0);
  }, [
    u
  ]);
  return Le(() => () => _(), [
    _
  ]), Le(() => {
    if (c && d) {
      const f = (h) => p(h, d), g = (h) => p(h, c);
      return c.addEventListener("pointerleave", f), d.addEventListener("pointerleave", g), () => {
        c.removeEventListener("pointerleave", f), d.removeEventListener("pointerleave", g);
      };
    }
  }, [
    c,
    d,
    p,
    _
  ]), Le(() => {
    if (a) {
      const f = (g) => {
        const h = g.target, b = {
          x: g.clientX,
          y: g.clientY
        }, v = (c == null ? void 0 : c.contains(h)) || (d == null ? void 0 : d.contains(h)), $ = !_Oe(b, a);
        v ? _() : $ && (_(), l());
      };
      return document.addEventListener("pointermove", f), () => document.removeEventListener("pointermove", f);
    }
  }, [
    c,
    d,
    a,
    l,
    _
  ]), /* @__PURE__ */ Pe(Vae, We({}, e, {
    ref: i
  }));
}), [cOe, Zmd] = UT(Vq, {
  isInside: !1
}), Vae = /* @__PURE__ */ it((e, t) => {
  const { __scopeTooltip: n, children: o, "aria-label": r, onEscapeKeyDown: i, onPointerDownOutside: a, ...s } = e, c = WT(dw, n), l = jq(n), { onClose: d } = c;
  return Le(() => (document.addEventListener(ZN, d), () => document.removeEventListener(ZN, d)), [
    d
  ]), Le(() => {
    if (c.trigger) {
      const u = (_) => {
        const p = _.target;
        p != null && p.contains(c.trigger) && d();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    d
  ]), /* @__PURE__ */ Pe(jT, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ Pe(Mq, We({
    "data-state": c.stateAttribute
  }, l, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ Pe(pae, null, o), /* @__PURE__ */ Pe(cOe, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ Pe(Qze, {
    id: c.contentId,
    role: "tooltip"
  }, r || o))));
});
function lOe(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, o, r, i)) {
    case i:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function dOe(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      o.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      o.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      o.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return o;
}
function uOe(e) {
  const { top: t, right: n, bottom: o, left: r } = e;
  return [
    {
      x: r,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: o
    },
    {
      x: r,
      y: o
    }
  ];
}
function _Oe(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, d = t[a].y;
    c > o != d > o && n < (l - s) * (o - c) / (d - c) + s && (r = !r);
  }
  return r;
}
function pOe(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), mOe(t);
}
function mOe(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (r.y - a.y) >= (i.y - a.y) * (r.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const r = e[o];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (r.y - a.y) >= (i.y - a.y) * (r.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const fOe = Fae, gOe = nOe, hOe = oOe, vOe = aOe, bOe = ({ children: e }) => /* @__PURE__ */ m(Ce, { children: e }), vU = Fae, yOe = bOe, $Oe = hOe, wOe = fOe, kOe = vOe, SOe = gOe;
function xOe() {
  for (var e = 0, t, n, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Bae(t)) && (o && (o += " "), o += n);
  return o;
}
function Bae(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", o = 0; o < e.length; o++)
    e[o] && (t = Bae(e[o])) && (n && (n += " "), n += t);
  return n;
}
var Bq = "-";
function EOe(e) {
  var t = AOe(e), n = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, r = o === void 0 ? {} : o;
  function i(s) {
    var c = s.split(Bq);
    return c[0] === "" && c.length !== 1 && c.shift(), Uae(c, t) || TOe(s);
  }
  function a(s, c) {
    var l = n[s] || [];
    return c && r[s] ? [].concat(l, r[s]) : l;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: a
  };
}
function Uae(e, t) {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], o = t.nextPart.get(n), r = o ? Uae(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length !== 0) {
    var i = e.join(Bq);
    return (a = t.validators.find(function(s) {
      var c = s.validator;
      return c(i);
    })) == null ? void 0 : a.classGroupId;
  }
}
var bU = /^\[(.+)\]$/;
function TOe(e) {
  if (bU.test(e)) {
    var t = bU.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function AOe(e) {
  var t = e.theme, n = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, r = zOe(Object.entries(e.classGroups), n);
  return r.forEach(function(i) {
    var a = i[0], s = i[1];
    QN(s, o, a, t);
  }), o;
}
function QN(e, t, n, o) {
  e.forEach(function(r) {
    if (typeof r == "string") {
      var i = r === "" ? t : yU(t, r);
      i.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (COe(r)) {
        QN(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(function(a) {
      var s = a[0], c = a[1];
      QN(c, yU(t, s), n, o);
    });
  });
}
function yU(e, t) {
  var n = e;
  return t.split(Bq).forEach(function(o) {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}
function COe(e) {
  return e.isThemeGetter;
}
function zOe(e, t) {
  return t ? e.map(function(n) {
    var o = n[0], r = n[1], i = r.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var c = s[0], l = s[1];
        return [t + c, l];
      })) : a;
    });
    return [o, i];
  }) : e;
}
function OOe(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function r(i, a) {
    n.set(i, a), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = o.get(a)) !== void 0)
        return r(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : r(a, s);
    }
  };
}
var Wae = "!";
function POe(e) {
  var t = e.separator || ":", n = t.length === 1, o = t[0], r = t.length;
  return function(a) {
    for (var s = [], c = 0, l = 0, d, u = 0; u < a.length; u++) {
      var _ = a[u];
      if (c === 0) {
        if (_ === o && (n || a.slice(u, u + r) === t)) {
          s.push(a.slice(l, u)), l = u + r;
          continue;
        }
        if (_ === "/") {
          d = u;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    var p = s.length === 0 ? a : a.substring(l), f = p.startsWith(Wae), g = f ? p.substring(1) : p, h = d && d > l ? d - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: f,
      baseClassName: g,
      maybePostfixModifierPosition: h
    };
  };
}
function IOe(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(o) {
    var r = o[0] === "[";
    r ? (t.push.apply(t, n.sort().concat([o])), n = []) : n.push(o);
  }), t.push.apply(t, n.sort()), t;
}
function ROe(e) {
  return {
    cache: OOe(e.cacheSize),
    splitModifiers: POe(e),
    ...EOe(e)
  };
}
var NOe = /\s+/;
function DOe(e, t) {
  var n = t.splitModifiers, o = t.getClassGroupId, r = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(NOe).map(function(a) {
    var s = n(a), c = s.modifiers, l = s.hasImportantModifier, d = s.baseClassName, u = s.maybePostfixModifierPosition, _ = o(u ? d.substring(0, u) : d), p = !!u;
    if (!_) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (_ = o(d), !_)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var f = IOe(c).join(":"), g = l ? f + Wae : f;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: _,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, c = a.classGroupId, l = a.hasPostfixModifier, d = s + c;
    return i.has(d) ? !1 : (i.add(d), r(c, l).forEach(function(u) {
      return i.add(s + u);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function MOe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var o, r, i, a = s;
  function s(l) {
    var d = t[0], u = t.slice(1), _ = u.reduce(function(p, f) {
      return f(p);
    }, d());
    return o = ROe(_), r = o.cache.get, i = o.cache.set, a = c, c(l);
  }
  function c(l) {
    var d = r(l);
    if (d)
      return d;
    var u = DOe(l, o);
    return i(l, u), u;
  }
  return function() {
    return a(xOe.apply(null, arguments));
  };
}
function Ur(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Gae = /^\[(?:([a-z-]+):)?(.+)\]$/i, LOe = /^\d+\/\d+$/, qOe = /* @__PURE__ */ new Set(["px", "full", "screen"]), jOe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, FOe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, VOe = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Ml(e) {
  return rf(e) || qOe.has(e) || LOe.test(e) || dp(e);
}
function dp(e) {
  return ag(e, "length", KOe);
}
function BOe(e) {
  return ag(e, "size", Hae);
}
function UOe(e) {
  return ag(e, "position", Hae);
}
function WOe(e) {
  return ag(e, "url", YOe);
}
function H1(e) {
  return ag(e, "number", rf);
}
function rf(e) {
  return !Number.isNaN(Number(e));
}
function GOe(e) {
  return e.endsWith("%") && rf(e.slice(0, -1));
}
function wy(e) {
  return $U(e) || ag(e, "number", $U);
}
function wi(e) {
  return Gae.test(e);
}
function ky() {
  return !0;
}
function rp(e) {
  return jOe.test(e);
}
function HOe(e) {
  return ag(e, "", ZOe);
}
function ag(e, t, n) {
  var o = Gae.exec(e);
  return o ? o[1] ? o[1] === t : n(o[2]) : !1;
}
function KOe(e) {
  return FOe.test(e);
}
function Hae() {
  return !1;
}
function YOe(e) {
  return e.startsWith("url(");
}
function $U(e) {
  return Number.isInteger(Number(e));
}
function ZOe(e) {
  return VOe.test(e);
}
function QOe() {
  var e = Ur("colors"), t = Ur("spacing"), n = Ur("blur"), o = Ur("brightness"), r = Ur("borderColor"), i = Ur("borderRadius"), a = Ur("borderSpacing"), s = Ur("borderWidth"), c = Ur("contrast"), l = Ur("grayscale"), d = Ur("hueRotate"), u = Ur("invert"), _ = Ur("gap"), p = Ur("gradientColorStops"), f = Ur("gradientColorStopPositions"), g = Ur("inset"), h = Ur("margin"), b = Ur("opacity"), v = Ur("padding"), $ = Ur("saturate"), k = Ur("scale"), S = Ur("sepia"), O = Ur("skew"), I = Ur("space"), D = Ur("translate"), M = function() {
    return ["auto", "contain", "none"];
  }, N = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, C = function() {
    return ["auto", t];
  }, P = function() {
    return ["", Ml];
  }, x = function() {
    return ["auto", rf, wi];
  }, w = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, E = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, T = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, z = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, j = function() {
    return ["", "0", wi];
  }, q = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, V = function() {
    return [rf, H1];
  }, F = function() {
    return [rf, wi];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [ky],
      spacing: [Ml],
      blur: ["none", "", rp, dp],
      brightness: V(),
      borderColor: [e],
      borderRadius: ["none", "", "full", rp, dp],
      borderSpacing: [t],
      borderWidth: P(),
      contrast: V(),
      grayscale: j(),
      hueRotate: F(),
      invert: j(),
      gap: [t],
      gradientColorStops: [e],
      gradientColorStopPositions: [GOe, dp],
      inset: C(),
      margin: C(),
      opacity: V(),
      padding: [t],
      saturate: V(),
      scale: V(),
      sepia: j(),
      skew: F(),
      space: [t],
      translate: [t]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", wi]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [rp]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": q()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": q()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(w(), [wi])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: N()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": N()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": N()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", wy]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: C()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", wi]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", wy]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ky]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [wy]
        }, wi]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": x()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": x()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ky]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [wy]
        }, wi]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": x()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": x()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", wi]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", wi]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [_]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [_]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [_]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(z())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(z(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(z(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Ml]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [rp]
        }, rp, dp]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Ml]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", rp, dp]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", H1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ky]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", dp]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rf, H1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ml]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", wi]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", wi]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(E(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ml]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ml]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [t]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", dp]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", wi]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(w(), [UOe])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", BOe]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, WOe]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [f]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(E(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: E()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(E())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ml]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ml]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: P()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ml]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", rp, HOe]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ky]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": T()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": T()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", rp, wi]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [$]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [$]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", wi]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: F()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", wi]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: F()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", wi]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [k]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [k]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [k]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [wy, wi]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [D]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [D]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", wi]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", wi]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [t]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [t]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [t]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [t]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [t]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [t]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [t]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [t]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [t]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [t]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [t]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [t]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [t]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [t]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [t]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [t]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [t]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [t]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", wi]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ml, H1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Kae = /* @__PURE__ */ MOe(QOe);
function ae(...e) {
  return Kae(e.filter(Boolean).join(" "));
}
function ot({
  name: e,
  size: t = 16,
  className: n,
  ...o
}) {
  return /* @__PURE__ */ m(
    "svg",
    {
      height: t,
      width: t,
      className: ae("fill-transparent", n),
      ...o,
      "aria-hidden": !0,
      children: /* @__PURE__ */ m("use", { href: `#${e}` })
    }
  );
}
var JOe = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [o, r] = n.split(/ ?: ?/).map((i, a) => a === 0 ? i.replace(/\s+/g, "") : i.trim());
  if (o && r) {
    const i = o.replace(/(\w)-(\w)/g, (s, c, l) => `${c}${l.toUpperCase()}`);
    let a = r.trim();
    Number.isNaN(Number(r)) || (a = Number(r)), t[o.startsWith("-") ? o : i] = a;
  }
  return t;
}, {});
function XOe(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let o = e; o > 0; --o)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var e4e = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], wU = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function t4e(e, t) {
  var i;
  const { key: n, level: o, ...r } = t;
  switch (e.nodeType) {
    case 1:
      return $e.createElement(
        o4e(e.nodeName),
        n4e(e, n),
        kU(e.childNodes, o, r)
      );
    case 3: {
      const a = ((i = e.nodeValue) == null ? void 0 : i.toString()) ?? "";
      if (!r.allowWhiteSpaces && /^\s+$/.test(a) && !/[\u00A0\u202F]/.test(a))
        return null;
      if (!e.parentNode)
        return a;
      const s = e.parentNode.nodeName.toLowerCase();
      return e4e.includes(s) ? (/\S/.test(a) && console.warn(
        `A textNode is not allowed inside '${s}'. Your text "${a}" will be ignored`
      ), null) : a;
    }
    case 8:
      return null;
    case 11:
      return kU(e.childNodes, o, t);
    default:
      return null;
  }
}
function n4e(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const o = e.getAttribute("class");
    o && (n.className = o), [...e.attributes].forEach((r) => {
      switch (r.name) {
        case "class":
          break;
        case "style":
          n[r.name] = JOe(r.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[wU[r.name] || r.name] = !0;
          break;
        default:
          n[wU[r.name] || r.name] = r.value;
      }
    });
  }
  return n;
}
function kU(e, t, n) {
  const o = [...e].map(
    (r, i) => Ex(r, {
      ...n,
      index: i,
      level: t + 1
    })
  ).filter(Boolean);
  return o.length ? o : null;
}
function o4e(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function Ex(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: o = 0, level: r = 0, randomKey: i } = t;
  let a = e, s = `${r}-${o}`;
  const c = [];
  return i && r === 0 && (s = `${XOe()}-${s}`), Array.isArray(n) && n.forEach((l) => {
    l.condition(a, s, r) && (typeof l.pre == "function" && (a = l.pre(a, s, r), a instanceof Node || (a = e)), typeof l.post == "function" && c.push(l.post(a, s, r)));
  }), c.length ? c : t4e(a, { key: s, level: r, ...t });
}
function r4e(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: o = !1,
    selector: r = "body > *",
    type: i = "text/html"
  } = t;
  try {
    const s = new DOMParser().parseFromString(e, i);
    if (n) {
      const { childNodes: l } = s.body;
      return o ? l : [...l].map((d) => Ex(d, t));
    }
    const c = s.querySelector(r) || s.body.childNodes[0];
    if (!(c instanceof Node))
      throw new TypeError("Error parsing input");
    return o ? c : Ex(c, t);
  } catch {
  }
  return null;
}
function Yae(e, t = {}) {
  return typeof e == "string" ? r4e(e, t) : e instanceof Node ? Ex(e, t) : null;
}
var i4e = Object.defineProperty, a4e = (e, t, n) => t in e ? i4e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, K1 = (e, t, n) => (a4e(e, typeof t != "symbol" ? t + "" : t, n), n), SU = "react-inlinesvg", xU = 10, vr = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function wS() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function s4e() {
  return l4e() && typeof window < "u" && window !== null;
}
async function Zae(e, t) {
  const n = await fetch(e, t), o = n.headers.get("content-type"), [r] = (o ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((i) => r.includes(i)))
    throw new Error(`Content type isn't valid: ${r}`);
  return n.text();
}
function c4e(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function l4e() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function d4e(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function u4e(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = "1234567890", o = `${t}${t.toUpperCase()}${n}`;
  let r = "";
  for (let i = 0; i < e; i++)
    r += d4e(o);
  return r;
}
function _4e(e, ...t) {
  const n = {};
  for (const o in e)
    ({}).hasOwnProperty.call(e, o) && (t.includes(o) || (n[o] = e[o]));
  return n;
}
var p4e = class {
  constructor() {
    K1(this, "cacheApi"), K1(this, "cacheStore"), K1(this, "subscribers", []), K1(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = SU, t = !1;
    wS() && (e = window.REACT_INLINESVG_CACHE_NAME ?? SU, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n, this.isReady = !0, this.subscribers.forEach((o) => o());
    }).catch((n) => {
      this.isReady = !0, console.error(`Failed to open cache: ${n.message}`);
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === vr.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === vr.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: vr.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: vr.LOADING });
      try {
        const o = await Zae(e, t);
        this.cacheStore.set(e, { content: o, status: vr.LOADED });
      } catch (o) {
        throw this.cacheStore.set(e, { content: "", status: vr.FAILED }), o;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var r, i, a;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === vr.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === vr.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: vr.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: vr.LOADING });
    const o = await ((r = this.cacheApi) == null ? void 0 : r.match(e));
    if (o) {
      const s = await o.text();
      this.cacheStore.set(e, { content: s, status: vr.LOADED });
      return;
    }
    try {
      await ((i = this.cacheApi) == null ? void 0 : i.add(new Request(e, t)));
      const s = await ((a = this.cacheApi) == null ? void 0 : a.match(e)), c = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: c, status: vr.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: vr.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var o;
    let n = 0;
    for (; ((o = this.cacheStore.get(e)) == null ? void 0 : o.status) === vr.LOADING && n < xU; )
      await c4e(0.1), n += 1;
    n >= xU && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function EU(e) {
  const t = Ue();
  return Le(() => {
    t.current = e;
  }), t.current;
}
function m4e(e) {
  const {
    baseURL: t,
    content: n,
    description: o,
    handleError: r,
    hash: i,
    preProcessor: a,
    title: s,
    uniquifyIDs: c = !1
  } = e;
  try {
    const l = f4e(n, a), d = Yae(l, { nodeOnly: !0 });
    if (!d || !(d instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const u = Qae(d, { baseURL: t, hash: i, uniquifyIDs: c });
    if (o) {
      const _ = u.querySelector("desc");
      _ != null && _.parentNode && _.parentNode.removeChild(_);
      const p = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      p.innerHTML = o, u.prepend(p);
    }
    if (typeof s < "u") {
      const _ = u.querySelector("title");
      if (_ != null && _.parentNode && _.parentNode.removeChild(_), s) {
        const p = document.createElementNS("http://www.w3.org/2000/svg", "title");
        p.innerHTML = s, u.prepend(p);
      }
    }
    return u;
  } catch (l) {
    return r(l);
  }
}
function f4e(e, t) {
  return t ? t(e) : e;
}
function Qae(e, t) {
  const { baseURL: n = "", hash: o, uniquifyIDs: r } = t, i = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], a = ["href", "xlink:href"], s = (c, l) => a.includes(c) && (l ? !l.includes("#") : !1);
  return r && [...e.children].forEach((c) => {
    var l;
    if ((l = c.attributes) != null && l.length) {
      const d = Object.values(c.attributes).map((u) => {
        const _ = u, p = /url\((.*?)\)/.exec(u.value);
        return p != null && p[1] && (_.value = u.value.replace(p[0], `url(${n}${p[1]}__${o})`)), _;
      });
      i.forEach((u) => {
        const _ = d.find((p) => p.name === u);
        _ && !s(u, _.value) && (_.value = `${_.value}__${o}`);
      });
    }
    return c.children.length ? Qae(c, t) : c;
  }), e;
}
var bh;
function g4e(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: o,
    fetchOptions: r,
    innerRef: i,
    loader: a = null,
    onError: s,
    onLoad: c,
    src: l,
    title: d,
    uniqueHash: u
  } = e, [_, p] = R0(
    (w, E) => ({
      ...w,
      ...E
    }),
    {
      content: "",
      element: null,
      isCached: t && bh.isCached(e.src),
      status: vr.IDLE
    }
  ), { content: f, element: g, isCached: h, status: b } = _, v = EU(e), $ = EU(_), k = Ue(u ?? u4e(8)), S = Ue(!1), O = Ue(!1), I = at(
    (w) => {
      S.current && (p({
        status: w.message === "Browser does not support SVG" ? vr.UNSUPPORTED : vr.FAILED
      }), s == null || s(w));
    },
    [s]
  ), D = at((w, E = !1) => {
    S.current && p({
      content: w,
      isCached: E,
      status: vr.LOADED
    });
  }, []), M = at(async () => {
    const w = await Zae(l, r);
    D(w);
  }, [r, D, l]), N = at(() => {
    try {
      const w = m4e({ ...e, handleError: I, hash: k.current, content: f }), E = Yae(w);
      if (!E || !bl(E))
        throw new Error("Could not convert the src to a React element");
      p({
        element: E,
        status: vr.READY
      });
    } catch (w) {
      I(new Error(w.message));
    }
  }, [f, I, e]), C = at(async () => {
    const w = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(l);
    let E;
    if (w ? E = w[1] ? window.atob(w[2]) : decodeURIComponent(w[2]) : l.includes("<svg") && (E = l), E) {
      D(E);
      return;
    }
    try {
      if (t) {
        const T = await bh.get(l, r);
        D(T, !0);
      } else
        await M();
    } catch (T) {
      I(T);
    }
  }, [t, M, r, I, D, l]), P = at(async () => {
    S.current && p({
      content: "",
      element: null,
      isCached: !1,
      status: vr.LOADING
    });
  }, []);
  Le(
    () => {
      if (S.current = !0, !wS() || O.current)
        return () => {
        };
      try {
        if (b === vr.IDLE) {
          if (!s4e())
            throw new Error("Browser does not support SVG");
          if (!l)
            throw new Error("Missing src");
          P();
        }
      } catch (w) {
        I(w);
      }
      return O.current = !0, () => {
        S.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), Le(() => {
    if (wS() && v)
      if (v.src !== l) {
        if (!l) {
          I(new Error("Missing src"));
          return;
        }
        P();
      } else
        (v.title !== d || v.description !== o) && N();
  }, [o, N, I, P, v, l, d]), Le(() => {
    $ && ($.status !== vr.LOADING && b === vr.LOADING && C(), $.status !== vr.LOADED && b === vr.LOADED && N(), $.status !== vr.READY && b === vr.READY && (c == null || c(l, h)));
  }, [C, N, h, c, $, l, b]);
  const x = _4e(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return wS() ? g ? w_(g, { ref: i, ...x }) : [vr.UNSUPPORTED, vr.FAILED].includes(b) ? n : a : a;
}
function h4e(e) {
  bh || (bh = new p4e());
  const { loader: t } = e, n = Ue(!1), [o, r] = ze(bh.isReady);
  return Le(() => {
    n.current || (bh.onReady(() => {
      r(!0);
    }), n.current = !0);
  }, []), o ? /* @__PURE__ */ m(g4e, { ...e }) : t;
}
const v4e = "";
function TU() {
  return /* @__PURE__ */ m(
    h4e,
    {
      src: `https://app.cal.com/icons/sprite.svg?v=-${v4e}`
    }
  );
}
const b4e = it(function(t) {
  return /* @__PURE__ */ Y(
    "svg",
    {
      className: t.className,
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ m(
          "path",
          {
            className: "fill-default",
            d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
            opacity: ".25"
          }
        ),
        /* @__PURE__ */ m(
          "path",
          {
            className: "animate-spinning fill-emphasis origin-center",
            d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
          }
        )
      ]
    }
  );
}), y4e = it(function(t, n) {
  return /* @__PURE__ */ Y(
    "svg",
    {
      ref: n,
      className: t.className,
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 360 360",
      children: [
        /* @__PURE__ */ m("title", { children: "Satoshis" }),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "201.48",
            y: "37.16",
            width: "23.49",
            height: "40.14",
            transform: "translate(21.82 -52.79) rotate(14.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "135.03",
            y: "287.5",
            width: "23.49",
            height: "40.14",
            transform: "translate(83.82 -27.36) rotate(14.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "184.27",
            y: "38.29",
            width: "23.49",
            height: "167.49",
            transform: "translate(364.26 -36.11) rotate(104.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "168.36",
            y: "98.26",
            width: "23.49",
            height: "167.49",
            transform: "translate(402.22 54.61) rotate(104.87)"
          }
        ),
        /* @__PURE__ */ m(
          "rect",
          {
            fill: "currentColor",
            x: "152.89",
            y: "156.52",
            width: "23.49",
            height: "167.49",
            transform: "translate(439.1 142.78) rotate(104.87)"
          }
        )
      ]
    }
  );
}), $4e = "Identitätsanbieter", w4e = 'Sie haben noch $t(Tage, {"count": {{days}} }) im Testzeitraum der PRO-Version', k4e = "{{count}} Tag", S4e = "{{count}} Tage", x4e = "{{count}} Sekunde", E4e = "{{count}} Sekunden", T4e = "Jetzt upgraden", A4e = "Ohne Titel", C4e = "Einladung annehmen", z4e = "Max. Zeichen", O4e = "Min. Zeichen", P4e = "{{appName}} stellt die Planungsinfrastruktur für absolut jeden bereit.", I4e = "Schließen Sie die Einrichtung Ihres {{appName}}-Kontos ab! Sie sind nur noch wenige Schritte davon entfernt, all Ihre Terminplanungsprobleme zu lösen.", R4e = "Haben Sie Fragen? Wir sind hier um Ihnen zu helfen.", N4e = "{{appName}}: Anleitung zum Zurücksetzen des Passworts", D4e = "{{appName}}: Bestätigen Sie Ihr Konto", M4e = "{{appName}}: Bestätigen Sie Ihre E-Mail-Adresse", L4e = "Schauen Sie in Ihrem E-Mail-Postfach nach", q4e = "Alte E-Mail-Adresse", j4e = "Neue E-Mail-Adresse", F4e = "Wir haben eine E-Mail an {{email}} gesendet. Es ist wichtig, Ihre E-Mail-Adresse zu bestätigen, um die Zustellbarkeit für E-Mails und Kalenderbenachrichtigungen von {{appName}} zu gewährleisten.", V4e = "Bestätigen Sie Ihre E-Mail-Adresse, um die Zustellbarkeit von E-Mails und Kalenderbenachrichtigungen zu gewährleisten", B4e = "Bestätigen Sie Ihre E-Mail-Adresse", U4e = "E-Mail bestätigen", W4e = "Assistent", G4e = "Cal Video-Transkriptions-E-Mails senden", H4e = "E-Mails mit der Transkription des Cal Videos nach Beendigung des Meetings versenden. (Erfordert einen kostenpflichtigen Plan)", K4e = "Sie haben vor kurzem angefordert, die E-Mail-Adresse zu ändern, die Sie verwenden, um sich bei Ihrem {{appName}} Konto anzumelden. Bitte klicken Sie auf die Schaltfläche unten, um Ihre neue E-Mail-Adresse zu bestätigen.", Y4e = "Ihre E-Mail wurde auf {{email}} aktualisiert", Z4e = "Fehler beim Aktualisieren der E-Mail.", Q4e = "Bestätigen Sie Ihre neue {{appName}} E-Mail-Adresse", J4e = "Wir haben einen Bestätigungslink an {{email}} gesendet. Wir werden Ihre E-Mail-Adresse aktualisieren, sobald Sie auf diesen Link klicken.", X4e = "Speichern Sie diesen API-Schlüssel an einem sicheren Ort. Sie können ihn nicht erneut ansehen.", e3e = "Bitte bestätigen Sie Ihre E-Mail-Adresse, indem Sie unten auf die Schaltfläche klicken.", t3e = "Bitte bestätigen Sie Ihre E-Mail-Adresse mit dem unten stehenden Code.", n3e = "Hier ist der Link, falls Sie lieber keine Schaltflächen anklicken möchten:", o3e = "Geben Sie den Bestätigungscode ein", r3e = "Geben Sie den Bestätigungscode ein, den Sie per E-Mail erhalten haben", i3e = "Der Bestätigungscode ist falsch.", a3e = "E-Mail erfolgreich gesendet", s3e = "Fehler beim Senden der E-Mail aufgetreten", c3e = "Abgelehnt: {{title}} am {{date}}", l3e = "Abgesagt: {{title}} am {{date}}", d3e = "Neu zugewiesen: {{title}} am {{date}}", u3e = "Ihre Event-Anfrage wurde abgelehnt", _3e = "Cal Video-Einstellungen anpassen", p3e = "Konfigurieren Sie Videokonferenz-Präferenzen einschließlich Aufnahmeberechtigungen für Gastgeber und Teilnehmer.", m3e = "Aufnahme für Gäste deaktivieren", f3e = "Automatische Transkription nach Beitritt zum Meeting aktivieren", g3e = "Automatische Aufnahme aktivieren, nachdem der Organisator dem Meeting beigetreten ist", h3e = "Videooptionen", v3e = "Termin bearbeiten", b3e = "Sitzungsdetails anzeigen", y3e = "Meeting-Sitzungsdetails", $3e = "Meeting-Sitzung", w3e = "Sitzungs-ID", k3e = "Maximale Teilnehmerzahl", S3e = "Unbegrenzt", x3e = "Laufend", E3e = "Beendet", T3e = "Teilnehmer", A3e = "Anonymer Benutzer", C3e = "Sitzungsdauer", z3e = "Keine Meeting-Sitzungen gefunden", O3e = "Nicht verfügbar", P3e = "Aufnahme für Organisator deaktivieren", I3e = "Transkription für Gäste deaktivieren", R3e = "Transkription für Organisator deaktivieren", N3e = "Ihre wiederkehrende Terminanfrage wurde abgelehnt", D3e = "Ihr geplanter Termin wurde abgesagt", M3e = "Ihr geplanter Termin wurde neu zugewiesen", L3e = "Der Termin wird nicht mehr in Ihrem Kalender erscheinen und Ihre Round-Robin-Wahrscheinlichkeit wird nicht negativ beeinflusst", q3e = "Organisator", j3e = "Neu zugewiesen an", F3e = "Möchten Sie einen neuen Termin finden oder absagen?", V3e = "Sie können die Buchungsdetails unter dieser URL einsehen {{url}} und den Termin zu Ihrem Kalender hinzufügen", B3e = "Keine Optionen verfügbar", U3e = "Grund für Ihre Absage (optional)", W3e = "Abgesagt von", G3e = "Grund für die Absage", H3e = "Warum sagen Sie ab?", K3e = "Der Stornierungsgrund wird mit den Gästen geteilt", Y3e = "Warum lehnen Sie ab?", Z3e = "Grund für die Ablehnung", Q3e = "Die Buchungsanfrage ablehnen?", J3e = "Sind Sie sicher, dass Sie die Buchung ablehnen möchten? Wir werden die Person, die versucht hat zu buchen, informieren. Sie können einen Grund angeben.", X3e = "Buchung ablehnen", e6e = "Diesen Termin verwalten", t6e = "Teammitglied einladen", n6e = "Person einladen", o6e = "Massenimport", r6e = "Eing.", i6e = "Ihr Termin wurde gebucht", a6e = "Ihr wiederkehrender Termin wurde gebucht", s6e = "Akzeptieren Sie unsere Lizenz, indem Sie die .env-Variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> auf '{{agree}} ' ändern.", c6e = "Um diesen Banner zu entfernen, öffnen Sie bitte Ihre .env-Datei und ändern Sie die <1>NEXT_PUBLIC_LICENSE_CONSENT</1> Variable auf '{{agree}}'.", l6e = "Die Fehlermeldung war: '{{errorMessage}}'", d6e = "Rückerstattung fehlgeschlagen: {{userName}} - {{date}} - {{eventType}}", u6e = "Die Rückerstattung für den Termin {{eventType}} mit {{userName}} am {{date}} ist fehlgeschlagen.", _6e = "Bitte überprüfen Sie bei Ihrem Zahlungsanbieter und {{userName}}, wie Sie damit umgehen.", p6e = "Erstattung fehlgeschlagen", m6e = "Warte auf Zahlung: {{title}} am {{date}}", f6e = "Zahlung für den Termin noch offen", g6e = "Die Farbe des dunklen Designs hat die Kontrastprüfung nicht bestanden. Wir empfehlen Ihnen, diese Farbe zu ändern, damit Ihre Schaltflächen sichtbarer sind.", h6e = "Die Farbe des hellen Designs hat die Kontrastprüfung nicht bestanden. Wir empfehlen Ihnen, diese Farbe zu ändern, damit Ihre Schaltflächen sichtbarer sind.", v6e = "Die Farbe für das helle Design besteht den Kontrasttest nicht. Wir empfehlen, diese Farbe zu ändern, damit Ihre Ereignistypen besser sichtbar sind.", b6e = "Die Farbe für das dunkle Design besteht den Kontrasttest nicht. Wir empfehlen, diese Farbe zu ändern, damit Ihre Ereignistypen besser sichtbar sind.", y6e = "Zahlung konnte nicht erstellt werden", $6e = "Karte konnte nicht für die Zahlung belastet werden", w6e = "Keine verfügbaren Benutzer gefunden. Können Sie es mit einem anderen Zeitfenster versuchen?", k6e = "Der ausgewählte Zeitraum ist nicht mehr verfügbar. <0>Bitte wähle eine neue Zeit</0>", S6e = "Belegt", x6e = "Sie haben gerade eine Verbindung hergestellt. Bitte buchen Sie aus den obigen Zeitfenstern oder versuchen Sie es später erneut.", E6e = "Nicht verfügbarer Zeitslot", T6e = "Der Termin kann zu diesem Zeitpunkt nicht gebucht werden. Möchten Sie einen anderen Zeitslot versuchen?", A6e = "Interner Fehler. Request-Body enthält keinen Endzeitpunkt", C6e = "Kalenderereignis konnte nicht im Kalender des Organisators erstellt werden", z6e = "Kalenderereignis konnte nicht aktualisiert werden.", O6e = "Kalenderereignis konnte nicht gelöscht werden.", P6e = "Sie sind bereits für diese Buchung registriert.", I6e = "Einige der Veranstalter sind nicht für die Buchung verfügbar.", R6e = "Einige der festen Gastgeber sind für Buchungen nicht verfügbar.", N6e = "Round-Robin-Host ist für Buchungen nicht verfügbar.", D6e = "Hilfe", M6e = "Preis", L6e = "Bezahlt", q6e = "Erstattet", j6e = "Aufnehmen", F6e = "Transkribieren", V6e = "Bezahlung", B6e = "Fehlender Eintrag für Karteninformationen", U6e = "Jetzt bezahlen", W6e = "Allgemeine Aufforderung", G6e = "Transkription unterstützt durch KI", H6e = "Aufnahme starten oder stoppen", K6e = "Nachricht starten", Y6e = "Die Codebasis muss Open Source bleiben, unabhängig davon, ob sie geändert wurde oder nicht", Z6e = "Sie dürfen die Codebasis nicht weiter verkaufen", Q6e = "Erwerben Sie eine kommerzielle Lizenz per Email, um diese Bedingungen zu entfernen", J6e = "Zusammenfassung der Bedingungen", X6e = ".env öffnen und unserer Lizenz zustimmen", e5e = "Ich habe mein .env geändert", t5e = "Lizenz akzeptieren", n5e = "Ein Termin wartet noch auf Bestätigung", o5e = "Termin-Anfrage wartet: {{attendeeName}} - {{date}} - {{eventType}}", r5e = 'Keine Ergebnisse gefunden für "{{searchTerm}}"', i5e = "Keine weiteren Ergebnisse", a5e = "Keine Ergebnisse", s5e = "Weitere Ergebnisse laden", c5e = "{{integrationName}} Termin-ID: {{meetingId}}", l5e = "Bestätigt: {{eventType}} mit {{name}} am {{date}}", d5e = "Neue Termin-Anfrage: {{attendeeName}} - {{date}} - {{eventType}}", u5e = "Anfrage bestätigen oder ablehnen", _5e = "Überprüfen Sie Ihre Buchungsseite, um die Buchung zu bestätigen oder abzulehnen.", p5e = "Check-in-Assistent", m5e = "Führt einen ausgehenden Anruf durch, um zu prüfen, ob der geplante Termin funktioniert oder ob Sie ihn verschieben möchten.", f5e = "Erstellen Sie Ihre eigene Aufforderung und verwenden Sie sie für einen ausgehenden Anruf.", g5e = "Ein neuer Termin wartet auf Ihre Bestätigung", h5e = "Ein wiederkehrender Termin wartet auf Ihre Bestätigung", v5e = "Jemand hat eine Terminanfrage gestellt.", b5e = "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern.", y5e = "Wenn diese E-Mail-Adresse in unserem System existiert, sollten Sie eine Zurücksetzungs-E-Mail erhalten.", $5e = "Wenn Sie dies nicht angefordert haben, können Sie diese E-Mail sicher ignorieren und Ihr Passwort wird nicht geändert.", w5e = "Warte auf Bestätigung: {{title}} um {{date}}", k5e = "Ein Termin wartet noch auf Ihre Bestätigung", S5e = "Termin eingereicht: {{title}} am {{date}}", x5e = "Aufnahme herunterladen: {{title}} am {{date}}", E5e = "Transkript herunterladen: {{title}} am {{date}}", T5e = "Ihre Aufnahme herunterladen", A5e = "Ihre Transkripte herunterladen", C5e = "Ihr Termin wurde gebucht", z5e = "Ihr {{title}} wurde auf den {{date}} verschoben.", O5e = "Dein {{title}} wurde aktualisiert.", P5e = "Ihr Termin wurde verschoben.", I5e = "Termin wurde aktualisiert", R5e = "Ihr Termin wurde umgeplant", N5e = "{{organizer}} hat den Termin abgesagt und Sie gebeten, eine andere Zeit auszuwählen.", D5e = "Sie haben {{attendee}} zur Neuplanung aufgefordert", M5e = "Sie haben die Buchung storniert und {{attendee}} muss eine neue Buchungszeit mit Ihnen vereinbaren.", L5e = "Anfrage für Neuplanung gesendet: {{eventType}} mit {{name}} am {{date}}", q5e = "Aktion erforderlich - Neuplanung: Bitte buchen Sie eine neue Zeit für „{{eventType}}“ mit {{name}}", j5e = "Hallo, {{name}}", F5e = "{{eventType}} mit {{name}}", V5e = "Es scheint, dass alle unsere Experten momentan beschäftigt sind. Bitte vereinbaren Sie einen Termin zu einem Zeitpunkt, der Ihnen am besten passt, und wir werden bereit sein, Ihnen zu helfen.", B5e = "Stattdessen planen", U5e = "Neuer Termin: {{attendeeName}} - {{date}} - {{eventType}}", W5e = "{{entryPoint}} beitreten", G5e = "Notizen", H5e = "Meine Termine verwalten", K5e = "Sie müssen eine Änderung vornehmen?", Y5e = "Ein neuer Termin wurde geplant.", Z5e = "Ein neuer wiederkehrender Termin wurde geplant.", Q5e = "Teilnehmer-Email", J5e = "Zeitzone der Teilnehmenden", X5e = "Verbleibende Zeit", ePe = "Termintyp", tPe = "Doppelter Ereignistyp", nPe = "Termin beitreten", oPe = "Videoanbieter", rPe = "Termin-ID", iPe = "Termin-Passwort", aPe = "Termin-URL", sPe = "Meeting-URL nicht gefunden", cPe = "Token nicht gefunden", lPe = "Ein anderer Gastgeber hat das Meeting bereits angenommen. Möchtest du trotzdem teilnehmen? <0>Weiter zum Meeting</0>", dPe = "Ihre Terminanfrage wurde abgelehnt", uPe = "Abgelehnt: {{eventType}} mit {{organizer}} auf {{date}}", _Pe = "Hi", pPe = "Team beitreten", mPe = "Dieses Team verwalten", fPe = "Informationen zum Team", gPe = "Meeting beitreten", hPe = "Falls Sie {{toEmail}} lieber nicht als Ihre {{appName}}-E-Mail verwenden möchten oder bereits über ein {{appName}}-Konto verfügen, fordern Sie bitte eine weitere Einladung zu dieser E-Mail an.", vPe = "Sie wurden eingeladen, dem Team {{teamName}} beizutreten", bPe = "{{user}} hat Sie eingeladen, dem {{entity}} {{team}} auf {{appName}} beizutreten", yPe = "Sie sind in diesem Team ausgeblendet", $Pe = "Ihre Teammitgliedschaft ist nicht bezahlt, entweder upgraden Sie Ihren Account auf Pro oder lassen den Team-Organisator wissen, dass er für Ihren Platz im Team bezahlen kann.", wPe = "Sie benötigen einen Pro-Account um die Teamfunktionen zu verweden. Sie werden dem Team nicht angezeigt, bis der Account upgegradet wurde.", kPe = "p.s. Es läuft in {{expiresIn}} Stunden ab.", SPe = "Upgrade auf Pro-Mitglied lizensierung", xPe = "Sitzplatzoption unterstützt keine Bestätigungsanforderung", EPe = "Mehrere Standorte unterstützt die Sitzplätze-Option nicht", TPe = "Gebühr für das Nichterscheinen unterstützt die Sitzplätze-Option nicht", APe = "Sitzplätze-Option unterstützt mehrere Standorte nicht", CPe = "Von den {{memberCount}} Mitgliedern in Ihrem Team sind {{unpaidCount}} Sitze(n) unbezahlt. Bei ${{seatPrice}}/m pro Sitzplatz betragen die geschätzten Gesamtkosten Ihrer Mitgliedschaft ${{totalCost}}/m.", zPe = "Vielen Dank, dass Sie unseren neuen Teamplan getestet haben. Wir haben festgestellt, dass Ihr Team „{{teamName}}“ aktualisiert werden muss.", OPe = "Hier aufrüsten", PPe = "Das Update für Ihr Team war erfolgreich!", IPe = "Vielen Dank, dass Sie unseren neuen Tarif „Organization“ getestet haben. Wir haben festgestellt, dass Ihre Organization „{{teamName}}“ ein Upgrade benötigt.", RPe = "Das Upgrade für Ihre Organization war erfolgreich!", NPe = "Benutzen Sie den Link, um Ihr Passwort zurückzusetzen", DPe = "Hallo", MPe = "dort", LPe = "Passwort vergessen? - {{appName}}", qPe = "Sind Sie sicher, dass Sie diesen Webhook löschen möchten? Sie werden keine {{appName}}-Meetingdaten mehr unter einer bestimmten URL, in Echtzeit erhalten, wenn ein Ereignis geplant oder abgesagt wird.", jPe = "Ja, Webhook löschen", FPe = "Webhook bearbeiten", VPe = "Webhook löschen", BPe = "Webhook-Status", UPe = "Webhook aktiviert", WPe = "Webhook deaktiviert", GPe = "Webhook-Antwort", HPe = "Webhook-Test", KPe = "Webhook-Aktualisierungsformular", YPe = "Fügen Sie Ihrem OAuth-Client einen Webhook hinzu.", ZPe = "Webhook verwalten", QPe = "Webhook erfolgreich erstellt!", JPe = "Webhook erfolgreich aktualisiert!", XPe = "Webhook erfolgreich entfernt!", eIe = "Abonnement erforderlich", tIe = "Sie haben kein Platform-Abonnement.", nIe = "Payload Vorlage", oIe = "Ignorieren", rIe = "Noch keine Daten", iIe = "Pingtest", aIe = "Fügen Sie diese App Ihrem Startbildschirm für schnelleren Zugriff hinzu.", sIe = "Bevorstehende", cIe = "Wiederkehrende", lIe = "Vergangene", dIe = "Datei auswählen...", uIe = "Bild hochladen", _Ie = "{{target}} hochladen", pIe = "Kein {{target}}", mIe = "Regler schieben zum zoomen, gedrückt halten zum bewegen", fIe = "Benachrichtigungen anzeigen", gIe = "Öffentliche Seite anzeigen", hIe = "Link zur öffentlichen Seite kopieren", vIe = "Empfehlungslink kopieren", bIe = "Abmelden", yIe = "Weitere hinzufügen", $Ie = "Weitere installieren", wIe = "bis", kIe = "betrieben von", SIe = "Nicht verfügbar", xIe = "Arbeitszeiten festlegen", EIe = "Verfügbarkeit für Buchungen ändern", TIe = "Auswählen...", AIe = "Text", CIe = "Ihre Telefonnummer", zIe = "Mehrzeiliger Text", OIe = "Nummer", PIe = "Checkbox", IIe = "Erforderlich", RIe = "Dieses Feld als erforderlich markieren", NIe = "Erforderlich", DIe = "Optional", MIe = "Eingabetyp", LIe = "Abgelehnt", qIe = "Unbestätigt", jIe = "Gäste", FIe = "Gast", VIe = "Web-Konferenzdetails folgen.", BIe = "Bestätigung", UIe = "Was Ihr Bucher angeben sollte, um Bestätigungen zu erhalten", WIe = "Benutzername", GIe = "ist noch verfügbar.", HIe = "Dokumentation", KIe = "Lernen Sie, wie Sie unsere Tools in Ihre App integrieren", YIe = "API-Referenz", ZIe = "Eine vollständige API-Referenz für unsere Bibliotheken", QIe = "Blog", JIe = "Lesen Sie unsere Neuigkeiten und Artikel", XIe = "Treten Sie unserer Community bei", eRe = "Beliebte Seiten", tRe = "Jetzt registrieren", nRe = "Registrieren", oRe = "Diese Seite existiert nicht.", rRe = "Keine aktive Telefonnummer verfügbar", iRe = "Workflow-Schritt nicht konfiguriert", aRe = "Prüfen Sie auf Rechtschreibfehler oder gehen Sie zur vorherigen Seite zurück.", sRe = "Wir konnten den Termin nicht finden, den Sie buchen möchten.", cRe = "Los geht's", lRe = "Passwort", dRe = "Leer lassen, um Passwort zu entfernen", uRe = "Stellen Sie sicher, dass Ihr Server aus Sicherheitsgründen nur die erwarteten {{appName}}-Anfragen empfängt", _Re = "Geheimer Termin", pRe = "Stattdessen einloggen", mRe = "Konto erstellen", fRe = "Loslegen", gRe = "Passwort bestätigen", hRe = "Legen Sie Ihr neues Passwort mit den Anweisungen fest, die an Ihre E-Mail-Adresse gesendet wurden.", vRe = "Bitte laden Sie Bild mit einer Breite von {{width}} und einer Höhe von {{height}} hoch.", bRe = "Melden Sie sich mit Ihrer neuen E-Mail-Adresse und Ihrem Passwort wieder an.", yRe = "Erstellen Sie Ihr Konto", $Re = "Erstellen Sie Ihr Cal.com-Konto", wRe = "Registrieren", kRe = "Sie wurden abgemeldet", SRe = "Wir hoffen, Sie bald wieder zu sehen!", xRe = "Abgemeldet", ERe = "Bitte versuchen Sie es erneut und kontaktieren Sie uns, falls das Problem weiterhin besteht.", TRe = "Zwei-Faktor-Code ist falsch.", ARe = "Es gibt kein Konto, das mit dieser E-Mail-Adresse übereinstimmt.", CRe = "Konto erstellen", zRe = "Sie haben noch kein Konto?", ORe = "Mit Ihrem Konto anmelden", PRe = "Anmelden", IRe = "Zurück zur Login-Seite", RRe = "Beim Anmelden ist ein Fehler aufgetreten. Gehen Sie zurück zum Anmeldebildschirm und versuchen Sie es erneut.", NRe = "Passwort zurücksetzen", DRe = "Einladung senden", MRe = "Passwort vergessen", LRe = "Vergessen?", qRe = "Erledigt", jRe = "Erledigt!", FRe = "Alle", VRe = "Ihr Konto", BRe = "Verfügbare Apps", URe = "Verfügbare Apps", WRe = "Sieh dir beliebte Apps unten an und entdecke mehr in unserem <0>App Store</0>", GRe = "Füge jeden hinzu, der an der Veranstaltung teilnehmen muss. <0>Mehr erfahren</0>", HRe = "Personen in einer Gruppe wechseln sich ab, eine Person aus jeder Gruppe wird bei der Veranstaltung erscheinen.", KRe = "Die Leute in der Gruppe wechseln sich ab und nur eine Person wird für die Veranstaltung erscheinen.", YRe = "Überprüfen Sie Ihre E-Mail. Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts gesendet.", ZRe = "Fertig", QRe = "Einstellungen für die Sprache und Zeitzone Ihres Teams verwalten", JRe = "Schreiben Sie eine kurze Beschreibung, welche auf Ihrer persönlichen URL-Seite erscheinen wird.", XRe = "Fast fertig", eNe = "Zum Schluss: Eine kurze Beschreibung über Sie und ein Foto helfen wirklich, Buchungen zu erhalten und lassen andere wissen, mit wem sie einen Termin buchen.", tNe = "Definieren Sie Zeiträume, wenn Sie wiederkehrend verfügbar sind. Sie können später weitere Zeiträume erstellen und verschiedenen Kalendern zuordnen.", nNe = "Verfügbarkeit festlegen", oNe = "Legen Sie Zeitpläne für die Zeiten fest, in denen Sie gebucht werden möchten.", rNe = "Link oder Einbettung teilen", iNe = "Teilen Sie Ihren {{appName}} Link oder betten Sie ihn auf Ihrer Website ein.", aNe = "Verfügbarkeitseinstellungen", sNe = "Ohne Kalender fortfahren", cNe = "Mit {{appName}} fortfahren", lNe = "Kalender verbinden", dNe = "Verbinden Sie Ihre Video-Apps", uNe = "Verbinden Sie Ihre Video-Apps, um sie für Ihre Termintypen zu verwenden.", _Ne = "Verbinden Sie Ihren Kalender, um automatisch nach belegten Zeiten zu suchen und neue Termine zu erfassen, sobald sie geplant werden.", pNe = "Später einrichten", mNe = "Aktuelle Zeit", fNe = "Details", gNe = "Willkommen", hNe = "Willkommen zurück", vNe = "Willkommen bei {{appName}}", bNe = "Teilen Sie uns mit, wie wir Sie nennen sollen und in welcher Zeitzone Sie sich befinden. Sie können dies später bearbeiten.", yNe = "Mit CalDav-Server verbinden", $Ne = "Mit einem ICS-Feed verbinden", wNe = "Verbinden", kNe = "Kostenlos testen", SNe = "Erstellen Sie Ihren eigenen Buchungslink mit {{appName}}", xNe = "Wer", ENe = "Was", TNe = "Wann", ANe = "Wo", CNe = "Zum Kalender hinzufügen", zNe = "Wählen Sie aus, wo Termine hinzugefügt werden sollen, wenn Sie gebucht werden.", ONe = "Termine hinzufügen zu", PNe = "Einen weiteren Kalender hinzufügen", INe = "Sonstige", RNe = "Ihr Anmelde-Link für {{appName}}", NNe = "Sie treffen sich mit {{user}}. Wir haben eine E-Mail mit einer Kalendereinladung mit den Details an alle gesendet.", DNe = "{{host}} trifft sich mit {{attendee}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details gesendet.", MNe = "Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details gesendet.", LNe = "Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", qNe = "Sie treffen sich mit {{user}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", jNe = "{{host}} trifft sich mit {{attendee}}. Wir haben allen eine E-Mail mit einer Kalendereinladung und den Details für das erste dieser wiederkehrenden Events gesendet.", FNe = "Wir haben eine E-Mail mit diesen Informationen an alle gesendet.", VNe = "Ihr Termin muss noch bestätigt oder abgelehnt werden.", BNe = "Ihr wiederkehrender Termin muss noch bestätigt oder abgelehnt werden.", UNe = "{{user}} muss den Termin noch bestätigen oder ablehnen.", WNe = "{{user}} muss noch die Terminreihe des wiederkehrenden Termins bestätigen oder ablehnen.", GNe = "Dieser Termin ist geplant", HNe = "Ihr wiederkehrender Termin wurde geplant", KNe = "Ihre Buchung wurde versandt", YNe = "Ihre wiederkehrende Buchung wurde versandt", ZNe = "Ihr Termin wurde bestätigt", QNe = "Ihr wiederkehrender Termin wurde bestätigt", JNe = "Zahlungen werden bei wiederkehrenden Terminen noch nicht unterstützt", XNe = "Zahlungen werden bei wiederkehrenden Terminen noch nicht unterstützt", eDe = "Geben Sie das neue Passwort ein.", tDe = "Passwort zurücksetzen", nDe = "Passwort ändern", oDe = "Passwort anzeigen", rDe = "Passwort verbergen", iDe = "Erneut versuchen", aDe = "Diese Anfrage ist abgelaufen.", sDe = "Geben Sie die E-Mail-Adresse Ihres Kontos ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.", cDe = "Diese Anfrage ist abgelaufen. Gehen Sie zurück und geben Sie die E-Mail Ihres Kontos ein und wir senden Ihnen einen weiteren Link zum Zurücksetzen Ihres Passworts.", lDe = "Hoppla", dDe = "Anmelden", uDe = "Das hat geklappt", _De = "Fehlschlagen", pDe = "Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt mit Ihrem neu erstellten Passwort anmelden.", mDe = "Layout", fDe = "Standardansicht", gDe = "Sie können mehrere auswählen und Ihre Bucher können anschließend die Ansicht wechseln.", hDe = "Buchungslayout", vDe = "Sie können mehrere auswählen und Bucher können anschließend die Ansicht wechseln. Dies kann pro Termin überschrieben werden.", bDe = "Monat", yDe = "Wöchentlich", $De = "Spalte", wDe = "Es muss mindestens ein Layout aktiviert sein.", kDe = "Das Layout, das Sie als Standardansicht ausgewählt haben, ist nicht Teil der aktivierten Layouts.", SDe = "Das ausgewählte Layout ist kein gültiges Layout.", xDe = "Du kannst dies für alle deine Ereignistypen in Einstellungen -> <0>Erscheinungsbild</0> verwalten oder <1>überschreiben</1> nur für dieses Ereignis.", EDe = "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut.", TDe = "Ungültige Zeit am Sonntag", ADe = "Ungültige Zeit am Montag", CDe = "Ungültige Zeit am Dienstag", zDe = "Ungültige Zeit am Mittwoch", ODe = "Ungültige Zeit am Donnerstag", PDe = "Ungültige Zeit am Freitag", IDe = "Ungültige Zeit am Samstag", RDe = "Die Endzeit darf nicht vor der Startzeit liegen", NDe = "Die Endzeit darf nicht größer als 24 Stunden sein", DDe = "Zurück zu den Buchungen", MDe = "Sie können jederzeit einen anderen Termin wählen.", LDe = "Abgesagt", qDe = "Keine Buchung", jDe = "Warten auf Gastgeber", FDe = "Stornierung erfolgreich", VDe = "Möchten Sie wirklich stornieren?", BDe = "Sie können diese Buchung nicht stornieren", UDe = "Stattdessen können Sie den Termin auch verschieben.", WDe = "Der Termin ist in der Vergangenheit", GDe = "Der Termin ist eine Instanz eines wiederkehrenden Termins.", HDe = "Dies sind alle verbleibende Instanzen im wiederkehrenden Termin.", KDe = "Ein Fehler mit dem Statuscode {{status}} ist aufgetreten.", YDe = "Ein Termintyp mit dieser URL existiert bereits.", ZDe = "Sie können diesen Termin nicht erstellen", QDe = "Sie können diesen Termin nicht bearbeiten", JDe = "Sie können diesen Workflow nicht erstellen", XDe = "Sie können diesen Verfügbarkeitsplan nicht erstellen", eMe = "Dieser Termin wurde bereits abgesagt", tMe = "Diese Buchung wurde bereits angenommen oder abgelehnt", nMe = "Zurück zum Anfang", oMe = "Oder navigieren Sie zurück", rMe = "Kein Termin gefunden", iMe = "Dieser Termin existiert nicht. Kontaktieren Sie den Ersteller um einen aktuellen Link zu bekommen.", aMe = "Es gibt noch keine {{status}} Buchungen", sMe = "Sie haben keine {{status}} Buchungen. {{description}}", cMe = "{{eventName}} zwischen {{host}} und {{attendeeName}}", lMe = "Buchungen", dMe = "Termin nicht gefunden", uMe = "Sehen Sie anstehende und vergangene Veranstaltungen, die über Ihre Events gebucht wurden.", _Me = "Sobald jemand eine Zeit bei Ihnen bucht können Sie das hier sehen.", pMe = "Sobald jemand einen wiederkehrenden Termin mit Ihnen bucht wird er hier erscheinen.", mMe = "Ihre früheren Buchungen werden hier angezeigt.", fMe = "Ihre abgesagten Termine werden hier angezeigt.", gMe = "Ihre unbestätigten Buchungen werden hier angezeigt.", hMe = "Unbestätigte Buchungen", vMe = "auf", bMe = "und", yMe = "Ihr Kalender ist belegt zwischen", $Me = "Problembehandlung", wMe = "Verstehen Sie, warum bestimmte Zeiten verfügbar und andere blockiert sind.", kMe = "Hier ist eine Übersicht Ihres Tages am", SMe = "Tipp: Fahre über die markierten Zeiten um das ganze Datum zu sehen", xMe = "Beginn", EMe = "Ende", TMe = "Pufferzeit", AMe = "Vor dem Termin", CMe = "Nach dem Termin", zMe = "Keine Pufferzeit", OMe = "Puffer", PMe = "Ihr Tag beginnt um", IMe = "Ihr Tag endet um", RMe = "Fehlersuche starten", NMe = "Sie können die Problembehandlung nutzen um zu recherchieren warum Ihr Kalender so angezeigt wird, wie er angezeigt wird.", DMe = "Verfügbare Zeiten ändern", MMe = "Ändern Sie Ihre verfügbaren Zeiten", LMe = "Ändern Sie die Anfangs- und Endzeit Ihres Tages", qMe = "Legen Sie die Anfangs- und Endzeit Ihres Tages und einen Puffer zwischen Ihren Meetings fest.", jMe = "Momentan startet Ihr Tag um", FMe = "Die Anfangs- und Endzeiten Ihres Tages wurden erfolgreich aktualisiert.", VMe = "und endet um", BMe = "Hell", UMe = "Dunkel", WMe = "Theme automatisch basierend auf den Einstellungen des Teilnehmers anpassen", GMe = "Einige der Benutzer in der Gruppe haben derzeit dynamische Gruppenbuchungen deaktiviert", HMe = "Gruppenbuchungslinks, die dynamisch durch Hinzufügen mehrerer Benutzernamen mit einem '+' erstellt werden können. Beispiel: '{{appName}}/bailey+peer'", KMe = "Ermöglichen Sie es den Teilnehmenden, Sie über dynamische Gruppenbuchungen zu buchen", YMe = "Dynamische Gruppenlinks", ZMe = "Suchmaschinen erlauben, auf Ihre öffentlichen Inhalte zuzugreifen", QMe = "Suchmaschinenindexierung erlauben", JMe = "Browser-Benachrichtigungen zulassen", XMe = "Sie haben Benachrichtigungen abgelehnt. Setzen Sie die Berechtigung in den Browser-Einstellungen zurück, um sie zu aktivieren.", eLe = "Browser-Benachrichtigungen deaktivieren", tLe = "Browser-Benachrichtigungen aktiviert", nLe = "Browser-Benachrichtigungen deaktiviert", oLe = "Browser-Benachrichtigungen verweigert", rLe = "Bitte erlauben Sie Benachrichtigungen in der Abfrage", iLe = "Push-Benachrichtigungen", aLe = "Erhalten Sie Push-Benachrichtigungen, wenn ein Bucher eine sofortige Terminbuchung vornimmt.", sLe = "Ihr Browser unterstützt keine Push-Benachrichtigungen. Wenn Sie Brave-Nutzer sind, aktivieren Sie die Option 'Google-Dienste für Push-Nachrichten verwenden' unter brave://settings/?search=push+messaging", cLe = "E-Mail", lLe = "max@example.com", dLe = "Vollständiger Name", uLe = "Durchsuchen Sie unsere API Dokumentation", _Le = "Nutzen Sie unsere API für die volle Kontrolle und Anpassbarkeit.", pLe = "Webhook erstellen", mLe = "Sofortiges Meeting erstellt", fLe = "Termin abgesagt", gLe = "Termin verlegt", hLe = "Download-Link der Aufnahme ist nun verfügbar", vLe = "Transkript erstellt", bLe = "Termin erstellt", yLe = "Termin abgelehnt", $Le = "Buchung angefragt", wLe = "Buchungszahlung eingeleitet", kLe = "Meeting beendet", SLe = "Formular gesendet", xLe = "Formular übermittelt, kein Termin gebucht", ELe = "Buchung bezahlt", TLe = "Abwesenheitsnotiz erstellt", ALe = "Buchung als Nichterscheinen aktualisiert", CLe = "Event-Auslöser", zLe = "Subscriber-URL", OLe = "Einen neuen Webhook erstellen", PLe = "Webhooks", ILe = "Team-Webhooks", RLe = "Erstellen Sie einen neuen Webhook in Ihrem Account", NLe = "Neuer Webhook", DLe = "Erhalten Sie in Echtzeit {{appName}}-Termindaten unter einer bestimmten URL, wenn ein Termin geplant oder abgesagt wird.", MLe = "Erhalten Sie in Echtzeit {{appName}}-Termindaten unter einer bestimmten URL, wenn dieser Termin geplant oder abgesagt wird.", LLe = "Responsives Vollbild-iFrame", qLe = "Wird geladen...", jLe = "Lösche...", FLe = "Standard iFrame", VLe = "Entwickler", BLe = "Verwalten Sie Ihre Entwicklereinstellungen.", ULe = "iFrame-Einbettung", WLe = "Der einfachste Weg, {{appName}} auf Ihrer Website einzubinden.", GLe = "Integrieren Sie Cal.com in Ihre Website mit unseren Einbettungs-Optionen oder erhalten Sie Buchungsdaten mit Webhooks.", HLe = "Termin planen", KLe = "Ihre Rechnungsdetails ansehen und verwalten", YLe = "Rechnungsdaten ansehen, bearbeiten oder Abonnement kündigen.", ZLe = "Zum Rechnungsportal gehen", QLe = "Brauchen Sie etwas anderes?", JLe = "Wenn Sie weitere Hilfe bei der Rechnungsstellung benötigen, hilft Ihnen unser Support-Team gerne weiter.", XLe = "Kontaktieren Sie", eqe = "unser Support-Team", tqe = "Kontaktieren Sie unser Support-Team", nqe = "Uh oh!", oqe = "Dieser Benutzer hat noch keine Termintypen eingerichtet.", rqe = "Logo bearbeiten", iqe = "Logo hochladen", aqe = "Logo hochladen", sqe = "Logos entfernen", cqe = "Aktivieren", lqe = "Code", dqe = "Code ist falsch.", uqe = "Neues Zeitfenster hinzufügen", _qe = "Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsstufe hinzu, falls Ihr Passwort gestohlen wird.", pqe = "Zwei-Faktor-Authentifizierung aktivieren", mqe = "Zwei-Faktor-Authentifizierung deaktivieren", fqe = "Falls Sie 2FA deaktivieren müssen, empfehlen wir, es so schnell wie möglich wieder zu aktivieren.", gqe = "Fehler beim Deaktivieren der Zwei-Faktor-Authentifizierung", hqe = "Fehler beim Einrichten der Zwei-Faktor-Authentifizierung", vqe = "Sicherheit", bqe = "Verwalten Sie die Sicherheit Ihres Kontos.", yqe = "Passwort", $qe = "Passwort erfolgreich aktualisiert", wqe = "Ihr Passwort wurde erfolgreich geändert.", kqe = "Fehler beim Ändern des Passworts", Sqe = "Ihre Sitzungskonfiguration wurde erfolgreich aktualisiert.", xqe = "Fehler beim Aktualisieren der Sitzungskonfiguration", Eqe = "Etwas ist schief gelaufen", Tqe = "Irgendwas sieht nicht richtig aus?", Aqe = "Bitte erneut versuchen", Cqe = "Ihr supersicheres neues Passwort", zqe = "Neues Passwort", Oqe = "Ihr altes Passwort", Pqe = "Aktuelles Passwort", Iqe = "Passwort ändern", Rqe = "Geheimnis ändern", Nqe = "Neues Passwort stimmt mit Ihrem alten Passwort überein. Bitte wählen Sie ein anderes Passwort.", Dqe = "Wenn Sie dieses Passwort verloren oder vergessen haben, können Sie es ändern. Bitte beachten Sie, dass alle Integrationen, die dieses Geheimnis nutzen, aktualisiert werden müssen", Mqe = "Aktuelles Passwort ist falsch", Lqe = "Mischung aus Groß- und Kleinbuchstaben", qqe = "Mindestens 7 Zeichen lang", jqe = "Mindestens 15 Zeichen lang", Fqe = "Enthält mindestens 1 Zahl", Vqe = "Muss {{limit}} oder weniger Zeichen lang sein", Bqe = "Das Passwort muss mindestens {{passwordLength}} Zeichen lang sein und mindestens eine Nummer beinhalten, sowie eine Mischung aus Groß- und Kleinbuchstaben sein", Uqe = "Passwort ist falsch", Wqe = "Die E-Mail-Adresse oder das Passwort ist falsch.", Gqe = "Benutze Einstellung", Hqe = "am/pm", Kqe = "Zeitoptionen", Yqe = "Januar", Zqe = "Februar", Qqe = "März", Jqe = "April", Xqe = "Mai", e9e = "Juni", t9e = "Juli", n9e = "August", o9e = "September", r9e = "Oktober", i9e = "November", a9e = "Dezember", s9e = "Montag", c9e = "Dienstag", l9e = "Mittwoch", d9e = "Donnerstag", u9e = "Freitag", _9e = "Samstag", p9e = "Sonntag", m9e = "Alle Termine bereits vergeben.", f9e = "Die verfügbaren Zeitfenster konnten nicht geladen werden.", g9e = "+ Weitere Gäste", h9e = "Ihr Name", v9e = "Ihr vollständiger Name", b9e = "Kein Name", y9e = "Bitte geben Sie eine Zahl zwischen 1 und {{maxOccurences}} ein", $9e = "Schnell und einfach - kein Konto erforderlich. Perfekt für einmalige Meetings.", w9e = "E-Mail Adresse", k9e = "Bitte geben Sie eine gültige Emaildresse ein", S9e = " Bitte planen Sie einen Anruf in der Zukunft ein, falls wir nicht innerhalb von {{seconds}} Sekunden verfügbar sind", x9e = "Ort", E9e = "Adresse", T9e = "Geben Sie eine Adresse ein", A9e = "Vor Ort (Adresse von Ihnen)", C9e = "Anderer Ort", z9e = "Benutzerdefinierter Teilnehmerort", O9e = "Als Gast fortfahren", P9e = "Als Gast beitreten", I9e = "Ideal für einmalige Anrufe", R9e = "Beliebiger Ort", N9e = "Ja", D9e = "Nein", M9e = "Zusätzliche Notizen", L9e = "Termin konnte nicht gebucht werden.", q9e = "Termin konnte nicht neugeplant werden.", j9e = "Bitten teilen Sie Notizen zur Vorbereitung des Termins, falls nötig.", F9e = "Bestätigen Sie {{eventTypeTitle}} mit {{profileName}}", V9e = "Planen Sie Ihr {{eventTypeTitle}} mit {{profileName}} um", B9e = "Vor-Ort-Termin", U9e = "Vor Ort (Organisator-Adresse)", W9e = "Termin verknüpfen", G9e = "Telefonnummer", H9e = "Telefonnummer", K9e = "Telefonnummer des Organisators", Y9e = "Telefonnummer eingeben", Z9e = "Neuplanen", Q9e = "Stattdessen verschieben", J9e = "Teammitglied stattdessen buchen", X9e = "ODER", eje = "Zurück", tje = "E-Mail oder Benutzername", nje = "Einladungs-E-Mail senden", oje = "Rolle", rje = "Rolle bearbeiten", ije = "Rolle anzeigen", aje = "Team bearbeiten", sje = "Benutzer bearbeiten", cje = "Organisation bearbeiten", lje = "Wenn du deine Webhooks bearbeiten oder verwalten möchtest, gehe bitte zu den <0>Webhook-Einstellungen</0>", dje = "Ablehnen", uje = "Alle ablehnen", _je = "Annehmen", pje = "Verlassen", mje = "Profil", fje = "Meine Team-URL", gje = "Meine Teams", hje = "Teamname", vje = "Ihr Teamname", bje = "Team erfolgreich aktualisiert", yje = "Ihr Team wurde erfolgreich aktualisiert.", $je = "Ihre Org wurde erfolgreich aktualisiert.", wje = "Fehler beim Kopieren in die Zwischenablage", kje = "Beschreibung", Sje = "Ein paar Sätze über Ihr Team auf der öffentlichen Teamseite.", xje = "Organisations-ID", Eje = "Organisations-ID kopiert.", Tje = "Ein paar Sätze zu Ihrer Organisation. Dies wird auf der URL-Seite Ihrer Organisation erscheinen.", Aje = "Team-ID", Cje = "Team-ID kopiert.", zje = "Mitglieder", Oje = "Mitglieder der Organization", Pje = "Mitglied", Ije = "{{count}} Mitglied", Rje = "{{count}} Mitglieder", Nje = "{{count}} ausgewählt", Dje = "Inhaber", Mje = "Administrator", Lje = "Admin API", qje = "Administrator Benutzer", jje = "Lass uns als erstes den Administrator Benutzer anlegen.", Fje = "Administrator-Benutzereinrichtung", Vje = "Sie haben bereits einen Administrator-Benutzer erstellt. Sie können sich nun in Ihr Konto einloggen.", Bje = "Neues Mitglied", Uje = "Einladen", Wje = "Teammitglieder hinzufügen", Gje = "Mitglieder hinzufügen", Hje = "Lade andere ein, deinem Team beizutreten", Kje = "Teammitglied hinzufügen", Yje = "Ein neues Mitglied einladen", Zje = "Hinweis: Dies wird <0>einen zusätzlichen Platz (15$/Monat)</0> in deinem Abonnement kosten.", Qje = "Laden Sie jemanden in Ihr Team ein.", Jje = "Eine .csv-Datei hochladen", Xje = "Per E-Mail einladen", eFe = "Rolle des Teammitglieds ändern", tFe = "{{appName}}-Branding deaktivieren", nFe = "Blendet alle {{appName}}-Werbung auf Ihren öffentlichen Seiten aus.", oFe = "„Ein Teammitglied buchen“-Schaltfläche ausblenden", rFe = "Blendet die „Ein Teammitglied buchen“-Schaltflächen auf Ihren öffentlichen Seiten aus.", iFe = "Achtung", aFe = "Seien Sie vorsichtig. Die Kontolöschung kann nicht rückgängig gemacht werden.", sFe = "Seien Sie vorsichtig. Die Teamlöschung kann nicht rückgängig gemacht werden.", cFe = "Zurück", lFe = "Stornieren", dFe = "Alle verbleibenden absagen", uFe = "Anwenden", _Fe = "Termin absagen", pFe = "Bestätigen", mFe = "Alle bestätigen", fFe = "Team auflösen", gFe = "Bist du sicher, dass du dieses Team auflösen möchtest? Jeder der diesen Team-Link erhalten hat, kann Sie nicht mehr buchen.", hFe = "Organization auflösen", vFe = "Sind Sie sicher, dass Sie diese Organisation auflösen möchten? Alle Teams und Mitglieder werden gelöscht.", bFe = "Sind Sie sicher, dass Sie dieses Mitglied aus dem Team entfernen möchten?", yFe = "Ja, Team auflösen", $Fe = "Ja, Mitglied entfernen", wFe = "Ja, Abonnement kündigen", kFe = "Abonnement kündigen", SFe = "Durch die Kündigung Ihres Abonnements wird Ihr aktueller Plan dauerhaft deaktiviert. Diese Aktion kann nicht rückgängig gemacht werden.", xFe = "Mitglied entfernen", EFe = "Team verwalten", TFe = "Sie haben noch keine Teams.", AFe = "Teams ermöglichen Termine zu buchen, an denen mehrere Mitarbeiter beteiligt sind.", CFe = "Abschicken", zFe = "Ja, Attribut entfernen", OFe = "Attribut entfernen", PFe = "Sind Sie sicher, dass Sie das Attribut '{{name}}' entfernen möchten? Alle Benutzer, die derzeit zugewiesen sind, werden abgemeldet.", IFe = "Aktualisieren", RFe = "Speichern", NFe = "Ausstehend", DFe = "Optionen öffnen", MFe = "Link kopieren", LFe = "Teilen", qFe = "Können Sie einen Termin in meinem Kalender reservieren oder mir Ihren Kalender zukommen lassen?", jFe = "Link zum Team kopieren", FFe = "Team verlassen", VFe = "Ja, Team verlassen", BFe = "Sind Sie sicher, dass Sie dieses Team verlassen möchten? Sie können dann nicht mehr über dieses Team gebucht werden.", UFe = "{{user}} von {{team}}", WFe = "Vorschau", GFe = "Link kopiert!", HFe = "Kopiert!", KFe = "Privater Link kopiert!", YFe = "Link geteilt!", ZFe = "Titel", QFe = "Beschreibung", JFe = "Apps-Status", XFe = "Ein schnelles Video-Meeting.", e8e = "Termintyp", t8e = "Teamvorschau", n8e = "Kollektiv", o8e = "Planen Sie Meetings, bei denen alle ausgewählten Teammitglieder verfügbar sind.", r8e = "Dauer", i8e = "Verfügbare Laufzeiten", a8e = "Standardlaufzeit", s8e = "Bitte wählen Sie zuerst die verfügbaren Laufzeiten aus", c8e = "{{count}} $t(minute_timeUnit)", l8e = "{{count}} $t({{unit}}_timeUnit)", d8e = "{{count}}$t({{unit}}_short)", u8e = "Minuten", _8e = "Benutzen Sie Cal.ai, um eine KI-betriebene Nummer zu erhalten oder Anrufe an Gäste zu tätigen.", p8e = "Termination-URI", m8e = "SIP-Trunk-Benutzername", f8e = "SIP-Trunk-Passwort", g8e = "Spitzname", h8e = "Telefonnummer löschen", v8e = "Workflow-Validierung fehlgeschlagen", b8e = "Ein oder mehrere Workflow-Schritte haben leere Nachrichteninhalte", y8e = "Eine oder mehrere Telefonnummern oder E-Mail-Adressen sind nicht verifiziert", $8e = "Optimiere deine Arbeitsabläufe mit Cal.ai", w8e = "Lebensechte KI-Agenten, die Meetings buchen, Erinnerungen senden und mit deinen Kunden Nachfassen.", k8e = "Telefonnummer erfolgreich importiert und mit Agent verknüpft", S8e = "Telefonnummer erfolgreich gelöscht", x8e = "Sind Sie sicher, dass Sie diese Telefonnummer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", E8e = "Ja, Telefonnummer löschen", T8e = "Die Nummer, die Sie importieren möchten, muss im E.164-Format sein (+Ländervorwahl gefolgt von der Nummer, ohne Leerzeichen oder Sonderzeichen), z.B. +1234567890", A8e = "Die Termination-URI zur eindeutigen Identifizierung Ihres elastischen SIP-Trunks. Diese wird für ausgehende Anrufe verwendet. Bei Twilio elastischen SIP-Trunks endet sie immer mit .pstn.twilio.com.", C8e = "Der Benutzername zur Authentifizierung des SIP-Trunks.", z8e = "Das Passwort zur Authentifizierung des SIP-Trunks.", O8e = "Spitzname der Nummer. Dies dient nur zu Ihrer Information.", P8e = "Speichern und Testanruf", I8e = "Anruf erfolgreich eingeleitet", R8e = "Bitte geben Sie eine Telefonnummer ein", N8e = "Agent erfolgreich aktualisiert", D8e = "Agent erfolgreich erstellt", M8e = "Ereignistyp erfolgreich hinzugefügt", L8e = "Telefonnummer erfolgreich abgemeldet", q8e = "Dieser Prompt definiert die Rolle und die primären Ziele des Agenten", j8e = "Prompt", F8e = "Anrufen", V8e = "Testanruf zur Überprüfung der Konfiguration durchführen", B8e = "Erste Nachricht", U8e = "Die erste Nachricht, die der Agent beim Starten eines Anrufs sagen wird", W8e = "Probleme beim Importieren?", G8e = "Erfahren", H8e = "Erfahren Sie, wie Sie Ihre Termination URI und SIP-Trunk-Anmeldedaten erhalten", K8e = "Telefonnummer-Abonnement erfolgreich gekündigt", Y8e = "Aktualisierung läuft", Z8e = "Round Robin", Q8e = "Hallo, wie geht es dir?", J8e = "Treffen zwischen mehreren Teammitgliedern durchwechseln.", X8e = "Verwaltetes Ereignis", e7e = "Benutzername", t7e = "Erstellen und verteilen Sie Ereignistypen im Block an Teammitglieder", n7e = "Verwaltet", o7e = "„Benutzername“ wird mit dem Benutzernamen der zugewiesenen Mitglieder ausgefüllt", r7e = "Zuordnen zu", i7e = "Telefonnummer für Testanruf eingeben", a7e = "Testanruf durchführen", s7e = "Neuen Cal.ai Voice-Agenten für Workflow erstellen", c7e = "Erstellen Sie einen neuen Cal.ai Voice-Agenten für Workflow, um Ihre Arbeitsabläufe zu automatisieren", l7e = "Telefonnummer (für unseren Agenten zum Anrufen)", d7e = "Kaufen Sie eine Telefonnummer oder importieren Sie eine, die Sie bereits bei Twilio haben", u7e = "Agent testen", _7e = "Web-Anruf testen", p7e = "Telefonnummern", m7e = "Abmelden", f7e = "Workflow-Schritt löschen", g7e = "Telefonnummer abmelden", h7e = "Neue Nummer kaufen", v7e = "Sie können nur US-Telefonnummern kaufen. Für andere Länder können Sie Ihre eigene Twilio-Telefonnummer importieren.", b7e = "Kaufen Sie eine US-Nummer für ${{priceInDollars}} pro Monat", y7e = "Unterstützte Anrufziele", $7e = "Keine Telefonnummer verbunden", w7e = "Workflow-Schritt-ID konnte nicht abgerufen werden", k7e = "Cal.ai Agent", S7e = "Cal.ai Agent testen", x7e = "Sind Sie sicher, dass Sie diesen Workflow-Schritt löschen möchten?", E7e = "Möchten Sie die Telefonnummer wirklich von diesem Agent abmelden?", T7e = "Diese Aktion wird die Telefonnummer vom Agent trennen. Der Agent kann keine Anrufe tätigen, bis eine neue Telefonnummer verbunden wird.", A7e = "Telefonnummern", C7e = "Telefonnummer verbinden", z7e = "Verwalte deine Telefonnummern", O7e = "Nummer importieren", P7e = "Diese Aktion wird auch:", I7e = "Telefonnummer importieren", R7e = "Aktives Abonnement", N7e = "Ihr Telefonnummer-Abonnement kündigen", D7e = "Die zugehörige Telefonnummer löschen", M7e = "Sie sind nicht berechtigt, diesen Workflow zu erstellen", L7e = "Importiere deine Twilio-Telefonnummer zur Verwendung mit Telefon", q7e = "${{price}}/Monat", j7e = "Neue Nummer kaufen", F7e = "Der Kauf einer Telefonnummer kostet ${{priceInDollars}} pro Monat. Ihnen wird monatlich für jede aktive Telefonnummer eine Gebühr berechnet.", V7e = "Vorwahl (Optional)", B7e = "Keine Telefonnummern", U7e = "Telefonnummer erfolgreich erworben", W7e = "Telefonnummer-Abonnement kündigen", G7e = "Ja, Abonnement kündigen", H7e = "Sind Sie sicher, dass Sie dieses Telefonnummer-Abonnement kündigen möchten? Diese Aktion kann nicht rückgängig gemacht werden und Sie verlieren den Zugriff auf diese Telefonnummer.", K7e = "Mitglieder hinzufügen...", Y7e = "Mitglieder hinzufügen", Z7e = "Keine zugeordneten Mitglieder", Q7e = "Zugeordnet zu", J7e = "Sie müssen bei {{url}} angemeldet sein", X7e = "Mit der Zuordnung von Mitgliedern oben beginnen", eVe = "Mitglieder werden dies nicht bearbeiten können", tVe = "Mitglieder können bearbeiten", nVe = "Diese Option wurde vom Team-Admin gesperrt", oVe = "Vom Team-Admin entsperrt", rVe = "URL", iVe = "Versteckt", aVe = "Schreibgeschützt", sVe = "Einmaliger Link", cVe = "Sie haben gerade den Tarif: {{plan}}.", lVe = "Aktualisieren Sie Ihr Konto auf den Pro-Plan, um alle Funktionen freizuschalten.", dVe = "Sie müssen Ihr Paket upgraden, um mehr als einen aktiven Ereignistyp zu haben.", uVe = "Du musst deinen Plan upgraden, um ein Team zu erstellen.", _Ve = "Sie können <1>hier upgraden</1>.", pVe = "Ereignistypen", mVe = "Erstellen Sie teilbare Termine, die andere Personen buchen können.", fVe = "Neuer Ereignistyp", gVe = "Erstellen Sie Ihren ersten Ereignistyp", hVe = "Mit Ereignistypen kann man verfügbare Zeiten im Kalendar freigeben, die andere Personen dann buchen können.", vVe = "{{eventTypeTitle}} Ereignistyp erfolgreich erstellt", bVe = "{{eventTypeTitle}} Termintyp erfolgreich aktualisiert", yVe = "Termintyp erfolgreich gelöscht", $Ve = "Stunden", wVe = "Personen", kVe = "Ihre E-Mail-Adresse", SVe = "Profilbild ändern", xVe = "Avatar hochladen", EVe = "Sprache", TVe = "Zeitzone", AVe = "Erster Tag der Woche", CVe = "Wiederholt sich bis zu {{count}} mal", zVe = "Wiederholt sich bis zu {{count}} mal", OVe = "Alle {{freq}} für", PVe = "{{count}} Ereignis übrig", IVe = "{{count}} Termine übrig", RVe = "Wiederholt sich alle", NVe = "Vorkommnis", DVe = "Vorkommnisse", MVe = "Woche", LVe = "Wochen", qVe = "Monat", jVe = "Monate", FVe = "Jahr", VVe = "Jahre", BVe = "{{count}} mehr", UVe = "Maximal", WVe = "Einzelnes Theme", GVe = "Markenfarbe", HVe = "Markenfarbe (Helles Theme)", KVe = "Markenfarbe (Dunkles Theme)", YVe = "Ereignistyp-Farbe (Helles Design)", ZVe = "Ereignistyp-Farbe (Dunkles Design)", QVe = "Datei heißt nicht [idOrSlug]/[user]", JVe = "Team erstellen", XVe = "Name", eBe = "Namenloses Team", tBe = "OAuth-Clients", nBe = "Verwalten Sie OAuth-Clients für Ihre Organisation", oBe = "OAuth-Client erstellen", rBe = "Erstellen Sie einen neuen OAuth-Client für Drittanbieter-Integrationen", iBe = "OAuth-Client erfolgreich gelöscht", aBe = "Erstellen Sie ein neues Team, um mit anderen zusammenzuarbeiten.", sBe = "Ein neues Team erstellen", cBe = "URL Ihrer Buchungsseite", lBe = "URL der Seite, auf der Ihre Nutzer ihre Buchung stornieren können", dBe = "URL der Seite, auf der Ihre Nutzer ihre Buchung umplanen können", uBe = "Dieser Zeitraum ist nicht mehr verfügbar. Bitte kehren Sie zur vorherigen Seite zurück und wählen Sie eine andere Zeit.", _Be = "Offene Einladungen", pBe = "Neues Team", mBe = "Erstellen Sie Ihr erstes Team und laden Sie andere Benutzer ein, zusammenzuarbeiten.", fBe = "Erstellen Sie ein Team um loszulegen", gBe = "Teams", hBe = "Team", vBe = "Organization", bBe = "Abrechnung der Teams", yBe = "Verwalte die Abrechungen deines Teams", $Be = "Wir haben die Abrechnung für Teams geändert", wBe = "Es gibt Mitglieder in Ihrem Team ohne Lizenz. Upgraden Sie Ihren Pro-Plan um fehlende Lizenzen abzudecken.", kBe = "Ab Januar 2022 berechnen wir pro Sitzplatz für Teammitglieder. Mitglieder deines Teams, die Pro kostenlos hatten, sind jetzt in einer 14 Tage Testphase. Sobald die Testversion abläuft, werden diese Mitglieder vor Ihrem Team verborgen, es sei denn, Sie upgraden jetzt.", SBe = "Erstellen und verwalten Sie Teams, um kollaborative Funktionen zu nutzen.", xBe = "Diese Funktion ist nur im Pro Plan verfügbar", EBe = "Um das {{appName}}-Branding von Ihren Buchungsseiten zu entfernen, müssen Sie auf ein Pro-Konto upgraden.", TBe = "Bearbeiten Sie Ihre Profilinformationen, welche bei Ihrem Cal-Link angezeigt werden.", ABe = "Möglicherweise müssen Sie sich aus- und einloggen, um die Änderung wirksam zu machen.", CBe = "Ein wenig über sich selbst.", zBe = "Profil erfolgreich aktualisiert", OBe = "Ihr Benutzerprofil wurde erfolgreich aktualisiert.", PBe = "Ihr Upgrade ist da", IBe = "Verbessern Sie Ihr Buchungserlebnis durch ein Upgrade auf den neuen Plan und genießen Sie die neuen Funktionen.", RBe = "Alles ist eingerichtet", NBe = "Sie nutzen bereits den aktuellsten Plan. Kein Upgrade erforderlich. Genießen Sie die neuen Funktionen und kontaktieren Sie uns bei Fragen!", DBe = "Benutzer scheint eingeloggt zu sein, kann aber nicht in der Datenbank gefunden werden", MBe = "Einbetten & Webhooks", LBe = "Aktiviert", qBe = "Deaktiviert", jBe = "Deaktivieren", FBe = "Abrechnung", VBe = "hier", BBe = "Verwalten Sie Ihre Rechnungsinformationen und kündigen Sie Ihr Abonnement.", UBe = "Verfügbarkeit", WBe = "Verfügbarkeit bearbeiten", GBe = "Konfigurieren Sie die Zeiten, in denen Sie für Buchungen zur Verfügung stehen.", HBe = "Zeiten kopieren in", KBe = "Kopiere Zeiten nach …", YBe = "Wöchentliche Termine ändern", ZBe = "Logo", QBe = "Fehler", JBe = "Bitte geben Sie wenigstens ein Zeichen ein", XBe = "Bitte geben Sie mindestens {{count}} Zeichen ein", eUe = "Team-Logo", tUe = "Standort hinzufügen", nUe = "Teilnehmende", oUe = "Teilnehmende hinzufügen", rUe = "Erweiterte Einstellungen anzeigen", iUe = "Erweiterte Einstellungen ausblenden", aUe = "Termin-Name", sUe = "Ereignisname im Kalender", cUe = "Der Name, der in Kalendern angezeigt wird", lUe = "Meeting mit {{attendeeName}}", dUe = "Zusätzliche Notizen", uUe = "Erfordert die Eingabe zusätzlicher Eingaben durch den Planer vor der Terminbestätigung", _Ue = "Bezeichnung", pUe = "Platzhalter", mUe = "„Zum Kalender hinzufügen“-E-Mail als Organisator anzeigen", fUe = "Wir werden diese E-Mail-Adresse als Veranstalter anzeigen und Bestätigungs-E-Mails hierhin senden.", gUe = 'Wenn aktiviert, werden wir die E-Mail-Adresse aus Ihrem "Zum Kalender hinzufügen" als Organisator anzeigen und dort Bestätigungs-E-Mails senden', hUe = "Bitte beachten Sie, dass Sie möglicherweise die Verbindung trennen und anschließend Ihr „Zum Kalender hinzufügen“-Konto erneut verbinden müssen, um diese Funktion nutzen zu können.", vUe = "Typ", bUe = "Bearbeiten", yUe = "Eingabe hinzufügen", $Ue = "Notizen im Kalender ausblenden", wUe = "Aus Datenschutzgründen werden zusätzliche Eingaben und Notizen im Kalendereintrag ausgeblendet. Sie werden trotzdem an Ihre E-Mail gesendet.", kUe = "Die Buchung muss manuell bestätigt werden, bevor die Buchungsinformationen an die Integrationen weitergeleitet werden und eine Bestätigungsmail gesendet wird.", SUe = "Unbestätigte Buchungen blockieren trotzdem Kalenderslots.", xUe = "Wiederkehrender Termin", EUe = "Personen können sich für wiederkehrende Termine anmelden", TUe = "Verbinden und beitreten", AUe = "Es kann nicht mit bezahlten Ereignistypen verwendet werden", CUe = "Softige Meetings werden von wiederkehrenden Ereignissen und Zahlungs-Apps noch nicht unterstützt", zUe = "Experimentell: „Sofortiges Meeting“-Ereignisse sind derzeit eine experimentelle Funktion.", OUe = "Beginnen", PUe = "Gäste deaktivieren", IUe = "Das Hinzufügen zusätzlicher Gäste deaktivieren.", RUe = "Privaten Link generieren", NUe = "Private URL aktivieren", DUe = "Privater Link", MUe = "Ihr privater Link wird nach jeder Nutzung neu generiert", LUe = "Privaten Link kopieren", qUe = "Privaten Link zum Ereignis kopieren", jUe = "Erzeugen Sie einen privaten Link, den Sie teilen können, ohne Ihren {{appName}}-Benutzername preiszugeben", FUe = "Private Links", VUe = "Generieren Sie private URLs ohne den Benutzernamen preiszugeben, mit konfigurierbaren Ablauf- und Nutzungsbeschränkungen", BUe = "Neuen Link hinzufügen", UUe = "Privater Link kopiert", WUe = "Teilnehmende können folgendes buchen", GUe = "Datumszeitraum", HUe = "Kalendertage", KUe = "Werktage", YUe = "Adresse oder Ort festlegen", ZUe = "Einen Link zum Termin setzen", QUe = "Kann nicht umgeschaltet werden. Kann nur für untergeordnete Ereignistypen freigeschaltet werden", JUe = "{{appName}} wird Ihren Teilnehmer bitten, vor der Planung eine Telefonnummer einzugeben.", XUe = "{{appName}} wird einen Google Meet Ort zur Verfügung stellen.", eWe = "{{appName}} wird eine Zoom Meeting URL zur Verfügung stellen.", tWe = "{{appName}} wird eine Tandem Meeting URL zur Verfügung stellen.", nWe = "{{appName}} wird eine Video-Meeting URL zur Verfügung stellen.", oWe = "Cal stellt eine Jitsi Meet URL zur Verfügung.", rWe = "{{appName}} wird eine Huddle01 Video-Meeting URL zur Verfügung stellen.", iWe = "{{appName}} wird eine MS Teams Meeting-URL zur Verfügung stellen. HINWEIS: SIE BRAUCHEN EIN BERUFS- ODER SCHULKONTO", aWe = "Zahlung erforderlich", sWe = "Sie müssen einen Namen hinzufügen", cWe = "Provision pro Transaktion", lWe = "Ihr Termintyp wurde erfolgreich aktualisiert.", dWe = "Termintyp ausblenden", uWe = "Standort bearbeiten", _We = "in die Zukunft", pWe = "Bei Buchung mit weniger als <0></0> Vorlaufzeit", mWe = "Innerhalb eines Zeitraums", fWe = "Auf unbestimmte Zeit in die Zukunft", gWe = "Neues individuelles Eingabefeld hinzufügen", hWe = "Schneller Chat", vWe = "Neuen Termintyp hinzufügen", bWe = "Neuen Termintyp hinzufügen", yWe = "Erstellen Sie einen neuen Termintyp, mit dem Personen Zeiten buchen können.", $We = "Länge", wWe = "Mindestvorlaufzeit für eine Buchung", kWe = "Versetzte Startzeiten", SWe = "Versetzt die den Buchern angezeigten Zeitfenster um eine bestimmte Anzahl von Minuten", xWe = "Versetzt um", EWe = "z.B. wird dies Zeitfenster für Ihre Bucher um {{ adjustedTime }} statt {{ originalTime }} anzeigen", TWe = "Zeit-Slot-Intervalle", AWe = "Verwende Terminlänge (Standard)", CWe = "Ereignistyp löschen?", zWe = "Verwalteten Ereignistyp löschen?", OWe = "Jede Person, mit der Sie diesen Link geteilt haben, kann nicht mehr über den Link buchen.", PWe = "Mitglieder, die diesem Ereignistyp zugewiesen sind, werden ebenfalls ihre Ereignistypen gelöscht bekommen.", IWe = "Jeder, mit dem sie ihren Link geteilt haben, wird diesen nicht mehr zur Buchung verwenden können.", RWe = "Ja, löschen", NWe = "Account löschen", DWe = "Ja, Account löschen", MWe = "Sie können dann nicht mehr über Ihre geteilten Links gebucht werden und alle Einstellungen werden gelöscht.", LWe = "Integrationen", qWe = "Apps", jWe = "Hier finden Sie eine Liste Ihrer Apps", FWe = "App-Listing", VWe = "{{category}} Apps", BWe = "App Store", UWe = "Verbindet Menschen, Technologie und den Arbeitsplatz.", WWe = "Verbinden Sie Ihre Videokonferenz-App", GWe = "Einstellungen", HWe = "Die Daten wurden erfolgreich gespeichert", KWe = "Nächster Schritt", YWe = "Schritt überspringen", ZWe = "Vorheriger Schritt", QWe = "Installieren", JWe = "Kostenlose Testphase starten", XWe = "Installiert", eGe = "{{count}} aktive Installation", tGe = "{{count}} aktive Installationen", nGe = "Global installiert", oGe = "App erfolgreich installiert", rGe = "App konnte nicht installiert werden", iGe = "Trennen", aGe = "Fügen Sie Ihren Kalender in Ihre Webseite ein", sGe = "Verbinden Sie Ihre Lieblings-Apps.", cGe = "Automatisierung", lGe = "Konfigurieren Sie, wie Ihre Termin-Typen mit Ihren Kalendern interagieren sollen.", dGe = "Wechseln Sie die Kalender in denen nach Konflikten gesucht werden sollen, um Doppelbuchungen zu vermeiden.", uGe = "Zusätzlichen Kalender verbinden", _Ge = "Kalender erfolgreich aktualisiert", pGe = "Hier auswählen", mGe = "Videokonferenzen", fGe = "Kalender", gGe = "Zahlungen", hGe = "Nicht installiert", vGe = "Passwörter stimmen nicht überein.", bGe = "Dieses Feld ist erforderlich.", yGe = "Status", $Ge = "Verfügbarkeit des Benutzers anzeigen", wGe = "Der Benutzer muss die Einladung annehmen, um freie Termine zu sehen", kGe = "Stelle deinen Status auf Abwesend", SGe = "Abwesenheitsstatus deaktivieren", xGe = "Fehler beim Aktualisieren des Abwesenheitsstatus", EGe = "Dieser Benutzer ist derzeit abwesend.", TGe = "Die Person, mit der Sie einen Termin buchen wollen, ist zur Zeit abwesend und akzeptiert daher keine neuen Buchungen.", AGe = "Triff Leute mit den selben Token", CGe = "Nur Buchungen von Personen erlauben, die die gleichen Token, DAOs oder NFTs teilen.", zGe = "Ihr Konto wurde mit einem Identitäts-Anbieter erstellt.", OGe = "Ihr Konto wird verwaltet von {{provider}}", PGe = "Um Ihre E-Mail-Adresse, Ihr Passwort, die Zwei-Faktor-Authentifizierung und sonstiges zu ändern, besuchen Sie bitte Ihre {{provider}} -Kontoeinstellungen.", IGe = "Ihr Konto wird von einem anderen Identitätsanbieter verwaltet. Versuchen Sie, sich mit {{provider}} anzumelden.", RGe = "Fehler beim Erstellen eines neuen Benutzers. Bitte versuchen Sie es erneut.", NGe = "Mit Google anmelden", DGe = "Anmelden mit SAML", MGe = "Anmelden mit SAML/OIDC", LGe = "Mit E-Mail fortfahren", qGe = "Mit Google fortfahren", jGe = "Zuletzt verwendet", FGe = "Sie müssen ein Zugriffstoken in ihrem alten Kalender-Tool erzeugen.", VGe = "Importieren von", BGe = "Zugriffs-Token", UGe = "Roadmap", WGe = "Vorgestellte Kategorien", GGe = "Feature-Flags", HGe = "Hier können Sie die Funktionen Ihrer Cal.com-Instanz ein- und ausschalten.", KGe = "Beliebte Kategorien", YGe = "{{count}} Apps", ZGe = "{{count}} Apps", QGe = "Angesagte Apps", JGe = "Am beliebtesten", XGe = "Installierte Apps", eHe = "Kostenlos", tHe = "Keine {{category}} Apps", nHe = "Alle Apps", oHe = "Fügen Sie eine Kalender-App hinzu, in der nach Konflikten gesucht werden soll, um Doppelbuchungen zu vermeiden", rHe = "Versuchen Sie, eine Konferenz-App für Videoanrufe mit Ihren Kunden hinzuzufügen", iHe = "Fügen Sie eine Zahlungs-App hinzu, um die Transaktion zwischen Ihnen und Ihren Kunden zu erleichtern", aHe = "Fügen Sie eine Analyse-App für Ihre Buchungsseiten hinzu", sHe = "Fügen Sie eine Automatisierungs-App hinzu, die verwendet werden soll", cHe = "Füge jede beliebige andere Art von App hinzu, um alle möglichen Dinge zu tun", lHe = "Fügen Sie eine Nachrichten-App hinzu, um benutzerdefinierte Benachrichtigungen und Erinnerungen einzurichten", dHe = "Fügen Sie eine CRM-App hinzu, um einen Überblick über die Personen zu behalten, mit denen Sie sich getroffen haben", uHe = "Legen Sie den/die Kalender in denen nach Konflikten gesucht werden sollen fest, um Doppelbuchungen zu vermeiden.", _He = "Konfigurieren Sie die Zahlungsdienstleister, welcher bei der Belastung Ihrer Kunden verwendet werden sollen.", pHe = "Konfigurieren Sie, welche Analyse-Apps für Ihre Buchungsseiten verwendet werden sollen", mHe = "Alle von Ihnen installierten Apps aus anderen Kategorien.", fHe = "Konfigurieren Sie, welche Konferenz-Apps verwendet werden sollen", gHe = "Konfigurieren Sie, welche Automatisierungs-Apps verwendet werden sollen", hHe = "Konfigurieren Sie zur Einrichtung benutzerdefinierter Benachrichtigungen und Erinnerungen, welche Nachrichten-Apps verwendet werden sollen", vHe = "Konfigurieren Sie, welche CRM-Apps verwendet werden sollen, um einen Überblick über die Personen zu behalten, mit denen Sie sich getroffen haben", bHe = "Analyse", yHe = "Keine Apps installiert", $He = "Apps erlauben es Ihnen, Ihren Arbeitsfluss zu verbessern und Ihre Planung viel besser zu gestalten.", wHe = "Durchsuchen Sie den App Store", kHe = "Verwalten Sie Ihre installierten Apps oder ändern Sie die Einstellungen", SHe = "Apps durchsuchen", xHe = "Funktionen", EHe = "Berechtigungen", THe = "Nutzungsbedingungen und Datenschutz", AHe = "Veröffentlicht von {{author}}", CHe = "Abonnieren", zHe = "Kaufen", OHe = "App installieren", PHe = "Kategorien", IHe = "Preise", RHe = "Mehr erfahren", NHe = "Jetzt ausprobieren", DHe = "Datenschutzerklärung", MHe = "Nutzungsbedingungen", LHe = "Entfernen", qHe = "Hinzufügen", jHe = "{{count}} installiert", FHe = "Wallet verifizieren", VHe = "Erstelle Termine in:", BHe = "Dies ist eine kommerzielle Funktion", UHe = "Sie können diese Funktion lokal testen, aber nicht in der Produktionsumgebung.", WHe = "Um eine kommerzielle Lizenz zu erwerben, wenden Sie sich bitte an unser Vertriebsteam. Falls bereits ein Lizenzschlüssel vorhanden ist, kontaktieren Sie bitte support@cal.com für Unterstützung.", GHe = "Lizenz fehlt", HHe = "Nächste Schritte", KHe = "Eine kommerzielle Lizenz erwerben", YHe = "Der Infrastrukturplan ist nutzungsbasiert und bietet Startup-freundliche Discounts an.", ZHe = "Erstellen Sie ein Konto über Prisma Studio", QHe = "Erfahren Sie, wie Sie Ihren ersten Benutzer einrichten können", JHe = "Vertrieb kontaktieren", XHe = "Fehler 404", eKe = "Als Standard festlegen", tKe = "Neuer Verfügbarkeitsplan", nKe = "Neuen Verfügbarkeitsplan hinzufügen", oKe = "Neuen Kalender hinzufügen", rKe = "Legen Sie fest, wo neue Events hinzugefügt werden sollen, wenn Sie ausgebucht sind.", iKe = "Verfügbarkeitsplan löschen", aKe = "Das Löschen eines Verfügbarkeitsplanes entfernt ihn von allen Termintypen. Diese Aktion kann nicht rückgängig gemacht werden.", sKe = "{{scheduleName}} -Verfügbarkeitsplan erfolgreich erstellt", cKe = "{{scheduleName}} Zeitplan erfolgreich aktualisiert", lKe = "Verfügbarkeitsplan erfolgreich gelöscht", dKe = "Arbeitszeiten", uKe = "Erstelle einen Verfügbarkeitsplan", _Ke = "Das Erstellen eines Verfügbarkeitsplan sorgt dafür, dass Ihre Verfügbarkeit bei mehreren Termintypen genutzt werden kann.", pKe = "Erfordert Besitz eines Tokens, das zu der folgenden Adresse gehört:", mKe = "Max Mustermann", fKe = "Zeitformat", gKe = "Weiterleitung bei Buchung ", hKe = 'Sie werden in $t(second, {"count": {{seconds}} }) auf {{ url }} weitergeleitet.', vKe = "https://example.com/redirect-to-my-success-page", bKe = "Nach erfolgreicher Buchung auf eine benutzerdefinierte URL weiterleiten", yKe = "Duplizieren", $Ke = "Plätze anbieten", wKe = "Bieten Sie Plätze für Buchungen an (dies deaktiviert Gäste & Opt-in-Buchungen)", kKe = "Platz verfügbar", SKe = "Plätze verfügbar", xKe = "Plätze fast voll", EKe = "Plätze werden schnell belegt", TKe = "Anzahl der Plätze pro Termin", AKe = "Beitrittszeitfenster festlegen (Sekunden): Der Zeitraum in Sekunden, in dem der Gastgeber beitreten und das Meeting starten kann. Nach dieser Zeit läuft die Beitritts-URL ab.", CKe = "Anzahl der Plätze eingeben", zKe = "Sie können Ihren Verfügbarkeitsplan bei Ihren Verfügbarkeiten ändern.", OKe = "Keine weiteren Plätze verfügbar", PKe = "API-Schlüssel", IKe = "API-Schlüssel", RKe = "API-Schlüssel testen", NKe = "Test bestanden!", DKe = "Test fehlgeschlagen", MKe = "API-Schlüssel bereitstellen", LKe = "Mit API-Schlüsseln können Sie API-Aufrufe für Ihren eigenen Account durchführen.", qKe = "Erstellen Sie stattdessen einen Marktplatz oder eine Plattform.", jKe = "Generieren Sie API-Schlüssel für den Zugriff auf Ihren eigenen Account.", FKe = "API-Schlüssel erstellen", VKe = "Diesen Schlüssel benennen", BKe = "z. B. „Entwicklung“", UKe = "API-Schlüssel ohne Namen", WKe = "Dieser API-Schlüssel hat kein Ablaufdatum", GKe = "API-Schlüssel bearbeiten", HKe = "API-Schlüssel erfolgreich erstellt", KKe = "API-Schlüssel erfolgreich aktualisiert", YKe = "Erstellen", ZKe = "Speichern Sie diesen API-Schlüssel an einem sicheren Speicherort ab.", QKe = "Sie werden ihn nicht mehr anzeigen können, wenn Sie dieses Dialogfenster schließen.", JKe = "In Zwischenablage kopieren", XKe = "Nach der Aktualisierung aktiviert", eYe = "Der private Link funktioniert nach dem Speichern", tYe = "Diesen API-Schlüssel widerrufen", nYe = "Umbuchung deaktivieren", oYe = "Gäste können die Veranstaltung nicht mehr über Kalendereinladung oder E-Mail umbuchen", rYe = "Buchung über Umbuchungslink erlauben", iYe = "Wenn aktiviert, können Benutzer eine neue Buchung erstellen, wenn sie versuchen, eine stornierte Buchung umzuplanen", aYe = "Stornierung deaktivieren", sYe = "Gäste können die Veranstaltung nicht mehr über Kalendereinladung oder E-Mail stornieren", cYe = "API-Schlüssel widerrufen", lYe = "API-Schlüssel kopiert!", dYe = "Der API-Schlüssel läuft ab am", uYe = "Diesen API-Schlüssel dauerhaft von Ihrem Konto entfernen?", _Ye = "Kopieren", pYe = "Ablaufdatum", mYe = "Abgelaufen", fYe = "Läuft niemals ab", gYe = "Läuft ab", hYe = "Anfrage zur Neuplanung Ihrer Buchung", vYe = "Grund für die Neuplanung", bYe = "Neue Zeit buchen", yYe = "Anfrage zur Neuplanung gesendet", $Ye = "Damit wird das geplante Meeting abgesagt. Benachrichtigen Sie die Person, die das Meeting geplant hat, und bitten Sie sie, eine neue Zeit auszuwählen.", wYe = "Grund für die Anfrage zur Neuplanung", kYe = "Neuplanung anfordern ", SYe = "Buchung bearbeiten", xYe = "Buchung neu planen", EYe = "Vorherige Zeit", TYe = "Gif für Bestätigungsseite", AYe = "Suche", CYe = "Imitieren", zYe = "Benutzeridentitätswechsel", OYe = "Erlaubt es unserem Support-Team, sich vorübergehend mit Ihrem Konto anzumelden, um jegliche Probleme, die Sie gemeldet haben, schneller zu lösen.", PYe = "Ermöglicht den Team-Administratoren, sich vorübergehend als Sie einzuloggen.", IYe = "Für Einzelpersonen kostenlos. Teampläne für kollaborative Funktionen.", RYe = "Organisation privat stellen", NYe = "Wenn diese Einstellung aktiv ist, können Ihre Organisationsmitglieder keine anderen Organisationsmitglieder sehen.", DYe = "Team privat stellen", MYe = "Wenn diese Einstellung aktiv ist, können deine Teammitglieder keine anderen Teammitglieder sehen.", LYe = "Sie können nicht alle Teammitglieder eines privaten Teams sehen.", qYe = "Du kannst keine Teams einer privaten Organisation sehen.", jYe = "Mehrere Dauern erlauben", FYe = "Alle Verwendungen dieser Funktion werden geprüft.", VYe = "Imitiere den Account {{user}}.", BYe = "Klicken Sie hier, um zu stoppen", UYe = "Aktualisiert - Ihr Termin hat den Standort geändert", WYe = "Hinzugefügt - Neue Gäste zu Ihrem Ereignis hinzugefügt", GYe = "Ort geändert: {{eventType}} mit {{name}} am {{date}}", HYe = "Gäste hinzugefügt: {{eventType}} mit {{name}} am {{date}}", KYe = "Aktueller Ort", YYe = "Neuer Ort", ZYe = "Sitzung", QYe = "Verwalten Sie Ihre Kontositzung", JYe = "Zeitüberschreitung der Sitzung nach", XYe = "Zeitüberschreitung der Sitzung", eZe = "Erklärt nach einer bestimmten Zeit Ihre Sitzung für ungültig.", tZe = "Kein Ort definiert", nZe = "Ort festlegen", oZe = "Ort aktualisieren", rZe = "Ort aktualisiert", iZe = "Aktualisierung des Standorts fehlgeschlagen", aZe = "Gäste hinzugefügt", sZe = "Gäste konnten nicht hinzugefügt werden", cZe = "Das sieht nicht wie eine E-Mail-Adresse aus", lZe = "E-Mail-Adressen müssen eindeutig und gültig sein", dZe = "Das sieht nicht wie eine gültige URL aus", uZe = "Kopieren Sie diesen Code an die Stelle in Ihrem HTML, an der Ihr {{appName}}-Widget erscheinen soll.", _Ze = "Erstellen oder Aktualisieren einer existierenden Reaktionskomponente wie unten gezeigt.", pZe = "Code kopieren", mZe = "Code kopiert!", fZe = "Wie möchten Sie {{appName}} zu Ihrer Website hinzufügen?", gZe = "Wählen Sie eine der folgenden Möglichkeiten, um {{appName}} in Ihre Website zu integrieren.", hZe = "Einrichtung Ihrer Zapier-Integration", vZe = "Einrichtung Ihrer Make-Integration", bZe = "Api Key generieren", yZe = "Generieren Sie einen API-Schlüssel für {{appName}} unter", $Ze = "Ihr eindeutiger API-Key", wZe = "Kopieren Sie diesen API-Schlüssel und speichern Sie ihn an einem sicheren Ort. Wenn Sie diesen Schlüssel verlieren, müssen Sie einen neuen generieren.", kZe = "<0>Loggen Sie sich in Ihr Zapier-Konto ein und erstelle einen neuen Zap.</0><1>Wählen Sie Cal.com als ihre Trigger-App aus. Wählen Sie auch ein Auslöserereignis.</0></1>Wählen Sie ihr Konto aus und geben dann ihren eindeutigen API-Key ein.</2><3>Testen Sie den Trigger.</3><4>Alles fertig!</4>", SZe = "Gehe zu <0>Make Einladungslink</0> und installiere die Cal.com-App.", xZe = "Melde dich bei deinem Make-Konto an und erstelle ein neues Szenario.", EZe = "Wähle Cal.com als deine Trigger-App. Wähle auch ein Trigger-Ereignis.", TZe = "Wähle dein Konto und gib dann deinen einzigartigen API-Schlüssel ein.", AZe = "Teste deinen Trigger.", CZe = "Du bist fertig!", zZe = "Bitte installieren Sie zuerst die Zapier-App im App Store.", OZe = "Bitte installieren Sie zuerst die Make-App im App Store.", PZe = "App-Installation", IZe = "App nicht installiert", RZe = "Entschuldigung, diese App ist nicht auf Ihrem Konto installiert. Bitte besuchen Sie unseren App-Store, um diese und andere großartige Apps zu entdecken und zu erkunden.", NZe = "Mit Apple-Server verbinden", DZe = "Kalender-URL", MZe = "Generieren Sie ein App-spezifisches Passwort für {{appName}} unter", LZe = "Dieses Apple-Kalender-Konto konnte nicht hinzugefügt werden. Bitte stellen Sie sicher, dass Sie ein app-spezifisches Passwort und nicht Ihr Konto-Passwort verwenden.", qZe = "Ihre Zugangsdaten werden verschlüsselt gespeichert.", jZe = "Er wird gespeichert und verschlüsselt.", FZe = "Zum App Store", VZe = "Etwas ist schiefgelaufen. Versuche deinen Kalender mit allen notwendigen Berechtigungen erneut zu verbinden", BZe = "Telefonnummer für den Termin festlegen", UZe = "Keine belegten Zeiten vorhanden", WZe = "Auf der Buchungsseite anzeigen", GZe = "Ort wird sichtbar sein, bevor die Buchung bestätigt wird", HZe = "GIF hinzufügen", KZe = "Giphy durchsuchen", YZe = "Giphy-Link hinzufügen", ZZe = "GIF zur Bestätigungsseite hinzufügen", QZe = "Finden Sie GIFs, um Ihre Bestätigungsseite aufzupeppen", JZe = "Feedback teilen", XZe = "Ressourcen", eQe = "Support Dokumentation", tQe = "Entwickler-Dokumentation", nQe = "Kontakt aufnehmen", oQe = "Support kontaktieren", rQe = "Premium-Support", iQe = "Community Support", aQe = "Feedback", sQe = "Vielen Dank für Ihr Feedback!", cQe = "Fehler beim Senden des Feedbacks", lQe = "Kommentare", dQe = "Buchungsdetails", uQe = "oder", _Qe = "Abbrechen", pQe = "Gehe zu: ", mQe = "Zapier Einladungs-Link", fQe = "Eine Termin-URL wird angelegt, sobald der Termin bestätigt wurde.", gQe = "Zeigt dynamisch entweder Ihnen den Namen Ihres Teilnehmers bzw. Ihrer Teilnehmerin an oder zeigt Ihrem/Ihrer Teilnehmerin Ihren Namen an", hQe = "Ort des Termins", vQe = "Grund für die Verschiebung (optional)", bQe = "Lassen Sie andere wissen, warum Sie den Termin verschieben müssen", yQe = "Dieser Termin ist abgesagt", $Qe = "Wir haben eine E-Mail an alle gesendet, um sie darüber zu informieren.", wQe = "Diese Eingabe wird bei der Buchung dieses Termins angezeigt", kQe = "Termin-URL ist in der Bestätigungsmail", SQe = "URL muss mit http:// oder https:// beginnen", xQe = "Telefonnummer wird angegeben", EQe = "vor Beginn des Termins", TQe = "wenn der Termin abgesagt wird", AQe = "Nachdem die Gastgeber nicht am Cal-Video teilgenommen haben", CQe = "Nachdem die Gäste nicht am Cal-Video teilgenommen haben", zQe = "Am Videoanruf teilnehmen", OQe = "Bei Cal.com anmelden", PQe = "Bei Cal.com anmelden", IQe = "Verfolgen Sie Ihre Meetings, erhalten Sie Benachrichtigungen und verwalten Sie Ihren Zeitplan effektiver.", RQe = "Verfolge deine Meetings und verwalte deinen Zeitplan effektiver", NQe = "Beitritt zum Anruf fehlgeschlagen. Bitte versuche es erneut.", DQe = "Wählen Sie, wie Sie an diesem Anruf teilnehmen möchten", MQe = "Wähle, wie du im Anruf erscheinen möchtest", LQe = "wenn ein neuer Termin gebucht wird", qQe = "E-Mail an den Veranstalter senden", jQe = "E-Mail an Teilnehmende senden", FQe = "SMS an Teilnehmende senden", VQe = "SMS an eine bestimmte Nummer senden", BQe = "Senden Sie Meeting-Erinnerungen einfach per SMS an Ihre Teilnehmer", UQe = "WhatsApp-Nachricht an eine bestimmte Nummer senden", WQe = "WhatsApp-Nachricht an Teilnehmer senden", GQe = "Workflows", HQe = "Neuer Workflow", KQe = "Wie möchtest du beginnen?", YQe = "Einen neuen Workflow hinzufügen", ZQe = "wenn das Ereignis neu geplant wird", QQe = "Auslöser", JQe = "Auslöser", XQe = "Aktion", eJe = "Workflows erstellen, um Benachrichtigungen und Erinnerungen zu automatisieren", tJe = "Workflow-Name", nJe = "Eigener Workflow", oJe = "{{workflowName}} erfolgreich erstellt", rJe = "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?", iJe = "Workflow löschen", aJe = "Ja, Workflow löschen", sJe = "Workflow erfolgreich gelöscht", cJe = "Wie lange bevor das Ereignis beginnt?", lJe = "Tage", dJe = "Stunden", uJe = "Minuten", _Je = "Min", pJe = "Std", mJe = "Erstellen Sie Ihren ersten Workflow", fJe = "Workflows ermöglichen Ihnen das automatisierte Versenden von Erinnerungen und Benachrichtigungen.", gJe = "Aktiv am", hJe = "{{workflowName}} Workflow erfolgreich aktualisiert", vJe = "Dies ist ein Standard-Benutzername und die Aktualisierung führt Sie zur Rechnungsstellung, um ein Downgrade durchzuführen.", bJe = "Dies ist ein Premium-Benutzername, holen Sie sich Ihren für {{price}}", yJe = "Aktuell", $Je = "Premium", wJe = "Standard", kJe = "Änderung des Benutzernamens bestätigen", SJe = "Da Sie von einem Standard- zu einem Premium-Benutzernamen wechseln, werden Sie zum Upgrade zur Kasse gebracht.", xJe = "Da Sie von einem Premium- zu einem Standard-Benutzernamen wechseln, werden Sie zum Downgrade zur Kasse gebracht.", EJe = "Zur Abrechnung", TJe = "Zahlung für Buchungen (0,5 % + 0,10 € Provision pro Transaktion)", AJe = "Ihre Testversion ist abgelaufen", CJe = "App entfernen", zJe = "Ja, App entfernen", OJe = "Sind Sie sicher, dass Sie diese App entfernen möchten?", PJe = "App erfolgreich entfernt", IJe = "Fehler beim Entfernen der App", RJe = "Webkonferenz", NJe = "Web-Anruf", DJe = "Web-Anruf starten", MJe = "Anruf beenden", LJe = "Testen Sie Ihren Agenten mit einem Web-Anruf ohne Telefonnummer", qJe = "Telefonanruf", jJe = "Verbindung zum Agenten wird hergestellt...", FJe = "Anruf aktiv", VJe = "Anruf beendet", BJe = "Anruffehler", UJe = "Bereit zum Starten des Anrufs", WJe = "Web-Anruf konnte nicht gestartet werden. Bitte versuchen Sie es erneut.", GJe = "Bei dem Anruf ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", HJe = "Web-Anruf konnte nicht initialisiert werden. Bitte stellen Sie sicher, dass Mikrofonberechtigungen erteilt wurden.", KJe = "Starten Sie einen Anruf, um die Konversation zu sehen", YJe = "Warte auf Konversation...", ZJe = "KI-Agent", QJe = "Live", JJe = "Verbinde...", XJe = "Erfordert Bestätigung", eXe = "Erfordert eine Bestätigung bei Buchung mit < {{time}} $t({{unit}}_timeUnit) Vorlauf", tXe = "Kann Bestätigung erfordern", nXe = "{{count}} Ereignistyp", oXe = "{{count}} Ereignistypen", rXe = "{{count}} Team", iXe = "{{count}} Teams", aXe = "Aktion hinzufügen", sXe = "Whereby Link festlegen", cXe = "Bitte geben Sie einen gültigen Whereby Link ein", lXe = "Around.Co Link festlegen", dXe = "Bitte geben Sie einen gültigen Around Link ein", uXe = "Riverside Link festlegen", _Xe = "Bitte geben Sie einen gültigen Riverside Link ein", pXe = "Bitte geben Sie einen gültigen Ping.gg Link ein", mXe = "Exchange 2013-Server verbinden", fXe = "Exchange 2016-Server verbinden", gXe = "Benutzerdefinierte Vorlage", hXe = "Inhalt", vXe = "Textnachricht", bXe = "Haben Sie ein spezielles Problem", yXe = "Durchsuchen Sie unsere Dokumentation", $Xe = "Vorlage auswählen", wXe = "Benutzerdefiniert", kXe = "Erinnerung", SXe = "Neu geplant", xXe = "Neu geplant von", EXe = "Ursprüngliche Buchung", TXe = "Erledigt", AXe = "Bewertung", CXe = "Erinnerung: {{eventType}} mit {{name}} bei {{date}}", zXe = "Wird nicht für bereits bestehende Buchungen ausgelöst, da der Benutzer bei der Buchung nach einer Telefonnummer gefragt wird.", OXe = "{{count}} Minute", PXe = "{{count}}m", IXe = "{{count}} Minuten", RXe = "{{count}} Stunde", NXe = "{{count}}h", DXe = "{{count}} Stunden", MXe = "Ungültige Eingabe", LXe = "Wir konnten den {{location}}-Meeting-Link nicht zu deinem geplanten Ereignis hinzufügen. Kontaktiere deine Eingeladenen oder aktualisiere deinen Kalendereintrag, um die Details hinzuzufügen. Du kannst entweder <0>deinen Standort im Ereignistyp ändern</0> oder versuchen, <1>die App zu entfernen und erneut hinzuzufügen.</1>", qXe = "Wir konnten Ihren <1>{{calendar}}</1> nicht aktualisieren. <2> Bitte überprüfen Sie die Kalendereinstellungen oder entfernen Sie Ihren Kalender und fügen Sie Ihren Kalender erneut hinzu </2>", jXe = "Name des Teilnehmenden", FXe = "Der vollständige Name der buchenden Person", VXe = "Defekte Integration", BXe = "Beim Hinzufügen eines Video-Links ist ein Problem aufgetreten", UXe = "Es gab ein Problem beim Aktualisieren Ihres Kalenders", WXe = "Aktiv bei {{count}} Ereignistyp", GXe = "Aktiv bei {{count}} Termintypen", HXe = "Aktiv in {{count}} Team", KXe = "Aktiv in {{count}} Teams", YXe = "Aktiv für alle Ereignistypen", ZXe = "Aktiv in allen Teams", QXe = "Keine aktiven Termintypen", JXe = "Keine aktiven Teams", XXe = "Neuer Teilnehmer {{name}} beim {{eventType}} am {{date}}", eet = "Jemand hat sich zu einem Ereignis hinzugefügt", tet = "Variable", net = "Event Name", oet = "Teilnehmer", ret = "Event Datum", iet = "Event Zeit", aet = "Organisator Name", set = "Um diese Funktion nutzen zu können, müssen Sie ein Upgrade auf einen Pro-Account durchführen.", cet = "Ungültige Telefonnummer", det = "Ungültige URL für {{label}}. Beispiel-URL: {{sampleUrl}}", uet = "Navigieren", _et = "Öffnen", pet = "Schließen", met = "Upgraden", fet = "US-Nummer für {{priceInDollars}}$/Monat kaufen", get = "Upgraden, um auf Aufnahmen zuzugreifen", het = "Aufnahmen sind nur als Teil unseres Teams-Plans verfügbar. Sie müssen upgraden, um Ihre Anrufe aufzuzeichnen", vet = "Führen Sie ein Upgrade zum Enterprise-Plan durch, um eine KI-Agent-Telefonnummer zu generieren, die Gäste anrufen und Anrufe planen kann", bet = "Aufnahmen sind Teil des Teams-Plans", yet = "Dies ist eine Team-Funktion. Sie müssen auf die Team-Version upgraden, um die Verfügbarkeit Ihres Teams zu sehen.", $et = "Dies ist eine Team-Funktion. Sie müssen auf die Team-Version upgraden, um Ihre Termin-Benachrichtigungen und Erinnerungen mit Workflows zu automatisieren.", wet = "Im Profil anzeigen", ket = "Einbetten", xet = "Neuer Benutzername", Eet = "Aktueller Benutzername", Tet = "Beispiel 1", Aet = "Beispiel 2", Cet = "Buchungsfragenbezeichner", zet = "Unternehmensgröße", Oet = "Wobei benötigen Sie Hilfe?", Pet = "Variablenformat", Iet = "Webhook Abonnenten-URL ist bereits definiert", Ret = "Ignorieren Sie alle Sonderzeichen der zusätzlichen Eingabebezeichnung (verwenden Sie nur Buchstaben und Zahlen), schreiben Sie alle Buchstaben groß und ersetzen Sie Leerzeichen durch Unterstriche.", Net = "Wie verwende ich Buchungsfragen als Variablen?", Det = "Desktop-App herunterladen", Met = "Ping-Link festlegen", Let = "Anmeldeversuchsgrenze überschritten", qet = "Wenn etwas passiert", jet = "Eine Aktion wird ausgeführt", Fet = "Aktion testen", Vet = "Benachrichtigung gesendet", Bet = "Kein Input", Uet = "Workflow-Aktion testen", Wet = "SMS versenden", Get = "Sind Sie sicher, dass Sie eine SMS an {{number}} senden möchten?", Het = "Kein Kalender verknüpft", Ket = "Sie können Ihren Kalender von <1>hier</1> verbinden.", Yet = "Standardkalender", Zet = "Im Profil ausblenden", Qet = "Termin-Einrichtung", Jet = "Keine Verfügbarkeit im Zeitplan gefunden", Xet = "Limits", ett = "Wie oft können Sie gebucht werden", ttt = "Kalendereinstellungen & mehr...", ntt = "Erweitert", ott = "Zahlungen für Veranstaltung einrichten", rtt = "Terminkonfiguration: Mehrere Laufzeiten erfordern mindestens eine Option.", itt = "Termineinrichtung: Bitte wählen Sie eine gültige Standarddauer.", att = "Die Buchungslimits müssen in aufsteigender Reihenfolge sein. [Tag, Woche, Monat, Jahr]", stt = "Die Zeitlimits müssen aufsteigend sortiert sein. [Tag, Woche, Monat, Jahr]", ctt = "Wählen Sie den Kalender aus, zu dem Termine hinzugefügt werden sollen", ltt = "Eigener Terminname", dtt = "Erstellen Sie benutzerdefinierte Terminnamen, die im Kalendereintrag angezeigt werden sollen", utt = "Falscher Zwei-Faktor-Authentifizierungscode", _tt = "Auf welchen Termintyp wird dies angewandt?", ptt = "Auf alle anwenden, einschließlich zukünftiger Ereignistypen", mtt = "Auf alle Team- und Benutzer-Ereignistypen anwenden", ftt = "Für welches Team soll dies gelten?", gtt = "Workflows ermöglichen die einfache Automatisierung des Versands von Benachrichtigungen und Erinnerungen, so dass Sie Prozesse rund um Ihre Termine erstellen können.", htt = "Dies ist eine interne Einstellung, die keinen Einfluss darauf hat, wie die Zeiten auf den öffentlichen Buchungsseiten für Sie oder jemanden, der Sie buchen möchte, angezeigt werden.", vtt = "Einen Workflow erstellen", btt = "Mache dies", ytt = "Abschalten", $tt = "Einschalten", wtt = "Stornierte Buchungen können nicht verschoben werden", ktt = "Einstellungen erfolgreich aktualisiert", Stt = "Fehler beim Aktualisieren der Einstellungen", xtt = "Meine persönliche {{appName}}-URL", Ett = "Schreiben Sie eine kurze Beschreibung, welche auf Ihrer persönlichen Profil-Seite erscheinen wird.", Ttt = "Einrichtung abschließen und loslegen", Att = "Dieser Benutzer hat noch keine Bio hinzugefügt.", Ctt = "Biografie", ztt = "Account löschen", Ott = "Sind Sie sicher, dass Sie Ihr {{appName}}-Konto löschen möchten?", Ptt = "Meinen Account löschen", Itt = "Wochenstart", Rtt = "Aufnahmen", Ntt = "Aufnahme", Dtt = "Fröhliche Terminplanung", Mtt = "Wählen Sie aus, in welchen Kalendern Sie nach Konflikten suchen wollen, um Doppelbuchungen zu vermeiden.", Ltt = "Auf Konflikte prüfen", qtt = "Aufnahmen anzeigen", jtt = "Nach Aufnahmen suchen", Ftt = "Termine hinzufügen zu", Vtt = "Systemeinstellungen folgen", Btt = "Eigene Marken-Farben", Utt = "Passen Sie Ihre eigene Markenfarbe auf Ihrer Buchungsseite an.", Wtt = "Pro", Gtt = "Entfernt alle {{appName}}-bezogenen Markenzeichen, z. B. „Powered by {{appName}}.“", Htt = "Sofortiges Meeting mit {{name}}", Ktt = "Profilbild", Ytt = "Upload", Ztt = "Profilbild hinzufügen", Qtt = "Adresse des Token", Jtt = "Blockchain", Xtt = "Altes Passwort", ent = "Ihr sicheres neues Passwort", tnt = "Fehler beim aktualisieren des Passworts", nnt = "Zwei-Faktor-Authentifizierung", ont = "Einen wiederholenden Zeitplan einrichten", rnt = "heute", int = "Darstellung", ant = "Mein Account", snt = "Allgemein", cnt = "Kalender", lnt = "Rechnungen", dnt = "Embeds", unt = "Benutzeridentitätswechsel", _nt = "Einstellungen zur Verwaltung der Benutzeridentifikation", pnt = "Letzte Identitätswechsel", mnt = "Schneller Identitätswechsel", fnt = "Keine kürzlichen Identitätswechsel", gnt = "Benutzer", hnt = "Benutzer", vnt = "Einstellungen für Ihr {{appName}} Profil verwalten", bnt = "Hier finden Sie eine Liste aller Benutzer", ynt = "Benutzer-Listing", $nt = "Einstellungen für Ihre Sprache und Zeitzone verwalten", wnt = "Konfigurieren Sie, wie Ihre Event-Typen mit Ihren Kalendern interagieren sollen", knt = "Einstellungen für Ihre Buchungsdarstellung verwalten", Snt = "Fügen Sie Ihre favorisierten Videokonferenz-Apps für Ihre Meetings hinzu", xnt = "Konferenz-App hinzufügen", Ent = "Einstellungen für Ihre Konto-Passwörter verwalten", Tnt = "Zwei-Faktor-Authentifizierung einrichten", Ant = "Wir benötigen nur ein paar grundlegende Informationen, um Ihr Profil einzurichten.", Cnt = "Überspringen", znt = "Später machen", Ont = "Zeiträume definieren, in denen Sie verfügbar sind", Pnt = "Sie können dies alles später auf der Verfügbarkeitsseite anpassen.", Int = "Verbinden Sie zuerst einen Kalender", Rnt = "Vervollständigen Sie Ihr Profil", Nnt = "Sie können weitere Kalender aus dem App-Store hinzufügen", Dnt = "Konferenz-Apps verbinden", Mnt = "Kalender-Apps verbinden", Lnt = "Zahlungs-Apps verbinden", qnt = "Automatisierungs-Apps verbinden", jnt = "Analyse-Apps verbinden", Fnt = "Andere Apps verbinden", Vnt = "Nachrichten-Apps verbinden", Bnt = "CRM-Apps verbinden", Unt = "Schritt {{currentStep}} von {{maxSteps}}", Wnt = "Variable hinzufügen", Gnt = "Benutzerdefinierte Telefonnummer", Hnt = "Nachrichtenvorlage", Knt = "Betreff", Ynt = "Dynamische Textvariablen hinzufügen", Znt = "Name des Ereignistyps", Qnt = "Das Datum der Veranstaltung", Jnt = "Die Dauer des Ereignisses", Xnt = "Die Startzeit des Termins", eot = "Ereignistyp nicht gefunden", tot = "Anzurufende Nummer", not = "Die Telefonnummer des Benutzers, den du anrufst", oot = "Ort", rot = "Der Ort des Events", iot = "Zusätzliche Notizen", aot = "Die zusätzlichen Anmerkungen der Buchung", sot = "Name der buchenden Person", cot = "Name des Organisators", lot = "An", dot = "{{workflowName}} Workflow erfolgreich {{offOn}}geschaltet", uot = "Antworten herunterladen", _ot = "Laden Sie alle Antworten zu Ihrem Formular im CSV-Format herunter.", pot = "Antworten anzeigen", mot = "Herunterladen", fot = "Wird heruntergeladen", got = "Aufnahme herunterladen", hot = "Transkriptionen sind jetzt aktiviert", vot = "Transkriptionen werden jetzt gestoppt", bot = "Transkript herunterladen", yot = "Transkript", $ot = "Eine Aufnahme von Ihrem letzten Anruf auf {{appName}} steht zum Download bereit", wot = "Transkript von Ihrem letzten Anruf bei {{appName}} ist zum Herunterladen bereit. Links sind nur für 1 Stunde gültig", kot = "Sie können das Protokoll auch aus den Anhängen herunterladen", Sot = "Hinweis: Der Download-Link ist nur für 12 Stunden gültig. Sie können einen neuen Downloadlink durch das Befolgen der Anweisungen <1>hier</1> generieren.", xot = "Hinweis: Der Download-Link ist nur 12 Stunden gültig. Sie können einen neuen Download-Link generieren, indem Sie den Anweisungen folgen.", Eot = "Erstellen Sie Ihr erstes Formular", Tot = "Mithilfe von Leitungsformularen können Sie qualifizierende Fragen stellen und zur richtigen Person oder zum richtigen Veranstaltungstyp weiterleiten.", Aot = "Erstellen Sie Ihren ersten Webhook", Cot = "Mit Webhooks können Sie Meetingdaten in Echtzeit erhalten, sobald etwas in {{appName}} passiert.", zot = "Für maximal", Oot = "Ereignis", Pot = "Termine", Iot = "Einstellungen für Ihr Teamprofil verwalten", Rot = "Einstellungen für Ihr Organization-Profil verwalten", Not = "Benutzer in der Gruppe", Dot = "Administratoren und Mitglieder in Ihrer Organization verwalten", Mot = "Team-URL", Lot = "Teammitglieder", qot = "Mehr", jot = "Cal.ai Arbeitsabläufe", Fot = "und {{count}} mehr", Vot = "Wir betrachten die mobile Anwendung als Erweiterung der Web-Anwendung. Wenn Sie komplizierte Aktionen durchführen, verwenden Sie bitte die Web-Anwendung.", Bot = "Eine Erinnerung per Mail an die Teilnehmer verschicken, 24 Stunden bevor das Event startet", Uot = "Eine Erinnerung per SMS an die Teilnehmer verschicken, eine Stunde bevor das Event startet", Wot = "Benutzerdefinierte E-Mail senden, wenn der Termin zum Moderieren gebucht wird", Got = "Eine Erinnerung per SMS an die Teilnehmer verschicken, 24 Stunden bevor das Event startet", Hot = "Benutzerdefinierte E-Mail senden, wenn der Termin zum Moderieren neu geplant wird", Kot = "Benutzerdefinierte SMS senden, wenn der Termin zum Moderieren gebucht wird", Yot = "SMS-Erinnerung senden", Zot = "24 Stunden vor Terminbeginn", Qot = "Nachfassen bei Nichterscheinen", Jot = "30 Minuten nach Terminende", Xot = "Teilnehmer erinnern, Ausweis mitzubringen", ert = "1 Tag vor Terminbeginn", trt = "E-Mail-Erinnerung", nrt = "1 Stunde vor Terminbeginn", ort = "Benutzerdefinierte SMS-Erinnerung", rrt = "Wenn Termin geplant wird", irt = "Benutzerdefinierte E-Mail-Erinnerung", art = "Termin wird für Gastgeber umgeplant", srt = "Buchungszahlen von verwalteten Ereignistypen einbeziehen", crt = "Willkommen bei {{appName}}!", lrt = "Du kannst dies später bearbeiten.", drt = "Ich verbinde meinen Kalender später", urt = "Beim Speichern Ihrer Daten ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.", _rt = "Fehlende Plätze kaufen", prt = "Zeitfensterlänge", mrt = "Darstellung der Buchungsseite", frt = "Einstellungen für die Buchungsdarstellung Ihres Teams verwalten", grt = "Einstellungen für die Buchungsdarstellung Ihrer Organisation verwalten", hrt = "Nur der Besitzer dieses Teams kann Änderungen an den Buchungen des Teams vornehmen ", vrt = "Entfernt alle {{appName}}-bezogenen Markenzeichen, z. B. „Powered by {{appName}}“", brt = "{{teamName}} hat Sie eingeladen, dem Team als {{role}} beizutreten", yrt = "Token ist entweder ungültig oder abgelaufen.", $rt = "Buchung anzeigen", wrt = "Mit Microsoft Exchange verbinden", krt = "Authentifizierungsmethode", Srt = "Basisauthentifizierung", xrt = "NTLM-Authentifizierung", Ert = "GZip-Kompression", Trt = "Exchange Version", Art = "2007 SP1", Crt = "2010", zrt = "2010 SP1", Ort = "2010 SP2", Prt = "2013", Irt = "2013 SP1", Rrt = "2015", Nrt = "2016", Drt = "Weiterleitung", Mrt = "Erstellen Sie Formulare , um Teilnehmer zu den richtigen Stellen weiterzuleiten", Lrt = "E-Mail an Eigentümer senden", qrt = "Sendet eine E-Mail an den Eigentümer, wenn das Formular abgeschickt wird", jrt = "E-Mail senden an", Frt = "Neues Formular hinzufügen", Vrt = "Neues Formular zu Ihrem Team hinzufügen", Brt = "Erstellen Sie Ihre erste Weiterleitung", Urt = "Anhand der Formularantworten an die richtige Person weiterleiten", Wrt = "Formular", Grt = "Erstellen Sie Ihr Formular, um einen Bucher zu anzuleiten", Hrt = "Link in Formular kopieren", Krt = "Design der Buchungsseite", Yrt = "Dies gilt nur für Ihre öffentlichen Buchungsseiten", Zrt = "Dashboard-Design", Qrt = "Dies gilt nur für Ihr eingeloggtes Dashboard", Jrt = "Systemstandard", Xrt = "Team hinzufügen", eit = "Erhalten Sie Meetingdaten in Echtzeit, wenn etwas in {{appName}} passiert", tit = "Löst aus, wenn", nit = "Bitte führen Sie einen Pingtest vor der Erstellung durch.", oit = "Webhook aktivieren", rit = "Webhook hinzufügen", iit = "Webhook gespeichert", ait = "Generieren Sie API-Schlüssel für den Zugriff auf Ihren eigenen Account", sit = "Neuer API-Schlüssel", cit = "Aktiv", lit = "API-Schlüsselname aktualisiert", dit = "Fehler beim Aktualisieren des API-Schlüsselnamens", uit = "HTML iframe-Einbettung", _it = "Alle Event-Typen auf Ihrer Website einbetten", pit = "Erstellen Sie Ihren ersten API-Schlüssel", mit = "API-Schlüssel erlauben es anderen Apps, mit {{appName}} zu kommunizieren", fit = "Zurück zur Anmeldung", git = "Zurücksetzungslink gesendet", hit = "Eine E-Mail mit Anweisungen zum Zurücksetzen deines Passworts ist unterwegs an {{email}}.", vit = "Falls Sie nicht bald eine E-Mail erhalten, überprüfen Sie, ob die eingegebene E-Mail-Adresse korrekt ist. Überprüfen Sie außerdem Ihren Spam-Ordner oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.", bit = "Passwort aktualisiert!", yit = "Zahlung ausstehend", $it = "Offene Einladungen", wit = "Ausstehende Organisationseinladungen", kit = "Nicht auf {{appName}}", Sit = "Kein Kalender installiert", xit = "Sie haben noch keinen Ihrer Kalender verbunden", Eit = "Kalender hinzufügen", Tit = "Möglicherweise müssen Sie sich ab- und wieder anmelden, um Änderungen wirksam zu sehen.", Ait = "Bitte bestätigen Sie Ihr Passwort, bevor Sie Ihre E-Mail-Adresse ändern", Cit = "Plätze", zit = "Jede App, die im {{appName}} App Store veröffentlicht wird, ist Open Source und gründlich durch Peer Reviews getestet. {{companyName}} unterstützt oder zertifiziert diese Apps jedoch nicht, es sei denn, sie werden von {{appName}} selbst veröffentlicht. Wenn Sie auf unangemessene Inhalte oder Verhaltensweisen stoßen, melden Sie diese bitte.", Oit = "App melden", Pit = "Buchungsfrequenz begrenzen", Iit = "Begrenzen, wie oft dieses Ereignis gebucht werden kann", Rit = "Nur den ersten verfügbaren Zeitslot pro Tag anzeigen", Nit = "Dies beschränkt Ihre Verfügbarkeit für diesen Ereignistyp auf einen Zeitslot pro Tag, der zum frühestmöglichen Zeitpunkt geplant wird.", Dit = "Gesamtbuchungsdauer beschränken", Mit = "Begrenzt die Gesamtanzahl, die dieser Termin gebucht werden kann", Lit = "Limit für aktive Buchungen pro Bucher", qit = "Begrenze die Anzahl der aktiven Buchungen, die ein Bucher für diesen Termintyp vornehmen kann", jit = "Wiederkehrende Termine unterstützen keine Buchungslimits pro Bucher", Fit = "Begrenzung hinzufügen", Vit = "Teamname erforderlich", Bit = "Teilnehmerinformationen zwischen Gästen teilen", Uit = "Anzahl der verfügbaren Plätze anzeigen", Wit = "Wie verwendet man Buchungsfragen als Variablen?", Git = "Format", Hit = "Fragen", Kit = "Alle Informationen, die dein Bucher vor der Buchung angeben sollte.", Yit = "Großbuchstaben für alle Buchstaben verwenden", Zit = "Leerzeichen durch Unterstriche ersetzen", Qit = "Plattform-Mitglieder", Jit = "Verwalten Sie die Administratoren und Mitglieder in Ihrem Plattform-Team", Xit = "Plattform-Abrechnung", eat = "Abrechnung verwalten", tat = "Alles zur Abrechnung verwalten", nat = "Sie verwenden derzeit den KOSTENLOSEN Plan", oat = "In Teams arbeitet man am Besten. Erweitern Sie Ihre Arbeitsabläufe mit Rundlauf und kollektiven Veranstaltungen und erstellen Sie erweiterte Leitungsformulare", rat = "Jetzt ausprobieren", iat = "Abrechnungsportal", aat = "Support kontaktieren", sat = "Ignorieren Sie Sonderzeichen in Ihrem Buchungsfragenbezeichner. Verwenden Sie nur Buchstaben und Zahlen", cat = "Erneut versuchen", lat = "Beim Abrufen Ihrer Kalender ist ein Problem aufgetreten. Bitte <1>versuchen Sie es erneut</1> oder wenden Sie sich an den Support.", dat = "Kalenderverbindung fehlgeschlagen", uat = "Buchungsbestätigung erfolgreich", _at = "Buchungsablehnung erfolgreich", pat = "Diese Buchung ist vorläufig", mat = "Hoppla, ich möchte akzeptieren", fat = "Wir werden dies nicht erneut anzeigen", gat = "Die Zeitzone konnte nicht aktualisiert werden", hat = "Zeitzone auf {{formattedCurrentTz}} aktualisiert", vat = "Zeitzone aktualisieren", bat = "Zeitzone aktualisieren?", yat = "Ihre lokale Zeitzone scheint sich zu {{formattedCurrentTz}} geändert zu haben. Es ist sehr wichtig, die richtige Zeitzone zu haben, um Buchungen zu unerwünschten Zeiten zu verhindern. Möchten Sie sie aktualisieren?", $at = "Nicht aktualisieren", wat = "Zusätzliche Notizen erforderlich", kat = "Zusätzliche Notizen bei der Buchung erforderlich machen", Sat = "eine E-Mail an eine bestimmte E-Mail-Adresse senden", xat = "nach Ende des Termins", Eat = "wenn eine Buchung abgelehnt wird", Tat = "wenn eine Buchung angefragt wird", Aat = "wenn eine Buchungszahlung eingeleitet wird", Cat = "wenn eine Buchungszahlung erfolgreich ist", zat = "wenn ein Nichterscheinen bei einer Buchung aktualisiert wird", Oat = "Wie lange nach Ende des Termins?", Pat = "Wie lange nachdem Gastgeber nicht zum Cal-Video-Meeting erscheinen?", Iat = "Wie lange nachdem Gäste nicht zum Cal-Video-Meeting erscheinen?", Rat = "Wie viele Minuten nachdem die Teilnehmer nicht zum Cal-Video-Meeting erscheinen?", Nat = "Keine verfügbaren Plätze", Dat = "Zeit verfügbar", Mat = "Kannst du nicht die richtige Konferenz-App finden? Besuche unseren <0>App Store</0>.", Lat = "Neue Kalender-App installieren", qat = "Telefonnummer für die Buchung des Termins erforderlich machen", jat = "{{eventTypeTitle}} | Verfügbarkeit", Fat = "Fehler beim Bearbeiten der Verfügbarkeit", Vat = "Ihnen fehlt die Berechtigung, auf diese Ressource zuzugreifen.", Bat = "Bitte fügen Sie die SAML-Metadaten von Ihrem SAML-Anbieter hier ein", Uat = "Bitte geben Sie eine E-Mail ein, damit wir Ihren SAML Anbieter finden können", Wat = "Einzelheiten zum Dienstanbieter", Gat = "Ihr Identitätsanbieter (IdP) bittet Sie um die folgenden Details, um die Konfiguration der SAML Anwendung abzuschließen.", Hat = "ACS-URL", Kat = "SP-Entitäts-ID", Yat = "ACS-URL kopiert!", Zat = "SP-Entitäts-ID kopiert!", Qat = "Kalender hinzufügen", Jat = "Zukünftige Termine begrenzen", Xat = "Begrenzt, wie weit in die Zukunft dieser Termin gebucht werden kann", est = "Keine Termintypen eingerichtet", tst = "{{name}} hat keine für Sie buchbaren Termintypen eingerichtet.", nst = "Rechnungshäufigkeit", ost = "Monatlich", rst = "Jährlich", ist = "Kasse", ast = "Ihr Team wurde erfolgreich aufgelöst", sst = "Ihre Organization wurde erfolgreich aufgelöst", cst = "Fehler beim Erstellen des Teams", lst = "Sie", dst = "Oder fortfahren mit", ust = "E-Mail erneut senden", _st = "Mitglied wurde bereits eingeladen", pst = "Benutzername wird bereits verwendet", mst = "E-Mail oder Benutzername eingeben", fst = "E-Mail-Adresse eingeben", gst = "E-Mail-Adressen eingeben", hst = "Sie sind darauf beschränkt, maximal {{nbUsers}} Benutzer gleichzeitig einzuladen.", vst = "Dieser Name ist bereits vergeben", bst = "Team-Name muss eingegeben werden", yst = "Team-URL muss eingegeben werden", $st = "Diese URL ist bereits vergeben", wst = "Es gab ein Problem bei der Registrierung der Subdomain, bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator", kst = "Team veröffentlichen", Sst = "Telefonnummer (Textbenachrichtigungen)", xst = "Telefonnummer (SMS-Benachrichtigungen)", Est = "Teilnehmer E-Mail", Tst = "Die E-Mail-Adresse der buchenden Person", Ast = "Buchungs-UID", Cst = "Geben Sie einen Befehl ein oder suchen Sie ...", zst = "Oh nein! Es sieht so aus, als ob die Berechtigung abgelaufen ist oder entzogen wurden. Bitte erneut installieren.", Ost = "App neu installieren", Pst = "Verlegungsgrund", Ist = "Gemeinsamen Zeitplan auswählen", Rst = "Aktivieren Sie dies, wenn Sie einen gemeinsamen Zeitplan für alle Gastgeber verwenden möchten. Wenn deaktiviert, wird jeder Gastgeber basierend auf seinem Standardzeitplan oder seinem gewählten Zeitplan gebucht.", Nst = "Grund", Dst = "Absender-ID", Mst = "Nur Buchstaben, Zahlen und Leerzeichen erlaubt (max. 11 Zeichen)", Lst = "Testweiterleitungsformular", qst = "Vorschau testen", jst = "Weiterleiten zu", Fst = "Testen Sie Ihr Weiterleitungsformular, ohne Daten zu senden", Vst = "Testweiterleitung", Bst = "Ein Administrator hat eine Zahlungs-App deaktiviert", Ust = "Termintyp bearbeiten", Wst = "Diese Organisation ist privat und nur der Administrator oder Eigentümer der Organisation kann ihre Mitglieder sehen.", Gst = "Nur der Administrator oder Eigentümer der Organisation kann die SSO-Einstellungen verwalten", Hst = "Nur der Administrator oder Inhaber der Organisation kann die Verzeichnissynchronisierungseinstellungen verwalten", Kst = "Nur der Administrator oder Inhaber der Organisation kann OAuth-Clients verwalten", Yst = "Kollektive Terminplanung", Zst = "Machen Sie es einfach, Ihr Team zu buchen, wenn jeder verfügbar ist.", Qst = "Finden Sie die beste verfügbare Person und rotieren Sie durch Ihr Team.", Jst = "Festgelegter Round Robin", Xst = "Fügen Sie einen festen Teilnehmer und einen Round Robin mit einer Reihe von Teilnehmern hinzu.", ect = "{{appName}} ist mit Teams noch besser", tct = "Das {{companyName}}-Team", nct = "Fügen Sie Ihre Teammitglieder zu Ihren Termintypen hinzu. Nutzen Sie kollektive Planung, um alle einzubinden oder finden Sie die geeignetste Person mit der Round Robin Planung.", oct = "Das Buchungslimit für diesen Termintyp wurde erreicht", rct = "Das Zeitlimit für diesen Termintyp wurde erreicht", ict = "Ein Admin hat {{appName}} deaktiviert", act = "Dies deaktiviert alle E-Mails an {{recipient}}. Dies umfasst Buchungsbestätigungen, Anfragen, Umbuchungen und Umbuchungsanfragen, Stornierungsmails und alle anderen E-Mails im Zusammenhang mit Buchungsaktualisierungen.<br /><br />Es liegt in deiner Verantwortung sicherzustellen, dass deine {{recipient}} über alle Buchungen und Änderungen ihrer Buchungen informiert sind.", sct = "Ein Admin hat {{appName}} deaktiviert, was Ihren Termintyp {{eventType}} betrifft", cct = "Ein Admin hat einen Ihrer Ereignistypen ersetzt", lct = "Ein Teamadministrator hat Ihr Ereignis ersetzt /{{slug}}", dct = "Ein Administrator im <strong>{{teamName}}</strong>-Team hat Ihren Ereignistyp <strong>/{{slug}}</strong> durch einen verwalteten Ereignistyp ersetzt, den er steuert.", uct = "Ihr Link wird weiterhin funktionieren, aber einige Einstellungen werden möglicherweise geändert. Sie können ihn bei Ereignistypen überprüfen.", _ct = "Wenn Sie Fragen zum Ereignistyp haben, wenden Sie sich bitte an Ihren Administrator.<br /><br />Fröhliche Terminplanung, <br />Das Cal.com-Team", pct = "Der Administrator hat {{appName}} deaktiviert, was Ihren Termintyp {{title}} beeinflusst. Teilnehmer können diesen Termintyp weiterhin buchen, werden aber nicht zur Zahlung aufgefordert. Sie können den Termintyp ausblenden, um dies zu verhindern, bis Ihr Administrator Ihre Zahlungsmethode wieder aktiviert.", mct = "Teilnehmer können diesen Termintyp weiterhin buchen, werden aber nicht zur Zahlung aufgefordert. Sie können den Termintyp ausblenden, um dies zu verhindern, bis Ihr Administrator Ihre Zahlungsmethode wieder aktiviert.", fct = "Der Admin hat {{appName}} deaktiviert, was Ihren Termintyp {{title}} beeinflusst.", gct = "Der Administrator hat {{appName}} deaktiviert, was Ihre Termintypen beeinflussen kann. Wenn Sie Termintypen mit {{appName}} als Ort haben, wird standardmäßig Cal Video gewählt.", hct = "{{appName}} wurde deaktiviert", vct = "Zu installierten Apps wechseln", bct = "Wenn Sie einen anderen Kalender installiert haben, werden neue Buchungen zu dem Kalender hinzugefügt. Verbinden Sie andernfalls einen neuen Kalender, damit Sie keine neuen Buchungen verpassen.", yct = "Apps aktivieren", $ct = "Apps aktivieren, die Benutzer mit {{appName}} integrieren können", wct = "Lizenz kaufen", kct = "Haben Sie bereits ein Konto?", Sct = "Ich habe bereits einen Schlüssel:", xct = "Bitte fügen Sie Ihre vorhandene CALCOM_LICENSE_KEY Umgebungsvariable hier ein.", Ect = "Lizenzschlüssel erstellen", Tct = "{{appName}} ist aktiviert", Act = "{{appName}} ist deaktiviert", Cct = "Schlüssel wurden gespeichert", zct = "App deaktivieren", Oct = "Das Deaktivieren dieser App kann Probleme mit den Interaktionen Ihrer Nutzer mit Cal verursachen", Pct = "Schlüssel bearbeiten", Ict = "Aktivieren Sie Apps für Ihre Instanz von Cal", Rct = "Eine Liste aller Benutzer in Ihrem Konto, einschließlich Name, Titel, E-Mail und Rolle.", Nct = "Hier können Sie einen neuen Benutzer hinzufügen.", Dct = "Hier können Sie einen bestehenden Benutzer bearbeiten.", Mct = "Hier können Sie eine Organisation bearbeiten.", Lct = "Neue OAuth-Clients hinzufügen", qct = "SMS-Versand für Benutzer sperren oder entsperren", jct = "Es gibt keine verfügbaren Apps", Fct = "Bitte stellen Sie sicher, dass sich unter „packages/app-store“ Apps in Ihrem Deployment befinden", Vct = "In dieser Instanz von Cal sind keine Apps aktiviert", Bct = "Es wurde noch keine App konfiguriert", Uct = "Sie können Apps in den Einstellungen aktivieren", Wct = "Bitte kontaktieren Sie Ihren Administrator", Gct = "Apps-Einstellungen", Hct = "Bitte füllen Sie dieses Feld aus", Kct = "Optionen", Yct = "Option {{index}} eingeben", Zct = "Option hinzufügen", Qct = "Dieser Standort existiert bereits. Bitte wählen Sie einen neuen Standort", Jct = "Radio", Xct = "Um Google Meet zu nutzen, müssen Sie Ihren Zielkalender auf einen Google-Kalender einstellen", elt = "Person", tlt = "Alle Buchungen", nlt = "Alle Benutzer", olt = "Alle Ereignistypen", rlt = "Ihre Buchungen", ilt = "Meeting-URL", alt = "Die URL der Meeting-Konferenz", slt = "Datumsüberschreibungen", clt = "Datumsüberschreibungen am {{date}} löschen", llt = "Fügen Sie Termine hinzu, an denen Ihre Verfügbarkeit von Ihren üblichen Geschäftszeiten abweicht.", dlt = "Überschreibungsdaten werden automatisch nach Überschreitung des Datums archiviert", ult = "Zu welchen Stunden sind Sie verfügbar?", _lt = "Zu welchen Stunden sind Sie beschäftigt?", plt = "Daten zum Überschreiben auswählen", mlt = "Ganztägig nicht verfügbar", flt = "Als nicht verfügbar markieren (Ganztägig)", glt = "An ausgewählten Daten als „nicht verfügbar“ markieren", hlt = "Überschreiben aktualisieren", vlt = "Datumsüberbrückung erfolgreich hinzugefügt", blt = "Überschreibung speichern", ylt = "{{slug}}-Kopie", $lt = "Als Standard festlegen", wlt = "Ereignistyp-Einzelheiten ausblenden", klt = "Navigation anzeigen", Slt = "Navigation ausblenden", xlt = "Bestätigungscode gesendet", Elt = "Erfolgreich bestätigt", Tlt = "Bestätigungscode falsch", Alt = "Noch nicht bestätigt", Clt = "Keine Verfügbarkeit im {{month}}", zlt = "Terminplanung ist nur bis zu {{days}} im Voraus verfügbar. Bitte schauen Sie bald wieder vorbei.", Olt = "Die Terminplanung endete am {{date}}. Bitte schauen Sie bald wieder vorbei.", Plt = "Vormonat anzeigen", Ilt = "Nächsten Monat anzeigen", Rlt = "Code senden", Nlt = "Nummer verifiziert", Dlt = "Erstellen Sie Ihren ersten Webhook für diesen Team-Ereignistyp", Mlt = "Einen Webhook für diesen Team-Ereignistyp erstellen", Llt = "Erfolgsseite deaktivieren (funktioniert nur, wenn eine Weiterleitungs-URL vorhanden ist)", qlt = "Sie sind als Admin festgelegt, benutzen allerdings ein Passwort, das kürzer als 15 Zeichen ist oder verwenden noch keine 2FA", jlt = "Ändern Sie Ihr Passwort, um Administratorzugriff zu erhalten", Flt = "Benutzername ist bereits vergeben", Vlt = "Zuordnung", Blt = "Festgelegte Veranstalter", Ult = "Festgelegte Veranstalter hinzufügen", Wlt = "Round-Robin-Veranstalter", Glt = "Anzahl der Veranstalter, die teilnehmen müssen", Hlt = "Veranstalter", Klt = "Sie müssen ein Team erstellen, um diese Funktion zu aktivieren. Klicken Sie hier, um ein Team zu erstellen.", Ylt = "Sie müssen auf unsere Enterprise-Lizenz aktualisieren, um diese Funktion zu aktivieren.", Zlt = "Neuer Teilnehmer", Qlt = "Wartet auf Genehmigung", Jlt = "Diese App erfordert eine Verbindung mit Google Calendar", Xlt = 'Für die Funktion "Zum Kalender hinzufügen" für diesen Termintyp wird ein Google Kalender benötigt, damit Meet funktioniert. Verbinde ihn <0>hier</0>.', edt = "Sie haben ein Google Calendar-Konto verbunden.", tdt = "Die Nutzung von Google Meet erfordert einen verbundenen Google Calendar", ndt = "Installation von Google Calender fortsetzen", odt = "Google Meet installieren", rdt = "Google Calendar installieren", idt = "Absendername", adt = "Teilnehmer bereits eingeladen", sdt = "Keine Aufnahmen gefunden", cdt = "Neuer Workflow für ...", ldt = "Meldungen", ddt = "Alle eingehenden Daten anzeigen und als CSV herunterladen", udt = "Teams-Plan benötigt", _dt = "Weiterleitungs-Formulare sind eine gute Möglichkeit, Ihre eingehenden Leads zur richtigen Person weiterzuleiten. Upgraden Sie auf einen Teams-Plan, um auf diese Funktion zuzugreifen.", pdt = "Wählen Sie eine Lizenz", mdt = "Cal.com enthält eine kostenlose AGPLv3-Lizenz, mit einigen Einschränkungen, die jederzeit auf eine Enterprise-Lizenz aufgerüstet werden können. Sie können später jederzeit upgraden.", fdt = "Lizenz", gdt = "AGPLv3 Lizenz", hdt = "Ihr Code muss nicht open-source bleiben", vdt = "Einfaches Neuverpacken, Rebranding und Weiterverkaufen", bdt = "Eine große Auswahl an Enterprise-Funktionen", ydt = "0,00 €/Monat", $dt = "Für immer offen & kostenlos", wdt = "Ihr Code muss open-source bleiben", kdt = "Kann nicht einfach neuverpackt, rebrandet und weiterverkauft werden", Sdt = "Keine Enterprise-Funktionen", xdt = "Enterprise-Lizenz", Edt = "Alles für einen kommerziellen Einsatzfall mit privatem Hosting, Umverpacken, Rebranding, Wiederverkauf und Zugriff auf exklusive Enterprise-Komponenten.", Tdt = "Einrichtung", Adt = "Cal.com Instanz einrichten", Cdt = "Konfigurieren", zdt = "Single Sign-On", Odt = "SAML/OIDC SSO konfigurieren und Teammitgliedern erlauben, sich mit einem Identitätsanbieter anzumelden", Pdt = "SAML/OIDC SSO konfigurieren und Organisationsmitgliedern erlauben, sich mit einem Identitätsanbieter anzumelden", Idt = "SSO mit OIDC", Rdt = "Konfigurieren Sie OIDC SSO mit einem Identitätsanbieter Ihrer Wahl.", Ndt = "OIDC-Konfiguration", Ddt = "Konfigurieren Sie die OIDC-Verbindung zu Ihrem Identitätsanbieter. Sie finden die erforderlichen Informationen in Ihrem Identitätsanbieter.", Mdt = "Callback-URL kopiert", Ldt = "SSO mit SAML", qdt = "Konfigurieren Sie SAML SSO mit Identity Provider Ihrer Wahl.", jdt = "SAML-Konfiguration", Fdt = "Konfigurieren Sie SAML-Verbindung zu Ihrem Identitätsanbieter. Sie finden die erforderlichen Informationen in Ihrem Identitätsanbieter.", Vdt = "ACS-URL kopiert", Bdt = "Entitäts-ID kopiert", Udt = "{{connectionType}}-Konfiguration erfolgreich erstellt", Wdt = "{{connectionType}}-Konfiguration erfolgreich gelöscht", Gdt = "{{connectionType}}-Konfiguration löschen", Hdt = "Ja, {{connectionType}}-Konfiguration löschen", Kdt = "Sind Sie sicher, dass Sie die {{connectionType}}-Konfiguration löschen möchten? Ihre Teammitglieder, die sich über {{connectionType}} anmelden, werden keinen Zugriff mehr auf Cal.com haben.", Ydt = "Zeitzone des Veranstalters", Zdt = "Einladung anzeigen", Qdt = "Einladung annehmen", Jdt = "Jetzt beitreten", Xdt = "Erfolgreich beigetreten", eut = "Du wurdest eingeladen, einem Team der Organisation {{parentTeamName}} beizutreten", tut = "Du wurdest eingeladen, einer {{appName}}-Organisation beizutreten", nut = "{{invitedBy}} hat Sie eingeladen, dem Team in {{appName}} beizutreten. {{appName}} ist der Event-Planer, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne ständiges hin und her zu planen.", out = "{{invitedBy}} hat Sie eingeladen, dem Team „{{teamName}}“ in seiner bzw. ihrer Organisation {{parentTeamName}} bei {{appName}} beizutreten. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.", rut = "{{invitedBy}} hat Sie eingeladen, ihrer Organisation „{{teamName}}“ in {{appName}} beizutreten. {{appName}} ist der Terminplaner, der es Ihnen und Ihrer Organisation ermöglicht, Meetings ohne ständiges hin und her zu planen.", iut = "Wir führen dich durch einige kurze Schritte und du wirst in kürzester Zeit stressfreie Terminplanung mit deinem {{entity}} genießen.", aut = "Wählen Sie Ihren Benutzernamen", sut = "Verbinden Sie Ihr Kalenderkonto", cut = "Legen Sie Ihre Verfügbarkeit fest", lut = "Treten Sie {{teamName}} bei", dut = "Fröhliche Terminplanung wünscht das {{appName}} Team", uut = "Sie sind dabei einen Benutzer zu imitieren, was bedeutet, dass Sie Änderungen in ihrem Namen vornehmen können. Bitte seien Sie vorsichtig.", _ut = "Verfügbare Variablen", put = "{Scheduler}", mut = "Keine Workflows", fut = "Ändern Sie den Filter, um Ihre eigenen und Ihre Team-Workflows anzuzeigen.", gut = "Passen Sie Ihre Filteroptionen an, um die Ergebnisse zu sehen.", hut = "Keine Ergebnisse für diesen Filter", vut = "Empfohlene nächste Schritte", but = "Einen verwalteten Ereignistyp erstellen", yut = "Meetings sind mit den richtigen Teammitgliedern besser. Laden Sie sie jetzt ein.", $ut = "Erstellen Sie eine One-on-One-Vorlage für einen Termintyp und verteilen Sie diese an mehrere Mitglieder.", wut = "Kollektiv oder Round-Robin", kut = "Buchen Sie Ihre Teammitglieder zusammen mit Kollektivveranstaltungen oder wählen Sie mit Round-Robin die richtige Person.", Sut = "Nimmt nicht mehr an {{title}} am {{date}} teil", xut = "Sie nehmen an diesem Termin nicht mehr teil", Eut = "Ein Teilnehmer nimmt nicht mehr an {{title}} am {{date}} teil", Tut = "Ein Teilnehmer nimmt nicht mehr an Ihrem Termin teil", Aut = "{{name}} hat abgesagt. Dies bedeutet, dass ein Platz in diesem Zeitfenster frei wurde", Cut = "Erstelle Termin am", zut = "Weiterleitungsformular erstellen am", Out = "Standard-App-Link festlegen", Put = "Mit dem Festlegen eines Standard-App-Links können alle neu erstellten Ereignistypen den App-Link verwenden, den Sie gesetzt haben.", Iut = "Standard-App des Organisators", Rut = "{{organizer}} hat keine Standard-Konferenz-App", Nut = "Wartungsarbeiten", Dut = "Das {{appName}} Team führt geplante Wartungsarbeiten durch. Wenn Sie Fragen haben, wenden Sie sich bitte an den Support.", Mut = "{{numberOfSeats}} Sitze", Lut = "Buchungsfragen", qut = "Passen Sie die Fragen an, die auf der Buchungsseite gefragt werden", jut = "Frage hinzufügen", Fut = "Bezeichner", Vut = "E-Mail ist doppelt vorhanden", But = "Geben Sie eine Weiterleitungs-URL ein, zu der der Teilnehmer gesendet wird, sobald er das Meeting verlässt.", Uut = "Zahlung für dieses Ereignis ist nicht mehr möglich", Wut = "Eine Rückerstattung für diese Buchungszahlung ist auf dem Weg.", Gut = "Diese Buchungszahlung wurde zurückerstattet.", Hut = "Gemäß der Rückerstattungsrichtlinie des Events ist die Buchungszahlung nicht erstattungsfähig.", Kut = "Das Rückerstattungsfenster für das Event ist abgelaufen. Daher ist die Buchungszahlung nicht erstattungsfähig.", Yut = "Buchungsbestätigung fehlgeschlagen", Zut = "Nicht genügend Plätze", Qut = "Ein Feld mit diesem Namen ist bereits vorhanden", Jut = "Das Gästefeld muss vom Typ 'Mehrere E-Mails' sein", Xut = "Auf der Buchungsseite anzeigen", e_t = "Sie können die Seite der stornierten Buchung besuchen", t_t = "Legen Sie mit Zapier-Vorlagen los", n_t = "Standardvorlagen", o_t = "Cal.ai-Vorlagen", r_t = "{{team}} ist unveröffentlicht", i_t = "Dieser Organisations-Link ist derzeit nicht verfügbar. Bitte kontaktieren Sie den Organisations-Besitzer oder fragen Sie ihn, ob er ihn veröffentlicht.", a_t = "Dieser {{entity}}-Link ist derzeit nicht verfügbar. Bitte kontaktieren Sie den {{entity}}-Besitzer oder fragen Sie ihn, ob er ihn veröffentlicht.", s_t = "Teammitglied", c_t = "Ein Weiterleitungsformular", l_t = "Formularbeschreibung", d_t = "Verbindung mit dem Formular beibehalten", u_t = "Alle Änderungen, die am Router oder an den Feldern des zu duplizierenden Formulars vorgenommen werden, spiegeln sich im Duplikat wider. Das Löschen eines Feldes entfernt es jedoch nicht aus dem Duplikat.", __t = "Formular gelöscht", p_t = "Möchten Sie dieses Formular wirklich löschen?", m_t = "Ja, Formular löschen", f_t = "Jede Person, mit der Sie den Link geteilt haben, kann nicht mehr über das Formular buchen.", g_t = "Alle zugehörigen Antworten werden gelöscht.", h_t = "Weiterleitungs-URL kopiert! Sie können jetzt die URL in Ihrem eigenen Formular einstellen.", v_t = "Änderungen in den Feldern und Weiterleitungen der folgenden Formulare werden in diesem Formular reflektiert.", b_t = "Verbundene Formulare", y_t = "Folgende Formulare wären betroffen, wenn Sie hier Felder oder Weiterleitungen ändern.", $_t = "Warten Sie einige Zeit, bis Antworten gesammelt werden. Sie können das Formular auch selbst ausfüllen.", w_t = "Dies ist, was Ihre Benutzer sehen würden", k_t = "Identifiziert Feld mit diesem Namen.", S_t = "1 Option pro Zeile hinzufügen", x_t = "Weiterleitungsformular auswählen", E_t = "Neue Route hinzufügen", T_t = "Treffen Sie mit Insights fundierte Entscheidungen", A_t = "Unser Insights-Dashboard deckt alle Aktivitäten in Ihrem Team ab und zeigt Ihnen Trends, die eine bessere Teamplanung und Entscheidungsfindung ermöglichen.", C_t = "Buchungen für alle Mitglieder anzeigen", z_t = "Sieh, wer die meisten Buchungen erhält und stelle die beste Verteilung in deinem Team sicher", O_t = "Buchungstrends erkennen", P_t = "Sehen Sie, welche Wochenzeiten und welche Tageszeiten bei Ihren Buchern beliebt sind", I_t = "Machen Sie beliebte Ereignistypen ausfindig", R_t = "Sehen Sie, welche Ihrer Ereignistypen die meisten Klicks und Buchungen erhalten", N_t = "Noch keine Antworten", D_t = "Keine Weiterleitungsrouten definiert", M_t = "Dies wird der Platzhalter sein", L_t = "Bei der Buchung dieses Termins ist ein Fehler aufgetreten, bitte aktualisieren Sie die Seite und versuchen Sie es erneut", q_t = "Kein Zeitfenster ausgewählt", j_t = "Bitte wählen Sie einen Zeitraum aus, um den Termin zu buchen.", F_t = "Zeitfenster auswählen", V_t = "Zur monatlichen Ansicht wechseln", B_t = "Zur Wochenansicht wechseln", U_t = "Zur Tagesansicht wechseln", W_t = "Zur Spaltenansicht wechseln", G_t = "{{num}} Veranstaltungsort-Optionen", H_t = "Im nächsten Schritt auswählen", K_t = "Dieses Meeting hat noch nicht begonnen", Y_t = "{{appName}} benötigt ein verbundenes {{dependencyName}}-Konto", Z_t = "{{dependencyName}} verbinden", Q_t = "{{dependencyName}} ist verbunden", J_t = "Benötigt {{dependencyName}}", X_t = "Bestätigungscode", ept = "Können Sie es zu einem anderen Zeitpunkt erneut versuchen?", tpt = "Bestätigen", npt = "Die Zeitzone der empfangenden Person", opt = "Zeitzone", rpt = "Endzeitpunkt des Termins", ipt = "Der Endzeitpunkt des Termins", apt = "Absage-URL", spt = "Die URL, um die Buchung abzusagen", cpt = "Stornierungsgrund", lpt = "Der Grund für die Stornierung der Buchung", dpt = "Umplanungs-URL", upt = "Die URL, um die Buchung umzuplanen", _pt = "Umbuchungsgrund", ppt = "Der Grund für die Umbuchung des Termins", mpt = "Es gibt eine ungültige Variable in Ihrem Terminnamen", fpt = "Alle auswählen", gpt = "Massenaktualisierung vorhandener Termintypen", hpt = "Standardverfügbarkeitsplan des Mitglieds", vpt = "Vom Team-Admin festgelegt", bpt = "Standardstandort des Mitglieds", ypt = "Wir werden den Standardverfügbarkeitsplan jedes Mitglieds verwenden. Sie können ihn bearbeiten oder ändern.", $pt = "Sie müssen mindestens einen Verfügbarkeitsplan haben", wpt = "Orte für die ausgewählten Termintypen aktualisieren", kpt = "Aktualisieren Sie die Zeitpläne für die ausgewählten Ereignistypen", Spt = "Für Mitglieder gesperrt", xpt = "Für Mitglieder freigeschaltet", Ept = "Mitglieder können die aktiven Apps sehen, können aber keine App-Einstellungen anpassen", Tpt = "Mitglieder können die aktiven Apps sehen und App-Einstellungen anpassen", Apt = "Sie können die aktiven Apps sehen, können aber keine App-Einstellungen anpassen", Cpt = "Sie können die aktiven Apps sehen und App-Einstellungen anpassen", zpt = "Mitglieder können ihre persönlichen Workflows nicht zu diesem Termintyp hinzufügen. Mitglieder können die aktiven Teamworkflows sehen, können aber keine Workflow-Einstellungen bearbeiten.", Opt = "Mitglieder werden ihre persönlichen Workflows zu diesem Termintyp hinzufügen können. Mitglieder können die aktiven Teamworkflows sehen, können aber keine Workflow-Einstellungen bearbeiten.", Ppt = "Sie werden die aktiven Team-Workflows sehen können, werden aber keine Workflow-Einstellungen ändern oder Ihre persönlichen Workflows zu diesem Termintypen hinzufügen können.", Ipt = "Sie werden ihre persönlichen Workflows bei diesem Termintyp aktivieren/deaktivieren können. Sie können die aktiven Teamworkflows sehen, können aber keine Team-Workflow-Einstellungen bearbeiten.", Rpt = "Mitglieder können diesem Ereignistyp keine persönlichen Webhooks hinzufügen. Mitglieder können die aktiven Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten.", Npt = "Mitglieder können diesem Ereignistyp ihre persönlichen Webhooks hinzufügen. Mitglieder können die aktiven Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten.", Dpt = "Sie können die aktiven verwalteten Webhooks sehen, aber keine Webhook-Einstellungen bearbeiten oder diesem Ereignistyp keine persönlichen Webhooks hinzufügen.", Mpt = "Sie können diesem Ereignistyp Webhooks hinzufügen. Sie können die aktiven verwalteten Webhooks sehen, können diese aber nicht bearbeiten.", Lpt = "Vom Team-Admin gesperrt", qpt = "Sie haben kein {{appName}}-Konto verbunden.", jpt = "Jetzt verbinden", Fpt = "{{count}} Mitglied ersetzen & benachrichtigen", Vpt = "{{count}} Mitglieder ersetzen & benachrichtigen", Bpt = "Die URL /{{slug}} wird bereits von {{count}} Mitglied genutzt. Möchten Sie sie ersetzen?", Upt = "Die URL /{{slug}} wird bereits von {{count}} Mitgliedern genutzt. Möchten Sie sie ersetzen?", Wpt = "<strong>{{names}}</strong> verwendet bereits die URL <strong>/{{slug}}</strong>-.", Gpt = "<strong>{{names}}</strong> verwenden bereits die URL <strong>/{{slug}}</strong>-.", Hpt = "Wenn Sie die URL ersetzen, werden wir sie benachrichtigen. Gehen Sie zurück und entfernen Sie sie, wenn Sie sie nicht überschreiben möchten.", Kpt = "Ereignistyp überprüfen", Ypt = "Suchen Sie nach weiteren Analysedaten?", Zpt = "Möchten Sie mehr Insights?", Qpt = "Filter", Jpt = "Filter", Xpt = "Mitglied hinzufügen", emt = "Filter hinzufügen", tmt = "Regel hinzufügen", nmt = "Regelgruppe hinzufügen", omt = "Alle Filter löschen", rmt = "E-Mail bestätigt", imt = "Benutzer auswählen", amt = "Ereignistyp auswählen", smt = "Datumsbereich auswählen", cmt = "Beliebte Termine", lmt = "Keine Ereignistypen gefunden", dmt = "Durchschnittliche Ereignisdauer", umt = "Buchungen nach Stunde", _mt = "Am häufigsten gebucht", pmt = "Am wenigsten gebucht", mmt = "Meiste geplante Buchungen", fmt = "Wenigste geplante Buchungen", gmt = "Meiste abgeschlossene Buchungen", hmt = "Wenigste abgeschlossene Buchungen", vmt = "Termine erstellt", bmt = "Termine abgeschlossen", ymt = "Termine abgesagt", $mt = "Termine neu geplant", wmt = "Termine", kmt = "Leistung", Smt = "seit dem letzten Zeitraum", xmt = "Von: {{startDate}} Bis: {{endDate}}", Emt = 'Das Hinzufügen einer Umleitung wird die Erfolgsseite deaktivieren. Erwähnen Sie "Buchung bestätigt" auf Ihrer benutzerdefinierten Erfolgsseite.', Tmt = "Ereignistrends", Amt = "Filter löschen", Cmt = "Löschen", zmt = "Halten", Omt = "Zahlung bei Buchung erhalten", Pmt = "Gebühr für das Nichterscheinen berechnen", Imt = "Karte gehalten", Rmt = "Karte belasten", Nmt = "Karte belastet", Dmt = "{{amount, currency}} Gebühr für das Nichterscheinen", Mmt = "Gebühr für das Nichterscheinen", Lmt = "Karte senden", qmt = "Zahlungsinformationen senden", jmt = "Ihr Meeting wartet auf eine Zahlungsmethode", Fmt = "Gebühr für das Nichterscheinen in Höhe von {{amount, currency}} für {{title}} am {{date}} berechnet", Vmt = "Die Gebühr für das Nichterscheinen wurde berechnet", Bmt = "Gebühr für das Nichterscheinen in Höhe von {{amount, currency}} wurde für das folgende Ereignis berechnet", Umt = "Beim Berechnen der Nichterscheinungsgebühr ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut.", Wmt = "Gebühr für das Nichterscheinen anfordern", Gmt = "Gebühr für das Nichterscheinen berechnet", Hmt = "Zahlung abgelehnt. Bitte versuchen Sie es mit einer anderen Karte oder wenden Sie sich an Ihre Bank.", Kmt = "Dieser Kartentyp wird für diesen Kauf nicht unterstützt. Bitte verwenden Sie eine andere Zahlungsmethode.", Ymt = "Der Mindestbetrag für Zahlungen beträgt 0,50 USD. Bitte erhöhen Sie Ihren Zahlungsbetrag.", Zmt = "Karte konnte nicht für die Zahlung belastet werden.", Qmt = "Erkenntnisse", Jmt = "Weiterleitungsformulare", Xmt = "Keine Daten für den ausgewählten Filter oder das ausgewählte Datum gefunden.", eft = "Ich bestätige, dass meiner Karte eine Gebühr von {{amount, currency}} berechnet wird, sofern ich nicht an diesem Ereignis teilnehme.", tft = "Tage", nft = "Karteninformationen", oft = "Bei uns ist etwas schiefgelaufen. Kontaktiere unseren Support und wir werden das Problem umgehend für dich beheben.", rft = "Bitte geben Sie den folgenden Text an, wenn Sie den Support kontaktieren, damit wir Ihnen besser helfen können", ift = "Aktuell können keine Plätze aktiviert oder eine Gebühr für das Nichterscheinen berechnet werden", aft = "Schließen Sie Ihre Buchung ab", sft = "Schließen Sie Ihre Buchung ab: {{title}} am {{date}}", cft = "Bestätigen Sie Ihre Daten", lft = "Einladungslink kopieren", dft = "Linkeinstellungen bearbeiten", uft = "Einladungslink kopiert", _ft = "Einladungslink gelöscht", pft = "API-Schlüssel gelöscht", mft = "Dies wird den API-Schlüssel dauerhaft löschen. Alle Anwendungen, die diesen Schlüssel verwenden, verlieren sofort den Zugriff auf Ihr Konto. Diese Aktion kann nicht rückgängig gemacht werden.", fft = "Einladungslink-Einstellungen gespeichert", gft = "Links verfallen nach...", hft = "1 Tag", vft = "7 Tage", bft = "30 Tage", yft = "3 Monate", $ft = "1 Jahr", wft = "Sie wurden eingeladen, ein Mitglied von {{teamName}} zu werden", kft = "{{amount, currency}}", Sft = "Sie sind im Begriff, dem Teilnehmer {{amount, currency}} in Rechnung zu stellen. Sind Sie sicher, dass Sie fortfahren möchten?", xft = "Teilnehmer {{amount, currency}} berechnen", Eft = "Zahlung erfordern ({{paymentFeePercentage}} % + {{fee, currency}} Provision pro Transaktion)", Tft = "{{email}} wurde eingeladen", Aft = "{{userCount}} Benutzer wurden eingeladen", Cft = "Kartenfehler", zft = "Das hochgeladene Bild sollte die maximale Größe von 5 MB nicht überschreiten", Oft = "{{errorCode}}: Sie sind nicht berechtigt, diesen Workflow zu aktivieren oder zu deaktivieren", Pft = "Inline-Einbettung", Ift = "Laden Sie Ihren Termintyp direkt inline mit Ihren anderen Website-Inhalten.", Rft = "Bewegliche Pop-Up-Schaltfläche", Nft = "Erstellt einen beweglichen Button auf Ihrer Website, der einen modales Dialogfenster mit Ihrem Termintypen erstellt.", Dft = "Pop-Up über Element-Klick", Mft = "Öffnet Ihren Cal-Dialog, wenn jemand ein Bedienelement anklickt.", Lft = "Eigenes Formular verwenden", qft = "Verwenden Sie unsere Headless-Routing-API und nutzen Sie Ihr eigenes Formular für Übermittlungen.", jft = "Brauchen Sie Hilfe? Sehen Sie sich unsere Anleitungen zum Einbetten von Cal auf Wix, Squarespace, oder WordPress an, schauen Sie sich unsere häufig gestellten Fragen an oder erkunden Sie erweiterte Einbettungsoptionen.", Fft = "Mich per Cal buchen", Vft = "Vorname", Bft = "Nachname", Uft = "Vorname, Nachname", Wft = "Einladen als", Gft = "Formular erfolgreich aktualisiert.", Hft = "Standardmäßige Bestätigungs-E-Mails für Teilnehmer deaktivieren", Kft = "Mindestens ein Workflow, durch den bei Buchung eine E-Mail an die Teilnehmer gesendet wird, ist für diesen Termintyp aktiv.", Yft = "Standardmäßige Bestätigungs-E-Mails für Veranstalter deaktivieren", Zft = "Mindestens ein Workflow, durch den bei Buchung eine E-Mail an den Veranstalter gesendet wird, ist für diesen Termintyp aktiv.", Qft = "Eine Überschreibung hinzufügen", Jft = "Benutzer aus Google Workspace importieren", Xft = "Google Workspace verbinden", egt = "Sie müssen ein Workspace-Admin sein, um diese Funktion nutzen zu können", tgt = "Erstellen Sie Ihren ersten Webhook für diesen Termintypen", ngt = "Erstellen Sie Ihren ersten Webhook mit „Sofortiges Meeting erstellt“ als Auslöser für diesen Ereignistyp", ogt = "App installieren auf", rgt = "Erstellen für", igt = "Währung", agt = "Schaffen Sie eine Umgebung, in der Ihre Teams gemeinsame Apps, Workflows und Termintypen mit Round-Robin- und kollektiver Planung erstellen können.", sgt = "Verwalten Sie Organizations mit mehreren Teams", cgt = "Ihre Organization einrichten", lgt = "Richten Sie Ihre Plattform ein", dgt = "Organizations sind geteilte Umgebungen, in denen Teams gemeinsame Termintypen, Apps, Workflows und mehr erstellen können.", ugt = "Pläne", _gt = "Plattform", pgt = "Verwalten Sie alles, was mit der Plattform zusammenhängt.", mgt = "Mit der Cal.com-Plattform können Sie die Terminplanung mühelos mit Hilfe von Plattform-APIs und -Atoms in Ihre App integrieren.", fgt = "Es muss ein Name für die Organization eingegeben werden", ggt = `Sie müssen Ihre Organization-Mailadresse eingeben
`, hgt = "Ihre Organization-E-Mail-Adresse", vgt = "Ihre Admin-E-Mail-Adresse", bgt = "Benutzername des Administrators", ygt = "Name der Organization", $gt = "Plattformname", wgt = "URL der Organization ", kgt = "Bestätigen Sie Ihre Organization-Mailadresse", Sgt = "Bitte verwenden Sie den folgenden Code, um Ihre E-Mail-Adresse zu bestätigen, um die Einrichtung Ihrer Organization fortzusetzen.", xgt = "Zusätzliche URL-Parameter", Egt = "Über Ihre Organization", Tgt = `Organizations sind geteilte Umgebungen, in denen Sie mehrere Teams mit gemeinsamen Mitgliedern, Termintypen, Apps, Workflows und mehr erstellen können.
`, Agt = "Erstellen Sie Ihre Teams", Cgt = "Fangen Sie an, gemeinsam zu planen, indem Sie Ihre Teammitglieder zu Ihrer Organization hinzufügen", zgt = "Laden Sie die Administratoren Ihrer Organization ein", Ogt = "Diese Administratoren haben Zugriff auf alle Teams in Ihrer Organization. Sie können Team-Administratoren und -mitglieder später hinzufügen.", Pgt = "Legen Sie ein Passwort fest", Igt = "Dies wird ein neues Benutzerkonto mit Ihrer Organization-Mailadresse und diesem Passwort erstellen.", Rgt = "Logo der Organization", Ngt = "Ein paar Sätze zu Ihrer Organization. Dies wird auf der öffentlichen Profilseite Ihrer Organization erscheinen.", Dgt = "Ich werde das später tun", Mgt = "Bestätigen Sie Ihre E-Mail-Adresse", Lgt = "Geben Sie den 6-stelligen Code ein, den wir an {{email}} gesendet haben", qgt = "Bestätigen Sie Ihre E-Mail-Adresse, um eine Organization zu erstellen", jgt = "Der eingegebene Code ist ungültig, versuchen Sie es erneut", Fgt = "Die E-Mail-Adresse wird bereits verwendet", Vgt = "Sie wurden eingeladen, ein Mitglied von {{orgName}} zu werden", Bgt = "Schließen Sie sich Ihrem Team bei {{orgName}} an und konzentrieren Sie sich auf Ihre Meetings, nicht auf das Planen von Meetings!", Ugt = "Die folgenden Teams konnten aufgrund von doppelten Slugs nicht erstellt werden: {{slugs}}", Wgt = "Teamnamen dürfen nicht leer sein", Ggt = "Teamnamen dürfen nicht bereits verwendet werden", Hgt = "Der Benutzer gehört einer Organization an", Kgt = "Diese Organization hat noch keine Teams", Ygt = "Falls Sie ein Administrator sind, sollten Sie unbedingt Teams erstellen, welche hier angezeigt werden können.", Zgt = "Einrichten", Qgt = "Mein Profil", Jgt = "Meine Einstellungen", Xgt = "CRM", eht = "Nachrichten", tht = "Name oder Nummer, welcher bzw. welche als Absender einer SMS angezeigt wird (einige Länder erlauben keine alphanumerischen Absender-IDs)", nht = "Nur der Administrator Ihrer Organization kann neue Teams erstellen", oht = "Googles neue Spam-Richtlinie könnte verhindern, dass du E-Mail- und Kalenderbenachrichtigungen über diese Buchung erhältst.", rht = "Problem lösen", iht = "Beim Erstellen von Teams für diese Organization ist ein Fehler aufgetreten. URL-Slug fehlt.", aht = "Link zur Organization kopieren", sht = "Team: {{teamName}}", cht = "Benutzer: {{userName}}", lht = "Erfahren Sie mehr über Ihre Termine und Ihr Team", dht = "Anrufverlauf", uht = "Anrufverlauf aller Cal.ai-Anrufe anzeigen", _ht = "{{locationCount}} Veranstaltungsort-Optionen", pht = "Kanaltyp", mht = "Beendigungsgrund", fht = "Sitzungsstatus", ght = "Nutzer-Stimmung", hht = "Zeit", vht = "Von", bht = "Maßgeschneiderter Tarif", yht = "E-Mail Einbettung", $ht = "Zeiten zur E-Mail hinzufügen", wht = "Zeit auswählen", kht = "Datum auswählen", Sht = "Nur anzeigen, wenn ein Parameter gesetzt ist", xht = "Parameter hinzufügen", Eht = "Wir verbinden Sie mit jemandem von {{orgName}}.", Tht = "Bitte schließen oder aktualisieren Sie diese Seite nicht", Aht = "Alle verfügbaren Zeiten ansehen", Cht = "z.B. Marketing-Team", zht = "z.B. Vertriebsteam", Oht = "z. B. Design-Team", Pht = "z.B. Engineering-Team", Iht = "z.B. Data Analytics Team", Rht = "Weitere Teams können Sie zu einem späteren Zeitpunkt hinzufügen.", Nht = "Worum geht es in diesem Termin?", Dht = "Zum Team hinzufügen", Mht = "Benutzer aus der Organisation entfernen", Lht = "Delegierungsnachweis", qht = "Der Delegierungsnachweis ermöglicht es Ihnen, den Zugriff auf Google Workspace-Kalender für Ihre Organisation zu verwalten.", jht = "Fügen Sie diese Client-ID in Google Workspace mit dem folgenden Bereich hinzu", Fht = "Delegierungsnachweis aktiviert", Vht = "Delegierungsnachweis hinzufügen", Bht = "Delegierungsnachweis bearbeiten", Uht = "Domain", Wht = "Keine Workspace-Plattformen", Ght = "Workspace-Plattform", Hht = "Workspace-Plattformen", Kht = "Verwalten Sie Workspace-Plattformen, die für den Delegierungsnachweis verwendet werden können", Yht = "Workspace-Plattform bearbeiten", Zht = "Servicekonto bearbeiten", Qht = "Workspace-Plattform hinzufügen", Jht = "Slug", Xht = "Servicekonto-Schlüssel JSON", evt = "Servicekonto-Schlüssel JSON bearbeiten", tvt = "Der Delegierungsnachweis beschränkt das Hinzufügen von mehr als einer Installation", nvt = "App erfolgreich installiert und verwendet delegierte Anmeldeinformationen", ovt = "Sind Sie sicher, dass Sie {{userCount}} Benutzer aus dieser Organisation entfernen möchten?", rvt = "Benutzer aus Team entfernen", ivt = "Sind Sie sicher, dass Sie {{userCount}} Benutzer aus diesem Team entfernen möchten?", avt = "Dieser Benutzer hat noch keine Verfügbarkeitspläne eingerichtet", svt = "Dieser Benutzer ist in keinem Team", cvt = "Dieser Benutzer hat noch keine Apps installiert", lvt = "Erfordert E-Mail-Verifizierung des Buchenden", dvt = "Um sicherzustellen, dass die E-Mail des Buchenden vor der Terminplanung verifiziert ist", uvt = "Textnachrichten können nur an Teilnehmer gesendet werden, wenn der Ereignistyp bestätigt werden muss.", _vt = "Organisationen", pvt = "Cal Video Logo hochladen", mvt = "Cal Video Logo aktualisieren", fvt = "Banner hochladen", gvt = "Um sicherzustellen, dass Ihr Logo vor dem dunklen Hintergrund von Cal Video gut sichtbar ist, laden Sie bitte ein helles Bild im PNG- oder SVG-Format hoch, um die Transparenz zu erhalten.", hvt = "Weitere Teams", vvt = "Hier können Sie Teams innerhalb Ihrer Organisation sehen, zu denen Sie nicht gehören. Sie können sich bei Bedarf selbst hinzufügen.", bvt = "Sie gehören keiner Organisation an", yvt = "Keine weiteren Teams gefunden", $vt = "Es gibt keine weiteren Teams in dieser Organisation.", wvt = "Vorname des Teilnehmers", kvt = "Nachname des Teilnehmers", Svt = "Vorname der buchenden Person", xvt = "Nachname der buchenden Person", Evt = "Ihre monatliche Statistik", Tvt = "Mitgliedsname", Avt = "Beliebteste Termine", Cvt = "Hier ist Ihre Zusammenfassung der beliebten Termine für Ihr Team {{teamName}} der letzten 30 Tage", zvt = "Ich", Ovt = "Meeting nicht verfügbar", Pvt = "Monatliche Zusammenfassungs-E-Mail", Ivt = "Monatliche Statistik E-Mail für Teams", Rvt = "Verifizieren Sie Ihr Team, um das Senden von Nachrichten an Teilnehmer zu aktivieren", Nvt = "Mitglied entfernt", Dvt = "Meine Verfügbarkeit", Mvt = "Teamverfügbarkeit", Lvt = "Sofortige Verfügbarkeit für Meetings", qvt = "Backup-Code", jvt = "Backup-Codes", Fvt = "Jeder Backup-Code kann genau einmal verwendet werden, um Zugriff ohne Ihren Authentifikator zu gewähren.", Vvt = "Backup-Codes kopiert!", Bvt = "Backup-Code ist falsch.", Uvt = "Zugriff verloren", Wvt = "Keine Backup-Codes gefunden. Bitte generieren Sie diese in Ihren Einstellungen.", Gvt = "Neue Organisation erstellt: Ausstehende Aktion", Hvt = "Hallo, Administrator", Kvt = "Eine Organisation benötigt DNS-Konfiguration", Yvt = 'Eine Organisation mit slug "{{orgSlug}}" wurde erstellt.<br /><br />Bitte konfigurieren Sie Ihre DNS-Registry so, dass die Subdomain der neuen Organisation auf die Hauptanwendung verweist. Andernfalls wird die Organisation nicht funktionieren.<br /><br />Hier sind nur die grundlegenden Optionen, um eine Subdomain so zu konfigurieren, dass sie auf ihre App verweist, so dass sie die Organisationsprofilseite lädt.<br /><br />SIe können es entweder mit dem A Record machen:', Zvt = "Oder der CNAME-Eintrag:", Qvt = "Sobald Sie die Subdomain konfiguriert haben, markieren Sie bitte die DNS-Konfiguration wie in den Organisationen Admin-Einstellungen.", Jvt = "Zu den Organisationen Admin-Einstellungen wechseln", Xvt = "Org wurde verarbeitet", ebt = "Beim Verarbeiten dieser Organisation ist ein Fehler aufgetreten", tbt = "Eine Liste aller Organisationen. Wenn Sie eine Organisation akzeptieren, können sich alle Benutzer mit dieser E-Mail-Domain OHNE E-Mail-Überprüfung registrieren.", nbt = "Nicht verifiziert", obt = "Verifiziert", rbt = "DNS fehlt", ibt = "DNS konfiguriert", abt = "Als DNS konfiguriert kennzeichnen", sbt = "Wert", cbt = "Ihre Organisation wurde erfolgreich aktualisiert", lbt = "Dieses Team hat keine Ereignistypen", dbt = "Platzoption unterstützt mehrere Dauern nicht", ubt = "Kalenderereignis hinzufügen", _bt = "OAuth", pbt = "OAuth-Client-Erstellungsformular", mbt = "Dies ist das Formular zur Erstellung eines neuen OAuth-Clients", fbt = "OAuth-Client-Aktualisierungsformular", gbt = "Dies ist das Formular zur Bearbeitung eines bestehenden OAuth-Clients", hbt = "Kürzlich hinzugefügt", vbt = "Verbinden Sie alle Ihre Kalender", bbt = "{{appName}} liest die Verfügbarkeit aus allen Ihren vorhandenen Kalendern.", ybt = "Personalisieren Sie Ihre Planungserfahrung mit Workflows", $bt = "Workflow-Automatisierung", wbt = "Planen Sie Ihr Team mit kollektiver Terminplanung und Round-Robin-Terminplanung", kbt = "Keine Mitglieder gefunden", Sbt = "Verzeichnissynchronisierung", xbt = "Verzeichnisname", Ebt = "Verzeichnisanbieter", Tbt = "SCIM-Basis-URL", Abt = "SCIM-Bearer-Token", Cbt = "SCIM-Basis-URL kopiert", zbt = "SCIM-Bearer-Token kopiert", Obt = "Ihr Identitätsanbieter wird nach den folgenden Informationen fragen, um SCIM zu konfigurieren. Befolgen Sie die Anweisungen, um die Einrichtung abzuschließen.", Pbt = "Verzeichnissynchronisation konfigurieren", Ibt = "Wählen Sie einen Identitätsanbieter, um das Verzeichnis für Ihr Team zu konfigurieren.", Rbt = "Konfigurieren Sie einen Identitätsanbieter, um mit SCIM zu starten.", Nbt = "Verzeichnissynchronisierungs-Verbindung erstellt.", Dbt = `Bereitstellen und Entfernen von Nutzern mit Ihrem Verzeichnisanbieter.
`, Mbt = "Verzeichnissynchronisierungs-Verbindung gelöscht.", Lbt = "Verbindung löschen", qbt = "Verzeichnissynchronisierungs-Verbindung löschen", jbt = "Sind Sie sicher, dass Sie diese Verzeichnissynchronisierungs-Verbindung löschen möchten?", Fbt = "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird die Verzeichnissynchronisierungs-Verbindung dauerhaft löschen.", Vbt = "Ereignis-Einrichtung: Die Dauer muss mindestens 1 Minute betragen.", Bbt = "Verfügbarkeitspläne", Ubt = "Nicht authorisiert", Wbt = "{{clientName}} möchte auf Ihr {{appName}} Konto zugreifen", Gbt = "Konto oder Team auswählen", Hbt = "Dies wird {{clientName}} erlauben", Kbt = "Verknüpfen Sie sich mit Ihren persönlichen Daten von {{clientName}}", Ybt = "Ihre persönlichen Daten einzusehen, einschließlich persönlicher Informationen, die Sie öffentlich zugänglich gemacht haben", Zbt = "Ihre primäre E-Mail-Adresse einzusehen", Qbt = "Sich mit Ihren installierten Apps zu verbinden", Jbt = "Lesen, Bearbeiten, Löschen Ihrer Ereignis-Typen", Xbt = "Lesen, Bearbeiten, Löschen Ihrer Verfügbarkeiten", eyt = "Lesen, Bearbeiten, Löschen Ihrer Termine", tyt = "{{clientName}} zulassen, dies zu tun?", nyt = "Indem Sie auf „Erlauben“ klicken, erlauben Sie dieser App, Ihre Informationen gemäß ihrer Nutzungsbedingungen und Datenschutzrichtlinien zu verwenden. Sie können den Zugriff im {{appName}} App Store aufheben.", oyt = "Zulassen", ryt = "Dieser Benutzer hat das Onboarding noch nicht abgeschlossen. Sie können seine Verfügbarkeit erst festlegen, wenn er das Onboarding abgeschlossen hat.", iyt = "Sie sehen die Verfügbarkeit dieses Benutzers. Sie können nur Ihre eigene Verfügbarkeit bearbeiten.", ayt = "Sie können dies in den erweiterten Einstellungen pro Termin für jeden Termintyp überschreiben.", syt = "Benutzerverfügbarkeit bearbeiten: {{username}}", cyt = "Einladung erneut senden", lyt = "Die Einladung wurde erneut gesendet.", dyt = "SAML", uyt = "Kunde hinzufügen", _yt = "Nach dem Kopieren des Geheimnisses können Sie es nicht mehr ansehen", pyt = "Neuen Kunden hinzufügen", myt = "Neuen Benutzer hinzufügen", fyt = "Diese App wurde noch nicht eingerichtet", gyt = "als CSV", hyt = "Meinen Kalender überlagern", vyt = "Durch das Verbinden mit Ihrem Kalender akzeptieren Sie unsere Datenschutzerklärung und Nutzungsbedingungen. Sie können den Zugriff jederzeit widerrufen.", byt = "Sehen Sie sich Ihre Kalendertermine an, um Buchungskonflikte zu vermeiden.", yyt = "{{eventLocationType}} beitreten", $yt = "Problembehandlung", wyt = "Kalender, die wir auf Konflikte prüfen", kyt = "Verfügbarkeitspläne", Syt = "Kalender verwalten", xyt = "Verfügbarkeitspläne verwalten", Eyt = "Gesperrt", Tyt = "Freigeschaltet", Ayt = "Zeitzone auf der Buchungsseite sperren", Cyt = "Um die Zeitzone auf der Buchungsseite zu sperren, nützlich für Termine in Person.", zyt = "Sie können nur eine Zahlungs-App pro Ereignistyp aktiv haben.", Oyt = "Bitte geben Sie die Nummer im internationalen Format ein.", Pyt = "Kalender installieren", Iyt = "Marken-Subdomain", Ryt = "Holen Sie sich Ihre eigene Marken-Subdomain, wie z.B. acme.cal.com", Nyt = "Organisationsweite Insights", Dyt = "Verstehen Sie, wie Ihre gesamte Organisation Zeit verbringt", Myt = "Dedizierte Onboarding- und Engineeringsupport", Lyt = "Passen Sie Ihre Planungserfahrung mit Ihrem eigenen Logo, eigenen Farben und mehr an", qyt = "Unbegrenzte Teams", jyt = "E-Mail bestätigen", Fyt = "Bitte geben Sie die für diese Buchung verwendete E-Mail-Adresse ein, um mit der Stornierung fortzufahren", Vyt = "E-Mail stimmt nicht mit der Buchungs-E-Mail überein", Byt = "Fügen Sie Ihrer Organisation so viele Unterteams hinzu, wie notwendig", Uyt = "Einheitliche Abrechnung", Wyt = "Erweiterte verwaltete Ereignistypen", Gyt = "Fügen Sie eine einzige Kreditkarte hinzu, um alle Abonnements Ihres Teams zu bezahlen", Hyt = "Unternehmen", Kyt = "Upgraden Sie um Ihre Organisation zu erstellen", Yyt = "Erstellen Sie Ihre Organisation", Zyt = "Organisation erstellen", Qyt = "Upgraden und erhalten Sie eine Subdomain, einheitliche Abrechnungen, Insights, umfangreiches Whitelabeling und mehr", Jyt = "Rüsten Sie auf die Enterprise-Version auf, um Zugriff auf Active Directy Sync, SCIM automatische Benutzerbereitstellung, Cal.ai Voice Agents, Admin APIs und mehr zu erhalten!", Xyt = "Sie können nur eine Zahlungs-App pro Ereignistyp aktivieren", e$t = "Teams, die Mitglied dieser Organisation sind, werden zusammen mit ihren Ereignistypen ebenfalls gelöscht", t$t = "Benutzer, die Teil der Organisation waren, werden nicht gelöscht, aber ihre Benutzernamen würden geändert werden, um ihnen zu ermöglichen, außerhalb der Organisation zu existieren", n$t = "Benutzer-Ereignistypen, die erstellt wurden, nachdem der Benutzer in der Organisation war, werden gelöscht", o$t = "Migrierte Benutzer-Ereignistypen werden nicht gelöscht", r$t = "{{organizationName}} löschen?", i$t = "Veröffentlicht", a$t = "Unveröffentlicht", s$t = "Veröffentlichen", c$t = "Öffnen Sie die Problembehandlung und finden Sie heraus, was mit Ihrem Zeitplan nicht stimmt", l$t = "Brauchst du Hilfe?", d$t = "Problembehandlung", u$t = "Nummer zum Anrufen", _$t = "Gastname", p$t = "Gast-E-Mail", m$t = "Gastunternehmen", f$t = "Bitte installieren Sie einen Kalender", g$t = "Sofortige Buchung", h$t = "Personen sofort buchen lassen", v$t = "Rüsten Sie auf Enterprise auf und lassen Sie Ihre Gäste an einem Sofortanruf teilnehmen, an dem die Teilnehmer direkt teilnehmen können. Dies ist nur für Team-Ereignistypen verfügbar", b$t = "Sie möchten nicht warten?", y$t = "Meeting gestartet", $$t = "Zum Buchen bezahlen", w$t = "Lassen Sie sich von KI-Agenten buchen", k$t = "Buchung konnte nicht gefunden werden", S$t = "Die Buchungsplätze sind voll", x$t = "Fehlende Zahlungsinformationen", E$t = "Fehlende Zahlungsapp-ID", T$t = "Die Buchung hat nicht genügend Plätze verfügbar", A$t = "{{username}} ist derzeit kurzzeitig abwesend.", C$t = "In der Zwischenzeit wird {{profile.username}} für alle neuen geplanten Meetings im Namen von {{username}} verantwortlich sein.", z$t = "Abwesend", O$t = "Konfigurieren Sie Aktionen in Ihrem Profil während Sie abwesend sind.", P$t = "Anfrage senden", I$t = "Startdatum und Enddatum sind erforderlich", R$t = "Das Startdatum muss vor dem Enddatum liegen", N$t = "Das Startdatum muss in der Zukunft liegen", D$t = "Benutzer nicht gefunden", M$t = "Weiterleitung auf sich selbst nicht möglich", L$t = "Abwesenheitseintrag existiert bereits", q$t = "Abwesenheitseintrags-ID erforderlich", j$t = "Es besteht bereits eine Buchungsumleitung von diesem Benutzer zu Ihnen.", F$t = "Neuer Eintrag wurde erfolgreich erstellt", V$t = "Buchungsumleitungsbenachrichtigung", B$t = "Buchungsumleitungsbenachrichtigung", U$t = "Sie haben eine Buchungsumleitung von {{eventOwner}} erhalten. Deren Profillinks werden für den Zeitraum {{dates}} auf Ihre umgeleitet.", W$t = "Benachrichtigung über Änderung der Buchungsumleitung", G$t = "Benachrichtigung über Änderung der Buchungsumleitung", H$t = "Ihre Buchungsumleitung von {{eventOwner}} für den Zeitraum {{oldDates}} wurde aktualisiert. Der neue Zeitraum für die Umleitung ist {{dates}}.", K$t = "Benachrichtigung über Stornierung der Buchungsumleitung", Y$t = "Benachrichtigung über Stornierung der Buchungsumleitung", Z$t = "Ihre Buchungsumleitung von {{eventOwner}} für den Zeitraum {{dates}} wurde storniert.", Q$t = "Sie haben diese Buchungsumleitungsanfrage akzeptiert.", J$t = "Sie haben diese Buchungsumleitungsanfrage abgelehnt.", X$t = "Link zum Teilen der Anfrage kopieren", ewt = "Buchungsumleitungsanfrage", twt = "Teammitglied auswählen", nwt = "Verreisen Sie? Markieren Sie einfach Ihren Profillink für eine gewisse Zeit als nicht verfügbar.", owt = "Leiten Sie Ihr Profil an ein anderes Teammitglied um", rwt = "Leiten Sie Ihr Profil an ein anderes Teammitglied um (Teamplan erforderlich)", iwt = "Abwesenheits-Unverfügbarkeitsliste", awt = "Eintrag erfolgreich gelöscht", swt = "Abwesenheitseintrag erfolgreich bearbeitet", cwt = "Temporär abwesend?", lwt = "Umleitung hinzufügen", dwt = "Eintrag erstellen", uwt = "Zeitspanne", _wt = "Alle Teammitglieder hinzufügen, einschließlich zukünftiger Mitglieder", pwt = "Umleiten zu", mwt = "Haben Sie Schwierigkeiten, ein Zeitfenster zu finden?", fwt = "Mehr anzeigen", gwt = "Weiterleitungsparameter wie ?email=...&name=.... und mehr", hwt = "Planen Sie Meetings ein, wenn jeder verfügbar ist, oder rotieren Sie durch die Mitglieder Ihres Team", vwt = "Niedrigste", bwt = "Niedrig", ywt = "Mittel", $wt = "Hoch", wwt = "Höchste", kwt = "Bucher senden an", Swt = "Priorität festlegen", xwt = "Gewichtung festlegen", Ewt = "Gewichtungen aktivieren", Twt = "Priorität von {{userName}}", Awt = "Gewichtungen bestimmen, wie Meetings unter den Gastgebern verteilt werden. <0>Mehr erfahren</0>", Cwt = "Gewichtung für {{userName}}", zwt = "Priorität ändern", Owt = "Verwenden Sie Feldbezeichner als Variablen für Ihre benutzerdefinierte Ereignisumleitung", Pwt = "Verwenden Sie Feldbezeichner als Variablen für Ihre benutzerdefinierte Ereignisumleitung (z. B. {{variable}})", Iwt = "Konto ist bereits verknüpft", Rwt = "E-Mail senden", Nwt = "Teilnehmer mit Cal.ai Sprachassistent anrufen", Dwt = "Anruf zur Buchungsbestätigung", Mwt = "2 Std. vor Terminbeginn", Lwt = "Cal.ai Agent-Konfiguration", qwt = "Bitte wählen Sie mindestens einen Ereignistyp aus, um einen Testanruf zu tätigen.", jwt = "Als No-Show markieren", Fwt = "Markierung als No-Show entfernen", Vwt = "Konto erfolgreich getrennt", Bwt = "Beim Trennen der Verknüpfung des Kontos ist ein Fehler aufgetreten", Uwt = "Reiseplan", Wwt = "Planen Sie Ihre Reise im Voraus, um Ihren bestehenden Zeitplan in einer anderen Zeitzone zu behalten und zu verhindern, dass Sie um Mitternacht gebucht werden.", Gwt = "Zeitzonenänderung planen", Hwt = "Datum", Kwt = "Geben Sie die allgemeine Aufforderung für den Agenten ein", Ywt = "Dies überlappt sich mit einem bestehenden Zeitplan. Bitte wählen Sie ein anderes Datum.", Zwt = "Erhalten Sie Benachrichtigungen, wenn Ihr Team keine Verfügbarkeiten hat", Qwt = "Admins erhalten E-Mail-Benachrichtigungen, wenn ein Benutzer versucht, ein Teammitglied zu buchen, und „Keine Verfügbarkeit“ sieht. Wir lösen diese E-Mail nach zwei Vorfällen aus und erinnern Sie alle 7 Tage pro Benutzer.  ", Jwt = "SMS-Benachrichtigungen für reine Telefon-Eventtypen deaktivieren", Xwt = "Automatische SMS-Benachrichtigungen für Eventtypen deaktivieren, die nur Telefonnummer (attendeePhoneNumber) als Pflichtfrage haben, wobei E-Mail optional oder nicht erforderlich ist", e0t = "Ihr aktueller Tarif", t0t = "37 $ pro Benutzer pro Monat", n0t = "Privatsphäre-Einstellungen für Ihre Organisation verwalten", o0t = "Datenschutz", r0t = "Neue Teams werden unter Ihrer Organisation sein", i0t = "Gruppennamen hinzufügen", a0t = "Gruppenname", s0t = "Router", c0t = "Primär", l0t = "Zur Primäradresse machen", d0t = "E-Mail-Adresse hinzufügen", u0t = "E-Mails hinzufügen", _0t = "Fügen Sie eine E-Mail-Adresse hinzu, um die Ihre primäre E-Mail-Adresse ersetzt, oder als alternative E-Mail in Ihren Ereignistypen verwendet wird.", p0t = "Bestätigen Sie Ihre E-Mail-Adresse", m0t = "$t(hey_there) {{name}}, wir bestätigen Ihre Buchung am {{date}}.", f0t = "Der Vorname der buchenden Person", g0t = "Der Nachname der buchenden Person", h0t = "Name des Planers", v0t = "Ihr Vorname", b0t = "Wir haben eine E-Mail an <strong>{{email}}</strong> gesendet. Klicken Sie auf den Link in der E-Mail, um diese Adresse zu bestätigen.", y0t = "Termindetails senden an", $0t = "Zeitzone ohne Enddatum einplanen", w0t = "Mitglieder auswählen", k0t = "Was soll mit den bestehenden Termintypen Ihres Mitglieds geschehen?", S0t = "Alle individuellen Termintypen (außer verwaltete Typen) von Ihren Mitgliedern werden dauerhaft gelöscht. Sie werden nicht in der Lage sein, neue zu erstellen", x0t = "Die individuellen Termintypen werden von Profilen verborgen (abgesehen von verwalteten), die Links werden jedoch weiterhin aktiv sein. Sie werden nicht in der Lage sein, neue zu erstellen.  ", E0t = "Einzelne Termintypen verbergen", T0t = "Einzelne Termintypen löschen", A0t = "Erstellung einzelner Termintypen sperren", C0t = "Mitglieder daran hindern, ihre eigenen Termintypen zu erstellen.", z0t = "Zu Termintyp hinzufügen", O0t = "Kontopasswort erstellen", P0t = "Konto mit SAML erstellen", I0t = "Passwort konnte nicht erstellt werden", R0t = "Kann kein Kontopasswort für Cal-Konten erstellen", N0t = "Es kann kein Passwort für bereits erstellte Konten erstellt werden", D0t = "Sie haben kein Konto-Passwort. Erstellen Sie eines, indem Sie zu Sicherheit -> Passwort navigieren. Die Verbindung kann nicht getrennt werden, bis ein Konto-Passwort erstellt wurde.", M0t = "Verbundenes Konto trennen", L0t = "Das Trennen Ihres verbundenen Kontos ändert die Art und Weise, wie Sie sich anmelden. Sie können sich nur mit E-Mail + Passwort bei Ihrem Konto anmelden", q0t = "Ich stimme der Datenschutzerklärung und der Verwendung von Cookies zu", j0t = "Anruf tätigen", F0t = "Round-Robin-Zuweisung überspringen, wenn der Kontakt in Salesforce existiert", V0t = "URL muss die E-Mail des Kontakts als Parameter enthalten, z. B. ?email=contactEmail", B0t = "Konto auswählen", U0t = "Installieren Sie {{appName}} auf Ihrem persönlichen Konto oder auf einem Teamkonto.", W0t = "Termintypen auswählen", G0t = "Auf welchem Termintypen möchten Sie {{appName}} installieren?", H0t = "{{appName}} konfigurieren", K0t = "App-Einrichtung abschließen. Sie können diese Einstellungen später ändern.", Y0t = "bereits installiert", Z0t = "Nicht angegeben", Q0t = "Urlaub", J0t = "Verreist", X0t = "Krankheitsurlaub", ekt = "Feiertag", tkt = "Weiterleitung an <0>{{username}}</0>", nkt = "Keine Weiterleitung", okt = "Eine Abwesenheit erstellen", rkt = "Informieren Sie Ihre Bucher, wann Sie nicht zur Buchung bereitstehen. Sie können immer noch von ihnen bei Ihrer Rückkehr buchen oder sie an ein Teammitglied weiterleiten.", ikt = "{{displayName}} ist abwesend", akt = "<0>{{displayName}}</0> kann die Meetings während der Abwesenheit abhalten.", skt = "{{displayName}} buchen", ckt = "Grund auswählen", lkt = "Abwesenheit eintragen", dkt = "Abwesenheitseintrag bearbeiten", ukt = "Feedback absenden", _kt = "Ihr Gastgeber ist nicht erschienen", pkt = "Sie können ein anderes Meeting mit ihm bzw. ihr planen", mkt = "Wie können wir unseren Service verbessern?", fkt = "Was gefällt Ihnen am meisten?", gkt = "Überprüfung", hkt = "Überprüft", vkt = "Ungeprüft", bkt = "Bewertungs-URL", ykt = "Die URL für das Bewertungsfeedback-Formular", $kt = "No-Show-URL", wkt = "Die URL für Feedback zum Nichterscheinen anzeigen", kkt = "Keine Unterstützung erforderlich?", Skt = "Unterstützung ausblenden", xkt = "Durchschnittliche Bewertungen", Ekt = "Nichterscheinen (Gastgeber)", Tkt = "Nichterscheinen (Gast)", Akt = "Aktuelle Bewertungen", Ckt = "Keine Bewertungen eingereicht", zkt = "Fügen Sie einen Workflow mit „Bewertung“ hinzu, um Bewertungen nach Meetings zu sammeln", Okt = "Meiste Nichterscheinungen", Pkt = "Am besten bewertet", Ikt = "Am schlechtesten bewertet", Rkt = "Mitglieder mit den am höchsten bewerteten Meetings", Nkt = "Mitglieder mit den am niedrigsten bewerteten Meetings", Dkt = "CSAT-Bewertung", Mkt = "Gesperrte SMS", Lkt = "Verlassen, ohne jemanden zuzuordnen?", qkt = "Sind Sie sicher, dass Sie diesen Termin verlassen möchten, ohne Teilnehmer hinzuzufügen?", jkt = "Wenn Sie niemanden für diesen Termin zuweisen, wird den Buchenden keine Verfügbarkeit angezeigt.", Fkt = "Zurück und zuweisen", Vkt = "Ohne Zuordnung verlassen", Bkt = "Indem Sie fortfahren, stimmen Sie unseren <0>Nutzungsbedingungen</0> und unserer <1>Datenschutzerklärung</1> zu.", Ukt = "Indem Sie fortfahren, stimmen Sie unseren", Wkt = "Nutzungsbedingungen", Gkt = "Immer für {{x}} Tage verfügbar", Hkt = "Verschiebt das {{x}}-Tage-Buchungsfenster automatisch jeden Tag nach vorne und stellt sicher, dass Ihr Kalender immer die nächsten {{x}} Tage mit verfügbaren Zeitfenstern anzeigt.", Kkt = "Team-Abonnement erfolgreich gekündigt", Ykt = "Fehler bei der Kündigung des Team-Abonnements", Zkt = "Beim Abonnieren des Platform-Plans ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Qkt = "Beim Aktualisieren des OAuth-Clients ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Jkt = "Beim Erstellen des OAuth-Clients ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", Xkt = "Farbe des Ereignistyps", e1t = "Dies wird nur zur Unterscheidung von Ereignistypen und Buchungen innerhalb der App verwendet. Es wird den Buchenden nicht angezeigt.", t1t = "Als nicht erschienen markieren", n1t = "{{x}} als No-Show markiert", o1t = "No-Show-Markierung von {{x}} entfernt", r1t = "Auslöser für alle Team-Ereignistypen und persönliche Ereignistypen aller Teammitglieder", i1t = "Verwalte die Einstellungen für dein Team", a1t = "No-Show-Status für Teilnehmer aktualisiert", s1t = "E-Mail kopiert", c1t = "Telefonnummer kopiert", l1t = "Benutzer ist ein ausstehendes Mitglied der Organisation", d1t = "Benutzer ist bereits ein Mitglied oder eingeladen", u1t = "Benutzer ist Mitglied einer Organisation, zu der dieses Team nicht angehört.", _1t = "Buchung wurde neu zugewiesen", p1t = "Neu zuweisen", m1t = "Buchung einem anderen verfügbaren Round-Robin-Gastgeber zuweisen", f1t = "Teammitglied zuweisen", g1t = "Überschreiben Sie, welches Teammitglied Sie zuweisen möchten.", h1t = "Keine verfügbaren Gastgeber", v1t = "Round-Robin-Gastgeber neu zuweisen", b1t = "Nicht in den ICS-Feed schreiben", y1t = "Eine Umbuchung ist nicht möglich, da das Ereignis abgelaufen ist", $1t = "Dieses Ereignis ist abgelaufen", w1t = "Kontakte nicht erstellen, wenn sie in {{appName}} nicht existieren", k1t = "Wenn Ihr ICS-Link schreibgeschützt ist (z.B. Proton Calendar), aktivieren Sie das obige Kontrollkästchen, um Fehler zu vermeiden. Sie müssen Ihren Kalender auch manuell aktualisieren, um Änderungen zu übernehmen.", S1t = "Attribute", x1t = "Neues Attribut", E1t = "Attribute hinzufügen", T1t = "Fügen Sie Ihren Teammitgliedern Attribute hinzu", A1t = "Neue Option", C1t = "Mitglied aktualisieren", z1t = "Attribut", O1t = "Erstelle ein Attribut für deine Teammitglieder", P1t = "Bearbeite ein Attribut für deine Teammitglieder", I1t = "Attribut erfolgreich aktualisiert", R1t = "Attribut erfolgreich gelöscht", N1t = "Attribute erfolgreich bearbeitet", D1t = "Verwalten Sie Attribute für Ihre Teammitglieder", M1t = "Bearbeiten Sie Attribute für Ihre Teammitglieder", L1t = "Zurück zu den Attributen", q1t = "Sind Sie sicher, dass Sie diese Option löschen möchten?", j1t = "Diese Option ist {{numberOfUsers}} Mitgliedern zugewiesen. Durch das Löschen wird sie aus deren Profil entfernt.", F1t = "Standardmäßige E-Mails an Teilnehmer für diesen Ereignistyp deaktivieren", V1t = "Deaktiviert die standardmäßige E-Mail-Kommunikation für diesen Ereignistyp, einschließlich Buchungsbestätigungen, Erinnerungen und Stornierungen.", B1t = "Standardmäßige E-Mails an Gastgeber für diesen Ereignistyp deaktivieren", U1t = "Geben Sie 'bestätigen' ein, um fortzufahren", W1t = "E-Mail deaktivieren", G1t = "Admin-API-Zugriff gewähren", H1t = "Admin-API-Zugriff widerrufen", K1t = "{{calendar}}-Kalender hinzufügen", Y1t = "Apple Kalender verbinden", Z1t = "Apple Kalender verbunden", Q1t = "Apple Kalender wird überprüft", J1t = "Google Kalender verbinden", X1t = "Google Kalender verbunden", e2t = "Google Kalender wird überprüft", t2t = "Outlook Kalender verbinden", n2t = "Outlook Kalender verbunden", o2t = "Outlook Kalender wird überprüft", r2t = "Mit Stripe verbinden", i2t = "Stripe verbunden", a2t = "Überprüfe Stripe-Anmeldedaten", s2t = "Variablen für Buchungsfragen-Antworten", c2t = "Verwaltet von {{teamAdmins}}", l2t = "{{count}} Optionen", d2t = "Mit demselben Round-Robin-Gastgeber neu planen", u2t = "Neu geplante Ereignisse werden demselben Gastgeber zugewiesen wie ursprünglich geplant", _2t = "Eingabe deaktivieren, wenn die URL-Kennung vorausgefüllt ist", p2t = "Buchungslimits", m2t = "Buchungslimits für Teammitglieder über alle Team-Ereignistypen hinweg", f2t = "Begrenzen Sie, wie oft Mitglieder über alle Team-Ereignistypen hinweg gebucht werden können", g2t = "Buchungslimits erfolgreich aktualisiert", h2t = "Sie sind nicht berechtigt, diese Änderung an der Buchung vorzunehmen", v2t = "Delegierungsnachweis deaktiviert", b2t = "Passende Mitglieder", y2t = "{{x}} passende Mitglieder", $2t = "Warteschlange für passende Mitglieder (mit Attributgewichtung)", w2t = "Warteschlange für passende Mitglieder (mit Gewichtung der Terminverantwortlichen)", k2t = "Keine passenden Mitglieder gefunden. Es wird auf die dem Ereignistyp zugewiesenen Teammitglieder zurückgegriffen.", S2t = "Keine passenden Mitglieder gefunden. Es wird auf alle dem Ereignistyp zugewiesenen Teammitglieder zurückgegriffen. Erwägen Sie, eine Fallback-Option hinzuzufügen oder die Logik für using_fallback_members zu korrigieren", x2t = "Kalenderereignisdetails in geteilten Kalendern verbergen", E2t = "Wenn ein Kalender geteilt wird, sind Ereignisse für Leser sichtbar, aber ihre Details bleiben für Personen ohne Schreibzugriff verborgen.", T2t = "Letzte {{count}} Tage", A2t = "Aktueller Monat", C2t = "Aktuelles Jahr", z2t = "Benutzerdefinierter Zeitraum", O2t = "Rückerstattungsrichtlinie", P2t = "Immer", I2t = "Nie", R2t = "Zahlungsoption", N2t = "Bei Stornierung", D2t = "vor", M2t = "Alle Spalten anzeigen", L2t = "Spalten ein-/ausblenden", q2t = "Keine Spalten gefunden", j2t = "Bei der Buchung Ereignisse und neue Teilnehmer hinzufügen als:", F2t = "Lead", V2t = "Kontakt unter einem Account", B2t = "Überspringen Sie die Erstellung eines {{entry}}-Datensatzes, wenn dieser nicht in Salesforce existiert", U2t = "Wenn der Kontakt nicht unter einem Account existiert, erstellen Sie einen neuen Lead aus dem Teilnehmer", W2t = "Erstellen Sie einen neuen Kontakt unter einem Account basierend auf der E-Mail-Domain des Teilnehmers und bestehenden Kontakten", G2t = "Datensatzinhaber bei Buchung ändern", H2t = "Attribute massenweise zuweisen", K2t = "Es führt zur Anzeige einer benutzerdefinierten Nachricht. Versuchen Sie, die Antwort zu ändern, um zu einem Ereignis weiterzuleiten", Y2t = "Es führt zur Weiterleitung auf {{externalUrl}}. Versuchen Sie, die Antwort zu ändern, um zu einem Ereignis weiterzuleiten", Z2t = "Möglicher Gastgeber", Q2t = "Aktueller Weiterleitungsstatus", J2t = "Buchung umleiten", X2t = "Leiten Sie die Buchung an andere Teammitglieder um", eSt = "Neue Route überprüfen", tSt = "Umleiten", nSt = "Neuer Weiterleitungsstatus", oSt = "Wenn der Teilnehmer in Salesforce existiert, buchen Sie direkt beim Besitzer", rSt = "Entität, deren Besitzer für die direkte Buchung überprüft werden soll", iSt = "Account", aSt = "Zeitpläne der Gastgeber auswählen", sSt = "Sie können für jeden Gastgeber einen anderen Zeitplan auswählen. Standardmäßig wird der Standardzeitplan jedes Gastgebers ausgewählt.", cSt = "Keine Gastgeber zugewiesen. Fügen Sie Gastgeber im Zuweisungs-Tab hinzu.", lSt = "Round-Robin-Gastgeber manuell neu zuweisen", dSt = "Round-Robin-Gastgeber manuell einem anderen verfügbaren Gastgeber neu zuweisen", uSt = "Round-Robin-Gastgeber einem anderen verfügbaren Gastgeber neu zuweisen", _St = "Neuer Benutzer ist kein gültiger Round-Robin-Gastgeber für diesen Ereignistyp", pSt = "Neuer Benutzer ist ein fester Gastgeber für diesen Ereignistyp", mSt = "Mit gleichem Zeitfenster neu planen", fSt = "Mit gleichem Zeitfenster des neuen Ereignisses neu planen", gSt = "Zum neuen Ereignis mit anderem Zeitfenster neu planen", hSt = "Mit anderem Zeitfenster neu planen", vSt = "Wir haben keine ID für das neue Ereignis. Bitte gehen Sie zum Routing-Formular und speichern Sie es erneut.", bSt = "Buchung erfolgreich umgeleitet. Weiterleitung zur Buchungsseite", ySt = "Bei Buchung in Ereignisobjekt schreiben", $St = "Feldname", wSt = "Neues Feld hinzufügen", kSt = "Sie haben keine Berechtigung, diese Buchung umzuleiten", SSt = "Formularantwort nicht gefunden", xSt = "Kontaktinhaber", ESt = "Nicht gefunden", TSt = "Verwendung von Fallback-Mitgliedern", ASt = "Gewählte Route", CSt = "Attributlogik zutreffend", zSt = "Attributlogik-Fallback zutreffend", OSt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, einige Attributregeln hinzuzufügen.", PSt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, einige Attributregeln für den Fallback hinzuzufügen.", ISt = "Alle zugewiesenen Mitglieder des Team-Ereignistyps. Erwägen Sie, den Fallback anzupassen, um eine Übereinstimmung zu erzielen.", RSt = "Warnung", NSt = "Fallback: Wenn keine Teammitglieder übereinstimmen, verwenden Sie diejenigen, die den folgenden Kriterien entsprechen (standardmäßig alle zugewiesenen Teammitglieder des Ereignisses)", DSt = "Fallback-Warnung", MSt = "Nicht erforderlich", LSt = "Gastgeber nicht verfügbar", qSt = "Gastgeber verfügbar", jSt = "Sind Sie sicher, dass Sie diese Buchung einem nicht verfügbaren Gastgeber neu zuweisen möchten?", FSt = "Sind Sie sicher, dass Sie diese Buchung neu zuweisen möchten?", VSt = "Ja, neu zuweisen", BSt = "Nach Attributen filtern", USt = "Grund für die Neuzuweisung", WSt = "Das Ändern des Feldtyps kann zu Datenverlust führen. Bitte erstelle stattdessen ein neues Feld.", GSt = "Neu zugewiesen von", HSt = "Zeile", KSt = "Zeilen", YSt = "Zeitzone des Teilnehmers", ZSt = "Ereignis-Startzeit in der Zeitzone des Teilnehmers", QSt = "Ereignis-Startzeit in der Zeitzone des Teilnehmers", JSt = "Ereignis-Endzeit in der Zeitzone des Teilnehmers", XSt = "Ereignis-Endzeit in der Zeitzone des Teilnehmers", ext = "Event für Kontakt erstellen, falls vorhanden. Andernfalls auf Lead zurückgreifen", txt = "Zu ändernder Besitzername", nxt = "Kein Filter gesetzt", oxt = "Buchungs-Testlauf erfolgreich", rxt = "Der Testlauf wurde erfolgreich abgeschlossen.", ixt = "Sie haben keinen Zugriff auf diese Seite", axt = "Um diese Seite anzuzeigen oder mit ihr zu interagieren, benötigen Sie Administrator- oder Eigentümerrechte", sxt = "Feldtyp", cxt = "Wann schreiben", lxt = "Bei Buchung in ein benutzerdefiniertes Feld des Teilnehmer-{{record}}-Datensatzes schreiben", dxt = "Bei jeder Buchung", uxt = "Nur wenn das Feld leer ist", _xt = "Buchungs-Startdatum", pxt = "Buchungs-Erstellungsdatum", mxt = "Buchung an {{host}} neu zugewiesen", fxt = "Kein Kontaktinhaber", gxt = "Erstellte Weiterleitungsformulare", hxt = "Gesamtantworten", vxt = "Gesamtantworten ohne Buchung", bxt = "Gesamtantworten mit Buchung", yxt = "Keine Buchungen", $xt = "Formularname", wxt = "Buchung", kxt = "Keine Buchung", Sxt = "Gebucht von", xxt = "Erstellt am", Ext = "Buchungsstatus", Txt = "Gebucht am", Axt = "Eingereicht am", Cxt = "Weiterleitungs-URL kopieren", zxt = "Weiterleitungs-URL beim Verlassen", Oxt = "Gesamtbuchungen pro Zeitraum", Pxt = "Weitergeleitet pro Zeitraum", Ixt = "Pro Tag", Rxt = "Pro Woche", Nxt = "Pro Monat", Dxt = "Zuweisungsgrund", Mxt = "Zugriff verweigert", Lxt = "Der Kontaktinhaber wird der Round Robin Host sein, falls verfügbar", qxt = "Neue Teilnehmer hinzufügen als", jxt = "Der Kontaktinhaber wird nicht erzwungen (kann trotzdem Host sein, wenn die Attribute und Round Robin Kriterien übereinstimmen)", Fxt = "Weiterleitung an einen Benutzer, der mit einem Lookup-Feld eines Accounts übereinstimmt", Vxt = "Salesforce-Option", Bxt = "Name des Lookup-Felds", Uxt = "Bei Teilnehmern mit einer kostenlosen E-Mail-Domain die Eigentümerprüfung überspringen und round robin wie gewohnt durchführen", Wxt = "Ist", Gxt = "Ist nicht", Hxt = "Enthält", Kxt = "Enthält nicht", Yxt = "Beginnt mit", Zxt = "Endet mit", Qxt = "Ist leer", Jxt = "Ist nicht leer", Xxt = "Titel und Beschreibung automatisch übersetzen", eEt = "Titel und Beschreibungen automatisch in die Browsersprache des Besuchers mittels KI übersetzen.", tEt = "Verteilung", nEt = "Ermöglicht die Optimierung der Verteilung für maximale Verfügbarkeit oder eine ausgewogenere Zuweisung.", oEt = "Verfügbarkeit maximieren", rEt = "Ermöglicht Buchenden, Meetings zu buchen, wann immer ein Host verfügbar ist. Nutzen Sie dies, um die Anzahl potenzieller Meetings zu maximieren, wenn die gleichmäßige Verteilung der Meetings auf die Hosts weniger wichtig ist.", iEt = "Lastverteilung", aEt = "Wir überwachen, wie viele Buchungen bei jedem Host eingegangen sind und vergleichen dies mit anderen. Hosts, die zu weit voraus sind, werden temporär deaktiviert, damit die Buchungen gleichmäßig verteilt werden.", sEt = "Gewichtungen bearbeiten", cEt = "Gewichtungen erfolgreich aktualisiert", lEt = "Bestätigung nur für kostenlose E-Mail-Anbieter erforderlich (z.B. @gmail.com, @outlook.com)", dEt = "E-Mails ausschließen, die ... enthalten", uEt = "E-Mails müssen enthalten ...", _Et = "Bitte geben Sie eine gültige Geschäfts-E-Mail-Adresse ein", pEt = "Sie dürfen mit dieser E-Mail-Domain keine Buchung vornehmen. Bitte kontaktieren Sie den Besitzer dieses Links.", mEt = "Spalten durchsuchen", fEt = "Suchoptionen", gEt = "Öffentliches Organisationsprofil deaktivieren und weiterleiten", hEt = "Leitet {{orgSlug}}.cal.com zu {{destination}} weiter", vEt = "Einfachauswahl", bEt = "Mehrfachauswahl", yEt = "Kalender-Konflikt-Einstellungen", $Et = "Wählen Sie die Kalender aus, die auf Konflikte überprüft werden sollen", wEt = "Gruppenbesprechung", kEt = "Sind Sie sicher, dass Sie diese App entfernen möchten von", SEt = "App trennen von", xEt = "Keine neuen Datensätze für Gäste erstellen, die zur Buchung hinzugefügt wurden", EEt = "Google Meet", TEt = "Zoom", AEt = "MS Teams Video", CEt = "Für Zuweisung sperren", zEt = "Die Sperrung erlaubt Zuweisungen nur über die Verzeichnissynchronisierung", OEt = "Attribut erfolgreich bearbeitet", PEt = "Neue Gruppenoption", IEt = "Gewichtungen aktiviert", REt = "Durch die Aktivierung von Gewichtungen ist es möglich, bestimmten Attributen pro Benutzer eine höhere Priorität zuzuweisen. Je höher die Gewichtung, desto höher die Priorität.", NEt = "Weitergeleitet", DEt = "Neu zugewiesen", MEt = "Umbuchung vergangener Termine erlauben", LEt = "Wenn diese Option aktiviert ist, können vergangene Termine umgebucht werden", qEt = "Umgeleitet", jEt = "Salesforce-Zuweisung", FEt = "Router-Position", VEt = "Passende Hosts anzeigen", BEt = "Keine aktiven Warteschlangen für diese Eingabe", UEt = "Gewichtung", WEt = "Kalibrierung", GEt = "Fehlmenge", HEt = "Routing-Formular", KEt = "Zurück und speichern", YEt = "Änderungen speichern", ZEt = "Ohne speichern verlassen", QEt = "Sind Sie sicher, dass Sie die Änderungen an Ihrem Routing-Formular nicht speichern möchten?", JEt = "Ein unerwarteter Fehler ist aufgetreten", XEt = "Sie führen eine Testbuchung durch.", eTt = "Icon-Übersicht", tTt = "Icons-Übersicht", nTt = "Migration vom Team", oTt = "Funktion ist derzeit deaktiviert", rTt = "Option auswählen", iTt = "Optionswert eingeben", aTt = "Option entfernen", sTt = "Attributgewichtungen verwenden", cTt = "Wenn aktiviert, werden alle im Ereignistyp festgelegten Gewichtungen ignoriert", lTt = "Attribut für Gewichtungen", dTt = "Verwaltete Benutzer", uTt = "Sehen Sie alle verwalteten Benutzer, die von Ihrem OAuth-Client erstellt wurden", _Tt = "Können Sie mir etwas erzählen über ", pTt = "Nutzen Sie KI, um Ihre Fragen zu beantworten", mTt = "Fehler beim Abrufen der Antwort ", fTt = "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut", gTt = "OAuth-Client auswählen", hTt = "Bei jeder Instanz", vTt = "Die Funktion für den Delegierungsnachweis ist für Ihre Organisation nicht aktiviert", bTt = "Interner Vermerk", yTt = "Grund, der dem Kunden mitgeteilt wird (optional)", $Tt = "Dieser Vermerk ist nur für Mitglieder deines Teams sichtbar", wTt = "Vorlagen für interne Stornierungsvermerke", kTt = "Erstelle Vorlagen für interne Vermerke, die auf Buchungen angewendet werden können", STt = "Vorlagen für interne Vermerke erfolgreich aktualisiert", xTt = "Vorlage hinzufügen", ETt = "Autorisieren", TTt = "Weiter", ATt = "Ausblenden", CTt = "Anzeigen", zTt = "UTM-Parameter", OTt = "Keine UTM-Parameter verfügbar.", PTt = "Aufsteigend", ITt = "Absteigend", RTt = "E-Mail-Änderung bestätigen", NTt = "Credits kaufen", DTt = "Credits", MTt = "Verbrauchte Credits", LTt = "Verbleibende Gesamtanzahl", qTt = "Sie erhalten 1000 Credits pro Monat pro Teammitglied", jTt = "Sie erhalten 750 Credits pro Monat pro Teammitglied", FTt = "Credits für den Versand von SMS-Nachrichten anzeigen und verwalten", VTt = "Credits für das Senden von SMS-Nachrichten anzeigen und verwalten. Ein Credit entspricht 1¢ (USD). <0>Mehr erfahren</0>", BTt = "Ein Credit entspricht 1¢ (USD). <0>Mehr erfahren</0>", UTt = "Zusätzliche Credits kaufen (0,01 $ pro Credit)", WTt = "Zusätzliche Credit-Ausgaben können Sie in Ihrem Ausgabenprotokoll einsehen", GTt = "Übersicht", HTt = "Der Organisations-Slug ist bereits vergeben", KTt = "Sie können keine Organisation erstellen, da Sie bereits Teil einer Organisation sind", YTt = "Sie müssen das Benutzer-Onboarding abschließen, bevor Sie eine Organisation erstellen können", ZTt = "Verwenden Sie die Firmen-E-Mail-Adresse, um eine Organisation zu erstellen", QTt = "Sie können keine Plattform-Organisation erstellen, da Sie bereits Teil eines Teams sind", JTt = "Sie müssen mindestens veröffentlichte Teams haben", XTt = "Sie sind bereits Teil dieser Organisation", eAt = "Sie sind Teil einer anderen Organisation und können keine neue Organisation erstellen", tAt = "Sie sind Teil einer anderen Plattformorganisation und können keine neue Organisation erstellen", nAt = "Organisationszahlung erfolgreich", oAt = "Ihre Organisation wurde erfolgreich erstellt", rAt = "Dies kann einige Sekunden dauern...", iAt = "Status des Organisations-Onboardings", aAt = "Beschreibung des Organisations-Onboarding-Status", sAt = "Zahlung fehlgeschlagen", cAt = "Ihre Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut.", lAt = "Ihre Organisation wird erstellt", dAt = "Organisations-Onboarding bereits abgeschlossen", uAt = "Organisations-Onboarding existiert bereits", _At = "Organisations-Onboarding nicht gefunden", pAt = "Zahlung erfolgreich!", mAt = "Übergabe-Onboarding", fAt = "Übergabe des Onboardings an den Benutzer", gAt = "Eine organisation mit diesem slug existiert bereits", hAt = "Sie haben keine berechtigung, eine organisation für diese e-mail-adresse zu erstellen", vAt = "Sie haben keine berechtigung, eines oder mehrere der teams zu migrieren", bAt = "Die organisation hat bereits ein abonnement", yAt = "Intervall für gewichtetes Round Robin zurücksetzen", $At = "Intervall", wAt = "Legt fest, wie oft der Round Robin Buchungszähler zurückgesetzt wird, um eine ausgewogene Verteilung zu gewährleisten.", kAt = "Täglich", SAt = "Sie haben kein Enddatum für Ihre Abwesenheit festgelegt", xAt = "Meine Abwesenheit", EAt = "Team-Abwesenheit", TAt = "Verwalten Sie die Abwesenheiten Ihres Teams.", AAt = "Abwesenheit erstellen", CAt = "Erstellen Sie eine Abwesenheit für ein Teammitglied", zAt = "Bearbeiten Sie eine Abwesenheit für ein Teammitglied", OAt = "Abwesenheit für Ihr Team erstellen", PAt = "Informieren Sie Bucher, wenn Ihre Teammitglieder nicht für Buchungen verfügbar sind. Sie können bei ihrer Rückkehr immer noch gebucht werden, oder Sie können sie an ein anderes Teammitglied weiterleiten.", IAt = "Abwesenheitsweiterleitung ist nur an ein Mitglied desselben Teams erlaubt.", RAt = "Es gibt bereits eine umgekehrte Weiterleitung zwischen diesen Benutzern.", NAt = "Keine vorherige Abwesenheit gefunden", DAt = "Vorherige", MAt = "Round Robin-Intervall erfolgreich aktualisiert", LAt = "Testmodus", qAt = "Inaktiver Team-Plan", jAt = "Ihr Team-Plan ist inaktiv. Überprüfen Sie Ihr Abonnement oder wenden Sie sich an den Kundensupport", FAt = "Eingeschränkter Zugriff während der Testphase. Funktion nach Ablauf der Testphase verfügbar.", VAt = "Empfehlungsprogramm", BAt = "Verdiene 20% Empfehlungsbonus", UAt = "Du benötigst einen Dub API-Schlüssel und eine Programm-ID, um diese Seite zu nutzen.", WAt = "UID", GAt = "Link", HAt = "Zeilen pro Seite", KAt = "{{currentRange}} von {{totalItems}}", YAt = "Tipp: Sie können ein '+' zwischen Benutzernamen einfügen: cal.com/anna+brian, um ein dynamisches Gruppenmeeting zu erstellen", ZAt = "Sie haben noch kein Team", QAt = "Sie haben noch keine Teammitglieder", JAt = "Wiederkehrende Events unterstützen die Sitzplatzfunktion nicht. Machen Sie es zu einem einmaligen Event, um Sitzplätze zu aktivieren.", XAt = "Wiederkehrende Ereignisse unterstützen die Funktion zur Buchungsbegrenzung pro Bucher nicht. Deaktiviere die Buchungsbegrenzung pro Bucher, um wiederkehrende Ereignisse zu aktivieren.", eCt = "Die Sitzplatzfunktion unterstützt keine wiederkehrenden Events. Deaktivieren Sie die Sitzplatzfunktion, um es wiederkehrend zu machen.", tCt = "Wiederkehrende Events unterstützen die Sitzplatzfunktion nicht. Deaktivieren Sie die Sitzplatzfunktion oder machen Sie das Event nicht wiederkehrend.", nCt = "Segment", oCt = "Gespeicherte Filter", rCt = "Umbenennen", iCt = "Segment umbenennen", aCt = "Segment löschen", sCt = "Segment duplizieren", cCt = "Sind Sie sicher, dass Sie dieses Segment löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", lCt = "Filtersegment aktualisiert", dCt = "Fehler beim Aktualisieren des Filtersegments", uCt = "Filtersegment dupliziert", _Ct = "Fehler beim Duplizieren des Filtersegments", pCt = "Filtersegment gelöscht", mCt = "Fehler beim Löschen des Filtersegments", fCt = "Segment speichern", gCt = "Segment nicht gefunden", hCt = "Filtersegment gespeichert", vCt = "Keine Segmente", bCt = "Fehler beim Speichern des Filtersegments", yCt = 'Überschreibungen in "{{name}}" speichern', $Ct = "Neues Segment erstellen", wCt = "Für Team speichern", kCt = "Team auswählen", SCt = "Bitte wähle ein Team aus", xCt = "Persönlich", ECt = "Team-Profillink ausblenden", TCt = "Den Team-Profillink auf Buchungsseiten ausblenden", ACt = "Anzeige", CCt = "Konnte keinen Slug finden, um die Organisation zu veröffentlichen", zCt = "Auswahlliste", OCt = "Meiste stornierte Buchungen", PCt = "Oberflächensprache", ICt = "Legen Sie Ihre bevorzugte Sprache für die Buchungsoberfläche fest", RCt = "Browsersprache des Besuchers", NCt = "Name oder E-Mail", DCt = "Wenn kein Kontakt gefunden wird, auf den Lead-Eigentümer zurückgreifen, falls vorhanden", MCt = "Kauf von Credits fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.", LCt = "Mindestens 50 Credits erforderlich", qCt = "Delegierungsnachweis aktivieren", jCt = "Gewähren Sie Cal.com automatischen Zugriff auf die Kalender aller Organisationsmitglieder, indem Sie den Delegierungsnachweis aktivieren.", FCt = "Delegierungsnachweis deaktivieren", VCt = "Sobald die Delegationsanmeldedaten deaktiviert sind, müssen Organisationsmitglieder, die ihre Kalender noch nicht verbunden haben, dies manuell tun.", BCt = "Zuletzt aktiv", UCt = "Mitglied seit", WCt = "Zuletzt aktualisiert", GCt = "Bei stornierter Buchung in den Ereignisdatensatz schreiben, anstatt das Ereignis zu löschen", HCt = "Bei jeder Stornierung", KCt = "Problem melden", YCt = "Sie können ein Ticket auf GitHub einreichen oder Ihren Plan upgraden, um Echtzeit-Support mit Entwicklerkonferenzen zu erhalten", ZCt = "Problem öffnen", QCt = "Dies ist Ihr aktueller Plan", JCt = "Einen Termin vereinbaren", XCt = "Dies beinhaltet:", ezt = "OAuth-Client erfolgreich aktualisiert", tzt = "OAuth-Client nicht gefunden.", nzt = "Plattform abonnieren", ozt = "Fehler beim Zugriff auf Webhooks.", rzt = "Aktualisierung des Webhooks fehlgeschlagen.", izt = "Erstellung des Webhooks fehlgeschlagen.", azt = "Ungültiger Link", szt = "Sie haben derzeit den {{planFirstLetter}}{{planRest}}-Plan abonniert", czt = "Benutzer/Team", lzt = "Client-ID kopiert!", dzt = "Client-Secret kopiert!", uzt = "Das Cal.com-Team führt geplante Wartungsarbeiten durch. Bei Fragen wenden Sie sich bitte an den Support.", _zt = "Ihre Zahlung ist fehlgeschlagen", pzt = "Überprüfen Sie Ihren Posteingang", mzt = "Dein Konto wurde erstellt, aber dein Premium-Name wurde nicht reserviert.", fzt = "Wir haben eine E-Mail an {{email}} mit einem Link zur Aktivierung deines Kontos gesendet.", gzt = "Sobald du dein Konto aktiviert hast, kannst du erneut versuchen, deinen Premium-Benutzernamen zu kaufen oder einen anderen auswählen.", hzt = "In Gmail öffnen", vzt = "Keine E-Mail erhalten?", bzt = "Erneut senden in {{seconds}} Sekunden", yzt = "Erneut senden", $zt = "Bestätigungs-E-Mail gesendet", wzt = "Alle Mitglieder auswählen", kzt = "Wenn du alle Mitglieder auswählst, werden alle zukünftigen Teammitglieder hinzugefügt, sobald sie dem Team beitreten.", Szt = "Formulareinstellungen", xzt = "Whitelist-Status entfernen", Ezt = "Benutzer-Workflows zur Whitelist hinzufügen", Tzt = "Benutzer-Workflows zur Whitelist hinzugefügt", Azt = "Benutzer-Workflows von der Whitelist entfernt", Czt = "Datum und Uhrzeit", zzt = "Dies ist eine Erinnerung an Ihre bevorstehende Veranstaltung.", Ozt = "Diese Erinnerung wurde durch einen Workflow in Cal ausgelöst.", Pzt = "Ereignis", Izt = "Terminplanung durch", Rzt = "Wie war Ihre letzte Erfahrung?", Nzt = "Wir arbeiten ständig daran, das Kundenerlebnis zu verbessern.", Dzt = "Wie zufrieden waren Sie mit Ihrer letzten Besprechung?", Mzt = "nicht am Meeting teilgenommen?", Lzt = "Hier neu planen.", qzt = "E-Mail-Adresse des Organisators verbergen", jzt = "Du bist bereits Teil einer Plattform-Organisation, weshalb du keine neue Organisation erstellen kannst. Jeder Benutzer kann nur einer Organisation angehören. Bitte erstelle ein neues Cal.com-Konto mit einer anderen E-Mail-Adresse und verwende dieses Konto, um das Organisations-Abonnement abzuschließen.", Fzt = "Du bist bereits Teil einer Organisation, weshalb du keine Plattform-Organisation erstellen kannst. Jeder Benutzer kann nur einer Organisation angehören. Bitte erstelle ein neues Cal.com-Konto mit einer anderen E-Mail-Adresse und verwende dieses Konto, um das Plattform-Abonnement abzuschließen.", Vzt = "E-Mail-Adresse des Organisators im Buchungsbildschirm, in E-Mail-Benachrichtigungen und Kalenderereignissen verbergen", Bzt = "Sie &", Uzt = "Verifizierte E-Mail-Adresse auswählen", Wzt = "Verifizierte E-Mail hinzufügen", Gzt = "Verifizierte E-Mails hinzufügen", Hzt = "Benutzerdefinierte 'Antwort an'-E-Mail", Kzt = "Verwende eine andere E-Mail-Adresse als 'Antwort an' für Bestätigungs-E-Mails anstelle der E-Mail-Adresse des Organisators", Yzt = "Diese Umfrage wurde durch einen Workflow in Cal ausgelöst.", Zzt = "Testphase überspringen", Qzt = "Team-Testphasen erfolgreich übersprungen", Jzt = "Durch die Eingabe deiner Telefonnummer stimmst du zu, SMS-Nachrichten für dieses Event zu erhalten. Es können SMS-Gebühren anfallen.", Xzt = "Weitere Informationen finden Sie in den <0>Routing-Einblicken</0>", eOt = "Ergebnisse", tOt = "Formular anzeigen", nOt = "Senden Sie STOP, um sich von SMS-Nachrichten abzumelden", oOt = "Ihrem Team {{teamName}} gehen die Credits aus", rOt = "Ihnen gehen die Credits aus", iOt = "[Handlung erforderlich] Ihrem Team {{teamName}} sind die Credits ausgegangen", aOt = "[Handlung erforderlich] Ihnen sind die Credits ausgegangen", sOt = "Ihrem Cal.com-Team {{teamName}} gehen die Credits aus. Um Unterbrechungen des Dienstes zu vermeiden, kaufen Sie bitte zusätzliche Credits. Wenn Ihr Guthaben aufgebraucht ist, werden SMS-Nachrichten nicht mehr gesendet und stattdessen als E-Mails verschickt.", cOt = "Ihrem Cal.com-Konto gehen die Credits aus. Um Unterbrechungen des Dienstes zu vermeiden, kaufen Sie bitte zusätzliche Credits. Wenn Ihr Guthaben aufgebraucht ist, werden SMS-Nachrichten nicht mehr gesendet und stattdessen als E-Mails verschickt.", lOt = "Ihrem Cal.com-Team {{teamName}} sind die Credits ausgegangen. Infolgedessen werden SMS-Nachrichten jetzt per E-Mail gesendet. Um wieder SMS zu senden, kaufen Sie bitte zusätzliche Credits.", dOt = "Dein Cal.com-Konto hat keine Credits mehr. Infolgedessen werden SMS-Nachrichten jetzt stattdessen per E-Mail gesendet. Um das Senden von SMS fortzusetzen, kaufe bitte zusätzliche Credits.", uOt = "Aktuelles Guthaben: {{balance}} Credits", _Ot = "Aktuelles Guthaben:", pOt = "Benachrichtigung über deine Buchung", mOt = "Monatliche Credits", fOt = "Gesamte Credits: {{totalCredits}}", gOt = "Verbleibende Credits: {{remainingCredits}}", hOt = "Verbleibend", vOt = "Gesamt", bOt = "Zusätzliche Credits", yOt = "{{count}} nächste in der Warteschlange", $Ot = "E-Mail-Antworten senden an", wOt = "Unvollständige Buchungen", kOt = "Nicht erschienene Buchungen in Round-Robin-Berechnungen einbeziehen", SOt = "Kürzliche No-Show-Gäste", xOt = "Zeigt Buchungen, bei denen alle Teilnehmer nicht erschienen sind, keine teilweisen No-Shows", EOt = "Übereinstimmung", TOt = "Event-Weiterleitung", AOt = "Formular zurücksetzen", COt = "Round Robin-Einstellungen erfolgreich aktualisiert", zOt = "Verteilungsgrundlage für gewichtetes Round Robin", OOt = "Bestimmt, welcher Ereigniszeitstempel als Grundlage für die gewichtete Round Robin-Verteilung verwendet wird.", POt = "Erfordert Credits", IOt = "Du benötigst genügend Credits in deinem Konto, um diese Funktion zu nutzen", ROt = "Verfügbare Credits", NOt = "Rolle erstellen", DOt = "Rollen & Berechtigungen", MOt = "Verwalte Rollen und Berechtigungen für deine Organisation", LOt = "Erfahre mehr darüber, wie Berechtigungen funktionieren", qOt = "Rollenname", jOt = "Rollenname ist erforderlich", FOt = "z.B. Vertriebsteam, Support-Mitarbeiter", VOt = "Rollenbeschreibung", BOt = "Beschreibe, wofür diese Rolle gedacht ist und welche Berechtigungen sie benötigt", UOt = "Standardrolle", WOt = "Benutzerdefinierte Rolle", GOt = "Erweitert", HOt = "Berechtigungen suchen", KOt = "Alle Berechtigungen", YOt = "Keine", ZOt = "Nur lesen", QOt = "Alle Aktionen für alle Ressourcen", JOt = "Alle Ressourcen", XOt = "Ereignistypen", e4t = "Teams", t4t = "Organization", n4t = "Buchungen", o4t = "Erkenntnisse", r4t = "Rollen", i4t = "Weiterleitungsformulare", a4t = "Workflows", s4t = "Alle Aktionen", c4t = "Erstellen", l4t = "Ansehen", d4t = "Bearbeiten", u4t = "Löschen", _4t = "Verwalten", p4t = "Einladen", m4t = "Entfernen", f4t = "Mitgliedsrolle ändern", g4t = "Mitglieder auflisten", h4t = "Abrechnung verwalten", v4t = "Team-Buchungen ansehen", b4t = "Organizations-Buchungen ansehen", y4t = "Aufnahmen anzeigen", $4t = "Imitieren", w4t = "Rolle erfolgreich erstellt", k4t = "Rolle erfolgreich aktualisiert", S4t = "Rolle löschen", x4t = "Sind Sie sicher, dass Sie die Rolle löschen möchten: {{roleName}}. Diese Aktion kann nicht rückgängig gemacht werden.", E4t = "Rolle erfolgreich gelöscht", T4t = "Fehler beim Erstellen der Rolle", A4t = "Fehler beim Aktualisieren der Rolle", C4t = "Rollen erstellen", z4t = "Attribute", O4t = "Organisationsattribute anzeigen", P4t = "Organisationsattribute aktualisieren", I4t = "Organisationsattribute löschen", R4t = "Organisationsattribute erstellen", N4t = "Rollen anzeigen", D4t = "Rollen aktualisieren", M4t = "Rollen löschen", L4t = "Neue Workflows erstellen und einrichten", q4t = "Einrichtung erforderlich", j4t = "Bestehende Workflows und ihre Konfigurationen anzeigen", F4t = "Workflow-Einstellungen bearbeiten und ändern", V4t = "Workflows aus dem System entfernen", B4t = "Webhook", U4t = "Verfügbarkeit", W4t = "Abwesenheit", G4t = "Webhooks erstellen", H4t = "Webhooks anzeigen", K4t = "Webhooks aktualisieren", Y4t = "Webhooks löschen", Z4t = "Verfügbarkeit erstellen", Q4t = "Verfügbarkeit anzeigen", J4t = "Verfügbarkeit aktualisieren", X4t = "Verfügbarkeit löschen", e3t = "Abwesenheit erstellen", t3t = "Abwesenheit anzeigen", n3t = "Abwesenheit aktualisieren", o3t = "Abwesenheit löschen", r3t = "Vollständiger Verwaltungszugriff auf alle Workflows", i3t = "Ereignistypen erstellen", a3t = "Ereignistypen anzeigen", s3t = "Ereignistypen aktualisieren", c3t = "Ereignistypen löschen", l3t = "Alle Aktionen für Ereignistypen", d3t = "Teams erstellen", u3t = "Teamdetails anzeigen", _3t = "Teameinstellungen aktualisieren", p3t = "Team löschen", m3t = "Teammitglieder einladen", f3t = "Teammitglieder entfernen", g3t = "Rolle von Teammitgliedern ändern", h3t = "Teammitglieder imitieren", v3t = "Alle Aktionen für Teams in der gesamten Organisation", b3t = "Organisation erstellen", y3t = "Organisationsdetails anzeigen", $3t = "Organisationsmitglieder auflisten", w3t = "Organisationsmitglieder einladen", k3t = "Organisationsmitglieder entfernen", S3t = "Organisationsabrechnung verwalten", x3t = "Rolle von Organisationsmitgliedern ändern", E3t = "Organisationsmitglieder imitieren", T3t = "Organisationseinstellungen bearbeiten", A3t = "Alle Aktionen für Organisationen", C3t = "Buchungen anzeigen", z3t = "Team-Buchungen anzeigen", O3t = "Organisationsbuchungen anzeigen", P3t = "Buchungsaufzeichnungen anzeigen", I3t = "Buchungen aktualisieren", R3t = "Alle Aktionen für Buchungen", N3t = "Team-Insights anzeigen", D3t = "Team-Insights verwalten", M3t = "Weiterleitungsformulare erstellen", L3t = "Weiterleitungsformulare anzeigen", q3t = "Weiterleitungsformulare aktualisieren", j3t = "Weiterleitungsformulare löschen", F3t = "Leseberechtigung wird automatisch aktiviert, wenn eine Ressource erstellt, aktualisiert oder gelöscht wird", V3t = "Einschränkungszeitplan hinzufügen", B3t = "Beschränken Sie die Verfügbarkeit von Gastgebern, um nur Zeitfenster anzuzeigen, die in einen festgelegten Zeitplan fallen.", U3t = "Zeitzone des Buchenden verwenden", W3t = "Den ausgewählten Einschränkungszeitplan in der Zeitzone des Buchenden anwenden", G3t = "Dies deaktiviert die Lastverteilung für alle Ihre Round-Robin-Ereignistypen", H3t = "Lastverteilung ist nur verfügbar, wenn die Zeitstempelbasis auf Buchungserstellungszeit eingestellt ist", K3t = "Lastausgleich ist mit Round-Robin-Gruppen nicht verfügbar", Y3t = "Passen Sie die Standard-Round-Robin-Einstellungen für dieses Team an", Z3t = "Round-Robin-Einstellungen erfolgreich aktualisiert", Q3t = "Erstellungszeit der Buchung", J3t = "Besprechungsstartzeit", X3t = "Betroffene Mitglieder", e6t = "Keine Mitglieder von der Deaktivierung der Delegationsanmeldedaten betroffen", t6t = "Ausgabenprotokoll herunterladen", n6t = "Fehler beim Herunterladen des Ausgabenprotokolls", o6t = "Angebot zur Umbuchung der letzten aktiven Buchung auf den gewählten Zeitraum", r6t = "Maximale Anzahl aktiver Buchungen des Buchers überschritten", i6t = "Sie haben bereits eine Buchung für dieses Event am {{date}}. Möchten Sie auf die neu gewählte Zeit umbuchen?", a6t = "Die Dauer muss mindestens {{min}} Minute(n) betragen", s6t = "Die Dauer darf {{max}} Minuten (24 Stunden) nicht überschreiten", c6t = "Buchung außerhalb der Verfügbarkeit des Einschränkungsplans.", l6t = "Einschränkungsplan nicht gefunden", d6t = "Bildgrößenlimit überschritten, bitte verwenden Sie ein kleineres Bild, vorzugsweise im JPEG-Format", u6t = "Gruppe hinzufügen", _6t = "Routing-Trichter", p6t = "Gesamtanzahl der Einreichungen", m6t = "Erfolgreiche Weiterleitungen", f6t = "Akzeptierte Buchungen", g6t = "Lizenzschlüssel", h6t = "Wählen Sie ihre Lizenz", v6t = "Wählen Sie, wie Sie Ihre Cal.com-Bereitstellung lizenzieren möchten", b6t = "Verwenden Sie Cal.com unter der AGPLv3 Open-Source-Lizenz", y6t = "Lizenzschlüssel eingeben", $6t = "Zugang zu allen Enterprise-Funktionen", w6t = "Ab 15 $/Benutzer pro Monat", k6t = "Zugang zu allen Enterprise-Funktionen", S6t = "Geben Sie Ihren Lizenzschlüssel ein", x6t = "Lizenzschlüssel speichern", E6t = "Signatur-Token (optional)", T6t = "Das Signatur-Token wird verwendet, um zu überprüfen, ob der Lizenzschlüssel Ihnen gehört, wenn nutzungsbasierte Abrechnungen erhöht werden. Sie finden es in Ihrer Kaufbestätigungs-E-Mail. Wenn Sie eine ältere Lizenz haben, können Sie dieses Feld leer lassen.", A6t = "Benötigen Sie eine Lizenz?", C6t = "Lizenzschlüssel ist erforderlich", z6t = "Ungültiger Lizenzschlüssel", O6t = "Validierung des Lizenzschlüssels fehlgeschlagen", P6t = "Anhänge optional", I6t = "Nachricht senden", R6t = "Beschreiben Sie das Problem", N6t = "Dateigröße überschreitet das Limit", D6t = "Ungültiger Dateityp", M6t = "Ungültiger Dateityp. Akzeptierte Typen: {{acceptedTypes}}", L6t = "Maximale Anzahl an Dateien überschritten", q6t = "Dateien erfolgreich hochgeladen", j6t = "Akzeptierte Typen: {{acceptedTypes}}; Maximale Dateigröße: {{maxSize}}", F6t = "Lizenzschlüssel erfolgreich gespeichert", V6t = "Sie sehen den Bericht basierend auf Ihrer Profil-Zeitzone ({{userTimezone}}), während Ihr Browser auf die Zeitzone ({{browserTimezone}}) eingestellt ist", B6t = "Optimierte Zeitfenster", U6t = "Zeitfenster anordnen, um die Verfügbarkeit zu optimieren.", W6t = "Fehlgeschlagene Buchungen nach Feld", G6t = "Fehlgeschlagene Buchungen", H6t = "Dem Ereignistyp sind keine Gastgeber zugewiesen", K6t = "Cache-Status", Y6t = "Zuletzt aktualisiert: {{timestamp}}", Z6t = "Zwischengespeicherte Daten löschen", Q6t = "Cache erfolgreich gelöscht", J6t = "Fehler beim Löschen des Caches", X6t = "Sind Sie sicher, dass Sie die zwischengespeicherten Daten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.", e5t = "Ja, Cache löschen", t5t = "{{remainder}} von {{maximum}} Verwendungen übrig", n5t = "{{remainder}} von {{maximum}} Verwendung übrig", o5t = "Läuft am {{date}}, Ende des Tages ab", r5t = "Einmalige Verwendung", i5t = "Zeitbasiertes Ablaufdatum", a5t = "Nutzungsbasiertes Ablaufdatum", s5t = "Anzahl der Verwendungen", c5t = "Läuft ab am", l5t = "Maximale Anzahl der Verwendungen", d5t = "Link-Einstellungen", u5t = "Dieser Link ist am {{date}}, Ende des Tages abgelaufen", _5t = "Nutzungslimit erreicht", p5t = "Maximale Nutzungsanzahl muss größer sein als die aktuelle Nutzungsanzahl", m5t = "Dieser Link ist abgelaufen", f5t = "Dieser Link kann für Buchungen bis zum Ende des {{date}} verwendet werden", g5t = "Dieser Link kann so konfiguriert werden, dass er nach einem festgelegten Datum abläuft", h5t = "Dieser Link kann für {{count}} Buchung verwendet werden", v5t = "Dieser Link kann so konfiguriert werden, dass er nach einer festgelegten Anzahl von Buchungen abläuft", b5t = "Dieser Link kann für {{count}} Buchungen verwendet werden", y5t = "Der Name des Auslöseereignisses (z.B. BOOKING_CREATED, BOOKING_CANCELLED)", $5t = "Der Zeitpunkt des Webhooks", w5t = "Der Ereignistyp-Slug", k5t = "Agent einrichten", S5t = "Der Name des Ereignistyps", x5t = "Die Startzeit des Ereignisses", E5t = "Die Endzeit des Ereignisses", T5t = "Die Beschreibung des Ereignisses wie in den Ereignistyp-Einstellungen beschrieben", A5t = "Ort des Ereignisses", C5t = "Die UID der Buchung", z5t = "Die UID für die Umbuchung", O5t = "Grund für die Stornierung", P5t = "Grund für die Ablehnung", I5t = "Name des Organisators", R5t = "E-Mail des Organisators", N5t = "Zeitzone des Organisators (z.B. 'America/New_York', 'Asia/Kolkata')", D5t = "Sprache des Organisators (z.B. 'en', 'fr')", M5t = "Benutzername des Organisators (z.B. 'john.doe')", L5t = "Benutzername des Organisators in seiner Organisation (z.B. 'john.doe')", q5t = "Name des ersten Teilnehmers", j5t = "E-Mail des ersten Teilnehmers", F5t = "Zeitzone des ersten Teilnehmers", V5t = "Sprache des ersten Teilnehmers", B5t = "Name des gebuchten Teams", U5t = "Mitglieder des gebuchten Teams", W5t = "Video-Anruf-URL für das Meeting", G5t = "Variablen ausblenden", H5t = "Verfügbare Variablen anzeigen", K5t = "Veranstaltung und Buchung", Y5t = "Personen", Z5t = "Teams", Q5t = "Metadaten", J5t = "Statistiken", X5t = "Buchungsstatus", ePt = "Besuchen", tPt = "Benutzerdefinierte Bezeichnung auf der Buchungsseite", nPt = "Meeting-Link", oPt = "Sitzungsergebnis", rPt = "Anruf erstellt", iPt = "Sprachnachricht", aPt = "Meine Buchungen", sPt = "Telefon", cPt = "Kostenlos", lPt = "Benutzer-E-Mail", dPt = "Benutzername", uPt = "Panel erweitern", _Pt = "Panel einklappen", pPt = "E-Mail-Verifizierung ist für diesen Ereignistyp erforderlich", mPt = "Ungültiger Verifizierungscode angegeben", fPt = "Sie haben ein Team", gPt = "Erwägen Sie die Einrichtung einer Organisation, um Abrechnung, Administrationstools und Analysen für Ihr Team zu vereinheitlichen.", hPt = "Erwägen Sie die Einrichtung einer Organisation, um Abrechnung, Administrationstools und Analysen für Ihre Teams zu vereinheitlichen.", vPt = "Nachricht gesendet", bPt = "Vielen Dank für Ihre Kontaktaufnahme. Wir werden uns so schnell wie möglich bei Ihnen melden.", yPt = "Variablen durchsuchen", $Pt = "Bitte beschreiben Sie das Problem, mit dem Sie konfrontiert sind, z.B. 'Belegte Zeitfenster werden als verfügbar angezeigt', ..., usw.", wPt = "Weitere Nachricht senden", kPt = "Wird gesendet", SPt = "Keine Variablen gefunden", xPt = "Credits erforderlich", EPt = "Web-Anrufe verbrauchen Credits. Stellen Sie sicher, dass Sie genügend Credits haben, um einen Anruf zu starten.", TPt = "Web-Anrufe erfordern Credits. Sie haben 0 Credits übrig.", APt = "Credits kaufen", CPt = "Diese Aktion erfordert Credits, um fortzufahren", zPt = "Der Name darf {{max}} Zeichen nicht überschreiten", OPt = "Automatische Berechnung der Ausfallgebühr für kurzfristige Stornierungen", PPt = "Vor dem geplanten Startzeitpunkt", IPt = "Ich bestätige, dass mir bei einer Stornierung innerhalb von {{timeValue}} {{timeUnit}} vor dem Startzeitpunkt die Ausfallgebühr von {{amount, currency}} berechnet wird", RPt = "Bei Fragen wenden Sie sich bitte an den Organisator.", NPt = "Buchungszeit", DPt = "Wann die Buchung geplant ist (Anfang bis Ende)", MPt = "Erstellt am", LPt = "Wann die Buchung ursprünglich erstellt wurde", qPt = "Anrufdetails", jPt = "Anruf-ID", FPt = "Anrufinformationen", VPt = "Stimmung", BPt = "Trennungsgrund", UPt = "Anrufzusammenfassung", WPt = "Transkription", GPt = "Ereignisdetails", HPt = "Agent", KPt = "Kein Transkript verfügbar", YPt = "Beachten Sie beim Testen dieses Workflows, dass SMS mindestens 15 Minuten im Voraus geplant werden müssen", ZPt = "Von Grund auf neu beginnen", QPt = "Erstellen Sie Ihren eigenen Workflow von Grund auf.", JPt = "Cal.ai-Vorlage", XPt = "KI-Agenten, die Meetings buchen, Erinnerungen senden und nachfassen!", eIt = "Stimme", tIt = "Stimme auswählen", nIt = "Wähle eine Stimme für deinen Agenten", oIt = "Wähle eine Stimme für deinen Agenten", rIt = "Eigenschaft", iIt = "Stimm-ID", aIt = "Stimme verwenden", sIt = "Aktuelle Stimme", cIt = "Eingehenden Agent einrichten", lIt = "Konfigurieren Sie einen KI-Agenten, um eingehende Anrufe auf Ihrer Telefonnummer zu bearbeiten", dIt = "Verbinden Sie zuerst eine Telefonnummer", uIt = "Agent für eingehende Anrufe einrichten", _It = "Agent für die Bearbeitung eingehender Anrufe konfigurieren", pIt = "Eingehende Anrufe", mIt = "Ausgehende Anrufe", fIt = "Einrichtung des Inbound-Agenten erfolgreich", gIt = "Inbound-Agent konfiguriert", hIt = "Inbound-Agent einrichten", vIt = "Bitte wählen Sie zuerst einen Ereignistyp aus", bIt = "Konfiguration bearbeiten", yIt = "Eingehende Anrufe können nur einen Ereignistyp buchen. Wählen Sie den Ereignistyp aus, für den Meetings geplant werden, wenn Anrufer Ihren Agenten erreichen.", $It = "Inbound-Agent für eingehende Anrufe einrichten", wIt = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Fügen Sie Ihre neuen Code-Zeilen über dieser hinzu ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", kIt = {
  identity_provider: $4e,
  trial_days_left: w4e,
  day_one: k4e,
  day_other: S4e,
  second_one: x4e,
  second_other: E4e,
  upgrade_now: T4e,
  untitled: A4e,
  accept_invitation: C4e,
  max_characters: z4e,
  min_characters: O4e,
  calcom_explained: P4e,
  calcom_explained_new_user: I4e,
  have_any_questions: R4e,
  reset_password_subject: N4e,
  verify_email_subject: D4e,
  verify_email_subject_verifying_email: M4e,
  check_your_email: L4e,
  old_email_address: q4e,
  new_email_address: j4e,
  verify_email_page_body: F4e,
  verify_email_banner_body: V4e,
  verify_email_email_header: B4e,
  verify_email_button: U4e,
  cal_ai_assistant: W4e,
  send_cal_video_transcription_emails: G4e,
  description_send_cal_video_transcription_emails: H4e,
  verify_email_change_description: K4e,
  verify_email_change_success_toast: Y4e,
  verify_email_change_failure_toast: Z4e,
  change_of_email: Q4e,
  change_of_email_toast: J4e,
  copy_somewhere_safe: X4e,
  verify_email_email_body: e3e,
  verify_email_by_code_email_body: t3e,
  verify_email_email_link_text: n3e,
  email_verification_code: o3e,
  email_verification_code_placeholder: r3e,
  incorrect_email_verification_code: i3e,
  email_sent: a3e,
  email_not_sent: s3e,
  event_declined_subject: c3e,
  event_cancelled_subject: l3e,
  event_reassigned_subject: d3e,
  event_request_declined: u3e,
  customize_calvideo_settings: _3e,
  calvideo_settings_description: p3e,
  disable_recording_for_guests: m3e,
  enable_automatic_transcription: f3e,
  enable_automatic_recording: g3e,
  video_options: h3e,
  edit_event: v3e,
  view_session_details: b3e,
  meeting_session_details: y3e,
  meeting_session: $3e,
  session_id: w3e,
  max_participants: k3e,
  unlimited: S3e,
  ongoing: x3e,
  ended: E3e,
  participants: T3e,
  anonymous_user: A3e,
  session_duration: C3e,
  no_meeting_sessions_found: z3e,
  not_available: O3e,
  disable_recording_for_organizer: P3e,
  disable_transcription_for_guests: I3e,
  disable_transcription_for_organizer: R3e,
  event_request_declined_recurring: N3e,
  event_request_cancelled: D3e,
  event_request_reassigned: M3e,
  event_reassigned_subtitle: L3e,
  organizer: q3e,
  reassigned_to: j3e,
  need_to_reschedule_or_cancel: F3e,
  you_can_view_booking_details_with_this_url: V3e,
  no_options_available: B3e,
  cancellation_reason: U3e,
  cancelled_by: W3e,
  cancellation_reason_host: G3e,
  cancellation_reason_placeholder: H3e,
  notify_attendee_cancellation_reason_warning: K3e,
  rejection_reason_placeholder: Y3e,
  rejection_reason: Z3e,
  rejection_reason_title: Q3e,
  rejection_reason_description: J3e,
  rejection_confirmation: X3e,
  manage_this_event: e6e,
  invite_team_member: t6e,
  invite_team_individual_segment: n6e,
  invite_team_bulk_segment: o6e,
  invite_team_notifcation_badge: r6e,
  your_event_has_been_scheduled: i6e,
  your_event_has_been_scheduled_recurring: a6e,
  accept_our_license: s6e,
  remove_banner_instructions: c6e,
  error_message: l6e,
  refund_failed_subject: d6e,
  refund_failed: u6e,
  check_with_provider_and_user: _6e,
  a_refund_failed: p6e,
  awaiting_payment_subject: m6e,
  meeting_awaiting_payment: f6e,
  dark_theme_contrast_error: g6e,
  light_theme_contrast_error: h6e,
  event_type_color_light_theme_contrast_error: v6e,
  event_type_color_dark_theme_contrast_error: b6e,
  payment_not_created_error: y6e,
  couldnt_charge_card_error: $6e,
  no_available_users_found_error: w6e,
  timeslot_unavailable_book_a_new_time: k6e,
  timeslot_unavailable_short: S6e,
  just_connected_description: x6e,
  unavailable_timeslot_title: E6e,
  booking_time_out_of_bounds_error: T6e,
  request_body_end_time_internal_error: A6e,
  create_calendar_event_error: C6e,
  update_calendar_event_error: z6e,
  delete_calendar_event_error: O6e,
  already_signed_up_for_this_booking_error: P6e,
  hosts_unavailable_for_booking: I6e,
  fixed_hosts_unavailable_for_booking: R6e,
  round_robin_host_unavailable_for_booking: N6e,
  help: D6e,
  price: M6e,
  paid: L6e,
  refunded: q6e,
  record: j6e,
  transcribe: F6e,
  payment: V6e,
  missing_card_fields: B6e,
  pay_now: U6e,
  general_prompt: W6e,
  transcription_powered_by_ai: G6e,
  start_or_stop_recording: H6e,
  begin_message: K6e,
  codebase_has_to_stay_opensource: Y6e,
  cannot_repackage_codebase: Z6e,
  acquire_license: Q6e,
  terms_summary: J6e,
  open_env: X6e,
  env_changed: e5e,
  accept_license: t5e,
  still_waiting_for_approval: n5e,
  event_is_still_waiting: o5e,
  no_result_found_for: r5e,
  no_more_results: i5e,
  no_results: a5e,
  load_more_results: s5e,
  integration_meeting_id: c5e,
  confirmed_event_type_subject: l5e,
  new_event_request: d5e,
  confirm_or_reject_request: u5e,
  check_bookings_page_to_confirm_or_reject: _5e,
  check_in_assistant: p5e,
  check_in_assistant_description: m5e,
  create_your_own_prompt: f5e,
  event_awaiting_approval: g5e,
  event_awaiting_approval_recurring: h5e,
  someone_requested_an_event: v5e,
  someone_requested_password_reset: b5e,
  password_reset_email_sent: y5e,
  password_reset_instructions: $5e,
  event_awaiting_approval_subject: w5e,
  event_still_awaiting_approval: k5e,
  booking_submitted_subject: S5e,
  download_recording_subject: x5e,
  download_transcript_email_subject: E5e,
  download_your_recording: T5e,
  download_your_transcripts: A5e,
  your_meeting_has_been_booked: C5e,
  event_type_has_been_rescheduled_on_time_date: z5e,
  event_type_has_been_updated: O5e,
  event_has_been_rescheduled: P5e,
  event_has_been_updated: I5e,
  your_event_has_been_rescheduled: R5e,
  request_reschedule_subtitle: N5e,
  request_reschedule_title_organizer: D5e,
  request_reschedule_subtitle_organizer: M5e,
  rescheduled_event_type_subject: L5e,
  requested_to_reschedule_subject_attendee: q5e,
  hi_user_name: j5e,
  ics_event_title: F5e,
  please_book_a_time_sometime_later: V5e,
  schedule_instead: B5e,
  new_event_subject: U5e,
  join_by_entrypoint: W5e,
  notes: G5e,
  manage_my_bookings: H5e,
  need_to_make_a_change: K5e,
  new_event_scheduled: Y5e,
  new_event_scheduled_recurring: Z5e,
  invitee_email: Q5e,
  invitee_timezone: J5e,
  time_left: X5e,
  event_type: ePe,
  duplicate_event_type: tPe,
  enter_meeting: nPe,
  video_call_provider: oPe,
  meeting_id: rPe,
  meeting_password: iPe,
  meeting_url: aPe,
  meeting_url_not_found: sPe,
  token_not_found: cPe,
  some_other_host_already_accepted_the_meeting: lPe,
  meeting_request_rejected: dPe,
  rejected_event_type_with_organizer: uPe,
  hi: _Pe,
  join_team: pPe,
  manage_this_team: mPe,
  team_info: fPe,
  join_meeting: gPe,
  request_another_invitation_email: hPe,
  you_have_been_invited: vPe,
  user_invited_you: bPe,
  hidden_team_member_title: yPe,
  hidden_team_member_message: $Pe,
  hidden_team_owner_message: wPe,
  link_expires: kPe,
  upgrade_to_per_seat: SPe,
  seat_options_doesnt_support_confirmation: xPe,
  multilocation_doesnt_support_seats: EPe,
  no_show_fee_doesnt_support_seats: TPe,
  seats_option_doesnt_support_multi_location: APe,
  team_upgrade_seats_details: CPe,
  team_upgrade_banner_description: zPe,
  upgrade_banner_action: OPe,
  team_upgraded_successfully: PPe,
  org_upgrade_banner_description: IPe,
  org_upgraded_successfully: RPe,
  use_link_to_reset_password: NPe,
  hey_there: DPe,
  there: MPe,
  forgot_your_password_calcom: LPe,
  delete_webhook_confirmation_message: qPe,
  confirm_delete_webhook: jPe,
  edit_webhook: FPe,
  delete_webhook: VPe,
  webhook_status: BPe,
  webhook_enabled: UPe,
  webhook_disabled: WPe,
  webhook_response: GPe,
  webhook_test: HPe,
  webhook_update_form: KPe,
  webhook_update_form_description: YPe,
  manage_your_webhook: ZPe,
  webhook_created_successfully: QPe,
  webhook_updated_successfully: JPe,
  webhook_removed_successfully: XPe,
  subscription_needed: eIe,
  subscription_needed_description: tIe,
  payload_template: nIe,
  dismiss: oIe,
  no_data_yet: rIe,
  ping_test: iIe,
  add_to_homescreen: aIe,
  upcoming: sIe,
  recurring: cIe,
  past: lIe,
  choose_a_file: dIe,
  upload_image: uIe,
  upload_target: _Ie,
  no_target: pIe,
  slide_zoom_drag_instructions: mIe,
  view_notifications: fIe,
  view_public_page: gIe,
  copy_public_page_link: hIe,
  copy_referral_link: vIe,
  sign_out: bIe,
  add_another: yIe,
  install_another: $Ie,
  until: wIe,
  powered_by: kIe,
  unavailable: SIe,
  set_work_schedule: xIe,
  change_bookings_availability: EIe,
  select: TIe,
  "2fa_confirm_current_password": "Bestätigen Sie Ihr aktuelles Passwort, um loszulegen.",
  "2fa_scan_image_or_use_code": "Scannen Sie das Bild mit der Authentifizierungs-App auf Ihrem Telefon oder geben Sie stattdessen den Textcode manuell ein.",
  text: AIe,
  your_phone_number: CIe,
  multiline_text: zIe,
  number: OIe,
  checkbox: PIe,
  is_required: IIe,
  make_field_required: RIe,
  required: NIe,
  optional: DIe,
  input_type: MIe,
  rejected: LIe,
  unconfirmed: qIe,
  guests: jIe,
  guest: FIe,
  web_conferencing_details_to_follow: VIe,
  confirmation: BIe,
  what_booker_should_provide: UIe,
  "404_the_user": "Der Benutzername",
  username: WIe,
  is_still_available: GIe,
  documentation: HIe,
  documentation_description: KIe,
  api_reference: YIe,
  api_reference_description: ZIe,
  blog: QIe,
  blog_description: JIe,
  join_our_community: XIe,
  "404_claim_entity_user": "Benutzername registrieren und Termine vergeben",
  popular_pages: eRe,
  register_now: tRe,
  register: nRe,
  page_doesnt_exist: oRe,
  no_active_phone_number_available: rRe,
  workflow_step_not_configured: iRe,
  check_spelling_mistakes_or_go_back: aRe,
  "404_page_not_found": "Fehler 404: Diese Seite konnte nicht gefunden werden.",
  booker_event_not_found: sRe,
  getting_started: cRe,
  "15min_meeting": "15 Minuten Termin",
  "30min_meeting": "30 Minuten Termin",
  secret: lRe,
  leave_blank_to_remove_secret: dRe,
  webhook_secret_key_description: uRe,
  secret_meeting: _Re,
  login_instead: pRe,
  create_account: mRe,
  get_started: fRe,
  confirm_password: gRe,
  reset_your_password: hRe,
  org_banner_instructions: vRe,
  email_change: bRe,
  create_your_account: yRe,
  create_your_calcom_account: $Re,
  sign_up: wRe,
  youve_been_logged_out: kRe,
  hope_to_see_you_soon: SRe,
  logged_out: xRe,
  please_try_again_and_contact_us: ERe,
  incorrect_2fa_code: TRe,
  no_account_exists: ARe,
  "2fa_enabled_instructions": "Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein.",
  "2fa_enter_six_digit_code": "Geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein.",
  create_an_account: CRe,
  dont_have_an_account: zRe,
  "2fa_code": "Zwei-Faktor-Code",
  sign_in_account: ORe,
  sign_in: PRe,
  go_back_login: IRe,
  error_during_login: RRe,
  request_password_reset: NRe,
  send_invite: DRe,
  forgot_password: MRe,
  forgot: LRe,
  done: qRe,
  all_done: jRe,
  all: FRe,
  yours: VRe,
  available_apps: BRe,
  available_apps_lower_case: URe,
  available_apps_desc: WRe,
  fixed_host_helper: GRe,
  round_robin_groups_helper: HRe,
  round_robin_helper: KRe,
  check_email_reset_password: YRe,
  finish: ZRe,
  organization_general_description: QRe,
  few_sentences_about_yourself: JRe,
  nearly_there: XRe,
  nearly_there_instructions: eNe,
  set_availability_instructions: tNe,
  set_availability: nNe,
  set_availbility_description: oNe,
  share_a_link_or_embed: rNe,
  share_a_link_or_embed_description: iNe,
  availability_settings: aNe,
  continue_without_calendar: sNe,
  continue_with: cNe,
  connect_your_calendar: lNe,
  connect_your_video_app: dNe,
  connect_your_video_app_instructions: uNe,
  connect_your_calendar_instructions: _Ne,
  set_up_later: pNe,
  current_time: mNe,
  details: fNe,
  welcome: gNe,
  welcome_back: hNe,
  welcome_to_calcom: vNe,
  welcome_instructions: bNe,
  connect_caldav: yNe,
  connect_ics_feed: $Ne,
  connect: wNe,
  try_for_free: kNe,
  create_booking_link_with_calcom: SNe,
  who: xNe,
  what: ENe,
  when: TNe,
  where: ANe,
  add_to_calendar: CNe,
  add_to_calendar_description: zNe,
  add_events_to: ONe,
  add_another_calendar: PNe,
  other: INe,
  email_sign_in_subject: RNe,
  round_robin_emailed_you_and_attendees: NNe,
  round_robin_emailed_host_and_attendee: DNe,
  emailed_host_and_attendee: MNe,
  emailed_host_and_attendee_recurring: LNe,
  round_robin_emailed_you_and_attendees_recurring: qNe,
  round_robin_emailed_host_and_attendee_recurring: jNe,
  emailed_you_and_any_other_attendees: FNe,
  needs_to_be_confirmed_or_rejected: VNe,
  needs_to_be_confirmed_or_rejected_recurring: BNe,
  user_needs_to_confirm_or_reject_booking: UNe,
  user_needs_to_confirm_or_reject_booking_recurring: WNe,
  meeting_is_scheduled: GNe,
  meeting_is_scheduled_recurring: HNe,
  booking_submitted: KNe,
  booking_submitted_recurring: YNe,
  booking_confirmed: ZNe,
  booking_confirmed_recurring: QNe,
  warning_recurring_event_payment: JNe,
  warning_payment_recurring_event: XNe,
  enter_new_password: eDe,
  reset_password: tDe,
  change_your_password: nDe,
  show_password: oDe,
  hide_password: rDe,
  try_again: iDe,
  request_is_expired: aDe,
  reset_instructions: sDe,
  request_is_expired_instructions: cDe,
  whoops: lDe,
  login: dDe,
  success: uDe,
  failed: _De,
  password_has_been_reset_login: pDe,
  layout: mDe,
  bookerlayout_default_title: fDe,
  bookerlayout_description: gDe,
  bookerlayout_user_settings_title: hDe,
  bookerlayout_user_settings_description: vDe,
  bookerlayout_month_view: bDe,
  bookerlayout_week_view: yDe,
  bookerlayout_column_view: $De,
  bookerlayout_error_min_one_enabled: wDe,
  bookerlayout_error_default_not_enabled: kDe,
  bookerlayout_error_unknown_layout: SDe,
  bookerlayout_override_global_settings: xDe,
  unexpected_error_try_again: EDe,
  sunday_time_error: TDe,
  monday_time_error: ADe,
  tuesday_time_error: CDe,
  wednesday_time_error: zDe,
  thursday_time_error: ODe,
  friday_time_error: PDe,
  saturday_time_error: IDe,
  error_end_time_before_start_time: RDe,
  error_end_time_next_day: NDe,
  back_to_bookings: DDe,
  free_to_pick_another_event_type: MDe,
  cancelled: LDe,
  no_booking: qDe,
  awaiting_host: jDe,
  cancellation_successful: FDe,
  really_cancel_booking: VDe,
  cannot_cancel_booking: BDe,
  reschedule_instead: UDe,
  event_is_in_the_past: WDe,
  cancelling_event_recurring: GDe,
  cancelling_all_recurring: HDe,
  error_with_status_code_occured: KDe,
  error_event_type_url_duplicate: YDe,
  error_event_type_unauthorized_create: ZDe,
  error_event_type_unauthorized_update: QDe,
  error_workflow_unauthorized_create: JDe,
  error_schedule_unauthorized_create: XDe,
  booking_already_cancelled: eMe,
  booking_already_accepted_rejected: tMe,
  go_back_home: nMe,
  or_go_back_home: oMe,
  no_meeting_found: rMe,
  no_meeting_found_description: iMe,
  no_status_bookings_yet: aMe,
  no_status_bookings_yet_description: sMe,
  event_between_users: cMe,
  bookings: lMe,
  booking_not_found: dMe,
  bookings_description: uMe,
  upcoming_bookings: _Me,
  recurring_bookings: pMe,
  past_bookings: mMe,
  cancelled_bookings: fMe,
  unconfirmed_bookings: gMe,
  unconfirmed_bookings_tooltip: hMe,
  on: vMe,
  and: bMe,
  calendar_shows_busy_between: yMe,
  troubleshoot: $Me,
  troubleshoot_description: wMe,
  overview_of_day: kMe,
  hover_over_bold_times_tip: SMe,
  start_time: xMe,
  end_time: EMe,
  buffer_time: TMe,
  before_event: AMe,
  after_event: CMe,
  event_buffer_default: zMe,
  buffer: OMe,
  your_day_starts_at: PMe,
  your_day_ends_at: IMe,
  launch_troubleshooter: RMe,
  troubleshoot_availability: NMe,
  change_available_times: DMe,
  change_your_available_times: MMe,
  change_start_end: LMe,
  change_start_end_buffer: qMe,
  current_start_date: jMe,
  start_end_changed_successfully: FMe,
  and_end_at: VMe,
  light: BMe,
  dark: UMe,
  automatically_adjust_theme: WMe,
  user_dynamic_booking_disabled: GMe,
  allow_dynamic_booking_tooltip: HMe,
  allow_dynamic_booking: KMe,
  dynamic_booking: YMe,
  allow_seo_indexing: ZMe,
  seo_indexing: QMe,
  allow_browser_notifications: JMe,
  you_have_denied_notifications: XMe,
  disable_browser_notifications: eLe,
  browser_notifications_turned_on: tLe,
  browser_notifications_turned_off: nLe,
  browser_notifications_denied: oLe,
  please_allow_notifications: rLe,
  push_notifications: iLe,
  push_notifications_description: aLe,
  browser_notifications_not_supported: sLe,
  email: cLe,
  email_placeholder: lLe,
  full_name: dLe,
  browse_api_documentation: uLe,
  leverage_our_api: _Le,
  create_webhook: pLe,
  instant_meeting: mLe,
  booking_cancelled: fLe,
  booking_rescheduled: gLe,
  recording_ready: hLe,
  recording_transcription_generated: vLe,
  booking_created: bLe,
  booking_rejected: yLe,
  booking_requested: $Le,
  booking_payment_initiated: wLe,
  meeting_ended: kLe,
  form_submitted: SLe,
  form_submitted_no_event: xLe,
  booking_paid: ELe,
  ooo_created: TLe,
  booking_no_show_updated: ALe,
  event_triggers: CLe,
  subscriber_url: zLe,
  create_new_webhook: OLe,
  webhooks: PLe,
  team_webhooks: ILe,
  create_new_webhook_to_account: RLe,
  new_webhook: NLe,
  receive_cal_meeting_data: DLe,
  receive_cal_event_meeting_data: MLe,
  responsive_fullscreen_iframe: LLe,
  loading: qLe,
  deleting: jLe,
  standard_iframe: FLe,
  developer: VLe,
  manage_developer_settings: BLe,
  iframe_embed: ULe,
  embed_calcom: WLe,
  integrate_using_embed_or_webhooks: GLe,
  schedule_a_meeting: HLe,
  view_and_manage_billing_details: KLe,
  view_and_edit_billing_details: YLe,
  go_to_billing_portal: ZLe,
  need_anything_else: QLe,
  further_billing_help: JLe,
  contact: XLe,
  our_support_team: eqe,
  contact_our_support_team: tqe,
  uh_oh: nqe,
  no_event_types_have_been_setup: oqe,
  edit_logo: rqe,
  upload_a_logo: iqe,
  upload_logo: aqe,
  remove_logo: sqe,
  enable: cqe,
  code: lqe,
  code_is_incorrect: dqe,
  add_time_availability: uqe,
  add_an_extra_layer_of_security: _qe,
  "2fa": "Zwei-Faktor-Authentifizierung",
  "2fa_disabled": "Zwei-Faktor-Authentifizierung kann nur für E-Mail- und Passwort-Authentifizierung aktiviert werden",
  enable_2fa: pqe,
  disable_2fa: mqe,
  disable_2fa_recommendation: fqe,
  error_disabling_2fa: gqe,
  error_enabling_2fa: hqe,
  security: vqe,
  manage_account_security: bqe,
  password: yqe,
  password_updated_successfully: $qe,
  password_has_been_changed: wqe,
  error_changing_password: kqe,
  session_timeout_changed: Sqe,
  session_timeout_change_error: xqe,
  something_went_wrong: Eqe,
  something_doesnt_look_right: Tqe,
  please_try_again: Aqe,
  super_secure_new_password: Cqe,
  new_password: zqe,
  your_old_password: Oqe,
  current_password: Pqe,
  change_password: Iqe,
  change_secret: Rqe,
  new_password_matches_old_password: Nqe,
  forgotten_secret_description: Dqe,
  current_incorrect_password: Mqe,
  password_hint_caplow: Lqe,
  password_hint_min: qqe,
  password_hint_admin_min: jqe,
  password_hint_num: Fqe,
  max_limit_allowed_hint: Vqe,
  invalid_password_hint: Bqe,
  incorrect_password: Uqe,
  incorrect_email_password: Wqe,
  use_setting: Gqe,
  am_pm: Hqe,
  time_options: Kqe,
  january: Yqe,
  february: Zqe,
  march: Qqe,
  april: Jqe,
  may: Xqe,
  june: e9e,
  july: t9e,
  august: n9e,
  september: o9e,
  october: r9e,
  november: i9e,
  december: a9e,
  monday: s9e,
  tuesday: c9e,
  wednesday: l9e,
  thursday: d9e,
  friday: u9e,
  saturday: _9e,
  sunday: p9e,
  all_booked_today: m9e,
  slots_load_fail: f9e,
  additional_guests: g9e,
  your_name: h9e,
  your_full_name: v9e,
  no_name: b9e,
  enter_number_between_range: y9e,
  continue_as_guest_description: $9e,
  email_address: w9e,
  enter_valid_email: k9e,
  please_schedule_future_call: S9e,
  location: x9e,
  address: E9e,
  enter_address: T9e,
  in_person_attendee_address: A9e,
  somewhere_else: C9e,
  custom_attendee_location: z9e,
  continue_as_guest: O9e,
  join_as_guest: P9e,
  ideal_for_one_time_calls: I9e,
  any_location: R9e,
  yes: N9e,
  no: D9e,
  additional_notes: M9e,
  booking_fail: L9e,
  reschedule_fail: q9e,
  share_additional_notes: j9e,
  booking_confirmation: F9e,
  booking_reschedule_confirmation: V9e,
  in_person_meeting: B9e,
  in_person: U9e,
  link_meeting: W9e,
  phone_number: G9e,
  attendee_phone_number: H9e,
  organizer_phone_number: K9e,
  enter_phone_number: Y9e,
  reschedule: Z9e,
  reschedule_this: Q9e,
  book_a_team_member: J9e,
  or: X9e,
  go_back: eje,
  email_or_username: tje,
  send_invite_email: nje,
  role: oje,
  edit_role: rje,
  view_role: ije,
  edit_team: aje,
  editing_user: sje,
  editing_org: cje,
  edit_or_manage_webhooks: lje,
  reject: dje,
  reject_all: uje,
  accept: _je,
  leave: pje,
  profile: mje,
  my_team_url: fje,
  my_teams: gje,
  team_name: hje,
  your_team_name: vje,
  team_updated_successfully: bje,
  your_team_updated_successfully: yje,
  your_org_updated_successfully: $je,
  error_copying_to_clipboard: wje,
  about: kje,
  team_description: Sje,
  organization_id: xje,
  organization_id_copied: Eje,
  org_description: Tje,
  team_id: Aje,
  team_id_copied: Cje,
  members: zje,
  organization_members: Oje,
  member: Pje,
  number_member_one: Ije,
  number_member_other: Rje,
  number_selected: Nje,
  owner: Dje,
  admin: Mje,
  admin_api: Lje,
  administrator_user: qje,
  lets_create_first_administrator_user: jje,
  admin_user_created: Fje,
  admin_user_created_description: Vje,
  new_member: Bje,
  invite: Uje,
  add_team_members: Wje,
  add_org_members: Gje,
  add_team_members_description: Hje,
  add_team_member: Kje,
  invite_new_member: Yje,
  invite_new_member_description: Zje,
  invite_new_team_member: Qje,
  upload_csv_file: Jje,
  invite_via_email: Xje,
  change_member_role: eFe,
  disable_cal_branding: tFe,
  disable_cal_branding_description: nFe,
  hide_book_a_team_member: oFe,
  hide_book_a_team_member_description: rFe,
  danger_zone: iFe,
  account_deletion_cannot_be_undone: aFe,
  team_deletion_cannot_be_undone: sFe,
  back: cFe,
  cancel: lFe,
  cancel_all_remaining: dFe,
  apply: uFe,
  cancel_event: _Fe,
  continue: "Weiter",
  confirm: pFe,
  confirm_all: mFe,
  disband_team: fFe,
  disband_team_confirmation_message: gFe,
  disband_org: hFe,
  disband_org_confirmation_message: vFe,
  remove_member_confirmation_message: bFe,
  confirm_disband_team: yFe,
  confirm_remove_member: $Fe,
  confirm_subscription_cancellation: wFe,
  cancel_subscription: kFe,
  cancel_subscription_description: SFe,
  remove_member: xFe,
  manage_your_team: EFe,
  no_teams: TFe,
  no_teams_description: AFe,
  submit: CFe,
  confirm_remove_attribute: zFe,
  remove_attribute: OFe,
  remove_attribute_confirmation_message: PFe,
  delete: "Löschen",
  update: IFe,
  save: RFe,
  pending: NFe,
  open_options: DFe,
  copy_link: MFe,
  share: LFe,
  share_event: qFe,
  copy_link_team: jFe,
  leave_team: FFe,
  confirm_leave_team: VFe,
  leave_team_confirmation_message: BFe,
  user_from_team: UFe,
  preview: WFe,
  link_copied: GFe,
  copied: HFe,
  private_link_copied: KFe,
  link_shared: YFe,
  title: ZFe,
  description: QFe,
  apps_status: JFe,
  quick_video_meeting: XFe,
  scheduling_type: e8e,
  preview_team: t8e,
  collective: n8e,
  collective_description: o8e,
  duration: r8e,
  available_durations: i8e,
  default_duration: a8e,
  default_duration_no_options: s8e,
  multiple_duration_mins: c8e,
  multiple_duration_timeUnit: l8e,
  multiple_duration_timeUnit_short: d8e,
  minutes: u8e,
  use_cal_ai_to_make_call_description: _8e,
  termination_uri: p8e,
  sip_trunk_username: m8e,
  sip_trunk_password: f8e,
  nickname: g8e,
  delete_phone_number: h8e,
  workflow_validation_failed: v8e,
  workflow_validation_empty_fields: b8e,
  workflow_validation_unverified_contacts: y8e,
  supercharge_your_workflows_with_cal_ai: $8e,
  supercharge_your_workflows_with_cal_ai_description: w8e,
  phone_number_imported_successfully: k8e,
  phone_number_deleted_successfully: S8e,
  delete_phone_number_confirmation: x8e,
  yes_delete_phone_number: E8e,
  phone_number_info_tooltip: T8e,
  termination_uri_info_tooltip: A8e,
  sip_trunk_username_info_tooltip: C8e,
  sip_trunk_password_info_tooltip: z8e,
  nickname_info_tooltip: O8e,
  save_and_test_call: P8e,
  call_initiated_successfully: I8e,
  please_enter_phone_number: R8e,
  agent_updated_successfully: N8e,
  agent_created_successfully: D8e,
  agent_event_type_updated_successfully: M8e,
  phone_number_unsubscribed_successfully: L8e,
  general_prompt_description: q8e,
  prompt: j8e,
  call_to: F8e,
  make_test_call_to_verify_configuration: V8e,
  initial_message: B8e,
  initial_message_description: U8e,
  having_trouble_importing: W8e,
  learn: G8e,
  learn_how_to_get_your_terminator: H8e,
  phone_number_subscription_cancelled_successfully: K8e,
  updating: Y8e,
  round_robin: Z8e,
  hi_how_are_you_doing: Q8e,
  round_robin_description: J8e,
  managed_event: X8e,
  username_placeholder: e7e,
  managed_event_description: t7e,
  managed: n7e,
  managed_event_url_clarification: o7e,
  assign_to: r7e,
  enter_phone_number_to_test_call: i7e,
  make_test_call: a7e,
  create_new_workflow_agent: s7e,
  create_new_workflow_agent_description: c7e,
  phone_number_for_ai_call: l7e,
  buy_a_phone_number_or_import_one_you_already_have: d7e,
  test_agent: u7e,
  test_web_call: _7e,
  phone_numbers: p7e,
  unsubscribe: m7e,
  delete_workflow_step: f7e,
  unsubscribe_phone_number: g7e,
  buy_a_new_number: h7e,
  only_us_phone_numbers_can_be_purchased_here: v7e,
  buy_number_for_x_per_month: b7e,
  supported_call_destinations: y7e,
  no_phone_number_connected: $7e,
  failed_to_get_workflow_step_id: w7e,
  cal_ai_agent: k7e,
  test_cal_ai_agent: S7e,
  are_you_sure_you_want_to_delete_workflow_step: x7e,
  do_you_still_want_to_unsubscribe: E7e,
  the_action_will_disconnect_phone_number: T7e,
  cal_ai_phone_numbers: A7e,
  connect_phone_number: C7e,
  cal_ai_phone_numbers_description: z7e,
  import_number: O7e,
  this_action_will_also: P7e,
  import_phone_number: I7e,
  active_subscription: R7e,
  cancel_your_phone_number_subscription: N7e,
  delete_associated_phone_number: D7e,
  unauthorized_create_workflow: M7e,
  import_phone_number_description: L7e,
  phone_number_cost: q7e,
  buy_new_number: j7e,
  buy_number_cost_x_per_month: F7e,
  area_code_optional: V7e,
  no_phone_numbers: B7e,
  phone_number_purchased_successfully: U7e,
  cancel_phone_number_subscription: W7e,
  yes_cancel_subscription: G7e,
  cancel_phone_number_subscription_confirmation: H7e,
  add_members: K7e,
  add_members_no_ellipsis: Y7e,
  no_assigned_members: Z7e,
  assigned_to: Q7e,
  you_must_be_logged_in_to: J7e,
  start_assigning_members_above: X7e,
  locked_fields_admin_description: eVe,
  unlocked_fields_admin_description: tVe,
  locked_fields_member_description: nVe,
  unlocked_fields_member_description: oVe,
  url: rVe,
  hidden: iVe,
  readonly: aVe,
  one_time_link: sVe,
  plan_description: cVe,
  plan_upgrade_invitation: lVe,
  plan_upgrade: dVe,
  plan_upgrade_teams: uVe,
  plan_upgrade_instructions: _Ve,
  event_types_page_title: pVe,
  event_types_page_subtitle: mVe,
  new: "Neu",
  new_event_type_btn: fVe,
  new_event_type_heading: gVe,
  new_event_type_description: hVe,
  event_type_created_successfully: vVe,
  event_type_updated_successfully: bVe,
  event_type_deleted_successfully: yVe,
  hours: $Ve,
  people: wVe,
  your_email: kVe,
  change_avatar: SVe,
  upload_avatar: xVe,
  language: EVe,
  timezone: TVe,
  first_day_of_week: AVe,
  repeats_up_to_one: CVe,
  repeats_up_to_other: zVe,
  every_for_freq: OVe,
  event_remaining_one: PVe,
  event_remaining_other: IVe,
  repeats_every: RVe,
  occurrence_one: NVe,
  occurrence_other: DVe,
  weekly_one: MVe,
  weekly_other: LVe,
  monthly_one: qVe,
  monthly_other: jVe,
  yearly_one: FVe,
  yearly_other: VVe,
  plus_more: BVe,
  max: UVe,
  single_theme: WVe,
  brand_color: GVe,
  light_brand_color: HVe,
  dark_brand_color: KVe,
  light_event_type_color: YVe,
  dark_event_type_color: ZVe,
  file_not_named: QVe,
  create_team: JVe,
  name: XVe,
  nameless_team: eBe,
  oauth_clients: tBe,
  oauth_clients_description: nBe,
  create_oauth_client: oBe,
  create_oauth_client_description: rBe,
  oauth_client_deletion_message: iBe,
  create_new_team_description: aBe,
  create_new_team: sBe,
  booking_redirect_uri: cBe,
  booking_cancel_redirect_uri: lBe,
  booking_reschedule_redirect_uri: dBe,
  booking_conflict_error: uBe,
  open_invitations: _Be,
  new_team: pBe,
  create_first_team_and_invite_others: mBe,
  create_team_to_get_started: fBe,
  teams: gBe,
  team: hBe,
  organization: vBe,
  team_billing: bBe,
  team_billing_description: yBe,
  upgrade_to_flexible_pro_title: $Be,
  upgrade_to_flexible_pro_message: wBe,
  changed_team_billing_info: kBe,
  create_manage_teams_collaborative: SBe,
  only_available_on_pro_plan: xBe,
  remove_cal_branding_description: EBe,
  edit_profile_info_description: TBe,
  change_email_tip: ABe,
  little_something_about: CBe,
  profile_updated_successfully: zBe,
  your_user_profile_updated_successfully: OBe,
  your_upgrade_is_here: PBe,
  your_upgrade_is_here_description: IBe,
  you_are_all_set: RBe,
  you_are_all_set_description: NBe,
  user_cannot_found_db: DBe,
  embed_and_webhooks: MBe,
  enabled: LBe,
  disabled: qBe,
  disable: jBe,
  billing: FBe,
  here: VBe,
  manage_your_billing_info: BBe,
  availability: UBe,
  edit_availability: WBe,
  configure_availability: GBe,
  copy_times_to: HBe,
  copy_times_to_tooltip: KBe,
  change_weekly_schedule: YBe,
  logo: ZBe,
  error: QBe,
  at_least_characters_one: JBe,
  at_least_characters_other: XBe,
  team_logo: eUe,
  add_location: tUe,
  attendees: nUe,
  add_attendees: oUe,
  show_advanced_settings: rUe,
  hide_advanced_settings: iUe,
  event_name: aUe,
  event_name_in_calendar: sUe,
  event_name_tooltip: cUe,
  meeting_with_user: lUe,
  additional_inputs: dUe,
  additional_input_description: uUe,
  label: _Ue,
  placeholder: pUe,
  display_add_to_calendar_organizer: mUe,
  display_email_as_organizer: fUe,
  if_enabled_email_address_as_organizer: gUe,
  reconnect_calendar_to_use: hUe,
  type: vUe,
  edit: bUe,
  add_input: yUe,
  disable_notes: $Ue,
  disable_notes_description: wUe,
  requires_confirmation_description: kUe,
  requires_confirmation_will_block_slot_description: SUe,
  recurring_event: xUe,
  recurring_event_description: EUe,
  connect_and_join: TUe,
  cannot_be_used_with_paid_event_types: AUe,
  warning_payment_instant_meeting_event: CUe,
  warning_instant_meeting_experimental: zUe,
  starting: OUe,
  disable_guests: PUe,
  disable_guests_description: IUe,
  private_link: RUe,
  enable_private_url: NUe,
  private_link_label: DUe,
  private_link_hint: MUe,
  copy_private_link: LUe,
  copy_private_link_to_event: qUe,
  private_link_description: jUe,
  multiple_private_links_title: FUe,
  multiple_private_links_description: VUe,
  add_a_multiple_private_link: BUe,
  multiple_private_link_copied: UUe,
  invitees_can_schedule: WUe,
  date_range: GUe,
  calendar_days: HUe,
  business_days: KUe,
  set_address_place: YUe,
  set_link_meeting: ZUe,
  managed_event_field_parent_control_disabled: QUe,
  cal_invitee_phone_number_scheduling: JUe,
  cal_provide_google_meet_location: XUe,
  cal_provide_zoom_meeting_url: eWe,
  cal_provide_tandem_meeting_url: tWe,
  cal_provide_video_meeting_url: nWe,
  cal_provide_jitsi_meeting_url: oWe,
  cal_provide_huddle01_meeting_url: rWe,
  cal_provide_teams_meeting_url: iWe,
  require_payment: aWe,
  you_need_to_add_a_name: sWe,
  commission_per_transaction: cWe,
  event_type_updated_successfully_description: lWe,
  hide_event_type: dWe,
  edit_location: uWe,
  into_the_future: _We,
  when_booked_with_less_than_notice: pWe,
  within_date_range: mWe,
  indefinitely_into_future: fWe,
  add_new_custom_input_field: gWe,
  quick_chat: hWe,
  add_new_team_event_type: vWe,
  add_new_event_type: bWe,
  new_event_type_to_book_description: yWe,
  length: $We,
  minimum_booking_notice: wWe,
  offset_toggle: kWe,
  offset_toggle_description: SWe,
  offset_start: xWe,
  offset_start_description: EWe,
  slot_interval: TWe,
  slot_interval_default: AWe,
  delete_event_type: CWe,
  delete_managed_event_type: zWe,
  delete_event_type_description: OWe,
  delete_managed_event_type_description_1: PWe,
  delete_managed_event_type_description_2: IWe,
  confirm_delete_event_type: RWe,
  delete_account: NWe,
  confirm_delete_account: DWe,
  delete_account_confirmation_message: MWe,
  integrations: LWe,
  apps: qWe,
  apps_description: jWe,
  apps_listing: FWe,
  category_apps: VWe,
  app_store: BWe,
  app_store_description: UWe,
  connect_your_video: WWe,
  settings: GWe,
  event_type_moved_successfully: HWe,
  next_step_text: KWe,
  next_step: YWe,
  prev_step: ZWe,
  install: QWe,
  start_paid_trial: JWe,
  installed: XWe,
  active_install_one: eGe,
  active_install_other: tGe,
  globally_install: nGe,
  app_successfully_installed: oGe,
  app_could_not_be_installed: rGe,
  disconnect: iGe,
  embed_your_calendar: aGe,
  connect_your_favourite_apps: sGe,
  automation: cGe,
  configure_how_your_event_types_interact: lGe,
  toggle_calendars_conflict: dGe,
  connect_additional_calendar: uGe,
  calendar_updated_successfully: _Ge,
  check_here: pGe,
  conferencing: mGe,
  calendar: fGe,
  payments: gGe,
  not_installed: hGe,
  error_password_mismatch: vGe,
  error_required_field: bGe,
  status: yGe,
  team_view_user_availability: $Ge,
  team_view_user_availability_disabled: wGe,
  set_as_away: kGe,
  set_as_free: SGe,
  toggle_away_error: xGe,
  user_away: EGe,
  user_away_description: TGe,
  meet_people_with_the_same_tokens: AGe,
  only_book_people_and_allow: CGe,
  account_created_with_identity_provider: zGe,
  account_managed_by_identity_provider: OGe,
  account_managed_by_identity_provider_description: PGe,
  account_managed_by_identity_provider_error: IGe,
  user_creation_error: RGe,
  signin_with_google: NGe,
  signin_with_saml: DGe,
  signin_with_saml_oidc: MGe,
  continue_with_email: LGe,
  continue_with_google: qGe,
  last_used: jGe,
  you_will_need_to_generate: FGe,
  import: "Importieren",
  import_from: VGe,
  access_token: BGe,
  visit_roadmap: UGe,
  featured_categories: WGe,
  feature_flags: GGe,
  admin_flags_description: HGe,
  popular_categories: KGe,
  number_apps_one: YGe,
  number_apps_other: ZGe,
  trending_apps: QGe,
  most_popular: JGe,
  installed_apps: XGe,
  free_to_use_apps: eHe,
  no_category_apps: tHe,
  all_apps: nHe,
  no_category_apps_description_calendar: oHe,
  no_category_apps_description_conferencing: rHe,
  no_category_apps_description_payment: iHe,
  no_category_apps_description_analytics: aHe,
  no_category_apps_description_automation: sHe,
  no_category_apps_description_other: cHe,
  no_category_apps_description_messaging: lHe,
  no_category_apps_description_crm: dHe,
  installed_app_calendar_description: uHe,
  installed_app_payment_description: _He,
  installed_app_analytics_description: pHe,
  installed_app_other_description: mHe,
  installed_app_conferencing_description: fHe,
  installed_app_automation_description: gHe,
  installed_app_messaging_description: hHe,
  installed_app_crm_description: vHe,
  analytics: bHe,
  empty_installed_apps_headline: yHe,
  empty_installed_apps_description: $He,
  empty_installed_apps_button: wHe,
  manage_your_connected_apps: kHe,
  browse_apps: SHe,
  features: xHe,
  permissions: EHe,
  terms_and_privacy: THe,
  published_by: AHe,
  subscribe: CHe,
  buy: zHe,
  install_app: OHe,
  categories: PHe,
  pricing: IHe,
  learn_more: RHe,
  try_now: NHe,
  privacy_policy: DHe,
  terms_of_service: MHe,
  remove: LHe,
  add: qHe,
  installed_other: jHe,
  verify_wallet: FHe,
  create_events_on: VHe,
  enterprise_license: BHe,
  enterprise_license_locally: UHe,
  enterprise_license_sales: WHe,
  missing_license: GHe,
  next_steps: HHe,
  acquire_commercial_license: KHe,
  the_infrastructure_plan: YHe,
  prisma_studio_tip: ZHe,
  prisma_studio_tip_description: QHe,
  contact_sales: JHe,
  error_404: XHe,
  default: "Standard",
  set_to_default: eKe,
  new_schedule_btn: tKe,
  add_new_schedule: nKe,
  add_new_calendar: oKe,
  set_calendar: rKe,
  delete_schedule: iKe,
  delete_schedule_description: aKe,
  schedule_created_successfully: sKe,
  availability_updated_successfully: cKe,
  schedule_deleted_successfully: lKe,
  default_schedule_name: dKe,
  new_schedule_heading: uKe,
  new_schedule_description: _Ke,
  requires_ownership_of_a_token: pKe,
  example_name: mKe,
  time_format: fKe,
  "12_hour": "12 Stunden",
  "24_hour": "24 Stunden",
  "12_hour_short": "12 Std",
  "24_hour_short": "24 Std",
  redirect_success_booking: gKe,
  you_are_being_redirected: hKe,
  external_redirect_url: vKe,
  redirect_url_description: bKe,
  duplicate: yKe,
  offer_seats: $Ke,
  offer_seats_description: wKe,
  seats_available_one: kKe,
  seats_available_other: SKe,
  seats_nearly_full: xKe,
  seats_half_full: EKe,
  number_of_seats: TKe,
  set_instant_meeting_expiry_time_offset_description: AKe,
  enter_number_of_seats: CKe,
  you_can_manage_your_schedules: zKe,
  booking_full: OKe,
  api_keys: PKe,
  api_key: IKe,
  test_api_key: RKe,
  test_passed: NKe,
  test_failed: DKe,
  provide_api_key: MKe,
  api_key_modal_subtitle: LKe,
  api_key_modal_subtitle_platform: qKe,
  api_keys_subtitle: jKe,
  create_api_key: FKe,
  personal_note: VKe,
  personal_note_placeholder: BKe,
  api_key_no_note: UKe,
  api_key_never_expires: WKe,
  edit_api_key: GKe,
  success_api_key_created: HKe,
  success_api_key_edited: KKe,
  create: YKe,
  success_api_key_created_bold_tagline: ZKe,
  you_will_only_view_it_once: QKe,
  copy_to_clipboard: JKe,
  enabled_after_update: XKe,
  enabled_after_update_description: eYe,
  confirm_delete_api_key: tYe,
  disable_rescheduling: nYe,
  description_disable_rescheduling: oYe,
  allow_rescheduling_cancelled_bookings: rYe,
  description_allow_rescheduling_cancelled_bookings: iYe,
  disable_cancelling: aYe,
  description_disable_cancelling: sYe,
  revoke_api_key: cYe,
  api_key_copied: lYe,
  api_key_expires_on: dYe,
  delete_api_key_confirm_title: uYe,
  copy: _Ye,
  expire_date: pYe,
  expired: mYe,
  never_expires: fYe,
  expires: gYe,
  request_reschedule_booking: hYe,
  reason_for_reschedule: vYe,
  book_a_new_time: bYe,
  reschedule_request_sent: yYe,
  reschedule_modal_description: $Ye,
  reason_for_reschedule_request: wYe,
  send_reschedule_request: kYe,
  edit_booking: SYe,
  reschedule_booking: xYe,
  former_time: EYe,
  confirmation_page_gif: TYe,
  search: AYe,
  impersonate: CYe,
  user_impersonation_heading: zYe,
  user_impersonation_description: OYe,
  team_impersonation_description: PYe,
  cal_signup_description: IYe,
  make_org_private: RYe,
  make_org_private_description: NYe,
  make_team_private: DYe,
  make_team_private_description: MYe,
  you_cannot_see_team_members: LYe,
  you_cannot_see_teams_of_org: qYe,
  allow_multiple_durations: jYe,
  impersonate_user_tip: FYe,
  impersonating_user_warning: VYe,
  impersonating_stop_instructions: BYe,
  event_location_changed: UYe,
  new_guests_added: WYe,
  location_changed_event_type_subject: GYe,
  guests_added_event_type_subject: HYe,
  current_location: KYe,
  new_location: YYe,
  session: ZYe,
  session_description: QYe,
  session_timeout_after: JYe,
  session_timeout: XYe,
  session_timeout_description: eZe,
  no_location: tZe,
  set_location: nZe,
  update_location: oZe,
  location_updated: rZe,
  location_update_failed: iZe,
  guests_added: aZe,
  unable_to_add_guests: sZe,
  email_validation_error: cZe,
  emails_must_be_unique_valid: lZe,
  url_validation_error: dZe,
  place_where_cal_widget_appear: uZe,
  create_update_react_component: _Ze,
  copy_code: pZe,
  code_copied: mZe,
  how_you_want_add_cal_site: fZe,
  choose_ways_put_cal_site: gZe,
  setting_up_zapier: hZe,
  setting_up_make: vZe,
  generate_api_key: bZe,
  generate_api_key_description: yZe,
  your_unique_api_key: $Ze,
  copy_safe_api_key: wZe,
  zapier_setup_instructions: kZe,
  make_setup_instructions_1: SZe,
  make_setup_instructions_2: xZe,
  make_setup_instructions_3: EZe,
  make_setup_instructions_4: TZe,
  make_setup_instructions_5: AZe,
  make_setup_instructions_6: CZe,
  install_zapier_app: zZe,
  install_make_app: OZe,
  app_installation: PZe,
  app_not_installed: IZe,
  visit_our_app_store: RZe,
  connect_apple_server: NZe,
  calendar_url: DZe,
  apple_server_generate_password: MZe,
  unable_to_add_apple_calendar: LZe,
  credentials_stored_encrypted: qZe,
  it_stored_encrypted: jZe,
  go_to_app_store: FZe,
  calendar_error: VZe,
  set_your_phone_number: BZe,
  calendar_no_busy_slots: UZe,
  display_location_label: WZe,
  display_location_info_badge: GZe,
  add_gif: HZe,
  search_giphy: KZe,
  add_link_from_giphy: YZe,
  add_gif_to_confirmation: ZZe,
  find_gif_spice_confirmation: QZe,
  share_feedback: JZe,
  resources: XZe,
  support_documentation: eQe,
  developer_documentation: tQe,
  get_in_touch: nQe,
  contact_support: oQe,
  premium_support: rQe,
  community_support: iQe,
  feedback: aQe,
  submitted_feedback: sQe,
  feedback_error: cQe,
  comments: lQe,
  booking_details: dQe,
  or_lowercase: uQe,
  nevermind: _Qe,
  go_to: pQe,
  zapier_invite_link: mQe,
  meeting_url_provided_after_confirmed: fQe,
  dynamically_display_attendee_or_organizer: gQe,
  event_location: hQe,
  reschedule_optional: vQe,
  reschedule_placeholder: bQe,
  event_cancelled: yQe,
  emailed_information_about_cancelled_event: $Qe,
  this_input_will_shown_booking_this_event: wQe,
  meeting_url_in_confirmation_email: kQe,
  url_start_with_https: SQe,
  number_provided: xQe,
  before_event_trigger: EQe,
  event_cancelled_trigger: TQe,
  after_hosts_cal_video_no_show: AQe,
  after_guests_cal_video_no_show: CQe,
  join_video_call: zQe,
  sign_in_to_cal_com: OQe,
  log_in_to_cal_com: PQe,
  track_your_meetings: IQe,
  track_meetings_and_manage_schedule: RQe,
  failed_to_join_call: NQe,
  choose_how_you_d_like_to_join_call: DQe,
  choose_how_you_d_like_to_appear_on_the_call: MQe,
  new_event_trigger: LQe,
  email_host_action: qQe,
  email_attendee_action: jQe,
  sms_attendee_action: FQe,
  sms_number_action: VQe,
  send_reminder_sms: BQe,
  whatsapp_number_action: UQe,
  whatsapp_attendee_action: WQe,
  workflows: GQe,
  new_workflow_btn: HQe,
  how_would_you_like_to_start: KQe,
  add_new_workflow: YQe,
  reschedule_event_trigger: ZQe,
  trigger: QQe,
  triggers: JQe,
  action: XQe,
  workflows_to_automate_notifications: eJe,
  workflow_name: tJe,
  custom_workflow: nJe,
  workflow_created_successfully: oJe,
  delete_workflow_description: rJe,
  delete_workflow: iJe,
  confirm_delete_workflow: aJe,
  workflow_deleted_successfully: sJe,
  how_long_before: cJe,
  day_timeUnit: lJe,
  hour_timeUnit: dJe,
  minute_timeUnit: uJe,
  minute_short: _Je,
  hour_short: pJe,
  new_workflow_heading: mJe,
  new_workflow_description: fJe,
  active_on: gJe,
  workflow_updated_successfully: hJe,
  premium_to_standard_username_description: vJe,
  premium_username: bJe,
  current: yJe,
  premium: $Je,
  standard: wJe,
  confirm_username_change_dialog_title: kJe,
  change_username_standard_to_premium: SJe,
  change_username_premium_to_standard: xJe,
  go_to_stripe_billing: EJe,
  stripe_description: TJe,
  trial_expired: AJe,
  remove_app: CJe,
  yes_remove_app: zJe,
  are_you_sure_you_want_to_remove_this_app: OJe,
  app_removed_successfully: PJe,
  error_removing_app: IJe,
  web_conference: RJe,
  web_call: NJe,
  start_web_call: DJe,
  end_call: MJe,
  test_your_agent_with_web_call: LJe,
  phone_call: qJe,
  connecting_to_agent: jJe,
  call_active: FJe,
  call_ended: VJe,
  call_error: BJe,
  ready_to_start_call: UJe,
  failed_to_start_web_call_try_again: WJe,
  call_encountered_error_try_again: GJe,
  failed_initialize_web_call_microphone_permissions: HJe,
  start_call_to_see_conversation: KJe,
  waiting_for_conversation: YJe,
  ai_agent: ZJe,
  live: QJe,
  connecting: JJe,
  requires_confirmation: XJe,
  requires_confirmation_threshold: eXe,
  may_require_confirmation: tXe,
  nr_event_type_one: nXe,
  nr_event_type_other: oXe,
  count_team_one: rXe,
  count_team_other: iXe,
  add_action: aXe,
  set_whereby_link: sXe,
  invalid_whereby_link: cXe,
  set_around_link: lXe,
  invalid_around_link: dXe,
  set_riverside_link: uXe,
  invalid_riverside_link: _Xe,
  invalid_ping_link: pXe,
  add_exchange2013: mXe,
  add_exchange2016: fXe,
  custom_template: gXe,
  email_body: hXe,
  text_message: vXe,
  specific_issue: bXe,
  browse_our_docs: yXe,
  choose_template: $Xe,
  custom: wXe,
  reminder: kXe,
  rescheduled: SXe,
  rescheduled_by: xXe,
  original_booking: EXe,
  completed: TXe,
  rating: AXe,
  reminder_email: CXe,
  not_triggering_existing_bookings: zXe,
  minute_one: OXe,
  minute_one_short: PXe,
  minute_other: IXe,
  hour_one: RXe,
  hour_one_short: NXe,
  hour_other: DXe,
  invalid_input: MXe,
  broken_video_action: LXe,
  broken_calendar_action: qXe,
  attendee_name: jXe,
  scheduler_full_name: FXe,
  broken_integration: VXe,
  problem_adding_video_link: BXe,
  problem_updating_calendar: UXe,
  active_on_event_types_one: WXe,
  active_on_event_types_other: GXe,
  active_on_teams_one: HXe,
  active_on_teams_other: KXe,
  active_on_all_event_types: YXe,
  active_on_all_teams: ZXe,
  no_active_event_types: QXe,
  no_active_teams: JXe,
  new_seat_subject: XXe,
  new_seat_title: eet,
  variable: tet,
  event_name_variable: net,
  attendee_name_variable: oet,
  event_date_variable: ret,
  event_time_variable: iet,
  organizer_name_variable: aet,
  app_upgrade_description: set,
  invalid_number: cet,
  invalid_url_error_message: det,
  navigate: uet,
  open: _et,
  close: pet,
  upgrade: met,
  buy_us_number_button: fet,
  upgrade_to_access_recordings_title: get,
  upgrade_to_access_recordings_description: het,
  upgrade_to_cal_ai_phone_number_description: vet,
  recordings_are_part_of_the_teams_plan: bet,
  team_feature_teams: yet,
  team_feature_workflows: $et,
  show_eventtype_on_profile: wet,
  embed: ket,
  new_username: xet,
  current_username: Eet,
  example_1: Tet,
  example_2: Aet,
  booking_question_identifier: Cet,
  company_size: zet,
  what_help_needed: Oet,
  variable_format: Pet,
  webhook_subscriber_url_reserved: Iet,
  custom_input_as_variable_info: Ret,
  using_booking_questions_as_variables: Net,
  download_desktop_app: Det,
  set_ping_link: Met,
  rate_limit_exceeded: Let,
  when_something_happens: qet,
  action_is_performed: jet,
  test_action: Fet,
  notification_sent: Vet,
  no_input: Bet,
  test_workflow_action: Uet,
  send_sms: Wet,
  send_sms_to_number: Get,
  missing_connected_calendar: Het,
  connect_your_calendar_and_link: Ket,
  default_calendar_selected: Yet,
  hide_from_profile: Zet,
  basics: Qet,
  availability_not_found_in_schedule_error: Jet,
  event_limit_tab_title: Xet,
  event_limit_tab_description: ett,
  event_advanced_tab_description: ttt,
  event_advanced_tab_title: ntt,
  event_payments_tab_description: ott,
  event_setup_multiple_duration_error: rtt,
  event_setup_multiple_duration_default_error: itt,
  event_setup_booking_limits_error: att,
  event_setup_duration_limits_error: stt,
  select_which_cal: ctt,
  custom_event_name: ltt,
  custom_event_name_description: dtt,
  "2fa_required": "Zwei-Faktor-Authentifizierung erforderlich",
  incorrect_2fa: utt,
  which_event_type_apply: _tt,
  apply_to_all_event_types: ptt,
  apply_to_all_teams: mtt,
  which_team_apply: ftt,
  no_workflows_description: gtt,
  timeformat_profile_hint: htt,
  create_workflow: vtt,
  do_this: btt,
  turn_off: ytt,
  turn_on: $tt,
  cancelled_bookings_cannot_be_rescheduled: wtt,
  settings_updated_successfully: ktt,
  error_updating_settings: Stt,
  personal_cal_url: xtt,
  bio_hint: Ett,
  finish_and_start: Ttt,
  user_has_no_bio: Att,
  bio: Ctt,
  delete_account_modal_title: ztt,
  confirm_delete_account_modal: Ott,
  delete_my_account: Ptt,
  start_of_week: Itt,
  recordings_title: Rtt,
  recording: Ntt,
  happy_scheduling: Dtt,
  select_calendars: Mtt,
  check_for_conflicts: Ltt,
  view_recordings: qtt,
  check_for_recordings: jtt,
  adding_events_to: Ftt,
  follow_system_preferences: Vtt,
  custom_brand_colors: Btt,
  customize_your_brand_colors: Utt,
  pro: Wtt,
  removes_cal_branding: Gtt,
  instant_meeting_with_title: Htt,
  profile_picture: Ktt,
  upload: Ytt,
  add_profile_photo: Ztt,
  token_address: Qtt,
  blockchain: Jtt,
  old_password: Xtt,
  secure_password: ent,
  error_updating_password: tnt,
  two_factor_auth: nnt,
  recurring_event_tab_description: ont,
  today: rnt,
  appearance: int,
  my_account: ant,
  general: snt,
  calendars: cnt,
  "2fa_auth": "2 Faktor-Authentifizierung",
  invoices: lnt,
  embeds: dnt,
  impersonation: unt,
  impersonation_description: _nt,
  recent_impersonations: pnt,
  quick_impersonate: mnt,
  no_recent_impersonations: fnt,
  users: gnt,
  user: hnt,
  profile_description: vnt,
  users_description: bnt,
  users_listing: ynt,
  general_description: $nt,
  calendars_description: wnt,
  appearance_description: knt,
  conferencing_description: Snt,
  add_conferencing_app: xnt,
  password_description: Ent,
  set_up_two_factor_authentication: Tnt,
  we_just_need_basic_info: Ant,
  skip: Cnt,
  do_this_later: znt,
  set_availability_getting_started_subtitle_1: Ont,
  set_availability_getting_started_subtitle_2: Pnt,
  connect_calendar_first: Int,
  complete_profile: Rnt,
  connect_calendars_from_app_store: Nnt,
  connect_conference_apps: Dnt,
  connect_calendar_apps: Mnt,
  connect_payment_apps: Lnt,
  connect_automation_apps: qnt,
  connect_analytics_apps: jnt,
  connect_other_apps: Fnt,
  connect_messaging_apps: Vnt,
  connect_crm_apps: Bnt,
  current_step_of_total: Unt,
  add_variable: Wnt,
  custom_phone_number: Gnt,
  message_template: Hnt,
  email_subject: Knt,
  add_dynamic_variables: Ynt,
  event_name_info: Znt,
  event_date_info: Qnt,
  event_duration_info: Jnt,
  event_time_info: Xnt,
  event_type_not_found: eot,
  number_to_call_variable: tot,
  number_to_call_info: not,
  location_variable: oot,
  location_info: rot,
  additional_notes_variable: iot,
  additional_notes_info: aot,
  attendee_name_info: sot,
  organizer_name_info: cot,
  to: lot,
  workflow_turned_on_successfully: dot,
  download_responses: uot,
  download_responses_description: _ot,
  view_responses: pot,
  download: mot,
  downloading: fot,
  download_recording: got,
  transcription_enabled: hot,
  transcription_stopped: vot,
  download_transcript: bot,
  transcript: yot,
  recording_from_your_recent_call: $ot,
  transcript_from_previous_call: wot,
  you_can_download_transcript_from_attachments: kot,
  link_valid_for_12_hrs: Sot,
  link_valid_for_12_hrs_description: xot,
  create_your_first_form: Eot,
  create_your_first_form_description: Tot,
  create_your_first_webhook: Aot,
  create_your_first_webhook_description: Cot,
  for_a_maximum_of: zot,
  event_one: Oot,
  event_other: Pot,
  profile_team_description: Iot,
  profile_org_description: Rot,
  members_team_description: Not,
  organization_description: Dot,
  team_url: Mot,
  team_members: Lot,
  more: qot,
  cal_ai_workflows: jot,
  and_count_more: Fot,
  more_page_footer: Vot,
  workflow_example_1: Bot,
  workflow_example_2: Uot,
  workflow_example_3: Wot,
  workflow_example_4: Got,
  workflow_example_5: Hot,
  workflow_example_6: Kot,
  send_sms_reminder: Yot,
  send_sms_reminder_description: Zot,
  follow_up_with_no_shows: Qot,
  follow_up_with_no_shows_description: Jot,
  remind_attendees_to_bring_id: Xot,
  remind_attendees_to_bring_id_description: ert,
  email_to_remind_booking: trt,
  email_to_remind_booking_description: nrt,
  custom_sms_reminder: ort,
  custom_sms_reminder_description: rrt,
  custom_email_reminder: irt,
  custom_email_reminder_description: art,
  count_managed_to_limit: srt,
  welcome_to_cal_header: crt,
  edit_form_later_subtitle: lrt,
  connect_calendar_later: drt,
  problem_saving_user_profile: urt,
  purchase_missing_seats: _rt,
  slot_length: prt,
  booking_appearance: mrt,
  appearance_team_description: frt,
  appearance_org_description: grt,
  only_owner_change: hrt,
  team_disable_cal_branding_description: vrt,
  invited_by_team: brt,
  token_invalid_expired: yrt,
  view_booking: $rt,
  exchange_add: wrt,
  exchange_authentication: krt,
  exchange_authentication_standard: Srt,
  exchange_authentication_ntlm: xrt,
  exchange_compression: Ert,
  exchange_version: Trt,
  exchange_version_2007_SP1: Art,
  exchange_version_2010: Crt,
  exchange_version_2010_SP1: zrt,
  exchange_version_2010_SP2: Ort,
  exchange_version_2013: Prt,
  exchange_version_2013_SP1: Irt,
  exchange_version_2015: Rrt,
  exchange_version_2016: Nrt,
  routing: Drt,
  routing_forms_description: Mrt,
  routing_forms_send_email_owner: Lrt,
  routing_forms_send_email_owner_description: qrt,
  routing_forms_send_email_to: jrt,
  add_new_form: Frt,
  add_new_team_form: Vrt,
  create_your_first_route: Brt,
  route_to_the_right_person: Urt,
  form: Wrt,
  form_description: Grt,
  copy_link_to_form: Hrt,
  theme: Krt,
  theme_applies_note: Yrt,
  app_theme: Zrt,
  app_theme_applies_note: Qrt,
  theme_system: Jrt,
  add_a_team: Xrt,
  add_webhook_description: eit,
  triggers_when: tit,
  test_webhook: nit,
  enable_webhook: oit,
  add_webhook: rit,
  webhook_edited_successfully: iit,
  api_keys_description: ait,
  new_api_key: sit,
  active: cit,
  api_key_updated: lit,
  api_key_update_failed: dit,
  embeds_title: uit,
  embeds_description: _it,
  create_first_api_key: pit,
  create_first_api_key_description: mit,
  back_to_signin: fit,
  reset_link_sent: git,
  password_reset_email: hit,
  password_reset_leading: vit,
  password_updated: bit,
  pending_payment: yit,
  pending_invites: $it,
  pending_organization_invites: wit,
  not_on_cal: kit,
  no_calendar_installed: Sit,
  no_calendar_installed_description: xit,
  add_a_calendar: Eit,
  change_email_hint: Tit,
  confirm_password_change_email: Ait,
  seats: Cit,
  every_app_published: zit,
  report_app: Oit,
  limit_booking_frequency: Pit,
  limit_booking_frequency_description: Iit,
  only_show_first_available_slot: Rit,
  only_show_first_available_slot_description: Nit,
  limit_total_booking_duration: Dit,
  limit_total_booking_duration_description: Mit,
  booker_booking_limit: Lit,
  booker_booking_limit_description: qit,
  recurring_event_doesnt_support_booker_booking_limit: jit,
  add_limit: Fit,
  team_name_required: Vit,
  show_attendees: Bit,
  show_available_seats_count: Uit,
  how_booking_questions_as_variables: Wit,
  format: Git,
  questions: Hit,
  all_info_your_booker_provide: Kit,
  uppercase_for_letters: Yit,
  replace_whitespaces_underscores: Zit,
  platform_members: Qit,
  platform_members_description: Jit,
  platform_billing: Xit,
  manage_billing: eat,
  manage_billing_description: tat,
  billing_freeplan_title: nat,
  billing_freeplan_description: oat,
  billing_freeplan_cta: rat,
  billing_portal: iat,
  billing_help_cta: aat,
  ignore_special_characters_booking_questions: sat,
  retry: cat,
  fetching_calendars_error: lat,
  calendar_connection_fail: dat,
  booking_confirmation_success: uat,
  booking_rejection_success: _at,
  booking_tentative: pat,
  booking_accept_intent: mat,
  we_wont_show_again: fat,
  couldnt_update_timezone: gat,
  updated_timezone_to: hat,
  update_timezone: vat,
  update_timezone_question: bat,
  update_timezone_description: yat,
  dont_update: $at,
  require_additional_notes: wat,
  require_additional_notes_description: kat,
  email_address_action: Sat,
  after_event_trigger: xat,
  booking_rejected_trigger: Eat,
  booking_requested_trigger: Tat,
  booking_payment_initiated_trigger: Aat,
  booking_paid_trigger: Cat,
  booking_no_show_updated_trigger: zat,
  how_long_after: Oat,
  how_long_after_hosts_no_show: Pat,
  how_long_after_guests_no_show: Iat,
  how_long_after_user_no_show_minutes: Rat,
  no_available_slots: Nat,
  time_available: Dat,
  cant_find_the_right_conferencing_app_visit_our_app_store: Mat,
  install_new_calendar_app: Lat,
  make_phone_number_required: qat,
  new_event_type_availability: jat,
  error_editing_availability: Fat,
  dont_have_permission: Vat,
  saml_configuration_placeholder: Bat,
  saml_email_required: Uat,
  saml_sp_title: Wat,
  saml_sp_description: Gat,
  saml_sp_acs_url: Hat,
  saml_sp_entity_id: Kat,
  saml_sp_acs_url_copied: Yat,
  saml_sp_entity_id_copied: Zat,
  add_calendar: Qat,
  limit_future_bookings: Jat,
  limit_future_bookings_description: Xat,
  no_event_types: est,
  no_event_types_description: tst,
  billing_frequency: nst,
  monthly: ost,
  yearly: rst,
  checkout: ist,
  your_team_disbanded_successfully: ast,
  your_org_disbanded_successfully: sst,
  error_creating_team: cst,
  you: lst,
  or_continue_with: dst,
  resend_email: ust,
  member_already_invited: _st,
  already_in_use_error: pst,
  enter_email_or_username: mst,
  enter_email: fst,
  enter_emails: gst,
  too_many_invites: hst,
  team_name_taken: vst,
  must_enter_team_name: bst,
  team_url_required: yst,
  url_taken: $st,
  problem_registering_domain: wst,
  team_publish: kst,
  number_text_notifications: Sst,
  number_sms_notifications: xst,
  attendee_email_variable: Est,
  attendee_email_info: Tst,
  booking_uid: Ast,
  kbar_search_placeholder: Cst,
  invalid_credential: zst,
  invalid_credential_action: Ost,
  reschedule_reason: Pst,
  choose_common_schedule_team_event: Ist,
  choose_common_schedule_team_event_description: Rst,
  reason: Nst,
  sender_id: Dst,
  sender_id_error_message: Mst,
  test_routing_form: Lst,
  test_preview: qst,
  route_to: jst,
  test_preview_description: Fst,
  test_routing: Vst,
  payment_app_disabled: Bst,
  edit_event_type: Ust,
  only_admin_can_see_members_of_org: Wst,
  only_admin_can_manage_sso_org: Gst,
  only_admin_can_manage_directory_sync: Hst,
  only_admin_can_manage_oauth_clients: Kst,
  collective_scheduling: Yst,
  make_it_easy_to_book: Zst,
  find_the_best_person: Qst,
  fixed_round_robin: Jst,
  add_one_fixed_attendee: Xst,
  calcom_is_better_with_team: ect,
  the_calcom_team: tct,
  add_your_team_members: nct,
  booking_limit_reached: oct,
  duration_limit_reached: rct,
  admin_has_disabled: ict,
  disable_attendees_emails_description: act,
  disabled_app_affects_event_type: sct,
  event_replaced_notice: cct,
  email_subject_slug_replacement: lct,
  email_body_slug_replacement_notice: dct,
  email_body_slug_replacement_info: uct,
  email_body_slug_replacement_suggestion: _ct,
  disable_payment_app: pct,
  payment_disabled_still_able_to_book: mct,
  app_disabled_with_event_type: fct,
  app_disabled_video: gct,
  app_disabled_subject: hct,
  navigate_installed_apps: vct,
  disabled_calendar: bct,
  enable_apps: yct,
  enable_apps_description: $ct,
  purchase_license: wct,
  already_have_account: kct,
  already_have_key: Sct,
  already_have_key_suggestion: xct,
  create_license_key: Ect,
  app_is_enabled: Tct,
  app_is_disabled: Act,
  keys_have_been_saved: Cct,
  disable_app: zct,
  disable_app_description: Oct,
  edit_keys: Pct,
  admin_apps_description: Ict,
  admin_users_description: Rct,
  admin_users_add_description: Nct,
  admin_users_edit_description: Dct,
  admin_orgs_edit_description: Mct,
  admin_oAuth_description: Lct,
  admin_lockedSMS_description: qct,
  no_available_apps: jct,
  no_available_apps_description: Fct,
  no_apps: Vct,
  no_apps_configured: Bct,
  enable_in_settings: Uct,
  please_contact_admin: Wct,
  apps_settings: Gct,
  fill_this_field: Hct,
  options: Kct,
  enter_option: Yct,
  add_an_option: Zct,
  location_already_exists: Qct,
  radio: Jct,
  google_meet_warning: Xct,
  individual: elt,
  all_bookings_filter_label: tlt,
  all_users_filter_label: nlt,
  all_event_types_filter_label: olt,
  your_bookings_filter_label: rlt,
  meeting_url_variable: ilt,
  meeting_url_info: alt,
  date_overrides: slt,
  date_overrides_delete_on_date: clt,
  date_overrides_subtitle: llt,
  date_overrides_info: dlt,
  date_overrides_dialog_which_hours: ult,
  date_overrides_dialog_which_hours_unavailable: _lt,
  date_overrides_dialog_title: plt,
  date_overrides_unavailable: mlt,
  date_overrides_mark_all_day_unavailable_one: flt,
  date_overrides_mark_all_day_unavailable_other: glt,
  date_overrides_update_btn: hlt,
  date_successfully_added: vlt,
  date_overrides_save_btn: blt,
  event_type_duplicate_copy_text: ylt,
  set_as_default: $lt,
  hide_eventtype_details: wlt,
  show_navigation: klt,
  hide_navigation: Slt,
  verification_code_sent: xlt,
  verified_successfully: Elt,
  wrong_code: Tlt,
  not_verified: Alt,
  no_availability_in_month: Clt,
  no_availability_rolling: zlt,
  no_availability_range: Olt,
  view_previous_month: Plt,
  view_next_month: Ilt,
  send_code: Rlt,
  number_verified: Nlt,
  create_your_first_team_webhook_description: Dlt,
  create_webhook_team_event_type: Mlt,
  disable_success_page: Llt,
  invalid_admin_password: qlt,
  change_password_admin: jlt,
  username_already_taken: Flt,
  assignment: Vlt,
  fixed_hosts: Blt,
  add_fixed_hosts: Ult,
  round_robin_hosts: Wlt,
  minimum_round_robin_hosts_count: Glt,
  hosts: Hlt,
  upgrade_to_enable_feature: Klt,
  orgs_upgrade_to_enable_feature: Ylt,
  new_attendee: Zlt,
  awaiting_approval: Qlt,
  requires_google_calendar: Jlt,
  event_type_requires_google_calendar: Xlt,
  connected_google_calendar: edt,
  using_meet_requires_calendar: tdt,
  continue_to_install_google_calendar: ndt,
  install_google_meet: odt,
  install_google_calendar: rdt,
  sender_name: idt,
  already_invited: adt,
  no_recordings_found: sdt,
  new_workflow_subtitle: cdt,
  reporting: ldt,
  reporting_feature: ddt,
  teams_plan_required: udt,
  routing_forms_are_a_great_way: _dt,
  choose_a_license: pdt,
  choose_license_description: mdt,
  license: fdt,
  agplv3_license: gdt,
  no_need_to_keep_your_code_open_source: hdt,
  repackage_rebrand_resell: vdt,
  a_vast_suite_of_enterprise_features: bdt,
  free_license_fee: ydt,
  forever_open_and_free: $dt,
  required_to_keep_your_code_open_source: wdt,
  cannot_repackage_and_resell: kdt,
  no_enterprise_features: Sdt,
  step_enterprise_license: xdt,
  step_enterprise_license_description: Edt,
  setup: Tdt,
  setup_description: Adt,
  configure: Cdt,
  sso_configuration: zdt,
  sso_configuration_description: Odt,
  sso_configuration_description_orgs: Pdt,
  sso_oidc_heading: Idt,
  sso_oidc_description: Rdt,
  sso_oidc_configuration_title: Ndt,
  sso_oidc_configuration_description: Ddt,
  sso_oidc_callback_copied: Mdt,
  sso_saml_heading: Ldt,
  sso_saml_description: qdt,
  sso_saml_configuration_title: jdt,
  sso_saml_configuration_description: Fdt,
  sso_saml_acsurl_copied: Vdt,
  sso_saml_entityid_copied: Bdt,
  sso_connection_created_successfully: Udt,
  sso_connection_deleted_successfully: Wdt,
  delete_sso_configuration: Gdt,
  delete_sso_configuration_confirmation: Hdt,
  delete_sso_configuration_confirmation_description: Kdt,
  organizer_timezone: Ydt,
  email_user_cta: Zdt,
  accept_invite: Qdt,
  join_now: Jdt,
  successfully_joined: Xdt,
  email_no_user_invite_heading_subteam: eut,
  email_no_user_invite_heading_org: tut,
  email_no_user_invite_subheading: nut,
  email_user_invite_subheading_subteam: out,
  email_user_invite_subheading_org: rut,
  email_no_user_invite_steps_intro: iut,
  email_no_user_step_one: aut,
  email_no_user_step_two: sut,
  email_no_user_step_three: cut,
  email_no_user_step_four: lut,
  email_no_user_signoff: dut,
  impersonation_user_tip: uut,
  available_variables: _ut,
  scheduler: put,
  no_workflows: mut,
  change_filter: fut,
  change_filter_common: gut,
  no_results_for_filter: hut,
  recommended_next_steps: vut,
  create_a_managed_event: but,
  meetings_are_better_with_the_right: yut,
  create_a_one_one_template: $ut,
  collective_or_roundrobin: wut,
  book_your_team_members: kut,
  event_no_longer_attending_subject: Sut,
  no_longer_attending: xut,
  attendee_no_longer_attending_subject: Eut,
  attendee_no_longer_attending: Tut,
  attendee_no_longer_attending_subtitle: Aut,
  create_event_on: Cut,
  create_routing_form_on: zut,
  default_app_link_title: Out,
  default_app_link_description: Put,
  organizer_default_conferencing_app: Iut,
  organizer_default_conferencing_app_not_found: Rut,
  under_maintenance: Nut,
  under_maintenance_description: Dut,
  event_type_seats: Mut,
  booking_questions_title: Lut,
  booking_questions_description: qut,
  add_a_booking_question: jut,
  identifier: Fut,
  duplicate_email: Vut,
  enter_redirect_url_on_exit_description: But,
  booking_with_payment_cancelled: Uut,
  booking_with_payment_cancelled_already_paid: Wut,
  booking_with_payment_cancelled_refunded: Gut,
  booking_with_payment_cancelled_no_refund: Hut,
  booking_with_payment_cancelled_refund_window_expired: Kut,
  booking_confirmation_failed: Yut,
  not_enough_seats: Zut,
  form_builder_field_already_exists: Qut,
  guests_field_must_be_multiemail: Jut,
  show_on_booking_page: Xut,
  visit_cancelled_booking: e_t,
  get_started_zapier_templates: t_t,
  standard_templates: n_t,
  cal_ai_templates: o_t,
  team_is_unpublished: r_t,
  org_is_unpublished_description: i_t,
  team_is_unpublished_description: a_t,
  team_member: s_t,
  a_routing_form: c_t,
  form_description_placeholder: l_t,
  keep_me_connected_with_form: d_t,
  fields_in_form_duplicated: u_t,
  form_deleted: __t,
  delete_form: p_t,
  delete_form_action: m_t,
  delete_form_confirmation: f_t,
  delete_form_confirmation_2: g_t,
  typeform_redirect_url_copied: h_t,
  modifications_in_fields_warning: v_t,
  connected_forms: b_t,
  form_modifications_warning: y_t,
  responses_collection_waiting_description: $_t,
  this_is_what_your_users_would_see: w_t,
  identifies_name_field: k_t,
  add_1_option_per_line: S_t,
  select_a_router: x_t,
  add_a_new_route: E_t,
  make_informed_decisions: T_t,
  make_informed_decisions_description: A_t,
  view_bookings_across: C_t,
  view_bookings_across_description: z_t,
  identify_booking_trends: O_t,
  identify_booking_trends_description: P_t,
  spot_popular_event_types: I_t,
  spot_popular_event_types_description: R_t,
  no_responses_yet: N_t,
  no_routes_defined: D_t,
  this_will_be_the_placeholder: M_t,
  error_booking_event: L_t,
  timeslot_missing_title: q_t,
  timeslot_missing_description: j_t,
  timeslot_missing_cta: F_t,
  switch_monthly: V_t,
  switch_weekly: B_t,
  switch_multiday: U_t,
  switch_columnview: W_t,
  num_locations: G_t,
  select_on_next_step: H_t,
  this_meeting_has_not_started_yet: K_t,
  this_app_requires_connected_account: Y_t,
  connect_app: Z_t,
  app_is_connected: Q_t,
  requires_app: J_t,
  verification_code: X_t,
  can_you_try_again: ept,
  verify: tpt,
  timezone_info: npt,
  timezone_variable: opt,
  event_end_time_variable: rpt,
  event_end_time_info: ipt,
  cancel_url_variable: apt,
  cancel_url_info: spt,
  cancel_reason_variable: cpt,
  cancel_reason_info: lpt,
  reschedule_url_variable: dpt,
  reschedule_url_info: upt,
  reschedule_reason_variable: _pt,
  reschedule_reason_info: ppt,
  invalid_event_name_variables: mpt,
  select_all: fpt,
  default_conferencing_bulk_title: gpt,
  members_default_schedule: hpt,
  set_by_admin: vpt,
  members_default_location: bpt,
  members_default_schedule_description: ypt,
  requires_at_least_one_schedule: $pt,
  default_conferencing_bulk_description: wpt,
  default_schedules_bulk_description: kpt,
  locked_for_members: Spt,
  unlocked_for_members: xpt,
  apps_locked_for_members_description: Ept,
  apps_unlocked_for_members_description: Tpt,
  apps_locked_by_team_admins_description: Apt,
  apps_unlocked_by_team_admins_description: Cpt,
  workflows_locked_for_members_description: zpt,
  workflows_unlocked_for_members_description: Opt,
  workflows_locked_by_team_admins_description: Ppt,
  workflows_unlocked_by_team_admins_description: Ipt,
  webhooks_locked_for_members_description: Rpt,
  webhooks_unlocked_for_members_description: Npt,
  webhooks_locked_by_team_admins_description: Dpt,
  webhooks_unlocked_by_team_admins_description: Mpt,
  locked_by_team_admin: Lpt,
  app_not_connected: qpt,
  connect_now: jpt,
  managed_event_dialog_confirm_button_one: Fpt,
  managed_event_dialog_confirm_button_other: Vpt,
  managed_event_dialog_title_one: Bpt,
  managed_event_dialog_title_other: Upt,
  managed_event_dialog_information_one: Wpt,
  managed_event_dialog_information_other: Gpt,
  managed_event_dialog_clarification: Hpt,
  review_event_type: Kpt,
  looking_for_more_analytics: Ypt,
  looking_for_more_insights: Zpt,
  filters: Qpt,
  filter: Jpt,
  add_a_member: Xpt,
  add_filter: emt,
  add_rule: tmt,
  add_rule_group: nmt,
  remove_filters: omt,
  email_verified: rmt,
  select_user: imt,
  select_event_type: amt,
  select_date_range: smt,
  popular_events: cmt,
  no_event_types_found: lmt,
  average_event_duration: dmt,
  bookings_by_hour: umt,
  most_booked_members: _mt,
  least_booked_members: pmt,
  most_bookings_scheduled: mmt,
  least_bookings_scheduled: fmt,
  most_bookings_completed: gmt,
  least_bookings_completed: hmt,
  events_created: vmt,
  events_completed: bmt,
  events_cancelled: ymt,
  events_rescheduled: $mt,
  events: wmt,
  performance: kmt,
  from_last_period: Smt,
  from_to_date_period: xmt,
  redirect_url_warning: Emt,
  event_trends: Tmt,
  clear_filters: Amt,
  clear: Cmt,
  hold: zmt,
  on_booking_option: Omt,
  hold_option: Pmt,
  card_held: Imt,
  charge_card: Rmt,
  card_charged: Nmt,
  no_show_fee_amount: Dmt,
  no_show_fee: Mmt,
  submit_card: Lmt,
  submit_payment_information: qmt,
  meeting_awaiting_payment_method: jmt,
  no_show_fee_charged_email_subject: Fmt,
  no_show_fee_charged_text_body: Vmt,
  no_show_fee_charged_subtitle: Bmt,
  error_charging_card: Umt,
  collect_no_show_fee: Wmt,
  no_show_fee_charged: Gmt,
  your_card_was_declined: Hmt,
  your_card_does_not_support_this_type_of_purchase: Kmt,
  amount_must_convert_to_at_least: Ymt,
  could_not_charge_card: Zmt,
  insights: Qmt,
  routing_forms: Jmt,
  insights_no_data_found_for_filter: Xmt,
  acknowledge_booking_no_show_fee: eft,
  days: tft,
  card_details: nft,
  something_went_wrong_on_our_end: oft,
  please_provide_following_text_to_suppport: rft,
  seats_and_no_show_fee_error: ift,
  complete_your_booking: aft,
  complete_your_booking_subject: sft,
  confirm_your_details: cft,
  copy_invite_link: lft,
  edit_invite_link: dft,
  invite_link_copied: uft,
  invite_link_deleted: _ft,
  api_key_deleted: pft,
  delete_api_key_warning: mft,
  invite_link_updated: fft,
  link_expires_after: gft,
  one_day: hft,
  seven_days: vft,
  thirty_days: bft,
  three_months: yft,
  one_year: $ft,
  team_invite_received: wft,
  currency_string: kft,
  charge_card_dialog_body: Sft,
  charge_attendee: xft,
  payment_app_commission: Eft,
  email_invite_team: Tft,
  email_invite_team_bulk: Aft,
  error_collecting_card: Cft,
  image_size_limit_exceed: zft,
  unauthorized_workflow_error_message: Oft,
  inline_embed: Pft,
  load_inline_content: Ift,
  floating_pop_up_button: Rft,
  floating_button_trigger_modal: Nft,
  pop_up_element_click: Dft,
  open_dialog_with_element_click: Mft,
  use_my_own_form: Lft,
  use_our_headless_routing_api: qft,
  need_help_embedding: jft,
  book_my_cal: Fft,
  first_name: Vft,
  last_name: Bft,
  first_last_name: Uft,
  invite_as: Wft,
  form_updated_successfully: Gft,
  disable_attendees_confirmation_emails: Hft,
  disable_attendees_confirmation_emails_description: Kft,
  disable_host_confirmation_emails: Yft,
  disable_host_confirmation_emails_description: Zft,
  add_an_override: Qft,
  import_from_google_workspace: Jft,
  connect_google_workspace: Xft,
  google_workspace_admin_tooltip: egt,
  first_event_type_webhook_description: tgt,
  create_instant_meeting_webhook_description: ngt,
  install_app_on: ogt,
  create_for: rgt,
  currency: igt,
  organization_banner_description: agt,
  organization_banner_title: sgt,
  set_up_your_organization: cgt,
  set_up_your_platform_organization: lgt,
  organizations_description: dgt,
  plans: ugt,
  platform: _gt,
  platform_description: pgt,
  platform_organization_description: mgt,
  must_enter_organization_name: fgt,
  must_enter_organization_admin_email: ggt,
  admin_email: hgt,
  platform_admin_email: vgt,
  admin_username: bgt,
  organization_name: ygt,
  platform_name: $gt,
  organization_url: wgt,
  organization_verify_header: kgt,
  organization_verify_email_body: Sgt,
  additional_url_parameters: xgt,
  about_your_organization: Egt,
  about_your_organization_description: Tgt,
  create_your_teams: Agt,
  create_your_teams_description: Cgt,
  invite_organization_admins: zgt,
  invite_organization_admins_description: Ogt,
  set_a_password: Pgt,
  set_a_password_description: Igt,
  organization_logo: Rgt,
  organization_about_description: Ngt,
  ill_do_this_later: Dgt,
  verify_your_email: Mgt,
  enter_digit_code: Lgt,
  verify_email_organization: qgt,
  code_provided_invalid: jgt,
  email_already_used: Fgt,
  organization_admin_invited_heading: Vgt,
  organization_admin_invited_body: Bgt,
  duplicated_slugs_warning: Ugt,
  team_names_empty: Wgt,
  team_names_repeated: Ggt,
  user_belongs_organization: Hgt,
  org_no_teams_yet: Kgt,
  org_no_teams_yet_description: Ygt,
  set_up: Zgt,
  my_profile: Qgt,
  my_settings: Jgt,
  crm: Xgt,
  messaging: eht,
  sender_id_info: tht,
  org_admins_can_create_new_teams: nht,
  google_new_spam_policy: oht,
  resolve: rht,
  no_organization_slug: iht,
  copy_link_org: aht,
  "404_the_org": "Die Organization",
  "404_the_team": "Das Team",
  "404_claim_entity_org": "Beanspruchen Sie Ihre Subdomain für Ihre Organization",
  "404_claim_entity_team": "Dieses Team beanspruchen und gemeinsam mit der Verwaltung von Verfügbarkeitsplänen beginnen",
  insights_team_filter: sht,
  insights_user_filter: cht,
  insights_subtitle: lht,
  call_history: dht,
  call_history_subtitle: uht,
  location_options: _ht,
  channel_type: pht,
  end_reason: mht,
  session_status: fht,
  user_sentiment: ght,
  time_header: hht,
  from_header: vht,
  custom_plan: bht,
  email_embed: yht,
  add_times_to_your_email: $ht,
  select_time: wht,
  select_date: kht,
  only_show_if_parameter_set: Sht,
  add_parameter: xht,
  connecting_you_to_someone: Eht,
  please_do_not_close_this_tab: Tht,
  see_all_available_times: Aht,
  org_team_names_example_1: Cht,
  org_team_names_example_2: zht,
  org_team_names_example_3: Oht,
  org_team_names_example_4: Pht,
  org_team_names_example_5: Iht,
  org_max_team_warnings: Rht,
  what_is_this_meeting_about: Nht,
  add_to_team: Dht,
  remove_users_from_org: Mht,
  delegation_credential: Lht,
  delegation_credential_description: qht,
  add_client_id_in_google_workspace_with_below_scope: jht,
  delegation_credential_enabled: Fht,
  add_delegation_credential: Vht,
  edit_delegation_credential: Bht,
  domain: Uht,
  no_workspace_platforms: Wht,
  workspace_platform: Ght,
  workspace_platforms: Hht,
  workspace_platforms_description: Kht,
  edit_workspace_platform: Yht,
  edit_service_account: Zht,
  add_workspace_platform: Qht,
  slug: Jht,
  service_account_key: Xht,
  edit_service_account_key: evt,
  delegation_credential_restricts_adding_more_than_one_installation: tvt,
  app_successfully_installed_and_is_using_delegated_credentials: nvt,
  remove_users_from_org_confirm: ovt,
  remove_users_from_team: rvt,
  remove_users_from_team_confirm: ivt,
  user_has_no_schedules: avt,
  user_isnt_in_any_teams: svt,
  user_has_no_app_installed: cvt,
  requires_booker_email_verification: lvt,
  description_requires_booker_email_verification: dvt,
  requires_confirmation_mandatory: uvt,
  organizations: _vt,
  upload_cal_video_logo: pvt,
  update_cal_video_logo: mvt,
  upload_banner: fvt,
  cal_video_logo_upload_instruction: gvt,
  org_admin_other_teams: hvt,
  org_admin_other_teams_description: vvt,
  not_part_of_org: bvt,
  no_other_teams_found: yvt,
  no_other_teams_found_description: $vt,
  attendee_first_name_variable: wvt,
  attendee_last_name_variable: kvt,
  attendee_first_name_info: Svt,
  attendee_last_name_info: xvt,
  your_monthly_digest: Evt,
  member_name: Tvt,
  most_popular_events: Avt,
  summary_of_events_for_your_team_for_the_last_30_days: Cvt,
  me: zvt,
  meeting_unavailable: Ovt,
  monthly_digest_email: Pvt,
  monthly_digest_email_for_teams: Ivt,
  verify_team_tooltip: Rvt,
  member_removed: Nvt,
  my_availability: Dvt,
  team_availability: Mvt,
  instant_meeting_availability: Lvt,
  backup_code: qvt,
  backup_codes: jvt,
  backup_code_instructions: Fvt,
  backup_codes_copied: Vvt,
  incorrect_backup_code: Bvt,
  lost_access: Uvt,
  missing_backup_codes: Wvt,
  admin_org_notification_email_subject: Gvt,
  hi_admin: Hvt,
  admin_org_notification_email_title: Kvt,
  admin_org_notification_email_body_part1: Yvt,
  admin_org_notification_email_body_part2: Zvt,
  admin_org_notification_email_body_part3: Qvt,
  admin_org_notification_email_cta: Jvt,
  org_has_been_processed: Xvt,
  org_error_processing: ebt,
  orgs_page_description: tbt,
  unverified: nbt,
  verified: obt,
  dns_missing: rbt,
  dns_configured: ibt,
  mark_dns_configured: abt,
  value: sbt,
  your_organization_updated_sucessfully: cbt,
  team_no_event_types: lbt,
  seat_options_doesnt_multiple_durations: dbt,
  include_calendar_event: ubt,
  oAuth: _bt,
  oAuth_client_creation_form: pbt,
  oAuth_client_creation_form_description: mbt,
  oAuth_client_updation_form: fbt,
  oAuth_client_updation_form_description: gbt,
  recently_added: hbt,
  connect_all_calendars: vbt,
  connect_all_calendars_description: bbt,
  workflow_automation_description: ybt,
  scheduling_for_your_team: $bt,
  scheduling_for_your_team_description: wbt,
  no_members_found: kbt,
  directory_sync: Sbt,
  directory_name: xbt,
  directory_provider: Ebt,
  directory_scim_url: Tbt,
  directory_scim_token: Abt,
  directory_scim_url_copied: Cbt,
  directory_scim_token_copied: zbt,
  directory_sync_info_description: Obt,
  directory_sync_configure: Pbt,
  directory_sync_configure_description: Ibt,
  directory_sync_title: Rbt,
  directory_sync_created: Nbt,
  directory_sync_description: Dbt,
  directory_sync_deleted: Mbt,
  directory_sync_delete_connection: Lbt,
  directory_sync_delete_title: qbt,
  directory_sync_delete_description: jbt,
  directory_sync_delete_confirmation: Fbt,
  event_setup_length_error: Vbt,
  availability_schedules: Bbt,
  unauthorized: Ubt,
  access_cal_account: Wbt,
  select_account_team: Gbt,
  allow_client_to: Hbt,
  associate_with_cal_account: Kbt,
  see_personal_info: Ybt,
  see_primary_email_address: Zbt,
  connect_installed_apps: Qbt,
  access_event_type: Jbt,
  access_availability: Xbt,
  access_bookings: eyt,
  allow_client_to_do: tyt,
  oauth_access_information: nyt,
  allow: oyt,
  view_only_edit_availability_not_onboarded: ryt,
  view_only_edit_availability: iyt,
  you_can_override_calendar_in_advanced_tab: ayt,
  edit_users_availability: syt,
  resend_invitation: cyt,
  invitation_resent: lyt,
  saml_sso: dyt,
  add_client: uyt,
  copy_client_secret_info: _yt,
  add_new_client: pyt,
  add_new_user: myt,
  this_app_is_not_setup_already: fyt,
  as_csv: gyt,
  overlay_my_calendar: hyt,
  overlay_my_calendar_toc: vyt,
  view_overlay_calendar_events: byt,
  join_event_location: yyt,
  troubleshooting: $yt,
  calendars_were_checking_for_conflicts: wyt,
  availabilty_schedules: kyt,
  manage_calendars: Syt,
  manage_availability_schedules: xyt,
  locked: Eyt,
  unlocked: Tyt,
  lock_timezone_toggle_on_booking_page: Ayt,
  description_lock_timezone_toggle_on_booking_page: Cyt,
  event_setup_multiple_payment_apps_error: zyt,
  number_in_international_format: Oyt,
  install_calendar: Pyt,
  branded_subdomain: Iyt,
  branded_subdomain_description: Ryt,
  org_insights: Nyt,
  org_insights_description: Dyt,
  extensive_whitelabeling: Myt,
  extensive_whitelabeling_description: Lyt,
  unlimited_teams: qyt,
  verify_email: jyt,
  proceed_with_cancellation_description: Fyt,
  proceed_with_cancellation_error: Vyt,
  unlimited_teams_description: Byt,
  unified_billing: Uyt,
  advanced_managed_events: Wyt,
  advanced_managed_events_description: Gyt,
  enterprise: Hyt,
  enterprise_description: Kyt,
  create_your_org: Yyt,
  create_org: Zyt,
  create_your_org_description: Qyt,
  create_your_enterprise_description: Jyt,
  other_payment_app_enabled: Xyt,
  admin_delete_organization_description_1: e$t,
  admin_delete_organization_description_2: t$t,
  admin_delete_organization_description_3: n$t,
  admin_delete_organization_description_4: o$t,
  admin_delete_organization_title: r$t,
  published: i$t,
  unpublished: a$t,
  publish: s$t,
  troubleshooter_tooltip: c$t,
  need_help: l$t,
  troubleshooter: d$t,
  number_to_call: u$t,
  guest_name: _$t,
  guest_email: p$t,
  guest_company: m$t,
  please_install_a_calendar: f$t,
  instant_tab_title: g$t,
  instant_event_tab_description: h$t,
  uprade_to_create_instant_bookings: v$t,
  dont_want_to_wait: b$t,
  meeting_started: y$t,
  pay_and_book: $$t,
  cal_ai_event_tab_description: w$t,
  booking_not_found_error: k$t,
  booking_seats_full_error: S$t,
  missing_payment_credential_error: x$t,
  missing_payment_app_id_error: E$t,
  not_enough_available_seats_error: T$t,
  user_redirect_title: A$t,
  user_redirect_description: C$t,
  out_of_office: z$t,
  out_of_office_description: O$t,
  send_request: P$t,
  start_date_and_end_date_required: I$t,
  start_date_must_be_before_end_date: R$t,
  start_date_must_be_in_the_future: N$t,
  user_not_found: D$t,
  cannot_redirect_to_self: M$t,
  out_of_office_entry_already_exists: L$t,
  out_of_office_id_required: q$t,
  booking_redirect_infinite_not_allowed: j$t,
  success_entry_created: F$t,
  booking_redirect_email_subject: V$t,
  booking_redirect_email_title: B$t,
  booking_redirect_email_description: U$t,
  booking_redirect_updated_email_subject: W$t,
  booking_redirect_updated_email_title: G$t,
  booking_redirect_updated_email_description: H$t,
  booking_redirect_cancelled_email_subject: K$t,
  booking_redirect_cancelled_email_title: Y$t,
  booking_redirect_cancelled_email_description: Z$t,
  success_accept_booking_redirect: Q$t,
  success_reject_booking_redirect: J$t,
  copy_link_booking_redirect_request: X$t,
  booking_redirect_request_title: ewt,
  select_team_member: twt,
  going_away_title: nwt,
  redirect_team_enabled: owt,
  redirect_team_disabled: rwt,
  out_of_office_unavailable_list: iwt,
  success_deleted_entry_out_of_office: awt,
  success_edited_entry_out_of_office: swt,
  temporarily_out_of_office: cwt,
  add_a_redirect: lwt,
  create_entry: dwt,
  time_range: uwt,
  automatically_add_all_team_members: _wt,
  redirect_to: pwt,
  having_trouble_finding_time: mwt,
  show_more: fwt,
  forward_params_redirect: gwt,
  assignment_description: hwt,
  lowest: vwt,
  low: bwt,
  medium: ywt,
  high: $wt,
  Highest: wwt,
  send_booker_to: kwt,
  set_priority: Swt,
  set_weight: xwt,
  enable_weights: Ewt,
  priority_for_user: Twt,
  weights_description: Awt,
  weight_for_user: Cwt,
  change_priority: zwt,
  field_identifiers_as_variables: Owt,
  field_identifiers_as_variables_with_example: Pwt,
  account_already_linked: Iwt,
  send_email: Rwt,
  cal_ai_phone_call_action: Nwt,
  call_to_confirm_booking: Dwt,
  cal_ai_phone_call_action_description: Mwt,
  cal_ai_agent_configuration: Lwt,
  choose_at_least_one_event_type_test_call: qwt,
  mark_as_no_show: jwt,
  unmark_as_no_show: Fwt,
  account_unlinked_success: Vwt,
  account_unlinked_error: Bwt,
  travel_schedule: Uwt,
  travel_schedule_description: Wwt,
  schedule_timezone_change: Gwt,
  date: Hwt,
  enter_the_general_prompt_for_the_agent: Kwt,
  overlaps_with_existing_schedule: Ywt,
  "org_admin_no_slots|heading": "Keine Verfügbarkeit für {{name}} gefunden",
  "org_admin_no_slots|content": "Hallo Organisationsadministratoren,<br /><br />Bitte beachten: Es wurde uns mitgeteilt, dass {{username}} keine Verfügbarkeit hatte, als ein Benutzer {{username}}/{{slug}} besucht hat<br /><br />Es gibt einige Gründe, warum dies passieren könnte<br />Der Benutzer hat keine Kalender verbunden<br />Die mit diesem Termin verknüpften Zeitpläne sind nicht aktiviert<br /> <br />Wir empfehlen, die Verfügbarkeit zu überprüfen, um dieses Problem zu lösen.",
  "org_admin_no_slots|cta": "Benutzerverfügbarkeit öffnen",
  organization_no_slots_notification_switch_title: Zwt,
  organization_no_slots_notification_switch_description: Qwt,
  organization_disable_phone_only_sms_notifications_switch_title: Jwt,
  organization_disable_phone_only_sms_notifications_switch_description: Xwt,
  "email_team_invite|subject|added_to_org": "{{user}} hat Sie zur Organisation {{team}} auf {{appName}} hinzugefügt",
  "email_team_invite|subject|invited_to_org": "{{user}} hat Sie eingeladen, der Organisation {{team}} auf {{appName}} beizutreten",
  "email_team_invite|subject|added_to_subteam": "{{user}} hat Sie zum Team {{team}} der Organisation {{parentTeamName}} auf {{appName}} hinzugefügt",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} hat Sie eingeladen, dem Team {{team}} auf {{appName}} beizutreten",
  "email_team_invite|heading|added_to_org": "Du wurdest zu einer {{appName}}-Organisation hinzugefügt",
  "email_team_invite|heading|invited_to_org": "Du wurdest zu einer {{appName}}-Organisation eingeladen",
  "email_team_invite|heading|added_to_subteam": "Du wurdest zu einem Team der {{parentTeamName}}-Organisation hinzugefügt",
  "email_team_invite|heading|invited_to_subteam": "Du wurdest zu einem Team der {{parentTeamName}}-Organisation eingeladen",
  "email_team_invite|heading|invited_to_regular_team": "Du wurdest eingeladen, einem {{appName}}-Team beizutreten",
  "email_team_invite|content|added_to_org": "{{invitedBy}} hat Sie zur <strong>{{teamName}}</strong>-Organisation hinzugefügt.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} hat Sie zur {{teamName}}-Organisation eingeladen.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} hat Sie eingeladen, dem Team {{team}} der Organisation {{parentTeamName}} auf {{appName}} beizutreten",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} hat Sie zum Team <strong>{{teamName}}</strong> in seiner bzw. ihrer Organisation {{parentTeamName}} hinzugefügt. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} hat Sie zum Team <strong>{{teamName}}</strong> in seiner bzw. ihrer Organisation {{parentTeamName}} eingeladen. {{appName}} ist der Terminplaner, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} hat Sie eingeladen, dem Team „{{teamName}}“ beizutreten. {{appName}} ist der Event-Planer, der es Ihnen und Ihrem Team ermöglicht, Meetings ohne Hin und Her zu planen.",
  "email|existing_user_added_link_will_change": "Bei Annahme der Einladung wird sich dein Link auf die Domain deiner Organisation ändern, aber keine Sorge, alle vorherigen Links werden weiterhin funktionieren und entsprechend weiterleiten.<br /><br />Bitte beachte: Alle deine persönlichen Ereignistypen werden in die <strong>{{teamName}}</strong> Organisation verschoben, was auch potenzielle persönliche Links einschließen kann. <br /><br />Für persönliche Ereignisse empfehlen wir, ein neues Konto mit einer persönlichen E-Mail-Adresse zu erstellen.",
  "email|existing_user_added_link_changed": "Dein Link wurde von {{a0}} zu {{a1}} geändert, aber keine Sorge, alle vorherigen Links funktionieren weiterhin und leiten entsprechend weiter. <br /><br />Bitte beachte: Alle deine persönlichen Ereignistypen wurden in die <strong>{{teamName}}</strong> Organisation verschoben, was auch potenzielle persönliche Links einschließen kann.<br /><br />Bitte melde dich an und stelle sicher, dass du keine privaten Ereignisse in deinem neuen Organisationskonto hast.<br /><br />Für persönliche Ereignisse empfehlen wir, ein neues Konto mit einer persönlichen E-Mail-Adresse zu erstellen.<br /><br />Genieße deinen neuen übersichtlichen Link: {{a2}}",
  "email_organization_created|subject": "Ihre Organisation wurde erstellt",
  your_current_plan: e0t,
  organization_price_per_user_month: t0t,
  privacy_organization_description: n0t,
  privacy: o0t,
  team_will_be_under_org: r0t,
  add_group_name: i0t,
  group_name: a0t,
  routers: s0t,
  primary: c0t,
  make_primary: l0t,
  add_email: d0t,
  add_emails: u0t,
  add_email_description: _0t,
  confirm_email: p0t,
  confirming_your_booking_sms: m0t,
  scheduler_first_name: f0t,
  scheduler_last_name: g0t,
  scheduler_name: h0t,
  organizer_first_name: v0t,
  confirm_email_description: b0t,
  send_event_details_to: y0t,
  schedule_tz_without_end_date: $0t,
  select_members: w0t,
  lock_event_types_modal_header: k0t,
  org_delete_event_types_org_admin: S0t,
  org_hide_event_types_org_admin: x0t,
  hide_org_eventtypes: E0t,
  delete_org_eventtypes: T0t,
  lock_org_users_eventtypes: A0t,
  lock_org_users_eventtypes_description: C0t,
  add_to_event_type: z0t,
  create_account_password: O0t,
  create_account_with_saml: P0t,
  error_creating_account_password: I0t,
  cannot_create_account_password_cal_provider: R0t,
  cannot_create_account_password_already_existing: N0t,
  create_account_password_hint: D0t,
  disconnect_account: M0t,
  disconnect_account_hint: L0t,
  cookie_consent_checkbox: q0t,
  make_a_call: j0t,
  skip_rr_assignment_label: F0t,
  skip_rr_description: V0t,
  select_account_header: B0t,
  select_account_description: U0t,
  select_event_types_header: W0t,
  select_event_types_description: G0t,
  configure_app_header: H0t,
  configure_app_description: K0t,
  already_installed: Y0t,
  ooo_reasons_unspecified: Z0t,
  ooo_reasons_vacation: Q0t,
  ooo_reasons_travel: J0t,
  ooo_reasons_sick_leave: X0t,
  ooo_reasons_public_holiday: ekt,
  ooo_forwarding_to: tkt,
  ooo_not_forwarding: nkt,
  ooo_empty_title: okt,
  ooo_empty_description: rkt,
  ooo_user_is_ooo: ikt,
  ooo_slots_returning: akt,
  ooo_slots_book_with: skt,
  ooo_select_reason: ckt,
  create_an_out_of_office: lkt,
  edit_an_out_of_office: dkt,
  submit_feedback: ukt,
  host_no_show: _kt,
  no_show_description: pkt,
  how_can_we_improve: mkt,
  most_liked: fkt,
  review: gkt,
  reviewed: hkt,
  unreviewed: vkt,
  rating_url_variable: bkt,
  rating_url_info: ykt,
  no_show_url_variable: $kt,
  no_show_url_info: wkt,
  no_support_needed: kkt,
  hide_support: Skt,
  event_ratings: xkt,
  event_no_show: Ekt,
  event_no_show_guest: Tkt,
  recent_ratings: Akt,
  no_ratings: Ckt,
  no_ratings_description: zkt,
  most_no_show_host: Okt,
  highest_rated: Pkt,
  lowest_rated: Ikt,
  highest_rated_members: Rkt,
  lowest_rated_members: Nkt,
  csat_score: Dkt,
  lockedSMS: Mkt,
  leave_without_assigning_anyone: Lkt,
  leave_without_adding_attendees: qkt,
  no_availability_shown_to_bookers: jkt,
  go_back_and_assign: Fkt,
  leave_without_assigning: Vkt,
  signing_up_terms: Bkt,
  proceeding_agreement: Ukt,
  terms: Wkt,
  always_show_x_days: Gkt,
  always_show_x_days_description: Hkt,
  team_subscription_cancelled_successfully: Kkt,
  team_subscription_cancellation_error: Ykt,
  unable_to_subscribe_to_the_platform: Zkt,
  updating_oauth_client_error: Qkt,
  creating_oauth_client_error: Jkt,
  event_type_color: Xkt,
  event_type_color_description: e1t,
  mark_as_no_show_title: t1t,
  x_marked_as_no_show: n1t,
  x_unmarked_as_no_show: o1t,
  team_select_info: r1t,
  team_settings_description: i1t,
  no_show_updated: a1t,
  email_copied: s1t,
  phone_number_copied: c1t,
  USER_PENDING_MEMBER_OF_THE_ORG: l1t,
  USER_ALREADY_INVITED_OR_MEMBER: d1t,
  USER_MEMBER_OF_OTHER_ORGANIZATION: u1t,
  booking_reassigned: _1t,
  reassign: p1t,
  reassign_to_another_rr_host: m1t,
  assign_team_member: f1t,
  override_team_member_to_assign: g1t,
  no_available_hosts: h1t,
  reassign_round_robin_host: v1t,
  skip_writing_to_calendar: b1t,
  rescheduling_not_possible: y1t,
  event_expired: $1t,
  skip_contact_creation: w1t,
  skip_writing_to_calendar_note: k1t,
  attributes: S1t,
  new_attribute: x1t,
  add_attributes: E1t,
  add_attributes_description: T1t,
  new_option: A1t,
  update_profile: C1t,
  attribute: z1t,
  create_attribute_description: O1t,
  edit_attribute_description: P1t,
  attribute_updated_successfully: I1t,
  attribute_deleted_successfully: R1t,
  attributes_edited_successfully: N1t,
  attribute_meta_description: D1t,
  attributes_edit_description: M1t,
  back_to_attributes: L1t,
  delete_attribute: q1t,
  delete_attribute_description: j1t,
  disable_all_emails_to_attendees: F1t,
  disable_all_emails_description: V1t,
  disable_all_emails_to_hosts: B1t,
  type_confirm_to_continue: U1t,
  disable_email: W1t,
  grant_admin_api: G1t,
  revoke_admin_api: H1t,
  add_calendar_label: K1t,
  apple_connect_atom_label: Y1t,
  apple_connect_atom_already_connected_label: Z1t,
  apple_connect_atom_loading_label: Q1t,
  google_connect_atom_label: J1t,
  google_connect_atom_already_connected_label: X1t,
  google_connect_atom_loading_label: e2t,
  outlook_connect_atom_label: t2t,
  outlook_connect_atom_already_connected_label: n2t,
  outlook_connect_atom_loading_label: o2t,
  stripe_connect_atom_label: r2t,
  stripe_connect_atom_already_connected_label: i2t,
  stripe_connect_atom_loading_label: a2t,
  booking_question_response_variables: s2t,
  managed_by_teamAdmins: c2t,
  number_of_options: l2t,
  reschedule_with_same_round_robin_host_title: d2t,
  reschedule_with_same_round_robin_host_description: u2t,
  disable_input_if_prefilled: _2t,
  booking_limits: p2t,
  booking_limits_team_description: m2t,
  limit_team_booking_frequency_description: f2t,
  booking_limits_updated_successfully: g2t,
  you_are_unauthorized_to_make_this_change_to_the_booking: h2t,
  delegation_credential_disabled: v2t,
  matching_members: b2t,
  x_matching_members: y2t,
  matching_members_queue_using_attribute_weights: $2t,
  matching_members_queue_using_event_assignee_weights: w2t,
  no_matching_members: k2t,
  no_matching_members_will_fallback_to_all_assigned_members: S2t,
  hide_calendar_event_details: x2t,
  description_hide_calendar_event_details: E2t,
  last_number_of_days: T2t,
  month_to_date: A2t,
  year_to_date: C2t,
  custom_range: z2t,
  refund_policy: O2t,
  always: P2t,
  never: I2t,
  payment_option: R2t,
  if_cancelled: N2t,
  before: D2t,
  show_all_columns: M2t,
  toggle_columns: L2t,
  no_columns_found: q2t,
  salesforce_create_record_as: j2t,
  salesforce_lead: F2t,
  salesforce_contact_under_account: V2t,
  salesforce_skip_entry_creation: B2t,
  salesforce_if_account_does_not_exist: U2t,
  salesforce_create_new_contact_under_account: W2t,
  salesforce_change_record_owner_on_booking: G2t,
  mass_assign_attributes: H2t,
  reroute_preview_custom_message: K2t,
  reroute_preview_external_redirect: Y2t,
  reroute_preview_possible_host: Z2t,
  current_routing_status: Q2t,
  reroute_booking: J2t,
  reroute_booking_description: X2t,
  verify_new_route: eSt,
  reroute: tSt,
  new_routing_status: nSt,
  salesforce_book_directly_with_attendee_owner: oSt,
  salesforce_check_owner_of: rSt,
  account: iSt,
  choose_hosts_schedule: aSt,
  hosts_schedule_description: sSt,
  no_hosts_description: cSt,
  team_member_round_robin_reassign: lSt,
  team_member_round_robin_reassign_description: dSt,
  round_robin_reassign_description: uSt,
  invalid_round_robin_host: _St,
  user_is_round_robin_fixed: pSt,
  reschedule_with_same_timeslot: mSt,
  reschedule_with_same_timeslot_of_new_event: fSt,
  reschedule_to_the_new_event_with_different_timeslot: gSt,
  reschedule_with_different_timeslot: hSt,
  we_dont_have_id_for_the_new_event: vSt,
  rerouted_booking_successfully_redirecting_to_booking_page: bSt,
  on_booking_write_to_event_object: ySt,
  field_name: $St,
  add_new_field: wSt,
  you_dont_have_access_to_reroute_this_booking: kSt,
  form_response_not_found: SSt,
  contact_owner: xSt,
  contact_owner_not_found: ESt,
  using_fallback_members: TSt,
  chosen_route: ASt,
  attribute_logic_matched: CSt,
  attribute_logic_fallback_matched: zSt,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: OSt,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: PSt,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: ISt,
  warning: RSt,
  fallback_attribute_logic_description: NSt,
  fallback_attribute_logic_warning: DSt,
  fallback_not_needed: MSt,
  confirm_reassign_unavailable: LSt,
  confirm_reassign_available: qSt,
  reassign_unavailable_team_member_description: jSt,
  reassign_available_team_member_description: FSt,
  yes_reassign: VSt,
  filter_by_attributes: BSt,
  reassign_reason: USt,
  field_type_change_suggestion: WSt,
  reassigned_by: GSt,
  row: HSt,
  rows: KSt,
  attendee_timezone_variable: YSt,
  event_start_time_in_attendee_timezone_variable: ZSt,
  event_start_time_in_attendee_timezone_info: QSt,
  event_end_time_in_attendee_timezone_info: JSt,
  event_end_time_in_attendee_timezone_variable: XSt,
  salesforce_create_event_on_contact: ext,
  salesforce_owner_name_to_change: txt,
  no_filter_set: nxt,
  booking_dry_run_successful: oxt,
  booking_dry_run_successful_description: rxt,
  dont_have_access_this_page: ixt,
  you_need_admin_or_owner_privileges_to_access: axt,
  field_type: sxt,
  when_to_write: cxt,
  salesforce_on_booking_write_to_record: lxt,
  on_every_booking: dxt,
  only_if_field_is_empty: uxt,
  booking_start_date: _xt,
  booking_created_date: pxt,
  booking_reassigned_to_host: mxt,
  no_contact_owner: fxt,
  routing_forms_created: gxt,
  routing_forms_total_responses: hxt,
  routing_forms_total_responses_without_booking: vxt,
  routing_forms_total_responses_with_booking: bxt,
  routing_form_insights: yxt,
  routing_form_insights_form_name_header: $xt,
  routing_form_insights_booking_status_header: wxt,
  routing_form_insights_response_no_booking: kxt,
  routing_form_insights_booked_by: Sxt,
  routing_form_insights_created_at: xxt,
  routing_form_insights_booking_status: Ext,
  routing_form_insights_booking_at: Txt,
  routing_form_insights_submitted_at: Axt,
  copy_redirect_url: Cxt,
  redirect_url_on_exit: zxt,
  total_bookings_per_period: Oxt,
  routed_to_per_period: Pxt,
  per_day: Ixt,
  per_week: Rxt,
  per_month: Nxt,
  routing_form_insights_assignment_reason: Dxt,
  access_denied: Mxt,
  salesforce_route_to_owner: Lxt,
  salesforce_add_attendees_as: qxt,
  salesforce_do_not_route_to_owner: jxt,
  salesforce_route_to_custom_lookup_field: Fxt,
  salesforce_option: Vxt,
  lookup_field_name: Bxt,
  salesforce_if_free_email_domain_skip_owner_check: Uxt,
  filter_operator_is: Wxt,
  filter_operator_is_not: Gxt,
  filter_operator_contains: Hxt,
  filter_operator_does_not_contain: Kxt,
  filter_operator_starts_with: Yxt,
  filter_operator_ends_with: Zxt,
  filter_operator_is_empty: Qxt,
  filter_operator_not_empty: Jxt,
  translate_description_button: Xxt,
  translate_description_button_description: eEt,
  rr_distribution_method: tEt,
  rr_distribution_method_description: nEt,
  rr_distribution_method_availability_title: oEt,
  rr_distribution_method_availability_description: rEt,
  rr_distribution_method_balanced_title: iEt,
  rr_distribution_method_balanced_description: aEt,
  edit_team_member_weights: sEt,
  weights_updated_successfully: cEt,
  require_confirmation_for_free_email: lEt,
  exclude_emails_that_contain: dEt,
  require_emails_that_contain: uEt,
  exclude_emails_match_found_error_message: _Et,
  require_emails_no_match_found_error_message: pEt,
  search_columns: mEt,
  search_options: fEt,
  disable_org_url_label: gEt,
  disable_org_url_description: hEt,
  single_select: vEt,
  multi_select: bEt,
  calendar_conflict_settings: yEt,
  select_calendars_conflict_check: $Et,
  group_meeting: wEt,
  are_you_sure_you_want_to_remove_this_app_from: kEt,
  disconnect_app_from: SEt,
  salesforce_ignore_guests: xEt,
  google_meet: EEt,
  zoom: TEt,
  office_365_video: AEt,
  lock_attribute_for_assignment: CEt,
  lock_attribute_for_assignment_description: zEt,
  attribute_edited_successfully: OEt,
  new_group_option: PEt,
  attribute_weight_enabled: IEt,
  attribute_weight_enabled_description: REt,
  routed: NEt,
  reassigned: DEt,
  allow_rescheduling_past_events: MEt,
  allow_rescheduling_past_events_description: LEt,
  rerouted: qEt,
  salesforce_assigned: jEt,
  router_position: FEt,
  show_matching_hosts: VEt,
  no_active_queues: BEt,
  weight: UEt,
  calibration: WEt,
  shortfall: GEt,
  routing_form: HEt,
  go_back_and_save: KEt,
  save_changes: YEt,
  leave_without_saving: ZEt,
  leave_without_saving_description: QEt,
  something_unexpected_occurred: JEt,
  "500_error_message": "Es liegt nicht an Ihnen, sondern an uns.",
  dry_run_mode_active: XEt,
  icon_showcase: eTt,
  icons_showcase: tTt,
  migrating_from_team: nTt,
  feature_currently_disabled: oTt,
  choose_an_option: rTt,
  enter_option_value: iTt,
  remove_option: aTt,
  use_attribute_weights: sTt,
  if_enabled_ignore_event_type_weights: cTt,
  attribute_for_weights: lTt,
  managed_users: dTt,
  managed_users_description: uTt,
  can_you_tell_me_about: _Tt,
  use_ai_to_answer_your_questions: pTt,
  error_fetching_answer: mTt,
  k_bar_ai_error: fTt,
  select_oAuth_client: gTt,
  on_every_instance: hTt,
  delegation_credential_feature_not_enabled: vTt,
  internal_booking_note: bTt,
  internal_note_cancellation_reason: yTt,
  internal_booking_note_description: $Tt,
  internal_note_presets: wTt,
  internal_note_presets_description: kTt,
  internal_note_presets_updated_successfully: STt,
  add_preset: xTt,
  authorize: ETt,
  next: TTt,
  hide: ATt,
  show: CTt,
  utm_params: zTt,
  no_utm_params: OTt,
  asc: PTt,
  desc: ITt,
  verify_email_change: RTt,
  buy_credits: NTt,
  credits: DTt,
  credits_used: MTt,
  total_credits_remaining: LTt,
  credits_per_tip_org: qTt,
  credits_per_tip_teams: jTt,
  view_and_manage_credits: FTt,
  view_and_manage_credits_description: VTt,
  credit_worth_description: BTt,
  buy_additional_credits: UTt,
  view_additional_credits_expense_tip: WTt,
  overview: GTt,
  organization_slug_taken: HTt,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: KTt,
  you_need_to_complete_user_onboarding_before_creating_an_organization: YTt,
  use_company_email_to_create_an_organization: ZTt,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: QTt,
  you_need_to_have_minimum_published_teams: JTt,
  you_are_part_of_this_organization_already: XTt,
  you_are_part_of_another_organization_cannot_create_organization: eAt,
  you_are_part_of_another_platform_organization_cannot_create_organization: tAt,
  organization_payment_success: nAt,
  organization_payment_success_description: oAt,
  this_may_take_a_few_seconds: rAt,
  organization_onboarding_status: iAt,
  organization_onboarding_status_description: aAt,
  payment_failed: sAt,
  payment_failed_description: cAt,
  creating_your_organization: lAt,
  organization_onboarding_already_completed: dAt,
  organization_onboarding_already_exists: uAt,
  organization_onboarding_not_found: _At,
  payment_successful: pAt,
  handover_onboarding_page_title: mAt,
  handover_onboarding_page_description: fAt,
  organization_already_exists_with_this_slug: gAt,
  you_do_not_have_permission_to_create_an_organization_for_this_email: hAt,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: vAt,
  organization_has_subscription_already: bAt,
  reset_interval_weighted_rr: yAt,
  interval: $At,
  rr_reset_interval_description: wAt,
  daily: kAt,
  end_date_not_selected: SAt,
  my_ooo: xAt,
  team_ooo: EAt,
  out_of_office_team_description: TAt,
  create_ooo_dialog_team_title: AAt,
  create_ooo_dialog_team_subtitle: CAt,
  edit_ooo_dialog_team_subtitle: zAt,
  ooo_team_empty_title: OAt,
  ooo_team_empty_description: PAt,
  forward_to_team_member_only: IAt,
  ooo_team_redirect_infinite_not_allowed: RAt,
  previous_ooo_empty_title: NAt,
  previous: DAt,
  rr_interval_successfully_updated: MAt,
  trial_mode: LAt,
  inactive_team_plan: qAt,
  inactive_team_plan_description: jAt,
  limited_access_trial_mode: FAt,
  referral_program: VAt,
  referral_text: BAt,
  dub_disabled_error_message: UAt,
  uid: WAt,
  link: GAt,
  rows_per_page: HAt,
  pagination_status: KAt,
  tip_username_plus: YAt,
  user_has_no_team_yet: ZAt,
  no_team_members: QAt,
  recurring_event_doesnt_support_seats: JAt,
  booking_limit_per_booker_doesnt_support_recurring: XAt,
  seats_doesnt_support_recurring: eCt,
  recurring_event_seats_error: tCt,
  segment: nCt,
  saved_filters: oCt,
  rename: rCt,
  rename_segment: iCt,
  delete_segment: aCt,
  duplicate_segment: sCt,
  delete_segment_confirmation: cCt,
  filter_segment_updated: lCt,
  error_updating_filter_segment: dCt,
  filter_segment_duplicated: uCt,
  error_duplicating_filter_segment: _Ct,
  filter_segment_deleted: pCt,
  error_deleting_filter_segment: mCt,
  save_segment: fCt,
  segment_not_found: gCt,
  filter_segment_saved: hCt,
  no_segments: vCt,
  error_saving_filter_segment: bCt,
  override_segment: yCt,
  create_new_segment: $Ct,
  save_for_team: wCt,
  select_team: kCt,
  please_select_team: SCt,
  personal: xCt,
  hide_team_profile_link: ECt,
  hide_team_profile_link_description: TCt,
  display: ACt,
  could_not_find_slug_to_publish_org: CCt,
  picklist: zCt,
  most_cancelled_bookings: OCt,
  interface_language: PCt,
  interface_language_description: ICt,
  visitors_browser_language: RCt,
  name_or_email: NCt,
  salesforce_round_robin_skip_fallback_to_lead_owner: DCt,
  credit_purchase_failed: MCt,
  minimum_of_credits_required: LCt,
  enable_delegation_credential: qCt,
  enable_delegation_credential_description: jCt,
  disable_delegation_credential: FCt,
  disable_delegation_credential_description: VCt,
  last_active: BCt,
  member_since: UCt,
  last_updated: WCt,
  salesforce_on_cancel_write_to_event: GCt,
  salesforce_on_every_cancellation: HCt,
  report_issue: KCt,
  report_issue_description: YCt,
  open_issue: ZCt,
  this_is_your_current_plan: QCt,
  schedule_a_time: JCt,
  this_includes: XCt,
  oauth_client_updated_successfully: ezt,
  oauth_client_not_found: tzt,
  subscribe_to_platform: nzt,
  error_accessing_webhooks: ozt,
  webhook_update_failed: rzt,
  webhook_create_failed: izt,
  invalid_link: azt,
  currently_subscribed_to_plan: szt,
  user_team: czt,
  client_id_copied: lzt,
  client_secret_copied: dzt,
  maintenance_message: uzt,
  your_payment_failed: _zt,
  check_your_inbox: pzt,
  account_created_premium_not_reserved: mzt,
  email_sent_with_activation_link: fzt,
  activate_account_to_purchase_username: gzt,
  open_in_gmail: hzt,
  dont_see_email: vzt,
  resend_in_seconds: bzt,
  resend: yzt,
  verification_email_sent: $zt,
  select_all_members: wzt,
  select_all_members_tooltip: kzt,
  form_settings: Szt,
  remove_whitelist_status: xzt,
  whitelist_user_workflows: Ezt,
  user_workflows_whitelisted: Tzt,
  user_workflows_unwhitelisted: Azt,
  date_and_time: Czt,
  email_reminder_upcoming_event_notice: zzt,
  email_reminder_triggered_by_workflow: Ozt,
  event_upper_case: Pzt,
  scheduling_by: Izt,
  experience_review_prompt: Rzt,
  improve_customer_experience_message: Nzt,
  meeting_satisfaction_question: Dzt,
  meeting_not_joined_question: Mzt,
  reschedule_cta_short: Lzt,
  hide_organizer_email: qzt,
  platform_customer_cant_create_organization: jzt,
  organization_customer_cant_create_platform: Fzt,
  hide_organizer_email_description: Vzt,
  you_and_conjunction: Bzt,
  select_verified_email: Uzt,
  add_verified_email: Wzt,
  add_verified_emails: Gzt,
  custom_reply_to_email_title: Hzt,
  custom_reply_to_email_description: Kzt,
  email_survey_triggered_by_workflow: Yzt,
  skip_trial: Zzt,
  team_trials_skipped_successfully: Qzt,
  sms_workflow_consent: Jzt,
  routing_preview_more_info_found_insights: Xzt,
  results: eOt,
  view_form: tOt,
  sms_opt_out_message: nOt,
  team_credits_low_warning: oOt,
  user_credits_low_warning: rOt,
  action_required_out_of_credits: iOt,
  action_required_user_out_of_credits: aOt,
  low_credits_warning_message: sOt,
  low_credits_warning_message_user: cOt,
  credit_limit_reached_message: lOt,
  credit_limit_reached_message_user: dOt,
  current_credit_balance: uOt,
  current_balance: _Ot,
  notification_about_your_booking: pOt,
  monthly_credits: mOt,
  total_credits: fOt,
  remaining_credits: gOt,
  remaining: hOt,
  total: vOt,
  additional_credits: bOt,
  routing_form_next_in_queue: yOt,
  routing_form_select_members_to_email: $Ot,
  routing_incomplete_booking_tab: wOt,
  include_no_show_in_rr_calculation: kOt,
  recent_no_show_guests: SOt,
  recent_no_show_guests_tooltip: xOt,
  matching: EOt,
  event_redirect: TOt,
  reset_form: AOt,
  rr_settings_successfully_updated: COt,
  distribution_basis_weighted_rr: zOt,
  timestamp_basis_description: OOt,
  requires_credits: POt,
  requires_credits_tooltip: IOt,
  available_credits: ROt,
  create_role: NOt,
  roles_and_permissions: DOt,
  roles_and_permissions_description: MOt,
  learn_more_permissions: LOt,
  role_name: qOt,
  role_name_required: jOt,
  role_name_placeholder: FOt,
  role_description: VOt,
  role_description_placeholder: BOt,
  default_role: UOt,
  custom_role: WOt,
  advanced: GOt,
  search_permissions: HOt,
  all_permissions: KOt,
  none: YOt,
  read_only: ZOt,
  pbac_desc_all_actions_all_resources: QOt,
  pbac_resource_all: JOt,
  pbac_resource_event_type: XOt,
  pbac_resource_team: e4t,
  pbac_resource_organization: t4t,
  pbac_resource_booking: n4t,
  pbac_resource_insights: o4t,
  pbac_resource_role: r4t,
  pbac_resource_routing_form: i4t,
  pbac_resource_workflow: a4t,
  pbac_action_all: s4t,
  pbac_action_create: c4t,
  pbac_action_read: l4t,
  pbac_action_update: d4t,
  pbac_action_delete: u4t,
  pbac_action_manage: _4t,
  pbac_action_invite: p4t,
  pbac_action_remove: m4t,
  pbac_action_change_member_role: f4t,
  pbac_action_list_members: g4t,
  pbac_action_manage_billing: h4t,
  pbac_action_read_team_bookings: v4t,
  pbac_action_read_org_bookings: b4t,
  pbac_action_read_recordings: y4t,
  pbac_action_impersonate: $4t,
  role_created_successfully: w4t,
  role_updated_successfully: k4t,
  delete_role: S4t,
  confirm_delete_role: x4t,
  role_deleted_successfully: E4t,
  error_creating_role: T4t,
  error_updating_role: A4t,
  pbac_desc_create_roles: C4t,
  pbac_resource_attributes: z4t,
  pbac_desc_view_organization_attributes: O4t,
  pbac_desc_update_organization_attributes: P4t,
  pbac_desc_delete_organization_attributes: I4t,
  pbac_desc_create_organization_attributes: R4t,
  pbac_desc_view_roles: N4t,
  pbac_desc_update_roles: D4t,
  pbac_desc_delete_roles: M4t,
  pbac_desc_create_workflows: L4t,
  set_up_required: q4t,
  pbac_desc_view_workflows: j4t,
  pbac_desc_update_workflows: F4t,
  pbac_desc_delete_workflows: V4t,
  pbac_resource_webhook: B4t,
  pbac_resource_availability: U4t,
  pbac_resource_out_of_office: W4t,
  pbac_desc_create_webhooks: G4t,
  pbac_desc_view_webhooks: H4t,
  pbac_desc_update_webhooks: K4t,
  pbac_desc_delete_webhooks: Y4t,
  pbac_desc_create_availability: Z4t,
  pbac_desc_view_availability: Q4t,
  pbac_desc_update_availability: J4t,
  pbac_desc_delete_availability: X4t,
  pbac_desc_create_out_of_office: e3t,
  pbac_desc_view_out_of_office: t3t,
  pbac_desc_update_out_of_office: n3t,
  pbac_desc_delete_out_of_office: o3t,
  pbac_desc_manage_workflows: r3t,
  pbac_desc_create_event_types: i3t,
  pbac_desc_view_event_types: a3t,
  pbac_desc_update_event_types: s3t,
  pbac_desc_delete_event_types: c3t,
  pbac_desc_manage_event_types: l3t,
  pbac_desc_create_teams: d3t,
  pbac_desc_view_team_details: u3t,
  pbac_desc_update_team_settings: _3t,
  pbac_desc_delete_team: p3t,
  pbac_desc_invite_team_members: m3t,
  pbac_desc_remove_team_members: f3t,
  pbac_desc_change_team_member_role: g3t,
  pbac_desc_impersonate_team_members: h3t,
  pbac_desc_manage_teams: v3t,
  pbac_desc_create_organization: b3t,
  pbac_desc_view_organization_details: y3t,
  pbac_desc_list_organization_members: $3t,
  pbac_desc_invite_organization_members: w3t,
  pbac_desc_remove_organization_members: k3t,
  pbac_desc_manage_organization_billing: S3t,
  pbac_desc_change_organization_member_role: x3t,
  pbac_desc_impersonate_organization_members: E3t,
  pbac_desc_edit_organization_settings: T3t,
  pbac_desc_manage_organizations: A3t,
  pbac_desc_view_bookings: C3t,
  pbac_desc_view_team_bookings: z3t,
  pbac_desc_view_organization_bookings: O3t,
  pbac_desc_view_booking_recordings: P3t,
  pbac_desc_update_bookings: I3t,
  pbac_desc_manage_bookings: R3t,
  pbac_desc_view_team_insights: N3t,
  pbac_desc_manage_team_insights: D3t,
  pbac_desc_create_routing_forms: M3t,
  pbac_desc_view_routing_forms: L3t,
  pbac_desc_update_routing_forms: q3t,
  pbac_desc_delete_routing_forms: j3t,
  read_permission_auto_enabled_tooltip: F3t,
  choose_restriction_schedule: V3t,
  restriction_schedule_description: B3t,
  use_booker_timezone: U3t,
  use_booker_timezone_info: W3t,
  load_balancing_warning: G3t,
  rr_load_balancing_disabled: H3t,
  rr_load_balancing_disabled_with_groups: K3t,
  round_robin_settings_description: Y3t,
  round_robin_settings_updated_successfully: Z3t,
  booking_creation_time: Q3t,
  meeting_start_time: J3t,
  members_affected_by_disabling_delegation_credential: X3t,
  no_members_affected_by_disabling_delegation_credential: e6t,
  download_expense_log: t6t,
  error_downloading_expense_log: n6t,
  offer_to_reschedule_last_booking: o6t,
  booker_limit_exceeded_error: r6t,
  booker_limit_exceeded_error_reschedule: i6t,
  duration_min_error: a6t,
  duration_max_error: s6t,
  booking_not_allowed_by_restriction_schedule_error: c6t,
  restriction_schedule_not_found_error: l6t,
  converted_image_size_limit_exceed: d6t,
  add_group: u6t,
  routing_funnel: _6t,
  routing_funnel_total_submissions: p6t,
  routing_funnel_successful_routings: m6t,
  routing_funnel_accepted_bookings: f6t,
  license_key: g6t,
  license_selection_title: h6t,
  license_selection_description: v6t,
  agplv3_license_description: b6t,
  enter_license_key: y6t,
  enter_your_license_key: $6t,
  enter_existing_license: w6t,
  enter_license_key_description: k6t,
  license_key_placeholder: S6t,
  save_license_key: x6t,
  signature_token_optional: E6t,
  signature_token_description: T6t,
  need_a_license: A6t,
  license_key_required: C6t,
  invalid_license_key: z6t,
  license_validation_failed: O6t,
  attachments_optional: P6t,
  send_message: I6t,
  describe_the_issue: R6t,
  file_size_limit_exceed: N6t,
  invalid_file_type: D6t,
  invalid_file_type_extension: M6t,
  max_files_exceeded: L6t,
  files_uploaded_successfully: q6t,
  file_upload_instructions: j6t,
  license_key_saved: F6t,
  timezone_mismatch_tooltip: V6t,
  show_optimized_slots: B6t,
  show_optimized_slots_description: U6t,
  failed_bookings_by_field: W6t,
  failed_bookings: G6t,
  event_type_no_hosts: H6t,
  cache_status: K6t,
  cache_last_updated: Y6t,
  delete_cached_data: Z6t,
  cache_deleted_successfully: Q6t,
  error_deleting_cache: J6t,
  confirm_delete_cache: X6t,
  yes_delete_cache: e5t,
  remainder_of_maximum_uses_left_plural: t5t,
  remainder_of_maximum_use_left_singular: n5t,
  expires_on_date: o5t,
  single_use: r5t,
  time_based_expiration: i5t,
  usage_based_expiration: a5t,
  number_of_uses: s5t,
  expires_on: c5t,
  max_usage_count: l5t,
  link_settings: d5t,
  link_expired_on_date: u5t,
  usage_limit_reached: _5t,
  usage_count_error: p5t,
  private_link_expired: m5t,
  time_based_expiration_description: f5t,
  time_based_generic_expiration_description: g5t,
  usage_based_expiration_description: h5t,
  usage_based_generic_expiration_description: v5t,
  usage_based_expiration_description_plural: b5t,
  webhook_trigger_event: y5t,
  webhook_created_at: $5t,
  webhook_type: w5t,
  set_up_agent: k5t,
  webhook_title: S5t,
  webhook_start_time: x5t,
  webhook_end_time: E5t,
  webhook_description: T5t,
  webhook_location: A5t,
  webhook_uid: C5t,
  webhook_reschedule_uid: z5t,
  webhook_cancellation_reason: O5t,
  webhook_rejection_reason: P5t,
  webhook_organizer_name: I5t,
  webhook_organizer_email: R5t,
  webhook_organizer_timezone: N5t,
  webhook_organizer_locale: D5t,
  webhook_organizer_username: M5t,
  webhook_organizer_username_in_org: L5t,
  webhook_attendee_name: q5t,
  webhook_attendee_email: j5t,
  webhook_attendee_timezone: F5t,
  webhook_attendee_locale: V5t,
  webhook_team_name: B5t,
  webhook_team_members: U5t,
  webhook_video_call_url: W5t,
  webhook_hide_variables: G5t,
  webhook_show_variable: H5t,
  webhook_event_and_booking: K5t,
  webhook_people: Y5t,
  webhook_teams: Z5t,
  webhook_metadata: Q5t,
  stats: J5t,
  booking_status: X5t,
  visit: ePt,
  location_custom_label_input_label: tPt,
  meeting_link: nPt,
  session_outcome: oPt,
  call_created: rPt,
  voicemail: iPt,
  my_bookings: aPt,
  phone: sPt,
  free: cPt,
  user_email: lPt,
  user_name: dPt,
  expand_panel: uPt,
  collapse_panel: _Pt,
  email_verification_required: pPt,
  invalid_verification_code: mPt,
  you_have_one_team: fPt,
  consider_consolidating_one_team_org: gPt,
  consider_consolidating_multi_team_org: hPt,
  message_sent: vPt,
  support_message_sent_description: bPt,
  search_variables: yPt,
  support_message_placeholder: $Pt,
  send_another_message: wPt,
  sending: kPt,
  no_variables_found: SPt,
  credits_required: xPt,
  web_call_credits_info: EPt,
  web_call_no_credits: TPt,
  purchase_credits: APt,
  credits_required_tooltip: CPt,
  api_key_name_too_long: zPt,
  auto_charge_for_last_minute_cancellation: OPt,
  before_scheduled_start_time: PPt,
  cancel_booking_acknowledge_no_show_fee: IPt,
  contact_organizer: RPt,
  booking_time_option: NPt,
  booking_time_option_description: DPt,
  created_at_option: MPt,
  created_at_option_description: LPt,
  call_details: qPt,
  call_id: jPt,
  call_information: FPt,
  sentiment: VPt,
  disconnect_reason: BPt,
  call_summary: UPt,
  transcription: WPt,
  event_details: GPt,
  agent: HPt,
  no_transcript_available: KPt,
  testing_sms_workflow_info_message: YPt,
  start_from_scratch_title: ZPt,
  start_from_scratch_description: QPt,
  cal_ai_template_title: JPt,
  cal_ai_template_description: XPt,
  voice: eIt,
  select_voice: tIt,
  select_voice_for_agent: nIt,
  choose_a_voice_for_your_agent: oIt,
  trait: rIt,
  voice_id: iIt,
  use_voice: aIt,
  current_voice: sIt,
  setup_incoming_agent: cIt,
  setup_incoming_agent_description: lIt,
  connect_a_phone_number_first: dIt,
  setup_agent_for_incoming_calls: uIt,
  configure_agent_to_handle_incoming_calls: _It,
  incoming_calls: pIt,
  outgoing_calls: mIt,
  inbound_agent_setup_success: fIt,
  inbound_agent_configured: gIt,
  setup_inbound_agent: hIt,
  please_select_event_type_first: vIt,
  edit_configuration: bIt,
  select_event_type_for_inbound_calls: yIt,
  setup_inbound_agent_for_incoming_calls: $It,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: wIt
}, SIt = "Identity provider", xIt = 'You have $t(day, {"count": {{days}} }) left on your PRO trial', EIt = "{{count}} day", TIt = "{{count}} days", AIt = "{{count}} second", CIt = "{{count}} seconds", zIt = "Upgrade now", OIt = "Untitled", PIt = "Accept Invitation", IIt = "Max. Characters", RIt = "Min. Characters", NIt = "{{appName}} provides scheduling infrastructure for absolutely everyone.", DIt = "Finish setting up your {{appName}} account! You're just a few steps away from solving all your scheduling problems.", MIt = "Have questions? We're here to help.", LIt = "{{appName}}: Reset password instructions", qIt = "{{appName}}: Verify your account", jIt = "{{appName}}: Verify your email", FIt = "Check your email", VIt = "Old Email", BIt = "New Email", UIt = "We've sent an email to {{email}}. It is important to verify your email address to guarantee the best email and calendar deliverability from {{appName}}.", WIt = "Verify your email address to guarantee the best email and calendar deliverability", GIt = "Verify your email address", HIt = "Verify email", KIt = "Assistant", YIt = "Send Cal Video Transcription Emails", ZIt = "Send emails with the transcription of the Cal Video after the meeting ends. (Requires a paid plan)", QIt = "You have recently requested to change the email address you use to log into your {{appName}} account. Please click the button below to confirm your new email address.", JIt = "Updated your email to {{email}}", XIt = "Failed to update email.", eRt = "Verify your new {{appName}} email address", tRt = "We have sent a verification link to {{email}}. We will update your email address once you click this link.", nRt = "Save this API key somewhere safe. You will not be able to view it again.", oRt = "Please verify your email address by clicking the button below.", rRt = "Please verify your email address by using the below code.", iRt = "Here's the link in case you don't like clicking buttons:", aRt = "Enter verification code", sRt = "Enter verification code sent to your mail", cRt = "Verification code is incorrect.", lRt = "Email sent successfully", dRt = "Error occurred while sending email", uRt = "Declined: {{title}} at {{date}}", _Rt = "Canceled: {{title}} at {{date}}", pRt = "Reassigned: {{title}} at {{date}}", mRt = "Your event request has been declined", fRt = "Customize Cal Video Settings", gRt = "Configure video meeting preferences including recording permissions for hosts and attendees.", hRt = "Disable recording for guests", vRt = "Enable automatic transcription after joining the meeting", bRt = "Enable automatic recording after organizer joins the meeting", yRt = "Video Options", $Rt = "Edit event", wRt = "View Session Details", kRt = "Meeting Session Details", SRt = "Meeting Session", xRt = "Session ID", ERt = "Max Participants", TRt = "Unlimited", ARt = "Ongoing", CRt = "Ended", zRt = "Participants", ORt = "Anonymous User", PRt = "Session Duration", IRt = "No meeting sessions found", RRt = "Not available", NRt = "Disable recording for organizer", DRt = "Disable transcription for guests", MRt = "Disable transcription for organizer", LRt = "Your recurring event request has been declined", qRt = "Your scheduled event was canceled", jRt = "Your scheduled event was reassigned", FRt = "You will no longer have the event on your calendar and your round robin likelihood will not be negatively impacted", VRt = "Organizer", BRt = "Reassigned to", URt = "Need to reschedule or cancel?", WRt = "You can view the booking details from this url {{url}} and add the event to your calendar", GRt = "No options available", HRt = "Reason for cancellation (optional)", KRt = "Cancelled By", YRt = "Reason for cancellation", ZRt = "Why are you cancelling?", QRt = "Cancellation reason will be shared with guests", JRt = "Why are you rejecting?", XRt = "Reason for rejecting", eNt = "Reject the booking request?", tNt = "Are you sure you want to reject the booking? We'll let the person who tried to book know. You can provide a reason below.", nNt = "Reject the booking", oNt = "Report this booking as suspicious. This helps us identify and prevent spam or unwanted bookings.", rNt = "Spam or unwanted booking", iNt = "I don't know this person", aNt = "Other", sNt = "Cancel this booking", cNt = "Report all remaining bookings in series", lNt = "Submit Report", dNt = "Please provide additional details about why you're reporting this booking (optional)", uNt = "Manage this event", _Nt = "Invite team member", pNt = "Invite individual", mNt = "Bulk import", fNt = "Inv.", gNt = "Your event has been scheduled", hNt = "Your recurring event has been scheduled", vNt = "Accept our license by changing the .env variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> to '{{agree}}'.", bNt = "To remove this banner, please open your .env file and change the <1>NEXT_PUBLIC_LICENSE_CONSENT</1> variable to '{{agree}}'.", yNt = "The error message was: '{{errorMessage}}'", $Nt = "Refund failed: {{name}} - {{date}} - {{eventType}}", wNt = "The refund for the event {{eventType}} with {{userName}} on {{date}} failed.", kNt = "Please check with your payment provider and {{user}} how to handle this.", SNt = "A refund failed", xNt = "Awaiting Payment: {{title}} on {{date}}", ENt = "Your meeting is awaiting payment", TNt = "Dark Theme color doesn't pass contrast check. We recommend you change this colour so your buttons will be more visible.", ANt = "Light Theme color doesn't pass contrast check. We recommend you change this colour so your buttons will be more visible.", CNt = "Light Theme color doesn't pass contrast check. We recommend you change this color so your event types color will be more visible.", zNt = "Dark Theme color doesn't pass contrast check. We recommend you change this color so your event types color will be more visible.", ONt = "Payment could not be created", PNt = "Could not charge card for Payment", INt = "No available users found. Could you try another time slot?", RNt = "The selected time slot is no longer available. <0>Please select a new time</0>", NNt = "Taken", DNt = "You’ve just connected. Please book from above slots or retry later.", MNt = "Unavailable timeslot", LNt = "The event type cannot be booked at this time. Could you try another time slot?", qNt = "Internal Error. Request body does not contain end time", jNt = "Unable to create Calendar event in Organizer's calendar", FNt = "Unable to update Calendar event.", VNt = "Unable to delete Calendar event.", BNt = "You are already signed up for this booking.", UNt = "Some of the hosts are unavailable for booking.", WNt = "Some of the fixed hosts are unavailable for booking.", GNt = "Round Robin host is unavailable for booking.", HNt = "Help", KNt = "Price", YNt = "Paid", ZNt = "Refunded", QNt = "Record", JNt = "Transcribe", XNt = "Payment", eDt = "Missing card fields", tDt = "Pay now", nDt = "General Prompt", oDt = "Transcription powered by AI", rDt = "Start or stop recording", iDt = "Begin Message", aDt = "The codebase has to stay open source, whether it was modified or not", sDt = "You can not repackage or sell the codebase", cDt = "Acquire a commercial license to remove these terms by emailing", lDt = "Summary of terms", dDt = "Open .env and agree to our License", uDt = "I've changed my .env", _Dt = "Accept License", pDt = "An event is still waiting for approval", mDt = "Event request is still waiting: {{attendeeName}} - {{date}} - {{eventType}}", fDt = 'No result found for "{{searchTerm}}"', gDt = "No more results", hDt = "No results", vDt = "Load more results", bDt = "{{integrationName}} meeting ID: {{meetingId}}", yDt = "Confirmed: {{eventType}} with {{name}} at {{date}}", $Dt = "New event request: {{attendeeName}} - {{date}} - {{eventType}}", wDt = "Confirm or reject the request", kDt = "Check your bookings page to confirm or reject the booking.", SDt = "Check-in Assistant", xDt = "Makes an outbound call to check if scheduled appointment works or if you want to reschedule.", EDt = "Create your own prompt and use it to make an outbound call.", TDt = "An event is waiting for your approval", ADt = "A recurring event is waiting for your approval", CDt = "Someone has requested to schedule an event on your calendar.", zDt = "Someone has requested a link to change your password.", ODt = "If this email exists in our system, you should receive a reset email.", PDt = "If you didn't request this, you can safely ignore this email and your password will not be changed.", IDt = "Awaiting Approval: {{title}} at {{date}}", RDt = "An event is still waiting for your approval", NDt = "Booking Submitted: {{title}} at {{date}}", DDt = "Download Recording: {{title}} at {{date}}", MDt = "Download Transcript: {{title}} at {{date}}", LDt = "Download your recording", qDt = "Download your Transcripts", jDt = "Your meeting has been booked", FDt = "Your {{title}} has been rescheduled to {{date}}.", VDt = "Your {{title}} has been updated.", BDt = "Updated - Your event has been rescheduled", UDt = "Event has been updated", WDt = "Your event has been rescheduled", GDt = "{{organizer}} has canceled the booking and requested you to pick another time.", HDt = "You have requested {{attendee}} to reschedule", KDt = "You have canceled the booking and {{attendee}} should pick a new booking time with you.", YDt = "Request for reschedule sent: {{eventType}} with {{name}} at {{date}}", ZDt = "Action Required Reschedule: Please book a new time for {{eventType}} with {{name}}", QDt = "Hi {{name}}", JDt = "{{eventType}} with {{name}}", XDt = "It looks like all of our experts are busy right now. Please schedule a call at a time that works best for you and we'll be ready to assist you.", eMt = "Schedule instead", tMt = "New event: {{attendeeName}} - {{date}} - {{eventType}}", nMt = "Join by {{entryPoint}}", oMt = "Notes", rMt = "Manage my bookings", iMt = "Need to make a change?", aMt = "A new event has been scheduled.", sMt = "A new recurring event has been scheduled.", cMt = "Invitee Email", lMt = "Invitee Time Zone", dMt = "Time left", uMt = "Event Type", _Mt = "Duplicate Event Type", pMt = "Enter Meeting", mMt = "Video call provider", fMt = "Meeting ID", gMt = "Meeting Password", hMt = "Meeting URL", vMt = "Meeting URL not found", bMt = "Token not found", yMt = "Some other host already accepted the meeting. Do you still want to join? <0>Continue to Meeting</0>", $Mt = "Your meeting request has been rejected", wMt = "Rejected: {{eventType}} with {{organizer}} on {{date}}", kMt = "Hi", SMt = "Join team", xMt = "Manage this team", EMt = "Team Info", TMt = "Join Meeting", AMt = "If you prefer not to use {{toEmail}} as your {{appName}} email or already have a {{appName}} account, please request another invitation to that email.", CMt = "You have been invited to join the team {{teamName}}", zMt = "{{user}} invited you to join the {{entity}} {{team}} on {{appName}}", OMt = "You are hidden in this team", PMt = "Your seat is not paid for, either Upgrade to PRO or let the team owner know they can pay for your seat.", IMt = "You need a pro account to use teams, you are hidden until you upgrade.", RMt = "p.s. It expires in {{expiresIn}} hours.", NMt = "Upgrade to Per-Seat", DMt = "Seats option doesn't support confirmation requirement", MMt = "Multiple Locations doesn't support seats option", LMt = "No show fee doesn't support seats option", qMt = "Seats option doesn't support Multiple Locations", jMt = "Of the {{memberCount}} members in your team, {{unpaidCount}} seat(s) are unpaid. At ${{seatPrice}}/month per seat the estimated total cost of your membership is ${{totalCost}}/month.", FMt = `You haven't finished your team setup. Your team "{{teamName}}" needs to be upgraded.`, VMt = "Upgrade here", BMt = "Your team was upgraded successfully!", UMt = 'Thank you for trialing our Organization plan. We noticed your Organization "{{teamName}}" needs to be upgraded.', WMt = "Your Organization was upgraded successfully!", GMt = "Use the link below to reset your password", HMt = "Hey there", KMt = "there", YMt = "Forgot your password? - {{appName}}", ZMt = "Are you sure you want to delete this webhook? You will no longer receive {{appName}} meeting data at a specified URL, in real-time, when an event is scheduled or canceled.", QMt = "Yes, delete webhook", JMt = "Edit Webhook", XMt = "Delete Webhook", eLt = "Webhook Status", tLt = "Webhook Enabled", nLt = "Webhook Disabled", oLt = "Webhook response", rLt = "Webhook test", iLt = "Webhook update form", aLt = "Add a webhook to your OAuthClient.", sLt = "Manage your webhook", cLt = "Webhook created successfully!", lLt = "Webhook updated successfully!", dLt = "Webhook removed successfully!", uLt = "Subscription needed", _Lt = "You are not subscribed to a Platform plan.", pLt = "Payload Template", mLt = "Dismiss", fLt = "No data yet", gLt = "Ping test", hLt = "Add this app to your home screen for faster access and improved experience.", vLt = "Upcoming", bLt = "Recurring", yLt = "Past", $Lt = "Choose a file...", wLt = "Upload image", kLt = "Upload {{target}}", SLt = "No {{target}}", xLt = "Slide to zoom, drag to reposition", ELt = "View notifications", TLt = "View public page", ALt = "Copy public page link", CLt = "Copy referral link", zLt = "Sign out", OLt = "Add another", PLt = "Install another", ILt = "until", RLt = "powered by", NLt = "Unavailable", DLt = "Set your work schedule", MLt = "Change when you are available for bookings", LLt = "Select...", qLt = "Text", jLt = "Your Phone Number", FLt = "Multiline Text", VLt = "Number", BLt = "Checkbox", ULt = "Is required", WLt = "Make this field required", GLt = "Required", HLt = "Optional", KLt = "Input type", YLt = "Rejected", ZLt = "Unconfirmed", QLt = "Guests", JLt = "Guest", XLt = "Web conferencing details to follow in the confirmation email.", eqt = "Confirmation", tqt = "What your booker should provide to receive confirmations", nqt = "Username", oqt = "is still available.", rqt = "Documentation", iqt = "Learn how to integrate our tools with your app", aqt = "API Reference", sqt = "A complete API reference for our libraries", cqt = "Blog", lqt = "Read our latest news and articles", dqt = "Join our community", uqt = "Popular pages", _qt = "Register now", pqt = "Register", mqt = "This page does not exist.", fqt = "No active phone number available", gqt = "Workflow step not configured", hqt = "Check for spelling mistakes or go back to the previous page.", vqt = "We could not find the event you are trying to book.", bqt = "Getting Started", yqt = "Secret", $qt = "Leave blank to remove secret", wqt = "Ensure your server is only receiving the expected {{appName}} requests for security reasons", kqt = "Secret Meeting", Sqt = "Login instead", xqt = "Create Account", Eqt = "Get started", Tqt = "Confirm password", Aqt = "Set your new password with the instructions sent to your email address.", Cqt = "Please upload image of {{width}} width and {{height}} height.", zqt = "Log back in with your new email address and password.", Oqt = "Create your account", Pqt = "Create your Cal.com account", Iqt = "Sign up", Rqt = "You've been logged out", Nqt = "We hope to see you again soon!", Dqt = "Logged out", Mqt = "Please try again and contact us if the issue persists.", Lqt = "Two-factor code is incorrect.", qqt = "No account exists matching that email address.", jqt = "Create an account", Fqt = "Don't have an account?", Vqt = "Sign in to your account", Bqt = "Sign in", Uqt = "Go back to the login page", Wqt = "An error occurred when logging you in. Head back to the login screen and try again.", Gqt = "Send reset email", Hqt = "Send invite", Kqt = "Forgot Password?", Yqt = "Forgot?", Zqt = "Done", Qqt = "All done!", Jqt = "All", Xqt = "Your account", e9t = "Available Apps", t9t = "Available apps", n9t = "View popular apps below and explore more in our <0>App Store</0>", o9t = "Add anyone who needs to attend the event. <0>Learn more</0>", r9t = "People in a group take turns, one person of each group will show up for the event. <0>Learn more</0>", i9t = "People in the group take turns and only one person will show up for the event. <0>Learn more</0>", a9t = "Check your email. We sent you a link to reset your password.", s9t = "Finish", c9t = "Manage settings for your team language and timezone", l9t = "A few sentences about yourself. This will appear on your scheduling link.", d9t = "Nearly there!", u9t = "Last thing, a brief description about you and a photo really helps you get bookings and let people know who they're booking with.", _9t = "Define ranges of time when you are available on a recurring basis. You can create more of these later and assign them to different calendars.", p9t = "Set your availability", m9t = "Set schedules for the times you want to be booked.", f9t = "Share a link or embed", g9t = "Share your {{appName}} link or embed on your site.", h9t = "Availability Settings", v9t = "Continue without calendar", b9t = "Continue with {{appName}}", y9t = "Connect your calendar", $9t = "Connect your video apps", w9t = "Connect your preferred video conferencing app to use it for your meetings.", k9t = "Connect your calendar to automatically check for busy times and new events as they're scheduled.", S9t = "Set up later", x9t = "Current time", E9t = "Details", T9t = "Welcome", A9t = "Welcome back", C9t = "Welcome to {{appName}}", z9t = "Tell us what to call you and let us know what timezone you're in. You'll be able to edit this later.", O9t = "Connect to CalDav (Beta)", P9t = "Connect to an ICS Feed", I9t = "Connect", R9t = "Try it for free", N9t = "Create your own booking link with {{appName}}", D9t = "Who", M9t = "What", L9t = "When", q9t = "Where", j9t = "Add to calendar", F9t = "Select where to add events when you're booked.", V9t = "Add events to", B9t = "Add another calendar", U9t = "Other", W9t = "Your sign-in link for {{appName}}", G9t = "You are meeting with {{user}}. We sent an email with a calendar invitation with the details to everyone.", H9t = "{{host}} is meeting with {{attendee}}. We sent an email with a calendar invitation with the details to everyone.", K9t = "We sent an email with a calendar invitation with the details to everyone.", Y9t = "We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", Z9t = "You are meeting with {{user}}. We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", Q9t = "{{host}} is meeting with {{attendee}}. We sent an email with a calendar invitation with the details to everyone for the first of these recurring events.", J9t = "We sent an email to everyone with this information.", X9t = "Your booking still needs to be confirmed or rejected.", ejt = "Your recurring meeting still needs to be confirmed or rejected.", tjt = "{{user}} still needs to confirm or reject the booking.", njt = "{{user}} still needs to confirm or reject each booking of the recurring meeting.", ojt = "This meeting is scheduled", rjt = "The recurring events are scheduled", ijt = "Your booking has been submitted", ajt = "Your recurring meeting has been submitted", sjt = "Your booking has been confirmed", cjt = "Your recurring meeting has been confirmed", ljt = "Payments are not supported with Recurring Events yet", djt = "Recurring events are not supported with Payments yet", ujt = "Enter the new password you'd like for your account.", _jt = "Reset Password", pjt = "Change your password", mjt = "Show password", fjt = "Hide password", gjt = "Try Again", hjt = "That Request is Expired.", vjt = "Enter the email address associated with your account and we will send you a link to reset your password.", bjt = "That request is expired. Go back and enter the email associated with your account and we will send you another link to reset your password.", yjt = "Whoops", $jt = "Login", wjt = "Success", kjt = "Failed", Sjt = "Your password has been reset. You can now login with your newly created password.", xjt = "Layout", Ejt = "Default view", Tjt = "You can select multiple and your bookers can switch views.", Ajt = "Booking layout", Cjt = "You can select multiple and bookers can switch views. This can be overridden on a per event basis.", zjt = "Month", Ojt = "Weekly", Pjt = "Column", Ijt = "At least one layout has to be enabled.", Rjt = "The layout you selected as the default view is not part of the enabled layouts.", Njt = "The layout you selected is not a valid layout.", Djt = "You can manage this for all your event types in Settings -> <0>Appearance</0> or <1>Override</1> for this event only.", Mjt = "An unexpected error occurred. Try again.", Ljt = "Invalid time on Sunday", qjt = "Invalid time on Monday", jjt = "Invalid time on Tuesday", Fjt = "Invalid time on Wednesday", Vjt = "Invalid time on Thursday", Bjt = "Invalid time on Friday", Ujt = "Invalid time on Saturday", Wjt = "End time cannot be before start time", Gjt = "End time cannot be greater than 24 hours", Hjt = "Back to bookings", Kjt = "Feel free to pick another event anytime.", Yjt = "Canceled", Zjt = "No booking", Qjt = "Awaiting host", Jjt = "Cancellation successful", Xjt = "Really cancel your booking?", eFt = "You cannot cancel this booking", tFt = "Instead, you could also reschedule it.", nFt = "The event is in the past", oFt = "The event is one instance of a recurring event.", rFt = "These are all remaining instances in the recurring event.", iFt = "An error with status code {{status}} occurred.", aFt = "An event type with this URL already exists.", sFt = "You are not able to create this event", cFt = "You are not able to edit this event", lFt = "You are not able to create this workflow", dFt = "You are not able to create this schedule", uFt = "This booking was already canceled", _Ft = "This booking was already accepted or rejected", pFt = "Go back home", mFt = "Or go back home", fFt = "No Meeting Found", gFt = "This meeting does not exist. Contact the meeting owner for an updated link.", hFt = "No {{status}} bookings", vFt = "You have no {{status}} bookings. {{description}}", bFt = "{{eventName}} between {{host}} and {{attendeeName}}", yFt = "Bookings", $Ft = "Booking not found", wFt = "See upcoming and past events booked through your event type links.", kFt = "As soon as someone books a time with you it will show up here.", SFt = "As soon as someone books a recurring meeting with you it will show up here.", xFt = "Your past bookings will show up here.", EFt = "Your canceled bookings will show up here.", TFt = "Your unconfirmed bookings will show up here.", AFt = "Unconfirmed bookings", CFt = "on", zFt = "and", OFt = "Your calendar shows you as busy between", PFt = "Troubleshoot", IFt = "Understand why certain times are available and others are blocked.", RFt = "Here is an overview of your day on", NFt = "Tip: Hover over the bold times for a full timestamp", DFt = "Start time", MFt = "End time", LFt = "Buffer time", qFt = "Before event", jFt = "After event", FFt = "No buffer time", VFt = "Buffer", BFt = "Your day starts at", UFt = "Your day ends at", WFt = "Launch troubleshooter", GFt = "Troubleshoot your availability to explore why your times are showing as they are.", HFt = "Change available times", KFt = "Change your available times", YFt = "Change the start and end times of your day", ZFt = "Set the start and end time of your day and a minimum buffer between your meetings.", QFt = "Currently, your day is set to start at", JFt = "The start and end times for your day have been changed successfully.", XFt = "and end at", e8t = "Light", t8t = "Dark", n8t = "Automatically adjust theme based on invitee preferences", o8t = "Some of the users in the group have currently disabled dynamic group bookings", r8t = "Group booking links that can be created dynamically by adding multiple usernames with a '+'. example: '{{appName}}/bailey+peer'", i8t = "Allow attendees to book you through dynamic group bookings", a8t = "Dynamic group links", s8t = "Allow search engines to access your public content", c8t = "Allow search engine indexing", l8t = "Allow Browser Notifications", d8t = "You have denied notifications. Reset permission in browser settings to enable.", u8t = "Disable Browser Notifications", _8t = "Browser Notifications turned on", p8t = "Browser Notifications turned off", m8t = "Browser Notifications denied", f8t = "Please allow notifications from the prompt", g8t = "Push Notifications", h8t = "Receive push notifications when booker submits instant meeting booking.", v8t = "Your browser does not support Push Notifications. If you are Brave user then enable `Use Google services for push messaging` Option on brave://settings/?search=push+messaging", b8t = "Email", y8t = "jdoe@example.com", $8t = "Full name", w8t = "Browse our API documentation", k8t = "Leverage our API for full control and customizability.", S8t = "Create Webhook", x8t = "Instant Meeting Created", E8t = "Booking Canceled", T8t = "Booking Rescheduled", A8t = "Recording Download Link Ready", C8t = "Transcript Generated", z8t = "Booking Created", O8t = "Booking Rejected", P8t = "Booking Requested", I8t = "Booking Payment Initiated", R8t = "Meeting Ended", N8t = "Form Submitted", D8t = "Form submitted, no event booked", M8t = "Booking Paid", L8t = "Out of Office Created", q8t = "Booking No-Show Updated", j8t = "Event Triggers", F8t = "Subscriber URL", V8t = "Create a new webhook", B8t = "Webhooks", U8t = "Team Webhooks", W8t = "Create a new webhook to your account", G8t = "New Webhook", H8t = "Receive {{appName}} meeting data at a specified URL, in real-time, when an event is scheduled or canceled.", K8t = "Receive {{appName}} meeting data at a specified URL, in real-time, when this event is scheduled or canceled.", Y8t = "Responsive full screen iframe", Z8t = "Loading...", Q8t = "Deleting...", J8t = "Standard iframe", X8t = "Developer", e7t = "Manage your developer settings.", t7t = "iframe Embed", n7t = "The easiest way to embed {{appName}} on your website.", o7t = "Integrate with your website using our embed options, or get real-time booking information using custom webhooks.", r7t = "Schedule a meeting", i7t = "View and manage your billing details", a7t = "View and edit your billing details, as well as cancel your subscription.", s7t = "Go to the billing portal", c7t = "Need anything else?", l7t = "If you need any further help with billing, our support team are here to help.", d7t = "Contact", u7t = "our support team", _7t = "Contact our support team", p7t = "Uh oh!", m7t = "This user hasn't set up any event types yet.", f7t = "Edit logo", g7t = "Upload a logo", h7t = "Upload logo", v7t = "Remove logo", b7t = "Enable", y7t = "Code", $7t = "Code is incorrect.", w7t = "Add new time slot", k7t = "Add an extra layer of security to your account in case your password is stolen.", S7t = "Enable two-factor authentication", x7t = "Disable two-factor authentication", E7t = "If you need to disable 2FA, we recommend re-enabling it as soon as possible.", T7t = "Error disabling two-factor authentication", A7t = "Error setting up two-factor authentication", C7t = "Security", z7t = "Manage your account's security.", O7t = "Password", P7t = "Password updated successfully", I7t = "Your password has been successfully changed.", R7t = "Error changing password", N7t = "Your session configuration has been updated successfully.", D7t = "Error updating session configuration", M7t = "Something went wrong.", L7t = "Something doesn't look right?", q7t = "Please try again.", j7t = "Your super secure new password", F7t = "New Password", V7t = "Your old password", B7t = "Current Password", U7t = "Change Password", W7t = "Change Secret", G7t = "New password matches your old password. Please choose a different password.", H7t = "If you have lost or forgotten this secret, you can change it, but be aware that all integrations using this secret will need to be updated", K7t = "Current password is incorrect", Y7t = "Mix of uppercase & lowercase letters", Z7t = "Minimum 7 characters long", Q7t = "Minimum 15 characters long", J7t = "Contain at least 1 number", X7t = "Must be {{limit}} or fewer characters long", eVt = "The password must be a minimum of {{passwordLength}} characters long containing at least one number and have a mixture of uppercase and lowercase letters", tVt = "Password is incorrect.", nVt = "Email or password is incorrect.", oVt = "Use setting", rVt = "am/pm", iVt = "Time options", aVt = "January", sVt = "February", cVt = "March", lVt = "April", dVt = "May", uVt = "June", _Vt = "July", pVt = "August", mVt = "September", fVt = "October", gVt = "November", hVt = "December", vVt = "Monday", bVt = "Tuesday", yVt = "Wednesday", $Vt = "Thursday", wVt = "Friday", kVt = "Saturday", SVt = "Sunday", xVt = "All booked.", EVt = "Could not load the available time slots.", TVt = "Add guests", AVt = "Your name", CVt = "Your full name", zVt = "No name", OVt = "Please enter a number between 1 and {{maxOccurences}}", PVt = "Quick and easy - no account required. Perfect for one-time meetings.", IVt = "Email address", RVt = "Please enter a valid email", NVt = " Please schedule a future call if we're not available in {{seconds}} seconds", DVt = "Location", MVt = "Address", LVt = "Enter address", qVt = "In Person (Attendee Address)", jVt = "Somewhere Else", FVt = "Custom attendee location", VVt = "Continue as Guest", BVt = "Join as Guest", UVt = "Ideal for one-time calls", WVt = "Any location", GVt = "Yes", HVt = "No", KVt = "Additional notes", YVt = "Could not book the meeting.", ZVt = "Could not reschedule the meeting.", QVt = "Please share anything that will help prepare for our meeting.", JVt = "Confirm your {{eventTypeTitle}} with {{profileName}}", XVt = "Reschedule your {{eventTypeTitle}} with {{profileName}}", eBt = "In-person meeting", tBt = "In Person (Organizer Address)", nBt = "Link meeting", oBt = "Phone Number", rBt = "Attendee Phone Number", iBt = "Organizer Phone Number", aBt = "Enter phone number", sBt = "Reschedule", cBt = "Reschedule instead", lBt = "Book a team member instead", dBt = "OR", uBt = "Go back", _Bt = "Email or Username", pBt = "Send an invite email", mBt = "Role", fBt = "Edit Role", gBt = "View Role", hBt = "Edit team", vBt = "Editing user", bBt = "Editing organization", yBt = "If you wish to edit or manage your web hooks, please head over to <0>webhooks settings</0>", $Bt = "Reject", wBt = "Reject all", kBt = "Accept", SBt = "Leave", xBt = "Profile", EBt = "My team URL", TBt = "My teams", ABt = "Team Name", CBt = "Your team name", zBt = "Team updated successfully", OBt = "Your team has been updated successfully.", PBt = "Your Org has been updated successfully.", IBt = "Error copying to clipboard", RBt = "About", NBt = "A few sentences about your team. This will appear on your team's url page.", DBt = "Organization ID", MBt = "Organization ID copied.", LBt = "A few sentences about your organization. This will appear on your organization's url page.", qBt = "Team ID", jBt = "Team ID copied.", FBt = "Members", VBt = "Organization members", BBt = "Member", UBt = "{{count}} member", WBt = "{{count}} members", GBt = "{{count}} selected", HBt = "Owner", KBt = "Admin", YBt = "Admin API", ZBt = "Administrator user", QBt = "Let's create the first administrator user.", JBt = "Administrator user setup", XBt = "You have already created an administrator user. You can now log in to your account.", eUt = "New Member", tUt = "Invite", nUt = "Add team members", oUt = "Add members", rUt = "Invite others to join your team", iUt = "Add team member", aUt = "Invite a new team member", sUt = "Note: This will <0>cost an extra seat ($15/m)</0> on your subscription.", cUt = "Invite someone to your team.", lUt = "Upload a .csv file", dUt = "Invite via email", uUt = "Change team member role", _Ut = "Disable {{appName}} branding", pUt = "Hide all {{appName}} branding from your public pages.", mUt = "Hide Book a Team Member Button", fUt = "Hide Book a Team Member Button from your public pages.", gUt = "Danger zone", hUt = "Be careful. Account deletion cannot be undone.", vUt = "Be careful. Team deletion cannot be undone.", bUt = "Back", yUt = "Cancel", $Ut = "Cancel all remaining", wUt = "Apply", kUt = "Cancel event", SUt = "Report booking", xUt = "Reporting this booking will automatically cancel it", EUt = "Add to report", TUt = "Reported", AUt = "Confirm", CUt = "Confirm all", zUt = "Disband Team", OUt = "Are you sure you want to disband this team? Anyone who you've shared this team link with will no longer be able to book using it.", PUt = "Disband Organization", IUt = "Are you sure you want to disband this Org? All teams and members will be deleted.", RUt = "Are you sure you want to remove this member from the team?", NUt = "Yes, disband team", DUt = "Yes, remove member", MUt = "Yes, cancel subscription", LUt = "Cancel subscription", qUt = "Cancelling your subscription will permanently deactivate your current plan. This action cannot be undone.", jUt = "Remove member", FUt = "Manage your team", VUt = "You don't have any teams yet.", BUt = "Teams allow others to book events shared between your coworkers.", UUt = "Submit", WUt = "Yes, remove attribute", GUt = "Remove attribute", HUt = "Are you sure you want to remove the attribute '{{name}}'? All users currently assigned to it will be unassigned.", KUt = "View", YUt = "Update", ZUt = "Save", QUt = "Pending", JUt = "Open options", XUt = "Copy link to event", eWt = "Share", tWt = "Would you mind booking my cal or send me your link?", nWt = "Copy link to team", oWt = "Leave team", rWt = "Yes, leave team", iWt = "Are you sure you want to leave this team? You will no longer be able to book using it.", aWt = "{{user}} from {{team}}", sWt = "Preview", cWt = "Link copied!", lWt = "Copied!", dWt = "Private link copied!", uWt = "Link shared!", _Wt = "Title", pWt = "Description", mWt = "Apps Status", fWt = "A quick video meeting.", gWt = "Scheduling Type", hWt = "Preview team", vWt = "Collective", bWt = "Schedule meetings when all selected team members are available.", yWt = "Duration", $Wt = "Available durations", wWt = "Default duration", kWt = "Please choose available durations first", SWt = "{{count}} $t(minute_timeUnit)", xWt = "{{count}} $t({{unit}}_timeUnit)", EWt = "{{count}}$t({{unit}}_short)", TWt = "Minutes", AWt = "Use Cal.ai to get an AI powered phone number or make calls to guests.", CWt = "Termination URI", zWt = "SIP Trunk User Name", OWt = "SIP Trunk Password", PWt = "Nickname", IWt = "Delete Phone Number", RWt = "Workflow validation failed", NWt = "One or more workflow steps have empty message content", DWt = "One or more phone numbers or email addresses are not verified", MWt = "Supercharge your Workflows with Cal.ai", LWt = "Lifelike AI agents that book meetings, send reminders, and follow up with your customers.", qWt = "Phone number imported and linked to agent successfully", jWt = "Phone number deleted successfully", FWt = "Are you sure you want to delete this phone number? This action cannot be undone.", VWt = "Yes, delete phone number", BWt = "The number you are trying to import must be in E.164 format (+country code followed by the number, with no spaces or special characters), e.g. +1234567890", UWt = "The termination URI to uniquely identify your elastic SIP trunk. This is used for outbound calls. For Twilio elastic SIP trunks it always ends with .pstn.twilio.com.", WWt = "The username used to authenticate the SIP trunk.", GWt = "The password used to authenticate the SIP trunk.", HWt = "Nickname of the number. This is for your reference only.", KWt = "Save and Test Call", YWt = "Call initiated successfully", ZWt = "Please enter a phone number", QWt = "Agent updated successfully", JWt = "Agent created successfully", XWt = "Event type added successfully", eGt = "Phone number unsubscribed successfully", tGt = "This prompt defines the agent's role and primary objectives", nGt = "Prompt", oGt = "Call to", rGt = "Make Test Call to Verify Configuration", iGt = "Initial Message", aGt = "The first message the agent will say when starting a call", sGt = "Having trouble importing?", cGt = "Learn", lGt = "Learn how to get your Termination URI and SIP trunk credentials", dGt = "Phone number subscription canceled successfully", uGt = "Updating", _Gt = "Round Robin", pGt = "Hi, how are you doing?", mGt = "Cycle meetings between multiple team members.", fGt = "Managed Event", gGt = "username", hGt = "Create & distribute event types in bulk to team members", vGt = "Managed", bGt = '"username" will be filled by the username of the members assigned', yGt = "Assign to", $Gt = "Enter phone number to test call", wGt = "Make Test Call", kGt = "Create new workflow cal.ai voice agent", SGt = "Create a new workflow cal.ai voice agent to automate your workflows", xGt = "Phone number (for our agent to call)", EGt = "Buy a phone number or import one you already have on twilio", TGt = "Test Agent", AGt = "Test Web Call", CGt = "Phone Numbers", zGt = "Unsubscribe", OGt = "Delete Workflow Step", PGt = "Unsubscribe Phone Number", IGt = "Buy a new number", RGt = "You can only buy US phone numbers. For other countries, you can import your own Twilio phone number.", NGt = "Buy a US Number for ${{priceInDollars}} per month", DGt = "Supported Call Destinations", MGt = "No phone number connected", LGt = "Failed to get workflow step ID", qGt = "Cal.ai Agent", jGt = "Test Cal.ai Agent", FGt = "Are you sure you want to delete this workflow step?", VGt = "Do you still want to unsubscribe the phone number from this agent?", BGt = "This action will disconnect the phone number from the agent. The agent will not be able to make calls until a new phone number is connected.", UGt = "Phone Numbers", WGt = "Connect Phone Number", GGt = "Manage your Phone Numbers", HGt = "Import Number", KGt = "This action will also:", YGt = "Import Phone Number", ZGt = "Active Subscription", QGt = "Cancel your phone number subscription", JGt = "Delete the associated phone number", XGt = "You are not authorized to create this workflow", eHt = "Import your Twilio phone number to use with Phone", tHt = "${{price}}/month", nHt = "Buy New Number", oHt = "Buying a phone number costs ${{priceInDollars}} per month. You will be charged monthly for each active phone number.", rHt = "Area Code (Optional)", iHt = "No phone numbers", aHt = "Phone number purchased successfully", sHt = "Cancel Phone Number Subscription", cHt = "Yes, Cancel Subscription", lHt = "Are you sure you want to cancel this phone number subscription? This action cannot be undone and you will lose access to this phone number.", dHt = "Add members...", uHt = "Add members", _Ht = "No assigned members", pHt = "Assigned to", mHt = "You must be logged in to {{url}}", fHt = "Start assigning members above", gHt = "Members can not edit", hHt = "Members can edit", vHt = "Locked by the team admin", bHt = "Unlocked by team admin", yHt = "URL", $Ht = "Hidden", wHt = "Readonly", kHt = "One-time link", SHt = "You're currently on the {{plan}} plan.", xHt = "Upgrade your account to the PRO plan to unlock all of the features we have to offer.", EHt = "You need to upgrade your plan to have more than one active event type.", THt = "You need to upgrade your plan to create a team.", AHt = "You can <1>upgrade here</1>.", CHt = "Event Types", zHt = "Create events to share for people to book on your calendar.", OHt = "New event type", PHt = "Create your first event type", IHt = "Event types enable you to share links that show available times on your calendar and allow people to make bookings with you.", RHt = "{{eventTypeTitle}} event type created successfully", NHt = "No call history", DHt = "No matching call history found for the particular account/search query.", MHt = "{{eventTypeTitle}} event type updated successfully", LHt = "Event type deleted successfully", qHt = "Hours", jHt = "People", FHt = "Your Email", VHt = "Change Avatar", BHt = "Upload Avatar", UHt = "Language", WHt = "Timezone", GHt = "First Day of Week", HHt = "Repeats up to {{count}} time", KHt = "Repeats up to {{count}} times", YHt = "Every {{freq}} for", ZHt = "{{count}} event remaining", QHt = "{{count}} events remaining", JHt = "Repeats every", XHt = "occurrence", eKt = "occurrences", tKt = "week", nKt = "weeks", oKt = "month", rKt = "months", iKt = "year", aKt = "years", sKt = "{{count}} more", cKt = "Max", lKt = "Single Theme", dKt = "Brand Color", uKt = "Brand Color (Light Theme)", _Kt = "Brand Color (Dark Theme)", pKt = "Event Type Color (Light Theme)", mKt = "Event Type Color (Dark Theme)", fKt = "File is not named [idOrSlug]/[user]", gKt = "Create team", hKt = "Name", vKt = "Nameless Team", bKt = "OAuth Clients", yKt = "Manage OAuth clients for your organization", $Kt = "Create OAuth Client", wKt = "Create a new OAuth client for third-party integrations", kKt = "OAuth client deleted successfully", SKt = "Create a new team to collaborate with users.", xKt = "Create a new team", EKt = "URL of your booking page", TKt = "URL of the page where your users can cancel their booking", AKt = "URL of the page where your users can reschedule their booking", CKt = "This slot is no longer available. Please return to the previous page and select another time.", zKt = "Open Invitations", OKt = "New Team", PKt = "Create your first team and invite other users to work together.", IKt = "Create a team to get started", RKt = "Teams", NKt = "Team", DKt = "Organization", MKt = "Team Billing", LKt = "Manage billing for your team", qKt = "We've changed billing for teams", jKt = "There are members in your team without a seat. Upgrade your pro plan to cover missing seats.", FKt = "As of January 2022 we charge on a per-seat basis for team members. Members of your team who had PRO for free are now on a 14 day trial. Once their trial expires these members will be hidden from your team unless you upgrade now.", VKt = "Create and manage teams to use collaborative features.", BKt = "This feature is only available in Pro plan", UKt = "In order to remove the {{appName}} branding from your booking pages, you need to upgrade to a Pro account.", WKt = "Edit your profile information, which shows on your scheduling link.", GKt = "You may need to log out and back in to see the change take effect.", HKt = "A little something about yourself.", KKt = "Profile updated successfully", YKt = "Your user profile has been updated successfully.", ZKt = "Your upgrade is here", QKt = "Improve your scheduling experience by upgrading to the new plan and enjoy the new features.", JKt = "You are all set", XKt = "You are already on the latest plan. Nothing to upgrade. Enjoy the new features and reach out to us with any questions!", eYt = "User seems logged in but cannot be found in the db", tYt = "Embed & Webhooks", nYt = "Enabled", oYt = "Disabled", rYt = "Disable", iYt = "Billing", aYt = "here", sYt = "Manage your billing information and cancel your subscription.", cYt = "Availability", lYt = "Edit availability", dYt = "Configure times when you are available for bookings.", uYt = "Copy times to", _Yt = "Copy times to …", pYt = "Change your weekly schedule", mYt = "Logo", fYt = "Error", gYt = "Please enter at least one character", hYt = "Please enter at least {{count}} characters", vYt = "Team Logo", bYt = "Add a location", yYt = "Attendees", $Yt = "Add attendees", wYt = "Show advanced settings", kYt = "Hide advanced settings", SYt = "Event Name", xYt = "Calendar event name", EYt = "The name that will appear in calendars", TYt = "{Event type title} between {Organiser} & {Scheduler}", AYt = "Additional Inputs", CYt = "Require scheduler to input additional inputs prior the booking is confirmed", zYt = "Label", OYt = "Placeholder", PYt = 'Use "Add to calendar" email as the organizer', IYt = "We'll display this email address as the organizer, and send confirmation emails here.", RYt = `If enabled, we'll display the email address from your "Add to calendar" as organizer and send confirmation emails there`, NYt = "Please note that you may need to disconnect and then reconnect your 'Add to Calendar' account to use this feature.", DYt = "Type", MYt = "Edit", LYt = "Add an Input", qYt = "Hide notes in calendar", jYt = "For privacy reasons, additional inputs and notes will be hidden in the calendar entry. They will still be sent to your email. <0>Learn more</0>", FYt = "The booking needs to be manually confirmed before it is pushed to your calendar and a confirmation is sent. <0>Learn more</0>", VYt = "Unconfirmed bookings still block calendar slots.", BYt = "Recurring Event", UYt = "People can subscribe for recurring events. <0>Learn more</0>", WYt = "Connect and Join", GYt = "It cannot be used with paid event types", HYt = "Instant Meetings are not supported with recurring events and payment apps yet", KYt = "Experimental: Instant Meeting Events are currently experimental.", YYt = "Starting", ZYt = "Disable Guests", QYt = "Disable adding additional guests while booking.", JYt = "Generate private link", XYt = "Enable Private URL", eZt = "Private link", tZt = "Your private link will regenerate after each use", nZt = "Copy private link", oZt = "Copy private link to event", rZt = "Generate a private URL to share without exposing your {{appName}} username", iZt = "Private Links", aZt = "Generate private URLs without exposing the username, with configurable expiry and usage limits. <0>Learn more</0>", sZt = "Add new link", cZt = "Private link copied", lZt = "Invitees can schedule", dZt = "Date Range", uZt = "calendar days", _Zt = "business days", pZt = "Set an address or place", mZt = "Set a link to the meeting", fZt = "Can't be toggled. It can only be unlocked for child event types", gZt = "{{appName}} will ask your invitee to enter a phone number before scheduling.", hZt = "{{appName}} will provide a Google Meet location.", vZt = "{{appName}} will provide a Zoom meeting URL.", bZt = "{{appName}} will provide a Tandem meeting URL.", yZt = "{{appName}} will provide a video meeting URL.", $Zt = "We will generate a Jitsi Meet URL for you.", wZt = "{{appName}} will provide a Huddle01 video meeting URL.", kZt = "{{appName}} will provide a MS Teams meeting URL. NOTE: MUST HAVE A WORK OR SCHOOL ACCOUNT", SZt = "Require Payment", xZt = "You need to add a name", EZt = "commission per transaction", TZt = "Your event type has been updated successfully.", AZt = "Hide event type", CZt = "Edit location", zZt = "into the future", OZt = "When booked with less than <0></0> notice", PZt = "Within a date range", IZt = "Indefinitely into the future", RZt = "Add new custom input field", NZt = "Quick Chat", DZt = "Add a new team event type", MZt = "Add a new event type", LZt = "Set up event types to offer different types of meetings.", qZt = "Length", jZt = "Minimum Notice", FZt = "Offset start times", VZt = "Offset timeslots shown to bookers by a specified number of minutes", BZt = "Offset by", UZt = "e.g. this will show time slots to your bookers at {{ adjustedTime }} instead of {{ originalTime }}", WZt = "Time-slot intervals", GZt = "Use event length (default)", HZt = "Delete event type?", KZt = "Delete managed event type?", YZt = "Anyone who you've shared this link with will no longer be able to book using it.", ZZt = "Members assigned to this event type will also have their event types deleted.", QZt = "Anyone who they've shared their link with will no longer be able to book using it.", JZt = "Yes, delete", XZt = "Delete account", eQt = "Yes, delete account", tQt = "Anyone who you've shared your account link with will no longer be able to book using it and any preferences you have saved will be lost.", nQt = "Integrations", oQt = "Apps", rQt = "Here you can find a list of your apps", iQt = "App listing", aQt = "{{category}} apps", sQt = "App Store", cQt = "Connecting people, technology and the workplace.", lQt = "Connect your video conferencing app", dQt = "Settings", uQt = "Event type has been moved successfully", _Qt = "Next Step", pQt = "Skip step", mQt = "Prev step", fQt = "Install", gQt = "Start free Trial", hQt = "Installed", vQt = "{{count}} active install", bQt = "{{count}} active installs", yQt = "Globally installed", $Qt = "App successfully installed", wQt = "App could not be installed", kQt = "Disconnect", SQt = "Embed your calendar within your webpage", xQt = "Connect your favourite apps.", EQt = "Automation", TQt = "Configure how your event types should interact with your calendars.", AQt = "Toggle the calendars you want to check for conflicts to prevent double bookings.", CQt = "Connect additional calendar", zQt = "Calendar updated successfully", OQt = "Check here", PQt = "Conferencing", IQt = "Calendar", RQt = "Payments", NQt = "Not installed", DQt = "Passwords don't match.", MQt = "This field is required.", LQt = "Status", qQt = "View user availability", jQt = "User needs to accept invite to view availability", FQt = "Set yourself as away", VQt = "Disable away status", BQt = "Error updating away status", UQt = "This user is currently away.", WQt = "The person you are trying to book has set themselves to away, and therefore is not accepting new bookings.", GQt = "Meet people with the same tokens", HQt = "Only book and allow bookings from people who share the same tokens, DAOs, or NFTs.", KQt = "Your account was created using an Identity Provider.", YQt = "Your account is managed by {{provider}}", ZQt = "To change your email, password, enable two-factor authentication and more, please visit your {{provider}} account settings.", QQt = "Your account is managed by different identity provider. Try logging in with {{provider}}.", JQt = "Error creating a new user. Please try again.", XQt = "Sign in with Google", eJt = "Sign in with SAML", tJt = "Sign in with SAML/OIDC", nJt = "Continue with Email", oJt = "Continue with Google", rJt = "Last used", iJt = "You will need to generate an access token from your old scheduling tool.", aJt = "Import from", sJt = "Access token", cJt = "Roadmap", lJt = "Featured Categories", dJt = "Feature Flags", uJt = "Here you can toggle your Cal.com instance features.", _Jt = "Feature assigned successfully", pJt = "Feature unassigned successfully", mJt = "Popular Categories", fJt = "{{count}} App", gJt = "{{count}} Apps", hJt = "Trending Apps", vJt = "Most Popular", bJt = "Installed Apps", yJt = "Free", $Jt = "No {{category}} apps", wJt = "All apps", kJt = "Add a calendar app to check for conflicts to prevent double bookings", SJt = "Try adding a conference app for video calls with your clients", xJt = "Add a payment app to ease transaction between you and your clients", EJt = "Add an analytics app for your booking pages", TJt = "Add an automation app to use", AJt = "Add any other type of app to do all sorts of things", CJt = "Add a messaging app to set up custom notifications & reminders", zJt = "Add a CRM app to keep track of who you've met with", OJt = "Set the calendars to check for conflicts to prevent double bookings.", PJt = "Configure which payment processing services to use when charging your clients.", IJt = "Configure which analytics apps to use for your booking pages", RJt = "All your installed apps from other categories.", NJt = "Configure which conferencing apps to use", DJt = "Configure which automation apps to use", MJt = "Configure which messaging apps to use for setting up custom notifications & reminders", LJt = "Configure which CRM apps to use for keeping track of who you've met with", qJt = "Analytics", jJt = "No apps installed", FJt = "Apps enable you to enhance your workflow and improve your scheduling life significantly.", VJt = "Browse App Store", BJt = "Manage your installed apps or change settings", UJt = "Browse Apps", WJt = "Features", GJt = "Permissions", HJt = "Terms and Privacy", KJt = "Published by {{author}}", YJt = "Subscribe", ZJt = "Buy", QJt = "Install App", JJt = "Categories", XJt = "Pricing", eXt = "Learn more", tXt = "Try now", nXt = "Privacy Policy", oXt = "Terms of Service", rXt = "Remove", iXt = "Add", aXt = "{{count}} installed", sXt = "Verify Wallet", cXt = "Create events on", lXt = "This is a commercial feature", dXt = "You can test this feature locally but not on production.", uXt = "To purchase a commercial license, please reach out to our sales team. If a license key is already in place, please contact support@cal.com for help.", _Xt = "Missing License", pXt = "Next Steps", mXt = "Acquire a commercial license", fXt = "The infrastructure plan is usage-based and has startup-friendly discounts.", gXt = "Create an account via Prisma Studio", hXt = "Learn how to set up your first user", vXt = "Contact Sales", bXt = "Error 404", yXt = "Set as Default", $Xt = "New schedule", wXt = "Add a new schedule", kXt = "Add a new calendar", SXt = "Set where to add new events to when you're booked.", xXt = "Delete schedule", EXt = "Deleting a schedule will remove it from all event types. This action cannot be undone.", TXt = "{{scheduleName}} schedule created successfully", AXt = "{{scheduleName}} schedule updated successfully", CXt = "Schedule deleted successfully", zXt = "Working Hours", OXt = "Create an availability schedule", PXt = "Creating availability schedules allows you to manage availability across event types. They can be applied to one or more event types.", IXt = "Requires ownership of a token belonging to the following address:", RXt = "John Doe", NXt = "Time format", DXt = "Redirect on booking ", MXt = 'You are being redirected to {{ url }} in $t(second, {"count": {{seconds}} }).', LXt = "https://example.com/redirect-to-my-success-page", qXt = "Redirect to a custom URL after a successful booking", jXt = "Duplicate", FXt = "Offer seats", VXt = "Offer seats for booking. This automatically disables guest & opt-in bookings. <0>Learn more</0>", BXt = "Seat available", UXt = "Seats available", WXt = "Seats almost full", GXt = "Seats filling fast", HXt = "Number of seats per booking", KXt = "Set meeting join window (seconds): The time frame in seconds within which host can join and start the meeting. After this period, the meeting join url will expire.", YXt = "Enter number of seats", ZXt = "You can manage your schedules on the Availability page.", QXt = "No more seats available", JXt = "API keys", XXt = "API key", een = "Test API key", ten = "Test passed!", nen = "Test failed", oen = "Provide API key", ren = "API keys allow you to make API calls for your own account.", ien = "Create a marketplace or platform instead.", aen = "Generate API keys to use for accessing your own account.", sen = "Create an API key", cen = "Name this key", len = "E.g. Development", den = "Nameless API key", uen = "This API key has no expiration date", _en = "Edit API key", pen = "API key created successfully", men = "API key updated successfully", fen = "Create", gen = "Save this API key somewhere safe.", hen = "You will not be able to view it again once you close this modal.", ven = "Copy to clipboard", ben = "Enabled after update", yen = "The private link will work after saving", $en = "Revoke this API key", wen = "Disable Rescheduling", ken = "Guests can no longer reschedule the event with calendar invite or email. <0>Learn more</0>", Sen = "Allow booking through reschedule link", xen = "When enabled, users will be able to create a new booking when trying to reschedule a cancelled booking", Een = "Disable Cancelling", Ten = "Guests can no longer cancel the event with calendar invite or email. <0>Learn more</0>", Aen = "Revoke API key", Cen = "API key copied!", zen = "The API key will expire on", Oen = "Permanently remove this API key from your account?", Pen = "Copy", Ien = "Expiration date", Ren = "Expired", Nen = "Never expires", Den = "Expires", Men = "Request to reschedule your booking", Len = "Reason for reschedule", qen = "Book a new time", jen = "Reschedule request sent", Fen = "This will cancel the scheduled meeting, notify the scheduler and ask them to pick a new time.", Ven = "Reason for reschedule request", Ben = "Request reschedule ", Uen = "Edit booking", Wen = "Reschedule booking", Gen = "Former time", Hen = "Add a GIF to your confirmation page", Ken = "Search", Yen = "Impersonate", Zen = "User Impersonation", Qen = "Allows our support team to temporarily sign in as you to help us quickly resolve any issues you report to us.", Jen = "Allows your team Owners/Admins to temporarily sign in as you.", Xen = "Free for individuals. Team plans for collaborative features.", etn = "Make organization private", ttn = "Your organization members won't be able to see other organization members when this is turned on.", ntn = "Make team private", otn = "Your team members won't be able to see other team members when this is turned on.", rtn = "You cannot see all the team members of a private team.", itn = "You cannot see teams of a private organization.", atn = "Allow multiple durations", stn = "All uses of this feature is audited.", ctn = 'Impersonating username "{{user}}".', ltn = "Click here to stop", dtn = "Updated - Your event changed the location", utn = "Added - New guests added to your event", _tn = "Location Changed: {{eventType}} with {{name}} at {{date}}", ptn = "Guests Added: {{eventType}} with {{name}} at {{date}}", mtn = "Current Location", ftn = "New Location", gtn = "Session", htn = "Control your account session", vtn = "Timeout session after", btn = "Session timeout", ytn = "Invalidate your session after a certain amount of time.", $tn = "No location defined", wtn = "Set Location", ktn = "Update Location", Stn = "Location updated", xtn = "Location update failed", Etn = "Guests added", Ttn = "Unable to add guests", Atn = "That doesn't look like an email address", Ctn = "Emails must be unique and valid", ztn = "That doesn't look like a URL", Otn = "Place this code in your HTML where you want your {{appName}} widget to appear.", Ptn = "Create or update an existing React component as shown below.", Itn = "Copy Code", Rtn = "Code copied!", Ntn = "How do you want to add {{appName}} to your site?", Dtn = "Choose one of the following ways to put {{appName}} on your site.", Mtn = "Setting up your Zapier integration", Ltn = "Setting up your Make integration", qtn = "Generate API key", jtn = "Generate an API key to use with {{appName}} at", Ftn = "Your unique API key", Vtn = "Copy this API key and save it somewhere safe. If you lose this key you have to generate a new one.", Btn = "<0>Log into your Zapier account and create a new Zap.</0><1>Select Cal.com as your Trigger app. Also choose a Trigger event.</1><2>Choose your account and then enter your Unique API Key.</2><3>Test your Trigger.</3><4>You're set!</4>", Utn = "Go to <0>Make Invite Link</0> and install the Cal.com app.", Wtn = "Log into your Make account and create a new Scenario.", Gtn = "Select Cal.com as your Trigger app. Also choose a Trigger event.", Htn = "Choose your account and then enter your Unique API Key.", Ktn = "Test your Trigger.", Ytn = "You're set!", Ztn = "Please first install the Zapier App in the app store.", Qtn = "Please first install the Make App in the app store.", Jtn = "App Installation", Xtn = "App not installed", enn = "Sorry, this app isn't installed on your account. Please visit our app store to explore and discover this and other great apps.", tnn = "Connect to Apple Server", nnn = "Calendar URL", onn = "Generate an app specific password to use with {{appName}} at", rnn = "Unable to add this Apple Calendar account. Please ensure you're using an app-specific password rather than your account password.", inn = "Your credentials will be stored and encrypted.", ann = "It will be stored and encrypted.", snn = "Go to App Store", cnn = "Try reconnecting your calendar with all necessary permissions", lnn = "Set a phone number for the meeting", dnn = "There are no busy slots", unn = "Display on booking page", _nn = "Location will be visible before the booking is confirmed", pnn = "Add GIF", mnn = "Search Giphy", fnn = "Add link from Giphy", gnn = "Adding a GIF to confirmation page", hnn = "Find GIF to spice up your confirmation page", vnn = "Share feedback", bnn = "Resources", ynn = "Support Documentation", $nn = "Developer Documentation", wnn = "Get in touch", knn = "Contact Support", Snn = "Premium Support", xnn = "Community Support", Enn = "Feedback", Tnn = "Thank you for your feedback!", Ann = "Error sending feedback", Cnn = "Share your comments here:", znn = "Booking details", Onn = "or", Pnn = "Nevermind", Inn = "Go to: ", Rnn = "Zapier Invite Link", Nnn = "A Meeting URL will be created once the event is confirmed.", Dnn = "Dynamically display the name of your attendee for you, or your name if it's viewed by your attendee", Mnn = "Event's location", Lnn = "Reason for rescheduling (optional)", qnn = "Let others know why you need to reschedule", jnn = "This event is canceled", Fnn = "We sent an email to everyone to let them know.", Vnn = "This input will be shown when booking this event", Bnn = "Meeting url is in the confirmation email", Unn = "URL needs to start with http:// or https://", Wnn = "Phone number will be provided", Gnn = "before event starts", Hnn = "when event is canceled", Knn = "After hosts didn't join cal video", Ynn = "After guests didn't join cal video", Znn = "Join the video call", Qnn = "Sign in to Cal.com", Jnn = "Log in to Cal.com", Xnn = "Track your meetings, get notifications, and manage your schedule more effectively.", eon = "Track your meetings and manage your schedule more effectively", ton = "Failed to join the call. Please try again.", non = "Choose how you'd like to join this call", oon = "Choose how you'd like to appear on the call", ron = "when new event is booked", ion = "send email to host", aon = "send email to attendees", son = "Send email to submitted email address", con = "Send SMS to submitted phone number", lon = "Send SMS to attendee", don = "send SMS to a specific number", uon = "Easily send meeting reminders via SMS to your attendees", _on = "send WhatsApp message to a specific number", pon = "send WhatsApp message to attendee", mon = "Workflows", fon = "New Workflow", gon = "How would you like to start?", hon = "Add a new workflow", von = "when event is rescheduled", bon = "Trigger", yon = "Triggers", $on = "Action", won = "Create workflows to automate notifications and reminders", kon = "Workflow name", Son = "Custom workflow", xon = "{{workflowName}} created successfully", Eon = "Are you sure you want to delete this workflow?", Ton = "Delete Workflow", Aon = "Yes, delete workflow", Con = "Workflow deleted successfully", zon = "How long before event starts?", Oon = "days", Pon = "hours", Ion = "mins", Ron = "m", Non = "h", Don = "Create your first workflow", Mon = "Workflows enable you to automate sending reminders and notifications.", Lon = "Active on", qon = "{{workflowName}} workflow updated successfully", jon = "This is a standard username and updating will take you to billing to downgrade.", Fon = "This is a premium username, get yours for {{price}}", Von = "Current", Bon = "premium", Uon = "standard", Won = "Confirm username change", Gon = "As you are changing from a standard to a premium username, you will be taken to the checkout to upgrade.", Hon = "As you are changing from a premium to a standard username, you will be taken to the checkout to downgrade.", Kon = "Go to billing", Yon = "Require payment for bookings (0.5% + €0.10 commission per transaction)", Zon = "Your trial has expired", Qon = "Remove App", Jon = "Yes, remove app", Xon = "Are you sure you want to remove this app?", ern = "App removed successfully", trn = "Error removing app", nrn = "Web conference", orn = "Web call", rrn = "Start web call", irn = "End call", arn = "Test your agent with a web call without requiring a phone number", srn = "Phone call", crn = "Connecting to agent...", lrn = "Call active", drn = "Call ended", urn = "Call error", _rn = "Ready to start call", prn = "Failed to start web call. Please try again.", mrn = "Call encountered an error. Please try again.", frn = "Failed to initialize web call. Please ensure microphone permissions are granted.", grn = "Start a call to see the conversation", hrn = "Waiting for conversation...", vrn = "AI Agent", brn = "Live", yrn = "Connecting...", $rn = "Requires confirmation", wrn = "Requires confirmation if booked with < {{time}} $t({{unit}}_timeUnit) notice", krn = "May require confirmation", Srn = "{{count}} event type", xrn = "{{count}} event types", Ern = "{{count}} routing form", Trn = "{{count}} routing forms", Arn = "{{count}} team", Crn = "{{count}} teams", zrn = "Add action", Orn = "Set Whereby link", Prn = "Please enter a valid Whereby Link", Irn = "Set Around.Co link", Rrn = "Please enter a valid Around Link", Nrn = "Set Riverside link", Drn = "Please enter a valid Riverside Link", Mrn = "Please enter a valid Ping.gg Link", Lrn = "Connect Exchange 2013 Server", qrn = "Connect Exchange 2016 Server", jrn = "Custom template", Frn = "Email body", Vrn = "Text message", Brn = "Have a specific issue?", Urn = "browse our docs", Wrn = "Choose a template", Grn = "Custom", Hrn = "Reminder", Krn = "Rescheduled", Yrn = "Rescheduled by", Zrn = "Original booking", Qrn = "Completed", Jrn = "Rating", Xrn = "Reminder: {{eventType}} with {{name}} at {{date}}", ein = "Won't trigger for already existing bookings as user will be asked for phone number when booking the event.", tin = "{{count}} minute", nin = "{{count}}m", oin = "{{count}} minutes", rin = "{{count}} hour", iin = "{{count}}h", ain = "{{count}} hours", sin = "Invalid input", cin = "We could not add the {{location}} meeting link to your scheduled event. Contact your invitees or update your calendar event to add the details. You can either <0> change your location on the event type </0> or try <1>removing and adding the app again.</1>", lin = "We could not update your <1>{{calendar}}</1>. <2> Please check your calendar settings or remove and add your calendar again </2>", din = "Attendee's name", uin = "The full name of the person booking", _in = "Broken integration", pin = "There was a problem adding a video link", min = "There was a problem updating your calendar", fin = "Active on {{count}} event type", gin = "Active on {{count}} event types", hin = "Active on {{count}} team", vin = "Active on {{count}} teams", bin = "Active on all event types", yin = "Active on all teams", $in = "No active event types", win = "No active teams", kin = "New Attendee {{name}} on {{eventType}} at {{date}}", Sin = "Someone has added themselves to an event", xin = "Variable", Ein = "Event name", Tin = "Attendee", Ain = "Event date", Cin = "Event time", zin = "Organizer name", Oin = "In order to use this feature, you need to upgrade to a Pro account.", Pin = "Invalid phone number", Iin = "Invalid URL for {{label}}. Sample URL: {{sampleUrl}}", Rin = "Navigate", Nin = "Open", Din = "Close", Min = "Upgrade", Lin = "Buy US number for {{priceInDollars}}$/month", qin = "Upgrade to access recordings", jin = "Recordings are only available as part of our teams plan. Upgrade to start recording your calls", Fin = "Upgrade to Enterprise to generate an AI Agent phone number that can call guests to schedule calls", Vin = "Recordings are part of the teams plan", Bin = "This is a Team feature. Upgrade to Team to see your team's availability.", Uin = "This is a Team feature. Upgrade to Team to automate your event notifications and reminders with Workflows.", Win = "Show on Profile", Gin = "Embed", Hin = "New username", Kin = "Current username", Yin = "Example 1", Zin = "Example 2", Qin = "Booking Question Identifier", Jin = "Company size", Xin = "What do you need help with?", ean = "Variable format", tan = "Webhook subscriber url is already defined", nan = "Ignore all special characters of the additional input label (use only letters and numbers), use uppercase for all letters and replace whitespaces with underscores.", oan = "How do I use booking questions as variables?", ran = "Download desktop app", ian = "Set Ping link", aan = "Rate limit exceeded", san = "When something happens", can = "An action is performed", lan = "Test action", dan = "Notification sent", uan = "No input", _an = "Test workflow action", pan = "Send SMS", man = "Are you sure you want to send a SMS to {{number}}?", fan = "No default calendar connected", gan = "You can connect your calendar from <1>here</1>.", han = "Default calendar", van = "Hide from profile", ban = "Basics", yan = "No availability found in schedule", $an = "Limits", wan = "How often you can be booked", kan = "Calendar settings & more...", San = "Advanced", xan = "Set up payments for event", Ean = "Event Setup: Multiple durations requires at least 1 option.", Tan = "Event Setup: Please select a valid default duration.", Aan = "Booking limits must be in ascending order. [day, week, month, year]", Can = "Duration limits must be in ascending order. [day, week, month, year]", zan = "The calendar to add bookings to", Oan = "Custom event name", Pan = "Create customised event names to display on calendar event", Ian = "Incorrect two factor authentication code", Ran = "Which event type will this apply to?", Nan = "Which routing form will this apply to?", Dan = "Apply to all, including future event types", Man = "Apply to all, including future routing forms", Lan = "Apply to all team and user event types", qan = "Which team will this apply to?", jan = "Workflows enable simple automation to send notifications & reminders enabling you to build processes around your events.", Fan = "This is an internal setting and will not affect how times are displayed on public booking pages for you or anyone booking you.", Van = "Create a workflow", Ban = "Do this", Uan = "Turn off", Wan = "Turn on", Gan = "Canceled bookings cannot be rescheduled", Han = "Settings updated successfully", Kan = "Error updating settings", Yan = "My personal {{appName}} URL", Zan = "A few sentences about yourself. this will appear on your scheduling link.", Qan = "Finish setup and get started", Jan = "This user has not added a bio yet.", Xan = "Bio", esn = "Delete Account", tsn = "Are you sure you want to delete your {{appName}} account?", nsn = "Delete my account", osn = "Start of week", rsn = "Recordings", isn = "Recording", asn = "Happy scheduling", ssn = "Select which calendars you want to check for conflicts to prevent double bookings.", csn = "Check for conflicts", lsn = "View recordings", dsn = "Check for recordings", usn = "Adding events to", _sn = "Follow system preferences", psn = "Custom brand colors", msn = "Customize your own brand colour into your booking page.", fsn = "Pro", gsn = "Removes any {{appName}} related brandings, i.e. 'Powered by {{appName}}.'", hsn = "Instant Meeting with {{name}}", vsn = "Profile Picture", bsn = "Upload", ysn = "Add profile photo", $sn = "Token Address", wsn = "Blockchain", ksn = "Old password", Ssn = "Your new super secure password", xsn = "Error updating password", Esn = "Two factor authentication", Tsn = "Set up a repeating schedule", Asn = "today", Csn = "Appearance", zsn = "My account", Osn = "General", Psn = "Calendars", Isn = "Invoices", Rsn = "Embeds", Nsn = "Impersonation", Dsn = "Settings to manage user impersonation", Msn = "Recent Impersonations", Lsn = "Quick Impersonate", qsn = "No recent impersonations", jsn = "Users", Fsn = "User", Vsn = "Manage settings for your {{appName}} profile", Bsn = "Here you can find a list of all users", Usn = "User listing", Wsn = "Manage settings for your language and timezone", Gsn = "Configure how your event types interact with your calendars", Hsn = "Manage settings for your booking appearance", Ksn = "Add your favourite video conferencing apps for your meetings", Ysn = "Add Conferencing App", Zsn = "Manage settings for your account passwords", Qsn = "Set up your Two-factor authentication", Jsn = "We just need some basic info to get your profile setup.", Xsn = "Skip", ecn = "Do this later", tcn = "Define ranges of time when you are available.", ncn = "Customize it later in the availability page.", ocn = "Connect a calendar first", rcn = "Complete your profile", icn = "Complete your profile", acn = "Add details to personalize your scheduling experience", scn = "Let's set up your personal account", ccn = "Profile photo", lcn = "Connect your calendar to prevent double bookings and conflicts", dcn = "Connect your video app", ucn = "Connect your preferred video conferencing app", _cn = "Welcome to Cal.com", pcn = "Name is required", mcn = "Connected", fcn = "You can add more calendars from the app store", gcn = "Connect conference apps", hcn = "Connect calendar apps", vcn = "Connect payment apps", bcn = "Connect automation apps", ycn = "Connect analytics apps", $cn = "Connect other apps", wcn = "Connect messaging apps", kcn = "Connect CRM apps", Scn = "Step {{currentStep}} of {{maxSteps}}", xcn = "Add variable", Ecn = "Custom phone number", Tcn = "Message template", Acn = "Email subject", Ccn = "Add dynamic text variables", zcn = "The event type name", Ocn = "The event date", Pcn = "The event duration", Icn = "The event start time", Rcn = "EventType not Found", Ncn = "Number to call", Dcn = "The phone number of the user you are calling", Mcn = "Location", Lcn = "The location of the event", qcn = "Additional notes", jcn = "The additional notes of booking", Fcn = "The person booking's name", Vcn = "Organizer's name", Bcn = "To", Ucn = "{{workflowName}} workflow turned {{offOn}} successfully", Wcn = "Download responses", Gcn = "Download all responses to your form in CSV format.", Hcn = "View Responses", Kcn = "Download", Ycn = "Downloading", Zcn = "Download Recording", Qcn = "Transcriptions are enabled now", Jcn = "Transcriptions are stopped now", Xcn = "Download Transcript", eln = "Transcript", tln = "A recording from your recent call on {{appName}} is ready for download", nln = "Transcript from your recent call on {{appName}} is ready to download. Links are valid only for 1 Hour", oln = "You can also download transcript from attachments", rln = "Note: The download link is valid only for 12 hours. You can generate new download link by following instructions <1>here</1>.", iln = "Note: The download link is only valid for 12 hours. You can generate new download link by following the instructions", aln = "Create your first form", sln = "With Routing Forms you can ask qualifying questions and route to the correct person or event type.", cln = "Create your first Webhook", lln = "With Webhooks you can receive meeting data in real-time when something happens in {{appName}}.", dln = "For a maximum of", uln = "event", _ln = "events", pln = "Manage settings for your team profile", mln = "Manage settings for your organization profile", fln = "Users that are in the group", gln = "Manage the admins and members in your organization", hln = "Team URL", vln = "Team members", bln = "More", yln = "Cal.ai Workflows", $ln = "and {{count}} more", wln = "We view the mobile application as an extension of the web application. If you are performing any complicated actions, please refer back to the web application.", kln = "Send SMS reminder 24 hours before event starts to attendee", Sln = "Send custom SMS when event is rescheduled to attendee", xln = "Send custom email when new event is booked to host", Eln = "Send email reminder 1 hour before events starts to attendee", Tln = "Send custom email when event is rescheduled to host", Aln = "Send custom SMS when new event is booked to host", Cln = "Send SMS reminder", zln = "24 hours before event starts", Oln = "Follow up with no shows", Pln = "30m after event ends", Iln = "Remind attendees to bring ID", Rln = "1 day before event starts", Nln = "Email Reminder", Dln = "1 hour before event starts", Mln = "Custom SMS Reminder", Lln = "When event is scheduled", qln = "Custom Email Reminder", jln = "Event is rescheduled to host", Fln = "Include booking counts from managed event types", Vln = "Welcome to {{appName}}!", Bln = "You'll be able to edit this later.", Uln = "I'll connect my calendar later", Wln = "There was a problem saving your data. Please try again or reach out to customer support.", Gln = "Purchase missing seats", Hln = "Slot length", Kln = "Booking Appearance", Yln = "Manage settings for your team's booking appearance", Zln = "Manage settings for your organization's booking appearance", Qln = "Only the owner of this team can make changes to the team's booking ", Jln = "Removes any {{appName}} related brandings, i.e. 'Powered by {{appName}}'", Xln = "{{teamName}} has invited you to join their team as a {{role}}", edn = "Token is either invalid or expired.", tdn = "View Booking", ndn = "Connect to Microsoft Exchange", odn = "Authentication method", rdn = "Basic authentication", idn = "NTLM authentication", adn = "GZip compression", sdn = "Exchange Version", cdn = "2007 SP1", ldn = "2010", ddn = "2010 SP1", udn = "2010 SP2", _dn = "2013", pdn = "2013 SP1", mdn = "2015", fdn = "2016", gdn = "Routing", hdn = "Create forms to direct attendees to the correct destinations", vdn = "Send Email to Owner", bdn = "Sends an email to the owner when the form is submitted", ydn = "Send Email to", $dn = "Add new form", wdn = "Add new form to your team", kdn = "Create your first route", Sdn = "Route to the right person based on the answers to your form", xdn = "Form", Edn = "Create your form to route a booker", Tdn = "Copy link to form", Adn = "Booking page theme", Cdn = "This only applies to your public booking pages", zdn = "Dashboard theme", Odn = "This only applies to your logged in dashboard", Pdn = "System default", Idn = "Add a team", Rdn = "Receive meeting data in real-time when something happens in {{appName}}", Ndn = "Triggers when", Ddn = "Please ping test before creating.", Mdn = "Enable Webhook", Ldn = "Add Webhook", qdn = "Webhook saved", jdn = "Generate API keys for accessing your own account", Fdn = "New API key", Vdn = "active", Bdn = "API key name updated", Udn = "Error updating API key name", Wdn = "HTML iframe embed", Gdn = "Embed all your event types on your website", Hdn = "Create your first API key", Kdn = "API keys allow other apps to communicate with {{appName}}", Ydn = "Back to sign in", Zdn = "Reset link sent", Qdn = "An email is on it's way to {{email}} with instructions to reset your password.", Jdn = "If you don't receive an email soon, check that the email address you entered is correct, check your spam folder or reach out to support if the issue persists.", Xdn = "Password updated!", eun = "Pending payment", tun = "Pending Invites", nun = "Pending Organization Invites", oun = "Not on {{appName}}", run = "No calendar installed", iun = "You have not yet connected any of your calendars", aun = "Add a calendar", sun = "You may need to log out and back in to see any change take effect.", cun = "Please confirm your password before changing your email address", lun = "seats", dun = "Every app published on the {{appName}} App Store is open source and thoroughly tested via peer reviews. Nevertheless, {{companyName}} does not endorse or certify these apps unless they are published by {{appName}}. If you encounter inappropriate content or behaviour please report it.", uun = "Report app", _un = "Limit booking frequency", pun = "Limit how many times this event can be booked. <0>Learn more</0>", mun = "Only show the first slot of each day as available", fun = "This will limit your availability for this event type to one slot per day, scheduled at the earliest available time.", gun = "Limit total booking duration", hun = "Limit total amount of time that this event can be booked", vun = "Limit number of upcoming bookings per booker", bun = "Limit the number of active bookings a booker can make for this event type. <0>Learn more</0>", yun = "Recurring events don't support booker booking limit", $un = "Add Limit", wun = "Team name required", kun = "Share attendee information between guests", Sun = "Show the number of available seats", xun = "How to use booking questions as variables?", Eun = "Format", Tun = "Questions", Aun = "All the info your booker should provide before booking with you.", Cun = "Use uppercase for all letters", zun = "Replace whitespaces with underscores", Oun = "Platform members", Pun = "Manage the admins and members in your platform team", Iun = "Platform billing", Run = "Manage billing", Nun = "Manage all things billing", Dun = "You're currently on the FREE plan", Mun = "We work better in teams. Extend your workflows with round-robin and collective events and make advanced routing forms", Lun = "Try now", qun = "Billing portal", jun = "Contact support", Fun = "Ignore special characters in your booking question identifier. Use only letters and numbers", Vun = "Retry", Bun = "There was a problem fetching your calendars. Please <1>try again</1> or reach out to customer support.", Uun = "Calendar connection failed", Wun = "Booking confirmation succeeded", Gun = "Booking rejection succeeded", Hun = "This booking is tentative", Kun = "Oops, I want to accept", Yun = "We won't show this again", Zun = "We couldn't update the timezone", Qun = "Updated timezone to {{formattedCurrentTz}}", Jun = "Update timezone", Xun = "Update Timezone?", e_n = "It seems like your local timezone has changed to {{formattedCurrentTz}}.  It's very important to have the correct timezone to prevent bookings at undesired times. Do you want to update it?", t_n = "Don't update", n_n = "Require additional notes", o_n = "Require additional notes to be filled out when booking", r_n = "send email to a specific email address", i_n = "after event ends", a_n = "when booking is rejected", s_n = "when booking is requested", c_n = "when booking payment is initiated", l_n = "when booking payment is successful", d_n = "when booking no-show is updated", u_n = "How long after event ends?", __n = "How long after hosts don't show up on cal video meeting?", p_n = "How long after guests don't show up on cal video meeting?", m_n = "How long after the users don't show up on cal video meeting?", f_n = "No Available slots", g_n = "Time available", h_n = "Can't find the right conferencing app? Visit our <0>App Store</0>.", v_n = "Install new calendar app", b_n = "Make phone number required for booking event", y_n = "{{eventTypeTitle}} Availability", $_n = "Error editing availability", w_n = "You don't have permission to access this resource.", k_n = "Please paste the SAML metadata from your Identity Provider here", S_n = "Please enter an email so we can find your SAML Identity Provider", x_n = "Service Provider Details", E_n = "Your Identity Provider (IdP) will ask you for the following details to complete the SAML application configuration.", T_n = "ACS URL", A_n = "SP Entity ID", C_n = "ACS URL copied!", z_n = "SP Entity ID copied!", O_n = "Add Calendar", P_n = "Limit future bookings", I_n = "Limit how far in the future this event can be booked. <0>Learn more</0>", R_n = "No event types setup", N_n = "{{name}} has not setup any event types for you to book.", D_n = "Billing Frequency", M_n = "Monthly", L_n = "Yearly", q_n = "Checkout", j_n = "Your team has been disbanded successfully", F_n = "Your organization has been disbanded successfully", V_n = "Error creating team", B_n = "You", U_n = "Or continue with", W_n = "Resend email", G_n = "Member has already been invited", H_n = "Username already in use", K_n = "Enter an email or username", Y_n = "Enter an email", Z_n = "Enter emails", Q_n = "You are limited to inviting a maximum of {{nbUsers}} users at once.", J_n = "This name is already taken", X_n = "Must enter a team name", epn = "Must enter a team URL", tpn = "This URL is already taken", npn = "There was a problem with registering the subdomain, please try again or contact an administrator", opn = "Publish team", rpn = "Phone number (Text notifications)", ipn = "Phone number (SMS notifications)", apn = "Attendee email", spn = "The person booking's email", cpn = "Booking UID", lpn = "Type a command or search...", dpn = "It looks like permissions expired or were revoked for {{appName}}.", upn = "Reinstall app", _pn = "Reschedule reason", ppn = "Choose a common schedule", mpn = "Enable this if you want to use a common schedule between hosts. When disabled, each host will be booked based on their default schedule or their chosen schedule.", fpn = "Reason", gpn = "Sender ID", hpn = "Only letters, numbers and spaces allowed (max. 11 characters)", vpn = "Test Routing Form", bpn = "Test Preview", ypn = "Route to", $pn = "Test your routing form without submitting any data", wpn = "Test Routing", kpn = "An admin has disabled a payment app", Spn = "Edit event type", xpn = "This Organization is private, and only the organization's admin or owner can view its members.", Epn = "Only the organization's admin or owner can manage SSO settings", Tpn = "Only the organization's admin or owner can manage directory sync settings", Apn = "Only the organization's admin or owner can manage OAuth clients", Cpn = "Collective Scheduling", zpn = "Make it easy to book your team when everyone is available.", Opn = "Find the best person available and cycle through your team.", Ppn = "Fixed round robin", Ipn = "Add one fixed attendee and round robin through a number of attendees.", Rpn = "{{appName}} is better with teams", Npn = "The {{companyName}} team", Dpn = "Add your team members to your event types. Use collective scheduling to include everyone or find the most suitable person with round robin scheduling.", Mpn = "Booking Limit for this event type has been reached", Lpn = "Duration Limit for this event type has been reached", qpn = "An admin has disabled {{appName}}", jpn = "This will disable all emails to {{recipient}}. This includes booking confirmations, requests, reschedules and reschedule requests, cancellation emails, and any other emails related to booking updates.<br /><br />It is your responsibility to ensure that your {{recipient}} are aware of any bookings and changes to their bookings.", Fpn = "An admin has disabled {{appName}} which affects your event type {{eventType}}", Vpn = "An admin has replaced one of your event types", Bpn = "A team administrator has replaced your event /{{slug}}", Upn = "An administrator on the <strong>{{teamName}}</strong> team has replaced your event type <strong>/{{slug}}</strong> with a managed event type that they control.", Wpn = "Your link will continue to work but some settings for it may have changed. You can review it in event types.", Gpn = "If you have any questions about the event type, please reach out to your administrator.<br /><br />Happy scheduling, <br />The Cal.com team", Hpn = "The admin has disabled {{appName}} which affects your event type {{title}}. Attendees are still able to book this type of event but will not be prompted to pay. You may hide the event type to prevent this until your admin renables your payment method.", Kpn = "Attendees are still able to book this type of event but will not be prompted to pay. You may hide the event type to prevent this until your admin reenables your payment method.", Ypn = "The admin has disabled {{appName}} which affects your event type {{title}}.", Zpn = "The admin has disabled {{appName}} which may affect your event types. If you have event types with {{appName}} as the location then it will default to Cal Video.", Qpn = "{{appName}} has been disabled", Jpn = "Go to installed apps", Xpn = "If you have another calendar installed new bookings will be added to it. If not then connect a new calendar so you do not miss any new bookings.", emn = "Enable Apps", tmn = "Enable apps that users can integrate with {{appName}}", nmn = "Purchase a License", omn = "Already have an account?", rmn = "I already have a key:", imn = "Please copy your existing CALCOM_LICENSE_KEY environment variable here.", amn = "Create License Key", smn = "{{appName}} is enabled", cmn = "{{appName}} is disabled", lmn = "Keys have been saved", dmn = "Disable App", umn = "Disabling this app could cause problems with how your users interact with Cal", _mn = "Edit Keys", pmn = "Enable apps for your instance of Cal", mmn = "A list of all the users in your account including their name, title, email and role.", fmn = "Here you can add a new user.", gmn = "Here you can edit a current user.", hmn = "Here you can edit an organization.", vmn = "Add new OAuth Clients", bmn = "Lock or unlock SMS sending for users", ymn = "There are no available apps", $mn = "Please ensure there are apps in your deployment under 'packages/app-store'", wmn = "There are no apps enabled in this instance of Cal", kmn = "No app has been configured yet", Smn = "You can enable apps in the settings", xmn = "Please contact your admin", Emn = "Apps settings", Tmn = "Please fill in this field", Amn = "Options", Cmn = "Enter Option {{index}}", zmn = "Add an option", Omn = "This location already exists. Please select a new location", Pmn = "Radio", Imn = "In order to use Google Meet, you must set your destination calendar to a Google Calendar", Rmn = "Individual", Nmn = "All Bookings", Dmn = "All Users", Mmn = "All Event Types", Lmn = "Your Bookings", qmn = "Meeting url", jmn = "The event meeting conference url", Fmn = "Date overrides", Vmn = "Delete date overrides on {{date}}", Bmn = "Add dates when your availability changes from your daily hours.", Umn = "Date overrides are archived automatically after the date has passed", Wmn = "Which hours are you free?", Gmn = "Which hours are you busy?", Hmn = "Select the dates to override", Kmn = "Unavailable all day", Ymn = "Mark unavailable (All day)", Zmn = "Mark unavailable on selected dates", Qmn = "Update Override", Jmn = "Date override added successfully", Xmn = "Save Override", efn = "{{slug}}-copy", tfn = "Set as default", nfn = "Hide event type details", ofn = "Show navigation", rfn = "Hide navigation", ifn = "Verification code sent", afn = "Verified successfully", sfn = "Wrong verification code", cfn = "Not yet verified", lfn = "No availability in {{month}}", dfn = "Scheduling is only available up to {{days}} in advance. Please check again soon.", ufn = "Scheduling ended on {{date}}. Please check again soon.", _fn = "View previous month", pfn = "View next month", mfn = "Send code", ffn = "Number verified", gfn = "Create your first webhook for this team event type", hfn = "Create a webhook for this team event type", vfn = "Disable Success Page (only works if you have a redirect URL)", bfn = "You are admin but you do not have a password length of at least 15 characters or no 2FA yet", yfn = "Change your password to gain admin access", $fn = "Username is already taken", wfn = "Assignment", kfn = "Fixed Hosts", Sfn = "Add fixed hosts", xfn = "Round-Robin Hosts", Efn = "Number of hosts required to attend", Tfn = "Hosts", Afn = "You need to create a team to enable this feature. Click here to create a team.", Cfn = "You need to upgrade to our enterprise plan to enable this feature.", zfn = "New Attendee", Ofn = "Awaiting Approval", Pfn = "This app requires a Google Calendar connection", Ifn = 'The "Add to calendar" for this event type needs to be a Google Calendar for Meet to work. Connect it <0>here</0>.', Rfn = "You have connected a Google Calendar account.", Nfn = "Using Google Meet requires a connected Google Calendar", Dfn = "Continue to install Google Calendar", Mfn = "Install Google Meet", Lfn = "Install Google Calendar", qfn = "Sender name", jfn = "Attendee already invited", Ffn = "No recordings found", Vfn = "New workflow for...", Bfn = "Reporting", Ufn = "See all incoming form data and download it as a CSV", Wfn = "Teams plan required", Gfn = "Routing forms are a great way to route your incoming leads to the right person. Upgrade to a Teams plan to access this feature.", Hfn = "Choose a license", Kfn = "Cal.com comes with an accessible and free AGPLv3 license which has limitations. We are onboarding Enterprise customers for the commercial license which you can inquire about by contacting sales below.", Yfn = "License", Zfn = "AGPLv3 License", Qfn = "No need to keep your code open source", Jfn = "Repackage, rebrand and resell easily", Xfn = "A vast suite of enterprise features", egn = "$0.00/month", tgn = "Forever Open & Free", ngn = "Required to keep your code open source", ogn = "Cannot repackage, rebrand and resell easily", rgn = "No enterprise features", ign = "Enterprise License", agn = "Everything for a commercial use case with private hosting, repackaging, rebranding and reselling and access exclusive enterprise components.", sgn = "Setup", cgn = "Setup Cal.com instance", lgn = "Configure", dgn = "Single sign-on", ugn = "Configure SAML/OIDC SSO and allow team members to login using an Identity Provider", _gn = "Configure SAML/OIDC SSO and allow organization members to login using an Identity Provider", pgn = "SSO with OIDC", mgn = "Configure OIDC SSO with Identity Provider of your choice.", fgn = "OIDC Configuration", ggn = "Configure OIDC connection to your identity provider. You can find the required information in your identity provider.", hgn = "Callback URL copied", vgn = "SSO with SAML", bgn = "Configure SAML SSO with Identity Provider of your choice.", ygn = "SAML Configuration", $gn = "Configure SAML connection to your identity provider. You can find the required information in your identity provider.", wgn = "ACS URL copied", kgn = "Entity ID copied", Sgn = "{{connectionType}} configuration created successfully", xgn = "{{connectionType}} configuration deleted successfully", Egn = "Delete {{connectionType}} configuration", Tgn = "Yes, delete {{connectionType}} configuration", Agn = "Are you sure you want to delete the {{connectionType}} configuration? Your team members who use {{connectionType}} login will no longer be able to access Cal.com.", Cgn = "Organizer timezone", zgn = "View Invitation", Ogn = "Accept Invite", Pgn = "Join Now", Ign = "Successfully joined", Rgn = "You've been invited to join a team of {{parentTeamName}} organization", Ngn = "You've been invited to join a {{appName}} organization", Dgn = "{{invitedBy}} has invited you to join their team on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.", Mgn = "{{invitedBy}} has invited you to join the team {{teamName}} in their organization {{parentTeamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.", Lgn = "{{invitedBy}} has invited you to join their organization {{teamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your organization to schedule meetings without the email tennis.", qgn = "We'll walk you through a few short steps and you'll be enjoying stress free scheduling with your {{entity}} in no time.", jgn = "Choose your username", Fgn = "Connect your calendar account", Vgn = "Set your Availability", Bgn = "Join {{teamName}}", Ugn = "Happy Scheduling from the {{appName}} team", Wgn = "You are about to impersonate a user, which means you can make changes on their behalf. Please be careful.", Ggn = "Available variables", Hgn = "{Scheduler}", Kgn = "No workflows", Ygn = "Change filter to see your personal and team workflows.", Zgn = "Change filter to see the results.", Qgn = "No results for the filter", Jgn = "Recommended next steps", Xgn = "Create a managed event type", ehn = "Meetings are better with the right team members there. Invite them now.", thn = "Create a one-one one template for an event type and distribute it to multiple members.", nhn = "Collective or round-robin", ohn = "Book your team members together with collective events or cycle through to get the right person with round-robin.", rhn = "No longer attending {{title}} at {{date}}", ihn = "You are no longer attending this event", ahn = "An attendee is no longer attending {{title}} at {{date}}", shn = "An attendee is no longer attending your event", chn = "{{name}} has canceled. This means a seat has opened up for this time slot", lhn = "Create event on", dhn = "Create routing form on", uhn = "Set a default app link", _hn = "Setting a default app link allows all newly created event types to use the app link you set.", phn = "Organizer's default app", mhn = "{{organizer}} has no default conferencing app", fhn = "Down for maintenance", ghn = "The {{appName}} team are performing scheduled maintenance. If you have any questions, please contact support.", hhn = "{{numberOfSeats}} seats", vhn = "Booking questions", bhn = "Customize the questions asked on the booking page. <0>Learn more</0>", yhn = "Add a question", $hn = "Identifier", whn = "Email is duplicate", khn = "Enter a redirect URL to which the attendee will be sent once they leave the meeting.", Shn = "Paying for this event is no longer possible", xhn = "A refund for this booking payment is on its way.", Ehn = "This booking payment has been refunded.", Thn = "As per the event's refund policy, the booking payment is non-refundable.", Ahn = "The event's refund window has expired. Hence, booking payment is non-refundable.", Chn = "Booking confirmation failed", zhn = "Not enough seats", Ohn = "A field with this name already exists", Phn = "Guests field must be of type 'Multiple emails'", Ihn = "Show on booking page", Rhn = "You can visit the canceled booking page", Nhn = "Get started with Zapier templates", Dhn = "Standard Templates", Mhn = "Cal.ai Templates", Lhn = "{{team}} is unpublished", qhn = "This organization link is currently not available. Please contact the organization owner or ask them to publish it.", jhn = "This team link is currently not available. Please contact the team owner or ask them to publish it.", Fhn = "Team member", Vhn = "A Routing Form", Bhn = "Form Description", Uhn = "Keep me connected with the form", Whn = "Any changes made to the router or fields of the form being duplicated will be reflected in the duplicate. However, deleting a field will not remove it from the duplicate.", Ghn = "Form deleted", Hhn = "Are you sure you want to delete this form?", Khn = "Yes, delete Form", Yhn = "Anyone who you've shared the link with will no longer be able to access it.", Zhn = "All associated responses will be deleted.", Qhn = "Redirect URL copied! You can go and set the URL in your own form.", Jhn = "Modifications in fields and routes of following forms will be reflected in this form.", Xhn = "Connected Forms", evn = "Following forms would be affected when you modify fields or routes here.", tvn = "Wait for some time for responses to be collected. You can go and submit the form yourself as well.", nvn = "This is what your users would see", ovn = "Identifies field by this name.", rvn = "Add 1 option per line", ivn = "Select a router", avn = "Add a new Route", svn = "Make informed decisions with Insights", cvn = "Our Insights dashboard surfaces all activity across your team and shows you trends that enable better team scheduling and decision making.", lvn = "View bookings across all members", dvn = "See who's receiving the most bookings and ensure the best distribution across your team", uvn = "Identify booking trends", _vn = "See what times of the week and what times during the day are popular for your bookers", pvn = "Spot popular event types", mvn = "See which of your event types are receiving the most clicks and bookings", fvn = "No responses yet", gvn = "No routes defined", hvn = "This will be the placeholder", vvn = "An error occurred when booking the event, please refresh the page and try again", bvn = "No timeslot selected", yvn = "Please select a timeslot to book the event.", $vn = "Select timeslot", wvn = "Switch to monthly view", kvn = "Switch to weekly view", Svn = "Switch to day view", xvn = "Switch to column view", Evn = "{{num}} location options", Tvn = "Select on the next step", Avn = "This meeting has not started yet", Cvn = "{{appName}} requires a connected {{dependencyName}} account", zvn = "Connect {{dependencyName}}", Ovn = "{{dependencyName}} is connected", Pvn = "Requires {{dependencyName}}", Ivn = "Verification code", Rvn = "Can you try again with a different time?", Nvn = "Verify", Dvn = "The timezone of the person receiving", Mvn = "Timezone", Lvn = "Event end time", qvn = "The event end time", jvn = "Cancel URL", Fvn = "The URL to cancel the booking", Vvn = "Cancellation Reason", Bvn = "The reason for canceling the booking", Uvn = "Reschedule URL", Wvn = "The URL to reschedule the booking", Gvn = "Reschedule Reason", Hvn = "The reason for rescheduling the booking", Kvn = "{{item}} is an invalid variable in your event name", Yvn = "Select All", Zvn = "Bulk update existing event types", Qvn = "Member's default schedule", Jvn = "Set by team admin", Xvn = "Member's default location", ebn = "We will use each members default availability schedule. They will be able to edit or change it.", tbn = "You are required to have at least one schedule", nbn = "Update the locations for the selected event types", obn = "Update the schedules for the selected event types", rbn = "Locked for members", ibn = "Unlocked for members", abn = "Members will be able to see the active apps but will not be able to edit any app settings", sbn = "Members will be able to see the active apps and will be able to edit any app settings", cbn = "You will be able to see the active apps but will not be able to edit any app settings", lbn = "You will be able to see the active apps and will be able to edit any app settings", dbn = "Members can not add their personal workflows to this event type.  Members will be able to see the active team workflows but will not be able to edit any workflow settings.", ubn = "Members will be able to add their personal workflows to this event type.  Members will be able to see the active team workflows but will not be able to edit any workflow settings.", _bn = "You will be able to see the active team workflows but will not be able to edit any workflow settings or add your personal workflows to this event type.", pbn = "You will be able to enable/disable personal workflows on this event type. You will be able to see the active team workflows but will not be able to edit any team workflow settings.", mbn = "Members can not add their personal webhooks to this event type. Members will be able to see the active webhooks but will not be able to edit any webhook settings.", fbn = "Members will be able to add their personal webhooks to this event type. Members will be able to see the active webhooks but will not be able to edit any webhook settings.", gbn = "You are able to see the active managed webhooks but will not be able to edit any webhook settings or add your personal webhooks to this event type.", hbn = "You can add webhooks to this event type. You are able to see the active managed webhooks but will not be able to edit them.", vbn = "Locked by team admin", bbn = "You have not connected a {{appName}} account.", ybn = "Connect now", $bn = "Replace & notify {{count}} member", wbn = "Replace & notify {{count}} members", kbn = "The url /{{slug}} already exists for {{count}} member. Do you want to replace it?", Sbn = "The url /{{slug}} already exists for {{count}} members. Do you want to replace it?", xbn = "<strong>{{names}}</strong> is already using the <strong>/{{slug}}</strong> url.", Ebn = "<strong>{{names}}</strong> are already using the <strong>/{{slug}}</strong> url.", Tbn = "If you choose to replace it, we will notify them. Go back and remove them if you don't want to overwrite it.", Abn = "Review Event Type", Cbn = "Looking for more analytics?", zbn = "Looking for more Insights?", Obn = "Filters", Pbn = "Filter", Ibn = "Add a member", Rbn = "Add filter", Nbn = "Add rule", Dbn = "Add rule group", Mbn = "Clear all filters", Lbn = "Email Verified", qbn = "Select User", jbn = "Select Event Type", Fbn = "Select Date Range", Vbn = "Popular Events", Bbn = "No event types found", Ubn = "Average Event Duration", Wbn = "Bookings by Hour", Gbn = "Most Booked", Hbn = "Least Booked", Kbn = "Most Bookings Scheduled", Ybn = "Least Bookings Scheduled", Zbn = "Most Bookings Completed", Qbn = "Least Bookings Completed", Jbn = "Events Created", Xbn = "Events Completed", eyn = "Events Cancelled", tyn = "Events Rescheduled", nyn = "Events", oyn = "Performance", ryn = "from last period", iyn = "From: {{startDate}} To: {{endDate}}", ayn = 'Adding a redirect will disable the success page. Make sure to mention "Booking Confirmed" on your custom success page.', syn = "Event Trends", cyn = "Clear Filters", lyn = "Clear", dyn = "Hold", uyn = "Collect payment on booking", _yn = "Charge no-show fee", pyn = "Card held", myn = "Charge card", fyn = "Card charged", gyn = "{{amount, currency}} no-show fee", hyn = "No-show Fee", vyn = "Submit card", byn = "Submit payment information", yyn = "Your meeting is awaiting a payment method", $yn = "No-show fee of {{amount, currency}} charged for {{title}} at {{date}}", wyn = "No-show fee was charged", kyn = "No-show fee of {{amount, currency}} was charged for the following event", Syn = "Something went wrong charging the no-show fee. Please try again later.", xyn = "Collect no-show fee", Eyn = "No-show fee charged", Tyn = "Payment declined. Please try a different card or contact your bank for assistance.", Ayn = "This card type isn't supported for this purchase. Please use a different payment method.", Cyn = "Minimum payment amount is $0.50 USD. Please increase your payment amount.", zyn = "Could not charge card for payment.", Oyn = "Insights", Pyn = "Routing Forms", Iyn = "No data found for the selected filter or selected dates.", Ryn = "No-Show Hosts Over Time", Nyn = "CSAT Over Time", Dyn = "No-Show Hosts", Myn = "CSAT", Lyn = "I acknowledge that if I do not attend this event that a {{amount, currency}} no show fee will be applied to my card.", qyn = "days", jyn = "Card details", Fyn = "Something went wrong on our end. Get in touch with our support team, and we'll get it fixed right away for you.", Vyn = "Please provide the following text when contacting support to better help you", Byn = "Currently cannot enable seats and charge a no-show fee", Uyn = "Complete your booking", Wyn = "Complete your booking: {{title}} on {{date}}", Gyn = "Confirm your details", Hyn = "Copy invite link", Kyn = "Edit link settings", Yyn = "Invite link copied", Zyn = "Invite link deleted", Qyn = "API Key deleted", Jyn = "This will permanently delete the API key. Any applications using this key will immediately lose access to your account. This action cannot be undone.", Xyn = "Invite link settings saved", e$n = "Links set to expire after...", t$n = "1 day", n$n = "7 days", o$n = "30 days", r$n = "3 months", i$n = "1 year", a$n = "You have been invited to join {{teamName}}", s$n = "{{amount, currency}}", c$n = "You are about to charge the attendee {{amount, currency}}. Are you sure you want to continue?", l$n = "Charge attendee {{amount, currency}}", d$n = "Require payment ({{paymentFeePercentage}}% + {{fee, currency}} commission per transaction)", u$n = "{{email}} has been invited", _$n = "{{userCount}} users have been invited", p$n = "Error collecting card", m$n = "Uploaded image shouldn't exceed 5mb size limit", f$n = "{{errorCode}}: You are not authorized to enable or disable this workflow", g$n = "Inline Embed", h$n = "Loads your event type directly inline with your other website content.", v$n = "Floating pop-up button", b$n = "Puts a floating button on your site that triggers a modal with your event type.", y$n = "Pop up via element click", $$n = "Open your calendar as a dialog when someone clicks an element.", w$n = "Use my own form", k$n = "Use our headless routing API and use your own form for submissions.", S$n = "Need help? See our guides for embedding Cal on Wix, Squarespace, or WordPress, check our common questions, or explore advanced embed options.", x$n = "Book my Cal", E$n = "First name", T$n = "Last name", A$n = "First name, Last name", C$n = "Invite as", z$n = "Form updated successfully.", O$n = "Disable default confirmation emails for attendees", P$n = "At least one workflow is active on this event type that sends a booking confirmation to the attendees.", I$n = "Disable default confirmation emails for host", R$n = "At least one workflow is active on this event type that sends an email to the host when the event is booked.", N$n = "Add an override", D$n = "Import users from Google Workspace", M$n = "Connect Google Workspace", L$n = "You must be a Workspace Admin to use this feature", q$n = "Create your first webhook for this event type", j$n = "Create your first webhook with 'Instant Meeting Created' as trigger for this event type", F$n = "Install app on", V$n = "Create for", B$n = "Currency", U$n = "Create an environment where your teams can create shared apps, workflows and event types with round-robin and collective scheduling.", W$n = "Manage organizations with multiple teams", G$n = "Set up your organization", H$n = "Set up your platform", K$n = "Organizations are shared environments where teams can create shared event types, apps, workflows and more.", Y$n = "Plans", Z$n = "Platform", Q$n = "Manage everything related to platform.", J$n = "Cal.com Platform lets you integrate scheduling effortlessly into your app using platform apis and atoms.", X$n = "Must enter an organization name", ewn = "Must enter your organization email address", twn = "Your organization email address", nwn = "Your admin email address", own = "Administrator's username", rwn = "Organization name", iwn = "Platform name", awn = "Organization URL", swn = "Verify your organization email", cwn = "Please use the code below to verify your email address to continue setting up your organization.", lwn = "Additional URL parameters", dwn = "About your organization", uwn = "Organizations are shared environments where you can create multiple teams with shared members, event types, apps, workflows and more.", _wn = "Create your teams", pwn = "Start scheduling together by adding your team members to your organization", mwn = "Invite organization members", fwn = "Invite others to join your organization. You can add members later.", gwn = "Set a password", hwn = "This will create a new user account with your organization email and this password.", vwn = "Organization Logo", bwn = "A few sentences about your organization. This will appear on your organization public profile page.", ywn = "I'll do this later", $wn = "Verify your email", wwn = "Enter the 6 digit code we sent to {{email}}", kwn = "Verify your email to create an organization", Swn = "The code provided is not valid, try again", xwn = "Email already being used", Ewn = "You've been invited to join {{orgName}}", Twn = "Join your team at {{orgName}} and start focusing on meeting, not making meetings!", Awn = "The following teams couldn't be created due to duplicated slugs: {{slugs}}", Cwn = "Team names can't be empty", zwn = "Team names can't be repeated", Own = "User belongs to an organization", Pwn = "This organization has no teams yet", Iwn = "If you are an administrator, be sure to create teams to be shown here.", Rwn = "Set up", Nwn = "My profile", Dwn = "My settings", Mwn = "CRM", Lwn = "Messaging", qwn = "Name or number shown as the sender of an SMS (some countries do not allow alphanumeric sender IDs)", jwn = "Only the admin of your organization can create new teams", Fwn = "Google's new spam policy could prevent you from receiving any email and calendar notifications about this booking.", Vwn = "Resolve", Bwn = "There was an error creating teams for this organization. Missing URL slug.", Uwn = "Copy link to organization", Wwn = "Team: {{teamName}}", Gwn = "User: {{userName}}", Hwn = "View booking insights across your events", Kwn = "Call History", Ywn = "View call history across your Cal.ai calls", Zwn = "{{locationCount}} location options", Qwn = "Channel Type", Jwn = "End Reason", Xwn = "Session Status", e0n = "User Sentiment", t0n = "Time", n0n = "From", o0n = "Custom Plan", r0n = "Email Embed", i0n = "Select a few available times and embed them in your Email", a0n = "Select Time", s0n = "Select Date", c0n = "Only show if a parameter is set", l0n = "Add parameter", d0n = "We are connecting you to someone from {{orgName}}.", u0n = "Please do not close or refresh this page", _0n = "See all available times", p0n = "e.g. Marketing Team", m0n = "e.g. Sales Team", f0n = "e.g. Design Team", g0n = "e.g. Engineering Team", h0n = "e.g. Data Analytics Team", v0n = "You will be able to add more teams later on.", b0n = "What is this meeting about?", y0n = "Add to team", $0n = "Remove users from organization", w0n = "Delegation credential", k0n = "Delegation credential allows you to manage access to Google Workspace calendars for your organization.", S0n = "Add this Client Id in Google Workspace with the scope below", x0n = "Delegation credential enabled", E0n = "Add delegation credential", T0n = "Edit delegation credential", A0n = "Domain", C0n = "No workspace platforms", z0n = "Workspace platform", O0n = "Workspace platforms", P0n = "Manage workspace platforms that can be used for delegation credential", I0n = "Edit workspace platform", R0n = "Edit service account", N0n = "Add workspace platform", D0n = "Slug", M0n = "Service account key JSON", L0n = "Edit service account key JSON", q0n = "Delegation credential restricts adding more than one installation", j0n = "App successfully installed and is using delegated credentials", F0n = "Are you sure you want to remove {{userCount}} users from this organization?", V0n = "Remove users from team", B0n = "Are you sure you want to remove {{userCount}} users from this team?", U0n = "This user has not setup any schedules yet", W0n = "This user is not in any teams", G0n = "This user has not installed any apps yet", H0n = "Requires booker email verification", K0n = "To ensure booker's email verification before scheduling events", Y0n = "Text messages can only be sent to attendees when event type requires confirmation.", Z0n = "Organizations", Q0n = "Upload Cal Video Logo", J0n = "Update Cal Video Logo", X0n = "Upload Banner", ekn = "To ensure your logo is visible against Cal video's dark background, please upload a light-colored image in PNG or SVG format to maintain transparency.", tkn = "Other teams", nkn = "Here you can see teams inside your organization that you are not part of. You can add yourself to them if needed.", okn = "You are not part of any organization", rkn = "No other teams found", ikn = "There are no other teams in this organization.", akn = "Attendee first name", skn = "Attendee last name", ckn = "The person booking's first name", lkn = "The person booking's last name", dkn = "Your Monthly Digest", ukn = "Member Name", _kn = "Most Popular Events", pkn = "Here's your summary of popular events for your team {{teamName}} for the last 30 days", mkn = "Me", fkn = "Meeting Unavailable", gkn = "Monthly digest email", hkn = "Monthly digest email for teams", vkn = "Verify your team to enable sending messages to attendees", bkn = "Member removed", ykn = "My Availability", $kn = "Team Availability", wkn = "Instant meeting availability", kkn = "Backup Code", Skn = "Backup Codes", xkn = "Each backup code can be used exactly once to grant access without your authenticator.", Ekn = "Backup codes copied!", Tkn = "Backup code is incorrect.", Akn = "Lost access", Ckn = "No backup codes found. Please generate them in your settings.", zkn = "New organization created: pending action", Okn = "Hi Administrator", Pkn = "An organization requires DNS setup", Ikn = 'An organization with slug "{{orgSlug}}" was created.<br /><br />Please be sure to configure your DNS registry to point the subdomain corresponding to the new organization to where the main app is running. Otherwise the organization will not work.<br /><br />Here are just the very basic options to configure a subdomain to point to their app so it loads the organization profile page.<br /><br />You can do it either with the A Record:', Rkn = "Or the CNAME record:", Nkn = "Once you configure the subdomain, please mark the DNS configuration as done in Organizations Admin Settings.", Dkn = "Go to Organizations Admin Settings", Mkn = "Org has been processed", Lkn = "There has been an error processing this organization", qkn = "A list of all organizations. Accepting an organization will allow all users with that email domain to sign up WITHOUT email verification.", jkn = "Unverified", Fkn = "Verified", Vkn = "DNS Missing", Bkn = "DNS Configured", Ukn = "Mark as DNS configured", Wkn = "Value", Gkn = "Your organization updated successfully", Hkn = "This team has no event types", Kkn = "Seat option doesn't support multiple durations", Ykn = "Include calendar event", Zkn = "OAuth", Qkn = "OAuth client creation form", Jkn = "This is the form to create a new OAuth client", Xkn = "OAuth client updation form", e1n = "This is the form to edit an existing OAuth client", t1n = "Recently added", n1n = "Connect all your calendars", o1n = "{{appName}} reads availability from all your existing calendars.", r1n = "Personalise your scheduling experience with workflows", i1n = "Workflow automation", a1n = "Schedule for your team with collective and round-robin scheduling", s1n = "No members found", c1n = "Directory Sync", l1n = "Directory Name", d1n = "Directory Provider", u1n = "SCIM Base URL", _1n = "SCIM Bearer Token", p1n = "SCIM Base URL copied", m1n = "SCIM Bearer Token copied", f1n = "Your Identity Provider will ask for the following information to configure SCIM. Follow the instructions to finish the setup.", g1n = "Configure Directory Sync", h1n = "Choose an identity provider to configure directory for your team.", v1n = "Configure an identity provider to get started with SCIM.", b1n = "Directory sync connection created.", y1n = "Provision and de-provision users with your directory provider.", $1n = "Directory sync connection deleted.", w1n = "Delete Connection", k1n = "Delete Directory Sync Connection", S1n = "Are you sure you want to delete this directory sync connection?", x1n = "This action cannot be undone. This will permanently delete the directory sync connection.", E1n = "Event Setup: The duration must be at least 1 minute.", T1n = "Availability Schedules", A1n = "Unauthorized", C1n = "{{clientName}} would like access to your {{appName}} account", z1n = "Select account or team", O1n = "This will allow {{clientName}} to", P1n = "Associate you with your personal info from {{clientName}}", I1n = "See your personal info, including any personal info you've made publicly available", R1n = "See your primary email address", N1n = "Connect to your installed apps", D1n = "Read, edit, delete your event-types", M1n = "Read, edit, delete your availability", L1n = "Read, edit, delete your bookings", q1n = "Allow {{clientName}} to do this?", j1n = "By clicking allow, you allow this app to use your information in accordance with their terms of service and privacy policy. You can remove access in the {{appName}} App Store.", F1n = "Allow", V1n = "This user has not completed onboarding. You will not be able to set their availability until they have completed onboarding.", B1n = "You are viewing this user's availability. You can only edit your own availability.", U1n = "You can override this on a per-event basis in Advanced settings in each event type.", W1n = "Edit user's availability: {{username}}", G1n = "Resend invitation", H1n = "The invitation was resent.", K1n = "SAML", Y1n = "Add client", Z1n = "After copying the secret you won't be able to view it anymore", Q1n = "Add new Client", J1n = "Add new user", X1n = "This app has not been setup yet", e2n = "as CSV", t2n = "Overlay my calendar", n2n = "By connecting to your calendar, you accept our privacy policy and terms of use. You may revoke access at any time.", o2n = "View your calendar events to prevent clashed booking.", r2n = "Join {{eventLocationType}}", i2n = "Troubleshooting", a2n = "Calendars we're checking for conflicts", s2n = "Availability schedules", c2n = "Manage calendars", l2n = "Manage availability schedules", d2n = "Locked", u2n = "Unlocked", _2n = "Lock timezone on booking page", p2n = "To lock the timezone on booking page, useful for in-person events. <0>Learn more</0>", m2n = "You can only have one payment app enabled per event type.", f2n = "Please enter number in international format.", g2n = "Install Calendar", h2n = "Branded Subdomain", v2n = "Get your own branded subdomain, such as acme.cal.com", b2n = "Organization-wide Insights", y2n = "Understand how your entire organization is spending time", $2n = "Extensive Whitelabeling", w2n = "Customize your scheduling experience with your own logo, colors, and more", k2n = "Unlimited Teams", S2n = "Verify email", x2n = "Please enter the email address used for this booking to proceed with cancellation", E2n = "Email doesn't match the booking email", T2n = "Add as many subteams as you need to your organization", A2n = "Unified Billing", C2n = "Advanced Managed Event Types", z2n = "Add a single credit card to pay for all your team's subscriptions", O2n = "Enterprise", P2n = "Upgrade to Enterprise to create your Organization", I2n = "Create your Organization", R2n = "Create organization", N2n = "Upgrade to Organizations and receive a subdomain, unified billing, Insights, extensive whitelabeling and more", D2n = "Upgrade to Enterprise and get access to Active Directory Sync, SCIM Automatic User provisioning, Cal.ai Voice Agents, Admin APIs and more!", M2n = "You can only enable one payment app per event type", L2n = "Teams that are member of this organization will also be deleted along with their event-types", q2n = "Users that were part of the organization will not be deleted but their usernames would be changed to allow them to exist outside the organization", j2n = "User event-types created after the user was in the organization will be deleted", F2n = "Migrated user event-types will not be deleted", V2n = "Delete {{organizationName}}?", B2n = "Published", U2n = "Unpublished", W2n = "Publish", G2n = "Open the troubleshooter and figure out what is wrong with your schedule", H2n = "Need help?", K2n = "Troubleshooter", Y2n = "Number to Call", Z2n = "Guest Name", Q2n = "Guest Email", J2n = "Guest Company", X2n = "Please install a calendar", eSn = "Instant Booking", tSn = "Let people book immediately", nSn = "Upgrade to Enterprise and let guests join an instant call that attendees can jump straight into. This is only for team event types", oSn = "Don't want to wait?", rSn = "Meeting Started", iSn = "Pay to book", aSn = "Let AI Agents book you", sSn = "Could not find booking", cSn = "Booking seats are full", lSn = "Missing payment credentials", dSn = "Missing payment app id", uSn = "Booking does not have enough available seats", _Sn = "{{username}} is currently away for a brief period of time.", pSn = "In the meantime, {{profile.username}} will be in charge of all the new scheduled meetings on behalf of {{username}}.", mSn = "Out of office", fSn = "Let your bookers know when you're OOO.", gSn = "Send request", hSn = "Start date and end date are required", vSn = "Start date must be before end date", bSn = "Start date must be in the future", ySn = "User not found", $Sn = "Cannot redirect to self", wSn = "Out of office entry already exists", kSn = "Out of office entry id required", SSn = "There is already a booking redirect from that user to you.", xSn = "Successfully created a new entry", ESn = "Booking redirect notification", TSn = "Booking Redirect Notification", ASn = "You have received a booking redirection from {{eventOwner}} so their profile links will be redirect to yours for the time interval {{dates}}.", CSn = "Booking redirect edit notification", zSn = "Booking Redirect Edit Notification", OSn = "Your booking redirection from {{eventOwner}} for the time interval {{oldDates}} has been udpated. New time interval for the redirection is {{dates}}.", PSn = "Booking redirect cancel notification", ISn = "Booking Redirect Cancel Notification", RSn = "Your booking redirection from {{eventOwner}}, for time interval {{dates}} has been canceled.", NSn = "You have accepted this booking redirect request.", DSn = "You have rejected this booking redirect request.", MSn = "Copy link to share request", LSn = "Booking Redirect Request", qSn = "Select team member", jSn = "Going away? Simply mark your profile link as unavailable for a period of time.", FSn = "Provide a link to a team member when OOO", VSn = "Provide a link to a team member when OOO (Team plan required)", BSn = "Out of office unavailability list", USn = "Successfully deleted entry", WSn = "Successfully edited entry", GSn = "Temporarily Out-Of-Office?", HSn = "Add a redirect", KSn = "Create entry", YSn = "Time range", ZSn = "Add all team members, including future members", QSn = "Redirect to", JSn = "Having trouble finding a time?", XSn = "Show more", exn = "Forward parameters such as ?email=...&name=.... and more", txn = "Schedule meetings when everyone is available or rotate through members on your team", nxn = "lowest", oxn = "low", rxn = "medium", ixn = "high", axn = "highest", sxn = "Send Booker to", cxn = "Set Priority", lxn = "Set Weight", dxn = "Enable Weights", uxn = "Priority for {{userName}}", _xn = "Weights determine how meetings are distributed among hosts. <0>Learn more</0>", pxn = "Weight for {{userName}}", mxn = "change priority", fxn = "Use field identifiers as variables for your custom event redirect", gxn = "Use field identifiers as variables for your custom event redirect (e.g. {{variable}})", hxn = "Account is already linked", vxn = "Send email", bxn = "Call attendee using Cal.ai Voice Agent", yxn = "Call to confirm booking", $xn = "2 hrs before event starts", wxn = "Cal.ai Agent Configuration", kxn = "Please choose at least one event type to make a test call.", Sxn = "Mark as no-show", xxn = "Unmark no-show", Exn = "Account unlinked successfully", Txn = "There was an error unlinking the account", Axn = "Travel Schedule", Cxn = "Plan your trip ahead to keep your existing schedule in a different timezone and prevent being booked at midnight.", zxn = "Schedule timezone change", Oxn = "Date", Pxn = "Enter the general prompt for the agent", Ixn = "This overlaps with an existing schedule. Please select a different date.", Rxn = "Get notifications when your team has no availability", Nxn = "Admins will get email notifications when a user tries to book a team member and is faced with 'No availability'. We trigger this email after two occurrences and remind you every 7 days per user.  ", Dxn = "Disable SMS notifications for phone only event types", Mxn = "Disable automated SMS notifications for event types that only have phone number(attendeePhoneNumber) as required question with email as optional or not required", Lxn = "Your current plan", qxn = "$37 per user per month", jxn = "Manage privacy settings for your organization", Fxn = "Privacy", Vxn = "Privacy & Security", Bxn = "New teams will be under your organization", Uxn = "Add group name", Wxn = "Group Name", Gxn = "Routers", Hxn = "Primary", Kxn = "Make primary", Yxn = "Add Email", Zxn = "Add Emails", Qxn = "Add an email address to replace your primary or to use as an alternative email on your event types.", Jxn = "Confirm your email", Xxn = "$t(hey_there) {{name}}, confirming your booking on {{date}}.", eEn = "The first name of the person booking", tEn = "The last name of the person booking", nEn = "Scheduler Name", oEn = "Your first name", rEn = "We sent an email to <strong>{{email}}</strong>. Click the link in the email to verify this address.", iEn = "Send event details to", aEn = "Schedule timezone without end date", sEn = "Select members", cEn = "What should we do with your member's existing event types?", lEn = "All of your members individual event types (except managed ones) will be permanently deleted. They will not be able to create new ones", dEn = "Your members individual event types will be hidden (except managed ones) from profiles but the links will still be active. They will not be able to create new ones.  ", uEn = "Hide individual event types", _En = "Delete individual event types", pEn = "Lock individual event type creation", mEn = "Prevent members from creating their own event types.", fEn = "Add to event type", gEn = "Create account password", hEn = "Create Account with SAML", vEn = "Failed to create account password", bEn = "Cannot create account password for cal accounts", yEn = "Cannot create account password for already created ones", $En = "You don't have an account password, create one by navigating to Security -> Password. Can't disconnect until an account password is created.", wEn = "Disconnect connected account", kEn = "Disconnecting your connected account will change the way you log in. You will only be able to login to your account using email + password", SEn = "I agree to the privacy policy and cookie usage", xEn = "Make a Call", EEn = "Skip round robin assignment if contact exists in Salesforce", TEn = "URL must contain the contacts email as a parameter ex. ?email=contactEmail", AEn = "Select Account", CEn = "Install {{appName}} on your personal account or on a team account.", zEn = "Select Event Types", OEn = "On which event type do you want to install {{appName}}?", PEn = "Configure {{appName}}", IEn = "Finalise the App setup. You can change these settings later.", REn = "already installed", NEn = "Unspecified", DEn = "Vacation", MEn = "Travel", LEn = "Sick leave", qEn = "Public holiday", jEn = "Forwarding to <0>{{username}}</0>", FEn = "No forwarding", VEn = "Create an OOO", BEn = "Communicate to your bookers when you're not available to take bookings. They can still book you upon your return or you can forward them to a team member.", UEn = "{{displayName}} is OOO", WEn = "<0>{{displayName}}</0> can take their meetings while they are away.", GEn = "Book {{displayName}}", HEn = "Select reason", KEn = "Go Out of Office", YEn = "Edit Out of Office Entry", ZEn = "Submit Feedback", QEn = "Your host didn't show up", JEn = "You can reschedule another meeting with them", XEn = "How can we improve our service?", eTn = "What did you like the most?", tTn = "Review", nTn = "Reviewed", oTn = "Unreviewed", rTn = "Rating url", iTn = "The URL for Rating Feedback Form", aTn = "No Show url", sTn = "The URL for No Show Feedback", cTn = "No Support Needed?", lTn = "Hide Support", dTn = "Average Ratings", uTn = "No-Show (Host)", _Tn = "No-Show (Guest)", pTn = "Recent Ratings", mTn = "No ratings submitted", fTn = "Add a workflow with 'Rating' to collect ratings after meetings", gTn = "Most No-Show", hTn = "Highest Rated", vTn = "Lowest Rated", bTn = "Members with highest rated meetings", yTn = "Members with lowest rated meetings", $Tn = "CSAT Score", wTn = "Locked SMS", kTn = "Leave without assigning anyone?", STn = "Are you sure want to leave this event without adding attendees?", xTn = "If you don't assign anyone for this event, there will be no availability shown to bookers.", ETn = "Go back and Assign", TTn = "Leave without Assigning", ATn = "By proceeding, you agree to our <0>Terms</0> and <1>Privacy Policy</1>.", CTn = "By proceeding, you agree to our", zTn = "Terms", OTn = "Always {{x}} days available", PTn = "Automatically moves the {{x}}-day booking window forward each day, ensuring your calendar always shows the next {{x}} days of available slots.", ITn = "Team subscription cancelled successfully", RTn = "Error while cancelling the team subscription", NTn = "An error occurred while trying to subscribe to the platform plan, please try again later", DTn = "An error occurred while updating the OAuth client, please try again later", MTn = "An error occurred while creating the OAuth client, please try again later", LTn = "Event type color", qTn = "This is only used for event type & booking differentiation within the app. It is not displayed to bookers.", jTn = "Mark as no show", FTn = "{{x}} marked as no-show", VTn = "{{x}} unmarked as no-show", BTn = "triggers for all team event types and all team members' personal event types", UTn = "Manage settings for you team", WTn = "No-show status updated for attendees", GTn = "Email copied", HTn = "Phone Number Copied", KTn = "User is a pending member of the organization", YTn = "User is already invited or a member", ZTn = "User is member of an organization that this team is not a part of.", QTn = "Booking has been reassigned", JTn = "Reassign", XTn = "Reassign booking to another available round robin host", eAn = "Assign team member", tAn = "Override which team member you want to assign to.", nAn = "No available hosts", oAn = "Reassign round robin host", rAn = "Do not write to the ICS feed", iAn = "Rescheduling is not possible as the event has expired", aAn = "This event is expired", sAn = "Skip creating contacts if they do not exist in {{appName}} ", cAn = "If your ICS link is read-only (e.g., Proton Calendar), check the box above to avoid errors. You'll also need to manually update your calendar for changes.", lAn = "Attributes", dAn = "New attribute", uAn = "Add attributes", _An = "Add attributes to your team members", pAn = "New option", mAn = "Update member", fAn = "Attribute", gAn = "Create an attribute for your team members", hAn = "Edit an attribute for your team members", vAn = "Attribute updated successfully", bAn = "Attribute deleted successfully", yAn = "Attributes edited successfully", $An = "Manage attributes for your team members", wAn = "Edit attributes for your team members", kAn = "Back to attributes", SAn = "Are you sure you want to delete this option?", xAn = "This option is assigned to {{numberOfUsers}} members. Deleting it will remove it from their profile.", EAn = "Disable standard emails to attendees related to this event type", TAn = "Disables standard email communication related to this event type, including booking confirmations, reminders, and cancellations.", AAn = "Disable standard emails to hosts related to this event type", CAn = "Type confirm to continue", zAn = "Disable email", OAn = "Grant Admin API Access", PAn = "Revoke Admin API Access", IAn = "Add {{calendar}} Calendar", RAn = "Connect Apple Calendar", NAn = "Connected Apple Calendar", DAn = "Checking Apple Calendar", MAn = "Connect Google Calendar", LAn = "Connected Google Calendar", qAn = "Checking Google Calendar", jAn = "Connect Outlook Calendar", FAn = "Connected Outlook Calendar", VAn = "Checking Outlook Calendar", BAn = "Connect to Stripe", UAn = "Connected Stripe", WAn = "Checking Stripe credentials", GAn = "Booking question response variables", HAn = "Managed by {{teamAdmins}}", KAn = "{{count}} options", YAn = "Reschedule with same Round-Robin host", ZAn = "Rescheduled events will be assigned to the same host as initially scheduled", QAn = "Disable input if the URL identifier is prefilled", JAn = "Booking Limits", XAn = "Booking limits for team members across all team event types", eCn = "Limit how many times members can be booked across all team event types", tCn = "Booking limits updated successfully", nCn = "You are unauthorized to make this change to the booking", oCn = "Delegation credential disabled", rCn = "Matching members", iCn = "{{x}} matching members", aCn = "Matching members queue (using attribute weights)", sCn = "Matching members queue (using event assignee weights)", cCn = "No matching members. It will fallback to using the team members assigned to the event type.", lCn = "No matching members. It will fallback to using the team members assigned to the event type. Consider adding a fallback or correcting the logic of using_fallback_members", dCn = "Hide calendar event details on shared calendars", uCn = "When a calendar is shared, events are visible to readers but their details are hidden from those without write access.", _Cn = "Last {{count}} days", pCn = "Month to date", mCn = "Year to date", fCn = "Custom range", gCn = "Refund Policy", hCn = "Always", vCn = "Never", bCn = "Payment Option", yCn = "If cancelled", $Cn = "before", wCn = "Show all columns", kCn = "Toggle columns", SCn = "No columns found", xCn = "On booking, add events on and new attendees as:", ECn = "Lead", TCn = "Contact under an account", ACn = "Skip creating {{entry}} record if they do not exist in Salesforce", CCn = "If the contact does not exist under an account, create new lead from attendee", zCn = "Create a new contact under an account based on email domain of attendee and existing contacts", OCn = "Change record owner on booking", PCn = "Mass assign attributes", ICn = "It results in showing custom message. Try changing the response to route to an event", RCn = "It results in redirecting to {{externalUrl}}. Try changing the response to route to an event", NCn = "Possible host", DCn = "Current routing status", MCn = "Reroute booking", LCn = "Reroute the booking to different team members", qCn = "Verify new route", jCn = "Reroute", FCn = "New routing status", VCn = "If attendee exists in Salesforce, book directly with the owner", BCn = "Entity to check owner of to book directly", UCn = "Account", WCn = "Choose host schedules", GCn = "You can select a different schedule for each host. Each host's default schedule is chosen by default.", HCn = "No hosts assigned, add hosts in assignment tab.", KCn = "Manually reassign round robin host", YCn = "Manually reassign round robin host to another available host", ZCn = "Reassign round robin host to another available host", QCn = "New user is not a valid round-robin host for this event type", JCn = "New user is a fixed host for this event type", XCn = "Reschedule with same timeslot", ezn = "Reschedule with same timeslot of the new event", tzn = "Reschedule to the new event with different timeslot", nzn = "Reschedule with different timeslot", ozn = "We don't have ID for the new event. Please go to the Routing Form and save it again.", rzn = "Rerouted booking successfully. Redirecting to booking page", izn = "On booking, write to event object", azn = "Field name", szn = "Add new field", czn = "You don't have access to reroute this booking", lzn = "Form response not found", dzn = "Contact owner", uzn = "Not found", _zn = "Using fallback members", pzn = "Chosen Route", mzn = "Attribute logic matched", fzn = "Attribute logic fallback matched", gzn = "All assigned members of the team event type. Consider adding some attribute rules.", hzn = "All assigned members of the team event type. Consider adding some attribute rules to fallback.", vzn = "All assigned members of the team event type. Consider tweaking fallback to have a match.", bzn = "Warning", yzn = "Fallback: If no Team Members match, use those that match the following criteria (matches all assigned team members of the event by default)", $zn = "Fallback warning", wzn = "Not needed", kzn = "Host unavailable", Szn = "Host available", xzn = "Are you sure you want to reassign this booking to an unavailable host?", Ezn = "Are you sure you want to reassign this booking?", Tzn = "Yes, reassign", Azn = "Filter by attributes", Czn = "Reason for reassigning", zzn = "Changing the field type may cause data loss. Please create a new field instead.", Ozn = "Reassigned by", Pzn = "row", Izn = "rows", Rzn = "Attendee Timezone", Nzn = "Event Start Time In Attendee Timezone", Dzn = "Event Start Time In Attendee Timezone", Mzn = "Event End Time In Attendee Timezone", Lzn = "Event End Time In Attendee Timezone", qzn = "Create event on contact, if it exists. Else fallback to lead", jzn = "Owner name to change", Fzn = "No filter set", Vzn = "Booking dry run successful", Bzn = "The dry run was completed successfully.", Uzn = "You don't have access to this page", Wzn = "In order to view or interact with this page, you must have admin or owner privileges", Gzn = "Field type", Hzn = "When to write", Kzn = "On booking, write to a custom field on the attendee {{record}} record", Yzn = "On every booking", Zzn = "Only if field is empty", Qzn = "Booking start date", Jzn = "Booking created date", Xzn = "Booking reassigned to {{host}}", eOn = "No contact owner", tOn = "Routing Forms Created", nOn = "Total Responses", oOn = "Total Responses Without Booking", rOn = "Total Responses With Booking", iOn = "No Bookings", aOn = "Form Name", sOn = "Booking", cOn = "No Booking", lOn = "Booked by", dOn = "Created at", uOn = "Booking Status", _On = "Booking At", pOn = "Submitted At", mOn = "Copy Redirect URL", fOn = "Redirect URL on Exit", gOn = "Total Bookings per period", hOn = "Routed to per period", vOn = "Per day", bOn = "Per week", yOn = "Per month", $On = "Assignment Reason", wOn = "Access Denied", kOn = "Contact owner will be the Round Robin host if available", SOn = "Add new attendees as", xOn = "Contact owner will not be forced (can still be host if it matches the attributes and Round Robin criteria)", EOn = "Route to a user that matches a lookup field on an account", TOn = "Salesforce Option", AOn = "Lookup Field Name", COn = "If attendee has a free email domain, skip the ownership check and round robin as normal", zOn = "Is", OOn = "Is not", POn = "Contains", IOn = "Does not contain", ROn = "Starts with", NOn = "Ends with", DOn = "Is empty", MOn = "Not empty", LOn = "Auto translate title and description", qOn = "Automatically translate titles and descriptions to the visitor’s browser language using AI.", jOn = "Distribution", FOn = "Allows for optimising distribution for maximum availability or to aim for a more balanced assignment.", VOn = "Maximize availability", BOn = "Allows bookers to book meetings whenever a host is available. Use this to maximize the number of potential meetings booked and when the even distribution of meetings across hosts is less important.", UOn = "Load balancing", WOn = "We will monitor how many bookings have been made with each host and compare this with others, disabling some hosts that are too far ahead so bookings are evenly distributed.", GOn = "Edit Weights", HOn = "Weights updated successfully", KOn = "Only require confirmation for free email providers (Ex. @gmail.com, @outlook.com)", YOn = "Exclude emails that contain", ZOn = "Require emails that contain", QOn = "Please enter a valid work email address", JOn = "You are not allowed to book with this email domain. Please contact the owner of this link.", XOn = "Search columns", e4n = "Search options", t4n = "Disable public organization profile and redirect", n4n = "Redirects {{orgSlug}}.cal.com to {{destination}}", o4n = "Single Select", r4n = "Multi Select", i4n = "Calendar Conflict Settings", a4n = "Select which calendars to check for conflicts", s4n = "Group Meeting", c4n = "Are you sure you want to remove this app from", l4n = "Disconnect app from", d4n = "Do not create new records for guests added to the booking", u4n = "Google Meet", _4n = "Zoom", p4n = "MS Teams Video", m4n = "Lock for assignment", f4n = "Locking would only allow assignments from Directory Sync", g4n = "Attribute edited successfully", h4n = "New group option", v4n = "Weights enabled", b4n = "By enabling weights, it would be possible to assign higher priority to certain attributes per user. The higher the weight, the higher the priority.", y4n = "Routed", $4n = "Reassigned", w4n = "Allow rescheduling past events", k4n = "Enabling this option allows for past events to be rescheduled. <0>Learn more</0>", S4n = "Rerouted", x4n = "Salesforce assignment", E4n = "Router Position", T4n = "Show matching hosts", A4n = "No active queues for this input", C4n = "Weight", z4n = "Calibration", O4n = "Shortfall", P4n = "Routing Form", I4n = "Go back and save", R4n = "Save changes", N4n = "Leave without saving", D4n = "Are you sure you want to leave without saving changes to your routing form?", M4n = "Something unexpected occurred", L4n = "You are doing a test booking.", q4n = "Icon showcase", j4n = "Icons showcase", F4n = "Migrating from team", V4n = "Feature is currently disabled", B4n = "Choose an option", U4n = "Enter option value", W4n = "Remove option", G4n = "Use Attribute weights", H4n = "If enabled, all weights set within the event type will be ignored", K4n = "Attribute for weights", Y4n = "Managed Users", Z4n = "See all the managed users created by your OAuth client", Q4n = "Can you tell me about ", J4n = "Use AI to answer your questions", X4n = "Error while fetching answer ", e3n = "An unexpected error occured. Please try again later", t3n = "Select Oauth Client", n3n = "On every instance", o3n = "Delegation credential feature is not enabled for your organization", r3n = "Internal Note", i3n = "Reason shared with customer (optional)", a3n = "This note will be visible to only members of your team", s3n = "Internal Cancelation Notes Presets", c3n = "Create presets for internal notes that can be applied to bookings", l3n = "Internal note presets updated successfully", d3n = "Add Preset", u3n = "Authorize", _3n = "Next", p3n = "Hide", m3n = "Show", f3n = "UTM parameters", g3n = "No UTM parameters available.", h3n = "Asc", v3n = "Desc", b3n = "Verify email change", y3n = "Buy Credits", $3n = "Credits", w3n = "Credits used", k3n = "Total remaining", S3n = "You receive 1000 credits per month, per team member", x3n = "You receive 750 credits per month, per team member", E3n = "View and manage credits for sending SMS messages", T3n = "View and manage credits for sending SMS messages. One credit is worth 1¢ (USD). <0>Learn more</0>", A3n = "One credit is worth 1¢ (USD). <0>Learn more</0>", C3n = "Buy additional credits ($0.01 per credit)", z3n = "You can view Additional credit spending in your expense log", O3n = "Overview", P3n = "Organization slug is already taken", I3n = "You cannot create an organization as you are already a part of an organization", R3n = "You need to complete user onboarding before creating an organization", N3n = "Use company email to create an organization", D3n = "You cannot create a platform organization as you are already a part of a team", M3n = "You need to have minimum published teams", L3n = "You are part of this organization already", q3n = "You are part of another organization, cannot create a new organization", j3n = "You are part of another platform organization, cannot create a new organization", F3n = "Organization payment success", V3n = "Your organization has been created successfully", B3n = "This may take a few seconds...", U3n = "Organization onboarding status", W3n = "Organization onboarding status description", G3n = "Payment failed", H3n = "Your payment has failed. Please try again.", K3n = "Creating your organization", Y3n = "Organization onboarding already completed", Z3n = "Organization onboarding already exists", Q3n = "Organization onboarding not found", J3n = "No onboarding ID provided", X3n = "Onboarding not found", e6n = "Onboarding already complete", t6n = "This onboarding has already been completed. You can view your organization in settings.", n6n = "Resume Onboarding", o6n = "Continue with your organization onboarding process", r6n = "Payment successful!", i6n = "Handover onboarding", a6n = "Handover onboarding to the user", s6n = "Organization already exists with this slug", c6n = "You do not have permission to create an organization for this email", l6n = "You do not have permission to migrate one or more of the teams", d6n = "Organization has a subscription already", u6n = "Reset interval for weighted Round Robin", _6n = "Interval", p6n = "Determines how often the round robin booking count resets to ensure balanced distribution.", m6n = "Daily", f6n = "You didn't set an end date for your OOO", g6n = "My OOO", h6n = "Team OOO", v6n = "Manage your teams OOO.", b6n = "Create Out of Office", y6n = "Create an OOO for a team member", $6n = "Edit an OOO for a team member", w6n = "Create OOO for your team", k6n = "Communicate to bookers when your team members are not available to take bookings. They can still be booked upon their return or you can forward them to another team member.", S6n = "OOO forwarding is only allowed to a member of the same team.", x6n = "There is already a reverse forwarding between these users.", E6n = "No previous OOO found", T6n = "Previous", A6n = "Round Robin interval successfully updated", C6n = "Trial mode", z6n = "Inactive team plan", O6n = "Your team plan is inactive. Check your subcription or reach out to customer support", P6n = "Limited access during trial. Feature available after trial ends.", I6n = "Referral Program", R6n = "Refer and earn", N6n = "You need a Dub API Key and Program Id to use this page.", D6n = "UID", M6n = "Link", L6n = "rows per page", q6n = "{{currentRange}} of {{totalItems}}", j6n = "Tip: You can add a '+' between usernames: cal.com/anna+brian to make a dynamic group meeting", F6n = "You don't have a team yet", V6n = "You don't have team members yet", B6n = "Recurring event doesn't support seats feature. Make it non-recurring to enable seats.", U6n = "Recurring event doesn't support booking limit per booker feature. Disable booking limit per booker to enable Recurring event.", W6n = "Seats feature doesn't support recurring event. Disable seats feature to make it recurring.", G6n = "Recurring event doesn't support seats feature. Disable seats feature or make the event non-recurring.", H6n = "Segment", K6n = "Saved filters", Y6n = "Rename", Z6n = "Rename Segment", Q6n = "Delete Segment", J6n = "Duplicate Segment", X6n = "Are you sure you want to delete this segment? This action cannot be undone.", e5n = "Filter segment updated", t5n = "Error updating filter segment", n5n = "Filter segment duplicated", o5n = "Error duplicating filter segment", r5n = "Filter segment deleted", i5n = "Error deleting filter segment", a5n = "Save Segment", s5n = "Segment not found", c5n = "Filter segment saved", l5n = "No segments", d5n = "Error saving filter segment", u5n = 'Save overrides to "{{name}}"', _5n = "Create new segment", p5n = "Save for team", m5n = "Select team", f5n = "Please select a team", g5n = "Personal", h5n = "Hide Team Profile Link", v5n = "Hide the team profile link on booking pages", b5n = "Display", y5n = "Could not find slug to publish the organization", $5n = "Picklist", w5n = "Most Cancelled", k5n = "Interface Language", S5n = "Set your preferred language for the booking interface", x5n = "Visitor's browser language", E5n = "Name or Email", T5n = "If no contact is found, fallback to lead owner if it exists", A5n = "Credit purchase failed. Please try again or contact support.", C5n = "Minimum of 50 credits required", z5n = "Enable Delegation Credential", O5n = "Grant Cal.com automatic access to the calendars of all organization members by enabling delegation credential.", P5n = "Disable Delegation Credential", I5n = "Once delegation credential is disabled, organization members who haven't connected their calendars will need to do so manually.", R5n = "Last Active", N5n = "Member Since", D5n = "Last Updated", M5n = "On cancelled booking, write to event record instead of deleting event", L5n = "On every cancellation", q5n = "Report issue", j5n = "You can submit a ticket on GitHub or upgrade your plan to receive real-time support with developer conferences", F5n = "Open Issue", V5n = "This is your current plan", B5n = "Schedule a time", U5n = "This includes:", W5n = "OAuth client updated successfully", G5n = "OAuth Client not found.", H5n = "Subscribe to Platform", K5n = "Error while trying to access webhooks.", Y5n = "Failed to update webhook.", Z5n = "Failed to create webhook.", Q5n = "Invalid Link", J5n = "You are currently subscribed to {{planFirstLetter}}{{planRest}} plan", X5n = "User/Team", ePn = "Client ID copied!", tPn = "Client secret copied!", nPn = "The Cal.com team are performing scheduled maintenance. If you have any questions, please contact support.", oPn = "Your payment failed", rPn = "Check your Inbox", iPn = "Your account has been created, but your premium has not been reserved.", aPn = "We have sent an email to {{email}} with a link to activate your account.", sPn = "Once you activate your account you will be able to try purchase your premium username again or select a different one.", cPn = "Open in Gmail", lPn = "Don't seen an email?", dPn = "Resend in {{seconds}} seconds", uPn = "Resend", _Pn = "Verification email sent", pPn = "Select all members", mPn = "Selecting all members will add all future team members when they are added to the team.", fPn = "Form Settings", gPn = "Remove whitelist status", hPn = "Whitelist user workflows", vPn = "User workflows whitelisted", bPn = "User workflows unwhitelisted", yPn = "Date & Time", $Pn = "This is a reminder about your upcoming event.", wPn = "This reminder was triggered by a Workflow in Cal.", kPn = "Event", SPn = "Scheduling by", xPn = "How was your recent experience?", EPn = "We're always looking to improve our customer's experience.", TPn = "How satisfied were you with your recent meeting?", APn = "didn't join the meeting?", CPn = "Reschedule here.", zPn = "Hide organizer's email", OPn = "You are already part of a platform organization which is why you can't create a new organization. Each user can only belong to one organization. Please, create a new cal.com account with a different email and use that account to subscribe to the organizations plan.", PPn = "You are already part of an organization which is why you can't create a platform organization. Each user can only belong to one organization. Please, create a new cal.com account with a different email and use that account to subscribe to the platform plan.", IPn = "Hide organizer's email address from the booking screen, email notifications, and calendar events. <0>Learn more</0>", RPn = "You &", NPn = "Select a verified email", DPn = "Add verified email", MPn = "Add verified emails", LPn = "Custom 'Reply-To' email", qPn = "Use a different email address as the replyTo for confirmation emails instead of the organizer's email", jPn = "This survey was triggered by a Workflow in Cal.", FPn = "Skip trial period", VPn = "Team trials skipped successfully", BPn = "By entering your phone number you consent to receive SMS messages for this event. SMS rates may apply.", UPn = "More info can be found in <0>Routing Insights</0>", WPn = "Results", GPn = "View Form", HPn = "Text STOP to opt-out of SMS messages", KPn = "Your team {{teamName}} is running low on credits", YPn = "You are running low on credits", ZPn = "[Action Required] Your team {{teamName}} has run out of credits", QPn = "[Action Required] You have run out of credits", JPn = "Your Cal.com team {{teamName}} is running low on credits. To avoid any disruption in service, please purchase additional credits. If your balance runs out, SMS messages will stop sending and will be sent as emails instead.", XPn = "Your Cal.com account is running low on credits. To avoid any disruption in service, please purchase additional credits. If your balance runs out, SMS messages will stop sending and will be sent as emails instead.", eIn = "Your Cal.com team {{teamName}} has run out of credits. As a result, SMS messages are now being sent via email instead. To resume sending SMS, please purchase additional credits.", tIn = "Your Cal.com account has run out of credits. As a result, SMS messages are now being sent via email instead. To resume sending SMS, please purchase additional credits.", nIn = "Current balance: {{balance}} credits", oIn = "Current balance:", rIn = "Notification about your booking", iIn = "Monthly credits", aIn = "Total credits: {{totalCredits}}", sIn = "Remaining credits: {{remainingCredits}}", cIn = "Remaining", lIn = "Total", dIn = "Additional credits", uIn = "{{count}} next in queue", _In = "Send email responses to", pIn = "Incomplete Bookings", mIn = "Include no show bookings in round robin calculations", fIn = "Recent No-Show Guests", gIn = "Shows bookings where all attendees were no-shows, not partial no-shows", hIn = "Matching", vIn = "Event Redirect", bIn = "Reset Form", yIn = "Round Robin settings successfully updated", $In = "Distribution basis for weighted Round Robin", wIn = "Determines which event timestamp is used as the basis for weighted round robin distribution.", kIn = "Requires credits", SIn = "You need enough credits in your account to use this feature", xIn = "Available credits", EIn = "Create role", TIn = "Roles", AIn = "Roles & Permissions", CIn = "Manage roles and permissions for your organization", zIn = "Learn more about how Permissions work", OIn = "Role name", PIn = "Role name is required", IIn = "e.g. Sales Team, Support Staff", RIn = "Role description", NIn = "Describe what this role is for and what permissions it needs", DIn = "Default role", MIn = "Custom role", LIn = "Advanced", qIn = "Search permissions", jIn = "All permissions", FIn = "None", VIn = "Read only", BIn = "All actions on all resources", UIn = "All Resources", WIn = "Event Types", GIn = "Teams", HIn = "Organization", KIn = "Bookings", YIn = "Insights", ZIn = "Roles", QIn = "Routing Forms", JIn = "Workflows", XIn = "All Actions", eRn = "Create", tRn = "View", nRn = "Edit", oRn = "Delete", rRn = "Manage", iRn = "Invite", aRn = "Remove", sRn = "Change Member Role", cRn = "List Members", lRn = "Manage Billing", dRn = "View Team Bookings", uRn = "View Organization Bookings", _Rn = "View Recordings", pRn = "Impersonate", mRn = "Role created successfully", fRn = "Role updated successfully", gRn = "Delete role", hRn = "Are you sure you want to delete role: {{roleName}}. This action cannot be undone.", vRn = "Role deleted successfully", bRn = "Error creating role", yRn = "Error updating role", $Rn = "Create roles", wRn = "Attributes", kRn = "View organization attributes", SRn = "Update organization attributes", xRn = "Delete organization attributes", ERn = "Create organization attributes", TRn = "View roles", ARn = "Update roles", CRn = "Delete roles", zRn = "Create and set up new workflows", ORn = "Set up required", PRn = "View existing workflows and their configurations", IRn = "Edit and modify workflow settings", RRn = "Remove workflows from the system", NRn = "Webhook", DRn = "Availability", MRn = "Out of Office", LRn = "Blocklist", qRn = "Create webhooks", jRn = "View webhooks", FRn = "Update webhooks", VRn = "Delete webhooks", BRn = "Create availability", URn = "View availability", WRn = "Update availability", GRn = "Delete availability", HRn = "Create out of office", KRn = "View out of office", YRn = "Update out of office", ZRn = "Delete out of office", QRn = "Full management access to all workflows", JRn = "Create event types", XRn = "View event types", eNn = "Update event types", tNn = "Delete event types", nNn = "All actions on event types", oNn = "Create teams", rNn = "View team details", iNn = "Update team settings", aNn = "Delete team", sNn = "Invite team members", cNn = "Remove team members", lNn = "Change role of team members", dNn = "Impersonate team members", uNn = "All actions on teams across organization teams", _Nn = "Create organization", pNn = "View organization details", mNn = "List organization members", fNn = "Invite organization members", gNn = "Remove organization members", hNn = "Manage organization billing", vNn = "Change role of organization members", bNn = "Impersonate organization members", yNn = "Edit organization settings", $Nn = "All actions on organizations", wNn = "View bookings", kNn = "View team bookings", SNn = "View organization bookings", xNn = "View booking recordings", ENn = "Update bookings", TNn = "All actions on bookings", ANn = "View team insights", CNn = "Manage team insights", zNn = "Create routing forms", ONn = "View routing forms", PNn = "Update routing forms", INn = "Delete routing forms", RNn = "Enable Roles & Permissions for your organization", NNn = "Take control of your organization with customizable roles and granular permissions for your team members.", DNn = "Custom roles", MNn = "Create custom roles tailored to your organization's unique workflow", LNn = "Granular permissions", qNn = "Control exactly what team members can view, edit, and manage", jNn = "Team member assignment", FNn = "Easily assign roles to team members as your team grows", VNn = "Enhanced security", BNn = "Protect sensitive data with organization-wide security controls", UNn = "Enable PBAC", WNn = "Successfully enabled PBAC for your organization", GNn = "Failed to enable PBAC for your organization", HNn = "Read permission is automatically enabled when creating, updating, or deleting a resource", KNn = "Add restriction schedule", YNn = "Limit availability of hosts to only display slots that fall within a specified schedule.", ZNn = "Use booker's timezone", QNn = "Apply the selected restriction schedule in the booker's timezone", JNn = "This will disable Load Balancing on all your Round Robin event types", XNn = "Load Balancing is only available when the timestamp basis is set to Booking Creation Time", eDn = "Load Balancing is not available with Round Robin Groups", tDn = "Customize the default round robin settings for this team", nDn = "Round Robin settings updated successfully", oDn = "Booking creation time", rDn = "Meeting start time", iDn = "Affected members", aDn = "No members affected by disabling delegation credential", sDn = "Download Expense Log", cDn = "Error downloading expense log", lDn = "Prevent Impersonation on Bookings", dDn = "When enabled, anyone trying to book events using your email address must verify they own it via a one time code or be logged in to prevent impersonation", uDn = "Offer to reschedule the last booking to the new time slot", _Dn = "You've reached the limit of {{count}} upcoming bookings for this event type", pDn = "You already have a booking for this event on {{date}}. Would you like to reschedule to the new selected time?", mDn = "Duration must be at least {{min}} minute(s)", fDn = "Duration cannot exceed {{max}} minutes (24 hours)", gDn = "Booking outside restriction schedule availability.", hDn = "Restriction schedule not found", vDn = "Image size limit exceeded, please use a smaller image preferably in JPEG format", bDn = "Add Group", yDn = "Routing Funnel", $Dn = "Total Submissions", wDn = "Successful Routings", kDn = "Accepted Bookings", SDn = "License key", xDn = "Choose your license", EDn = "Select how you want to license your Cal.com deployment", TDn = "Use Cal.com under the AGPLv3 open source license", ADn = "Enter License Key", CDn = "Access to all enterprise features", zDn = "Starting at $15/user per month", ODn = "Access to all enterprise features", PDn = "Enter your license key", IDn = "Save License Key", RDn = "Signature token (optional)", NDn = "Signature token is used to verify the license key is yours when incrementing usage based billing. You can find it in your purchase confirmation email. If you are on a legacy license, you can leave this blank.", DDn = "Need a license?", MDn = "License key is required", LDn = "Invalid license key", qDn = "Failed to validate license key", jDn = "Attachments Optional", FDn = "Send Message", VDn = "Describe the issue", BDn = "File size exceeds limit", UDn = "Invalid file type", WDn = "Invalid file type. Accepted types: {{acceptedTypes}}", GDn = "Maximum number of files exceeded", HDn = "Files uploaded successfully", KDn = "Accepted types: {{acceptedTypes}}; Max file size: {{maxSize}}", YDn = "License key saved successfully", ZDn = "You are viewing the report based on your profile timezone ({{userTimezone}}), while your browser is set to timezone ({{browserTimezone}})", QDn = "Optimized slots", JDn = "Arrange time slots to optimize availability. <0>Learn more</0>", XDn = "Failed Bookings By Field", eMn = "Failed bookings", tMn = "No hosts are assigned to event type", nMn = "Cache Status", oMn = "Last updated: {{timestamp}}", rMn = "Delete cached data", iMn = "Cache deleted successfully", aMn = "Error deleting cache", sMn = "Are you sure you want to delete the cached data? This action cannot be undone.", cMn = "Yes, delete cache", lMn = "{{remainder}} of {{maximum}} uses left", dMn = "{{remainder}} of {{maximum}} use left", uMn = "Expires on {{date}}, end of day", _Mn = "Single use", pMn = "Time-based expiration", mMn = "Usage-based expiration", fMn = "Number of uses", gMn = "Expires on", hMn = "Maximum number of uses", vMn = "Link Settings", bMn = "This link expired on {{date}}, end of day", yMn = "Usage limit reached", $Mn = "Maximum usage count must be greater than current usage count", wMn = "This link has expired", kMn = "This link can be used for bookings until the end of {{date}}", SMn = "This link can be configured to expire after a set date", xMn = "This link can be used for {{count}} booking", EMn = "This link can be configured to expire after a set number of bookings", TMn = "This link can be used for {{count}} bookings", AMn = "The name of the trigger event (e.g., BOOKING_CREATED, BOOKING_CANCELLED)", CMn = "The time of the webhook", zMn = "The event type slug", OMn = "Set up Agent", PMn = "The event type name", IMn = "The event's start time", RMn = "The event's end time", NMn = "The event's description as described in the event type settings", DMn = "Location of the event", MMn = "The UID of the booking", LMn = "The UID for rescheduling", qMn = "Reason for cancellation", jMn = "Reason for rejection", FMn = "Name of the organizer", VMn = "Email of the organizer", BMn = "Timezone of the organizer (e.g., 'America/New_York', 'Asia/Kolkata')", UMn = "Locale of the organizer (e.g., 'en', 'fr')", WMn = "Username of the organizer (e.g., 'john.doe')", GMn = "Username of the organizer in their organization (e.g., 'john.doe')", HMn = "Name of the first attendee", KMn = "Email of the first attendee", YMn = "Timezone of the first attendee", ZMn = "Locale of the first attendee", QMn = "Name of the team booked", JMn = "Members of the team booked", XMn = "Video call URL for the meeting", eLn = "Hide variables", tLn = "Show available variables", nLn = "Event and Booking", oLn = "People", rLn = "Teams", iLn = "Metadata", aLn = "Stats", sLn = "Booking status", cLn = "When routing form is submitted", lLn = "When routing form is submitted and no booking is created", dLn = "How long after the form was submitted?", uLn = "Visit", _Ln = "Custom label on booking page", pLn = "Meeting link", mLn = "Session Outcome", fLn = "Call Created", gLn = "Voicemail", hLn = "My Bookings", vLn = "Phone", bLn = "Free", yLn = "User Email", $Ln = "User Name", wLn = "Expand Panel", kLn = "Collapse Panel", SLn = "Email verification is required for this event type", xLn = "Invalid verification code provided", ELn = "You have one team", TLn = "Consider setting up an organization to unify billing, admin tools, and analytics across your team.", ALn = "Consider setting up an organization to unify billing, admin tools, and analytics across your teams.", CLn = "Message Sent", zLn = "Thank you for contacting us. We'll get back to you as soon as possible.", OLn = "Search variables", PLn = "Please describe the issue you're facing, e.g. 'Busy slots are marked available', ..., etc.", ILn = "Send another message", RLn = "Sending", NLn = "No variables found", DLn = "Credits Required", MLn = "Web calls consume credits. Make sure you have enough credits to start a call.", LLn = "Web calls require credits. You have 0 credits remaining.", qLn = "Purchase Credits", jLn = "This action requires credits to proceed", FLn = "Name must not exceed {{max}} characters", VLn = "Auto charge no-show fee for last minute cancellations", BLn = "Before scheduled start time", ULn = "I acknowledge that by cancelling the booking within {{timeValue}} {{timeUnit}} of the start time I will be charged the no show fee of {{amount, currency}}", WLn = "If you have any questions, please contact the organizer.", GLn = "Booking time", HLn = "When the booking is scheduled (start to end)", KLn = "Created at", YLn = "When the booking was originally created", ZLn = "Call Details", QLn = "Call ID", JLn = "Call Information", XLn = "Sentiment", eqn = "Disconnect Reason", tqn = "Call Summary", nqn = "Transcription", oqn = "Event Details", rqn = "Agent", iqn = "No transcript available", aqn = "When testing this workflow, be aware that SMS need to be scheduled at least 15 minutes in advance", sqn = "Start from scratch", cqn = "Create your own workflow from scratch.", lqn = "Cal.ai template", dqn = "AI agents that book meetings, send reminders, and follow up!", uqn = "Voice", _qn = "Select Voice", pqn = "Select a voice for your agent", mqn = "Choose a voice for your agent", fqn = "Trait", gqn = "Voice ID", hqn = "Use Voice", vqn = "Current Voice", bqn = "Set up incoming agent", yqn = "Configure an AI agent to handle incoming calls on your phone number", $qn = "Connect a Phone Number first", wqn = "Set up Agent for incoming calls", kqn = "Configure agent to handle incoming calls", Sqn = "Incoming Calls", xqn = "Outgoing Calls", Eqn = "Both Email and Attendee Phone Number cannot be hidden", Tqn = "At least Email or Attendee Phone Number must be a required field", Aqn = "Attendee Phone Number must be required when Email is hidden", Cqn = "Email must be required when Attendee Phone Number is hidden", zqn = "Inbound agent setup successful", Oqn = "Inbound agent configured", Pqn = "Set up Inbound Agent", Iqn = "Please select an event type first", Rqn = "Edit Configuration", Nqn = "Inbound calls can book only one event type. Select the event type where meetings will be scheduled when callers reach your agent.", Dqn = "Set up inbound agent for incoming calls", Mqn = "Create Block Entry", Lqn = "Blocklist Entry Details", qqn = "Blocklist entry not found", jqn = "Blocklist entry created successfully", Fqn = "Blocklist entry deleted successfully", Vqn = "Audit History", Bqn = "No audit history available", Uqn = "Delete Blocklist Entry", Wqn = 'Are you sure you want to remove "{{value}}" from the blocklist? This action cannot be undone.', Gqn = "Created By", Hqn = "Blocked By", Kqn = "By", Yqn = "Added", Zqn = "No description provided", Qqn = "Organization Blocklist", Jqn = "Manage blocked emails and domains for your organization", Xqn = "Invalid domain format. Example: example.com", e9n = "Invalid email address. Example: user@example.com", t9n = "Reason for adding to blocklist", n9n = "What would you like to block?", o9n = "Domain Name", r9n = "Add your Organization's details", i9n = "Customize your booking pages with your Organization's name and bio", a9n = "Organization bio", s9n = "Acme helps thousands of companies expand globally with unmatched speed and flexibility.", c9n = "Add your Organization's teams", l9n = "Start scheduling together by adding your teams", d9n = "Add your Organization's brand", u9n = "Customize your booking pages with your logo and a custom banner", _9n = "Primary color", p9n = "Banner", m9n = "Recommended size 64x64px (max 10mb)", f9n = "Recommended size 1500x150px (max 10mb)", g9n = "Nameless", h9n = "Enterprise sales", v9n = "Jump on a call with one of our sales reps to learn more", b9n = "Logo preview", y9n = "Banner preview", $9n = "Pick color", w9n = "Invite your teammates", k9n = "Enter your teammates email address and set their team to add them to your Organization.", S9n = "Connect your Google Workspace, invite via email, upload a CSV file or copy the invite link and share it with your teammates to add them to your Organization.", x9n = "Connect Google Workspace", E9n = "Upload CSV file", T9n = "Copy invite link", A9n = "Invite all as", C9n = "Admins", z9n = "You can modify roles later", O9n = "Skip for now", P9n = "or", I9n = "Team is required", R9n = "Hey {{userName}}", N9n = "To personalize your experience, what do you plan to use Cal.com for?", D9n = "For personal use", M9n = "Free", L9n = "Good for individuals who are just starting out and simply want the essentials.", q9n = "With my team", j9n = "Highly recommended for small teams who seek to upgrade their time and perform better as a unit.", F9n = "For my organization", V9n = "$15/user/mo", B9n = "$37/user/mo", U9n = "Robust scheduling for larger teams looking to have more control, privacy, and security.", W9n = "View previous week", G9n = "View next week", H9n = "Invite Teammates", K9n = "Organization Brand", Y9n = "Organization Details", Z9n = "Organization Teams", Q9n = "Personal Profile", J9n = "Personal Settings", X9n = "Team Brand", ejn = "Team Details", tjn = "Team Invite", njn = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Add your new strings above here ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", Tx = {
  identity_provider: SIt,
  trial_days_left: xIt,
  day_one: EIt,
  day_other: TIt,
  second_one: AIt,
  second_other: CIt,
  upgrade_now: zIt,
  untitled: OIt,
  accept_invitation: PIt,
  max_characters: IIt,
  min_characters: RIt,
  calcom_explained: NIt,
  calcom_explained_new_user: DIt,
  have_any_questions: MIt,
  reset_password_subject: LIt,
  verify_email_subject: qIt,
  verify_email_subject_verifying_email: jIt,
  check_your_email: FIt,
  old_email_address: VIt,
  new_email_address: BIt,
  verify_email_page_body: UIt,
  verify_email_banner_body: WIt,
  verify_email_email_header: GIt,
  verify_email_button: HIt,
  cal_ai_assistant: KIt,
  send_cal_video_transcription_emails: YIt,
  description_send_cal_video_transcription_emails: ZIt,
  verify_email_change_description: QIt,
  verify_email_change_success_toast: JIt,
  verify_email_change_failure_toast: XIt,
  change_of_email: eRt,
  change_of_email_toast: tRt,
  copy_somewhere_safe: nRt,
  verify_email_email_body: oRt,
  verify_email_by_code_email_body: rRt,
  verify_email_email_link_text: iRt,
  email_verification_code: aRt,
  email_verification_code_placeholder: sRt,
  incorrect_email_verification_code: cRt,
  email_sent: lRt,
  email_not_sent: dRt,
  event_declined_subject: uRt,
  event_cancelled_subject: _Rt,
  event_reassigned_subject: pRt,
  event_request_declined: mRt,
  customize_calvideo_settings: fRt,
  calvideo_settings_description: gRt,
  disable_recording_for_guests: hRt,
  enable_automatic_transcription: vRt,
  enable_automatic_recording: bRt,
  video_options: yRt,
  edit_event: $Rt,
  view_session_details: wRt,
  meeting_session_details: kRt,
  meeting_session: SRt,
  session_id: xRt,
  max_participants: ERt,
  unlimited: TRt,
  ongoing: ARt,
  ended: CRt,
  participants: zRt,
  anonymous_user: ORt,
  session_duration: PRt,
  no_meeting_sessions_found: IRt,
  not_available: RRt,
  disable_recording_for_organizer: NRt,
  disable_transcription_for_guests: DRt,
  disable_transcription_for_organizer: MRt,
  event_request_declined_recurring: LRt,
  event_request_cancelled: qRt,
  event_request_reassigned: jRt,
  event_reassigned_subtitle: FRt,
  organizer: VRt,
  reassigned_to: BRt,
  need_to_reschedule_or_cancel: URt,
  you_can_view_booking_details_with_this_url: WRt,
  no_options_available: GRt,
  cancellation_reason: HRt,
  cancelled_by: KRt,
  cancellation_reason_host: YRt,
  cancellation_reason_placeholder: ZRt,
  notify_attendee_cancellation_reason_warning: QRt,
  rejection_reason_placeholder: JRt,
  rejection_reason: XRt,
  rejection_reason_title: eNt,
  rejection_reason_description: tNt,
  rejection_confirmation: nNt,
  report_booking_description: oNt,
  report_reason_spam: rNt,
  report_reason_dont_know_person: iNt,
  report_reason_other: aNt,
  cancel_booking_when_reporting: sNt,
  report_all_remaining_bookings: cNt,
  submit_report: lNt,
  report_booking_description_placeholder: dNt,
  manage_this_event: uNt,
  invite_team_member: _Nt,
  invite_team_individual_segment: pNt,
  invite_team_bulk_segment: mNt,
  invite_team_notifcation_badge: fNt,
  your_event_has_been_scheduled: gNt,
  your_event_has_been_scheduled_recurring: hNt,
  accept_our_license: vNt,
  remove_banner_instructions: bNt,
  error_message: yNt,
  refund_failed_subject: $Nt,
  refund_failed: wNt,
  check_with_provider_and_user: kNt,
  a_refund_failed: SNt,
  awaiting_payment_subject: xNt,
  meeting_awaiting_payment: ENt,
  dark_theme_contrast_error: TNt,
  light_theme_contrast_error: ANt,
  event_type_color_light_theme_contrast_error: CNt,
  event_type_color_dark_theme_contrast_error: zNt,
  payment_not_created_error: ONt,
  couldnt_charge_card_error: PNt,
  no_available_users_found_error: INt,
  timeslot_unavailable_book_a_new_time: RNt,
  timeslot_unavailable_short: NNt,
  just_connected_description: DNt,
  unavailable_timeslot_title: MNt,
  booking_time_out_of_bounds_error: LNt,
  request_body_end_time_internal_error: qNt,
  create_calendar_event_error: jNt,
  update_calendar_event_error: FNt,
  delete_calendar_event_error: VNt,
  already_signed_up_for_this_booking_error: BNt,
  hosts_unavailable_for_booking: UNt,
  fixed_hosts_unavailable_for_booking: WNt,
  round_robin_host_unavailable_for_booking: GNt,
  help: HNt,
  price: KNt,
  paid: YNt,
  refunded: ZNt,
  record: QNt,
  transcribe: JNt,
  payment: XNt,
  missing_card_fields: eDt,
  pay_now: tDt,
  general_prompt: nDt,
  transcription_powered_by_ai: oDt,
  start_or_stop_recording: rDt,
  begin_message: iDt,
  codebase_has_to_stay_opensource: aDt,
  cannot_repackage_codebase: sDt,
  acquire_license: cDt,
  terms_summary: lDt,
  open_env: dDt,
  env_changed: uDt,
  accept_license: _Dt,
  still_waiting_for_approval: pDt,
  event_is_still_waiting: mDt,
  no_result_found_for: fDt,
  no_more_results: gDt,
  no_results: hDt,
  load_more_results: vDt,
  integration_meeting_id: bDt,
  confirmed_event_type_subject: yDt,
  new_event_request: $Dt,
  confirm_or_reject_request: wDt,
  check_bookings_page_to_confirm_or_reject: kDt,
  check_in_assistant: SDt,
  check_in_assistant_description: xDt,
  create_your_own_prompt: EDt,
  event_awaiting_approval: TDt,
  event_awaiting_approval_recurring: ADt,
  someone_requested_an_event: CDt,
  someone_requested_password_reset: zDt,
  password_reset_email_sent: ODt,
  password_reset_instructions: PDt,
  event_awaiting_approval_subject: IDt,
  event_still_awaiting_approval: RDt,
  booking_submitted_subject: NDt,
  download_recording_subject: DDt,
  download_transcript_email_subject: MDt,
  download_your_recording: LDt,
  download_your_transcripts: qDt,
  your_meeting_has_been_booked: jDt,
  event_type_has_been_rescheduled_on_time_date: FDt,
  event_type_has_been_updated: VDt,
  event_has_been_rescheduled: BDt,
  event_has_been_updated: UDt,
  your_event_has_been_rescheduled: WDt,
  request_reschedule_subtitle: GDt,
  request_reschedule_title_organizer: HDt,
  request_reschedule_subtitle_organizer: KDt,
  rescheduled_event_type_subject: YDt,
  requested_to_reschedule_subject_attendee: ZDt,
  hi_user_name: QDt,
  ics_event_title: JDt,
  please_book_a_time_sometime_later: XDt,
  schedule_instead: eMt,
  new_event_subject: tMt,
  join_by_entrypoint: nMt,
  notes: oMt,
  manage_my_bookings: rMt,
  need_to_make_a_change: iMt,
  new_event_scheduled: aMt,
  new_event_scheduled_recurring: sMt,
  invitee_email: cMt,
  invitee_timezone: lMt,
  time_left: dMt,
  event_type: uMt,
  duplicate_event_type: _Mt,
  enter_meeting: pMt,
  video_call_provider: mMt,
  meeting_id: fMt,
  meeting_password: gMt,
  meeting_url: hMt,
  meeting_url_not_found: vMt,
  token_not_found: bMt,
  some_other_host_already_accepted_the_meeting: yMt,
  meeting_request_rejected: $Mt,
  rejected_event_type_with_organizer: wMt,
  hi: kMt,
  join_team: SMt,
  manage_this_team: xMt,
  team_info: EMt,
  join_meeting: TMt,
  request_another_invitation_email: AMt,
  you_have_been_invited: CMt,
  user_invited_you: zMt,
  hidden_team_member_title: OMt,
  hidden_team_member_message: PMt,
  hidden_team_owner_message: IMt,
  link_expires: RMt,
  upgrade_to_per_seat: NMt,
  seat_options_doesnt_support_confirmation: DMt,
  multilocation_doesnt_support_seats: MMt,
  no_show_fee_doesnt_support_seats: LMt,
  seats_option_doesnt_support_multi_location: qMt,
  team_upgrade_seats_details: jMt,
  team_upgrade_banner_description: FMt,
  upgrade_banner_action: VMt,
  team_upgraded_successfully: BMt,
  org_upgrade_banner_description: UMt,
  org_upgraded_successfully: WMt,
  use_link_to_reset_password: GMt,
  hey_there: HMt,
  there: KMt,
  forgot_your_password_calcom: YMt,
  delete_webhook_confirmation_message: ZMt,
  confirm_delete_webhook: QMt,
  edit_webhook: JMt,
  delete_webhook: XMt,
  webhook_status: eLt,
  webhook_enabled: tLt,
  webhook_disabled: nLt,
  webhook_response: oLt,
  webhook_test: rLt,
  webhook_update_form: iLt,
  webhook_update_form_description: aLt,
  manage_your_webhook: sLt,
  webhook_created_successfully: cLt,
  webhook_updated_successfully: lLt,
  webhook_removed_successfully: dLt,
  subscription_needed: uLt,
  subscription_needed_description: _Lt,
  payload_template: pLt,
  dismiss: mLt,
  no_data_yet: fLt,
  ping_test: gLt,
  add_to_homescreen: hLt,
  upcoming: vLt,
  recurring: bLt,
  past: yLt,
  choose_a_file: $Lt,
  upload_image: wLt,
  upload_target: kLt,
  no_target: SLt,
  slide_zoom_drag_instructions: xLt,
  view_notifications: ELt,
  view_public_page: TLt,
  copy_public_page_link: ALt,
  copy_referral_link: CLt,
  sign_out: zLt,
  add_another: OLt,
  install_another: PLt,
  until: ILt,
  powered_by: RLt,
  unavailable: NLt,
  set_work_schedule: DLt,
  change_bookings_availability: MLt,
  select: LLt,
  "2fa_confirm_current_password": "Confirm your current password to get started.",
  "2fa_scan_image_or_use_code": "Scan the image below with the authenticator app on your phone or manually enter the text code instead.",
  text: qLt,
  your_phone_number: jLt,
  multiline_text: FLt,
  number: VLt,
  checkbox: BLt,
  is_required: ULt,
  make_field_required: WLt,
  required: GLt,
  optional: HLt,
  input_type: KLt,
  rejected: YLt,
  unconfirmed: ZLt,
  guests: QLt,
  guest: JLt,
  web_conferencing_details_to_follow: XLt,
  confirmation: eqt,
  what_booker_should_provide: tqt,
  "404_the_user": "The username",
  username: nqt,
  is_still_available: oqt,
  documentation: rqt,
  documentation_description: iqt,
  api_reference: aqt,
  api_reference_description: sqt,
  blog: cqt,
  blog_description: lqt,
  join_our_community: dqt,
  "404_claim_entity_user": "Claim your username and schedule events",
  popular_pages: uqt,
  register_now: _qt,
  register: pqt,
  page_doesnt_exist: mqt,
  no_active_phone_number_available: fqt,
  workflow_step_not_configured: gqt,
  check_spelling_mistakes_or_go_back: hqt,
  "404_page_not_found": "404: This page could not be found.",
  booker_event_not_found: vqt,
  getting_started: bqt,
  "15min_meeting": "15 Min Meeting",
  "30min_meeting": "30 Min Meeting",
  secret: yqt,
  leave_blank_to_remove_secret: $qt,
  webhook_secret_key_description: wqt,
  secret_meeting: kqt,
  login_instead: Sqt,
  create_account: xqt,
  get_started: Eqt,
  confirm_password: Tqt,
  reset_your_password: Aqt,
  org_banner_instructions: Cqt,
  email_change: zqt,
  create_your_account: Oqt,
  create_your_calcom_account: Pqt,
  sign_up: Iqt,
  youve_been_logged_out: Rqt,
  hope_to_see_you_soon: Nqt,
  logged_out: Dqt,
  please_try_again_and_contact_us: Mqt,
  incorrect_2fa_code: Lqt,
  no_account_exists: qqt,
  "2fa_enabled_instructions": "Two-factor authentication enabled. Please enter the six-digit code from your authenticator app.",
  "2fa_enter_six_digit_code": "Enter the six-digit code from your authenticator app below.",
  create_an_account: jqt,
  dont_have_an_account: Fqt,
  "2fa_code": "Two-Factor Code",
  sign_in_account: Vqt,
  sign_in: Bqt,
  go_back_login: Uqt,
  error_during_login: Wqt,
  request_password_reset: Gqt,
  send_invite: Hqt,
  forgot_password: Kqt,
  forgot: Yqt,
  done: Zqt,
  all_done: Qqt,
  all: Jqt,
  yours: Xqt,
  available_apps: e9t,
  available_apps_lower_case: t9t,
  available_apps_desc: n9t,
  fixed_host_helper: o9t,
  round_robin_groups_helper: r9t,
  round_robin_helper: i9t,
  check_email_reset_password: a9t,
  finish: s9t,
  organization_general_description: c9t,
  few_sentences_about_yourself: l9t,
  nearly_there: d9t,
  nearly_there_instructions: u9t,
  set_availability_instructions: _9t,
  set_availability: p9t,
  set_availbility_description: m9t,
  share_a_link_or_embed: f9t,
  share_a_link_or_embed_description: g9t,
  availability_settings: h9t,
  continue_without_calendar: v9t,
  continue_with: b9t,
  connect_your_calendar: y9t,
  connect_your_video_app: $9t,
  connect_your_video_app_instructions: w9t,
  connect_your_calendar_instructions: k9t,
  set_up_later: S9t,
  current_time: x9t,
  details: E9t,
  welcome: T9t,
  welcome_back: A9t,
  welcome_to_calcom: C9t,
  welcome_instructions: z9t,
  connect_caldav: O9t,
  connect_ics_feed: P9t,
  connect: I9t,
  try_for_free: R9t,
  create_booking_link_with_calcom: N9t,
  who: D9t,
  what: M9t,
  when: L9t,
  where: q9t,
  add_to_calendar: j9t,
  add_to_calendar_description: F9t,
  add_events_to: V9t,
  add_another_calendar: B9t,
  other: U9t,
  email_sign_in_subject: W9t,
  round_robin_emailed_you_and_attendees: G9t,
  round_robin_emailed_host_and_attendee: H9t,
  emailed_host_and_attendee: K9t,
  emailed_host_and_attendee_recurring: Y9t,
  round_robin_emailed_you_and_attendees_recurring: Z9t,
  round_robin_emailed_host_and_attendee_recurring: Q9t,
  emailed_you_and_any_other_attendees: J9t,
  needs_to_be_confirmed_or_rejected: X9t,
  needs_to_be_confirmed_or_rejected_recurring: ejt,
  user_needs_to_confirm_or_reject_booking: tjt,
  user_needs_to_confirm_or_reject_booking_recurring: njt,
  meeting_is_scheduled: ojt,
  meeting_is_scheduled_recurring: rjt,
  booking_submitted: ijt,
  booking_submitted_recurring: ajt,
  booking_confirmed: sjt,
  booking_confirmed_recurring: cjt,
  warning_recurring_event_payment: ljt,
  warning_payment_recurring_event: djt,
  enter_new_password: ujt,
  reset_password: _jt,
  change_your_password: pjt,
  show_password: mjt,
  hide_password: fjt,
  try_again: gjt,
  request_is_expired: hjt,
  reset_instructions: vjt,
  request_is_expired_instructions: bjt,
  whoops: yjt,
  login: $jt,
  success: wjt,
  failed: kjt,
  password_has_been_reset_login: Sjt,
  layout: xjt,
  bookerlayout_default_title: Ejt,
  bookerlayout_description: Tjt,
  bookerlayout_user_settings_title: Ajt,
  bookerlayout_user_settings_description: Cjt,
  bookerlayout_month_view: zjt,
  bookerlayout_week_view: Ojt,
  bookerlayout_column_view: Pjt,
  bookerlayout_error_min_one_enabled: Ijt,
  bookerlayout_error_default_not_enabled: Rjt,
  bookerlayout_error_unknown_layout: Njt,
  bookerlayout_override_global_settings: Djt,
  unexpected_error_try_again: Mjt,
  sunday_time_error: Ljt,
  monday_time_error: qjt,
  tuesday_time_error: jjt,
  wednesday_time_error: Fjt,
  thursday_time_error: Vjt,
  friday_time_error: Bjt,
  saturday_time_error: Ujt,
  error_end_time_before_start_time: Wjt,
  error_end_time_next_day: Gjt,
  back_to_bookings: Hjt,
  free_to_pick_another_event_type: Kjt,
  cancelled: Yjt,
  no_booking: Zjt,
  awaiting_host: Qjt,
  cancellation_successful: Jjt,
  really_cancel_booking: Xjt,
  cannot_cancel_booking: eFt,
  reschedule_instead: tFt,
  event_is_in_the_past: nFt,
  cancelling_event_recurring: oFt,
  cancelling_all_recurring: rFt,
  error_with_status_code_occured: iFt,
  error_event_type_url_duplicate: aFt,
  error_event_type_unauthorized_create: sFt,
  error_event_type_unauthorized_update: cFt,
  error_workflow_unauthorized_create: lFt,
  error_schedule_unauthorized_create: dFt,
  booking_already_cancelled: uFt,
  booking_already_accepted_rejected: _Ft,
  go_back_home: pFt,
  or_go_back_home: mFt,
  no_meeting_found: fFt,
  no_meeting_found_description: gFt,
  no_status_bookings_yet: hFt,
  no_status_bookings_yet_description: vFt,
  event_between_users: bFt,
  bookings: yFt,
  booking_not_found: $Ft,
  bookings_description: wFt,
  upcoming_bookings: kFt,
  recurring_bookings: SFt,
  past_bookings: xFt,
  cancelled_bookings: EFt,
  unconfirmed_bookings: TFt,
  unconfirmed_bookings_tooltip: AFt,
  on: CFt,
  and: zFt,
  calendar_shows_busy_between: OFt,
  troubleshoot: PFt,
  troubleshoot_description: IFt,
  overview_of_day: RFt,
  hover_over_bold_times_tip: NFt,
  start_time: DFt,
  end_time: MFt,
  buffer_time: LFt,
  before_event: qFt,
  after_event: jFt,
  event_buffer_default: FFt,
  buffer: VFt,
  your_day_starts_at: BFt,
  your_day_ends_at: UFt,
  launch_troubleshooter: WFt,
  troubleshoot_availability: GFt,
  change_available_times: HFt,
  change_your_available_times: KFt,
  change_start_end: YFt,
  change_start_end_buffer: ZFt,
  current_start_date: QFt,
  start_end_changed_successfully: JFt,
  and_end_at: XFt,
  light: e8t,
  dark: t8t,
  automatically_adjust_theme: n8t,
  user_dynamic_booking_disabled: o8t,
  allow_dynamic_booking_tooltip: r8t,
  allow_dynamic_booking: i8t,
  dynamic_booking: a8t,
  allow_seo_indexing: s8t,
  seo_indexing: c8t,
  allow_browser_notifications: l8t,
  you_have_denied_notifications: d8t,
  disable_browser_notifications: u8t,
  browser_notifications_turned_on: _8t,
  browser_notifications_turned_off: p8t,
  browser_notifications_denied: m8t,
  please_allow_notifications: f8t,
  push_notifications: g8t,
  push_notifications_description: h8t,
  browser_notifications_not_supported: v8t,
  email: b8t,
  email_placeholder: y8t,
  full_name: $8t,
  browse_api_documentation: w8t,
  leverage_our_api: k8t,
  create_webhook: S8t,
  instant_meeting: x8t,
  booking_cancelled: E8t,
  booking_rescheduled: T8t,
  recording_ready: A8t,
  recording_transcription_generated: C8t,
  booking_created: z8t,
  booking_rejected: O8t,
  booking_requested: P8t,
  booking_payment_initiated: I8t,
  meeting_ended: R8t,
  form_submitted: N8t,
  form_submitted_no_event: D8t,
  booking_paid: M8t,
  ooo_created: L8t,
  booking_no_show_updated: q8t,
  event_triggers: j8t,
  subscriber_url: F8t,
  create_new_webhook: V8t,
  webhooks: B8t,
  team_webhooks: U8t,
  create_new_webhook_to_account: W8t,
  new_webhook: G8t,
  receive_cal_meeting_data: H8t,
  receive_cal_event_meeting_data: K8t,
  responsive_fullscreen_iframe: Y8t,
  loading: Z8t,
  deleting: Q8t,
  standard_iframe: J8t,
  developer: X8t,
  manage_developer_settings: e7t,
  iframe_embed: t7t,
  embed_calcom: n7t,
  integrate_using_embed_or_webhooks: o7t,
  schedule_a_meeting: r7t,
  view_and_manage_billing_details: i7t,
  view_and_edit_billing_details: a7t,
  go_to_billing_portal: s7t,
  need_anything_else: c7t,
  further_billing_help: l7t,
  contact: d7t,
  our_support_team: u7t,
  contact_our_support_team: _7t,
  uh_oh: p7t,
  no_event_types_have_been_setup: m7t,
  edit_logo: f7t,
  upload_a_logo: g7t,
  upload_logo: h7t,
  remove_logo: v7t,
  enable: b7t,
  code: y7t,
  code_is_incorrect: $7t,
  add_time_availability: w7t,
  add_an_extra_layer_of_security: k7t,
  "2fa": "Two-Factor Authentication",
  "2fa_disabled": "Two-Factor authentication can only be enabled for email and password authentication",
  enable_2fa: S7t,
  disable_2fa: x7t,
  disable_2fa_recommendation: E7t,
  error_disabling_2fa: T7t,
  error_enabling_2fa: A7t,
  security: C7t,
  manage_account_security: z7t,
  password: O7t,
  password_updated_successfully: P7t,
  password_has_been_changed: I7t,
  error_changing_password: R7t,
  session_timeout_changed: N7t,
  session_timeout_change_error: D7t,
  something_went_wrong: M7t,
  something_doesnt_look_right: L7t,
  please_try_again: q7t,
  super_secure_new_password: j7t,
  new_password: F7t,
  your_old_password: V7t,
  current_password: B7t,
  change_password: U7t,
  change_secret: W7t,
  new_password_matches_old_password: G7t,
  forgotten_secret_description: H7t,
  current_incorrect_password: K7t,
  password_hint_caplow: Y7t,
  password_hint_min: Z7t,
  password_hint_admin_min: Q7t,
  password_hint_num: J7t,
  max_limit_allowed_hint: X7t,
  invalid_password_hint: eVt,
  incorrect_password: tVt,
  incorrect_email_password: nVt,
  use_setting: oVt,
  am_pm: rVt,
  time_options: iVt,
  january: aVt,
  february: sVt,
  march: cVt,
  april: lVt,
  may: dVt,
  june: uVt,
  july: _Vt,
  august: pVt,
  september: mVt,
  october: fVt,
  november: gVt,
  december: hVt,
  monday: vVt,
  tuesday: bVt,
  wednesday: yVt,
  thursday: $Vt,
  friday: wVt,
  saturday: kVt,
  sunday: SVt,
  all_booked_today: xVt,
  slots_load_fail: EVt,
  additional_guests: TVt,
  your_name: AVt,
  your_full_name: CVt,
  no_name: zVt,
  enter_number_between_range: OVt,
  continue_as_guest_description: PVt,
  email_address: IVt,
  enter_valid_email: RVt,
  please_schedule_future_call: NVt,
  location: DVt,
  address: MVt,
  enter_address: LVt,
  in_person_attendee_address: qVt,
  somewhere_else: jVt,
  custom_attendee_location: FVt,
  continue_as_guest: VVt,
  join_as_guest: BVt,
  ideal_for_one_time_calls: UVt,
  any_location: WVt,
  yes: GVt,
  no: HVt,
  additional_notes: KVt,
  booking_fail: YVt,
  reschedule_fail: ZVt,
  share_additional_notes: QVt,
  booking_confirmation: JVt,
  booking_reschedule_confirmation: XVt,
  in_person_meeting: eBt,
  in_person: tBt,
  link_meeting: nBt,
  phone_number: oBt,
  attendee_phone_number: rBt,
  organizer_phone_number: iBt,
  enter_phone_number: aBt,
  reschedule: sBt,
  reschedule_this: cBt,
  book_a_team_member: lBt,
  or: dBt,
  go_back: uBt,
  email_or_username: _Bt,
  send_invite_email: pBt,
  role: mBt,
  edit_role: fBt,
  view_role: gBt,
  edit_team: hBt,
  editing_user: vBt,
  editing_org: bBt,
  edit_or_manage_webhooks: yBt,
  reject: $Bt,
  reject_all: wBt,
  accept: kBt,
  leave: SBt,
  profile: xBt,
  my_team_url: EBt,
  my_teams: TBt,
  team_name: ABt,
  your_team_name: CBt,
  team_updated_successfully: zBt,
  your_team_updated_successfully: OBt,
  your_org_updated_successfully: PBt,
  error_copying_to_clipboard: IBt,
  about: RBt,
  team_description: NBt,
  organization_id: DBt,
  organization_id_copied: MBt,
  org_description: LBt,
  team_id: qBt,
  team_id_copied: jBt,
  members: FBt,
  organization_members: VBt,
  member: BBt,
  number_member_one: UBt,
  number_member_other: WBt,
  number_selected: GBt,
  owner: HBt,
  admin: KBt,
  admin_api: YBt,
  administrator_user: ZBt,
  lets_create_first_administrator_user: QBt,
  admin_user_created: JBt,
  admin_user_created_description: XBt,
  new_member: eUt,
  invite: tUt,
  add_team_members: nUt,
  add_org_members: oUt,
  add_team_members_description: rUt,
  add_team_member: iUt,
  invite_new_member: aUt,
  invite_new_member_description: sUt,
  invite_new_team_member: cUt,
  upload_csv_file: lUt,
  invite_via_email: dUt,
  change_member_role: uUt,
  disable_cal_branding: _Ut,
  disable_cal_branding_description: pUt,
  hide_book_a_team_member: mUt,
  hide_book_a_team_member_description: fUt,
  danger_zone: gUt,
  account_deletion_cannot_be_undone: hUt,
  team_deletion_cannot_be_undone: vUt,
  back: bUt,
  cancel: yUt,
  cancel_all_remaining: $Ut,
  apply: wUt,
  cancel_event: kUt,
  report_booking: SUt,
  report_booking_will_cancel_description: xUt,
  add_to_report: EUt,
  reported: TUt,
  continue: "Continue",
  confirm: AUt,
  confirm_all: CUt,
  disband_team: zUt,
  disband_team_confirmation_message: OUt,
  disband_org: PUt,
  disband_org_confirmation_message: IUt,
  remove_member_confirmation_message: RUt,
  confirm_disband_team: NUt,
  confirm_remove_member: DUt,
  confirm_subscription_cancellation: MUt,
  cancel_subscription: LUt,
  cancel_subscription_description: qUt,
  remove_member: jUt,
  manage_your_team: FUt,
  no_teams: VUt,
  no_teams_description: BUt,
  submit: UUt,
  confirm_remove_attribute: WUt,
  remove_attribute: GUt,
  remove_attribute_confirmation_message: HUt,
  delete: "Delete",
  view: KUt,
  update: YUt,
  save: ZUt,
  pending: QUt,
  open_options: JUt,
  copy_link: XUt,
  share: eWt,
  share_event: tWt,
  copy_link_team: nWt,
  leave_team: oWt,
  confirm_leave_team: rWt,
  leave_team_confirmation_message: iWt,
  user_from_team: aWt,
  preview: sWt,
  link_copied: cWt,
  copied: lWt,
  private_link_copied: dWt,
  link_shared: uWt,
  title: _Wt,
  description: pWt,
  apps_status: mWt,
  quick_video_meeting: fWt,
  scheduling_type: gWt,
  preview_team: hWt,
  collective: vWt,
  collective_description: bWt,
  duration: yWt,
  available_durations: $Wt,
  default_duration: wWt,
  default_duration_no_options: kWt,
  multiple_duration_mins: SWt,
  multiple_duration_timeUnit: xWt,
  multiple_duration_timeUnit_short: EWt,
  minutes: TWt,
  use_cal_ai_to_make_call_description: AWt,
  termination_uri: CWt,
  sip_trunk_username: zWt,
  sip_trunk_password: OWt,
  nickname: PWt,
  delete_phone_number: IWt,
  workflow_validation_failed: RWt,
  workflow_validation_empty_fields: NWt,
  workflow_validation_unverified_contacts: DWt,
  supercharge_your_workflows_with_cal_ai: MWt,
  supercharge_your_workflows_with_cal_ai_description: LWt,
  phone_number_imported_successfully: qWt,
  phone_number_deleted_successfully: jWt,
  delete_phone_number_confirmation: FWt,
  yes_delete_phone_number: VWt,
  phone_number_info_tooltip: BWt,
  termination_uri_info_tooltip: UWt,
  sip_trunk_username_info_tooltip: WWt,
  sip_trunk_password_info_tooltip: GWt,
  nickname_info_tooltip: HWt,
  save_and_test_call: KWt,
  call_initiated_successfully: YWt,
  please_enter_phone_number: ZWt,
  agent_updated_successfully: QWt,
  agent_created_successfully: JWt,
  agent_event_type_updated_successfully: XWt,
  phone_number_unsubscribed_successfully: eGt,
  general_prompt_description: tGt,
  prompt: nGt,
  call_to: oGt,
  make_test_call_to_verify_configuration: rGt,
  initial_message: iGt,
  initial_message_description: aGt,
  having_trouble_importing: sGt,
  learn: cGt,
  learn_how_to_get_your_terminator: lGt,
  phone_number_subscription_cancelled_successfully: dGt,
  updating: uGt,
  round_robin: _Gt,
  hi_how_are_you_doing: pGt,
  round_robin_description: mGt,
  managed_event: fGt,
  username_placeholder: gGt,
  managed_event_description: hGt,
  managed: vGt,
  managed_event_url_clarification: bGt,
  assign_to: yGt,
  enter_phone_number_to_test_call: $Gt,
  make_test_call: wGt,
  create_new_workflow_agent: kGt,
  create_new_workflow_agent_description: SGt,
  phone_number_for_ai_call: xGt,
  buy_a_phone_number_or_import_one_you_already_have: EGt,
  test_agent: TGt,
  test_web_call: AGt,
  phone_numbers: CGt,
  unsubscribe: zGt,
  delete_workflow_step: OGt,
  unsubscribe_phone_number: PGt,
  buy_a_new_number: IGt,
  only_us_phone_numbers_can_be_purchased_here: RGt,
  buy_number_for_x_per_month: NGt,
  supported_call_destinations: DGt,
  no_phone_number_connected: MGt,
  failed_to_get_workflow_step_id: LGt,
  cal_ai_agent: qGt,
  test_cal_ai_agent: jGt,
  are_you_sure_you_want_to_delete_workflow_step: FGt,
  do_you_still_want_to_unsubscribe: VGt,
  the_action_will_disconnect_phone_number: BGt,
  cal_ai_phone_numbers: UGt,
  connect_phone_number: WGt,
  cal_ai_phone_numbers_description: GGt,
  import_number: HGt,
  this_action_will_also: KGt,
  import_phone_number: YGt,
  active_subscription: ZGt,
  cancel_your_phone_number_subscription: QGt,
  delete_associated_phone_number: JGt,
  unauthorized_create_workflow: XGt,
  import_phone_number_description: eHt,
  phone_number_cost: tHt,
  buy_new_number: nHt,
  buy_number_cost_x_per_month: oHt,
  area_code_optional: rHt,
  no_phone_numbers: iHt,
  phone_number_purchased_successfully: aHt,
  cancel_phone_number_subscription: sHt,
  yes_cancel_subscription: cHt,
  cancel_phone_number_subscription_confirmation: lHt,
  add_members: dHt,
  add_members_no_ellipsis: uHt,
  no_assigned_members: _Ht,
  assigned_to: pHt,
  you_must_be_logged_in_to: mHt,
  start_assigning_members_above: fHt,
  locked_fields_admin_description: gHt,
  unlocked_fields_admin_description: hHt,
  locked_fields_member_description: vHt,
  unlocked_fields_member_description: bHt,
  url: yHt,
  hidden: $Ht,
  readonly: wHt,
  one_time_link: kHt,
  plan_description: SHt,
  plan_upgrade_invitation: xHt,
  plan_upgrade: EHt,
  plan_upgrade_teams: THt,
  plan_upgrade_instructions: AHt,
  event_types_page_title: CHt,
  event_types_page_subtitle: zHt,
  new: "New",
  new_event_type_btn: OHt,
  new_event_type_heading: PHt,
  new_event_type_description: IHt,
  event_type_created_successfully: RHt,
  no_call_history: NHt,
  no_call_history_description: DHt,
  event_type_updated_successfully: MHt,
  event_type_deleted_successfully: LHt,
  hours: qHt,
  people: jHt,
  your_email: FHt,
  change_avatar: VHt,
  upload_avatar: BHt,
  language: UHt,
  timezone: WHt,
  first_day_of_week: GHt,
  repeats_up_to_one: HHt,
  repeats_up_to_other: KHt,
  every_for_freq: YHt,
  event_remaining_one: ZHt,
  event_remaining_other: QHt,
  repeats_every: JHt,
  occurrence_one: XHt,
  occurrence_other: eKt,
  weekly_one: tKt,
  weekly_other: nKt,
  monthly_one: oKt,
  monthly_other: rKt,
  yearly_one: iKt,
  yearly_other: aKt,
  plus_more: sKt,
  max: cKt,
  single_theme: lKt,
  brand_color: dKt,
  light_brand_color: uKt,
  dark_brand_color: _Kt,
  light_event_type_color: pKt,
  dark_event_type_color: mKt,
  file_not_named: fKt,
  create_team: gKt,
  name: hKt,
  nameless_team: vKt,
  oauth_clients: bKt,
  oauth_clients_description: yKt,
  create_oauth_client: $Kt,
  create_oauth_client_description: wKt,
  oauth_client_deletion_message: kKt,
  create_new_team_description: SKt,
  create_new_team: xKt,
  booking_redirect_uri: EKt,
  booking_cancel_redirect_uri: TKt,
  booking_reschedule_redirect_uri: AKt,
  booking_conflict_error: CKt,
  open_invitations: zKt,
  new_team: OKt,
  create_first_team_and_invite_others: PKt,
  create_team_to_get_started: IKt,
  teams: RKt,
  team: NKt,
  organization: DKt,
  team_billing: MKt,
  team_billing_description: LKt,
  upgrade_to_flexible_pro_title: qKt,
  upgrade_to_flexible_pro_message: jKt,
  changed_team_billing_info: FKt,
  create_manage_teams_collaborative: VKt,
  only_available_on_pro_plan: BKt,
  remove_cal_branding_description: UKt,
  edit_profile_info_description: WKt,
  change_email_tip: GKt,
  little_something_about: HKt,
  profile_updated_successfully: KKt,
  your_user_profile_updated_successfully: YKt,
  your_upgrade_is_here: ZKt,
  your_upgrade_is_here_description: QKt,
  you_are_all_set: JKt,
  you_are_all_set_description: XKt,
  user_cannot_found_db: eYt,
  embed_and_webhooks: tYt,
  enabled: nYt,
  disabled: oYt,
  disable: rYt,
  billing: iYt,
  here: aYt,
  manage_your_billing_info: sYt,
  availability: cYt,
  edit_availability: lYt,
  configure_availability: dYt,
  copy_times_to: uYt,
  copy_times_to_tooltip: _Yt,
  change_weekly_schedule: pYt,
  logo: mYt,
  error: fYt,
  at_least_characters_one: gYt,
  at_least_characters_other: hYt,
  team_logo: vYt,
  add_location: bYt,
  attendees: yYt,
  add_attendees: $Yt,
  show_advanced_settings: wYt,
  hide_advanced_settings: kYt,
  event_name: SYt,
  event_name_in_calendar: xYt,
  event_name_tooltip: EYt,
  meeting_with_user: TYt,
  additional_inputs: AYt,
  additional_input_description: CYt,
  label: zYt,
  placeholder: OYt,
  display_add_to_calendar_organizer: PYt,
  display_email_as_organizer: IYt,
  if_enabled_email_address_as_organizer: RYt,
  reconnect_calendar_to_use: NYt,
  type: DYt,
  edit: MYt,
  add_input: LYt,
  disable_notes: qYt,
  disable_notes_description: jYt,
  requires_confirmation_description: FYt,
  requires_confirmation_will_block_slot_description: VYt,
  recurring_event: BYt,
  recurring_event_description: UYt,
  connect_and_join: WYt,
  cannot_be_used_with_paid_event_types: GYt,
  warning_payment_instant_meeting_event: HYt,
  warning_instant_meeting_experimental: KYt,
  starting: YYt,
  disable_guests: ZYt,
  disable_guests_description: QYt,
  private_link: JYt,
  enable_private_url: XYt,
  private_link_label: eZt,
  private_link_hint: tZt,
  copy_private_link: nZt,
  copy_private_link_to_event: oZt,
  private_link_description: rZt,
  multiple_private_links_title: iZt,
  multiple_private_links_description: aZt,
  add_a_multiple_private_link: sZt,
  multiple_private_link_copied: cZt,
  invitees_can_schedule: lZt,
  date_range: dZt,
  calendar_days: uZt,
  business_days: _Zt,
  set_address_place: pZt,
  set_link_meeting: mZt,
  managed_event_field_parent_control_disabled: fZt,
  cal_invitee_phone_number_scheduling: gZt,
  cal_provide_google_meet_location: hZt,
  cal_provide_zoom_meeting_url: vZt,
  cal_provide_tandem_meeting_url: bZt,
  cal_provide_video_meeting_url: yZt,
  cal_provide_jitsi_meeting_url: $Zt,
  cal_provide_huddle01_meeting_url: wZt,
  cal_provide_teams_meeting_url: kZt,
  require_payment: SZt,
  you_need_to_add_a_name: xZt,
  commission_per_transaction: EZt,
  event_type_updated_successfully_description: TZt,
  hide_event_type: AZt,
  edit_location: CZt,
  into_the_future: zZt,
  when_booked_with_less_than_notice: OZt,
  within_date_range: PZt,
  indefinitely_into_future: IZt,
  add_new_custom_input_field: RZt,
  quick_chat: NZt,
  add_new_team_event_type: DZt,
  add_new_event_type: MZt,
  new_event_type_to_book_description: LZt,
  length: qZt,
  minimum_booking_notice: jZt,
  offset_toggle: FZt,
  offset_toggle_description: VZt,
  offset_start: BZt,
  offset_start_description: UZt,
  slot_interval: WZt,
  slot_interval_default: GZt,
  delete_event_type: HZt,
  delete_managed_event_type: KZt,
  delete_event_type_description: YZt,
  delete_managed_event_type_description_1: ZZt,
  delete_managed_event_type_description_2: QZt,
  confirm_delete_event_type: JZt,
  delete_account: XZt,
  confirm_delete_account: eQt,
  delete_account_confirmation_message: tQt,
  integrations: nQt,
  apps: oQt,
  apps_description: rQt,
  apps_listing: iQt,
  category_apps: aQt,
  app_store: sQt,
  app_store_description: cQt,
  connect_your_video: lQt,
  settings: dQt,
  event_type_moved_successfully: uQt,
  next_step_text: _Qt,
  next_step: pQt,
  prev_step: mQt,
  install: fQt,
  start_paid_trial: gQt,
  installed: hQt,
  active_install_one: vQt,
  active_install_other: bQt,
  globally_install: yQt,
  app_successfully_installed: $Qt,
  app_could_not_be_installed: wQt,
  disconnect: kQt,
  embed_your_calendar: SQt,
  connect_your_favourite_apps: xQt,
  automation: EQt,
  configure_how_your_event_types_interact: TQt,
  toggle_calendars_conflict: AQt,
  connect_additional_calendar: CQt,
  calendar_updated_successfully: zQt,
  check_here: OQt,
  conferencing: PQt,
  calendar: IQt,
  payments: RQt,
  not_installed: NQt,
  error_password_mismatch: DQt,
  error_required_field: MQt,
  status: LQt,
  team_view_user_availability: qQt,
  team_view_user_availability_disabled: jQt,
  set_as_away: FQt,
  set_as_free: VQt,
  toggle_away_error: BQt,
  user_away: UQt,
  user_away_description: WQt,
  meet_people_with_the_same_tokens: GQt,
  only_book_people_and_allow: HQt,
  account_created_with_identity_provider: KQt,
  account_managed_by_identity_provider: YQt,
  account_managed_by_identity_provider_description: ZQt,
  account_managed_by_identity_provider_error: QQt,
  user_creation_error: JQt,
  signin_with_google: XQt,
  signin_with_saml: eJt,
  signin_with_saml_oidc: tJt,
  continue_with_email: nJt,
  continue_with_google: oJt,
  last_used: rJt,
  you_will_need_to_generate: iJt,
  import: "Import",
  import_from: aJt,
  access_token: sJt,
  visit_roadmap: cJt,
  featured_categories: lJt,
  feature_flags: dJt,
  admin_flags_description: uJt,
  feature_assigned_successfully: _Jt,
  feature_unassigned_successfully: pJt,
  popular_categories: mJt,
  number_apps_one: fJt,
  number_apps_other: gJt,
  trending_apps: hJt,
  most_popular: vJt,
  installed_apps: bJt,
  free_to_use_apps: yJt,
  no_category_apps: $Jt,
  all_apps: wJt,
  no_category_apps_description_calendar: kJt,
  no_category_apps_description_conferencing: SJt,
  no_category_apps_description_payment: xJt,
  no_category_apps_description_analytics: EJt,
  no_category_apps_description_automation: TJt,
  no_category_apps_description_other: AJt,
  no_category_apps_description_messaging: CJt,
  no_category_apps_description_crm: zJt,
  installed_app_calendar_description: OJt,
  installed_app_payment_description: PJt,
  installed_app_analytics_description: IJt,
  installed_app_other_description: RJt,
  installed_app_conferencing_description: NJt,
  installed_app_automation_description: DJt,
  installed_app_messaging_description: MJt,
  installed_app_crm_description: LJt,
  analytics: qJt,
  empty_installed_apps_headline: jJt,
  empty_installed_apps_description: FJt,
  empty_installed_apps_button: VJt,
  manage_your_connected_apps: BJt,
  browse_apps: UJt,
  features: WJt,
  permissions: GJt,
  terms_and_privacy: HJt,
  published_by: KJt,
  subscribe: YJt,
  buy: ZJt,
  install_app: QJt,
  categories: JJt,
  pricing: XJt,
  learn_more: eXt,
  try_now: tXt,
  privacy_policy: nXt,
  terms_of_service: oXt,
  remove: rXt,
  add: iXt,
  installed_other: aXt,
  verify_wallet: sXt,
  create_events_on: cXt,
  enterprise_license: lXt,
  enterprise_license_locally: dXt,
  enterprise_license_sales: uXt,
  missing_license: _Xt,
  next_steps: pXt,
  acquire_commercial_license: mXt,
  the_infrastructure_plan: fXt,
  prisma_studio_tip: gXt,
  prisma_studio_tip_description: hXt,
  contact_sales: vXt,
  error_404: bXt,
  default: "Default",
  set_to_default: yXt,
  new_schedule_btn: $Xt,
  add_new_schedule: wXt,
  add_new_calendar: kXt,
  set_calendar: SXt,
  delete_schedule: xXt,
  delete_schedule_description: EXt,
  schedule_created_successfully: TXt,
  availability_updated_successfully: AXt,
  schedule_deleted_successfully: CXt,
  default_schedule_name: zXt,
  new_schedule_heading: OXt,
  new_schedule_description: PXt,
  requires_ownership_of_a_token: IXt,
  example_name: RXt,
  time_format: NXt,
  "12_hour": "12 hour",
  "24_hour": "24 hour",
  "12_hour_short": "12h",
  "24_hour_short": "24h",
  redirect_success_booking: DXt,
  you_are_being_redirected: MXt,
  external_redirect_url: LXt,
  redirect_url_description: qXt,
  duplicate: jXt,
  offer_seats: FXt,
  offer_seats_description: VXt,
  seats_available_one: BXt,
  seats_available_other: UXt,
  seats_nearly_full: WXt,
  seats_half_full: GXt,
  number_of_seats: HXt,
  set_instant_meeting_expiry_time_offset_description: KXt,
  enter_number_of_seats: YXt,
  you_can_manage_your_schedules: ZXt,
  booking_full: QXt,
  api_keys: JXt,
  api_key: XXt,
  test_api_key: een,
  test_passed: ten,
  test_failed: nen,
  provide_api_key: oen,
  api_key_modal_subtitle: ren,
  api_key_modal_subtitle_platform: ien,
  api_keys_subtitle: aen,
  create_api_key: sen,
  personal_note: cen,
  personal_note_placeholder: len,
  api_key_no_note: den,
  api_key_never_expires: uen,
  edit_api_key: _en,
  success_api_key_created: pen,
  success_api_key_edited: men,
  create: fen,
  success_api_key_created_bold_tagline: gen,
  you_will_only_view_it_once: hen,
  copy_to_clipboard: ven,
  enabled_after_update: ben,
  enabled_after_update_description: yen,
  confirm_delete_api_key: $en,
  disable_rescheduling: wen,
  description_disable_rescheduling: ken,
  allow_rescheduling_cancelled_bookings: Sen,
  description_allow_rescheduling_cancelled_bookings: xen,
  disable_cancelling: Een,
  description_disable_cancelling: Ten,
  revoke_api_key: Aen,
  api_key_copied: Cen,
  api_key_expires_on: zen,
  delete_api_key_confirm_title: Oen,
  copy: Pen,
  expire_date: Ien,
  expired: Ren,
  never_expires: Nen,
  expires: Den,
  request_reschedule_booking: Men,
  reason_for_reschedule: Len,
  book_a_new_time: qen,
  reschedule_request_sent: jen,
  reschedule_modal_description: Fen,
  reason_for_reschedule_request: Ven,
  send_reschedule_request: Ben,
  edit_booking: Uen,
  reschedule_booking: Wen,
  former_time: Gen,
  confirmation_page_gif: Hen,
  search: Ken,
  impersonate: Yen,
  user_impersonation_heading: Zen,
  user_impersonation_description: Qen,
  team_impersonation_description: Jen,
  cal_signup_description: Xen,
  make_org_private: etn,
  make_org_private_description: ttn,
  make_team_private: ntn,
  make_team_private_description: otn,
  you_cannot_see_team_members: rtn,
  you_cannot_see_teams_of_org: itn,
  allow_multiple_durations: atn,
  impersonate_user_tip: stn,
  impersonating_user_warning: ctn,
  impersonating_stop_instructions: ltn,
  event_location_changed: dtn,
  new_guests_added: utn,
  location_changed_event_type_subject: _tn,
  guests_added_event_type_subject: ptn,
  current_location: mtn,
  new_location: ftn,
  session: gtn,
  session_description: htn,
  session_timeout_after: vtn,
  session_timeout: btn,
  session_timeout_description: ytn,
  no_location: $tn,
  set_location: wtn,
  update_location: ktn,
  location_updated: Stn,
  location_update_failed: xtn,
  guests_added: Etn,
  unable_to_add_guests: Ttn,
  email_validation_error: Atn,
  emails_must_be_unique_valid: Ctn,
  url_validation_error: ztn,
  place_where_cal_widget_appear: Otn,
  create_update_react_component: Ptn,
  copy_code: Itn,
  code_copied: Rtn,
  how_you_want_add_cal_site: Ntn,
  choose_ways_put_cal_site: Dtn,
  setting_up_zapier: Mtn,
  setting_up_make: Ltn,
  generate_api_key: qtn,
  generate_api_key_description: jtn,
  your_unique_api_key: Ftn,
  copy_safe_api_key: Vtn,
  zapier_setup_instructions: Btn,
  make_setup_instructions_1: Utn,
  make_setup_instructions_2: Wtn,
  make_setup_instructions_3: Gtn,
  make_setup_instructions_4: Htn,
  make_setup_instructions_5: Ktn,
  make_setup_instructions_6: Ytn,
  install_zapier_app: Ztn,
  install_make_app: Qtn,
  app_installation: Jtn,
  app_not_installed: Xtn,
  visit_our_app_store: enn,
  connect_apple_server: tnn,
  calendar_url: nnn,
  apple_server_generate_password: onn,
  unable_to_add_apple_calendar: rnn,
  credentials_stored_encrypted: inn,
  it_stored_encrypted: ann,
  go_to_app_store: snn,
  calendar_error: cnn,
  set_your_phone_number: lnn,
  calendar_no_busy_slots: dnn,
  display_location_label: unn,
  display_location_info_badge: _nn,
  add_gif: pnn,
  search_giphy: mnn,
  add_link_from_giphy: fnn,
  add_gif_to_confirmation: gnn,
  find_gif_spice_confirmation: hnn,
  share_feedback: vnn,
  resources: bnn,
  support_documentation: ynn,
  developer_documentation: $nn,
  get_in_touch: wnn,
  contact_support: knn,
  premium_support: Snn,
  community_support: xnn,
  feedback: Enn,
  submitted_feedback: Tnn,
  feedback_error: Ann,
  comments: Cnn,
  booking_details: znn,
  or_lowercase: Onn,
  nevermind: Pnn,
  go_to: Inn,
  zapier_invite_link: Rnn,
  meeting_url_provided_after_confirmed: Nnn,
  dynamically_display_attendee_or_organizer: Dnn,
  event_location: Mnn,
  reschedule_optional: Lnn,
  reschedule_placeholder: qnn,
  event_cancelled: jnn,
  emailed_information_about_cancelled_event: Fnn,
  this_input_will_shown_booking_this_event: Vnn,
  meeting_url_in_confirmation_email: Bnn,
  url_start_with_https: Unn,
  number_provided: Wnn,
  before_event_trigger: Gnn,
  event_cancelled_trigger: Hnn,
  after_hosts_cal_video_no_show: Knn,
  after_guests_cal_video_no_show: Ynn,
  join_video_call: Znn,
  sign_in_to_cal_com: Qnn,
  log_in_to_cal_com: Jnn,
  track_your_meetings: Xnn,
  track_meetings_and_manage_schedule: eon,
  failed_to_join_call: ton,
  choose_how_you_d_like_to_join_call: non,
  choose_how_you_d_like_to_appear_on_the_call: oon,
  new_event_trigger: ron,
  email_host_action: ion,
  email_attendee_action: aon,
  email_attendee_action_form: son,
  sms_attendee_action_form: con,
  sms_attendee_action: lon,
  sms_number_action: don,
  send_reminder_sms: uon,
  whatsapp_number_action: _on,
  whatsapp_attendee_action: pon,
  workflows: mon,
  new_workflow_btn: fon,
  how_would_you_like_to_start: gon,
  add_new_workflow: hon,
  reschedule_event_trigger: von,
  trigger: bon,
  triggers: yon,
  action: $on,
  workflows_to_automate_notifications: won,
  workflow_name: kon,
  custom_workflow: Son,
  workflow_created_successfully: xon,
  delete_workflow_description: Eon,
  delete_workflow: Ton,
  confirm_delete_workflow: Aon,
  workflow_deleted_successfully: Con,
  how_long_before: zon,
  day_timeUnit: Oon,
  hour_timeUnit: Pon,
  minute_timeUnit: Ion,
  minute_short: Ron,
  hour_short: Non,
  new_workflow_heading: Don,
  new_workflow_description: Mon,
  active_on: Lon,
  workflow_updated_successfully: qon,
  premium_to_standard_username_description: jon,
  premium_username: Fon,
  current: Von,
  premium: Bon,
  standard: Uon,
  confirm_username_change_dialog_title: Won,
  change_username_standard_to_premium: Gon,
  change_username_premium_to_standard: Hon,
  go_to_stripe_billing: Kon,
  stripe_description: Yon,
  trial_expired: Zon,
  remove_app: Qon,
  yes_remove_app: Jon,
  are_you_sure_you_want_to_remove_this_app: Xon,
  app_removed_successfully: ern,
  error_removing_app: trn,
  web_conference: nrn,
  web_call: orn,
  start_web_call: rrn,
  end_call: irn,
  test_your_agent_with_web_call: arn,
  phone_call: srn,
  connecting_to_agent: crn,
  call_active: lrn,
  call_ended: drn,
  call_error: urn,
  ready_to_start_call: _rn,
  failed_to_start_web_call_try_again: prn,
  call_encountered_error_try_again: mrn,
  failed_initialize_web_call_microphone_permissions: frn,
  start_call_to_see_conversation: grn,
  waiting_for_conversation: hrn,
  ai_agent: vrn,
  live: brn,
  connecting: yrn,
  requires_confirmation: $rn,
  requires_confirmation_threshold: wrn,
  may_require_confirmation: krn,
  nr_event_type_one: Srn,
  nr_event_type_other: xrn,
  nr_routing_form_one: Ern,
  nr_routing_form_other: Trn,
  count_team_one: Arn,
  count_team_other: Crn,
  add_action: zrn,
  set_whereby_link: Orn,
  invalid_whereby_link: Prn,
  set_around_link: Irn,
  invalid_around_link: Rrn,
  set_riverside_link: Nrn,
  invalid_riverside_link: Drn,
  invalid_ping_link: Mrn,
  add_exchange2013: Lrn,
  add_exchange2016: qrn,
  custom_template: jrn,
  email_body: Frn,
  text_message: Vrn,
  specific_issue: Brn,
  browse_our_docs: Urn,
  choose_template: Wrn,
  custom: Grn,
  reminder: Hrn,
  rescheduled: Krn,
  rescheduled_by: Yrn,
  original_booking: Zrn,
  completed: Qrn,
  rating: Jrn,
  reminder_email: Xrn,
  not_triggering_existing_bookings: ein,
  minute_one: tin,
  minute_one_short: nin,
  minute_other: oin,
  hour_one: rin,
  hour_one_short: iin,
  hour_other: ain,
  invalid_input: sin,
  broken_video_action: cin,
  broken_calendar_action: lin,
  attendee_name: din,
  scheduler_full_name: uin,
  broken_integration: _in,
  problem_adding_video_link: pin,
  problem_updating_calendar: min,
  active_on_event_types_one: fin,
  active_on_event_types_other: gin,
  active_on_teams_one: hin,
  active_on_teams_other: vin,
  active_on_all_event_types: bin,
  active_on_all_teams: yin,
  no_active_event_types: $in,
  no_active_teams: win,
  new_seat_subject: kin,
  new_seat_title: Sin,
  variable: xin,
  event_name_variable: Ein,
  attendee_name_variable: Tin,
  event_date_variable: Ain,
  event_time_variable: Cin,
  organizer_name_variable: zin,
  app_upgrade_description: Oin,
  invalid_number: Pin,
  invalid_url_error_message: Iin,
  navigate: Rin,
  open: Nin,
  close: Din,
  upgrade: Min,
  buy_us_number_button: Lin,
  upgrade_to_access_recordings_title: qin,
  upgrade_to_access_recordings_description: jin,
  upgrade_to_cal_ai_phone_number_description: Fin,
  recordings_are_part_of_the_teams_plan: Vin,
  team_feature_teams: Bin,
  team_feature_workflows: Uin,
  show_eventtype_on_profile: Win,
  embed: Gin,
  new_username: Hin,
  current_username: Kin,
  example_1: Yin,
  example_2: Zin,
  booking_question_identifier: Qin,
  company_size: Jin,
  what_help_needed: Xin,
  variable_format: ean,
  webhook_subscriber_url_reserved: tan,
  custom_input_as_variable_info: nan,
  using_booking_questions_as_variables: oan,
  download_desktop_app: ran,
  set_ping_link: ian,
  rate_limit_exceeded: aan,
  when_something_happens: san,
  action_is_performed: can,
  test_action: lan,
  notification_sent: dan,
  no_input: uan,
  test_workflow_action: _an,
  send_sms: pan,
  send_sms_to_number: man,
  missing_connected_calendar: fan,
  connect_your_calendar_and_link: gan,
  default_calendar_selected: han,
  hide_from_profile: van,
  basics: ban,
  availability_not_found_in_schedule_error: yan,
  event_limit_tab_title: $an,
  event_limit_tab_description: wan,
  event_advanced_tab_description: kan,
  event_advanced_tab_title: San,
  event_payments_tab_description: xan,
  event_setup_multiple_duration_error: Ean,
  event_setup_multiple_duration_default_error: Tan,
  event_setup_booking_limits_error: Aan,
  event_setup_duration_limits_error: Can,
  select_which_cal: zan,
  custom_event_name: Oan,
  custom_event_name_description: Pan,
  "2fa_required": "Two factor authentication required",
  incorrect_2fa: Ian,
  which_event_type_apply: Ran,
  which_routing_form_apply: Nan,
  apply_to_all_event_types: Dan,
  apply_to_all_routing_forms: Man,
  apply_to_all_teams: Lan,
  which_team_apply: qan,
  no_workflows_description: jan,
  timeformat_profile_hint: Fan,
  create_workflow: Van,
  do_this: Ban,
  turn_off: Uan,
  turn_on: Wan,
  cancelled_bookings_cannot_be_rescheduled: Gan,
  settings_updated_successfully: Han,
  error_updating_settings: Kan,
  personal_cal_url: Yan,
  bio_hint: Zan,
  finish_and_start: Qan,
  user_has_no_bio: Jan,
  bio: Xan,
  delete_account_modal_title: esn,
  confirm_delete_account_modal: tsn,
  delete_my_account: nsn,
  start_of_week: osn,
  recordings_title: rsn,
  recording: isn,
  happy_scheduling: asn,
  select_calendars: ssn,
  check_for_conflicts: csn,
  view_recordings: lsn,
  check_for_recordings: dsn,
  adding_events_to: usn,
  follow_system_preferences: _sn,
  custom_brand_colors: psn,
  customize_your_brand_colors: msn,
  pro: fsn,
  removes_cal_branding: gsn,
  instant_meeting_with_title: hsn,
  profile_picture: vsn,
  upload: bsn,
  add_profile_photo: ysn,
  token_address: $sn,
  blockchain: wsn,
  old_password: ksn,
  secure_password: Ssn,
  error_updating_password: xsn,
  two_factor_auth: Esn,
  recurring_event_tab_description: Tsn,
  today: Asn,
  appearance: Csn,
  my_account: zsn,
  general: Osn,
  calendars: Psn,
  "2fa_auth": "Two factor auth",
  invoices: Isn,
  embeds: Rsn,
  impersonation: Nsn,
  impersonation_description: Dsn,
  recent_impersonations: Msn,
  quick_impersonate: Lsn,
  no_recent_impersonations: qsn,
  users: jsn,
  user: Fsn,
  profile_description: Vsn,
  users_description: Bsn,
  users_listing: Usn,
  general_description: Wsn,
  calendars_description: Gsn,
  appearance_description: Hsn,
  conferencing_description: Ksn,
  add_conferencing_app: Ysn,
  password_description: Zsn,
  set_up_two_factor_authentication: Qsn,
  we_just_need_basic_info: Jsn,
  skip: Xsn,
  do_this_later: ecn,
  set_availability_getting_started_subtitle_1: tcn,
  set_availability_getting_started_subtitle_2: ncn,
  connect_calendar_first: ocn,
  complete_profile: rcn,
  complete_your_profile: icn,
  personal_profile_subtitle: acn,
  personal_settings_subtitle: scn,
  profile_photo: ccn,
  connect_calendar_to_prevent_conflicts: lcn,
  connect_video_app: dcn,
  video_app_connection_subtitle: ucn,
  welcome_to_cal_com: _cn,
  name_required: pcn,
  connected: mcn,
  connect_calendars_from_app_store: fcn,
  connect_conference_apps: gcn,
  connect_calendar_apps: hcn,
  connect_payment_apps: vcn,
  connect_automation_apps: bcn,
  connect_analytics_apps: ycn,
  connect_other_apps: $cn,
  connect_messaging_apps: wcn,
  connect_crm_apps: kcn,
  current_step_of_total: Scn,
  add_variable: xcn,
  custom_phone_number: Ecn,
  message_template: Tcn,
  email_subject: Acn,
  add_dynamic_variables: Ccn,
  event_name_info: zcn,
  event_date_info: Ocn,
  event_duration_info: Pcn,
  event_time_info: Icn,
  event_type_not_found: Rcn,
  number_to_call_variable: Ncn,
  number_to_call_info: Dcn,
  location_variable: Mcn,
  location_info: Lcn,
  additional_notes_variable: qcn,
  additional_notes_info: jcn,
  attendee_name_info: Fcn,
  organizer_name_info: Vcn,
  to: Bcn,
  workflow_turned_on_successfully: Ucn,
  download_responses: Wcn,
  download_responses_description: Gcn,
  view_responses: Hcn,
  download: Kcn,
  downloading: Ycn,
  download_recording: Zcn,
  transcription_enabled: Qcn,
  transcription_stopped: Jcn,
  download_transcript: Xcn,
  transcript: eln,
  recording_from_your_recent_call: tln,
  transcript_from_previous_call: nln,
  you_can_download_transcript_from_attachments: oln,
  link_valid_for_12_hrs: rln,
  link_valid_for_12_hrs_description: iln,
  create_your_first_form: aln,
  create_your_first_form_description: sln,
  create_your_first_webhook: cln,
  create_your_first_webhook_description: lln,
  for_a_maximum_of: dln,
  event_one: uln,
  event_other: _ln,
  profile_team_description: pln,
  profile_org_description: mln,
  members_team_description: fln,
  organization_description: gln,
  team_url: hln,
  team_members: vln,
  more: bln,
  cal_ai_workflows: yln,
  and_count_more: $ln,
  more_page_footer: wln,
  workflow_example_1: kln,
  workflow_example_2: Sln,
  workflow_example_3: xln,
  workflow_example_4: Eln,
  workflow_example_5: Tln,
  workflow_example_6: Aln,
  send_sms_reminder: Cln,
  send_sms_reminder_description: zln,
  follow_up_with_no_shows: Oln,
  follow_up_with_no_shows_description: Pln,
  remind_attendees_to_bring_id: Iln,
  remind_attendees_to_bring_id_description: Rln,
  email_to_remind_booking: Nln,
  email_to_remind_booking_description: Dln,
  custom_sms_reminder: Mln,
  custom_sms_reminder_description: Lln,
  custom_email_reminder: qln,
  custom_email_reminder_description: jln,
  count_managed_to_limit: Fln,
  welcome_to_cal_header: Vln,
  edit_form_later_subtitle: Bln,
  connect_calendar_later: Uln,
  problem_saving_user_profile: Wln,
  purchase_missing_seats: Gln,
  slot_length: Hln,
  booking_appearance: Kln,
  appearance_team_description: Yln,
  appearance_org_description: Zln,
  only_owner_change: Qln,
  team_disable_cal_branding_description: Jln,
  invited_by_team: Xln,
  token_invalid_expired: edn,
  view_booking: tdn,
  exchange_add: ndn,
  exchange_authentication: odn,
  exchange_authentication_standard: rdn,
  exchange_authentication_ntlm: idn,
  exchange_compression: adn,
  exchange_version: sdn,
  exchange_version_2007_SP1: cdn,
  exchange_version_2010: ldn,
  exchange_version_2010_SP1: ddn,
  exchange_version_2010_SP2: udn,
  exchange_version_2013: _dn,
  exchange_version_2013_SP1: pdn,
  exchange_version_2015: mdn,
  exchange_version_2016: fdn,
  routing: gdn,
  routing_forms_description: hdn,
  routing_forms_send_email_owner: vdn,
  routing_forms_send_email_owner_description: bdn,
  routing_forms_send_email_to: ydn,
  add_new_form: $dn,
  add_new_team_form: wdn,
  create_your_first_route: kdn,
  route_to_the_right_person: Sdn,
  form: xdn,
  form_description: Edn,
  copy_link_to_form: Tdn,
  theme: Adn,
  theme_applies_note: Cdn,
  app_theme: zdn,
  app_theme_applies_note: Odn,
  theme_system: Pdn,
  add_a_team: Idn,
  add_webhook_description: Rdn,
  triggers_when: Ndn,
  test_webhook: Ddn,
  enable_webhook: Mdn,
  add_webhook: Ldn,
  webhook_edited_successfully: qdn,
  api_keys_description: jdn,
  new_api_key: Fdn,
  active: Vdn,
  api_key_updated: Bdn,
  api_key_update_failed: Udn,
  embeds_title: Wdn,
  embeds_description: Gdn,
  create_first_api_key: Hdn,
  create_first_api_key_description: Kdn,
  back_to_signin: Ydn,
  reset_link_sent: Zdn,
  password_reset_email: Qdn,
  password_reset_leading: Jdn,
  password_updated: Xdn,
  pending_payment: eun,
  pending_invites: tun,
  pending_organization_invites: nun,
  not_on_cal: oun,
  no_calendar_installed: run,
  no_calendar_installed_description: iun,
  add_a_calendar: aun,
  change_email_hint: sun,
  confirm_password_change_email: cun,
  seats: lun,
  every_app_published: dun,
  report_app: uun,
  limit_booking_frequency: _un,
  limit_booking_frequency_description: pun,
  only_show_first_available_slot: mun,
  only_show_first_available_slot_description: fun,
  limit_total_booking_duration: gun,
  limit_total_booking_duration_description: hun,
  booker_upcoming_limit: vun,
  booker_booking_limit_description: bun,
  recurring_event_doesnt_support_booker_booking_limit: yun,
  add_limit: $un,
  team_name_required: wun,
  show_attendees: kun,
  show_available_seats_count: Sun,
  how_booking_questions_as_variables: xun,
  format: Eun,
  questions: Tun,
  all_info_your_booker_provide: Aun,
  uppercase_for_letters: Cun,
  replace_whitespaces_underscores: zun,
  platform_members: Oun,
  platform_members_description: Pun,
  platform_billing: Iun,
  manage_billing: Run,
  manage_billing_description: Nun,
  billing_freeplan_title: Dun,
  billing_freeplan_description: Mun,
  billing_freeplan_cta: Lun,
  billing_portal: qun,
  billing_help_cta: jun,
  ignore_special_characters_booking_questions: Fun,
  retry: Vun,
  fetching_calendars_error: Bun,
  calendar_connection_fail: Uun,
  booking_confirmation_success: Wun,
  booking_rejection_success: Gun,
  booking_tentative: Hun,
  booking_accept_intent: Kun,
  we_wont_show_again: Yun,
  couldnt_update_timezone: Zun,
  updated_timezone_to: Qun,
  update_timezone: Jun,
  update_timezone_question: Xun,
  update_timezone_description: e_n,
  dont_update: t_n,
  require_additional_notes: n_n,
  require_additional_notes_description: o_n,
  email_address_action: r_n,
  after_event_trigger: i_n,
  booking_rejected_trigger: a_n,
  booking_requested_trigger: s_n,
  booking_payment_initiated_trigger: c_n,
  booking_paid_trigger: l_n,
  booking_no_show_updated_trigger: d_n,
  how_long_after: u_n,
  how_long_after_hosts_no_show: __n,
  how_long_after_guests_no_show: p_n,
  how_long_after_user_no_show_minutes: m_n,
  no_available_slots: f_n,
  time_available: g_n,
  cant_find_the_right_conferencing_app_visit_our_app_store: h_n,
  install_new_calendar_app: v_n,
  make_phone_number_required: b_n,
  new_event_type_availability: y_n,
  error_editing_availability: $_n,
  dont_have_permission: w_n,
  saml_configuration_placeholder: k_n,
  saml_email_required: S_n,
  saml_sp_title: x_n,
  saml_sp_description: E_n,
  saml_sp_acs_url: T_n,
  saml_sp_entity_id: A_n,
  saml_sp_acs_url_copied: C_n,
  saml_sp_entity_id_copied: z_n,
  add_calendar: O_n,
  limit_future_bookings: P_n,
  limit_future_bookings_description: I_n,
  no_event_types: R_n,
  no_event_types_description: N_n,
  billing_frequency: D_n,
  monthly: M_n,
  yearly: L_n,
  checkout: q_n,
  your_team_disbanded_successfully: j_n,
  your_org_disbanded_successfully: F_n,
  error_creating_team: V_n,
  you: B_n,
  or_continue_with: U_n,
  resend_email: W_n,
  member_already_invited: G_n,
  already_in_use_error: H_n,
  enter_email_or_username: K_n,
  enter_email: Y_n,
  enter_emails: Z_n,
  too_many_invites: Q_n,
  team_name_taken: J_n,
  must_enter_team_name: X_n,
  team_url_required: epn,
  url_taken: tpn,
  problem_registering_domain: npn,
  team_publish: opn,
  number_text_notifications: rpn,
  number_sms_notifications: ipn,
  attendee_email_variable: apn,
  attendee_email_info: spn,
  booking_uid: cpn,
  kbar_search_placeholder: lpn,
  invalid_credential: dpn,
  invalid_credential_action: upn,
  reschedule_reason: _pn,
  choose_common_schedule_team_event: ppn,
  choose_common_schedule_team_event_description: mpn,
  reason: fpn,
  sender_id: gpn,
  sender_id_error_message: hpn,
  test_routing_form: vpn,
  test_preview: bpn,
  route_to: ypn,
  test_preview_description: $pn,
  test_routing: wpn,
  payment_app_disabled: kpn,
  edit_event_type: Spn,
  only_admin_can_see_members_of_org: xpn,
  only_admin_can_manage_sso_org: Epn,
  only_admin_can_manage_directory_sync: Tpn,
  only_admin_can_manage_oauth_clients: Apn,
  collective_scheduling: Cpn,
  make_it_easy_to_book: zpn,
  find_the_best_person: Opn,
  fixed_round_robin: Ppn,
  add_one_fixed_attendee: Ipn,
  calcom_is_better_with_team: Rpn,
  the_calcom_team: Npn,
  add_your_team_members: Dpn,
  booking_limit_reached: Mpn,
  duration_limit_reached: Lpn,
  admin_has_disabled: qpn,
  disable_attendees_emails_description: jpn,
  disabled_app_affects_event_type: Fpn,
  event_replaced_notice: Vpn,
  email_subject_slug_replacement: Bpn,
  email_body_slug_replacement_notice: Upn,
  email_body_slug_replacement_info: Wpn,
  email_body_slug_replacement_suggestion: Gpn,
  disable_payment_app: Hpn,
  payment_disabled_still_able_to_book: Kpn,
  app_disabled_with_event_type: Ypn,
  app_disabled_video: Zpn,
  app_disabled_subject: Qpn,
  navigate_installed_apps: Jpn,
  disabled_calendar: Xpn,
  enable_apps: emn,
  enable_apps_description: tmn,
  purchase_license: nmn,
  already_have_account: omn,
  already_have_key: rmn,
  already_have_key_suggestion: imn,
  create_license_key: amn,
  app_is_enabled: smn,
  app_is_disabled: cmn,
  keys_have_been_saved: lmn,
  disable_app: dmn,
  disable_app_description: umn,
  edit_keys: _mn,
  admin_apps_description: pmn,
  admin_users_description: mmn,
  admin_users_add_description: fmn,
  admin_users_edit_description: gmn,
  admin_orgs_edit_description: hmn,
  admin_oAuth_description: vmn,
  admin_lockedSMS_description: bmn,
  no_available_apps: ymn,
  no_available_apps_description: $mn,
  no_apps: wmn,
  no_apps_configured: kmn,
  enable_in_settings: Smn,
  please_contact_admin: xmn,
  apps_settings: Emn,
  fill_this_field: Tmn,
  options: Amn,
  enter_option: Cmn,
  add_an_option: zmn,
  location_already_exists: Omn,
  radio: Pmn,
  google_meet_warning: Imn,
  individual: Rmn,
  all_bookings_filter_label: Nmn,
  all_users_filter_label: Dmn,
  all_event_types_filter_label: Mmn,
  your_bookings_filter_label: Lmn,
  meeting_url_variable: qmn,
  meeting_url_info: jmn,
  date_overrides: Fmn,
  date_overrides_delete_on_date: Vmn,
  date_overrides_subtitle: Bmn,
  date_overrides_info: Umn,
  date_overrides_dialog_which_hours: Wmn,
  date_overrides_dialog_which_hours_unavailable: Gmn,
  date_overrides_dialog_title: Hmn,
  date_overrides_unavailable: Kmn,
  date_overrides_mark_all_day_unavailable_one: Ymn,
  date_overrides_mark_all_day_unavailable_other: Zmn,
  date_overrides_update_btn: Qmn,
  date_successfully_added: Jmn,
  date_overrides_save_btn: Xmn,
  event_type_duplicate_copy_text: efn,
  set_as_default: tfn,
  hide_eventtype_details: nfn,
  show_navigation: ofn,
  hide_navigation: rfn,
  verification_code_sent: ifn,
  verified_successfully: afn,
  wrong_code: sfn,
  not_verified: cfn,
  no_availability_in_month: lfn,
  no_availability_rolling: dfn,
  no_availability_range: ufn,
  view_previous_month: _fn,
  view_next_month: pfn,
  send_code: mfn,
  number_verified: ffn,
  create_your_first_team_webhook_description: gfn,
  create_webhook_team_event_type: hfn,
  disable_success_page: vfn,
  invalid_admin_password: bfn,
  change_password_admin: yfn,
  username_already_taken: $fn,
  assignment: wfn,
  fixed_hosts: kfn,
  add_fixed_hosts: Sfn,
  round_robin_hosts: xfn,
  minimum_round_robin_hosts_count: Efn,
  hosts: Tfn,
  upgrade_to_enable_feature: Afn,
  orgs_upgrade_to_enable_feature: Cfn,
  new_attendee: zfn,
  awaiting_approval: Ofn,
  requires_google_calendar: Pfn,
  event_type_requires_google_calendar: Ifn,
  connected_google_calendar: Rfn,
  using_meet_requires_calendar: Nfn,
  continue_to_install_google_calendar: Dfn,
  install_google_meet: Mfn,
  install_google_calendar: Lfn,
  sender_name: qfn,
  already_invited: jfn,
  no_recordings_found: Ffn,
  new_workflow_subtitle: Vfn,
  reporting: Bfn,
  reporting_feature: Ufn,
  teams_plan_required: Wfn,
  routing_forms_are_a_great_way: Gfn,
  choose_a_license: Hfn,
  choose_license_description: Kfn,
  license: Yfn,
  agplv3_license: Zfn,
  no_need_to_keep_your_code_open_source: Qfn,
  repackage_rebrand_resell: Jfn,
  a_vast_suite_of_enterprise_features: Xfn,
  free_license_fee: egn,
  forever_open_and_free: tgn,
  required_to_keep_your_code_open_source: ngn,
  cannot_repackage_and_resell: ogn,
  no_enterprise_features: rgn,
  step_enterprise_license: ign,
  step_enterprise_license_description: agn,
  setup: sgn,
  setup_description: cgn,
  configure: lgn,
  sso_configuration: dgn,
  sso_configuration_description: ugn,
  sso_configuration_description_orgs: _gn,
  sso_oidc_heading: pgn,
  sso_oidc_description: mgn,
  sso_oidc_configuration_title: fgn,
  sso_oidc_configuration_description: ggn,
  sso_oidc_callback_copied: hgn,
  sso_saml_heading: vgn,
  sso_saml_description: bgn,
  sso_saml_configuration_title: ygn,
  sso_saml_configuration_description: $gn,
  sso_saml_acsurl_copied: wgn,
  sso_saml_entityid_copied: kgn,
  sso_connection_created_successfully: Sgn,
  sso_connection_deleted_successfully: xgn,
  delete_sso_configuration: Egn,
  delete_sso_configuration_confirmation: Tgn,
  delete_sso_configuration_confirmation_description: Agn,
  organizer_timezone: Cgn,
  email_user_cta: zgn,
  accept_invite: Ogn,
  join_now: Pgn,
  successfully_joined: Ign,
  email_no_user_invite_heading_subteam: Rgn,
  email_no_user_invite_heading_org: Ngn,
  email_no_user_invite_subheading: Dgn,
  email_user_invite_subheading_subteam: Mgn,
  email_user_invite_subheading_org: Lgn,
  email_no_user_invite_steps_intro: qgn,
  email_no_user_step_one: jgn,
  email_no_user_step_two: Fgn,
  email_no_user_step_three: Vgn,
  email_no_user_step_four: Bgn,
  email_no_user_signoff: Ugn,
  impersonation_user_tip: Wgn,
  available_variables: Ggn,
  scheduler: Hgn,
  no_workflows: Kgn,
  change_filter: Ygn,
  change_filter_common: Zgn,
  no_results_for_filter: Qgn,
  recommended_next_steps: Jgn,
  create_a_managed_event: Xgn,
  meetings_are_better_with_the_right: ehn,
  create_a_one_one_template: thn,
  collective_or_roundrobin: nhn,
  book_your_team_members: ohn,
  event_no_longer_attending_subject: rhn,
  no_longer_attending: ihn,
  attendee_no_longer_attending_subject: ahn,
  attendee_no_longer_attending: shn,
  attendee_no_longer_attending_subtitle: chn,
  create_event_on: lhn,
  create_routing_form_on: dhn,
  default_app_link_title: uhn,
  default_app_link_description: _hn,
  organizer_default_conferencing_app: phn,
  organizer_default_conferencing_app_not_found: mhn,
  under_maintenance: fhn,
  under_maintenance_description: ghn,
  event_type_seats: hhn,
  booking_questions_title: vhn,
  booking_questions_description: bhn,
  add_a_booking_question: yhn,
  identifier: $hn,
  duplicate_email: whn,
  enter_redirect_url_on_exit_description: khn,
  booking_with_payment_cancelled: Shn,
  booking_with_payment_cancelled_already_paid: xhn,
  booking_with_payment_cancelled_refunded: Ehn,
  booking_with_payment_cancelled_no_refund: Thn,
  booking_with_payment_cancelled_refund_window_expired: Ahn,
  booking_confirmation_failed: Chn,
  not_enough_seats: zhn,
  form_builder_field_already_exists: Ohn,
  guests_field_must_be_multiemail: Phn,
  show_on_booking_page: Ihn,
  visit_cancelled_booking: Rhn,
  get_started_zapier_templates: Nhn,
  standard_templates: Dhn,
  cal_ai_templates: Mhn,
  team_is_unpublished: Lhn,
  org_is_unpublished_description: qhn,
  team_is_unpublished_description: jhn,
  team_member: Fhn,
  a_routing_form: Vhn,
  form_description_placeholder: Bhn,
  keep_me_connected_with_form: Uhn,
  fields_in_form_duplicated: Whn,
  form_deleted: Ghn,
  delete_form: Hhn,
  delete_form_action: Khn,
  delete_form_confirmation: Yhn,
  delete_form_confirmation_2: Zhn,
  typeform_redirect_url_copied: Qhn,
  modifications_in_fields_warning: Jhn,
  connected_forms: Xhn,
  form_modifications_warning: evn,
  responses_collection_waiting_description: tvn,
  this_is_what_your_users_would_see: nvn,
  identifies_name_field: ovn,
  add_1_option_per_line: rvn,
  select_a_router: ivn,
  add_a_new_route: avn,
  make_informed_decisions: svn,
  make_informed_decisions_description: cvn,
  view_bookings_across: lvn,
  view_bookings_across_description: dvn,
  identify_booking_trends: uvn,
  identify_booking_trends_description: _vn,
  spot_popular_event_types: pvn,
  spot_popular_event_types_description: mvn,
  no_responses_yet: fvn,
  no_routes_defined: gvn,
  this_will_be_the_placeholder: hvn,
  error_booking_event: vvn,
  timeslot_missing_title: bvn,
  timeslot_missing_description: yvn,
  timeslot_missing_cta: $vn,
  switch_monthly: wvn,
  switch_weekly: kvn,
  switch_multiday: Svn,
  switch_columnview: xvn,
  num_locations: Evn,
  select_on_next_step: Tvn,
  this_meeting_has_not_started_yet: Avn,
  this_app_requires_connected_account: Cvn,
  connect_app: zvn,
  app_is_connected: Ovn,
  requires_app: Pvn,
  verification_code: Ivn,
  can_you_try_again: Rvn,
  verify: Nvn,
  timezone_info: Dvn,
  timezone_variable: Mvn,
  event_end_time_variable: Lvn,
  event_end_time_info: qvn,
  cancel_url_variable: jvn,
  cancel_url_info: Fvn,
  cancel_reason_variable: Vvn,
  cancel_reason_info: Bvn,
  reschedule_url_variable: Uvn,
  reschedule_url_info: Wvn,
  reschedule_reason_variable: Gvn,
  reschedule_reason_info: Hvn,
  invalid_event_name_variables: Kvn,
  select_all: Yvn,
  default_conferencing_bulk_title: Zvn,
  members_default_schedule: Qvn,
  set_by_admin: Jvn,
  members_default_location: Xvn,
  members_default_schedule_description: ebn,
  requires_at_least_one_schedule: tbn,
  default_conferencing_bulk_description: nbn,
  default_schedules_bulk_description: obn,
  locked_for_members: rbn,
  unlocked_for_members: ibn,
  apps_locked_for_members_description: abn,
  apps_unlocked_for_members_description: sbn,
  apps_locked_by_team_admins_description: cbn,
  apps_unlocked_by_team_admins_description: lbn,
  workflows_locked_for_members_description: dbn,
  workflows_unlocked_for_members_description: ubn,
  workflows_locked_by_team_admins_description: _bn,
  workflows_unlocked_by_team_admins_description: pbn,
  webhooks_locked_for_members_description: mbn,
  webhooks_unlocked_for_members_description: fbn,
  webhooks_locked_by_team_admins_description: gbn,
  webhooks_unlocked_by_team_admins_description: hbn,
  locked_by_team_admin: vbn,
  app_not_connected: bbn,
  connect_now: ybn,
  managed_event_dialog_confirm_button_one: $bn,
  managed_event_dialog_confirm_button_other: wbn,
  managed_event_dialog_title_one: kbn,
  managed_event_dialog_title_other: Sbn,
  managed_event_dialog_information_one: xbn,
  managed_event_dialog_information_other: Ebn,
  managed_event_dialog_clarification: Tbn,
  review_event_type: Abn,
  looking_for_more_analytics: Cbn,
  looking_for_more_insights: zbn,
  filters: Obn,
  filter: Pbn,
  add_a_member: Ibn,
  add_filter: Rbn,
  add_rule: Nbn,
  add_rule_group: Dbn,
  remove_filters: Mbn,
  email_verified: Lbn,
  select_user: qbn,
  select_event_type: jbn,
  select_date_range: Fbn,
  popular_events: Vbn,
  no_event_types_found: Bbn,
  average_event_duration: Ubn,
  bookings_by_hour: Wbn,
  most_booked_members: Gbn,
  least_booked_members: Hbn,
  most_bookings_scheduled: Kbn,
  least_bookings_scheduled: Ybn,
  most_bookings_completed: Zbn,
  least_bookings_completed: Qbn,
  events_created: Jbn,
  events_completed: Xbn,
  events_cancelled: eyn,
  events_rescheduled: tyn,
  events: nyn,
  performance: oyn,
  from_last_period: ryn,
  from_to_date_period: iyn,
  redirect_url_warning: ayn,
  event_trends: syn,
  clear_filters: cyn,
  clear: lyn,
  hold: dyn,
  on_booking_option: uyn,
  hold_option: _yn,
  card_held: pyn,
  charge_card: myn,
  card_charged: fyn,
  no_show_fee_amount: gyn,
  no_show_fee: hyn,
  submit_card: vyn,
  submit_payment_information: byn,
  meeting_awaiting_payment_method: yyn,
  no_show_fee_charged_email_subject: $yn,
  no_show_fee_charged_text_body: wyn,
  no_show_fee_charged_subtitle: kyn,
  error_charging_card: Syn,
  collect_no_show_fee: xyn,
  no_show_fee_charged: Eyn,
  your_card_was_declined: Tyn,
  your_card_does_not_support_this_type_of_purchase: Ayn,
  amount_must_convert_to_at_least: Cyn,
  could_not_charge_card: zyn,
  insights: Oyn,
  routing_forms: Pyn,
  insights_no_data_found_for_filter: Iyn,
  no_show_hosts_over_time: Ryn,
  csat_over_time: Nyn,
  no_show_hosts: Dyn,
  csat: Myn,
  acknowledge_booking_no_show_fee: Lyn,
  days: qyn,
  card_details: jyn,
  something_went_wrong_on_our_end: Fyn,
  please_provide_following_text_to_suppport: Vyn,
  seats_and_no_show_fee_error: Byn,
  complete_your_booking: Uyn,
  complete_your_booking_subject: Wyn,
  confirm_your_details: Gyn,
  copy_invite_link: Hyn,
  edit_invite_link: Kyn,
  invite_link_copied: Yyn,
  invite_link_deleted: Zyn,
  api_key_deleted: Qyn,
  delete_api_key_warning: Jyn,
  invite_link_updated: Xyn,
  link_expires_after: e$n,
  one_day: t$n,
  seven_days: n$n,
  thirty_days: o$n,
  three_months: r$n,
  one_year: i$n,
  team_invite_received: a$n,
  currency_string: s$n,
  charge_card_dialog_body: c$n,
  charge_attendee: l$n,
  payment_app_commission: d$n,
  email_invite_team: u$n,
  email_invite_team_bulk: _$n,
  error_collecting_card: p$n,
  image_size_limit_exceed: m$n,
  unauthorized_workflow_error_message: f$n,
  inline_embed: g$n,
  load_inline_content: h$n,
  floating_pop_up_button: v$n,
  floating_button_trigger_modal: b$n,
  pop_up_element_click: y$n,
  open_dialog_with_element_click: $$n,
  use_my_own_form: w$n,
  use_our_headless_routing_api: k$n,
  need_help_embedding: S$n,
  book_my_cal: x$n,
  first_name: E$n,
  last_name: T$n,
  first_last_name: A$n,
  invite_as: C$n,
  form_updated_successfully: z$n,
  disable_attendees_confirmation_emails: O$n,
  disable_attendees_confirmation_emails_description: P$n,
  disable_host_confirmation_emails: I$n,
  disable_host_confirmation_emails_description: R$n,
  add_an_override: N$n,
  import_from_google_workspace: D$n,
  connect_google_workspace: M$n,
  google_workspace_admin_tooltip: L$n,
  first_event_type_webhook_description: q$n,
  create_instant_meeting_webhook_description: j$n,
  install_app_on: F$n,
  create_for: V$n,
  currency: B$n,
  organization_banner_description: U$n,
  organization_banner_title: W$n,
  set_up_your_organization: G$n,
  set_up_your_platform_organization: H$n,
  organizations_description: K$n,
  plans: Y$n,
  platform: Z$n,
  platform_description: Q$n,
  platform_organization_description: J$n,
  must_enter_organization_name: X$n,
  must_enter_organization_admin_email: ewn,
  admin_email: twn,
  platform_admin_email: nwn,
  admin_username: own,
  organization_name: rwn,
  platform_name: iwn,
  organization_url: awn,
  organization_verify_header: swn,
  organization_verify_email_body: cwn,
  additional_url_parameters: lwn,
  about_your_organization: dwn,
  about_your_organization_description: uwn,
  create_your_teams: _wn,
  create_your_teams_description: pwn,
  invite_organization_admins: mwn,
  invite_organization_admins_description: fwn,
  set_a_password: gwn,
  set_a_password_description: hwn,
  organization_logo: vwn,
  organization_about_description: bwn,
  ill_do_this_later: ywn,
  verify_your_email: $wn,
  enter_digit_code: wwn,
  verify_email_organization: kwn,
  code_provided_invalid: Swn,
  email_already_used: xwn,
  organization_admin_invited_heading: Ewn,
  organization_admin_invited_body: Twn,
  duplicated_slugs_warning: Awn,
  team_names_empty: Cwn,
  team_names_repeated: zwn,
  user_belongs_organization: Own,
  org_no_teams_yet: Pwn,
  org_no_teams_yet_description: Iwn,
  set_up: Rwn,
  my_profile: Nwn,
  my_settings: Dwn,
  crm: Mwn,
  messaging: Lwn,
  sender_id_info: qwn,
  org_admins_can_create_new_teams: jwn,
  google_new_spam_policy: Fwn,
  resolve: Vwn,
  no_organization_slug: Bwn,
  copy_link_org: Uwn,
  "404_the_org": "The organization",
  "404_the_team": "The team",
  "404_claim_entity_org": "Claim your subdomain for your organization",
  "404_claim_entity_team": "Claim this team and start managing schedules collectively",
  insights_team_filter: Wwn,
  insights_user_filter: Gwn,
  insights_subtitle: Hwn,
  call_history: Kwn,
  call_history_subtitle: Ywn,
  location_options: Zwn,
  channel_type: Qwn,
  end_reason: Jwn,
  session_status: Xwn,
  user_sentiment: e0n,
  time_header: t0n,
  from_header: n0n,
  custom_plan: o0n,
  email_embed: r0n,
  add_times_to_your_email: i0n,
  select_time: a0n,
  select_date: s0n,
  only_show_if_parameter_set: c0n,
  add_parameter: l0n,
  connecting_you_to_someone: d0n,
  please_do_not_close_this_tab: u0n,
  see_all_available_times: _0n,
  org_team_names_example_1: p0n,
  org_team_names_example_2: m0n,
  org_team_names_example_3: f0n,
  org_team_names_example_4: g0n,
  org_team_names_example_5: h0n,
  org_max_team_warnings: v0n,
  what_is_this_meeting_about: b0n,
  add_to_team: y0n,
  remove_users_from_org: $0n,
  delegation_credential: w0n,
  delegation_credential_description: k0n,
  add_client_id_in_google_workspace_with_below_scope: S0n,
  delegation_credential_enabled: x0n,
  add_delegation_credential: E0n,
  edit_delegation_credential: T0n,
  domain: A0n,
  no_workspace_platforms: C0n,
  workspace_platform: z0n,
  workspace_platforms: O0n,
  workspace_platforms_description: P0n,
  edit_workspace_platform: I0n,
  edit_service_account: R0n,
  add_workspace_platform: N0n,
  slug: D0n,
  service_account_key: M0n,
  edit_service_account_key: L0n,
  delegation_credential_restricts_adding_more_than_one_installation: q0n,
  app_successfully_installed_and_is_using_delegated_credentials: j0n,
  remove_users_from_org_confirm: F0n,
  remove_users_from_team: V0n,
  remove_users_from_team_confirm: B0n,
  user_has_no_schedules: U0n,
  user_isnt_in_any_teams: W0n,
  user_has_no_app_installed: G0n,
  requires_booker_email_verification: H0n,
  description_requires_booker_email_verification: K0n,
  requires_confirmation_mandatory: Y0n,
  organizations: Z0n,
  upload_cal_video_logo: Q0n,
  update_cal_video_logo: J0n,
  upload_banner: X0n,
  cal_video_logo_upload_instruction: ekn,
  org_admin_other_teams: tkn,
  org_admin_other_teams_description: nkn,
  not_part_of_org: okn,
  no_other_teams_found: rkn,
  no_other_teams_found_description: ikn,
  attendee_first_name_variable: akn,
  attendee_last_name_variable: skn,
  attendee_first_name_info: ckn,
  attendee_last_name_info: lkn,
  your_monthly_digest: dkn,
  member_name: ukn,
  most_popular_events: _kn,
  summary_of_events_for_your_team_for_the_last_30_days: pkn,
  me: mkn,
  meeting_unavailable: fkn,
  monthly_digest_email: gkn,
  monthly_digest_email_for_teams: hkn,
  verify_team_tooltip: vkn,
  member_removed: bkn,
  my_availability: ykn,
  team_availability: $kn,
  instant_meeting_availability: wkn,
  backup_code: kkn,
  backup_codes: Skn,
  backup_code_instructions: xkn,
  backup_codes_copied: Ekn,
  incorrect_backup_code: Tkn,
  lost_access: Akn,
  missing_backup_codes: Ckn,
  admin_org_notification_email_subject: zkn,
  hi_admin: Okn,
  admin_org_notification_email_title: Pkn,
  admin_org_notification_email_body_part1: Ikn,
  admin_org_notification_email_body_part2: Rkn,
  admin_org_notification_email_body_part3: Nkn,
  admin_org_notification_email_cta: Dkn,
  org_has_been_processed: Mkn,
  org_error_processing: Lkn,
  orgs_page_description: qkn,
  unverified: jkn,
  verified: Fkn,
  dns_missing: Vkn,
  dns_configured: Bkn,
  mark_dns_configured: Ukn,
  value: Wkn,
  your_organization_updated_sucessfully: Gkn,
  team_no_event_types: Hkn,
  seat_options_doesnt_multiple_durations: Kkn,
  include_calendar_event: Ykn,
  oAuth: Zkn,
  oAuth_client_creation_form: Qkn,
  oAuth_client_creation_form_description: Jkn,
  oAuth_client_updation_form: Xkn,
  oAuth_client_updation_form_description: e1n,
  recently_added: t1n,
  connect_all_calendars: n1n,
  connect_all_calendars_description: o1n,
  workflow_automation_description: r1n,
  scheduling_for_your_team: i1n,
  scheduling_for_your_team_description: a1n,
  no_members_found: s1n,
  directory_sync: c1n,
  directory_name: l1n,
  directory_provider: d1n,
  directory_scim_url: u1n,
  directory_scim_token: _1n,
  directory_scim_url_copied: p1n,
  directory_scim_token_copied: m1n,
  directory_sync_info_description: f1n,
  directory_sync_configure: g1n,
  directory_sync_configure_description: h1n,
  directory_sync_title: v1n,
  directory_sync_created: b1n,
  directory_sync_description: y1n,
  directory_sync_deleted: $1n,
  directory_sync_delete_connection: w1n,
  directory_sync_delete_title: k1n,
  directory_sync_delete_description: S1n,
  directory_sync_delete_confirmation: x1n,
  event_setup_length_error: E1n,
  availability_schedules: T1n,
  unauthorized: A1n,
  access_cal_account: C1n,
  select_account_team: z1n,
  allow_client_to: O1n,
  associate_with_cal_account: P1n,
  see_personal_info: I1n,
  see_primary_email_address: R1n,
  connect_installed_apps: N1n,
  access_event_type: D1n,
  access_availability: M1n,
  access_bookings: L1n,
  allow_client_to_do: q1n,
  oauth_access_information: j1n,
  allow: F1n,
  view_only_edit_availability_not_onboarded: V1n,
  view_only_edit_availability: B1n,
  you_can_override_calendar_in_advanced_tab: U1n,
  edit_users_availability: W1n,
  resend_invitation: G1n,
  invitation_resent: H1n,
  saml_sso: K1n,
  add_client: Y1n,
  copy_client_secret_info: Z1n,
  add_new_client: Q1n,
  add_new_user: J1n,
  this_app_is_not_setup_already: X1n,
  as_csv: e2n,
  overlay_my_calendar: t2n,
  overlay_my_calendar_toc: n2n,
  view_overlay_calendar_events: o2n,
  join_event_location: r2n,
  troubleshooting: i2n,
  calendars_were_checking_for_conflicts: a2n,
  availabilty_schedules: s2n,
  manage_calendars: c2n,
  manage_availability_schedules: l2n,
  locked: d2n,
  unlocked: u2n,
  lock_timezone_toggle_on_booking_page: _2n,
  description_lock_timezone_toggle_on_booking_page: p2n,
  event_setup_multiple_payment_apps_error: m2n,
  number_in_international_format: f2n,
  install_calendar: g2n,
  branded_subdomain: h2n,
  branded_subdomain_description: v2n,
  org_insights: b2n,
  org_insights_description: y2n,
  extensive_whitelabeling: $2n,
  extensive_whitelabeling_description: w2n,
  unlimited_teams: k2n,
  verify_email: S2n,
  proceed_with_cancellation_description: x2n,
  proceed_with_cancellation_error: E2n,
  unlimited_teams_description: T2n,
  unified_billing: A2n,
  advanced_managed_events: C2n,
  advanced_managed_events_description: z2n,
  enterprise: O2n,
  enterprise_description: P2n,
  create_your_org: I2n,
  create_org: R2n,
  create_your_org_description: N2n,
  create_your_enterprise_description: D2n,
  other_payment_app_enabled: M2n,
  admin_delete_organization_description_1: L2n,
  admin_delete_organization_description_2: q2n,
  admin_delete_organization_description_3: j2n,
  admin_delete_organization_description_4: F2n,
  admin_delete_organization_title: V2n,
  published: B2n,
  unpublished: U2n,
  publish: W2n,
  troubleshooter_tooltip: G2n,
  need_help: H2n,
  troubleshooter: K2n,
  number_to_call: Y2n,
  guest_name: Z2n,
  guest_email: Q2n,
  guest_company: J2n,
  please_install_a_calendar: X2n,
  instant_tab_title: eSn,
  instant_event_tab_description: tSn,
  uprade_to_create_instant_bookings: nSn,
  dont_want_to_wait: oSn,
  meeting_started: rSn,
  pay_and_book: iSn,
  cal_ai_event_tab_description: aSn,
  booking_not_found_error: sSn,
  booking_seats_full_error: cSn,
  missing_payment_credential_error: lSn,
  missing_payment_app_id_error: dSn,
  not_enough_available_seats_error: uSn,
  user_redirect_title: _Sn,
  user_redirect_description: pSn,
  out_of_office: mSn,
  out_of_office_description: fSn,
  send_request: gSn,
  start_date_and_end_date_required: hSn,
  start_date_must_be_before_end_date: vSn,
  start_date_must_be_in_the_future: bSn,
  user_not_found: ySn,
  cannot_redirect_to_self: $Sn,
  out_of_office_entry_already_exists: wSn,
  out_of_office_id_required: kSn,
  booking_redirect_infinite_not_allowed: SSn,
  success_entry_created: xSn,
  booking_redirect_email_subject: ESn,
  booking_redirect_email_title: TSn,
  booking_redirect_email_description: ASn,
  booking_redirect_updated_email_subject: CSn,
  booking_redirect_updated_email_title: zSn,
  booking_redirect_updated_email_description: OSn,
  booking_redirect_cancelled_email_subject: PSn,
  booking_redirect_cancelled_email_title: ISn,
  booking_redirect_cancelled_email_description: RSn,
  success_accept_booking_redirect: NSn,
  success_reject_booking_redirect: DSn,
  copy_link_booking_redirect_request: MSn,
  booking_redirect_request_title: LSn,
  select_team_member: qSn,
  going_away_title: jSn,
  redirect_team_enabled: FSn,
  redirect_team_disabled: VSn,
  out_of_office_unavailable_list: BSn,
  success_deleted_entry_out_of_office: USn,
  success_edited_entry_out_of_office: WSn,
  temporarily_out_of_office: GSn,
  add_a_redirect: HSn,
  create_entry: KSn,
  time_range: YSn,
  automatically_add_all_team_members: ZSn,
  redirect_to: QSn,
  having_trouble_finding_time: JSn,
  show_more: XSn,
  forward_params_redirect: exn,
  assignment_description: txn,
  lowest: nxn,
  low: oxn,
  medium: rxn,
  high: ixn,
  Highest: axn,
  send_booker_to: sxn,
  set_priority: cxn,
  set_weight: lxn,
  enable_weights: dxn,
  priority_for_user: uxn,
  weights_description: _xn,
  weight_for_user: pxn,
  change_priority: mxn,
  field_identifiers_as_variables: fxn,
  field_identifiers_as_variables_with_example: gxn,
  account_already_linked: hxn,
  send_email: vxn,
  cal_ai_phone_call_action: bxn,
  call_to_confirm_booking: yxn,
  cal_ai_phone_call_action_description: $xn,
  cal_ai_agent_configuration: wxn,
  choose_at_least_one_event_type_test_call: kxn,
  mark_as_no_show: Sxn,
  unmark_as_no_show: xxn,
  account_unlinked_success: Exn,
  account_unlinked_error: Txn,
  travel_schedule: Axn,
  travel_schedule_description: Cxn,
  schedule_timezone_change: zxn,
  date: Oxn,
  enter_the_general_prompt_for_the_agent: Pxn,
  overlaps_with_existing_schedule: Ixn,
  "org_admin_no_slots|heading": "No availability found for {{name}}",
  "org_admin_no_slots|content": "Hello Organization Admins,<br /><br />Please note: It has been brought to our attention that {{username}} has not had any availability when a user has visited {{username}}/{{slug}}<br /><br />There's a few reasons why this could be happening<br />The user does not have any calendars connected<br />Their schedules attached to this event are not enabled<br /> <br />We recommend checking their availability to resolve this.",
  "org_admin_no_slots|cta": "Open users availability",
  organization_no_slots_notification_switch_title: Rxn,
  organization_no_slots_notification_switch_description: Nxn,
  organization_disable_phone_only_sms_notifications_switch_title: Dxn,
  organization_disable_phone_only_sms_notifications_switch_description: Mxn,
  "email_team_invite|subject|added_to_org": "{{user}} added you to the organization {{team}} on {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} invited you to join the organization {{team}} on {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} added you to the team {{team}} of organization {{parentTeamName}} on {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} invited you to join the team {{team}} on {{appName}}",
  "email_team_invite|heading|added_to_org": "You've been added to a {{appName}} organization",
  "email_team_invite|heading|invited_to_org": "You've been invited to a {{appName}} organization",
  "email_team_invite|heading|added_to_subteam": "You've been added to a team of {{parentTeamName}} organization",
  "email_team_invite|heading|invited_to_subteam": "You've been invited to a team of {{parentTeamName}} organization",
  "email_team_invite|heading|invited_to_regular_team": "You've been invited to join a {{appName}} team",
  "email_team_invite|content|added_to_org": "{{invitedBy}} has added you to the <strong>{{teamName}}</strong> organization.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} has invited you to join the {{teamName}} organization.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} invited you to join the team {{team}} of organization {{parentTeamName}} on {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} has added you to the team <strong>{{teamName}}</strong> in their organization {{parentTeamName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} has invited you to join the team <strong>{{teamName}}</strong> in their organization {{parentTeamName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} has invited you to join their team {{teamName}} on {{appName}}. {{appName}} is the event-juggling scheduler that enables you and your team to schedule meetings without the email tennis.",
  "email|existing_user_added_link_will_change": "On accepting the invite, your link will change to your organization domain but don't worry, all previous links will still work and redirect appropriately.<br /><br />Please note: All of your personal event types will be moved into the <strong>{{teamName}}</strong> organization, which may also include potential personal link.  <br /><br />For personal events we recommend creating a new account with a personal email address.",
  "email|existing_user_added_link_changed": "Your link has been changed from {{a0}} to {{a1}} but don't worry, all previous links still work and redirect appropriately. <br /><br />Please note: All of your personal event types have been moved into the <strong>{{teamName}}</strong> organisation, which may also include potential personal link.<br /><br />Please log in and make sure you have no private events on your new organisational account.<br /><br />For personal events we recommend creating a new account with a personal email address.<br /><br />Enjoy your new clean link: {{a2}}",
  "email_organization_created|subject": "Your organization has been created",
  your_current_plan: Lxn,
  organization_price_per_user_month: qxn,
  privacy_organization_description: jxn,
  privacy: Fxn,
  privacy_and_security: Vxn,
  team_will_be_under_org: Bxn,
  add_group_name: Uxn,
  group_name: Wxn,
  routers: Gxn,
  primary: Hxn,
  make_primary: Kxn,
  add_email: Yxn,
  add_emails: Zxn,
  add_email_description: Qxn,
  confirm_email: Jxn,
  confirming_your_booking_sms: Xxn,
  scheduler_first_name: eEn,
  scheduler_last_name: tEn,
  scheduler_name: nEn,
  organizer_first_name: oEn,
  confirm_email_description: rEn,
  send_event_details_to: iEn,
  schedule_tz_without_end_date: aEn,
  select_members: sEn,
  lock_event_types_modal_header: cEn,
  org_delete_event_types_org_admin: lEn,
  org_hide_event_types_org_admin: dEn,
  hide_org_eventtypes: uEn,
  delete_org_eventtypes: _En,
  lock_org_users_eventtypes: pEn,
  lock_org_users_eventtypes_description: mEn,
  add_to_event_type: fEn,
  create_account_password: gEn,
  create_account_with_saml: hEn,
  error_creating_account_password: vEn,
  cannot_create_account_password_cal_provider: bEn,
  cannot_create_account_password_already_existing: yEn,
  create_account_password_hint: $En,
  disconnect_account: wEn,
  disconnect_account_hint: kEn,
  cookie_consent_checkbox: SEn,
  make_a_call: xEn,
  skip_rr_assignment_label: EEn,
  skip_rr_description: TEn,
  select_account_header: AEn,
  select_account_description: CEn,
  select_event_types_header: zEn,
  select_event_types_description: OEn,
  configure_app_header: PEn,
  configure_app_description: IEn,
  already_installed: REn,
  ooo_reasons_unspecified: NEn,
  ooo_reasons_vacation: DEn,
  ooo_reasons_travel: MEn,
  ooo_reasons_sick_leave: LEn,
  ooo_reasons_public_holiday: qEn,
  ooo_forwarding_to: jEn,
  ooo_not_forwarding: FEn,
  ooo_empty_title: VEn,
  ooo_empty_description: BEn,
  ooo_user_is_ooo: UEn,
  ooo_slots_returning: WEn,
  ooo_slots_book_with: GEn,
  ooo_select_reason: HEn,
  create_an_out_of_office: KEn,
  edit_an_out_of_office: YEn,
  submit_feedback: ZEn,
  host_no_show: QEn,
  no_show_description: JEn,
  how_can_we_improve: XEn,
  most_liked: eTn,
  review: tTn,
  reviewed: nTn,
  unreviewed: oTn,
  rating_url_variable: rTn,
  rating_url_info: iTn,
  no_show_url_variable: aTn,
  no_show_url_info: sTn,
  no_support_needed: cTn,
  hide_support: lTn,
  event_ratings: dTn,
  event_no_show: uTn,
  event_no_show_guest: _Tn,
  recent_ratings: pTn,
  no_ratings: mTn,
  no_ratings_description: fTn,
  most_no_show_host: gTn,
  highest_rated: hTn,
  lowest_rated: vTn,
  highest_rated_members: bTn,
  lowest_rated_members: yTn,
  csat_score: $Tn,
  lockedSMS: wTn,
  leave_without_assigning_anyone: kTn,
  leave_without_adding_attendees: STn,
  no_availability_shown_to_bookers: xTn,
  go_back_and_assign: ETn,
  leave_without_assigning: TTn,
  signing_up_terms: ATn,
  proceeding_agreement: CTn,
  terms: zTn,
  always_show_x_days: OTn,
  always_show_x_days_description: PTn,
  team_subscription_cancelled_successfully: ITn,
  team_subscription_cancellation_error: RTn,
  unable_to_subscribe_to_the_platform: NTn,
  updating_oauth_client_error: DTn,
  creating_oauth_client_error: MTn,
  event_type_color: LTn,
  event_type_color_description: qTn,
  mark_as_no_show_title: jTn,
  x_marked_as_no_show: FTn,
  x_unmarked_as_no_show: VTn,
  team_select_info: BTn,
  team_settings_description: UTn,
  no_show_updated: WTn,
  email_copied: GTn,
  phone_number_copied: HTn,
  USER_PENDING_MEMBER_OF_THE_ORG: KTn,
  USER_ALREADY_INVITED_OR_MEMBER: YTn,
  USER_MEMBER_OF_OTHER_ORGANIZATION: ZTn,
  booking_reassigned: QTn,
  reassign: JTn,
  reassign_to_another_rr_host: XTn,
  assign_team_member: eAn,
  override_team_member_to_assign: tAn,
  no_available_hosts: nAn,
  reassign_round_robin_host: oAn,
  skip_writing_to_calendar: rAn,
  rescheduling_not_possible: iAn,
  event_expired: aAn,
  skip_contact_creation: sAn,
  skip_writing_to_calendar_note: cAn,
  attributes: lAn,
  new_attribute: dAn,
  add_attributes: uAn,
  add_attributes_description: _An,
  new_option: pAn,
  update_profile: mAn,
  attribute: fAn,
  create_attribute_description: gAn,
  edit_attribute_description: hAn,
  attribute_updated_successfully: vAn,
  attribute_deleted_successfully: bAn,
  attributes_edited_successfully: yAn,
  attribute_meta_description: $An,
  attributes_edit_description: wAn,
  back_to_attributes: kAn,
  delete_attribute: SAn,
  delete_attribute_description: xAn,
  disable_all_emails_to_attendees: EAn,
  disable_all_emails_description: TAn,
  disable_all_emails_to_hosts: AAn,
  type_confirm_to_continue: CAn,
  disable_email: zAn,
  grant_admin_api: OAn,
  revoke_admin_api: PAn,
  add_calendar_label: IAn,
  apple_connect_atom_label: RAn,
  apple_connect_atom_already_connected_label: NAn,
  apple_connect_atom_loading_label: DAn,
  google_connect_atom_label: MAn,
  google_connect_atom_already_connected_label: LAn,
  google_connect_atom_loading_label: qAn,
  outlook_connect_atom_label: jAn,
  outlook_connect_atom_already_connected_label: FAn,
  outlook_connect_atom_loading_label: VAn,
  stripe_connect_atom_label: BAn,
  stripe_connect_atom_already_connected_label: UAn,
  stripe_connect_atom_loading_label: WAn,
  booking_question_response_variables: GAn,
  managed_by_teamAdmins: HAn,
  number_of_options: KAn,
  reschedule_with_same_round_robin_host_title: YAn,
  reschedule_with_same_round_robin_host_description: ZAn,
  disable_input_if_prefilled: QAn,
  booking_limits: JAn,
  booking_limits_team_description: XAn,
  limit_team_booking_frequency_description: eCn,
  booking_limits_updated_successfully: tCn,
  you_are_unauthorized_to_make_this_change_to_the_booking: nCn,
  delegation_credential_disabled: oCn,
  matching_members: rCn,
  x_matching_members: iCn,
  matching_members_queue_using_attribute_weights: aCn,
  matching_members_queue_using_event_assignee_weights: sCn,
  no_matching_members: cCn,
  no_matching_members_will_fallback_to_all_assigned_members: lCn,
  hide_calendar_event_details: dCn,
  description_hide_calendar_event_details: uCn,
  last_number_of_days: _Cn,
  month_to_date: pCn,
  year_to_date: mCn,
  custom_range: fCn,
  refund_policy: gCn,
  always: hCn,
  never: vCn,
  payment_option: bCn,
  if_cancelled: yCn,
  before: $Cn,
  show_all_columns: wCn,
  toggle_columns: kCn,
  no_columns_found: SCn,
  salesforce_create_record_as: xCn,
  salesforce_lead: ECn,
  salesforce_contact_under_account: TCn,
  salesforce_skip_entry_creation: ACn,
  salesforce_if_account_does_not_exist: CCn,
  salesforce_create_new_contact_under_account: zCn,
  salesforce_change_record_owner_on_booking: OCn,
  mass_assign_attributes: PCn,
  reroute_preview_custom_message: ICn,
  reroute_preview_external_redirect: RCn,
  reroute_preview_possible_host: NCn,
  current_routing_status: DCn,
  reroute_booking: MCn,
  reroute_booking_description: LCn,
  verify_new_route: qCn,
  reroute: jCn,
  new_routing_status: FCn,
  salesforce_book_directly_with_attendee_owner: VCn,
  salesforce_check_owner_of: BCn,
  account: UCn,
  choose_hosts_schedule: WCn,
  hosts_schedule_description: GCn,
  no_hosts_description: HCn,
  team_member_round_robin_reassign: KCn,
  team_member_round_robin_reassign_description: YCn,
  round_robin_reassign_description: ZCn,
  invalid_round_robin_host: QCn,
  user_is_round_robin_fixed: JCn,
  reschedule_with_same_timeslot: XCn,
  reschedule_with_same_timeslot_of_new_event: ezn,
  reschedule_to_the_new_event_with_different_timeslot: tzn,
  reschedule_with_different_timeslot: nzn,
  we_dont_have_id_for_the_new_event: ozn,
  rerouted_booking_successfully_redirecting_to_booking_page: rzn,
  on_booking_write_to_event_object: izn,
  field_name: azn,
  add_new_field: szn,
  you_dont_have_access_to_reroute_this_booking: czn,
  form_response_not_found: lzn,
  contact_owner: dzn,
  contact_owner_not_found: uzn,
  using_fallback_members: _zn,
  chosen_route: pzn,
  attribute_logic_matched: mzn,
  attribute_logic_fallback_matched: fzn,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: gzn,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: hzn,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: vzn,
  warning: bzn,
  fallback_attribute_logic_description: yzn,
  fallback_attribute_logic_warning: $zn,
  fallback_not_needed: wzn,
  confirm_reassign_unavailable: kzn,
  confirm_reassign_available: Szn,
  reassign_unavailable_team_member_description: xzn,
  reassign_available_team_member_description: Ezn,
  yes_reassign: Tzn,
  filter_by_attributes: Azn,
  reassign_reason: Czn,
  field_type_change_suggestion: zzn,
  reassigned_by: Ozn,
  row: Pzn,
  rows: Izn,
  attendee_timezone_variable: Rzn,
  event_start_time_in_attendee_timezone_variable: Nzn,
  event_start_time_in_attendee_timezone_info: Dzn,
  event_end_time_in_attendee_timezone_info: Mzn,
  event_end_time_in_attendee_timezone_variable: Lzn,
  salesforce_create_event_on_contact: qzn,
  salesforce_owner_name_to_change: jzn,
  no_filter_set: Fzn,
  booking_dry_run_successful: Vzn,
  booking_dry_run_successful_description: Bzn,
  dont_have_access_this_page: Uzn,
  you_need_admin_or_owner_privileges_to_access: Wzn,
  field_type: Gzn,
  when_to_write: Hzn,
  salesforce_on_booking_write_to_record: Kzn,
  on_every_booking: Yzn,
  only_if_field_is_empty: Zzn,
  booking_start_date: Qzn,
  booking_created_date: Jzn,
  booking_reassigned_to_host: Xzn,
  no_contact_owner: eOn,
  routing_forms_created: tOn,
  routing_forms_total_responses: nOn,
  routing_forms_total_responses_without_booking: oOn,
  routing_forms_total_responses_with_booking: rOn,
  routing_form_insights: iOn,
  routing_form_insights_form_name_header: aOn,
  routing_form_insights_booking_status_header: sOn,
  routing_form_insights_response_no_booking: cOn,
  routing_form_insights_booked_by: lOn,
  routing_form_insights_created_at: dOn,
  routing_form_insights_booking_status: uOn,
  routing_form_insights_booking_at: _On,
  routing_form_insights_submitted_at: pOn,
  copy_redirect_url: mOn,
  redirect_url_on_exit: fOn,
  total_bookings_per_period: gOn,
  routed_to_per_period: hOn,
  per_day: vOn,
  per_week: bOn,
  per_month: yOn,
  routing_form_insights_assignment_reason: $On,
  access_denied: wOn,
  salesforce_route_to_owner: kOn,
  salesforce_add_attendees_as: SOn,
  salesforce_do_not_route_to_owner: xOn,
  salesforce_route_to_custom_lookup_field: EOn,
  salesforce_option: TOn,
  lookup_field_name: AOn,
  salesforce_if_free_email_domain_skip_owner_check: COn,
  filter_operator_is: zOn,
  filter_operator_is_not: OOn,
  filter_operator_contains: POn,
  filter_operator_does_not_contain: IOn,
  filter_operator_starts_with: ROn,
  filter_operator_ends_with: NOn,
  filter_operator_is_empty: DOn,
  filter_operator_not_empty: MOn,
  translate_description_button: LOn,
  translate_description_button_description: qOn,
  rr_distribution_method: jOn,
  rr_distribution_method_description: FOn,
  rr_distribution_method_availability_title: VOn,
  rr_distribution_method_availability_description: BOn,
  rr_distribution_method_balanced_title: UOn,
  rr_distribution_method_balanced_description: WOn,
  edit_team_member_weights: GOn,
  weights_updated_successfully: HOn,
  require_confirmation_for_free_email: KOn,
  exclude_emails_that_contain: YOn,
  require_emails_that_contain: ZOn,
  exclude_emails_match_found_error_message: QOn,
  require_emails_no_match_found_error_message: JOn,
  search_columns: XOn,
  search_options: e4n,
  disable_org_url_label: t4n,
  disable_org_url_description: n4n,
  single_select: o4n,
  multi_select: r4n,
  calendar_conflict_settings: i4n,
  select_calendars_conflict_check: a4n,
  group_meeting: s4n,
  are_you_sure_you_want_to_remove_this_app_from: c4n,
  disconnect_app_from: l4n,
  salesforce_ignore_guests: d4n,
  google_meet: u4n,
  zoom: _4n,
  office_365_video: p4n,
  lock_attribute_for_assignment: m4n,
  lock_attribute_for_assignment_description: f4n,
  attribute_edited_successfully: g4n,
  new_group_option: h4n,
  attribute_weight_enabled: v4n,
  attribute_weight_enabled_description: b4n,
  routed: y4n,
  reassigned: $4n,
  allow_rescheduling_past_events: w4n,
  allow_rescheduling_past_events_description: k4n,
  rerouted: S4n,
  salesforce_assigned: x4n,
  router_position: E4n,
  show_matching_hosts: T4n,
  no_active_queues: A4n,
  weight: C4n,
  calibration: z4n,
  shortfall: O4n,
  routing_form: P4n,
  go_back_and_save: I4n,
  save_changes: R4n,
  leave_without_saving: N4n,
  leave_without_saving_description: D4n,
  something_unexpected_occurred: M4n,
  "500_error_message": "It's not you, it's us.",
  dry_run_mode_active: L4n,
  icon_showcase: q4n,
  icons_showcase: j4n,
  migrating_from_team: F4n,
  feature_currently_disabled: V4n,
  choose_an_option: B4n,
  enter_option_value: U4n,
  remove_option: W4n,
  use_attribute_weights: G4n,
  if_enabled_ignore_event_type_weights: H4n,
  attribute_for_weights: K4n,
  managed_users: Y4n,
  managed_users_description: Z4n,
  can_you_tell_me_about: Q4n,
  use_ai_to_answer_your_questions: J4n,
  error_fetching_answer: X4n,
  k_bar_ai_error: e3n,
  select_oAuth_client: t3n,
  on_every_instance: n3n,
  delegation_credential_feature_not_enabled: o3n,
  internal_booking_note: r3n,
  internal_note_cancellation_reason: i3n,
  internal_booking_note_description: a3n,
  internal_note_presets: s3n,
  internal_note_presets_description: c3n,
  internal_note_presets_updated_successfully: l3n,
  add_preset: d3n,
  authorize: u3n,
  next: _3n,
  hide: p3n,
  show: m3n,
  utm_params: f3n,
  no_utm_params: g3n,
  asc: h3n,
  desc: v3n,
  verify_email_change: b3n,
  buy_credits: y3n,
  credits: $3n,
  credits_used: w3n,
  total_credits_remaining: k3n,
  credits_per_tip_org: S3n,
  credits_per_tip_teams: x3n,
  view_and_manage_credits: E3n,
  view_and_manage_credits_description: T3n,
  credit_worth_description: A3n,
  buy_additional_credits: C3n,
  view_additional_credits_expense_tip: z3n,
  overview: O3n,
  organization_slug_taken: P3n,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: I3n,
  you_need_to_complete_user_onboarding_before_creating_an_organization: R3n,
  use_company_email_to_create_an_organization: N3n,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: D3n,
  you_need_to_have_minimum_published_teams: M3n,
  you_are_part_of_this_organization_already: L3n,
  you_are_part_of_another_organization_cannot_create_organization: q3n,
  you_are_part_of_another_platform_organization_cannot_create_organization: j3n,
  organization_payment_success: F3n,
  organization_payment_success_description: V3n,
  this_may_take_a_few_seconds: B3n,
  organization_onboarding_status: U3n,
  organization_onboarding_status_description: W3n,
  payment_failed: G3n,
  payment_failed_description: H3n,
  creating_your_organization: K3n,
  organization_onboarding_already_completed: Y3n,
  organization_onboarding_already_exists: Z3n,
  organization_onboarding_not_found: Q3n,
  no_onboarding_id_provided: J3n,
  onboarding_not_found: X3n,
  onboarding_already_complete: e6n,
  onboarding_already_complete_description: t6n,
  resume_onboarding: n6n,
  resume_onboarding_description: o6n,
  payment_successful: r6n,
  handover_onboarding_page_title: i6n,
  handover_onboarding_page_description: a6n,
  organization_already_exists_with_this_slug: s6n,
  you_do_not_have_permission_to_create_an_organization_for_this_email: c6n,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: l6n,
  organization_has_subscription_already: d6n,
  reset_interval_weighted_rr: u6n,
  interval: _6n,
  rr_reset_interval_description: p6n,
  daily: m6n,
  end_date_not_selected: f6n,
  my_ooo: g6n,
  team_ooo: h6n,
  out_of_office_team_description: v6n,
  create_ooo_dialog_team_title: b6n,
  create_ooo_dialog_team_subtitle: y6n,
  edit_ooo_dialog_team_subtitle: $6n,
  ooo_team_empty_title: w6n,
  ooo_team_empty_description: k6n,
  forward_to_team_member_only: S6n,
  ooo_team_redirect_infinite_not_allowed: x6n,
  previous_ooo_empty_title: E6n,
  previous: T6n,
  rr_interval_successfully_updated: A6n,
  trial_mode: C6n,
  inactive_team_plan: z6n,
  inactive_team_plan_description: O6n,
  limited_access_trial_mode: P6n,
  referral_program: I6n,
  referral_text: R6n,
  dub_disabled_error_message: N6n,
  uid: D6n,
  link: M6n,
  rows_per_page: L6n,
  pagination_status: q6n,
  tip_username_plus: j6n,
  user_has_no_team_yet: F6n,
  no_team_members: V6n,
  recurring_event_doesnt_support_seats: B6n,
  booking_limit_per_booker_doesnt_support_recurring: U6n,
  seats_doesnt_support_recurring: W6n,
  recurring_event_seats_error: G6n,
  segment: H6n,
  saved_filters: K6n,
  rename: Y6n,
  rename_segment: Z6n,
  delete_segment: Q6n,
  duplicate_segment: J6n,
  delete_segment_confirmation: X6n,
  filter_segment_updated: e5n,
  error_updating_filter_segment: t5n,
  filter_segment_duplicated: n5n,
  error_duplicating_filter_segment: o5n,
  filter_segment_deleted: r5n,
  error_deleting_filter_segment: i5n,
  save_segment: a5n,
  segment_not_found: s5n,
  filter_segment_saved: c5n,
  no_segments: l5n,
  error_saving_filter_segment: d5n,
  override_segment: u5n,
  create_new_segment: _5n,
  save_for_team: p5n,
  select_team: m5n,
  please_select_team: f5n,
  personal: g5n,
  hide_team_profile_link: h5n,
  hide_team_profile_link_description: v5n,
  display: b5n,
  could_not_find_slug_to_publish_org: y5n,
  picklist: $5n,
  most_cancelled_bookings: w5n,
  interface_language: k5n,
  interface_language_description: S5n,
  visitors_browser_language: x5n,
  name_or_email: E5n,
  salesforce_round_robin_skip_fallback_to_lead_owner: T5n,
  credit_purchase_failed: A5n,
  minimum_of_credits_required: C5n,
  enable_delegation_credential: z5n,
  enable_delegation_credential_description: O5n,
  disable_delegation_credential: P5n,
  disable_delegation_credential_description: I5n,
  last_active: R5n,
  member_since: N5n,
  last_updated: D5n,
  salesforce_on_cancel_write_to_event: M5n,
  salesforce_on_every_cancellation: L5n,
  report_issue: q5n,
  report_issue_description: j5n,
  open_issue: F5n,
  this_is_your_current_plan: V5n,
  schedule_a_time: B5n,
  this_includes: U5n,
  oauth_client_updated_successfully: W5n,
  oauth_client_not_found: G5n,
  subscribe_to_platform: H5n,
  error_accessing_webhooks: K5n,
  webhook_update_failed: Y5n,
  webhook_create_failed: Z5n,
  invalid_link: Q5n,
  currently_subscribed_to_plan: J5n,
  user_team: X5n,
  client_id_copied: ePn,
  client_secret_copied: tPn,
  maintenance_message: nPn,
  your_payment_failed: oPn,
  check_your_inbox: rPn,
  account_created_premium_not_reserved: iPn,
  email_sent_with_activation_link: aPn,
  activate_account_to_purchase_username: sPn,
  open_in_gmail: cPn,
  dont_see_email: lPn,
  resend_in_seconds: dPn,
  resend: uPn,
  verification_email_sent: _Pn,
  select_all_members: pPn,
  select_all_members_tooltip: mPn,
  form_settings: fPn,
  remove_whitelist_status: gPn,
  whitelist_user_workflows: hPn,
  user_workflows_whitelisted: vPn,
  user_workflows_unwhitelisted: bPn,
  date_and_time: yPn,
  email_reminder_upcoming_event_notice: $Pn,
  email_reminder_triggered_by_workflow: wPn,
  event_upper_case: kPn,
  scheduling_by: SPn,
  experience_review_prompt: xPn,
  improve_customer_experience_message: EPn,
  meeting_satisfaction_question: TPn,
  meeting_not_joined_question: APn,
  reschedule_cta_short: CPn,
  hide_organizer_email: zPn,
  platform_customer_cant_create_organization: OPn,
  organization_customer_cant_create_platform: PPn,
  hide_organizer_email_description: IPn,
  you_and_conjunction: RPn,
  select_verified_email: NPn,
  add_verified_email: DPn,
  add_verified_emails: MPn,
  custom_reply_to_email_title: LPn,
  custom_reply_to_email_description: qPn,
  email_survey_triggered_by_workflow: jPn,
  skip_trial: FPn,
  team_trials_skipped_successfully: VPn,
  sms_workflow_consent: BPn,
  routing_preview_more_info_found_insights: UPn,
  results: WPn,
  view_form: GPn,
  sms_opt_out_message: HPn,
  team_credits_low_warning: KPn,
  user_credits_low_warning: YPn,
  action_required_out_of_credits: ZPn,
  action_required_user_out_of_credits: QPn,
  low_credits_warning_message: JPn,
  low_credits_warning_message_user: XPn,
  credit_limit_reached_message: eIn,
  credit_limit_reached_message_user: tIn,
  current_credit_balance: nIn,
  current_balance: oIn,
  notification_about_your_booking: rIn,
  monthly_credits: iIn,
  total_credits: aIn,
  remaining_credits: sIn,
  remaining: cIn,
  total: lIn,
  additional_credits: dIn,
  routing_form_next_in_queue: uIn,
  routing_form_select_members_to_email: _In,
  routing_incomplete_booking_tab: pIn,
  include_no_show_in_rr_calculation: mIn,
  recent_no_show_guests: fIn,
  recent_no_show_guests_tooltip: gIn,
  matching: hIn,
  event_redirect: vIn,
  reset_form: bIn,
  rr_settings_successfully_updated: yIn,
  distribution_basis_weighted_rr: $In,
  timestamp_basis_description: wIn,
  requires_credits: kIn,
  requires_credits_tooltip: SIn,
  available_credits: xIn,
  create_role: EIn,
  roles: TIn,
  roles_and_permissions: AIn,
  roles_and_permissions_description: CIn,
  learn_more_permissions: zIn,
  role_name: OIn,
  role_name_required: PIn,
  role_name_placeholder: IIn,
  role_description: RIn,
  role_description_placeholder: NIn,
  default_role: DIn,
  custom_role: MIn,
  advanced: LIn,
  search_permissions: qIn,
  all_permissions: jIn,
  none: FIn,
  read_only: VIn,
  pbac_desc_all_actions_all_resources: BIn,
  pbac_resource_all: UIn,
  pbac_resource_event_type: WIn,
  pbac_resource_team: GIn,
  pbac_resource_organization: HIn,
  pbac_resource_booking: KIn,
  pbac_resource_insights: YIn,
  pbac_resource_role: ZIn,
  pbac_resource_routing_form: QIn,
  pbac_resource_workflow: JIn,
  pbac_action_all: XIn,
  pbac_action_create: eRn,
  pbac_action_read: tRn,
  pbac_action_update: nRn,
  pbac_action_delete: oRn,
  pbac_action_manage: rRn,
  pbac_action_invite: iRn,
  pbac_action_remove: aRn,
  pbac_action_change_member_role: sRn,
  pbac_action_list_members: cRn,
  pbac_action_manage_billing: lRn,
  pbac_action_read_team_bookings: dRn,
  pbac_action_read_org_bookings: uRn,
  pbac_action_read_recordings: _Rn,
  pbac_action_impersonate: pRn,
  role_created_successfully: mRn,
  role_updated_successfully: fRn,
  delete_role: gRn,
  confirm_delete_role: hRn,
  role_deleted_successfully: vRn,
  error_creating_role: bRn,
  error_updating_role: yRn,
  pbac_desc_create_roles: $Rn,
  pbac_resource_attributes: wRn,
  pbac_desc_view_organization_attributes: kRn,
  pbac_desc_update_organization_attributes: SRn,
  pbac_desc_delete_organization_attributes: xRn,
  pbac_desc_create_organization_attributes: ERn,
  pbac_desc_view_roles: TRn,
  pbac_desc_update_roles: ARn,
  pbac_desc_delete_roles: CRn,
  pbac_desc_create_workflows: zRn,
  set_up_required: ORn,
  pbac_desc_view_workflows: PRn,
  pbac_desc_update_workflows: IRn,
  pbac_desc_delete_workflows: RRn,
  pbac_resource_webhook: NRn,
  pbac_resource_availability: DRn,
  pbac_resource_out_of_office: MRn,
  pbac_resource_blocklist: LRn,
  pbac_desc_create_webhooks: qRn,
  pbac_desc_view_webhooks: jRn,
  pbac_desc_update_webhooks: FRn,
  pbac_desc_delete_webhooks: VRn,
  pbac_desc_create_availability: BRn,
  pbac_desc_view_availability: URn,
  pbac_desc_update_availability: WRn,
  pbac_desc_delete_availability: GRn,
  pbac_desc_create_out_of_office: HRn,
  pbac_desc_view_out_of_office: KRn,
  pbac_desc_update_out_of_office: YRn,
  pbac_desc_delete_out_of_office: ZRn,
  pbac_desc_manage_workflows: QRn,
  pbac_desc_create_event_types: JRn,
  pbac_desc_view_event_types: XRn,
  pbac_desc_update_event_types: eNn,
  pbac_desc_delete_event_types: tNn,
  pbac_desc_manage_event_types: nNn,
  pbac_desc_create_teams: oNn,
  pbac_desc_view_team_details: rNn,
  pbac_desc_update_team_settings: iNn,
  pbac_desc_delete_team: aNn,
  pbac_desc_invite_team_members: sNn,
  pbac_desc_remove_team_members: cNn,
  pbac_desc_change_team_member_role: lNn,
  pbac_desc_impersonate_team_members: dNn,
  pbac_desc_manage_teams: uNn,
  pbac_desc_create_organization: _Nn,
  pbac_desc_view_organization_details: pNn,
  pbac_desc_list_organization_members: mNn,
  pbac_desc_invite_organization_members: fNn,
  pbac_desc_remove_organization_members: gNn,
  pbac_desc_manage_organization_billing: hNn,
  pbac_desc_change_organization_member_role: vNn,
  pbac_desc_impersonate_organization_members: bNn,
  pbac_desc_edit_organization_settings: yNn,
  pbac_desc_manage_organizations: $Nn,
  pbac_desc_view_bookings: wNn,
  pbac_desc_view_team_bookings: kNn,
  pbac_desc_view_organization_bookings: SNn,
  pbac_desc_view_booking_recordings: xNn,
  pbac_desc_update_bookings: ENn,
  pbac_desc_manage_bookings: TNn,
  pbac_desc_view_team_insights: ANn,
  pbac_desc_manage_team_insights: CNn,
  pbac_desc_create_routing_forms: zNn,
  pbac_desc_view_routing_forms: ONn,
  pbac_desc_update_routing_forms: PNn,
  pbac_desc_delete_routing_forms: INn,
  pbac_opt_in_title: RNn,
  pbac_opt_in_description: NNn,
  pbac_opt_in_custom_roles_title: DNn,
  pbac_opt_in_custom_roles_desc: MNn,
  pbac_opt_in_granular_permissions_title: LNn,
  pbac_opt_in_granular_permissions_desc: qNn,
  pbac_opt_in_team_assignment_title: jNn,
  pbac_opt_in_team_assignment_desc: FNn,
  pbac_opt_in_enhanced_security_title: VNn,
  pbac_opt_in_enhanced_security_desc: BNn,
  pbac_opt_in_enable_button: UNn,
  pbac_enabled_success: WNn,
  pbac_enabled_error: GNn,
  read_permission_auto_enabled_tooltip: HNn,
  choose_restriction_schedule: KNn,
  restriction_schedule_description: YNn,
  use_booker_timezone: ZNn,
  use_booker_timezone_info: QNn,
  load_balancing_warning: JNn,
  rr_load_balancing_disabled: XNn,
  rr_load_balancing_disabled_with_groups: eDn,
  round_robin_settings_description: tDn,
  round_robin_settings_updated_successfully: nDn,
  booking_creation_time: oDn,
  meeting_start_time: rDn,
  members_affected_by_disabling_delegation_credential: iDn,
  no_members_affected_by_disabling_delegation_credential: aDn,
  download_expense_log: sDn,
  error_downloading_expense_log: cDn,
  require_booker_email_verification: lDn,
  require_booker_email_verification_description: dDn,
  reschedule_last_booking_offer: uDn,
  booker_upcoming_limit_reached: _Dn,
  booker_limit_exceeded_error_reschedule: pDn,
  duration_min_error: mDn,
  duration_max_error: fDn,
  booking_not_allowed_by_restriction_schedule_error: gDn,
  restriction_schedule_not_found_error: hDn,
  converted_image_size_limit_exceed: vDn,
  add_group: bDn,
  routing_funnel: yDn,
  routing_funnel_total_submissions: $Dn,
  routing_funnel_successful_routings: wDn,
  routing_funnel_accepted_bookings: kDn,
  license_key: SDn,
  license_selection_title: xDn,
  license_selection_description: EDn,
  agplv3_license_description: TDn,
  enter_license_key: ADn,
  enter_your_license_key: CDn,
  enter_existing_license: zDn,
  enter_license_key_description: ODn,
  license_key_placeholder: PDn,
  save_license_key: IDn,
  signature_token_optional: RDn,
  signature_token_description: NDn,
  need_a_license: DDn,
  license_key_required: MDn,
  invalid_license_key: LDn,
  license_validation_failed: qDn,
  attachments_optional: jDn,
  send_message: FDn,
  describe_the_issue: VDn,
  file_size_limit_exceed: BDn,
  invalid_file_type: UDn,
  invalid_file_type_extension: WDn,
  max_files_exceeded: GDn,
  files_uploaded_successfully: HDn,
  file_upload_instructions: KDn,
  license_key_saved: YDn,
  timezone_mismatch_tooltip: ZDn,
  show_optimized_slots: QDn,
  show_optimized_slots_description: JDn,
  failed_bookings_by_field: XDn,
  failed_bookings: eMn,
  event_type_no_hosts: tMn,
  cache_status: nMn,
  cache_last_updated: oMn,
  delete_cached_data: rMn,
  cache_deleted_successfully: iMn,
  error_deleting_cache: aMn,
  confirm_delete_cache: sMn,
  yes_delete_cache: cMn,
  remainder_of_maximum_uses_left_plural: lMn,
  remainder_of_maximum_use_left_singular: dMn,
  expires_on_date: uMn,
  single_use: _Mn,
  time_based_expiration: pMn,
  usage_based_expiration: mMn,
  number_of_uses: fMn,
  expires_on: gMn,
  max_usage_count: hMn,
  link_settings: vMn,
  link_expired_on_date: bMn,
  usage_limit_reached: yMn,
  usage_count_error: $Mn,
  private_link_expired: wMn,
  time_based_expiration_description: kMn,
  time_based_generic_expiration_description: SMn,
  usage_based_expiration_description: xMn,
  usage_based_generic_expiration_description: EMn,
  usage_based_expiration_description_plural: TMn,
  webhook_trigger_event: AMn,
  webhook_created_at: CMn,
  webhook_type: zMn,
  set_up_agent: OMn,
  webhook_title: PMn,
  webhook_start_time: IMn,
  webhook_end_time: RMn,
  webhook_description: NMn,
  webhook_location: DMn,
  webhook_uid: MMn,
  webhook_reschedule_uid: LMn,
  webhook_cancellation_reason: qMn,
  webhook_rejection_reason: jMn,
  webhook_organizer_name: FMn,
  webhook_organizer_email: VMn,
  webhook_organizer_timezone: BMn,
  webhook_organizer_locale: UMn,
  webhook_organizer_username: WMn,
  webhook_organizer_username_in_org: GMn,
  webhook_attendee_name: HMn,
  webhook_attendee_email: KMn,
  webhook_attendee_timezone: YMn,
  webhook_attendee_locale: ZMn,
  webhook_team_name: QMn,
  webhook_team_members: JMn,
  webhook_video_call_url: XMn,
  webhook_hide_variables: eLn,
  webhook_show_variable: tLn,
  webhook_event_and_booking: nLn,
  webhook_people: oLn,
  webhook_teams: rLn,
  webhook_metadata: iLn,
  stats: aLn,
  booking_status: sLn,
  form_submitted_trigger: cLn,
  form_submitted_no_event_trigger: lLn,
  how_long_after_form_submitted_no_event: dLn,
  visit: uLn,
  location_custom_label_input_label: _Ln,
  meeting_link: pLn,
  session_outcome: mLn,
  call_created: fLn,
  voicemail: gLn,
  my_bookings: hLn,
  phone: vLn,
  free: bLn,
  user_email: yLn,
  user_name: $Ln,
  expand_panel: wLn,
  collapse_panel: kLn,
  email_verification_required: SLn,
  invalid_verification_code: xLn,
  you_have_one_team: ELn,
  consider_consolidating_one_team_org: TLn,
  consider_consolidating_multi_team_org: ALn,
  message_sent: CLn,
  support_message_sent_description: zLn,
  search_variables: OLn,
  support_message_placeholder: PLn,
  send_another_message: ILn,
  sending: RLn,
  no_variables_found: NLn,
  credits_required: DLn,
  web_call_credits_info: MLn,
  web_call_no_credits: LLn,
  purchase_credits: qLn,
  credits_required_tooltip: jLn,
  api_key_name_too_long: FLn,
  auto_charge_for_last_minute_cancellation: VLn,
  before_scheduled_start_time: BLn,
  cancel_booking_acknowledge_no_show_fee: ULn,
  contact_organizer: WLn,
  booking_time_option: GLn,
  booking_time_option_description: HLn,
  created_at_option: KLn,
  created_at_option_description: YLn,
  call_details: ZLn,
  call_id: QLn,
  call_information: JLn,
  sentiment: XLn,
  disconnect_reason: eqn,
  call_summary: tqn,
  transcription: nqn,
  event_details: oqn,
  agent: rqn,
  no_transcript_available: iqn,
  testing_sms_workflow_info_message: aqn,
  start_from_scratch_title: sqn,
  start_from_scratch_description: cqn,
  cal_ai_template_title: lqn,
  cal_ai_template_description: dqn,
  voice: uqn,
  select_voice: _qn,
  select_voice_for_agent: pqn,
  choose_a_voice_for_your_agent: mqn,
  trait: fqn,
  voice_id: gqn,
  use_voice: hqn,
  current_voice: vqn,
  setup_incoming_agent: bqn,
  setup_incoming_agent_description: yqn,
  connect_a_phone_number_first: $qn,
  setup_agent_for_incoming_calls: wqn,
  configure_agent_to_handle_incoming_calls: kqn,
  incoming_calls: Sqn,
  outgoing_calls: xqn,
  booking_fields_email_and_phone_both_hidden: Eqn,
  booking_fields_email_or_phone_required: Tqn,
  booking_fields_phone_required_when_email_hidden: Aqn,
  booking_fields_email_required_when_phone_hidden: Cqn,
  inbound_agent_setup_success: zqn,
  inbound_agent_configured: Oqn,
  setup_inbound_agent: Pqn,
  please_select_event_type_first: Iqn,
  edit_configuration: Rqn,
  select_event_type_for_inbound_calls: Nqn,
  setup_inbound_agent_for_incoming_calls: Dqn,
  create_block_entry: Mqn,
  blocklist_entry_details: Lqn,
  blocklist_entry_not_found: qqn,
  blocklist_entry_created: jqn,
  blocklist_entry_deleted: Fqn,
  audit_history: Vqn,
  no_audit_history: Bqn,
  delete_blocklist_entry: Uqn,
  delete_blocklist_entry_confirmation: Wqn,
  created_by: Gqn,
  blocked_by: Hqn,
  by: Kqn,
  added: Yqn,
  no_description_provided: Zqn,
  organization_blocklist: Qqn,
  manage_blocked_emails_and_domains: Jqn,
  invalid_domain_format: Xqn,
  invalid_email_address: e9n,
  reason_for_adding_to_blocklist: t9n,
  what_would_you_like_to_block: n9n,
  domain_name: o9n,
  onboarding_org_details_title: r9n,
  onboarding_org_details_subtitle: i9n,
  onboarding_org_bio_label: a9n,
  onboarding_org_bio_placeholder: s9n,
  onboarding_org_teams_title: c9n,
  onboarding_org_teams_subtitle: l9n,
  onboarding_org_brand_title: d9n,
  onboarding_org_brand_subtitle: u9n,
  onboarding_primary_color_label: _9n,
  onboarding_banner_label: p9n,
  onboarding_logo_size_hint: m9n,
  onboarding_banner_size_hint: f9n,
  onboarding_preview_nameless: g9n,
  onboarding_preview_example_title: h9n,
  onboarding_preview_example_description: v9n,
  onboarding_logo_preview_alt: b9n,
  onboarding_banner_preview_alt: y9n,
  onboarding_pick_color_aria: $9n,
  onboarding_org_invite_title: w9n,
  onboarding_org_invite_subtitle_email: k9n,
  onboarding_org_invite_subtitle_full: S9n,
  onboarding_connect_google_workspace: x9n,
  onboarding_upload_csv: E9n,
  onboarding_copy_invite_link: T9n,
  onboarding_invite_all_as: A9n,
  onboarding_admins: C9n,
  onboarding_modify_roles_later: z9n,
  onboarding_skip_for_now: O9n,
  onboarding_or_divider: P9n,
  onboarding_team_required: I9n,
  onboarding_welcome_message: R9n,
  onboarding_welcome_question: N9n,
  onboarding_plan_personal_title: D9n,
  onboarding_plan_personal_badge: M9n,
  onboarding_plan_personal_description: L9n,
  onboarding_plan_team_title: q9n,
  onboarding_plan_team_description: j9n,
  onboarding_plan_organization_title: F9n,
  onboarding_plan_team_badge: V9n,
  onboarding_plan_organization_badge: B9n,
  onboarding_plan_organization_description: U9n,
  view_previous_week: W9n,
  view_next_week: G9n,
  invite_teammates: H9n,
  organization_brand: K9n,
  organization_details: Y9n,
  organization_teams: Z9n,
  personal_profile: Q9n,
  personal_settings: J9n,
  team_brand: X9n,
  team_details: ejn,
  team_invite: tjn,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: njn
}, ojn = "Proveedor de identidad", rjn = 'Tienes $t(day, {"count": {{days}} }) restantes en tu prueba PRO', ijn = "{{count}} día", ajn = "{{count}} días", sjn = "{{count}} segundo", cjn = "{{count}} segundos", ljn = "Actualizar ahora", djn = "Sin título", ujn = "Aceptar invitación", _jn = "Máx. caracteres", pjn = "Mín. caracteres", mjn = "{{appName}} proporciona una infraestructura de programación para absolutamente todo el mundo.", fjn = "¡Termine de configurar su cuenta de {{appName}}! Está a solo unos pasos de resolver todos sus problemas de programación.", gjn = "¿Tienes preguntas? Estamos aquí para ayudar.", hjn = "{{appName}}: Instrucciones para restablecer la contraseña", vjn = "{{appName}}: Verifique su cuenta", bjn = "{{appName}}: Verifica tu correo electrónico", yjn = "Revise su correo electrónico", $jn = "Correo electrónico antiguo", wjn = "Correo electrónico nuevo", kjn = "Enviamos un correo electrónico a {{email}}. Es importante que verifique su dirección de correo electrónico para garantizar que {{appName}} le ofrezca el mejor servicio de entrega de correos y calendarios.", Sjn = "Verifique su dirección de correo electrónico para garantizar la mejor entrega de correo electrónico y calendario", xjn = "Verifique su dirección de correo electrónico", Ejn = "Verificar correo electrónico", Tjn = "Asistente", Ajn = "Enviar correos con transcripción de Cal Video", Cjn = "Enviar correos electrónicos con la transcripción del Cal Video después de que finalice la reunión. (Requiere un plan de pago)", zjn = "Recientemente has solicitado cambiar la dirección de correo electrónico que usas para iniciar sesión en tu cuenta de {{appName}}. Por favor, haz clic en el botón de abajo para confirmar tu nueva dirección de correo electrónico.", Ojn = "Se ha actualizado tu correo electrónico a {{email}}", Pjn = "No se pudo actualizar el correo electrónico.", Ijn = "Verifica tu nuevo correo electrónico de {{appName}}", Rjn = "Hemos enviado un enlace de verificación a {{email}}. Actualizaremos tu dirección de correo electrónico una vez que hagas clic en este enlace.", Njn = "Guarde esta clave API en algún lugar seguro. No podrá volver a verla.", Djn = "Verifique su dirección de correo electrónico al hacer clic en el botón a continuación.", Mjn = "Verifique su dirección de correo electrónico al hacer clic en el botón a continuación.", Ljn = "Este es el enlace en caso de que no prefiera hacer clic en los botones:", qjn = "Ingrese el código de verificación", jjn = "Ingrese el código de verificación enviado a su correo", Fjn = "El código de verificación es incorrecto.", Vjn = "Correo electrónico enviado correctamente", Bjn = "Se produjo un error al enviar el correo electrónico", Ujn = "Rechazado: {{title}} en {{date}}", Wjn = "Cancelado: {{title}} el {{date}}", Gjn = "Reasignado: {{title}} el {{date}}", Hjn = "Su solicitud de reunión ha sido rechazada", Kjn = "Personalizar ajustes de Cal Video", Yjn = "Configura las preferencias de reuniones por video, incluyendo permisos de grabación para anfitriones y asistentes.", Zjn = "Desactivar grabación para invitados", Qjn = "Activar transcripción automática después de unirse a la reunión", Jjn = "Habilitar grabación automática después de que el organizador se una a la reunión", Xjn = "Opciones de video", eFn = "Editar evento", tFn = "Ver detalles de la sesión", nFn = "Detalles de la sesión de reunión", oFn = "Sesión de reunión", rFn = "ID de sesión", iFn = "Máximo de participantes", aFn = "Ilimitado", sFn = "En curso", cFn = "Finalizada", lFn = "Participantes", dFn = "Usuario anónimo", uFn = "Duración de la sesión", _Fn = "No se encontraron sesiones de reunión", pFn = "No disponible", mFn = "Desactivar grabación para organizador", fFn = "Desactivar transcripción para invitados", gFn = "Desactivar transcripción para el organizador", hFn = "Su solicitud de evento recurrente se ha rechazado", vFn = "Se canceló su evento programado", bFn = "Tu evento programado ha sido reasignado", yFn = "Ya no tendrás el evento en tu calendario y tu probabilidad de round robin no se verá afectada negativamente", $Fn = "Organizador", wFn = "Reasignado a", kFn = "¿Necesita reprogramar o cancelar?", SFn = "Puedes ver los detalles de la reserva desde esta URL {{url}} y añadir el evento a tu calendario", xFn = "No hay opciones disponibles", EFn = "Motivo de la cancelación (opcional)", TFn = "Cancelado por", AFn = "Motivo de cancelación", CFn = "¿Por qué razón está cancelando?", zFn = "El motivo de la cancelación se compartirá con los invitados", OFn = "¿Por qué estás rechazando?", PFn = "Motivo del rechazo", IFn = "¿Rechazar la solicitud de reserva?", RFn = "¿Estás seguro de que deseas rechazar la reserva? Le haremos saber a la persona que ha intentado reservar. Puedes indicar una razón a continuación.", NFn = "Rechazar la reserva", DFn = "Administrar este evento", MFn = "Invite a un miembro del equipo", LFn = "Invitar individualmente", qFn = "Importar en masa", jFn = "Inv.", FFn = "Tu evento ha sido programado", VFn = "Su evento recurrente se ha programado", BFn = "Acepte nuestra licencia cambiando la variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", UFn = "Para eliminar este banner, abra su archivo .env y cambie la variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", WFn = "El mensaje de error fue: '{{errorMessage}}'", GFn = "Reembolso fallido: {{userName}} - {{date}} - {{eventType}}", HFn = "El reembolso del evento {{eventType}} con {{userName}} en {{date}} falló.", KFn = "Por favor, compruebe con su proveedor de pago y {{userName}} cómo manejar esto.", YFn = "Un reembolso falló", ZFn = "Esperando pago: {{title}} en {{date}}", QFn = "Su reunión está a la espera de pago", JFn = "El color del tema oscuro no pasa la verificación de contraste. Recomendamos cambiar este color para que tus botones sean más visibles.", XFn = "El color del tema claro no pasa la verificación de contraste. Recomendamos cambiar este color para que tus botones sean más visibles.", e8n = "El color del tema claro no pasa la verificación de contraste. Recomendamos cambiar este color para que el color de tus tipos de eventos sea más visible.", t8n = "El color del tema oscuro no pasa la verificación de contraste. Recomendamos cambiar este color para que el color de tus tipos de eventos sea más visible.", n8n = "No se pudo crear el pago", o8n = "No se pudo cargar la tarjeta para el pago", r8n = "No se encontraron usuarios disponibles. ¿Podrías intentar en otro horario?", i8n = "El horario seleccionado ya no está disponible. <0>Por favor selecciona un nuevo horario</0>", a8n = "Ocupado", s8n = "Acabas de conectarte. Por favor, reserva desde los espacios de arriba o inténtalo más tarde.", c8n = "Horario no disponible", l8n = "Este tipo de evento no se puede reservar en este momento. ¿Podrías intentar con otro horario?", d8n = "Error interno. El cuerpo de la solicitud no contiene la hora de finalización", u8n = "No se pudo crear el evento en el calendario del organizador", _8n = "No se pudo actualizar el evento del calendario.", p8n = "No se pudo eliminar el evento del calendario.", m8n = "Ya estás registrado para esta reserva.", f8n = "Algunos de los anfitriones no están disponibles para la reserva.", g8n = "Algunos de los anfitriones fijos no están disponibles para reservar.", h8n = "El anfitrión de Round Robin no está disponible para reservas.", v8n = "Ayuda", b8n = "Precio", y8n = "Pagado", $8n = "Reembolsado", w8n = "Grabar", k8n = "Transcribir", S8n = "Pago", x8n = "Faltan campos de la tarjeta", E8n = "Paga ahora", T8n = "Mensaje General", A8n = "Transcripción impulsada por IA", C8n = "Iniciar o detener grabación", z8n = "Iniciar Mensaje", O8n = "El código base debe permanecer en código abierto, si fue modificado o no", P8n = "No puede reempaquetar o vender el código base", I8n = "Adquiera una licencia comercial para eliminar estos términos por correo electrónico", R8n = "Resumen de los términos", N8n = "Abra .env y acepte nuestra licencia", D8n = "He cambiado mi .env", M8n = "Aceptar licencia", L8n = "Un evento aún está esperando su aprobación", q8n = "La solicitud del evento todavía está esperando: {{attendeeName}} - {{date}} - {{eventType}}", j8n = 'No se encontraron resultados para "{{searchTerm}}"', F8n = "No hay más resultados", V8n = "Sin resultados", B8n = "Cargar más resultados", U8n = "ID de la reunión {{integrationName}}: {{meetingId}}", W8n = "Confirma: {{eventType}} con {{name}} en {{date}}", G8n = "Nueva solicitud de evento: {{attendeeName}} - {{date}} - {{eventType}}", H8n = "Confirmar o rechazar la solicitud", K8n = "Consulta la página de reservas para confirmar o rechazar la reserva.", Y8n = "Asistente de Registro", Z8n = "Realiza una llamada saliente para verificar si la cita programada funciona o si deseas reprogramarla.", Q8n = "Crea tu propio mensaje y úsalo para hacer una llamada saliente.", J8n = "Un nuevo evento espera su aprobación", X8n = "Un nuevo evento está esperando su aprobación", e7n = "Alguien ha solicitado programar un evento en su calendario.", t7n = "Alguien ha solicitado un enlace para cambiar su contraseña.", n7n = "Si este correo electrónico existe en nuestro sistema, debería recibir un correo electrónico de restablecimiento.", o7n = "Si usted no solicitó esto, puede ignorar este correo electrónico de forma segura y su contraseña no se cambiará.", r7n = "Esperando aprobación: {{title}} en {{date}}", i7n = "Un evento aún está esperando su aprobación", a7n = "Reserva enviada:{{title}} el {{date}}", s7n = "Descargar grabación: {{title}} el {{date}}", c7n = "Descargar Transcripción: {{title}} en {{date}}", l7n = "Descargue su grabación", d7n = "Descarga tus Transcripciones", u7n = "Su reunión ha sido reservada", _7n = "Tu {{title}} ha sido reprogramado para el {{date}}.", p7n = "Tu {{title}} ha sido actualizado.", m7n = "Tu evento ha sido reprogramado.", f7n = "El evento ha sido actualizado", g7n = "Tu evento ha sido reprogramado", h7n = "{{organizer}} ha cancelado la reserva y le ha solicitado que elija otra hora.", v7n = "Le ha solicitado a {{attendee}} que reprograme", b7n = "Usted ha cancelado la reserva y {{attendee}} deberá seleccionar una nueva hora de reserva con usted.", y7n = "Solicitud de reprogramación enviada: {{eventType}} con {{name}} el {{date}}", $7n = "Reprogramar acción requerida: reserva una nueva hora para {{eventType}} con {{name}}", w7n = "Hola {{name}}", k7n = "{{eventType}} con {{name}}", S7n = "Parece que todos nuestros expertos están ocupados en este momento. Por favor, programa una llamada en el horario que mejor te convenga y estaremos listos para ayudarte.", x7n = "Programar ahora", E7n = "Nuevo Evento: {{attendeeName}} - {{date}} - {{eventType}}", T7n = "Únase por {{entryPoint}}", A7n = "Notas", C7n = "Gestionar mis reservas", z7n = "¿Necesitas hacer un cambio?", O7n = "Un nuevo evento ha sido programado.", P7n = "Se ha programado un nuevo evento recurrente.", I7n = "Email del Invitado", R7n = "Zona horaria del Invitado", N7n = "Tiempo restante", D7n = "Tipo de Evento", M7n = "Tipo de Evento Duplicado", L7n = "Entrar a la reunión", q7n = "Proveedor de videollamadas", j7n = "ID de Reunión", F7n = "Contraseña de la reunión", V7n = "URL de la reunión", B7n = "URL de la reunión no encontrada", U7n = "Token no encontrado", W7n = "Otro anfitrión ya aceptó la reunión. ¿Aún deseas unirte? <0>Continuar a la reunión</0>", G7n = "Su solicitud de reunión ha sido rechazada", H7n = "Rechazado: {{eventType}} con {{organizer}} en {{date}}", K7n = "Hola", Y7n = "Unirse al Equipo", Z7n = "Administrar este equipo", Q7n = "Información del equipo", J7n = "Unirse a la Reunión", X7n = "Si prefiere no utilizar {{toEmail}} como su correo electrónico de {{appName}} o ya tiene una cuenta de {{appName}}, por favor solicite otra invitación a ese email.", eVn = "Has sido invitado a unirte al equipo {{teamName}}", tVn = "{{user}} lo invitó a unirse al equipo {{entity}} {{team}} en {{appName}}", nVn = "Estás oculto en este equipo", oVn = "No está paga tu plaza, actualiza a PRO o infórmale al propietario del equipo para que pague tu plaza.", rVn = "Necesitas una cuenta Pro para gestionar equipos, permanecerás oculto hasta que se realice la mejora.", iVn = "p.s. Expira en {{expiresIn}} horas.", aVn = "Actualiza a Por-Asiento", sVn = "La opción de plazas no admite el requisito de confirmación", cVn = "Múltiples ubicaciones no soportan la opción de asientos", lVn = "La tarifa por no presentarse no soporta la opción de asientos", dVn = "La opción de asientos no soporta múltiples ubicaciones", uVn = "De los {{memberCount}} miembros de su equipo, no se han pagado {{unpaidCount}} licencia(s). A {{seatPrice}} $/m por licencia, el coste total estimado de su membresía es de {{totalCost}} $/mes.", _Vn = 'Gracias por probar nuestro nuevo plan de equipo. Notamos que su equipo "{{teamName}}" necesita actualizarse.', pVn = "Actualizar aquí", mVn = "¡Tu equipo se actualizó con éxito!", fVn = 'Gracias por probar nuestro nuevo plan Organization. Notamos que su Organization "{{teamName}}" necesita actualizarse.', gVn = "Su Organization se actualizó con éxito.", hVn = "Utilice el enlace de abajo para restablecer su contraseña", vVn = "Hola", bVn = "ahí", yVn = "¿Olvidaste tu contraseña? - {{appName}}", $Vn = "¿Está seguro de que desea eliminar este webhook? Ya no recibirá datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", wVn = "Sí, elimina este webhook", kVn = "Editar Webhook", SVn = "Eliminar Webhook", xVn = "Estado del Webhook", EVn = "Webhook habilitado", TVn = "Webhook Desactivado", AVn = "Respuesta del Webhook", CVn = "Prueba del Webhook", zVn = "Formulario de actualización de webhook", OVn = "Añade un webhook a tu cliente OAuth.", PVn = "Administra tu webhook", IVn = "¡Webhook creado con éxito!", RVn = "¡Webhook actualizado con éxito!", NVn = "¡Webhook eliminado correctamente!", DVn = "Se requiere suscripción", MVn = "No estás suscrito a un plan de la plataforma.", LVn = "Plantilla de carga", qVn = "Rechazar", jVn = "Todavía no hay datos", FVn = "Prueba Ping", VVn = "Agregue esta aplicación a su pantalla de inicio para un acceso más rápido y una experiencia mejorada.", BVn = "Próximamente", UVn = "Recurrente", WVn = "Pasado", GVn = "Elija un archivo...", HVn = "Cargar imagen", KVn = "Cargar {{target}}", YVn = "No {{target}}", ZVn = "Desliza para hacer zoom, arrastra para reposicionar", QVn = "Ver notificaciones", JVn = "Ver página pública", XVn = "Copiar enlace de página pública", eBn = "Copiar enlace de referencia", tBn = "Cerrar sesión", nBn = "Añadir otro", oBn = "Instalar otra", rBn = "hasta el", iBn = "con tecnología de", aBn = "Indisponible", sBn = "Establezca su horario de trabajo", cBn = "Cambiar cuando está disponible para reservas", lBn = "Seleccionar...", dBn = "Texto", uBn = "Su número de teléfono", _Bn = "Texto de varias líneas", pBn = "Número", mBn = "Casilla", fBn = "Es requerido", gBn = "Hacer que este campo sea obligatorio", hBn = "Requerido", vBn = "Opcional", bBn = "Tipo de entrada", yBn = "Rechazado", $Bn = "Sin confirmar", wBn = "Invitados", kBn = "Invitado", SBn = "Los detalles a seguir de su conferencia, en el correo de confirmación.", xBn = "Confirmación", EBn = "Lo que tu reservador debe proporcionar para recibir confirmaciones", TBn = "Usuario", ABn = "aún está disponible.", CBn = "Documentación", zBn = "Aprende cómo integrar nuestras herramientas con tu aplicación", OBn = "Referencia de API", PBn = "Una referencia completa de la API para nuestras bibliotecas", IBn = "Blog", RBn = "Lee nuestras últimas noticias y artículos", NBn = "Únete a nuestra comunidad", DBn = "Páginas Populares", MBn = "Regístrate Ahora", LBn = "Registrar", qBn = "Esta página no existe.", jBn = "No hay número de teléfono activo disponible", FBn = "Paso de flujo de trabajo no configurado", VBn = "Comprueba errores ortográficos o vuelve a la página anterior.", BBn = "No pudimos encontrar el evento que está intentando reservar.", UBn = "Empezar", WBn = "Secreto", GBn = "Dejar en blanco para eliminar el secreto", HBn = "Verifica que tu servidor solo esté recibiendo las solicitudes previstas de {{appName}} por motivos de seguridad", KBn = "Reunión Secreta", YBn = "Iniciar Sesión en su lugar", ZBn = "Crear Cuenta", QBn = "Comenzar", JBn = "Confirmar Contraseña", XBn = "Establezca su nueva contraseña con las instrucciones enviadas a su dirección de correo electrónico.", eUn = "Por favor, sube una imagen de {{width}} de ancho y {{height}} de alto.", tUn = "Vuelva a iniciar sesión con su nueva dirección de correo electrónico y contraseña.", nUn = "Crea tu Cuenta", oUn = "Crea tu cuenta en Cal.com", rUn = "Regístrate", iUn = "Has cerrado la sesión", aUn = "¡Esperamos volver a verte pronto!", sUn = "Sesión Cerrada", cUn = "Por favor, inténtelo de nuevo y contáctenos si el problema persiste.", lUn = "Código de doble factor es incorrecto.", dUn = "No existe una cuenta que coincida con ese email.", uUn = "Crear una Cuenta", _Un = "¿No tienes una cuenta?", pUn = "Iniciar sesión en tu cuenta", mUn = "Iniciar Sesión", fUn = "Volver a la página de inicio", gUn = "Se ha producido un error al iniciar sesión. Vuelve a la pantalla de inicio de sesión e inténtalo de nuevo.", hUn = "Restablecer contraseña", vUn = "Enviar invitación", bUn = "Olvidé la contraseña", yUn = "¿Olvidado?", $Un = "Hecho", wUn = "¡Todo listo!", kUn = "Todos", SUn = "Su cuenta", xUn = "Aplicaciones disponibles", EUn = "Aplicaciones disponibles", TUn = "Mira las aplicaciones populares a continuación y explora más en nuestra <0>Tienda de aplicaciones</0>", AUn = "Añade a cualquier persona que necesite asistir al evento. <0>Más información</0>", CUn = "Las personas en un grupo se turnan, una persona de cada grupo se presentará al evento.", zUn = "Las personas del grupo se turnan y solo una persona se presentará al evento.", OUn = "Revisa tu email. Te hemos enviado un enlace para restablecer tu contraseña.", PUn = "Terminar", IUn = "Administre los ajustes para el idioma y la zona horaria de su equipo", RUn = "Unas pocas frases sobre ti mismo. Esto aparecerá en tu página de url personal.", NUn = "¡Ya casi está!", DUn = "Por último, una breve descripción sobre ti y una foto realmente ayuda a conseguir reservas y permite a las personas saber con quién están reservando.", MUn = "Defina los intervalos de tiempo cuando esté disponible de forma recurrente. Puede crear más tarde y asignarlos a diferentes calendarios.", LUn = "Establecer Disponibilidad", qUn = "Establece horarios para los momentos en que deseas ser reservado.", jUn = "Comparte un enlace o incrusta", FUn = "Comparte tu enlace de {{appName}} o incrústalo en tu sitio.", VUn = "Configuración de disponibilidad", BUn = "Continuar sin calendario", UUn = "Continuar con {{appName}}", WUn = "Conecta tu calendario", GUn = "Conecte sus aplicaciones favoritas", HUn = "Conecte sus aplicaciones de vídeo para usarlas en sus tipos de eventos.", KUn = "Conecta tu calendario para verificar automáticamente los horarios ocupados y nuevos eventos a medida que se programan.", YUn = "Configurar más tarde", ZUn = "Hora Actual", QUn = "Detalles", JUn = "Bienvenido", XUn = "Bienvenido de nuevo", eWn = "Bienvenido a {{appName}}", tWn = "Dinos cómo quieres que te llamemos e indícanos en qué zona horaria te encuentras. Podrás editar esto más tarde.", nWn = "Conectar con CalDav (Beta)", oWn = "Conectar a una fuente ICS", rWn = "Conectar", iWn = "Pruébalo Gratis", aWn = "Crea tu propio enlace de reserva con {{appName}}", sWn = "Quien", cWn = "Qué", lWn = "Cuándo", dWn = "Donde", uWn = "Añadir al Calendario", _Wn = "Selecciona dónde añadir eventos cuando te reserven.", pWn = "Agregar eventos a", mWn = "Añadir otro calendario", fWn = "Otro", gWn = "Su enlace de inicio de sesión para {{appName}}", hWn = "Te reunirás con {{user}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", vWn = "{{host}} se reunirá con {{attendee}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", bWn = "Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos.", yWn = "Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", $Wn = "Te reunirás con {{user}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", wWn = "{{host}} se reunirá con {{attendee}}. Hemos enviado un correo electrónico con una invitación de calendario con los detalles a todos para el primero de estos eventos recurrentes.", kWn = "Usted y cualquier otro asistente han recibido esta información.", SWn = "Su reserva todavía necesita ser confirmada o rechazada.", xWn = "Su reunión recurrente todavía necesita confirmarse o rechazarse.", EWn = "{{user}} aún necesita confirmar o rechazar la reserva.", TWn = "El {{user}} todavía necesita confirmar o rechazar cada reserva de la reunión recurrente.", AWn = "Esta reunión está programada", CWn = "Se han programado los eventos recurrentes", zWn = "Reserva enviada", OWn = "Su reunión recurrente se ha enviado", PWn = "Reserva confirmada", IWn = "Su reunión recurrente se ha confirmado", RWn = "Todavía no se puede cobrar por los eventos recurrentes", NWn = "Los eventos recurrentes aún no son compatibles con los pagos", DWn = "Introduce la nueva contraseña que te gustaría para tu cuenta.", MWn = "Restablecer Contraseña", LWn = "Cambiar Contraseña", qWn = "Mostrar contraseña", jWn = "Ocultar contraseña", FWn = "Volver a Intentarlo", VWn = "Esta solicitud ha caducado.", BWn = "Introduzca el email asociado a su cuenta y le enviaremos un enlace para restablecer su contraseña.", UWn = "La solicitud ha caducado. Vuelve e introduce el email asociado a tu cuenta y te enviaremos otro enlace para restablecer tu contraseña.", WWn = "Ups", GWn = "Entrar", HWn = "Éxito", KWn = "Falló", YWn = "Su contraseña ha sido restablecida. Ahora puede iniciar sesión con su nueva contraseña.", ZWn = "Diseño", QWn = "Vista predeterminada", JWn = "Puede seleccionar varias y quienes le reserven pueden cambiar de vista.", XWn = "Diseño de reserva", eGn = "Puede seleccionar varios y quienes le reservan pueden cambiar de vista. Esto se puede anular por evento.", tGn = "Mes", nGn = "Semanal", oGn = "Columna", rGn = "Al menos un diseño tiene que estar habilitado.", iGn = "El diseño que seleccionó como vista predeterminada no es parte de los diseños habilitados.", aGn = "El diseño seleccionado no es un diseño válido.", sGn = "Puedes gestionar esto para todos tus tipos de eventos en Configuración -> <0>Apariencia</0> o <1>Personalizar</1> solo para este evento.", cGn = "Ocurrió un error inesperado. Inténtelo de nuevo.", lGn = "Hora inválida del domingo", dGn = "Hora inválida del lunes", uGn = "Hora inválida del martes", _Gn = "Hora inválida del miércoles", pGn = "Hora inválida del jueves", mGn = "Hora inválida del viernes", fGn = "Hora inválida del sábado", gGn = "La hora final no puede ser anterior a la hora de inicio", hGn = "La hora final no puede ser mayor de 24 horas", vGn = "Volver a Reservas", bGn = "No dude en elegir otro evento en cualquier momento.", yGn = "Cancelado", $Gn = "Sin reserva", wGn = "Esperando al anfitrión", kGn = "Cancelación Realizada", SGn = "¿Realmente deseas cancelar tu reserva?", xGn = "No puedes cancelar esta reserva", EGn = "En su lugar, también puedes reprogramarlo.", TGn = "El evento es en el pasado", AGn = "El evento es un caso de un evento recurrente.", CGn = "Todas estas son instancias restantes en el evento recurrente.", zGn = "Se produjo un error con el código de estado {{status}}.", OGn = "Ya existe un tipo de evento con esta URL.", PGn = "No puede crear este evento", IGn = "No puede editar este evento", RGn = "No puede crear este flujo de trabajo", NGn = "No puede crear este programa", DGn = "Esta reserva ya se canceló", MGn = "Esta reserva ya se aceptó o rechazó", LGn = "Volver a Inicio", qGn = "O Volver al Inicio", jGn = "Reunión no Encontrada", FGn = "Esta reunión no existe. Póngase en contacto con el responsable de la reunión para obtener un enlace actualizado.", VGn = "Aún no hay reservas {{status}}", BGn = "No tienes {{status}} reservas. {{description}}", UGn = "{{eventName}} entre {{host}} y {{attendeeName}}", WGn = "Reservas", GGn = "Reserva no encontrada", HGn = "Vea eventos futuros y pasados reservados a través de sus enlaces de tipo de eventos.", KGn = "Tan pronto como alguien reserve una hora contigo, aparecerá aquí.", YGn = "Tan pronto como alguien reserve una reunión recurrente con usted, aparecerá aquí.", ZGn = "Sus reservas pasadas aparecerán aquí.", QGn = "Las reservas canceladas aparecerán aquí.", JGn = "Las reservas sin confirmar aparecerán aquí.", XGn = "Reservas sin confirmar", eHn = "en", tHn = "y", nHn = "Tu calendario te muestra como ocupado entre", oHn = "Resolución de Problemas", rHn = "Comprenda por qué ciertos horarios están disponibles y otros están bloqueados.", iHn = "Aquí tienes un resumen de tu día el", aHn = "Consejo: Supera los tiempos en negrita para una marca de tiempo completa", sHn = "Hora de Inicio", cHn = "Hora de finalización", lHn = "Tiempo de búfer", dHn = "Antes del evento", uHn = "Después del evento", _Hn = "Sin tiempo de búfer", pHn = "Búfer", mHn = "Tu día empieza a las", fHn = "Tu día termina a las", gHn = "Iniciar solucionador de problemas", hHn = "Solucione problemas de disponibilidad para explorar por qué sus tiempos se muestran como son.", vHn = "Cambiar Horas Disponibles", bHn = "Cambiar las Horas Disponibles", yHn = "Cambiar las horas de inicio y fin de tu día", $Hn = "Establezca la hora de inicio y finalización de su día y un búfer mínimo entre sus reuniones.", wHn = "Actualmente, tu día está listo para comenzar a las", kHn = "La hora de inicio y fin de tu día se ha cambiado correctamente.", SHn = "y terminar a las", xHn = "Claro", EHn = "Oscuro", THn = "Ajusta automáticamente el tema según las preferencias de los invitados", AHn = "Actualmente, algunos de los usuarios del grupo tienen desactivadas las reservas dinámicas grupales", CHn = "Los enlaces de reservas grupales se pueden crear dinámicamente añadiendo varios nombres de usuario con un '+'. Ejemplo: '{{appName}}/bailey+peer'", zHn = "Permitir que los asistentes lo reserven a través de reservas dinámicas de grupo", OHn = "Enlaces dinámicos de grupo", PHn = "Permita que los motores de búsqueda accedan a su contenido público", IHn = "Permitir indexación en motores de búsqueda", RHn = "Permitir notificaciones del navegador", NHn = "Has denegado las notificaciones. Restablece el permiso en la configuración del navegador para habilitarlas.", DHn = "Desactivar notificaciones del navegador", MHn = "Notificaciones del navegador activadas", LHn = "Notificaciones del navegador desactivadas", qHn = "Notificaciones del navegador denegadas", jHn = "Por favor, permite las notificaciones desde el aviso", FHn = "Notificaciones push", VHn = "Recibe notificaciones push cuando el usuario realiza una reserva instantánea de reunión.", BHn = "Tu navegador no soporta las notificaciones push. Si usas Brave, habilita la opción `Usar servicios de Google para la mensajería push` en brave://settings/?search=push+messaging", UHn = "Correo electrónico", WHn = "nombre@ejemplo.com", GHn = "Nombre Completo", HHn = "Consulte la documentación de nuestra API", KHn = "Aproveche nuestra API para un control total y personalización.", YHn = "Crear Webhook", ZHn = "Reunión instantánea creada", QHn = "Reserva cancelada", JHn = "Reserva habilitada", XHn = "Enlace de descarga de grabación listo", eKn = "Transcripción generada", tKn = "Reserva Creada", nKn = "Reserva rechazada", oKn = "Reserva solicitada", rKn = "Pago de la reserva iniciado", iKn = "Reunión finalizada", aKn = "Formulario enviado", sKn = "Formulario enviado, ningún evento reservado", cKn = "Reserva pagada", lKn = "Fuera de la oficina creado", dKn = "Reserva de no presentación actualizada", uKn = "Activadores de Eventos", _Kn = "URL del suscriptor", pKn = "Crear un nuevo Webhook", mKn = "Webhooks", fKn = "Webhooks del equipo", gKn = "Crear un nuevo webhook en tu cuenta", hKn = "Nuevo Webhook", vKn = "Reciba datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", bKn = "Reciba datos de reuniones de {{appName}} en una URL específica, en tiempo real, cuando se programe o cancele un evento.", yKn = "Iframe receptivo a pantalla completa", $Kn = "Cargando...", wKn = "Eliminando...", kKn = "Iframe estándar", SKn = "Desarrollador", xKn = "Administre sus configuraciones de desarrollador.", EKn = "incrustar iframe", TKn = "La forma más sencilla de integrar {{appName}} en su sitio web.", AKn = "Intégrese con su sitio web utilizando nuestras opciones de inserción u obtenga información de reserva en tiempo real utilizando webhooks personalizados.", CKn = "Programar una reunión", zKn = "Ver y administrar sus datos de facturación", OKn = "Vea y edite sus datos de facturación, así como cancele su suscripción.", PKn = "Ir al portal de facturación", IKn = "¿Necesita algo más?", RKn = "Si necesita más ayuda con la facturación, nuestro equipo de soporte está aquí para ayudarlo.", NKn = "Contactar", DKn = "nuestro equipo de soporte", MKn = "Contacte con nuestro equipo de soporte", LKn = "Uh oh!", qKn = "Este usuario aún no ha configurado ningún tipo de evento.", jKn = "Cambiar la marca", FKn = "Subir una marca", VKn = "Cargar logo", BKn = "Quitar logo", UKn = "Habilitar", WKn = "Código", GKn = "El código es incorrecto.", HKn = "Añadir nuevo intervalo de tiempo", KKn = "Agregue una capa adicional de seguridad a su cuenta en caso de que le roben su contraseña.", YKn = "Habilitar la autenticación de dos factores", ZKn = "Deshabilitar la autenticación de dos factores", QKn = "Si necesita deshabilitar 2FA, le recomendamos que lo vuelva a habilitar lo antes posible.", JKn = "Error al deshabilitar la autenticación de dos factores", XKn = "Error al configurar la autenticación de dos factores", eYn = "Seguridad", tYn = "Administra la seguridad de tu cuenta.", nYn = "Contraseña", oYn = "Contraseña Actualizada con Éxito", rYn = "Su contraseña se ha cambiado correctamente.", iYn = "Error al cambiar la contraseña", aYn = "La configuración de su sesión se ha actualizado correctamente.", sYn = "Error al actualizar la configuración de la sesión", cYn = "Algo ha Fallado.", lYn = "¿Algo no se ve bien?", dYn = "Por Favor, Inténtalo de Nuevo.", uYn = "Su nueva contraseña super segura", _Yn = "Nueva contraseña", pYn = "Su contraseña antigua", mYn = "Contraseña Actual", fYn = "Cambiar Contraseña", gYn = "Cambiar secreto", hYn = "La nueva contraseña coincide con su contraseña antigua. Por favor, elija una contraseña diferente.", vYn = "Si has perdido u olvidado este secreto, puedes cambiarlo, pero ten en cuenta que todas las integraciones que usen este secreto tendrán que actualizarse", bYn = "La Contraseña Actual es Incorrecta", yYn = "Mezcla de letras mayúsculas y minúsculas", $Yn = "Mínimo 7 caracteres", wYn = "Longitud mínima de 15 caracteres", kYn = "Debe contener al menos 1 número", SYn = "Debe tener {{limit}} o menos caracteres", xYn = "La contraseña debe tener un mínimo de {{passwordLength}} caracteres que contengan al menos un número y una mezcla de letras mayúsculas y minúsculas", EYn = "La Contraseña es Incorrecta.", TYn = "El correo electrónico o la contraseña son incorrectos.", AYn = "Usar Ajuste", CYn = "am/pm", zYn = "Opciones Horas", OYn = "Enero", PYn = "Febrero", IYn = "Marzo", RYn = "Abril", NYn = "Mayo", DYn = "Junio", MYn = "Julio", LYn = "Agosto", qYn = "Septiembre", jYn = "Octubre", FYn = "Noviembre", VYn = "Diciembre", BYn = "Lunes", UYn = "Martes", WYn = "Miércoles", GYn = "Jueves", HYn = "Viernes", KYn = "Sábado", YYn = "Domingo", ZYn = "Todo reservado.", QYn = "No se pudo cargar el intervalo de tiempo disponible.", JYn = "Añadir invitados", XYn = "Tu Nombre", eZn = "Su nombre completo", tZn = "Sin nombre", nZn = "Introduzca un número entre 1 y {{maxOccurences}}", oZn = "Rápido y sencillo - no se requiere cuenta. Perfecto para reuniones puntuales.", rZn = "Email", iZn = "Ingresa un correo electrónico válido", aZn = "Por favor, programa una llamada futura si no estamos disponibles en {{seconds}} segundos", sZn = "Ubicación", cZn = "Ubicación", lZn = "Ingrese la dirección", dZn = "En persona (dirección del asistente)", uZn = "Otro lugar", _Zn = "Ubicación personalizada del asistente", pZn = "Continuar como invitado", mZn = "Unirse como invitado", fZn = "Ideal para llamadas únicas", gZn = "Cualquier ubicación", hZn = "Sí", vZn = "No", bZn = "Notas Adicionales", yZn = "No se ha podido reservar la reunión.", $Zn = "No se ha podido reprogramar la reunión.", wZn = "Por favor, comparta cualquier cosa que ayude a preparar nuestra reunión.", kZn = "Confirma tu {{eventTypeTitle}} con {{profileName}}", SZn = "Reprogramar tu {{eventTypeTitle}} con {{profileName}}", xZn = "Reunión en Persona", EZn = "En persona (dirección del organizador)", TZn = "Enlace de la reunión", AZn = "Nª de Telefono", CZn = "Número de teléfono del asistente", zZn = "Número de teléfono del organizador", OZn = "Introducir Nº de Telefono", PZn = "Reprogramar", IZn = "Reprogramar en su lugar", RZn = "Reservar un miembro del equipo en su lugar", NZn = "O", DZn = "Volver", MZn = "Email o Nombre de Usuario", LZn = "Enviar Invitación por Email", qZn = "Rol", jZn = "Editar Rol", FZn = "Ver rol", VZn = "Editar Equipo", BZn = "Editando usuario", UZn = "Editando organización", WZn = "Si deseas editar o gestionar tus webhooks, dirígete a la <0>configuración de webhooks</0>", GZn = "Rechazar", HZn = "Rechazar todo", KZn = "Aceptar", YZn = "Abandonar", ZZn = "Perfil", QZn = "URL de Mi Equipo", JZn = "Mis equipos", XZn = "Nombre del equipo", eQn = "Nombre de tu Equipo", tQn = "Equipo Actualizado Correctamente", nQn = "Tu equipo ha sido actualizado con éxito.", oQn = "Su organización se ha actualizado correctamente.", rQn = "Error al copiar al portapapeles", iQn = "Acerca de", aQn = "Comentarios sobre tu equipo. Esta información aparecerá en la página de la URL de tu equipo.", sQn = "ID de la organización", cQn = "ID de la organización copiado.", lQn = "Algunas frases sobre su organización. Esto aparecerá en la página de la URL de su organización.", dQn = "ID del equipo", uQn = "ID del equipo copiado.", _Qn = "Miembros", pQn = "Miembros de Organization", mQn = "Miembro", fQn = "{{count}} miembro", gQn = "{{count}} miembros", hQn = "{{count}} seleccionados", vQn = "Propietario", bQn = "Administrador", yQn = "API de administración", $Qn = "Usuario administrador", wQn = "Vamos a crear el primer usuario administrador.", kQn = "Configuración del usuario administrador", SQn = "Ya ha creado un usuario administrador. Ahora puede iniciar sesión en su cuenta.", xQn = "Nuevo Miembro", EQn = "Invitación", TQn = "Añadir miembros del equipo", AQn = "Agregar miembros", CQn = "Invitar a otros a unirse a tu equipo", zQn = "Añadir miembro del equipo", OQn = "Invitar a un nuevo miembro", PQn = "Nota: Esto <0>costará un asiento adicional (15$/mes)</0> en tu suscripción.", IQn = "Invita a alguien a tu equipo.", RQn = "Cargar un archivo .csv", NQn = "Invitar por correo electrónico", DQn = "Cambiar rol del miembro del equipo", MQn = "Desactivar la marca de {{appName}}", LQn = "Ocultar todas las marcas de {{appName}} de sus páginas públicas.", qQn = "Ocultar el botón Reservar un miembro del equipo", jQn = "Ocultar el botón Reservar un miembro del equipo de sus páginas públicas.", FQn = "Paso definitivo", VQn = "Ten cuidado. La eliminación de la cuenta no se puede deshacer.", BQn = "Ten cuidado. La eliminación del equipo no se puede deshacer.", UQn = "Atrás", WQn = "Cancelar", GQn = "Cancelar todos los restantes", HQn = "Aplicar", KQn = "Cancelar este evento", YQn = "Confirmar", ZQn = "Confirmar todo", QQn = "Disolver Equipo", JQn = "¿Estás seguro de que quieres disolver este equipo? Cualquiera con quien has compartido este enlace de equipo ya no podrá reservar usando el mismo.", XQn = "Disolver la organización", eJn = "¿Está seguro de que desea disolver esta organización? Todos los equipos y miembros se eliminarán.", tJn = "¿Estás seguro de que quieres eliminar este miembro del equipo?", nJn = "Sí, Disolver Equipo", oJn = "Sí, Eliminar Miembro", rJn = "Sí, cancelar suscripción", iJn = "Cancelar suscripción", aJn = "Al cancelar tu suscripción se desactivará permanentemente tu plan actual. Esta acción no se puede deshacer.", sJn = "Eliminar Miembro", cJn = "Administra tu Equipo", lJn = "Todavía no tienes ningún equipo.", dJn = "Los equipos permiten que otros reserven eventos compartidos entre tus compañeros de trabajo.", uJn = "Enviar", _Jn = "Sí, eliminar atributo", pJn = "Eliminar atributo", mJn = "¿Estás seguro de que deseas eliminar el atributo '{{name}}'? Todos los usuarios asignados actualmente serán desvinculados.", fJn = "Actualizar", gJn = "Guardar", hJn = "Pendiente", vJn = "Abrir Opciones", bJn = "Copiar Enlace", yJn = "Compartir", $Jn = "¿Quieres reservar mi Cal o enviarme tu enlace?", wJn = "Copiar enlace al equipo", kJn = "Abandonar equipo", SJn = "Sí, abandonar equipo", xJn = "¿Estás seguro de que quieres salir de este equipo? Ya no podrás reservar usándolo.", EJn = "{{user}} de {{team}}", TJn = "Vista Previa", AJn = "¡Enlace Copiado!", CJn = "¡Copiado!", zJn = "¡Enlace privado copiado!", OJn = "¡Enlace compartido!", PJn = "Título", IJn = "Descripción", RJn = "Estado de las aplicaciones", NJn = "Reunión de Vídeo Rápida.", DJn = "Tipo de Programación", MJn = "Ver Equipo", LJn = "Colectivo", qJn = "Programe reuniones cuando todos los miembros del equipo seleccionados estén disponibles.", jJn = "Duración", FJn = "Duraciones disponibles", VJn = "Duración predeterminada", BJn = "Seleccione primero las duraciones disponibles", UJn = "{{count}} $t(minute_timeUnit)", WJn = "{{count}} $t({{unit}}_timeUnit)", GJn = "{{count}}$t({{unit}}_short)", HJn = "Minutos", KJn = "Usa Cal.ai para obtener un número de teléfono con inteligencia artificial o hacer llamadas a invitados.", YJn = "URI de terminación", ZJn = "Nombre de usuario del troncal SIP", QJn = "Contraseña del troncal SIP", JJn = "Apodo", XJn = "Eliminar número de teléfono", eXn = "La validación del flujo de trabajo falló", tXn = "Uno o más pasos del flujo de trabajo tienen contenido de mensaje vacío", nXn = "Uno o más números de teléfono o direcciones de correo electrónico no están verificados", oXn = "Potencia tus flujos de trabajo con Cal.ai", rXn = "Agentes de IA realistas que programan reuniones, envían recordatorios y hacen seguimiento con tus clientes.", iXn = "Número de teléfono importado y vinculado al agente con éxito", aXn = "Número de teléfono eliminado con éxito", sXn = "¿Estás seguro de que quieres eliminar este número de teléfono? Esta acción no se puede deshacer.", cXn = "Sí, eliminar número de teléfono", lXn = "El número que estás intentando importar debe estar en formato E.164 (código de país seguido por el número, sin espacios ni caracteres especiales), por ejemplo, +1234567890", dXn = "El URI de terminación para identificar de forma única tu troncal SIP elástico. Esto se utiliza para llamadas salientes. Para troncales SIP elásticos de Twilio siempre termina con .pstn.twilio.com.", uXn = "El nombre de usuario utilizado para autenticar el troncal SIP.", _Xn = "La contraseña utilizada para autenticar el troncal SIP.", pXn = "Apodo del número. Esto es solo para tu referencia.", mXn = "Guardar y probar llamada", fXn = "Llamada iniciada con éxito", gXn = "Por favor, introduce un número de teléfono", hXn = "Agente actualizado con éxito", vXn = "Agente creado con éxito", bXn = "Tipo de evento añadido con éxito", yXn = "Número de teléfono dado de baja correctamente", $Xn = "Este prompt define el rol del agente y sus objetivos principales", wXn = "Prompt", kXn = "Llamar a", SXn = "Realizar llamada de prueba para verificar la configuración", xXn = "Mensaje inicial", EXn = "El primer mensaje que dirá el agente al iniciar una llamada", TXn = "¿Problemas al importar?", AXn = "Aprender", CXn = "Aprende cómo obtener tu URI de terminación y credenciales de troncal SIP", zXn = "Suscripción del número de teléfono cancelada correctamente", OXn = "Actualizando", PXn = "Petición Firmada por Turnos", IXn = "Hola, ¿cómo estás?", RXn = "Ciclo de reuniones entre varios miembros del equipo.", NXn = "Evento gestionado", DXn = "nombre de usuario", MXn = "Cree y distribuya tipos de eventos de forma masiva a los miembros del equipo", LXn = "Gestionado", qXn = 'El "nombre de usuario" se completará con el nombre de usuario de los miembros asignados', jXn = "Asignar a", FXn = "Introduce un número de teléfono para la llamada de prueba", VXn = "Realizar llamada de prueba", BXn = "Crear nuevo agente de voz cal.ai para flujo de trabajo", UXn = "Crea un nuevo agente de voz cal.ai para automatizar tus flujos de trabajo", WXn = "Número de teléfono (para que nuestro agente llame)", GXn = "Compra un número de teléfono o importa uno que ya tengas en twilio", HXn = "Probar agente", KXn = "Probar llamada web", YXn = "Números de teléfono", ZXn = "Dar de baja", QXn = "Eliminar paso del flujo de trabajo", JXn = "Dar de baja el número de teléfono", XXn = "Comprar un nuevo número", eeo = "Solo puedes comprar números de teléfono de EE. UU. Para otros países, puedes importar tu propio número de teléfono de Twilio.", teo = "Compre un número de EE. UU. por ${{priceInDollars}} al mes", neo = "Destinos de llamadas compatibles", oeo = "No hay número de teléfono conectado", reo = "Error al obtener el ID del paso del flujo de trabajo", ieo = "Agente Cal.ai", aeo = "Probar agente Cal.ai", seo = "¿Está seguro que desea eliminar este paso del flujo de trabajo?", ceo = "¿Todavía desea dar de baja el número de teléfono de este agente?", leo = "Esta acción desconectará el número de teléfono del agente. El agente no podrá realizar llamadas hasta que se conecte un nuevo número de teléfono.", deo = "Números de teléfono", ueo = "Conectar número de teléfono", _eo = "Gestiona tus números de teléfono", peo = "Importar número", meo = "Esta acción también:", feo = "Importar número de teléfono", geo = "Suscripción activa", heo = "Cancelar su suscripción de número de teléfono", veo = "Eliminar el número de teléfono asociado", beo = "No está autorizado para crear este flujo de trabajo", yeo = "Importa tu número de teléfono de Twilio para usar con Phone", $eo = "${{price}}/mes", weo = "Comprar nuevo número", keo = "Comprar un número de teléfono cuesta ${{priceInDollars}} al mes. Se le cobrará mensualmente por cada número de teléfono activo.", Seo = "Código de área (opcional)", xeo = "No hay números de teléfono", Eeo = "Número de teléfono comprado con éxito", Teo = "Cancelar suscripción de número de teléfono", Aeo = "Sí, cancelar suscripción", Ceo = "¿Está seguro de que desea cancelar esta suscripción de número de teléfono? Esta acción no se puede deshacer y perderá el acceso a este número de teléfono.", zeo = "Agregar miembros...", Oeo = "Agregar miembros", Peo = "No hay miembros asignados", Ieo = "Asignado a", Reo = "Debes iniciar sesión en {{url}}", Neo = "Empezar a asignar miembros más arriba", Deo = "Los miembros no podrán editar esto", Meo = "Los miembros pueden editar", Leo = "El administrador del equipo bloqueó esta opción", qeo = "Desbloqueado por el administrador del equipo", jeo = "URL", Feo = "Oculto", Veo = "Sólo Lectura", Beo = "Enlace de una sola vez", Ueo = "Actualmente estás en el plan {{plan}}.", Weo = "Actualiza tu cuenta al plan Pro para poder utilizar todas las funciones que ofrecemos.", Geo = "Necesitas actualizar tu plan para tener más de un tipo de evento activo.", Heo = "Necesita actualizar su plan para crear un equipo.", Keo = "Puedes <1>actualizar aquí</1>.", Yeo = "Tipos de Evento", Zeo = "Crea eventos para que la gente que invites reserve en tu calendario.", Qeo = "Nuevo Tipo de Evento", Jeo = "Crea tu primer tipo de evento", Xeo = "Los tipos de eventos te permiten compartir enlaces que muestran las horas disponibles en tu calendario y permitir que la gente haga reservas contigo.", eto = "{{eventTypeTitle}} tipo de evento creado con éxito", tto = "{{eventTypeTitle}} tipo de evento actualizado con éxito", nto = "Tipo de evento eliminado con éxito", oto = "Horas", rto = "Personas", ito = "Tu Email", ato = "Cambiar Avatar", sto = "Cargar avatar", cto = "Lenguaje", lto = "Zona Horaria", dto = "Primer dia de la semana", uto = "Se repite hasta {{count}} vez", _to = "Se repite hasta {{count}} veces", pto = "Cada {{freq}} para", mto = "{{count}} evento restante", fto = "{{count}} eventos restantes", gto = "Se repite cada", hto = "repetición", vto = "repeticiones", bto = "semana", yto = "semanas", $to = "mes", wto = "meses", kto = "año", Sto = "años", xto = "{{count}} más", Eto = "Máx.", Tto = "Tema", Ato = "Color de marca", Cto = "Color de la marca (Tema claro)", zto = "Color de la marca (Tema oscuro)", Oto = "Color del tipo de evento (Tema claro)", Pto = "Color del tipo de evento (Tema oscuro)", Ito = "El archivo no se llama [idOrSlug] / [user]", Rto = "Crear equipo", Nto = "Nombre", Dto = "Equipo sin nombre", Mto = "Clientes OAuth", Lto = "Gestione clientes OAuth para su organización", qto = "Crear cliente OAuth", jto = "Cree un nuevo cliente OAuth para integraciones de terceros", Fto = "Cliente OAuth eliminado correctamente", Vto = "Crea un nuevo equipo para colaborar con los usuarios.", Bto = "Crear Nuevo Equipo", Uto = "URL de tu página de reservas", Wto = "URL de la página donde tus usuarios pueden cancelar su reserva", Gto = "URL de la página donde tus usuarios pueden reprogramar su reserva", Hto = "Este horario ya no está disponible. Por favor, regresa a la página anterior y selecciona otro horario.", Kto = "Invitaciones Abiertas", Yto = "Nuevo Equipo", Zto = "Cree su primer equipo e invite a otros usuarios a trabajar juntos.", Qto = "Crea un equipo para empezar", Jto = "Equipos", Xto = "Equipo", eno = "Organization", tno = "Facturación del equipo", nno = "Gestione la facturación para su equipo", ono = "Hemos cambiado la facturación de los equipos", rno = "Hay miembros en tu equipo sin asiento. Actualiza al plan Pro para cubrir los asientos restantes.", ino = "A partir de enero de 2022 cobramos por licencia para los miembros del equipo. Los miembros de tu equipo que tenían el plan Pro de forma gratuita están ahora en una prueba de 14 días. Una vez que caduque su prueba, estos miembros estarán ocultos para tu equipo a menos que actualices ahora.", ano = "Cree y gestiona equipos para utilizar las funciones colaborativas.", sno = "Esta función solo está disponible en el plan Pro", cno = "Para eliminar la marca {{appName}} de sus páginas de reserva, debe actualizar a una cuenta Pro.", lno = "Edite la información de su perfil, que se muestra en su enlace de programación.", dno = "Es posible que tengas que cerrar sesión y volver a entrar para ver el cambio realizado.", uno = "Algo sobre ti.", _no = "Perfil Actualizado con Éxito", pno = "Su perfil de usuario se ha actualizado correctamente.", mno = "Tu actualización está lista", fno = "Mejora tu experiencia de programación actualizando al nuevo plan y disfruta de las nuevas funcionalidades.", gno = "Todo está listo", hno = "Ya estás en el último plan. No hay nada que actualizar. ¡Disfruta de las nuevas funcionalidades y contáctanos si tienes alguna pregunta!", vno = "El usuario parece haber iniciado sesión pero no se puede encontrar en la base de datos", bno = "Incrustrar y Webhooks", yno = "Activado", $no = "Desactivado", wno = "Deshabilitar", kno = "Facturación", Sno = "aquí", xno = "Gestione su información de facturación y cancele su suscripción.", Eno = "Disponibilidad", Tno = "Editar disponibilidad", Ano = "Configure los horarios en los que está disponible para realizar reservas.", Cno = "Copiar tiempos en", zno = "Copiar tiempos a …", Ono = "Cambia tu Horario Semanal", Pno = "Logotipo", Ino = "Error", Rno = "Introduce al menos un carácter", Nno = "Introduce al menos {{count}} caracteres", Dno = "Logo del Equipo", Mno = "Añadir Localización", Lno = "Asistentes", qno = "Añadir Asistentes", jno = "Mostrar Opciones Avanzadas", Fno = "Ocultar ajustes avanzados", Vno = "Nombre del Evento", Bno = "Nombre del evento en el calendario", Uno = "Nombre que aparecerá en los calendarios", Wno = "Reunión con {{attendeeName}}", Gno = "Campos Adicionales", Hno = "Se requiere que el planificador introduzca entradas adicionales antes de confirmar la reserva", Kno = "Etiqueta", Yno = "Marcador de posición", Zno = 'Usa el correo electrónico "Agregar al calendario" como el organizador', Qno = "Mostraremos esta dirección de correo electrónico como el organizador y enviaremos correos de confirmación aquí.", Jno = 'Si está habilitado, mostraremos la dirección de correo electrónico de tu "Agregar al calendario" como organizador y enviaremos correos de confirmación allí.', Xno = "Ten en cuenta que puede que necesites desconectar y luego volver a conectar tu cuenta de 'Agregar al calendario' para usar esta función.", eoo = "Tipo", too = "Editar", noo = "Agregar una entrada", ooo = "Ocultar notas en el calendario", roo = "Por razones de privacidad, las entradas y notas adicionales se ocultarán en la entrada del calendario. Seguirán enviándose a su correo electrónico.", ioo = "La reserva debe confirmarse manualmente antes de que se envíe a las integraciones y se genere un correo de confirmación.", aoo = "Las reservas no confirmadas aún bloquean los espacios en el calendario.", soo = "Evento recurrente", coo = "Las personas pueden suscribirse a eventos recurrentes", loo = "Conecta y únete", doo = "No se puede usar con tipos de eventos de pago.", uoo = "Las reuniones instantáneas no son compatibles con eventos recurrentes y aplicaciones de pago todavía.", _oo = "Experimental: Los eventos de reuniones instantáneas son actualmente experimentales.", poo = "A partir", moo = "Desactivar Invitados", foo = "Desactiva agregar invitados adicionales al hacer la reserva.", goo = "Generar una URL privada", hoo = "Activar URL privada", voo = "Enlace privado", boo = "Su enlace privado se regenera después de cada uso", yoo = "Copiar enlace privado", $oo = "Copiar enlace privado al evento", woo = "Generar una URL privada para compartir sin exponer su nombre de usuario de {{appName}}", koo = "Enlaces privados", Soo = "Generar URLs privadas sin exponer el nombre de usuario, con límites configurables de caducidad y uso", xoo = "Agregar nuevo enlace", Eoo = "Enlace privado copiado", Too = "Los invitados pueden programar", Aoo = "Rango de Fechas", Coo = "Días del Calendário", zoo = "Días Laborales", Ooo = "Establecer una dirección o un lugar", Poo = "Establecer un enlace a la reunión", Ioo = "No se puede alternar. Solo se puede desbloquear para tipos de eventos secundarios", Roo = "{{appName}} le pedirá a su invitado que introduzca un número de teléfono antes de agendar.", Noo = "{{appName}} proporcionará una URL de reunión de Google Meet.", Doo = "{{appName}} proporcionará una URL de reunión de Zoom.", Moo = "{{appName}} proporcionará una URL de reunión de Tandem.", Loo = "{{appName}} proporcionará una URL de la video llamada.", qoo = "Cal proporcionará una URL de reunión de Jitsi Meet.", joo = "{{appName}} proporcionará una URL de la videollamada de Huddle01 Web3.", Foo = "{{appName}} proporcionará una URL de reunión de MS Teams. NOTA: DEBE TENER UNA CUENTA DE TRABAJO O INSTITUCIÓN", Voo = "Requiere Pago", Boo = "Necesita agregar un nombre", Uoo = "Comisión por Transacción", Woo = "Tu Evento fue Actualizado con Éxito.", Goo = "Ocultar Tipo de Evento", Hoo = "Editar Localización", Koo = "en el futuro", Yoo = "Cuando se reserva con menos de <0></0> de antelación", Zoo = "Dentro de un rango de fechas", Qoo = "Indefinidamente en el futuro", Joo = "Agregar nuevo campo de entrada personalizado", Xoo = "Chat Rápido", ero = "Crear Nuevo Tipo de Evento para Equipo", tro = "Crear Nuevo Tipo de Evento", nro = "Crea un nuevo tipo de evento para que las personas reserven horarios.", oro = "Tamaño", rro = "Aviso de Reserva", iro = "Desplazar horas de inicio", aro = "Desplazar las franjas horarias que se muestran a los que reservan por un número específico de minutos", sro = "Desplazar por", cro = "por ejemplo, esto mostrará las franjas horarias a quienes reservan a las {{ adjustedTime }} en lugar de {{ originalTime }}", lro = "Intervalos de tiempo", dro = "Usar duración del evento (por defecto)", uro = "¿Eliminar tipo de evento?", _ro = "¿Eliminar tipo de evento gestionado?", pro = "Cualquier persona con la que haya compartido este enlace ya no podrá reservar con él.", mro = "Los miembros asignados a este tipo de evento también tendrán sus tipos de eventos eliminados.", fro = "Cualquier persona con quien hayan compartido su enlace ya no podrá reservar usándolo.", gro = "Sí, eliminar", hro = "Eliminar cuenta", vro = "Sí, eliminar cuenta", bro = "Cualquier persona con la que hayas compartido el enlace de tu cuenta ya no podrá agendar con ella y cualquier preferencia que hayas guardado se perderá.", yro = "Integraciones", $ro = "Aplicaciones", wro = "Aquí puede encontrar una lista de sus aplicaciones", kro = "Lista de aplicaciones", Sro = "Aplicaciones {{category}}", xro = "App Store", Ero = "Conectar personas, tecnología y lugar de trabajo.", Tro = "Conecte su aplicación de videoconferencia", Aro = "Ajustes", Cro = "El tipo de evento se ha movido correctamente", zro = "Siguiente paso", Oro = "Saltar paso", Pro = "Paso anterior", Iro = "Instalar", Rro = "Comenzar prueba gratuita", Nro = "Instalado", Dro = "{{count}} instalación activa", Mro = "{{count}} instalaciones activas", Lro = "Instalado globalmente", qro = "Aplicación instalada correctamente", jro = "No se ha podido instalar la aplicación", Fro = "Desconectar", Vro = "Incorpora tu calendario en tu página web", Bro = "Conecta tus aplicaciones favoritas.", Uro = "Automatización", Wro = "Configure cómo deben interactuar sus tipos de eventos con sus calendarios.", Gro = "Activa/desactiva los calendarios en los que desees comprobar conflictos para evitar reservas dobles.", Hro = "Conectar calendario adicional", Kro = "Calendario actualizado correctamente", Yro = "Verificar aquí", Zro = "Conferencias", Qro = "Calendario", Jro = "Pagos", Xro = "No instalado", eio = "Las contraseñas no coinciden.", tio = "Este campo es requerido.", nio = "Estado", oio = "Ver disponibilidad de usuario", rio = "El usuario necesita aceptar la invitación para ver su disponibilidad", iio = "Activar estado Ausente", aio = "Desactivar estado Ausente", sio = "Error al actualizar el estado ausente", cio = "Este usuario se encuentra Ausente.", lio = "La persona a la que estás intentando reservar se ha marcado a sí misma como Ausente, por lo tanto, no acepta nuevas reservas por ahora.", dio = "Conoce personas con los mismos tokens", uio = "Solo reservar y permitir reservas de personas que compartan los mismos tokens, DAO o NFT.", _io = "Tu cuenta se creó mediante un Proveedor de Identidad.", pio = "Tu cuenta es administrada por {{provider}}", mio = "Para cambiar tu correo electrónico, contraseña, habilitar la autenticación de doble factor y más, por favor visita la configuración de tu cuenta de {{provider}}.", fio = "Tu cuenta está gestionada por un proveedor de identidad diferente. Intenta iniciar sesión con {{provider}}.", gio = "Error al crear un nuevo usuario. Por favor, inténtalo de nuevo.", hio = "Iniciar sesión con Google", vio = "Iniciar sesión con SAML", bio = "Inicie sesión con SAML/OIDC", yio = "Continuar con correo electrónico", $io = "Continuar con Google", wio = "Último uso", kio = "Necesitarás generar un token de acceso desde tu antigua herramienta de programación.", Sio = "Importar desde", xio = "Token de acceso", Eio = "Hoja de ruta", Tio = "Categorías destacadas", Aio = "Indicadores de funciones", Cio = "Aquí puedes activar o desactivar las funciones de tu instancia de Cal.com.", zio = "Categorías populares", Oio = "{{count}} aplicación", Pio = "{{count}} aplicaciones", Iio = "Aplicaciones populares", Rio = "Más popular", Nio = "Apps instaladas", Dio = "Gratis", Mio = "No hay aplicaciones de {{category}}", Lio = "Todas las aplicaciones", qio = "Añade una aplicación de calendario para comprobar si hay conflictos y evitar reservas duplicadas", jio = "Intente agregar una aplicación de conferencia para videollamadas con sus clientes", Fio = "Añade una aplicación de pagos para facilitar las transacciones con tus clientes", Vio = "Añada una aplicación de análisis para sus páginas de reserva", Bio = "Añada una aplicación de automatización para utilizar", Uio = "Añade cualquier otro tipo de aplicación para hacer todo tipo de tareas", Wio = "Agregue una aplicación de mensajería para configurar notificaciones y recordatorios personalizados", Gio = "Agregue una aplicación CRM para realizar un seguimiento de con quiénes se ha reunido", Hio = "Configure el(los) calendario(s) para comprobar conflictos y evitar reservas duplicadas.", Kio = "Configura los servicios de procesamiento de pagos que vas a utilizar para cobrar a tus clientes.", Yio = "Configure qué aplicaciones de análisis va a utilizar para sus páginas de reserva", Zio = "Todas tus aplicaciones instaladas de otras categorías.", Qio = "Configure qué aplicaciones de conferencia usará", Jio = "Configure qué aplicaciones de automatización va a utilizar", Xio = "Configure qué aplicaciones de mensajería usar para configurar notificaciones y recordatorios personalizados", eao = "Configure qué aplicaciones de CRM usar para realizar un seguimiento de las personas con las que se ha reunido", tao = "Análisis", nao = "No hay aplicaciones instaladas", oao = "Las aplicaciones te permiten mejorar significativamente tu flujo de trabajo y mejorar tu agendamiento.", rao = "Explore la tienda de aplicaciones", iao = "Administra tus aplicaciones instaladas o cambia la configuración", aao = "Ver aplicaciones", sao = "Características", cao = "Permisos", lao = "Términos y privacidad", dao = "Publicado por {{author}}", uao = "Suscribirse", _ao = "Comprar", pao = "Instalar aplicación", mao = "Categorías", fao = "Precios", gao = "Más información", hao = "Prueba ahora", vao = "Política de privacidad", bao = "Términos de servicio", yao = "Eliminar", $ao = "Añadir", wao = "{{count}} instaladas", kao = "Verificar billetera", Sao = "Crear eventos en", xao = "Esta es una función comercial", Eao = "Puedes probar esta función localmente pero no en producción.", Tao = "Para adquirir una licencia comercial, por favor contacta a nuestro equipo de ventas. Si ya tienes una clave de licencia, contacta a support@cal.com para obtener ayuda.", Aao = "Falta la licencia", Cao = "Pasos siguientes", zao = "Adquirir una licencia comercial", Oao = "El plan de infraestructura está basado en el uso y tiene descuentos favorables para empresas emergentes.", Pao = "Crea una cuenta a través de Prisma Studio", Iao = "Aprende cómo configurar tu primer usuario", Rao = "Contactar con Ventas", Nao = "Error 404", Dao = "Establecer como predeterminado", Mao = "Nuevo agenda", Lao = "Añadir un nuevo agenda", qao = "Añadir un calendario nuevo", jao = "Especifica dónde se añadirán los eventos nuevos cuando haya reservas.", Fao = "Eliminar agenda", Vao = "Al borrar un horario se eliminará de todos los tipos de eventos. Esta acción no se puede deshacer.", Bao = "Horario {{scheduleName}} creado con éxito", Uao = "El horario de {{scheduleName}} se actualizó correctamente", Wao = "Programación eliminada exitosamente", Gao = "Horas laborables", Hao = "Crear un horario de disponibilidad", Kao = "Crear horarios de disponibilidad le permite gestionar la disponibilidad a través de tipos de eventos. Pueden aplicarse a uno o más tipos de eventos.", Yao = "Requiere la propiedad de un token perteneciente a la siguiente dirección:", Zao = "Juan Pérez", Qao = "Formato de hora", Jao = "Redirigir al reservar ", Xao = 'Estás siendo redirigido a {{ url }} en $t(second, {"count": {{seconds}} }).', eso = "https://example.com/redirect-to-my-success-page", tso = "Redirija a una URL personalizada después de una reserva exitosa", nso = "Duplicado", oso = "Ofrecer plazas", rso = "Ofrecer plazas para las reservas (desactiva las reservas de invitados y las optativas)", iso = "Asiento disponible", aso = "Asientos disponibles", sso = "Cupos casi llenos", cso = "Los cupos se están copando rápido", lso = "Número de plazas por reserva", dso = "Establecer ventana de unión a la reunión (segundos): El período de tiempo en segundos dentro del cual el anfitrión puede unirse y comenzar la reunión. Después de este período, la URL de unión a la reunión expirará.", uso = "Introduzca el número de plazas", _so = "Puede administrar sus horarios en la página Disponibilidad.", pso = "No hay más plazas disponibles", mso = "Claves API", fso = "Clave API", gso = "Probar clave API", hso = "¡Prueba aprobada!", vso = "Prueba fallida", bso = "Proporcionar clave API", yso = "Las claves API le permiten realizar llamadas API para su propia cuenta.", $so = "Crea un marketplace o plataforma en su lugar.", wso = "Genere claves API que se usarán para acceder a su propia cuenta.", kso = "Crear una clave API", Sso = "Nombrar esta clave", xso = "Por ejemplo: Desarrollo", Eso = "Clave API sin nombre", Tso = "Esta clave API no tiene fecha de caducidad", Aso = "Editar clave API", Cso = "Clave API creada exitosamente", zso = "Clave API actualizada exitosamente", Oso = "Crear", Pso = "Guarde esta clave API en algún lugar seguro.", Iso = "No podrá volver a verla una vez que cierre esta ventana modal.", Rso = "Copiar al portapapeles", Nso = "Habilitado tras la actualización", Dso = "El enlace privado funcionará después de guardar", Mso = "Revocar esta clave API", Lso = "Desactivar reprogramación", qso = "Los invitados ya no pueden reprogramar el evento con la invitación del calendario o correo electrónico", jso = "Permitir reservas a través del enlace de reprogramación", Fso = "Cuando está habilitado, los usuarios podrán crear una nueva reserva al intentar reprogramar una reserva cancelada", Vso = "Desactivar cancelación", Bso = "Los invitados ya no pueden cancelar el evento con la invitación del calendario o correo electrónico", Uso = "Revocar clave API", Wso = "¡Clave API copiada!", Gso = "La clave API caducará el", Hso = "¿Eliminar permanentemente esta clave de API de tu cuenta?", Kso = "Copiar", Yso = "Fecha de caducidad", Zso = "Caducó", Qso = "Nunca caduca", Jso = "Caduca", Xso = "Solicitud para reprogramar tu reserva", eco = "Motivo de la reprogramación", tco = "Reserva una nueva hora", nco = "Solicitud de reprogramación enviada", oco = "Esto cancelará la reunión programada, notificará al planificador y te pedirá que escojas una nueva hora.", rco = "Motivo de la solicitud de reprogramación", ico = "Solicitar reprogramación ", aco = "Editar reserva", sco = "Reprogramar reserva", cco = "Hora anterior", lco = "Añade un GIF a tu página de confirmación", dco = "Buscar", uco = "Suplantar", _co = "Suplantación de usuario", pco = "Permite a nuestro equipo de soporte iniciar sesión temporalmente para ayudar a resolver rápidamente cualquier problema reportado.", mco = "Permita a los administradores de su equipo iniciar sesión temporalmente como usted.", fco = "Gratis para individuos. Planes de equipo para funciones colaborativas.", gco = "Hacer la organización privada", hco = "Los miembros de tu organización no podrán ver a otros miembros de la organización cuando esto esté activado.", vco = "Hacer que el equipo sea privado", bco = "Los miembros de su equipo no podrán ver a otros miembros del equipo cuando esto esté activado.", yco = "No puede ver a todos los miembros de un equipo privado.", $co = "No puedes ver los equipos de una organización privada.", wco = "Permitir múltiples duraciones", kco = "Todos los usos de esta función son revisados.", Sco = 'Suplantando nombre de usuario "{{user}}".', xco = "Haga clic aquí para detener.", Eco = "Actualizado - Su evento cambió la ubicación", Tco = "Añadido - Nuevos invitados añadidos a tu evento", Aco = "Ubicación cambiada: {{eventType}} con {{name}} el {{date}}", Cco = "Invitados añadidos: {{eventType}} con {{name}} el {{date}}", zco = "Ubicación actual", Oco = "Nueva ubicación", Pco = "Sesión", Ico = "Controle la sesión de su cuenta", Rco = "Tiempo de sesión agotado después de", Nco = "Tiempo de sesión agotado", Dco = "Invalide su sesión después de una cierta cantidad de tiempo.", Mco = "No se ha definido ninguna ubicación", Lco = "Establecer ubicación", qco = "Actualizar ubicación", jco = "Ubicación actualizada", Fco = "La actualización de la ubicación ha fallado", Vco = "Invitados añadidos", Bco = "No se pueden añadir invitados", Uco = "Eso no parece una dirección de correo electrónico", Wco = "Los correos electrónicos deben ser únicos y válidos", Gco = "Eso no parece una URL", Hco = "Coloque este código en su HTML donde desea que aparezca su widget de {{appName}}.", Kco = "Cree o actualice un componente React existente como se muestra a continuación.", Yco = "Copiar código", Zco = "¡Código copiado!", Qco = "¿Cómo quiere añadir {{appName}} a su sitio?", Jco = "Elija una de las siguientes maneras de poner {{appName}} en su sitio.", Xco = "Configurando su integración con Zapier", elo = "Configurando su integración Make", tlo = "Generar clave API", nlo = "Generar una clave API para usar con {{appName}} en", olo = "Su clave API única", rlo = "Copie esta clave API y guárdela en algún lugar seguro. Si pierde esta clave tendrá que generar una nueva.", ilo = "<0>Inicie sesión en su cuenta de Zapier y cree un nuevo Zap.</0><1>Seleccione Cal.com cómo su aplicación Trigger. También elija un evento Trigger.</1><2>Seleccione su cuenta e ingrese su Clave API única.</2><3>Pruebe su Trigger.</3><4>¡Listo!</4>", alo = "Ve a <0>Enlace de invitación de Make</0> e instala la aplicación de Cal.com.", slo = "Inicia sesión en tu cuenta de Make y crea un nuevo escenario.", clo = "Selecciona Cal.com como tu aplicación de activación. También elige un evento de activación.", llo = "Elige tu cuenta y luego ingresa tu clave API única.", dlo = "Prueba tu activador.", ulo = "¡Ya está listo!", _lo = "Instale primero la aplicación Zapier desde la App Store.", plo = "Instale primero la aplicación Make desde la App Store.", mlo = "Instalación de la aplicación", flo = "Aplicación no instalada", glo = "Lo sentimos, esta aplicación no está instalada en tu cuenta. Por favor visita nuestra tienda de aplicaciones para explorar y descubrir esta y otras grandes aplicaciones.", hlo = "Conectar con Apple Server", vlo = "URL del calendario", blo = "Genere una contraseña específica de la aplicación para utilizarla con {{appName}} en", ylo = "No se puede añadir esta cuenta de Apple Calendar. Por favor asegúrate de estar usando una contraseña específica para la aplicación en lugar de la contraseña de tu cuenta.", $lo = "Sus credenciales serán almacenadas y cifradas.", wlo = "Se almacenará y cifrará.", klo = "Ir a App Store", Slo = "Intenta volver a conectar tu calendario con todos los permisos necesarios", xlo = "Configurar un número de teléfono para la reunión", Elo = "No hay franjas horarias ocupadas", Tlo = "Mostrar en la página de reservas", Alo = "La ubicación será visible antes de confirmar la reserva", Clo = "Añadir GIF", zlo = "Buscar en Giphy", Olo = "Añadir enlace de Giphy", Plo = "Añadiendo un GIF a la página de confirmación", Ilo = "Busque un GIF para mejorar su página de confirmación", Rlo = "Comparta sus comentarios", Nlo = "Recursos", Dlo = "Documentación de soporte", Mlo = "Documentación del desarrollador", Llo = "Póngase en contacto", qlo = "Contactar con Soporte", jlo = "Soporte Premium", Flo = "Soporte comunitario", Vlo = "Comentarios", Blo = "¡Gracias por sus comentarios!", Ulo = "Error al enviar comentarios", Wlo = "Comparte tus comentarios aquí:", Glo = "Detalles de la reserva", Hlo = "o", Klo = "No tiene importancia", Ylo = "Ir a: ", Zlo = "Zapier Invite Link", Qlo = "Se creará una URL de la reunión una vez que se confirme el evento.", Jlo = "Mostrar dinámicamente el nombre de su asistente para usted, o su nombre si es visto por su asistente", Xlo = "Ubicación del evento", edo = "Razón para reagendar (opcional)", tdo = "Informa a los demás la razón por la que necesitas reagendar", ndo = "Este evento se canceló", odo = "Le enviamos un correo electrónico a usted y a los demás asistentes para informarles.", rdo = "Esta entrada se mostrará al reservar este evento.", ido = "La URL de la reunión está en el correo de confirmación", ado = "La URL debe empezar por http:// o https://", sdo = "Se proporcionará el número de teléfono", cdo = "antes del inicio del evento", ldo = "cuando se cancela el evento", ddo = "Después de que los anfitriones no se unieron al video de Cal", udo = "Después de que los invitados no se unieron al video de Cal", _do = "Unirse a la videollamada", pdo = "Iniciar sesión en Cal.com", mdo = "Iniciar sesión en Cal.com", fdo = "Haz seguimiento de tus reuniones, recibe notificaciones y gestiona tu agenda de manera más efectiva.", gdo = "Haz seguimiento de tus reuniones y gestiona tu agenda de manera más efectiva", hdo = "No se pudo unir a la llamada. Por favor, inténtalo de nuevo.", vdo = "Elige cómo te gustaría unirte a esta llamada", bdo = "Elige cómo quieres aparecer en la llamada", ydo = "cuando se reserva un nuevo evento", $do = "enviar correo electrónico al anfitrión", wdo = "enviar correo electrónico a los asistentes", kdo = "Enviar un SMS al asistente", Sdo = "enviar SMS a un número específico", xdo = "Envíe fácilmente recordatorios de reuniones por SMS a sus asistentes", Edo = "enviar un mensaje de Whatsapp a un número específico", Tdo = "enviar un mensae de Whatsapp al asistente", Ado = "Flujos de trabajo", Cdo = "Flujo de trabajo nuevo", zdo = "¿Cómo te gustaría empezar?", Odo = "Agregar un flujo de trabajo nuevo", Pdo = "cuando el evento se vuelva a programar", Ido = "Desencadenante", Rdo = "Desencadenantes", Ndo = "Acción", Ddo = "Crear flujos de trabajo para automatizar notificaciones y recordatorios", Mdo = "Nombre del flujo de trabajo", Ldo = "Flujo de trabajo personalizado", qdo = "{{workflowName}} creado exitosamente", jdo = "¿Está seguro que desea eliminar este flujo de trabajo?", Fdo = "Eliminar flujo de trabajo", Vdo = "Sí, eliminar el flujo de trabajo", Bdo = "Flujo de trabajo eliminado correctamente", Udo = "¿Cuánto tiempo antes de que comience el evento?", Wdo = "días", Gdo = "horas", Hdo = "minutos", Kdo = "m", Ydo = "h", Zdo = "Cree su primer workflow", Qdo = "Los flujos de trabajo te permiten automatizar el envío de recordatorios y notificaciones.", Jdo = "Activo en", Xdo = "Flujo de trabajo {{workflowName}} actualizado correctamente", euo = "Este es un nombre de usuario estándar y la actualización te llevará a la facturación para bajar de categoría.", tuo = "Este es un nombre de usuario premium, obtenga el suyo por {{price}}", nuo = "Actual", ouo = "premium", ruo = "estándar", iuo = "Confirmar cambio de nombre de usuario", auo = "Como estás cambiando de un nombre de usuario estándar a un nombre de usuario premium, se te llevará al pago para actualizarlo.", suo = "Como estás cambiando de un nombre de usuario premium a un nombre de usuario estándar, se te llevará al pago para bajar de categoría.", cuo = "Ir a facturación", luo = "Se requiere un pago para las reservas (0,5 % + 0,10 € de comisión por transacción)", duo = "Tu prueba ha caducado", uuo = "Eliminar aplicación", _uo = "Sí, eliminar aplicación", puo = "¿Está seguro de que desea eliminar esta aplicación?", muo = "Aplicación eliminada correctamente", fuo = "Error al eliminar la aplicación", guo = "Conferencia web", huo = "Llamada web", vuo = "Iniciar llamada web", buo = "Finalizar llamada", yuo = "Prueba tu agente con una llamada web sin necesidad de un número de teléfono", $uo = "Llamada telefónica", wuo = "Conectando con el agente...", kuo = "Llamada activa", Suo = "Llamada finalizada", xuo = "Error en la llamada", Euo = "Listo para iniciar la llamada", Tuo = "No se pudo iniciar la llamada web. Por favor, inténtalo de nuevo.", Auo = "La llamada encontró un error. Por favor, inténtalo de nuevo.", Cuo = "No se pudo inicializar la llamada web. Asegúrate de que los permisos del micrófono estén concedidos.", zuo = "Inicia una llamada para ver la conversación", Ouo = "Esperando conversación...", Puo = "Agente de IA", Iuo = "En vivo", Ruo = "Conectando...", Nuo = "Requiere confirmación", Duo = "Requiere confirmación si se reservó con < {{time}} $t({{unit}}_timeUnit) de aviso", Muo = "Puede requerir confirmación", Luo = "{{count}} tipo de evento", quo = "{{count}} tipos de eventos", juo = "{{count}} equipo", Fuo = "{{count}} equipos", Vuo = "Agregar acción", Buo = "Establecer enlace Whereby", Uuo = "Introduce un enlace Whereby válido", Wuo = "Establecer enlace Around.Co", Guo = "Introduce un enlace Around válido", Huo = "Establecer enlace Riverside", Kuo = "Introduce un enlace Riverside válido", Yuo = "Introduce un enlace Ping.gg válido", Zuo = "Conectar con Exchange 2013 Server", Quo = "Conectar con Exchange 2016 Server", Juo = "Plantilla personalizada", Xuo = "Cuerpo del mensaje", e_o = "Mensaje de texto", t_o = "¿Tienes un problema específico?", n_o = "navega por nuestros documentos", o_o = "Elija una plantilla", r_o = "Personalizado", i_o = "Recordatorio", a_o = "Reprogramado", s_o = "Reprogramado por", c_o = "Reserva original", l_o = "Completado", d_o = "Calificación", u_o = "Recordatorio: {{eventType}} con {{name}} el {{date}}", __o = "No se activará para las reservas ya existentes, ya que se le pedirá al usuario un número de teléfono al reservar el evento.", p_o = "{{count}} minuto", m_o = "{{count}}m", f_o = "{{count}} minutos", g_o = "{{count}} hora", h_o = "{{count}}h", v_o = "{{count}} horas", b_o = "Entrada inválida", y_o = "No pudimos añadir el enlace de la reunión de {{location}} a tu evento programado. Contacta a tus invitados o actualiza tu evento en el calendario para añadir los detalles. Puedes <0>cambiar tu ubicación en el tipo de evento</0> o intentar <1>eliminar y añadir la aplicación nuevamente.</1>", $_o = "No pudimos actualizar tu <1>{{calendar}}</1>. <2> Comprueba la configuración de tu calendario o elimina y añade tu calendario de nuevo </2>", w_o = "Nombre del asistente", k_o = "El nombre completo de la persona que reserva", S_o = "Integración rota", x_o = "Hubo un problema al añadir un enlace de vídeo", E_o = "Hubo un problema al actualizar tu calendario", T_o = "Activo en {{count}} tipo de evento", A_o = "Activo en {{count}} tipos de eventos", C_o = "Activo en {{count}} equipo", z_o = "Activo en {{count}} equipos", O_o = "Activo en todos los tipos de eventos", P_o = "Activo en todos los equipos", I_o = "No hay tipos de evento activos", R_o = "No hay equipos activos", N_o = "Nuevo asistente {{name}} en {{eventType}} el {{date}}", D_o = "Alguien se ha añadido a un evento", M_o = "Variable", L_o = "Nombre del evento", q_o = "Nombre completo del asistente", j_o = "Fecha del evento", F_o = "Hora del evento", V_o = "Nombre del organizador", B_o = "Para poder usar esta función, necesita actualizarse a una cuenta Pro.", U_o = "Número de teléfono no válido", W_o = "URL no válida para {{label}}. URL de ejemplo: {{sampleUrl}}", G_o = "Navegar", H_o = "Abrir", K_o = "Cerrar", Y_o = "Actualizar", Z_o = "Comprar número de EE.UU. por {{priceInDollars}}$/mes", Q_o = "Actualizar para acceder a las grabaciones", J_o = "Las grabaciones solo están disponibles como parte de nuestro plan de equipos. Actualice para comenzar a grabar sus llamadas", X_o = "Actualiza a Enterprise para generar un número de teléfono de Agente AI que pueda llamar a los invitados para programar llamadas", epo = "Las grabaciones son parte del plan de equipos", tpo = "Esta es una función Team. Actualiza a Team para ver la disponibilidad de tu equipo.", npo = "Esta es una función Team. Actualiza a Team para automatizar los recordadorios y las notificaciones de eventos con flujos de trabajo.", opo = "Mostrar en perfil", rpo = "Insertar", ipo = "Nombre de usuario nuevo", apo = "Nombre de usuario actual", spo = "Ejemplo 1", cpo = "Ejemplo 2", lpo = "Identificador de preguntas de reserva", dpo = "Tamaño de la empresa", upo = "¿Con qué necesitas ayuda?", _po = "Formato variable", ppo = "La URL del suscriptor de Webhook ya está definida", mpo = "Ignore todos los caracteres especiales de la etiqueta de entrada adicional (utilice solo letras y números), utilice mayúsculas para todas las letras y sustituya los espacios en blanco por guiones bajos.", fpo = "¿Cómo uso las preguntas de reserva como variables?", gpo = "Descargar la aplicación de escritorio", hpo = "Establecer enlace Ping", vpo = "Límite de tasa excedido", bpo = "Cuando algo sucede", ypo = "Una acción es realizada", $po = "Probar acción", wpo = "Notificación enviada", kpo = "Sin entrada", Spo = "Probar acción de flujo de trabajo", xpo = "Enviar SMS", Epo = "¿Está seguro de que desea enviar un SMS al {{number}}?", Tpo = "No hay ningún calendario predeterminado conectado", Apo = "Puede conectar su calendario desde <1>aquí</1>.", Cpo = "Calendario predeterminado", zpo = "Ocultar del perfil", Opo = "Configuración del evento", Ppo = "No se encontró disponibilidad en el horario", Ipo = "Límites", Rpo = "Con qué frecuencia se puede reservar", Npo = "Ajustes del calendario y más...", Dpo = "Avanzado", Mpo = "Configurar pagos para el evento", Lpo = "Configuración de eventos: varias duraciones requieren al menos una opción.", qpo = "Configuración de eventos: seleccione una duración predeterminada válida.", jpo = "Los límites de las reservas deben estar en orden ascendente. [día, semana, mes, año]", Fpo = "Los límites de duración deben estar en orden ascendente. [día, semana, mes, año]", Vpo = "Seleccione a qué calendario añadir reservas", Bpo = "Nombre de evento personalizado", Upo = "Cree nombres de eventos personalizados para que el evento aparezca en el calendario", Wpo = "Código de autenticación de dos factores incorrecto", Gpo = "¿A qué tipo de evento se aplicará esto?", Hpo = "Aplicar a todos, incluidos los tipos de eventos futuros", Kpo = "Aplicar a todos los tipos de eventos de equipo y usuario", Ypo = "¿A qué equipo se aplicará esto?", Zpo = "Los flujos de trabajo permiten una automatización simple para enviar notificaciones y recordatorios que le permiten crear procesos para sus eventos.", Qpo = "Esta es una configuración interna y no afectará la manera en que se muestran los horarios en las páginas de reservas públicas para usted o para cualquier persona que lo solicite.", Jpo = "Crear un flujo de trabajo", Xpo = "Hacer esto", emo = "Apagar", tmo = "Activar", nmo = "Las reservas canceladas no se pueden reprogramar", omo = "Configuración actualizada correctamente", rmo = "Error al actualizar la configuración", imo = "Mi URL personal de {{appName}}", amo = "Algunas frases sobre usted, esta información aparecerá en la página de su URL personal.", smo = "Finalizar configuración y comenzar", cmo = "Este usuario no ha añadido una biografía todavía.", lmo = "Biografía", dmo = "Eliminar cuenta", umo = "¿Está seguro que desea eliminar su cuenta de {{appName}}?", _mo = "Eliminar mi cuenta", pmo = "Inicio de la semana", mmo = "Grabaciones", fmo = "Grabación", gmo = "Feliz programación", hmo = "Seleccione los calendarios en los que desee comprobar conflictos para evitar reservas dobles.", vmo = "Comprobar conflictos", bmo = "Ver grabaciones", ymo = "Comprobar si hay grabaciones", $mo = "Agregando eventos a", wmo = "Siga las preferencias del sistema", kmo = "Colores de marca personalizados", Smo = "Personalice el color de su propia marca en su página de reservas.", xmo = "Pro", Emo = 'Elimina cualquier marca relacionada con {{appName}}, p. ej., "Powered by {{appName}}".', Tmo = "Reunión instantánea con {{name}}", Amo = "Imagen de perfil", Cmo = "Cargar", zmo = "Agregar foto de perfil", Omo = "Dirección del token", Pmo = "Blockchain", Imo = "Contraseña anterior", Rmo = "Su contraseña nueva supersegura", Nmo = "Error al actualizar la contraseña", Dmo = "Autenticación de dos factores", Mmo = "Configurar un calendario repetitivo", Lmo = "hoy", qmo = "Aspecto", jmo = "Mi cuenta", Fmo = "General", Vmo = "Calendarios", Bmo = "Facturas", Umo = "Inserciones", Wmo = "Suplantación", Gmo = "Configuración para administrar la suplantación del usuario", Hmo = "Suplantaciones recientes", Kmo = "Suplantar rápidamente", Ymo = "No hay suplantaciones recientes", Zmo = "Usuarios", Qmo = "Usuario", Jmo = "Administra los ajustes para tu perfil de {{appName}}", Xmo = "Aquí puede encontrar una lista de todos los usuarios", efo = "Lista de usuarios", tfo = "Administre los ajustes para tu idioma y zona horaria", nfo = "Configura cómo interactúan tus tipos de eventos con tus calendarios", ofo = "Administra los ajustes para el aspecto de tu reserva", rfo = "Añada sus aplicaciones de videoconferencia favoritas para sus reuniones", ifo = "Añadir aplicación de conferencia", afo = "Administra los ajustes para las contraseñas de tu cuenta", sfo = "Configure su autenticación de doble factor", cfo = "Solo necesitamos información básica para configurar tu perfil.", lfo = "Omitir", dfo = "Hacerlo más tarde", ufo = "Define los rangos de tiempo en los que estás disponible", _fo = "Puedes personalizar todo esto más tarde en la página de disponibilidad.", pfo = "Conecte un calendario primero", mfo = "Complete su perfil", ffo = "Puedes añadir más calendarios desde la tienda de aplicaciones", gfo = "Conectar aplicaciones de conferencia", hfo = "Conectar aplicaciones de calendario", vfo = "Conectar aplicaciones de pago", bfo = "Conecte aplicaciones de automatización", yfo = "Conecte aplicaciones de análisis", $fo = "Conectar otras aplicaciones", wfo = "Conectar aplicaciones de mensajería", kfo = "Conectar aplicaciones CRM", Sfo = "Paso {{currentStep}} de {{maxSteps}}", xfo = "Añadir variable", Efo = "Número de teléfono personalizado", Tfo = "Plantilla de mensaje", Afo = "Asunto del correo electrónico", Cfo = "Añadir variables de texto dinámico", zfo = "Nombre del tipo de evento", Ofo = "Fecha del evento", Pfo = "La duración del evento", Ifo = "Hora de inicio del evento", Rfo = "Tipo de evento no encontrado", Nfo = "Número para llamar", Dfo = "El número de teléfono del usuario al que estás llamando", Mfo = "Ubicación", Lfo = "Ubicación del evento", qfo = "Notas adicionales", jfo = "Notas adicionales de la reserva", Ffo = "Nombre completo de la persona que reserva", Vfo = "Nombre del organizador", Bfo = "Para", Ufo = "El flujo de trabajo {{workflowName}} se ha activado {{offOn}} con éxito", Wfo = "Descargar respuestas", Gfo = "Descargue todas las respuestas de su formulario en formato CSV.", Hfo = "Ver respuestas", Kfo = "Descargar", Yfo = "Descargando", Zfo = "Descargar grabación", Qfo = "Las transcripciones están habilitadas ahora", Jfo = "Las transcripciones están detenidas ahora", Xfo = "Descargar transcripción", ego = "Transcripción", tgo = "Una grabación de su llamada reciente en {{appName}} está lista para descargar", ngo = "La transcripción de su llamada reciente en {{appName}} está lista para descargar. Los enlaces son válidos solo por 1 hora.", ogo = "También puedes descargar la transcripción desde los archivos adjuntos", rgo = "Nota: El enlace de descarga es válido solo por 12 horas. Puede generar un nuevo enlace de descarga siguiendo las instrucciones <1>aquí</1>.", igo = "Nota: El enlace de descarga es válido solo por 12 horas. Puedes generar un nuevo enlace de descarga siguiendo las instrucciones.", ago = "Crea tu primer formulario", sgo = "Con los formularios de orientación puedes hacer preguntas calificadoras y encaminarte hacia la persona o tipo de evento correctos.", cgo = "Crea tu primer Webhook", lgo = "Con Webhooks puedes recibir datos de reuniones en tiempo real cuando suceda algo en {{appName}}.", dgo = "Para un máximo de", ugo = "evento", _go = "eventos", pgo = "Administra los ajustes para el perfil de tu equipo", mgo = "Administre la configuración para el perfil de su organización", fgo = "Usuarios que están en el grupo", ggo = "Gestione los administradores y miembros de su organización", hgo = "URL del equipo", vgo = "Miembros del equipo", bgo = "Más", ygo = "Flujos de trabajo de Cal.ai", $go = "y {{count}} más", wgo = "Consideramos la aplicación móvil como una extensión de la aplicación web. Si está realizando acciones complicadas, consulta la aplicación web.", kgo = "Enviar recordatorio por SMS al asistente, 24 horas antes de que el evento comience", Sgo = "Enviar SMS personalizado al asistente cuando se reprograma el evento", xgo = "Enviar correo electrónico personalizado al anfitrión cuando se reserve un evento nuevo", Ego = "Enviar recordatorio por correo electrónico al asistente, 1 hora antes de que el evento comience", Tgo = "Enviar correo electrónico personalizado al anfitrión cuando se reprograme el evento", Ago = "Enviar SMS personalizado al anfitrión cuando se reserve un evento nuevo", Cgo = "Enviar recordatorio por SMS", zgo = "24 horas antes del inicio del evento", Ogo = "Seguimiento de ausencias", Pgo = "30 minutos después de finalizar el evento", Igo = "Recordar a los asistentes que traigan identificación", Rgo = "1 día antes del inicio del evento", Ngo = "Recordatorio por email", Dgo = "1 hora antes del inicio del evento", Mgo = "Recordatorio SMS personalizado", Lgo = "Cuando se programa el evento", qgo = "Recordatorio por email personalizado", jgo = "Evento reprogramado para el anfitrión", Fgo = "Incluir el conteo de reservas de los tipos de eventos gestionados", Vgo = "¡Bienvenido a {{appName}}!", Bgo = "Podrás editarlo más tarde.", Ugo = "Conectaré mi calendario más tarde", Wgo = "Se produjo un problema al guardar tus datos. Inténtalo de nuevo o ponte en contacto con el servicio de atención al cliente.", Ggo = "Adquirir las plazas que faltan", Hgo = "Duración de la franja", Kgo = "Aspecto de la reserva", Ygo = "Administra los ajustes para el aspecto de la reserva de tu equipo", Zgo = "Administre la configuración de la apariencia de las reservas de su organización", Qgo = "Solo el propietario de este equipo puede hacer cambios en la reserva ", Jgo = 'Elimina cualquier marca relacionada con {{appName}}, p. ej., "Powered by {{appName}}"', Xgo = "{{teamName}} te invitó a unirte a su equipo como {{role}}", eho = "El token no es válido o ha caducado.", tho = "Ver reserva", nho = "Conectar a Microsoft Exchange", oho = "Método de autenticación", rho = "Autenticación básica", iho = "Autenticación NTLM", aho = "Compresión GZip", sho = "Versión de Exchange", cho = "2007 SP1", lho = "2010", dho = "2010 SP1", uho = "2010 SP2", _ho = "2013", pho = "2013 SP1", mho = "2015", fho = "2016", gho = "Enrutamiento", hho = "Crea formularios para dirigir a los asistentes a sus destinos correctos", vho = "Enviar correo electrónico al propietario", bho = "Mande un correo electrónico al propietario cuando se envía el formulario", yho = "Enviar correo electrónico a", $ho = "Añadir formulario nuevo", who = "Añada un nuevo formulario a su equipo", kho = "Cree su primera ruta", Sho = "Ruta a la persona adecuada en función de las respuestas a su formulario", xho = "Formulario", Eho = "Crea tu formulario para dirigirlo a un agente de reservas", Tho = "Copiar enlace al formulario", Aho = "Tema de la página de reserva", Cho = "Esto sólo se aplica a tus páginas públicas de reservas", zho = "Tema del panel de control", Oho = "Esto solo se aplica a su tabla de control conectada", Pho = "Predeterminado del sistema", Iho = "Añadir un equipo", Rho = "Recibe los datos de la reunión en tiempo real cuando ocurra algo en {{appName}}", Nho = "Se activa cuando", Dho = "Antes de crear, ejecuta una prueba de ping.", Mho = "Activar Webhook", Lho = "Añadir Webhook", qho = "Webhook guardado", jho = "Genera claves API para acceder a tu propia cuenta", Fho = "Clave API nueva", Vho = "activo", Bho = "Nombre de la clave API actualizado", Uho = "Error al actualizar el nombre de la clave API", Who = "Inserción de iframe HTML", Gho = "Incorpora todos tus tipos de eventos en tu sitio web", Hho = "Genera tu primera clave API", Kho = "Las claves API permiten a otras aplicaciones comunicarse con {{appName}}", Yho = "Volver a iniciar sesión", Zho = "Enlace de restablecimiento enviado", Qho = "Se ha enviado un correo electrónico a {{email}} con instrucciones para restablecer tu contraseña.", Jho = "Si no recibe un correo electrónico pronto, compruebe que la dirección de correo que ha introducido sea correcta, revise su carpeta de correo no deseado o comuníquese con el equipo de soporte si el problema persiste.", Xho = "¡Contraseña actualizada!", evo = "Pago pendiente", tvo = "Invitaciones pendientes", nvo = "Invitaciones pendientes de la organización", ovo = "No estás en {{appName}}", rvo = "No hay ningún calendario instalado", ivo = "Aún no has conectado ninguno de tus calendarios", avo = "Añadir un calendario", svo = "Es posible que necesites cerrar sesión y volver a iniciarla para ver los cambios aplicados.", cvo = "Confirma tu contraseña antes de cambiar la dirección de correo electrónico", lvo = "plazas", dvo = "Todas las aplicaciones publicadas en la tienda de aplicaciones de {{appName}} son de código abierto y han sido probadas exhaustivamente mediante revisiones por parte de los usuarios. Sin embargo, {{companyName}} no respalda ni certifica estas aplicaciones a menos que sean publicadas por {{appName}}. Si encuentras contenidos o comportamientos inapropiados, notifícalos.", uvo = "Denunciar aplicación", _vo = "Limite la frecuencia de reserva", pvo = "Limite la cantidad de veces que se puede reservar este evento", mvo = "Mostrar solo el primer horario disponible de cada día", fvo = "Esto limitará su disponibilidad para este tipo de evento a un horario por día, programado a la hora más temprana disponible.", gvo = "Limitar la duración total de la reserva", hvo = "Limitar la cantidad total de tiempo que se puede reservar este evento", vvo = "Límite de reservas activas del solicitante", bvo = "Limita el número de reservas activas que un solicitante puede hacer para este tipo de evento", yvo = "Los eventos recurrentes no admiten límite de reservas del solicitante", $vo = "Agregue un límite", wvo = "Nombre de equipo requerido", kvo = "Comparta información de los asistentes entre los invitados", Svo = "Mostrar el número de cupos disponibles", xvo = "¿Cómo utilizar las preguntas de reserva como variables?", Evo = "Formato", Tvo = "Preguntas", Avo = "Toda la información que tu solicitante debe proporcionar antes de reservar contigo.", Cvo = "Use mayúsculas para todas las letras", zvo = "Reemplace espacios en blanco con guiones bajos", Ovo = "Miembros de la plataforma", Pvo = "Gestiona los administradores y miembros en tu equipo de plataforma", Ivo = "Facturación de la plataforma", Rvo = "Gestione la facturación", Nvo = "Gestione todo lo relacionado con la facturación", Dvo = "Actualmente está en el plan GRATUITO", Mvo = "Trabajamos mejor en equipo. Amplíe sus flujos de trabajo con eventos colectivos y rotativos y genere formularios de enrutamiento avanzados", Lvo = "Pruebe ahora", qvo = "Portal de facturación", jvo = "Contacte con soporte", Fvo = "Ignore los caracteres especiales en su identificador de pregunta de reserva. Use solo letras y números", Vvo = "Reintentar", Bvo = "Se produjo un problema al recuperar sus calendarios. <1>Inténtelo de nuevo</1> o contacte con el servicio de atención al cliente.", Uvo = "Error de conexión con el calendario", Wvo = "Confirmación de reserva exitosa", Gvo = "Rechazo de reserva exitoso", Hvo = "Esta reserva es provisional", Kvo = "Ups, quiero aceptar", Yvo = "No mostraremos esto de nuevo", Zvo = "No pudimos actualizar la zona horaria", Qvo = "Zona horaria actualizada a {{formattedCurrentTz}}", Jvo = "Actualizar zona horaria", Xvo = "¿Actualizar zona horaria?", ebo = "Parece que su zona horaria local ha cambiado a {{formattedCurrentTz}}. Es muy importante tener la zona horaria correcta para evitar reservas en tiempos no deseados. ¿Desea actualizarla?", tbo = "No actualizar", nbo = "Solicitar notas adicionales", obo = "Solicitar completar las notas adicionales al reservar", rbo = "enviar un correo electrónico a una dirección específica", ibo = "después de que el evento termine", abo = "cuando la reserva es rechazada", sbo = "cuando la reserva es solicitada", cbo = "cuando el pago de la reserva es iniciado", lbo = "cuando el pago de la reserva es exitoso", dbo = "cuando la no presentación de la reserva es actualizada", ubo = "¿Cuánto tiempo después de que termine el evento?", _bo = "¿Cuánto tiempo después de que los anfitriones no se presenten en la reunión de video de Cal?", pbo = "¿Cuánto tiempo después de que los invitados no se presenten en la reunión de video de Cal?", mbo = "¿Cuánto tiempo después de que los usuarios no se presenten en la reunión de video de Cal?", fbo = "No hay espacios disponibles", gbo = "Tiempo disponible", hbo = "¿No encuentras la aplicación de conferencias adecuada? Visita nuestra <0>Tienda de aplicaciones</0>.", vbo = "Instalar nueva aplicación de calendario", bbo = "Solicitar número de teléfono para reservar el evento", ybo = "Disponibilidad para {{eventTypeTitle}}", $bo = "Error al editar la disponibilidad", wbo = "No tiene permiso para acceder a este recurso.", kbo = "Pega los metadatos SAML de tu Proveedor de Identidad aquí", Sbo = "Por favor, introduce un correo electrónico para que podamos encontrar tu Proveedor de Identidad SAML", xbo = "Detalles del proveedor de servicios", Ebo = "Su proveedor de identidad (IdP) le pedirá los siguientes detalles para completar la configuración de la aplicación SAML.", Tbo = "URL de ACS", Abo = "ID de entidad SP", Cbo = "¡URL de ACS copiada!", zbo = "¡ID de entidad SP copiado!", Obo = "Añadir un calendario", Pbo = "Limitar reservas futuras", Ibo = "Limite hasta qué punto se puede reservar este evento en el futuro", Rbo = "No hay tipos de eventos configurados", Nbo = "{{name}} no ha configurado ningún tipo de evento para que usted reserve.", Dbo = "Frecuencia de facturación", Mbo = "Mensual", Lbo = "Anual", qbo = "Proceder al pago", jbo = "Su equipo se ha disuelto con éxito", Fbo = "Su organización se ha disuelto con éxito", Vbo = "Error al crear el equipo", Bbo = "Usted", Ubo = "O continuar con", Wbo = "Reenviar correo electrónico", Gbo = "El miembro ya se ha invitado", Hbo = "El nombre de usuario ya está en uso", Kbo = "Introduzca un correo electrónico o nombre de usuario", Ybo = "Ingrese un correo electrónico", Zbo = "Ingrese correos electrónicos", Qbo = "Está limitado a invitar a un máximo de {{nbUsers}} usuarios a la vez.", Jbo = "Este nombre ya está en uso", Xbo = "Debe introducir un nombre de equipo", eyo = "Debe introducir una URL del equipo", tyo = "Esta URL ya está en uso", nyo = "Hubo un problema con el registro del subdominio, intente nuevamente o comuníquese con un administrador", oyo = "Publicar equipo", ryo = "Número de teléfono (Notificaciones de texto)", iyo = "Número de teléfono (notificaciones SMS)", ayo = "Correo electrónico del asistente", syo = "El correo electrónico de la persona que reserva", cyo = "UID de reserva", lyo = "Escriba un comando o búsqueda...", dyo = "¡Oh no! Parece que el permiso ha caducado o se ha revocado. Vuelva a instalarlo.", uyo = "Reinstalar aplicación", _yo = "Razón de la reprogramación", pyo = "Elige un horario común para todos", myo = "Activa esto si quieres usar un horario común entre anfitriones. Cuando está desactivado, cada anfitrión será reservado según su horario predeterminado o el horario que hayan elegido.", fyo = "Motivo", gyo = "ID del remitente", hyo = "Sólo se permiten letras, números y espacios (máx. 11 caracteres)", vyo = "Prueba de formulario de ruta", byo = "Probar vista previa", yyo = "Ruta hacia", $yo = "Pruebe su formulario de ruta sin enviar ningún dato", wyo = "Prueba de ruta", kyo = "Un administrador desactivó una aplicación de pago", Syo = "Editar tipo de evento", xyo = "Esta organización es privada, y solo el administrador o propietario de la organización puede ver a sus miembros.", Eyo = "Solo el administrador o propietario de la organización puede gestionar la configuración de SSO", Tyo = "Solo el administrador o propietario de la organización puede gestionar la configuración de sincronización de directorios", Ayo = "Solo el administrador o propietario de la organización puede gestionar los clientes OAuth", Cyo = "Programación colectiva", zyo = "Haga que sea fácil reservar su equipo cuando todos estén disponibles.", Oyo = "Encuentre a la mejor persona disponible y haga una rotación en su equipo.", Pyo = "Rotación fija por turnos", Iyo = "Agregue un asistente fijo y realice rotación por turnos a través de un número de asistentes.", Ryo = "{{appName}} funciona mejor con equipos", Nyo = "El equipo de {{companyName}}", Dyo = "Añada los miembros de su equipo a sus tipos de eventos. Utilice la programación colectiva para incluir a todos o encuentre a la persona más adecuada con programación de rotación por turnos.", Myo = "Se ha alcanzado el límite de reserva para este tipo de evento", Lyo = "Se ha alcanzado el límite de duración para este tipo de evento", qyo = "Un administrador desactivó {{appName}}", jyo = "Esto desactivará todos los correos electrónicos para {{recipient}}. Esto incluye confirmaciones de reserva, solicitudes, reprogramaciones y solicitudes de reprogramación, correos de cancelación y cualquier otro correo relacionado con actualizaciones de reservas.<br /><br />Es tu responsabilidad asegurarte de que tus {{recipient}} estén al tanto de cualquier reserva y cambios en sus reservas.", Fyo = "Un administrador desactivó {{appName}}, lo que afecta a su tipo de evento {{eventType}}", Vyo = "Un administrador ha reemplazado uno de sus tipos de eventos", Byo = "Un administrador del equipo ha reemplazado su evento /{{slug}}", Uyo = "Un administrador del equipo <strong>{{teamName}}</strong> reemplazó su tipo de evento <strong>/{{slug}}</strong> con un tipo de evento gestionado que él controla.", Wyo = "Su enlace seguirá funcionando, pero algunas configuraciones pueden haber cambiado. Puede revisarlo en tipos de eventos.", Gyo = "Si tiene alguna pregunta sobre el tipo de evento, comuníquese con su administrador.<br /><br />Feliz programación, <br />El equipo de Cal.com", Hyo = "El administrador ha desactivado {{appName}}, lo que afecta a tu tipo de evento {{title}}. Los asistentes aún pueden reservar este tipo de evento, pero no se les pedirá que paguen. Puedes ocultar el tipo de evento para evitar esto hasta que tu administrador vuelva a habilitar tu método de pago.", Kyo = "Los asistentes aún pueden reservar este tipo de evento, pero no se les pedirá que paguen. Puedes ocultar el tipo de evento para evitar esto hasta que tu administrador vuelva a habilitar tu método de pago.", Yyo = "El administrador desactivó {{appName}}, lo que afecta a su tipo de evento {{title}}.", Zyo = "El administrador ha desactivado {{appName}}, lo que puede afectar a sus tipos de evento. Si tiene tipos de eventos con {{appName}} como localización, entonces el valor predeterminado será Cal Video.", Qyo = "{{appName}} se desactivó", Jyo = "Ir a las aplicaciones instaladas", Xyo = "Si tiene otro calendario instalado, las nuevas reservas se añadirán a él. De lo contrario, conecte un nuevo calendario para que no se pierda ninguna reserva nueva.", e$o = "Activar aplicaciones", t$o = "Habilite las aplicaciones que los usuarios pueden integrar con {{appName}}", n$o = "Compre una licencia", o$o = "¿Ya tienes una cuenta?", r$o = "Ya tengo una clave:", i$o = "Copie aquí su variable de entorno CALCOM_LICENSE_KEY existente.", a$o = "Crear clave de licencia", s$o = "{{appName}} está activada", c$o = "{{appName}} está desactivada", l$o = "Se han guardado las claves", d$o = "Desactivar aplicación", u$o = "Desactivar esta aplicación puede causar problemas con la forma en que sus usuarios interactúan con Cal", _$o = "Editar claves", p$o = "Habilite aplicaciones para su instancia de Cal", m$o = "Una lista de todos los usuarios en tu cuenta, incluyendo su nombre, título, correo electrónico y rol.", f$o = "Aquí puedes añadir un nuevo usuario.", g$o = "Aquí puedes editar un usuario existente.", h$o = "Aquí puedes editar una organización.", v$o = "Añadir nuevos clientes OAuth", b$o = "Bloquear o desbloquear el envío de SMS para los usuarios", y$o = "No hay aplicaciones disponibles", $$o = "Verifique que haya aplicaciones en su implementación en 'packages/app-store'", w$o = "No hay aplicaciones activadas en esta instancia de Cal", k$o = "Aún no se ha configurado ninguna aplicación", S$o = "Puede activar aplicaciones en la configuración", x$o = "Póngase en contacto con su administrador", E$o = "Configuración de aplicaciones", T$o = "Complete este campo", A$o = "Opciones", C$o = "Introduzca la opción {{index}}", z$o = "Agregue una opción", O$o = "Esta ubicación ya existe. Por favor, selecciona una nueva ubicación", P$o = "Botón radial", I$o = "Para usar Google Meet, debes configurar tu calendario de destino como un calendario de Google", R$o = "Individuo", N$o = "Todas las reservas", D$o = "Todos los usuarios", M$o = "Todos los tipos de eventos", L$o = "Sus reservas", q$o = "URL de la reunión", j$o = "URL de la reunión del evento", F$o = "Anular fechas", V$o = "Eliminar anulaciones de fecha el {{date}}", B$o = "Agregue fechas cuando su disponibilidad difiera de su horario diario.", U$o = "Las anulaciones de fecha se archivan automáticamente después de que haya pasado la fecha", W$o = "¿En qué horas está disponible?", G$o = "¿En qué horas está ocupado(a)?", H$o = "Seleccione las fechas para anular", K$o = "No disponible todo el día", Y$o = "Marcar como no disponible (Todo el día)", Z$o = "Marcar como no disponible en las fechas seleccionadas", Q$o = "Actualizar anulación", J$o = "Sustitución de fechas añadida correctamente", X$o = "Guardar excepción", ewo = "{{slug}}-copia", two = "Establecer como predeterminado", nwo = "Ocultar detalles del tipo de evento", owo = "Mostrar navegación", rwo = "Ocultar navegación", iwo = "Se envió el código de verificación", awo = "Verificado exitosamente", swo = "Código de verificación incorrecto", cwo = "Aún no se ha verificado", lwo = "Sin disponibilidad en {{month}}", dwo = "La programación solo está disponible hasta {{days}} días por adelantado. Por favor, vuelve a consultar pronto.", uwo = "La programación terminó el {{date}}. Por favor, comprueba de nuevo pronto.", _wo = "Ver mes anterior", pwo = "Ver el próximo mes", mwo = "Enviar código", fwo = "Número verificado", gwo = "Cree su primer webhook para este tipo de evento de equipo", hwo = "Crear un webhook para este tipo de evento de equipo", vwo = "Desactivar página de éxito (solo funciona si tiene una URL de redireccionamiento)", bwo = "Usted es administrador pero no tiene una contraseña de al menos 15 caracteres o una autenticación de 2 factores aún", ywo = "Cambia tu contraseña para obtener acceso de administrador", $wo = "Este nombre de usuario ya está en uso", wwo = "Asignación", kwo = "Anfitriones fijos", Swo = "Añadir anfitriones fijos", xwo = "Anfitriones por turnos", Ewo = "Número de anfitriones requeridos para asistir", Two = "Anfitriones", Awo = "Necesitas crear un equipo para habilitar esta función. Haz clic aquí para crear un equipo.", Cwo = "Debe pasarse a nuestro plan Enterprise para habilitar esta función.", zwo = "Nuevo asistente", Owo = "En espera de aprobación", Pwo = "Esta aplicación requiere una conexión con Google Calendar", Iwo = 'El "Añadir al calendario" para este tipo de evento necesita ser un Google Calendar para que Meet funcione. Conéctalo <0>aquí</0>.', Rwo = "Ha conectado una cuenta de Google Calendar.", Nwo = "El uso de Google Meet requiere un Google Calendar conectado", Dwo = "Siga con la instalación de Google Calendar", Mwo = "Instale Google Meet", Lwo = "Instale Google Calendar", qwo = "Nombre del remitente", jwo = "Asistente ya invitado", Fwo = "No se encontraron grabaciones", Vwo = "Nuevo flujo de trabajo para...", Bwo = "Reportando", Uwo = "Vea todos los datos entrantes y descárguelos como un CSV", Wwo = "Se requiere un plan de Equipos", Gwo = "Los formularios de enrutamiento son una excelente manera de dirigir sus clientes potenciales entrantes a la persona adecuada. Actualice a un plan de Equipos para acceder a esta función.", Hwo = "Elija una licencia", Kwo = "Cal.com viene con una licencia AGPLv3 accesible y gratuita, la cual tiene algunas limitaciones. Esta licencia se puede actualizar a una licencia Empresarial en cualquier momento. Puede actualizarla más tarde.", Ywo = "Licencia", Zwo = "Licencia AGPLv3", Qwo = "No es necesario mantener su código abierto", Jwo = "Vuelva a empaquetar, cambie la marca y revenda fácilmente", Xwo = "Un amplio conjunto de funciones empresariales", e0o = "$0,00/mes", t0o = "Siempre abierto y gratis", n0o = "Necesario para mantener su código abierto", o0o = "No se puede volver a empaquetar, cambiar la marca y revender fácilmente", r0o = "Sin características empresariales", i0o = "Licencia Empresarial", a0o = "Todo para un caso de uso comercial con alojamiento privado, reempaquetado, cambio de marca y reventa, además de acceso a componentes empresariales exclusivos.", s0o = "Configuración", c0o = "Configurar la instancia de Cal.com", l0o = "Configurar", d0o = "Inicio de sesión único", u0o = "Configure SAML/OIDC SSO y permita que los miembros del equipo inicien sesión con un proveedor de identidad", _0o = "Configure SSO SAML/OIDC y permita que los miembros de la organización inicien sesión utilizando un proveedor de identidad", p0o = "SSO con OIDC", m0o = "Configure OIDC SSO con el proveedor de identidad de su elección.", f0o = "Configuración de OIDC", g0o = "Configure la conexión OIDC a su proveedor de identidad. Puede encontrar la información requerida en su proveedor de identidad.", h0o = "URL de devolución de llamada copiada", v0o = "SSO con SAML", b0o = "Configure SAML SSO con el proveedor de identidad de su elección.", y0o = "Configuración de SAML", $0o = "Configure la conexión SAML a su proveedor de identidad. Puede encontrar la información requerida en su proveedor de identidad.", w0o = "URL de ACS copiada", k0o = "ID de entidad copiado", S0o = "Configuración de {{connectionType}} creada con éxito", x0o = "Configuración de {{connectionType}} eliminada con éxito", E0o = "Eliminar la configuración de {{connectionType}}", T0o = "Sí, eliminar la configuración de {{connectionType}}", A0o = "¿Está seguro de que desea eliminar la configuración de {{connectionType}}? Los miembros de su equipo que utilicen el inicio de sesión {{connectionType}} ya no podrán acceder a Cal.com.", C0o = "Zona horaria del organizador", z0o = "Ver la invitación", O0o = "Aceptar invitación", P0o = "Unirse ahora", I0o = "Unido con éxito", R0o = "Has sido invitado a unirte a un equipo de la organización {{parentTeamName}}", N0o = "Has sido invitado a unirte a una organización de {{appName}}", D0o = "{{invitedBy}} lo invitó a unirse a su equipo en {{appName}}. {{appName}} es el programador de eventos que les permite a usted y a su equipo programar reuniones sin necesidad de enviar correos electrónicos.", M0o = "{{invitedBy}} le ha invitado a unirse al equipo {{teamName}} en su organización {{parentTeamName}} en {{appName}}. {{appName}} es el programador de eventos que le permite a usted y a su equipo programar reuniones sin el intercambio constante de correos electrónicos.", L0o = '{{invitedBy}} lo ha invitado a unirse a su organización "{{teamName}}" en {{appName}}. {{appName}} es el programador de eventos que le permite a usted y a su organización programar reuniones sin el tenis del correo electrónico.', q0o = "Te guiaremos a través de unos breves pasos y estarás disfrutando de programación sin estrés con tu {{entity}} en poco tiempo.", j0o = "Elija su nombre de usuario", F0o = "Conecte su cuenta de calendario", V0o = "Establezca su disponibilidad", B0o = "Únase a {{teamName}}", U0o = "Feliz programación le desea el equipo de {{appName}}", W0o = "Está a punto de suplantar a un usuario, lo que significa que puede hacer cambios en su nombre. Tenga cuidado.", G0o = "Variables disponibles", H0o = "{Scheduler}", K0o = "No hay flujos de trabajo", Y0o = "Cambie el filtro para ver sus flujos de trabajo personales y de equipo.", Z0o = "Cambie el filtro para ver los resultados.", Q0o = "No hay resultados para el filtro", J0o = "Siguientes pasos recomendados", X0o = "Crear un tipo de evento administrado", eko = "Las reuniones son mejores si están los miembros adecuados del equipo. Invítelos ahora.", tko = "Cree una plantilla de reunión individual para un tipo de evento y distribúyala a varios miembros.", nko = "Colectivo o turnos rotativos", oko = "Reserve a los miembros de su equipo juntos con eventos colectivos o por ciclos para conseguir a la persona adecuada con turnos rotativos.", rko = "Ya no asistirá a {{title}} a las {{date}}", iko = "Ya no asistirá a este evento", ako = "Un asistente ya no asistirá a {{title}} a las {{date}}", sko = "Un asistente ya no asistirá a su evento", cko = "{{name}} ha cancelado. Esto significa que está disponible una plaza para esta franja horaria", lko = "Crear evento en", dko = "Crear formulario de enrutamiento en", uko = "Establecer un enlace de aplicación predeterminado", _ko = "Establecer un enlace de aplicación predeterminado permite que todos los tipos de eventos recién creados utilicen el enlace de aplicación que establezca.", pko = "Aplicación por defecto del organizador", mko = "{{organizer}} no tiene una aplicación de conferencias predeterminada", fko = "Fuera de servicio por mantenimiento", gko = "El equipo de {{appName}} está realizando un mantenimiento programado. Si tiene alguna pregunta, comuníquese con soporte.", hko = "{{numberOfSeats}} plazas", vko = "Preguntas sobre la reserva", bko = "Personalice las preguntas que se hacen en la página de reservas", yko = "Agregar una pregunta", $ko = "Identificador", wko = "El correo electrónico está duplicado", kko = "Introduce una URL de redirección a la que se enviará al asistente una vez que abandone la reunión.", Sko = "Ya no es posible pagar por este evento", xko = "Un reembolso por el pago de esta reserva está en camino.", Eko = "El pago de esta reserva se ha reembolsado.", Tko = "Según la política de reembolso del evento, el pago de la reserva no es reembolsable.", Ako = "El período de reembolso del evento ha expirado. Por lo tanto, el pago de la reserva no es reembolsable.", Cko = "Error al confirmar la reserva", zko = "No hay suficientes plazas", Oko = "Ya existe un campo con este nombre", Pko = "El campo de invitados debe ser de tipo 'Múltiples correos electrónicos'", Iko = "Mostrar en la página de reserva", Rko = "Puedes visitar la página de la reserva cancelada", Nko = "Comience con las plantillas de Zapier", Dko = "Plantillas estándar", Mko = "Plantillas de Cal.ai", Lko = "{{team}} no está publicado", qko = "El enlace de esta organización no está disponible actualmente. Comuníquese con el propietario de la organización o pídale que lo publique.", jko = "Este enlace de {{entity}} no está disponible actualmente. Póngase en contacto con el propietario de {{entity}} o pídale que lo publique.", Fko = "Miembro del equipo", Vko = "Un formulario de enrutamiento", Bko = "Descripción del formulario", Uko = "Mantenerme conectado con el formulario", Wko = "Cualquier cambio realizado en el enrutador o en los campos del formulario que se está duplicando se reflejará en el duplicado. Sin embargo, eliminar un campo no lo eliminará del duplicado.", Gko = "Formulario eliminado", Hko = "¿Está seguro de que desea eliminar este formulario?", Kko = "Sí, eliminar formulario", Yko = "Cualquier persona con la que hayas compartido el enlace ya no podrá acceder a él.", Zko = "Se eliminarán todas las respuestas asociadas.", Qko = "¡URL de redirección copiada! Puedes ir y configurar la URL en tu propio formulario.", Jko = "Las modificaciones en los campos y rutas de los siguientes formularios se reflejarán en este formulario.", Xko = "Formularios conectados", e1o = "Los siguientes formularios se verían afectados cuando modifique campos o rutas aquí.", t1o = "Espere un tiempo para que se recopilen las respuestas. También puede proceder y enviar el formulario usted mismo.", n1o = "Esto es lo que verían sus usuarios", o1o = "Identifique el campo con este nombre.", r1o = "Agregue 1 opción por línea", i1o = "Seleccione un enrutador", a1o = "Agregar una ruta nueva", s1o = "Tome decisiones informadas con Insights", c1o = "Nuestro panel de Insights muestra toda la actividad de su equipo y las tendencias que permiten una mejor programación y toma de decisiones.", l1o = "Ver reservas de todos los miembros", d1o = "Mira quién está recibiendo más reservas y asegura la mejor distribución en tu equipo", u1o = "Identificar tendencias de reserva", _1o = "Consultar cuáles son las horas de la semana y del día más populares para sus reservas", p1o = "Detectar tipos de eventos populares", m1o = "Consulte cuál de sus tipos de eventos están recibiendo más clics y reservas", f1o = "Aún no hay respuestas", g1o = "No hay rutas definidas", h1o = "Este será el marcador de posición", v1o = "Ocurrió un error al reservar el evento, actualice la página e intente nuevamente", b1o = "No hay intervalo de tiempo seleccionado", y1o = "Seleccione un intervalo de tiempo para reservar el evento.", $1o = "Seleccionar intervalo de tiempo", w1o = "Cambiar a la vista mensual", k1o = "Cambiar a la vista semanal", S1o = "Cambiar a la vista diaria", x1o = "Cambiar a la vista de columna", E1o = "{{num}} opciones de ubicación", T1o = "Seleccionar en el siguiente paso", A1o = "Esta reunión aún no ha comenzado", C1o = "{{appName}} requiere una cuenta {{dependencyName}} conectada", z1o = "Conectar {{dependencyName}}", O1o = "{{dependencyName}} está conectada", P1o = "Requiere {{dependencyName}}", I1o = "Código de verificación", R1o = "¿Puede intentarlo de nuevo con una hora diferente?", N1o = "Verificar", D1o = "Zona horaria de la persona que recibe", M1o = "Zona horaria", L1o = "Hora de finalización del evento", q1o = "La hora de finalización del evento", j1o = "URL de cancelación", F1o = "La URL para cancelar la reserva", V1o = "Motivo de cancelación", B1o = "El motivo de la cancelación de la reserva", U1o = "URL de reprogramación", W1o = "La URL para reprogramar la reserva", G1o = "Motivo de reprogramación", H1o = "El motivo de la reprogramación de la reserva", K1o = "Hay una variable no válida en el nombre de su evento", Y1o = "Seleccionar todo", Z1o = "Actualización masiva de los tipos de eventos existentes", Q1o = "Horario predeterminado del miembro", J1o = "Establecido por el administrador del equipo", X1o = "Ubicación predeterminada del miembro", e2o = "Usaremos el horario de disponibilidad predeterminado de cada miembro. Este se podrá editar o cambiar.", t2o = "Es necesario tener al menos un horario", n2o = "Actualizar las ubicaciones para los tipos de eventos seleccionados", o2o = "Actualiza los horarios para los tipos de eventos seleccionados", r2o = "Bloqueado para miembros", i2o = "Desbloqueado para miembros", a2o = "Los miembros podrán ver las aplicaciones activas, pero no podrán editar ninguna configuración de la aplicación", s2o = "Los miembros podrán ver las aplicaciones activas y podrán editar cualquier configuración de la aplicación", c2o = "Podrás ver las aplicaciones activas pero no podrás editar ninguna configuración de la aplicación", l2o = "Podrás ver las aplicaciones activas y podrás editar cualquier configuración de la aplicación", d2o = "Los miembros no pueden agregar sus flujos de trabajo personales a este tipo de evento. Los miembros podrán ver los flujos de trabajo del equipo activos pero no podrán editar ninguna configuración del flujo de trabajo.", u2o = "Los miembros podrán agregar sus flujos de trabajo personales a este tipo de evento. Los miembros podrán ver los flujos de trabajo del equipo activos pero no podrán editar ninguna configuración del flujo de trabajo.", _2o = "Podrás ver los flujos de trabajo del equipo activos pero no podrás editar ninguna configuración del flujo de trabajo ni agregar tus flujos de trabajo personales a este tipo de evento.", p2o = "Podrás habilitar/deshabilitar flujos de trabajo personales en este tipo de evento. Podrás ver los flujos de trabajo del equipo activos pero no podrás editar ninguna configuración del flujo de trabajo del equipo.", m2o = "Los miembros no pueden añadir sus webhooks personales a este tipo de evento. Los miembros podrán ver los webhooks activos pero no podrán editar ninguna configuración de webhook.", f2o = "Los miembros podrán añadir sus webhooks personales a este tipo de evento. Los miembros podrán ver los webhooks activos pero no podrán editar ninguna configuración de webhook.", g2o = "Puedes ver los webhooks administrados activos pero no podrás editar ninguna configuración de webhook ni añadir tus webhooks personales a este tipo de evento.", h2o = "Puedes añadir webhooks a este tipo de evento. Puedes ver los webhooks administrados activos pero no podrás editarlos.", v2o = "Bloqueado por el administrador del equipo", b2o = "No ha conectado una cuenta de {{appName}}.", y2o = "Conectar ahora", $2o = "Reemplazar y notificar a {{count}} miembro", w2o = "Reemplazar y notificar a {{count}} miembros", k2o = "La url /{{slug}} ya existe para {{count}} miembro. ¿Desea reemplazarla?", S2o = "La url /{{slug}} ya existe para {{count}} miembros. ¿Desea reemplazarla?", x2o = "<strong>{{names}}</strong> ya usa la url <strong>/{{slug}}</strong>.", E2o = "<strong>{{names}}</strong> ya usan la url <strong>/{{slug}}</strong>.", T2o = "Si elige reemplazarlo, se lo notificaremos. Regrese y elimínelos si no desea sobrescribirlo.", A2o = "Revisar tipo de evento", C2o = "¿Busca más datos de análisis?", z2o = "¿Quiere saber más sobre Insights?", O2o = "Filtros", P2o = "Filtrar", I2o = "Añadir un miembro", R2o = "Añadir filtro", N2o = "Añadir regla", D2o = "Añadir grupo de reglas", M2o = "Borrar todos los filtros", L2o = "Correo electrónico verificado", q2o = "Seleccionar usuario", j2o = "Seleccionar tipo de evento", F2o = "Seleccionar rango de fechas", V2o = "Eventos populares", B2o = "No se encontraron tipos de eventos", U2o = "Duración promedio del evento", W2o = "Reservas por hora", G2o = "Miembros más reservados", H2o = "Miembros menos reservados", K2o = "Mayor número de reservas programadas", Y2o = "Menor número de reservas programadas", Z2o = "Mayor número de reservas completadas", Q2o = "Menor número de reservas completadas", J2o = "Eventos creados", X2o = "Eventos completados", eSo = "Eventos cancelados", tSo = "Eventos reprogramados", nSo = "Eventos", oSo = "Rendimiento", rSo = "desde el último período", iSo = "Desde: {{startDate}} Hasta: {{endDate}}", aSo = 'Agregar una redirección deshabilitará la página de éxito. Asegúrese de mencionar "Reserva confirmada" en su página de éxito personalizada.', sSo = "Tendencias del evento", cSo = "Eliminar filtros", lSo = "Borrar", dSo = "Retener", uSo = "Cobrar el pago durante la reserva", _So = "Cobrar comisión por no presentarse", pSo = "Tarjeta retenida", mSo = "Cargar la tarjeta", fSo = "Se le cobró a la tarjeta", gSo = "{{amount, currency}} cargo por no presentarse", hSo = "Comisión por no presentarse", vSo = "Enviar tarjeta", bSo = "Enviar información de pago", ySo = "Su reunión está esperando un método de pago", $So = "Comisión por no presentarse de {{amount, currency}} cobrada para {{title}} el {{date}}", wSo = "Se cobró una tarifa por no presentarse", kSo = "Se cobró una comisión de {{amount, currency}} por no presentarse al siguiente evento", SSo = "Algo salió mal al cobrar la tarifa por no presentarse. Inténtelo de nuevo más tarde.", xSo = "Cobrar comisión por no presentarse", ESo = "Comisión por no presentarse cobrada", TSo = "Pago rechazado. Por favor, intente con otra tarjeta o contacte a su banco para obtener ayuda.", ASo = "Este tipo de tarjeta no es compatible con esta compra. Por favor, utilice un método de pago diferente.", CSo = "El monto mínimo de pago es $0.50 USD. Por favor, aumente su monto de pago.", zSo = "No se pudo cargar la tarjeta para el pago.", OSo = "Perspectivas", PSo = "Formularios de enrutamiento", ISo = "No se encontraron datos para el filtro seleccionado o las fechas seleccionadas.", RSo = "Reconozco que si no asisto a este evento, se aplicará a mi tarjeta una tarifa de {{amount, currency}} por no presentarme.", NSo = "días", DSo = "Detalles de la tarjeta", MSo = "Algo salió mal por nuestra parte. Ponte en contacto con nuestro equipo de soporte y lo solucionaremos de inmediato.", LSo = "Proporcione el siguiente texto cuando se comunique con el soporte para ayudarlo mejor", qSo = "Actualmente, no se pueden habilitar cupos ni cobrar una tarifa por no presentarse", jSo = "Complete su reserva", FSo = "Complete su reserva: {{title}} el {{date}}", VSo = "Confirme sus datos", BSo = "Copiar enlace de invitación", USo = "Editar ajustes de enlace", WSo = "Enlace de invitación copiado", GSo = "Enlace de invitación eliminado", HSo = "Clave API eliminada", KSo = "Esto eliminará permanentemente la clave API. Cualquier aplicación que use esta clave perderá inmediatamente el acceso a tu cuenta. Esta acción no se puede deshacer.", YSo = "Configuración de enlace de invitación guardada", ZSo = "Enlaces establecidos para expirar después de...", QSo = "1 día", JSo = "7 días", XSo = "30 días", exo = "3 meses", txo = "1 año", nxo = "Lo han invitado a unirse a {{teamName}}", oxo = "{{amount, currency}}", rxo = "Está a punto de cobrarle {{amount, currency}} al asistente. ¿Está seguro de que desea continuar?", ixo = "Cobrar al asistente {{amount, currency}}", axo = "Solicitar pago ({{paymentFeePercentage}}% + {{fee, currency}} comisión por transacción)", sxo = "Se ha invitado a {{email}}", cxo = "Se han invitado {{userCount}} usuarios", lxo = "Error al cargar la tarjeta", dxo = "La imagen cargada no debe exceder el límite de tamaño de 5 Mb", uxo = "{{errorCode}}: No está autorizado para habilitar o deshabilitar este flujo de trabajo", _xo = "Incrustar en línea", pxo = "Carga su tipo de evento directamente en línea con otro contenido de su sitio web.", mxo = "Botón emergente flotante", fxo = "Pone un botón flotante en su sitio que activa un modal con su tipo de evento.", gxo = "Aparece mediante un clic en el elemento", hxo = "Abre su cuadro de diálogo Cal cuando alguien hace clic en un elemento.", vxo = "Usar mi propio formulario", bxo = "Use nuestra API de enrutamiento sin interfaz y utilice su propio formulario para envíos.", yxo = "¿Necesita ayuda? Consulte nuestras guías para incrustar Cal en Wix, Squarespace o WordPress, consulte nuestras preguntas comunes o explore las opciones avanzadas de incrustación.", $xo = "Reservar mi Cal", wxo = "Nombre", kxo = "Nombre", Sxo = "Nombre, Apellido", xxo = "Invitar como", Exo = "Formulario actualizado con éxito.", Txo = "Desactivar los correos electrónicos de confirmación predeterminados para los asistentes", Axo = "Al menos un flujo de trabajo está activo en este tipo de evento que envía un correo electrónico a los asistentes cuando se reserva el evento.", Cxo = "Desactivar los correos electrónicos de confirmación predeterminados para el anfitrión", zxo = "Al menos un flujo de trabajo está activo en este tipo de evento que envía un correo electrónico al anfitrión cuando se reserva el evento.", Oxo = "Agregar una anulación", Pxo = "Importar usuarios de Google Workspace", Ixo = "Conectar Google Workspace", Rxo = "Debe ser administrador para usar esta función", Nxo = "Cree su primer webhook para este tipo de evento", Dxo = "Crea tu primer webhook con 'Reunión instantánea creada' como desencadenante para este tipo de evento", Mxo = "Instalar aplicación en", Lxo = "Crear para", qxo = "Moneda", jxo = "Crea un entorno donde tus equipos puedan crear aplicaciones compartidas, flujos de trabajo y tipos de eventos con programación round robin y colectiva.", Fxo = "Gestione organizaciones con varios equipos", Vxo = "Configure su organización", Bxo = "Configura tu plataforma", Uxo = "Las organizaciones son entornos compartidos donde los equipos pueden crear tipos de eventos, aplicaciones, flujos de trabajo compartidos y más.", Wxo = "Planes", Gxo = "Plataforma", Hxo = "Gestiona todo lo relacionado con la plataforma.", Kxo = "Cal.com Platform te permite integrar la programación sin esfuerzo en tu aplicación utilizando APIs y átomos de la plataforma.", Yxo = "Debe introducir el nombre de una organización", Zxo = "Debe introducir la dirección de correo electrónico de su organización", Qxo = "Dirección de correo electrónico de su organización", Jxo = "Tu dirección de correo electrónico de administrador", Xxo = "Nombre de usuario del administrador", eEo = "Nombre de la organización", tEo = "Nombre de la plataforma", nEo = "URL de la organización", oEo = "Verifique el correo electrónico de su organización", rEo = "Utilice el siguiente código para verificar su dirección de correo electrónico y continuar con la configuración de su organización.", iEo = "Parámetros adicionales de URL", aEo = "Acerca de su organización", sEo = "Las organizaciones son entornos compartidos donde puede crear varios equipos con miembros, tipos de eventos, aplicaciones, flujos de trabajo compartidos y más.", cEo = "Cree sus equipos", lEo = "Comiencen a programar juntos agregando miembros de su equipo a su organización", dEo = "Invite a los administradores de su organización", uEo = "Estos administradores tendrán acceso a todos los equipos de su organización. Puede agregar administradores y miembros del equipo más tarde.", _Eo = "Establezca una contraseña", pEo = "Esto creará una nueva cuenta de usuario con el correo electrónico de su organización y esta contraseña.", mEo = "Logo de la organización", fEo = "Algunas frases sobre su organización. Esto aparecerá en la página de perfil público de su organización.", gEo = "Lo haré más tarde", hEo = "Verifique su correo electrónico", vEo = "Ingrese el código de 6 dígitos que enviamos a {{email}}", bEo = "Verifique su correo electrónico para crear una organización", yEo = "El código proporcionado no es válido, inténtelo de nuevo", $Eo = "El correo electrónico ya se está utilizando", wEo = "Lo han invitado a unirse a {{orgName}}", kEo = "Únase a su equipo en {{orgName}} y comience a concentrarse en las reuniones, no en hacer reuniones.", SEo = "No se pudieron crear los siguientes equipos debido a slugs duplicados: {{slugs}}", xEo = "Los nombres de equipo no pueden estar vacíos", EEo = "Los nombres de equipo no se pueden repetir", TEo = "El usuario pertenece a una organización", AEo = "Esta organización aún no tiene equipos", CEo = "Si usted es un administrador, asegúrese de crear equipos para que se muestren aquí.", zEo = "Configurar", OEo = "Mi perfil", PEo = "Mi configuración", IEo = "CRM", REo = "Mensajería", NEo = "Nombre o número que se muestra como el remitente de un SMS (algunos países no permiten ID de remitente alfanumérico)", DEo = "Sólo el administrador de su organización puede crear nuevos equipos", MEo = "La nueva política de spam de Google podría impedir que recibas notificaciones por correo electrónico y calendario sobre esta reserva.", LEo = "Resolver", qEo = "Hubo un error al crear equipos para esta organización. Falta el slug de URL.", jEo = "Copiar enlace a la organización", FEo = "Equipo: {{teamName}}", VEo = "Usuario: {{userName}}", BEo = "Mire información de insights en todos sus eventos", UEo = "Historial de llamadas", WEo = "Ver historial de llamadas de tus llamadas con Cal.ai", GEo = "{{locationCount}} opciones de ubicación", HEo = "Tipo de canal", KEo = "Motivo de finalización", YEo = "Estado de la sesión", ZEo = "Sentimiento del usuario", QEo = "Hora", JEo = "De", XEo = "Plan personalizado", eTo = "Incrustado en el correo electrónico", tTo = "Seleccione algunos horarios disponibles e incrústelos en su correo electrónico", nTo = "Seleccione la hora", oTo = "Seleccione la fecha", rTo = "Mostrar solo si se establece un parámetro", iTo = "Agregar parámetro", aTo = "Te estamos conectando con alguien de {{orgName}}.", sTo = "Por favor, no cierres ni actualices esta página", cTo = "Ver todas las horas disponibles", lTo = "ej. Equipo de marketing", dTo = "ej. Equipo de ventas", uTo = "ej. Equipo de diseño", _To = "ej. Equipo de ingeniería", pTo = "ej. Equipo de análisis de datos", mTo = "Más adelante podrá añadir más equipos.", fTo = "¿De qué trata esta reunión?", gTo = "Agregar al equipo", hTo = "Eliminar usuarios de la organización", vTo = "Credencial de delegación", bTo = "La credencial de delegación te permite gestionar el acceso a los calendarios de Google Workspace para tu organización.", yTo = "Añade este ID de cliente en Google Workspace con el siguiente alcance", $To = "Credencial de delegación habilitada", wTo = "Añadir credencial de delegación", kTo = "Editar credencial de delegación", STo = "Dominio", xTo = "No hay plataformas de trabajo", ETo = "Plataforma de trabajo", TTo = "Plataformas de trabajo", ATo = "Gestiona las plataformas de trabajo que se pueden usar para la credencial de delegación", CTo = "Editar plataforma de trabajo", zTo = "Editar cuenta de servicio", OTo = "Añadir plataforma de trabajo", PTo = "Slug", ITo = "JSON de la clave de cuenta de servicio", RTo = "Editar JSON de la clave de cuenta de servicio", NTo = "La credencial de delegación restringe añadir más de una instalación", DTo = "Aplicación instalada correctamente y está usando credenciales delegadas", MTo = "¿Está seguro de que desea eliminar {{userCount}} usuarios de esta organización?", LTo = "Eliminar usuarios del equipo", qTo = "¿Estás seguro de que quieres eliminar a {{userCount}} usuarios de este equipo?", jTo = "Este usuario no ha configurado ningún horario todavía", FTo = "Este usuario no está en ningún equipo", VTo = "Este usuario aún no ha instalado ninguna aplicación", BTo = "Requiere verificación por correo electrónico de quien reserva", UTo = "Para asegurar la verificación del correo electrónico de quien reserva antes de programar eventos", WTo = "Los mensajes de texto solo se pueden enviar a los asistentes cuando el tipo de evento requiere confirmación.", GTo = "Organizaciones", HTo = "Subir logo de Cal Video", KTo = "Actualizar logo de Cal Video", YTo = "Subir banner", ZTo = "Para asegurar que tu logo sea visible contra el fondo oscuro de Cal Video, por favor sube una imagen de color claro en formato PNG o SVG para mantener la transparencia.", QTo = "Otros equipos", JTo = "Aquí puede ver los equipos dentro de su organización de los que no forma parte. Puede agregarse a ellos si es necesario.", XTo = "No formas parte de ninguna organización", eAo = "No se encontraron otros equipos", tAo = "No hay otros equipos en esta organización.", nAo = "Nombre del asistente", oAo = "Apellido del asistente", rAo = "Primer nombre de la persona que reserva", iAo = "Apellido de la persona que reserva", aAo = "Su resumen mensual", sAo = "Nombre del miembro", cAo = "Eventos más populares", lAo = "Este es el resumen de los eventos populares de su equipo {{teamName}} durante los últimos 30 días", dAo = "Yo", uAo = "Reunión no disponible", _Ao = "Correo electrónico de resumen mensual", pAo = "Correo electrónico de resumen mensual para equipos", mAo = "Verifique su equipo para activar el envío de mensajes a los asistentes", fAo = "Miembro eliminado", gAo = "Mi disponibilidad", hAo = "Disponibilidad del equipo", vAo = "Disponibilidad para reuniones instantáneas", bAo = "Código de respaldo", yAo = "Códigos de respaldo", $Ao = "Cada código de respaldo se puede utilizar exactamente una vez para conceder acceso sin su autenticador.", wAo = "¡Códigos de respaldo copiados!", kAo = "El código de respaldo no es correcto.", SAo = "Acceso perdido", xAo = "No se encontraron códigos de respaldo. Genere los códigos en su configuración.", EAo = "Nueva organización creada: acción pendiente", TAo = "Hola Administrador", AAo = "Una organización requiere la configuración DNS", CAo = 'Se creó una organización con slug "{{orgSlug}}".<br /><br />Asegúrese de configurar su registro DNS para que apunte el subdominio correspondiente a la nueva organización hacia donde se ejecuta la aplicación principal. De lo contrario, la organización no funcionará.<br /><br />Estas son solo las opciones muy básicas para configurar un subdominio para que apunte a su aplicación para que cargue la página de perfil de la organización.<br /><br />Puede hacerlo ya sea con el Registro A:', zAo = "O el registro CNAME:", OAo = "Una vez que configure el subdominio, marque la configuración DNS como se hace en la Configuración de administrador.", PAo = "Ir a la Configuración del administrador de organizaciones", IAo = "Se procesó la organización", RAo = "Ocurrió un error al procesar esta organización", NAo = "Una lista de todas las organizaciones. Aceptar una organización permitirá que todos los usuarios con ese dominio de correo electrónico se registren SIN verificación de correo electrónico.", DAo = "Sin verificar", MAo = "Verificado", LAo = "Falta el DNS", qAo = "DNS Configurado", jAo = "Marcar como DNS configurado", FAo = "Valor", VAo = "Su organization se actualizó con éxito", BAo = "Este equipo no tiene tipos de eventos", UAo = "La opción Cupo no soporta múltiples duraciones", WAo = "Incluir evento del calendario", GAo = "OAuth", HAo = "Formulario de creación de cliente OAuth", KAo = "Este es el formulario para crear un nuevo cliente OAuth", YAo = "Formulario de actualización de cliente OAuth", ZAo = "Este es el formulario para editar un cliente OAuth existente", QAo = "Añadido recientemente", JAo = "Conecte todos sus calendarios", XAo = "{{appName}} lee la disponibilidad de todos tus calendarios existentes.", eCo = "Personaliza tu experiencia de programación con flujos de trabajo", tCo = "Automatización del flujo de trabajo", nCo = "Programa para tu equipo con programación colectiva y en turnos rotativos", oCo = "No se encontraron miembros", rCo = "Directory Sync", iCo = "Nombre del directorio", aCo = "Proveedor del directorio", sCo = "URL base de SCIM", cCo = "Token de portador SCIM", lCo = "URL base de SCIM copiada", dCo = "Token de portador SCIM copiado", uCo = "Tu proveedor de identidad solicitará la siguiente información para configurar SCIM. Sigue las instrucciones para finalizar la configuración.", _Co = "Configurar sincronización de directorio", pCo = "Elige un proveedor de identidad para configurar el directorio para tu equipo.", mCo = "Configura un proveedor de identidad para empezar con SCIM.", fCo = "Conexión de sincronización de directorio creada.", gCo = "Provisiona y desprovisiona usuarios con tu proveedor de directorio.", hCo = "Conexión de sincronización de directorio eliminada.", vCo = "Eliminar Conexión", bCo = "Eliminar Conexión de Sincronización de Directorio", yCo = "¿Estás seguro de que quieres eliminar esta conexión de sincronización de directorio?", $Co = "Esta acción no se puede deshacer. Esto eliminará permanentemente la conexión de sincronización de directorio.", wCo = "Configuración del evento: la duración debe ser de al menos 1 minuto.", kCo = "Horarios de disponibilidad", SCo = "Sin autorización", xCo = "{{clientName}} quiere acceder a su cuenta de {{appName}}", ECo = "Seleccionar cuenta o equipo", TCo = "Esto permitirá que {{clientName}}", ACo = "Lo asocie con su información personal de {{clientName}}", CCo = "Consulte su información personal, incluida la información personal que haya hecho pública", zCo = "Consulte su dirección de correo electrónico principal", OCo = "Se conecte a sus aplicaciones instaladas", PCo = "Lea, edite y elimine sus tipos de eventos", ICo = "Lea, edite y elimine su disponibilidad", RCo = "Lea, edite y elimine sus reservas", NCo = "¿Desea permitir que {{clientName}} haga esto?", DCo = "Al hacer clic en permitir, permite que esta aplicación utilice su información de acuerdo con sus términos de servicio y política de privacidad. Puede eliminar el acceso en la App Store de {{appName}}.", MCo = "Permitir", LCo = "Este usuario no ha completado la incorporación. No podrá establecer su disponibilidad hasta que haya completado la incorporación.", qCo = "Está viendo la disponibilidad de este usuario. Sólo puede editar su propia disponibilidad.", jCo = "Puede anular esto por evento en la Configuración avanzada de cada tipo de evento.", FCo = "Editar disponibilidad del usuario: {{username}}", VCo = "Reenviar invitación", BCo = "Se reenvió la invitación.", UCo = "SAML", WCo = "Agregar cliente", GCo = "Después de copiar el secreto, ya no podrá volver a verlo", HCo = "Agregar nuevo cliente", KCo = "Añadir nuevo usuario", YCo = "Esta aplicación aún no se ha configurado", ZCo = "como CSV", QCo = "Superponer mi calendario", JCo = "Al conectarse a su calendario, acepta nuestra política de privacidad y nuestros términos de uso. Puede revocar el acceso en cualquier momento.", XCo = "Consulte los eventos de su calendario para evitar el conflicto de reservas.", ezo = "Únete a {{eventLocationType}}", tzo = "Solución de problemas", nzo = "Calendarios que estamos comprobando para conflictos", ozo = "Horarios de disponibilidad", rzo = "Gestionar calendarios", izo = "Gestionar horarios de disponibilidad", azo = "Bloqueado", szo = "Desbloqueado", czo = "Bloquear la zona horaria en la página de reserva", lzo = "Bloquear la zona horaria en la página de reserva, es útil para eventos en persona.", dzo = "Solo puedes tener una aplicación de pago habilitada por tipo de evento.", uzo = "Por favor, introduce el número en formato internacional.", _zo = "Instalar Calendario", pzo = "Subdominio personalizado", mzo = "Obtén tu propio subdominio personalizado, como acme.cal.com", fzo = "Perspectivas de toda la organización", gzo = "Entiende cómo toda tu organización está utilizando el tiempo", hzo = "Asistencia dedicada en materia de incorporación e ingeniería", vzo = "Personaliza tu experiencia de programación con tu propio logo, colores y más", bzo = "Equipos Ilimitados", yzo = "Verificar correo electrónico", $zo = "Por favor, introduzca la dirección de correo electrónico utilizada para esta reserva para proceder con la cancelación", wzo = "El correo electrónico no coincide con el correo de la reserva", kzo = "Añade tantos subequipos como necesites a tu organización", Szo = "Facturación Unificada", xzo = "Tipos de Eventos Avanzados Gestionados", Ezo = "Añade una sola tarjeta de crédito para pagar todas las suscripciones de tu equipo", Tzo = "Empresa", Azo = "Actualiza a Enterprise para crear tu Organización", Czo = "Crea tu Organización", zzo = "Crear organización", Ozo = "Actualiza a Organizaciones y recibe un subdominio, facturación unificada, Insights, personalización extensa y más", Pzo = "Actualiza a Enterprise y obtén acceso a la sincronización de Active Directory, aprovisionamiento automático de usuarios SCIM, agentes de voz de Cal.ai, APIs de administración y más", Izo = "Solo puedes habilitar una aplicación de pago por tipo de evento", Rzo = "Los equipos que son miembros de esta organización también serán eliminados junto con sus tipos de eventos", Nzo = "Los usuarios que formaban parte de la organización no serán eliminados, pero sus nombres de usuario se cambiarán para permitirles existir fuera de la organización", Dzo = "Los tipos de eventos de usuario creados después de que el usuario estuviera en la organización serán eliminados", Mzo = "Los tipos de eventos de usuario migrados no serán eliminados", Lzo = "¿Eliminar {{organizationName}}?", qzo = "Publicado", jzo = "No Publicado", Fzo = "Publicar", Vzo = "Abre el solucionador de problemas y averigua qué está mal con tu horario", Bzo = "¿Necesita ayuda?", Uzo = "Solucionador de Problemas", Wzo = "Número a Llamar", Gzo = "Nombre del Invitado", Hzo = "Correo Electrónico del Invitado", Kzo = "Empresa del Invitado", Yzo = "Por favor, instala un calendario", Zzo = "Reserva Instantánea", Qzo = "Permite que la gente reserve inmediatamente", Jzo = "Actualiza a Enterprise y permite que los invitados se unan a una llamada instantánea a la que los asistentes pueden entrar directamente. Esto es solo para tipos de eventos de equipo", Xzo = "¿No quieres esperar?", eOo = "Reunión Iniciada", tOo = "Pagar para reservar", nOo = "Permite que Agentes de IA te reserven", oOo = "No se pudo encontrar la reserva", rOo = "No hay asientos disponibles para la reserva", iOo = "Faltan credenciales de pago", aOo = "Falta el ID de la aplicación de pago", sOo = "No hay suficientes asientos disponibles para la reserva", cOo = "{{username}} está ausente por un breve período de tiempo.", lOo = "Mientras tanto, {{profile.username}} se encargará de todas las nuevas reuniones programadas en nombre de {{username}}.", dOo = "Fuera de la oficina", uOo = "Informa a tus reservadores cuando estés fuera de la oficina.", _Oo = "Enviar solicitud", pOo = "Se requieren fecha de inicio y fecha de fin", mOo = "La fecha de inicio debe ser antes de la fecha de fin", fOo = "La fecha de inicio debe estar en el futuro", gOo = "Usuario no encontrado", hOo = "No se puede redirigir a sí mismo", vOo = "Ya existe una entrada de fuera de la oficina", bOo = "Se requiere el ID de la entrada de fuera de la oficina", yOo = "Ya existe una redirección de reserva de ese usuario hacia ti.", $Oo = "Entrada creada con éxito", wOo = "Notificación de redirección de reserva", kOo = "Notificación de Redirección de Reserva", SOo = "Has recibido una redirección de reserva de {{eventOwner}}, por lo que los enlaces de su perfil se redirigirán al tuyo durante el intervalo de tiempo {{dates}}.", xOo = "Notificación de edición de redirección de reserva", EOo = "Notificación de Edición de Redirección de Reserva", TOo = "Tu redirección de reserva de {{eventOwner}} para el intervalo de tiempo {{oldDates}} ha sido actualizada. El nuevo intervalo de tiempo para la redirección es {{dates}}.", AOo = "Notificación de cancelación de redirección de reserva", COo = "Notificación de Cancelación de Redirección de Reserva", zOo = "Tu redirección de reserva de {{eventOwner}} para el intervalo de tiempo {{dates}} ha sido cancelada.", OOo = "Has aceptado esta solicitud de redirección de reserva.", POo = "Has rechazado esta solicitud de redirección de reserva.", IOo = "Copiar enlace para compartir solicitud", ROo = "Solicitud de Redirección de Reserva", NOo = "Seleccionar miembro del equipo", DOo = "¿Te vas? Simplemente marca el enlace de tu perfil como no disponible por un período de tiempo.", MOo = "Proporciona un enlace a un miembro del equipo cuando estés fuera de la oficina", LOo = "Proporciona un enlace a un miembro del equipo cuando estés fuera de la oficina (Se requiere plan de equipo)", qOo = "Lista de indisponibilidad fuera de la oficina", jOo = "Entrada eliminada con éxito", FOo = "Entrada editada con éxito", VOo = "¿Fuera de la oficina temporalmente?", BOo = "Agregar una redirección", UOo = "Crear entrada", WOo = "Rango de tiempo", GOo = "Agregar a todos los miembros del equipo, incluidos los futuros", HOo = "Redirigir a", KOo = "¿Tienes problemas para encontrar un tiempo?", YOo = "Mostrar más", ZOo = "Reenviar parámetros como ?email=...&name=... y más", QOo = "Programa reuniones cuando todos estén disponibles o rota entre los miembros de tu equipo", JOo = "más bajo", XOo = "bajo", e4o = "medio", t4o = "alto", n4o = "más alto", o4o = "Enviar a Booker a", r4o = "Establecer prioridad", i4o = "Establecer peso", a4o = "Habilitar pesos", s4o = "Prioridad para {{userName}}", c4o = "Los pesos determinan cómo se distribuyen las reuniones entre los anfitriones. <0>Más información</0>", l4o = "Peso para {{userName}}", d4o = "cambiar prioridad", u4o = "Usa identificadores de campo como variables para tu redirección de eventos personalizada", _4o = "Usa identificadores de campo como variables para tu redirección de eventos personalizada (por ejemplo, {{variable}})", p4o = "La cuenta ya está vinculada", m4o = "Enviar correo electrónico", f4o = "Llamar al asistente usando el agente de voz de Cal.ai", g4o = "Llamada para confirmar reserva", h4o = "2 horas antes del inicio del evento", v4o = "Configuración del agente Cal.ai", b4o = "Por favor, elige al menos un tipo de evento para realizar una llamada de prueba.", y4o = "Marcar como no presentado", $4o = "Desmarcar como no presentado", w4o = "Cuenta desvinculada con éxito", k4o = "Hubo un error al desvincular la cuenta", S4o = "Horario de viaje", x4o = "Planifica tu viaje con anticipación para mantener tu horario existente en una zona horaria diferente y evitar ser reservado a medianoche.", E4o = "Programar cambio de zona horaria", T4o = "Fecha", A4o = "Introduce la indicación general para el agente", C4o = "Esto se superpone con un horario existente. Por favor selecciona una fecha diferente.", z4o = "Recibir notificaciones cuando tu equipo no tenga disponibilidad", O4o = "Los administradores recibirán notificaciones por correo electrónico cuando un usuario intente reservar con un miembro del equipo y no haya disponibilidad. Enviamos este correo después de dos intentos y te recordamos cada 7 días por usuario.", P4o = "Desactivar notificaciones SMS para tipos de eventos solo con teléfono", I4o = "Desactivar notificaciones SMS automáticas para tipos de eventos que solo tienen número de teléfono (attendeePhoneNumber) como pregunta obligatoria con correo electrónico opcional o no requerido", R4o = "Tu plan actual", N4o = "$37 por usuario al mes", D4o = "Gestiona la configuración de privacidad para tu organización", M4o = "Privacidad", L4o = "Los nuevos equipos estarán bajo tu organización", q4o = "Añadir nombre del grupo", j4o = "Nombre del grupo", F4o = "Enrutadores", V4o = "Primario", B4o = "Hacer primario", U4o = "Añadir correo electrónico", W4o = "Añadir correos electrónicos", G4o = "Añade una dirección de correo electrónico para reemplazar tu principal o para usar como correo alternativo en tus tipos de eventos.", H4o = "Confirma tu correo electrónico", K4o = "$t(hey_there) {{name}}, confirmando tu reserva para el {{date}}.", Y4o = "El nombre de la persona que reserva", Z4o = "El apellido de la persona que reserva", Q4o = "Nombre del programador", J4o = "Tu nombre", X4o = "Enviamos un correo electrónico a <strong>{{email}}</strong>. Haz clic en el enlace del correo para verificar esta dirección.", e3o = "Enviar detalles del evento a", t3o = "Programar zona horaria sin fecha de finalización", n3o = "Seleccionar miembros", o3o = "¿Qué debemos hacer con los tipos de eventos existentes de tu miembro?", r3o = "Todos los tipos de eventos individuales de tus miembros (excepto los gestionados) se eliminarán permanentemente. No podrán crear nuevos.", i3o = "Los tipos de eventos individuales de tus miembros (excepto los gestionados) se ocultarán de los perfiles, pero los enlaces seguirán activos. No podrán crear nuevos.", a3o = "Ocultar tipos de eventos individuales", s3o = "Eliminar tipos de eventos individuales", c3o = "Bloquear la creación de tipos de eventos individuales", l3o = "Evitar que los miembros creen sus propios tipos de eventos.", d3o = "Añadir al tipo de evento", u3o = "Crear contraseña de cuenta", _3o = "Crear cuenta con SAML", p3o = "Error al crear la contraseña de la cuenta", m3o = "No se puede crear la contraseña de la cuenta para cuentas de calendario", f3o = "No se puede crear la contraseña de la cuenta para las ya existentes", g3o = "No tienes una contraseña de cuenta, crea una navegando a Seguridad -> Contraseña. No puedes desconectar hasta que se cree una contraseña de cuenta.", h3o = "Desconectar cuenta conectada", v3o = "Desconectar tu cuenta conectada cambiará la forma en que inicias sesión. Solo podrás iniciar sesión en tu cuenta usando correo electrónico + contraseña", b3o = "Estoy de acuerdo con la política de privacidad y el uso de cookies", y3o = "Hacer una llamada", $3o = "Omitir asignación de turnos si el contacto existe en Salesforce", w3o = "La URL debe contener el correo electrónico del contacto como parámetro, por ejemplo, ?email=contactEmail", k3o = "Seleccionar cuenta", S3o = "Instala {{appName}} en tu cuenta personal o en una cuenta de equipo.", x3o = "Seleccionar tipos de eventos", E3o = "¿En qué tipo de evento quieres instalar {{appName}}?", T3o = "Configurar {{appName}}", A3o = "Finaliza la configuración de la aplicación. Puedes cambiar estos ajustes más tarde.", C3o = "ya instalado", z3o = "No especificado", O3o = "Vacaciones", P3o = "Viaje", I3o = "Baja por enfermedad", R3o = "Día festivo", N3o = "Reenviando a <0>{{username}}</0>", D3o = "Sin reenvío", M3o = "Crear un OOO", L3o = "Comunica a tus reservadores cuando no estés disponible para tomar reservas. Aún pueden reservarte a tu regreso o puedes reenviarlos a un miembro del equipo.", q3o = "{{displayName}} está fuera de la oficina", j3o = "<0>{{displayName}}</0> puede tomar sus reuniones mientras está fuera.", F3o = "Reservar con {{displayName}}", V3o = "Seleccionar motivo", B3o = "Salir de la oficina", U3o = "Editar Entrada de Fuera de la Oficina", W3o = "Enviar comentarios", G3o = "Tu anfitrión no se presentó", H3o = "Puedes reprogramar otra reunión con ellos", K3o = "¿Cómo podemos mejorar nuestro servicio?", Y3o = "¿Qué te gustó más?", Z3o = "Reseña", Q3o = "Reseñado", J3o = "Sin revisar", X3o = "URL de valoración", e6o = "La URL para el formulario de retroalimentación de calificaciones", t6o = "URL de no asistencia", n6o = "La URL para la retroalimentación de no asistencia", o6o = "¿No se necesita soporte?", r6o = "Ocultar soporte", i6o = "Calificaciones promedio", a6o = "No presentado (Anfitrión)", s6o = "No presentado (Invitado)", c6o = "Calificaciones recientes", l6o = "No se han enviado calificaciones", d6o = "Agrega un flujo de trabajo con 'Calificación' para recopilar calificaciones después de las reuniones", u6o = "Mayor ausencia", _6o = "Mejor calificado", p6o = "Peor calificado", m6o = "Miembros con reuniones mejor calificadas", f6o = "Miembros con reuniones peor calificadas", g6o = "Puntuación CSAT", h6o = "SMS bloqueado", v6o = "¿Salir sin asignar a nadie?", b6o = "¿Estás seguro de que quieres salir de este evento sin agregar asistentes?", y6o = "Si no asignas a nadie para este evento, no habrá disponibilidad mostrada a los reservadores.", $6o = "Volver y asignar", w6o = "Salir sin asignar", k6o = "Al continuar, acepta nuestras <0>condiciones de uso</0> y nuestra <1>política de privacidad</1>.", S6o = "Al continuar, aceptas nuestros", x6o = "Términos", E6o = "Siempre {{x}} días disponibles", T6o = "Mueve automáticamente la ventana de reservas de {{x}} días hacia adelante cada día, asegurando que tu calendario siempre muestre los próximos {{x}} días de espacios disponibles.", A6o = "Suscripción del equipo cancelada con éxito", C6o = "Error al cancelar la suscripción del equipo", z6o = "Ocurrió un error al intentar suscribirse al plan de la plataforma, por favor intente de nuevo más tarde", O6o = "Ocurrió un error al actualizar el cliente OAuth, por favor intente de nuevo más tarde", P6o = "Ocurrió un error al crear el cliente OAuth, por favor intente de nuevo más tarde", I6o = "Color del tipo de evento", R6o = "Esto solo se usa para diferenciar el tipo de evento y la reserva dentro de la aplicación. No se muestra a los reservadores.", N6o = "Marcar como no presentado", D6o = "{{x}} marcado como no presentado", M6o = "{{x}} desmarcado como no presentado", L6o = "se activa para todos los tipos de eventos del equipo y los tipos de eventos personales de todos los miembros del equipo", q6o = "Administra la configuración de tu equipo", j6o = "Estado de no presentado actualizado para los asistentes", F6o = "Correo electrónico copiado", V6o = "Número de teléfono copiado", B6o = "El usuario es un miembro pendiente de la organización", U6o = "El usuario ya está invitado o es miembro", W6o = "El usuario es miembro de una organización de la que este equipo no forma parte.", G6o = "La reserva ha sido reasignada", H6o = "Reasignar", K6o = "Reasignar la reserva a otro anfitrión disponible de round robin", Y6o = "Asignar miembro del equipo", Z6o = "Anular qué miembro del equipo desea asignar.", Q6o = "No hay anfitriones disponibles", J6o = "Reasignar anfitrión de round robin", X6o = "No escribir en el feed ICS", e5o = "No es posible reprogramar ya que el evento ha expirado", t5o = "Este evento ha expirado", n5o = "Omitir la creación de contactos si no existen en {{appName}}", o5o = "Si su enlace ICS es de solo lectura (por ejemplo, Proton Calendar), marque la casilla de arriba para evitar errores. También deberá actualizar manualmente su calendario para los cambios.", r5o = "Atributos", i5o = "Nuevo atributo", a5o = "Agregar atributos", s5o = "Añadir atributos a los miembros de tu equipo", c5o = "Nueva opción", l5o = "Actualizar miembro", d5o = "Atributo", u5o = "Crear un atributo para los miembros de tu equipo", _5o = "Editar un atributo para los miembros de tu equipo", p5o = "Atributo actualizado con éxito", m5o = "Atributo eliminado con éxito", f5o = "Atributos editados con éxito", g5o = "Gestionar atributos para los miembros de tu equipo", h5o = "Editar atributos para los miembros de tu equipo", v5o = "Volver a atributos", b5o = "¿Estás seguro de que quieres eliminar esta opción?", y5o = "Esta opción está asignada a {{numberOfUsers}} miembros. Eliminarla la quitará de sus perfiles.", $5o = "Desactivar correos electrónicos estándar a los asistentes relacionados con este tipo de evento", w5o = "Desactiva la comunicación por correo electrónico estándar relacionada con este tipo de evento, incluidas las confirmaciones de reserva, recordatorios y cancelaciones.", k5o = "Desactivar correos electrónicos estándar a los anfitriones relacionados con este tipo de evento", S5o = "Escribe confirmar para continuar", x5o = "Desactivar correo electrónico", E5o = "Conceder acceso a la API de administrador", T5o = "Revocar acceso a la API de administrador", A5o = "Agregar calendario de {{calendar}}", C5o = "Conectar Calendario de Apple", z5o = "Calendario de Apple conectado", O5o = "Comprobando Calendario de Apple", P5o = "Conectar Calendario de Google", I5o = "Calendario de Google conectado", R5o = "Comprobando Calendario de Google", N5o = "Conectar Calendario de Outlook", D5o = "Calendario de Outlook conectado", M5o = "Comprobando el calendario de Outlook", L5o = "Conectar con Stripe", q5o = "Stripe conectado", j5o = "Verificando credenciales de Stripe", F5o = "Variables de respuesta a preguntas de reserva", V5o = "Gestionado por {{teamAdmins}}", B5o = "{{count}} opciones", U5o = "Reprogramar con el mismo anfitrión de Round-Robin", W5o = "Los eventos reprogramados se asignarán al mismo anfitrión que inicialmente", G5o = "Desactivar entrada si el identificador de URL está prellenado", H5o = "Límites de Reservas", K5o = "Límites de reservas para los miembros del equipo en todos los tipos de eventos del equipo", Y5o = "Limitar cuántas veces se pueden reservar los miembros en todos los tipos de eventos del equipo", Z5o = "Límites de reservas actualizados con éxito", Q5o = "No tienes autorización para realizar este cambio en la reserva", J5o = "Credencial de delegación deshabilitada", X5o = "Miembros coincidentes", ePo = "{{x}} miembros coincidentes", tPo = "Cola de miembros coincidentes (usando pesos de atributos)", nPo = "Cola de miembros coincidentes (usando pesos de asignados al evento)", oPo = "No hay miembros coincidentes. Se utilizarán los miembros del equipo asignados al tipo de evento como alternativa.", rPo = "No hay miembros coincidentes. Se utilizarán los miembros del equipo asignados al tipo de evento como alternativa. Considera añadir una opción de respaldo o corregir la lógica de using_fallback_members", iPo = "Ocultar detalles de eventos del calendario en calendarios compartidos", aPo = "Cuando se comparte un calendario, los eventos son visibles para los lectores, pero sus detalles están ocultos para aquellos sin acceso de escritura.", sPo = "Últimos {{count}} días", cPo = "Mes hasta la fecha", lPo = "Año hasta la fecha", dPo = "Rango personalizado", uPo = "Política de reembolso", _Po = "Siempre", pPo = "Nunca", mPo = "Opción de pago", fPo = "Si se cancela", gPo = "antes", hPo = "Mostrar todas las columnas", vPo = "Alternar columnas", bPo = "No se encontraron columnas", yPo = "Al reservar, agregar eventos y nuevos asistentes como:", $Po = "Cliente potencial", wPo = "Contacto bajo una cuenta", kPo = "Omitir la creación del registro de {{entry}} si no existe en Salesforce", SPo = "Si el contacto no existe bajo una cuenta, crear un nuevo cliente potencial a partir del asistente", xPo = "Crear un nuevo contacto bajo una cuenta basado en el dominio de correo electrónico del asistente y los contactos existentes", EPo = "Cambiar propietario del registro en la reserva", TPo = "Asignar atributos en masa", APo = "Resulta en mostrar un mensaje personalizado. Intenta cambiar la respuesta para redirigir a un evento", CPo = "Resulta en redirigir a {{externalUrl}}. Intenta cambiar la respuesta para redirigir a un evento", zPo = "Posible anfitrión", OPo = "Estado actual de enrutamiento", PPo = "Redirigir reserva", IPo = "Redirige la reserva a diferentes miembros del equipo", RPo = "Verificar nueva ruta", NPo = "Redirigir", DPo = "Nuevo estado de enrutamiento", MPo = "Si el asistente existe en Salesforce, reservar directamente con el propietario", LPo = "Entidad de la que verificar el propietario para reservar directamente", qPo = "Cuenta", jPo = "Elegir horarios de los anfitriones", FPo = "Puedes seleccionar un horario diferente para cada anfitrión. Por defecto, se elige el horario predeterminado de cada anfitrión.", VPo = "No hay anfitriones asignados, añade anfitriones en la pestaña de asignación.", BPo = "Reasignar manualmente el anfitrión de round robin", UPo = "Reasignar manualmente el anfitrión de round robin a otro anfitrión disponible", WPo = "Reasignar el anfitrión de round robin a otro anfitrión disponible", GPo = "El nuevo usuario no es un anfitrión válido de round robin para este tipo de evento", HPo = "El nuevo usuario es un anfitrión fijo para este tipo de evento", KPo = "Reprogramar con el mismo horario", YPo = "Reprogramar con el mismo horario del nuevo evento", ZPo = "Reprogramar al nuevo evento con un horario diferente", QPo = "Reprogramar con un horario diferente", JPo = "No tenemos ID para el nuevo evento. Por favor, ve al Formulario de Enrutamiento y guárdalo de nuevo.", XPo = "Reserva redirigida con éxito. Redirigiendo a la página de reserva", eIo = "Al reservar, escribir en el objeto del evento", tIo = "Nombre del campo", nIo = "Añadir nuevo campo", oIo = "No tienes acceso para redirigir esta reserva", rIo = "Respuesta del formulario no encontrada", iIo = "Propietario del contacto", aIo = "No encontrado", sIo = "Usando miembros de respaldo", cIo = "Ruta elegida", lIo = "Lógica de atributos coincidente", dIo = "Lógica de atributos de respaldo coincidente", uIo = "Todos los miembros asignados al tipo de evento del equipo. Considera añadir algunas reglas de atributos.", _Io = "Todos los miembros asignados al tipo de evento del equipo. Considera añadir algunas reglas de atributos como respaldo.", pIo = "Todos los miembros asignados al tipo de evento del equipo. Considera ajustar el respaldo para obtener una coincidencia.", mIo = "Advertencia", fIo = "Respaldo: Si ningún miembro del equipo coincide, usa aquellos que cumplan los siguientes criterios (por defecto, coincide con todos los miembros del equipo asignados al evento)", gIo = "Advertencia de lógica de atributos de respaldo", hIo = "No es necesario", vIo = "Anfitrión no disponible", bIo = "Anfitrión disponible", yIo = "¿Estás seguro de que quieres reasignar esta reserva a un anfitrión no disponible?", $Io = "¿Estás seguro de que quieres reasignar esta reserva?", wIo = "Sí, reasignar", kIo = "Filtrar por atributos", SIo = "Motivo de la reasignación", xIo = "Cambiar el tipo de campo puede causar pérdida de datos. Por favor, crea un nuevo campo en su lugar.", EIo = "Reasignado por", TIo = "fila", AIo = "filas", CIo = "Zona horaria del asistente", zIo = "Hora de inicio del evento en la zona horaria del asistente", OIo = "Hora de inicio del evento en la zona horaria del asistente", PIo = "Hora de finalización del evento en la zona horaria del asistente", IIo = "Hora de finalización del evento en la zona horaria del asistente", RIo = "Crear evento en el contacto, si existe. De lo contrario, usar el lead", NIo = "Nombre del propietario a cambiar", DIo = "Ningún filtro establecido", MIo = "Prueba de reserva exitosa", LIo = "La prueba de simulación se completó con éxito.", qIo = "No tienes acceso a esta página", jIo = "Para ver o interactuar con esta página, debes tener privilegios de administrador o propietario", FIo = "Tipo de campo", VIo = "Cuándo escribir", BIo = "Al reservar, escribir en un campo personalizado en el registro {{record}} del asistente", UIo = "En cada reserva", WIo = "Solo si el campo está vacío", GIo = "Fecha de inicio de la reserva", HIo = "Fecha de creación de la reserva", KIo = "Reserva reasignada a {{host}}", YIo = "Sin propietario del contacto", ZIo = "Formularios de enrutamiento creados", QIo = "Total de respuestas", JIo = "Total de respuestas sin reserva", XIo = "Total de respuestas con reserva", eRo = "Sin reservas", tRo = "Nombre del formulario", nRo = "Reserva", oRo = "Sin reserva", rRo = "Reservado por", iRo = "Creado el", aRo = "Estado de la reserva", sRo = "Fecha de reserva", cRo = "Fecha de envío", lRo = "Copiar URL de redirección", dRo = "URL de redirección al salir", uRo = "Total de reservas por período", _Ro = "Enrutado a por período", pRo = "Por día", mRo = "Por semana", fRo = "Por mes", gRo = "Motivo de asignación", hRo = "Acceso denegado", vRo = "El propietario del contacto será el anfitrión de Round Robin si está disponible", bRo = "Añadir nuevos asistentes como", yRo = "No se forzará al propietario del contacto (aún puede ser anfitrión si coincide con los atributos y criterios de Round Robin)", $Ro = "Dirigir a un usuario que coincida con un campo de búsqueda en una cuenta", wRo = "Opción de Salesforce", kRo = "Nombre del campo de búsqueda", SRo = "Si el asistente tiene un dominio de correo gratuito, omitir la verificación de propiedad y distribuir round robin de forma normal", xRo = "Es", ERo = "No es", TRo = "Contiene", ARo = "No contiene", CRo = "Empieza con", zRo = "Termina con", ORo = "Está vacío", PRo = "No está vacío", IRo = "Auto traducir título y descripción", RRo = "Traduce automáticamente títulos y descripciones al idioma del navegador del visitante usando IA.", NRo = "Distribución", DRo = "Permite optimizar la distribución para maximizar la disponibilidad o lograr una asignación más equilibrada.", MRo = "Maximizar disponibilidad", LRo = "Permite a los usuarios reservar reuniones cuando un anfitrión esté disponible. Utiliza esta opción para maximizar el número de reuniones potenciales y cuando la distribución equitativa entre anfitriones sea menos importante.", qRo = "Equilibrio de carga", jRo = "Monitorizaremos cuántas reservas se han realizado con cada anfitrión y las compararemos con otros, deshabilitando algunos anfitriones que estén muy por delante para que las reservas se distribuyan uniformemente.", FRo = "Editar pesos", VRo = "Pesos actualizados correctamente", BRo = "Solo requerir confirmación para proveedores de correo gratuito (Ej. @gmail.com, @outlook.com)", URo = "Excluir correos que contengan...", WRo = "Requerir correos que contengan...", GRo = "Por favor, introduce una dirección de correo electrónico laboral válida", HRo = "No tienes permiso para agendar con este dominio de correo electrónico. Por favor, contacta al propietario de este enlace.", KRo = "Buscar columnas", YRo = "Opciones de búsqueda", ZRo = "Desactivar perfil público de la organización y redireccionar", QRo = "Redirecciona {{orgSlug}}.cal.com a {{destination}}", JRo = "Selección única", XRo = "Selección múltiple", eNo = "Configuración de conflictos de calendario", tNo = "Selecciona qué calendarios comprobar para detectar conflictos", nNo = "Reunión grupal", oNo = "¿Está seguro de que desea eliminar esta aplicación de", rNo = "Desconectar aplicación de", iNo = "No crear nuevos registros para invitados añadidos a la reserva", aNo = "Google Meet", sNo = "Zoom", cNo = "Video de MS Teams", lNo = "Bloquear para asignación", dNo = "El bloqueo solo permitirá asignaciones desde la sincronización del directorio", uNo = "Atributo editado correctamente", _No = "Nueva opción de grupo", pNo = "Pesos habilitados", mNo = "Al habilitar los pesos, sería posible asignar mayor prioridad a ciertos atributos por usuario. Cuanto mayor sea el peso, mayor será la prioridad.", fNo = "Enrutado", gNo = "Reasignado", hNo = "Permitir reprogramar eventos pasados", vNo = "Al habilitar esta opción se permite reprogramar eventos pasados", bNo = "Reenrutado", yNo = "Asignación de Salesforce", $No = "Posición del enrutador", wNo = "Mostrar hosts coincidentes", kNo = "No hay colas activas para esta entrada", SNo = "Peso", xNo = "Calibración", ENo = "Déficit", TNo = "Formulario de enrutamiento", ANo = "Volver y guardar", CNo = "Guardar cambios", zNo = "Salir sin guardar", ONo = "¿Estás seguro de que quieres salir sin guardar los cambios en tu formulario de enrutamiento?", PNo = "Algo inesperado ha ocurrido", INo = "Estás haciendo una reserva de prueba.", RNo = "Muestra de iconos", NNo = "Muestra de iconos", DNo = "Migrando desde el equipo", MNo = "La función está actualmente desactivada", LNo = "Elige una opción", qNo = "Ingresa el valor de la opción", jNo = "Eliminar opción", FNo = "Usar pesos de atributos", VNo = "Si está activado, se ignorarán todos los pesos establecidos dentro del tipo de evento", BNo = "Atributo para pesos", UNo = "Usuarios gestionados", WNo = "Ver todos los usuarios gestionados creados por tu cliente OAuth", GNo = "¿Puedes contarme sobre ", HNo = "Usa la IA para responder tus preguntas", KNo = "Error al obtener la respuesta ", YNo = "Ocurrió un error inesperado. Por favor, inténtalo de nuevo más tarde", ZNo = "Seleccionar cliente OAuth", QNo = "En cada instancia", JNo = "La función de credencial de delegación no está habilitada para tu organización", XNo = "Nota interna", eDo = "Motivo compartido con el cliente (opcional)", tDo = "Esta nota solo será visible para los miembros de tu equipo", nDo = "Plantillas de notas internas de cancelación", oDo = "Crea plantillas para notas internas que se pueden aplicar a las reservas", rDo = "Las plantillas de notas internas se actualizaron correctamente", iDo = "Agregar plantilla", aDo = "Autorizar", sDo = "Siguiente", cDo = "Ocultar", lDo = "Mostrar", dDo = "Parámetros UTM", uDo = "No hay parámetros UTM disponibles.", _Do = "Asc", pDo = "Desc", mDo = "Verificar cambio de correo electrónico", fDo = "Comprar créditos", gDo = "Créditos", hDo = "Créditos utilizados", vDo = "Total restante", bDo = "Recibes 1000 créditos por mes, por miembro del equipo", yDo = "Recibes 750 créditos por mes, por miembro del equipo", $Do = "Ver y gestionar créditos para enviar mensajes SMS", wDo = "Ver y gestionar créditos para enviar mensajes SMS. Un crédito equivale a 1¢ (USD). <0>Más información</0>", kDo = "Un crédito vale 1¢ (USD). <0>Más información</0>", SDo = "Comprar créditos adicionales ($0.01 por crédito)", xDo = "Puedes ver el gasto de créditos adicionales en tu registro de gastos", EDo = "Resumen", TDo = "El slug de la organización ya está en uso", ADo = "No puedes crear una organización ya que ya formas parte de una", CDo = "Necesitas completar la incorporación de usuario antes de crear una organización", zDo = "Usa el correo electrónico de la empresa para crear una organización", ODo = "No puedes crear una organización de plataforma ya que ya formas parte de un equipo", PDo = "Necesitas tener un mínimo de equipos publicados", IDo = "Ya formas parte de esta organización", RDo = "Formas parte de otra organización, no puedes crear una nueva", NDo = "Formas parte de otra organización de plataforma, no puedes crear una nueva organización", DDo = "Pago de la organización exitoso", MDo = "Tu organización se ha creado con éxito", LDo = "Esto puede tardar unos segundos...", qDo = "Estado de incorporación de la organización", jDo = "Descripción del estado de incorporación de la organización", FDo = "El pago ha fallado", VDo = "Tu pago ha fallado. Por favor, inténtalo de nuevo.", BDo = "Creando tu organización", UDo = "La incorporación de la organización ya se ha completado", WDo = "La incorporación de la organización ya existe", GDo = "No se encontró la incorporación de la organización", HDo = "¡Pago exitoso!", KDo = "Traspaso de incorporación", YDo = "Traspaso de incorporación al usuario", ZDo = "Ya existe una organización con este slug", QDo = "No tienes permiso para crear una organización con este correo electrónico", JDo = "No tienes permiso para migrar uno o más de los equipos", XDo = "La organización ya tiene una suscripción", eMo = "Intervalo de reinicio para Round Robin ponderado", tMo = "Intervalo", nMo = "Determina con qué frecuencia se reinicia el conteo de reservas de rotación para asegurar una distribución equilibrada.", oMo = "Diario", rMo = "No has establecido una fecha de finalización para tu ausencia", iMo = "Mi ausencia", aMo = "Ausencia del equipo", sMo = "Gestiona las ausencias de tu equipo.", cMo = "Crear ausencia", lMo = "Crear una ausencia para un miembro del equipo", dMo = "Editar una ausencia para un miembro del equipo", uMo = "Crear ausencia para tu equipo", _Mo = "Comunica a los reservadores cuándo los miembros de tu equipo no están disponibles para aceptar reservas. Aún pueden ser reservados a su regreso o puedes redirigirlos a otro miembro del equipo.", pMo = "El reenvío de ausencias solo está permitido a un miembro del mismo equipo.", mMo = "Ya existe un reenvío inverso entre estos usuarios.", fMo = "No se encontraron ausencias anteriores", gMo = "Anterior", hMo = "Intervalo de Round Robin actualizado con éxito", vMo = "Modo de prueba", bMo = "Plan de equipo inactivo", yMo = "Tu plan de equipo está inactivo. Revisa tu suscripción o contacta con el soporte al cliente", $Mo = "Acceso limitado durante la prueba. Función disponible después de que termine la prueba.", wMo = "Programa de referidos", kMo = "Gana 20% de referencia", SMo = "Necesitas una clave API de Dub y un ID de programa para usar esta página.", xMo = "UID", EMo = "Enlace", TMo = "filas por página", AMo = "{{currentRange}} de {{totalItems}}", CMo = "Consejo: Puedes añadir un '+' entre nombres de usuario: cal.com/anna+brian para crear una reunión grupal dinámica", zMo = "Aún no tienes un equipo", OMo = "Aún no tienes miembros en tu equipo", PMo = "Los eventos recurrentes no admiten la función de asientos. Hazlo no recurrente para habilitar asientos.", IMo = "El evento recurrente no es compatible con la función de límite de reservas por persona. Desactiva el límite de reservas por persona para habilitar el evento recurrente.", RMo = "La función de asientos no admite eventos recurrentes. Desactiva la función de asientos para hacerlo recurrente.", NMo = "Los eventos recurrentes no admiten la función de asientos. Desactiva la función de asientos o haz que el evento no sea recurrente.", DMo = "Segmento", MMo = "Filtros guardados", LMo = "Renombrar", qMo = "Renombrar segmento", jMo = "Eliminar segmento", FMo = "Duplicar segmento", VMo = "¿Estás seguro de que quieres eliminar este segmento? Esta acción no se puede deshacer.", BMo = "Segmento de filtro actualizado", UMo = "Error al actualizar el segmento de filtro", WMo = "Segmento de filtro duplicado", GMo = "Error al duplicar el segmento de filtro", HMo = "Segmento de filtro eliminado", KMo = "Error al eliminar el segmento de filtro", YMo = "Guardar segmento", ZMo = "Segmento no encontrado", QMo = "Segmento de filtro guardado", JMo = "Sin segmentos", XMo = "Error al guardar el segmento de filtro", eLo = 'Guardar cambios en "{{name}}"', tLo = "Crear nuevo segmento", nLo = "Guardar para el equipo", oLo = "Seleccionar equipo", rLo = "Por favor, selecciona un equipo", iLo = "Personal", aLo = "Ocultar enlace del perfil del equipo", sLo = "Ocultar el enlace del perfil del equipo en las páginas de reserva", cLo = "Mostrar", lLo = "No se pudo encontrar el slug para publicar la organización", dLo = "Lista de selección", uLo = "Más cancelaciones", _Lo = "Idioma de la interfaz", pLo = "Establece tu idioma preferido para la interfaz de reservas", mLo = "Idioma del navegador del visitante", fLo = "Nombre o correo electrónico", gLo = "Si no se encuentra ningún contacto, recurrir al propietario del lead si existe", hLo = "La compra de créditos falló. Por favor, inténtalo de nuevo o contacta con soporte.", vLo = "Se requiere un mínimo de 50 créditos", bLo = "Habilitar credencial de delegación", yLo = "Concede a Cal.com acceso automático a los calendarios de todos los miembros de la organización habilitando la credencial de delegación.", $Lo = "Deshabilitar credencial de delegación", wLo = "Una vez que se desactiva la credencial de delegación, los miembros de la organización que no hayan conectado sus calendarios deberán hacerlo manualmente.", kLo = "Última actividad", SLo = "Miembro desde", xLo = "Última actualización", ELo = "Al cancelar la reserva, escribir en el registro del evento en lugar de eliminarlo", TLo = "En cada cancelación", ALo = "Informar de un problema", CLo = "Puedes enviar un ticket en GitHub o actualizar tu plan para recibir soporte en tiempo real con conferencias de desarrolladores", zLo = "Abrir incidencia", OLo = "Este es tu plan actual", PLo = "Programar una hora", ILo = "Esto incluye:", RLo = "Cliente OAuth actualizado correctamente", NLo = "Cliente OAuth no encontrado.", DLo = "Suscribirse a la plataforma", MLo = "Error al intentar acceder a los webhooks.", LLo = "Error al actualizar el webhook.", qLo = "Error al crear el webhook.", jLo = "Enlace no válido", FLo = "Actualmente estás suscrito al plan {{planFirstLetter}}{{planRest}}", VLo = "Usuario/Equipo", BLo = "¡ID de cliente copiado!", ULo = "¡Secreto de cliente copiado!", WLo = "El equipo de Cal.com está realizando mantenimiento programado. Si tienes alguna pregunta, contacta con soporte.", GLo = "Tu pago ha fallado", HLo = "Revisa tu bandeja de entrada", KLo = "Tu cuenta ha sido creada, pero tu premium no ha sido reservado.", YLo = "Hemos enviado un correo electrónico a {{email}} con un enlace para activar tu cuenta.", ZLo = "Una vez que actives tu cuenta, podrás intentar comprar tu nombre de usuario premium nuevamente o seleccionar uno diferente.", QLo = "Abrir en Gmail", JLo = "¿No ves un correo electrónico?", XLo = "Reenviar en {{seconds}} segundos", eqo = "Reenviar", tqo = "Correo de verificación enviado", nqo = "Seleccionar todos los miembros", oqo = "Al seleccionar todos los miembros se añadirán todos los futuros miembros del equipo cuando se agreguen al equipo.", rqo = "Configuración del formulario", iqo = "Eliminar estado de lista blanca", aqo = "Incluir flujos de trabajo de usuario en lista blanca", sqo = "Flujos de trabajo de usuario incluidos en lista blanca", cqo = "Flujos de trabajo de usuario eliminados de lista blanca", lqo = "Fecha y hora", dqo = "Este es un recordatorio sobre su próximo evento.", uqo = "Este recordatorio fue activado por un flujo de trabajo en Cal.", _qo = "Evento", pqo = "Programado por", mqo = "¿Cómo fue tu experiencia reciente?", fqo = "Siempre buscamos mejorar la experiencia de nuestros clientes.", gqo = "¿Qué tan satisfecho estuvo con su última reunión?", hqo = "¿no asististe a la reunión?", vqo = "Reprogramar aquí.", bqo = "Ocultar correo electrónico del organizador", yqo = "Ya formas parte de una organización de plataforma, por lo que no puedes crear una nueva organización. Cada usuario solo puede pertenecer a una organización. Por favor, crea una nueva cuenta de cal.com con un correo electrónico diferente y usa esa cuenta para suscribirte al plan de organizaciones.", $qo = "Ya formas parte de una organización, por lo que no puedes crear una organización de plataforma. Cada usuario solo puede pertenecer a una organización. Por favor, crea una nueva cuenta de cal.com con un correo electrónico diferente y usa esa cuenta para suscribirte al plan de plataforma.", wqo = "Ocultar la dirección de correo electrónico del organizador en la pantalla de reserva, notificaciones por correo electrónico y eventos del calendario", kqo = "Tú &", Sqo = "Seleccionar un correo electrónico verificado", xqo = "Añadir correo electrónico verificado", Eqo = "Añadir correos electrónicos verificados", Tqo = "Correo electrónico personalizado para 'Responder a'", Aqo = "Usar una dirección de correo electrónico diferente como destinatario de respuesta para los correos de confirmación en lugar del correo del organizador", Cqo = "Esta encuesta fue activada por un Workflow en Cal.", zqo = "Omitir período de prueba", Oqo = "Períodos de prueba del equipo omitidos con éxito", Pqo = "Al ingresar tu número de teléfono, consientes recibir mensajes SMS para este evento. Pueden aplicarse tarifas de SMS.", Iqo = "Más información disponible en <0>Estadísticas de enrutamiento</0>", Rqo = "Resultados", Nqo = "Ver formulario", Dqo = "Envía STOP para cancelar los mensajes SMS", Mqo = "Tu equipo {{teamName}} se está quedando sin créditos", Lqo = "Te estás quedando sin créditos", qqo = "[Acción requerida] Tu equipo {{teamName}} se ha quedado sin créditos", jqo = "[Acción requerida] Te has quedado sin créditos", Fqo = "Tu equipo de Cal.com {{teamName}} se está quedando sin créditos. Para evitar cualquier interrupción en el servicio, por favor compra créditos adicionales. Si tu saldo se agota, los mensajes SMS dejarán de enviarse y se enviarán como correos electrónicos en su lugar.", Vqo = "Tu cuenta de Cal.com se está quedando sin créditos. Para evitar cualquier interrupción en el servicio, por favor compra créditos adicionales. Si tu saldo se agota, los mensajes SMS dejarán de enviarse y se enviarán como correos electrónicos en su lugar.", Bqo = "Tu equipo de Cal.com {{teamName}} se ha quedado sin créditos. Como resultado, los mensajes SMS ahora se están enviando por correo electrónico. Para reanudar el envío de SMS, por favor compra créditos adicionales.", Uqo = "Tu cuenta de Cal.com se ha quedado sin créditos. Como resultado, los mensajes SMS ahora se envían por correo electrónico. Para reanudar el envío de SMS, por favor compra créditos adicionales.", Wqo = "Saldo actual: {{balance}} créditos", Gqo = "Saldo actual:", Hqo = "Notificación sobre tu reserva", Kqo = "Créditos mensuales", Yqo = "Créditos totales: {{totalCredits}}", Zqo = "Créditos restantes: {{remainingCredits}}", Qqo = "Restante", Jqo = "Total", Xqo = "Créditos adicionales", e9o = "{{count}} siguiente(s) en cola", t9o = "Enviar respuestas por correo electrónico a", n9o = "Reservas incompletas", o9o = "Incluir reservas no presentadas en los cálculos de round robin", r9o = "Invitados recientes que no asistieron", i9o = "Muestra las reservas donde todos los asistentes no se presentaron, no ausencias parciales", a9o = "Coincidencia", s9o = "Redirección de evento", c9o = "Restablecer formulario", l9o = "Configuración de Round Robin actualizada con éxito", d9o = "Base de distribución para Round Robin ponderado", u9o = "Determina qué marca de tiempo del evento se utiliza como base para la distribución ponderada de round robin.", _9o = "Requiere créditos", p9o = "Necesitas tener suficientes créditos en tu cuenta para usar esta función", m9o = "Créditos disponibles", f9o = "Crear rol", g9o = "Roles y permisos", h9o = "Gestiona roles y permisos para tu organización", v9o = "Aprende más sobre cómo funcionan los permisos", b9o = "Nombre del rol", y9o = "El nombre del rol es obligatorio", $9o = "p. ej. Equipo de ventas, Personal de soporte", w9o = "Descripción del rol", k9o = "Describe para qué sirve este rol y qué permisos necesita", S9o = "Rol predeterminado", x9o = "Rol personalizado", E9o = "Avanzado", T9o = "Buscar permisos", A9o = "Todos los permisos", C9o = "Ninguno", z9o = "Solo lectura", O9o = "Todas las acciones en todos los recursos", P9o = "Todos los recursos", I9o = "Tipos de evento", R9o = "Equipos", N9o = "Organización", D9o = "Reservas", M9o = "Perspectivas", L9o = "Roles", q9o = "Formularios de enrutamiento", j9o = "Flujos de trabajo", F9o = "Todas las acciones", V9o = "Crear", B9o = "Ver", U9o = "Editar", W9o = "Eliminar", G9o = "Gestionar", H9o = "Invitar", K9o = "Eliminar", Y9o = "Cambiar rol de miembro", Z9o = "Listar miembros", Q9o = "Gestionar facturación", J9o = "Ver reservas del equipo", X9o = "Ver reservas de la organización", ejo = "Ver grabaciones", tjo = "Suplantar", njo = "Rol creado con éxito", ojo = "Rol actualizado con éxito", rjo = "Eliminar rol", ijo = "¿Estás seguro de que quieres eliminar el rol: {{roleName}}? Esta acción no se puede deshacer.", ajo = "Rol eliminado con éxito", sjo = "Error al crear el rol", cjo = "Error al actualizar el rol", ljo = "Crear roles", djo = "Atributos", ujo = "Ver atributos de la organización", _jo = "Actualizar atributos de la organización", pjo = "Eliminar atributos de la organización", mjo = "Crear atributos de la organización", fjo = "Ver roles", gjo = "Actualizar roles", hjo = "Eliminar roles", vjo = "Crear y configurar nuevos flujos de trabajo", bjo = "Configuración requerida", yjo = "Ver flujos de trabajo existentes y sus configuraciones", $jo = "Editar y modificar ajustes de flujos de trabajo", wjo = "Eliminar flujos de trabajo del sistema", kjo = "Webhook", Sjo = "Disponibilidad", xjo = "Fuera de la oficina", Ejo = "Crear webhooks", Tjo = "Ver webhooks", Ajo = "Actualizar webhooks", Cjo = "Eliminar webhooks", zjo = "Crear disponibilidad", Ojo = "Ver disponibilidad", Pjo = "Actualizar disponibilidad", Ijo = "Eliminar disponibilidad", Rjo = "Crear fuera de la oficina", Njo = "Ver fuera de la oficina", Djo = "Actualizar fuera de la oficina", Mjo = "Eliminar fuera de la oficina", Ljo = "Acceso completo de gestión a todos los flujos de trabajo", qjo = "Crear tipos de eventos", jjo = "Ver tipos de eventos", Fjo = "Actualizar tipos de eventos", Vjo = "Eliminar tipos de eventos", Bjo = "Todas las acciones en tipos de eventos", Ujo = "Crear equipos", Wjo = "Ver detalles del equipo", Gjo = "Actualizar configuración del equipo", Hjo = "Eliminar equipo", Kjo = "Invitar miembros al equipo", Yjo = "Eliminar miembros del equipo", Zjo = "Cambiar rol de los miembros del equipo", Qjo = "Suplantar miembros del equipo", Jjo = "Todas las acciones en equipos a través de los equipos de la organización", Xjo = "Crear organización", eFo = "Ver detalles de la organización", tFo = "Listar miembros de la organización", nFo = "Invitar miembros a la organización", oFo = "Eliminar miembros de la organización", rFo = "Gestionar facturación de la organización", iFo = "Cambiar rol de los miembros de la organización", aFo = "Suplantar miembros de la organización", sFo = "Editar configuración de la organización", cFo = "Todas las acciones en organizaciones", lFo = "Ver reservas", dFo = "Ver reservas del equipo", uFo = "Ver reservas de la organización", _Fo = "Ver grabaciones de reservas", pFo = "Actualizar reservas", mFo = "Todas las acciones en reservas", fFo = "Ver estadísticas del equipo", gFo = "Gestionar estadísticas del equipo", hFo = "Crear formularios de enrutamiento", vFo = "Ver formularios de enrutamiento", bFo = "Actualizar formularios de enrutamiento", yFo = "Eliminar formularios de enrutamiento", $Fo = "El permiso de lectura se habilita automáticamente al crear, actualizar o eliminar un recurso", wFo = "Añadir horario de restricción", kFo = "Limita la disponibilidad de los anfitriones para mostrar solo los espacios que se encuentran dentro de un horario específico.", SFo = "Usar zona horaria del reservante", xFo = "Aplicar el horario de restricción seleccionado en la zona horaria del reservante", EFo = "Esto desactivará el Balanceo de Carga en todos tus tipos de eventos round robin", TFo = "El Balanceo de Carga solo está disponible cuando la base de tiempo está configurada como Momento de Creación de la Reserva", AFo = "El balanceo de carga no está disponible con Grupos de Round Robin", CFo = "Personalice la configuración predeterminada de round robin para este equipo", zFo = "Configuración de Round Robin actualizada correctamente", OFo = "Hora de creación de la reserva", PFo = "Hora de inicio de la reunión", IFo = "Miembros afectados", RFo = "Ningún miembro afectado por la desactivación de la credencial de delegación", NFo = "Descargar registro de gastos", DFo = "Error al descargar el registro de gastos", MFo = "Ofrecer reprogramar la última reserva activa al horario elegido", LFo = "Se ha excedido el límite máximo de reservas activas del usuario", qFo = "Ya tienes una reserva para este evento el {{date}}. ¿Quieres reprogramarla para el nuevo horario seleccionado?", jFo = "La duración debe ser de al menos {{min}} minuto(s)", FFo = "La duración no puede exceder {{max}} minutos (24 horas)", VFo = "Reserva fuera de la disponibilidad del horario de restricción.", BFo = "Horario de restricción no encontrado", UFo = "Límite de tamaño de imagen excedido, utilice una imagen más pequeña preferiblemente en formato JPEG", WFo = "Añadir grupo", GFo = "Embudo de enrutamiento", HFo = "Total de envíos", KFo = "Enrutamientos exitosos", YFo = "Reservas aceptadas", ZFo = "Clave de licencia", QFo = "Elija su licencia", JFo = "Seleccione cómo desea licenciar su implementación de Cal.com", XFo = "Utilice Cal.com bajo la licencia de código abierto AGPLv3", e8o = "Introducir clave de licencia", t8o = "Acceso a todas las funciones empresariales", n8o = "Desde $15/usuario al mes", o8o = "Acceso a todas las funciones empresariales", r8o = "Introduzca su clave de licencia", i8o = "Guardar clave de licencia", a8o = "Token de firma (opcional)", s8o = "El token de firma se utiliza para verificar que la clave de licencia es tuya al incrementar la facturación basada en el uso. Puedes encontrarlo en tu correo electrónico de confirmación de compra. Si tienes una licencia antigua, puedes dejar esto en blanco.", c8o = "¿Necesitas una licencia?", l8o = "La clave de licencia es obligatoria", d8o = "Clave de licencia no válida", u8o = "No se pudo validar la clave de licencia", _8o = "Archivos adjuntos opcionales", p8o = "Enviar mensaje", m8o = "Describe el problema", f8o = "El tamaño del archivo excede el límite", g8o = "Tipo de archivo no válido", h8o = "Tipo de archivo no válido. Tipos aceptados: {{acceptedTypes}}", v8o = "Número máximo de archivos excedido", b8o = "Archivos subidos correctamente", y8o = "Tipos aceptados: {{acceptedTypes}}; Tamaño máximo de archivo: {{maxSize}}", $8o = "Clave de licencia guardada correctamente", w8o = "Estás viendo el informe basado en la zona horaria de tu perfil ({{userTimezone}}), mientras que tu navegador está configurado en la zona horaria ({{browserTimezone}})", k8o = "Franjas optimizadas", S8o = "Organiza las franjas horarias para optimizar la disponibilidad.", x8o = "Reservas fallidas por campo", E8o = "Reservas fallidas", T8o = "No hay anfitriones asignados al tipo de evento", A8o = "Estado de la caché", C8o = "Última actualización: {{timestamp}}", z8o = "Eliminar datos en caché", O8o = "Caché eliminada correctamente", P8o = "Error al eliminar la caché", I8o = "¿Estás seguro de que quieres eliminar los datos en caché? Esta acción no se puede deshacer.", R8o = "Sí, eliminar caché", N8o = "Quedan {{remainder}} de {{maximum}} usos", D8o = "Queda {{remainder}} de {{maximum}} uso", M8o = "Caduca el {{date}}, al final del día", L8o = "Un solo uso", q8o = "Caducidad basada en tiempo", j8o = "Caducidad basada en uso", F8o = "Número de usos", V8o = "Caduca el", B8o = "Número máximo de usos", U8o = "Configuración del enlace", W8o = "Este enlace caducó el {{date}}, al final del día", G8o = "Límite de uso alcanzado", H8o = "El número máximo de usos debe ser mayor que el uso actual", K8o = "Este enlace ha caducado", Y8o = "Este enlace puede usarse para reservas hasta el final del {{date}}", Z8o = "Este enlace puede configurarse para caducar después de una fecha determinada", Q8o = "Este enlace puede usarse para {{count}} reserva", J8o = "Este enlace puede configurarse para caducar después de un número determinado de reservas", X8o = "Este enlace puede usarse para {{count}} reservas", e7o = "El nombre del evento desencadenante (p. ej., BOOKING_CREATED, BOOKING_CANCELLED)", t7o = "La hora del webhook", n7o = "El slug del tipo de evento", o7o = "Configurar agente", r7o = "El nombre del tipo de evento", i7o = "La hora de inicio del evento", a7o = "La hora de finalización del evento", s7o = "La descripción del evento según se describe en la configuración del tipo de evento", c7o = "Ubicación del evento", l7o = "El UID de la reserva", d7o = "El UID para reprogramar", u7o = "Motivo de cancelación", _7o = "Motivo del rechazo", p7o = "Nombre del organizador", m7o = "Correo electrónico del organizador", f7o = "Zona horaria del organizador (p. ej., 'America/New_York', 'Asia/Kolkata')", g7o = "Configuración regional del organizador (p. ej., 'en', 'fr')", h7o = "Nombre de usuario del organizador (p. ej., 'john.doe')", v7o = "Nombre de usuario del organizador en su organización (p. ej., 'john.doe')", b7o = "Nombre del primer asistente", y7o = "Correo electrónico del primer asistente", $7o = "Zona horaria del primer asistente", w7o = "Configuración regional del primer asistente", k7o = "Nombre del equipo reservado", S7o = "Miembros del equipo reservado", x7o = "URL de videollamada para la reunión", E7o = "Ocultar variables", T7o = "Mostrar variables disponibles", A7o = "Evento y reserva", C7o = "Personas", z7o = "Equipos", O7o = "Metadatos", P7o = "Estadísticas", I7o = "Estado de la reserva", R7o = "Visitar", N7o = "Etiqueta personalizada en la página de reservas", D7o = "Enlace de la reunión", M7o = "Resultado de la sesión", L7o = "Llamada creada", q7o = "Buzón de voz", j7o = "Mis reservas", F7o = "Teléfono", V7o = "Gratis", B7o = "Correo electrónico del usuario", U7o = "Nombre de usuario", W7o = "Expandir panel", G7o = "Contraer panel", H7o = "Se requiere verificación de correo electrónico para este tipo de evento", K7o = "Código de verificación proporcionado no válido", Y7o = "Tienes un equipo", Z7o = "Considera configurar una organización para unificar la facturación, herramientas de administración y análisis en tu equipo.", Q7o = "Considera configurar una organización para unificar la facturación, herramientas de administración y análisis en tus equipos.", J7o = "Mensaje enviado", X7o = "Gracias por contactarnos. Te responderemos lo antes posible.", eVo = "Buscar variables", tVo = "Por favor describe el problema que estás enfrentando, por ejemplo: 'Los horarios ocupados aparecen como disponibles', ..., etc.", nVo = "Enviar otro mensaje", oVo = "Enviando", rVo = "No se encontraron variables", iVo = "Créditos requeridos", aVo = "Las llamadas web consumen créditos. Asegúrate de tener suficientes créditos para iniciar una llamada.", sVo = "Las llamadas web requieren créditos. Te quedan 0 créditos.", cVo = "Comprar créditos", lVo = "Esta acción requiere créditos para continuar", dVo = "El nombre no debe exceder los {{max}} caracteres", uVo = "Cobrar automáticamente la tarifa por no presentarse en caso de cancelaciones de último minuto", _Vo = "Antes de la hora de inicio programada", pVo = "Reconozco que al cancelar la reserva dentro de los {{timeValue}} {{timeUnit}} previos a la hora de inicio, se me cobrará la tarifa por no presentarme de {{amount, currency}}", mVo = "Si tienes alguna pregunta, por favor contacta al organizador.", fVo = "Hora de reserva", gVo = "Cuando se programa la reserva (inicio a fin)", hVo = "Creado el", vVo = "Cuando se creó originalmente la reserva", bVo = "Detalles de la llamada", yVo = "ID de llamada", $Vo = "Información de la llamada", wVo = "Sentimiento", kVo = "Motivo de desconexión", SVo = "Resumen de la llamada", xVo = "Transcripción", EVo = "Detalles del evento", TVo = "Agente", AVo = "No hay transcripción disponible", CVo = "Al probar este flujo de trabajo, ten en cuenta que los SMS deben programarse con al menos 15 minutos de antelación", zVo = "Comenzar desde cero", OVo = "Crea tu propio flujo de trabajo desde cero.", PVo = "Plantilla de Cal.ai", IVo = "¡Agentes de IA que programan reuniones, envían recordatorios y hacen seguimiento!", RVo = "Voz", NVo = "Seleccionar voz", DVo = "Selecciona una voz para tu agente", MVo = "Elige una voz para tu agente", LVo = "Característica", qVo = "ID de voz", jVo = "Usar voz", FVo = "Voz actual", VVo = "Configurar agente entrante", BVo = "Configura un agente de IA para gestionar las llamadas entrantes en tu número de teléfono", UVo = "Conecta primero un número de teléfono", WVo = "Configurar agente para llamadas entrantes", GVo = "Configurar agente para gestionar llamadas entrantes", HVo = "Llamadas entrantes", KVo = "Llamadas salientes", YVo = "Configuración de agente entrante exitosa", ZVo = "Agente entrante configurado", QVo = "Configurar agente entrante", JVo = "Por favor, selecciona primero un tipo de evento", XVo = "Editar configuración", eBo = "Las llamadas entrantes solo pueden reservar un tipo de evento. Selecciona el tipo de evento donde se programarán las reuniones cuando los llamantes contacten con tu agente.", tBo = "Configurar agente entrante para llamadas entrantes", nBo = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Agregue sus nuevas cadenas arriba ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", oBo = {
  identity_provider: ojn,
  trial_days_left: rjn,
  day_one: ijn,
  day_other: ajn,
  second_one: sjn,
  second_other: cjn,
  upgrade_now: ljn,
  untitled: djn,
  accept_invitation: ujn,
  max_characters: _jn,
  min_characters: pjn,
  calcom_explained: mjn,
  calcom_explained_new_user: fjn,
  have_any_questions: gjn,
  reset_password_subject: hjn,
  verify_email_subject: vjn,
  verify_email_subject_verifying_email: bjn,
  check_your_email: yjn,
  old_email_address: $jn,
  new_email_address: wjn,
  verify_email_page_body: kjn,
  verify_email_banner_body: Sjn,
  verify_email_email_header: xjn,
  verify_email_button: Ejn,
  cal_ai_assistant: Tjn,
  send_cal_video_transcription_emails: Ajn,
  description_send_cal_video_transcription_emails: Cjn,
  verify_email_change_description: zjn,
  verify_email_change_success_toast: Ojn,
  verify_email_change_failure_toast: Pjn,
  change_of_email: Ijn,
  change_of_email_toast: Rjn,
  copy_somewhere_safe: Njn,
  verify_email_email_body: Djn,
  verify_email_by_code_email_body: Mjn,
  verify_email_email_link_text: Ljn,
  email_verification_code: qjn,
  email_verification_code_placeholder: jjn,
  incorrect_email_verification_code: Fjn,
  email_sent: Vjn,
  email_not_sent: Bjn,
  event_declined_subject: Ujn,
  event_cancelled_subject: Wjn,
  event_reassigned_subject: Gjn,
  event_request_declined: Hjn,
  customize_calvideo_settings: Kjn,
  calvideo_settings_description: Yjn,
  disable_recording_for_guests: Zjn,
  enable_automatic_transcription: Qjn,
  enable_automatic_recording: Jjn,
  video_options: Xjn,
  edit_event: eFn,
  view_session_details: tFn,
  meeting_session_details: nFn,
  meeting_session: oFn,
  session_id: rFn,
  max_participants: iFn,
  unlimited: aFn,
  ongoing: sFn,
  ended: cFn,
  participants: lFn,
  anonymous_user: dFn,
  session_duration: uFn,
  no_meeting_sessions_found: _Fn,
  not_available: pFn,
  disable_recording_for_organizer: mFn,
  disable_transcription_for_guests: fFn,
  disable_transcription_for_organizer: gFn,
  event_request_declined_recurring: hFn,
  event_request_cancelled: vFn,
  event_request_reassigned: bFn,
  event_reassigned_subtitle: yFn,
  organizer: $Fn,
  reassigned_to: wFn,
  need_to_reschedule_or_cancel: kFn,
  you_can_view_booking_details_with_this_url: SFn,
  no_options_available: xFn,
  cancellation_reason: EFn,
  cancelled_by: TFn,
  cancellation_reason_host: AFn,
  cancellation_reason_placeholder: CFn,
  notify_attendee_cancellation_reason_warning: zFn,
  rejection_reason_placeholder: OFn,
  rejection_reason: PFn,
  rejection_reason_title: IFn,
  rejection_reason_description: RFn,
  rejection_confirmation: NFn,
  manage_this_event: DFn,
  invite_team_member: MFn,
  invite_team_individual_segment: LFn,
  invite_team_bulk_segment: qFn,
  invite_team_notifcation_badge: jFn,
  your_event_has_been_scheduled: FFn,
  your_event_has_been_scheduled_recurring: VFn,
  accept_our_license: BFn,
  remove_banner_instructions: UFn,
  error_message: WFn,
  refund_failed_subject: GFn,
  refund_failed: HFn,
  check_with_provider_and_user: KFn,
  a_refund_failed: YFn,
  awaiting_payment_subject: ZFn,
  meeting_awaiting_payment: QFn,
  dark_theme_contrast_error: JFn,
  light_theme_contrast_error: XFn,
  event_type_color_light_theme_contrast_error: e8n,
  event_type_color_dark_theme_contrast_error: t8n,
  payment_not_created_error: n8n,
  couldnt_charge_card_error: o8n,
  no_available_users_found_error: r8n,
  timeslot_unavailable_book_a_new_time: i8n,
  timeslot_unavailable_short: a8n,
  just_connected_description: s8n,
  unavailable_timeslot_title: c8n,
  booking_time_out_of_bounds_error: l8n,
  request_body_end_time_internal_error: d8n,
  create_calendar_event_error: u8n,
  update_calendar_event_error: _8n,
  delete_calendar_event_error: p8n,
  already_signed_up_for_this_booking_error: m8n,
  hosts_unavailable_for_booking: f8n,
  fixed_hosts_unavailable_for_booking: g8n,
  round_robin_host_unavailable_for_booking: h8n,
  help: v8n,
  price: b8n,
  paid: y8n,
  refunded: $8n,
  record: w8n,
  transcribe: k8n,
  payment: S8n,
  missing_card_fields: x8n,
  pay_now: E8n,
  general_prompt: T8n,
  transcription_powered_by_ai: A8n,
  start_or_stop_recording: C8n,
  begin_message: z8n,
  codebase_has_to_stay_opensource: O8n,
  cannot_repackage_codebase: P8n,
  acquire_license: I8n,
  terms_summary: R8n,
  open_env: N8n,
  env_changed: D8n,
  accept_license: M8n,
  still_waiting_for_approval: L8n,
  event_is_still_waiting: q8n,
  no_result_found_for: j8n,
  no_more_results: F8n,
  no_results: V8n,
  load_more_results: B8n,
  integration_meeting_id: U8n,
  confirmed_event_type_subject: W8n,
  new_event_request: G8n,
  confirm_or_reject_request: H8n,
  check_bookings_page_to_confirm_or_reject: K8n,
  check_in_assistant: Y8n,
  check_in_assistant_description: Z8n,
  create_your_own_prompt: Q8n,
  event_awaiting_approval: J8n,
  event_awaiting_approval_recurring: X8n,
  someone_requested_an_event: e7n,
  someone_requested_password_reset: t7n,
  password_reset_email_sent: n7n,
  password_reset_instructions: o7n,
  event_awaiting_approval_subject: r7n,
  event_still_awaiting_approval: i7n,
  booking_submitted_subject: a7n,
  download_recording_subject: s7n,
  download_transcript_email_subject: c7n,
  download_your_recording: l7n,
  download_your_transcripts: d7n,
  your_meeting_has_been_booked: u7n,
  event_type_has_been_rescheduled_on_time_date: _7n,
  event_type_has_been_updated: p7n,
  event_has_been_rescheduled: m7n,
  event_has_been_updated: f7n,
  your_event_has_been_rescheduled: g7n,
  request_reschedule_subtitle: h7n,
  request_reschedule_title_organizer: v7n,
  request_reschedule_subtitle_organizer: b7n,
  rescheduled_event_type_subject: y7n,
  requested_to_reschedule_subject_attendee: $7n,
  hi_user_name: w7n,
  ics_event_title: k7n,
  please_book_a_time_sometime_later: S7n,
  schedule_instead: x7n,
  new_event_subject: E7n,
  join_by_entrypoint: T7n,
  notes: A7n,
  manage_my_bookings: C7n,
  need_to_make_a_change: z7n,
  new_event_scheduled: O7n,
  new_event_scheduled_recurring: P7n,
  invitee_email: I7n,
  invitee_timezone: R7n,
  time_left: N7n,
  event_type: D7n,
  duplicate_event_type: M7n,
  enter_meeting: L7n,
  video_call_provider: q7n,
  meeting_id: j7n,
  meeting_password: F7n,
  meeting_url: V7n,
  meeting_url_not_found: B7n,
  token_not_found: U7n,
  some_other_host_already_accepted_the_meeting: W7n,
  meeting_request_rejected: G7n,
  rejected_event_type_with_organizer: H7n,
  hi: K7n,
  join_team: Y7n,
  manage_this_team: Z7n,
  team_info: Q7n,
  join_meeting: J7n,
  request_another_invitation_email: X7n,
  you_have_been_invited: eVn,
  user_invited_you: tVn,
  hidden_team_member_title: nVn,
  hidden_team_member_message: oVn,
  hidden_team_owner_message: rVn,
  link_expires: iVn,
  upgrade_to_per_seat: aVn,
  seat_options_doesnt_support_confirmation: sVn,
  multilocation_doesnt_support_seats: cVn,
  no_show_fee_doesnt_support_seats: lVn,
  seats_option_doesnt_support_multi_location: dVn,
  team_upgrade_seats_details: uVn,
  team_upgrade_banner_description: _Vn,
  upgrade_banner_action: pVn,
  team_upgraded_successfully: mVn,
  org_upgrade_banner_description: fVn,
  org_upgraded_successfully: gVn,
  use_link_to_reset_password: hVn,
  hey_there: vVn,
  there: bVn,
  forgot_your_password_calcom: yVn,
  delete_webhook_confirmation_message: $Vn,
  confirm_delete_webhook: wVn,
  edit_webhook: kVn,
  delete_webhook: SVn,
  webhook_status: xVn,
  webhook_enabled: EVn,
  webhook_disabled: TVn,
  webhook_response: AVn,
  webhook_test: CVn,
  webhook_update_form: zVn,
  webhook_update_form_description: OVn,
  manage_your_webhook: PVn,
  webhook_created_successfully: IVn,
  webhook_updated_successfully: RVn,
  webhook_removed_successfully: NVn,
  subscription_needed: DVn,
  subscription_needed_description: MVn,
  payload_template: LVn,
  dismiss: qVn,
  no_data_yet: jVn,
  ping_test: FVn,
  add_to_homescreen: VVn,
  upcoming: BVn,
  recurring: UVn,
  past: WVn,
  choose_a_file: GVn,
  upload_image: HVn,
  upload_target: KVn,
  no_target: YVn,
  slide_zoom_drag_instructions: ZVn,
  view_notifications: QVn,
  view_public_page: JVn,
  copy_public_page_link: XVn,
  copy_referral_link: eBn,
  sign_out: tBn,
  add_another: nBn,
  install_another: oBn,
  until: rBn,
  powered_by: iBn,
  unavailable: aBn,
  set_work_schedule: sBn,
  change_bookings_availability: cBn,
  select: lBn,
  "2fa_confirm_current_password": "Confirma tu contraseña actual para empezar.",
  "2fa_scan_image_or_use_code": "Escanee la imagen a continuación con la aplicación de autenticación en su teléfono o ingrese manualmente el código de texto.",
  text: dBn,
  your_phone_number: uBn,
  multiline_text: _Bn,
  number: pBn,
  checkbox: mBn,
  is_required: fBn,
  make_field_required: gBn,
  required: hBn,
  optional: vBn,
  input_type: bBn,
  rejected: yBn,
  unconfirmed: $Bn,
  guests: wBn,
  guest: kBn,
  web_conferencing_details_to_follow: SBn,
  confirmation: xBn,
  what_booker_should_provide: EBn,
  "404_the_user": "El Nombre de Usuario",
  username: TBn,
  is_still_available: ABn,
  documentation: CBn,
  documentation_description: zBn,
  api_reference: OBn,
  api_reference_description: PBn,
  blog: IBn,
  blog_description: RBn,
  join_our_community: NBn,
  "404_claim_entity_user": "Reclama tu nombre de usuario y programa eventos",
  popular_pages: DBn,
  register_now: MBn,
  register: LBn,
  page_doesnt_exist: qBn,
  no_active_phone_number_available: jBn,
  workflow_step_not_configured: FBn,
  check_spelling_mistakes_or_go_back: VBn,
  "404_page_not_found": "404: Esta página no se ha encontrado.",
  booker_event_not_found: BBn,
  getting_started: UBn,
  "15min_meeting": "Reunión de 15 min",
  "30min_meeting": "Reunión de 30 min",
  secret: WBn,
  leave_blank_to_remove_secret: GBn,
  webhook_secret_key_description: HBn,
  secret_meeting: KBn,
  login_instead: YBn,
  create_account: ZBn,
  get_started: QBn,
  confirm_password: JBn,
  reset_your_password: XBn,
  org_banner_instructions: eUn,
  email_change: tUn,
  create_your_account: nUn,
  create_your_calcom_account: oUn,
  sign_up: rUn,
  youve_been_logged_out: iUn,
  hope_to_see_you_soon: aUn,
  logged_out: sUn,
  please_try_again_and_contact_us: cUn,
  incorrect_2fa_code: lUn,
  no_account_exists: dUn,
  "2fa_enabled_instructions": "Autenticación de doble factor activada. Introduzca el código de seis dígitos de su aplicación de autenticación.",
  "2fa_enter_six_digit_code": "Ingrese el código de seis dígitos de su aplicación de autenticación a continuación.",
  create_an_account: uUn,
  dont_have_an_account: _Un,
  "2fa_code": "Código de Dos Factores",
  sign_in_account: pUn,
  sign_in: mUn,
  go_back_login: fUn,
  error_during_login: gUn,
  request_password_reset: hUn,
  send_invite: vUn,
  forgot_password: bUn,
  forgot: yUn,
  done: $Un,
  all_done: wUn,
  all: kUn,
  yours: SUn,
  available_apps: xUn,
  available_apps_lower_case: EUn,
  available_apps_desc: TUn,
  fixed_host_helper: AUn,
  round_robin_groups_helper: CUn,
  round_robin_helper: zUn,
  check_email_reset_password: OUn,
  finish: PUn,
  organization_general_description: IUn,
  few_sentences_about_yourself: RUn,
  nearly_there: NUn,
  nearly_there_instructions: DUn,
  set_availability_instructions: MUn,
  set_availability: LUn,
  set_availbility_description: qUn,
  share_a_link_or_embed: jUn,
  share_a_link_or_embed_description: FUn,
  availability_settings: VUn,
  continue_without_calendar: BUn,
  continue_with: UUn,
  connect_your_calendar: WUn,
  connect_your_video_app: GUn,
  connect_your_video_app_instructions: HUn,
  connect_your_calendar_instructions: KUn,
  set_up_later: YUn,
  current_time: ZUn,
  details: QUn,
  welcome: JUn,
  welcome_back: XUn,
  welcome_to_calcom: eWn,
  welcome_instructions: tWn,
  connect_caldav: nWn,
  connect_ics_feed: oWn,
  connect: rWn,
  try_for_free: iWn,
  create_booking_link_with_calcom: aWn,
  who: sWn,
  what: cWn,
  when: lWn,
  where: dWn,
  add_to_calendar: uWn,
  add_to_calendar_description: _Wn,
  add_events_to: pWn,
  add_another_calendar: mWn,
  other: fWn,
  email_sign_in_subject: gWn,
  round_robin_emailed_you_and_attendees: hWn,
  round_robin_emailed_host_and_attendee: vWn,
  emailed_host_and_attendee: bWn,
  emailed_host_and_attendee_recurring: yWn,
  round_robin_emailed_you_and_attendees_recurring: $Wn,
  round_robin_emailed_host_and_attendee_recurring: wWn,
  emailed_you_and_any_other_attendees: kWn,
  needs_to_be_confirmed_or_rejected: SWn,
  needs_to_be_confirmed_or_rejected_recurring: xWn,
  user_needs_to_confirm_or_reject_booking: EWn,
  user_needs_to_confirm_or_reject_booking_recurring: TWn,
  meeting_is_scheduled: AWn,
  meeting_is_scheduled_recurring: CWn,
  booking_submitted: zWn,
  booking_submitted_recurring: OWn,
  booking_confirmed: PWn,
  booking_confirmed_recurring: IWn,
  warning_recurring_event_payment: RWn,
  warning_payment_recurring_event: NWn,
  enter_new_password: DWn,
  reset_password: MWn,
  change_your_password: LWn,
  show_password: qWn,
  hide_password: jWn,
  try_again: FWn,
  request_is_expired: VWn,
  reset_instructions: BWn,
  request_is_expired_instructions: UWn,
  whoops: WWn,
  login: GWn,
  success: HWn,
  failed: KWn,
  password_has_been_reset_login: YWn,
  layout: ZWn,
  bookerlayout_default_title: QWn,
  bookerlayout_description: JWn,
  bookerlayout_user_settings_title: XWn,
  bookerlayout_user_settings_description: eGn,
  bookerlayout_month_view: tGn,
  bookerlayout_week_view: nGn,
  bookerlayout_column_view: oGn,
  bookerlayout_error_min_one_enabled: rGn,
  bookerlayout_error_default_not_enabled: iGn,
  bookerlayout_error_unknown_layout: aGn,
  bookerlayout_override_global_settings: sGn,
  unexpected_error_try_again: cGn,
  sunday_time_error: lGn,
  monday_time_error: dGn,
  tuesday_time_error: uGn,
  wednesday_time_error: _Gn,
  thursday_time_error: pGn,
  friday_time_error: mGn,
  saturday_time_error: fGn,
  error_end_time_before_start_time: gGn,
  error_end_time_next_day: hGn,
  back_to_bookings: vGn,
  free_to_pick_another_event_type: bGn,
  cancelled: yGn,
  no_booking: $Gn,
  awaiting_host: wGn,
  cancellation_successful: kGn,
  really_cancel_booking: SGn,
  cannot_cancel_booking: xGn,
  reschedule_instead: EGn,
  event_is_in_the_past: TGn,
  cancelling_event_recurring: AGn,
  cancelling_all_recurring: CGn,
  error_with_status_code_occured: zGn,
  error_event_type_url_duplicate: OGn,
  error_event_type_unauthorized_create: PGn,
  error_event_type_unauthorized_update: IGn,
  error_workflow_unauthorized_create: RGn,
  error_schedule_unauthorized_create: NGn,
  booking_already_cancelled: DGn,
  booking_already_accepted_rejected: MGn,
  go_back_home: LGn,
  or_go_back_home: qGn,
  no_meeting_found: jGn,
  no_meeting_found_description: FGn,
  no_status_bookings_yet: VGn,
  no_status_bookings_yet_description: BGn,
  event_between_users: UGn,
  bookings: WGn,
  booking_not_found: GGn,
  bookings_description: HGn,
  upcoming_bookings: KGn,
  recurring_bookings: YGn,
  past_bookings: ZGn,
  cancelled_bookings: QGn,
  unconfirmed_bookings: JGn,
  unconfirmed_bookings_tooltip: XGn,
  on: eHn,
  and: tHn,
  calendar_shows_busy_between: nHn,
  troubleshoot: oHn,
  troubleshoot_description: rHn,
  overview_of_day: iHn,
  hover_over_bold_times_tip: aHn,
  start_time: sHn,
  end_time: cHn,
  buffer_time: lHn,
  before_event: dHn,
  after_event: uHn,
  event_buffer_default: _Hn,
  buffer: pHn,
  your_day_starts_at: mHn,
  your_day_ends_at: fHn,
  launch_troubleshooter: gHn,
  troubleshoot_availability: hHn,
  change_available_times: vHn,
  change_your_available_times: bHn,
  change_start_end: yHn,
  change_start_end_buffer: $Hn,
  current_start_date: wHn,
  start_end_changed_successfully: kHn,
  and_end_at: SHn,
  light: xHn,
  dark: EHn,
  automatically_adjust_theme: THn,
  user_dynamic_booking_disabled: AHn,
  allow_dynamic_booking_tooltip: CHn,
  allow_dynamic_booking: zHn,
  dynamic_booking: OHn,
  allow_seo_indexing: PHn,
  seo_indexing: IHn,
  allow_browser_notifications: RHn,
  you_have_denied_notifications: NHn,
  disable_browser_notifications: DHn,
  browser_notifications_turned_on: MHn,
  browser_notifications_turned_off: LHn,
  browser_notifications_denied: qHn,
  please_allow_notifications: jHn,
  push_notifications: FHn,
  push_notifications_description: VHn,
  browser_notifications_not_supported: BHn,
  email: UHn,
  email_placeholder: WHn,
  full_name: GHn,
  browse_api_documentation: HHn,
  leverage_our_api: KHn,
  create_webhook: YHn,
  instant_meeting: ZHn,
  booking_cancelled: QHn,
  booking_rescheduled: JHn,
  recording_ready: XHn,
  recording_transcription_generated: eKn,
  booking_created: tKn,
  booking_rejected: nKn,
  booking_requested: oKn,
  booking_payment_initiated: rKn,
  meeting_ended: iKn,
  form_submitted: aKn,
  form_submitted_no_event: sKn,
  booking_paid: cKn,
  ooo_created: lKn,
  booking_no_show_updated: dKn,
  event_triggers: uKn,
  subscriber_url: _Kn,
  create_new_webhook: pKn,
  webhooks: mKn,
  team_webhooks: fKn,
  create_new_webhook_to_account: gKn,
  new_webhook: hKn,
  receive_cal_meeting_data: vKn,
  receive_cal_event_meeting_data: bKn,
  responsive_fullscreen_iframe: yKn,
  loading: $Kn,
  deleting: wKn,
  standard_iframe: kKn,
  developer: SKn,
  manage_developer_settings: xKn,
  iframe_embed: EKn,
  embed_calcom: TKn,
  integrate_using_embed_or_webhooks: AKn,
  schedule_a_meeting: CKn,
  view_and_manage_billing_details: zKn,
  view_and_edit_billing_details: OKn,
  go_to_billing_portal: PKn,
  need_anything_else: IKn,
  further_billing_help: RKn,
  contact: NKn,
  our_support_team: DKn,
  contact_our_support_team: MKn,
  uh_oh: LKn,
  no_event_types_have_been_setup: qKn,
  edit_logo: jKn,
  upload_a_logo: FKn,
  upload_logo: VKn,
  remove_logo: BKn,
  enable: UKn,
  code: WKn,
  code_is_incorrect: GKn,
  add_time_availability: HKn,
  add_an_extra_layer_of_security: KKn,
  "2fa": "Autorización de dos factores",
  "2fa_disabled": "La autenticación de dos factores solo se puede habilitar para la autenticación por correo electrónico y contraseña",
  enable_2fa: YKn,
  disable_2fa: ZKn,
  disable_2fa_recommendation: QKn,
  error_disabling_2fa: JKn,
  error_enabling_2fa: XKn,
  security: eYn,
  manage_account_security: tYn,
  password: nYn,
  password_updated_successfully: oYn,
  password_has_been_changed: rYn,
  error_changing_password: iYn,
  session_timeout_changed: aYn,
  session_timeout_change_error: sYn,
  something_went_wrong: cYn,
  something_doesnt_look_right: lYn,
  please_try_again: dYn,
  super_secure_new_password: uYn,
  new_password: _Yn,
  your_old_password: pYn,
  current_password: mYn,
  change_password: fYn,
  change_secret: gYn,
  new_password_matches_old_password: hYn,
  forgotten_secret_description: vYn,
  current_incorrect_password: bYn,
  password_hint_caplow: yYn,
  password_hint_min: $Yn,
  password_hint_admin_min: wYn,
  password_hint_num: kYn,
  max_limit_allowed_hint: SYn,
  invalid_password_hint: xYn,
  incorrect_password: EYn,
  incorrect_email_password: TYn,
  use_setting: AYn,
  am_pm: CYn,
  time_options: zYn,
  january: OYn,
  february: PYn,
  march: IYn,
  april: RYn,
  may: NYn,
  june: DYn,
  july: MYn,
  august: LYn,
  september: qYn,
  october: jYn,
  november: FYn,
  december: VYn,
  monday: BYn,
  tuesday: UYn,
  wednesday: WYn,
  thursday: GYn,
  friday: HYn,
  saturday: KYn,
  sunday: YYn,
  all_booked_today: ZYn,
  slots_load_fail: QYn,
  additional_guests: JYn,
  your_name: XYn,
  your_full_name: eZn,
  no_name: tZn,
  enter_number_between_range: nZn,
  continue_as_guest_description: oZn,
  email_address: rZn,
  enter_valid_email: iZn,
  please_schedule_future_call: aZn,
  location: sZn,
  address: cZn,
  enter_address: lZn,
  in_person_attendee_address: dZn,
  somewhere_else: uZn,
  custom_attendee_location: _Zn,
  continue_as_guest: pZn,
  join_as_guest: mZn,
  ideal_for_one_time_calls: fZn,
  any_location: gZn,
  yes: hZn,
  no: vZn,
  additional_notes: bZn,
  booking_fail: yZn,
  reschedule_fail: $Zn,
  share_additional_notes: wZn,
  booking_confirmation: kZn,
  booking_reschedule_confirmation: SZn,
  in_person_meeting: xZn,
  in_person: EZn,
  link_meeting: TZn,
  phone_number: AZn,
  attendee_phone_number: CZn,
  organizer_phone_number: zZn,
  enter_phone_number: OZn,
  reschedule: PZn,
  reschedule_this: IZn,
  book_a_team_member: RZn,
  or: NZn,
  go_back: DZn,
  email_or_username: MZn,
  send_invite_email: LZn,
  role: qZn,
  edit_role: jZn,
  view_role: FZn,
  edit_team: VZn,
  editing_user: BZn,
  editing_org: UZn,
  edit_or_manage_webhooks: WZn,
  reject: GZn,
  reject_all: HZn,
  accept: KZn,
  leave: YZn,
  profile: ZZn,
  my_team_url: QZn,
  my_teams: JZn,
  team_name: XZn,
  your_team_name: eQn,
  team_updated_successfully: tQn,
  your_team_updated_successfully: nQn,
  your_org_updated_successfully: oQn,
  error_copying_to_clipboard: rQn,
  about: iQn,
  team_description: aQn,
  organization_id: sQn,
  organization_id_copied: cQn,
  org_description: lQn,
  team_id: dQn,
  team_id_copied: uQn,
  members: _Qn,
  organization_members: pQn,
  member: mQn,
  number_member_one: fQn,
  number_member_other: gQn,
  number_selected: hQn,
  owner: vQn,
  admin: bQn,
  admin_api: yQn,
  administrator_user: $Qn,
  lets_create_first_administrator_user: wQn,
  admin_user_created: kQn,
  admin_user_created_description: SQn,
  new_member: xQn,
  invite: EQn,
  add_team_members: TQn,
  add_org_members: AQn,
  add_team_members_description: CQn,
  add_team_member: zQn,
  invite_new_member: OQn,
  invite_new_member_description: PQn,
  invite_new_team_member: IQn,
  upload_csv_file: RQn,
  invite_via_email: NQn,
  change_member_role: DQn,
  disable_cal_branding: MQn,
  disable_cal_branding_description: LQn,
  hide_book_a_team_member: qQn,
  hide_book_a_team_member_description: jQn,
  danger_zone: FQn,
  account_deletion_cannot_be_undone: VQn,
  team_deletion_cannot_be_undone: BQn,
  back: UQn,
  cancel: WQn,
  cancel_all_remaining: GQn,
  apply: HQn,
  cancel_event: KQn,
  continue: "Continuar",
  confirm: YQn,
  confirm_all: ZQn,
  disband_team: QQn,
  disband_team_confirmation_message: JQn,
  disband_org: XQn,
  disband_org_confirmation_message: eJn,
  remove_member_confirmation_message: tJn,
  confirm_disband_team: nJn,
  confirm_remove_member: oJn,
  confirm_subscription_cancellation: rJn,
  cancel_subscription: iJn,
  cancel_subscription_description: aJn,
  remove_member: sJn,
  manage_your_team: cJn,
  no_teams: lJn,
  no_teams_description: dJn,
  submit: uJn,
  confirm_remove_attribute: _Jn,
  remove_attribute: pJn,
  remove_attribute_confirmation_message: mJn,
  delete: "Eliminar",
  update: fJn,
  save: gJn,
  pending: hJn,
  open_options: vJn,
  copy_link: bJn,
  share: yJn,
  share_event: $Jn,
  copy_link_team: wJn,
  leave_team: kJn,
  confirm_leave_team: SJn,
  leave_team_confirmation_message: xJn,
  user_from_team: EJn,
  preview: TJn,
  link_copied: AJn,
  copied: CJn,
  private_link_copied: zJn,
  link_shared: OJn,
  title: PJn,
  description: IJn,
  apps_status: RJn,
  quick_video_meeting: NJn,
  scheduling_type: DJn,
  preview_team: MJn,
  collective: LJn,
  collective_description: qJn,
  duration: jJn,
  available_durations: FJn,
  default_duration: VJn,
  default_duration_no_options: BJn,
  multiple_duration_mins: UJn,
  multiple_duration_timeUnit: WJn,
  multiple_duration_timeUnit_short: GJn,
  minutes: HJn,
  use_cal_ai_to_make_call_description: KJn,
  termination_uri: YJn,
  sip_trunk_username: ZJn,
  sip_trunk_password: QJn,
  nickname: JJn,
  delete_phone_number: XJn,
  workflow_validation_failed: eXn,
  workflow_validation_empty_fields: tXn,
  workflow_validation_unverified_contacts: nXn,
  supercharge_your_workflows_with_cal_ai: oXn,
  supercharge_your_workflows_with_cal_ai_description: rXn,
  phone_number_imported_successfully: iXn,
  phone_number_deleted_successfully: aXn,
  delete_phone_number_confirmation: sXn,
  yes_delete_phone_number: cXn,
  phone_number_info_tooltip: lXn,
  termination_uri_info_tooltip: dXn,
  sip_trunk_username_info_tooltip: uXn,
  sip_trunk_password_info_tooltip: _Xn,
  nickname_info_tooltip: pXn,
  save_and_test_call: mXn,
  call_initiated_successfully: fXn,
  please_enter_phone_number: gXn,
  agent_updated_successfully: hXn,
  agent_created_successfully: vXn,
  agent_event_type_updated_successfully: bXn,
  phone_number_unsubscribed_successfully: yXn,
  general_prompt_description: $Xn,
  prompt: wXn,
  call_to: kXn,
  make_test_call_to_verify_configuration: SXn,
  initial_message: xXn,
  initial_message_description: EXn,
  having_trouble_importing: TXn,
  learn: AXn,
  learn_how_to_get_your_terminator: CXn,
  phone_number_subscription_cancelled_successfully: zXn,
  updating: OXn,
  round_robin: PXn,
  hi_how_are_you_doing: IXn,
  round_robin_description: RXn,
  managed_event: NXn,
  username_placeholder: DXn,
  managed_event_description: MXn,
  managed: LXn,
  managed_event_url_clarification: qXn,
  assign_to: jXn,
  enter_phone_number_to_test_call: FXn,
  make_test_call: VXn,
  create_new_workflow_agent: BXn,
  create_new_workflow_agent_description: UXn,
  phone_number_for_ai_call: WXn,
  buy_a_phone_number_or_import_one_you_already_have: GXn,
  test_agent: HXn,
  test_web_call: KXn,
  phone_numbers: YXn,
  unsubscribe: ZXn,
  delete_workflow_step: QXn,
  unsubscribe_phone_number: JXn,
  buy_a_new_number: XXn,
  only_us_phone_numbers_can_be_purchased_here: eeo,
  buy_number_for_x_per_month: teo,
  supported_call_destinations: neo,
  no_phone_number_connected: oeo,
  failed_to_get_workflow_step_id: reo,
  cal_ai_agent: ieo,
  test_cal_ai_agent: aeo,
  are_you_sure_you_want_to_delete_workflow_step: seo,
  do_you_still_want_to_unsubscribe: ceo,
  the_action_will_disconnect_phone_number: leo,
  cal_ai_phone_numbers: deo,
  connect_phone_number: ueo,
  cal_ai_phone_numbers_description: _eo,
  import_number: peo,
  this_action_will_also: meo,
  import_phone_number: feo,
  active_subscription: geo,
  cancel_your_phone_number_subscription: heo,
  delete_associated_phone_number: veo,
  unauthorized_create_workflow: beo,
  import_phone_number_description: yeo,
  phone_number_cost: $eo,
  buy_new_number: weo,
  buy_number_cost_x_per_month: keo,
  area_code_optional: Seo,
  no_phone_numbers: xeo,
  phone_number_purchased_successfully: Eeo,
  cancel_phone_number_subscription: Teo,
  yes_cancel_subscription: Aeo,
  cancel_phone_number_subscription_confirmation: Ceo,
  add_members: zeo,
  add_members_no_ellipsis: Oeo,
  no_assigned_members: Peo,
  assigned_to: Ieo,
  you_must_be_logged_in_to: Reo,
  start_assigning_members_above: Neo,
  locked_fields_admin_description: Deo,
  unlocked_fields_admin_description: Meo,
  locked_fields_member_description: Leo,
  unlocked_fields_member_description: qeo,
  url: jeo,
  hidden: Feo,
  readonly: Veo,
  one_time_link: Beo,
  plan_description: Ueo,
  plan_upgrade_invitation: Weo,
  plan_upgrade: Geo,
  plan_upgrade_teams: Heo,
  plan_upgrade_instructions: Keo,
  event_types_page_title: Yeo,
  event_types_page_subtitle: Zeo,
  new: "Nuevo",
  new_event_type_btn: Qeo,
  new_event_type_heading: Jeo,
  new_event_type_description: Xeo,
  event_type_created_successfully: eto,
  event_type_updated_successfully: tto,
  event_type_deleted_successfully: nto,
  hours: oto,
  people: rto,
  your_email: ito,
  change_avatar: ato,
  upload_avatar: sto,
  language: cto,
  timezone: lto,
  first_day_of_week: dto,
  repeats_up_to_one: uto,
  repeats_up_to_other: _to,
  every_for_freq: pto,
  event_remaining_one: mto,
  event_remaining_other: fto,
  repeats_every: gto,
  occurrence_one: hto,
  occurrence_other: vto,
  weekly_one: bto,
  weekly_other: yto,
  monthly_one: $to,
  monthly_other: wto,
  yearly_one: kto,
  yearly_other: Sto,
  plus_more: xto,
  max: Eto,
  single_theme: Tto,
  brand_color: Ato,
  light_brand_color: Cto,
  dark_brand_color: zto,
  light_event_type_color: Oto,
  dark_event_type_color: Pto,
  file_not_named: Ito,
  create_team: Rto,
  name: Nto,
  nameless_team: Dto,
  oauth_clients: Mto,
  oauth_clients_description: Lto,
  create_oauth_client: qto,
  create_oauth_client_description: jto,
  oauth_client_deletion_message: Fto,
  create_new_team_description: Vto,
  create_new_team: Bto,
  booking_redirect_uri: Uto,
  booking_cancel_redirect_uri: Wto,
  booking_reschedule_redirect_uri: Gto,
  booking_conflict_error: Hto,
  open_invitations: Kto,
  new_team: Yto,
  create_first_team_and_invite_others: Zto,
  create_team_to_get_started: Qto,
  teams: Jto,
  team: Xto,
  organization: eno,
  team_billing: tno,
  team_billing_description: nno,
  upgrade_to_flexible_pro_title: ono,
  upgrade_to_flexible_pro_message: rno,
  changed_team_billing_info: ino,
  create_manage_teams_collaborative: ano,
  only_available_on_pro_plan: sno,
  remove_cal_branding_description: cno,
  edit_profile_info_description: lno,
  change_email_tip: dno,
  little_something_about: uno,
  profile_updated_successfully: _no,
  your_user_profile_updated_successfully: pno,
  your_upgrade_is_here: mno,
  your_upgrade_is_here_description: fno,
  you_are_all_set: gno,
  you_are_all_set_description: hno,
  user_cannot_found_db: vno,
  embed_and_webhooks: bno,
  enabled: yno,
  disabled: $no,
  disable: wno,
  billing: kno,
  here: Sno,
  manage_your_billing_info: xno,
  availability: Eno,
  edit_availability: Tno,
  configure_availability: Ano,
  copy_times_to: Cno,
  copy_times_to_tooltip: zno,
  change_weekly_schedule: Ono,
  logo: Pno,
  error: Ino,
  at_least_characters_one: Rno,
  at_least_characters_other: Nno,
  team_logo: Dno,
  add_location: Mno,
  attendees: Lno,
  add_attendees: qno,
  show_advanced_settings: jno,
  hide_advanced_settings: Fno,
  event_name: Vno,
  event_name_in_calendar: Bno,
  event_name_tooltip: Uno,
  meeting_with_user: Wno,
  additional_inputs: Gno,
  additional_input_description: Hno,
  label: Kno,
  placeholder: Yno,
  display_add_to_calendar_organizer: Zno,
  display_email_as_organizer: Qno,
  if_enabled_email_address_as_organizer: Jno,
  reconnect_calendar_to_use: Xno,
  type: eoo,
  edit: too,
  add_input: noo,
  disable_notes: ooo,
  disable_notes_description: roo,
  requires_confirmation_description: ioo,
  requires_confirmation_will_block_slot_description: aoo,
  recurring_event: soo,
  recurring_event_description: coo,
  connect_and_join: loo,
  cannot_be_used_with_paid_event_types: doo,
  warning_payment_instant_meeting_event: uoo,
  warning_instant_meeting_experimental: _oo,
  starting: poo,
  disable_guests: moo,
  disable_guests_description: foo,
  private_link: goo,
  enable_private_url: hoo,
  private_link_label: voo,
  private_link_hint: boo,
  copy_private_link: yoo,
  copy_private_link_to_event: $oo,
  private_link_description: woo,
  multiple_private_links_title: koo,
  multiple_private_links_description: Soo,
  add_a_multiple_private_link: xoo,
  multiple_private_link_copied: Eoo,
  invitees_can_schedule: Too,
  date_range: Aoo,
  calendar_days: Coo,
  business_days: zoo,
  set_address_place: Ooo,
  set_link_meeting: Poo,
  managed_event_field_parent_control_disabled: Ioo,
  cal_invitee_phone_number_scheduling: Roo,
  cal_provide_google_meet_location: Noo,
  cal_provide_zoom_meeting_url: Doo,
  cal_provide_tandem_meeting_url: Moo,
  cal_provide_video_meeting_url: Loo,
  cal_provide_jitsi_meeting_url: qoo,
  cal_provide_huddle01_meeting_url: joo,
  cal_provide_teams_meeting_url: Foo,
  require_payment: Voo,
  you_need_to_add_a_name: Boo,
  commission_per_transaction: Uoo,
  event_type_updated_successfully_description: Woo,
  hide_event_type: Goo,
  edit_location: Hoo,
  into_the_future: Koo,
  when_booked_with_less_than_notice: Yoo,
  within_date_range: Zoo,
  indefinitely_into_future: Qoo,
  add_new_custom_input_field: Joo,
  quick_chat: Xoo,
  add_new_team_event_type: ero,
  add_new_event_type: tro,
  new_event_type_to_book_description: nro,
  length: oro,
  minimum_booking_notice: rro,
  offset_toggle: iro,
  offset_toggle_description: aro,
  offset_start: sro,
  offset_start_description: cro,
  slot_interval: lro,
  slot_interval_default: dro,
  delete_event_type: uro,
  delete_managed_event_type: _ro,
  delete_event_type_description: pro,
  delete_managed_event_type_description_1: mro,
  delete_managed_event_type_description_2: fro,
  confirm_delete_event_type: gro,
  delete_account: hro,
  confirm_delete_account: vro,
  delete_account_confirmation_message: bro,
  integrations: yro,
  apps: $ro,
  apps_description: wro,
  apps_listing: kro,
  category_apps: Sro,
  app_store: xro,
  app_store_description: Ero,
  connect_your_video: Tro,
  settings: Aro,
  event_type_moved_successfully: Cro,
  next_step_text: zro,
  next_step: Oro,
  prev_step: Pro,
  install: Iro,
  start_paid_trial: Rro,
  installed: Nro,
  active_install_one: Dro,
  active_install_other: Mro,
  globally_install: Lro,
  app_successfully_installed: qro,
  app_could_not_be_installed: jro,
  disconnect: Fro,
  embed_your_calendar: Vro,
  connect_your_favourite_apps: Bro,
  automation: Uro,
  configure_how_your_event_types_interact: Wro,
  toggle_calendars_conflict: Gro,
  connect_additional_calendar: Hro,
  calendar_updated_successfully: Kro,
  check_here: Yro,
  conferencing: Zro,
  calendar: Qro,
  payments: Jro,
  not_installed: Xro,
  error_password_mismatch: eio,
  error_required_field: tio,
  status: nio,
  team_view_user_availability: oio,
  team_view_user_availability_disabled: rio,
  set_as_away: iio,
  set_as_free: aio,
  toggle_away_error: sio,
  user_away: cio,
  user_away_description: lio,
  meet_people_with_the_same_tokens: dio,
  only_book_people_and_allow: uio,
  account_created_with_identity_provider: _io,
  account_managed_by_identity_provider: pio,
  account_managed_by_identity_provider_description: mio,
  account_managed_by_identity_provider_error: fio,
  user_creation_error: gio,
  signin_with_google: hio,
  signin_with_saml: vio,
  signin_with_saml_oidc: bio,
  continue_with_email: yio,
  continue_with_google: $io,
  last_used: wio,
  you_will_need_to_generate: kio,
  import: "Importar",
  import_from: Sio,
  access_token: xio,
  visit_roadmap: Eio,
  featured_categories: Tio,
  feature_flags: Aio,
  admin_flags_description: Cio,
  popular_categories: zio,
  number_apps_one: Oio,
  number_apps_other: Pio,
  trending_apps: Iio,
  most_popular: Rio,
  installed_apps: Nio,
  free_to_use_apps: Dio,
  no_category_apps: Mio,
  all_apps: Lio,
  no_category_apps_description_calendar: qio,
  no_category_apps_description_conferencing: jio,
  no_category_apps_description_payment: Fio,
  no_category_apps_description_analytics: Vio,
  no_category_apps_description_automation: Bio,
  no_category_apps_description_other: Uio,
  no_category_apps_description_messaging: Wio,
  no_category_apps_description_crm: Gio,
  installed_app_calendar_description: Hio,
  installed_app_payment_description: Kio,
  installed_app_analytics_description: Yio,
  installed_app_other_description: Zio,
  installed_app_conferencing_description: Qio,
  installed_app_automation_description: Jio,
  installed_app_messaging_description: Xio,
  installed_app_crm_description: eao,
  analytics: tao,
  empty_installed_apps_headline: nao,
  empty_installed_apps_description: oao,
  empty_installed_apps_button: rao,
  manage_your_connected_apps: iao,
  browse_apps: aao,
  features: sao,
  permissions: cao,
  terms_and_privacy: lao,
  published_by: dao,
  subscribe: uao,
  buy: _ao,
  install_app: pao,
  categories: mao,
  pricing: fao,
  learn_more: gao,
  try_now: hao,
  privacy_policy: vao,
  terms_of_service: bao,
  remove: yao,
  add: $ao,
  installed_other: wao,
  verify_wallet: kao,
  create_events_on: Sao,
  enterprise_license: xao,
  enterprise_license_locally: Eao,
  enterprise_license_sales: Tao,
  missing_license: Aao,
  next_steps: Cao,
  acquire_commercial_license: zao,
  the_infrastructure_plan: Oao,
  prisma_studio_tip: Pao,
  prisma_studio_tip_description: Iao,
  contact_sales: Rao,
  error_404: Nao,
  default: "Predeterminado",
  set_to_default: Dao,
  new_schedule_btn: Mao,
  add_new_schedule: Lao,
  add_new_calendar: qao,
  set_calendar: jao,
  delete_schedule: Fao,
  delete_schedule_description: Vao,
  schedule_created_successfully: Bao,
  availability_updated_successfully: Uao,
  schedule_deleted_successfully: Wao,
  default_schedule_name: Gao,
  new_schedule_heading: Hao,
  new_schedule_description: Kao,
  requires_ownership_of_a_token: Yao,
  example_name: Zao,
  time_format: Qao,
  "12_hour": "12 horas",
  "24_hour": "24 horas",
  "12_hour_short": "12 h",
  "24_hour_short": "24hs",
  redirect_success_booking: Jao,
  you_are_being_redirected: Xao,
  external_redirect_url: eso,
  redirect_url_description: tso,
  duplicate: nso,
  offer_seats: oso,
  offer_seats_description: rso,
  seats_available_one: iso,
  seats_available_other: aso,
  seats_nearly_full: sso,
  seats_half_full: cso,
  number_of_seats: lso,
  set_instant_meeting_expiry_time_offset_description: dso,
  enter_number_of_seats: uso,
  you_can_manage_your_schedules: _so,
  booking_full: pso,
  api_keys: mso,
  api_key: fso,
  test_api_key: gso,
  test_passed: hso,
  test_failed: vso,
  provide_api_key: bso,
  api_key_modal_subtitle: yso,
  api_key_modal_subtitle_platform: $so,
  api_keys_subtitle: wso,
  create_api_key: kso,
  personal_note: Sso,
  personal_note_placeholder: xso,
  api_key_no_note: Eso,
  api_key_never_expires: Tso,
  edit_api_key: Aso,
  success_api_key_created: Cso,
  success_api_key_edited: zso,
  create: Oso,
  success_api_key_created_bold_tagline: Pso,
  you_will_only_view_it_once: Iso,
  copy_to_clipboard: Rso,
  enabled_after_update: Nso,
  enabled_after_update_description: Dso,
  confirm_delete_api_key: Mso,
  disable_rescheduling: Lso,
  description_disable_rescheduling: qso,
  allow_rescheduling_cancelled_bookings: jso,
  description_allow_rescheduling_cancelled_bookings: Fso,
  disable_cancelling: Vso,
  description_disable_cancelling: Bso,
  revoke_api_key: Uso,
  api_key_copied: Wso,
  api_key_expires_on: Gso,
  delete_api_key_confirm_title: Hso,
  copy: Kso,
  expire_date: Yso,
  expired: Zso,
  never_expires: Qso,
  expires: Jso,
  request_reschedule_booking: Xso,
  reason_for_reschedule: eco,
  book_a_new_time: tco,
  reschedule_request_sent: nco,
  reschedule_modal_description: oco,
  reason_for_reschedule_request: rco,
  send_reschedule_request: ico,
  edit_booking: aco,
  reschedule_booking: sco,
  former_time: cco,
  confirmation_page_gif: lco,
  search: dco,
  impersonate: uco,
  user_impersonation_heading: _co,
  user_impersonation_description: pco,
  team_impersonation_description: mco,
  cal_signup_description: fco,
  make_org_private: gco,
  make_org_private_description: hco,
  make_team_private: vco,
  make_team_private_description: bco,
  you_cannot_see_team_members: yco,
  you_cannot_see_teams_of_org: $co,
  allow_multiple_durations: wco,
  impersonate_user_tip: kco,
  impersonating_user_warning: Sco,
  impersonating_stop_instructions: xco,
  event_location_changed: Eco,
  new_guests_added: Tco,
  location_changed_event_type_subject: Aco,
  guests_added_event_type_subject: Cco,
  current_location: zco,
  new_location: Oco,
  session: Pco,
  session_description: Ico,
  session_timeout_after: Rco,
  session_timeout: Nco,
  session_timeout_description: Dco,
  no_location: Mco,
  set_location: Lco,
  update_location: qco,
  location_updated: jco,
  location_update_failed: Fco,
  guests_added: Vco,
  unable_to_add_guests: Bco,
  email_validation_error: Uco,
  emails_must_be_unique_valid: Wco,
  url_validation_error: Gco,
  place_where_cal_widget_appear: Hco,
  create_update_react_component: Kco,
  copy_code: Yco,
  code_copied: Zco,
  how_you_want_add_cal_site: Qco,
  choose_ways_put_cal_site: Jco,
  setting_up_zapier: Xco,
  setting_up_make: elo,
  generate_api_key: tlo,
  generate_api_key_description: nlo,
  your_unique_api_key: olo,
  copy_safe_api_key: rlo,
  zapier_setup_instructions: ilo,
  make_setup_instructions_1: alo,
  make_setup_instructions_2: slo,
  make_setup_instructions_3: clo,
  make_setup_instructions_4: llo,
  make_setup_instructions_5: dlo,
  make_setup_instructions_6: ulo,
  install_zapier_app: _lo,
  install_make_app: plo,
  app_installation: mlo,
  app_not_installed: flo,
  visit_our_app_store: glo,
  connect_apple_server: hlo,
  calendar_url: vlo,
  apple_server_generate_password: blo,
  unable_to_add_apple_calendar: ylo,
  credentials_stored_encrypted: $lo,
  it_stored_encrypted: wlo,
  go_to_app_store: klo,
  calendar_error: Slo,
  set_your_phone_number: xlo,
  calendar_no_busy_slots: Elo,
  display_location_label: Tlo,
  display_location_info_badge: Alo,
  add_gif: Clo,
  search_giphy: zlo,
  add_link_from_giphy: Olo,
  add_gif_to_confirmation: Plo,
  find_gif_spice_confirmation: Ilo,
  share_feedback: Rlo,
  resources: Nlo,
  support_documentation: Dlo,
  developer_documentation: Mlo,
  get_in_touch: Llo,
  contact_support: qlo,
  premium_support: jlo,
  community_support: Flo,
  feedback: Vlo,
  submitted_feedback: Blo,
  feedback_error: Ulo,
  comments: Wlo,
  booking_details: Glo,
  or_lowercase: Hlo,
  nevermind: Klo,
  go_to: Ylo,
  zapier_invite_link: Zlo,
  meeting_url_provided_after_confirmed: Qlo,
  dynamically_display_attendee_or_organizer: Jlo,
  event_location: Xlo,
  reschedule_optional: edo,
  reschedule_placeholder: tdo,
  event_cancelled: ndo,
  emailed_information_about_cancelled_event: odo,
  this_input_will_shown_booking_this_event: rdo,
  meeting_url_in_confirmation_email: ido,
  url_start_with_https: ado,
  number_provided: sdo,
  before_event_trigger: cdo,
  event_cancelled_trigger: ldo,
  after_hosts_cal_video_no_show: ddo,
  after_guests_cal_video_no_show: udo,
  join_video_call: _do,
  sign_in_to_cal_com: pdo,
  log_in_to_cal_com: mdo,
  track_your_meetings: fdo,
  track_meetings_and_manage_schedule: gdo,
  failed_to_join_call: hdo,
  choose_how_you_d_like_to_join_call: vdo,
  choose_how_you_d_like_to_appear_on_the_call: bdo,
  new_event_trigger: ydo,
  email_host_action: $do,
  email_attendee_action: wdo,
  sms_attendee_action: kdo,
  sms_number_action: Sdo,
  send_reminder_sms: xdo,
  whatsapp_number_action: Edo,
  whatsapp_attendee_action: Tdo,
  workflows: Ado,
  new_workflow_btn: Cdo,
  how_would_you_like_to_start: zdo,
  add_new_workflow: Odo,
  reschedule_event_trigger: Pdo,
  trigger: Ido,
  triggers: Rdo,
  action: Ndo,
  workflows_to_automate_notifications: Ddo,
  workflow_name: Mdo,
  custom_workflow: Ldo,
  workflow_created_successfully: qdo,
  delete_workflow_description: jdo,
  delete_workflow: Fdo,
  confirm_delete_workflow: Vdo,
  workflow_deleted_successfully: Bdo,
  how_long_before: Udo,
  day_timeUnit: Wdo,
  hour_timeUnit: Gdo,
  minute_timeUnit: Hdo,
  minute_short: Kdo,
  hour_short: Ydo,
  new_workflow_heading: Zdo,
  new_workflow_description: Qdo,
  active_on: Jdo,
  workflow_updated_successfully: Xdo,
  premium_to_standard_username_description: euo,
  premium_username: tuo,
  current: nuo,
  premium: ouo,
  standard: ruo,
  confirm_username_change_dialog_title: iuo,
  change_username_standard_to_premium: auo,
  change_username_premium_to_standard: suo,
  go_to_stripe_billing: cuo,
  stripe_description: luo,
  trial_expired: duo,
  remove_app: uuo,
  yes_remove_app: _uo,
  are_you_sure_you_want_to_remove_this_app: puo,
  app_removed_successfully: muo,
  error_removing_app: fuo,
  web_conference: guo,
  web_call: huo,
  start_web_call: vuo,
  end_call: buo,
  test_your_agent_with_web_call: yuo,
  phone_call: $uo,
  connecting_to_agent: wuo,
  call_active: kuo,
  call_ended: Suo,
  call_error: xuo,
  ready_to_start_call: Euo,
  failed_to_start_web_call_try_again: Tuo,
  call_encountered_error_try_again: Auo,
  failed_initialize_web_call_microphone_permissions: Cuo,
  start_call_to_see_conversation: zuo,
  waiting_for_conversation: Ouo,
  ai_agent: Puo,
  live: Iuo,
  connecting: Ruo,
  requires_confirmation: Nuo,
  requires_confirmation_threshold: Duo,
  may_require_confirmation: Muo,
  nr_event_type_one: Luo,
  nr_event_type_other: quo,
  count_team_one: juo,
  count_team_other: Fuo,
  add_action: Vuo,
  set_whereby_link: Buo,
  invalid_whereby_link: Uuo,
  set_around_link: Wuo,
  invalid_around_link: Guo,
  set_riverside_link: Huo,
  invalid_riverside_link: Kuo,
  invalid_ping_link: Yuo,
  add_exchange2013: Zuo,
  add_exchange2016: Quo,
  custom_template: Juo,
  email_body: Xuo,
  text_message: e_o,
  specific_issue: t_o,
  browse_our_docs: n_o,
  choose_template: o_o,
  custom: r_o,
  reminder: i_o,
  rescheduled: a_o,
  rescheduled_by: s_o,
  original_booking: c_o,
  completed: l_o,
  rating: d_o,
  reminder_email: u_o,
  not_triggering_existing_bookings: __o,
  minute_one: p_o,
  minute_one_short: m_o,
  minute_other: f_o,
  hour_one: g_o,
  hour_one_short: h_o,
  hour_other: v_o,
  invalid_input: b_o,
  broken_video_action: y_o,
  broken_calendar_action: $_o,
  attendee_name: w_o,
  scheduler_full_name: k_o,
  broken_integration: S_o,
  problem_adding_video_link: x_o,
  problem_updating_calendar: E_o,
  active_on_event_types_one: T_o,
  active_on_event_types_other: A_o,
  active_on_teams_one: C_o,
  active_on_teams_other: z_o,
  active_on_all_event_types: O_o,
  active_on_all_teams: P_o,
  no_active_event_types: I_o,
  no_active_teams: R_o,
  new_seat_subject: N_o,
  new_seat_title: D_o,
  variable: M_o,
  event_name_variable: L_o,
  attendee_name_variable: q_o,
  event_date_variable: j_o,
  event_time_variable: F_o,
  organizer_name_variable: V_o,
  app_upgrade_description: B_o,
  invalid_number: U_o,
  invalid_url_error_message: W_o,
  navigate: G_o,
  open: H_o,
  close: K_o,
  upgrade: Y_o,
  buy_us_number_button: Z_o,
  upgrade_to_access_recordings_title: Q_o,
  upgrade_to_access_recordings_description: J_o,
  upgrade_to_cal_ai_phone_number_description: X_o,
  recordings_are_part_of_the_teams_plan: epo,
  team_feature_teams: tpo,
  team_feature_workflows: npo,
  show_eventtype_on_profile: opo,
  embed: rpo,
  new_username: ipo,
  current_username: apo,
  example_1: spo,
  example_2: cpo,
  booking_question_identifier: lpo,
  company_size: dpo,
  what_help_needed: upo,
  variable_format: _po,
  webhook_subscriber_url_reserved: ppo,
  custom_input_as_variable_info: mpo,
  using_booking_questions_as_variables: fpo,
  download_desktop_app: gpo,
  set_ping_link: hpo,
  rate_limit_exceeded: vpo,
  when_something_happens: bpo,
  action_is_performed: ypo,
  test_action: $po,
  notification_sent: wpo,
  no_input: kpo,
  test_workflow_action: Spo,
  send_sms: xpo,
  send_sms_to_number: Epo,
  missing_connected_calendar: Tpo,
  connect_your_calendar_and_link: Apo,
  default_calendar_selected: Cpo,
  hide_from_profile: zpo,
  basics: Opo,
  availability_not_found_in_schedule_error: Ppo,
  event_limit_tab_title: Ipo,
  event_limit_tab_description: Rpo,
  event_advanced_tab_description: Npo,
  event_advanced_tab_title: Dpo,
  event_payments_tab_description: Mpo,
  event_setup_multiple_duration_error: Lpo,
  event_setup_multiple_duration_default_error: qpo,
  event_setup_booking_limits_error: jpo,
  event_setup_duration_limits_error: Fpo,
  select_which_cal: Vpo,
  custom_event_name: Bpo,
  custom_event_name_description: Upo,
  "2fa_required": "Se requiere autenticación de dos factores",
  incorrect_2fa: Wpo,
  which_event_type_apply: Gpo,
  apply_to_all_event_types: Hpo,
  apply_to_all_teams: Kpo,
  which_team_apply: Ypo,
  no_workflows_description: Zpo,
  timeformat_profile_hint: Qpo,
  create_workflow: Jpo,
  do_this: Xpo,
  turn_off: emo,
  turn_on: tmo,
  cancelled_bookings_cannot_be_rescheduled: nmo,
  settings_updated_successfully: omo,
  error_updating_settings: rmo,
  personal_cal_url: imo,
  bio_hint: amo,
  finish_and_start: smo,
  user_has_no_bio: cmo,
  bio: lmo,
  delete_account_modal_title: dmo,
  confirm_delete_account_modal: umo,
  delete_my_account: _mo,
  start_of_week: pmo,
  recordings_title: mmo,
  recording: fmo,
  happy_scheduling: gmo,
  select_calendars: hmo,
  check_for_conflicts: vmo,
  view_recordings: bmo,
  check_for_recordings: ymo,
  adding_events_to: $mo,
  follow_system_preferences: wmo,
  custom_brand_colors: kmo,
  customize_your_brand_colors: Smo,
  pro: xmo,
  removes_cal_branding: Emo,
  instant_meeting_with_title: Tmo,
  profile_picture: Amo,
  upload: Cmo,
  add_profile_photo: zmo,
  token_address: Omo,
  blockchain: Pmo,
  old_password: Imo,
  secure_password: Rmo,
  error_updating_password: Nmo,
  two_factor_auth: Dmo,
  recurring_event_tab_description: Mmo,
  today: Lmo,
  appearance: qmo,
  my_account: jmo,
  general: Fmo,
  calendars: Vmo,
  "2fa_auth": "Autenticación de dos factores",
  invoices: Bmo,
  embeds: Umo,
  impersonation: Wmo,
  impersonation_description: Gmo,
  recent_impersonations: Hmo,
  quick_impersonate: Kmo,
  no_recent_impersonations: Ymo,
  users: Zmo,
  user: Qmo,
  profile_description: Jmo,
  users_description: Xmo,
  users_listing: efo,
  general_description: tfo,
  calendars_description: nfo,
  appearance_description: ofo,
  conferencing_description: rfo,
  add_conferencing_app: ifo,
  password_description: afo,
  set_up_two_factor_authentication: sfo,
  we_just_need_basic_info: cfo,
  skip: lfo,
  do_this_later: dfo,
  set_availability_getting_started_subtitle_1: ufo,
  set_availability_getting_started_subtitle_2: _fo,
  connect_calendar_first: pfo,
  complete_profile: mfo,
  connect_calendars_from_app_store: ffo,
  connect_conference_apps: gfo,
  connect_calendar_apps: hfo,
  connect_payment_apps: vfo,
  connect_automation_apps: bfo,
  connect_analytics_apps: yfo,
  connect_other_apps: $fo,
  connect_messaging_apps: wfo,
  connect_crm_apps: kfo,
  current_step_of_total: Sfo,
  add_variable: xfo,
  custom_phone_number: Efo,
  message_template: Tfo,
  email_subject: Afo,
  add_dynamic_variables: Cfo,
  event_name_info: zfo,
  event_date_info: Ofo,
  event_duration_info: Pfo,
  event_time_info: Ifo,
  event_type_not_found: Rfo,
  number_to_call_variable: Nfo,
  number_to_call_info: Dfo,
  location_variable: Mfo,
  location_info: Lfo,
  additional_notes_variable: qfo,
  additional_notes_info: jfo,
  attendee_name_info: Ffo,
  organizer_name_info: Vfo,
  to: Bfo,
  workflow_turned_on_successfully: Ufo,
  download_responses: Wfo,
  download_responses_description: Gfo,
  view_responses: Hfo,
  download: Kfo,
  downloading: Yfo,
  download_recording: Zfo,
  transcription_enabled: Qfo,
  transcription_stopped: Jfo,
  download_transcript: Xfo,
  transcript: ego,
  recording_from_your_recent_call: tgo,
  transcript_from_previous_call: ngo,
  you_can_download_transcript_from_attachments: ogo,
  link_valid_for_12_hrs: rgo,
  link_valid_for_12_hrs_description: igo,
  create_your_first_form: ago,
  create_your_first_form_description: sgo,
  create_your_first_webhook: cgo,
  create_your_first_webhook_description: lgo,
  for_a_maximum_of: dgo,
  event_one: ugo,
  event_other: _go,
  profile_team_description: pgo,
  profile_org_description: mgo,
  members_team_description: fgo,
  organization_description: ggo,
  team_url: hgo,
  team_members: vgo,
  more: bgo,
  cal_ai_workflows: ygo,
  and_count_more: $go,
  more_page_footer: wgo,
  workflow_example_1: kgo,
  workflow_example_2: Sgo,
  workflow_example_3: xgo,
  workflow_example_4: Ego,
  workflow_example_5: Tgo,
  workflow_example_6: Ago,
  send_sms_reminder: Cgo,
  send_sms_reminder_description: zgo,
  follow_up_with_no_shows: Ogo,
  follow_up_with_no_shows_description: Pgo,
  remind_attendees_to_bring_id: Igo,
  remind_attendees_to_bring_id_description: Rgo,
  email_to_remind_booking: Ngo,
  email_to_remind_booking_description: Dgo,
  custom_sms_reminder: Mgo,
  custom_sms_reminder_description: Lgo,
  custom_email_reminder: qgo,
  custom_email_reminder_description: jgo,
  count_managed_to_limit: Fgo,
  welcome_to_cal_header: Vgo,
  edit_form_later_subtitle: Bgo,
  connect_calendar_later: Ugo,
  problem_saving_user_profile: Wgo,
  purchase_missing_seats: Ggo,
  slot_length: Hgo,
  booking_appearance: Kgo,
  appearance_team_description: Ygo,
  appearance_org_description: Zgo,
  only_owner_change: Qgo,
  team_disable_cal_branding_description: Jgo,
  invited_by_team: Xgo,
  token_invalid_expired: eho,
  view_booking: tho,
  exchange_add: nho,
  exchange_authentication: oho,
  exchange_authentication_standard: rho,
  exchange_authentication_ntlm: iho,
  exchange_compression: aho,
  exchange_version: sho,
  exchange_version_2007_SP1: cho,
  exchange_version_2010: lho,
  exchange_version_2010_SP1: dho,
  exchange_version_2010_SP2: uho,
  exchange_version_2013: _ho,
  exchange_version_2013_SP1: pho,
  exchange_version_2015: mho,
  exchange_version_2016: fho,
  routing: gho,
  routing_forms_description: hho,
  routing_forms_send_email_owner: vho,
  routing_forms_send_email_owner_description: bho,
  routing_forms_send_email_to: yho,
  add_new_form: $ho,
  add_new_team_form: who,
  create_your_first_route: kho,
  route_to_the_right_person: Sho,
  form: xho,
  form_description: Eho,
  copy_link_to_form: Tho,
  theme: Aho,
  theme_applies_note: Cho,
  app_theme: zho,
  app_theme_applies_note: Oho,
  theme_system: Pho,
  add_a_team: Iho,
  add_webhook_description: Rho,
  triggers_when: Nho,
  test_webhook: Dho,
  enable_webhook: Mho,
  add_webhook: Lho,
  webhook_edited_successfully: qho,
  api_keys_description: jho,
  new_api_key: Fho,
  active: Vho,
  api_key_updated: Bho,
  api_key_update_failed: Uho,
  embeds_title: Who,
  embeds_description: Gho,
  create_first_api_key: Hho,
  create_first_api_key_description: Kho,
  back_to_signin: Yho,
  reset_link_sent: Zho,
  password_reset_email: Qho,
  password_reset_leading: Jho,
  password_updated: Xho,
  pending_payment: evo,
  pending_invites: tvo,
  pending_organization_invites: nvo,
  not_on_cal: ovo,
  no_calendar_installed: rvo,
  no_calendar_installed_description: ivo,
  add_a_calendar: avo,
  change_email_hint: svo,
  confirm_password_change_email: cvo,
  seats: lvo,
  every_app_published: dvo,
  report_app: uvo,
  limit_booking_frequency: _vo,
  limit_booking_frequency_description: pvo,
  only_show_first_available_slot: mvo,
  only_show_first_available_slot_description: fvo,
  limit_total_booking_duration: gvo,
  limit_total_booking_duration_description: hvo,
  booker_booking_limit: vvo,
  booker_booking_limit_description: bvo,
  recurring_event_doesnt_support_booker_booking_limit: yvo,
  add_limit: $vo,
  team_name_required: wvo,
  show_attendees: kvo,
  show_available_seats_count: Svo,
  how_booking_questions_as_variables: xvo,
  format: Evo,
  questions: Tvo,
  all_info_your_booker_provide: Avo,
  uppercase_for_letters: Cvo,
  replace_whitespaces_underscores: zvo,
  platform_members: Ovo,
  platform_members_description: Pvo,
  platform_billing: Ivo,
  manage_billing: Rvo,
  manage_billing_description: Nvo,
  billing_freeplan_title: Dvo,
  billing_freeplan_description: Mvo,
  billing_freeplan_cta: Lvo,
  billing_portal: qvo,
  billing_help_cta: jvo,
  ignore_special_characters_booking_questions: Fvo,
  retry: Vvo,
  fetching_calendars_error: Bvo,
  calendar_connection_fail: Uvo,
  booking_confirmation_success: Wvo,
  booking_rejection_success: Gvo,
  booking_tentative: Hvo,
  booking_accept_intent: Kvo,
  we_wont_show_again: Yvo,
  couldnt_update_timezone: Zvo,
  updated_timezone_to: Qvo,
  update_timezone: Jvo,
  update_timezone_question: Xvo,
  update_timezone_description: ebo,
  dont_update: tbo,
  require_additional_notes: nbo,
  require_additional_notes_description: obo,
  email_address_action: rbo,
  after_event_trigger: ibo,
  booking_rejected_trigger: abo,
  booking_requested_trigger: sbo,
  booking_payment_initiated_trigger: cbo,
  booking_paid_trigger: lbo,
  booking_no_show_updated_trigger: dbo,
  how_long_after: ubo,
  how_long_after_hosts_no_show: _bo,
  how_long_after_guests_no_show: pbo,
  how_long_after_user_no_show_minutes: mbo,
  no_available_slots: fbo,
  time_available: gbo,
  cant_find_the_right_conferencing_app_visit_our_app_store: hbo,
  install_new_calendar_app: vbo,
  make_phone_number_required: bbo,
  new_event_type_availability: ybo,
  error_editing_availability: $bo,
  dont_have_permission: wbo,
  saml_configuration_placeholder: kbo,
  saml_email_required: Sbo,
  saml_sp_title: xbo,
  saml_sp_description: Ebo,
  saml_sp_acs_url: Tbo,
  saml_sp_entity_id: Abo,
  saml_sp_acs_url_copied: Cbo,
  saml_sp_entity_id_copied: zbo,
  add_calendar: Obo,
  limit_future_bookings: Pbo,
  limit_future_bookings_description: Ibo,
  no_event_types: Rbo,
  no_event_types_description: Nbo,
  billing_frequency: Dbo,
  monthly: Mbo,
  yearly: Lbo,
  checkout: qbo,
  your_team_disbanded_successfully: jbo,
  your_org_disbanded_successfully: Fbo,
  error_creating_team: Vbo,
  you: Bbo,
  or_continue_with: Ubo,
  resend_email: Wbo,
  member_already_invited: Gbo,
  already_in_use_error: Hbo,
  enter_email_or_username: Kbo,
  enter_email: Ybo,
  enter_emails: Zbo,
  too_many_invites: Qbo,
  team_name_taken: Jbo,
  must_enter_team_name: Xbo,
  team_url_required: eyo,
  url_taken: tyo,
  problem_registering_domain: nyo,
  team_publish: oyo,
  number_text_notifications: ryo,
  number_sms_notifications: iyo,
  attendee_email_variable: ayo,
  attendee_email_info: syo,
  booking_uid: cyo,
  kbar_search_placeholder: lyo,
  invalid_credential: dyo,
  invalid_credential_action: uyo,
  reschedule_reason: _yo,
  choose_common_schedule_team_event: pyo,
  choose_common_schedule_team_event_description: myo,
  reason: fyo,
  sender_id: gyo,
  sender_id_error_message: hyo,
  test_routing_form: vyo,
  test_preview: byo,
  route_to: yyo,
  test_preview_description: $yo,
  test_routing: wyo,
  payment_app_disabled: kyo,
  edit_event_type: Syo,
  only_admin_can_see_members_of_org: xyo,
  only_admin_can_manage_sso_org: Eyo,
  only_admin_can_manage_directory_sync: Tyo,
  only_admin_can_manage_oauth_clients: Ayo,
  collective_scheduling: Cyo,
  make_it_easy_to_book: zyo,
  find_the_best_person: Oyo,
  fixed_round_robin: Pyo,
  add_one_fixed_attendee: Iyo,
  calcom_is_better_with_team: Ryo,
  the_calcom_team: Nyo,
  add_your_team_members: Dyo,
  booking_limit_reached: Myo,
  duration_limit_reached: Lyo,
  admin_has_disabled: qyo,
  disable_attendees_emails_description: jyo,
  disabled_app_affects_event_type: Fyo,
  event_replaced_notice: Vyo,
  email_subject_slug_replacement: Byo,
  email_body_slug_replacement_notice: Uyo,
  email_body_slug_replacement_info: Wyo,
  email_body_slug_replacement_suggestion: Gyo,
  disable_payment_app: Hyo,
  payment_disabled_still_able_to_book: Kyo,
  app_disabled_with_event_type: Yyo,
  app_disabled_video: Zyo,
  app_disabled_subject: Qyo,
  navigate_installed_apps: Jyo,
  disabled_calendar: Xyo,
  enable_apps: e$o,
  enable_apps_description: t$o,
  purchase_license: n$o,
  already_have_account: o$o,
  already_have_key: r$o,
  already_have_key_suggestion: i$o,
  create_license_key: a$o,
  app_is_enabled: s$o,
  app_is_disabled: c$o,
  keys_have_been_saved: l$o,
  disable_app: d$o,
  disable_app_description: u$o,
  edit_keys: _$o,
  admin_apps_description: p$o,
  admin_users_description: m$o,
  admin_users_add_description: f$o,
  admin_users_edit_description: g$o,
  admin_orgs_edit_description: h$o,
  admin_oAuth_description: v$o,
  admin_lockedSMS_description: b$o,
  no_available_apps: y$o,
  no_available_apps_description: $$o,
  no_apps: w$o,
  no_apps_configured: k$o,
  enable_in_settings: S$o,
  please_contact_admin: x$o,
  apps_settings: E$o,
  fill_this_field: T$o,
  options: A$o,
  enter_option: C$o,
  add_an_option: z$o,
  location_already_exists: O$o,
  radio: P$o,
  google_meet_warning: I$o,
  individual: R$o,
  all_bookings_filter_label: N$o,
  all_users_filter_label: D$o,
  all_event_types_filter_label: M$o,
  your_bookings_filter_label: L$o,
  meeting_url_variable: q$o,
  meeting_url_info: j$o,
  date_overrides: F$o,
  date_overrides_delete_on_date: V$o,
  date_overrides_subtitle: B$o,
  date_overrides_info: U$o,
  date_overrides_dialog_which_hours: W$o,
  date_overrides_dialog_which_hours_unavailable: G$o,
  date_overrides_dialog_title: H$o,
  date_overrides_unavailable: K$o,
  date_overrides_mark_all_day_unavailable_one: Y$o,
  date_overrides_mark_all_day_unavailable_other: Z$o,
  date_overrides_update_btn: Q$o,
  date_successfully_added: J$o,
  date_overrides_save_btn: X$o,
  event_type_duplicate_copy_text: ewo,
  set_as_default: two,
  hide_eventtype_details: nwo,
  show_navigation: owo,
  hide_navigation: rwo,
  verification_code_sent: iwo,
  verified_successfully: awo,
  wrong_code: swo,
  not_verified: cwo,
  no_availability_in_month: lwo,
  no_availability_rolling: dwo,
  no_availability_range: uwo,
  view_previous_month: _wo,
  view_next_month: pwo,
  send_code: mwo,
  number_verified: fwo,
  create_your_first_team_webhook_description: gwo,
  create_webhook_team_event_type: hwo,
  disable_success_page: vwo,
  invalid_admin_password: bwo,
  change_password_admin: ywo,
  username_already_taken: $wo,
  assignment: wwo,
  fixed_hosts: kwo,
  add_fixed_hosts: Swo,
  round_robin_hosts: xwo,
  minimum_round_robin_hosts_count: Ewo,
  hosts: Two,
  upgrade_to_enable_feature: Awo,
  orgs_upgrade_to_enable_feature: Cwo,
  new_attendee: zwo,
  awaiting_approval: Owo,
  requires_google_calendar: Pwo,
  event_type_requires_google_calendar: Iwo,
  connected_google_calendar: Rwo,
  using_meet_requires_calendar: Nwo,
  continue_to_install_google_calendar: Dwo,
  install_google_meet: Mwo,
  install_google_calendar: Lwo,
  sender_name: qwo,
  already_invited: jwo,
  no_recordings_found: Fwo,
  new_workflow_subtitle: Vwo,
  reporting: Bwo,
  reporting_feature: Uwo,
  teams_plan_required: Wwo,
  routing_forms_are_a_great_way: Gwo,
  choose_a_license: Hwo,
  choose_license_description: Kwo,
  license: Ywo,
  agplv3_license: Zwo,
  no_need_to_keep_your_code_open_source: Qwo,
  repackage_rebrand_resell: Jwo,
  a_vast_suite_of_enterprise_features: Xwo,
  free_license_fee: e0o,
  forever_open_and_free: t0o,
  required_to_keep_your_code_open_source: n0o,
  cannot_repackage_and_resell: o0o,
  no_enterprise_features: r0o,
  step_enterprise_license: i0o,
  step_enterprise_license_description: a0o,
  setup: s0o,
  setup_description: c0o,
  configure: l0o,
  sso_configuration: d0o,
  sso_configuration_description: u0o,
  sso_configuration_description_orgs: _0o,
  sso_oidc_heading: p0o,
  sso_oidc_description: m0o,
  sso_oidc_configuration_title: f0o,
  sso_oidc_configuration_description: g0o,
  sso_oidc_callback_copied: h0o,
  sso_saml_heading: v0o,
  sso_saml_description: b0o,
  sso_saml_configuration_title: y0o,
  sso_saml_configuration_description: $0o,
  sso_saml_acsurl_copied: w0o,
  sso_saml_entityid_copied: k0o,
  sso_connection_created_successfully: S0o,
  sso_connection_deleted_successfully: x0o,
  delete_sso_configuration: E0o,
  delete_sso_configuration_confirmation: T0o,
  delete_sso_configuration_confirmation_description: A0o,
  organizer_timezone: C0o,
  email_user_cta: z0o,
  accept_invite: O0o,
  join_now: P0o,
  successfully_joined: I0o,
  email_no_user_invite_heading_subteam: R0o,
  email_no_user_invite_heading_org: N0o,
  email_no_user_invite_subheading: D0o,
  email_user_invite_subheading_subteam: M0o,
  email_user_invite_subheading_org: L0o,
  email_no_user_invite_steps_intro: q0o,
  email_no_user_step_one: j0o,
  email_no_user_step_two: F0o,
  email_no_user_step_three: V0o,
  email_no_user_step_four: B0o,
  email_no_user_signoff: U0o,
  impersonation_user_tip: W0o,
  available_variables: G0o,
  scheduler: H0o,
  no_workflows: K0o,
  change_filter: Y0o,
  change_filter_common: Z0o,
  no_results_for_filter: Q0o,
  recommended_next_steps: J0o,
  create_a_managed_event: X0o,
  meetings_are_better_with_the_right: eko,
  create_a_one_one_template: tko,
  collective_or_roundrobin: nko,
  book_your_team_members: oko,
  event_no_longer_attending_subject: rko,
  no_longer_attending: iko,
  attendee_no_longer_attending_subject: ako,
  attendee_no_longer_attending: sko,
  attendee_no_longer_attending_subtitle: cko,
  create_event_on: lko,
  create_routing_form_on: dko,
  default_app_link_title: uko,
  default_app_link_description: _ko,
  organizer_default_conferencing_app: pko,
  organizer_default_conferencing_app_not_found: mko,
  under_maintenance: fko,
  under_maintenance_description: gko,
  event_type_seats: hko,
  booking_questions_title: vko,
  booking_questions_description: bko,
  add_a_booking_question: yko,
  identifier: $ko,
  duplicate_email: wko,
  enter_redirect_url_on_exit_description: kko,
  booking_with_payment_cancelled: Sko,
  booking_with_payment_cancelled_already_paid: xko,
  booking_with_payment_cancelled_refunded: Eko,
  booking_with_payment_cancelled_no_refund: Tko,
  booking_with_payment_cancelled_refund_window_expired: Ako,
  booking_confirmation_failed: Cko,
  not_enough_seats: zko,
  form_builder_field_already_exists: Oko,
  guests_field_must_be_multiemail: Pko,
  show_on_booking_page: Iko,
  visit_cancelled_booking: Rko,
  get_started_zapier_templates: Nko,
  standard_templates: Dko,
  cal_ai_templates: Mko,
  team_is_unpublished: Lko,
  org_is_unpublished_description: qko,
  team_is_unpublished_description: jko,
  team_member: Fko,
  a_routing_form: Vko,
  form_description_placeholder: Bko,
  keep_me_connected_with_form: Uko,
  fields_in_form_duplicated: Wko,
  form_deleted: Gko,
  delete_form: Hko,
  delete_form_action: Kko,
  delete_form_confirmation: Yko,
  delete_form_confirmation_2: Zko,
  typeform_redirect_url_copied: Qko,
  modifications_in_fields_warning: Jko,
  connected_forms: Xko,
  form_modifications_warning: e1o,
  responses_collection_waiting_description: t1o,
  this_is_what_your_users_would_see: n1o,
  identifies_name_field: o1o,
  add_1_option_per_line: r1o,
  select_a_router: i1o,
  add_a_new_route: a1o,
  make_informed_decisions: s1o,
  make_informed_decisions_description: c1o,
  view_bookings_across: l1o,
  view_bookings_across_description: d1o,
  identify_booking_trends: u1o,
  identify_booking_trends_description: _1o,
  spot_popular_event_types: p1o,
  spot_popular_event_types_description: m1o,
  no_responses_yet: f1o,
  no_routes_defined: g1o,
  this_will_be_the_placeholder: h1o,
  error_booking_event: v1o,
  timeslot_missing_title: b1o,
  timeslot_missing_description: y1o,
  timeslot_missing_cta: $1o,
  switch_monthly: w1o,
  switch_weekly: k1o,
  switch_multiday: S1o,
  switch_columnview: x1o,
  num_locations: E1o,
  select_on_next_step: T1o,
  this_meeting_has_not_started_yet: A1o,
  this_app_requires_connected_account: C1o,
  connect_app: z1o,
  app_is_connected: O1o,
  requires_app: P1o,
  verification_code: I1o,
  can_you_try_again: R1o,
  verify: N1o,
  timezone_info: D1o,
  timezone_variable: M1o,
  event_end_time_variable: L1o,
  event_end_time_info: q1o,
  cancel_url_variable: j1o,
  cancel_url_info: F1o,
  cancel_reason_variable: V1o,
  cancel_reason_info: B1o,
  reschedule_url_variable: U1o,
  reschedule_url_info: W1o,
  reschedule_reason_variable: G1o,
  reschedule_reason_info: H1o,
  invalid_event_name_variables: K1o,
  select_all: Y1o,
  default_conferencing_bulk_title: Z1o,
  members_default_schedule: Q1o,
  set_by_admin: J1o,
  members_default_location: X1o,
  members_default_schedule_description: e2o,
  requires_at_least_one_schedule: t2o,
  default_conferencing_bulk_description: n2o,
  default_schedules_bulk_description: o2o,
  locked_for_members: r2o,
  unlocked_for_members: i2o,
  apps_locked_for_members_description: a2o,
  apps_unlocked_for_members_description: s2o,
  apps_locked_by_team_admins_description: c2o,
  apps_unlocked_by_team_admins_description: l2o,
  workflows_locked_for_members_description: d2o,
  workflows_unlocked_for_members_description: u2o,
  workflows_locked_by_team_admins_description: _2o,
  workflows_unlocked_by_team_admins_description: p2o,
  webhooks_locked_for_members_description: m2o,
  webhooks_unlocked_for_members_description: f2o,
  webhooks_locked_by_team_admins_description: g2o,
  webhooks_unlocked_by_team_admins_description: h2o,
  locked_by_team_admin: v2o,
  app_not_connected: b2o,
  connect_now: y2o,
  managed_event_dialog_confirm_button_one: $2o,
  managed_event_dialog_confirm_button_other: w2o,
  managed_event_dialog_title_one: k2o,
  managed_event_dialog_title_other: S2o,
  managed_event_dialog_information_one: x2o,
  managed_event_dialog_information_other: E2o,
  managed_event_dialog_clarification: T2o,
  review_event_type: A2o,
  looking_for_more_analytics: C2o,
  looking_for_more_insights: z2o,
  filters: O2o,
  filter: P2o,
  add_a_member: I2o,
  add_filter: R2o,
  add_rule: N2o,
  add_rule_group: D2o,
  remove_filters: M2o,
  email_verified: L2o,
  select_user: q2o,
  select_event_type: j2o,
  select_date_range: F2o,
  popular_events: V2o,
  no_event_types_found: B2o,
  average_event_duration: U2o,
  bookings_by_hour: W2o,
  most_booked_members: G2o,
  least_booked_members: H2o,
  most_bookings_scheduled: K2o,
  least_bookings_scheduled: Y2o,
  most_bookings_completed: Z2o,
  least_bookings_completed: Q2o,
  events_created: J2o,
  events_completed: X2o,
  events_cancelled: eSo,
  events_rescheduled: tSo,
  events: nSo,
  performance: oSo,
  from_last_period: rSo,
  from_to_date_period: iSo,
  redirect_url_warning: aSo,
  event_trends: sSo,
  clear_filters: cSo,
  clear: lSo,
  hold: dSo,
  on_booking_option: uSo,
  hold_option: _So,
  card_held: pSo,
  charge_card: mSo,
  card_charged: fSo,
  no_show_fee_amount: gSo,
  no_show_fee: hSo,
  submit_card: vSo,
  submit_payment_information: bSo,
  meeting_awaiting_payment_method: ySo,
  no_show_fee_charged_email_subject: $So,
  no_show_fee_charged_text_body: wSo,
  no_show_fee_charged_subtitle: kSo,
  error_charging_card: SSo,
  collect_no_show_fee: xSo,
  no_show_fee_charged: ESo,
  your_card_was_declined: TSo,
  your_card_does_not_support_this_type_of_purchase: ASo,
  amount_must_convert_to_at_least: CSo,
  could_not_charge_card: zSo,
  insights: OSo,
  routing_forms: PSo,
  insights_no_data_found_for_filter: ISo,
  acknowledge_booking_no_show_fee: RSo,
  days: NSo,
  card_details: DSo,
  something_went_wrong_on_our_end: MSo,
  please_provide_following_text_to_suppport: LSo,
  seats_and_no_show_fee_error: qSo,
  complete_your_booking: jSo,
  complete_your_booking_subject: FSo,
  confirm_your_details: VSo,
  copy_invite_link: BSo,
  edit_invite_link: USo,
  invite_link_copied: WSo,
  invite_link_deleted: GSo,
  api_key_deleted: HSo,
  delete_api_key_warning: KSo,
  invite_link_updated: YSo,
  link_expires_after: ZSo,
  one_day: QSo,
  seven_days: JSo,
  thirty_days: XSo,
  three_months: exo,
  one_year: txo,
  team_invite_received: nxo,
  currency_string: oxo,
  charge_card_dialog_body: rxo,
  charge_attendee: ixo,
  payment_app_commission: axo,
  email_invite_team: sxo,
  email_invite_team_bulk: cxo,
  error_collecting_card: lxo,
  image_size_limit_exceed: dxo,
  unauthorized_workflow_error_message: uxo,
  inline_embed: _xo,
  load_inline_content: pxo,
  floating_pop_up_button: mxo,
  floating_button_trigger_modal: fxo,
  pop_up_element_click: gxo,
  open_dialog_with_element_click: hxo,
  use_my_own_form: vxo,
  use_our_headless_routing_api: bxo,
  need_help_embedding: yxo,
  book_my_cal: $xo,
  first_name: wxo,
  last_name: kxo,
  first_last_name: Sxo,
  invite_as: xxo,
  form_updated_successfully: Exo,
  disable_attendees_confirmation_emails: Txo,
  disable_attendees_confirmation_emails_description: Axo,
  disable_host_confirmation_emails: Cxo,
  disable_host_confirmation_emails_description: zxo,
  add_an_override: Oxo,
  import_from_google_workspace: Pxo,
  connect_google_workspace: Ixo,
  google_workspace_admin_tooltip: Rxo,
  first_event_type_webhook_description: Nxo,
  create_instant_meeting_webhook_description: Dxo,
  install_app_on: Mxo,
  create_for: Lxo,
  currency: qxo,
  organization_banner_description: jxo,
  organization_banner_title: Fxo,
  set_up_your_organization: Vxo,
  set_up_your_platform_organization: Bxo,
  organizations_description: Uxo,
  plans: Wxo,
  platform: Gxo,
  platform_description: Hxo,
  platform_organization_description: Kxo,
  must_enter_organization_name: Yxo,
  must_enter_organization_admin_email: Zxo,
  admin_email: Qxo,
  platform_admin_email: Jxo,
  admin_username: Xxo,
  organization_name: eEo,
  platform_name: tEo,
  organization_url: nEo,
  organization_verify_header: oEo,
  organization_verify_email_body: rEo,
  additional_url_parameters: iEo,
  about_your_organization: aEo,
  about_your_organization_description: sEo,
  create_your_teams: cEo,
  create_your_teams_description: lEo,
  invite_organization_admins: dEo,
  invite_organization_admins_description: uEo,
  set_a_password: _Eo,
  set_a_password_description: pEo,
  organization_logo: mEo,
  organization_about_description: fEo,
  ill_do_this_later: gEo,
  verify_your_email: hEo,
  enter_digit_code: vEo,
  verify_email_organization: bEo,
  code_provided_invalid: yEo,
  email_already_used: $Eo,
  organization_admin_invited_heading: wEo,
  organization_admin_invited_body: kEo,
  duplicated_slugs_warning: SEo,
  team_names_empty: xEo,
  team_names_repeated: EEo,
  user_belongs_organization: TEo,
  org_no_teams_yet: AEo,
  org_no_teams_yet_description: CEo,
  set_up: zEo,
  my_profile: OEo,
  my_settings: PEo,
  crm: IEo,
  messaging: REo,
  sender_id_info: NEo,
  org_admins_can_create_new_teams: DEo,
  google_new_spam_policy: MEo,
  resolve: LEo,
  no_organization_slug: qEo,
  copy_link_org: jEo,
  "404_the_org": "La organización",
  "404_the_team": "El equipo",
  "404_claim_entity_org": "Reclame su subdominio para su organización",
  "404_claim_entity_team": "Reclame este equipo y empiece a gestionar los horarios de forma colectiva",
  insights_team_filter: FEo,
  insights_user_filter: VEo,
  insights_subtitle: BEo,
  call_history: UEo,
  call_history_subtitle: WEo,
  location_options: GEo,
  channel_type: HEo,
  end_reason: KEo,
  session_status: YEo,
  user_sentiment: ZEo,
  time_header: QEo,
  from_header: JEo,
  custom_plan: XEo,
  email_embed: eTo,
  add_times_to_your_email: tTo,
  select_time: nTo,
  select_date: oTo,
  only_show_if_parameter_set: rTo,
  add_parameter: iTo,
  connecting_you_to_someone: aTo,
  please_do_not_close_this_tab: sTo,
  see_all_available_times: cTo,
  org_team_names_example_1: lTo,
  org_team_names_example_2: dTo,
  org_team_names_example_3: uTo,
  org_team_names_example_4: _To,
  org_team_names_example_5: pTo,
  org_max_team_warnings: mTo,
  what_is_this_meeting_about: fTo,
  add_to_team: gTo,
  remove_users_from_org: hTo,
  delegation_credential: vTo,
  delegation_credential_description: bTo,
  add_client_id_in_google_workspace_with_below_scope: yTo,
  delegation_credential_enabled: $To,
  add_delegation_credential: wTo,
  edit_delegation_credential: kTo,
  domain: STo,
  no_workspace_platforms: xTo,
  workspace_platform: ETo,
  workspace_platforms: TTo,
  workspace_platforms_description: ATo,
  edit_workspace_platform: CTo,
  edit_service_account: zTo,
  add_workspace_platform: OTo,
  slug: PTo,
  service_account_key: ITo,
  edit_service_account_key: RTo,
  delegation_credential_restricts_adding_more_than_one_installation: NTo,
  app_successfully_installed_and_is_using_delegated_credentials: DTo,
  remove_users_from_org_confirm: MTo,
  remove_users_from_team: LTo,
  remove_users_from_team_confirm: qTo,
  user_has_no_schedules: jTo,
  user_isnt_in_any_teams: FTo,
  user_has_no_app_installed: VTo,
  requires_booker_email_verification: BTo,
  description_requires_booker_email_verification: UTo,
  requires_confirmation_mandatory: WTo,
  organizations: GTo,
  upload_cal_video_logo: HTo,
  update_cal_video_logo: KTo,
  upload_banner: YTo,
  cal_video_logo_upload_instruction: ZTo,
  org_admin_other_teams: QTo,
  org_admin_other_teams_description: JTo,
  not_part_of_org: XTo,
  no_other_teams_found: eAo,
  no_other_teams_found_description: tAo,
  attendee_first_name_variable: nAo,
  attendee_last_name_variable: oAo,
  attendee_first_name_info: rAo,
  attendee_last_name_info: iAo,
  your_monthly_digest: aAo,
  member_name: sAo,
  most_popular_events: cAo,
  summary_of_events_for_your_team_for_the_last_30_days: lAo,
  me: dAo,
  meeting_unavailable: uAo,
  monthly_digest_email: _Ao,
  monthly_digest_email_for_teams: pAo,
  verify_team_tooltip: mAo,
  member_removed: fAo,
  my_availability: gAo,
  team_availability: hAo,
  instant_meeting_availability: vAo,
  backup_code: bAo,
  backup_codes: yAo,
  backup_code_instructions: $Ao,
  backup_codes_copied: wAo,
  incorrect_backup_code: kAo,
  lost_access: SAo,
  missing_backup_codes: xAo,
  admin_org_notification_email_subject: EAo,
  hi_admin: TAo,
  admin_org_notification_email_title: AAo,
  admin_org_notification_email_body_part1: CAo,
  admin_org_notification_email_body_part2: zAo,
  admin_org_notification_email_body_part3: OAo,
  admin_org_notification_email_cta: PAo,
  org_has_been_processed: IAo,
  org_error_processing: RAo,
  orgs_page_description: NAo,
  unverified: DAo,
  verified: MAo,
  dns_missing: LAo,
  dns_configured: qAo,
  mark_dns_configured: jAo,
  value: FAo,
  your_organization_updated_sucessfully: VAo,
  team_no_event_types: BAo,
  seat_options_doesnt_multiple_durations: UAo,
  include_calendar_event: WAo,
  oAuth: GAo,
  oAuth_client_creation_form: HAo,
  oAuth_client_creation_form_description: KAo,
  oAuth_client_updation_form: YAo,
  oAuth_client_updation_form_description: ZAo,
  recently_added: QAo,
  connect_all_calendars: JAo,
  connect_all_calendars_description: XAo,
  workflow_automation_description: eCo,
  scheduling_for_your_team: tCo,
  scheduling_for_your_team_description: nCo,
  no_members_found: oCo,
  directory_sync: rCo,
  directory_name: iCo,
  directory_provider: aCo,
  directory_scim_url: sCo,
  directory_scim_token: cCo,
  directory_scim_url_copied: lCo,
  directory_scim_token_copied: dCo,
  directory_sync_info_description: uCo,
  directory_sync_configure: _Co,
  directory_sync_configure_description: pCo,
  directory_sync_title: mCo,
  directory_sync_created: fCo,
  directory_sync_description: gCo,
  directory_sync_deleted: hCo,
  directory_sync_delete_connection: vCo,
  directory_sync_delete_title: bCo,
  directory_sync_delete_description: yCo,
  directory_sync_delete_confirmation: $Co,
  event_setup_length_error: wCo,
  availability_schedules: kCo,
  unauthorized: SCo,
  access_cal_account: xCo,
  select_account_team: ECo,
  allow_client_to: TCo,
  associate_with_cal_account: ACo,
  see_personal_info: CCo,
  see_primary_email_address: zCo,
  connect_installed_apps: OCo,
  access_event_type: PCo,
  access_availability: ICo,
  access_bookings: RCo,
  allow_client_to_do: NCo,
  oauth_access_information: DCo,
  allow: MCo,
  view_only_edit_availability_not_onboarded: LCo,
  view_only_edit_availability: qCo,
  you_can_override_calendar_in_advanced_tab: jCo,
  edit_users_availability: FCo,
  resend_invitation: VCo,
  invitation_resent: BCo,
  saml_sso: UCo,
  add_client: WCo,
  copy_client_secret_info: GCo,
  add_new_client: HCo,
  add_new_user: KCo,
  this_app_is_not_setup_already: YCo,
  as_csv: ZCo,
  overlay_my_calendar: QCo,
  overlay_my_calendar_toc: JCo,
  view_overlay_calendar_events: XCo,
  join_event_location: ezo,
  troubleshooting: tzo,
  calendars_were_checking_for_conflicts: nzo,
  availabilty_schedules: ozo,
  manage_calendars: rzo,
  manage_availability_schedules: izo,
  locked: azo,
  unlocked: szo,
  lock_timezone_toggle_on_booking_page: czo,
  description_lock_timezone_toggle_on_booking_page: lzo,
  event_setup_multiple_payment_apps_error: dzo,
  number_in_international_format: uzo,
  install_calendar: _zo,
  branded_subdomain: pzo,
  branded_subdomain_description: mzo,
  org_insights: fzo,
  org_insights_description: gzo,
  extensive_whitelabeling: hzo,
  extensive_whitelabeling_description: vzo,
  unlimited_teams: bzo,
  verify_email: yzo,
  proceed_with_cancellation_description: $zo,
  proceed_with_cancellation_error: wzo,
  unlimited_teams_description: kzo,
  unified_billing: Szo,
  advanced_managed_events: xzo,
  advanced_managed_events_description: Ezo,
  enterprise: Tzo,
  enterprise_description: Azo,
  create_your_org: Czo,
  create_org: zzo,
  create_your_org_description: Ozo,
  create_your_enterprise_description: Pzo,
  other_payment_app_enabled: Izo,
  admin_delete_organization_description_1: Rzo,
  admin_delete_organization_description_2: Nzo,
  admin_delete_organization_description_3: Dzo,
  admin_delete_organization_description_4: Mzo,
  admin_delete_organization_title: Lzo,
  published: qzo,
  unpublished: jzo,
  publish: Fzo,
  troubleshooter_tooltip: Vzo,
  need_help: Bzo,
  troubleshooter: Uzo,
  number_to_call: Wzo,
  guest_name: Gzo,
  guest_email: Hzo,
  guest_company: Kzo,
  please_install_a_calendar: Yzo,
  instant_tab_title: Zzo,
  instant_event_tab_description: Qzo,
  uprade_to_create_instant_bookings: Jzo,
  dont_want_to_wait: Xzo,
  meeting_started: eOo,
  pay_and_book: tOo,
  cal_ai_event_tab_description: nOo,
  booking_not_found_error: oOo,
  booking_seats_full_error: rOo,
  missing_payment_credential_error: iOo,
  missing_payment_app_id_error: aOo,
  not_enough_available_seats_error: sOo,
  user_redirect_title: cOo,
  user_redirect_description: lOo,
  out_of_office: dOo,
  out_of_office_description: uOo,
  send_request: _Oo,
  start_date_and_end_date_required: pOo,
  start_date_must_be_before_end_date: mOo,
  start_date_must_be_in_the_future: fOo,
  user_not_found: gOo,
  cannot_redirect_to_self: hOo,
  out_of_office_entry_already_exists: vOo,
  out_of_office_id_required: bOo,
  booking_redirect_infinite_not_allowed: yOo,
  success_entry_created: $Oo,
  booking_redirect_email_subject: wOo,
  booking_redirect_email_title: kOo,
  booking_redirect_email_description: SOo,
  booking_redirect_updated_email_subject: xOo,
  booking_redirect_updated_email_title: EOo,
  booking_redirect_updated_email_description: TOo,
  booking_redirect_cancelled_email_subject: AOo,
  booking_redirect_cancelled_email_title: COo,
  booking_redirect_cancelled_email_description: zOo,
  success_accept_booking_redirect: OOo,
  success_reject_booking_redirect: POo,
  copy_link_booking_redirect_request: IOo,
  booking_redirect_request_title: ROo,
  select_team_member: NOo,
  going_away_title: DOo,
  redirect_team_enabled: MOo,
  redirect_team_disabled: LOo,
  out_of_office_unavailable_list: qOo,
  success_deleted_entry_out_of_office: jOo,
  success_edited_entry_out_of_office: FOo,
  temporarily_out_of_office: VOo,
  add_a_redirect: BOo,
  create_entry: UOo,
  time_range: WOo,
  automatically_add_all_team_members: GOo,
  redirect_to: HOo,
  having_trouble_finding_time: KOo,
  show_more: YOo,
  forward_params_redirect: ZOo,
  assignment_description: QOo,
  lowest: JOo,
  low: XOo,
  medium: e4o,
  high: t4o,
  Highest: n4o,
  send_booker_to: o4o,
  set_priority: r4o,
  set_weight: i4o,
  enable_weights: a4o,
  priority_for_user: s4o,
  weights_description: c4o,
  weight_for_user: l4o,
  change_priority: d4o,
  field_identifiers_as_variables: u4o,
  field_identifiers_as_variables_with_example: _4o,
  account_already_linked: p4o,
  send_email: m4o,
  cal_ai_phone_call_action: f4o,
  call_to_confirm_booking: g4o,
  cal_ai_phone_call_action_description: h4o,
  cal_ai_agent_configuration: v4o,
  choose_at_least_one_event_type_test_call: b4o,
  mark_as_no_show: y4o,
  unmark_as_no_show: $4o,
  account_unlinked_success: w4o,
  account_unlinked_error: k4o,
  travel_schedule: S4o,
  travel_schedule_description: x4o,
  schedule_timezone_change: E4o,
  date: T4o,
  enter_the_general_prompt_for_the_agent: A4o,
  overlaps_with_existing_schedule: C4o,
  "org_admin_no_slots|heading": "No se encontró disponibilidad para {{name}}",
  "org_admin_no_slots|content": "Hola Administradores de la Organización,<br /><br />Nota: Se ha señalado a nuestra atención que {{username}} no ha tenido disponibilidad cuando un usuario ha visitado {{username}}/{{slug}}<br /><br />Hay algunas razones por las que esto podría estar sucediendo<br />El usuario no tiene calendarios conectados<br />Sus horarios adjuntos a este evento no están habilitados<br /> <br />Recomendamos verificar su disponibilidad para resolver esto.",
  "org_admin_no_slots|cta": "Abrir disponibilidad de usuarios",
  organization_no_slots_notification_switch_title: z4o,
  organization_no_slots_notification_switch_description: O4o,
  organization_disable_phone_only_sms_notifications_switch_title: P4o,
  organization_disable_phone_only_sms_notifications_switch_description: I4o,
  "email_team_invite|subject|added_to_org": "{{user}} te ha añadido a la organización {{team}} en {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} te ha invitado a unirte a la organización {{team}} en {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} te ha añadido al equipo {{team}} de la organización {{parentTeamName}} en {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} te invitó a unirte al equipo {{team}} en {{appName}}",
  "email_team_invite|heading|added_to_org": "Has sido añadido a una organización de {{appName}}",
  "email_team_invite|heading|invited_to_org": "Has sido invitado a una organización de {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Has sido añadido a un equipo de la organización {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Has sido invitado a un equipo de la organización {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Has sido invitado a unirte a un equipo de {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} te ha añadido a la organización <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} te ha invitado a unirte a la organización {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} te ha invitado a unirte al equipo {{team}} de la organización {{parentTeamName}} en {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} te ha añadido al equipo <strong>{{teamName}}</strong> en su organización {{parentTeamName}}. {{appName}} es el programador de eventos que permite a ti y a tu equipo agendar reuniones sin el ir y venir de correos electrónicos.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} te ha invitado a unirte al equipo <strong>{{teamName}}</strong> en su organización {{parentTeamName}}. {{appName}} es el programador de eventos que permite a ti y a tu equipo agendar reuniones sin el ir y venir de correos electrónicos.",
  "email_team_invite|content|invited_to_regular_team": '{{invitedBy}} lo ha invitado a unirse a su equipo "{{teamName}}" en {{appName}}. {{appName}} es el planificador de eventos que le permite a usted y a su equipo programar reuniones sin correos electrónicos de ida y vuelta.',
  "email|existing_user_added_link_will_change": "Al aceptar la invitación, tu enlace cambiará al dominio de tu organización, pero no te preocupes, todos los enlaces anteriores seguirán funcionando y redireccionando adecuadamente.<br /><br />Ten en cuenta: Todos tus tipos de eventos personales se moverán a la organización <strong>{{teamName}}</strong>, lo que también puede incluir un posible enlace personal. <br /><br />Para eventos personales, recomendamos crear una nueva cuenta con una dirección de correo electrónico personal.",
  "email|existing_user_added_link_changed": "Tu enlace ha cambiado de {{a0}} a {{a1}} pero no te preocupes, todos los enlaces anteriores siguen funcionando y redireccionando adecuadamente. <br /><br />Ten en cuenta: Todos tus tipos de eventos personales se han movido a la organización <strong>{{teamName}}</strong>, lo que también puede incluir un posible enlace personal.<br /><br />Por favor, inicia sesión y asegúrate de que no tienes eventos privados en tu nueva cuenta organizacional.<br /><br />Para eventos personales, recomendamos crear una nueva cuenta con una dirección de correo electrónico personal.<br /><br />Disfruta de tu nuevo enlace limpio: {{a2}}",
  "email_organization_created|subject": "Tu organización ha sido creada",
  your_current_plan: R4o,
  organization_price_per_user_month: N4o,
  privacy_organization_description: D4o,
  privacy: M4o,
  team_will_be_under_org: L4o,
  add_group_name: q4o,
  group_name: j4o,
  routers: F4o,
  primary: V4o,
  make_primary: B4o,
  add_email: U4o,
  add_emails: W4o,
  add_email_description: G4o,
  confirm_email: H4o,
  confirming_your_booking_sms: K4o,
  scheduler_first_name: Y4o,
  scheduler_last_name: Z4o,
  scheduler_name: Q4o,
  organizer_first_name: J4o,
  confirm_email_description: X4o,
  send_event_details_to: e3o,
  schedule_tz_without_end_date: t3o,
  select_members: n3o,
  lock_event_types_modal_header: o3o,
  org_delete_event_types_org_admin: r3o,
  org_hide_event_types_org_admin: i3o,
  hide_org_eventtypes: a3o,
  delete_org_eventtypes: s3o,
  lock_org_users_eventtypes: c3o,
  lock_org_users_eventtypes_description: l3o,
  add_to_event_type: d3o,
  create_account_password: u3o,
  create_account_with_saml: _3o,
  error_creating_account_password: p3o,
  cannot_create_account_password_cal_provider: m3o,
  cannot_create_account_password_already_existing: f3o,
  create_account_password_hint: g3o,
  disconnect_account: h3o,
  disconnect_account_hint: v3o,
  cookie_consent_checkbox: b3o,
  make_a_call: y3o,
  skip_rr_assignment_label: $3o,
  skip_rr_description: w3o,
  select_account_header: k3o,
  select_account_description: S3o,
  select_event_types_header: x3o,
  select_event_types_description: E3o,
  configure_app_header: T3o,
  configure_app_description: A3o,
  already_installed: C3o,
  ooo_reasons_unspecified: z3o,
  ooo_reasons_vacation: O3o,
  ooo_reasons_travel: P3o,
  ooo_reasons_sick_leave: I3o,
  ooo_reasons_public_holiday: R3o,
  ooo_forwarding_to: N3o,
  ooo_not_forwarding: D3o,
  ooo_empty_title: M3o,
  ooo_empty_description: L3o,
  ooo_user_is_ooo: q3o,
  ooo_slots_returning: j3o,
  ooo_slots_book_with: F3o,
  ooo_select_reason: V3o,
  create_an_out_of_office: B3o,
  edit_an_out_of_office: U3o,
  submit_feedback: W3o,
  host_no_show: G3o,
  no_show_description: H3o,
  how_can_we_improve: K3o,
  most_liked: Y3o,
  review: Z3o,
  reviewed: Q3o,
  unreviewed: J3o,
  rating_url_variable: X3o,
  rating_url_info: e6o,
  no_show_url_variable: t6o,
  no_show_url_info: n6o,
  no_support_needed: o6o,
  hide_support: r6o,
  event_ratings: i6o,
  event_no_show: a6o,
  event_no_show_guest: s6o,
  recent_ratings: c6o,
  no_ratings: l6o,
  no_ratings_description: d6o,
  most_no_show_host: u6o,
  highest_rated: _6o,
  lowest_rated: p6o,
  highest_rated_members: m6o,
  lowest_rated_members: f6o,
  csat_score: g6o,
  lockedSMS: h6o,
  leave_without_assigning_anyone: v6o,
  leave_without_adding_attendees: b6o,
  no_availability_shown_to_bookers: y6o,
  go_back_and_assign: $6o,
  leave_without_assigning: w6o,
  signing_up_terms: k6o,
  proceeding_agreement: S6o,
  terms: x6o,
  always_show_x_days: E6o,
  always_show_x_days_description: T6o,
  team_subscription_cancelled_successfully: A6o,
  team_subscription_cancellation_error: C6o,
  unable_to_subscribe_to_the_platform: z6o,
  updating_oauth_client_error: O6o,
  creating_oauth_client_error: P6o,
  event_type_color: I6o,
  event_type_color_description: R6o,
  mark_as_no_show_title: N6o,
  x_marked_as_no_show: D6o,
  x_unmarked_as_no_show: M6o,
  team_select_info: L6o,
  team_settings_description: q6o,
  no_show_updated: j6o,
  email_copied: F6o,
  phone_number_copied: V6o,
  USER_PENDING_MEMBER_OF_THE_ORG: B6o,
  USER_ALREADY_INVITED_OR_MEMBER: U6o,
  USER_MEMBER_OF_OTHER_ORGANIZATION: W6o,
  booking_reassigned: G6o,
  reassign: H6o,
  reassign_to_another_rr_host: K6o,
  assign_team_member: Y6o,
  override_team_member_to_assign: Z6o,
  no_available_hosts: Q6o,
  reassign_round_robin_host: J6o,
  skip_writing_to_calendar: X6o,
  rescheduling_not_possible: e5o,
  event_expired: t5o,
  skip_contact_creation: n5o,
  skip_writing_to_calendar_note: o5o,
  attributes: r5o,
  new_attribute: i5o,
  add_attributes: a5o,
  add_attributes_description: s5o,
  new_option: c5o,
  update_profile: l5o,
  attribute: d5o,
  create_attribute_description: u5o,
  edit_attribute_description: _5o,
  attribute_updated_successfully: p5o,
  attribute_deleted_successfully: m5o,
  attributes_edited_successfully: f5o,
  attribute_meta_description: g5o,
  attributes_edit_description: h5o,
  back_to_attributes: v5o,
  delete_attribute: b5o,
  delete_attribute_description: y5o,
  disable_all_emails_to_attendees: $5o,
  disable_all_emails_description: w5o,
  disable_all_emails_to_hosts: k5o,
  type_confirm_to_continue: S5o,
  disable_email: x5o,
  grant_admin_api: E5o,
  revoke_admin_api: T5o,
  add_calendar_label: A5o,
  apple_connect_atom_label: C5o,
  apple_connect_atom_already_connected_label: z5o,
  apple_connect_atom_loading_label: O5o,
  google_connect_atom_label: P5o,
  google_connect_atom_already_connected_label: I5o,
  google_connect_atom_loading_label: R5o,
  outlook_connect_atom_label: N5o,
  outlook_connect_atom_already_connected_label: D5o,
  outlook_connect_atom_loading_label: M5o,
  stripe_connect_atom_label: L5o,
  stripe_connect_atom_already_connected_label: q5o,
  stripe_connect_atom_loading_label: j5o,
  booking_question_response_variables: F5o,
  managed_by_teamAdmins: V5o,
  number_of_options: B5o,
  reschedule_with_same_round_robin_host_title: U5o,
  reschedule_with_same_round_robin_host_description: W5o,
  disable_input_if_prefilled: G5o,
  booking_limits: H5o,
  booking_limits_team_description: K5o,
  limit_team_booking_frequency_description: Y5o,
  booking_limits_updated_successfully: Z5o,
  you_are_unauthorized_to_make_this_change_to_the_booking: Q5o,
  delegation_credential_disabled: J5o,
  matching_members: X5o,
  x_matching_members: ePo,
  matching_members_queue_using_attribute_weights: tPo,
  matching_members_queue_using_event_assignee_weights: nPo,
  no_matching_members: oPo,
  no_matching_members_will_fallback_to_all_assigned_members: rPo,
  hide_calendar_event_details: iPo,
  description_hide_calendar_event_details: aPo,
  last_number_of_days: sPo,
  month_to_date: cPo,
  year_to_date: lPo,
  custom_range: dPo,
  refund_policy: uPo,
  always: _Po,
  never: pPo,
  payment_option: mPo,
  if_cancelled: fPo,
  before: gPo,
  show_all_columns: hPo,
  toggle_columns: vPo,
  no_columns_found: bPo,
  salesforce_create_record_as: yPo,
  salesforce_lead: $Po,
  salesforce_contact_under_account: wPo,
  salesforce_skip_entry_creation: kPo,
  salesforce_if_account_does_not_exist: SPo,
  salesforce_create_new_contact_under_account: xPo,
  salesforce_change_record_owner_on_booking: EPo,
  mass_assign_attributes: TPo,
  reroute_preview_custom_message: APo,
  reroute_preview_external_redirect: CPo,
  reroute_preview_possible_host: zPo,
  current_routing_status: OPo,
  reroute_booking: PPo,
  reroute_booking_description: IPo,
  verify_new_route: RPo,
  reroute: NPo,
  new_routing_status: DPo,
  salesforce_book_directly_with_attendee_owner: MPo,
  salesforce_check_owner_of: LPo,
  account: qPo,
  choose_hosts_schedule: jPo,
  hosts_schedule_description: FPo,
  no_hosts_description: VPo,
  team_member_round_robin_reassign: BPo,
  team_member_round_robin_reassign_description: UPo,
  round_robin_reassign_description: WPo,
  invalid_round_robin_host: GPo,
  user_is_round_robin_fixed: HPo,
  reschedule_with_same_timeslot: KPo,
  reschedule_with_same_timeslot_of_new_event: YPo,
  reschedule_to_the_new_event_with_different_timeslot: ZPo,
  reschedule_with_different_timeslot: QPo,
  we_dont_have_id_for_the_new_event: JPo,
  rerouted_booking_successfully_redirecting_to_booking_page: XPo,
  on_booking_write_to_event_object: eIo,
  field_name: tIo,
  add_new_field: nIo,
  you_dont_have_access_to_reroute_this_booking: oIo,
  form_response_not_found: rIo,
  contact_owner: iIo,
  contact_owner_not_found: aIo,
  using_fallback_members: sIo,
  chosen_route: cIo,
  attribute_logic_matched: lIo,
  attribute_logic_fallback_matched: dIo,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: uIo,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: _Io,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: pIo,
  warning: mIo,
  fallback_attribute_logic_description: fIo,
  fallback_attribute_logic_warning: gIo,
  fallback_not_needed: hIo,
  confirm_reassign_unavailable: vIo,
  confirm_reassign_available: bIo,
  reassign_unavailable_team_member_description: yIo,
  reassign_available_team_member_description: $Io,
  yes_reassign: wIo,
  filter_by_attributes: kIo,
  reassign_reason: SIo,
  field_type_change_suggestion: xIo,
  reassigned_by: EIo,
  row: TIo,
  rows: AIo,
  attendee_timezone_variable: CIo,
  event_start_time_in_attendee_timezone_variable: zIo,
  event_start_time_in_attendee_timezone_info: OIo,
  event_end_time_in_attendee_timezone_info: PIo,
  event_end_time_in_attendee_timezone_variable: IIo,
  salesforce_create_event_on_contact: RIo,
  salesforce_owner_name_to_change: NIo,
  no_filter_set: DIo,
  booking_dry_run_successful: MIo,
  booking_dry_run_successful_description: LIo,
  dont_have_access_this_page: qIo,
  you_need_admin_or_owner_privileges_to_access: jIo,
  field_type: FIo,
  when_to_write: VIo,
  salesforce_on_booking_write_to_record: BIo,
  on_every_booking: UIo,
  only_if_field_is_empty: WIo,
  booking_start_date: GIo,
  booking_created_date: HIo,
  booking_reassigned_to_host: KIo,
  no_contact_owner: YIo,
  routing_forms_created: ZIo,
  routing_forms_total_responses: QIo,
  routing_forms_total_responses_without_booking: JIo,
  routing_forms_total_responses_with_booking: XIo,
  routing_form_insights: eRo,
  routing_form_insights_form_name_header: tRo,
  routing_form_insights_booking_status_header: nRo,
  routing_form_insights_response_no_booking: oRo,
  routing_form_insights_booked_by: rRo,
  routing_form_insights_created_at: iRo,
  routing_form_insights_booking_status: aRo,
  routing_form_insights_booking_at: sRo,
  routing_form_insights_submitted_at: cRo,
  copy_redirect_url: lRo,
  redirect_url_on_exit: dRo,
  total_bookings_per_period: uRo,
  routed_to_per_period: _Ro,
  per_day: pRo,
  per_week: mRo,
  per_month: fRo,
  routing_form_insights_assignment_reason: gRo,
  access_denied: hRo,
  salesforce_route_to_owner: vRo,
  salesforce_add_attendees_as: bRo,
  salesforce_do_not_route_to_owner: yRo,
  salesforce_route_to_custom_lookup_field: $Ro,
  salesforce_option: wRo,
  lookup_field_name: kRo,
  salesforce_if_free_email_domain_skip_owner_check: SRo,
  filter_operator_is: xRo,
  filter_operator_is_not: ERo,
  filter_operator_contains: TRo,
  filter_operator_does_not_contain: ARo,
  filter_operator_starts_with: CRo,
  filter_operator_ends_with: zRo,
  filter_operator_is_empty: ORo,
  filter_operator_not_empty: PRo,
  translate_description_button: IRo,
  translate_description_button_description: RRo,
  rr_distribution_method: NRo,
  rr_distribution_method_description: DRo,
  rr_distribution_method_availability_title: MRo,
  rr_distribution_method_availability_description: LRo,
  rr_distribution_method_balanced_title: qRo,
  rr_distribution_method_balanced_description: jRo,
  edit_team_member_weights: FRo,
  weights_updated_successfully: VRo,
  require_confirmation_for_free_email: BRo,
  exclude_emails_that_contain: URo,
  require_emails_that_contain: WRo,
  exclude_emails_match_found_error_message: GRo,
  require_emails_no_match_found_error_message: HRo,
  search_columns: KRo,
  search_options: YRo,
  disable_org_url_label: ZRo,
  disable_org_url_description: QRo,
  single_select: JRo,
  multi_select: XRo,
  calendar_conflict_settings: eNo,
  select_calendars_conflict_check: tNo,
  group_meeting: nNo,
  are_you_sure_you_want_to_remove_this_app_from: oNo,
  disconnect_app_from: rNo,
  salesforce_ignore_guests: iNo,
  google_meet: aNo,
  zoom: sNo,
  office_365_video: cNo,
  lock_attribute_for_assignment: lNo,
  lock_attribute_for_assignment_description: dNo,
  attribute_edited_successfully: uNo,
  new_group_option: _No,
  attribute_weight_enabled: pNo,
  attribute_weight_enabled_description: mNo,
  routed: fNo,
  reassigned: gNo,
  allow_rescheduling_past_events: hNo,
  allow_rescheduling_past_events_description: vNo,
  rerouted: bNo,
  salesforce_assigned: yNo,
  router_position: $No,
  show_matching_hosts: wNo,
  no_active_queues: kNo,
  weight: SNo,
  calibration: xNo,
  shortfall: ENo,
  routing_form: TNo,
  go_back_and_save: ANo,
  save_changes: CNo,
  leave_without_saving: zNo,
  leave_without_saving_description: ONo,
  something_unexpected_occurred: PNo,
  "500_error_message": "No eres tú, somos nosotros.",
  dry_run_mode_active: INo,
  icon_showcase: RNo,
  icons_showcase: NNo,
  migrating_from_team: DNo,
  feature_currently_disabled: MNo,
  choose_an_option: LNo,
  enter_option_value: qNo,
  remove_option: jNo,
  use_attribute_weights: FNo,
  if_enabled_ignore_event_type_weights: VNo,
  attribute_for_weights: BNo,
  managed_users: UNo,
  managed_users_description: WNo,
  can_you_tell_me_about: GNo,
  use_ai_to_answer_your_questions: HNo,
  error_fetching_answer: KNo,
  k_bar_ai_error: YNo,
  select_oAuth_client: ZNo,
  on_every_instance: QNo,
  delegation_credential_feature_not_enabled: JNo,
  internal_booking_note: XNo,
  internal_note_cancellation_reason: eDo,
  internal_booking_note_description: tDo,
  internal_note_presets: nDo,
  internal_note_presets_description: oDo,
  internal_note_presets_updated_successfully: rDo,
  add_preset: iDo,
  authorize: aDo,
  next: sDo,
  hide: cDo,
  show: lDo,
  utm_params: dDo,
  no_utm_params: uDo,
  asc: _Do,
  desc: pDo,
  verify_email_change: mDo,
  buy_credits: fDo,
  credits: gDo,
  credits_used: hDo,
  total_credits_remaining: vDo,
  credits_per_tip_org: bDo,
  credits_per_tip_teams: yDo,
  view_and_manage_credits: $Do,
  view_and_manage_credits_description: wDo,
  credit_worth_description: kDo,
  buy_additional_credits: SDo,
  view_additional_credits_expense_tip: xDo,
  overview: EDo,
  organization_slug_taken: TDo,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: ADo,
  you_need_to_complete_user_onboarding_before_creating_an_organization: CDo,
  use_company_email_to_create_an_organization: zDo,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: ODo,
  you_need_to_have_minimum_published_teams: PDo,
  you_are_part_of_this_organization_already: IDo,
  you_are_part_of_another_organization_cannot_create_organization: RDo,
  you_are_part_of_another_platform_organization_cannot_create_organization: NDo,
  organization_payment_success: DDo,
  organization_payment_success_description: MDo,
  this_may_take_a_few_seconds: LDo,
  organization_onboarding_status: qDo,
  organization_onboarding_status_description: jDo,
  payment_failed: FDo,
  payment_failed_description: VDo,
  creating_your_organization: BDo,
  organization_onboarding_already_completed: UDo,
  organization_onboarding_already_exists: WDo,
  organization_onboarding_not_found: GDo,
  payment_successful: HDo,
  handover_onboarding_page_title: KDo,
  handover_onboarding_page_description: YDo,
  organization_already_exists_with_this_slug: ZDo,
  you_do_not_have_permission_to_create_an_organization_for_this_email: QDo,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: JDo,
  organization_has_subscription_already: XDo,
  reset_interval_weighted_rr: eMo,
  interval: tMo,
  rr_reset_interval_description: nMo,
  daily: oMo,
  end_date_not_selected: rMo,
  my_ooo: iMo,
  team_ooo: aMo,
  out_of_office_team_description: sMo,
  create_ooo_dialog_team_title: cMo,
  create_ooo_dialog_team_subtitle: lMo,
  edit_ooo_dialog_team_subtitle: dMo,
  ooo_team_empty_title: uMo,
  ooo_team_empty_description: _Mo,
  forward_to_team_member_only: pMo,
  ooo_team_redirect_infinite_not_allowed: mMo,
  previous_ooo_empty_title: fMo,
  previous: gMo,
  rr_interval_successfully_updated: hMo,
  trial_mode: vMo,
  inactive_team_plan: bMo,
  inactive_team_plan_description: yMo,
  limited_access_trial_mode: $Mo,
  referral_program: wMo,
  referral_text: kMo,
  dub_disabled_error_message: SMo,
  uid: xMo,
  link: EMo,
  rows_per_page: TMo,
  pagination_status: AMo,
  tip_username_plus: CMo,
  user_has_no_team_yet: zMo,
  no_team_members: OMo,
  recurring_event_doesnt_support_seats: PMo,
  booking_limit_per_booker_doesnt_support_recurring: IMo,
  seats_doesnt_support_recurring: RMo,
  recurring_event_seats_error: NMo,
  segment: DMo,
  saved_filters: MMo,
  rename: LMo,
  rename_segment: qMo,
  delete_segment: jMo,
  duplicate_segment: FMo,
  delete_segment_confirmation: VMo,
  filter_segment_updated: BMo,
  error_updating_filter_segment: UMo,
  filter_segment_duplicated: WMo,
  error_duplicating_filter_segment: GMo,
  filter_segment_deleted: HMo,
  error_deleting_filter_segment: KMo,
  save_segment: YMo,
  segment_not_found: ZMo,
  filter_segment_saved: QMo,
  no_segments: JMo,
  error_saving_filter_segment: XMo,
  override_segment: eLo,
  create_new_segment: tLo,
  save_for_team: nLo,
  select_team: oLo,
  please_select_team: rLo,
  personal: iLo,
  hide_team_profile_link: aLo,
  hide_team_profile_link_description: sLo,
  display: cLo,
  could_not_find_slug_to_publish_org: lLo,
  picklist: dLo,
  most_cancelled_bookings: uLo,
  interface_language: _Lo,
  interface_language_description: pLo,
  visitors_browser_language: mLo,
  name_or_email: fLo,
  salesforce_round_robin_skip_fallback_to_lead_owner: gLo,
  credit_purchase_failed: hLo,
  minimum_of_credits_required: vLo,
  enable_delegation_credential: bLo,
  enable_delegation_credential_description: yLo,
  disable_delegation_credential: $Lo,
  disable_delegation_credential_description: wLo,
  last_active: kLo,
  member_since: SLo,
  last_updated: xLo,
  salesforce_on_cancel_write_to_event: ELo,
  salesforce_on_every_cancellation: TLo,
  report_issue: ALo,
  report_issue_description: CLo,
  open_issue: zLo,
  this_is_your_current_plan: OLo,
  schedule_a_time: PLo,
  this_includes: ILo,
  oauth_client_updated_successfully: RLo,
  oauth_client_not_found: NLo,
  subscribe_to_platform: DLo,
  error_accessing_webhooks: MLo,
  webhook_update_failed: LLo,
  webhook_create_failed: qLo,
  invalid_link: jLo,
  currently_subscribed_to_plan: FLo,
  user_team: VLo,
  client_id_copied: BLo,
  client_secret_copied: ULo,
  maintenance_message: WLo,
  your_payment_failed: GLo,
  check_your_inbox: HLo,
  account_created_premium_not_reserved: KLo,
  email_sent_with_activation_link: YLo,
  activate_account_to_purchase_username: ZLo,
  open_in_gmail: QLo,
  dont_see_email: JLo,
  resend_in_seconds: XLo,
  resend: eqo,
  verification_email_sent: tqo,
  select_all_members: nqo,
  select_all_members_tooltip: oqo,
  form_settings: rqo,
  remove_whitelist_status: iqo,
  whitelist_user_workflows: aqo,
  user_workflows_whitelisted: sqo,
  user_workflows_unwhitelisted: cqo,
  date_and_time: lqo,
  email_reminder_upcoming_event_notice: dqo,
  email_reminder_triggered_by_workflow: uqo,
  event_upper_case: _qo,
  scheduling_by: pqo,
  experience_review_prompt: mqo,
  improve_customer_experience_message: fqo,
  meeting_satisfaction_question: gqo,
  meeting_not_joined_question: hqo,
  reschedule_cta_short: vqo,
  hide_organizer_email: bqo,
  platform_customer_cant_create_organization: yqo,
  organization_customer_cant_create_platform: $qo,
  hide_organizer_email_description: wqo,
  you_and_conjunction: kqo,
  select_verified_email: Sqo,
  add_verified_email: xqo,
  add_verified_emails: Eqo,
  custom_reply_to_email_title: Tqo,
  custom_reply_to_email_description: Aqo,
  email_survey_triggered_by_workflow: Cqo,
  skip_trial: zqo,
  team_trials_skipped_successfully: Oqo,
  sms_workflow_consent: Pqo,
  routing_preview_more_info_found_insights: Iqo,
  results: Rqo,
  view_form: Nqo,
  sms_opt_out_message: Dqo,
  team_credits_low_warning: Mqo,
  user_credits_low_warning: Lqo,
  action_required_out_of_credits: qqo,
  action_required_user_out_of_credits: jqo,
  low_credits_warning_message: Fqo,
  low_credits_warning_message_user: Vqo,
  credit_limit_reached_message: Bqo,
  credit_limit_reached_message_user: Uqo,
  current_credit_balance: Wqo,
  current_balance: Gqo,
  notification_about_your_booking: Hqo,
  monthly_credits: Kqo,
  total_credits: Yqo,
  remaining_credits: Zqo,
  remaining: Qqo,
  total: Jqo,
  additional_credits: Xqo,
  routing_form_next_in_queue: e9o,
  routing_form_select_members_to_email: t9o,
  routing_incomplete_booking_tab: n9o,
  include_no_show_in_rr_calculation: o9o,
  recent_no_show_guests: r9o,
  recent_no_show_guests_tooltip: i9o,
  matching: a9o,
  event_redirect: s9o,
  reset_form: c9o,
  rr_settings_successfully_updated: l9o,
  distribution_basis_weighted_rr: d9o,
  timestamp_basis_description: u9o,
  requires_credits: _9o,
  requires_credits_tooltip: p9o,
  available_credits: m9o,
  create_role: f9o,
  roles_and_permissions: g9o,
  roles_and_permissions_description: h9o,
  learn_more_permissions: v9o,
  role_name: b9o,
  role_name_required: y9o,
  role_name_placeholder: $9o,
  role_description: w9o,
  role_description_placeholder: k9o,
  default_role: S9o,
  custom_role: x9o,
  advanced: E9o,
  search_permissions: T9o,
  all_permissions: A9o,
  none: C9o,
  read_only: z9o,
  pbac_desc_all_actions_all_resources: O9o,
  pbac_resource_all: P9o,
  pbac_resource_event_type: I9o,
  pbac_resource_team: R9o,
  pbac_resource_organization: N9o,
  pbac_resource_booking: D9o,
  pbac_resource_insights: M9o,
  pbac_resource_role: L9o,
  pbac_resource_routing_form: q9o,
  pbac_resource_workflow: j9o,
  pbac_action_all: F9o,
  pbac_action_create: V9o,
  pbac_action_read: B9o,
  pbac_action_update: U9o,
  pbac_action_delete: W9o,
  pbac_action_manage: G9o,
  pbac_action_invite: H9o,
  pbac_action_remove: K9o,
  pbac_action_change_member_role: Y9o,
  pbac_action_list_members: Z9o,
  pbac_action_manage_billing: Q9o,
  pbac_action_read_team_bookings: J9o,
  pbac_action_read_org_bookings: X9o,
  pbac_action_read_recordings: ejo,
  pbac_action_impersonate: tjo,
  role_created_successfully: njo,
  role_updated_successfully: ojo,
  delete_role: rjo,
  confirm_delete_role: ijo,
  role_deleted_successfully: ajo,
  error_creating_role: sjo,
  error_updating_role: cjo,
  pbac_desc_create_roles: ljo,
  pbac_resource_attributes: djo,
  pbac_desc_view_organization_attributes: ujo,
  pbac_desc_update_organization_attributes: _jo,
  pbac_desc_delete_organization_attributes: pjo,
  pbac_desc_create_organization_attributes: mjo,
  pbac_desc_view_roles: fjo,
  pbac_desc_update_roles: gjo,
  pbac_desc_delete_roles: hjo,
  pbac_desc_create_workflows: vjo,
  set_up_required: bjo,
  pbac_desc_view_workflows: yjo,
  pbac_desc_update_workflows: $jo,
  pbac_desc_delete_workflows: wjo,
  pbac_resource_webhook: kjo,
  pbac_resource_availability: Sjo,
  pbac_resource_out_of_office: xjo,
  pbac_desc_create_webhooks: Ejo,
  pbac_desc_view_webhooks: Tjo,
  pbac_desc_update_webhooks: Ajo,
  pbac_desc_delete_webhooks: Cjo,
  pbac_desc_create_availability: zjo,
  pbac_desc_view_availability: Ojo,
  pbac_desc_update_availability: Pjo,
  pbac_desc_delete_availability: Ijo,
  pbac_desc_create_out_of_office: Rjo,
  pbac_desc_view_out_of_office: Njo,
  pbac_desc_update_out_of_office: Djo,
  pbac_desc_delete_out_of_office: Mjo,
  pbac_desc_manage_workflows: Ljo,
  pbac_desc_create_event_types: qjo,
  pbac_desc_view_event_types: jjo,
  pbac_desc_update_event_types: Fjo,
  pbac_desc_delete_event_types: Vjo,
  pbac_desc_manage_event_types: Bjo,
  pbac_desc_create_teams: Ujo,
  pbac_desc_view_team_details: Wjo,
  pbac_desc_update_team_settings: Gjo,
  pbac_desc_delete_team: Hjo,
  pbac_desc_invite_team_members: Kjo,
  pbac_desc_remove_team_members: Yjo,
  pbac_desc_change_team_member_role: Zjo,
  pbac_desc_impersonate_team_members: Qjo,
  pbac_desc_manage_teams: Jjo,
  pbac_desc_create_organization: Xjo,
  pbac_desc_view_organization_details: eFo,
  pbac_desc_list_organization_members: tFo,
  pbac_desc_invite_organization_members: nFo,
  pbac_desc_remove_organization_members: oFo,
  pbac_desc_manage_organization_billing: rFo,
  pbac_desc_change_organization_member_role: iFo,
  pbac_desc_impersonate_organization_members: aFo,
  pbac_desc_edit_organization_settings: sFo,
  pbac_desc_manage_organizations: cFo,
  pbac_desc_view_bookings: lFo,
  pbac_desc_view_team_bookings: dFo,
  pbac_desc_view_organization_bookings: uFo,
  pbac_desc_view_booking_recordings: _Fo,
  pbac_desc_update_bookings: pFo,
  pbac_desc_manage_bookings: mFo,
  pbac_desc_view_team_insights: fFo,
  pbac_desc_manage_team_insights: gFo,
  pbac_desc_create_routing_forms: hFo,
  pbac_desc_view_routing_forms: vFo,
  pbac_desc_update_routing_forms: bFo,
  pbac_desc_delete_routing_forms: yFo,
  read_permission_auto_enabled_tooltip: $Fo,
  choose_restriction_schedule: wFo,
  restriction_schedule_description: kFo,
  use_booker_timezone: SFo,
  use_booker_timezone_info: xFo,
  load_balancing_warning: EFo,
  rr_load_balancing_disabled: TFo,
  rr_load_balancing_disabled_with_groups: AFo,
  round_robin_settings_description: CFo,
  round_robin_settings_updated_successfully: zFo,
  booking_creation_time: OFo,
  meeting_start_time: PFo,
  members_affected_by_disabling_delegation_credential: IFo,
  no_members_affected_by_disabling_delegation_credential: RFo,
  download_expense_log: NFo,
  error_downloading_expense_log: DFo,
  offer_to_reschedule_last_booking: MFo,
  booker_limit_exceeded_error: LFo,
  booker_limit_exceeded_error_reschedule: qFo,
  duration_min_error: jFo,
  duration_max_error: FFo,
  booking_not_allowed_by_restriction_schedule_error: VFo,
  restriction_schedule_not_found_error: BFo,
  converted_image_size_limit_exceed: UFo,
  add_group: WFo,
  routing_funnel: GFo,
  routing_funnel_total_submissions: HFo,
  routing_funnel_successful_routings: KFo,
  routing_funnel_accepted_bookings: YFo,
  license_key: ZFo,
  license_selection_title: QFo,
  license_selection_description: JFo,
  agplv3_license_description: XFo,
  enter_license_key: e8o,
  enter_your_license_key: t8o,
  enter_existing_license: n8o,
  enter_license_key_description: o8o,
  license_key_placeholder: r8o,
  save_license_key: i8o,
  signature_token_optional: a8o,
  signature_token_description: s8o,
  need_a_license: c8o,
  license_key_required: l8o,
  invalid_license_key: d8o,
  license_validation_failed: u8o,
  attachments_optional: _8o,
  send_message: p8o,
  describe_the_issue: m8o,
  file_size_limit_exceed: f8o,
  invalid_file_type: g8o,
  invalid_file_type_extension: h8o,
  max_files_exceeded: v8o,
  files_uploaded_successfully: b8o,
  file_upload_instructions: y8o,
  license_key_saved: $8o,
  timezone_mismatch_tooltip: w8o,
  show_optimized_slots: k8o,
  show_optimized_slots_description: S8o,
  failed_bookings_by_field: x8o,
  failed_bookings: E8o,
  event_type_no_hosts: T8o,
  cache_status: A8o,
  cache_last_updated: C8o,
  delete_cached_data: z8o,
  cache_deleted_successfully: O8o,
  error_deleting_cache: P8o,
  confirm_delete_cache: I8o,
  yes_delete_cache: R8o,
  remainder_of_maximum_uses_left_plural: N8o,
  remainder_of_maximum_use_left_singular: D8o,
  expires_on_date: M8o,
  single_use: L8o,
  time_based_expiration: q8o,
  usage_based_expiration: j8o,
  number_of_uses: F8o,
  expires_on: V8o,
  max_usage_count: B8o,
  link_settings: U8o,
  link_expired_on_date: W8o,
  usage_limit_reached: G8o,
  usage_count_error: H8o,
  private_link_expired: K8o,
  time_based_expiration_description: Y8o,
  time_based_generic_expiration_description: Z8o,
  usage_based_expiration_description: Q8o,
  usage_based_generic_expiration_description: J8o,
  usage_based_expiration_description_plural: X8o,
  webhook_trigger_event: e7o,
  webhook_created_at: t7o,
  webhook_type: n7o,
  set_up_agent: o7o,
  webhook_title: r7o,
  webhook_start_time: i7o,
  webhook_end_time: a7o,
  webhook_description: s7o,
  webhook_location: c7o,
  webhook_uid: l7o,
  webhook_reschedule_uid: d7o,
  webhook_cancellation_reason: u7o,
  webhook_rejection_reason: _7o,
  webhook_organizer_name: p7o,
  webhook_organizer_email: m7o,
  webhook_organizer_timezone: f7o,
  webhook_organizer_locale: g7o,
  webhook_organizer_username: h7o,
  webhook_organizer_username_in_org: v7o,
  webhook_attendee_name: b7o,
  webhook_attendee_email: y7o,
  webhook_attendee_timezone: $7o,
  webhook_attendee_locale: w7o,
  webhook_team_name: k7o,
  webhook_team_members: S7o,
  webhook_video_call_url: x7o,
  webhook_hide_variables: E7o,
  webhook_show_variable: T7o,
  webhook_event_and_booking: A7o,
  webhook_people: C7o,
  webhook_teams: z7o,
  webhook_metadata: O7o,
  stats: P7o,
  booking_status: I7o,
  visit: R7o,
  location_custom_label_input_label: N7o,
  meeting_link: D7o,
  session_outcome: M7o,
  call_created: L7o,
  voicemail: q7o,
  my_bookings: j7o,
  phone: F7o,
  free: V7o,
  user_email: B7o,
  user_name: U7o,
  expand_panel: W7o,
  collapse_panel: G7o,
  email_verification_required: H7o,
  invalid_verification_code: K7o,
  you_have_one_team: Y7o,
  consider_consolidating_one_team_org: Z7o,
  consider_consolidating_multi_team_org: Q7o,
  message_sent: J7o,
  support_message_sent_description: X7o,
  search_variables: eVo,
  support_message_placeholder: tVo,
  send_another_message: nVo,
  sending: oVo,
  no_variables_found: rVo,
  credits_required: iVo,
  web_call_credits_info: aVo,
  web_call_no_credits: sVo,
  purchase_credits: cVo,
  credits_required_tooltip: lVo,
  api_key_name_too_long: dVo,
  auto_charge_for_last_minute_cancellation: uVo,
  before_scheduled_start_time: _Vo,
  cancel_booking_acknowledge_no_show_fee: pVo,
  contact_organizer: mVo,
  booking_time_option: fVo,
  booking_time_option_description: gVo,
  created_at_option: hVo,
  created_at_option_description: vVo,
  call_details: bVo,
  call_id: yVo,
  call_information: $Vo,
  sentiment: wVo,
  disconnect_reason: kVo,
  call_summary: SVo,
  transcription: xVo,
  event_details: EVo,
  agent: TVo,
  no_transcript_available: AVo,
  testing_sms_workflow_info_message: CVo,
  start_from_scratch_title: zVo,
  start_from_scratch_description: OVo,
  cal_ai_template_title: PVo,
  cal_ai_template_description: IVo,
  voice: RVo,
  select_voice: NVo,
  select_voice_for_agent: DVo,
  choose_a_voice_for_your_agent: MVo,
  trait: LVo,
  voice_id: qVo,
  use_voice: jVo,
  current_voice: FVo,
  setup_incoming_agent: VVo,
  setup_incoming_agent_description: BVo,
  connect_a_phone_number_first: UVo,
  setup_agent_for_incoming_calls: WVo,
  configure_agent_to_handle_incoming_calls: GVo,
  incoming_calls: HVo,
  outgoing_calls: KVo,
  inbound_agent_setup_success: YVo,
  inbound_agent_configured: ZVo,
  setup_inbound_agent: QVo,
  please_select_event_type_first: JVo,
  edit_configuration: XVo,
  select_event_type_for_inbound_calls: eBo,
  setup_inbound_agent_for_incoming_calls: tBo,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: nBo
}, rBo = "Fournisseur d'identité", iBo = 'Il vous reste $t(day, {"count": {{days}} }) pour votre essai Pro', aBo = "{{count}} jour", sBo = "{{count}} jours", cBo = "{{count}} seconde", lBo = "{{count}} secondes", dBo = "Mettre à niveau maintenant", uBo = "Sans titre", _Bo = "Accepter l'invitation", pBo = "Caractères max.", mBo = "Caractères min.", fBo = "{{appName}} fournit une infrastructure de planification pour absolument tout le monde.", gBo = "Finalisez la configuration de votre compte {{appName}} ! Vous n'êtes qu'à quelques étapes de résoudre tous vos problèmes de planification.", hBo = "Vous avez des questions ? Nous sommes là pour vous aider.", vBo = "{{appName}} : Instructions de réinitialisation de mot de passe", bBo = "{{appName}} : Vérifiez votre compte", yBo = "{{appName}} : Faites vérifier votre adresse e-mail", $Bo = "Vérifiez votre e-mail", wBo = "Ancienne adresse e-mail", kBo = "Nouvelle adresse e-mail", SBo = "Nous avons envoyé un e-mail à {{email}}. Il est important de vérifier votre adresse e-mail pour garantir la meilleure délivrabilité des e-mails et des calendriers de {{appName}}.", xBo = "Vérifiez votre adresse e-mail pour garantir la meilleure délivrabilité des e-mails et des calendriers", EBo = "Vérifiez votre adresse e-mail", TBo = "Vérifier l'e-mail", ABo = "Assistant", CBo = "Envoyer les e-mails de transcription vidéo Cal", zBo = "Envoyer des e-mails avec la transcription de la vidéo Cal après la fin de la réunion. (Nécessite un abonnement payant)", OBo = "Vous avez récemment demandé à changer l'adresse e-mail que vous utilisez pour vous connecter à votre compte {{appName}}. Veuillez cliquer sur le bouton ci-dessous pour confirmer votre nouvelle adresse e-mail.", PBo = "Mise à jour de votre adresse e-mail. Nouvelle : {{email}}", IBo = "Échec de la mise à jour de l'adresse e-mail.", RBo = "Faites vérifier votre nouvelle adresse e-mail {{appName}}", NBo = "Nous avons envoyé un lien de vérification à {{email}}. Nous mettrons à jour votre adresse e-mail une fois que vous aurez cliqué sur ce lien.", DBo = "Sauvegardez cette clé API dans un endroit sûr. Vous ne pourrez plus la revoir.", MBo = "Veuillez vérifier votre adresse e-mail en cliquant sur le bouton ci-dessous.", LBo = "Veuillez vérifier votre adresse e-mail en utilisant le code ci-dessous.", qBo = "Si vous n'aimez pas cliquer sur les boutons, voici le lien :", jBo = "Saisissez le code de vérification", FBo = "Saisissez le code de vérification envoyé à votre adresse e-mail", VBo = "Le code de vérification est incorrect.", BBo = "E-mail envoyé avec succès", UBo = "Une erreur s'est produite lors de l'envoi de l'e-mail", WBo = "Refusé : {{title}} le {{date}}", GBo = "Annulé : {{title}} le {{date}}", HBo = "Réaffecté : {{title}} le {{date}}", KBo = "Votre demande d'événement a été refusée", YBo = "Personnaliser les paramètres de Cal Video", ZBo = "Configurez les préférences de réunion vidéo, y compris les autorisations d'enregistrement pour les hôtes et les participants.", QBo = "Désactiver l'enregistrement pour les invités", JBo = "Activer la transcription automatique après avoir rejoint la réunion", XBo = "Activer l'enregistrement automatique après que l'organisateur rejoint la réunion", eUo = "Options vidéo", tUo = "Modifier l'événement", nUo = "Voir les détails de la session", oUo = "Détails de la session de réunion", rUo = "Session de réunion", iUo = "ID de session", aUo = "Nombre maximum de participants", sUo = "Illimité", cUo = "En cours", lUo = "Terminée", dUo = "Participants", uUo = "Utilisateur anonyme", _Uo = "Durée de la session", pUo = "Aucune session de réunion trouvée", mUo = "Non disponible", fUo = "Désactiver l'enregistrement pour l'organisateur", gUo = "Désactiver la transcription pour les invités", hUo = "Désactiver la transcription pour l'organisateur", vUo = "Votre demande d'événement récurrent a été refusée", bUo = "Votre événement planifié a été annulé", yUo = "Votre événement programmé a été réaffecté", $Uo = "L'événement ne sera plus dans votre calendrier et votre probabilité de round robin ne sera pas affectée négativement", wUo = "Organisateur", kUo = "Réaffecté à", SUo = "Besoin de replanifier ou d'annuler ?", xUo = "Vous pouvez consulter les détails de la réservation à partir de cette URL {{url}} et ajouter l'événement à votre calendrier", EUo = "Aucune option disponible", TUo = "Motif de l'annulation (facultatif)", AUo = "Annulé par", CUo = "Motif d'annulation", zUo = "Pourquoi annulez-vous ?", OUo = "La raison de l'annulation sera partagée avec les invités", PUo = "Pourquoi refusez-vous ?", IUo = "Motif de refus", RUo = "Refuser la demande de réservation ?", NUo = "Voulez-vous vraiment refuser la réservation ? Nous informerons la personne qui a tenté de réserver. Vous pouvez fournir un motif ci-dessous.", DUo = "Refuser la réservation", MUo = "Gérer cet événement", LUo = "Inviter un membre d'équipe", qUo = "Inviter une personne", jUo = "Importation multiple", FUo = "Inv.", VUo = "Votre événement a été planifié", BUo = "Votre événement récurrent a été planifié", UUo = "Acceptez notre licence en changeant la variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> en « {{agree}} ».", WUo = "Pour supprimer cette bannière, veuillez ouvrir votre fichier .env et changer la variable <1>NEXT_PUBLIC_LICENSE_CONSENT</1> en « {{agree}} ».", GUo = "Le message d'erreur était : « {{errorMessage}} »", HUo = "Le remboursement a échoué : {{name}} - {{date}} - {{eventType}}", KUo = "Le remboursement de l'événement {{eventType}} avec {{userName}} le {{date}} a échoué.", YUo = "Veuillez vérifier avec votre fournisseur de paiement et {{user}} comment gérer cela.", ZUo = "Un remboursement a échoué", QUo = "En attente de paiement : {{title}} le {{date}}", JUo = "Votre rendez-vous est en attente de paiement", XUo = "La couleur du thème sombre ne passe pas la vérification du contraste. Nous vous recommandons de modifier cette couleur afin que vos boutons soient plus visibles.", eWo = "La couleur du thème clair ne passe pas la vérification du contraste. Nous vous recommandons de modifier cette couleur afin que vos boutons soient plus visibles.", tWo = "La couleur du thème clair ne passe pas le contrôle de contraste. Nous vous recommandons de changer cette couleur pour que vos types d'événements soient plus visibles.", nWo = "La couleur du thème sombre ne passe pas le contrôle de contraste. Nous vous recommandons de changer cette couleur pour que vos types d'événements soient plus visibles.", oWo = "Le paiement n'a pas pu être créé", rWo = "Impossible de débiter la carte pour le Paiement", iWo = "Aucun utilisateur disponible n'a été trouvé. Pourriez-vous essayer un autre créneau horaire ?", aWo = "Le créneau horaire sélectionné n'est plus disponible. <0>Veuillez sélectionner un nouvel horaire</0>", sWo = "Pris", cWo = "Vous venez de vous connecter. Veuillez réserver parmi les créneaux ci-dessus ou réessayer plus tard.", lWo = "Créneau indisponible", dWo = "Le type d'événement ne peut pas être réservé à ce moment. Pourriez-vous essayer un autre créneau horaire ?", uWo = "Erreur interne. Le corps de la demande ne contient pas l'heure de fin", _Wo = "Impossible de créer un événement de Calendrier dans le calendrier de l'Organisateur", pWo = "Impossible de mettre à jour l'événement de Calendrier.", mWo = "Impossible de supprimer l'événement de Calendrier.", fWo = "Vous êtes déjà inscrit(e) à cette réservation.", gWo = "Certains hôtes sont indisponibles pour la réservation.", hWo = "Certains des hôtes fixes ne sont pas disponibles pour la réservation.", vWo = "L'hôte du tour de rôle n'est pas disponible pour la réservation.", bWo = "Aide", yWo = "Prix", $Wo = "Payé", wWo = "Remboursé", kWo = "Enregistrer", SWo = "Transcrire", xWo = "Paiement", EWo = "Champs de carte manquants", TWo = "Payer maintenant", AWo = "Invite générale", CWo = "Transcription alimentée par l'IA", zWo = "Démarrer ou arrêter l'enregistrement", OWo = "Commencer le message", PWo = "La base de code doit rester open source, qu'elle ait été modifiée ou non", IWo = "Vous ne pouvez pas restructurer ou vendre la base de code", RWo = "Obtenez une licence commerciale pour supprimer ces termes en envoyant un e-mail", NWo = "Résumé des conditions", DWo = "Ouvrez le fichier .env et acceptez notre licence", MWo = "J'ai modifié mon fichier .env", LWo = "Accepter la licence", qWo = "Un événement est toujours en attente de validation", jWo = "La demande d'événement est toujours en attente : {{attendeeName}} - {{date}} - {{eventType}}", FWo = 'Aucun résultat trouvé pour "{{searchTerm}}"', VWo = "Il n'y a plus de résultats", BWo = "Aucun résultat", UWo = "Charger plus de résultats", WWo = "Identifiant du rendez-vous {{integrationName}} : {{meetingId}}", GWo = "Confirmé : {{eventType}} avec {{name}} le {{date}}", HWo = "Nouvelle demande d'événement : {{attendeeName}} - {{date}} - {{eventType}}", KWo = "Confirmer ou refuser la demande", YWo = "Consultez votre page de réservation pour confirmer ou refuser la réservation.", ZWo = "Assistant de vérification", QWo = "Effectue un appel sortant pour vérifier si le rendez-vous prévu convient ou si vous souhaitez le reprogrammer.", JWo = "Créez votre propre invite et utilisez-la pour passer un appel sortant.", XWo = "Un nouvel événement attend votre validation", eGo = "Un événement récurrent attend votre validation", tGo = "Quelqu'un a demandé à planifier un événement sur votre calendrier.", nGo = "Quelqu'un a demandé un lien pour modifier votre mot de passe.", oGo = "Si cette adresse e-mail existe dans notre système, vous devriez recevoir un e-mail de réinitialisation.", rGo = "Si vous n'en avez pas fait la demande, vous pouvez ignorer cet e-mail en toute sécurité et votre mot de passe ne sera pas modifié.", iGo = "En attente de validation : {{title}} le {{date}}", aGo = "Un événement est toujours en attente de votre validation", sGo = "En attente de validation: {{title}} le {{date}}", cGo = "Télécharger l'enregistrement : {{title}} le {{date}}", lGo = "Télécharger l'enregistrement : {{title}} le {{date}}", dGo = "Télécharger votre enregistrement", uGo = "Téléchargez vos transcriptions", _Go = "Votre rendez-vous a été réservé", pGo = "Votre {{title}} a été replanifié le {{date}}", mGo = "Votre {{title}} a été mis(e) à jour.", fGo = "Mise à jour - Votre événement a été replanifié", gGo = "L'événement a été mis à jour", hGo = "Votre événement a été replanifié", vGo = "{{organizer}} a annulé la réservation et vous a demandé de choisir un autre moment.", bGo = "Vous avez demandé à {{attendee}} de replanifier la réservation", yGo = "Vous avez annulé la réservation et {{attendee}} doit choisir un nouveau créneau de réservation.", $Go = "Demande de replanification envoyée : {{eventType}} avec {{name}} le {{date}}", wGo = "Replanification requise : veuillez réserver un nouveau créneau pour {{eventType}} avec {{name}}", kGo = "Bonjour {{name}}", SGo = "{{eventType}} avec {{name}}", xGo = "Il semble que tous nos experts soient occupés pour le moment. Veuillez planifier un appel à un moment qui vous convient le mieux et nous serons prêts à vous aider.", EGo = "Planifier à la place", TGo = "Nouvel événement : {{attendeeName}} - {{date}} - {{eventType}}", AGo = "Rejoindre par {{entryPoint}}", CGo = "Notes", zGo = "Gérer mes réservations", OGo = "Besoin de faire un changement ?", PGo = "Un nouvel événement a été planifié", IGo = "Un nouvel événement récurrent a été planifié", RGo = "E-mail de l'invité", NGo = "Fuseau horaire de l'invité", DGo = "Temps restant", MGo = "Type d'événement", LGo = "Dupliquer le type d'événement", qGo = "Rejoindre le rendez-vous", jGo = "Service d'appel vidéo", FGo = "ID du rendez-vous", VGo = "Mot de passe du rendez-vous", BGo = "Lien du rendez-vous", UGo = "L'URL du rendez-vous est introuvable", WGo = "Jeton introuvable", GGo = "Un autre hôte a déjà accepté la réunion. Souhaitez-vous quand même y participer ? <0>Continuer vers la réunion</0>", HGo = "Votre demande de rendez-vous a été refusée", KGo = "Refusé : {{eventType}} avec {{organizer}} le {{date}}", YGo = "Bonjour", ZGo = "Rejoindre l'équipe", QGo = "Gérer cette équipe", JGo = "Informations sur l'équipe", XGo = "Rejoindre le rendez-vous", eHo = "Si vous préférez ne pas utiliser {{toEmail}} comme votre adresse e-mail {{appName}} ou si vous avez déjà un compte {{appName}}, veuillez demander une autre invitation à cette adresse.", tHo = "Vous avez été invité à rejoindre l'équipe {{teamName}}", nHo = "{{user}} vous a invité à rejoindre l'{{entity}} {{team}} sur {{appName}}", oHo = "Vous êtes masqué dans cette équipe", rHo = "Votre place n'est pas payée, passez au plan Pro ou faites savoir au propriétaire de l'équipe qu'il peut payer votre place.", iHo = "Vous avez besoin d'un compte Pro pour utiliser les équipes, vous êtes masqué jusqu'à ce que vous mettiez à niveau.", aHo = "p.s. Il expire dans {{expiresIn}} heures.", sHo = "Mise à niveau vers la place", cHo = "L'option de places ne prend pas en charge l'exigence de confirmation", lHo = "Plusieurs lieux ne prennent pas en charge l'option de places", dHo = "Les frais d'absence ne prennent pas en charge l'option de places", uHo = "L'option de places ne prend pas en charge plusieurs lieux", _Ho = "Parmi les {{memberCount}} membres de votre équipe, {{unpaidCount}} place(s) sont impayées. À {{seatPrice}} $/mois par place, le coût total estimé de votre abonnement est de {{totalCost}} $/mois.", pHo = "Vous n'avez pas terminé la configuration de votre équipe. Votre équipe « {{teamName}} » doit être mise à niveau.", mHo = "Mettre à niveau", fHo = "Votre équipe a été mise à niveau avec succès !", gHo = "Merci d'avoir testé notre plan Organisation. Nous avons remarqué que votre organisation « {{teamName}} » doit être mise à niveau.", hHo = "Votre organisation a été mise à niveau avec succès !", vHo = "Utilisez le lien ci-dessous pour réinitialiser votre mot de passe", bHo = "Bonjour", yHo = "là", $Ho = "Mot de passe oublié ? - {{appName}}", wHo = "Voulez-vous vraiment supprimer ce webhook ? Vous ne recevrez plus les données de rendez-vous de {{appName}} à un lien spécifié, en temps réel, lorsqu'un événement est planifié ou annulé.", kHo = "Oui, supprimer le webhook", SHo = "Modifier le webhook", xHo = "Supprimer le webhook", EHo = "Statut du webhook", THo = "Webhook activé", AHo = "Webhook désactivé", CHo = "Réponse du webhook", zHo = "Test du webhook", OHo = "Formulaire de mise à jour du webhook", PHo = "Ajoutez un webhook à votre client OAuth.", IHo = "Gérez votre webhook", RHo = "Webhook créé avec succès !", NHo = "Webhook mis à jour avec succès !", DHo = "Webhook supprimé avec succès !", MHo = "Abonnement requis", LHo = "Vous n'êtes pas abonné à un plan Platform.", qHo = "Modèle de charge utile", jHo = "Ignorer", FHo = "Aucune donnée pour l'instant", VHo = "Tester le ping", BHo = "Ajoutez cette application à votre écran d'accueil pour un accès plus rapide et une meilleure expérience.", UHo = "À venir", WHo = "Récurrence", GHo = "Passées", HHo = "Choisir un fichier...", KHo = "Télécharger une image", YHo = "Télécharger un {{target}}", ZHo = "Pas de {{target}}", QHo = "Faites glisser pour zoomer, déplacer pour repositionner", JHo = "Voir les notifications", XHo = "Voir la page publique", eKo = "Copier le lien de la page publique", tKo = "Copier le lien de parrainage", nKo = "Se déconnecter", oKo = "Ajouter un autre", rKo = "Installer une autre", iKo = "jusqu'au", aKo = "propulsé par", sKo = "Indisponible", cKo = "Définissez vos horaires de travail", lKo = "Modifiez vos disponibilités pour les réservations", dKo = "Sélectionner...", uKo = "Texte", _Ko = "Votre numéro de téléphone", pKo = "Zone de texte", mKo = "Nombre", fKo = "Case à cocher", gKo = "Obligatoire", hKo = "Rendre ce champ obligatoire", vKo = "Obligatoire", bKo = "Facultatif", yKo = "Type de champ", $Ko = "Refusé", wKo = "Non confirmées", kKo = "Invités", SKo = "Invité", xKo = "Les détails du rendez-vous sont à retrouver dans l'e-mail de confirmation.", EKo = "Confirmation", TKo = "Ce que votre réservateur doit fournir pour recevoir des confirmations", AKo = "Nom d'utilisateur", CKo = "est toujours disponible.", zKo = "Documentation", OKo = "Découvrez comment intégrer nos outils à votre application", PKo = "Référence API", IKo = "Une référence API complète pour nos bibliothèques", RKo = "Blog", NKo = "Lire nos dernières actualités et articles", DKo = "Rejoignez notre communauté", MKo = "Pages populaires", LKo = "S'inscrire maintenant", qKo = "S'inscrire", jKo = "Cette page n'existe pas.", FKo = "Aucun numéro de téléphone actif disponible", VKo = "Étape de workflow non configurée", BKo = "Vérifiez s'il y a des erreurs d'orthographe ou retournez à la page précédente.", UKo = "Nous n'avons pas pu trouver l'événement que vous essayez de réserver.", WKo = "Commencer", GKo = "Secret", HKo = "Laissez vide pour supprimer le secret.", KKo = "Assurez-vous que votre serveur ne reçoit que les demandes attendues de {{appName}} pour des raisons de sécurité", YKo = "Rendez-vous secret", ZKo = "Se connecter à la place", QKo = "Créer un compte", JKo = "Commencer", XKo = "Confirmer le mot de passe", eYo = "Définissez votre nouveau mot de passe avec les instructions envoyées à votre adresse e-mail.", tYo = "Veuillez télécharger une image d'une largeur de {{width}} et d'une hauteur de {{height}}.", nYo = "Reconnectez-vous avec votre nouvelle adresse e-mail et votre nouveau mot de passe.", oYo = "Créez votre compte", rYo = "Créez votre compte Cal.com", iYo = "S'inscrire", aYo = "Vous avez été déconnecté", sYo = "Nous espérons vous revoir bientôt !", cYo = "Déconnecté", lYo = "Veuillez réessayer et nous contacter si le problème persiste.", dYo = "Le code de double authentification est incorrect.", uYo = "Aucun compte ne correspond à cette adresse email.", _Yo = "Créer un compte", pYo = "Vous n'avez pas de compte ?", mYo = "Connectez-vous à votre compte", fYo = "Se connecter", gYo = "Retour à la page de connexion", hYo = "Une erreur s'est produite lors de votre connexion. Retournez à l'écran de connexion et réessayez.", vYo = "Envoyer l'email de réinitialisation", bYo = "Envoyer l'invitation", yYo = "Mot de passe oublié ?", $Yo = "Oublié ?", wYo = "Terminé", kYo = "Terminé !", SYo = "Tous", xYo = "Votre compte", EYo = "Applications disponibles", TYo = "Applications disponibles", AYo = "Consultez les applications populaires ci-dessous et explorez-en davantage dans notre <0>App Store</0>", CYo = "Ajoutez toute personne qui doit assister à l'événement. <0>En savoir plus</0>", zYo = "Les personnes d'un groupe se relaient, une personne de chaque groupe se présentera à l'événement.", OYo = "Les membres du groupe se relaient et une seule personne se présentera à l'événement.", PYo = "Vérifiez vos e-mails. Nous vous avons envoyé un lien pour réinitialiser votre mot de passe.", IYo = "Terminer", RYo = "Gérez les paramètres de langue et de fuseau horaire de votre équipe.", NYo = "Quelques mots à propos de vous. Ces informations apparaîtront sur votre page publique.", DYo = "C'est bientôt terminé !", MYo = "Dernière chose, une brève description de vous et une photo vous aident vraiment à obtenir des réservations et permettent aux gens de savoir avec qui ils réservent.", LYo = "Définissez des plages de temps pendant lesquelles vous êtes disponible de manière récurrente. Vous pourrez en créer d'autres ultérieurement et les assigner à différents calendriers.", qYo = "Définissez vos disponibilités", jYo = "Définissez des horaires pour les périodes où vous souhaitez être réservé.", FYo = "Partagez un lien ou une intégration", VYo = "Partagez votre lien ou intégration {{appName}} sur votre site.", BYo = "Paramètres de disponibilité", UYo = "Continuer sans calendrier", WYo = "Continuer avec {{appName}}", GYo = "Connectez votre calendrier", HYo = "Connectez vos applications vidéo", KYo = "Connectez vos applications vidéo pour les utiliser sur vos types d'événements.", YYo = "Connectez votre calendrier pour vérifier automatiquement les périodes d'indisponibilité et les nouveaux événements au fur et à mesure qu'ils sont programmés.", ZYo = "Configurer plus tard", QYo = "Heure actuelle", JYo = "Détails", XYo = "Bienvenue", eZo = "Content de vous revoir", tZo = "Bienvenue sur {{appName}}", nZo = "Dites-nous comment vous appeler et indiquez-nous dans quel fuseau horaire vous vous trouvez. Vous pourrez modifier ces informations ultérieurement.", oZo = "Se connecter au serveur CalDAV (Bêta)", rZo = "Connexion à un flux ICS", iZo = "Connecter", aZo = "Essayez gratuitement", sZo = "Créez votre propre lien de réservation avec {{appName}}", cZo = "Qui", lZo = "Quoi", dZo = "Quand", uZo = "Où", _Zo = "Ajouter au calendrier", pZo = "Sélectionnez où ajouter les événements lorsque vous êtes réservé.", mZo = "Ajouter les événements à", fZo = "Ajouter un autre calendrier", gZo = "Autre", hZo = "Votre lien de connexion pour {{appName}}", vZo = "Vous avez rendez-vous avec {{user}}. Nous avons envoyé un e-mail avec une invitation de calendrier comprenant les détails à tout le monde.", bZo = "{{host}} a un rendez-vous avec {{attendee}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants.", yZo = "Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants.", $Zo = "Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", wZo = "Vous avez un rendez-vous avec {{user}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", kZo = "{{host}} a un rendez-vous avec {{attendee}}. Nous avons envoyé un e-mail avec une invitation calendrier contenant tous les détails aux participants pour le premier de ces événements récurrents.", SZo = "Nous avons envoyé cette information à tout le monde par e-mail.", xZo = "Votre réservation doit encore être confirmée ou refusée.", EZo = "Votre rendez-vous récurrent doit encore être confirmé ou refusé.", TZo = "{{user}} doit encore confirmer ou refuser la réservation.", AZo = "{{user}} doit encore confirmer ou refuser chaque réservation du rendez-vous récurrent.", CZo = "Le rendez-vous est planifié", zZo = "Les événements récurrents sont planifiés", OZo = "Votre réservation a été envoyée", PZo = "Votre rendez-vous récurrent a été envoyé", IZo = "Votre réservation a été confirmée", RZo = "Votre rendez-vous récurrent a été confirmé", NZo = "Les paiements ne sont pas encore compatibles avec les événements récurrents", DZo = "Les événements récurrents ne sont pas encore compatibles avec les paiements", MZo = "Saisissez le nouveau mot de passe que vous souhaitez pour votre compte.", LZo = "Réinitialiser le mot de passe", qZo = "Modifier votre mot de passe", jZo = "Afficher le mot de passe", FZo = "Masquer le mot de passe", VZo = "Réessayer", BZo = "Cette requête a expiré.", UZo = "Saisissez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.", WZo = "Cette requête a expiré. Revenez en arrière et saisissez l'adresse e-mail associée à votre compte. Nous vous enverrons un autre lien pour réinitialiser votre mot de passe.", GZo = "Oups", HZo = "Connexion", KZo = "Succès", YZo = "Échoué", ZZo = "Votre mot de passe a été réinitialisé. Vous pouvez désormais vous connecter avec votre nouveau mot de passe.", QZo = "Mise en page", JZo = "Vue par défaut", XZo = "Vous pouvez en sélectionner plusieurs, vos utilisateurs peuvent basculer entre les vues.", eQo = "Mise en page de réservation", tQo = "Vous pouvez en sélectionner plusieurs, les utilisateurs peuvent basculer entre les vues. Cela peut être remplacé individuellement pour événement.", nQo = "Mensuelle", oQo = "Hebdomadaire", rQo = "Colonnes", iQo = "Au moins une mise en page doit être activée.", aQo = "La mise en page sélectionnée comme vue par défaut ne fait pas partie des mises en page activées.", sQo = "La mise en page que vous avez sélectionnée n'est pas une mise en page valide.", cQo = "Vous pouvez gérer cela pour tous vos types d'événements dans Paramètres -> <0>Apparence</0> ou <1>Remplacer</1> pour cet événement uniquement.", lQo = "Une erreur inattendue s'est produite. Veuillez réessayer.", dQo = "Heure non valide le dimanche", uQo = "Créneau invalide le lundi", _Qo = "Créneau invalide le mardi", pQo = "Créneau invalide le mercredi", mQo = "Créneau invalide le jeudi", fQo = "Créneau invalide le vendredi", gQo = "Créneau invalide le samedi", hQo = "L'heure de fin ne peut être antérieure à l'heure de début", vQo = "L'heure de fin ne peut pas être supérieure à 24 heures", bQo = "Retour aux réservations", yQo = "N'hésitez pas à choisir un autre événement à tout moment.", $Qo = "Annulées", wQo = "Aucune réservation", kQo = "En attente de l'hôte", SQo = "Annulation réussie", xQo = "Voulez-vous vraiment annuler votre réservation ?", EQo = "Vous ne pouvez pas annuler cette réservation", TQo = "Au lieu de cela, vous pouvez également le replanifier.", AQo = "L'événement est dans le passé", CQo = "L'événement est une instance d'un événement récurrent.", zQo = "Voici toutes les instances restantes dans l'événement récurrent.", OQo = "Une erreur avec le code de statut {{status}} est survenue.", PQo = "Un type d'événement avec cette URL existe déjà.", IQo = "Vous n'êtes pas autorisé à créer cet événement", RQo = "Vous n'êtes pas autorisé à modifier cet événement", NQo = "Vous n'êtes pas autorisé à créer ce workflow", DQo = "Vous n'êtes pas autorisé à créer ce planning", MQo = "Cette réservation a déjà été annulée", LQo = "Cette réservation a déjà été acceptée ou refusée.", qQo = "Retour à la page d'accueil", jQo = "Retour à la page d'accueil", FQo = "Aucun rendez-vous trouvé", VQo = "Ce rendez-vous n'existe pas. Contactez le propriétaire du rendez-vous pour obtenir un lien mis à jour.", BQo = "Aucune réservation {{status}} pour le moment", UQo = "Vous n'avez pas de réservations {{status}}. {{description}}", WQo = "{{eventName}} entre {{host}} et {{attendeeName}}", GQo = "Réservations", HQo = "Réservation introuvable", KQo = "Consultez les événements à venir et passés réservés via vos liens de type d'événement.", YQo = "Dès que quelqu'un réservera un rendez-vous avec vous, il apparaîtra ici.", ZQo = "Dès que quelqu'un réserve un rendez-vous récurrent avec vous, il apparaît ici.", QQo = "Vos réservations passées apparaîtront ici.", JQo = "Vos réservations annulées apparaîtront ici.", XQo = "Vos réservations non confirmées apparaîtront ici.", eJo = "Réservations non confirmées", tJo = "le", nJo = "et", oJo = "Votre calendrier indique que vous êtes occupé entre", rJo = "Dépannage", iJo = "Comprendre pourquoi certains créneaux sont disponibles et d'autres sont bloquées.", aJo = "Voici un aperçu de votre journée le", sJo = "Astuce : Survolez les heures en gras pour obtenir un horodatage complet.", cJo = "Début", lJo = "Fin", dJo = "Marge de temps", uJo = "Avant l'événement", _Jo = "Après l'événement", pJo = "Aucune marge de temps", mJo = "Intervalle", fJo = "Votre journée commence à", gJo = "Votre journée se termine à", hJo = "Lancer le dépannage", vJo = "Dépannez vos disponibilités pour découvrir pourquoi elles s'affichent comme cela.", bJo = "Changer les horaires de disponibilité", yJo = "Changer vos horaires de disponibilité", $Jo = "Modifier vos heures de début et de fin de journées", wJo = "Définissez l'heure de début et de fin de votre journée ainsi qu'une marge minimum entre vos rendez-vous.", kJo = "Actuellement, votre journée est configurée pour commencer à", SJo = "Les heures de début et de fin de votre journée ont été modifiées avec succès.", xJo = "et se termine à", EJo = "Clair", TJo = "Sombre", AJo = "Ajuster automatiquement l'apparence en fonction des préférences de l'invité", CJo = "Certains utilisateurs du groupe ont actuellement désactivé les réservations de groupe dynamiques", zJo = "Les liens de réservation de groupe peuvent être créés dynamiquement en ajoutant plusieurs noms d'utilisateur séparés par un « + ». Exemple : « {{appName}}/bailey+peer ».", OJo = "Autorisez les participants à prendre rendez-vous avec vous via des réservations de groupe dynamiques.", PJo = "Liens de groupe dynamiques", IJo = "Autorisez les moteurs de recherche à accéder à votre contenu public.", RJo = "Autoriser l'indexation par les moteurs de recherche", NJo = "Autoriser les notifications du navigateur", DJo = "Vous avez refusé les notifications. Réinitialisez l'autorisation dans les paramètres du navigateur pour les activer.", MJo = "Désactiver les notifications du navigateur", LJo = "Notifications du navigateur activées", qJo = "Notifications du navigateur désactivées", jJo = "Notifications du navigateur refusées", FJo = "Veuillez autoriser les notifications dans l'invite", VJo = "Notifications push", BJo = "Recevez des notifications push lorsqu'un utilisateur soumet une réservation de réunion instantanée.", UJo = "Votre navigateur ne prend pas en charge les notifications push. Si vous utilisez Brave, activez l'option 'Utiliser les services Google pour la messagerie push' dans brave://settings/?search=push+messaging", WJo = "E-mail", GJo = "jdoe@exemple.com", HJo = "Nom complet", KJo = "Parcourez la documentation de l'API", YJo = "Profitez de notre API pour tout personnaliser et contrôler.", ZJo = "Créer un webhook", QJo = "Rendez-vous instantané créé", JJo = "Réservation annulée", XJo = "Réservation replanifiée", eXo = "Lien de téléchargement de l'enregistrement prêt", tXo = "Transcription générée", nXo = "Réservation créée", oXo = "Réservation rejetée", rXo = "Réservation demandée", iXo = "Paiement de la réservation initiée", aXo = "Rendez-vous terminé", sXo = "Formulaire envoyé", cXo = "Formulaire soumis, aucun événement réservé", lXo = "Réservation payée", dXo = "Absence créée", uXo = "Absence au rendez-vous mise à jour", _Xo = "Déclencheurs d'événement", pXo = "Lien de l'abonné", mXo = "Créez un nouveau webhook", fXo = "Webhooks", gXo = "Webhooks d’équipe", hXo = "Créez un nouveau webhook sur votre compte", vXo = "Nouveau webhook", bXo = "Recevez les données de rendez-vous {{appName}} à un lien spécifié, en temps réel, lorsqu'un événement est planifié ou annulé.", yXo = "Recevez les données de rendez-vous {{appName}} à un lien spécifié, en temps réel, lorsque cet événement est planifié ou annulé.", $Xo = "iframe plein écran réactif", wXo = "Chargement...", kXo = "Suppression en cours...", SXo = "iframe standard", xXo = "Développeur", EXo = "Gérez vos paramètres de développeur.", TXo = "iframe intégré", AXo = "La façon la plus simple d'intégrer {{appName}} sur votre site web.", CXo = "Intégrez sur votre site web à l'aide de nos options d'intégration ou obtenez des informations sur les réservations en temps réel à l'aide de webhooks personnalisés.", zXo = "Planifier un rendez-vous", OXo = "Consultez et gérez vos informations de facturation.", PXo = "Consultez et modifiez vos informations de facturation, et annulez votre abonnement.", IXo = "Accéder au portail de facturation", RXo = "Besoin d'autre chose ?", NXo = "Si vous avez besoin d'aide pour la facturation, notre équipe d'assistance est là pour vous aider.", DXo = "Contacter", MXo = "notre équipe d'assistance", LXo = "Contactez notre équipe d'assistance", qXo = "Oups !", jXo = "Cet utilisateur n'a pas encore configuré de type d'événement.", FXo = "Modifier le logo", VXo = "Télécharger un logo", BXo = "Télécharger un logo", UXo = "Supprimer le logo", WXo = "Activer", GXo = "Code", HXo = "Le code est incorrect.", KXo = "Ajouter un créneau horaire", YXo = "Ajoutez une sécurité supplémentaire à votre compte en cas de vol de votre mot de passe.", ZXo = "Activer la double authentification", QXo = "Désactiver la double authentification", JXo = "Si vous avez besoin de désactiver la double authentification, nous vous recommandons de la réactiver dès que possible.", XXo = "Erreur lors de la désactivation de la double authentification", eer = "Erreur lors de la configuration de la double authentification", ter = "Sécurité", ner = "Gérez la sécurité de votre compte.", oer = "Mot de passe", rer = "Mot de passe mis à jour avec succès", ier = "Votre mot de passe a été modifié avec succès.", aer = "Erreur lors de la modification du mot de passe", ser = "La configuration de votre session a été mise à jour avec succès.", cer = "Erreur lors de la mise à jour de la configuration de la session", ler = "Une erreur s'est produite.", der = "Quelque chose ne va pas ?", uer = "Veuillez réessayer.", _er = "Votre nouveau mot de passe super sécurisé", per = "Nouveau mot de passe", mer = "Votre ancien mot de passe", fer = "Mot de passe actuel", ger = "Modifier le mot de passe", her = "Changer le secret", ver = "Le nouveau mot de passe est identique à l'ancien. Veuillez choisir un mot de passe différent.", ber = "Vous pouvez modifier ce secret si vous l'avez perdu ou oublié. Soyez cependant conscient que toutes les intégrations l'utilisant devront être mises à jour.", yer = "Le mot de passe actuel est incorrect", $er = "Mélange de lettres majuscules et minuscules", wer = "7 caractères minimum", ker = "Minimum 15 caractères", Ser = "Doit contenir au moins 1 chiffre", xer = "Doit contenir {{limit}} caractères ou moins", Eer = "Le mot de passe doit contenir au moins {{passwordLength}} caractères, un chiffre et un mélange de lettres majuscules et minuscules.", Ter = "Le mot de passe est incorrect.", Aer = "L’adresse e-mail ou le mot de passe est incorrect.", Cer = "Utiliser le paramètre", zer = "AM/PM", Oer = "Options de temps", Per = "Janvier", Ier = "Février", Rer = "Mars", Ner = "Avril", Der = "Mai", Mer = "Juin", Ler = "Juillet", qer = "Août", jer = "Septembre", Fer = "Octobre", Ver = "Novembre", Ber = "Décembre", Uer = "Lundi", Wer = "Mardi", Ger = "Mercredi", Her = "Jeudi", Ker = "Vendredi", Yer = "Samedi", Zer = "Dimanche", Qer = "Tout est réservé.", Jer = "Impossible de charger les créneaux disponibles.", Xer = "Ajouter des invités", etr = "Votre nom", ttr = "Votre nom complet", ntr = "Pas de nom", otr = "Veuillez entrer un nombre entre 1 et {{maxOccurences}}", rtr = "Rapide et facile - aucun compte requis. Parfait pour les réunions ponctuelles.", itr = "Adresse e-mail", atr = "Veuillez saisir une adresse e-mail valide", str = " Veuillez programmer un appel ultérieur si nous ne sommes pas disponibles dans {{seconds}} secondes", ctr = "Lieu", ltr = "Adresse", dtr = "Entrer une adresse", utr = "En personne (adresse du participant)", _tr = "Autre lieu", ptr = "Lieu personnalisé du participant", mtr = "Continuer en tant qu'invité", ftr = "Rejoindre en tant qu'invité", gtr = "Idéal pour les appels ponctuels", htr = "N'importe quel lieu", vtr = "Oui", btr = "Non", ytr = "Notes supplémentaires", $tr = "Le rendez-vous n'a pas pu être réservé.", wtr = "Le rendez-vous n'a pas pu être replanifié.", ktr = "Merci de renseigner tout ce qui aidera à préparer notre rendez-vous.", Str = "Confirmez votre {{eventTypeTitle}} avec {{profileName}}", xtr = "Replanifiez votre {{eventTypeTitle}} avec {{profileName}}", Etr = "Rendez-vous en personne", Ttr = "En personne (adresse de l'organisateur)", Atr = "Rendez-vous avec lien", Ctr = "Numéro de téléphone", ztr = "Numéro de téléphone du participant", Otr = "Numéro de téléphone de l'organisateur", Ptr = "Saisissez votre numéro de téléphone", Itr = "Replanifier", Rtr = "Replanifier à la place", Ntr = "Réserver plutôt un membre de l'équipe", Dtr = "OU", Mtr = "Retour", Ltr = "Adresse e-mail ou identifiant", qtr = "Envoyer une invitation par e-mail", jtr = "Rôle", Ftr = "Modifier le rôle", Vtr = "Voir le rôle", Btr = "Modifier l'équipe", Utr = "Modification de l'utilisateur", Wtr = "Modification de l'organisation", Gtr = "Si vous souhaitez modifier ou gérer vos webhooks, veuillez vous rendre dans les <0>paramètres des webhooks</0>", Htr = "Refuser", Ktr = "Tout refuser", Ytr = "Accepter", Ztr = "Quitter", Qtr = "Profil", Jtr = "Lien de mon équipe", Xtr = "Mes équipes", enr = "Nom de l'équipe", tnr = "Nom de votre équipe", nnr = "Équipe mise à jour avec succès", onr = "Votre équipe a été mise à jour avec succès.", rnr = "Votre organisation a été mise à jour avec succès.", inr = "Erreur lors de la copie dans le presse-papiers", anr = "À propos", snr = "Quelques mots à propos de votre équipe. Ces informations apparaîtront sur la page publique de votre équipe.", cnr = "ID de l'organisation", lnr = "ID de l'organisation copié.", dnr = "Quelques phrases à propos de votre organisation. Elles apparaîtront sur la page de profil public de votre organisation.", unr = "ID de l'équipe", _nr = "ID de l'équipe copié.", pnr = "Membres", mnr = "Membres de l'organisation", fnr = "Membre", gnr = "{{count}} membre", hnr = "{{count}} membres", vnr = "{{count}} sélectionnés", bnr = "Propriétaire", ynr = "Administrateur", $nr = "API admin", wnr = "Utilisateur administrateur", knr = "Nous allons créer le premier utilisateur administrateur.", Snr = "Utilisateur administrateur configuré", xnr = "Vous avez déjà créé un utilisateur administrateur. Vous pouvez maintenant vous connecter à votre compte.", Enr = "Nouveau membre", Tnr = "Inviter", Anr = "Ajouter des membres d'équipe", Cnr = "Ajouter des membres", znr = "Invitez d'autres personnes à rejoindre votre équipe.", Onr = "Ajouter un membre d'équipe", Pnr = "Inviter un nouveau membre d'équipe", Inr = "Remarque : Cela <0>coûtera une place supplémentaire (15 $/mois)</0> sur votre abonnement.", Rnr = "Invitez quelqu'un à rejoindre votre équipe.", Nnr = "Télécharger un fichier .csv", Dnr = "Inviter par e-mail", Mnr = "Changer le rôle du membre de l'équipe", Lnr = "Désactiver les références à la marque {{appName}}", qnr = "Supprimez toutes les références à la marque {{appName}} de vos pages publiques.", jnr = "Masquer le bouton Réserver un membre d'équipe", Fnr = "Masquez le bouton Réserver un membre d'équipe de vos pages publiques.", Vnr = "Zone de danger", Bnr = "Attention. La suppression du compte ne peut pas être annulée.", Unr = "Attention. La suppression de l'équipe ne peut pas être annulée.", Wnr = "Retour", Gnr = "Annuler", Hnr = "Annuler tous les événements restants", Knr = "Appliquer", Ynr = "Annuler l'événement", Znr = "Confirmer", Qnr = "Confirmer tout", Jnr = "Dissoudre l'équipe", Xnr = "Voulez-vous vraiment dissoudre cette équipe ? Toute personne avec qui vous avez partagé ce lien d'équipe ne pourra plus faire de réservation en l'utilisant.", eor = "Dissoudre l'organisation", tor = "Voulez-vous vraiment dissoudre cette organisation ? Toutes les équipes et tous les membres seront supprimés.", nor = "Voulez-vous vraiment supprimer ce membre de l'équipe ?", oor = "Oui, dissoudre l'équipe", ror = "Oui, supprimer le membre", ior = "Oui, annuler l'abonnement", aor = "Annuler l'abonnement", sor = "L'annulation de votre abonnement désactivera définitivement votre forfait actuel. Cette action ne peut pas être annulée.", cor = "Supprimer le membre", lor = "Gérez votre équipe", dor = "Vous n'avez pas encore d'équipe.", uor = "Les équipes permettent aux autres de réserver des événements partagés entre vos collègues.", _or = "Envoyer", por = "Oui, supprimer l'attribut", mor = "Supprimer l'attribut", gor = "Êtes-vous sûr de vouloir supprimer l'attribut '{{name}}' ? Tous les utilisateurs actuellement assignés à cet attribut seront désassignés.", hor = "Mettre à jour", vor = "Enregistrer", bor = "En attente", yor = "Ouvrir les options", $or = "Copier le lien vers l'événement", wor = "Partager", kor = "Voulez-vous réserver mon cal ou m'envoyer votre lien ?", Sor = "Copier le lien vers l'équipe", xor = "Quitter l'équipe", Eor = "Oui, quitter l'équipe", Tor = "Voulez-vous vraiment quitter cette équipe ? Vous ne pourrez plus l'utiliser pour effectuer des réservations.", Aor = "{{user}} de {{team}}", Cor = "Aperçu", zor = "Lien copié !", Oor = "Copié !", Por = "Lien privé copié !", Ior = "Lien partagé !", Ror = "Titre", Nor = "Description", Dor = "Statut des applications", Mor = "Un court rendez-vous vidéo.", Lor = "Type de planification", qor = "Aperçu de l'équipe", jor = "Collective", For = "Planifiez des rendez-vous lorsque tous les membres de l'équipe sélectionnés sont disponibles.", Vor = "Durée", Bor = "Durées disponibles", Uor = "Durée par défaut", Wor = "Veuillez d'abord choisir les durées disponibles", Gor = "{{count}} $t(minute_timeUnit)", Hor = "{{count}} $t({{unit}}_timeUnit)", Kor = "{{count}}$t({{unit}}_short)", Yor = "minutes", Zor = "Utilisez Cal.ai pour obtenir un numéro de téléphone géré par une IA ou pour passer des appels à des invités.", Qor = "URI de terminaison", Jor = "Nom d'utilisateur du trunk SIP", Xor = "Mot de passe du trunk SIP", err = "Surnom", trr = "Supprimer le numéro de téléphone", nrr = "La validation du workflow a échoué", orr = "Un ou plusieurs étapes du workflow ont un contenu de message vide", rrr = "Un ou plusieurs numéros de téléphone ou adresses e-mail ne sont pas vérifiés", irr = "Optimisez vos flux de travail avec Cal.ai", arr = "Des agents IA réalistes qui réservent des réunions, envoient des rappels et assurent le suivi avec vos clients.", srr = "Numéro de téléphone importé et lié à l'agent avec succès", crr = "Numéro de téléphone supprimé avec succès", lrr = "Êtes-vous sûr de vouloir supprimer ce numéro de téléphone ? Cette action ne peut pas être annulée.", drr = "Oui, supprimer le numéro de téléphone", urr = "Le numéro que vous essayez d'importer doit être au format E.164 (indicatif du pays suivi du numéro, sans espaces ni caractères spéciaux), par exemple +1234567890", _rr = "L'URI de terminaison pour identifier de manière unique votre trunk SIP élastique. Il est utilisé pour les appels sortants. Pour les trunks SIP élastiques Twilio, il se termine toujours par .pstn.twilio.com.", prr = "Le nom d'utilisateur utilisé pour authentifier le trunk SIP.", mrr = "Le mot de passe utilisé pour authentifier le trunk SIP.", frr = "Surnom du numéro. Ceci est uniquement pour votre référence.", grr = "Enregistrer et tester l'appel", hrr = "Appel initié avec succès", vrr = "Veuillez saisir un numéro de téléphone", brr = "Agent mis à jour avec succès", yrr = "Agent créé avec succès", $rr = "Type d'événement ajouté avec succès", wrr = "Numéro de téléphone désabonné avec succès", krr = "Cette invite définit le rôle et les objectifs principaux de l'agent", Srr = "Invite", xrr = "Appeler", Err = "Effectuer un appel test pour vérifier la configuration", Trr = "Message initial", Arr = "Le premier message que l'agent dira au début d'un appel", Crr = "Des difficultés à importer ?", zrr = "Apprendre", Orr = "Apprenez comment obtenir votre URI de terminaison et vos identifiants de trunk SIP", Prr = "Abonnement au numéro de téléphone annulé avec succès", Irr = "Mise à jour en cours", Rrr = "Round-robin", Nrr = "Bonjour, comment allez-vous ?", Drr = "Alternez vos rendez-vous entre plusieurs membres d'équipe.", Mrr = "Événement géré", Lrr = "nom d'utilisateur", qrr = "Créez et distribuez plusieurs types d'événements aux membres de l'équipe.", jrr = "Géré", Frr = "« nom d'utilisateur » sera rempli par le nom d'utilisateur des membres assignés", Vrr = "Assigner à", Brr = "Saisissez un numéro de téléphone pour tester l'appel", Urr = "Effectuer un appel test", Wrr = "Créer un nouvel agent vocal cal.ai pour workflow", Grr = "Créez un nouvel agent vocal cal.ai pour automatiser vos workflows", Hrr = "Numéro de téléphone (pour que notre agent puisse appeler)", Krr = "Achetez un numéro de téléphone ou importez-en un que vous possédez déjà sur Twilio", Yrr = "Tester l'agent", Zrr = "Tester l'appel web", Qrr = "Numéros de téléphone", Jrr = "Se désabonner", Xrr = "Supprimer l'étape du workflow", eir = "Désabonner le numéro de téléphone", tir = "Acheter un nouveau numéro", nir = "Vous ne pouvez acheter que des numéros de téléphone américains. Pour les autres pays, vous pouvez importer votre propre numéro Twilio.", oir = "Acheter un numéro américain pour ${{priceInDollars}} par mois", rir = "Destinations d'appel prises en charge", iir = "Aucun numéro de téléphone connecté", air = "Échec de récupération de l'ID de l'étape du workflow", sir = "Agent Cal.ai", cir = "Tester l'agent Cal.ai", lir = "Êtes-vous sûr de vouloir supprimer cette étape du workflow ?", dir = "Voulez-vous toujours désabonner ce numéro de téléphone de cet agent ?", uir = "Cette action déconnectera le numéro de téléphone de l'agent. L'agent ne pourra pas passer d'appels tant qu'un nouveau numéro de téléphone ne sera pas connecté.", _ir = "Numéros de téléphone", pir = "Connecter un numéro de téléphone", mir = "Gérez vos numéros de téléphone", fir = "Importer un numéro", gir = "Cette action va également :", hir = "Importer un numéro de téléphone", vir = "Abonnement actif", bir = "Annuler votre abonnement de numéro de téléphone", yir = "Supprimer le numéro de téléphone associé", $ir = "Vous n'êtes pas autorisé à créer ce workflow", wir = "Importez votre numéro de téléphone Twilio pour l'utiliser avec Phone", kir = "${{price}}/mois", Sir = "Acheter un nouveau numéro", xir = "L'achat d'un numéro de téléphone coûte ${{priceInDollars}} par mois. Vous serez facturé mensuellement pour chaque numéro de téléphone actif.", Eir = "Indicatif régional (facultatif)", Tir = "Aucun numéro de téléphone", Air = "Numéro de téléphone acheté avec succès", Cir = "Annuler l'abonnement au numéro de téléphone", zir = "Oui, annuler l'abonnement", Oir = "Êtes-vous sûr de vouloir annuler cet abonnement au numéro de téléphone ? Cette action ne peut pas être annulée et vous perdrez l'accès à ce numéro de téléphone.", Pir = "Ajouter des membres...", Iir = "Ajouter des membres", Rir = "Aucun membre assigné", Nir = "Assigné à", Dir = "Vous devez être connecté(e) à {{url}}", Mir = "Commencez à assigner des membres ci-dessus", Lir = "Les membres ne pourront pas modifier ceci.", qir = "Les membres peuvent modifier", jir = "Cette option a été verrouillée par l'administrateur de l'équipe.", Fir = "Déverrouillé par l'administrateur de l'équipe", Vir = "Lien", Bir = "Masqué", Uir = "Lecture seule", Wir = "Lien à usage unique", Gir = "Vous êtes actuellement sur le plan {{plan}}.", Hir = "Mettez à niveau votre compte vers le plan Pro pour débloquer toutes les fonctionnalités que nous avons à proposer.", Kir = "Vous devez mettre à niveau votre plan pour avoir plus d'un type d'événement actif.", Yir = "Vous devez mettre à niveau votre plan pour créer une équipe.", Zir = "Vous pouvez <1>mettre à niveau ici</1>.", Qir = "Types d'évènements", Jir = "Créez des événements à partager pour que les personnes puissent réserver des créneaux sur votre calendrier.", Xir = "Nouveau type d'événement", ear = "Créez votre premier type d'événement", tar = "Les types d'événements vous permettent de partager des liens qui affichent vos disponibilités sur votre calendrier et permettent aux personnes de réserver des créneaux.", nar = "{{eventTypeTitle}} type d'événement créé avec succès", oar = "{{eventTypeTitle}} type d'événement mis à jour avec succès", rar = "Type d'événement supprimé avec succès", iar = "heures", aar = "Personnes", sar = "Votre adresse e-mail", car = "Changer d'avatar", lar = "Télécharger un avatar", dar = "Langue", uar = "Fuseau horaire", _ar = "Premier jour de la semaine", par = "Répéter jusqu'à {{count}} fois", mar = "Répéter jusqu'à {{count}} fois", far = "Chaque {{freq}} pour", gar = "{{count}} événement restant", har = "{{count}} événements restants", bar = "Répéter chaque", yar = "occurrence", $ar = "occurrences", war = "semaine", kar = "semaines", Sar = "mois", xar = "mois", Ear = "année", Tar = "années", Aar = "{{count}} de plus", Car = "max.", zar = "Thème unique", Oar = "Couleur de la marque", Par = "Couleur de la marque (clair)", Iar = "Couleur de la marque (sombre)", Rar = "Couleur du type d'événement (Thème clair)", Nar = "Couleur du type d'événement (Thème sombre)", Dar = "Le fichier n'est pas nommé [idOrSlug]/[user]", Mar = "Créer une équipe", Lar = "Nom", qar = "Équipe sans nom", jar = "Clients OAuth", Far = "Gérer les clients OAuth pour votre organisation", Var = "Créer un client OAuth", Bar = "Créer un nouveau client OAuth pour les intégrations tierces", Uar = "Client OAuth supprimé avec succès", War = "Créez une nouvelle équipe pour collaborer avec les utilisateurs.", Gar = "Créer une nouvelle équipe", Har = "URL de votre page de réservation", Kar = "URL de la page où vos utilisateurs peuvent annuler leur réservation", Yar = "URL de la page où vos utilisateurs peuvent replanifier leur réservation", Zar = "Ce créneau n'est plus disponible. Veuillez revenir à la page précédente et sélectionner un autre horaire.", Qar = "Invitations ouvertes", Jar = "Nouvelle équipe", Xar = "Créez votre première équipe et invitez d'autres utilisateurs à travailler ensemble.", esr = "Créez une équipe pour commencer", tsr = "Équipes", nsr = "Équipe", osr = "Organisation", rsr = "Facturation de l'équipe", isr = "Gérez la facturation pour votre équipe.", asr = "Nous avons modifié la facturation pour les équipes", ssr = "Des membres dans votre équipe n'ont pas de place. Mettez à niveau votre plan Pro pour couvrir les places manquantes.", csr = "Depuis janvier 2022, nous facturons chaque place aux membres de l'équipe. Les membres de votre équipe qui ont eu le plan Pro gratuitement disposent maintenant d'un essai de 14 jours. Une fois leur période d'essai expirée, ces membres seront masqués pour votre équipe sauf si vous mettez à niveau maintenant.", lsr = "Créez et gérez des équipes pour utiliser les fonctionnalités collaboratives.", dsr = "Cette fonctionnalité n'est disponible que dans le plan Pro", usr = "Pour supprimer les références à la marque {{appName}} de vos pages de réservation, vous devez passer à un compte Pro.", _sr = "Modifiez les informations de votre profil, qui apparaissent sur votre lien de réservation.", psr = "Vous devrez peut-être vous reconnecter pour que la modification prenne effet.", msr = "Quelque mots à propos de vous.", fsr = "Profil mis à jour avec succès", gsr = "Votre profil utilisateur a été mis à jour avec succès.", hsr = "Votre mise à niveau est disponible", vsr = "Améliorez votre expérience de planification en passant au nouveau plan et profitez des nouvelles fonctionnalités.", bsr = "Tout est prêt", ysr = "Vous disposez déjà du dernier plan. Aucune mise à niveau nécessaire. Profitez des nouvelles fonctionnalités et contactez-nous pour toute question !", $sr = "L'utilisateur semble connecté, mais est introuvable dans la base de données.", wsr = "Intégrations et webhooks", ksr = "Activé", Ssr = "Désactivé", xsr = "Désactiver", Esr = "Facturation", Tsr = "ici", Asr = "Gérez vos informations de facturation et annulez votre abonnement.", Csr = "Disponibilités", zsr = "Modifier les disponibilités", Osr = "Définissez les moments où vous êtes disponible pour les réservations.", Psr = "Copier les créneaux vers", Isr = "Copier les horaires dans…", Rsr = "Modifier votre planning hebdomadaire", Nsr = "Logo", Dsr = "Erreur", Msr = "Veuillez saisir au moins un caractère", Lsr = "Veuillez saisir au moins {{count}} caractères", qsr = "Logo de l'équipe", jsr = "Ajouter un lieu", Fsr = "Participants", Vsr = "Ajouter des participants", Bsr = "Afficher les paramètres avancés", Usr = "Masquer les paramètres avancés", Wsr = "Nom de l'événement", Gsr = "Nom de l'événement dans le calendrier", Hsr = "Le nom qui apparaîtra dans les calendriers", Ksr = "{Event type title} entre {Organiser} et {Scheduler}", Ysr = "Champs supplémentaires", Zsr = "Exiger que le planificateur saisisse des champs supplémentaires avant la confirmation de la réservation.", Qsr = "Libellé", Jsr = "Texte de substitution", Xsr = "Afficher l'e-mail « Ajouter au calendrier » en tant qu'organisateur", ecr = "Nous afficherons cette adresse e-mail en tant qu'organisateur et enverrons les e-mails de confirmation à cette adresse.", tcr = "Si cette option est activée, nous afficherons l'adresse e-mail de votre « Ajouter au calendrier » en tant qu'organisateur et nous enverrons des e-mails de confirmation à cette adresse", ncr = "Veuillez noter que vous devrez peut-être vous déconnecter puis reconnecter votre compte 'Ajouter au calendrier' pour utiliser cette fonctionnalité.", ocr = "Type", rcr = "Modifier", icr = "Ajouter un champ", acr = "Masquer les notes dans le calendrier", scr = "Pour des raisons de confidentialité, les champs et notes supplémentaires seront masquées dans l'entrée du calendrier. Elles vous seront tout de même envoyées par e-mail.", ccr = "La réservation doit être confirmée manuellement avant d'être poussée vers les intégrations et qu'un e-mail de confirmation soit envoyé.", lcr = "Les réservations non confirmées bloquent quand même les créneaux du calendrier.", dcr = "Événement récurrent", ucr = "Les personnes peuvent s'inscrire à des événements récurrents.", _cr = "Se connecter et rejoindre", pcr = "À ne pas utiliser avec les types d'événement payants", mcr = "Les Rendez-vous instantanés ne sont pas encore pris en charge par les événements récurrents et les applications de paiement", fcr = "Expérimental : Les événements de Rendez-vous instantané sont actuellement expérimentaux.", gcr = "Début", hcr = "Désactiver les invités", vcr = "Désactivez l'ajout d'invités supplémentaires lors de la réservation.", bcr = "Générer un lien privé", ycr = "Rendre le lien privé", $cr = "Lien privé", wcr = "Votre lien privé sera régénéré après chaque utilisation", kcr = "Copier le lien privé", Scr = "Copier le lien privé de l'événement", xcr = "Générez un lien privé à partager sans révéler votre nom d'utilisateur {{appName}}.", Ecr = "Liens privés", Tcr = "Générer des URL privées sans exposer le nom d'utilisateur, avec des limites d'expiration et d'utilisation configurables", Acr = "Ajouter un nouveau lien", Ccr = "Lien privé copié", zcr = "Les invités peuvent réserver", Ocr = "Plage de dates", Pcr = "jours calendaires", Icr = "jours ouvrés", Rcr = "Définir une adresse ou un lieu", Ncr = "Définir un lien vers le rendez-vous", Dcr = "Ne peut pas être modifié. Il ne peut être déverrouillé que pour les types d'événements enfants", Mcr = "{{appName}} demandera à votre invité d'entrer un numéro de téléphone avant de faire une réservation.", Lcr = "{{appName}} fournira un lien Google Meet.", qcr = "{{appName}} fournira un lien de rendez-vous Zoom.", jcr = "{{appName}} fournira un lien de rendez-vous Tandem.", Fcr = "{{appName}} fournira un lien de rendez-vous vidéo.", Vcr = "Nous générerons un lien de réunion Jitsi Meet pour vous.", Bcr = "{{appName}} fournira un lien de rendez-vous vidéo Huddle01.", Ucr = "{{appName}} fournira un lien de rendez-vous MS Teams. NOTE : IL FAUT AVOIR UN COMPTE PROFESSIONNEL OU SCOLAIRE", Wcr = "Exiger un paiement", Gcr = "Vous devez ajouter un nom", Hcr = "commission par transaction", Kcr = "Votre type d'événement a été mis à jour avec succès.", Ycr = "Masquer le type d'événement", Zcr = "Modifier le lieu", Qcr = "dans le futur", Jcr = "Lorsque réservé avec moins de <0></0> de préavis", Xcr = "Dans une plage de dates", elr = "Indéfiniment dans le futur", tlr = "Ajouter un nouveau champ personnalisé", nlr = "Conversation rapide", olr = "Ajouter un nouveau type d'événement d'équipe", rlr = "Ajouter un nouveau type d'événement", ilr = "Créez un nouveau type d’événement pour que les personnes puissent effectuer des réservations.", alr = "Durée", slr = "Préavis minimum", clr = "Décalage de l'heure de début", llr = "Appliquez un décalage de durée spécifique aux créneaux horaires affichés aux utilisateurs.", dlr = "Décalage de", ulr = "p. ex. cela affichera les créneaux à vos utilisateurs à {{ adjustedTime }} au lieu de {{ originalTime }}", _lr = "Fréquence de créneaux horaires", plr = "Utiliser la durée de l'événement (par défaut)", mlr = "Supprimer le type d'événement ?", flr = "Supprimer le type d'événement géré ?", glr = "Toute personne avec qui vous avez partagé ce lien ne pourra plus réserver avec.", hlr = "Les membres assignés à ce type d'événement verront également leurs types d'événements supprimés.", vlr = "Toute personne avec qui ils ont partagé leur lien ne pourra plus réserver en l'utilisant.", blr = "Oui, supprimer", ylr = "Supprimer le compte", $lr = "Oui, supprimer le compte", wlr = "Toute personne avec qui vous avez partagé le lien de votre compte ne pourra plus réserver en utilisant ce lien et toutes les préférences que vous avez sauvegardées seront perdues.", klr = "Intégrations", Slr = "Applications", xlr = "Vous trouverez ici une liste de vos applications.", Elr = "Liste des applications", Tlr = "Applications {{category}}", Alr = "App Store", Clr = "Connecter les personnes, la technologie et l'espace de travail.", zlr = "Connectez votre application de visioconférence", Olr = "Paramètres", Plr = "Le type d'événement a été déplacé avec succès", Ilr = "Prochaine étape", Rlr = "Passer l'étape", Nlr = "Étape précédente", Dlr = "Installer", Mlr = "Démarrer l'essai gratuit", Llr = "Installée", qlr = "{{count}} installation active", jlr = "{{count}} installations actives", Flr = "Installée globalement", Vlr = "Application installée avec succès", Blr = "L'application n'a pas pu être installée", Ulr = "Déconnecter", Wlr = "Intégrez votre calendrier dans votre page web", Glr = "Connectez vos applications favorites.", Hlr = "Automatisation", Klr = "Configurez la manière dont vos types d'événements doivent interagir avec vos calendriers.", Ylr = "Activez/désactivez les calendriers pour lesquels vous souhaitez vérifier les conflits afin d'éviter les doubles réservations.", Zlr = "Connecter un calendrier supplémentaire", Qlr = "Calendrier mis à jour avec succès", Jlr = "Vérifier ici", Xlr = "Visioconférence", edr = "Calendrier", tdr = "Paiements", ndr = "Non installé", odr = "Les mots de passe ne correspondent pas.", rdr = "Ce champ est obligatoire.", idr = "Statut", adr = "Voir les disponibilités de l'utilisateur", sdr = "L'utilisateur doit accepter l'invitation pour voir les disponibilités", cdr = "Se définir comme absent", ldr = "Désactiver le statut absent", ddr = "Erreur lors de la mise à jour du statut d'absence", udr = "Cet utilisateur est actuellement absent.", _dr = "La personne avec qui vous essayez de prendre rendez-vous est absente et n'accepte donc pas de nouvelles réservations.", pdr = "Rencontrez des personnes avec les mêmes tokens", mdr = "Réservez et autorisez uniquement les réservations de personnes qui partagent les mêmes tokens, DAO ou NFT.", fdr = "Votre compte a été créé à l'aide d'un fournisseur d'identité.", gdr = "Votre compte est géré par {{provider}}", hdr = "Pour modifier votre adresse e-mail et/ou votre mot de passe, activez l'authentification à deux facteurs et plus, veuillez consulter les paramètres de votre compte {{provider}}.", vdr = "Votre compte est géré par un fournisseur d'identité différent. Essayez de vous connecter avec {{provider}}.", bdr = "Erreur lors de la création d'un nouvel utilisateur. Veuillez réessayer.", ydr = "Se connecter avec Google", $dr = "Se connecter avec SAML", wdr = "Se connecter avec SAML/OIDC", kdr = "Continuer avec l'e-mail", Sdr = "Continuer avec Google", xdr = "Dernière utilisation", Edr = "Vous devrez générer un token d'accès à partir de votre ancien outil de planification.", Tdr = "Importer depuis", Adr = "Token d'accès", Cdr = "Feuille de route", zdr = "Catégories en vedette", Odr = "Drapeaux de fonctionnalités", Pdr = "Ici, vous pouvez activer ou désactiver les fonctionnalités de votre instance Cal.com.", Idr = "Catégories populaires", Rdr = "{{count}} Application", Ndr = "{{count}} applications", Ddr = "Applications populaires", Mdr = "Les plus populaires", Ldr = "Apps installées", qdr = "Gratuit", jdr = "Aucune application {{category}}", Fdr = "Toutes les apps", Vdr = "Ajoutez une application de calendrier pour vérifier les conflits et éviter les doubles réservations.", Bdr = "Essayez d'ajouter une application de visioconférence pour les appels vidéo avec vos clients.", Udr = "Ajoutez une application de paiement pour faciliter les transactions entre vous et vos clients.", Wdr = "Ajoutez une application d'analyse pour vos pages de réservation.", Gdr = "Ajoutez une application d'automatisation.", Hdr = "Ajoutez n'importe quel autre type d'application pour faire toutes sortes de choses.", Kdr = "Ajoutez une application de messagerie pour configurer des notifications et des rappels personnalisés.", Ydr = "Ajoutez une application de CRM pour garder une trace des personnes que vous avez rencontrées.", Zdr = "Définissez les calendriers pour vérifier les conflits afin d'éviter les doubles réservations.", Qdr = "Configurez les services de traitement de paiement à utiliser lors de la facturation de vos clients.", Jdr = "Configurez les applications d'analyse à utiliser pour vos pages de réservation.", Xdr = "Toutes vos applications installées à partir d'autres catégories.", eur = "Configurez les applications de conférence à utiliser.", tur = "Configurez les applications d'automatisation à utiliser.", nur = "Configurez les applications de messagerie à utiliser pour configurer des notifications et des rappels personnalisés.", our = "Configurez les applications de CRM à utiliser pour garder une trace des personnes que vous avez rencontrées.", rur = "Analytiques", iur = "Aucune application installée", aur = "Les applications vous permettent d'améliorer votre workflow et votre processus de planification de façon significative.", sur = "Explorer l'App Store", cur = "Gérez vos applications installées ou modifiez les paramètres.", lur = "Parcourir les applications", dur = "Fonctionnalités", uur = "Permissions", _ur = "Conditions et confidentialité", pur = "Publiée par {{author}}", mur = "S'abonner", fur = "Acheter", gur = "Installer l'application", hur = "Catégories", vur = "Prix", bur = "En savoir plus", yur = "Essayer maintenant", $ur = "Politique de confidentialité", wur = "Conditions d'utilisation", kur = "Supprimer", Sur = "Ajouter", xur = "{{count}} installation(s)", Eur = "Vérifier le portefeuille", Tur = "Créer des événements dans :", Aur = "Ceci est une fonctionnalité commerciale", Cur = "Vous pouvez tester cette fonctionnalité en local, mais pas en production.", zur = "Pour acheter une licence commerciale, veuillez contacter notre équipe commerciale. Si une clé de licence est déjà en place, veuillez contacter support@cal.com pour obtenir de l'aide.", Our = "Licence manquante", Pur = "Prochaines étapes", Iur = "Obtenir une licence commerciale", Rur = "Le plan d'infrastructure est basé sur l'utilisation et propose des réductions adaptées aux startups.", Nur = "Créer un compte via Prisma Studio", Dur = "Découvrez comment configurer votre premier utilisateur", Mur = "Contacter le service commercial", Lur = "Erreur 404", qur = "Définir par défaut", jur = "Nouveau planning", Fur = "Ajouter un nouveau planning", Vur = "Ajouter un nouveau calendrier", Bur = "Définissez où ajouter les nouveaux événements après une réservation.", Uur = "Supprimer le planning", Wur = "La suppression d'un planning l'enlèvera de tous les types d'événements. Cette action ne peut pas être annulée.", Gur = "Planning {{scheduleName}} créé avec succès", Hur = "Planning {{scheduleName}} mis à jour avec succès", Kur = "Planning supprimé avec succès", Yur = "Heures de travail", Zur = "Créer un planning de disponibilité", Qur = "La création de plannings de disponibilité vous permet de gérer la disponibilité pour tous les types d'événements. Ils peuvent être appliqués à un ou plusieurs types d'événements.", Jur = "Nécessite la propriété d'un token appartenant à l'adresse suivante :", Xur = "Jean Dupont", e_r = "Format horaire", t_r = "Rediriger après la réservation", n_r = 'Vous allez être redirigé vers {{ url }} dans $t(second, {"count": {{seconds}} }).', o_r = "https://example.com/redirect-to-my-success-page", r_r = "Redirigez l'utilisateur vers un lien personnalisé après une réservation réussie.", i_r = "Dupliquer", a_r = "Proposer des places", s_r = "Proposez des places de réservation. Cela désactive automatiquement les réservations d'invités et d'opt-in.", c_r = "Place disponible", l_r = "Places disponibles", d_r = "Places presque toutes occupées", u_r = "Les places partent vite", __r = "Nombre de places par réservation", p_r = "Définir la fenêtre de participation à la réunion (secondes) : La période en secondes pendant laquelle l'hôte peut rejoindre et démarrer la réunion. Après cette période, l'URL de participation à la réunion expirera.", m_r = "Saisir le nombre de places", f_r = "Vous pouvez gérer vos disponibilités sur la page Disponibilité.", g_r = "Plus de places disponibles", h_r = "Clés API", v_r = "Clé API", b_r = "Tester la clé API", y_r = "Test réussi !", $_r = "Échec du test", w_r = "Fournir une clé d'API", k_r = "Les clés API vous permettent d'effectuer des appels API pour votre propre compte.", S_r = "Créez plutôt une place de marché ou une plateforme.", x_r = "Générer des clés API à utiliser pour accéder à votre propre compte.", E_r = "Créer une clé API", T_r = "Nommer cette clé", A_r = "Par exemple : développement", C_r = "Clé API sans nom", z_r = "Cette clé API n'a pas de date d'expiration", O_r = "Modifier la clé API", P_r = "Clé API créée avec succès", I_r = "Clé API mise à jour avec succès", R_r = "Créer", N_r = "Enregistrez cette clé API dans un endroit sûr.", D_r = "Vous ne pourrez plus la revoir après avoir fermé cette boîte de dialogue.", M_r = "Copier dans le presse-papiers", L_r = "Activée après mise à jour", q_r = "Le lien privé fonctionnera après l'enregistrement", j_r = "Révoquer cette clé API", F_r = "Désactiver le report", V_r = "Les invités ne peuvent plus reporter l'événement via l'invitation au calendrier ou l'e-mail", B_r = "Autoriser la réservation via le lien de replanification", U_r = "Lorsque cette option est activée, les utilisateurs pourront créer une nouvelle réservation lorsqu'ils essaient de reprogrammer une réservation annulée", W_r = "Désactiver l'annulation", G_r = "Les invités ne peuvent plus annuler l'événement via l'invitation au calendrier ou l'e-mail", H_r = "Révoquer la clé API", K_r = "Clé API copiée !", Y_r = "La clé API expirera le", Z_r = "Supprimer définitivement cette clé API de votre compte ?", Q_r = "Copier", J_r = "Date d'expiration", X_r = "Expirée", epr = "N'expire jamais", tpr = "Expire", npr = "Demander une replanification de votre réservation", opr = "Raison de la replanification", rpr = "Réserver un nouveau créneau", ipr = "Demande de replanification envoyée", apr = "Ceci annulera le rendez-vous planifié et demandera à l'invité de choisir un nouveau créneau.", spr = "Raison de la demande de replanification", cpr = "Demander une replanification ", lpr = "Modifier la réservation", dpr = "Replanifier la réservation", upr = "Ancien créneau", _pr = "Ajouter un GIF à la page de confirmation", ppr = "Rechercher", mpr = "Emprunt d'identité", fpr = "Emprunt d'identité", gpr = "Autorisez notre équipe d'assistance à se connecter temporairement à votre place pour nous aider à résoudre les problèmes que vous pourriez nous signaler.", hpr = "Autorisez les propriétaires/administrateurs de votre équipe à se connecter temporairement à votre place.", vpr = "Gratuit pour les particuliers. Plans Équipes pour les fonctionnalités collaboratives.", bpr = "Rendre l'organisation privée", ypr = "Les membres de votre organisation ne pourront pas voir les autres membres de l'organisation lorsque cette option est activée.", $pr = "Rendre l'équipe privée", wpr = "Les membres de votre équipe ne pourront pas voir les autres membres de l'équipe si cette option est activée.", kpr = "Vous ne pouvez pas voir tous les membres d'une équipe privée.", Spr = "Vous ne pouvez pas voir les équipes d'une organisation privée.", xpr = "Autoriser plusieurs durées", Epr = "Toutes les utilisations de cette fonctionnalité sont vérifiées.", Tpr = "Emprunt du nom d'utilisateur « {{user}} ».", Apr = "Cliquez ici pour arrêter", Cpr = "Mise à jour - Votre événement a changé de lieu", zpr = "Ajoutés - Nouveaux invités ajoutés à votre événement", Opr = "Lieu modifié : {{eventType}} avec {{name}} le {{date}}", Ppr = "Invités ajoutés : {{eventType}} avec {{name}} le {{date}}", Ipr = "Lieu actuel", Rpr = "Nouveau lieu", Npr = "Session", Dpr = "Contrôlez la session de votre compte.", Mpr = "Expiration de la session après", Lpr = "Expiration de la session", qpr = "Invalidez votre session après un certain temps.", jpr = "Aucun lieu défini", Fpr = "Définir le lieu", Vpr = "Mettre à jour le lieu", Bpr = "Lieu mis à jour", Upr = "La mise à jour du lieu a échoué", Wpr = "Invités ajoutés", Gpr = "Impossible d'ajouter des invités", Hpr = "Ceci ne ressemble pas à une adresse e-mail", Kpr = "Les adresses e-mail doivent être uniques et valides", Ypr = "Cela ne ressemble pas à une URL valide", Zpr = "Placez ce code dans votre HTML à l'endroit où vous souhaitez que votre widget {{appName}} apparaisse.", Qpr = "Créez ou mettez à jour un composant React existant comme indiqué ci-dessous.", Jpr = "Copier le code", Xpr = "Code copié !", emr = "Comment souhaitez-vous ajouter {{appName}} à votre site ?", tmr = "Choisissez l'une des méthodes suivantes pour mettre {{appName}} sur votre site.", nmr = "Configuration de votre intégration Zapier", omr = "Configuration de votre intégration Make", rmr = "Générer une clé API", imr = "Générer une clé API à utiliser avec {{appName}} sur", amr = "Votre clé API unique", smr = "Copiez cette clé API et conservez-la dans un endroit sûr. Si vous perdez cette clé, vous devrez en générer une nouvelle.", cmr = "<0>Connectez-vous à votre compte Zapier et créez un nouveau Zap.</0><1>Sélectionnez Cal.com comme application déclencheur. Choisissez également un événement déclencheur.</1><2>Choisissez votre compte, puis saisissez votre clé API unique.</2><3>Testez votre déclencheur.</3><4>Vous êtes prêt !</4>", lmr = "Accédez à <0>Make Invite Link</0> et installez l'application Cal.com.", dmr = "Connectez-vous à votre compte Make et créez un nouveau scénario.", umr = "Sélectionnez Cal.com comme application déclencheur. Choisissez également un événement déclencheur.", _mr = "Choisissez votre compte puis saisissez votre clé API unique.", pmr = "Testez votre déclencheur.", mmr = "Vous êtes prêt !", fmr = "Veuillez d'abord installer l'application Zapier dans l'App Store.", gmr = "Veuillez d'abord installer l'application Make dans l'App Store.", hmr = "Installation de l'application", vmr = "Application non installée", bmr = "Désolé, cette application n'est pas installée sur votre compte. Veuillez visiter notre boutique d'applications pour explorer et découvrir celle-ci et d'autres applications intéressantes.", ymr = "Se connecter au serveur d'Apple", $mr = "Lien du calendrier", wmr = "Générez un mot de passe pour application à utiliser avec {{appName}} sur", kmr = "Impossible d'ajouter ce compte Apple Calendar. Veuillez vous assurer que vous utilisez un mot de passe spécifique à l'application plutôt que le mot de passe de votre compte.", Smr = "Vos identifiants seront stockés et chiffrés.", xmr = "Elle sera stockée et chiffrée.", Emr = "Accéder à l'App Store", Tmr = "Une erreur est survenue, essayez de reconnecter votre calendrier avec toutes les autorisations nécessaires", Amr = "Définir un numéro de téléphone pour le rendez-vous", Cmr = "Aucun créneau n'est occupé", zmr = "Afficher sur la page de réservation", Omr = "Le lieu sera visible avant la confirmation de la réservation", Pmr = "Ajouter un GIF", Imr = "Rechercher dans Giphy", Rmr = "Ajouter un lien depuis Giphy", Nmr = "Ajout d'un GIF à la page de confirmation", Dmr = "Trouvez un GIF pour agrémenter votre page de confirmation", Mmr = "Partagez vos commentaires", Lmr = "Ressources", qmr = "Documentation d'assistance", jmr = "Documentation pour développeurs", Fmr = "Contactez-nous", Vmr = "Contacter l'assistance", Bmr = "Assistance Premium", Umr = "Aide communautaire", Wmr = "Commentaires", Gmr = "Merci pour vos commentaires !", Hmr = "Erreur lors de l'envoi du commentaire", Kmr = "Partagez vos commentaires ici :", Ymr = "Informations sur la réservation", Zmr = "ou", Qmr = "Annuler", Jmr = "Aller à : ", Xmr = "Lien d'invitation Zapier", efr = "Un lien de rendez-vous sera créé une fois l'événement confirmé.", tfr = "Affiche dynamiquement le nom du participant pour vous ou votre nom s'il est vu par le participant", nfr = "Lieu de l'événement", ofr = "Raison de la replanification (facultatif)", rfr = "Faites savoir aux autres pourquoi vous devez replanifier le rendez-vous.", ifr = "Cet événement est annulé", afr = "Nous avons envoyé un e-mail à tout le monde pour les en informer.", sfr = "Ce champ sera affiché lors de la réservation de cet événement.", cfr = "Le lien du rendez-vous est dans l'e-mail de confirmation", lfr = "Le lien doit commencer par http:// ou https://", dfr = "Un numéro de téléphone sera fourni", ufr = "avant le début de l'événement", _fr = "lorsque l'événement est annulé", pfr = "Après que les hôtes ne se sont pas connectés à l'appel vidéo", mfr = "Après que les invités ne se sont pas connectés à l'appel vidéo", ffr = "Rejoindre l'appel vidéo", gfr = "Se connecter à Cal.com", hfr = "Connectez-vous à Cal.com", vfr = "Suivez vos réunions, recevez des notifications et gérez votre emploi du temps plus efficacement.", bfr = "Suivez vos réunions et gérez votre emploi du temps plus efficacement", yfr = "Échec de la connexion à l'appel. Veuillez réessayer.", $fr = "Choisissez comment vous souhaitez rejoindre cet appel", wfr = "Choisissez comment vous souhaitez apparaître lors de l'appel", kfr = "lorsqu'un nouvel événement est réservé", Sfr = "envoyer un e-mail à l'hôte", xfr = "envoyer un e-mail aux participants", Efr = "Envoyer un SMS au participant", Tfr = "envoyer un SMS à un numéro spécifique", Afr = "Envoyez facilement des rappels de rendez-vous par SMS à vos participants", Cfr = "envoyer un message WhatsApp à un numéro spécifique", zfr = "envoyer un message WhatsApp au participant", Ofr = "Workflows", Pfr = "Nouveau workflow", Ifr = "Comment souhaitez-vous commencer ?", Rfr = "Ajouter un nouveau workflow", Nfr = "lorsque l'événement est replanifié", Dfr = "Déclencheur", Mfr = "Déclencheurs", Lfr = "Action", qfr = "Créez des workflows pour automatiser les notifications et les rappels.", jfr = "Nom du workflow", Ffr = "Workflow personnalisé", Vfr = "{{workflowName}} créé avec succès", Bfr = "Voulez-vous vraiment supprimer ce workflow ?", Ufr = "Supprimer le workflow", Wfr = "Oui, supprimer le workflow", Gfr = "Workflow supprimé avec succès", Hfr = "Combien de temps avant le début de l'événement ?", Kfr = "jours", Yfr = "heures", Zfr = "minutes", Qfr = "min", Jfr = "h", Xfr = "Créez votre premier workflow", egr = "Les workflows vous permettent d'automatiser l'envoi de rappels et de notifications.", tgr = "Actif sur", ngr = "Workflow {{workflowName}} mis à jour avec succès", ogr = "Il s'agit d'un nom d'utilisateur standard et l'appliquer vous redirigera vers la facturation pour résilier votre plan.", rgr = "Il s'agit d'un nom d'utilisateur premium, obtenez-le pour {{price}}", igr = "Actuel", agr = "premium", sgr = "standard", cgr = "Confirmer le changement de nom d'utilisateur", lgr = "Il s'agit d'un nom d'utilisateur premium et l'appliquer vous redirigera vers la facturation pour valider le changement.", dgr = "Il s'agit d'un nom d'utilisateur standard et l'appliquer vous redirigera vers la facturation pour résilier votre plan.", ugr = "Accéder à la facturation", _gr = "Exigez un paiement pour les réservations (0,5 % + 0,10 € de commission par transaction).", pgr = "Votre période d'essai a expiré", mgr = "Supprimer l'application", fgr = "Oui, supprimer l'application", ggr = "Voulez-vous vraiment supprimer cette application ?", hgr = "Application supprimée avec succès", vgr = "Erreur lors de la suppression de l'application", bgr = "Visioconférence", ygr = "Appel web", $gr = "Démarrer l'appel web", wgr = "Terminer l'appel", kgr = "Testez votre agent avec un appel web sans nécessiter de numéro de téléphone", Sgr = "Appel téléphonique", xgr = "Connexion à l'agent...", Egr = "Appel en cours", Tgr = "Appel terminé", Agr = "Erreur d'appel", Cgr = "Prêt à démarrer l'appel", zgr = "Échec du démarrage de l'appel web. Veuillez réessayer.", Ogr = "L'appel a rencontré une erreur. Veuillez réessayer.", Pgr = "Échec d'initialisation de l'appel web. Veuillez vous assurer que les permissions du microphone sont accordées.", Igr = "Démarrez un appel pour voir la conversation", Rgr = "En attente de conversation...", Ngr = "Agent IA", Dgr = "En direct", Mgr = "Connexion en cours...", Lgr = "Nécessite une confirmation", qgr = "Une confirmation est requise si réservé avec un préavis de moins de {{time}} $t({{unit}}_timeUnit)", jgr = "Peut nécessiter une confirmation", Fgr = "{{count}} type d'événement", Vgr = "{{count}} types d'événements", Bgr = "{{count}} équipe", Ugr = "{{count}} équipes", Wgr = "Ajouter une action", Ggr = "Définir le lien Whereby", Hgr = "Veuillez saisir un lien Whereby valide", Kgr = "Définir un lien Around.Co", Ygr = "Veuillez saisir un lien Around.Co valide", Zgr = "Définir un lien Riverside", Qgr = "Veuillez saisir un lien Riverside valide", Jgr = "Veuillez saisir un lien Ping.gg valide", Xgr = "Connecter le serveur Exchange 2013", ehr = "Connecter le serveur Exchange 2016", thr = "Modèle personnalisé", nhr = "Corps", ohr = "Message texte", rhr = "Vous avez un problème particulier ?", ihr = "parcourir notre documentation", ahr = "Choisir un modèle", shr = "Personnalisé", chr = "Rappel", lhr = "Replanifié", dhr = "Replanifié par", uhr = "Réservation initiale", _hr = "Terminé", phr = "Évaluation", mhr = "Rappel : {{eventType}} avec {{name}} le {{date}}", fhr = "Ne se déclenchera pas pour les réservations déjà existantes car l'utilisateur sera invité à fournir un numéro de téléphone lors de la réservation de l'événement.", ghr = "{{count}} minute", hhr = "{{count}}min", vhr = "{{count}} minutes", bhr = "{{count}} heure", yhr = "{{count}}h", $hr = "{{count}} heures", whr = "Saisie non valide", khr = "Nous n'avons pas pu ajouter le lien de réunion {{location}} à votre événement programmé. Contactez vos invités ou mettez à jour votre événement de calendrier pour ajouter les détails. Vous pouvez soit <0>modifier votre lieu sur le type d'événement</0> ou essayer de <1>supprimer et d'ajouter à nouveau l'application.</1>", Shr = "Nous n'avons pas pu mettre à jour votre <1>{{calendar}}</1>. <2> Veuillez vérifier les paramètres de votre calendrier ou supprimer et ajouter votre calendrier à nouveau </2>", xhr = "Nom du participant", Ehr = "Le nom complet de la personne qui effectue la réservation", Thr = "Intégration défaillante", Ahr = "Un problème est survenu lors de l'ajout d'un lien vidéo", Chr = "Un problème est survenu lors de la mise à jour de votre calendrier", zhr = "Actif sur {{count}} type d'événement", Ohr = "Actif sur {{count}} types d'événements", Phr = "Actif sur {{count}} équipe", Ihr = "Actif sur {{count}} équipes", Rhr = "Actif sur tous les types d'événements", Nhr = "Actif sur toutes les équipes", Dhr = "Aucun type d’événement actif", Mhr = "Aucune équipe active", Lhr = "Nouveau participant : {{name}} pour {{eventType}} le {{date}}", qhr = "Quelqu'un s'est ajouté à un événement", jhr = "Variable", Fhr = "Nom de l'événement", Vhr = "Nom du participant", Bhr = "Date de l'événement", Uhr = "Heure de l'événement", Whr = "Nom de l'organisateur", Ghr = "Pour pouvoir utiliser cette fonctionnalité, vous devez passer à un compte Pro.", Hhr = "Numéro de téléphone invalide", Khr = "URL non valide pour {{label}}. Exemple d'URL : {{sampleUrl}}", Yhr = "Naviguer", Zhr = "Ouvrir", Qhr = "Fermer", Jhr = "Mettre à niveau", Xhr = "Acheter un numéro US pour {{priceInDollars}}$/mois", evr = "Mettez à niveau pour accéder aux enregistrements", tvr = "Les enregistrements ne sont disponibles que dans le plan Équipes. Mettez à niveau pour commencer à enregistrer vos appels.", nvr = "Passez à la version Entreprise pour générer un numéro de téléphone d'agent IA capable d'appeler les invités pour planifier des appels", ovr = "Les enregistrements font partie du plan Équipes", rvr = "Ceci est une fonctionnalité d'équipe. Mettez à jour vers le plan Équipes pour voir les disponibilités de votre équipe.", ivr = "Ceci est une fonctionnalité d'équipe. Mettez à jour vers le plan Équipes pour automatiser vos notifications et rappels d'événements avec les workflows.", avr = "Afficher sur le profil", svr = "Intégrer", cvr = "Nouveau nom d'utilisateur", lvr = "Nom d'utilisateur actuel", dvr = "Exemple 1", uvr = "Exemple 2", _vr = "Identifiant de la question de réservation", pvr = "Taille de l'entreprise", mvr = "Avez-vous besoin d'aide ?", fvr = "Format des variables", gvr = "Le lien de l'abonné webhook est déjà défini", hvr = "Ignorer tous les caractères spéciaux du libellé de champ supplémentaire (utiliser uniquement des lettres et des chiffres), utiliser des majuscules pour toutes les lettres et remplacer les espaces par des tirets bas.", vvr = "Comment puis-je utiliser les questions de réservation comme variables ?", bvr = "Télécharger l'application de bureau", yvr = "Définir le lien Ping", $vr = "Limite dépassée", wvr = "Quand quelque chose se passe.", kvr = "Une action est effectuée.", Svr = "Tester l'action", xvr = "Notification envoyée", Evr = "Aucun champ", Tvr = "Tester l'action du workflow", Avr = "Envoyer un SMS", Cvr = "Voulez-vous vraiment envoyer un SMS au {{number}} ?", zvr = "Aucun calendrier par défaut connecté", Ovr = "Vous pouvez connecter votre calendrier depuis <1>ici</1>.", Pvr = "Calendrier par défaut", Ivr = "Masquer du profil", Rvr = "Configuration", Nvr = "Aucune disponibilité trouvée dans le planning", Dvr = "Limites", Mvr = "Fréquence de réservation", Lvr = "Paramètres du calendrier, etc.", qvr = "Avancé", jvr = "Configurer les paiements pour l'événement", Fvr = "Configuration de l'événement : plusieurs durées requièrent au moins une option.", Vvr = "Configuration de l'événement : veuillez sélectionner une durée par défaut valide.", Bvr = "Les limites de réservation doivent être dans l'ordre croissant. [jour, semaine, mois, année]", Uvr = "Les limites de durée doivent être dans l'ordre croissant. [jour, semaine, mois, année]", Wvr = "Sélectionnez le calendrier auquel ajouter les réservations.", Gvr = "Nom d'événement personnalisé", Hvr = "Créez des noms d'événement personnalisés à afficher sur l'événement du calendrier", Kvr = "Code de double authentification incorrect", Yvr = "À quel type d'événement s'appliquera-t-il ?", Zvr = "Appliquer à tous, y compris aux futurs types d'événements", Qvr = "Appliquer à tous les types d'événements d'équipe et d'utilisateur", Jvr = "À quelle équipe cela s'appliquera-t-il ?", Xvr = "Les workflows permettent une automatisation simple pour envoyer des notifications et des rappels vous permettant de créer des processus autour de vos événements.", ebr = "Il s'agit d'un paramètre interne qui n'affectera pas la façon dont les horaires sont affichés sur les pages de réservation publiques, que ce soit pour vous ou toute personne prenant rendez-vous avec vous.", tbr = "Créer un workflow", nbr = "Effectuer ceci", obr = "Désactiver", rbr = "Activer", ibr = "Les réservations annulées ne peuvent pas être reprogrammées", abr = "Paramètres mis à jour avec succès", sbr = "Erreur lors de la mise à jour des paramètres", cbr = "Mon lien {{appName}} personnel", lbr = "Quelques mots à propos de vous. Ces informations apparaîtront sur votre page publique.", dbr = "Terminez la configuration et commencez", ubr = "Cet utilisateur n'a pas encore ajouté de description.", _br = "Bio", pbr = "Supprimer le compte", mbr = "Voulez-vous vraiment supprimer votre compte {{appName}} ?", fbr = "Supprimer mon compte", gbr = "Début de la semaine", hbr = "Enregistrements", vbr = "Enregistrement", bbr = "Bonne planification", ybr = "Sélectionnez les calendriers dont vous souhaitez vérifier les conflits afin d'éviter les doubles réservations.", $br = "Vérifier les conflits", wbr = "Voir les enregistrements", kbr = "Chercher des enregistrements", Sbr = "Ajout d'événements", xbr = "Suivre les préférences système", Ebr = "Couleurs de marque personnalisées", Tbr = "Personnalisez la couleur de votre page de réservation à l'image de votre marque.", Abr = "Pro", Cbr = "Supprimez toutes les références à la marque {{appName}}, par exemple « Propulsé par {{appName}} ».", zbr = "Rendez-vous instantané avec {{name}}", Obr = "Photo de profil", Pbr = "Télécharger", Ibr = "Ajouter une photo de profil", Rbr = "Adresse du token", Nbr = "Blockchain", Dbr = "Ancien mot de passe", Mbr = "Votre nouveau mot de passe super sécurisé", Lbr = "Erreur lors de la mise à jour du mot de passe", qbr = "Double authentification", jbr = "Configurer une disponibilité récurrente", Fbr = "aujourd'hui", Vbr = "Apparence", Bbr = "Mon compte", Ubr = "Général", Wbr = "Calendriers", Gbr = "Factures", Hbr = "Intégrations", Kbr = "Emprunt d'identité", Ybr = "Gérez les paramètres d'emprunt d'identité.", Zbr = "Usurpations récentes", Qbr = "Usurpation rapide", Jbr = "Aucune usurpation récente", Xbr = "Utilisateurs", eyr = "Utilisateur", tyr = "Gérez les paramètres de votre profil {{appName}}.", nyr = "Vous trouverez ici une liste de tous les utilisateurs", oyr = "Liste des utilisateurs", ryr = "Gérez les paramètres de votre langue et de votre fuseau horaire.", iyr = "Configurez la manière dont vos types d'événements interagissent avec vos calendriers.", ayr = "Gérez les paramètres d'apparence de vos réservations.", syr = "Ajoutez vos applications de visioconférence préférées pour vos rendez-vous.", cyr = "Ajouter une application de conférence", lyr = "Gérez les paramètres pour les mots de passe de votre compte.", dyr = "Configurez votre double authentification", uyr = "Nous avons juste besoin de quelques informations de base pour configurer votre profil.", _yr = "Ignorer", pyr = "Plus tard", myr = "Définissez les plages horaires durant lesquelles vous êtes disponible.", fyr = "Vous pouvez personnaliser tout cela plus tard dans la page Disponibilités.", gyr = "Connectez d'abord un calendrier", hyr = "Complétez votre profil", vyr = "Vous pouvez ajouter plus de calendriers depuis l'App Store", byr = "Connecter les applications de visioconférence", yyr = "Connecter des apps de calendrier", $yr = "Connecter des apps de paiement", wyr = "Connecter des apps d'automatisation", kyr = "Connecter des apps d'analytique", Syr = "Connecter d'autres applications", xyr = "Connecter des apps de messagerie", Eyr = "Connecter des apps de CRM", Tyr = "Étape {{currentStep}} sur {{maxSteps}}", Ayr = "Ajouter une variable", Cyr = "Numéro de téléphone personnalisé", zyr = "Modèle de message", Oyr = "Objet", Pyr = "Ajouter des variables de texte dynamiques", Iyr = "Nom du type d'événement", Ryr = "Date de l'événement", Nyr = "La durée de l'événement", Dyr = "Heure de début de l'événement", Myr = "Type d'événement introuvable", Lyr = "Numéro à appeler", qyr = "Le numéro de téléphone de l'utilisateur que vous appelez", jyr = "Lieu", Fyr = "Lieu de l'événement", Vyr = "Notes supplémentaires", Byr = "Notes supplémentaires de la réservation", Uyr = "Nom du participant", Wyr = "Nom de l'organisateur", Gyr = "À", Hyr = "Le workflow {{workflowName}} a été {{offOn}} avec succès", Kyr = "Télécharger les réponses", Yyr = "Téléchargez toutes les réponses à votre formulaire au format CSV.", Zyr = "Voir les réponses", Qyr = "Télécharger", Jyr = "Téléchargement en cours", Xyr = "Télécharger l'enregistrement", e$r = "Les transcriptions sont désormais activées", t$r = "Les transcriptions sont désormais arrêtées", n$r = "Télécharger la transcription", o$r = "Transcription", r$r = "Un enregistrement de votre appel récent sur {{appName}} est prêt à être téléchargé", i$r = "La transcription de votre récent appel sur {{appName}} est prête à être téléchargée. Les liens ne sont valides que pendant 1 heure", a$r = "Vous pouvez également télécharger la transcription depuis les pièces jointes", s$r = "Remarque : le lien de téléchargement n'est valide que pendant 12 heures. Vous pouvez générer un nouveau lien de téléchargement en suivant les instructions <1>ici</1>.", c$r = "Remarque : le lien de téléchargement n'est valable que pendant 12 heures. Vous pouvez générer un nouveau lien de téléchargement en suivant les instructions.", l$r = "Créez votre premier formulaire", d$r = "Avec les formulaires de routage, vous pouvez poser des questions de qualification et rediriger vers la bonne personne ou le bon type d'événement.", u$r = "Créez votre premier webhook", _$r = "Avec les webhooks, vous pouvez recevoir les données de rendez-vous en temps réel lorsque quelque chose se passe sur {{appName}}.", p$r = "Pour un maximum de", m$r = "événement", f$r = "événements", g$r = "Gérez les paramètres du profil de votre équipe.", h$r = "Gérez les paramètres de votre profil d'organisation.", v$r = "Utilisateurs présents dans le groupe.", b$r = "Gérez les administrateurs et les membres de votre organisation.", y$r = "Lien de l'équipe", $$r = "Membres de l'équipe", w$r = "Plus", k$r = "Flux de travail Cal.ai", S$r = "et {{count}} de plus", x$r = "Nous considérons l'application mobile comme une extension de l'application web. Si vous effectuez des actions complexes, veuillez vous référer à l'application web.", E$r = "Envoyer un rappel par SMS 24 heures avant le début de l'événement", T$r = "Envoyer un SMS personnalisé au participant lorsque l'événement est replanifié", A$r = "Envoyer un e-mail personnalisé à l'hôte lorsqu'un nouvel événement est réservé", C$r = "Envoyer un rappel par e-mail aux participants 1 heure avant le début des événements", z$r = "Envoyer un e-mail personnalisé à l'hôte lorsque l'événement est replanifié", O$r = "Envoyer un SMS personnalisé à l'hôte lorsqu'un nouvel événement est réservé", P$r = "Envoyer un rappel par SMS", I$r = "24 heures avant le début de l'événement", R$r = "Suivi des absents", N$r = "30 minutes après la fin de l'événement", D$r = "Rappeler aux participants d'apporter une pièce d'identité", M$r = "1 jour avant le début de l'événement", L$r = "Rappel par e-mail", q$r = "1 heure avant le début de l'événement", j$r = "Rappel SMS personnalisé", F$r = "Lorsque l'événement est programmé", V$r = "Rappel par e-mail personnalisé", B$r = "L'événement est replanifié pour l'hôte", U$r = "Inclure les compteurs de réservation des types d'événements gérés", W$r = "Bienvenue sur {{appName}} !", G$r = "Vous pourrez modifier cela ultérieurement.", H$r = "Je connecterai mon calendrier plus tard", K$r = "Un problème est survenu lors de l'enregistrement de vos données. Veuillez réessayer ou contacter le service client.", Y$r = "Acheter des places manquantes", Z$r = "Durée du créneau", Q$r = "Apparence", J$r = "Gérez les paramètres d'apparence de vos réservations d'équipe.", X$r = "Gérez les paramètres d'apparence de vos réservations d'organisation", ewr = "Seul le propriétaire de cette équipe peut apporter des modifications à la réservation de l'équipe ", twr = "Supprimez toutes les références à la marque {{appName}}, par exemple « Propulsé par {{appName}} ».", nwr = "{{teamName}} vous a invité à rejoindre son équipe en tant que {{role}}", owr = "Le token est invalide ou a expiré.", rwr = "Voir la réservation", iwr = "Se connecter à Microsoft Exchange", awr = "Méthode d'authentification", swr = "Authentification de base", cwr = "Authentification NTLM", lwr = "Compression GZip", dwr = "Version d'Exchange", uwr = "2007 SP1", _wr = "2010", pwr = "2010 SP1", mwr = "2010 SP2", fwr = "2013", gwr = "2013 SP1", hwr = "2015", vwr = "2016", bwr = "Routage", ywr = "Créez des formulaires pour acheminer les participants vers les bonnes destinations.", $wr = "Envoyer un e-mail au propriétaire", wwr = "Envoie un e-mail au propriétaire lorsque le formulaire est soumis", kwr = "Envoyer un e-mail à", Swr = "Ajouter un nouveau formulaire", xwr = "Ajouter un nouveau formulaire à votre équipe", Ewr = "Créez votre première route", Twr = "Acheminez vers la bonne personne en fonction des réponses à votre formulaire.", Awr = "Formulaire", Cwr = "Créez votre formulaire pour rediriger un utilisateur.", zwr = "Copier le lien vers le formulaire", Owr = "Thème de la page de réservation", Pwr = "Ceci s'applique uniquement à vos pages publiques de réservation.", Iwr = "Thème du tableau de bord", Rwr = "Cela s'applique uniquement à votre tableau de bord connecté", Nwr = "Automatique", Dwr = "Ajouter une équipe", Mwr = "Recevez les données de rendez-vous en temps réel lorsque quelque chose se passe sur {{appName}}.", Lwr = "Se déclenche quand", qwr = "Veuillez faire un test de ping avant de le créer.", jwr = "Activer le webhook", Fwr = "Ajouter un webhook", Vwr = "Webhook enregistré", Bwr = "Générez des clés API pour accéder à votre propre compte.", Uwr = "Nouvelle clé API", Wwr = "actif", Gwr = "Nom de clé API mis à jour", Hwr = "Erreur lors de la mise à jour du nom de la clé API", Kwr = "Intégration d'iframe HTML", Ywr = "Intégrez tous vos types d'événements sur votre site web.", Zwr = "Créez votre première clé API", Qwr = "Les clés API permettent à d'autres applications de communiquer avec {{appName}}.", Jwr = "Retour à la connexion", Xwr = "Lien de réinitialisation envoyé", e0r = "Un e-mail est en route vers {{email}} avec les instructions pour réinitialiser votre mot de passe.", t0r = "Si vous ne recevez pas d'e-mail bientôt, vérifiez que l'adresse e-mail que vous avez saisie est correcte, vérifiez vos spams ou contactez l'assistance si le problème persiste.", n0r = "Mot de passe mis à jour !", o0r = "Paiement en attente", r0r = "Invitations en attente", i0r = "Invitations de l'organisation en attente", a0r = "Pas sur {{appName}}", s0r = "Aucun calendrier installé", c0r = "Vous n'avez pas encore connecté vos calendriers.", l0r = "Ajouter un calendrier", d0r = "Vous devrez peut-être vous déconnecter et vous reconnecter pour voir les changements prendre effet.", u0r = "Veuillez confirmer votre mot de passe avant de changer votre adresse e-mail", _0r = "places", p0r = "Chaque application publiée sur l'App Store de {{appName}} est open source et soigneusement testée via des évaluations par les pairs. Néanmoins, {{companyName}} n'approuve ni ne certifie ces applications à moins qu'elles ne soient publiées par {{appName}}. Si vous rencontrez un contenu ou comportement inapproprié, veuillez le signaler.", m0r = "Signaler l'application", f0r = "Limiter la fréquence de réservation", g0r = "Limitez le nombre de réservations possibles pour cet événement.", h0r = "N'afficher que le premier créneau disponible de chaque jour", v0r = "Cela limitera votre disponibilité pour ce type d'événement à un créneau par jour, programmé au plus tôt possible.", b0r = "Limiter la durée totale de réservation", y0r = "Limitez la durée totale pendant laquelle cet événement peut être réservé.", $0r = "Limite de réservations actives par utilisateur", w0r = "Limitez le nombre de réservations actives qu'un utilisateur peut effectuer pour ce type d'événement", k0r = "Les événements récurrents ne prennent pas en charge la limite de réservation par utilisateur", S0r = "Ajouter une limite", x0r = "Nom d'équipe requis", E0r = "Partagez les informations des participants entre les invités", T0r = "Afficher le nombre de places disponibles", A0r = "Comment utiliser les questions de réservation comme variables ?", C0r = "Format", z0r = "Questions", O0r = "Toutes les informations que votre utilisateur doit fournir avant de réserver avec vous.", P0r = "Utilisez des majuscules pour toutes les lettres.", I0r = "Remplacez les espaces par des tirets bas.", R0r = "Membres de la plateforme", N0r = "Gérez les administrateurs et les membres de votre équipe sur la plateforme", D0r = "Facturation de la plateforme", M0r = "Gérer la facturation", L0r = "Gérez tout ce qui est en lien avec la facturation.", q0r = "Vous êtes actuellement sur le plan Gratuit", j0r = "Nous travaillons mieux en équipe. Élargissez vos workflows avec les événements round-robin et collectifs et produisez des formulaires de routage avancés.", F0r = "Essayer maintenant", V0r = "Portail de facturation", B0r = "Contacter l'assistance", U0r = "Ignorez les caractères spéciaux dans l'identifiant de votre question de réservation, utilisez uniquement des lettres et des chiffres.", W0r = "Réessayer", G0r = "Un problème est survenu lors de la récupération de vos calendriers. Veuillez <1>réessayer</1> ou contacter le service client.", H0r = "Échec de la connexion au calendrier", K0r = "Confirmation de la réservation réussie", Y0r = "Refus de la réservation réussi", Z0r = "Cette réservation est provisoire", Q0r = "Oups, je veux accepter", J0r = "Nous n'afficherons plus ceci", X0r = "Nous n'avons pas pu mettre à jour le fuseau horaire", ekr = "Fuseau horaire mis à jour vers {{formattedCurrentTz}}", tkr = "Mettre à jour le fuseau horaire", nkr = "Mettre à jour le fuseau horaire ?", okr = "Votre fuseau horaire local semble être passé sur {{formattedCurrentTz}}. Il est très important d'avoir le bon fuseau horaire pour éviter les réservations à des heures indésirables. Souhaitez-vous le mettre à jour ?", rkr = "Ne pas mettre à jour", ikr = "Notes supplémentaires obligatoires", akr = "Exigez des notes supplémentaires à saisir lors de la réservation.", skr = "envoyer un e-mail à une adresse e-mail spécifique", ckr = "après la fin de l'événement", lkr = "lorsque la réservation est rejetée", dkr = "lorsque la réservation est demandée", ukr = "lorsque le paiement de la réservation est initié", _kr = "lorsque le paiement de la réservation est réussi", pkr = "lorsque l'absence au rendez-vous est mise à jour", mkr = "Combien de temps après la fin de l'événement ?", fkr = "Combien de temps après que les hôtes ne se présentent pas à la réunion vidéo Cal ?", gkr = "Combien de temps après que les invités ne se présentent pas à la réunion vidéo Cal ?", hkr = "Combien de minutes après que les utilisateurs ne se présentent pas à la réunion vidéo Cal ?", vkr = "Aucun créneau disponible", bkr = "Disponibilités", ykr = "Vous ne trouvez pas l'application de conférence adaptée ? Visitez notre <0>App Store</0>.", $kr = "Installer une nouvelle application de calendrier", wkr = "Rendre le numéro de téléphone obligatoire pour la réservation de l'événement", kkr = "Disponibilités de {{eventTypeTitle}}", Skr = "Erreur lors de la modification des disponibilités", xkr = "Vous n'avez pas la permission d'accéder à cette ressource.", Ekr = "Veuillez coller les métadonnées SAML de votre fournisseur d'identité ici.", Tkr = "Veuillez saisir une adresse e-mail pour que nous puissions trouver votre fournisseur d'identité SAML", Akr = "Informations sur le fournisseur de services", Ckr = "Votre fournisseur d'identité (IdP) vous demandera les détails suivants pour compléter la configuration de l'application SAML.", zkr = "Lien ACS", Okr = "Identifiant SP Entity", Pkr = "Lien ACS copié !", Ikr = "Identifiant SP Entity copié !", Rkr = "Ajouter un calendrier", Nkr = "Limiter les réservations futures", Dkr = "Limitez jusqu'à quand cet événement peut être réservé dans le futur.", Mkr = "Aucun type d’événement configuré", Lkr = "{{name}} n'a pas configuré de type d'événement que vous pouvez réserver.", qkr = "Fréquence de facturation", jkr = "Mensuellement", Fkr = "Annuellement", Vkr = "Paiement", Bkr = "Votre équipe a bien été dissoute", Ukr = "Votre organisation a bien été dissoute", Wkr = "Erreur lors de la création de l'équipe", Gkr = "Vous", Hkr = "Ou continuez avec", Kkr = "Renvoyer l’e-mail", Ykr = "Le membre a déjà été invité", Zkr = "Nom d'utilisateur déjà utilisé", Qkr = "Saisissez une adresse e-mail ou un nom d'utilisateur", Jkr = "Saisissez une adresse e-mail", Xkr = "Saisissez des adresses e-mail", e1r = "Vous ne pouvez inviter qu'un maximum de {{nbUsers}} utilisateurs à la fois.", t1r = "Ce nom est déjà pris", n1r = "Vous devez saisir un nom d'équipe", o1r = "Vous devez saisir un lien d'équipe", r1r = "Ce lien est déjà pris", i1r = "Un problème est survenu lors de l'enregistrement du sous-domaine, veuillez réessayer ou contacter un administrateur", a1r = "Publier l'équipe", s1r = "Numéro de téléphone (notifications par SMS)", c1r = "Numéro de téléphone (notifications par SMS)", l1r = "Adresse e-mail du participant", d1r = "Adresse e-mail du participant", u1r = "UID de réservation", _1r = "Saisissez une commande ou une recherche...", p1r = "Oh non ! On dirait que l’autorisation a expiré ou a été révoquée. Veuillez la réinstaller.", m1r = "Réinstaller l'application", f1r = "Raison de la replanification", g1r = "Choisissez un horaire commun", h1r = "Activez cette option si vous souhaitez utiliser un planning commun entre les hôtes. Lorsqu'elle est désactivée, chaque hôte sera réservé en fonction de son planning par défaut ou de son planning choisi.", v1r = "Raison", b1r = "ID de l'expéditeur", y1r = "Seules les lettres, chiffres et espaces sont autorisés (max. 11 caractères)", $1r = "Tester le formulaire de routage", w1r = "Tester l'aperçu", k1r = "Rediriger vers", S1r = "Tester votre formulaire de routage sans envoyer de données", x1r = "Tester le routage", E1r = "Un administrateur a désactivé une application de paiement", T1r = "Modifier le type d'événement", A1r = "Cette organisation est privée et seuls son administrateur ou son propriétaire peuvent en voir les membres.", C1r = "Seuls l'administrateur ou le propriétaire de l'organisation peuvent gérer les paramètres SSO", z1r = "Seul l'administrateur ou le propriétaire de l'organisation peut gérer les paramètres de synchronisation d'annuaire", O1r = "Seul l'administrateur ou le propriétaire de l'organisation peut gérer les clients OAuth", P1r = "Planification collective", I1r = "Facilitez la réservation de votre équipe lorsque tout le monde est disponible.", R1r = "Trouvez la meilleure personne disponible et alternez à travers votre équipe.", N1r = "Round-robin fixe", D1r = "Ajoutez un participant fixe et le round-robin via un certain nombre de participants.", M1r = "{{appName}} est meilleur en équipe", L1r = "L'équipe {{companyName}}", q1r = "Ajoutez les membres de votre équipe à vos types d'événements. Utilisez la planification collective pour inclure tout le monde ou trouvez la personne la plus appropriée avec la planification round-robin.", j1r = "La limite de réservation pour ce type d'événement a été atteinte", F1r = "La limite de durée pour ce type d'événement a été atteinte", V1r = "Un administrateur a désactivé {{appName}}", B1r = "Cela désactivera tous les e-mails destinés à {{recipient}}. Cela inclut les confirmations de réservation, les demandes, les reprogrammations et les demandes de reprogrammation, les e-mails d'annulation et tout autre e-mail lié aux mises à jour de réservation.<br /><br />Il est de votre responsabilité de vous assurer que vos {{recipient}} sont informés de toute réservation et des modifications apportées à leurs réservations.", U1r = "Un administrateur a désactivé {{appName}} qui affecte votre type d'événement {{eventType}}", W1r = "Un administrateur a remplacé l'un de vos types d'événements", G1r = "Un administrateur d'équipe a remplacé votre événement /{{slug}}", H1r = "Un administrateur de l'équipe <strong>{{teamName}}</strong> a remplacé votre type d'événement <strong>/{{slug}}</strong> par un type d'événement géré qu'il contrôle.", K1r = "Votre lien continuera de fonctionner, mais certains de ses paramètres peuvent avoir changé. Vous pouvez l'examiner dans les types d'événements.", Y1r = "Si vous avez des questions sur le type d'événement, veuillez contacter votre administrateur.<br /><br />Bonne planification, <br />L'équipe Cal.com", Z1r = "L'administrateur a désactivé {{appName}}, ce qui affecte votre type d'événement {{title}}. Les participants peuvent toujours réserver ce type d'événement mais ne seront pas invités à payer. Vous pouvez masquer le type d'événement pour éviter cela jusqu'à ce que votre administrateur réactive votre mode de paiement.", Q1r = "Les participants peuvent toujours réserver ce type d'événement mais ne seront pas invités à payer. Vous pouvez masquer le type d'événement pour éviter cela jusqu'à ce que votre administrateur réactive votre mode de paiement.", J1r = "L'administrateur a désactivé {{appName}} qui affecte votre type d'événement {{title}}.", X1r = "L'administrateur a désactivé {{appName}}, ce qui peut affecter vos types d'événements. Si vous avez des types d'événements avec {{appName}} comme emplacement, Cal Video sera alors utilisé par défaut.", e2r = "{{appName}} a été désactivé", t2r = "Accéder aux applications installées", n2r = "Si un autre calendrier est installé, les nouvelles réservations y seront ajoutées. Si ce n'est pas le cas, connectez un nouveau calendrier pour ne pas manquer de nouvelles réservations.", o2r = "Activer les applications", r2r = "Activer les applications que les utilisateurs peuvent intégrer à {{appName}}", i2r = "Acheter une licence", a2r = "J'ai déjà un compte", s2r = "J'ai déjà une clé :", c2r = "Veuillez copier votre variable d'environnement CALCOM_LICENSE_KEY existante ici.", l2r = "Créer une clé de licence", d2r = "{{appName}} est activé", u2r = "{{appName}} est désactivé", _2r = "Les clés ont été sauvegardées", p2r = "Désactiver l'application", m2r = "Désactiver cette application peut causer des problèmes avec la façon dont vos utilisateurs interagissent avec Cal", f2r = "Modifier les clés", g2r = "Activer les applications pour votre instance de Cal", h2r = "Une liste de tous les utilisateurs de votre compte, incluant leur nom, titre, e-mail et rôle.", v2r = "Ici, vous pouvez ajouter un nouvel utilisateur.", b2r = "Ici, vous pouvez modifier un utilisateur existant.", y2r = "Ici, vous pouvez modifier une organisation.", $2r = "Ajouter de nouveaux clients OAuth", w2r = "Verrouiller ou déverrouiller l'envoi de SMS pour les utilisateurs", k2r = "Il n'y a aucune application disponible", S2r = `Veuillez vous assurer qu'il y a des applications dans votre déploiement sous "packages/app-store"`, x2r = "Aucune application n'est activée dans cette instance de Cal", E2r = "Aucune application n'a encore été configurée", T2r = "Vous pouvez activer les applications dans les paramètres", A2r = "Veuillez contacter votre administrateur", C2r = "Paramètres des applications", z2r = "Veuillez remplir ce champ", O2r = "Options", P2r = "Entrer l'option {{index}}", I2r = "Ajouter une option", R2r = "Cet emplacement existe déjà. Veuillez sélectionner un nouvel emplacement", N2r = "Radio", D2r = "Pour utiliser Google Meet, vous devez définir votre calendrier de destination comme un calendrier Google", M2r = "Particulier", L2r = "Toutes les réservations", q2r = "Tous les utilisateurs", j2r = "Tous les types d'événement", F2r = "Vos réservations", V2r = "Lien du rendez-vous", B2r = "Lien de la visioconférence du rendez-vous", U2r = "Superpositions de dates", W2r = "Supprimer les superpositions de date le {{date}}", G2r = "Ajoutez les dates où vos disponibilités changent de vos heures quotidiennes.", H2r = "Les superpositions de dates sont archivées automatiquement une fois la date passée", K2r = "À quelles heures êtes-vous disponible ?", Y2r = "À quelles heures êtes-vous occupé ?", Z2r = "Sélectionnez les dates à superposer", Q2r = "Indisponible toute la journée", J2r = "Marquer comme indisponible (toute la journée)", X2r = "Marquer comme indisponible aux dates sélectionnées", eSr = "Mettre à jour la superposition", tSr = "Ajout du remplacement de date réussi", nSr = "Enregistrer l'exception", oSr = "{{slug}}-copie", rSr = "Définir par défaut", iSr = "Masquer les détails du type d'événement", aSr = "Afficher la navigation", sSr = "Masquer la navigation", cSr = "Code de vérification envoyé", lSr = "Vérification réussie", dSr = "Code de vérification incorrect", uSr = "Pas encore vérifié", _Sr = "Aucune disponibilité en {{month}}", pSr = "La planification n'est disponible que jusqu'à {{days}} jours à l'avance. Veuillez vérifier à nouveau prochainement.", mSr = "La planification s'est terminée le {{date}}. Veuillez vérifier à nouveau prochainement.", fSr = "Voir le mois précédent", gSr = "Voir le mois suivant", hSr = "Envoyer le code", vSr = "Numéro vérifié", bSr = "Créez votre premier webhook pour ce type d'événement d'équipe", ySr = "Créez un webhook pour ce type d'événement d'équipe.", $Sr = "Désactiver la page de validation (fonctionne uniquement si vous avez un lien de redirection)", wSr = "Vous êtes administrateur, mais votre mot de passe ne fait pas au moins 15 caractères ou la double authentification n'est pas définie", kSr = "Changez votre mot de passe pour obtenir l'accès administrateur", SSr = "Ce nom d'utilisateur est déjà pris", xSr = "Affectation", ESr = "Hôtes fixes", TSr = "Ajouter des hôtes fixes", ASr = "Hôtes round-robin", CSr = "Nombre d'hôtes requis pour participer", zSr = "Hôtes", OSr = "Vous devez créer une équipe pour activer cette fonctionnalité. Cliquez ici pour créer une équipe.", PSr = "Vous devez passer sur notre formule entreprise pour activer cette fonctionnalité.", ISr = "Nouveau participant", RSr = "En attente de validation", NSr = "Cette application nécessite une connexion à Google Agenda", DSr = `L'option "Ajouter au calendrier" pour ce type d'événement doit être un Google Calendar pour que Meet fonctionne. Connectez-le <0>ici</0>.`, MSr = "Vous avez connecté un compte Google Agenda.", LSr = "L'utilisation de Google Meet nécessite un calendrier Google connecté", qSr = "Continuer à installer Google Agenda", jSr = "Installer Google Meet", FSr = "Installer Google Agenda", VSr = "Nom de l'expéditeur", BSr = "Participant déjà invité", USr = "Aucun enregistrement trouvé", WSr = "Nouveau workflow pour...", GSr = "Rapports", HSr = "Voir toutes les données entrantes et les télécharger au format CSV.", KSr = "Le plan Équipes est requis", YSr = "Les formulaires de routage sont un excellent moyen d'acheminer vos prospects entrants vers la bonne personne. Passez au plan Équipes pour accéder à cette fonctionnalité.", ZSr = "Choisir une licence", QSr = "Cal.com est fourni avec une licence AGPLv3 accessible et gratuite mais comportant des limitations. Nous sommes en train d'intégrer les clients du plan Entreprise pour la licence commerciale. Vous pouvez vous renseigner à ce sujet en contactant le service commercial ci-dessous.", JSr = "Licence", XSr = "Licence AGPLv3", exr = "Pas besoin de garder votre code open source", txr = "Restructurez, changez de marque et revendez facilement", nxr = "Une vaste suite de fonctionnalités d'entreprise", oxr = "0,00 $/mois", rxr = "Ouvert et gratuit pour toujours", ixr = "Votre code doit rester open source", axr = "Impossible de restructurer, changer de marque et revendre facilement", sxr = "Aucune fonctionnalité d'entreprise", cxr = "Licence Entreprise", lxr = "Tout pour une utilisation commerciale avec hébergement privé, restructuration, changement de marque, revente et accès à des composants d'entreprise exclusifs.", dxr = "Configurer", uxr = "Configurez l'instance Cal.com.", _xr = "Configurer", pxr = "Authentification unique", mxr = "Configurez le SSO SAML/OIDC et autorisez les membres d'équipe à se connecter à l'aide d'un fournisseur d'identité.", fxr = "Configurez le SSO SAML/OIDC et autorisez les membres de l'organisation à se connecter à l'aide d'un fournisseur d'identité", gxr = "SSO avec OIDC", hxr = "Configurez le SSO OIDC avec le fournisseur d'identité de votre choix.", vxr = "Configuration OIDC", bxr = "Configurez la connexion OIDC à votre fournisseur d'identité. Vous pouvez trouver les informations requises dans votre fournisseur d'identité.", yxr = "Lien de rappel copié", $xr = "SSO avec SAML", wxr = "Configurez le SSO SAML avec le fournisseur d'identité de votre choix.", kxr = "Configuration SAML", Sxr = "Configurez la connexion SAML à votre fournisseur d'identité. Vous pouvez trouver les informations requises dans votre fournisseur d'identité.", xxr = "Lien ACS copié", Exr = "ID d'entité copié", Txr = "Configuration {{connectionType}} créée avec succès", Axr = "Configuration {{connectionType}} supprimée avec succès", Cxr = "Supprimer la configuration {{connectionType}}", zxr = "Oui, supprimer la configuration {{connectionType}}", Oxr = "Voulez-vous vraiment supprimer la configuration {{connectionType}} ? Les membres de votre équipe utilisant la connexion {{connectionType}} ne pourront plus accéder à Cal.com.", Pxr = "Fuseau horaire de l'organisateur", Ixr = "Voir l'invitation", Rxr = "Accepter l'invitation", Nxr = "Rejoindre maintenant", Dxr = "Rejoint avec succès", Mxr = "Vous avez été invité à rejoindre une équipe de l'organisation {{parentTeamName}}", Lxr = "Vous avez été invité à rejoindre une organisation {{appName}}", qxr = "{{invitedBy}} vous a invité à rejoindre son équipe sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.", jxr = "{{invitedBy}} vous a invité(e) à rejoindre son équipe {{teamName}} dans son organisation {{parentTeamName}} sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.", Fxr = "{{invitedBy}} vous a invité à rejoindre son organisation « {{teamName}} » sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre organisation d'organiser des rendez-vous sans échanges d'e-mails.", Vxr = "Nous vous guiderons à travers quelques étapes rapides et vous profiterez bientôt d'une planification sans stress avec votre {{entity}}.", Bxr = "Choisissez votre nom d'utilisateur", Uxr = "Connectez votre compte de calendrier", Wxr = "Définissez vos disponibilités", Gxr = "Rejoignez {{teamName}}", Hxr = "Bonne planification de la part de l'équipe {{appName}}", Kxr = "Vous êtes sur le point d'emprunter l'identité d'un utilisateur, ce qui signifie que vous pouvez effectuer des modifications en son nom. S'il vous plaît, soyez prudent.", Yxr = "Variables disponibles", Zxr = "{Scheduler}", Qxr = "Aucun workflow", Jxr = "Changez le filtre pour voir vos workflows personnels et d'équipe.", Xxr = "Changez le filtre pour voir les résultats.", eEr = "Aucun résultat pour le filtre", tEr = "Étapes suivantes recommandées", nEr = "Créer un type d'événement géré", oEr = "Les rendez-vous sont meilleurs avec les bons membres d'équipe. Invitez-les maintenant.", rEr = "Créez un modèle unique pour un type d'événement et distribuez-le à plusieurs membres.", iEr = "Collective ou round-robin", aEr = "Réservez les membres de votre équipe entre eux avec des événements collectifs ou mettez en place un cycle pour obtenir la bonne personne avec le round-robin.", sEr = "Ne participe plus à {{title}} le {{date}}", cEr = "Vous ne participez plus à cet événement", lEr = "Un participant ne participe plus à {{title}} le {{date}}", dEr = "Un participant ne participe plus à votre événement", uEr = "{{name}} a annulé. Cela signifie qu'une place s'est libérée pour ce créneau horaire", _Er = "Créer un événement dans", pEr = "Créer un formulaire de routage sur", mEr = "Définir un lien d'application par défaut", fEr = "Définir un lien d'application par défaut permet à tous les nouveaux types d'événements d'utiliser le lien d'application que vous avez défini.", gEr = "Application par défaut de l'organisateur", hEr = "{{organizer}} n'a pas d'application de conférence par défaut", vEr = "En cours de maintenance", bEr = "L'équipe {{appName}} effectue une maintenance planifiée. Si vous avez des questions, veuillez contacter l'assistance.", yEr = "{{numberOfSeats}} places", $Er = "Questions de réservation", wEr = "Personnalisez les questions posées sur la page de réservation.", kEr = "Ajouter une question", SEr = "Identifiant", xEr = "L'adresse e-mail existe déjà", EEr = "Saisissez une URL de redirection vers laquelle le participant sera dirigé une fois qu'il quittera la réunion.", TEr = "Payer pour cet événement n'est plus possible", AEr = "Un remboursement pour ce paiement de réservation est en route.", CEr = "Ce paiement de réservation a été remboursé.", zEr = "Conformément à la politique de remboursement de l'événement, le paiement de la réservation n'est pas remboursable.", OEr = "La période de remboursement de l'événement a expiré. Par conséquent, le paiement de la réservation n'est pas remboursable.", PEr = "Échec de la confirmation de la réservation", IEr = "Pas assez de places", REr = "Un champ avec ce nom existe déjà", NEr = "Le champ invités doit être de type 'Emails multiples'", DEr = "Afficher sur la page de réservation", MEr = "Vous pouvez consulter la page de réservation annulée", LEr = "Démarrer avec les modèles Zapier", qEr = "Modèles standard", jEr = "Modèles Cal.ai", FEr = "{{team}} n'est pas publiée", VEr = "Ce lien d'organisation n'est actuellement pas disponible. Veuillez contacter le propriétaire de l'organisation ou lui demander de le publier.", BEr = "Ce lien d'équipe n'est actuellement pas disponible. Veuillez contacter le propriétaire de l'équipe ou lui demander de le publier.", UEr = "Membre d'équipe", WEr = "Un formulaire de routage", GEr = "Description du formulaire", HEr = "Rester connecté avec le formulaire", KEr = "Toute modification apportée au routeur ou aux champs du formulaire en cours de duplication sera reflétée dans la copie. Cependant, la suppression d'un champ ne l'enlèvera pas de la copie.", YEr = "Formulaire supprimé", ZEr = "Voulez-vous vraiment supprimer ce formulaire ?", QEr = "Oui, supprimer le formulaire", JEr = "Toute personne avec qui vous avez partagé le lien ne pourra plus y accéder.", XEr = "Toutes les réponses associées seront supprimées.", eTr = "URL de redirection copiée ! Vous pouvez maintenant définir l'URL dans votre propre formulaire.", tTr = "Les modifications dans les champs et les routes des formulaires suivants seront répercutées dans ce formulaire.", nTr = "Formulaires connectés", oTr = "Les formulaires suivants seraient affectés lorsque vous modifieriez des champs ou des routes ici.", rTr = "Attendez un certain temps que les réponses soient collectées. Vous pouvez également envoyer le formulaire vous-même.", iTr = "Voici ce que vos utilisateurs verraient", aTr = "Identifie le champ par ce nom.", sTr = "Ajouter une option par ligne", cTr = "Sélectionner un routeur", lTr = "Ajouter une nouvelle route", dTr = "Prenez des décisions éclairées grâce aux statistiques", uTr = "Notre tableau de bord de statistiques analyse l'activité de votre équipe et vous révèle les tendances qui permettent d'améliorer la planification et la prise de décision au sein de l'équipe.", _Tr = "Visualisez les réservations de tous les membres", pTr = "Voyez qui reçoit le plus de réservations et assurez la meilleure distribution au sein de votre équipe", mTr = "Identifiez les tendances de réservation", fTr = "Découvrez quels jours de la semaine et quelles heures de la journée sont populaires auprès de vos utilisateurs.", gTr = "Identifiez les types d'événements populaires", hTr = "Découvrez lesquels de vos types d'événements reçoivent le plus de clics et de réservations.", vTr = "Aucune réponse pour l'instant", bTr = "Aucune route définie", yTr = "Ce sera le texte de substitution", $Tr = "Une erreur s'est produite lors de la réservation de l'événement, veuillez actualiser la page et réessayer", wTr = "Aucun créneau sélectionné", kTr = "Veuillez sélectionner un créneau pour réserver l'événement.", STr = "Sélectionner un créneau", xTr = "Passer en vue mensuelle", ETr = "Passer en vue hebdomadaire", TTr = "Passer en vue journalière", ATr = "Passer en vue colonnes", CTr = "{{num}} options de lieu", zTr = "Sélectionner à l'étape suivante", OTr = "Ce rendez-vous n'a pas encore commencé", PTr = "{{appName}} requiert un compte {{dependencyName}} connecté", ITr = "Connecter {{dependencyName}}", RTr = "{{dependencyName}} est connectée", NTr = "Requiert {{dependencyName}}", DTr = "Code de vérification", MTr = "Pouvez-vous réessayer avec un autre créneau ?", LTr = "Vérifier", qTr = "Le fuseau horaire du destinataire", jTr = "Fuseau horaire", FTr = "Heure de fin de l'événement", VTr = "L'heure de fin de l'événement", BTr = "Lien d'annulation", UTr = "Le lien d'annulation de la réservation", WTr = "Motif d'annulation", GTr = "Le motif de l'annulation de la réservation", HTr = "Lien de replanification", KTr = "Le lien de replanification de la réservation", YTr = "Motif de report", ZTr = "Le motif du report de la réservation", QTr = "Il y a une variable invalide dans le nom de votre événement", JTr = "Tout sélectionner", XTr = "Mise à jour multiple des types d'événements existants", eAr = "Planning par défaut du membre", tAr = "Défini par l'administrateur de l'équipe", nAr = "Lieu par défaut du membre", oAr = "Nous utiliserons le calendrier de disponibilité par défaut de chaque membre. Ils pourront le modifier ou le changer.", rAr = "Vous devez avoir au moins un planning", iAr = "Mettez à jour les emplacements pour les types d'événements sélectionnés.", aAr = "Mettre à jour les horaires pour les types d'événements sélectionnés", sAr = "Verrouillé pour les membres", cAr = "Déverrouillé pour les membres", lAr = "Les membres pourront voir les applications actives, mais ne pourront pas modifier leurs paramètres.", dAr = "Les membres pourront voir les applications actives et modifier leurs paramètres", uAr = "Vous pourrez voir les applications actives, mais ne pourrez pas modifier leurs paramètres", _Ar = "Vous pourrez voir les applications actives et modifier leurs paramètres", pAr = "Les membres ne peuvent pas ajouter leurs propres flux de travail à ce type d'évènement.  Ils pourront voir les flux de travail actifs de l'équipe, mais ne pourront pas en modifier les paramètres.", mAr = "Les membres pourront ajouter leurs propres flux de travail à ce type d'évènement.  Ils pourront voir les flux de travail actifs de l'équipe, mais ne pourront pas en modifier les paramètres.", fAr = "Vous pourrez voir les flux de travail actifs de l'équipe, mais vous ne pourrez pas modifier les paramètres de flux de travail ni ajouter vos flux de travail personnels à ce type d'évènement.", gAr = "Vous pourrez activer/désactiver les flux de travail personnels pour ce type d'évènement. Vous pourrez voir les flux de travail d'équipe actifs, mais vous ne pourrez pas modifier les paramètres des flux de travail d'équipe.", hAr = "Les membres ne peuvent pas ajouter leurs webhooks personnels à ce type d'événement. Les membres pourront voir les webhooks actifs mais ne pourront pas modifier les paramètres des webhooks.", vAr = "Les membres pourront ajouter leurs webhooks personnels à ce type d'événement. Les membres pourront voir les webhooks actifs mais ne pourront pas modifier les paramètres des webhooks.", bAr = "Vous pouvez voir les webhooks gérés actifs mais vous ne pourrez pas modifier les paramètres des webhooks ni ajouter vos webhooks personnels à ce type d'événement.", yAr = "Vous pouvez ajouter des webhooks à ce type d'événement. Vous pouvez voir les webhooks gérés actifs mais vous ne pourrez pas les modifier.", $Ar = "Verrouillé par l'administrateur de l'équipe", wAr = "Vous n'avez pas connecté de compte {{appName}}.", kAr = "Connecter maintenant", SAr = "Remplacer et notifier {{count}} membre", xAr = "Remplacer et notifier {{count}} membres", EAr = "Le lien /{{slug}} existe déjà pour {{count}} membre. Voulez-vous le remplacer ?", TAr = "Le lien /{{slug}} existe déjà pour {{count}} membres. Voulez-vous le remplacer ?", AAr = "<strong>{{names}}</strong> utilise déjà le lien <strong>/{{slug}}</strong>.", CAr = "<strong>{{names}}</strong> utilisent déjà l'URL <strong>/{{slug}}</strong>.", zAr = "Si vous choisissez de le remplacer, nous les en informerons. Revenez en arrière et supprimez-les si vous ne souhaitez pas l'écraser.", OAr = "Examiner le type d'événement", PAr = "Vous cherchez plus d'analyses ?", IAr = "Vous cherchez plus de statistiques ?", RAr = "Filtres", NAr = "Filtrer", DAr = "Ajouter un membre", MAr = "Ajouter un filtre", LAr = "Ajouter une règle", qAr = "Ajouter un groupe de règles", jAr = "Effacer les filtres", FAr = "E-mail vérifié", VAr = "Sélectionner un utilisateur", BAr = "Sélectionner un type d'événement", UAr = "Sélectionner une plage de dates", WAr = "Événements populaires", GAr = "Aucun type d’événement trouvé", HAr = "Durée moyenne de l'événement", KAr = "Réservations par heure", YAr = "Membres les plus réservés", ZAr = "Membres les moins réservés", QAr = "Plus grand nombre de réservations planifiées", JAr = "Plus petit nombre de réservations planifiées", XAr = "Plus grand nombre de réservations terminées", eCr = "Plus petit nombre de réservations terminées", tCr = "Événements créés", nCr = "Événements terminés", oCr = "Événements annulés", rCr = "Événements replanifiés", iCr = "Événements", aCr = "Performance", sCr = "depuis la dernière période", cCr = "De : {{startDate}} À : {{endDate}}", lCr = "L'ajout d'une redirection désactivera la page de succès. Assurez-vous de mentionner « Réservation confirmée » sur votre page de succès personnalisée.", dCr = "Tendances de l'événement", uCr = "Effacer les filtres", _Cr = "Effacer", pCr = "Retenir", mCr = "Percevoir le paiement à la réservation", fCr = "Facturer des frais d'absence", gCr = "Carte retenue", hCr = "Débiter la carte", vCr = "Carte débitée", bCr = "Frais d'absence de {{amount, currency}}", yCr = "Frais d'absence", $Cr = "Soumettre la carte", wCr = "Soumettre les informations de paiement", kCr = "Votre rendez-vous est en attente d'un moyen de paiement", SCr = "Frais d'absence de {{amount, currency}} facturés pour {{title}} le {{date}}", xCr = "Des frais d'absence ont été facturés", ECr = "Des frais d'absence de {{amount, currency}} ont été facturés pour l'événement suivant", TCr = "Une erreur s'est produite lors de la facturation des frais d'absence. Veuillez réessayer plus tard.", ACr = "Percevoir les frais d'absence", CCr = "Frais d'absence facturés", zCr = "Paiement refusé. Veuillez essayer une autre carte ou contacter votre banque pour obtenir de l'aide.", OCr = "Ce type de carte n'est pas pris en charge pour cet achat. Veuillez utiliser un autre moyen de paiement.", PCr = "Le montant minimum de paiement est de 0,50 $ USD. Veuillez augmenter votre montant de paiement.", ICr = "Impossible de débiter la carte pour le paiement.", RCr = "Statistiques", NCr = "Formulaires de routage", DCr = "Aucune donnée trouvée pour le filtre ou les dates sélectionnés.", MCr = "Je reconnais que si je ne participe pas à cet événement, des frais d'absence de {{amount, currency}} seront appliqués à ma carte.", LCr = "jours", qCr = "Détails de la carte", jCr = "Un problème est survenu de notre côté. Contactez notre équipe d'assistance, et nous le résoudrons immédiatement pour vous.", FCr = "Veuillez fournir le texte suivant lorsque vous contactez le support pour mieux vous aider", VCr = "Il n'est pas possible d'activer les places et de facturer des frais d'absence pour le moment", BCr = "Terminez votre réservation", UCr = "Terminez votre réservation : {{title}} le {{date}}", WCr = "Confirmez vos coordonnées", GCr = "Copier le lien d'invitation", HCr = "Modifier les paramètres du lien", KCr = "Lien d'invitation copié", YCr = "Lien d'invitation supprimé", ZCr = "Clé API supprimée", QCr = "Cela supprimera définitivement la clé API. Toutes les applications utilisant cette clé perdront immédiatement l'accès à votre compte. Cette action ne peut pas être annulée.", JCr = "Paramètres de lien d'invitation enregistrés", XCr = "Les liens ont été définis pour expirer après...", ezr = "1 jour", tzr = "7 jours", nzr = "30 jours", ozr = "3 mois", rzr = "1 an", izr = "Vous avez été invité à rejoindre {{teamName}}", azr = "{{amount, currency}}", szr = "Vous êtes sur le point de facturer {{amount, currency}} au participant. Voulez-vous vraiment continuer ?", czr = "Facturer {{amount, currency}} au participant", lzr = "Exiger un paiement ({{paymentFeePercentage}} % + {{fee, currency}} de commission par transaction)", dzr = "{{email}} a été invité", uzr = "{{userCount}} utilisateurs ont été invités", _zr = "Erreur lors de la récupération de la carte", pzr = "L'image téléchargée ne doit pas dépasser 5 Mo", mzr = "{{errorCode}} : Vous n'êtes pas autorisé à activer ou désactiver ce workflow", fzr = "Intégration en ligne", gzr = "Charge votre type d'événement directement dans le contenu de votre site web.", hzr = "Bouton flottant", vzr = "Place un bouton flottant sur votre site qui déclenche une modale avec votre type d'événement.", bzr = "Clic sur un élément", yzr = "Ouvre votre calendrier sous forme de boîte de dialogue lorsque quelqu'un clique sur un élément.", $zr = "Utiliser mon propre formulaire", wzr = "Utilisez notre API de routage headless et votre propre formulaire pour les soumissions.", kzr = "Besoin d'aide ? Consultez nos guides pour intégrer Cal sur Wix, Squarespace ou WordPress, consultez nos questions fréquentes ou explorez les options d'intégration avancées.", Szr = "Prendre rendez-vous", xzr = "Prénom", Ezr = "Nom", Tzr = "Prénom, Nom", Azr = "Inviter en tant que", Czr = "Formulaire mis à jour avec succès.", zzr = "Désactiver les e-mails de confirmation par défaut pour les participants", Ozr = "Au moins un workflow est actif sur ce type d'événement qui envoie un e-mail aux participants lorsque l'événement est réservé.", Pzr = "Désactiver les e-mails de confirmation par défaut pour l'hôte", Izr = "Au moins un workflow est actif sur ce type d'événement qui envoie un e-mail à l'hôte lorsque l'événement est réservé.", Rzr = "Ajouter une superposition", Nzr = "Importer des utilisateurs depuis Google Workspace", Dzr = "Connecter Google Workspace", Mzr = "Vous devez être un administrateur d'espace de travail pour utiliser cette fonctionnalité", Lzr = "Créez votre premier webhook pour ce type d'événement", qzr = "Créez votre premier webhook avec « Rendez-vous instantané créé » comme déclencheur pour ce type d'événement", jzr = "Installer l’application sur", Fzr = "Créer pour", Vzr = "Devise", Bzr = "Créez un environnement où vos équipes peuvent créer des applications, des flux de travail et des types d'événements partagés avec une planification round robin et collective.", Uzr = "Gérer les organisations avec plusieurs équipes", Wzr = "Configurer votre organisation", Gzr = "Configurer votre plateforme", Hzr = "Les organisations sont des environnements partagés dans lesquels les équipes peuvent créer des types d'événements partagés, des applications, des workflows, etc.", Kzr = "Plans", Yzr = "Plateforme", Zzr = "Gérez tout ce qui concerne la plateforme.", Qzr = "La plateforme Cal.com vous permet d'intégrer sans effort la planification dans votre application en utilisant les API et atoms de la plateforme.", Jzr = "Vous devez entrer un nom d'organisation", Xzr = "Vous devez entrer l'adresse e-mail de votre organisation", eOr = "Adresse e-mail de votre organisation", tOr = "Adresse e-mail de votre administrateur", nOr = "Nom d'utilisateur de l'administrateur", oOr = "Nom de l'organisation", rOr = "Nom de la plateforme", iOr = "Lien de l'organisation", aOr = "Vérifier l'adresse e-mail de votre organisation", sOr = "Veuillez utiliser le code ci-dessous pour vérifier votre adresse e-mail et continuer à configurer votre organisation.", cOr = "Paramètres d'URL supplémentaires", lOr = "À propos de votre organisation", dOr = "Les organisations sont des environnements partagés dans lesquels vous pouvez créer plusieurs équipes avec des membres partagés, des types d'événements, des applications, des workflows, etc.", uOr = "Créer vos équipes", _Or = "Commencez à planifier ensemble en ajoutant les membres de votre équipe à votre organisation", pOr = "Inviter les administrateurs de votre organisation", mOr = "Ces administrateurs auront accès à toutes les équipes de votre organisation. Vous pouvez ajouter des administrateurs et des membres d'équipe plus tard.", fOr = "Définir un mot de passe", gOr = "Cela créera un nouveau compte utilisateur avec l'adresse e-mail de votre organisation et ce mot de passe.", hOr = "Logo de l'organisation", vOr = "Quelques phrases à propos de votre organisation. Elles apparaîtront sur la page de profil public de votre organisation.", bOr = "Je le ferai plus tard", yOr = "Vérifier votre adresse e-mail", $Or = "Entrez le code à 6 chiffres que nous avons envoyé à {{email}}", wOr = "Vérifiez votre adresse e-mail pour créer une organisation", kOr = "Le code fourni n'est pas valide, veuillez réessayer", SOr = "L'adresse e-mail est déjà utilisée", xOr = "Vous avez été invité à rejoindre {{orgName}}", EOr = "Rejoignez votre équipe à {{orgName}} et commencez à vous concentrer sur les rendez-vous, pas sur leur préparation !", TOr = "Les équipes suivantes n'ont pas pu être créées en raison de slugs identiques : {{slugs}}", AOr = "Les noms d'équipe ne peuvent pas être vides", COr = "Les noms d'équipe ne peuvent pas être répétés", zOr = "L'utilisateur appartient à une organisation", OOr = "Cette organisation n'a pas encore d'équipe", POr = "Si vous êtes un administrateur, assurez-vous de créer des équipes à afficher ici.", IOr = "Configurer", ROr = "Mon profil", NOr = "Mes paramètres", DOr = "CRM", MOr = "Messagerie", LOr = "Nom ou numéro affiché comme expéditeur d'un SMS (certains pays n'autorisent pas les ID d'expéditeur alphanumériques)", qOr = "Seul l'administrateur de votre organisation peut créer de nouvelles équipes", jOr = "La nouvelle politique anti-spam de Google pourrait vous empêcher de recevoir des notifications par e-mail et calendrier concernant cette réservation.", FOr = "Résoudre", VOr = "Une erreur s'est produite lors de la création des équipes pour cette organisation. Le slug du lien est manquant.", BOr = "Copier le lien vers l’organisation", UOr = "Équipe : {{teamName}}", WOr = "Utilisateur : {{userName}}", GOr = "Visualisez les statistiques de réservation à travers vos événements", HOr = "Historique des appels", KOr = "Consultez l'historique des appels pour tous vos appels Cal.ai", YOr = "{{locationCount}} options de lieu", ZOr = "Type de canal", QOr = "Raison de fin", JOr = "Statut de la session", XOr = "Sentiment de l'utilisateur", e4r = "Heure", t4r = "De", n4r = "Plan personnalisé", o4r = "Intégration aux e-mails", r4r = "Sélectionnez quelques créneaux disponibles et intégrez-les dans votre e-mail.", i4r = "Sélectionner un créneau", a4r = "Sélectionner une date", s4r = "Afficher uniquement si un paramètre est défini", c4r = "Ajouter un paramètre", l4r = "Nous vous mettons en relation avec quelqu'un de {{orgName}}.", d4r = "Veuillez ne pas fermer ou actualiser cette page", u4r = "Voir tous les créneaux disponibles", _4r = "p. ex. Équipe marketing", p4r = "p. ex. Équipe de vente", m4r = "p. ex. Équipe de design", f4r = "p. ex. Équipe d'ingénierie", g4r = "p. ex. Équipe d'analyse de données", h4r = "Vous pourrez ajouter plus d'équipes plus tard.", v4r = "En quoi consiste ce rendez-vous ?", b4r = "Ajouter à l'équipe", y4r = "Supprimer des utilisateurs de l'organisation", $4r = "Identifiant de délégation", w4r = "L'identifiant de délégation vous permet de gérer l'accès aux calendriers Google Workspace pour votre organisation.", k4r = "Ajoutez cet identifiant client dans Google Workspace avec la portée ci-dessous", S4r = "Identifiant de délégation activé", x4r = "Ajouter un identifiant de délégation", E4r = "Modifier l'identifiant de délégation", T4r = "Domaine", A4r = "Aucune plateforme workspace", C4r = "Plateforme workspace", z4r = "Plateformes workspace", O4r = "Gérez les plateformes workspace qui peuvent être utilisées pour l'identifiant de délégation", P4r = "Modifier la plateforme workspace", I4r = "Modifier le compte de service", R4r = "Ajouter une plateforme workspace", N4r = "Slug", D4r = "Clé JSON du compte de service", M4r = "Modifier la clé JSON du compte de service", L4r = "L'identifiant de délégation limite l'ajout à une seule installation", q4r = "L'application a été installée avec succès et utilise les identifiants délégués", j4r = "Voulez-vous vraiment supprimer {{userCount}} utilisateurs de cette organisation ?", F4r = "Retirer des utilisateurs de l'équipe", V4r = "Êtes-vous sûr de vouloir retirer {{userCount}} utilisateurs de cette équipe ?", B4r = "Cet utilisateur n'a pas encore configuré de planning", U4r = "Cet utilisateur n'est dans aucune équipe", W4r = "Cet utilisateur n'a pas encore installé d'applications", G4r = "Nécessite la vérification par e-mail du participant", H4r = "Pour assurer la vérification par e-mail du participant avant la planification des événements.", K4r = "Les messages ne peuvent être envoyés aux participants que lorsque le type d'événement nécessite une confirmation.", Y4r = "Organisations", Z4r = "Téléverser un logo vidéo Cal", Q4r = "Mettre à jour un logo vidéo Cal", J4r = "Télécharger une bannière", X4r = "Pour assurer que votre logo reste visible sur le fond sombre de la vidéo Cal, veuillez téléverser une image de couleur claire au format PNG ou SVG afin de maintenir la transparence.", e3r = "Autres équipes", t3r = "Ici, vous pouvez voir les équipes au sein de votre organisation dont vous ne faites pas partie. Vous pouvez vous y ajouter si nécessaire.", n3r = "Vous ne faites partie d'aucune organisation", o3r = "Aucune autre équipe trouvée", r3r = "Il n'y a pas d'autres équipes dans cette organisation.", i3r = "Prénom du participant", a3r = "Nom du participant", s3r = "Le prénom du participant", c3r = "Le nom de famille du participant", l3r = "Votre résumé mensuel", d3r = "Nom du membre", u3r = "Événements les plus populaires", _3r = "Voici votre résumé des événements populaires pour votre équipe {{teamName}} au cours des 30 derniers jours", p3r = "Moi", m3r = "Réunion indisponible", f3r = "E-mail de synthèse mensuelle", g3r = "E-mail de résumé mensuel pour les équipes.", h3r = "Vérifiez votre équipe pour activer l'envoi de messages aux participants", v3r = "Membre supprimé", b3r = "Mes disponibilités", y3r = "Disponibilités de l'équipe", $3r = "Disponibilité immédiate pour une réunion", w3r = "Code de récupération", k3r = "Codes de récupération", S3r = "Chaque code de récupération peut être utilisé une seule fois pour accorder l'accès sans votre authentificateur.", x3r = "Codes de récupération copiés !", E3r = "Le code de récupération est incorrect.", T3r = "Accès perdu", A3r = "Aucun code de récupération trouvé. Merci de les générer dans vos paramètres.", C3r = "Nouvelle organisation créée : action en attente", z3r = "Bonjour administrateur", O3r = "Une organisation nécessite une configuration DNS", P3r = "Une organisation avec le slug « {{orgSlug}} » a été créée.<br /><br />Assurez-vous de configurer votre registre DNS pour pointer le sous-domaine correspondant à la nouvelle organisation où l'application principale est en cours d'exécution. Autrement, l'organisation ne fonctionnera pas.<br /><br />Voici les options de base pour configurer un sous-domaine pour qu'il pointe vers son application afin qu'il charge la page de profil de l'organisation.<br /><br />Vous pouvez le faire soit avec l'enregistrement A :", I3r = "Ou l'enregistrement CNAME :", R3r = "Une fois le sous-domaine configuré, veuillez marquer la configuration DNS comme terminée dans les paramètres d'administration des organisations.", N3r = "Accéder aux paramètres d'administration des organisations", D3r = "L'organisation a été traitée", M3r = "Une erreur s'est produite lors du traitement de cette organisation", L3r = "Une liste de toutes les organisations. Accepter une organisation permettra à tous les utilisateurs avec ce domaine de messagerie de s'inscrire SANS vérification d'e-mail.", q3r = "Non vérifié", j3r = "Vérifié", F3r = "DNS manquant", V3r = "DNS configuré", B3r = "Marquer comme DNS configuré", U3r = "Valeur", W3r = "Votre organisation a été mise à jour avec succès", G3r = "Cette équipe n'a aucun type d'événement", H3r = "L'option par place ne prend pas en charge les durées multiples", K3r = "Inclure l'événement du calendrier", Y3r = "OAuth", Z3r = "Formulaire de création de client OAuth", Q3r = "Ceci est le formulaire pour créer un nouveau client OAuth", J3r = "Formulaire de mise à jour du client OAuth", X3r = "Ceci est le formulaire pour modifier un client OAuth existant", e6r = "Ajoutées récemment", t6r = "Connectez vos calendriers", n6r = "{{appName}} relève la disponibilité de tous vos calendriers existants.", o6r = "Personnalisez votre expérience de planification avec les workflows", r6r = "Automatisation de workflows", i6r = "Planifiez pour votre équipe grâce à la planification collective et par permutation circulaire", a6r = "Aucun membre trouvé", s6r = "Synchronisation des dossiers", c6r = "Nom du répertoire", l6r = "Fournisseur du répertoire", d6r = "URL de base SCIM", u6r = "Jeton du porteur SCIM", _6r = "URL de base SCIM copiée", p6r = "Le jeton SCIM Bearer a été copié", m6r = "Votre Fournisseur d'identité vous demandera les informations suivantes pour configurer SCIM. Suivez les instructions pour terminer l'installation.", f6r = "Configurer la synchronisation du répertoire", g6r = "Choisissez un fournisseur d'identité pour configurer le répertoire de votre équipe.", h6r = "Configurer un fournisseur d'identité pour commencer avec SCIM.", v6r = "Connexion de synchronisation du répertoire créée.", b6r = "Fourniture et dispense des utilisateurs avec votre fournisseur de répertoire.", y6r = "Connexion de synchronisation du répertoire supprimé.", $6r = "Supprimer la connexion", w6r = "Supprimer la connexion de synchronisation de répertoire", k6r = "Êtes-vous sûr de vouloir supprimer cette connexion de synchronisation de répertoire?", S6r = "Cette action ne peut pas être annulée. Cela supprimera définitivement la connexion de synchronisation du répertoire.", x6r = "Configuration de l'événement : la durée doit être d'au moins 1 minute.", E6r = "Horaires de disponibilité", T6r = "Non autorisé", A6r = "{{clientName}} aimerait accéder à votre compte {{appName}}", C6r = "Sélectionner un compte ou une équipe", z6r = "Cela permettra au {{clientName}} de", O6r = "Vous associer à vos informations personnelles de {{clientName}}", P6r = "Voir vos informations personnelles, y compris celles que vous avez rendues publiques", I6r = "Voir votre adresse e-mail principale", R6r = "Vous connecter à vos applications installées", N6r = "Lire, modifier, supprimer vos types d'événements", D6r = "Lire, modifier, supprimer vos disponibilités", M6r = "Lire, modifier, supprimer vos réservations", L6r = "Autoriser {{clientName}} à faire cela ?", q6r = "En cliquant sur autoriser, vous autorisez cette application à utiliser vos informations conformément à ses conditions de service et à sa politique de confidentialité. Vous pouvez supprimer l'accès dans l'App Store de {{appName}}.", j6r = "Autoriser", F6r = "Cet utilisateur n'a pas terminé son intégration. Vous ne pourrez pas définir sa disponibilité tant qu'il n'aura pas terminé son intégration.", V6r = "Vous consultez les disponibilités de cet utilisateur. Vous ne pouvez modifier que vos propres disponibilités.", B6r = "Vous pouvez modifier ceci pour chaque événement dans les paramètres avancés de chaque type d'événement.", U6r = "Modifier la disponibilité de l'utilisateur : {{username}}", W6r = "Renvoyer l'invitation", G6r = "L'invitation a été renvoyée.", H6r = "SAML", K6r = "Ajouter un client", Y6r = "Après avoir copié le secret, vous ne pourrez plus le voir", Z6r = "Ajouter un nouveau client", Q6r = "Ajouter un nouvel utilisateur", J6r = "Cette application n'a pas encore été configurée", X6r = "au format CSV", e5r = "Superposer mon calendrier", t5r = "En vous connectant à votre calendrier, vous acceptez notre politique de confidentialité et nos conditions d'utilisation. Vous pouvez révoquer cet accès à tout moment.", n5r = "Consultez les événements de votre calendrier afin d'éviter les réservations incompatibles.", o5r = "Rejoignez {{eventLocationType}}", r5r = "Dépannage", i5r = "Calendriers que nous vérifions pour les conflits", a5r = "Horaires de disponibilité", s5r = "Gérer les calendriers", c5r = "Gérer les horaires de disponibilité", l5r = "Verrouillé", d5r = "Déverrouillé", u5r = "Verrouiller le fuseau horaire sur la page de réservation", _5r = "Pour verrouiller le fuseau horaire sur la page de réservation, utile pour les événements en personne.", p5r = "Vous ne pouvez activer qu'une seule application de paiement par type d'événement.", m5r = "Veuillez entrer le numéro au format international.", f5r = "Installer Calendrier", g5r = "Sous-domaine de marque", h5r = "Obtenez votre propre sous-domaine de marque, tel que acme.cal.com", v5r = "Statistiques à l'échelle de l'organisation", b5r = "Comprenez comment l'ensemble de votre organisation passe son temps", y5r = "Marque blanche étendue", $5r = "Personnalisez votre expérience de planification avec votre propre logo, vos couleurs, etc.", w5r = "Équipes illimitées", k5r = "Vérifier l'e-mail", S5r = "Veuillez saisir l'adresse e-mail utilisée pour cette réservation afin de procéder à l'annulation", x5r = "L'e-mail ne correspond pas à l'e-mail de réservation", E5r = "Ajoutez autant de sous-équipes que nécessaire à votre organisation", T5r = "Facturation unifiée", A5r = "Types d'événements gérés avancés", C5r = "Ajoutez une seule carte de crédit pour payer tous les abonnements de votre équipe", z5r = "Entreprise", O5r = "Passez en Entreprise pour créer votre organisation", P5r = "Créer votre organisation", I5r = "Créer une organisation", R5r = "Passez en Organizations et recevez un sous-domaine, une facturation unifiée, des statistiques, un marquage blanc extensif et plus encore", N5r = "Passez à la version Entreprise et accédez à Synchronisation Active Directory, au provisionnement automatique des utilisateurs SCIM, aux agents vocaux Cal.ai, aux API d'administration et à bien d'autres choses encore !", D5r = "Vous ne pouvez activer qu'une seule application de paiement par type d'événement", M5r = "Les équipes membres de cette organisation seront également supprimées avec leurs types d'événements", L5r = "Les utilisateurs qui faisaient partie de l'organisation ne seront pas supprimés, mais leurs noms d'utilisateur seraient modifiés pour leur permettre d'exister en dehors de l'organisation", q5r = "Les types d'événements utilisateur créés après l'intégration de l'utilisateur dans l'organisation seront supprimés", j5r = "Les types d'événements utilisateur migrés ne seront pas supprimés", F5r = "Supprimer {{organizationName}} ?", V5r = "Publiée", B5r = "Non publiée", U5r = "Publier", W5r = "Ouvrez l'outil de dépannage et déterminez ce qui ne va pas avec votre planning", G5r = "Besoin d'aide ?", H5r = "Dépannage", K5r = "Numéro à appeler", Y5r = "Nom de l'invité", Z5r = "Adresse e-mail de l'invité", Q5r = "Entreprise de l'invité", J5r = "Veuillez installer un publier", X5r = "Réservation instantanée", ePr = "Autoriser les gens à réserver immédiatement", tPr = "Passez en Entreprise et autorisez les invités à rejoindre un appel instantané auquel les participants peuvent accéder directement. Ceci n'est valable que pour les types d'événements d'équipe", nPr = "Vous ne voulez pas attendre ?", oPr = "Le rendez-vous a commencé", rPr = "Payer pour réserver", iPr = "Laissez les agents IA vous réserver", aPr = "Impossible de trouver la réservation", sPr = "Les places de réservation sont complètes", cPr = "Identifiants de paiement manquants", lPr = "Id de l'application de paiement manquant", dPr = "La réservation n'a pas assez de places disponibles", uPr = "{{username}} est actuellement en absence de courte durée.", _Pr = "Pendant ce temps, {{profile.username}} sera responsable de tous les rendez-vous programmés de la part de {{username}}.", pPr = "Absent du bureau", mPr = "Configurez des actions dans votre profil pendant votre absence.", fPr = "Envoyer une demande", gPr = "Les dates de début et de fin sont requises", hPr = "La date de début doit être antérieure à la date de fin", vPr = "La date de début doit être dans le futur", bPr = "Utilisateur introuvable", yPr = "Impossible de rediriger vers soi-même", $Pr = "L'entrée absent du bureau existe déjà", wPr = "L'id de l'entrée absent du bureau est requis", kPr = "Une redirection de réservation de cet utilisateur vers vous existe déjà.", SPr = "Création d'une nouvelle entrée réussie", xPr = "Notification de redirection de réservation", EPr = "Notification de redirection de réservation", TPr = "Vous avez reçu une redirection de réservation de la part de {{eventOwner}}. Leurs liens de profil seront redirigés vers le vôtre pour la période du {{dates}}.", APr = "Notification de modification de redirection de réservation", CPr = "Notification de modification de redirection de réservation", zPr = "Votre redirection de réservation de la part de {{eventOwner}} pour la période du {{oldDates}} a été mise à jour. La nouvelle période de redirection est du {{dates}}.", OPr = "Notification d'annulation de redirection de réservation", PPr = "Notification d'annulation de redirection de réservation", IPr = "Votre redirection de réservation de la part de {{eventOwner}}, pour la période du {{dates}}, a été annulée.", RPr = "Vous avez accepté cette demande de redirection de réservation.", NPr = "Vous avez refusé cette demande de redirection de réservation.", DPr = "Copier le lien pour partager la demande", MPr = "Demande de redirection de réservation", LPr = "Sélectionner un membre de l'équipe", qPr = "Vous partez? Marquez simplement le lien de votre profil comme étant indisponible pendant un certain temps.", jPr = "Redirigez votre profil vers un autre membre de l'équipe", FPr = "Redirigez votre profil vers un autre membre de l'équipe (formule Équipe requise)", VPr = "Liste des indisponibilités absent du bureau", BPr = "Suppression de l'entrée réussie", UPr = "Entrée modifiée avec succès", WPr = "Temporairement absent du bureau?", GPr = "Ajouter une redirection", HPr = "Créer une entrée", KPr = "Plage temporelle", YPr = "Ajouter tous les membres de l'équipe, y compris les futurs membres", ZPr = "Redirection vers", QPr = "Vous avez du mal à trouver un créneau?", JPr = "En voir plus", XPr = "Transmettez des paramètres tels que ?email=...&name=.... et plus", eIr = "Planifiez des rendez-vous lorsque tout le monde est disponible ou faites une rotation entre les membres de votre équipe", tIr = "le plus bas", nIr = "bas", oIr = "moyen", rIr = "élevé", iIr = "le plus élevé", aIr = "Envoyer un utilisateur vers", sIr = "Définir la priorité", cIr = "Définir la pondération", lIr = "Activer les pondérations", dIr = "Priorité pour {{userName}}", uIr = "Les pondérations déterminent comment les réunions sont distribuées entre les hôtes. <0>En savoir plus</0>", _Ir = "Pondération pour {{userName}}", pIr = "changer la priorité", mIr = "Utiliser les identifiants de champs comme variables pour la redirection de votre événement personnalisé", fIr = "Utiliser les identifiants de champs comme variables pour la redirection de votre événement personnalisé (par ex. : {{variable}})", gIr = "Le compte est déjà associé", hIr = "Envoyer un e-mail", vIr = "Appeler le participant en utilisant l'agent vocal Cal.ai", bIr = "Appel pour confirmer la réservation", yIr = "2 heures avant le début de l'événement", $Ir = "Configuration de l'agent Cal.ai", wIr = "Veuillez choisir au moins un type d'événement pour effectuer un appel test.", kIr = "Marquer comme absence", SIr = "Ne plus marquer comme absence", xIr = "Dissociation du compte réussie", EIr = "Une erreur est survenue lors de la dissociation du compte", TIr = "Programme de voyage", AIr = "Planifiez votre voyage à l'avance pour conserver votre horaire actuel dans un fuseau horaire différent et éviter d'être réservé à minuit.", CIr = "Changement de fuseau horaire", zIr = "Date", OIr = "Saisissez l'invite générale pour l'agent", PIr = "Cette date chevauche un horaire existant. Veuillez sélectionner une autre date.", IIr = "Recevez des notifications lorsque votre équipe n'est pas disponible", RIr = "Les administrateurs recevront des notifications par e-mail lorsqu'un utilisateur essaiera de réserver un membre de l'équipe et qu'il rencontrera la mention « Pas de disponibilité ». Nous déclenchons cet e-mail après deux occurrences et nous vous rappelons tous les 7 jours par utilisateur.  ", NIr = "Désactiver les notifications SMS pour les types d'événements par téléphone uniquement", DIr = "Désactiver les notifications SMS automatisées pour les types d'événements qui n'ont que le numéro de téléphone (attendeePhoneNumber) comme question obligatoire avec l'email en option ou non requis", MIr = "Votre formule actuelle", LIr = "37 $ par utilisateur par mois", qIr = "Gérez les paramètres de confidentialité de votre organisation", jIr = "Confidentialité", FIr = "De nouvelles équipes seront rattachées à votre organisation", VIr = "Ajouter un nom de groupe", BIr = "Nom de groupe", UIr = "Routeurs", WIr = "Primaire", GIr = "Rendre primaire", HIr = "Ajouter un e-mail", KIr = "Ajouter des e-mails", YIr = "Ajoutez une adresse e-mail pour remplacer votre adresse principale ou pour utiliser comme adresse de courriel alternative sur vos types d'événements.", ZIr = "Confirmez votre adresse e-mail", QIr = "$t(hey_there) {{name}}, confirmation de votre réservation le {{date}}.", JIr = "Le prénom de la personne qui effectue la réservation", XIr = "Le nom de famille de la personne qui effectue la réservation", eRr = "Nom du planificateur", tRr = "Votre prénom", nRr = "Nous avons envoyé un e-mail à <strong>{{email}}</strong>. Cliquez sur le lien dans l'e-mail pour vérifier cette adresse.", oRr = "Envoyer les détails de l'événement à", rRr = "Fuseau horaire de la planification sans date de fin", iRr = "Sélectionner les membres", aRr = "Que devons-nous faire des types d'évènements existants de votre membre ?", sRr = "Tous les types d'évènements individuels de vos membres (à l'exception des évènements gérés) seront définitivement supprimés. Ils ne pourront plus en créer de nouveaux", cRr = "Les types d'évènements individuels de vos membres seront masqués (à l'exception des évènements gérés) dans les profils, mais les liens seront toujours actifs. Ils ne pourront pas en créer de nouveaux.  ", lRr = "Masquer les types d'évènements individuels", dRr = "Supprimer les types d'évènements individuels", uRr = "Verrouiller la création de types d'évènements individuels", _Rr = "Empêchez les membres de créer leurs propres types d'évènements.", pRr = "Ajouter un type d'évènement", mRr = "Créer le mot de passe du compte", fRr = "Créer un compte avec SAML", gRr = "Échec de la création du mot de passe du compte", hRr = "Impossible de créer un mot de passe pour les comptes cal", vRr = "Impossible de créer un mot de passe pour un compte déjà créé", bRr = "Vous n'avez pas de mot de passe pour votre compte. Créez-en un depuis Sécurité -> Mot de passe. Vous ne pouvez pas vous déconnecter tant que le mot de passe du compte n'a pas été créé.", yRr = "Déconnecter le compte connecté", $Rr = "La déconnexion de votre compte connecté modifiera votre façon de vous connecter. Vous ne pourrez plus vous connecter à votre compte qu'en utilisant votre adresse e-mail et votre mot de passe", wRr = "J'accepte la politique de confidentialité et l'utilisation des cookies", kRr = "Passer un appel", SRr = "Ignorer l'affectation par permutation circulaire si le contact existe dans Salesforce", xRr = "L'URL doit contenir l'adresse e-mail du contact en tant que paramètre. Ex. : ?email=contactEmail", ERr = "Sélectionnez un compte", TRr = "Installez {{appName}} sur votre compte personnel ou sur le compte d'une équipe.", ARr = "Sélectionner des types d'évènement", CRr = "Sur quel type d'évènement voulez-vous installer {{appName}} ?", zRr = "Configurer {{appName}}", ORr = "Finalisez la configuration de l'application. Vous pourrez modifier ces paramètres ultérieurement.", PRr = "déjà installé", IRr = "Non spécifiée", RRr = "Vacances", NRr = "Voyage", DRr = "Congé maladie", MRr = "Jour férié", LRr = "Transfert vers <0>{{username}}</0>", qRr = "Pas de transfert", jRr = "Créer une absence", FRr = "Communiquez à vos utilisateurs lorsque vous n'êtes pas disponible pour prendre des réservations. Ils peuvent toujours prendre une réservation à votre retour ou vous pouvez les transmettre à un membre de l'équipe.", VRr = "{{displayName}} est en absence", BRr = "<0>{{displayName}}</0> peut prendre vos rendez-vous quand vous n'êtes pas là.", URr = "Réserver {{displayName}}", WRr = "Sélectionnez une raison", GRr = "Passer en absence", HRr = "Modifier une entrée d'absence", KRr = "Envoyer un commentaire", YRr = "Votre hôte ne s'est pas présenté", ZRr = "Vous pouvez reprogrammer un autre rendez-vous avec lui ou elle", QRr = "Comment pouvons-nous améliorer notre service ?", JRr = "Qu'avez-vous préféré ?", XRr = "Examiner", eNr = "Évalué", tNr = "Sans évaluation", nNr = "URL d'évaluation", oNr = "L'URL du formulaire de commentaire et d'évaluation", rNr = "URL d'absence", iNr = "L'URL de commentaire en cas de non présentation", aNr = "Pas besoin d'assistance ?", sNr = "Masquer l'assistance", cNr = "Évaluations moyennes", lNr = "Absence (hôte)", dNr = "Absence (invité)", uNr = "Évaluations récentes", _Nr = "Aucune évaluation envoyée", pNr = "Ajoutez un flux de travail avec « Évaluation » pour récupérer les évaluations après les réunions", mNr = "Hôte avec le plus d'absences", fNr = "Mieux noté", gNr = "Moins bien noté", hNr = "Membres dont les réunions sont les mieux notées", vNr = "Membres dont les réunions sont les moins bien notées", bNr = "Score CSAT", yNr = "SMS verrouillé", $Nr = "Partir sans affecter personne ?", wNr = "Voulez-vous vraiment quitter cet évènement sans ajouter de participants ?", kNr = "Si vous n'affectez personne à cet évènement, aucune disponibilité ne sera indiquée aux personnes qui effectuent une réservation.", SNr = "Revenir en arrière et affecter", xNr = "Quitter sans affecter", ENr = "En poursuivant, vous acceptez nos <0>Conditions d'utilisation</0> et <1>Politique de confidentialité</1>.", TNr = "En continuant, vous acceptez nos", ANr = "Conditions", CNr = "Tout disponible pendant {{x}} jours", zNr = "Déplace automatiquement la fenêtre de réservation de {{x}} jours chaque jour, garantissant que votre calendrier affiche toujours les {{x}} prochains jours de créneaux disponibles.", ONr = "Abonnement d'équipe annulé avec succès", PNr = "Erreur lors de l'annulation de l'abonnement d'équipe", INr = "Une erreur est survenue lors de la souscription à l'offre de plateforme. Veuillez réessayer plus tard", RNr = "Une erreur est survenue lors de la mise à jour du client OAuth. Veuillez réessayer plus tard", NNr = "Une erreur est survenue lors de la création du client OAuth. Veuillez réessayer plus tard", DNr = "Couleur du type d'événement", MNr = "Cette couleur est uniquement utilisée pour différencier les types d'événements et les réservations dans l'application. Elle n'est pas affichée aux personnes qui réservent.", LNr = "Marquer comme absence", qNr = "{{x}} marqués comme absences", jNr = "{{x}} plus marqués comme absences", FNr = "déclencheurs pour tous les types d'événements d'équipe et les types d'événements personnels de tous les membres de l'équipe", VNr = "Gérez les paramètres de votre équipe", BNr = "Statut absence mis à jour pour les participants", UNr = "E-mail copié", WNr = "Numéro de téléphone copié", GNr = "L'utilisateur est un membre en attente de l'organisation", HNr = "L'utilisateur a déjà été invité ou est déjà membre", KNr = "L'utilisateur est membre d'une organisation dont cette équipe ne fait pas partie.", YNr = "La réservation a été réaffectée", ZNr = "Réaffecter", QNr = "Réaffecter la réservation à un autre hôte round robin disponible", JNr = "Assigner un membre de l'équipe", XNr = "Remplacer le membre de l'équipe que vous souhaitez assigner.", eDr = "Aucun hôte disponible", tDr = "Réaffecter l'hôte round robin", nDr = "Ne pas écrire dans le flux ICS", oDr = "Le report n'est pas possible car l'événement a expiré", rDr = "Cet événement a expiré", iDr = "Ne pas créer de contacts s'ils n'existent pas dans {{appName}}", aDr = "Si votre lien ICS est en lecture seule (par exemple, Proton Calendar), cochez la case ci-dessus pour éviter les erreurs. Vous devrez également mettre à jour manuellement votre calendrier pour les changements.", sDr = "Attributs", cDr = "Nouvel attribut", lDr = "Ajouter des attributs", dDr = "Ajouter des attributs à vos membres d'équipe", uDr = "Nouvelle option", _Dr = "Mettre à jour le membre", pDr = "Attribut", mDr = "Créer un attribut pour les membres de votre équipe", fDr = "Modifier un attribut pour les membres de votre équipe", gDr = "Attribut mis à jour avec succès", hDr = "Attribut supprimé avec succès", vDr = "Attributs modifiés avec succès", bDr = "Gérer les attributs de vos membres d'équipe", yDr = "Modifier les attributs de vos membres d'équipe", $Dr = "Retour aux attributs", wDr = "Êtes-vous sûr de vouloir supprimer cette option ?", kDr = "Cette option est attribuée à {{numberOfUsers}} membres. Sa suppression l'enlèvera de leur profil.", SDr = "Désactiver les e-mails standard aux participants liés à ce type d'événement", xDr = "Désactive la communication par e-mail standard liée à ce type d'événement, y compris les confirmations de réservation, les rappels et les annulations.", EDr = "Désactiver les e-mails standard aux hôtes liés à ce type d'événement", TDr = "Tapez 'confirmer' pour continuer", ADr = "Désactiver l'e-mail", CDr = "Accorder l'accès à l'API d'administration", zDr = "Révoquer l'accès à l'API d'administration", ODr = "Ajouter le calendrier {{calendar}}", PDr = "Connecter le calendrier Apple", IDr = "Calendrier Apple connecté", RDr = "Vérification du calendrier Apple", NDr = "Connecter le calendrier Google", DDr = "Calendrier Google connecté", MDr = "Vérification du calendrier Google", LDr = "Connecter le calendrier Outlook", qDr = "Calendrier Outlook connecté", jDr = "Vérification du calendrier Outlook", FDr = "Se connecter à Stripe", VDr = "Stripe connecté", BDr = "Vérification des identifiants Stripe", UDr = "Variables de réponse aux questions de réservation", WDr = "Géré par {{teamAdmins}}", GDr = "{{count}} options", HDr = "Reprogrammer avec le même hôte round-robin", KDr = "Les événements reprogrammés seront attribués au même hôte que celui initialement prévu", YDr = "Désactiver la saisie si l'identifiant URL est prérempli", ZDr = "Limites de réservation", QDr = "Limites de réservation pour les membres de l'équipe sur tous les types d'événements d'équipe", JDr = "Limiter le nombre de fois où les membres peuvent être réservés pour tous les types d'événements d'équipe", XDr = "Limites de réservation mises à jour avec succès", eMr = "Vous n'êtes pas autorisé à apporter cette modification à la réservation", tMr = "Identifiant de délégation désactivé", nMr = "Membres correspondants", oMr = "{{x}} membres correspondants", rMr = "File d'attente des membres correspondants (selon les pondérations d'attributs)", iMr = "File d'attente des membres correspondants (selon les pondérations des assignés à l'événement)", aMr = "Aucun membre correspondant. Par défaut, les membres de l'équipe assignés au type d'événement seront utilisés.", sMr = "Aucun membre correspondant. Le système utilisera par défaut les membres de l'équipe assignés au type d'événement. Envisagez d'ajouter une solution de repli ou de corriger la logique d'utilisation des membres de repli", cMr = "Masquer les détails des événements du calendrier sur les calendriers partagés", lMr = "Lorsqu'un calendrier est partagé, les événements sont visibles pour les lecteurs, mais leurs détails sont cachés pour ceux qui n'ont pas d'accès en écriture.", dMr = "{{count}} derniers jours", uMr = "Mois en cours", _Mr = "Année en cours", pMr = "Période personnalisée", mMr = "Politique de remboursement", fMr = "Toujours", gMr = "Jamais", hMr = "Option de paiement", vMr = "Si annulé", bMr = "avant", yMr = "Afficher toutes les colonnes", $Mr = "Basculer les colonnes", wMr = "Aucune colonne trouvée", kMr = "Lors de la réservation, ajouter les événements et les nouveaux participants en tant que :", SMr = "Prospect", xMr = "Contact sous un compte", EMr = "Ne pas créer d'enregistrement {{entry}} s'il n'existe pas dans Salesforce", TMr = "Si le contact n'existe pas sous un compte, créer un nouveau prospect à partir du participant", AMr = "Créer un nouveau contact sous un compte basé sur le domaine e-mail du participant et les contacts existants", CMr = "Changer le propriétaire de l'enregistrement lors de la réservation", zMr = "Attribuer des attributs en masse", OMr = "Cela affiche un message personnalisé. Essayez de modifier la réponse pour rediriger vers un événement", PMr = "Cela entraîne une redirection vers {{externalUrl}}. Essayez de modifier la réponse pour rediriger vers un événement", IMr = "Hôte possible", RMr = "Statut d'acheminement actuel", NMr = "Réacheminer la réservation", DMr = "Réacheminer la réservation vers différents membres de l'équipe", MMr = "Vérifier le nouvel itinéraire", LMr = "Réacheminer", qMr = "Nouveau statut d'acheminement", jMr = "Si le participant existe dans Salesforce, réserver directement avec le propriétaire", FMr = "Entité dont il faut vérifier le propriétaire pour réserver directement", VMr = "Compte", BMr = "Choisir les horaires des hôtes", UMr = "Vous pouvez sélectionner un horaire différent pour chaque hôte. L'horaire par défaut de chaque hôte est choisi par défaut.", WMr = "Aucun hôte assigné, ajoutez des hôtes dans l'onglet d'affectation.", GMr = "Réassigner manuellement l'hôte round robin", HMr = "Réassigner manuellement l'hôte round robin à un autre hôte disponible", KMr = "Réassigner l'hôte round robin à un autre hôte disponible", YMr = "Le nouvel utilisateur n'est pas un hôte round robin valide pour ce type d'événement", ZMr = "Le nouvel utilisateur est un hôte fixe pour ce type d'événement", QMr = "Replanifier avec le même créneau horaire", JMr = "Replanifier avec le même créneau horaire du nouvel événement", XMr = "Replanifier vers le nouvel événement avec un créneau horaire différent", eLr = "Replanifier avec un créneau horaire différent", tLr = "Nous n'avons pas d'identifiant pour le nouvel événement. Veuillez retourner au formulaire de routage et l'enregistrer à nouveau.", nLr = "Réservation réacheminée avec succès. Redirection vers la page de réservation", oLr = "Lors de la réservation, écrire dans l'objet de l'événement", rLr = "Nom du champ", iLr = "Ajouter un nouveau champ", aLr = "Vous n'avez pas accès pour rediriger cette réservation", sLr = "Réponse du formulaire non trouvée", cLr = "Propriétaire du contact", lLr = "Non trouvé", dLr = "Utilisation des membres de repli", uLr = "Itinéraire choisi", _Lr = "Logique d'attribut correspondante", pLr = "Logique de repli d'attribut correspondante", mLr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajouter des règles d'attributs.", fLr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajouter des règles d'attributs pour le repli.", gLr = "Tous les membres assignés au type d'événement d'équipe. Envisagez d'ajuster le repli pour obtenir une correspondance.", hLr = "Avertissement", vLr = "Repli : si aucun membre de l'équipe ne correspond, utilisez ceux qui correspondent aux critères suivants (correspond par défaut à tous les membres de l'équipe assignés à l'événement)", bLr = "Avertissement de repli", yLr = "Non nécessaire", $Lr = "Hôte indisponible", wLr = "Hôte disponible", kLr = "Êtes-vous sûr de vouloir réassigner cette réservation à un hôte indisponible ?", SLr = "Êtes-vous sûr de vouloir réassigner cette réservation ?", xLr = "Oui, réassigner", ELr = "Filtrer par attributs", TLr = "Raison de la réassignation", ALr = "La modification du type de champ peut entraîner une perte de données. Veuillez plutôt créer un nouveau champ.", CLr = "Réassigné par", zLr = "ligne", OLr = "lignes", PLr = "Fuseau horaire du participant", ILr = "Heure de début de l'événement dans le fuseau horaire du participant", RLr = "Heure de début de l'événement dans le fuseau horaire du participant", NLr = "Heure de fin de l'événement dans le fuseau horaire du participant", DLr = "Heure de fin de l'événement dans le fuseau horaire du participant", MLr = "Créer un événement sur le contact, s'il existe. Sinon, utiliser le lead comme alternative", LLr = "Nom du propriétaire à modifier", qLr = "Aucun filtre défini", jLr = "Test de réservation réussi", FLr = "Le test à blanc a été effectué avec succès.", VLr = "Vous n'avez pas accès à cette page", BLr = "Pour voir ou interagir avec cette page, vous devez avoir des privilèges d'administrateur ou de propriétaire", ULr = "Type de champ", WLr = "Quand écrire", GLr = "Lors de la réservation, écrire dans un champ personnalisé sur l'enregistrement {{record}} du participant", HLr = "À chaque réservation", KLr = "Seulement si le champ est vide", YLr = "Date de début de la réservation", ZLr = "Date de création de la réservation", QLr = "Réservation réassignée à {{host}}", JLr = "Aucun propriétaire de contact", XLr = "Formulaires de routage créés", eqr = "Réponses totales", tqr = "Réponses totales sans réservation", nqr = "Réponses totales avec réservation", oqr = "Aucune réservation", rqr = "Nom du formulaire", iqr = "Réservation", aqr = "Aucune réservation", sqr = "Réservé par", cqr = "Créé le", lqr = "Statut de la réservation", dqr = "Réservé le", uqr = "Soumis le", _qr = "Copier l'URL de redirection", pqr = "URL de redirection à la sortie", mqr = "Total des réservations par période", fqr = "Acheminé vers par période", gqr = "Par jour", hqr = "Par semaine", vqr = "Par mois", bqr = "Motif d'attribution", yqr = "Accès refusé", $qr = "Le propriétaire du contact sera l'hôte Round Robin si disponible", wqr = "Ajouter de nouveaux participants en tant que", kqr = "Le propriétaire du contact ne sera pas forcé (peut toujours être l'hôte si cela correspond aux attributs et aux critères Round Robin)", Sqr = "Acheminer vers un utilisateur correspondant à un champ de recherche sur un compte", xqr = "Option Salesforce", Eqr = "Nom du champ de recherche", Tqr = "Si le participant a un domaine de messagerie gratuit, ignorer la vérification du propriétaire et procéder au round robin normalement", Aqr = "Est", Cqr = "N'est pas", zqr = "Contient", Oqr = "Ne contient pas", Pqr = "Commence par", Iqr = "Se termine par", Rqr = "Est vide", Nqr = "N'est pas vide", Dqr = "Traduction automatique du titre et de la description", Mqr = "Traduit automatiquement les titres et descriptions dans la langue du navigateur du visiteur en utilisant l'IA.", Lqr = "Distribution", qqr = "Permet d'optimiser la distribution pour une disponibilité maximale ou pour viser une répartition plus équilibrée.", jqr = "Maximiser la disponibilité", Fqr = "Permet aux participants de réserver des réunions dès qu'un hôte est disponible. Utilisez cette option pour maximiser le nombre potentiel de réunions réservées lorsque la distribution équitable des réunions entre les hôtes est moins importante.", Vqr = "Équilibrage de charge", Bqr = "Nous surveillerons le nombre de réservations effectuées avec chaque hôte et le comparerons avec les autres, en désactivant certains hôtes trop en avance pour que les réservations soient réparties équitablement.", Uqr = "Modifier les pondérations", Wqr = "Pondérations mises à jour avec succès", Gqr = "Exiger une confirmation uniquement pour les fournisseurs de messagerie gratuits (Ex. @gmail.com, @outlook.com)", Hqr = "Exclure les e-mails contenant ...", Kqr = "Exiger des e-mails qui contiennent...", Yqr = "Veuillez entrer une adresse e-mail professionnelle valide", Zqr = "Vous n'êtes pas autorisé à effectuer une réservation avec ce domaine e-mail. Veuillez contacter le propriétaire de ce lien.", Qqr = "Rechercher dans les colonnes", Jqr = "Options de recherche", Xqr = "Désactiver le profil public de l'organisation et rediriger", e9r = "Redirige {{orgSlug}}.cal.com vers {{destination}}", t9r = "Sélection unique", n9r = "Sélection multiple", o9r = "Paramètres de conflit de calendrier", r9r = "Sélectionnez les calendriers à vérifier pour les conflits", i9r = "Réunion de groupe", a9r = "Êtes-vous sûr de vouloir supprimer cette application de", s9r = "Déconnecter l'application de", c9r = "Ne pas créer de nouveaux enregistrements pour les invités ajoutés à la réservation", l9r = "Google Meet", d9r = "Zoom", u9r = "Vidéo MS Teams", _9r = "Verrouiller pour l'attribution", p9r = "Le verrouillage n'autorisera que les attributions depuis la synchronisation d'annuaire", m9r = "Attribut modifié avec succès", f9r = "Nouvelle option de groupe", g9r = "Pondération activée", h9r = "En activant la pondération, il sera possible d'attribuer une priorité plus élevée à certains attributs par utilisateur. Plus le poids est élevé, plus la priorité est importante.", v9r = "Acheminé", b9r = "Réaffecté", y9r = "Autoriser la reprogrammation des événements passés", $9r = "L'activation de cette option permet de reprogrammer les événements passés", w9r = "Réacheminé", k9r = "Affectation Salesforce", S9r = "Position du routeur", x9r = "Afficher les hôtes correspondants", E9r = "Aucune file d'attente active pour cette entrée", T9r = "Poids", A9r = "Calibrage", C9r = "Déficit", z9r = "Formulaire de routage", O9r = "Retourner et sauvegarder", P9r = "Enregistrer les modifications", I9r = "Quitter sans sauvegarder", R9r = "Êtes-vous sûr de vouloir quitter sans sauvegarder les modifications de votre formulaire de routage ?", N9r = "Une erreur inattendue s'est produite", D9r = "Vous effectuez une réservation test.", M9r = "Présentation des icônes", L9r = "Présentation des icônes", q9r = "Migration depuis l'équipe", j9r = "La fonctionnalité est actuellement désactivée", F9r = "Choisir une option", V9r = "Saisir la valeur de l'option", B9r = "Supprimer l'option", U9r = "Utiliser les pondérations d'attributs", W9r = "Si activé, toutes les pondérations définies dans le type d'événement seront ignorées", G9r = "Attribut pour les pondérations", H9r = "Utilisateurs gérés", K9r = "Voir tous les utilisateurs gérés créés par votre client OAuth", Y9r = "Pouvez-vous me parler de ", Z9r = "Utilisez l'IA pour répondre à vos questions", Q9r = "Erreur lors de la récupération de la réponse ", J9r = "Une erreur inattendue s'est produite. Veuillez réessayer plus tard", X9r = "Sélectionner le client OAuth", ejr = "Sur chaque instance", tjr = "La fonctionnalité d'identifiant de délégation n'est pas activée pour votre organisation", njr = "Note interne", ojr = "Raison partagée avec le client (facultatif)", rjr = "Cette note sera visible uniquement par les membres de votre équipe", ijr = "Modèles de notes d'annulation internes", ajr = "Créez des modèles de notes internes qui peuvent être appliqués aux réservations", sjr = "Modèles de notes internes mis à jour avec succès", cjr = "Ajouter un modèle", ljr = "Autoriser", djr = "Suivant", ujr = "Masquer", _jr = "Afficher", pjr = "Paramètres UTM", mjr = "Aucun paramètre UTM disponible.", fjr = "Asc", gjr = "Desc", hjr = "Vérifier le changement d'e-mail", vjr = "Acheter des crédits", bjr = "Crédits", yjr = "Crédits utilisés", $jr = "Total restant", wjr = "Vous recevez 1000 crédits par mois, par membre de l'équipe", kjr = "Vous recevez 750 crédits par mois, par membre de l'équipe", Sjr = "Consulter et gérer les crédits pour l'envoi de SMS", xjr = "Consultez et gérez les crédits pour l'envoi de SMS. Un crédit vaut 1¢ (USD). <0>En savoir plus</0>", Ejr = "Un crédit vaut 1¢ (USD). <0>En savoir plus</0>", Tjr = "Acheter des crédits supplémentaires (0,01 $ par crédit)", Ajr = "Vous pouvez consulter les dépenses de crédits supplémentaires dans votre journal des dépenses", Cjr = "Aperçu", zjr = "L'identifiant de l'organisation est déjà pris", Ojr = "Vous ne pouvez pas créer une organisation car vous faites déjà partie d'une organisation", Pjr = "Vous devez terminer l'intégration utilisateur avant de créer une organisation", Ijr = "Utilisez l'e-mail de l'entreprise pour créer une organisation", Rjr = "Vous ne pouvez pas créer une organisation plateforme car vous faites déjà partie d'une équipe", Njr = "Vous devez avoir un minimum d'équipes publiées", Djr = "Vous faites déjà partie de cette organisation", Mjr = "Vous faites partie d'une autre organisation, impossible de créer une nouvelle organisation", Ljr = "Vous faites partie d'une autre organisation de plateforme, impossible de créer une nouvelle organisation", qjr = "Paiement de l'organisation réussi", jjr = "Votre organisation a été créée avec succès", Fjr = "Cela peut prendre quelques secondes...", Vjr = "Statut d'intégration de l'organisation", Bjr = "Description du statut d'intégration de l'organisation", Ujr = "Le paiement a échoué", Wjr = "Votre paiement a échoué. Veuillez réessayer.", Gjr = "Création de votre organisation", Hjr = "L'intégration de l'organisation est déjà terminée", Kjr = "L'intégration de l'organisation existe déjà", Yjr = "Intégration de l'organisation non trouvée", Zjr = "Paiement réussi !", Qjr = "Transfert de l'intégration", Jjr = "Transfert de l'intégration à l'utilisateur", Xjr = "Une organisation existe déjà avec ce slug", eFr = "Vous n'avez pas la permission de créer une organisation pour cet e-mail", tFr = "Vous n'avez pas la permission de migrer une ou plusieurs des équipes", nFr = "L'organisation a déjà un abonnement", oFr = "Réinitialiser l'intervalle pour le Round Robin pondéré", rFr = "Intervalle", iFr = "Détermine la fréquence à laquelle le compteur de réservations round-robin se réinitialise pour assurer une distribution équilibrée.", aFr = "Quotidien", sFr = "Vous n'avez pas défini de date de fin pour votre absence", cFr = "Mes absences", lFr = "Absences de l'équipe", dFr = "Gérez les absences de votre équipe.", uFr = "Créer une absence", _Fr = "Créer une absence pour un membre de l'équipe", pFr = "Modifier une absence pour un membre de l'équipe", mFr = "Créer une absence pour votre équipe", fFr = "Informez les utilisateurs lorsque les membres de votre équipe ne sont pas disponibles pour prendre des réservations. Ils peuvent toujours être réservés à leur retour ou vous pouvez les rediriger vers un autre membre de l'équipe.", gFr = "La redirection des absences n'est autorisée que vers un membre de la même équipe.", hFr = "Il existe déjà une redirection inverse entre ces utilisateurs.", vFr = "Aucune absence précédente trouvée", bFr = "Précédent", yFr = "Intervalle Round Robin mis à jour avec succès", $Fr = "Mode d'essai", wFr = "Plan d'équipe inactif", kFr = "Votre plan d'équipe est inactif. Vérifiez votre abonnement ou contactez le support client", SFr = "Accès limité pendant l'essai. Fonctionnalité disponible après la fin de l'essai.", xFr = "Programme de parrainage", EFr = "Gagnez 20% de parrainage", TFr = "Vous avez besoin d'une clé API Dub et d'un identifiant de programme pour utiliser cette page.", AFr = "UID", CFr = "Lien", zFr = "lignes par page", OFr = "{{currentRange}} sur {{totalItems}}", PFr = "Astuce : vous pouvez ajouter un '+' entre les noms d'utilisateurs : cal.com/anna+brian pour créer une réunion de groupe dynamique", IFr = "Vous n'avez pas encore d'équipe", RFr = "Vous n'avez pas encore de membres d'équipe", NFr = "Les événements récurrents ne prennent pas en charge la fonctionnalité de places. Rendez-le non récurrent pour activer les places.", DFr = "L'événement récurrent ne prend pas en charge la fonctionnalité de limite de réservation par réservateur. Désactivez la limite de réservation par réservateur pour activer l'événement récurrent.", MFr = "La fonctionnalité de places ne prend pas en charge les événements récurrents. Désactivez la fonctionnalité de places pour le rendre récurrent.", LFr = "Les événements récurrents ne prennent pas en charge la fonctionnalité de places. Désactivez la fonctionnalité de places ou rendez l'événement non récurrent.", qFr = "Segment", jFr = "Filtres enregistrés", FFr = "Renommer", VFr = "Renommer le segment", BFr = "Supprimer le segment", UFr = "Dupliquer le segment", WFr = "Êtes-vous sûr de vouloir supprimer ce segment ? Cette action ne peut pas être annulée.", GFr = "Segment de filtre mis à jour", HFr = "Erreur lors de la mise à jour du segment de filtre", KFr = "Segment de filtre dupliqué", YFr = "Erreur lors de la duplication du segment de filtre", ZFr = "Segment de filtre supprimé", QFr = "Erreur lors de la suppression du segment de filtre", JFr = "Enregistrer le segment", XFr = "Segment introuvable", e8r = "Segment de filtre enregistré", t8r = "Aucun segment", n8r = "Erreur lors de l'enregistrement du segment de filtre", o8r = 'Enregistrer les remplacements pour "{{name}}"', r8r = "Créer un nouveau segment", i8r = "Enregistrer pour l'équipe", a8r = "Sélectionner une équipe", s8r = "Veuillez sélectionner une équipe", c8r = "Personnel", l8r = "Masquer le lien du profil d'équipe", d8r = "Masquer le lien du profil d'équipe sur les pages de réservation", u8r = "Affichage", _8r = "Impossible de trouver le slug pour publier l'organisation", p8r = "Liste de sélection", m8r = "Plus d'annulations", f8r = "Langue de l'interface", g8r = "Définissez votre langue préférée pour l'interface de réservation", h8r = "Langue du navigateur du visiteur", v8r = "Nom ou e-mail", b8r = "Si aucun contact n'est trouvé, se rabattre sur le propriétaire du lead s'il existe", y8r = "L'achat de crédits a échoué. Veuillez réessayer ou contacter le support.", $8r = "Minimum de 50 crédits requis", w8r = "Activer l'identifiant de délégation", k8r = "Accordez à Cal.com un accès automatique aux calendriers de tous les membres de l'organisation en activant l'identifiant de délégation.", S8r = "Désactiver l'identifiant de délégation", x8r = "Une fois les identifiants de délégation désactivés, les membres de l'organisation qui n'ont pas connecté leurs calendriers devront le faire manuellement.", E8r = "Dernière activité", T8r = "Membre depuis", A8r = "Dernière mise à jour", C8r = "Lors de l'annulation d'une réservation, écrire dans l'enregistrement de l'événement au lieu de le supprimer", z8r = "À chaque annulation", O8r = "Signaler un problème", P8r = "Vous pouvez soumettre un ticket sur GitHub ou mettre à niveau votre forfait pour bénéficier d'une assistance en temps réel avec des conférences de développeurs", I8r = "Ouvrir un problème", R8r = "Ceci est votre forfait actuel", N8r = "Planifier un horaire", D8r = "Cela comprend :", M8r = "Client OAuth mis à jour avec succès", L8r = "Client OAuth introuvable.", q8r = "S'abonner à la plateforme", j8r = "Erreur lors de la tentative d'accès aux webhooks.", F8r = "Échec de la mise à jour du webhook.", V8r = "Échec de la création du webhook.", B8r = "Lien invalide", U8r = "Vous êtes actuellement abonné au forfait {{planFirstLetter}}{{planRest}}", W8r = "Utilisateur/Équipe", G8r = "ID client copié !", H8r = "Secret client copié !", K8r = "L'équipe de Cal.com effectue une maintenance planifiée. Si vous avez des questions, veuillez contacter le support.", Y8r = "Votre paiement a échoué", Z8r = "Vérifiez votre boîte de réception", Q8r = "Votre compte a été créé, mais votre premium n'a pas été réservé.", J8r = "Nous avons envoyé un e-mail à {{email}} avec un lien pour activer votre compte.", X8r = "Une fois votre compte activé, vous pourrez essayer d'acheter votre nom d'utilisateur premium à nouveau ou en sélectionner un autre.", e7r = "Ouvrir dans Gmail", t7r = "Vous ne voyez pas d'e-mail ?", n7r = "Renvoyer dans {{seconds}} secondes", o7r = "Renvoyer", r7r = "E-mail de vérification envoyé", i7r = "Sélectionner tous les membres", a7r = "La sélection de tous les membres ajoutera automatiquement tous les futurs membres de l'équipe lorsqu'ils seront ajoutés à l'équipe.", s7r = "Paramètres du formulaire", c7r = "Supprimer le statut de liste blanche", l7r = "Mettre les workflows utilisateur en liste blanche", d7r = "Workflows utilisateur mis en liste blanche", u7r = "Workflows utilisateur retirés de la liste blanche", _7r = "Date et heure", p7r = "Ceci est un rappel concernant votre événement à venir.", m7r = "Ce rappel a été déclenché par un workflow dans Cal.", f7r = "Événement", g7r = "Planifié par", h7r = "Comment s'est déroulée votre dernière expérience ?", v7r = "Nous cherchons toujours à améliorer l'expérience client.", b7r = "Dans quelle mesure étiez-vous satisfait de votre dernière réunion ?", y7r = "vous n'avez pas participé à la réunion ?", $7r = "Reprogrammer ici.", w7r = "Masquer l'e-mail de l'organisateur", k7r = "Vous faites déjà partie d'une organisation de plateforme, c'est pourquoi vous ne pouvez pas créer une nouvelle organisation. Chaque utilisateur ne peut appartenir qu'à une seule organisation. Veuillez créer un nouveau compte cal.com avec une adresse e-mail différente et utiliser ce compte pour vous abonner au plan des organisations.", S7r = "Vous faites déjà partie d'une organisation, c'est pourquoi vous ne pouvez pas créer une organisation de plateforme. Chaque utilisateur ne peut appartenir qu'à une seule organisation. Veuillez créer un nouveau compte cal.com avec une adresse e-mail différente et utiliser ce compte pour vous abonner au plan de plateforme.", x7r = "Masquer l'adresse e-mail de l'organisateur sur l'écran de réservation, les notifications par e-mail et les événements du calendrier", E7r = "Vous &", T7r = "Sélectionner un e-mail vérifié", A7r = "Ajouter une adresse e-mail vérifiée", C7r = "Ajouter des adresses e-mail vérifiées", z7r = "E-mail 'Répondre à' personnalisé", O7r = "Utiliser une adresse e-mail différente comme destinataire de réponse pour les e-mails de confirmation au lieu de l'e-mail de l'organisateur", P7r = "Ce questionnaire a été déclenché par un Workflow dans Cal.", I7r = "Ignorer la période d'essai", R7r = "Périodes d'essai d'équipe ignorées avec succès", N7r = "En saisissant votre numéro de téléphone, vous consentez à recevoir des SMS pour cet événement. Des frais de SMS peuvent s'appliquer.", D7r = "Plus d'informations sont disponibles dans <0>Analyses de routage</0>", M7r = "Résultats", L7r = "Voir le formulaire", q7r = "Envoyez STOP pour vous désinscrire des messages SMS", j7r = "Votre équipe {{teamName}} manque de crédits", F7r = "Vous manquez de crédits", V7r = "[Action requise] Votre équipe {{teamName}} n'a plus de crédits", B7r = "[Action requise] Vous n'avez plus de crédits", U7r = "Votre équipe Cal.com {{teamName}} manque de crédits. Pour éviter toute interruption de service, veuillez acheter des crédits supplémentaires. Si votre solde est épuisé, les SMS cesseront d'être envoyés et seront envoyés par e-mail à la place.", W7r = "Votre compte Cal.com manque de crédits. Pour éviter toute interruption de service, veuillez acheter des crédits supplémentaires. Si votre solde est épuisé, les SMS cesseront d'être envoyés et seront envoyés par e-mail à la place.", G7r = "Votre équipe Cal.com {{teamName}} n'a plus de crédits. Par conséquent, les SMS sont maintenant envoyés par e-mail. Pour reprendre l'envoi de SMS, veuillez acheter des crédits supplémentaires.", H7r = "Votre compte Cal.com n'a plus de crédits. Par conséquent, les messages SMS sont désormais envoyés par e-mail. Pour reprendre l'envoi de SMS, veuillez acheter des crédits supplémentaires.", K7r = "Solde actuel : {{balance}} crédits", Y7r = "Solde actuel :", Z7r = "Notification concernant votre réservation", Q7r = "Crédits mensuels", J7r = "Total des crédits : {{totalCredits}}", X7r = "Crédits restants : {{remainingCredits}}", eVr = "Restant", tVr = "Total", nVr = "Crédits supplémentaires", oVr = "{{count}} suivant(s) dans la file d'attente", rVr = "Envoyer les réponses par e-mail à", iVr = "Réservations incomplètes", aVr = "Inclure les réservations non honorées dans les calculs de round robin", sVr = "Participants récemment absents", cVr = "Affiche les réservations où tous les participants étaient absents, et non les absences partielles", lVr = "Correspondance", dVr = "Redirection d'événement", uVr = "Réinitialiser le formulaire", _Vr = "Paramètres Round Robin mis à jour avec succès", pVr = "Base de distribution pour le Round Robin pondéré", mVr = "Détermine quel horodatage d'événement est utilisé comme base pour la distribution Round Robin pondérée.", fVr = "Nécessite des crédits", gVr = "Vous devez avoir suffisamment de crédits sur votre compte pour utiliser cette fonctionnalité", hVr = "Crédits disponibles", vVr = "Créer un rôle", bVr = "Rôles et permissions", yVr = "Gérer les rôles et les permissions pour votre organisation", $Vr = "En savoir plus sur le fonctionnement des permissions", wVr = "Nom du rôle", kVr = "Le nom du rôle est requis", SVr = "ex. Équipe commerciale, Personnel de support", xVr = "Description du rôle", EVr = "Décrivez à quoi sert ce rôle et quelles permissions il nécessite", TVr = "Rôle par défaut", AVr = "Rôle personnalisé", CVr = "Avancé", zVr = "Rechercher des permissions", OVr = "Toutes les permissions", PVr = "Aucune", IVr = "Lecture seule", RVr = "Toutes les actions sur toutes les ressources", NVr = "Toutes les ressources", DVr = "Types d'événements", MVr = "Équipes", LVr = "Organisation", qVr = "Réservations", jVr = "Statistiques", FVr = "Rôles", VVr = "Formulaires de routage", BVr = "Workflows", UVr = "Toutes les actions", WVr = "Créer", GVr = "Voir", HVr = "Modifier", KVr = "Supprimer", YVr = "Gérer", ZVr = "Inviter", QVr = "Supprimer", JVr = "Changer le rôle d'un membre", XVr = "Lister les membres", eBr = "Gérer la facturation", tBr = "Voir les réservations d'équipe", nBr = "Voir les réservations de l'organisation", oBr = "Voir les enregistrements", rBr = "Emprunt d'identité", iBr = "Rôle créé avec succès", aBr = "Rôle mis à jour avec succès", sBr = "Supprimer le rôle", cBr = "Êtes-vous sûr de vouloir supprimer le rôle : {{roleName}} ? Cette action ne peut pas être annulée.", lBr = "Rôle supprimé avec succès", dBr = "Erreur lors de la création du rôle", uBr = "Erreur lors de la mise à jour du rôle", _Br = "Créer des rôles", pBr = "Attributs", mBr = "Voir les attributs de l'organisation", fBr = "Mettre à jour les attributs de l'organisation", gBr = "Supprimer les attributs de l'organisation", hBr = "Créer des attributs d'organisation", vBr = "Voir les rôles", bBr = "Mettre à jour les rôles", yBr = "Supprimer des rôles", $Br = "Créer et configurer de nouveaux workflows", wBr = "Configuration requise", kBr = "Voir les workflows existants et leurs configurations", SBr = "Éditer et modifier les paramètres des workflows", xBr = "Supprimer des workflows du système", EBr = "Webhook", TBr = "Disponibilités", ABr = "Absence du bureau", CBr = "Créer des webhooks", zBr = "Consulter les webhooks", OBr = "Mettre à jour les webhooks", PBr = "Supprimer les webhooks", IBr = "Créer des disponibilités", RBr = "Voir les disponibilités", NBr = "Mettre à jour les disponibilités", DBr = "Supprimer des disponibilités", MBr = "Créer une absence", LBr = "Voir les absences", qBr = "Mettre à jour une absence", jBr = "Supprimer une absence", FBr = "Accès complet à la gestion de tous les workflows", VBr = "Créer des types d'événements", BBr = "Voir les types d'événements", UBr = "Mettre à jour les types d'événements", WBr = "Supprimer des types d'événements", GBr = "Toutes les actions sur les types d'événements", HBr = "Créer des équipes", KBr = "Voir les détails de l'équipe", YBr = "Mettre à jour les paramètres de l'équipe", ZBr = "Supprimer l'équipe", QBr = "Inviter des membres d'équipe", JBr = "Supprimer des membres d'équipe", XBr = "Changer le rôle des membres de l'équipe", eUr = "Emprunter l'identité des membres de l'équipe", tUr = "Toutes les actions sur les équipes à travers les équipes de l'organisation", nUr = "Créer une organisation", oUr = "Voir les détails de l'organisation", rUr = "Lister les membres de l'organisation", iUr = "Inviter des membres dans l'organisation", aUr = "Supprimer des membres de l'organisation", sUr = "Gérer la facturation de l'organisation", cUr = "Modifier le rôle des membres de l'organisation", lUr = "Emprunter l'identité des membres de l'organisation", dUr = "Modifier les paramètres de l'organisation", uUr = "Toutes les actions sur les organisations", _Ur = "Voir les réservations", pUr = "Voir les réservations de l'équipe", mUr = "Voir les réservations de l'organisation", fUr = "Voir les enregistrements des réservations", gUr = "Mettre à jour les réservations", hUr = "Toutes les actions sur les réservations", vUr = "Voir les analyses de l'équipe", bUr = "Gérer les analyses de l'équipe", yUr = "Créer des formulaires de routage", $Ur = "Voir les formulaires de routage", wUr = "Mettre à jour les formulaires de routage", kUr = "Supprimer les formulaires de routage", SUr = "L'autorisation de lecture est automatiquement activée lors de la création, la mise à jour ou la suppression d'une ressource", xUr = "Ajouter un calendrier de restriction", EUr = "Limiter la disponibilité des hôtes pour n'afficher que les créneaux qui correspondent à un horaire spécifié.", TUr = "Utiliser le fuseau horaire du réservateur", AUr = "Appliquer le calendrier de restriction sélectionné dans le fuseau horaire du réservateur", CUr = "Cela désactivera l'équilibrage de charge sur tous vos types d'événements round robin", zUr = "L'équilibrage de charge est uniquement disponible lorsque la base temporelle est définie sur l'heure de création de la réservation", OUr = "L'équilibrage de charge n'est pas disponible avec les groupes round robin", PUr = "Personnaliser les paramètres par défaut du tour de rôle pour cette équipe", IUr = "Paramètres du tour de rôle mis à jour avec succès", RUr = "Heure de création de la réservation", NUr = "Heure de début de la réunion", DUr = "Membres affectés", MUr = "Aucun membre affecté par la désactivation des identifiants de délégation", LUr = "Télécharger le journal des dépenses", qUr = "Erreur lors du téléchargement du journal des dépenses", jUr = "Proposer de reprogrammer la dernière réservation active au créneau horaire choisi", FUr = "Limite maximale de réservations actives dépassée", VUr = "Vous avez déjà une réservation pour cet événement le {{date}}. Souhaitez-vous la reprogrammer à la nouvelle heure sélectionnée ?", BUr = "La durée doit être d'au moins {{min}} minute(s)", UUr = "La durée ne peut pas dépasser {{max}} minutes (24 heures)", WUr = "Réservation en dehors de la disponibilité du calendrier de restriction.", GUr = "Calendrier de restriction introuvable", HUr = "Limite de taille d'image dépassée, veuillez utiliser une image plus petite, de préférence au format JPEG", KUr = "Ajouter un groupe", YUr = "Entonnoir de routage", ZUr = "Total des soumissions", QUr = "Routages réussis", JUr = "Réservations acceptées", XUr = "Clé de licence", eWr = "Choisir votre licence", tWr = "Sélectionnez comment vous souhaitez licencier votre déploiement Cal.com", nWr = "Utiliser Cal.com sous la licence open source AGPLv3", oWr = "Saisir la clé de licence", rWr = "Accès à toutes les fonctionnalités entreprise", iWr = "À partir de 15$/utilisateur par mois", aWr = "Accès à toutes les fonctionnalités entreprise", sWr = "Saisissez votre clé de licence", cWr = "Enregistrer la clé de licence", lWr = "Jeton de signature (facultatif)", dWr = "Le jeton de signature est utilisé pour vérifier que la clé de licence est la vôtre lors de l'incrémentation de la facturation basée sur l'utilisation. Vous pouvez le trouver dans votre e-mail de confirmation d'achat. Si vous utilisez une licence héritée, vous pouvez laisser ce champ vide.", uWr = "Besoin d'une licence ?", _Wr = "La clé de licence est requise", pWr = "Clé de licence invalide", mWr = "Échec de la validation de la clé de licence", fWr = "Pièces jointes optionnelles", gWr = "Envoyer le message", hWr = "Décrivez le problème", vWr = "La taille du fichier dépasse la limite", bWr = "Type de fichier invalide", yWr = "Type de fichier invalide. Types acceptés : {{acceptedTypes}}", $Wr = "Nombre maximum de fichiers dépassé", wWr = "Fichiers téléchargés avec succès", kWr = "Types acceptés : {{acceptedTypes}} ; Taille maximale : {{maxSize}}", SWr = "Clé de licence enregistrée avec succès", xWr = "Vous consultez le rapport selon le fuseau horaire de votre profil ({{userTimezone}}), alors que votre navigateur est configuré sur le fuseau horaire ({{browserTimezone}})", EWr = "Créneaux optimisés", TWr = "Organiser les créneaux horaires pour optimiser la disponibilité.", AWr = "Réservations échouées par champ", CWr = "Réservations échouées", zWr = "Aucun hôte n'est assigné à ce type d'événement", OWr = "État du cache", PWr = "Dernière mise à jour : {{timestamp}}", IWr = "Supprimer les données en cache", RWr = "Cache supprimé avec succès", NWr = "Erreur lors de la suppression du cache", DWr = "Êtes-vous sûr de vouloir supprimer les données en cache ? Cette action ne peut pas être annulée.", MWr = "Oui, supprimer le cache", LWr = "{{remainder}} utilisations restantes sur {{maximum}}", qWr = "{{remainder}} utilisation restante sur {{maximum}}", jWr = "Expire le {{date}}, fin de journée", FWr = "Usage unique", VWr = "Expiration basée sur le temps", BWr = "Expiration basée sur l'utilisation", UWr = "Nombre d'utilisations", WWr = "Expire le", GWr = "Nombre maximum d'utilisations", HWr = "Paramètres du lien", KWr = "Ce lien a expiré le {{date}}, fin de journée", YWr = "Limite d'utilisation atteinte", ZWr = "Le nombre maximum d'utilisations doit être supérieur au nombre d'utilisations actuel", QWr = "Ce lien a expiré", JWr = "Ce lien peut être utilisé pour des réservations jusqu'à la fin du {{date}}", XWr = "Ce lien peut être configuré pour expirer après une date définie", eGr = "Ce lien peut être utilisé pour {{count}} réservation", tGr = "Ce lien peut être configuré pour expirer après un nombre défini de réservations", nGr = "Ce lien peut être utilisé pour {{count}} réservations", oGr = "Le nom de l'événement déclencheur (par ex., BOOKING_CREATED, BOOKING_CANCELLED)", rGr = "L'heure du webhook", iGr = "Le slug du type d'événement", aGr = "Configurer l'agent", sGr = "Le nom du type d'événement", cGr = "L'heure de début de l'événement", lGr = "L'heure de fin de l'événement", dGr = "La description de l'événement telle que définie dans les paramètres du type d'événement", uGr = "Lieu de l'événement", _Gr = "L'UID de la réservation", pGr = "L'UID pour le report", mGr = "Motif d'annulation", fGr = "Motif de refus", gGr = "Nom de l'organisateur", hGr = "Email de l'organisateur", vGr = "Fuseau horaire de l'organisateur (par ex., 'America/New_York', 'Asia/Kolkata')", bGr = "Locale de l'organisateur (par ex., 'en', 'fr')", yGr = "Nom d'utilisateur de l'organisateur (par ex., 'john.doe')", $Gr = "Nom d'utilisateur de l'organisateur dans son organisation (par ex., 'john.doe')", wGr = "Nom du premier participant", kGr = "Email du premier participant", SGr = "Fuseau horaire du premier participant", xGr = "Locale du premier participant", EGr = "Nom de l'équipe réservée", TGr = "Membres de l'équipe réservée", AGr = "URL d'appel vidéo pour la réunion", CGr = "Masquer les variables", zGr = "Afficher les variables disponibles", OGr = "Événement et réservation", PGr = "Personnes", IGr = "Équipes", RGr = "Métadonnées", NGr = "Statistiques", DGr = "Statut de la réservation", MGr = "Visiter", LGr = "Étiquette personnalisée sur la page de réservation", qGr = "Lien de réunion", jGr = "Résultat de la session", FGr = "Appel créé", VGr = "Messagerie vocale", BGr = "Mes réservations", UGr = "Téléphone", WGr = "Gratuit", GGr = "Email de l'utilisateur", HGr = "Nom d'utilisateur", KGr = "Développer le panneau", YGr = "Réduire le panneau", ZGr = "La vérification de l'e-mail est requise pour ce type d'événement", QGr = "Code de vérification fourni invalide", JGr = "Vous avez une équipe", XGr = "Envisagez de créer une organisation pour unifier la facturation, les outils d'administration et les analyses pour votre équipe.", eHr = "Envisagez de créer une organisation pour unifier la facturation, les outils d'administration et les analyses pour vos équipes.", tHr = "Message envoyé", nHr = "Merci de nous avoir contactés. Nous vous répondrons dès que possible.", oHr = "Rechercher des variables", rHr = 'Veuillez décrire le problème que vous rencontrez, par ex. "Les créneaux occupés sont marqués comme disponibles", ..., etc.', iHr = "Envoyer un autre message", aHr = "Envoi en cours", sHr = "Aucune variable trouvée", cHr = "Crédits requis", lHr = "Les appels web consomment des crédits. Assurez-vous d'avoir suffisamment de crédits pour démarrer un appel.", dHr = "Les appels web nécessitent des crédits. Il vous reste 0 crédit.", uHr = "Acheter des crédits", _Hr = "Cette action nécessite des crédits pour continuer", pHr = "Le nom ne doit pas dépasser {{max}} caractères", mHr = "Facturer automatiquement des frais de non-présentation pour les annulations de dernière minute", fHr = "Avant l'heure de début prévue", gHr = "Je reconnais qu'en annulant la réservation dans les {{timeValue}} {{timeUnit}} précédant l'heure de début, des frais de non-présentation de {{amount, currency}} me seront facturés", hHr = "Si vous avez des questions, veuillez contacter l'organisateur.", vHr = "Heure de réservation", bHr = "Quand la réservation est programmée (début à fin)", yHr = "Créé le", $Hr = "Quand la réservation a été initialement créée", wHr = "Détails de l'appel", kHr = "ID d'appel", SHr = "Informations d'appel", xHr = "Sentiment", EHr = "Raison de déconnexion", THr = "Résumé de l'appel", AHr = "Transcription", CHr = "Détails de l'événement", zHr = "Agent", OHr = "Aucune transcription disponible", PHr = "Lors du test de ce workflow, sachez que les SMS doivent être programmés au moins 15 minutes à l'avance", IHr = "Commencer de zéro", RHr = "Créez votre propre workflow à partir de zéro.", NHr = "Modèle Cal.ai", DHr = "Agents IA qui réservent des réunions, envoient des rappels et assurent le suivi !", MHr = "Voix", LHr = "Sélectionner une voix", qHr = "Sélectionner une voix pour votre agent", jHr = "Choisissez une voix pour votre agent", FHr = "Caractéristique", VHr = "ID de voix", BHr = "Utiliser la voix", UHr = "Voix actuelle", WHr = "Configurer l'agent entrant", GHr = "Configurez un agent IA pour gérer les appels entrants sur votre numéro de téléphone", HHr = "Connectez d'abord un numéro de téléphone", KHr = "Configurer l'agent pour les appels entrants", YHr = "Configurer l'agent pour gérer les appels entrants", ZHr = "Appels entrants", QHr = "Appels sortants", JHr = "Configuration de l'agent entrant réussie", XHr = "Agent entrant configuré", eKr = "Configurer l'agent entrant", tKr = "Veuillez d'abord sélectionner un type d'événement", nKr = "Modifier la configuration", oKr = "Les appels entrants ne peuvent réserver qu'un seul type d'événement. Sélectionnez le type d'événement où les réunions seront programmées lorsque les appelants joignent votre agent.", rKr = "Configurer l'agent entrant pour les appels entrants", iKr = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Ajoutez vos nouvelles chaînes ci-dessus ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", aKr = {
  identity_provider: rBo,
  trial_days_left: iBo,
  day_one: aBo,
  day_other: sBo,
  second_one: cBo,
  second_other: lBo,
  upgrade_now: dBo,
  untitled: uBo,
  accept_invitation: _Bo,
  max_characters: pBo,
  min_characters: mBo,
  calcom_explained: fBo,
  calcom_explained_new_user: gBo,
  have_any_questions: hBo,
  reset_password_subject: vBo,
  verify_email_subject: bBo,
  verify_email_subject_verifying_email: yBo,
  check_your_email: $Bo,
  old_email_address: wBo,
  new_email_address: kBo,
  verify_email_page_body: SBo,
  verify_email_banner_body: xBo,
  verify_email_email_header: EBo,
  verify_email_button: TBo,
  cal_ai_assistant: ABo,
  send_cal_video_transcription_emails: CBo,
  description_send_cal_video_transcription_emails: zBo,
  verify_email_change_description: OBo,
  verify_email_change_success_toast: PBo,
  verify_email_change_failure_toast: IBo,
  change_of_email: RBo,
  change_of_email_toast: NBo,
  copy_somewhere_safe: DBo,
  verify_email_email_body: MBo,
  verify_email_by_code_email_body: LBo,
  verify_email_email_link_text: qBo,
  email_verification_code: jBo,
  email_verification_code_placeholder: FBo,
  incorrect_email_verification_code: VBo,
  email_sent: BBo,
  email_not_sent: UBo,
  event_declined_subject: WBo,
  event_cancelled_subject: GBo,
  event_reassigned_subject: HBo,
  event_request_declined: KBo,
  customize_calvideo_settings: YBo,
  calvideo_settings_description: ZBo,
  disable_recording_for_guests: QBo,
  enable_automatic_transcription: JBo,
  enable_automatic_recording: XBo,
  video_options: eUo,
  edit_event: tUo,
  view_session_details: nUo,
  meeting_session_details: oUo,
  meeting_session: rUo,
  session_id: iUo,
  max_participants: aUo,
  unlimited: sUo,
  ongoing: cUo,
  ended: lUo,
  participants: dUo,
  anonymous_user: uUo,
  session_duration: _Uo,
  no_meeting_sessions_found: pUo,
  not_available: mUo,
  disable_recording_for_organizer: fUo,
  disable_transcription_for_guests: gUo,
  disable_transcription_for_organizer: hUo,
  event_request_declined_recurring: vUo,
  event_request_cancelled: bUo,
  event_request_reassigned: yUo,
  event_reassigned_subtitle: $Uo,
  organizer: wUo,
  reassigned_to: kUo,
  need_to_reschedule_or_cancel: SUo,
  you_can_view_booking_details_with_this_url: xUo,
  no_options_available: EUo,
  cancellation_reason: TUo,
  cancelled_by: AUo,
  cancellation_reason_host: CUo,
  cancellation_reason_placeholder: zUo,
  notify_attendee_cancellation_reason_warning: OUo,
  rejection_reason_placeholder: PUo,
  rejection_reason: IUo,
  rejection_reason_title: RUo,
  rejection_reason_description: NUo,
  rejection_confirmation: DUo,
  manage_this_event: MUo,
  invite_team_member: LUo,
  invite_team_individual_segment: qUo,
  invite_team_bulk_segment: jUo,
  invite_team_notifcation_badge: FUo,
  your_event_has_been_scheduled: VUo,
  your_event_has_been_scheduled_recurring: BUo,
  accept_our_license: UUo,
  remove_banner_instructions: WUo,
  error_message: GUo,
  refund_failed_subject: HUo,
  refund_failed: KUo,
  check_with_provider_and_user: YUo,
  a_refund_failed: ZUo,
  awaiting_payment_subject: QUo,
  meeting_awaiting_payment: JUo,
  dark_theme_contrast_error: XUo,
  light_theme_contrast_error: eWo,
  event_type_color_light_theme_contrast_error: tWo,
  event_type_color_dark_theme_contrast_error: nWo,
  payment_not_created_error: oWo,
  couldnt_charge_card_error: rWo,
  no_available_users_found_error: iWo,
  timeslot_unavailable_book_a_new_time: aWo,
  timeslot_unavailable_short: sWo,
  just_connected_description: cWo,
  unavailable_timeslot_title: lWo,
  booking_time_out_of_bounds_error: dWo,
  request_body_end_time_internal_error: uWo,
  create_calendar_event_error: _Wo,
  update_calendar_event_error: pWo,
  delete_calendar_event_error: mWo,
  already_signed_up_for_this_booking_error: fWo,
  hosts_unavailable_for_booking: gWo,
  fixed_hosts_unavailable_for_booking: hWo,
  round_robin_host_unavailable_for_booking: vWo,
  help: bWo,
  price: yWo,
  paid: $Wo,
  refunded: wWo,
  record: kWo,
  transcribe: SWo,
  payment: xWo,
  missing_card_fields: EWo,
  pay_now: TWo,
  general_prompt: AWo,
  transcription_powered_by_ai: CWo,
  start_or_stop_recording: zWo,
  begin_message: OWo,
  codebase_has_to_stay_opensource: PWo,
  cannot_repackage_codebase: IWo,
  acquire_license: RWo,
  terms_summary: NWo,
  open_env: DWo,
  env_changed: MWo,
  accept_license: LWo,
  still_waiting_for_approval: qWo,
  event_is_still_waiting: jWo,
  no_result_found_for: FWo,
  no_more_results: VWo,
  no_results: BWo,
  load_more_results: UWo,
  integration_meeting_id: WWo,
  confirmed_event_type_subject: GWo,
  new_event_request: HWo,
  confirm_or_reject_request: KWo,
  check_bookings_page_to_confirm_or_reject: YWo,
  check_in_assistant: ZWo,
  check_in_assistant_description: QWo,
  create_your_own_prompt: JWo,
  event_awaiting_approval: XWo,
  event_awaiting_approval_recurring: eGo,
  someone_requested_an_event: tGo,
  someone_requested_password_reset: nGo,
  password_reset_email_sent: oGo,
  password_reset_instructions: rGo,
  event_awaiting_approval_subject: iGo,
  event_still_awaiting_approval: aGo,
  booking_submitted_subject: sGo,
  download_recording_subject: cGo,
  download_transcript_email_subject: lGo,
  download_your_recording: dGo,
  download_your_transcripts: uGo,
  your_meeting_has_been_booked: _Go,
  event_type_has_been_rescheduled_on_time_date: pGo,
  event_type_has_been_updated: mGo,
  event_has_been_rescheduled: fGo,
  event_has_been_updated: gGo,
  your_event_has_been_rescheduled: hGo,
  request_reschedule_subtitle: vGo,
  request_reschedule_title_organizer: bGo,
  request_reschedule_subtitle_organizer: yGo,
  rescheduled_event_type_subject: $Go,
  requested_to_reschedule_subject_attendee: wGo,
  hi_user_name: kGo,
  ics_event_title: SGo,
  please_book_a_time_sometime_later: xGo,
  schedule_instead: EGo,
  new_event_subject: TGo,
  join_by_entrypoint: AGo,
  notes: CGo,
  manage_my_bookings: zGo,
  need_to_make_a_change: OGo,
  new_event_scheduled: PGo,
  new_event_scheduled_recurring: IGo,
  invitee_email: RGo,
  invitee_timezone: NGo,
  time_left: DGo,
  event_type: MGo,
  duplicate_event_type: LGo,
  enter_meeting: qGo,
  video_call_provider: jGo,
  meeting_id: FGo,
  meeting_password: VGo,
  meeting_url: BGo,
  meeting_url_not_found: UGo,
  token_not_found: WGo,
  some_other_host_already_accepted_the_meeting: GGo,
  meeting_request_rejected: HGo,
  rejected_event_type_with_organizer: KGo,
  hi: YGo,
  join_team: ZGo,
  manage_this_team: QGo,
  team_info: JGo,
  join_meeting: XGo,
  request_another_invitation_email: eHo,
  you_have_been_invited: tHo,
  user_invited_you: nHo,
  hidden_team_member_title: oHo,
  hidden_team_member_message: rHo,
  hidden_team_owner_message: iHo,
  link_expires: aHo,
  upgrade_to_per_seat: sHo,
  seat_options_doesnt_support_confirmation: cHo,
  multilocation_doesnt_support_seats: lHo,
  no_show_fee_doesnt_support_seats: dHo,
  seats_option_doesnt_support_multi_location: uHo,
  team_upgrade_seats_details: _Ho,
  team_upgrade_banner_description: pHo,
  upgrade_banner_action: mHo,
  team_upgraded_successfully: fHo,
  org_upgrade_banner_description: gHo,
  org_upgraded_successfully: hHo,
  use_link_to_reset_password: vHo,
  hey_there: bHo,
  there: yHo,
  forgot_your_password_calcom: $Ho,
  delete_webhook_confirmation_message: wHo,
  confirm_delete_webhook: kHo,
  edit_webhook: SHo,
  delete_webhook: xHo,
  webhook_status: EHo,
  webhook_enabled: THo,
  webhook_disabled: AHo,
  webhook_response: CHo,
  webhook_test: zHo,
  webhook_update_form: OHo,
  webhook_update_form_description: PHo,
  manage_your_webhook: IHo,
  webhook_created_successfully: RHo,
  webhook_updated_successfully: NHo,
  webhook_removed_successfully: DHo,
  subscription_needed: MHo,
  subscription_needed_description: LHo,
  payload_template: qHo,
  dismiss: jHo,
  no_data_yet: FHo,
  ping_test: VHo,
  add_to_homescreen: BHo,
  upcoming: UHo,
  recurring: WHo,
  past: GHo,
  choose_a_file: HHo,
  upload_image: KHo,
  upload_target: YHo,
  no_target: ZHo,
  slide_zoom_drag_instructions: QHo,
  view_notifications: JHo,
  view_public_page: XHo,
  copy_public_page_link: eKo,
  copy_referral_link: tKo,
  sign_out: nKo,
  add_another: oKo,
  install_another: rKo,
  until: iKo,
  powered_by: aKo,
  unavailable: sKo,
  set_work_schedule: cKo,
  change_bookings_availability: lKo,
  select: dKo,
  "2fa_confirm_current_password": "Confirmez votre mot de passe actuel pour commencer.",
  "2fa_scan_image_or_use_code": "Scannez l'image ci-dessous avec votre application d'authentification ou saisissez manuellement le code.",
  text: uKo,
  your_phone_number: _Ko,
  multiline_text: pKo,
  number: mKo,
  checkbox: fKo,
  is_required: gKo,
  make_field_required: hKo,
  required: vKo,
  optional: bKo,
  input_type: yKo,
  rejected: $Ko,
  unconfirmed: wKo,
  guests: kKo,
  guest: SKo,
  web_conferencing_details_to_follow: xKo,
  confirmation: EKo,
  what_booker_should_provide: TKo,
  "404_the_user": "Le nom d'utilisateur",
  username: AKo,
  is_still_available: CKo,
  documentation: zKo,
  documentation_description: OKo,
  api_reference: PKo,
  api_reference_description: IKo,
  blog: RKo,
  blog_description: NKo,
  join_our_community: DKo,
  "404_claim_entity_user": "Réservez votre nom d'utilisateur et planifiez des événements",
  popular_pages: MKo,
  register_now: LKo,
  register: qKo,
  page_doesnt_exist: jKo,
  no_active_phone_number_available: FKo,
  workflow_step_not_configured: VKo,
  check_spelling_mistakes_or_go_back: BKo,
  "404_page_not_found": "404 : Cette page est introuvable.",
  booker_event_not_found: UKo,
  getting_started: WKo,
  "15min_meeting": "Rendez-vous de 15 min",
  "30min_meeting": "Rendez-vous de 30 min",
  secret: GKo,
  leave_blank_to_remove_secret: HKo,
  webhook_secret_key_description: KKo,
  secret_meeting: YKo,
  login_instead: ZKo,
  create_account: QKo,
  get_started: JKo,
  confirm_password: XKo,
  reset_your_password: eYo,
  org_banner_instructions: tYo,
  email_change: nYo,
  create_your_account: oYo,
  create_your_calcom_account: rYo,
  sign_up: iYo,
  youve_been_logged_out: aYo,
  hope_to_see_you_soon: sYo,
  logged_out: cYo,
  please_try_again_and_contact_us: lYo,
  incorrect_2fa_code: dYo,
  no_account_exists: uYo,
  "2fa_enabled_instructions": "La double authentification est activée. Veuillez entrer le code à six chiffres de votre application d'authentification.",
  "2fa_enter_six_digit_code": "Saisissez le code à six chiffres de votre application d'authentification ci-dessous.",
  create_an_account: _Yo,
  dont_have_an_account: pYo,
  "2fa_code": "Code de double authentification",
  sign_in_account: mYo,
  sign_in: fYo,
  go_back_login: gYo,
  error_during_login: hYo,
  request_password_reset: vYo,
  send_invite: bYo,
  forgot_password: yYo,
  forgot: $Yo,
  done: wYo,
  all_done: kYo,
  all: SYo,
  yours: xYo,
  available_apps: EYo,
  available_apps_lower_case: TYo,
  available_apps_desc: AYo,
  fixed_host_helper: CYo,
  round_robin_groups_helper: zYo,
  round_robin_helper: OYo,
  check_email_reset_password: PYo,
  finish: IYo,
  organization_general_description: RYo,
  few_sentences_about_yourself: NYo,
  nearly_there: DYo,
  nearly_there_instructions: MYo,
  set_availability_instructions: LYo,
  set_availability: qYo,
  set_availbility_description: jYo,
  share_a_link_or_embed: FYo,
  share_a_link_or_embed_description: VYo,
  availability_settings: BYo,
  continue_without_calendar: UYo,
  continue_with: WYo,
  connect_your_calendar: GYo,
  connect_your_video_app: HYo,
  connect_your_video_app_instructions: KYo,
  connect_your_calendar_instructions: YYo,
  set_up_later: ZYo,
  current_time: QYo,
  details: JYo,
  welcome: XYo,
  welcome_back: eZo,
  welcome_to_calcom: tZo,
  welcome_instructions: nZo,
  connect_caldav: oZo,
  connect_ics_feed: rZo,
  connect: iZo,
  try_for_free: aZo,
  create_booking_link_with_calcom: sZo,
  who: cZo,
  what: lZo,
  when: dZo,
  where: uZo,
  add_to_calendar: _Zo,
  add_to_calendar_description: pZo,
  add_events_to: mZo,
  add_another_calendar: fZo,
  other: gZo,
  email_sign_in_subject: hZo,
  round_robin_emailed_you_and_attendees: vZo,
  round_robin_emailed_host_and_attendee: bZo,
  emailed_host_and_attendee: yZo,
  emailed_host_and_attendee_recurring: $Zo,
  round_robin_emailed_you_and_attendees_recurring: wZo,
  round_robin_emailed_host_and_attendee_recurring: kZo,
  emailed_you_and_any_other_attendees: SZo,
  needs_to_be_confirmed_or_rejected: xZo,
  needs_to_be_confirmed_or_rejected_recurring: EZo,
  user_needs_to_confirm_or_reject_booking: TZo,
  user_needs_to_confirm_or_reject_booking_recurring: AZo,
  meeting_is_scheduled: CZo,
  meeting_is_scheduled_recurring: zZo,
  booking_submitted: OZo,
  booking_submitted_recurring: PZo,
  booking_confirmed: IZo,
  booking_confirmed_recurring: RZo,
  warning_recurring_event_payment: NZo,
  warning_payment_recurring_event: DZo,
  enter_new_password: MZo,
  reset_password: LZo,
  change_your_password: qZo,
  show_password: jZo,
  hide_password: FZo,
  try_again: VZo,
  request_is_expired: BZo,
  reset_instructions: UZo,
  request_is_expired_instructions: WZo,
  whoops: GZo,
  login: HZo,
  success: KZo,
  failed: YZo,
  password_has_been_reset_login: ZZo,
  layout: QZo,
  bookerlayout_default_title: JZo,
  bookerlayout_description: XZo,
  bookerlayout_user_settings_title: eQo,
  bookerlayout_user_settings_description: tQo,
  bookerlayout_month_view: nQo,
  bookerlayout_week_view: oQo,
  bookerlayout_column_view: rQo,
  bookerlayout_error_min_one_enabled: iQo,
  bookerlayout_error_default_not_enabled: aQo,
  bookerlayout_error_unknown_layout: sQo,
  bookerlayout_override_global_settings: cQo,
  unexpected_error_try_again: lQo,
  sunday_time_error: dQo,
  monday_time_error: uQo,
  tuesday_time_error: _Qo,
  wednesday_time_error: pQo,
  thursday_time_error: mQo,
  friday_time_error: fQo,
  saturday_time_error: gQo,
  error_end_time_before_start_time: hQo,
  error_end_time_next_day: vQo,
  back_to_bookings: bQo,
  free_to_pick_another_event_type: yQo,
  cancelled: $Qo,
  no_booking: wQo,
  awaiting_host: kQo,
  cancellation_successful: SQo,
  really_cancel_booking: xQo,
  cannot_cancel_booking: EQo,
  reschedule_instead: TQo,
  event_is_in_the_past: AQo,
  cancelling_event_recurring: CQo,
  cancelling_all_recurring: zQo,
  error_with_status_code_occured: OQo,
  error_event_type_url_duplicate: PQo,
  error_event_type_unauthorized_create: IQo,
  error_event_type_unauthorized_update: RQo,
  error_workflow_unauthorized_create: NQo,
  error_schedule_unauthorized_create: DQo,
  booking_already_cancelled: MQo,
  booking_already_accepted_rejected: LQo,
  go_back_home: qQo,
  or_go_back_home: jQo,
  no_meeting_found: FQo,
  no_meeting_found_description: VQo,
  no_status_bookings_yet: BQo,
  no_status_bookings_yet_description: UQo,
  event_between_users: WQo,
  bookings: GQo,
  booking_not_found: HQo,
  bookings_description: KQo,
  upcoming_bookings: YQo,
  recurring_bookings: ZQo,
  past_bookings: QQo,
  cancelled_bookings: JQo,
  unconfirmed_bookings: XQo,
  unconfirmed_bookings_tooltip: eJo,
  on: tJo,
  and: nJo,
  calendar_shows_busy_between: oJo,
  troubleshoot: rJo,
  troubleshoot_description: iJo,
  overview_of_day: aJo,
  hover_over_bold_times_tip: sJo,
  start_time: cJo,
  end_time: lJo,
  buffer_time: dJo,
  before_event: uJo,
  after_event: _Jo,
  event_buffer_default: pJo,
  buffer: mJo,
  your_day_starts_at: fJo,
  your_day_ends_at: gJo,
  launch_troubleshooter: hJo,
  troubleshoot_availability: vJo,
  change_available_times: bJo,
  change_your_available_times: yJo,
  change_start_end: $Jo,
  change_start_end_buffer: wJo,
  current_start_date: kJo,
  start_end_changed_successfully: SJo,
  and_end_at: xJo,
  light: EJo,
  dark: TJo,
  automatically_adjust_theme: AJo,
  user_dynamic_booking_disabled: CJo,
  allow_dynamic_booking_tooltip: zJo,
  allow_dynamic_booking: OJo,
  dynamic_booking: PJo,
  allow_seo_indexing: IJo,
  seo_indexing: RJo,
  allow_browser_notifications: NJo,
  you_have_denied_notifications: DJo,
  disable_browser_notifications: MJo,
  browser_notifications_turned_on: LJo,
  browser_notifications_turned_off: qJo,
  browser_notifications_denied: jJo,
  please_allow_notifications: FJo,
  push_notifications: VJo,
  push_notifications_description: BJo,
  browser_notifications_not_supported: UJo,
  email: WJo,
  email_placeholder: GJo,
  full_name: HJo,
  browse_api_documentation: KJo,
  leverage_our_api: YJo,
  create_webhook: ZJo,
  instant_meeting: QJo,
  booking_cancelled: JJo,
  booking_rescheduled: XJo,
  recording_ready: eXo,
  recording_transcription_generated: tXo,
  booking_created: nXo,
  booking_rejected: oXo,
  booking_requested: rXo,
  booking_payment_initiated: iXo,
  meeting_ended: aXo,
  form_submitted: sXo,
  form_submitted_no_event: cXo,
  booking_paid: lXo,
  ooo_created: dXo,
  booking_no_show_updated: uXo,
  event_triggers: _Xo,
  subscriber_url: pXo,
  create_new_webhook: mXo,
  webhooks: fXo,
  team_webhooks: gXo,
  create_new_webhook_to_account: hXo,
  new_webhook: vXo,
  receive_cal_meeting_data: bXo,
  receive_cal_event_meeting_data: yXo,
  responsive_fullscreen_iframe: $Xo,
  loading: wXo,
  deleting: kXo,
  standard_iframe: SXo,
  developer: xXo,
  manage_developer_settings: EXo,
  iframe_embed: TXo,
  embed_calcom: AXo,
  integrate_using_embed_or_webhooks: CXo,
  schedule_a_meeting: zXo,
  view_and_manage_billing_details: OXo,
  view_and_edit_billing_details: PXo,
  go_to_billing_portal: IXo,
  need_anything_else: RXo,
  further_billing_help: NXo,
  contact: DXo,
  our_support_team: MXo,
  contact_our_support_team: LXo,
  uh_oh: qXo,
  no_event_types_have_been_setup: jXo,
  edit_logo: FXo,
  upload_a_logo: VXo,
  upload_logo: BXo,
  remove_logo: UXo,
  enable: WXo,
  code: GXo,
  code_is_incorrect: HXo,
  add_time_availability: KXo,
  add_an_extra_layer_of_security: YXo,
  "2fa": "Double authentification",
  "2fa_disabled": "La double authentification ne peut être activée que pour l'authentification par e-mail et mot de passe",
  enable_2fa: ZXo,
  disable_2fa: QXo,
  disable_2fa_recommendation: JXo,
  error_disabling_2fa: XXo,
  error_enabling_2fa: eer,
  security: ter,
  manage_account_security: ner,
  password: oer,
  password_updated_successfully: rer,
  password_has_been_changed: ier,
  error_changing_password: aer,
  session_timeout_changed: ser,
  session_timeout_change_error: cer,
  something_went_wrong: ler,
  something_doesnt_look_right: der,
  please_try_again: uer,
  super_secure_new_password: _er,
  new_password: per,
  your_old_password: mer,
  current_password: fer,
  change_password: ger,
  change_secret: her,
  new_password_matches_old_password: ver,
  forgotten_secret_description: ber,
  current_incorrect_password: yer,
  password_hint_caplow: $er,
  password_hint_min: wer,
  password_hint_admin_min: ker,
  password_hint_num: Ser,
  max_limit_allowed_hint: xer,
  invalid_password_hint: Eer,
  incorrect_password: Ter,
  incorrect_email_password: Aer,
  use_setting: Cer,
  am_pm: zer,
  time_options: Oer,
  january: Per,
  february: Ier,
  march: Rer,
  april: Ner,
  may: Der,
  june: Mer,
  july: Ler,
  august: qer,
  september: jer,
  october: Fer,
  november: Ver,
  december: Ber,
  monday: Uer,
  tuesday: Wer,
  wednesday: Ger,
  thursday: Her,
  friday: Ker,
  saturday: Yer,
  sunday: Zer,
  all_booked_today: Qer,
  slots_load_fail: Jer,
  additional_guests: Xer,
  your_name: etr,
  your_full_name: ttr,
  no_name: ntr,
  enter_number_between_range: otr,
  continue_as_guest_description: rtr,
  email_address: itr,
  enter_valid_email: atr,
  please_schedule_future_call: str,
  location: ctr,
  address: ltr,
  enter_address: dtr,
  in_person_attendee_address: utr,
  somewhere_else: _tr,
  custom_attendee_location: ptr,
  continue_as_guest: mtr,
  join_as_guest: ftr,
  ideal_for_one_time_calls: gtr,
  any_location: htr,
  yes: vtr,
  no: btr,
  additional_notes: ytr,
  booking_fail: $tr,
  reschedule_fail: wtr,
  share_additional_notes: ktr,
  booking_confirmation: Str,
  booking_reschedule_confirmation: xtr,
  in_person_meeting: Etr,
  in_person: Ttr,
  link_meeting: Atr,
  phone_number: Ctr,
  attendee_phone_number: ztr,
  organizer_phone_number: Otr,
  enter_phone_number: Ptr,
  reschedule: Itr,
  reschedule_this: Rtr,
  book_a_team_member: Ntr,
  or: Dtr,
  go_back: Mtr,
  email_or_username: Ltr,
  send_invite_email: qtr,
  role: jtr,
  edit_role: Ftr,
  view_role: Vtr,
  edit_team: Btr,
  editing_user: Utr,
  editing_org: Wtr,
  edit_or_manage_webhooks: Gtr,
  reject: Htr,
  reject_all: Ktr,
  accept: Ytr,
  leave: Ztr,
  profile: Qtr,
  my_team_url: Jtr,
  my_teams: Xtr,
  team_name: enr,
  your_team_name: tnr,
  team_updated_successfully: nnr,
  your_team_updated_successfully: onr,
  your_org_updated_successfully: rnr,
  error_copying_to_clipboard: inr,
  about: anr,
  team_description: snr,
  organization_id: cnr,
  organization_id_copied: lnr,
  org_description: dnr,
  team_id: unr,
  team_id_copied: _nr,
  members: pnr,
  organization_members: mnr,
  member: fnr,
  number_member_one: gnr,
  number_member_other: hnr,
  number_selected: vnr,
  owner: bnr,
  admin: ynr,
  admin_api: $nr,
  administrator_user: wnr,
  lets_create_first_administrator_user: knr,
  admin_user_created: Snr,
  admin_user_created_description: xnr,
  new_member: Enr,
  invite: Tnr,
  add_team_members: Anr,
  add_org_members: Cnr,
  add_team_members_description: znr,
  add_team_member: Onr,
  invite_new_member: Pnr,
  invite_new_member_description: Inr,
  invite_new_team_member: Rnr,
  upload_csv_file: Nnr,
  invite_via_email: Dnr,
  change_member_role: Mnr,
  disable_cal_branding: Lnr,
  disable_cal_branding_description: qnr,
  hide_book_a_team_member: jnr,
  hide_book_a_team_member_description: Fnr,
  danger_zone: Vnr,
  account_deletion_cannot_be_undone: Bnr,
  team_deletion_cannot_be_undone: Unr,
  back: Wnr,
  cancel: Gnr,
  cancel_all_remaining: Hnr,
  apply: Knr,
  cancel_event: Ynr,
  continue: "Continuer",
  confirm: Znr,
  confirm_all: Qnr,
  disband_team: Jnr,
  disband_team_confirmation_message: Xnr,
  disband_org: eor,
  disband_org_confirmation_message: tor,
  remove_member_confirmation_message: nor,
  confirm_disband_team: oor,
  confirm_remove_member: ror,
  confirm_subscription_cancellation: ior,
  cancel_subscription: aor,
  cancel_subscription_description: sor,
  remove_member: cor,
  manage_your_team: lor,
  no_teams: dor,
  no_teams_description: uor,
  submit: _or,
  confirm_remove_attribute: por,
  remove_attribute: mor,
  remove_attribute_confirmation_message: gor,
  delete: "Supprimer",
  update: hor,
  save: vor,
  pending: bor,
  open_options: yor,
  copy_link: $or,
  share: wor,
  share_event: kor,
  copy_link_team: Sor,
  leave_team: xor,
  confirm_leave_team: Eor,
  leave_team_confirmation_message: Tor,
  user_from_team: Aor,
  preview: Cor,
  link_copied: zor,
  copied: Oor,
  private_link_copied: Por,
  link_shared: Ior,
  title: Ror,
  description: Nor,
  apps_status: Dor,
  quick_video_meeting: Mor,
  scheduling_type: Lor,
  preview_team: qor,
  collective: jor,
  collective_description: For,
  duration: Vor,
  available_durations: Bor,
  default_duration: Uor,
  default_duration_no_options: Wor,
  multiple_duration_mins: Gor,
  multiple_duration_timeUnit: Hor,
  multiple_duration_timeUnit_short: Kor,
  minutes: Yor,
  use_cal_ai_to_make_call_description: Zor,
  termination_uri: Qor,
  sip_trunk_username: Jor,
  sip_trunk_password: Xor,
  nickname: err,
  delete_phone_number: trr,
  workflow_validation_failed: nrr,
  workflow_validation_empty_fields: orr,
  workflow_validation_unverified_contacts: rrr,
  supercharge_your_workflows_with_cal_ai: irr,
  supercharge_your_workflows_with_cal_ai_description: arr,
  phone_number_imported_successfully: srr,
  phone_number_deleted_successfully: crr,
  delete_phone_number_confirmation: lrr,
  yes_delete_phone_number: drr,
  phone_number_info_tooltip: urr,
  termination_uri_info_tooltip: _rr,
  sip_trunk_username_info_tooltip: prr,
  sip_trunk_password_info_tooltip: mrr,
  nickname_info_tooltip: frr,
  save_and_test_call: grr,
  call_initiated_successfully: hrr,
  please_enter_phone_number: vrr,
  agent_updated_successfully: brr,
  agent_created_successfully: yrr,
  agent_event_type_updated_successfully: $rr,
  phone_number_unsubscribed_successfully: wrr,
  general_prompt_description: krr,
  prompt: Srr,
  call_to: xrr,
  make_test_call_to_verify_configuration: Err,
  initial_message: Trr,
  initial_message_description: Arr,
  having_trouble_importing: Crr,
  learn: zrr,
  learn_how_to_get_your_terminator: Orr,
  phone_number_subscription_cancelled_successfully: Prr,
  updating: Irr,
  round_robin: Rrr,
  hi_how_are_you_doing: Nrr,
  round_robin_description: Drr,
  managed_event: Mrr,
  username_placeholder: Lrr,
  managed_event_description: qrr,
  managed: jrr,
  managed_event_url_clarification: Frr,
  assign_to: Vrr,
  enter_phone_number_to_test_call: Brr,
  make_test_call: Urr,
  create_new_workflow_agent: Wrr,
  create_new_workflow_agent_description: Grr,
  phone_number_for_ai_call: Hrr,
  buy_a_phone_number_or_import_one_you_already_have: Krr,
  test_agent: Yrr,
  test_web_call: Zrr,
  phone_numbers: Qrr,
  unsubscribe: Jrr,
  delete_workflow_step: Xrr,
  unsubscribe_phone_number: eir,
  buy_a_new_number: tir,
  only_us_phone_numbers_can_be_purchased_here: nir,
  buy_number_for_x_per_month: oir,
  supported_call_destinations: rir,
  no_phone_number_connected: iir,
  failed_to_get_workflow_step_id: air,
  cal_ai_agent: sir,
  test_cal_ai_agent: cir,
  are_you_sure_you_want_to_delete_workflow_step: lir,
  do_you_still_want_to_unsubscribe: dir,
  the_action_will_disconnect_phone_number: uir,
  cal_ai_phone_numbers: _ir,
  connect_phone_number: pir,
  cal_ai_phone_numbers_description: mir,
  import_number: fir,
  this_action_will_also: gir,
  import_phone_number: hir,
  active_subscription: vir,
  cancel_your_phone_number_subscription: bir,
  delete_associated_phone_number: yir,
  unauthorized_create_workflow: $ir,
  import_phone_number_description: wir,
  phone_number_cost: kir,
  buy_new_number: Sir,
  buy_number_cost_x_per_month: xir,
  area_code_optional: Eir,
  no_phone_numbers: Tir,
  phone_number_purchased_successfully: Air,
  cancel_phone_number_subscription: Cir,
  yes_cancel_subscription: zir,
  cancel_phone_number_subscription_confirmation: Oir,
  add_members: Pir,
  add_members_no_ellipsis: Iir,
  no_assigned_members: Rir,
  assigned_to: Nir,
  you_must_be_logged_in_to: Dir,
  start_assigning_members_above: Mir,
  locked_fields_admin_description: Lir,
  unlocked_fields_admin_description: qir,
  locked_fields_member_description: jir,
  unlocked_fields_member_description: Fir,
  url: Vir,
  hidden: Bir,
  readonly: Uir,
  one_time_link: Wir,
  plan_description: Gir,
  plan_upgrade_invitation: Hir,
  plan_upgrade: Kir,
  plan_upgrade_teams: Yir,
  plan_upgrade_instructions: Zir,
  event_types_page_title: Qir,
  event_types_page_subtitle: Jir,
  new: "Nouveau",
  new_event_type_btn: Xir,
  new_event_type_heading: ear,
  new_event_type_description: tar,
  event_type_created_successfully: nar,
  event_type_updated_successfully: oar,
  event_type_deleted_successfully: rar,
  hours: iar,
  people: aar,
  your_email: sar,
  change_avatar: car,
  upload_avatar: lar,
  language: dar,
  timezone: uar,
  first_day_of_week: _ar,
  repeats_up_to_one: par,
  repeats_up_to_other: mar,
  every_for_freq: far,
  event_remaining_one: gar,
  event_remaining_other: har,
  repeats_every: bar,
  occurrence_one: yar,
  occurrence_other: $ar,
  weekly_one: war,
  weekly_other: kar,
  monthly_one: Sar,
  monthly_other: xar,
  yearly_one: Ear,
  yearly_other: Tar,
  plus_more: Aar,
  max: Car,
  single_theme: zar,
  brand_color: Oar,
  light_brand_color: Par,
  dark_brand_color: Iar,
  light_event_type_color: Rar,
  dark_event_type_color: Nar,
  file_not_named: Dar,
  create_team: Mar,
  name: Lar,
  nameless_team: qar,
  oauth_clients: jar,
  oauth_clients_description: Far,
  create_oauth_client: Var,
  create_oauth_client_description: Bar,
  oauth_client_deletion_message: Uar,
  create_new_team_description: War,
  create_new_team: Gar,
  booking_redirect_uri: Har,
  booking_cancel_redirect_uri: Kar,
  booking_reschedule_redirect_uri: Yar,
  booking_conflict_error: Zar,
  open_invitations: Qar,
  new_team: Jar,
  create_first_team_and_invite_others: Xar,
  create_team_to_get_started: esr,
  teams: tsr,
  team: nsr,
  organization: osr,
  team_billing: rsr,
  team_billing_description: isr,
  upgrade_to_flexible_pro_title: asr,
  upgrade_to_flexible_pro_message: ssr,
  changed_team_billing_info: csr,
  create_manage_teams_collaborative: lsr,
  only_available_on_pro_plan: dsr,
  remove_cal_branding_description: usr,
  edit_profile_info_description: _sr,
  change_email_tip: psr,
  little_something_about: msr,
  profile_updated_successfully: fsr,
  your_user_profile_updated_successfully: gsr,
  your_upgrade_is_here: hsr,
  your_upgrade_is_here_description: vsr,
  you_are_all_set: bsr,
  you_are_all_set_description: ysr,
  user_cannot_found_db: $sr,
  embed_and_webhooks: wsr,
  enabled: ksr,
  disabled: Ssr,
  disable: xsr,
  billing: Esr,
  here: Tsr,
  manage_your_billing_info: Asr,
  availability: Csr,
  edit_availability: zsr,
  configure_availability: Osr,
  copy_times_to: Psr,
  copy_times_to_tooltip: Isr,
  change_weekly_schedule: Rsr,
  logo: Nsr,
  error: Dsr,
  at_least_characters_one: Msr,
  at_least_characters_other: Lsr,
  team_logo: qsr,
  add_location: jsr,
  attendees: Fsr,
  add_attendees: Vsr,
  show_advanced_settings: Bsr,
  hide_advanced_settings: Usr,
  event_name: Wsr,
  event_name_in_calendar: Gsr,
  event_name_tooltip: Hsr,
  meeting_with_user: Ksr,
  additional_inputs: Ysr,
  additional_input_description: Zsr,
  label: Qsr,
  placeholder: Jsr,
  display_add_to_calendar_organizer: Xsr,
  display_email_as_organizer: ecr,
  if_enabled_email_address_as_organizer: tcr,
  reconnect_calendar_to_use: ncr,
  type: ocr,
  edit: rcr,
  add_input: icr,
  disable_notes: acr,
  disable_notes_description: scr,
  requires_confirmation_description: ccr,
  requires_confirmation_will_block_slot_description: lcr,
  recurring_event: dcr,
  recurring_event_description: ucr,
  connect_and_join: _cr,
  cannot_be_used_with_paid_event_types: pcr,
  warning_payment_instant_meeting_event: mcr,
  warning_instant_meeting_experimental: fcr,
  starting: gcr,
  disable_guests: hcr,
  disable_guests_description: vcr,
  private_link: bcr,
  enable_private_url: ycr,
  private_link_label: $cr,
  private_link_hint: wcr,
  copy_private_link: kcr,
  copy_private_link_to_event: Scr,
  private_link_description: xcr,
  multiple_private_links_title: Ecr,
  multiple_private_links_description: Tcr,
  add_a_multiple_private_link: Acr,
  multiple_private_link_copied: Ccr,
  invitees_can_schedule: zcr,
  date_range: Ocr,
  calendar_days: Pcr,
  business_days: Icr,
  set_address_place: Rcr,
  set_link_meeting: Ncr,
  managed_event_field_parent_control_disabled: Dcr,
  cal_invitee_phone_number_scheduling: Mcr,
  cal_provide_google_meet_location: Lcr,
  cal_provide_zoom_meeting_url: qcr,
  cal_provide_tandem_meeting_url: jcr,
  cal_provide_video_meeting_url: Fcr,
  cal_provide_jitsi_meeting_url: Vcr,
  cal_provide_huddle01_meeting_url: Bcr,
  cal_provide_teams_meeting_url: Ucr,
  require_payment: Wcr,
  you_need_to_add_a_name: Gcr,
  commission_per_transaction: Hcr,
  event_type_updated_successfully_description: Kcr,
  hide_event_type: Ycr,
  edit_location: Zcr,
  into_the_future: Qcr,
  when_booked_with_less_than_notice: Jcr,
  within_date_range: Xcr,
  indefinitely_into_future: elr,
  add_new_custom_input_field: tlr,
  quick_chat: nlr,
  add_new_team_event_type: olr,
  add_new_event_type: rlr,
  new_event_type_to_book_description: ilr,
  length: alr,
  minimum_booking_notice: slr,
  offset_toggle: clr,
  offset_toggle_description: llr,
  offset_start: dlr,
  offset_start_description: ulr,
  slot_interval: _lr,
  slot_interval_default: plr,
  delete_event_type: mlr,
  delete_managed_event_type: flr,
  delete_event_type_description: glr,
  delete_managed_event_type_description_1: hlr,
  delete_managed_event_type_description_2: vlr,
  confirm_delete_event_type: blr,
  delete_account: ylr,
  confirm_delete_account: $lr,
  delete_account_confirmation_message: wlr,
  integrations: klr,
  apps: Slr,
  apps_description: xlr,
  apps_listing: Elr,
  category_apps: Tlr,
  app_store: Alr,
  app_store_description: Clr,
  connect_your_video: zlr,
  settings: Olr,
  event_type_moved_successfully: Plr,
  next_step_text: Ilr,
  next_step: Rlr,
  prev_step: Nlr,
  install: Dlr,
  start_paid_trial: Mlr,
  installed: Llr,
  active_install_one: qlr,
  active_install_other: jlr,
  globally_install: Flr,
  app_successfully_installed: Vlr,
  app_could_not_be_installed: Blr,
  disconnect: Ulr,
  embed_your_calendar: Wlr,
  connect_your_favourite_apps: Glr,
  automation: Hlr,
  configure_how_your_event_types_interact: Klr,
  toggle_calendars_conflict: Ylr,
  connect_additional_calendar: Zlr,
  calendar_updated_successfully: Qlr,
  check_here: Jlr,
  conferencing: Xlr,
  calendar: edr,
  payments: tdr,
  not_installed: ndr,
  error_password_mismatch: odr,
  error_required_field: rdr,
  status: idr,
  team_view_user_availability: adr,
  team_view_user_availability_disabled: sdr,
  set_as_away: cdr,
  set_as_free: ldr,
  toggle_away_error: ddr,
  user_away: udr,
  user_away_description: _dr,
  meet_people_with_the_same_tokens: pdr,
  only_book_people_and_allow: mdr,
  account_created_with_identity_provider: fdr,
  account_managed_by_identity_provider: gdr,
  account_managed_by_identity_provider_description: hdr,
  account_managed_by_identity_provider_error: vdr,
  user_creation_error: bdr,
  signin_with_google: ydr,
  signin_with_saml: $dr,
  signin_with_saml_oidc: wdr,
  continue_with_email: kdr,
  continue_with_google: Sdr,
  last_used: xdr,
  you_will_need_to_generate: Edr,
  import: "Importer",
  import_from: Tdr,
  access_token: Adr,
  visit_roadmap: Cdr,
  featured_categories: zdr,
  feature_flags: Odr,
  admin_flags_description: Pdr,
  popular_categories: Idr,
  number_apps_one: Rdr,
  number_apps_other: Ndr,
  trending_apps: Ddr,
  most_popular: Mdr,
  installed_apps: Ldr,
  free_to_use_apps: qdr,
  no_category_apps: jdr,
  all_apps: Fdr,
  no_category_apps_description_calendar: Vdr,
  no_category_apps_description_conferencing: Bdr,
  no_category_apps_description_payment: Udr,
  no_category_apps_description_analytics: Wdr,
  no_category_apps_description_automation: Gdr,
  no_category_apps_description_other: Hdr,
  no_category_apps_description_messaging: Kdr,
  no_category_apps_description_crm: Ydr,
  installed_app_calendar_description: Zdr,
  installed_app_payment_description: Qdr,
  installed_app_analytics_description: Jdr,
  installed_app_other_description: Xdr,
  installed_app_conferencing_description: eur,
  installed_app_automation_description: tur,
  installed_app_messaging_description: nur,
  installed_app_crm_description: our,
  analytics: rur,
  empty_installed_apps_headline: iur,
  empty_installed_apps_description: aur,
  empty_installed_apps_button: sur,
  manage_your_connected_apps: cur,
  browse_apps: lur,
  features: dur,
  permissions: uur,
  terms_and_privacy: _ur,
  published_by: pur,
  subscribe: mur,
  buy: fur,
  install_app: gur,
  categories: hur,
  pricing: vur,
  learn_more: bur,
  try_now: yur,
  privacy_policy: $ur,
  terms_of_service: wur,
  remove: kur,
  add: Sur,
  installed_other: xur,
  verify_wallet: Eur,
  create_events_on: Tur,
  enterprise_license: Aur,
  enterprise_license_locally: Cur,
  enterprise_license_sales: zur,
  missing_license: Our,
  next_steps: Pur,
  acquire_commercial_license: Iur,
  the_infrastructure_plan: Rur,
  prisma_studio_tip: Nur,
  prisma_studio_tip_description: Dur,
  contact_sales: Mur,
  error_404: Lur,
  default: "Par défaut",
  set_to_default: qur,
  new_schedule_btn: jur,
  add_new_schedule: Fur,
  add_new_calendar: Vur,
  set_calendar: Bur,
  delete_schedule: Uur,
  delete_schedule_description: Wur,
  schedule_created_successfully: Gur,
  availability_updated_successfully: Hur,
  schedule_deleted_successfully: Kur,
  default_schedule_name: Yur,
  new_schedule_heading: Zur,
  new_schedule_description: Qur,
  requires_ownership_of_a_token: Jur,
  example_name: Xur,
  time_format: e_r,
  "12_hour": "12 heures",
  "24_hour": "24 heures",
  "12_hour_short": "12 h",
  "24_hour_short": "24 h",
  redirect_success_booking: t_r,
  you_are_being_redirected: n_r,
  external_redirect_url: o_r,
  redirect_url_description: r_r,
  duplicate: i_r,
  offer_seats: a_r,
  offer_seats_description: s_r,
  seats_available_one: c_r,
  seats_available_other: l_r,
  seats_nearly_full: d_r,
  seats_half_full: u_r,
  number_of_seats: __r,
  set_instant_meeting_expiry_time_offset_description: p_r,
  enter_number_of_seats: m_r,
  you_can_manage_your_schedules: f_r,
  booking_full: g_r,
  api_keys: h_r,
  api_key: v_r,
  test_api_key: b_r,
  test_passed: y_r,
  test_failed: $_r,
  provide_api_key: w_r,
  api_key_modal_subtitle: k_r,
  api_key_modal_subtitle_platform: S_r,
  api_keys_subtitle: x_r,
  create_api_key: E_r,
  personal_note: T_r,
  personal_note_placeholder: A_r,
  api_key_no_note: C_r,
  api_key_never_expires: z_r,
  edit_api_key: O_r,
  success_api_key_created: P_r,
  success_api_key_edited: I_r,
  create: R_r,
  success_api_key_created_bold_tagline: N_r,
  you_will_only_view_it_once: D_r,
  copy_to_clipboard: M_r,
  enabled_after_update: L_r,
  enabled_after_update_description: q_r,
  confirm_delete_api_key: j_r,
  disable_rescheduling: F_r,
  description_disable_rescheduling: V_r,
  allow_rescheduling_cancelled_bookings: B_r,
  description_allow_rescheduling_cancelled_bookings: U_r,
  disable_cancelling: W_r,
  description_disable_cancelling: G_r,
  revoke_api_key: H_r,
  api_key_copied: K_r,
  api_key_expires_on: Y_r,
  delete_api_key_confirm_title: Z_r,
  copy: Q_r,
  expire_date: J_r,
  expired: X_r,
  never_expires: epr,
  expires: tpr,
  request_reschedule_booking: npr,
  reason_for_reschedule: opr,
  book_a_new_time: rpr,
  reschedule_request_sent: ipr,
  reschedule_modal_description: apr,
  reason_for_reschedule_request: spr,
  send_reschedule_request: cpr,
  edit_booking: lpr,
  reschedule_booking: dpr,
  former_time: upr,
  confirmation_page_gif: _pr,
  search: ppr,
  impersonate: mpr,
  user_impersonation_heading: fpr,
  user_impersonation_description: gpr,
  team_impersonation_description: hpr,
  cal_signup_description: vpr,
  make_org_private: bpr,
  make_org_private_description: ypr,
  make_team_private: $pr,
  make_team_private_description: wpr,
  you_cannot_see_team_members: kpr,
  you_cannot_see_teams_of_org: Spr,
  allow_multiple_durations: xpr,
  impersonate_user_tip: Epr,
  impersonating_user_warning: Tpr,
  impersonating_stop_instructions: Apr,
  event_location_changed: Cpr,
  new_guests_added: zpr,
  location_changed_event_type_subject: Opr,
  guests_added_event_type_subject: Ppr,
  current_location: Ipr,
  new_location: Rpr,
  session: Npr,
  session_description: Dpr,
  session_timeout_after: Mpr,
  session_timeout: Lpr,
  session_timeout_description: qpr,
  no_location: jpr,
  set_location: Fpr,
  update_location: Vpr,
  location_updated: Bpr,
  location_update_failed: Upr,
  guests_added: Wpr,
  unable_to_add_guests: Gpr,
  email_validation_error: Hpr,
  emails_must_be_unique_valid: Kpr,
  url_validation_error: Ypr,
  place_where_cal_widget_appear: Zpr,
  create_update_react_component: Qpr,
  copy_code: Jpr,
  code_copied: Xpr,
  how_you_want_add_cal_site: emr,
  choose_ways_put_cal_site: tmr,
  setting_up_zapier: nmr,
  setting_up_make: omr,
  generate_api_key: rmr,
  generate_api_key_description: imr,
  your_unique_api_key: amr,
  copy_safe_api_key: smr,
  zapier_setup_instructions: cmr,
  make_setup_instructions_1: lmr,
  make_setup_instructions_2: dmr,
  make_setup_instructions_3: umr,
  make_setup_instructions_4: _mr,
  make_setup_instructions_5: pmr,
  make_setup_instructions_6: mmr,
  install_zapier_app: fmr,
  install_make_app: gmr,
  app_installation: hmr,
  app_not_installed: vmr,
  visit_our_app_store: bmr,
  connect_apple_server: ymr,
  calendar_url: $mr,
  apple_server_generate_password: wmr,
  unable_to_add_apple_calendar: kmr,
  credentials_stored_encrypted: Smr,
  it_stored_encrypted: xmr,
  go_to_app_store: Emr,
  calendar_error: Tmr,
  set_your_phone_number: Amr,
  calendar_no_busy_slots: Cmr,
  display_location_label: zmr,
  display_location_info_badge: Omr,
  add_gif: Pmr,
  search_giphy: Imr,
  add_link_from_giphy: Rmr,
  add_gif_to_confirmation: Nmr,
  find_gif_spice_confirmation: Dmr,
  share_feedback: Mmr,
  resources: Lmr,
  support_documentation: qmr,
  developer_documentation: jmr,
  get_in_touch: Fmr,
  contact_support: Vmr,
  premium_support: Bmr,
  community_support: Umr,
  feedback: Wmr,
  submitted_feedback: Gmr,
  feedback_error: Hmr,
  comments: Kmr,
  booking_details: Ymr,
  or_lowercase: Zmr,
  nevermind: Qmr,
  go_to: Jmr,
  zapier_invite_link: Xmr,
  meeting_url_provided_after_confirmed: efr,
  dynamically_display_attendee_or_organizer: tfr,
  event_location: nfr,
  reschedule_optional: ofr,
  reschedule_placeholder: rfr,
  event_cancelled: ifr,
  emailed_information_about_cancelled_event: afr,
  this_input_will_shown_booking_this_event: sfr,
  meeting_url_in_confirmation_email: cfr,
  url_start_with_https: lfr,
  number_provided: dfr,
  before_event_trigger: ufr,
  event_cancelled_trigger: _fr,
  after_hosts_cal_video_no_show: pfr,
  after_guests_cal_video_no_show: mfr,
  join_video_call: ffr,
  sign_in_to_cal_com: gfr,
  log_in_to_cal_com: hfr,
  track_your_meetings: vfr,
  track_meetings_and_manage_schedule: bfr,
  failed_to_join_call: yfr,
  choose_how_you_d_like_to_join_call: $fr,
  choose_how_you_d_like_to_appear_on_the_call: wfr,
  new_event_trigger: kfr,
  email_host_action: Sfr,
  email_attendee_action: xfr,
  sms_attendee_action: Efr,
  sms_number_action: Tfr,
  send_reminder_sms: Afr,
  whatsapp_number_action: Cfr,
  whatsapp_attendee_action: zfr,
  workflows: Ofr,
  new_workflow_btn: Pfr,
  how_would_you_like_to_start: Ifr,
  add_new_workflow: Rfr,
  reschedule_event_trigger: Nfr,
  trigger: Dfr,
  triggers: Mfr,
  action: Lfr,
  workflows_to_automate_notifications: qfr,
  workflow_name: jfr,
  custom_workflow: Ffr,
  workflow_created_successfully: Vfr,
  delete_workflow_description: Bfr,
  delete_workflow: Ufr,
  confirm_delete_workflow: Wfr,
  workflow_deleted_successfully: Gfr,
  how_long_before: Hfr,
  day_timeUnit: Kfr,
  hour_timeUnit: Yfr,
  minute_timeUnit: Zfr,
  minute_short: Qfr,
  hour_short: Jfr,
  new_workflow_heading: Xfr,
  new_workflow_description: egr,
  active_on: tgr,
  workflow_updated_successfully: ngr,
  premium_to_standard_username_description: ogr,
  premium_username: rgr,
  current: igr,
  premium: agr,
  standard: sgr,
  confirm_username_change_dialog_title: cgr,
  change_username_standard_to_premium: lgr,
  change_username_premium_to_standard: dgr,
  go_to_stripe_billing: ugr,
  stripe_description: _gr,
  trial_expired: pgr,
  remove_app: mgr,
  yes_remove_app: fgr,
  are_you_sure_you_want_to_remove_this_app: ggr,
  app_removed_successfully: hgr,
  error_removing_app: vgr,
  web_conference: bgr,
  web_call: ygr,
  start_web_call: $gr,
  end_call: wgr,
  test_your_agent_with_web_call: kgr,
  phone_call: Sgr,
  connecting_to_agent: xgr,
  call_active: Egr,
  call_ended: Tgr,
  call_error: Agr,
  ready_to_start_call: Cgr,
  failed_to_start_web_call_try_again: zgr,
  call_encountered_error_try_again: Ogr,
  failed_initialize_web_call_microphone_permissions: Pgr,
  start_call_to_see_conversation: Igr,
  waiting_for_conversation: Rgr,
  ai_agent: Ngr,
  live: Dgr,
  connecting: Mgr,
  requires_confirmation: Lgr,
  requires_confirmation_threshold: qgr,
  may_require_confirmation: jgr,
  nr_event_type_one: Fgr,
  nr_event_type_other: Vgr,
  count_team_one: Bgr,
  count_team_other: Ugr,
  add_action: Wgr,
  set_whereby_link: Ggr,
  invalid_whereby_link: Hgr,
  set_around_link: Kgr,
  invalid_around_link: Ygr,
  set_riverside_link: Zgr,
  invalid_riverside_link: Qgr,
  invalid_ping_link: Jgr,
  add_exchange2013: Xgr,
  add_exchange2016: ehr,
  custom_template: thr,
  email_body: nhr,
  text_message: ohr,
  specific_issue: rhr,
  browse_our_docs: ihr,
  choose_template: ahr,
  custom: shr,
  reminder: chr,
  rescheduled: lhr,
  rescheduled_by: dhr,
  original_booking: uhr,
  completed: _hr,
  rating: phr,
  reminder_email: mhr,
  not_triggering_existing_bookings: fhr,
  minute_one: ghr,
  minute_one_short: hhr,
  minute_other: vhr,
  hour_one: bhr,
  hour_one_short: yhr,
  hour_other: $hr,
  invalid_input: whr,
  broken_video_action: khr,
  broken_calendar_action: Shr,
  attendee_name: xhr,
  scheduler_full_name: Ehr,
  broken_integration: Thr,
  problem_adding_video_link: Ahr,
  problem_updating_calendar: Chr,
  active_on_event_types_one: zhr,
  active_on_event_types_other: Ohr,
  active_on_teams_one: Phr,
  active_on_teams_other: Ihr,
  active_on_all_event_types: Rhr,
  active_on_all_teams: Nhr,
  no_active_event_types: Dhr,
  no_active_teams: Mhr,
  new_seat_subject: Lhr,
  new_seat_title: qhr,
  variable: jhr,
  event_name_variable: Fhr,
  attendee_name_variable: Vhr,
  event_date_variable: Bhr,
  event_time_variable: Uhr,
  organizer_name_variable: Whr,
  app_upgrade_description: Ghr,
  invalid_number: Hhr,
  invalid_url_error_message: Khr,
  navigate: Yhr,
  open: Zhr,
  close: Qhr,
  upgrade: Jhr,
  buy_us_number_button: Xhr,
  upgrade_to_access_recordings_title: evr,
  upgrade_to_access_recordings_description: tvr,
  upgrade_to_cal_ai_phone_number_description: nvr,
  recordings_are_part_of_the_teams_plan: ovr,
  team_feature_teams: rvr,
  team_feature_workflows: ivr,
  show_eventtype_on_profile: avr,
  embed: svr,
  new_username: cvr,
  current_username: lvr,
  example_1: dvr,
  example_2: uvr,
  booking_question_identifier: _vr,
  company_size: pvr,
  what_help_needed: mvr,
  variable_format: fvr,
  webhook_subscriber_url_reserved: gvr,
  custom_input_as_variable_info: hvr,
  using_booking_questions_as_variables: vvr,
  download_desktop_app: bvr,
  set_ping_link: yvr,
  rate_limit_exceeded: $vr,
  when_something_happens: wvr,
  action_is_performed: kvr,
  test_action: Svr,
  notification_sent: xvr,
  no_input: Evr,
  test_workflow_action: Tvr,
  send_sms: Avr,
  send_sms_to_number: Cvr,
  missing_connected_calendar: zvr,
  connect_your_calendar_and_link: Ovr,
  default_calendar_selected: Pvr,
  hide_from_profile: Ivr,
  basics: Rvr,
  availability_not_found_in_schedule_error: Nvr,
  event_limit_tab_title: Dvr,
  event_limit_tab_description: Mvr,
  event_advanced_tab_description: Lvr,
  event_advanced_tab_title: qvr,
  event_payments_tab_description: jvr,
  event_setup_multiple_duration_error: Fvr,
  event_setup_multiple_duration_default_error: Vvr,
  event_setup_booking_limits_error: Bvr,
  event_setup_duration_limits_error: Uvr,
  select_which_cal: Wvr,
  custom_event_name: Gvr,
  custom_event_name_description: Hvr,
  "2fa_required": "Double authentification requise",
  incorrect_2fa: Kvr,
  which_event_type_apply: Yvr,
  apply_to_all_event_types: Zvr,
  apply_to_all_teams: Qvr,
  which_team_apply: Jvr,
  no_workflows_description: Xvr,
  timeformat_profile_hint: ebr,
  create_workflow: tbr,
  do_this: nbr,
  turn_off: obr,
  turn_on: rbr,
  cancelled_bookings_cannot_be_rescheduled: ibr,
  settings_updated_successfully: abr,
  error_updating_settings: sbr,
  personal_cal_url: cbr,
  bio_hint: lbr,
  finish_and_start: dbr,
  user_has_no_bio: ubr,
  bio: _br,
  delete_account_modal_title: pbr,
  confirm_delete_account_modal: mbr,
  delete_my_account: fbr,
  start_of_week: gbr,
  recordings_title: hbr,
  recording: vbr,
  happy_scheduling: bbr,
  select_calendars: ybr,
  check_for_conflicts: $br,
  view_recordings: wbr,
  check_for_recordings: kbr,
  adding_events_to: Sbr,
  follow_system_preferences: xbr,
  custom_brand_colors: Ebr,
  customize_your_brand_colors: Tbr,
  pro: Abr,
  removes_cal_branding: Cbr,
  instant_meeting_with_title: zbr,
  profile_picture: Obr,
  upload: Pbr,
  add_profile_photo: Ibr,
  token_address: Rbr,
  blockchain: Nbr,
  old_password: Dbr,
  secure_password: Mbr,
  error_updating_password: Lbr,
  two_factor_auth: qbr,
  recurring_event_tab_description: jbr,
  today: Fbr,
  appearance: Vbr,
  my_account: Bbr,
  general: Ubr,
  calendars: Wbr,
  "2fa_auth": "Double authentification",
  invoices: Gbr,
  embeds: Hbr,
  impersonation: Kbr,
  impersonation_description: Ybr,
  recent_impersonations: Zbr,
  quick_impersonate: Qbr,
  no_recent_impersonations: Jbr,
  users: Xbr,
  user: eyr,
  profile_description: tyr,
  users_description: nyr,
  users_listing: oyr,
  general_description: ryr,
  calendars_description: iyr,
  appearance_description: ayr,
  conferencing_description: syr,
  add_conferencing_app: cyr,
  password_description: lyr,
  set_up_two_factor_authentication: dyr,
  we_just_need_basic_info: uyr,
  skip: _yr,
  do_this_later: pyr,
  set_availability_getting_started_subtitle_1: myr,
  set_availability_getting_started_subtitle_2: fyr,
  connect_calendar_first: gyr,
  complete_profile: hyr,
  connect_calendars_from_app_store: vyr,
  connect_conference_apps: byr,
  connect_calendar_apps: yyr,
  connect_payment_apps: $yr,
  connect_automation_apps: wyr,
  connect_analytics_apps: kyr,
  connect_other_apps: Syr,
  connect_messaging_apps: xyr,
  connect_crm_apps: Eyr,
  current_step_of_total: Tyr,
  add_variable: Ayr,
  custom_phone_number: Cyr,
  message_template: zyr,
  email_subject: Oyr,
  add_dynamic_variables: Pyr,
  event_name_info: Iyr,
  event_date_info: Ryr,
  event_duration_info: Nyr,
  event_time_info: Dyr,
  event_type_not_found: Myr,
  number_to_call_variable: Lyr,
  number_to_call_info: qyr,
  location_variable: jyr,
  location_info: Fyr,
  additional_notes_variable: Vyr,
  additional_notes_info: Byr,
  attendee_name_info: Uyr,
  organizer_name_info: Wyr,
  to: Gyr,
  workflow_turned_on_successfully: Hyr,
  download_responses: Kyr,
  download_responses_description: Yyr,
  view_responses: Zyr,
  download: Qyr,
  downloading: Jyr,
  download_recording: Xyr,
  transcription_enabled: e$r,
  transcription_stopped: t$r,
  download_transcript: n$r,
  transcript: o$r,
  recording_from_your_recent_call: r$r,
  transcript_from_previous_call: i$r,
  you_can_download_transcript_from_attachments: a$r,
  link_valid_for_12_hrs: s$r,
  link_valid_for_12_hrs_description: c$r,
  create_your_first_form: l$r,
  create_your_first_form_description: d$r,
  create_your_first_webhook: u$r,
  create_your_first_webhook_description: _$r,
  for_a_maximum_of: p$r,
  event_one: m$r,
  event_other: f$r,
  profile_team_description: g$r,
  profile_org_description: h$r,
  members_team_description: v$r,
  organization_description: b$r,
  team_url: y$r,
  team_members: $$r,
  more: w$r,
  cal_ai_workflows: k$r,
  and_count_more: S$r,
  more_page_footer: x$r,
  workflow_example_1: E$r,
  workflow_example_2: T$r,
  workflow_example_3: A$r,
  workflow_example_4: C$r,
  workflow_example_5: z$r,
  workflow_example_6: O$r,
  send_sms_reminder: P$r,
  send_sms_reminder_description: I$r,
  follow_up_with_no_shows: R$r,
  follow_up_with_no_shows_description: N$r,
  remind_attendees_to_bring_id: D$r,
  remind_attendees_to_bring_id_description: M$r,
  email_to_remind_booking: L$r,
  email_to_remind_booking_description: q$r,
  custom_sms_reminder: j$r,
  custom_sms_reminder_description: F$r,
  custom_email_reminder: V$r,
  custom_email_reminder_description: B$r,
  count_managed_to_limit: U$r,
  welcome_to_cal_header: W$r,
  edit_form_later_subtitle: G$r,
  connect_calendar_later: H$r,
  problem_saving_user_profile: K$r,
  purchase_missing_seats: Y$r,
  slot_length: Z$r,
  booking_appearance: Q$r,
  appearance_team_description: J$r,
  appearance_org_description: X$r,
  only_owner_change: ewr,
  team_disable_cal_branding_description: twr,
  invited_by_team: nwr,
  token_invalid_expired: owr,
  view_booking: rwr,
  exchange_add: iwr,
  exchange_authentication: awr,
  exchange_authentication_standard: swr,
  exchange_authentication_ntlm: cwr,
  exchange_compression: lwr,
  exchange_version: dwr,
  exchange_version_2007_SP1: uwr,
  exchange_version_2010: _wr,
  exchange_version_2010_SP1: pwr,
  exchange_version_2010_SP2: mwr,
  exchange_version_2013: fwr,
  exchange_version_2013_SP1: gwr,
  exchange_version_2015: hwr,
  exchange_version_2016: vwr,
  routing: bwr,
  routing_forms_description: ywr,
  routing_forms_send_email_owner: $wr,
  routing_forms_send_email_owner_description: wwr,
  routing_forms_send_email_to: kwr,
  add_new_form: Swr,
  add_new_team_form: xwr,
  create_your_first_route: Ewr,
  route_to_the_right_person: Twr,
  form: Awr,
  form_description: Cwr,
  copy_link_to_form: zwr,
  theme: Owr,
  theme_applies_note: Pwr,
  app_theme: Iwr,
  app_theme_applies_note: Rwr,
  theme_system: Nwr,
  add_a_team: Dwr,
  add_webhook_description: Mwr,
  triggers_when: Lwr,
  test_webhook: qwr,
  enable_webhook: jwr,
  add_webhook: Fwr,
  webhook_edited_successfully: Vwr,
  api_keys_description: Bwr,
  new_api_key: Uwr,
  active: Wwr,
  api_key_updated: Gwr,
  api_key_update_failed: Hwr,
  embeds_title: Kwr,
  embeds_description: Ywr,
  create_first_api_key: Zwr,
  create_first_api_key_description: Qwr,
  back_to_signin: Jwr,
  reset_link_sent: Xwr,
  password_reset_email: e0r,
  password_reset_leading: t0r,
  password_updated: n0r,
  pending_payment: o0r,
  pending_invites: r0r,
  pending_organization_invites: i0r,
  not_on_cal: a0r,
  no_calendar_installed: s0r,
  no_calendar_installed_description: c0r,
  add_a_calendar: l0r,
  change_email_hint: d0r,
  confirm_password_change_email: u0r,
  seats: _0r,
  every_app_published: p0r,
  report_app: m0r,
  limit_booking_frequency: f0r,
  limit_booking_frequency_description: g0r,
  only_show_first_available_slot: h0r,
  only_show_first_available_slot_description: v0r,
  limit_total_booking_duration: b0r,
  limit_total_booking_duration_description: y0r,
  booker_booking_limit: $0r,
  booker_booking_limit_description: w0r,
  recurring_event_doesnt_support_booker_booking_limit: k0r,
  add_limit: S0r,
  team_name_required: x0r,
  show_attendees: E0r,
  show_available_seats_count: T0r,
  how_booking_questions_as_variables: A0r,
  format: C0r,
  questions: z0r,
  all_info_your_booker_provide: O0r,
  uppercase_for_letters: P0r,
  replace_whitespaces_underscores: I0r,
  platform_members: R0r,
  platform_members_description: N0r,
  platform_billing: D0r,
  manage_billing: M0r,
  manage_billing_description: L0r,
  billing_freeplan_title: q0r,
  billing_freeplan_description: j0r,
  billing_freeplan_cta: F0r,
  billing_portal: V0r,
  billing_help_cta: B0r,
  ignore_special_characters_booking_questions: U0r,
  retry: W0r,
  fetching_calendars_error: G0r,
  calendar_connection_fail: H0r,
  booking_confirmation_success: K0r,
  booking_rejection_success: Y0r,
  booking_tentative: Z0r,
  booking_accept_intent: Q0r,
  we_wont_show_again: J0r,
  couldnt_update_timezone: X0r,
  updated_timezone_to: ekr,
  update_timezone: tkr,
  update_timezone_question: nkr,
  update_timezone_description: okr,
  dont_update: rkr,
  require_additional_notes: ikr,
  require_additional_notes_description: akr,
  email_address_action: skr,
  after_event_trigger: ckr,
  booking_rejected_trigger: lkr,
  booking_requested_trigger: dkr,
  booking_payment_initiated_trigger: ukr,
  booking_paid_trigger: _kr,
  booking_no_show_updated_trigger: pkr,
  how_long_after: mkr,
  how_long_after_hosts_no_show: fkr,
  how_long_after_guests_no_show: gkr,
  how_long_after_user_no_show_minutes: hkr,
  no_available_slots: vkr,
  time_available: bkr,
  cant_find_the_right_conferencing_app_visit_our_app_store: ykr,
  install_new_calendar_app: $kr,
  make_phone_number_required: wkr,
  new_event_type_availability: kkr,
  error_editing_availability: Skr,
  dont_have_permission: xkr,
  saml_configuration_placeholder: Ekr,
  saml_email_required: Tkr,
  saml_sp_title: Akr,
  saml_sp_description: Ckr,
  saml_sp_acs_url: zkr,
  saml_sp_entity_id: Okr,
  saml_sp_acs_url_copied: Pkr,
  saml_sp_entity_id_copied: Ikr,
  add_calendar: Rkr,
  limit_future_bookings: Nkr,
  limit_future_bookings_description: Dkr,
  no_event_types: Mkr,
  no_event_types_description: Lkr,
  billing_frequency: qkr,
  monthly: jkr,
  yearly: Fkr,
  checkout: Vkr,
  your_team_disbanded_successfully: Bkr,
  your_org_disbanded_successfully: Ukr,
  error_creating_team: Wkr,
  you: Gkr,
  or_continue_with: Hkr,
  resend_email: Kkr,
  member_already_invited: Ykr,
  already_in_use_error: Zkr,
  enter_email_or_username: Qkr,
  enter_email: Jkr,
  enter_emails: Xkr,
  too_many_invites: e1r,
  team_name_taken: t1r,
  must_enter_team_name: n1r,
  team_url_required: o1r,
  url_taken: r1r,
  problem_registering_domain: i1r,
  team_publish: a1r,
  number_text_notifications: s1r,
  number_sms_notifications: c1r,
  attendee_email_variable: l1r,
  attendee_email_info: d1r,
  booking_uid: u1r,
  kbar_search_placeholder: _1r,
  invalid_credential: p1r,
  invalid_credential_action: m1r,
  reschedule_reason: f1r,
  choose_common_schedule_team_event: g1r,
  choose_common_schedule_team_event_description: h1r,
  reason: v1r,
  sender_id: b1r,
  sender_id_error_message: y1r,
  test_routing_form: $1r,
  test_preview: w1r,
  route_to: k1r,
  test_preview_description: S1r,
  test_routing: x1r,
  payment_app_disabled: E1r,
  edit_event_type: T1r,
  only_admin_can_see_members_of_org: A1r,
  only_admin_can_manage_sso_org: C1r,
  only_admin_can_manage_directory_sync: z1r,
  only_admin_can_manage_oauth_clients: O1r,
  collective_scheduling: P1r,
  make_it_easy_to_book: I1r,
  find_the_best_person: R1r,
  fixed_round_robin: N1r,
  add_one_fixed_attendee: D1r,
  calcom_is_better_with_team: M1r,
  the_calcom_team: L1r,
  add_your_team_members: q1r,
  booking_limit_reached: j1r,
  duration_limit_reached: F1r,
  admin_has_disabled: V1r,
  disable_attendees_emails_description: B1r,
  disabled_app_affects_event_type: U1r,
  event_replaced_notice: W1r,
  email_subject_slug_replacement: G1r,
  email_body_slug_replacement_notice: H1r,
  email_body_slug_replacement_info: K1r,
  email_body_slug_replacement_suggestion: Y1r,
  disable_payment_app: Z1r,
  payment_disabled_still_able_to_book: Q1r,
  app_disabled_with_event_type: J1r,
  app_disabled_video: X1r,
  app_disabled_subject: e2r,
  navigate_installed_apps: t2r,
  disabled_calendar: n2r,
  enable_apps: o2r,
  enable_apps_description: r2r,
  purchase_license: i2r,
  already_have_account: a2r,
  already_have_key: s2r,
  already_have_key_suggestion: c2r,
  create_license_key: l2r,
  app_is_enabled: d2r,
  app_is_disabled: u2r,
  keys_have_been_saved: _2r,
  disable_app: p2r,
  disable_app_description: m2r,
  edit_keys: f2r,
  admin_apps_description: g2r,
  admin_users_description: h2r,
  admin_users_add_description: v2r,
  admin_users_edit_description: b2r,
  admin_orgs_edit_description: y2r,
  admin_oAuth_description: $2r,
  admin_lockedSMS_description: w2r,
  no_available_apps: k2r,
  no_available_apps_description: S2r,
  no_apps: x2r,
  no_apps_configured: E2r,
  enable_in_settings: T2r,
  please_contact_admin: A2r,
  apps_settings: C2r,
  fill_this_field: z2r,
  options: O2r,
  enter_option: P2r,
  add_an_option: I2r,
  location_already_exists: R2r,
  radio: N2r,
  google_meet_warning: D2r,
  individual: M2r,
  all_bookings_filter_label: L2r,
  all_users_filter_label: q2r,
  all_event_types_filter_label: j2r,
  your_bookings_filter_label: F2r,
  meeting_url_variable: V2r,
  meeting_url_info: B2r,
  date_overrides: U2r,
  date_overrides_delete_on_date: W2r,
  date_overrides_subtitle: G2r,
  date_overrides_info: H2r,
  date_overrides_dialog_which_hours: K2r,
  date_overrides_dialog_which_hours_unavailable: Y2r,
  date_overrides_dialog_title: Z2r,
  date_overrides_unavailable: Q2r,
  date_overrides_mark_all_day_unavailable_one: J2r,
  date_overrides_mark_all_day_unavailable_other: X2r,
  date_overrides_update_btn: eSr,
  date_successfully_added: tSr,
  date_overrides_save_btn: nSr,
  event_type_duplicate_copy_text: oSr,
  set_as_default: rSr,
  hide_eventtype_details: iSr,
  show_navigation: aSr,
  hide_navigation: sSr,
  verification_code_sent: cSr,
  verified_successfully: lSr,
  wrong_code: dSr,
  not_verified: uSr,
  no_availability_in_month: _Sr,
  no_availability_rolling: pSr,
  no_availability_range: mSr,
  view_previous_month: fSr,
  view_next_month: gSr,
  send_code: hSr,
  number_verified: vSr,
  create_your_first_team_webhook_description: bSr,
  create_webhook_team_event_type: ySr,
  disable_success_page: $Sr,
  invalid_admin_password: wSr,
  change_password_admin: kSr,
  username_already_taken: SSr,
  assignment: xSr,
  fixed_hosts: ESr,
  add_fixed_hosts: TSr,
  round_robin_hosts: ASr,
  minimum_round_robin_hosts_count: CSr,
  hosts: zSr,
  upgrade_to_enable_feature: OSr,
  orgs_upgrade_to_enable_feature: PSr,
  new_attendee: ISr,
  awaiting_approval: RSr,
  requires_google_calendar: NSr,
  event_type_requires_google_calendar: DSr,
  connected_google_calendar: MSr,
  using_meet_requires_calendar: LSr,
  continue_to_install_google_calendar: qSr,
  install_google_meet: jSr,
  install_google_calendar: FSr,
  sender_name: VSr,
  already_invited: BSr,
  no_recordings_found: USr,
  new_workflow_subtitle: WSr,
  reporting: GSr,
  reporting_feature: HSr,
  teams_plan_required: KSr,
  routing_forms_are_a_great_way: YSr,
  choose_a_license: ZSr,
  choose_license_description: QSr,
  license: JSr,
  agplv3_license: XSr,
  no_need_to_keep_your_code_open_source: exr,
  repackage_rebrand_resell: txr,
  a_vast_suite_of_enterprise_features: nxr,
  free_license_fee: oxr,
  forever_open_and_free: rxr,
  required_to_keep_your_code_open_source: ixr,
  cannot_repackage_and_resell: axr,
  no_enterprise_features: sxr,
  step_enterprise_license: cxr,
  step_enterprise_license_description: lxr,
  setup: dxr,
  setup_description: uxr,
  configure: _xr,
  sso_configuration: pxr,
  sso_configuration_description: mxr,
  sso_configuration_description_orgs: fxr,
  sso_oidc_heading: gxr,
  sso_oidc_description: hxr,
  sso_oidc_configuration_title: vxr,
  sso_oidc_configuration_description: bxr,
  sso_oidc_callback_copied: yxr,
  sso_saml_heading: $xr,
  sso_saml_description: wxr,
  sso_saml_configuration_title: kxr,
  sso_saml_configuration_description: Sxr,
  sso_saml_acsurl_copied: xxr,
  sso_saml_entityid_copied: Exr,
  sso_connection_created_successfully: Txr,
  sso_connection_deleted_successfully: Axr,
  delete_sso_configuration: Cxr,
  delete_sso_configuration_confirmation: zxr,
  delete_sso_configuration_confirmation_description: Oxr,
  organizer_timezone: Pxr,
  email_user_cta: Ixr,
  accept_invite: Rxr,
  join_now: Nxr,
  successfully_joined: Dxr,
  email_no_user_invite_heading_subteam: Mxr,
  email_no_user_invite_heading_org: Lxr,
  email_no_user_invite_subheading: qxr,
  email_user_invite_subheading_subteam: jxr,
  email_user_invite_subheading_org: Fxr,
  email_no_user_invite_steps_intro: Vxr,
  email_no_user_step_one: Bxr,
  email_no_user_step_two: Uxr,
  email_no_user_step_three: Wxr,
  email_no_user_step_four: Gxr,
  email_no_user_signoff: Hxr,
  impersonation_user_tip: Kxr,
  available_variables: Yxr,
  scheduler: Zxr,
  no_workflows: Qxr,
  change_filter: Jxr,
  change_filter_common: Xxr,
  no_results_for_filter: eEr,
  recommended_next_steps: tEr,
  create_a_managed_event: nEr,
  meetings_are_better_with_the_right: oEr,
  create_a_one_one_template: rEr,
  collective_or_roundrobin: iEr,
  book_your_team_members: aEr,
  event_no_longer_attending_subject: sEr,
  no_longer_attending: cEr,
  attendee_no_longer_attending_subject: lEr,
  attendee_no_longer_attending: dEr,
  attendee_no_longer_attending_subtitle: uEr,
  create_event_on: _Er,
  create_routing_form_on: pEr,
  default_app_link_title: mEr,
  default_app_link_description: fEr,
  organizer_default_conferencing_app: gEr,
  organizer_default_conferencing_app_not_found: hEr,
  under_maintenance: vEr,
  under_maintenance_description: bEr,
  event_type_seats: yEr,
  booking_questions_title: $Er,
  booking_questions_description: wEr,
  add_a_booking_question: kEr,
  identifier: SEr,
  duplicate_email: xEr,
  enter_redirect_url_on_exit_description: EEr,
  booking_with_payment_cancelled: TEr,
  booking_with_payment_cancelled_already_paid: AEr,
  booking_with_payment_cancelled_refunded: CEr,
  booking_with_payment_cancelled_no_refund: zEr,
  booking_with_payment_cancelled_refund_window_expired: OEr,
  booking_confirmation_failed: PEr,
  not_enough_seats: IEr,
  form_builder_field_already_exists: REr,
  guests_field_must_be_multiemail: NEr,
  show_on_booking_page: DEr,
  visit_cancelled_booking: MEr,
  get_started_zapier_templates: LEr,
  standard_templates: qEr,
  cal_ai_templates: jEr,
  team_is_unpublished: FEr,
  org_is_unpublished_description: VEr,
  team_is_unpublished_description: BEr,
  team_member: UEr,
  a_routing_form: WEr,
  form_description_placeholder: GEr,
  keep_me_connected_with_form: HEr,
  fields_in_form_duplicated: KEr,
  form_deleted: YEr,
  delete_form: ZEr,
  delete_form_action: QEr,
  delete_form_confirmation: JEr,
  delete_form_confirmation_2: XEr,
  typeform_redirect_url_copied: eTr,
  modifications_in_fields_warning: tTr,
  connected_forms: nTr,
  form_modifications_warning: oTr,
  responses_collection_waiting_description: rTr,
  this_is_what_your_users_would_see: iTr,
  identifies_name_field: aTr,
  add_1_option_per_line: sTr,
  select_a_router: cTr,
  add_a_new_route: lTr,
  make_informed_decisions: dTr,
  make_informed_decisions_description: uTr,
  view_bookings_across: _Tr,
  view_bookings_across_description: pTr,
  identify_booking_trends: mTr,
  identify_booking_trends_description: fTr,
  spot_popular_event_types: gTr,
  spot_popular_event_types_description: hTr,
  no_responses_yet: vTr,
  no_routes_defined: bTr,
  this_will_be_the_placeholder: yTr,
  error_booking_event: $Tr,
  timeslot_missing_title: wTr,
  timeslot_missing_description: kTr,
  timeslot_missing_cta: STr,
  switch_monthly: xTr,
  switch_weekly: ETr,
  switch_multiday: TTr,
  switch_columnview: ATr,
  num_locations: CTr,
  select_on_next_step: zTr,
  this_meeting_has_not_started_yet: OTr,
  this_app_requires_connected_account: PTr,
  connect_app: ITr,
  app_is_connected: RTr,
  requires_app: NTr,
  verification_code: DTr,
  can_you_try_again: MTr,
  verify: LTr,
  timezone_info: qTr,
  timezone_variable: jTr,
  event_end_time_variable: FTr,
  event_end_time_info: VTr,
  cancel_url_variable: BTr,
  cancel_url_info: UTr,
  cancel_reason_variable: WTr,
  cancel_reason_info: GTr,
  reschedule_url_variable: HTr,
  reschedule_url_info: KTr,
  reschedule_reason_variable: YTr,
  reschedule_reason_info: ZTr,
  invalid_event_name_variables: QTr,
  select_all: JTr,
  default_conferencing_bulk_title: XTr,
  members_default_schedule: eAr,
  set_by_admin: tAr,
  members_default_location: nAr,
  members_default_schedule_description: oAr,
  requires_at_least_one_schedule: rAr,
  default_conferencing_bulk_description: iAr,
  default_schedules_bulk_description: aAr,
  locked_for_members: sAr,
  unlocked_for_members: cAr,
  apps_locked_for_members_description: lAr,
  apps_unlocked_for_members_description: dAr,
  apps_locked_by_team_admins_description: uAr,
  apps_unlocked_by_team_admins_description: _Ar,
  workflows_locked_for_members_description: pAr,
  workflows_unlocked_for_members_description: mAr,
  workflows_locked_by_team_admins_description: fAr,
  workflows_unlocked_by_team_admins_description: gAr,
  webhooks_locked_for_members_description: hAr,
  webhooks_unlocked_for_members_description: vAr,
  webhooks_locked_by_team_admins_description: bAr,
  webhooks_unlocked_by_team_admins_description: yAr,
  locked_by_team_admin: $Ar,
  app_not_connected: wAr,
  connect_now: kAr,
  managed_event_dialog_confirm_button_one: SAr,
  managed_event_dialog_confirm_button_other: xAr,
  managed_event_dialog_title_one: EAr,
  managed_event_dialog_title_other: TAr,
  managed_event_dialog_information_one: AAr,
  managed_event_dialog_information_other: CAr,
  managed_event_dialog_clarification: zAr,
  review_event_type: OAr,
  looking_for_more_analytics: PAr,
  looking_for_more_insights: IAr,
  filters: RAr,
  filter: NAr,
  add_a_member: DAr,
  add_filter: MAr,
  add_rule: LAr,
  add_rule_group: qAr,
  remove_filters: jAr,
  email_verified: FAr,
  select_user: VAr,
  select_event_type: BAr,
  select_date_range: UAr,
  popular_events: WAr,
  no_event_types_found: GAr,
  average_event_duration: HAr,
  bookings_by_hour: KAr,
  most_booked_members: YAr,
  least_booked_members: ZAr,
  most_bookings_scheduled: QAr,
  least_bookings_scheduled: JAr,
  most_bookings_completed: XAr,
  least_bookings_completed: eCr,
  events_created: tCr,
  events_completed: nCr,
  events_cancelled: oCr,
  events_rescheduled: rCr,
  events: iCr,
  performance: aCr,
  from_last_period: sCr,
  from_to_date_period: cCr,
  redirect_url_warning: lCr,
  event_trends: dCr,
  clear_filters: uCr,
  clear: _Cr,
  hold: pCr,
  on_booking_option: mCr,
  hold_option: fCr,
  card_held: gCr,
  charge_card: hCr,
  card_charged: vCr,
  no_show_fee_amount: bCr,
  no_show_fee: yCr,
  submit_card: $Cr,
  submit_payment_information: wCr,
  meeting_awaiting_payment_method: kCr,
  no_show_fee_charged_email_subject: SCr,
  no_show_fee_charged_text_body: xCr,
  no_show_fee_charged_subtitle: ECr,
  error_charging_card: TCr,
  collect_no_show_fee: ACr,
  no_show_fee_charged: CCr,
  your_card_was_declined: zCr,
  your_card_does_not_support_this_type_of_purchase: OCr,
  amount_must_convert_to_at_least: PCr,
  could_not_charge_card: ICr,
  insights: RCr,
  routing_forms: NCr,
  insights_no_data_found_for_filter: DCr,
  acknowledge_booking_no_show_fee: MCr,
  days: LCr,
  card_details: qCr,
  something_went_wrong_on_our_end: jCr,
  please_provide_following_text_to_suppport: FCr,
  seats_and_no_show_fee_error: VCr,
  complete_your_booking: BCr,
  complete_your_booking_subject: UCr,
  confirm_your_details: WCr,
  copy_invite_link: GCr,
  edit_invite_link: HCr,
  invite_link_copied: KCr,
  invite_link_deleted: YCr,
  api_key_deleted: ZCr,
  delete_api_key_warning: QCr,
  invite_link_updated: JCr,
  link_expires_after: XCr,
  one_day: ezr,
  seven_days: tzr,
  thirty_days: nzr,
  three_months: ozr,
  one_year: rzr,
  team_invite_received: izr,
  currency_string: azr,
  charge_card_dialog_body: szr,
  charge_attendee: czr,
  payment_app_commission: lzr,
  email_invite_team: dzr,
  email_invite_team_bulk: uzr,
  error_collecting_card: _zr,
  image_size_limit_exceed: pzr,
  unauthorized_workflow_error_message: mzr,
  inline_embed: fzr,
  load_inline_content: gzr,
  floating_pop_up_button: hzr,
  floating_button_trigger_modal: vzr,
  pop_up_element_click: bzr,
  open_dialog_with_element_click: yzr,
  use_my_own_form: $zr,
  use_our_headless_routing_api: wzr,
  need_help_embedding: kzr,
  book_my_cal: Szr,
  first_name: xzr,
  last_name: Ezr,
  first_last_name: Tzr,
  invite_as: Azr,
  form_updated_successfully: Czr,
  disable_attendees_confirmation_emails: zzr,
  disable_attendees_confirmation_emails_description: Ozr,
  disable_host_confirmation_emails: Pzr,
  disable_host_confirmation_emails_description: Izr,
  add_an_override: Rzr,
  import_from_google_workspace: Nzr,
  connect_google_workspace: Dzr,
  google_workspace_admin_tooltip: Mzr,
  first_event_type_webhook_description: Lzr,
  create_instant_meeting_webhook_description: qzr,
  install_app_on: jzr,
  create_for: Fzr,
  currency: Vzr,
  organization_banner_description: Bzr,
  organization_banner_title: Uzr,
  set_up_your_organization: Wzr,
  set_up_your_platform_organization: Gzr,
  organizations_description: Hzr,
  plans: Kzr,
  platform: Yzr,
  platform_description: Zzr,
  platform_organization_description: Qzr,
  must_enter_organization_name: Jzr,
  must_enter_organization_admin_email: Xzr,
  admin_email: eOr,
  platform_admin_email: tOr,
  admin_username: nOr,
  organization_name: oOr,
  platform_name: rOr,
  organization_url: iOr,
  organization_verify_header: aOr,
  organization_verify_email_body: sOr,
  additional_url_parameters: cOr,
  about_your_organization: lOr,
  about_your_organization_description: dOr,
  create_your_teams: uOr,
  create_your_teams_description: _Or,
  invite_organization_admins: pOr,
  invite_organization_admins_description: mOr,
  set_a_password: fOr,
  set_a_password_description: gOr,
  organization_logo: hOr,
  organization_about_description: vOr,
  ill_do_this_later: bOr,
  verify_your_email: yOr,
  enter_digit_code: $Or,
  verify_email_organization: wOr,
  code_provided_invalid: kOr,
  email_already_used: SOr,
  organization_admin_invited_heading: xOr,
  organization_admin_invited_body: EOr,
  duplicated_slugs_warning: TOr,
  team_names_empty: AOr,
  team_names_repeated: COr,
  user_belongs_organization: zOr,
  org_no_teams_yet: OOr,
  org_no_teams_yet_description: POr,
  set_up: IOr,
  my_profile: ROr,
  my_settings: NOr,
  crm: DOr,
  messaging: MOr,
  sender_id_info: LOr,
  org_admins_can_create_new_teams: qOr,
  google_new_spam_policy: jOr,
  resolve: FOr,
  no_organization_slug: VOr,
  copy_link_org: BOr,
  "404_the_org": "L'organisation",
  "404_the_team": "L'équipe",
  "404_claim_entity_org": "Réservez votre sous-domaine pour votre organisation",
  "404_claim_entity_team": "Revendiquez cette équipe et commencez à gérer vos plannings collectivement",
  insights_team_filter: UOr,
  insights_user_filter: WOr,
  insights_subtitle: GOr,
  call_history: HOr,
  call_history_subtitle: KOr,
  location_options: YOr,
  channel_type: ZOr,
  end_reason: QOr,
  session_status: JOr,
  user_sentiment: XOr,
  time_header: e4r,
  from_header: t4r,
  custom_plan: n4r,
  email_embed: o4r,
  add_times_to_your_email: r4r,
  select_time: i4r,
  select_date: a4r,
  only_show_if_parameter_set: s4r,
  add_parameter: c4r,
  connecting_you_to_someone: l4r,
  please_do_not_close_this_tab: d4r,
  see_all_available_times: u4r,
  org_team_names_example_1: _4r,
  org_team_names_example_2: p4r,
  org_team_names_example_3: m4r,
  org_team_names_example_4: f4r,
  org_team_names_example_5: g4r,
  org_max_team_warnings: h4r,
  what_is_this_meeting_about: v4r,
  add_to_team: b4r,
  remove_users_from_org: y4r,
  delegation_credential: $4r,
  delegation_credential_description: w4r,
  add_client_id_in_google_workspace_with_below_scope: k4r,
  delegation_credential_enabled: S4r,
  add_delegation_credential: x4r,
  edit_delegation_credential: E4r,
  domain: T4r,
  no_workspace_platforms: A4r,
  workspace_platform: C4r,
  workspace_platforms: z4r,
  workspace_platforms_description: O4r,
  edit_workspace_platform: P4r,
  edit_service_account: I4r,
  add_workspace_platform: R4r,
  slug: N4r,
  service_account_key: D4r,
  edit_service_account_key: M4r,
  delegation_credential_restricts_adding_more_than_one_installation: L4r,
  app_successfully_installed_and_is_using_delegated_credentials: q4r,
  remove_users_from_org_confirm: j4r,
  remove_users_from_team: F4r,
  remove_users_from_team_confirm: V4r,
  user_has_no_schedules: B4r,
  user_isnt_in_any_teams: U4r,
  user_has_no_app_installed: W4r,
  requires_booker_email_verification: G4r,
  description_requires_booker_email_verification: H4r,
  requires_confirmation_mandatory: K4r,
  organizations: Y4r,
  upload_cal_video_logo: Z4r,
  update_cal_video_logo: Q4r,
  upload_banner: J4r,
  cal_video_logo_upload_instruction: X4r,
  org_admin_other_teams: e3r,
  org_admin_other_teams_description: t3r,
  not_part_of_org: n3r,
  no_other_teams_found: o3r,
  no_other_teams_found_description: r3r,
  attendee_first_name_variable: i3r,
  attendee_last_name_variable: a3r,
  attendee_first_name_info: s3r,
  attendee_last_name_info: c3r,
  your_monthly_digest: l3r,
  member_name: d3r,
  most_popular_events: u3r,
  summary_of_events_for_your_team_for_the_last_30_days: _3r,
  me: p3r,
  meeting_unavailable: m3r,
  monthly_digest_email: f3r,
  monthly_digest_email_for_teams: g3r,
  verify_team_tooltip: h3r,
  member_removed: v3r,
  my_availability: b3r,
  team_availability: y3r,
  instant_meeting_availability: $3r,
  backup_code: w3r,
  backup_codes: k3r,
  backup_code_instructions: S3r,
  backup_codes_copied: x3r,
  incorrect_backup_code: E3r,
  lost_access: T3r,
  missing_backup_codes: A3r,
  admin_org_notification_email_subject: C3r,
  hi_admin: z3r,
  admin_org_notification_email_title: O3r,
  admin_org_notification_email_body_part1: P3r,
  admin_org_notification_email_body_part2: I3r,
  admin_org_notification_email_body_part3: R3r,
  admin_org_notification_email_cta: N3r,
  org_has_been_processed: D3r,
  org_error_processing: M3r,
  orgs_page_description: L3r,
  unverified: q3r,
  verified: j3r,
  dns_missing: F3r,
  dns_configured: V3r,
  mark_dns_configured: B3r,
  value: U3r,
  your_organization_updated_sucessfully: W3r,
  team_no_event_types: G3r,
  seat_options_doesnt_multiple_durations: H3r,
  include_calendar_event: K3r,
  oAuth: Y3r,
  oAuth_client_creation_form: Z3r,
  oAuth_client_creation_form_description: Q3r,
  oAuth_client_updation_form: J3r,
  oAuth_client_updation_form_description: X3r,
  recently_added: e6r,
  connect_all_calendars: t6r,
  connect_all_calendars_description: n6r,
  workflow_automation_description: o6r,
  scheduling_for_your_team: r6r,
  scheduling_for_your_team_description: i6r,
  no_members_found: a6r,
  directory_sync: s6r,
  directory_name: c6r,
  directory_provider: l6r,
  directory_scim_url: d6r,
  directory_scim_token: u6r,
  directory_scim_url_copied: _6r,
  directory_scim_token_copied: p6r,
  directory_sync_info_description: m6r,
  directory_sync_configure: f6r,
  directory_sync_configure_description: g6r,
  directory_sync_title: h6r,
  directory_sync_created: v6r,
  directory_sync_description: b6r,
  directory_sync_deleted: y6r,
  directory_sync_delete_connection: $6r,
  directory_sync_delete_title: w6r,
  directory_sync_delete_description: k6r,
  directory_sync_delete_confirmation: S6r,
  event_setup_length_error: x6r,
  availability_schedules: E6r,
  unauthorized: T6r,
  access_cal_account: A6r,
  select_account_team: C6r,
  allow_client_to: z6r,
  associate_with_cal_account: O6r,
  see_personal_info: P6r,
  see_primary_email_address: I6r,
  connect_installed_apps: R6r,
  access_event_type: N6r,
  access_availability: D6r,
  access_bookings: M6r,
  allow_client_to_do: L6r,
  oauth_access_information: q6r,
  allow: j6r,
  view_only_edit_availability_not_onboarded: F6r,
  view_only_edit_availability: V6r,
  you_can_override_calendar_in_advanced_tab: B6r,
  edit_users_availability: U6r,
  resend_invitation: W6r,
  invitation_resent: G6r,
  saml_sso: H6r,
  add_client: K6r,
  copy_client_secret_info: Y6r,
  add_new_client: Z6r,
  add_new_user: Q6r,
  this_app_is_not_setup_already: J6r,
  as_csv: X6r,
  overlay_my_calendar: e5r,
  overlay_my_calendar_toc: t5r,
  view_overlay_calendar_events: n5r,
  join_event_location: o5r,
  troubleshooting: r5r,
  calendars_were_checking_for_conflicts: i5r,
  availabilty_schedules: a5r,
  manage_calendars: s5r,
  manage_availability_schedules: c5r,
  locked: l5r,
  unlocked: d5r,
  lock_timezone_toggle_on_booking_page: u5r,
  description_lock_timezone_toggle_on_booking_page: _5r,
  event_setup_multiple_payment_apps_error: p5r,
  number_in_international_format: m5r,
  install_calendar: f5r,
  branded_subdomain: g5r,
  branded_subdomain_description: h5r,
  org_insights: v5r,
  org_insights_description: b5r,
  extensive_whitelabeling: y5r,
  extensive_whitelabeling_description: $5r,
  unlimited_teams: w5r,
  verify_email: k5r,
  proceed_with_cancellation_description: S5r,
  proceed_with_cancellation_error: x5r,
  unlimited_teams_description: E5r,
  unified_billing: T5r,
  advanced_managed_events: A5r,
  advanced_managed_events_description: C5r,
  enterprise: z5r,
  enterprise_description: O5r,
  create_your_org: P5r,
  create_org: I5r,
  create_your_org_description: R5r,
  create_your_enterprise_description: N5r,
  other_payment_app_enabled: D5r,
  admin_delete_organization_description_1: M5r,
  admin_delete_organization_description_2: L5r,
  admin_delete_organization_description_3: q5r,
  admin_delete_organization_description_4: j5r,
  admin_delete_organization_title: F5r,
  published: V5r,
  unpublished: B5r,
  publish: U5r,
  troubleshooter_tooltip: W5r,
  need_help: G5r,
  troubleshooter: H5r,
  number_to_call: K5r,
  guest_name: Y5r,
  guest_email: Z5r,
  guest_company: Q5r,
  please_install_a_calendar: J5r,
  instant_tab_title: X5r,
  instant_event_tab_description: ePr,
  uprade_to_create_instant_bookings: tPr,
  dont_want_to_wait: nPr,
  meeting_started: oPr,
  pay_and_book: rPr,
  cal_ai_event_tab_description: iPr,
  booking_not_found_error: aPr,
  booking_seats_full_error: sPr,
  missing_payment_credential_error: cPr,
  missing_payment_app_id_error: lPr,
  not_enough_available_seats_error: dPr,
  user_redirect_title: uPr,
  user_redirect_description: _Pr,
  out_of_office: pPr,
  out_of_office_description: mPr,
  send_request: fPr,
  start_date_and_end_date_required: gPr,
  start_date_must_be_before_end_date: hPr,
  start_date_must_be_in_the_future: vPr,
  user_not_found: bPr,
  cannot_redirect_to_self: yPr,
  out_of_office_entry_already_exists: $Pr,
  out_of_office_id_required: wPr,
  booking_redirect_infinite_not_allowed: kPr,
  success_entry_created: SPr,
  booking_redirect_email_subject: xPr,
  booking_redirect_email_title: EPr,
  booking_redirect_email_description: TPr,
  booking_redirect_updated_email_subject: APr,
  booking_redirect_updated_email_title: CPr,
  booking_redirect_updated_email_description: zPr,
  booking_redirect_cancelled_email_subject: OPr,
  booking_redirect_cancelled_email_title: PPr,
  booking_redirect_cancelled_email_description: IPr,
  success_accept_booking_redirect: RPr,
  success_reject_booking_redirect: NPr,
  copy_link_booking_redirect_request: DPr,
  booking_redirect_request_title: MPr,
  select_team_member: LPr,
  going_away_title: qPr,
  redirect_team_enabled: jPr,
  redirect_team_disabled: FPr,
  out_of_office_unavailable_list: VPr,
  success_deleted_entry_out_of_office: BPr,
  success_edited_entry_out_of_office: UPr,
  temporarily_out_of_office: WPr,
  add_a_redirect: GPr,
  create_entry: HPr,
  time_range: KPr,
  automatically_add_all_team_members: YPr,
  redirect_to: ZPr,
  having_trouble_finding_time: QPr,
  show_more: JPr,
  forward_params_redirect: XPr,
  assignment_description: eIr,
  lowest: tIr,
  low: nIr,
  medium: oIr,
  high: rIr,
  Highest: iIr,
  send_booker_to: aIr,
  set_priority: sIr,
  set_weight: cIr,
  enable_weights: lIr,
  priority_for_user: dIr,
  weights_description: uIr,
  weight_for_user: _Ir,
  change_priority: pIr,
  field_identifiers_as_variables: mIr,
  field_identifiers_as_variables_with_example: fIr,
  account_already_linked: gIr,
  send_email: hIr,
  cal_ai_phone_call_action: vIr,
  call_to_confirm_booking: bIr,
  cal_ai_phone_call_action_description: yIr,
  cal_ai_agent_configuration: $Ir,
  choose_at_least_one_event_type_test_call: wIr,
  mark_as_no_show: kIr,
  unmark_as_no_show: SIr,
  account_unlinked_success: xIr,
  account_unlinked_error: EIr,
  travel_schedule: TIr,
  travel_schedule_description: AIr,
  schedule_timezone_change: CIr,
  date: zIr,
  enter_the_general_prompt_for_the_agent: OIr,
  overlaps_with_existing_schedule: PIr,
  "org_admin_no_slots|heading": "Aucune disponibilité trouvée pour {{name}}",
  "org_admin_no_slots|content": "Bonjour aux administrateurs de l'organisation,<br /><br />Veuillez noter : il a été porté à notre attention que {{username}} n'a pas eu de disponibilité lorsqu'un utilisateur a visité {{username}}/{{slug}}<br /><br />Il y a plusieurs raisons pour lesquelles cela pourrait se produire<br />L'utilisateur n'a pas de calendriers connectés<br />Leurs horaires attachés à cet événement ne sont pas activés<br /> <br />Nous vous recommandons de vérifier leur disponibilité pour résoudre ce problème.",
  "org_admin_no_slots|cta": "Ouvrir les disponibilités de l'utilisateur",
  organization_no_slots_notification_switch_title: IIr,
  organization_no_slots_notification_switch_description: RIr,
  organization_disable_phone_only_sms_notifications_switch_title: NIr,
  organization_disable_phone_only_sms_notifications_switch_description: DIr,
  "email_team_invite|subject|added_to_org": "{{user}} vous a ajouté(e) à l'organisation {{team}} sur {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} vous a invité(e) à rejoindre l'organisation {{team}} sur {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} vous a ajouté(e) à l'équipe {{team}} de l'organisation {{parentTeamName}} sur {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} vous a invité à rejoindre l'équipe {{team}} sur {{appName}}",
  "email_team_invite|heading|added_to_org": "Vous avez été ajouté à une organisation {{appName}}",
  "email_team_invite|heading|invited_to_org": "Vous avez été invité à une organisation {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Vous avez été ajouté à une équipe de l'organisation {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Vous avez été invité à une équipe de l'organisation {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Vous avez été invité à rejoindre une équipe {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} vous a ajouté(e) à l'organisation <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} vous a invité(e) à rejoindre l'organisation {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} vous a invité(e) à rejoindre l'équipe {{team}} de l'organisation {{parentTeamName}} sur {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} vous a ajouté(e) à son équipe <strong>{{teamName}}</strong> de son organisation {{parentTeamName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} vous a invité(e) à rejoindre son équipe <strong>{{teamName}}</strong> de son organisation {{parentTeamName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} vous a invité à rejoindre son équipe « {{teamName}} » sur {{appName}}. {{appName}} est le planificateur d'événements qui vous permet à vous et à votre équipe d'organiser des rendez-vous sans échanges d'e-mails.",
  "email|existing_user_added_link_will_change": "En acceptant l'invitation, votre lien changera pour le domaine de votre organisation, mais ne vous inquiétez pas, tous les liens précédents fonctionneront toujours et redirigeront correctement.<br /><br />Veuillez noter : Tous vos types d'événements personnels seront déplacés dans l'organisation <strong>{{teamName}}</strong>, ce qui peut également inclure un lien personnel potentiel. <br /><br />Pour les événements personnels, nous vous recommandons de créer un nouveau compte avec une adresse e-mail personnelle.",
  "email|existing_user_added_link_changed": "Votre lien a été modifié de {{a0}} à {{a1}}, mais ne vous inquiétez pas, tous les liens précédents fonctionnent toujours et redirigent correctement. <br /><br />Veuillez noter : Tous vos types d'événements personnels ont été déplacés dans l'organisation <strong>{{teamName}}</strong>, ce qui peut également inclure un lien personnel potentiel.<br /><br />Veuillez vous connecter et vérifier que vous n'avez pas d'événements privés sur votre nouveau compte organisationnel.<br /><br />Pour les événements personnels, nous vous recommandons de créer un nouveau compte avec une adresse e-mail personnelle.<br /><br />Profitez de votre nouveau lien épuré : {{a2}}",
  "email_organization_created|subject": "Votre organisation a été créée",
  your_current_plan: MIr,
  organization_price_per_user_month: LIr,
  privacy_organization_description: qIr,
  privacy: jIr,
  team_will_be_under_org: FIr,
  add_group_name: VIr,
  group_name: BIr,
  routers: UIr,
  primary: WIr,
  make_primary: GIr,
  add_email: HIr,
  add_emails: KIr,
  add_email_description: YIr,
  confirm_email: ZIr,
  confirming_your_booking_sms: QIr,
  scheduler_first_name: JIr,
  scheduler_last_name: XIr,
  scheduler_name: eRr,
  organizer_first_name: tRr,
  confirm_email_description: nRr,
  send_event_details_to: oRr,
  schedule_tz_without_end_date: rRr,
  select_members: iRr,
  lock_event_types_modal_header: aRr,
  org_delete_event_types_org_admin: sRr,
  org_hide_event_types_org_admin: cRr,
  hide_org_eventtypes: lRr,
  delete_org_eventtypes: dRr,
  lock_org_users_eventtypes: uRr,
  lock_org_users_eventtypes_description: _Rr,
  add_to_event_type: pRr,
  create_account_password: mRr,
  create_account_with_saml: fRr,
  error_creating_account_password: gRr,
  cannot_create_account_password_cal_provider: hRr,
  cannot_create_account_password_already_existing: vRr,
  create_account_password_hint: bRr,
  disconnect_account: yRr,
  disconnect_account_hint: $Rr,
  cookie_consent_checkbox: wRr,
  make_a_call: kRr,
  skip_rr_assignment_label: SRr,
  skip_rr_description: xRr,
  select_account_header: ERr,
  select_account_description: TRr,
  select_event_types_header: ARr,
  select_event_types_description: CRr,
  configure_app_header: zRr,
  configure_app_description: ORr,
  already_installed: PRr,
  ooo_reasons_unspecified: IRr,
  ooo_reasons_vacation: RRr,
  ooo_reasons_travel: NRr,
  ooo_reasons_sick_leave: DRr,
  ooo_reasons_public_holiday: MRr,
  ooo_forwarding_to: LRr,
  ooo_not_forwarding: qRr,
  ooo_empty_title: jRr,
  ooo_empty_description: FRr,
  ooo_user_is_ooo: VRr,
  ooo_slots_returning: BRr,
  ooo_slots_book_with: URr,
  ooo_select_reason: WRr,
  create_an_out_of_office: GRr,
  edit_an_out_of_office: HRr,
  submit_feedback: KRr,
  host_no_show: YRr,
  no_show_description: ZRr,
  how_can_we_improve: QRr,
  most_liked: JRr,
  review: XRr,
  reviewed: eNr,
  unreviewed: tNr,
  rating_url_variable: nNr,
  rating_url_info: oNr,
  no_show_url_variable: rNr,
  no_show_url_info: iNr,
  no_support_needed: aNr,
  hide_support: sNr,
  event_ratings: cNr,
  event_no_show: lNr,
  event_no_show_guest: dNr,
  recent_ratings: uNr,
  no_ratings: _Nr,
  no_ratings_description: pNr,
  most_no_show_host: mNr,
  highest_rated: fNr,
  lowest_rated: gNr,
  highest_rated_members: hNr,
  lowest_rated_members: vNr,
  csat_score: bNr,
  lockedSMS: yNr,
  leave_without_assigning_anyone: $Nr,
  leave_without_adding_attendees: wNr,
  no_availability_shown_to_bookers: kNr,
  go_back_and_assign: SNr,
  leave_without_assigning: xNr,
  signing_up_terms: ENr,
  proceeding_agreement: TNr,
  terms: ANr,
  always_show_x_days: CNr,
  always_show_x_days_description: zNr,
  team_subscription_cancelled_successfully: ONr,
  team_subscription_cancellation_error: PNr,
  unable_to_subscribe_to_the_platform: INr,
  updating_oauth_client_error: RNr,
  creating_oauth_client_error: NNr,
  event_type_color: DNr,
  event_type_color_description: MNr,
  mark_as_no_show_title: LNr,
  x_marked_as_no_show: qNr,
  x_unmarked_as_no_show: jNr,
  team_select_info: FNr,
  team_settings_description: VNr,
  no_show_updated: BNr,
  email_copied: UNr,
  phone_number_copied: WNr,
  USER_PENDING_MEMBER_OF_THE_ORG: GNr,
  USER_ALREADY_INVITED_OR_MEMBER: HNr,
  USER_MEMBER_OF_OTHER_ORGANIZATION: KNr,
  booking_reassigned: YNr,
  reassign: ZNr,
  reassign_to_another_rr_host: QNr,
  assign_team_member: JNr,
  override_team_member_to_assign: XNr,
  no_available_hosts: eDr,
  reassign_round_robin_host: tDr,
  skip_writing_to_calendar: nDr,
  rescheduling_not_possible: oDr,
  event_expired: rDr,
  skip_contact_creation: iDr,
  skip_writing_to_calendar_note: aDr,
  attributes: sDr,
  new_attribute: cDr,
  add_attributes: lDr,
  add_attributes_description: dDr,
  new_option: uDr,
  update_profile: _Dr,
  attribute: pDr,
  create_attribute_description: mDr,
  edit_attribute_description: fDr,
  attribute_updated_successfully: gDr,
  attribute_deleted_successfully: hDr,
  attributes_edited_successfully: vDr,
  attribute_meta_description: bDr,
  attributes_edit_description: yDr,
  back_to_attributes: $Dr,
  delete_attribute: wDr,
  delete_attribute_description: kDr,
  disable_all_emails_to_attendees: SDr,
  disable_all_emails_description: xDr,
  disable_all_emails_to_hosts: EDr,
  type_confirm_to_continue: TDr,
  disable_email: ADr,
  grant_admin_api: CDr,
  revoke_admin_api: zDr,
  add_calendar_label: ODr,
  apple_connect_atom_label: PDr,
  apple_connect_atom_already_connected_label: IDr,
  apple_connect_atom_loading_label: RDr,
  google_connect_atom_label: NDr,
  google_connect_atom_already_connected_label: DDr,
  google_connect_atom_loading_label: MDr,
  outlook_connect_atom_label: LDr,
  outlook_connect_atom_already_connected_label: qDr,
  outlook_connect_atom_loading_label: jDr,
  stripe_connect_atom_label: FDr,
  stripe_connect_atom_already_connected_label: VDr,
  stripe_connect_atom_loading_label: BDr,
  booking_question_response_variables: UDr,
  managed_by_teamAdmins: WDr,
  number_of_options: GDr,
  reschedule_with_same_round_robin_host_title: HDr,
  reschedule_with_same_round_robin_host_description: KDr,
  disable_input_if_prefilled: YDr,
  booking_limits: ZDr,
  booking_limits_team_description: QDr,
  limit_team_booking_frequency_description: JDr,
  booking_limits_updated_successfully: XDr,
  you_are_unauthorized_to_make_this_change_to_the_booking: eMr,
  delegation_credential_disabled: tMr,
  matching_members: nMr,
  x_matching_members: oMr,
  matching_members_queue_using_attribute_weights: rMr,
  matching_members_queue_using_event_assignee_weights: iMr,
  no_matching_members: aMr,
  no_matching_members_will_fallback_to_all_assigned_members: sMr,
  hide_calendar_event_details: cMr,
  description_hide_calendar_event_details: lMr,
  last_number_of_days: dMr,
  month_to_date: uMr,
  year_to_date: _Mr,
  custom_range: pMr,
  refund_policy: mMr,
  always: fMr,
  never: gMr,
  payment_option: hMr,
  if_cancelled: vMr,
  before: bMr,
  show_all_columns: yMr,
  toggle_columns: $Mr,
  no_columns_found: wMr,
  salesforce_create_record_as: kMr,
  salesforce_lead: SMr,
  salesforce_contact_under_account: xMr,
  salesforce_skip_entry_creation: EMr,
  salesforce_if_account_does_not_exist: TMr,
  salesforce_create_new_contact_under_account: AMr,
  salesforce_change_record_owner_on_booking: CMr,
  mass_assign_attributes: zMr,
  reroute_preview_custom_message: OMr,
  reroute_preview_external_redirect: PMr,
  reroute_preview_possible_host: IMr,
  current_routing_status: RMr,
  reroute_booking: NMr,
  reroute_booking_description: DMr,
  verify_new_route: MMr,
  reroute: LMr,
  new_routing_status: qMr,
  salesforce_book_directly_with_attendee_owner: jMr,
  salesforce_check_owner_of: FMr,
  account: VMr,
  choose_hosts_schedule: BMr,
  hosts_schedule_description: UMr,
  no_hosts_description: WMr,
  team_member_round_robin_reassign: GMr,
  team_member_round_robin_reassign_description: HMr,
  round_robin_reassign_description: KMr,
  invalid_round_robin_host: YMr,
  user_is_round_robin_fixed: ZMr,
  reschedule_with_same_timeslot: QMr,
  reschedule_with_same_timeslot_of_new_event: JMr,
  reschedule_to_the_new_event_with_different_timeslot: XMr,
  reschedule_with_different_timeslot: eLr,
  we_dont_have_id_for_the_new_event: tLr,
  rerouted_booking_successfully_redirecting_to_booking_page: nLr,
  on_booking_write_to_event_object: oLr,
  field_name: rLr,
  add_new_field: iLr,
  you_dont_have_access_to_reroute_this_booking: aLr,
  form_response_not_found: sLr,
  contact_owner: cLr,
  contact_owner_not_found: lLr,
  using_fallback_members: dLr,
  chosen_route: uLr,
  attribute_logic_matched: _Lr,
  attribute_logic_fallback_matched: pLr,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: mLr,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: fLr,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: gLr,
  warning: hLr,
  fallback_attribute_logic_description: vLr,
  fallback_attribute_logic_warning: bLr,
  fallback_not_needed: yLr,
  confirm_reassign_unavailable: $Lr,
  confirm_reassign_available: wLr,
  reassign_unavailable_team_member_description: kLr,
  reassign_available_team_member_description: SLr,
  yes_reassign: xLr,
  filter_by_attributes: ELr,
  reassign_reason: TLr,
  field_type_change_suggestion: ALr,
  reassigned_by: CLr,
  row: zLr,
  rows: OLr,
  attendee_timezone_variable: PLr,
  event_start_time_in_attendee_timezone_variable: ILr,
  event_start_time_in_attendee_timezone_info: RLr,
  event_end_time_in_attendee_timezone_info: NLr,
  event_end_time_in_attendee_timezone_variable: DLr,
  salesforce_create_event_on_contact: MLr,
  salesforce_owner_name_to_change: LLr,
  no_filter_set: qLr,
  booking_dry_run_successful: jLr,
  booking_dry_run_successful_description: FLr,
  dont_have_access_this_page: VLr,
  you_need_admin_or_owner_privileges_to_access: BLr,
  field_type: ULr,
  when_to_write: WLr,
  salesforce_on_booking_write_to_record: GLr,
  on_every_booking: HLr,
  only_if_field_is_empty: KLr,
  booking_start_date: YLr,
  booking_created_date: ZLr,
  booking_reassigned_to_host: QLr,
  no_contact_owner: JLr,
  routing_forms_created: XLr,
  routing_forms_total_responses: eqr,
  routing_forms_total_responses_without_booking: tqr,
  routing_forms_total_responses_with_booking: nqr,
  routing_form_insights: oqr,
  routing_form_insights_form_name_header: rqr,
  routing_form_insights_booking_status_header: iqr,
  routing_form_insights_response_no_booking: aqr,
  routing_form_insights_booked_by: sqr,
  routing_form_insights_created_at: cqr,
  routing_form_insights_booking_status: lqr,
  routing_form_insights_booking_at: dqr,
  routing_form_insights_submitted_at: uqr,
  copy_redirect_url: _qr,
  redirect_url_on_exit: pqr,
  total_bookings_per_period: mqr,
  routed_to_per_period: fqr,
  per_day: gqr,
  per_week: hqr,
  per_month: vqr,
  routing_form_insights_assignment_reason: bqr,
  access_denied: yqr,
  salesforce_route_to_owner: $qr,
  salesforce_add_attendees_as: wqr,
  salesforce_do_not_route_to_owner: kqr,
  salesforce_route_to_custom_lookup_field: Sqr,
  salesforce_option: xqr,
  lookup_field_name: Eqr,
  salesforce_if_free_email_domain_skip_owner_check: Tqr,
  filter_operator_is: Aqr,
  filter_operator_is_not: Cqr,
  filter_operator_contains: zqr,
  filter_operator_does_not_contain: Oqr,
  filter_operator_starts_with: Pqr,
  filter_operator_ends_with: Iqr,
  filter_operator_is_empty: Rqr,
  filter_operator_not_empty: Nqr,
  translate_description_button: Dqr,
  translate_description_button_description: Mqr,
  rr_distribution_method: Lqr,
  rr_distribution_method_description: qqr,
  rr_distribution_method_availability_title: jqr,
  rr_distribution_method_availability_description: Fqr,
  rr_distribution_method_balanced_title: Vqr,
  rr_distribution_method_balanced_description: Bqr,
  edit_team_member_weights: Uqr,
  weights_updated_successfully: Wqr,
  require_confirmation_for_free_email: Gqr,
  exclude_emails_that_contain: Hqr,
  require_emails_that_contain: Kqr,
  exclude_emails_match_found_error_message: Yqr,
  require_emails_no_match_found_error_message: Zqr,
  search_columns: Qqr,
  search_options: Jqr,
  disable_org_url_label: Xqr,
  disable_org_url_description: e9r,
  single_select: t9r,
  multi_select: n9r,
  calendar_conflict_settings: o9r,
  select_calendars_conflict_check: r9r,
  group_meeting: i9r,
  are_you_sure_you_want_to_remove_this_app_from: a9r,
  disconnect_app_from: s9r,
  salesforce_ignore_guests: c9r,
  google_meet: l9r,
  zoom: d9r,
  office_365_video: u9r,
  lock_attribute_for_assignment: _9r,
  lock_attribute_for_assignment_description: p9r,
  attribute_edited_successfully: m9r,
  new_group_option: f9r,
  attribute_weight_enabled: g9r,
  attribute_weight_enabled_description: h9r,
  routed: v9r,
  reassigned: b9r,
  allow_rescheduling_past_events: y9r,
  allow_rescheduling_past_events_description: $9r,
  rerouted: w9r,
  salesforce_assigned: k9r,
  router_position: S9r,
  show_matching_hosts: x9r,
  no_active_queues: E9r,
  weight: T9r,
  calibration: A9r,
  shortfall: C9r,
  routing_form: z9r,
  go_back_and_save: O9r,
  save_changes: P9r,
  leave_without_saving: I9r,
  leave_without_saving_description: R9r,
  something_unexpected_occurred: N9r,
  "500_error_message": "Ce n'est pas vous, c'est nous.",
  dry_run_mode_active: D9r,
  icon_showcase: M9r,
  icons_showcase: L9r,
  migrating_from_team: q9r,
  feature_currently_disabled: j9r,
  choose_an_option: F9r,
  enter_option_value: V9r,
  remove_option: B9r,
  use_attribute_weights: U9r,
  if_enabled_ignore_event_type_weights: W9r,
  attribute_for_weights: G9r,
  managed_users: H9r,
  managed_users_description: K9r,
  can_you_tell_me_about: Y9r,
  use_ai_to_answer_your_questions: Z9r,
  error_fetching_answer: Q9r,
  k_bar_ai_error: J9r,
  select_oAuth_client: X9r,
  on_every_instance: ejr,
  delegation_credential_feature_not_enabled: tjr,
  internal_booking_note: njr,
  internal_note_cancellation_reason: ojr,
  internal_booking_note_description: rjr,
  internal_note_presets: ijr,
  internal_note_presets_description: ajr,
  internal_note_presets_updated_successfully: sjr,
  add_preset: cjr,
  authorize: ljr,
  next: djr,
  hide: ujr,
  show: _jr,
  utm_params: pjr,
  no_utm_params: mjr,
  asc: fjr,
  desc: gjr,
  verify_email_change: hjr,
  buy_credits: vjr,
  credits: bjr,
  credits_used: yjr,
  total_credits_remaining: $jr,
  credits_per_tip_org: wjr,
  credits_per_tip_teams: kjr,
  view_and_manage_credits: Sjr,
  view_and_manage_credits_description: xjr,
  credit_worth_description: Ejr,
  buy_additional_credits: Tjr,
  view_additional_credits_expense_tip: Ajr,
  overview: Cjr,
  organization_slug_taken: zjr,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: Ojr,
  you_need_to_complete_user_onboarding_before_creating_an_organization: Pjr,
  use_company_email_to_create_an_organization: Ijr,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: Rjr,
  you_need_to_have_minimum_published_teams: Njr,
  you_are_part_of_this_organization_already: Djr,
  you_are_part_of_another_organization_cannot_create_organization: Mjr,
  you_are_part_of_another_platform_organization_cannot_create_organization: Ljr,
  organization_payment_success: qjr,
  organization_payment_success_description: jjr,
  this_may_take_a_few_seconds: Fjr,
  organization_onboarding_status: Vjr,
  organization_onboarding_status_description: Bjr,
  payment_failed: Ujr,
  payment_failed_description: Wjr,
  creating_your_organization: Gjr,
  organization_onboarding_already_completed: Hjr,
  organization_onboarding_already_exists: Kjr,
  organization_onboarding_not_found: Yjr,
  payment_successful: Zjr,
  handover_onboarding_page_title: Qjr,
  handover_onboarding_page_description: Jjr,
  organization_already_exists_with_this_slug: Xjr,
  you_do_not_have_permission_to_create_an_organization_for_this_email: eFr,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: tFr,
  organization_has_subscription_already: nFr,
  reset_interval_weighted_rr: oFr,
  interval: rFr,
  rr_reset_interval_description: iFr,
  daily: aFr,
  end_date_not_selected: sFr,
  my_ooo: cFr,
  team_ooo: lFr,
  out_of_office_team_description: dFr,
  create_ooo_dialog_team_title: uFr,
  create_ooo_dialog_team_subtitle: _Fr,
  edit_ooo_dialog_team_subtitle: pFr,
  ooo_team_empty_title: mFr,
  ooo_team_empty_description: fFr,
  forward_to_team_member_only: gFr,
  ooo_team_redirect_infinite_not_allowed: hFr,
  previous_ooo_empty_title: vFr,
  previous: bFr,
  rr_interval_successfully_updated: yFr,
  trial_mode: $Fr,
  inactive_team_plan: wFr,
  inactive_team_plan_description: kFr,
  limited_access_trial_mode: SFr,
  referral_program: xFr,
  referral_text: EFr,
  dub_disabled_error_message: TFr,
  uid: AFr,
  link: CFr,
  rows_per_page: zFr,
  pagination_status: OFr,
  tip_username_plus: PFr,
  user_has_no_team_yet: IFr,
  no_team_members: RFr,
  recurring_event_doesnt_support_seats: NFr,
  booking_limit_per_booker_doesnt_support_recurring: DFr,
  seats_doesnt_support_recurring: MFr,
  recurring_event_seats_error: LFr,
  segment: qFr,
  saved_filters: jFr,
  rename: FFr,
  rename_segment: VFr,
  delete_segment: BFr,
  duplicate_segment: UFr,
  delete_segment_confirmation: WFr,
  filter_segment_updated: GFr,
  error_updating_filter_segment: HFr,
  filter_segment_duplicated: KFr,
  error_duplicating_filter_segment: YFr,
  filter_segment_deleted: ZFr,
  error_deleting_filter_segment: QFr,
  save_segment: JFr,
  segment_not_found: XFr,
  filter_segment_saved: e8r,
  no_segments: t8r,
  error_saving_filter_segment: n8r,
  override_segment: o8r,
  create_new_segment: r8r,
  save_for_team: i8r,
  select_team: a8r,
  please_select_team: s8r,
  personal: c8r,
  hide_team_profile_link: l8r,
  hide_team_profile_link_description: d8r,
  display: u8r,
  could_not_find_slug_to_publish_org: _8r,
  picklist: p8r,
  most_cancelled_bookings: m8r,
  interface_language: f8r,
  interface_language_description: g8r,
  visitors_browser_language: h8r,
  name_or_email: v8r,
  salesforce_round_robin_skip_fallback_to_lead_owner: b8r,
  credit_purchase_failed: y8r,
  minimum_of_credits_required: $8r,
  enable_delegation_credential: w8r,
  enable_delegation_credential_description: k8r,
  disable_delegation_credential: S8r,
  disable_delegation_credential_description: x8r,
  last_active: E8r,
  member_since: T8r,
  last_updated: A8r,
  salesforce_on_cancel_write_to_event: C8r,
  salesforce_on_every_cancellation: z8r,
  report_issue: O8r,
  report_issue_description: P8r,
  open_issue: I8r,
  this_is_your_current_plan: R8r,
  schedule_a_time: N8r,
  this_includes: D8r,
  oauth_client_updated_successfully: M8r,
  oauth_client_not_found: L8r,
  subscribe_to_platform: q8r,
  error_accessing_webhooks: j8r,
  webhook_update_failed: F8r,
  webhook_create_failed: V8r,
  invalid_link: B8r,
  currently_subscribed_to_plan: U8r,
  user_team: W8r,
  client_id_copied: G8r,
  client_secret_copied: H8r,
  maintenance_message: K8r,
  your_payment_failed: Y8r,
  check_your_inbox: Z8r,
  account_created_premium_not_reserved: Q8r,
  email_sent_with_activation_link: J8r,
  activate_account_to_purchase_username: X8r,
  open_in_gmail: e7r,
  dont_see_email: t7r,
  resend_in_seconds: n7r,
  resend: o7r,
  verification_email_sent: r7r,
  select_all_members: i7r,
  select_all_members_tooltip: a7r,
  form_settings: s7r,
  remove_whitelist_status: c7r,
  whitelist_user_workflows: l7r,
  user_workflows_whitelisted: d7r,
  user_workflows_unwhitelisted: u7r,
  date_and_time: _7r,
  email_reminder_upcoming_event_notice: p7r,
  email_reminder_triggered_by_workflow: m7r,
  event_upper_case: f7r,
  scheduling_by: g7r,
  experience_review_prompt: h7r,
  improve_customer_experience_message: v7r,
  meeting_satisfaction_question: b7r,
  meeting_not_joined_question: y7r,
  reschedule_cta_short: $7r,
  hide_organizer_email: w7r,
  platform_customer_cant_create_organization: k7r,
  organization_customer_cant_create_platform: S7r,
  hide_organizer_email_description: x7r,
  you_and_conjunction: E7r,
  select_verified_email: T7r,
  add_verified_email: A7r,
  add_verified_emails: C7r,
  custom_reply_to_email_title: z7r,
  custom_reply_to_email_description: O7r,
  email_survey_triggered_by_workflow: P7r,
  skip_trial: I7r,
  team_trials_skipped_successfully: R7r,
  sms_workflow_consent: N7r,
  routing_preview_more_info_found_insights: D7r,
  results: M7r,
  view_form: L7r,
  sms_opt_out_message: q7r,
  team_credits_low_warning: j7r,
  user_credits_low_warning: F7r,
  action_required_out_of_credits: V7r,
  action_required_user_out_of_credits: B7r,
  low_credits_warning_message: U7r,
  low_credits_warning_message_user: W7r,
  credit_limit_reached_message: G7r,
  credit_limit_reached_message_user: H7r,
  current_credit_balance: K7r,
  current_balance: Y7r,
  notification_about_your_booking: Z7r,
  monthly_credits: Q7r,
  total_credits: J7r,
  remaining_credits: X7r,
  remaining: eVr,
  total: tVr,
  additional_credits: nVr,
  routing_form_next_in_queue: oVr,
  routing_form_select_members_to_email: rVr,
  routing_incomplete_booking_tab: iVr,
  include_no_show_in_rr_calculation: aVr,
  recent_no_show_guests: sVr,
  recent_no_show_guests_tooltip: cVr,
  matching: lVr,
  event_redirect: dVr,
  reset_form: uVr,
  rr_settings_successfully_updated: _Vr,
  distribution_basis_weighted_rr: pVr,
  timestamp_basis_description: mVr,
  requires_credits: fVr,
  requires_credits_tooltip: gVr,
  available_credits: hVr,
  create_role: vVr,
  roles_and_permissions: bVr,
  roles_and_permissions_description: yVr,
  learn_more_permissions: $Vr,
  role_name: wVr,
  role_name_required: kVr,
  role_name_placeholder: SVr,
  role_description: xVr,
  role_description_placeholder: EVr,
  default_role: TVr,
  custom_role: AVr,
  advanced: CVr,
  search_permissions: zVr,
  all_permissions: OVr,
  none: PVr,
  read_only: IVr,
  pbac_desc_all_actions_all_resources: RVr,
  pbac_resource_all: NVr,
  pbac_resource_event_type: DVr,
  pbac_resource_team: MVr,
  pbac_resource_organization: LVr,
  pbac_resource_booking: qVr,
  pbac_resource_insights: jVr,
  pbac_resource_role: FVr,
  pbac_resource_routing_form: VVr,
  pbac_resource_workflow: BVr,
  pbac_action_all: UVr,
  pbac_action_create: WVr,
  pbac_action_read: GVr,
  pbac_action_update: HVr,
  pbac_action_delete: KVr,
  pbac_action_manage: YVr,
  pbac_action_invite: ZVr,
  pbac_action_remove: QVr,
  pbac_action_change_member_role: JVr,
  pbac_action_list_members: XVr,
  pbac_action_manage_billing: eBr,
  pbac_action_read_team_bookings: tBr,
  pbac_action_read_org_bookings: nBr,
  pbac_action_read_recordings: oBr,
  pbac_action_impersonate: rBr,
  role_created_successfully: iBr,
  role_updated_successfully: aBr,
  delete_role: sBr,
  confirm_delete_role: cBr,
  role_deleted_successfully: lBr,
  error_creating_role: dBr,
  error_updating_role: uBr,
  pbac_desc_create_roles: _Br,
  pbac_resource_attributes: pBr,
  pbac_desc_view_organization_attributes: mBr,
  pbac_desc_update_organization_attributes: fBr,
  pbac_desc_delete_organization_attributes: gBr,
  pbac_desc_create_organization_attributes: hBr,
  pbac_desc_view_roles: vBr,
  pbac_desc_update_roles: bBr,
  pbac_desc_delete_roles: yBr,
  pbac_desc_create_workflows: $Br,
  set_up_required: wBr,
  pbac_desc_view_workflows: kBr,
  pbac_desc_update_workflows: SBr,
  pbac_desc_delete_workflows: xBr,
  pbac_resource_webhook: EBr,
  pbac_resource_availability: TBr,
  pbac_resource_out_of_office: ABr,
  pbac_desc_create_webhooks: CBr,
  pbac_desc_view_webhooks: zBr,
  pbac_desc_update_webhooks: OBr,
  pbac_desc_delete_webhooks: PBr,
  pbac_desc_create_availability: IBr,
  pbac_desc_view_availability: RBr,
  pbac_desc_update_availability: NBr,
  pbac_desc_delete_availability: DBr,
  pbac_desc_create_out_of_office: MBr,
  pbac_desc_view_out_of_office: LBr,
  pbac_desc_update_out_of_office: qBr,
  pbac_desc_delete_out_of_office: jBr,
  pbac_desc_manage_workflows: FBr,
  pbac_desc_create_event_types: VBr,
  pbac_desc_view_event_types: BBr,
  pbac_desc_update_event_types: UBr,
  pbac_desc_delete_event_types: WBr,
  pbac_desc_manage_event_types: GBr,
  pbac_desc_create_teams: HBr,
  pbac_desc_view_team_details: KBr,
  pbac_desc_update_team_settings: YBr,
  pbac_desc_delete_team: ZBr,
  pbac_desc_invite_team_members: QBr,
  pbac_desc_remove_team_members: JBr,
  pbac_desc_change_team_member_role: XBr,
  pbac_desc_impersonate_team_members: eUr,
  pbac_desc_manage_teams: tUr,
  pbac_desc_create_organization: nUr,
  pbac_desc_view_organization_details: oUr,
  pbac_desc_list_organization_members: rUr,
  pbac_desc_invite_organization_members: iUr,
  pbac_desc_remove_organization_members: aUr,
  pbac_desc_manage_organization_billing: sUr,
  pbac_desc_change_organization_member_role: cUr,
  pbac_desc_impersonate_organization_members: lUr,
  pbac_desc_edit_organization_settings: dUr,
  pbac_desc_manage_organizations: uUr,
  pbac_desc_view_bookings: _Ur,
  pbac_desc_view_team_bookings: pUr,
  pbac_desc_view_organization_bookings: mUr,
  pbac_desc_view_booking_recordings: fUr,
  pbac_desc_update_bookings: gUr,
  pbac_desc_manage_bookings: hUr,
  pbac_desc_view_team_insights: vUr,
  pbac_desc_manage_team_insights: bUr,
  pbac_desc_create_routing_forms: yUr,
  pbac_desc_view_routing_forms: $Ur,
  pbac_desc_update_routing_forms: wUr,
  pbac_desc_delete_routing_forms: kUr,
  read_permission_auto_enabled_tooltip: SUr,
  choose_restriction_schedule: xUr,
  restriction_schedule_description: EUr,
  use_booker_timezone: TUr,
  use_booker_timezone_info: AUr,
  load_balancing_warning: CUr,
  rr_load_balancing_disabled: zUr,
  rr_load_balancing_disabled_with_groups: OUr,
  round_robin_settings_description: PUr,
  round_robin_settings_updated_successfully: IUr,
  booking_creation_time: RUr,
  meeting_start_time: NUr,
  members_affected_by_disabling_delegation_credential: DUr,
  no_members_affected_by_disabling_delegation_credential: MUr,
  download_expense_log: LUr,
  error_downloading_expense_log: qUr,
  offer_to_reschedule_last_booking: jUr,
  booker_limit_exceeded_error: FUr,
  booker_limit_exceeded_error_reschedule: VUr,
  duration_min_error: BUr,
  duration_max_error: UUr,
  booking_not_allowed_by_restriction_schedule_error: WUr,
  restriction_schedule_not_found_error: GUr,
  converted_image_size_limit_exceed: HUr,
  add_group: KUr,
  routing_funnel: YUr,
  routing_funnel_total_submissions: ZUr,
  routing_funnel_successful_routings: QUr,
  routing_funnel_accepted_bookings: JUr,
  license_key: XUr,
  license_selection_title: eWr,
  license_selection_description: tWr,
  agplv3_license_description: nWr,
  enter_license_key: oWr,
  enter_your_license_key: rWr,
  enter_existing_license: iWr,
  enter_license_key_description: aWr,
  license_key_placeholder: sWr,
  save_license_key: cWr,
  signature_token_optional: lWr,
  signature_token_description: dWr,
  need_a_license: uWr,
  license_key_required: _Wr,
  invalid_license_key: pWr,
  license_validation_failed: mWr,
  attachments_optional: fWr,
  send_message: gWr,
  describe_the_issue: hWr,
  file_size_limit_exceed: vWr,
  invalid_file_type: bWr,
  invalid_file_type_extension: yWr,
  max_files_exceeded: $Wr,
  files_uploaded_successfully: wWr,
  file_upload_instructions: kWr,
  license_key_saved: SWr,
  timezone_mismatch_tooltip: xWr,
  show_optimized_slots: EWr,
  show_optimized_slots_description: TWr,
  failed_bookings_by_field: AWr,
  failed_bookings: CWr,
  event_type_no_hosts: zWr,
  cache_status: OWr,
  cache_last_updated: PWr,
  delete_cached_data: IWr,
  cache_deleted_successfully: RWr,
  error_deleting_cache: NWr,
  confirm_delete_cache: DWr,
  yes_delete_cache: MWr,
  remainder_of_maximum_uses_left_plural: LWr,
  remainder_of_maximum_use_left_singular: qWr,
  expires_on_date: jWr,
  single_use: FWr,
  time_based_expiration: VWr,
  usage_based_expiration: BWr,
  number_of_uses: UWr,
  expires_on: WWr,
  max_usage_count: GWr,
  link_settings: HWr,
  link_expired_on_date: KWr,
  usage_limit_reached: YWr,
  usage_count_error: ZWr,
  private_link_expired: QWr,
  time_based_expiration_description: JWr,
  time_based_generic_expiration_description: XWr,
  usage_based_expiration_description: eGr,
  usage_based_generic_expiration_description: tGr,
  usage_based_expiration_description_plural: nGr,
  webhook_trigger_event: oGr,
  webhook_created_at: rGr,
  webhook_type: iGr,
  set_up_agent: aGr,
  webhook_title: sGr,
  webhook_start_time: cGr,
  webhook_end_time: lGr,
  webhook_description: dGr,
  webhook_location: uGr,
  webhook_uid: _Gr,
  webhook_reschedule_uid: pGr,
  webhook_cancellation_reason: mGr,
  webhook_rejection_reason: fGr,
  webhook_organizer_name: gGr,
  webhook_organizer_email: hGr,
  webhook_organizer_timezone: vGr,
  webhook_organizer_locale: bGr,
  webhook_organizer_username: yGr,
  webhook_organizer_username_in_org: $Gr,
  webhook_attendee_name: wGr,
  webhook_attendee_email: kGr,
  webhook_attendee_timezone: SGr,
  webhook_attendee_locale: xGr,
  webhook_team_name: EGr,
  webhook_team_members: TGr,
  webhook_video_call_url: AGr,
  webhook_hide_variables: CGr,
  webhook_show_variable: zGr,
  webhook_event_and_booking: OGr,
  webhook_people: PGr,
  webhook_teams: IGr,
  webhook_metadata: RGr,
  stats: NGr,
  booking_status: DGr,
  visit: MGr,
  location_custom_label_input_label: LGr,
  meeting_link: qGr,
  session_outcome: jGr,
  call_created: FGr,
  voicemail: VGr,
  my_bookings: BGr,
  phone: UGr,
  free: WGr,
  user_email: GGr,
  user_name: HGr,
  expand_panel: KGr,
  collapse_panel: YGr,
  email_verification_required: ZGr,
  invalid_verification_code: QGr,
  you_have_one_team: JGr,
  consider_consolidating_one_team_org: XGr,
  consider_consolidating_multi_team_org: eHr,
  message_sent: tHr,
  support_message_sent_description: nHr,
  search_variables: oHr,
  support_message_placeholder: rHr,
  send_another_message: iHr,
  sending: aHr,
  no_variables_found: sHr,
  credits_required: cHr,
  web_call_credits_info: lHr,
  web_call_no_credits: dHr,
  purchase_credits: uHr,
  credits_required_tooltip: _Hr,
  api_key_name_too_long: pHr,
  auto_charge_for_last_minute_cancellation: mHr,
  before_scheduled_start_time: fHr,
  cancel_booking_acknowledge_no_show_fee: gHr,
  contact_organizer: hHr,
  booking_time_option: vHr,
  booking_time_option_description: bHr,
  created_at_option: yHr,
  created_at_option_description: $Hr,
  call_details: wHr,
  call_id: kHr,
  call_information: SHr,
  sentiment: xHr,
  disconnect_reason: EHr,
  call_summary: THr,
  transcription: AHr,
  event_details: CHr,
  agent: zHr,
  no_transcript_available: OHr,
  testing_sms_workflow_info_message: PHr,
  start_from_scratch_title: IHr,
  start_from_scratch_description: RHr,
  cal_ai_template_title: NHr,
  cal_ai_template_description: DHr,
  voice: MHr,
  select_voice: LHr,
  select_voice_for_agent: qHr,
  choose_a_voice_for_your_agent: jHr,
  trait: FHr,
  voice_id: VHr,
  use_voice: BHr,
  current_voice: UHr,
  setup_incoming_agent: WHr,
  setup_incoming_agent_description: GHr,
  connect_a_phone_number_first: HHr,
  setup_agent_for_incoming_calls: KHr,
  configure_agent_to_handle_incoming_calls: YHr,
  incoming_calls: ZHr,
  outgoing_calls: QHr,
  inbound_agent_setup_success: JHr,
  inbound_agent_configured: XHr,
  setup_inbound_agent: eKr,
  please_select_event_type_first: tKr,
  edit_configuration: nKr,
  select_event_type_for_inbound_calls: oKr,
  setup_inbound_agent_for_incoming_calls: rKr,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: iKr
}, sKr = "Provider di identità", cKr = 'Ti rimangono $t(day, {"count": {{days}} }) di prova con il piano PRO', lKr = "{{count}} giorno", dKr = "{{count}} giorni", uKr = "{{count}} secondo", _Kr = "{{count}} secondi", pKr = "Cambia piano", mKr = "Senza titolo", fKr = "Accetta Invito", gKr = "Caratteri max.", hKr = "Caratteri min.", vKr = "{{appName}} fornisce un'infrastruttura di panificazione aperta a tutti.", bKr = "Completa la configurazione del tuo account {{appName}}! Sei a pochi passi dalla soluzione di tutti i tuoi problemi di pianificazione.", yKr = "Hai domande? Siamo qui per aiutare.", $Kr = "{{appName}}: istruzioni per reimpostare la password", wKr = "{{appName}}: verifica il tuo account", kKr = "{{appName}}: Verifica la tua email", SKr = "Controlla la tua e-mail", xKr = "Vecchio indirizzo email", EKr = "Nuovo indirizzo email", TKr = "Abbiamo inviato un'e-mail a {{email}}. È importante verificare il tuo indirizzo e-mail per garantire la consegna delle e-mail e delle notifiche del calendario {{appName}}.", AKr = "Verifica il tuo indirizzo e-mail per garantire la consegna delle e-mail e delle notifiche del calendario", CKr = "Verifica il tuo indirizzo e-mail", zKr = "Verifica email", OKr = "Assistente", PKr = "Invia email con trascrizione video Cal", IKr = "Invia email con la trascrizione del video Cal dopo la fine della riunione. (Richiede un piano a pagamento)", RKr = "Hai recentemente chiesto di cambiare l'indirizzo email che utilizzi per accedere al tuo account {{appName}}. Fai clic sul pulsante qui sotto pe confermare il tuo nuovo indirizzo email.", NKr = "Indirizzo email aggiornato: {{email}}", DKr = "Aggiornamento email non riuscito.", MKr = "Verifica il tuo nuovo indirizzo email per {{appName}}", LKr = "Abbiamo inviato un link di verifica a {{email}}. Aggiorneremo il tuo indirizzo email quando farai clic sul link.", qKr = "Salva questa chiave API in un posto sicuro. Non potrai visualizzarla in seguito.", jKr = "Verifica il tuo indirizzo e-mail facendo clic sul pulsante qui sotto.", FKr = "Verifica il tuo indirizzo e-mail utilizzando il codice sottostante.", VKr = "Se non ti piacciono i pulsanti, puoi usare questo link:", BKr = "Inserisci il codice di verifica", UKr = "Inserisci il codice di verifica che hai ricevuto via e-mail", WKr = "Il codice di verifica è errato.", GKr = "Email inviata", HKr = "Si è verificato un errore durante l'invito dell'e-mail", KKr = "Rifiutato: {{title}} il {{date}}", YKr = "Cancellato: {{title}} il {{date}}", ZKr = "Riassegnato: {{title}} il {{date}}", QKr = "La tua richiesta per l'evento è stata rifiutata", JKr = "Personalizza impostazioni Cal Video", XKr = "Configura le preferenze per le riunioni video, incluse le autorizzazioni di registrazione per host e partecipanti.", eYr = "Disabilita registrazione per gli ospiti", tYr = "Abilita la trascrizione automatica dopo l'ingresso alla riunione", nYr = "Abilita registrazione automatica dopo che l'organizzatore si unisce alla riunione", oYr = "Opzioni video", rYr = "Modifica evento", iYr = "Visualizza dettagli sessione", aYr = "Dettagli della sessione di riunione", sYr = "Sessione di riunione", cYr = "ID sessione", lYr = "Numero massimo di partecipanti", dYr = "Illimitato", uYr = "In corso", _Yr = "Terminata", pYr = "Partecipanti", mYr = "Utente anonimo", fYr = "Durata della sessione", gYr = "Nessuna sessione di riunione trovata", hYr = "Non disponibile", vYr = "Disabilita registrazione per l'organizzatore", bYr = "Disabilita la trascrizione per gli ospiti", yYr = "Disabilita la trascrizione per l'organizzatore", $Yr = "La tua richiesta per l'evento ricorrente è stata rifiutata", wYr = "Il tuo evento programmato è stato cancellato", kYr = "Il tuo evento programmato è stato riassegnato", SYr = "L'evento non sarà più presente nel tuo calendario e la tua probabilità di round robin non sarà influenzata negativamente", xYr = "Organizzatore", EYr = "Riassegnato a", TYr = "È necessario riprogrammare o annullare?", AYr = "Puoi visualizzare i dettagli della prenotazione da questo URL {{url}} e aggiungere l'evento al tuo calendario", CYr = "Nessuna opzione disponibile", zYr = "Motivo dell'annullamento (facoltativo)", OYr = "Cancellato da", PYr = "Motivo della cancellazione", IYr = "Perché stai annullando?", RYr = "Il motivo della cancellazione sarà condiviso con gli ospiti", NYr = "Perché stai rifiutando?", DYr = "Motivo del rifiuto", MYr = "Rifiutare la richiesta di prenotazione?", LYr = "Sei sicuro di voler rifiutare la prenotazione? Informeremo la persona che ha cercato di prenotare. Puoi indicare il motivo qui sotto.", qYr = "Rifiuta la prenotazione", jYr = "Gestisci questo evento", FYr = "Invia un membro del team", VYr = "Invita una persona", BYr = "Importazione in blocco", UYr = "Inv.", WYr = "Il tuo evento è stato programmato", GYr = "Il tuo evento ricorrente è stato programmato", HYr = "Accetta la nostra licenza cambiando la variabile .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> a '{{agree}}'.", KYr = "Per rimuovere questo banner, apri il tuo file .env e cambia la variabile <1>NEXT_PUBLIC_LICENSE_CONSENT</1> in '{{agree}}'.", YYr = "Il messaggio di errore era: '{{errorMessage}}'", ZYr = "Rimborso non riuscito: {{name}} - {{date}} - {{eventType}}", QYr = "Il rimborso per l'evento {{eventType}} di {{userName}} del {{date}} non è riuscito.", JYr = "Verifica con il tuo fornitore di servizi di pagamento e {{user}} come gestirlo.", XYr = "Un rimborso non è riuscito", eZr = "In attesa del pagamento: {{title}} il {{date}}", tZr = "La tua riunione è in attesa di pagamento", nZr = "Il colore del tema scuro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore in modo che i pulsanti siano più visibili.", oZr = "Il colore del tema chiaro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore in modo che i pulsanti siano più visibili.", rZr = "Il colore del tema chiaro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore affinché il colore dei tuoi tipi di evento sia più visibile.", iZr = "Il colore del tema scuro non supera il controllo del contrasto. Ti consigliamo di cambiare questo colore affinché il colore dei tuoi tipi di evento sia più visibile.", aZr = "Non è stato possibile creare il pagamento", sZr = "Non è stato possibile addebitare la carta per il pagamento", cZr = "Nessun utente disponibile. Puoi provare un altro intervallo temporale?", lZr = "La fascia oraria selezionata non è più disponibile. <0>Seleziona un nuovo orario</0>", dZr = "Occupato", uZr = "Ti sei appena connesso. Prenota dagli slot sopra indicati o riprova più tardi.", _Zr = "Intervallo non disponibile", pZr = "Non è possibile prenotare questo tipo di evento in questo momento. Potresti provare un altro orario?", mZr = "Errore interno. La richiesta non contiene l'ora finale", fZr = "Impossibile creare l'evento nel calendario dell'organizzatore", gZr = "Impossibile aggiornare l'evento nel calendario.", hZr = "Impossibile eliminare l'evento dal calendario.", vZr = "Ti sei già registrato per questa prenotazione.", bZr = "Alcuni degli organizzatori non sono disponibili per la prenotazione.", yZr = "Alcuni degli host fissi non sono disponibili per la prenotazione.", $Zr = "L'host Round Robin non è disponibile per la prenotazione.", wZr = "Guida", kZr = "Prezzo", SZr = "Pagato", xZr = "Rimborsato", EZr = "Registra", TZr = "Trascrivi", AZr = "Pagamento", CZr = "Campi della carta mancanti", zZr = "Paga ora", OZr = "General Prompt", PZr = "Trascrizione alimentata dall'IA", IZr = "Avvia o interrompi la registrazione", RZr = "Inizia messaggio", NZr = "Il codebase deve rimanere open source, che sia stato modificato o meno", DZr = "Non è possibile rimontare o vendere il codebase", MZr = "Acquista una licenza commerciale per rimuovere questi termini via email", LZr = "Riassunto dei termini", qZr = "Apri .env e accetta la nostra licenza", jZr = "Ho cambiato il mio .env", FZr = "Accetta Licenza", VZr = "Un evento è ancora in attesa di approvazione", BZr = "La richiesta d'evento è ancora in attesa: {{attendeeName}} - {{date}} - {{eventType}}", UZr = 'Nessun risultato trovato per "{{searchTerm}}"', WZr = "Nessun altro risultato", GZr = "Nessun risultato", HZr = "Carica più risultati", KZr = "{{integrationName}} meeting ID: {{meetingId}}", YZr = "Confermato: {{eventType}} con {{name}} il {{date}}", ZZr = "Richiesta di nuovo evento: {{attendeeName}} - {{date}} - {{eventType}}", QZr = "Conferma o rifiuta la richiesta", JZr = "Controlla la pagina delle prenotazioni per confermare o rifiutare la prenotazione.", XZr = "Assistente Check-in", eQr = "Effettua una chiamata in uscita per verificare se l'appuntamento programmato è confermato o se desideri riprogrammare.", tQr = "Crea il tuo prompt e usalo per effettuare una chiamata in uscita.", nQr = "Un evento aspetta la tua approvazione", oQr = "Un evento ricorrente è in attesa della tua approvazione", rQr = "Qualcuno ha richiesto di programmare un evento sul tuo calendario.", iQr = "Qualcuno ha richiesto un link per cambiare la tua password.", aQr = "Se questo indirizzo e-mail esiste nel nostro sistema, riceverai un'e-mail per la reimpostazione.", sQr = "Se non l'hai richiesto, puoi tranquillamente ignorare questa email e la tua password non verrà modificata.", cQr = "In attesa di approvazione: {{title}} il {{date}}", lQr = "Un evento è ancora in attesa della tua approvazione", dQr = "Prenotazione inviata: {{title}} il {{date}}", uQr = "Scarica registrazione: {{title}} alle {{date}}", _Qr = "Scarica trascrizione: {{title}} il {{date}}", pQr = "Scarica la tua registrazione", mQr = "Scarica le trascrizioni", fQr = "Il tuo meeting è stata prenotato", gQr = "Il tuo {{title}} è stato riprogrammato per il {{date}}.", hQr = "Il tuo {{title}} è stato aggiornato.", vQr = "Aggiornato: il tuo evento è stato riprogrammato", bQr = "L'evento è stato aggiornato", yQr = "Il tuo evento è stato riprogrammato", $Qr = "{{organizer}} ha cancellato la prenotazione e ti ha chiesto di scegliere un altro orario.", wQr = "Hai richiesto a {{attendee}} di riprogrammare", kQr = "Hai cancellato la prenotazione e {{attendee}} deve selezionare un nuovo orario per la prenotazione.", SQr = "Richiesta di riprogrammazione inviata: {{eventType}} con {{name}} il {{date}}", xQr = "Azione richiesta per la riprogrammazione: prenota un nuovo orario per {{eventType}} con {{name}}", EQr = "Ciao {{name}}", TQr = "{{eventType}} con {{name}}", AQr = "Sembra che tutti i nostri esperti siano occupati al momento. Ti invitiamo a programmare una chiamata in un momento che ti sia più comodo e saremo pronti ad assisterti.", CQr = "Programma invece", zQr = "Richiesta di nuovo evento: {{attendeeName}} - {{date}} - {{eventType}}", OQr = "Entra da {{entryPoint}}", PQr = "Osservazioni", IQr = "Gestisci le mie prenotazioni", RQr = "Hai bisogno di fare una modifica?", NQr = "Un nuovo evento è stato riprogrammato.", DQr = "È stato programmato un nuovo evento ricorrente.", MQr = "Email dell'invitato", LQr = "Fuso Orario dell' invitato", qQr = "Tempo rimanente", jQr = "Tipo di Evento", FQr = "Duplica tipo di evento", VQr = "Inserisci Riunione", BQr = "Provider di videochiamate", UQr = "Meeting ID", WQr = "Password del meeting", GQr = "URL del Meeting", HQr = "URL della riunione non trovato", KQr = "Token non trovato", YQr = "Un altro host ha già accettato la riunione. Vuoi comunque partecipare? <0>Continua alla riunione</0>", ZQr = "La tua richiesta di riunione è stata rifiutata", QQr = "Rifiutato: {{eventType}} con {{organizer}} il {{date}}", JQr = "Ciao", XQr = "Unisciti al team", eJr = "Gestisci questo team", tJr = "Informazioni sul team", nJr = "Partecipa alla riunione", oJr = "Se preferisci non usare {{toEmail}} come email {{appName}} o già hai un account {{appName}}, per favore richiedi un altro invito a quella email.", rJr = "Sei stato invitato ad unirti al team {{teamName}}", iJr = "{{user}} ti ha invitato a unirti a {{entity}} {{team}} su {{appName}}", aJr = "Sei nascosto in questo team", sJr = "Il tuo posto non è pagato. Passa a Pro oppure informa il proprietario del team che può pagare il tuo posto.", cJr = "Per utilizzare i team ti occorre un account Pro. Sarai nascosto finché non cambierai piano.", lJr = "p.s. Scade tra {{expiresIn}} ore.", dJr = "Passa al piano Per-posto", uJr = "L'opzione di prenotazione dei posti non è disponibile per le prenotazioni che richiedono conferma", _Jr = "Le ubicazioni multiple non sono compatibili con l'opzione di prenotazione dei posti", pJr = "La penale per mancata presentazione non è compatibile con l'opzione di prenotazione dei posti", mJr = "L'opzione di prenotazione dei posti non supporta ubicazioni multiple", fJr = "Per i {{memberCount}} membri del tuo team, {{unpaidCount}} posti non sono pagati. A € {{seatPrice}}/m per posto, il costo totale stimato della tua adesione è di € {{totalCost}}/m.", gJr = `Grazie per aver provato il nostro piano team. Abbiamo notato che è necessario effettuare l'upgrade del tuo team "{{teamName}}".`, hJr = "Effettua l'upgrade", vJr = "Il tuo team è stato aggiornato!", bJr = `Grazie per aver provato il nostro piano Organization. Abbiamo notato che è necessario eseguire l'upgrade del piano Organization per "{{teamName}}".`, yJr = "È stato eseguito l'upgrade del piano Organization!", $Jr = "Usa il link qui sotto per reimpostare la tua password", wJr = "Ciao", kJr = "lì", SJr = "Hai dimenticato la password? - {{appName}}", xJr = "Sei sicuro di voler eliminare questo webhook? Non riceverai più {{appName}} dati di riunione in un URL specificato, in tempo reale, quando un evento è programmato o annullato.", EJr = "Sì, elimina webhook", TJr = "Modifica Webhook", AJr = "Elimina Webhook", CJr = "Stato Webhook", zJr = "Webhook Abilitato", OJr = "Webhook Disabilitato", PJr = "Risposta Webhook", IJr = "Test Webhook", RJr = "Modulo di aggiornamento webhook", NJr = "Aggiungi un webhook al tuo OAuthClient.", DJr = "Gestisci il tuo webhook", MJr = "Webhook creato con successo!", LJr = "Webhook aggiornato con successo!", qJr = "Webhook rimosso con successo!", jJr = "Abbonamento necessario", FJr = "Non sei abbonato a un piano Platform.", VJr = "Modello di Payload", BJr = "Ignora", UJr = "Ancora nessun dato", WJr = "Test Ping", GJr = "Aggiungi questa app alla schermata iniziale per un accesso più veloce e un'esperienza migliore.", HJr = "Prossimi", KJr = "Ricorrente", YJr = "Passati", ZJr = "Scegli un file...", QJr = "Carica immagine", JJr = "Carica {{target}}", XJr = "Nessun {{target}}", eXr = "Scorri per ingrandire, trascina per riposizionare", tXr = "Visualizza notifiche", nXr = "Visualizza la pagina pubblica", oXr = "Copia link della pagina pubblica", rXr = "Copia il link di riferimento", iXr = "Esci", aXr = "Aggiungi un altro", sXr = "Installane un'altra", cXr = "fino a", lXr = "offerto da", dXr = "Non Disponibile", uXr = "Imposta il tuo programma di lavoro", _Xr = "Cambia quando sei disponibile per le prenotazioni", pXr = "Seleziona...", mXr = "Testo", fXr = "Il tuo numero di telefono", gXr = "Testo Multilinea", hXr = "Numero", vXr = "Casella di controllo", bXr = "È obbligatorio", yXr = "Rendi questo campo obbligatorio", $Xr = "Obbligatorio", wXr = "Facoltativo", kXr = "Tipo di input", SXr = "Rifiutato", xXr = "Non Confermato", EXr = "Ospiti", TXr = "Ospite", AXr = "Dettagli della conferenza web da seguire.", CXr = "Conferma", zXr = "Cosa deve fornire chi prenota per ricevere le conferme", OXr = "Username", PXr = "è ancora disponibile.", IXr = "Documentazione", RXr = "Scopri come integrare i nostri strumenti con la tua app", NXr = "Riferimento API", DXr = "Un riferimento API completo per le nostre librerie", MXr = "Blog", LXr = "Leggi le nostre ultime notizie e articoli", qXr = "Unisciti alla nostra community", jXr = "Pagine popolari", FXr = "Registrati ora", VXr = "Registrati", BXr = "Questa pagina non esiste.", UXr = "Nessun numero di telefono attivo disponibile", WXr = "Passaggio del flusso di lavoro non configurato", GXr = "Controlla gli errori di ortografia o torna alla pagina precedente.", HXr = "Non siamo riusciti a trovare l'evento che stai cercando di prenotare.", KXr = "Stiamo iniziando", YXr = "Parola segreta", ZXr = "Lasciare vuoto per rimuovere la parola segreta", QXr = "Per motivi di sicurezza, assicurati che il tuo server riceva soltanto le richieste previste di {{appName}}", JXr = "Riunione Segreta", XXr = "Effettua il login invece", eei = "Crea Account", tei = "Inizia", nei = "Conferma password", oei = "Imposta la nuova password seguendo le istruzioni che ti sono state inviate via e-mail.", rei = "Carica un'immagine larga {{width}} e alta {{height}}.", iei = "Accedi di nuovo con il nuovo indirizzo e-mail e la nuova password.", aei = "Crea il tuo account", sei = "Crea il tuo accout Cal.com", cei = "Registrati", lei = "Hai fatto il log out", dei = "Speriamo di rivederti presto!", uei = "Hai fatto il log out", _ei = "Si prega di riprovare e contattarci se il problema persiste.", pei = "Il codice a due fattori non è corretto.", mei = "Nessun account esiste corrispondente a quell'indirizzo email.", fei = "Crea il tuo account", gei = "Non hai un account?", hei = "Accedi al tuo account", vei = "Accedi", bei = "Torna alla pagina di accesso", yei = "Si è verificato un errore durante il login. Torna alla schermata di accesso e riprova.", $ei = "Invia email di ripristino", wei = "Invia invito", kei = "Password dimenticata?", Sei = "Dimenticato?", xei = "Fatto", Eei = "Operazione completata!", Tei = "Tutte", Aei = "Il tuo account", Cei = "Applicazioni disponibili", zei = "Applicazioni disponibili", Oei = "Visualizza le app popolari qui sotto ed esplora altre nel nostro <0>App Store</0>", Pei = "Aggiungi chiunque debba partecipare all'evento. <0>Scopri di più</0>", Iei = "Le persone in un gruppo fanno a turno, una persona di ciascun gruppo si presenterà all'evento.", Rei = "Le persone nel gruppo fanno a turno e una sola persona si presenterà all'evento.", Nei = "Controlla la tua email. Ti abbiamo inviato un link per reimpostare la password.", Dei = "Fine", Mei = "Gestisci le impostazioni della lingua e del fuso orario per il tuo team", Lei = "Alcune frasi su di te. Questo apparirà sulla tua pagina url personale.", qei = "Ci siamo quasi", jei = "Ultima cosa, una breve descrizione su di te e una foto aiutano davvero a ottenere prenotazioni e a far sapere alle persone con chi stanno prenotando.", Fei = "Definisci intervalli di tempo di quando sei disponibile su una base ricorrente. Puoi crearne di più in seguito e assegnarli a calendari diversi.", Vei = "Imposta la tua disponibilità", Bei = "Programma gli orari in cui vuoi essere prenotato.", Uei = "Condividi o pubblica un link", Wei = "Condividi il tuo link {{appName}} o inseriscilo nel tuo sito.", Gei = "Impostazioni di disponibilità", Hei = "Continua senza calendario", Kei = "Continua con {{appName}}", Yei = "Collega il tuo calendario", Zei = "Collega le tue applicazioni video", Qei = "Collega le tue applicazioni video per utilizzarle per i tuoi tipi di evento.", Jei = "Collega il tuo calendario per verificare automaticamente gli orari occupati e i nuovi eventi man mano che vengono programmati.", Xei = "Configura più tardi", eti = "Orario corrente", tti = "Dettagli", nti = "Benvenuto", oti = "Bentornato", rti = "Benvenuto in {{appName}}", iti = "Dicci come vuoi essere chiamato e facci sapere in quale fuso orario ti trovi. Potrai modificare queste informazioni in seguito.", ati = "Connetti al server CalDav", sti = "Collega a un feed ICS", cti = "Connetti", lti = "Provalo gratuitamente", dti = "Crea il tuo link di prenotazione con {{appName}}", uti = "Chi", _ti = "Cosa", pti = "Quando", mti = "Dove", fti = "Aggiungi al calendario", gti = "Seleziona dove aggiungere gli eventi quando vieni prenotato.", hti = "Aggiungi eventi a", vti = "Aggiungi un altro calendario", bti = "Altro", yti = "Link di accesso a {{appName}}", $ti = "Avrai un incontro con {{user}}. Abbiamo inviato a tutti un'email di invito contenente tutte le informazioni.", wti = "{{host}} si incontra con {{attendee}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti.", kti = "Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti.", Sti = "Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", xti = "Ti incontri con {{user}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", Eti = "{{host}} si incontra con {{attendee}}. Abbiamo inviato un'email con un invito al calendario con i dettagli a tutti per il primo di questi eventi ricorrenti.", Tti = "Tu e tutti gli altri partecipanti siete stati invitati via email con queste informazioni.", Ati = "La tua prenotazione deve ancora essere confermata o rifiutata.", Cti = "La tua riunione ricorrente deve ancora essere confermata o rifiutata.", zti = "{{user}} deve ancora confermare o rifiutare la prenotazione.", Oti = "{{user}} deve ancora confermare o rifiutare ciascuna prenotazione della riunione ricorrente.", Pti = "Questo incontro è in programma", Iti = "Gli eventi ricorrenti sono programmati", Rti = "Prenotazione Inviata", Nti = "La tua riunione ricorrente è stata inviata", Dti = "Prenotazione Confermata", Mti = "La tua riunione ricorrente è stata confermata", Lti = "I pagamenti per gli eventi ricorrenti non sono ancora supportati", qti = "I pagamenti per gli eventi ricorrenti non sono ancora supportati", jti = "Inserisci la nuova password che desideri per il tuo account.", Fti = "Reimposta Password", Vti = "Cambia la tua password", Bti = "Mostra password", Uti = "Nascondi password", Wti = "Prova Di Nuovo", Gti = "Quella richiesta è scaduta.", Hti = "Inserisci l'indirizzo email associato al tuo account e ti invieremo un link per reimpostare la password.", Kti = "La richiesta è scaduta. Torna indietro e inserisci l'email associata al tuo account e ti invieremo un altro link per reimpostare la password.", Yti = "Oops", Zti = "Login", Qti = "Riuscito", Jti = "Fallito", Xti = "La tua password è stata reimpostata. Ora puoi accedere con la tua password appena creata.", eni = "Layout", tni = "Vista predefinita", nni = "Puoi selezionarne diverse e le persone che prenotano possono cambiare visualizzazione.", oni = "Layout prenotazioni", rni = "Puoi selezionarne diverse e le persone che prenotano possono cambiare visualizzazione. È possibile definire impostazioni specifiche per ciascun evento.", ini = "Mese", ani = "Settimanale", sni = "Colonna", cni = "Deve essere abilitato almeno un layout.", lni = "Il layout selezionato come vista predefinita non è tra quelli abilitati.", dni = "Il layout selezionato non è un layout valido.", uni = "Puoi gestire questo per tutti i tuoi tipi di eventi in Impostazioni -> <0>Aspetto</0> o <1>Sovrascrivi</1> solo per questo evento.", _ni = "Si è verificato un errore imprevisto. Riprova.", pni = "Ora non valida la domenica", mni = "Ora non valida il lunedì", fni = "Ora non valida il martedì", gni = "Ora non valida il mercoledì", hni = "Ora non valida il giovedì", vni = "Ora non valida il venerdì", bni = "Ora non valida il sabato", yni = "L'ora di conclusione non può precedere l'ora di inizio", $ni = "L'ora di conclusione non può essere maggiore di 24 ore", wni = "Torna alle prenotazioni", kni = "Sentiti libero di scegliere un altro evento in qualsiasi momento.", Sni = "Cancellato", xni = "Nessuna prenotazione", Eni = "In attesa dell'host", Tni = "Cancellazione riuscita", Ani = "Davvero vuoi annullare la prenotazione?", Cni = "Non puoi annullare questa prenotazione", zni = "Invece, lo potresti riprogrammare.", Oni = "L'evento è nel passato", Pni = "L'evento è un'istanza di un evento ricorrente.", Ini = "Queste sono tutte le istanze rimanenti dell'evento ricorrente.", Rni = "Si è verificato un errore con il codice di stato {{status}}.", Nni = "Esiste già un tipo di evento con questo URL.", Dni = "Non puoi creare questo evento", Mni = "Non puoi modificare questo evento", Lni = "Non puoi creare questo flusso di lavoro", qni = "Non puoi creare questo programma", jni = "Questa prenotazione è stata già cancellata", Fni = "Questa prenotazione è già stata accettata o rifiutata", Vni = "Torna alla home", Bni = "Torna alla home", Uni = "Nessuna Riunione Trovata", Wni = "Questa riunione non esiste. Contatta il proprietario della riunione per un link aggiornato.", Gni = "Nessuna prenotazione in {{status}}", Hni = "Non hai {{status}} prenotazioni. {{description}}", Kni = "{{eventName}} tra {{host}} e {{attendeeName}}", Yni = "Prenotazioni", Zni = "Prenotazione non trovata", Qni = "Vedi gli eventi imminenti e passati prenotati attraverso i link di tipo evento.", Jni = "Non appena qualcuno prenota una riunione con voi apparirà qui.", Xni = "Quando qualcuno prenoterà una riunione ricorrente con te, la riunione apparirà qui.", eoi = "Le tue prenotazioni passate appariranno qui.", toi = "Le prenotazioni cancellate appariranno qui.", noi = "Le tue prenotazioni non confermate appariranno qui.", ooi = "Prenotazioni non confermate", roi = "su", ioi = "e", aoi = "Il tuo calendario ti mostra come occupato tra", soi = "Risoluzione Dei Problemi", coi = "Capisci perché determinati tempi sono disponibili e altri sono bloccati.", loi = "Ecco una panoramica della tua giornata", doi = "Suggerimento: Passa sui tempi in grassetto per un timestamp completo", uoi = "Ora di inizio", _oi = "Ora di fine", poi = "Tempo buffer", moi = "Prima dell'evento", foi = "Dopo l'evento", goi = "Nessun tempo buffer", hoi = "Buffer", voi = "La tua giornata inizia alle", boi = "La tua giornata termina alle", yoi = "Avvia la risoluzione dei problemi", $oi = "Risolvi i problemi della vostra disponibilità per esplorare il motivo per cui i vostri orari di disponibilità si stanno mostrando come sono.", woi = "Cambia gli orari disponibili", koi = "Cambia gli orari disponibili", Soi = "Cambia gli orari di inizio e fine della giornata", xoi = "Imposta l'ora di inizio e di fine della giornata e un buffer minimo tra le riunioni.", Eoi = "Attualmente, il tuo giorno è impostato per iniziare a", Toi = "Gli orari di inizio e di fine della giornata sono stati modificati con successo.", Aoi = "e termina a", Coi = "Chiaro", zoi = "Scuro", Ooi = "Regola automaticamente il tema in base alle preferenze dell'invito", Poi = "Alcuni degli utenti del gruppo hanno attualmente disabilitato le prenotazioni di gruppo dinamiche", Ioi = "È possibile creare dinamicamente collegamenti a prenotazioni di gruppo inserendo più nomi utente separati da '+'. Esempio: '{{appName}}/bailey+peer'", Roi = "Consenti ai partecipanti di prenotare per te utilizzando le prenotazioni di gruppo dinamiche", Noi = "Collegamenti dinamici di gruppo", Doi = "Consenti ai motori di ricerca di accedere ai tuoi contenuti pubblici", Moi = "Consenti l'indicizzazione dei motori di ricerca", Loi = "Consenti notifiche del browser", qoi = "Hai negato le notifiche. Reimposta i permessi nelle impostazioni del browser per abilitarle.", joi = "Disabilita notifiche del browser", Foi = "Notifiche del browser attivate", Voi = "Notifiche del browser disattivate", Boi = "Notifiche del browser negate", Uoi = "Consenti le notifiche dal prompt", Woi = "Notifiche push", Goi = "Ricevi notifiche push quando un utente invia una prenotazione immediata di un incontro.", Hoi = "Il tuo browser non supporta le notifiche push. Se usi Brave, abilita l'opzione `Usa i servizi di Google per la messaggistica push` su brave://settings/?search=push+messaging", Koi = "Email", Yoi = "jdoe@example.com", Zoi = "Nome completo", Qoi = "Sfoglia la nostra documentazione API", Joi = "Sfrutta la nostra API per il pieno controllo e la personalizzabilità.", Xoi = "Crea Webhook", eri = "Riunione immediata creata", tri = "Prenotazione cancellata", nri = "Prenotazione Riprogrammata", ori = "Il link per scaricare la registrazione è pronto", rri = "Trascrizione generata", iri = "Prenotazione Creata", ari = "Prenotazione Rifiutata", sri = "Richiesta di prenotazione inviata", cri = "Pagamento della prenotazione iniziato", lri = "Riunione terminata", dri = "Modulo inviato", uri = "Modulo inviato, nessun evento prenotato", _ri = "Prenotazione pagata", pri = "Fuori sede creato", mri = "Prenotazione No-Show aggiornata", fri = "Attivatori Evento", gri = "URL abbonato", hri = "Crea un nuovo webhook", vri = "Webhook", bri = "Webhook del team", yri = "Crea un nuovo webhook sul tuo account", $ri = "Nuovo Webhook", wri = "Ricevi i dati delle riunioni {{appName}} a un URL specificato in tempo reale quando un evento viene programmato o cancellato.", kri = "Ricevi i dati della riunione {{appName}} a un URL specificato in tempo reale quando questo evento viene programmato o cancellato.", Sri = "Iframe full screen responsive", xri = "Caricamento...", Eri = "Eliminazione...", Tri = "Iframe standard", Ari = "Sviluppatore", Cri = "Gestisci le impostazioni sviluppatore.", zri = "iframe Incorporato", Ori = "Il modo più semplice per incorporare {{appName}} sul tuo sito web.", Pri = "Integra con il tuo sito web utilizzando le nostre opzioni incorporate, o ottieni informazioni di prenotazione in tempo reale utilizzando webhooks personalizzati.", Iri = "Pianifica una riunione", Rri = "Visualizza e gestisci i tuoi dettagli di fatturazione", Nri = "Visualizza e modifica i tuoi dati di fatturazione, puoi anche modificare la tua subcription.", Dri = "Vai al portale di fatturazione", Mri = "Hai bisogno di altro?", Lri = "Se hai bisogno di ulteriore aiuto per la fatturazione, il nostro team di supporto è qui per aiutarti.", qri = "Contatta", jri = "il nostro team di supporto", Fri = "Contatta il nostro team di supporto", Vri = "Uh oh!", Bri = "Questo utente non ha ancora impostato alcun tipo di evento.", Uri = "Modifica logo", Wri = "Carica un logo", Gri = "Carica logo", Hri = "Rimuovi logo", Kri = "Abilita", Yri = "Codice", Zri = "Il codice non è corretto.", Qri = "Aggiungi nuova fascia oraria", Jri = "Aggiungi un ulteriore livello di sicurezza al tuo account nel caso in cui la password venga rubata.", Xri = "Abilita autenticazione a due fattori", eii = "Disabilita autenticazione a due fattori", tii = "Se è necessario disattivare 2FA, si consiglia di riattivarlo il prima possibile.", nii = "Disabilita autenticazione a due fattori", oii = "Disabilita autenticazione a due fattori", rii = "Sicurezza", iii = "Gestisci la sicurezza del tuo account.", aii = "Password", sii = "Webhook aggiornato con successo", cii = "La password è stata cambiata con successo.", lii = "Errore nel cambiare la password", dii = "La configurazione della sessione è stata aggiornata correttamente.", uii = "Errore durante l'aggiornamento della configurazione della sessione", _ii = "Qualcosa è andato storto.", pii = "Qualcosa non sembra giusto?", mii = "Per favore riprova.", fii = "La tua nuova password super sicura", gii = "Nuova Password", hii = "La tua vecchia password", vii = "Password Attuale", bii = "Cambia la tua password", yii = "Cambia parola segreta", $ii = "La nuova password corrisponde alla vecchia password. Scegli una password diversa.", wii = "Nel caso la parola segreta venga persa o dimenticata, è possibile cambiarla, ma tieni presente che tutte le integrazioni che la utilizzano dovranno essere aggiornate", kii = "La password attuale non è corretta", Sii = "Combinazione di caratteri maiuscoli e minuscoli", xii = "La lunghezza minima è di 7 caratteri", Eii = "La lunghezza minima è di 15 caratteri", Tii = "Deve contenere almeno 1 numero", Aii = "Deve avere una lunghezza massima di {{limit}} caratteri", Cii = "La password deve avere una lunghezza minima di {{passwordLength}} caratteri e deve contenere almeno 1 numero e una combinazione di caratteri maiuscoli e minuscoli", zii = "La password non è corretta.", Oii = "Indirizzo e-mail o password errati.", Pii = "Usa impostazione", Iii = "am/pm", Rii = "Opzioni tempo", Nii = "Gennaio", Dii = "Febbraio", Mii = "Marzo", Lii = "Aprile", qii = "Maggio", jii = "Giugno", Fii = "Luglio", Vii = "Agosto", Bii = "Settembre", Uii = "Ottobre", Wii = "Novembre", Gii = "Dicembre", Hii = "Lunedì", Kii = "Martedì", Yii = "Mercoledì", Zii = "Giovedì", Qii = "Venerdì", Jii = "Sabato", Xii = "Domenica", eai = "Nessuna disponibilità.", tai = "Impossibile caricare gli intervalli di tempo disponibili.", nai = "Aggiungi ospiti", oai = "Il tuo nome", rai = "Nome completo", iai = "Nessun nome", aai = "Insrisci un numero compreso tra 1 e {{maxOccurences}}", sai = "Veloce e facile - nessun account richiesto. Perfetto per incontri occasionali.", cai = "Indirizzo email", lai = "Immettere un indirizzo e-mail valido", dai = " Pianifica una chiamata futura se non siamo disponibili entro {{seconds}} secondi", uai = "Luogo", _ai = "Indirizzo", pai = "Immettere l'indirizzo", mai = "Di persona (indirizzo del partecipante)", fai = "Altrove", gai = "Posizione personalizzata del partecipante", hai = "Continua come ospite", vai = "Partecipa come ospite", bai = "Ideale per chiamate occasionali", yai = "Qualsiasi posizione", $ai = "Sì", wai = "No", kai = "Note aggiuntive", Sai = "Impossibile prenotare la riunione.", xai = "Impossibile riprogrammare la riunione.", Eai = "Si prega di condividere tutto ciò che aiuterà a preparare il nostro incontro.", Tai = "Conferma il tuo {{eventTypeTitle}} con {{profileName}}", Aai = "Riprogramma il tuo {{eventTypeTitle}} con {{profileName}}", Cai = "Link o riunione di persona", zai = "Di persona (indirizzo dell'organizzatore)", Oai = "Collegamento riunione", Pai = "Numero Di Telefono", Iai = "Numero di telefono del partecipante", Rai = "Numero di telefono organizzatore", Nai = "Inserisci numero di telefono", Dai = "Riprogramma", Mai = "Riprogramma", Lai = "Prenota invece un membro del team", qai = "O", jai = "Torna indietro", Fai = "Email o Username", Vai = "Invia un'email di invito", Bai = "Ruolo", Uai = "Modifica Ruolo", Wai = "Visualizza ruolo", Gai = "Modifica team", Hai = "Modifica utente", Kai = "Modifica organizzazione", Yai = "Se desideri modificare o gestire i tuoi webhook, vai alle <0>impostazioni dei webhook</0>", Zai = "Rifiuta", Qai = "Rifiuta tutto", Jai = "Accetta", Xai = "Abbandona", esi = "Profilo", tsi = "Url del mio team", nsi = "I miei team", osi = "Nome del team", rsi = "Nome del tuo team", isi = "Team aggiornato con successo", asi = "Il tuo team è stato aggiornato con successo.", ssi = "La tua organizzazione è stata aggiornata con successo.", csi = "Errore durante la copia negli appunti", lsi = "Informazioni", dsi = "Alcune frasi sul tuo team. Appariranno nella pagina URL del team.", usi = "ID organizzazione", _si = "ID organizzazione copiato.", psi = "Qualche informazione sulla tua organizzazione. Le informazioni appariranno nella pagina di profilo dell'organizzazione.", msi = "ID team", fsi = "ID team copiato.", gsi = "Membri", hsi = "Membri dell'organizzazione", vsi = "Membri", bsi = "{{count}} membro", ysi = "{{count}} membri", $si = "{{count}} selezionato/i", wsi = "Proprietario", ksi = "Amministratore", Ssi = "API di amministrazione", xsi = "Utente amministratore", Esi = "Creiamo il primo utente amministratore.", Tsi = "Impostazione utente amministratore", Asi = "Hai già creato un utente amministratore. Puoi effettuare l'accesso al tuo account.", Csi = "Nuovo Membro", zsi = "Invita", Osi = "Aggiungi membri del team", Psi = "Aggiungi membri", Isi = "Invita altri utenti a unirsi al tuo team", Rsi = "Aggiungi un membro del team", Nsi = "Invita un nuovo membro", Dsi = "Nota: Questo <0>costerà un posto aggiuntivo (15$/m)</0> sul tuo abbonamento.", Msi = "Invita qualcuno nel tuo team.", Lsi = "Carica un file .csv", qsi = "Invita via e-mail", jsi = "Cambia il ruolo del membro del team", Fsi = "Disabilita il branding {{appName}}", Vsi = "Nascondi tutti i brand {{appName}} dalle tue pagine pubbliche.", Bsi = "Nascondi pulsante Prenota un membro del team", Usi = "Nasconde il pulsante Prenota un membro del team nelle pagine pubbliche.", Wsi = "Zona pericolosa", Gsi = "Attenzione. L'eliminazione dell'account non può essere annullata.", Hsi = "Attenzione. L'eliminazione del team non può essere annullata.", Ksi = "Indietro", Ysi = "Annulla", Zsi = "Annulla tutti i rimanenti", Qsi = "Applica", Jsi = "Annulla questo evento", Xsi = "Conferma", eci = "Conferma tutto", tci = "Sciogli Squadra", nci = "Sei sicuro di voler sciogliere questo team? Chiunque tu&apos;abbia condiviso questo link di squadra con non sarà più in grado di prenotare utilizzandolo.", oci = "Sciogli organizzazione", rci = "Desideri sciogliere questa organizzazione? Tutti i team e i membri verranno eliminati.", ici = "Sei sicuro di voler rimuovere questo membro dalla squadra?", aci = "Sì, disband team", sci = "Sì, rimuovi membro", cci = "Sì, annulla l'abbonamento", lci = "Annulla abbonamento", dci = "L'annullamento dell'abbonamento disattiverà permanentemente il tuo piano attuale. Questa azione non può essere annullata.", uci = "Rimuovi membro", _ci = "Gestisci il tuo team", pci = "Non hai ancora alcun team.", mci = "I team permettono ad altri di prenotare eventi in condivisione con i tuoi collaboratori.", fci = "Invia", gci = "Sì, rimuovi attributo", hci = "Rimuovi attributo", vci = "Sei sicuro di voler rimuovere l'attributo '{{name}}'? Tutti gli utenti attualmente assegnati verranno disassegnati.", bci = "Aggiorna", yci = "Salva", $ci = "In Attesa", wci = "Apri opzioni", kci = "Copia link all'evento", Sci = "Condividi", xci = "Ti dispiacerebbe prenotare sul mio calendario o inviarmi il tuo link?", Eci = "Copia il link al team", Tci = "Lascia il team", Aci = "Sì, lascio il team", Cci = "Sei sicuro di voler lasciare questo team? Non potrai più utilizzarlo per prenotare.", zci = "{{user}} da {{team}}", Oci = "Anteprima", Pci = "Link copiato!", Ici = "Copiato!", Rci = "Link privato copiato!", Nci = "Link condiviso!", Dci = "Titolo", Mci = "Descrizione", Lci = "Stato delle applicazioni", qci = "Una riunione video veloce.", jci = "Tipo Di Pianificazione", Fci = "Anteprima team", Vci = "Collettivo", Bci = "Pianifica le riunioni quando tutti i membri del team selezionati sono disponibili.", Uci = "Durata", Wci = "Durate disponibili", Gci = "Durata predefinita", Hci = "Scegliere prima delle durate disponibili", Kci = "{{count}} $t(minute_timeUnit)", Yci = "{{count}} $t({{unit}}_timeUnit)", Zci = "{{count}}$t({{unit}}_short)", Qci = "Minuti", Jci = "Usa Cal.ai per avere un numero di telefono gestito dalla IA o per chiamare agli ospiti.", Xci = "URI di terminazione", eli = "Nome utente SIP Trunk", tli = "Password SIP Trunk", nli = "Nickname", oli = "Elimina numero di telefono", rli = "Validazione del flusso di lavoro fallita", ili = "Uno o più passaggi del flusso di lavoro hanno contenuti del messaggio vuoti", ali = "Uno o più numeri di telefono o indirizzi email non sono verificati", sli = "Potenzia i tuoi flussi di lavoro con Cal.ai", cli = "Agenti AI realistici che prenotano incontri, inviano promemoria e seguono i tuoi clienti.", lli = "Numero di telefono importato e collegato all'agente con successo", dli = "Numero di telefono eliminato con successo", uli = "Sei sicuro di voler eliminare questo numero di telefono? Questa azione non può essere annullata.", _li = "Sì, elimina il numero di telefono", pli = "Il numero che stai cercando di importare deve essere in formato E.164 (prefisso internazionale seguito dal numero, senza spazi o caratteri speciali), ad esempio +1234567890", mli = "L'URI di terminazione per identificare in modo univoco il tuo trunk SIP elastico. Viene utilizzato per le chiamate in uscita. Per i trunk SIP elastici di Twilio termina sempre con .pstn.twilio.com.", fli = "Il nome utente utilizzato per autenticare il trunk SIP.", gli = "La password utilizzata per autenticare il trunk SIP.", hli = "Nickname del numero. Questo è solo per tuo riferimento.", vli = "Salva e testa chiamata", bli = "Chiamata avviata con successo", yli = "Inserisci un numero di telefono", $li = "Agente aggiornato con successo", wli = "Agente creato con successo", kli = "Tipo di evento aggiunto con successo", Sli = "Numero di telefono disiscritto con successo", xli = "Questo prompt definisce il ruolo e gli obiettivi principali dell'agente", Eli = "Prompt", Tli = "Chiama a", Ali = "Effettua una chiamata di prova per verificare la configurazione", Cli = "Messaggio iniziale", zli = "Il primo messaggio che l'agente dirà all'inizio di una chiamata", Oli = "Problemi con l'importazione?", Pli = "Scopri", Ili = "Scopri come ottenere il tuo URI di terminazione e le credenziali del trunk SIP", Rli = "Abbonamento al numero di telefono annullato con successo", Nli = "Aggiornamento in corso", Dli = "Round Robin", Mli = "Ciao, come stai?", Lli = "Ciclo di riunioni tra più membri del team.", qli = "Evento gestito", jli = "username", Fli = "Crea e distribuisci tipi di evento in blocco ai membri del team", Vli = "Gestito", Bli = 'il campo "username" può essere compilato solo con il nome utente dei membri assegnati', Uli = "Assegna a", Wli = "Inserisci il numero di telefono per la chiamata di prova", Gli = "Effettua una chiamata di prova", Hli = "Crea un nuovo agente vocale cal.ai per il workflow", Kli = "Crea un nuovo agente vocale cal.ai per automatizzare i tuoi workflow", Yli = "Numero di telefono (che il nostro agente chiamerà)", Zli = "Acquista un numero di telefono o importane uno che hai già su Twilio", Qli = "Testa l'agente", Jli = "Prova chiamata web", Xli = "Numeri di telefono", edi = "Disiscriviti", tdi = "Elimina fase del workflow", ndi = "Disiscriviti dal numero di telefono", odi = "Acquista un nuovo numero", rdi = "Puoi acquistare solo numeri di telefono statunitensi. Per altri paesi, puoi importare il tuo numero di telefono Twilio.", idi = "Acquista un numero USA per ${{priceInDollars}} al mese", adi = "Destinazioni di chiamata supportate", sdi = "Nessun numero di telefono collegato", cdi = "Impossibile ottenere l'ID del passaggio del flusso di lavoro", ldi = "Agente Cal.ai", ddi = "Testa l'agente Cal.ai", udi = "Sei sicuro di voler eliminare questo passaggio del flusso di lavoro?", _di = "Vuoi ancora disattivare l'abbonamento del numero di telefono da questo agente?", pdi = "Questa azione disconnetterà il numero di telefono dall'agente. L'agente non sarà in grado di effettuare chiamate finché non verrà collegato un nuovo numero di telefono.", mdi = "Numeri di telefono", fdi = "Collega numero di telefono", gdi = "Gestisci i tuoi numeri di telefono", hdi = "Importa numero", vdi = "Questa azione inoltre:", bdi = "Importa numero di telefono", ydi = "Abbonamento attivo", $di = "Annulla l'abbonamento al tuo numero di telefono", wdi = "Elimina il numero di telefono associato", kdi = "Non sei autorizzato a creare questo flusso di lavoro", Sdi = "Importa il tuo numero di telefono Twilio da utilizzare con Phone", xdi = "${{price}}/mese", Edi = "Acquista nuovo numero", Tdi = "L'acquisto di un numero di telefono costa ${{priceInDollars}} al mese. Ti verrà addebitato un costo mensile per ogni numero di telefono attivo.", Adi = "Prefisso (Opzionale)", Cdi = "Nessun numero di telefono", zdi = "Numero di telefono acquistato con successo", Odi = "Annulla abbonamento numero di telefono", Pdi = "Sì, annulla abbonamento", Idi = "Sei sicuro di voler annullare questo abbonamento al numero di telefono? Questa azione non può essere annullata e perderai l'accesso a questo numero di telefono.", Rdi = "Aggiungi membri...", Ndi = "Aggiungi membri", Ddi = "Nessun membro assegnato", Mdi = "Assegnato a", Ldi = "Devi effettuare l'accesso a {{url}}", qdi = "Inizia ad assegnare membri in alto", jdi = "I membri non potranno fare modifiche", Fdi = "I membri possono fare modifiche", Vdi = "Questa opzione è stata bloccata dall'amministratore del team", Bdi = "Sbloccato dall'amministratore del team", Udi = "URL", Wdi = "Nascosto", Gdi = "Sola lettura", Hdi = "Link monouso", Kdi = "Al momento sei nel piano {{plan}}.", Ydi = "Passa al piano Pro per sbloccare tutte le funzionalità che abbiamo da offrire.", Zdi = "È necessario aggiornare il piano per avere più di un tipo di evento attivo.", Qdi = "Devi aggiornare il tuo piano per creare un team.", Jdi = "Puoi <1>cambiare piano qui</1>.", Xdi = "Tipo di Evento", eui = "Crea eventi da condividere per le persone che prenotano sul tuo calendario.", tui = "Nuovo tipo di evento", nui = "Crea il tuo primo tipo di evento", oui = "I tipi di eventi ti permettono di condividere i link che mostrano gli orari disponibili sul tuo calendario e consentire alle persone di effettuare prenotazioni con te.", rui = "{{eventTypeTitle}} tipo di evento creato con successo", iui = "{{eventTypeTitle}} tipo di evento aggiornato con successo", aui = "Tipo di evento eliminato con successo", sui = "Ore", cui = "Persone", lui = "La Tua Email", dui = "Cambia Avatar", uui = "Carica avatar", _ui = "Lingua", pui = "Timezone", mui = "Primo giorno della settimana", fui = "Si ripete {{count}} volta", gui = "Si ripete {{count}} volte", hui = "Ogni {{freq}} per", vui = "{{count}} evento rimanente", bui = "{{count}} eventi rimanenti", yui = "Si ripete ogni", $ui = "occorrenza", wui = "occorrenze", kui = "settimana", Sui = "settimane", xui = "mese", Eui = "mesi", Tui = "anno", Aui = "anni", Cui = "Altri {{count}}", zui = "Max", Oui = "Tema Singolo", Pui = "Colore del Marchio", Iui = "Colore del marchio (tema chiaro)", Rui = "Colore del marchio (tema scuro)", Nui = "Colore del tipo di evento (Tema chiaro)", Dui = "Colore del tipo di evento (Tema scuro)", Mui = "Il file non è chiamato [idOrSlug]/[user]", Lui = "Crea team", qui = "Nome", jui = "Team senza nome", Fui = "Client OAuth", Vui = "Gestisci i client OAuth per la tua organizzazione", Bui = "Crea client OAuth", Uui = "Crea un nuovo client OAuth per integrazioni di terze parti", Wui = "Client OAuth eliminato con successo", Gui = "Crea un nuovo team per collaborare con gli utenti.", Hui = "Crea un nuovo team", Kui = "URL della tua pagina di prenotazione", Yui = "URL della pagina dove i tuoi utenti possono cancellare la prenotazione", Zui = "URL della pagina dove i tuoi utenti possono riprogrammare la prenotazione", Qui = "Questo slot non è più disponibile. Torna alla pagina precedente e seleziona un altro orario.", Jui = "Inviti Aperti", Xui = "Nuovo Team", e_i = "Crea il tuo primo team e invita altri utenti a lavorare insieme.", t_i = "Crea una squadra per iniziare", n_i = "Team", o_i = "Team", r_i = "Organizzazione", i_i = "Fatturazione team", a_i = "Gestisci la fatturazione per il tuo team", s_i = "Abbiamo cambiato la fatturazione per i team", c_i = "Alcuni membri del tuo team non hanno un posto. Aggiorna il tuo piano Pro per coprire i posti mancanti.", l_i = "A partire da gennaio 2022, applichiamo una tariffazione in base ai posti per i membri dei team. I membri del tuo team che utilizzavano Pro gratuitamente dispongono ora di un periodo di prova di 14 giorni. Terminata la prova, questi membri saranno nascosti dal tuo team, se non aggiornerai il piano.", d_i = "Crea e gestisci team per utilizzare funzionalità di collaborazione.", u_i = "Questa funzione è disponibile solo nel piano Pro", __i = "Al fine di rimuovere il marchio {{appName}} dalle pagine di prenotazione, è necessario acquistare un account Pro.", p_i = "Modifica le informazioni del tuo profilo, che verranno visualizzate sul tuo link di pianificazione.", m_i = "Perché la modifica abbia effetto, potrebbe essere necessario disconnettersi e accedere nuovamente.", f_i = "Qualcosa su di te.", g_i = "Profilo aggiornato con successo", h_i = "Il tuo profilo utente è stato aggiornato con successo.", v_i = "Il tuo upgrade è disponibile", b_i = "Migliora la tua esperienza di pianificazione passando al nuovo piano e goditi le nuove funzionalità.", y_i = "Sei a posto", $_i = "Sei già sul piano più recente. Nessun upgrade necessario. Goditi le nuove funzionalità e contattaci per qualsiasi domanda!", w_i = "L'utente sembra loggato ma non può essere trovato nel database", k_i = "Incorpora e webhook", S_i = "Abilitato", x_i = "Disabilitato", E_i = "Disabilitato", T_i = "Fatturazione", A_i = "qui", C_i = "Gestisci le tue informazioni di fatturazione e annulla il tuo abbonamento.", z_i = "Disponibilità", O_i = "Modifica disponibilità", P_i = "Cambia quando sei disponibile per le prenotazioni.", I_i = "Copia orari in", R_i = "Copia orari in…", N_i = "Cambia il tuo programma settimanale", D_i = "Logo", M_i = "Errore", L_i = "Immettere almeno un carattere", q_i = "Immettere almeno {{count}} caratteri", j_i = "Logo Del Team", F_i = "Aggiungi un luogo", V_i = "Partecipanti", B_i = "Aggiungi partecipanti", U_i = "Mostra impostazioni avanzate", W_i = "Nascondi impostazioni avanzate", G_i = "Nome Dell'Evento", H_i = "Nome dell'evento nel calendario", K_i = "Il nome che apparirà nei calendari", Y_i = "Riunione con {{attendeeName}}", Z_i = "Input Aggiuntivi", Q_i = "Chiedi al creatore del programma di inserire dei campi di input aggiuntivi prima che la prenotazione sia confermata", J_i = "Etichetta", X_i = "Segnaposto", epi = `Visualizza l'email "Aggiungi al calendario" come organizzatore`, tpi = "Indicheremo questo indirizzo email come organizzatore e invieremo qui le email di conferma.", npi = `Se attivata, indicheremo l'indirizzo email del tuo "Aggiungi al calendario" come organizzatore e invieremo a tale indirizzo le email di conferma`, opi = `Nota che potrebbe essere necessario disconnettere e poi riconnettere l'account "Aggiungi al calendario" per utilizzare questa funzione.`, rpi = "Tipo", ipi = "Modifica", api = "Aggiungi un input", spi = "Nascondi le note nel calendario", cpi = "Per motivi di privacy, gli input e le note aggiuntivi saranno nascosti nella voce del calendario. Verranno comunque invitati alla tua email.", lpi = "La prenotazione deve essere confermata manualmente prima di essere inviata alle integrazioni e che venga inviata una e-mail di conferma.", dpi = "Le prenotazioni non confermate bloccano comunque gli slot del calendario.", upi = "Evento ricorrente", _pi = "Le persone possono iscriversi a eventi ricorrenti", ppi = "Connettiti e partecipa", mpi = "Non può essere utilizzato con i tipi di evento a pagamento", fpi = "Le riunioni immediate non sono ancora disponibili con gli eventi ricorrenti e le app di pagamento", gpi = "Sperimentale: gli eventi Riunione immediata al momento sono in fase di sperimentazione.", hpi = "Inizio", vpi = "Disabilita Ospiti", bpi = "Disabilita l'aggiunta di ulteriori ospiti durante la prenotazione.", ypi = "Genera URL privato", $pi = "Abilita URL privato", wpi = "Link privato", kpi = "Il tuo link privato verrà rigenerato dopo ogni utilizzo", Spi = "Copia link privato", xpi = "Copia link privato nell'evento", Epi = "Genera un URL privato da condividere senza mostrare il tuo nome utente {{appName}}", Tpi = "Link Privati", Api = "Genera URL privati senza esporre il nome utente, con limiti di scadenza e utilizzo configurabili", Cpi = "Aggiungi nuovo link", zpi = "Link privato copiato", Opi = "Gli inviti possono programmare", Ppi = "Range di date", Ipi = "giorni del calendario", Rpi = "giorni lavorativi", Npi = "Imposta un indirizzo o un luogo", Dpi = "Imposta un collegamento alla riunione", Mpi = "Non può essere attivato. Può essere sbloccato solo per i tipi di eventi figli", Lpi = "{{appName}} chiederà al tuo invitato di inserire un numero di telefono prima della pianificazione.", qpi = "{{appName}} fornirà un Google Meet location.", jpi = "{{appName}} fornirà un URL di riunione Zoom.", Fpi = "{{appName}} fornirà un URL di riunione Tandem.", Vpi = "{{appName}} fornirà un URL di riunione Daily video.", Bpi = "{{appName}} fornirà un URL di riunione Jitsi Meet.", Upi = "{{appName}} fornirà un URL di riunione Huddle01 video.", Wpi = "{{appName}} fornirà un URL per la riunione MS Teams. NOTA: È NECESSARIO POSSEDERE UN ACCOUNT LAVORATIVO O SCOLASTICO", Gpi = "Richiedi Pagamento", Hpi = "Indica un nome", Kpi = "commissione per transazione", Ypi = "Il tuo team è stato aggiornato con successo.", Zpi = "Nascondi tipo evento", Qpi = "Aggiungi un luogo", Jpi = "nel futuro", Xpi = "Quando prenotato con meno di <0></0> di preavviso", emi = "All'interno di un intervallo di date", tmi = "Indefinitamente nel futuro", nmi = "Aggiungi un nuovo campo di input personalizzato", omi = "Chat Veloce", rmi = "Aggiungi un nuovo tipo di evento del team", imi = "Aggiungi un nuovo tipo di evento", ami = "Crea un nuovo tipo di evento per le persone con cui prenotare.", smi = "Durata", cmi = "Preavviso minimo", lmi = "Sposta orari di inizio", dmi = "Sposta le fasce orarie mostrate alle persone che prenotano di un numero specificato di minuti", umi = "Sposta di", _mi = "ad es., le persone che prenotano vedranno le fasce orarie alle {{ adjustedTime }} anziché alle {{ originalTime }}", pmi = "Intervalli di fascia oraria", mmi = "Usa durata evento (impostazione predefinita)", fmi = "Eliminare il tipo di evento?", gmi = "Eliminare il tipo di evento gestito?", hmi = "Gli utenti con cui hai condiviso il link non saranno più in grado di usarlo per prenotare.", vmi = "I membri assegnati a questo tipo di evento avranno anche i loro tipi di evento eliminati.", bmi = "Chiunque con cui abbiano condiviso il loro link non sarà più in grado di prenotare utilizzandolo.", ymi = "Sì, elimina", $mi = "Elimina account", wmi = "Sì, elimina account", kmi = "Chiunque abbia il link del tuo account non potrà più utilizzarlo per prenotare e le preferenze che hai salvato andranno perse.", Smi = "Integrazioni", xmi = "App", Emi = "Qui puoi trovare l'elenco delle tue app", Tmi = "Elenco delle app", Ami = "App {{category}}", Cmi = "App Store", zmi = "Collegare persone, tecnologia e luogo di lavoro.", Omi = "Connetti la tua app di videoconferenza", Pmi = "Impostazioni", Imi = "Il tipo di evento è stato spostato con successo", Rmi = "Prossimo passo", Nmi = "Salta passo", Dmi = "Passo precedente", Mmi = "Installa", Lmi = "Inizia la prova gratuita", qmi = "Installato", jmi = "{{count}} installazione attiva", Fmi = "{{count}} installazioni attive", Vmi = "Installato a livello globale", Bmi = "App installata correttamente", Umi = "Impossibile installare l'app", Wmi = "Disconnetti", Gmi = "Incorpora il tuo calendario nella tua pagina web", Hmi = "Collega le tue app preferite.", Kmi = "Automazione", Ymi = "Configura come i tipi di eventi dovrebbero interagire con i tuoi calendari.", Zmi = "Attiva/disattiva i calendari in cui desideri controllare i conflitti per evitare doppie prenotazioni.", Qmi = "Collega calendario aggiuntivo", Jmi = "Calendario aggiornato correttamente", Xmi = "Controlla qui", efi = "Conferenze", tfi = "Calendario", nfi = "Pagamenti", ofi = "Non installato", rfi = "Le password non corrispondono.", ifi = "Questo campo è richiesto.", afi = "Stato", sfi = "Visualizza la disponibilità degli utenti", cfi = "L'utente deve accettare l'invito per visualizzare la disponibilità", lfi = "Segnalati assente", dfi = 'Disabilita lo stato "assente"', ufi = `Errore durante l'aggiornamento dello stato "assente"`, _fi = "Questo utente è attualmente assente.", pfi = "La persona che stai cercando di prenotare si è segnalata assente, quindi non accetta nuove prenotazioni.", mfi = "Incontra persone con gli stessi token", ffi = "Prenota e accetta prenotazioni solo con persone che condividono gli stessi token, DAO o NFT.", gfi = "Il tuo account è stato creato utilizzando un provider di identità.", hfi = "Il tuo account è gestito da {{provider}}", vfi = "Per modificare la tua email o la tua password, per abilitare l'autenticazione a due fattori e altro ancora, consulta le impostazioni del tuo account {{provider}}.", bfi = "Il tuo account è gestito da un provider di identità diverso. Prova ad accedere con {{provider}}.", yfi = "Errore durante la creazione di un nuovo utente. Riprova.", $fi = "Accedi con Google", wfi = "Accedi con SAML", kfi = "Accedi con SAML/OIDC", Sfi = "Continua con l'email", xfi = "Continua con Google", Efi = "Ultimo utilizzo", Tfi = "Dovrai generare un token di accesso con il tuo vecchio strumento di pianificazione.", Afi = "Importa da", Cfi = "Token di accesso", zfi = "Roadmap", Ofi = "Categorie in evidenza", Pfi = "Flag delle funzionalità", Ifi = "Qui puoi attivare o disattivare le funzionalità della tua istanza Cal.com.", Rfi = "Categorie popolari", Nfi = "{{count}} App", Dfi = "{{count}} app", Mfi = "App di tendenza", Lfi = "Più popolari", qfi = "App installate", jfi = "Gratuito", Ffi = "Nessuna app {{category}}", Vfi = "Tutte le app", Bfi = "Aggiungi un'app di calendario per controllare i conflitti ed evitare doppie prenotazioni", Ufi = "Prova ad aggiungere un'app di conferenza per effettuare videochiamate con i clienti", Wfi = "Aggiungi un'app di pagamento per facilitare le transazioni con i clienti", Gfi = "Aggiungi un'app di analisi per le tue pagine di prenotazione", Hfi = "Aggiungi un'app di automazione da usare", Kfi = "Aggiungi qualsiasi altra app per fare altre attività", Yfi = "Aggiungi un'app di messaggistica per impostare notifiche e promemoria personalizzati", Zfi = "Aggiungi un'app CRM per tenere traccia delle persone che hai incontrato", Qfi = "Imposta uno o più calendari per controllare i conflitti ed evitare doppie prenotazioni.", Jfi = "Configura quale servizio di elaborazione dei pagamenti usare per addebitare i clienti.", Xfi = "Imposta quali app di analisi usare per le tue pagine di prenotazione", egi = "Tutte le app installate appartenenti ad altre categorie.", tgi = "Scegli quali app di conferenza utilizzare", ngi = "Imposta quali app di automazione usare", ogi = "Scegli le app di messaggistica da usare per impostare notifiche e promemoria personalizzati", rgi = "Scegli quali app CRM utilizzare per tenere traccia delle persone che hai incontrato", igi = "Analisi", agi = "Nessuna app installata", sgi = "Le app consentono di ottimizzare il flusso di lavoro e di migliorare significativamente la pianificazione.", cgi = "Esplora l'App Store", lgi = "Gestisci le app installate o modifica le impostazioni", dgi = "Sfoglia app", ugi = "Funzionalità", _gi = "Autorizzazioni", pgi = "Termini e informativa privacy", mgi = "Pubblicato da {{author}}", fgi = "Abbonati", ggi = "Acquista", hgi = "Installa app", vgi = "Categorie", bgi = "Prezzi", ygi = "Ulteriori informazioni", $gi = "Prova ora", wgi = "Informativa sulla privacy", kgi = "Termini del servizio", Sgi = "Rimuovi", xgi = "Aggiungi", Egi = "{{count}} installate", Tgi = "Verifica Wallet", Agi = "Crea eventi su:", Cgi = "Questa è una funzionalità commerciale", zgi = "Puoi testare questa funzione localmente ma non in ambiente di produzione.", Ogi = "Per acquistare una licenza commerciale, contatta il nostro team di vendita. Se hai già una chiave di licenza, contatta support@cal.com per assistenza.", Pgi = "Licenza mancante", Igi = "Prossimi Passi", Rgi = "Acquista una licenza commerciale", Ngi = "Il piano infrastrutturale è basato sull'utilizzo e ha sconti rivolti alle startup.", Dgi = "Crea un account tramite Prisma Studio", Mgi = "Scopri come configurare il tuo primo utente", Lgi = "Contatta reparto commerciale", qgi = "Errore 404", jgi = "Imposta come predefinito", Fgi = "Nuovo programma", Vgi = "Aggiungi un nuovo programma", Bgi = "Aggiungi un nuovo calendario", Ugi = "Imposta dove aggiungere nuovi eventi quando c'è una prenotazione.", Wgi = "Elimina programma", Ggi = "L'eliminazione di una pianificazione comporterà la sua rimozione da tutti i tipi di eventi. L'azione non può essere annullata.", Hgi = "Programma {{scheduleName}} creato", Kgi = "Disponibilità aggiornata con successo", Ygi = "Programma eliminato", Zgi = "Orario lavorativo", Qgi = "Crea un programma di disponibilità", Jgi = "La creazione di programmi di disponibilità consente di gestire la disponibilità per i diversi tipi di eventi. I programmi possono essere applicati a uno o più tipi di evento.", Xgi = "Richiede il possesso di un token appartenente al seguente indirizzo:", ehi = "Paolo Rossi", thi = "Formato dell'orario", nhi = "Reindirizza su prenotazione ", ohi = 'Verrai reindirizzato a {{ url }} tra $t(second, {"count": {{seconds}} }).', rhi = "https://example.com/redirect-to-my-success-page", ihi = "Dopo una prenotazione, reindirizza a un URL personalizzato", ahi = "Duplica", shi = "Imposta posti", chi = "Indica i posti disponibili (ciò disabiliterà le prenotazioni ospite e le prenotazioni opt-in).", lhi = "Posto disponibile", dhi = "Posti disponibili", uhi = "Quasi tutti i posti sono al completo", _hi = "I posti si esauriscono in fretta", phi = "Numero di posti per prenotazione", mhi = "Imposta la finestra di accesso alla riunione (secondi): Il periodo di tempo in secondi entro il quale l'host può accedere e avviare la riunione. Dopo questo periodo, l'URL di accesso alla riunione scadrà.", fhi = "Immettere il numero di posti", ghi = "Puoi gestire i tuoi programmi dalla pagina Disponibilità.", hhi = "Non ci sono più posti disponibili", vhi = "Chiavi API", bhi = "Chiave API", yhi = "Prova chiave API", $hi = "Test superato!", whi = "Prova non superata", khi = "Fornisci chiave API", Shi = "Le chiavi API consentono di effettuare chiamate API per il proprio account.", xhi = "Crea invece un marketplace o una piattaforma.", Ehi = "Genera chiavi API da usare per accedere al tuo account.", Thi = "Crea una chiave API", Ahi = "Assegna un nome a questa chiave", Chi = "Ad es. Sviluppo", zhi = "Chiave API senza nome", Ohi = "Questa chiave API non ha data di scadenza", Phi = "Modifica chiave API", Ihi = "Chiave API creata", Rhi = "Chiave API aggiornata", Nhi = "Crea", Dhi = "Salva questa chiave API in un posto sicuro.", Mhi = "Una volta chiusa questa finestra non sarà più possibila visualizzarla.", Lhi = "Copia negli Appunti", qhi = "Abilitato dopo l'aggiornamento", jhi = "Il link privato funzionerà dopo il salvataggio", Fhi = "Revoca questa chiave API", Vhi = "Disabilita riprogrammazione", Bhi = "Gli ospiti non possono più riprogrammare l'evento tramite invito di calendario o email", Uhi = "Consenti la prenotazione tramite link di riprogrammazione", Whi = "Quando abilitato, gli utenti potranno creare una nuova prenotazione quando tentano di riprogrammare una prenotazione annullata", Ghi = "Disabilita cancellazione", Hhi = "Gli ospiti non possono più cancellare l'evento tramite invito di calendario o email", Khi = "Revoca chiave API", Yhi = "Chiave API copiata", Zhi = "La chiave API scadrà il", Qhi = "Rimuovere definitivamente questa chiave API dal tuo account?", Jhi = "Copia", Xhi = "Data di scadenza", evi = "Scaduta", tvi = "Nessuna scadenza", nvi = "Scade", ovi = "Richiesta di riprogrammare la prenotazione", rvi = "Motivo della riprogrammazione", ivi = "Prenota un nuovo orario", avi = "Richiesta di riprogrammazione inviata", svi = "Questa operazione annullerà la riunione programmata, avviserà il creatore del programma e gli chiederà di scegliere una nuova ora.", cvi = "Motivo della richiesta di riprogrammazione", lvi = "Richiedi riprogrammazione ", dvi = "Modifica prenotazione", uvi = "Riprogramma prenotazione", _vi = "Orario precedente", pvi = "Aggiungi GIF per la pagina di conferma", mvi = "Cerca", fvi = "Accedi con altra identità", gvi = "Accesso con altra identità", hvi = "Consente al nostro team di supporto di effettuare l'accesso temporaneo a tuo nome per risolvere rapidamente gli eventuali problemi da te segnalati.", vvi = "Consente ai proprietari/amministratori del tuo team di accedere temporaneamente con il tuo nome.", bvi = "Gratuito per le singole pesone. Piani collettivi per le funzionalità di collaborazione.", yvi = "Rendi l'organizzazione privata", $vi = "Quando questa opzione è attivata, i membri della tua organizzazione non possono vedere gli altri membri.", wvi = "Rendi il team privato", kvi = "Quando questa opzione è attivata, i membri del tuo team non potranno vedere gli altri membri del team.", Svi = "Non è possibile vedere tutti i membri di un team privato.", xvi = "Non puoi vedere i team di un'organizzazione privata.", Evi = "Consenti durate multiple", Tvi = "Ogni utilizzo di questa funzionalità viene controllato.", Avi = `Accesso con l'identità dell'utente "{{user}}".`, Cvi = "Fai clic qui per interrompere", zvi = "Aggiornato: è cambiato il luogo del tuo evento", Ovi = "Aggiunti - Nuovi ospiti aggiunti al tuo evento", Pvi = "Luogo cambiato: {{eventType}} con {{name}} il {{date}}", Ivi = "Ospiti aggiunti: {{eventType}} con {{name}} il {{date}}", Rvi = "Luogo corrente", Nvi = "Nuovo luogo", Dvi = "Sessione", Mvi = "Controlla la sessione del tuo account", Lvi = "Timeout sessione dopo", qvi = "Timeout sessione", jvi = "Invalida la sessione dopo un determinato periodo di tempo.", Fvi = "Nessun luogo definito", Vvi = "Imposta luogo", Bvi = "Aggiorna luogo", Uvi = "Luogo aggiornato", Wvi = "Aggiornamento della posizione fallito", Gvi = "Ospiti aggiunti", Hvi = "Impossibile aggiungere ospiti", Kvi = "Questo non sembra un indirizzo email valido", Yvi = "Le email devono essere uniche e valide", Zvi = "Questo non sembra un URL", Qvi = "Inserisci questo codice nel tuo HTML nel punto in cui vuoi che appaia il widget {{appName}}.", Jvi = "Crea o aggiorna un componente React esistente come mostrato di seguito.", Xvi = "Copia codice", ebi = "Codice copiato!", tbi = "Come desideri aggiungere {{appName}} al tuo sito?", nbi = "Scegli uno dei seguenti modi per inserire {{appName}} nel tuo sito.", obi = "Configurare l'integrazione con Zapier", rbi = "Configurare l'integrazione con Make", ibi = "Genera una chiave API", abi = "Genera una chiave API da usare con {{appName}} su", sbi = "La tua chiave API univoca", cbi = "Copia questa chiave API e conservala in un posto sicuro. Se perdi la chiave, dovrai generarne una nuova.", lbi = "<0>Accedi al tuo account Zapier e crea un nuovo Zap.</0><1>Seleziona Cal.com come app trigger. Scegli l'evento trigger.</1><2>Seleziona il tuo account e immetti la tua chiave API univoca.</2><3>Fai una prova del tuo trigger.</3><4>Fatto!</4>", dbi = "Vai su <0>Make Invite Link</0> e installa l'app Cal.com.", ubi = "Accedi al tuo account Make e crea un nuovo Scenario.", _bi = "Seleziona Cal.com come app Trigger. Scegli anche un evento Trigger.", pbi = "Scegli il tuo account e inserisci la tua Chiave API Unica.", mbi = "Testa il tuo Trigger.", fbi = "Hai finito!", gbi = "Prima è necessario installare l'app Zapier, disponibile nell'App Store.", hbi = "Prima è necessario installare l'applicazione Make, disponibile nell'App Store.", vbi = "Installazione app", bbi = "App non installata", ybi = "Spiacenti, questa app non è installata sul tuo account. Visita il nostro app store per esplorare e scoprire questa e altre fantastiche app.", $bi = "Connetti al server Apple", wbi = "URL del calendario", kbi = "Genera una password specifica dell'app da usare con {{appName}} presso", Sbi = "Impossibile aggiungere questo account Apple Calendar. Assicurati di usare una password specifica per l'app e non la password del tuo account.", xbi = "Le tue credenziali verranno memorizzate e crittografate.", Ebi = "Sarà memorizzata e crittografata.", Tbi = "Vai all'App Store", Abi = "Prova a riconnettere il calendario con tutti i permessi necessari", Cbi = "Imposta un numero di telefono per la riunione", zbi = "Non ci sono intervalli orari occupati", Obi = "Mostra nella pagina di prenotazione", Pbi = "Il luogo sarà visibile prima della conferma della prenotazione", Ibi = "Aggiungi GIF", Rbi = "Cerca su Giphy", Nbi = "Aggiungi link da Giphy", Dbi = "Aggiungere una GIF alla pagina di conferma", Mbi = "Trova una GIF per ravvivare la pagina di conferma", Lbi = "Condividi feedback", qbi = "Risorse", jbi = "Documentazione di supporto", Fbi = "Documentazione sviluppatore", Vbi = "Contattaci", Bbi = "Contatta il supporto", Ubi = "Assistenza Premium", Wbi = "Supporto della community", Gbi = "Feedback", Hbi = "Grazie per il tuo feedback!", Kbi = "Errore durante l'invio del feedback", Ybi = "Condividi qui i tuoi commenti:", Zbi = "Dettagli della prenotazione", Qbi = "o", Jbi = "Non importa", Xbi = "Vai a: ", eyi = "Link di invito Zapier", tyi = "Una volta confermato l'evento, verrà creato un URL di riunione.", nyi = "Visualizza dinamicamente il nome del partecipante oppure il tuo nome, se visualizzato dal partecipante", oyi = "Luogo dell'evento", ryi = "Motivo della riprogrammazione (facoltativo)", iyi = "Fai sapere agli alti perché hai bisogno di riprogrammare", ayi = "Questo evento è stato cancellato", syi = "Abbiamo inviato un'e-mail di notifica a te e agli altri partecipanti.", cyi = "Questo input verrà mostrato durante la prenotazione di questo evento", lyi = "L'URL della riunione è riportato nell'e-mail di conferma", dyi = "L'URL deve iniziare con http:// o https://", uyi = "Verrà fornito il numero di telefono", _yi = "prima dell'inizio dell'evento", pyi = "quando l'evento viene cancellato", myi = "Dopo che gli host non si sono uniti alla videochiamata", fyi = "Dopo che gli ospiti non si sono uniti alla videochiamata", gyi = "Partecipa alla videochiamata", hyi = "Accedi a Cal.com", vyi = "Accedi a Cal.com", byi = "Tieni traccia dei tuoi incontri, ricevi notifiche e gestisci il tuo calendario in modo più efficace.", yyi = "Tieni traccia dei tuoi incontri e gestisci il tuo calendario in modo più efficace", $yi = "Impossibile partecipare alla chiamata. Riprova.", wyi = "Scegli come vuoi partecipare a questa chiamata", kyi = "Scegli come desideri apparire nella chiamata", Syi = "quando viene prenotato un nuovo evento", xyi = "invia e-mail all'organizzatore", Eyi = "invia e-mail ai partecipanti", Tyi = "Invia SMS al partecipante", Ayi = "invia SMS a un numero specifico", Cyi = "Invia facilmente dei promemoria di riunioni via SMS ai partecipanti", zyi = "invia un messaggio Whatsapp a un numero specifico", Oyi = "invia un messaggio Whatsapp al partecipante", Pyi = "Flussi di lavoro", Iyi = "Nuovo flusso di lavoro", Ryi = "Come vorresti iniziare?", Nyi = "Aggiungi un nuovo flusso di lavoro", Dyi = "quando un evento viene riprogrammato", Myi = "Attivatore", Lyi = "Attivatori", qyi = "Azione", jyi = "Crea flussi di lavoro per automatizzare notifiche e promemoria", Fyi = "Nome flusso di lavoro", Vyi = "Flusso di lavoro personalizzato", Byi = "{{workflowName}} creato correttamente", Uyi = "Eliminare questo flusso di lavoro?", Wyi = "Elimina flusso di lavoro", Gyi = "Sì, elimina flusso di lavoro", Hyi = "Flusso di lavoro eliminato", Kyi = "Quanto tempo prima dell'inizio dell'evento?", Yyi = "giorni", Zyi = "ore", Qyi = "minuti", Jyi = "m", Xyi = "h", e$i = "Crea il tuo primo flusso di lavoro", t$i = "I flussi di lavoro consentono di automatizzare l'invio di promemoria e notifiche.", n$i = "Data attivazione", o$i = "Flusso di lavoro {{workflowName}} aggiornato correttamente", r$i = "Questo è un nome utente standard e l'aggiornamento ti porterà alla fatturazione per il downgrade.", i$i = "Questo è un nome utente premium, ottieni il tuo per {{price}}", a$i = "Corrente", s$i = "premium", c$i = "standard", l$i = "Conferma modifica nome utente", d$i = "Poiché stai passando da un nome utente standard a un nome utente premium, sarai portato alla pagina di pagamento per effettuare l'upgrade.", u$i = "Poiché stai passando da un nome utente premium a un nome utente standard, sarai portato alla pagina di pagamento per effettuare il downgrade.", _$i = "Vai alla fatturazione", p$i = "Richiedi pagamento per le prenotazioni (0,5% + 0,10 € di commissione per transazione)", m$i = "Il periodo di prova è scaduto", f$i = "Rimuovi app", g$i = "Sì, rimuovi l'app", h$i = "Rimuovere questa app?", v$i = "App rimossa correttamente", b$i = "Errore durante la rimozione dell'app", y$i = "Conferenza Web", $$i = "Chiamata web", w$i = "Inizia chiamata web", k$i = "Termina chiamata", S$i = "Prova il tuo agente con una chiamata web senza richiedere un numero di telefono", x$i = "Chiamata telefonica", E$i = "Connessione all'agente in corso...", T$i = "Chiamata attiva", A$i = "Chiamata terminata", C$i = "Errore nella chiamata", z$i = "Pronto per iniziare la chiamata", O$i = "Impossibile avviare la chiamata web. Riprova.", P$i = "La chiamata ha riscontrato un errore. Riprova.", I$i = "Impossibile inizializzare la chiamata web. Assicurati che i permessi del microfono siano concessi.", R$i = "Inizia una chiamata per vedere la conversazione", N$i = "In attesa della conversazione...", D$i = "Agente IA", M$i = "In diretta", L$i = "Connessione in corso...", q$i = "Richiede conferma", j$i = "Richiede conferma se si prenota con un preavviso di < {{time}} $t({{unit}}_timeUnit)", F$i = "Può richiedere conferma", V$i = "{{count}} tipo di evento", B$i = "{{count}} tipi di evento", U$i = "{{count}} team", W$i = "{{count}} team", G$i = "Aggiungi azione", H$i = "Imposta link Whereby", K$i = "Inserisci un link Whereby valido", Y$i = "Imposta link Around.Co", Z$i = "Inserisci un link Around.Co valido", Q$i = "Imposta link Riverside", J$i = "Inserisci un link Riverside valido", X$i = "Inserire un link Ping.gg valido", ewi = "Connetti al server Exchange 2013", twi = "Connetti al server Exchange 2016", nwi = "Modello personalizzato", owi = "Testo email", rwi = "Messaggio di testo", iwi = "Hai un problema specifico?", awi = "sfoglia i nostri documenti", swi = "Scegli un modello", cwi = "Personalizzato", lwi = "Promemoria", dwi = "Riprogrammato", uwi = "Riprogrammato da", _wi = "Prenotazione originale", pwi = "Completato", mwi = "Valutazione", fwi = "Promemoria: {{eventType}} con {{name}} il {{date}}", gwi = "Non verrà attivato per le prenotazioni già esistenti, in quanto agli utenti verrà chiesto di specificare il numero di telefono al momento della prenotazione dell'evento.", hwi = "{{count}} minuto", vwi = "{{count}}m", bwi = "{{count}} minuti", ywi = "{{count}} ora", $wi = "{{count}}h", wwi = "{{count}} ore", kwi = "Input non valido", Swi = "Non è stato possibile aggiungere il link alla riunione {{location}} al tuo evento programmato. Contatta i tuoi invitati o aggiorna l'evento nel calendario per aggiungere i dettagli. Puoi <0>modificare la posizione sul tipo di evento</0> o provare a <1>rimuovere e aggiungere nuovamente l'app.</1>", xwi = "Non è stato possibile aggiornare il tuo <1>{{calendar}}</1>. <2> Controlla le impostazioni del tuo calendario oppure rimuovi il calendario e aggiungilo nuovamente </2>", Ewi = "Nome del partecipante", Twi = "Nome completo della persona che prenota", Awi = "Integrazione non funzionante", Cwi = "Si è verificato un problema durante l'aggiunta di un collegamento video", zwi = "Si è verificato un problema durante l'aggiornamento del calendario", Owi = "Attivo per {{count}} tipo di evento", Pwi = "Attivo per {{count}} tipi di evento", Iwi = "Attivo su {{count}} team", Rwi = "Attivo su {{count}} team", Nwi = "Attivo su tutti i tipi di eventi", Dwi = "Attivo su tutti i team", Mwi = "Non ci sono tipi di evento attivi", Lwi = "Nessun team attivo", qwi = "Nuovo partecipante {{name}} a {{eventType}} il {{date}}", jwi = "Qualcuno ha aggiunto se stesso a un evento", Fwi = "Variabile", Vwi = "Nome evento", Bwi = "Partecipante", Uwi = "Data evento", Wwi = "Ora evento", Gwi = "Nome organizzatore", Hwi = "Per poter utilizzare questa funzionalità, è necessario passare a un account Pro.", Kwi = "Numero di telefono non valido", Ywi = "URL non valido per {{label}}. URL di esempio: {{sampleUrl}}", Zwi = "Esplora", Qwi = "Apri", Jwi = "Chiudi", Xwi = "Effettua l'upgrade", e0i = "Acquista numero US per {{priceInDollars}}$/mese", t0i = "Effettua l'upgrade per accedere alle registrazioni", n0i = "Le registrazioni sono disponibili solo con il piano team. Effettua l'upgrade per registrare le tue chiamate", o0i = "Passa a Enterprise per generare un numero di telefono con operatore IA, in grado di contattare gli ospiti per pianificare le chiamate", r0i = "Le registrazioni sono disponibili con il piano team", i0i = "Questa è una funzionalità del piano Team. Effettua l'upgrade al piano Team per vedere la disponibilità del tuo team.", a0i = "Questa è una funzionalità del piano Team. Effettua l'upgrade al piano Team per automatizzare le notifiche e i promemoria degli eventi con i flussi di lavoro.", s0i = "Mostra nel profilo", c0i = "Incorpora", l0i = "Nuovo nome utente", d0i = "Nome utente corrente", u0i = "Esempio 1", _0i = "Esempio 2", p0i = "Identificatore della domanda posta in fase di prenotazione", m0i = "Dimensione dell'azienda", f0i = "Per cosa ti serve assistenza?", g0i = "Formato variabile", h0i = "URL dell'abbonato Webhook già definito", v0i = "Ignora tutti i caratteri speciali dell'etichetta del campo di input aggiuntivo (usa solo lettere e numeri), usa solo lettere maiuscole e sostituisci gli spazi con il trattino basso.", b0i = "Come posso utilizzare le domande poste nella pagina di prenotazione come variabili?", y0i = "Scarica app desktop", $0i = "Imposta link di Ping", w0i = "Limite superato", k0i = "Quando succede qualcosa", S0i = "Viene eseguita un'azione", x0i = "Verifica azione", E0i = "Notifica inviata", T0i = "Nessun input", A0i = "Verifica azione del flusso di lavoro", C0i = "Invia SMS", z0i = "Inviare un SMS a {{number}}?", O0i = "Nessun calendario predefinito collegato", P0i = "Puoi collegare il tuo calendario <1>qui</1>.", I0i = "Calendario predefinito", R0i = "Nascondi nel profilo", N0i = "Impostazione evento", D0i = "Nessuna disponibilità trovata nel programma", M0i = "Limiti", L0i = "Con quale frequenza è possibile fare una prenotazione", q0i = "Impostazioni calendario e altro...", j0i = "Avanzate", F0i = "Configura i pagamenti per l'evento", V0i = "Impostazione evento: In caso di più durate è richiesta almeno 1 opzione.", B0i = "Impostazione evento: Selezionare una durata predefinita valida.", U0i = "I limiti per le prenotazioni devono essere specificati in ordine crescente [giorno,settimana,mese,anno]", W0i = "I limiti di durata devono essere specificati in ordine crescente [giorno, settimana, mese, anno]", G0i = "Seleziona il calendario al quale aggiungere prenotazioni", H0i = "Nome evento personalizzato", K0i = "Crea nomi di eventi personalizzati da visualizzare nell'evento del calendario", Y0i = "Codice di autenticazione a due fattori errato", Z0i = "A quale tipo di evento si applicherà?", Q0i = "Applica a tutti, inclusi i tipi di eventi futuri", J0i = "Applica a tutti i tipi di eventi di team e utenti", X0i = "A quale team si applica?", eki = "I flussi di lavoro attivano una semplice automazione per inviare notifiche e promemoria che ti consentono di creare processi per i tuoi eventi.", tki = "Questa è un'impostazione interna e non influenzerà il modo in cui gli orari sono visualizzati nelle pagine di prenotazione pubbliche a te e a chiunque faccia una prenotazione.", nki = "Crea un flusso di lavoro", oki = "Esegui questa operazione", rki = "Disattiva", iki = "Attiva", aki = "Le prenotazioni annullate non possono essere riprogrammate", ski = "Impostazioni aggiornate correttamente", cki = "Errore durante l'aggiornamento delle impostazioni", lki = "Il mio URL personale di {{appName}}", dki = "Scrivi qualcosa di te. Queste informazioni appariranno nella tua pagina personale.", uki = "Completa la configurazione e inizia", _ki = "Questo utente non ha ancora aggiunto una biografia.", pki = "Biografia", mki = "Elimina account", fki = "Eliminare il tuo account {{appName}}?", gki = "Elimina il mio account", hki = "Inizio della settimana", vki = "Registrazioni", bki = "Registrazione", yki = "Buona pianificazione", $ki = "Seleziona su quali calendari desideri controllare i conflitti per evitare doppie prenotazioni.", wki = "Controlla conflitti", kki = "Visualizza registrazioni", Ski = "Controlla le registrazioni", xki = "Aggiungendo eventi a", Eki = "Segui le preferenze di sistema", Tki = "Colori del marchio personalizzati", Aki = "Personalizza la tua pagina di prenotazione con i colori del tuo marchio.", Cki = "Pro", zki = "Rimuove tutte le scritte con il marchio {{appName}}, ad es., 'Powered by {{appName}}.'", Oki = "Riunione immediata con {{name}}", Pki = "Immagine del profilo", Iki = "Carica", Rki = "Aggiungi foto del profilo", Nki = "Indirizzo token", Dki = "Blockchain", Mki = "Vecchia password", Lki = "La tua nuova password super sicura", qki = "Errore durante l'aggiornamento della password", jki = "Autenticazione a due fattori", Fki = "Imposta una pianificazione ricorrente", Vki = "oggi", Bki = "Aspetto", Uki = "Il mio account", Wki = "Generale", Gki = "Calendari", Hki = "Fatture", Kki = "Integrazioni", Yki = "Accesso con altra identità", Zki = "Impostazioni per gestire gli accessi con altra identità", Qki = "Impersonificazioni recenti", Jki = "Impersonificazione rapida", Xki = "Nessuna impersonificazione recente", e1i = "Utenti", t1i = "Utente", n1i = "Gestisci le impostazioni del tuo profilo {{appName}}", o1i = "Qui è possibile trovare l'elenco di tutti gli utenti", r1i = "Elenco degli utenti", i1i = "Gestisci le impostazioni di lingua e fuso orario", a1i = "Configura come i tipi di eventi devono interagire con i tuoi calendari", s1i = "Gestisci le impostazioni di aspetto delle tue prenotazioni", c1i = "Aggiungi le tue app di videoconferenza preferite per le tue riunioni", l1i = "Aggiungi app di videoconferenza", d1i = "Gestisci le impostazioni relative alle password del tuo account", u1i = "Imposta l'autenticazione a due fattori", _1i = "Abbiamo bisogno di alcune semplici informazioni per completare la configurazione del tuo profilo.", p1i = "Salta", m1i = "Più tardi", f1i = "Definisci gli intervalli di tempo in cui sei disponibile", g1i = "È possibile personalizzare queste impostazioni in un secondo tempo nella pagina della disponibilità.", h1i = "Connetti prima un calendario", v1i = "Completa il tuo profilo", b1i = "È possibile aggiungere altri calendari dall'App store", y1i = "Connetti app di conferenza", $1i = "Connetti app di calendario", w1i = "Connetti app di pagamento", k1i = "Connetti app di automazione", S1i = "Connetti app di analisi", x1i = "Connetti altre app", E1i = "Connetti app di messaggistica", T1i = "Connetti app CRM", A1i = "Passo {{currentStep}} di {{maxSteps}}", C1i = "Aggiungi variabile", z1i = "Numero di telefono personalizzato", O1i = "Modello di messaggio", P1i = "Oggetto e-mail", I1i = "Aggiungi variabili di testo dinamico", R1i = "Nome del tipo di evento", N1i = "Data dell'evento", D1i = "La durata dell'evento", M1i = "Ora di inizio dell'evento", L1i = "EventType non trovato", q1i = "Numero da chiamare", j1i = "Il numero di telefono dell'utente che stai chiamando", F1i = "Luogo", V1i = "Luogo dell'evento", B1i = "Note aggiuntive", U1i = "Note aggiuntive sulla prenotazione", W1i = "Nome del partecipante", G1i = "Nome dell'organizzatore", H1i = "A", K1i = "Il flusso di lavoro {{workflowName}} è stato impostato come {{offOn}}", Y1i = "Scarica risposte", Z1i = "Scarica tutte le risposte al tuo modulo in formato CSV.", Q1i = "Visualizza risposte", J1i = "Scarica", X1i = "Download in corso", e2i = "Scarica registrazione", t2i = "Le trascrizioni sono attivate", n2i = "Le trascrizioni non sono attive", o2i = "Scarica trascrizione", r2i = "Trascrizione", i2i = "La registrazione della tua recente chiamata su {{appName}} è pronta per il download", a2i = "La trascrizione dalla tua recente chiamata su {{appName}} è pronta per essere scaricata. I link sono validi solo per 1 ora", s2i = "Puoi anche scaricare la trascrizione dagli allegati", c2i = "Nota: Il link per il download è valido solo per 12 ore. Puoi generare un nuovo link di download seguendo le istruzioni <1>qui</1>.", l2i = "Nota: il link per il download è valido solo per 12 ore. Puoi generare un nuovo link per il download seguendo le istruzioni.", d2i = "Crea il tuo primo modulo", u2i = "I Moduli di instradamento consentono di porre domande qualificanti agli utenti per indirizzarli a persone o eventi pertinenti.", _2i = "Crea il tuo primo Webhook", p2i = "I Webhook consentono di ricevere in tempo reale le informazioni sulle riunioni quando succede qualcosa su {{appName}}.", m2i = "Per un massimo di", f2i = "evento", g2i = "eventi", h2i = "Gestisci le impostazioni del profilo del tuo team", v2i = "Gestisci le impostazioni del profilo della tua organizzazione", b2i = "Utenti nel gruppo", y2i = "Gestisci gli amministratori e i membri della tua organizzazione", $2i = "URL del team", w2i = "Membri del team", k2i = "Altro", S2i = "Flussi di lavoro Cal.ai", x2i = "e altri {{count}}", E2i = "Consideriamo l'applicazione mobile un'estensione dell'applicazione web. Se stai eseguendo delle azioni complesse, ti invitiamo a fare riferimento all'applicazione web.", T2i = "Invia al partecipante un promemoria via SMS 24 ore prima dell'inizio dell'evento", A2i = "Invia al partecipante un SMS personalizzato se l'evento viene riprogrammato", C2i = "Invia all'organizzatore un'e-mail personalizzata quando viene prenotato un nuovo evento", z2i = "Invia al partecipante un promemoria via e-mail un'ora prima dell'inizio dell'evento", O2i = "Invia all'organizzatore un'e-mail personalizzata se l'evento viene riprogrammato", P2i = "Invia all'organizzatore un SMS personalizzato quando viene prenotato un nuovo evento", I2i = "Invia promemoria SMS", R2i = "24 ore prima dell'inizio dell'evento", N2i = "Segui chi non si presenta", D2i = "30 minuti dopo la fine dell'evento", M2i = "Ricorda ai partecipanti di portare un documento d'identità", L2i = "1 giorno prima dell'inizio dell'evento", q2i = "Promemoria via email", j2i = "1 ora prima dell'inizio dell'evento", F2i = "Promemoria SMS personalizzato", V2i = "Quando l'evento viene programmato", B2i = "Promemoria email personalizzato", U2i = "L'evento viene riprogrammato per l'organizzatore", W2i = "Includi i conteggi delle prenotazioni dai tipi di eventi gestiti", G2i = "Benvenuto in {{appName}}!", H2i = "Potrai modificarlo in seguito.", K2i = "Connetterò il mio calendario più tardi", Y2i = "Si è verificato un problema durante il salvataggio dei dati. Riprova o contatta l'assistenza clienti.", Z2i = "Acquista posti mancanti", Q2i = "Durata della fascia oraria", J2i = "Aspetto prenotazione", X2i = "Gestisci le impostazioni di aspetto delle prenotazioni del tuo team", eSi = "Imposta l'aspetto delle prenotazioni per la tua organizzazione", tSi = "Solo il proprietario del team può apportare modifiche alla prenotazione del team ", nSi = "Rimuove tutte le scritte con il marchio {{appName}}, ad es., 'Powered by {{appName}}'", oSi = "{{teamName}} ti ha invitato a unirti al team come {{role}}", rSi = "Il token non è valido o è scaduto.", iSi = "Visualizza prenotazione", aSi = "Connetti a Microsoft Exchange", sSi = "Metodo di autenticazione", cSi = "Autenticazione di base", lSi = "Autenticazione NTLM", dSi = "Compressione GZip", uSi = "Versione di Exchange", _Si = "2007 SP1", pSi = "2010", mSi = "2010 SP1", fSi = "2010 SP2", gSi = "2013", hSi = "2013 SP1", vSi = "2015", bSi = "2016", ySi = "Instradamento", $Si = "Crea moduli per indirizzare i partecipanti alle destinazioni corrette", wSi = "Invia e-mail al proprietario", kSi = "Invia un'e-mail al proprietario quando il modulo viene inviato", SSi = "Invia email a", xSi = "Aggiungi nuovo modulo", ESi = "Aggiungi un nuovo modulo per il tuo team", TSi = "Crea il tuo primo percorso", ASi = "Instrada gli utenti verso la persona giusta in base alle risposte al modulo", CSi = "Modulo", zSi = "Crea un modulo per instradare le persone che prenotano", OSi = "Copia il link del modulo", PSi = "Tema della pagina di prenotazione", ISi = "Si applica solo alle pagine di prenotazione pubbliche", RSi = "Tema della dashboard", NSi = "Questo riguarda solo il pannello di controllo per cui hai effettuato l'accesso", DSi = "Predefinito di sistema", MSi = "Aggiungi un team", LSi = "Ricevi in tempo reale le informazioni sulle riunioni quando succede qualcosa su {{appName}}", qSi = "Viene attivato quando", jSi = "Esegui un test ping prima di creare.", FSi = "Abilita Webhook", VSi = "Aggiungi Webhook", BSi = "Webhook salvato", USi = "Genera chiavi API per accedere al tuo account", WSi = "Nuova chiave API", GSi = "attivo", HSi = "Nome chiave API aggiornato", KSi = "Errore durante l'aggiornamento del nome della chiave API", YSi = "iframe HTML incorporato", ZSi = "Incorpora tutti i tipi di eventi nel tuo sito web", QSi = "Crea la tua prima chiave API", JSi = "Le chiavi API consentono alle altre applicazioni di comunicare con {{appName}}", XSi = "Torna alla pagina di accesso", exi = "Link per la reimpostazione inviato", txi = "Un'email è in arrivo a {{email}} con le istruzioni per reimpostare la password.", nxi = "Se un'e-mail non ti dovesse arrivare a breve, assicurati che l'indirizzo specificato sia corretto e controlla la cartella della posta indesiderata. Se il problema persiste, contatta l'assistenza clienti.", oxi = "Password aggiornata!", rxi = "Pagamento in sospeso", ixi = "Inviti in sospeso", axi = "Inviti in sospeso dell'organizzazione", sxi = "Non presente su {{appName}}", cxi = "Nessun calendario installato", lxi = "Non hai ancora collegato alcun calendario", dxi = "Aggiungi un calendario", uxi = "Potrebbe essere necessario disconnettersi e riconnettersi per vedere le modifiche applicate.", _xi = "Conferma la password prima di cambiare l'indirizzo e-mail", pxi = "posti", mxi = "Tutte le applicazioni pubblicate nell'App store di {{appName}} sono open source e sono state testate in modo approfondito attraverso una valutazione tra pari. Tuttavia, {{companyName}} non promuove né certifica tali applicazioni, a meno che siano pubblicate da {{appName}}. Se noti contenuti o comportamenti inappropriati, ti invitiamo a segnalarceli.", fxi = "Segnala app", gxi = "Limita frequenza di prenotazione", hxi = "Indica quante volte è possibile prenotare questo evento", vxi = "Mostra solo il primo slot disponibile di ogni giorno", bxi = "Questo limiterà la tua disponibilità per questo tipo di evento a uno slot al giorno, programmato al primo orario disponibile.", yxi = "Limita durata totale prenotazione", $xi = "Indicare la quantità di tempo totale disponibile per prenotare questo evento", wxi = "Limite di prenotazioni attive per il prenotante", kxi = "Limita il numero di prenotazioni attive che un prenotante può effettuare per questo tipo di evento", Sxi = "Gli eventi ricorrenti non supportano il limite di prenotazioni per il prenotante", xxi = "Aggiungi limite", Exi = "Nome del team richiesto", Txi = "Condividi le informazioni dei partecipanti tra gli ospiti", Axi = "Mostra il numero di posti disponibili", Cxi = "Come utilizzare le domande poste nella pagina di prenotazione come variabili?", zxi = "Formato", Oxi = "Domande", Pxi = "Tutte le informazioni che il tuo prenotante dovrebbe fornire prima di prenotare con te.", Ixi = "Usa tutte lettere maiuscole", Rxi = "Sostituisci spazi con sottolineature", Nxi = "Membri della piattaforma", Dxi = "Gestisci gli amministratori e i membri del tuo team della piattaforma", Mxi = "Fatturazione della piattaforma", Lxi = "Gestisci fatturazione", qxi = "Gestisci tutto ciò che riguarda la fatturazione", jxi = "Attualmente stai usando il piano GRATUITO", Fxi = "Si lavora meglio in squadra. Migliora i tuoi flussi di lavoro con eventi round robin o di gruppo e crea moduli di instradamento avanzati", Vxi = "Prova ora", Bxi = "Portale di fatturazione", Uxi = "Contatta l'assistenza", Wxi = "Ignora i caratteri speciali nell'identificatore della domanda posta in fase di prenotazione. Usa solo lettere e numeri", Gxi = "Riprova", Hxi = "Si è verificato un problema durante il recupero dei calendari. <1>Riprova</1> o contatta l'assistenza clienti.", Kxi = "Impossibile connettersi al calendario", Yxi = "Prenotazione confermata correttamente", Zxi = "Prenotazione rifiutata correttamente", Qxi = "Questa prenotazione è provvisoria", Jxi = "Ops! Desidero accettare", Xxi = "Questo messaggio non verrà più visualizzato", eEi = "Impossibile aggiornare il fuso orario", tEi = "Fuso orario aggiornato a {{formattedCurrentTz}}", nEi = "Aggiorna fuso orario", oEi = "Aggiornare il fuso orario?", rEi = "Sembra che il fuso orario locale sia stato cambiato in {{formattedCurrentTz}}. È molto importante che il fuso orario sia impostato correttamente per evitare prenotazioni in orari indesiderati. Vuoi aggiornare il fuso orario?", iEi = "Non aggiornare", aEi = "Richiedi note aggiuntive", sEi = "Chiedi di compilare le note aggiuntive al momento della prenotazione", cEi = "invia e-mail a un indirizzo e-mail specifico", lEi = "dopo la fine dell'evento", dEi = "quando la prenotazione viene rifiutata", uEi = "quando viene richiesta una prenotazione", _Ei = "quando viene avviato il pagamento della prenotazione", pEi = "quando il pagamento della prenotazione è andato a buon fine", mEi = "quando lo stato no-show della prenotazione viene aggiornato", fEi = "Quanto tempo dopo la fine dell'evento?", gEi = "Quanto tempo dopo che gli host non si presentano alla riunione video di Cal?", hEi = "Quanto tempo dopo che gli ospiti non si presentano alla riunione video di Cal?", vEi = "Quanto tempo dopo che gli utenti non si presentano alla riunione video di Cal?", bEi = "Nessuna fascia oraria disponibile", yEi = "Tempo disponibile", $Ei = "Non trovi l'app di videoconferenza giusta? Visita il nostro <0>App Store</0>.", wEi = "Installa nuova app di calendario", kEi = "Rendi obbligatorio il numero di telefono per prenotare un evento", SEi = "Disponibilità {{eventTypeTitle}}", xEi = "Errore durante la modifica della disponibilità", EEi = "Non hai l'autorizzazione per accedere a questa risorsa.", TEi = "Incolla qui i metadati SAML forniti dal tuo provider di identità", AEi = "Inserisci un indirizzo email che consenta di individuare il tuo provider di identità SAML", CEi = "Dettagli del provider", zEi = "Il tuo provider di identità (IdP) ti chiederà le seguenti informazioni per completare la configurazione dell'applicazione SAML.", OEi = "URL dell'ACS", PEi = "ID Entità SP", IEi = "URL dell'ACS copiato!", REi = "ID entità SP copiato!", NEi = "Aggiungi calendario", DEi = "Limita le prenotazioni future", MEi = "Indica fino a che data è possibile prenotare questo evento", LEi = "Nessun tipo di evento impostato", qEi = "{{name}} non ha impostato alcun tipo di evento che puoi prenotare.", jEi = "Frequenza di fatturazione", FEi = "Mensile", VEi = "Annuale", BEi = "Pagamento", UEi = "Il tuo team è stato sciolto correttamente", WEi = "La tua organizzazione è stata sciolta", GEi = "Errore durante la creazione del team", HEi = "Tu", KEi = "Oppure continua con", YEi = "Invia di nuovo l'e-mail", ZEi = "Membro già invitato", QEi = "Nome utente già in uso", JEi = "Immettere un indirizzo e-mail o un nome utente", XEi = "Inserisci un'email", eTi = "Inserisci email", tTi = "Puoi invitare un massimo di {{nbUsers}} utenti alla volta.", nTi = "Nome già utilizzato", oTi = "Necessario immettere un nome per il team", rTi = "Immettere un URL per il team", iTi = "URL già occupato", aTi = "Si è verificato un problema durante la registrazione del sottodominio, riprova o contatta un amministratore", sTi = "Pubblica team", cTi = "Numero di telefono (notifiche di testo)", lTi = "Numero di telefono (notifiche SMS)", dTi = "E-mail partecipante", uTi = "E-mail della persona che prenota", _Ti = "UID prenotazione", pTi = "Digita un comando o esegui una ricerca...", mTi = "Errore! Sembra che l'autorizzazione sia scaduta o che sia stata revocata. Prova a reinstallare.", fTi = "Reinstalla app", gTi = "Motivo della riprogrammazione", hTi = "Scegli un programma comune", vTi = "Abilita questa opzione se desideri utilizzare un programma comune tra gli host. Quando disabilitata, ogni host sarà prenotato in base al proprio programma predefinito o a quello scelto.", bTi = "Motivo", yTi = "Id mittente", $Ti = "Sono consentiti solo lettere, numeri e spazi (massimo 11 caratteri)", wTi = "Test modulo di instradamento", kTi = "Test anteprima", STi = "Instrada a", xTi = "Esegui un test del modulo di instradamento senza inviare alcun dato", ETi = "Test instradamento", TTi = "Un amministratore ha disabilitato un'app di pagamento", ATi = "Modifica tipo di evento", CTi = "Questa organizzazione è privata e solo l'amministratore o il proprietario dell'organizzazione può visualizzare i suoi membri.", zTi = "Solo l'amministratore o il proprietario dell'organizzazione può gestire le impostazioni SSO", OTi = "Solo l'amministratore o il proprietario dell'organizzazione può gestire le impostazioni di sincronizzazione della directory", PTi = "Solo l'amministratore o il proprietario dell'organizzazione può gestire i client OAuth", ITi = "Pianificazione collettiva", RTi = "Facilita la prenotazione del tuo team quando tutti sono disponibili.", NTi = "Trova la persona più adatta disponibile e fai ruotare i membri del team.", DTi = "Round robin fisso", MTi = "Aggiungi un partecipante fisso e fai intervenire a turno altri partecipanti.", LTi = "{{appName}} funziona meglio in team", qTi = "Il team {{companyName}}", jTi = "Aggiungi i membri del tuo team ai tuoi tipi di eventi. Usa la pianificazione collettiva per includere tutti o trova la persona più adatta con la pianificazione round robin.", FTi = "È stato raggiunto il limite di prenotazione per questo tipo di evento", VTi = "È stato raggiunto il limite di durata per questo tipo di evento", BTi = "Un amministratore ha disabilitato {{appName}}", UTi = "Questo disabiliterà tutte le email a {{recipient}}. Ciò include conferme di prenotazione, richieste, riprogrammazioni e richieste di riprogrammazione, email di cancellazione e qualsiasi altra email relativa agli aggiornamenti delle prenotazioni.<br /><br />È tua responsabilità assicurarti che i tuoi {{recipient}} siano a conoscenza di eventuali prenotazioni e modifiche alle loro prenotazioni.", WTi = "Un amministratore ha disabilitato {{appName}}, il che ha effetto sul tuo tipo di evento {{eventType}}", GTi = "Un amministratore ha sostituito uno dei tuoi tipi di evento", HTi = "Un amministratore di team ha sostituito il tuo evento /{{slug}}", KTi = "Un amministratore del team <strong>{{teamName}}</strong> ha sostituito il tuo tipo di evento <strong>/{{slug}}</strong> con un tipo di evento gestito da lui controllato.", YTi = "Il tuo link continuerà a funzionare, ma alcune delle sue impostazioni potrebbero essere state cambiate. Puoi verificarlo nella sezione Tipi di evento.", ZTi = "Per qualsiasi domanda sul tipo di evento, contatta il tuo amministratore.<br /><br />Ti auguriamo una piacevole esperienza di pianificazione, <br />Il team Cal.com", QTi = "L'amministratore ha disabilitato {{appName}} che influisce sul tuo tipo di evento {{title}}. I partecipanti possono ancora prenotare questo tipo di evento ma non verrà richiesto loro di pagare. Puoi nascondere il tipo di evento per evitare questo fino a quando l'amministratore non riabiliterà il tuo metodo di pagamento.", JTi = "I partecipanti possono ancora prenotare questo tipo di evento ma non verrà richiesto loro di pagare. Puoi nascondere il tipo di evento per evitare questo fino a quando l'amministratore non riabiliterà il tuo metodo di pagamento.", XTi = "L'amministratore ha disabilitato {{appName}}, il che ha effetto sul tuo tipo di evento {{title}}.", eAi = "L'amministratore ha disabilitato {{appName}}, il che potrebbe avere effetto sui tuoi tipi di eventi. Se hai dei tipi di eventi che utilizzano {{appName}} come luogo, allora verrà usato Cal Video come luogo predefinito.", tAi = "{{appName}} è stato disabilitato", nAi = "Vai alle app installate", oAi = "Se hai un altro calendario installato, le nuove prenotazioni saranno aggiunte a quel calendario. Altrimenti, collega un nuovo calendario in modo da non perdere nessuna nuova prenotazione.", rAi = "Abilita app", iAi = "Abilita le app che gli utenti possono integrare con {{appName}}", aAi = "Acquista una licenza", sAi = "Hai già un account?", cAi = "Ho già una chiave:", lAi = "Copia qui la variabile di ambiente CALCOM_LICENSE_KEY esistente.", dAi = "Crea Chiave di Licenza", uAi = "{{appName}} è abilitato", _Ai = "{{appName}} è disabilitato", pAi = "Le chiavi sono state salvate", mAi = "Disabilita app", fAi = "La disattivazione di questa app potrebbe causare problemi nell'interazione dei tuoi utenti con Cal", gAi = "Modifica chiavi", hAi = "Abilita le app per la tua istanza di Cal", vAi = "Un elenco di tutti gli utenti nel tuo account, inclusi nome, titolo, email e ruolo.", bAi = "Qui puoi aggiungere un nuovo utente.", yAi = "Qui puoi modificare un utente esistente.", $Ai = "Qui puoi modificare un'organizzazione.", wAi = "Aggiungi nuovi client OAuth", kAi = "Blocca o sblocca l'invio di SMS per gli utenti", SAi = "Nessuna app disponibile", xAi = "Controlla che ci siano delle applicazioni nella tua distribuzione, in 'packages/app-store'", EAi = "Non ci sono applicazioni abilitate in questa istanza di Cal", TAi = "Nessuna applicazione configurata al momento", AAi = "È possibile abilitare le applicazioni nelle impostazioni", CAi = "Contatta il tuo amministratore", zAi = "Impostazioni delle app", OAi = "Compilare il campo", PAi = "Opzioni", IAi = "Immetti opzione {{index}}", RAi = "Aggiungi un'opzione", NAi = "Questa località esiste già. Seleziona una nuova località", DAi = "Pulsante di opzione", MAi = "Per utilizzare Google Meet, devi impostare il tuo calendario di destinazione su Google Calendar", LAi = "Persona", qAi = "Tutte le prenotazioni", jAi = "Tutti gli utenti", FAi = "Tutti i tipi di evento", VAi = "Le tue prenotazioni", BAi = "URL della riunione", UAi = "URL dell'evento, dell'incontro o della conferenza", WAi = "Configurazione date specifiche", GAi = "Cancella configurazione specifica per il {{date}}", HAi = "Aggiungi le date in cui la tua disponibilità differisce dall'orario giornaliero.", KAi = "Le configurazioni valide per date specifiche vengono archiviate automaticamente dopo tali date", YAi = "In quali orari sei libero/a?", ZAi = "In quali orari sei occupato/a?", QAi = "Seleziona le date da configurare", JAi = "Non disponibile, per tutto il giorno", XAi = "Segna come non disponibile (tutto il giorno)", eCi = "Segna come non disponibile nelle date selezionate", tCi = "Aggiorna configurazione data specifica", nCi = "Configurazione delle date aggiunta correttamente", oCi = "Salva modifica", rCi = "{{slug}}-copia", iCi = "Imposta come predefinito", aCi = "Nascondi dettagli del tipo di evento", sCi = "Mostra navigazione", cCi = "Nascondi navigazione", lCi = "Codice di verifica inviato", dCi = "Verifica completata", uCi = "Codice di verifica errato", _Ci = "Non ancora verificato", pCi = "Nessuna disponibilità in {{month}}", mCi = "La programmazione è disponibile solo fino a {{days}} giorni in anticipo. Controlla di nuovo a breve.", fCi = "La pianificazione è terminata il {{date}}. Si prega di controllare nuovamente a breve.", gCi = "Visualizza mese precedente", hCi = "Visualizza il mese successivo", vCi = "Invia codice", bCi = "Numero verificato", yCi = "Crea il primo webhook per questo tipo di evento del team", $Ci = "Crea un webhook per questo tipo di evento del team", wCi = "Disabilita pagina di conferma dell'esito (funziona solo se si dispone di un URL di reindirizzamento)", kCi = "Sei un amministratore, ma la tua password non ha la lunghezza minima di 15 caratteri, oppure non utilizzi ancora l'autenticazione a due fattori", SCi = "Cambia la tua password per ottenere l'accesso come amministratore", xCi = "Nome utente già in uso", ECi = "Assegnazione", TCi = "Organizzatori fissi", ACi = "Aggiungi organizzatori fissi", CCi = "Organizzatori round robin", zCi = "Numero di organizzatori necessario per partecipare", OCi = "Organizzatori", PCi = "Devi creare un team per abilitare questa funzionalità. Clicca qui per creare un team.", ICi = "Per abilitare questa funzione, è necessario eseguire l'upgrade al nostro piano Enterprise.", RCi = "Nuovo partecipante", NCi = "In attesa di approvazione", DCi = "L'app richiede una connessione a Google Calendar", MCi = `L'opzione "Aggiungi al calendario" per questo tipo di evento deve essere un Google Calendar affinché Meet funzioni. Collegalo <0>qui</0>.`, LCi = "È stato connesso un account di Google Calendar.", qCi = "Per usare Google Meet, è necessario connettere un account di Google Calendar", jCi = "Continua e installa Google Calendar", FCi = "Installa Google Meet", VCi = "Installa Google Calendar", BCi = "Nome mittente", UCi = "Partecipante già invitato", WCi = "Nessuna registrazione trovata", GCi = "Nuovo flusso di lavoro per...", HCi = "Reporting", KCi = "Visualizza tutti i dati in arrivo e scaricali in formato CSV", YCi = "Piano Team richiesto", ZCi = "I moduli di instradamento sono un ottimo strumento per instradare i contatti in entrata verso le persone giuste. Per accedere a questa funzione, effettua l'upgrade al piano Team.", QCi = "Scegli una licenza", JCi = "Cal.com viene fornito con una licenza AGPLv3 accessibile e gratuita che ha alcune limitazioni e può essere convertita in una licenza Enterprise in qualsiasi momento. È possibile effettuare l'upgrade in un secondo tempo.", XCi = "Licenza", ezi = "Licenza AGPLv3", tzi = "Non è necessario che il codice rimanga open source", nzi = "Rivendi facilmente con un nuovo marchio", ozi = "Un'estesa suite di funzionalità enterprise", rzi = "0,00 $/mese", izi = "Aperto e gratuito per sempre", azi = "È necessario che il codice rimanga open source", szi = "Non è possibile rivenderlo facilmente con un nuovo marchio", czi = "Nessuna funzionalità enterprise", lzi = "Licenza Enterprise", dzi = "Tutto per un uso commerciale con hosting privato, rivendita con nuovo marchio e accesso ai componenti enterprise esclusivi.", uzi = "Impostazione", _zi = "Imposta istanza Cal.com", pzi = "Configura", mzi = "Configurazione Single Sign-On", fzi = "Configura accesso SSO tramite SAML/OIDC e consenti ai membri del team di accedere utilizzando un provider di identità", gzi = "Configura l'accesso SSO con SAML/OIDC per consentire ai membri dell'organizzazione di accedere utilizzando un provider di identità", hzi = "SSO con OIDC", vzi = "Configura accesso SSO tramite OIDC con un provider di identità di tua scelta.", bzi = "Configurazione OIDC", yzi = "Configura la connessione OIDC al tuo provider di identità. Puoi trovare le informazioni necessarie presso il tuo provider di identità.", $zi = "URL di callback copiato", wzi = "SSO con SAML", kzi = "Configura accesso SSO tramite SAML con un provider di identità di tua scelta.", Szi = "Configurazione SAML", xzi = "Configura la connessione SAML al tuo provider di identità. Puoi trovare le informazioni necessarie presso il tuo provider di identità.", Ezi = "URL dell'ACS copiato", Tzi = "ID entità copiato", Azi = "Configurazione {{connectionType}} creata correttamente", Czi = "Configurazione {{connectionType}} eliminata correttamente", zzi = "Eliminare la configurazione {{connectionType}}", Ozi = "Sì, elimina la configurazione {{connectionType}}", Pzi = "Eliminare la configurazione {{connectionType}}? I membri del tuo team che utilizzano l'accesso {{connectionType}} non saranno più in grado di accedere a Cal.com.", Izi = "Fuso orario organizzatore", Rzi = "Visualizza invito", Nzi = "Accetta Invito", Dzi = "Unisciti Ora", Mzi = "Iscrizione completata con successo", Lzi = "Sei stato invitato a unirti a un team dell'organizzazione {{parentTeamName}}", qzi = "Sei stato invitato a unirti a un'organizzazione {{appName}}", jzi = "{{invitedBy}} ti ha invitato a unirti al suo team su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette al tuo team di pianificare le riunioni senza scambiare decine di e-mail.", Fzi = "{{invitedBy}} ti ha invitato a entrare nel team {{teamName}} della sua organizzazione {{parentTeamName}} su {{appName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza lo scambio di infinite email.", Vzi = "{{invitedBy}} ti ha invitato a unirti alla sua organizzazione `{{teamName}}` su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette a te e alla tua organizzazione di pianificare le riunioni senza scambiare decine di e-mail.", Bzi = "Ti guideremo attraverso alcuni brevi passaggi e potrai goderti la pianificazione senza stress con la tua {{entity}} in pochissimo tempo.", Uzi = "Scegli il tuo nome utente", Wzi = "Collega il tuo account di calendario", Gzi = "Imposta la tua disponibilità", Hzi = "Unisciti a {{teamName}}", Kzi = "Il team {{appName}} ti augura una piacevole esperienza di pianificazione", Yzi = "Stai per effettuare l'accesso con altra identità; potrai cioè apportare modifiche a nome di un altro utente. Procedi con cautela.", Zzi = "Variabili disponibili", Qzi = "{Scheduler}", Jzi = "Nessun flusso di lavoro", Xzi = "Modifica il filtro per vedere i flussi di lavoro personali e di squadra.", eOi = "Cambia i criteri di filtro per vedere i risultati.", tOi = "Nessun risultato per il filtro", nOi = "Passaggi successivi consigliati", oOi = "Crea un tipo di evento gestito", rOi = "Le riunioni sono efficaci quando sono presenti le persone giuste. Invitale adesso.", iOi = "Crea un modello uno a uno per un tipo di evento e distribuiscilo a più membri.", aOi = "Di gruppo o round robin", sOi = "Usa eventi di gruppo per riunire tutti i membri del team o eventi round robin per fare partecipare a rotazione le persone giuste.", cOi = "Non partecipa più a {{title}} con il seguente orario: {{date}}", lOi = "Non partecipi più a questo evento", dOi = "Un partecipante non partecipa più a {{title}} con il seguente orario {{date}}", uOi = "Un partecipante non partecipa più al tuo evento", _Oi = "{{name}} ha disdetto. Di conseguenza, si è liberato un posto in questa fascia oraria", pOi = "Crea evento in", mOi = "Crea modulo di instradamento su", fOi = "Imposta il link dell'app predefinita", gOi = "L'impostazione di un link dell'app predefinita permette a tutti i nuovi tipi di eventi di usare il link dell'app impostato.", hOi = "Applicazione predefinita dell'organizzatore", vOi = "{{organizer}} non ha un'app di conferenza predefinita", bOi = "Inattivo per manutenzione", yOi = "Il team di {{appName}} sta eseguendo la manutenzione programmata. Per qualsiasi domanda, contattare il supporto.", $Oi = "{{numberOfSeats}} posti", wOi = "Domande per la prenotazione", kOi = "Personalizza le domande poste nella pagina di prenotazione", SOi = "Aggiungi una domanda", xOi = "Identificatore", EOi = "Indirizzo e-mail duplicato", TOi = "Inserisci un URL di reindirizzamento verso cui il partecipante verrà inviato una volta terminata la riunione.", AOi = "Non è più possibile pagare per questo evento", COi = "È in corso il rimborso del pagamento per questa prenotazione.", zOi = "Il pagamento per questa prenotazione è stato rimborsato.", OOi = "In base alla politica di rimborso dell'evento, il pagamento della prenotazione non è rimborsabile.", POi = "Il periodo di rimborso dell'evento è scaduto. Pertanto, il pagamento della prenotazione non è rimborsabile.", IOi = "Conferma prenotazione non riuscita", ROi = "Posti insufficienti", NOi = "Esiste già un campo con questo nome", DOi = "Il campo ospiti deve essere di tipo 'Email multiple'", MOi = "Mostra nella pagina di prenotazione", LOi = "Puoi visitare la pagina della prenotazione annullata", qOi = "Inizia con i modelli Zapier", jOi = "Template standard", FOi = "Template Cal.ai", VOi = "{{team}} non è pubblicato", BOi = "Il link di questa organizzazione non è attualmente disponibile. Contatta il proprietario dell'organizzazione o chiedigli di pubblicarlo.", UOi = "Questo link di {{entity}} non è attualmente disponibile. Contatta il proprietario di {{entity}} o chiedigli di pubblicarlo.", WOi = "Membro del team", GOi = "Un modulo di instradamento", HOi = "Descrizione modulo", KOi = "Mantieni la connessione con il modulo", YOi = "Qualsiasi modifica apportata al router o ai campi del modulo duplicato si rifletterà nella copia. Tuttavia, l'eliminazione di un campo non lo rimuoverà dalla copia.", ZOi = "Modulo eliminato", QOi = "Confermi l'eliminazione del modulo?", JOi = "Sì, elimina modulo", XOi = "Gli utenti con cui hai condiviso il link non potranno più accedervi.", e4i = "Tutte le risposte associate verranno eliminate.", t4i = "URL di reindirizzamento copiato! Puoi andare a impostare l'URL nel tuo modulo.", n4i = "Le eventuali modifiche apportate ai campi e ai percorsi dei seguenti moduli si rifletteranno in questo modulo.", o4i = "Moduli connessi", r4i = "Le modifiche qui apportate a campi e percorsi si rifletteranno nei seguenti moduli.", i4i = "Attendere che vengano raccolte alcune risposte. È possibile anche compilare e inviare il modulo personalmente.", a4i = "Ecco cosa vedranno gli utenti", s4i = "Identifica il campo con questo nome.", c4i = "Aggiungi 1 opzione per riga", l4i = "Seleziona un instradatore", d4i = "Aggiungi un nuovo percorso", u4i = "Prendi decisioni informate con Insights", _4i = "Il pannello di controllo Insights offre una panoramica di tutte le attività del team e mostra le tendenze, il che consente di migliorare la pianificazione di gruppo e il processo decisionale.", p4i = "Visualizza le prenotazioni di tutti i membri", m4i = "Vedi chi riceve più prenotazioni e assicura la migliore distribuzione nel tuo team", f4i = "Identifica le tendenze di prenotazione", g4i = "Scopri quali giorni della settimana e quali fasce orarie sono popolari tra le persone che prenotano", h4i = "Individua i tipi di evento popolari", v4i = "Scopri quali tipi di evento ricevono più clic e prenotazioni", b4i = "Per ora non ci sono risposte", y4i = "Nessun percorso definito", $4i = "Questo sarà il segnaposto", w4i = "Si è verificato un errore durante la prenotazione dell'evento. Aggiorna la pagina e riprova", k4i = "Nessuna fascia oraria selezionata", S4i = "Seleziona una fascia oraria per prenotare l'evento.", x4i = "Seleziona fascia oraria", E4i = "Passa alla vista mensile", T4i = "Passa alla vista settimanale", A4i = "Passa alla vista giornaliera", C4i = "Passa alla vista colonna", z4i = "{{num}} opzioni di luogo", O4i = "Seleziona nel passaggio successivo", P4i = "Questa riunione non è ancora iniziata", I4i = "{{appName}} richiede un account di {{dependencyName}} connesso", R4i = "Connetti {{dependencyName}}", N4i = "{{dependencyName}} è connesso", D4i = "Richiede {{dependencyName}}", M4i = "Codice di verifica", L4i = "Riprovare specificando un orario differente.", q4i = "Verifica", j4i = "Il fuso orario della persona che riceve la prenotazione", F4i = "Timezone", V4i = "Ora di conclusione dell'evento", B4i = "Ora di conclusione dell'evento", U4i = "URL di annullamento", W4i = "URL per annullare la prenotazione", G4i = "Motivo della cancellazione", H4i = "Il motivo per la cancellazione della prenotazione", K4i = "URL di riprogrammazione", Y4i = "URL per riprogrammare la prenotazione", Z4i = "Motivo del cambio data", Q4i = "Il motivo per il cambio data della prenotazione", J4i = "Nel nome dell'evento è presente una variabile non valida", X4i = "Seleziona tutto", e3i = "Aggiorna in blocco i tipi di eventi esistenti", t3i = "Pianificazione predefinita membro", n3i = "Impostato dall'amministratore del team", o3i = "Posizione predefinita del membro", r3i = "Useremo il programma di disponibilità predefinito di ciascun membro. I membri potranno modificarlo.", i3i = "È necessario avere almeno un programma", a3i = "Aggiorna le posizioni per i tipi di eventi selezionati", s3i = "Aggiorna i programmi per i tipi di eventi selezionati", c3i = "Bloccato per i membri", l3i = "Sbloccato per i membri", d3i = "I membri potranno vedere le app attive, ma non potranno modificare le impostazioni delle app", u3i = "I membri potranno vedere le app attive e modificare le impostazioni delle app", _3i = "Potrai vedere le app attive, ma non potrai modificare le impostazioni delle app", p3i = "Potrai vedere le app attive e modificare le impostazioni delle app", m3i = "I membri non possono aggiungere i loro flussi di lavoro personali a questo tipo di evento. I membri potranno vedere i flussi di lavoro attivi del team, ma non potranno modificare le impostazioni dei flussi di lavoro.", f3i = "I membri possono aggiungere i loro flussi di lavoro personali a questo tipo di evento. I membri potranno vedere i flussi di lavoro attivi del team, ma non potranno modificare le impostazioni dei flussi di lavoro.", g3i = "Potrai vedere i flussi di lavoro attivi del team, ma non potrai modificare le impostazioni dei flussi di lavoro né aggiungere i tuoi flussi di lavoro personali a questo tipo di evento.", h3i = "Potrai attivare/disattivare flussi di lavoro personali su questo tipo di evento. Potrai vedere i flussi di lavoro attivi del team, ma non potrai modificare le impostazioni dei flussi di lavoro.", v3i = "I membri non possono aggiungere i propri webhook personali a questo tipo di evento. I membri potranno vedere i webhook attivi ma non potranno modificare alcuna impostazione dei webhook.", b3i = "I membri potranno aggiungere i propri webhook personali a questo tipo di evento. I membri potranno vedere i webhook attivi ma non potranno modificare alcuna impostazione dei webhook.", y3i = "Puoi vedere i webhook gestiti attivi ma non potrai modificare alcuna impostazione dei webhook o aggiungere i tuoi webhook personali a questo tipo di evento.", $3i = "Puoi aggiungere webhook a questo tipo di evento. Puoi vedere i webhook gestiti attivi ma non potrai modificarli.", w3i = "Bloccato dall'amministratore del team", k3i = "Non è stato connesso un account di {{appName}}.", S3i = "Connetti ora", x3i = "Sostituisci e invia notifica a {{count}} membro", E3i = "Sostituisci e invia notifica a {{count}} membri", T3i = "L'URL /{{slug}} esiste già per {{count}} membro. Vuoi sostituirlo?", A3i = "L'URL /{{slug}} esiste già per {{count}} membri. Vuoi sostituirlo?", C3i = "<strong>{{names}}</strong> utilizza già l'URL <strong>/{{slug}}</strong>.", z3i = "<strong>{{names}}</strong> utilizzano già l'URL <strong>/{{slug}}</strong>.", O3i = "Se decidi di sostituirlo, i membri ne saranno avvisati. Torna indietro e rimuovili se non desideri sovrascriverlo.", P3i = "Rivedi tipo di evento", I3i = "Hai bisogno di più dati analitici?", R3i = "Ti servono più Insights?", N3i = "Filtri", D3i = "Filtra", M3i = "Aggiungi un membro", L3i = "Aggiungi filtro", q3i = "Aggiungi regola", j3i = "Aggiungi gruppo di regole", F3i = "Cancella tutti i filtri", V3i = "Email verificata", B3i = "Seleziona utente", U3i = "Seleziona tipo di evento", W3i = "Seleziona intervallo di date", G3i = "Eventi popolari", H3i = "Nessun tipo di evento trovato", K3i = "Durata media evento", Y3i = "Prenotazioni per ora", Z3i = "Membri più prenotati", Q3i = "Membri meno prenotati", J3i = "Maggior numero di prenotazioni programmate", X3i = "Minor numero di prenotazioni programmate", e6i = "Maggior numero di prenotazioni completate", t6i = "Minor numero di prenotazioni completate", n6i = "Eventi creati", o6i = "Eventi completati", r6i = "Eventi annullati", i6i = "Eventi riprogrammati", a6i = "Eventi", s6i = "Prestazioni", c6i = "dal periodo precedente", l6i = "Da: {{startDate}} A: {{endDate}}", d6i = `Aggiungendo un reindirizzamento, viene disabilitata la pagina di conferma dell'esito. Assicurati che nella pagina di conferma dell'esito personalizzata compaia la dicitura "Prenotazione confermata".`, u6i = "Tendenze eventi", _6i = "Cancella filtri", p6i = "Cancella", m6i = "Preautorizzazione", f6i = "Raccogli pagamento alla prenotazione", g6i = "Addebita penale per mancata presentazione", h6i = "Preautorizzazione carta", v6i = "Addebita carta", b6i = "Carta addebitata", y6i = "Penale per mancata presentazione: {{amount, currency}}", $6i = "Penale per mancata presentazione", w6i = "Invia carta", k6i = "Invia informazioni di pagamento", S6i = "La tua riunione è in attesa di un metodo di pagamento", x6i = "Una penale per mancata presentazione di {{amount, currency}} è stata addebitata per {{title}} alle {{date}}", E6i = "È stata addebitata una penale per mancata presentazione", T6i = "Una penale per mancata presentazione di {{amount, currency}} è stata addebitata per il seguente evento", A6i = "L'addebito della penale per mancata presentazione non è andato a buon fine. Riprovare più tardi.", C6i = "Riscuoti penale per mancata presentazione", z6i = "Penale per mancata presentazione addebitata", O6i = "Pagamento rifiutato. Prova con una carta diversa o contatta la tua banca per assistenza.", P6i = "Questo tipo di carta non è supportato per questo acquisto. Utilizza un metodo di pagamento diverso.", I6i = "L'importo minimo del pagamento è $0.50 USD. Aumenta l'importo del pagamento.", R6i = "Non è stato possibile addebitare la carta per il pagamento.", N6i = "Approfondimenti", D6i = "Moduli di Routing", M6i = "Nessun dato trovato per il filtro selezionato o le date selezionate.", L6i = "Confermo che in caso di mia mancata partecipazione a questo evento, una penale per mancata presentazione di {{amount, currency}} verrà addebitata sulla mia carta.", q6i = "giorni", j6i = "Dati della carta", F6i = "Qualcosa è andato storto da parte nostra. Contatta il nostro team di supporto e risolveremo il problema immediatamente per te.", V6i = "Fornisci il seguente testo quando contatterai il team di supporto per permeterci di aiutarti meglio", B6i = "Attualmente non è possibile abilitare i posti e addebitare la penale per mancata presentazione", U6i = "Completa la prenotazione", W6i = "Completa la prenotazione: {{title}} del {{date}}", G6i = "Conferma i tuoi dati", H6i = "Copia link d'invito", K6i = "Modifica impostazioni link", Y6i = "Link d'invito copiato", Z6i = "Link d'invito eliminato", Q6i = "Chiave API eliminata", J6i = "Questa azione eliminerà permanentemente la chiave API. Tutte le applicazioni che utilizzano questa chiave perderanno immediatamente l'accesso al tuo account. Questa azione non può essere annullata.", X6i = "Impostazioni link d'invito salvate", e5i = "La scadenza dei link è impostata dopo...", t5i = "1 giorno", n5i = "7 giorni", o5i = "30 giorni", r5i = "3 mesi", i5i = "1 anno", a5i = "Hai ricevuto un invito a unirti al team {{teamName}}", s5i = "{{amount, currency}}", c5i = "Stai per addebitare {{amount, currency}} al partecipante. Confermi di voler proseguire?", l5i = "Addebita {{amount, currency}} al partecipante", d5i = "Richiedi un pagamento ({{paymentFeePercentage}}% + {{fee, currency}} di commissione per transazione)", u5i = "{{email}} è stato invitato", _5i = "{{userCount}} utenti sono stati invitati", p5i = "Errore durante l'elaborazione della carta", m5i = "Le dimensioni dell'immagine caricata non devono superare il limite di 5 MB", f5i = "{{errorCode}}: Non hai l'autorizzazione ad abilitare o disabilitare questo flusso di lavoro", g5i = "Elemento incorporato nella pagina", h5i = "Carica il tuo tipo di evento direttamente nella pagina con gli altri contenuti del sito web.", v5i = "Pulsante a comparsa mobile", b5i = "Inserisce nel sito un pulsante mobile che attiva una finestra modale con il tuo tipo di evento.", y5i = "Finestra popup tramite clic su un elemento", $5i = "Apre la finestra di dialogo di Cal quando un utente fa clic su un elemento.", w5i = "Usa il mio modulo", k5i = "Usa la nostra API di routing headless e utilizza il tuo modulo per le sottomissioni.", S5i = "Hai bisogno di aiuto? Consulta le nostre guide per integrare Cal su Wix, Squarespace o WordPress, leggi le risposte alle domande più frequenti o esplora le opzioni di incorporamento avanzate.", x5i = "Prenota su Cal", E5i = "Nome", T5i = "Cognome", A5i = "Nome, cognome", C5i = "Invita come", z5i = "Modulo aggiornato correttamente.", O5i = "Disabilita le e-mail di conferma predefinite per i partecipanti", P5i = "Per questo tipo di evento è attivo almeno un flusso di lavoro che invia un'e-mail ai partecipanti quando l'evento viene prenotato.", I5i = "Disabilita le e-mail di conferma predefinite per gli organizzatori", R5i = "Per questo tipo di evento è attivo almeno un flusso di lavoro che invia un'e-mail agli organizzatori quando l'evento viene prenotato.", N5i = "Aggiungi configurazione specifica", D5i = "Importa utenti da Google Workspace", M5i = "Collega Google Workspace", L5i = "Per usare questa funzione è necessario essere amministratori di Workspace", q5i = "Crea il primo webhook per questo tipo di evento", j5i = 'Crea il tuo primo webhook con "Riunione immediata creata" come attivatore per questo tipo di evento', F5i = "Installa l'app su", V5i = "Crea per", B5i = "Valuta", U5i = "Crea un ambiente in cui i tuoi team possono creare app condivise, flussi di lavoro e tipi di eventi con round robin e pianificazione collettiva.", W5i = "Gestisci organizzazioni con più team", G5i = "Imposta la tua organizzazione", H5i = "Configura la tua piattaforma", K5i = "Le organizzazioni sono ambienti condivisi dove i team possono creare e condividere tipi di eventi, applicazioni, flussi di lavoro e altro ancora.", Y5i = "Piani", Z5i = "Piattaforma", Q5i = "Gestisci tutto ciò che riguarda la piattaforma.", J5i = "La piattaforma Cal.com ti permette di integrare facilmente la pianificazione nella tua app utilizzando API e atom della piattaforma.", X5i = "È necessario inserire il nome dell'organizzazione", ePi = "È necessario inserire l'indirizzo e-mail dell'organizzazione", tPi = "Il tuo indirizzo e-mail nell'organizzazione", nPi = "Indirizzo email dell'amministratore", oPi = "Nome utente dell'amministratore", rPi = "Nome dell'organizzazione", iPi = "Nome della piattaforma", aPi = "URL dell'organizzazione", sPi = "Verifica il tuo indirizzo e-mail", cPi = "Usa il codice sottostante per verificare il tuo indirizzo e-mail e proseguire la configurazione dell'organizzazione.", lPi = "Parametri aggiuntivi dell'URL", dPi = "Informazioni sulla tua organizzazione", uPi = "Le organizzazioni sono ambienti condivisi dove è possibile creare dei team con condivisione di membri, tipi di eventi, applicazioni, flussi di lavoro e altro ancora.", _Pi = "Crea i tuoi team", pPi = "Inizia la pianificazione condivisa aggiungendo i membri del tuo team alla tua organizzazione", mPi = "Invita gli amministratori dell'organizzazione", fPi = "Gli amministratori avranno accesso a tutti i team della tua organizzazione. Puoi aggiungere amministratori e membri dei team in un secondo tempo.", gPi = "Imposta una password", hPi = "Verrà creato un nuovo account utente con l'indirizzo e-mail della tua organizzazione e questa password.", vPi = "Logo dell'organizzazione", bPi = "Qualche informazione sulla tua organizzazione. Le informazioni appariranno nella pagina del profilo pubblico dell'organizzazione.", yPi = "Lo farò più tardi", $Pi = "Verifica l'e-mail", wPi = "Immetti il codice di 6 cifre che è stato inviato a {{email}}", kPi = "Verifica il tuo indirizzo e-mail per creare un'organizzazione", SPi = "Il codice immesso non è valido, riprova", xPi = "Indirizzo e-mail già in uso", EPi = "Hai ricevuto un invito a unirti a {{orgName}}", TPi = "Unisciti al tuo team su {{orgName}}, per concentrarti sulle riunioni e non sulla loro pianificazione!", APi = "Non è stato possibile creare i seguenti team a causa di slug duplicati: {{slugs}}", CPi = "I nomi di team non possono essere vuoti", zPi = "I nomi di team devono essere unici", OPi = "L'utente appartiene a un'organizzazione", PPi = "Questa organizzazione non ha ancora alcun team", IPi = "Se sei un amministratore, assicurati di creare dei team da mostrare qui.", RPi = "Imposta", NPi = "Il mio profilo", DPi = "Le mie impostazioni", MPi = "CRM", LPi = "Messaggistica", qPi = "Nome o numero mostrato come mittente di un SMS (alcuni paesi non consentono ID alfanumerici dei mittenti)", jPi = "Solo l'amministratore della tua organizzazione può creare nuovi team", FPi = "La nuova politica anti-spam di Google potrebbe impedirti di ricevere email e notifiche di calendario relative a questa prenotazione.", VPi = "Risolvi", BPi = "Si è verificato un errore durante la creazione dei team per questa organizzazione. Slug URL mancante.", UPi = "Copia link all'organizzazione", WPi = "Team: {{teamName}}", GPi = "Utente: {{userName}}", HPi = "Visualizza insight sulle prenotazioni per tutti i tuoi eventi", KPi = "Cronologia chiamate", YPi = "Visualizza la cronologia delle chiamate effettuate con Cal.ai", ZPi = "{{locationCount}} opzioni di luogo", QPi = "Tipo di canale", JPi = "Motivo di fine", XPi = "Stato della sessione", eIi = "Sentiment dell'utente", tIi = "Ora", nIi = "Da", oIi = "Piano personalizzato", rIi = "Incorporamento nell'e-mail", iIi = "Seleziona alcuni orari disponibili e incorporali nella tua e-mail", aIi = "Seleziona l'ora", sIi = "Seleziona la data", cIi = "Mostra solo se un parametro è impostato", lIi = "Aggiungi parametro", dIi = "Ti stiamo mettendo in contatto con qualcuno di {{orgName}}.", uIi = "Per favore, non chiudere o aggiornare questa pagina", _Ii = "Vedi tutti gli orari disponibili", pIi = "ad es., team di marketing", mIi = "ad es., team vendite", fIi = "ad es., team di progettazione", gIi = "ad es., team di ingegneria", hIi = "ad es., team di analisi dei dati", vIi = "Sarà possibile aggiungere altri team in un secondo momento.", bIi = "Qual è l'oggetto della riunione?", yIi = "Aggiungi al team", $Ii = "Rimuovi utenti dall'organizzazione", wIi = "Credenziale di delega", kIi = "La credenziale di delega ti permette di gestire l'accesso ai calendari di Google Workspace per la tua organizzazione.", SIi = "Aggiungi questo Client Id in Google Workspace con lo scope indicato sotto", xIi = "Credenziale di delega abilitata", EIi = "Aggiungi credenziale di delega", TIi = "Modifica credenziale di delega", AIi = "Dominio", CIi = "Nessuna piattaforma workspace", zIi = "Piattaforma workspace", OIi = "Piattaforme workspace", PIi = "Gestisci le piattaforme workspace che possono essere utilizzate per la credenziale di delega", IIi = "Modifica piattaforma workspace", RIi = "Modifica account di servizio", NIi = "Aggiungi piattaforma workspace", DIi = "Slug", MIi = "JSON chiave account di servizio", LIi = "Modifica JSON chiave account di servizio", qIi = "La credenziale di delega limita l'aggiunta di più di un'installazione", jIi = "App installata con successo e sta utilizzando le credenziali delegate", FIi = "Rimuovere {{userCount}} utenti da questa organizzazione?", VIi = "Rimuovi utenti dal team", BIi = "Sei sicuro di voler rimuovere {{userCount}} utenti da questo team?", UIi = "Questo utente non ha ancora impostato alcuna pianificazione", WIi = "Questo utente non fa parte di nessun team", GIi = "Questo utente non ha ancora installato alcuna app", HIi = "Richiede la verifica dell'indirizzo e-mail della persona che prenota", KIi = "Per garantire la verifica dell'indirizzo e-mail della persona che prenota prima di panificare eventi", YIi = "I messaggi di testo possono solo essere invitati ai partecipanti quando il tipo di evento richiede una conferma.", ZIi = "Organizzazioni", QIi = "Carica il logo Cal Video", JIi = "Aggiorna il logo Cal Video", XIi = "Carica banner", eRi = "Per fare in modo che il tuo logo sia visibile sullo sfondo scuro del video Cal, carica un'immagine di colore chiaro in formato PNG o SVG per mantenere la trasparenza.", tRi = "Atri team", nRi = "Qui puoi vedere i team di cui non fai parte all'interno della tua organizzazione. Puoi entrare a far parte di tali team se necessario.", oRi = "Non fai parte di alcuna organizzazione", rRi = "Nessun altro team trovato", iRi = "Non ci sono altri team in questa organizzazione.", aRi = "Nome del partecipante", sRi = "Cognome del partecipante", cRi = "Nome della persona che prenota", lRi = "Cognome della persona che prenota", dRi = "Riepilogo mensile", uRi = "Nome del membro", _Ri = "Eventi più popolari", pRi = "Ecco il riepilogo degli eventi popolari per il tuo team {{teamName}} negli ultimi 30 giorni", mRi = "Io", fRi = "Incontro non disponibile", gRi = "Email di riepilogo mensile", hRi = "E-mail di riepilogo mensili per i team", vRi = "Effettua la verifica del tuo team per abilitare l'invio di messaggi ai partecipanti", bRi = "Membro rimosso", yRi = "La mia disponibilità", $Ri = "La disponibilità del team", wRi = "Disponibilità immediata per riunioni", kRi = "Codice di backup", SRi = "Codici di backup", xRi = "Ogni codice di backup può essere utilizzato soltanto una volta per concedere l'accesso senza l'autenticatore.", ERi = "Codici di backup copiati!", TRi = "Il codice di backup è errato.", ARi = "Accesso perso", CRi = "Nessun codice di backup trovato. Puoi generarli nelle impostazioni.", zRi = "Nuova organizzazione creata: azione in sospeso", ORi = "Ciao amministratore", PRi = "Un'organizzazione richiede la configurazione DNS", IRi = `È stata creata un'organizzazione con lo slug "{{orgSlug}}".<br /><br />Assicurati di configurare il registro DNS in modo che il sottodominio corrispondente alla nuova organizzazione punti verso dov'è eseguita l'applicazione principale, altrimenti l'organizzazione non funzionerà.<br /><br />Ecco solo alcune opzioni molto basilari per configurare un sottodominio in modo che punti alla propria app e carichi la pagina del profilo dell'organizzazione.<br /><br />È possibile farlo utilizzando il record A:`, RRi = "O il record CNAME:", NRi = "Dopo aver configurato il sottodominio, contrassegnare la configurazione del DNS come completata nelle impostazioni di amministrazione dell'organizzazione.", DRi = "Vai alle impostazioni di amministrazione dell'organizzazione", MRi = "Organizzazione elaborata", LRi = "Si è verificato un errore durante l'elaborazione di questa organizzazione", qRi = "Un elenco di tutte le organizzazioni. Accettando un'organizzazione, tutti gli utenti con il rispettivo dominio e-mail potranno registrarsi SENZA verificare l'indirizzo e-mail.", jRi = "Non verificato", FRi = "Verificato", VRi = "DNS mancante", BRi = "DNS Configurato", URi = "Contrassegna DNS come configurato", WRi = "Valore", GRi = "L'organizzazione è stata aggiornata correttamente", HRi = "Questo team non ha nessun tipo di evento", KRi = "L'opzione di prenotazione dei posti non supporta durate multiple", YRi = "Includi evento del calendario", ZRi = "OAuth", QRi = "Modulo di creazione client OAuth", JRi = "Questo è il modulo per creare un nuovo client OAuth", XRi = "Modulo di aggiornamento client OAuth", eNi = "Questo è il modulo per modificare un client OAuth esistente", tNi = "Aggiunti di recente", nNi = "Collega tutti i tuoi calendari", oNi = "{{appName}} legge la disponibilità da tutti i tuoi calendari esistenti.", rNi = "Personalizza la tua esperienza di programmazione con i flussi di lavoro", iNi = "Automazione dei flussi di lavoro", aNi = "Usa la programmazione collettiva e round robin per il tuo team", sNi = "Nessun membro trovato", cNi = "Directory Sync", lNi = "Nome directory", dNi = "Provider directory", uNi = "URL base SCIM", _Ni = "Token SCIM al portatore", pNi = "ULR base SCIM copiato", mNi = "Token SCIM al portatore copiato", fNi = "Il tuo provider di identità chiederà le seguenti informazioni per configurare SCIM. Segui le istruzioni per completare la configurazione.", gNi = "Configura sincronizzazione directory", hNi = "Scegli un provider di identità per configurare la directory per il tuo team.", vNi = "Configurare un provider di identità per iniziare con SCIM.", bNi = "Connessione per sincronizzazione directory creata.", yNi = "Crea ed elimina account degli utenti presso il servizio di directory.", $Ni = "Connessione per sincronizzazione directory eliminata.", wNi = "Elimina Connessione", kNi = "Elimina connessione di sincronizzazione directory", SNi = "Confermi di voler eliminare questa connessione di sincronizzazione directory?", xNi = "Questa operazione non può essere annullata. Eliminerà definitivamente la connessione di sincronizzazione della directory.", ENi = "Impostazione evento: la durata deve essere di almeno 1 minuto.", TNi = "Calendario disponibilità", ANi = "Non autorizzato", CNi = "{{clientName}} vorrebbe accedere al tuo account {{appName}}", zNi = "Seleziona un account o un team", ONi = "Ciò consentirà a {{clientName}} di", PNi = "Associarti con i tuoi dati personali da {{clientName}}", INi = "Vedere i tuoi dati personali, inclusi i dati personali che hai reso disponibili al pubblico", RNi = "Vedere il tuo indirizzo e-mail principale", NNi = "Connettersi alle tue applicazioni installate", DNi = "Leggere, modificare, eliminare i tuoi tipi di eventi", MNi = "Leggere, modificare, eliminare la tua disponibilità", LNi = "Leggere, modificare, eliminare le tue prenotazioni", qNi = "Consentire a {{clientName}} di farlo?", jNi = "Facendo clic su Consenti, consentirai a questa applicazione di usare i tuoi dati in conformità ai suoi termini di servizio e informativa sulla privacy. Puoi revocare l'accesso nelle impostazioni di {{appName}} nell'App Store.", FNi = "Consenti", VNi = "Questo utente non ha completato l'onboarding. Non sarai in grado di impostare la sua disponibilità fino a quando non avrà completato l'onboarding.", BNi = "Stai visualizzando la disponibilità di questo utente. Puoi solo modificare la tua disponibilità.", UNi = "Puoi configurare queste impostazioni su base per evento nelle impostazioni avanzate di ciascun tipo di evento.", WNi = "Modifica la disponibilità dell'utente: {{username}}", GNi = "Invia di nuovo l'invito", HNi = "L'invito è stato inviato di nuovo.", KNi = "SAML", YNi = "Aggiungi cliente", ZNi = "Dopo aver copiato questa parola segreta non sarai più in grado di vederla", QNi = "Aggiungi nuovo cliente", JNi = "Aggiungi nuovo utente", XNi = "Questa applicazione non è stata ancora impostata", eDi = "come CSV", tDi = "Sovrapponi il mio calendario", nDi = "Collegando il tuo calendario, accetti la nostra informativa sulla privacy e i termini di servizio. Puoi revocare l'accesso in qualsiasi momento.", oDi = "Visualizza gli eventi del tuo calendario per prevenire prenotazioni in conflitto.", rDi = "Partecipa a {{eventLocationType}}", iDi = "Risoluzione problemi", aDi = "Calendari che stiamo controllando per conflitti", sDi = "Programmi di disponibilità", cDi = "Gestisci calendari", lDi = "Gestisci programmi di disponibilità", dDi = "Bloccato", uDi = "Sbloccato", _Di = "Blocca fuso orario nella pagina di prenotazione", pDi = "Per bloccare il fuso orario nella pagina di prenotazione, utile per gli eventi di persona.", mDi = "Puoi avere solo un'app di pagamento abilitata per ciascun tipo di evento.", fDi = "Inserisci il numero in formato internazionale.", gDi = "Installa Calendario", hDi = "Sottodominio del marchio", vDi = "Crea un sottodominio per il tuo marchio, come acme.cal.com", bDi = "Approfondimenti a livello di organizzazione", yDi = "Comprendi come la tua organizzazione utilizza il tempo", $Di = "Assistenza per l'onboarding e supporto tecnico dedicati", wDi = "Personalizza la tua esperienza di programmazione con il tuo logo, colori e altro ancora", kDi = "Numero illimitato di team", SDi = "Verifica email", xDi = "Inserisci l'indirizzo email utilizzato per questa prenotazione per procedere con la cancellazione", EDi = "L'email non corrisponde all'email di prenotazione", TDi = "Aggiungi alla tua organizzazione tutti i sotto-team necessari", ADi = "Fatturazione unificata", CDi = "Tipi di evento gestiti avanzati", zDi = "Indica una singola carta di credito per pagare tutti gli abbonamenti del tuo team", ODi = "Impresa", PDi = "Passa a Enterprise per creare la tua organizzazione", IDi = "Crea la tua organizzazione", RDi = "Crea organizzazione", NDi = "Passa a Organizations per avere sottodominio, fatturazione unificata, approfondimenti, personalizzazione completa e altro ancora", DDi = "Passa a Enterprise per poter utilizzare la sincronizzazione per Active Directory, la configurazione automatica SCIM degli utenti, gli operatori vocali Cal.ai, l'API di amministrazione e altro ancora!", MDi = "Puoi attivare solo un'app di pagamento per ciascun tipo di evento", LDi = "I team che sono membri di questa organizzazione saranno eliminati insieme ai loro tipi di eventi", qDi = "Gli utenti che facevano parte dell'organizzazione non saranno eliminati, ma i loro nomi utente verranno modificati per consentire loro di esistere al di fuori dell'organizzazione", jDi = "I tipi di eventi utente creati dopo che l'utente è entrato nell'organizzazione saranno eliminati", FDi = "I tipi di eventi utente migrati non saranno eliminati", VDi = "Eliminare {{organizationName}}?", BDi = "Pubblicato", UDi = "Pubblicazione annullata", WDi = "Pubblica", GDi = "Apri lo strumento di soluzione dei problemi per individuare il problema del tuo programma", HDi = "Hai bisogno di aiuto?", KDi = "Risoluzione problemi", YDi = "Numero da chiamare", ZDi = "Nome ospite", QDi = "E-mail ospite", JDi = "Azienda ospite", XDi = "Installa un calendario", eMi = "Prenotazione immediata", tMi = "Consenti alle persone di prenotare immediatamente", nMi = "Passa a Enterprise e permetti agli ospiti di partecipare a una chiamata immediata a cui i partecipanti possono accedere direttamente. Ciò è riservato agli eventi per team", oMi = "Non vuoi aspettare?", rMi = "Riunione iniziata", iMi = "Pagare per prenotare", aMi = "Consenti agli operatori IA di prenotare", sMi = "Prenotazione non trovata", cMi = "I posti sono esauriti", lMi = "Credenziali di pagamento mancanti", dMi = "ID dell'app di pagamento mancante", uMi = "La prenotazione non ha abbastanza posti disponibili", _Mi = "{{username}} è attualmente assente per un breve periodo.", pMi = "Nel frattempo, {{profile.username}} sarà responsabile di tutte le nuove riunioni programmate per conto di {{username}}.", mMi = "Assente", fMi = "Configura le azioni nel tuo profilo mentre sei assente.", gMi = "Invia richiesta", hMi = "Data iniziale e data finale sono obbligatorie", vMi = "La data iniziale deve precedere quella finale", bMi = "La data iniziale deve essere nel futuro", yMi = "Utente non trovato", $Mi = "Impossibile reindirizzare a se stesso", wMi = "La voce per l'assenza esiste già", kMi = "L'ID della voce per l'assenza è obbligatorio", SMi = "Esiste già un reindirizzamento della prenotazione dall'utente a te.", xMi = "Nuova voce creata correttamente", EMi = "Notifica di reindirizzamento prenotazione", TMi = "Notifica di reindirizzamento prenotazione", AMi = "Hai ricevuto un reindirizzamento di prenotazione da {{eventOwner}}, quindi i loro link del profilo saranno reindirizzati ai tuoi per l'intervallo di tempo {{dates}}.", CMi = "Notifica di modifica del reindirizzamento della prenotazione", zMi = "Notifica di Modifica del Reindirizzamento della Prenotazione", OMi = "Il tuo reindirizzamento di prenotazione da {{eventOwner}} per l'intervallo di tempo {{oldDates}} è stato aggiornato. Il nuovo intervallo di tempo per il reindirizzamento è {{dates}}.", PMi = "Notifica di cancellazione del reindirizzamento della prenotazione", IMi = "Notifica di Cancellazione del Reindirizzamento della Prenotazione", RMi = "Il tuo reindirizzamento di prenotazione da {{eventOwner}}, per l'intervallo di tempo {{dates}}, è stato annullato.", NMi = "Hai accettato questa richiesta di reindirizzamento delle prenotazioni.", DMi = "Hai rifiutato questa richiesta di reindirizzamento delle prenotazioni.", MMi = "Copia link per condividere la richiesta", LMi = "Richiesta di reindirizzamento delle prenotazioni", qMi = "Seleziona un membro del team", jMi = "Devi assentarti? Segnala che il link al tuo profilo non è disponibile per un periodo.", FMi = "Rendirizza il tuo profilo a un altro membro del team", VMi = "Reindirizza il tuo profilo a un altro membro del team (è necessario il piano Team)", BMi = "Elenco di indisponibilità per assenza", UMi = "Voce eliminata", WMi = "Voce modificata con successo", GMi = "Temporaneamente assente?", HMi = "Aggiungi un reindirizzamento", KMi = "Crea una voce", YMi = "Intervallo temporale", ZMi = "Aggiungi tutti i membri del team, compresi quelli futuri", QMi = "Reindirizza a", JMi = "Non riesci a trovare un orario?", XMi = "Mostra altro", eLi = "Parametri di inoltro come ?email=...&name=.... e altri", tLi = "Pianifica le riunioni quando tutti sono disponibili, oppure ruota tra i membri del tuo team", nLi = "più basso", oLi = "basso", rLi = "medio", iLi = "alto", aLi = "più alto", sLi = "Rimanda la persona che prenota a", cLi = "Imposta priorità", lLi = "Imposta Peso", dLi = "Abilita Pesi", uLi = "Priorità per {{userName}}", _Li = "I pesi determinano come le riunioni vengono distribuite tra gli host. <0>Scopri di più</0>", pLi = "Peso per {{userName}}", mLi = "cambia priorità", fLi = "Usa gli identificatori di campo come variabili per il reindirizzamento dell'evento personalizzato", gLi = "Usa gli identificatori di campo come variabili per il reindirizzamento dell'evento personalizzato (es: {{variable}})", hLi = "L'account è già collegato", vLi = "Invia e-mail", bLi = "Chiama il partecipante usando l'agente vocale Cal.ai", yLi = "Chiama per confermare la prenotazione", $Li = "2 ore prima dell'inizio dell'evento", wLi = "Configurazione agente Cal.ai", kLi = "Seleziona almeno un tipo di evento per effettuare una chiamata di prova.", SLi = "Contrassegna come Mancata presentazione", xLi = "Elimina contrassegno di Mancata presentazione", ELi = "Account scollegato correttamente", TLi = "Si è verificato un errore nello scollegare l'account", ALi = "Programma di viaggio", CLi = "Pianifica il tuo viaggio anticipatamente per mantenere il tuo programma esistente in un fuso orario diverso ed evitare di avere prenotazioni a mezzanotte.", zLi = "Programma un cambio di fuso orario", OLi = "Data", PLi = "Inserisci il prompt generale per l'agente", ILi = "Si sovrappone con un altro programma. Seleziona una data diversa.", RLi = "Ricevi una notifica quando il tuo team non ha disponibilità", NLi = 'Gli amministratori riceveranno una notifica via email quando un utente cerca di prenotare un membro del team e riceve il messaggio "Nessuna disponibilità". Questa email viene attivata dopo due casi, e riceverai un promemoria ogni 7 giorni per ciascun utente.  ', DLi = "Disabilita le notifiche SMS per i tipi di evento solo telefonici", MLi = "Disabilita le notifiche SMS automatiche per i tipi di evento che hanno solo il numero di telefono (attendeePhoneNumber) come domanda obbligatoria con email facoltativa o non richiesta", LLi = "Il tuo piano attuale", qLi = "$37 per utente al mese", jLi = "Gestisci le impostazioni della privacy per la tua organizzazione", FLi = "Privacy", VLi = "I nuovi team saranno nella tua organizzazione", BLi = "Aggiungi nome gruppo", ULi = "Nome gruppo", WLi = "Instradatori", GLi = "Principale", HLi = "Rendi principale", KLi = "Aggiungi Email", YLi = "Aggiungi Email", ZLi = "Aggiungi un indirizzo email con cui sostituire quello principale o da utilizzare come email alternativa per i tipi di evento.", QLi = "Conferma la tua email", JLi = "$t(hey_there) {{name}}, confermiamo la tua prenotazione per il {{date}}.", XLi = "Nome della persona che prenota", eqi = "Cognome della persona che prenota", tqi = "Nome del Pianificatore", nqi = "Il tuo nome", oqi = "Abbiamo inviato un'email a <strong>{{email}}</strong>. Clicca sul link nell'email per verificare questo indirizzo.", rqi = "Invia dettagli evento a", iqi = "Pianifica fuso orario senza data finale", aqi = "Seleziona membri", sqi = "Cosa si deve fare con i tipi di eventi esistenti di questo membro?", cqi = "Tutti i tipi di evento individuali dei membri (tranne quelli gestiti) verranno eliminati definitivamente. Non potranno crearne di nuovi", lqi = "I tipi di eventi individuali dei membri (tranne quelli gestiti) non saranno visibili nei profili, ma i link rimarranno attivi. Non potranno crearne di nuovi.  ", dqi = "Nascondi tipi di evento individuali", uqi = "Elimina tipi di evento individuali", _qi = "Blocca la creazione di tipi di evento individuali", pqi = "Impedisci ai membri di creare propri tipi di evento.", mqi = "Aggiungi al tipo di evento", fqi = "Crea password per l'account", gqi = "Crea un account con SAML", hqi = "Non è stato possibile creare la password per l'account", vqi = "Impossibile creare password per gli account cal", bqi = "Impossibile creare password per account già creati", yqi = "Non hai una password per l'account, creane una andando su Sicurezza -> Password. La disconnessione non è possibile finché non viene creata una password per l'account.", $qi = "Disconnetti l'account", wqi = "La disconnessione dell'account modifica la tua modalità di accesso. Potrai accedere all'account solamente tramite email + password", kqi = "Accetto l'informativa sulla privacy e l'uso dei cookie", Sqi = "Fai una chiamata", xqi = "Salta assegnazione round robin se il contatto è esistente in Salesforce", Eqi = "L'URL deve contenere l'email del contatto come parametro. Esempio: ?email=contactEmail", Tqi = "Seleziona account", Aqi = "Installa {{appName}} nel tuo account personale o in un account di gruppo.", Cqi = "Seleziona tipi di evento", zqi = "Su quale tipo di evento vuoi installare {{appName}}?", Oqi = "Configura {{appName}}", Pqi = "Completa l'installazione dell'app. Puoi modificare le impostazioni in seguito.", Iqi = "già installata", Rqi = "Non specificato", Nqi = "Vacanza", Dqi = "Viaggio", Mqi = "Assenza per malattia", Lqi = "Festività pubblica", qqi = "Inoltro a <0>{{username}}</0>", jqi = "Nessun inoltro", Fqi = "Crea un'assenza", Vqi = "Comunica alle persone interessate quando non sarai disponibile per le prenotazioni. Potranno comunque prenotare incontri con te al tuo ritorno, oppure puoi indirizzarli a un altro membro del tuo team.", Bqi = "{{displayName}} è assente", Uqi = "<0>{{displayName}}</0> può incaricarsi delle sue riunioni durante la sua assenza.", Wqi = "Prenota {{displayName}}", Gqi = "Seleziona motivo", Hqi = "Inizia assenza", Kqi = "Modifica Voce Fuori Ufficio", Yqi = "Invia feedback", Zqi = "L'organizzatore non si è presentato", Qqi = "Puoi programmare un nuovo incontro", Jqi = "Come possiamo migliorare il nostro servizio?", Xqi = "Cosa ti è piaciuto di più?", e9i = "Rivedere", t9i = "Con recensione", n9i = "Senza recensione", o9i = "URL di valutazione", r9i = "L'URL del modulo di valutazione", i9i = "URL per mancata presenza", a9i = "L'URL del modulo per Mancata presentazione", s9i = "Assistenza non necessaria?", c9i = "Nascondi assistenza", l9i = "Valutazione media", d9i = "Assenza (Host)", u9i = "Assenza (Ospite)", _9i = "Valutazioni recenti", p9i = "Nessuna valutazione inviata", m9i = 'Aggiungi un flusso di lavoro con "Valutazione" per raccogliere valutazioni dopo gli incontri', f9i = "Host con più assenze", g9i = "Valutazione più alta", h9i = "Valutazione più bassa", v9i = "Membri con la valutazione più alta per gli incontri", b9i = "Membri con la valutazione più bassa per gli incontri", y9i = "Punteggio CSAT", $9i = "SMS bloccati", w9i = "Uscire senza effettuare assegnazioni?", k9i = "Confermi di voler uscire da questo evento senza aggiungere partecipanti?", S9i = "Se non assegni nessuno a questo evento, chi prenota non vedrà alcuna disponibilità.", x9i = "Torna indietro ed effettua assegnazione", E9i = "Esci senza assegnazioni", T9i = "Proseguendo, accetti i nostri <0>Termini</0> e l'<1>Informativa sulla privacy</1>.", A9i = "Procedendo, accetti i nostri", C9i = "Termini", z9i = "Sempre {{x}} giorni disponibili", O9i = "Sposta automaticamente avanti ogni giorno la finestra di prenotazione di {{x}} giorni, assicurando che il tuo calendario mostri sempre i prossimi {{x}} giorni di slot disponibili.", P9i = "Abbonamento del team annullato con successo", I9i = "Errore durante l'annullamento dell'abbonamento del team", R9i = "Si è verificato un errore durante il tentativo di abbonamento al piano Platform, riprova più tardi", N9i = "Si è verificato un errore durante l'aggiornamento del client OAuth, riprova più tardi", D9i = "Si è verificato un errore in fase di creazione del client OAuth, riprova più tardi", M9i = "Colore del tipo di evento", L9i = "Questo è utilizzato solo per la differenziazione dei tipi di eventi e delle prenotazioni all'interno dell'app. Non viene visualizzato ai prenotatori.", q9i = "Contrassegna come Mancata presentazione", j9i = "{{x}} contrassegnati come Mancata presentazione", F9i = "Rimossi {{x}} contrassegni di Mancata presentazione", V9i = "attiva per tutti i tipi di eventi del team e per tutti i tipi di eventi personali dei membri del team", B9i = "Gestisci le impostazioni del tuo team", U9i = "Stato di Mancata presentazione aggiornato per i partecipanti", W9i = "Email copiata", G9i = "Numero di telefono copiato", H9i = "L'utente è un membro in sospeso dell'organizzazione", K9i = "L'utente è già stato invitato o è un membro", Y9i = "L'utente è membro di un'organizzazione di cui questo team non fa parte.", Z9i = "La prenotazione è stata riassegnata", Q9i = "Riassegna", J9i = "Riassegna la prenotazione a un altro host round robin disponibile", X9i = "Assegna membro del team", eji = "Sostituisci il membro del team che vuoi assegnare.", tji = "Nessun host disponibile", nji = "Riassegna host round robin", oji = "Non scrivere nel feed ICS", rji = "Non è possibile riprogrammare poiché l'evento è scaduto", iji = "Questo evento è scaduto", aji = "Salta la creazione di contatti se non esistono in {{appName}}", sji = "Se il tuo link ICS è in sola lettura (ad esempio, Proton Calendar), seleziona la casella sopra per evitare errori. Dovrai anche aggiornare manualmente il tuo calendario per le modifiche.", cji = "Attributi", lji = "Nuovo attributo", dji = "Aggiungi attributi", uji = "Aggiungi attributi ai membri del tuo team", _ji = "Nuova opzione", pji = "Aggiorna membro", mji = "Attributo", fji = "Crea un attributo per i membri del tuo team", gji = "Modifica un attributo per i membri del tuo team", hji = "Attributo aggiornato con successo", vji = "Attributo eliminato con successo", bji = "Attributi modificati con successo", yji = "Gestisci gli attributi per i membri del tuo team", $ji = "Modifica gli attributi per i membri del tuo team", wji = "Torna agli attributi", kji = "Sei sicuro di voler eliminare questa opzione?", Sji = "Questa opzione è assegnata a {{numberOfUsers}} membri. Eliminandola, verrà rimossa dal loro profilo.", xji = "Disabilita le email standard ai partecipanti relative a questo tipo di evento", Eji = "Disabilita la comunicazione email standard relativa a questo tipo di evento, incluse le conferme di prenotazione, i promemoria e le cancellazioni.", Tji = "Disabilita le email standard agli host relative a questo tipo di evento", Aji = "Digita conferma per continuare", Cji = "Disabilita email", zji = "Concedi accesso API amministratore", Oji = "Revoca accesso API amministratore", Pji = "Aggiungi il calendario {{calendar}}", Iji = "Connetti Calendario Apple", Rji = "Calendario Apple connesso", Nji = "Verifica Calendario Apple", Dji = "Connetti Calendario Google", Mji = "Calendario Google connesso", Lji = "Verifica Calendario Google", qji = "Connetti Calendario Outlook", jji = "Calendario Outlook connesso", Fji = "Verifica Calendario Outlook", Vji = "Collegati a Stripe", Bji = "Stripe collegato", Uji = "Verifica delle credenziali Stripe in corso", Wji = "Variabili di risposta alle domande di prenotazione", Gji = "Gestito da {{teamAdmins}}", Hji = "{{count}} opzioni", Kji = "Ripianifica con lo stesso host Round-Robin", Yji = "Gli eventi ripianificati saranno assegnati allo stesso host inizialmente programmato", Zji = "Disabilita input se l'identificatore URL è precompilato", Qji = "Limiti di Prenotazione", Jji = "Limiti di prenotazione per i membri del team in tutti i tipi di eventi del team", Xji = "Limita quante volte i membri possono essere prenotati su tutti i tipi di eventi del team", eFi = "Limiti di prenotazione aggiornati con successo", tFi = "Non sei autorizzato a effettuare questa modifica alla prenotazione", nFi = "Credenziale di delega disabilitata", oFi = "Membri corrispondenti", rFi = "{{x}} membri corrispondenti", iFi = "Coda di membri corrispondenti (utilizzando i pesi degli attributi)", aFi = "Coda di membri corrispondenti (utilizzando i pesi degli assegnatari dell'evento)", sFi = "Nessun membro corrispondente. Verrà utilizzato il fallback con i membri del team assegnati al tipo di evento.", cFi = "Nessun membro corrispondente. Si utilizzeranno i membri del team assegnati al tipo di evento come fallback. Considera di aggiungere un fallback o correggere la logica di using_fallback_members", lFi = "Nascondi i dettagli degli eventi del calendario nei calendari condivisi", dFi = "Quando un calendario è condiviso, gli eventi sono visibili ai lettori ma i loro dettagli sono nascosti a chi non ha accesso in scrittura.", uFi = "Ultimi {{count}} giorni", _Fi = "Mese corrente", pFi = "Anno corrente", mFi = "Intervallo personalizzato", fFi = "Politica di rimborso", gFi = "Sempre", hFi = "Mai", vFi = "Opzione di pagamento", bFi = "Se cancellato", yFi = "prima", $Fi = "Mostra tutte le colonne", wFi = "Attiva/disattiva colonne", kFi = "Nessuna colonna trovata", SFi = "Al momento della prenotazione, aggiungi eventi e nuovi partecipanti come:", xFi = "Lead", EFi = "Contatto sotto un account", TFi = "Salta la creazione del record {{entry}} se non esistono in Salesforce", AFi = "Se il contatto non esiste sotto un account, crea un nuovo lead dal partecipante", CFi = "Crea un nuovo contatto sotto un account basato sul dominio email del partecipante e contatti esistenti", zFi = "Cambia proprietario del record alla prenotazione", OFi = "Assegna attributi in massa", PFi = "Risulta nella visualizzazione di un messaggio personalizzato. Prova a modificare la risposta per indirizzare a un evento", IFi = "Risulta nel reindirizzamento a {{externalUrl}}. Prova a modificare la risposta per indirizzare a un evento", RFi = "Possibile host", NFi = "Stato di instradamento attuale", DFi = "Reindirizza prenotazione", MFi = "Reindirizza la prenotazione a diversi membri del team", LFi = "Verifica nuovo percorso", qFi = "Reindirizza", jFi = "Nuovo stato di instradamento", FFi = "Se il partecipante esiste in Salesforce, prenota direttamente con il proprietario", VFi = "Entità per verificare il proprietario per prenotare direttamente", BFi = "Account", UFi = "Scegli gli orari degli host", WFi = "Puoi selezionare un orario diverso per ogni host. L'orario predefinito di ciascun host è selezionato di default.", GFi = "Nessun host assegnato, aggiungi host nella scheda di assegnazione.", HFi = "Riassegna manualmente l'host round robin", KFi = "Riassegna manualmente l'host round robin a un altro host disponibile", YFi = "Riassegna l'host round robin a un altro host disponibile", ZFi = "Il nuovo utente non è un host round robin valido per questo tipo di evento", QFi = "Il nuovo utente è un host fisso per questo tipo di evento", JFi = "Riprogramma con lo stesso slot orario", XFi = "Riprogramma con lo stesso slot orario del nuovo evento", e8i = "Riprogramma al nuovo evento con slot orario diverso", t8i = "Riprogramma con slot orario diverso", n8i = "Non abbiamo l'ID per il nuovo evento. Per favore, vai al Modulo di Instradamento e salvalo di nuovo.", o8i = "Prenotazione reindirizzata con successo. Reindirizzamento alla pagina di prenotazione", r8i = "Alla prenotazione, scrivi nell'oggetto evento", i8i = "Nome del campo", a8i = "Aggiungi nuovo campo", s8i = "Non hai l'accesso per reindirizzare questa prenotazione", c8i = "Risposta del modulo non trovata", l8i = "Proprietario del contatto", d8i = "Non trovato", u8i = "Utilizzo dei membri di fallback", _8i = "Percorso scelto", p8i = "Logica degli attributi corrispondente", m8i = "Logica di fallback degli attributi corrispondente", f8i = "Tutti i membri assegnati al tipo di evento del team. Considera di aggiungere alcune regole di attributo.", g8i = "Tutti i membri assegnati al tipo di evento del team. Considera di aggiungere alcune regole di attributo al fallback.", h8i = "Tutti i membri assegnati al tipo di evento del team. Considera di modificare il fallback per ottenere una corrispondenza.", v8i = "Attenzione", b8i = "Fallback: se nessun membro del team corrisponde, usa quelli che soddisfano i seguenti criteri (corrisponde a tutti i membri del team assegnati all'evento per impostazione predefinita)", y8i = "Avviso di fallback", $8i = "Non necessario", w8i = "Host non disponibile", k8i = "Host disponibile", S8i = "Sei sicuro di voler riassegnare questa prenotazione a un host non disponibile?", x8i = "Sei sicuro di voler riassegnare questa prenotazione?", E8i = "Sì, riassegna", T8i = "Filtra per attributi", A8i = "Motivo della riassegnazione", C8i = "La modifica del tipo di campo potrebbe causare perdita di dati. Si consiglia di creare un nuovo campo.", z8i = "Riassegnato da", O8i = "riga", P8i = "righe", I8i = "Fuso orario del partecipante", R8i = "Ora di inizio evento nel fuso orario del partecipante", N8i = "Ora di inizio evento nel fuso orario del partecipante", D8i = "Ora di fine evento nel fuso orario del partecipante", M8i = "Ora di fine evento nel fuso orario del partecipante", L8i = "Crea evento sul contatto, se esiste. Altrimenti, passa al lead", q8i = "Nome del proprietario da modificare", j8i = "Nessun filtro impostato", F8i = "Test di prenotazione completato con successo", V8i = "Il test di prova è stato completato con successo.", B8i = "Non hai accesso a questa pagina", U8i = "Per visualizzare o interagire con questa pagina, devi avere privilegi di amministratore o proprietario", W8i = "Tipo di campo", G8i = "Quando scrivere", H8i = "Al momento della prenotazione, scrivi in un campo personalizzato nel record {{record}} del partecipante", K8i = "Ad ogni prenotazione", Y8i = "Solo se il campo è vuoto", Z8i = "Data di inizio prenotazione", Q8i = "Data di creazione della prenotazione", J8i = "Prenotazione riassegnata a {{host}}", X8i = "Nessun proprietario del contatto", e7i = "Moduli di instradamento creati", t7i = "Risposte totali", n7i = "Risposte totali senza prenotazione", o7i = "Risposte totali con prenotazione", r7i = "Nessuna prenotazione", i7i = "Nome del modulo", a7i = "Prenotazione", s7i = "Nessuna prenotazione", c7i = "Prenotato da", l7i = "Creato il", d7i = "Stato della prenotazione", u7i = "Data prenotazione", _7i = "Data invio", p7i = "Copia URL di reindirizzamento", m7i = "URL di reindirizzamento all'uscita", f7i = "Prenotazioni totali per periodo", g7i = "Instradamenti per periodo", h7i = "Al giorno", v7i = "A settimana", b7i = "Al mese", y7i = "Motivo dell'assegnazione", $7i = "Accesso negato", w7i = "Il proprietario del contatto sarà l'host del Round Robin se disponibile", k7i = "Aggiungi nuovi partecipanti come", S7i = "Il proprietario del contatto non sarà obbligato (può comunque essere l'host se corrisponde agli attributi e ai criteri del Round Robin)", x7i = "Instrada a un utente che corrisponde a un campo di ricerca su un account", E7i = "Opzione Salesforce", T7i = "Nome del campo di ricerca", A7i = "Se il partecipante ha un dominio email gratuito, salta il controllo della proprietà e procedi con il round robin normalmente", C7i = "È", z7i = "Non è", O7i = "Contiene", P7i = "Non contiene", I7i = "Inizia con", R7i = "Finisce con", N7i = "È vuoto", D7i = "Non è vuoto", M7i = "Auto traduci titolo e descrizione", L7i = "Traduci automaticamente titoli e descrizioni nella lingua del browser del visitatore utilizzando l'IA.", q7i = "Distribuzione", j7i = "Permette di ottimizzare la distribuzione per massimizzare la disponibilità o per ottenere un'assegnazione più bilanciata.", F7i = "Massimizza disponibilità", V7i = "Permette ai prenotanti di fissare incontri ogni volta che un host è disponibile. Usa questa opzione per massimizzare il numero di potenziali incontri prenotabili e quando la distribuzione uniforme degli incontri tra gli host è meno importante.", B7i = "Bilanciamento del carico", U7i = "Monitoreremo quante prenotazioni sono state effettuate con ciascun host e le confronteremo con gli altri, disabilitando alcuni host che sono troppo avanti per garantire una distribuzione uniforme delle prenotazioni.", W7i = "Modifica pesi", G7i = "Pesi aggiornati con successo", H7i = "Richiedi conferma solo per i provider di posta elettronica gratuiti (Es. @gmail.com, @outlook.com)", K7i = "Escludi le email che contengono ...", Y7i = "Richiedi email che contengono ...", Z7i = "Inserisci un indirizzo email di lavoro valido", Q7i = "Non sei autorizzato a prenotare con questo dominio email. Contatta il proprietario di questo link.", J7i = "Cerca colonne", X7i = "Opzioni di ricerca", eVi = "Disabilita il profilo pubblico dell'organizzazione e reindirizza", tVi = "Reindirizza {{orgSlug}}.cal.com a {{destination}}", nVi = "Selezione singola", oVi = "Selezione multipla", rVi = "Impostazioni conflitti calendario", iVi = "Seleziona quali calendari controllare per i conflitti", aVi = "Riunione di gruppo", sVi = "Sei sicuro di voler rimuovere questa app da", cVi = "Disconnetti l'app da", lVi = "Non creare nuovi record per gli ospiti aggiunti alla prenotazione", dVi = "Google Meet", uVi = "Zoom", _Vi = "Video MS Teams", pVi = "Blocca per assegnazione", mVi = "Il blocco consentirà solo le assegnazioni da Directory Sync", fVi = "Attributo modificato con successo", gVi = "Nuova opzione gruppo", hVi = "Pesi abilitati", vVi = "Abilitando i pesi, sarà possibile assegnare una priorità più alta a determinati attributi per utente. Maggiore è il peso, maggiore è la priorità.", bVi = "Instradato", yVi = "Riassegnato", $Vi = "Consenti la riprogrammazione di eventi passati", wVi = "L'attivazione di questa opzione permette di riprogrammare eventi già conclusi", kVi = "Reindirizzato", SVi = "Assegnazione Salesforce", xVi = "Posizione del router", EVi = "Mostra host corrispondenti", TVi = "Nessuna coda attiva per questo input", AVi = "Peso", CVi = "Calibrazione", zVi = "Deficit", OVi = "Modulo di instradamento", PVi = "Torna indietro e salva", IVi = "Salva modifiche", RVi = "Esci senza salvare", NVi = "Sei sicuro di voler uscire senza salvare le modifiche al tuo modulo di instradamento?", DVi = "Si è verificato un errore imprevisto", MVi = "Stai effettuando una prenotazione di prova.", LVi = "Galleria delle icone", qVi = "Galleria delle icone", jVi = "Migrazione dal team", FVi = "La funzionalità è attualmente disattivata", VVi = "Scegli un'opzione", BVi = "Inserisci il valore dell'opzione", UVi = "Rimuovi opzione", WVi = "Usa pesi degli attributi", GVi = "Se abilitato, tutti i pesi impostati nel tipo di evento verranno ignorati", HVi = "Attributo per i pesi", KVi = "Utenti gestiti", YVi = "Visualizza tutti gli utenti gestiti creati dal tuo client OAuth", ZVi = "Puoi dirmi qualcosa su ", QVi = "Usa l'IA per rispondere alle tue domande", JVi = "Errore durante il recupero della risposta ", XVi = "Si è verificato un errore imprevisto. Per favore, riprova più tardi", eBi = "Seleziona client OAuth", tBi = "Su ogni istanza", nBi = "La funzionalità di credenziale di delega non è abilitata per la tua organizzazione", oBi = "Nota interna", rBi = "Motivo condiviso con il cliente (opzionale)", iBi = "Questa nota sarà visibile solo ai membri del tuo team", aBi = "Modelli di note interne di cancellazione", sBi = "Crea modelli per note interne che possono essere applicati alle prenotazioni", cBi = "Modelli di note interne aggiornati con successo", lBi = "Aggiungi modello", dBi = "Autorizza", uBi = "Avanti", _Bi = "Nascondi", pBi = "Mostra", mBi = "Parametri UTM", fBi = "Nessun parametro UTM disponibile.", gBi = "Crescente", hBi = "Decrescente", vBi = "Verifica la modifica dell'email", bBi = "Acquista crediti", yBi = "Crediti", $Bi = "Crediti utilizzati", wBi = "Totale rimanente", kBi = "Ricevi 1000 crediti al mese per ogni membro del team", SBi = "Ricevi 750 crediti al mese per ogni membro del team", xBi = "Visualizza e gestisci i crediti per l'invio di messaggi SMS", EBi = "Visualizza e gestisci i crediti per l'invio di messaggi SMS. Un credito vale 1¢ (USD). <0>Scopri di più</0>", TBi = "Un credito vale 1¢ (USD). <0>Scopri di più</0>", ABi = "Acquista crediti aggiuntivi ($0.01 per credito)", CBi = "Puoi visualizzare la spesa di crediti aggiuntivi nel registro delle spese", zBi = "Panoramica", OBi = "Lo slug dell'organizzazione è già stato preso", PBi = "Non puoi creare un'organizzazione poiché fai già parte di un'organizzazione", IBi = "Devi completare l'onboarding utente prima di creare un'organizzazione", RBi = "Usa l'email aziendale per creare un'organizzazione", NBi = "Non puoi creare un'organizzazione piattaforma poiché fai già parte di un team", DBi = "Devi avere un numero minimo di team pubblicati", MBi = "Fai già parte di questa organizzazione", LBi = "Fai parte di un'altra organizzazione, non puoi creare una nuova organizzazione", qBi = "Fai parte di un'altra organizzazione della piattaforma, non puoi creare una nuova organizzazione", jBi = "Pagamento dell'organizzazione riuscito", FBi = "La tua organizzazione è stata creata con successo", VBi = "Questo potrebbe richiedere alcuni secondi...", BBi = "Stato dell'onboarding dell'organizzazione", UBi = "Descrizione dello stato dell'onboarding dell'organizzazione", WBi = "Pagamento fallito", GBi = "Il tuo pagamento non è andato a buon fine. Per favore, riprova.", HBi = "Creazione della tua organizzazione", KBi = "Onboarding dell'organizzazione già completato", YBi = "L'onboarding dell'organizzazione esiste già", ZBi = "Onboarding dell'organizzazione non trovato", QBi = "Pagamento riuscito!", JBi = "Passaggio di consegne dell'onboarding", XBi = "Passaggio di consegne dell'onboarding all'utente", eUi = "Un'organizzazione con questo slug esiste già", tUi = "Non hai il permesso di creare un'organizzazione per questa email", nUi = "Non hai il permesso di migrare uno o più team", oUi = "L'organizzazione ha già un abbonamento", rUi = "Intervallo di reset per Round Robin ponderato", iUi = "Intervallo", aUi = "Determina la frequenza con cui il conteggio delle prenotazioni round robin viene azzerato per garantire una distribuzione equilibrata.", sUi = "Giornaliero", cUi = "Non hai impostato una data di fine per la tua assenza", lUi = "Le mie assenze", dUi = "Assenze del team", uUi = "Gestisci le assenze del tuo team.", _Ui = "Crea assenza", pUi = "Crea un'assenza per un membro del team", mUi = "Modifica un'assenza per un membro del team", fUi = "Crea assenze per il tuo team", gUi = "Comunica ai prenotatori quando i membri del tuo team non sono disponibili per le prenotazioni. Potranno comunque essere prenotati al loro ritorno o puoi reindirizzarli a un altro membro del team.", hUi = "Il reindirizzamento delle assenze è consentito solo a un membro dello stesso team.", vUi = "Esiste già un reindirizzamento inverso tra questi utenti.", bUi = "Nessuna assenza precedente trovata", yUi = "Precedente", $Ui = "Intervallo Round Robin aggiornato con successo", wUi = "Modalità di prova", kUi = "Piano team inattivo", SUi = "Il tuo piano team è inattivo. Controlla il tuo abbonamento o contatta l'assistenza clienti", xUi = "Accesso limitato durante la prova. Funzionalità disponibile al termine del periodo di prova.", EUi = "Programma di referral", TUi = "Guadagna il 20% di referral", AUi = "Hai bisogno di una chiave API Dub e di un ID programma per utilizzare questa pagina.", CUi = "UID", zUi = "Link", OUi = "righe per pagina", PUi = "{{currentRange}} di {{totalItems}}", IUi = "Suggerimento: puoi aggiungere un '+' tra i nomi utente: cal.com/anna+brian per creare un incontro di gruppo dinamico", RUi = "Non hai ancora un team", NUi = "Non hai ancora membri del team", DUi = "L'evento ricorrente non supporta la funzionalità dei posti. Rendilo non ricorrente per abilitare i posti.", MUi = "L'evento ricorrente non supporta la funzionalità di limite di prenotazione per prenotatore. Disabilita il limite di prenotazione per prenotatore per abilitare l'evento ricorrente.", LUi = "La funzionalità dei posti non supporta eventi ricorrenti. Disabilita la funzionalità dei posti per renderlo ricorrente.", qUi = "L'evento ricorrente non supporta la funzionalità dei posti. Disabilita la funzionalità dei posti o rendi l'evento non ricorrente.", jUi = "Segmento", FUi = "Filtri salvati", VUi = "Rinomina", BUi = "Rinomina segmento", UUi = "Elimina segmento", WUi = "Duplica segmento", GUi = "Sei sicuro di voler eliminare questo segmento? Questa azione non può essere annullata.", HUi = "Segmento di filtro aggiornato", KUi = "Errore durante l'aggiornamento del segmento di filtro", YUi = "Segmento di filtro duplicato", ZUi = "Errore durante la duplicazione del segmento di filtro", QUi = "Segmento di filtro eliminato", JUi = "Errore durante l'eliminazione del segmento di filtro", XUi = "Salva segmento", eWi = "Segmento non trovato", tWi = "Segmento di filtro salvato", nWi = "Nessun segmento", oWi = "Errore durante il salvataggio del segmento di filtro", rWi = 'Salva modifiche in "{{name}}"', iWi = "Crea nuovo segmento", aWi = "Salva per il team", sWi = "Seleziona team", cWi = "Per favore seleziona un team", lWi = "Personale", dWi = "Nascondi link al profilo del team", uWi = "Nascondi il link al profilo del team nelle pagine di prenotazione", _Wi = "Visualizzazione", pWi = "Impossibile trovare lo slug per pubblicare l'organizzazione", mWi = "Lista di selezione", fWi = "Prenotazioni più cancellate", gWi = "Lingua dell'interfaccia", hWi = "Imposta la tua lingua preferita per l'interfaccia di prenotazione", vWi = "Lingua del browser del visitatore", bWi = "Nome o email", yWi = "Se non viene trovato alcun contatto, passa al proprietario del lead se esiste", $Wi = "Acquisto crediti fallito. Riprova o contatta l'assistenza.", wWi = "Minimo di 50 crediti richiesti", kWi = "Abilita credenziale di delega", SWi = "Concedi a Cal.com l'accesso automatico ai calendari di tutti i membri dell'organizzazione abilitando la credenziale di delega.", xWi = "Disabilita credenziale di delega", EWi = "Una volta disabilitata la credenziale di delega, i membri dell'organizzazione che non hanno collegato i propri calendari dovranno farlo manualmente.", TWi = "Ultima attività", AWi = "Membro dal", CWi = "Ultimo aggiornamento", zWi = "In caso di prenotazione annullata, scrivi nel record dell'evento invece di eliminarlo", OWi = "Ad ogni cancellazione", PWi = "Segnala un problema", IWi = "Puoi inviare un ticket su GitHub o aggiornare il tuo piano per ricevere supporto in tempo reale con conferenze per sviluppatori", RWi = "Apri segnalazione", NWi = "Questo è il tuo piano attuale", DWi = "Programma un orario", MWi = "Questo include:", LWi = "Client OAuth aggiornato con successo", qWi = "Client OAuth non trovato.", jWi = "Abbonati alla piattaforma", FWi = "Errore durante il tentativo di accesso ai webhook.", VWi = "Aggiornamento del webhook fallito.", BWi = "Creazione del webhook fallita.", UWi = "Link non valido", WWi = "Attualmente sei abbonato al piano {{planFirstLetter}}{{planRest}}", GWi = "Utente/Team", HWi = "ID client copiato!", KWi = "Secret del client copiato!", YWi = "Il team di Cal.com sta eseguendo una manutenzione programmata. Per qualsiasi domanda, contatta l'assistenza.", ZWi = "Il tuo pagamento è fallito", QWi = "Controlla la tua casella di posta", JWi = "Il tuo account è stato creato, ma il tuo premium non è stato riservato.", XWi = "Abbiamo inviato un'email a {{email}} con un link per attivare il tuo account.", eGi = "Una volta attivato l'account potrai provare ad acquistare il tuo nome utente premium o selezionarne uno diverso.", tGi = "Apri in Gmail", nGi = "Non vedi un'email?", oGi = "Reinvia tra {{seconds}} secondi", rGi = "Reinvia", iGi = "Email di verifica inviata", aGi = "Seleziona tutti i membri", sGi = "Selezionando tutti i membri verranno aggiunti tutti i futuri membri del team quando vengono aggiunti al team.", cGi = "Impostazioni modulo", lGi = "Rimuovi stato whitelist", dGi = "Inserisci in whitelist i flussi di lavoro utente", uGi = "Flussi di lavoro utente inseriti in whitelist", _Gi = "Flussi di lavoro utente rimossi dalla whitelist", pGi = "Data e ora", mGi = "Questo è un promemoria per il tuo prossimo evento.", fGi = "Questo promemoria è stato attivato da un Workflow in Cal.", gGi = "Evento", hGi = "Pianificato da", vGi = "Come è stata la tua recente esperienza?", bGi = "Cerchiamo sempre di migliorare l'esperienza dei clienti.", yGi = "Quanto sei soddisfatto del tuo ultimo incontro?", $Gi = "non hai partecipato all'incontro?", wGi = "Riprogramma qui.", kGi = "Nascondi email dell'organizzatore", SGi = "Fai già parte di un'organizzazione della piattaforma, per questo motivo non puoi creare una nuova organizzazione. Ogni utente può appartenere a una sola organizzazione. Per favore, crea un nuovo account cal.com con un'email diversa e usa quell'account per iscriverti al piano organizzazioni.", xGi = "Fai già parte di un'organizzazione, per questo motivo non puoi creare un'organizzazione della piattaforma. Ogni utente può appartenere a una sola organizzazione. Per favore, crea un nuovo account cal.com con un'email diversa e usa quell'account per iscriverti al piano piattaforma.", EGi = "Nascondi l'indirizzo email dell'organizzatore dalla schermata di prenotazione, dalle notifiche email e dagli eventi del calendario", TGi = "Tu &", AGi = "Seleziona un'email verificata", CGi = "Aggiungi email verificata", zGi = "Aggiungi email verificate", OGi = "Email 'Rispondi a' personalizzata", PGi = "Usa un indirizzo email diverso come replyTo per le email di conferma invece dell'email dell'organizzatore", IGi = "Questo sondaggio è stato attivato da un Workflow in Cal.", RGi = "Salta periodo di prova", NGi = "Periodi di prova del team saltati con successo", DGi = "Inserendo il tuo numero di telefono acconsenti a ricevere messaggi SMS per questo evento. Potrebbero essere applicate tariffe SMS.", MGi = "Maggiori informazioni sono disponibili in <0>Analisi di instradamento</0>", LGi = "Risultati", qGi = "Visualizza modulo", jGi = "Invia STOP per disattivare i messaggi SMS", FGi = "Il tuo team {{teamName}} sta esaurendo i crediti", VGi = "Stai esaurendo i crediti", BGi = "[Azione richiesta] Il tuo team {{teamName}} ha esaurito i crediti", UGi = "[Azione richiesta] Hai esaurito i crediti", WGi = "Il tuo team Cal.com {{teamName}} sta esaurendo i crediti. Per evitare interruzioni del servizio, acquista crediti aggiuntivi. Se il saldo si esaurisce, i messaggi SMS smetteranno di essere inviati e verranno inviati come email.", GGi = "Il tuo account Cal.com sta esaurendo i crediti. Per evitare interruzioni del servizio, acquista crediti aggiuntivi. Se il saldo si esaurisce, i messaggi SMS smetteranno di essere inviati e verranno inviati come email.", HGi = "Il tuo team Cal.com {{teamName}} ha esaurito i crediti. Di conseguenza, i messaggi SMS vengono ora inviati tramite email. Per riprendere l'invio di SMS, acquista crediti aggiuntivi.", KGi = "Il tuo account Cal.com ha esaurito i crediti. Di conseguenza, i messaggi SMS vengono ora inviati tramite email. Per riprendere l'invio di SMS, acquista crediti aggiuntivi.", YGi = "Saldo attuale: {{balance}} crediti", ZGi = "Saldo attuale:", QGi = "Notifica sulla tua prenotazione", JGi = "Crediti mensili", XGi = "Crediti totali: {{totalCredits}}", eHi = "Crediti rimanenti: {{remainingCredits}}", tHi = "Rimanente", nHi = "Totale", oHi = "Crediti aggiuntivi", rHi = "{{count}} successivi in coda", iHi = "Invia risposte email a", aHi = "Prenotazioni incomplete", sHi = "Includi prenotazioni non presentate nei calcoli round robin", cHi = "Ospiti recenti non presentati", lHi = "Mostra le prenotazioni in cui tutti i partecipanti non si sono presentati, non le assenze parziali", dHi = "Corrispondenza", uHi = "Reindirizzamento evento", _Hi = "Reimposta modulo", pHi = "Impostazioni Round Robin aggiornate con successo", mHi = "Base di distribuzione per Round Robin ponderato", fHi = "Determina quale timestamp dell'evento viene utilizzato come base per la distribuzione Round Robin ponderata.", gHi = "Richiede crediti", hHi = "Devi avere abbastanza crediti nel tuo account per utilizzare questa funzionalità", vHi = "Crediti disponibili", bHi = "Crea ruolo", yHi = "Ruoli e permessi", $Hi = "Gestisci ruoli e permessi per la tua organizzazione", wHi = "Scopri di più su come funzionano i permessi", kHi = "Nome del ruolo", SHi = "Il nome del ruolo è obbligatorio", xHi = "es. Team vendite, Staff di supporto", EHi = "Descrizione del ruolo", THi = "Descrivi a cosa serve questo ruolo e quali permessi necessita", AHi = "Ruolo predefinito", CHi = "Ruolo personalizzato", zHi = "Avanzate", OHi = "Cerca autorizzazioni", PHi = "Tutte le autorizzazioni", IHi = "Nessuna", RHi = "Sola lettura", NHi = "Tutte le azioni su tutte le risorse", DHi = "Tutte le risorse", MHi = "Tipi di evento", LHi = "Team", qHi = "Organizzazione", jHi = "Prenotazioni", FHi = "Approfondimenti", VHi = "Ruoli", BHi = "Moduli di instradamento", UHi = "Flussi di lavoro", WHi = "Tutte le azioni", GHi = "Crea", HHi = "Visualizza", KHi = "Modifica", YHi = "Elimina", ZHi = "Gestisci", QHi = "Invita", JHi = "Rimuovi", XHi = "Cambia ruolo membro", eKi = "Elenca membri", tKi = "Gestisci fatturazione", nKi = "Visualizza prenotazioni del team", oKi = "Visualizza prenotazioni dell'organizzazione", rKi = "Visualizza registrazioni", iKi = "Accedi con altra identità", aKi = "Ruolo creato con successo", sKi = "Ruolo aggiornato con successo", cKi = "Elimina ruolo", lKi = "Sei sicuro di voler eliminare il ruolo: {{roleName}}? Questa azione non può essere annullata.", dKi = "Ruolo eliminato con successo", uKi = "Errore durante la creazione del ruolo", _Ki = "Errore durante l'aggiornamento del ruolo", pKi = "Crea ruoli", mKi = "Attributi", fKi = "Visualizza attributi dell'organizzazione", gKi = "Aggiorna attributi dell'organizzazione", hKi = "Elimina attributi dell'organizzazione", vKi = "Crea attributi dell'organizzazione", bKi = "Visualizza ruoli", yKi = "Aggiorna ruoli", $Ki = "Elimina ruoli", wKi = "Crea e configura nuovi flussi di lavoro", kKi = "Configurazione richiesta", SKi = "Visualizza flussi di lavoro esistenti e le loro configurazioni", xKi = "Modifica e cambia le impostazioni dei flussi di lavoro", EKi = "Rimuovi flussi di lavoro dal sistema", TKi = "Webhook", AKi = "Disponibilità", CKi = "Fuori sede", zKi = "Crea webhook", OKi = "Visualizza webhook", PKi = "Aggiorna webhook", IKi = "Elimina webhook", RKi = "Crea disponibilità", NKi = "Visualizza disponibilità", DKi = "Aggiorna disponibilità", MKi = "Elimina disponibilità", LKi = "Crea fuori sede", qKi = "Visualizza fuori sede", jKi = "Aggiorna fuori sede", FKi = "Elimina fuori sede", VKi = "Accesso completo alla gestione di tutti i flussi di lavoro", BKi = "Crea tipi di evento", UKi = "Visualizza tipi di evento", WKi = "Aggiorna tipi di evento", GKi = "Elimina tipi di evento", HKi = "Tutte le azioni sui tipi di evento", KKi = "Crea team", YKi = "Visualizza dettagli del team", ZKi = "Aggiorna impostazioni del team", QKi = "Elimina team", JKi = "Invita membri del team", XKi = "Rimuovi membri del team", eYi = "Cambia ruolo dei membri del team", tYi = "Accedi con l'identità dei membri del team", nYi = "Tutte le azioni sui team dell'organizzazione", oYi = "Crea organizzazione", rYi = "Visualizza dettagli dell'organizzazione", iYi = "Elenca membri dell'organizzazione", aYi = "Invita membri dell'organizzazione", sYi = "Rimuovi membri dell'organizzazione", cYi = "Gestisci fatturazione dell'organizzazione", lYi = "Cambia ruolo dei membri dell'organizzazione", dYi = "Accedi con l'identità dei membri dell'organizzazione", uYi = "Modifica impostazioni dell'organizzazione", _Yi = "Tutte le azioni sulle organizzazioni", pYi = "Visualizza prenotazioni", mYi = "Visualizza prenotazioni del team", fYi = "Visualizza prenotazioni dell'organizzazione", gYi = "Visualizza registrazioni delle prenotazioni", hYi = "Aggiorna prenotazioni", vYi = "Tutte le azioni sulle prenotazioni", bYi = "Visualizza insight del team", yYi = "Gestisci insight del team", $Yi = "Crea moduli di instradamento", wYi = "Visualizza moduli di instradamento", kYi = "Aggiorna moduli di instradamento", SYi = "Elimina moduli di instradamento", xYi = "Il permesso di lettura viene abilitato automaticamente quando si crea, aggiorna o elimina una risorsa", EYi = "Aggiungi programma di restrizione", TYi = "Limita la disponibilità degli host per mostrare solo gli slot che rientrano in un programma specificato.", AYi = "Usa fuso orario del prenotante", CYi = "Applica il programma di restrizione selezionato nel fuso orario del prenotante", zYi = "Questo disabiliterà il bilanciamento del carico su tutti i tuoi tipi di evento round robin", OYi = "Il bilanciamento del carico è disponibile solo quando la base temporale è impostata su Orario di creazione della prenotazione", PYi = "Il bilanciamento del carico non è disponibile con i gruppi Round Robin", IYi = "Personalizza le impostazioni predefinite del round robin per questo team", RYi = "Impostazioni Round Robin aggiornate con successo", NYi = "Orario di creazione prenotazione", DYi = "Orario di inizio meeting", MYi = "Membri interessati", LYi = "Nessun membro interessato dalla disabilitazione delle credenziali di delega", qYi = "Scarica il registro delle spese", jYi = "Errore durante il download del registro delle spese", FYi = "Offri di riprogrammare l'ultima prenotazione attiva nella fascia oraria scelta", VYi = "Limite massimo di prenotazioni attive superato", BYi = "Hai già una prenotazione per questo evento il {{date}}. Vuoi riprogrammarla al nuovo orario selezionato?", UYi = "La durata deve essere di almeno {{min}} minuto/i", WYi = "La durata non può superare {{max}} minuti (24 ore)", GYi = "Prenotazione al di fuori della disponibilità del programma di restrizione.", HYi = "Programma di restrizione non trovato", KYi = "Limite di dimensione dell'immagine superato, utilizza un'immagine più piccola preferibilmente in formato JPEG", YYi = "Aggiungi gruppo", ZYi = "Funnel di instradamento", QYi = "Invii totali", JYi = "Instradamenti riusciti", XYi = "Prenotazioni accettate", eZi = "Chiave di licenza", tZi = "Scegli la tua licenza", nZi = "Seleziona come vuoi concedere in licenza la tua implementazione di Cal.com", oZi = "Utilizza Cal.com con la licenza open source AGPLv3", rZi = "Inserisci la chiave di licenza", iZi = "Accesso a tutte le funzionalità enterprise", aZi = "A partire da 15$/utente al mese", sZi = "Accesso a tutte le funzionalità enterprise", cZi = "Inserisci la tua chiave di licenza", lZi = "Salva chiave di licenza", dZi = "Token di firma (opzionale)", uZi = "Il token di firma viene utilizzato per verificare che la chiave di licenza sia tua quando incrementi la fatturazione basata sull'utilizzo. Puoi trovarlo nell'email di conferma dell'acquisto. Se hai una licenza precedente, puoi lasciare questo campo vuoto.", _Zi = "Hai bisogno di una licenza?", pZi = "La chiave di licenza è obbligatoria", mZi = "Chiave di licenza non valida", fZi = "Impossibile convalidare la chiave di licenza", gZi = "Allegati opzionali", hZi = "Invia messaggio", vZi = "Descrivi il problema", bZi = "La dimensione del file supera il limite", yZi = "Tipo di file non valido", $Zi = "Tipo di file non valido. Tipi accettati: {{acceptedTypes}}", wZi = "Numero massimo di file superato", kZi = "File caricati con successo", SZi = "Tipi accettati: {{acceptedTypes}}; Dimensione massima del file: {{maxSize}}", xZi = "Chiave di licenza salvata con successo", EZi = "Stai visualizzando il report in base al fuso orario del tuo profilo ({{userTimezone}}), mentre il tuo browser è impostato sul fuso orario ({{browserTimezone}})", TZi = "Slot ottimizzati", AZi = "Organizza gli slot temporali per ottimizzare la disponibilità.", CZi = "Prenotazioni fallite per campo", zZi = "Prenotazioni fallite", OZi = "Nessun host è assegnato al tipo di evento", PZi = "Stato della cache", IZi = "Ultimo aggiornamento: {{timestamp}}", RZi = "Elimina dati in cache", NZi = "Cache eliminata con successo", DZi = "Errore durante l'eliminazione della cache", MZi = "Sei sicuro di voler eliminare i dati in cache? Questa azione non può essere annullata.", LZi = "Sì, elimina cache", qZi = "{{remainder}} di {{maximum}} utilizzi rimasti", jZi = "{{remainder}} di {{maximum}} utilizzo rimasto", FZi = "Scade il {{date}}, a fine giornata", VZi = "Uso singolo", BZi = "Scadenza basata sul tempo", UZi = "Scadenza basata sull'utilizzo", WZi = "Numero di utilizzi", GZi = "Scade il", HZi = "Numero massimo di utilizzi", KZi = "Impostazioni link", YZi = "Questo link è scaduto il {{date}}, a fine giornata", ZZi = "Limite di utilizzo raggiunto", QZi = "Il numero massimo di utilizzi deve essere maggiore del conteggio di utilizzo attuale", JZi = "Questo link è scaduto", XZi = "Questo link può essere utilizzato per prenotazioni fino alla fine del {{date}}", eQi = "Questo link può essere configurato per scadere dopo una data stabilita", tQi = "Questo link può essere utilizzato per {{count}} prenotazione", nQi = "Questo link può essere configurato per scadere dopo un numero stabilito di prenotazioni", oQi = "Questo link può essere utilizzato per {{count}} prenotazioni", rQi = "Il nome dell'evento trigger (es. BOOKING_CREATED, BOOKING_CANCELLED)", iQi = "L'ora del webhook", aQi = "Lo slug del tipo di evento", sQi = "Configura Agente", cQi = "Il nome del tipo di evento", lQi = "L'ora di inizio dell'evento", dQi = "L'ora di conclusione dell'evento", uQi = "La descrizione dell'evento come indicata nelle impostazioni del tipo di evento", _Qi = "Luogo dell'evento", pQi = "L'UID della prenotazione", mQi = "L'UID per la riprogrammazione", fQi = "Motivo della cancellazione", gQi = "Motivo del rifiuto", hQi = "Nome dell'organizzatore", vQi = "Email dell'organizzatore", bQi = "Fuso orario dell'organizzatore (es. 'America/New_York', 'Asia/Kolkata')", yQi = "Locale dell'organizzatore (es. 'en', 'fr')", $Qi = "Nome utente dell'organizzatore (es. 'john.doe')", wQi = "Nome utente dell'organizzatore nella propria organizzazione (es. 'john.doe')", kQi = "Nome del primo partecipante", SQi = "Email del primo partecipante", xQi = "Fuso orario del primo partecipante", EQi = "Locale del primo partecipante", TQi = "Nome del team prenotato", AQi = "Membri del team prenotato", CQi = "URL della videochiamata per la riunione", zQi = "Nascondi variabili", OQi = "Mostra variabili disponibili", PQi = "Evento e prenotazione", IQi = "Persone", RQi = "Team", NQi = "Metadati", DQi = "Statistiche", MQi = "Stato della prenotazione", LQi = "Visita", qQi = "Etichetta personalizzata sulla pagina di prenotazione", jQi = "Link della riunione", FQi = "Esito della sessione", VQi = "Chiamata creata", BQi = "Segreteria telefonica", UQi = "Le mie prenotazioni", WQi = "Telefono", GQi = "Gratuito", HQi = "Email utente", KQi = "Nome utente", YQi = "Espandi pannello", ZQi = "Comprimi pannello", QQi = "La verifica dell'email è richiesta per questo tipo di evento", JQi = "Codice di verifica fornito non valido", XQi = "Hai un team", eJi = "Considera la creazione di un'organizzazione per unificare fatturazione, strumenti di amministrazione e analisi per il tuo team.", tJi = "Considera la creazione di un'organizzazione per unificare fatturazione, strumenti di amministrazione e analisi per i tuoi team.", nJi = "Messaggio inviato", oJi = "Grazie per averci contattato. Ti risponderemo il prima possibile.", rJi = "Cerca variabili", iJi = "Per favore descrivi il problema che stai riscontrando, ad esempio 'Gli slot occupati sono segnati come disponibili', ..., ecc.", aJi = "Invia un altro messaggio", sJi = "Invio in corso", cJi = "Nessuna variabile trovata", lJi = "Crediti richiesti", dJi = "Le chiamate web consumano crediti. Assicurati di avere crediti sufficienti per iniziare una chiamata.", uJi = "Le chiamate web richiedono crediti. Hai 0 crediti rimanenti.", _Ji = "Acquista crediti", pJi = "Questa azione richiede crediti per procedere", mJi = "Il nome non deve superare i {{max}} caratteri", fJi = "Addebita automaticamente la penale per cancellazioni dell'ultimo minuto", gJi = "Prima dell'orario di inizio programmato", hJi = "Riconosco che cancellando la prenotazione entro {{timeValue}} {{timeUnit}} dall'orario di inizio mi verrà addebitata la penale di mancata presenza di {{amount, currency}}", vJi = "Per qualsiasi domanda, contatta l'organizzatore.", bJi = "Orario di prenotazione", yJi = "Quando la prenotazione è programmata (inizio e fine)", $Ji = "Creato il", wJi = "Quando la prenotazione è stata originariamente creata", kJi = "Dettagli chiamata", SJi = "ID chiamata", xJi = "Informazioni chiamata", EJi = "Sentimento", TJi = "Motivo disconnessione", AJi = "Riepilogo chiamata", CJi = "Trascrizione", zJi = "Dettagli evento", OJi = "Agente", PJi = "Nessuna trascrizione disponibile", IJi = "Quando testi questo flusso di lavoro, tieni presente che gli SMS devono essere programmati con almeno 15 minuti di anticipo", RJi = "Inizia da zero", NJi = "Crea il tuo flusso di lavoro da zero.", DJi = "Template Cal.ai", MJi = "Agenti AI che prenotano riunioni, inviano promemoria e fanno follow-up!", LJi = "Voce", qJi = "Seleziona voce", jJi = "Seleziona una voce per il tuo agente", FJi = "Scegli una voce per il tuo agente", VJi = "Caratteristica", BJi = "ID voce", UJi = "Usa voce", WJi = "Voce attuale", GJi = "Configura agente in entrata", HJi = "Configura un agente AI per gestire le chiamate in entrata sul tuo numero di telefono", KJi = "Connetti prima un numero di telefono", YJi = "Configura agente per chiamate in entrata", ZJi = "Configura agente per gestire chiamate in entrata", QJi = "Chiamate in entrata", JJi = "Chiamate in uscita", XJi = "Configurazione agente in entrata completata con successo", eXi = "Agente in entrata configurato", tXi = "Configura agente in entrata", nXi = "Seleziona prima un tipo di evento", oXi = "Modifica configurazione", rXi = "Le chiamate in entrata possono prenotare solo un tipo di evento. Seleziona il tipo di evento in cui verranno programmati gli incontri quando i chiamanti raggiungono il tuo agente.", iXi = "Configura agente in entrata per chiamate in entrata", aXi = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Aggiungi le tue nuove stringhe qui sopra ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", sXi = {
  identity_provider: sKr,
  trial_days_left: cKr,
  day_one: lKr,
  day_other: dKr,
  second_one: uKr,
  second_other: _Kr,
  upgrade_now: pKr,
  untitled: mKr,
  accept_invitation: fKr,
  max_characters: gKr,
  min_characters: hKr,
  calcom_explained: vKr,
  calcom_explained_new_user: bKr,
  have_any_questions: yKr,
  reset_password_subject: $Kr,
  verify_email_subject: wKr,
  verify_email_subject_verifying_email: kKr,
  check_your_email: SKr,
  old_email_address: xKr,
  new_email_address: EKr,
  verify_email_page_body: TKr,
  verify_email_banner_body: AKr,
  verify_email_email_header: CKr,
  verify_email_button: zKr,
  cal_ai_assistant: OKr,
  send_cal_video_transcription_emails: PKr,
  description_send_cal_video_transcription_emails: IKr,
  verify_email_change_description: RKr,
  verify_email_change_success_toast: NKr,
  verify_email_change_failure_toast: DKr,
  change_of_email: MKr,
  change_of_email_toast: LKr,
  copy_somewhere_safe: qKr,
  verify_email_email_body: jKr,
  verify_email_by_code_email_body: FKr,
  verify_email_email_link_text: VKr,
  email_verification_code: BKr,
  email_verification_code_placeholder: UKr,
  incorrect_email_verification_code: WKr,
  email_sent: GKr,
  email_not_sent: HKr,
  event_declined_subject: KKr,
  event_cancelled_subject: YKr,
  event_reassigned_subject: ZKr,
  event_request_declined: QKr,
  customize_calvideo_settings: JKr,
  calvideo_settings_description: XKr,
  disable_recording_for_guests: eYr,
  enable_automatic_transcription: tYr,
  enable_automatic_recording: nYr,
  video_options: oYr,
  edit_event: rYr,
  view_session_details: iYr,
  meeting_session_details: aYr,
  meeting_session: sYr,
  session_id: cYr,
  max_participants: lYr,
  unlimited: dYr,
  ongoing: uYr,
  ended: _Yr,
  participants: pYr,
  anonymous_user: mYr,
  session_duration: fYr,
  no_meeting_sessions_found: gYr,
  not_available: hYr,
  disable_recording_for_organizer: vYr,
  disable_transcription_for_guests: bYr,
  disable_transcription_for_organizer: yYr,
  event_request_declined_recurring: $Yr,
  event_request_cancelled: wYr,
  event_request_reassigned: kYr,
  event_reassigned_subtitle: SYr,
  organizer: xYr,
  reassigned_to: EYr,
  need_to_reschedule_or_cancel: TYr,
  you_can_view_booking_details_with_this_url: AYr,
  no_options_available: CYr,
  cancellation_reason: zYr,
  cancelled_by: OYr,
  cancellation_reason_host: PYr,
  cancellation_reason_placeholder: IYr,
  notify_attendee_cancellation_reason_warning: RYr,
  rejection_reason_placeholder: NYr,
  rejection_reason: DYr,
  rejection_reason_title: MYr,
  rejection_reason_description: LYr,
  rejection_confirmation: qYr,
  manage_this_event: jYr,
  invite_team_member: FYr,
  invite_team_individual_segment: VYr,
  invite_team_bulk_segment: BYr,
  invite_team_notifcation_badge: UYr,
  your_event_has_been_scheduled: WYr,
  your_event_has_been_scheduled_recurring: GYr,
  accept_our_license: HYr,
  remove_banner_instructions: KYr,
  error_message: YYr,
  refund_failed_subject: ZYr,
  refund_failed: QYr,
  check_with_provider_and_user: JYr,
  a_refund_failed: XYr,
  awaiting_payment_subject: eZr,
  meeting_awaiting_payment: tZr,
  dark_theme_contrast_error: nZr,
  light_theme_contrast_error: oZr,
  event_type_color_light_theme_contrast_error: rZr,
  event_type_color_dark_theme_contrast_error: iZr,
  payment_not_created_error: aZr,
  couldnt_charge_card_error: sZr,
  no_available_users_found_error: cZr,
  timeslot_unavailable_book_a_new_time: lZr,
  timeslot_unavailable_short: dZr,
  just_connected_description: uZr,
  unavailable_timeslot_title: _Zr,
  booking_time_out_of_bounds_error: pZr,
  request_body_end_time_internal_error: mZr,
  create_calendar_event_error: fZr,
  update_calendar_event_error: gZr,
  delete_calendar_event_error: hZr,
  already_signed_up_for_this_booking_error: vZr,
  hosts_unavailable_for_booking: bZr,
  fixed_hosts_unavailable_for_booking: yZr,
  round_robin_host_unavailable_for_booking: $Zr,
  help: wZr,
  price: kZr,
  paid: SZr,
  refunded: xZr,
  record: EZr,
  transcribe: TZr,
  payment: AZr,
  missing_card_fields: CZr,
  pay_now: zZr,
  general_prompt: OZr,
  transcription_powered_by_ai: PZr,
  start_or_stop_recording: IZr,
  begin_message: RZr,
  codebase_has_to_stay_opensource: NZr,
  cannot_repackage_codebase: DZr,
  acquire_license: MZr,
  terms_summary: LZr,
  open_env: qZr,
  env_changed: jZr,
  accept_license: FZr,
  still_waiting_for_approval: VZr,
  event_is_still_waiting: BZr,
  no_result_found_for: UZr,
  no_more_results: WZr,
  no_results: GZr,
  load_more_results: HZr,
  integration_meeting_id: KZr,
  confirmed_event_type_subject: YZr,
  new_event_request: ZZr,
  confirm_or_reject_request: QZr,
  check_bookings_page_to_confirm_or_reject: JZr,
  check_in_assistant: XZr,
  check_in_assistant_description: eQr,
  create_your_own_prompt: tQr,
  event_awaiting_approval: nQr,
  event_awaiting_approval_recurring: oQr,
  someone_requested_an_event: rQr,
  someone_requested_password_reset: iQr,
  password_reset_email_sent: aQr,
  password_reset_instructions: sQr,
  event_awaiting_approval_subject: cQr,
  event_still_awaiting_approval: lQr,
  booking_submitted_subject: dQr,
  download_recording_subject: uQr,
  download_transcript_email_subject: _Qr,
  download_your_recording: pQr,
  download_your_transcripts: mQr,
  your_meeting_has_been_booked: fQr,
  event_type_has_been_rescheduled_on_time_date: gQr,
  event_type_has_been_updated: hQr,
  event_has_been_rescheduled: vQr,
  event_has_been_updated: bQr,
  your_event_has_been_rescheduled: yQr,
  request_reschedule_subtitle: $Qr,
  request_reschedule_title_organizer: wQr,
  request_reschedule_subtitle_organizer: kQr,
  rescheduled_event_type_subject: SQr,
  requested_to_reschedule_subject_attendee: xQr,
  hi_user_name: EQr,
  ics_event_title: TQr,
  please_book_a_time_sometime_later: AQr,
  schedule_instead: CQr,
  new_event_subject: zQr,
  join_by_entrypoint: OQr,
  notes: PQr,
  manage_my_bookings: IQr,
  need_to_make_a_change: RQr,
  new_event_scheduled: NQr,
  new_event_scheduled_recurring: DQr,
  invitee_email: MQr,
  invitee_timezone: LQr,
  time_left: qQr,
  event_type: jQr,
  duplicate_event_type: FQr,
  enter_meeting: VQr,
  video_call_provider: BQr,
  meeting_id: UQr,
  meeting_password: WQr,
  meeting_url: GQr,
  meeting_url_not_found: HQr,
  token_not_found: KQr,
  some_other_host_already_accepted_the_meeting: YQr,
  meeting_request_rejected: ZQr,
  rejected_event_type_with_organizer: QQr,
  hi: JQr,
  join_team: XQr,
  manage_this_team: eJr,
  team_info: tJr,
  join_meeting: nJr,
  request_another_invitation_email: oJr,
  you_have_been_invited: rJr,
  user_invited_you: iJr,
  hidden_team_member_title: aJr,
  hidden_team_member_message: sJr,
  hidden_team_owner_message: cJr,
  link_expires: lJr,
  upgrade_to_per_seat: dJr,
  seat_options_doesnt_support_confirmation: uJr,
  multilocation_doesnt_support_seats: _Jr,
  no_show_fee_doesnt_support_seats: pJr,
  seats_option_doesnt_support_multi_location: mJr,
  team_upgrade_seats_details: fJr,
  team_upgrade_banner_description: gJr,
  upgrade_banner_action: hJr,
  team_upgraded_successfully: vJr,
  org_upgrade_banner_description: bJr,
  org_upgraded_successfully: yJr,
  use_link_to_reset_password: $Jr,
  hey_there: wJr,
  there: kJr,
  forgot_your_password_calcom: SJr,
  delete_webhook_confirmation_message: xJr,
  confirm_delete_webhook: EJr,
  edit_webhook: TJr,
  delete_webhook: AJr,
  webhook_status: CJr,
  webhook_enabled: zJr,
  webhook_disabled: OJr,
  webhook_response: PJr,
  webhook_test: IJr,
  webhook_update_form: RJr,
  webhook_update_form_description: NJr,
  manage_your_webhook: DJr,
  webhook_created_successfully: MJr,
  webhook_updated_successfully: LJr,
  webhook_removed_successfully: qJr,
  subscription_needed: jJr,
  subscription_needed_description: FJr,
  payload_template: VJr,
  dismiss: BJr,
  no_data_yet: UJr,
  ping_test: WJr,
  add_to_homescreen: GJr,
  upcoming: HJr,
  recurring: KJr,
  past: YJr,
  choose_a_file: ZJr,
  upload_image: QJr,
  upload_target: JJr,
  no_target: XJr,
  slide_zoom_drag_instructions: eXr,
  view_notifications: tXr,
  view_public_page: nXr,
  copy_public_page_link: oXr,
  copy_referral_link: rXr,
  sign_out: iXr,
  add_another: aXr,
  install_another: sXr,
  until: cXr,
  powered_by: lXr,
  unavailable: dXr,
  set_work_schedule: uXr,
  change_bookings_availability: _Xr,
  select: pXr,
  "2fa_confirm_current_password": "Conferma la tua password attuale per iniziare.",
  "2fa_scan_image_or_use_code": "Scansiona l'immagine qui sotto con l'app di autenticazione sul tuo telefono o inserisci manualmente il codice di testo.",
  text: mXr,
  your_phone_number: fXr,
  multiline_text: gXr,
  number: hXr,
  checkbox: vXr,
  is_required: bXr,
  make_field_required: yXr,
  required: $Xr,
  optional: wXr,
  input_type: kXr,
  rejected: SXr,
  unconfirmed: xXr,
  guests: EXr,
  guest: TXr,
  web_conferencing_details_to_follow: AXr,
  confirmation: CXr,
  what_booker_should_provide: zXr,
  "404_the_user": "Il nome utente",
  username: OXr,
  is_still_available: PXr,
  documentation: IXr,
  documentation_description: RXr,
  api_reference: NXr,
  api_reference_description: DXr,
  blog: MXr,
  blog_description: LXr,
  join_our_community: qXr,
  "404_claim_entity_user": "Richiedi il tuo nome utente e pianifica eventi",
  popular_pages: jXr,
  register_now: FXr,
  register: VXr,
  page_doesnt_exist: BXr,
  no_active_phone_number_available: UXr,
  workflow_step_not_configured: WXr,
  check_spelling_mistakes_or_go_back: GXr,
  "404_page_not_found": "404: Questa pagina non è stata trovata.",
  booker_event_not_found: HXr,
  getting_started: KXr,
  "15min_meeting": "Meeting di 15 minuti",
  "30min_meeting": "Meeting di 30 minuti",
  secret: YXr,
  leave_blank_to_remove_secret: ZXr,
  webhook_secret_key_description: QXr,
  secret_meeting: JXr,
  login_instead: XXr,
  create_account: eei,
  get_started: tei,
  confirm_password: nei,
  reset_your_password: oei,
  org_banner_instructions: rei,
  email_change: iei,
  create_your_account: aei,
  create_your_calcom_account: sei,
  sign_up: cei,
  youve_been_logged_out: lei,
  hope_to_see_you_soon: dei,
  logged_out: uei,
  please_try_again_and_contact_us: _ei,
  incorrect_2fa_code: pei,
  no_account_exists: mei,
  "2fa_enabled_instructions": "Autenticazione a due fattori abilitata. Inserisci il codice a sei cifre dalla tua app di autenticazione.",
  "2fa_enter_six_digit_code": "Inserisci il codice a sei cifre dall'app di autenticazione qui sotto.",
  create_an_account: fei,
  dont_have_an_account: gei,
  "2fa_code": "Codice A Due Fattori",
  sign_in_account: hei,
  sign_in: vei,
  go_back_login: bei,
  error_during_login: yei,
  request_password_reset: $ei,
  send_invite: wei,
  forgot_password: kei,
  forgot: Sei,
  done: xei,
  all_done: Eei,
  all: Tei,
  yours: Aei,
  available_apps: Cei,
  available_apps_lower_case: zei,
  available_apps_desc: Oei,
  fixed_host_helper: Pei,
  round_robin_groups_helper: Iei,
  round_robin_helper: Rei,
  check_email_reset_password: Nei,
  finish: Dei,
  organization_general_description: Mei,
  few_sentences_about_yourself: Lei,
  nearly_there: qei,
  nearly_there_instructions: jei,
  set_availability_instructions: Fei,
  set_availability: Vei,
  set_availbility_description: Bei,
  share_a_link_or_embed: Uei,
  share_a_link_or_embed_description: Wei,
  availability_settings: Gei,
  continue_without_calendar: Hei,
  continue_with: Kei,
  connect_your_calendar: Yei,
  connect_your_video_app: Zei,
  connect_your_video_app_instructions: Qei,
  connect_your_calendar_instructions: Jei,
  set_up_later: Xei,
  current_time: eti,
  details: tti,
  welcome: nti,
  welcome_back: oti,
  welcome_to_calcom: rti,
  welcome_instructions: iti,
  connect_caldav: ati,
  connect_ics_feed: sti,
  connect: cti,
  try_for_free: lti,
  create_booking_link_with_calcom: dti,
  who: uti,
  what: _ti,
  when: pti,
  where: mti,
  add_to_calendar: fti,
  add_to_calendar_description: gti,
  add_events_to: hti,
  add_another_calendar: vti,
  other: bti,
  email_sign_in_subject: yti,
  round_robin_emailed_you_and_attendees: $ti,
  round_robin_emailed_host_and_attendee: wti,
  emailed_host_and_attendee: kti,
  emailed_host_and_attendee_recurring: Sti,
  round_robin_emailed_you_and_attendees_recurring: xti,
  round_robin_emailed_host_and_attendee_recurring: Eti,
  emailed_you_and_any_other_attendees: Tti,
  needs_to_be_confirmed_or_rejected: Ati,
  needs_to_be_confirmed_or_rejected_recurring: Cti,
  user_needs_to_confirm_or_reject_booking: zti,
  user_needs_to_confirm_or_reject_booking_recurring: Oti,
  meeting_is_scheduled: Pti,
  meeting_is_scheduled_recurring: Iti,
  booking_submitted: Rti,
  booking_submitted_recurring: Nti,
  booking_confirmed: Dti,
  booking_confirmed_recurring: Mti,
  warning_recurring_event_payment: Lti,
  warning_payment_recurring_event: qti,
  enter_new_password: jti,
  reset_password: Fti,
  change_your_password: Vti,
  show_password: Bti,
  hide_password: Uti,
  try_again: Wti,
  request_is_expired: Gti,
  reset_instructions: Hti,
  request_is_expired_instructions: Kti,
  whoops: Yti,
  login: Zti,
  success: Qti,
  failed: Jti,
  password_has_been_reset_login: Xti,
  layout: eni,
  bookerlayout_default_title: tni,
  bookerlayout_description: nni,
  bookerlayout_user_settings_title: oni,
  bookerlayout_user_settings_description: rni,
  bookerlayout_month_view: ini,
  bookerlayout_week_view: ani,
  bookerlayout_column_view: sni,
  bookerlayout_error_min_one_enabled: cni,
  bookerlayout_error_default_not_enabled: lni,
  bookerlayout_error_unknown_layout: dni,
  bookerlayout_override_global_settings: uni,
  unexpected_error_try_again: _ni,
  sunday_time_error: pni,
  monday_time_error: mni,
  tuesday_time_error: fni,
  wednesday_time_error: gni,
  thursday_time_error: hni,
  friday_time_error: vni,
  saturday_time_error: bni,
  error_end_time_before_start_time: yni,
  error_end_time_next_day: $ni,
  back_to_bookings: wni,
  free_to_pick_another_event_type: kni,
  cancelled: Sni,
  no_booking: xni,
  awaiting_host: Eni,
  cancellation_successful: Tni,
  really_cancel_booking: Ani,
  cannot_cancel_booking: Cni,
  reschedule_instead: zni,
  event_is_in_the_past: Oni,
  cancelling_event_recurring: Pni,
  cancelling_all_recurring: Ini,
  error_with_status_code_occured: Rni,
  error_event_type_url_duplicate: Nni,
  error_event_type_unauthorized_create: Dni,
  error_event_type_unauthorized_update: Mni,
  error_workflow_unauthorized_create: Lni,
  error_schedule_unauthorized_create: qni,
  booking_already_cancelled: jni,
  booking_already_accepted_rejected: Fni,
  go_back_home: Vni,
  or_go_back_home: Bni,
  no_meeting_found: Uni,
  no_meeting_found_description: Wni,
  no_status_bookings_yet: Gni,
  no_status_bookings_yet_description: Hni,
  event_between_users: Kni,
  bookings: Yni,
  booking_not_found: Zni,
  bookings_description: Qni,
  upcoming_bookings: Jni,
  recurring_bookings: Xni,
  past_bookings: eoi,
  cancelled_bookings: toi,
  unconfirmed_bookings: noi,
  unconfirmed_bookings_tooltip: ooi,
  on: roi,
  and: ioi,
  calendar_shows_busy_between: aoi,
  troubleshoot: soi,
  troubleshoot_description: coi,
  overview_of_day: loi,
  hover_over_bold_times_tip: doi,
  start_time: uoi,
  end_time: _oi,
  buffer_time: poi,
  before_event: moi,
  after_event: foi,
  event_buffer_default: goi,
  buffer: hoi,
  your_day_starts_at: voi,
  your_day_ends_at: boi,
  launch_troubleshooter: yoi,
  troubleshoot_availability: $oi,
  change_available_times: woi,
  change_your_available_times: koi,
  change_start_end: Soi,
  change_start_end_buffer: xoi,
  current_start_date: Eoi,
  start_end_changed_successfully: Toi,
  and_end_at: Aoi,
  light: Coi,
  dark: zoi,
  automatically_adjust_theme: Ooi,
  user_dynamic_booking_disabled: Poi,
  allow_dynamic_booking_tooltip: Ioi,
  allow_dynamic_booking: Roi,
  dynamic_booking: Noi,
  allow_seo_indexing: Doi,
  seo_indexing: Moi,
  allow_browser_notifications: Loi,
  you_have_denied_notifications: qoi,
  disable_browser_notifications: joi,
  browser_notifications_turned_on: Foi,
  browser_notifications_turned_off: Voi,
  browser_notifications_denied: Boi,
  please_allow_notifications: Uoi,
  push_notifications: Woi,
  push_notifications_description: Goi,
  browser_notifications_not_supported: Hoi,
  email: Koi,
  email_placeholder: Yoi,
  full_name: Zoi,
  browse_api_documentation: Qoi,
  leverage_our_api: Joi,
  create_webhook: Xoi,
  instant_meeting: eri,
  booking_cancelled: tri,
  booking_rescheduled: nri,
  recording_ready: ori,
  recording_transcription_generated: rri,
  booking_created: iri,
  booking_rejected: ari,
  booking_requested: sri,
  booking_payment_initiated: cri,
  meeting_ended: lri,
  form_submitted: dri,
  form_submitted_no_event: uri,
  booking_paid: _ri,
  ooo_created: pri,
  booking_no_show_updated: mri,
  event_triggers: fri,
  subscriber_url: gri,
  create_new_webhook: hri,
  webhooks: vri,
  team_webhooks: bri,
  create_new_webhook_to_account: yri,
  new_webhook: $ri,
  receive_cal_meeting_data: wri,
  receive_cal_event_meeting_data: kri,
  responsive_fullscreen_iframe: Sri,
  loading: xri,
  deleting: Eri,
  standard_iframe: Tri,
  developer: Ari,
  manage_developer_settings: Cri,
  iframe_embed: zri,
  embed_calcom: Ori,
  integrate_using_embed_or_webhooks: Pri,
  schedule_a_meeting: Iri,
  view_and_manage_billing_details: Rri,
  view_and_edit_billing_details: Nri,
  go_to_billing_portal: Dri,
  need_anything_else: Mri,
  further_billing_help: Lri,
  contact: qri,
  our_support_team: jri,
  contact_our_support_team: Fri,
  uh_oh: Vri,
  no_event_types_have_been_setup: Bri,
  edit_logo: Uri,
  upload_a_logo: Wri,
  upload_logo: Gri,
  remove_logo: Hri,
  enable: Kri,
  code: Yri,
  code_is_incorrect: Zri,
  add_time_availability: Qri,
  add_an_extra_layer_of_security: Jri,
  "2fa": "Autenticazione A Due Fattori",
  "2fa_disabled": "L'autenticazione a due fattori può essere abilitata solo per l'autenticazione tramite e-mail e password",
  enable_2fa: Xri,
  disable_2fa: eii,
  disable_2fa_recommendation: tii,
  error_disabling_2fa: nii,
  error_enabling_2fa: oii,
  security: rii,
  manage_account_security: iii,
  password: aii,
  password_updated_successfully: sii,
  password_has_been_changed: cii,
  error_changing_password: lii,
  session_timeout_changed: dii,
  session_timeout_change_error: uii,
  something_went_wrong: _ii,
  something_doesnt_look_right: pii,
  please_try_again: mii,
  super_secure_new_password: fii,
  new_password: gii,
  your_old_password: hii,
  current_password: vii,
  change_password: bii,
  change_secret: yii,
  new_password_matches_old_password: $ii,
  forgotten_secret_description: wii,
  current_incorrect_password: kii,
  password_hint_caplow: Sii,
  password_hint_min: xii,
  password_hint_admin_min: Eii,
  password_hint_num: Tii,
  max_limit_allowed_hint: Aii,
  invalid_password_hint: Cii,
  incorrect_password: zii,
  incorrect_email_password: Oii,
  use_setting: Pii,
  am_pm: Iii,
  time_options: Rii,
  january: Nii,
  february: Dii,
  march: Mii,
  april: Lii,
  may: qii,
  june: jii,
  july: Fii,
  august: Vii,
  september: Bii,
  october: Uii,
  november: Wii,
  december: Gii,
  monday: Hii,
  tuesday: Kii,
  wednesday: Yii,
  thursday: Zii,
  friday: Qii,
  saturday: Jii,
  sunday: Xii,
  all_booked_today: eai,
  slots_load_fail: tai,
  additional_guests: nai,
  your_name: oai,
  your_full_name: rai,
  no_name: iai,
  enter_number_between_range: aai,
  continue_as_guest_description: sai,
  email_address: cai,
  enter_valid_email: lai,
  please_schedule_future_call: dai,
  location: uai,
  address: _ai,
  enter_address: pai,
  in_person_attendee_address: mai,
  somewhere_else: fai,
  custom_attendee_location: gai,
  continue_as_guest: hai,
  join_as_guest: vai,
  ideal_for_one_time_calls: bai,
  any_location: yai,
  yes: $ai,
  no: wai,
  additional_notes: kai,
  booking_fail: Sai,
  reschedule_fail: xai,
  share_additional_notes: Eai,
  booking_confirmation: Tai,
  booking_reschedule_confirmation: Aai,
  in_person_meeting: Cai,
  in_person: zai,
  link_meeting: Oai,
  phone_number: Pai,
  attendee_phone_number: Iai,
  organizer_phone_number: Rai,
  enter_phone_number: Nai,
  reschedule: Dai,
  reschedule_this: Mai,
  book_a_team_member: Lai,
  or: qai,
  go_back: jai,
  email_or_username: Fai,
  send_invite_email: Vai,
  role: Bai,
  edit_role: Uai,
  view_role: Wai,
  edit_team: Gai,
  editing_user: Hai,
  editing_org: Kai,
  edit_or_manage_webhooks: Yai,
  reject: Zai,
  reject_all: Qai,
  accept: Jai,
  leave: Xai,
  profile: esi,
  my_team_url: tsi,
  my_teams: nsi,
  team_name: osi,
  your_team_name: rsi,
  team_updated_successfully: isi,
  your_team_updated_successfully: asi,
  your_org_updated_successfully: ssi,
  error_copying_to_clipboard: csi,
  about: lsi,
  team_description: dsi,
  organization_id: usi,
  organization_id_copied: _si,
  org_description: psi,
  team_id: msi,
  team_id_copied: fsi,
  members: gsi,
  organization_members: hsi,
  member: vsi,
  number_member_one: bsi,
  number_member_other: ysi,
  number_selected: $si,
  owner: wsi,
  admin: ksi,
  admin_api: Ssi,
  administrator_user: xsi,
  lets_create_first_administrator_user: Esi,
  admin_user_created: Tsi,
  admin_user_created_description: Asi,
  new_member: Csi,
  invite: zsi,
  add_team_members: Osi,
  add_org_members: Psi,
  add_team_members_description: Isi,
  add_team_member: Rsi,
  invite_new_member: Nsi,
  invite_new_member_description: Dsi,
  invite_new_team_member: Msi,
  upload_csv_file: Lsi,
  invite_via_email: qsi,
  change_member_role: jsi,
  disable_cal_branding: Fsi,
  disable_cal_branding_description: Vsi,
  hide_book_a_team_member: Bsi,
  hide_book_a_team_member_description: Usi,
  danger_zone: Wsi,
  account_deletion_cannot_be_undone: Gsi,
  team_deletion_cannot_be_undone: Hsi,
  back: Ksi,
  cancel: Ysi,
  cancel_all_remaining: Zsi,
  apply: Qsi,
  cancel_event: Jsi,
  continue: "Continua",
  confirm: Xsi,
  confirm_all: eci,
  disband_team: tci,
  disband_team_confirmation_message: nci,
  disband_org: oci,
  disband_org_confirmation_message: rci,
  remove_member_confirmation_message: ici,
  confirm_disband_team: aci,
  confirm_remove_member: sci,
  confirm_subscription_cancellation: cci,
  cancel_subscription: lci,
  cancel_subscription_description: dci,
  remove_member: uci,
  manage_your_team: _ci,
  no_teams: pci,
  no_teams_description: mci,
  submit: fci,
  confirm_remove_attribute: gci,
  remove_attribute: hci,
  remove_attribute_confirmation_message: vci,
  delete: "Elimina",
  update: bci,
  save: yci,
  pending: $ci,
  open_options: wci,
  copy_link: kci,
  share: Sci,
  share_event: xci,
  copy_link_team: Eci,
  leave_team: Tci,
  confirm_leave_team: Aci,
  leave_team_confirmation_message: Cci,
  user_from_team: zci,
  preview: Oci,
  link_copied: Pci,
  copied: Ici,
  private_link_copied: Rci,
  link_shared: Nci,
  title: Dci,
  description: Mci,
  apps_status: Lci,
  quick_video_meeting: qci,
  scheduling_type: jci,
  preview_team: Fci,
  collective: Vci,
  collective_description: Bci,
  duration: Uci,
  available_durations: Wci,
  default_duration: Gci,
  default_duration_no_options: Hci,
  multiple_duration_mins: Kci,
  multiple_duration_timeUnit: Yci,
  multiple_duration_timeUnit_short: Zci,
  minutes: Qci,
  use_cal_ai_to_make_call_description: Jci,
  termination_uri: Xci,
  sip_trunk_username: eli,
  sip_trunk_password: tli,
  nickname: nli,
  delete_phone_number: oli,
  workflow_validation_failed: rli,
  workflow_validation_empty_fields: ili,
  workflow_validation_unverified_contacts: ali,
  supercharge_your_workflows_with_cal_ai: sli,
  supercharge_your_workflows_with_cal_ai_description: cli,
  phone_number_imported_successfully: lli,
  phone_number_deleted_successfully: dli,
  delete_phone_number_confirmation: uli,
  yes_delete_phone_number: _li,
  phone_number_info_tooltip: pli,
  termination_uri_info_tooltip: mli,
  sip_trunk_username_info_tooltip: fli,
  sip_trunk_password_info_tooltip: gli,
  nickname_info_tooltip: hli,
  save_and_test_call: vli,
  call_initiated_successfully: bli,
  please_enter_phone_number: yli,
  agent_updated_successfully: $li,
  agent_created_successfully: wli,
  agent_event_type_updated_successfully: kli,
  phone_number_unsubscribed_successfully: Sli,
  general_prompt_description: xli,
  prompt: Eli,
  call_to: Tli,
  make_test_call_to_verify_configuration: Ali,
  initial_message: Cli,
  initial_message_description: zli,
  having_trouble_importing: Oli,
  learn: Pli,
  learn_how_to_get_your_terminator: Ili,
  phone_number_subscription_cancelled_successfully: Rli,
  updating: Nli,
  round_robin: Dli,
  hi_how_are_you_doing: Mli,
  round_robin_description: Lli,
  managed_event: qli,
  username_placeholder: jli,
  managed_event_description: Fli,
  managed: Vli,
  managed_event_url_clarification: Bli,
  assign_to: Uli,
  enter_phone_number_to_test_call: Wli,
  make_test_call: Gli,
  create_new_workflow_agent: Hli,
  create_new_workflow_agent_description: Kli,
  phone_number_for_ai_call: Yli,
  buy_a_phone_number_or_import_one_you_already_have: Zli,
  test_agent: Qli,
  test_web_call: Jli,
  phone_numbers: Xli,
  unsubscribe: edi,
  delete_workflow_step: tdi,
  unsubscribe_phone_number: ndi,
  buy_a_new_number: odi,
  only_us_phone_numbers_can_be_purchased_here: rdi,
  buy_number_for_x_per_month: idi,
  supported_call_destinations: adi,
  no_phone_number_connected: sdi,
  failed_to_get_workflow_step_id: cdi,
  cal_ai_agent: ldi,
  test_cal_ai_agent: ddi,
  are_you_sure_you_want_to_delete_workflow_step: udi,
  do_you_still_want_to_unsubscribe: _di,
  the_action_will_disconnect_phone_number: pdi,
  cal_ai_phone_numbers: mdi,
  connect_phone_number: fdi,
  cal_ai_phone_numbers_description: gdi,
  import_number: hdi,
  this_action_will_also: vdi,
  import_phone_number: bdi,
  active_subscription: ydi,
  cancel_your_phone_number_subscription: $di,
  delete_associated_phone_number: wdi,
  unauthorized_create_workflow: kdi,
  import_phone_number_description: Sdi,
  phone_number_cost: xdi,
  buy_new_number: Edi,
  buy_number_cost_x_per_month: Tdi,
  area_code_optional: Adi,
  no_phone_numbers: Cdi,
  phone_number_purchased_successfully: zdi,
  cancel_phone_number_subscription: Odi,
  yes_cancel_subscription: Pdi,
  cancel_phone_number_subscription_confirmation: Idi,
  add_members: Rdi,
  add_members_no_ellipsis: Ndi,
  no_assigned_members: Ddi,
  assigned_to: Mdi,
  you_must_be_logged_in_to: Ldi,
  start_assigning_members_above: qdi,
  locked_fields_admin_description: jdi,
  unlocked_fields_admin_description: Fdi,
  locked_fields_member_description: Vdi,
  unlocked_fields_member_description: Bdi,
  url: Udi,
  hidden: Wdi,
  readonly: Gdi,
  one_time_link: Hdi,
  plan_description: Kdi,
  plan_upgrade_invitation: Ydi,
  plan_upgrade: Zdi,
  plan_upgrade_teams: Qdi,
  plan_upgrade_instructions: Jdi,
  event_types_page_title: Xdi,
  event_types_page_subtitle: eui,
  new: "Nuovo",
  new_event_type_btn: tui,
  new_event_type_heading: nui,
  new_event_type_description: oui,
  event_type_created_successfully: rui,
  event_type_updated_successfully: iui,
  event_type_deleted_successfully: aui,
  hours: sui,
  people: cui,
  your_email: lui,
  change_avatar: dui,
  upload_avatar: uui,
  language: _ui,
  timezone: pui,
  first_day_of_week: mui,
  repeats_up_to_one: fui,
  repeats_up_to_other: gui,
  every_for_freq: hui,
  event_remaining_one: vui,
  event_remaining_other: bui,
  repeats_every: yui,
  occurrence_one: $ui,
  occurrence_other: wui,
  weekly_one: kui,
  weekly_other: Sui,
  monthly_one: xui,
  monthly_other: Eui,
  yearly_one: Tui,
  yearly_other: Aui,
  plus_more: Cui,
  max: zui,
  single_theme: Oui,
  brand_color: Pui,
  light_brand_color: Iui,
  dark_brand_color: Rui,
  light_event_type_color: Nui,
  dark_event_type_color: Dui,
  file_not_named: Mui,
  create_team: Lui,
  name: qui,
  nameless_team: jui,
  oauth_clients: Fui,
  oauth_clients_description: Vui,
  create_oauth_client: Bui,
  create_oauth_client_description: Uui,
  oauth_client_deletion_message: Wui,
  create_new_team_description: Gui,
  create_new_team: Hui,
  booking_redirect_uri: Kui,
  booking_cancel_redirect_uri: Yui,
  booking_reschedule_redirect_uri: Zui,
  booking_conflict_error: Qui,
  open_invitations: Jui,
  new_team: Xui,
  create_first_team_and_invite_others: e_i,
  create_team_to_get_started: t_i,
  teams: n_i,
  team: o_i,
  organization: r_i,
  team_billing: i_i,
  team_billing_description: a_i,
  upgrade_to_flexible_pro_title: s_i,
  upgrade_to_flexible_pro_message: c_i,
  changed_team_billing_info: l_i,
  create_manage_teams_collaborative: d_i,
  only_available_on_pro_plan: u_i,
  remove_cal_branding_description: __i,
  edit_profile_info_description: p_i,
  change_email_tip: m_i,
  little_something_about: f_i,
  profile_updated_successfully: g_i,
  your_user_profile_updated_successfully: h_i,
  your_upgrade_is_here: v_i,
  your_upgrade_is_here_description: b_i,
  you_are_all_set: y_i,
  you_are_all_set_description: $_i,
  user_cannot_found_db: w_i,
  embed_and_webhooks: k_i,
  enabled: S_i,
  disabled: x_i,
  disable: E_i,
  billing: T_i,
  here: A_i,
  manage_your_billing_info: C_i,
  availability: z_i,
  edit_availability: O_i,
  configure_availability: P_i,
  copy_times_to: I_i,
  copy_times_to_tooltip: R_i,
  change_weekly_schedule: N_i,
  logo: D_i,
  error: M_i,
  at_least_characters_one: L_i,
  at_least_characters_other: q_i,
  team_logo: j_i,
  add_location: F_i,
  attendees: V_i,
  add_attendees: B_i,
  show_advanced_settings: U_i,
  hide_advanced_settings: W_i,
  event_name: G_i,
  event_name_in_calendar: H_i,
  event_name_tooltip: K_i,
  meeting_with_user: Y_i,
  additional_inputs: Z_i,
  additional_input_description: Q_i,
  label: J_i,
  placeholder: X_i,
  display_add_to_calendar_organizer: epi,
  display_email_as_organizer: tpi,
  if_enabled_email_address_as_organizer: npi,
  reconnect_calendar_to_use: opi,
  type: rpi,
  edit: ipi,
  add_input: api,
  disable_notes: spi,
  disable_notes_description: cpi,
  requires_confirmation_description: lpi,
  requires_confirmation_will_block_slot_description: dpi,
  recurring_event: upi,
  recurring_event_description: _pi,
  connect_and_join: ppi,
  cannot_be_used_with_paid_event_types: mpi,
  warning_payment_instant_meeting_event: fpi,
  warning_instant_meeting_experimental: gpi,
  starting: hpi,
  disable_guests: vpi,
  disable_guests_description: bpi,
  private_link: ypi,
  enable_private_url: $pi,
  private_link_label: wpi,
  private_link_hint: kpi,
  copy_private_link: Spi,
  copy_private_link_to_event: xpi,
  private_link_description: Epi,
  multiple_private_links_title: Tpi,
  multiple_private_links_description: Api,
  add_a_multiple_private_link: Cpi,
  multiple_private_link_copied: zpi,
  invitees_can_schedule: Opi,
  date_range: Ppi,
  calendar_days: Ipi,
  business_days: Rpi,
  set_address_place: Npi,
  set_link_meeting: Dpi,
  managed_event_field_parent_control_disabled: Mpi,
  cal_invitee_phone_number_scheduling: Lpi,
  cal_provide_google_meet_location: qpi,
  cal_provide_zoom_meeting_url: jpi,
  cal_provide_tandem_meeting_url: Fpi,
  cal_provide_video_meeting_url: Vpi,
  cal_provide_jitsi_meeting_url: Bpi,
  cal_provide_huddle01_meeting_url: Upi,
  cal_provide_teams_meeting_url: Wpi,
  require_payment: Gpi,
  you_need_to_add_a_name: Hpi,
  commission_per_transaction: Kpi,
  event_type_updated_successfully_description: Ypi,
  hide_event_type: Zpi,
  edit_location: Qpi,
  into_the_future: Jpi,
  when_booked_with_less_than_notice: Xpi,
  within_date_range: emi,
  indefinitely_into_future: tmi,
  add_new_custom_input_field: nmi,
  quick_chat: omi,
  add_new_team_event_type: rmi,
  add_new_event_type: imi,
  new_event_type_to_book_description: ami,
  length: smi,
  minimum_booking_notice: cmi,
  offset_toggle: lmi,
  offset_toggle_description: dmi,
  offset_start: umi,
  offset_start_description: _mi,
  slot_interval: pmi,
  slot_interval_default: mmi,
  delete_event_type: fmi,
  delete_managed_event_type: gmi,
  delete_event_type_description: hmi,
  delete_managed_event_type_description_1: vmi,
  delete_managed_event_type_description_2: bmi,
  confirm_delete_event_type: ymi,
  delete_account: $mi,
  confirm_delete_account: wmi,
  delete_account_confirmation_message: kmi,
  integrations: Smi,
  apps: xmi,
  apps_description: Emi,
  apps_listing: Tmi,
  category_apps: Ami,
  app_store: Cmi,
  app_store_description: zmi,
  connect_your_video: Omi,
  settings: Pmi,
  event_type_moved_successfully: Imi,
  next_step_text: Rmi,
  next_step: Nmi,
  prev_step: Dmi,
  install: Mmi,
  start_paid_trial: Lmi,
  installed: qmi,
  active_install_one: jmi,
  active_install_other: Fmi,
  globally_install: Vmi,
  app_successfully_installed: Bmi,
  app_could_not_be_installed: Umi,
  disconnect: Wmi,
  embed_your_calendar: Gmi,
  connect_your_favourite_apps: Hmi,
  automation: Kmi,
  configure_how_your_event_types_interact: Ymi,
  toggle_calendars_conflict: Zmi,
  connect_additional_calendar: Qmi,
  calendar_updated_successfully: Jmi,
  check_here: Xmi,
  conferencing: efi,
  calendar: tfi,
  payments: nfi,
  not_installed: ofi,
  error_password_mismatch: rfi,
  error_required_field: ifi,
  status: afi,
  team_view_user_availability: sfi,
  team_view_user_availability_disabled: cfi,
  set_as_away: lfi,
  set_as_free: dfi,
  toggle_away_error: ufi,
  user_away: _fi,
  user_away_description: pfi,
  meet_people_with_the_same_tokens: mfi,
  only_book_people_and_allow: ffi,
  account_created_with_identity_provider: gfi,
  account_managed_by_identity_provider: hfi,
  account_managed_by_identity_provider_description: vfi,
  account_managed_by_identity_provider_error: bfi,
  user_creation_error: yfi,
  signin_with_google: $fi,
  signin_with_saml: wfi,
  signin_with_saml_oidc: kfi,
  continue_with_email: Sfi,
  continue_with_google: xfi,
  last_used: Efi,
  you_will_need_to_generate: Tfi,
  import: "Importa",
  import_from: Afi,
  access_token: Cfi,
  visit_roadmap: zfi,
  featured_categories: Ofi,
  feature_flags: Pfi,
  admin_flags_description: Ifi,
  popular_categories: Rfi,
  number_apps_one: Nfi,
  number_apps_other: Dfi,
  trending_apps: Mfi,
  most_popular: Lfi,
  installed_apps: qfi,
  free_to_use_apps: jfi,
  no_category_apps: Ffi,
  all_apps: Vfi,
  no_category_apps_description_calendar: Bfi,
  no_category_apps_description_conferencing: Ufi,
  no_category_apps_description_payment: Wfi,
  no_category_apps_description_analytics: Gfi,
  no_category_apps_description_automation: Hfi,
  no_category_apps_description_other: Kfi,
  no_category_apps_description_messaging: Yfi,
  no_category_apps_description_crm: Zfi,
  installed_app_calendar_description: Qfi,
  installed_app_payment_description: Jfi,
  installed_app_analytics_description: Xfi,
  installed_app_other_description: egi,
  installed_app_conferencing_description: tgi,
  installed_app_automation_description: ngi,
  installed_app_messaging_description: ogi,
  installed_app_crm_description: rgi,
  analytics: igi,
  empty_installed_apps_headline: agi,
  empty_installed_apps_description: sgi,
  empty_installed_apps_button: cgi,
  manage_your_connected_apps: lgi,
  browse_apps: dgi,
  features: ugi,
  permissions: _gi,
  terms_and_privacy: pgi,
  published_by: mgi,
  subscribe: fgi,
  buy: ggi,
  install_app: hgi,
  categories: vgi,
  pricing: bgi,
  learn_more: ygi,
  try_now: $gi,
  privacy_policy: wgi,
  terms_of_service: kgi,
  remove: Sgi,
  add: xgi,
  installed_other: Egi,
  verify_wallet: Tgi,
  create_events_on: Agi,
  enterprise_license: Cgi,
  enterprise_license_locally: zgi,
  enterprise_license_sales: Ogi,
  missing_license: Pgi,
  next_steps: Igi,
  acquire_commercial_license: Rgi,
  the_infrastructure_plan: Ngi,
  prisma_studio_tip: Dgi,
  prisma_studio_tip_description: Mgi,
  contact_sales: Lgi,
  error_404: qgi,
  default: "Predefinito",
  set_to_default: jgi,
  new_schedule_btn: Fgi,
  add_new_schedule: Vgi,
  add_new_calendar: Bgi,
  set_calendar: Ugi,
  delete_schedule: Wgi,
  delete_schedule_description: Ggi,
  schedule_created_successfully: Hgi,
  availability_updated_successfully: Kgi,
  schedule_deleted_successfully: Ygi,
  default_schedule_name: Zgi,
  new_schedule_heading: Qgi,
  new_schedule_description: Jgi,
  requires_ownership_of_a_token: Xgi,
  example_name: ehi,
  time_format: thi,
  "12_hour": "12 ore",
  "24_hour": "24 ore",
  "12_hour_short": "12h",
  "24_hour_short": "24 ore",
  redirect_success_booking: nhi,
  you_are_being_redirected: ohi,
  external_redirect_url: rhi,
  redirect_url_description: ihi,
  duplicate: ahi,
  offer_seats: shi,
  offer_seats_description: chi,
  seats_available_one: lhi,
  seats_available_other: dhi,
  seats_nearly_full: uhi,
  seats_half_full: _hi,
  number_of_seats: phi,
  set_instant_meeting_expiry_time_offset_description: mhi,
  enter_number_of_seats: fhi,
  you_can_manage_your_schedules: ghi,
  booking_full: hhi,
  api_keys: vhi,
  api_key: bhi,
  test_api_key: yhi,
  test_passed: $hi,
  test_failed: whi,
  provide_api_key: khi,
  api_key_modal_subtitle: Shi,
  api_key_modal_subtitle_platform: xhi,
  api_keys_subtitle: Ehi,
  create_api_key: Thi,
  personal_note: Ahi,
  personal_note_placeholder: Chi,
  api_key_no_note: zhi,
  api_key_never_expires: Ohi,
  edit_api_key: Phi,
  success_api_key_created: Ihi,
  success_api_key_edited: Rhi,
  create: Nhi,
  success_api_key_created_bold_tagline: Dhi,
  you_will_only_view_it_once: Mhi,
  copy_to_clipboard: Lhi,
  enabled_after_update: qhi,
  enabled_after_update_description: jhi,
  confirm_delete_api_key: Fhi,
  disable_rescheduling: Vhi,
  description_disable_rescheduling: Bhi,
  allow_rescheduling_cancelled_bookings: Uhi,
  description_allow_rescheduling_cancelled_bookings: Whi,
  disable_cancelling: Ghi,
  description_disable_cancelling: Hhi,
  revoke_api_key: Khi,
  api_key_copied: Yhi,
  api_key_expires_on: Zhi,
  delete_api_key_confirm_title: Qhi,
  copy: Jhi,
  expire_date: Xhi,
  expired: evi,
  never_expires: tvi,
  expires: nvi,
  request_reschedule_booking: ovi,
  reason_for_reschedule: rvi,
  book_a_new_time: ivi,
  reschedule_request_sent: avi,
  reschedule_modal_description: svi,
  reason_for_reschedule_request: cvi,
  send_reschedule_request: lvi,
  edit_booking: dvi,
  reschedule_booking: uvi,
  former_time: _vi,
  confirmation_page_gif: pvi,
  search: mvi,
  impersonate: fvi,
  user_impersonation_heading: gvi,
  user_impersonation_description: hvi,
  team_impersonation_description: vvi,
  cal_signup_description: bvi,
  make_org_private: yvi,
  make_org_private_description: $vi,
  make_team_private: wvi,
  make_team_private_description: kvi,
  you_cannot_see_team_members: Svi,
  you_cannot_see_teams_of_org: xvi,
  allow_multiple_durations: Evi,
  impersonate_user_tip: Tvi,
  impersonating_user_warning: Avi,
  impersonating_stop_instructions: Cvi,
  event_location_changed: zvi,
  new_guests_added: Ovi,
  location_changed_event_type_subject: Pvi,
  guests_added_event_type_subject: Ivi,
  current_location: Rvi,
  new_location: Nvi,
  session: Dvi,
  session_description: Mvi,
  session_timeout_after: Lvi,
  session_timeout: qvi,
  session_timeout_description: jvi,
  no_location: Fvi,
  set_location: Vvi,
  update_location: Bvi,
  location_updated: Uvi,
  location_update_failed: Wvi,
  guests_added: Gvi,
  unable_to_add_guests: Hvi,
  email_validation_error: Kvi,
  emails_must_be_unique_valid: Yvi,
  url_validation_error: Zvi,
  place_where_cal_widget_appear: Qvi,
  create_update_react_component: Jvi,
  copy_code: Xvi,
  code_copied: ebi,
  how_you_want_add_cal_site: tbi,
  choose_ways_put_cal_site: nbi,
  setting_up_zapier: obi,
  setting_up_make: rbi,
  generate_api_key: ibi,
  generate_api_key_description: abi,
  your_unique_api_key: sbi,
  copy_safe_api_key: cbi,
  zapier_setup_instructions: lbi,
  make_setup_instructions_1: dbi,
  make_setup_instructions_2: ubi,
  make_setup_instructions_3: _bi,
  make_setup_instructions_4: pbi,
  make_setup_instructions_5: mbi,
  make_setup_instructions_6: fbi,
  install_zapier_app: gbi,
  install_make_app: hbi,
  app_installation: vbi,
  app_not_installed: bbi,
  visit_our_app_store: ybi,
  connect_apple_server: $bi,
  calendar_url: wbi,
  apple_server_generate_password: kbi,
  unable_to_add_apple_calendar: Sbi,
  credentials_stored_encrypted: xbi,
  it_stored_encrypted: Ebi,
  go_to_app_store: Tbi,
  calendar_error: Abi,
  set_your_phone_number: Cbi,
  calendar_no_busy_slots: zbi,
  display_location_label: Obi,
  display_location_info_badge: Pbi,
  add_gif: Ibi,
  search_giphy: Rbi,
  add_link_from_giphy: Nbi,
  add_gif_to_confirmation: Dbi,
  find_gif_spice_confirmation: Mbi,
  share_feedback: Lbi,
  resources: qbi,
  support_documentation: jbi,
  developer_documentation: Fbi,
  get_in_touch: Vbi,
  contact_support: Bbi,
  premium_support: Ubi,
  community_support: Wbi,
  feedback: Gbi,
  submitted_feedback: Hbi,
  feedback_error: Kbi,
  comments: Ybi,
  booking_details: Zbi,
  or_lowercase: Qbi,
  nevermind: Jbi,
  go_to: Xbi,
  zapier_invite_link: eyi,
  meeting_url_provided_after_confirmed: tyi,
  dynamically_display_attendee_or_organizer: nyi,
  event_location: oyi,
  reschedule_optional: ryi,
  reschedule_placeholder: iyi,
  event_cancelled: ayi,
  emailed_information_about_cancelled_event: syi,
  this_input_will_shown_booking_this_event: cyi,
  meeting_url_in_confirmation_email: lyi,
  url_start_with_https: dyi,
  number_provided: uyi,
  before_event_trigger: _yi,
  event_cancelled_trigger: pyi,
  after_hosts_cal_video_no_show: myi,
  after_guests_cal_video_no_show: fyi,
  join_video_call: gyi,
  sign_in_to_cal_com: hyi,
  log_in_to_cal_com: vyi,
  track_your_meetings: byi,
  track_meetings_and_manage_schedule: yyi,
  failed_to_join_call: $yi,
  choose_how_you_d_like_to_join_call: wyi,
  choose_how_you_d_like_to_appear_on_the_call: kyi,
  new_event_trigger: Syi,
  email_host_action: xyi,
  email_attendee_action: Eyi,
  sms_attendee_action: Tyi,
  sms_number_action: Ayi,
  send_reminder_sms: Cyi,
  whatsapp_number_action: zyi,
  whatsapp_attendee_action: Oyi,
  workflows: Pyi,
  new_workflow_btn: Iyi,
  how_would_you_like_to_start: Ryi,
  add_new_workflow: Nyi,
  reschedule_event_trigger: Dyi,
  trigger: Myi,
  triggers: Lyi,
  action: qyi,
  workflows_to_automate_notifications: jyi,
  workflow_name: Fyi,
  custom_workflow: Vyi,
  workflow_created_successfully: Byi,
  delete_workflow_description: Uyi,
  delete_workflow: Wyi,
  confirm_delete_workflow: Gyi,
  workflow_deleted_successfully: Hyi,
  how_long_before: Kyi,
  day_timeUnit: Yyi,
  hour_timeUnit: Zyi,
  minute_timeUnit: Qyi,
  minute_short: Jyi,
  hour_short: Xyi,
  new_workflow_heading: e$i,
  new_workflow_description: t$i,
  active_on: n$i,
  workflow_updated_successfully: o$i,
  premium_to_standard_username_description: r$i,
  premium_username: i$i,
  current: a$i,
  premium: s$i,
  standard: c$i,
  confirm_username_change_dialog_title: l$i,
  change_username_standard_to_premium: d$i,
  change_username_premium_to_standard: u$i,
  go_to_stripe_billing: _$i,
  stripe_description: p$i,
  trial_expired: m$i,
  remove_app: f$i,
  yes_remove_app: g$i,
  are_you_sure_you_want_to_remove_this_app: h$i,
  app_removed_successfully: v$i,
  error_removing_app: b$i,
  web_conference: y$i,
  web_call: $$i,
  start_web_call: w$i,
  end_call: k$i,
  test_your_agent_with_web_call: S$i,
  phone_call: x$i,
  connecting_to_agent: E$i,
  call_active: T$i,
  call_ended: A$i,
  call_error: C$i,
  ready_to_start_call: z$i,
  failed_to_start_web_call_try_again: O$i,
  call_encountered_error_try_again: P$i,
  failed_initialize_web_call_microphone_permissions: I$i,
  start_call_to_see_conversation: R$i,
  waiting_for_conversation: N$i,
  ai_agent: D$i,
  live: M$i,
  connecting: L$i,
  requires_confirmation: q$i,
  requires_confirmation_threshold: j$i,
  may_require_confirmation: F$i,
  nr_event_type_one: V$i,
  nr_event_type_other: B$i,
  count_team_one: U$i,
  count_team_other: W$i,
  add_action: G$i,
  set_whereby_link: H$i,
  invalid_whereby_link: K$i,
  set_around_link: Y$i,
  invalid_around_link: Z$i,
  set_riverside_link: Q$i,
  invalid_riverside_link: J$i,
  invalid_ping_link: X$i,
  add_exchange2013: ewi,
  add_exchange2016: twi,
  custom_template: nwi,
  email_body: owi,
  text_message: rwi,
  specific_issue: iwi,
  browse_our_docs: awi,
  choose_template: swi,
  custom: cwi,
  reminder: lwi,
  rescheduled: dwi,
  rescheduled_by: uwi,
  original_booking: _wi,
  completed: pwi,
  rating: mwi,
  reminder_email: fwi,
  not_triggering_existing_bookings: gwi,
  minute_one: hwi,
  minute_one_short: vwi,
  minute_other: bwi,
  hour_one: ywi,
  hour_one_short: $wi,
  hour_other: wwi,
  invalid_input: kwi,
  broken_video_action: Swi,
  broken_calendar_action: xwi,
  attendee_name: Ewi,
  scheduler_full_name: Twi,
  broken_integration: Awi,
  problem_adding_video_link: Cwi,
  problem_updating_calendar: zwi,
  active_on_event_types_one: Owi,
  active_on_event_types_other: Pwi,
  active_on_teams_one: Iwi,
  active_on_teams_other: Rwi,
  active_on_all_event_types: Nwi,
  active_on_all_teams: Dwi,
  no_active_event_types: Mwi,
  no_active_teams: Lwi,
  new_seat_subject: qwi,
  new_seat_title: jwi,
  variable: Fwi,
  event_name_variable: Vwi,
  attendee_name_variable: Bwi,
  event_date_variable: Uwi,
  event_time_variable: Wwi,
  organizer_name_variable: Gwi,
  app_upgrade_description: Hwi,
  invalid_number: Kwi,
  invalid_url_error_message: Ywi,
  navigate: Zwi,
  open: Qwi,
  close: Jwi,
  upgrade: Xwi,
  buy_us_number_button: e0i,
  upgrade_to_access_recordings_title: t0i,
  upgrade_to_access_recordings_description: n0i,
  upgrade_to_cal_ai_phone_number_description: o0i,
  recordings_are_part_of_the_teams_plan: r0i,
  team_feature_teams: i0i,
  team_feature_workflows: a0i,
  show_eventtype_on_profile: s0i,
  embed: c0i,
  new_username: l0i,
  current_username: d0i,
  example_1: u0i,
  example_2: _0i,
  booking_question_identifier: p0i,
  company_size: m0i,
  what_help_needed: f0i,
  variable_format: g0i,
  webhook_subscriber_url_reserved: h0i,
  custom_input_as_variable_info: v0i,
  using_booking_questions_as_variables: b0i,
  download_desktop_app: y0i,
  set_ping_link: $0i,
  rate_limit_exceeded: w0i,
  when_something_happens: k0i,
  action_is_performed: S0i,
  test_action: x0i,
  notification_sent: E0i,
  no_input: T0i,
  test_workflow_action: A0i,
  send_sms: C0i,
  send_sms_to_number: z0i,
  missing_connected_calendar: O0i,
  connect_your_calendar_and_link: P0i,
  default_calendar_selected: I0i,
  hide_from_profile: R0i,
  basics: N0i,
  availability_not_found_in_schedule_error: D0i,
  event_limit_tab_title: M0i,
  event_limit_tab_description: L0i,
  event_advanced_tab_description: q0i,
  event_advanced_tab_title: j0i,
  event_payments_tab_description: F0i,
  event_setup_multiple_duration_error: V0i,
  event_setup_multiple_duration_default_error: B0i,
  event_setup_booking_limits_error: U0i,
  event_setup_duration_limits_error: W0i,
  select_which_cal: G0i,
  custom_event_name: H0i,
  custom_event_name_description: K0i,
  "2fa_required": "Autenticazione a due fattori necessaria",
  incorrect_2fa: Y0i,
  which_event_type_apply: Z0i,
  apply_to_all_event_types: Q0i,
  apply_to_all_teams: J0i,
  which_team_apply: X0i,
  no_workflows_description: eki,
  timeformat_profile_hint: tki,
  create_workflow: nki,
  do_this: oki,
  turn_off: rki,
  turn_on: iki,
  cancelled_bookings_cannot_be_rescheduled: aki,
  settings_updated_successfully: ski,
  error_updating_settings: cki,
  personal_cal_url: lki,
  bio_hint: dki,
  finish_and_start: uki,
  user_has_no_bio: _ki,
  bio: pki,
  delete_account_modal_title: mki,
  confirm_delete_account_modal: fki,
  delete_my_account: gki,
  start_of_week: hki,
  recordings_title: vki,
  recording: bki,
  happy_scheduling: yki,
  select_calendars: $ki,
  check_for_conflicts: wki,
  view_recordings: kki,
  check_for_recordings: Ski,
  adding_events_to: xki,
  follow_system_preferences: Eki,
  custom_brand_colors: Tki,
  customize_your_brand_colors: Aki,
  pro: Cki,
  removes_cal_branding: zki,
  instant_meeting_with_title: Oki,
  profile_picture: Pki,
  upload: Iki,
  add_profile_photo: Rki,
  token_address: Nki,
  blockchain: Dki,
  old_password: Mki,
  secure_password: Lki,
  error_updating_password: qki,
  two_factor_auth: jki,
  recurring_event_tab_description: Fki,
  today: Vki,
  appearance: Bki,
  my_account: Uki,
  general: Wki,
  calendars: Gki,
  "2fa_auth": "Autenticazione a due fattori",
  invoices: Hki,
  embeds: Kki,
  impersonation: Yki,
  impersonation_description: Zki,
  recent_impersonations: Qki,
  quick_impersonate: Jki,
  no_recent_impersonations: Xki,
  users: e1i,
  user: t1i,
  profile_description: n1i,
  users_description: o1i,
  users_listing: r1i,
  general_description: i1i,
  calendars_description: a1i,
  appearance_description: s1i,
  conferencing_description: c1i,
  add_conferencing_app: l1i,
  password_description: d1i,
  set_up_two_factor_authentication: u1i,
  we_just_need_basic_info: _1i,
  skip: p1i,
  do_this_later: m1i,
  set_availability_getting_started_subtitle_1: f1i,
  set_availability_getting_started_subtitle_2: g1i,
  connect_calendar_first: h1i,
  complete_profile: v1i,
  connect_calendars_from_app_store: b1i,
  connect_conference_apps: y1i,
  connect_calendar_apps: $1i,
  connect_payment_apps: w1i,
  connect_automation_apps: k1i,
  connect_analytics_apps: S1i,
  connect_other_apps: x1i,
  connect_messaging_apps: E1i,
  connect_crm_apps: T1i,
  current_step_of_total: A1i,
  add_variable: C1i,
  custom_phone_number: z1i,
  message_template: O1i,
  email_subject: P1i,
  add_dynamic_variables: I1i,
  event_name_info: R1i,
  event_date_info: N1i,
  event_duration_info: D1i,
  event_time_info: M1i,
  event_type_not_found: L1i,
  number_to_call_variable: q1i,
  number_to_call_info: j1i,
  location_variable: F1i,
  location_info: V1i,
  additional_notes_variable: B1i,
  additional_notes_info: U1i,
  attendee_name_info: W1i,
  organizer_name_info: G1i,
  to: H1i,
  workflow_turned_on_successfully: K1i,
  download_responses: Y1i,
  download_responses_description: Z1i,
  view_responses: Q1i,
  download: J1i,
  downloading: X1i,
  download_recording: e2i,
  transcription_enabled: t2i,
  transcription_stopped: n2i,
  download_transcript: o2i,
  transcript: r2i,
  recording_from_your_recent_call: i2i,
  transcript_from_previous_call: a2i,
  you_can_download_transcript_from_attachments: s2i,
  link_valid_for_12_hrs: c2i,
  link_valid_for_12_hrs_description: l2i,
  create_your_first_form: d2i,
  create_your_first_form_description: u2i,
  create_your_first_webhook: _2i,
  create_your_first_webhook_description: p2i,
  for_a_maximum_of: m2i,
  event_one: f2i,
  event_other: g2i,
  profile_team_description: h2i,
  profile_org_description: v2i,
  members_team_description: b2i,
  organization_description: y2i,
  team_url: $2i,
  team_members: w2i,
  more: k2i,
  cal_ai_workflows: S2i,
  and_count_more: x2i,
  more_page_footer: E2i,
  workflow_example_1: T2i,
  workflow_example_2: A2i,
  workflow_example_3: C2i,
  workflow_example_4: z2i,
  workflow_example_5: O2i,
  workflow_example_6: P2i,
  send_sms_reminder: I2i,
  send_sms_reminder_description: R2i,
  follow_up_with_no_shows: N2i,
  follow_up_with_no_shows_description: D2i,
  remind_attendees_to_bring_id: M2i,
  remind_attendees_to_bring_id_description: L2i,
  email_to_remind_booking: q2i,
  email_to_remind_booking_description: j2i,
  custom_sms_reminder: F2i,
  custom_sms_reminder_description: V2i,
  custom_email_reminder: B2i,
  custom_email_reminder_description: U2i,
  count_managed_to_limit: W2i,
  welcome_to_cal_header: G2i,
  edit_form_later_subtitle: H2i,
  connect_calendar_later: K2i,
  problem_saving_user_profile: Y2i,
  purchase_missing_seats: Z2i,
  slot_length: Q2i,
  booking_appearance: J2i,
  appearance_team_description: X2i,
  appearance_org_description: eSi,
  only_owner_change: tSi,
  team_disable_cal_branding_description: nSi,
  invited_by_team: oSi,
  token_invalid_expired: rSi,
  view_booking: iSi,
  exchange_add: aSi,
  exchange_authentication: sSi,
  exchange_authentication_standard: cSi,
  exchange_authentication_ntlm: lSi,
  exchange_compression: dSi,
  exchange_version: uSi,
  exchange_version_2007_SP1: _Si,
  exchange_version_2010: pSi,
  exchange_version_2010_SP1: mSi,
  exchange_version_2010_SP2: fSi,
  exchange_version_2013: gSi,
  exchange_version_2013_SP1: hSi,
  exchange_version_2015: vSi,
  exchange_version_2016: bSi,
  routing: ySi,
  routing_forms_description: $Si,
  routing_forms_send_email_owner: wSi,
  routing_forms_send_email_owner_description: kSi,
  routing_forms_send_email_to: SSi,
  add_new_form: xSi,
  add_new_team_form: ESi,
  create_your_first_route: TSi,
  route_to_the_right_person: ASi,
  form: CSi,
  form_description: zSi,
  copy_link_to_form: OSi,
  theme: PSi,
  theme_applies_note: ISi,
  app_theme: RSi,
  app_theme_applies_note: NSi,
  theme_system: DSi,
  add_a_team: MSi,
  add_webhook_description: LSi,
  triggers_when: qSi,
  test_webhook: jSi,
  enable_webhook: FSi,
  add_webhook: VSi,
  webhook_edited_successfully: BSi,
  api_keys_description: USi,
  new_api_key: WSi,
  active: GSi,
  api_key_updated: HSi,
  api_key_update_failed: KSi,
  embeds_title: YSi,
  embeds_description: ZSi,
  create_first_api_key: QSi,
  create_first_api_key_description: JSi,
  back_to_signin: XSi,
  reset_link_sent: exi,
  password_reset_email: txi,
  password_reset_leading: nxi,
  password_updated: oxi,
  pending_payment: rxi,
  pending_invites: ixi,
  pending_organization_invites: axi,
  not_on_cal: sxi,
  no_calendar_installed: cxi,
  no_calendar_installed_description: lxi,
  add_a_calendar: dxi,
  change_email_hint: uxi,
  confirm_password_change_email: _xi,
  seats: pxi,
  every_app_published: mxi,
  report_app: fxi,
  limit_booking_frequency: gxi,
  limit_booking_frequency_description: hxi,
  only_show_first_available_slot: vxi,
  only_show_first_available_slot_description: bxi,
  limit_total_booking_duration: yxi,
  limit_total_booking_duration_description: $xi,
  booker_booking_limit: wxi,
  booker_booking_limit_description: kxi,
  recurring_event_doesnt_support_booker_booking_limit: Sxi,
  add_limit: xxi,
  team_name_required: Exi,
  show_attendees: Txi,
  show_available_seats_count: Axi,
  how_booking_questions_as_variables: Cxi,
  format: zxi,
  questions: Oxi,
  all_info_your_booker_provide: Pxi,
  uppercase_for_letters: Ixi,
  replace_whitespaces_underscores: Rxi,
  platform_members: Nxi,
  platform_members_description: Dxi,
  platform_billing: Mxi,
  manage_billing: Lxi,
  manage_billing_description: qxi,
  billing_freeplan_title: jxi,
  billing_freeplan_description: Fxi,
  billing_freeplan_cta: Vxi,
  billing_portal: Bxi,
  billing_help_cta: Uxi,
  ignore_special_characters_booking_questions: Wxi,
  retry: Gxi,
  fetching_calendars_error: Hxi,
  calendar_connection_fail: Kxi,
  booking_confirmation_success: Yxi,
  booking_rejection_success: Zxi,
  booking_tentative: Qxi,
  booking_accept_intent: Jxi,
  we_wont_show_again: Xxi,
  couldnt_update_timezone: eEi,
  updated_timezone_to: tEi,
  update_timezone: nEi,
  update_timezone_question: oEi,
  update_timezone_description: rEi,
  dont_update: iEi,
  require_additional_notes: aEi,
  require_additional_notes_description: sEi,
  email_address_action: cEi,
  after_event_trigger: lEi,
  booking_rejected_trigger: dEi,
  booking_requested_trigger: uEi,
  booking_payment_initiated_trigger: _Ei,
  booking_paid_trigger: pEi,
  booking_no_show_updated_trigger: mEi,
  how_long_after: fEi,
  how_long_after_hosts_no_show: gEi,
  how_long_after_guests_no_show: hEi,
  how_long_after_user_no_show_minutes: vEi,
  no_available_slots: bEi,
  time_available: yEi,
  cant_find_the_right_conferencing_app_visit_our_app_store: $Ei,
  install_new_calendar_app: wEi,
  make_phone_number_required: kEi,
  new_event_type_availability: SEi,
  error_editing_availability: xEi,
  dont_have_permission: EEi,
  saml_configuration_placeholder: TEi,
  saml_email_required: AEi,
  saml_sp_title: CEi,
  saml_sp_description: zEi,
  saml_sp_acs_url: OEi,
  saml_sp_entity_id: PEi,
  saml_sp_acs_url_copied: IEi,
  saml_sp_entity_id_copied: REi,
  add_calendar: NEi,
  limit_future_bookings: DEi,
  limit_future_bookings_description: MEi,
  no_event_types: LEi,
  no_event_types_description: qEi,
  billing_frequency: jEi,
  monthly: FEi,
  yearly: VEi,
  checkout: BEi,
  your_team_disbanded_successfully: UEi,
  your_org_disbanded_successfully: WEi,
  error_creating_team: GEi,
  you: HEi,
  or_continue_with: KEi,
  resend_email: YEi,
  member_already_invited: ZEi,
  already_in_use_error: QEi,
  enter_email_or_username: JEi,
  enter_email: XEi,
  enter_emails: eTi,
  too_many_invites: tTi,
  team_name_taken: nTi,
  must_enter_team_name: oTi,
  team_url_required: rTi,
  url_taken: iTi,
  problem_registering_domain: aTi,
  team_publish: sTi,
  number_text_notifications: cTi,
  number_sms_notifications: lTi,
  attendee_email_variable: dTi,
  attendee_email_info: uTi,
  booking_uid: _Ti,
  kbar_search_placeholder: pTi,
  invalid_credential: mTi,
  invalid_credential_action: fTi,
  reschedule_reason: gTi,
  choose_common_schedule_team_event: hTi,
  choose_common_schedule_team_event_description: vTi,
  reason: bTi,
  sender_id: yTi,
  sender_id_error_message: $Ti,
  test_routing_form: wTi,
  test_preview: kTi,
  route_to: STi,
  test_preview_description: xTi,
  test_routing: ETi,
  payment_app_disabled: TTi,
  edit_event_type: ATi,
  only_admin_can_see_members_of_org: CTi,
  only_admin_can_manage_sso_org: zTi,
  only_admin_can_manage_directory_sync: OTi,
  only_admin_can_manage_oauth_clients: PTi,
  collective_scheduling: ITi,
  make_it_easy_to_book: RTi,
  find_the_best_person: NTi,
  fixed_round_robin: DTi,
  add_one_fixed_attendee: MTi,
  calcom_is_better_with_team: LTi,
  the_calcom_team: qTi,
  add_your_team_members: jTi,
  booking_limit_reached: FTi,
  duration_limit_reached: VTi,
  admin_has_disabled: BTi,
  disable_attendees_emails_description: UTi,
  disabled_app_affects_event_type: WTi,
  event_replaced_notice: GTi,
  email_subject_slug_replacement: HTi,
  email_body_slug_replacement_notice: KTi,
  email_body_slug_replacement_info: YTi,
  email_body_slug_replacement_suggestion: ZTi,
  disable_payment_app: QTi,
  payment_disabled_still_able_to_book: JTi,
  app_disabled_with_event_type: XTi,
  app_disabled_video: eAi,
  app_disabled_subject: tAi,
  navigate_installed_apps: nAi,
  disabled_calendar: oAi,
  enable_apps: rAi,
  enable_apps_description: iAi,
  purchase_license: aAi,
  already_have_account: sAi,
  already_have_key: cAi,
  already_have_key_suggestion: lAi,
  create_license_key: dAi,
  app_is_enabled: uAi,
  app_is_disabled: _Ai,
  keys_have_been_saved: pAi,
  disable_app: mAi,
  disable_app_description: fAi,
  edit_keys: gAi,
  admin_apps_description: hAi,
  admin_users_description: vAi,
  admin_users_add_description: bAi,
  admin_users_edit_description: yAi,
  admin_orgs_edit_description: $Ai,
  admin_oAuth_description: wAi,
  admin_lockedSMS_description: kAi,
  no_available_apps: SAi,
  no_available_apps_description: xAi,
  no_apps: EAi,
  no_apps_configured: TAi,
  enable_in_settings: AAi,
  please_contact_admin: CAi,
  apps_settings: zAi,
  fill_this_field: OAi,
  options: PAi,
  enter_option: IAi,
  add_an_option: RAi,
  location_already_exists: NAi,
  radio: DAi,
  google_meet_warning: MAi,
  individual: LAi,
  all_bookings_filter_label: qAi,
  all_users_filter_label: jAi,
  all_event_types_filter_label: FAi,
  your_bookings_filter_label: VAi,
  meeting_url_variable: BAi,
  meeting_url_info: UAi,
  date_overrides: WAi,
  date_overrides_delete_on_date: GAi,
  date_overrides_subtitle: HAi,
  date_overrides_info: KAi,
  date_overrides_dialog_which_hours: YAi,
  date_overrides_dialog_which_hours_unavailable: ZAi,
  date_overrides_dialog_title: QAi,
  date_overrides_unavailable: JAi,
  date_overrides_mark_all_day_unavailable_one: XAi,
  date_overrides_mark_all_day_unavailable_other: eCi,
  date_overrides_update_btn: tCi,
  date_successfully_added: nCi,
  date_overrides_save_btn: oCi,
  event_type_duplicate_copy_text: rCi,
  set_as_default: iCi,
  hide_eventtype_details: aCi,
  show_navigation: sCi,
  hide_navigation: cCi,
  verification_code_sent: lCi,
  verified_successfully: dCi,
  wrong_code: uCi,
  not_verified: _Ci,
  no_availability_in_month: pCi,
  no_availability_rolling: mCi,
  no_availability_range: fCi,
  view_previous_month: gCi,
  view_next_month: hCi,
  send_code: vCi,
  number_verified: bCi,
  create_your_first_team_webhook_description: yCi,
  create_webhook_team_event_type: $Ci,
  disable_success_page: wCi,
  invalid_admin_password: kCi,
  change_password_admin: SCi,
  username_already_taken: xCi,
  assignment: ECi,
  fixed_hosts: TCi,
  add_fixed_hosts: ACi,
  round_robin_hosts: CCi,
  minimum_round_robin_hosts_count: zCi,
  hosts: OCi,
  upgrade_to_enable_feature: PCi,
  orgs_upgrade_to_enable_feature: ICi,
  new_attendee: RCi,
  awaiting_approval: NCi,
  requires_google_calendar: DCi,
  event_type_requires_google_calendar: MCi,
  connected_google_calendar: LCi,
  using_meet_requires_calendar: qCi,
  continue_to_install_google_calendar: jCi,
  install_google_meet: FCi,
  install_google_calendar: VCi,
  sender_name: BCi,
  already_invited: UCi,
  no_recordings_found: WCi,
  new_workflow_subtitle: GCi,
  reporting: HCi,
  reporting_feature: KCi,
  teams_plan_required: YCi,
  routing_forms_are_a_great_way: ZCi,
  choose_a_license: QCi,
  choose_license_description: JCi,
  license: XCi,
  agplv3_license: ezi,
  no_need_to_keep_your_code_open_source: tzi,
  repackage_rebrand_resell: nzi,
  a_vast_suite_of_enterprise_features: ozi,
  free_license_fee: rzi,
  forever_open_and_free: izi,
  required_to_keep_your_code_open_source: azi,
  cannot_repackage_and_resell: szi,
  no_enterprise_features: czi,
  step_enterprise_license: lzi,
  step_enterprise_license_description: dzi,
  setup: uzi,
  setup_description: _zi,
  configure: pzi,
  sso_configuration: mzi,
  sso_configuration_description: fzi,
  sso_configuration_description_orgs: gzi,
  sso_oidc_heading: hzi,
  sso_oidc_description: vzi,
  sso_oidc_configuration_title: bzi,
  sso_oidc_configuration_description: yzi,
  sso_oidc_callback_copied: $zi,
  sso_saml_heading: wzi,
  sso_saml_description: kzi,
  sso_saml_configuration_title: Szi,
  sso_saml_configuration_description: xzi,
  sso_saml_acsurl_copied: Ezi,
  sso_saml_entityid_copied: Tzi,
  sso_connection_created_successfully: Azi,
  sso_connection_deleted_successfully: Czi,
  delete_sso_configuration: zzi,
  delete_sso_configuration_confirmation: Ozi,
  delete_sso_configuration_confirmation_description: Pzi,
  organizer_timezone: Izi,
  email_user_cta: Rzi,
  accept_invite: Nzi,
  join_now: Dzi,
  successfully_joined: Mzi,
  email_no_user_invite_heading_subteam: Lzi,
  email_no_user_invite_heading_org: qzi,
  email_no_user_invite_subheading: jzi,
  email_user_invite_subheading_subteam: Fzi,
  email_user_invite_subheading_org: Vzi,
  email_no_user_invite_steps_intro: Bzi,
  email_no_user_step_one: Uzi,
  email_no_user_step_two: Wzi,
  email_no_user_step_three: Gzi,
  email_no_user_step_four: Hzi,
  email_no_user_signoff: Kzi,
  impersonation_user_tip: Yzi,
  available_variables: Zzi,
  scheduler: Qzi,
  no_workflows: Jzi,
  change_filter: Xzi,
  change_filter_common: eOi,
  no_results_for_filter: tOi,
  recommended_next_steps: nOi,
  create_a_managed_event: oOi,
  meetings_are_better_with_the_right: rOi,
  create_a_one_one_template: iOi,
  collective_or_roundrobin: aOi,
  book_your_team_members: sOi,
  event_no_longer_attending_subject: cOi,
  no_longer_attending: lOi,
  attendee_no_longer_attending_subject: dOi,
  attendee_no_longer_attending: uOi,
  attendee_no_longer_attending_subtitle: _Oi,
  create_event_on: pOi,
  create_routing_form_on: mOi,
  default_app_link_title: fOi,
  default_app_link_description: gOi,
  organizer_default_conferencing_app: hOi,
  organizer_default_conferencing_app_not_found: vOi,
  under_maintenance: bOi,
  under_maintenance_description: yOi,
  event_type_seats: $Oi,
  booking_questions_title: wOi,
  booking_questions_description: kOi,
  add_a_booking_question: SOi,
  identifier: xOi,
  duplicate_email: EOi,
  enter_redirect_url_on_exit_description: TOi,
  booking_with_payment_cancelled: AOi,
  booking_with_payment_cancelled_already_paid: COi,
  booking_with_payment_cancelled_refunded: zOi,
  booking_with_payment_cancelled_no_refund: OOi,
  booking_with_payment_cancelled_refund_window_expired: POi,
  booking_confirmation_failed: IOi,
  not_enough_seats: ROi,
  form_builder_field_already_exists: NOi,
  guests_field_must_be_multiemail: DOi,
  show_on_booking_page: MOi,
  visit_cancelled_booking: LOi,
  get_started_zapier_templates: qOi,
  standard_templates: jOi,
  cal_ai_templates: FOi,
  team_is_unpublished: VOi,
  org_is_unpublished_description: BOi,
  team_is_unpublished_description: UOi,
  team_member: WOi,
  a_routing_form: GOi,
  form_description_placeholder: HOi,
  keep_me_connected_with_form: KOi,
  fields_in_form_duplicated: YOi,
  form_deleted: ZOi,
  delete_form: QOi,
  delete_form_action: JOi,
  delete_form_confirmation: XOi,
  delete_form_confirmation_2: e4i,
  typeform_redirect_url_copied: t4i,
  modifications_in_fields_warning: n4i,
  connected_forms: o4i,
  form_modifications_warning: r4i,
  responses_collection_waiting_description: i4i,
  this_is_what_your_users_would_see: a4i,
  identifies_name_field: s4i,
  add_1_option_per_line: c4i,
  select_a_router: l4i,
  add_a_new_route: d4i,
  make_informed_decisions: u4i,
  make_informed_decisions_description: _4i,
  view_bookings_across: p4i,
  view_bookings_across_description: m4i,
  identify_booking_trends: f4i,
  identify_booking_trends_description: g4i,
  spot_popular_event_types: h4i,
  spot_popular_event_types_description: v4i,
  no_responses_yet: b4i,
  no_routes_defined: y4i,
  this_will_be_the_placeholder: $4i,
  error_booking_event: w4i,
  timeslot_missing_title: k4i,
  timeslot_missing_description: S4i,
  timeslot_missing_cta: x4i,
  switch_monthly: E4i,
  switch_weekly: T4i,
  switch_multiday: A4i,
  switch_columnview: C4i,
  num_locations: z4i,
  select_on_next_step: O4i,
  this_meeting_has_not_started_yet: P4i,
  this_app_requires_connected_account: I4i,
  connect_app: R4i,
  app_is_connected: N4i,
  requires_app: D4i,
  verification_code: M4i,
  can_you_try_again: L4i,
  verify: q4i,
  timezone_info: j4i,
  timezone_variable: F4i,
  event_end_time_variable: V4i,
  event_end_time_info: B4i,
  cancel_url_variable: U4i,
  cancel_url_info: W4i,
  cancel_reason_variable: G4i,
  cancel_reason_info: H4i,
  reschedule_url_variable: K4i,
  reschedule_url_info: Y4i,
  reschedule_reason_variable: Z4i,
  reschedule_reason_info: Q4i,
  invalid_event_name_variables: J4i,
  select_all: X4i,
  default_conferencing_bulk_title: e3i,
  members_default_schedule: t3i,
  set_by_admin: n3i,
  members_default_location: o3i,
  members_default_schedule_description: r3i,
  requires_at_least_one_schedule: i3i,
  default_conferencing_bulk_description: a3i,
  default_schedules_bulk_description: s3i,
  locked_for_members: c3i,
  unlocked_for_members: l3i,
  apps_locked_for_members_description: d3i,
  apps_unlocked_for_members_description: u3i,
  apps_locked_by_team_admins_description: _3i,
  apps_unlocked_by_team_admins_description: p3i,
  workflows_locked_for_members_description: m3i,
  workflows_unlocked_for_members_description: f3i,
  workflows_locked_by_team_admins_description: g3i,
  workflows_unlocked_by_team_admins_description: h3i,
  webhooks_locked_for_members_description: v3i,
  webhooks_unlocked_for_members_description: b3i,
  webhooks_locked_by_team_admins_description: y3i,
  webhooks_unlocked_by_team_admins_description: $3i,
  locked_by_team_admin: w3i,
  app_not_connected: k3i,
  connect_now: S3i,
  managed_event_dialog_confirm_button_one: x3i,
  managed_event_dialog_confirm_button_other: E3i,
  managed_event_dialog_title_one: T3i,
  managed_event_dialog_title_other: A3i,
  managed_event_dialog_information_one: C3i,
  managed_event_dialog_information_other: z3i,
  managed_event_dialog_clarification: O3i,
  review_event_type: P3i,
  looking_for_more_analytics: I3i,
  looking_for_more_insights: R3i,
  filters: N3i,
  filter: D3i,
  add_a_member: M3i,
  add_filter: L3i,
  add_rule: q3i,
  add_rule_group: j3i,
  remove_filters: F3i,
  email_verified: V3i,
  select_user: B3i,
  select_event_type: U3i,
  select_date_range: W3i,
  popular_events: G3i,
  no_event_types_found: H3i,
  average_event_duration: K3i,
  bookings_by_hour: Y3i,
  most_booked_members: Z3i,
  least_booked_members: Q3i,
  most_bookings_scheduled: J3i,
  least_bookings_scheduled: X3i,
  most_bookings_completed: e6i,
  least_bookings_completed: t6i,
  events_created: n6i,
  events_completed: o6i,
  events_cancelled: r6i,
  events_rescheduled: i6i,
  events: a6i,
  performance: s6i,
  from_last_period: c6i,
  from_to_date_period: l6i,
  redirect_url_warning: d6i,
  event_trends: u6i,
  clear_filters: _6i,
  clear: p6i,
  hold: m6i,
  on_booking_option: f6i,
  hold_option: g6i,
  card_held: h6i,
  charge_card: v6i,
  card_charged: b6i,
  no_show_fee_amount: y6i,
  no_show_fee: $6i,
  submit_card: w6i,
  submit_payment_information: k6i,
  meeting_awaiting_payment_method: S6i,
  no_show_fee_charged_email_subject: x6i,
  no_show_fee_charged_text_body: E6i,
  no_show_fee_charged_subtitle: T6i,
  error_charging_card: A6i,
  collect_no_show_fee: C6i,
  no_show_fee_charged: z6i,
  your_card_was_declined: O6i,
  your_card_does_not_support_this_type_of_purchase: P6i,
  amount_must_convert_to_at_least: I6i,
  could_not_charge_card: R6i,
  insights: N6i,
  routing_forms: D6i,
  insights_no_data_found_for_filter: M6i,
  acknowledge_booking_no_show_fee: L6i,
  days: q6i,
  card_details: j6i,
  something_went_wrong_on_our_end: F6i,
  please_provide_following_text_to_suppport: V6i,
  seats_and_no_show_fee_error: B6i,
  complete_your_booking: U6i,
  complete_your_booking_subject: W6i,
  confirm_your_details: G6i,
  copy_invite_link: H6i,
  edit_invite_link: K6i,
  invite_link_copied: Y6i,
  invite_link_deleted: Z6i,
  api_key_deleted: Q6i,
  delete_api_key_warning: J6i,
  invite_link_updated: X6i,
  link_expires_after: e5i,
  one_day: t5i,
  seven_days: n5i,
  thirty_days: o5i,
  three_months: r5i,
  one_year: i5i,
  team_invite_received: a5i,
  currency_string: s5i,
  charge_card_dialog_body: c5i,
  charge_attendee: l5i,
  payment_app_commission: d5i,
  email_invite_team: u5i,
  email_invite_team_bulk: _5i,
  error_collecting_card: p5i,
  image_size_limit_exceed: m5i,
  unauthorized_workflow_error_message: f5i,
  inline_embed: g5i,
  load_inline_content: h5i,
  floating_pop_up_button: v5i,
  floating_button_trigger_modal: b5i,
  pop_up_element_click: y5i,
  open_dialog_with_element_click: $5i,
  use_my_own_form: w5i,
  use_our_headless_routing_api: k5i,
  need_help_embedding: S5i,
  book_my_cal: x5i,
  first_name: E5i,
  last_name: T5i,
  first_last_name: A5i,
  invite_as: C5i,
  form_updated_successfully: z5i,
  disable_attendees_confirmation_emails: O5i,
  disable_attendees_confirmation_emails_description: P5i,
  disable_host_confirmation_emails: I5i,
  disable_host_confirmation_emails_description: R5i,
  add_an_override: N5i,
  import_from_google_workspace: D5i,
  connect_google_workspace: M5i,
  google_workspace_admin_tooltip: L5i,
  first_event_type_webhook_description: q5i,
  create_instant_meeting_webhook_description: j5i,
  install_app_on: F5i,
  create_for: V5i,
  currency: B5i,
  organization_banner_description: U5i,
  organization_banner_title: W5i,
  set_up_your_organization: G5i,
  set_up_your_platform_organization: H5i,
  organizations_description: K5i,
  plans: Y5i,
  platform: Z5i,
  platform_description: Q5i,
  platform_organization_description: J5i,
  must_enter_organization_name: X5i,
  must_enter_organization_admin_email: ePi,
  admin_email: tPi,
  platform_admin_email: nPi,
  admin_username: oPi,
  organization_name: rPi,
  platform_name: iPi,
  organization_url: aPi,
  organization_verify_header: sPi,
  organization_verify_email_body: cPi,
  additional_url_parameters: lPi,
  about_your_organization: dPi,
  about_your_organization_description: uPi,
  create_your_teams: _Pi,
  create_your_teams_description: pPi,
  invite_organization_admins: mPi,
  invite_organization_admins_description: fPi,
  set_a_password: gPi,
  set_a_password_description: hPi,
  organization_logo: vPi,
  organization_about_description: bPi,
  ill_do_this_later: yPi,
  verify_your_email: $Pi,
  enter_digit_code: wPi,
  verify_email_organization: kPi,
  code_provided_invalid: SPi,
  email_already_used: xPi,
  organization_admin_invited_heading: EPi,
  organization_admin_invited_body: TPi,
  duplicated_slugs_warning: APi,
  team_names_empty: CPi,
  team_names_repeated: zPi,
  user_belongs_organization: OPi,
  org_no_teams_yet: PPi,
  org_no_teams_yet_description: IPi,
  set_up: RPi,
  my_profile: NPi,
  my_settings: DPi,
  crm: MPi,
  messaging: LPi,
  sender_id_info: qPi,
  org_admins_can_create_new_teams: jPi,
  google_new_spam_policy: FPi,
  resolve: VPi,
  no_organization_slug: BPi,
  copy_link_org: UPi,
  "404_the_org": "L'organizzazione",
  "404_the_team": "Il team",
  "404_claim_entity_org": "Richiedi il sottodominio per la tua organizzazione",
  "404_claim_entity_team": "Richiedi l'accesso a questo team per iniziare a gestire le pianificazioni collettivamente",
  insights_team_filter: WPi,
  insights_user_filter: GPi,
  insights_subtitle: HPi,
  call_history: KPi,
  call_history_subtitle: YPi,
  location_options: ZPi,
  channel_type: QPi,
  end_reason: JPi,
  session_status: XPi,
  user_sentiment: eIi,
  time_header: tIi,
  from_header: nIi,
  custom_plan: oIi,
  email_embed: rIi,
  add_times_to_your_email: iIi,
  select_time: aIi,
  select_date: sIi,
  only_show_if_parameter_set: cIi,
  add_parameter: lIi,
  connecting_you_to_someone: dIi,
  please_do_not_close_this_tab: uIi,
  see_all_available_times: _Ii,
  org_team_names_example_1: pIi,
  org_team_names_example_2: mIi,
  org_team_names_example_3: fIi,
  org_team_names_example_4: gIi,
  org_team_names_example_5: hIi,
  org_max_team_warnings: vIi,
  what_is_this_meeting_about: bIi,
  add_to_team: yIi,
  remove_users_from_org: $Ii,
  delegation_credential: wIi,
  delegation_credential_description: kIi,
  add_client_id_in_google_workspace_with_below_scope: SIi,
  delegation_credential_enabled: xIi,
  add_delegation_credential: EIi,
  edit_delegation_credential: TIi,
  domain: AIi,
  no_workspace_platforms: CIi,
  workspace_platform: zIi,
  workspace_platforms: OIi,
  workspace_platforms_description: PIi,
  edit_workspace_platform: IIi,
  edit_service_account: RIi,
  add_workspace_platform: NIi,
  slug: DIi,
  service_account_key: MIi,
  edit_service_account_key: LIi,
  delegation_credential_restricts_adding_more_than_one_installation: qIi,
  app_successfully_installed_and_is_using_delegated_credentials: jIi,
  remove_users_from_org_confirm: FIi,
  remove_users_from_team: VIi,
  remove_users_from_team_confirm: BIi,
  user_has_no_schedules: UIi,
  user_isnt_in_any_teams: WIi,
  user_has_no_app_installed: GIi,
  requires_booker_email_verification: HIi,
  description_requires_booker_email_verification: KIi,
  requires_confirmation_mandatory: YIi,
  organizations: ZIi,
  upload_cal_video_logo: QIi,
  update_cal_video_logo: JIi,
  upload_banner: XIi,
  cal_video_logo_upload_instruction: eRi,
  org_admin_other_teams: tRi,
  org_admin_other_teams_description: nRi,
  not_part_of_org: oRi,
  no_other_teams_found: rRi,
  no_other_teams_found_description: iRi,
  attendee_first_name_variable: aRi,
  attendee_last_name_variable: sRi,
  attendee_first_name_info: cRi,
  attendee_last_name_info: lRi,
  your_monthly_digest: dRi,
  member_name: uRi,
  most_popular_events: _Ri,
  summary_of_events_for_your_team_for_the_last_30_days: pRi,
  me: mRi,
  meeting_unavailable: fRi,
  monthly_digest_email: gRi,
  monthly_digest_email_for_teams: hRi,
  verify_team_tooltip: vRi,
  member_removed: bRi,
  my_availability: yRi,
  team_availability: $Ri,
  instant_meeting_availability: wRi,
  backup_code: kRi,
  backup_codes: SRi,
  backup_code_instructions: xRi,
  backup_codes_copied: ERi,
  incorrect_backup_code: TRi,
  lost_access: ARi,
  missing_backup_codes: CRi,
  admin_org_notification_email_subject: zRi,
  hi_admin: ORi,
  admin_org_notification_email_title: PRi,
  admin_org_notification_email_body_part1: IRi,
  admin_org_notification_email_body_part2: RRi,
  admin_org_notification_email_body_part3: NRi,
  admin_org_notification_email_cta: DRi,
  org_has_been_processed: MRi,
  org_error_processing: LRi,
  orgs_page_description: qRi,
  unverified: jRi,
  verified: FRi,
  dns_missing: VRi,
  dns_configured: BRi,
  mark_dns_configured: URi,
  value: WRi,
  your_organization_updated_sucessfully: GRi,
  team_no_event_types: HRi,
  seat_options_doesnt_multiple_durations: KRi,
  include_calendar_event: YRi,
  oAuth: ZRi,
  oAuth_client_creation_form: QRi,
  oAuth_client_creation_form_description: JRi,
  oAuth_client_updation_form: XRi,
  oAuth_client_updation_form_description: eNi,
  recently_added: tNi,
  connect_all_calendars: nNi,
  connect_all_calendars_description: oNi,
  workflow_automation_description: rNi,
  scheduling_for_your_team: iNi,
  scheduling_for_your_team_description: aNi,
  no_members_found: sNi,
  directory_sync: cNi,
  directory_name: lNi,
  directory_provider: dNi,
  directory_scim_url: uNi,
  directory_scim_token: _Ni,
  directory_scim_url_copied: pNi,
  directory_scim_token_copied: mNi,
  directory_sync_info_description: fNi,
  directory_sync_configure: gNi,
  directory_sync_configure_description: hNi,
  directory_sync_title: vNi,
  directory_sync_created: bNi,
  directory_sync_description: yNi,
  directory_sync_deleted: $Ni,
  directory_sync_delete_connection: wNi,
  directory_sync_delete_title: kNi,
  directory_sync_delete_description: SNi,
  directory_sync_delete_confirmation: xNi,
  event_setup_length_error: ENi,
  availability_schedules: TNi,
  unauthorized: ANi,
  access_cal_account: CNi,
  select_account_team: zNi,
  allow_client_to: ONi,
  associate_with_cal_account: PNi,
  see_personal_info: INi,
  see_primary_email_address: RNi,
  connect_installed_apps: NNi,
  access_event_type: DNi,
  access_availability: MNi,
  access_bookings: LNi,
  allow_client_to_do: qNi,
  oauth_access_information: jNi,
  allow: FNi,
  view_only_edit_availability_not_onboarded: VNi,
  view_only_edit_availability: BNi,
  you_can_override_calendar_in_advanced_tab: UNi,
  edit_users_availability: WNi,
  resend_invitation: GNi,
  invitation_resent: HNi,
  saml_sso: KNi,
  add_client: YNi,
  copy_client_secret_info: ZNi,
  add_new_client: QNi,
  add_new_user: JNi,
  this_app_is_not_setup_already: XNi,
  as_csv: eDi,
  overlay_my_calendar: tDi,
  overlay_my_calendar_toc: nDi,
  view_overlay_calendar_events: oDi,
  join_event_location: rDi,
  troubleshooting: iDi,
  calendars_were_checking_for_conflicts: aDi,
  availabilty_schedules: sDi,
  manage_calendars: cDi,
  manage_availability_schedules: lDi,
  locked: dDi,
  unlocked: uDi,
  lock_timezone_toggle_on_booking_page: _Di,
  description_lock_timezone_toggle_on_booking_page: pDi,
  event_setup_multiple_payment_apps_error: mDi,
  number_in_international_format: fDi,
  install_calendar: gDi,
  branded_subdomain: hDi,
  branded_subdomain_description: vDi,
  org_insights: bDi,
  org_insights_description: yDi,
  extensive_whitelabeling: $Di,
  extensive_whitelabeling_description: wDi,
  unlimited_teams: kDi,
  verify_email: SDi,
  proceed_with_cancellation_description: xDi,
  proceed_with_cancellation_error: EDi,
  unlimited_teams_description: TDi,
  unified_billing: ADi,
  advanced_managed_events: CDi,
  advanced_managed_events_description: zDi,
  enterprise: ODi,
  enterprise_description: PDi,
  create_your_org: IDi,
  create_org: RDi,
  create_your_org_description: NDi,
  create_your_enterprise_description: DDi,
  other_payment_app_enabled: MDi,
  admin_delete_organization_description_1: LDi,
  admin_delete_organization_description_2: qDi,
  admin_delete_organization_description_3: jDi,
  admin_delete_organization_description_4: FDi,
  admin_delete_organization_title: VDi,
  published: BDi,
  unpublished: UDi,
  publish: WDi,
  troubleshooter_tooltip: GDi,
  need_help: HDi,
  troubleshooter: KDi,
  number_to_call: YDi,
  guest_name: ZDi,
  guest_email: QDi,
  guest_company: JDi,
  please_install_a_calendar: XDi,
  instant_tab_title: eMi,
  instant_event_tab_description: tMi,
  uprade_to_create_instant_bookings: nMi,
  dont_want_to_wait: oMi,
  meeting_started: rMi,
  pay_and_book: iMi,
  cal_ai_event_tab_description: aMi,
  booking_not_found_error: sMi,
  booking_seats_full_error: cMi,
  missing_payment_credential_error: lMi,
  missing_payment_app_id_error: dMi,
  not_enough_available_seats_error: uMi,
  user_redirect_title: _Mi,
  user_redirect_description: pMi,
  out_of_office: mMi,
  out_of_office_description: fMi,
  send_request: gMi,
  start_date_and_end_date_required: hMi,
  start_date_must_be_before_end_date: vMi,
  start_date_must_be_in_the_future: bMi,
  user_not_found: yMi,
  cannot_redirect_to_self: $Mi,
  out_of_office_entry_already_exists: wMi,
  out_of_office_id_required: kMi,
  booking_redirect_infinite_not_allowed: SMi,
  success_entry_created: xMi,
  booking_redirect_email_subject: EMi,
  booking_redirect_email_title: TMi,
  booking_redirect_email_description: AMi,
  booking_redirect_updated_email_subject: CMi,
  booking_redirect_updated_email_title: zMi,
  booking_redirect_updated_email_description: OMi,
  booking_redirect_cancelled_email_subject: PMi,
  booking_redirect_cancelled_email_title: IMi,
  booking_redirect_cancelled_email_description: RMi,
  success_accept_booking_redirect: NMi,
  success_reject_booking_redirect: DMi,
  copy_link_booking_redirect_request: MMi,
  booking_redirect_request_title: LMi,
  select_team_member: qMi,
  going_away_title: jMi,
  redirect_team_enabled: FMi,
  redirect_team_disabled: VMi,
  out_of_office_unavailable_list: BMi,
  success_deleted_entry_out_of_office: UMi,
  success_edited_entry_out_of_office: WMi,
  temporarily_out_of_office: GMi,
  add_a_redirect: HMi,
  create_entry: KMi,
  time_range: YMi,
  automatically_add_all_team_members: ZMi,
  redirect_to: QMi,
  having_trouble_finding_time: JMi,
  show_more: XMi,
  forward_params_redirect: eLi,
  assignment_description: tLi,
  lowest: nLi,
  low: oLi,
  medium: rLi,
  high: iLi,
  Highest: aLi,
  send_booker_to: sLi,
  set_priority: cLi,
  set_weight: lLi,
  enable_weights: dLi,
  priority_for_user: uLi,
  weights_description: _Li,
  weight_for_user: pLi,
  change_priority: mLi,
  field_identifiers_as_variables: fLi,
  field_identifiers_as_variables_with_example: gLi,
  account_already_linked: hLi,
  send_email: vLi,
  cal_ai_phone_call_action: bLi,
  call_to_confirm_booking: yLi,
  cal_ai_phone_call_action_description: $Li,
  cal_ai_agent_configuration: wLi,
  choose_at_least_one_event_type_test_call: kLi,
  mark_as_no_show: SLi,
  unmark_as_no_show: xLi,
  account_unlinked_success: ELi,
  account_unlinked_error: TLi,
  travel_schedule: ALi,
  travel_schedule_description: CLi,
  schedule_timezone_change: zLi,
  date: OLi,
  enter_the_general_prompt_for_the_agent: PLi,
  overlaps_with_existing_schedule: ILi,
  "org_admin_no_slots|heading": "Nessuna disponibilità trovata per {{name}}",
  "org_admin_no_slots|content": "Salve Amministratori dell'Organizzazione,<br /><br />Vi informiamo che: è stato portato alla nostra attenzione che {{username}} non ha avuto disponibilità quando un utente ha visitato {{username}}/{{slug}}<br /><br />Ci sono alcuni motivi per cui questo potrebbe accadere<br />L'utente non ha calendari collegati<br />I suoi orari associati a questo evento non sono abilitati<br /> <br />Consigliamo di controllare la sua disponibilità per risolvere questo problema.",
  "org_admin_no_slots|cta": "Apri disponibilità utenti",
  organization_no_slots_notification_switch_title: RLi,
  organization_no_slots_notification_switch_description: NLi,
  organization_disable_phone_only_sms_notifications_switch_title: DLi,
  organization_disable_phone_only_sms_notifications_switch_description: MLi,
  "email_team_invite|subject|added_to_org": "{{user}} ti ha inserito nell'organizzazione {{team}} su {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} ti ha invitato nell'organizzazione {{team}} su {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} ti ha inserito nel team {{team}} dell'organizzazione {{parentTeamName}} su {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} ti ha invitato a unirti alla squadra {{team}} su {{appName}}",
  "email_team_invite|heading|added_to_org": "Sei stato aggiunto a un'organizzazione {{appName}}",
  "email_team_invite|heading|invited_to_org": "Sei stato invitato a un'organizzazione {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Sei stato aggiunto a un team dell'organizzazione {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Sei stato invitato a un team dell'organizzazione {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Sei stato invitato a unirti a un team {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} ti ha inserito nell'organizzazione <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} ti ha invitato nell'organizzazione {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} ti ha invitato a unirti al team {{team}} dell'organizzazione {{parentTeamName}} su {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} ti ha inserito nel team <strong>{{teamName}}</strong> della sua organizzazione {{parentTeamName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza infiniti scambi di email.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} ti ha invitato nel team <strong>{{teamName}}</strong> della sua organizzazione {{parentTeamName}}. {{appName}} è lo strumento di programmazione degli eventi che consente a te e al tuo team di programmare riunioni senza infiniti scambi di email.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} ti ha invitato a unirti al suo team `{{teamName}}` su {{appName}}. {{appName}} è uno strumento di pianificazione di eventi che permette a te e al tuo team di pianificare le riunioni senza scambiare decine di e-mail.",
  "email|existing_user_added_link_will_change": "Accettando l'invito, il tuo link cambierà nel dominio della tua organizzazione, ma non preoccuparti, tutti i link precedenti continueranno a funzionare e reindirizzeranno correttamente.<br /><br />Nota: tutti i tuoi tipi di eventi personali saranno trasferiti nell'organizzazione <strong>{{teamName}}</strong>, che potrebbe includere anche potenziali link personali. <br /><br />Per gli eventi personali consigliamo di creare un nuovo account con un indirizzo email personale.",
  "email|existing_user_added_link_changed": "Il tuo link è stato modificato da {{a0}} a {{a1}} ma non preoccuparti, tutti i link precedenti funzionano ancora e reindirizzano correttamente. <br /><br />Nota: tutti i tuoi tipi di eventi personali sono stati trasferiti nell'organizzazione <strong>{{teamName}}</strong>, che potrebbe includere anche potenziali link personali.<br /><br />Accedi e assicurati di non avere eventi privati sul tuo nuovo account organizzativo.<br /><br />Per gli eventi personali consigliamo di creare un nuovo account con un indirizzo email personale.<br /><br />Goditi il tuo nuovo link pulito: {{a2}}",
  "email_organization_created|subject": "La tua organizzazione è stata creata",
  your_current_plan: LLi,
  organization_price_per_user_month: qLi,
  privacy_organization_description: jLi,
  privacy: FLi,
  team_will_be_under_org: VLi,
  add_group_name: BLi,
  group_name: ULi,
  routers: WLi,
  primary: GLi,
  make_primary: HLi,
  add_email: KLi,
  add_emails: YLi,
  add_email_description: ZLi,
  confirm_email: QLi,
  confirming_your_booking_sms: JLi,
  scheduler_first_name: XLi,
  scheduler_last_name: eqi,
  scheduler_name: tqi,
  organizer_first_name: nqi,
  confirm_email_description: oqi,
  send_event_details_to: rqi,
  schedule_tz_without_end_date: iqi,
  select_members: aqi,
  lock_event_types_modal_header: sqi,
  org_delete_event_types_org_admin: cqi,
  org_hide_event_types_org_admin: lqi,
  hide_org_eventtypes: dqi,
  delete_org_eventtypes: uqi,
  lock_org_users_eventtypes: _qi,
  lock_org_users_eventtypes_description: pqi,
  add_to_event_type: mqi,
  create_account_password: fqi,
  create_account_with_saml: gqi,
  error_creating_account_password: hqi,
  cannot_create_account_password_cal_provider: vqi,
  cannot_create_account_password_already_existing: bqi,
  create_account_password_hint: yqi,
  disconnect_account: $qi,
  disconnect_account_hint: wqi,
  cookie_consent_checkbox: kqi,
  make_a_call: Sqi,
  skip_rr_assignment_label: xqi,
  skip_rr_description: Eqi,
  select_account_header: Tqi,
  select_account_description: Aqi,
  select_event_types_header: Cqi,
  select_event_types_description: zqi,
  configure_app_header: Oqi,
  configure_app_description: Pqi,
  already_installed: Iqi,
  ooo_reasons_unspecified: Rqi,
  ooo_reasons_vacation: Nqi,
  ooo_reasons_travel: Dqi,
  ooo_reasons_sick_leave: Mqi,
  ooo_reasons_public_holiday: Lqi,
  ooo_forwarding_to: qqi,
  ooo_not_forwarding: jqi,
  ooo_empty_title: Fqi,
  ooo_empty_description: Vqi,
  ooo_user_is_ooo: Bqi,
  ooo_slots_returning: Uqi,
  ooo_slots_book_with: Wqi,
  ooo_select_reason: Gqi,
  create_an_out_of_office: Hqi,
  edit_an_out_of_office: Kqi,
  submit_feedback: Yqi,
  host_no_show: Zqi,
  no_show_description: Qqi,
  how_can_we_improve: Jqi,
  most_liked: Xqi,
  review: e9i,
  reviewed: t9i,
  unreviewed: n9i,
  rating_url_variable: o9i,
  rating_url_info: r9i,
  no_show_url_variable: i9i,
  no_show_url_info: a9i,
  no_support_needed: s9i,
  hide_support: c9i,
  event_ratings: l9i,
  event_no_show: d9i,
  event_no_show_guest: u9i,
  recent_ratings: _9i,
  no_ratings: p9i,
  no_ratings_description: m9i,
  most_no_show_host: f9i,
  highest_rated: g9i,
  lowest_rated: h9i,
  highest_rated_members: v9i,
  lowest_rated_members: b9i,
  csat_score: y9i,
  lockedSMS: $9i,
  leave_without_assigning_anyone: w9i,
  leave_without_adding_attendees: k9i,
  no_availability_shown_to_bookers: S9i,
  go_back_and_assign: x9i,
  leave_without_assigning: E9i,
  signing_up_terms: T9i,
  proceeding_agreement: A9i,
  terms: C9i,
  always_show_x_days: z9i,
  always_show_x_days_description: O9i,
  team_subscription_cancelled_successfully: P9i,
  team_subscription_cancellation_error: I9i,
  unable_to_subscribe_to_the_platform: R9i,
  updating_oauth_client_error: N9i,
  creating_oauth_client_error: D9i,
  event_type_color: M9i,
  event_type_color_description: L9i,
  mark_as_no_show_title: q9i,
  x_marked_as_no_show: j9i,
  x_unmarked_as_no_show: F9i,
  team_select_info: V9i,
  team_settings_description: B9i,
  no_show_updated: U9i,
  email_copied: W9i,
  phone_number_copied: G9i,
  USER_PENDING_MEMBER_OF_THE_ORG: H9i,
  USER_ALREADY_INVITED_OR_MEMBER: K9i,
  USER_MEMBER_OF_OTHER_ORGANIZATION: Y9i,
  booking_reassigned: Z9i,
  reassign: Q9i,
  reassign_to_another_rr_host: J9i,
  assign_team_member: X9i,
  override_team_member_to_assign: eji,
  no_available_hosts: tji,
  reassign_round_robin_host: nji,
  skip_writing_to_calendar: oji,
  rescheduling_not_possible: rji,
  event_expired: iji,
  skip_contact_creation: aji,
  skip_writing_to_calendar_note: sji,
  attributes: cji,
  new_attribute: lji,
  add_attributes: dji,
  add_attributes_description: uji,
  new_option: _ji,
  update_profile: pji,
  attribute: mji,
  create_attribute_description: fji,
  edit_attribute_description: gji,
  attribute_updated_successfully: hji,
  attribute_deleted_successfully: vji,
  attributes_edited_successfully: bji,
  attribute_meta_description: yji,
  attributes_edit_description: $ji,
  back_to_attributes: wji,
  delete_attribute: kji,
  delete_attribute_description: Sji,
  disable_all_emails_to_attendees: xji,
  disable_all_emails_description: Eji,
  disable_all_emails_to_hosts: Tji,
  type_confirm_to_continue: Aji,
  disable_email: Cji,
  grant_admin_api: zji,
  revoke_admin_api: Oji,
  add_calendar_label: Pji,
  apple_connect_atom_label: Iji,
  apple_connect_atom_already_connected_label: Rji,
  apple_connect_atom_loading_label: Nji,
  google_connect_atom_label: Dji,
  google_connect_atom_already_connected_label: Mji,
  google_connect_atom_loading_label: Lji,
  outlook_connect_atom_label: qji,
  outlook_connect_atom_already_connected_label: jji,
  outlook_connect_atom_loading_label: Fji,
  stripe_connect_atom_label: Vji,
  stripe_connect_atom_already_connected_label: Bji,
  stripe_connect_atom_loading_label: Uji,
  booking_question_response_variables: Wji,
  managed_by_teamAdmins: Gji,
  number_of_options: Hji,
  reschedule_with_same_round_robin_host_title: Kji,
  reschedule_with_same_round_robin_host_description: Yji,
  disable_input_if_prefilled: Zji,
  booking_limits: Qji,
  booking_limits_team_description: Jji,
  limit_team_booking_frequency_description: Xji,
  booking_limits_updated_successfully: eFi,
  you_are_unauthorized_to_make_this_change_to_the_booking: tFi,
  delegation_credential_disabled: nFi,
  matching_members: oFi,
  x_matching_members: rFi,
  matching_members_queue_using_attribute_weights: iFi,
  matching_members_queue_using_event_assignee_weights: aFi,
  no_matching_members: sFi,
  no_matching_members_will_fallback_to_all_assigned_members: cFi,
  hide_calendar_event_details: lFi,
  description_hide_calendar_event_details: dFi,
  last_number_of_days: uFi,
  month_to_date: _Fi,
  year_to_date: pFi,
  custom_range: mFi,
  refund_policy: fFi,
  always: gFi,
  never: hFi,
  payment_option: vFi,
  if_cancelled: bFi,
  before: yFi,
  show_all_columns: $Fi,
  toggle_columns: wFi,
  no_columns_found: kFi,
  salesforce_create_record_as: SFi,
  salesforce_lead: xFi,
  salesforce_contact_under_account: EFi,
  salesforce_skip_entry_creation: TFi,
  salesforce_if_account_does_not_exist: AFi,
  salesforce_create_new_contact_under_account: CFi,
  salesforce_change_record_owner_on_booking: zFi,
  mass_assign_attributes: OFi,
  reroute_preview_custom_message: PFi,
  reroute_preview_external_redirect: IFi,
  reroute_preview_possible_host: RFi,
  current_routing_status: NFi,
  reroute_booking: DFi,
  reroute_booking_description: MFi,
  verify_new_route: LFi,
  reroute: qFi,
  new_routing_status: jFi,
  salesforce_book_directly_with_attendee_owner: FFi,
  salesforce_check_owner_of: VFi,
  account: BFi,
  choose_hosts_schedule: UFi,
  hosts_schedule_description: WFi,
  no_hosts_description: GFi,
  team_member_round_robin_reassign: HFi,
  team_member_round_robin_reassign_description: KFi,
  round_robin_reassign_description: YFi,
  invalid_round_robin_host: ZFi,
  user_is_round_robin_fixed: QFi,
  reschedule_with_same_timeslot: JFi,
  reschedule_with_same_timeslot_of_new_event: XFi,
  reschedule_to_the_new_event_with_different_timeslot: e8i,
  reschedule_with_different_timeslot: t8i,
  we_dont_have_id_for_the_new_event: n8i,
  rerouted_booking_successfully_redirecting_to_booking_page: o8i,
  on_booking_write_to_event_object: r8i,
  field_name: i8i,
  add_new_field: a8i,
  you_dont_have_access_to_reroute_this_booking: s8i,
  form_response_not_found: c8i,
  contact_owner: l8i,
  contact_owner_not_found: d8i,
  using_fallback_members: u8i,
  chosen_route: _8i,
  attribute_logic_matched: p8i,
  attribute_logic_fallback_matched: m8i,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: f8i,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: g8i,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: h8i,
  warning: v8i,
  fallback_attribute_logic_description: b8i,
  fallback_attribute_logic_warning: y8i,
  fallback_not_needed: $8i,
  confirm_reassign_unavailable: w8i,
  confirm_reassign_available: k8i,
  reassign_unavailable_team_member_description: S8i,
  reassign_available_team_member_description: x8i,
  yes_reassign: E8i,
  filter_by_attributes: T8i,
  reassign_reason: A8i,
  field_type_change_suggestion: C8i,
  reassigned_by: z8i,
  row: O8i,
  rows: P8i,
  attendee_timezone_variable: I8i,
  event_start_time_in_attendee_timezone_variable: R8i,
  event_start_time_in_attendee_timezone_info: N8i,
  event_end_time_in_attendee_timezone_info: D8i,
  event_end_time_in_attendee_timezone_variable: M8i,
  salesforce_create_event_on_contact: L8i,
  salesforce_owner_name_to_change: q8i,
  no_filter_set: j8i,
  booking_dry_run_successful: F8i,
  booking_dry_run_successful_description: V8i,
  dont_have_access_this_page: B8i,
  you_need_admin_or_owner_privileges_to_access: U8i,
  field_type: W8i,
  when_to_write: G8i,
  salesforce_on_booking_write_to_record: H8i,
  on_every_booking: K8i,
  only_if_field_is_empty: Y8i,
  booking_start_date: Z8i,
  booking_created_date: Q8i,
  booking_reassigned_to_host: J8i,
  no_contact_owner: X8i,
  routing_forms_created: e7i,
  routing_forms_total_responses: t7i,
  routing_forms_total_responses_without_booking: n7i,
  routing_forms_total_responses_with_booking: o7i,
  routing_form_insights: r7i,
  routing_form_insights_form_name_header: i7i,
  routing_form_insights_booking_status_header: a7i,
  routing_form_insights_response_no_booking: s7i,
  routing_form_insights_booked_by: c7i,
  routing_form_insights_created_at: l7i,
  routing_form_insights_booking_status: d7i,
  routing_form_insights_booking_at: u7i,
  routing_form_insights_submitted_at: _7i,
  copy_redirect_url: p7i,
  redirect_url_on_exit: m7i,
  total_bookings_per_period: f7i,
  routed_to_per_period: g7i,
  per_day: h7i,
  per_week: v7i,
  per_month: b7i,
  routing_form_insights_assignment_reason: y7i,
  access_denied: $7i,
  salesforce_route_to_owner: w7i,
  salesforce_add_attendees_as: k7i,
  salesforce_do_not_route_to_owner: S7i,
  salesforce_route_to_custom_lookup_field: x7i,
  salesforce_option: E7i,
  lookup_field_name: T7i,
  salesforce_if_free_email_domain_skip_owner_check: A7i,
  filter_operator_is: C7i,
  filter_operator_is_not: z7i,
  filter_operator_contains: O7i,
  filter_operator_does_not_contain: P7i,
  filter_operator_starts_with: I7i,
  filter_operator_ends_with: R7i,
  filter_operator_is_empty: N7i,
  filter_operator_not_empty: D7i,
  translate_description_button: M7i,
  translate_description_button_description: L7i,
  rr_distribution_method: q7i,
  rr_distribution_method_description: j7i,
  rr_distribution_method_availability_title: F7i,
  rr_distribution_method_availability_description: V7i,
  rr_distribution_method_balanced_title: B7i,
  rr_distribution_method_balanced_description: U7i,
  edit_team_member_weights: W7i,
  weights_updated_successfully: G7i,
  require_confirmation_for_free_email: H7i,
  exclude_emails_that_contain: K7i,
  require_emails_that_contain: Y7i,
  exclude_emails_match_found_error_message: Z7i,
  require_emails_no_match_found_error_message: Q7i,
  search_columns: J7i,
  search_options: X7i,
  disable_org_url_label: eVi,
  disable_org_url_description: tVi,
  single_select: nVi,
  multi_select: oVi,
  calendar_conflict_settings: rVi,
  select_calendars_conflict_check: iVi,
  group_meeting: aVi,
  are_you_sure_you_want_to_remove_this_app_from: sVi,
  disconnect_app_from: cVi,
  salesforce_ignore_guests: lVi,
  google_meet: dVi,
  zoom: uVi,
  office_365_video: _Vi,
  lock_attribute_for_assignment: pVi,
  lock_attribute_for_assignment_description: mVi,
  attribute_edited_successfully: fVi,
  new_group_option: gVi,
  attribute_weight_enabled: hVi,
  attribute_weight_enabled_description: vVi,
  routed: bVi,
  reassigned: yVi,
  allow_rescheduling_past_events: $Vi,
  allow_rescheduling_past_events_description: wVi,
  rerouted: kVi,
  salesforce_assigned: SVi,
  router_position: xVi,
  show_matching_hosts: EVi,
  no_active_queues: TVi,
  weight: AVi,
  calibration: CVi,
  shortfall: zVi,
  routing_form: OVi,
  go_back_and_save: PVi,
  save_changes: IVi,
  leave_without_saving: RVi,
  leave_without_saving_description: NVi,
  something_unexpected_occurred: DVi,
  "500_error_message": "Non è colpa tua, è colpa nostra.",
  dry_run_mode_active: MVi,
  icon_showcase: LVi,
  icons_showcase: qVi,
  migrating_from_team: jVi,
  feature_currently_disabled: FVi,
  choose_an_option: VVi,
  enter_option_value: BVi,
  remove_option: UVi,
  use_attribute_weights: WVi,
  if_enabled_ignore_event_type_weights: GVi,
  attribute_for_weights: HVi,
  managed_users: KVi,
  managed_users_description: YVi,
  can_you_tell_me_about: ZVi,
  use_ai_to_answer_your_questions: QVi,
  error_fetching_answer: JVi,
  k_bar_ai_error: XVi,
  select_oAuth_client: eBi,
  on_every_instance: tBi,
  delegation_credential_feature_not_enabled: nBi,
  internal_booking_note: oBi,
  internal_note_cancellation_reason: rBi,
  internal_booking_note_description: iBi,
  internal_note_presets: aBi,
  internal_note_presets_description: sBi,
  internal_note_presets_updated_successfully: cBi,
  add_preset: lBi,
  authorize: dBi,
  next: uBi,
  hide: _Bi,
  show: pBi,
  utm_params: mBi,
  no_utm_params: fBi,
  asc: gBi,
  desc: hBi,
  verify_email_change: vBi,
  buy_credits: bBi,
  credits: yBi,
  credits_used: $Bi,
  total_credits_remaining: wBi,
  credits_per_tip_org: kBi,
  credits_per_tip_teams: SBi,
  view_and_manage_credits: xBi,
  view_and_manage_credits_description: EBi,
  credit_worth_description: TBi,
  buy_additional_credits: ABi,
  view_additional_credits_expense_tip: CBi,
  overview: zBi,
  organization_slug_taken: OBi,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: PBi,
  you_need_to_complete_user_onboarding_before_creating_an_organization: IBi,
  use_company_email_to_create_an_organization: RBi,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: NBi,
  you_need_to_have_minimum_published_teams: DBi,
  you_are_part_of_this_organization_already: MBi,
  you_are_part_of_another_organization_cannot_create_organization: LBi,
  you_are_part_of_another_platform_organization_cannot_create_organization: qBi,
  organization_payment_success: jBi,
  organization_payment_success_description: FBi,
  this_may_take_a_few_seconds: VBi,
  organization_onboarding_status: BBi,
  organization_onboarding_status_description: UBi,
  payment_failed: WBi,
  payment_failed_description: GBi,
  creating_your_organization: HBi,
  organization_onboarding_already_completed: KBi,
  organization_onboarding_already_exists: YBi,
  organization_onboarding_not_found: ZBi,
  payment_successful: QBi,
  handover_onboarding_page_title: JBi,
  handover_onboarding_page_description: XBi,
  organization_already_exists_with_this_slug: eUi,
  you_do_not_have_permission_to_create_an_organization_for_this_email: tUi,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: nUi,
  organization_has_subscription_already: oUi,
  reset_interval_weighted_rr: rUi,
  interval: iUi,
  rr_reset_interval_description: aUi,
  daily: sUi,
  end_date_not_selected: cUi,
  my_ooo: lUi,
  team_ooo: dUi,
  out_of_office_team_description: uUi,
  create_ooo_dialog_team_title: _Ui,
  create_ooo_dialog_team_subtitle: pUi,
  edit_ooo_dialog_team_subtitle: mUi,
  ooo_team_empty_title: fUi,
  ooo_team_empty_description: gUi,
  forward_to_team_member_only: hUi,
  ooo_team_redirect_infinite_not_allowed: vUi,
  previous_ooo_empty_title: bUi,
  previous: yUi,
  rr_interval_successfully_updated: $Ui,
  trial_mode: wUi,
  inactive_team_plan: kUi,
  inactive_team_plan_description: SUi,
  limited_access_trial_mode: xUi,
  referral_program: EUi,
  referral_text: TUi,
  dub_disabled_error_message: AUi,
  uid: CUi,
  link: zUi,
  rows_per_page: OUi,
  pagination_status: PUi,
  tip_username_plus: IUi,
  user_has_no_team_yet: RUi,
  no_team_members: NUi,
  recurring_event_doesnt_support_seats: DUi,
  booking_limit_per_booker_doesnt_support_recurring: MUi,
  seats_doesnt_support_recurring: LUi,
  recurring_event_seats_error: qUi,
  segment: jUi,
  saved_filters: FUi,
  rename: VUi,
  rename_segment: BUi,
  delete_segment: UUi,
  duplicate_segment: WUi,
  delete_segment_confirmation: GUi,
  filter_segment_updated: HUi,
  error_updating_filter_segment: KUi,
  filter_segment_duplicated: YUi,
  error_duplicating_filter_segment: ZUi,
  filter_segment_deleted: QUi,
  error_deleting_filter_segment: JUi,
  save_segment: XUi,
  segment_not_found: eWi,
  filter_segment_saved: tWi,
  no_segments: nWi,
  error_saving_filter_segment: oWi,
  override_segment: rWi,
  create_new_segment: iWi,
  save_for_team: aWi,
  select_team: sWi,
  please_select_team: cWi,
  personal: lWi,
  hide_team_profile_link: dWi,
  hide_team_profile_link_description: uWi,
  display: _Wi,
  could_not_find_slug_to_publish_org: pWi,
  picklist: mWi,
  most_cancelled_bookings: fWi,
  interface_language: gWi,
  interface_language_description: hWi,
  visitors_browser_language: vWi,
  name_or_email: bWi,
  salesforce_round_robin_skip_fallback_to_lead_owner: yWi,
  credit_purchase_failed: $Wi,
  minimum_of_credits_required: wWi,
  enable_delegation_credential: kWi,
  enable_delegation_credential_description: SWi,
  disable_delegation_credential: xWi,
  disable_delegation_credential_description: EWi,
  last_active: TWi,
  member_since: AWi,
  last_updated: CWi,
  salesforce_on_cancel_write_to_event: zWi,
  salesforce_on_every_cancellation: OWi,
  report_issue: PWi,
  report_issue_description: IWi,
  open_issue: RWi,
  this_is_your_current_plan: NWi,
  schedule_a_time: DWi,
  this_includes: MWi,
  oauth_client_updated_successfully: LWi,
  oauth_client_not_found: qWi,
  subscribe_to_platform: jWi,
  error_accessing_webhooks: FWi,
  webhook_update_failed: VWi,
  webhook_create_failed: BWi,
  invalid_link: UWi,
  currently_subscribed_to_plan: WWi,
  user_team: GWi,
  client_id_copied: HWi,
  client_secret_copied: KWi,
  maintenance_message: YWi,
  your_payment_failed: ZWi,
  check_your_inbox: QWi,
  account_created_premium_not_reserved: JWi,
  email_sent_with_activation_link: XWi,
  activate_account_to_purchase_username: eGi,
  open_in_gmail: tGi,
  dont_see_email: nGi,
  resend_in_seconds: oGi,
  resend: rGi,
  verification_email_sent: iGi,
  select_all_members: aGi,
  select_all_members_tooltip: sGi,
  form_settings: cGi,
  remove_whitelist_status: lGi,
  whitelist_user_workflows: dGi,
  user_workflows_whitelisted: uGi,
  user_workflows_unwhitelisted: _Gi,
  date_and_time: pGi,
  email_reminder_upcoming_event_notice: mGi,
  email_reminder_triggered_by_workflow: fGi,
  event_upper_case: gGi,
  scheduling_by: hGi,
  experience_review_prompt: vGi,
  improve_customer_experience_message: bGi,
  meeting_satisfaction_question: yGi,
  meeting_not_joined_question: $Gi,
  reschedule_cta_short: wGi,
  hide_organizer_email: kGi,
  platform_customer_cant_create_organization: SGi,
  organization_customer_cant_create_platform: xGi,
  hide_organizer_email_description: EGi,
  you_and_conjunction: TGi,
  select_verified_email: AGi,
  add_verified_email: CGi,
  add_verified_emails: zGi,
  custom_reply_to_email_title: OGi,
  custom_reply_to_email_description: PGi,
  email_survey_triggered_by_workflow: IGi,
  skip_trial: RGi,
  team_trials_skipped_successfully: NGi,
  sms_workflow_consent: DGi,
  routing_preview_more_info_found_insights: MGi,
  results: LGi,
  view_form: qGi,
  sms_opt_out_message: jGi,
  team_credits_low_warning: FGi,
  user_credits_low_warning: VGi,
  action_required_out_of_credits: BGi,
  action_required_user_out_of_credits: UGi,
  low_credits_warning_message: WGi,
  low_credits_warning_message_user: GGi,
  credit_limit_reached_message: HGi,
  credit_limit_reached_message_user: KGi,
  current_credit_balance: YGi,
  current_balance: ZGi,
  notification_about_your_booking: QGi,
  monthly_credits: JGi,
  total_credits: XGi,
  remaining_credits: eHi,
  remaining: tHi,
  total: nHi,
  additional_credits: oHi,
  routing_form_next_in_queue: rHi,
  routing_form_select_members_to_email: iHi,
  routing_incomplete_booking_tab: aHi,
  include_no_show_in_rr_calculation: sHi,
  recent_no_show_guests: cHi,
  recent_no_show_guests_tooltip: lHi,
  matching: dHi,
  event_redirect: uHi,
  reset_form: _Hi,
  rr_settings_successfully_updated: pHi,
  distribution_basis_weighted_rr: mHi,
  timestamp_basis_description: fHi,
  requires_credits: gHi,
  requires_credits_tooltip: hHi,
  available_credits: vHi,
  create_role: bHi,
  roles_and_permissions: yHi,
  roles_and_permissions_description: $Hi,
  learn_more_permissions: wHi,
  role_name: kHi,
  role_name_required: SHi,
  role_name_placeholder: xHi,
  role_description: EHi,
  role_description_placeholder: THi,
  default_role: AHi,
  custom_role: CHi,
  advanced: zHi,
  search_permissions: OHi,
  all_permissions: PHi,
  none: IHi,
  read_only: RHi,
  pbac_desc_all_actions_all_resources: NHi,
  pbac_resource_all: DHi,
  pbac_resource_event_type: MHi,
  pbac_resource_team: LHi,
  pbac_resource_organization: qHi,
  pbac_resource_booking: jHi,
  pbac_resource_insights: FHi,
  pbac_resource_role: VHi,
  pbac_resource_routing_form: BHi,
  pbac_resource_workflow: UHi,
  pbac_action_all: WHi,
  pbac_action_create: GHi,
  pbac_action_read: HHi,
  pbac_action_update: KHi,
  pbac_action_delete: YHi,
  pbac_action_manage: ZHi,
  pbac_action_invite: QHi,
  pbac_action_remove: JHi,
  pbac_action_change_member_role: XHi,
  pbac_action_list_members: eKi,
  pbac_action_manage_billing: tKi,
  pbac_action_read_team_bookings: nKi,
  pbac_action_read_org_bookings: oKi,
  pbac_action_read_recordings: rKi,
  pbac_action_impersonate: iKi,
  role_created_successfully: aKi,
  role_updated_successfully: sKi,
  delete_role: cKi,
  confirm_delete_role: lKi,
  role_deleted_successfully: dKi,
  error_creating_role: uKi,
  error_updating_role: _Ki,
  pbac_desc_create_roles: pKi,
  pbac_resource_attributes: mKi,
  pbac_desc_view_organization_attributes: fKi,
  pbac_desc_update_organization_attributes: gKi,
  pbac_desc_delete_organization_attributes: hKi,
  pbac_desc_create_organization_attributes: vKi,
  pbac_desc_view_roles: bKi,
  pbac_desc_update_roles: yKi,
  pbac_desc_delete_roles: $Ki,
  pbac_desc_create_workflows: wKi,
  set_up_required: kKi,
  pbac_desc_view_workflows: SKi,
  pbac_desc_update_workflows: xKi,
  pbac_desc_delete_workflows: EKi,
  pbac_resource_webhook: TKi,
  pbac_resource_availability: AKi,
  pbac_resource_out_of_office: CKi,
  pbac_desc_create_webhooks: zKi,
  pbac_desc_view_webhooks: OKi,
  pbac_desc_update_webhooks: PKi,
  pbac_desc_delete_webhooks: IKi,
  pbac_desc_create_availability: RKi,
  pbac_desc_view_availability: NKi,
  pbac_desc_update_availability: DKi,
  pbac_desc_delete_availability: MKi,
  pbac_desc_create_out_of_office: LKi,
  pbac_desc_view_out_of_office: qKi,
  pbac_desc_update_out_of_office: jKi,
  pbac_desc_delete_out_of_office: FKi,
  pbac_desc_manage_workflows: VKi,
  pbac_desc_create_event_types: BKi,
  pbac_desc_view_event_types: UKi,
  pbac_desc_update_event_types: WKi,
  pbac_desc_delete_event_types: GKi,
  pbac_desc_manage_event_types: HKi,
  pbac_desc_create_teams: KKi,
  pbac_desc_view_team_details: YKi,
  pbac_desc_update_team_settings: ZKi,
  pbac_desc_delete_team: QKi,
  pbac_desc_invite_team_members: JKi,
  pbac_desc_remove_team_members: XKi,
  pbac_desc_change_team_member_role: eYi,
  pbac_desc_impersonate_team_members: tYi,
  pbac_desc_manage_teams: nYi,
  pbac_desc_create_organization: oYi,
  pbac_desc_view_organization_details: rYi,
  pbac_desc_list_organization_members: iYi,
  pbac_desc_invite_organization_members: aYi,
  pbac_desc_remove_organization_members: sYi,
  pbac_desc_manage_organization_billing: cYi,
  pbac_desc_change_organization_member_role: lYi,
  pbac_desc_impersonate_organization_members: dYi,
  pbac_desc_edit_organization_settings: uYi,
  pbac_desc_manage_organizations: _Yi,
  pbac_desc_view_bookings: pYi,
  pbac_desc_view_team_bookings: mYi,
  pbac_desc_view_organization_bookings: fYi,
  pbac_desc_view_booking_recordings: gYi,
  pbac_desc_update_bookings: hYi,
  pbac_desc_manage_bookings: vYi,
  pbac_desc_view_team_insights: bYi,
  pbac_desc_manage_team_insights: yYi,
  pbac_desc_create_routing_forms: $Yi,
  pbac_desc_view_routing_forms: wYi,
  pbac_desc_update_routing_forms: kYi,
  pbac_desc_delete_routing_forms: SYi,
  read_permission_auto_enabled_tooltip: xYi,
  choose_restriction_schedule: EYi,
  restriction_schedule_description: TYi,
  use_booker_timezone: AYi,
  use_booker_timezone_info: CYi,
  load_balancing_warning: zYi,
  rr_load_balancing_disabled: OYi,
  rr_load_balancing_disabled_with_groups: PYi,
  round_robin_settings_description: IYi,
  round_robin_settings_updated_successfully: RYi,
  booking_creation_time: NYi,
  meeting_start_time: DYi,
  members_affected_by_disabling_delegation_credential: MYi,
  no_members_affected_by_disabling_delegation_credential: LYi,
  download_expense_log: qYi,
  error_downloading_expense_log: jYi,
  offer_to_reschedule_last_booking: FYi,
  booker_limit_exceeded_error: VYi,
  booker_limit_exceeded_error_reschedule: BYi,
  duration_min_error: UYi,
  duration_max_error: WYi,
  booking_not_allowed_by_restriction_schedule_error: GYi,
  restriction_schedule_not_found_error: HYi,
  converted_image_size_limit_exceed: KYi,
  add_group: YYi,
  routing_funnel: ZYi,
  routing_funnel_total_submissions: QYi,
  routing_funnel_successful_routings: JYi,
  routing_funnel_accepted_bookings: XYi,
  license_key: eZi,
  license_selection_title: tZi,
  license_selection_description: nZi,
  agplv3_license_description: oZi,
  enter_license_key: rZi,
  enter_your_license_key: iZi,
  enter_existing_license: aZi,
  enter_license_key_description: sZi,
  license_key_placeholder: cZi,
  save_license_key: lZi,
  signature_token_optional: dZi,
  signature_token_description: uZi,
  need_a_license: _Zi,
  license_key_required: pZi,
  invalid_license_key: mZi,
  license_validation_failed: fZi,
  attachments_optional: gZi,
  send_message: hZi,
  describe_the_issue: vZi,
  file_size_limit_exceed: bZi,
  invalid_file_type: yZi,
  invalid_file_type_extension: $Zi,
  max_files_exceeded: wZi,
  files_uploaded_successfully: kZi,
  file_upload_instructions: SZi,
  license_key_saved: xZi,
  timezone_mismatch_tooltip: EZi,
  show_optimized_slots: TZi,
  show_optimized_slots_description: AZi,
  failed_bookings_by_field: CZi,
  failed_bookings: zZi,
  event_type_no_hosts: OZi,
  cache_status: PZi,
  cache_last_updated: IZi,
  delete_cached_data: RZi,
  cache_deleted_successfully: NZi,
  error_deleting_cache: DZi,
  confirm_delete_cache: MZi,
  yes_delete_cache: LZi,
  remainder_of_maximum_uses_left_plural: qZi,
  remainder_of_maximum_use_left_singular: jZi,
  expires_on_date: FZi,
  single_use: VZi,
  time_based_expiration: BZi,
  usage_based_expiration: UZi,
  number_of_uses: WZi,
  expires_on: GZi,
  max_usage_count: HZi,
  link_settings: KZi,
  link_expired_on_date: YZi,
  usage_limit_reached: ZZi,
  usage_count_error: QZi,
  private_link_expired: JZi,
  time_based_expiration_description: XZi,
  time_based_generic_expiration_description: eQi,
  usage_based_expiration_description: tQi,
  usage_based_generic_expiration_description: nQi,
  usage_based_expiration_description_plural: oQi,
  webhook_trigger_event: rQi,
  webhook_created_at: iQi,
  webhook_type: aQi,
  set_up_agent: sQi,
  webhook_title: cQi,
  webhook_start_time: lQi,
  webhook_end_time: dQi,
  webhook_description: uQi,
  webhook_location: _Qi,
  webhook_uid: pQi,
  webhook_reschedule_uid: mQi,
  webhook_cancellation_reason: fQi,
  webhook_rejection_reason: gQi,
  webhook_organizer_name: hQi,
  webhook_organizer_email: vQi,
  webhook_organizer_timezone: bQi,
  webhook_organizer_locale: yQi,
  webhook_organizer_username: $Qi,
  webhook_organizer_username_in_org: wQi,
  webhook_attendee_name: kQi,
  webhook_attendee_email: SQi,
  webhook_attendee_timezone: xQi,
  webhook_attendee_locale: EQi,
  webhook_team_name: TQi,
  webhook_team_members: AQi,
  webhook_video_call_url: CQi,
  webhook_hide_variables: zQi,
  webhook_show_variable: OQi,
  webhook_event_and_booking: PQi,
  webhook_people: IQi,
  webhook_teams: RQi,
  webhook_metadata: NQi,
  stats: DQi,
  booking_status: MQi,
  visit: LQi,
  location_custom_label_input_label: qQi,
  meeting_link: jQi,
  session_outcome: FQi,
  call_created: VQi,
  voicemail: BQi,
  my_bookings: UQi,
  phone: WQi,
  free: GQi,
  user_email: HQi,
  user_name: KQi,
  expand_panel: YQi,
  collapse_panel: ZQi,
  email_verification_required: QQi,
  invalid_verification_code: JQi,
  you_have_one_team: XQi,
  consider_consolidating_one_team_org: eJi,
  consider_consolidating_multi_team_org: tJi,
  message_sent: nJi,
  support_message_sent_description: oJi,
  search_variables: rJi,
  support_message_placeholder: iJi,
  send_another_message: aJi,
  sending: sJi,
  no_variables_found: cJi,
  credits_required: lJi,
  web_call_credits_info: dJi,
  web_call_no_credits: uJi,
  purchase_credits: _Ji,
  credits_required_tooltip: pJi,
  api_key_name_too_long: mJi,
  auto_charge_for_last_minute_cancellation: fJi,
  before_scheduled_start_time: gJi,
  cancel_booking_acknowledge_no_show_fee: hJi,
  contact_organizer: vJi,
  booking_time_option: bJi,
  booking_time_option_description: yJi,
  created_at_option: $Ji,
  created_at_option_description: wJi,
  call_details: kJi,
  call_id: SJi,
  call_information: xJi,
  sentiment: EJi,
  disconnect_reason: TJi,
  call_summary: AJi,
  transcription: CJi,
  event_details: zJi,
  agent: OJi,
  no_transcript_available: PJi,
  testing_sms_workflow_info_message: IJi,
  start_from_scratch_title: RJi,
  start_from_scratch_description: NJi,
  cal_ai_template_title: DJi,
  cal_ai_template_description: MJi,
  voice: LJi,
  select_voice: qJi,
  select_voice_for_agent: jJi,
  choose_a_voice_for_your_agent: FJi,
  trait: VJi,
  voice_id: BJi,
  use_voice: UJi,
  current_voice: WJi,
  setup_incoming_agent: GJi,
  setup_incoming_agent_description: HJi,
  connect_a_phone_number_first: KJi,
  setup_agent_for_incoming_calls: YJi,
  configure_agent_to_handle_incoming_calls: ZJi,
  incoming_calls: QJi,
  outgoing_calls: JJi,
  inbound_agent_setup_success: XJi,
  inbound_agent_configured: eXi,
  setup_inbound_agent: tXi,
  please_select_event_type_first: nXi,
  edit_configuration: oXi,
  select_event_type_for_inbound_calls: rXi,
  setup_inbound_agent_for_incoming_calls: iXi,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: aXi
}, cXi = "Identiteitsprovider", lXi = 'U heeft nog $t(day, {"count": {{days}} }) over van uw PRO-proefperiode', dXi = "{{count}} dag", uXi = "{{count}} dagen", _Xi = "{{count}} seconde", pXi = "{{count}} seconden", mXi = "Nu upgraden", fXi = "Naamloos", gXi = "Uitnodiging accepteren", hXi = "Max. Karakters", vXi = "Min. Karakters", bXi = "{{appName}} is het open source Calendly-alternatief waarmee u uw eigen gegevens, werkstroom en uiterlijk in de hand houdt.", yXi = "Voltooi de instelling van uw {{appName}}-account! U bent nog maar een paar stappen verwijderd van het oplossen van al uw planningsproblemen.", $Xi = "Heeft u vragen? We zijn er om te helpen.", wXi = "{{appName}}: Instructies voor het opnieuw instellen van uw wachtwoord", kXi = "{{appName}}: verifieer je account", SXi = "{{appName}}: Verifieer je e-mailadres", xXi = "Controleer uw e-mail", EXi = "Oud e-mailadres", TXi = "Nieuw e-mailadres", AXi = "We hebben een e-mail naar {{email}} gestuurd. Het is belangrijk om uw e-mailadres te verifiëren om de beste bezorgbaarheid van e-mails en agenda's van {{appName}} te garanderen.", CXi = "Verifieer uw e-mailadres om de beste bezorgbaarheid van e-mails en agenda's te garanderen", zXi = "Verifieer uw e-mailadres", OXi = "E-mail verifiëren", PXi = "Assistent", IXi = "Cal Video transcriptie-e-mails versturen", RXi = "Verstuur e-mails met de transcriptie van de Cal Video na afloop van de meeting. (Vereist een betaald abonnement)", NXi = "Je hebt onlangs verzocht om het e-mailadres te wijzigen dat je gebruikt om in te loggen op je {{appName}}-account. Klik op de onderstaande knop om je nieuwe e-mailadres te bevestigen.", DXi = "Je e-mailadres is bijgewerkt naar {{email}}", MXi = "Het bijwerken van het e-mailadres is mislukt.", LXi = "Verifieer je nieuwe {{appName}} e-mailadres", qXi = "We hebben een verificatielink gestuurd naar {{email}}. We zullen je e-mailadres bijwerken zodra je op deze link klikt.", jXi = "Sla deze API-sleutel ergens veilig op. U kunt deze niet opnieuw bekijken.", FXi = "Verifieer uw e-mailadres door op de onderstaande knop te klikken.", VXi = "Verifieer je e-mailadres door onderstaande code te gebruiken.", BXi = "Hier is de link voor het geval u niet graag op knoppen klikt:", UXi = "Voer verificatiecode in", WXi = "Voer de verificatiecode in die u per e-mail is toegestuurd", GXi = "Verificatiecode is onjuist.", HXi = "E-mail verzonden", KXi = "Fout opgetreden tijdens het versturen van e-mail", YXi = "Afgewezen: {{title}}", ZXi = "Geannuleerd: {{title}} op {{date}}", QXi = "Opnieuw toegewezen: {{title}} op {{date}}", JXi = "Uw gebeurtenisverzoek is geweigerd", XXi = "Cal video-instellingen aanpassen", eea = "Configureer voorkeuren voor videovergaderingen, inclusief opnamerechten voor hosts en deelnemers.", tea = "Opname uitschakelen voor gasten", nea = "Automatische transcriptie inschakelen na deelname aan de vergadering", oea = "Automatische opname inschakelen nadat organisator deelneemt aan de vergadering", rea = "Video-opties", iea = "Evenement bewerken", aea = "Sessiedetails bekijken", sea = "Vergadersessiegegevens", cea = "Vergadersessie", lea = "Sessie-ID", dea = "Max. deelnemers", uea = "Onbeperkt", _ea = "Lopend", pea = "Beëindigd", mea = "Deelnemers", fea = "Anonieme gebruiker", gea = "Sessieduur", hea = "Geen vergadersessies gevonden", vea = "Niet beschikbaar", bea = "Opname uitschakelen voor organisator", yea = "Transcriptie uitschakelen voor gasten", $ea = "Transcriptie uitschakelen voor organisator", wea = "Uw verzoek voor een terugkerende gebeurtenis is geweigerd", kea = "Uw geplande gebeurtenis is geannuleerd", Sea = "Je geplande afspraak is opnieuw toegewezen", xea = "De afspraak staat niet meer in je agenda en je round robin-kans wordt niet negatief beïnvloed", Eea = "Organisator", Tea = "Opnieuw toegewezen aan", Aea = "Moet u verplaatsen of annuleren?", Cea = "Je kunt de boekingsdetails bekijken via deze url {{url}} en het evenement aan je agenda toevoegen", zea = "Geen opties beschikbaar", Oea = "Reden voor annulering (optioneel)", Pea = "Geannuleerd door", Iea = "Reden voor annulering", Rea = "Waarom annuleert u?", Nea = "De annuleringsreden wordt gedeeld met gasten", Dea = "Waarom wijs je dit af?", Mea = "Reden voor weigering", Lea = "Boekingsverzoek weigeren?", qea = "Weet u zeker dat u de boeking wilt weigeren? We informeren de persoon die probeerde te boeken. U kunt hieronder een reden opgeven.", jea = "Boeking weigeren", Fea = "Deze gebeurtenis beheren", Vea = "Teamlid uitnodigen", Bea = "Persoon uitnodigen", Uea = "Bulkimport", Wea = "Uitg.", Gea = "Uw gebeurtenis is gepland", Hea = "Uw terugkerende gebeurtenis is gepland", Kea = "Accepteer onze licentie door de variable .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> te veranderen in '{{agree}}'.", Yea = "Om deze banner te verwijderen, opent u het .env bestand en verandert <1>NEXT_PUBLIC_LICENSE_CONSENT</1> in '{{agree}}'.", Zea = "De foutmelding was: '{{errorMessage}}'", Qea = "Terugbetaling mislukt: {{name}} - {{date}} - {{eventType}}", Jea = "De terugbetaling voor het evenement {{eventType}} met {{userName}} op {{date}} is mislukt.", Xea = "Neem contact op met uw betalingsverwerker en {{user}} om dit op te lossen.", eta = "Een terugbetaling is mislukt", tta = "In afwachting van betaling: {{title}} op {{date}}", nta = "Er is een openstaande betaling voor uw vergadering", ota = "De kleur van het donkere thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat je knoppen beter zichtbaar zijn.", rta = "De kleur van het lichte thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat je knoppen beter zichtbaar zijn.", ita = "De kleur van het lichte thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat de kleur van je evenementtypen beter zichtbaar is.", ata = "De kleur van het donkere thema voldoet niet aan de contrastcontrole. We raden aan deze kleur te wijzigen zodat de kleur van je evenementtypen beter zichtbaar is.", sta = "Betaling kon niet worden aangemaakt", cta = "Kon de kaart niet belasten voor betaling", lta = "Geen beschikbare gebruikers gevonden. Kun je een ander tijdslot proberen?", dta = "Het geselecteerde tijdslot is niet meer beschikbaar. <0>Selecteer alstublieft een nieuwe tijd</0>", uta = "Bezet", _ta = "Je hebt zojuist verbinding gemaakt. Boek een tijdslot hierboven of probeer het later opnieuw.", pta = "Niet-beschikbaar tijdslot", mta = "Het afspraaktype kan op dit moment niet worden geboekt. Zou je een ander tijdslot willen proberen?", fta = "Interne fout. Verzoek bevat geen eindtijd", gta = "Kan geen agenda-evenement aanmaken in de agenda van de organisator", hta = "Kan de agenda-afspraak niet bijwerken.", vta = "Kan de agenda-afspraak niet verwijderen.", bta = "Je bent al ingeschreven voor deze boeking.", yta = "Sommige hosts zijn niet beschikbaar voor boeking.", $ta = "Sommige vaste hosts zijn niet beschikbaar voor boeking.", wta = "Round Robin host is niet beschikbaar voor boekingen.", kta = "Help", Sta = "Prijs", xta = "Betaald", Eta = "Terugbetaald", Tta = "Opnemen", Ata = "Transcriberen", Cta = "Betaling", zta = "Velden voor creditcard ontbreken", Ota = "Nu betalen", Pta = "Algemene Prompt", Ita = "Transcriptie aangedreven door AI", Rta = "Opname starten of stoppen", Nta = "Begin Bericht", Dta = "De codebase moet open source blijven, ongeacht of deze is gewijzigd of niet", Mta = "U kunt de codebase niet opnieuw verpakken of verkopen", Lta = "Schaf via e-mail een commerciële licentie aan om deze voorwaarden te verwijderen", qta = "Samenvatting van voorwaarden", jta = "Open .env en ga akkoord met onze voorwaarden", Fta = "Ik heb mijn .env gewijzigd", Vta = "Licentie accepteren", Bta = "Er is nog een openstaande goedkeuring voor een evenement", Uta = "Openstaand verzoek voor evenement: {{attendeeName}} - {{date}} - {{eventType}}", Wta = 'Geen resultaten gevonden voor "{{searchTerm}}"', Gta = "Geen verdere resultaten", Hta = "Geen resultaten", Kta = "Meer resultaten laden", Yta = "{{integrationName}} afspraak ID: {{meetingId}}", Zta = "Bevestigd: {{eventType}} met {{name}} op {{date}}", Qta = "Nieuwe afspraakaanvraag: {{attendeeName}} - {{date}} - {{eventType}}", Jta = "Bevestig of weiger het verzoek", Xta = "Controleer uw boekingen om de boeking te bevestigen of te verwerpen.", ena = "Check-in Assistent", tna = "Pleit een uitgaande oproep om te controleren of de geplande afspraak werkt of als je wilt herplannen.", nna = "Maak je eigen prompt en gebruik deze om een uitgaande oproep te doen.", ona = "Een gebeurtenis wacht op uw goedkeuring", rna = "Een terugkerende gebeurtenis wacht op uw goedkeuring", ina = "Iemand heeft verzocht om een gebeurtenis op uw kalender te plannen.", ana = "Iemand heeft een link verzocht om uw wachtwoord te wijzigen.", sna = "Als dit e-mailadres in ons systeem bestaat, zou u een e-mail voor het opnieuw instellen van uw wachtwoord moeten ontvangen.", cna = "Als dit niet heeft verzocht, kunt u deze e-mail gerust negeren en wordt uw wachtwoord niet gewijzigd.", lna = "In afwachting van goedkeuring: {{title}} om {{date}}", dna = "Een gebeurtenis wacht nog op uw goedkeuring", una = "Boeking verzonden: {{title}} om {{date}}", _na = "Opname downloaden: {{title}} op {{date}}", pna = "Download Transcript: {{title}} op {{date}}", mna = "Download uw opname", fna = "Download je Transcripts", gna = "Uw afspraak is geboekt", hna = "Uw {{title}} is verplaatst naar {{date}}.", vna = "Je {{title}} is bijgewerkt.", bna = "Bijgewerkt - Uw gebeurtenis is verplaatst", yna = "Afspraak is bijgewerkt", $na = "Je afspraak is verzet", wna = "{{organizer}} heeft de boeking geannuleerd en u verzocht een andere tijd te kiezen.", kna = "U heeft {{attendee}} gevraagd om te verplaatsen", Sna = "U heeft de boeking geannuleerd en {{attendee}} moet samen met u een nieuwe boekingstijd kiezen.", xna = "Verplaatst: {{eventType}} met {{name}} op {{date}}", Ena = "Actie vereist voor verplaatsing: boek een nieuwe tijd voor {{eventType}} met {{name}}", Tna = "Hallo {{name}}", Ana = "{{eventType}} met {{name}}", Cna = "Het lijkt erop dat al onze experts momenteel bezet zijn. Plan een gesprek in op een moment dat jou het beste uitkomt en we staan klaar om je te helpen.", zna = "Plan in plaats daarvan", Ona = "Nieuwe afspraak: {{attendeeName}} - {{date}} - {{eventType}}", Pna = "Word lid via {{entryPoint}}", Ina = "Opmerkingen", Rna = "Mijn boekingen beheren", Nna = "Moet u iets veranderen?", Dna = "Er is een nieuwe afspraak gemaakt.", Mna = "Er is een nieuwe terugkerende gebeurtenis gepland.", Lna = "E-mail", qna = "Tijdzone", jna = "Resterende tijd", Fna = "Evenement", Vna = "Dubbel Event Type", Bna = "Deelnemen", Una = "Videobellen via", Wna = "Afspraakcode", Gna = "Deelneming wachtwoord", Hna = "URL afspraak", Kna = "Vergader-URL niet gevonden", Yna = "Token niet gevonden", Zna = "Een andere host heeft de vergadering al geaccepteerd. Wil je nog steeds deelnemen? <0>Doorgaan naar vergadering</0>", Qna = "Uw afspraak is helaas afgewezen", Jna = "Afgewezen: {{eventType}} met {{organizer}} op {{date}}", Xna = "Hallo", eoa = "Lidverzoek accepteren", toa = "Dit team beheren", noa = "Teaminformatie", ooa = "Deelnemen aan Vergadering", roa = "Als u {{toEmail}} liever niet als uw {{appName}} e-mail wilt gebruiken of al een {{appName}} account heeft, vraag dan een andere uitnodiging aan voor die e-mail.", ioa = "U bent uitgenodigd om lid te worden van het team {{teamName}}", aoa = "{{user}} heeft u uitgenodigd om lid te worden van het {{entity}} {{team}} op {{appName}}", soa = "U bent verborgen in dit team", coa = "Uw plaats is niet betaald. Upgrade naar Pro of laat de teameigenaar weten dat deze uw plaats kan betalen.", loa = "U heeft een Pro-account nodig om teams te gebruiken, u bent verborgen tot u upgradet.", doa = "p.s. De uitnodiging verloopt over {{expiresIn}} uur.", uoa = "Upgraden naar per plaats", _oa = "De optie plaatsen optie ondersteunt geen bevestigingseis", poa = "Meerdere Locaties ondersteunt geen plaatsenoptie", moa = "No-show vergoeding ondersteunt geen plaatsenoptie", foa = "Plaatsenoptie ondersteunt geen Meerdere Locaties", goa = "Van de {{memberCount}} leden in uw team zijn {{unpaidCount}} plaats(en) onbetaald. Voor $ {{seatPrice}}/maand per plaats bedragen de geschatte totale kosten van uw abonnement $ {{totalCost}}/maand.", hoa = 'Bedankt voor het testen van ons nieuwe teamabonnement. We hebben geconstateerd dat uw team "{{teamName}}" moet worden geüpgraded.', voa = "Hier upgraden", boa = "Uw team is geüpgraded!", yoa = 'Bedankt voor het testen van ons organisatieabonnement. We hebben geconstateerd dat uw organisatie "{{teamName}}" moet worden geüpgraded.', $oa = "Uw organisatie is geüpgraded!", woa = "Gebruik de onderstaande link om uw wachtwoord te resetten", koa = "Hoi daar", Soa = "daar", xoa = "Wachtwoord vergeten? - {{appName}}", Eoa = "Weet u zeker dat u deze webhook wilt verwijderen? U ontvangt dan niet langer {{appName}} vergadergegevens op een opgegeven URL, in real-time, wanneer een evenement is geboekt of geannuleerd.", Toa = "Ja, webhook verwijderen", Aoa = "Webhook bewerken", Coa = "Webhook verwijderen", zoa = "Webhook status", Ooa = "Webhook ingeschakeld", Poa = "Webhook uitgeschakeld", Ioa = "Webhook melding", Roa = "Webhook testen", Noa = "Webhook-updateformulier", Doa = "Voeg een webhook toe aan je OAuthClient.", Moa = "Beheer uw webhook", Loa = "Webhook succesvol toegevoegd!", qoa = "Webhook succesvol bijgewerkt!", joa = "Webhook succesvol verwijderd!", Foa = "Abonnement vereist", Voa = "Je hebt geen abonnement op een Platform-plan.", Boa = "Gegevenssjabloon", Uoa = "Negeer", Woa = "Nog geen gegevens", Goa = "Ping test", Hoa = "Voeg deze app toe aan uw startscherm voor een snellere toegang en verbeterde ervaring.", Koa = "Toekomstige", Yoa = "Terugkerend", Zoa = "Verleden", Qoa = "Bestand kiezen...", Joa = "Afbeelding uploaden", Xoa = "Upload {{target}}", era = "Geen {{target}}", tra = "Schuif om in te zoomen, sleep om de positie te wijzigen", nra = "Notificaties bekijken", ora = "Publieke pagina bekijken", rra = "Link openbare pagina kopiëren", ira = "Kopieer verwijzingslink", ara = "Log uit", sra = "Nog een toevoegen", cra = "Nog een installeren", lra = "tot", dra = "mogelijk gemaakt door", ura = "Niet beschikbaar", _ra = "Uw werkschema instellen", pra = "Verander tijden wanneer u beschikbaar bent voor afspraken", mra = "Selecteer...", fra = "Tekst", gra = "Uw telefoonnummer", hra = "Meerdere regels tekst", vra = "Nummer", bra = "Selectievakje", yra = "Is verplicht", $ra = "Maak dit veld verplicht", wra = "Vereist", kra = "Optioneel", Sra = "Input type", xra = "Geweigerd", Era = "Niet-bevestigd", Tra = "Bezoekers", Ara = "Gast", Cra = "Details van de web conferentie zullen volgen.", zra = "Bevestiging", Ora = "Wat je boeker moet verstrekken om bevestigingen te ontvangen", Pra = "Gebruikersnaam", Ira = "is nog steeds beschikbaar.", Rra = "Documentatie", Nra = "Leer hoe u onze tools kunt integreren met uw app", Dra = "API Referentie", Mra = "Een complete API-referentie voor onze database", Lra = "Blog", qra = "Lees ons laatste nieuws en artikelen", jra = "Word lid van onze community", Fra = "Populaire pagina's", Vra = "Registreer nu", Bra = "Registreer", Ura = "Deze pagina bestaat niet.", Wra = "Geen actief telefoonnummer beschikbaar", Gra = "Workflowstap niet geconfigureerd", Hra = "Controleer op spelfouten of ga terug naar de vorige pagina.", Kra = "We kunnen de gebeurtenis die u probeert te boeken niet vinden.", Yra = "Aan de slag", Zra = "Geheim", Qra = "Leeglaten om geheim te verwijderen", Jra = "Zorg om beveiligingsredenen ervoor dat uw server alleen de verwachte {{appName}}-verzoeken ontvangt", Xra = "Geheime Afspraak", eia = "In plaats daarvan inloggen", tia = "Account Aanmaken", nia = "Aan de slag", oia = "Wachtwoord bevestigen", ria = "Stel uw nieuwe wachtwoord in met de instructies die u per e-mail zijn toegestuurd.", iia = "Upload een afbeelding van {{width}} breedte en {{height}} hoogte.", aia = "Log opnieuw in met uw nieuwe e-mailadres en wachtwoord.", sia = "Uw account aanmaken", cia = "Maak je Cal.com-account aan", lia = "Registreer nu", dia = "U bent uitgelogd", uia = "We hopen u spoedig weer te zien!", _ia = "Uitgelogd", pia = "Probeer het opnieuw en neem contact met ons op als het probleem zich blijft voordoen.", mia = "Tweestapsverificatie code is onjuist.", fia = "Er bestaat geen account met dat e-mailadres.", gia = "Account aanmaken", hia = "Heeft u nog geen account?", via = "Log in op uw account", bia = "Log in", yia = "Ga terug naar de inlogpagina", $ia = "Er is een fout opgetreden tijdens het inloggen. Ga terug naar de inlogpagina en probeer het opnieuw.", wia = "E-mail voor opnieuw instellen van wachtwoord versturen", kia = "Uitnodiging versturen", Sia = "Wachtwoord vergeten?", xia = "Vergeten?", Eia = "Voltooid", Tia = "Helemaal klaar!", Aia = "Alle", Cia = "Uw account", zia = "Beschikbare apps", Oia = "Beschikbare apps", Pia = "Bekijk populaire apps hieronder en ontdek meer in onze <0>App Store</0>", Iia = "Voeg iedereen toe die bij het evenement aanwezig moet zijn. <0>Meer informatie</0>", Ria = "Mensen in een groep wisselen elkaar af, één persoon van elke groep zal aanwezig zijn bij de gebeurtenis.", Nia = "Mensen in de groep wisselen elkaar af en er komt maar één persoon opdagen voor de gebeurtenis.", Dia = "Controleer uw e-mail. We hebben u een link gestuurd om uw wachtwoord opnieuw in te stellen.", Mia = "Voltooien", Lia = "Beheer de instellingen voor de taal en tijdzone van uw team", qia = "Een korte introductie over uzelf. Dit wordt weergegeven op uw persoonlijke pagina.", jia = "Bijna klaar!", Fia = "Als laatste, een korte beschrijving over jezelf en een foto helpt echt bij het krijgen van boekingen en laat mensen weten met wie ze een afspraak maken.", Via = "Bepaal tijdbereiken waarin u periodiek beschikbaar bent. U kunt op een later tijdstip terugkomen en hier meer van aanmaken en toewijzen aan verschillende kalenders.", Bia = "Beschikbaarheid bepalen", Uia = "Stel schema's in voor de tijden waarop je geboekt wilt worden.", Wia = "Deel een link of embed", Gia = "Deel je {{appName}}-link of embed deze op je site.", Hia = "Beschikbaarheidsinstellingen", Kia = "Doorgaan zonder kalender", Yia = "Ga door met {{appName}}", Zia = "Koppel uw agenda", Qia = "Koppel uw videoapps", Jia = "Koppel uw videoapps om ze op uw gebeurtenistypes te gebruiken.", Xia = "Verbind je agenda om automatisch te controleren op bezette tijden en nieuwe afspraken zodra deze worden gepland.", eaa = "Later instellen", taa = "Huidige tijd", naa = "Details", oaa = "Welkom", raa = "Welkom terug", iaa = "Welkom bij {{appName}}", aaa = "Vertel ons hoe we je moeten noemen en laat ons weten in welke tijdzone je je bevindt. Je kunt dit later bewerken.", saa = "Verbinding maken met de CalDav (Beta)", caa = "Verbind met een ICS-feed", laa = "Koppelen", daa = "Probeer het gratis", uaa = "Maak uw eigen boekingslink met {{appName}}", _aa = "Wie", paa = "Wat", maa = "Wanneer", faa = "Waar", gaa = "Toevoegen aan kalender", haa = "Selecteer waar je evenementen wilt toevoegen wanneer je geboekt bent.", vaa = "Voeg gebeurtenissen toe aan", baa = "Andere agenda toevoegen", yaa = "Overige", $aa = "Uw aanmeldingslink voor {{appName}}", waa = "Je hebt een afspraak met {{user}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", kaa = "{{host}} heeft een afspraak met {{attendee}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", Saa = "We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd.", xaa = "We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", Eaa = "Je hebt een afspraak met {{user}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", Taa = "{{host}} heeft een afspraak met {{attendee}}. We hebben een e-mail met een kalenderuitnodiging en de details naar iedereen gestuurd voor de eerste van deze terugkerende evenementen.", Aaa = "U en alle andere deelnemers zijn gemaild met deze informatie.", Caa = "Uw boeking moet nog steeds worden bevestigd of geweigerd.", zaa = "Uw terugkerende afspraak moet nog steeds bevestigd of geweigerd worden.", Oaa = "{{user}} moet de boeking nog steeds bevestigen of weigeren.", Paa = "{{user}} moet nog steeds elke boeking van de terugkerende afspraak bevestigen of weigeren.", Iaa = "Deze afspraak is ingeboekt", Raa = "De terugkerende gebeurtenissen zijn gepland", Naa = "Afspraak Verzonden", Daa = "Uw terugkerende afspraak is verzonden", Maa = "Afspraak bevestigd", Laa = "Uw terugkerende vergadering is bevestigd", qaa = "Betalingen worden nog niet ondersteund voor terugkerende gebeurtenissen", jaa = "Terugkerende gebeurtenissen worden nog niet ondersteund met betalingen", Faa = "Voer het nieuwe wachtwoord in dat u wilt gebruiken voor uw account.", Vaa = "Wachtwoord opnieuw instellen", Baa = "Uw wachtwoord wijzigen", Uaa = "Wachtwoord tonen", Waa = "Wachtwoord verbergen", Gaa = "Opnieuw proberen", Haa = "Dat verzoek is verlopen.", Kaa = "Voer het e-mailadres van uw account in en wij sturen u een link om uw wachtwoord opnieuw in te stellen.", Yaa = "Dat verzoek is verlopen. Ga terug en voer het e-mailadres in dat gekoppeld is aan uw account en wij sturen u een andere link om uw wachtwoord opnieuw in te stellen.", Zaa = "Oeps", Qaa = "Inloggen", Jaa = "Geslaagd", Xaa = "Mislukt", esa = "Uw wachtwoord is opnieuw ingesteld. U kunt nu inloggen met uw nieuwe wachtwoord.", tsa = "Indeling", nsa = "Standaardweergave", osa = "U kunt er meerdere selecteren en uw boekers kunnen van weergave wisselen.", rsa = "Boekingsindeling", isa = "U kunt er meerdere selecteren en boekers kunnen van weergave wisselen. Dit kan per gebeurtenis worden aangepast.", asa = "Maand", ssa = "Wekelijks", csa = "Kolom", lsa = "Minimaal één indeling moet ingeschakeld zijn.", dsa = "De indeling die u als standaardweergave heeft geselecteerd, behoort niet tot de ingeschakelde indelingen.", usa = "De door u geselecteerde indeling is geen geldige indeling.", _sa = "Je kunt dit voor al je evenementtypes beheren in Instellingen -> <0>Weergave</0> of <1>Overschrijven</1> alleen voor dit evenement.", psa = "Er is een onverwachte fout opgetreden. Probeer het opnieuw.", msa = "Ongeldige tijd op zondag", fsa = "Ongeldige tijd op maandag", gsa = "Ongeldige tijd op dinsdag", hsa = "Ongeldige tijd op woensdag", vsa = "Ongeldige tijd op donderdag", bsa = "Ongeldige tijd op vrijdag", ysa = "Ongeldige tijd op zaterdag", $sa = "De eindtijd mag niet voor de begintijd zijn", wsa = "De eindtijd mag niet meer dan 24 uur later zijn", ksa = "Terug naar afspraken", Ssa = "U kunt op elk moment een andere afspraak maken.", xsa = "Geannuleerd", Esa = "Geen boeking", Tsa = "Wachten op host", Asa = "Annulering geslaagd", Csa = "Weet u zeker dat u deze afspraak wilt annuleren?", zsa = "U kunt deze afspraak niet annuleren", Osa = "U kunt de afspraak ook verzetten.", Psa = "De afspraak is verlopen", Isa = "De gebeurtenis is één exemplaar van een terugkerende gebeurtenis.", Rsa = "Dit zijn alle resterende exemplaren van de terugkerende gebeurtenis.", Nsa = "Er is een fout opgetreden met de code {{status}}.", Dsa = "Er bestaat al een gebeurtenistype met deze URL.", Msa = "U kunt deze gebeurtenis niet maken", Lsa = "U kunt deze gebeurtenis niet bewerken", qsa = "U kunt deze werkstroom niet maken", jsa = "U kunt deze planning niet maken", Fsa = "Deze boeking is al geannuleerd", Vsa = "Deze boeking is al geaccepteerd of geweigerd", Bsa = "Terug naar startpagina", Usa = "Of ga terug naar de startpagina", Wsa = "Afspraak Niet Gevonden", Gsa = "Kan deze afspraak niet vinden. Neem contact op met de organisator voor een nieuwe link.", Hsa = "Geen {{status}} afspraken", Ksa = "U heeft nog geen {{status}} afspraken. {{description}}", Ysa = "{{eventName}} tussen {{host}} en {{attendeeName}}", Zsa = "Afspraken", Qsa = "Boeking niet gevonden", Jsa = "Bekijk geplande en voorgaande afspraken die geboekt zijn door middel van uw links.", Xsa = "Zodra iemand een tijd boekt zal deze hier verschijnen.", eca = "Zodra iemand een terugkerende afspraak met u boekt, verschijnt die hier.", tca = "Uw oude afspraken zullen hier verschijnen.", nca = "Uw geannuleerde boekingen worden hier weergegeven.", oca = "Uw niet-bevestigde afspraken zullen hier verschijnen.", rca = "Niet-bevestigde boekingen", ica = "aan", aca = "en", sca = "Uw agenda toont u als bezig tussen", cca = "Probleemoplosser", lca = "Begrijp waarom bepaalde tijden beschikbaar zijn en andere worden geblokkeerd.", dca = "Hier is een overzicht van uw dag op", uca = "Tip: Beweeg over de dik gedrukte tijden voor een volledige weergave", _ca = "Begin tijd", pca = "Eind tijd", mca = "Buffertijd", fca = "Voor gebeurtenis", gca = "Na gebeurtenis", hca = "Geen buffertijd", vca = "Buffer", bca = "Uw dag begint om", yca = "Uw dag eindigt om", $ca = "Probleemoplosser openen", wca = "Bekijk uw beschikbaarheid om te ontdekken waarom uw tijden zo zichtbaar zijn.", kca = "Verander beschikbare tijden", Sca = "Verander uw beschikbare tijden", xca = "Wijzig de begin- en eindtijden van uw dag", Eca = "Stel de begin- en eindtijd van uw dag in en een minimale buffer tussen uw afspraken.", Tca = "Momenteel is uw dag ingesteld om te starten op", Aca = "De begin- en eindtijden voor uw dag zijn succesvol gewijzigd.", Cca = "en eindigt om", zca = "Licht", Oca = "Donker", Pca = "Thema automatisch aanpassen op basis van voorkeur genodigde", Ica = "Sommige gebruikers in de groep hebben momenteel dynamische groepsboekingen uitgeschakeld", Rca = 'Groepsboekingslinks die dynamisch kunnen worden aangemaakt door meerdere gebruikersnamen toe te voegen met een "+", bijvoorbeeld: "{{appName}}/bailey+peer', Nca = "Sta deelnemers toe om u te boeken via dynamische groepsboekingen", Dca = "Dynamische groepslinks", Mca = "Geef zoekmachines toegang tot uw openbare content", Lca = "Indexering door zoekmachines toestaan", qca = "Browsermeldingen toestaan", jca = "Je hebt meldingen geweigerd. Stel de toestemming opnieuw in via de browserinstellingen om deze in te schakelen.", Fca = "Browsermeldingen uitschakelen", Vca = "Browsermeldingen ingeschakeld", Bca = "Browsermeldingen uitgeschakeld", Uca = "Browsermeldingen geweigerd", Wca = "Sta meldingen toe via de prompt", Gca = "Pushmeldingen", Hca = "Ontvang pushmeldingen wanneer een boeker een directe afspraak maakt.", Kca = "Je browser ondersteunt geen pushmeldingen. Als je Brave gebruikt, schakel dan de optie `Google-services gebruiken voor pushberichten` in op brave://settings/?search=push+messaging", Yca = "E-mailadres", Zca = "jjansen@voorbeeld.nl", Qca = "Volledige naam", Jca = "Bekijk onze API-documentatie", Xca = "Gebruik onze API voor volledige controle en aanpasbaarheid.", ela = "Webhook maken", tla = "Directe Vergadering Aangemaakt", nla = "Boeking geannuleerd", ola = "Afspraak verplaatst", rla = "Opnamedownloadlink gereed", ila = "Transcriptie gegenereerd", ala = "Boeking aangemaakt", sla = "Boeking geweigerd", cla = "Boeking aangevraagd", lla = "Betaling boeking gestart", dla = "Vergadering beëindigd", ula = "Formulier verzonden", _la = "Formulier ingediend, geen afspraak geboekt", pla = "Boeking betaald", mla = "Out of Office aangemaakt", fla = "Boeking No-Show Bijgewerkt", gla = "Webhook activaties", hla = "Abonnee-URL", vla = "Nieuwe webhook aanmaken", bla = "Webhooks", yla = "Teamwebhooks", $la = "Maak een nieuwe webhook aan voor uw account", wla = "Maak een Webhook", kla = "Ontvang afspraakgegevens van {{appName}} in realtime op een opgegeven URL wanneer een gebeurtenis wordt gepland of geannuleerd.", Sla = "Ontvang afspraakgegevens van {{appName}} in realtime op een opgegeven URL wanneer deze gebeurtenis wordt gepland of geannuleerd.", xla = "Responsieve iframe", Ela = "Laden...", Tla = "Verwijderen...", Ala = "Standaard iframe", Cla = "Ontwikkelaar", zla = "Beheer uw ontwikkelaarsinstellingen.", Ola = "iframe insluiten", Pla = "De makkelijkste manier om {{appName}} op uw website in te sluiten.", Ila = "Integreer met uw eigen website met behulp van onze insluitingsopties, of ontvang informatie over afspraken met behulp van webhooks.", Rla = "Afspraak maken", Nla = "Bekijk en beheer uw betalingsgegevens", Dla = "Uw betalingsgegevens bekijken of uw account opzeggen.", Mla = "Ga naar het facturatiepaneel", Lla = "Nog iets nodig?", qla = "Als u verdere hulp nodig heeft bij facturering, is ons ondersteuningsteam er om u te helpen.", jla = "Contact", Fla = "ons ondersteuningsteam", Vla = "Neem contact op met onze klantenservice", Bla = "Oeps!", Ula = "Deze gebruiker heeft nog geen evenementen.", Wla = "Bewerk logo", Gla = "Logo uploaden", Hla = "Logo uploaden", Kla = "Logo verwijderen", Yla = "Inschakelen", Zla = "Code", Qla = "Code is ongeldig.", Jla = "Nieuw tijdslot toevoegen", Xla = "Voeg een extra beveiligingslaag toe aan uw account in het geval uw wachtwoord gestolen wordt.", eda = "Tweestapsverificatie inschakelen", tda = "Tweestapsverificatie uitschakelen", nda = "Als u tweestapsverificatie wilt deactiveren, raden wij aan om dit zo snel mogelijk ongedaan te maken.", oda = "Er ging iets mis bij het deactiveren van tweestapsverificatie", rda = "Er ging iets mis bij het activeren van tweestapsverificatie", ida = "Beveiliging", ada = "Uw account beveiligen.", sda = "Wachtwoord", cda = "Wachtwoord met succes bijgewerkt", lda = "Uw wachtwoord is met succes gewijzigd.", dda = "Er ging iets mis tijdens het wijzigen van uw wachtwoord", uda = "Uw sessieconfiguratie is bijgewerkt.", _da = "Fout bij het bijwerken van de sessieconfiguratie", pda = "Er ging iets fout.", mda = "Iets ziet er niet correct uit?", fda = "Probeer het nogmaals.", gda = "Uw veilige nieuwe wachtwoord", hda = "Nieuw Wachtwoord", vda = "Uw oude wachtwoord", bda = "Huidig Wachtwoord", yda = "Wachtwoord wijzigen", $da = "Geheim wijzigen", wda = "Het nieuwe wachtwoord komt overeen met uw oude wachtwoord. Kies een ander wachtwoord.", kda = "Als u dit geheim vergeten of verloren bent, kunt u het wijzigen. Maar wees u ervan bewust dat alle integraties die dit geheim gebruiken bijgewerkt moeten worden", Sda = "Uw wachtwoord is verkeerd", xda = "Mix van hoofd- en kleine letters", Eda = "Minimaal 7 tekens lang", Tda = "Minimaal 15 tekens lang", Ada = "Minimaal 1 cijfer bevatten", Cda = "Moet {{limit}}} of minder tekens lang zijn", zda = "Het wachtwoord moet minimaal {{passwordLength}} tekens lang zijn, minimaal 1 cijfer bevatten en bestaan uit een mix van hoofd- en kleine letters", Oda = "Uw wachtwoord is incorrect.", Pda = "E-mailadres of wachtwoord is onjuist.", Ida = "Instelling gebruiken", Rda = "am/pm", Nda = "Tijd, datum en tijdzone instellen", Dda = "Januari", Mda = "Februari", Lda = "Maart", qda = "April", jda = "Mei", Fda = "Juni", Vda = "Juli", Bda = "Augustus", Uda = "September", Wda = "Oktober", Gda = "November", Hda = "December", Kda = "Maandag", Yda = "Dinsdag", Zda = "Woensdag", Qda = "Donderdag", Jda = "Vrijdag", Xda = "Zaterdag", eua = "Zondag", tua = "Alles geboekt.", nua = "De beschikbare tijdsperiodes konden niet worden geladen.", oua = "Gasten toevoegen", rua = "Uw naam", iua = "Uw volledige naam", aua = "Geen naam", sua = "Voer een getal in tussen 1 en {{maxOccurences}}", cua = "Snel en eenvoudig - geen account vereist. Perfect voor eenmalige afspraken.", lua = "E-mail adres", dua = "Voer een geldig e-mailadres in", uua = "Plan een toekomstige oproep als we niet beschikbaar zijn in {{seconds}} seconden", _ua = "Locatie", pua = "Adres", mua = "Voer adres in", fua = "Persoonlijk (adres deelnemer)", gua = "Elders", hua = "Aangepaste locatie deelnemer", vua = "Doorgaan als gast", bua = "Deelnemen als gast", yua = "Ideaal voor eenmalige gesprekken", $ua = "Elke locatie", wua = "Ja", kua = "Nee", Sua = "Aanvullende notities", xua = "De afspraak kon niet geboekt worden.", Eua = "De afspraak kon niet opnieuw gepland worden.", Tua = "Deel alstublieft alles wat kan helpen bij de voorbereiding van onze afspraak.", Aua = "Bevestig uw {{eventTypeTitle}} met {{profileName}}", Cua = "Opnieuw plannen van uw {{eventTypeTitle}} met {{profileName}}", zua = "Online of persoonlijk afspreken", Oua = "Persoonlijk (adres organisator)", Pua = "Vergadering koppelen", Iua = "Telefoon nummer", Rua = "Telefoonnummer deelnemer", Nua = "Telefoonnummer organisator", Dua = "Telefoonnummer", Mua = "Boeking wijzigen", Lua = "Verplaatst in plaats daarvan", qua = "Of, reserveer een teamlid", jua = "OF", Fua = "Ga terug", Vua = "E-mail of gebruikersnaam", Bua = "Verstuur een uitnodigingsmail", Uua = "Functie", Wua = "Rol bewerken", Gua = "Rol bekijken", Hua = "Bewerk team", Kua = "Gebruiker bewerken", Yua = "Organisatie bewerken", Zua = "Als je je webhooks wilt bewerken of beheren, ga dan naar <0>webhooks instellingen</0>", Qua = "Weigeren", Jua = "Alles weigeren", Xua = "Aanvaarden", e_a = "Verlaat", t_a = "Profiel", n_a = "Mijn team URL", o_a = "Mijn teams", r_a = "Teamnaam", i_a = "Naam van uw team", a_a = "Team bijgewerkt", s_a = "Uw team is succesvol bijgewerkt.", c_a = "Uw organisatie is bijgewerkt.", l_a = "Fout bij kopiëren naar klembord", d_a = "Introductie", u_a = "Een paar zinnen over uw team. Dit is zichtbaar op uw teampagina.", __a = "Organisatie-ID", p_a = "Organisatie-ID gekopieerd.", m_a = "Een paar zinnen over uw organisatie. Dit wordt weergegeven op op uw organisatiepagina.", f_a = "Team-ID", g_a = "Team-ID gekopieerd.", h_a = "Leden", v_a = "Organisatieleden", b_a = "Lid", y_a = "{{count}} lid", $_a = "{{count}} leden", w_a = "{{count}} geselecteerd", k_a = "Eigenaar", S_a = "Beheerder", x_a = "Admin API", E_a = "Beheerdersgebruiker", T_a = "Laten we de eerste beheerdersgebruiker aanmaken.", A_a = "Beheerdersgebruikerconfiguratie", C_a = "U heeft al een beheerdergebruiker gemaakt. U kunt nu inloggen op uw account.", z_a = "Nieuw Lid", O_a = "Uitnodigen", P_a = "Teamleden toevoegen", I_a = "Leden toevoegen", R_a = "Anderen uitnodigen om deel te nemen aan uw team", N_a = "Teamlid toevoegen", D_a = "Nieuw teamlid uitnodigen", M_a = "Let op: Dit zal <0>een extra zetel kosten (€15/m)</0> op je abonnement.", L_a = "Nodig iemand uit tot uw team.", q_a = "Upload een .csv-bestand", j_a = "Uitnodigen via e-mail", F_a = "Rol teamlid wijzigen", V_a = "{{appName}}-merk uitschakelen", B_a = "Verberg alle {{appName}} branding op uw openbare pagina's.", U_a = "Knop 'Teamlid boeken' verbergen", W_a = "Verberg de knop 'Teamlid boeken' op uw openbare pagina's.", G_a = "Gevarenzone", H_a = "Wees voorzichtig. Het verwijderen van een account kan niet ongedaan worden gemaakt.", K_a = "Wees voorzichtig. Het verwijderen van een team kan niet ongedaan worden gemaakt.", Y_a = "Terug", Z_a = "Annuleren", Q_a = "Alle resterende annuleren", J_a = "Toepassen", X_a = "Gebeurtenis annuleren", epa = "Bevestig", tpa = "Alles bevestigen", npa = "Team ontbinden", opa = "Weet u zeker dat u dit team wilt ontbinden? Iedereen met wie u deze teampagina heeft gedeeld zal hem niet meer kunnen gebruiken om te boeken.", rpa = "Organisatie ontbinden", ipa = "Weet u zeker dat u deze organisatie wilt ontbinden? Alle teams en leden worden verwijderd.", apa = "Weet u zeker dat u dit lid uit het team wilt verwijderen?", spa = "Ja, ontbind team", cpa = "Ja, verwijder lid", lpa = "Ja, abonnement opzeggen", dpa = "Abonnement opzeggen", upa = "Door je abonnement op te zeggen wordt je huidige plan permanent gedeactiveerd. Deze actie kan niet ongedaan worden gemaakt.", _pa = "Verwijder lid", ppa = "Beheer uw team", mpa = "U heeft nog geen teams.", fpa = "Teams geven anderen de mogelijkheid om gebeurtenissen te boeken die zijn gedeeld tussen uw collega's.", gpa = "Opslaan", hpa = "Ja, attribuut verwijderen", vpa = "Attribuut verwijderen", bpa = "Weet u zeker dat u het attribuut '{{name}}' wilt verwijderen? Alle gebruikers die momenteel zijn toegewezen, zullen worden losgekoppeld.", ypa = "Bijwerken", $pa = "Opslaan", wpa = "In afwachting", kpa = "Opties openen", Spa = "Link naar afspraak kopiëren", xpa = "Delen", Epa = "Zou u mijn Cal willen boeken of mij uw link willen sturen?", Tpa = "Link naar team kopiëren", Apa = "Team verlaten", Cpa = "Ja, team verlaten", zpa = "Weet u zeker dat u dit team wilt verlaten? U kunt er niet meer mee boeken.", Opa = "{{user}} van {{team}}", Ppa = "Voorbeeld", Ipa = "Link gekopieerd!", Rpa = "Gekopieerd!", Npa = "Privélink gekopieerd!", Dpa = "Link gedeeld!", Mpa = "Titel", Lpa = "Beschrijving", qpa = "Apps-status", jpa = "Een korte videovergadering.", Fpa = "Planning Type", Vpa = "Bekijk team", Bpa = "Collectief", Upa = "Plan vergaderingen wanneer alle geselecteerde teamleden beschikbaar zijn.", Wpa = "Looptijd", Gpa = "Beschikbare duur", Hpa = "Standaardduur", Kpa = "Kies eerst de beschikbare duur", Ypa = "{{count}} $t(minute_timeUnit)", Zpa = "{{count}} $t({{unit}}_timeUnit)", Qpa = "{{count}}$t({{unit}}_short)", Jpa = "Minuten", Xpa = "Gebruik Cal.ai om een AI-gestuurd telefoonnummer te krijgen of om oproepen te doen naar gasten.", ema = "Beëindigings-URI", tma = "SIP Trunk gebruikersnaam", nma = "SIP Trunk wachtwoord", oma = "Bijnaam", rma = "Telefoonnummer verwijderen", ima = "Workflow-validatie mislukt", ama = "Een of meer workflow-stappen hebben lege berichtinhoud", sma = "Een of meer telefoonnummers of e-mailadressen zijn niet geverifieerd", cma = "Versterk je workflows met Cal.ai", lma = "Levensechte AI-agenten die afspraken boeken, herinneringen sturen en opvolgen met je klanten.", dma = "Telefoonnummer succesvol geïmporteerd en gekoppeld aan agent", uma = "Telefoonnummer succesvol verwijderd", _ma = "Weet je zeker dat je dit telefoonnummer wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", pma = "Ja, verwijder telefoonnummer", mma = "Het nummer dat je probeert te importeren moet in E.164-formaat zijn (+landcode gevolgd door het nummer, zonder spaties of speciale tekens), bijv. +1234567890", fma = "De beëindigings-URI om je elastische SIP-trunk uniek te identificeren. Dit wordt gebruikt voor uitgaande gesprekken. Voor Twilio elastische SIP-trunks eindigt het altijd met .pstn.twilio.com.", gma = "De gebruikersnaam die wordt gebruikt om de SIP-trunk te authenticeren.", hma = "Het wachtwoord dat wordt gebruikt om de SIP-trunk te authenticeren.", vma = "Bijnaam van het nummer. Dit is alleen voor je eigen referentie.", bma = "Opslaan en testgesprek", yma = "Gesprek succesvol gestart", $ma = "Voer een telefoonnummer in", wma = "Agent succesvol bijgewerkt", kma = "Agent succesvol aangemaakt", Sma = "Evenementtype succesvol toegevoegd", xma = "Telefoonnummer succesvol afgemeld", Ema = "Deze prompt definieert de rol en primaire doelstellingen van de agent", Tma = "Prompt", Ama = "Bellen naar", Cma = "Maak een testgesprek om de configuratie te verifiëren", zma = "Eerste bericht", Oma = "Het eerste bericht dat de agent zal zeggen bij het begin van een gesprek", Pma = "Problemen met importeren?", Ima = "Leren", Rma = "Leer hoe je je Termination URI en SIP-trunk inloggegevens kunt verkrijgen", Nma = "Telefoonnummer-abonnement succesvol geannuleerd", Dma = "Bijwerken", Mma = "Round Robin", Lma = "Hoi, hoe gaat het met je?", qma = "Afspraken wisselen tussen meerdere teamleden.", jma = "Beheerde gebeurtenis", Fma = "gebruikersnaam", Vma = "Maak en distribueer gebeurtenistypen in bulk naar teamleden", Bma = "Beheerd", Uma = '"username" wordt gevuld met de gebruikersnaam van de toegewezen leden', Wma = "Toewijzen aan", Gma = "Voer telefoonnummer in voor testgesprek", Hma = "Maak testgesprek", Kma = "Nieuwe workflow cal.ai spraakagent aanmaken", Yma = "Maak een nieuwe workflow cal.ai spraakagent om je workflows te automatiseren", Zma = "Telefoonnummer (voor onze agent om te bellen)", Qma = "Koop een telefoonnummer of importeer er een die je al hebt bij Twilio", Jma = "Test agent", Xma = "Test webgesprek", efa = "Telefoonnummers", tfa = "Afmelden", nfa = "Workflow-stap verwijderen", ofa = "Telefoonnummer afmelden", rfa = "Koop een nieuw nummer", ifa = "Je kunt alleen Amerikaanse telefoonnummers kopen. Voor andere landen kun je je eigen Twilio-telefoonnummer importeren.", afa = "Koop een Amerikaans nummer voor ${{priceInDollars}} per maand", sfa = "Ondersteunde belbestemmingen", cfa = "Geen telefoonnummer verbonden", lfa = "Ophalen van werkstroom-stap ID mislukt", dfa = "Cal.ai Agent", ufa = "Test Cal.ai Agent", _fa = "Weet u zeker dat u deze werkstroomstap wilt verwijderen?", pfa = "Wilt u het telefoonnummer nog steeds afmelden bij deze agent?", mfa = "Deze actie zal het telefoonnummer loskoppelen van de agent. De agent kan geen oproepen meer maken totdat er een nieuw telefoonnummer is verbonden.", ffa = "Telefoonnummers", gfa = "Telefoonnummer verbinden", hfa = "Beheer je telefoonnummers", vfa = "Nummer importeren", bfa = "Deze actie zal ook:", yfa = "Telefoonnummer importeren", $fa = "Actief abonnement", wfa = "Uw telefoonnummerabonnement opzeggen", kfa = "Het bijbehorende telefoonnummer verwijderen", Sfa = "U bent niet gemachtigd om deze werkstroom aan te maken", xfa = "Importeer je Twilio-telefoonnummer om te gebruiken met Telefoon", Efa = "${{price}}/maand", Tfa = "Nieuw nummer kopen", Afa = "Een telefoonnummer kopen kost ${{priceInDollars}} per maand. U wordt maandelijks gefactureerd voor elk actief telefoonnummer.", Cfa = "Netnummer (optioneel)", zfa = "Geen telefoonnummers", Ofa = "Telefoonnummer succesvol aangeschaft", Pfa = "Telefoonnummer-abonnement opzeggen", Ifa = "Ja, abonnement opzeggen", Rfa = "Weet u zeker dat u dit telefoonnummer-abonnement wilt opzeggen? Deze actie kan niet ongedaan worden gemaakt en u verliest toegang tot dit telefoonnummer.", Nfa = "Leden toevoegen...", Dfa = "Leden toevoegen", Mfa = "Geen toegewezen leden", Lfa = "Toegewezen aan", qfa = "Je moet ingelogd zijn op {{url}}", jfa = "Begin met het toewijzen van leden hierboven", Ffa = "Leden kunnen dit niet bewerken", Vfa = "Leden kunnen bewerken", Bfa = "Deze optie is vergrendeld door de teambeheerder", Ufa = "Vrijgegeven door teambeheerder", Wfa = "Link", Gfa = "Verborgen", Hfa = "Enkel-lezen", Kfa = "Eenmalige link", Yfa = "U heeft momenteel het {{plan}}-abonnement.", Zfa = "Upgrade uw account naar het Pro-abonnement om alle functies te ontgrendelen die we te bieden hebben.", Qfa = "U moet uw abonnement upgraden om meer dan één actief afspraaktype te hebben.", Jfa = "U moet uw abonnement upgraden om een team aan te maken.", Xfa = "U kunt <1>hier upgraden</1>.", ega = "Evenementen", tga = "Maak deelbare evenementen die bezoekers kunnen gebruiken om afspraken in uw agenda te boeken.", nga = "Nieuw evenement", oga = "Maak uw eerste evenement aan", rga = "Evenementen stellen u in staat om links te delen die beschikbare tijden tonen op uw agenda en bezoekers hiervan kunnen deze gebruiken om afspraken te maken.", iga = "{{eventTypeTitle}} evenement met succes aangemaakt", aga = "Evenement is bijgewerkt", sga = "Evenement is verwijderd", cga = "Uren", lga = "Mensen", dga = "Uw E-mailadres", uga = "Wijzig avatar", _ga = "Avatar uploaden", pga = "Taal", mga = "Tijdzone", fga = "Eerste dag van de week", gga = "Wordt tot {{count}} keer herhaald", hga = "Wordt tot {{count}} keer herhaald", vga = "Elke {{freq}} gedurende", bga = "{{count}} gebeurtenis resterend", yga = "{{count}} gebeurtenissen resterend", $ga = "Wordt herhaald om de", wga = "herhaling", kga = "keer", Sga = "week", xga = "weken", Ega = "maand", Tga = "maanden", Aga = "jaar", Cga = "jaar", zga = "Nog {{count}}", Oga = "Max.", Pga = "Enkel Thema", Iga = "Merkkleur", Rga = "Merkkleur (licht thema)", Nga = "Merkkleur (donker thema)", Dga = "Kleur van evenementtype (Licht Thema)", Mga = "Kleur van evenementtype (Donker Thema)", Lga = "Bestandsnaam is niet [idOrSlug]/[user]", qga = "Team aanmaken", jga = "Naam", Fga = "Naamloos team", Vga = "OAuth-clients", Bga = "Beheer OAuth-clients voor uw organisatie", Uga = "OAuth-client aanmaken", Wga = "Maak een nieuwe OAuth-client voor integraties met derden", Gga = "OAuth-client succesvol verwijderd", Hga = "Maak een nieuw team aan om met andere gebruikers samen te werken.", Kga = "Nieuw team aanmaken", Yga = "URL van je boekingspagina", Zga = "URL van de pagina waar je gebruikers hun boeking kunnen annuleren", Qga = "URL van de pagina waar je gebruikers hun boeking kunnen verzetten", Jga = "Dit tijdslot is niet meer beschikbaar. Ga terug naar de vorige pagina en kies een andere tijd.", Xga = "Openstaande uitnodigingen", eha = "Nieuw Team", tha = "Maak uw eerste team en nodig andere gebruikers uit om samen te werken.", nha = "Maak een team aan om aan de slag te gaan", oha = "Teams", rha = "Team", iha = "Organisatie", aha = "Teamfacturatie", sha = "Beheer de facturering voor uw team", cha = "We hebben het factureren gewijzigd voor teams", lha = "Er zijn leden in uw team zonder een plaats. Upgrade uw Pro-abonnement om de ontbrekende plaatsen te dekken.", dha = "Vanaf januari 2022 rekenen we per plaats voor teamleden. Leden van uw team die Pro gratis hadden, hebben nu een proefperiode van 14 dagen. Zodra hun proefperiode afloopt, worden deze leden verborgen voor uw team, tenzij u nu upgradet.", uha = "Maak en beheer teams om gezamenlijke functies te gebruiken.", _ha = "Deze functie is alleen beschikbaar in het Pro-pakket", pha = "Om de {{appName}} branding van uw boekpagina's te verwijderen, moet u upgraden naar een Pro-account.", mha = "Bewerk profielgegevens die worden weergegeven op uw boekpagina.", fha = "U moet zich mogelijk afmelden en weer aanmelden voordat de wijziging ingaat.", gha = "Een introductie over uzelf.", hha = "Profiel bijgewerkt", vha = "Uw profiel is is met succes bijgewerkt.", bha = "Je upgrade is beschikbaar", yha = "Verbeter je planningservaring door te upgraden naar het nieuwe plan en geniet van de nieuwe functies.", $ha = "Je bent helemaal klaar", wha = "Je gebruikt al het nieuwste plan. Geen upgrade nodig. Geniet van de nieuwe functies en neem contact met ons op als je vragen hebt!", kha = "Gebruiker lijkt ingelogd maar kan niet gevonden worden in de db", Sha = "Insluiten & Webhooks", xha = "Ingeschakeld", Eha = "Uitgeschakeld", Tha = "Uitschakelen", Aha = "Abonnement", Cha = "hier", zha = "Beheer uw betalingsgegevens en annuleer uw abonnement.", Oha = "Beschikbaarheid", Pha = "Beschikbaarheid bewerken", Iha = "Configureer tijden wanneer u beschikbaar bent voor afspraken.", Rha = "Tijden kopiëren naar", Nha = "Tijden kopiëren naar …", Dha = "Verander uw weekschema", Mha = "Logo", Lha = "Foutmelding", qha = "Voer minimaal één teken in", jha = "Voer minimaal {{count}} tekens in", Fha = "Team Logo", Vha = "Een locatie toevoegen", Bha = "Deelnemers", Uha = "Deelnemers toevoegen", Wha = "Toon geavanceerde instellingen", Gha = "Geavanceerde instellingen verbergen", Hha = "Naam van evenement", Kha = "Gebeurtenisnaam in agenda", Yha = "De naam die in kalenders wordt weergegeven", Zha = "Afspraak met {{attendeeName}}", Qha = "Extra invoer", Jha = "Planner vereist om extra gegevens in te voeren voordat de boeking wordt bevestigd", Xha = "Omschrijving", eva = "Plaatsaanduiding", tva = 'Gebruik "Toevoegen aan kalender"-e-mail als organisator', nva = "We tonen dit e-mailadres als organisator en sturen hier bevestigingsmails naartoe.", ova = 'Als ingeschakeld, tonen we het e-mailadres van je "Toevoegen aan kalender" als organisator en sturen we hier bevestigingsmails naartoe.', rva = "Let op dat je mogelijk je 'Toevoegen aan kalender'-account moet loskoppelen en opnieuw verbinden om deze functie te gebruiken.", iva = "Type", ava = "Wijzigen", sva = "Voeg een invoer toe", cva = "Notities verbergen in kalender", lva = "Om privacyredenen worden extra invoer en notities verborgen in het kalenderitem. Ze worden nog wel naar uw e-mail verzonden.", dva = "De boeking moet handmatig bevestigd worden voordat deze naar de integraties wordt gepusht en een bevestigings-e-mail wordt verzonden.", uva = "Onbevestigde boekingen blokkeren nog steeds de kalender slots.", _va = "Terugkerende gebeurtenis", pva = "Mensen kunnen zich abonneren op terugkerende gebeurtenissen", mva = "Verbind en doe mee", fva = "Het kan niet worden gebruikt met betaalde evenementtypes", gva = "Directe Vergaderingen worden nog niet ondersteund met terugkerende evenementen en betalingsapps", hva = "Experimenteel: Instant Meeting Events zijn momenteel experimenteel.", vva = "Vanaf", bva = "Gasten uitschakelen", yva = "Schakel toevoegen van extra gasten uit tijdens het boeken.", $va = "Privélink genereren", wva = "Privé-URL inschakelen", kva = "Privélink", Sva = "Uw privélink wordt na elk gebruik opnieuw gegenereerd", xva = "Privélink kopiëren", Eva = "Kopieer privélink naar evenement", Tva = "Genereer een privé-URL om te delen zonder uw {{appName}}-gebruikersnaam te onthullen", Ava = "Privélinks", Cva = "Genereer privé-URL's zonder de gebruikersnaam bloot te geven, met configureerbare verval- en gebruikslimieten", zva = "Nieuwe link toevoegen", Ova = "Privélink gekopieerd", Pva = "Genodigden kunnen plannen", Iva = "Date Range", Rva = "kalender dagen", Nva = "werkdagen", Dva = "Een adres of plaats instellen", Mva = "Stel een link in naar de vergadering", Lva = "Kan niet worden in- of uitgeschakeld. Kan alleen worden ontgrendeld voor subgebeurtenistypen", qva = "{{appName}} zal de genodigde om een telefoonnummer vragen.", jva = "{{appName}} zal een Google Meet meeting-URL meegeven in de afspraak bevestiging.", Fva = "{{appName}} zal een Zoom meeting-URL meegeven in de afspraak bevestiging.", Vva = "{{appName}} zal een Tandem meeting-URL meegeven in de afspraak bevestiging.", Bva = "{{appName}} zal een Daily meeting-URL meegeven in de afspraak bevestiging.", Uva = "{{appName}} zal een Jitsi Meet meeting-URL meegeven in de afspraak bevestiging.", Wva = "{{appName}} zal een Huddle01 meeting-URL meegeven in de afspraak bevestiging.", Gva = "{{appName}} geeft een vergaderings-URL voor MS Teams. OPMERKING: MOET EEN WERK- OF SCHOOLACCOUNT HEBBEN", Hva = "Betaling vereisen", Kva = "U moet een naam toevoegen", Yva = "commissie per transactie", Zva = "Uw evenement is met succes bijgewerkt.", Qva = "Verberg evenement", Jva = "Locatie wijzigen", Xva = "in de toekomst", eba = "Wanneer geboekt met minder dan <0></0> vooraf", tba = "Binnen een datumbereik", nba = "Voor onbepaalde tijd", oba = "Nieuw invoerveld toevoegen", rba = "Kort Gesprek", iba = "Een nieuw type vergadering toevoegen", aba = "Een nieuw type afspraak toevoegen", sba = "Maak een nieuw afspraak type voor bezoekers om tijden mee te reserveren.", cba = "Lengte", lba = "Minimale kennisgevingstermijn", dba = "Verschuiving begintijden", uba = "Verschuif de aan boekers weergegeven tijdslots met een opgegeven aantal minuten", _ba = "Verschuiven met", pba = "dit geeft bijvoorbeeld tijdslots aan uw boekers weer op {{ adjustedTime }} in plaats van {{ originalTime }}", mba = "Tijdslot intervallen", fba = "Gebruik evenement lengte (standaard)", gba = "Gebeurtenistype verwijderen?", hba = "Type beheerde gebeurtenis verwijderen?", vba = "Iedereen met wie u deze link hebt gedeeld, kan niet meer boeken via deze link.", bba = "Leden die aan dit evenementtype zijn toegewezen, zullen ook hun evenementtypes verwijderd zien worden.", yba = "Iedereen met wie ze hun link hebben gedeeld, zal deze niet meer kunnen gebruiken om te boeken.", $ba = "Ja, verwijderen", wba = "Account verwijderen", kba = "Ja, account verwijderen", Sba = "Iedereen met wie u uw accountlink gedeeld heeft, kan er niet meer mee boeken en alle voorkeuren die u opgeslagen heeft gaan verloren.", xba = "Integraties", Eba = "Apps", Tba = "Hier vindt u een lijst van uw apps", Aba = "App-beschrijving", Cba = "apps voor {{category}}", zba = "App Store", Oba = "Mensen, technologie en de werkplek verbinden.", Pba = "Verbind uw videovergaderapp", Iba = "Instellingen", Rba = "Gebeurtenistype is verplaatst", Nba = "Volgende stap", Dba = "Stap overslaan", Mba = "Vorige stap", Lba = "Installeren", qba = "Start gratis proefperiode", jba = "Geinstalleerd", Fba = "{{count}} actieve installatie", Vba = "{{count}} actieve installaties", Bba = "Wereldwijd geïnstalleerd", Uba = "De app is geïnstalleerd", Wba = "De app kon niet geïnstalleerd worden", Gba = "Ontkoppelen", Hba = "Voeg {{appName}} toe aan uw webpagina", Kba = "Koppel je favoriete apps.", Yba = "Automatisering", Zba = "Stel in hoe uw evenementen met uw agenda wilt verbinden.", Qba = "Schakel de agenda's in die u wilt controleren op conflicten om dubbele boekingen te voorkomen.", Jba = "Extra agenda kopppelen", Xba = "Agenda bijgewerkt", eya = "Controleer hier", tya = "Confereren", nya = "Agenda", oya = "Betalingen", rya = "Niet geïnstalleerd", iya = "Wachtwoorden komen niet overeen.", aya = "Dit veld is verplicht.", sya = "Status", cya = "Beschikbaarheid van gebruikers weergeven", lya = "Gebruiker moet de uitnodiging accepteren om beschikbaarheid weer te geven", dya = "Zet uzelf op afwezig", uya = "Status afwezig uitschakelen", _ya = "Fout bij het bijwerken van de status afwezig", pya = "Deze gebruiker is momenteel afwezig.", mya = "De persoon die u probeert te boeken heeft zichzelf op afwezig gezet en accepteert dus geen nieuwe boekingen.", fya = "Ontmoet mensen met dezelfde tokens", gya = "Boek alleen en laat boekingen toe van mensen die dezelfde tokens,, DAO's of NFT's delen.", hya = "Uw account is aangemaakt met behulp van een identiteitsprovider.", vya = "Uw account wordt beheerd door {{provider}}", bya = "Ga naar uw accountinstellingen bij {{provider}} om uw e-mailadres en wachtwoord te wijzigen, tweestapsverificatie in te schakelen en meer.", yya = "Je account wordt beheerd door een andere identiteitsprovider. Probeer in te loggen met {{provider}}.", $ya = "Fout bij het aanmaken van een nieuwe gebruiker. Probeer het opnieuw.", wya = "Aanmelden met Google", kya = "Aanmelden met SAML", Sya = "Aanmelden met SAML/OIDC", xya = "Doorgaan met e-mail", Eya = "Doorgaan met Google", Tya = "Laatst gebruikt", Aya = "U moet een toegangstoken genereren van uw oude planningstool.", Cya = "Importeren van", zya = "Toegangstoken", Oya = "Routekaart", Pya = "Uitgelichte categorieën", Iya = "Functievlaggen", Rya = "Hier kunt u de functies van uw Cal.com-instantie in- en uitschakelen.", Nya = "Populaire categorieën", Dya = "{{count}} app", Mya = "{{count}} apps", Lya = "Trending apps", qya = "Meest populair", jya = "Geinstalleerde apps", Fya = "Gratis", Vya = "Geen apps voor {{category}}", Bya = "Alle apps", Uya = "Voeg een agenda-app toe om te controleren op conflicten om dubbele boekingen te voorkomen", Wya = "Probeer een conferentieapp toe te voegen voor videogesprekken met uw klanten", Gya = "Voeg een betaalapp toe om transacties tussen u en uw klanten te vergemakkelijken", Hya = "Voeg een analyse-app toe aan uw boekingspagina's", Kya = "Voeg een automatiseringsapp toe om te gebruiken", Yya = "Voeg een ander type app toe om allerlei soorten dingen te doen", Zya = "Voeg een berichtenapp toe om aangepaste meldingen en herinneringen in te stellen", Qya = "Voeg een CRM-app toe om bij te houden met wie u heeft ontmoet", Jya = "Stel de agenda('s) in om te controleren op conflicten om dubbele boekingen te voorkomen.", Xya = "Configureer welke betalingsverwerkingsdiensten u wilt gebruiken bij het factureren aan uw klanten.", e$a = "Configureer welke analyse-apps moeten worden gebruikt voor uw boekingspagina's", t$a = "Alle geïnstalleerde apps uit andere categorieën.", n$a = "Configureer welke conferentieapps moeten worden gebruikt", o$a = "Configureer welke automatiseringsapps moeten worden gebruikt", r$a = "Configureer welke berichtenapps moeten worden gebruikt voor het instellen van aangepaste meldingen en herinneringen", i$a = "Configureer welke CRM-apps moeten worden gebruikt voor het bijhouden van wie u hebt ontmoet", a$a = "Analyse", s$a = "Geen apps geïnstalleerd", c$a = "Met apps kunt u uw workflow en uw planning aanzienlijk verbeteren.", l$a = "Bladeren in App Store", d$a = "Beheer uw geïnstalleerde apps of wijzig instellingen", u$a = "Door apps bladeren", _$a = "Functies", p$a = "Machtigingen", m$a = "Voorwaarden en privacy", f$a = "Gepubliceerd door {{author}}", g$a = "Abonneren", h$a = "Kopen", v$a = "App installeren", b$a = "Categorieën", y$a = "Prijzen", $$a = "Meer informatie", w$a = "Nu proberen", k$a = "Privacybeleid", S$a = "Gebruiksvoorwaarden", x$a = "Verwijderen", E$a = "Toevoegen", T$a = "{{count}} keer geïnstalleerd", A$a = "Wallet verifiëren", C$a = "Maak gebeurtenissen aan in de", z$a = "Dit is een commerciële functie", O$a = "Je kunt deze functie lokaal testen, maar niet in productie.", P$a = "Neem contact op met ons verkoopteam om een commerciële licentie aan te schaffen. Als er al een licentiesleutel aanwezig is, neem dan contact op met support@cal.com voor hulp.", I$a = "Ontbrekende licentie", R$a = "Volgende stappen", N$a = "Verkrijg een commerciële licentie", D$a = "Het infrastructuurabonnement is gebaseerd op gebruik en heeft speciale kortingen voor start-ups.", M$a = "Maak een account aan via Prisma Studio", L$a = "Leer hoe u uw eerste gebruiker instelt", q$a = "Contact met Sales", j$a = "Fout 404", F$a = "Als standaard instellen", V$a = "Nieuwe planning", B$a = "Voeg een nieuwe planning toe", U$a = "Voeg een nieuwe agenda toe", W$a = "Stel in waar nieuwe gebeurtenissen worden toegevoegd wanneer u boekt.", G$a = "Planning verwijderen", H$a = "Het verwijderen van een planning verwijdert deze uit alle gebeurtenistypen. Deze actie kan niet ongedaan worden gemaakt.", K$a = "Planning {{scheduleName}} aangemaakt", Y$a = "Beschikbaarheid bijgewerkt", Z$a = "Planning verwijderd", Q$a = "Werktijden", J$a = "Beschikbaarheidsschema aanmaken", X$a = "Door beschikbaarheidsschema's te maken kunt u de beschikbaarheid beheren voor verschillende gebeurteenistypes. Ze kunnen worden toegepast op één of meer gebeurtenistypes.", ewa = "Vereist eigendom van een token dat aan het volgende adres toebehoort:", twa = "Jan Pietersen", nwa = "Tijdnotatie", owa = "Omleiding bij boeking ", rwa = 'U wordt omgeleid naar {{ url }} over $t(seconde, {"count": {{seconden}} }).', iwa = "https://example.com/redirect-to-my-success-page", awa = "Leid door naar een aangepaste URL na een geslaagde boeking", swa = "Dupliceren", cwa = "Plaatsen aanbieden", lwa = "Bied beschikbare plaatsen aan voor boekingen. Hiermee worden gastboekingen en aanmeldingsboekingen automatisch uitgeschakeld.", dwa = "Plaats beschikbaar", uwa = "Plaatsen beschikbaar", _wa = "Plaatsen bijna vol", pwa = "Plaatsen raken snel vol", mwa = "Aantal plaatsen per boeking", fwa = "Stel vergaderingsvenster in (seconden): De tijdsperiode in seconden waarin de host de vergadering kan joinen en starten. Na deze periode verloopt de join-URL van de vergadering.", gwa = "Voer het aantal plaatsen in", hwa = "U kunt uw schema's beheren op de beschikbaarheidspagina.", vwa = "Geen plaatsen meer beschikbaar", bwa = "API-sleutels", ywa = "API-sleutel", $wa = "API-sleutel testen", wwa = "Test gelukt!", kwa = "Test mislukt", Swa = "API-sleutel verstrekken", xwa = "Met API-sleutels kunt API-aanroepen naar uw eigen account doen.", Ewa = "Maak in plaats daarvan een marktplaats of platform.", Twa = "Genereer API-sleutels voor toegang tot uw eigen account.", Awa = "Maak een API-sleutel aan", Cwa = "Geef deze sleutel een naam", zwa = "Bijvoorbeeld Ontwikkeling", Owa = "Naamloze API-sleutel", Pwa = "Deze API-sleutel heeft geen verloopdatum", Iwa = "API-sleutel bewerken", Rwa = "API-sleutel aangemaakt", Nwa = "API-sleutel bijgewerkt", Dwa = "Aanmaken", Mwa = "Sla deze API-sleutel ergens veilig op.", Lwa = "U kunt hem niet opnieuw bekijken zodra u dit venster sluit.", qwa = "Naar klembord kopiëren", jwa = "Ingeschakeld na update", Fwa = "De privélink werkt na opslaan", Vwa = "Deze API-sleutel intrekken", Bwa = "Herschikken uitschakelen", Uwa = "Gasten kunnen het evenement niet meer herschikken via de kalenderuitnodiging of e-mail", Wwa = "Boeken via herplanningslink toestaan", Gwa = "Indien ingeschakeld, kunnen gebruikers een nieuwe boeking maken wanneer ze proberen een geannuleerde boeking te verzetten", Hwa = "Annuleren uitschakelen", Kwa = "Gasten kunnen het evenement niet meer annuleren via de kalenderuitnodiging of e-mail", Ywa = "API-sleutel intrekken", Zwa = "API-sleutel gekopieerd!", Qwa = "De API-sleutel verloopt op", Jwa = "Deze API-sleutel permanent van uw account verwijderen?", Xwa = "Kopiëren", e0a = "Verloopdatum", t0a = "Verlopen", n0a = "Verloopt nooit", o0a = "Verloopt", r0a = "Aanvraag om uw boeking te verplaatsen", i0a = "Reden voor verplaatsen", a0a = "Boek een nieuwe tijd", s0a = "Verplaatsingsaanvraag verzonden", c0a = "Hierdoor wordt de geplande vergadering geannuleerd, wordt de planner geïnformeerd en wordt hem/haar gevraagd een nieuwe tijd te kiezen.", l0a = "Reden voor verplaatsingsaanvraag", d0a = "Verplaatsing aanvragen ", u0a = "Boeking bewerken", _0a = "Boeking verplaatsen", p0a = "Vorige tijd", m0a = "Voeg een GIF toe aan uw bevestigingspagina", f0a = "Zoeken", g0a = "Imiteren", h0a = "Imitatie van gebruiker", v0a = "Hiermee kan ons ondersteuningsteam tijdelijk als u inloggen zodat we eventuele problemen die u aan ons meldt snel op kunnen lossen.", b0a = "Hiermee kunnen uw teamleden zich tijdelijk aanmelden als u.", y0a = "Gratis voor individuen. Teamplannen voor samenwerkingsfuncties.", $0a = "Maak organisatie privé", w0a = "Je organisatieleden kunnen andere organisatieleden niet zien wanneer dit is ingeschakeld.", k0a = "Team privé maken", S0a = "Uw teamleden kunnen geen andere teamleden zien wanneer dit ingeschakeld is.", x0a = "U kunt niet alle teamleden van een privéteam zien.", E0a = "Je kunt de teams van een privéorganisatie niet zien.", T0a = "Meerdere tijdsduren toestaan", A0a = "Alle gebruik van deze functie wordt gecontroleerd.", C0a = 'Gebruikersnaam "{{user}}" wordt geïmiteerd.', z0a = "Klik hier om te stoppen", O0a = "Bijgewerkt - de locatie van uw gebeurtenis is gewijzigd", P0a = "Toegevoegd - Nieuwe gasten toegevoegd aan je evenement", I0a = "Locatie gewijzigd: {{eventType}} met {{name}} op {{date}}", R0a = "Gasten Toegevoegd: {{eventType}} met {{name}} op {{date}}", N0a = "Huidige locatie", D0a = "Nieuwe locatie", M0a = "Sessie", L0a = "Beheer uw accountsessie", q0a = "Sessietime-out na", j0a = "Sessietime-out", F0a = "Maak uw sessie ongeldig na een bepaalde tijd.", V0a = "Geen locatie bepaald", B0a = "Locatie instellen", U0a = "Locatie bijwerken", W0a = "Locatie bijgewerkt", G0a = "Locatie-update mislukt", H0a = "Gasten toegevoegd", K0a = "Kan geen gasten toevoegen", Y0a = "Dat lijkt niet op een e-mailadres", Z0a = "E-mails moeten uniek en geldig zijn", Q0a = "Dat lijkt niet op een URL", J0a = "Plaats deze code in uw HTML op de plaats waar u uw {{appName}}-widget wilt hebben.", X0a = "Maak een bestaande React-component of werk deze bij, zoals hieronder weergegeven.", eka = "Code kopiëren", tka = "Code gekopieerd!", nka = "Hoe wilt u {{appName}} aan uw website toevoegen?", oka = "Kies een van de volgende manieren om {{appName}} op uw website te plaatsen.", rka = "Uw Zapier-integratie configureren", ika = "Uw Make-integratie configureren", aka = "API-sleutel genereren", ska = "Genereer een API-sleutel die gebruikt moet worden met {{appName}} op", cka = "Uw unieke API-sleutel", lka = "Kopieer deze API-sleutel en sla deze ergens veilig op. Als u deze sleutel verliest, moet u een nieuwe genereren.", dka = "<0>Meld u aan op uw Zapier-account en maak een nieuwe Zap.</0><1>Selecteer {{appName}} als uw activatie-app. Kies ook een activatiegebeurtenis.</1><2>Kies uw account en voer vervolgens uw unieke API-sleutel in.</2><3>Test uw activatie.</3><4>U bent er klaar voor!</4>", uka = "Ga naar <0>Make Uitnodigingslink</0> en installeer de Cal.com app.", _ka = "Log in op je Make account en maak een nieuw scenario.", pka = "Selecteer Cal.com als je trigger-app. Kies ook een trigger-gebeurtenis.", mka = "Kies je account en voer vervolgens je unieke API-sleutel in.", fka = "Test je trigger.", gka = "Je bent klaar!", hka = "Installeer eerst de Zapier-app in de App Store.", vka = "Installeer eerst de Make-app uit de appstore.", bka = "App-installatie", yka = "App niet geïnstalleerd", $ka = "Sorry, deze app is niet geïnstalleerd op je account. Bezoek onze app store om deze en andere geweldige apps te ontdekken.", wka = "Verbinding maken met Apple Server", kka = "Agenda-URL", Ska = "Genereer een appspecifiek wachtwoord voor gebruik met {{appName}} op", xka = "Kan deze Apple Calendar-account niet toevoegen. Zorg ervoor dat je een app-specifiek wachtwoord gebruikt in plaats van je accountwachtwoord.", Eka = "Uw inloggegevens worden opgeslagen en versleuteld.", Tka = "Deze wordt opgeslagen en versleuteld.", Aka = "Naar App Store", Cka = "Probeer uw agenda opnieuw te verbinden met alle benodigde machtigingen", zka = "Stel een telefoonnummer in voor de afspraak", Oka = "Er zijn geen drukke tijdvakken", Pka = "Weergeven op boekingspagina", Ika = "De locatie is zichtbaar voordat de boeking bevestigd wordt", Rka = "GIF toevoegen", Nka = "Giphy zoeken", Dka = "Link van Giphy toevoegen", Mka = "GIF toevoegen aan bevestigingspagina", Lka = "Zoek een GIF om uw bevestigingspagina op te leuken", qka = "Feedback delen", jka = "Hulpmiddelen", Fka = "Ondersteuningsdocumentatie", Vka = "Ontwikkelaarsdocumentatie", Bka = "Neem contact op", Uka = "Neem contact op met de ondersteuning", Wka = "Premium Ondersteuning", Gka = "Ondersteuning door de community", Hka = "Feedback", Kka = "Bedankt voor uw feedback!", Yka = "Fout bij verzenden van feedback", Zka = "Geef hier uw opmerkingen:", Qka = "Boekingsgegevens", Jka = "of", Xka = "Laat maar", e1a = "Ga naar: ", t1a = "Zapier-uitnodigingslink", n1a = "Er wordt een afspraak-URL gemaakt zodra de gebeurtenis bevestigd is.", o1a = "Geef dynamisch de naam van uw deelnemer weer aan u of uw naam als het door uw deelnemer bekeken wordt", r1a = "Locatie gebeurtenis", i1a = "Reden voor verplaatsen (optioneel)", a1a = "Informeer anderen waarom u het moet verplaatsen", s1a = "Deze gebeurtenis is geannuleerd", c1a = "We hebben u en de andere deelnemers een e-mail gestuurd om hen te informeren.", l1a = "Deze invoer wordt getoond tijdens het boeken van dit evenement", d1a = "De vergader-URL wordt vermeld in de bevestigings-e-mail", u1a = "URL moet beginnen met http:// of https://", _1a = "Telefoonnummer wordt verstrekt", p1a = "voordat de gebeurtenis begint", m1a = "wanneer de gebeurtenis is geannuleerd", f1a = "Nadat hosts niet bij de cal video zijn gekomen", g1a = "Nadat gasten niet bij de cal video zijn gekomen", h1a = "Deelnemen aan de videogesprek", v1a = "Inloggen bij Cal.com", b1a = "Inloggen bij Cal.com", y1a = "Houd je afspraken bij, ontvang meldingen en beheer je agenda effectiever.", $1a = "Volg je afspraken en beheer je agenda effectiever", w1a = "Kon niet deelnemen aan het gesprek. Probeer het opnieuw.", k1a = "Kies hoe je aan dit gesprek wilt deelnemen", S1a = "Kies hoe je wilt verschijnen in het gesprek", x1a = "wanneer een nieuwe gebeurtenis is geboekt", E1a = "e-mail naar organisator versturen", T1a = "e-mail naar deelnemers versturen", A1a = "Sms verzenden naar deelnemer", C1a = "sms naar een specifiek nummer sturen", z1a = "Stuur eenvoudig vergaderherinneringen via sms naar uw deelnemers", O1a = "WhatsApp-bericht naar een specifiek nummer versturen", P1a = "WhatsApp-bericht naar deelnemer versturen", I1a = "Werkstromen", R1a = "Nieuwe werkstroom", N1a = "Hoe wil je beginnen?", D1a = "Een nieuwe werkstroom toevoegen", M1a = "wanneer de gebeurtenis verplaatst wordt", L1a = "Activatie", q1a = "Activaties", j1a = "Actie", F1a = "Maak werkstromen om meldingen en herinneringen te automatiseren", V1a = "Naam werkstroom", B1a = "Aangepaste werkstroom", U1a = "{{workflowName}} aangemaakt", W1a = "Weet u zeker dat u deze werkstroom wilt verwijderen?", G1a = "Werkstroom verwijderen", H1a = "Ja, verwijder werkstroom", K1a = "Werkstroom verwijderd", Y1a = "Hoelang voordat de gebeurtenis begint?", Z1a = "dagen", Q1a = "uur", J1a = "min.", X1a = "m", e2a = "u", t2a = "Maak uw eerste werkstroom aan", n2a = "Met werkstromen kunt u het verzenden van herinneringen en meldingen automatiseren.", o2a = "Actief op", r2a = "Werkstroom {{workflowName}} bijgewerkt", i2a = "Dit is een standaard gebruikersnaam. Als u deze bijwerkt, gaat u naar facturering om te downgraden.", a2a = "Dit is een premium gebruikersnaam, koop de uwe voor {{price}}", s2a = "Huidig", c2a = "premium", l2a = "standaard", d2a = "Bevestig wijziging gebruikersnaam", u2a = "Omdat je van een standaard naar een premium gebruikersnaam verandert, word je naar de kassa geleid om te upgraden.", _2a = "Omdat je van een premium naar een standaard gebruikersnaam verandert, word je naar de kassa geleid om te downgraden.", p2a = "Naar facturatie", m2a = "Vereis betaling voor boekingen (0,5% en € 0,10 provisie per transactie)", f2a = "Uw proefperiode is verlopen", g2a = "App verwijderen", h2a = "Ja, verwijder app", v2a = "Weet u zeker dat u deze app wilt verwijderen?", b2a = "De app is verwijderd", y2a = "Fout bij het verwijderen van de app", $2a = "Webconferentie", w2a = "Webgesprek", k2a = "Start webgesprek", S2a = "Gesprek beëindigen", x2a = "Test je agent met een webgesprek zonder dat een telefoonnummer nodig is", E2a = "Telefoongesprek", T2a = "Verbinding maken met agent...", A2a = "Gesprek actief", C2a = "Gesprek beëindigd", z2a = "Gespreksfout", O2a = "Klaar om gesprek te starten", P2a = "Webgesprek starten mislukt. Probeer het opnieuw.", I2a = "Er is een fout opgetreden tijdens het gesprek. Probeer het opnieuw.", R2a = "Initialiseren van webgesprek mislukt. Zorg ervoor dat microfoonrechten zijn toegestaan.", N2a = "Start een gesprek om de conversatie te zien", D2a = "Wachten op conversatie...", M2a = "AI-agent", L2a = "Live", q2a = "Verbinding maken...", j2a = "Vereist bevestiging", F2a = "Vereist bevestiging indien geboekt met < {{time}} $t({{unit}}_timeUnit) kennisgeving", V2a = "Kan bevestiging vereisen", B2a = "{{count}} gebeurtenistype", U2a = "{{count}} gebeurtenistypen", W2a = "{{count}} team", G2a = "{{count}} teams", H2a = "Actie toevoegen", K2a = "Whereby-link instellen", Y2a = "Voer een geldige Whereby-link in", Z2a = "Around.Co-link instellen", Q2a = "Voer een geldige Around.Co-link in", J2a = "Riverside-link instellen", X2a = "Voer een geldige Riverside-link in", eSa = "Voer een geldige Ping.gg-link in", tSa = "Verbinding maken met Exchange 2013 Server", nSa = "Verbinding maken met Exchange 2016 Server", oSa = "Aangepast sjabloon", rSa = "E-mailtekst", iSa = "Tekstbericht", aSa = "Heeft u een specifiek probleem?", sSa = "door onze documenten bladen", cSa = "Kies een sjabloon", lSa = "Aangepast", dSa = "Herinnering", uSa = "Opnieuw gepland", _Sa = "Opnieuw gepland door", pSa = "Oorspronkelijke boeking", mSa = "Voltooid", fSa = "Beoordeling", gSa = "Herinnering: {{eventType}} met {{name}} op {{date}}", hSa = "Wordt niet geactiveerd voor bestaande boekingen, omdat de gebruiker om zijn/haar telefoonnummer gevraagd wordt bij het boeken van de gebeurtenis.", vSa = "{{count}} minuut", bSa = "{{count}}m", ySa = "{{count}} minuten", $Sa = "{{count}} uur", wSa = "{{count}}u", kSa = "{{count}} uur", SSa = "Ongeldige invoer", xSa = "We konden de {{location}} vergaderlink niet toevoegen aan je geplande evenement. Neem contact op met je genodigden of werk je agenda-evenement bij om de details toe te voegen. Je kunt ofwel <0>je locatie wijzigen op het evenementtype</0> of proberen <1>de app te verwijderen en opnieuw toe te voegen.</1>", ESa = "We konden uw <1>{{calendar}}</1> niet bijwerken. <2>Controleer uw agenda-instellingen of verwijder uw agenda en voeg uw agenda opnieuw toe </2>", TSa = "Naam deelnemer", ASa = "De volledige naam van de persoon die boekt", CSa = "Beschadigde integratie", zSa = "Er was een probleem met het toevoegen van een videolink", OSa = "Er was een probleem met het bijwerken van uw agenda", PSa = "Actief op {{count}} gebeurtenistype", ISa = "Actief op {{count}} gebeurtenistypen", RSa = "Actief in {{count}} team", NSa = "Actief in {{count}} teams", DSa = "Actief voor alle evenementtypen", MSa = "Actief in alle teams", LSa = "Geen actieve gebeurtenistypen", qSa = "Geen actieve teams", jSa = "Nieuwe deelnemer {{name}} op {{eventType}} om {{date}}", FSa = "Iemand heeft zichzelf toegevoegd aan een evenement", VSa = "Variabel", BSa = "Naam gebeurtenis", USa = "Deelnemer", WSa = "Datum gebeurtenis", GSa = "Tijd gebeurtenis", HSa = "Naam organisator", KSa = "Om deze functie te gebruiken, moet u upgraden naar een Pro-account.", YSa = "Ongeldig telefoonnummer", ZSa = "Ongeldige URL voor {{label}}. Voorbeeld-URL: {{sampleUrl}}", QSa = "Navigeren", JSa = "Openen", XSa = "Sluiten", exa = "Upgraden", txa = "Koop US-nummer voor {{priceInDollars}}$/maand", nxa = "Upgrade om toegang te krijgen tot opnames", oxa = "Opnames zijn alleen beschikbaar als onderdeel van ons teamsabonnement. Upgrade om te beginnen met het opnemen van uw gesprekken", rxa = "Upgrade naar Enterprise om een AI-agent telefoonnummer te genereren dat gasten kan bellen om afspraken in te plannen", ixa = "Opnames zijn onderdeel van het teamsabonnement", axa = "Dit is een Team-functie. Upgrade naar Team om de beschikbaarheid van uw team te zien.", sxa = "Dit is een Team-functie. Upgrade naar Team om uw meldingen en herinneringen van gebeurtenissen te automatiseren met werkstromen.", cxa = "Op profiel tonen", lxa = "Insluiten", dxa = "Nieuwe gebruikersnaam", uxa = "Huidige gebruikersnaam", _xa = "Voorbeeld 1", pxa = "Voorbeeld 2", mxa = "Boekingsvraag-ID", fxa = "Bedrijfsgrootte", gxa = "Waar heeft u hulp bij nodig?", hxa = "Variabele indeling", vxa = "De abonnee-URL voor Webhook is al gedefinieerd", bxa = "Negeer alle speciale tekens van het label voor aanvullende invoer (gebruik alleen letters en cijfers) en gebruik hoofdletters voor alle letters en vervang spaties door onderstrepingstekens.", yxa = "Hoe gebruik ik boekingsvragen als variabelen?", $xa = "Desktop-app downloaden", wxa = "Ping-link instellen", kxa = "Tariefgrenswaarde overschreden", Sxa = "Als er iets gebeurt", xxa = "Er wordt een actie uitgevoerd", Exa = "Actie testen", Txa = "Melding verzonden", Axa = "Geen invoer", Cxa = "Werkstroomactie testen", zxa = "Sms versturen", Oxa = "Weet u zeker dat u een sms naar {{number}} wilt versturen?", Pxa = "Geen standaard agenda verbonden", Ixa = "U kunt uw agenda koppelen vanaf <1>hier</1>.", Rxa = "Standaardagenda", Nxa = "In profiel verbergen", Dxa = "Configuratie gebeurtenis", Mxa = "Geen beschikbaarheid gevonden in het schema", Lxa = "Grenswaarden", qxa = "Hoe vaak u geboekt kunt worden", jxa = "Agenda-instellingen en meer...", Fxa = "Geavanceerd", Vxa = "Betalingen instellen voor evenement", Bxa = "Gebeurtenisconfiguratie: voor meerdere duren is minimaal 1 optie vereist.", Uxa = "Gebeurtenisconfiguratie: selecteer een geldige standaardduur.", Wxa = "Reserveringslimieten moeten in oplopende volgorde zijn. [dag, week, maand, jaar]", Gxa = "Duurlimieten moeten in oplopende volgorde zijn. [dag, week, maand, jaar]", Hxa = "Selecteer aan welke agenda u boekingen wilt toevoegen", Kxa = "Aangepaste gebeurtenisnaam", Yxa = "Maak aangepaste gebeurtenisnamen om weer te geven op agendagebeurtenissen", Zxa = "Onjuiste tweestapsverificatiecode", Qxa = "Op welk type gebeurtenis is dit van toepassing?", Jxa = "Toepassen op alle, inclusief toekomstige evenementtypen", Xxa = "Toepassen op alle team- en gebruikersgebeurtenistypen", eEa = "Op welk team zal dit van toepassing zijn?", tEa = "Werkstromen maken eenvoudige automatisering van het versturen van meldingen en herinneringen mogelijk, zodat u processen rond uw gebeurtenissen kunt opbouwen.", nEa = "Dit is een interne instelling en heeft geen invloed op hoe de tijden worden weergegeven op de openbare boekingspagina's voor u of voor iemand die u boekt.", oEa = "Maak een werkstroom", rEa = "Doe dit", iEa = "Uitschakelen", aEa = "Inschakelen", sEa = "Geannuleerde boekingen kunnen niet opnieuw worden ingepland", cEa = "Instellingen bijgewerkt", lEa = "Fout bij het bijwerken van de instellingen", dEa = "Mijn persoonlijke {{appName}}-URL", uEa = "Een korte introductie over uzelf. Dit wordt weergegeven op uw persoonlijke pagina.", _Ea = "Installatie voltooien en beginnen", pEa = "Deze gebruiker heeft nog geen bio toegevoegd.", mEa = "Bio", fEa = "Account verwijderen", gEa = "Weet u zeker dat u uw {{appName}}-account wilt verwijderen?", hEa = "Verwijder mijn account", vEa = "Begin van de week", bEa = "Opnames", yEa = "Opname", $Ea = "Veel plezier met plannen", wEa = "Selecteer de agenda's die u wilt controleren op conflicten om dubbele boekingen te voorkomen.", kEa = "Controleer op conflicten", SEa = "Opnames weergeven", xEa = "Controleer op opnames", EEa = "Toevoegen van gebeurtenissen aan", TEa = "Volg systeemvoorkeuren", AEa = "Aangepaste merkkleuren", CEa = "Pas uw eigen merkkleur aan op uw boekingspagina.", zEa = "Pro", OEa = 'Verwijdert alle {{appName}}-gerelateerde merken, zoals "Mogelijk gemaakt door {{appName}}".', PEa = "Directe vergadering met {{name}}", IEa = "Profielafbeelding", REa = "Uploaden", NEa = "Profielfoto toevoegen", DEa = "Tokenadres", MEa = "Blockchain", LEa = "Oude wachtwoord", qEa = "Uw nieuwe superveilige wachtwoord", jEa = "Fout bij het bijwerken van het wachtwoord", FEa = "Tweestapsverificatie", VEa = "Stel een herhalingsschema in", BEa = "vandaag", UEa = "Weergave", WEa = "Mijn account", GEa = "Algemeen", HEa = "Agenda's", KEa = "Facturen", YEa = "Ingesloten opties", ZEa = "Imitatie", QEa = "Instellingen voor imitatie van gebruiker beheren", JEa = "Recente identiteitsovernames", XEa = "Snel identiteit overnemen", eTa = "Geen recente identiteitsovernames", tTa = "Gebruikers", nTa = "Gebruiker", oTa = "Beheer de instellingen van uw {{appName}}-profiel", rTa = "Hier vindt u een lijst met alle gebruikers", iTa = "Gebruikersbeschrijving", aTa = "Beheer de instellingen voor uw taal en tijdzone", sTa = "Configureer hoe uw typen gebeurtenissen samenwerken met uw agenda's", cTa = "Beheer de instellingen voor uw boekingsweergave", lTa = "Beheer uw favoriete apps voor videoconferenties voor uw vergaderingen", dTa = "Conferentieapp toevoegen", uTa = "Beheer de instellingen voor uw accountwachtwoorden", _Ta = "Stel uw tweestapsverificatie in", pTa = "We hebben alleen wat basisinformatie nodig om uw profiel te kunnen configureren.", mTa = "Overslaan", fTa = "Doe dit later", gTa = "Bepaal de tijdvakken waarin u beschikbaar bent", hTa = "U kunt dit allemaal later aanpassen op de beschikbaarheidspagina.", vTa = "Verbind eerst een agenda", bTa = "Voltooi uw profiel", yTa = "U kunt meer agenda's toevoegen vanuit de App Store", $Ta = "Conferentieapps koppelen", wTa = "Agenda-apps koppelen", kTa = "Betaalapps koppelen", STa = "Koppel automatiseringsapps", xTa = "Koppel analyse-apps", ETa = "Andere apps koppelen", TTa = "Berichtenapps koppelen", ATa = "CRM-apps koppelen", CTa = "Stap {{currentStep}} van {{maxSteps}}", zTa = "Variabele toevoegen", OTa = "Aangepast telefoonnummer", PTa = "Berichtsjabloon", ITa = "E-mailonderwerp", RTa = "Voeg dynamische tekstvariabelen toe", NTa = "Naam van het type gebeurtenis", DTa = "De datum van de gebeurtenis", MTa = "De duur van het evenement", LTa = "De begintijd van de gebeurtenis", qTa = "EvenementType niet gevonden", jTa = "Te bellen nummer", FTa = "Het telefoonnummer van de gebruiker die je belt", VTa = "Locatie", BTa = "De locatie van de gebeurtenis", UTa = "Aanvullende notities", WTa = "De aanvullende opmerkingen bij de boeking", GTa = "De naam van de persoon die boekt", HTa = "Naam van de organisator", KTa = "Aan", YTa = "De werkstroom {{workflowName}} is {{offOn}}", ZTa = "Reacties downloaden", QTa = "Download alle reacties op uw formulier in CSV-indeling.", JTa = "Reacties bekijken", XTa = "Downloaden", eAa = "Bezig met downloaden", tAa = "Opname downloaden", nAa = "Transcripties zijn nu ingeschakeld", oAa = "Transcripties zijn nu gestopt", rAa = "Transcriptie downloaden", iAa = "Transcript", aAa = "Een opname van uw recente gesprek op {{appName}} is klaar om te downloaden", sAa = "Transcriptie van uw recente gesprek op {{appName}} is klaar om te downloaden. Links zijn slechts 1 uur geldig", cAa = "Je kunt het transcript ook downloaden via de bijlagen", lAa = "Opmerking: De downloadlink is slechts 12 uur geldig. U kunt een nieuwe downloadlink genereren door de instructies <1>hier</1> te volgen.", dAa = "Opmerking: De downloadlink is slechts 12 uur geldig. Je kunt een nieuwe downloadlink genereren door de instructies te volgen.", uAa = "Maak uw eerste formulier", _Aa = "Met routeringsformulieren kunt u kwalificerende vragen stellen en doorverwijzen naar de juiste persoon of het juiste type gebeurtenis.", pAa = "Maak uw eerste webhook", mAa = "Met Webhooks kunt u in realtime vergadergegevens ontvangen wanneer er iets gebeurt in {{appName}}.", fAa = "Voor maximaal", gAa = "gebeurtenis", hAa = "gebeurtenissen", vAa = "Beheer de instellingen van uw teamprofiel", bAa = "Beheer de instellingen van uw organisatieprofiel", yAa = "Gebruikers in de groep", $Aa = "Beheer de beheerders en leden in uw organisatie", wAa = "Team-URL", kAa = "Teamleden", SAa = "Meer", xAa = "Cal.ai Workflows", EAa = "en nog {{count}}", TAa = "We zien de mobiele app als een verlengstuk van de webapp. Voor ingewikkelde acties raden we u aan de webapp te gebruiken.", AAa = "24 uur voor het begin van de gebeurtenis een sms-herinnering naar deelnemer versturen", CAa = "Aangepaste sms versturen naar deelnemer wanneer gebeurtenis wordt verplaatst", zAa = "Aangepaste e-mail versturen naar organisator wanneer een nieuwe gebeurtenis wordt geboekt", OAa = "1 uur voor het begin van gebeurtenissen een e-mailherinnering naar deelnemer versturen", PAa = "Aangepaste e-mail versturen naar organisator wanneer gebeurtenis wordt verplaatst", IAa = "Aangepaste sms versturen naar organisator wanneer een nieuwe gebeurtenis wordt geboekt", RAa = "SMS-herinnering versturen", NAa = "24 uur voor aanvang van de afspraak", DAa = "Opvolgen bij no-shows", MAa = "30 minuten na afloop van de afspraak", LAa = "Herinner deelnemers om ID mee te nemen", qAa = "1 dag voor aanvang van de afspraak", jAa = "E-mailherinnering", FAa = "1 uur voor aanvang van de afspraak", VAa = "Aangepaste SMS-herinnering", BAa = "Wanneer afspraak is gepland", UAa = "Aangepaste e-mailherinnering", WAa = "Afspraak is verzet naar host", GAa = "Inclusief boekingsaantallen van beheerde evenementtypen", HAa = "Welkom bij {{appName}}!", KAa = "Je kunt dit later bewerken.", YAa = "Ik koppel mijn agenda later", ZAa = "Er is een probleem opgetreden bij het opslaan van uw gegevens. Probeer het opnieuw of neem contact op met de klantenservice.", QAa = "Ontbrekende plaatsen kopen", JAa = "Lengte van tijdvak", XAa = "Boekingsweergave", eCa = "Beheer de instellingen voor de boekingsweergave van uw team", tCa = "Beheer instellingen voor de boekingsweergave van uw organisatie", nCa = "Alleen de eigenaar van dit team kan wijzigingen aanbrengen in de boeking van het team ", oCa = 'Verwijdert alle {{appName}}-gerelateerde merken, zoals "Mogelijk gemaakt door {{appName}}"', rCa = "{{teamName}} heeft u uitgenodigd om deel te nemen aan hun team als {{role}}", iCa = "Token is ongeldig of verlopen.", aCa = "Boeking bekijken", sCa = "Koppel met Microsoft Exchange", cCa = "Verificatiemethode", lCa = "Basisverificatie", dCa = "NTLM-verificatie", uCa = "GZip-compressie", _Ca = "Exchange-versie", pCa = "2007 SP1", mCa = "2010", fCa = "2010 SP1", gCa = "2010 SP2", hCa = "2013", vCa = "2013 SP1", bCa = "2015", yCa = "2016", $Ca = "Routering", wCa = "Maak formulieren om deelnemers naar de juiste bestemmingen te verwijzen", kCa = "E-mail naar eigenaar versturen", SCa = "Verstuurt een e-mail naar de eigenaar wanneer het formulier is verzonden", xCa = "E-mail verzenden naar", ECa = "Nieuw formulier toevoegen", TCa = "Voeg een nieuw formulier toe aan uw team", ACa = "Maak uw eerste route", CCa = "Route naar de juiste persoon op basis van de antwoorden op uw formulier", zCa = "Formulier", OCa = "Maak uw formulier om naar een boeker door te verwijzen", PCa = "Link kopiëren naar formulier", ICa = "Thema van de boekingspagina", RCa = "Dit is alleen van toepassing op uw openbare boekingspagina's", NCa = "Dashboard-thema", DCa = "Dit is alleen van toepassing op uw aangemelde dashboard", MCa = "Systeemstandaard", LCa = "Voeg een team toe", qCa = "Ontvang in realtime vergadergegevens wanneer er iets gebeurt in {{appName}}", jCa = "Wordt geactiveerd wanneer", FCa = "Voer een pingtest uit voordat u dit aanmaakt.", VCa = "Webhook inschakelen", BCa = "Webhook toevoegen", UCa = "Webhook opgeslagen", WCa = "Genereer API-sleutels voor toegang tot uw eigen account", GCa = "Nieuwe API-sleutel", HCa = "Actief", KCa = "Naam van API-sleutel bijgewerkt", YCa = "Fout bij het bijwerken van de naam van de API-sleutel", ZCa = "HTML-iframe insluiten", QCa = "Sluit al uw type gebeurtenissen in op uw website", JCa = "Maak uw eerste API-sleutel", XCa = "Met API-sleutels kunnen andere apps communiceren met {{appName}}", eza = "Terug naar aanmelden", tza = "Link om opnieuw in te stellen is verzonden", nza = "Er is een e-mail onderweg naar {{email}} met instructies om je wachtwoord opnieuw in te stellen.", oza = "Als u niet spoedig een e-mail ontvangt, controleer dan of het ingevoerde e-mailadres correct is, controleer uw spamfolder of neem contact op met de ondersteuning als het probleem zich blijft voordoen.", rza = "Wachtwoord bijgewerkt!", iza = "In afwachting van betaling", aza = "Openstaande uitnodigingen", sza = "Openstaande organisatie-uitnodigingen", cza = "Niet op {{appName}}", lza = "Geen agenda geïnstalleerd", dza = "U heeft nog geen agenda's gekoppeld", uza = "Voeg een agenda toe", _za = "Mogelijk moet u uit- en weer inloggen om de wijziging te zien.", pza = "Bevestig uw wachtwoord voordat u uw e-mailadres wijzigt", mza = "plaatsen", fza = "Elke app die in de App Store van {{appName}} wordt gepubliceerd is open source en grondig getest via collegiale beoordelingen. Desondanks onderschrijft of certificeert {{companyName}} deze apps niet, tenzij ze zijn gepubliceerd door {{appName}}. Meld het als u ongepaste inhoud of gedrag tegenkomt.", gza = "App melden", hza = "Boekingsfrequentie beperken", vza = "Beperk hoe vaak deze gebeurtenis kan worden geboekt", bza = "Toon alleen de eerste beschikbare tijdslot", yza = "Dit beperkt je beschikbaarheid voor dit type evenement tot één tijdslot per dag, gepland op de vroegst beschikbare tijd.", $za = "Totale boekingsduur beperken", wza = "Beperk de totale tijd dat deze gebeurtenis kan worden geboekt", kza = "Limiet voor actieve boekingen per boeker", Sza = "Beperk het aantal actieve boekingen dat een boeker kan maken voor dit afspraaktype", xza = "Terugkerende afspraken ondersteunen geen limiet voor boekingen per boeker", Eza = "Voeg een limiet toe", Tza = "Teamnaam verplicht", Aza = "Deel de deelnemersinformatie met de gasten", Cza = "Aantal beschikbare plaatsen weergeven", zza = "Hoe gebruik ik boekingsvragen als variabelen?", Oza = "Formatteren", Pza = "Vragen", Iza = "Alle informatie die je boeker moet verstrekken voordat ze bij jou boeken.", Rza = "Gebruik hoofdletters voor alle letters", Nza = "Vervang spaties door onderstrepingstekens", Dza = "Platformleden", Mza = "Beheer de beheerders en leden in je platformteam", Lza = "Platformfacturering", qza = "Facturering beheren", jza = "Alles beheren wat met facturering te maken heeft", Fza = "U heeft momenteel het GRATIS abonnement", Vza = "We werken beter in teams. Breid uw werkstromen uit met Round Robin en collectieve gebeurtenissen en maak geavanceerde routeringsformulieren", Bza = "Nu proberen", Uza = "Factureringsportaal", Wza = "Contact opnemen met de ondersteuning", Gza = "Negeer speciale tekens in uw boekingsvraag-ID. Gebruik alleen letters en cijfers", Hza = "Opnieuw proberen", Kza = "Er is een probleem opgetreden bij het ophalen van uw agenda's. <1>Probeer het opnieuw</1> of neem contact op met de klantenservice.", Yza = "Agendaverbinding mislukt", Zza = "Boekingsbevestiging gelukt", Qza = "Boekingsweigering gelukt", Jza = "Deze boeking is voorlopig", Xza = "Oeps, ik wil accepteren", eOa = "We zullen dit niet opnieuw weergeven", tOa = "We konden de tijdzone niet bijwerken", nOa = "Tijdzone bijgewerkt naar {{formattedCurrentTz}}", oOa = "Werk de tijdzone bij", rOa = "Tijdzone bijwerken?", iOa = "Het lijkt erop dat uw lokale tijdzone is gewijzigd in {{formattedCurrentTz}}.  Het is erg belangrijk dat de juiste tijdzone is ingesteld om boekingen op ongewenste tijden te voorkomen. Wilt u het bijwerken?", aOa = "Niet bijwerken", sOa = "Aanvullende opmerkingen vereisen", cOa = "Vereisen dat extra opmerkingen worden ingevuld tijdens het boeken", lOa = "e-mail versturen naar een specifiek e-mailadres", dOa = "na afloop van gebeurtenis", uOa = "wanneer boeking wordt geweigerd", _Oa = "wanneer boeking wordt aangevraagd", pOa = "wanneer betaling voor boeking wordt gestart", mOa = "wanneer betaling voor boeking succesvol is", fOa = "wanneer boeking no-show wordt bijgewerkt", gOa = "Hoelang na afloop van de gebeurtenis?", hOa = "Hoe lang nadat hosts niet verschijnen bij een cal videovergadering?", vOa = "Hoe lang nadat gasten niet verschijnen bij een cal videovergadering?", bOa = "Hoe lang nadat gebruikers niet verschijnen bij een cal videovergadering?", yOa = "Geen beschikbare tijdvakken", $Oa = "Tijd beschikbaar", wOa = "Kun je de juiste vergader-app niet vinden? Bezoek onze <0>App Store</0>.", kOa = "Installeer een nieuwe agenda-app", SOa = "Een telefoonnummer verplicht stellen voor het boeken van een gebeurtenis", xOa = "Beschikbaarheid {{eventTypeTitle}}", EOa = "Fout bij het bewerken van de beschikbaarheid", TOa = "U heeft geen machting voor toegang tot dit hulpmiddel.", AOa = "Plak de SAML-metagegevens van uw identiteitsprovider hier", COa = "Voer een e-mailadres in zodat we uw SAML-identiteitsprovider kunnen vinden", zOa = "Serviceprovidergegevens", OOa = "Uw identiteitsprovider (IdP) zal u om de volgende gegevens vragen om de configuratie van de SAML-applicatie te voltooien.", POa = "ACS-URL", IOa = "SP-entiteits-ID", ROa = "ACS-URL gekopieerd!", NOa = "SP-entiteits-ID gekopieerd!", DOa = "Agenda toevoegen", MOa = "Toekomstige boekingen beperken", LOa = "Beperk hoe ver in de toekomst dezew gebeurtenis kan worden geboekt", qOa = "Geen gebeurtenistype ingesteld", jOa = "{{name}} heeft geen gebeurtenistypen ingesteld die u kunt boeken.", FOa = "Factureringsfrequentie", VOa = "Maandelijks", BOa = "Jaarlijks", UOa = "Kassa", WOa = "Uw team is ontbonden", GOa = "Uw organisatie is ontbonden", HOa = "Fout bij het aanmaken van team", KOa = "U", YOa = "Of ga verder met", ZOa = "E-mail opnieuw verzenden", QOa = "Lid is al uitgenodigd", JOa = "Gebruikersnaam al in gebruik", XOa = "Voer een e-mailadres of gebruikersnaam in", e4a = "Voer een e-mailadres in", t4a = "Voer e-mailadressen in", n4a = "Je kunt maximaal {{nbUsers}} gebruikers tegelijk uitnodigen.", o4a = "Deze naam is al in gebruik", r4a = "Moet een teamnaam invoeren", i4a = "Moet een team-URL invoeren", a4a = "Deze URL is al in gebruik", s4a = "Er is een probleem opgetreden bij het registreren van het subdomein. Probeer het opnieuw of neem contact op met een beheerder", c4a = "Team publiceren", l4a = "Telefoonnummer (sms-meldingen)", d4a = "Telefoonnummer (sms-meldingen)", u4a = "E-mailadres deelnemer", _4a = "Het e-mailadres van de persoon die boekt", p4a = "Boeking UID", m4a = "Typ een opdracht of zoek...", f4a = "Oh nee! Het lijkt erop dat de machtiging is verlopen of is ingetrokken. Installeer het opnieuw.", g4a = "Herinstalleer de app", h4a = "Reden voor opnieuw plannen", v4a = "Kies een gezamenlijke planning", b4a = "Schakel dit in als je een gemeenschappelijk schema wilt gebruiken tussen hosts. Wanneer uitgeschakeld, wordt elke host geboekt op basis van hun standaardschema of hun gekozen schema.", y4a = "Reden", $4a = "Afzender-ID", w4a = "Alleen letters, cijfers en spaties toegestaan (max. 11 tekens)", k4a = "Routeringsformulier testen", S4a = "Voorbeeld testen", x4a = "Routeren naar", E4a = "Test uw routeringsformulier zonder gegevens te versturen", T4a = "Routering testen", A4a = "Een beheerder heeft een betaalapp uitgeschakeld", C4a = "Gebeurtenistype bewerken", z4a = "Deze organisatie is privé, en alleen de beheerder of eigenaar van de organisatie kan de leden zien.", O4a = "Alleen de beheerder of eigenaar van de organisatie kan SSO-instellingen beheren", P4a = "Alleen de beheerder of eigenaar van de organisatie kan directory-synchronisatie-instellingen beheren", I4a = "Alleen de beheerder of eigenaar van de organisatie kan OAuth-clients beheren", R4a = "Collectieve planning", N4a = "Maak het gemakkelijk om uw team te boeken wanneer iedereen beschikbaar is.", D4a = "Zoek de beste beschikbare persoon en blader door uw team.", M4a = "Vaste round-robin", L4a = "Voeg één vaste deelnemer en round-robin toe via een aantal deelnemers.", q4a = "{{appName}} is beter met teams", j4a = "Het team van {{companyName}}", F4a = "Voeg uw teamleden toe aan uw gebeurtenistypes. Gebruik collectieve planning om iedereen op te nemen of zoek de meest geschikte persoon met round robin-planning.", V4a = "Boekingslimiet voor dit gebeurtenistype is bereikt", B4a = "Duurlimiet voor dit gebeurtenistype is bereikt", U4a = "Een beheerder heeft {{appName}} uitgeschakeld", W4a = "Dit zal alle e-mails naar {{recipient}} uitschakelen. Dit omvat boekingsbevestigingen, verzoeken, herplanningen en herplanningsverzoeken, annuleringsmails en alle andere e-mails met betrekking tot boekingsupdates.<br /><br />Het is jouw verantwoordelijkheid om ervoor te zorgen dat je {{recipient}} op de hoogte zijn van boekingen en wijzigingen in hun boekingen.", G4a = "Een beheerder heeft {{appName}} uitgeschakeld die van invloed is op uw gebeurtenistype {{eventType}}", H4a = "Een beheerder heeft een van uw gebeurtenistypen vervangen", K4a = "Een teambeheerder heeft uw gebeurtenis vervangen /{{slug}}", Y4a = "Een beheerder van het team <strong>{{teamName}}</strong> heeft uw gebeurtenistype <strong>/{{slug}}</strong> vervangen door een type beheerde gebeurtenis dat deze beheert.", Z4a = "Uw link blijft werken, maar sommige instellingen ervoor kunnen gewijzigd zijn. U kunt deze bekijken in gebeurtenistypen.", Q4a = "Neem contact op met uw beheerder als u vragen hebt over het gebeurtenistype.<br /><br />Veel plezier met plannen, <br />Het Cal.com-team", J4a = "De beheerder heeft {{appName}} uitgeschakeld, wat invloed heeft op je afspraaktype {{title}}. Deelnemers kunnen dit type afspraak nog steeds boeken, maar worden niet gevraagd te betalen. Je kunt het afspraaktype verbergen om dit te voorkomen totdat je beheerder je betaalmethode opnieuw inschakelt.", X4a = "Deelnemers kunnen dit type afspraak nog steeds boeken, maar worden niet gevraagd te betalen. Je kunt het afspraaktype verbergen om dit te voorkomen totdat je beheerder je betaalmethode opnieuw inschakelt.", e3a = "De beheerder heeft {{appName}} uitgeschakeld die van invloed is op uw gebeurtenistype {{title}}.", t3a = "De beheerder heeft {{appName}} uitgeschakeld, wat van invloed kan zijn op uw gebeurtenistypes. Als u gebeurtenistypes heeft met {{appName}} als locatie, is het standaard Cal Video.", n3a = "{{appName}} is uitgeschakeld", o3a = "Naar geïnstalleerde apps", r3a = "Als u een andere agenda heeft geïnstalleerd, worden nieuwe boekingen daaraan toegevoegd. Zo niet, koppel dan een nieuwe agenda zodat u geen nieuwe boekingen mist.", i3a = "Apps inschakelen", a3a = "Schakel apps in die gebruikers kunnen integreren met {{appName}}", s3a = "Koop een licentie", c3a = "Heeft u al een account?", l3a = "Ik heb al een code:", d3a = "Kopieer hier uw bestaande CALCOM_LICENSE_KEY-omgevingsvariabele.", u3a = "Licentiesleutel aanmaken", _3a = "{{appName}} is ingeschakeld", p3a = "{{appName}} is uitgeschakeld", m3a = "Sleutels zijn opgeslagen", f3a = "App uitschakelen", g3a = "Het uitschakelen van deze app kan problemen veroorzaken met de interactie tussen uw gebruikers en Cal", h3a = "Sleutels bewerken", v3a = "Schakel apps in voor uw exemplaar van Cal", b3a = "Een lijst van alle gebruikers in uw account, inclusief hun naam, functie, e-mail en rol.", y3a = "Hier kunt u een nieuwe gebruiker toevoegen.", $3a = "Hier kunt u een huidige gebruiker bewerken.", w3a = "Hier kunt u een organisatie bewerken.", k3a = "Nieuwe OAuth-clients toevoegen", S3a = "SMS-verzending voor gebruikers vergrendelen of ontgrendelen", x3a = "Er zijn geen beschikbare apps", E3a = 'Zorg ervoor dat er apps zijn in uw implementatie onder "packages/app-store"', T3a = "Er zijn geen apps ingeschakeld in dit exemplaar van Cal", A3a = "Er is nog geen app geconfigureerd", C3a = "U kunt apps inschakelen in de instellingen", z3a = "Neem contact op met uw beheerder", O3a = "Appsinstellingen", P3a = "Vul dit veld in", I3a = "Opties", R3a = "Voer optie {{index}} in", N3a = "Voeg een optie toe", D3a = "Deze locatie bestaat al. Kies een nieuwe locatie", M3a = "Radio", L3a = "Om Google Meet te gebruiken, moet je je doelkalender instellen als een Google Agenda", q3a = "Individueel", j3a = "Alle boekingen", F3a = "Alle gebruikers", V3a = "Alle evenementtypes", B3a = "Uw boekingen", U3a = "Vergaderings-URL", W3a = "De vergaderingsconferentie-url van de gebeurtenis", G3a = "Datumoverschrijvingen", H3a = "Verwijder datumoverschrijvingen op {{date}}", K3a = "Voeg datums toe wanneer uw beschikbaarheid afwijkt van uw dagelijkse tijden.", Y3a = "Datumoverschrijvingen worden automatisch gearchiveerd nadat de datum is verstreken", Z3a = "Welke tijden bent u beschikbaar?", Q3a = "Welke tijden bent u bezet?", J3a = "Selecteer de datums om te overschrijven", X3a = "Hele dag niet beschikbaar", e6a = "Markeren als niet beschikbaar (hele dag)", t6a = "Markeren als niet beschikbaar op geselecteerde datums", n6a = "Overschrijving bijwerken", o6a = "Datumoverschrijing toegevoegd", r6a = "Uitzondering opslaan", i6a = "{{slug}}-kopie", a6a = "Als standaard instellen", s6a = "Gebeurtenistypegegevens verbergen", c6a = "Navigatie weergeven", l6a = "Navigatie verbergen", d6a = "Verificatiecode verzonden", u6a = "Geverifieerd", _6a = "Onjuiste verificatiecode", p6a = "Nog niet geverifieerd", m6a = "Geen beschikbaarheid in {{month}}", f6a = "Afspraken kunnen alleen tot {{days}} dagen vooruit worden gepland. Kijk binnenkort nog eens.", g6a = "Plannen is geëindigd op {{date}}. Kijk binnenkort nog eens.", h6a = "Vorige maand bekijken", v6a = "Volgende maand weergeven", b6a = "Code verzenden", y6a = "Nummer geverifieerd", $6a = "Maak uw eerste webhook voor dit teamgebeurtenistype", w6a = "Maak een webhook voor dit teamgebeurtenistype", k6a = "Succespagina uitschakelen (werkt alleen als u een omleidings-URL heeft)", S6a = "U bent beheerder, maar u hebt geen wachtwoord van minimaal 15 tekens of nog geen tweestapsverificatie", x6a = "Wijzig je wachtwoord om beheerderstoegang te krijgen", E6a = "De gebruikersnaam is al in gebruik", T6a = "Toewijzing", A6a = "Vaste hosts", C6a = "Vaste hosts toevoegen", z6a = "Round-robin-hosts", O6a = "Aantal vereiste hosts voor deelname", P6a = "Hosts", I6a = "Je moet een team aanmaken om deze functie in te schakelen. Klik hier om een team aan te maken.", R6a = "U moet upgraden naar ons Enterprise-abonnement om deze functie in te schakelen.", N6a = "Nieuwe deelnemer", D6a = "In afwachting van goedkeuring", M6a = "Deze app vereist een Google Agenda-koppeling", L6a = 'De "Toevoegen aan agenda" voor dit afspraaktype moet een Google Agenda zijn om Meet te laten werken. Verbind het <0>hier</0>.', q6a = "U heeft een Google Agenda-account gekoppeld.", j6a = "Het gebruik van Google Meet vereist een gekoppelde Google-agenda", F6a = "Ga door met het installeren van Google Agenda", V6a = "Google Meet installeren", B6a = "Google Agenda installeren", U6a = "Afzendernaam", W6a = "Deelnemer reeds uitgenodigd", G6a = "Geen opnames gevonden", H6a = "Nieuwe werkstroom voor...", K6a = "Rapportage", Y6a = "Bekijk alle inkomende gegevens en download ze als een CSV-bestand", Z6a = "Teams-abonnement vereist", Q6a = "Routeringsformulieren zijn een geweldige manier om uw inkomende leads naar de juiste persoon te leiden. Upgrade naar een Teams-abonnement om toegang te krijgen tot deze functie.", J6a = "Kies een licentie", X6a = "Cal.com wordt geleverd met een toegankelijke en gratis AGPLv3-licentie met enkele beperkingen die op elk moment kan worden geüpgraded naar een bedrijfslicentie. U kunt later altijd upgraden.", e5a = "Licentie", t5a = "AGPLv3-licentie", n5a = "Uw code hoeft niet open source te zijn", o5a = "Gemakkelijk opnieuw verpakken, rebranden en doorverkopen", r5a = "Een uitgebreid pakket bedrijfsfuncties", i5a = "$ 0,00/maand", a5a = "Voor altijd open en gratis", s5a = "Vereist om uw code open source te houden", c5a = "Kan niet gemakkelijk opnieuw verpakken, rebranden en doorverkopen", l5a = "Geen bedrijfsfuncties", d5a = "Enterprise-licentie", u5a = "Alles voor commerciële toepassing met privéhosting, opnieuw verpakken, rebranden en doorverkopen en toegang tot exclusieve bedrijfscomponenten.", _5a = "Configuratie", p5a = "Cal.com-exemplaar configureren", m5a = "Configureren", f5a = "Single sign-on", g5a = "SAML/OIDC SSO configureren en teamleden laten inloggen met behulp van een identiteitsprovider", h5a = "Configureer SAML/OIDC SSO en laat organisatieleden inloggen met een Identity Provider", v5a = "SSO met OIDC", b5a = "Configureer OIDC SSO met de identiteitsprovider van uw keuze.", y5a = "OIDC-configuratie", $5a = "Configureer de OIDC-verbinding met uw identiteitsprovider. U kunt de vereiste informatie vinden bij uw identiteitsprovider.", w5a = "URL voor terugbellen gekopieerd", k5a = "SSO met SAML", S5a = "Configureer SAML SSO met de identiteitsprovider van uw keuze.", x5a = "SAML-configuratie", E5a = "Configureer de SAML-verbinding met uw identiteitsprovider. U kunt de vereiste informatie vinden bij uw identiteitsprovider.", T5a = "ACS-URL gekopieerd", A5a = "Entiteits-ID gekopieerd", C5a = "{{connectionType}}-configuratie gemaakt", z5a = "{{connectionType}}-configuratie verwijderd", O5a = "{{connectionType}}-configuratie verwijderen", P5a = "Ja, verwijder de {{connectionType}}-configuratie", I5a = "Weet u zeker dat u de {{connectionType}}-configuratie wilt verwijderen? Uw teamleden die {{connectionType}}-aanmelding gebruiken hebben niet langer toegang tot Cal.com.", R5a = "Tijdzone organisator", N5a = "Uitnodiging weergeven", D5a = "Uitnodiging accepteren", M5a = "Nu deelnemen", L5a = "Succesvol deelgenomen", q5a = "Je bent uitgenodigd om lid te worden van een team binnen de {{parentTeamName}} organisatie", j5a = "Je bent uitgenodigd om lid te worden van een {{appName}} organisatie", F5a = "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn team op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw team in staat stelt vergaderingen te plannen zonder heen en weer te e-mailen.", V5a = "{{invitedBy}} heeft je uitgenodigd om lid te worden van het team {{teamName}} in hun organisatie {{parentTeamName}} op {{appName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.", B5a = "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn organisatie '{{teamName}}' op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw organisatie in staat stelt afspraken te plannen zonder heen en weer te e-mailen.", U5a = "We leiden je door een paar korte stappen en je kunt in een mum van tijd genieten van stressvrij plannen met je {{entity}}.", W5a = "Kies uw gebruikersnaam", G5a = "Koppel uw agenda-account", H5a = "Stel uw beschikbaarheid in", K5a = "Neem deel aan {{teamName}}", Y5a = "Veel plezier met het plannen van het {{appName}}-team", Z5a = "U staat op het punt zich voor te doen als een gebruiker, wat betekent dat u namens hem wijzigingen kunt aanbrengen. Wees voorzichtig.", Q5a = "Beschikbare variabelen", J5a = "{Scheduler}", X5a = "Geen werkstromen", ePa = "Wijzig het filter om uw persoonlijke en teamwerkstromen te zien.", tPa = "Wijzig het filter om de resultaten te zien.", nPa = "Geen resultaten voor het filter", oPa = "Aanbevolen volgende stappen", rPa = "Maak een beheerd gebeurtenistype", iPa = "Vergaderingen zijn beter met de juiste teamleden erbij. Nodig ze nu uit.", aPa = "Maak een een-op-een sjabloon voor een gebeurtenistype en verspreid het onder meerdere leden.", sPa = "Collectief of round-robin", cPa = "Boek uw teamleden samen met collectieve gebeurtenissen of blader voor de juiste persoon met round-robin.", lPa = "Neemt niet langer deel aan {{title}} op {{date}}", dPa = "U neemt niet langer deel aan deze gebeurtenis", uPa = "Een deelnemer neemt niet langer deel aan {{title}} op {{date}}", _Pa = "Een deelnemer neemt niet langer deel aan uw gebeurtenis", pPa = "{{name}} heeft geannuleerd. Dit betekent dat er een plaats is vrijgekomen voor dit tijdslot", mPa = "Gebeurtenis aanmaken op", fPa = "Routeringsformulier maken op", gPa = "Stel een standaard app-link in", hPa = "Door een standaard app-link in te stellen kunnen alle nieuw gemaakte gebeurtenistypes de door u ingestelde app-link gebruiken.", vPa = "Standaardapp organisator", bPa = "{{organizer}} heeft geen standaard vergaderapp", yPa = "Onbereikbaar wegens onderhoud", $Pa = "Het {{appName}}-team voert gepland onderhoud uit. Neem contact op met de ondersteuning als u vragen heeft.", wPa = "{{numberOfSeats}} plaatsen", kPa = "Boekingsvragen", SPa = "Pas de gestelde vragen op de boekingspagina aan", xPa = "Vraag toevoegen", EPa = "ID", TPa = "E-mailadres dubbel", APa = "Voer een doorverwijzings-URL in waarnaar de deelnemer wordt gestuurd zodra deze de vergadering verlaat.", CPa = "Betalen voor deze gebeurtenis is niet meer mogelijk", zPa = "Een terugbetaling voor deze boeking is onderweg.", OPa = "Deze boekingsbetaling is terugbetaald.", PPa = "Volgens het restitutiebeleid van het evenement is de boekingsbetaling niet-restitueerbaar.", IPa = "De restitutieperiode van het evenement is verlopen. Daarom is de boekingsbetaling niet-restitueerbaar.", RPa = "Boekingsbevestiging mislukt", NPa = "Onvoldoende plaatsen", DPa = "Een veld met deze naam bestaat al", MPa = "Gastveld moet van het type 'Meerdere e-mails' zijn", LPa = "Weergeven op boekingspagina", qPa = "Je kunt de pagina van de geannuleerde boeking bezoeken", jPa = "Aan de slag met Zapier-sjablonen", FPa = "Standaard sjablonen", VPa = "Cal.ai sjablonen", BPa = "{{team}} is niet gepubliceerd", UPa = "Deze organisatiekoppeling is momenteel niet beschikbaar. Neem contact op met de organisatie-eigenaar of vraag om het te publiceren.", WPa = "Deze {{entity}}-link is momenteel niet beschikbaar. Neem contact op met de {{entity}}-eigenaar of vraag hem het te publiceren.", GPa = "Teamlid", HPa = "Een routeringsformulier", KPa = "Formulierbeschrijving", YPa = "Houd me verbonden met het formulier", ZPa = "Alle wijzigingen die worden aangebracht in de router of velden van het formulier dat wordt gedupliceerd, worden weergegeven in het duplicaat. Het verwijderen van een veld zal het echter niet uit het duplicaat verwijderen.", QPa = "Formulier verwijderd", JPa = "Weet u zeker dat u dit formulier wilt verwijderen?", XPa = "Ja, verwijder het formulier", eIa = "Iedereen met wie u de link heeft gedeeld heeft dan geen toegang meer ertoe.", tIa = "Alle bijbehorende reacties worden verwijderd.", nIa = "Doorverwijzings-URL gekopieerd! Je kunt nu de URL in je eigen formulier instellen.", oIa = "Wijzigingen in velden en routes van de volgende formulieren worden in dit formulier verwerkt.", rIa = "Verbonden formulieren", iIa = "De volgende formulieren worden beïnvloed wanneer u hier velden of routes wijzigt.", aIa = "Wacht enige tijd tot de reacties zijn verzameld. U kunt het formulier ook zelf indienen.", sIa = "Dit is wat uw gebruikers te zien krijgen", cIa = "Identificeert het veld met deze naam.", lIa = "Voeg 1 optie per regel toe", dIa = "Selecteer een router", uIa = "Voeg een nieuwe route toe", _Ia = "Neem geïnformeerde beslissingen met Insights", pIa = "Ons Insights-dashboard geeft alle activiteiten in uw team weer en toont u trends die betere teamplanning en besluitvorming mogelijk maken.", mIa = "Geef boekingen van alle leden weer", fIa = "Bekijk wie de meeste boekingen ontvangt en zorg voor de beste verdeling binnen je team", gIa = "Identificeer boekingstrends", hIa = "Bekijk welke tijden van de week en welke tijden overdag populair zijn voor uw boekers", vIa = "Spot populaire gebeurtenistypen", bIa = "Bekijk welke van uw gebeurtenistypen de meeste kliks en boekingen ontvangen", yIa = "Nog geen reacties", $Ia = "Geen routes gedefinieerd", wIa = "Dit wordt de plaatshouder", kIa = "Er is een fout opgetreden bij het boeken van de gebeurtenis. Vernieuw de pagina en probeer het opnieuw", SIa = "Geen tijdslot geselecteerd", xIa = "Selecteer een tijdslot om de gebeurtenis te boeken.", EIa = "Tijdslot selecteren", TIa = "Overschakelen naar maandelijkse weergave", AIa = "Overschakelen naar wekelijkse weergave", CIa = "Overschakelen naar dagelijkse weergave", zIa = "Overschakelen naar kolomweergave", OIa = "{{num}} locatieopties", PIa = "Selecteer bij de volgende stap", IIa = "Deze vergadering is nog niet begonnen", RIa = "{{appName}} vereist een gekoppeld {{dependencyName}}-account", NIa = "{{dependencyName}} koppelen", DIa = "{{dependencyName}} is gekoppeld", MIa = "Vereist {{dependencyName}}", LIa = "Verificatiecode", qIa = "Kunt u het opnieuw proberen met een andere tijd?", jIa = "Verifiëren", FIa = "De tijdzone van de ontvanger", VIa = "Tijdzone", BIa = "Eindtijd gebeurtenis", UIa = "De eindtijd van de gebeurtenis", WIa = "Annulerings-URL", GIa = "De URL om de boeking te annuleren", HIa = "Annuleringsreden", KIa = "De reden voor het annuleren van de boeking", YIa = "Verplaatsings-URL", ZIa = "De URL om de boeking te verplaatsen", QIa = "Reden voor verzetten", JIa = "De reden voor het verzetten van de boeking", XIa = "Uw gebeurtenisnaam bevat een ongeldige variabele", eRa = "Alles selecteren", tRa = "Bestaande gebeurtenistypen in bulk bijwerken", nRa = "Standaardschema lid", oRa = "Ingesteld door teambeheerder", rRa = "Standaardlocatie lid", iRa = "Wij gebruiken de standaard beschikbaarheidsplanning van elk lid. Leden kunnen dit bewerken of wijzigen.", aRa = "U moet ten minste één planning hebben", sRa = "Werk de locaties voor de geselecteerde gebeurtenistypen bij", cRa = "Werk de schema's bij voor de geselecteerde evenementtypes", lRa = "Vergrendeld voor leden", dRa = "Ontgrendeld voor leden", uRa = "Leden kunnen de actieve apps zien, maar kunnen geen appinstellingen bewerken", _Ra = "Leden kunnen de actieve apps zien en alle app-instellingen bewerken", pRa = "Je kunt de actieve apps zien, maar je kunt geen app-instellingen bewerken", mRa = "Je zult de actieve apps kunnen zien en de instellingen van elke app kunnen bewerken.", fRa = "Leden kunnen hun persoonlijke workflows niet toevoegen aan dit type evenement. Leden kunnen de actieve teamworkflows zien, maar kunnen geen workflow-instellingen bewerken.", gRa = "Leden kunnen hun persoonlijke workflows toevoegen aan dit type evenement. Leden kunnen de actieve teamworkflows zien, maar kunnen geen workflow-instellingen bewerken.", hRa = "Je zult de actieve teamworkflows kunnen zien, maar je kunt geen workflow-instellingen bewerken of je persoonlijke workflows toevoegen aan dit type evenement.", vRa = "Je kunt persoonlijke workflows in- of uitschakelen voor dit type evenement. Je zult de actieve teamworkflows kunnen zien, maar je kunt geen teamworkflow-instellingen bewerken.", bRa = "Leden kunnen geen persoonlijke webhooks toevoegen aan dit afspraaktype. Leden kunnen wel de actieve webhooks zien, maar kunnen geen webhook-instellingen bewerken.", yRa = "Leden kunnen hun persoonlijke webhooks toevoegen aan dit afspraaktype. Leden kunnen de actieve webhooks zien, maar kunnen geen webhook-instellingen bewerken.", $Ra = "Je kunt de actieve beheerde webhooks zien, maar je kunt geen webhook-instellingen bewerken of je persoonlijke webhooks toevoegen aan dit afspraaktype.", wRa = "Je kunt webhooks toevoegen aan dit afspraaktype. Je kunt de actieve beheerde webhooks zien, maar je kunt deze niet bewerken.", kRa = "Vergrendeld door teambeheerder", SRa = "U hebt geen {{appName}}-account gekoppeld.", xRa = "Nu koppelen", ERa = "{{count}} lid vervangen en informeren", TRa = "{{count}} leden vervangen en informeren", ARa = "De URL /{{slug}} bestaat al voor {{count}} lid. Wilt u deze vervangen?", CRa = "De URL /{{slug}} bestaat al voor {{count}} leden. Wilt u deze vervangen?", zRa = "<strong>{{names}}</strong> gebruikt de URL <strong>/{{slug}}</strong> al.", ORa = "<strong>{{names}}</strong> gebruiken de URL <strong>/{{slug}}</strong> al.", PRa = "Als u ervoor kiest om de URL te vervangen, informeren wij de leden daarover. Ga terug en verwijder ze als u de URL niet wilt overschrijven.", IRa = "Gebeurtenistype bekijken", RRa = "Op zoek naar meer analyses?", NRa = "Op zoek naar meer Insights?", DRa = "Filters", MRa = "Filter", LRa = "Lid toevoegen", qRa = "Filter toevoegen", jRa = "Regel toevoegen", FRa = "Regelgroep toevoegen", VRa = "Alle filters wissen", BRa = "E-mail geverifieerd", URa = "Selecteer gebruiker", WRa = "Selecteer gebeurtenistype", GRa = "Selecteer datumbereik", HRa = "Populaire gebeurtenissen", KRa = "Geen gebeurtenistypen gevonden", YRa = "Gemiddelde gebeurtenisduur", ZRa = "Boekingen per uur", QRa = "Meest geboekt", JRa = "Minst geboekt", XRa = "Meeste boekingen gepland", eNa = "Minste boekingen gepland", tNa = "Meeste boekingen voltooid", nNa = "Minste boekingen voltooid", oNa = "Gemaakte gebeurtenissen", rNa = "Voltooide gebeurtenissen", iNa = "Afspraken geannuleerd", aNa = "Verplaatste gebeurtenissen", sNa = "Evenementen", cNa = "Prestaties", lNa = "van afgelopen periode", dNa = "Van: {{startDate}} Tot: {{endDate}}", uNa = 'Als u een omleiding toevoegt, wordt de succespagina uitgeschakeld. Zorg ervoor dat u op uw aangepaste succespagina "Boeking bevestigd" vermeldt.', _Na = "Gebeurtenistrends", pNa = "Filters wissen", mNa = "Wissen", fNa = "Vasthouden", gNa = "Betaling ontvangen bij boeken", hNa = "Afwezigheidsvergoeding in rekening brengen", vNa = "Kaartbetaling vastgehouden", bNa = "In rekening brengen op kaart", yNa = "In rekening gebracht op kaart", $Na = "{{amount, currency}} afwezigheidsvergoeding", wNa = "Afwezigheidsvergoeding", kNa = "Kaart verzenden", SNa = "Betaalgegevens verzenden", xNa = "Uw vergadering wacht op een betaalmethode", ENa = "Afwezigheidsvergoeding van {{amount, currency}} in rekening gebracht voor {{title}} om {{date}}", TNa = "Afwezigheidsvergoeding is in rekening gebracht", ANa = "Er is een afwezigheidsvergoeding van {{amount, currency}} in rekening gebracht voor de volgende gebeurtenis", CNa = "Er is iets misgegaan met het in rekening brengen van de afwezigheidsvergoeding. Probeer het later opnieuw.", zNa = "Afwezigheidsvergoeding innen", ONa = "Afwezigheidsvergoeding in rekening gebracht", PNa = "Betaling geweigerd. Probeer een andere kaart of neem contact op met uw bank voor hulp.", INa = "Dit kaarttype wordt niet ondersteund voor deze aankoop. Gebruik een andere betaalmethode.", RNa = "Minimaal betalingsbedrag is $0.50 USD. Verhoog uw betalingsbedrag.", NNa = "Kon de kaart niet belasten voor betaling.", DNa = "Inzichten", MNa = "Routeringsformulieren", LNa = "Geen gegevens gevonden voor het geselecteerde filter of de geselecteerde datums.", qNa = "Ik erken dat als ik deze gebeurtenis niet bijwoon, er {{amount, currency}} aan afwezigheidsvergoeding van mijn kaart worden afgeschreven.", jNa = "dagen", FNa = "Kaartgegevens", VNa = "Er is iets misgegaan aan onze kant. Neem contact op met ons ondersteuningsteam, en we lossen het meteen voor je op.", BNa = "Vermeld de volgende tekst wanneer u contact opneemt met ondersteuning, zodat we u beter kunnen helpen", UNa = "Kan op dit moment geen plaatsen inschakelen en afwezigheidsvergoeding in rekening brengen", WNa = "Voltooi uw boeking", GNa = "Voltooi uw boeking: {{title}} op {{date}}", HNa = "Bevestig uw gegevens", KNa = "Uitnodigingslink kopiëren", YNa = "Linkinstellingen bewerken", ZNa = "Uitnodigingslink gekopieerd", QNa = "Uitnodigingslink verwijderd", JNa = "API-sleutel verwijderd", XNa = "Dit zal de API-sleutel permanent verwijderen. Alle applicaties die deze sleutel gebruiken, verliezen onmiddellijk toegang tot je account. Deze actie kan niet ongedaan worden gemaakt.", eDa = "Uitnodigingslinkinstellingen opgeslagen", tDa = "Links verlopen na...", nDa = "1 dag", oDa = "7 dagen", rDa = "30 dagen", iDa = "3 maanden", aDa = "1 jaar", sDa = "U bent uitgenodigd om lid te worden van {{teamName}}", cDa = "{{amount, currency}}", lDa = "U staat op het punt om de deelnemer {{amount, currency}} in rekening te brengen. Weet u zeker dat u wilt doorgaan?", dDa = "Deelnemer {{amount, currency}} in rekening brengen", uDa = "Betaling vereisen ({{paymentFeePercentage}}% + {{fee, currency}} commissie per transactie)", _Da = "{{email}} is uitgenodigd", pDa = "{{userCount}} gebruikers zijn uitgenodigd", mDa = "Fout bij incasseren van kaart", fDa = "De geüploade afbeelding mag niet groter zijn dan 5 MB", gDa = "{{errorCode}}: u bent niet geautoriseerd om deze werkstroom in of uit te schakelen", hDa = "Inline insluiting", vDa = "Laadt uw gebeurtenistype rechtstreeks inline met uw andere websitecontent.", bDa = "Zwevende pop-upknop", yDa = "Plaatst een zwevende knop op uw site die een dialoogvenster met uw gebeurtenistype activeert.", $Da = "Pop-up via elementklik", wDa = "Open uw Cal-dialoogvenster wanneer iemand op een element klikt.", kDa = "Mijn eigen formulier gebruiken", SDa = "Gebruik onze headless routing API en gebruik uw eigen formulier voor inzendingen.", xDa = "Hulp nodig? Bekijk onze handleidingen voor het insluiten van Cal op Wix, Squarespace of WordPress. Bekijk onze veelgestelde vragen of ontdek geavanceerde insluitopties.", EDa = "Boeken op Cal", TDa = "Voornaam", ADa = "Achternaam", CDa = "Voornaam, achternaam", zDa = "Uitnodigen als", ODa = "Formulier bijgewerkt.", PDa = "Standaardbevestigings-e-mails voor deelnemers uitschakelen", IDa = "Er is minstens één werkstroom actief voor dit gebeurtenistype die een e-mail naar de deelnemers stuurt wanneer de gebeurtenis geboekt is.", RDa = "Standaardbevestigings-e-mails voor organisator uitschakelen", NDa = "Er is minstens één werkstroom actief voor dit gebeurtenistype die een e-mail naar de organisator stuurt wanneer de gebeurtenis geboekt is.", DDa = "Voeg een overschrijving toe", MDa = "Gebruikers importeren uit Google Workspace", LDa = "Google Workspace koppelen", qDa = "U moet een Google Workspace-beheerder zijn om deze functie te gebruiken", jDa = "Maak uw eerste webhook voor dit gebeurtenistype", FDa = "Maak je eerste webhook met 'Instant Meeting Created' als trigger voor dit type evenement.", VDa = "App installeren op", BDa = "Maken voor", UDa = "Valuta", WDa = "Creëer een omgeving waarin je teams gedeelde apps, workflows en afspraaktypes kunnen maken met round-robin en collectieve planning.", GDa = "Beheer organisaties met meerdere teams", HDa = "Stel uw organisatie in", KDa = "Stel je platform in", YDa = "Organisaties zijn gedeelde omgevingen waar teams gedeelde gebeurtenistypen, apps, werkstromen en meer kunnen maken.", ZDa = "Abonnementen", QDa = "Platform", JDa = "Beheer alles wat met het platform te maken heeft.", XDa = "Cal.com Platform stelt je in staat om plannen moeiteloos te integreren in je app met behulp van platform-API's en -atomen.", eMa = "U moet een organisatienaam invoeren", tMa = "U moet het e-mailadres van uw organisatie invoeren", nMa = "E-mailadres van uw organisatie", oMa = "Je beheerders e-mailadres", rMa = "Gebruikersnaam beheerder", iMa = "Organisatienaam", aMa = "Platformnaam", sMa = "Organisatie-URL", cMa = "Verifieer het e-mailadres van uw organisatie", lMa = "Gebruik de onderstaande code om uw e-mailadres te verifiëren en door te gaan met het instellen van uw organisatie.", dMa = "Extra URL-parameters", uMa = "Over uw organisatie", _Ma = "Organisaties zijn gedeelde omgevingen waar u meerdere teams met gedeelde gebeurtenistypen, apps, werkstromen en meer kunt maken.", pMa = "Maak uw teams", mMa = "Begin met samen plannen door uw teamleden aan uw organisatie toe te voegen", fMa = "Nodig uw organisatiebeheerders uit", gMa = "Deze beheerders hebben toegang tot alle teams in uw organisatie. U kunt later teambeheerders en -leden toevoegen.", hMa = "Stel een wachtwoord in", vMa = "Hierdoor wordt een nieuwe gebruikersaccount gemaakt met het e-mailadres van uw organisatie en dit wachtwoord.", bMa = "Organisatielogo", yMa = "Een paar zinnen over uw organisatie. Dit wordt weergegeven op de openbare profielpagina van uw organisatie.", $Ma = "Ik doe dit later", wMa = "Verifieer uw e-mailadres", kMa = "Voer de 6-cijferige code in die we naar {{email}} hebben gestuurd", SMa = "Verifieer uw e-mailadres om een organisatie te maken", xMa = "De opgegeven code is ongeldig, probeer het opnieuw", EMa = "Het e-mailadres wordt al gebruikt", TMa = "U bent uitgenodigd om lid te worden van {{orgName}}", AMa = "Word lid van uw team bij {{orgName}} en begin met het richten op afspraken, niet op het maken van afspraken!", CMa = "De volgende teams konden niet worden gemaakt vanwege dubbele slugs: {{slugs}}", zMa = "Teamnamen mogen niet leeg zijn", OMa = "Teamnamen mogen niet herhaald worden", PMa = "Gebruiker behoort tot een organisatie", IMa = "Deze organisatie heeft nog geen teams", RMa = "Als u een beheerder bent, zorg er dan voor dat u teams maakt die hier weergegeven worden.", NMa = "Instellen", DMa = "Mijn profiel", MMa = "Mijn instellingen", LMa = "CRM", qMa = "Berichten", jMa = "Naam of nummer weergegeven als de afzender van een sms (sommige landen staan geen alfanumerieke afzender-ID's toe)", FMa = "Alleen de beheerder van uw organisatie kan nieuwe teams maken", VMa = "Google's nieuwe spambeleid kan voorkomen dat je e-mail- en agendameldingen over deze boeking ontvangt.", BMa = "Oplossen", UMa = "Er is een fout opgetreden bij het maken van teams voor deze organisatie. Ontbrekende URL-slug.", WMa = "Link kopiëren naar organisatie", GMa = "Team: {{teamName}}", HMa = "Gebruiker: {{userName}}", KMa = "Bekijk boekingsinsights voor al uw gebeurtenissen", YMa = "Belgeschiedenis", ZMa = "Bekijk belgeschiedenis van al je Cal.ai gesprekken", QMa = "{{locationCount}} locatieopties", JMa = "Kanaaltype", XMa = "Reden van beëindiging", eLa = "Sessiestatus", tLa = "Gebruikerssentiment", nLa = "Tijd", oLa = "Van", rLa = "Aangepast abonnement", iLa = "E-mail insluiten", aLa = "Selecteer enkele beschikbare tijden en voeg ze toe aan uw e-mail", sLa = "Tijd selecteren", cLa = "Datum selecteren", lLa = "Alleen tonen als een parameter is ingesteld", dLa = "Parameter toevoegen", uLa = "We verbinden je met iemand van {{orgName}}.", _La = "Sluit of vernieuw deze pagina niet", pLa = "Bekijk alle beschikbare tijden", mLa = "bijvoorbeeld Marketingteam", fLa = "bijvoorbeeld Verkoopteam", gLa = "bijvoorbeeld Ontwerpteam", hLa = "bijvoorbeeld Engineeringteam", vLa = "bijvoorbeeld Gegevensanalyseteam", bLa = "U kunt later meer teams toevoegen.", yLa = "Waar gaat deze afspraak over?", $La = "Voeg toe aan team", wLa = "Gebruikers verwijderen uit organisatie", kLa = "Delegatiereferentie", SLa = "Met een delegatiereferentie kunt u de toegang tot Google Workspace-agenda's voor uw organisatie beheren.", xLa = "Voeg deze Client ID toe in Google Workspace met onderstaande scope", ELa = "Delegatiereferentie ingeschakeld", TLa = "Delegatiereferentie toevoegen", ALa = "Delegatiereferentie bewerken", CLa = "Domein", zLa = "Geen workspace-platforms", OLa = "Workspace-platform", PLa = "Workspace-platforms", ILa = "Beheer workspace-platforms die kunnen worden gebruikt voor delegatiereferenties", RLa = "Workspace-platform bewerken", NLa = "Serviceaccount bewerken", DLa = "Workspace-platform toevoegen", MLa = "Slug", LLa = "Serviceaccount-sleutel JSON", qLa = "Serviceaccount-sleutel JSON bewerken", jLa = "Delegatiereferentie beperkt het toevoegen van meer dan één installatie", FLa = "App succesvol geïnstalleerd en gebruikt gedelegeerde inloggegevens", VLa = "Weet u zeker dat u {{userCount}} gebruikers uit deze organisatie wilt verwijderen?", BLa = "Gebruikers uit team verwijderen", ULa = "Weet je zeker dat je {{userCount}} gebruikers uit dit team wilt verwijderen?", WLa = "Deze gebruiker heeft nog geen planningen ingesteld", GLa = "Deze gebruiker zit niet in een team", HLa = "Deze gebruiker heeft nog geen apps geïnstalleerd", KLa = "E-mailverificatie door boeker vereist", YLa = "Om te zorgen voor de e-mailverificatie door de boeker voordat gebeurtenissen worden gepland", ZLa = "Sms-berichten kunnen alleen naar deelnemers worden verzonden als het gebeurtenistype bevestiging vereist.", QLa = "Organisaties", JLa = "Upload Cal Video Logo", XLa = "Update Cal Video Logo", eqa = "Upload Banner", tqa = "Om ervoor te zorgen dat je logo zichtbaar is tegen de donkere achtergrond van Cal video, upload een lichtgekleurde afbeelding in PNG- of SVG-formaat om transparantie te behouden.", nqa = "Andere teams", oqa = "Hier kunt u teams binnen uw organisatie zien waar u geen deel van uitmaakt. U kunt uzelf aan hen toevoegen indien nodig.", rqa = "Je maakt geen deel uit van een organisatie", iqa = "Geen andere teams gevonden", aqa = "Er zijn geen andere teams binnen deze organisatie.", sqa = "Voornaam deelnemer", cqa = "Achternaam deelnemer", lqa = "De voornaam van de persoon die boekt", dqa = "De achternaam van de persoon die boekt", uqa = "Uw maandelijks overzicht", _qa = "Lidnaam", pqa = "Populairste gebeurtenissen", mqa = "Dit is uw overzicht van populaire evenementen voor uw team {{teamName}} van de afgelopen 30 dagen", fqa = "Ik", gqa = "Afspraak niet beschikbaar", hqa = "Maandelijkse overzichtsmail", vqa = "Maandelijks overzichts-e-mail voor teams", bqa = "Verifieer uw team om het versturen van berichten naar deelnemers in te schakelen", yqa = "Lid verwijderd", $qa = "Mijn beschikbaarheid", wqa = "Beschikbaarheid team", kqa = "Directe beschikbaarheid voor vergaderingen", Sqa = "Back-upcode", xqa = "Back-upcodes", Eqa = "Elke back-upcode kan slechts één keer gebruikt worden om toegang te verlenen zonder uw authenticator.", Tqa = "Back-upcodes gekopieerd!", Aqa = "De back-upcode is onjuist.", Cqa = "Toegang verloren", zqa = "Geen back-upcodes gevonden. Genereer ze in uw instellingen.", Oqa = "Nieuwe organisatie gemaakt: in afwachting van actie", Pqa = "Hallo beheerder", Iqa = "Een organisatie vereist DNS-configuratie", Rqa = 'Een organisatie met de slug "{{orgSlug}}" is gemaakt.<br /><br />Zorg ervoor dat u uw DNS-register configureert om het subdomein dat overeenkomt met de nieuwe organisatie te verwijzen naar waar de hoofd-app draait. Anders werkt de organisatie niet.<br /><br />Hier zijn slechts de basisopties om een subdomein te laten verwijzen naar de app, zodat de organisatieprofielpagina wordt geladen.<br /><br />U kunt dit doen met het A-record:', Nqa = "Of het CNAME-record:", Dqa = "Zodra u het subdomein heeft geconfigureerd, markeert u de DNS-configuratie als voltooid in Beheerdersinstellingen voor organisaties.", Mqa = "Naar Beheerdersinstellingen voor organisaties", Lqa = "Organisatie is verwerkt", qqa = "Er is een fout opgetreden bij het verwerken van deze organisatie", jqa = "Een lijst met alle organisaties. Als u een organisatie accepteert, kunnen alle gebruikers met dat e-maildomein zich aanmelden ZONDER e-mailverificatie.", Fqa = "Niet-geverifieerd", Vqa = "Geverifieerd", Bqa = "DNS ontbreekt", Uqa = "DNS Geconfigureerd", Wqa = "Markeer als DNS geconfigureerd", Gqa = "Waarde", Hqa = "Uw organisatie is bijgewerkt", Kqa = "Dit team heeft geen gebeurtenistypes", Yqa = "De plaatsoptie ondersteunt geen meerdere duren", Zqa = "Agendagebeurtenis opnemen", Qqa = "OAuth", Jqa = "OAuth-client aanmaakformulier", Xqa = "Dit is het formulier om een nieuwe OAuth-client aan te maken", e9a = "OAuth-client bewerkingsformulier", t9a = "Dit is het formulier om een bestaande OAuth-client te bewerken", n9a = "Recent toegevoegd", o9a = "Koppel al uw agenda's", r9a = "{{appName}} leest beschikbaarheid van al je bestaande agenda's.", i9a = "Personaliseer je planningservaring met workflows", a9a = "Automatisering van de werkstroom", s9a = "Plan voor je team met collectieve en round-robin planning", c9a = "Geen leden gevonden", l9a = "Mapsynchronisatie", d9a = "Directory Naam", u9a = "Directory Provider", _9a = "SCIM Basis URL", p9a = "SCIM Bearer Token", m9a = "SCIM Basis URL gekopieerd", f9a = "SCIM Bearer Token gekopieerd", g9a = "Je Identity Provider zal om de volgende informatie vragen om SCIM te configureren. Volg de instructies om de setup te voltooien.", h9a = "Configureer Directory Sync", v9a = "Kies een identity provider om de directory voor je team te configureren.", b9a = "Configureer een identity provider om te beginnen met SCIM.", y9a = "Directory sync verbinding gecreëerd.", $9a = "Voorzie en verwijder gebruikers met je directory provider.", w9a = "Directory sync verbinding verwijderd.", k9a = "Verbinding Verwijderen", S9a = "Verwijder Directory Sync Verbinding", x9a = "Weet je zeker dat je deze directory sync-verbinding wilt verwijderen?", E9a = "Deze actie kan niet ongedaan worden gemaakt. Dit zal de directory sync-verbinding permanent verwijderen.", T9a = "Gebeurtenisconfiguratie: de duur moet minimaal 1 minuut zijn.", A9a = "Beschikbaarheidsschema's", C9a = "Ongeautoriseerd", z9a = "{{clientName}} wil graag toegang tot uw {{appName}}-account", O9a = "Account of team selecteren", P9a = "Hierdoor kan {{clientName}}", I9a = "U koppelen aan uw persoonsgegevens van {{clientName}}", R9a = "Uw persoonsgegevens bekijken, waaronder alle persoonsgegevens die u openbaar heeft gemaakt", N9a = "Uw primaire e-mailadres bekijken", D9a = "Koppelen met uw geïnstalleerde apps", M9a = "Uw gebeurtenistypes lezen, bewerken en verwijderen", L9a = "Uw beschikbaarheid lezen, bewerken en verwijderen", q9a = "Uw boekingen lezen, bewerken en verwijderen", j9a = "Dit toestaan voor {{clientName}}?", F9a = "Door op Toestaan te klikken, geeft u deze app toestemming om uw gegevens te gebruiken in overeenstemming met hun gebruiksvoorwaarden en privacybeleid. U kunt de toegang verwijderen in de {{appName}} App Store.", V9a = "Toestaan", B9a = "Deze gebruiker heeft de onboarding nog niet voltooid. U kunt diens beschikbaarheid pas instellen nadat ze men de onboarding heeft voltooid.", U9a = "U bekijkt de beschikbaarheid van deze gebruiker. U kunt alleen uw eigen beschikbaarheid bewerken.", W9a = "U kunt dit per gebeurtenis overschrijven in Geavanceerde instellingen voor elk gebeurtenistype.", G9a = "Beschikbaarheid van gebruiker bewerken: {{username}}", H9a = "Uitnodiging opnieuw versturen", K9a = "De uitnodiging is opnieuw verstuurd.", Y9a = "SAML", Z9a = "Klant toevoegen", Q9a = "Na het kopiëren van het geheim kunt u het niet meer bekijken", J9a = "Nieuwe klant toevoegen", X9a = "Nieuwe gebruiker toevoegen", eja = "Deze app is nog niet ingesteld", tja = "als CSV", nja = "Mijn agenda overleggen", oja = "Door uw agenda te koppelen accepteert u ons privacybeleid en onze gebruiksvoorwaarden. U kunt de toegang op elk moment weer intrekken.", rja = "Bekijk uw agendagebeurtenissen om dubbele boekingen te voorkomen.", ija = "Deelnemen aan {{eventLocationType}}", aja = "Probleemoplossing", sja = "Agenda's die we controleren op conflicten", cja = "Beschikbaarheidsroosters", lja = "Kalenders beheren", dja = "Beschikbaarheidsroosters beheren", uja = "Vergrendeld", _ja = "Ontgrendeld", pja = "Tijdzone vergrendelen op boekingspagina", mja = "Om de tijdzone op de boekingspagina te vergrendelen, handig voor persoonlijke gebeurtenissen.", fja = "Je kunt slechts één betalingsapp per evenementtype inschakelen.", gja = "Voer het nummer in internationaal formaat in.", hja = "Kalender installeren", vja = "Gemerkt subdomein", bja = "Krijg je eigen gemerkte subdomein, zoals acme.cal.com", yja = "Inzichten voor de hele organisatie", $ja = "Begrijp hoe je hele organisatie tijd besteedt", wja = "Speciale onboarding en technische ondersteuning", kja = "Pas je planningservaring aan met je eigen logo, kleuren en meer", Sja = "Onbeperkte teams", xja = "E-mail verifiëren", Eja = "Voer het e-mailadres in dat voor deze boeking is gebruikt om door te gaan met annulering", Tja = "E-mail komt niet overeen met het e-mailadres van de boeking", Aja = "Voeg zoveel subteams toe als je nodig hebt voor je organisatie", Cja = "Gecombineerde facturering", zja = "Geavanceerde beheerde evenementtypes", Oja = "Voeg een enkele creditcard toe om voor alle abonnementen van je team te betalen", Pja = "Onderneming", Ija = "Upgrade naar Enterprise om je Organisatie te creëren", Rja = "Creëer je Organisatie", Nja = "Organisatie aanmaken", Dja = "Upgrade naar Organisaties en ontvang een subdomein, uniforme facturering, inzichten, uitgebreide whitelabeling en meer", Mja = "Upgrade naar Enterprise en krijg toegang tot Active Directory Sync, SCIM Automatische Gebruikersprovisioning, Cal.ai Voice Agents, Admin API's en meer!", Lja = "Je kunt slechts één betalingsapp per evenementtype inschakelen", qja = "Teams die lid zijn van deze organisatie worden ook verwijderd samen met hun afspraaktypes", jja = "Gebruikers die deel uitmaakten van de organisatie worden niet verwijderd, maar hun gebruikersnamen worden gewijzigd zodat ze buiten de organisatie kunnen bestaan", Fja = "Gebruikersafspraaktypes die zijn aangemaakt nadat de gebruiker in de organisatie zat, worden verwijderd", Vja = "Gemigreerde gebruikersafspraaktypes worden niet verwijderd", Bja = "{{organizationName}} verwijderen?", Uja = "Gepubliceerd", Wja = "Niet gepubliceerd", Gja = "Publiceren", Hja = "Open de probleemoplosser en ontdek wat er mis is met je schema", Kja = "Hulp nodig?", Yja = "Probleemoplosser", Zja = "Te bellen nummer", Qja = "Naam gast", Jja = "E-mail gast", Xja = "Bedrijf gast", eFa = "Installeer een kalender", tFa = "Direct boeken", nFa = "Laat mensen direct boeken", oFa = "Upgrade naar Enterprise en laat gasten deelnemen aan een direct gesprek waar deelnemers meteen in kunnen springen. Dit is alleen voor team evenementtypes", rFa = "Wil je niet wachten?", iFa = "Vergadering gestart", aFa = "Betalen om te boeken", sFa = "Laat AI-agenten voor je boeken", cFa = "Boeking niet gevonden", lFa = "Boekingsplaatsen zijn vol", dFa = "Ontbrekende betalingsgegevens", uFa = "Ontbrekende betalingsapp-id", _Fa = "Niet genoeg beschikbare plaatsen voor de boeking", pFa = "{{username}} is momenteel even weg.", mFa = "In de tussentijd zal {{profile.username}} alle nieuwe geplande vergaderingen namens {{username}} beheren.", fFa = "Afwezig", gFa = "Laat je boekers weten wanneer je afwezig bent.", hFa = "Verzoek versturen", vFa = "Startdatum en einddatum zijn vereist", bFa = "Startdatum moet voor de einddatum liggen", yFa = "Startdatum moet in de toekomst liggen", $Fa = "Gebruiker niet gevonden", wFa = "Kan niet naar zichzelf doorverwijzen", kFa = "Afwezigheidsvermelding bestaat al", SFa = "Afwezigheidsvermelding-id vereist", xFa = "Er is al een boekingsomleiding van die gebruiker naar jou.", EFa = "Nieuwe vermelding succesvol aangemaakt", TFa = "Boekingsomleidingsmelding", AFa = "Boekingsomleidingsmelding", CFa = "Je hebt een boekingsomleiding ontvangen van {{eventOwner}}, zodat hun profielkoppelingen naar die van jou worden omgeleid voor de tijdsperiode {{dates}}.", zFa = "Melding van wijziging in boekingsomleiding", OFa = "Melding van Wijziging in Boekingsomleiding", PFa = "Je boekingsomleiding van {{eventOwner}} voor de tijdsperiode {{oldDates}} is bijgewerkt. De nieuwe tijdsperiode voor de omleiding is {{dates}}.", IFa = "Melding van annulering van boekingsomleiding", RFa = "Melding van Annulering van Boekingsomleiding", NFa = "Je boekingsomleiding van {{eventOwner}} voor de tijdsperiode {{dates}} is geannuleerd.", DFa = "Je hebt dit boekingsomleidingsverzoek geaccepteerd.", MFa = "Je hebt dit boekingsomleidingsverzoek afgewezen.", LFa = "Kopieer link om verzoek te delen", qFa = "Verzoek om omleiding van boeking", jFa = "Selecteer teamlid", FFa = "Gaat u weg? Markeer eenvoudig uw profiel als niet beschikbaar voor een bepaalde periode.", VFa = "Geef een link naar een teamlid wanneer u afwezig bent", BFa = "Geef een link naar een teamlid wanneer u afwezig bent (Teamplan vereist)", UFa = "Lijst van onbeschikbaarheid buiten kantoor", WFa = "Invoer succesvol verwijderd", GFa = "Inschrijving succesvol bewerkt", HFa = "Tijdelijk afwezig?", KFa = "Voeg een omleiding toe", YFa = "Invoer maken", ZFa = "Tijdsbereik", QFa = "Voeg alle teamleden toe, inclusief toekomstige leden", JFa = "Omleiden naar", XFa = "Moeite met het vinden van een tijd?", e8a = "Meer weergeven", t8a = "Stuur parameters door zoals ?email=...&name=... en meer", n8a = "Plan vergaderingen wanneer iedereen beschikbaar is of roteer door teamleden", o8a = "laagste", r8a = "laag", i8a = "gemiddeld", a8a = "hoog", s8a = "hoogste", c8a = "Stuur boeker naar", l8a = "Stel prioriteit in", d8a = "Stel gewicht in", u8a = "Schakel gewichten in", _8a = "Prioriteit voor {{userName}}", p8a = "Gewichten bepalen hoe afspraken worden verdeeld onder hosts. <0>Meer informatie</0>", m8a = "Gewicht voor {{userName}}", f8a = "prioriteit wijzigen", g8a = "Gebruik veldidentificatoren als variabelen voor je aangepaste evenementomleiding", h8a = "Gebruik veldidentificatoren als variabelen voor je aangepaste evenementomleiding (bijv. {{variable}})", v8a = "Account is al gekoppeld", b8a = "E-mail versturen", y8a = "Bel deelnemer met Cal.ai spraakassistent", $8a = "Bel om boeking te bevestigen", w8a = "2 uur voor aanvang van het evenement", k8a = "Cal.ai agent configuratie", S8a = "Kies ten minste één evenementtype om een testgesprek te maken.", x8a = "Markeren als no-show", E8a = "No-show markering verwijderen", T8a = "Account succesvol ontkoppeld", A8a = "Er is een fout opgetreden bij het ontkoppelen van het account", C8a = "Reisschema", z8a = "Plan je reis van tevoren om je bestaande schema in een andere tijdzone te behouden en te voorkomen dat je midden in de nacht wordt geboekt.", O8a = "Wijziging tijdzone plannen", P8a = "Datum", I8a = "Voer de algemene prompt voor de agent in", R8a = "Dit overlapt met een bestaand schema. Kies een andere datum.", N8a = "Ontvang meldingen wanneer je team geen beschikbaarheid heeft", D8a = "Beheerders ontvangen e-mailmeldingen wanneer een gebruiker probeert een teamlid te boeken en wordt geconfronteerd met 'Geen beschikbaarheid'. We sturen deze e-mail na twee voorvallen en herinneren je elke 7 dagen per gebruiker.", M8a = "SMS-meldingen uitschakelen voor alleen-telefoon evenementtypes", L8a = "Schakel geautomatiseerde SMS-meldingen uit voor evenementtypes die alleen telefoonnummer (attendeePhoneNumber) als verplichte vraag hebben met e-mail als optioneel of niet vereist", q8a = "Uw huidige plan", j8a = "$37 per gebruiker per maand", F8a = "Beheer privacy-instellingen voor uw organisatie", V8a = "Privacy", B8a = "Nieuwe teams vallen onder uw organisatie", U8a = "Groepsnaam toevoegen", W8a = "Groepsnaam", G8a = "Routers", H8a = "Primair", K8a = "Maak primair", Y8a = "E-mailadres toevoegen", Z8a = "E-mailadressen toevoegen", Q8a = "Voeg een e-mailadres toe om uw primaire te vervangen of als alternatief e-mailadres voor uw evenementtypes te gebruiken.", J8a = "Bevestig uw e-mailadres", X8a = "$t(hey_there) {{name}}, bevestiging van je boeking op {{date}}.", e7a = "De voornaam van de persoon die boekt", t7a = "De achternaam van de persoon die boekt", n7a = "Naam van de planner", o7a = "Uw voornaam", r7a = "We hebben een e-mail gestuurd naar <strong>{{email}}</strong>. Klik op de link in de e-mail om dit adres te verifiëren.", i7a = "Stuur evenementdetails naar", a7a = "Plan tijdzone zonder einddatum", s7a = "Selecteer leden", c7a = "Wat moeten we doen met de bestaande evenementtypes van uw lid?", l7a = "Alle individuele evenementtypen van uw leden (behalve beheerde) worden permanent verwijderd. Ze zullen geen nieuwe kunnen aanmaken.", d7a = "De individuele evenementtypen van uw leden worden verborgen (behalve beheerde) van profielen, maar de links blijven actief. Ze zullen geen nieuwe kunnen aanmaken.", u7a = "Verberg individuele evenementtypen", _7a = "Verwijder individuele evenementtypen", p7a = "Blokkeer het aanmaken van individuele evenementtypen", m7a = "Voorkom dat leden hun eigen evenementtypen aanmaken.", f7a = "Toevoegen aan evenementtype", g7a = "Maak een accountwachtwoord aan", h7a = "Account aanmaken met SAML", v7a = "Het aanmaken van een accountwachtwoord is mislukt", b7a = "Kan geen accountwachtwoord aanmaken voor cal-accounts", y7a = "Kan geen accountwachtwoord aanmaken voor reeds bestaande accounts", $7a = "U heeft geen accountwachtwoord, maak er een aan door naar Beveiliging -> Wachtwoord te navigeren. U kunt niet loskoppelen totdat een accountwachtwoord is aangemaakt.", w7a = "Koppel verbonden account los", k7a = "Het loskoppelen van uw verbonden account zal de manier waarop u inlogt veranderen. U kunt alleen inloggen met e-mail + wachtwoord.", S7a = "Ik ga akkoord met het privacybeleid en het gebruik van cookies", x7a = "Bel", E7a = "Sla round robin-toewijzing over als contact in Salesforce bestaat", T7a = "URL moet het e-mailadres van de contactpersoon als parameter bevatten, bijv. ?email=contactEmail", A7a = "Selecteer Account", C7a = "Installeer {{appName}} op uw persoonlijke account of op een teamaccount.", z7a = "Selecteer Evenementtypen", O7a = "Op welk evenementtype wilt u {{appName}} installeren?", P7a = "Configureer {{appName}}", I7a = "Rond de app-configuratie af. Je kunt deze instellingen later wijzigen.", R7a = "al geïnstalleerd", N7a = "Niet gespecificeerd", D7a = "Vakantie", M7a = "Reis", L7a = "Ziekteverlof", q7a = "Feestdag", j7a = "Doorsturen naar <0>{{username}}</0>", F7a = "Geen doorgifte", V7a = "Maak een OOO", B7a = "Communiceer aan je boekers wanneer je niet beschikbaar bent voor boekingen. Ze kunnen je nog steeds boeken na je terugkeer of je kunt ze doorsturen naar een teamlid.", U7a = "{{displayName}} is OOO", W7a = "<0>{{displayName}}</0> kan hun vergaderingen aannemen terwijl ze weg zijn.", G7a = "Boek {{displayName}}", H7a = "Selecteer reden", K7a = "Ga Out of Office", Y7a = "Bewerk Afwezigheidsmelding", Z7a = "Feedback indienen", Q7a = "Je gastheer is niet komen opdagen", J7a = "Je kunt een andere vergadering met hen plannen", X7a = "Hoe kunnen we onze service verbeteren?", eVa = "Wat vond je het leukst?", tVa = "Beoordeling", nVa = "Beoordeeld", oVa = "Niet beoordeeld", rVa = "Beoordelings-url", iVa = "De URL voor het feedbackformulier voor beoordelingen", aVa = "No-show url", sVa = "De URL voor No Show Feedback", cVa = "Geen ondersteuning nodig?", lVa = "Ondersteuning verbergen", dVa = "Gemiddelde beoordelingen", uVa = "No-show (host)", _Va = "No-show (gast)", pVa = "Recente beoordelingen", mVa = "Geen beoordelingen ingediend", fVa = "Voeg een workflow met 'Beoordeling' toe om beoordelingen na vergaderingen te verzamelen", gVa = "Meeste no-shows", hVa = "Hoogst beoordeeld", vVa = "Laagst beoordeeld", bVa = "Leden met de hoogste beoordeelde vergaderingen", yVa = "Leden met de laagste beoordeelde vergaderingen", $Va = "CSAT-score", wVa = "Vergrendelde SMS", kVa = "Vertrekken zonder iemand toe te wijzen?", SVa = "Weet je zeker dat je dit evenement wilt verlaten zonder deelnemers toe te voegen?", xVa = "Als je niemand toewijst voor dit evenement, zal er geen beschikbaarheid worden getoond aan boekers.", EVa = "Ga terug en wijs toe", TVa = "Vertrekken zonder toe te wijzen", AVa = "Door verder te gaan, ga je akkoord met onze <0>Voorwaarden</0> en <1>Privacybeleid</1>.", CVa = "Door verder te gaan ga je akkoord met onze", zVa = "Voorwaarden", OVa = "Altijd {{x}} dagen beschikbaar", PVa = "Verplaatst het {{x}}-daagse boekingsvenster elke dag automatisch vooruit, zodat je agenda altijd de komende {{x}} dagen aan beschikbare tijdslots toont.", IVa = "Teamabonnement succesvol opgezegd", RVa = "Fout bij het opzeggen van het teamabonnement", NVa = "Er is een fout opgetreden bij het proberen te abonneren op het platformplan, probeer het later opnieuw", DVa = "Er is een fout opgetreden bij het bijwerken van de OAuth-client, probeer het later opnieuw", MVa = "Er is een fout opgetreden bij het aanmaken van de OAuth-client, probeer het later opnieuw", LVa = "Kleur van evenementtype", qVa = "Dit wordt alleen gebruikt voor het onderscheiden van evenementtypes en boekingen binnen de app. Het wordt niet getoond aan boekers.", jVa = "Markeren als no-show", FVa = "{{x}} gemarkeerd als no-show", VVa = "{{x}} niet langer gemarkeerd als no-show", BVa = "triggers voor alle evenementtypes van het team en persoonlijke evenementtypes van alle teamleden", UVa = "Beheer instellingen voor je team", WVa = "No-show status bijgewerkt voor deelnemers", GVa = "E-mail gekopieerd", HVa = "Telefoonnummer gekopieerd", KVa = "Gebruiker is een in afwachting zijnd lid van de organisatie", YVa = "Gebruiker is al uitgenodigd of een lid", ZVa = "Gebruiker is lid van een organisatie waar dit team geen deel van uitmaakt.", QVa = "Boeking is opnieuw toegewezen", JVa = "Opnieuw toewijzen", XVa = "Boeking opnieuw toewijzen aan een andere beschikbare round robin host", eBa = "Teamlid toewijzen", tBa = "Overschrijf welk teamlid je wilt toewijzen.", nBa = "Geen beschikbare hosts", oBa = "Round robin host opnieuw toewijzen", rBa = "Niet naar de ICS-feed schrijven", iBa = "Herschikken is niet mogelijk omdat het evenement is verlopen", aBa = "Dit evenement is verlopen", sBa = "Contacten overslaan als ze niet bestaan in {{appName}}", cBa = "Als je ICS-link alleen-lezen is (bijv. Proton Calendar), vink het vakje hierboven aan om fouten te voorkomen. Je moet je agenda handmatig bijwerken voor wijzigingen.", lBa = "Attributen", dBa = "Nieuw attribuut", uBa = "Attributen toevoegen", _Ba = "Voeg attributen toe aan je teamleden", pBa = "Nieuwe optie", mBa = "Lid bijwerken", fBa = "Kenmerk", gBa = "Maak een kenmerk aan voor je teamleden", hBa = "Bewerk een kenmerk voor je teamleden", vBa = "Attribuut succesvol bijgewerkt", bBa = "Attribuut succesvol verwijderd", yBa = "Attributen succesvol bewerkt", $Ba = "Beheer attributen voor je teamleden", wBa = "Bewerk attributen voor je teamleden", kBa = "Terug naar attributen", SBa = "Weet je zeker dat je deze optie wilt verwijderen?", xBa = "Deze optie is toegewezen aan {{numberOfUsers}} leden. Het verwijderen ervan zal het uit hun profiel verwijderen.", EBa = "Schakel standaard e-mails naar deelnemers uit met betrekking tot dit type evenement", TBa = "Schakelt standaard e-mailcommunicatie uit met betrekking tot dit type evenement, inclusief boekingsbevestigingen, herinneringen en annuleringen.", ABa = "Schakel standaard e-mails naar hosts uit met betrekking tot dit type evenement", CBa = "Typ bevestigen om door te gaan", zBa = "E-mail uitschakelen", OBa = "Geef Admin API-toegang", PBa = "Admin API-toegang intrekken", IBa = "Voeg {{calendar}} kalender toe", RBa = "Apple Agenda verbinden", NBa = "Verbonden Apple Agenda", DBa = "Apple Agenda controleren", MBa = "Google Agenda verbinden", LBa = "Verbonden Google Agenda", qBa = "Google Agenda controleren", jBa = "Outlook Agenda verbinden", FBa = "Verbonden Outlook-agenda", VBa = "Outlook-agenda controleren", BBa = "Verbinden met Stripe", UBa = "Stripe verbonden", WBa = "Stripe-gegevens controleren", GBa = "Variabelen voor boekingsvraagreacties", HBa = "Beheerd door {{teamAdmins}}", KBa = "{{count}} opties", YBa = "Opnieuw plannen met dezelfde Round-Robin host", ZBa = "Opnieuw geplande evenementen worden toegewezen aan dezelfde host als oorspronkelijk gepland", QBa = "Invoer uitschakelen als de URL-identificatie vooraf is ingevuld", JBa = "Boekingslimieten", XBa = "Boekingslimieten voor teamleden voor alle soorten teamevenementen", eUa = "Beperk hoe vaak leden kunnen worden geboekt voor alle team evenementtypen", tUa = "Boekingslimieten succesvol bijgewerkt", nUa = "U bent niet gemachtigd om deze wijziging in de boeking aan te brengen", oUa = "Delegatiereferentie uitgeschakeld", rUa = "Overeenkomende leden", iUa = "{{x}} overeenkomende leden", aUa = "Wachtrij voor overeenkomende leden (op basis van kenmerkengewicht)", sUa = "Wachtrij voor overeenkomende leden (op basis van toewijzingsgewicht)", cUa = "Geen overeenkomende leden. Er wordt teruggevallen op de teamleden die aan het type evenement zijn toegewezen.", lUa = "Geen overeenkomende leden. Er wordt teruggevallen op de teamleden die aan het evenementtype zijn toegewezen. Overweeg een fallback toe te voegen of de logica van using_fallback_members te corrigeren", dUa = "Verberg details van kalendergebeurtenissen op gedeelde kalenders", uUa = "Wanneer een kalender wordt gedeeld, zijn gebeurtenissen zichtbaar voor lezers, maar hun details zijn verborgen voor degenen zonder schrijfrechten.", _Ua = "Laatste {{count}} dagen", pUa = "Maand tot nu toe", mUa = "Jaar tot nu toe", fUa = "Aangepaste periode", gUa = "Restitutiebeleid", hUa = "Altijd", vUa = "Nooit", bUa = "Betalingsoptie", yUa = "Indien geannuleerd", $Ua = "voor", wUa = "Toon alle kolommen", kUa = "Kolommen wisselen", SUa = "Geen kolommen gevonden", xUa = "Bij boeking, voeg evenementen toe en nieuwe deelnemers als:", EUa = "Lead", TUa = "Contact onder een account", AUa = "Sla het aanmaken van {{entry}} record over als deze niet in Salesforce bestaat", CUa = "Als de contactpersoon niet onder een account bestaat, maak een nieuwe lead van de deelnemer", zUa = "Maak een nieuw contact onder een account op basis van het e-maildomein van de deelnemer en bestaande contacten", OUa = "Eigenaar van record wijzigen bij boeking", PUa = "Attribuuttoewijzing in bulk", IUa = "Dit resulteert in het tonen van een aangepast bericht. Probeer het antwoord te wijzigen om naar een evenement te routeren", RUa = "Dit resulteert in een doorverwijzing naar {{externalUrl}}. Probeer het antwoord te wijzigen om naar een evenement te routeren", NUa = "Mogelijke host", DUa = "Huidige routeringsstatus", MUa = "Boeking omleiden", LUa = "Leid de boeking om naar verschillende teamleden", qUa = "Nieuwe route verifiëren", jUa = "Omleiden", FUa = "Nieuwe routeringsstatus", VUa = "Als de deelnemer in Salesforce bestaat, boek direct met de eigenaar", BUa = "Entiteit om eigenaar van te controleren voor directe boeking", UUa = "Account", WUa = "Kies hostschema's", GUa = "U kunt een ander schema selecteren voor elke host. Standaard is het standaardschema van elke host geselecteerd.", HUa = "Geen hosts toegewezen, voeg hosts toe in het toewijzingstabblad.", KUa = "Handmatig round robin host opnieuw toewijzen", YUa = "Wijs handmatig een round robin host opnieuw toe aan een andere beschikbare host", ZUa = "Wijs round robin host opnieuw toe aan een andere beschikbare host", QUa = "Nieuwe gebruiker is geen geldige round robin host voor dit afspraaktype", JUa = "Nieuwe gebruiker is een vaste host voor dit afspraaktype", XUa = "Opnieuw plannen met hetzelfde tijdslot", eWa = "Opnieuw plannen met hetzelfde tijdslot van het nieuwe evenement", tWa = "Opnieuw plannen naar het nieuwe evenement met een ander tijdslot", nWa = "Opnieuw plannen met een ander tijdslot", oWa = "We hebben geen ID voor het nieuwe evenement. Ga naar het Routeringsformulier en sla het opnieuw op.", rWa = "Boeking succesvol omgeleid. U wordt doorgestuurd naar de boekingspagina", iWa = "Bij boeking, schrijf naar event object", aWa = "Veldnaam", sWa = "Nieuw veld toevoegen", cWa = "Je hebt geen toegang om deze boeking om te leiden", lWa = "Formulierreactie niet gevonden", dWa = "Contacteigenaar", uWa = "Niet gevonden", _Wa = "Gebruik van fallback-leden", pWa = "Gekozen route", mWa = "Attribuutlogica komt overeen", fWa = "Attribuutlogica fallback komt overeen", gWa = "Alle toegewezen leden van het team-evenementtype. Overweeg enkele attribuutregels toe te voegen.", hWa = "Alle toegewezen leden van het team-evenementtype. Overweeg enkele attribuutregels toe te voegen aan de fallback.", vWa = "Alle toegewezen leden van het team-evenementtype. Overweeg de fallback aan te passen om een match te krijgen.", bWa = "Waarschuwing", yWa = "Fallback: Als er geen teamleden overeenkomen, gebruik dan degenen die aan de volgende criteria voldoen (standaard alle toegewezen teamleden van het evenement)", $Wa = "Fallback-waarschuwing", wWa = "Niet nodig", kWa = "Host niet beschikbaar", SWa = "Host beschikbaar", xWa = "Weet je zeker dat je deze boeking wilt toewijzen aan een niet-beschikbare host?", EWa = "Weet je zeker dat je deze boeking opnieuw wilt toewijzen?", TWa = "Ja, opnieuw toewijzen", AWa = "Filteren op kenmerken", CWa = "Reden voor opnieuw toewijzen", zWa = "Het wijzigen van het veldtype kan gegevensverlies veroorzaken. Maak in plaats daarvan een nieuw veld aan.", OWa = "Opnieuw toegewezen door", PWa = "rij", IWa = "rijen", RWa = "Tijdzone deelnemer", NWa = "Starttijd evenement in tijdzone deelnemer", DWa = "Starttijd evenement in tijdzone deelnemer", MWa = "Eindtijd evenement in tijdzone deelnemer", LWa = "Eindtijd evenement in tijdzone deelnemer", qWa = "Maak een evenement aan op het contact, indien aanwezig. Anders terugvallen op lead", jWa = "Eigenaarsnaam om te wijzigen", FWa = "Geen filter ingesteld", VWa = "Boeking test succesvol", BWa = "De testrun is succesvol afgerond.", UWa = "Je hebt geen toegang tot deze pagina", WWa = "Om deze pagina te bekijken of ermee te communiceren, moet je over admin- of eigenaarsrechten beschikken", GWa = "Veldtype", HWa = "Wanneer schrijven", KWa = "Bij boeking, schrijf naar een aangepast veld op het {{record}}-record van de deelnemer", YWa = "Bij elke boeking", ZWa = "Alleen als het veld leeg is", QWa = "Startdatum boeking", JWa = "Aanmaakdatum boeking", XWa = "Boeking opnieuw toegewezen aan {{host}}", eGa = "Geen contacteigenaar", tGa = "Routeringsformulieren aangemaakt", nGa = "Totaal aantal reacties", oGa = "Totaal aantal reacties zonder boeking", rGa = "Totaal aantal reacties met boeking", iGa = "Geen boekingen", aGa = "Formuliernaam", sGa = "Boeking", cGa = "Geen boeking", lGa = "Geboekt door", dGa = "Aangemaakt op", uGa = "Boekingsstatus", _Ga = "Geboekt op", pGa = "Ingediend op", mGa = "Kopieer doorverwijzings-URL", fGa = "Doorverwijzings-URL bij afsluiten", gGa = "Totaal aantal boekingen per periode", hGa = "Doorverwezen naar per periode", vGa = "Per dag", bGa = "Per week", yGa = "Per maand", $Ga = "Toewijzingsreden", wGa = "Toegang geweigerd", kGa = "Contacteigenaar zal de Round Robin host zijn indien beschikbaar", SGa = "Nieuwe deelnemers toevoegen als", xGa = "Contacteigenaar wordt niet geforceerd (kan nog steeds host zijn als het overeenkomt met de attributen en Round Robin criteria)", EGa = "Routeer naar een gebruiker die overeenkomt met een zoekveld op een account", TGa = "Salesforce-optie", AGa = "Zoekveldnaam", CGa = "Als de deelnemer een gratis e-maildomein heeft, sla dan de eigendomscontrole over en gebruik round robin zoals normaal", zGa = "Is", OGa = "Is niet", PGa = "Bevat", IGa = "Bevat niet", RGa = "Begint met", NGa = "Eindigt met", DGa = "Is leeg", MGa = "Is niet leeg", LGa = "Titel en beschrijving automatisch vertalen", qGa = "Titels en beschrijvingen automatisch vertalen naar de browsertaal van de bezoeker met behulp van AI.", jGa = "Distributie", FGa = "Maakt het mogelijk om de distributie te optimaliseren voor maximale beschikbaarheid of voor een meer gebalanceerde toewijzing.", VGa = "Maximale beschikbaarheid", BGa = "Stelt boekers in staat om afspraken te maken wanneer een host beschikbaar is. Gebruik dit om het aantal potentiële afspraken te maximaliseren en wanneer de gelijke verdeling van afspraken over hosts minder belangrijk is.", UGa = "Evenredige verdeling", WGa = "We monitoren hoeveel boekingen er bij elke host zijn gemaakt en vergelijken dit met anderen. Hosts die te ver voorlopen worden tijdelijk uitgeschakeld zodat boekingen gelijkmatig worden verdeeld.", GGa = "Gewichten bewerken", HGa = "Gewichten succesvol bijgewerkt", KGa = "Vereist alleen bevestiging voor gratis e-mailproviders (bijv. @gmail.com, @outlook.com)", YGa = "E-mailadressen uitsluiten die ... bevatten", ZGa = "E-mailadressen moeten bevatten ...", QGa = "Voer een geldig zakelijk e-mailadres in", JGa = "Je mag niet boeken met dit e-maildomein. Neem contact op met de eigenaar van deze link.", XGa = "Kolommen zoeken", eHa = "Zoekopties", tHa = "Openbaar organisatieprofiel uitschakelen en doorverwijzen", nHa = "Verwijst {{orgSlug}}.cal.com door naar {{destination}}", oHa = "Enkele selectie", rHa = "Meervoudige selectie", iHa = "Agenda-conflictinstellingen", aHa = "Selecteer welke agenda's gecontroleerd moeten worden op conflicten", sHa = "Groepsbijeenkomst", cHa = "Weet u zeker dat u deze app wilt verwijderen van", lHa = "App ontkoppelen van", dHa = "Maak geen nieuwe records aan voor gasten die aan de boeking zijn toegevoegd", uHa = "Google Meet", _Ha = "Zoom", pHa = "MS Teams Video", mHa = "Vergrendelen voor toewijzing", fHa = "Vergrendeling staat alleen toewijzingen toe via Directory Sync", gHa = "Attribuut succesvol bewerkt", hHa = "Nieuwe groepsoptie", vHa = "Gewichten ingeschakeld", bHa = "Door gewichten in te schakelen is het mogelijk om een hogere prioriteit toe te kennen aan bepaalde attributen per gebruiker. Hoe hoger het gewicht, hoe hoger de prioriteit.", yHa = "Doorgestuurd", $Ha = "Opnieuw toegewezen", wHa = "Sta het verzetten van afgelopen afspraken toe", kHa = "Door deze optie in te schakelen kunnen afgelopen afspraken worden verzet", SHa = "Omgeleid", xHa = "Salesforce toewijzing", EHa = "Router positie", THa = "Toon overeenkomende hosts", AHa = "Geen actieve wachtrijen voor deze invoer", CHa = "Gewicht", zHa = "Kalibratie", OHa = "Tekort", PHa = "Routeringsformulier", IHa = "Ga terug en sla op", RHa = "Wijzigingen opslaan", NHa = "Verlaten zonder opslaan", DHa = "Weet je zeker dat je wilt verlaten zonder de wijzigingen in je routeringsformulier op te slaan?", MHa = "Er is iets onverwachts gebeurd", LHa = "Je doet een testboeking.", qHa = "Icoon overzicht", jHa = "Iconen overzicht", FHa = "Migreren van team", VHa = "Functie is momenteel uitgeschakeld", BHa = "Kies een optie", UHa = "Voer optiewaarde in", WHa = "Optie verwijderen", GHa = "Gebruik attribuutgewichten", HHa = "Indien ingeschakeld worden alle gewichten binnen het afspraaktype genegeerd", KHa = "Attribuut voor gewichten", YHa = "Beheerde gebruikers", ZHa = "Bekijk alle beheerde gebruikers die zijn aangemaakt door je OAuth-client", QHa = "Kun je me vertellen over ", JHa = "Gebruik AI om je vragen te beantwoorden", XHa = "Fout bij het ophalen van het antwoord ", eKa = "Er is een onverwachte fout opgetreden. Probeer het later opnieuw", tKa = "Selecteer OAuth-client", nKa = "Op elke instantie", oKa = "De functie voor delegatiereferenties is niet ingeschakeld voor uw organisatie", rKa = "Interne notitie", iKa = "Reden gedeeld met klant (optioneel)", aKa = "Deze notitie is alleen zichtbaar voor leden van je team", sKa = "Voorinstellingen voor interne annuleringsnotities", cKa = "Maak voorinstellingen voor interne notities die kunnen worden toegepast op boekingen", lKa = "Voorinstellingen voor interne notities zijn succesvol bijgewerkt", dKa = "Voorinstelling toevoegen", uKa = "Autoriseren", _Ka = "Volgende", pKa = "Verbergen", mKa = "Tonen", fKa = "UTM-parameters", gKa = "Geen UTM-parameters beschikbaar.", hKa = "Oplopend", vKa = "Aflopend", bKa = "Verifieer e-mailwijziging", yKa = "Credits kopen", $Ka = "Credits", wKa = "Gebruikte credits", kKa = "Totaal resterend", SKa = "Je ontvangt 1000 credits per maand, per teamlid", xKa = "Je ontvangt 750 credits per maand, per teamlid", EKa = "Bekijk en beheer credits voor het versturen van sms-berichten", TKa = "Bekijk en beheer credits voor het versturen van SMS-berichten. Eén credit is 1¢ (USD) waard. <0>Meer informatie</0>", AKa = "Eén credit is 1¢ (USD) waard. <0>Meer informatie</0>", CKa = "Extra credits kopen ($0.01 per credit)", zKa = "Je kunt extra credituitgaven bekijken in je uitgavenlogboek", OKa = "Overzicht", PKa = "Organisatie-slug is al in gebruik", IKa = "Je kunt geen organisatie aanmaken omdat je al deel uitmaakt van een organisatie", RKa = "Je moet de gebruikers-onboarding voltooien voordat je een organisatie kunt aanmaken", NKa = "Gebruik een bedrijfse-mail om een organisatie aan te maken", DKa = "Je kunt geen platformorganisatie aanmaken omdat je al deel uitmaakt van een team", MKa = "Je moet minimaal gepubliceerde teams hebben", LKa = "Je maakt al deel uit van deze organisatie", qKa = "Je maakt deel uit van een andere organisatie, kan geen nieuwe organisatie aanmaken", jKa = "Je maakt deel uit van een andere platformorganisatie, kan geen nieuwe organisatie aanmaken", FKa = "Organisatiebetaling geslaagd", VKa = "Je organisatie is succesvol aangemaakt", BKa = "Dit kan een paar seconden duren...", UKa = "Status organisatie-onboarding", WKa = "Beschrijving status organisatie-onboarding", GKa = "Betaling mislukt", HKa = "Je betaling is mislukt. Probeer het opnieuw.", KKa = "Je organisatie wordt aangemaakt", YKa = "Organisatie-onboarding al voltooid", ZKa = "Organisatie-onboarding bestaat al", QKa = "Organisatie-onboarding niet gevonden", JKa = "Betaling geslaagd!", XKa = "Overdracht onboarding", eYa = "Overdracht onboarding aan de gebruiker", tYa = "Er bestaat al een organisatie met deze slug", nYa = "Je hebt geen toestemming om een organisatie aan te maken voor dit e-mailadres", oYa = "Je hebt geen toestemming om een of meer teams te migreren", rYa = "De organisatie heeft al een abonnement", iYa = "Reset-interval voor gewogen Round Robin", aYa = "Interval", sYa = "Bepaalt hoe vaak de round robin boekingstelling wordt gereset om een evenwichtige verdeling te garanderen.", cYa = "Dagelijks", lYa = "U heeft geen einddatum ingesteld voor uw OOO", dYa = "Mijn OOO", uYa = "Team OOO", _Ya = "Beheer de OOO van uw team.", pYa = "Out of Office aanmaken", mYa = "Maak een OOO aan voor een teamlid", fYa = "Bewerk een OOO voor een teamlid", gYa = "Maak OOO aan voor uw team", hYa = "Communiceer naar boekers wanneer uw teamleden niet beschikbaar zijn voor boekingen. Ze kunnen nog steeds geboekt worden bij hun terugkeer of u kunt ze doorverwijzen naar een ander teamlid.", vYa = "OOO-doorverwijzing is alleen toegestaan naar een lid van hetzelfde team.", bYa = "Er is al een omgekeerde doorverwijzing tussen deze gebruikers.", yYa = "Geen eerdere OOO gevonden", $Ya = "Vorige", wYa = "Round Robin-interval succesvol bijgewerkt", kYa = "Proefmodus", SYa = "Inactief teamabonnement", xYa = "Uw teamabonnement is inactief. Controleer uw abonnement of neem contact op met de klantenondersteuning", EYa = "Beperkte toegang tijdens proefperiode. Functie beschikbaar na afloop van de proefperiode.", TYa = "Verwijzingsprogramma", AYa = "Verdien 20% verwijzingsbonus", CYa = "Je hebt een Dub API-sleutel en programma-ID nodig om deze pagina te gebruiken.", zYa = "UID", OYa = "Link", PYa = "rijen per pagina", IYa = "{{currentRange}} van {{totalItems}}", RYa = "Tip: Je kunt een '+' tussen gebruikersnamen toevoegen: cal.com/anna+brian om een dynamische groepsbijeenkomst te maken", NYa = "U heeft nog geen team", DYa = "U heeft nog geen teamleden", MYa = "Terugkerend evenement ondersteunt geen stoelfunctie. Maak het niet-terugkerend om stoelen in te schakelen.", LYa = "Terugkerende afspraken ondersteunen geen boekingslimiet per boeker. Schakel de boekingslimiet per boeker uit om terugkerende afspraken mogelijk te maken.", qYa = "Stoelfunctie ondersteunt geen terugkerend evenement. Schakel stoelfunctie uit om het terugkerend te maken.", jYa = "Terugkerend evenement ondersteunt geen stoelfunctie. Schakel stoelfunctie uit of maak het evenement niet-terugkerend.", FYa = "Segment", VYa = "Opgeslagen filters", BYa = "Hernoemen", UYa = "Segment hernoemen", WYa = "Segment verwijderen", GYa = "Segment dupliceren", HYa = "Weet je zeker dat je dit segment wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", KYa = "Filtersegment bijgewerkt", YYa = "Fout bij het bijwerken van filtersegment", ZYa = "Filtersegment gedupliceerd", QYa = "Fout bij het dupliceren van filtersegment", JYa = "Filtersegment verwijderd", XYa = "Fout bij het verwijderen van filtersegment", eZa = "Segment opslaan", tZa = "Segment niet gevonden", nZa = "Filtersegment opgeslagen", oZa = "Geen segmenten", rZa = "Fout bij het opslaan van filtersegment", iZa = 'Wijzigingen opslaan naar "{{name}}"', aZa = "Nieuw segment maken", sZa = "Opslaan voor team", cZa = "Team selecteren", lZa = "Selecteer een team", dZa = "Persoonlijk", uZa = "Teamprofiellink verbergen", _Za = "Verberg de teamprofiellink op boekingspagina's", pZa = "Weergave", mZa = "Kon geen slug vinden om de organisatie te publiceren", fZa = "Keuzelijst", gZa = "Meest geannuleerd", hZa = "Interfacetaal", vZa = "Stel je voorkeurstaal in voor de boekingsinterface", bZa = "Taal van de browser van de bezoeker", yZa = "Naam of e-mail", $Za = "Als er geen contactpersoon wordt gevonden, val dan terug op de lead-eigenaar als deze bestaat", wZa = "Aankoop van credits mislukt. Probeer het opnieuw of neem contact op met de klantenservice.", kZa = "Minimaal 50 credits vereist", SZa = "Delegatiereferentie inschakelen", xZa = "Geef Cal.com automatisch toegang tot de agenda's van alle organisatieleden door delegatiereferentie in te schakelen.", EZa = "Delegatiereferentie uitschakelen", TZa = "Zodra de delegatiereferentie is uitgeschakeld, moeten organisatieleden die hun agenda's nog niet hebben gekoppeld dit handmatig doen.", AZa = "Laatst actief", CZa = "Lid sinds", zZa = "Laatst bijgewerkt", OZa = "Bij geannuleerde boeking, schrijf naar evenementrecord in plaats van evenement verwijderen", PZa = "Bij elke annulering", IZa = "Probleem melden", RZa = "Je kunt een ticket indienen op GitHub of je abonnement upgraden om realtime ondersteuning te krijgen met ontwikkelaarsconferenties", NZa = "Issue openen", DZa = "Dit is je huidige abonnement", MZa = "Plan een tijdstip", LZa = "Dit omvat:", qZa = "OAuth-client succesvol bijgewerkt", jZa = "OAuth-client niet gevonden.", FZa = "Abonneren op platform", VZa = "Fout bij het proberen toegang te krijgen tot webhooks.", BZa = "Webhook bijwerken mislukt.", UZa = "Webhook aanmaken mislukt.", WZa = "Ongeldige link", GZa = "Je hebt momenteel een abonnement op het {{planFirstLetter}}{{planRest}}-abonnement", HZa = "Gebruiker/team", KZa = "Client-ID gekopieerd!", YZa = "Client secret gekopieerd!", ZZa = "Het Cal.com-team voert gepland onderhoud uit. Als je vragen hebt, neem dan contact op met de klantenservice.", QZa = "Je betaling is mislukt", JZa = "Controleer je inbox", XZa = "Je account is aangemaakt, maar je premium is niet gereserveerd.", eQa = "We hebben een e-mail gestuurd naar {{email}} met een link om je account te activeren.", tQa = "Zodra je je account activeert, kun je opnieuw proberen je premium gebruikersnaam te kopen of een andere kiezen.", nQa = "Openen in Gmail", oQa = "Geen e-mail ontvangen?", rQa = "Opnieuw verzenden over {{seconds}} seconden", iQa = "Opnieuw verzenden", aQa = "Verificatie-e-mail verzonden", sQa = "Selecteer alle leden", cQa = "Door alle leden te selecteren worden alle toekomstige teamleden toegevoegd wanneer ze aan het team worden toegevoegd.", lQa = "Formulierinstellingen", dQa = "Whitelist-status verwijderen", uQa = "Whitelist gebruikersworkflows", _Qa = "Gebruikersworkflows op whitelist geplaatst", pQa = "Gebruikersworkflows van whitelist verwijderd", mQa = "Datum en tijd", fQa = "Dit is een herinnering voor je aankomende evenement.", gQa = "Deze herinnering is geactiveerd door een Workflow in Cal.", hQa = "Evenement", vQa = "Gepland door", bQa = "Hoe was uw recente ervaring?", yQa = "We werken continu aan betere klantervaringen.", $Qa = "Hoe tevreden was u met uw laatste vergadering?", wQa = "heeft u niet deelgenomen aan de vergadering?", kQa = "Hier opnieuw plannen.", SQa = "E-mail van organisator verbergen", xQa = "Je maakt al deel uit van een platformorganisatie, daarom kun je geen nieuwe organisatie aanmaken. Elke gebruiker kan slechts tot één organisatie behoren. Maak een nieuw cal.com-account aan met een ander e-mailadres en gebruik dat account om je te abonneren op het organisatieplan.", EQa = "Je maakt al deel uit van een organisatie, daarom kun je geen platformorganisatie aanmaken. Elke gebruiker kan slechts tot één organisatie behoren. Maak een nieuw cal.com-account aan met een ander e-mailadres en gebruik dat account om je te abonneren op het platformplan.", TQa = "Verberg het e-mailadres van de organisator op het boekingsscherm, in e-mailnotificaties en in agenda-afspraken", AQa = "U &", CQa = "Selecteer een geverifieerd e-mailadres", zQa = "Geverifieerde e-mail toevoegen", OQa = "Geverifieerde e-mails toevoegen", PQa = "Aangepast 'Antwoord-aan' e-mailadres", IQa = "Gebruik een ander e-mailadres als antwoordadres voor bevestigingsmails in plaats van het e-mailadres van de organisator", RQa = "Deze enquête is geactiveerd door een Workflow in Cal.", NQa = "Proefperiode overslaan", DQa = "Teamproefperiodes succesvol overgeslagen", MQa = "Door je telefoonnummer in te voeren, stem je ermee in sms-berichten te ontvangen voor dit evenement. Sms-tarieven kunnen van toepassing zijn.", LQa = "Meer informatie is te vinden in <0>Routeringsinzichten</0>", qQa = "Resultaten", jQa = "Formulier bekijken", FQa = "Stuur STOP om je af te melden voor sms-berichten", VQa = "Je team {{teamName}} heeft bijna geen credits meer", BQa = "Je hebt bijna geen credits meer", UQa = "[Actie vereist] Je team {{teamName}} heeft geen credits meer", WQa = "[Actie vereist] Je hebt geen credits meer", GQa = "Het Cal.com-team {{teamName}} heeft bijna geen credits meer. Om onderbrekingen in de service te voorkomen, koop je extra credits. Als je saldo op is, worden SMS-berichten niet meer verzonden en worden ze in plaats daarvan als e-mails verzonden.", HQa = "Je Cal.com-account heeft bijna geen credits meer. Om onderbrekingen in de service te voorkomen, koop je extra credits. Als je saldo op is, worden SMS-berichten niet meer verzonden en worden ze in plaats daarvan als e-mails verzonden.", KQa = "Je Cal.com-team {{teamName}} heeft geen credits meer. Hierdoor worden SMS-berichten nu via e-mail verzonden. Om weer SMS-berichten te kunnen versturen, koop je extra credits.", YQa = "Je Cal.com-account heeft geen credits meer. Hierdoor worden sms-berichten nu via e-mail verzonden. Om weer sms-berichten te kunnen versturen, koop je extra credits.", ZQa = "Huidige saldo: {{balance}} credits", QQa = "Huidige saldo:", JQa = "Melding over je boeking", XQa = "Maandelijkse credits", eJa = "Totaal credits: {{totalCredits}}", tJa = "Resterende credits: {{remainingCredits}}", nJa = "Resterend", oJa = "Totaal", rJa = "Extra credits", iJa = "{{count}} volgende in wachtrij", aJa = "Stuur e-mailreacties naar", sJa = "Onvolledige boekingen", cJa = "Niet-verschenen boekingen meenemen in round robin berekeningen", lJa = "Recente no-show gasten", dJa = "Toont boekingen waarbij alle deelnemers niet zijn komen opdagen, geen gedeeltelijke no-shows", uJa = "Overeenkomend", _Ja = "Evenement doorverwijzing", pJa = "Formulier resetten", mJa = "Round Robin-instellingen succesvol bijgewerkt", fJa = "Verdelingsbasis voor gewogen Round Robin", gJa = "Bepaalt welke gebeurtenistijdstempel wordt gebruikt als basis voor de gewogen round robin-verdeling.", hJa = "Vereist credits", vJa = "Je hebt voldoende credits op je account nodig om deze functie te gebruiken", bJa = "Beschikbare credits", yJa = "Rol aanmaken", $Ja = "Rollen & rechten", wJa = "Beheer rollen en rechten voor je organisatie", kJa = "Meer informatie over hoe rechten werken", SJa = "Rolnaam", xJa = "Rolnaam is vereist", EJa = "bijv. Verkoopteam, Supportmedewerkers", TJa = "Rolbeschrijving", AJa = "Beschrijf waarvoor deze rol dient en welke rechten deze nodig heeft", CJa = "Standaardrol", zJa = "Aangepaste rol", OJa = "Geavanceerd", PJa = "Zoek machtigingen", IJa = "Alle machtigingen", RJa = "Geen", NJa = "Alleen lezen", DJa = "Alle acties op alle hulpmiddelen", MJa = "Alle hulpmiddelen", LJa = "Evenementen", qJa = "Teams", jJa = "Organisatie", FJa = "Afspraken", VJa = "Inzichten", BJa = "Functies", UJa = "Routeringsformulieren", WJa = "Werkstromen", GJa = "Alle acties", HJa = "Aanmaken", KJa = "Bekijken", YJa = "Wijzigen", ZJa = "Verwijderen", QJa = "Beheren", JJa = "Uitnodigen", XJa = "Verwijderen", eXa = "Functie van lid wijzigen", tXa = "Leden weergeven", nXa = "Facturering beheren", oXa = "Team afspraken bekijken", rXa = "Organisatie afspraken bekijken", iXa = "Opnames bekijken", aXa = "Imiteren", sXa = "Rol succesvol aangemaakt", cXa = "Rol succesvol bijgewerkt", lXa = "Rol verwijderen", dXa = "Weet je zeker dat je de rol wilt verwijderen: {{roleName}}. Deze actie kan niet ongedaan worden gemaakt.", uXa = "Rol succesvol verwijderd", _Xa = "Fout bij het aanmaken van rol", pXa = "Fout bij het bijwerken van rol", mXa = "Rollen aanmaken", fXa = "Attributen", gXa = "Organisatieattributen bekijken", hXa = "Organisatieattributen bijwerken", vXa = "Organisatieattributen verwijderen", bXa = "Organisatieattributen aanmaken", yXa = "Rollen bekijken", $Xa = "Rollen bijwerken", wXa = "Rollen verwijderen", kXa = "Nieuwe werkstromen maken en instellen", SXa = "Instellen vereist", xXa = "Bestaande werkstromen en hun configuraties bekijken", EXa = "Werkstroominstellingen bewerken en wijzigen", TXa = "Werkstromen uit het systeem verwijderen", AXa = "Webhook", CXa = "Beschikbaarheid", zXa = "Afwezigheid", OXa = "Webhooks maken", PXa = "Webhooks bekijken", IXa = "Webhooks bijwerken", RXa = "Webhooks verwijderen", NXa = "Beschikbaarheid aanmaken", DXa = "Beschikbaarheid bekijken", MXa = "Beschikbaarheid bijwerken", LXa = "Beschikbaarheid verwijderen", qXa = "Afwezigheid aanmaken", jXa = "Afwezigheid bekijken", FXa = "Afwezigheid bijwerken", VXa = "Afwezigheid verwijderen", BXa = "Volledige beheertoegang tot alle werkstromen", UXa = "Gebeurtenistypes aanmaken", WXa = "Gebeurtenistypes bekijken", GXa = "Gebeurtenistypes bijwerken", HXa = "Gebeurtenistypes verwijderen", KXa = "Alle acties op gebeurtenistypes", YXa = "Teams aanmaken", ZXa = "Teamdetails bekijken", QXa = "Teaminstellingen bijwerken", JXa = "Team verwijderen", XXa = "Teamleden uitnodigen", ees = "Teamleden verwijderen", tes = "Rol van teamleden wijzigen", nes = "Teamleden imiteren", oes = "Alle acties op teams binnen organisatieteams", res = "Organisatie aanmaken", ies = "Organisatiedetails bekijken", aes = "Organisatieleden weergeven", ses = "Organisatieleden uitnodigen", ces = "Organisatieleden verwijderen", les = "Organisatiefacturering beheren", des = "Rol van organisatieleden wijzigen", ues = "Organisatieleden imiteren", _es = "Organisatie-instellingen bewerken", pes = "Alle acties op organisaties", mes = "Boekingen bekijken", fes = "Teamboekingen bekijken", ges = "Organisatieboekingen bekijken", hes = "Boekingsopnames bekijken", ves = "Boekingen bijwerken", bes = "Alle acties op boekingen", yes = "Team-inzichten bekijken", $es = "Team-inzichten beheren", wes = "Routeringsformulieren maken", kes = "Routeringsformulieren bekijken", Ses = "Routeringsformulieren bijwerken", xes = "Routeringsformulieren verwijderen", Ees = "Leesrechten worden automatisch ingeschakeld bij het aanmaken, bijwerken of verwijderen van een resource", Tes = "Beperkingsschema toevoegen", Aes = "Beperk beschikbaarheid van hosts om alleen tijdsloten weer te geven die binnen een specifiek schema vallen.", Ces = "Gebruik tijdzone van de boeker", zes = "Pas het geselecteerde beperkingsschema toe in de tijdzone van de boeker", Oes = "Dit zal Load Balancing uitschakelen op al je round robin evenementtypes", Pes = "Load Balancing is alleen beschikbaar wanneer de tijdstempelbasis is ingesteld op Boekingsaanmaaktijd", Ies = "Load balancing is niet beschikbaar met round robin groepen", Res = "Pas de standaard round robin-instellingen aan voor dit team", Nes = "Round Robin-instellingen succesvol bijgewerkt", Des = "Aanmaaktijd boeking", Mes = "Starttijd vergadering", Les = "Getroffen leden", qes = "Geen leden getroffen door het uitschakelen van delegatiereferentie", jes = "Download uitgavenlogboek", Fes = "Fout bij het downloaden van uitgavenlogboek", Ves = "Bied aan om de laatste actieve boeking te verplaatsen naar het gekozen tijdslot", Bes = "Maximaal aantal actieve boekingen voor de boeker overschreden", Ues = "Je hebt al een boeking voor dit evenement op {{date}}. Wil je deze verplaatsen naar de nieuw geselecteerde tijd?", Wes = "Duur moet minimaal {{min}} minu(u)t(en) zijn", Ges = "Duur mag niet langer zijn dan {{max}} minuten (24 uur)", Hes = "Boeken buiten de beschikbaarheid van het beperkingsschema.", Kes = "Beperkingsschema niet gevonden", Yes = "Afbeeldingsgrootte overschreden, gebruik een kleinere afbeelding bij voorkeur in JPEG-formaat", Zes = "Groep toevoegen", Qes = "Routeringstrechter", Jes = "Totaal aantal inzendingen", Xes = "Succesvolle routeringen", ets = "Geaccepteerde boekingen", tts = "Licentiesleutel", nts = "Kies je licentie", ots = "Selecteer hoe je je Cal.com-implementatie wilt licenseren", rts = "Gebruik Cal.com onder de AGPLv3 open source licentie", its = "Voer licentiesleutel in", ats = "Toegang tot alle enterprise-functies", sts = "Vanaf €15/gebruiker per maand", cts = "Toegang tot alle enterprise-functies", lts = "Voer je licentiesleutel in", dts = "Licentiesleutel opslaan", uts = "Handtekeningtoken (optioneel)", _ts = "Handtekeningtoken wordt gebruikt om te verifiëren dat de licentiesleutel van jou is bij het verhogen van gebruiksgebaseerde facturering. Je kunt het vinden in je aankoopbevestigingsmail. Als je een oudere licentie hebt, kun je dit leeg laten.", pts = "Heb je een licentie nodig?", mts = "Licentiesleutel is vereist", fts = "Ongeldige licentiesleutel", gts = "Validatie van licentiesleutel mislukt", hts = "Bijlagen optioneel", vts = "Bericht versturen", bts = "Beschrijf het probleem", yts = "Bestandsgrootte overschrijdt limiet", $ts = "Ongeldig bestandstype", wts = "Ongeldig bestandstype. Geaccepteerde types: {{acceptedTypes}}", kts = "Maximaal aantal bestanden overschreden", Sts = "Bestanden succesvol geüpload", xts = "Geaccepteerde types: {{acceptedTypes}}; Max. bestandsgrootte: {{maxSize}}", Ets = "Licentiesleutel succesvol opgeslagen", Tts = "Je bekijkt het rapport op basis van je profieltijdzone ({{userTimezone}}), terwijl je browser is ingesteld op tijdzone ({{browserTimezone}})", Ats = "Geoptimaliseerde tijdsloten", Cts = "Tijdsloten rangschikken om beschikbaarheid te optimaliseren.", zts = "Mislukte boekingen per veld", Ots = "Mislukte boekingen", Pts = "Geen hosts toegewezen aan evenementtype", Its = "Cache-status", Rts = "Laatst bijgewerkt: {{timestamp}}", Nts = "Gecachte gegevens verwijderen", Dts = "Cache succesvol verwijderd", Mts = "Fout bij verwijderen cache", Lts = "Weet je zeker dat je de gecachte gegevens wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.", qts = "Ja, cache verwijderen", jts = "{{remainder}} van {{maximum}} gebruiken over", Fts = "{{remainder}} van {{maximum}} gebruik over", Vts = "Verloopt op {{date}}, einde van de dag", Bts = "Eenmalig gebruik", Uts = "Tijdgebaseerde vervaldatum", Wts = "Gebruiksgebaseerde vervaldatum", Gts = "Aantal gebruiken", Hts = "Verloopt op", Kts = "Maximaal aantal gebruiken", Yts = "Linkinstellingen", Zts = "Deze link is verlopen op {{date}}, einde van de dag", Qts = "Gebruikslimiet bereikt", Jts = "Maximaal aantal gebruiken moet groter zijn dan het huidige aantal gebruiken", Xts = "Deze link is verlopen", ens = "Deze link kan worden gebruikt voor boekingen tot het einde van {{date}}", tns = "Deze link kan worden ingesteld om te verlopen na een bepaalde datum", nns = "Deze link kan worden gebruikt voor {{count}} boeking", ons = "Deze link kan worden ingesteld om te verlopen na een bepaald aantal boekingen", rns = "Deze link kan worden gebruikt voor {{count}} boekingen", ins = "De naam van de trigger-gebeurtenis (bijv. BOOKING_CREATED, BOOKING_CANCELLED)", ans = "Het tijdstip van de webhook", sns = "De slug van het gebeurtenistype", cns = "Agent instellen", lns = "De naam van het gebeurtenistype", dns = "De starttijd van de gebeurtenis", uns = "De eindtijd van de gebeurtenis", _ns = "De beschrijving van de gebeurtenis zoals beschreven in de instellingen van het gebeurtenistype", pns = "Locatie van de gebeurtenis", mns = "De UID van de boeking", fns = "De UID voor het opnieuw plannen", gns = "Reden voor annulering", hns = "Reden voor weigering", vns = "Naam van de organisator", bns = "E-mail van de organisator", yns = "Tijdzone van de organisator (bijv. 'America/New_York', 'Asia/Kolkata')", $ns = "Taalinstelling van de organisator (bijv. 'en', 'fr')", wns = "Gebruikersnaam van de organisator (bijv. 'john.doe')", kns = "Gebruikersnaam van de organisator in hun organisatie (bijv. 'john.doe')", Sns = "Naam van de eerste deelnemer", xns = "E-mail van de eerste deelnemer", Ens = "Tijdzone van de eerste deelnemer", Tns = "Taalinstelling van de eerste deelnemer", Ans = "Naam van het geboekte team", Cns = "Leden van het geboekte team", zns = "Video-oproep URL voor de vergadering", Ons = "Variabelen verbergen", Pns = "Beschikbare variabelen tonen", Ins = "Evenement en boeking", Rns = "Mensen", Nns = "Teams", Dns = "Metadata", Mns = "Statistieken", Lns = "Boekingsstatus", qns = "Bezoek", jns = "Aangepast label op boekingspagina", Fns = "Vergaderlink", Vns = "Sessieresultaat", Bns = "Gesprek aangemaakt", Uns = "Voicemail", Wns = "Mijn boekingen", Gns = "Telefoon", Hns = "Gratis", Kns = "E-mailadres gebruiker", Yns = "Gebruikersnaam", Zns = "Paneel uitklappen", Qns = "Paneel inklappen", Jns = "E-mailverificatie is vereist voor dit afspraaktype", Xns = "Ongeldige verificatiecode opgegeven", eos = "Je hebt één team", tos = "Overweeg een organisatie op te zetten om facturering, beheerderstools en analyses voor je team te verenigen.", nos = "Overweeg een organisatie op te zetten om facturering, beheerderstools en analyses voor je teams te verenigen.", oos = "Bericht verzonden", ros = "Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op.", ios = "Variabelen zoeken", aos = "Beschrijf het probleem dat je ondervindt, bijv. 'Bezette tijdslots worden als beschikbaar weergegeven', ..., etc.", sos = "Nog een bericht versturen", cos = "Bezig met verzenden", los = "Geen variabelen gevonden", dos = "Credits vereist", uos = "Webgesprekken verbruiken credits. Zorg ervoor dat je voldoende credits hebt om een gesprek te starten.", _os = "Webgesprekken vereisen credits. Je hebt 0 credits over.", pos = "Credits kopen", mos = "Deze actie vereist credits om verder te gaan", fos = "Naam mag niet langer zijn dan {{max}} tekens", gos = "Automatisch no-show kosten in rekening brengen voor last-minute annuleringen", hos = "Voor geplande starttijd", vos = "Ik erken dat door de boeking te annuleren binnen {{timeValue}} {{timeUnit}} voor de starttijd, mij de no-show kosten van {{amount, currency}} in rekening worden gebracht", bos = "Als je vragen hebt, neem dan contact op met de organisator.", yos = "Boekingstijd", $os = "Wanneer de boeking is gepland (begin tot eind)", wos = "Aangemaakt op", kos = "Wanneer de boeking oorspronkelijk is aangemaakt", Sos = "Gespreksdetails", xos = "Gesprek-ID", Eos = "Gespreksinformatie", Tos = "Sentiment", Aos = "Reden voor verbreken", Cos = "Gespreksoverzicht", zos = "Transcriptie", Oos = "Afspraakdetails", Pos = "Agent", Ios = "Geen transcript beschikbaar", Ros = "Houd er bij het testen van deze workflow rekening mee dat sms'en minimaal 15 minuten van tevoren moeten worden gepland", Nos = "Begin vanaf nul", Dos = "Maak je eigen workflow vanaf nul.", Mos = "Cal.ai sjabloon", Los = "AI-agents die afspraken boeken, herinneringen sturen en opvolgen!", qos = "Stem", jos = "Selecteer stem", Fos = "Selecteer een stem voor je agent", Vos = "Kies een stem voor je agent", Bos = "Eigenschap", Uos = "Stem-ID", Wos = "Gebruik stem", Gos = "Huidige stem", Hos = "Inkomende agent instellen", Kos = "Configureer een AI-agent om inkomende gesprekken op je telefoonnummer af te handelen", Yos = "Verbind eerst een telefoonnummer", Zos = "Agent instellen voor inkomende gesprekken", Qos = "Agent configureren om inkomende gesprekken af te handelen", Jos = "Inkomende gesprekken", Xos = "Uitgaande gesprekken", ers = "Inkomende agent succesvol ingesteld", trs = "Inkomende agent geconfigureerd", nrs = "Inkomende agent instellen", ors = "Selecteer eerst een evenementtype", rrs = "Configuratie bewerken", irs = "Inkomende gesprekken kunnen slechts één evenementtype boeken. Selecteer het evenementtype waarbij afspraken worden gepland wanneer bellers je agent bereiken.", ars = "Inkomende agent instellen voor inkomende gesprekken", srs = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Voeg uw nieuwe strings hierboven toe ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", crs = {
  identity_provider: cXi,
  trial_days_left: lXi,
  day_one: dXi,
  day_other: uXi,
  second_one: _Xi,
  second_other: pXi,
  upgrade_now: mXi,
  untitled: fXi,
  accept_invitation: gXi,
  max_characters: hXi,
  min_characters: vXi,
  calcom_explained: bXi,
  calcom_explained_new_user: yXi,
  have_any_questions: $Xi,
  reset_password_subject: wXi,
  verify_email_subject: kXi,
  verify_email_subject_verifying_email: SXi,
  check_your_email: xXi,
  old_email_address: EXi,
  new_email_address: TXi,
  verify_email_page_body: AXi,
  verify_email_banner_body: CXi,
  verify_email_email_header: zXi,
  verify_email_button: OXi,
  cal_ai_assistant: PXi,
  send_cal_video_transcription_emails: IXi,
  description_send_cal_video_transcription_emails: RXi,
  verify_email_change_description: NXi,
  verify_email_change_success_toast: DXi,
  verify_email_change_failure_toast: MXi,
  change_of_email: LXi,
  change_of_email_toast: qXi,
  copy_somewhere_safe: jXi,
  verify_email_email_body: FXi,
  verify_email_by_code_email_body: VXi,
  verify_email_email_link_text: BXi,
  email_verification_code: UXi,
  email_verification_code_placeholder: WXi,
  incorrect_email_verification_code: GXi,
  email_sent: HXi,
  email_not_sent: KXi,
  event_declined_subject: YXi,
  event_cancelled_subject: ZXi,
  event_reassigned_subject: QXi,
  event_request_declined: JXi,
  customize_calvideo_settings: XXi,
  calvideo_settings_description: eea,
  disable_recording_for_guests: tea,
  enable_automatic_transcription: nea,
  enable_automatic_recording: oea,
  video_options: rea,
  edit_event: iea,
  view_session_details: aea,
  meeting_session_details: sea,
  meeting_session: cea,
  session_id: lea,
  max_participants: dea,
  unlimited: uea,
  ongoing: _ea,
  ended: pea,
  participants: mea,
  anonymous_user: fea,
  session_duration: gea,
  no_meeting_sessions_found: hea,
  not_available: vea,
  disable_recording_for_organizer: bea,
  disable_transcription_for_guests: yea,
  disable_transcription_for_organizer: $ea,
  event_request_declined_recurring: wea,
  event_request_cancelled: kea,
  event_request_reassigned: Sea,
  event_reassigned_subtitle: xea,
  organizer: Eea,
  reassigned_to: Tea,
  need_to_reschedule_or_cancel: Aea,
  you_can_view_booking_details_with_this_url: Cea,
  no_options_available: zea,
  cancellation_reason: Oea,
  cancelled_by: Pea,
  cancellation_reason_host: Iea,
  cancellation_reason_placeholder: Rea,
  notify_attendee_cancellation_reason_warning: Nea,
  rejection_reason_placeholder: Dea,
  rejection_reason: Mea,
  rejection_reason_title: Lea,
  rejection_reason_description: qea,
  rejection_confirmation: jea,
  manage_this_event: Fea,
  invite_team_member: Vea,
  invite_team_individual_segment: Bea,
  invite_team_bulk_segment: Uea,
  invite_team_notifcation_badge: Wea,
  your_event_has_been_scheduled: Gea,
  your_event_has_been_scheduled_recurring: Hea,
  accept_our_license: Kea,
  remove_banner_instructions: Yea,
  error_message: Zea,
  refund_failed_subject: Qea,
  refund_failed: Jea,
  check_with_provider_and_user: Xea,
  a_refund_failed: eta,
  awaiting_payment_subject: tta,
  meeting_awaiting_payment: nta,
  dark_theme_contrast_error: ota,
  light_theme_contrast_error: rta,
  event_type_color_light_theme_contrast_error: ita,
  event_type_color_dark_theme_contrast_error: ata,
  payment_not_created_error: sta,
  couldnt_charge_card_error: cta,
  no_available_users_found_error: lta,
  timeslot_unavailable_book_a_new_time: dta,
  timeslot_unavailable_short: uta,
  just_connected_description: _ta,
  unavailable_timeslot_title: pta,
  booking_time_out_of_bounds_error: mta,
  request_body_end_time_internal_error: fta,
  create_calendar_event_error: gta,
  update_calendar_event_error: hta,
  delete_calendar_event_error: vta,
  already_signed_up_for_this_booking_error: bta,
  hosts_unavailable_for_booking: yta,
  fixed_hosts_unavailable_for_booking: $ta,
  round_robin_host_unavailable_for_booking: wta,
  help: kta,
  price: Sta,
  paid: xta,
  refunded: Eta,
  record: Tta,
  transcribe: Ata,
  payment: Cta,
  missing_card_fields: zta,
  pay_now: Ota,
  general_prompt: Pta,
  transcription_powered_by_ai: Ita,
  start_or_stop_recording: Rta,
  begin_message: Nta,
  codebase_has_to_stay_opensource: Dta,
  cannot_repackage_codebase: Mta,
  acquire_license: Lta,
  terms_summary: qta,
  open_env: jta,
  env_changed: Fta,
  accept_license: Vta,
  still_waiting_for_approval: Bta,
  event_is_still_waiting: Uta,
  no_result_found_for: Wta,
  no_more_results: Gta,
  no_results: Hta,
  load_more_results: Kta,
  integration_meeting_id: Yta,
  confirmed_event_type_subject: Zta,
  new_event_request: Qta,
  confirm_or_reject_request: Jta,
  check_bookings_page_to_confirm_or_reject: Xta,
  check_in_assistant: ena,
  check_in_assistant_description: tna,
  create_your_own_prompt: nna,
  event_awaiting_approval: ona,
  event_awaiting_approval_recurring: rna,
  someone_requested_an_event: ina,
  someone_requested_password_reset: ana,
  password_reset_email_sent: sna,
  password_reset_instructions: cna,
  event_awaiting_approval_subject: lna,
  event_still_awaiting_approval: dna,
  booking_submitted_subject: una,
  download_recording_subject: _na,
  download_transcript_email_subject: pna,
  download_your_recording: mna,
  download_your_transcripts: fna,
  your_meeting_has_been_booked: gna,
  event_type_has_been_rescheduled_on_time_date: hna,
  event_type_has_been_updated: vna,
  event_has_been_rescheduled: bna,
  event_has_been_updated: yna,
  your_event_has_been_rescheduled: $na,
  request_reschedule_subtitle: wna,
  request_reschedule_title_organizer: kna,
  request_reschedule_subtitle_organizer: Sna,
  rescheduled_event_type_subject: xna,
  requested_to_reschedule_subject_attendee: Ena,
  hi_user_name: Tna,
  ics_event_title: Ana,
  please_book_a_time_sometime_later: Cna,
  schedule_instead: zna,
  new_event_subject: Ona,
  join_by_entrypoint: Pna,
  notes: Ina,
  manage_my_bookings: Rna,
  need_to_make_a_change: Nna,
  new_event_scheduled: Dna,
  new_event_scheduled_recurring: Mna,
  invitee_email: Lna,
  invitee_timezone: qna,
  time_left: jna,
  event_type: Fna,
  duplicate_event_type: Vna,
  enter_meeting: Bna,
  video_call_provider: Una,
  meeting_id: Wna,
  meeting_password: Gna,
  meeting_url: Hna,
  meeting_url_not_found: Kna,
  token_not_found: Yna,
  some_other_host_already_accepted_the_meeting: Zna,
  meeting_request_rejected: Qna,
  rejected_event_type_with_organizer: Jna,
  hi: Xna,
  join_team: eoa,
  manage_this_team: toa,
  team_info: noa,
  join_meeting: ooa,
  request_another_invitation_email: roa,
  you_have_been_invited: ioa,
  user_invited_you: aoa,
  hidden_team_member_title: soa,
  hidden_team_member_message: coa,
  hidden_team_owner_message: loa,
  link_expires: doa,
  upgrade_to_per_seat: uoa,
  seat_options_doesnt_support_confirmation: _oa,
  multilocation_doesnt_support_seats: poa,
  no_show_fee_doesnt_support_seats: moa,
  seats_option_doesnt_support_multi_location: foa,
  team_upgrade_seats_details: goa,
  team_upgrade_banner_description: hoa,
  upgrade_banner_action: voa,
  team_upgraded_successfully: boa,
  org_upgrade_banner_description: yoa,
  org_upgraded_successfully: $oa,
  use_link_to_reset_password: woa,
  hey_there: koa,
  there: Soa,
  forgot_your_password_calcom: xoa,
  delete_webhook_confirmation_message: Eoa,
  confirm_delete_webhook: Toa,
  edit_webhook: Aoa,
  delete_webhook: Coa,
  webhook_status: zoa,
  webhook_enabled: Ooa,
  webhook_disabled: Poa,
  webhook_response: Ioa,
  webhook_test: Roa,
  webhook_update_form: Noa,
  webhook_update_form_description: Doa,
  manage_your_webhook: Moa,
  webhook_created_successfully: Loa,
  webhook_updated_successfully: qoa,
  webhook_removed_successfully: joa,
  subscription_needed: Foa,
  subscription_needed_description: Voa,
  payload_template: Boa,
  dismiss: Uoa,
  no_data_yet: Woa,
  ping_test: Goa,
  add_to_homescreen: Hoa,
  upcoming: Koa,
  recurring: Yoa,
  past: Zoa,
  choose_a_file: Qoa,
  upload_image: Joa,
  upload_target: Xoa,
  no_target: era,
  slide_zoom_drag_instructions: tra,
  view_notifications: nra,
  view_public_page: ora,
  copy_public_page_link: rra,
  copy_referral_link: ira,
  sign_out: ara,
  add_another: sra,
  install_another: cra,
  until: lra,
  powered_by: dra,
  unavailable: ura,
  set_work_schedule: _ra,
  change_bookings_availability: pra,
  select: mra,
  "2fa_confirm_current_password": "Bevestig uw huidige wachtwoord om aan de slag te gaan.",
  "2fa_scan_image_or_use_code": "Scan de afbeelding hieronder met de authenticator-app op uw telefoon of voer de tekstcode handmatig in.",
  text: fra,
  your_phone_number: gra,
  multiline_text: hra,
  number: vra,
  checkbox: bra,
  is_required: yra,
  make_field_required: $ra,
  required: wra,
  optional: kra,
  input_type: Sra,
  rejected: xra,
  unconfirmed: Era,
  guests: Tra,
  guest: Ara,
  web_conferencing_details_to_follow: Cra,
  confirmation: zra,
  what_booker_should_provide: Ora,
  "404_the_user": "De gebruikersnaam",
  username: Pra,
  is_still_available: Ira,
  documentation: Rra,
  documentation_description: Nra,
  api_reference: Dra,
  api_reference_description: Mra,
  blog: Lra,
  blog_description: qra,
  join_our_community: jra,
  "404_claim_entity_user": "Claim uw gebruikersnaam en plan evenementen",
  popular_pages: Fra,
  register_now: Vra,
  register: Bra,
  page_doesnt_exist: Ura,
  no_active_phone_number_available: Wra,
  workflow_step_not_configured: Gra,
  check_spelling_mistakes_or_go_back: Hra,
  "404_page_not_found": "404: Deze pagina kan niet worden gevonden.",
  booker_event_not_found: Kra,
  getting_started: Yra,
  "15min_meeting": "15 Minuten afspraak",
  "30min_meeting": "30 Minuten afspraak",
  secret: Zra,
  leave_blank_to_remove_secret: Qra,
  webhook_secret_key_description: Jra,
  secret_meeting: Xra,
  login_instead: eia,
  create_account: tia,
  get_started: nia,
  confirm_password: oia,
  reset_your_password: ria,
  org_banner_instructions: iia,
  email_change: aia,
  create_your_account: sia,
  create_your_calcom_account: cia,
  sign_up: lia,
  youve_been_logged_out: dia,
  hope_to_see_you_soon: uia,
  logged_out: _ia,
  please_try_again_and_contact_us: pia,
  incorrect_2fa_code: mia,
  no_account_exists: fia,
  "2fa_enabled_instructions": "Tweestapsverificatie ingeschakeld. Voer de zescijferige code in vanuit uw authenticatie-app.",
  "2fa_enter_six_digit_code": "Voer hieronder de zescijferige code van uw authenticatie-app in.",
  create_an_account: gia,
  dont_have_an_account: hia,
  "2fa_code": "Tweestapsverificatie code",
  sign_in_account: via,
  sign_in: bia,
  go_back_login: yia,
  error_during_login: $ia,
  request_password_reset: wia,
  send_invite: kia,
  forgot_password: Sia,
  forgot: xia,
  done: Eia,
  all_done: Tia,
  all: Aia,
  yours: Cia,
  available_apps: zia,
  available_apps_lower_case: Oia,
  available_apps_desc: Pia,
  fixed_host_helper: Iia,
  round_robin_groups_helper: Ria,
  round_robin_helper: Nia,
  check_email_reset_password: Dia,
  finish: Mia,
  organization_general_description: Lia,
  few_sentences_about_yourself: qia,
  nearly_there: jia,
  nearly_there_instructions: Fia,
  set_availability_instructions: Via,
  set_availability: Bia,
  set_availbility_description: Uia,
  share_a_link_or_embed: Wia,
  share_a_link_or_embed_description: Gia,
  availability_settings: Hia,
  continue_without_calendar: Kia,
  continue_with: Yia,
  connect_your_calendar: Zia,
  connect_your_video_app: Qia,
  connect_your_video_app_instructions: Jia,
  connect_your_calendar_instructions: Xia,
  set_up_later: eaa,
  current_time: taa,
  details: naa,
  welcome: oaa,
  welcome_back: raa,
  welcome_to_calcom: iaa,
  welcome_instructions: aaa,
  connect_caldav: saa,
  connect_ics_feed: caa,
  connect: laa,
  try_for_free: daa,
  create_booking_link_with_calcom: uaa,
  who: _aa,
  what: paa,
  when: maa,
  where: faa,
  add_to_calendar: gaa,
  add_to_calendar_description: haa,
  add_events_to: vaa,
  add_another_calendar: baa,
  other: yaa,
  email_sign_in_subject: $aa,
  round_robin_emailed_you_and_attendees: waa,
  round_robin_emailed_host_and_attendee: kaa,
  emailed_host_and_attendee: Saa,
  emailed_host_and_attendee_recurring: xaa,
  round_robin_emailed_you_and_attendees_recurring: Eaa,
  round_robin_emailed_host_and_attendee_recurring: Taa,
  emailed_you_and_any_other_attendees: Aaa,
  needs_to_be_confirmed_or_rejected: Caa,
  needs_to_be_confirmed_or_rejected_recurring: zaa,
  user_needs_to_confirm_or_reject_booking: Oaa,
  user_needs_to_confirm_or_reject_booking_recurring: Paa,
  meeting_is_scheduled: Iaa,
  meeting_is_scheduled_recurring: Raa,
  booking_submitted: Naa,
  booking_submitted_recurring: Daa,
  booking_confirmed: Maa,
  booking_confirmed_recurring: Laa,
  warning_recurring_event_payment: qaa,
  warning_payment_recurring_event: jaa,
  enter_new_password: Faa,
  reset_password: Vaa,
  change_your_password: Baa,
  show_password: Uaa,
  hide_password: Waa,
  try_again: Gaa,
  request_is_expired: Haa,
  reset_instructions: Kaa,
  request_is_expired_instructions: Yaa,
  whoops: Zaa,
  login: Qaa,
  success: Jaa,
  failed: Xaa,
  password_has_been_reset_login: esa,
  layout: tsa,
  bookerlayout_default_title: nsa,
  bookerlayout_description: osa,
  bookerlayout_user_settings_title: rsa,
  bookerlayout_user_settings_description: isa,
  bookerlayout_month_view: asa,
  bookerlayout_week_view: ssa,
  bookerlayout_column_view: csa,
  bookerlayout_error_min_one_enabled: lsa,
  bookerlayout_error_default_not_enabled: dsa,
  bookerlayout_error_unknown_layout: usa,
  bookerlayout_override_global_settings: _sa,
  unexpected_error_try_again: psa,
  sunday_time_error: msa,
  monday_time_error: fsa,
  tuesday_time_error: gsa,
  wednesday_time_error: hsa,
  thursday_time_error: vsa,
  friday_time_error: bsa,
  saturday_time_error: ysa,
  error_end_time_before_start_time: $sa,
  error_end_time_next_day: wsa,
  back_to_bookings: ksa,
  free_to_pick_another_event_type: Ssa,
  cancelled: xsa,
  no_booking: Esa,
  awaiting_host: Tsa,
  cancellation_successful: Asa,
  really_cancel_booking: Csa,
  cannot_cancel_booking: zsa,
  reschedule_instead: Osa,
  event_is_in_the_past: Psa,
  cancelling_event_recurring: Isa,
  cancelling_all_recurring: Rsa,
  error_with_status_code_occured: Nsa,
  error_event_type_url_duplicate: Dsa,
  error_event_type_unauthorized_create: Msa,
  error_event_type_unauthorized_update: Lsa,
  error_workflow_unauthorized_create: qsa,
  error_schedule_unauthorized_create: jsa,
  booking_already_cancelled: Fsa,
  booking_already_accepted_rejected: Vsa,
  go_back_home: Bsa,
  or_go_back_home: Usa,
  no_meeting_found: Wsa,
  no_meeting_found_description: Gsa,
  no_status_bookings_yet: Hsa,
  no_status_bookings_yet_description: Ksa,
  event_between_users: Ysa,
  bookings: Zsa,
  booking_not_found: Qsa,
  bookings_description: Jsa,
  upcoming_bookings: Xsa,
  recurring_bookings: eca,
  past_bookings: tca,
  cancelled_bookings: nca,
  unconfirmed_bookings: oca,
  unconfirmed_bookings_tooltip: rca,
  on: ica,
  and: aca,
  calendar_shows_busy_between: sca,
  troubleshoot: cca,
  troubleshoot_description: lca,
  overview_of_day: dca,
  hover_over_bold_times_tip: uca,
  start_time: _ca,
  end_time: pca,
  buffer_time: mca,
  before_event: fca,
  after_event: gca,
  event_buffer_default: hca,
  buffer: vca,
  your_day_starts_at: bca,
  your_day_ends_at: yca,
  launch_troubleshooter: $ca,
  troubleshoot_availability: wca,
  change_available_times: kca,
  change_your_available_times: Sca,
  change_start_end: xca,
  change_start_end_buffer: Eca,
  current_start_date: Tca,
  start_end_changed_successfully: Aca,
  and_end_at: Cca,
  light: zca,
  dark: Oca,
  automatically_adjust_theme: Pca,
  user_dynamic_booking_disabled: Ica,
  allow_dynamic_booking_tooltip: Rca,
  allow_dynamic_booking: Nca,
  dynamic_booking: Dca,
  allow_seo_indexing: Mca,
  seo_indexing: Lca,
  allow_browser_notifications: qca,
  you_have_denied_notifications: jca,
  disable_browser_notifications: Fca,
  browser_notifications_turned_on: Vca,
  browser_notifications_turned_off: Bca,
  browser_notifications_denied: Uca,
  please_allow_notifications: Wca,
  push_notifications: Gca,
  push_notifications_description: Hca,
  browser_notifications_not_supported: Kca,
  email: Yca,
  email_placeholder: Zca,
  full_name: Qca,
  browse_api_documentation: Jca,
  leverage_our_api: Xca,
  create_webhook: ela,
  instant_meeting: tla,
  booking_cancelled: nla,
  booking_rescheduled: ola,
  recording_ready: rla,
  recording_transcription_generated: ila,
  booking_created: ala,
  booking_rejected: sla,
  booking_requested: cla,
  booking_payment_initiated: lla,
  meeting_ended: dla,
  form_submitted: ula,
  form_submitted_no_event: _la,
  booking_paid: pla,
  ooo_created: mla,
  booking_no_show_updated: fla,
  event_triggers: gla,
  subscriber_url: hla,
  create_new_webhook: vla,
  webhooks: bla,
  team_webhooks: yla,
  create_new_webhook_to_account: $la,
  new_webhook: wla,
  receive_cal_meeting_data: kla,
  receive_cal_event_meeting_data: Sla,
  responsive_fullscreen_iframe: xla,
  loading: Ela,
  deleting: Tla,
  standard_iframe: Ala,
  developer: Cla,
  manage_developer_settings: zla,
  iframe_embed: Ola,
  embed_calcom: Pla,
  integrate_using_embed_or_webhooks: Ila,
  schedule_a_meeting: Rla,
  view_and_manage_billing_details: Nla,
  view_and_edit_billing_details: Dla,
  go_to_billing_portal: Mla,
  need_anything_else: Lla,
  further_billing_help: qla,
  contact: jla,
  our_support_team: Fla,
  contact_our_support_team: Vla,
  uh_oh: Bla,
  no_event_types_have_been_setup: Ula,
  edit_logo: Wla,
  upload_a_logo: Gla,
  upload_logo: Hla,
  remove_logo: Kla,
  enable: Yla,
  code: Zla,
  code_is_incorrect: Qla,
  add_time_availability: Jla,
  add_an_extra_layer_of_security: Xla,
  "2fa": "Tweestapsverificatie",
  "2fa_disabled": "Tweestapsverificatie kan alleen worden ingeschakeld voor e-mail- en wachtwoordverificatie",
  enable_2fa: eda,
  disable_2fa: tda,
  disable_2fa_recommendation: nda,
  error_disabling_2fa: oda,
  error_enabling_2fa: rda,
  security: ida,
  manage_account_security: ada,
  password: sda,
  password_updated_successfully: cda,
  password_has_been_changed: lda,
  error_changing_password: dda,
  session_timeout_changed: uda,
  session_timeout_change_error: _da,
  something_went_wrong: pda,
  something_doesnt_look_right: mda,
  please_try_again: fda,
  super_secure_new_password: gda,
  new_password: hda,
  your_old_password: vda,
  current_password: bda,
  change_password: yda,
  change_secret: $da,
  new_password_matches_old_password: wda,
  forgotten_secret_description: kda,
  current_incorrect_password: Sda,
  password_hint_caplow: xda,
  password_hint_min: Eda,
  password_hint_admin_min: Tda,
  password_hint_num: Ada,
  max_limit_allowed_hint: Cda,
  invalid_password_hint: zda,
  incorrect_password: Oda,
  incorrect_email_password: Pda,
  use_setting: Ida,
  am_pm: Rda,
  time_options: Nda,
  january: Dda,
  february: Mda,
  march: Lda,
  april: qda,
  may: jda,
  june: Fda,
  july: Vda,
  august: Bda,
  september: Uda,
  october: Wda,
  november: Gda,
  december: Hda,
  monday: Kda,
  tuesday: Yda,
  wednesday: Zda,
  thursday: Qda,
  friday: Jda,
  saturday: Xda,
  sunday: eua,
  all_booked_today: tua,
  slots_load_fail: nua,
  additional_guests: oua,
  your_name: rua,
  your_full_name: iua,
  no_name: aua,
  enter_number_between_range: sua,
  continue_as_guest_description: cua,
  email_address: lua,
  enter_valid_email: dua,
  please_schedule_future_call: uua,
  location: _ua,
  address: pua,
  enter_address: mua,
  in_person_attendee_address: fua,
  somewhere_else: gua,
  custom_attendee_location: hua,
  continue_as_guest: vua,
  join_as_guest: bua,
  ideal_for_one_time_calls: yua,
  any_location: $ua,
  yes: wua,
  no: kua,
  additional_notes: Sua,
  booking_fail: xua,
  reschedule_fail: Eua,
  share_additional_notes: Tua,
  booking_confirmation: Aua,
  booking_reschedule_confirmation: Cua,
  in_person_meeting: zua,
  in_person: Oua,
  link_meeting: Pua,
  phone_number: Iua,
  attendee_phone_number: Rua,
  organizer_phone_number: Nua,
  enter_phone_number: Dua,
  reschedule: Mua,
  reschedule_this: Lua,
  book_a_team_member: qua,
  or: jua,
  go_back: Fua,
  email_or_username: Vua,
  send_invite_email: Bua,
  role: Uua,
  edit_role: Wua,
  view_role: Gua,
  edit_team: Hua,
  editing_user: Kua,
  editing_org: Yua,
  edit_or_manage_webhooks: Zua,
  reject: Qua,
  reject_all: Jua,
  accept: Xua,
  leave: e_a,
  profile: t_a,
  my_team_url: n_a,
  my_teams: o_a,
  team_name: r_a,
  your_team_name: i_a,
  team_updated_successfully: a_a,
  your_team_updated_successfully: s_a,
  your_org_updated_successfully: c_a,
  error_copying_to_clipboard: l_a,
  about: d_a,
  team_description: u_a,
  organization_id: __a,
  organization_id_copied: p_a,
  org_description: m_a,
  team_id: f_a,
  team_id_copied: g_a,
  members: h_a,
  organization_members: v_a,
  member: b_a,
  number_member_one: y_a,
  number_member_other: $_a,
  number_selected: w_a,
  owner: k_a,
  admin: S_a,
  admin_api: x_a,
  administrator_user: E_a,
  lets_create_first_administrator_user: T_a,
  admin_user_created: A_a,
  admin_user_created_description: C_a,
  new_member: z_a,
  invite: O_a,
  add_team_members: P_a,
  add_org_members: I_a,
  add_team_members_description: R_a,
  add_team_member: N_a,
  invite_new_member: D_a,
  invite_new_member_description: M_a,
  invite_new_team_member: L_a,
  upload_csv_file: q_a,
  invite_via_email: j_a,
  change_member_role: F_a,
  disable_cal_branding: V_a,
  disable_cal_branding_description: B_a,
  hide_book_a_team_member: U_a,
  hide_book_a_team_member_description: W_a,
  danger_zone: G_a,
  account_deletion_cannot_be_undone: H_a,
  team_deletion_cannot_be_undone: K_a,
  back: Y_a,
  cancel: Z_a,
  cancel_all_remaining: Q_a,
  apply: J_a,
  cancel_event: X_a,
  continue: "Doorgaan",
  confirm: epa,
  confirm_all: tpa,
  disband_team: npa,
  disband_team_confirmation_message: opa,
  disband_org: rpa,
  disband_org_confirmation_message: ipa,
  remove_member_confirmation_message: apa,
  confirm_disband_team: spa,
  confirm_remove_member: cpa,
  confirm_subscription_cancellation: lpa,
  cancel_subscription: dpa,
  cancel_subscription_description: upa,
  remove_member: _pa,
  manage_your_team: ppa,
  no_teams: mpa,
  no_teams_description: fpa,
  submit: gpa,
  confirm_remove_attribute: hpa,
  remove_attribute: vpa,
  remove_attribute_confirmation_message: bpa,
  delete: "Verwijderen",
  update: ypa,
  save: $pa,
  pending: wpa,
  open_options: kpa,
  copy_link: Spa,
  share: xpa,
  share_event: Epa,
  copy_link_team: Tpa,
  leave_team: Apa,
  confirm_leave_team: Cpa,
  leave_team_confirmation_message: zpa,
  user_from_team: Opa,
  preview: Ppa,
  link_copied: Ipa,
  copied: Rpa,
  private_link_copied: Npa,
  link_shared: Dpa,
  title: Mpa,
  description: Lpa,
  apps_status: qpa,
  quick_video_meeting: jpa,
  scheduling_type: Fpa,
  preview_team: Vpa,
  collective: Bpa,
  collective_description: Upa,
  duration: Wpa,
  available_durations: Gpa,
  default_duration: Hpa,
  default_duration_no_options: Kpa,
  multiple_duration_mins: Ypa,
  multiple_duration_timeUnit: Zpa,
  multiple_duration_timeUnit_short: Qpa,
  minutes: Jpa,
  use_cal_ai_to_make_call_description: Xpa,
  termination_uri: ema,
  sip_trunk_username: tma,
  sip_trunk_password: nma,
  nickname: oma,
  delete_phone_number: rma,
  workflow_validation_failed: ima,
  workflow_validation_empty_fields: ama,
  workflow_validation_unverified_contacts: sma,
  supercharge_your_workflows_with_cal_ai: cma,
  supercharge_your_workflows_with_cal_ai_description: lma,
  phone_number_imported_successfully: dma,
  phone_number_deleted_successfully: uma,
  delete_phone_number_confirmation: _ma,
  yes_delete_phone_number: pma,
  phone_number_info_tooltip: mma,
  termination_uri_info_tooltip: fma,
  sip_trunk_username_info_tooltip: gma,
  sip_trunk_password_info_tooltip: hma,
  nickname_info_tooltip: vma,
  save_and_test_call: bma,
  call_initiated_successfully: yma,
  please_enter_phone_number: $ma,
  agent_updated_successfully: wma,
  agent_created_successfully: kma,
  agent_event_type_updated_successfully: Sma,
  phone_number_unsubscribed_successfully: xma,
  general_prompt_description: Ema,
  prompt: Tma,
  call_to: Ama,
  make_test_call_to_verify_configuration: Cma,
  initial_message: zma,
  initial_message_description: Oma,
  having_trouble_importing: Pma,
  learn: Ima,
  learn_how_to_get_your_terminator: Rma,
  phone_number_subscription_cancelled_successfully: Nma,
  updating: Dma,
  round_robin: Mma,
  hi_how_are_you_doing: Lma,
  round_robin_description: qma,
  managed_event: jma,
  username_placeholder: Fma,
  managed_event_description: Vma,
  managed: Bma,
  managed_event_url_clarification: Uma,
  assign_to: Wma,
  enter_phone_number_to_test_call: Gma,
  make_test_call: Hma,
  create_new_workflow_agent: Kma,
  create_new_workflow_agent_description: Yma,
  phone_number_for_ai_call: Zma,
  buy_a_phone_number_or_import_one_you_already_have: Qma,
  test_agent: Jma,
  test_web_call: Xma,
  phone_numbers: efa,
  unsubscribe: tfa,
  delete_workflow_step: nfa,
  unsubscribe_phone_number: ofa,
  buy_a_new_number: rfa,
  only_us_phone_numbers_can_be_purchased_here: ifa,
  buy_number_for_x_per_month: afa,
  supported_call_destinations: sfa,
  no_phone_number_connected: cfa,
  failed_to_get_workflow_step_id: lfa,
  cal_ai_agent: dfa,
  test_cal_ai_agent: ufa,
  are_you_sure_you_want_to_delete_workflow_step: _fa,
  do_you_still_want_to_unsubscribe: pfa,
  the_action_will_disconnect_phone_number: mfa,
  cal_ai_phone_numbers: ffa,
  connect_phone_number: gfa,
  cal_ai_phone_numbers_description: hfa,
  import_number: vfa,
  this_action_will_also: bfa,
  import_phone_number: yfa,
  active_subscription: $fa,
  cancel_your_phone_number_subscription: wfa,
  delete_associated_phone_number: kfa,
  unauthorized_create_workflow: Sfa,
  import_phone_number_description: xfa,
  phone_number_cost: Efa,
  buy_new_number: Tfa,
  buy_number_cost_x_per_month: Afa,
  area_code_optional: Cfa,
  no_phone_numbers: zfa,
  phone_number_purchased_successfully: Ofa,
  cancel_phone_number_subscription: Pfa,
  yes_cancel_subscription: Ifa,
  cancel_phone_number_subscription_confirmation: Rfa,
  add_members: Nfa,
  add_members_no_ellipsis: Dfa,
  no_assigned_members: Mfa,
  assigned_to: Lfa,
  you_must_be_logged_in_to: qfa,
  start_assigning_members_above: jfa,
  locked_fields_admin_description: Ffa,
  unlocked_fields_admin_description: Vfa,
  locked_fields_member_description: Bfa,
  unlocked_fields_member_description: Ufa,
  url: Wfa,
  hidden: Gfa,
  readonly: Hfa,
  one_time_link: Kfa,
  plan_description: Yfa,
  plan_upgrade_invitation: Zfa,
  plan_upgrade: Qfa,
  plan_upgrade_teams: Jfa,
  plan_upgrade_instructions: Xfa,
  event_types_page_title: ega,
  event_types_page_subtitle: tga,
  new: "Nieuw",
  new_event_type_btn: nga,
  new_event_type_heading: oga,
  new_event_type_description: rga,
  event_type_created_successfully: iga,
  event_type_updated_successfully: aga,
  event_type_deleted_successfully: sga,
  hours: cga,
  people: lga,
  your_email: dga,
  change_avatar: uga,
  upload_avatar: _ga,
  language: pga,
  timezone: mga,
  first_day_of_week: fga,
  repeats_up_to_one: gga,
  repeats_up_to_other: hga,
  every_for_freq: vga,
  event_remaining_one: bga,
  event_remaining_other: yga,
  repeats_every: $ga,
  occurrence_one: wga,
  occurrence_other: kga,
  weekly_one: Sga,
  weekly_other: xga,
  monthly_one: Ega,
  monthly_other: Tga,
  yearly_one: Aga,
  yearly_other: Cga,
  plus_more: zga,
  max: Oga,
  single_theme: Pga,
  brand_color: Iga,
  light_brand_color: Rga,
  dark_brand_color: Nga,
  light_event_type_color: Dga,
  dark_event_type_color: Mga,
  file_not_named: Lga,
  create_team: qga,
  name: jga,
  nameless_team: Fga,
  oauth_clients: Vga,
  oauth_clients_description: Bga,
  create_oauth_client: Uga,
  create_oauth_client_description: Wga,
  oauth_client_deletion_message: Gga,
  create_new_team_description: Hga,
  create_new_team: Kga,
  booking_redirect_uri: Yga,
  booking_cancel_redirect_uri: Zga,
  booking_reschedule_redirect_uri: Qga,
  booking_conflict_error: Jga,
  open_invitations: Xga,
  new_team: eha,
  create_first_team_and_invite_others: tha,
  create_team_to_get_started: nha,
  teams: oha,
  team: rha,
  organization: iha,
  team_billing: aha,
  team_billing_description: sha,
  upgrade_to_flexible_pro_title: cha,
  upgrade_to_flexible_pro_message: lha,
  changed_team_billing_info: dha,
  create_manage_teams_collaborative: uha,
  only_available_on_pro_plan: _ha,
  remove_cal_branding_description: pha,
  edit_profile_info_description: mha,
  change_email_tip: fha,
  little_something_about: gha,
  profile_updated_successfully: hha,
  your_user_profile_updated_successfully: vha,
  your_upgrade_is_here: bha,
  your_upgrade_is_here_description: yha,
  you_are_all_set: $ha,
  you_are_all_set_description: wha,
  user_cannot_found_db: kha,
  embed_and_webhooks: Sha,
  enabled: xha,
  disabled: Eha,
  disable: Tha,
  billing: Aha,
  here: Cha,
  manage_your_billing_info: zha,
  availability: Oha,
  edit_availability: Pha,
  configure_availability: Iha,
  copy_times_to: Rha,
  copy_times_to_tooltip: Nha,
  change_weekly_schedule: Dha,
  logo: Mha,
  error: Lha,
  at_least_characters_one: qha,
  at_least_characters_other: jha,
  team_logo: Fha,
  add_location: Vha,
  attendees: Bha,
  add_attendees: Uha,
  show_advanced_settings: Wha,
  hide_advanced_settings: Gha,
  event_name: Hha,
  event_name_in_calendar: Kha,
  event_name_tooltip: Yha,
  meeting_with_user: Zha,
  additional_inputs: Qha,
  additional_input_description: Jha,
  label: Xha,
  placeholder: eva,
  display_add_to_calendar_organizer: tva,
  display_email_as_organizer: nva,
  if_enabled_email_address_as_organizer: ova,
  reconnect_calendar_to_use: rva,
  type: iva,
  edit: ava,
  add_input: sva,
  disable_notes: cva,
  disable_notes_description: lva,
  requires_confirmation_description: dva,
  requires_confirmation_will_block_slot_description: uva,
  recurring_event: _va,
  recurring_event_description: pva,
  connect_and_join: mva,
  cannot_be_used_with_paid_event_types: fva,
  warning_payment_instant_meeting_event: gva,
  warning_instant_meeting_experimental: hva,
  starting: vva,
  disable_guests: bva,
  disable_guests_description: yva,
  private_link: $va,
  enable_private_url: wva,
  private_link_label: kva,
  private_link_hint: Sva,
  copy_private_link: xva,
  copy_private_link_to_event: Eva,
  private_link_description: Tva,
  multiple_private_links_title: Ava,
  multiple_private_links_description: Cva,
  add_a_multiple_private_link: zva,
  multiple_private_link_copied: Ova,
  invitees_can_schedule: Pva,
  date_range: Iva,
  calendar_days: Rva,
  business_days: Nva,
  set_address_place: Dva,
  set_link_meeting: Mva,
  managed_event_field_parent_control_disabled: Lva,
  cal_invitee_phone_number_scheduling: qva,
  cal_provide_google_meet_location: jva,
  cal_provide_zoom_meeting_url: Fva,
  cal_provide_tandem_meeting_url: Vva,
  cal_provide_video_meeting_url: Bva,
  cal_provide_jitsi_meeting_url: Uva,
  cal_provide_huddle01_meeting_url: Wva,
  cal_provide_teams_meeting_url: Gva,
  require_payment: Hva,
  you_need_to_add_a_name: Kva,
  commission_per_transaction: Yva,
  event_type_updated_successfully_description: Zva,
  hide_event_type: Qva,
  edit_location: Jva,
  into_the_future: Xva,
  when_booked_with_less_than_notice: eba,
  within_date_range: tba,
  indefinitely_into_future: nba,
  add_new_custom_input_field: oba,
  quick_chat: rba,
  add_new_team_event_type: iba,
  add_new_event_type: aba,
  new_event_type_to_book_description: sba,
  length: cba,
  minimum_booking_notice: lba,
  offset_toggle: dba,
  offset_toggle_description: uba,
  offset_start: _ba,
  offset_start_description: pba,
  slot_interval: mba,
  slot_interval_default: fba,
  delete_event_type: gba,
  delete_managed_event_type: hba,
  delete_event_type_description: vba,
  delete_managed_event_type_description_1: bba,
  delete_managed_event_type_description_2: yba,
  confirm_delete_event_type: $ba,
  delete_account: wba,
  confirm_delete_account: kba,
  delete_account_confirmation_message: Sba,
  integrations: xba,
  apps: Eba,
  apps_description: Tba,
  apps_listing: Aba,
  category_apps: Cba,
  app_store: zba,
  app_store_description: Oba,
  connect_your_video: Pba,
  settings: Iba,
  event_type_moved_successfully: Rba,
  next_step_text: Nba,
  next_step: Dba,
  prev_step: Mba,
  install: Lba,
  start_paid_trial: qba,
  installed: jba,
  active_install_one: Fba,
  active_install_other: Vba,
  globally_install: Bba,
  app_successfully_installed: Uba,
  app_could_not_be_installed: Wba,
  disconnect: Gba,
  embed_your_calendar: Hba,
  connect_your_favourite_apps: Kba,
  automation: Yba,
  configure_how_your_event_types_interact: Zba,
  toggle_calendars_conflict: Qba,
  connect_additional_calendar: Jba,
  calendar_updated_successfully: Xba,
  check_here: eya,
  conferencing: tya,
  calendar: nya,
  payments: oya,
  not_installed: rya,
  error_password_mismatch: iya,
  error_required_field: aya,
  status: sya,
  team_view_user_availability: cya,
  team_view_user_availability_disabled: lya,
  set_as_away: dya,
  set_as_free: uya,
  toggle_away_error: _ya,
  user_away: pya,
  user_away_description: mya,
  meet_people_with_the_same_tokens: fya,
  only_book_people_and_allow: gya,
  account_created_with_identity_provider: hya,
  account_managed_by_identity_provider: vya,
  account_managed_by_identity_provider_description: bya,
  account_managed_by_identity_provider_error: yya,
  user_creation_error: $ya,
  signin_with_google: wya,
  signin_with_saml: kya,
  signin_with_saml_oidc: Sya,
  continue_with_email: xya,
  continue_with_google: Eya,
  last_used: Tya,
  you_will_need_to_generate: Aya,
  import: "Importeren",
  import_from: Cya,
  access_token: zya,
  visit_roadmap: Oya,
  featured_categories: Pya,
  feature_flags: Iya,
  admin_flags_description: Rya,
  popular_categories: Nya,
  number_apps_one: Dya,
  number_apps_other: Mya,
  trending_apps: Lya,
  most_popular: qya,
  installed_apps: jya,
  free_to_use_apps: Fya,
  no_category_apps: Vya,
  all_apps: Bya,
  no_category_apps_description_calendar: Uya,
  no_category_apps_description_conferencing: Wya,
  no_category_apps_description_payment: Gya,
  no_category_apps_description_analytics: Hya,
  no_category_apps_description_automation: Kya,
  no_category_apps_description_other: Yya,
  no_category_apps_description_messaging: Zya,
  no_category_apps_description_crm: Qya,
  installed_app_calendar_description: Jya,
  installed_app_payment_description: Xya,
  installed_app_analytics_description: e$a,
  installed_app_other_description: t$a,
  installed_app_conferencing_description: n$a,
  installed_app_automation_description: o$a,
  installed_app_messaging_description: r$a,
  installed_app_crm_description: i$a,
  analytics: a$a,
  empty_installed_apps_headline: s$a,
  empty_installed_apps_description: c$a,
  empty_installed_apps_button: l$a,
  manage_your_connected_apps: d$a,
  browse_apps: u$a,
  features: _$a,
  permissions: p$a,
  terms_and_privacy: m$a,
  published_by: f$a,
  subscribe: g$a,
  buy: h$a,
  install_app: v$a,
  categories: b$a,
  pricing: y$a,
  learn_more: $$a,
  try_now: w$a,
  privacy_policy: k$a,
  terms_of_service: S$a,
  remove: x$a,
  add: E$a,
  installed_other: T$a,
  verify_wallet: A$a,
  create_events_on: C$a,
  enterprise_license: z$a,
  enterprise_license_locally: O$a,
  enterprise_license_sales: P$a,
  missing_license: I$a,
  next_steps: R$a,
  acquire_commercial_license: N$a,
  the_infrastructure_plan: D$a,
  prisma_studio_tip: M$a,
  prisma_studio_tip_description: L$a,
  contact_sales: q$a,
  error_404: j$a,
  default: "standaard keuze",
  set_to_default: F$a,
  new_schedule_btn: V$a,
  add_new_schedule: B$a,
  add_new_calendar: U$a,
  set_calendar: W$a,
  delete_schedule: G$a,
  delete_schedule_description: H$a,
  schedule_created_successfully: K$a,
  availability_updated_successfully: Y$a,
  schedule_deleted_successfully: Z$a,
  default_schedule_name: Q$a,
  new_schedule_heading: J$a,
  new_schedule_description: X$a,
  requires_ownership_of_a_token: ewa,
  example_name: twa,
  time_format: nwa,
  "12_hour": "12 uur",
  "24_hour": "24 uur",
  "12_hour_short": "12 uur",
  "24_hour_short": "24u",
  redirect_success_booking: owa,
  you_are_being_redirected: rwa,
  external_redirect_url: iwa,
  redirect_url_description: awa,
  duplicate: swa,
  offer_seats: cwa,
  offer_seats_description: lwa,
  seats_available_one: dwa,
  seats_available_other: uwa,
  seats_nearly_full: _wa,
  seats_half_full: pwa,
  number_of_seats: mwa,
  set_instant_meeting_expiry_time_offset_description: fwa,
  enter_number_of_seats: gwa,
  you_can_manage_your_schedules: hwa,
  booking_full: vwa,
  api_keys: bwa,
  api_key: ywa,
  test_api_key: $wa,
  test_passed: wwa,
  test_failed: kwa,
  provide_api_key: Swa,
  api_key_modal_subtitle: xwa,
  api_key_modal_subtitle_platform: Ewa,
  api_keys_subtitle: Twa,
  create_api_key: Awa,
  personal_note: Cwa,
  personal_note_placeholder: zwa,
  api_key_no_note: Owa,
  api_key_never_expires: Pwa,
  edit_api_key: Iwa,
  success_api_key_created: Rwa,
  success_api_key_edited: Nwa,
  create: Dwa,
  success_api_key_created_bold_tagline: Mwa,
  you_will_only_view_it_once: Lwa,
  copy_to_clipboard: qwa,
  enabled_after_update: jwa,
  enabled_after_update_description: Fwa,
  confirm_delete_api_key: Vwa,
  disable_rescheduling: Bwa,
  description_disable_rescheduling: Uwa,
  allow_rescheduling_cancelled_bookings: Wwa,
  description_allow_rescheduling_cancelled_bookings: Gwa,
  disable_cancelling: Hwa,
  description_disable_cancelling: Kwa,
  revoke_api_key: Ywa,
  api_key_copied: Zwa,
  api_key_expires_on: Qwa,
  delete_api_key_confirm_title: Jwa,
  copy: Xwa,
  expire_date: e0a,
  expired: t0a,
  never_expires: n0a,
  expires: o0a,
  request_reschedule_booking: r0a,
  reason_for_reschedule: i0a,
  book_a_new_time: a0a,
  reschedule_request_sent: s0a,
  reschedule_modal_description: c0a,
  reason_for_reschedule_request: l0a,
  send_reschedule_request: d0a,
  edit_booking: u0a,
  reschedule_booking: _0a,
  former_time: p0a,
  confirmation_page_gif: m0a,
  search: f0a,
  impersonate: g0a,
  user_impersonation_heading: h0a,
  user_impersonation_description: v0a,
  team_impersonation_description: b0a,
  cal_signup_description: y0a,
  make_org_private: $0a,
  make_org_private_description: w0a,
  make_team_private: k0a,
  make_team_private_description: S0a,
  you_cannot_see_team_members: x0a,
  you_cannot_see_teams_of_org: E0a,
  allow_multiple_durations: T0a,
  impersonate_user_tip: A0a,
  impersonating_user_warning: C0a,
  impersonating_stop_instructions: z0a,
  event_location_changed: O0a,
  new_guests_added: P0a,
  location_changed_event_type_subject: I0a,
  guests_added_event_type_subject: R0a,
  current_location: N0a,
  new_location: D0a,
  session: M0a,
  session_description: L0a,
  session_timeout_after: q0a,
  session_timeout: j0a,
  session_timeout_description: F0a,
  no_location: V0a,
  set_location: B0a,
  update_location: U0a,
  location_updated: W0a,
  location_update_failed: G0a,
  guests_added: H0a,
  unable_to_add_guests: K0a,
  email_validation_error: Y0a,
  emails_must_be_unique_valid: Z0a,
  url_validation_error: Q0a,
  place_where_cal_widget_appear: J0a,
  create_update_react_component: X0a,
  copy_code: eka,
  code_copied: tka,
  how_you_want_add_cal_site: nka,
  choose_ways_put_cal_site: oka,
  setting_up_zapier: rka,
  setting_up_make: ika,
  generate_api_key: aka,
  generate_api_key_description: ska,
  your_unique_api_key: cka,
  copy_safe_api_key: lka,
  zapier_setup_instructions: dka,
  make_setup_instructions_1: uka,
  make_setup_instructions_2: _ka,
  make_setup_instructions_3: pka,
  make_setup_instructions_4: mka,
  make_setup_instructions_5: fka,
  make_setup_instructions_6: gka,
  install_zapier_app: hka,
  install_make_app: vka,
  app_installation: bka,
  app_not_installed: yka,
  visit_our_app_store: $ka,
  connect_apple_server: wka,
  calendar_url: kka,
  apple_server_generate_password: Ska,
  unable_to_add_apple_calendar: xka,
  credentials_stored_encrypted: Eka,
  it_stored_encrypted: Tka,
  go_to_app_store: Aka,
  calendar_error: Cka,
  set_your_phone_number: zka,
  calendar_no_busy_slots: Oka,
  display_location_label: Pka,
  display_location_info_badge: Ika,
  add_gif: Rka,
  search_giphy: Nka,
  add_link_from_giphy: Dka,
  add_gif_to_confirmation: Mka,
  find_gif_spice_confirmation: Lka,
  share_feedback: qka,
  resources: jka,
  support_documentation: Fka,
  developer_documentation: Vka,
  get_in_touch: Bka,
  contact_support: Uka,
  premium_support: Wka,
  community_support: Gka,
  feedback: Hka,
  submitted_feedback: Kka,
  feedback_error: Yka,
  comments: Zka,
  booking_details: Qka,
  or_lowercase: Jka,
  nevermind: Xka,
  go_to: e1a,
  zapier_invite_link: t1a,
  meeting_url_provided_after_confirmed: n1a,
  dynamically_display_attendee_or_organizer: o1a,
  event_location: r1a,
  reschedule_optional: i1a,
  reschedule_placeholder: a1a,
  event_cancelled: s1a,
  emailed_information_about_cancelled_event: c1a,
  this_input_will_shown_booking_this_event: l1a,
  meeting_url_in_confirmation_email: d1a,
  url_start_with_https: u1a,
  number_provided: _1a,
  before_event_trigger: p1a,
  event_cancelled_trigger: m1a,
  after_hosts_cal_video_no_show: f1a,
  after_guests_cal_video_no_show: g1a,
  join_video_call: h1a,
  sign_in_to_cal_com: v1a,
  log_in_to_cal_com: b1a,
  track_your_meetings: y1a,
  track_meetings_and_manage_schedule: $1a,
  failed_to_join_call: w1a,
  choose_how_you_d_like_to_join_call: k1a,
  choose_how_you_d_like_to_appear_on_the_call: S1a,
  new_event_trigger: x1a,
  email_host_action: E1a,
  email_attendee_action: T1a,
  sms_attendee_action: A1a,
  sms_number_action: C1a,
  send_reminder_sms: z1a,
  whatsapp_number_action: O1a,
  whatsapp_attendee_action: P1a,
  workflows: I1a,
  new_workflow_btn: R1a,
  how_would_you_like_to_start: N1a,
  add_new_workflow: D1a,
  reschedule_event_trigger: M1a,
  trigger: L1a,
  triggers: q1a,
  action: j1a,
  workflows_to_automate_notifications: F1a,
  workflow_name: V1a,
  custom_workflow: B1a,
  workflow_created_successfully: U1a,
  delete_workflow_description: W1a,
  delete_workflow: G1a,
  confirm_delete_workflow: H1a,
  workflow_deleted_successfully: K1a,
  how_long_before: Y1a,
  day_timeUnit: Z1a,
  hour_timeUnit: Q1a,
  minute_timeUnit: J1a,
  minute_short: X1a,
  hour_short: e2a,
  new_workflow_heading: t2a,
  new_workflow_description: n2a,
  active_on: o2a,
  workflow_updated_successfully: r2a,
  premium_to_standard_username_description: i2a,
  premium_username: a2a,
  current: s2a,
  premium: c2a,
  standard: l2a,
  confirm_username_change_dialog_title: d2a,
  change_username_standard_to_premium: u2a,
  change_username_premium_to_standard: _2a,
  go_to_stripe_billing: p2a,
  stripe_description: m2a,
  trial_expired: f2a,
  remove_app: g2a,
  yes_remove_app: h2a,
  are_you_sure_you_want_to_remove_this_app: v2a,
  app_removed_successfully: b2a,
  error_removing_app: y2a,
  web_conference: $2a,
  web_call: w2a,
  start_web_call: k2a,
  end_call: S2a,
  test_your_agent_with_web_call: x2a,
  phone_call: E2a,
  connecting_to_agent: T2a,
  call_active: A2a,
  call_ended: C2a,
  call_error: z2a,
  ready_to_start_call: O2a,
  failed_to_start_web_call_try_again: P2a,
  call_encountered_error_try_again: I2a,
  failed_initialize_web_call_microphone_permissions: R2a,
  start_call_to_see_conversation: N2a,
  waiting_for_conversation: D2a,
  ai_agent: M2a,
  live: L2a,
  connecting: q2a,
  requires_confirmation: j2a,
  requires_confirmation_threshold: F2a,
  may_require_confirmation: V2a,
  nr_event_type_one: B2a,
  nr_event_type_other: U2a,
  count_team_one: W2a,
  count_team_other: G2a,
  add_action: H2a,
  set_whereby_link: K2a,
  invalid_whereby_link: Y2a,
  set_around_link: Z2a,
  invalid_around_link: Q2a,
  set_riverside_link: J2a,
  invalid_riverside_link: X2a,
  invalid_ping_link: eSa,
  add_exchange2013: tSa,
  add_exchange2016: nSa,
  custom_template: oSa,
  email_body: rSa,
  text_message: iSa,
  specific_issue: aSa,
  browse_our_docs: sSa,
  choose_template: cSa,
  custom: lSa,
  reminder: dSa,
  rescheduled: uSa,
  rescheduled_by: _Sa,
  original_booking: pSa,
  completed: mSa,
  rating: fSa,
  reminder_email: gSa,
  not_triggering_existing_bookings: hSa,
  minute_one: vSa,
  minute_one_short: bSa,
  minute_other: ySa,
  hour_one: $Sa,
  hour_one_short: wSa,
  hour_other: kSa,
  invalid_input: SSa,
  broken_video_action: xSa,
  broken_calendar_action: ESa,
  attendee_name: TSa,
  scheduler_full_name: ASa,
  broken_integration: CSa,
  problem_adding_video_link: zSa,
  problem_updating_calendar: OSa,
  active_on_event_types_one: PSa,
  active_on_event_types_other: ISa,
  active_on_teams_one: RSa,
  active_on_teams_other: NSa,
  active_on_all_event_types: DSa,
  active_on_all_teams: MSa,
  no_active_event_types: LSa,
  no_active_teams: qSa,
  new_seat_subject: jSa,
  new_seat_title: FSa,
  variable: VSa,
  event_name_variable: BSa,
  attendee_name_variable: USa,
  event_date_variable: WSa,
  event_time_variable: GSa,
  organizer_name_variable: HSa,
  app_upgrade_description: KSa,
  invalid_number: YSa,
  invalid_url_error_message: ZSa,
  navigate: QSa,
  open: JSa,
  close: XSa,
  upgrade: exa,
  buy_us_number_button: txa,
  upgrade_to_access_recordings_title: nxa,
  upgrade_to_access_recordings_description: oxa,
  upgrade_to_cal_ai_phone_number_description: rxa,
  recordings_are_part_of_the_teams_plan: ixa,
  team_feature_teams: axa,
  team_feature_workflows: sxa,
  show_eventtype_on_profile: cxa,
  embed: lxa,
  new_username: dxa,
  current_username: uxa,
  example_1: _xa,
  example_2: pxa,
  booking_question_identifier: mxa,
  company_size: fxa,
  what_help_needed: gxa,
  variable_format: hxa,
  webhook_subscriber_url_reserved: vxa,
  custom_input_as_variable_info: bxa,
  using_booking_questions_as_variables: yxa,
  download_desktop_app: $xa,
  set_ping_link: wxa,
  rate_limit_exceeded: kxa,
  when_something_happens: Sxa,
  action_is_performed: xxa,
  test_action: Exa,
  notification_sent: Txa,
  no_input: Axa,
  test_workflow_action: Cxa,
  send_sms: zxa,
  send_sms_to_number: Oxa,
  missing_connected_calendar: Pxa,
  connect_your_calendar_and_link: Ixa,
  default_calendar_selected: Rxa,
  hide_from_profile: Nxa,
  basics: Dxa,
  availability_not_found_in_schedule_error: Mxa,
  event_limit_tab_title: Lxa,
  event_limit_tab_description: qxa,
  event_advanced_tab_description: jxa,
  event_advanced_tab_title: Fxa,
  event_payments_tab_description: Vxa,
  event_setup_multiple_duration_error: Bxa,
  event_setup_multiple_duration_default_error: Uxa,
  event_setup_booking_limits_error: Wxa,
  event_setup_duration_limits_error: Gxa,
  select_which_cal: Hxa,
  custom_event_name: Kxa,
  custom_event_name_description: Yxa,
  "2fa_required": "Tweestapsverificatie vereist",
  incorrect_2fa: Zxa,
  which_event_type_apply: Qxa,
  apply_to_all_event_types: Jxa,
  apply_to_all_teams: Xxa,
  which_team_apply: eEa,
  no_workflows_description: tEa,
  timeformat_profile_hint: nEa,
  create_workflow: oEa,
  do_this: rEa,
  turn_off: iEa,
  turn_on: aEa,
  cancelled_bookings_cannot_be_rescheduled: sEa,
  settings_updated_successfully: cEa,
  error_updating_settings: lEa,
  personal_cal_url: dEa,
  bio_hint: uEa,
  finish_and_start: _Ea,
  user_has_no_bio: pEa,
  bio: mEa,
  delete_account_modal_title: fEa,
  confirm_delete_account_modal: gEa,
  delete_my_account: hEa,
  start_of_week: vEa,
  recordings_title: bEa,
  recording: yEa,
  happy_scheduling: $Ea,
  select_calendars: wEa,
  check_for_conflicts: kEa,
  view_recordings: SEa,
  check_for_recordings: xEa,
  adding_events_to: EEa,
  follow_system_preferences: TEa,
  custom_brand_colors: AEa,
  customize_your_brand_colors: CEa,
  pro: zEa,
  removes_cal_branding: OEa,
  instant_meeting_with_title: PEa,
  profile_picture: IEa,
  upload: REa,
  add_profile_photo: NEa,
  token_address: DEa,
  blockchain: MEa,
  old_password: LEa,
  secure_password: qEa,
  error_updating_password: jEa,
  two_factor_auth: FEa,
  recurring_event_tab_description: VEa,
  today: BEa,
  appearance: UEa,
  my_account: WEa,
  general: GEa,
  calendars: HEa,
  "2fa_auth": "Tweestapsverificatie",
  invoices: KEa,
  embeds: YEa,
  impersonation: ZEa,
  impersonation_description: QEa,
  recent_impersonations: JEa,
  quick_impersonate: XEa,
  no_recent_impersonations: eTa,
  users: tTa,
  user: nTa,
  profile_description: oTa,
  users_description: rTa,
  users_listing: iTa,
  general_description: aTa,
  calendars_description: sTa,
  appearance_description: cTa,
  conferencing_description: lTa,
  add_conferencing_app: dTa,
  password_description: uTa,
  set_up_two_factor_authentication: _Ta,
  we_just_need_basic_info: pTa,
  skip: mTa,
  do_this_later: fTa,
  set_availability_getting_started_subtitle_1: gTa,
  set_availability_getting_started_subtitle_2: hTa,
  connect_calendar_first: vTa,
  complete_profile: bTa,
  connect_calendars_from_app_store: yTa,
  connect_conference_apps: $Ta,
  connect_calendar_apps: wTa,
  connect_payment_apps: kTa,
  connect_automation_apps: STa,
  connect_analytics_apps: xTa,
  connect_other_apps: ETa,
  connect_messaging_apps: TTa,
  connect_crm_apps: ATa,
  current_step_of_total: CTa,
  add_variable: zTa,
  custom_phone_number: OTa,
  message_template: PTa,
  email_subject: ITa,
  add_dynamic_variables: RTa,
  event_name_info: NTa,
  event_date_info: DTa,
  event_duration_info: MTa,
  event_time_info: LTa,
  event_type_not_found: qTa,
  number_to_call_variable: jTa,
  number_to_call_info: FTa,
  location_variable: VTa,
  location_info: BTa,
  additional_notes_variable: UTa,
  additional_notes_info: WTa,
  attendee_name_info: GTa,
  organizer_name_info: HTa,
  to: KTa,
  workflow_turned_on_successfully: YTa,
  download_responses: ZTa,
  download_responses_description: QTa,
  view_responses: JTa,
  download: XTa,
  downloading: eAa,
  download_recording: tAa,
  transcription_enabled: nAa,
  transcription_stopped: oAa,
  download_transcript: rAa,
  transcript: iAa,
  recording_from_your_recent_call: aAa,
  transcript_from_previous_call: sAa,
  you_can_download_transcript_from_attachments: cAa,
  link_valid_for_12_hrs: lAa,
  link_valid_for_12_hrs_description: dAa,
  create_your_first_form: uAa,
  create_your_first_form_description: _Aa,
  create_your_first_webhook: pAa,
  create_your_first_webhook_description: mAa,
  for_a_maximum_of: fAa,
  event_one: gAa,
  event_other: hAa,
  profile_team_description: vAa,
  profile_org_description: bAa,
  members_team_description: yAa,
  organization_description: $Aa,
  team_url: wAa,
  team_members: kAa,
  more: SAa,
  cal_ai_workflows: xAa,
  and_count_more: EAa,
  more_page_footer: TAa,
  workflow_example_1: AAa,
  workflow_example_2: CAa,
  workflow_example_3: zAa,
  workflow_example_4: OAa,
  workflow_example_5: PAa,
  workflow_example_6: IAa,
  send_sms_reminder: RAa,
  send_sms_reminder_description: NAa,
  follow_up_with_no_shows: DAa,
  follow_up_with_no_shows_description: MAa,
  remind_attendees_to_bring_id: LAa,
  remind_attendees_to_bring_id_description: qAa,
  email_to_remind_booking: jAa,
  email_to_remind_booking_description: FAa,
  custom_sms_reminder: VAa,
  custom_sms_reminder_description: BAa,
  custom_email_reminder: UAa,
  custom_email_reminder_description: WAa,
  count_managed_to_limit: GAa,
  welcome_to_cal_header: HAa,
  edit_form_later_subtitle: KAa,
  connect_calendar_later: YAa,
  problem_saving_user_profile: ZAa,
  purchase_missing_seats: QAa,
  slot_length: JAa,
  booking_appearance: XAa,
  appearance_team_description: eCa,
  appearance_org_description: tCa,
  only_owner_change: nCa,
  team_disable_cal_branding_description: oCa,
  invited_by_team: rCa,
  token_invalid_expired: iCa,
  view_booking: aCa,
  exchange_add: sCa,
  exchange_authentication: cCa,
  exchange_authentication_standard: lCa,
  exchange_authentication_ntlm: dCa,
  exchange_compression: uCa,
  exchange_version: _Ca,
  exchange_version_2007_SP1: pCa,
  exchange_version_2010: mCa,
  exchange_version_2010_SP1: fCa,
  exchange_version_2010_SP2: gCa,
  exchange_version_2013: hCa,
  exchange_version_2013_SP1: vCa,
  exchange_version_2015: bCa,
  exchange_version_2016: yCa,
  routing: $Ca,
  routing_forms_description: wCa,
  routing_forms_send_email_owner: kCa,
  routing_forms_send_email_owner_description: SCa,
  routing_forms_send_email_to: xCa,
  add_new_form: ECa,
  add_new_team_form: TCa,
  create_your_first_route: ACa,
  route_to_the_right_person: CCa,
  form: zCa,
  form_description: OCa,
  copy_link_to_form: PCa,
  theme: ICa,
  theme_applies_note: RCa,
  app_theme: NCa,
  app_theme_applies_note: DCa,
  theme_system: MCa,
  add_a_team: LCa,
  add_webhook_description: qCa,
  triggers_when: jCa,
  test_webhook: FCa,
  enable_webhook: VCa,
  add_webhook: BCa,
  webhook_edited_successfully: UCa,
  api_keys_description: WCa,
  new_api_key: GCa,
  active: HCa,
  api_key_updated: KCa,
  api_key_update_failed: YCa,
  embeds_title: ZCa,
  embeds_description: QCa,
  create_first_api_key: JCa,
  create_first_api_key_description: XCa,
  back_to_signin: eza,
  reset_link_sent: tza,
  password_reset_email: nza,
  password_reset_leading: oza,
  password_updated: rza,
  pending_payment: iza,
  pending_invites: aza,
  pending_organization_invites: sza,
  not_on_cal: cza,
  no_calendar_installed: lza,
  no_calendar_installed_description: dza,
  add_a_calendar: uza,
  change_email_hint: _za,
  confirm_password_change_email: pza,
  seats: mza,
  every_app_published: fza,
  report_app: gza,
  limit_booking_frequency: hza,
  limit_booking_frequency_description: vza,
  only_show_first_available_slot: bza,
  only_show_first_available_slot_description: yza,
  limit_total_booking_duration: $za,
  limit_total_booking_duration_description: wza,
  booker_booking_limit: kza,
  booker_booking_limit_description: Sza,
  recurring_event_doesnt_support_booker_booking_limit: xza,
  add_limit: Eza,
  team_name_required: Tza,
  show_attendees: Aza,
  show_available_seats_count: Cza,
  how_booking_questions_as_variables: zza,
  format: Oza,
  questions: Pza,
  all_info_your_booker_provide: Iza,
  uppercase_for_letters: Rza,
  replace_whitespaces_underscores: Nza,
  platform_members: Dza,
  platform_members_description: Mza,
  platform_billing: Lza,
  manage_billing: qza,
  manage_billing_description: jza,
  billing_freeplan_title: Fza,
  billing_freeplan_description: Vza,
  billing_freeplan_cta: Bza,
  billing_portal: Uza,
  billing_help_cta: Wza,
  ignore_special_characters_booking_questions: Gza,
  retry: Hza,
  fetching_calendars_error: Kza,
  calendar_connection_fail: Yza,
  booking_confirmation_success: Zza,
  booking_rejection_success: Qza,
  booking_tentative: Jza,
  booking_accept_intent: Xza,
  we_wont_show_again: eOa,
  couldnt_update_timezone: tOa,
  updated_timezone_to: nOa,
  update_timezone: oOa,
  update_timezone_question: rOa,
  update_timezone_description: iOa,
  dont_update: aOa,
  require_additional_notes: sOa,
  require_additional_notes_description: cOa,
  email_address_action: lOa,
  after_event_trigger: dOa,
  booking_rejected_trigger: uOa,
  booking_requested_trigger: _Oa,
  booking_payment_initiated_trigger: pOa,
  booking_paid_trigger: mOa,
  booking_no_show_updated_trigger: fOa,
  how_long_after: gOa,
  how_long_after_hosts_no_show: hOa,
  how_long_after_guests_no_show: vOa,
  how_long_after_user_no_show_minutes: bOa,
  no_available_slots: yOa,
  time_available: $Oa,
  cant_find_the_right_conferencing_app_visit_our_app_store: wOa,
  install_new_calendar_app: kOa,
  make_phone_number_required: SOa,
  new_event_type_availability: xOa,
  error_editing_availability: EOa,
  dont_have_permission: TOa,
  saml_configuration_placeholder: AOa,
  saml_email_required: COa,
  saml_sp_title: zOa,
  saml_sp_description: OOa,
  saml_sp_acs_url: POa,
  saml_sp_entity_id: IOa,
  saml_sp_acs_url_copied: ROa,
  saml_sp_entity_id_copied: NOa,
  add_calendar: DOa,
  limit_future_bookings: MOa,
  limit_future_bookings_description: LOa,
  no_event_types: qOa,
  no_event_types_description: jOa,
  billing_frequency: FOa,
  monthly: VOa,
  yearly: BOa,
  checkout: UOa,
  your_team_disbanded_successfully: WOa,
  your_org_disbanded_successfully: GOa,
  error_creating_team: HOa,
  you: KOa,
  or_continue_with: YOa,
  resend_email: ZOa,
  member_already_invited: QOa,
  already_in_use_error: JOa,
  enter_email_or_username: XOa,
  enter_email: e4a,
  enter_emails: t4a,
  too_many_invites: n4a,
  team_name_taken: o4a,
  must_enter_team_name: r4a,
  team_url_required: i4a,
  url_taken: a4a,
  problem_registering_domain: s4a,
  team_publish: c4a,
  number_text_notifications: l4a,
  number_sms_notifications: d4a,
  attendee_email_variable: u4a,
  attendee_email_info: _4a,
  booking_uid: p4a,
  kbar_search_placeholder: m4a,
  invalid_credential: f4a,
  invalid_credential_action: g4a,
  reschedule_reason: h4a,
  choose_common_schedule_team_event: v4a,
  choose_common_schedule_team_event_description: b4a,
  reason: y4a,
  sender_id: $4a,
  sender_id_error_message: w4a,
  test_routing_form: k4a,
  test_preview: S4a,
  route_to: x4a,
  test_preview_description: E4a,
  test_routing: T4a,
  payment_app_disabled: A4a,
  edit_event_type: C4a,
  only_admin_can_see_members_of_org: z4a,
  only_admin_can_manage_sso_org: O4a,
  only_admin_can_manage_directory_sync: P4a,
  only_admin_can_manage_oauth_clients: I4a,
  collective_scheduling: R4a,
  make_it_easy_to_book: N4a,
  find_the_best_person: D4a,
  fixed_round_robin: M4a,
  add_one_fixed_attendee: L4a,
  calcom_is_better_with_team: q4a,
  the_calcom_team: j4a,
  add_your_team_members: F4a,
  booking_limit_reached: V4a,
  duration_limit_reached: B4a,
  admin_has_disabled: U4a,
  disable_attendees_emails_description: W4a,
  disabled_app_affects_event_type: G4a,
  event_replaced_notice: H4a,
  email_subject_slug_replacement: K4a,
  email_body_slug_replacement_notice: Y4a,
  email_body_slug_replacement_info: Z4a,
  email_body_slug_replacement_suggestion: Q4a,
  disable_payment_app: J4a,
  payment_disabled_still_able_to_book: X4a,
  app_disabled_with_event_type: e3a,
  app_disabled_video: t3a,
  app_disabled_subject: n3a,
  navigate_installed_apps: o3a,
  disabled_calendar: r3a,
  enable_apps: i3a,
  enable_apps_description: a3a,
  purchase_license: s3a,
  already_have_account: c3a,
  already_have_key: l3a,
  already_have_key_suggestion: d3a,
  create_license_key: u3a,
  app_is_enabled: _3a,
  app_is_disabled: p3a,
  keys_have_been_saved: m3a,
  disable_app: f3a,
  disable_app_description: g3a,
  edit_keys: h3a,
  admin_apps_description: v3a,
  admin_users_description: b3a,
  admin_users_add_description: y3a,
  admin_users_edit_description: $3a,
  admin_orgs_edit_description: w3a,
  admin_oAuth_description: k3a,
  admin_lockedSMS_description: S3a,
  no_available_apps: x3a,
  no_available_apps_description: E3a,
  no_apps: T3a,
  no_apps_configured: A3a,
  enable_in_settings: C3a,
  please_contact_admin: z3a,
  apps_settings: O3a,
  fill_this_field: P3a,
  options: I3a,
  enter_option: R3a,
  add_an_option: N3a,
  location_already_exists: D3a,
  radio: M3a,
  google_meet_warning: L3a,
  individual: q3a,
  all_bookings_filter_label: j3a,
  all_users_filter_label: F3a,
  all_event_types_filter_label: V3a,
  your_bookings_filter_label: B3a,
  meeting_url_variable: U3a,
  meeting_url_info: W3a,
  date_overrides: G3a,
  date_overrides_delete_on_date: H3a,
  date_overrides_subtitle: K3a,
  date_overrides_info: Y3a,
  date_overrides_dialog_which_hours: Z3a,
  date_overrides_dialog_which_hours_unavailable: Q3a,
  date_overrides_dialog_title: J3a,
  date_overrides_unavailable: X3a,
  date_overrides_mark_all_day_unavailable_one: e6a,
  date_overrides_mark_all_day_unavailable_other: t6a,
  date_overrides_update_btn: n6a,
  date_successfully_added: o6a,
  date_overrides_save_btn: r6a,
  event_type_duplicate_copy_text: i6a,
  set_as_default: a6a,
  hide_eventtype_details: s6a,
  show_navigation: c6a,
  hide_navigation: l6a,
  verification_code_sent: d6a,
  verified_successfully: u6a,
  wrong_code: _6a,
  not_verified: p6a,
  no_availability_in_month: m6a,
  no_availability_rolling: f6a,
  no_availability_range: g6a,
  view_previous_month: h6a,
  view_next_month: v6a,
  send_code: b6a,
  number_verified: y6a,
  create_your_first_team_webhook_description: $6a,
  create_webhook_team_event_type: w6a,
  disable_success_page: k6a,
  invalid_admin_password: S6a,
  change_password_admin: x6a,
  username_already_taken: E6a,
  assignment: T6a,
  fixed_hosts: A6a,
  add_fixed_hosts: C6a,
  round_robin_hosts: z6a,
  minimum_round_robin_hosts_count: O6a,
  hosts: P6a,
  upgrade_to_enable_feature: I6a,
  orgs_upgrade_to_enable_feature: R6a,
  new_attendee: N6a,
  awaiting_approval: D6a,
  requires_google_calendar: M6a,
  event_type_requires_google_calendar: L6a,
  connected_google_calendar: q6a,
  using_meet_requires_calendar: j6a,
  continue_to_install_google_calendar: F6a,
  install_google_meet: V6a,
  install_google_calendar: B6a,
  sender_name: U6a,
  already_invited: W6a,
  no_recordings_found: G6a,
  new_workflow_subtitle: H6a,
  reporting: K6a,
  reporting_feature: Y6a,
  teams_plan_required: Z6a,
  routing_forms_are_a_great_way: Q6a,
  choose_a_license: J6a,
  choose_license_description: X6a,
  license: e5a,
  agplv3_license: t5a,
  no_need_to_keep_your_code_open_source: n5a,
  repackage_rebrand_resell: o5a,
  a_vast_suite_of_enterprise_features: r5a,
  free_license_fee: i5a,
  forever_open_and_free: a5a,
  required_to_keep_your_code_open_source: s5a,
  cannot_repackage_and_resell: c5a,
  no_enterprise_features: l5a,
  step_enterprise_license: d5a,
  step_enterprise_license_description: u5a,
  setup: _5a,
  setup_description: p5a,
  configure: m5a,
  sso_configuration: f5a,
  sso_configuration_description: g5a,
  sso_configuration_description_orgs: h5a,
  sso_oidc_heading: v5a,
  sso_oidc_description: b5a,
  sso_oidc_configuration_title: y5a,
  sso_oidc_configuration_description: $5a,
  sso_oidc_callback_copied: w5a,
  sso_saml_heading: k5a,
  sso_saml_description: S5a,
  sso_saml_configuration_title: x5a,
  sso_saml_configuration_description: E5a,
  sso_saml_acsurl_copied: T5a,
  sso_saml_entityid_copied: A5a,
  sso_connection_created_successfully: C5a,
  sso_connection_deleted_successfully: z5a,
  delete_sso_configuration: O5a,
  delete_sso_configuration_confirmation: P5a,
  delete_sso_configuration_confirmation_description: I5a,
  organizer_timezone: R5a,
  email_user_cta: N5a,
  accept_invite: D5a,
  join_now: M5a,
  successfully_joined: L5a,
  email_no_user_invite_heading_subteam: q5a,
  email_no_user_invite_heading_org: j5a,
  email_no_user_invite_subheading: F5a,
  email_user_invite_subheading_subteam: V5a,
  email_user_invite_subheading_org: B5a,
  email_no_user_invite_steps_intro: U5a,
  email_no_user_step_one: W5a,
  email_no_user_step_two: G5a,
  email_no_user_step_three: H5a,
  email_no_user_step_four: K5a,
  email_no_user_signoff: Y5a,
  impersonation_user_tip: Z5a,
  available_variables: Q5a,
  scheduler: J5a,
  no_workflows: X5a,
  change_filter: ePa,
  change_filter_common: tPa,
  no_results_for_filter: nPa,
  recommended_next_steps: oPa,
  create_a_managed_event: rPa,
  meetings_are_better_with_the_right: iPa,
  create_a_one_one_template: aPa,
  collective_or_roundrobin: sPa,
  book_your_team_members: cPa,
  event_no_longer_attending_subject: lPa,
  no_longer_attending: dPa,
  attendee_no_longer_attending_subject: uPa,
  attendee_no_longer_attending: _Pa,
  attendee_no_longer_attending_subtitle: pPa,
  create_event_on: mPa,
  create_routing_form_on: fPa,
  default_app_link_title: gPa,
  default_app_link_description: hPa,
  organizer_default_conferencing_app: vPa,
  organizer_default_conferencing_app_not_found: bPa,
  under_maintenance: yPa,
  under_maintenance_description: $Pa,
  event_type_seats: wPa,
  booking_questions_title: kPa,
  booking_questions_description: SPa,
  add_a_booking_question: xPa,
  identifier: EPa,
  duplicate_email: TPa,
  enter_redirect_url_on_exit_description: APa,
  booking_with_payment_cancelled: CPa,
  booking_with_payment_cancelled_already_paid: zPa,
  booking_with_payment_cancelled_refunded: OPa,
  booking_with_payment_cancelled_no_refund: PPa,
  booking_with_payment_cancelled_refund_window_expired: IPa,
  booking_confirmation_failed: RPa,
  not_enough_seats: NPa,
  form_builder_field_already_exists: DPa,
  guests_field_must_be_multiemail: MPa,
  show_on_booking_page: LPa,
  visit_cancelled_booking: qPa,
  get_started_zapier_templates: jPa,
  standard_templates: FPa,
  cal_ai_templates: VPa,
  team_is_unpublished: BPa,
  org_is_unpublished_description: UPa,
  team_is_unpublished_description: WPa,
  team_member: GPa,
  a_routing_form: HPa,
  form_description_placeholder: KPa,
  keep_me_connected_with_form: YPa,
  fields_in_form_duplicated: ZPa,
  form_deleted: QPa,
  delete_form: JPa,
  delete_form_action: XPa,
  delete_form_confirmation: eIa,
  delete_form_confirmation_2: tIa,
  typeform_redirect_url_copied: nIa,
  modifications_in_fields_warning: oIa,
  connected_forms: rIa,
  form_modifications_warning: iIa,
  responses_collection_waiting_description: aIa,
  this_is_what_your_users_would_see: sIa,
  identifies_name_field: cIa,
  add_1_option_per_line: lIa,
  select_a_router: dIa,
  add_a_new_route: uIa,
  make_informed_decisions: _Ia,
  make_informed_decisions_description: pIa,
  view_bookings_across: mIa,
  view_bookings_across_description: fIa,
  identify_booking_trends: gIa,
  identify_booking_trends_description: hIa,
  spot_popular_event_types: vIa,
  spot_popular_event_types_description: bIa,
  no_responses_yet: yIa,
  no_routes_defined: $Ia,
  this_will_be_the_placeholder: wIa,
  error_booking_event: kIa,
  timeslot_missing_title: SIa,
  timeslot_missing_description: xIa,
  timeslot_missing_cta: EIa,
  switch_monthly: TIa,
  switch_weekly: AIa,
  switch_multiday: CIa,
  switch_columnview: zIa,
  num_locations: OIa,
  select_on_next_step: PIa,
  this_meeting_has_not_started_yet: IIa,
  this_app_requires_connected_account: RIa,
  connect_app: NIa,
  app_is_connected: DIa,
  requires_app: MIa,
  verification_code: LIa,
  can_you_try_again: qIa,
  verify: jIa,
  timezone_info: FIa,
  timezone_variable: VIa,
  event_end_time_variable: BIa,
  event_end_time_info: UIa,
  cancel_url_variable: WIa,
  cancel_url_info: GIa,
  cancel_reason_variable: HIa,
  cancel_reason_info: KIa,
  reschedule_url_variable: YIa,
  reschedule_url_info: ZIa,
  reschedule_reason_variable: QIa,
  reschedule_reason_info: JIa,
  invalid_event_name_variables: XIa,
  select_all: eRa,
  default_conferencing_bulk_title: tRa,
  members_default_schedule: nRa,
  set_by_admin: oRa,
  members_default_location: rRa,
  members_default_schedule_description: iRa,
  requires_at_least_one_schedule: aRa,
  default_conferencing_bulk_description: sRa,
  default_schedules_bulk_description: cRa,
  locked_for_members: lRa,
  unlocked_for_members: dRa,
  apps_locked_for_members_description: uRa,
  apps_unlocked_for_members_description: _Ra,
  apps_locked_by_team_admins_description: pRa,
  apps_unlocked_by_team_admins_description: mRa,
  workflows_locked_for_members_description: fRa,
  workflows_unlocked_for_members_description: gRa,
  workflows_locked_by_team_admins_description: hRa,
  workflows_unlocked_by_team_admins_description: vRa,
  webhooks_locked_for_members_description: bRa,
  webhooks_unlocked_for_members_description: yRa,
  webhooks_locked_by_team_admins_description: $Ra,
  webhooks_unlocked_by_team_admins_description: wRa,
  locked_by_team_admin: kRa,
  app_not_connected: SRa,
  connect_now: xRa,
  managed_event_dialog_confirm_button_one: ERa,
  managed_event_dialog_confirm_button_other: TRa,
  managed_event_dialog_title_one: ARa,
  managed_event_dialog_title_other: CRa,
  managed_event_dialog_information_one: zRa,
  managed_event_dialog_information_other: ORa,
  managed_event_dialog_clarification: PRa,
  review_event_type: IRa,
  looking_for_more_analytics: RRa,
  looking_for_more_insights: NRa,
  filters: DRa,
  filter: MRa,
  add_a_member: LRa,
  add_filter: qRa,
  add_rule: jRa,
  add_rule_group: FRa,
  remove_filters: VRa,
  email_verified: BRa,
  select_user: URa,
  select_event_type: WRa,
  select_date_range: GRa,
  popular_events: HRa,
  no_event_types_found: KRa,
  average_event_duration: YRa,
  bookings_by_hour: ZRa,
  most_booked_members: QRa,
  least_booked_members: JRa,
  most_bookings_scheduled: XRa,
  least_bookings_scheduled: eNa,
  most_bookings_completed: tNa,
  least_bookings_completed: nNa,
  events_created: oNa,
  events_completed: rNa,
  events_cancelled: iNa,
  events_rescheduled: aNa,
  events: sNa,
  performance: cNa,
  from_last_period: lNa,
  from_to_date_period: dNa,
  redirect_url_warning: uNa,
  event_trends: _Na,
  clear_filters: pNa,
  clear: mNa,
  hold: fNa,
  on_booking_option: gNa,
  hold_option: hNa,
  card_held: vNa,
  charge_card: bNa,
  card_charged: yNa,
  no_show_fee_amount: $Na,
  no_show_fee: wNa,
  submit_card: kNa,
  submit_payment_information: SNa,
  meeting_awaiting_payment_method: xNa,
  no_show_fee_charged_email_subject: ENa,
  no_show_fee_charged_text_body: TNa,
  no_show_fee_charged_subtitle: ANa,
  error_charging_card: CNa,
  collect_no_show_fee: zNa,
  no_show_fee_charged: ONa,
  your_card_was_declined: PNa,
  your_card_does_not_support_this_type_of_purchase: INa,
  amount_must_convert_to_at_least: RNa,
  could_not_charge_card: NNa,
  insights: DNa,
  routing_forms: MNa,
  insights_no_data_found_for_filter: LNa,
  acknowledge_booking_no_show_fee: qNa,
  days: jNa,
  card_details: FNa,
  something_went_wrong_on_our_end: VNa,
  please_provide_following_text_to_suppport: BNa,
  seats_and_no_show_fee_error: UNa,
  complete_your_booking: WNa,
  complete_your_booking_subject: GNa,
  confirm_your_details: HNa,
  copy_invite_link: KNa,
  edit_invite_link: YNa,
  invite_link_copied: ZNa,
  invite_link_deleted: QNa,
  api_key_deleted: JNa,
  delete_api_key_warning: XNa,
  invite_link_updated: eDa,
  link_expires_after: tDa,
  one_day: nDa,
  seven_days: oDa,
  thirty_days: rDa,
  three_months: iDa,
  one_year: aDa,
  team_invite_received: sDa,
  currency_string: cDa,
  charge_card_dialog_body: lDa,
  charge_attendee: dDa,
  payment_app_commission: uDa,
  email_invite_team: _Da,
  email_invite_team_bulk: pDa,
  error_collecting_card: mDa,
  image_size_limit_exceed: fDa,
  unauthorized_workflow_error_message: gDa,
  inline_embed: hDa,
  load_inline_content: vDa,
  floating_pop_up_button: bDa,
  floating_button_trigger_modal: yDa,
  pop_up_element_click: $Da,
  open_dialog_with_element_click: wDa,
  use_my_own_form: kDa,
  use_our_headless_routing_api: SDa,
  need_help_embedding: xDa,
  book_my_cal: EDa,
  first_name: TDa,
  last_name: ADa,
  first_last_name: CDa,
  invite_as: zDa,
  form_updated_successfully: ODa,
  disable_attendees_confirmation_emails: PDa,
  disable_attendees_confirmation_emails_description: IDa,
  disable_host_confirmation_emails: RDa,
  disable_host_confirmation_emails_description: NDa,
  add_an_override: DDa,
  import_from_google_workspace: MDa,
  connect_google_workspace: LDa,
  google_workspace_admin_tooltip: qDa,
  first_event_type_webhook_description: jDa,
  create_instant_meeting_webhook_description: FDa,
  install_app_on: VDa,
  create_for: BDa,
  currency: UDa,
  organization_banner_description: WDa,
  organization_banner_title: GDa,
  set_up_your_organization: HDa,
  set_up_your_platform_organization: KDa,
  organizations_description: YDa,
  plans: ZDa,
  platform: QDa,
  platform_description: JDa,
  platform_organization_description: XDa,
  must_enter_organization_name: eMa,
  must_enter_organization_admin_email: tMa,
  admin_email: nMa,
  platform_admin_email: oMa,
  admin_username: rMa,
  organization_name: iMa,
  platform_name: aMa,
  organization_url: sMa,
  organization_verify_header: cMa,
  organization_verify_email_body: lMa,
  additional_url_parameters: dMa,
  about_your_organization: uMa,
  about_your_organization_description: _Ma,
  create_your_teams: pMa,
  create_your_teams_description: mMa,
  invite_organization_admins: fMa,
  invite_organization_admins_description: gMa,
  set_a_password: hMa,
  set_a_password_description: vMa,
  organization_logo: bMa,
  organization_about_description: yMa,
  ill_do_this_later: $Ma,
  verify_your_email: wMa,
  enter_digit_code: kMa,
  verify_email_organization: SMa,
  code_provided_invalid: xMa,
  email_already_used: EMa,
  organization_admin_invited_heading: TMa,
  organization_admin_invited_body: AMa,
  duplicated_slugs_warning: CMa,
  team_names_empty: zMa,
  team_names_repeated: OMa,
  user_belongs_organization: PMa,
  org_no_teams_yet: IMa,
  org_no_teams_yet_description: RMa,
  set_up: NMa,
  my_profile: DMa,
  my_settings: MMa,
  crm: LMa,
  messaging: qMa,
  sender_id_info: jMa,
  org_admins_can_create_new_teams: FMa,
  google_new_spam_policy: VMa,
  resolve: BMa,
  no_organization_slug: UMa,
  copy_link_org: WMa,
  "404_the_org": "De organisatie",
  "404_the_team": "Het team",
  "404_claim_entity_org": "Claim uw subdomein voor uw organisatie",
  "404_claim_entity_team": "Claim dit team en begin met het gezamenlijk beheren van planningen",
  insights_team_filter: GMa,
  insights_user_filter: HMa,
  insights_subtitle: KMa,
  call_history: YMa,
  call_history_subtitle: ZMa,
  location_options: QMa,
  channel_type: JMa,
  end_reason: XMa,
  session_status: eLa,
  user_sentiment: tLa,
  time_header: nLa,
  from_header: oLa,
  custom_plan: rLa,
  email_embed: iLa,
  add_times_to_your_email: aLa,
  select_time: sLa,
  select_date: cLa,
  only_show_if_parameter_set: lLa,
  add_parameter: dLa,
  connecting_you_to_someone: uLa,
  please_do_not_close_this_tab: _La,
  see_all_available_times: pLa,
  org_team_names_example_1: mLa,
  org_team_names_example_2: fLa,
  org_team_names_example_3: gLa,
  org_team_names_example_4: hLa,
  org_team_names_example_5: vLa,
  org_max_team_warnings: bLa,
  what_is_this_meeting_about: yLa,
  add_to_team: $La,
  remove_users_from_org: wLa,
  delegation_credential: kLa,
  delegation_credential_description: SLa,
  add_client_id_in_google_workspace_with_below_scope: xLa,
  delegation_credential_enabled: ELa,
  add_delegation_credential: TLa,
  edit_delegation_credential: ALa,
  domain: CLa,
  no_workspace_platforms: zLa,
  workspace_platform: OLa,
  workspace_platforms: PLa,
  workspace_platforms_description: ILa,
  edit_workspace_platform: RLa,
  edit_service_account: NLa,
  add_workspace_platform: DLa,
  slug: MLa,
  service_account_key: LLa,
  edit_service_account_key: qLa,
  delegation_credential_restricts_adding_more_than_one_installation: jLa,
  app_successfully_installed_and_is_using_delegated_credentials: FLa,
  remove_users_from_org_confirm: VLa,
  remove_users_from_team: BLa,
  remove_users_from_team_confirm: ULa,
  user_has_no_schedules: WLa,
  user_isnt_in_any_teams: GLa,
  user_has_no_app_installed: HLa,
  requires_booker_email_verification: KLa,
  description_requires_booker_email_verification: YLa,
  requires_confirmation_mandatory: ZLa,
  organizations: QLa,
  upload_cal_video_logo: JLa,
  update_cal_video_logo: XLa,
  upload_banner: eqa,
  cal_video_logo_upload_instruction: tqa,
  org_admin_other_teams: nqa,
  org_admin_other_teams_description: oqa,
  not_part_of_org: rqa,
  no_other_teams_found: iqa,
  no_other_teams_found_description: aqa,
  attendee_first_name_variable: sqa,
  attendee_last_name_variable: cqa,
  attendee_first_name_info: lqa,
  attendee_last_name_info: dqa,
  your_monthly_digest: uqa,
  member_name: _qa,
  most_popular_events: pqa,
  summary_of_events_for_your_team_for_the_last_30_days: mqa,
  me: fqa,
  meeting_unavailable: gqa,
  monthly_digest_email: hqa,
  monthly_digest_email_for_teams: vqa,
  verify_team_tooltip: bqa,
  member_removed: yqa,
  my_availability: $qa,
  team_availability: wqa,
  instant_meeting_availability: kqa,
  backup_code: Sqa,
  backup_codes: xqa,
  backup_code_instructions: Eqa,
  backup_codes_copied: Tqa,
  incorrect_backup_code: Aqa,
  lost_access: Cqa,
  missing_backup_codes: zqa,
  admin_org_notification_email_subject: Oqa,
  hi_admin: Pqa,
  admin_org_notification_email_title: Iqa,
  admin_org_notification_email_body_part1: Rqa,
  admin_org_notification_email_body_part2: Nqa,
  admin_org_notification_email_body_part3: Dqa,
  admin_org_notification_email_cta: Mqa,
  org_has_been_processed: Lqa,
  org_error_processing: qqa,
  orgs_page_description: jqa,
  unverified: Fqa,
  verified: Vqa,
  dns_missing: Bqa,
  dns_configured: Uqa,
  mark_dns_configured: Wqa,
  value: Gqa,
  your_organization_updated_sucessfully: Hqa,
  team_no_event_types: Kqa,
  seat_options_doesnt_multiple_durations: Yqa,
  include_calendar_event: Zqa,
  oAuth: Qqa,
  oAuth_client_creation_form: Jqa,
  oAuth_client_creation_form_description: Xqa,
  oAuth_client_updation_form: e9a,
  oAuth_client_updation_form_description: t9a,
  recently_added: n9a,
  connect_all_calendars: o9a,
  connect_all_calendars_description: r9a,
  workflow_automation_description: i9a,
  scheduling_for_your_team: a9a,
  scheduling_for_your_team_description: s9a,
  no_members_found: c9a,
  directory_sync: l9a,
  directory_name: d9a,
  directory_provider: u9a,
  directory_scim_url: _9a,
  directory_scim_token: p9a,
  directory_scim_url_copied: m9a,
  directory_scim_token_copied: f9a,
  directory_sync_info_description: g9a,
  directory_sync_configure: h9a,
  directory_sync_configure_description: v9a,
  directory_sync_title: b9a,
  directory_sync_created: y9a,
  directory_sync_description: $9a,
  directory_sync_deleted: w9a,
  directory_sync_delete_connection: k9a,
  directory_sync_delete_title: S9a,
  directory_sync_delete_description: x9a,
  directory_sync_delete_confirmation: E9a,
  event_setup_length_error: T9a,
  availability_schedules: A9a,
  unauthorized: C9a,
  access_cal_account: z9a,
  select_account_team: O9a,
  allow_client_to: P9a,
  associate_with_cal_account: I9a,
  see_personal_info: R9a,
  see_primary_email_address: N9a,
  connect_installed_apps: D9a,
  access_event_type: M9a,
  access_availability: L9a,
  access_bookings: q9a,
  allow_client_to_do: j9a,
  oauth_access_information: F9a,
  allow: V9a,
  view_only_edit_availability_not_onboarded: B9a,
  view_only_edit_availability: U9a,
  you_can_override_calendar_in_advanced_tab: W9a,
  edit_users_availability: G9a,
  resend_invitation: H9a,
  invitation_resent: K9a,
  saml_sso: Y9a,
  add_client: Z9a,
  copy_client_secret_info: Q9a,
  add_new_client: J9a,
  add_new_user: X9a,
  this_app_is_not_setup_already: eja,
  as_csv: tja,
  overlay_my_calendar: nja,
  overlay_my_calendar_toc: oja,
  view_overlay_calendar_events: rja,
  join_event_location: ija,
  troubleshooting: aja,
  calendars_were_checking_for_conflicts: sja,
  availabilty_schedules: cja,
  manage_calendars: lja,
  manage_availability_schedules: dja,
  locked: uja,
  unlocked: _ja,
  lock_timezone_toggle_on_booking_page: pja,
  description_lock_timezone_toggle_on_booking_page: mja,
  event_setup_multiple_payment_apps_error: fja,
  number_in_international_format: gja,
  install_calendar: hja,
  branded_subdomain: vja,
  branded_subdomain_description: bja,
  org_insights: yja,
  org_insights_description: $ja,
  extensive_whitelabeling: wja,
  extensive_whitelabeling_description: kja,
  unlimited_teams: Sja,
  verify_email: xja,
  proceed_with_cancellation_description: Eja,
  proceed_with_cancellation_error: Tja,
  unlimited_teams_description: Aja,
  unified_billing: Cja,
  advanced_managed_events: zja,
  advanced_managed_events_description: Oja,
  enterprise: Pja,
  enterprise_description: Ija,
  create_your_org: Rja,
  create_org: Nja,
  create_your_org_description: Dja,
  create_your_enterprise_description: Mja,
  other_payment_app_enabled: Lja,
  admin_delete_organization_description_1: qja,
  admin_delete_organization_description_2: jja,
  admin_delete_organization_description_3: Fja,
  admin_delete_organization_description_4: Vja,
  admin_delete_organization_title: Bja,
  published: Uja,
  unpublished: Wja,
  publish: Gja,
  troubleshooter_tooltip: Hja,
  need_help: Kja,
  troubleshooter: Yja,
  number_to_call: Zja,
  guest_name: Qja,
  guest_email: Jja,
  guest_company: Xja,
  please_install_a_calendar: eFa,
  instant_tab_title: tFa,
  instant_event_tab_description: nFa,
  uprade_to_create_instant_bookings: oFa,
  dont_want_to_wait: rFa,
  meeting_started: iFa,
  pay_and_book: aFa,
  cal_ai_event_tab_description: sFa,
  booking_not_found_error: cFa,
  booking_seats_full_error: lFa,
  missing_payment_credential_error: dFa,
  missing_payment_app_id_error: uFa,
  not_enough_available_seats_error: _Fa,
  user_redirect_title: pFa,
  user_redirect_description: mFa,
  out_of_office: fFa,
  out_of_office_description: gFa,
  send_request: hFa,
  start_date_and_end_date_required: vFa,
  start_date_must_be_before_end_date: bFa,
  start_date_must_be_in_the_future: yFa,
  user_not_found: $Fa,
  cannot_redirect_to_self: wFa,
  out_of_office_entry_already_exists: kFa,
  out_of_office_id_required: SFa,
  booking_redirect_infinite_not_allowed: xFa,
  success_entry_created: EFa,
  booking_redirect_email_subject: TFa,
  booking_redirect_email_title: AFa,
  booking_redirect_email_description: CFa,
  booking_redirect_updated_email_subject: zFa,
  booking_redirect_updated_email_title: OFa,
  booking_redirect_updated_email_description: PFa,
  booking_redirect_cancelled_email_subject: IFa,
  booking_redirect_cancelled_email_title: RFa,
  booking_redirect_cancelled_email_description: NFa,
  success_accept_booking_redirect: DFa,
  success_reject_booking_redirect: MFa,
  copy_link_booking_redirect_request: LFa,
  booking_redirect_request_title: qFa,
  select_team_member: jFa,
  going_away_title: FFa,
  redirect_team_enabled: VFa,
  redirect_team_disabled: BFa,
  out_of_office_unavailable_list: UFa,
  success_deleted_entry_out_of_office: WFa,
  success_edited_entry_out_of_office: GFa,
  temporarily_out_of_office: HFa,
  add_a_redirect: KFa,
  create_entry: YFa,
  time_range: ZFa,
  automatically_add_all_team_members: QFa,
  redirect_to: JFa,
  having_trouble_finding_time: XFa,
  show_more: e8a,
  forward_params_redirect: t8a,
  assignment_description: n8a,
  lowest: o8a,
  low: r8a,
  medium: i8a,
  high: a8a,
  Highest: s8a,
  send_booker_to: c8a,
  set_priority: l8a,
  set_weight: d8a,
  enable_weights: u8a,
  priority_for_user: _8a,
  weights_description: p8a,
  weight_for_user: m8a,
  change_priority: f8a,
  field_identifiers_as_variables: g8a,
  field_identifiers_as_variables_with_example: h8a,
  account_already_linked: v8a,
  send_email: b8a,
  cal_ai_phone_call_action: y8a,
  call_to_confirm_booking: $8a,
  cal_ai_phone_call_action_description: w8a,
  cal_ai_agent_configuration: k8a,
  choose_at_least_one_event_type_test_call: S8a,
  mark_as_no_show: x8a,
  unmark_as_no_show: E8a,
  account_unlinked_success: T8a,
  account_unlinked_error: A8a,
  travel_schedule: C8a,
  travel_schedule_description: z8a,
  schedule_timezone_change: O8a,
  date: P8a,
  enter_the_general_prompt_for_the_agent: I8a,
  overlaps_with_existing_schedule: R8a,
  "org_admin_no_slots|heading": "Geen beschikbaarheid gevonden voor {{name}}",
  "org_admin_no_slots|content": "Hallo organisatiebeheerders,<br /><br />Let op: het is onder onze aandacht gebracht dat {{username}} geen beschikbaarheid had toen een gebruiker {{username}}/{{slug}} heeft bezocht<br /><br />Er zijn een paar redenen waarom dit zou kunnen gebeuren<br />De gebruiker heeft geen agenda's verbonden<br />Hun schema's gekoppeld aan deze afspraak zijn niet ingeschakeld<br /> <br />We raden aan om hun beschikbaarheid te controleren om dit op te lossen.",
  "org_admin_no_slots|cta": "Open beschikbaarheid van gebruikers",
  organization_no_slots_notification_switch_title: N8a,
  organization_no_slots_notification_switch_description: D8a,
  organization_disable_phone_only_sms_notifications_switch_title: M8a,
  organization_disable_phone_only_sms_notifications_switch_description: L8a,
  "email_team_invite|subject|added_to_org": "{{user}} heeft je toegevoegd aan de organisatie {{team}} op {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} heeft je uitgenodigd om deel te nemen aan de organisatie {{team}} op {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} heeft je toegevoegd aan het team {{team}} van de organisatie {{parentTeamName}} op {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} heeft u uitgenodigd om lid te worden van het team {{team}} op {{appName}}",
  "email_team_invite|heading|added_to_org": "Je bent toegevoegd aan een {{appName}} organisatie",
  "email_team_invite|heading|invited_to_org": "Je bent uitgenodigd voor een {{appName}} organisatie",
  "email_team_invite|heading|added_to_subteam": "Je bent toegevoegd aan een team van de {{parentTeamName}} organisatie",
  "email_team_invite|heading|invited_to_subteam": "Je bent uitgenodigd voor een team van de {{parentTeamName}} organisatie",
  "email_team_invite|heading|invited_to_regular_team": "Je bent uitgenodigd om lid te worden van een {{appName}} team",
  "email_team_invite|content|added_to_org": "{{invitedBy}} heeft je toegevoegd aan de <strong>{{teamName}}</strong> organisatie.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} heeft je uitgenodigd om deel te nemen aan de {{teamName}} organisatie.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} heeft u uitgenodigd om lid te worden van het team {{team}} van de organisatie {{parentTeamName}} op {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} heeft je toegevoegd aan het team <strong>{{teamName}}</strong> in hun organisatie {{parentTeamName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} heeft je uitgenodigd om deel te nemen aan het team <strong>{{teamName}}</strong> in hun organisatie {{parentTeamName}}. {{appName}} is de planner die jou en je team in staat stelt om vergaderingen te plannen zonder eindeloos heen en weer te mailen.",
  "email_team_invite|content|invited_to_regular_team": "{{invitedBy}} heeft u uitgenodigd om lid te worden van zijn team '{{teamName}}' op {{appName}}. {{appName}} is de gebeurtenissenplanner die u en uw team in staat stelt afspraken te plannen zonder heen en weer te e-mailen.",
  "email|existing_user_added_link_will_change": "Bij het accepteren van de uitnodiging zal je link veranderen naar het domein van je organisatie, maar maak je geen zorgen, alle vorige links blijven werken en worden correct doorverwezen.<br /><br />Let op: al je persoonlijke afspraaktypes worden verplaatst naar de <strong>{{teamName}}</strong> organisatie, wat mogelijk ook een persoonlijke link kan bevatten. <br /><br />Voor persoonlijke afspraken raden we aan om een nieuw account aan te maken met een persoonlijk e-mailadres.",
  "email|existing_user_added_link_changed": "Je link is gewijzigd van {{a0}} naar {{a1}} maar maak je geen zorgen, alle vorige links werken nog steeds en worden correct doorverwezen. <br /><br />Let op: al je persoonlijke afspraaktypes zijn verplaatst naar de <strong>{{teamName}}</strong> organisatie, wat mogelijk ook een persoonlijke link kan bevatten.<br /><br />Log in en controleer of je geen privé-afspraken hebt op je nieuwe organisatieaccount.<br /><br />Voor persoonlijke afspraken raden we aan om een nieuw account aan te maken met een persoonlijk e-mailadres.<br /><br />Geniet van je nieuwe nette link: {{a2}}",
  "email_organization_created|subject": "Uw organisatie is aangemaakt",
  your_current_plan: q8a,
  organization_price_per_user_month: j8a,
  privacy_organization_description: F8a,
  privacy: V8a,
  team_will_be_under_org: B8a,
  add_group_name: U8a,
  group_name: W8a,
  routers: G8a,
  primary: H8a,
  make_primary: K8a,
  add_email: Y8a,
  add_emails: Z8a,
  add_email_description: Q8a,
  confirm_email: J8a,
  confirming_your_booking_sms: X8a,
  scheduler_first_name: e7a,
  scheduler_last_name: t7a,
  scheduler_name: n7a,
  organizer_first_name: o7a,
  confirm_email_description: r7a,
  send_event_details_to: i7a,
  schedule_tz_without_end_date: a7a,
  select_members: s7a,
  lock_event_types_modal_header: c7a,
  org_delete_event_types_org_admin: l7a,
  org_hide_event_types_org_admin: d7a,
  hide_org_eventtypes: u7a,
  delete_org_eventtypes: _7a,
  lock_org_users_eventtypes: p7a,
  lock_org_users_eventtypes_description: m7a,
  add_to_event_type: f7a,
  create_account_password: g7a,
  create_account_with_saml: h7a,
  error_creating_account_password: v7a,
  cannot_create_account_password_cal_provider: b7a,
  cannot_create_account_password_already_existing: y7a,
  create_account_password_hint: $7a,
  disconnect_account: w7a,
  disconnect_account_hint: k7a,
  cookie_consent_checkbox: S7a,
  make_a_call: x7a,
  skip_rr_assignment_label: E7a,
  skip_rr_description: T7a,
  select_account_header: A7a,
  select_account_description: C7a,
  select_event_types_header: z7a,
  select_event_types_description: O7a,
  configure_app_header: P7a,
  configure_app_description: I7a,
  already_installed: R7a,
  ooo_reasons_unspecified: N7a,
  ooo_reasons_vacation: D7a,
  ooo_reasons_travel: M7a,
  ooo_reasons_sick_leave: L7a,
  ooo_reasons_public_holiday: q7a,
  ooo_forwarding_to: j7a,
  ooo_not_forwarding: F7a,
  ooo_empty_title: V7a,
  ooo_empty_description: B7a,
  ooo_user_is_ooo: U7a,
  ooo_slots_returning: W7a,
  ooo_slots_book_with: G7a,
  ooo_select_reason: H7a,
  create_an_out_of_office: K7a,
  edit_an_out_of_office: Y7a,
  submit_feedback: Z7a,
  host_no_show: Q7a,
  no_show_description: J7a,
  how_can_we_improve: X7a,
  most_liked: eVa,
  review: tVa,
  reviewed: nVa,
  unreviewed: oVa,
  rating_url_variable: rVa,
  rating_url_info: iVa,
  no_show_url_variable: aVa,
  no_show_url_info: sVa,
  no_support_needed: cVa,
  hide_support: lVa,
  event_ratings: dVa,
  event_no_show: uVa,
  event_no_show_guest: _Va,
  recent_ratings: pVa,
  no_ratings: mVa,
  no_ratings_description: fVa,
  most_no_show_host: gVa,
  highest_rated: hVa,
  lowest_rated: vVa,
  highest_rated_members: bVa,
  lowest_rated_members: yVa,
  csat_score: $Va,
  lockedSMS: wVa,
  leave_without_assigning_anyone: kVa,
  leave_without_adding_attendees: SVa,
  no_availability_shown_to_bookers: xVa,
  go_back_and_assign: EVa,
  leave_without_assigning: TVa,
  signing_up_terms: AVa,
  proceeding_agreement: CVa,
  terms: zVa,
  always_show_x_days: OVa,
  always_show_x_days_description: PVa,
  team_subscription_cancelled_successfully: IVa,
  team_subscription_cancellation_error: RVa,
  unable_to_subscribe_to_the_platform: NVa,
  updating_oauth_client_error: DVa,
  creating_oauth_client_error: MVa,
  event_type_color: LVa,
  event_type_color_description: qVa,
  mark_as_no_show_title: jVa,
  x_marked_as_no_show: FVa,
  x_unmarked_as_no_show: VVa,
  team_select_info: BVa,
  team_settings_description: UVa,
  no_show_updated: WVa,
  email_copied: GVa,
  phone_number_copied: HVa,
  USER_PENDING_MEMBER_OF_THE_ORG: KVa,
  USER_ALREADY_INVITED_OR_MEMBER: YVa,
  USER_MEMBER_OF_OTHER_ORGANIZATION: ZVa,
  booking_reassigned: QVa,
  reassign: JVa,
  reassign_to_another_rr_host: XVa,
  assign_team_member: eBa,
  override_team_member_to_assign: tBa,
  no_available_hosts: nBa,
  reassign_round_robin_host: oBa,
  skip_writing_to_calendar: rBa,
  rescheduling_not_possible: iBa,
  event_expired: aBa,
  skip_contact_creation: sBa,
  skip_writing_to_calendar_note: cBa,
  attributes: lBa,
  new_attribute: dBa,
  add_attributes: uBa,
  add_attributes_description: _Ba,
  new_option: pBa,
  update_profile: mBa,
  attribute: fBa,
  create_attribute_description: gBa,
  edit_attribute_description: hBa,
  attribute_updated_successfully: vBa,
  attribute_deleted_successfully: bBa,
  attributes_edited_successfully: yBa,
  attribute_meta_description: $Ba,
  attributes_edit_description: wBa,
  back_to_attributes: kBa,
  delete_attribute: SBa,
  delete_attribute_description: xBa,
  disable_all_emails_to_attendees: EBa,
  disable_all_emails_description: TBa,
  disable_all_emails_to_hosts: ABa,
  type_confirm_to_continue: CBa,
  disable_email: zBa,
  grant_admin_api: OBa,
  revoke_admin_api: PBa,
  add_calendar_label: IBa,
  apple_connect_atom_label: RBa,
  apple_connect_atom_already_connected_label: NBa,
  apple_connect_atom_loading_label: DBa,
  google_connect_atom_label: MBa,
  google_connect_atom_already_connected_label: LBa,
  google_connect_atom_loading_label: qBa,
  outlook_connect_atom_label: jBa,
  outlook_connect_atom_already_connected_label: FBa,
  outlook_connect_atom_loading_label: VBa,
  stripe_connect_atom_label: BBa,
  stripe_connect_atom_already_connected_label: UBa,
  stripe_connect_atom_loading_label: WBa,
  booking_question_response_variables: GBa,
  managed_by_teamAdmins: HBa,
  number_of_options: KBa,
  reschedule_with_same_round_robin_host_title: YBa,
  reschedule_with_same_round_robin_host_description: ZBa,
  disable_input_if_prefilled: QBa,
  booking_limits: JBa,
  booking_limits_team_description: XBa,
  limit_team_booking_frequency_description: eUa,
  booking_limits_updated_successfully: tUa,
  you_are_unauthorized_to_make_this_change_to_the_booking: nUa,
  delegation_credential_disabled: oUa,
  matching_members: rUa,
  x_matching_members: iUa,
  matching_members_queue_using_attribute_weights: aUa,
  matching_members_queue_using_event_assignee_weights: sUa,
  no_matching_members: cUa,
  no_matching_members_will_fallback_to_all_assigned_members: lUa,
  hide_calendar_event_details: dUa,
  description_hide_calendar_event_details: uUa,
  last_number_of_days: _Ua,
  month_to_date: pUa,
  year_to_date: mUa,
  custom_range: fUa,
  refund_policy: gUa,
  always: hUa,
  never: vUa,
  payment_option: bUa,
  if_cancelled: yUa,
  before: $Ua,
  show_all_columns: wUa,
  toggle_columns: kUa,
  no_columns_found: SUa,
  salesforce_create_record_as: xUa,
  salesforce_lead: EUa,
  salesforce_contact_under_account: TUa,
  salesforce_skip_entry_creation: AUa,
  salesforce_if_account_does_not_exist: CUa,
  salesforce_create_new_contact_under_account: zUa,
  salesforce_change_record_owner_on_booking: OUa,
  mass_assign_attributes: PUa,
  reroute_preview_custom_message: IUa,
  reroute_preview_external_redirect: RUa,
  reroute_preview_possible_host: NUa,
  current_routing_status: DUa,
  reroute_booking: MUa,
  reroute_booking_description: LUa,
  verify_new_route: qUa,
  reroute: jUa,
  new_routing_status: FUa,
  salesforce_book_directly_with_attendee_owner: VUa,
  salesforce_check_owner_of: BUa,
  account: UUa,
  choose_hosts_schedule: WUa,
  hosts_schedule_description: GUa,
  no_hosts_description: HUa,
  team_member_round_robin_reassign: KUa,
  team_member_round_robin_reassign_description: YUa,
  round_robin_reassign_description: ZUa,
  invalid_round_robin_host: QUa,
  user_is_round_robin_fixed: JUa,
  reschedule_with_same_timeslot: XUa,
  reschedule_with_same_timeslot_of_new_event: eWa,
  reschedule_to_the_new_event_with_different_timeslot: tWa,
  reschedule_with_different_timeslot: nWa,
  we_dont_have_id_for_the_new_event: oWa,
  rerouted_booking_successfully_redirecting_to_booking_page: rWa,
  on_booking_write_to_event_object: iWa,
  field_name: aWa,
  add_new_field: sWa,
  you_dont_have_access_to_reroute_this_booking: cWa,
  form_response_not_found: lWa,
  contact_owner: dWa,
  contact_owner_not_found: uWa,
  using_fallback_members: _Wa,
  chosen_route: pWa,
  attribute_logic_matched: mWa,
  attribute_logic_fallback_matched: fWa,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: gWa,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: hWa,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: vWa,
  warning: bWa,
  fallback_attribute_logic_description: yWa,
  fallback_attribute_logic_warning: $Wa,
  fallback_not_needed: wWa,
  confirm_reassign_unavailable: kWa,
  confirm_reassign_available: SWa,
  reassign_unavailable_team_member_description: xWa,
  reassign_available_team_member_description: EWa,
  yes_reassign: TWa,
  filter_by_attributes: AWa,
  reassign_reason: CWa,
  field_type_change_suggestion: zWa,
  reassigned_by: OWa,
  row: PWa,
  rows: IWa,
  attendee_timezone_variable: RWa,
  event_start_time_in_attendee_timezone_variable: NWa,
  event_start_time_in_attendee_timezone_info: DWa,
  event_end_time_in_attendee_timezone_info: MWa,
  event_end_time_in_attendee_timezone_variable: LWa,
  salesforce_create_event_on_contact: qWa,
  salesforce_owner_name_to_change: jWa,
  no_filter_set: FWa,
  booking_dry_run_successful: VWa,
  booking_dry_run_successful_description: BWa,
  dont_have_access_this_page: UWa,
  you_need_admin_or_owner_privileges_to_access: WWa,
  field_type: GWa,
  when_to_write: HWa,
  salesforce_on_booking_write_to_record: KWa,
  on_every_booking: YWa,
  only_if_field_is_empty: ZWa,
  booking_start_date: QWa,
  booking_created_date: JWa,
  booking_reassigned_to_host: XWa,
  no_contact_owner: eGa,
  routing_forms_created: tGa,
  routing_forms_total_responses: nGa,
  routing_forms_total_responses_without_booking: oGa,
  routing_forms_total_responses_with_booking: rGa,
  routing_form_insights: iGa,
  routing_form_insights_form_name_header: aGa,
  routing_form_insights_booking_status_header: sGa,
  routing_form_insights_response_no_booking: cGa,
  routing_form_insights_booked_by: lGa,
  routing_form_insights_created_at: dGa,
  routing_form_insights_booking_status: uGa,
  routing_form_insights_booking_at: _Ga,
  routing_form_insights_submitted_at: pGa,
  copy_redirect_url: mGa,
  redirect_url_on_exit: fGa,
  total_bookings_per_period: gGa,
  routed_to_per_period: hGa,
  per_day: vGa,
  per_week: bGa,
  per_month: yGa,
  routing_form_insights_assignment_reason: $Ga,
  access_denied: wGa,
  salesforce_route_to_owner: kGa,
  salesforce_add_attendees_as: SGa,
  salesforce_do_not_route_to_owner: xGa,
  salesforce_route_to_custom_lookup_field: EGa,
  salesforce_option: TGa,
  lookup_field_name: AGa,
  salesforce_if_free_email_domain_skip_owner_check: CGa,
  filter_operator_is: zGa,
  filter_operator_is_not: OGa,
  filter_operator_contains: PGa,
  filter_operator_does_not_contain: IGa,
  filter_operator_starts_with: RGa,
  filter_operator_ends_with: NGa,
  filter_operator_is_empty: DGa,
  filter_operator_not_empty: MGa,
  translate_description_button: LGa,
  translate_description_button_description: qGa,
  rr_distribution_method: jGa,
  rr_distribution_method_description: FGa,
  rr_distribution_method_availability_title: VGa,
  rr_distribution_method_availability_description: BGa,
  rr_distribution_method_balanced_title: UGa,
  rr_distribution_method_balanced_description: WGa,
  edit_team_member_weights: GGa,
  weights_updated_successfully: HGa,
  require_confirmation_for_free_email: KGa,
  exclude_emails_that_contain: YGa,
  require_emails_that_contain: ZGa,
  exclude_emails_match_found_error_message: QGa,
  require_emails_no_match_found_error_message: JGa,
  search_columns: XGa,
  search_options: eHa,
  disable_org_url_label: tHa,
  disable_org_url_description: nHa,
  single_select: oHa,
  multi_select: rHa,
  calendar_conflict_settings: iHa,
  select_calendars_conflict_check: aHa,
  group_meeting: sHa,
  are_you_sure_you_want_to_remove_this_app_from: cHa,
  disconnect_app_from: lHa,
  salesforce_ignore_guests: dHa,
  google_meet: uHa,
  zoom: _Ha,
  office_365_video: pHa,
  lock_attribute_for_assignment: mHa,
  lock_attribute_for_assignment_description: fHa,
  attribute_edited_successfully: gHa,
  new_group_option: hHa,
  attribute_weight_enabled: vHa,
  attribute_weight_enabled_description: bHa,
  routed: yHa,
  reassigned: $Ha,
  allow_rescheduling_past_events: wHa,
  allow_rescheduling_past_events_description: kHa,
  rerouted: SHa,
  salesforce_assigned: xHa,
  router_position: EHa,
  show_matching_hosts: THa,
  no_active_queues: AHa,
  weight: CHa,
  calibration: zHa,
  shortfall: OHa,
  routing_form: PHa,
  go_back_and_save: IHa,
  save_changes: RHa,
  leave_without_saving: NHa,
  leave_without_saving_description: DHa,
  something_unexpected_occurred: MHa,
  "500_error_message": "Het ligt niet aan jou, het ligt aan ons.",
  dry_run_mode_active: LHa,
  icon_showcase: qHa,
  icons_showcase: jHa,
  migrating_from_team: FHa,
  feature_currently_disabled: VHa,
  choose_an_option: BHa,
  enter_option_value: UHa,
  remove_option: WHa,
  use_attribute_weights: GHa,
  if_enabled_ignore_event_type_weights: HHa,
  attribute_for_weights: KHa,
  managed_users: YHa,
  managed_users_description: ZHa,
  can_you_tell_me_about: QHa,
  use_ai_to_answer_your_questions: JHa,
  error_fetching_answer: XHa,
  k_bar_ai_error: eKa,
  select_oAuth_client: tKa,
  on_every_instance: nKa,
  delegation_credential_feature_not_enabled: oKa,
  internal_booking_note: rKa,
  internal_note_cancellation_reason: iKa,
  internal_booking_note_description: aKa,
  internal_note_presets: sKa,
  internal_note_presets_description: cKa,
  internal_note_presets_updated_successfully: lKa,
  add_preset: dKa,
  authorize: uKa,
  next: _Ka,
  hide: pKa,
  show: mKa,
  utm_params: fKa,
  no_utm_params: gKa,
  asc: hKa,
  desc: vKa,
  verify_email_change: bKa,
  buy_credits: yKa,
  credits: $Ka,
  credits_used: wKa,
  total_credits_remaining: kKa,
  credits_per_tip_org: SKa,
  credits_per_tip_teams: xKa,
  view_and_manage_credits: EKa,
  view_and_manage_credits_description: TKa,
  credit_worth_description: AKa,
  buy_additional_credits: CKa,
  view_additional_credits_expense_tip: zKa,
  overview: OKa,
  organization_slug_taken: PKa,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: IKa,
  you_need_to_complete_user_onboarding_before_creating_an_organization: RKa,
  use_company_email_to_create_an_organization: NKa,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: DKa,
  you_need_to_have_minimum_published_teams: MKa,
  you_are_part_of_this_organization_already: LKa,
  you_are_part_of_another_organization_cannot_create_organization: qKa,
  you_are_part_of_another_platform_organization_cannot_create_organization: jKa,
  organization_payment_success: FKa,
  organization_payment_success_description: VKa,
  this_may_take_a_few_seconds: BKa,
  organization_onboarding_status: UKa,
  organization_onboarding_status_description: WKa,
  payment_failed: GKa,
  payment_failed_description: HKa,
  creating_your_organization: KKa,
  organization_onboarding_already_completed: YKa,
  organization_onboarding_already_exists: ZKa,
  organization_onboarding_not_found: QKa,
  payment_successful: JKa,
  handover_onboarding_page_title: XKa,
  handover_onboarding_page_description: eYa,
  organization_already_exists_with_this_slug: tYa,
  you_do_not_have_permission_to_create_an_organization_for_this_email: nYa,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: oYa,
  organization_has_subscription_already: rYa,
  reset_interval_weighted_rr: iYa,
  interval: aYa,
  rr_reset_interval_description: sYa,
  daily: cYa,
  end_date_not_selected: lYa,
  my_ooo: dYa,
  team_ooo: uYa,
  out_of_office_team_description: _Ya,
  create_ooo_dialog_team_title: pYa,
  create_ooo_dialog_team_subtitle: mYa,
  edit_ooo_dialog_team_subtitle: fYa,
  ooo_team_empty_title: gYa,
  ooo_team_empty_description: hYa,
  forward_to_team_member_only: vYa,
  ooo_team_redirect_infinite_not_allowed: bYa,
  previous_ooo_empty_title: yYa,
  previous: $Ya,
  rr_interval_successfully_updated: wYa,
  trial_mode: kYa,
  inactive_team_plan: SYa,
  inactive_team_plan_description: xYa,
  limited_access_trial_mode: EYa,
  referral_program: TYa,
  referral_text: AYa,
  dub_disabled_error_message: CYa,
  uid: zYa,
  link: OYa,
  rows_per_page: PYa,
  pagination_status: IYa,
  tip_username_plus: RYa,
  user_has_no_team_yet: NYa,
  no_team_members: DYa,
  recurring_event_doesnt_support_seats: MYa,
  booking_limit_per_booker_doesnt_support_recurring: LYa,
  seats_doesnt_support_recurring: qYa,
  recurring_event_seats_error: jYa,
  segment: FYa,
  saved_filters: VYa,
  rename: BYa,
  rename_segment: UYa,
  delete_segment: WYa,
  duplicate_segment: GYa,
  delete_segment_confirmation: HYa,
  filter_segment_updated: KYa,
  error_updating_filter_segment: YYa,
  filter_segment_duplicated: ZYa,
  error_duplicating_filter_segment: QYa,
  filter_segment_deleted: JYa,
  error_deleting_filter_segment: XYa,
  save_segment: eZa,
  segment_not_found: tZa,
  filter_segment_saved: nZa,
  no_segments: oZa,
  error_saving_filter_segment: rZa,
  override_segment: iZa,
  create_new_segment: aZa,
  save_for_team: sZa,
  select_team: cZa,
  please_select_team: lZa,
  personal: dZa,
  hide_team_profile_link: uZa,
  hide_team_profile_link_description: _Za,
  display: pZa,
  could_not_find_slug_to_publish_org: mZa,
  picklist: fZa,
  most_cancelled_bookings: gZa,
  interface_language: hZa,
  interface_language_description: vZa,
  visitors_browser_language: bZa,
  name_or_email: yZa,
  salesforce_round_robin_skip_fallback_to_lead_owner: $Za,
  credit_purchase_failed: wZa,
  minimum_of_credits_required: kZa,
  enable_delegation_credential: SZa,
  enable_delegation_credential_description: xZa,
  disable_delegation_credential: EZa,
  disable_delegation_credential_description: TZa,
  last_active: AZa,
  member_since: CZa,
  last_updated: zZa,
  salesforce_on_cancel_write_to_event: OZa,
  salesforce_on_every_cancellation: PZa,
  report_issue: IZa,
  report_issue_description: RZa,
  open_issue: NZa,
  this_is_your_current_plan: DZa,
  schedule_a_time: MZa,
  this_includes: LZa,
  oauth_client_updated_successfully: qZa,
  oauth_client_not_found: jZa,
  subscribe_to_platform: FZa,
  error_accessing_webhooks: VZa,
  webhook_update_failed: BZa,
  webhook_create_failed: UZa,
  invalid_link: WZa,
  currently_subscribed_to_plan: GZa,
  user_team: HZa,
  client_id_copied: KZa,
  client_secret_copied: YZa,
  maintenance_message: ZZa,
  your_payment_failed: QZa,
  check_your_inbox: JZa,
  account_created_premium_not_reserved: XZa,
  email_sent_with_activation_link: eQa,
  activate_account_to_purchase_username: tQa,
  open_in_gmail: nQa,
  dont_see_email: oQa,
  resend_in_seconds: rQa,
  resend: iQa,
  verification_email_sent: aQa,
  select_all_members: sQa,
  select_all_members_tooltip: cQa,
  form_settings: lQa,
  remove_whitelist_status: dQa,
  whitelist_user_workflows: uQa,
  user_workflows_whitelisted: _Qa,
  user_workflows_unwhitelisted: pQa,
  date_and_time: mQa,
  email_reminder_upcoming_event_notice: fQa,
  email_reminder_triggered_by_workflow: gQa,
  event_upper_case: hQa,
  scheduling_by: vQa,
  experience_review_prompt: bQa,
  improve_customer_experience_message: yQa,
  meeting_satisfaction_question: $Qa,
  meeting_not_joined_question: wQa,
  reschedule_cta_short: kQa,
  hide_organizer_email: SQa,
  platform_customer_cant_create_organization: xQa,
  organization_customer_cant_create_platform: EQa,
  hide_organizer_email_description: TQa,
  you_and_conjunction: AQa,
  select_verified_email: CQa,
  add_verified_email: zQa,
  add_verified_emails: OQa,
  custom_reply_to_email_title: PQa,
  custom_reply_to_email_description: IQa,
  email_survey_triggered_by_workflow: RQa,
  skip_trial: NQa,
  team_trials_skipped_successfully: DQa,
  sms_workflow_consent: MQa,
  routing_preview_more_info_found_insights: LQa,
  results: qQa,
  view_form: jQa,
  sms_opt_out_message: FQa,
  team_credits_low_warning: VQa,
  user_credits_low_warning: BQa,
  action_required_out_of_credits: UQa,
  action_required_user_out_of_credits: WQa,
  low_credits_warning_message: GQa,
  low_credits_warning_message_user: HQa,
  credit_limit_reached_message: KQa,
  credit_limit_reached_message_user: YQa,
  current_credit_balance: ZQa,
  current_balance: QQa,
  notification_about_your_booking: JQa,
  monthly_credits: XQa,
  total_credits: eJa,
  remaining_credits: tJa,
  remaining: nJa,
  total: oJa,
  additional_credits: rJa,
  routing_form_next_in_queue: iJa,
  routing_form_select_members_to_email: aJa,
  routing_incomplete_booking_tab: sJa,
  include_no_show_in_rr_calculation: cJa,
  recent_no_show_guests: lJa,
  recent_no_show_guests_tooltip: dJa,
  matching: uJa,
  event_redirect: _Ja,
  reset_form: pJa,
  rr_settings_successfully_updated: mJa,
  distribution_basis_weighted_rr: fJa,
  timestamp_basis_description: gJa,
  requires_credits: hJa,
  requires_credits_tooltip: vJa,
  available_credits: bJa,
  create_role: yJa,
  roles_and_permissions: $Ja,
  roles_and_permissions_description: wJa,
  learn_more_permissions: kJa,
  role_name: SJa,
  role_name_required: xJa,
  role_name_placeholder: EJa,
  role_description: TJa,
  role_description_placeholder: AJa,
  default_role: CJa,
  custom_role: zJa,
  advanced: OJa,
  search_permissions: PJa,
  all_permissions: IJa,
  none: RJa,
  read_only: NJa,
  pbac_desc_all_actions_all_resources: DJa,
  pbac_resource_all: MJa,
  pbac_resource_event_type: LJa,
  pbac_resource_team: qJa,
  pbac_resource_organization: jJa,
  pbac_resource_booking: FJa,
  pbac_resource_insights: VJa,
  pbac_resource_role: BJa,
  pbac_resource_routing_form: UJa,
  pbac_resource_workflow: WJa,
  pbac_action_all: GJa,
  pbac_action_create: HJa,
  pbac_action_read: KJa,
  pbac_action_update: YJa,
  pbac_action_delete: ZJa,
  pbac_action_manage: QJa,
  pbac_action_invite: JJa,
  pbac_action_remove: XJa,
  pbac_action_change_member_role: eXa,
  pbac_action_list_members: tXa,
  pbac_action_manage_billing: nXa,
  pbac_action_read_team_bookings: oXa,
  pbac_action_read_org_bookings: rXa,
  pbac_action_read_recordings: iXa,
  pbac_action_impersonate: aXa,
  role_created_successfully: sXa,
  role_updated_successfully: cXa,
  delete_role: lXa,
  confirm_delete_role: dXa,
  role_deleted_successfully: uXa,
  error_creating_role: _Xa,
  error_updating_role: pXa,
  pbac_desc_create_roles: mXa,
  pbac_resource_attributes: fXa,
  pbac_desc_view_organization_attributes: gXa,
  pbac_desc_update_organization_attributes: hXa,
  pbac_desc_delete_organization_attributes: vXa,
  pbac_desc_create_organization_attributes: bXa,
  pbac_desc_view_roles: yXa,
  pbac_desc_update_roles: $Xa,
  pbac_desc_delete_roles: wXa,
  pbac_desc_create_workflows: kXa,
  set_up_required: SXa,
  pbac_desc_view_workflows: xXa,
  pbac_desc_update_workflows: EXa,
  pbac_desc_delete_workflows: TXa,
  pbac_resource_webhook: AXa,
  pbac_resource_availability: CXa,
  pbac_resource_out_of_office: zXa,
  pbac_desc_create_webhooks: OXa,
  pbac_desc_view_webhooks: PXa,
  pbac_desc_update_webhooks: IXa,
  pbac_desc_delete_webhooks: RXa,
  pbac_desc_create_availability: NXa,
  pbac_desc_view_availability: DXa,
  pbac_desc_update_availability: MXa,
  pbac_desc_delete_availability: LXa,
  pbac_desc_create_out_of_office: qXa,
  pbac_desc_view_out_of_office: jXa,
  pbac_desc_update_out_of_office: FXa,
  pbac_desc_delete_out_of_office: VXa,
  pbac_desc_manage_workflows: BXa,
  pbac_desc_create_event_types: UXa,
  pbac_desc_view_event_types: WXa,
  pbac_desc_update_event_types: GXa,
  pbac_desc_delete_event_types: HXa,
  pbac_desc_manage_event_types: KXa,
  pbac_desc_create_teams: YXa,
  pbac_desc_view_team_details: ZXa,
  pbac_desc_update_team_settings: QXa,
  pbac_desc_delete_team: JXa,
  pbac_desc_invite_team_members: XXa,
  pbac_desc_remove_team_members: ees,
  pbac_desc_change_team_member_role: tes,
  pbac_desc_impersonate_team_members: nes,
  pbac_desc_manage_teams: oes,
  pbac_desc_create_organization: res,
  pbac_desc_view_organization_details: ies,
  pbac_desc_list_organization_members: aes,
  pbac_desc_invite_organization_members: ses,
  pbac_desc_remove_organization_members: ces,
  pbac_desc_manage_organization_billing: les,
  pbac_desc_change_organization_member_role: des,
  pbac_desc_impersonate_organization_members: ues,
  pbac_desc_edit_organization_settings: _es,
  pbac_desc_manage_organizations: pes,
  pbac_desc_view_bookings: mes,
  pbac_desc_view_team_bookings: fes,
  pbac_desc_view_organization_bookings: ges,
  pbac_desc_view_booking_recordings: hes,
  pbac_desc_update_bookings: ves,
  pbac_desc_manage_bookings: bes,
  pbac_desc_view_team_insights: yes,
  pbac_desc_manage_team_insights: $es,
  pbac_desc_create_routing_forms: wes,
  pbac_desc_view_routing_forms: kes,
  pbac_desc_update_routing_forms: Ses,
  pbac_desc_delete_routing_forms: xes,
  read_permission_auto_enabled_tooltip: Ees,
  choose_restriction_schedule: Tes,
  restriction_schedule_description: Aes,
  use_booker_timezone: Ces,
  use_booker_timezone_info: zes,
  load_balancing_warning: Oes,
  rr_load_balancing_disabled: Pes,
  rr_load_balancing_disabled_with_groups: Ies,
  round_robin_settings_description: Res,
  round_robin_settings_updated_successfully: Nes,
  booking_creation_time: Des,
  meeting_start_time: Mes,
  members_affected_by_disabling_delegation_credential: Les,
  no_members_affected_by_disabling_delegation_credential: qes,
  download_expense_log: jes,
  error_downloading_expense_log: Fes,
  offer_to_reschedule_last_booking: Ves,
  booker_limit_exceeded_error: Bes,
  booker_limit_exceeded_error_reschedule: Ues,
  duration_min_error: Wes,
  duration_max_error: Ges,
  booking_not_allowed_by_restriction_schedule_error: Hes,
  restriction_schedule_not_found_error: Kes,
  converted_image_size_limit_exceed: Yes,
  add_group: Zes,
  routing_funnel: Qes,
  routing_funnel_total_submissions: Jes,
  routing_funnel_successful_routings: Xes,
  routing_funnel_accepted_bookings: ets,
  license_key: tts,
  license_selection_title: nts,
  license_selection_description: ots,
  agplv3_license_description: rts,
  enter_license_key: its,
  enter_your_license_key: ats,
  enter_existing_license: sts,
  enter_license_key_description: cts,
  license_key_placeholder: lts,
  save_license_key: dts,
  signature_token_optional: uts,
  signature_token_description: _ts,
  need_a_license: pts,
  license_key_required: mts,
  invalid_license_key: fts,
  license_validation_failed: gts,
  attachments_optional: hts,
  send_message: vts,
  describe_the_issue: bts,
  file_size_limit_exceed: yts,
  invalid_file_type: $ts,
  invalid_file_type_extension: wts,
  max_files_exceeded: kts,
  files_uploaded_successfully: Sts,
  file_upload_instructions: xts,
  license_key_saved: Ets,
  timezone_mismatch_tooltip: Tts,
  show_optimized_slots: Ats,
  show_optimized_slots_description: Cts,
  failed_bookings_by_field: zts,
  failed_bookings: Ots,
  event_type_no_hosts: Pts,
  cache_status: Its,
  cache_last_updated: Rts,
  delete_cached_data: Nts,
  cache_deleted_successfully: Dts,
  error_deleting_cache: Mts,
  confirm_delete_cache: Lts,
  yes_delete_cache: qts,
  remainder_of_maximum_uses_left_plural: jts,
  remainder_of_maximum_use_left_singular: Fts,
  expires_on_date: Vts,
  single_use: Bts,
  time_based_expiration: Uts,
  usage_based_expiration: Wts,
  number_of_uses: Gts,
  expires_on: Hts,
  max_usage_count: Kts,
  link_settings: Yts,
  link_expired_on_date: Zts,
  usage_limit_reached: Qts,
  usage_count_error: Jts,
  private_link_expired: Xts,
  time_based_expiration_description: ens,
  time_based_generic_expiration_description: tns,
  usage_based_expiration_description: nns,
  usage_based_generic_expiration_description: ons,
  usage_based_expiration_description_plural: rns,
  webhook_trigger_event: ins,
  webhook_created_at: ans,
  webhook_type: sns,
  set_up_agent: cns,
  webhook_title: lns,
  webhook_start_time: dns,
  webhook_end_time: uns,
  webhook_description: _ns,
  webhook_location: pns,
  webhook_uid: mns,
  webhook_reschedule_uid: fns,
  webhook_cancellation_reason: gns,
  webhook_rejection_reason: hns,
  webhook_organizer_name: vns,
  webhook_organizer_email: bns,
  webhook_organizer_timezone: yns,
  webhook_organizer_locale: $ns,
  webhook_organizer_username: wns,
  webhook_organizer_username_in_org: kns,
  webhook_attendee_name: Sns,
  webhook_attendee_email: xns,
  webhook_attendee_timezone: Ens,
  webhook_attendee_locale: Tns,
  webhook_team_name: Ans,
  webhook_team_members: Cns,
  webhook_video_call_url: zns,
  webhook_hide_variables: Ons,
  webhook_show_variable: Pns,
  webhook_event_and_booking: Ins,
  webhook_people: Rns,
  webhook_teams: Nns,
  webhook_metadata: Dns,
  stats: Mns,
  booking_status: Lns,
  visit: qns,
  location_custom_label_input_label: jns,
  meeting_link: Fns,
  session_outcome: Vns,
  call_created: Bns,
  voicemail: Uns,
  my_bookings: Wns,
  phone: Gns,
  free: Hns,
  user_email: Kns,
  user_name: Yns,
  expand_panel: Zns,
  collapse_panel: Qns,
  email_verification_required: Jns,
  invalid_verification_code: Xns,
  you_have_one_team: eos,
  consider_consolidating_one_team_org: tos,
  consider_consolidating_multi_team_org: nos,
  message_sent: oos,
  support_message_sent_description: ros,
  search_variables: ios,
  support_message_placeholder: aos,
  send_another_message: sos,
  sending: cos,
  no_variables_found: los,
  credits_required: dos,
  web_call_credits_info: uos,
  web_call_no_credits: _os,
  purchase_credits: pos,
  credits_required_tooltip: mos,
  api_key_name_too_long: fos,
  auto_charge_for_last_minute_cancellation: gos,
  before_scheduled_start_time: hos,
  cancel_booking_acknowledge_no_show_fee: vos,
  contact_organizer: bos,
  booking_time_option: yos,
  booking_time_option_description: $os,
  created_at_option: wos,
  created_at_option_description: kos,
  call_details: Sos,
  call_id: xos,
  call_information: Eos,
  sentiment: Tos,
  disconnect_reason: Aos,
  call_summary: Cos,
  transcription: zos,
  event_details: Oos,
  agent: Pos,
  no_transcript_available: Ios,
  testing_sms_workflow_info_message: Ros,
  start_from_scratch_title: Nos,
  start_from_scratch_description: Dos,
  cal_ai_template_title: Mos,
  cal_ai_template_description: Los,
  voice: qos,
  select_voice: jos,
  select_voice_for_agent: Fos,
  choose_a_voice_for_your_agent: Vos,
  trait: Bos,
  voice_id: Uos,
  use_voice: Wos,
  current_voice: Gos,
  setup_incoming_agent: Hos,
  setup_incoming_agent_description: Kos,
  connect_a_phone_number_first: Yos,
  setup_agent_for_incoming_calls: Zos,
  configure_agent_to_handle_incoming_calls: Qos,
  incoming_calls: Jos,
  outgoing_calls: Xos,
  inbound_agent_setup_success: ers,
  inbound_agent_configured: trs,
  setup_inbound_agent: nrs,
  please_select_event_type_first: ors,
  edit_configuration: rrs,
  select_event_type_for_inbound_calls: irs,
  setup_inbound_agent_for_incoming_calls: ars,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: srs
}, lrs = "Provedor de identidade", drs = 'Você tem $t(day, {"count": {{days}} }) restantes no seu período de testes da versão PRO', urs = "{{count}} dia", _rs = "{{count}} dias", prs = "{{count}} segundo", mrs = "{{count}} segundos", frs = "Atualizar agora", grs = "Sem título", hrs = "Aceitar convite", vrs = "Máx. Caracteres", brs = "Mín. Caracteres", yrs = "{{appName}} é a alternativa de código aberto ao Calendly que coloca você no controle dos seus dados, fluxo de trabalho e aparência.", $rs = "Conclua a configuração da sua conta {{appName}}! Você está a poucos passos de resolver todos os seus problemas de agendamento.", wrs = "Precisa de ajuda? Estamos aqui para ajudar.", krs = "{{appName}}: Instruções para redefinir sua senha", Srs = "{{appName}}: Verifique sua conta", xrs = "{{appName}}: Verifique seu e-mail", Ers = "Verifique seu e-mail", Trs = "E-mail antigo", Ars = "Novo e-mail", Crs = "Enviamos um e-mail para {{email}}. É importante verificar seu endereço de e-mail para garantir o melhor envio de e-mail e calendário do {{appName}}.", zrs = "Verifique seu endereço de e-mail para garantir o fornecimento do melhor e-mail e calendário", Ors = "Verifique seu endereço de e-mail", Prs = "Verificar e-mail", Irs = "Assistente", Rrs = "Enviar e-mails com transcrição do Cal Video", Nrs = "Enviar e-mails com a transcrição do Cal Video após o término da reunião. (Requer um plano pago)", Drs = "Você solicitou recentemente a alteração do endereço de e-mail que você usa para entrar em sua conta {{appName}}. Por favor, clique no botão abaixo para confirmar o seu novo endereço de e-mail.", Mrs = "Seu e-mail foi atualizado para {{email}}", Lrs = "Não foi possível atualizar o e-mail.", qrs = "Verifique seu novo endereço de e-mail da sua conta {{appName}}", jrs = "Enviamos um link de verificação para {{email}}. Atualizaremos seu endereço de e-mail quando você clicar neste link.", Frs = "Salve esta chave de API em um lugar seguro. Você não será capaz de vê-la novamente.", Vrs = "Por favor, verifique seu endereço de e-mail clicando no botão abaixo.", Brs = "Por favor, verifique seu endereço de e-mail usando o código abaixo.", Urs = "Aqui está o link caso você não goste de usar botões:", Wrs = "Insira o código de verificação", Grs = "Insira o código de verificação enviado para seu e-mail", Hrs = "O código de verificação está incorreto.", Krs = "E-mail enviado com sucesso", Yrs = "Ocorreu um erro ao enviar o e-mail", Zrs = "Recusado: {{title}} em {{date}}", Qrs = "Cancelado: {{title}} em {{date}}", Jrs = "Reatribuído: {{title}} em {{date}}", Xrs = "Sua solicitação de reunião foi recusada", eis = "Personalizar configurações do Cal Video", tis = "Configure preferências de reuniões por vídeo, incluindo permissões de gravação para anfitriões e participantes.", nis = "Desativar gravação para convidados", ois = "Ativar transcrição automática após entrar na reunião", ris = "Ativar gravação automática após o organizador entrar na reunião", iis = "Opções de vídeo", ais = "Editar evento", sis = "Ver detalhes da sessão", cis = "Detalhes da sessão de reunião", lis = "Sessão de reunião", dis = "ID da sessão", uis = "Máximo de participantes", _is = "Ilimitado", pis = "Em andamento", mis = "Finalizada", fis = "Participantes", gis = "Usuário anônimo", his = "Duração da sessão", vis = "Nenhuma sessão de reunião encontrada", bis = "Não disponível", yis = "Desativar gravação para organizador", $is = "Desativar transcrição para convidados", wis = "Desativar transcrição para organizador", kis = "Sua solicitação de evento recorrente foi recusada", Sis = "Seu evento agendado foi cancelado", xis = "Seu evento agendado foi reatribuído", Eis = "O evento não estará mais em seu calendário e sua probabilidade de round robin não será afetada negativamente", Tis = "Organizador", Ais = "Reatribuído para", Cis = "Precisa reagendar ou cancelar?", zis = "Você pode ver os detalhes da reserva neste URL {{url}} e adicionar o evento ao seu calendário", Ois = "Sem opções disponíveis", Pis = "Motivo do cancelamento", Iis = "Cancelado por", Ris = "Motivo do cancelamento", Nis = "Por que você está cancelando?", Dis = "O motivo do cancelamento será compartilhado com os convidados", Mis = "Por que você está rejeitando?", Lis = "Motivo da recusa", qis = "Recusar a solicitação de reserva?", jis = "Tem certeza de que deseja recusar a reserva? Avisaremos a pessoa que tentou reservar. Se quiser, informe um motivo abaixo.", Fis = "Recusar a reserva", Vis = "Gerenciar este evento", Bis = "Convidar membro da equipe", Uis = "Convite individual", Wis = "Importação em massa", Gis = "Con.", His = "A sua reunião foi agendada", Kis = "Seu evento recorrente foi agendado", Yis = "Aceite a nossa licença alterando a variável no arquivo .env <1>NEXT_PUBLIC_LICENSE_CONSENT</1> para '{{agree}}'.", Zis = "Para remover este banner, por favor abra seu arquivo .env e altere a variável <1>NEXT_PUBLIC_LICENSE_CONSENT</1> para '{{agree}}'.", Qis = "A mensagem de erro: '{{errorMessage}}'", Jis = "O reembolso falhou: {{name}} - {{date}} - {{eventType}}", Xis = "O reembolso do evento {{eventType}} com {{userName}} em {{date}} falhou.", eas = "Por favor, tente resolver junto do seu fornecedor de pagamentos e com o {{user}}.", tas = "Um reembolso falhou", nas = "Aguardando pagamento: {{title}} em {{date}}", oas = "Sua reunião está aguardando o pagamento", ras = "A cor do tema escuro não foi aprovada pela verificação de contraste. Recomendamos que você altere esta cor para que seus botões fiquem mais visíveis.", ias = "A cor do tema claro não foi aprovada pela verificação de contraste. Recomendamos que você altere esta cor para que seus botões fiquem mais visíveis.", aas = "A cor do Tema Claro não passa na verificação de contraste. Recomendamos que você altere essa cor para que a cor dos seus tipos de eventos seja mais visível.", sas = "A cor do Tema Escuro não passa na verificação de contraste. Recomendamos que você altere essa cor para que a cor dos seus tipos de eventos seja mais visível.", cas = "O pagamento não pôde ser criado", las = "Não foi possível cobrar o cartão para o pagamento", das = "Nenhum usuário disponível foi encontrado. Você poderia tentar outra faixa horária?", uas = "O horário selecionado não está mais disponível. <0>Por favor, selecione um novo horário</0>", _as = "Ocupado", pas = "Você acabou de se conectar. Por favor, reserve um dos horários acima ou tente novamente mais tarde.", mas = "Horário indisponível", fas = "O tipo de evento não pode ser agendado neste horário. Você poderia tentar outro horário?", gas = "Erro interno. O corpo da solicitação não contém a hora final", has = "Não foi possível criar um evento no calendário do organizador", vas = "Não foi possível atualizar o evento.", bas = "Não foi possível deletar o evento.", yas = "Você já está inscrito para esta reserva.", $as = "Algum dos anfitriões não está disponível para reserva.", was = "Alguns dos anfitriões fixos não estão disponíveis para reserva.", kas = "O anfitrião do Round Robin não está disponível para agendamento.", Sas = "Ajuda", xas = "Preço", Eas = "Pago", Tas = "Reembolsado", Aas = "Gravar", Cas = "Transcrever", zas = "Pagamento", Oas = "Faltam campos do cartão", Pas = "Pagar agora", Ias = "Solicitação Geral", Ras = "Transcrição alimentada por IA", Nas = "Iniciar ou parar gravação", Das = "Inicie a Mensagem", Mas = "Todo o código deverá permanecer em código aberto, quer seja modificado ou não", Las = "Você não pode redistribuir ou vender o código", qas = "Envie um e-mail para adquirir uma licença comercial e remover estes termos", jas = "Resumo dos termos", Fas = "Abra o arquivo .env e aceite a nossa licença", Vas = "Alterei o meu arquivo .env", Bas = "Aceitar licença", Uas = "Um evento ainda aguarda aprovação", Was = "Solicitação de evento pendente: {{attendeeName}} - {{date}} - {{eventType}}", Gas = 'Nenhum resultado encontrado para "{{searchTerm}}"', Has = "Não existem mais resultados", Kas = "Nenhum resultado", Yas = "Carregar mais resultados", Zas = "ID da reunião de {{integrationName}}: {{meetingId}}", Qas = "Confirmado: {{eventType}} com {{name}} em {{date}}", Jas = "Solicitação de novo evento: {{attendeeName}} - {{date}} - {{eventType}}", Xas = "Confirmar ou recusar a reserva", ess = "Consulte a sua página de reservas para confirmar ou recusar a reserva.", tss = "Assistente de Check-in", nss = "Faz uma chamada para verificar se o compromisso agendado funciona ou se você deseja reagendar.", oss = "Crie seu próprio prompt e use-o para fazer uma chamada.", rss = "Um evento está aguardando a sua aprovação", iss = "Um evento recorrente aguarda a sua aprovação", ass = "Alguém solicitou o agendamento de um evento em sua agenda.", sss = "Alguém solicitou um link para alterar sua senha.", css = "Se estee-mail existir em nosso sistema, você receberá um e-mail de redefinição.", lss = "Se você não fez essa solicitação, você pode ignorar este e-mail e sua senha não será alterada.", dss = "Aguardando aprovação: {{title}} em {{date}}", uss = "Um evento está aguardando a sua aprovação", _ss = "Reserva enviada: {{title}} em {{date}}", pss = "Baixar gravação: {{title}} em {{date}}", mss = "Baixe a transcrição: {{title}} em {{date}}", fss = "Baixe sua gravação", gss = "Baixe suas transcrições", hss = "A sua reunião foi agendada", vss = "Seu {{title}} foi remarcado para {{date}}.", bss = "Seu {{title}} foi atualizado.", yss = "Atualização - O seu evento foi reagendado", $ss = "O evento foi atualizado", wss = "Seu evento foi reagendado", kss = "{{organizer}} cancelou a reserva e solicitou que você escolhesse outro horário.", Sss = "Você solicitou que {{attendee}} reagendasse", xss = "Você cancelou a reserva e {{attendee}} escolherá um novo horário.", Ess = "Solicitação de reagendamento enviado: {{eventType}} com {{name}} às {{date}}", Tss = "Ação de reagendamento necessária: reserve outro horário para {{eventType}} com {{name}}", Ass = "Olá {{name}}", Css = "{{eventType}} com {{name}}", zss = "Parece que todos os nossos especialistas estão ocupados no momento. Por favor, agende uma chamada em um horário que seja mais conveniente para você e estaremos prontos para ajudar.", Oss = "Agendar agora", Pss = "Novo evento: {{attendeeName}} - {{date}} - {{eventType}}", Iss = "Junte-se através de {{entryPoint}}", Rss = "Notas", Nss = "Gerenciar minhas reservas", Dss = "Precisa alterar?", Mss = "Um novo evento foi agendado.", Lss = "Um novo evento recorrente foi agendado.", qss = "E-mail do participante", jss = "Fuso horário do participante", Fss = "Tempo restante", Vss = "Tipo do evento", Bss = "Tipo de evento duplicado", Uss = "Entrar na reunião", Wss = "Fornecedor de videochamada", Gss = "ID da reunião", Hss = "Senha da reunião", Kss = "URL da reunião", Yss = "URL da reunião não encontrada", Zss = "Token não encontrado", Qss = "Outro anfitrião já aceitou a reunião. Você ainda deseja participar? <0>Continuar para a reunião</0>", Jss = "A sua solicitação de reunião foi rejeitada", Xss = "Rejeitado: {{eventType}} com {{organizer}} em {{date}}", ecs = "Olá", tcs = "Entrar no time", ncs = "Gerenciar esta equipe", ocs = "Informações da equipe", rcs = "Entrar na reunião", ics = "Se não quiser utilizar {{toEmail}} como e-mail do {{appName}}, ou já tem uma conta em {{appName}}, por favor peça outro convite para esse e-mail.", acs = "Você recebeu um convite para se juntar ao time {{teamName}}", scs = "{{user}} convidou para ingressar na equipe {{team}} de {{entity}} em {{appName}}", ccs = "Você está oculto nesta equipe", lcs = "Seu assento não é pago, atualize para a versão Pro ou avise o proprietário da equipe de que é possível pagar pelo seu assento.", dcs = "É preciso ter uma conta Pro para usar equipes, você permanecerá oculto até a atualização.", ucs = "P.S.: Expira em {{expiresIn}} horas.", _cs = 'Atualize para "Por assento"', pcs = "Não é possível usar reservas com assento quando a reserva exigir confirmação", mcs = "Múltiplas Localizações não suportam a opção de assentos", fcs = "A taxa de não comparecimento não suporta a opção de assentos", gcs = "A opção de assentos não suporta Múltiplas Localizações", hcs = "Dos {{memberCount}} membros da sua equipe, há {{unpaidCount}} assento(s) não pago(s). A ${{seatPrice}}/mês por assento, o custo total estimado da sua assinatura é de ${{totalCost}}/mês.", vcs = 'Agradecemos por testar nosso novo plano de equipe. Notamos que a sua equipe "{{teamName}}" precisa ser atualizada.', bcs = "Atualizar aqui", ycs = "Sua equipe foi atualizada com êxito!", $cs = 'Agradecemos por testar nosso novo plano Organization. Notamos que a sua organização "{{teamName}}" precisa ser atualizada.', wcs = "Sua Organização foi atualizada com êxito!", kcs = "Use o link abaixo para redefinir a sua senha", Scs = "Olá", xcs = "lá", Ecs = "Esqueceu sua senha? - {{appName}}", Tcs = "Você tem certeza que quer remover este Webhook? Você não receberá mais dados de reuniões de {{appName}} na URL especificada, em tempo real, quando um evento for agendado ou cancelado.", Acs = "Sim, remover o Webhook", Ccs = "Editar Webhook", zcs = "Excluir Webhook", Ocs = "Status do Webhook", Pcs = "Webhook ativado", Ics = "Webhook desativado", Rcs = "Resposta do Webhook", Ncs = "Teste do Webhook", Dcs = "Formulário de atualização de webhook", Mcs = "Adicione um webhook ao seu OAuthClient.", Lcs = "Gerenciar o seu Webhook", qcs = "Webhook criado com sucesso!", jcs = "Webhook atualizado com sucesso!", Fcs = "Webhook removido com sucesso!", Vcs = "Assinatura necessária", Bcs = "Você não está inscrito em um plano da plataforma.", Ucs = "Modelo de carga", Wcs = "Descartar", Gcs = "Ainda não há dados", Hcs = "Teste de ping", Kcs = "Adicione este aplicativo à sua tela inicial para acesso mais rápido e melhor experiência.", Ycs = "Próximos", Zcs = "Recorrente", Qcs = "Anteriores", Jcs = "Escolher um arquivo...", Xcs = "Enviar imagem", els = "Enviar {{target}}", tls = "Nenhum {{target}}", nls = "Deslize para ampliar, arraste para reposicionar", ols = "Ver notificações", rls = "Ver página pública", ils = "Copiar link de página pública", als = "Copiar link de indicação", sls = "Sair", cls = "Adicionar outro", lls = "Instalar outro", dls = "até", uls = "desenvolvido por", _ls = "Indisponível", pls = "Defina o seu horário de trabalho", mls = "Altere a sua disponibilidade para reservas", fls = "Selecionar...", gls = "Texto", hls = "Seu número de telefone", vls = "Múltiplas linhas de texto", bls = "Número", yls = "Caixa de seleção", $ls = "É obrigatório", wls = "Tornar este campo obrigatório", kls = "Obrigatório", Sls = "Opcional", xls = "Tipo de campo", Els = "Recusado", Tls = "Não confirmado", Als = "Participantes", Cls = "Participante", zls = "Os detalhes para a vídeo chamada serão fornecidos em breve.", Ols = "Confirmação", Pls = "O que seu agendador deve fornecer para receber confirmações", Ils = "Nome de usuário", Rls = "ainda está disponível.", Nls = "Documentação", Dls = "Saiba como integrar as nossas ferramentas com a sua aplicação", Mls = "Referência da API", Lls = "Uma referência completa da API para as nossas bibliotecas", qls = "Blog", jls = "Leia as nossas últimas notícias e artigos", Fls = "Junte-se à nossa comunidade", Vls = "Páginas populares", Bls = "Inscreva-se agora", Uls = "Inscrição", Wls = "Esta página não existe.", Gls = "Nenhum número de telefone ativo disponível", Hls = "Etapa do fluxo de trabalho não configurada", Kls = "Verificar erros ortográficos ou voltar à página anterior.", Yls = "Não foi possível achar o evento que você está tentando reservar.", Zls = "Começar", Qls = "Segredo", Jls = "Deixe em branco para remover o segredo", Xls = "Verifique se o seu servidor está recebendo apenas as solicitações esperadas do {{appName}} por razões de segurança", eds = "Reunião secreta", tds = "Em vez disso, faça login", nds = "Criar Conta", ods = "Começar", rds = "Confirmar senha", ids = "Defina sua nova senha com as instruções enviadas para seu endereço de e-mail.", ads = "Faça upload de uma imagem com largura {{width}} e altura {{height}} .", sds = "Volte a entrar com seu novo endereço de e-mail e senha.", cds = "Criar sua conta", lds = "Crie sua conta Cal.com", dds = "Cadastro", uds = "A sessão foi encerrada", _ds = "Esperamos te ver novamente em breve!", pds = "Sessão Encerrada", mds = "Por favor, tente novamente e contate-nos se o problema persistir.", fds = "O código de dois fatores está incorreto.", gds = "Não existe nenhuma conta associada a este endereço de e-mail.", hds = "Criar uma conta", vds = "Não tem uma conta?", bds = "Fazer login em sua conta", yds = "Iniciar sessão", $ds = "Voltar à página de login", wds = "Ocorreu um erro ao iniciar sessão. Volte a tela de login e tente novamente.", kds = "Solicitar redefinição da senha", Sds = "Enviar convite", xds = "Esqueceu a senha?", Eds = "Esqueceu?", Tds = "Concluído", Ads = "Tudo pronto!", Cds = "Todos", zds = "Sua conta", Ods = "Aplicativos disponíveis", Pds = "Aplicativos disponíveis", Ids = "Veja aplicativos populares abaixo e explore mais em nossa <0>App Store</0>", Rds = "Adicione qualquer pessoa que precise participar do evento. <0>Saiba mais</0>", Nds = "As pessoas em um grupo se revezam, uma pessoa de cada grupo aparecerá para o evento.", Dds = "As pessoas do grupo se revezam, e apenas uma aparecerá para o evento.", Mds = "Verifique o seu e-mail. Enviamos um link para redefinir a sua senha.", Lds = "Finalizar", qds = "Gerencie as configurações para o idioma e o fuso horário da sua equipe", jds = "Fale um pouco sobre você. Isto será exibido em sua página pessoal.", Fds = "Quase lá!", Vds = "Por último, uma breve descrição sobre você e uma foto realmente ajudam a conseguir agendamentos e permitem que as pessoas saibam com quem estão agendando.", Bds = "Definir períodos em que você está disponível de forma recorrente. Mais tarde você poderá criar outros períodos e atribuí-los a diferentes calendários.", Uds = "Definir disponibilidade", Wds = "Defina os horários que você quer que estejam disponíveis para reservas.", Gds = "Compartilhe um link ou incorpore", Hds = "Compartilhe o link da sua conta {{appName}} ou incorpore no seu site.", Kds = "Configurações de disponibilidade", Yds = "Continuar sem calendário", Zds = "Continuar com {{appName}}", Qds = "Conectar seu calendário", Jds = "Conecte seus aplicativos de vídeo", Xds = "Conecte seus aplicativos de vídeo para usá-los nos seus tipos de evento.", eus = "Conecte seu calendário para verificar automaticamente horários ocupados e novos eventos conforme são agendados.", tus = "Configurar mais tarde", nus = "Hora atual", ous = "Detalhes", rus = "Bem vindo", ius = "Bem-vindo(a) novamente", aus = "Bem vindo ao {{appName}}", sus = "Diga-nos como devemos chamá-lo e informe em qual fuso horário você está. Você poderá editar isso mais tarde.", cus = "Conectar a um servidor CalDav", lus = "Conectar a um feed ICS", dus = "Conectar", uus = "Experimente gratuitamente", _us = "Crie o seu próprio link para reservas com {{appName}}", pus = "Quem", mus = "O quê", fus = "Quando", gus = "Onde", hus = "Adicionar ao calendário", vus = "Selecione onde adicionar eventos quando você for agendado.", bus = "Adicionar eventos a", yus = "Adicionar outro calendário", $us = "Outras", wus = "Seu link de login para {{appName}}", kus = "Você está reunindo-se com {{user}}. Nós enviamos um e-mail com um convite de calendário com todos os detalhes para todos.", Sus = "{{host}} terá uma reunião com {{attendee}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes.", xus = "Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes.", Eus = "Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", Tus = "Você terá uma reunião com {{user}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", Aus = "{{host}} terá uma reunião com {{attendee}}. Enviamos um e-mail com um convite para o calendário contendo todos os detalhes para todos os participantes para o primeiro destes eventos recorrentes.", Cus = "Esta informação foi enviada para você e para todos os outros participantes.", zus = "A sua reserva ainda precisa de ser confirmada ou recusada.", Ous = "A sua reunião recorrente ainda precisa ser confirmada ou recusada.", Pus = "{{user}} ainda tem de confirmar ou recusar a reserva.", Ius = "{{user}} ainda precisa confirmar ou recusar cada reserva da reunião recorrente.", Rus = "Esta reunião está agendada", Nus = "Os eventos recorrentes foram agendados", Dus = "Reserva efetuada", Mus = "Sua reunião recorrente foi enviada", Lus = "Reserva confirmada", qus = "Sua reunião recorrente foi confirmada", jus = "Os pagamentos ainda não são compatíveis com eventos recorrentes", Fus = "Eventos recorrentes ainda não são compatíveis com os pagamentos", Vus = "Insira a nova senha que você deseja utilizar.", Bus = "Redefinir senha", Uus = "Alterar sua senha", Wus = "Exibir senha", Gus = "Ocultar senha", Hus = "Tente novamente", Kus = "Este pedido expirou.", Yus = "Digite o endereço de e-mail associado à sua conta e um link para redefinir sua senha será enviado.", Zus = "Este pedido expirou. Volte atrás e digite o e-mail associado à sua conta para lhe enviarmos uma nova ligação para redefinir a sua senha.", Qus = "Ops", Jus = "Login", Xus = "Sucesso", e_s = "Falhou", t_s = "A sua senha foi redefinida. Agora pode fazer login com a sua senha recém-criada.", n_s = "Layout", o_s = "Visualização padrão", r_s = "Você pode selecionar várias opções, e os reservantes podem alternar entre as visualizações.", i_s = "Layout da reserva", a_s = "Você pode selecionar várias opções, e os reservantes podem alternar entre as visualizações. Pode ser sobrescrito a cada evento.", s_s = "Mês", c_s = "Semanalmente", l_s = "Coluna", d_s = "Pelo menos um layout precisa ser habilitado.", u_s = "O layout selecionado como visualização padrão não faz parte dos layouts habilitados.", __s = "O layout selecionado não é válido.", p_s = "Você pode gerenciar isso para todos os seus tipos de eventos em Configurações -> <0>Aparência</0> ou <1>Substituir</1> apenas para este evento.", m_s = "Ocorreu um erro inesperado. Tente novamente.", f_s = "Horário inválido no domingo", g_s = "Horário inválido na segunda-feira", h_s = "Horário inválido na terça-feira", v_s = "Horário inválido na quarta-feira", b_s = "Horário inválido na quinta-feira", y_s = "Horário inválido na sexta-feira", $_s = "Horário inválido no sábado", w_s = "O horário de término não pode ser anterior ao de início", k_s = "O horário de término não pode ser maior do que 24 horas", S_s = "Voltar às Reservas", x_s = "Sinta-se à vontade para escolher outro evento a qualquer hora.", E_s = "Cancelado", T_s = "Sem agendamento", A_s = "Aguardando anfitrião", C_s = "Cancelado com Sucesso", z_s = "Deseja realmente cancelar a sua reserva?", O_s = "Você não pode cancelar esta reserva", P_s = "Em vez disso, você também pode reagendar.", I_s = "Este evento já aconteceu", R_s = "O evento é uma instância de um evento recorrente.", N_s = "Estas são todas as instâncias restantes no evento recorrente.", D_s = "Ocorreu um erro com o status code {{status}}.", M_s = "Já existe um tipo de evento para este URL.", L_s = "Não é possível criar este evento", q_s = "Não é possível editar este evento", j_s = "Não é possível criar este fluxo de trabalho", F_s = "Não é possível criar esta agenda", V_s = "Esta agenda já foi cancelada", B_s = "Esta reserva já foi aceita ou recusada", U_s = "Voltar à Página Inicial", W_s = "Ou volte à página inicial", G_s = "Nenhuma reunião encontrada", H_s = "Esta reunião não existe. Contate o organizador da reunião para obter um link atualizado.", K_s = "Ainda não tem reservas {{status}}", Y_s = "Você não possui reservas {{status}}. {{description}}", Z_s = "{{eventName}} entre {{host}} e {{attendeeName}}", Q_s = "Reservas", J_s = "Reserva não encontrada", X_s = "Veja os eventos futuros e passados reservados através dos links de tipos de eventos.", eps = "Assim que alguém reservar uma hora, ela aparecerá aqui.", tps = "Assim que alguém reservar uma reunião recorrente com você, essa pessoa aparecerá aqui.", nps = "As suas reservas anteriores aparecerão aqui.", ops = "Suas reservas canceladas aparecerão aqui.", rps = "Suas reservas não confirmadas aparecerão aqui.", ips = "Reservas não confirmadas", aps = "em", sps = "e", cps = "O seu calendário mostra que você está ocupado entre", lps = "Solucionar problemas", dps = "Entenda por que há certos horários disponíveis e outros estão bloqueados.", ups = "Aqui está uma visão geral do seu dia em", _ps = "Dica: passe o mouse sobre os horários em negrito para um visão completa", pps = "Hora de início", mps = "Hora de término", fps = "Horário de intervalo", gps = "Antes do evento", hps = "Após o evento", vps = "Sem horário de intervalo", bps = "Intervalo", yps = "O seu dia começa às", $ps = "O seu dia termina às", wps = "Iniciar o solucionador de problemas", kps = "Utilize o solucionador de problemas para descobrir o porque os seus horários estão aparecendo desta forma.", Sps = "Alterar os horários disponíveis", xps = "Alterar os horários disponíveis", Eps = "Alterar as horas de início e término do seu dia", Tps = "Defina a hora de início e término do seu dia e um intervalo mínimo entre as suas reuniões.", Aps = "Atualmente, o seu dia está definido para começar as", Cps = "As horas de início e término do seu dia foram alteradas com sucesso.", zps = "e termina em", Ops = "Claro", Pps = "Escuro", Ips = "Ajustar tema automaticamente com base nas preferências do usuário", Rps = "Alguns usuários do grupo desativaram as reservas de grupos dinâmicas", Nps = 'Agrupe links de reserva que podem ser criados dinamicamente ao adicionar vários nomes de usuário com "+", por exemplo: "{{appName}}/bailey+peer"', Dps = "Permita que os participantes façam reservas com as reservas de grupo dinâmicas", Mps = "Links de grupo dinâmicos", Lps = "Permitir que mecanismos de busca acessem seu conteúdo público", qps = "Permitir indexação por motores de busca", jps = "Permitir notificações do navegador", Fps = "Você negou as notificações. Redefina a permissão nas configurações do navegador para ativar.", Vps = "Desativar notificações do navegador", Bps = "Notificações do navegador ativadas", Ups = "Notificações do navegador desativadas", Wps = "Notificações do navegador negadas", Gps = "Por favor, permita notificações no prompt", Hps = "Notificações push", Kps = "Receba notificações push quando o agendador fizer uma reserva instantânea de reunião.", Yps = "Seu navegador não suporta notificações push. Se você é usuário do Brave, ative a opção `Usar serviços do Google para mensagens push` em brave://settings/?search=push+messaging", Zps = "E-mail", Qps = "nome@exemplo.com", Jps = "Nome Completo", Xps = "Consulte a nossa documentação da API", ems = "Utilize nossa API para controle e personalização completa.", tms = "Criar Webhook", nms = "Reunião instantânea criada", oms = "Reserva cancelada", rms = "Reserva Reagendada", ims = "Link para download de gravação pronto", ams = "Transcrição Gerada", sms = "Reserva Criada", cms = "Reserva recusada", lms = "Reserva solicitada", dms = "Pagamento da reserva iniciado", ums = "Reunião encerrada", _ms = "Formulário enviado", pms = "Formulário enviado, nenhum evento agendado", mms = "Reserva paga", fms = "Fora do Escritório Criado", gms = "Não Comparecimento Atualizado", hms = "Gatilhos de eventos", vms = "URL do assinante", bms = "Criar um novo webhook", yms = "Webhooks", $ms = "Webhooks da equipe", wms = "Criar um webhook para sua conta", kms = "Novo Webhook", Sms = "Receba dados da reunião {{appName}} em uma, URL especificada, em tempo real, quando um evento for agendado ou cancelado.", xms = "Receba em tempo real dados da reunião do {{appName}} em um URL especificada quando este evento for agendado ou cancelado.", Ems = "Iframe responsivo de tela inteira", Tms = "Carregando...", Ams = "Excluindo...", Cms = "Iframe padrão", zms = "Desenvolvedor", Oms = "Gerencie suas configurações de desenvolvedor.", Pms = "Incorporar iframe", Ims = "A maneira mais fácil de incorporar o {{appName}} no seu site.", Rms = "Integre em seu site utilizando as nossas opções para embutir ou obtenha informações da reserva em tempo real utilizando webhooks personalizados.", Nms = "Agende uma Reunião", Dms = "Visualizar e gerenciar os seus detalhes de faturamento", Mms = "Ver e editar os seus dados de faturamento, bem como cancelar a sua assinatura.", Lms = "Ir para o portal de pagamento", qms = "Precisa de algo mais?", jms = "Se precisar de mais ajuda com o faturamento, o nosso time de suporte está aqui para ajudar.", Fms = "Contato", Vms = "a nossa equipe de suporte", Bms = "Fale com a nossa equipe de suporte", Ums = "Oh oh!", Wms = "Este usuário ainda não definiu nenhum tipo de evento.", Gms = "Editar logotipo", Hms = "Envie um logotipo", Kms = "Carregar logotipo", Yms = "Remover logotipo", Zms = "Ativado", Qms = "Código", Jms = "Código incorreto.", Xms = "Adicionar novo horário", efs = "Adicione uma camada extra de segurança à sua conta, caso sua senha seja comprometida.", tfs = "Ativar autenticação de dois fatores", nfs = "Desativar autenticação de dois fatores", ofs = "Se precisar desativar a autenticação de dois fatores, recomendamos reativá-la o mais rápido possível.", rfs = "Erro ao desativar autenticação de dois fatores", ifs = "Erro ao configurar autenticação de dois fatores", afs = "Segurança", sfs = "Gerenciar a segurança da sua conta.", cfs = "Senha", lfs = "Senha atualizada com sucesso", dfs = "Sua senha foi alterada com sucesso.", ufs = "Erro ao alterar senha", _fs = "Sua configuração da sessão foi atualizada com sucesso.", pfs = "Erro ao atualizar a configuração da sessão", mfs = "Ocorreu um erro.", ffs = "Algo parece errado?", gfs = "Por favor, tente novamente.", hfs = "Sua nova senha super segura", vfs = "Nova Senha", bfs = "Sua senha antiga", yfs = "Senha Atual", $fs = "Alterar Senha", wfs = "Alterar segredo", kfs = "Nova senha é idêntica à sua senha antiga. Por favor, escolha uma senha diferente.", Sfs = "Caso tenha perdido ou esquecido o segredo, você poderá alterá-lo. Mas fique ciente de que todas as integrações com esse segredo precisarão ser atualizadas", xfs = "Senha atual está incorreta", Efs = "Mistura de letras maiúsculas e minúsculas", Tfs = "Mínimo de sete caracteres", Afs = "No mínimo 15 caracteres", Cfs = "Contém pelo menos um número", zfs = "O tamanho deve ser de {{limit}} ou menos caracteres", Ofs = "A senha precisa ter pelo menos sete caracteres com pelo menos um número e ser uma combinação de letras maiúsculas e minúsculas", Pfs = "Senha incorreta.", Ifs = "A senha ou o nome de usuário está incorreto.", Rfs = "Usar configurações", Nfs = "manhã/tarde", Dfs = "Opções de horário", Mfs = "Janeiro", Lfs = "Fevereiro", qfs = "Março", jfs = "Abril", Ffs = "Maio", Vfs = "Junho", Bfs = "Julho", Ufs = "Agosto", Wfs = "Setembro", Gfs = "Outubro", Hfs = "Novembro", Kfs = "Dezembro", Yfs = "Segunda-feira", Zfs = "Terça-feira", Qfs = "Quarta-feira", Jfs = "Quinta-feira", Xfs = "Sexta-feira", egs = "Sábado", tgs = "Domingo", ngs = "Tudo reservado.", ogs = "Não foi possível carregar os horários disponíveis.", rgs = "+ Participantes Adicionais", igs = "Seu nome", ags = "Seu nome completo", sgs = "Sem nome", cgs = "Por favor, insira um número entre 1 e {{maxOccurences}}", lgs = "Rápido e fácil - sem necessidade de conta. Perfeito para reuniões únicas.", dgs = "Endereço de e-mail", ugs = "Insira um e-mail válido", _gs = " Por favor, agende uma chamada futura se não estivermos disponíveis em {{seconds}} segundos", pgs = "Local", mgs = "Local", fgs = "Insira o endereço", ggs = "Pessoalmente (endereço do participante)", hgs = "Outro Lugar", vgs = "Localização personalizada do participante", bgs = "Continuar como convidado", ygs = "Entrar como convidado", $gs = "Ideal para chamadas únicas", wgs = "Qualquer localização", kgs = "Sim", Sgs = "Não", xgs = "Observações adicionais", Egs = "Não foi possível agendar a reunião.", Tgs = "Não foi possível reagendar a reunião.", Ags = "Por favor, compartilhe qualquer coisa que nos ajude a nos preparar para nossa reunião.", Cgs = "Confirme seu {{eventTypeTitle}} com {{profileName}}", zgs = "Reagende seu {{eventTypeTitle}} com {{profileName}}", Ogs = "Reunião presencial", Pgs = "Pessoalmente (endereço do organizador)", Igs = "Vincular reunião", Rgs = "Número de Telefone", Ngs = "Número de telefone do participante", Dgs = "Número de telefone do organizador", Mgs = "Digite o número de telefone", Lgs = "Reagendar", qgs = "Ou reagendar", jgs = "Agende um membro da equipe no lugar", Fgs = "OU", Vgs = "Retornar", Bgs = "E-mail ou Nome de Usuário", Ugs = "Enviar um convite por e-mail", Wgs = "Função", Ggs = "Editar função", Hgs = "Ver função", Kgs = "Editar time", Ygs = "Editando usuário", Zgs = "Editando organização", Qgs = "Se você deseja editar ou gerenciar seus webhooks, acesse as <0>configurações de webhooks</0>", Jgs = "Recusar", Xgs = "Recusar tudo", ehs = "Aceitar", ths = "Sair", nhs = "Perfil", ohs = "URL do meu time", rhs = "Meus times", ihs = "Nome do time", ahs = "Nome do seu time", shs = "Time atualizado com sucesso", chs = "Seu time foi atualizado com sucesso.", lhs = "Sua organização foi atualizada com sucesso.", dhs = "Erro ao copiar para a área de transferência", uhs = "Sobre", _hs = "Fale um pouco sobre seu time. Isso aparecerá na página pública do seu time.", phs = "ID da organização", mhs = "ID da organização copiado.", fhs = "Uma breve descrição sobre sua organização. Isso aparecerá na página principal da sua organização.", ghs = "ID da equipe", hhs = "ID da equipe copiado.", vhs = "Membros", bhs = "Membros da organização", yhs = "Membro", $hs = "{{count}} membro", whs = "{{count}} membros", khs = "{{count}} selecionados", Shs = "Proprietário", xhs = "Admin", Ehs = "API de Admin", Ths = "Usuário administrador", Ahs = "Vamos criar o primeiro usuário administrador.", Chs = "Configuração de usuário administrador", zhs = "Você já criou um usuário administrador. Já é possível fazer login na sua conta.", Ohs = "Novo Membro", Phs = "Convidar", Ihs = "Adicionar membros da equipe", Rhs = "Adicionar membros", Nhs = "Convidar outros para se juntar à sua equipe", Dhs = "Adicionar membro da equipe", Mhs = "Convidar um novo membro", Lhs = "Nota: Isso <0>custará um assento adicional (R$15/mês)</0> em sua assinatura.", qhs = "Convidar alguém para seu time.", jhs = "Carregar arquivo .csv", Fhs = "Convidar via e-mail", Vhs = "Alterar função de membro da equipe", Bhs = "Remover a marca {{appName}}", Uhs = "Ocultar todas as marcas de {{appName}} de suas páginas públicas.", Whs = "Ocultar botão de agendar um membro da equipe", Ghs = "Oculte o botão de agendar um membro da equipe em suas páginas públicas.", Hhs = "Zona de perigo", Khs = "Cuidado. A exclusão da conta não pode ser desfeita.", Yhs = "Cuidado. A exclusão da equipe não pode ser desfeita.", Zhs = "Voltar", Qhs = "Cancelar", Jhs = "Cancelar todos os restantes", Xhs = "Aplicar", evs = "Cancelar este evento", tvs = "Confirmar", nvs = "Confirmar tudo", ovs = "Desfazer Time", rvs = "Tem certeza de que deseja desfazer esta equipe? Qualquer pessoa com quem você compartilhou este link da equipe não será mais capaz de fazer novos agendamentos.", ivs = "Desfazer organização", avs = "Tem certeza de que deseja desfazer esta Org? Todos os membros e equipes serão excluídos.", svs = "Tem certeza de que deseja remover este membro do time?", cvs = "Sim, disfazer time", lvs = "Sim, remover membro", dvs = "Sim, cancelar assinatura", uvs = "Cancelar assinatura", _vs = "Cancelar sua assinatura desativará permanentemente seu plano atual. Esta ação não pode ser desfeita.", pvs = "Remover membro", mvs = "Gerenciar sua equipe", fvs = "Você ainda não tem nenhuma equipe.", gvs = "Equipes permitem que outras pessoas reservem eventos compartilhados entre seus colegas de trabalho.", hvs = "Enviar", vvs = "Sim, remover atributo", bvs = "Remover atributo", yvs = "Você tem certeza de que deseja remover o atributo '{{name}}'? Todos os usuários atualmente atribuídos a ele serão desassociados.", $vs = "Atualizar", wvs = "Salvar", kvs = "Pendente", Svs = "Abrir opções", xvs = "Copiar link do evento", Evs = "Compartilhar", Tvs = "Você se importa de fazer uma reserva para mim no Cal ou enviar seu link?", Avs = "Copiar link do time", Cvs = "Sair do time", zvs = "Sim, sair do time", Ovs = "Você tem certeza de que deseja sair deste time? Você não conseguirá reservar mais utilizando esse time.", Pvs = "{{user}} do {{team}}", Ivs = "Pré-visualizar", Rvs = "Link copiado!", Nvs = "Copiado!", Dvs = "Link privado copiado!", Mvs = "Link compartilhado!", Lvs = "Título", qvs = "Descrição", jvs = "Status de apps", Fvs = "Uma chamada rápida de video.", Vvs = "Tipo de Agendamento", Bvs = "Pré-visualizar time", Uvs = "Coletivo", Wvs = "Agende reuniões quando todos os membros selecionados do time estiverem disponíveis.", Gvs = "Duração", Hvs = "Durações disponíveis", Kvs = "Duração padrão", Yvs = "Escolha as durações disponíveis primeiro", Zvs = "{{count}} $t(minute_timeUnit)", Qvs = "{{count}} $t({{unit}}_timeUnit)", Jvs = "{{count}}$t({{unit}}_short)", Xvs = "Minutos", ebs = "Use Cal.ai para adquirir um número de telefone com IA ou faça ligações para convidados.", tbs = "URI de terminação", nbs = "Nome de usuário do tronco SIP", obs = "Senha do tronco SIP", rbs = "Apelido", ibs = "Excluir número de telefone", abs = "Falha na validação do fluxo de trabalho", sbs = "Uma ou mais etapas do fluxo de trabalho têm conteúdo de mensagem vazio", cbs = "Um ou mais números de telefone ou endereços de e-mail não estão verificados", lbs = "Potencialize seus fluxos de trabalho com Cal.ai", dbs = "Agentes de IA realistas que marcam reuniões, enviam lembretes e fazem acompanhamento com seus clientes.", ubs = "Número de telefone importado e vinculado ao agente com sucesso", _bs = "Número de telefone excluído com sucesso", pbs = "Tem certeza de que deseja excluir este número de telefone? Esta ação não pode ser desfeita.", mbs = "Sim, excluir número de telefone", fbs = "O número que você está tentando importar deve estar no formato E.164 (+código do país seguido pelo número, sem espaços ou caracteres especiais), por exemplo, +1234567890", gbs = "O URI de terminação para identificar exclusivamente seu tronco SIP elástico. Isso é usado para chamadas de saída. Para troncos SIP elásticos da Twilio, sempre termina com .pstn.twilio.com.", hbs = "O nome de usuário usado para autenticar o tronco SIP.", vbs = "A senha usada para autenticar o tronco SIP.", bbs = "Apelido do número. Isso é apenas para sua referência.", ybs = "Salvar e testar chamada", $bs = "Chamada iniciada com sucesso", wbs = "Por favor, insira um número de telefone", kbs = "Agente atualizado com sucesso", Sbs = "Agente criado com sucesso", xbs = "Tipo de evento adicionado com sucesso", Ebs = "Número de telefone cancelado com sucesso", Tbs = "Este prompt define o papel e os objetivos principais do agente", Abs = "Prompt", Cbs = "Ligar para", zbs = "Fazer ligação de teste para verificar a configuração", Obs = "Mensagem inicial", Pbs = "A primeira mensagem que o agente dirá ao iniciar uma chamada", Ibs = "Está tendo problemas para importar?", Rbs = "Aprender", Nbs = "Aprenda como obter seu URI de terminação e credenciais de tronco SIP", Dbs = "Assinatura do número de telefone cancelada com sucesso", Mbs = "Atualizando", Lbs = "Round Robin", qbs = "Olá, como você está?", jbs = "Reuniões recorrentes entre vários membros da equipe.", Fbs = "Evento gerenciado", Vbs = "nome de usuário", Bbs = "Crie e distribua tipos de eventos em massa para os membros da equipe", Ubs = "Gerenciado", Wbs = 'o "nome de usuário" será preenchido com o nome de usuário dos membros atribuídos', Gbs = "Atribuir a", Hbs = "Digite o número de telefone para teste de chamada", Kbs = "Fazer ligação de teste", Ybs = "Criar novo agente de voz cal.ai para fluxo de trabalho", Zbs = "Crie um novo agente de voz cal.ai para fluxo de trabalho para automatizar seus processos", Qbs = "Número de telefone (para nosso agente ligar)", Jbs = "Compre um número de telefone ou importe um que você já tenha na Twilio", Xbs = "Testar agente", eys = "Testar chamada web", tys = "Números de telefone", nys = "Cancelar inscrição", oys = "Excluir etapa do fluxo de trabalho", rys = "Cancelar inscrição do número de telefone", iys = "Comprar um novo número", ays = "Você só pode comprar números de telefone dos EUA. Para outros países, você pode importar seu próprio número de telefone da Twilio.", sys = "Compre um número dos EUA por ${{priceInDollars}} por mês", cys = "Destinos de chamada compatíveis", lys = "Nenhum número de telefone conectado", dys = "Falha ao obter o ID da etapa do fluxo de trabalho", uys = "Agente Cal.ai", _ys = "Testar agente Cal.ai", pys = "Tem certeza que deseja excluir esta etapa do fluxo de trabalho?", mys = "Você ainda deseja cancelar a assinatura do número de telefone deste agente?", fys = "Esta ação desconectará o número de telefone do agente. O agente não poderá fazer chamadas até que um novo número de telefone seja conectado.", gys = "Números de telefone", hys = "Conectar número de telefone", vys = "Gerencie seus números de telefone", bys = "Importar número", yys = "Esta ação também irá:", $ys = "Importar número de telefone", wys = "Assinatura ativa", kys = "Cancelar sua assinatura de número de telefone", Sys = "Excluir o número de telefone associado", xys = "Você não está autorizado a criar este fluxo de trabalho", Eys = "Importe seu número de telefone Twilio para usar com o Phone", Tys = "${{price}}/mês", Ays = "Comprar novo número", Cys = "Comprar um número de telefone custa ${{priceInDollars}} por mês. Você será cobrado mensalmente por cada número de telefone ativo.", zys = "Código de área (opcional)", Oys = "Nenhum número de telefone", Pys = "Número de telefone comprado com sucesso", Iys = "Cancelar assinatura do número de telefone", Rys = "Sim, cancelar assinatura", Nys = "Tem certeza que deseja cancelar esta assinatura de número de telefone? Esta ação não pode ser desfeita e você perderá o acesso a este número de telefone.", Dys = "Adicionar membros...", Mys = "Adicionar membros", Lys = "Nenhum membro atribuído", qys = "Atribuído a", jys = "Você deve estar logado em {{url}}", Fys = "Começar a atribuir os membros acima", Vys = "Os membros não poderão editar isto", Bys = "Membros podem editar", Uys = "Esta opção foi bloqueada pelo administrador da equipe", Wys = "Desbloqueado pelo administrador da equipe", Gys = "URL", Hys = "Esconder", Kys = "Somente leitura", Yys = "Link único", Zys = "Atualmente você está no plano {{plan}}.", Qys = "Atualize a sua conta para o plano Pro e desbloqueie todos os recursos que temos para oferecer.", Jys = "Você precisa fazer um upgrade do seu plano para ter mais de um tipo de evento ativo.", Xys = "Você precisa fazer upgrade do seu plano para criar um time.", e$s = "Você pode <1>atualizar aqui</1>.", t$s = "Tipos de Eventos", n$s = "Crie eventos para que as pessoas possam fazer agendamentos em seu calendário.", o$s = "Novo tipo de evento", r$s = "Crie seu primeiro evento", i$s = "Os eventos permitem que você compartilhe links que mostram os horários disponíveis no seu calendário para que os usuários façam agendamentos com você.", a$s = "{{eventTypeTitle}} evento criado com sucesso", s$s = "{{eventTypeTitle}} tipo de evento atualizado com sucesso", c$s = "Tipo de evento removido com sucesso", l$s = "Horas", d$s = "Pessoas", u$s = "Seu E-mail", _$s = "Alterar Avatar", p$s = "Enviar avatar", m$s = "Idioma", f$s = "Fuso Horário", g$s = "Primeiro Dia da Semana", h$s = "Repete-se até {{count}} vez", v$s = "Repete-se até {{count}} vezes", b$s = "A cada {{freq}} durante", y$s = "{{count}} evento restante", $$s = "{{count}} eventos restantes", w$s = "Repete-se a cada", k$s = "ocorrência", S$s = "ocorrências", x$s = "semana", E$s = "semanas", T$s = "mês", A$s = "meses", C$s = "ano", z$s = "anos", O$s = "Mais {{count}}", P$s = "Máx", I$s = "Tema", R$s = "Cor da Marca", N$s = "Cor da marca (tema claro)", D$s = "Cor da marca (tema escuro)", M$s = "Cor do Tipo de Evento (Tema Claro)", L$s = "Cor do Tipo de Evento (Tema Escuro)", q$s = "Arquivo não é [idOrSlug]/[user]", j$s = "Criar equipe", F$s = "Nome", V$s = "Equipe sem nome", B$s = "Clientes OAuth", U$s = "Gerencie clientes OAuth para sua organização", W$s = "Criar cliente OAuth", G$s = "Crie um novo cliente OAuth para integrações de terceiros", H$s = "Cliente OAuth excluído com sucesso", K$s = "Crie um time para colaborar com os usuários.", Y$s = "Criar um novo time", Z$s = "URL da sua página de agendamento", Q$s = "URL da página onde seus usuários podem cancelar o agendamento", J$s = "URL da página onde seus usuários podem reagendar", X$s = "Este horário não está mais disponível. Por favor, volte à página anterior e selecione outro horário.", ews = "Convites enviados", tws = "Novo time", nws = "Crie seu primeiro time e convide outros usuários para trabalharem com você.", ows = "Criar um time para começar", rws = "Times", iws = "Equipe", aws = "Organização", sws = "Cobrança da equipe", cws = "Gerenciar cobrança para sua equipe", lws = "Alteramos a cobrança para equipes", dws = "Há membros da sua equipe que não têm assento. Atualize para o plano Pro para incluir os assentos faltando.", uws = "A partir de janeiro de 2022, a cobrança dos membros de equipe será realizada por assento. Os membros da sua equipe que tinham o plano PRO gratuito receberam um teste de 14 dias. Ao fim do teste, eles serão ocultos da sua equipe, a não ser que você atualize agora.", _ws = "Criar e gerenciar times para usar recursos de colaboração.", pws = "Este recurso só está disponível no plano Pro", mws = "Para remover a marca {{appName}} das suas páginas de reservas, você precisar fazer o upgrade para uma conta Pro.", fws = "Edite as informações do seu perfil, que aparecem na sua página de reservas.", gws = "Você precisa sair e entrar novamente para as alterações surtirem efeito.", hws = "Fale um pouco mais sobre você.", vws = "Perfil atualizado com sucesso", bws = "O seu perfil foi atualizado com sucesso.", yws = "Sua atualização chegou", $ws = "Melhore sua experiência de agendamento atualizando para o novo plano e aproveite os novos recursos.", wws = "Está tudo pronto", kws = "Você já está no plano mais recente. Não há nada para atualizar. Aproveite os novos recursos e entre em contato conosco se tiver alguma dúvida!", Sws = "O usuário parece estar logado, mas não foi encontrado no banco de dados", xws = "Incorporar & Webhooks", Ews = "Ativado", Tws = "Desativado", Aws = "Desativar", Cws = "Faturamento", zws = "aqui", Ows = "Gerenciar as suas informações de faturamento e cancelar a sua assinatura.", Pws = "Disponibilidade", Iws = "Editar disponibilidade", Rws = "Configure os horários em que estiver disponível para reservas.", Nws = "Copiar tipos para", Dws = "Copiar horários para…", Mws = "Altere a sua agenda semanal", Lws = "Logotipo", qws = "Erro", jws = "Insira pelo menos um caractere", Fws = "Insira pelo menos {{count}} caracteres", Vws = "Logotipo do time", Bws = "Adicionar uma localização", Uws = "Participantes", Wws = "Adicionar Participantes", Gws = "Mostrar Configurações Avançadas", Hws = "Ocultar configurações avançadas", Kws = "Nome do Evento", Yws = "Nome do evento no calendário", Zws = "O nome que aparecerá nos calendários", Qws = "Reunião com {{attendeeName}}", Jws = "Campos adicionais", Xws = "Solicitar que o agendador insira entradas adicionais antes que o pedido seja confirmado", e0s = "Etiqueta", t0s = "Preenchimento", n0s = "Exibir o e-mail 'Adicionar ao calendário' como organizador", o0s = "Iremos exibir este endereço de e-mail como o organizador, e enviaremos e-mails de confirmação aqui.", r0s = 'Se habilitado, iremos exibir o endereço de e-mail do seu "Adicionar ao calendário" como organizador e enviaremos e-mails de confirmação lá', i0s = "Observe que pode ser necessário desconectar e reconectar sua conta 'Adicionar ao calendário' para usar esse recurso.", a0s = "Tipo", s0s = "Editar", c0s = "Adicionar um campo", l0s = "Ocultar notas no calendário", d0s = "Por motivo de privacidade, notas e dados adicionais serão ocultos na entrada do calendário. Serão enviadas por e-mail.", u0s = "A reserva precisa ser confirmada manualmente antes de ser enviada para as integrações e ser enviado um e-mail de confirmação.", _0s = "Reservas não confirmadas ainda bloqueiam os horários no calendário.", p0s = "Evento recorrente", m0s = "As pessoas podem se inscrever em eventos recorrentes", f0s = "Conecte-se e participe", g0s = "Não pode ser usado com eventos pagos", h0s = "Reuniões instantâneas ainda não são compatíveis com eventos recorrentes e aplicativos de pagamento", v0s = "Experimental: reunião instantânea são atualmente experimentais.", b0s = "Iniciando", y0s = "Desativar participantes", $0s = "Desativar a adição de participantes adicionais durante a reserva.", w0s = "Gerar link privado", k0s = "Ativar URL privada", S0s = "Link privado", x0s = "Seu link privado será reaproveitado após cada uso", E0s = "Copiar link privado", T0s = "Copiar link privado para evento", A0s = "Gere um URL privado para compartilhar sem expor seu nome de usuário do {{appName}}", C0s = "Links Privados", z0s = "Gere URLs privados sem expor o nome de usuário, com limites configuráveis de expiração e uso", O0s = "Adicionar novo link", P0s = "Link privado copiado", I0s = "Os convidados podem agendar", R0s = "Intervalo de Datas", N0s = "dias da agenda", D0s = "dias úteis", M0s = "Defina um endereço ou local", L0s = "Defina um link para a reunião", q0s = "Não pode ser alternado. Só pode ser desbloqueado para tipos de eventos filhos", j0s = "{{appName}} solicitará ao seu convidado que insira um número de telefone antes de agendar.", F0s = "{{appName}} fornecerá um link para o Google Meet.", V0s = "{{appName}} fornecerá uma URL de reunião do Zoom.", B0s = "{{appName}} fornecerá um URL de reunião do Tandem.", U0s = "O {{appName}} irá fornecer um URL de reunião do Daily video.", W0s = "O Cal fornecerá um URL de reunião do Jitsi Meet.", G0s = "O {{appName}} fornecerá um URL de reunião do Huddle01 Web3 video.", H0s = "O {{appName}} enviará um URL da reunião para o MS Teams. OBSERVAÇÃO: É PRECISO TER UMA CONTA ESCOLAR OU CORPORATIVA", K0s = "Requerer Pagamento", Y0s = "Você precisa adicionar um nome", Z0s = "comissão por transação", Q0s = "O seu tipo de evento foi atualizado com sucesso.", J0s = "Ocultar Tipo de Evento", X0s = "Editar Localização", eks = "no futuro", tks = "Quando agendado com menos de <0></0> de antecedência", nks = "Dentro de um período", oks = "Indefinidamente no futuro", rks = "Adicionar novo campo personalizado", iks = "Bate papo rápido", aks = "Adicionar um novo tipo de evento de equipe", sks = "Adicionar um novo tipo de evento", cks = "Crie um novo tipo de evento para as pessoas agendarem horários.", lks = "Comprimento", dks = "Aviso mínimo", uks = "Deslocar horários de início", _ks = "Deslocar em uma quantidade específica de minutos as alocações de horário mostradas aos reservantes", pks = "Deslocar em", mks = "ex.: serão mostradas aos seus reservantes alocações de horário à(s) {{ adjustedTime }} em vez de {{ originalTime }}", fks = "Intervalos de tempo", gks = "Usar a duração do evento (padrão)", hks = "Excluir tipo de evento?", vks = "Excluir tipo de evento gerenciado?", bks = "Este link não poderá mais ser usado para fazer reserva por qualquer pessoa com quem tenha sido compartilhado.", yks = "Os membros atribuídos a este tipo de evento também terão seus tipos de eventos excluídos.", $ks = "Qualquer pessoa com quem eles compartilharam seu link não poderá mais agendar usando-o.", wks = "Sim, excluir", kks = "Apagar conta", Sks = "Sim, apagar conta", xks = "Qualquer pessoa que você compartilhou seu link de reservas não poderá mais utilizá-lo para agendar novos eventos e todas as suas preferências serão perdidas.", Eks = "Integrações", Tks = "Apps", Aks = "Aqui você poderá encontrar uma lista de todos os seus aplicativos", Cks = "Listagem de aplicativos", zks = "Aplicativos de {{category}}", Oks = "App Store", Pks = "Conectando pessoas, tecnologia e o ambiente de trabalho.", Iks = "Conecte seu aplicativo de videoconferência", Rks = "Configurações", Nks = "Tipo de evento atualizado com sucesso", Dks = "Próximo Passo", Mks = "Ignorar passo", Lks = "Passo anterior", qks = "Instalar", jks = "Comece o teste gratuito", Fks = "Instalado", Vks = "{{count}} instalação ativa", Bks = "{{count}} instalações ativas", Uks = "Instalado globalmente", Wks = "Aplicativo instalado com sucesso", Gks = "Não foi possível instalar o aplicativo", Hks = "Desconectar", Kks = "Incorpore o seu calendário no seu site", Yks = "Conecte as suas aplicações favoritas.", Zks = "Automatização", Qks = "Configure como os seus tipos de evento deverão interagir com os seus calendários.", Jks = "Ative/desative os calendários que você quiser para verificar conflitos e evitar reservas repetidas.", Xks = "Conectar calendário adicional", e1s = "Calendário atualizado com êxito", t1s = "Verifique aqui", n1s = "Conferência", o1s = "Calendário", r1s = "Pagamentos", i1s = "Não instalado", a1s = "As senhas inseridas são difererentes.", s1s = "Este campo é obrigatório.", c1s = "Status", l1s = "Ver disponibilidade do usuário", d1s = "O usuário precisa aceitar o convite para ver a disponibilidade", u1s = "Definir-se como indisponível", _1s = "Desativar status indisponível", p1s = "Erro ao atualizar status de ausência", m1s = "Este usuário está indisponível no momento.", f1s = "A pessoa que você está tentando realizar uma reserva está indisponível no momento e, portanto, não está aceitando novas reservas.", g1s = "Conheça pessoas com os mesmos tokens", h1s = "Faça ou permita reservas apenas de pessoas que compartilham os mesmos tokens, DAOs ou NFTs.", v1s = "Sua conta foi criada através de um provedor de identidade.", b1s = "Sua conta é gerenciada por {{provider}}", y1s = "Para alterar o seu endereço de e-mail, senha, ativar a autenticação de dois fatores e outras alterações, por favor utilize as configurações de seu provedor de identidade {{provider}}.", $1s = "Sua conta é gerenciada por um provedor de identidade diferente. Tente fazer login com {{provider}}.", w1s = "Erro ao criar um novo usuário. Por favor, tente novamente.", k1s = "Entrar com Google", S1s = "Entrar com SAML", x1s = "Entrar com SAML/OIDC", E1s = "Continuar com e-mail", T1s = "Continuar com o Google", A1s = "Último uso", C1s = "Você precisa gerar um token de acesso na ferramenta de agendamento antiga.", z1s = "Importar de", O1s = "Token de acesso", P1s = "Roadmap", I1s = "Categorias em destaque", R1s = "Flags de recursos", N1s = "Aqui você pode ativar ou desativar os recursos da sua instância do Cal.com.", D1s = "Categorias populares", M1s = "{{count}} Aplicativo", L1s = "{{count}} aplicativos", q1s = "Apps em alta", j1s = "Mais popular", F1s = "Apps instalados", V1s = "Grátis", B1s = "Sem aplicativos de {{category}}", U1s = "Todos os aplicativos", W1s = "Adicione um aplicativo de calendário para verificar se há conflitos para evitar agendamentos duplos", G1s = "Tente adicionar um aplicativo para chamadas de vídeo com seus clientes", H1s = "Adicione um aplicativo de pagamento para facilitar a transação entre você e seus clientes", K1s = "Adicione um aplicativo de análise às suas páginas de reservas", Y1s = "Adicione um aplicativo de automação para usar", Z1s = "Adicione qualquer outro tipo de aplicativo para fazer todos os tipos de coisas", Q1s = "Adicione um aplicativo de mensagem para definir lembretes e notificações personalizados", J1s = "Adicione um aplicativo CRM para acompanhar todos os integrantes das suas reuniões", X1s = "Defina o(s) calendário(s) para verificar se há conflitos e evitar reservas duplas.", e2s = "Configure quais serviços de processamento de pagamento serão usados no carregamento de seus clientes.", t2s = "Configure quais aplicativos de análise serão usados nas suas páginas de reservas", n2s = "Todos os seus aplicativos instalados de outras categorias.", o2s = "Configure quais aplicativos de conferência serão usados", r2s = "Configure quais aplicativos de automação serão usados", i2s = "Configure quais aplicativos de mensagem usar para definir lembretes e notificações", a2s = "Configure quais aplicativos CRM usar para acompanhar os integrantes das suas reuniões", s2s = "Análise", c2s = "Nenhum app instalado", l2s = "Os aplicativos permitem que você melhore o fluxo de trabalho e melhore significativamente sua vida de agendamento.", d2s = "Navegue na App Store", u2s = "Gerencie os apps instalados ou altere as configurações", _2s = "Procurar apps", p2s = "Recursos", m2s = "Permissões", f2s = "Termos e privacidade", g2s = "Publicado por {{author}}", h2s = "Assinar", v2s = "Comprar", b2s = "Instalar app", y2s = "Categorias", $2s = "Preço", w2s = "Saiba mais", k2s = "Experimente agora", S2s = "Política de privacidade", x2s = "Termos de serviço", E2s = "Remover", T2s = "Adicionar", A2s = "{{count}} instalado(s)", C2s = "Verificar carteira", z2s = "Criar eventos em", O2s = "Este é um recurso comercial", P2s = "Você pode testar este recurso localmente mas não em produção.", I2s = "Para adquirir uma licença comercial, entre em contato com nossa equipe de vendas. Se você já possui uma chave de licença, por favor, entre em contato com support@cal.com para obter ajuda.", R2s = "Falta a licença", N2s = "Próximos passos", D2s = "Adquira uma licença comercial", M2s = "O plano de infraestrutura é baseado no uso e tem descontos acessíveis para novos usuários.", L2s = "Crie uma conta com o Prisma Studio", q2s = "Aprenda a configurar seu primeiro usuário", j2s = "Fale com a equipe de vendas", F2s = "Erro 404", V2s = "Definir como padrão", B2s = "Nova agenda", U2s = "Adicionar nova agenda", W2s = "Adicionar um novo calendário", G2s = "Definir onde adicionar novos eventos quando você estiver com a reserva feita.", H2s = "Excluir agenda", K2s = "A exclusão da agenda vai removê-la de todos os tipos de evento. Essa ação não pode ser desfeita.", Y2s = "Agenda {{scheduleName}} criada com êxito", Z2s = "Agenda {{scheduleName}} criada com êxito", Q2s = "Agenda removida com êxito", J2s = "Horas de trabalho", X2s = "Criar agenda de disponibilidade", eSs = "A criação de agendas de disponibilidade permite gerenciar a disponibilidade em tipos de evento. Podem ser aplicadas a um ou mais tipos de evento.", tSs = "Requer que o usuário que agendar tenha um token que pertence ao endereço a seguir:", nSs = "João da Silva", oSs = "Formato de hora", rSs = "Redirecionar após a reserva ", iSs = 'Você está sendo redirecionado para {{ url }} em $t(second, {"count": {{seconds}} }).', aSs = "https://example.com/redirect-to-my-success-page", sSs = "Redirecione para um URL personalizado após realizar uma reserva", cSs = "Duplicar", lSs = "Oferecer assentos", dSs = "Oferecer assentos para reserva. Isto desativa automaticamente reservas de convidados e confirmações.", uSs = "Assento disponível", _Ss = "Assentos disponíveis", pSs = "Assentos quase preenchidos", mSs = "Assentos sendo preenchidos rapidamente", fSs = "Número de assentos por reserva", gSs = "Defina a janela de entrada da reunião (segundos): O período de tempo em segundos dentro do qual o anfitrião pode entrar e iniciar a reunião. Após esse período, a URL de entrada da reunião expirará.", hSs = "Insira a quantidade de assentos", vSs = "Você pode gerenciar suas agendas na página de Disponibilidade.", bSs = "Não há mais assentos disponíveis", ySs = "Chaves de API", $Ss = "Chave de API", wSs = "Testar chave de API", kSs = "Teste aprovado!", SSs = "Teste com falha", xSs = "Informe a chave de API", ESs = "Chaves de API permitem criar chamadas de API para a sua própria conta.", TSs = "Crie um marketplace ou plataforma em vez disso.", ASs = "Gere chaves de API e use-as para acessar a sua própria conta.", CSs = "Criar uma chave de API", zSs = "Nomear essa chave", OSs = "Exemplo: Desenvolvimento", PSs = "Chave de API sem nome", ISs = "Esta chave de API não data de vencimento", RSs = "Editar chave de API", NSs = "Chave de API criada com êxito", DSs = "Chave de API atualizada com êxito", MSs = "Criar", LSs = "Salve esta chave de API em um local seguro.", qSs = "Não será possível visualizá-la novamente ao fechar esta janela.", jSs = "Copiar para a área de transferência", FSs = "Ativado após a atualização", VSs = "O link privado funcionará após salvar", BSs = "Revogar esta chave de API", USs = "Desativar reagendamento", WSs = "Os convidados não podem mais reagendar o evento pelo convite do calendário ou e-mail", GSs = "Permitir agendamento através do link de reagendamento", HSs = "Quando ativado, os usuários poderão criar uma nova reserva ao tentar reagendar uma reserva cancelada", KSs = "Desativar cancelamento", YSs = "Os convidados não podem mais cancelar o evento pelo convite do calendário ou e-mail", ZSs = "Revogar chave de API", QSs = "Chave de API copiada!", JSs = "A chave de API expira em", XSs = "Remover permanentemente esta chave de API da sua conta?", exs = "Copiar", txs = "Data de vencimento", nxs = "Expirada", oxs = "Nunca expira", rxs = "Expira", ixs = "Solicitar o reagendamento da sua reserva", axs = "Motivo do reagendamento", sxs = "Agendar um novo horário", cxs = "Solicitação de reagendamento enviada", lxs = "Isso cancelará a reunião agendada, notifique quem agendou e peça que escolha outro horário.", dxs = "Motivo da solicitação de reagendamento", uxs = "Solicitar reagendamento ", _xs = "Editar reserva", pxs = "Reagendar reserva", mxs = "Horário anterior", fxs = "Adicionar um GIF à sua página de confirmação", gxs = "Procurar", hxs = "Representar", vxs = "Representação do usuário", bxs = "Permite que a nossa equipe de suporte entre temporariamente como você para ajudar a resolver rapidamente os problemas relatados.", yxs = "Permite que os administradores da sua equipe façam login como você.", $xs = "Gratuito para pessoas. Planos de equipe para recursos colaborativos.", wxs = "Tornar a organização privada", kxs = "Os membros da sua organização não poderão ver outros membros da organização quando esta opção estiver ativada.", Sxs = "Tornar equipe privada", xxs = "Os membros da sua equipe não poderão ver outros membros da equipe após habilitar isso.", Exs = "Você não pode ver todos os membros da equipe de uma equipe privada.", Txs = "Você não pode equipes de uma organização privada.", Axs = "Permitir múltiplas durações", Cxs = "Todos os usos desse recurso são auditados.", zxs = 'Representando o nome de usuário "{{user}}".', Oxs = "Clique aqui para parar", Pxs = "Atualização: o local do seu evento foi alterado", Ixs = "Adicionado - Novos convidados adicionados ao seu evento", Rxs = "Local alterado: {{eventType}} com {{name}} em {{date}}", Nxs = "Convidados Adicionados: {{eventType}} com {{name}} em {{date}}", Dxs = "Local atual", Mxs = "Novo local", Lxs = "Sessão", qxs = "Controle sua sessão da conta", jxs = "Tempo esgotado de sessão após", Fxs = "Tempo de sessão esgotado", Vxs = "Invalide sua sessão após um certo tempo.", Bxs = "Nenhum local definido", Uxs = "Definir local", Wxs = "Atualizar local", Gxs = "Local atualizado", Hxs = "Falha na atualização da localização", Kxs = "Convidados adicionados", Yxs = "Não foi possível adicionar convidados", Zxs = "Isso não parece um endereço de e-mail", Qxs = "Os e-mails devem ser únicos e válidos", Jxs = "Isso não parece ser uma URL", Xxs = "Coloque este código no seu HTML onde você quiser que o seu widget do {{appName}} apareça.", eEs = "Crie ou atualize um componente existente do React como demonstrado abaixo.", tEs = "Copiar código", nEs = "Código copiado!", oEs = "Como deseja adicionar o {{appName}} ao seu site?", rEs = "Escolha uma das maneiras a seguir para colocar o {{appName}} no seu site.", iEs = "Configurando a sua integração com o Zapier", aEs = "Configurando a sua integração com o Make", sEs = "Gerar chave de API", cEs = "Gerar uma chave de API para usar com o {{appName}} em", lEs = "Sua chave de API única", dEs = "Copie esta chave de API e salve em um local seguro. Se perder a chave, será preciso gerar uma nova.", uEs = "<0>Entre na conta do Zapier e crie um novo Zap.</0><1>Selecione {{appName}} como seu app de gatilho. Escolha também um evento de gatilho.</1><2>Escolha sua conta e insira sua chave de API única.</2><3>Teste seu gatilho.</3><4>Tudo pronto!</4>", _Es = "Vá para <0>Link de Convite do Make</0> e instale o aplicativo Cal.com.", pEs = "Faça login na sua conta Make e crie um novo Cenário.", mEs = "Selecione Cal.com como seu aplicativo de Gatilho. Escolha também um evento de Gatilho.", fEs = "Escolha sua conta e insira sua Chave API Única.", gEs = "Teste seu Gatilho.", hEs = "Tudo pronto!", vEs = "Instale primeiro o app do Zapier na loja de apps.", bEs = "Instale primeiro o aplicativo do Make na loja de aplicativos.", yEs = "Instalação do app", $Es = "Aplicativo não instalado", wEs = "Desculpe, este aplicativo não está instalado na sua conta. Por favor, visite nossa loja de aplicativos para explorar e descobrir este e outros ótimos aplicativos.", kEs = "Conectar com o servidor da Apple", SEs = "URL do calendário", xEs = "Gerar uma senha específica de app para usar com o {{appName}} em", EEs = "Não é possível adicionar esta conta de calendário da Apple. Por favor, verifique se você está usando uma senha específica para aplicativos ao invés de uma senha de conta.", TEs = "As suas credenciais serão armazenadas e encriptadas.", AEs = "Será armazenada e criptografada.", CEs = "Ir para a loja de apps", zEs = "Algo deu errado, tente reconectar seu calendário com todas as permissões necessárias", OEs = "Defina um número de telefone para a reunião", PEs = "Não há espaços ocupados", IEs = "Exibir na página de reserva", REs = "A localização estará visível antes da confirmação da reserva", NEs = "Adicionar GIF", DEs = "Procurar Giphy", MEs = "Adicionar link de Giphy", LEs = "Adicionando GIF à página de confirmação", qEs = "Encontre um GIF para animar a sua página de confirmação", jEs = "Compartilhar comentário", FEs = "Recursos", VEs = "Documentação de suporte", BEs = "Documentação do desenvolvedor", UEs = "Entrar em contato", WEs = "Fale com o suporte", GEs = "Suporte Premium", HEs = "Suporte da comunidade", KEs = "Comentário", YEs = "Agradecemos o seu comentário!", ZEs = "Erro ao enviar comentário", QEs = "Compartilhe seus comentários aqui:", JEs = "Detalhes da reserva", XEs = "ou", eTs = "Não importa", tTs = "Ir para: ", nTs = "Link de convite do Zapier", oTs = "Um URL de Reunião será criado assim que o evento for confirmado.", rTs = "Exibe dinamicamente o nome do participante para você, ou seu nome se for visto pelo seu participante", iTs = "Local do evento", aTs = "Motivo de reagendamento (opcional)", sTs = "Diga por que você precisa reagendar", cTs = "Este evento foi cancelado", lTs = "Avisamos por e-mail aos outros participantes e a você.", dTs = "Este campo será mostrado na reserva deste evento", uTs = "O URL da reunião está no e-mail de confirmação", _Ts = "O URL precisa começar com http:// ou https://", pTs = "O número de telefone será fornecido", mTs = "antes do início do evento", fTs = "quando o evento for cancelado", gTs = "Após os anfitriões não entrarem na videochamada do Cal", hTs = "Após os convidados não entrarem na videochamada do Cal", vTs = "Entrar na videochamada", bTs = "Entrar no Cal.com", yTs = "Entrar no Cal.com", $Ts = "Acompanhe suas reuniões, receba notificações e gerencie sua agenda com mais eficiência.", wTs = "Acompanhe suas reuniões e gerencie sua agenda com mais eficiência", kTs = "Falha ao entrar na chamada. Por favor, tente novamente.", STs = "Escolha como você gostaria de entrar nesta chamada", xTs = "Escolha como você gostaria de aparecer na chamada", ETs = "quando um novo evento for reservado", TTs = "enviar e-mail para a(o) anfitriã(o)", ATs = "enviar e-mail aos participantes", CTs = "Enviar SMS para participante", zTs = "enviar SMS para um número específico", OTs = "Envie lembretes de reuniões facilmente aos participantes por SMS", PTs = "enviar mensagem por WhatsApp para um número específico", ITs = "enviar mensagem por WhatsApp para participante", RTs = "Fluxos de trabalho", NTs = "Novo fluxo de trabalho", DTs = "Como você gostaria de começar?", MTs = "Adicionar um novo workflow", LTs = "quando o evento for reagendado", qTs = "Gatilho", jTs = "Gatilhos", FTs = "Acão", VTs = "Crie fluxos de trabalho para automatizar notificações e lembretes", BTs = "Nome do fluxo de trabalho", UTs = "Fluxo de trabalho personalizado", WTs = "{{workflowName}} criado com sucesso", GTs = "Tem certeza que deseja excluir este fluxo de trabalho?", HTs = "Excluir fluxo de trabalho", KTs = "Sim, excluir fluxo de trabalho", YTs = "Fluxo de trabalho excluído com sucesso", ZTs = "Quanto tempo antes do início do evento?", QTs = "dias", JTs = "hours", XTs = "minutos", eAs = "m", tAs = "h", nAs = "Criar seu primeiro fluxo de trabalho", oAs = "Fluxos de trabalho permitem que você automatize o envio de lembretes e notificações.", rAs = "Ativar em", iAs = "Fluxo de trabalho {{workflowName}} atualizado com sucesso", aAs = "Este é um nome de usuário padrão. Para atualizá-lo, levaremos você para fazer downgrade na cobrança.", sAs = "Este é um nome de usuário premium, obtenha o seu por {{price}}", cAs = "Atual", lAs = "premium", dAs = "padrão", uAs = "Confirmar alteração de nome de usuário", _As = "O nome de usuário será alterado de padrão para premium, por isso levaremos você para atualizar na conclusão.", pAs = "O nome de usuário será alterado de premium para padrão, por isso levaremos você para fazer downgrade na conclusão.", mAs = "Ir para cobrança", fAs = "Solicitar pagamento de reservas (0,5% + €0.10 de comissão por transação)", gAs = "Seu teste expirou", hAs = "Remover app", vAs = "Sim, remover o app", bAs = "Tem certeza de que deseja remover este app?", yAs = "Aplicativo removido com sucesso", $As = "Erro ao remover o aplicativo", wAs = "Conferência via web", kAs = "Chamada web", SAs = "Iniciar chamada web", xAs = "Encerrar chamada", EAs = "Teste seu agente com uma chamada web sem precisar de um número de telefone", TAs = "Chamada telefônica", AAs = "Conectando ao agente...", CAs = "Chamada ativa", zAs = "Chamada encerrada", OAs = "Erro na chamada", PAs = "Pronto para iniciar a chamada", IAs = "Falha ao iniciar a chamada web. Por favor, tente novamente.", RAs = "A chamada encontrou um erro. Por favor, tente novamente.", NAs = "Falha ao inicializar a chamada web. Verifique se as permissões do microfone estão concedidas.", DAs = "Inicie uma chamada para ver a conversa", MAs = "Aguardando conversa...", LAs = "Agente de IA", qAs = "Ao vivo", jAs = "Conectando...", FAs = "Requer confirmação", VAs = "Requer confirmação caso a reserva seja feita com menos de {{time}} $t({{unit}}_timeUnit) de antecedência", BAs = "Pode exigir confirmação", UAs = "{{count}} tipo de evento", WAs = "{{count}} tipos de evento", GAs = "{{count}} equipe", HAs = "{{count}} equipes", KAs = "Adicionar ação", YAs = "Definir link do Whereby", ZAs = "Insira um link válido do Whereby", QAs = "Definir link do Around.Co", JAs = "Insira um link válido do Around.Co", XAs = "Definir link do Riverside", eCs = "Insira um link válido do Riverside", tCs = "Insira um link de Ping.gg válido", nCs = "Conectar com o servidor do Exchange 2013", oCs = "Conectar com o servidor do Exchange 2016", rCs = "Modelo personalizado", iCs = "Corpo do e-mail", aCs = "Mensagem de texto", sCs = "Tem um problema específico?", cCs = "pesquisar nos nossos documentos", lCs = "Escolher um modelo", dCs = "Personalizado", uCs = "Lembrete", _Cs = "Reagendado", pCs = "Reagendado por", mCs = "Agendamento original", fCs = "Concluído", gCs = "Nota", hCs = "Lembrete: {{eventType}} com {{name}} em {{date}}", vCs = "Não será acionado para reservas já existentes, pois o usuário deverá fornecer o número de telefone ao fazer um pedido no evento.", bCs = "{{count}} minuto", yCs = "{{count}}m", $Cs = "{{count}} minutos", wCs = "{{count}} hora", kCs = "{{count}}h", SCs = "{{count}} horas", xCs = "Entrada inválida", ECs = "Não foi possível adicionar o link da reunião {{location}} ao seu evento agendado. Entre em contato com seus convidados ou atualize seu evento no calendário para adicionar os detalhes. Você pode <0>alterar sua localização no tipo de evento</0> ou tentar <1>remover e adicionar o aplicativo novamente.</1>", TCs = "Não foi possível atualizar seu <1>{{calendar}}</1>. <2> Confira as configurações do seu calendário ou remova e adicione seu calendário novamente </2>", ACs = "Nome do participante", CCs = "O nome completo da pessoa que está fazendo a reserva", zCs = "Integração com falha", OCs = "Ocorreu um problema ao adicionar um link de vídeo", PCs = "Ocorreu um problema ao atualizar seu calendário", ICs = "Ativo em {{count}} tipo de evento", RCs = "Ativo em {{count}} tipos de eventos", NCs = "Ativo em {{count}} equipe", DCs = "Ativo em {{count}} equipes", MCs = "Ativo em todos os tipos de eventos", LCs = "Ativo em todas as equipes", qCs = "Nenhum tipo de evento ativo", jCs = "Nenhuma equipe ativa", FCs = "Novo participante {{name}} no {{eventType}} em {{date}}", VCs = "Alguém se adicionou a um evento", BCs = "Variável", UCs = "Nome do evento", WCs = "Nome do participante", GCs = "Data do evento", HCs = "Horário do evento", KCs = "Nome do organizador", YCs = "Para usar este recurso, atualize para uma conta Pro.", ZCs = "Número de telefone inválido", QCs = "URL inválida para {{label}}. URL de amostra: {{sampleUrl}}", JCs = "Navegar", XCs = "Abrir", ezs = "Fechar", tzs = "Atualizar", nzs = "Comprar número dos EUA por {{priceInDollars}}$/mês", ozs = "Atualize para acessar as gravações", rzs = "Gravações estão disponíveis apenas como parte do plano Teams. Atualize para começar a gravar suas chamadas", izs = "Atualize para Enterprise para poder criar um número de telefone de Assistente de IA que pode ligar para convidados para agendar ligações", azs = "Gravações fazem parte do plano Teams", szs = "Este é um recurso de Equipe. Atualize para Equipe para ver a disponibilidade da sua equipe.", czs = "Este é um recurso de Equipe. Atualize para a Equipe para automatizar suas notificações de eventos e lembretes com fluxos de trabalho.", lzs = "Exibir no perfil", dzs = "Inserir", uzs = "Novo nome de usuário", _zs = "Nome de usuário atual", pzs = "Exemplo 1", mzs = "Exemplo 2", fzs = "Identificador de pergunta de reserva", gzs = "Tamanho da empresa", hzs = "Em que você precisa de ajuda?", vzs = "Formato variável", bzs = "URL de assinante de webhook já está definida", yzs = "Ignore todos os caracteres especiais da etiqueta de entrada adicional (use apenas letras e números), use todas as letras maiúsculas e substitua espaços em branco por sublinhados.", $zs = "Como usar perguntas de reserva como variáveis?", wzs = "Baixar app para desktop", kzs = "Definir link do Ping", Szs = "Limite excedido", xzs = "Quando algo acontece", Ezs = "Uma ação é realizada", Tzs = "Ação de teste", Azs = "Notificação enviada", Czs = "Sem dados", zzs = "Testar ação do fluxo de trabalho", Ozs = "Enviar SMS", Pzs = "Tem certeza de que deseja enviar um SMS para {{number}}?", Izs = "Nenhum calendário padrão conectado", Rzs = "Você pode conectar seu calendário por <1>aqui</1>.", Nzs = "Calendário padrão", Dzs = "Ocultar do perfil", Mzs = "Configuração de eventos", Lzs = "Nenhuma disponibilidade encontrada na programação", qzs = "Limites", jzs = "Com que frequência você pode receber reserva", Fzs = "Configurações de calendário e muito mais...", Vzs = "Avançado", Bzs = "Configurar pagamentos para o evento", Uzs = "Configuração do evento: múltiplas durações requerem pelo menos uma opção.", Wzs = "Configuração de evento: selecione uma duração padrão válida.", Gzs = "Limites de reserva devem estar em ordem crescente. [dia, semana, mês, ano,]", Hzs = "Limites de duração devem estar em ordem crescente. [dia, semana, mês, ano,]", Kzs = "Selecione para qual calendário adicionar reservas", Yzs = "Nome de evento personalizado", Zzs = "Criar nomes de eventos personalizados para exibir no evento do calendário", Qzs = "Código de autenticação de dois fatores incorreto", Jzs = "A que tipo de evento isto se aplica?", Xzs = "Aplicar a todos, incluindo futuros tipos de eventos", eOs = "Aplicar a todos os tipos de eventos de equipe e usuário", tOs = "A qual equipe isso se aplicará?", nOs = "Fluxo de trabalho permitem uma simples automação para enviar notificações e lembretes que permitem que você crie processos em torno de seus eventos.", oOs = "Esta é uma configuração interna e não afetará a quantidade de exibições em páginas públicas de reservas para você ou outra pessoa que estiver fazendo reserva.", rOs = "Criar fluxo de trabalho", iOs = "Faça isso", aOs = "Desligar", sOs = "Ligar", cOs = "Reservas canceladas não podem ser remarcadas", lOs = "Configurações atualizadas com sucesso", dOs = "Erro ao atualizar configurações", uOs = "Meu URL pessoal da {{appName}}", _Os = "Escreva algumas frases sobre você. Isso aparecerá no URL da sua página pessoal.", pOs = "Finalizar configuração e começar", mOs = "Este usuário ainda não adicionou uma biografia.", fOs = "Biografia", gOs = "Excluir conta", hOs = "Tem certeza de que deseja excluir sua conta {{appName}}?", vOs = "Excluir minha conta", bOs = "Início da semana", yOs = "Gravações", $Os = "Gravação", wOs = "Bom agendamento", kOs = "Selecionar em quais calendários você deseja verificar se há conflitos para evitar dupla reserva.", SOs = "Verificar se há conflitos", xOs = "Ver gravações", EOs = "Verificar gravações", TOs = "Adicionando eventos a", AOs = "Seguir preferências do sistema", COs = "Cores personalizadas da marca", zOs = "Personalizar a cor da sua marca na página de reservas.", OOs = "Pro", POs = 'Remover qualquer marca relacionada a {{appName}}, ex.: "Desenvolvido pela {{appName}}".', IOs = "Reunião instantânea com {{name}}", ROs = "Imagem do perfil", NOs = "Enviar", DOs = "Adicionar foto do perfil", MOs = "Endereço do Token", LOs = "Blockchain", qOs = "Senha antiga", jOs = "Sua nova senha supersegura", FOs = "Erro ao atualizar senha", VOs = "Autenticação de dois fatores", BOs = "Configurar um cronograma repetido", UOs = "hoje", WOs = "Aparência", GOs = "Minha conta", HOs = "Geral", KOs = "Calendários", YOs = "Faturas", ZOs = "Incorporados", QOs = "Representação", JOs = "Configurações para gerenciar representação de usuário", XOs = "Personificações recentes", e4s = "Personificação rápida", t4s = "Sem personificações recentes", n4s = "Usuários", o4s = "Usuário", r4s = "Gerencie as configurações para o seu perfil {{appName}}", i4s = "Aqui você poderá encontrar uma lista de todos os usuários", a4s = "Listagem de usuários", s4s = "Gerencie as configurações para seu idioma e fuso horário", c4s = "Configure como seus tipos de evento interagem com seus calendários", l4s = "Gerencie as configurações da aparência da sua reserva", d4s = "Gerencie seus aplicativos de videoconferência para suas reuniões", u4s = "Adicionar aplicativo de conferência", _4s = "Gerencie as configurações para as senhas da sua conta", p4s = "Definir autenticação de dois fatores", m4s = "Precisamos apenas de algumas informações básicas para configurar seu perfil.", f4s = "Pular", g4s = "Mais tarde", h4s = "Definir intervalos de tempo quando você estiver disponível", v4s = "Você pode personalizar tudo isso mais tarde na página de disponibilidade.", b4s = "Conecte um calendário primeiro", y4s = "Complete seu perfil", $4s = "Você pode adicionar mais calendários da loja de aplicativos", w4s = "Conectar aplicativos de conferência", k4s = "Conectar aplicativos de calendário", S4s = "Conectar aplicativos de pagamento", x4s = "Conecte aplicativos de automação", E4s = "Conecte aplicativos de análise", T4s = "Conectar outros aplicativos", A4s = "Conectar com aplicativos de mensagem", C4s = "Conecte aplicativos CRM", z4s = "Passo {{currentStep}} de {{maxSteps}}", O4s = "Adicionar variável", P4s = "Número de telefone personalizado", I4s = "Modelo de mensagem", R4s = "Assunto do e-mail", N4s = "Adicionar variáveis de texto dinâmicas", D4s = "O nome do tipo de evento", M4s = "A data do evento", L4s = "A duração do evento", q4s = "O horário inicial do evento", j4s = "Tipo de evento não encontrado", F4s = "Número para ligar", V4s = "O número de telefone do usuário que você está chamando", B4s = "Local", U4s = "O local do evento", W4s = "Observações adicionais", G4s = "Notas adicionais da reserva", H4s = "O nome da pessoa que fez a reserva", K4s = "Nome do organizador", Y4s = "Para", Z4s = "Fluxo de trabalho {{workflowName}} atualizado para {{offOn}} com sucesso", Q4s = "Baixar respostas", J4s = "Baixe todas as respostas para seu formulário em formato CSV.", X4s = "Ver respostas", e3s = "Baixar", t3s = "Baixando", n3s = "Baixar gravação", o3s = "As transcrições foram habilitadas", r3s = "As transcrições foram desabilitadas", i3s = "Baixar Transcrição", a3s = "Transcrição", s3s = "Uma gravação da sua chamada recente no {{appName}} está pronta para ser baixada", c3s = "As transcrições da sua ligação recente no {{appName}} já estão prontas para serem baixadas. Os links são válidos por apenas 1 hora", l3s = "Você também pode baixar a transcrição dos anexos", d3s = "Nota: O link para baixar só é válido por 12 horas. Você pode gerar um novo link para baixar seguindo as seguintes instruções <1>aqui</1>.", u3s = "Nota: O link de download é válido apenas por 12 horas. Você pode gerar um novo link de download seguindo as instruções.", _3s = "Criar seu primeiro formulário", p3s = "Com os Formulários de roteamento, você pode fazer perguntas e encaminhar para a pessoa correta ou o tipo de evento.", m3s = "Criar seu primeiro Webhook", f3s = "Com Webhooks, você pode receber dados de reuniões em tempo real quando algo acontece na {{appName}}.", g3s = "Por um máximo de", h3s = "evento", v3s = "eventos", b3s = "Gerenciar as configurações para o perfil da sua equipe", y3s = "Gerencie as configurações para o perfil da sua organização", $3s = "Usuários que estão no grupo", w3s = "Gerencie os administradores e membros da sua organização", k3s = "URL da equipe", S3s = "Membros da equipe", x3s = "Mais", E3s = "Fluxos de trabalho Cal.ai", T3s = "e mais {{count}}", A3s = "Nós vemos o aplicativo móvel como uma extensão do aplicativo da web. Se você estiver realizando alguma ação complicada, consulte o aplicativo da web.", C3s = "Enviar lembrete por SMS 24 horas antes do evento começar para o participante", z3s = "Enviar SMS personalizado quando o evento for reagendado para o participante", O3s = "Enviar e-mail personalizado quando o novo evento for agendado para a(o) anfitriã(o)", P3s = "Enviar um lembrete por e-mail 1 hora antes dos eventos começarem para o participante", I3s = "Enviar e-mail personalizado quando o evento for reagendado para a(o) anfitriã(o)", R3s = "Enviar SMS personalizado quando o novo evento for agendado para a(o) anfitriã(o)", N3s = "Enviar lembrete por SMS", D3s = "24 horas antes do início do evento", M3s = "Acompanhamento de ausentes", L3s = "30 minutos após o término do evento", q3s = "Lembrar participantes de trazer identificação", j3s = "1 dia antes do início do evento", F3s = "Lembrete por email", V3s = "1 hora antes do início do evento", B3s = "Lembrete SMS personalizado", U3s = "Quando o evento é agendado", W3s = "Lembrete de email personalizado", G3s = "Evento é reagendado para o anfitrião", H3s = "Incluir contagens de reservas de tipos de eventos gerenciados", K3s = "Bem-vindo(a) à {{appName}}!", Y3s = "Você poderá editar isso mais tarde.", Z3s = "Vou conectar a meu calendário mais tarde", Q3s = "Houve um problema ao salvar seus dados. Tente novamente ou entre em contato com o suporte ao cliente.", J3s = "Compre assentos faltantes", X3s = "Extensão do espaço", e6s = "Aparência da reserva", t6s = "Gerenciar as configurações de aparência da reserva da sua equipe", n6s = "Gerencie as configurações da aparência da sua organização", o6s = "Apenas o proprietário desta equipe pode fazer alterações na reserva da equipe ", r6s = 'Remover qualquer marca relacionada a {{appName}}, ex.: "Desenvolvido pela {{appName}}"', i6s = "{{teamName}} enviou um convite para juntar-se à equipe como {{role}}", a6s = "O token é inválido ou expirou.", s6s = "Ver Reserva", c6s = "Conectar-se ao Microsoft Exchange", l6s = "Método de autenticação", d6s = "Autenticação básica", u6s = "Autenticação NTLM", _6s = "Compressão GZip", p6s = "Versão do Exchange", m6s = "2007 SP1", f6s = "2010", g6s = "2010 SP1", h6s = "2010 SP2", v6s = "2013", b6s = "2013 SP1", y6s = "2015", $6s = "2016", w6s = "Roteamento", k6s = "Criar formulários para direcionar os participantes para os destinos corretos", S6s = "Enviar e-mail ao proprietário", x6s = "Envia um e-mail ao proprietário após o envio do formulário", E6s = "Enviar E-mail para", T6s = "Adicionar novo formulário", A6s = "Adicionar novo formulário à sua equipe", C6s = "Crie sua primeira rota", z6s = "Roteie para a pessoa certa com base nas respostas do seu formulário", O6s = "Formulário", P6s = "Crie o seu formulário para encaminhar um reservante", I6s = "Copiar link para formulário", R6s = "Tema da página de agendamento", N6s = "Isto só se aplica às suas páginas de reservas públicas", D6s = "Tema do painel", M6s = "Isso se aplica apenas ao seu painel conectado", L6s = "Padrão do sistema", q6s = "Adicionar uma equipe", j6s = "Receber dados de reunião em tempo real quando algo acontecer na {{appName}}", F6s = "Executar quando", V6s = "Faça o teste de ping antes de criar.", B6s = "Habilitar webhook", U6s = "Adicionar Webhook", W6s = "Webhook salvo", G6s = "Gerar chaves de API para acessar sua própria conta", H6s = "Nova chave de API", K6s = "ativo", Y6s = "Nome da chave API atualizada", Z6s = "Erro ao atualizar nome da chave API", Q6s = "Iframe HTML incorporado", J6s = "Incorpore todos os tipos de evento no seu site", X6s = "Crie a sua primeira chave de API", e5s = "As chaves API permitem que outros aplicativos se comuniquem com a {{appName}}", t5s = "Voltar para o registro", n5s = "Link de redefinição enviado", o5s = "Um e-mail está a caminho para {{email}} com instruções para redefinir sua senha.", r5s = "Se não receber um e-mail em breve, verifique se o endereço de e-mail digitado está correto, verifique sua pasta de spam ou entre em contato com o suporte se o problema persistir.", i5s = "Senha atualizada!", a5s = "Pagamento pendente", s5s = "Convites pendentes", c5s = "Convites pendentes da organização", l5s = "Não está na {{appName}}", d5s = "Nenhum calendário instalado", u5s = "Você ainda não conectou nenhum de seus calendários", _5s = "Adicionar um calendário", p5s = "Pode ser necessário sair e entrar novamente para ver as alterações aplicadas.", m5s = "Confirme sua senha antes de alterar o endereço de e-mail", f5s = "assentos", g5s = "Todos os aplicativos publicados na App Store da {{appName}} são de código aberto e testados minuciosamente por meio de avaliações por pares. No entanto, a {{companyName}} não endossa ou certifica esses aplicativos a não ser que sejam publicados pela {{appName}}. Se você encontrar conteúdo ou comportamento inadequado, denuncie.", h5s = "Denunciar aplicativo", v5s = "Limite frequência de reserva", b5s = "Limite quantas vezes este evento pode ser reservado", y5s = "Mostrar apenas o primeiro horário disponível de cada dia", $5s = "Isso limitará sua disponibilidade para este tipo de evento a um horário por dia, agendado no primeiro horário disponível.", w5s = "Limitar duração total de reserva", k5s = "Limite de quanto tempo este evento pode ser reservado", S5s = "Limite de reservas ativas do agendador", x5s = "Limite o número de reservas ativas que um agendador pode fazer para este tipo de evento", E5s = "Eventos recorrentes não suportam limite de reservas do agendador", T5s = "Adicione limite", A5s = "Nome da equipe obrigatório", C5s = "Compartilhe informações do participante entre convidados", z5s = "Mostrar a quantidade de assentos disponíveis", O5s = "Como usar perguntas de reserva como variáveis?", P5s = "Formato", I5s = "Perguntas", R5s = "Todas as informações que seu agendador deve fornecer antes de fazer uma reserva com você.", N5s = "Use letras maiúsculas para todas as letras", D5s = "Substituir espaços em branco com sublinhados", M5s = "Membros da plataforma", L5s = "Gerencie os administradores e membros da sua equipe da plataforma", q5s = "Faturamento da plataforma", j5s = "Gerencie o faturamento", F5s = "Gerencie tudo do faturamento", V5s = "No momento, você está no plano GRÁTIS", B5s = "Trabalhamos melhor em equipe. Amplie seus fluxos de trabalho com eventos circulares e coletivos e faça formulários avançados de roteamento", U5s = "Tentar agora", W5s = "Portal de Cobrança", G5s = "Falar com o suporte", H5s = "Ignore caracteres especiais no seu identificador de pergunta de reserva. Use apenas letras e números", K5s = "Repetir", Y5s = "Houve um problema ao buscar suas agendas. <1>Tente novamente</1> ou entre em contato com o suporte ao cliente.", Z5s = "Falha na conexão com a agenda", Q5s = "Reserva confirmada com sucesso", J5s = "Recusa de reserva realizada", X5s = "Esta reserva é provisória", ePs = "Ops, quero aceitar", tPs = "Não exibiremos isso novamente", nPs = "Não foi possível atualizar o fuso horário", oPs = "Fuso horário atualizado para {{formattedCurrentTz}}", rPs = "Atualize o fuso horário", iPs = "Atualizar fuso horário?", aPs = "Parece que seu fuso horário local mudou para {{formattedCurrentTz}}. É muito importante ter o fuso horário correto para evitar reservas em horários indesejados. Você deseja atualizá-lo?", sPs = "Não atualizar", cPs = "Solicitar notas adicionais", lPs = "Solicitar que as notas adicionais sejam preenchidas no momento da reserva", dPs = "enviar e-mail para um endereço de e-mail específico", uPs = "após o término do evento", _Ps = "quando a reserva é recusada", pPs = "quando a reserva é solicitada", mPs = "quando o pagamento da reserva é iniciado", fPs = "quando o pagamento da reserva é bem-sucedido", gPs = "quando o não comparecimento da reserva é atualizado", hPs = "Quanto tempo após o término do evento?", vPs = "Quanto tempo após os anfitriões não aparecerem na reunião de vídeo do Cal?", bPs = "Quanto tempo após os convidados não aparecerem na reunião de vídeo do Cal?", yPs = "Quanto tempo após os usuários não aparecerem na reunião de vídeo do Cal?", $Ps = "Não há espaços disponíveis", wPs = "Tempo disponível", kPs = "Não encontra o aplicativo de conferência certo? Visite nossa <0>App Store</0>.", SPs = "Instale novo aplicativo de calendário", xPs = "Torne o número de telefone necessário para o evento de reserva", EPs = "Disponibilidade de {{eventTypeTitle}}", TPs = "Erro ao editar disponibilidade", APs = "Você não tem permissão para acessar este recurso.", CPs = "Por favor cole o SAML metadata do seu Provedor de Identidade aqui", zPs = "Por favor insira um endereço de e-mail para que possamos encontrar o seu Provedor de Identidade", OPs = "Detalhes do Provedor de Serviços", PPs = "Seu Provedor de Identidade (IdP) solicitará os seguintes detalhes para concluir a configuração da aplicação SAML.", IPs = "URL do ACS", RPs = "ID da Entidade SP", NPs = "URL do ACS copiada!", DPs = "ID da Entidade SP copiada!", MPs = "Adicionar calendário", LPs = "Limitar reservas futuras", qPs = "Limita o tempo de antecedência com que este evento pode ser reservado", jPs = "Nenhuma configuração de tipo de evento", FPs = "{{name}} não configurou nenhum tipo de evento para você reservar.", VPs = "Frequência de cobrança", BPs = "Mensal", UPs = "Anual", WPs = "Finalizar compra", GPs = "Sua equipe foi desfeita com êxito", HPs = "Sua organização foi desfeita com êxito", KPs = "Erro ao criar equipe", YPs = "Você", ZPs = "Ou continue com", QPs = "Reenviar e-mail", JPs = "O membro já foi convidado", XPs = "Este nome de usuário já está em uso", eIs = "Insira um e-mail ou nome de usuário", tIs = "Insira um e-mail", nIs = "Insira e-mails", oIs = "Você está limitado a convidar no máximo {{nbUsers}} usuários de uma só vez.", rIs = "Este nome já está em uso", iIs = "É preciso inserir um nome de equipe", aIs = "É preciso inserir uma URL de equipe", sIs = "Este URL já está em uso", cIs = "Houve um problema ao registrar o subdomínio, tente novamente ou fale com o administrador", lIs = "Publicar equipe", dIs = "Número de telefone (notificações via texto)", uIs = "Número de telefone (notificações SMS)", _Is = "E-mail do participante", pIs = "O e-mail da pessoa que fez a reserva", mIs = "UID da reserva", fIs = "Digite um comando ou procure...", gIs = "Ah, não! Parece que a permissão expirou ou foi revogada. Reinstale novamente.", hIs = "Reinstale o aplicativo", vIs = "Motivo de reagendamento", bIs = "Escolha uma agenda compartilhada", yIs = "Ative isso se quiser usar uma agenda comum entre os anfitriões. Quando desativado, cada anfitrião será agendado com base em sua agenda padrão ou na agenda escolhida.", $Is = "Motivo", wIs = "ID do remetente", kIs = "Apenas letras, números e espaços permitidos (no máx. 11 caracteres)", SIs = "Testar formulário de roteamento", xIs = "Visualizar teste", EIs = "Direcionar para", TIs = "Teste seu formulário de roteamento sem enviar dados", AIs = "Testar roteamento", CIs = "Um administrador desativou um aplicativo de pagamento", zIs = "Editar tipo de evento", OIs = "Esta Organização é privada, e apenas o administrador ou dono da organização podem ver seus membros.", PIs = "Apenas o administrador ou dono da organização podem gerenciar configurações de SSO", IIs = "Apenas o administrador ou proprietário da organização pode gerenciar as configurações de sincronização de diretório", RIs = "Apenas o administrador ou proprietário da organização pode gerenciar clientes OAuth", NIs = "Programação coletiva", DIs = "Facilite a reserva da sua equipe quando todos estiverem disponíveis.", MIs = "Encontre a pessoa mais indicada disponível e percorra sua equipe.", LIs = "Round-robin fixo", qIs = "Adicione um participante fixo e utilize o round-robin em uma determinada quantidade de participantes.", jIs = "{{appName}} é melhor com equipes", FIs = "A equipe de {{companyName}}", VIs = "Adicione membros da sua equipe aos seus tipos de evento. Use programação coletiva para incluir todos ou encontre a pessoa mais apropriada pela programação com round-robin.", BIs = "O limite de reseva para este tipo de evento foi atingido", UIs = "O limite de duração para este tipo de evento foi atingido", WIs = "Um administrador desativou {{appName}}", GIs = "Isso desativará todos os e-mails para {{recipient}}. Isso inclui confirmações de agendamento, solicitações, reagendamentos e pedidos de reagendamento, e-mails de cancelamento e quaisquer outros e-mails relacionados a atualizações de agendamento.<br /><br />É sua responsabilidade garantir que seus {{recipient}} estejam cientes de quaisquer agendamentos e alterações em seus agendamentos.", HIs = "Um administrador desativou {{appName}}, afetando seu tipo de evento {{eventType}}", KIs = "Um administrador substituiu um dos seus tipos de evento", YIs = "Um administrador de equipe substituiu seu evento /{{slug}}", ZIs = "Um administrador na equipe <strong>{{teamName}}</strong> substituiu seu tipo de evento <strong>/{{slug}}</strong> por um tipo de evento controlado por ele.", QIs = "Seu link continuará a funcionar, mas algumas configurações podem ter sido alteradas. Você pode revisar nos tipos de evento.", JIs = "Se tiver alguma pergunta sobre o tipo de evento, fale com o seu administrador.<br /><br />Bom agendamento, <br/>Equipe do Cal.com", XIs = "O administrador desativou o {{appName}}, o que afeta seu tipo de evento {{title}}. Os participantes ainda podem agendar este tipo de evento, mas não serão solicitados a pagar. Você pode ocultar o tipo de evento para evitar isso até que seu administrador reative seu método de pagamento.", eRs = "Os participantes ainda podem agendar este tipo de evento, mas não serão solicitados a pagar. Você pode ocultar o tipo de evento para evitar isso até que seu administrador reative seu método de pagamento.", tRs = "O administrador desativou {{appName}}, afetando seu tipo de evento {{title}}.", nRs = "O administrador desativou {{appName}}, afetando seus tipos de evento. Se você tiver tipos de evento com {{appName}} como localização, Vídeo do Cal será definido como padrão.", oRs = "{{appName}} foi desativado", rRs = "Ir para aplicativos instalados", iRs = "Se você tiver outro calendário instalado, novas reservas serão adicionadas a ele. Caso contrário, conecte um novo calendário para não perder novas reservas.", aRs = "Ativar aplicativos", sRs = "Ative aplicativos que os usuários podem integrar com o {{appName}}", cRs = "Comprar uma licença", lRs = "Já tem uma conta?", dRs = "Já tenho uma chave:", uRs = "Copie a variável de ambiente CALCOM_LICENSE_KEY existente aqui.", _Rs = "Criar Chave de Licença", pRs = "{{appName}} foi ativado", mRs = "{{appName}} foi desativado", fRs = "As chaves foram salvas", gRs = "Desativar aplicativo", hRs = "Desativar este aplicativo pode causar problemas para a interação dos usuários com o Cal", vRs = "Editar chaves", bRs = "Ativar apps para sua instância do Cal", yRs = "Uma lista de todos os usuários em sua conta, incluindo nome, cargo, e-mail e função.", $Rs = "Aqui você pode adicionar um novo usuário.", wRs = "Aqui você pode editar um usuário atual.", kRs = "Aqui você pode editar uma organização.", SRs = "Adicionar novos clientes OAuth", xRs = "Bloquear ou desbloquear o envio de SMS para usuários", ERs = "Não há aplicativos disponíveis", TRs = 'Verifique se há aplicativos na sua implantação, em "packages/app-store"', ARs = "Não há aplicativos ativados nesta instância do Cal", CRs = "Nenhum aplicativo foi configurado ainda", zRs = "Você pode habilitar aplicativos nas configurações", ORs = "Entre em contato com o administrador", PRs = "Configurações do app", IRs = "Preencha este campo", RRs = "Opções", NRs = "insira a opção {{index}}", DRs = "Adicionar uma opção", MRs = "Esta localização já existe. Por favor, selecione uma nova localização", LRs = "Rádio", qRs = "Para usar o Google Meet, você deve definir seu calendário de destino como um Google Calendar", jRs = "Individual", FRs = "Todas as reservas", VRs = "Todos os usuários", BRs = "Todos os tipos de eventos", URs = "Suas reservas", WRs = "URL da reunião", GRs = "O URL da conferência de reunião do evento", HRs = "Substituições de data", KRs = "Apagar a data sobrescreve em {{date}}", YRs = "Adicione datas quando sua disponibilidade mudar em relação às suas horas diárias.", ZRs = "Substituições de data são realizadas automaticamente quando uma data tiver passado", QRs = "Que horas você está livre?", JRs = "Que horas você está ocupado(a)?", XRs = "Selecione as datas para substituir", eNs = "Indisponível o dia todo", tNs = "Marcar indisponível (o dia todo)", nNs = "Marcar indisponível nas datas selecionadas", oNs = "Atualizar substituição", rNs = "Substituição de data adicionada com sucesso", iNs = "Salvar Substituição", aNs = "Cópia de {{slug}}", sNs = "Definir como padrão", cNs = "Ocultar detalhes do tipo de evento", lNs = "Mostrar navegação", dNs = "Ocultar navegação", uNs = "Código de verificação enviado", _Ns = "Verificação bem-sucedida", pNs = "Código de verificação incorreto", mNs = "Verificação ainda não realizada", fNs = "Sem disponibilidade em {{month}}", gNs = "O agendamento só está disponível até {{days}} dias à frente. Por favor, verifique novamente em breve.", hNs = "O agendamento terminou em {{date}}. Por favor, verifique novamente em breve.", vNs = "Ver mês anterior", bNs = "Ver próximo mês", yNs = "Enviar código", $Ns = "Número verificado", wNs = "Crie seu primeiro webhook para este tipo de evento em equipe", kNs = "Crie um webhook para este tipo de evento em equipe", SNs = "Desativar página de reserva bem-sucedida (funciona apenas se você tiver uma URL de redirecionamento)", xNs = "Você é administrador, mas ainda não tem uma senha de pelo menos 15 caracteres ou 2FA", ENs = "Altere sua senha para obter acesso de administrador", TNs = "O nome do usuário já está em uso", ANs = "Atribuição", CNs = "Anfitriões fixos", zNs = "Adicionar anfitriões fixos", ONs = "Anfitriões em Round-Robin", PNs = "Número de anfitriões necessários para participar", INs = "Anfitriões", RNs = "Você precisa criar uma equipe para ativar este recurso. Clique aqui para criar uma equipe.", NNs = "Você precisa atualizar para nosso plano empresarial para ativar esse recurso.", DNs = "Novo participante", MNs = "Aguardando aprovação", LNs = "Este aplicativo requer uma conexão com o Google Calendar", qNs = 'O "Adicionar ao calendário" para este tipo de evento precisa ser um Google Calendar para que o Meet funcione. Conecte-o <0>aqui</0>.', jNs = "Você se conectou com uma conta do Google Calendar.", FNs = "É preciso ter um Google Calendar conectado para usar o Google Meet", VNs = "Continuar para instalar o Google Calendar", BNs = "Instalar o Google Meet", UNs = "Instalar o Google Calendar", WNs = "Nome do remetente", GNs = "Participante já convidado", HNs = "Nenhum registro encontrado", KNs = "Novo fluxo de trabalho para...", YNs = "Relatando", ZNs = "Veja todos os dados recebidos e baixe como CSV", QNs = "Plano da equipe obrigatório", JNs = "Formulários de roteamento são uma ótima maneira de direcionar os clientes potenciais recebidos para a pessoa certa. Atualize para o plano Teams e acesse esse recurso.", XNs = "Escolha uma licença", eDs = "O Cal.com vem com uma licença AGPLv3 acessível e gratuita, mas tem algumas limitações, que podem ser resolvidas atualizando para a licença Enterprise a qualquer momento. Você poderá fazer isso mais tarde, quando quiser.", tDs = "Licença", nDs = "Licença AGPLv3", oDs = "Não precisa manter seu código em código aberto", rDs = "Reempacote, troque de marca e revenda com facilidade", iDs = "Uma ampla variedade de recursos empresariais", aDs = "$0,00/mês", sDs = "Aberto e gratuito permanentemente", cDs = "Obrigatório para manter seu código em código aberto", lDs = "Não é possível reempacotar, trocar de marca e revender facilmente", dDs = "Sem recursos corporativos", uDs = "Licença Enterprise", _Ds = "Tudo para um caso de uso comercial com hospedagem privada, reempacotamento, troca de marca e revenda, além de acesso a componentes corporativos exclusivos.", pDs = "Configuração", mDs = "Instância de configuração do Cal.com", fDs = "Configurar", gDs = "Configuração de login único", hDs = "Configure o SAML/OIDC SSO e permita que membros da equipe façam login com um provedor de identidade", vDs = "Configure o SAML/OIDC SSO e permita que membros da organização façam login usando um provedor de identidade", bDs = "SSO com OIDC", yDs = "Configure o OIDC SSO com o provedor de identidade de sua escolha.", $Ds = "Configuração do OIDC", wDs = "Configure a conexão do OIDC com seu provedor de identidade. Confira as informações necessárias nele.", kDs = "URL de chamada de retorno copiada", SDs = "SSO com SAML", xDs = "Configure o SAML SSO com o provedor de identidade de sua escolha.", EDs = "Configuração do SAML", TDs = "Configure a conexão do SAML com seu provedor de identidade. Confira as informações necessárias nele.", ADs = "URL do ACS copiada", CDs = "ID da entidade copiada", zDs = "Configuração de {{connectionType}} criada com sucesso", ODs = "Configuração de {{connectionType}} excluída com sucesso", PDs = "Excluir a configuração de {{connectionType}}", IDs = "Sim, excluir a configuração de {{connectionType}}", RDs = "Você tem certeza que deseja remover a configuração de {{connectionType}}? Os membros do seu time que utilizam {{connectionType}} para fazer login não conseguirão acessar o Cal.com.", NDs = "Fuso horário do organizador", DDs = "Ver convite", MDs = "Aceitar convite", LDs = "Participar agora", qDs = "Participação bem-sucedida", jDs = "Você foi convidado para participar de uma equipe da organização {{parentTeamName}}", FDs = "Você foi convidado para participar de uma organização {{appName}}", VDs = "Você recebeu um convite de {{invitedBy}} para ingressar em sua equipe em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua equipe agende reuniões sem precisar trocar e-mails.", BDs = "{{invitedBy}} convidou você para se juntar à equipe {{teamName}} na organização {{parentTeamName}} em {{appName}} . {{appName}} é o agendador de eventos que permite que você e sua equipe agendem reuniões sem o envio de e-mail.", UDs = 'Você recebeu um convite de {{invitedBy}} para ingressar na organização "{{teamName}}" em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua organização agende reuniões sem precisar trocar e-mails.', WDs = "Vamos guiá-lo por algumas etapas rápidas e você estará aproveitando agendamentos sem estresse com seu {{entity}} em pouco tempo.", GDs = "Escolha seu nome de usuário", HDs = "Conecte com sua conta de calendário", KDs = "Defina sua disponibilidade", YDs = "Ingresse em {{teamName}}", ZDs = "Divirta-se com os agendamentos, equipe do {{appName}}", QDs = "Você está preses a representar um usuário, ou seja, tem possibilidade de realizar mudanças em nome dele. Tenha cuidado.", JDs = "Variáveis disponíveis", XDs = "{Scheduler}", eMs = "Sem fluxos de trabalho", tMs = "Mude o filtro para ver seus fluxos de trabalho pessoais e da equipe.", nMs = "Altere o filtro para ver os resultados.", oMs = "Nenhum resultado para filtrar", rMs = "Próximos passos recomendados", iMs = "Crie um tipo de evento gerenciado", aMs = "Reuniões são melhores com a presença dos membros certos da equipe. Convide-os agora.", sMs = "Crie um modelo um a um para um tipo de evento e distribua para vários membros.", cMs = "Coletivo ou round-robin", lMs = "Reúna os membros da sua equipe com eventos coletivos, ou selecione a pessoa certa com o round-robin.", dMs = "Não está mais participando de {{title}} às {{date}}", uMs = "Você não está mais participando deste evento", _Ms = "Um participante não está mais participando de {{title}} às {{date}}", pMs = "Um participante não está mais participando do seu evento", mMs = "{{name}} cancelou. Quer dizer que um assento foi liberado para este período de tempo", fMs = "Criar evento em", gMs = "Criar formulário de roteamento em", hMs = "Defina um link padrão para o app", vMs = "Definir um link padrão para o app permite que todos os tipos de evento recém-criados usem o link definido para o app.", bMs = "Aplicativo padrão do organizador", yMs = "{{organizer}} não possui um aplicativo de conferência padrão", $Ms = "Serviço interrompido para manutenção", wMs = "A equipe do {{appName}} está realizando uma manutenção programada. Se tiver alguma dúvida, fale com o suporte.", kMs = "{{numberOfSeats}} assentos", SMs = "Perguntas sobre reserva", xMs = "Personalize as perguntas feitas na página de reservas", EMs = "Adicione uma pergunta", TMs = "Identificador", AMs = "Este e-mail já existe", CMs = "Insira uma URL de redirecionamento para a qual o participante será enviado ao sair da reunião.", zMs = "Não é mais possível pagar por este evento", OMs = "Um reembolso pelo pagamento desta reserva está a caminho.", PMs = "O pagamento desta reserva foi reembolsado.", IMs = "De acordo com a política de reembolso do evento, o pagamento da reserva não é reembolsável.", RMs = "O prazo para reembolso do evento expirou. Portanto, o pagamento da reserva não é reembolsável.", NMs = "Falhar ao confirmar reserva", DMs = "Sem assentos suficientes", MMs = "Já existe um campo com este nome", LMs = "O campo de convidados deve ser do tipo 'Múltiplos e-mails'", qMs = "Mostrar na página de reservas", jMs = "Você pode visitar a página de reserva cancelada", FMs = "Comece agora com modelos do Zapier", VMs = "Modelos Padrão", BMs = "Modelos Cal.ai", UMs = "Publicação de {{team}} cancelada", WMs = "Este link da organização não está disponível no momento. Entre em contato com o proprietário da organização ou peça que seja publicado.", GMs = "O link de {{entity}} não está disponível por enquanto. Fale com o proprietário de {{entity}} ou peça que seja publicado.", HMs = "Membro da equipe", KMs = "Formulário de roteamento", YMs = "Descrição do formulário", ZMs = "Mantenha minha conexão com o formulário", QMs = "Quaisquer alterações feitas no roteador ou nos campos do formulário que está sendo duplicado serão refletidas na cópia. No entanto, excluir um campo não o removerá da cópia.", JMs = "Formulário excluído", XMs = "Tem certeza de que deseja excluir este formulário?", eLs = "Sim, excluir formulário", tLs = "Este link não será mais acessível para qualquer pessoa com quem tenha sido compartilhado.", nLs = "Todas as respostas associadas serão excluídas.", oLs = "URL de redirecionamento copiada! Você pode ir e definir a URL no seu próprio formulário.", rLs = "Modificações nos campos e rotas dos formulários a seguir afetarão este formulário.", iLs = "Formulários conectados", aLs = "Os formulários a seguir serão afetados ao modificar os campos e rotas aqui.", sLs = "Aguarde um pouco até as respostas serem coletadas. Você também pode acessar e enviar o formulário por conta própria.", cLs = "Isto é o que seus usuários verão", lLs = "Identifica campo por este nome.", dLs = "Adiciona uma opção por linha", uLs = "Selecione um formulário de roteamento", _Ls = "Adicione uma nova Rota", pLs = "Tome decisões conscientes com o Insights", mLs = "Nosso painel de informações do Insights apresenta todas as atividades da sua equipe e mostra as tendências que permitem melhor tomada de decisão e agendamento da equipe.", fLs = "Ver reservas em todos os membros", gLs = "Veja quem está recebendo mais reservas e garanta a melhor distribuição em sua equipe", hLs = "Identificar tendências de reserva", vLs = "Veja quais são os horários da semana e do dia mais procurados pelos reservantes", bLs = "Localizar tipos de evento populares", yLs = "Veja quais tipos de eventos estão recebendo a maioria dos cliques e reservas", $Ls = "Sem respostas por enquanto", wLs = "Nenhuma rota definida", kLs = "Este será o espaço reservado", SLs = "Ocorreu um erro ao reservar o evento, atualize a página e tente novamente", xLs = "Nenhuma alocação de tempo selecionada", ELs = "Selecione uma alocação de tempo para reservar o evento.", TLs = "Selecione a alocação de tempo", ALs = "Trocar para visualização mensal", CLs = "Trocar para visualização semanal", zLs = "Trocar para visualização diária", OLs = "Trocar para visualização de coluna", PLs = "{{num}} opções de local", ILs = "Selecione na próxima etapa", RLs = "Esta reunião ainda não começou", NLs = "{{appName}} requer uma conta de {{dependencyName}} conectada", DLs = "Conectar {{dependencyName}}", MLs = "{{dependencyName}} se conectou", LLs = "Requer {{dependencyName}}", qLs = "Código de verificação", jLs = "Poderia tentar novamente em um horário diferente?", FLs = "Verificar", VLs = "O fuso horário do destinatário", BLs = "Fuso horário", ULs = "Horário de término do evento", WLs = "O horário de término do evento", GLs = "Cancelar URL", HLs = "O URL para cancelar a reserva", KLs = "Motivo do cancelamento", YLs = "O motivo para cancelar o agendamento", ZLs = "URL de reagendamento", QLs = "O URL para reagendar a reserva", JLs = "Motivo do reagendamento", XLs = "O motivo para reagendar o agendamento", eqs = "Há uma variável inválida no seu nome do evento", tqs = "Selecionar tudo", nqs = "Atualize em massa os tipos de evento existentes", oqs = "Agenda padrão do membro", rqs = "Definido pelo administrador da equipe", iqs = "Local padrão do membro", aqs = "Usaremos a agenda de disponibilidade padrão de cada membro. Não será possível editar ou alterar.", sqs = "Você precisa ter pelo menos uma agenda", cqs = "Atualize as localizações para os tipos de evento selecionados", lqs = "Atualize os horários para os tipos de eventos selecionados", dqs = "Bloqueado para membros", uqs = "Desbloqueado para membros", _qs = "Os membros poderão ver os aplicativos ativos, mas não poderão editar as configurações", pqs = "Os membros poderão ver os aplicativos ativos e poderão editar as configurações", mqs = "Você poderá ver os aplicativos ativos mas não poderá editar as configurações", fqs = "Você poderá ver os aplicativos ativos e poderá editar as configurações", gqs = "Membros não podem adicionar seus fluxos de trabalho pessoais a este tipo de evento. Membros poderão ver os fluxos de trabalho ativos da equipe mas não poderão editar configurações de fluxo de trabalho.", hqs = "Membros poderão adicionar seus fluxos de trabalho pessoais a este tipo de evento. Membros poderão ver os fluxos de trabalho ativos da equipe mas não poderão editar configurações de fluxo de trabalho.", vqs = "Você pode ver os fluxos de trabalho ativos da equipe mas não poderá editar as configurações ou adicionar seus fluxos de trabalho pessoais a este tipo de evento.", bqs = "Você poderá habilitar/desabilitar fluxos de trabalho pessoais neste tipo de evento. Você poderá ver os fluxos de trabalho ativos da equipe mas não poderá editar configurações de fluxo de trabalho.", yqs = "Os membros não podem adicionar seus webhooks pessoais a este tipo de evento. Os membros poderão ver os webhooks ativos, mas não poderão editar nenhuma configuração de webhook.", $qs = "Os membros poderão adicionar seus webhooks pessoais a este tipo de evento. Os membros poderão ver os webhooks ativos, mas não poderão editar nenhuma configuração de webhook.", wqs = "Você pode ver os webhooks gerenciados ativos, mas não poderá editar nenhuma configuração de webhook ou adicionar seus webhooks pessoais a este tipo de evento.", kqs = "Você pode adicionar webhooks a este tipo de evento. Você pode ver os webhooks gerenciados ativos, mas não poderá editá-los.", Sqs = "Bloqueado pelo administrador da equipe", xqs = "Você não conectou uma conta do {{appName}}.", Eqs = "Conectar agora", Tqs = "Substituir e notificar {{count}} membro", Aqs = "Substituir e notificar {{count}} membros", Cqs = "O url/{{slug}} já existe para {{count}} membro. Deseja substituir?", zqs = "O url/{{slug}} já existe para {{count}} membros. Deseja substituir?", Oqs = "<strong>{{names}}</strong> já está usando o url <strong>/{{slug}}</strong>.", Pqs = "<strong>{{names}}</strong> já estão usando o url <strong>/{{slug}}</strong>.", Iqs = "Se você escolher substituir, serão enviadas notificações. Volte e remova caso não queira sobrescrever.", Rqs = "Revisar tipo de evento", Nqs = "Procurando mais análises?", Dqs = "Procurando mais Insights?", Mqs = "Filtros", Lqs = "Filtrar", qqs = "Adicionar um membro", jqs = "Adicionar filtro", Fqs = "Adicionar regra", Vqs = "Adicionar grupo de regras", Bqs = "Limpar todos os filtros", Uqs = "E-mail Verificado", Wqs = "Selecionar usuário", Gqs = "Selecionar tipo de evento", Hqs = "Selecionar intervalo de data", Kqs = "Eventos populares", Yqs = "Nenhum tipo de evento encontrado", Zqs = "Duração média de evento", Qqs = "Reservas por hora", Jqs = "Membros mais reservados", Xqs = "Membros menos reservados", e9s = "Mais agendamentos marcados", t9s = "Menos agendamentos marcados", n9s = "Mais agendamentos concluídos", o9s = "Menos agendamentos concluídos", r9s = "Eventos criados", i9s = "Eventos concluídos", a9s = "Eventos cancelados", s9s = "Eventos reagendados", c9s = "Eventos", l9s = "Desempenho", d9s = "do último período", u9s = "De: {{startDate}} Para: {{endDate}}", _9s = 'A página de sucesso será desabilitada ao adicionar um redirecionamento. Não se esqueça de mencionar "Reserva confirmada" na sua página de sucesso personalizada.', p9s = "Tendências de evento", m9s = "Limpar filtros", f9s = "Limpar", g9s = "Segurar", h9s = "Coletar pagamento na reserva", v9s = "Carregar taxa de não comparecimento", b9s = "Cartão em posse", y9s = "Carregar cartão", $9s = "Cartão carregado", w9s = "{{amount, currency}} de taxa de não comparecimento", k9s = "Taxa de não comparecimento", S9s = "Enviar cartão", x9s = "Enviar informações de pagamento", E9s = "Sua reunião está aguardando um método de pagamento", T9s = "Foi cobrada uma taxa de não comparecimento de {{amount, currency}} para {{title}} à(s) {{date}}", A9s = "Taxa de não comparecimento cobrada", C9s = "Foi cobrada uma taxa de não comparecimento de {{amount, currency}} para o evento seguinte", z9s = "Algo deu errado ao cobrar a taxa de não comparecimento. Tente novamente mais tarde.", O9s = "Coletar taxa de não comparecimento", P9s = "Taxa de não comparecimento cobrada", I9s = "Pagamento recusado. Por favor, tente outro cartão ou entre em contato com seu banco para obter assistência.", R9s = "Este tipo de cartão não é compatível com esta compra. Por favor, use um método de pagamento diferente.", N9s = "O valor mínimo de pagamento é $0,50 USD. Por favor, aumente o valor do seu pagamento.", D9s = "Não foi possível cobrar o cartão para pagamento.", M9s = "Insights", L9s = "Formulários de Roteamento", q9s = "Nenhum dado encontrado para o filtro ou dados selecionados.", j9s = "Estou ciente de que, se eu não comparecer a este evento, será cobrada no meu cartão uma taxa de não comparecimento de {{amount, currency}}.", F9s = "dias", V9s = "Detalhes do cartão", B9s = "Algo deu errado do nosso lado. Entre em contato com nossa equipe de suporte, e resolveremos isso imediatamente para você.", U9s = "Para obter mais ajuda, insira o texto a seguir ao entrar em contato com o suporte", W9s = "Neste momento, não é possível habilitar assentos e cobrar taxa de não comparecimento", G9s = "Conclua sua reserva", H9s = "Conclua sua reserva: {{title}} à(s) {{date}}", K9s = "Confirme suas informações", Y9s = "Copiar link de convite", Z9s = "Editar configurações do link", Q9s = "Link de convite copiado", J9s = "Link de convite excluído", X9s = "Chave da API excluída", ejs = "Isso excluirá permanentemente a chave de API. Qualquer aplicativo que use esta chave perderá imediatamente o acesso à sua conta. Esta ação não pode ser desfeita.", tjs = "Configurações do link de convite salvas", njs = "Link configurado para expirar após...", ojs = "1 dia", rjs = "7 dias", ijs = "30 dias", ajs = "3 meses", sjs = "1 ano", cjs = "Você recebeu um convite para ingressar em {{teamName}}", ljs = "{{amount, currency}}", djs = "Você está prestes a cobrar {{amount, currency}} do participante. Tem certeza de que deseja continuar?", ujs = "Cobrar {{amount, currency}} do participante", _js = "Solicitar pagamento ({{paymentFeePercentage}}% + {{fee, currency}} de comissão a cada transação)", pjs = "{{email}} recebeu um convite", mjs = "{{userCount}} usuários foram convidados", fjs = "Erro ao coletar cartão", gjs = "A imagem carregada não deve ultrapassar o limite de 5 MB", hjs = "{{errorCode}}: você não tem autorização para habilidar ou desabilitar este fluxo de trabalho", vjs = "Inserção embutida", bjs = "Carrega seu tipo de evento embutido diretamente no conteúdo restante do site.", yjs = "Botão pop-up flutuante", $js = "Insere um botão flutuante no seu site para ativar um modal com seu tipo de evento.", wjs = "Pop-up ao clicar em elemento", kjs = "Abra uma caixa de diálogo quando alguém clicar em um elemento.", Sjs = "Usar meu próprio formulário", xjs = "Use nossa API de roteamento headless e use seu próprio formulário para envios.", Ejs = "Precisa de ajuda? Confira nosso guia para incorporar o Cal no Wix, Squarespace ou WordPress. Consulte as perguntas frequentes ou explore opções de incorporação avançadas.", Tjs = "Reservar meu Cal", Ajs = "Primeiro nome", Cjs = "Sobrenome", zjs = "Primeiro nome, Sobrenome", Ojs = "Convidar como", Pjs = "Formulário atualizado com êxito.", Ijs = "Desative os e-mails de confirmação padrão para participantes", Rjs = "Pelo menos um fluxo de trabalho está ativo neste tipo de evento, que envia um e-mail aos participantes quando o evento for reservado.", Njs = "Desative e-mails de confirmação padrão para anfitriões", Djs = "Pelo menos um fluxo de trabalho está ativo neste tipo de evento, que envia um e-mail aos anfitriões quando o evento for reservado.", Mjs = "Adicionar uma substituição", Ljs = "Importar usuários do Google Workspace", qjs = "Conectar com o Google Workspace", jjs = "Você deve ser administrador do Google Workspace para usar este recurso", Fjs = "Crie seu primeiro webhook para este tipo de evento", Vjs = "Crie seu primeiro webhook com 'Reunião instantânea criada' como gatilho para este tipo de evento", Bjs = "Instalar aplicativo em", Ujs = "Criar para", Wjs = "Moeda", Gjs = "Crie um ambiente onde suas equipes possam criar aplicativos compartilhados, fluxos de trabalho e tipos de eventos com agendamento round-robin e coletivo.", Hjs = "Gerenciar organizações com múltiplas equipes", Kjs = "Configurar sua organização", Yjs = "Configurar sua plataforma", Zjs = "Organizações são ambientes compartilhados em que as equipes podem criar fluxos de trabalho, aplicativos, tipos de evento compartilhados e muito mais.", Qjs = "Planos", Jjs = "Plataforma", Xjs = "Gerencie tudo relacionado à plataforma.", eFs = "A Plataforma Cal.com permite que você facilmente integre agendadores no seu aplicativo usando APIs e módulos da plataforma.", tFs = "Requer um nome de organização", nFs = "Requer o endereço de e-mail da sua organização", oFs = "Endereço de e-mail da sua organização", rFs = "Seu endereço de e-mail de administrador", iFs = "Nome do usuário do administrador", aFs = "Nome da organização", sFs = "Nome da plataforma", cFs = "URL da organização", lFs = "Verifique o e-mail da sua organização", dFs = "Use o código abaixo para verificar seu endereço de e-mail e continuar a configuração da sua organização.", uFs = "Parâmetros adicionais de URL", _Fs = "Sobre a sua organização", pFs = "Organizações são ambientes compartilhados em que você pode criar múltiplas equipes com membros, fluxos de trabalho, aplicativos, tipos de evento compartilhados e muito mais.", mFs = "Criar suas equipes", fFs = "Comece a agendar juntos ao adicionar os membros das suas equipes à sua organização", gFs = "Convidar administradores da sua organização", hFs = "Estes administradores terão acesso a todas as equipes na sua organização. Você pode adicionar administradores e membros da equipe mais tarde.", vFs = "Definir senha", bFs = "Será criada uma nova conta de usuário com o e-mail da sua organização e esta senha.", yFs = "Logotipo da organização", $Fs = "Uma breve descrição sobre sua organização. Isso aparecerá na página do perfil público da sua organização.", wFs = "Farei isso mais tarde", kFs = "Verifique seu e-mail", SFs = "Insira o código de seis dígitos enviado para {{email}}", xFs = "Verifique seu e-mail para criar uma organização", EFs = "O código inserido não é válido, tente novamente", TFs = "Este e-mail já está sendo usado", AFs = "Você recebeu um convite para ingressar em {{orgName}}", CFs = "Ingresse na sua equipe em {{orgName}} e comece a focar na reunião, não em fazer reuniões!", zFs = "Não foi possível criar as equipes a seguir devido a campos de dados dinâmicos: {{slugs}}", OFs = "Nomes de equipe não podem ser vazios", PFs = "Nomes de equipe não podem ser repetidos", IFs = "O usuário pertence a uma organização", RFs = "Esta organização ainda não tem nenhuma equipe", NFs = "Se você for administrador, não se esqueça de criar equipes para mostrar aqui.", DFs = "Configurar", MFs = "Meu perfil", LFs = "Minhas configurações", qFs = "CRM", jFs = "Mensagens", FFs = "Nome ou número mostrado como remetente do SMS (alguns países não permitem IDs de remetentes com caracteres alfanuméricos)", VFs = "Apenas o administrador da sua organização pode criar equipes novas", BFs = "A nova política de spam do Google pode impedir que você receba e-mails e notificações de calendário sobre esta reserva.", UFs = "Resolver", WFs = "Houve um erro ao criar equipes para esta organizazção. Falta o campo de dados dinâmico do URL.", GFs = "Copiar link para a organização", HFs = "Equipe: {{teamName}}", KFs = "Usuário: {{userName}}", YFs = "Veja insights de reserva em seus eventos", ZFs = "Histórico de Chamadas", QFs = "Visualize o histórico de chamadas em todas as suas chamadas Cal.ai", JFs = "{{locationCount}} opções de local", XFs = "Tipo de Canal", e8s = "Motivo de Encerramento", t8s = "Status da Sessão", n8s = "Sentimento do Usuário", o8s = "Hora", r8s = "De", i8s = "Plano personalizado", a8s = "Incorporação de e-mail", s8s = "Selecione alguns horários disponíveis e incorpore-os no seu e-mail", c8s = "Selecione o horário", l8s = "Selecione a data", d8s = "Mostrar apenas se um parâmetro estiver definido", u8s = "Adicionar parâmetro", _8s = "Estamos conectando você a alguém da {{orgName}}.", p8s = "Por favor, não feche ou atualize esta página", m8s = "Veja todos os horários disponíveis", f8s = "ex.: Time de Marketing", g8s = "ex: Time de Vendas", h8s = "ex: Time de Design", v8s = "ex: Time de Engenharia", b8s = "ex: Time de Análise de Dados", y8s = "Você poderá adicionar mais equipes depois.", $8s = "De que se trata esta reunião?", w8s = "Adicionar à equipe", k8s = "Remover usuários da organização", S8s = "Credencial de delegação", x8s = "A credencial de delegação permite que você gerencie o acesso aos calendários do Google Workspace para sua organização.", E8s = "Adicione este ID do Cliente no Google Workspace com o escopo abaixo", T8s = "Credencial de delegação ativada", A8s = "Adicionar credencial de delegação", C8s = "Editar credencial de delegação", z8s = "Domínio", O8s = "Nenhuma plataforma de workspace", P8s = "Plataforma de workspace", I8s = "Plataformas de workspace", R8s = "Gerencie as plataformas de workspace que podem ser usadas para credencial de delegação", N8s = "Editar plataforma de workspace", D8s = "Editar conta de serviço", M8s = "Adicionar plataforma de workspace", L8s = "Slug", q8s = "JSON da chave da conta de serviço", j8s = "Editar JSON da chave da conta de serviço", F8s = "A credencial de delegação restringe a adição de mais de uma instalação", V8s = "Aplicativo instalado com sucesso e está usando credenciais delegadas", B8s = "Tem certeza de que deseja remover {{userCount}} usuários desta organização?", U8s = "Remover usuários da equipe", W8s = "Tem certeza de que deseja remover {{userCount}} usuários desta equipe?", G8s = "Este usuário ainda não definiu nenhuma agenda", H8s = "Este usuário não está em nenhuma equipe", K8s = "Este usuário ainda não instalou nenhum aplicativo", Y8s = "Requer verificação de e-mail do reservante", Z8s = "Para assegurar a verificação do e-mail do reservante antes de agendar eventos", Q8s = "Mensagens de texto só podem ser enviadas a participantes quando este tipo de evento exigir confirmação.", J8s = "Organizações", X8s = "Carregar Logotipo do Vídeo Cal", e7s = "Atualizar logotipo do vídeo Cal", t7s = "Carregar Banner", n7s = "Para garantir que seu logotipo fique visível no fundo escuro do vídeo Cal, carregue uma imagem de cor clara em formato PNG ou SVG para manter a transparência.", o7s = "Outros times", r7s = "Aqui você pode conferir os times da sua organização dos quais você não faz parte. Se necessário, você pode se adicionar a eles.", i7s = "Você não faz parte de nenhuma organização", a7s = "Nenhum outro time encontrado", s7s = "Não há outros times nesta organização.", c7s = "Nome do participante", l7s = "Sobrenome do participante", d7s = "Nome da pessoa que fez a reserva", u7s = "O sobrenome da pessoa que fez a reserva", _7s = "Seu Resumo Mensal", p7s = "Nome do Membro", m7s = "Eventos Mais Populares", f7s = "Aqui está seu resumo dos eventos populares da sua equipe {{teamName}} nos últimos 30 dias", g7s = "Eu", h7s = "Reunião indisponível", v7s = "E-mail de resumo mensal", b7s = "E-mail de resumo mensal para as equipes", y7s = "Verifique seu time para habilitar o envio de mensagens aos participantes", $7s = "Membro removido", w7s = "Minha disponibilidade", k7s = "Disponibilidade da equipe", S7s = "Disponibilidade imediata para reuniões", x7s = "Código de reserva", E7s = "Códigos de reserva", T7s = "Cada código de reserva pode ser usado exatamente uma vez para conceder acesso sem seu autenticador.", A7s = "Códigos de reserva copiados!", C7s = "O código de reserva está incorreto.", z7s = "Acesso perdido", O7s = "Nenhum código de reserva encontrado. Gere nas suas configurações.", P7s = "Nova organização criada: ação pendente", I7s = "Olá, administrador", R7s = "A organização exige uma configuração de DNS", N7s = 'Foi criada uma organização com um campo de dados dinâmicos "{{orgSlug}}".<br /><br />Configure seu registro de DNS para apontar o subdomínio correspondente da nova organização para onde o aplicativo principal está sendo executado. Se não fizer isso, a organização não funcionará.<br /><br />Confira algumas opções muito básicas de configuração para que o subdomínio aponte para seu aplicativo e a página do perfil da organização seja carregada.<br /><br />É possível fazer isso com um registro de endereço:', D7s = "Ou o registro CNAME:", M7s = "Após configurar o subdomínio, marque a configuração do DNS com concluída nas Configurações de administrador das organizações.", L7s = "Ir para Configurações de administrador das organizações", q7s = "A organização foi processada", j7s = "Ocorreu um erro ao processar esta organização", F7s = "Uma lista de todas as organizações. Ao aceitar uma organização, todos os usuários com aquele domínio de e-mail poderão entrar SEM a verificação do e-mail.", V7s = "Sem verificação", B7s = "Verificado", U7s = "DNS ausente", W7s = "DNS configurado", G7s = "Marcar como DNS configurado", H7s = "Valor", K7s = "Sua organização foi atualizada com êxito", Y7s = "Sua equipe não tem tipos de evento", Z7s = "A opção de assento não é compatível com múltiplas durações", Q7s = "Incluir evento do calendário", J7s = "OAuth", X7s = "Formulário de criação de cliente OAuth", eVs = "Este é o formulário para criar um novo cliente OAuth", tVs = "Formulário de atualização de cliente OAuth", nVs = "Este é o formulário para editar um cliente OAuth existente", oVs = "Adicionou recentemente", rVs = "Conecte todos os seus calendários", iVs = "{{appName}} lê a disponibilidade de todos os seus calendários existentes.", aVs = "Personalize sua experiência de agendamento com fluxos de trabalho", sVs = "Automação de fluxo de trabalho", cVs = "Agende para sua equipe com agendamento coletivo e round-robin", lVs = "Nenhum membro encontrado", dVs = "Sincronização de diretório", uVs = "Nome do diretório", _Vs = "Provedor de diretório", pVs = "URL base do SCIM", mVs = "Bearer Token SCIM", fVs = "URL base do SCIM copiado", gVs = "Bearer Token SCIM copiado", hVs = "Seu provedor de identidade solicitará as seguintes informações para configurar o SCIM. Siga as instruções para finalizar a configuração.", vVs = "Configurar sincronização de diretório", bVs = "Escolha um provedor de identidade para configurar o diretório da sua equipe.", yVs = "Configure um provedor de identidade para começar a usar o SCIM.", $Vs = "Conexão de sincronização de diretório criada.", wVs = "Provisione e desprovisione usuários com seu provedor de diretório.", kVs = "Conexão de sincronização de diretório excluída.", SVs = "Excluir conexão", xVs = "Excluir conexão de sincronização de diretório", EVs = "Tem certeza de que deseja excluir esta conexão de sincronização de diretório?", TVs = "Essa ação não pode ser desfeita. Isso excluirá permanentemente a conexão de sincronização de diretório.", AVs = "Configuração do evento: deve ter pelo menos 1 minuto de duração.", CVs = "Agendamentos de disponibilidade", zVs = "Não autorizado", OVs = "{{clientName}} gostaria de acessar a sua conta {{appName}}", PVs = "Selecionar conta ou equipe", IVs = "Isso permitirá ao {{clientName}}", RVs = "Associar você com suas informações pessoais de {{clientName}}", NVs = "Veja suas informações pessoais, incluindo quaisquer informações pessoais disponibilizadas publicamente", DVs = "Veja seu endereço de e-mail principal", MVs = "Conecte-se aos seus aplicativos instalados", LVs = "Ler, editar, excluir os seus tipos de eventos", qVs = "Ler, editar, excluir sua disponibilidade", jVs = "Ler, editar, excluir suas reservas", FVs = "Permitir que {{clientName}} faça isto?", VVs = "Ao clicar em Permitir, você autoriza que este aplicativo use suas informações, de acordo com os termos de serviço e política de privacidade. Você pode remover o acesso na App Store do {{appName}}.", BVs = "Permitir", UVs = "Este usuário não concluiu a integração. Não será possível definir a disponibilidade antes de concluir a integração.", WVs = "Você está vendo a disponibilidade deste usuário. Você só pode editar sua disponibilidade.", GVs = "Você pode substituir isso por evento nas configurações Avançadas em cada tipo de evento.", HVs = "Editar disponibilidade do usuário: {{username}}", KVs = "Reenviar convite", YVs = "O convite foi reenviado.", ZVs = "SAML", QVs = "Adicionar cliente", JVs = "Depois de copiar o segredo, você não poderá mais visualizá-lo", XVs = "Adicionar novo cliente", eBs = "Adicionar novo usuário", tBs = "Este app ainda não foi configurado", nBs = "como CSV", oBs = "Sobrepor meu calendário", rBs = "Ao conectar-se à seu Calendário, você aceita nossa política de privacidade e termos de uso. Você pode revogar o acesso a qualquer momento.", iBs = "Veja seus eventos do calendário para evitar conflito nos agendamentos.", aBs = "Junte-se a {{eventLocationType}}", sBs = "Solução de problemas", cBs = "Calendários que estamos verificando para conflitos", lBs = "Horários de disponibilidade", dBs = "Gerenciar calendários", uBs = "Gerenciar agendas de disponibilidade", _Bs = "Bloqueado", pBs = "Desbloqueado", mBs = "Bloquear fuso horário na página de reserva", fBs = "Bloquear o fuso horário na página de reservas, útil para eventos presenciais.", gBs = "Você só pode ter um aplicativo de pagamento ativado por tipo de evento.", hBs = "Insira o número em formato internacional.", vBs = "Instalar Calendário", bBs = "Subdomínio próprio", yBs = "Obtenha seu próprio subdomínio, como acme.cal.com", $Bs = "Insights de toda a organização", wBs = "Entenda como toda a sua organização está gastando o tempo", kBs = "Marca própria abrangente", SBs = "Personalize sua experiência de agendamento com seu próprio logotipo, cores e muito mais", xBs = "Equipes ilimitadas", EBs = "Verificar e-mail", TBs = "Por favor, digite o endereço de e-mail usado para esta reserva para prosseguir com o cancelamento", ABs = "O e-mail não corresponde ao e-mail da reserva", CBs = "Adicione quantas subequipes forem necessárias à sua organização", zBs = "Faturamento Unificado", OBs = "Tipos de eventos gerenciados avançados", PBs = "Adicione um único cartão de crédito para pagar todas as assinaturas da sua equipe", IBs = "Empresa", RBs = "Atualize para Enterprise para criar sua organização", NBs = "Crie sua organização", DBs = "Criar organização", MBs = "Atualize para Organizations e receba um subdomínio, faturamento unificado, insights, whitelabeling abrangente e muito mais", LBs = "Atualize para Enterprise e ganhe acesso à Sincronização de Diretório Ativo, Provisionamento Automático de Usuários SCIM, Agentes de Voz Cal.ai, APIs de Administrador e mais!", qBs = "Você só pode ativar um aplicativo de pagamento por tipo de evento", jBs = "Equipes que são membros desta organização também serão excluídas junto com seus tipos de eventos", FBs = "Usuários que faziam parte da organização não serão excluídos, mas seus nomes de usuário seriam alterados para permitir que existam fora da organização", VBs = "Tipos de eventos de usuário criados após o usuário estar na organização serão excluídos", BBs = "Tipos de eventos de usuário migrados não serão excluídos", UBs = "Excluir {{organizationName}} ?", WBs = "Publicado", GBs = "Não publicado", HBs = "Publicar", KBs = "Abra o solucionador de problemas e descubra o que há de errado com sua programação", YBs = "Precisa de ajuda?", ZBs = "Solucionador de problemas", QBs = "Número para Ligar", JBs = "Nome do Convidado", XBs = "E-mail do Convidado", eUs = "Empresa do Convidado", tUs = "Instale um calendário", nUs = "Reserva instantânea", oUs = "Deixe as pessoas reservarem imediatamente", rUs = "Atualize para Enterprise e permita que os convidados participem de uma chamada instantânea na qual os participantes possam participar diretamente. Isso é apenas para tipos de eventos de equipe", iUs = "Não quer esperar?", aUs = "Reunião iniciada", sUs = "Pague para reservar", cUs = "Deixe Assistentes de IA agendarem para você", lUs = "Não foi possível encontrar a reserva", dUs = "A reserva de assentos está lotada", uUs = "Credenciais de pagamento ausentes", _Us = "ID do aplicativo de pagamento ausente", pUs = "A reserva não tem assentos disponíveis suficientes", mUs = "{{username}} está ausente por um breve período de tempo.", fUs = "Enquanto isso, {{profile.username}} será responsável por todas as novas reuniões agendadas em nome de {{username}} .", gUs = "Ausente", hUs = "Configure ações em seu perfil enquanto estiver ausente.", vUs = "Enviar pedido", bUs = "A data de início e a data de término são obrigatórias", yUs = "A data de início deve ser anterior à data de término", $Us = "A data de início deve ser no futuro", wUs = "Usuário não encontrado", kUs = "Não é possível redirecionar para si mesmo", SUs = "Ausência já existente", xUs = "ID de ausência obrigatório", EUs = "Já existe um redirecionamento de reserva desse usuário para você.", TUs = "Entrada criada com sucesso", AUs = "Notificação de redirecionamento de reserva", CUs = "Notificação de redirecionamento de reserva", zUs = "Você recebeu um redirecionamento de agendamento de {{eventOwner}}, então os links do perfil deles serão redirecionados para o seu durante o intervalo de tempo {{dates}}.", OUs = "Notificação de edição de redirecionamento de agendamento", PUs = "Notificação de Edição de Redirecionamento de Agendamento", IUs = "Seu redirecionamento de agendamento de {{eventOwner}} para o intervalo de tempo {{oldDates}} foi atualizado. O novo intervalo de tempo para o redirecionamento é {{dates}}.", RUs = "Notificação de cancelamento de redirecionamento de agendamento", NUs = "Notificação de Cancelamento de Redirecionamento de Agendamento", DUs = "Seu redirecionamento de agendamento de {{eventOwner}} para o intervalo de tempo {{dates}} foi cancelado.", MUs = "Você aceitou esta solicitação de redirecionamento de reserva.", LUs = "Você rejeitou esta solicitação de redirecionamento de reserva.", qUs = "Copiar link para solicitação de compartilhamento", jUs = "Solicitação de redirecionamento de reserva", FUs = "Selecione o membro da equipe", VUs = "Indo embora? Basta marcar o link do seu perfil como indisponível por um período de tempo.", BUs = "Redirecione seu perfil para outro membro da equipe", UUs = "Redirecione seu perfil para outro membro da equipe (é necessário plano de equipe)", WUs = "Lista de indisponibilidade", GUs = "Entrada excluída com sucesso", HUs = "Entrada editada com sucesso", KUs = "Temporariamente ausente?", YUs = "Adicionar um redirecionamento", ZUs = "Criar entrada", QUs = "Intervalo de tempo", JUs = "Adicione todos os membros da equipe, incluindo futuros membros", XUs = "Redirecionar para", eWs = "Está tendo problemas para encontrar um horário?", tWs = "Mostrar mais", nWs = "Encaminhar parâmetros como ?email=...&name=.... e mais", oWs = "Agende reuniões quando todos estiverem disponíveis ou alterne entre os membros da sua equipe", rWs = "mais baixo", iWs = "baixo", aWs = "médio", sWs = "alto", cWs = "mais alto", lWs = "Enviar reserva para", dWs = "Definir prioridade", uWs = "Definir Peso", _Ws = "Habilitar Pesos", pWs = "Prioridade para {{userName}}", mWs = "Os pesos determinam como as reuniões são distribuídas entre os anfitriões. <0>Saiba mais</0>", fWs = "Peso para {{userName}}", gWs = "alterar prioridade", hWs = "Use identificadores de campo como variáveis para seu redirecionamento de evento personalizado", vWs = "Use identificadores de campo como variáveis para seu redirecionamento de evento personalizado (por exemplo {{variable}} )", bWs = "A conta já está vinculada", yWs = "Enviar e-mail", $Ws = "Ligar para o participante usando o Agente de Voz Cal.ai", wWs = "Ligar para confirmar reserva", kWs = "2 horas antes do início do evento", SWs = "Configuração do agente Cal.ai", xWs = "Por favor, escolha pelo menos um tipo de evento para fazer uma chamada de teste.", EWs = "Marcar como não compareceu", TWs = "Desmarcar como não compareceu", AWs = "Conta vinculada com sucesso", CWs = "Houve um erro ao desvincular a conta", zWs = "Agendar Viagem", OWs = "Planeje sua viagem com antecedência para manter seus agendamento existentes em um fuso horário diferente e evitar ser agendado à meia-noite.", PWs = "Agende mudança de fuso horário", IWs = "Data", RWs = "Digite o prompt geral para o agente", NWs = "Isto se sobrepõe com um agendamento existente. Por favor, selecione uma data diferente.", DWs = "Receber notificações quando seu time não tem disponibilidade", MWs = "Administradores receberão notificações de e-mail quando um usuário tentar agendar um membro da equipe e receber 'Sem disponibilidade'. Nós enviamos este e-mail depois de duas ocorrências e te lembramos a cada 7 dias para cada usuário.  ", LWs = "Desativar notificações por SMS para tipos de eventos apenas com telefone", qWs = "Desativar notificações automáticas por SMS para tipos de eventos que têm apenas número de telefone (attendeePhoneNumber) como pergunta obrigatória, com e-mail opcional ou não obrigatório", jWs = "Seu plano atual", FWs = "$37 por usuário por mês", VWs = "Gerencie as configurações de privacidade da sua organização", BWs = "Privacidade", UWs = "Novos times estarão sob sua organização", WWs = "Adicionar nome do grupo", GWs = "Nome do Grupo", HWs = "Roteadores", KWs = "Primário", YWs = "Tornar primário", ZWs = "Adicionar e-mail", QWs = "Adicionar e-mails", JWs = "Adicione um endereço de e-mail para substituir seu e-mail principal ou para usar como e-mail alternativo em seus tipos de eventos.", XWs = "Confirme seu e-mail", eGs = "$t(hey_there) {{name}}, confirmando sua reserva em {{date}}.", tGs = "O primeiro nome da pessoa que está agendando", nGs = "O sobrenome da pessoa que está agendando", oGs = "Nome do agendador", rGs = "Seu primeiro nome", iGs = "Enviamos um e-mail para <strong>{{email}}</strong> . Clique no link do e-mail para verificar este endereço.", aGs = "Envie detalhes do evento para", sGs = "Agendar fuso horário sem data final", cGs = "Selecionar membros", lGs = "O que nós devemos fazer com os tipos de evento do seu membro?", dGs = "Todos os tipos de evento individuais dos seus membros (exceto os gerenciados) serão permanentemente apagados. Eles não conseguirão criar novos", uGs = "Os tipos de evento individuais dos seus membros serão ocultados dos perfis (exceto os gerenciados) mas os links ainda ficarão ativos. Eles não serão capazes de criar novos.  ", _Gs = "Ocultar tipos de evento individuais", pGs = "Apagar tipos de evento individuais", mGs = "Bloquear criação de tipos de evento individuais", fGs = "Impedir membros de criar seus próprios tipos de evento.", gGs = "Adicionar ao tipo de evento", hGs = "Crie a senha da conta", vGs = "Criar conta com SAML", bGs = "Erro ao criar senha da conta", yGs = "Não é permitido criar senha de conta para contas cal", $Gs = "Não é permitido criar senha de conta para senhas já criadas", wGs = "Você não tem uma senha de conta, crie uma em Securança -> Senha. Não é possível disconectar até uma senha de conta ser criada.", kGs = "Disconecte contas conectadas", SGs = "Disconectar sua conta conectada mudará a maneira como você faz login. Você só poderá fazer login usando e-mail + senha", xGs = "Eu concordo com a política de privacidade e o uso de cookies", EGs = "Fazer uma Ligação", TGs = "Pular atribuição round robin se o contato existir no Salesforce", AGs = "A URL deve conter o e-mail do contato como um parâmetro, ex. ?email=contactEmail", CGs = "Selecionar Conta", zGs = "Instale {{appName}} na sua conta pessoal ou em uma conta de equipe.", OGs = "Selecionar Tipos de Evento", PGs = "Em qual tipo de evento você deseja instalar {{appName}}?", IGs = "Configurar {{appName}}", RGs = "Finalize a configuração do App. Você pode alterar essas configurações mais tarde.", NGs = "já instalado", DGs = "Não especificado", MGs = "Férias", LGs = "Viagem", qGs = "Doente", jGs = "Feriado", FGs = "Encaminhando para <0>{{username}}</0>", VGs = "Não é possível encaminhar", BGs = "Crie uma política Ausente", UGs = "Comunique aos seus agendadores quando você não estiver disponível para receber agendamentos. Eles ainda poderão agendar com você após seu retorno ou você pode encaminhá-los a um membro da equipe.", WGs = "{{displayName}} está ausente", GGs = "<0>{{displayName}}</0> participará das reuniões enquanto ele(a) estiver ausente.", HGs = "Agende com {{displayName}}", KGs = "Selecione motivo", YGs = "Criar política Ausente", ZGs = "Editar Entrada de Ausência", QGs = "Enviar Feedback", JGs = "A(O) anfitriã(o) não apareceu", XGs = "Você pode agendar outra reunião com ele(a)", eHs = "Como podemos melhorar nosso serviço?", tHs = "O que você mais gostou?", nHs = "Revisar", oHs = "Revisado", rHs = "Não revisado", iHs = "URL de avaliação", aHs = "URL para o Formulário de Avaliação", sHs = "URL de não comparecimento", cHs = "URL para Feedback de Não-Comparecimento", lHs = "Não precisa de ajuda?", dHs = "Ocultar ajuda", uHs = "Média de Avaliações", _Hs = "Não comparecimento (Anfitrião)", pHs = "Não comparecimento (Convidado)", mHs = "Avaliações recentes", fHs = "Nenhuma avaliação enviada", gHs = "Adicione um fluxo de trabalho com 'Avaliação' para receber avaliações após as reuniões", hHs = "Maior ausência", vHs = "Melhor avaliado", bHs = "Pior avaliado", yHs = "Membros com a maior taxa de reuniões", $Hs = "Membros com a menor taxa de reuniões", wHs = "Pontuação CSAT", kHs = "SMS Bloqueado", SHs = "Sair sem atribuir ninguém?", xHs = "Tem certeza de que deseja sair deste evento sem adicionar participantes?", EHs = "Se você não atribuir ninguém para este evento, não haverá disponibilidade mostrada para os agendadores.", THs = "Voltar e Atribuir", AHs = "Sair sem Atribuir", CHs = "Ao continuar, você concorda com nossos <0>Termos</0> e <1>Política de Privacidade</1>.", zHs = "Ao prosseguir, você concorda com nossos", OHs = "Termos", PHs = "Sempre {{x}} dias disponíveis", IHs = "Move automaticamente a janela de agendamento de {{x}} dias para frente a cada dia, garantindo que seu calendário sempre mostre os próximos {{x}} dias de horários disponíveis.", RHs = "Assinatura da equipe cancelada com sucesso", NHs = "Erro ao cancelar a assinatura da equipe", DHs = "Um erro ocorreu ao tentar adicionar ao plano da plataforma, por favor tente novamente mais tarde", MHs = "Um erro ocorreu ao tentar atualizar o cliente OAuth, por favor tente novamente mais tarde", LHs = "Um erro ocorreu ao tentar criar o cliente OAuth, por favor tente novamente mais tarde", qHs = "Cor do tipo de evento", jHs = "Isso é usado apenas para diferenciação de tipo de evento e agendamento dentro do aplicativo. Não é exibido para os agendadores.", FHs = "Marcar como não compareceu", VHs = "{{x}} marcado como não compareceu", BHs = "{{x}} desmarcado como não compareceu", UHs = "disparadores para todos os tipos de eventos da equipe e todos os tipos de eventos pessoais dos membros da equipe", WHs = "Gerencie as configurações da sua equipe", GHs = "Status de não comparecimento atualizado para os participantes", HHs = "Email copiado", KHs = "Número de telefone copiado", YHs = "Usuário é um membro pendente da organização", ZHs = "Usuário já foi convidado ou é membro", QHs = "Usuário é membro de uma organização que esta equipe não faz parte.", JHs = "Reserva foi reatribuída", XHs = "Reatribuir", eKs = "Reatribuir reserva para outro anfitrião disponível de round robin", tKs = "Atribuir membro da equipe", nKs = "Substituir qual membro da equipe você deseja atribuir.", oKs = "Nenhum anfitrião disponível", rKs = "Reatribuir anfitrião de round robin", iKs = "Não escrever no feed ICS", aKs = "Reagendamento não é possível, pois o evento expirou", sKs = "Este evento expirou", cKs = "Pular criação de contatos se eles não existirem no {{appName}}", lKs = "Se o seu link ICS for somente leitura (por exemplo, Proton Calendar), marque a caixa acima para evitar erros. Você também precisará atualizar manualmente seu calendário para mudanças.", dKs = "Atributos", uKs = "Novo atributo", _Ks = "Adicionar atributos", pKs = "Adicionar atributos aos membros da sua equipe", mKs = "Nova opção", fKs = "Atualizar membro", gKs = "Atributo", hKs = "Criar um atributo para os membros da sua equipe", vKs = "Editar um atributo para os membros da sua equipe", bKs = "Atributo atualizado com sucesso", yKs = "Atributo excluído com sucesso", $Ks = "Atributos editados com sucesso", wKs = "Gerencie atributos para os membros da sua equipe", kKs = "Edite atributos para os membros da sua equipe", SKs = "Voltar para atributos", xKs = "Tem certeza de que deseja excluir esta opção?", EKs = "Esta opção está atribuída a {{numberOfUsers}} membros. Excluí-la a removerá de seus perfis.", TKs = "Desativar e-mails padrão para participantes relacionados a este tipo de evento", AKs = "Desativa a comunicação por e-mail padrão relacionada a este tipo de evento, incluindo confirmações de reserva, lembretes e cancelamentos.", CKs = "Desativar e-mails padrão para anfitriões relacionados a este tipo de evento", zKs = "Digite confirmar para continuar", OKs = "Desativar e-mail", PKs = "Conceder acesso à API de administrador", IKs = "Revogar acesso à API de administrador", RKs = "Adicionar calendário {{calendar}}", NKs = "Conectar Calendário Apple", DKs = "Calendário Apple conectado", MKs = "Verificando Calendário Apple", LKs = "Conectar Calendário Google", qKs = "Calendário Google conectado", jKs = "Verificando Calendário Google", FKs = "Conectar Calendário Outlook", VKs = "Calendário Outlook conectado", BKs = "Verificando Calendário Outlook", UKs = "Conectar ao Stripe", WKs = "Stripe Conectado", GKs = "Verificando credenciais do Stripe", HKs = "Variáveis de resposta de perguntas de reserva", KKs = "Gerenciado por {{teamAdmins}}", YKs = "{{count}} opções", ZKs = "Reagendar com o mesmo anfitrião Round-Robin", QKs = "Eventos reagendados serão atribuídos ao mesmo anfitrião inicialmente agendado", JKs = "Desativar entrada se o identificador da URL estiver preenchido", XKs = "Limites de Agendamento", eYs = "Limites de agendamento para membros da equipe em todos os tipos de eventos da equipe", tYs = "Limitar quantas vezes os membros podem ser reservados em todos os tipos de eventos da equipe", nYs = "Limites de agendamento atualizados com sucesso", oYs = "Você não tem autorização para fazer essa alteração na reserva", rYs = "Credencial de delegação desativada", iYs = "Membros correspondentes", aYs = "{{x}} membros correspondentes", sYs = "Fila de membros correspondentes (usando pesos de atributos)", cYs = "Fila de membros correspondentes (usando pesos de designados do evento)", lYs = "Nenhum membro correspondente. Será utilizado como alternativa os membros da equipe atribuídos ao tipo de evento.", dYs = "Nenhum membro correspondente. Será usado como fallback os membros da equipe atribuídos ao tipo de evento. Considere adicionar um fallback ou corrigir a lógica de using_fallback_members", uYs = "Ocultar detalhes dos eventos do calendário em calendários compartilhados", _Ys = "Quando um calendário é compartilhado, os eventos são visíveis para os leitores, mas seus detalhes são ocultados para aqueles que não têm acesso de escrita.", pYs = "Últimos {{count}} dias", mYs = "Mês até hoje", fYs = "Ano até hoje", gYs = "Período personalizado", hYs = "Política de reembolso", vYs = "Sempre", bYs = "Nunca", yYs = "Opção de pagamento", $Ys = "Se cancelado", wYs = "antes", kYs = "Mostrar todas as colunas", SYs = "Alternar colunas", xYs = "Nenhuma coluna encontrada", EYs = "Ao agendar, adicione eventos e novos participantes como:", TYs = "Lead", AYs = "Contato em uma conta", CYs = "Pular a criação do registro de {{entry}} se não existir no Salesforce", zYs = "Se o contato não existir em uma conta, criar novo lead a partir do participante", OYs = "Criar um novo contato em uma conta com base no domínio de e-mail do participante e contatos existentes", PYs = "Alterar proprietário do registro na reserva", IYs = "Atribuir atributos em massa", RYs = "Isso resulta na exibição de uma mensagem personalizada. Tente alterar a resposta para redirecionar a um evento", NYs = "Isso resulta no redirecionamento para {{externalUrl}}. Tente alterar a resposta para redirecionar a um evento", DYs = "Possível anfitrião", MYs = "Status atual de roteamento", LYs = "Redirecionar agendamento", qYs = "Redirecionar o agendamento para diferentes membros da equipe", jYs = "Verificar nova rota", FYs = "Redirecionar", VYs = "Novo status de roteamento", BYs = "Se o participante existir no Salesforce, agendar diretamente com o proprietário", UYs = "Entidade para verificar o proprietário para agendar diretamente", WYs = "Conta", GYs = "Escolher horários dos anfitriões", HYs = "Você pode selecionar um horário diferente para cada anfitrião. O horário padrão de cada anfitrião é escolhido por padrão.", KYs = "Nenhum anfitrião atribuído, adicione anfitriões na aba de atribuição.", YYs = "Reatribuir manualmente o anfitrião round robin", ZYs = "Reatribuir manualmente o anfitrião round robin para outro anfitrião disponível", QYs = "Reatribuir o anfitrião round robin para outro anfitrião disponível", JYs = "O novo usuário não é um anfitrião round robin válido para este tipo de evento", XYs = "O novo usuário é um anfitrião fixo para este tipo de evento", eZs = "Reagendar com o mesmo horário", tZs = "Reagendar com o mesmo horário do novo evento", nZs = "Reagendar para o novo evento com horário diferente", oZs = "Reagendar com horário diferente", rZs = "Não temos o ID para o novo evento. Por favor, vá para o Formulário de Roteamento e salve-o novamente.", iZs = "Agendamento redirecionado com sucesso. Redirecionando para a página de agendamento", aZs = "Na reserva, escrever no objeto do evento", sZs = "Nome do campo", cZs = "Adicionar novo campo", lZs = "Você não tem acesso para redirecionar esta reserva", dZs = "Resposta do formulário não encontrada", uZs = "Proprietário do contato", _Zs = "Não encontrado", pZs = "Usando membros de fallback", mZs = "Rota escolhida", fZs = "Lógica de atributos correspondida", gZs = "Lógica de atributos de fallback correspondida", hZs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere adicionar algumas regras de atributos.", vZs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere adicionar algumas regras de atributos para fallback.", bZs = "Todos os membros atribuídos ao tipo de evento da equipe. Considere ajustar o fallback para obter uma correspondência.", yZs = "Aviso", $Zs = "Fallback: Se nenhum membro da equipe corresponder, use aqueles que atendam aos seguintes critérios (por padrão, corresponde a todos os membros da equipe atribuídos ao evento)", wZs = "Aviso de fallback", kZs = "Não necessário", SZs = "Anfitrião indisponível", xZs = "Anfitrião disponível", EZs = "Tem certeza de que deseja reatribuir esta reserva a um anfitrião indisponível?", TZs = "Tem certeza de que deseja reatribuir esta reserva?", AZs = "Sim, reatribuir", CZs = "Filtrar por atributos", zZs = "Motivo da reatribuição", OZs = "Alterar o tipo de campo pode causar perda de dados. Por favor, crie um novo campo em vez disso.", PZs = "Reatribuído por", IZs = "linha", RZs = "linhas", NZs = "Fuso horário do participante", DZs = "Hora de início do evento no fuso horário do participante", MZs = "Hora de início do evento no fuso horário do participante", LZs = "Hora de término do evento no fuso horário do participante", qZs = "Hora de término do evento no fuso horário do participante", jZs = "Criar evento no contato, se existir. Caso contrário, usar lead como alternativa", FZs = "Nome do proprietário a ser alterado", VZs = "Nenhum filtro definido", BZs = "Simulação de agendamento bem-sucedida", UZs = "O teste simulado foi concluído com sucesso.", WZs = "Você não tem acesso a esta página", GZs = "Para visualizar ou interagir com esta página, você deve ter privilégios de administrador ou proprietário", HZs = "Tipo de campo", KZs = "Quando escrever", YZs = "Ao fazer uma reserva, escrever em um campo personalizado no registro {{record}} do participante", ZZs = "Em cada reserva", QZs = "Apenas se o campo estiver vazio", JZs = "Data de início da reserva", XZs = "Data de criação da reserva", eQs = "Reserva reatribuída para {{host}}", tQs = "Sem proprietário do contato", nQs = "Formulários de Roteamento Criados", oQs = "Total de Respostas", rQs = "Total de Respostas Sem Agendamento", iQs = "Total de Respostas Com Agendamento", aQs = "Sem Agendamentos", sQs = "Nome do Formulário", cQs = "Agendamento", lQs = "Sem Agendamento", dQs = "Agendado por", uQs = "Criado em", _Qs = "Status do Agendamento", pQs = "Agendado em", mQs = "Enviado em", fQs = "Copiar URL de redirecionamento", gQs = "URL de redirecionamento ao sair", hQs = "Total de agendamentos por período", vQs = "Encaminhados por período", bQs = "Por dia", yQs = "Por semana", $Qs = "Por mês", wQs = "Motivo da atribuição", kQs = "Acesso negado", SQs = "O proprietário do contato será o anfitrião do Round Robin se disponível", xQs = "Adicionar novos participantes como", EQs = "O proprietário do contato não será forçado (ainda pode ser anfitrião se corresponder aos atributos e critérios do Round Robin)", TQs = "Direcionar para um usuário que corresponda a um campo de pesquisa em uma conta", AQs = "Opção do Salesforce", CQs = "Nome do campo de pesquisa", zQs = "Se o participante tiver um domínio de e-mail gratuito, ignore a verificação de propriedade e faça o round robin normalmente", OQs = "É", PQs = "Não é", IQs = "Contém", RQs = "Não contém", NQs = "Começa com", DQs = "Termina com", MQs = "Está vazio", LQs = "Não está vazio", qQs = "Traduzir título e descrição automaticamente", jQs = "Traduz automaticamente títulos e descrições para o idioma do navegador do visitante usando IA.", FQs = "Distribuição", VQs = "Permite otimizar a distribuição para máxima disponibilidade ou buscar uma atribuição mais equilibrada.", BQs = "Maximizar disponibilidade", UQs = "Permite que os agendadores marquem reuniões sempre que um anfitrião estiver disponível. Use isso para maximizar o número de reuniões potenciais agendadas quando a distribuição uniforme de reuniões entre os anfitriões for menos importante.", WQs = "Balanceamento de carga", GQs = "Monitoraremos quantas reservas foram feitas com cada anfitrião e compararemos com os outros, desativando alguns anfitriões que estão muito à frente para que as reservas sejam distribuídas uniformemente.", HQs = "Editar pesos", KQs = "Pesos atualizados com sucesso", YQs = "Exigir confirmação apenas para provedores de e-mail gratuitos (Ex. @gmail.com, @outlook.com)", ZQs = "Excluir e-mails que contêm ...", QQs = "Exigir emails que contenham ...", JQs = "Por favor, insira um endereço de e-mail corporativo válido", XQs = "Você não tem permissão para agendar com este domínio de email. Por favor, entre em contato com o proprietário deste link.", eJs = "Buscar colunas", tJs = "Opções de busca", nJs = "Desativar perfil público da organização e redirecionar", oJs = "Redireciona {{orgSlug}}.cal.com para {{destination}}", rJs = "Seleção única", iJs = "Seleção múltipla", aJs = "Configurações de conflito de agenda", sJs = "Selecione quais agendas verificar para conflitos", cJs = "Reunião em grupo", lJs = "Tem certeza de que deseja remover este aplicativo de", dJs = "Desconectar aplicativo de", uJs = "Não criar novos registros para convidados adicionados ao agendamento", _Js = "Google Meet", pJs = "Zoom", mJs = "Vídeo do MS Teams", fJs = "Bloquear para atribuição", gJs = "O bloqueio permitirá apenas atribuições do Directory Sync", hJs = "Atributo editado com sucesso", vJs = "Nova opção de grupo", bJs = "Pesos habilitados", yJs = "Ao habilitar os pesos, será possível atribuir maior prioridade a determinados atributos por usuário. Quanto maior o peso, maior a prioridade.", $Js = "Encaminhado", wJs = "Reatribuído", kJs = "Permitir reagendamento de eventos passados", SJs = "Ativar esta opção permite que eventos passados sejam reagendados", xJs = "Reencaminhado", EJs = "Atribuição do Salesforce", TJs = "Posição do roteador", AJs = "Mostrar hosts correspondentes", CJs = "Não há filas ativas para esta entrada", zJs = "Peso", OJs = "Calibração", PJs = "Déficit", IJs = "Formulário de roteamento", RJs = "Voltar e salvar", NJs = "Salvar alterações", DJs = "Sair sem salvar", MJs = "Tem certeza que deseja sair sem salvar as alterações no seu formulário de roteamento?", LJs = "Algo inesperado aconteceu", qJs = "Você está fazendo um agendamento de teste.", jJs = "Mostruário de ícones", FJs = "Mostruário de ícones", VJs = "Migrando da equipe", BJs = "O recurso está desativado no momento", UJs = "Escolha uma opção", WJs = "Digite o valor da opção", GJs = "Remover opção", HJs = "Usar pesos dos atributos", KJs = "Se ativado, todos os pesos definidos no tipo de evento serão ignorados", YJs = "Atributo para pesos", ZJs = "Usuários gerenciados", QJs = "Veja todos os usuários gerenciados criados pelo seu cliente OAuth", JJs = "Você pode me falar sobre ", XJs = "Use a IA para responder suas perguntas", eXs = "Erro ao buscar resposta ", tXs = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde", nXs = "Selecionar cliente OAuth", oXs = "Em cada instância", rXs = "O recurso de credencial de delegação não está habilitado para sua organização", iXs = "Nota interna", aXs = "Motivo compartilhado com o cliente (opcional)", sXs = "Esta nota será visível apenas para membros da sua equipe", cXs = "Modelos de notas internas de cancelamento", lXs = "Crie modelos de notas internas que podem ser aplicados às reservas", dXs = "Modelos de notas internas atualizados com sucesso", uXs = "Adicionar modelo", _Xs = "Autorizar", pXs = "Próximo", mXs = "Ocultar", fXs = "Mostrar", gXs = "Parâmetros UTM", hXs = "Nenhum parâmetro UTM disponível.", vXs = "Crescente", bXs = "Decrescente", yXs = "Verificar alteração de e-mail", $Xs = "Comprar créditos", wXs = "Créditos", kXs = "Créditos utilizados", SXs = "Total restante", xXs = "Você recebe 1000 créditos por mês, por membro da equipe", EXs = "Você recebe 750 créditos por mês, por membro da equipe", TXs = "Visualizar e gerenciar créditos para envio de mensagens SMS", AXs = "Visualize e gerencie créditos para envio de mensagens SMS. Um crédito vale 1¢ (USD). <0>Saiba mais</0>", CXs = "Um crédito vale 1¢ (USD). <0>Saiba mais</0>", zXs = "Comprar créditos adicionais ($0.01 por crédito)", OXs = "Você pode visualizar gastos de créditos adicionais no seu registro de despesas", PXs = "Visão geral", IXs = "O slug da organização já está em uso", RXs = "Você não pode criar uma organização, pois já faz parte de uma", NXs = "Você precisa concluir a integração do usuário antes de criar uma organização", DXs = "Use o e-mail da empresa para criar uma organização", MXs = "Você não pode criar uma organização de plataforma, pois já faz parte de uma equipe", LXs = "Você precisa ter um número mínimo de equipes publicadas", qXs = "Você já faz parte desta organização", jXs = "Você faz parte de outra organização, não é possível criar uma nova", FXs = "Você faz parte de outra organização da plataforma, não é possível criar uma nova organização", VXs = "Pagamento da organização bem-sucedido", BXs = "Sua organização foi criada com sucesso", UXs = "Isso pode levar alguns segundos...", WXs = "Status de integração da organização", GXs = "Descrição do status de integração da organização", HXs = "Falha no pagamento", KXs = "Seu pagamento falhou. Por favor, tente novamente.", YXs = "Criando sua organização", ZXs = "Integração da organização já concluída", QXs = "Integração da organização já existe", JXs = "Integração da organização não encontrada", XXs = "Pagamento bem-sucedido!", eec = "Transferência de integração", tec = "Transferir integração para o usuário", nec = "Já existe uma organização com este slug", oec = "Você não tem permissão para criar uma organização para este e-mail", rec = "Você não tem permissão para migrar uma ou mais das equipes", iec = "A organização já possui uma assinatura", aec = "Intervalo de reinicialização para Round Robin ponderado", sec = "Intervalo", cec = "Determina com que frequência a contagem de reservas do round robin é reiniciada para garantir uma distribuição equilibrada.", lec = "Diariamente", dec = "Você não definiu uma data de término para sua ausência", uec = "Minha ausência", _ec = "Ausência da equipe", pec = "Gerencie as ausências da sua equipe.", mec = "Criar ausência", fec = "Criar uma ausência para um membro da equipe", gec = "Editar uma ausência para um membro da equipe", hec = "Criar ausência para sua equipe", vec = "Comunique aos agendadores quando os membros da sua equipe não estão disponíveis para receber agendamentos. Eles ainda podem ser agendados após o retorno ou você pode encaminhá-los para outro membro da equipe.", bec = "O encaminhamento de ausência só é permitido para um membro da mesma equipe.", yec = "Já existe um encaminhamento reverso entre esses usuários.", $ec = "Nenhuma ausência anterior encontrada", wec = "Anterior", kec = "Intervalo de Round Robin atualizado com sucesso", Sec = "Modo de teste", xec = "Plano de equipe inativo", Eec = "Seu plano de equipe está inativo. Verifique sua assinatura ou entre em contato com o suporte ao cliente", Tec = "Acesso limitado durante o período de teste. Recurso disponível após o término do teste.", Aec = "Programa de indicação", Cec = "Ganhe 20% de indicação", zec = "Você precisa de uma chave de API Dub e um ID de programa para usar esta página.", Oec = "UID", Pec = "Link", Iec = "linhas por página", Rec = "{{currentRange}} de {{totalItems}}", Nec = "Dica: Você pode adicionar um '+' entre nomes de usuário: cal.com/anna+brian para criar uma reunião de grupo dinâmica", Dec = "Você ainda não tem uma equipe", Mec = "Você ainda não tem membros na equipe", Lec = "Eventos recorrentes não suportam o recurso de assentos. Torne-o não recorrente para habilitar assentos.", qec = "Evento recorrente não suporta o recurso de limite de reservas por agendador. Desative o limite de reservas por agendador para habilitar o evento recorrente.", jec = "O recurso de assentos não suporta eventos recorrentes. Desative o recurso de assentos para torná-lo recorrente.", Fec = "Eventos recorrentes não suportam o recurso de assentos. Desative o recurso de assentos ou torne o evento não recorrente.", Vec = "Segmento", Bec = "Filtros salvos", Uec = "Renomear", Wec = "Renomear segmento", Gec = "Excluir segmento", Hec = "Duplicar segmento", Kec = "Tem certeza que deseja excluir este segmento? Esta ação não pode ser desfeita.", Yec = "Segmento de filtro atualizado", Zec = "Erro ao atualizar segmento de filtro", Qec = "Segmento de filtro duplicado", Jec = "Erro ao duplicar segmento de filtro", Xec = "Segmento de filtro excluído", etc = "Erro ao excluir segmento de filtro", ttc = "Salvar segmento", ntc = "Segmento não encontrado", otc = "Segmento de filtro salvo", rtc = "Sem segmentos", itc = "Erro ao salvar segmento de filtro", atc = 'Salvar substituições para "{{name}}"', stc = "Criar novo segmento", ctc = "Salvar para equipe", ltc = "Selecionar equipe", dtc = "Por favor, selecione uma equipe", utc = "Pessoal", _tc = "Ocultar link do perfil da equipe", ptc = "Ocultar o link do perfil da equipe nas páginas de agendamento", mtc = "Exibir", ftc = "Não foi possível encontrar o slug para publicar a organização", gtc = "Lista de seleção", htc = "Mais cancelamentos", vtc = "Idioma da interface", btc = "Defina seu idioma preferido para a interface de agendamento", ytc = "Idioma do navegador do visitante", $tc = "Nome ou e-mail", wtc = "Se nenhum contato for encontrado, recorrer ao proprietário do lead, se existir", ktc = "Compra de créditos falhou. Tente novamente ou entre em contato com o suporte.", Stc = "Mínimo de 50 créditos necessários", xtc = "Ativar credencial de delegação", Etc = "Conceda ao Cal.com acesso automático aos calendários de todos os membros da organização ativando a credencial de delegação.", Ttc = "Desativar credencial de delegação", Atc = "Uma vez que a credencial de delegação for desativada, os membros da organização que não conectaram seus calendários precisarão fazê-lo manualmente.", Ctc = "Último ativo", ztc = "Membro desde", Otc = "Última atualização", Ptc = "Ao cancelar a reserva, escrever no registro do evento em vez de excluí-lo", Itc = "Em cada cancelamento", Rtc = "Reportar problema", Ntc = "Você pode enviar um ticket no GitHub ou fazer upgrade do seu plano para receber suporte em tempo real com conferências de desenvolvedores", Dtc = "Abrir problema", Mtc = "Este é seu plano atual", Ltc = "Agendar um horário", qtc = "Isso inclui:", jtc = "Cliente OAuth atualizado com sucesso", Ftc = "Cliente OAuth não encontrado.", Vtc = "Assinar a plataforma", Btc = "Erro ao tentar acessar webhooks.", Utc = "Falha ao atualizar webhook.", Wtc = "Falha ao criar webhook.", Gtc = "Link inválido", Htc = "Você está atualmente inscrito no plano {{planFirstLetter}}{{planRest}}", Ktc = "Usuário/Equipe", Ytc = "ID do cliente copiado!", Ztc = "Segredo do cliente copiado!", Qtc = "A equipe do Cal.com está realizando manutenção programada. Se você tiver alguma dúvida, entre em contato com o suporte.", Jtc = "Seu pagamento falhou", Xtc = "Verifique sua caixa de entrada", enc = "Sua conta foi criada, mas seu premium não foi reservado.", tnc = "Enviamos um e-mail para {{email}} com um link para ativar sua conta.", nnc = "Depois de ativar sua conta, você poderá tentar comprar seu nome de usuário premium novamente ou selecionar um diferente.", onc = "Abrir no Gmail", rnc = "Não recebeu um e-mail?", inc = "Reenviar em {{seconds}} segundos", anc = "Reenviar", snc = "E-mail de verificação enviado", cnc = "Selecionar todos os membros", lnc = "Selecionar todos os membros adicionará todos os futuros membros da equipe quando eles forem adicionados à equipe.", dnc = "Configurações do formulário", unc = "Remover status de lista branca", _nc = "Adicionar fluxos de trabalho do usuário à lista branca", pnc = "Fluxos de trabalho do usuário adicionados à lista branca", mnc = "Fluxos de trabalho do usuário removidos da lista branca", fnc = "Data e horário", gnc = "Este é um lembrete sobre seu próximo evento.", hnc = "Este lembrete foi acionado por um Workflow no Cal.", vnc = "Evento", bnc = "Agendado por", ync = "Como foi sua experiência recente?", $nc = "Sempre buscamos melhorar a experiência do cliente.", wnc = "Quão satisfeito você está com sua última reunião?", knc = "não participou da reunião?", Snc = "Reagende aqui.", xnc = "Ocultar e-mail do organizador", Enc = "Você já faz parte de uma organização de plataforma, por isso não pode criar uma nova organização. Cada usuário só pode pertencer a uma organização. Por favor, crie uma nova conta cal.com com um e-mail diferente e use essa conta para assinar o plano de organizações.", Tnc = "Você já faz parte de uma organização, por isso não pode criar uma organização de plataforma. Cada usuário só pode pertencer a uma organização. Por favor, crie uma nova conta cal.com com um e-mail diferente e use essa conta para assinar o plano de plataforma.", Anc = "Ocultar o endereço de e-mail do organizador na tela de agendamento, notificações por e-mail e eventos do calendário", Cnc = "Você &", znc = "Selecione um e-mail verificado", Onc = "Adicionar e-mail verificado", Pnc = "Adicionar e-mails verificados", Inc = "E-mail personalizado para 'Responder a'", Rnc = "Use um endereço de e-mail diferente como resposta para e-mails de confirmação em vez do e-mail do organizador", Nnc = "Esta pesquisa foi acionada por um Workflow no Cal.", Dnc = "Pular período de teste", Mnc = "Períodos de teste da equipe pulados com sucesso", Lnc = "Ao inserir seu número de telefone, você consente em receber mensagens SMS para este evento. Tarifas de SMS podem ser aplicadas.", qnc = "Mais informações podem ser encontradas em <0>Insights de Roteamento</0>", jnc = "Resultados", Fnc = "Visualizar formulário", Vnc = "Envie STOP para cancelar o recebimento de mensagens SMS", Bnc = "Sua equipe {{teamName}} está com poucos créditos", Unc = "Você está com poucos créditos", Wnc = "[Ação necessária] Sua equipe {{teamName}} ficou sem créditos", Gnc = "[Ação necessária] Você ficou sem créditos", Hnc = "Sua equipe Cal.com {{teamName}} está com poucos créditos. Para evitar qualquer interrupção no serviço, compre créditos adicionais. Se seu saldo acabar, as mensagens SMS deixarão de ser enviadas e serão enviadas como e-mails.", Knc = "Sua conta Cal.com está com poucos créditos. Para evitar qualquer interrupção no serviço, compre créditos adicionais. Se seu saldo acabar, as mensagens SMS deixarão de ser enviadas e serão enviadas como e-mails.", Ync = "Sua equipe Cal.com {{teamName}} ficou sem créditos. Como resultado, as mensagens SMS agora estão sendo enviadas por e-mail. Para retomar o envio de SMS, compre créditos adicionais.", Znc = "Sua conta Cal.com ficou sem créditos. Como resultado, as mensagens SMS agora estão sendo enviadas por e-mail. Para retomar o envio de SMS, adquira créditos adicionais.", Qnc = "Saldo atual: {{balance}} créditos", Jnc = "Saldo atual:", Xnc = "Notificação sobre seu agendamento", eoc = "Créditos mensais", toc = "Total de créditos: {{totalCredits}}", noc = "Créditos restantes: {{remainingCredits}}", ooc = "Restante", roc = "Total", ioc = "Créditos adicionais", aoc = "{{count}} próximo na fila", soc = "Enviar respostas por e-mail para", coc = "Agendamentos incompletos", loc = "Incluir agendamentos não comparecidos nos cálculos de round robin", doc = "Participantes recentes que não compareceram", uoc = "Mostra reservas onde todos os participantes não compareceram, não ausências parciais", _oc = "Correspondência", poc = "Redirecionamento de evento", moc = "Redefinir formulário", foc = "Configurações de Round Robin atualizadas com sucesso", goc = "Base de distribuição para Round Robin ponderado", hoc = "Determina qual timestamp do evento é usado como base para a distribuição ponderada do round robin.", voc = "Requer créditos", boc = "Você precisa ter créditos suficientes em sua conta para usar este recurso", yoc = "Créditos disponíveis", $oc = "Criar função", woc = "Funções e permissões", koc = "Gerencie funções e permissões para sua organização", Soc = "Saiba mais sobre como as permissões funcionam", xoc = "Nome da função", Eoc = "Nome da função é obrigatório", Toc = "ex. Equipe de vendas, Equipe de suporte", Aoc = "Descrição da função", Coc = "Descreva para que serve esta função e quais permissões ela precisa", zoc = "Função padrão", Ooc = "Função personalizada", Poc = "Avançado", Ioc = "Buscar permissões", Roc = "Todas as permissões", Noc = "Nenhum", Doc = "Somente leitura", Moc = "Todas as ações em todos os recursos", Loc = "Todos os recursos", qoc = "Tipos de eventos", joc = "Times", Foc = "Organização", Voc = "Reservas", Boc = "Insights", Uoc = "Funções", Woc = "Formulários de Roteamento", Goc = "Fluxos de trabalho", Hoc = "Todas as ações", Koc = "Criar", Yoc = "Visualizar", Zoc = "Editar", Qoc = "Excluir", Joc = "Gerenciar", Xoc = "Convidar", erc = "Remover", trc = "Alterar função do membro", nrc = "Listar membros", orc = "Gerenciar faturamento", rrc = "Visualizar reservas da equipe", irc = "Visualizar reservas da organização", arc = "Ver Gravações", src = "Representar", crc = "Função criada com sucesso", lrc = "Função atualizada com sucesso", drc = "Excluir função", urc = "Tem certeza que deseja excluir a função: {{roleName}}? Esta ação não pode ser desfeita.", _rc = "Função excluída com sucesso", prc = "Erro ao criar função", mrc = "Erro ao atualizar função", frc = "Criar funções", grc = "Atributos", hrc = "Visualizar atributos da organização", vrc = "Atualizar atributos da organização", brc = "Excluir atributos da organização", yrc = "Criar atributos da organização", $rc = "Ver funções", wrc = "Atualizar funções", krc = "Excluir funções", Src = "Criar e configurar novos fluxos de trabalho", xrc = "Configuração necessária", Erc = "Visualizar fluxos de trabalho existentes e suas configurações", Trc = "Editar e modificar configurações de fluxo de trabalho", Arc = "Remover fluxos de trabalho do sistema", Crc = "Webhook", zrc = "Disponibilidade", Orc = "Ausente", Prc = "Criar webhooks", Irc = "Visualizar webhooks", Rrc = "Atualizar webhooks", Nrc = "Excluir webhooks", Drc = "Criar disponibilidade", Mrc = "Visualizar disponibilidade", Lrc = "Atualizar disponibilidade", qrc = "Excluir disponibilidade", jrc = "Criar ausência", Frc = "Visualizar ausência", Vrc = "Atualizar ausência", Brc = "Excluir ausência", Urc = "Acesso completo de gerenciamento a todos os fluxos de trabalho", Wrc = "Criar tipos de eventos", Grc = "Ver tipos de eventos", Hrc = "Atualizar tipos de eventos", Krc = "Excluir tipos de eventos", Yrc = "Todas as ações em tipos de eventos", Zrc = "Criar equipes", Qrc = "Ver detalhes da equipe", Jrc = "Atualizar configurações da equipe", Xrc = "Excluir equipe", eic = "Convidar membros para a equipe", tic = "Remover membros da equipe", nic = "Alterar função dos membros da equipe", oic = "Representar membros da equipe", ric = "Todas as ações em equipes entre as equipes da organização", iic = "Criar organização", aic = "Ver detalhes da organização", sic = "Listar membros da organização", cic = "Convidar membros para a organização", lic = "Remover membros da organização", dic = "Gerenciar faturamento da organização", uic = "Alterar função dos membros da organização", _ic = "Representar membros da organização", pic = "Editar configurações da organização", mic = "Todas as ações em organizações", fic = "Ver reservas", gic = "Ver reservas da equipe", hic = "Ver reservas da organização", vic = "Ver gravações de reservas", bic = "Atualizar reservas", yic = "Todas as ações em reservas", $ic = "Ver insights da equipe", wic = "Gerenciar insights da equipe", kic = "Criar formulários de roteamento", Sic = "Visualizar formulários de roteamento", xic = "Atualizar formulários de roteamento", Eic = "Excluir formulários de roteamento", Tic = "A permissão de leitura é ativada automaticamente ao criar, atualizar ou excluir um recurso", Aic = "Adicionar agenda de restrição", Cic = "Limite a disponibilidade dos anfitriões para exibir apenas horários que se enquadrem em um cronograma específico.", zic = "Usar fuso horário do agendador", Oic = "Aplicar a agenda de restrição selecionada no fuso horário do agendador", Pic = "Isso desativará o Balanceamento de Carga em todos os seus tipos de eventos round robin", Iic = "O Balanceamento de Carga só está disponível quando a base de timestamp está definida como Hora de Criação da Reserva", Ric = "O balanceamento de carga não está disponível com Grupos Round Robin", Nic = "Personalize as configurações padrão de rodízio para esta equipe", Dic = "Configurações de rodízio atualizadas com sucesso", Mic = "Horário de criação do agendamento", Lic = "Horário de início da reunião", qic = "Membros afetados", jic = "Nenhum membro afetado pela desativação da credencial de delegação", Fic = "Baixar registro de despesas", Vic = "Erro ao baixar registro de despesas", Bic = "Oferecer reagendamento da última reserva ativa para o horário escolhido", Uic = "Limite máximo de reservas ativas do agendador excedido", Wic = "Você já tem uma reserva para este evento em {{date}}. Gostaria de reagendar para o novo horário selecionado?", Gic = "A duração deve ser de pelo menos {{min}} minuto(s)", Hic = "A duração não pode exceder {{max}} minutos (24 horas)", Kic = "Reserva fora da disponibilidade do cronograma de restrição.", Yic = "Cronograma de restrição não encontrado", Zic = "Limite de tamanho da imagem excedido, por favor use uma imagem menor preferencialmente em formato JPEG", Qic = "Adicionar grupo", Jic = "Funil de Roteamento", Xic = "Total de Envios", eac = "Roteamentos Bem-sucedidos", tac = "Reservas Aceitas", nac = "Chave de licença", oac = "Escolha sua licença", rac = "Selecione como você deseja licenciar sua implantação do Cal.com", iac = "Use o Cal.com sob a licença de código aberto AGPLv3", aac = "Inserir chave de licença", sac = "Acesso a todos os recursos empresariais", cac = "A partir de $15/usuário por mês", lac = "Acesso a todos os recursos empresariais", dac = "Insira sua chave de licença", uac = "Salvar chave de licença", _ac = "Token de assinatura (opcional)", pac = "O token de assinatura é usado para verificar se a chave de licença é sua ao incrementar o faturamento baseado em uso. Você pode encontrá-lo no e-mail de confirmação de compra. Se você estiver usando uma licença legada, pode deixar este campo em branco.", mac = "Precisa de uma licença?", fac = "A chave de licença é obrigatória", gac = "Chave de licença inválida", hac = "Falha ao validar a chave de licença", vac = "Anexos Opcionais", bac = "Enviar Mensagem", yac = "Descreva o problema", $ac = "Tamanho do arquivo excede o limite", wac = "Tipo de arquivo inválido", kac = "Tipo de arquivo inválido. Tipos aceitos: {{acceptedTypes}}", Sac = "Número máximo de arquivos excedido", xac = "Arquivos enviados com sucesso", Eac = "Tipos aceitos: {{acceptedTypes}}; Tamanho máximo do arquivo: {{maxSize}}", Tac = "Chave de licença salva com sucesso", Aac = "Você está visualizando o relatório com base no fuso horário do seu perfil ({{userTimezone}}), enquanto seu navegador está configurado para o fuso horário ({{browserTimezone}})", Cac = "Horários otimizados", zac = "Organize os horários para otimizar a disponibilidade.", Oac = "Reservas Falhas por Campo", Pac = "Reservas com falha", Iac = "Nenhum anfitrião está atribuído ao tipo de evento", Rac = "Status do Cache", Nac = "Última atualização: {{timestamp}}", Dac = "Excluir dados em cache", Mac = "Cache excluído com sucesso", Lac = "Erro ao excluir cache", qac = "Tem certeza de que deseja excluir os dados em cache? Esta ação não pode ser desfeita.", jac = "Sim, excluir cache", Fac = "{{remainder}} de {{maximum}} usos restantes", Vac = "{{remainder}} de {{maximum}} uso restante", Bac = "Expira em {{date}}, final do dia", Uac = "Uso único", Wac = "Expiração baseada em tempo", Gac = "Expiração baseada em uso", Hac = "Número de usos", Kac = "Expira em", Yac = "Número máximo de usos", Zac = "Configurações do link", Qac = "Este link expirou em {{date}}, final do dia", Jac = "Limite de uso atingido", Xac = "O número máximo de usos deve ser maior que o uso atual", esc = "Este link expirou", tsc = "Este link pode ser usado para agendamentos até o final de {{date}}", nsc = "Este link pode ser configurado para expirar após uma data definida", osc = "Este link pode ser usado para {{count}} agendamento", rsc = "Este link pode ser configurado para expirar após um número definido de agendamentos", isc = "Este link pode ser usado para {{count}} agendamentos", asc = "O nome do evento de gatilho (ex.: BOOKING_CREATED, BOOKING_CANCELLED)", ssc = "O horário do webhook", csc = "O slug do tipo de evento", lsc = "Configurar Agente", dsc = "O nome do tipo de evento", usc = "O horário de início do evento", _sc = "O horário de término do evento", psc = "A descrição do evento conforme descrito nas configurações do tipo de evento", msc = "Local do evento", fsc = "O UID da reserva", gsc = "O UID para reagendamento", hsc = "Motivo do cancelamento", vsc = "Motivo da recusa", bsc = "Nome do organizador", ysc = "Email do organizador", $sc = "Fuso horário do organizador (ex.: 'America/New_York', 'Asia/Kolkata')", wsc = "Idioma do organizador (ex.: 'en', 'fr')", ksc = "Nome de usuário do organizador (ex.: 'john.doe')", Ssc = "Nome de usuário do organizador na organização (ex.: 'john.doe')", xsc = "Nome do primeiro participante", Esc = "Email do primeiro participante", Tsc = "Fuso horário do primeiro participante", Asc = "Idioma do primeiro participante", Csc = "Nome da equipe reservada", zsc = "Membros da equipe reservada", Osc = "URL da videochamada para a reunião", Psc = "Ocultar variáveis", Isc = "Mostrar variáveis disponíveis", Rsc = "Evento e reserva", Nsc = "Pessoas", Dsc = "Times", Msc = "Metadados", Lsc = "Estatísticas", qsc = "Status da reserva", jsc = "Visitar", Fsc = "Rótulo personalizado na página de reserva", Vsc = "Link da reunião", Bsc = "Resultado da Sessão", Usc = "Chamada Criada", Wsc = "Correio de Voz", Gsc = "Minhas reservas", Hsc = "Telefone", Ksc = "Grátis", Ysc = "E-mail do usuário", Zsc = "Nome do usuário", Qsc = "Expandir painel", Jsc = "Recolher painel", Xsc = "A verificação de e-mail é necessária para este tipo de evento", ecc = "Código de verificação fornecido é inválido", tcc = "Você tem uma equipe", ncc = "Considere configurar uma organização para unificar faturamento, ferramentas administrativas e análises em sua equipe.", occ = "Considere configurar uma organização para unificar faturamento, ferramentas administrativas e análises em suas equipes.", rcc = "Mensagem enviada", icc = "Obrigado por entrar em contato conosco. Responderemos o mais breve possível.", acc = "Pesquisar variáveis", scc = "Por favor, descreva o problema que você está enfrentando, por exemplo, 'Horários ocupados estão marcados como disponíveis', ..., etc.", ccc = "Enviar outra mensagem", lcc = "Enviando", dcc = "Nenhuma variável encontrada", ucc = "Créditos necessários", _cc = "Chamadas web consomem créditos. Certifique-se de ter créditos suficientes para iniciar uma chamada.", pcc = "Chamadas web requerem créditos. Você tem 0 créditos restantes.", mcc = "Comprar créditos", fcc = "Esta ação requer créditos para prosseguir", gcc = "O nome não deve exceder {{max}} caracteres", hcc = "Cobrar automaticamente taxa de não comparecimento para cancelamentos de última hora", vcc = "Antes do horário de início agendado", bcc = "Reconheço que, ao cancelar a reserva dentro de {{timeValue}} {{timeUnit}} antes do horário de início, serei cobrado pela taxa de não comparecimento de {{amount, currency}}", ycc = "Se você tiver alguma dúvida, entre em contato com o organizador.", $cc = "Horário da reserva", wcc = "Quando a reserva está agendada (início ao fim)", kcc = "Criado em", Scc = "Quando a reserva foi originalmente criada", xcc = "Detalhes da Chamada", Ecc = "ID da Chamada", Tcc = "Informações da Chamada", Acc = "Sentimento", Ccc = "Motivo da Desconexão", zcc = "Resumo da Chamada", Occ = "Transcrição", Pcc = "Detalhes do Evento", Icc = "Agente", Rcc = "Nenhuma transcrição disponível", Ncc = "Ao testar este fluxo de trabalho, esteja ciente de que as mensagens SMS precisam ser agendadas com pelo menos 15 minutos de antecedência", Dcc = "Começar do zero", Mcc = "Crie seu próprio fluxo de trabalho do zero.", Lcc = "Modelo Cal.ai", qcc = "Agentes de IA que agendam reuniões, enviam lembretes e fazem acompanhamento!", jcc = "Voz", Fcc = "Selecionar voz", Vcc = "Selecione uma voz para seu agente", Bcc = "Escolha uma voz para seu agente", Ucc = "Característica", Wcc = "ID da voz", Gcc = "Usar voz", Hcc = "Voz atual", Kcc = "Configurar agente de entrada", Ycc = "Configure um agente de IA para atender chamadas recebidas em seu número de telefone", Zcc = "Conecte um número de telefone primeiro", Qcc = "Configurar agente para chamadas recebidas", Jcc = "Configurar agente para atender chamadas recebidas", Xcc = "Chamadas recebidas", elc = "Chamadas realizadas", tlc = "Configuração do agente de entrada bem-sucedida", nlc = "Agente de entrada configurado", olc = "Configurar agente de entrada", rlc = "Por favor, selecione um tipo de evento primeiro", ilc = "Editar configuração", alc = "Chamadas recebidas podem agendar apenas um tipo de evento. Selecione o tipo de evento onde as reuniões serão agendadas quando os chamadores alcançarem seu agente.", slc = "Configurar agente de entrada para chamadas recebidas", clc = "↑↑↑↑↑↑↑↑↑↑↑↑↑ Adicione suas novas strings aqui em cima ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑", llc = {
  identity_provider: lrs,
  trial_days_left: drs,
  day_one: urs,
  day_other: _rs,
  second_one: prs,
  second_other: mrs,
  upgrade_now: frs,
  untitled: grs,
  accept_invitation: hrs,
  max_characters: vrs,
  min_characters: brs,
  calcom_explained: yrs,
  calcom_explained_new_user: $rs,
  have_any_questions: wrs,
  reset_password_subject: krs,
  verify_email_subject: Srs,
  verify_email_subject_verifying_email: xrs,
  check_your_email: Ers,
  old_email_address: Trs,
  new_email_address: Ars,
  verify_email_page_body: Crs,
  verify_email_banner_body: zrs,
  verify_email_email_header: Ors,
  verify_email_button: Prs,
  cal_ai_assistant: Irs,
  send_cal_video_transcription_emails: Rrs,
  description_send_cal_video_transcription_emails: Nrs,
  verify_email_change_description: Drs,
  verify_email_change_success_toast: Mrs,
  verify_email_change_failure_toast: Lrs,
  change_of_email: qrs,
  change_of_email_toast: jrs,
  copy_somewhere_safe: Frs,
  verify_email_email_body: Vrs,
  verify_email_by_code_email_body: Brs,
  verify_email_email_link_text: Urs,
  email_verification_code: Wrs,
  email_verification_code_placeholder: Grs,
  incorrect_email_verification_code: Hrs,
  email_sent: Krs,
  email_not_sent: Yrs,
  event_declined_subject: Zrs,
  event_cancelled_subject: Qrs,
  event_reassigned_subject: Jrs,
  event_request_declined: Xrs,
  customize_calvideo_settings: eis,
  calvideo_settings_description: tis,
  disable_recording_for_guests: nis,
  enable_automatic_transcription: ois,
  enable_automatic_recording: ris,
  video_options: iis,
  edit_event: ais,
  view_session_details: sis,
  meeting_session_details: cis,
  meeting_session: lis,
  session_id: dis,
  max_participants: uis,
  unlimited: _is,
  ongoing: pis,
  ended: mis,
  participants: fis,
  anonymous_user: gis,
  session_duration: his,
  no_meeting_sessions_found: vis,
  not_available: bis,
  disable_recording_for_organizer: yis,
  disable_transcription_for_guests: $is,
  disable_transcription_for_organizer: wis,
  event_request_declined_recurring: kis,
  event_request_cancelled: Sis,
  event_request_reassigned: xis,
  event_reassigned_subtitle: Eis,
  organizer: Tis,
  reassigned_to: Ais,
  need_to_reschedule_or_cancel: Cis,
  you_can_view_booking_details_with_this_url: zis,
  no_options_available: Ois,
  cancellation_reason: Pis,
  cancelled_by: Iis,
  cancellation_reason_host: Ris,
  cancellation_reason_placeholder: Nis,
  notify_attendee_cancellation_reason_warning: Dis,
  rejection_reason_placeholder: Mis,
  rejection_reason: Lis,
  rejection_reason_title: qis,
  rejection_reason_description: jis,
  rejection_confirmation: Fis,
  manage_this_event: Vis,
  invite_team_member: Bis,
  invite_team_individual_segment: Uis,
  invite_team_bulk_segment: Wis,
  invite_team_notifcation_badge: Gis,
  your_event_has_been_scheduled: His,
  your_event_has_been_scheduled_recurring: Kis,
  accept_our_license: Yis,
  remove_banner_instructions: Zis,
  error_message: Qis,
  refund_failed_subject: Jis,
  refund_failed: Xis,
  check_with_provider_and_user: eas,
  a_refund_failed: tas,
  awaiting_payment_subject: nas,
  meeting_awaiting_payment: oas,
  dark_theme_contrast_error: ras,
  light_theme_contrast_error: ias,
  event_type_color_light_theme_contrast_error: aas,
  event_type_color_dark_theme_contrast_error: sas,
  payment_not_created_error: cas,
  couldnt_charge_card_error: las,
  no_available_users_found_error: das,
  timeslot_unavailable_book_a_new_time: uas,
  timeslot_unavailable_short: _as,
  just_connected_description: pas,
  unavailable_timeslot_title: mas,
  booking_time_out_of_bounds_error: fas,
  request_body_end_time_internal_error: gas,
  create_calendar_event_error: has,
  update_calendar_event_error: vas,
  delete_calendar_event_error: bas,
  already_signed_up_for_this_booking_error: yas,
  hosts_unavailable_for_booking: $as,
  fixed_hosts_unavailable_for_booking: was,
  round_robin_host_unavailable_for_booking: kas,
  help: Sas,
  price: xas,
  paid: Eas,
  refunded: Tas,
  record: Aas,
  transcribe: Cas,
  payment: zas,
  missing_card_fields: Oas,
  pay_now: Pas,
  general_prompt: Ias,
  transcription_powered_by_ai: Ras,
  start_or_stop_recording: Nas,
  begin_message: Das,
  codebase_has_to_stay_opensource: Mas,
  cannot_repackage_codebase: Las,
  acquire_license: qas,
  terms_summary: jas,
  open_env: Fas,
  env_changed: Vas,
  accept_license: Bas,
  still_waiting_for_approval: Uas,
  event_is_still_waiting: Was,
  no_result_found_for: Gas,
  no_more_results: Has,
  no_results: Kas,
  load_more_results: Yas,
  integration_meeting_id: Zas,
  confirmed_event_type_subject: Qas,
  new_event_request: Jas,
  confirm_or_reject_request: Xas,
  check_bookings_page_to_confirm_or_reject: ess,
  check_in_assistant: tss,
  check_in_assistant_description: nss,
  create_your_own_prompt: oss,
  event_awaiting_approval: rss,
  event_awaiting_approval_recurring: iss,
  someone_requested_an_event: ass,
  someone_requested_password_reset: sss,
  password_reset_email_sent: css,
  password_reset_instructions: lss,
  event_awaiting_approval_subject: dss,
  event_still_awaiting_approval: uss,
  booking_submitted_subject: _ss,
  download_recording_subject: pss,
  download_transcript_email_subject: mss,
  download_your_recording: fss,
  download_your_transcripts: gss,
  your_meeting_has_been_booked: hss,
  event_type_has_been_rescheduled_on_time_date: vss,
  event_type_has_been_updated: bss,
  event_has_been_rescheduled: yss,
  event_has_been_updated: $ss,
  your_event_has_been_rescheduled: wss,
  request_reschedule_subtitle: kss,
  request_reschedule_title_organizer: Sss,
  request_reschedule_subtitle_organizer: xss,
  rescheduled_event_type_subject: Ess,
  requested_to_reschedule_subject_attendee: Tss,
  hi_user_name: Ass,
  ics_event_title: Css,
  please_book_a_time_sometime_later: zss,
  schedule_instead: Oss,
  new_event_subject: Pss,
  join_by_entrypoint: Iss,
  notes: Rss,
  manage_my_bookings: Nss,
  need_to_make_a_change: Dss,
  new_event_scheduled: Mss,
  new_event_scheduled_recurring: Lss,
  invitee_email: qss,
  invitee_timezone: jss,
  time_left: Fss,
  event_type: Vss,
  duplicate_event_type: Bss,
  enter_meeting: Uss,
  video_call_provider: Wss,
  meeting_id: Gss,
  meeting_password: Hss,
  meeting_url: Kss,
  meeting_url_not_found: Yss,
  token_not_found: Zss,
  some_other_host_already_accepted_the_meeting: Qss,
  meeting_request_rejected: Jss,
  rejected_event_type_with_organizer: Xss,
  hi: ecs,
  join_team: tcs,
  manage_this_team: ncs,
  team_info: ocs,
  join_meeting: rcs,
  request_another_invitation_email: ics,
  you_have_been_invited: acs,
  user_invited_you: scs,
  hidden_team_member_title: ccs,
  hidden_team_member_message: lcs,
  hidden_team_owner_message: dcs,
  link_expires: ucs,
  upgrade_to_per_seat: _cs,
  seat_options_doesnt_support_confirmation: pcs,
  multilocation_doesnt_support_seats: mcs,
  no_show_fee_doesnt_support_seats: fcs,
  seats_option_doesnt_support_multi_location: gcs,
  team_upgrade_seats_details: hcs,
  team_upgrade_banner_description: vcs,
  upgrade_banner_action: bcs,
  team_upgraded_successfully: ycs,
  org_upgrade_banner_description: $cs,
  org_upgraded_successfully: wcs,
  use_link_to_reset_password: kcs,
  hey_there: Scs,
  there: xcs,
  forgot_your_password_calcom: Ecs,
  delete_webhook_confirmation_message: Tcs,
  confirm_delete_webhook: Acs,
  edit_webhook: Ccs,
  delete_webhook: zcs,
  webhook_status: Ocs,
  webhook_enabled: Pcs,
  webhook_disabled: Ics,
  webhook_response: Rcs,
  webhook_test: Ncs,
  webhook_update_form: Dcs,
  webhook_update_form_description: Mcs,
  manage_your_webhook: Lcs,
  webhook_created_successfully: qcs,
  webhook_updated_successfully: jcs,
  webhook_removed_successfully: Fcs,
  subscription_needed: Vcs,
  subscription_needed_description: Bcs,
  payload_template: Ucs,
  dismiss: Wcs,
  no_data_yet: Gcs,
  ping_test: Hcs,
  add_to_homescreen: Kcs,
  upcoming: Ycs,
  recurring: Zcs,
  past: Qcs,
  choose_a_file: Jcs,
  upload_image: Xcs,
  upload_target: els,
  no_target: tls,
  slide_zoom_drag_instructions: nls,
  view_notifications: ols,
  view_public_page: rls,
  copy_public_page_link: ils,
  copy_referral_link: als,
  sign_out: sls,
  add_another: cls,
  install_another: lls,
  until: dls,
  powered_by: uls,
  unavailable: _ls,
  set_work_schedule: pls,
  change_bookings_availability: mls,
  select: fls,
  "2fa_confirm_current_password": "Insira a sua senha atual para começar.",
  "2fa_scan_image_or_use_code": "Digitalize a imagem abaixo com o aplicativo autenticador no seu telefone, ou insira o código manualmente.",
  text: gls,
  your_phone_number: hls,
  multiline_text: vls,
  number: bls,
  checkbox: yls,
  is_required: $ls,
  make_field_required: wls,
  required: kls,
  optional: Sls,
  input_type: xls,
  rejected: Els,
  unconfirmed: Tls,
  guests: Als,
  guest: Cls,
  web_conferencing_details_to_follow: zls,
  confirmation: Ols,
  what_booker_should_provide: Pls,
  "404_the_user": "O nome de usuário",
  username: Ils,
  is_still_available: Rls,
  documentation: Nls,
  documentation_description: Dls,
  api_reference: Mls,
  api_reference_description: Lls,
  blog: qls,
  blog_description: jls,
  join_our_community: Fls,
  "404_claim_entity_user": "Obtenha o seu nome de usuário e agende eventos",
  popular_pages: Vls,
  register_now: Bls,
  register: Uls,
  page_doesnt_exist: Wls,
  no_active_phone_number_available: Gls,
  workflow_step_not_configured: Hls,
  check_spelling_mistakes_or_go_back: Kls,
  "404_page_not_found": "404: Não foi possível encontrar esta página.",
  booker_event_not_found: Yls,
  getting_started: Zls,
  "15min_meeting": "Reunião de 15 min",
  "30min_meeting": "Reunião de 30 min",
  secret: Qls,
  leave_blank_to_remove_secret: Jls,
  webhook_secret_key_description: Xls,
  secret_meeting: eds,
  login_instead: tds,
  create_account: nds,
  get_started: ods,
  confirm_password: rds,
  reset_your_password: ids,
  org_banner_instructions: ads,
  email_change: sds,
  create_your_account: cds,
  create_your_calcom_account: lds,
  sign_up: dds,
  youve_been_logged_out: uds,
  hope_to_see_you_soon: _ds,
  logged_out: pds,
  please_try_again_and_contact_us: mds,
  incorrect_2fa_code: fds,
  no_account_exists: gds,
  "2fa_enabled_instructions": "A autenticação de dois fatores está ativada. Por favor, insira o código de seis dígitos do seu aplicativo autenticador.",
  "2fa_enter_six_digit_code": "Insira abaixo o código de seis dígitos do seu aplicativo autenticador.",
  create_an_account: hds,
  dont_have_an_account: vds,
  "2fa_code": "Código de dois fatores",
  sign_in_account: bds,
  sign_in: yds,
  go_back_login: $ds,
  error_during_login: wds,
  request_password_reset: kds,
  send_invite: Sds,
  forgot_password: xds,
  forgot: Eds,
  done: Tds,
  all_done: Ads,
  all: Cds,
  yours: zds,
  available_apps: Ods,
  available_apps_lower_case: Pds,
  available_apps_desc: Ids,
  fixed_host_helper: Rds,
  round_robin_groups_helper: Nds,
  round_robin_helper: Dds,
  check_email_reset_password: Mds,
  finish: Lds,
  organization_general_description: qds,
  few_sentences_about_yourself: jds,
  nearly_there: Fds,
  nearly_there_instructions: Vds,
  set_availability_instructions: Bds,
  set_availability: Uds,
  set_availbility_description: Wds,
  share_a_link_or_embed: Gds,
  share_a_link_or_embed_description: Hds,
  availability_settings: Kds,
  continue_without_calendar: Yds,
  continue_with: Zds,
  connect_your_calendar: Qds,
  connect_your_video_app: Jds,
  connect_your_video_app_instructions: Xds,
  connect_your_calendar_instructions: eus,
  set_up_later: tus,
  current_time: nus,
  details: ous,
  welcome: rus,
  welcome_back: ius,
  welcome_to_calcom: aus,
  welcome_instructions: sus,
  connect_caldav: cus,
  connect_ics_feed: lus,
  connect: dus,
  try_for_free: uus,
  create_booking_link_with_calcom: _us,
  who: pus,
  what: mus,
  when: fus,
  where: gus,
  add_to_calendar: hus,
  add_to_calendar_description: vus,
  add_events_to: bus,
  add_another_calendar: yus,
  other: $us,
  email_sign_in_subject: wus,
  round_robin_emailed_you_and_attendees: kus,
  round_robin_emailed_host_and_attendee: Sus,
  emailed_host_and_attendee: xus,
  emailed_host_and_attendee_recurring: Eus,
  round_robin_emailed_you_and_attendees_recurring: Tus,
  round_robin_emailed_host_and_attendee_recurring: Aus,
  emailed_you_and_any_other_attendees: Cus,
  needs_to_be_confirmed_or_rejected: zus,
  needs_to_be_confirmed_or_rejected_recurring: Ous,
  user_needs_to_confirm_or_reject_booking: Pus,
  user_needs_to_confirm_or_reject_booking_recurring: Ius,
  meeting_is_scheduled: Rus,
  meeting_is_scheduled_recurring: Nus,
  booking_submitted: Dus,
  booking_submitted_recurring: Mus,
  booking_confirmed: Lus,
  booking_confirmed_recurring: qus,
  warning_recurring_event_payment: jus,
  warning_payment_recurring_event: Fus,
  enter_new_password: Vus,
  reset_password: Bus,
  change_your_password: Uus,
  show_password: Wus,
  hide_password: Gus,
  try_again: Hus,
  request_is_expired: Kus,
  reset_instructions: Yus,
  request_is_expired_instructions: Zus,
  whoops: Qus,
  login: Jus,
  success: Xus,
  failed: e_s,
  password_has_been_reset_login: t_s,
  layout: n_s,
  bookerlayout_default_title: o_s,
  bookerlayout_description: r_s,
  bookerlayout_user_settings_title: i_s,
  bookerlayout_user_settings_description: a_s,
  bookerlayout_month_view: s_s,
  bookerlayout_week_view: c_s,
  bookerlayout_column_view: l_s,
  bookerlayout_error_min_one_enabled: d_s,
  bookerlayout_error_default_not_enabled: u_s,
  bookerlayout_error_unknown_layout: __s,
  bookerlayout_override_global_settings: p_s,
  unexpected_error_try_again: m_s,
  sunday_time_error: f_s,
  monday_time_error: g_s,
  tuesday_time_error: h_s,
  wednesday_time_error: v_s,
  thursday_time_error: b_s,
  friday_time_error: y_s,
  saturday_time_error: $_s,
  error_end_time_before_start_time: w_s,
  error_end_time_next_day: k_s,
  back_to_bookings: S_s,
  free_to_pick_another_event_type: x_s,
  cancelled: E_s,
  no_booking: T_s,
  awaiting_host: A_s,
  cancellation_successful: C_s,
  really_cancel_booking: z_s,
  cannot_cancel_booking: O_s,
  reschedule_instead: P_s,
  event_is_in_the_past: I_s,
  cancelling_event_recurring: R_s,
  cancelling_all_recurring: N_s,
  error_with_status_code_occured: D_s,
  error_event_type_url_duplicate: M_s,
  error_event_type_unauthorized_create: L_s,
  error_event_type_unauthorized_update: q_s,
  error_workflow_unauthorized_create: j_s,
  error_schedule_unauthorized_create: F_s,
  booking_already_cancelled: V_s,
  booking_already_accepted_rejected: B_s,
  go_back_home: U_s,
  or_go_back_home: W_s,
  no_meeting_found: G_s,
  no_meeting_found_description: H_s,
  no_status_bookings_yet: K_s,
  no_status_bookings_yet_description: Y_s,
  event_between_users: Z_s,
  bookings: Q_s,
  booking_not_found: J_s,
  bookings_description: X_s,
  upcoming_bookings: eps,
  recurring_bookings: tps,
  past_bookings: nps,
  cancelled_bookings: ops,
  unconfirmed_bookings: rps,
  unconfirmed_bookings_tooltip: ips,
  on: aps,
  and: sps,
  calendar_shows_busy_between: cps,
  troubleshoot: lps,
  troubleshoot_description: dps,
  overview_of_day: ups,
  hover_over_bold_times_tip: _ps,
  start_time: pps,
  end_time: mps,
  buffer_time: fps,
  before_event: gps,
  after_event: hps,
  event_buffer_default: vps,
  buffer: bps,
  your_day_starts_at: yps,
  your_day_ends_at: $ps,
  launch_troubleshooter: wps,
  troubleshoot_availability: kps,
  change_available_times: Sps,
  change_your_available_times: xps,
  change_start_end: Eps,
  change_start_end_buffer: Tps,
  current_start_date: Aps,
  start_end_changed_successfully: Cps,
  and_end_at: zps,
  light: Ops,
  dark: Pps,
  automatically_adjust_theme: Ips,
  user_dynamic_booking_disabled: Rps,
  allow_dynamic_booking_tooltip: Nps,
  allow_dynamic_booking: Dps,
  dynamic_booking: Mps,
  allow_seo_indexing: Lps,
  seo_indexing: qps,
  allow_browser_notifications: jps,
  you_have_denied_notifications: Fps,
  disable_browser_notifications: Vps,
  browser_notifications_turned_on: Bps,
  browser_notifications_turned_off: Ups,
  browser_notifications_denied: Wps,
  please_allow_notifications: Gps,
  push_notifications: Hps,
  push_notifications_description: Kps,
  browser_notifications_not_supported: Yps,
  email: Zps,
  email_placeholder: Qps,
  full_name: Jps,
  browse_api_documentation: Xps,
  leverage_our_api: ems,
  create_webhook: tms,
  instant_meeting: nms,
  booking_cancelled: oms,
  booking_rescheduled: rms,
  recording_ready: ims,
  recording_transcription_generated: ams,
  booking_created: sms,
  booking_rejected: cms,
  booking_requested: lms,
  booking_payment_initiated: dms,
  meeting_ended: ums,
  form_submitted: _ms,
  form_submitted_no_event: pms,
  booking_paid: mms,
  ooo_created: fms,
  booking_no_show_updated: gms,
  event_triggers: hms,
  subscriber_url: vms,
  create_new_webhook: bms,
  webhooks: yms,
  team_webhooks: $ms,
  create_new_webhook_to_account: wms,
  new_webhook: kms,
  receive_cal_meeting_data: Sms,
  receive_cal_event_meeting_data: xms,
  responsive_fullscreen_iframe: Ems,
  loading: Tms,
  deleting: Ams,
  standard_iframe: Cms,
  developer: zms,
  manage_developer_settings: Oms,
  iframe_embed: Pms,
  embed_calcom: Ims,
  integrate_using_embed_or_webhooks: Rms,
  schedule_a_meeting: Nms,
  view_and_manage_billing_details: Dms,
  view_and_edit_billing_details: Mms,
  go_to_billing_portal: Lms,
  need_anything_else: qms,
  further_billing_help: jms,
  contact: Fms,
  our_support_team: Vms,
  contact_our_support_team: Bms,
  uh_oh: Ums,
  no_event_types_have_been_setup: Wms,
  edit_logo: Gms,
  upload_a_logo: Hms,
  upload_logo: Kms,
  remove_logo: Yms,
  enable: Zms,
  code: Qms,
  code_is_incorrect: Jms,
  add_time_availability: Xms,
  add_an_extra_layer_of_security: efs,
  "2fa": "Autenticação de dois fatores",
  "2fa_disabled": "A autenticação de dois fatores pode ser habilitada para autenticação de senha e e-mail",
  enable_2fa: tfs,
  disable_2fa: nfs,
  disable_2fa_recommendation: ofs,
  error_disabling_2fa: rfs,
  error_enabling_2fa: ifs,
  security: afs,
  manage_account_security: sfs,
  password: cfs,
  password_updated_successfully: lfs,
  password_has_been_changed: dfs,
  error_changing_password: ufs,
  session_timeout_changed: _fs,
  session_timeout_change_error: pfs,
  something_went_wrong: mfs,
  something_doesnt_look_right: ffs,
  please_try_again: gfs,
  super_secure_new_password: hfs,
  new_password: vfs,
  your_old_password: bfs,
  current_password: yfs,
  change_password: $fs,
  change_secret: wfs,
  new_password_matches_old_password: kfs,
  forgotten_secret_description: Sfs,
  current_incorrect_password: xfs,
  password_hint_caplow: Efs,
  password_hint_min: Tfs,
  password_hint_admin_min: Afs,
  password_hint_num: Cfs,
  max_limit_allowed_hint: zfs,
  invalid_password_hint: Ofs,
  incorrect_password: Pfs,
  incorrect_email_password: Ifs,
  use_setting: Rfs,
  am_pm: Nfs,
  time_options: Dfs,
  january: Mfs,
  february: Lfs,
  march: qfs,
  april: jfs,
  may: Ffs,
  june: Vfs,
  july: Bfs,
  august: Ufs,
  september: Wfs,
  october: Gfs,
  november: Hfs,
  december: Kfs,
  monday: Yfs,
  tuesday: Zfs,
  wednesday: Qfs,
  thursday: Jfs,
  friday: Xfs,
  saturday: egs,
  sunday: tgs,
  all_booked_today: ngs,
  slots_load_fail: ogs,
  additional_guests: rgs,
  your_name: igs,
  your_full_name: ags,
  no_name: sgs,
  enter_number_between_range: cgs,
  continue_as_guest_description: lgs,
  email_address: dgs,
  enter_valid_email: ugs,
  please_schedule_future_call: _gs,
  location: pgs,
  address: mgs,
  enter_address: fgs,
  in_person_attendee_address: ggs,
  somewhere_else: hgs,
  custom_attendee_location: vgs,
  continue_as_guest: bgs,
  join_as_guest: ygs,
  ideal_for_one_time_calls: $gs,
  any_location: wgs,
  yes: kgs,
  no: Sgs,
  additional_notes: xgs,
  booking_fail: Egs,
  reschedule_fail: Tgs,
  share_additional_notes: Ags,
  booking_confirmation: Cgs,
  booking_reschedule_confirmation: zgs,
  in_person_meeting: Ogs,
  in_person: Pgs,
  link_meeting: Igs,
  phone_number: Rgs,
  attendee_phone_number: Ngs,
  organizer_phone_number: Dgs,
  enter_phone_number: Mgs,
  reschedule: Lgs,
  reschedule_this: qgs,
  book_a_team_member: jgs,
  or: Fgs,
  go_back: Vgs,
  email_or_username: Bgs,
  send_invite_email: Ugs,
  role: Wgs,
  edit_role: Ggs,
  view_role: Hgs,
  edit_team: Kgs,
  editing_user: Ygs,
  editing_org: Zgs,
  edit_or_manage_webhooks: Qgs,
  reject: Jgs,
  reject_all: Xgs,
  accept: ehs,
  leave: ths,
  profile: nhs,
  my_team_url: ohs,
  my_teams: rhs,
  team_name: ihs,
  your_team_name: ahs,
  team_updated_successfully: shs,
  your_team_updated_successfully: chs,
  your_org_updated_successfully: lhs,
  error_copying_to_clipboard: dhs,
  about: uhs,
  team_description: _hs,
  organization_id: phs,
  organization_id_copied: mhs,
  org_description: fhs,
  team_id: ghs,
  team_id_copied: hhs,
  members: vhs,
  organization_members: bhs,
  member: yhs,
  number_member_one: $hs,
  number_member_other: whs,
  number_selected: khs,
  owner: Shs,
  admin: xhs,
  admin_api: Ehs,
  administrator_user: Ths,
  lets_create_first_administrator_user: Ahs,
  admin_user_created: Chs,
  admin_user_created_description: zhs,
  new_member: Ohs,
  invite: Phs,
  add_team_members: Ihs,
  add_org_members: Rhs,
  add_team_members_description: Nhs,
  add_team_member: Dhs,
  invite_new_member: Mhs,
  invite_new_member_description: Lhs,
  invite_new_team_member: qhs,
  upload_csv_file: jhs,
  invite_via_email: Fhs,
  change_member_role: Vhs,
  disable_cal_branding: Bhs,
  disable_cal_branding_description: Uhs,
  hide_book_a_team_member: Whs,
  hide_book_a_team_member_description: Ghs,
  danger_zone: Hhs,
  account_deletion_cannot_be_undone: Khs,
  team_deletion_cannot_be_undone: Yhs,
  back: Zhs,
  cancel: Qhs,
  cancel_all_remaining: Jhs,
  apply: Xhs,
  cancel_event: evs,
  continue: "Continuar",
  confirm: tvs,
  confirm_all: nvs,
  disband_team: ovs,
  disband_team_confirmation_message: rvs,
  disband_org: ivs,
  disband_org_confirmation_message: avs,
  remove_member_confirmation_message: svs,
  confirm_disband_team: cvs,
  confirm_remove_member: lvs,
  confirm_subscription_cancellation: dvs,
  cancel_subscription: uvs,
  cancel_subscription_description: _vs,
  remove_member: pvs,
  manage_your_team: mvs,
  no_teams: fvs,
  no_teams_description: gvs,
  submit: hvs,
  confirm_remove_attribute: vvs,
  remove_attribute: bvs,
  remove_attribute_confirmation_message: yvs,
  delete: "Apagar",
  update: $vs,
  save: wvs,
  pending: kvs,
  open_options: Svs,
  copy_link: xvs,
  share: Evs,
  share_event: Tvs,
  copy_link_team: Avs,
  leave_team: Cvs,
  confirm_leave_team: zvs,
  leave_team_confirmation_message: Ovs,
  user_from_team: Pvs,
  preview: Ivs,
  link_copied: Rvs,
  copied: Nvs,
  private_link_copied: Dvs,
  link_shared: Mvs,
  title: Lvs,
  description: qvs,
  apps_status: jvs,
  quick_video_meeting: Fvs,
  scheduling_type: Vvs,
  preview_team: Bvs,
  collective: Uvs,
  collective_description: Wvs,
  duration: Gvs,
  available_durations: Hvs,
  default_duration: Kvs,
  default_duration_no_options: Yvs,
  multiple_duration_mins: Zvs,
  multiple_duration_timeUnit: Qvs,
  multiple_duration_timeUnit_short: Jvs,
  minutes: Xvs,
  use_cal_ai_to_make_call_description: ebs,
  termination_uri: tbs,
  sip_trunk_username: nbs,
  sip_trunk_password: obs,
  nickname: rbs,
  delete_phone_number: ibs,
  workflow_validation_failed: abs,
  workflow_validation_empty_fields: sbs,
  workflow_validation_unverified_contacts: cbs,
  supercharge_your_workflows_with_cal_ai: lbs,
  supercharge_your_workflows_with_cal_ai_description: dbs,
  phone_number_imported_successfully: ubs,
  phone_number_deleted_successfully: _bs,
  delete_phone_number_confirmation: pbs,
  yes_delete_phone_number: mbs,
  phone_number_info_tooltip: fbs,
  termination_uri_info_tooltip: gbs,
  sip_trunk_username_info_tooltip: hbs,
  sip_trunk_password_info_tooltip: vbs,
  nickname_info_tooltip: bbs,
  save_and_test_call: ybs,
  call_initiated_successfully: $bs,
  please_enter_phone_number: wbs,
  agent_updated_successfully: kbs,
  agent_created_successfully: Sbs,
  agent_event_type_updated_successfully: xbs,
  phone_number_unsubscribed_successfully: Ebs,
  general_prompt_description: Tbs,
  prompt: Abs,
  call_to: Cbs,
  make_test_call_to_verify_configuration: zbs,
  initial_message: Obs,
  initial_message_description: Pbs,
  having_trouble_importing: Ibs,
  learn: Rbs,
  learn_how_to_get_your_terminator: Nbs,
  phone_number_subscription_cancelled_successfully: Dbs,
  updating: Mbs,
  round_robin: Lbs,
  hi_how_are_you_doing: qbs,
  round_robin_description: jbs,
  managed_event: Fbs,
  username_placeholder: Vbs,
  managed_event_description: Bbs,
  managed: Ubs,
  managed_event_url_clarification: Wbs,
  assign_to: Gbs,
  enter_phone_number_to_test_call: Hbs,
  make_test_call: Kbs,
  create_new_workflow_agent: Ybs,
  create_new_workflow_agent_description: Zbs,
  phone_number_for_ai_call: Qbs,
  buy_a_phone_number_or_import_one_you_already_have: Jbs,
  test_agent: Xbs,
  test_web_call: eys,
  phone_numbers: tys,
  unsubscribe: nys,
  delete_workflow_step: oys,
  unsubscribe_phone_number: rys,
  buy_a_new_number: iys,
  only_us_phone_numbers_can_be_purchased_here: ays,
  buy_number_for_x_per_month: sys,
  supported_call_destinations: cys,
  no_phone_number_connected: lys,
  failed_to_get_workflow_step_id: dys,
  cal_ai_agent: uys,
  test_cal_ai_agent: _ys,
  are_you_sure_you_want_to_delete_workflow_step: pys,
  do_you_still_want_to_unsubscribe: mys,
  the_action_will_disconnect_phone_number: fys,
  cal_ai_phone_numbers: gys,
  connect_phone_number: hys,
  cal_ai_phone_numbers_description: vys,
  import_number: bys,
  this_action_will_also: yys,
  import_phone_number: $ys,
  active_subscription: wys,
  cancel_your_phone_number_subscription: kys,
  delete_associated_phone_number: Sys,
  unauthorized_create_workflow: xys,
  import_phone_number_description: Eys,
  phone_number_cost: Tys,
  buy_new_number: Ays,
  buy_number_cost_x_per_month: Cys,
  area_code_optional: zys,
  no_phone_numbers: Oys,
  phone_number_purchased_successfully: Pys,
  cancel_phone_number_subscription: Iys,
  yes_cancel_subscription: Rys,
  cancel_phone_number_subscription_confirmation: Nys,
  add_members: Dys,
  add_members_no_ellipsis: Mys,
  no_assigned_members: Lys,
  assigned_to: qys,
  you_must_be_logged_in_to: jys,
  start_assigning_members_above: Fys,
  locked_fields_admin_description: Vys,
  unlocked_fields_admin_description: Bys,
  locked_fields_member_description: Uys,
  unlocked_fields_member_description: Wys,
  url: Gys,
  hidden: Hys,
  readonly: Kys,
  one_time_link: Yys,
  plan_description: Zys,
  plan_upgrade_invitation: Qys,
  plan_upgrade: Jys,
  plan_upgrade_teams: Xys,
  plan_upgrade_instructions: e$s,
  event_types_page_title: t$s,
  event_types_page_subtitle: n$s,
  new: "Novo",
  new_event_type_btn: o$s,
  new_event_type_heading: r$s,
  new_event_type_description: i$s,
  event_type_created_successfully: a$s,
  event_type_updated_successfully: s$s,
  event_type_deleted_successfully: c$s,
  hours: l$s,
  people: d$s,
  your_email: u$s,
  change_avatar: _$s,
  upload_avatar: p$s,
  language: m$s,
  timezone: f$s,
  first_day_of_week: g$s,
  repeats_up_to_one: h$s,
  repeats_up_to_other: v$s,
  every_for_freq: b$s,
  event_remaining_one: y$s,
  event_remaining_other: $$s,
  repeats_every: w$s,
  occurrence_one: k$s,
  occurrence_other: S$s,
  weekly_one: x$s,
  weekly_other: E$s,
  monthly_one: T$s,
  monthly_other: A$s,
  yearly_one: C$s,
  yearly_other: z$s,
  plus_more: O$s,
  max: P$s,
  single_theme: I$s,
  brand_color: R$s,
  light_brand_color: N$s,
  dark_brand_color: D$s,
  light_event_type_color: M$s,
  dark_event_type_color: L$s,
  file_not_named: q$s,
  create_team: j$s,
  name: F$s,
  nameless_team: V$s,
  oauth_clients: B$s,
  oauth_clients_description: U$s,
  create_oauth_client: W$s,
  create_oauth_client_description: G$s,
  oauth_client_deletion_message: H$s,
  create_new_team_description: K$s,
  create_new_team: Y$s,
  booking_redirect_uri: Z$s,
  booking_cancel_redirect_uri: Q$s,
  booking_reschedule_redirect_uri: J$s,
  booking_conflict_error: X$s,
  open_invitations: ews,
  new_team: tws,
  create_first_team_and_invite_others: nws,
  create_team_to_get_started: ows,
  teams: rws,
  team: iws,
  organization: aws,
  team_billing: sws,
  team_billing_description: cws,
  upgrade_to_flexible_pro_title: lws,
  upgrade_to_flexible_pro_message: dws,
  changed_team_billing_info: uws,
  create_manage_teams_collaborative: _ws,
  only_available_on_pro_plan: pws,
  remove_cal_branding_description: mws,
  edit_profile_info_description: fws,
  change_email_tip: gws,
  little_something_about: hws,
  profile_updated_successfully: vws,
  your_user_profile_updated_successfully: bws,
  your_upgrade_is_here: yws,
  your_upgrade_is_here_description: $ws,
  you_are_all_set: wws,
  you_are_all_set_description: kws,
  user_cannot_found_db: Sws,
  embed_and_webhooks: xws,
  enabled: Ews,
  disabled: Tws,
  disable: Aws,
  billing: Cws,
  here: zws,
  manage_your_billing_info: Ows,
  availability: Pws,
  edit_availability: Iws,
  configure_availability: Rws,
  copy_times_to: Nws,
  copy_times_to_tooltip: Dws,
  change_weekly_schedule: Mws,
  logo: Lws,
  error: qws,
  at_least_characters_one: jws,
  at_least_characters_other: Fws,
  team_logo: Vws,
  add_location: Bws,
  attendees: Uws,
  add_attendees: Wws,
  show_advanced_settings: Gws,
  hide_advanced_settings: Hws,
  event_name: Kws,
  event_name_in_calendar: Yws,
  event_name_tooltip: Zws,
  meeting_with_user: Qws,
  additional_inputs: Jws,
  additional_input_description: Xws,
  label: e0s,
  placeholder: t0s,
  display_add_to_calendar_organizer: n0s,
  display_email_as_organizer: o0s,
  if_enabled_email_address_as_organizer: r0s,
  reconnect_calendar_to_use: i0s,
  type: a0s,
  edit: s0s,
  add_input: c0s,
  disable_notes: l0s,
  disable_notes_description: d0s,
  requires_confirmation_description: u0s,
  requires_confirmation_will_block_slot_description: _0s,
  recurring_event: p0s,
  recurring_event_description: m0s,
  connect_and_join: f0s,
  cannot_be_used_with_paid_event_types: g0s,
  warning_payment_instant_meeting_event: h0s,
  warning_instant_meeting_experimental: v0s,
  starting: b0s,
  disable_guests: y0s,
  disable_guests_description: $0s,
  private_link: w0s,
  enable_private_url: k0s,
  private_link_label: S0s,
  private_link_hint: x0s,
  copy_private_link: E0s,
  copy_private_link_to_event: T0s,
  private_link_description: A0s,
  multiple_private_links_title: C0s,
  multiple_private_links_description: z0s,
  add_a_multiple_private_link: O0s,
  multiple_private_link_copied: P0s,
  invitees_can_schedule: I0s,
  date_range: R0s,
  calendar_days: N0s,
  business_days: D0s,
  set_address_place: M0s,
  set_link_meeting: L0s,
  managed_event_field_parent_control_disabled: q0s,
  cal_invitee_phone_number_scheduling: j0s,
  cal_provide_google_meet_location: F0s,
  cal_provide_zoom_meeting_url: V0s,
  cal_provide_tandem_meeting_url: B0s,
  cal_provide_video_meeting_url: U0s,
  cal_provide_jitsi_meeting_url: W0s,
  cal_provide_huddle01_meeting_url: G0s,
  cal_provide_teams_meeting_url: H0s,
  require_payment: K0s,
  you_need_to_add_a_name: Y0s,
  commission_per_transaction: Z0s,
  event_type_updated_successfully_description: Q0s,
  hide_event_type: J0s,
  edit_location: X0s,
  into_the_future: eks,
  when_booked_with_less_than_notice: tks,
  within_date_range: nks,
  indefinitely_into_future: oks,
  add_new_custom_input_field: rks,
  quick_chat: iks,
  add_new_team_event_type: aks,
  add_new_event_type: sks,
  new_event_type_to_book_description: cks,
  length: lks,
  minimum_booking_notice: dks,
  offset_toggle: uks,
  offset_toggle_description: _ks,
  offset_start: pks,
  offset_start_description: mks,
  slot_interval: fks,
  slot_interval_default: gks,
  delete_event_type: hks,
  delete_managed_event_type: vks,
  delete_event_type_description: bks,
  delete_managed_event_type_description_1: yks,
  delete_managed_event_type_description_2: $ks,
  confirm_delete_event_type: wks,
  delete_account: kks,
  confirm_delete_account: Sks,
  delete_account_confirmation_message: xks,
  integrations: Eks,
  apps: Tks,
  apps_description: Aks,
  apps_listing: Cks,
  category_apps: zks,
  app_store: Oks,
  app_store_description: Pks,
  connect_your_video: Iks,
  settings: Rks,
  event_type_moved_successfully: Nks,
  next_step_text: Dks,
  next_step: Mks,
  prev_step: Lks,
  install: qks,
  start_paid_trial: jks,
  installed: Fks,
  active_install_one: Vks,
  active_install_other: Bks,
  globally_install: Uks,
  app_successfully_installed: Wks,
  app_could_not_be_installed: Gks,
  disconnect: Hks,
  embed_your_calendar: Kks,
  connect_your_favourite_apps: Yks,
  automation: Zks,
  configure_how_your_event_types_interact: Qks,
  toggle_calendars_conflict: Jks,
  connect_additional_calendar: Xks,
  calendar_updated_successfully: e1s,
  check_here: t1s,
  conferencing: n1s,
  calendar: o1s,
  payments: r1s,
  not_installed: i1s,
  error_password_mismatch: a1s,
  error_required_field: s1s,
  status: c1s,
  team_view_user_availability: l1s,
  team_view_user_availability_disabled: d1s,
  set_as_away: u1s,
  set_as_free: _1s,
  toggle_away_error: p1s,
  user_away: m1s,
  user_away_description: f1s,
  meet_people_with_the_same_tokens: g1s,
  only_book_people_and_allow: h1s,
  account_created_with_identity_provider: v1s,
  account_managed_by_identity_provider: b1s,
  account_managed_by_identity_provider_description: y1s,
  account_managed_by_identity_provider_error: $1s,
  user_creation_error: w1s,
  signin_with_google: k1s,
  signin_with_saml: S1s,
  signin_with_saml_oidc: x1s,
  continue_with_email: E1s,
  continue_with_google: T1s,
  last_used: A1s,
  you_will_need_to_generate: C1s,
  import: "Importar",
  import_from: z1s,
  access_token: O1s,
  visit_roadmap: P1s,
  featured_categories: I1s,
  feature_flags: R1s,
  admin_flags_description: N1s,
  popular_categories: D1s,
  number_apps_one: M1s,
  number_apps_other: L1s,
  trending_apps: q1s,
  most_popular: j1s,
  installed_apps: F1s,
  free_to_use_apps: V1s,
  no_category_apps: B1s,
  all_apps: U1s,
  no_category_apps_description_calendar: W1s,
  no_category_apps_description_conferencing: G1s,
  no_category_apps_description_payment: H1s,
  no_category_apps_description_analytics: K1s,
  no_category_apps_description_automation: Y1s,
  no_category_apps_description_other: Z1s,
  no_category_apps_description_messaging: Q1s,
  no_category_apps_description_crm: J1s,
  installed_app_calendar_description: X1s,
  installed_app_payment_description: e2s,
  installed_app_analytics_description: t2s,
  installed_app_other_description: n2s,
  installed_app_conferencing_description: o2s,
  installed_app_automation_description: r2s,
  installed_app_messaging_description: i2s,
  installed_app_crm_description: a2s,
  analytics: s2s,
  empty_installed_apps_headline: c2s,
  empty_installed_apps_description: l2s,
  empty_installed_apps_button: d2s,
  manage_your_connected_apps: u2s,
  browse_apps: _2s,
  features: p2s,
  permissions: m2s,
  terms_and_privacy: f2s,
  published_by: g2s,
  subscribe: h2s,
  buy: v2s,
  install_app: b2s,
  categories: y2s,
  pricing: $2s,
  learn_more: w2s,
  try_now: k2s,
  privacy_policy: S2s,
  terms_of_service: x2s,
  remove: E2s,
  add: T2s,
  installed_other: A2s,
  verify_wallet: C2s,
  create_events_on: z2s,
  enterprise_license: O2s,
  enterprise_license_locally: P2s,
  enterprise_license_sales: I2s,
  missing_license: R2s,
  next_steps: N2s,
  acquire_commercial_license: D2s,
  the_infrastructure_plan: M2s,
  prisma_studio_tip: L2s,
  prisma_studio_tip_description: q2s,
  contact_sales: j2s,
  error_404: F2s,
  default: "Padrão",
  set_to_default: V2s,
  new_schedule_btn: B2s,
  add_new_schedule: U2s,
  add_new_calendar: W2s,
  set_calendar: G2s,
  delete_schedule: H2s,
  delete_schedule_description: K2s,
  schedule_created_successfully: Y2s,
  availability_updated_successfully: Z2s,
  schedule_deleted_successfully: Q2s,
  default_schedule_name: J2s,
  new_schedule_heading: X2s,
  new_schedule_description: eSs,
  requires_ownership_of_a_token: tSs,
  example_name: nSs,
  time_format: oSs,
  "12_hour": "12 horas",
  "24_hour": "24 horas",
  "12_hour_short": "12h",
  "24_hour_short": "24h",
  redirect_success_booking: rSs,
  you_are_being_redirected: iSs,
  external_redirect_url: aSs,
  redirect_url_description: sSs,
  duplicate: cSs,
  offer_seats: lSs,
  offer_seats_description: dSs,
  seats_available_one: uSs,
  seats_available_other: _Ss,
  seats_nearly_full: pSs,
  seats_half_full: mSs,
  number_of_seats: fSs,
  set_instant_meeting_expiry_time_offset_description: gSs,
  enter_number_of_seats: hSs,
  you_can_manage_your_schedules: vSs,
  booking_full: bSs,
  api_keys: ySs,
  api_key: $Ss,
  test_api_key: wSs,
  test_passed: kSs,
  test_failed: SSs,
  provide_api_key: xSs,
  api_key_modal_subtitle: ESs,
  api_key_modal_subtitle_platform: TSs,
  api_keys_subtitle: ASs,
  create_api_key: CSs,
  personal_note: zSs,
  personal_note_placeholder: OSs,
  api_key_no_note: PSs,
  api_key_never_expires: ISs,
  edit_api_key: RSs,
  success_api_key_created: NSs,
  success_api_key_edited: DSs,
  create: MSs,
  success_api_key_created_bold_tagline: LSs,
  you_will_only_view_it_once: qSs,
  copy_to_clipboard: jSs,
  enabled_after_update: FSs,
  enabled_after_update_description: VSs,
  confirm_delete_api_key: BSs,
  disable_rescheduling: USs,
  description_disable_rescheduling: WSs,
  allow_rescheduling_cancelled_bookings: GSs,
  description_allow_rescheduling_cancelled_bookings: HSs,
  disable_cancelling: KSs,
  description_disable_cancelling: YSs,
  revoke_api_key: ZSs,
  api_key_copied: QSs,
  api_key_expires_on: JSs,
  delete_api_key_confirm_title: XSs,
  copy: exs,
  expire_date: txs,
  expired: nxs,
  never_expires: oxs,
  expires: rxs,
  request_reschedule_booking: ixs,
  reason_for_reschedule: axs,
  book_a_new_time: sxs,
  reschedule_request_sent: cxs,
  reschedule_modal_description: lxs,
  reason_for_reschedule_request: dxs,
  send_reschedule_request: uxs,
  edit_booking: _xs,
  reschedule_booking: pxs,
  former_time: mxs,
  confirmation_page_gif: fxs,
  search: gxs,
  impersonate: hxs,
  user_impersonation_heading: vxs,
  user_impersonation_description: bxs,
  team_impersonation_description: yxs,
  cal_signup_description: $xs,
  make_org_private: wxs,
  make_org_private_description: kxs,
  make_team_private: Sxs,
  make_team_private_description: xxs,
  you_cannot_see_team_members: Exs,
  you_cannot_see_teams_of_org: Txs,
  allow_multiple_durations: Axs,
  impersonate_user_tip: Cxs,
  impersonating_user_warning: zxs,
  impersonating_stop_instructions: Oxs,
  event_location_changed: Pxs,
  new_guests_added: Ixs,
  location_changed_event_type_subject: Rxs,
  guests_added_event_type_subject: Nxs,
  current_location: Dxs,
  new_location: Mxs,
  session: Lxs,
  session_description: qxs,
  session_timeout_after: jxs,
  session_timeout: Fxs,
  session_timeout_description: Vxs,
  no_location: Bxs,
  set_location: Uxs,
  update_location: Wxs,
  location_updated: Gxs,
  location_update_failed: Hxs,
  guests_added: Kxs,
  unable_to_add_guests: Yxs,
  email_validation_error: Zxs,
  emails_must_be_unique_valid: Qxs,
  url_validation_error: Jxs,
  place_where_cal_widget_appear: Xxs,
  create_update_react_component: eEs,
  copy_code: tEs,
  code_copied: nEs,
  how_you_want_add_cal_site: oEs,
  choose_ways_put_cal_site: rEs,
  setting_up_zapier: iEs,
  setting_up_make: aEs,
  generate_api_key: sEs,
  generate_api_key_description: cEs,
  your_unique_api_key: lEs,
  copy_safe_api_key: dEs,
  zapier_setup_instructions: uEs,
  make_setup_instructions_1: _Es,
  make_setup_instructions_2: pEs,
  make_setup_instructions_3: mEs,
  make_setup_instructions_4: fEs,
  make_setup_instructions_5: gEs,
  make_setup_instructions_6: hEs,
  install_zapier_app: vEs,
  install_make_app: bEs,
  app_installation: yEs,
  app_not_installed: $Es,
  visit_our_app_store: wEs,
  connect_apple_server: kEs,
  calendar_url: SEs,
  apple_server_generate_password: xEs,
  unable_to_add_apple_calendar: EEs,
  credentials_stored_encrypted: TEs,
  it_stored_encrypted: AEs,
  go_to_app_store: CEs,
  calendar_error: zEs,
  set_your_phone_number: OEs,
  calendar_no_busy_slots: PEs,
  display_location_label: IEs,
  display_location_info_badge: REs,
  add_gif: NEs,
  search_giphy: DEs,
  add_link_from_giphy: MEs,
  add_gif_to_confirmation: LEs,
  find_gif_spice_confirmation: qEs,
  share_feedback: jEs,
  resources: FEs,
  support_documentation: VEs,
  developer_documentation: BEs,
  get_in_touch: UEs,
  contact_support: WEs,
  premium_support: GEs,
  community_support: HEs,
  feedback: KEs,
  submitted_feedback: YEs,
  feedback_error: ZEs,
  comments: QEs,
  booking_details: JEs,
  or_lowercase: XEs,
  nevermind: eTs,
  go_to: tTs,
  zapier_invite_link: nTs,
  meeting_url_provided_after_confirmed: oTs,
  dynamically_display_attendee_or_organizer: rTs,
  event_location: iTs,
  reschedule_optional: aTs,
  reschedule_placeholder: sTs,
  event_cancelled: cTs,
  emailed_information_about_cancelled_event: lTs,
  this_input_will_shown_booking_this_event: dTs,
  meeting_url_in_confirmation_email: uTs,
  url_start_with_https: _Ts,
  number_provided: pTs,
  before_event_trigger: mTs,
  event_cancelled_trigger: fTs,
  after_hosts_cal_video_no_show: gTs,
  after_guests_cal_video_no_show: hTs,
  join_video_call: vTs,
  sign_in_to_cal_com: bTs,
  log_in_to_cal_com: yTs,
  track_your_meetings: $Ts,
  track_meetings_and_manage_schedule: wTs,
  failed_to_join_call: kTs,
  choose_how_you_d_like_to_join_call: STs,
  choose_how_you_d_like_to_appear_on_the_call: xTs,
  new_event_trigger: ETs,
  email_host_action: TTs,
  email_attendee_action: ATs,
  sms_attendee_action: CTs,
  sms_number_action: zTs,
  send_reminder_sms: OTs,
  whatsapp_number_action: PTs,
  whatsapp_attendee_action: ITs,
  workflows: RTs,
  new_workflow_btn: NTs,
  how_would_you_like_to_start: DTs,
  add_new_workflow: MTs,
  reschedule_event_trigger: LTs,
  trigger: qTs,
  triggers: jTs,
  action: FTs,
  workflows_to_automate_notifications: VTs,
  workflow_name: BTs,
  custom_workflow: UTs,
  workflow_created_successfully: WTs,
  delete_workflow_description: GTs,
  delete_workflow: HTs,
  confirm_delete_workflow: KTs,
  workflow_deleted_successfully: YTs,
  how_long_before: ZTs,
  day_timeUnit: QTs,
  hour_timeUnit: JTs,
  minute_timeUnit: XTs,
  minute_short: eAs,
  hour_short: tAs,
  new_workflow_heading: nAs,
  new_workflow_description: oAs,
  active_on: rAs,
  workflow_updated_successfully: iAs,
  premium_to_standard_username_description: aAs,
  premium_username: sAs,
  current: cAs,
  premium: lAs,
  standard: dAs,
  confirm_username_change_dialog_title: uAs,
  change_username_standard_to_premium: _As,
  change_username_premium_to_standard: pAs,
  go_to_stripe_billing: mAs,
  stripe_description: fAs,
  trial_expired: gAs,
  remove_app: hAs,
  yes_remove_app: vAs,
  are_you_sure_you_want_to_remove_this_app: bAs,
  app_removed_successfully: yAs,
  error_removing_app: $As,
  web_conference: wAs,
  web_call: kAs,
  start_web_call: SAs,
  end_call: xAs,
  test_your_agent_with_web_call: EAs,
  phone_call: TAs,
  connecting_to_agent: AAs,
  call_active: CAs,
  call_ended: zAs,
  call_error: OAs,
  ready_to_start_call: PAs,
  failed_to_start_web_call_try_again: IAs,
  call_encountered_error_try_again: RAs,
  failed_initialize_web_call_microphone_permissions: NAs,
  start_call_to_see_conversation: DAs,
  waiting_for_conversation: MAs,
  ai_agent: LAs,
  live: qAs,
  connecting: jAs,
  requires_confirmation: FAs,
  requires_confirmation_threshold: VAs,
  may_require_confirmation: BAs,
  nr_event_type_one: UAs,
  nr_event_type_other: WAs,
  count_team_one: GAs,
  count_team_other: HAs,
  add_action: KAs,
  set_whereby_link: YAs,
  invalid_whereby_link: ZAs,
  set_around_link: QAs,
  invalid_around_link: JAs,
  set_riverside_link: XAs,
  invalid_riverside_link: eCs,
  invalid_ping_link: tCs,
  add_exchange2013: nCs,
  add_exchange2016: oCs,
  custom_template: rCs,
  email_body: iCs,
  text_message: aCs,
  specific_issue: sCs,
  browse_our_docs: cCs,
  choose_template: lCs,
  custom: dCs,
  reminder: uCs,
  rescheduled: _Cs,
  rescheduled_by: pCs,
  original_booking: mCs,
  completed: fCs,
  rating: gCs,
  reminder_email: hCs,
  not_triggering_existing_bookings: vCs,
  minute_one: bCs,
  minute_one_short: yCs,
  minute_other: $Cs,
  hour_one: wCs,
  hour_one_short: kCs,
  hour_other: SCs,
  invalid_input: xCs,
  broken_video_action: ECs,
  broken_calendar_action: TCs,
  attendee_name: ACs,
  scheduler_full_name: CCs,
  broken_integration: zCs,
  problem_adding_video_link: OCs,
  problem_updating_calendar: PCs,
  active_on_event_types_one: ICs,
  active_on_event_types_other: RCs,
  active_on_teams_one: NCs,
  active_on_teams_other: DCs,
  active_on_all_event_types: MCs,
  active_on_all_teams: LCs,
  no_active_event_types: qCs,
  no_active_teams: jCs,
  new_seat_subject: FCs,
  new_seat_title: VCs,
  variable: BCs,
  event_name_variable: UCs,
  attendee_name_variable: WCs,
  event_date_variable: GCs,
  event_time_variable: HCs,
  organizer_name_variable: KCs,
  app_upgrade_description: YCs,
  invalid_number: ZCs,
  invalid_url_error_message: QCs,
  navigate: JCs,
  open: XCs,
  close: ezs,
  upgrade: tzs,
  buy_us_number_button: nzs,
  upgrade_to_access_recordings_title: ozs,
  upgrade_to_access_recordings_description: rzs,
  upgrade_to_cal_ai_phone_number_description: izs,
  recordings_are_part_of_the_teams_plan: azs,
  team_feature_teams: szs,
  team_feature_workflows: czs,
  show_eventtype_on_profile: lzs,
  embed: dzs,
  new_username: uzs,
  current_username: _zs,
  example_1: pzs,
  example_2: mzs,
  booking_question_identifier: fzs,
  company_size: gzs,
  what_help_needed: hzs,
  variable_format: vzs,
  webhook_subscriber_url_reserved: bzs,
  custom_input_as_variable_info: yzs,
  using_booking_questions_as_variables: $zs,
  download_desktop_app: wzs,
  set_ping_link: kzs,
  rate_limit_exceeded: Szs,
  when_something_happens: xzs,
  action_is_performed: Ezs,
  test_action: Tzs,
  notification_sent: Azs,
  no_input: Czs,
  test_workflow_action: zzs,
  send_sms: Ozs,
  send_sms_to_number: Pzs,
  missing_connected_calendar: Izs,
  connect_your_calendar_and_link: Rzs,
  default_calendar_selected: Nzs,
  hide_from_profile: Dzs,
  basics: Mzs,
  availability_not_found_in_schedule_error: Lzs,
  event_limit_tab_title: qzs,
  event_limit_tab_description: jzs,
  event_advanced_tab_description: Fzs,
  event_advanced_tab_title: Vzs,
  event_payments_tab_description: Bzs,
  event_setup_multiple_duration_error: Uzs,
  event_setup_multiple_duration_default_error: Wzs,
  event_setup_booking_limits_error: Gzs,
  event_setup_duration_limits_error: Hzs,
  select_which_cal: Kzs,
  custom_event_name: Yzs,
  custom_event_name_description: Zzs,
  "2fa_required": "Requer autenticação de dois fatores",
  incorrect_2fa: Qzs,
  which_event_type_apply: Jzs,
  apply_to_all_event_types: Xzs,
  apply_to_all_teams: eOs,
  which_team_apply: tOs,
  no_workflows_description: nOs,
  timeformat_profile_hint: oOs,
  create_workflow: rOs,
  do_this: iOs,
  turn_off: aOs,
  turn_on: sOs,
  cancelled_bookings_cannot_be_rescheduled: cOs,
  settings_updated_successfully: lOs,
  error_updating_settings: dOs,
  personal_cal_url: uOs,
  bio_hint: _Os,
  finish_and_start: pOs,
  user_has_no_bio: mOs,
  bio: fOs,
  delete_account_modal_title: gOs,
  confirm_delete_account_modal: hOs,
  delete_my_account: vOs,
  start_of_week: bOs,
  recordings_title: yOs,
  recording: $Os,
  happy_scheduling: wOs,
  select_calendars: kOs,
  check_for_conflicts: SOs,
  view_recordings: xOs,
  check_for_recordings: EOs,
  adding_events_to: TOs,
  follow_system_preferences: AOs,
  custom_brand_colors: COs,
  customize_your_brand_colors: zOs,
  pro: OOs,
  removes_cal_branding: POs,
  instant_meeting_with_title: IOs,
  profile_picture: ROs,
  upload: NOs,
  add_profile_photo: DOs,
  token_address: MOs,
  blockchain: LOs,
  old_password: qOs,
  secure_password: jOs,
  error_updating_password: FOs,
  two_factor_auth: VOs,
  recurring_event_tab_description: BOs,
  today: UOs,
  appearance: WOs,
  my_account: GOs,
  general: HOs,
  calendars: KOs,
  "2fa_auth": "Autenticação de dois fatores",
  invoices: YOs,
  embeds: ZOs,
  impersonation: QOs,
  impersonation_description: JOs,
  recent_impersonations: XOs,
  quick_impersonate: e4s,
  no_recent_impersonations: t4s,
  users: n4s,
  user: o4s,
  profile_description: r4s,
  users_description: i4s,
  users_listing: a4s,
  general_description: s4s,
  calendars_description: c4s,
  appearance_description: l4s,
  conferencing_description: d4s,
  add_conferencing_app: u4s,
  password_description: _4s,
  set_up_two_factor_authentication: p4s,
  we_just_need_basic_info: m4s,
  skip: f4s,
  do_this_later: g4s,
  set_availability_getting_started_subtitle_1: h4s,
  set_availability_getting_started_subtitle_2: v4s,
  connect_calendar_first: b4s,
  complete_profile: y4s,
  connect_calendars_from_app_store: $4s,
  connect_conference_apps: w4s,
  connect_calendar_apps: k4s,
  connect_payment_apps: S4s,
  connect_automation_apps: x4s,
  connect_analytics_apps: E4s,
  connect_other_apps: T4s,
  connect_messaging_apps: A4s,
  connect_crm_apps: C4s,
  current_step_of_total: z4s,
  add_variable: O4s,
  custom_phone_number: P4s,
  message_template: I4s,
  email_subject: R4s,
  add_dynamic_variables: N4s,
  event_name_info: D4s,
  event_date_info: M4s,
  event_duration_info: L4s,
  event_time_info: q4s,
  event_type_not_found: j4s,
  number_to_call_variable: F4s,
  number_to_call_info: V4s,
  location_variable: B4s,
  location_info: U4s,
  additional_notes_variable: W4s,
  additional_notes_info: G4s,
  attendee_name_info: H4s,
  organizer_name_info: K4s,
  to: Y4s,
  workflow_turned_on_successfully: Z4s,
  download_responses: Q4s,
  download_responses_description: J4s,
  view_responses: X4s,
  download: e3s,
  downloading: t3s,
  download_recording: n3s,
  transcription_enabled: o3s,
  transcription_stopped: r3s,
  download_transcript: i3s,
  transcript: a3s,
  recording_from_your_recent_call: s3s,
  transcript_from_previous_call: c3s,
  you_can_download_transcript_from_attachments: l3s,
  link_valid_for_12_hrs: d3s,
  link_valid_for_12_hrs_description: u3s,
  create_your_first_form: _3s,
  create_your_first_form_description: p3s,
  create_your_first_webhook: m3s,
  create_your_first_webhook_description: f3s,
  for_a_maximum_of: g3s,
  event_one: h3s,
  event_other: v3s,
  profile_team_description: b3s,
  profile_org_description: y3s,
  members_team_description: $3s,
  organization_description: w3s,
  team_url: k3s,
  team_members: S3s,
  more: x3s,
  cal_ai_workflows: E3s,
  and_count_more: T3s,
  more_page_footer: A3s,
  workflow_example_1: C3s,
  workflow_example_2: z3s,
  workflow_example_3: O3s,
  workflow_example_4: P3s,
  workflow_example_5: I3s,
  workflow_example_6: R3s,
  send_sms_reminder: N3s,
  send_sms_reminder_description: D3s,
  follow_up_with_no_shows: M3s,
  follow_up_with_no_shows_description: L3s,
  remind_attendees_to_bring_id: q3s,
  remind_attendees_to_bring_id_description: j3s,
  email_to_remind_booking: F3s,
  email_to_remind_booking_description: V3s,
  custom_sms_reminder: B3s,
  custom_sms_reminder_description: U3s,
  custom_email_reminder: W3s,
  custom_email_reminder_description: G3s,
  count_managed_to_limit: H3s,
  welcome_to_cal_header: K3s,
  edit_form_later_subtitle: Y3s,
  connect_calendar_later: Z3s,
  problem_saving_user_profile: Q3s,
  purchase_missing_seats: J3s,
  slot_length: X3s,
  booking_appearance: e6s,
  appearance_team_description: t6s,
  appearance_org_description: n6s,
  only_owner_change: o6s,
  team_disable_cal_branding_description: r6s,
  invited_by_team: i6s,
  token_invalid_expired: a6s,
  view_booking: s6s,
  exchange_add: c6s,
  exchange_authentication: l6s,
  exchange_authentication_standard: d6s,
  exchange_authentication_ntlm: u6s,
  exchange_compression: _6s,
  exchange_version: p6s,
  exchange_version_2007_SP1: m6s,
  exchange_version_2010: f6s,
  exchange_version_2010_SP1: g6s,
  exchange_version_2010_SP2: h6s,
  exchange_version_2013: v6s,
  exchange_version_2013_SP1: b6s,
  exchange_version_2015: y6s,
  exchange_version_2016: $6s,
  routing: w6s,
  routing_forms_description: k6s,
  routing_forms_send_email_owner: S6s,
  routing_forms_send_email_owner_description: x6s,
  routing_forms_send_email_to: E6s,
  add_new_form: T6s,
  add_new_team_form: A6s,
  create_your_first_route: C6s,
  route_to_the_right_person: z6s,
  form: O6s,
  form_description: P6s,
  copy_link_to_form: I6s,
  theme: R6s,
  theme_applies_note: N6s,
  app_theme: D6s,
  app_theme_applies_note: M6s,
  theme_system: L6s,
  add_a_team: q6s,
  add_webhook_description: j6s,
  triggers_when: F6s,
  test_webhook: V6s,
  enable_webhook: B6s,
  add_webhook: U6s,
  webhook_edited_successfully: W6s,
  api_keys_description: G6s,
  new_api_key: H6s,
  active: K6s,
  api_key_updated: Y6s,
  api_key_update_failed: Z6s,
  embeds_title: Q6s,
  embeds_description: J6s,
  create_first_api_key: X6s,
  create_first_api_key_description: e5s,
  back_to_signin: t5s,
  reset_link_sent: n5s,
  password_reset_email: o5s,
  password_reset_leading: r5s,
  password_updated: i5s,
  pending_payment: a5s,
  pending_invites: s5s,
  pending_organization_invites: c5s,
  not_on_cal: l5s,
  no_calendar_installed: d5s,
  no_calendar_installed_description: u5s,
  add_a_calendar: _5s,
  change_email_hint: p5s,
  confirm_password_change_email: m5s,
  seats: f5s,
  every_app_published: g5s,
  report_app: h5s,
  limit_booking_frequency: v5s,
  limit_booking_frequency_description: b5s,
  only_show_first_available_slot: y5s,
  only_show_first_available_slot_description: $5s,
  limit_total_booking_duration: w5s,
  limit_total_booking_duration_description: k5s,
  booker_booking_limit: S5s,
  booker_booking_limit_description: x5s,
  recurring_event_doesnt_support_booker_booking_limit: E5s,
  add_limit: T5s,
  team_name_required: A5s,
  show_attendees: C5s,
  show_available_seats_count: z5s,
  how_booking_questions_as_variables: O5s,
  format: P5s,
  questions: I5s,
  all_info_your_booker_provide: R5s,
  uppercase_for_letters: N5s,
  replace_whitespaces_underscores: D5s,
  platform_members: M5s,
  platform_members_description: L5s,
  platform_billing: q5s,
  manage_billing: j5s,
  manage_billing_description: F5s,
  billing_freeplan_title: V5s,
  billing_freeplan_description: B5s,
  billing_freeplan_cta: U5s,
  billing_portal: W5s,
  billing_help_cta: G5s,
  ignore_special_characters_booking_questions: H5s,
  retry: K5s,
  fetching_calendars_error: Y5s,
  calendar_connection_fail: Z5s,
  booking_confirmation_success: Q5s,
  booking_rejection_success: J5s,
  booking_tentative: X5s,
  booking_accept_intent: ePs,
  we_wont_show_again: tPs,
  couldnt_update_timezone: nPs,
  updated_timezone_to: oPs,
  update_timezone: rPs,
  update_timezone_question: iPs,
  update_timezone_description: aPs,
  dont_update: sPs,
  require_additional_notes: cPs,
  require_additional_notes_description: lPs,
  email_address_action: dPs,
  after_event_trigger: uPs,
  booking_rejected_trigger: _Ps,
  booking_requested_trigger: pPs,
  booking_payment_initiated_trigger: mPs,
  booking_paid_trigger: fPs,
  booking_no_show_updated_trigger: gPs,
  how_long_after: hPs,
  how_long_after_hosts_no_show: vPs,
  how_long_after_guests_no_show: bPs,
  how_long_after_user_no_show_minutes: yPs,
  no_available_slots: $Ps,
  time_available: wPs,
  cant_find_the_right_conferencing_app_visit_our_app_store: kPs,
  install_new_calendar_app: SPs,
  make_phone_number_required: xPs,
  new_event_type_availability: EPs,
  error_editing_availability: TPs,
  dont_have_permission: APs,
  saml_configuration_placeholder: CPs,
  saml_email_required: zPs,
  saml_sp_title: OPs,
  saml_sp_description: PPs,
  saml_sp_acs_url: IPs,
  saml_sp_entity_id: RPs,
  saml_sp_acs_url_copied: NPs,
  saml_sp_entity_id_copied: DPs,
  add_calendar: MPs,
  limit_future_bookings: LPs,
  limit_future_bookings_description: qPs,
  no_event_types: jPs,
  no_event_types_description: FPs,
  billing_frequency: VPs,
  monthly: BPs,
  yearly: UPs,
  checkout: WPs,
  your_team_disbanded_successfully: GPs,
  your_org_disbanded_successfully: HPs,
  error_creating_team: KPs,
  you: YPs,
  or_continue_with: ZPs,
  resend_email: QPs,
  member_already_invited: JPs,
  already_in_use_error: XPs,
  enter_email_or_username: eIs,
  enter_email: tIs,
  enter_emails: nIs,
  too_many_invites: oIs,
  team_name_taken: rIs,
  must_enter_team_name: iIs,
  team_url_required: aIs,
  url_taken: sIs,
  problem_registering_domain: cIs,
  team_publish: lIs,
  number_text_notifications: dIs,
  number_sms_notifications: uIs,
  attendee_email_variable: _Is,
  attendee_email_info: pIs,
  booking_uid: mIs,
  kbar_search_placeholder: fIs,
  invalid_credential: gIs,
  invalid_credential_action: hIs,
  reschedule_reason: vIs,
  choose_common_schedule_team_event: bIs,
  choose_common_schedule_team_event_description: yIs,
  reason: $Is,
  sender_id: wIs,
  sender_id_error_message: kIs,
  test_routing_form: SIs,
  test_preview: xIs,
  route_to: EIs,
  test_preview_description: TIs,
  test_routing: AIs,
  payment_app_disabled: CIs,
  edit_event_type: zIs,
  only_admin_can_see_members_of_org: OIs,
  only_admin_can_manage_sso_org: PIs,
  only_admin_can_manage_directory_sync: IIs,
  only_admin_can_manage_oauth_clients: RIs,
  collective_scheduling: NIs,
  make_it_easy_to_book: DIs,
  find_the_best_person: MIs,
  fixed_round_robin: LIs,
  add_one_fixed_attendee: qIs,
  calcom_is_better_with_team: jIs,
  the_calcom_team: FIs,
  add_your_team_members: VIs,
  booking_limit_reached: BIs,
  duration_limit_reached: UIs,
  admin_has_disabled: WIs,
  disable_attendees_emails_description: GIs,
  disabled_app_affects_event_type: HIs,
  event_replaced_notice: KIs,
  email_subject_slug_replacement: YIs,
  email_body_slug_replacement_notice: ZIs,
  email_body_slug_replacement_info: QIs,
  email_body_slug_replacement_suggestion: JIs,
  disable_payment_app: XIs,
  payment_disabled_still_able_to_book: eRs,
  app_disabled_with_event_type: tRs,
  app_disabled_video: nRs,
  app_disabled_subject: oRs,
  navigate_installed_apps: rRs,
  disabled_calendar: iRs,
  enable_apps: aRs,
  enable_apps_description: sRs,
  purchase_license: cRs,
  already_have_account: lRs,
  already_have_key: dRs,
  already_have_key_suggestion: uRs,
  create_license_key: _Rs,
  app_is_enabled: pRs,
  app_is_disabled: mRs,
  keys_have_been_saved: fRs,
  disable_app: gRs,
  disable_app_description: hRs,
  edit_keys: vRs,
  admin_apps_description: bRs,
  admin_users_description: yRs,
  admin_users_add_description: $Rs,
  admin_users_edit_description: wRs,
  admin_orgs_edit_description: kRs,
  admin_oAuth_description: SRs,
  admin_lockedSMS_description: xRs,
  no_available_apps: ERs,
  no_available_apps_description: TRs,
  no_apps: ARs,
  no_apps_configured: CRs,
  enable_in_settings: zRs,
  please_contact_admin: ORs,
  apps_settings: PRs,
  fill_this_field: IRs,
  options: RRs,
  enter_option: NRs,
  add_an_option: DRs,
  location_already_exists: MRs,
  radio: LRs,
  google_meet_warning: qRs,
  individual: jRs,
  all_bookings_filter_label: FRs,
  all_users_filter_label: VRs,
  all_event_types_filter_label: BRs,
  your_bookings_filter_label: URs,
  meeting_url_variable: WRs,
  meeting_url_info: GRs,
  date_overrides: HRs,
  date_overrides_delete_on_date: KRs,
  date_overrides_subtitle: YRs,
  date_overrides_info: ZRs,
  date_overrides_dialog_which_hours: QRs,
  date_overrides_dialog_which_hours_unavailable: JRs,
  date_overrides_dialog_title: XRs,
  date_overrides_unavailable: eNs,
  date_overrides_mark_all_day_unavailable_one: tNs,
  date_overrides_mark_all_day_unavailable_other: nNs,
  date_overrides_update_btn: oNs,
  date_successfully_added: rNs,
  date_overrides_save_btn: iNs,
  event_type_duplicate_copy_text: aNs,
  set_as_default: sNs,
  hide_eventtype_details: cNs,
  show_navigation: lNs,
  hide_navigation: dNs,
  verification_code_sent: uNs,
  verified_successfully: _Ns,
  wrong_code: pNs,
  not_verified: mNs,
  no_availability_in_month: fNs,
  no_availability_rolling: gNs,
  no_availability_range: hNs,
  view_previous_month: vNs,
  view_next_month: bNs,
  send_code: yNs,
  number_verified: $Ns,
  create_your_first_team_webhook_description: wNs,
  create_webhook_team_event_type: kNs,
  disable_success_page: SNs,
  invalid_admin_password: xNs,
  change_password_admin: ENs,
  username_already_taken: TNs,
  assignment: ANs,
  fixed_hosts: CNs,
  add_fixed_hosts: zNs,
  round_robin_hosts: ONs,
  minimum_round_robin_hosts_count: PNs,
  hosts: INs,
  upgrade_to_enable_feature: RNs,
  orgs_upgrade_to_enable_feature: NNs,
  new_attendee: DNs,
  awaiting_approval: MNs,
  requires_google_calendar: LNs,
  event_type_requires_google_calendar: qNs,
  connected_google_calendar: jNs,
  using_meet_requires_calendar: FNs,
  continue_to_install_google_calendar: VNs,
  install_google_meet: BNs,
  install_google_calendar: UNs,
  sender_name: WNs,
  already_invited: GNs,
  no_recordings_found: HNs,
  new_workflow_subtitle: KNs,
  reporting: YNs,
  reporting_feature: ZNs,
  teams_plan_required: QNs,
  routing_forms_are_a_great_way: JNs,
  choose_a_license: XNs,
  choose_license_description: eDs,
  license: tDs,
  agplv3_license: nDs,
  no_need_to_keep_your_code_open_source: oDs,
  repackage_rebrand_resell: rDs,
  a_vast_suite_of_enterprise_features: iDs,
  free_license_fee: aDs,
  forever_open_and_free: sDs,
  required_to_keep_your_code_open_source: cDs,
  cannot_repackage_and_resell: lDs,
  no_enterprise_features: dDs,
  step_enterprise_license: uDs,
  step_enterprise_license_description: _Ds,
  setup: pDs,
  setup_description: mDs,
  configure: fDs,
  sso_configuration: gDs,
  sso_configuration_description: hDs,
  sso_configuration_description_orgs: vDs,
  sso_oidc_heading: bDs,
  sso_oidc_description: yDs,
  sso_oidc_configuration_title: $Ds,
  sso_oidc_configuration_description: wDs,
  sso_oidc_callback_copied: kDs,
  sso_saml_heading: SDs,
  sso_saml_description: xDs,
  sso_saml_configuration_title: EDs,
  sso_saml_configuration_description: TDs,
  sso_saml_acsurl_copied: ADs,
  sso_saml_entityid_copied: CDs,
  sso_connection_created_successfully: zDs,
  sso_connection_deleted_successfully: ODs,
  delete_sso_configuration: PDs,
  delete_sso_configuration_confirmation: IDs,
  delete_sso_configuration_confirmation_description: RDs,
  organizer_timezone: NDs,
  email_user_cta: DDs,
  accept_invite: MDs,
  join_now: LDs,
  successfully_joined: qDs,
  email_no_user_invite_heading_subteam: jDs,
  email_no_user_invite_heading_org: FDs,
  email_no_user_invite_subheading: VDs,
  email_user_invite_subheading_subteam: BDs,
  email_user_invite_subheading_org: UDs,
  email_no_user_invite_steps_intro: WDs,
  email_no_user_step_one: GDs,
  email_no_user_step_two: HDs,
  email_no_user_step_three: KDs,
  email_no_user_step_four: YDs,
  email_no_user_signoff: ZDs,
  impersonation_user_tip: QDs,
  available_variables: JDs,
  scheduler: XDs,
  no_workflows: eMs,
  change_filter: tMs,
  change_filter_common: nMs,
  no_results_for_filter: oMs,
  recommended_next_steps: rMs,
  create_a_managed_event: iMs,
  meetings_are_better_with_the_right: aMs,
  create_a_one_one_template: sMs,
  collective_or_roundrobin: cMs,
  book_your_team_members: lMs,
  event_no_longer_attending_subject: dMs,
  no_longer_attending: uMs,
  attendee_no_longer_attending_subject: _Ms,
  attendee_no_longer_attending: pMs,
  attendee_no_longer_attending_subtitle: mMs,
  create_event_on: fMs,
  create_routing_form_on: gMs,
  default_app_link_title: hMs,
  default_app_link_description: vMs,
  organizer_default_conferencing_app: bMs,
  organizer_default_conferencing_app_not_found: yMs,
  under_maintenance: $Ms,
  under_maintenance_description: wMs,
  event_type_seats: kMs,
  booking_questions_title: SMs,
  booking_questions_description: xMs,
  add_a_booking_question: EMs,
  identifier: TMs,
  duplicate_email: AMs,
  enter_redirect_url_on_exit_description: CMs,
  booking_with_payment_cancelled: zMs,
  booking_with_payment_cancelled_already_paid: OMs,
  booking_with_payment_cancelled_refunded: PMs,
  booking_with_payment_cancelled_no_refund: IMs,
  booking_with_payment_cancelled_refund_window_expired: RMs,
  booking_confirmation_failed: NMs,
  not_enough_seats: DMs,
  form_builder_field_already_exists: MMs,
  guests_field_must_be_multiemail: LMs,
  show_on_booking_page: qMs,
  visit_cancelled_booking: jMs,
  get_started_zapier_templates: FMs,
  standard_templates: VMs,
  cal_ai_templates: BMs,
  team_is_unpublished: UMs,
  org_is_unpublished_description: WMs,
  team_is_unpublished_description: GMs,
  team_member: HMs,
  a_routing_form: KMs,
  form_description_placeholder: YMs,
  keep_me_connected_with_form: ZMs,
  fields_in_form_duplicated: QMs,
  form_deleted: JMs,
  delete_form: XMs,
  delete_form_action: eLs,
  delete_form_confirmation: tLs,
  delete_form_confirmation_2: nLs,
  typeform_redirect_url_copied: oLs,
  modifications_in_fields_warning: rLs,
  connected_forms: iLs,
  form_modifications_warning: aLs,
  responses_collection_waiting_description: sLs,
  this_is_what_your_users_would_see: cLs,
  identifies_name_field: lLs,
  add_1_option_per_line: dLs,
  select_a_router: uLs,
  add_a_new_route: _Ls,
  make_informed_decisions: pLs,
  make_informed_decisions_description: mLs,
  view_bookings_across: fLs,
  view_bookings_across_description: gLs,
  identify_booking_trends: hLs,
  identify_booking_trends_description: vLs,
  spot_popular_event_types: bLs,
  spot_popular_event_types_description: yLs,
  no_responses_yet: $Ls,
  no_routes_defined: wLs,
  this_will_be_the_placeholder: kLs,
  error_booking_event: SLs,
  timeslot_missing_title: xLs,
  timeslot_missing_description: ELs,
  timeslot_missing_cta: TLs,
  switch_monthly: ALs,
  switch_weekly: CLs,
  switch_multiday: zLs,
  switch_columnview: OLs,
  num_locations: PLs,
  select_on_next_step: ILs,
  this_meeting_has_not_started_yet: RLs,
  this_app_requires_connected_account: NLs,
  connect_app: DLs,
  app_is_connected: MLs,
  requires_app: LLs,
  verification_code: qLs,
  can_you_try_again: jLs,
  verify: FLs,
  timezone_info: VLs,
  timezone_variable: BLs,
  event_end_time_variable: ULs,
  event_end_time_info: WLs,
  cancel_url_variable: GLs,
  cancel_url_info: HLs,
  cancel_reason_variable: KLs,
  cancel_reason_info: YLs,
  reschedule_url_variable: ZLs,
  reschedule_url_info: QLs,
  reschedule_reason_variable: JLs,
  reschedule_reason_info: XLs,
  invalid_event_name_variables: eqs,
  select_all: tqs,
  default_conferencing_bulk_title: nqs,
  members_default_schedule: oqs,
  set_by_admin: rqs,
  members_default_location: iqs,
  members_default_schedule_description: aqs,
  requires_at_least_one_schedule: sqs,
  default_conferencing_bulk_description: cqs,
  default_schedules_bulk_description: lqs,
  locked_for_members: dqs,
  unlocked_for_members: uqs,
  apps_locked_for_members_description: _qs,
  apps_unlocked_for_members_description: pqs,
  apps_locked_by_team_admins_description: mqs,
  apps_unlocked_by_team_admins_description: fqs,
  workflows_locked_for_members_description: gqs,
  workflows_unlocked_for_members_description: hqs,
  workflows_locked_by_team_admins_description: vqs,
  workflows_unlocked_by_team_admins_description: bqs,
  webhooks_locked_for_members_description: yqs,
  webhooks_unlocked_for_members_description: $qs,
  webhooks_locked_by_team_admins_description: wqs,
  webhooks_unlocked_by_team_admins_description: kqs,
  locked_by_team_admin: Sqs,
  app_not_connected: xqs,
  connect_now: Eqs,
  managed_event_dialog_confirm_button_one: Tqs,
  managed_event_dialog_confirm_button_other: Aqs,
  managed_event_dialog_title_one: Cqs,
  managed_event_dialog_title_other: zqs,
  managed_event_dialog_information_one: Oqs,
  managed_event_dialog_information_other: Pqs,
  managed_event_dialog_clarification: Iqs,
  review_event_type: Rqs,
  looking_for_more_analytics: Nqs,
  looking_for_more_insights: Dqs,
  filters: Mqs,
  filter: Lqs,
  add_a_member: qqs,
  add_filter: jqs,
  add_rule: Fqs,
  add_rule_group: Vqs,
  remove_filters: Bqs,
  email_verified: Uqs,
  select_user: Wqs,
  select_event_type: Gqs,
  select_date_range: Hqs,
  popular_events: Kqs,
  no_event_types_found: Yqs,
  average_event_duration: Zqs,
  bookings_by_hour: Qqs,
  most_booked_members: Jqs,
  least_booked_members: Xqs,
  most_bookings_scheduled: e9s,
  least_bookings_scheduled: t9s,
  most_bookings_completed: n9s,
  least_bookings_completed: o9s,
  events_created: r9s,
  events_completed: i9s,
  events_cancelled: a9s,
  events_rescheduled: s9s,
  events: c9s,
  performance: l9s,
  from_last_period: d9s,
  from_to_date_period: u9s,
  redirect_url_warning: _9s,
  event_trends: p9s,
  clear_filters: m9s,
  clear: f9s,
  hold: g9s,
  on_booking_option: h9s,
  hold_option: v9s,
  card_held: b9s,
  charge_card: y9s,
  card_charged: $9s,
  no_show_fee_amount: w9s,
  no_show_fee: k9s,
  submit_card: S9s,
  submit_payment_information: x9s,
  meeting_awaiting_payment_method: E9s,
  no_show_fee_charged_email_subject: T9s,
  no_show_fee_charged_text_body: A9s,
  no_show_fee_charged_subtitle: C9s,
  error_charging_card: z9s,
  collect_no_show_fee: O9s,
  no_show_fee_charged: P9s,
  your_card_was_declined: I9s,
  your_card_does_not_support_this_type_of_purchase: R9s,
  amount_must_convert_to_at_least: N9s,
  could_not_charge_card: D9s,
  insights: M9s,
  routing_forms: L9s,
  insights_no_data_found_for_filter: q9s,
  acknowledge_booking_no_show_fee: j9s,
  days: F9s,
  card_details: V9s,
  something_went_wrong_on_our_end: B9s,
  please_provide_following_text_to_suppport: U9s,
  seats_and_no_show_fee_error: W9s,
  complete_your_booking: G9s,
  complete_your_booking_subject: H9s,
  confirm_your_details: K9s,
  copy_invite_link: Y9s,
  edit_invite_link: Z9s,
  invite_link_copied: Q9s,
  invite_link_deleted: J9s,
  api_key_deleted: X9s,
  delete_api_key_warning: ejs,
  invite_link_updated: tjs,
  link_expires_after: njs,
  one_day: ojs,
  seven_days: rjs,
  thirty_days: ijs,
  three_months: ajs,
  one_year: sjs,
  team_invite_received: cjs,
  currency_string: ljs,
  charge_card_dialog_body: djs,
  charge_attendee: ujs,
  payment_app_commission: _js,
  email_invite_team: pjs,
  email_invite_team_bulk: mjs,
  error_collecting_card: fjs,
  image_size_limit_exceed: gjs,
  unauthorized_workflow_error_message: hjs,
  inline_embed: vjs,
  load_inline_content: bjs,
  floating_pop_up_button: yjs,
  floating_button_trigger_modal: $js,
  pop_up_element_click: wjs,
  open_dialog_with_element_click: kjs,
  use_my_own_form: Sjs,
  use_our_headless_routing_api: xjs,
  need_help_embedding: Ejs,
  book_my_cal: Tjs,
  first_name: Ajs,
  last_name: Cjs,
  first_last_name: zjs,
  invite_as: Ojs,
  form_updated_successfully: Pjs,
  disable_attendees_confirmation_emails: Ijs,
  disable_attendees_confirmation_emails_description: Rjs,
  disable_host_confirmation_emails: Njs,
  disable_host_confirmation_emails_description: Djs,
  add_an_override: Mjs,
  import_from_google_workspace: Ljs,
  connect_google_workspace: qjs,
  google_workspace_admin_tooltip: jjs,
  first_event_type_webhook_description: Fjs,
  create_instant_meeting_webhook_description: Vjs,
  install_app_on: Bjs,
  create_for: Ujs,
  currency: Wjs,
  organization_banner_description: Gjs,
  organization_banner_title: Hjs,
  set_up_your_organization: Kjs,
  set_up_your_platform_organization: Yjs,
  organizations_description: Zjs,
  plans: Qjs,
  platform: Jjs,
  platform_description: Xjs,
  platform_organization_description: eFs,
  must_enter_organization_name: tFs,
  must_enter_organization_admin_email: nFs,
  admin_email: oFs,
  platform_admin_email: rFs,
  admin_username: iFs,
  organization_name: aFs,
  platform_name: sFs,
  organization_url: cFs,
  organization_verify_header: lFs,
  organization_verify_email_body: dFs,
  additional_url_parameters: uFs,
  about_your_organization: _Fs,
  about_your_organization_description: pFs,
  create_your_teams: mFs,
  create_your_teams_description: fFs,
  invite_organization_admins: gFs,
  invite_organization_admins_description: hFs,
  set_a_password: vFs,
  set_a_password_description: bFs,
  organization_logo: yFs,
  organization_about_description: $Fs,
  ill_do_this_later: wFs,
  verify_your_email: kFs,
  enter_digit_code: SFs,
  verify_email_organization: xFs,
  code_provided_invalid: EFs,
  email_already_used: TFs,
  organization_admin_invited_heading: AFs,
  organization_admin_invited_body: CFs,
  duplicated_slugs_warning: zFs,
  team_names_empty: OFs,
  team_names_repeated: PFs,
  user_belongs_organization: IFs,
  org_no_teams_yet: RFs,
  org_no_teams_yet_description: NFs,
  set_up: DFs,
  my_profile: MFs,
  my_settings: LFs,
  crm: qFs,
  messaging: jFs,
  sender_id_info: FFs,
  org_admins_can_create_new_teams: VFs,
  google_new_spam_policy: BFs,
  resolve: UFs,
  no_organization_slug: WFs,
  copy_link_org: GFs,
  "404_the_org": "A organização",
  "404_the_team": "A equipe",
  "404_claim_entity_org": "Solicite o subdomínio para a sua organização",
  "404_claim_entity_team": "Solicite esta equipe e comece a gerenciar agendamentos coletivamente",
  insights_team_filter: HFs,
  insights_user_filter: KFs,
  insights_subtitle: YFs,
  call_history: ZFs,
  call_history_subtitle: QFs,
  location_options: JFs,
  channel_type: XFs,
  end_reason: e8s,
  session_status: t8s,
  user_sentiment: n8s,
  time_header: o8s,
  from_header: r8s,
  custom_plan: i8s,
  email_embed: a8s,
  add_times_to_your_email: s8s,
  select_time: c8s,
  select_date: l8s,
  only_show_if_parameter_set: d8s,
  add_parameter: u8s,
  connecting_you_to_someone: _8s,
  please_do_not_close_this_tab: p8s,
  see_all_available_times: m8s,
  org_team_names_example_1: f8s,
  org_team_names_example_2: g8s,
  org_team_names_example_3: h8s,
  org_team_names_example_4: v8s,
  org_team_names_example_5: b8s,
  org_max_team_warnings: y8s,
  what_is_this_meeting_about: $8s,
  add_to_team: w8s,
  remove_users_from_org: k8s,
  delegation_credential: S8s,
  delegation_credential_description: x8s,
  add_client_id_in_google_workspace_with_below_scope: E8s,
  delegation_credential_enabled: T8s,
  add_delegation_credential: A8s,
  edit_delegation_credential: C8s,
  domain: z8s,
  no_workspace_platforms: O8s,
  workspace_platform: P8s,
  workspace_platforms: I8s,
  workspace_platforms_description: R8s,
  edit_workspace_platform: N8s,
  edit_service_account: D8s,
  add_workspace_platform: M8s,
  slug: L8s,
  service_account_key: q8s,
  edit_service_account_key: j8s,
  delegation_credential_restricts_adding_more_than_one_installation: F8s,
  app_successfully_installed_and_is_using_delegated_credentials: V8s,
  remove_users_from_org_confirm: B8s,
  remove_users_from_team: U8s,
  remove_users_from_team_confirm: W8s,
  user_has_no_schedules: G8s,
  user_isnt_in_any_teams: H8s,
  user_has_no_app_installed: K8s,
  requires_booker_email_verification: Y8s,
  description_requires_booker_email_verification: Z8s,
  requires_confirmation_mandatory: Q8s,
  organizations: J8s,
  upload_cal_video_logo: X8s,
  update_cal_video_logo: e7s,
  upload_banner: t7s,
  cal_video_logo_upload_instruction: n7s,
  org_admin_other_teams: o7s,
  org_admin_other_teams_description: r7s,
  not_part_of_org: i7s,
  no_other_teams_found: a7s,
  no_other_teams_found_description: s7s,
  attendee_first_name_variable: c7s,
  attendee_last_name_variable: l7s,
  attendee_first_name_info: d7s,
  attendee_last_name_info: u7s,
  your_monthly_digest: _7s,
  member_name: p7s,
  most_popular_events: m7s,
  summary_of_events_for_your_team_for_the_last_30_days: f7s,
  me: g7s,
  meeting_unavailable: h7s,
  monthly_digest_email: v7s,
  monthly_digest_email_for_teams: b7s,
  verify_team_tooltip: y7s,
  member_removed: $7s,
  my_availability: w7s,
  team_availability: k7s,
  instant_meeting_availability: S7s,
  backup_code: x7s,
  backup_codes: E7s,
  backup_code_instructions: T7s,
  backup_codes_copied: A7s,
  incorrect_backup_code: C7s,
  lost_access: z7s,
  missing_backup_codes: O7s,
  admin_org_notification_email_subject: P7s,
  hi_admin: I7s,
  admin_org_notification_email_title: R7s,
  admin_org_notification_email_body_part1: N7s,
  admin_org_notification_email_body_part2: D7s,
  admin_org_notification_email_body_part3: M7s,
  admin_org_notification_email_cta: L7s,
  org_has_been_processed: q7s,
  org_error_processing: j7s,
  orgs_page_description: F7s,
  unverified: V7s,
  verified: B7s,
  dns_missing: U7s,
  dns_configured: W7s,
  mark_dns_configured: G7s,
  value: H7s,
  your_organization_updated_sucessfully: K7s,
  team_no_event_types: Y7s,
  seat_options_doesnt_multiple_durations: Z7s,
  include_calendar_event: Q7s,
  oAuth: J7s,
  oAuth_client_creation_form: X7s,
  oAuth_client_creation_form_description: eVs,
  oAuth_client_updation_form: tVs,
  oAuth_client_updation_form_description: nVs,
  recently_added: oVs,
  connect_all_calendars: rVs,
  connect_all_calendars_description: iVs,
  workflow_automation_description: aVs,
  scheduling_for_your_team: sVs,
  scheduling_for_your_team_description: cVs,
  no_members_found: lVs,
  directory_sync: dVs,
  directory_name: uVs,
  directory_provider: _Vs,
  directory_scim_url: pVs,
  directory_scim_token: mVs,
  directory_scim_url_copied: fVs,
  directory_scim_token_copied: gVs,
  directory_sync_info_description: hVs,
  directory_sync_configure: vVs,
  directory_sync_configure_description: bVs,
  directory_sync_title: yVs,
  directory_sync_created: $Vs,
  directory_sync_description: wVs,
  directory_sync_deleted: kVs,
  directory_sync_delete_connection: SVs,
  directory_sync_delete_title: xVs,
  directory_sync_delete_description: EVs,
  directory_sync_delete_confirmation: TVs,
  event_setup_length_error: AVs,
  availability_schedules: CVs,
  unauthorized: zVs,
  access_cal_account: OVs,
  select_account_team: PVs,
  allow_client_to: IVs,
  associate_with_cal_account: RVs,
  see_personal_info: NVs,
  see_primary_email_address: DVs,
  connect_installed_apps: MVs,
  access_event_type: LVs,
  access_availability: qVs,
  access_bookings: jVs,
  allow_client_to_do: FVs,
  oauth_access_information: VVs,
  allow: BVs,
  view_only_edit_availability_not_onboarded: UVs,
  view_only_edit_availability: WVs,
  you_can_override_calendar_in_advanced_tab: GVs,
  edit_users_availability: HVs,
  resend_invitation: KVs,
  invitation_resent: YVs,
  saml_sso: ZVs,
  add_client: QVs,
  copy_client_secret_info: JVs,
  add_new_client: XVs,
  add_new_user: eBs,
  this_app_is_not_setup_already: tBs,
  as_csv: nBs,
  overlay_my_calendar: oBs,
  overlay_my_calendar_toc: rBs,
  view_overlay_calendar_events: iBs,
  join_event_location: aBs,
  troubleshooting: sBs,
  calendars_were_checking_for_conflicts: cBs,
  availabilty_schedules: lBs,
  manage_calendars: dBs,
  manage_availability_schedules: uBs,
  locked: _Bs,
  unlocked: pBs,
  lock_timezone_toggle_on_booking_page: mBs,
  description_lock_timezone_toggle_on_booking_page: fBs,
  event_setup_multiple_payment_apps_error: gBs,
  number_in_international_format: hBs,
  install_calendar: vBs,
  branded_subdomain: bBs,
  branded_subdomain_description: yBs,
  org_insights: $Bs,
  org_insights_description: wBs,
  extensive_whitelabeling: kBs,
  extensive_whitelabeling_description: SBs,
  unlimited_teams: xBs,
  verify_email: EBs,
  proceed_with_cancellation_description: TBs,
  proceed_with_cancellation_error: ABs,
  unlimited_teams_description: CBs,
  unified_billing: zBs,
  advanced_managed_events: OBs,
  advanced_managed_events_description: PBs,
  enterprise: IBs,
  enterprise_description: RBs,
  create_your_org: NBs,
  create_org: DBs,
  create_your_org_description: MBs,
  create_your_enterprise_description: LBs,
  other_payment_app_enabled: qBs,
  admin_delete_organization_description_1: jBs,
  admin_delete_organization_description_2: FBs,
  admin_delete_organization_description_3: VBs,
  admin_delete_organization_description_4: BBs,
  admin_delete_organization_title: UBs,
  published: WBs,
  unpublished: GBs,
  publish: HBs,
  troubleshooter_tooltip: KBs,
  need_help: YBs,
  troubleshooter: ZBs,
  number_to_call: QBs,
  guest_name: JBs,
  guest_email: XBs,
  guest_company: eUs,
  please_install_a_calendar: tUs,
  instant_tab_title: nUs,
  instant_event_tab_description: oUs,
  uprade_to_create_instant_bookings: rUs,
  dont_want_to_wait: iUs,
  meeting_started: aUs,
  pay_and_book: sUs,
  cal_ai_event_tab_description: cUs,
  booking_not_found_error: lUs,
  booking_seats_full_error: dUs,
  missing_payment_credential_error: uUs,
  missing_payment_app_id_error: _Us,
  not_enough_available_seats_error: pUs,
  user_redirect_title: mUs,
  user_redirect_description: fUs,
  out_of_office: gUs,
  out_of_office_description: hUs,
  send_request: vUs,
  start_date_and_end_date_required: bUs,
  start_date_must_be_before_end_date: yUs,
  start_date_must_be_in_the_future: $Us,
  user_not_found: wUs,
  cannot_redirect_to_self: kUs,
  out_of_office_entry_already_exists: SUs,
  out_of_office_id_required: xUs,
  booking_redirect_infinite_not_allowed: EUs,
  success_entry_created: TUs,
  booking_redirect_email_subject: AUs,
  booking_redirect_email_title: CUs,
  booking_redirect_email_description: zUs,
  booking_redirect_updated_email_subject: OUs,
  booking_redirect_updated_email_title: PUs,
  booking_redirect_updated_email_description: IUs,
  booking_redirect_cancelled_email_subject: RUs,
  booking_redirect_cancelled_email_title: NUs,
  booking_redirect_cancelled_email_description: DUs,
  success_accept_booking_redirect: MUs,
  success_reject_booking_redirect: LUs,
  copy_link_booking_redirect_request: qUs,
  booking_redirect_request_title: jUs,
  select_team_member: FUs,
  going_away_title: VUs,
  redirect_team_enabled: BUs,
  redirect_team_disabled: UUs,
  out_of_office_unavailable_list: WUs,
  success_deleted_entry_out_of_office: GUs,
  success_edited_entry_out_of_office: HUs,
  temporarily_out_of_office: KUs,
  add_a_redirect: YUs,
  create_entry: ZUs,
  time_range: QUs,
  automatically_add_all_team_members: JUs,
  redirect_to: XUs,
  having_trouble_finding_time: eWs,
  show_more: tWs,
  forward_params_redirect: nWs,
  assignment_description: oWs,
  lowest: rWs,
  low: iWs,
  medium: aWs,
  high: sWs,
  Highest: cWs,
  send_booker_to: lWs,
  set_priority: dWs,
  set_weight: uWs,
  enable_weights: _Ws,
  priority_for_user: pWs,
  weights_description: mWs,
  weight_for_user: fWs,
  change_priority: gWs,
  field_identifiers_as_variables: hWs,
  field_identifiers_as_variables_with_example: vWs,
  account_already_linked: bWs,
  send_email: yWs,
  cal_ai_phone_call_action: $Ws,
  call_to_confirm_booking: wWs,
  cal_ai_phone_call_action_description: kWs,
  cal_ai_agent_configuration: SWs,
  choose_at_least_one_event_type_test_call: xWs,
  mark_as_no_show: EWs,
  unmark_as_no_show: TWs,
  account_unlinked_success: AWs,
  account_unlinked_error: CWs,
  travel_schedule: zWs,
  travel_schedule_description: OWs,
  schedule_timezone_change: PWs,
  date: IWs,
  enter_the_general_prompt_for_the_agent: RWs,
  overlaps_with_existing_schedule: NWs,
  "org_admin_no_slots|heading": "Nenhuma disponibilidade encontrada para {{name}}",
  "org_admin_no_slots|content": "Olá Administradores da Organização,<br /><br />Observação: Foi trazido à nossa atenção que {{username}} não teve disponibilidade quando um usuário visitou {{username}}/{{slug}}<br /><br />Existem alguns motivos pelos quais isso pode estar acontecendo<br />O usuário não tem calendários conectados<br />Seus horários vinculados a este evento não estão habilitados<br /> <br />Recomendamos verificar a disponibilidade para resolver isso.",
  "org_admin_no_slots|cta": "Abrir a disponibilidade dos usuários",
  organization_no_slots_notification_switch_title: DWs,
  organization_no_slots_notification_switch_description: MWs,
  organization_disable_phone_only_sms_notifications_switch_title: LWs,
  organization_disable_phone_only_sms_notifications_switch_description: qWs,
  "email_team_invite|subject|added_to_org": "{{user}} adicionou você à organização {{team}} no {{appName}}",
  "email_team_invite|subject|invited_to_org": "{{user}} convidou você para se juntar à organização {{team}} no {{appName}}",
  "email_team_invite|subject|added_to_subteam": "{{user}} adicionou você à equipe {{team}} da organização {{parentTeamName}} no {{appName}}",
  "email_team_invite|subject|invited_to_regular_team": "{{user}} convidou você para se juntar à equipe {{team}} em {{appName}}",
  "email_team_invite|heading|added_to_org": "Você foi adicionado a uma organização do {{appName}}",
  "email_team_invite|heading|invited_to_org": "Você foi convidado para uma organização do {{appName}}",
  "email_team_invite|heading|added_to_subteam": "Você foi adicionado a uma equipe da organização {{parentTeamName}}",
  "email_team_invite|heading|invited_to_subteam": "Você foi convidado para uma equipe da organização {{parentTeamName}}",
  "email_team_invite|heading|invited_to_regular_team": "Você foi convidado para participar de uma equipe do {{appName}}",
  "email_team_invite|content|added_to_org": "{{invitedBy}} adicionou você à organização <strong>{{teamName}}</strong>.",
  "email_team_invite|content|invited_to_org": "{{invitedBy}} convidou você para se juntar à organização {{teamName}}.",
  "email_team_invite|subject|invited_to_subteam": "{{user}} convidou você para se juntar à equipe {{team}} da organização {{parentTeamName}} no {{appName}}",
  "email_team_invite|content|added_to_subteam": "{{invitedBy}} adicionou você à equipe <strong>{{teamName}}</strong> na organização {{parentTeamName}}. {{appName}} é o agendador para gerenciador de múltiplos eventos que permite que você e sua equipe agendem reuniões sem o vai-e-vem de e-mails.",
  "email_team_invite|content|invited_to_subteam": "{{invitedBy}} convidou você para a equipe <strong>{{teamName}}</strong> na organização {{parentTeamName}}. {{appName}} é o gerenciador de múltiplos eventos que permite que você e sua equipe agendem reuniões sem o vai-e-vem de e-mails.",
  "email_team_invite|content|invited_to_regular_team": 'Você recebeu um convite de {{invitedBy}} para ingressar na equipe "{{teamName}}" em {{appName}}. {{appName}} é um agendador que concilia eventos e permite que sua equipe agende reuniões sem precisar trocar e-mails.',
  "email|existing_user_added_link_will_change": "Ao aceitar o convite, seu link mudará para o domínio da sua organização, mas não se preocupe, todos os links anteriores ainda funcionarão e redirecionarão adequadamente.<br /><br />Observe: Todos os seus tipos de eventos pessoais serão movidos para a organização <strong>{{teamName}}</strong>, o que também pode incluir potencial link pessoal. <br /><br />Para eventos pessoais, recomendamos criar uma nova conta com um endereço de e-mail pessoal.",
  "email|existing_user_added_link_changed": "Seu link foi alterado de {{a0}} para {{a1}}, mas não se preocupe, todos os links anteriores ainda funcionam e redirecionam adequadamente. <br /><br />Observe: Todos os seus tipos de eventos pessoais foram movidos para a organização <strong>{{teamName}}</strong>, o que também pode incluir potencial link pessoal.<br /><br />Faça login e verifique se não há eventos privados em sua nova conta organizacional.<br /><br />Para eventos pessoais, recomendamos criar uma nova conta com um endereço de e-mail pessoal.<br /><br />Aproveite seu novo link limpo: {{a2}}",
  "email_organization_created|subject": "Sua organização foi criada",
  your_current_plan: jWs,
  organization_price_per_user_month: FWs,
  privacy_organization_description: VWs,
  privacy: BWs,
  team_will_be_under_org: UWs,
  add_group_name: WWs,
  group_name: GWs,
  routers: HWs,
  primary: KWs,
  make_primary: YWs,
  add_email: ZWs,
  add_emails: QWs,
  add_email_description: JWs,
  confirm_email: XWs,
  confirming_your_booking_sms: eGs,
  scheduler_first_name: tGs,
  scheduler_last_name: nGs,
  scheduler_name: oGs,
  organizer_first_name: rGs,
  confirm_email_description: iGs,
  send_event_details_to: aGs,
  schedule_tz_without_end_date: sGs,
  select_members: cGs,
  lock_event_types_modal_header: lGs,
  org_delete_event_types_org_admin: dGs,
  org_hide_event_types_org_admin: uGs,
  hide_org_eventtypes: _Gs,
  delete_org_eventtypes: pGs,
  lock_org_users_eventtypes: mGs,
  lock_org_users_eventtypes_description: fGs,
  add_to_event_type: gGs,
  create_account_password: hGs,
  create_account_with_saml: vGs,
  error_creating_account_password: bGs,
  cannot_create_account_password_cal_provider: yGs,
  cannot_create_account_password_already_existing: $Gs,
  create_account_password_hint: wGs,
  disconnect_account: kGs,
  disconnect_account_hint: SGs,
  cookie_consent_checkbox: xGs,
  make_a_call: EGs,
  skip_rr_assignment_label: TGs,
  skip_rr_description: AGs,
  select_account_header: CGs,
  select_account_description: zGs,
  select_event_types_header: OGs,
  select_event_types_description: PGs,
  configure_app_header: IGs,
  configure_app_description: RGs,
  already_installed: NGs,
  ooo_reasons_unspecified: DGs,
  ooo_reasons_vacation: MGs,
  ooo_reasons_travel: LGs,
  ooo_reasons_sick_leave: qGs,
  ooo_reasons_public_holiday: jGs,
  ooo_forwarding_to: FGs,
  ooo_not_forwarding: VGs,
  ooo_empty_title: BGs,
  ooo_empty_description: UGs,
  ooo_user_is_ooo: WGs,
  ooo_slots_returning: GGs,
  ooo_slots_book_with: HGs,
  ooo_select_reason: KGs,
  create_an_out_of_office: YGs,
  edit_an_out_of_office: ZGs,
  submit_feedback: QGs,
  host_no_show: JGs,
  no_show_description: XGs,
  how_can_we_improve: eHs,
  most_liked: tHs,
  review: nHs,
  reviewed: oHs,
  unreviewed: rHs,
  rating_url_variable: iHs,
  rating_url_info: aHs,
  no_show_url_variable: sHs,
  no_show_url_info: cHs,
  no_support_needed: lHs,
  hide_support: dHs,
  event_ratings: uHs,
  event_no_show: _Hs,
  event_no_show_guest: pHs,
  recent_ratings: mHs,
  no_ratings: fHs,
  no_ratings_description: gHs,
  most_no_show_host: hHs,
  highest_rated: vHs,
  lowest_rated: bHs,
  highest_rated_members: yHs,
  lowest_rated_members: $Hs,
  csat_score: wHs,
  lockedSMS: kHs,
  leave_without_assigning_anyone: SHs,
  leave_without_adding_attendees: xHs,
  no_availability_shown_to_bookers: EHs,
  go_back_and_assign: THs,
  leave_without_assigning: AHs,
  signing_up_terms: CHs,
  proceeding_agreement: zHs,
  terms: OHs,
  always_show_x_days: PHs,
  always_show_x_days_description: IHs,
  team_subscription_cancelled_successfully: RHs,
  team_subscription_cancellation_error: NHs,
  unable_to_subscribe_to_the_platform: DHs,
  updating_oauth_client_error: MHs,
  creating_oauth_client_error: LHs,
  event_type_color: qHs,
  event_type_color_description: jHs,
  mark_as_no_show_title: FHs,
  x_marked_as_no_show: VHs,
  x_unmarked_as_no_show: BHs,
  team_select_info: UHs,
  team_settings_description: WHs,
  no_show_updated: GHs,
  email_copied: HHs,
  phone_number_copied: KHs,
  USER_PENDING_MEMBER_OF_THE_ORG: YHs,
  USER_ALREADY_INVITED_OR_MEMBER: ZHs,
  USER_MEMBER_OF_OTHER_ORGANIZATION: QHs,
  booking_reassigned: JHs,
  reassign: XHs,
  reassign_to_another_rr_host: eKs,
  assign_team_member: tKs,
  override_team_member_to_assign: nKs,
  no_available_hosts: oKs,
  reassign_round_robin_host: rKs,
  skip_writing_to_calendar: iKs,
  rescheduling_not_possible: aKs,
  event_expired: sKs,
  skip_contact_creation: cKs,
  skip_writing_to_calendar_note: lKs,
  attributes: dKs,
  new_attribute: uKs,
  add_attributes: _Ks,
  add_attributes_description: pKs,
  new_option: mKs,
  update_profile: fKs,
  attribute: gKs,
  create_attribute_description: hKs,
  edit_attribute_description: vKs,
  attribute_updated_successfully: bKs,
  attribute_deleted_successfully: yKs,
  attributes_edited_successfully: $Ks,
  attribute_meta_description: wKs,
  attributes_edit_description: kKs,
  back_to_attributes: SKs,
  delete_attribute: xKs,
  delete_attribute_description: EKs,
  disable_all_emails_to_attendees: TKs,
  disable_all_emails_description: AKs,
  disable_all_emails_to_hosts: CKs,
  type_confirm_to_continue: zKs,
  disable_email: OKs,
  grant_admin_api: PKs,
  revoke_admin_api: IKs,
  add_calendar_label: RKs,
  apple_connect_atom_label: NKs,
  apple_connect_atom_already_connected_label: DKs,
  apple_connect_atom_loading_label: MKs,
  google_connect_atom_label: LKs,
  google_connect_atom_already_connected_label: qKs,
  google_connect_atom_loading_label: jKs,
  outlook_connect_atom_label: FKs,
  outlook_connect_atom_already_connected_label: VKs,
  outlook_connect_atom_loading_label: BKs,
  stripe_connect_atom_label: UKs,
  stripe_connect_atom_already_connected_label: WKs,
  stripe_connect_atom_loading_label: GKs,
  booking_question_response_variables: HKs,
  managed_by_teamAdmins: KKs,
  number_of_options: YKs,
  reschedule_with_same_round_robin_host_title: ZKs,
  reschedule_with_same_round_robin_host_description: QKs,
  disable_input_if_prefilled: JKs,
  booking_limits: XKs,
  booking_limits_team_description: eYs,
  limit_team_booking_frequency_description: tYs,
  booking_limits_updated_successfully: nYs,
  you_are_unauthorized_to_make_this_change_to_the_booking: oYs,
  delegation_credential_disabled: rYs,
  matching_members: iYs,
  x_matching_members: aYs,
  matching_members_queue_using_attribute_weights: sYs,
  matching_members_queue_using_event_assignee_weights: cYs,
  no_matching_members: lYs,
  no_matching_members_will_fallback_to_all_assigned_members: dYs,
  hide_calendar_event_details: uYs,
  description_hide_calendar_event_details: _Ys,
  last_number_of_days: pYs,
  month_to_date: mYs,
  year_to_date: fYs,
  custom_range: gYs,
  refund_policy: hYs,
  always: vYs,
  never: bYs,
  payment_option: yYs,
  if_cancelled: $Ys,
  before: wYs,
  show_all_columns: kYs,
  toggle_columns: SYs,
  no_columns_found: xYs,
  salesforce_create_record_as: EYs,
  salesforce_lead: TYs,
  salesforce_contact_under_account: AYs,
  salesforce_skip_entry_creation: CYs,
  salesforce_if_account_does_not_exist: zYs,
  salesforce_create_new_contact_under_account: OYs,
  salesforce_change_record_owner_on_booking: PYs,
  mass_assign_attributes: IYs,
  reroute_preview_custom_message: RYs,
  reroute_preview_external_redirect: NYs,
  reroute_preview_possible_host: DYs,
  current_routing_status: MYs,
  reroute_booking: LYs,
  reroute_booking_description: qYs,
  verify_new_route: jYs,
  reroute: FYs,
  new_routing_status: VYs,
  salesforce_book_directly_with_attendee_owner: BYs,
  salesforce_check_owner_of: UYs,
  account: WYs,
  choose_hosts_schedule: GYs,
  hosts_schedule_description: HYs,
  no_hosts_description: KYs,
  team_member_round_robin_reassign: YYs,
  team_member_round_robin_reassign_description: ZYs,
  round_robin_reassign_description: QYs,
  invalid_round_robin_host: JYs,
  user_is_round_robin_fixed: XYs,
  reschedule_with_same_timeslot: eZs,
  reschedule_with_same_timeslot_of_new_event: tZs,
  reschedule_to_the_new_event_with_different_timeslot: nZs,
  reschedule_with_different_timeslot: oZs,
  we_dont_have_id_for_the_new_event: rZs,
  rerouted_booking_successfully_redirecting_to_booking_page: iZs,
  on_booking_write_to_event_object: aZs,
  field_name: sZs,
  add_new_field: cZs,
  you_dont_have_access_to_reroute_this_booking: lZs,
  form_response_not_found: dZs,
  contact_owner: uZs,
  contact_owner_not_found: _Zs,
  using_fallback_members: pZs,
  chosen_route: mZs,
  attribute_logic_matched: fZs,
  attribute_logic_fallback_matched: gZs,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules: hZs,
  all_assigned_members_of_the_team_event_type_consider_adding_some_attribute_rules_to_fallback: vZs,
  all_assigned_members_of_the_team_event_type_consider_tweaking_fallback_to_have_a_match: bZs,
  warning: yZs,
  fallback_attribute_logic_description: $Zs,
  fallback_attribute_logic_warning: wZs,
  fallback_not_needed: kZs,
  confirm_reassign_unavailable: SZs,
  confirm_reassign_available: xZs,
  reassign_unavailable_team_member_description: EZs,
  reassign_available_team_member_description: TZs,
  yes_reassign: AZs,
  filter_by_attributes: CZs,
  reassign_reason: zZs,
  field_type_change_suggestion: OZs,
  reassigned_by: PZs,
  row: IZs,
  rows: RZs,
  attendee_timezone_variable: NZs,
  event_start_time_in_attendee_timezone_variable: DZs,
  event_start_time_in_attendee_timezone_info: MZs,
  event_end_time_in_attendee_timezone_info: LZs,
  event_end_time_in_attendee_timezone_variable: qZs,
  salesforce_create_event_on_contact: jZs,
  salesforce_owner_name_to_change: FZs,
  no_filter_set: VZs,
  booking_dry_run_successful: BZs,
  booking_dry_run_successful_description: UZs,
  dont_have_access_this_page: WZs,
  you_need_admin_or_owner_privileges_to_access: GZs,
  field_type: HZs,
  when_to_write: KZs,
  salesforce_on_booking_write_to_record: YZs,
  on_every_booking: ZZs,
  only_if_field_is_empty: QZs,
  booking_start_date: JZs,
  booking_created_date: XZs,
  booking_reassigned_to_host: eQs,
  no_contact_owner: tQs,
  routing_forms_created: nQs,
  routing_forms_total_responses: oQs,
  routing_forms_total_responses_without_booking: rQs,
  routing_forms_total_responses_with_booking: iQs,
  routing_form_insights: aQs,
  routing_form_insights_form_name_header: sQs,
  routing_form_insights_booking_status_header: cQs,
  routing_form_insights_response_no_booking: lQs,
  routing_form_insights_booked_by: dQs,
  routing_form_insights_created_at: uQs,
  routing_form_insights_booking_status: _Qs,
  routing_form_insights_booking_at: pQs,
  routing_form_insights_submitted_at: mQs,
  copy_redirect_url: fQs,
  redirect_url_on_exit: gQs,
  total_bookings_per_period: hQs,
  routed_to_per_period: vQs,
  per_day: bQs,
  per_week: yQs,
  per_month: $Qs,
  routing_form_insights_assignment_reason: wQs,
  access_denied: kQs,
  salesforce_route_to_owner: SQs,
  salesforce_add_attendees_as: xQs,
  salesforce_do_not_route_to_owner: EQs,
  salesforce_route_to_custom_lookup_field: TQs,
  salesforce_option: AQs,
  lookup_field_name: CQs,
  salesforce_if_free_email_domain_skip_owner_check: zQs,
  filter_operator_is: OQs,
  filter_operator_is_not: PQs,
  filter_operator_contains: IQs,
  filter_operator_does_not_contain: RQs,
  filter_operator_starts_with: NQs,
  filter_operator_ends_with: DQs,
  filter_operator_is_empty: MQs,
  filter_operator_not_empty: LQs,
  translate_description_button: qQs,
  translate_description_button_description: jQs,
  rr_distribution_method: FQs,
  rr_distribution_method_description: VQs,
  rr_distribution_method_availability_title: BQs,
  rr_distribution_method_availability_description: UQs,
  rr_distribution_method_balanced_title: WQs,
  rr_distribution_method_balanced_description: GQs,
  edit_team_member_weights: HQs,
  weights_updated_successfully: KQs,
  require_confirmation_for_free_email: YQs,
  exclude_emails_that_contain: ZQs,
  require_emails_that_contain: QQs,
  exclude_emails_match_found_error_message: JQs,
  require_emails_no_match_found_error_message: XQs,
  search_columns: eJs,
  search_options: tJs,
  disable_org_url_label: nJs,
  disable_org_url_description: oJs,
  single_select: rJs,
  multi_select: iJs,
  calendar_conflict_settings: aJs,
  select_calendars_conflict_check: sJs,
  group_meeting: cJs,
  are_you_sure_you_want_to_remove_this_app_from: lJs,
  disconnect_app_from: dJs,
  salesforce_ignore_guests: uJs,
  google_meet: _Js,
  zoom: pJs,
  office_365_video: mJs,
  lock_attribute_for_assignment: fJs,
  lock_attribute_for_assignment_description: gJs,
  attribute_edited_successfully: hJs,
  new_group_option: vJs,
  attribute_weight_enabled: bJs,
  attribute_weight_enabled_description: yJs,
  routed: $Js,
  reassigned: wJs,
  allow_rescheduling_past_events: kJs,
  allow_rescheduling_past_events_description: SJs,
  rerouted: xJs,
  salesforce_assigned: EJs,
  router_position: TJs,
  show_matching_hosts: AJs,
  no_active_queues: CJs,
  weight: zJs,
  calibration: OJs,
  shortfall: PJs,
  routing_form: IJs,
  go_back_and_save: RJs,
  save_changes: NJs,
  leave_without_saving: DJs,
  leave_without_saving_description: MJs,
  something_unexpected_occurred: LJs,
  "500_error_message": "Não é você, somos nós.",
  dry_run_mode_active: qJs,
  icon_showcase: jJs,
  icons_showcase: FJs,
  migrating_from_team: VJs,
  feature_currently_disabled: BJs,
  choose_an_option: UJs,
  enter_option_value: WJs,
  remove_option: GJs,
  use_attribute_weights: HJs,
  if_enabled_ignore_event_type_weights: KJs,
  attribute_for_weights: YJs,
  managed_users: ZJs,
  managed_users_description: QJs,
  can_you_tell_me_about: JJs,
  use_ai_to_answer_your_questions: XJs,
  error_fetching_answer: eXs,
  k_bar_ai_error: tXs,
  select_oAuth_client: nXs,
  on_every_instance: oXs,
  delegation_credential_feature_not_enabled: rXs,
  internal_booking_note: iXs,
  internal_note_cancellation_reason: aXs,
  internal_booking_note_description: sXs,
  internal_note_presets: cXs,
  internal_note_presets_description: lXs,
  internal_note_presets_updated_successfully: dXs,
  add_preset: uXs,
  authorize: _Xs,
  next: pXs,
  hide: mXs,
  show: fXs,
  utm_params: gXs,
  no_utm_params: hXs,
  asc: vXs,
  desc: bXs,
  verify_email_change: yXs,
  buy_credits: $Xs,
  credits: wXs,
  credits_used: kXs,
  total_credits_remaining: SXs,
  credits_per_tip_org: xXs,
  credits_per_tip_teams: EXs,
  view_and_manage_credits: TXs,
  view_and_manage_credits_description: AXs,
  credit_worth_description: CXs,
  buy_additional_credits: zXs,
  view_additional_credits_expense_tip: OXs,
  overview: PXs,
  organization_slug_taken: IXs,
  you_cannot_create_an_organization_as_you_are_already_part_of_an_organization: RXs,
  you_need_to_complete_user_onboarding_before_creating_an_organization: NXs,
  use_company_email_to_create_an_organization: DXs,
  you_cannot_create_a_platform_organization_as_you_are_already_part_of_a_team: MXs,
  you_need_to_have_minimum_published_teams: LXs,
  you_are_part_of_this_organization_already: qXs,
  you_are_part_of_another_organization_cannot_create_organization: jXs,
  you_are_part_of_another_platform_organization_cannot_create_organization: FXs,
  organization_payment_success: VXs,
  organization_payment_success_description: BXs,
  this_may_take_a_few_seconds: UXs,
  organization_onboarding_status: WXs,
  organization_onboarding_status_description: GXs,
  payment_failed: HXs,
  payment_failed_description: KXs,
  creating_your_organization: YXs,
  organization_onboarding_already_completed: ZXs,
  organization_onboarding_already_exists: QXs,
  organization_onboarding_not_found: JXs,
  payment_successful: XXs,
  handover_onboarding_page_title: eec,
  handover_onboarding_page_description: tec,
  organization_already_exists_with_this_slug: nec,
  you_do_not_have_permission_to_create_an_organization_for_this_email: oec,
  you_do_not_have_permission_to_migrate_one_or_more_of_the_teams: rec,
  organization_has_subscription_already: iec,
  reset_interval_weighted_rr: aec,
  interval: sec,
  rr_reset_interval_description: cec,
  daily: lec,
  end_date_not_selected: dec,
  my_ooo: uec,
  team_ooo: _ec,
  out_of_office_team_description: pec,
  create_ooo_dialog_team_title: mec,
  create_ooo_dialog_team_subtitle: fec,
  edit_ooo_dialog_team_subtitle: gec,
  ooo_team_empty_title: hec,
  ooo_team_empty_description: vec,
  forward_to_team_member_only: bec,
  ooo_team_redirect_infinite_not_allowed: yec,
  previous_ooo_empty_title: $ec,
  previous: wec,
  rr_interval_successfully_updated: kec,
  trial_mode: Sec,
  inactive_team_plan: xec,
  inactive_team_plan_description: Eec,
  limited_access_trial_mode: Tec,
  referral_program: Aec,
  referral_text: Cec,
  dub_disabled_error_message: zec,
  uid: Oec,
  link: Pec,
  rows_per_page: Iec,
  pagination_status: Rec,
  tip_username_plus: Nec,
  user_has_no_team_yet: Dec,
  no_team_members: Mec,
  recurring_event_doesnt_support_seats: Lec,
  booking_limit_per_booker_doesnt_support_recurring: qec,
  seats_doesnt_support_recurring: jec,
  recurring_event_seats_error: Fec,
  segment: Vec,
  saved_filters: Bec,
  rename: Uec,
  rename_segment: Wec,
  delete_segment: Gec,
  duplicate_segment: Hec,
  delete_segment_confirmation: Kec,
  filter_segment_updated: Yec,
  error_updating_filter_segment: Zec,
  filter_segment_duplicated: Qec,
  error_duplicating_filter_segment: Jec,
  filter_segment_deleted: Xec,
  error_deleting_filter_segment: etc,
  save_segment: ttc,
  segment_not_found: ntc,
  filter_segment_saved: otc,
  no_segments: rtc,
  error_saving_filter_segment: itc,
  override_segment: atc,
  create_new_segment: stc,
  save_for_team: ctc,
  select_team: ltc,
  please_select_team: dtc,
  personal: utc,
  hide_team_profile_link: _tc,
  hide_team_profile_link_description: ptc,
  display: mtc,
  could_not_find_slug_to_publish_org: ftc,
  picklist: gtc,
  most_cancelled_bookings: htc,
  interface_language: vtc,
  interface_language_description: btc,
  visitors_browser_language: ytc,
  name_or_email: $tc,
  salesforce_round_robin_skip_fallback_to_lead_owner: wtc,
  credit_purchase_failed: ktc,
  minimum_of_credits_required: Stc,
  enable_delegation_credential: xtc,
  enable_delegation_credential_description: Etc,
  disable_delegation_credential: Ttc,
  disable_delegation_credential_description: Atc,
  last_active: Ctc,
  member_since: ztc,
  last_updated: Otc,
  salesforce_on_cancel_write_to_event: Ptc,
  salesforce_on_every_cancellation: Itc,
  report_issue: Rtc,
  report_issue_description: Ntc,
  open_issue: Dtc,
  this_is_your_current_plan: Mtc,
  schedule_a_time: Ltc,
  this_includes: qtc,
  oauth_client_updated_successfully: jtc,
  oauth_client_not_found: Ftc,
  subscribe_to_platform: Vtc,
  error_accessing_webhooks: Btc,
  webhook_update_failed: Utc,
  webhook_create_failed: Wtc,
  invalid_link: Gtc,
  currently_subscribed_to_plan: Htc,
  user_team: Ktc,
  client_id_copied: Ytc,
  client_secret_copied: Ztc,
  maintenance_message: Qtc,
  your_payment_failed: Jtc,
  check_your_inbox: Xtc,
  account_created_premium_not_reserved: enc,
  email_sent_with_activation_link: tnc,
  activate_account_to_purchase_username: nnc,
  open_in_gmail: onc,
  dont_see_email: rnc,
  resend_in_seconds: inc,
  resend: anc,
  verification_email_sent: snc,
  select_all_members: cnc,
  select_all_members_tooltip: lnc,
  form_settings: dnc,
  remove_whitelist_status: unc,
  whitelist_user_workflows: _nc,
  user_workflows_whitelisted: pnc,
  user_workflows_unwhitelisted: mnc,
  date_and_time: fnc,
  email_reminder_upcoming_event_notice: gnc,
  email_reminder_triggered_by_workflow: hnc,
  event_upper_case: vnc,
  scheduling_by: bnc,
  experience_review_prompt: ync,
  improve_customer_experience_message: $nc,
  meeting_satisfaction_question: wnc,
  meeting_not_joined_question: knc,
  reschedule_cta_short: Snc,
  hide_organizer_email: xnc,
  platform_customer_cant_create_organization: Enc,
  organization_customer_cant_create_platform: Tnc,
  hide_organizer_email_description: Anc,
  you_and_conjunction: Cnc,
  select_verified_email: znc,
  add_verified_email: Onc,
  add_verified_emails: Pnc,
  custom_reply_to_email_title: Inc,
  custom_reply_to_email_description: Rnc,
  email_survey_triggered_by_workflow: Nnc,
  skip_trial: Dnc,
  team_trials_skipped_successfully: Mnc,
  sms_workflow_consent: Lnc,
  routing_preview_more_info_found_insights: qnc,
  results: jnc,
  view_form: Fnc,
  sms_opt_out_message: Vnc,
  team_credits_low_warning: Bnc,
  user_credits_low_warning: Unc,
  action_required_out_of_credits: Wnc,
  action_required_user_out_of_credits: Gnc,
  low_credits_warning_message: Hnc,
  low_credits_warning_message_user: Knc,
  credit_limit_reached_message: Ync,
  credit_limit_reached_message_user: Znc,
  current_credit_balance: Qnc,
  current_balance: Jnc,
  notification_about_your_booking: Xnc,
  monthly_credits: eoc,
  total_credits: toc,
  remaining_credits: noc,
  remaining: ooc,
  total: roc,
  additional_credits: ioc,
  routing_form_next_in_queue: aoc,
  routing_form_select_members_to_email: soc,
  routing_incomplete_booking_tab: coc,
  include_no_show_in_rr_calculation: loc,
  recent_no_show_guests: doc,
  recent_no_show_guests_tooltip: uoc,
  matching: _oc,
  event_redirect: poc,
  reset_form: moc,
  rr_settings_successfully_updated: foc,
  distribution_basis_weighted_rr: goc,
  timestamp_basis_description: hoc,
  requires_credits: voc,
  requires_credits_tooltip: boc,
  available_credits: yoc,
  create_role: $oc,
  roles_and_permissions: woc,
  roles_and_permissions_description: koc,
  learn_more_permissions: Soc,
  role_name: xoc,
  role_name_required: Eoc,
  role_name_placeholder: Toc,
  role_description: Aoc,
  role_description_placeholder: Coc,
  default_role: zoc,
  custom_role: Ooc,
  advanced: Poc,
  search_permissions: Ioc,
  all_permissions: Roc,
  none: Noc,
  read_only: Doc,
  pbac_desc_all_actions_all_resources: Moc,
  pbac_resource_all: Loc,
  pbac_resource_event_type: qoc,
  pbac_resource_team: joc,
  pbac_resource_organization: Foc,
  pbac_resource_booking: Voc,
  pbac_resource_insights: Boc,
  pbac_resource_role: Uoc,
  pbac_resource_routing_form: Woc,
  pbac_resource_workflow: Goc,
  pbac_action_all: Hoc,
  pbac_action_create: Koc,
  pbac_action_read: Yoc,
  pbac_action_update: Zoc,
  pbac_action_delete: Qoc,
  pbac_action_manage: Joc,
  pbac_action_invite: Xoc,
  pbac_action_remove: erc,
  pbac_action_change_member_role: trc,
  pbac_action_list_members: nrc,
  pbac_action_manage_billing: orc,
  pbac_action_read_team_bookings: rrc,
  pbac_action_read_org_bookings: irc,
  pbac_action_read_recordings: arc,
  pbac_action_impersonate: src,
  role_created_successfully: crc,
  role_updated_successfully: lrc,
  delete_role: drc,
  confirm_delete_role: urc,
  role_deleted_successfully: _rc,
  error_creating_role: prc,
  error_updating_role: mrc,
  pbac_desc_create_roles: frc,
  pbac_resource_attributes: grc,
  pbac_desc_view_organization_attributes: hrc,
  pbac_desc_update_organization_attributes: vrc,
  pbac_desc_delete_organization_attributes: brc,
  pbac_desc_create_organization_attributes: yrc,
  pbac_desc_view_roles: $rc,
  pbac_desc_update_roles: wrc,
  pbac_desc_delete_roles: krc,
  pbac_desc_create_workflows: Src,
  set_up_required: xrc,
  pbac_desc_view_workflows: Erc,
  pbac_desc_update_workflows: Trc,
  pbac_desc_delete_workflows: Arc,
  pbac_resource_webhook: Crc,
  pbac_resource_availability: zrc,
  pbac_resource_out_of_office: Orc,
  pbac_desc_create_webhooks: Prc,
  pbac_desc_view_webhooks: Irc,
  pbac_desc_update_webhooks: Rrc,
  pbac_desc_delete_webhooks: Nrc,
  pbac_desc_create_availability: Drc,
  pbac_desc_view_availability: Mrc,
  pbac_desc_update_availability: Lrc,
  pbac_desc_delete_availability: qrc,
  pbac_desc_create_out_of_office: jrc,
  pbac_desc_view_out_of_office: Frc,
  pbac_desc_update_out_of_office: Vrc,
  pbac_desc_delete_out_of_office: Brc,
  pbac_desc_manage_workflows: Urc,
  pbac_desc_create_event_types: Wrc,
  pbac_desc_view_event_types: Grc,
  pbac_desc_update_event_types: Hrc,
  pbac_desc_delete_event_types: Krc,
  pbac_desc_manage_event_types: Yrc,
  pbac_desc_create_teams: Zrc,
  pbac_desc_view_team_details: Qrc,
  pbac_desc_update_team_settings: Jrc,
  pbac_desc_delete_team: Xrc,
  pbac_desc_invite_team_members: eic,
  pbac_desc_remove_team_members: tic,
  pbac_desc_change_team_member_role: nic,
  pbac_desc_impersonate_team_members: oic,
  pbac_desc_manage_teams: ric,
  pbac_desc_create_organization: iic,
  pbac_desc_view_organization_details: aic,
  pbac_desc_list_organization_members: sic,
  pbac_desc_invite_organization_members: cic,
  pbac_desc_remove_organization_members: lic,
  pbac_desc_manage_organization_billing: dic,
  pbac_desc_change_organization_member_role: uic,
  pbac_desc_impersonate_organization_members: _ic,
  pbac_desc_edit_organization_settings: pic,
  pbac_desc_manage_organizations: mic,
  pbac_desc_view_bookings: fic,
  pbac_desc_view_team_bookings: gic,
  pbac_desc_view_organization_bookings: hic,
  pbac_desc_view_booking_recordings: vic,
  pbac_desc_update_bookings: bic,
  pbac_desc_manage_bookings: yic,
  pbac_desc_view_team_insights: $ic,
  pbac_desc_manage_team_insights: wic,
  pbac_desc_create_routing_forms: kic,
  pbac_desc_view_routing_forms: Sic,
  pbac_desc_update_routing_forms: xic,
  pbac_desc_delete_routing_forms: Eic,
  read_permission_auto_enabled_tooltip: Tic,
  choose_restriction_schedule: Aic,
  restriction_schedule_description: Cic,
  use_booker_timezone: zic,
  use_booker_timezone_info: Oic,
  load_balancing_warning: Pic,
  rr_load_balancing_disabled: Iic,
  rr_load_balancing_disabled_with_groups: Ric,
  round_robin_settings_description: Nic,
  round_robin_settings_updated_successfully: Dic,
  booking_creation_time: Mic,
  meeting_start_time: Lic,
  members_affected_by_disabling_delegation_credential: qic,
  no_members_affected_by_disabling_delegation_credential: jic,
  download_expense_log: Fic,
  error_downloading_expense_log: Vic,
  offer_to_reschedule_last_booking: Bic,
  booker_limit_exceeded_error: Uic,
  booker_limit_exceeded_error_reschedule: Wic,
  duration_min_error: Gic,
  duration_max_error: Hic,
  booking_not_allowed_by_restriction_schedule_error: Kic,
  restriction_schedule_not_found_error: Yic,
  converted_image_size_limit_exceed: Zic,
  add_group: Qic,
  routing_funnel: Jic,
  routing_funnel_total_submissions: Xic,
  routing_funnel_successful_routings: eac,
  routing_funnel_accepted_bookings: tac,
  license_key: nac,
  license_selection_title: oac,
  license_selection_description: rac,
  agplv3_license_description: iac,
  enter_license_key: aac,
  enter_your_license_key: sac,
  enter_existing_license: cac,
  enter_license_key_description: lac,
  license_key_placeholder: dac,
  save_license_key: uac,
  signature_token_optional: _ac,
  signature_token_description: pac,
  need_a_license: mac,
  license_key_required: fac,
  invalid_license_key: gac,
  license_validation_failed: hac,
  attachments_optional: vac,
  send_message: bac,
  describe_the_issue: yac,
  file_size_limit_exceed: $ac,
  invalid_file_type: wac,
  invalid_file_type_extension: kac,
  max_files_exceeded: Sac,
  files_uploaded_successfully: xac,
  file_upload_instructions: Eac,
  license_key_saved: Tac,
  timezone_mismatch_tooltip: Aac,
  show_optimized_slots: Cac,
  show_optimized_slots_description: zac,
  failed_bookings_by_field: Oac,
  failed_bookings: Pac,
  event_type_no_hosts: Iac,
  cache_status: Rac,
  cache_last_updated: Nac,
  delete_cached_data: Dac,
  cache_deleted_successfully: Mac,
  error_deleting_cache: Lac,
  confirm_delete_cache: qac,
  yes_delete_cache: jac,
  remainder_of_maximum_uses_left_plural: Fac,
  remainder_of_maximum_use_left_singular: Vac,
  expires_on_date: Bac,
  single_use: Uac,
  time_based_expiration: Wac,
  usage_based_expiration: Gac,
  number_of_uses: Hac,
  expires_on: Kac,
  max_usage_count: Yac,
  link_settings: Zac,
  link_expired_on_date: Qac,
  usage_limit_reached: Jac,
  usage_count_error: Xac,
  private_link_expired: esc,
  time_based_expiration_description: tsc,
  time_based_generic_expiration_description: nsc,
  usage_based_expiration_description: osc,
  usage_based_generic_expiration_description: rsc,
  usage_based_expiration_description_plural: isc,
  webhook_trigger_event: asc,
  webhook_created_at: ssc,
  webhook_type: csc,
  set_up_agent: lsc,
  webhook_title: dsc,
  webhook_start_time: usc,
  webhook_end_time: _sc,
  webhook_description: psc,
  webhook_location: msc,
  webhook_uid: fsc,
  webhook_reschedule_uid: gsc,
  webhook_cancellation_reason: hsc,
  webhook_rejection_reason: vsc,
  webhook_organizer_name: bsc,
  webhook_organizer_email: ysc,
  webhook_organizer_timezone: $sc,
  webhook_organizer_locale: wsc,
  webhook_organizer_username: ksc,
  webhook_organizer_username_in_org: Ssc,
  webhook_attendee_name: xsc,
  webhook_attendee_email: Esc,
  webhook_attendee_timezone: Tsc,
  webhook_attendee_locale: Asc,
  webhook_team_name: Csc,
  webhook_team_members: zsc,
  webhook_video_call_url: Osc,
  webhook_hide_variables: Psc,
  webhook_show_variable: Isc,
  webhook_event_and_booking: Rsc,
  webhook_people: Nsc,
  webhook_teams: Dsc,
  webhook_metadata: Msc,
  stats: Lsc,
  booking_status: qsc,
  visit: jsc,
  location_custom_label_input_label: Fsc,
  meeting_link: Vsc,
  session_outcome: Bsc,
  call_created: Usc,
  voicemail: Wsc,
  my_bookings: Gsc,
  phone: Hsc,
  free: Ksc,
  user_email: Ysc,
  user_name: Zsc,
  expand_panel: Qsc,
  collapse_panel: Jsc,
  email_verification_required: Xsc,
  invalid_verification_code: ecc,
  you_have_one_team: tcc,
  consider_consolidating_one_team_org: ncc,
  consider_consolidating_multi_team_org: occ,
  message_sent: rcc,
  support_message_sent_description: icc,
  search_variables: acc,
  support_message_placeholder: scc,
  send_another_message: ccc,
  sending: lcc,
  no_variables_found: dcc,
  credits_required: ucc,
  web_call_credits_info: _cc,
  web_call_no_credits: pcc,
  purchase_credits: mcc,
  credits_required_tooltip: fcc,
  api_key_name_too_long: gcc,
  auto_charge_for_last_minute_cancellation: hcc,
  before_scheduled_start_time: vcc,
  cancel_booking_acknowledge_no_show_fee: bcc,
  contact_organizer: ycc,
  booking_time_option: $cc,
  booking_time_option_description: wcc,
  created_at_option: kcc,
  created_at_option_description: Scc,
  call_details: xcc,
  call_id: Ecc,
  call_information: Tcc,
  sentiment: Acc,
  disconnect_reason: Ccc,
  call_summary: zcc,
  transcription: Occ,
  event_details: Pcc,
  agent: Icc,
  no_transcript_available: Rcc,
  testing_sms_workflow_info_message: Ncc,
  start_from_scratch_title: Dcc,
  start_from_scratch_description: Mcc,
  cal_ai_template_title: Lcc,
  cal_ai_template_description: qcc,
  voice: jcc,
  select_voice: Fcc,
  select_voice_for_agent: Vcc,
  choose_a_voice_for_your_agent: Bcc,
  trait: Ucc,
  voice_id: Wcc,
  use_voice: Gcc,
  current_voice: Hcc,
  setup_incoming_agent: Kcc,
  setup_incoming_agent_description: Ycc,
  connect_a_phone_number_first: Zcc,
  setup_agent_for_incoming_calls: Qcc,
  configure_agent_to_handle_incoming_calls: Jcc,
  incoming_calls: Xcc,
  outgoing_calls: elc,
  inbound_agent_setup_success: tlc,
  inbound_agent_configured: nlc,
  setup_inbound_agent: olc,
  please_select_event_type_first: rlc,
  edit_configuration: ilc,
  select_event_type_for_inbound_calls: alc,
  setup_inbound_agent_for_incoming_calls: slc,
  ADD_NEW_STRINGS_ABOVE_THIS_LINE_TO_PREVENT_MERGE_CONFLICTS: clc
}, JN = No({
  clientId: "",
  accessToken: "",
  organizationId: 0,
  options: { refreshUrl: "", apiUrl: "" },
  error: "",
  getClient: () => {
  },
  isEmbed: !1
}), po = () => Pn(JN), dlc = "get-me", sg = (e = !1) => {
  const t = `/${Pi.me}`;
  return go({
    queryKey: [dlc],
    queryFn: () => He == null ? void 0 : He.get(t).then((o) => {
      if (o.data.status === qt)
        return o.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!He.getAuthorizationHeader() && !e
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Vd = function() {
  return Vd = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Vd.apply(this, arguments);
};
function Jae(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function ulc(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function _lc(e) {
  var t = Ue();
  return Le(function() {
    t.current = e;
  }), t.current;
}
const plc = ({
  isEmbed: e,
  clientId: t,
  apiUrl: n,
  refreshUrl: o,
  onError: r,
  onSuccess: i
}) => {
  const a = _lc(t), [s, c] = ze(!1);
  return Le(() => {
    n && (He.setUrl(n), c(!0)), o && He.setRefreshUrl(o);
  }, [n, o]), Le(() => {
    if (!e && t && He.getUrl() && a !== t)
      try {
        He.get(`/provider/${t}`).then((l) => {
          l.data.status === qt && i(l.data.data), He.setClientIdHeader(t);
        }).catch((l) => {
          var d;
          ((d = l.response) == null ? void 0 : d.status) === 401 && r("Invalid oAuth Client.");
        });
      } catch (l) {
        console.error(l);
      }
  }, [e, t, r, a, i, He.getUrl()]), { isInit: s };
};
var Ax = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ax.exports;
(function(e, t) {
  (function() {
    var n, o = "4.17.21", r = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", l = 500, d = "__lodash_placeholder__", u = 1, _ = 2, p = 4, f = 1, g = 2, h = 1, b = 2, v = 4, $ = 8, k = 16, S = 32, O = 64, I = 128, D = 256, M = 512, N = 30, C = "...", P = 800, x = 16, w = 1, E = 2, T = 3, z = 1 / 0, j = 9007199254740991, q = 17976931348623157e292, V = NaN, F = 4294967295, L = F - 1, U = F >>> 1, W = [
      ["ary", I],
      ["bind", h],
      ["bindKey", b],
      ["curry", $],
      ["curryRight", k],
      ["flip", M],
      ["partial", S],
      ["partialRight", O],
      ["rearg", D]
    ], H = "[object Arguments]", Q = "[object Array]", X = "[object AsyncFunction]", re = "[object Boolean]", Z = "[object Date]", ee = "[object DOMException]", J = "[object Error]", oe = "[object Function]", ce = "[object GeneratorFunction]", de = "[object Map]", te = "[object Number]", ue = "[object Null]", le = "[object Object]", se = "[object Promise]", me = "[object Proxy]", pe = "[object RegExp]", be = "[object Set]", Se = "[object String]", Ae = "[object Symbol]", Ze = "[object Undefined]", Ge = "[object WeakMap]", rt = "[object WeakSet]", qe = "[object ArrayBuffer]", Xe = "[object DataView]", lt = "[object Float32Array]", Et = "[object Float64Array]", wt = "[object Int8Array]", nn = "[object Int16Array]", Dt = "[object Int32Array]", mt = "[object Uint8Array]", bt = "[object Uint8ClampedArray]", gn = "[object Uint16Array]", an = "[object Uint32Array]", Mn = /\b__p \+= '';/g, Ln = /\b(__p \+=) '' \+/g, un = /(__e\(.*?\)|\b__t\)) \+\n'';/g, qo = /&(?:amp|lt|gt|quot|#39);/g, cn = /[&<>"']/g, ln = RegExp(qo.source), kn = RegExp(cn.source), gt = /<%-([\s\S]+?)%>/g, Ot = /<%([\s\S]+?)%>/g, _n = /<%=([\s\S]+?)%>/g, wn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, so = /^\w*$/, rn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ht = /[\\^$.*+?()[\]{}|]/g, qn = RegExp(Ht.source), Bn = /^\s+/, Or = /\s/, oo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Zn = /\{\n\/\* \[wrapped with (.+)\] \*/, st = /,? & /, ft = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, yt = /[()=,{}\[\]\/\s]/, on = /\\(\\)?/g, Ut = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nt = /\w*$/, Kt = /^[-+]0x[0-9a-f]+$/i, At = /^0b[01]+$/i, Mt = /^\[object .+?Constructor\]$/, Ie = /^0o[0-7]+$/i, tt = /^(?:0|[1-9]\d*)$/, zt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $t = /($^)/, In = /['\n\r\u2028\u2029\\]/g, xe = "\\ud800-\\udfff", je = "\\u0300-\\u036f", pt = "\\ufe20-\\ufe2f", Jt = "\\u20d0-\\u20ff", Ye = je + pt + Jt, mn = "\\u2700-\\u27bf", Co = "a-z\\xdf-\\xf6\\xf8-\\xff", zo = "\\xac\\xb1\\xd7\\xf7", Di = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ti = "\\u2000-\\u206f", Ds = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", xu = "A-Z\\xc0-\\xd6\\xd8-\\xde", Bk = "\\ufe0e\\ufe0f", Uk = zo + Di + Ti + Ds, Db = "['’]", xg = "[" + xe + "]", Mb = "[" + Uk + "]", pm = "[" + Ye + "]", Lb = "\\d+", Wk = "[" + mn + "]", qb = "[" + Co + "]", jb = "[^" + xe + Uk + Lb + mn + Co + xu + "]", Fb = "\\ud83c[\\udffb-\\udfff]", $z = "(?:" + pm + "|" + Fb + ")", Gk = "[^" + xe + "]", Vb = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bb = "[\\ud800-\\udbff][\\udc00-\\udfff]", Bo = "[" + xu + "]", Ub = "\\u200d", Wb = "(?:" + qb + "|" + jb + ")", ma = "(?:" + Bo + "|" + jb + ")", Ol = "(?:" + Db + "(?:d|ll|m|re|s|t|ve))?", U_ = "(?:" + Db + "(?:D|LL|M|RE|S|T|VE))?", Gb = $z + "?", W_ = "[" + Bk + "]?", Hk = "(?:" + Ub + "(?:" + [Gk, Vb, Bb].join("|") + ")" + W_ + Gb + ")*", Hb = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wz = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Eg = W_ + Gb + Hk, G_ = "(?:" + [Wk, Vb, Bb].join("|") + ")" + Eg, Kk = "(?:" + [Gk + pm + "?", pm, Vb, Bb, xg].join("|") + ")", wd = RegExp(Db, "g"), Tg = RegExp(pm, "g"), Eu = RegExp(Fb + "(?=" + Fb + ")|" + Kk + Eg, "g"), oi = RegExp([
      Bo + "?" + qb + "+" + Ol + "(?=" + [Mb, Bo, "$"].join("|") + ")",
      ma + "+" + U_ + "(?=" + [Mb, Bo + Wb, "$"].join("|") + ")",
      Bo + "?" + Wb + "+" + Ol,
      Bo + "+" + U_,
      wz,
      Hb,
      Lb,
      G_
    ].join("|"), "g"), Yk = RegExp("[" + Ub + xe + Ye + Bk + "]"), Kb = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Zk = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Ag = -1, xr = {};
    xr[lt] = xr[Et] = xr[wt] = xr[nn] = xr[Dt] = xr[mt] = xr[bt] = xr[gn] = xr[an] = !0, xr[H] = xr[Q] = xr[qe] = xr[re] = xr[Xe] = xr[Z] = xr[J] = xr[oe] = xr[de] = xr[te] = xr[le] = xr[pe] = xr[be] = xr[Se] = xr[Ge] = !1;
    var ho = {};
    ho[H] = ho[Q] = ho[qe] = ho[Xe] = ho[re] = ho[Z] = ho[lt] = ho[Et] = ho[wt] = ho[nn] = ho[Dt] = ho[de] = ho[te] = ho[le] = ho[pe] = ho[be] = ho[Se] = ho[Ae] = ho[mt] = ho[bt] = ho[gn] = ho[an] = !0, ho[J] = ho[oe] = ho[Ge] = !1;
    var H_ = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, K_ = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Y_ = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Qk = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Jk = parseFloat, Yb = parseInt, Zb = typeof Je == "object" && Je && Je.Object === Object && Je, kz = typeof self == "object" && self && self.Object === Object && self, Mi = Zb || kz || Function("return this")(), mm = t && !t.nodeType && t, Tu = mm && !0 && e && !e.nodeType && e, Qb = Tu && Tu.exports === mm, Jb = Qb && Zb.process, cs = function() {
      try {
        var we = Tu && Tu.require && Tu.require("util").types;
        return we || Jb && Jb.binding && Jb.binding("util");
      } catch {
      }
    }(), Xk = cs && cs.isArrayBuffer, e1 = cs && cs.isDate, Au = cs && cs.isMap, fm = cs && cs.isRegExp, Xb = cs && cs.isSet, Cg = cs && cs.isTypedArray;
    function co(we, Me, Ne) {
      switch (Ne.length) {
        case 0:
          return we.call(Me);
        case 1:
          return we.call(Me, Ne[0]);
        case 2:
          return we.call(Me, Ne[0], Ne[1]);
        case 3:
          return we.call(Me, Ne[0], Ne[1], Ne[2]);
      }
      return we.apply(Me, Ne);
    }
    function t1(we, Me, Ne, _t) {
      for (var Pt = -1, fn = we == null ? 0 : we.length; ++Pt < fn; ) {
        var Jo = we[Pt];
        Me(_t, Jo, Ne(Jo), we);
      }
      return _t;
    }
    function ls(we, Me) {
      for (var Ne = -1, _t = we == null ? 0 : we.length; ++Ne < _t && Me(we[Ne], Ne, we) !== !1; )
        ;
      return we;
    }
    function n1(we, Me) {
      for (var Ne = we == null ? 0 : we.length; Ne-- && Me(we[Ne], Ne, we) !== !1; )
        ;
      return we;
    }
    function cc(we, Me) {
      for (var Ne = -1, _t = we == null ? 0 : we.length; ++Ne < _t; )
        if (!Me(we[Ne], Ne, we))
          return !1;
      return !0;
    }
    function Hc(we, Me) {
      for (var Ne = -1, _t = we == null ? 0 : we.length, Pt = 0, fn = []; ++Ne < _t; ) {
        var Jo = we[Ne];
        Me(Jo, Ne, we) && (fn[Pt++] = Jo);
      }
      return fn;
    }
    function gm(we, Me) {
      var Ne = we == null ? 0 : we.length;
      return !!Ne && kd(we, Me, 0) > -1;
    }
    function zg(we, Me, Ne) {
      for (var _t = -1, Pt = we == null ? 0 : we.length; ++_t < Pt; )
        if (Ne(Me, we[_t]))
          return !0;
      return !1;
    }
    function yo(we, Me) {
      for (var Ne = -1, _t = we == null ? 0 : we.length, Pt = Array(_t); ++Ne < _t; )
        Pt[Ne] = Me(we[Ne], Ne, we);
      return Pt;
    }
    function Mr(we, Me) {
      for (var Ne = -1, _t = Me.length, Pt = we.length; ++Ne < _t; )
        we[Pt + Ne] = Me[Ne];
      return we;
    }
    function Z_(we, Me, Ne, _t) {
      var Pt = -1, fn = we == null ? 0 : we.length;
      for (_t && fn && (Ne = we[++Pt]); ++Pt < fn; )
        Ne = Me(Ne, we[Pt], Pt, we);
      return Ne;
    }
    function o1(we, Me, Ne, _t) {
      var Pt = we == null ? 0 : we.length;
      for (_t && Pt && (Ne = we[--Pt]); Pt--; )
        Ne = Me(Ne, we[Pt], Pt, we);
      return Ne;
    }
    function ey(we, Me) {
      for (var Ne = -1, _t = we == null ? 0 : we.length; ++Ne < _t; )
        if (Me(we[Ne], Ne, we))
          return !0;
      return !1;
    }
    var Sz = Ms("length");
    function Lr(we) {
      return we.split("");
    }
    function ty(we) {
      return we.match(ft) || [];
    }
    function ny(we, Me, Ne) {
      var _t;
      return Ne(we, function(Pt, fn, Jo) {
        if (Me(Pt, fn, Jo))
          return _t = fn, !1;
      }), _t;
    }
    function Ki(we, Me, Ne, _t) {
      for (var Pt = we.length, fn = Ne + (_t ? 1 : -1); _t ? fn-- : ++fn < Pt; )
        if (Me(we[fn], fn, we))
          return fn;
      return -1;
    }
    function kd(we, Me, Ne) {
      return Me === Me ? Tz(we, Me, Ne) : Ki(we, oy, Ne);
    }
    function r1(we, Me, Ne, _t) {
      for (var Pt = Ne - 1, fn = we.length; ++Pt < fn; )
        if (_t(we[Pt], Me))
          return Pt;
      return -1;
    }
    function oy(we) {
      return we !== we;
    }
    function Og(we, Me) {
      var Ne = we == null ? 0 : we.length;
      return Ne ? Ig(we, Me) / Ne : V;
    }
    function Ms(we) {
      return function(Me) {
        return Me == null ? n : Me[we];
      };
    }
    function Pg(we) {
      return function(Me) {
        return we == null ? n : we[Me];
      };
    }
    function hm(we, Me, Ne, _t, Pt) {
      return Pt(we, function(fn, Jo, $o) {
        Ne = _t ? (_t = !1, fn) : Me(Ne, fn, Jo, $o);
      }), Ne;
    }
    function i1(we, Me) {
      var Ne = we.length;
      for (we.sort(Me); Ne--; )
        we[Ne] = we[Ne].value;
      return we;
    }
    function Ig(we, Me) {
      for (var Ne, _t = -1, Pt = we.length; ++_t < Pt; ) {
        var fn = Me(we[_t]);
        fn !== n && (Ne = Ne === n ? fn : Ne + fn);
      }
      return Ne;
    }
    function vm(we, Me) {
      for (var Ne = -1, _t = Array(we); ++Ne < we; )
        _t[Ne] = Me(Ne);
      return _t;
    }
    function ui(we, Me) {
      return yo(Me, function(Ne) {
        return [Ne, we[Ne]];
      });
    }
    function ry(we) {
      return we && we.slice(0, _e(we) + 1).replace(Bn, "");
    }
    function Da(we) {
      return function(Me) {
        return we(Me);
      };
    }
    function Sd(we, Me) {
      return yo(Me, function(Ne) {
        return we[Ne];
      });
    }
    function Pl(we, Me) {
      return we.has(Me);
    }
    function iy(we, Me) {
      for (var Ne = -1, _t = we.length; ++Ne < _t && kd(Me, we[Ne], 0) > -1; )
        ;
      return Ne;
    }
    function Rg(we, Me) {
      for (var Ne = we.length; Ne-- && kd(Me, we[Ne], 0) > -1; )
        ;
      return Ne;
    }
    function Kc(we, Me) {
      for (var Ne = we.length, _t = 0; Ne--; )
        we[Ne] === Me && ++_t;
      return _t;
    }
    var fa = Pg(H_), Ng = Pg(K_);
    function xz(we) {
      return "\\" + Qk[we];
    }
    function Ez(we, Me) {
      return we == null ? n : we[Me];
    }
    function Il(we) {
      return Yk.test(we);
    }
    function a1(we) {
      return Kb.test(we);
    }
    function s1(we) {
      for (var Me, Ne = []; !(Me = we.next()).done; )
        Ne.push(Me.value);
      return Ne;
    }
    function ay(we) {
      var Me = -1, Ne = Array(we.size);
      return we.forEach(function(_t, Pt) {
        Ne[++Me] = [Pt, _t];
      }), Ne;
    }
    function sy(we, Me) {
      return function(Ne) {
        return we(Me(Ne));
      };
    }
    function xd(we, Me) {
      for (var Ne = -1, _t = we.length, Pt = 0, fn = []; ++Ne < _t; ) {
        var Jo = we[Ne];
        (Jo === Me || Jo === d) && (we[Ne] = d, fn[Pt++] = Ne);
      }
      return fn;
    }
    function Dg(we) {
      var Me = -1, Ne = Array(we.size);
      return we.forEach(function(_t) {
        Ne[++Me] = _t;
      }), Ne;
    }
    function c1(we) {
      var Me = -1, Ne = Array(we.size);
      return we.forEach(function(_t) {
        Ne[++Me] = [_t, _t];
      }), Ne;
    }
    function Tz(we, Me, Ne) {
      for (var _t = Ne - 1, Pt = we.length; ++_t < Pt; )
        if (we[_t] === Me)
          return _t;
      return -1;
    }
    function R(we, Me, Ne) {
      for (var _t = Ne + 1; _t--; )
        if (we[_t] === Me)
          return _t;
      return _t;
    }
    function K(we) {
      return Il(we) ? ke(we) : Sz(we);
    }
    function ie(we) {
      return Il(we) ? Te(we) : Lr(we);
    }
    function _e(we) {
      for (var Me = we.length; Me-- && Or.test(we.charAt(Me)); )
        ;
      return Me;
    }
    var ge = Pg(Y_);
    function ke(we) {
      for (var Me = Eu.lastIndex = 0; Eu.test(we); )
        ++Me;
      return Me;
    }
    function Te(we) {
      return we.match(Eu) || [];
    }
    function Ve(we) {
      return we.match(oi) || [];
    }
    var et = function we(Me) {
      Me = Me == null ? Mi : nt.defaults(Mi.Object(), Me, nt.pick(Mi, Zk));
      var Ne = Me.Array, _t = Me.Date, Pt = Me.Error, fn = Me.Function, Jo = Me.Math, $o = Me.Object, Q_ = Me.RegExp, S1e = Me.String, Yc = Me.TypeError, l1 = Ne.prototype, x1e = fn.prototype, Mg = $o.prototype, d1 = Me["__core-js_shared__"], u1 = x1e.toString, mr = Mg.hasOwnProperty, E1e = 0, I7 = function() {
        var y = /[^.]+$/.exec(d1 && d1.keys && d1.keys.IE_PROTO || "");
        return y ? "Symbol(src)_1." + y : "";
      }(), _1 = Mg.toString, T1e = u1.call($o), A1e = Mi._, C1e = Q_(
        "^" + u1.call(mr).replace(Ht, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), p1 = Qb ? Me.Buffer : n, J_ = Me.Symbol, m1 = Me.Uint8Array, R7 = p1 ? p1.allocUnsafe : n, f1 = sy($o.getPrototypeOf, $o), N7 = $o.create, D7 = Mg.propertyIsEnumerable, g1 = l1.splice, M7 = J_ ? J_.isConcatSpreadable : n, cy = J_ ? J_.iterator : n, bm = J_ ? J_.toStringTag : n, h1 = function() {
        try {
          var y = Sm($o, "defineProperty");
          return y({}, "", {}), y;
        } catch {
        }
      }(), z1e = Me.clearTimeout !== Mi.clearTimeout && Me.clearTimeout, O1e = _t && _t.now !== Mi.Date.now && _t.now, P1e = Me.setTimeout !== Mi.setTimeout && Me.setTimeout, v1 = Jo.ceil, b1 = Jo.floor, Az = $o.getOwnPropertySymbols, I1e = p1 ? p1.isBuffer : n, L7 = Me.isFinite, R1e = l1.join, N1e = sy($o.keys, $o), Li = Jo.max, Ma = Jo.min, D1e = _t.now, M1e = Me.parseInt, q7 = Jo.random, L1e = l1.reverse, Cz = Sm(Me, "DataView"), ly = Sm(Me, "Map"), zz = Sm(Me, "Promise"), Lg = Sm(Me, "Set"), dy = Sm(Me, "WeakMap"), uy = Sm($o, "create"), y1 = dy && new dy(), qg = {}, q1e = xm(Cz), j1e = xm(ly), F1e = xm(zz), V1e = xm(Lg), B1e = xm(dy), $1 = J_ ? J_.prototype : n, _y = $1 ? $1.valueOf : n, j7 = $1 ? $1.toString : n;
      function he(y) {
        if (_i(y) && !ro(y) && !(y instanceof Oo)) {
          if (y instanceof Zc)
            return y;
          if (mr.call(y, "__wrapped__"))
            return FV(y);
        }
        return new Zc(y);
      }
      var jg = /* @__PURE__ */ function() {
        function y() {
        }
        return function(A) {
          if (!ri(A))
            return {};
          if (N7)
            return N7(A);
          y.prototype = A;
          var B = new y();
          return y.prototype = n, B;
        };
      }();
      function w1() {
      }
      function Zc(y, A) {
        this.__wrapped__ = y, this.__actions__ = [], this.__chain__ = !!A, this.__index__ = 0, this.__values__ = n;
      }
      he.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: gt,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ot,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: _n,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: he
        }
      }, he.prototype = w1.prototype, he.prototype.constructor = he, Zc.prototype = jg(w1.prototype), Zc.prototype.constructor = Zc;
      function Oo(y) {
        this.__wrapped__ = y, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = F, this.__views__ = [];
      }
      function U1e() {
        var y = new Oo(this.__wrapped__);
        return y.__actions__ = Ls(this.__actions__), y.__dir__ = this.__dir__, y.__filtered__ = this.__filtered__, y.__iteratees__ = Ls(this.__iteratees__), y.__takeCount__ = this.__takeCount__, y.__views__ = Ls(this.__views__), y;
      }
      function W1e() {
        if (this.__filtered__) {
          var y = new Oo(this);
          y.__dir__ = -1, y.__filtered__ = !0;
        } else
          y = this.clone(), y.__dir__ *= -1;
        return y;
      }
      function G1e() {
        var y = this.__wrapped__.value(), A = this.__dir__, B = ro(y), ne = A < 0, fe = B ? y.length : 0, ye = rSe(0, fe, this.__views__), Ee = ye.start, Re = ye.end, Be = Re - Ee, ct = ne ? Re : Ee - 1, dt = this.__iteratees__, ht = dt.length, Ft = 0, dn = Ma(Be, this.__takeCount__);
        if (!B || !ne && fe == Be && dn == Be)
          return dV(y, this.__actions__);
        var Cn = [];
        e:
          for (; Be-- && Ft < dn; ) {
            ct += A;
            for (var mo = -1, zn = y[ct]; ++mo < ht; ) {
              var So = dt[mo], Do = So.iteratee, uc = So.type, _s = Do(zn);
              if (uc == E)
                zn = _s;
              else if (!_s) {
                if (uc == w)
                  continue e;
                break e;
              }
            }
            Cn[Ft++] = zn;
          }
        return Cn;
      }
      Oo.prototype = jg(w1.prototype), Oo.prototype.constructor = Oo;
      function ym(y) {
        var A = -1, B = y == null ? 0 : y.length;
        for (this.clear(); ++A < B; ) {
          var ne = y[A];
          this.set(ne[0], ne[1]);
        }
      }
      function H1e() {
        this.__data__ = uy ? uy(null) : {}, this.size = 0;
      }
      function K1e(y) {
        var A = this.has(y) && delete this.__data__[y];
        return this.size -= A ? 1 : 0, A;
      }
      function Y1e(y) {
        var A = this.__data__;
        if (uy) {
          var B = A[y];
          return B === c ? n : B;
        }
        return mr.call(A, y) ? A[y] : n;
      }
      function Z1e(y) {
        var A = this.__data__;
        return uy ? A[y] !== n : mr.call(A, y);
      }
      function Q1e(y, A) {
        var B = this.__data__;
        return this.size += this.has(y) ? 0 : 1, B[y] = uy && A === n ? c : A, this;
      }
      ym.prototype.clear = H1e, ym.prototype.delete = K1e, ym.prototype.get = Y1e, ym.prototype.has = Z1e, ym.prototype.set = Q1e;
      function Cu(y) {
        var A = -1, B = y == null ? 0 : y.length;
        for (this.clear(); ++A < B; ) {
          var ne = y[A];
          this.set(ne[0], ne[1]);
        }
      }
      function J1e() {
        this.__data__ = [], this.size = 0;
      }
      function X1e(y) {
        var A = this.__data__, B = k1(A, y);
        if (B < 0)
          return !1;
        var ne = A.length - 1;
        return B == ne ? A.pop() : g1.call(A, B, 1), --this.size, !0;
      }
      function e2e(y) {
        var A = this.__data__, B = k1(A, y);
        return B < 0 ? n : A[B][1];
      }
      function t2e(y) {
        return k1(this.__data__, y) > -1;
      }
      function n2e(y, A) {
        var B = this.__data__, ne = k1(B, y);
        return ne < 0 ? (++this.size, B.push([y, A])) : B[ne][1] = A, this;
      }
      Cu.prototype.clear = J1e, Cu.prototype.delete = X1e, Cu.prototype.get = e2e, Cu.prototype.has = t2e, Cu.prototype.set = n2e;
      function zu(y) {
        var A = -1, B = y == null ? 0 : y.length;
        for (this.clear(); ++A < B; ) {
          var ne = y[A];
          this.set(ne[0], ne[1]);
        }
      }
      function o2e() {
        this.size = 0, this.__data__ = {
          hash: new ym(),
          map: new (ly || Cu)(),
          string: new ym()
        };
      }
      function r2e(y) {
        var A = N1(this, y).delete(y);
        return this.size -= A ? 1 : 0, A;
      }
      function i2e(y) {
        return N1(this, y).get(y);
      }
      function a2e(y) {
        return N1(this, y).has(y);
      }
      function s2e(y, A) {
        var B = N1(this, y), ne = B.size;
        return B.set(y, A), this.size += B.size == ne ? 0 : 1, this;
      }
      zu.prototype.clear = o2e, zu.prototype.delete = r2e, zu.prototype.get = i2e, zu.prototype.has = a2e, zu.prototype.set = s2e;
      function $m(y) {
        var A = -1, B = y == null ? 0 : y.length;
        for (this.__data__ = new zu(); ++A < B; )
          this.add(y[A]);
      }
      function c2e(y) {
        return this.__data__.set(y, c), this;
      }
      function l2e(y) {
        return this.__data__.has(y);
      }
      $m.prototype.add = $m.prototype.push = c2e, $m.prototype.has = l2e;
      function Rl(y) {
        var A = this.__data__ = new Cu(y);
        this.size = A.size;
      }
      function d2e() {
        this.__data__ = new Cu(), this.size = 0;
      }
      function u2e(y) {
        var A = this.__data__, B = A.delete(y);
        return this.size = A.size, B;
      }
      function _2e(y) {
        return this.__data__.get(y);
      }
      function p2e(y) {
        return this.__data__.has(y);
      }
      function m2e(y, A) {
        var B = this.__data__;
        if (B instanceof Cu) {
          var ne = B.__data__;
          if (!ly || ne.length < r - 1)
            return ne.push([y, A]), this.size = ++B.size, this;
          B = this.__data__ = new zu(ne);
        }
        return B.set(y, A), this.size = B.size, this;
      }
      Rl.prototype.clear = d2e, Rl.prototype.delete = u2e, Rl.prototype.get = _2e, Rl.prototype.has = p2e, Rl.prototype.set = m2e;
      function F7(y, A) {
        var B = ro(y), ne = !B && Em(y), fe = !B && !ne && op(y), ye = !B && !ne && !fe && Ug(y), Ee = B || ne || fe || ye, Re = Ee ? vm(y.length, S1e) : [], Be = Re.length;
        for (var ct in y)
          (A || mr.call(y, ct)) && !(Ee && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ct == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          fe && (ct == "offset" || ct == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          ye && (ct == "buffer" || ct == "byteLength" || ct == "byteOffset") || // Skip index properties.
          Ru(ct, Be))) && Re.push(ct);
        return Re;
      }
      function V7(y) {
        var A = y.length;
        return A ? y[Fz(0, A - 1)] : n;
      }
      function f2e(y, A) {
        return D1(Ls(y), wm(A, 0, y.length));
      }
      function g2e(y) {
        return D1(Ls(y));
      }
      function Oz(y, A, B) {
        (B !== n && !Nl(y[A], B) || B === n && !(A in y)) && Ou(y, A, B);
      }
      function py(y, A, B) {
        var ne = y[A];
        (!(mr.call(y, A) && Nl(ne, B)) || B === n && !(A in y)) && Ou(y, A, B);
      }
      function k1(y, A) {
        for (var B = y.length; B--; )
          if (Nl(y[B][0], A))
            return B;
        return -1;
      }
      function h2e(y, A, B, ne) {
        return X_(y, function(fe, ye, Ee) {
          A(ne, fe, B(fe), Ee);
        }), ne;
      }
      function B7(y, A) {
        return y && Td(A, Yi(A), y);
      }
      function v2e(y, A) {
        return y && Td(A, js(A), y);
      }
      function Ou(y, A, B) {
        A == "__proto__" && h1 ? h1(y, A, {
          configurable: !0,
          enumerable: !0,
          value: B,
          writable: !0
        }) : y[A] = B;
      }
      function Pz(y, A) {
        for (var B = -1, ne = A.length, fe = Ne(ne), ye = y == null; ++B < ne; )
          fe[B] = ye ? n : _O(y, A[B]);
        return fe;
      }
      function wm(y, A, B) {
        return y === y && (B !== n && (y = y <= B ? y : B), A !== n && (y = y >= A ? y : A)), y;
      }
      function Qc(y, A, B, ne, fe, ye) {
        var Ee, Re = A & u, Be = A & _, ct = A & p;
        if (B && (Ee = fe ? B(y, ne, fe, ye) : B(y)), Ee !== n)
          return Ee;
        if (!ri(y))
          return y;
        var dt = ro(y);
        if (dt) {
          if (Ee = aSe(y), !Re)
            return Ls(y, Ee);
        } else {
          var ht = La(y), Ft = ht == oe || ht == ce;
          if (op(y))
            return pV(y, Re);
          if (ht == le || ht == H || Ft && !fe) {
            if (Ee = Be || Ft ? {} : PV(y), !Re)
              return Be ? Y2e(y, v2e(Ee, y)) : K2e(y, B7(Ee, y));
          } else {
            if (!ho[ht])
              return fe ? y : {};
            Ee = sSe(y, ht, Re);
          }
        }
        ye || (ye = new Rl());
        var dn = ye.get(y);
        if (dn)
          return dn;
        ye.set(y, Ee), sB(y) ? y.forEach(function(zn) {
          Ee.add(Qc(zn, A, B, zn, y, ye));
        }) : iB(y) && y.forEach(function(zn, So) {
          Ee.set(So, Qc(zn, A, B, So, y, ye));
        });
        var Cn = ct ? Be ? Jz : Qz : Be ? js : Yi, mo = dt ? n : Cn(y);
        return ls(mo || y, function(zn, So) {
          mo && (So = zn, zn = y[So]), py(Ee, So, Qc(zn, A, B, So, y, ye));
        }), Ee;
      }
      function b2e(y) {
        var A = Yi(y);
        return function(B) {
          return U7(B, y, A);
        };
      }
      function U7(y, A, B) {
        var ne = B.length;
        if (y == null)
          return !ne;
        for (y = $o(y); ne--; ) {
          var fe = B[ne], ye = A[fe], Ee = y[fe];
          if (Ee === n && !(fe in y) || !ye(Ee))
            return !1;
        }
        return !0;
      }
      function W7(y, A, B) {
        if (typeof y != "function")
          throw new Yc(a);
        return yy(function() {
          y.apply(n, B);
        }, A);
      }
      function my(y, A, B, ne) {
        var fe = -1, ye = gm, Ee = !0, Re = y.length, Be = [], ct = A.length;
        if (!Re)
          return Be;
        B && (A = yo(A, Da(B))), ne ? (ye = zg, Ee = !1) : A.length >= r && (ye = Pl, Ee = !1, A = new $m(A));
        e:
          for (; ++fe < Re; ) {
            var dt = y[fe], ht = B == null ? dt : B(dt);
            if (dt = ne || dt !== 0 ? dt : 0, Ee && ht === ht) {
              for (var Ft = ct; Ft--; )
                if (A[Ft] === ht)
                  continue e;
              Be.push(dt);
            } else
              ye(A, ht, ne) || Be.push(dt);
          }
        return Be;
      }
      var X_ = vV(Ed), G7 = vV(Rz, !0);
      function y2e(y, A) {
        var B = !0;
        return X_(y, function(ne, fe, ye) {
          return B = !!A(ne, fe, ye), B;
        }), B;
      }
      function S1(y, A, B) {
        for (var ne = -1, fe = y.length; ++ne < fe; ) {
          var ye = y[ne], Ee = A(ye);
          if (Ee != null && (Re === n ? Ee === Ee && !dc(Ee) : B(Ee, Re)))
            var Re = Ee, Be = ye;
        }
        return Be;
      }
      function $2e(y, A, B, ne) {
        var fe = y.length;
        for (B = lo(B), B < 0 && (B = -B > fe ? 0 : fe + B), ne = ne === n || ne > fe ? fe : lo(ne), ne < 0 && (ne += fe), ne = B > ne ? 0 : lB(ne); B < ne; )
          y[B++] = A;
        return y;
      }
      function H7(y, A) {
        var B = [];
        return X_(y, function(ne, fe, ye) {
          A(ne, fe, ye) && B.push(ne);
        }), B;
      }
      function ga(y, A, B, ne, fe) {
        var ye = -1, Ee = y.length;
        for (B || (B = lSe), fe || (fe = []); ++ye < Ee; ) {
          var Re = y[ye];
          A > 0 && B(Re) ? A > 1 ? ga(Re, A - 1, B, ne, fe) : Mr(fe, Re) : ne || (fe[fe.length] = Re);
        }
        return fe;
      }
      var Iz = bV(), K7 = bV(!0);
      function Ed(y, A) {
        return y && Iz(y, A, Yi);
      }
      function Rz(y, A) {
        return y && K7(y, A, Yi);
      }
      function x1(y, A) {
        return Hc(A, function(B) {
          return Nu(y[B]);
        });
      }
      function km(y, A) {
        A = tp(A, y);
        for (var B = 0, ne = A.length; y != null && B < ne; )
          y = y[Ad(A[B++])];
        return B && B == ne ? y : n;
      }
      function Y7(y, A, B) {
        var ne = A(y);
        return ro(y) ? ne : Mr(ne, B(y));
      }
      function ds(y) {
        return y == null ? y === n ? Ze : ue : bm && bm in $o(y) ? oSe(y) : gSe(y);
      }
      function Nz(y, A) {
        return y > A;
      }
      function w2e(y, A) {
        return y != null && mr.call(y, A);
      }
      function k2e(y, A) {
        return y != null && A in $o(y);
      }
      function S2e(y, A, B) {
        return y >= Ma(A, B) && y < Li(A, B);
      }
      function Dz(y, A, B) {
        for (var ne = B ? zg : gm, fe = y[0].length, ye = y.length, Ee = ye, Re = Ne(ye), Be = 1 / 0, ct = []; Ee--; ) {
          var dt = y[Ee];
          Ee && A && (dt = yo(dt, Da(A))), Be = Ma(dt.length, Be), Re[Ee] = !B && (A || fe >= 120 && dt.length >= 120) ? new $m(Ee && dt) : n;
        }
        dt = y[0];
        var ht = -1, Ft = Re[0];
        e:
          for (; ++ht < fe && ct.length < Be; ) {
            var dn = dt[ht], Cn = A ? A(dn) : dn;
            if (dn = B || dn !== 0 ? dn : 0, !(Ft ? Pl(Ft, Cn) : ne(ct, Cn, B))) {
              for (Ee = ye; --Ee; ) {
                var mo = Re[Ee];
                if (!(mo ? Pl(mo, Cn) : ne(y[Ee], Cn, B)))
                  continue e;
              }
              Ft && Ft.push(Cn), ct.push(dn);
            }
          }
        return ct;
      }
      function x2e(y, A, B, ne) {
        return Ed(y, function(fe, ye, Ee) {
          A(ne, B(fe), ye, Ee);
        }), ne;
      }
      function fy(y, A, B) {
        A = tp(A, y), y = DV(y, A);
        var ne = y == null ? y : y[Ad(Xc(A))];
        return ne == null ? n : co(ne, y, B);
      }
      function Z7(y) {
        return _i(y) && ds(y) == H;
      }
      function E2e(y) {
        return _i(y) && ds(y) == qe;
      }
      function T2e(y) {
        return _i(y) && ds(y) == Z;
      }
      function gy(y, A, B, ne, fe) {
        return y === A ? !0 : y == null || A == null || !_i(y) && !_i(A) ? y !== y && A !== A : A2e(y, A, B, ne, gy, fe);
      }
      function A2e(y, A, B, ne, fe, ye) {
        var Ee = ro(y), Re = ro(A), Be = Ee ? Q : La(y), ct = Re ? Q : La(A);
        Be = Be == H ? le : Be, ct = ct == H ? le : ct;
        var dt = Be == le, ht = ct == le, Ft = Be == ct;
        if (Ft && op(y)) {
          if (!op(A))
            return !1;
          Ee = !0, dt = !1;
        }
        if (Ft && !dt)
          return ye || (ye = new Rl()), Ee || Ug(y) ? CV(y, A, B, ne, fe, ye) : tSe(y, A, Be, B, ne, fe, ye);
        if (!(B & f)) {
          var dn = dt && mr.call(y, "__wrapped__"), Cn = ht && mr.call(A, "__wrapped__");
          if (dn || Cn) {
            var mo = dn ? y.value() : y, zn = Cn ? A.value() : A;
            return ye || (ye = new Rl()), fe(mo, zn, B, ne, ye);
          }
        }
        return Ft ? (ye || (ye = new Rl()), nSe(y, A, B, ne, fe, ye)) : !1;
      }
      function C2e(y) {
        return _i(y) && La(y) == de;
      }
      function Mz(y, A, B, ne) {
        var fe = B.length, ye = fe, Ee = !ne;
        if (y == null)
          return !ye;
        for (y = $o(y); fe--; ) {
          var Re = B[fe];
          if (Ee && Re[2] ? Re[1] !== y[Re[0]] : !(Re[0] in y))
            return !1;
        }
        for (; ++fe < ye; ) {
          Re = B[fe];
          var Be = Re[0], ct = y[Be], dt = Re[1];
          if (Ee && Re[2]) {
            if (ct === n && !(Be in y))
              return !1;
          } else {
            var ht = new Rl();
            if (ne)
              var Ft = ne(ct, dt, Be, y, A, ht);
            if (!(Ft === n ? gy(dt, ct, f | g, ne, ht) : Ft))
              return !1;
          }
        }
        return !0;
      }
      function Q7(y) {
        if (!ri(y) || uSe(y))
          return !1;
        var A = Nu(y) ? C1e : Mt;
        return A.test(xm(y));
      }
      function z2e(y) {
        return _i(y) && ds(y) == pe;
      }
      function O2e(y) {
        return _i(y) && La(y) == be;
      }
      function P2e(y) {
        return _i(y) && V1(y.length) && !!xr[ds(y)];
      }
      function J7(y) {
        return typeof y == "function" ? y : y == null ? Fs : typeof y == "object" ? ro(y) ? tV(y[0], y[1]) : eV(y) : yB(y);
      }
      function Lz(y) {
        if (!by(y))
          return N1e(y);
        var A = [];
        for (var B in $o(y))
          mr.call(y, B) && B != "constructor" && A.push(B);
        return A;
      }
      function I2e(y) {
        if (!ri(y))
          return fSe(y);
        var A = by(y), B = [];
        for (var ne in y)
          ne == "constructor" && (A || !mr.call(y, ne)) || B.push(ne);
        return B;
      }
      function qz(y, A) {
        return y < A;
      }
      function X7(y, A) {
        var B = -1, ne = qs(y) ? Ne(y.length) : [];
        return X_(y, function(fe, ye, Ee) {
          ne[++B] = A(fe, ye, Ee);
        }), ne;
      }
      function eV(y) {
        var A = eO(y);
        return A.length == 1 && A[0][2] ? RV(A[0][0], A[0][1]) : function(B) {
          return B === y || Mz(B, y, A);
        };
      }
      function tV(y, A) {
        return nO(y) && IV(A) ? RV(Ad(y), A) : function(B) {
          var ne = _O(B, y);
          return ne === n && ne === A ? pO(B, y) : gy(A, ne, f | g);
        };
      }
      function E1(y, A, B, ne, fe) {
        y !== A && Iz(A, function(ye, Ee) {
          if (fe || (fe = new Rl()), ri(ye))
            R2e(y, A, Ee, B, E1, ne, fe);
          else {
            var Re = ne ? ne(rO(y, Ee), ye, Ee + "", y, A, fe) : n;
            Re === n && (Re = ye), Oz(y, Ee, Re);
          }
        }, js);
      }
      function R2e(y, A, B, ne, fe, ye, Ee) {
        var Re = rO(y, B), Be = rO(A, B), ct = Ee.get(Be);
        if (ct) {
          Oz(y, B, ct);
          return;
        }
        var dt = ye ? ye(Re, Be, B + "", y, A, Ee) : n, ht = dt === n;
        if (ht) {
          var Ft = ro(Be), dn = !Ft && op(Be), Cn = !Ft && !dn && Ug(Be);
          dt = Be, Ft || dn || Cn ? ro(Re) ? dt = Re : yi(Re) ? dt = Ls(Re) : dn ? (ht = !1, dt = pV(Be, !0)) : Cn ? (ht = !1, dt = mV(Be, !0)) : dt = [] : $y(Be) || Em(Be) ? (dt = Re, Em(Re) ? dt = dB(Re) : (!ri(Re) || Nu(Re)) && (dt = PV(Be))) : ht = !1;
        }
        ht && (Ee.set(Be, dt), fe(dt, Be, ne, ye, Ee), Ee.delete(Be)), Oz(y, B, dt);
      }
      function nV(y, A) {
        var B = y.length;
        if (B)
          return A += A < 0 ? B : 0, Ru(A, B) ? y[A] : n;
      }
      function oV(y, A, B) {
        A.length ? A = yo(A, function(ye) {
          return ro(ye) ? function(Ee) {
            return km(Ee, ye.length === 1 ? ye[0] : ye);
          } : ye;
        }) : A = [Fs];
        var ne = -1;
        A = yo(A, Da(Sn()));
        var fe = X7(y, function(ye, Ee, Re) {
          var Be = yo(A, function(ct) {
            return ct(ye);
          });
          return { criteria: Be, index: ++ne, value: ye };
        });
        return i1(fe, function(ye, Ee) {
          return H2e(ye, Ee, B);
        });
      }
      function N2e(y, A) {
        return rV(y, A, function(B, ne) {
          return pO(y, ne);
        });
      }
      function rV(y, A, B) {
        for (var ne = -1, fe = A.length, ye = {}; ++ne < fe; ) {
          var Ee = A[ne], Re = km(y, Ee);
          B(Re, Ee) && hy(ye, tp(Ee, y), Re);
        }
        return ye;
      }
      function D2e(y) {
        return function(A) {
          return km(A, y);
        };
      }
      function jz(y, A, B, ne) {
        var fe = ne ? r1 : kd, ye = -1, Ee = A.length, Re = y;
        for (y === A && (A = Ls(A)), B && (Re = yo(y, Da(B))); ++ye < Ee; )
          for (var Be = 0, ct = A[ye], dt = B ? B(ct) : ct; (Be = fe(Re, dt, Be, ne)) > -1; )
            Re !== y && g1.call(Re, Be, 1), g1.call(y, Be, 1);
        return y;
      }
      function iV(y, A) {
        for (var B = y ? A.length : 0, ne = B - 1; B--; ) {
          var fe = A[B];
          if (B == ne || fe !== ye) {
            var ye = fe;
            Ru(fe) ? g1.call(y, fe, 1) : Uz(y, fe);
          }
        }
        return y;
      }
      function Fz(y, A) {
        return y + b1(q7() * (A - y + 1));
      }
      function M2e(y, A, B, ne) {
        for (var fe = -1, ye = Li(v1((A - y) / (B || 1)), 0), Ee = Ne(ye); ye--; )
          Ee[ne ? ye : ++fe] = y, y += B;
        return Ee;
      }
      function Vz(y, A) {
        var B = "";
        if (!y || A < 1 || A > j)
          return B;
        do
          A % 2 && (B += y), A = b1(A / 2), A && (y += y);
        while (A);
        return B;
      }
      function vo(y, A) {
        return iO(NV(y, A, Fs), y + "");
      }
      function L2e(y) {
        return V7(Wg(y));
      }
      function q2e(y, A) {
        var B = Wg(y);
        return D1(B, wm(A, 0, B.length));
      }
      function hy(y, A, B, ne) {
        if (!ri(y))
          return y;
        A = tp(A, y);
        for (var fe = -1, ye = A.length, Ee = ye - 1, Re = y; Re != null && ++fe < ye; ) {
          var Be = Ad(A[fe]), ct = B;
          if (Be === "__proto__" || Be === "constructor" || Be === "prototype")
            return y;
          if (fe != Ee) {
            var dt = Re[Be];
            ct = ne ? ne(dt, Be, Re) : n, ct === n && (ct = ri(dt) ? dt : Ru(A[fe + 1]) ? [] : {});
          }
          py(Re, Be, ct), Re = Re[Be];
        }
        return y;
      }
      var aV = y1 ? function(y, A) {
        return y1.set(y, A), y;
      } : Fs, j2e = h1 ? function(y, A) {
        return h1(y, "toString", {
          configurable: !0,
          enumerable: !1,
          value: fO(A),
          writable: !0
        });
      } : Fs;
      function F2e(y) {
        return D1(Wg(y));
      }
      function Jc(y, A, B) {
        var ne = -1, fe = y.length;
        A < 0 && (A = -A > fe ? 0 : fe + A), B = B > fe ? fe : B, B < 0 && (B += fe), fe = A > B ? 0 : B - A >>> 0, A >>>= 0;
        for (var ye = Ne(fe); ++ne < fe; )
          ye[ne] = y[ne + A];
        return ye;
      }
      function V2e(y, A) {
        var B;
        return X_(y, function(ne, fe, ye) {
          return B = A(ne, fe, ye), !B;
        }), !!B;
      }
      function T1(y, A, B) {
        var ne = 0, fe = y == null ? ne : y.length;
        if (typeof A == "number" && A === A && fe <= U) {
          for (; ne < fe; ) {
            var ye = ne + fe >>> 1, Ee = y[ye];
            Ee !== null && !dc(Ee) && (B ? Ee <= A : Ee < A) ? ne = ye + 1 : fe = ye;
          }
          return fe;
        }
        return Bz(y, A, Fs, B);
      }
      function Bz(y, A, B, ne) {
        var fe = 0, ye = y == null ? 0 : y.length;
        if (ye === 0)
          return 0;
        A = B(A);
        for (var Ee = A !== A, Re = A === null, Be = dc(A), ct = A === n; fe < ye; ) {
          var dt = b1((fe + ye) / 2), ht = B(y[dt]), Ft = ht !== n, dn = ht === null, Cn = ht === ht, mo = dc(ht);
          if (Ee)
            var zn = ne || Cn;
          else
            ct ? zn = Cn && (ne || Ft) : Re ? zn = Cn && Ft && (ne || !dn) : Be ? zn = Cn && Ft && !dn && (ne || !mo) : dn || mo ? zn = !1 : zn = ne ? ht <= A : ht < A;
          zn ? fe = dt + 1 : ye = dt;
        }
        return Ma(ye, L);
      }
      function sV(y, A) {
        for (var B = -1, ne = y.length, fe = 0, ye = []; ++B < ne; ) {
          var Ee = y[B], Re = A ? A(Ee) : Ee;
          if (!B || !Nl(Re, Be)) {
            var Be = Re;
            ye[fe++] = Ee === 0 ? 0 : Ee;
          }
        }
        return ye;
      }
      function cV(y) {
        return typeof y == "number" ? y : dc(y) ? V : +y;
      }
      function lc(y) {
        if (typeof y == "string")
          return y;
        if (ro(y))
          return yo(y, lc) + "";
        if (dc(y))
          return j7 ? j7.call(y) : "";
        var A = y + "";
        return A == "0" && 1 / y == -z ? "-0" : A;
      }
      function ep(y, A, B) {
        var ne = -1, fe = gm, ye = y.length, Ee = !0, Re = [], Be = Re;
        if (B)
          Ee = !1, fe = zg;
        else if (ye >= r) {
          var ct = A ? null : X2e(y);
          if (ct)
            return Dg(ct);
          Ee = !1, fe = Pl, Be = new $m();
        } else
          Be = A ? [] : Re;
        e:
          for (; ++ne < ye; ) {
            var dt = y[ne], ht = A ? A(dt) : dt;
            if (dt = B || dt !== 0 ? dt : 0, Ee && ht === ht) {
              for (var Ft = Be.length; Ft--; )
                if (Be[Ft] === ht)
                  continue e;
              A && Be.push(ht), Re.push(dt);
            } else
              fe(Be, ht, B) || (Be !== Re && Be.push(ht), Re.push(dt));
          }
        return Re;
      }
      function Uz(y, A) {
        return A = tp(A, y), y = DV(y, A), y == null || delete y[Ad(Xc(A))];
      }
      function lV(y, A, B, ne) {
        return hy(y, A, B(km(y, A)), ne);
      }
      function A1(y, A, B, ne) {
        for (var fe = y.length, ye = ne ? fe : -1; (ne ? ye-- : ++ye < fe) && A(y[ye], ye, y); )
          ;
        return B ? Jc(y, ne ? 0 : ye, ne ? ye + 1 : fe) : Jc(y, ne ? ye + 1 : 0, ne ? fe : ye);
      }
      function dV(y, A) {
        var B = y;
        return B instanceof Oo && (B = B.value()), Z_(A, function(ne, fe) {
          return fe.func.apply(fe.thisArg, Mr([ne], fe.args));
        }, B);
      }
      function Wz(y, A, B) {
        var ne = y.length;
        if (ne < 2)
          return ne ? ep(y[0]) : [];
        for (var fe = -1, ye = Ne(ne); ++fe < ne; )
          for (var Ee = y[fe], Re = -1; ++Re < ne; )
            Re != fe && (ye[fe] = my(ye[fe] || Ee, y[Re], A, B));
        return ep(ga(ye, 1), A, B);
      }
      function uV(y, A, B) {
        for (var ne = -1, fe = y.length, ye = A.length, Ee = {}; ++ne < fe; ) {
          var Re = ne < ye ? A[ne] : n;
          B(Ee, y[ne], Re);
        }
        return Ee;
      }
      function Gz(y) {
        return yi(y) ? y : [];
      }
      function Hz(y) {
        return typeof y == "function" ? y : Fs;
      }
      function tp(y, A) {
        return ro(y) ? y : nO(y, A) ? [y] : jV(cr(y));
      }
      var B2e = vo;
      function np(y, A, B) {
        var ne = y.length;
        return B = B === n ? ne : B, !A && B >= ne ? y : Jc(y, A, B);
      }
      var _V = z1e || function(y) {
        return Mi.clearTimeout(y);
      };
      function pV(y, A) {
        if (A)
          return y.slice();
        var B = y.length, ne = R7 ? R7(B) : new y.constructor(B);
        return y.copy(ne), ne;
      }
      function Kz(y) {
        var A = new y.constructor(y.byteLength);
        return new m1(A).set(new m1(y)), A;
      }
      function U2e(y, A) {
        var B = A ? Kz(y.buffer) : y.buffer;
        return new y.constructor(B, y.byteOffset, y.byteLength);
      }
      function W2e(y) {
        var A = new y.constructor(y.source, Nt.exec(y));
        return A.lastIndex = y.lastIndex, A;
      }
      function G2e(y) {
        return _y ? $o(_y.call(y)) : {};
      }
      function mV(y, A) {
        var B = A ? Kz(y.buffer) : y.buffer;
        return new y.constructor(B, y.byteOffset, y.length);
      }
      function fV(y, A) {
        if (y !== A) {
          var B = y !== n, ne = y === null, fe = y === y, ye = dc(y), Ee = A !== n, Re = A === null, Be = A === A, ct = dc(A);
          if (!Re && !ct && !ye && y > A || ye && Ee && Be && !Re && !ct || ne && Ee && Be || !B && Be || !fe)
            return 1;
          if (!ne && !ye && !ct && y < A || ct && B && fe && !ne && !ye || Re && B && fe || !Ee && fe || !Be)
            return -1;
        }
        return 0;
      }
      function H2e(y, A, B) {
        for (var ne = -1, fe = y.criteria, ye = A.criteria, Ee = fe.length, Re = B.length; ++ne < Ee; ) {
          var Be = fV(fe[ne], ye[ne]);
          if (Be) {
            if (ne >= Re)
              return Be;
            var ct = B[ne];
            return Be * (ct == "desc" ? -1 : 1);
          }
        }
        return y.index - A.index;
      }
      function gV(y, A, B, ne) {
        for (var fe = -1, ye = y.length, Ee = B.length, Re = -1, Be = A.length, ct = Li(ye - Ee, 0), dt = Ne(Be + ct), ht = !ne; ++Re < Be; )
          dt[Re] = A[Re];
        for (; ++fe < Ee; )
          (ht || fe < ye) && (dt[B[fe]] = y[fe]);
        for (; ct--; )
          dt[Re++] = y[fe++];
        return dt;
      }
      function hV(y, A, B, ne) {
        for (var fe = -1, ye = y.length, Ee = -1, Re = B.length, Be = -1, ct = A.length, dt = Li(ye - Re, 0), ht = Ne(dt + ct), Ft = !ne; ++fe < dt; )
          ht[fe] = y[fe];
        for (var dn = fe; ++Be < ct; )
          ht[dn + Be] = A[Be];
        for (; ++Ee < Re; )
          (Ft || fe < ye) && (ht[dn + B[Ee]] = y[fe++]);
        return ht;
      }
      function Ls(y, A) {
        var B = -1, ne = y.length;
        for (A || (A = Ne(ne)); ++B < ne; )
          A[B] = y[B];
        return A;
      }
      function Td(y, A, B, ne) {
        var fe = !B;
        B || (B = {});
        for (var ye = -1, Ee = A.length; ++ye < Ee; ) {
          var Re = A[ye], Be = ne ? ne(B[Re], y[Re], Re, B, y) : n;
          Be === n && (Be = y[Re]), fe ? Ou(B, Re, Be) : py(B, Re, Be);
        }
        return B;
      }
      function K2e(y, A) {
        return Td(y, tO(y), A);
      }
      function Y2e(y, A) {
        return Td(y, zV(y), A);
      }
      function C1(y, A) {
        return function(B, ne) {
          var fe = ro(B) ? t1 : h2e, ye = A ? A() : {};
          return fe(B, y, Sn(ne, 2), ye);
        };
      }
      function Fg(y) {
        return vo(function(A, B) {
          var ne = -1, fe = B.length, ye = fe > 1 ? B[fe - 1] : n, Ee = fe > 2 ? B[2] : n;
          for (ye = y.length > 3 && typeof ye == "function" ? (fe--, ye) : n, Ee && us(B[0], B[1], Ee) && (ye = fe < 3 ? n : ye, fe = 1), A = $o(A); ++ne < fe; ) {
            var Re = B[ne];
            Re && y(A, Re, ne, ye);
          }
          return A;
        });
      }
      function vV(y, A) {
        return function(B, ne) {
          if (B == null)
            return B;
          if (!qs(B))
            return y(B, ne);
          for (var fe = B.length, ye = A ? fe : -1, Ee = $o(B); (A ? ye-- : ++ye < fe) && ne(Ee[ye], ye, Ee) !== !1; )
            ;
          return B;
        };
      }
      function bV(y) {
        return function(A, B, ne) {
          for (var fe = -1, ye = $o(A), Ee = ne(A), Re = Ee.length; Re--; ) {
            var Be = Ee[y ? Re : ++fe];
            if (B(ye[Be], Be, ye) === !1)
              break;
          }
          return A;
        };
      }
      function Z2e(y, A, B) {
        var ne = A & h, fe = vy(y);
        function ye() {
          var Ee = this && this !== Mi && this instanceof ye ? fe : y;
          return Ee.apply(ne ? B : this, arguments);
        }
        return ye;
      }
      function yV(y) {
        return function(A) {
          A = cr(A);
          var B = Il(A) ? ie(A) : n, ne = B ? B[0] : A.charAt(0), fe = B ? np(B, 1).join("") : A.slice(1);
          return ne[y]() + fe;
        };
      }
      function Vg(y) {
        return function(A) {
          return Z_(vB(hB(A).replace(wd, "")), y, "");
        };
      }
      function vy(y) {
        return function() {
          var A = arguments;
          switch (A.length) {
            case 0:
              return new y();
            case 1:
              return new y(A[0]);
            case 2:
              return new y(A[0], A[1]);
            case 3:
              return new y(A[0], A[1], A[2]);
            case 4:
              return new y(A[0], A[1], A[2], A[3]);
            case 5:
              return new y(A[0], A[1], A[2], A[3], A[4]);
            case 6:
              return new y(A[0], A[1], A[2], A[3], A[4], A[5]);
            case 7:
              return new y(A[0], A[1], A[2], A[3], A[4], A[5], A[6]);
          }
          var B = jg(y.prototype), ne = y.apply(B, A);
          return ri(ne) ? ne : B;
        };
      }
      function Q2e(y, A, B) {
        var ne = vy(y);
        function fe() {
          for (var ye = arguments.length, Ee = Ne(ye), Re = ye, Be = Bg(fe); Re--; )
            Ee[Re] = arguments[Re];
          var ct = ye < 3 && Ee[0] !== Be && Ee[ye - 1] !== Be ? [] : xd(Ee, Be);
          if (ye -= ct.length, ye < B)
            return xV(
              y,
              A,
              z1,
              fe.placeholder,
              n,
              Ee,
              ct,
              n,
              n,
              B - ye
            );
          var dt = this && this !== Mi && this instanceof fe ? ne : y;
          return co(dt, this, Ee);
        }
        return fe;
      }
      function $V(y) {
        return function(A, B, ne) {
          var fe = $o(A);
          if (!qs(A)) {
            var ye = Sn(B, 3);
            A = Yi(A), B = function(Re) {
              return ye(fe[Re], Re, fe);
            };
          }
          var Ee = y(A, B, ne);
          return Ee > -1 ? fe[ye ? A[Ee] : Ee] : n;
        };
      }
      function wV(y) {
        return Iu(function(A) {
          var B = A.length, ne = B, fe = Zc.prototype.thru;
          for (y && A.reverse(); ne--; ) {
            var ye = A[ne];
            if (typeof ye != "function")
              throw new Yc(a);
            if (fe && !Ee && R1(ye) == "wrapper")
              var Ee = new Zc([], !0);
          }
          for (ne = Ee ? ne : B; ++ne < B; ) {
            ye = A[ne];
            var Re = R1(ye), Be = Re == "wrapper" ? Xz(ye) : n;
            Be && oO(Be[0]) && Be[1] == (I | $ | S | D) && !Be[4].length && Be[9] == 1 ? Ee = Ee[R1(Be[0])].apply(Ee, Be[3]) : Ee = ye.length == 1 && oO(ye) ? Ee[Re]() : Ee.thru(ye);
          }
          return function() {
            var ct = arguments, dt = ct[0];
            if (Ee && ct.length == 1 && ro(dt))
              return Ee.plant(dt).value();
            for (var ht = 0, Ft = B ? A[ht].apply(this, ct) : dt; ++ht < B; )
              Ft = A[ht].call(this, Ft);
            return Ft;
          };
        });
      }
      function z1(y, A, B, ne, fe, ye, Ee, Re, Be, ct) {
        var dt = A & I, ht = A & h, Ft = A & b, dn = A & ($ | k), Cn = A & M, mo = Ft ? n : vy(y);
        function zn() {
          for (var So = arguments.length, Do = Ne(So), uc = So; uc--; )
            Do[uc] = arguments[uc];
          if (dn)
            var _s = Bg(zn), _c = Kc(Do, _s);
          if (ne && (Do = gV(Do, ne, fe, dn)), ye && (Do = hV(Do, ye, Ee, dn)), So -= _c, dn && So < ct) {
            var $i = xd(Do, _s);
            return xV(
              y,
              A,
              z1,
              zn.placeholder,
              B,
              Do,
              $i,
              Re,
              Be,
              ct - So
            );
          }
          var Dl = ht ? B : this, Mu = Ft ? Dl[y] : y;
          return So = Do.length, Re ? Do = hSe(Do, Re) : Cn && So > 1 && Do.reverse(), dt && Be < So && (Do.length = Be), this && this !== Mi && this instanceof zn && (Mu = mo || vy(Mu)), Mu.apply(Dl, Do);
        }
        return zn;
      }
      function kV(y, A) {
        return function(B, ne) {
          return x2e(B, y, A(ne), {});
        };
      }
      function O1(y, A) {
        return function(B, ne) {
          var fe;
          if (B === n && ne === n)
            return A;
          if (B !== n && (fe = B), ne !== n) {
            if (fe === n)
              return ne;
            typeof B == "string" || typeof ne == "string" ? (B = lc(B), ne = lc(ne)) : (B = cV(B), ne = cV(ne)), fe = y(B, ne);
          }
          return fe;
        };
      }
      function Yz(y) {
        return Iu(function(A) {
          return A = yo(A, Da(Sn())), vo(function(B) {
            var ne = this;
            return y(A, function(fe) {
              return co(fe, ne, B);
            });
          });
        });
      }
      function P1(y, A) {
        A = A === n ? " " : lc(A);
        var B = A.length;
        if (B < 2)
          return B ? Vz(A, y) : A;
        var ne = Vz(A, v1(y / K(A)));
        return Il(A) ? np(ie(ne), 0, y).join("") : ne.slice(0, y);
      }
      function J2e(y, A, B, ne) {
        var fe = A & h, ye = vy(y);
        function Ee() {
          for (var Re = -1, Be = arguments.length, ct = -1, dt = ne.length, ht = Ne(dt + Be), Ft = this && this !== Mi && this instanceof Ee ? ye : y; ++ct < dt; )
            ht[ct] = ne[ct];
          for (; Be--; )
            ht[ct++] = arguments[++Re];
          return co(Ft, fe ? B : this, ht);
        }
        return Ee;
      }
      function SV(y) {
        return function(A, B, ne) {
          return ne && typeof ne != "number" && us(A, B, ne) && (B = ne = n), A = Du(A), B === n ? (B = A, A = 0) : B = Du(B), ne = ne === n ? A < B ? 1 : -1 : Du(ne), M2e(A, B, ne, y);
        };
      }
      function I1(y) {
        return function(A, B) {
          return typeof A == "string" && typeof B == "string" || (A = el(A), B = el(B)), y(A, B);
        };
      }
      function xV(y, A, B, ne, fe, ye, Ee, Re, Be, ct) {
        var dt = A & $, ht = dt ? Ee : n, Ft = dt ? n : Ee, dn = dt ? ye : n, Cn = dt ? n : ye;
        A |= dt ? S : O, A &= ~(dt ? O : S), A & v || (A &= ~(h | b));
        var mo = [
          y,
          A,
          fe,
          dn,
          ht,
          Cn,
          Ft,
          Re,
          Be,
          ct
        ], zn = B.apply(n, mo);
        return oO(y) && MV(zn, mo), zn.placeholder = ne, LV(zn, y, A);
      }
      function Zz(y) {
        var A = Jo[y];
        return function(B, ne) {
          if (B = el(B), ne = ne == null ? 0 : Ma(lo(ne), 292), ne && L7(B)) {
            var fe = (cr(B) + "e").split("e"), ye = A(fe[0] + "e" + (+fe[1] + ne));
            return fe = (cr(ye) + "e").split("e"), +(fe[0] + "e" + (+fe[1] - ne));
          }
          return A(B);
        };
      }
      var X2e = Lg && 1 / Dg(new Lg([, -0]))[1] == z ? function(y) {
        return new Lg(y);
      } : vO;
      function EV(y) {
        return function(A) {
          var B = La(A);
          return B == de ? ay(A) : B == be ? c1(A) : ui(A, y(A));
        };
      }
      function Pu(y, A, B, ne, fe, ye, Ee, Re) {
        var Be = A & b;
        if (!Be && typeof y != "function")
          throw new Yc(a);
        var ct = ne ? ne.length : 0;
        if (ct || (A &= ~(S | O), ne = fe = n), Ee = Ee === n ? Ee : Li(lo(Ee), 0), Re = Re === n ? Re : lo(Re), ct -= fe ? fe.length : 0, A & O) {
          var dt = ne, ht = fe;
          ne = fe = n;
        }
        var Ft = Be ? n : Xz(y), dn = [
          y,
          A,
          B,
          ne,
          fe,
          dt,
          ht,
          ye,
          Ee,
          Re
        ];
        if (Ft && mSe(dn, Ft), y = dn[0], A = dn[1], B = dn[2], ne = dn[3], fe = dn[4], Re = dn[9] = dn[9] === n ? Be ? 0 : y.length : Li(dn[9] - ct, 0), !Re && A & ($ | k) && (A &= ~($ | k)), !A || A == h)
          var Cn = Z2e(y, A, B);
        else
          A == $ || A == k ? Cn = Q2e(y, A, Re) : (A == S || A == (h | S)) && !fe.length ? Cn = J2e(y, A, B, ne) : Cn = z1.apply(n, dn);
        var mo = Ft ? aV : MV;
        return LV(mo(Cn, dn), y, A);
      }
      function TV(y, A, B, ne) {
        return y === n || Nl(y, Mg[B]) && !mr.call(ne, B) ? A : y;
      }
      function AV(y, A, B, ne, fe, ye) {
        return ri(y) && ri(A) && (ye.set(A, y), E1(y, A, n, AV, ye), ye.delete(A)), y;
      }
      function eSe(y) {
        return $y(y) ? n : y;
      }
      function CV(y, A, B, ne, fe, ye) {
        var Ee = B & f, Re = y.length, Be = A.length;
        if (Re != Be && !(Ee && Be > Re))
          return !1;
        var ct = ye.get(y), dt = ye.get(A);
        if (ct && dt)
          return ct == A && dt == y;
        var ht = -1, Ft = !0, dn = B & g ? new $m() : n;
        for (ye.set(y, A), ye.set(A, y); ++ht < Re; ) {
          var Cn = y[ht], mo = A[ht];
          if (ne)
            var zn = Ee ? ne(mo, Cn, ht, A, y, ye) : ne(Cn, mo, ht, y, A, ye);
          if (zn !== n) {
            if (zn)
              continue;
            Ft = !1;
            break;
          }
          if (dn) {
            if (!ey(A, function(So, Do) {
              if (!Pl(dn, Do) && (Cn === So || fe(Cn, So, B, ne, ye)))
                return dn.push(Do);
            })) {
              Ft = !1;
              break;
            }
          } else if (!(Cn === mo || fe(Cn, mo, B, ne, ye))) {
            Ft = !1;
            break;
          }
        }
        return ye.delete(y), ye.delete(A), Ft;
      }
      function tSe(y, A, B, ne, fe, ye, Ee) {
        switch (B) {
          case Xe:
            if (y.byteLength != A.byteLength || y.byteOffset != A.byteOffset)
              return !1;
            y = y.buffer, A = A.buffer;
          case qe:
            return !(y.byteLength != A.byteLength || !ye(new m1(y), new m1(A)));
          case re:
          case Z:
          case te:
            return Nl(+y, +A);
          case J:
            return y.name == A.name && y.message == A.message;
          case pe:
          case Se:
            return y == A + "";
          case de:
            var Re = ay;
          case be:
            var Be = ne & f;
            if (Re || (Re = Dg), y.size != A.size && !Be)
              return !1;
            var ct = Ee.get(y);
            if (ct)
              return ct == A;
            ne |= g, Ee.set(y, A);
            var dt = CV(Re(y), Re(A), ne, fe, ye, Ee);
            return Ee.delete(y), dt;
          case Ae:
            if (_y)
              return _y.call(y) == _y.call(A);
        }
        return !1;
      }
      function nSe(y, A, B, ne, fe, ye) {
        var Ee = B & f, Re = Qz(y), Be = Re.length, ct = Qz(A), dt = ct.length;
        if (Be != dt && !Ee)
          return !1;
        for (var ht = Be; ht--; ) {
          var Ft = Re[ht];
          if (!(Ee ? Ft in A : mr.call(A, Ft)))
            return !1;
        }
        var dn = ye.get(y), Cn = ye.get(A);
        if (dn && Cn)
          return dn == A && Cn == y;
        var mo = !0;
        ye.set(y, A), ye.set(A, y);
        for (var zn = Ee; ++ht < Be; ) {
          Ft = Re[ht];
          var So = y[Ft], Do = A[Ft];
          if (ne)
            var uc = Ee ? ne(Do, So, Ft, A, y, ye) : ne(So, Do, Ft, y, A, ye);
          if (!(uc === n ? So === Do || fe(So, Do, B, ne, ye) : uc)) {
            mo = !1;
            break;
          }
          zn || (zn = Ft == "constructor");
        }
        if (mo && !zn) {
          var _s = y.constructor, _c = A.constructor;
          _s != _c && "constructor" in y && "constructor" in A && !(typeof _s == "function" && _s instanceof _s && typeof _c == "function" && _c instanceof _c) && (mo = !1);
        }
        return ye.delete(y), ye.delete(A), mo;
      }
      function Iu(y) {
        return iO(NV(y, n, UV), y + "");
      }
      function Qz(y) {
        return Y7(y, Yi, tO);
      }
      function Jz(y) {
        return Y7(y, js, zV);
      }
      var Xz = y1 ? function(y) {
        return y1.get(y);
      } : vO;
      function R1(y) {
        for (var A = y.name + "", B = qg[A], ne = mr.call(qg, A) ? B.length : 0; ne--; ) {
          var fe = B[ne], ye = fe.func;
          if (ye == null || ye == y)
            return fe.name;
        }
        return A;
      }
      function Bg(y) {
        var A = mr.call(he, "placeholder") ? he : y;
        return A.placeholder;
      }
      function Sn() {
        var y = he.iteratee || gO;
        return y = y === gO ? J7 : y, arguments.length ? y(arguments[0], arguments[1]) : y;
      }
      function N1(y, A) {
        var B = y.__data__;
        return dSe(A) ? B[typeof A == "string" ? "string" : "hash"] : B.map;
      }
      function eO(y) {
        for (var A = Yi(y), B = A.length; B--; ) {
          var ne = A[B], fe = y[ne];
          A[B] = [ne, fe, IV(fe)];
        }
        return A;
      }
      function Sm(y, A) {
        var B = Ez(y, A);
        return Q7(B) ? B : n;
      }
      function oSe(y) {
        var A = mr.call(y, bm), B = y[bm];
        try {
          y[bm] = n;
          var ne = !0;
        } catch {
        }
        var fe = _1.call(y);
        return ne && (A ? y[bm] = B : delete y[bm]), fe;
      }
      var tO = Az ? function(y) {
        return y == null ? [] : (y = $o(y), Hc(Az(y), function(A) {
          return D7.call(y, A);
        }));
      } : bO, zV = Az ? function(y) {
        for (var A = []; y; )
          Mr(A, tO(y)), y = f1(y);
        return A;
      } : bO, La = ds;
      (Cz && La(new Cz(new ArrayBuffer(1))) != Xe || ly && La(new ly()) != de || zz && La(zz.resolve()) != se || Lg && La(new Lg()) != be || dy && La(new dy()) != Ge) && (La = function(y) {
        var A = ds(y), B = A == le ? y.constructor : n, ne = B ? xm(B) : "";
        if (ne)
          switch (ne) {
            case q1e:
              return Xe;
            case j1e:
              return de;
            case F1e:
              return se;
            case V1e:
              return be;
            case B1e:
              return Ge;
          }
        return A;
      });
      function rSe(y, A, B) {
        for (var ne = -1, fe = B.length; ++ne < fe; ) {
          var ye = B[ne], Ee = ye.size;
          switch (ye.type) {
            case "drop":
              y += Ee;
              break;
            case "dropRight":
              A -= Ee;
              break;
            case "take":
              A = Ma(A, y + Ee);
              break;
            case "takeRight":
              y = Li(y, A - Ee);
              break;
          }
        }
        return { start: y, end: A };
      }
      function iSe(y) {
        var A = y.match(Zn);
        return A ? A[1].split(st) : [];
      }
      function OV(y, A, B) {
        A = tp(A, y);
        for (var ne = -1, fe = A.length, ye = !1; ++ne < fe; ) {
          var Ee = Ad(A[ne]);
          if (!(ye = y != null && B(y, Ee)))
            break;
          y = y[Ee];
        }
        return ye || ++ne != fe ? ye : (fe = y == null ? 0 : y.length, !!fe && V1(fe) && Ru(Ee, fe) && (ro(y) || Em(y)));
      }
      function aSe(y) {
        var A = y.length, B = new y.constructor(A);
        return A && typeof y[0] == "string" && mr.call(y, "index") && (B.index = y.index, B.input = y.input), B;
      }
      function PV(y) {
        return typeof y.constructor == "function" && !by(y) ? jg(f1(y)) : {};
      }
      function sSe(y, A, B) {
        var ne = y.constructor;
        switch (A) {
          case qe:
            return Kz(y);
          case re:
          case Z:
            return new ne(+y);
          case Xe:
            return U2e(y, B);
          case lt:
          case Et:
          case wt:
          case nn:
          case Dt:
          case mt:
          case bt:
          case gn:
          case an:
            return mV(y, B);
          case de:
            return new ne();
          case te:
          case Se:
            return new ne(y);
          case pe:
            return W2e(y);
          case be:
            return new ne();
          case Ae:
            return G2e(y);
        }
      }
      function cSe(y, A) {
        var B = A.length;
        if (!B)
          return y;
        var ne = B - 1;
        return A[ne] = (B > 1 ? "& " : "") + A[ne], A = A.join(B > 2 ? ", " : " "), y.replace(oo, `{
/* [wrapped with ` + A + `] */
`);
      }
      function lSe(y) {
        return ro(y) || Em(y) || !!(M7 && y && y[M7]);
      }
      function Ru(y, A) {
        var B = typeof y;
        return A = A ?? j, !!A && (B == "number" || B != "symbol" && tt.test(y)) && y > -1 && y % 1 == 0 && y < A;
      }
      function us(y, A, B) {
        if (!ri(B))
          return !1;
        var ne = typeof A;
        return (ne == "number" ? qs(B) && Ru(A, B.length) : ne == "string" && A in B) ? Nl(B[A], y) : !1;
      }
      function nO(y, A) {
        if (ro(y))
          return !1;
        var B = typeof y;
        return B == "number" || B == "symbol" || B == "boolean" || y == null || dc(y) ? !0 : so.test(y) || !wn.test(y) || A != null && y in $o(A);
      }
      function dSe(y) {
        var A = typeof y;
        return A == "string" || A == "number" || A == "symbol" || A == "boolean" ? y !== "__proto__" : y === null;
      }
      function oO(y) {
        var A = R1(y), B = he[A];
        if (typeof B != "function" || !(A in Oo.prototype))
          return !1;
        if (y === B)
          return !0;
        var ne = Xz(B);
        return !!ne && y === ne[0];
      }
      function uSe(y) {
        return !!I7 && I7 in y;
      }
      var _Se = d1 ? Nu : yO;
      function by(y) {
        var A = y && y.constructor, B = typeof A == "function" && A.prototype || Mg;
        return y === B;
      }
      function IV(y) {
        return y === y && !ri(y);
      }
      function RV(y, A) {
        return function(B) {
          return B == null ? !1 : B[y] === A && (A !== n || y in $o(B));
        };
      }
      function pSe(y) {
        var A = j1(y, function(ne) {
          return B.size === l && B.clear(), ne;
        }), B = A.cache;
        return A;
      }
      function mSe(y, A) {
        var B = y[1], ne = A[1], fe = B | ne, ye = fe < (h | b | I), Ee = ne == I && B == $ || ne == I && B == D && y[7].length <= A[8] || ne == (I | D) && A[7].length <= A[8] && B == $;
        if (!(ye || Ee))
          return y;
        ne & h && (y[2] = A[2], fe |= B & h ? 0 : v);
        var Re = A[3];
        if (Re) {
          var Be = y[3];
          y[3] = Be ? gV(Be, Re, A[4]) : Re, y[4] = Be ? xd(y[3], d) : A[4];
        }
        return Re = A[5], Re && (Be = y[5], y[5] = Be ? hV(Be, Re, A[6]) : Re, y[6] = Be ? xd(y[5], d) : A[6]), Re = A[7], Re && (y[7] = Re), ne & I && (y[8] = y[8] == null ? A[8] : Ma(y[8], A[8])), y[9] == null && (y[9] = A[9]), y[0] = A[0], y[1] = fe, y;
      }
      function fSe(y) {
        var A = [];
        if (y != null)
          for (var B in $o(y))
            A.push(B);
        return A;
      }
      function gSe(y) {
        return _1.call(y);
      }
      function NV(y, A, B) {
        return A = Li(A === n ? y.length - 1 : A, 0), function() {
          for (var ne = arguments, fe = -1, ye = Li(ne.length - A, 0), Ee = Ne(ye); ++fe < ye; )
            Ee[fe] = ne[A + fe];
          fe = -1;
          for (var Re = Ne(A + 1); ++fe < A; )
            Re[fe] = ne[fe];
          return Re[A] = B(Ee), co(y, this, Re);
        };
      }
      function DV(y, A) {
        return A.length < 2 ? y : km(y, Jc(A, 0, -1));
      }
      function hSe(y, A) {
        for (var B = y.length, ne = Ma(A.length, B), fe = Ls(y); ne--; ) {
          var ye = A[ne];
          y[ne] = Ru(ye, B) ? fe[ye] : n;
        }
        return y;
      }
      function rO(y, A) {
        if (!(A === "constructor" && typeof y[A] == "function") && A != "__proto__")
          return y[A];
      }
      var MV = qV(aV), yy = P1e || function(y, A) {
        return Mi.setTimeout(y, A);
      }, iO = qV(j2e);
      function LV(y, A, B) {
        var ne = A + "";
        return iO(y, cSe(ne, vSe(iSe(ne), B)));
      }
      function qV(y) {
        var A = 0, B = 0;
        return function() {
          var ne = D1e(), fe = x - (ne - B);
          if (B = ne, fe > 0) {
            if (++A >= P)
              return arguments[0];
          } else
            A = 0;
          return y.apply(n, arguments);
        };
      }
      function D1(y, A) {
        var B = -1, ne = y.length, fe = ne - 1;
        for (A = A === n ? ne : A; ++B < A; ) {
          var ye = Fz(B, fe), Ee = y[ye];
          y[ye] = y[B], y[B] = Ee;
        }
        return y.length = A, y;
      }
      var jV = pSe(function(y) {
        var A = [];
        return y.charCodeAt(0) === 46 && A.push(""), y.replace(rn, function(B, ne, fe, ye) {
          A.push(fe ? ye.replace(on, "$1") : ne || B);
        }), A;
      });
      function Ad(y) {
        if (typeof y == "string" || dc(y))
          return y;
        var A = y + "";
        return A == "0" && 1 / y == -z ? "-0" : A;
      }
      function xm(y) {
        if (y != null) {
          try {
            return u1.call(y);
          } catch {
          }
          try {
            return y + "";
          } catch {
          }
        }
        return "";
      }
      function vSe(y, A) {
        return ls(W, function(B) {
          var ne = "_." + B[0];
          A & B[1] && !gm(y, ne) && y.push(ne);
        }), y.sort();
      }
      function FV(y) {
        if (y instanceof Oo)
          return y.clone();
        var A = new Zc(y.__wrapped__, y.__chain__);
        return A.__actions__ = Ls(y.__actions__), A.__index__ = y.__index__, A.__values__ = y.__values__, A;
      }
      function bSe(y, A, B) {
        (B ? us(y, A, B) : A === n) ? A = 1 : A = Li(lo(A), 0);
        var ne = y == null ? 0 : y.length;
        if (!ne || A < 1)
          return [];
        for (var fe = 0, ye = 0, Ee = Ne(v1(ne / A)); fe < ne; )
          Ee[ye++] = Jc(y, fe, fe += A);
        return Ee;
      }
      function ySe(y) {
        for (var A = -1, B = y == null ? 0 : y.length, ne = 0, fe = []; ++A < B; ) {
          var ye = y[A];
          ye && (fe[ne++] = ye);
        }
        return fe;
      }
      function $Se() {
        var y = arguments.length;
        if (!y)
          return [];
        for (var A = Ne(y - 1), B = arguments[0], ne = y; ne--; )
          A[ne - 1] = arguments[ne];
        return Mr(ro(B) ? Ls(B) : [B], ga(A, 1));
      }
      var wSe = vo(function(y, A) {
        return yi(y) ? my(y, ga(A, 1, yi, !0)) : [];
      }), kSe = vo(function(y, A) {
        var B = Xc(A);
        return yi(B) && (B = n), yi(y) ? my(y, ga(A, 1, yi, !0), Sn(B, 2)) : [];
      }), SSe = vo(function(y, A) {
        var B = Xc(A);
        return yi(B) && (B = n), yi(y) ? my(y, ga(A, 1, yi, !0), n, B) : [];
      });
      function xSe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        return ne ? (A = B || A === n ? 1 : lo(A), Jc(y, A < 0 ? 0 : A, ne)) : [];
      }
      function ESe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        return ne ? (A = B || A === n ? 1 : lo(A), A = ne - A, Jc(y, 0, A < 0 ? 0 : A)) : [];
      }
      function TSe(y, A) {
        return y && y.length ? A1(y, Sn(A, 3), !0, !0) : [];
      }
      function ASe(y, A) {
        return y && y.length ? A1(y, Sn(A, 3), !0) : [];
      }
      function CSe(y, A, B, ne) {
        var fe = y == null ? 0 : y.length;
        return fe ? (B && typeof B != "number" && us(y, A, B) && (B = 0, ne = fe), $2e(y, A, B, ne)) : [];
      }
      function VV(y, A, B) {
        var ne = y == null ? 0 : y.length;
        if (!ne)
          return -1;
        var fe = B == null ? 0 : lo(B);
        return fe < 0 && (fe = Li(ne + fe, 0)), Ki(y, Sn(A, 3), fe);
      }
      function BV(y, A, B) {
        var ne = y == null ? 0 : y.length;
        if (!ne)
          return -1;
        var fe = ne - 1;
        return B !== n && (fe = lo(B), fe = B < 0 ? Li(ne + fe, 0) : Ma(fe, ne - 1)), Ki(y, Sn(A, 3), fe, !0);
      }
      function UV(y) {
        var A = y == null ? 0 : y.length;
        return A ? ga(y, 1) : [];
      }
      function zSe(y) {
        var A = y == null ? 0 : y.length;
        return A ? ga(y, z) : [];
      }
      function OSe(y, A) {
        var B = y == null ? 0 : y.length;
        return B ? (A = A === n ? 1 : lo(A), ga(y, A)) : [];
      }
      function PSe(y) {
        for (var A = -1, B = y == null ? 0 : y.length, ne = {}; ++A < B; ) {
          var fe = y[A];
          ne[fe[0]] = fe[1];
        }
        return ne;
      }
      function WV(y) {
        return y && y.length ? y[0] : n;
      }
      function ISe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        if (!ne)
          return -1;
        var fe = B == null ? 0 : lo(B);
        return fe < 0 && (fe = Li(ne + fe, 0)), kd(y, A, fe);
      }
      function RSe(y) {
        var A = y == null ? 0 : y.length;
        return A ? Jc(y, 0, -1) : [];
      }
      var NSe = vo(function(y) {
        var A = yo(y, Gz);
        return A.length && A[0] === y[0] ? Dz(A) : [];
      }), DSe = vo(function(y) {
        var A = Xc(y), B = yo(y, Gz);
        return A === Xc(B) ? A = n : B.pop(), B.length && B[0] === y[0] ? Dz(B, Sn(A, 2)) : [];
      }), MSe = vo(function(y) {
        var A = Xc(y), B = yo(y, Gz);
        return A = typeof A == "function" ? A : n, A && B.pop(), B.length && B[0] === y[0] ? Dz(B, n, A) : [];
      });
      function LSe(y, A) {
        return y == null ? "" : R1e.call(y, A);
      }
      function Xc(y) {
        var A = y == null ? 0 : y.length;
        return A ? y[A - 1] : n;
      }
      function qSe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        if (!ne)
          return -1;
        var fe = ne;
        return B !== n && (fe = lo(B), fe = fe < 0 ? Li(ne + fe, 0) : Ma(fe, ne - 1)), A === A ? R(y, A, fe) : Ki(y, oy, fe, !0);
      }
      function jSe(y, A) {
        return y && y.length ? nV(y, lo(A)) : n;
      }
      var FSe = vo(GV);
      function GV(y, A) {
        return y && y.length && A && A.length ? jz(y, A) : y;
      }
      function VSe(y, A, B) {
        return y && y.length && A && A.length ? jz(y, A, Sn(B, 2)) : y;
      }
      function BSe(y, A, B) {
        return y && y.length && A && A.length ? jz(y, A, n, B) : y;
      }
      var USe = Iu(function(y, A) {
        var B = y == null ? 0 : y.length, ne = Pz(y, A);
        return iV(y, yo(A, function(fe) {
          return Ru(fe, B) ? +fe : fe;
        }).sort(fV)), ne;
      });
      function WSe(y, A) {
        var B = [];
        if (!(y && y.length))
          return B;
        var ne = -1, fe = [], ye = y.length;
        for (A = Sn(A, 3); ++ne < ye; ) {
          var Ee = y[ne];
          A(Ee, ne, y) && (B.push(Ee), fe.push(ne));
        }
        return iV(y, fe), B;
      }
      function aO(y) {
        return y == null ? y : L1e.call(y);
      }
      function GSe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        return ne ? (B && typeof B != "number" && us(y, A, B) ? (A = 0, B = ne) : (A = A == null ? 0 : lo(A), B = B === n ? ne : lo(B)), Jc(y, A, B)) : [];
      }
      function HSe(y, A) {
        return T1(y, A);
      }
      function KSe(y, A, B) {
        return Bz(y, A, Sn(B, 2));
      }
      function YSe(y, A) {
        var B = y == null ? 0 : y.length;
        if (B) {
          var ne = T1(y, A);
          if (ne < B && Nl(y[ne], A))
            return ne;
        }
        return -1;
      }
      function ZSe(y, A) {
        return T1(y, A, !0);
      }
      function QSe(y, A, B) {
        return Bz(y, A, Sn(B, 2), !0);
      }
      function JSe(y, A) {
        var B = y == null ? 0 : y.length;
        if (B) {
          var ne = T1(y, A, !0) - 1;
          if (Nl(y[ne], A))
            return ne;
        }
        return -1;
      }
      function XSe(y) {
        return y && y.length ? sV(y) : [];
      }
      function exe(y, A) {
        return y && y.length ? sV(y, Sn(A, 2)) : [];
      }
      function txe(y) {
        var A = y == null ? 0 : y.length;
        return A ? Jc(y, 1, A) : [];
      }
      function nxe(y, A, B) {
        return y && y.length ? (A = B || A === n ? 1 : lo(A), Jc(y, 0, A < 0 ? 0 : A)) : [];
      }
      function oxe(y, A, B) {
        var ne = y == null ? 0 : y.length;
        return ne ? (A = B || A === n ? 1 : lo(A), A = ne - A, Jc(y, A < 0 ? 0 : A, ne)) : [];
      }
      function rxe(y, A) {
        return y && y.length ? A1(y, Sn(A, 3), !1, !0) : [];
      }
      function ixe(y, A) {
        return y && y.length ? A1(y, Sn(A, 3)) : [];
      }
      var axe = vo(function(y) {
        return ep(ga(y, 1, yi, !0));
      }), sxe = vo(function(y) {
        var A = Xc(y);
        return yi(A) && (A = n), ep(ga(y, 1, yi, !0), Sn(A, 2));
      }), cxe = vo(function(y) {
        var A = Xc(y);
        return A = typeof A == "function" ? A : n, ep(ga(y, 1, yi, !0), n, A);
      });
      function lxe(y) {
        return y && y.length ? ep(y) : [];
      }
      function dxe(y, A) {
        return y && y.length ? ep(y, Sn(A, 2)) : [];
      }
      function uxe(y, A) {
        return A = typeof A == "function" ? A : n, y && y.length ? ep(y, n, A) : [];
      }
      function sO(y) {
        if (!(y && y.length))
          return [];
        var A = 0;
        return y = Hc(y, function(B) {
          if (yi(B))
            return A = Li(B.length, A), !0;
        }), vm(A, function(B) {
          return yo(y, Ms(B));
        });
      }
      function HV(y, A) {
        if (!(y && y.length))
          return [];
        var B = sO(y);
        return A == null ? B : yo(B, function(ne) {
          return co(A, n, ne);
        });
      }
      var _xe = vo(function(y, A) {
        return yi(y) ? my(y, A) : [];
      }), pxe = vo(function(y) {
        return Wz(Hc(y, yi));
      }), mxe = vo(function(y) {
        var A = Xc(y);
        return yi(A) && (A = n), Wz(Hc(y, yi), Sn(A, 2));
      }), fxe = vo(function(y) {
        var A = Xc(y);
        return A = typeof A == "function" ? A : n, Wz(Hc(y, yi), n, A);
      }), gxe = vo(sO);
      function hxe(y, A) {
        return uV(y || [], A || [], py);
      }
      function vxe(y, A) {
        return uV(y || [], A || [], hy);
      }
      var bxe = vo(function(y) {
        var A = y.length, B = A > 1 ? y[A - 1] : n;
        return B = typeof B == "function" ? (y.pop(), B) : n, HV(y, B);
      });
      function KV(y) {
        var A = he(y);
        return A.__chain__ = !0, A;
      }
      function yxe(y, A) {
        return A(y), y;
      }
      function M1(y, A) {
        return A(y);
      }
      var $xe = Iu(function(y) {
        var A = y.length, B = A ? y[0] : 0, ne = this.__wrapped__, fe = function(ye) {
          return Pz(ye, y);
        };
        return A > 1 || this.__actions__.length || !(ne instanceof Oo) || !Ru(B) ? this.thru(fe) : (ne = ne.slice(B, +B + (A ? 1 : 0)), ne.__actions__.push({
          func: M1,
          args: [fe],
          thisArg: n
        }), new Zc(ne, this.__chain__).thru(function(ye) {
          return A && !ye.length && ye.push(n), ye;
        }));
      });
      function wxe() {
        return KV(this);
      }
      function kxe() {
        return new Zc(this.value(), this.__chain__);
      }
      function Sxe() {
        this.__values__ === n && (this.__values__ = cB(this.value()));
        var y = this.__index__ >= this.__values__.length, A = y ? n : this.__values__[this.__index__++];
        return { done: y, value: A };
      }
      function xxe() {
        return this;
      }
      function Exe(y) {
        for (var A, B = this; B instanceof w1; ) {
          var ne = FV(B);
          ne.__index__ = 0, ne.__values__ = n, A ? fe.__wrapped__ = ne : A = ne;
          var fe = ne;
          B = B.__wrapped__;
        }
        return fe.__wrapped__ = y, A;
      }
      function Txe() {
        var y = this.__wrapped__;
        if (y instanceof Oo) {
          var A = y;
          return this.__actions__.length && (A = new Oo(this)), A = A.reverse(), A.__actions__.push({
            func: M1,
            args: [aO],
            thisArg: n
          }), new Zc(A, this.__chain__);
        }
        return this.thru(aO);
      }
      function Axe() {
        return dV(this.__wrapped__, this.__actions__);
      }
      var Cxe = C1(function(y, A, B) {
        mr.call(y, B) ? ++y[B] : Ou(y, B, 1);
      });
      function zxe(y, A, B) {
        var ne = ro(y) ? cc : y2e;
        return B && us(y, A, B) && (A = n), ne(y, Sn(A, 3));
      }
      function Oxe(y, A) {
        var B = ro(y) ? Hc : H7;
        return B(y, Sn(A, 3));
      }
      var Pxe = $V(VV), Ixe = $V(BV);
      function Rxe(y, A) {
        return ga(L1(y, A), 1);
      }
      function Nxe(y, A) {
        return ga(L1(y, A), z);
      }
      function Dxe(y, A, B) {
        return B = B === n ? 1 : lo(B), ga(L1(y, A), B);
      }
      function YV(y, A) {
        var B = ro(y) ? ls : X_;
        return B(y, Sn(A, 3));
      }
      function ZV(y, A) {
        var B = ro(y) ? n1 : G7;
        return B(y, Sn(A, 3));
      }
      var Mxe = C1(function(y, A, B) {
        mr.call(y, B) ? y[B].push(A) : Ou(y, B, [A]);
      });
      function Lxe(y, A, B, ne) {
        y = qs(y) ? y : Wg(y), B = B && !ne ? lo(B) : 0;
        var fe = y.length;
        return B < 0 && (B = Li(fe + B, 0)), B1(y) ? B <= fe && y.indexOf(A, B) > -1 : !!fe && kd(y, A, B) > -1;
      }
      var qxe = vo(function(y, A, B) {
        var ne = -1, fe = typeof A == "function", ye = qs(y) ? Ne(y.length) : [];
        return X_(y, function(Ee) {
          ye[++ne] = fe ? co(A, Ee, B) : fy(Ee, A, B);
        }), ye;
      }), jxe = C1(function(y, A, B) {
        Ou(y, B, A);
      });
      function L1(y, A) {
        var B = ro(y) ? yo : X7;
        return B(y, Sn(A, 3));
      }
      function Fxe(y, A, B, ne) {
        return y == null ? [] : (ro(A) || (A = A == null ? [] : [A]), B = ne ? n : B, ro(B) || (B = B == null ? [] : [B]), oV(y, A, B));
      }
      var Vxe = C1(function(y, A, B) {
        y[B ? 0 : 1].push(A);
      }, function() {
        return [[], []];
      });
      function Bxe(y, A, B) {
        var ne = ro(y) ? Z_ : hm, fe = arguments.length < 3;
        return ne(y, Sn(A, 4), B, fe, X_);
      }
      function Uxe(y, A, B) {
        var ne = ro(y) ? o1 : hm, fe = arguments.length < 3;
        return ne(y, Sn(A, 4), B, fe, G7);
      }
      function Wxe(y, A) {
        var B = ro(y) ? Hc : H7;
        return B(y, F1(Sn(A, 3)));
      }
      function Gxe(y) {
        var A = ro(y) ? V7 : L2e;
        return A(y);
      }
      function Hxe(y, A, B) {
        (B ? us(y, A, B) : A === n) ? A = 1 : A = lo(A);
        var ne = ro(y) ? f2e : q2e;
        return ne(y, A);
      }
      function Kxe(y) {
        var A = ro(y) ? g2e : F2e;
        return A(y);
      }
      function Yxe(y) {
        if (y == null)
          return 0;
        if (qs(y))
          return B1(y) ? K(y) : y.length;
        var A = La(y);
        return A == de || A == be ? y.size : Lz(y).length;
      }
      function Zxe(y, A, B) {
        var ne = ro(y) ? ey : V2e;
        return B && us(y, A, B) && (A = n), ne(y, Sn(A, 3));
      }
      var Qxe = vo(function(y, A) {
        if (y == null)
          return [];
        var B = A.length;
        return B > 1 && us(y, A[0], A[1]) ? A = [] : B > 2 && us(A[0], A[1], A[2]) && (A = [A[0]]), oV(y, ga(A, 1), []);
      }), q1 = O1e || function() {
        return Mi.Date.now();
      };
      function Jxe(y, A) {
        if (typeof A != "function")
          throw new Yc(a);
        return y = lo(y), function() {
          if (--y < 1)
            return A.apply(this, arguments);
        };
      }
      function QV(y, A, B) {
        return A = B ? n : A, A = y && A == null ? y.length : A, Pu(y, I, n, n, n, n, A);
      }
      function JV(y, A) {
        var B;
        if (typeof A != "function")
          throw new Yc(a);
        return y = lo(y), function() {
          return --y > 0 && (B = A.apply(this, arguments)), y <= 1 && (A = n), B;
        };
      }
      var cO = vo(function(y, A, B) {
        var ne = h;
        if (B.length) {
          var fe = xd(B, Bg(cO));
          ne |= S;
        }
        return Pu(y, ne, A, B, fe);
      }), XV = vo(function(y, A, B) {
        var ne = h | b;
        if (B.length) {
          var fe = xd(B, Bg(XV));
          ne |= S;
        }
        return Pu(A, ne, y, B, fe);
      });
      function eB(y, A, B) {
        A = B ? n : A;
        var ne = Pu(y, $, n, n, n, n, n, A);
        return ne.placeholder = eB.placeholder, ne;
      }
      function tB(y, A, B) {
        A = B ? n : A;
        var ne = Pu(y, k, n, n, n, n, n, A);
        return ne.placeholder = tB.placeholder, ne;
      }
      function nB(y, A, B) {
        var ne, fe, ye, Ee, Re, Be, ct = 0, dt = !1, ht = !1, Ft = !0;
        if (typeof y != "function")
          throw new Yc(a);
        A = el(A) || 0, ri(B) && (dt = !!B.leading, ht = "maxWait" in B, ye = ht ? Li(el(B.maxWait) || 0, A) : ye, Ft = "trailing" in B ? !!B.trailing : Ft);
        function dn($i) {
          var Dl = ne, Mu = fe;
          return ne = fe = n, ct = $i, Ee = y.apply(Mu, Dl), Ee;
        }
        function Cn($i) {
          return ct = $i, Re = yy(So, A), dt ? dn($i) : Ee;
        }
        function mo($i) {
          var Dl = $i - Be, Mu = $i - ct, $B = A - Dl;
          return ht ? Ma($B, ye - Mu) : $B;
        }
        function zn($i) {
          var Dl = $i - Be, Mu = $i - ct;
          return Be === n || Dl >= A || Dl < 0 || ht && Mu >= ye;
        }
        function So() {
          var $i = q1();
          if (zn($i))
            return Do($i);
          Re = yy(So, mo($i));
        }
        function Do($i) {
          return Re = n, Ft && ne ? dn($i) : (ne = fe = n, Ee);
        }
        function uc() {
          Re !== n && _V(Re), ct = 0, ne = Be = fe = Re = n;
        }
        function _s() {
          return Re === n ? Ee : Do(q1());
        }
        function _c() {
          var $i = q1(), Dl = zn($i);
          if (ne = arguments, fe = this, Be = $i, Dl) {
            if (Re === n)
              return Cn(Be);
            if (ht)
              return _V(Re), Re = yy(So, A), dn(Be);
          }
          return Re === n && (Re = yy(So, A)), Ee;
        }
        return _c.cancel = uc, _c.flush = _s, _c;
      }
      var Xxe = vo(function(y, A) {
        return W7(y, 1, A);
      }), eEe = vo(function(y, A, B) {
        return W7(y, el(A) || 0, B);
      });
      function tEe(y) {
        return Pu(y, M);
      }
      function j1(y, A) {
        if (typeof y != "function" || A != null && typeof A != "function")
          throw new Yc(a);
        var B = function() {
          var ne = arguments, fe = A ? A.apply(this, ne) : ne[0], ye = B.cache;
          if (ye.has(fe))
            return ye.get(fe);
          var Ee = y.apply(this, ne);
          return B.cache = ye.set(fe, Ee) || ye, Ee;
        };
        return B.cache = new (j1.Cache || zu)(), B;
      }
      j1.Cache = zu;
      function F1(y) {
        if (typeof y != "function")
          throw new Yc(a);
        return function() {
          var A = arguments;
          switch (A.length) {
            case 0:
              return !y.call(this);
            case 1:
              return !y.call(this, A[0]);
            case 2:
              return !y.call(this, A[0], A[1]);
            case 3:
              return !y.call(this, A[0], A[1], A[2]);
          }
          return !y.apply(this, A);
        };
      }
      function nEe(y) {
        return JV(2, y);
      }
      var oEe = B2e(function(y, A) {
        A = A.length == 1 && ro(A[0]) ? yo(A[0], Da(Sn())) : yo(ga(A, 1), Da(Sn()));
        var B = A.length;
        return vo(function(ne) {
          for (var fe = -1, ye = Ma(ne.length, B); ++fe < ye; )
            ne[fe] = A[fe].call(this, ne[fe]);
          return co(y, this, ne);
        });
      }), lO = vo(function(y, A) {
        var B = xd(A, Bg(lO));
        return Pu(y, S, n, A, B);
      }), oB = vo(function(y, A) {
        var B = xd(A, Bg(oB));
        return Pu(y, O, n, A, B);
      }), rEe = Iu(function(y, A) {
        return Pu(y, D, n, n, n, A);
      });
      function iEe(y, A) {
        if (typeof y != "function")
          throw new Yc(a);
        return A = A === n ? A : lo(A), vo(y, A);
      }
      function aEe(y, A) {
        if (typeof y != "function")
          throw new Yc(a);
        return A = A == null ? 0 : Li(lo(A), 0), vo(function(B) {
          var ne = B[A], fe = np(B, 0, A);
          return ne && Mr(fe, ne), co(y, this, fe);
        });
      }
      function sEe(y, A, B) {
        var ne = !0, fe = !0;
        if (typeof y != "function")
          throw new Yc(a);
        return ri(B) && (ne = "leading" in B ? !!B.leading : ne, fe = "trailing" in B ? !!B.trailing : fe), nB(y, A, {
          leading: ne,
          maxWait: A,
          trailing: fe
        });
      }
      function cEe(y) {
        return QV(y, 1);
      }
      function lEe(y, A) {
        return lO(Hz(A), y);
      }
      function dEe() {
        if (!arguments.length)
          return [];
        var y = arguments[0];
        return ro(y) ? y : [y];
      }
      function uEe(y) {
        return Qc(y, p);
      }
      function _Ee(y, A) {
        return A = typeof A == "function" ? A : n, Qc(y, p, A);
      }
      function pEe(y) {
        return Qc(y, u | p);
      }
      function mEe(y, A) {
        return A = typeof A == "function" ? A : n, Qc(y, u | p, A);
      }
      function fEe(y, A) {
        return A == null || U7(y, A, Yi(A));
      }
      function Nl(y, A) {
        return y === A || y !== y && A !== A;
      }
      var gEe = I1(Nz), hEe = I1(function(y, A) {
        return y >= A;
      }), Em = Z7(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Z7 : function(y) {
        return _i(y) && mr.call(y, "callee") && !D7.call(y, "callee");
      }, ro = Ne.isArray, vEe = Xk ? Da(Xk) : E2e;
      function qs(y) {
        return y != null && V1(y.length) && !Nu(y);
      }
      function yi(y) {
        return _i(y) && qs(y);
      }
      function bEe(y) {
        return y === !0 || y === !1 || _i(y) && ds(y) == re;
      }
      var op = I1e || yO, yEe = e1 ? Da(e1) : T2e;
      function $Ee(y) {
        return _i(y) && y.nodeType === 1 && !$y(y);
      }
      function wEe(y) {
        if (y == null)
          return !0;
        if (qs(y) && (ro(y) || typeof y == "string" || typeof y.splice == "function" || op(y) || Ug(y) || Em(y)))
          return !y.length;
        var A = La(y);
        if (A == de || A == be)
          return !y.size;
        if (by(y))
          return !Lz(y).length;
        for (var B in y)
          if (mr.call(y, B))
            return !1;
        return !0;
      }
      function kEe(y, A) {
        return gy(y, A);
      }
      function SEe(y, A, B) {
        B = typeof B == "function" ? B : n;
        var ne = B ? B(y, A) : n;
        return ne === n ? gy(y, A, n, B) : !!ne;
      }
      function dO(y) {
        if (!_i(y))
          return !1;
        var A = ds(y);
        return A == J || A == ee || typeof y.message == "string" && typeof y.name == "string" && !$y(y);
      }
      function xEe(y) {
        return typeof y == "number" && L7(y);
      }
      function Nu(y) {
        if (!ri(y))
          return !1;
        var A = ds(y);
        return A == oe || A == ce || A == X || A == me;
      }
      function rB(y) {
        return typeof y == "number" && y == lo(y);
      }
      function V1(y) {
        return typeof y == "number" && y > -1 && y % 1 == 0 && y <= j;
      }
      function ri(y) {
        var A = typeof y;
        return y != null && (A == "object" || A == "function");
      }
      function _i(y) {
        return y != null && typeof y == "object";
      }
      var iB = Au ? Da(Au) : C2e;
      function EEe(y, A) {
        return y === A || Mz(y, A, eO(A));
      }
      function TEe(y, A, B) {
        return B = typeof B == "function" ? B : n, Mz(y, A, eO(A), B);
      }
      function AEe(y) {
        return aB(y) && y != +y;
      }
      function CEe(y) {
        if (_Se(y))
          throw new Pt(i);
        return Q7(y);
      }
      function zEe(y) {
        return y === null;
      }
      function OEe(y) {
        return y == null;
      }
      function aB(y) {
        return typeof y == "number" || _i(y) && ds(y) == te;
      }
      function $y(y) {
        if (!_i(y) || ds(y) != le)
          return !1;
        var A = f1(y);
        if (A === null)
          return !0;
        var B = mr.call(A, "constructor") && A.constructor;
        return typeof B == "function" && B instanceof B && u1.call(B) == T1e;
      }
      var uO = fm ? Da(fm) : z2e;
      function PEe(y) {
        return rB(y) && y >= -j && y <= j;
      }
      var sB = Xb ? Da(Xb) : O2e;
      function B1(y) {
        return typeof y == "string" || !ro(y) && _i(y) && ds(y) == Se;
      }
      function dc(y) {
        return typeof y == "symbol" || _i(y) && ds(y) == Ae;
      }
      var Ug = Cg ? Da(Cg) : P2e;
      function IEe(y) {
        return y === n;
      }
      function REe(y) {
        return _i(y) && La(y) == Ge;
      }
      function NEe(y) {
        return _i(y) && ds(y) == rt;
      }
      var DEe = I1(qz), MEe = I1(function(y, A) {
        return y <= A;
      });
      function cB(y) {
        if (!y)
          return [];
        if (qs(y))
          return B1(y) ? ie(y) : Ls(y);
        if (cy && y[cy])
          return s1(y[cy]());
        var A = La(y), B = A == de ? ay : A == be ? Dg : Wg;
        return B(y);
      }
      function Du(y) {
        if (!y)
          return y === 0 ? y : 0;
        if (y = el(y), y === z || y === -z) {
          var A = y < 0 ? -1 : 1;
          return A * q;
        }
        return y === y ? y : 0;
      }
      function lo(y) {
        var A = Du(y), B = A % 1;
        return A === A ? B ? A - B : A : 0;
      }
      function lB(y) {
        return y ? wm(lo(y), 0, F) : 0;
      }
      function el(y) {
        if (typeof y == "number")
          return y;
        if (dc(y))
          return V;
        if (ri(y)) {
          var A = typeof y.valueOf == "function" ? y.valueOf() : y;
          y = ri(A) ? A + "" : A;
        }
        if (typeof y != "string")
          return y === 0 ? y : +y;
        y = ry(y);
        var B = At.test(y);
        return B || Ie.test(y) ? Yb(y.slice(2), B ? 2 : 8) : Kt.test(y) ? V : +y;
      }
      function dB(y) {
        return Td(y, js(y));
      }
      function LEe(y) {
        return y ? wm(lo(y), -j, j) : y === 0 ? y : 0;
      }
      function cr(y) {
        return y == null ? "" : lc(y);
      }
      var qEe = Fg(function(y, A) {
        if (by(A) || qs(A)) {
          Td(A, Yi(A), y);
          return;
        }
        for (var B in A)
          mr.call(A, B) && py(y, B, A[B]);
      }), uB = Fg(function(y, A) {
        Td(A, js(A), y);
      }), U1 = Fg(function(y, A, B, ne) {
        Td(A, js(A), y, ne);
      }), jEe = Fg(function(y, A, B, ne) {
        Td(A, Yi(A), y, ne);
      }), FEe = Iu(Pz);
      function VEe(y, A) {
        var B = jg(y);
        return A == null ? B : B7(B, A);
      }
      var BEe = vo(function(y, A) {
        y = $o(y);
        var B = -1, ne = A.length, fe = ne > 2 ? A[2] : n;
        for (fe && us(A[0], A[1], fe) && (ne = 1); ++B < ne; )
          for (var ye = A[B], Ee = js(ye), Re = -1, Be = Ee.length; ++Re < Be; ) {
            var ct = Ee[Re], dt = y[ct];
            (dt === n || Nl(dt, Mg[ct]) && !mr.call(y, ct)) && (y[ct] = ye[ct]);
          }
        return y;
      }), UEe = vo(function(y) {
        return y.push(n, AV), co(_B, n, y);
      });
      function WEe(y, A) {
        return ny(y, Sn(A, 3), Ed);
      }
      function GEe(y, A) {
        return ny(y, Sn(A, 3), Rz);
      }
      function HEe(y, A) {
        return y == null ? y : Iz(y, Sn(A, 3), js);
      }
      function KEe(y, A) {
        return y == null ? y : K7(y, Sn(A, 3), js);
      }
      function YEe(y, A) {
        return y && Ed(y, Sn(A, 3));
      }
      function ZEe(y, A) {
        return y && Rz(y, Sn(A, 3));
      }
      function QEe(y) {
        return y == null ? [] : x1(y, Yi(y));
      }
      function JEe(y) {
        return y == null ? [] : x1(y, js(y));
      }
      function _O(y, A, B) {
        var ne = y == null ? n : km(y, A);
        return ne === n ? B : ne;
      }
      function XEe(y, A) {
        return y != null && OV(y, A, w2e);
      }
      function pO(y, A) {
        return y != null && OV(y, A, k2e);
      }
      var eTe = kV(function(y, A, B) {
        A != null && typeof A.toString != "function" && (A = _1.call(A)), y[A] = B;
      }, fO(Fs)), tTe = kV(function(y, A, B) {
        A != null && typeof A.toString != "function" && (A = _1.call(A)), mr.call(y, A) ? y[A].push(B) : y[A] = [B];
      }, Sn), nTe = vo(fy);
      function Yi(y) {
        return qs(y) ? F7(y) : Lz(y);
      }
      function js(y) {
        return qs(y) ? F7(y, !0) : I2e(y);
      }
      function oTe(y, A) {
        var B = {};
        return A = Sn(A, 3), Ed(y, function(ne, fe, ye) {
          Ou(B, A(ne, fe, ye), ne);
        }), B;
      }
      function rTe(y, A) {
        var B = {};
        return A = Sn(A, 3), Ed(y, function(ne, fe, ye) {
          Ou(B, fe, A(ne, fe, ye));
        }), B;
      }
      var iTe = Fg(function(y, A, B) {
        E1(y, A, B);
      }), _B = Fg(function(y, A, B, ne) {
        E1(y, A, B, ne);
      }), aTe = Iu(function(y, A) {
        var B = {};
        if (y == null)
          return B;
        var ne = !1;
        A = yo(A, function(ye) {
          return ye = tp(ye, y), ne || (ne = ye.length > 1), ye;
        }), Td(y, Jz(y), B), ne && (B = Qc(B, u | _ | p, eSe));
        for (var fe = A.length; fe--; )
          Uz(B, A[fe]);
        return B;
      });
      function sTe(y, A) {
        return pB(y, F1(Sn(A)));
      }
      var cTe = Iu(function(y, A) {
        return y == null ? {} : N2e(y, A);
      });
      function pB(y, A) {
        if (y == null)
          return {};
        var B = yo(Jz(y), function(ne) {
          return [ne];
        });
        return A = Sn(A), rV(y, B, function(ne, fe) {
          return A(ne, fe[0]);
        });
      }
      function lTe(y, A, B) {
        A = tp(A, y);
        var ne = -1, fe = A.length;
        for (fe || (fe = 1, y = n); ++ne < fe; ) {
          var ye = y == null ? n : y[Ad(A[ne])];
          ye === n && (ne = fe, ye = B), y = Nu(ye) ? ye.call(y) : ye;
        }
        return y;
      }
      function dTe(y, A, B) {
        return y == null ? y : hy(y, A, B);
      }
      function uTe(y, A, B, ne) {
        return ne = typeof ne == "function" ? ne : n, y == null ? y : hy(y, A, B, ne);
      }
      var mB = EV(Yi), fB = EV(js);
      function _Te(y, A, B) {
        var ne = ro(y), fe = ne || op(y) || Ug(y);
        if (A = Sn(A, 4), B == null) {
          var ye = y && y.constructor;
          fe ? B = ne ? new ye() : [] : ri(y) ? B = Nu(ye) ? jg(f1(y)) : {} : B = {};
        }
        return (fe ? ls : Ed)(y, function(Ee, Re, Be) {
          return A(B, Ee, Re, Be);
        }), B;
      }
      function pTe(y, A) {
        return y == null ? !0 : Uz(y, A);
      }
      function mTe(y, A, B) {
        return y == null ? y : lV(y, A, Hz(B));
      }
      function fTe(y, A, B, ne) {
        return ne = typeof ne == "function" ? ne : n, y == null ? y : lV(y, A, Hz(B), ne);
      }
      function Wg(y) {
        return y == null ? [] : Sd(y, Yi(y));
      }
      function gTe(y) {
        return y == null ? [] : Sd(y, js(y));
      }
      function hTe(y, A, B) {
        return B === n && (B = A, A = n), B !== n && (B = el(B), B = B === B ? B : 0), A !== n && (A = el(A), A = A === A ? A : 0), wm(el(y), A, B);
      }
      function vTe(y, A, B) {
        return A = Du(A), B === n ? (B = A, A = 0) : B = Du(B), y = el(y), S2e(y, A, B);
      }
      function bTe(y, A, B) {
        if (B && typeof B != "boolean" && us(y, A, B) && (A = B = n), B === n && (typeof A == "boolean" ? (B = A, A = n) : typeof y == "boolean" && (B = y, y = n)), y === n && A === n ? (y = 0, A = 1) : (y = Du(y), A === n ? (A = y, y = 0) : A = Du(A)), y > A) {
          var ne = y;
          y = A, A = ne;
        }
        if (B || y % 1 || A % 1) {
          var fe = q7();
          return Ma(y + fe * (A - y + Jk("1e-" + ((fe + "").length - 1))), A);
        }
        return Fz(y, A);
      }
      var yTe = Vg(function(y, A, B) {
        return A = A.toLowerCase(), y + (B ? gB(A) : A);
      });
      function gB(y) {
        return mO(cr(y).toLowerCase());
      }
      function hB(y) {
        return y = cr(y), y && y.replace(zt, fa).replace(Tg, "");
      }
      function $Te(y, A, B) {
        y = cr(y), A = lc(A);
        var ne = y.length;
        B = B === n ? ne : wm(lo(B), 0, ne);
        var fe = B;
        return B -= A.length, B >= 0 && y.slice(B, fe) == A;
      }
      function wTe(y) {
        return y = cr(y), y && kn.test(y) ? y.replace(cn, Ng) : y;
      }
      function kTe(y) {
        return y = cr(y), y && qn.test(y) ? y.replace(Ht, "\\$&") : y;
      }
      var STe = Vg(function(y, A, B) {
        return y + (B ? "-" : "") + A.toLowerCase();
      }), xTe = Vg(function(y, A, B) {
        return y + (B ? " " : "") + A.toLowerCase();
      }), ETe = yV("toLowerCase");
      function TTe(y, A, B) {
        y = cr(y), A = lo(A);
        var ne = A ? K(y) : 0;
        if (!A || ne >= A)
          return y;
        var fe = (A - ne) / 2;
        return P1(b1(fe), B) + y + P1(v1(fe), B);
      }
      function ATe(y, A, B) {
        y = cr(y), A = lo(A);
        var ne = A ? K(y) : 0;
        return A && ne < A ? y + P1(A - ne, B) : y;
      }
      function CTe(y, A, B) {
        y = cr(y), A = lo(A);
        var ne = A ? K(y) : 0;
        return A && ne < A ? P1(A - ne, B) + y : y;
      }
      function zTe(y, A, B) {
        return B || A == null ? A = 0 : A && (A = +A), M1e(cr(y).replace(Bn, ""), A || 0);
      }
      function OTe(y, A, B) {
        return (B ? us(y, A, B) : A === n) ? A = 1 : A = lo(A), Vz(cr(y), A);
      }
      function PTe() {
        var y = arguments, A = cr(y[0]);
        return y.length < 3 ? A : A.replace(y[1], y[2]);
      }
      var ITe = Vg(function(y, A, B) {
        return y + (B ? "_" : "") + A.toLowerCase();
      });
      function RTe(y, A, B) {
        return B && typeof B != "number" && us(y, A, B) && (A = B = n), B = B === n ? F : B >>> 0, B ? (y = cr(y), y && (typeof A == "string" || A != null && !uO(A)) && (A = lc(A), !A && Il(y)) ? np(ie(y), 0, B) : y.split(A, B)) : [];
      }
      var NTe = Vg(function(y, A, B) {
        return y + (B ? " " : "") + mO(A);
      });
      function DTe(y, A, B) {
        return y = cr(y), B = B == null ? 0 : wm(lo(B), 0, y.length), A = lc(A), y.slice(B, B + A.length) == A;
      }
      function MTe(y, A, B) {
        var ne = he.templateSettings;
        B && us(y, A, B) && (A = n), y = cr(y), A = U1({}, A, ne, TV);
        var fe = U1({}, A.imports, ne.imports, TV), ye = Yi(fe), Ee = Sd(fe, ye), Re, Be, ct = 0, dt = A.interpolate || $t, ht = "__p += '", Ft = Q_(
          (A.escape || $t).source + "|" + dt.source + "|" + (dt === _n ? Ut : $t).source + "|" + (A.evaluate || $t).source + "|$",
          "g"
        ), dn = "//# sourceURL=" + (mr.call(A, "sourceURL") ? (A.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ag + "]") + `
`;
        y.replace(Ft, function(zn, So, Do, uc, _s, _c) {
          return Do || (Do = uc), ht += y.slice(ct, _c).replace(In, xz), So && (Re = !0, ht += `' +
__e(` + So + `) +
'`), _s && (Be = !0, ht += `';
` + _s + `;
__p += '`), Do && (ht += `' +
((__t = (` + Do + `)) == null ? '' : __t) +
'`), ct = _c + zn.length, zn;
        }), ht += `';
`;
        var Cn = mr.call(A, "variable") && A.variable;
        if (!Cn)
          ht = `with (obj) {
` + ht + `
}
`;
        else if (yt.test(Cn))
          throw new Pt(s);
        ht = (Be ? ht.replace(Mn, "") : ht).replace(Ln, "$1").replace(un, "$1;"), ht = "function(" + (Cn || "obj") + `) {
` + (Cn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Re ? ", __e = _.escape" : "") + (Be ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ht + `return __p
}`;
        var mo = bB(function() {
          return fn(ye, dn + "return " + ht).apply(n, Ee);
        });
        if (mo.source = ht, dO(mo))
          throw mo;
        return mo;
      }
      function LTe(y) {
        return cr(y).toLowerCase();
      }
      function qTe(y) {
        return cr(y).toUpperCase();
      }
      function jTe(y, A, B) {
        if (y = cr(y), y && (B || A === n))
          return ry(y);
        if (!y || !(A = lc(A)))
          return y;
        var ne = ie(y), fe = ie(A), ye = iy(ne, fe), Ee = Rg(ne, fe) + 1;
        return np(ne, ye, Ee).join("");
      }
      function FTe(y, A, B) {
        if (y = cr(y), y && (B || A === n))
          return y.slice(0, _e(y) + 1);
        if (!y || !(A = lc(A)))
          return y;
        var ne = ie(y), fe = Rg(ne, ie(A)) + 1;
        return np(ne, 0, fe).join("");
      }
      function VTe(y, A, B) {
        if (y = cr(y), y && (B || A === n))
          return y.replace(Bn, "");
        if (!y || !(A = lc(A)))
          return y;
        var ne = ie(y), fe = iy(ne, ie(A));
        return np(ne, fe).join("");
      }
      function BTe(y, A) {
        var B = N, ne = C;
        if (ri(A)) {
          var fe = "separator" in A ? A.separator : fe;
          B = "length" in A ? lo(A.length) : B, ne = "omission" in A ? lc(A.omission) : ne;
        }
        y = cr(y);
        var ye = y.length;
        if (Il(y)) {
          var Ee = ie(y);
          ye = Ee.length;
        }
        if (B >= ye)
          return y;
        var Re = B - K(ne);
        if (Re < 1)
          return ne;
        var Be = Ee ? np(Ee, 0, Re).join("") : y.slice(0, Re);
        if (fe === n)
          return Be + ne;
        if (Ee && (Re += Be.length - Re), uO(fe)) {
          if (y.slice(Re).search(fe)) {
            var ct, dt = Be;
            for (fe.global || (fe = Q_(fe.source, cr(Nt.exec(fe)) + "g")), fe.lastIndex = 0; ct = fe.exec(dt); )
              var ht = ct.index;
            Be = Be.slice(0, ht === n ? Re : ht);
          }
        } else if (y.indexOf(lc(fe), Re) != Re) {
          var Ft = Be.lastIndexOf(fe);
          Ft > -1 && (Be = Be.slice(0, Ft));
        }
        return Be + ne;
      }
      function UTe(y) {
        return y = cr(y), y && ln.test(y) ? y.replace(qo, ge) : y;
      }
      var WTe = Vg(function(y, A, B) {
        return y + (B ? " " : "") + A.toUpperCase();
      }), mO = yV("toUpperCase");
      function vB(y, A, B) {
        return y = cr(y), A = B ? n : A, A === n ? a1(y) ? Ve(y) : ty(y) : y.match(A) || [];
      }
      var bB = vo(function(y, A) {
        try {
          return co(y, n, A);
        } catch (B) {
          return dO(B) ? B : new Pt(B);
        }
      }), GTe = Iu(function(y, A) {
        return ls(A, function(B) {
          B = Ad(B), Ou(y, B, cO(y[B], y));
        }), y;
      });
      function HTe(y) {
        var A = y == null ? 0 : y.length, B = Sn();
        return y = A ? yo(y, function(ne) {
          if (typeof ne[1] != "function")
            throw new Yc(a);
          return [B(ne[0]), ne[1]];
        }) : [], vo(function(ne) {
          for (var fe = -1; ++fe < A; ) {
            var ye = y[fe];
            if (co(ye[0], this, ne))
              return co(ye[1], this, ne);
          }
        });
      }
      function KTe(y) {
        return b2e(Qc(y, u));
      }
      function fO(y) {
        return function() {
          return y;
        };
      }
      function YTe(y, A) {
        return y == null || y !== y ? A : y;
      }
      var ZTe = wV(), QTe = wV(!0);
      function Fs(y) {
        return y;
      }
      function gO(y) {
        return J7(typeof y == "function" ? y : Qc(y, u));
      }
      function JTe(y) {
        return eV(Qc(y, u));
      }
      function XTe(y, A) {
        return tV(y, Qc(A, u));
      }
      var eAe = vo(function(y, A) {
        return function(B) {
          return fy(B, y, A);
        };
      }), tAe = vo(function(y, A) {
        return function(B) {
          return fy(y, B, A);
        };
      });
      function hO(y, A, B) {
        var ne = Yi(A), fe = x1(A, ne);
        B == null && !(ri(A) && (fe.length || !ne.length)) && (B = A, A = y, y = this, fe = x1(A, Yi(A)));
        var ye = !(ri(B) && "chain" in B) || !!B.chain, Ee = Nu(y);
        return ls(fe, function(Re) {
          var Be = A[Re];
          y[Re] = Be, Ee && (y.prototype[Re] = function() {
            var ct = this.__chain__;
            if (ye || ct) {
              var dt = y(this.__wrapped__), ht = dt.__actions__ = Ls(this.__actions__);
              return ht.push({ func: Be, args: arguments, thisArg: y }), dt.__chain__ = ct, dt;
            }
            return Be.apply(y, Mr([this.value()], arguments));
          });
        }), y;
      }
      function nAe() {
        return Mi._ === this && (Mi._ = A1e), this;
      }
      function vO() {
      }
      function oAe(y) {
        return y = lo(y), vo(function(A) {
          return nV(A, y);
        });
      }
      var rAe = Yz(yo), iAe = Yz(cc), aAe = Yz(ey);
      function yB(y) {
        return nO(y) ? Ms(Ad(y)) : D2e(y);
      }
      function sAe(y) {
        return function(A) {
          return y == null ? n : km(y, A);
        };
      }
      var cAe = SV(), lAe = SV(!0);
      function bO() {
        return [];
      }
      function yO() {
        return !1;
      }
      function dAe() {
        return {};
      }
      function uAe() {
        return "";
      }
      function _Ae() {
        return !0;
      }
      function pAe(y, A) {
        if (y = lo(y), y < 1 || y > j)
          return [];
        var B = F, ne = Ma(y, F);
        A = Sn(A), y -= F;
        for (var fe = vm(ne, A); ++B < y; )
          A(B);
        return fe;
      }
      function mAe(y) {
        return ro(y) ? yo(y, Ad) : dc(y) ? [y] : Ls(jV(cr(y)));
      }
      function fAe(y) {
        var A = ++E1e;
        return cr(y) + A;
      }
      var gAe = O1(function(y, A) {
        return y + A;
      }, 0), hAe = Zz("ceil"), vAe = O1(function(y, A) {
        return y / A;
      }, 1), bAe = Zz("floor");
      function yAe(y) {
        return y && y.length ? S1(y, Fs, Nz) : n;
      }
      function $Ae(y, A) {
        return y && y.length ? S1(y, Sn(A, 2), Nz) : n;
      }
      function wAe(y) {
        return Og(y, Fs);
      }
      function kAe(y, A) {
        return Og(y, Sn(A, 2));
      }
      function SAe(y) {
        return y && y.length ? S1(y, Fs, qz) : n;
      }
      function xAe(y, A) {
        return y && y.length ? S1(y, Sn(A, 2), qz) : n;
      }
      var EAe = O1(function(y, A) {
        return y * A;
      }, 1), TAe = Zz("round"), AAe = O1(function(y, A) {
        return y - A;
      }, 0);
      function CAe(y) {
        return y && y.length ? Ig(y, Fs) : 0;
      }
      function zAe(y, A) {
        return y && y.length ? Ig(y, Sn(A, 2)) : 0;
      }
      return he.after = Jxe, he.ary = QV, he.assign = qEe, he.assignIn = uB, he.assignInWith = U1, he.assignWith = jEe, he.at = FEe, he.before = JV, he.bind = cO, he.bindAll = GTe, he.bindKey = XV, he.castArray = dEe, he.chain = KV, he.chunk = bSe, he.compact = ySe, he.concat = $Se, he.cond = HTe, he.conforms = KTe, he.constant = fO, he.countBy = Cxe, he.create = VEe, he.curry = eB, he.curryRight = tB, he.debounce = nB, he.defaults = BEe, he.defaultsDeep = UEe, he.defer = Xxe, he.delay = eEe, he.difference = wSe, he.differenceBy = kSe, he.differenceWith = SSe, he.drop = xSe, he.dropRight = ESe, he.dropRightWhile = TSe, he.dropWhile = ASe, he.fill = CSe, he.filter = Oxe, he.flatMap = Rxe, he.flatMapDeep = Nxe, he.flatMapDepth = Dxe, he.flatten = UV, he.flattenDeep = zSe, he.flattenDepth = OSe, he.flip = tEe, he.flow = ZTe, he.flowRight = QTe, he.fromPairs = PSe, he.functions = QEe, he.functionsIn = JEe, he.groupBy = Mxe, he.initial = RSe, he.intersection = NSe, he.intersectionBy = DSe, he.intersectionWith = MSe, he.invert = eTe, he.invertBy = tTe, he.invokeMap = qxe, he.iteratee = gO, he.keyBy = jxe, he.keys = Yi, he.keysIn = js, he.map = L1, he.mapKeys = oTe, he.mapValues = rTe, he.matches = JTe, he.matchesProperty = XTe, he.memoize = j1, he.merge = iTe, he.mergeWith = _B, he.method = eAe, he.methodOf = tAe, he.mixin = hO, he.negate = F1, he.nthArg = oAe, he.omit = aTe, he.omitBy = sTe, he.once = nEe, he.orderBy = Fxe, he.over = rAe, he.overArgs = oEe, he.overEvery = iAe, he.overSome = aAe, he.partial = lO, he.partialRight = oB, he.partition = Vxe, he.pick = cTe, he.pickBy = pB, he.property = yB, he.propertyOf = sAe, he.pull = FSe, he.pullAll = GV, he.pullAllBy = VSe, he.pullAllWith = BSe, he.pullAt = USe, he.range = cAe, he.rangeRight = lAe, he.rearg = rEe, he.reject = Wxe, he.remove = WSe, he.rest = iEe, he.reverse = aO, he.sampleSize = Hxe, he.set = dTe, he.setWith = uTe, he.shuffle = Kxe, he.slice = GSe, he.sortBy = Qxe, he.sortedUniq = XSe, he.sortedUniqBy = exe, he.split = RTe, he.spread = aEe, he.tail = txe, he.take = nxe, he.takeRight = oxe, he.takeRightWhile = rxe, he.takeWhile = ixe, he.tap = yxe, he.throttle = sEe, he.thru = M1, he.toArray = cB, he.toPairs = mB, he.toPairsIn = fB, he.toPath = mAe, he.toPlainObject = dB, he.transform = _Te, he.unary = cEe, he.union = axe, he.unionBy = sxe, he.unionWith = cxe, he.uniq = lxe, he.uniqBy = dxe, he.uniqWith = uxe, he.unset = pTe, he.unzip = sO, he.unzipWith = HV, he.update = mTe, he.updateWith = fTe, he.values = Wg, he.valuesIn = gTe, he.without = _xe, he.words = vB, he.wrap = lEe, he.xor = pxe, he.xorBy = mxe, he.xorWith = fxe, he.zip = gxe, he.zipObject = hxe, he.zipObjectDeep = vxe, he.zipWith = bxe, he.entries = mB, he.entriesIn = fB, he.extend = uB, he.extendWith = U1, hO(he, he), he.add = gAe, he.attempt = bB, he.camelCase = yTe, he.capitalize = gB, he.ceil = hAe, he.clamp = hTe, he.clone = uEe, he.cloneDeep = pEe, he.cloneDeepWith = mEe, he.cloneWith = _Ee, he.conformsTo = fEe, he.deburr = hB, he.defaultTo = YTe, he.divide = vAe, he.endsWith = $Te, he.eq = Nl, he.escape = wTe, he.escapeRegExp = kTe, he.every = zxe, he.find = Pxe, he.findIndex = VV, he.findKey = WEe, he.findLast = Ixe, he.findLastIndex = BV, he.findLastKey = GEe, he.floor = bAe, he.forEach = YV, he.forEachRight = ZV, he.forIn = HEe, he.forInRight = KEe, he.forOwn = YEe, he.forOwnRight = ZEe, he.get = _O, he.gt = gEe, he.gte = hEe, he.has = XEe, he.hasIn = pO, he.head = WV, he.identity = Fs, he.includes = Lxe, he.indexOf = ISe, he.inRange = vTe, he.invoke = nTe, he.isArguments = Em, he.isArray = ro, he.isArrayBuffer = vEe, he.isArrayLike = qs, he.isArrayLikeObject = yi, he.isBoolean = bEe, he.isBuffer = op, he.isDate = yEe, he.isElement = $Ee, he.isEmpty = wEe, he.isEqual = kEe, he.isEqualWith = SEe, he.isError = dO, he.isFinite = xEe, he.isFunction = Nu, he.isInteger = rB, he.isLength = V1, he.isMap = iB, he.isMatch = EEe, he.isMatchWith = TEe, he.isNaN = AEe, he.isNative = CEe, he.isNil = OEe, he.isNull = zEe, he.isNumber = aB, he.isObject = ri, he.isObjectLike = _i, he.isPlainObject = $y, he.isRegExp = uO, he.isSafeInteger = PEe, he.isSet = sB, he.isString = B1, he.isSymbol = dc, he.isTypedArray = Ug, he.isUndefined = IEe, he.isWeakMap = REe, he.isWeakSet = NEe, he.join = LSe, he.kebabCase = STe, he.last = Xc, he.lastIndexOf = qSe, he.lowerCase = xTe, he.lowerFirst = ETe, he.lt = DEe, he.lte = MEe, he.max = yAe, he.maxBy = $Ae, he.mean = wAe, he.meanBy = kAe, he.min = SAe, he.minBy = xAe, he.stubArray = bO, he.stubFalse = yO, he.stubObject = dAe, he.stubString = uAe, he.stubTrue = _Ae, he.multiply = EAe, he.nth = jSe, he.noConflict = nAe, he.noop = vO, he.now = q1, he.pad = TTe, he.padEnd = ATe, he.padStart = CTe, he.parseInt = zTe, he.random = bTe, he.reduce = Bxe, he.reduceRight = Uxe, he.repeat = OTe, he.replace = PTe, he.result = lTe, he.round = TAe, he.runInContext = we, he.sample = Gxe, he.size = Yxe, he.snakeCase = ITe, he.some = Zxe, he.sortedIndex = HSe, he.sortedIndexBy = KSe, he.sortedIndexOf = YSe, he.sortedLastIndex = ZSe, he.sortedLastIndexBy = QSe, he.sortedLastIndexOf = JSe, he.startCase = NTe, he.startsWith = DTe, he.subtract = AAe, he.sum = CAe, he.sumBy = zAe, he.template = MTe, he.times = pAe, he.toFinite = Du, he.toInteger = lo, he.toLength = lB, he.toLower = LTe, he.toNumber = el, he.toSafeInteger = LEe, he.toString = cr, he.toUpper = qTe, he.trim = jTe, he.trimEnd = FTe, he.trimStart = VTe, he.truncate = BTe, he.unescape = UTe, he.uniqueId = fAe, he.upperCase = WTe, he.upperFirst = mO, he.each = YV, he.eachRight = ZV, he.first = WV, hO(he, function() {
        var y = {};
        return Ed(he, function(A, B) {
          mr.call(he.prototype, B) || (y[B] = A);
        }), y;
      }(), { chain: !1 }), he.VERSION = o, ls(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(y) {
        he[y].placeholder = he;
      }), ls(["drop", "take"], function(y, A) {
        Oo.prototype[y] = function(B) {
          B = B === n ? 1 : Li(lo(B), 0);
          var ne = this.__filtered__ && !A ? new Oo(this) : this.clone();
          return ne.__filtered__ ? ne.__takeCount__ = Ma(B, ne.__takeCount__) : ne.__views__.push({
            size: Ma(B, F),
            type: y + (ne.__dir__ < 0 ? "Right" : "")
          }), ne;
        }, Oo.prototype[y + "Right"] = function(B) {
          return this.reverse()[y](B).reverse();
        };
      }), ls(["filter", "map", "takeWhile"], function(y, A) {
        var B = A + 1, ne = B == w || B == T;
        Oo.prototype[y] = function(fe) {
          var ye = this.clone();
          return ye.__iteratees__.push({
            iteratee: Sn(fe, 3),
            type: B
          }), ye.__filtered__ = ye.__filtered__ || ne, ye;
        };
      }), ls(["head", "last"], function(y, A) {
        var B = "take" + (A ? "Right" : "");
        Oo.prototype[y] = function() {
          return this[B](1).value()[0];
        };
      }), ls(["initial", "tail"], function(y, A) {
        var B = "drop" + (A ? "" : "Right");
        Oo.prototype[y] = function() {
          return this.__filtered__ ? new Oo(this) : this[B](1);
        };
      }), Oo.prototype.compact = function() {
        return this.filter(Fs);
      }, Oo.prototype.find = function(y) {
        return this.filter(y).head();
      }, Oo.prototype.findLast = function(y) {
        return this.reverse().find(y);
      }, Oo.prototype.invokeMap = vo(function(y, A) {
        return typeof y == "function" ? new Oo(this) : this.map(function(B) {
          return fy(B, y, A);
        });
      }), Oo.prototype.reject = function(y) {
        return this.filter(F1(Sn(y)));
      }, Oo.prototype.slice = function(y, A) {
        y = lo(y);
        var B = this;
        return B.__filtered__ && (y > 0 || A < 0) ? new Oo(B) : (y < 0 ? B = B.takeRight(-y) : y && (B = B.drop(y)), A !== n && (A = lo(A), B = A < 0 ? B.dropRight(-A) : B.take(A - y)), B);
      }, Oo.prototype.takeRightWhile = function(y) {
        return this.reverse().takeWhile(y).reverse();
      }, Oo.prototype.toArray = function() {
        return this.take(F);
      }, Ed(Oo.prototype, function(y, A) {
        var B = /^(?:filter|find|map|reject)|While$/.test(A), ne = /^(?:head|last)$/.test(A), fe = he[ne ? "take" + (A == "last" ? "Right" : "") : A], ye = ne || /^find/.test(A);
        fe && (he.prototype[A] = function() {
          var Ee = this.__wrapped__, Re = ne ? [1] : arguments, Be = Ee instanceof Oo, ct = Re[0], dt = Be || ro(Ee), ht = function(So) {
            var Do = fe.apply(he, Mr([So], Re));
            return ne && Ft ? Do[0] : Do;
          };
          dt && B && typeof ct == "function" && ct.length != 1 && (Be = dt = !1);
          var Ft = this.__chain__, dn = !!this.__actions__.length, Cn = ye && !Ft, mo = Be && !dn;
          if (!ye && dt) {
            Ee = mo ? Ee : new Oo(this);
            var zn = y.apply(Ee, Re);
            return zn.__actions__.push({ func: M1, args: [ht], thisArg: n }), new Zc(zn, Ft);
          }
          return Cn && mo ? y.apply(this, Re) : (zn = this.thru(ht), Cn ? ne ? zn.value()[0] : zn.value() : zn);
        });
      }), ls(["pop", "push", "shift", "sort", "splice", "unshift"], function(y) {
        var A = l1[y], B = /^(?:push|sort|unshift)$/.test(y) ? "tap" : "thru", ne = /^(?:pop|shift)$/.test(y);
        he.prototype[y] = function() {
          var fe = arguments;
          if (ne && !this.__chain__) {
            var ye = this.value();
            return A.apply(ro(ye) ? ye : [], fe);
          }
          return this[B](function(Ee) {
            return A.apply(ro(Ee) ? Ee : [], fe);
          });
        };
      }), Ed(Oo.prototype, function(y, A) {
        var B = he[A];
        if (B) {
          var ne = B.name + "";
          mr.call(qg, ne) || (qg[ne] = []), qg[ne].push({ name: A, func: B });
        }
      }), qg[z1(n, b).name] = [{
        name: "wrapper",
        func: n
      }], Oo.prototype.clone = U1e, Oo.prototype.reverse = W1e, Oo.prototype.value = G1e, he.prototype.at = $xe, he.prototype.chain = wxe, he.prototype.commit = kxe, he.prototype.next = Sxe, he.prototype.plant = Exe, he.prototype.reverse = Txe, he.prototype.toJSON = he.prototype.valueOf = he.prototype.value = Axe, he.prototype.first = he.prototype.head, cy && (he.prototype[cy] = xxe), he;
    }, nt = et();
    Tu ? ((Tu.exports = nt)._ = nt, mm._ = nt) : Mi._ = nt;
  }).call(Je);
})(Ax, Ax.exports);
var mlc = Ax.exports, Xae = {};
Object.defineProperty(Xae, "__esModule", { value: !0 });
var AU = ve;
function flc(e) {
  var t = AU.useRef();
  return AU.useEffect(function() {
    t.current = e;
  }), t.current;
}
var glc = Xae.default = flc;
const hlc = mlc.debounce(He.refreshTokens, 1e4, { leading: !0, trailing: !1 }), vlc = ({ accessToken: e, refreshUrl: t, clientId: n, onError: o, onSuccess: r }) => {
  const [i, a] = ze(!1), [s, c] = ze(""), l = glc(e);
  return Le(() => {
    const d = s && He.getAuthorizationHeader() ? He.responseInterceptor.use(void 0, async (u) => {
      var p;
      const _ = u.config;
      if (t && ((p = u.response) == null ? void 0 : p.status) === 498 && !i) {
        a(!0);
        const f = await hlc(t);
        if (f)
          return c(f), r == null || r(), He.instance({
            ..._,
            headers: { ..._.headers, Authorization: `Bearer ${f}` }
          });
        o == null || o("Invalid Refresh Token."), a(!1);
      }
      return Promise.reject(u);
    }) : "";
    return () => {
      d && He.responseInterceptor.eject(d);
    };
  }, [s, i, t, o, r]), Le(() => {
    if (e && He.getUrl() && l !== e) {
      He.setAuthorizationHeader(e);
      try {
        He.get(`/provider/${n}/access-token`).catch(async (d) => {
          var u, _;
          if ((((u = d.response) == null ? void 0 : u.status) === 498 || ((_ = d.response) == null ? void 0 : _.status) === 401) && t) {
            a(!0);
            const p = await He.refreshTokens(t);
            p ? (c(p), r == null || r()) : o == null || o("Invalid Refresh Token."), a(!1);
          }
        }).finally(() => {
          c(e);
        });
      } catch {
      }
    }
  }, [e, n, t, l, o, r]), { isRefreshing: i, currentAccessToken: s };
};
var ese = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    var n = 1e3, o = 6e4, r = 36e5, i = "millisecond", a = "second", s = "minute", c = "hour", l = "day", d = "week", u = "month", _ = "quarter", p = "year", f = "date", g = "Invalid Date", h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, $ = function(x, w, E) {
      var T = String(x);
      return !T || T.length >= w ? x : "" + Array(w + 1 - T.length).join(E) + x;
    }, k = { s: $, z: function(x) {
      var w = -x.utcOffset(), E = Math.abs(w), T = Math.floor(E / 60), z = E % 60;
      return (w <= 0 ? "+" : "-") + $(T, 2, "0") + ":" + $(z, 2, "0");
    }, m: function x(w, E) {
      if (w.date() < E.date())
        return -x(E, w);
      var T = 12 * (E.year() - w.year()) + (E.month() - w.month()), z = w.clone().add(T, u), j = E - z < 0, q = w.clone().add(T + (j ? -1 : 1), u);
      return +(-(T + (E - z) / (j ? z - q : q - z)) || 0);
    }, a: function(x) {
      return x < 0 ? Math.ceil(x) || 0 : Math.floor(x);
    }, p: function(x) {
      return { M: u, y: p, w: d, d: l, D: f, h: c, m: s, s: a, ms: i, Q: _ }[x] || String(x || "").toLowerCase().replace(/s$/, "");
    }, u: function(x) {
      return x === void 0;
    } }, S = "en", O = {};
    O[S] = v;
    var I = function(x) {
      return x instanceof C;
    }, D = function x(w, E, T) {
      var z;
      if (!w)
        return S;
      if (typeof w == "string") {
        var j = w.toLowerCase();
        O[j] && (z = j), E && (O[j] = E, z = j);
        var q = w.split("-");
        if (!z && q.length > 1)
          return x(q[0]);
      } else {
        var V = w.name;
        O[V] = w, z = V;
      }
      return !T && z && (S = z), z || !T && S;
    }, M = function(x, w) {
      if (I(x))
        return x.clone();
      var E = typeof w == "object" ? w : {};
      return E.date = x, E.args = arguments, new C(E);
    }, N = k;
    N.l = D, N.i = I, N.w = function(x, w) {
      return M(x, { locale: w.$L, utc: w.$u, x: w.$x, $offset: w.$offset });
    };
    var C = function() {
      function x(E) {
        this.$L = D(E.locale, null, !0), this.parse(E);
      }
      var w = x.prototype;
      return w.parse = function(E) {
        this.$d = function(T) {
          var z = T.date, j = T.utc;
          if (z === null)
            return /* @__PURE__ */ new Date(NaN);
          if (N.u(z))
            return /* @__PURE__ */ new Date();
          if (z instanceof Date)
            return new Date(z);
          if (typeof z == "string" && !/Z$/i.test(z)) {
            var q = z.match(h);
            if (q) {
              var V = q[2] - 1 || 0, F = (q[7] || "0").substring(0, 3);
              return j ? new Date(Date.UTC(q[1], V, q[3] || 1, q[4] || 0, q[5] || 0, q[6] || 0, F)) : new Date(q[1], V, q[3] || 1, q[4] || 0, q[5] || 0, q[6] || 0, F);
            }
          }
          return new Date(z);
        }(E), this.$x = E.x || {}, this.init();
      }, w.init = function() {
        var E = this.$d;
        this.$y = E.getFullYear(), this.$M = E.getMonth(), this.$D = E.getDate(), this.$W = E.getDay(), this.$H = E.getHours(), this.$m = E.getMinutes(), this.$s = E.getSeconds(), this.$ms = E.getMilliseconds();
      }, w.$utils = function() {
        return N;
      }, w.isValid = function() {
        return this.$d.toString() !== g;
      }, w.isSame = function(E, T) {
        var z = M(E);
        return this.startOf(T) <= z && z <= this.endOf(T);
      }, w.isAfter = function(E, T) {
        return M(E) < this.startOf(T);
      }, w.isBefore = function(E, T) {
        return this.endOf(T) < M(E);
      }, w.$g = function(E, T, z) {
        return N.u(E) ? this[T] : this.set(z, E);
      }, w.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, w.valueOf = function() {
        return this.$d.getTime();
      }, w.startOf = function(E, T) {
        var z = this, j = !!N.u(T) || T, q = N.p(E), V = function(re, Z) {
          var ee = N.w(z.$u ? Date.UTC(z.$y, Z, re) : new Date(z.$y, Z, re), z);
          return j ? ee : ee.endOf(l);
        }, F = function(re, Z) {
          return N.w(z.toDate()[re].apply(z.toDate("s"), (j ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), z);
        }, L = this.$W, U = this.$M, W = this.$D, H = "set" + (this.$u ? "UTC" : "");
        switch (q) {
          case p:
            return j ? V(1, 0) : V(31, 11);
          case u:
            return j ? V(1, U) : V(0, U + 1);
          case d:
            var Q = this.$locale().weekStart || 0, X = (L < Q ? L + 7 : L) - Q;
            return V(j ? W - X : W + (6 - X), U);
          case l:
          case f:
            return F(H + "Hours", 0);
          case c:
            return F(H + "Minutes", 1);
          case s:
            return F(H + "Seconds", 2);
          case a:
            return F(H + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, w.endOf = function(E) {
        return this.startOf(E, !1);
      }, w.$set = function(E, T) {
        var z, j = N.p(E), q = "set" + (this.$u ? "UTC" : ""), V = (z = {}, z[l] = q + "Date", z[f] = q + "Date", z[u] = q + "Month", z[p] = q + "FullYear", z[c] = q + "Hours", z[s] = q + "Minutes", z[a] = q + "Seconds", z[i] = q + "Milliseconds", z)[j], F = j === l ? this.$D + (T - this.$W) : T;
        if (j === u || j === p) {
          var L = this.clone().set(f, 1);
          L.$d[V](F), L.init(), this.$d = L.set(f, Math.min(this.$D, L.daysInMonth())).$d;
        } else
          V && this.$d[V](F);
        return this.init(), this;
      }, w.set = function(E, T) {
        return this.clone().$set(E, T);
      }, w.get = function(E) {
        return this[N.p(E)]();
      }, w.add = function(E, T) {
        var z, j = this;
        E = Number(E);
        var q = N.p(T), V = function(U) {
          var W = M(j);
          return N.w(W.date(W.date() + Math.round(U * E)), j);
        };
        if (q === u)
          return this.set(u, this.$M + E);
        if (q === p)
          return this.set(p, this.$y + E);
        if (q === l)
          return V(1);
        if (q === d)
          return V(7);
        var F = (z = {}, z[s] = o, z[c] = r, z[a] = n, z)[q] || 1, L = this.$d.getTime() + E * F;
        return N.w(L, this);
      }, w.subtract = function(E, T) {
        return this.add(-1 * E, T);
      }, w.format = function(E) {
        var T = this, z = this.$locale();
        if (!this.isValid())
          return z.invalidDate || g;
        var j = E || "YYYY-MM-DDTHH:mm:ssZ", q = N.z(this), V = this.$H, F = this.$m, L = this.$M, U = z.weekdays, W = z.months, H = function(Z, ee, J, oe) {
          return Z && (Z[ee] || Z(T, j)) || J[ee].slice(0, oe);
        }, Q = function(Z) {
          return N.s(V % 12 || 12, Z, "0");
        }, X = z.meridiem || function(Z, ee, J) {
          var oe = Z < 12 ? "AM" : "PM";
          return J ? oe.toLowerCase() : oe;
        }, re = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: L + 1, MM: N.s(L + 1, 2, "0"), MMM: H(z.monthsShort, L, W, 3), MMMM: H(W, L), D: this.$D, DD: N.s(this.$D, 2, "0"), d: String(this.$W), dd: H(z.weekdaysMin, this.$W, U, 2), ddd: H(z.weekdaysShort, this.$W, U, 3), dddd: U[this.$W], H: String(V), HH: N.s(V, 2, "0"), h: Q(1), hh: Q(2), a: X(V, F, !0), A: X(V, F, !1), m: String(F), mm: N.s(F, 2, "0"), s: String(this.$s), ss: N.s(this.$s, 2, "0"), SSS: N.s(this.$ms, 3, "0"), Z: q };
        return j.replace(b, function(Z, ee) {
          return ee || re[Z] || q.replace(":", "");
        });
      }, w.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, w.diff = function(E, T, z) {
        var j, q = N.p(T), V = M(E), F = (V.utcOffset() - this.utcOffset()) * o, L = this - V, U = N.m(this, V);
        return U = (j = {}, j[p] = U / 12, j[u] = U, j[_] = U / 3, j[d] = (L - F) / 6048e5, j[l] = (L - F) / 864e5, j[c] = L / r, j[s] = L / o, j[a] = L / n, j)[q] || L, z ? U : N.a(U);
      }, w.daysInMonth = function() {
        return this.endOf(u).$D;
      }, w.$locale = function() {
        return O[this.$L];
      }, w.locale = function(E, T) {
        if (!E)
          return this.$L;
        var z = this.clone(), j = D(E, T, !0);
        return j && (z.$L = j), z;
      }, w.clone = function() {
        return N.w(this.$d, this);
      }, w.toDate = function() {
        return new Date(this.valueOf());
      }, w.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, w.toISOString = function() {
        return this.$d.toISOString();
      }, w.toString = function() {
        return this.$d.toUTCString();
      }, x;
    }(), P = C.prototype;
    return M.prototype = P, [["$ms", i], ["$s", a], ["$m", s], ["$H", c], ["$W", l], ["$M", u], ["$y", p], ["$D", f]].forEach(function(x) {
      P[x[1]] = function(w) {
        return this.$g(w, x[0], x[1]);
      };
    }), M.extend = function(x, w) {
      return x.$i || (x(w, C, M), x.$i = !0), M;
    }, M.locale = D, M.isDayjs = I, M.unix = function(x) {
      return M(1e3 * x);
    }, M.en = O[S], M.Ls = O, M.p = {}, M;
  });
})(ese);
var blc = ese.exports;
const De = /* @__PURE__ */ Zr(blc);
var tse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, i = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, s = {}, c = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, l = function(g) {
      return function(h) {
        this[g] = +h;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(h) {
        if (!h || h === "Z")
          return 0;
        var b = h.match(/([+-]|\d\d)/g), v = 60 * b[1] + (+b[2] || 0);
        return v === 0 ? 0 : b[0] === "+" ? -v : v;
      }(g);
    }], u = function(g) {
      var h = s[g];
      return h && (h.indexOf ? h : h.s.concat(h.f));
    }, _ = function(g, h) {
      var b, v = s.meridiem;
      if (v) {
        for (var $ = 1; $ <= 24; $ += 1)
          if (g.indexOf(v($, 0, h)) > -1) {
            b = $ > 12;
            break;
          }
      } else
        b = g === (h ? "pm" : "PM");
      return b;
    }, p = { A: [a, function(g) {
      this.afternoon = _(g, !1);
    }], a: [a, function(g) {
      this.afternoon = _(g, !0);
    }], S: [/\d/, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [r, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [i, l("seconds")], ss: [i, l("seconds")], m: [i, l("minutes")], mm: [i, l("minutes")], H: [i, l("hours")], h: [i, l("hours")], HH: [i, l("hours")], hh: [i, l("hours")], D: [i, l("day")], DD: [r, l("day")], Do: [a, function(g) {
      var h = s.ordinal, b = g.match(/\d+/);
      if (this.day = b[0], h)
        for (var v = 1; v <= 31; v += 1)
          h(v).replace(/\[|\]/g, "") === g && (this.day = v);
    }], M: [i, l("month")], MM: [r, l("month")], MMM: [a, function(g) {
      var h = u("months"), b = (u("monthsShort") || h.map(function(v) {
        return v.slice(0, 3);
      })).indexOf(g) + 1;
      if (b < 1)
        throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [a, function(g) {
      var h = u("months").indexOf(g) + 1;
      if (h < 1)
        throw new Error();
      this.month = h % 12 || h;
    }], Y: [/[+-]?\d+/, l("year")], YY: [r, function(g) {
      this.year = c(g);
    }], YYYY: [/\d{4}/, l("year")], Z: d, ZZ: d };
    function f(g) {
      var h, b;
      h = g, b = s && s.formats;
      for (var v = (g = h.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(M, N, C) {
        var P = C && C.toUpperCase();
        return N || b[C] || n[C] || b[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(x, w, E) {
          return w || E.slice(1);
        });
      })).match(o), $ = v.length, k = 0; k < $; k += 1) {
        var S = v[k], O = p[S], I = O && O[0], D = O && O[1];
        v[k] = D ? { regex: I, parser: D } : S.replace(/^\[|\]$/g, "");
      }
      return function(M) {
        for (var N = {}, C = 0, P = 0; C < $; C += 1) {
          var x = v[C];
          if (typeof x == "string")
            P += x.length;
          else {
            var w = x.regex, E = x.parser, T = M.slice(P), z = w.exec(T)[0];
            E.call(N, z), M = M.replace(z, "");
          }
        }
        return function(j) {
          var q = j.afternoon;
          if (q !== void 0) {
            var V = j.hours;
            q ? V < 12 && (j.hours += 12) : V === 12 && (j.hours = 0), delete j.afternoon;
          }
        }(N), N;
      };
    }
    return function(g, h, b) {
      b.p.customParseFormat = !0, g && g.parseTwoDigitYear && (c = g.parseTwoDigitYear);
      var v = h.prototype, $ = v.parse;
      v.parse = function(k) {
        var S = k.date, O = k.utc, I = k.args;
        this.$u = O;
        var D = I[1];
        if (typeof D == "string") {
          var M = I[2] === !0, N = I[3] === !0, C = M || N, P = I[2];
          N && (P = I[2]), s = this.$locale(), !M && P && (s = b.Ls[P]), this.$d = function(T, z, j) {
            try {
              if (["x", "X"].indexOf(z) > -1)
                return new Date((z === "X" ? 1e3 : 1) * T);
              var q = f(z)(T), V = q.year, F = q.month, L = q.day, U = q.hours, W = q.minutes, H = q.seconds, Q = q.milliseconds, X = q.zone, re = /* @__PURE__ */ new Date(), Z = L || (V || F ? 1 : re.getDate()), ee = V || re.getFullYear(), J = 0;
              V && !F || (J = F > 0 ? F - 1 : re.getMonth());
              var oe = U || 0, ce = W || 0, de = H || 0, te = Q || 0;
              return X ? new Date(Date.UTC(ee, J, Z, oe, ce, de, te + 60 * X.offset * 1e3)) : j ? new Date(Date.UTC(ee, J, Z, oe, ce, de, te)) : new Date(ee, J, Z, oe, ce, de, te);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(S, D, O), this.init(), P && P !== !0 && (this.$L = this.locale(P).$L), C && S != this.format(D) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (D instanceof Array)
          for (var x = D.length, w = 1; w <= x; w += 1) {
            I[1] = D[w - 1];
            var E = b.apply(this, I);
            if (E.isValid()) {
              this.$d = E.$d, this.$L = E.$L, this.init();
              break;
            }
            w === x && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          $.call(this, k);
      };
    };
  });
})(tse);
var ylc = tse.exports;
const $lc = /* @__PURE__ */ Zr(ylc);
var nse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    var n, o, r = 1e3, i = 6e4, a = 36e5, s = 864e5, c = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, l = 31536e6, d = 2592e6, u = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, _ = { years: l, months: d, days: s, hours: a, minutes: i, seconds: r, milliseconds: 1, weeks: 6048e5 }, p = function(S) {
      return S instanceof k;
    }, f = function(S, O, I) {
      return new k(S, I, O.$l);
    }, g = function(S) {
      return o.p(S) + "s";
    }, h = function(S) {
      return S < 0;
    }, b = function(S) {
      return h(S) ? Math.ceil(S) : Math.floor(S);
    }, v = function(S) {
      return Math.abs(S);
    }, $ = function(S, O) {
      return S ? h(S) ? { negative: !0, format: "" + v(S) + O } : { negative: !1, format: "" + S + O } : { negative: !1, format: "" };
    }, k = function() {
      function S(I, D, M) {
        var N = this;
        if (this.$d = {}, this.$l = M, I === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), D)
          return f(I * _[g(D)], this);
        if (typeof I == "number")
          return this.$ms = I, this.parseFromMilliseconds(), this;
        if (typeof I == "object")
          return Object.keys(I).forEach(function(x) {
            N.$d[g(x)] = I[x];
          }), this.calMilliseconds(), this;
        if (typeof I == "string") {
          var C = I.match(u);
          if (C) {
            var P = C.slice(2).map(function(x) {
              return x != null ? Number(x) : 0;
            });
            return this.$d.years = P[0], this.$d.months = P[1], this.$d.weeks = P[2], this.$d.days = P[3], this.$d.hours = P[4], this.$d.minutes = P[5], this.$d.seconds = P[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var O = S.prototype;
      return O.calMilliseconds = function() {
        var I = this;
        this.$ms = Object.keys(this.$d).reduce(function(D, M) {
          return D + (I.$d[M] || 0) * _[M];
        }, 0);
      }, O.parseFromMilliseconds = function() {
        var I = this.$ms;
        this.$d.years = b(I / l), I %= l, this.$d.months = b(I / d), I %= d, this.$d.days = b(I / s), I %= s, this.$d.hours = b(I / a), I %= a, this.$d.minutes = b(I / i), I %= i, this.$d.seconds = b(I / r), I %= r, this.$d.milliseconds = I;
      }, O.toISOString = function() {
        var I = $(this.$d.years, "Y"), D = $(this.$d.months, "M"), M = +this.$d.days || 0;
        this.$d.weeks && (M += 7 * this.$d.weeks);
        var N = $(M, "D"), C = $(this.$d.hours, "H"), P = $(this.$d.minutes, "M"), x = this.$d.seconds || 0;
        this.$d.milliseconds && (x += this.$d.milliseconds / 1e3);
        var w = $(x, "S"), E = I.negative || D.negative || N.negative || C.negative || P.negative || w.negative, T = C.format || P.format || w.format ? "T" : "", z = (E ? "-" : "") + "P" + I.format + D.format + N.format + T + C.format + P.format + w.format;
        return z === "P" || z === "-P" ? "P0D" : z;
      }, O.toJSON = function() {
        return this.toISOString();
      }, O.format = function(I) {
        var D = I || "YYYY-MM-DDTHH:mm:ss", M = { Y: this.$d.years, YY: o.s(this.$d.years, 2, "0"), YYYY: o.s(this.$d.years, 4, "0"), M: this.$d.months, MM: o.s(this.$d.months, 2, "0"), D: this.$d.days, DD: o.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: o.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: o.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: o.s(this.$d.seconds, 2, "0"), SSS: o.s(this.$d.milliseconds, 3, "0") };
        return D.replace(c, function(N, C) {
          return C || String(M[N]);
        });
      }, O.as = function(I) {
        return this.$ms / _[g(I)];
      }, O.get = function(I) {
        var D = this.$ms, M = g(I);
        return M === "milliseconds" ? D %= 1e3 : D = M === "weeks" ? b(D / _[M]) : this.$d[M], D === 0 ? 0 : D;
      }, O.add = function(I, D, M) {
        var N;
        return N = D ? I * _[g(D)] : p(I) ? I.$ms : f(I, this).$ms, f(this.$ms + N * (M ? -1 : 1), this);
      }, O.subtract = function(I, D) {
        return this.add(I, D, !0);
      }, O.locale = function(I) {
        var D = this.clone();
        return D.$l = I, D;
      }, O.clone = function() {
        return f(this.$ms, this);
      }, O.humanize = function(I) {
        return n().add(this.$ms, "ms").locale(this.$l).fromNow(!I);
      }, O.milliseconds = function() {
        return this.get("milliseconds");
      }, O.asMilliseconds = function() {
        return this.as("milliseconds");
      }, O.seconds = function() {
        return this.get("seconds");
      }, O.asSeconds = function() {
        return this.as("seconds");
      }, O.minutes = function() {
        return this.get("minutes");
      }, O.asMinutes = function() {
        return this.as("minutes");
      }, O.hours = function() {
        return this.get("hours");
      }, O.asHours = function() {
        return this.as("hours");
      }, O.days = function() {
        return this.get("days");
      }, O.asDays = function() {
        return this.as("days");
      }, O.weeks = function() {
        return this.get("weeks");
      }, O.asWeeks = function() {
        return this.as("weeks");
      }, O.months = function() {
        return this.get("months");
      }, O.asMonths = function() {
        return this.as("months");
      }, O.years = function() {
        return this.get("years");
      }, O.asYears = function() {
        return this.as("years");
      }, S;
    }();
    return function(S, O, I) {
      n = I, o = I().$utils(), I.duration = function(N, C) {
        var P = I.locale();
        return f(N, { $l: P }, C);
      }, I.isDuration = p;
      var D = O.prototype.add, M = O.prototype.subtract;
      O.prototype.add = function(N, C) {
        return p(N) && (N = N.asMilliseconds()), D.bind(this)(N, C);
      }, O.prototype.subtract = function(N, C) {
        return p(N) && (N = N.asMilliseconds()), M.bind(this)(N, C);
      };
    };
  });
})(nse);
var wlc = nse.exports;
const klc = /* @__PURE__ */ Zr(wlc);
var ose = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    return function(n, o, r) {
      o.prototype.isBetween = function(i, a, s, c) {
        var l = r(i), d = r(a), u = (c = c || "()")[0] === "(", _ = c[1] === ")";
        return (u ? this.isAfter(l, s) : !this.isBefore(l, s)) && (_ ? this.isBefore(d, s) : !this.isAfter(d, s)) || (u ? this.isBefore(l, s) : !this.isAfter(l, s)) && (_ ? this.isAfter(d, s) : !this.isBefore(d, s));
      };
    };
  });
})(ose);
var Slc = ose.exports;
const xlc = /* @__PURE__ */ Zr(Slc);
var rse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    return function(n, o, r) {
      o.prototype.isToday = function() {
        var i = "YYYY-MM-DD", a = r();
        return this.format(i) === a.format(i);
      };
    };
  });
})(rse);
var Elc = rse.exports;
const Tlc = /* @__PURE__ */ Zr(Elc);
var ise = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(o, r, i) {
      var a = r.prototype, s = a.format;
      i.en.formats = n, a.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var l = this.$locale().formats, d = function(u, _) {
          return u.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(p, f, g) {
            var h = g && g.toUpperCase();
            return f || _[g] || n[g] || _[h].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(b, v, $) {
              return v || $.slice(1);
            });
          });
        }(c, l === void 0 ? {} : l);
        return s.call(this, d);
      };
    };
  });
})(ise);
var Alc = ise.exports;
const Clc = /* @__PURE__ */ Zr(Alc);
var ase = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    return function(n, o, r) {
      var i = function(a, s) {
        if (!s || !s.length || !s[0] || s.length === 1 && !s[0].length)
          return null;
        var c;
        s.length === 1 && s[0].length > 0 && (s = s[0]), c = s[0];
        for (var l = 1; l < s.length; l += 1)
          s[l].isValid() && !s[l][a](c) || (c = s[l]);
        return c;
      };
      r.max = function() {
        var a = [].slice.call(arguments, 0);
        return i("isAfter", a);
      }, r.min = function() {
        var a = [].slice.call(arguments, 0);
        return i("isBefore", a);
      };
    };
  });
})(ase);
var zlc = ase.exports;
const Olc = /* @__PURE__ */ Zr(zlc);
var sse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    return function(n, o, r) {
      n = n || {};
      var i = o.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(l, d, u, _) {
        return i.fromToBase(l, d, u, _);
      }
      r.en.relativeTime = a, i.fromToBase = function(l, d, u, _, p) {
        for (var f, g, h, b = u.$locale().relativeTime || a, v = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], $ = v.length, k = 0; k < $; k += 1) {
          var S = v[k];
          S.d && (f = _ ? r(l).diff(u, S.d, !0) : u.diff(l, S.d, !0));
          var O = (n.rounding || Math.round)(Math.abs(f));
          if (h = f > 0, O <= S.r || !S.r) {
            O <= 1 && k > 0 && (S = v[k - 1]);
            var I = b[S.l];
            p && (O = p("" + O)), g = typeof I == "string" ? I.replace("%d", O) : I(O, d, S.l, h);
            break;
          }
        }
        if (d)
          return g;
        var D = h ? b.future : b.past;
        return typeof D == "function" ? D(g) : D.replace("%s", g);
      }, i.to = function(l, d) {
        return s(l, d, this, !0);
      }, i.from = function(l, d) {
        return s(l, d, this);
      };
      var c = function(l) {
        return l.$u ? r.utc() : r();
      };
      i.toNow = function(l) {
        return this.to(c(this), l);
      }, i.fromNow = function(l) {
        return this.from(c(this), l);
      };
    };
  });
})(sse);
var Plc = sse.exports;
const Ilc = /* @__PURE__ */ Zr(Plc);
var cse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    function n() {
      return n = Object.assign ? Object.assign.bind() : function(s) {
        for (var c = 1; c < arguments.length; c++) {
          var l = arguments[c];
          for (var d in l)
            Object.prototype.hasOwnProperty.call(l, d) && (s[d] = l[d]);
        }
        return s;
      }, n.apply(this, arguments);
    }
    var o = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }, i = {}, a = {};
    return function(s, c, l) {
      var d, u = function(g, h, b) {
        b === void 0 && (b = {});
        var v = new Date(g), $ = function(k, S) {
          S === void 0 && (S = {});
          var O = S.timeZoneName || "short", I = k + "|" + O, D = i[I];
          return D || (D = new Intl.DateTimeFormat("en-US", n({}, r, { hour12: !1, timeZone: k, timeZoneName: O })), i[I] = D), D;
        }(h, b);
        return $.formatToParts(v);
      }, _ = function(g, h) {
        for (var b = u(g, h), v = [], $ = 0; $ < b.length; $ += 1) {
          var k = b[$], S = k.type, O = k.value, I = o[S];
          I >= 0 && (v[I] = parseInt(O, 10));
        }
        var D = v[3], M = D === 24 ? 0 : D, N = v[0] + "-" + v[1] + "-" + v[2] + " " + M + ":" + v[4] + ":" + v[5] + ":000", C = +g;
        return (l.utc(N).valueOf() - (C -= C % 1e3)) / 6e4;
      }, p = c.prototype;
      p.tz = function(g, h) {
        g === void 0 && (g = d);
        var b = this.utcOffset(), v = this.toDate(), $ = function(I) {
          var D = a[I];
          return D || (D = new Intl.DateTimeFormat("en-US", n({}, r, { timeZone: I })), a[I] = D), D;
        }(g).format(v), k = Math.round((v - new Date($)) / 1e3 / 60), S = l($, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(v.getTimezoneOffset() / 15) - k, !0);
        if (h) {
          var O = S.utcOffset();
          S = S.add(b - O, "minute");
        }
        return S.$x.$timezone = g, S;
      }, p.offsetName = function(g) {
        var h = this.$x.$timezone || l.tz.guess(), b = u(this.valueOf(), h, { timeZoneName: g }).find(function(v) {
          return v.type.toLowerCase() === "timezonename";
        });
        return b && b.value;
      };
      var f = p.startOf;
      p.startOf = function(g, h) {
        if (!this.$x || !this.$x.$timezone)
          return f.call(this, g, h);
        var b = l(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return f.call(b, g, h).tz(this.$x.$timezone, !0);
      }, l.tz = function(g, h, b) {
        var v = b && h, $ = b || h || d, k = _(+l(), $);
        if (typeof g != "string")
          return l(g).tz($);
        var S = function(M, N, C) {
          var P = M - 60 * N * 1e3, x = _(P, C);
          if (N === x)
            return [P, N];
          var w = _(P -= 60 * (x - N) * 1e3, C);
          return x === w ? [P, x] : [M - 60 * Math.min(x, w) * 1e3, Math.max(x, w)];
        }(l.utc(g, v).valueOf(), k, $), O = S[0], I = S[1], D = l(O).utcOffset(I);
        return D.$x.$timezone = $, D;
      }, l.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, l.tz.setDefault = function(g) {
        d = g;
      };
    };
  });
})(cse);
var Rlc = cse.exports;
const Nlc = /* @__PURE__ */ Zr(Rlc);
var lse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    return function(n, o) {
      o.prototype.toArray = function() {
        return [this.$y, this.$M, this.$D, this.$H, this.$m, this.$s, this.$ms];
      };
    };
  });
})(lse);
var Dlc = lse.exports;
const Mlc = /* @__PURE__ */ Zr(Dlc);
var dse = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Je, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(i, a, s) {
      var c = a.prototype;
      s.utc = function(g) {
        var h = { date: g, utc: !0, args: arguments };
        return new a(h);
      }, c.utc = function(g) {
        var h = s(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? h.add(this.utcOffset(), n) : h;
      }, c.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var l = c.parse;
      c.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), l.call(this, g);
      };
      var d = c.init;
      c.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else
          d.call(this);
      };
      var u = c.utcOffset;
      c.utcOffset = function(g, h) {
        var b = this.$utils().u;
        if (b(g))
          return this.$u ? 0 : b(this.$offset) ? u.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(S) {
          S === void 0 && (S = "");
          var O = S.match(o);
          if (!O)
            return null;
          var I = ("" + O[0]).match(r) || ["-", 0, 0], D = I[0], M = 60 * +I[1] + +I[2];
          return M === 0 ? 0 : D === "+" ? M : -M;
        }(g), g === null))
          return this;
        var v = Math.abs(g) <= 16 ? 60 * g : g, $ = this;
        if (h)
          return $.$offset = v, $.$u = g === 0, $;
        if (g !== 0) {
          var k = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          ($ = this.local().add(v + k, n)).$offset = v, $.$x.$localOffset = k;
        } else
          $ = this.utc();
        return $;
      };
      var _ = c.format;
      c.format = function(g) {
        var h = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return _.call(this, h);
      }, c.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = c.toDate;
      c.toDate = function(g) {
        return g === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var f = c.diff;
      c.diff = function(g, h, b) {
        if (g && this.$u === g.$u)
          return f.call(this, g, h, b);
        var v = this.local(), $ = s(g).local();
        return f.call(v, $, h, b);
      };
    };
  });
})(dse);
var Llc = dse.exports;
const qlc = /* @__PURE__ */ Zr(Llc), jlc = (e = {}, t, n) => {
  const o = [1, 2, 3, 4, 5];
  n.getWorkingWeekdays = function() {
    return e.workingWeekdays || o;
  }, n.setWorkingWeekdays = function(r) {
    e.workingWeekdays = r;
  }, n.getHolidays = function() {
    return e.holidays || [];
  }, n.setHolidays = function(r) {
    e.holidays = r;
  }, n.getHolidayFormat = function() {
    return e.holidayFormat;
  }, n.setHolidayFormat = function(r) {
    e.holidayFormat = r;
  }, n.getAdditionalWorkingDays = function() {
    return e.additionalWorkingDays || [];
  }, n.setAdditionalWorkingDays = function(r) {
    e.additionalWorkingDays = r;
  }, n.getAdditionalWorkingDayFormat = function() {
    return e.additionalWorkingDayFormat;
  }, n.setAdditionalWorkingDayFormat = function(r) {
    e.additionalWorkingDayFormat = r;
  }, t.prototype.isHoliday = function() {
    return e.holidays ? !!e.holidays.includes(this.format(e.holidayFormat)) : !1;
  }, t.prototype.isBusinessDay = function() {
    const r = e.workingWeekdays || o;
    return this.isHoliday() ? !1 : !!(this.isAdditionalWorkingDay() || r.includes(this.day()));
  }, t.prototype.isAdditionalWorkingDay = function() {
    return e.additionalWorkingDays ? !!e.additionalWorkingDays.includes(this.format(e.additionalWorkingDayFormat)) : !1;
  }, t.prototype.businessDaysAdd = function(r) {
    const i = r < 0 ? -1 : 1;
    let a = this.clone(), s = Math.abs(r);
    for (; s > 0; )
      a = a.add(i, "d"), a.isBusinessDay() && (s -= 1);
    return a;
  }, t.prototype.businessDaysSubtract = function(r) {
    let i = this.clone();
    return i = i.businessDaysAdd(r * -1), i;
  }, t.prototype.businessDiff = function(r) {
    const i = this.clone(), a = r.clone(), s = i >= a;
    let c = s ? a : i;
    const l = s ? i : a;
    let d = 0;
    if (c.isSame(l))
      return d;
    for (; c < l; )
      c.isBusinessDay() && (d += 1), c = c.add(1, "d");
    return s ? d : -d;
  }, t.prototype.nextBusinessDay = function() {
    let i = this.clone(), a = 1;
    for (; a < 7 && (i = i.add(1, "day"), !i.isBusinessDay()); )
      a += 1;
    return i;
  }, t.prototype.prevBusinessDay = function() {
    let i = this.clone(), a = 1;
    for (; a < 7 && (i = i.subtract(1, "day"), !i.isBusinessDay()); )
      a += 1;
    return i;
  }, t.prototype.businessDaysInMonth = function() {
    if (!this.isValid())
      return [];
    let r = this.clone().startOf("month");
    const i = this.clone().endOf("month"), a = [];
    let s = !1;
    for (; !s; )
      r.isBusinessDay() && a.push(r.clone()), r = r.add(1, "day"), r.isAfter(i) && (s = !0);
    return a;
  }, t.prototype.lastBusinessDayOfMonth = function() {
    const r = this.businessDaysInMonth();
    return r[r.length - 1];
  }, t.prototype.businessWeeksInMonth = function() {
    if (!this.isValid())
      return [];
    let r = this.clone().startOf("month");
    const i = this.clone().endOf("month"), a = [];
    let s = [], c = !1;
    for (; !c; )
      r.isBusinessDay() && s.push(r.clone()), (r.day() === 5 || r.isSame(i, "day")) && (a.push(s), s = []), r = r.add(1, "day"), r.isAfter(i) && (c = !0);
    return a;
  };
};
De.extend($lc);
De.extend(jlc);
De.extend(xlc);
De.extend(Tlc);
De.extend(Clc);
De.extend(Ilc);
De.extend(Nlc);
De.extend(Mlc);
De.extend(qlc);
De.extend(Olc);
De.extend(klc);
const Flc = (e, t = De.tz.guess()) => {
  var i;
  const { data: n, isLoading: o } = sg(), r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.timeZone) ?? t;
  Le(() => {
    !o && r && e && r !== t && e(t);
  }, [t, r, e, o]);
}, Vlc = () => {
  const e = `/${Pi.me}`;
  return Yo({
    mutationFn: (n) => {
      const { timeZone: o } = n;
      return He == null ? void 0 : He.patch(e, { timeZone: o }).then((r) => {
        if (r.data.status === qt)
          return r.data;
        throw new Error(r.data.error.message);
      });
    }
  });
}, Blc = "calcom-atoms", Ii = ({
  children: e,
  customClassName: t
}) => {
  const { options: n } = po();
  return /* @__PURE__ */ m(
    "div",
    {
      dir: (n == null ? void 0 : n.readingDirection) ?? "ltr",
      className: ae(`${Blc} m-0 w-auto bg-transparent p-0`, t),
      children: e
    }
  );
};
function Uq(e) {
  const t = e + "CollectionProvider", [n, o] = os(t), [r, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (p) => {
    const { scope: f, children: g } = p, h = ve.useRef(null), b = ve.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ ve.createElement(r, {
      scope: f,
      itemMap: b,
      collectionRef: h
    }, g);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ ve.forwardRef((p, f) => {
    const { scope: g, children: h } = p, b = i(s, g), v = or(f, b.collectionRef);
    return /* @__PURE__ */ ve.createElement(Df, {
      ref: v
    }, h);
  }), l = e + "CollectionItemSlot", d = "data-radix-collection-item", u = /* @__PURE__ */ ve.forwardRef((p, f) => {
    const { scope: g, children: h, ...b } = p, v = ve.useRef(null), $ = or(f, v), k = i(l, g);
    return ve.useEffect(() => (k.itemMap.set(v, {
      ref: v,
      ...b
    }), () => void k.itemMap.delete(v))), /* @__PURE__ */ ve.createElement(Df, {
      [d]: "",
      ref: $
    }, h);
  });
  function _(p) {
    const f = i(e + "CollectionConsumer", p);
    return ve.useCallback(() => {
      const h = f.collectionRef.current;
      if (!h)
        return [];
      const b = Array.from(h.querySelectorAll(`[${d}]`));
      return Array.from(f.itemMap.values()).sort(
        (k, S) => b.indexOf(k.ref.current) - b.indexOf(S.ref.current)
      );
    }, [
      f.collectionRef,
      f.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: c,
      ItemSlot: u
    },
    _,
    o
  ];
}
const XN = "dismissableLayer.update", Ulc = "dismissableLayer.pointerDownOutside", Wlc = "dismissableLayer.focusOutside";
let CU;
const use = /* @__PURE__ */ No({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Glc = /* @__PURE__ */ it((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, d = Pn(use), [u, _] = ze(null), p = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, f] = ze({}), g = or(
    t,
    (D) => _(D)
  ), h = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf(b), $ = u ? h.indexOf(u) : -1, k = d.layersWithOutsidePointerEventsDisabled.size > 0, S = $ >= v, O = Klc((D) => {
    const M = D.target, N = [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    );
    !S || N || (i == null || i(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p), I = Ylc((D) => {
    const M = D.target;
    [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    ) || (a == null || a(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p);
  return Pq((D) => {
    $ === d.layers.size - 1 && (r == null || r(D), !D.defaultPrevented && c && (D.preventDefault(), c()));
  }, p), Le(() => {
    if (u)
      return o && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (CU = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), zU(), () => {
        o && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = CU);
      };
  }, [
    u,
    p,
    o,
    d
  ]), Le(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), zU());
  }, [
    u,
    d
  ]), Le(() => {
    const D = () => f({});
    return document.addEventListener(XN, D), () => document.removeEventListener(XN, D);
  }, []), /* @__PURE__ */ Pe(io.div, We({}, l, {
    ref: g,
    style: {
      pointerEvents: k ? S ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Bt(e.onFocusCapture, I.onFocusCapture),
    onBlurCapture: Bt(e.onBlurCapture, I.onBlurCapture),
    onPointerDownCapture: Bt(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
}), Hlc = /* @__PURE__ */ it((e, t) => {
  const n = Pn(use), o = Ue(null), r = or(t, o);
  return Le(() => {
    const i = o.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ Pe(io.div, We({}, e, {
    ref: r
  }));
});
function Klc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1), r = Ue(() => {
  });
  return Le(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          _se(Ulc, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Ylc(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1);
  return Le(() => {
    const r = (i) => {
      i.target && !o.current && _se(Wlc, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function zU() {
  const e = new CustomEvent(XN);
  document.dispatchEvent(e);
}
function _se(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? L0(r, i) : r.dispatchEvent(i);
}
const Zlc = Glc, Qlc = Hlc, Jlc = /* @__PURE__ */ it((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ Uv.createPortal(/* @__PURE__ */ Pe(io.div, We({}, r, {
    ref: t
  })), o) : null;
}), Xlc = globalThis != null && globalThis.document ? ts : () => {
}, pse = "ToastProvider", [Wq, edc, tdc] = Uq("Toast"), [mse, Qmd] = os("Toast", [
  tdc
]), [ndc, GT] = mse(pse), fse = (e) => {
  const { __scopeToast: t, label: n = "Notification", duration: o = 5e3, swipeDirection: r = "right", swipeThreshold: i = 50, children: a } = e, [s, c] = ze(null), [l, d] = ze(0), u = Ue(!1), _ = Ue(!1);
  return /* @__PURE__ */ Pe(Wq.Provider, {
    scope: t
  }, /* @__PURE__ */ Pe(ndc, {
    scope: t,
    label: n,
    duration: o,
    swipeDirection: r,
    swipeThreshold: i,
    toastCount: l,
    viewport: s,
    onViewportChange: c,
    onToastAdd: at(
      () => d(
        (p) => p + 1
      ),
      []
    ),
    onToastRemove: at(
      () => d(
        (p) => p - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: u,
    isClosePausedRef: _
  }, a));
};
fse.propTypes = {
  label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const t = `Invalid prop \`label\` supplied to \`${pse}\`. Expected non-empty \`string\`.`;
      return new Error(t);
    }
    return null;
  }
};
const odc = "ToastViewport", rdc = [
  "F8"
], eD = "toast.viewportPause", tD = "toast.viewportResume", idc = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, hotkey: o = rdc, label: r = "Notifications ({hotkey})", ...i } = e, a = GT(odc, n), s = edc(n), c = Ue(null), l = Ue(null), d = Ue(null), u = Ue(null), _ = or(t, u, a.onViewportChange), p = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), f = a.toastCount > 0;
  Le(() => {
    const h = (b) => {
      var v;
      o.every(
        (k) => b[k] || b.code === k
      ) && ((v = u.current) === null || v === void 0 || v.focus());
    };
    return document.addEventListener("keydown", h), () => document.removeEventListener("keydown", h);
  }, [
    o
  ]), Le(() => {
    const h = c.current, b = u.current;
    if (f && h && b) {
      const v = () => {
        if (!a.isClosePausedRef.current) {
          const O = new CustomEvent(eD);
          b.dispatchEvent(O), a.isClosePausedRef.current = !0;
        }
      }, $ = () => {
        if (a.isClosePausedRef.current) {
          const O = new CustomEvent(tD);
          b.dispatchEvent(O), a.isClosePausedRef.current = !1;
        }
      }, k = (O) => {
        !h.contains(O.relatedTarget) && $();
      }, S = () => {
        h.contains(document.activeElement) || $();
      };
      return h.addEventListener("focusin", v), h.addEventListener("focusout", k), h.addEventListener("pointermove", v), h.addEventListener("pointerleave", S), window.addEventListener("blur", v), window.addEventListener("focus", $), () => {
        h.removeEventListener("focusin", v), h.removeEventListener("focusout", k), h.removeEventListener("pointermove", v), h.removeEventListener("pointerleave", S), window.removeEventListener("blur", v), window.removeEventListener("focus", $);
      };
    }
  }, [
    f,
    a.isClosePausedRef
  ]);
  const g = at(({ tabbingDirection: h }) => {
    const v = s().map(($) => {
      const k = $.ref.current, S = [
        k,
        ...$dc(k)
      ];
      return h === "forwards" ? S : S.reverse();
    });
    return (h === "forwards" ? v.reverse() : v).flat();
  }, [
    s
  ]);
  return Le(() => {
    const h = u.current;
    if (h) {
      const b = (v) => {
        const $ = v.altKey || v.ctrlKey || v.metaKey;
        if (v.key === "Tab" && !$) {
          const D = document.activeElement, M = v.shiftKey;
          if (v.target === h && M) {
            var S;
            (S = l.current) === null || S === void 0 || S.focus();
            return;
          }
          const P = g({
            tabbingDirection: M ? "backwards" : "forwards"
          }), x = P.findIndex(
            (w) => w === D
          );
          if (VO(P.slice(x + 1)))
            v.preventDefault();
          else {
            var O, I;
            M ? (O = l.current) === null || O === void 0 || O.focus() : (I = d.current) === null || I === void 0 || I.focus();
          }
        }
      };
      return h.addEventListener("keydown", b), () => h.removeEventListener("keydown", b);
    }
  }, [
    s,
    g
  ]), /* @__PURE__ */ Pe(Qlc, {
    ref: c,
    role: "region",
    "aria-label": r.replace("{hotkey}", p),
    tabIndex: -1,
    style: {
      pointerEvents: f ? void 0 : "none"
    }
  }, f && /* @__PURE__ */ Pe(OU, {
    ref: l,
    onFocusFromOutsideViewport: () => {
      const h = g({
        tabbingDirection: "forwards"
      });
      VO(h);
    }
  }), /* @__PURE__ */ Pe(Wq.Slot, {
    scope: n
  }, /* @__PURE__ */ Pe(io.ol, We({
    tabIndex: -1
  }, i, {
    ref: _
  }))), f && /* @__PURE__ */ Pe(OU, {
    ref: d,
    onFocusFromOutsideViewport: () => {
      const h = g({
        tabbingDirection: "backwards"
      });
      VO(h);
    }
  }));
}), adc = "ToastFocusProxy", OU = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, onFocusFromOutsideViewport: o, ...r } = e, i = GT(adc, n);
  return /* @__PURE__ */ Pe(qq, We({
    "aria-hidden": !0,
    tabIndex: 0
  }, r, {
    ref: t,
    style: {
      position: "fixed"
    },
    onFocus: (a) => {
      var s;
      const c = a.relatedTarget;
      !((s = i.viewport) !== null && s !== void 0 && s.contains(c)) && o();
    }
  }));
}), HT = "Toast", sdc = "toast.swipeStart", cdc = "toast.swipeMove", ldc = "toast.swipeCancel", ddc = "toast.swipeEnd", udc = /* @__PURE__ */ it((e, t) => {
  const { forceMount: n, open: o, defaultOpen: r, onOpenChange: i, ...a } = e, [s = !0, c] = jc({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ Pe(rs, {
    present: n || s
  }, /* @__PURE__ */ Pe(gse, We({
    open: s
  }, a, {
    ref: t,
    onClose: () => c(!1),
    onPause: Ui(e.onPause),
    onResume: Ui(e.onResume),
    onSwipeStart: Bt(e.onSwipeStart, (l) => {
      l.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: Bt(e.onSwipeMove, (l) => {
      const { x: d, y: u } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
    }),
    onSwipeCancel: Bt(e.onSwipeCancel, (l) => {
      l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: Bt(e.onSwipeEnd, (l) => {
      const { x: d, y: u } = l.detail.delta;
      l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), c(!1);
    })
  })));
}), [_dc, pdc] = mse(HT, {
  onClose() {
  }
}), gse = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, type: o = "foreground", duration: r, open: i, onClose: a, onEscapeKeyDown: s, onPause: c, onResume: l, onSwipeStart: d, onSwipeMove: u, onSwipeCancel: _, onSwipeEnd: p, ...f } = e, g = GT(HT, n), [h, b] = ze(null), v = or(
    t,
    (w) => b(w)
  ), $ = Ue(null), k = Ue(null), S = r || g.duration, O = Ue(0), I = Ue(S), D = Ue(0), { onToastAdd: M, onToastRemove: N } = g, C = Ui(() => {
    var w;
    (h == null ? void 0 : h.contains(document.activeElement)) && ((w = g.viewport) === null || w === void 0 || w.focus()), a();
  }), P = at((w) => {
    !w || w === 1 / 0 || (window.clearTimeout(D.current), O.current = (/* @__PURE__ */ new Date()).getTime(), D.current = window.setTimeout(C, w));
  }, [
    C
  ]);
  Le(() => {
    const w = g.viewport;
    if (w) {
      const E = () => {
        P(I.current), l == null || l();
      }, T = () => {
        const z = (/* @__PURE__ */ new Date()).getTime() - O.current;
        I.current = I.current - z, window.clearTimeout(D.current), c == null || c();
      };
      return w.addEventListener(eD, T), w.addEventListener(tD, E), () => {
        w.removeEventListener(eD, T), w.removeEventListener(tD, E);
      };
    }
  }, [
    g.viewport,
    S,
    c,
    l,
    P
  ]), Le(() => {
    i && !g.isClosePausedRef.current && P(S);
  }, [
    i,
    S,
    g.isClosePausedRef,
    P
  ]), Le(() => (M(), () => N()), [
    M,
    N
  ]);
  const x = Tt(() => h ? yse(h) : null, [
    h
  ]);
  return g.viewport ? /* @__PURE__ */ Pe(Oi, null, x && /* @__PURE__ */ Pe(mdc, {
    __scopeToast: n,
    role: "status",
    "aria-live": o === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, x), /* @__PURE__ */ Pe(_dc, {
    scope: n,
    onClose: C
  }, /* @__PURE__ */ Wv(/* @__PURE__ */ Pe(Wq.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ Pe(Zlc, {
    asChild: !0,
    onEscapeKeyDown: Bt(s, () => {
      g.isFocusedToastEscapeKeyDownRef.current || C(), g.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ Pe(io.li, We({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": i ? "open" : "closed",
    "data-swipe-direction": g.swipeDirection
  }, f, {
    ref: v,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...e.style
    },
    onKeyDown: Bt(e.onKeyDown, (w) => {
      w.key === "Escape" && (s == null || s(w.nativeEvent), w.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, C()));
    }),
    onPointerDown: Bt(e.onPointerDown, (w) => {
      w.button === 0 && ($.current = {
        x: w.clientX,
        y: w.clientY
      });
    }),
    onPointerMove: Bt(e.onPointerMove, (w) => {
      if (!$.current)
        return;
      const E = w.clientX - $.current.x, T = w.clientY - $.current.y, z = !!k.current, j = [
        "left",
        "right"
      ].includes(g.swipeDirection), q = [
        "left",
        "up"
      ].includes(g.swipeDirection) ? Math.min : Math.max, V = j ? q(0, E) : 0, F = j ? 0 : q(0, T), L = w.pointerType === "touch" ? 10 : 2, U = {
        x: V,
        y: F
      }, W = {
        originalEvent: w,
        delta: U
      };
      z ? (k.current = U, Y1(cdc, u, W, {
        discrete: !1
      })) : PU(U, g.swipeDirection, L) ? (k.current = U, Y1(sdc, d, W, {
        discrete: !1
      }), w.target.setPointerCapture(w.pointerId)) : (Math.abs(E) > L || Math.abs(T) > L) && ($.current = null);
    }),
    onPointerUp: Bt(e.onPointerUp, (w) => {
      const E = k.current, T = w.target;
      if (T.hasPointerCapture(w.pointerId) && T.releasePointerCapture(w.pointerId), k.current = null, $.current = null, E) {
        const z = w.currentTarget, j = {
          originalEvent: w,
          delta: E
        };
        PU(E, g.swipeDirection, g.swipeThreshold) ? Y1(ddc, p, j, {
          discrete: !0
        }) : Y1(ldc, _, j, {
          discrete: !0
        }), z.addEventListener(
          "click",
          (q) => q.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), g.viewport))) : null;
});
gse.propTypes = {
  type(e) {
    if (e.type && ![
      "foreground",
      "background"
    ].includes(e.type)) {
      const t = `Invalid prop \`type\` supplied to \`${HT}\`. Expected \`foreground | background\`.`;
      return new Error(t);
    }
    return null;
  }
};
const mdc = (e) => {
  const { __scopeToast: t, children: n, ...o } = e, r = GT(HT, t), [i, a] = ze(!1), [s, c] = ze(!1);
  return bdc(
    () => a(!0)
  ), Le(() => {
    const l = window.setTimeout(
      () => c(!0),
      1e3
    );
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ Pe(Jlc, {
    asChild: !0
  }, /* @__PURE__ */ Pe(qq, o, i && /* @__PURE__ */ Pe(Oi, null, r.label, " ", n)));
}, fdc = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, ...o } = e;
  return /* @__PURE__ */ Pe(io.div, We({}, o, {
    ref: t
  }));
}), gdc = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, ...o } = e;
  return /* @__PURE__ */ Pe(io.div, We({}, o, {
    ref: t
  }));
}), hdc = "ToastAction", hse = /* @__PURE__ */ it((e, t) => {
  const { altText: n, ...o } = e;
  return n ? /* @__PURE__ */ Pe(bse, {
    altText: n,
    asChild: !0
  }, /* @__PURE__ */ Pe(vse, We({}, o, {
    ref: t
  }))) : null;
});
hse.propTypes = {
  altText(e) {
    return e.altText ? null : new Error(`Missing prop \`altText\` expected on \`${hdc}\``);
  }
};
const vdc = "ToastClose", vse = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, ...o } = e, r = pdc(vdc, n);
  return /* @__PURE__ */ Pe(bse, {
    asChild: !0
  }, /* @__PURE__ */ Pe(io.button, We({
    type: "button"
  }, o, {
    ref: t,
    onClick: Bt(e.onClick, r.onClose)
  })));
}), bse = /* @__PURE__ */ it((e, t) => {
  const { __scopeToast: n, altText: o, ...r } = e;
  return /* @__PURE__ */ Pe(io.div, We({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": o || void 0
  }, r, {
    ref: t
  }));
});
function yse(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), ydc(o)) {
      const r = o.ariaHidden || o.hidden || o.style.display === "none", i = o.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (i) {
          const a = o.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...yse(o));
    }
  }), t;
}
function Y1(e, t, n, { discrete: o }) {
  const r = n.originalEvent.currentTarget, i = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? L0(r, i) : r.dispatchEvent(i);
}
const PU = (e, t, n = 0) => {
  const o = Math.abs(e.x), r = Math.abs(e.y), i = o > r;
  return t === "left" || t === "right" ? i && o > n : !i && r > n;
};
function bdc(e = () => {
}) {
  const t = Ui(e);
  Xlc(() => {
    let n = 0, o = 0;
    return n = window.requestAnimationFrame(
      () => o = window.requestAnimationFrame(t)
    ), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(o);
    };
  }, [
    t
  ]);
}
function ydc(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function $dc(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function VO(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
const wdc = fse, $se = idc, wse = udc, kse = fdc, Sse = gdc, xse = hse, Ese = vse, IU = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, RU = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.flat(1 / 0).filter(Boolean).join(" ");
}, kdc = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return RU(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const d = n == null ? void 0 : n[l], u = i == null ? void 0 : i[l];
    if (d === null)
      return null;
    const _ = IU(d) || IU(u);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, d) => {
    let [u, _] = d;
    return _ === void 0 || (l[u] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, d) => {
    let { class: u, className: _, ...p } = d;
    return Object.entries(p).every((f) => {
      let [g, h] = f;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[g]) : {
        ...i,
        ...s
      }[g] === h;
    }) ? [
      ...l,
      u,
      _
    ] : l;
  }, []);
  return RU(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function Tse(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (t = 0; t < r; t++)
        e[t] && (n = Tse(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function Sdc() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++)
    (e = arguments[n]) && (t = Tse(e)) && (o && (o += " "), o += t);
  return o;
}
function uo(...e) {
  return Kae(Sdc(e));
}
const xdc = wdc, Ase = it(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  $se,
  {
    ref: n,
    className: uo(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
Ase.displayName = $se.displayName;
const Edc = kdc(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Cse = it(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ m(wse, { ref: o, className: uo(Edc({ variant: t }), e), ...n }));
Cse.displayName = wse.displayName;
const Tdc = it(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  xse,
  {
    ref: n,
    className: uo(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
Tdc.displayName = xse.displayName;
const zse = it(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Ese,
  {
    ref: n,
    className: uo(
      "text-foreground/50 hover:text-foreground absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ m(ot, { name: "x", className: "h-4 w-4" })
  }
));
zse.displayName = Ese.displayName;
const Ose = it(({ className: e, ...t }, n) => /* @__PURE__ */ m(kse, { ref: n, className: uo("text-sm font-semibold", e), ...t }));
Ose.displayName = kse.displayName;
const Pse = it(({ className: e, ...t }, n) => /* @__PURE__ */ m(Sse, { ref: n, className: uo("text-sm opacity-90", e), ...t }));
Pse.displayName = Sse.displayName;
const Adc = 1, Cdc = 1e6;
let BO = 0;
function zdc() {
  return BO = (BO + 1) % Number.MAX_SAFE_INTEGER, BO.toString();
}
const UO = /* @__PURE__ */ new Map(), NU = (e) => {
  if (UO.has(e))
    return;
  const t = setTimeout(() => {
    UO.delete(e), A$({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Cdc);
  UO.set(e, t);
}, Odc = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Adc)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? NU(n) : e.toasts.forEach((o) => {
        NU(o.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (o) => o.id === n || n === void 0 ? {
            ...o,
            open: !1
          } : o
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, kS = [];
let SS = { toasts: [] };
function A$(e) {
  SS = Odc(SS, e), kS.forEach((t) => {
    t(SS);
  });
}
function Pdc({ ...e }) {
  const t = zdc(), n = (r) => A$({
    type: "UPDATE_TOAST",
    toast: { ...r, id: t }
  }), o = () => A$({ type: "DISMISS_TOAST", toastId: t });
  return A$({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (r) => {
        r || o();
      }
    }
  }), {
    id: t,
    dismiss: o,
    update: n
  };
}
function C_() {
  const [e, t] = $e.useState(SS);
  return $e.useEffect(() => (kS.push(t), () => {
    const n = kS.indexOf(t);
    n > -1 && kS.splice(n, 1);
  }), [e]), {
    ...e,
    toast: Pdc,
    dismiss: (n) => A$({ type: "DISMISS_TOAST", toastId: n })
  };
}
function DU() {
  const { toasts: e } = C_();
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(xdc, { children: [
    e.map(function({ id: t, title: n, description: o, action: r, ...i }) {
      return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(Cse, { ...i, children: [
        /* @__PURE__ */ Y("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ m(Ose, { children: n }),
          o && /* @__PURE__ */ m(Pse, { children: o })
        ] }),
        r,
        /* @__PURE__ */ m(zse, {})
      ] }) }, t);
    }),
    /* @__PURE__ */ m(Ase, {})
  ] }) });
}
const Idc = "en";
function Rdc({
  clientId: e,
  accessToken: t,
  options: n,
  children: o,
  labels: r,
  autoUpdateTimezone: i,
  language: a = Idc,
  organizationId: s,
  onTimezoneChange: c,
  isEmbed: l
}) {
  const [d, u] = ze(""), [_, p] = ze(0), { data: f } = sg(l), { mutateAsync: g } = Vlc(), h = at(
    async (I) => {
      await g({ timeZone: I });
    },
    [g]
  ), b = at(() => {
    if (c)
      return c;
    if (!c && i)
      return h;
  }, [c, i, h]);
  Flc(b());
  const { isInit: v } = plc({
    isEmbed: l,
    clientId: e,
    apiUrl: n.apiUrl,
    refreshUrl: n.refreshUrl,
    onError: u,
    onSuccess: (I) => {
      u(""), p(I.organizationId);
    }
  }), { isRefreshing: $, currentAccessToken: k } = vlc({
    accessToken: t,
    refreshUrl: n.refreshUrl,
    onError: u,
    onSuccess: () => {
      u("");
    },
    clientId: e
  }), S = at(
    (I, D) => {
      if ((D == null ? void 0 : D.count) === void 0 || (D == null ? void 0 : D.count) === null)
        return I;
      const { count: M } = D;
      if (((r == null ? void 0 : r[I]) ?? String(MU(I, a) ?? "")).includes("{{count}}"))
        return I;
      const P = Number(M) === 1 ? "one" : "other";
      return `${I}_${P}`;
    },
    []
  ), O = {
    t: (I, D) => {
      const M = S(I, D);
      let N = (r == null ? void 0 : r[M]) ?? String(MU(M, a) ?? "");
      if (!N)
        return I;
      if (D) {
        const C = Object.keys(D);
        C.length && C.forEach((P) => {
          var x;
          N && (N = N.replace(
            `{{${String(P)}}}`,
            ((x = D[P]) == null ? void 0 : x.toString()) ?? `{{${String(P)}}}`
          ));
        });
      }
      return Ndc(N, Tx) ?? "";
    },
    i18n: {
      language: a,
      defaultLocale: a,
      locales: [a],
      exists: (I) => !!Tx[I]
    }
  };
  return v ? /* @__PURE__ */ Y(
    JN.Provider,
    {
      value: {
        clientId: e,
        accessToken: k,
        options: n,
        error: d,
        getClient: () => He,
        isRefreshing: $,
        isInit: v,
        isValidClient: !!(!d && e && v),
        isAuth: !!(v && !d && e && k && He.getAuthorizationHeader()),
        organizationId: s || _ || (f == null ? void 0 : f.data.organizationId) || 0,
        userId: f == null ? void 0 : f.data.id,
        isEmbed: l,
        ...O
      },
      children: [
        /* @__PURE__ */ m(vU, { children: o }),
        /* @__PURE__ */ m(DU, {}),
        /* @__PURE__ */ m(TU, {})
      ]
    }
  ) : /* @__PURE__ */ m(
    JN.Provider,
    {
      value: {
        clientId: e,
        options: n,
        error: d,
        getClient: () => He,
        isAuth: !1,
        isValidClient: !!(!d && e),
        isInit: !1,
        isRefreshing: !1,
        ...O,
        organizationId: 0,
        isEmbed: !1
      },
      children: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(vU, { children: o }),
        /* @__PURE__ */ m(DU, {}),
        /* @__PURE__ */ m(TU, {})
      ] })
    }
  );
}
function Ndc(e, t) {
  const n = /\$t\((.*?)\)/g;
  return e.replace(n, (o, r) => r in t ? t[r] : o);
}
function MU(e, t) {
  switch (t) {
    case "en":
      return Tx[e];
    case "fr":
      return aKr[e];
    case "pt-BR":
      return llc[e];
    case "de":
      return kIt[e];
    case "es":
      return oBo[e];
    case "it":
      return sXi[e];
    case "nl":
      return crs[e];
    default:
      return Tx[e];
  }
}
const LU = new Mie();
function qU({
  clientId: e,
  accessToken: t,
  options: n,
  children: o,
  autoUpdateTimezone: r = !0,
  labels: i,
  language: a = "en",
  onTimezoneChange: s,
  version: c = xq,
  organizationId: l,
  isEmbed: d = !1
}) {
  return Le(() => {
    He.setVersionHeader(c);
  }, [c]), Le(() => {
    t && LU.resetQueries();
  }, [t]), Le(() => {
    He.setPlatformEmbedHeader(d);
  }, [d]), /* @__PURE__ */ m(Fie, { client: LU, children: /* @__PURE__ */ m(
    Rdc,
    {
      isEmbed: d,
      autoUpdateTimezone: r,
      onTimezoneChange: s,
      clientId: e,
      accessToken: t,
      options: n,
      version: c,
      labels: i,
      language: a,
      organizationId: l,
      children: o
    }
  ) });
}
function S_(e) {
  "@babel/helpers - typeof";
  return S_ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, S_(e);
}
const Ddc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S_
}, Symbol.toStringTag, { value: "Module" }));
function Mdc(e, t) {
  if (S_(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (S_(o) !== "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ise(e) {
  var t = Mdc(e, "string");
  return S_(t) === "symbol" ? t : String(t);
}
function af(e, t, n) {
  return t = Ise(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
const Ldc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: af
}, Symbol.toStringTag, { value: "Module" }));
function uw(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
function cg(e, t) {
  if (e == null)
    return {};
  var n = uw(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      o = i[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
const qdc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cg
}, Symbol.toStringTag, { value: "Module" }));
function jdc() {
  if (console && console.warn) {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
  }
}
var jU = {};
function nD() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && jU[t[0]] || (typeof t[0] == "string" && (jU[t[0]] = /* @__PURE__ */ new Date()), jdc.apply(void 0, t));
}
var Rse = function(t, n) {
  return function() {
    if (t.isInitialized)
      n();
    else {
      var o = function r() {
        setTimeout(function() {
          t.off("initialized", r);
        }, 0), n();
      };
      t.on("initialized", o);
    }
  };
};
function FU(e, t, n) {
  e.loadNamespaces(t, Rse(e, n));
}
function VU(e, t, n, o) {
  typeof n == "string" && (n = [n]), n.forEach(function(r) {
    e.options.ns.indexOf(r) < 0 && e.options.ns.push(r);
  }), e.loadLanguages(t, Rse(e, o));
}
function Fdc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = t.languages[0], r = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (o.toLowerCase() === "cimode")
    return !0;
  var a = function(c, l) {
    var d = t.services.backendConnector.state["".concat(c, "|").concat(l)];
    return d === -1 || d === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(o, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(o, e) && (!r || a(i, e)));
}
function Vdc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return nD("i18n.languages were undefined or empty", t.languages), !0;
  var o = t.options.ignoreJSONStructure !== void 0;
  return o ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: function(i, a) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !a(i.isLanguageChangingTo, e))
        return !1;
    }
  }) : Fdc(e, t, n);
}
var Bdc = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Udc = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Wdc = function(t) {
  return Udc[t];
}, Gdc = function(t) {
  return t.replace(Bdc, Wdc);
}, Hdc = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Gdc
};
function Kdc() {
  return Hdc;
}
var Ydc;
function Zdc() {
  return Ydc;
}
function Gq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
const Qdc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gq
}, Symbol.toStringTag, { value: "Module" }));
function BU(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Ise(o.key), o);
  }
}
function Hq(e, t, n) {
  return t && BU(e.prototype, t), n && BU(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
const Jdc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hq
}, Symbol.toStringTag, { value: "Module" }));
var Xdc = No(), euc = function() {
  function e() {
    Gq(this, e), this.usedNamespaces = {};
  }
  return Hq(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var o = this;
      n.forEach(function(r) {
        o.usedNamespaces[r] || (o.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}();
function tuc(e) {
  if (Array.isArray(e))
    return e;
}
function nuc(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, i, a, s = [], c = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (o = i.call(n)).done) && (s.push(o.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      l = !0, r = d;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw r;
      }
    }
    return s;
  }
}
function oD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Nse(e, t) {
  if (e) {
    if (typeof e == "string")
      return oD(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return oD(e, t);
  }
}
function ouc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function od(e, t) {
  return tuc(e) || nuc(e, t) || Nse(e, t) || ouc();
}
const ruc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: od
}, Symbol.toStringTag, { value: "Module" }));
function UU(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function WO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UU(Object(n), !0).forEach(function(o) {
      af(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : UU(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
var iuc = function(t, n) {
  var o = Ue();
  return Le(function() {
    o.current = n ? o.current : t;
  }, [t, n]), o.current;
};
function auc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.i18n, o = Pn(Xdc) || {}, r = o.i18n, i = o.defaultNS, a = n || r || Zdc();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new euc()), !a) {
    nD("You will need to pass in an i18next instance by using initReactI18next");
    var s = function(M, N) {
      return typeof N == "string" ? N : N && S_(N) === "object" && typeof N.defaultValue == "string" ? N.defaultValue : Array.isArray(M) ? M[M.length - 1] : M;
    }, c = [s, {}, !1];
    return c.t = s, c.i18n = {}, c.ready = !1, c;
  }
  a.options.react && a.options.react.wait !== void 0 && nD("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var l = WO(WO(WO({}, Kdc()), a.options.react), t), d = l.useSuspense, u = l.keyPrefix, _ = e || i || a.options && a.options.defaultNS;
  _ = typeof _ == "string" ? [_] : _ || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(_);
  var p = (a.isInitialized || a.initializedStoreOnce) && _.every(function(D) {
    return Vdc(D, a, l);
  });
  function f() {
    return a.getFixedT(t.lng || null, l.nsMode === "fallback" ? _ : _[0], u);
  }
  var g = ze(f), h = od(g, 2), b = h[0], v = h[1], $ = _.join();
  t.lng && ($ = "".concat(t.lng).concat($));
  var k = iuc($), S = Ue(!0);
  Le(function() {
    var D = l.bindI18n, M = l.bindI18nStore;
    S.current = !0, !p && !d && (t.lng ? VU(a, t.lng, _, function() {
      S.current && v(f);
    }) : FU(a, _, function() {
      S.current && v(f);
    })), p && k && k !== $ && S.current && v(f);
    function N() {
      S.current && v(f);
    }
    return D && a && a.on(D, N), M && a && a.store.on(M, N), function() {
      S.current = !1, D && a && D.split(" ").forEach(function(C) {
        return a.off(C, N);
      }), M && a && M.split(" ").forEach(function(C) {
        return a.store.off(C, N);
      });
    };
  }, [a, $]);
  var O = Ue(!0);
  Le(function() {
    S.current && !O.current && v(f), O.current = !1;
  }, [a, u]);
  var I = [b, a, p];
  if (I.t = b, I.i18n = a, I.ready = p, p || !p && !d)
    return I;
  throw new Promise(function(D) {
    t.lng ? VU(a, t.lng, _, function() {
      return D();
    }) : FU(a, _, function() {
      return D();
    });
  });
}
const Fe = (e = "common") => {
  const t = po(), { i18n: n, t: o } = auc(e), r = Object.keys(n).length > 0;
  return t != null && t.clientId ? { i18n: t.i18n, t: t.t, isLocaleReady: !0 } : {
    i18n: n,
    t: o,
    isLocaleReady: r
  };
}, WU = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, GU = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.flat(1 / 0).filter(Boolean).join(" ");
}, Yv = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return GU(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const d = n == null ? void 0 : n[l], u = i == null ? void 0 : i[l];
    if (d === null)
      return null;
    const _ = WU(d) || WU(u);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, d) => {
    let [u, _] = d;
    return _ === void 0 || (l[u] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, d) => {
    let { class: u, className: _, ...p } = d;
    return Object.entries(p).every((f) => {
      let [g, h] = f;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[g]) : {
        ...i,
        ...s
      }[g] === h;
    }) ? [
      ...l,
      u,
      _
    ] : l;
  }, []);
  return GU(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var rD = { exports: {} }, q0 = {};
function Dse(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Dse = function(o) {
    return o ? n : t;
  })(e);
}
function suc(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Dse(t);
  if (n && n.has(e))
    return n.get(e);
  var o = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var a = r ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(o, i, a) : o[i] = e[i];
    }
  return o.default = e, n && n.set(e, o), o;
}
q0._ = suc;
var Z1 = { exports: {} }, GO = {}, HU;
function Mse() {
  return HU || (HU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      assign: function() {
        return i;
      },
      searchParamsToUrlQuery: function() {
        return n;
      },
      urlQueryToSearchParams: function() {
        return r;
      }
    });
    function n(a) {
      const s = {};
      for (const [c, l] of a.entries()) {
        const d = s[c];
        typeof d > "u" ? s[c] = l : Array.isArray(d) ? d.push(l) : s[c] = [
          d,
          l
        ];
      }
      return s;
    }
    function o(a) {
      return typeof a == "string" ? a : typeof a == "number" && !isNaN(a) || typeof a == "boolean" ? String(a) : "";
    }
    function r(a) {
      const s = new URLSearchParams();
      for (const [c, l] of Object.entries(a))
        if (Array.isArray(l))
          for (const d of l)
            s.append(c, o(d));
        else
          s.set(c, o(l));
      return s;
    }
    function i(a) {
      for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
        c[l - 1] = arguments[l];
      for (const d of c) {
        for (const u of d.keys())
          a.delete(u);
        for (const [u, _] of d.entries())
          a.append(u, _);
      }
      return a;
    }
  }(GO)), GO;
}
var HO = {}, KU;
function Lse() {
  return KU || (KU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var d in l)
        Object.defineProperty(c, d, {
          enumerable: !0,
          get: l[d]
        });
    }
    t(e, {
      formatUrl: function() {
        return i;
      },
      formatWithValidation: function() {
        return s;
      },
      urlObjectKeys: function() {
        return a;
      }
    });
    const o = /* @__PURE__ */ q0._(Mse()), r = /https?|ftp|gopher|file/;
    function i(c) {
      let { auth: l, hostname: d } = c, u = c.protocol || "", _ = c.pathname || "", p = c.hash || "", f = c.query || "", g = !1;
      l = l ? encodeURIComponent(l).replace(/%3A/i, ":") + "@" : "", c.host ? g = l + c.host : d && (g = l + (~d.indexOf(":") ? "[" + d + "]" : d), c.port && (g += ":" + c.port)), f && typeof f == "object" && (f = String(o.urlQueryToSearchParams(f)));
      let h = c.search || f && "?" + f || "";
      return u && !u.endsWith(":") && (u += ":"), c.slashes || (!u || r.test(u)) && g !== !1 ? (g = "//" + (g || ""), _ && _[0] !== "/" && (_ = "/" + _)) : g || (g = ""), p && p[0] !== "#" && (p = "#" + p), h && h[0] !== "?" && (h = "?" + h), _ = _.replace(/[?#]/g, encodeURIComponent), h = h.replace("#", "%23"), "" + u + g + _ + h + p;
    }
    const a = [
      "auth",
      "hash",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "slashes"
    ];
    function s(c) {
      return i(c);
    }
  }(HO)), HO;
}
var KO = {}, YU;
function cuc() {
  return YU || (YU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "omit", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n, o) {
      const r = {};
      return Object.keys(n).forEach((i) => {
        o.includes(i) || (r[i] = n[i]);
      }), r;
    }
  }(KO)), KO;
}
var YO = {}, ZU;
function KT() {
  return ZU || (ZU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(k, S) {
      for (var O in S)
        Object.defineProperty(k, O, {
          enumerable: !0,
          get: S[O]
        });
    }
    t(e, {
      DecodeError: function() {
        return f;
      },
      MiddlewareNotFoundError: function() {
        return v;
      },
      MissingStaticPage: function() {
        return b;
      },
      NormalizeError: function() {
        return g;
      },
      PageNotFoundError: function() {
        return h;
      },
      SP: function() {
        return _;
      },
      ST: function() {
        return p;
      },
      WEB_VITALS: function() {
        return n;
      },
      execOnce: function() {
        return o;
      },
      getDisplayName: function() {
        return c;
      },
      getLocationOrigin: function() {
        return a;
      },
      getURL: function() {
        return s;
      },
      isAbsoluteUrl: function() {
        return i;
      },
      isResSent: function() {
        return l;
      },
      loadGetInitialProps: function() {
        return u;
      },
      normalizeRepeatedSlashes: function() {
        return d;
      },
      stringifyError: function() {
        return $;
      }
    });
    const n = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function o(k) {
      let S = !1, O;
      return function() {
        for (var I = arguments.length, D = new Array(I), M = 0; M < I; M++)
          D[M] = arguments[M];
        return S || (S = !0, O = k(...D)), O;
      };
    }
    const r = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, i = (k) => r.test(k);
    function a() {
      const { protocol: k, hostname: S, port: O } = window.location;
      return k + "//" + S + (O ? ":" + O : "");
    }
    function s() {
      const { href: k } = window.location, S = a();
      return k.substring(S.length);
    }
    function c(k) {
      return typeof k == "string" ? k : k.displayName || k.name || "Unknown";
    }
    function l(k) {
      return k.finished || k.headersSent;
    }
    function d(k) {
      const S = k.split("?");
      return S[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (S[1] ? "?" + S.slice(1).join("?") : "");
    }
    async function u(k, S) {
      const O = S.res || S.ctx && S.ctx.res;
      if (!k.getInitialProps)
        return S.ctx && S.Component ? {
          pageProps: await u(S.Component, S.ctx)
        } : {};
      const I = await k.getInitialProps(S);
      if (O && l(O))
        return I;
      if (!I) {
        const D = '"' + c(k) + '.getInitialProps()" should resolve to an object. But found "' + I + '" instead.';
        throw Object.defineProperty(new Error(D), "__NEXT_ERROR_CODE", {
          value: "E394",
          enumerable: !1,
          configurable: !0
        });
      }
      return I;
    }
    const _ = typeof performance < "u", p = _ && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((k) => typeof performance[k] == "function");
    class f extends Error {
    }
    class g extends Error {
    }
    class h extends Error {
      constructor(S) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = "Cannot find module for page: " + S;
      }
    }
    class b extends Error {
      constructor(S, O) {
        super(), this.message = "Failed to load static file for page: " + S + " " + O;
      }
    }
    class v extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function $(k) {
      return JSON.stringify({
        message: k.message,
        stack: k.stack
      });
    }
  }(YO)), YO;
}
var Q1 = { exports: {} }, ZO = {}, QU;
function qse() {
  return QU || (QU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "removeTrailingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.replace(/\/$/, "") || "/";
    }
  }(ZO)), ZO;
}
var QO = {}, JU;
function Kq() {
  return JU || (JU = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "parsePath", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      const o = n.indexOf("#"), r = n.indexOf("?"), i = r > -1 && (o < 0 || r < o);
      return i || o > -1 ? {
        pathname: n.substring(0, i ? r : o),
        query: i ? n.substring(r, o > -1 ? o : void 0) : "",
        hash: o > -1 ? n.slice(o) : ""
      } : {
        pathname: n,
        query: "",
        hash: ""
      };
    }
  }(QO)), QO;
}
var XU;
function YT() {
  return XU || (XU = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = qse(), o = Kq(), r = (i) => {
      if (!i.startsWith("/"))
        return i;
      const { pathname: a, query: s, hash: c } = (0, o.parsePath)(i);
      return "" + (0, n.removeTrailingSlash)(a) + s + c;
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(Q1, Q1.exports)), Q1.exports;
}
var JO = {}, J1 = { exports: {} }, XO = {}, eW;
function luc() {
  return eW || (eW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "pathHasPrefix", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = Kq();
    function n(o, r) {
      if (typeof o != "string")
        return !1;
      const { pathname: i } = (0, t.parsePath)(o);
      return i === r || i.startsWith(r + "/");
    }
  }(XO)), XO;
}
var tW;
function duc() {
  return tW || (tW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "hasBasePath", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = luc(), o = "";
    function r(i) {
      return (0, n.pathHasPrefix)(i, o);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(J1, J1.exports)), J1.exports;
}
var nW;
function jse() {
  return nW || (nW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isLocalURL", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = KT(), n = duc();
    function o(r) {
      if (!(0, t.isAbsoluteUrl)(r))
        return !0;
      try {
        const i = (0, t.getLocationOrigin)(), a = new URL(r, i);
        return a.origin === i && (0, n.hasBasePath)(a.pathname);
      } catch {
        return !1;
      }
    }
  }(JO)), JO;
}
var e4 = {}, t4 = {}, oW;
function uuc() {
  return oW || (oW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    t(e, {
      getSortedRouteObjects: function() {
        return r;
      },
      getSortedRoutes: function() {
        return o;
      }
    });
    class n {
      insert(a) {
        this._insert(a.split("/").filter(Boolean), [], !1);
      }
      smoosh() {
        return this._smoosh();
      }
      _smoosh(a) {
        a === void 0 && (a = "/");
        const s = [
          ...this.children.keys()
        ].sort();
        this.slugName !== null && s.splice(s.indexOf("[]"), 1), this.restSlugName !== null && s.splice(s.indexOf("[...]"), 1), this.optionalRestSlugName !== null && s.splice(s.indexOf("[[...]]"), 1);
        const c = s.map((l) => this.children.get(l)._smoosh("" + a + l + "/")).reduce((l, d) => [
          ...l,
          ...d
        ], []);
        if (this.slugName !== null && c.push(...this.children.get("[]")._smoosh(a + "[" + this.slugName + "]/")), !this.placeholder) {
          const l = a === "/" ? "/" : a.slice(0, -1);
          if (this.optionalRestSlugName != null)
            throw Object.defineProperty(new Error('You cannot define a route with the same specificity as a optional catch-all route ("' + l + '" and "' + l + "[[..." + this.optionalRestSlugName + ']]").'), "__NEXT_ERROR_CODE", {
              value: "E458",
              enumerable: !1,
              configurable: !0
            });
          c.unshift(l);
        }
        return this.restSlugName !== null && c.push(...this.children.get("[...]")._smoosh(a + "[..." + this.restSlugName + "]/")), this.optionalRestSlugName !== null && c.push(...this.children.get("[[...]]")._smoosh(a + "[[..." + this.optionalRestSlugName + "]]/")), c;
      }
      _insert(a, s, c) {
        if (a.length === 0) {
          this.placeholder = !1;
          return;
        }
        if (c)
          throw Object.defineProperty(new Error("Catch-all must be the last part of the URL."), "__NEXT_ERROR_CODE", {
            value: "E392",
            enumerable: !1,
            configurable: !0
          });
        let l = a[0];
        if (l.startsWith("[") && l.endsWith("]")) {
          let _ = function(p, f) {
            if (p !== null && p !== f)
              throw Object.defineProperty(new Error("You cannot use different slug names for the same dynamic path ('" + p + "' !== '" + f + "')."), "__NEXT_ERROR_CODE", {
                value: "E337",
                enumerable: !1,
                configurable: !0
              });
            s.forEach((g) => {
              if (g === f)
                throw Object.defineProperty(new Error('You cannot have the same slug name "' + f + '" repeat within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E247",
                  enumerable: !1,
                  configurable: !0
                });
              if (g.replace(/\W/g, "") === l.replace(/\W/g, ""))
                throw Object.defineProperty(new Error('You cannot have the slug names "' + g + '" and "' + f + '" differ only by non-word symbols within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E499",
                  enumerable: !1,
                  configurable: !0
                });
            }), s.push(f);
          }, d = l.slice(1, -1), u = !1;
          if (d.startsWith("[") && d.endsWith("]") && (d = d.slice(1, -1), u = !0), d.startsWith("…"))
            throw Object.defineProperty(new Error("Detected a three-dot character ('…') at ('" + d + "'). Did you mean ('...')?"), "__NEXT_ERROR_CODE", {
              value: "E147",
              enumerable: !1,
              configurable: !0
            });
          if (d.startsWith("...") && (d = d.substring(3), c = !0), d.startsWith("[") || d.endsWith("]"))
            throw Object.defineProperty(new Error("Segment names may not start or end with extra brackets ('" + d + "')."), "__NEXT_ERROR_CODE", {
              value: "E421",
              enumerable: !1,
              configurable: !0
            });
          if (d.startsWith("."))
            throw Object.defineProperty(new Error("Segment names may not start with erroneous periods ('" + d + "')."), "__NEXT_ERROR_CODE", {
              value: "E288",
              enumerable: !1,
              configurable: !0
            });
          if (c)
            if (u) {
              if (this.restSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an required and optional catch-all route at the same level ("[...' + this.restSlugName + ']" and "' + a[0] + '" ).'), "__NEXT_ERROR_CODE", {
                  value: "E299",
                  enumerable: !1,
                  configurable: !0
                });
              _(this.optionalRestSlugName, d), this.optionalRestSlugName = d, l = "[[...]]";
            } else {
              if (this.optionalRestSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an optional and required catch-all route at the same level ("[[...' + this.optionalRestSlugName + ']]" and "' + a[0] + '").'), "__NEXT_ERROR_CODE", {
                  value: "E300",
                  enumerable: !1,
                  configurable: !0
                });
              _(this.restSlugName, d), this.restSlugName = d, l = "[...]";
            }
          else {
            if (u)
              throw Object.defineProperty(new Error('Optional route parameters are not yet supported ("' + a[0] + '").'), "__NEXT_ERROR_CODE", {
                value: "E435",
                enumerable: !1,
                configurable: !0
              });
            _(this.slugName, d), this.slugName = d, l = "[]";
          }
        }
        this.children.has(l) || this.children.set(l, new n()), this.children.get(l)._insert(a.slice(1), s, c);
      }
      constructor() {
        this.placeholder = !0, this.children = /* @__PURE__ */ new Map(), this.slugName = null, this.restSlugName = null, this.optionalRestSlugName = null;
      }
    }
    function o(i) {
      const a = new n();
      return i.forEach((s) => a.insert(s)), a.smoosh();
    }
    function r(i, a) {
      const s = {}, c = [];
      for (let d = 0; d < i.length; d++) {
        const u = a(i[d]);
        s[u] = d, c[d] = u;
      }
      return o(c).map((d) => i[s[d]]);
    }
  }(t4)), t4;
}
var n4 = {}, o4 = {}, r4 = {}, i4 = {}, rW;
function _uc() {
  return rW || (rW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.startsWith("/") ? n : "/" + n;
    }
  }(i4)), i4;
}
var Yq = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(s, c) {
    for (var l in c)
      Object.defineProperty(s, l, {
        enumerable: !0,
        get: c[l]
      });
  }
  t(e, {
    DEFAULT_SEGMENT_KEY: function() {
      return a;
    },
    PAGE_SEGMENT_KEY: function() {
      return i;
    },
    addSearchParamsIfPageSegment: function() {
      return r;
    },
    isGroupSegment: function() {
      return n;
    },
    isParallelRouteSegment: function() {
      return o;
    }
  });
  function n(s) {
    return s[0] === "(" && s.endsWith(")");
  }
  function o(s) {
    return s.startsWith("@") && s !== "@children";
  }
  function r(s, c) {
    if (s.includes(i)) {
      const d = JSON.stringify(c);
      return d !== "{}" ? i + "?" + d : i;
    }
    return s;
  }
  const i = "__PAGE__", a = "__DEFAULT__";
})(Yq);
var iW;
function puc() {
  return iW || (iW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      normalizeAppPath: function() {
        return r;
      },
      normalizeRscURL: function() {
        return i;
      }
    });
    const n = _uc(), o = Yq;
    function r(a) {
      return (0, n.ensureLeadingSlash)(a.split("/").reduce((s, c, l, d) => !c || (0, o.isGroupSegment)(c) || c[0] === "@" || (c === "page" || c === "route") && l === d.length - 1 ? s : s + "/" + c, ""));
    }
    function i(a) {
      return a.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  }(r4)), r4;
}
var aW;
function Fse() {
  return aW || (aW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return o;
      },
      extractInterceptionRouteInformation: function() {
        return i;
      },
      isInterceptionRouteAppPath: function() {
        return r;
      }
    });
    const n = puc(), o = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function r(a) {
      return a.split("/").find((s) => o.find((c) => s.startsWith(c))) !== void 0;
    }
    function i(a) {
      let s, c, l;
      for (const d of a.split("/"))
        if (c = o.find((u) => d.startsWith(u)), c) {
          [s, l] = a.split(c, 2);
          break;
        }
      if (!s || !c || !l)
        throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>"), "__NEXT_ERROR_CODE", {
          value: "E269",
          enumerable: !1,
          configurable: !0
        });
      switch (s = (0, n.normalizeAppPath)(s), c) {
        case "(.)":
          s === "/" ? l = "/" + l : l = s + "/" + l;
          break;
        case "(..)":
          if (s === "/")
            throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Cannot use (..) marker at the root level, use (.) instead."), "__NEXT_ERROR_CODE", {
              value: "E207",
              enumerable: !1,
              configurable: !0
            });
          l = s.split("/").slice(0, -1).concat(l).join("/");
          break;
        case "(...)":
          l = "/" + l;
          break;
        case "(..)(..)":
          const d = s.split("/");
          if (d.length <= 2)
            throw Object.defineProperty(new Error("Invalid interception route: " + a + ". Cannot use (..)(..) marker at the root level or one level up."), "__NEXT_ERROR_CODE", {
              value: "E486",
              enumerable: !1,
              configurable: !0
            });
          l = d.slice(0, -2).concat(l).join("/");
          break;
        default:
          throw Object.defineProperty(new Error("Invariant: unexpected marker"), "__NEXT_ERROR_CODE", {
            value: "E112",
            enumerable: !1,
            configurable: !0
          });
      }
      return {
        interceptingRoute: s,
        interceptedRoute: l
      };
    }
  }(o4)), o4;
}
var sW;
function muc() {
  return sW || (sW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isDynamicRoute", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const t = Fse(), n = /\/[^/]*\[[^/]+\][^/]*(?=\/|$)/, o = /\/\[[^/]+\](?=\/|$)/;
    function r(i, a) {
      return a === void 0 && (a = !0), (0, t.isInterceptionRouteAppPath)(i) && (i = (0, t.extractInterceptionRouteInformation)(i).interceptedRoute), a ? o.test(i) : n.test(i);
    }
  }(n4)), n4;
}
var cW;
function fuc() {
  return cW || (cW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(r, i) {
      for (var a in i)
        Object.defineProperty(r, a, {
          enumerable: !0,
          get: i[a]
        });
    }
    t(e, {
      getSortedRouteObjects: function() {
        return n.getSortedRouteObjects;
      },
      getSortedRoutes: function() {
        return n.getSortedRoutes;
      },
      isDynamicRoute: function() {
        return o.isDynamicRoute;
      }
    });
    const n = uuc(), o = muc();
  }(e4)), e4;
}
var a4 = {}, s4 = {}, c4 = {}, l4 = { exports: {} }, lW;
function guc() {
  return lW || (lW = 1, (() => {
    typeof __nccwpck_require__ < "u" && (__nccwpck_require__.ab = __dirname + "/");
    var e = {};
    (() => {
      var t = e;
      Object.defineProperty(t, "__esModule", { value: !0 }), t.pathToRegexp = t.tokensToRegexp = t.regexpToFunction = t.match = t.tokensToFunction = t.compile = t.parse = void 0;
      function n(g) {
        for (var h = [], b = 0; b < g.length; ) {
          var v = g[b];
          if (v === "*" || v === "+" || v === "?") {
            h.push({ type: "MODIFIER", index: b, value: g[b++] });
            continue;
          }
          if (v === "\\") {
            h.push({ type: "ESCAPED_CHAR", index: b++, value: g[b++] });
            continue;
          }
          if (v === "{") {
            h.push({ type: "OPEN", index: b, value: g[b++] });
            continue;
          }
          if (v === "}") {
            h.push({ type: "CLOSE", index: b, value: g[b++] });
            continue;
          }
          if (v === ":") {
            for (var $ = "", k = b + 1; k < g.length; ) {
              var S = g.charCodeAt(k);
              if (S >= 48 && S <= 57 || S >= 65 && S <= 90 || S >= 97 && S <= 122 || S === 95) {
                $ += g[k++];
                continue;
              }
              break;
            }
            if (!$)
              throw new TypeError("Missing parameter name at ".concat(b));
            h.push({ type: "NAME", index: b, value: $ }), b = k;
            continue;
          }
          if (v === "(") {
            var O = 1, I = "", k = b + 1;
            if (g[k] === "?")
              throw new TypeError('Pattern cannot start with "?" at '.concat(k));
            for (; k < g.length; ) {
              if (g[k] === "\\") {
                I += g[k++] + g[k++];
                continue;
              }
              if (g[k] === ")") {
                if (O--, O === 0) {
                  k++;
                  break;
                }
              } else if (g[k] === "(" && (O++, g[k + 1] !== "?"))
                throw new TypeError("Capturing groups are not allowed at ".concat(k));
              I += g[k++];
            }
            if (O)
              throw new TypeError("Unbalanced pattern at ".concat(b));
            if (!I)
              throw new TypeError("Missing pattern at ".concat(b));
            h.push({ type: "PATTERN", index: b, value: I }), b = k;
            continue;
          }
          h.push({ type: "CHAR", index: b, value: g[b++] });
        }
        return h.push({ type: "END", index: b, value: "" }), h;
      }
      function o(g, h) {
        h === void 0 && (h = {});
        for (var b = n(g), v = h.prefixes, $ = v === void 0 ? "./" : v, k = h.delimiter, S = k === void 0 ? "/#?" : k, O = [], I = 0, D = 0, M = "", N = function(W) {
          if (D < b.length && b[D].type === W)
            return b[D++].value;
        }, C = function(W) {
          var H = N(W);
          if (H !== void 0)
            return H;
          var Q = b[D], X = Q.type, re = Q.index;
          throw new TypeError("Unexpected ".concat(X, " at ").concat(re, ", expected ").concat(W));
        }, P = function() {
          for (var W = "", H; H = N("CHAR") || N("ESCAPED_CHAR"); )
            W += H;
          return W;
        }, x = function(W) {
          for (var H = 0, Q = S; H < Q.length; H++) {
            var X = Q[H];
            if (W.indexOf(X) > -1)
              return !0;
          }
          return !1;
        }, w = function(W) {
          var H = O[O.length - 1], Q = W || (H && typeof H == "string" ? H : "");
          if (H && !Q)
            throw new TypeError('Must have text between two parameters, missing text after "'.concat(H.name, '"'));
          return !Q || x(Q) ? "[^".concat(c(S), "]+?") : "(?:(?!".concat(c(Q), ")[^").concat(c(S), "])+?");
        }; D < b.length; ) {
          var E = N("CHAR"), T = N("NAME"), z = N("PATTERN");
          if (T || z) {
            var j = E || "";
            $.indexOf(j) === -1 && (M += j, j = ""), M && (O.push(M), M = ""), O.push({ name: T || I++, prefix: j, suffix: "", pattern: z || w(j), modifier: N("MODIFIER") || "" });
            continue;
          }
          var q = E || N("ESCAPED_CHAR");
          if (q) {
            M += q;
            continue;
          }
          M && (O.push(M), M = "");
          var V = N("OPEN");
          if (V) {
            var j = P(), F = N("NAME") || "", L = N("PATTERN") || "", U = P();
            C("CLOSE"), O.push({ name: F || (L ? I++ : ""), pattern: F && !L ? w(j) : L, prefix: j, suffix: U, modifier: N("MODIFIER") || "" });
            continue;
          }
          C("END");
        }
        return O;
      }
      t.parse = o;
      function r(g, h) {
        return i(o(g, h), h);
      }
      t.compile = r;
      function i(g, h) {
        h === void 0 && (h = {});
        var b = l(h), v = h.encode, $ = v === void 0 ? function(I) {
          return I;
        } : v, k = h.validate, S = k === void 0 ? !0 : k, O = g.map(function(I) {
          if (typeof I == "object")
            return new RegExp("^(?:".concat(I.pattern, ")$"), b);
        });
        return function(I) {
          for (var D = "", M = 0; M < g.length; M++) {
            var N = g[M];
            if (typeof N == "string") {
              D += N;
              continue;
            }
            var C = I ? I[N.name] : void 0, P = N.modifier === "?" || N.modifier === "*", x = N.modifier === "*" || N.modifier === "+";
            if (Array.isArray(C)) {
              if (!x)
                throw new TypeError('Expected "'.concat(N.name, '" to not repeat, but got an array'));
              if (C.length === 0) {
                if (P)
                  continue;
                throw new TypeError('Expected "'.concat(N.name, '" to not be empty'));
              }
              for (var w = 0; w < C.length; w++) {
                var E = $(C[w], N);
                if (S && !O[M].test(E))
                  throw new TypeError('Expected all "'.concat(N.name, '" to match "').concat(N.pattern, '", but got "').concat(E, '"'));
                D += N.prefix + E + N.suffix;
              }
              continue;
            }
            if (typeof C == "string" || typeof C == "number") {
              var E = $(String(C), N);
              if (S && !O[M].test(E))
                throw new TypeError('Expected "'.concat(N.name, '" to match "').concat(N.pattern, '", but got "').concat(E, '"'));
              D += N.prefix + E + N.suffix;
              continue;
            }
            if (!P) {
              var T = x ? "an array" : "a string";
              throw new TypeError('Expected "'.concat(N.name, '" to be ').concat(T));
            }
          }
          return D;
        };
      }
      t.tokensToFunction = i;
      function a(g, h) {
        var b = [], v = f(g, b, h);
        return s(v, b, h);
      }
      t.match = a;
      function s(g, h, b) {
        b === void 0 && (b = {});
        var v = b.decode, $ = v === void 0 ? function(k) {
          return k;
        } : v;
        return function(k) {
          var S = g.exec(k);
          if (!S)
            return !1;
          for (var O = S[0], I = S.index, D = /* @__PURE__ */ Object.create(null), M = function(C) {
            if (S[C] === void 0)
              return "continue";
            var P = h[C - 1];
            P.modifier === "*" || P.modifier === "+" ? D[P.name] = S[C].split(P.prefix + P.suffix).map(function(x) {
              return $(x, P);
            }) : D[P.name] = $(S[C], P);
          }, N = 1; N < S.length; N++)
            M(N);
          return { path: O, index: I, params: D };
        };
      }
      t.regexpToFunction = s;
      function c(g) {
        return g.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
      }
      function l(g) {
        return g && g.sensitive ? "" : "i";
      }
      function d(g, h) {
        if (!h)
          return g;
        for (var b = /\((?:\?<(.*?)>)?(?!\?)/g, v = 0, $ = b.exec(g.source); $; )
          h.push({ name: $[1] || v++, prefix: "", suffix: "", modifier: "", pattern: "" }), $ = b.exec(g.source);
        return g;
      }
      function u(g, h, b) {
        var v = g.map(function($) {
          return f($, h, b).source;
        });
        return new RegExp("(?:".concat(v.join("|"), ")"), l(b));
      }
      function _(g, h, b) {
        return p(o(g, b), h, b);
      }
      function p(g, h, b) {
        b === void 0 && (b = {});
        for (var v = b.strict, $ = v === void 0 ? !1 : v, k = b.start, S = k === void 0 ? !0 : k, O = b.end, I = O === void 0 ? !0 : O, D = b.encode, M = D === void 0 ? function(H) {
          return H;
        } : D, N = b.delimiter, C = N === void 0 ? "/#?" : N, P = b.endsWith, x = P === void 0 ? "" : P, w = "[".concat(c(x), "]|$"), E = "[".concat(c(C), "]"), T = S ? "^" : "", z = 0, j = g; z < j.length; z++) {
          var q = j[z];
          if (typeof q == "string")
            T += c(M(q));
          else {
            var V = c(M(q.prefix)), F = c(M(q.suffix));
            if (q.pattern)
              if (h && h.push(q), V || F)
                if (q.modifier === "+" || q.modifier === "*") {
                  var L = q.modifier === "*" ? "?" : "";
                  T += "(?:".concat(V, "((?:").concat(q.pattern, ")(?:").concat(F).concat(V, "(?:").concat(q.pattern, "))*)").concat(F, ")").concat(L);
                } else
                  T += "(?:".concat(V, "(").concat(q.pattern, ")").concat(F, ")").concat(q.modifier);
              else {
                if (q.modifier === "+" || q.modifier === "*")
                  throw new TypeError('Can not repeat "'.concat(q.name, '" without a prefix and suffix'));
                T += "(".concat(q.pattern, ")").concat(q.modifier);
              }
            else
              T += "(?:".concat(V).concat(F, ")").concat(q.modifier);
          }
        }
        if (I)
          $ || (T += "".concat(E, "?")), T += b.endsWith ? "(?=".concat(w, ")") : "$";
        else {
          var U = g[g.length - 1], W = typeof U == "string" ? E.indexOf(U[U.length - 1]) > -1 : U === void 0;
          $ || (T += "(?:".concat(E, "(?=").concat(w, "))?")), W || (T += "(?=".concat(E, "|").concat(w, ")"));
        }
        return new RegExp(T, l(b));
      }
      t.tokensToRegexp = p;
      function f(g, h, b) {
        return g instanceof RegExp ? d(g, h) : Array.isArray(g) ? u(g, h, b) : _(g, h, b);
      }
      t.pathToRegexp = f;
    })(), l4.exports = e;
  })()), l4.exports;
}
var d4 = {}, dW;
function huc() {
  return dW || (dW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, c) {
      for (var l in c)
        Object.defineProperty(s, l, {
          enumerable: !0,
          get: c[l]
        });
    }
    t(e, {
      hasAdjacentParameterIssues: function() {
        return o;
      },
      normalizeAdjacentParameters: function() {
        return r;
      },
      normalizeTokensForRegexp: function() {
        return i;
      },
      stripParameterSeparators: function() {
        return a;
      }
    });
    const n = "_NEXTSEP_";
    function o(s) {
      return typeof s != "string" ? !1 : !!(/\/\(\.{1,3}\):[^/\s]+/.test(s) || /:[a-zA-Z_][a-zA-Z0-9_]*:[a-zA-Z_][a-zA-Z0-9_]*/.test(s));
    }
    function r(s) {
      let c = s;
      return c = c.replace(/(\([^)]*\)):([^/\s]+)/g, `$1${n}:$2`), c = c.replace(/:([^:/\s)]+)(?=:)/g, `:$1${n}`), c;
    }
    function i(s) {
      return s.map((c) => typeof c == "object" && c !== null && // Not all token objects have 'modifier' property (e.g., simple text tokens)
      "modifier" in c && // Only repeating modifiers (* or +) cause the validation error
      // Other modifiers like '?' (optional) are fine
      (c.modifier === "*" || c.modifier === "+") && // Token objects can have different shapes depending on route pattern
      "prefix" in c && "suffix" in c && // Both prefix and suffix must be empty strings
      // This is what causes the validation error in path-to-regexp
      c.prefix === "" && c.suffix === "" ? {
        ...c,
        prefix: "/"
      } : c);
    }
    function a(s) {
      const c = {};
      for (const [l, d] of Object.entries(s))
        typeof d == "string" ? c[l] = d.replace(new RegExp(`^${n}`), "") : Array.isArray(d) ? c[l] = d.map((u) => typeof u == "string" ? u.replace(new RegExp(`^${n}`), "") : u) : c[l] = d;
      return c;
    }
  }(d4)), d4;
}
var uW;
function vuc() {
  return uW || (uW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var d in l)
        Object.defineProperty(c, d, {
          enumerable: !0,
          get: l[d]
        });
    }
    t(e, {
      safeCompile: function() {
        return i;
      },
      safePathToRegexp: function() {
        return r;
      },
      safeRegexpToFunction: function() {
        return a;
      },
      safeRouteMatcher: function() {
        return s;
      }
    });
    const n = guc(), o = huc();
    function r(c, l, d) {
      if (typeof c != "string")
        return (0, n.pathToRegexp)(c, l, d);
      const u = (0, o.hasAdjacentParameterIssues)(c), _ = u ? (0, o.normalizeAdjacentParameters)(c) : c;
      try {
        return (0, n.pathToRegexp)(_, l, d);
      } catch (p) {
        if (!u)
          try {
            const f = (0, o.normalizeAdjacentParameters)(c);
            return (0, n.pathToRegexp)(f, l, d);
          } catch {
            throw p;
          }
        throw p;
      }
    }
    function i(c, l) {
      const d = (0, o.hasAdjacentParameterIssues)(c), u = d ? (0, o.normalizeAdjacentParameters)(c) : c;
      try {
        return (0, n.compile)(u, l);
      } catch (_) {
        if (!d)
          try {
            const p = (0, o.normalizeAdjacentParameters)(c);
            return (0, n.compile)(p, l);
          } catch {
            throw _;
          }
        throw _;
      }
    }
    function a(c, l) {
      const d = (0, n.regexpToFunction)(c, l || []);
      return (u) => {
        const _ = d(u);
        return _ ? {
          ..._,
          params: (0, o.stripParameterSeparators)(_.params)
        } : !1;
      };
    }
    function s(c) {
      return (l) => {
        const d = c(l);
        return d ? (0, o.stripParameterSeparators)(d) : !1;
      };
    }
  }(c4)), c4;
}
var _W;
function Vse() {
  return _W || (_W = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "getRouteMatcher", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = KT(), n = vuc();
    function o(r) {
      let { re: i, groups: a } = r;
      const s = (c) => {
        const l = i.exec(c);
        if (!l)
          return !1;
        const d = (_) => {
          try {
            return decodeURIComponent(_);
          } catch {
            throw Object.defineProperty(new t.DecodeError("failed to decode param"), "__NEXT_ERROR_CODE", {
              value: "E528",
              enumerable: !1,
              configurable: !0
            });
          }
        }, u = {};
        for (const [_, p] of Object.entries(a)) {
          const f = l[p.pos];
          f !== void 0 && (p.repeat ? u[_] = f.split("/").map((g) => d(g)) : u[_] = d(f));
        }
        return u;
      };
      return (0, n.safeRouteMatcher)(s);
    }
  }(s4)), s4;
}
var u4 = {}, _4 = {}, pW;
function buc() {
  return pW || (pW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(Ae, Ze) {
      for (var Ge in Ze)
        Object.defineProperty(Ae, Ge, {
          enumerable: !0,
          get: Ze[Ge]
        });
    }
    t(e, {
      ACTION_SUFFIX: function() {
        return f;
      },
      APP_DIR_ALIAS: function() {
        return j;
      },
      CACHE_ONE_YEAR: function() {
        return N;
      },
      DOT_NEXT_ALIAS: function() {
        return T;
      },
      ESLINT_DEFAULT_DIRS: function() {
        return se;
      },
      GSP_NO_RETURNED_VALUE: function() {
        return oe;
      },
      GSSP_COMPONENT_MEMBER_ERROR: function() {
        return te;
      },
      GSSP_NO_RETURNED_VALUE: function() {
        return ce;
      },
      HTML_CONTENT_TYPE_HEADER: function() {
        return o;
      },
      INFINITE_CACHE: function() {
        return C;
      },
      INSTRUMENTATION_HOOK_FILENAME: function() {
        return w;
      },
      JSON_CONTENT_TYPE_HEADER: function() {
        return r;
      },
      MATCHED_PATH_HEADER: function() {
        return s;
      },
      MIDDLEWARE_FILENAME: function() {
        return P;
      },
      MIDDLEWARE_LOCATION_REGEXP: function() {
        return x;
      },
      NEXT_BODY_SUFFIX: function() {
        return b;
      },
      NEXT_CACHE_IMPLICIT_TAG_ID: function() {
        return M;
      },
      NEXT_CACHE_REVALIDATED_TAGS_HEADER: function() {
        return $;
      },
      NEXT_CACHE_REVALIDATE_TAG_TOKEN_HEADER: function() {
        return k;
      },
      NEXT_CACHE_SOFT_TAG_MAX_LENGTH: function() {
        return D;
      },
      NEXT_CACHE_TAGS_HEADER: function() {
        return v;
      },
      NEXT_CACHE_TAG_MAX_ITEMS: function() {
        return O;
      },
      NEXT_CACHE_TAG_MAX_LENGTH: function() {
        return I;
      },
      NEXT_DATA_SUFFIX: function() {
        return g;
      },
      NEXT_INTERCEPTION_MARKER_PREFIX: function() {
        return a;
      },
      NEXT_META_SUFFIX: function() {
        return h;
      },
      NEXT_QUERY_PARAM_PREFIX: function() {
        return i;
      },
      NEXT_RESUME_HEADER: function() {
        return S;
      },
      NON_STANDARD_NODE_ENV: function() {
        return ue;
      },
      PAGES_DIR_ALIAS: function() {
        return E;
      },
      PRERENDER_REVALIDATE_HEADER: function() {
        return c;
      },
      PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER: function() {
        return l;
      },
      PUBLIC_DIR_MIDDLEWARE_CONFLICT: function() {
        return Q;
      },
      ROOT_DIR_ALIAS: function() {
        return z;
      },
      RSC_ACTION_CLIENT_WRAPPER_ALIAS: function() {
        return H;
      },
      RSC_ACTION_ENCRYPTION_ALIAS: function() {
        return W;
      },
      RSC_ACTION_PROXY_ALIAS: function() {
        return F;
      },
      RSC_ACTION_VALIDATE_ALIAS: function() {
        return V;
      },
      RSC_CACHE_WRAPPER_ALIAS: function() {
        return L;
      },
      RSC_DYNAMIC_IMPORT_WRAPPER_ALIAS: function() {
        return U;
      },
      RSC_MOD_REF_PROXY_ALIAS: function() {
        return q;
      },
      RSC_PREFETCH_SUFFIX: function() {
        return d;
      },
      RSC_SEGMENTS_DIR_SUFFIX: function() {
        return u;
      },
      RSC_SEGMENT_SUFFIX: function() {
        return _;
      },
      RSC_SUFFIX: function() {
        return p;
      },
      SERVER_PROPS_EXPORT_ERROR: function() {
        return J;
      },
      SERVER_PROPS_GET_INIT_PROPS_CONFLICT: function() {
        return re;
      },
      SERVER_PROPS_SSG_CONFLICT: function() {
        return Z;
      },
      SERVER_RUNTIME: function() {
        return me;
      },
      SSG_FALLBACK_EXPORT_ERROR: function() {
        return le;
      },
      SSG_GET_INITIAL_PROPS_CONFLICT: function() {
        return X;
      },
      STATIC_STATUS_PAGE_GET_INITIAL_PROPS_ERROR: function() {
        return ee;
      },
      TEXT_PLAIN_CONTENT_TYPE_HEADER: function() {
        return n;
      },
      UNSTABLE_REVALIDATE_RENAME_ERROR: function() {
        return de;
      },
      WEBPACK_LAYERS: function() {
        return be;
      },
      WEBPACK_RESOURCE_QUERIES: function() {
        return Se;
      }
    });
    const n = "text/plain", o = "text/html; charset=utf-8", r = "application/json; charset=utf-8", i = "nxtP", a = "nxtI", s = "x-matched-path", c = "x-prerender-revalidate", l = "x-prerender-revalidate-if-generated", d = ".prefetch.rsc", u = ".segments", _ = ".segment.rsc", p = ".rsc", f = ".action", g = ".json", h = ".meta", b = ".body", v = "x-next-cache-tags", $ = "x-next-revalidated-tags", k = "x-next-revalidate-tag-token", S = "next-resume", O = 128, I = 256, D = 1024, M = "_N_T_", N = 31536e3, C = 4294967294, P = "middleware", x = `(?:src/)?${P}`, w = "instrumentation", E = "private-next-pages", T = "private-dot-next", z = "private-next-root-dir", j = "private-next-app-dir", q = "private-next-rsc-mod-ref-proxy", V = "private-next-rsc-action-validate", F = "private-next-rsc-server-reference", L = "private-next-rsc-cache-wrapper", U = "private-next-rsc-track-dynamic-import", W = "private-next-rsc-action-encryption", H = "private-next-rsc-action-client-wrapper", Q = "You can not have a '_next' folder inside of your public folder. This conflicts with the internal '/_next' route. https://nextjs.org/docs/messages/public-next-folder-conflict", X = "You can not use getInitialProps with getStaticProps. To use SSG, please remove your getInitialProps", re = "You can not use getInitialProps with getServerSideProps. Please remove getInitialProps.", Z = "You can not use getStaticProps or getStaticPaths with getServerSideProps. To use SSG, please remove getServerSideProps", ee = "can not have getInitialProps/getServerSideProps, https://nextjs.org/docs/messages/404-get-initial-props", J = "pages with `getServerSideProps` can not be exported. See more info here: https://nextjs.org/docs/messages/gssp-export", oe = "Your `getStaticProps` function did not return an object. Did you forget to add a `return`?", ce = "Your `getServerSideProps` function did not return an object. Did you forget to add a `return`?", de = "The `unstable_revalidate` property is available for general use.\nPlease use `revalidate` instead.", te = "can not be attached to a page's component and must be exported from the page. See more info here: https://nextjs.org/docs/messages/gssp-component-member", ue = 'You are using a non-standard "NODE_ENV" value in your environment. This creates inconsistencies in the project and is strongly advised against. Read more: https://nextjs.org/docs/messages/non-standard-node-env', le = "Pages with `fallback` enabled in `getStaticPaths` can not be exported. See more info here: https://nextjs.org/docs/messages/ssg-fallback-true-export", se = [
      "app",
      "pages",
      "components",
      "lib",
      "src"
    ], me = {
      edge: "edge",
      experimentalEdge: "experimental-edge",
      nodejs: "nodejs"
    }, pe = {
      /**
      * The layer for the shared code between the client and server bundles.
      */
      shared: "shared",
      /**
      * The layer for server-only runtime and picking up `react-server` export conditions.
      * Including app router RSC pages and app router custom routes and metadata routes.
      */
      reactServerComponents: "rsc",
      /**
      * Server Side Rendering layer for app (ssr).
      */
      serverSideRendering: "ssr",
      /**
      * The browser client bundle layer for actions.
      */
      actionBrowser: "action-browser",
      /**
      * The Node.js bundle layer for the API routes.
      */
      apiNode: "api-node",
      /**
      * The Edge Lite bundle layer for the API routes.
      */
      apiEdge: "api-edge",
      /**
      * The layer for the middleware code.
      */
      middleware: "middleware",
      /**
      * The layer for the instrumentation hooks.
      */
      instrument: "instrument",
      /**
      * The layer for assets on the edge.
      */
      edgeAsset: "edge-asset",
      /**
      * The browser client bundle layer for App directory.
      */
      appPagesBrowser: "app-pages-browser",
      /**
      * The browser client bundle layer for Pages directory.
      */
      pagesDirBrowser: "pages-dir-browser",
      /**
      * The Edge Lite bundle layer for Pages directory.
      */
      pagesDirEdge: "pages-dir-edge",
      /**
      * The Node.js bundle layer for Pages directory.
      */
      pagesDirNode: "pages-dir-node"
    }, be = {
      ...pe,
      GROUP: {
        builtinReact: [
          pe.reactServerComponents,
          pe.actionBrowser
        ],
        serverOnly: [
          pe.reactServerComponents,
          pe.actionBrowser,
          pe.instrument,
          pe.middleware
        ],
        neutralTarget: [
          // pages api
          pe.apiNode,
          pe.apiEdge
        ],
        clientOnly: [
          pe.serverSideRendering,
          pe.appPagesBrowser
        ],
        bundled: [
          pe.reactServerComponents,
          pe.actionBrowser,
          pe.serverSideRendering,
          pe.appPagesBrowser,
          pe.shared,
          pe.instrument,
          pe.middleware
        ],
        appPages: [
          // app router pages and layouts
          pe.reactServerComponents,
          pe.serverSideRendering,
          pe.appPagesBrowser,
          pe.actionBrowser
        ]
      }
    }, Se = {
      edgeSSREntry: "__next_edge_ssr_entry__",
      metadata: "__next_metadata__",
      metadataRoute: "__next_metadata_route__",
      metadataImageMeta: "__next_metadata_image_meta__"
    };
  }(_4)), _4;
}
var p4 = {}, mW;
function yuc() {
  return mW || (mW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "escapeStringRegexp", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = /[|\\{}()[\]^$+*?.-]/, n = /[|\\{}()[\]^$+*?.-]/g;
    function o(r) {
      return t.test(r) ? r.replace(n, "\\$&") : r;
    }
  }(p4)), p4;
}
var m4 = {}, fW;
function $uc() {
  return fW || (fW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      PARAMETER_PATTERN: function() {
        return o;
      },
      getDynamicParam: function() {
        return n;
      },
      parseMatchedParameter: function() {
        return i;
      },
      parseParameter: function() {
        return r;
      }
    });
    function n(a, s, c, l, d) {
      let u = a[s];
      if (d && d.has(s) ? u = d.get(s) : Array.isArray(u) ? u = u.map((_) => encodeURIComponent(_)) : typeof u == "string" && (u = encodeURIComponent(u)), !u) {
        const _ = c === "c", p = c === "oc";
        if (_ || p)
          return p ? {
            param: s,
            value: null,
            type: c,
            treeSegment: [
              s,
              "",
              c
            ]
          } : (u = l.split("/").slice(1).flatMap((f) => {
            const g = r(f);
            var h;
            return (h = a[g.key]) != null ? h : g.key;
          }), {
            param: s,
            value: u,
            type: c,
            // This value always has to be a string.
            treeSegment: [
              s,
              u.join("/"),
              c
            ]
          });
      }
      return {
        param: s,
        // The value that is passed to user code.
        value: u,
        // The value that is rendered in the router tree.
        treeSegment: [
          s,
          Array.isArray(u) ? u.join("/") : u,
          c
        ],
        type: c
      };
    }
    const o = /^([^[]*)\[((?:\[[^\]]*\])|[^\]]+)\](.*)$/;
    function r(a) {
      const s = a.match(o);
      return i(s ? s[2] : a);
    }
    function i(a) {
      const s = a.startsWith("[") && a.endsWith("]");
      s && (a = a.slice(1, -1));
      const c = a.startsWith("...");
      return c && (a = a.slice(3)), {
        key: a,
        repeat: c,
        optional: s
      };
    }
  }(m4)), m4;
}
var gW;
function Bse() {
  return gW || (gW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(f, g) {
      for (var h in g)
        Object.defineProperty(f, h, {
          enumerable: !0,
          get: g[h]
        });
    }
    t(e, {
      getNamedMiddlewareRegex: function() {
        return p;
      },
      getNamedRouteRegex: function() {
        return _;
      },
      getRouteRegex: function() {
        return c;
      }
    });
    const n = buc(), o = Fse(), r = yuc(), i = qse(), a = $uc();
    function s(f, g, h) {
      const b = {};
      let v = 1;
      const $ = [];
      for (const k of (0, i.removeTrailingSlash)(f).slice(1).split("/")) {
        const S = o.INTERCEPTION_ROUTE_MARKERS.find((I) => k.startsWith(I)), O = k.match(a.PARAMETER_PATTERN);
        if (S && O && O[2]) {
          const { key: I, optional: D, repeat: M } = (0, a.parseMatchedParameter)(O[2]);
          b[I] = {
            pos: v++,
            repeat: M,
            optional: D
          }, $.push("/" + (0, r.escapeStringRegexp)(S) + "([^/]+?)");
        } else if (O && O[2]) {
          const { key: I, repeat: D, optional: M } = (0, a.parseMatchedParameter)(O[2]);
          b[I] = {
            pos: v++,
            repeat: D,
            optional: M
          }, h && O[1] && $.push("/" + (0, r.escapeStringRegexp)(O[1]));
          let N = D ? M ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
          h && O[1] && (N = N.substring(1)), $.push(N);
        } else
          $.push("/" + (0, r.escapeStringRegexp)(k));
        g && O && O[3] && $.push((0, r.escapeStringRegexp)(O[3]));
      }
      return {
        parameterizedRoute: $.join(""),
        groups: b
      };
    }
    function c(f, g) {
      let { includeSuffix: h = !1, includePrefix: b = !1, excludeOptionalTrailingSlash: v = !1 } = g === void 0 ? {} : g;
      const { parameterizedRoute: $, groups: k } = s(f, h, b);
      let S = $;
      return v || (S += "(?:/)?"), {
        re: new RegExp("^" + S + "$"),
        groups: k
      };
    }
    function l() {
      let f = 0;
      return () => {
        let g = "", h = ++f;
        for (; h > 0; )
          g += String.fromCharCode(97 + (h - 1) % 26), h = Math.floor((h - 1) / 26);
        return g;
      };
    }
    function d(f) {
      let { interceptionMarker: g, getSafeRouteKey: h, segment: b, routeKeys: v, keyPrefix: $, backreferenceDuplicateKeys: k } = f;
      const { key: S, optional: O, repeat: I } = (0, a.parseMatchedParameter)(b);
      let D = S.replace(/\W/g, "");
      $ && (D = "" + $ + D);
      let M = !1;
      (D.length === 0 || D.length > 30) && (M = !0), isNaN(parseInt(D.slice(0, 1))) || (M = !0), M && (D = h());
      const N = D in v;
      $ ? v[D] = "" + $ + S : v[D] = S;
      const C = g ? (0, r.escapeStringRegexp)(g) : "";
      let P;
      return N && k ? P = "\\k<" + D + ">" : I ? P = "(?<" + D + ">.+?)" : P = "(?<" + D + ">[^/]+?)", O ? "(?:/" + C + P + ")?" : "/" + C + P;
    }
    function u(f, g, h, b, v) {
      const $ = l(), k = {}, S = [];
      for (const O of (0, i.removeTrailingSlash)(f).slice(1).split("/")) {
        const I = o.INTERCEPTION_ROUTE_MARKERS.some((M) => O.startsWith(M)), D = O.match(a.PARAMETER_PATTERN);
        if (I && D && D[2])
          S.push(d({
            getSafeRouteKey: $,
            interceptionMarker: D[1],
            segment: D[2],
            routeKeys: k,
            keyPrefix: g ? n.NEXT_INTERCEPTION_MARKER_PREFIX : void 0,
            backreferenceDuplicateKeys: v
          }));
        else if (D && D[2]) {
          b && D[1] && S.push("/" + (0, r.escapeStringRegexp)(D[1]));
          let M = d({
            getSafeRouteKey: $,
            segment: D[2],
            routeKeys: k,
            keyPrefix: g ? n.NEXT_QUERY_PARAM_PREFIX : void 0,
            backreferenceDuplicateKeys: v
          });
          b && D[1] && (M = M.substring(1)), S.push(M);
        } else
          S.push("/" + (0, r.escapeStringRegexp)(O));
        h && D && D[3] && S.push((0, r.escapeStringRegexp)(D[3]));
      }
      return {
        namedParameterizedRoute: S.join(""),
        routeKeys: k
      };
    }
    function _(f, g) {
      var h, b, v;
      const $ = u(f, g.prefixRouteKeys, (h = g.includeSuffix) != null ? h : !1, (b = g.includePrefix) != null ? b : !1, (v = g.backreferenceDuplicateKeys) != null ? v : !1);
      let k = $.namedParameterizedRoute;
      return g.excludeOptionalTrailingSlash || (k += "(?:/)?"), {
        ...c(f, g),
        namedRegex: "^" + k + "$",
        routeKeys: $.routeKeys
      };
    }
    function p(f, g) {
      const { parameterizedRoute: h } = s(f, !1, !1), { catchAll: b = !0 } = g;
      if (h === "/")
        return {
          namedRegex: "^/" + (b ? ".*" : "") + "$"
        };
      const { namedParameterizedRoute: v } = u(f, !1, !1, !1, !1);
      let $ = b ? "(?:(/.*)?)" : "";
      return {
        namedRegex: "^" + v + $ + "$"
      };
    }
  }(u4)), u4;
}
var hW;
function wuc() {
  return hW || (hW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "interpolateAs", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = Vse(), n = Bse();
    function o(r, i, a) {
      let s = "";
      const c = (0, n.getRouteRegex)(r), l = c.groups, d = (
        // Try to match the dynamic route against the asPath
        (i !== r ? (0, t.getRouteMatcher)(c)(i) : "") || // Fall back to reading the values from the href
        // TODO: should this take priority; also need to change in the router.
        a
      );
      s = r;
      const u = Object.keys(l);
      return u.every((_) => {
        let p = d[_] || "";
        const { repeat: f, optional: g } = l[_];
        let h = "[" + (f ? "..." : "") + _ + "]";
        return g && (h = (p ? "" : "/") + "[" + h + "]"), f && !Array.isArray(p) && (p = [
          p
        ]), (g || _ in d) && // Interpolate group into data URL if present
        (s = s.replace(h, f ? p.map(
          // these values should be fully encoded instead of just
          // path delimiter escaped since they are being inserted
          // into the URL and we expect URL encoded segments
          // when parsing dynamic route params
          (b) => encodeURIComponent(b)
        ).join("/") : encodeURIComponent(p)) || "/");
      }) || (s = ""), {
        params: u,
        result: s
      };
    }
  }(a4)), a4;
}
var vW;
function kuc() {
  return vW || (vW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "resolveHref", {
      enumerable: !0,
      get: function() {
        return _;
      }
    });
    const n = Mse(), o = Lse(), r = cuc(), i = KT(), a = YT(), s = jse(), c = fuc(), l = wuc(), d = Bse(), u = Vse();
    function _(p, f, g) {
      let h, b = typeof f == "string" ? f : (0, o.formatWithValidation)(f);
      const v = b.match(/^[a-z][a-z0-9+.-]*:\/\//i), $ = v ? b.slice(v[0].length) : b;
      if (($.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
        console.error("Invalid href '" + b + "' passed to next/router in page: '" + p.pathname + "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.");
        const S = (0, i.normalizeRepeatedSlashes)($);
        b = (v ? v[0] : "") + S;
      }
      if (!(0, s.isLocalURL)(b))
        return g ? [
          b
        ] : b;
      try {
        let S = b.startsWith("#") ? p.asPath : p.pathname;
        if (b.startsWith("?") && (S = p.asPath, (0, c.isDynamicRoute)(p.pathname))) {
          S = p.pathname;
          const O = (0, d.getRouteRegex)(p.pathname);
          (0, u.getRouteMatcher)(O)(p.asPath) || (S = p.asPath);
        }
        h = new URL(S, "http://n");
      } catch {
        h = new URL("/", "http://n");
      }
      try {
        const S = new URL(b, h);
        S.pathname = (0, a.normalizePathTrailingSlash)(S.pathname);
        let O = "";
        if ((0, c.isDynamicRoute)(S.pathname) && S.searchParams && g) {
          const D = (0, n.searchParamsToUrlQuery)(S.searchParams), { result: M, params: N } = (0, l.interpolateAs)(S.pathname, S.pathname, D);
          M && (O = (0, o.formatWithValidation)({
            pathname: M,
            hash: S.hash,
            query: (0, r.omit)(D, N)
          }));
        }
        const I = S.origin === h.origin ? S.href.slice(S.origin.length) : S.href;
        return g ? [
          I,
          O || I
        ] : I;
      } catch {
        return g ? [
          b
        ] : b;
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(Z1, Z1.exports)), Z1.exports;
}
var X1 = { exports: {} }, bW;
function Suc() {
  return bW || (bW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addLocale", {
      enumerable: !0,
      get: function() {
        return n;
      }
    }), YT();
    const n = function(o) {
      for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
        i[a - 1] = arguments[a];
      return o;
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(X1, X1.exports)), X1.exports;
}
var f4 = {}, sm = {};
function xuc(e) {
  return e && e.__esModule ? e : { default: e };
}
sm._ = xuc;
var yW;
function Euc() {
  return yW || (yW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "RouterContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ sm._(ve)).default.createContext(null);
  }(f4)), f4;
}
var e2 = { exports: {} }, t2 = { exports: {} }, $W;
function Use() {
  return $W || ($W = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    n(t, {
      cancelIdleCallback: function() {
        return r;
      },
      requestIdleCallback: function() {
        return o;
      }
    });
    const o = typeof self < "u" && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(i) {
      let a = Date.now();
      return self.setTimeout(function() {
        i({
          didTimeout: !1,
          timeRemaining: function() {
            return Math.max(0, 50 - (Date.now() - a));
          }
        });
      }, 1);
    }, r = typeof self < "u" && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(i) {
      return clearTimeout(i);
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(t2, t2.exports)), t2.exports;
}
var wW;
function Tuc() {
  return wW || (wW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "useIntersection", {
      enumerable: !0,
      get: function() {
        return l;
      }
    });
    const n = ve, o = Use(), r = typeof IntersectionObserver == "function", i = /* @__PURE__ */ new Map(), a = [];
    function s(d) {
      const u = {
        root: d.root || null,
        margin: d.rootMargin || ""
      }, _ = a.find((h) => h.root === u.root && h.margin === u.margin);
      let p;
      if (_ && (p = i.get(_), p))
        return p;
      const f = /* @__PURE__ */ new Map(), g = new IntersectionObserver((h) => {
        h.forEach((b) => {
          const v = f.get(b.target), $ = b.isIntersecting || b.intersectionRatio > 0;
          v && $ && v($);
        });
      }, d);
      return p = {
        id: u,
        observer: g,
        elements: f
      }, a.push(u), i.set(u, p), p;
    }
    function c(d, u, _) {
      const { id: p, observer: f, elements: g } = s(_);
      return g.set(d, u), f.observe(d), function() {
        if (g.delete(d), f.unobserve(d), g.size === 0) {
          f.disconnect(), i.delete(p);
          const b = a.findIndex((v) => v.root === p.root && v.margin === p.margin);
          b > -1 && a.splice(b, 1);
        }
      };
    }
    function l(d) {
      let { rootRef: u, rootMargin: _, disabled: p } = d;
      const f = p || !r, [g, h] = (0, n.useState)(!1), b = (0, n.useRef)(null), v = (0, n.useCallback)((k) => {
        b.current = k;
      }, []);
      (0, n.useEffect)(() => {
        if (r) {
          if (f || g)
            return;
          const k = b.current;
          if (k && k.tagName)
            return c(k, (O) => O && h(O), {
              root: u == null ? void 0 : u.current,
              rootMargin: _
            });
        } else if (!g) {
          const k = (0, o.requestIdleCallback)(() => h(!0));
          return () => (0, o.cancelIdleCallback)(k);
        }
      }, [
        f,
        _,
        u,
        g,
        b.current
      ]);
      const $ = (0, n.useCallback)(() => {
        h(!1);
      }, []);
      return [
        v,
        g,
        $
      ];
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(e2, e2.exports)), e2.exports;
}
var n2 = { exports: {} }, kW;
function Auc() {
  return kW || (kW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "getDomainLocale", {
      enumerable: !0,
      get: function() {
        return n;
      }
    }), YT();
    function n(o, r, i, a) {
      return !1;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(n2, n2.exports)), n2.exports;
}
var o2 = { exports: {} }, g4 = {}, SW;
function Cuc() {
  return SW || (SW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addPathPrefix", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = Kq();
    function n(o, r) {
      if (!o.startsWith("/") || !r)
        return o;
      const { pathname: i, query: a, hash: s } = (0, t.parsePath)(o);
      return "" + r + i + a + s;
    }
  }(g4)), g4;
}
var xW;
function zuc() {
  return xW || (xW = 1, function(e, t) {
    var n = {};
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addBasePath", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const o = Cuc(), r = YT(), i = "";
    function a(s, c) {
      return (0, r.normalizePathTrailingSlash)(n.__NEXT_MANUAL_CLIENT_BASE_PATH && !c ? s : (0, o.addPathPrefix)(s, i));
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(o2, o2.exports)), o2.exports;
}
var r2 = { exports: {} }, EW;
function Ouc() {
  return EW || (EW = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "useMergedRef", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = ve;
    function o(i, a) {
      const s = (0, n.useRef)(null), c = (0, n.useRef)(null);
      return (0, n.useCallback)((l) => {
        if (l === null) {
          const d = s.current;
          d && (s.current = null, d());
          const u = c.current;
          u && (c.current = null, u());
        } else
          i && (s.current = r(i, l)), a && (c.current = r(a, l));
      }, [
        i,
        a
      ]);
    }
    function r(i, a) {
      if (typeof i == "function") {
        const s = i(a);
        return typeof s == "function" ? s : () => i(null);
      } else
        return i.current = a, () => {
          i.current = null;
        };
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(r2, r2.exports)), r2.exports;
}
var h4 = {}, TW;
function Puc() {
  return TW || (TW = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "errorOnce", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    let t = (n) => {
    };
  }(h4)), h4;
}
(function(e, t) {
  "use client";
  var n = {};
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function o(N, C) {
    for (var P in C)
      Object.defineProperty(N, P, {
        enumerable: !0,
        get: C[P]
      });
  }
  o(t, {
    default: function() {
      return M;
    },
    useLinkStatus: function() {
      return D;
    }
  });
  const r = q0, i = PT, a = /* @__PURE__ */ r._(ve), s = kuc(), c = jse(), l = Lse(), d = KT(), u = Suc(), _ = Euc(), p = Tuc(), f = Auc(), g = zuc(), h = Ouc();
  Puc();
  const b = /* @__PURE__ */ new Set();
  function v(N, C, P, x) {
    if (!(typeof window > "u") && (0, c.isLocalURL)(C)) {
      if (!x.bypassPrefetchedCheck) {
        const w = (
          // Let the link's locale prop override the default router locale.
          typeof x.locale < "u" ? x.locale : "locale" in N ? N.locale : void 0
        ), E = C + "%" + P + "%" + w;
        if (b.has(E))
          return;
        b.add(E);
      }
      N.prefetch(C, P, x).catch((w) => {
      });
    }
  }
  function $(N) {
    const P = N.currentTarget.getAttribute("target");
    return P && P !== "_self" || N.metaKey || N.ctrlKey || N.shiftKey || N.altKey || // triggers resource download
    N.nativeEvent && N.nativeEvent.which === 2;
  }
  function k(N, C, P, x, w, E, T, z, j) {
    const { nodeName: q } = N.currentTarget;
    if (q.toUpperCase() === "A" && $(N) || N.currentTarget.hasAttribute("download"))
      return;
    if (!(0, c.isLocalURL)(P)) {
      w && (N.preventDefault(), location.replace(P));
      return;
    }
    N.preventDefault(), (() => {
      if (j) {
        let U = !1;
        if (j({
          preventDefault: () => {
            U = !0;
          }
        }), U)
          return;
      }
      const L = T ?? !0;
      "beforePopState" in C ? C[w ? "replace" : "push"](P, x, {
        shallow: E,
        locale: z,
        scroll: L
      }) : C[w ? "replace" : "push"](x || P, {
        scroll: L
      });
    })();
  }
  function S(N) {
    return typeof N == "string" ? N : (0, l.formatUrl)(N);
  }
  const O = /* @__PURE__ */ a.default.forwardRef(function(C, P) {
    let x;
    const { href: w, as: E, children: T, prefetch: z = null, passHref: j, replace: q, shallow: V, scroll: F, locale: L, onClick: U, onNavigate: W, onMouseEnter: H, onTouchStart: Q, legacyBehavior: X = !1, ...re } = C;
    x = T, X && (typeof x == "string" || typeof x == "number") && (x = /* @__PURE__ */ (0, i.jsx)("a", {
      children: x
    }));
    const Z = a.default.useContext(_.RouterContext), ee = z !== !1, { href: J, as: oe } = a.default.useMemo(() => {
      if (!Z) {
        const Ge = S(w);
        return {
          href: Ge,
          as: E ? S(E) : Ge
        };
      }
      const [Ae, Ze] = (0, s.resolveHref)(Z, w, !0);
      return {
        href: Ae,
        as: E ? (0, s.resolveHref)(Z, E) : Ze || Ae
      };
    }, [
      Z,
      w,
      E
    ]), ce = a.default.useRef(J), de = a.default.useRef(oe);
    let te;
    X && (te = a.default.Children.only(x));
    const ue = X ? te && typeof te == "object" && te.ref : P, [le, se, me] = (0, p.useIntersection)({
      rootMargin: "200px"
    }), pe = a.default.useCallback((Ae) => {
      (de.current !== oe || ce.current !== J) && (me(), de.current = oe, ce.current = J), le(Ae);
    }, [
      oe,
      J,
      me,
      le
    ]), be = (0, h.useMergedRef)(pe, ue);
    a.default.useEffect(() => {
      Z && (!se || !ee || v(Z, J, oe, {
        locale: L
      }));
    }, [
      oe,
      J,
      se,
      L,
      ee,
      Z == null ? void 0 : Z.locale,
      Z
    ]);
    const Se = {
      ref: be,
      onClick(Ae) {
        !X && typeof U == "function" && U(Ae), X && te.props && typeof te.props.onClick == "function" && te.props.onClick(Ae), Z && (Ae.defaultPrevented || k(Ae, Z, J, oe, q, V, F, L, W));
      },
      onMouseEnter(Ae) {
        !X && typeof H == "function" && H(Ae), X && te.props && typeof te.props.onMouseEnter == "function" && te.props.onMouseEnter(Ae), Z && v(Z, J, oe, {
          locale: L,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        });
      },
      onTouchStart: n.__NEXT_LINK_NO_TOUCH_START ? void 0 : function(Ze) {
        !X && typeof Q == "function" && Q(Ze), X && te.props && typeof te.props.onTouchStart == "function" && te.props.onTouchStart(Ze), Z && v(Z, J, oe, {
          locale: L,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        });
      }
    };
    if ((0, d.isAbsoluteUrl)(oe))
      Se.href = oe;
    else if (!X || j || te.type === "a" && !("href" in te.props)) {
      const Ae = typeof L < "u" ? L : Z == null ? void 0 : Z.locale, Ze = (Z == null ? void 0 : Z.isLocaleDomain) && (0, f.getDomainLocale)(oe, Ae, Z == null ? void 0 : Z.locales, Z == null ? void 0 : Z.domainLocales);
      Se.href = Ze || (0, g.addBasePath)((0, u.addLocale)(oe, Ae, Z == null ? void 0 : Z.defaultLocale));
    }
    return X ? /* @__PURE__ */ a.default.cloneElement(te, Se) : /* @__PURE__ */ (0, i.jsx)("a", {
      ...re,
      ...Se,
      children: x
    });
  }), I = /* @__PURE__ */ (0, a.createContext)({
    // We do not support link status in the Pages Router, so we always return false
    pending: !1
  }), D = () => (0, a.useContext)(I), M = O;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(rD, rD.exports);
var Iuc = rD.exports, Ruc = Iuc;
const Po = /* @__PURE__ */ Zr(Ruc);
function Ao({
  children: e,
  content: t,
  open: n,
  defaultOpen: o,
  onOpenChange: r,
  delayDuration: i,
  side: a = "top",
  ...s
}) {
  const c = /* @__PURE__ */ m(
    kOe,
    {
      ...s,
      className: ae(
        "calcom-tooltip",
        a === "top" && "-mt-7",
        a === "right" && "ml-2",
        "bg-inverted text-inverted relative z-50 rounded-md px-2 py-1 text-xs font-semibold shadow-lg",
        s.className && `${s.className}`
      ),
      side: a,
      align: "center",
      children: t
    }
  );
  return /* @__PURE__ */ Y(
    SOe,
    {
      delayDuration: i || 50,
      open: n,
      defaultOpen: o,
      onOpenChange: r,
      children: [
        /* @__PURE__ */ m($Oe, { asChild: !0, children: e }),
        /* @__PURE__ */ m(yOe, { children: c })
      ]
    }
  );
}
const Cx = Yv(
  "group whitespace-nowrap inline-flex items-center text-sm font-medium relative rounded-[10px] transition disabled:cursor-not-allowed gap-1",
  {
    variants: {
      variant: {
        button: "",
        icon: "flex justify-center",
        fab: "min-w-14 min-h-14 md:min-w-min md:min-h-min rounded-full justify-center md:rounded-[10px] radix-state-open:rotate-45 md:radix-state-open:rotate-0 radix-state-open:shadown-none radix-state-open:ring-0"
      },
      color: {
        primary: [
          // Base colors
          "bg-brand-default",
          "text-brand",
          // Hover state
          "enabled:hover:bg-brand-emphasis",
          // Focus state
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-button-solid-brand-focused",
          // Border
          "border border-brand-default",
          // Disabled
          "disabled:opacity-30",
          // Shadows and effects
          "shadow-button-solid-brand-default",
          "enabled:active:shadow-button-solid-brand-active",
          "enabled:hover:shadow-button-solid-brand-hover",
          "transition-shadow",
          "transition-transform",
          "duration-100"
        ],
        secondary: [
          // Base colors and border
          "bg-default",
          "text-default",
          "border",
          "border-default",
          // Hover state
          "enabled:hover:bg-muted",
          "enabled:hover:text-emphasis",
          // Disabled
          "disabled:opacity-30",
          // Focus state
          "focus-visible:bg-subtle",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-outline-gray-focused",
          // Shadows and effects
          "shadow-outline-gray-rested",
          "enabled:hover:shadow-outline-gray-hover",
          "enabled:active:shadow-outline-gray-active",
          "transition-shadow",
          "duration-200"
        ],
        minimal: [
          // Base color
          "text-subtle",
          "border border-transparent",
          // Hover
          "enabled:hover:bg-subtle",
          "enabled:hover:text-emphasis",
          "enabled:hover:border-subtle hover:border",
          // Disabled
          "disabled:opacity-30",
          // Focus
          "focus-visible:bg-subtle",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:border-subtle",
          "focus-visible:shadow-button-outline-gray-focused",
          // Shadows and effects
          "enabled:active:shadow-outline-gray-active",
          "transition-shadow",
          "duration-200"
        ],
        destructive: [
          // Base colors and border
          "border",
          "border-default",
          "text-error",
          // Hover state
          "dark:hover:text-red-100",
          "hover:border-semantic-error",
          "hover:bg-error",
          // Focus state
          "focus-visible:text-red-700",
          "focus-visible:bg-error",
          "focus-visible:outline-none",
          "focus-visible:ring-0",
          "focus-visible:shadow-button-outline-red-focused",
          // Disabled state
          "disabled:bg-red-100",
          "disabled:border-red-200",
          "disabled:text-red-700",
          "disabled:hover:border-red-200",
          "disabled:opacity-30",
          // Shadows and effects
          "shadow-outline-red-rested",
          "enabled:hover:shadow-outline-red-hover",
          "enabled:active:shadow-outline-red-active",
          "transition-shadow",
          "duration-200"
        ]
      },
      size: {
        xs: "h-6 p-2 leading-none text-xs rounded-md",
        sm: "h-7 px-2 py-1.5 leading-none text-sm",
        base: "px-2.5 py-2 text-sm leading-none",
        lg: "px-3 py-2.5 "
      },
      loading: {
        true: "cursor-wait"
      }
    },
    compoundVariants: [
      // Primary variants
      {
        loading: !0,
        color: "primary",
        className: "opacity-30"
      },
      // Secondary variants
      {
        loading: !0,
        color: "secondary",
        className: "bg-subtle text-emphasis/80"
      },
      // Minimal variants
      {
        loading: !0,
        color: "minimal",
        className: "bg-subtle text-emphasis/30"
      },
      // Destructive variants
      {
        loading: !0,
        color: "destructive",
        className: "text-red-700/30 dark:text-red-700/30 hover:text-red-700/30  border border-default text-emphasis"
      },
      {
        variant: "icon",
        size: "base",
        className: "min-h-[36px] min-w-[36px] !p-2 hover:border-default"
      },
      {
        variant: "icon",
        size: "xs",
        className: "h-5 w-5 !p-1 rounded-md"
      },
      {
        variant: "icon",
        size: "sm",
        className: "h-6 w-6 !p-1 rounded-md"
      },
      {
        variant: "icon",
        size: "lg",
        className: "h-10 w-10 !p-1"
      },
      {
        variant: "fab",
        size: "base",
        className: "md:px-4 md:py-2.5"
      }
    ],
    defaultVariants: {
      variant: "button",
      color: "primary",
      size: "base"
    }
  }
), ut = it(function(t, n) {
  const {
    loading: o = !1,
    color: r = "primary",
    size: i,
    variant: a = "button",
    type: s = "button",
    tooltipSide: c = "top",
    tooltipOffset: l = 4,
    tooltipClassName: d,
    StartIcon: u,
    CustomStartIcon: _,
    EndIcon: p,
    shallow: f,
    // attributes propagated from `HTMLAnchorProps` or `HTMLButtonProps`
    ...g
  } = t, h = t.disabled || o, b = typeof t.href < "u", v = b ? "a" : "button", $ = ve.createElement(
    v,
    {
      ...g,
      disabled: h,
      type: b ? void 0 : s,
      ref: n,
      className: ae(Cx({ color: r, size: i, loading: o, variant: a }), t.className),
      // if we click a disabled button, we prevent going through the click handler
      onClick: h ? (k) => {
        k.preventDefault();
      } : t.onClick
    },
    /* @__PURE__ */ Y(Ce, { children: [
      _ || u && /* @__PURE__ */ m(Ce, { children: a === "fab" ? /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(ot, { name: u, className: "hidden h-4 w-4 stroke-[1.5px]  md:inline-flex" }),
        /* @__PURE__ */ m(ot, { name: "plus", "data-testid": "plus", className: "inline h-6 w-6 md:hidden" })
      ] }) : /* @__PURE__ */ m(
        ot,
        {
          "data-name": "start-icon",
          name: u,
          className: ae(
            o ? "invisible" : "visible",
            "button-icon group-active:translate-y-[0.5px]",
            a === "icon" && "h-4 w-4",
            a === "button" && "h-4 w-4 stroke-[1.5px] "
          )
        }
      ) }),
      /* @__PURE__ */ m(
        "div",
        {
          className: ae(
            "contents",
            // This makes the div behave like it doesn't exist in the layout
            o ? "invisible" : "visible",
            a === "fab" ? "hidden md:contents" : "",
            "group-active:translate-y-[0.5px]"
          ),
          children: t.children
        }
      ),
      o && /* @__PURE__ */ m("div", { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform", children: /* @__PURE__ */ Y(
        "svg",
        {
          className: ae(
            "mx-4 h-5 w-5 animate-spin",
            r === "primary" ? "text-inverted" : "text-emphasis"
          ),
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [
            /* @__PURE__ */ m("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            /* @__PURE__ */ m(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      ) }),
      p && /* @__PURE__ */ m(Ce, { children: a === "fab" ? /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(ot, { name: p, className: "-mr-1 me-2 ms-2 hidden h-5 w-5 md:inline" }),
        /* @__PURE__ */ m(ot, { name: "plus", "data-testid": "plus", className: "inline h-6 w-6 md:hidden" })
      ] }) : /* @__PURE__ */ m(
        ot,
        {
          name: p,
          className: ae(
            o ? "invisible" : "visible",
            "group-active:translate-y-[0.5px]",
            a === "icon" && "h-4 w-4",
            a === "button" && "h-4 w-4 stroke-[1.5px] "
          )
        }
      ) })
    ] })
  );
  return t.href ? /* @__PURE__ */ m(Po, { "data-testid": "link-component", passHref: !0, href: t.href, shallow: f && f, legacyBehavior: !0, children: $ }) : /* @__PURE__ */ m(
    Nuc,
    {
      "data-testid": "wrapper",
      tooltip: t.tooltip,
      tooltipSide: c,
      tooltipOffset: l,
      tooltipClassName: d,
      children: $
    }
  );
}), Nuc = ({
  children: e,
  tooltip: t,
  tooltipSide: n,
  tooltipOffset: o,
  tooltipClassName: r
}) => t ? /* @__PURE__ */ m(
  Ao,
  {
    "data-testid": "tooltip",
    className: r,
    content: t,
    side: n,
    sideOffset: o,
    children: e
  }
) : /* @__PURE__ */ m(Ce, { children: e });
ut.displayName = "Button";
const Duc = /* @__PURE__ */ No(void 0);
function Muc(e) {
  const t = Pn(Duc);
  return e || t || "ltr";
}
let v4 = 0;
function Zq() {
  Le(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : AW()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : AW()), v4++, () => {
      v4 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), v4--;
    };
  }, []);
}
function AW() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const b4 = "focusScope.autoFocusOnMount", y4 = "focusScope.autoFocusOnUnmount", CW = {
  bubbles: !1,
  cancelable: !0
}, Qq = /* @__PURE__ */ it((e, t) => {
  const { loop: n = !1, trapped: o = !1, onMountAutoFocus: r, onUnmountAutoFocus: i, ...a } = e, [s, c] = ze(null), l = Ui(r), d = Ui(i), u = Ue(null), _ = or(
    t,
    (g) => c(g)
  ), p = Ue({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Le(() => {
    if (o) {
      let g = function($) {
        if (p.paused || !s)
          return;
        const k = $.target;
        s.contains(k) ? u.current = k : up(u.current, {
          select: !0
        });
      }, h = function($) {
        if (p.paused || !s)
          return;
        const k = $.relatedTarget;
        k !== null && (s.contains(k) || up(u.current, {
          select: !0
        }));
      }, b = function($) {
        const k = document.activeElement;
        for (const S of $)
          S.removedNodes.length > 0 && (s != null && s.contains(k) || up(s));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", h);
      const v = new MutationObserver(b);
      return s && v.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", h), v.disconnect();
      };
    }
  }, [
    o,
    s,
    p.paused
  ]), Le(() => {
    if (s) {
      OW.add(p);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const b = new CustomEvent(b4, CW);
        s.addEventListener(b4, l), s.dispatchEvent(b), b.defaultPrevented || (Luc(Buc(Wse(s)), {
          select: !0
        }), document.activeElement === g && up(s));
      }
      return () => {
        s.removeEventListener(b4, l), setTimeout(() => {
          const b = new CustomEvent(y4, CW);
          s.addEventListener(y4, d), s.dispatchEvent(b), b.defaultPrevented || up(g ?? document.body, {
            select: !0
          }), s.removeEventListener(y4, d), OW.remove(p);
        }, 0);
      };
    }
  }, [
    s,
    l,
    d,
    p
  ]);
  const f = at((g) => {
    if (!n && !o || p.paused)
      return;
    const h = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (h && b) {
      const v = g.currentTarget, [$, k] = quc(v);
      $ && k ? !g.shiftKey && b === k ? (g.preventDefault(), n && up($, {
        select: !0
      })) : g.shiftKey && b === $ && (g.preventDefault(), n && up(k, {
        select: !0
      })) : b === v && g.preventDefault();
    }
  }, [
    n,
    o,
    p.paused
  ]);
  return /* @__PURE__ */ Pe(io.div, We({
    tabIndex: -1
  }, a, {
    ref: _,
    onKeyDown: f
  }));
});
function Luc(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (up(o, {
      select: t
    }), document.activeElement !== n)
      return;
}
function quc(e) {
  const t = Wse(e), n = zW(t, e), o = zW(t.reverse(), e);
  return [
    n,
    o
  ];
}
function Wse(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function zW(e, t) {
  for (const n of e)
    if (!juc(n, {
      upTo: t
    }))
      return n;
}
function juc(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Fuc(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function up(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Fuc(e) && t && e.select();
  }
}
const OW = Vuc();
function Vuc() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = PW(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = PW(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function PW(e, t) {
  const n = [
    ...e
  ], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Buc(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Uuc = /* @__PURE__ */ No(void 0);
function Wuc(e) {
  const t = Pn(Uuc);
  return e || t || "ltr";
}
const $4 = "rovingFocusGroup.onEntryFocus", Guc = {
  bubbles: !1,
  cancelable: !0
}, Jq = "RovingFocusGroup", [iD, Gse, Huc] = Uq(Jq), [Kuc, Zv] = os(Jq, [
  Huc
]), [Yuc, Zuc] = Kuc(Jq), Quc = /* @__PURE__ */ it((e, t) => /* @__PURE__ */ Pe(iD.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(iD.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(Juc, We({}, e, {
  ref: t
}))))), Juc = /* @__PURE__ */ it((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: o, loop: r = !1, dir: i, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...d } = e, u = Ue(null), _ = or(t, u), p = Wuc(i), [f = null, g] = jc({
    prop: a,
    defaultProp: s,
    onChange: c
  }), [h, b] = ze(!1), v = Ui(l), $ = Gse(n), k = Ue(!1), [S, O] = ze(0);
  return Le(() => {
    const I = u.current;
    if (I)
      return I.addEventListener($4, v), () => I.removeEventListener($4, v);
  }, [
    v
  ]), /* @__PURE__ */ Pe(Yuc, {
    scope: n,
    orientation: o,
    dir: p,
    loop: r,
    currentTabStopId: f,
    onItemFocus: at(
      (I) => g(I),
      [
        g
      ]
    ),
    onItemShiftTab: at(
      () => b(!0),
      []
    ),
    onFocusableItemAdd: at(
      () => O(
        (I) => I + 1
      ),
      []
    ),
    onFocusableItemRemove: at(
      () => O(
        (I) => I - 1
      ),
      []
    )
  }, /* @__PURE__ */ Pe(io.div, We({
    tabIndex: h || S === 0 ? -1 : 0,
    "data-orientation": o
  }, d, {
    ref: _,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Bt(e.onMouseDown, () => {
      k.current = !0;
    }),
    onFocus: Bt(e.onFocus, (I) => {
      const D = !k.current;
      if (I.target === I.currentTarget && D && !h) {
        const M = new CustomEvent($4, Guc);
        if (I.currentTarget.dispatchEvent(M), !M.defaultPrevented) {
          const N = $().filter(
            (E) => E.focusable
          ), C = N.find(
            (E) => E.active
          ), P = N.find(
            (E) => E.id === f
          ), w = [
            C,
            P,
            ...N
          ].filter(Boolean).map(
            (E) => E.ref.current
          );
          Hse(w);
        }
      }
      k.current = !1;
    }),
    onBlur: Bt(
      e.onBlur,
      () => b(!1)
    )
  })));
}), Xuc = "RovingFocusGroupItem", e_c = /* @__PURE__ */ it((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: o = !0, active: r = !1, tabStopId: i, ...a } = e, s = Cc(), c = i || s, l = Zuc(Xuc, n), d = l.currentTabStopId === c, u = Gse(n), { onFocusableItemAdd: _, onFocusableItemRemove: p } = l;
  return Le(() => {
    if (o)
      return _(), () => p();
  }, [
    o,
    _,
    p
  ]), /* @__PURE__ */ Pe(iD.ItemSlot, {
    scope: n,
    id: c,
    focusable: o,
    active: r
  }, /* @__PURE__ */ Pe(io.span, We({
    tabIndex: d ? 0 : -1,
    "data-orientation": l.orientation
  }, a, {
    ref: t,
    onMouseDown: Bt(e.onMouseDown, (f) => {
      o ? l.onItemFocus(c) : f.preventDefault();
    }),
    onFocus: Bt(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: Bt(e.onKeyDown, (f) => {
      if (f.key === "Tab" && f.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (f.target !== f.currentTarget)
        return;
      const g = o_c(f, l.orientation, l.dir);
      if (g !== void 0) {
        f.preventDefault();
        let b = u().filter(
          (v) => v.focusable
        ).map(
          (v) => v.ref.current
        );
        if (g === "last")
          b.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && b.reverse();
          const v = b.indexOf(f.currentTarget);
          b = l.loop ? r_c(b, v + 1) : b.slice(v + 1);
        }
        setTimeout(
          () => Hse(b)
        );
      }
    })
  })));
}), t_c = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function n_c(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function o_c(e, t, n) {
  const o = n_c(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(o)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(o)))
    return t_c[o];
}
function Hse(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function r_c(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
const Xq = Quc, e9 = e_c;
var i_c = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Kg = /* @__PURE__ */ new WeakMap(), i2 = /* @__PURE__ */ new WeakMap(), a2 = {}, w4 = 0, t9 = function(e, t, n) {
  t === void 0 && (t = i_c(e)), n === void 0 && (n = "data-aria-hidden");
  var o = Array.isArray(e) ? e : [e];
  a2[n] || (a2[n] = /* @__PURE__ */ new WeakMap());
  var r = a2[n], i = [], a = /* @__PURE__ */ new Set(), s = function(l) {
    !l || a.has(l) || (a.add(l), s(l.parentNode));
  };
  o.forEach(s);
  var c = function(l) {
    !l || o.indexOf(l) >= 0 || Array.prototype.forEach.call(l.children, function(d) {
      if (a.has(d))
        c(d);
      else {
        var u = d.getAttribute("aria-hidden"), _ = u !== null && u !== "false", p = (Kg.get(d) || 0) + 1, f = (r.get(d) || 0) + 1;
        Kg.set(d, p), r.set(d, f), i.push(d), p === 1 && _ && i2.set(d, !0), f === 1 && d.setAttribute(n, "true"), _ || d.setAttribute("aria-hidden", "true");
      }
    });
  };
  return c(t), a.clear(), w4++, function() {
    i.forEach(function(l) {
      var d = Kg.get(l) - 1, u = r.get(l) - 1;
      Kg.set(l, d), r.set(l, u), d || (i2.has(l) || l.removeAttribute("aria-hidden"), i2.delete(l)), u || l.removeAttribute(n);
    }), w4--, w4 || (Kg = /* @__PURE__ */ new WeakMap(), Kg = /* @__PURE__ */ new WeakMap(), i2 = /* @__PURE__ */ new WeakMap(), a2 = {});
  };
}, xS = "right-scroll-bar-position", ES = "width-before-scroll-bar", a_c = "with-scroll-bars-hidden", s_c = "--removed-body-scroll-bar-size";
function k4(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function c_c(e, t) {
  var n = ze(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var IW = /* @__PURE__ */ new WeakMap();
function l_c(e, t) {
  var n = c_c(t || null, function(o) {
    return e.forEach(function(r) {
      return k4(r, o);
    });
  });
  return $e.useLayoutEffect(function() {
    var o = IW.get(n);
    if (o) {
      var r = new Set(o), i = new Set(e), a = n.current;
      r.forEach(function(s) {
        i.has(s) || k4(s, null);
      }), i.forEach(function(s) {
        r.has(s) || k4(s, a);
      });
    }
    IW.set(n, e);
  }, [e]), n;
}
function d_c(e) {
  return e;
}
function u_c(e, t) {
  t === void 0 && (t = d_c);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, o);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (o = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      o = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var c = function() {
        var d = a;
        a = [], d.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(d) {
          a.push(d), l();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return r;
}
function __c(e) {
  e === void 0 && (e = {});
  var t = u_c(null);
  return t.options = Vd({ async: !0, ssr: !1 }, e), t;
}
var Kse = function(e) {
  var t = e.sideCar, n = Jae(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return $e.createElement(o, Vd({}, n));
};
Kse.isSideCarExport = !0;
function p_c(e, t) {
  return e.useMedium(t), Kse;
}
var Yse = __c(), S4 = function() {
}, ZT = $e.forwardRef(function(e, t) {
  var n = $e.useRef(null), o = $e.useState({
    onScrollCapture: S4,
    onWheelCapture: S4,
    onTouchMoveCapture: S4
  }), r = o[0], i = o[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, d = e.enabled, u = e.shards, _ = e.sideCar, p = e.noIsolation, f = e.inert, g = e.allowPinchZoom, h = e.as, b = h === void 0 ? "div" : h, v = Jae(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), $ = _, k = l_c([n, t]), S = Vd(Vd({}, v), r);
  return $e.createElement(
    $e.Fragment,
    null,
    d && $e.createElement($, { sideCar: Yse, removeScrollBar: l, shards: u, noIsolation: p, inert: f, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    a ? $e.cloneElement($e.Children.only(s), Vd(Vd({}, S), { ref: k })) : $e.createElement(b, Vd({}, S, { className: c, ref: k }), s)
  );
});
ZT.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ZT.classNames = {
  fullWidth: ES,
  zeroRight: xS
};
var RW, m_c = function() {
  if (RW)
    return RW;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function f_c() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = m_c();
  return t && e.setAttribute("nonce", t), e;
}
function g_c(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function h_c(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var v_c = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = f_c()) && (g_c(t, n), h_c(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, b_c = function() {
  var e = v_c();
  return function(t, n) {
    $e.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Zse = function() {
  var e = b_c(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, y_c = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, x4 = function(e) {
  return parseInt(e || "", 10) || 0;
}, $_c = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [x4(n), x4(o), x4(r)];
}, w_c = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return y_c;
  var t = $_c(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, k_c = Zse(), S_c = function(e, t, n, o) {
  var r = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(a_c, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(xS, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ES, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(xS, " .").concat(xS, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ES, " .").concat(ES, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body {
    `).concat(s_c, ": ").concat(s, `px;
  }
`);
}, x_c = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o, i = $e.useMemo(function() {
    return w_c(r);
  }, [r]);
  return $e.createElement(k_c, { styles: S_c(i, !t, r, n ? "" : "!important") });
}, aD = !1;
if (typeof window < "u")
  try {
    var s2 = Object.defineProperty({}, "passive", {
      get: function() {
        return aD = !0, !0;
      }
    });
    window.addEventListener("test", s2, s2), window.removeEventListener("test", s2, s2);
  } catch {
    aD = !1;
  }
var Yg = aD ? { passive: !1 } : !1, E_c = function(e) {
  return e.tagName === "TEXTAREA";
}, Qse = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !E_c(e) && n[t] === "visible")
  );
}, T_c = function(e) {
  return Qse(e, "overflowY");
}, A_c = function(e) {
  return Qse(e, "overflowX");
}, NW = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = Jse(e, n);
    if (o) {
      var r = Xse(e, n), i = r[1], a = r[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, C_c = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, z_c = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Jse = function(e, t) {
  return e === "v" ? T_c(t) : A_c(t);
}, Xse = function(e, t) {
  return e === "v" ? C_c(t) : z_c(t);
}, O_c = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, P_c = function(e, t, n, o, r) {
  var i = O_c(e, window.getComputedStyle(t).direction), a = i * o, s = n.target, c = t.contains(s), l = !1, d = a > 0, u = 0, _ = 0;
  do {
    var p = Xse(e, s), f = p[0], g = p[1], h = p[2], b = g - h - i * f;
    (f || b) && Jse(e, s) && (u += b, _ += f), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && (r && u === 0 || !r && a > u) || !d && (r && _ === 0 || !r && -a > _)) && (l = !0), l;
}, c2 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, DW = function(e) {
  return [e.deltaX, e.deltaY];
}, MW = function(e) {
  return e && "current" in e ? e.current : e;
}, I_c = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, R_c = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, N_c = 0, Zg = [];
function D_c(e) {
  var t = $e.useRef([]), n = $e.useRef([0, 0]), o = $e.useRef(), r = $e.useState(N_c++)[0], i = $e.useState(function() {
    return Zse();
  })[0], a = $e.useRef(e);
  $e.useEffect(function() {
    a.current = e;
  }, [e]), $e.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = ulc([e.lockRef.current], (e.shards || []).map(MW), !0).filter(Boolean);
      return g.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = $e.useCallback(function(g, h) {
    if ("touches" in g && g.touches.length === 2)
      return !a.current.allowPinchZoom;
    var b = c2(g), v = n.current, $ = "deltaX" in g ? g.deltaX : v[0] - b[0], k = "deltaY" in g ? g.deltaY : v[1] - b[1], S, O = g.target, I = Math.abs($) > Math.abs(k) ? "h" : "v";
    if ("touches" in g && I === "h" && O.type === "range")
      return !1;
    var D = NW(I, O);
    if (!D)
      return !0;
    if (D ? S = I : (S = I === "v" ? "h" : "v", D = NW(I, O)), !D)
      return !1;
    if (!o.current && "changedTouches" in g && ($ || k) && (o.current = S), !S)
      return !0;
    var M = o.current || S;
    return P_c(M, h, g, M === "h" ? $ : k, !0);
  }, []), c = $e.useCallback(function(g) {
    var h = g;
    if (!(!Zg.length || Zg[Zg.length - 1] !== i)) {
      var b = "deltaY" in h ? DW(h) : c2(h), v = t.current.filter(function(S) {
        return S.name === h.type && S.target === h.target && I_c(S.delta, b);
      })[0];
      if (v && v.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!v) {
        var $ = (a.current.shards || []).map(MW).filter(Boolean).filter(function(S) {
          return S.contains(h.target);
        }), k = $.length > 0 ? s(h, $[0]) : !a.current.noIsolation;
        k && h.cancelable && h.preventDefault();
      }
    }
  }, []), l = $e.useCallback(function(g, h, b, v) {
    var $ = { name: g, delta: h, target: b, should: v };
    t.current.push($), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== $;
      });
    }, 1);
  }, []), d = $e.useCallback(function(g) {
    n.current = c2(g), o.current = void 0;
  }, []), u = $e.useCallback(function(g) {
    l(g.type, DW(g), g.target, s(g, e.lockRef.current));
  }, []), _ = $e.useCallback(function(g) {
    l(g.type, c2(g), g.target, s(g, e.lockRef.current));
  }, []);
  $e.useEffect(function() {
    return Zg.push(i), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: _
    }), document.addEventListener("wheel", c, Yg), document.addEventListener("touchmove", c, Yg), document.addEventListener("touchstart", d, Yg), function() {
      Zg = Zg.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", c, Yg), document.removeEventListener("touchmove", c, Yg), document.removeEventListener("touchstart", d, Yg);
    };
  }, []);
  var p = e.removeScrollBar, f = e.inert;
  return $e.createElement(
    $e.Fragment,
    null,
    f ? $e.createElement(i, { styles: R_c(r) }) : null,
    p ? $e.createElement(x_c, { gapMode: "margin" }) : null
  );
}
const M_c = p_c(Yse, D_c);
var ece = $e.forwardRef(function(e, t) {
  return $e.createElement(ZT, Vd({}, e, { ref: t, sideCar: M_c }));
});
ece.classNames = ZT.classNames;
const n9 = ece, L_c = [
  "Enter",
  " "
], q_c = [
  "ArrowDown",
  "PageUp",
  "Home"
], tce = [
  "ArrowUp",
  "PageDown",
  "End"
], j_c = [
  ...q_c,
  ...tce
], QT = "Menu", [sD, F_c, V_c] = Uq(QT), [lg, nce] = os(QT, [
  V_c,
  Kv,
  Zv
]), o9 = Kv(), oce = Zv(), [B_c, j0] = lg(QT), [U_c, r9] = lg(QT), W_c = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: i, modal: a = !0 } = e, s = o9(t), [c, l] = ze(null), d = Ue(!1), u = Ui(i), _ = Muc(r);
  return Le(() => {
    const p = () => {
      d.current = !0, document.addEventListener("pointerdown", f, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", f, {
        capture: !0,
        once: !0
      });
    }, f = () => d.current = !1;
    return document.addEventListener("keydown", p, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", p, {
        capture: !0
      }), document.removeEventListener("pointerdown", f, {
        capture: !0
      }), document.removeEventListener("pointermove", f, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ Pe(Nq, s, /* @__PURE__ */ Pe(B_c, {
    scope: t,
    open: n,
    onOpenChange: u,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ Pe(U_c, {
    scope: t,
    onClose: at(
      () => u(!1),
      [
        u
      ]
    ),
    isUsingKeyboardRef: d,
    dir: _,
    modal: a
  }, o)));
}, G_c = /* @__PURE__ */ it((e, t) => {
  const { __scopeMenu: n, ...o } = e, r = o9(n);
  return /* @__PURE__ */ Pe(Dq, We({}, r, o, {
    ref: t
  }));
}), rce = "MenuPortal", [H_c, K_c] = lg(rce, {
  forceMount: void 0
}), Y_c = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, i = j0(rce, t);
  return /* @__PURE__ */ Pe(H_c, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Pe(rs, {
    present: n || i.open
  }, /* @__PURE__ */ Pe(Lq, {
    asChild: !0,
    container: r
  }, o)));
}, Lp = "MenuContent", [Z_c, ice] = lg(Lp), Q_c = /* @__PURE__ */ it((e, t) => {
  const n = K_c(Lp, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, i = j0(Lp, e.__scopeMenu), a = r9(Lp, e.__scopeMenu);
  return /* @__PURE__ */ Pe(sD.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ Pe(rs, {
    present: o || i.open
  }, /* @__PURE__ */ Pe(sD.Slot, {
    scope: e.__scopeMenu
  }, a.modal ? /* @__PURE__ */ Pe(J_c, We({}, r, {
    ref: t
  })) : /* @__PURE__ */ Pe(X_c, We({}, r, {
    ref: t
  })))));
}), J_c = /* @__PURE__ */ it((e, t) => {
  const n = j0(Lp, e.__scopeMenu), o = Ue(null), r = or(t, o);
  return Le(() => {
    const i = o.current;
    if (i)
      return t9(i);
  }, []), /* @__PURE__ */ Pe(ace, We({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: Bt(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), X_c = /* @__PURE__ */ it((e, t) => {
  const n = j0(Lp, e.__scopeMenu);
  return /* @__PURE__ */ Pe(ace, We({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ace = /* @__PURE__ */ it((e, t) => {
  const { __scopeMenu: n, loop: o = !1, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: d, onFocusOutside: u, onInteractOutside: _, onDismiss: p, disableOutsideScroll: f, ...g } = e, h = j0(Lp, n), b = r9(Lp, n), v = o9(n), $ = oce(n), k = F_c(n), [S, O] = ze(null), I = Ue(null), D = or(t, I, h.onContentChange), M = Ue(0), N = Ue(""), C = Ue(0), P = Ue(null), x = Ue("right"), w = Ue(0), E = f ? n9 : Oi, T = f ? {
    as: Df,
    allowPinchZoom: !0
  } : void 0, z = (q) => {
    var V, F;
    const L = N.current + q, U = k().filter(
      (Z) => !Z.disabled
    ), W = document.activeElement, H = (V = U.find(
      (Z) => Z.ref.current === W
    )) === null || V === void 0 ? void 0 : V.textValue, Q = U.map(
      (Z) => Z.textValue
    ), X = ppc(Q, L, H), re = (F = U.find(
      (Z) => Z.textValue === X
    )) === null || F === void 0 ? void 0 : F.ref.current;
    (function Z(ee) {
      N.current = ee, window.clearTimeout(M.current), ee !== "" && (M.current = window.setTimeout(
        () => Z(""),
        1e3
      ));
    })(L), re && setTimeout(
      () => re.focus()
    );
  };
  Le(() => () => window.clearTimeout(M.current), []), Zq();
  const j = at((q) => {
    var V, F;
    return x.current === ((V = P.current) === null || V === void 0 ? void 0 : V.side) && fpc(q, (F = P.current) === null || F === void 0 ? void 0 : F.area);
  }, []);
  return /* @__PURE__ */ Pe(Z_c, {
    scope: n,
    searchRef: N,
    onItemEnter: at((q) => {
      j(q) && q.preventDefault();
    }, [
      j
    ]),
    onItemLeave: at((q) => {
      var V;
      j(q) || ((V = I.current) === null || V === void 0 || V.focus(), O(null));
    }, [
      j
    ]),
    onTriggerLeave: at((q) => {
      j(q) && q.preventDefault();
    }, [
      j
    ]),
    pointerGraceTimerRef: C,
    onPointerGraceIntentChange: at((q) => {
      P.current = q;
    }, [])
  }, /* @__PURE__ */ Pe(E, T, /* @__PURE__ */ Pe(Qq, {
    asChild: !0,
    trapped: r,
    onMountAutoFocus: Bt(i, (q) => {
      var V;
      q.preventDefault(), (V = I.current) === null || V === void 0 || V.focus();
    }),
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ Pe(jT, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: d,
    onFocusOutside: u,
    onInteractOutside: _,
    onDismiss: p
  }, /* @__PURE__ */ Pe(Xq, We({
    asChild: !0
  }, $, {
    dir: b.dir,
    orientation: "vertical",
    loop: o,
    currentTabStopId: S,
    onCurrentTabStopIdChange: O,
    onEntryFocus: Bt(c, (q) => {
      b.isUsingKeyboardRef.current || q.preventDefault();
    })
  }), /* @__PURE__ */ Pe(Mq, We({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": dpc(h.open),
    "data-radix-menu-content": "",
    dir: b.dir
  }, v, g, {
    ref: D,
    style: {
      outline: "none",
      ...g.style
    },
    onKeyDown: Bt(g.onKeyDown, (q) => {
      const F = q.target.closest("[data-radix-menu-content]") === q.currentTarget, L = q.ctrlKey || q.altKey || q.metaKey, U = q.key.length === 1;
      F && (q.key === "Tab" && q.preventDefault(), !L && U && z(q.key));
      const W = I.current;
      if (q.target !== W || !j_c.includes(q.key))
        return;
      q.preventDefault();
      const Q = k().filter(
        (X) => !X.disabled
      ).map(
        (X) => X.ref.current
      );
      tce.includes(q.key) && Q.reverse(), upc(Q);
    }),
    onBlur: Bt(e.onBlur, (q) => {
      q.currentTarget.contains(q.target) || (window.clearTimeout(M.current), N.current = "");
    }),
    onPointerMove: Bt(e.onPointerMove, lD((q) => {
      const V = q.target, F = w.current !== q.clientX;
      if (q.currentTarget.contains(V) && F) {
        const L = q.clientX > w.current ? "right" : "left";
        x.current = L, w.current = q.clientX;
      }
    }))
  })))))));
}), cD = "MenuItem", LW = "menu.itemSelect", i9 = /* @__PURE__ */ it((e, t) => {
  const { disabled: n = !1, onSelect: o, ...r } = e, i = Ue(null), a = r9(cD, e.__scopeMenu), s = ice(cD, e.__scopeMenu), c = or(t, i), l = Ue(!1), d = () => {
    const u = i.current;
    if (!n && u) {
      const _ = new CustomEvent(LW, {
        bubbles: !0,
        cancelable: !0
      });
      u.addEventListener(
        LW,
        (p) => o == null ? void 0 : o(p),
        {
          once: !0
        }
      ), L0(u, _), _.defaultPrevented ? l.current = !1 : a.onClose();
    }
  };
  return /* @__PURE__ */ Pe(epc, We({}, r, {
    ref: c,
    disabled: n,
    onClick: Bt(e.onClick, d),
    onPointerDown: (u) => {
      var _;
      (_ = e.onPointerDown) === null || _ === void 0 || _.call(e, u), l.current = !0;
    },
    onPointerUp: Bt(e.onPointerUp, (u) => {
      var _;
      l.current || (_ = u.currentTarget) === null || _ === void 0 || _.click();
    }),
    onKeyDown: Bt(e.onKeyDown, (u) => {
      const _ = s.searchRef.current !== "";
      n || _ && u.key === " " || L_c.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
    })
  }));
}), epc = /* @__PURE__ */ it((e, t) => {
  const { __scopeMenu: n, disabled: o = !1, textValue: r, ...i } = e, a = ice(cD, n), s = oce(n), c = Ue(null), l = or(t, c), [d, u] = ze(!1), [_, p] = ze("");
  return Le(() => {
    const f = c.current;
    if (f) {
      var g;
      p(((g = f.textContent) !== null && g !== void 0 ? g : "").trim());
    }
  }, [
    i.children
  ]), /* @__PURE__ */ Pe(sD.ItemSlot, {
    scope: n,
    disabled: o,
    textValue: r ?? _
  }, /* @__PURE__ */ Pe(e9, We({
    asChild: !0
  }, s, {
    focusable: !o
  }), /* @__PURE__ */ Pe(io.div, We({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0
  }, i, {
    ref: l,
    onPointerMove: Bt(e.onPointerMove, lD((f) => {
      o ? a.onItemLeave(f) : (a.onItemEnter(f), f.defaultPrevented || f.currentTarget.focus());
    })),
    onPointerLeave: Bt(e.onPointerLeave, lD(
      (f) => a.onItemLeave(f)
    )),
    onFocus: Bt(
      e.onFocus,
      () => u(!0)
    ),
    onBlur: Bt(
      e.onBlur,
      () => u(!1)
    )
  }))));
}), tpc = /* @__PURE__ */ it((e, t) => {
  const { checked: n = !1, onCheckedChange: o, ...r } = e;
  return /* @__PURE__ */ Pe(cce, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ Pe(i9, We({
    role: "menuitemcheckbox",
    "aria-checked": zx(n) ? "mixed" : n
  }, r, {
    ref: t,
    "data-state": a9(n),
    onSelect: Bt(
      r.onSelect,
      () => o == null ? void 0 : o(zx(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), npc = "MenuRadioGroup", [Jmd, opc] = lg(npc, {
  value: void 0,
  onValueChange: () => {
  }
}), rpc = "MenuRadioItem", ipc = /* @__PURE__ */ it((e, t) => {
  const { value: n, ...o } = e, r = opc(rpc, e.__scopeMenu), i = n === r.value;
  return /* @__PURE__ */ Pe(cce, {
    scope: e.__scopeMenu,
    checked: i
  }, /* @__PURE__ */ Pe(i9, We({
    role: "menuitemradio",
    "aria-checked": i
  }, o, {
    ref: t,
    "data-state": a9(i),
    onSelect: Bt(o.onSelect, () => {
      var a;
      return (a = r.onValueChange) === null || a === void 0 ? void 0 : a.call(r, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), sce = "MenuItemIndicator", [cce, apc] = lg(sce, {
  checked: !1
}), spc = /* @__PURE__ */ it((e, t) => {
  const { __scopeMenu: n, forceMount: o, ...r } = e, i = apc(sce, n);
  return /* @__PURE__ */ Pe(rs, {
    present: o || zx(i.checked) || i.checked === !0
  }, /* @__PURE__ */ Pe(io.span, We({}, r, {
    ref: t,
    "data-state": a9(i.checked)
  })));
}), cpc = /* @__PURE__ */ it((e, t) => {
  const { __scopeMenu: n, ...o } = e;
  return /* @__PURE__ */ Pe(io.div, We({
    role: "separator",
    "aria-orientation": "horizontal"
  }, o, {
    ref: t
  }));
}), lpc = "MenuSub";
lg(lpc);
function dpc(e) {
  return e ? "open" : "closed";
}
function zx(e) {
  return e === "indeterminate";
}
function a9(e) {
  return zx(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function upc(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function _pc(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
function ppc(e, t, n) {
  const r = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = _pc(e, Math.max(i, 0));
  r.length === 1 && (a = a.filter(
    (l) => l !== n
  ));
  const c = a.find(
    (l) => l.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function mpc(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, d = t[a].y;
    c > o != d > o && n < (l - s) * (o - c) / (d - c) + s && (r = !r);
  }
  return r;
}
function fpc(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return mpc(n, t);
}
function lD(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const gpc = W_c, hpc = G_c, vpc = Y_c, bpc = Q_c, ypc = i9, $pc = tpc, wpc = ipc, kpc = spc, Spc = cpc, lce = "DropdownMenu", [xpc, Xmd] = os(lce, [
  nce
]), z_ = nce(), [Epc, dce] = xpc(lce), Tpc = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: o, open: r, defaultOpen: i, onOpenChange: a, modal: s = !0 } = e, c = z_(t), l = Ue(null), [d = !1, u] = jc({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ Pe(Epc, {
    scope: t,
    triggerId: Cc(),
    triggerRef: l,
    contentId: Cc(),
    open: d,
    onOpenChange: u,
    onOpenToggle: at(
      () => u(
        (_) => !_
      ),
      [
        u
      ]
    ),
    modal: s
  }, /* @__PURE__ */ Pe(gpc, We({}, c, {
    open: d,
    onOpenChange: u,
    dir: o,
    modal: s
  }), n));
}, Apc = "DropdownMenuTrigger", Cpc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, i = dce(Apc, n), a = z_(n);
  return /* @__PURE__ */ Pe(hpc, We({
    asChild: !0
  }, a), /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": o ? "" : void 0,
    disabled: o
  }, r, {
    ref: Oq(t, i.triggerRef),
    onPointerDown: Bt(e.onPointerDown, (s) => {
      !o && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
    }),
    onKeyDown: Bt(e.onKeyDown, (s) => {
      o || ([
        "Enter",
        " "
      ].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), zpc = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = z_(t);
  return /* @__PURE__ */ Pe(vpc, We({}, o, n));
}, Opc = "DropdownMenuContent", Ppc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = dce(Opc, n), i = z_(n), a = Ue(!1);
  return /* @__PURE__ */ Pe(bpc, We({
    id: r.contentId,
    "aria-labelledby": r.triggerId
  }, i, o, {
    ref: t,
    onCloseAutoFocus: Bt(e.onCloseAutoFocus, (s) => {
      var c;
      a.current || (c = r.triggerRef.current) === null || c === void 0 || c.focus(), a.current = !1, s.preventDefault();
    }),
    onInteractOutside: Bt(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || l;
      (!r.modal || d) && (a.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), Ipc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = z_(n);
  return /* @__PURE__ */ Pe(ypc, We({}, r, o, {
    ref: t
  }));
}), Rpc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = z_(n);
  return /* @__PURE__ */ Pe($pc, We({}, r, o, {
    ref: t
  }));
}), Npc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = z_(n);
  return /* @__PURE__ */ Pe(wpc, We({}, r, o, {
    ref: t
  }));
}), Dpc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = z_(n);
  return /* @__PURE__ */ Pe(kpc, We({}, r, o, {
    ref: t
  }));
}), Mpc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = z_(n);
  return /* @__PURE__ */ Pe(Spc, We({}, r, o, {
    ref: t
  }));
}), Lpc = Tpc, qpc = Cpc, jpc = zpc, Fpc = Ppc, Vpc = Ipc, Bpc = Rpc, Upc = Npc, uce = Dpc, Wpc = Mpc, qW = (e) => [`get-${e}-check`], _ce = ({ onCheckError: e, calendar: t, initialData: n }) => {
  var c, l;
  const { isInit: o, accessToken: r } = po(), i = ns(), { data: a, refetch: s } = go({
    queryKey: qW(t),
    staleTime: 6e3,
    enabled: o && !!r,
    queryFn: () => He == null ? void 0 : He.get(`/calendars/${t}/check`).then(({ data: d }) => d.status === qt ? { status: qt, data: { allowConnect: !1, checked: !0 } } : (e == null || e(d), { status: Kp, data: { allowConnect: !0, checked: !0 } })).catch((d) => (e == null || e(d), { status: Kp, data: { allowConnect: !0, checked: !0 } })),
    initialData: n
  });
  return {
    allowConnect: ((c = a == null ? void 0 : a.data) == null ? void 0 : c.allowConnect) ?? !1,
    checked: ((l = a == null ? void 0 : a.data) == null ? void 0 : l.checked) ?? !1,
    refetch: () => {
      i.setQueryData(qW(t), {
        status: qt,
        data: { allowConnect: !1, checked: !1 }
      }), s();
    }
  };
}, Gpc = (e) => [`get-${e}-redirect-uri`], Hpc = (e, t, n) => {
  const o = t ? encodeURIComponent(t) : "";
  return go({
    queryKey: Gpc(e),
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => He == null ? void 0 : He.get(
      `/calendars/${e}/connect?redir=${o}&isDryRun=${n ?? ""}`
    ).then(({ data: i }) => {
      if (i.status === qt)
        return i.data.authUrl;
      if (i.status === Kp)
        throw new Error(i.error.message);
      return "";
    })
  });
}, Kpc = (e, t, n) => {
  const { refetch: o } = Hpc(e, t, n);
  return { connect: async () => {
    const i = await o();
    i.data && (window.location.href = i.data);
  } };
}, Ypc = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => {
    const { calendar: r, username: i, password: a } = o, s = {
      username: i,
      password: a
    };
    return He.post(`/calendars/${r}/credentials`, s).then((c) => c.data);
  },
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), s9 = "get-connected-calendars", Qv = (e) => {
  const { isInit: t } = po();
  return go({
    queryKey: [s9],
    queryFn: () => He.get("/calendars").then((o) => {
      var r;
      if (o.data.status === qt)
        return (r = o.data) == null ? void 0 : r.data;
      throw new Error(o.data.error.message);
    }),
    enabled: (e == null ? void 0 : e.enabled) !== void 0 ? e.enabled && t : t,
    staleTime: 5e3
  });
}, pce = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  calendar: i,
  redir: a,
  initialData: s,
  isMultiCalendar: c = !1,
  tooltip: l,
  tooltipSide: d = "bottom",
  isClickable: u,
  onSuccess: _,
  isDryRun: p
}) => {
  const { connect: f } = Kpc(i, a, p), { allowConnect: g, checked: h } = _ce({
    onCheckError: r,
    calendar: i,
    initialData: s
  }), b = !h, v = b || !g;
  let $ = e;
  return b ? $ = n : g || ($ = t), c ? /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    ut,
    {
      StartIcon: "calendar-days",
      color: "primary",
      disabled: u ? !1 : b,
      tooltip: l || /* @__PURE__ */ m(mce, { calendarInstance: i }),
      tooltipSide: d,
      tooltipOffset: 10,
      tooltipClassName: "p-0 text-inherit bg-inherit",
      className: uo("", !v && "cursor-pointer", "border-none md:rounded-md", o),
      onTouchEnd: () => {
        f(), _ == null || _();
      },
      onClick: () => {
        f(), _ == null || _();
      },
      children: $
    }
  ) }) : /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    ut,
    {
      StartIcon: "calendar-days",
      color: "primary",
      disabled: v,
      className: uo(
        "",
        v && "cursor-not-allowed",
        !v && "cursor-pointer",
        "border-none md:rounded-md",
        o
      ),
      onTouchEnd: () => {
        f(), _ == null || _();
      },
      onClick: () => f(),
      children: $
    }
  ) });
}, mce = ({
  calendarInstance: e
}) => {
  const { data: t, isLoading: n } = Qv({});
  return n ? /* @__PURE__ */ m("div", { className: "bg-subtle flex flex-col rounded-md border border-gray-300 px-4 py-2", children: "Loading..." }) : /* @__PURE__ */ m("div", { className: "bg-subtle flex flex-col rounded-md border border-gray-300", children: t == null ? void 0 : t.connectedCalendars.filter((o) => o.integration.slug === `${e}-calendar`).map((o, r, i) => {
    var a, s, c;
    return /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ Y("div", { className: "bg-transparent px-4 py-2 text-black", children: [
        (a = o.primary) == null ? void 0 : a.name,
        " - ",
        (s = o.primary) == null ? void 0 : s.email
      ] }, (c = o.primary) == null ? void 0 : c.externalId),
      i.length - 1 !== r && /* @__PURE__ */ m("hr", { className: "w-[90%] self-center" })
    ] });
  }) });
}, fce = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  redir: i,
  initialData: a,
  isMultiCalendar: s = !1,
  tooltipSide: c,
  tooltip: l,
  isClickable: d,
  isDryRun: u
}) => {
  const { t: _ } = Fe();
  return /* @__PURE__ */ m(
    pce,
    {
      label: e || _("google_connect_atom_label"),
      alreadyConnectedLabel: t || _("google_connect_atom_already_connected_label"),
      loadingLabel: n || _("google_connect_atom_loading_label"),
      calendar: vCe,
      className: o,
      onCheckError: r,
      redir: i,
      initialData: a,
      isMultiCalendar: s,
      tooltipSide: c,
      tooltip: l,
      isClickable: d,
      isDryRun: u
    }
  );
}, F0 = "use-atom-schedule", gce = (e, t) => {
  const n = "atoms/schedules", { isInit: o, accessToken: r } = po(), { isLoading: i, error: a, data: s } = go({
    queryKey: [F0, e, t],
    queryFn: () => He.get(n, {
      params: { scheduleId: e, isManagedEventType: t }
    }).then((c) => {
      var l;
      if (c.data.status === qt)
        return c.data.data;
      throw new Error((l = c.data.error) == null ? void 0 : l.message);
    }),
    enabled: o && !!r
  });
  return { isLoading: i, error: a, data: s };
}, hce = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: async ({ scheduleId: o, body: r }) => {
      const i = `atoms/schedules/${o}`;
      return (await He.patch(i, r)).data;
    },
    onSuccess: (o) => {
      o.status === qt ? (e == null || e(o), n.invalidateQueries({ queryKey: [F0] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
}, Zpc = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: (r) => {
      const { id: i } = r, a = `/${Pi.availability}/${i}`;
      return He == null ? void 0 : He.delete(a).then((s) => s.data);
    },
    onSuccess: (r) => {
      r.status === qt ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [F0] });
    }
  });
}, vce = Zpc;
var V0 = (e) => e.type === "checkbox", yh = (e) => e instanceof Date, bs = (e) => e == null;
const bce = (e) => typeof e == "object";
var Wi = (e) => !bs(e) && !Array.isArray(e) && bce(e) && !yh(e), yce = (e) => Wi(e) && e.target ? V0(e.target) ? e.target.checked : e.target.value : e, Qpc = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, $ce = (e, t) => e.has(Qpc(t)), Jv = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Xr = (e) => e === void 0, jt = (e, t, n) => {
  if (!t || !Wi(e))
    return n;
  const o = Jv(t.split(/[,[\].]+?/)).reduce((r, i) => bs(r) ? r : r[i], e);
  return Xr(o) || o === e ? Xr(e[t]) ? n : e[t] : o;
};
const Ox = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ml = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lu = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, wce = ve.createContext(null), Dn = () => ve.useContext(wce), kce = (e) => {
  const { children: t, ...n } = e;
  return ve.createElement(wce.Provider, { value: n }, t);
};
var Sce = (e, t, n, o = !0) => {
  const r = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(r, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== ml.all && (t._proxyFormState[a] = !o || ml.all), n && (n[a] = !0), e[a];
      }
    });
  return r;
}, wc = (e) => Wi(e) && !Object.keys(e).length, xce = (e, t, n, o) => {
  n(e);
  const { name: r, ...i } = e;
  return wc(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((a) => t[a] === (!o || ml.all));
}, Tc = (e) => Array.isArray(e) ? e : [e], Ece = (e, t, n) => n && t ? e === t : !e || !t || e === t || Tc(e).some((o) => o && (o.startsWith(t) || t.startsWith(o)));
function JT(e) {
  const t = ve.useRef(e);
  t.current = e, ve.useEffect(() => {
    const n = !e.disabled && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function Jpc(e) {
  const t = Dn(), { control: n = t.control, disabled: o, name: r, exact: i } = e || {}, [a, s] = ve.useState(n._formState), c = ve.useRef(!0), l = ve.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), d = ve.useRef(r);
  return d.current = r, JT({
    disabled: o,
    next: (u) => c.current && Ece(d.current, u.name, i) && xce(u, l.current, n._updateFormState) && s({
      ...n._formState,
      ...u
    }),
    subject: n._subjects.state
  }), ve.useEffect(() => {
    c.current = !0;
    const u = n._proxyFormState.isDirty && n._getDirty();
    return u !== n._formState.isDirty && n._subjects.state.next({
      isDirty: u
    }), l.current.isValid && n._updateValid(!0), () => {
      c.current = !1;
    };
  }, [n]), Sce(a, n, l.current, !1);
}
var Kd = (e) => typeof e == "string", Tce = (e, t, n, o, r) => Kd(e) ? (o && t.watch.add(e), jt(n, e, r)) : Array.isArray(e) ? e.map((i) => (o && t.watch.add(i), jt(n, i))) : (o && (t.watchAll = !0), n), Xpc = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Wi(t) && t.hasOwnProperty("isPrototypeOf");
}, c9 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function kc(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(c9 && (e instanceof Blob || e instanceof FileList)) && (n || Wi(e)))
    if (t = n ? [] : {}, !Array.isArray(e) && !Xpc(e))
      t = e;
    else
      for (const o in e)
        t[o] = kc(e[o]);
  else
    return e;
  return t;
}
function m_(e) {
  const t = Dn(), { control: n = t.control, name: o, defaultValue: r, disabled: i, exact: a } = e || {}, s = ve.useRef(o);
  s.current = o, JT({
    disabled: i,
    subject: n._subjects.values,
    next: (d) => {
      Ece(s.current, d.name, a) && l(kc(Tce(s.current, n._names, d.values || n._formValues, !1, r)));
    }
  });
  const [c, l] = ve.useState(n._getWatch(o, r));
  return ve.useEffect(() => n._removeUnmounted()), c;
}
function emc(e) {
  const t = Dn(), { name: n, control: o = t.control, shouldUnregister: r } = e, i = $ce(o._names.array, n), a = m_({
    control: o,
    name: n,
    defaultValue: jt(o._formValues, n, jt(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), s = Jpc({
    control: o,
    name: n
  }), c = ve.useRef(o.register(n, {
    ...e.rules,
    value: a
  }));
  return ve.useEffect(() => {
    const l = (d, u) => {
      const _ = jt(o._fields, d);
      _ && (_._f.mount = u);
    };
    return l(n, !0), () => {
      const d = o._options.shouldUnregister || r;
      (i ? d && !o._stateFlags.action : d) ? o.unregister(n) : l(n, !1);
    };
  }, [n, o, i, r]), {
    field: {
      name: n,
      value: a,
      onChange: ve.useCallback((l) => c.current.onChange({
        target: {
          value: yce(l),
          name: n
        },
        type: Ox.CHANGE
      }), [n]),
      onBlur: ve.useCallback(() => c.current.onBlur({
        target: {
          value: jt(o._formValues, n),
          name: n
        },
        type: Ox.BLUR
      }), [n, o]),
      ref: (l) => {
        const d = jt(o._fields, n);
        d && l && (d._f.ref = {
          focus: () => l.focus(),
          select: () => l.select(),
          setCustomValidity: (u) => l.setCustomValidity(u),
          reportValidity: () => l.reportValidity()
        });
      }
    },
    formState: s,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!jt(s.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!jt(s.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!jt(s.touchedFields, n)
      },
      error: {
        enumerable: !0,
        get: () => jt(s.errors, n)
      }
    })
  };
}
const Wt = (e) => e.render(emc(e));
var Ace = (e, t, n, o, r) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [o]: r || !0
  }
} : {}, l9 = (e) => /^\w*$/.test(e), Cce = (e) => Jv(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function jr(e, t, n) {
  let o = -1;
  const r = l9(t) ? [t] : Cce(t), i = r.length, a = i - 1;
  for (; ++o < i; ) {
    const s = r[o];
    let c = n;
    if (o !== a) {
      const l = e[s];
      c = Wi(l) || Array.isArray(l) ? l : isNaN(+r[o + 1]) ? {} : [];
    }
    e[s] = c, e = e[s];
  }
  return e;
}
const Px = (e, t, n) => {
  for (const o of n || Object.keys(e)) {
    const r = jt(e, o);
    if (r) {
      const { _f: i, ...a } = r;
      if (i && t(i.name)) {
        if (i.ref.focus) {
          i.ref.focus();
          break;
        } else if (i.refs && i.refs[0].focus) {
          i.refs[0].focus();
          break;
        }
      } else
        Wi(a) && Px(a, t);
    }
  }
};
var ip = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, E4 = (e, t, n = {}) => n.shouldFocus || Xr(n.shouldFocus) ? n.focusName || `${e}.${Xr(n.focusIndex) ? t : n.focusIndex}.` : "", dD = (e) => ({
  isOnSubmit: !e || e === ml.onSubmit,
  isOnBlur: e === ml.onBlur,
  isOnChange: e === ml.onChange,
  isOnAll: e === ml.all,
  isOnTouch: e === ml.onTouched
}), uD = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((o) => e.startsWith(o) && /^\.\w+/.test(e.slice(o.length)))), zce = (e, t, n) => {
  const o = Jv(jt(e, n));
  return jr(o, "root", t[n]), jr(e, n, o), e;
}, Rh = (e) => typeof e == "boolean", d9 = (e) => e.type === "file", Nh = (e) => typeof e == "function", Ix = (e) => {
  if (!c9)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, TS = (e) => Kd(e), u9 = (e) => e.type === "radio", Rx = (e) => e instanceof RegExp;
const jW = {
  value: !1,
  isValid: !1
}, FW = { value: !0, isValid: !0 };
var Oce = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Xr(e[0].attributes.value) ? Xr(e[0].value) || e[0].value === "" ? FW : { value: e[0].value, isValid: !0 } : FW
    ) : jW;
  }
  return jW;
};
const VW = {
  isValid: !1,
  value: null
};
var Pce = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, VW) : VW;
function BW(e, t, n = "validate") {
  if (TS(e) || Array.isArray(e) && e.every(TS) || Rh(e) && !e)
    return {
      type: n,
      message: TS(e) ? e : "",
      ref: t
    };
}
var Qg = (e) => Wi(e) && !Rx(e) ? e : {
  value: e,
  message: ""
}, _D = async (e, t, n, o, r) => {
  const { ref: i, refs: a, required: s, maxLength: c, minLength: l, min: d, max: u, pattern: _, validate: p, name: f, valueAsNumber: g, mount: h, disabled: b } = e._f, v = jt(t, f);
  if (!h || b)
    return {};
  const $ = a ? a[0] : i, k = (P) => {
    o && $.reportValidity && ($.setCustomValidity(Rh(P) ? "" : P || ""), $.reportValidity());
  }, S = {}, O = u9(i), I = V0(i), D = O || I, M = (g || d9(i)) && Xr(i.value) && Xr(v) || Ix(i) && i.value === "" || v === "" || Array.isArray(v) && !v.length, N = Ace.bind(null, f, n, S), C = (P, x, w, E = Lu.maxLength, T = Lu.minLength) => {
    const z = P ? x : w;
    S[f] = {
      type: P ? E : T,
      message: z,
      ref: i,
      ...N(P ? E : T, z)
    };
  };
  if (r ? !Array.isArray(v) || !v.length : s && (!D && (M || bs(v)) || Rh(v) && !v || I && !Oce(a).isValid || O && !Pce(a).isValid)) {
    const { value: P, message: x } = TS(s) ? { value: !!s, message: s } : Qg(s);
    if (P && (S[f] = {
      type: Lu.required,
      message: x,
      ref: $,
      ...N(Lu.required, x)
    }, !n))
      return k(x), S;
  }
  if (!M && (!bs(d) || !bs(u))) {
    let P, x;
    const w = Qg(u), E = Qg(d);
    if (!bs(v) && !isNaN(v)) {
      const T = i.valueAsNumber || v && +v;
      bs(w.value) || (P = T > w.value), bs(E.value) || (x = T < E.value);
    } else {
      const T = i.valueAsDate || new Date(v), z = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), j = i.type == "time", q = i.type == "week";
      Kd(w.value) && v && (P = j ? z(v) > z(w.value) : q ? v > w.value : T > new Date(w.value)), Kd(E.value) && v && (x = j ? z(v) < z(E.value) : q ? v < E.value : T < new Date(E.value));
    }
    if ((P || x) && (C(!!P, w.message, E.message, Lu.max, Lu.min), !n))
      return k(S[f].message), S;
  }
  if ((c || l) && !M && (Kd(v) || r && Array.isArray(v))) {
    const P = Qg(c), x = Qg(l), w = !bs(P.value) && v.length > P.value, E = !bs(x.value) && v.length < x.value;
    if ((w || E) && (C(w, P.message, x.message), !n))
      return k(S[f].message), S;
  }
  if (_ && !M && Kd(v)) {
    const { value: P, message: x } = Qg(_);
    if (Rx(P) && !v.match(P) && (S[f] = {
      type: Lu.pattern,
      message: x,
      ref: i,
      ...N(Lu.pattern, x)
    }, !n))
      return k(x), S;
  }
  if (p) {
    if (Nh(p)) {
      const P = await p(v, t), x = BW(P, $);
      if (x && (S[f] = {
        ...x,
        ...N(Lu.validate, x.message)
      }, !n))
        return k(x.message), S;
    } else if (Wi(p)) {
      let P = {};
      for (const x in p) {
        if (!wc(P) && !n)
          break;
        const w = BW(await p[x](v, t), $, x);
        w && (P = {
          ...w,
          ...N(x, w.message)
        }, k(w.message), n && (S[f] = P));
      }
      if (!wc(P) && (S[f] = {
        ref: $,
        ...P
      }, !n))
        return S;
    }
  }
  return k(!0), S;
};
function T4(e, t) {
  return [...e, ...Tc(t)];
}
var A4 = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function C4(e, t, n) {
  return [
    ...e.slice(0, t),
    ...Tc(n),
    ...e.slice(t)
  ];
}
var z4 = (e, t, n) => Array.isArray(e) ? (Xr(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [];
function O4(e, t) {
  return [...Tc(t), ...Tc(e)];
}
function tmc(e, t) {
  let n = 0;
  const o = [...e];
  for (const r of t)
    o.splice(r - n, 1), n++;
  return Jv(o).length ? o : [];
}
var P4 = (e, t) => Xr(t) ? [] : tmc(e, Tc(t).sort((n, o) => n - o)), I4 = (e, t, n) => {
  e[t] = [e[n], e[n] = e[t]][0];
};
function nmc(e, t) {
  const n = t.slice(0, -1).length;
  let o = 0;
  for (; o < n; )
    e = Xr(e) ? o++ : e[t[o++]];
  return e;
}
function omc(e) {
  for (const t in e)
    if (!Xr(e[t]))
      return !1;
  return !0;
}
function Ji(e, t) {
  const n = Array.isArray(t) ? t : l9(t) ? [t] : Cce(t), o = n.length === 1 ? e : nmc(e, n), r = n.length - 1, i = n[r];
  return o && delete o[i], r !== 0 && (Wi(o) && wc(o) || Array.isArray(o) && omc(o)) && Ji(e, n.slice(0, -1)), e;
}
var UW = (e, t, n) => (e[t] = n, e);
function B0(e) {
  const t = Dn(), { control: n = t.control, name: o, keyName: r = "id", shouldUnregister: i } = e, [a, s] = ve.useState(n._getFieldArray(o)), c = ve.useRef(n._getFieldArray(o).map(ip)), l = ve.useRef(a), d = ve.useRef(o), u = ve.useRef(!1);
  d.current = o, l.current = a, n._names.array.add(o), e.rules && n.register(o, e.rules), JT({
    next: ({ values: S, name: O }) => {
      if (O === d.current || !O) {
        const I = jt(S, d.current);
        Array.isArray(I) && (s(I), c.current = I.map(ip));
      }
    },
    subject: n._subjects.array
  });
  const _ = ve.useCallback((S) => {
    u.current = !0, n._updateFieldArray(o, S);
  }, [n, o]), p = (S, O) => {
    const I = Tc(kc(S)), D = T4(n._getFieldArray(o), I);
    n._names.focus = E4(o, D.length - 1, O), c.current = T4(c.current, I.map(ip)), _(D), s(D), n._updateFieldArray(o, D, T4, {
      argA: A4(S)
    });
  }, f = (S, O) => {
    const I = Tc(kc(S)), D = O4(n._getFieldArray(o), I);
    n._names.focus = E4(o, 0, O), c.current = O4(c.current, I.map(ip)), _(D), s(D), n._updateFieldArray(o, D, O4, {
      argA: A4(S)
    });
  }, g = (S) => {
    const O = P4(n._getFieldArray(o), S);
    c.current = P4(c.current, S), _(O), s(O), n._updateFieldArray(o, O, P4, {
      argA: S
    });
  }, h = (S, O, I) => {
    const D = Tc(kc(O)), M = C4(n._getFieldArray(o), S, D);
    n._names.focus = E4(o, S, I), c.current = C4(c.current, S, D.map(ip)), _(M), s(M), n._updateFieldArray(o, M, C4, {
      argA: S,
      argB: A4(O)
    });
  }, b = (S, O) => {
    const I = n._getFieldArray(o);
    I4(I, S, O), I4(c.current, S, O), _(I), s(I), n._updateFieldArray(o, I, I4, {
      argA: S,
      argB: O
    }, !1);
  }, v = (S, O) => {
    const I = n._getFieldArray(o);
    z4(I, S, O), z4(c.current, S, O), _(I), s(I), n._updateFieldArray(o, I, z4, {
      argA: S,
      argB: O
    }, !1);
  }, $ = (S, O) => {
    const I = kc(O), D = UW(n._getFieldArray(o), S, I);
    c.current = [...D].map((M, N) => !M || N === S ? ip() : c.current[N]), _(D), s([...D]), n._updateFieldArray(o, D, UW, {
      argA: S,
      argB: I
    }, !0, !1);
  }, k = (S) => {
    const O = Tc(kc(S));
    c.current = O.map(ip), _([...O]), s([...O]), n._updateFieldArray(o, [...O], (I) => I, {}, !0, !1);
  };
  return ve.useEffect(() => {
    if (n._stateFlags.action = !1, uD(o, n._names) && n._subjects.state.next({
      ...n._formState
    }), u.current && (!dD(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([o]).then((S) => {
          const O = jt(S.errors, o), I = jt(n._formState.errors, o);
          (I ? !O && I.type : O && O.type) && (O ? jr(n._formState.errors, o, O) : Ji(n._formState.errors, o), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const S = jt(n._fields, o);
        S && S._f && _D(S, n._formValues, n._options.criteriaMode === ml.all, n._options.shouldUseNativeValidation, !0).then((O) => !wc(O) && n._subjects.state.next({
          errors: zce(n._formState.errors, O, o)
        }));
      }
    n._subjects.values.next({
      name: o,
      values: n._formValues
    }), n._names.focus && Px(n._fields, (S) => !!S && S.startsWith(n._names.focus || "")), n._names.focus = "", n._updateValid();
  }, [a, o, n]), ve.useEffect(() => (!jt(n._formValues, o) && n._updateFieldArray(o), () => {
    (n._options.shouldUnregister || i) && n.unregister(o);
  }), [o, n, r, i]), {
    swap: ve.useCallback(b, [_, o, n]),
    move: ve.useCallback(v, [_, o, n]),
    prepend: ve.useCallback(f, [_, o, n]),
    append: ve.useCallback(p, [_, o, n]),
    remove: ve.useCallback(g, [_, o, n]),
    insert: ve.useCallback(h, [_, o, n]),
    update: ve.useCallback($, [_, o, n]),
    replace: ve.useCallback(k, [_, o, n]),
    fields: ve.useMemo(() => a.map((S, O) => ({
      ...S,
      [r]: c.current[O] || ip()
    })), [a, r])
  };
}
function R4() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (r) => {
      let i = 0;
      const a = e.length;
      for (; i < a; )
        e[i].next(r), ++i;
    },
    subscribe: (r) => (e.push(r), {
      unsubscribe: () => {
        e = e.filter((i) => i !== r);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var Nx = (e) => bs(e) || !bce(e);
function sf(e, t) {
  if (Nx(e) || Nx(t))
    return e === t;
  if (yh(e) && yh(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), o = Object.keys(t);
  if (n.length !== o.length)
    return !1;
  for (const r of n) {
    const i = e[r];
    if (!o.includes(r))
      return !1;
    if (r !== "ref") {
      const a = t[r];
      if (yh(i) && yh(a) || Wi(i) && Wi(a) || Array.isArray(i) && Array.isArray(a) ? !sf(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var Ice = (e) => e.type === "select-multiple", rmc = (e) => u9(e) || V0(e), N4 = (e) => Ix(e) && e.isConnected, Rce = (e) => {
  for (const t in e)
    if (Nh(e[t]))
      return !0;
  return !1;
};
function Dx(e, t = {}) {
  const n = Array.isArray(e);
  if (Wi(e) || n)
    for (const o in e)
      Array.isArray(e[o]) || Wi(e[o]) && !Rce(e[o]) ? (t[o] = Array.isArray(e[o]) ? [] : {}, Dx(e[o], t[o])) : bs(e[o]) || (t[o] = !0);
  return t;
}
function Nce(e, t, n) {
  const o = Array.isArray(e);
  if (Wi(e) || o)
    for (const r in e)
      Array.isArray(e[r]) || Wi(e[r]) && !Rce(e[r]) ? Xr(t) || Nx(n[r]) ? n[r] = Array.isArray(e[r]) ? Dx(e[r], []) : { ...Dx(e[r]) } : Nce(e[r], bs(t) ? {} : t[r], n[r]) : n[r] = !sf(e[r], t[r]);
  return n;
}
var D4 = (e, t) => Nce(e, t, Dx(t)), Dce = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: o }) => Xr(e) ? e : t ? e === "" ? NaN : e && +e : n && Kd(e) ? new Date(e) : o ? o(e) : e;
function M4(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return d9(t) ? t.files : u9(t) ? Pce(e.refs).value : Ice(t) ? [...t.selectedOptions].map(({ value: n }) => n) : V0(t) ? Oce(e.refs).value : Dce(Xr(t.value) ? e.ref.value : t.value, e);
}
var imc = (e, t, n, o) => {
  const r = {};
  for (const i of e) {
    const a = jt(t, i);
    a && jr(r, i, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: r,
    shouldUseNativeValidation: o
  };
}, Sy = (e) => Xr(e) ? e : Rx(e) ? e.source : Wi(e) ? Rx(e.value) ? e.value.source : e.value : e, amc = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function WW(e, t, n) {
  const o = jt(e, n);
  if (o || l9(n))
    return {
      error: o,
      name: n
    };
  const r = n.split(".");
  for (; r.length; ) {
    const i = r.join("."), a = jt(t, i), s = jt(e, i);
    if (a && !Array.isArray(a) && n !== i)
      return { name: n };
    if (s && s.type)
      return {
        name: i,
        error: s
      };
    r.pop();
  }
  return {
    name: n
  };
}
var smc = (e, t, n, o, r) => r.isOnAll ? !1 : !n && r.isOnTouch ? !(t || e) : (n ? o.isOnBlur : r.isOnBlur) ? !e : (n ? o.isOnChange : r.isOnChange) ? e : !0, cmc = (e, t) => !Jv(jt(e, t)).length && Ji(e, t);
const lmc = {
  mode: ml.onSubmit,
  reValidateMode: ml.onChange,
  shouldFocusError: !0
};
function dmc(e = {}, t) {
  let n = {
    ...lmc,
    ...e
  }, o = {
    submitCount: 0,
    isDirty: !1,
    isLoading: !0,
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, r = {}, i = Wi(n.defaultValues) || Wi(n.values) ? kc(n.defaultValues || n.values) || {} : {}, a = n.shouldUnregister ? {} : kc(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, c = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, d = 0;
  const u = e.resetOptions && e.resetOptions.keepDirtyValues, _ = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, p = {
    values: R4(),
    array: R4(),
    state: R4()
  }, f = dD(n.mode), g = dD(n.reValidateMode), h = n.criteriaMode === ml.all, b = (te) => (ue) => {
    clearTimeout(d), d = setTimeout(te, ue);
  }, v = async (te) => {
    if (_.isValid || te) {
      const ue = n.resolver ? wc((await M()).errors) : await C(r, !0);
      ue !== o.isValid && p.state.next({
        isValid: ue
      });
    }
  }, $ = (te) => _.isValidating && p.state.next({
    isValidating: te
  }), k = (te, ue = [], le, se, me = !0, pe = !0) => {
    if (se && le) {
      if (s.action = !0, pe && Array.isArray(jt(r, te))) {
        const be = le(jt(r, te), se.argA, se.argB);
        me && jr(r, te, be);
      }
      if (pe && Array.isArray(jt(o.errors, te))) {
        const be = le(jt(o.errors, te), se.argA, se.argB);
        me && jr(o.errors, te, be), cmc(o.errors, te);
      }
      if (_.touchedFields && pe && Array.isArray(jt(o.touchedFields, te))) {
        const be = le(jt(o.touchedFields, te), se.argA, se.argB);
        me && jr(o.touchedFields, te, be);
      }
      _.dirtyFields && (o.dirtyFields = D4(i, a)), p.state.next({
        name: te,
        isDirty: x(te, ue),
        dirtyFields: o.dirtyFields,
        errors: o.errors,
        isValid: o.isValid
      });
    } else
      jr(a, te, ue);
  }, S = (te, ue) => {
    jr(o.errors, te, ue), p.state.next({
      errors: o.errors
    });
  }, O = (te, ue, le, se) => {
    const me = jt(r, te);
    if (me) {
      const pe = jt(a, te, Xr(le) ? jt(i, te) : le);
      Xr(pe) || se && se.defaultChecked || ue ? jr(a, te, ue ? pe : M4(me._f)) : T(te, pe), s.mount && v();
    }
  }, I = (te, ue, le, se, me) => {
    let pe = !1, be = !1;
    const Se = {
      name: te
    };
    if (!le || se) {
      _.isDirty && (be = o.isDirty, o.isDirty = Se.isDirty = x(), pe = be !== Se.isDirty);
      const Ae = sf(jt(i, te), ue);
      be = jt(o.dirtyFields, te), Ae ? Ji(o.dirtyFields, te) : jr(o.dirtyFields, te, !0), Se.dirtyFields = o.dirtyFields, pe = pe || _.dirtyFields && be !== !Ae;
    }
    if (le) {
      const Ae = jt(o.touchedFields, te);
      Ae || (jr(o.touchedFields, te, le), Se.touchedFields = o.touchedFields, pe = pe || _.touchedFields && Ae !== le);
    }
    return pe && me && p.state.next(Se), pe ? Se : {};
  }, D = (te, ue, le, se) => {
    const me = jt(o.errors, te), pe = _.isValid && Rh(ue) && o.isValid !== ue;
    if (e.delayError && le ? (l = b(() => S(te, le)), l(e.delayError)) : (clearTimeout(d), l = null, le ? jr(o.errors, te, le) : Ji(o.errors, te)), (le ? !sf(me, le) : me) || !wc(se) || pe) {
      const be = {
        ...se,
        ...pe && Rh(ue) ? { isValid: ue } : {},
        errors: o.errors,
        name: te
      };
      o = {
        ...o,
        ...be
      }, p.state.next(be);
    }
    $(!1);
  }, M = async (te) => await n.resolver(a, n.context, imc(te || c.mount, r, n.criteriaMode, n.shouldUseNativeValidation)), N = async (te) => {
    const { errors: ue } = await M();
    if (te)
      for (const le of te) {
        const se = jt(ue, le);
        se ? jr(o.errors, le, se) : Ji(o.errors, le);
      }
    else
      o.errors = ue;
    return ue;
  }, C = async (te, ue, le = {
    valid: !0
  }) => {
    for (const se in te) {
      const me = te[se];
      if (me) {
        const { _f: pe, ...be } = me;
        if (pe) {
          const Se = c.array.has(pe.name), Ae = await _D(me, a, h, n.shouldUseNativeValidation, Se);
          if (Ae[pe.name] && (le.valid = !1, ue))
            break;
          !ue && (jt(Ae, pe.name) ? Se ? zce(o.errors, Ae, pe.name) : jr(o.errors, pe.name, Ae[pe.name]) : Ji(o.errors, pe.name));
        }
        be && await C(be, ue, le);
      }
    }
    return le.valid;
  }, P = () => {
    for (const te of c.unMount) {
      const ue = jt(r, te);
      ue && (ue._f.refs ? ue._f.refs.every((le) => !N4(le)) : !N4(ue._f.ref)) && Q(te);
    }
    c.unMount = /* @__PURE__ */ new Set();
  }, x = (te, ue) => (te && ue && jr(a, te, ue), !sf(F(), i)), w = (te, ue, le) => Tce(te, c, {
    ...s.mount ? a : Xr(ue) ? i : Kd(te) ? { [te]: ue } : ue
  }, le, ue), E = (te) => Jv(jt(s.mount ? a : i, te, e.shouldUnregister ? jt(i, te, []) : [])), T = (te, ue, le = {}) => {
    const se = jt(r, te);
    let me = ue;
    if (se) {
      const pe = se._f;
      pe && (!pe.disabled && jr(a, te, Dce(ue, pe)), me = Ix(pe.ref) && bs(ue) ? "" : ue, Ice(pe.ref) ? [...pe.ref.options].forEach((be) => be.selected = me.includes(be.value)) : pe.refs ? V0(pe.ref) ? pe.refs.length > 1 ? pe.refs.forEach((be) => (!be.defaultChecked || !be.disabled) && (be.checked = Array.isArray(me) ? !!me.find((Se) => Se === be.value) : me === be.value)) : pe.refs[0] && (pe.refs[0].checked = !!me) : pe.refs.forEach((be) => be.checked = be.value === me) : d9(pe.ref) ? pe.ref.value = "" : (pe.ref.value = me, pe.ref.type || p.values.next({
        name: te,
        values: { ...a }
      })));
    }
    (le.shouldDirty || le.shouldTouch) && I(te, me, le.shouldTouch, le.shouldDirty, !0), le.shouldValidate && V(te);
  }, z = (te, ue, le) => {
    for (const se in ue) {
      const me = ue[se], pe = `${te}.${se}`, be = jt(r, pe);
      (c.array.has(te) || !Nx(me) || be && !be._f) && !yh(me) ? z(pe, me, le) : T(pe, me, le);
    }
  }, j = (te, ue, le = {}) => {
    const se = jt(r, te), me = c.array.has(te), pe = kc(ue);
    jr(a, te, pe), me ? (p.array.next({
      name: te,
      values: { ...a }
    }), (_.isDirty || _.dirtyFields) && le.shouldDirty && p.state.next({
      name: te,
      dirtyFields: D4(i, a),
      isDirty: x(te, pe)
    })) : se && !se._f && !bs(pe) ? z(te, pe, le) : T(te, pe, le), uD(te, c) && p.state.next({ ...o }), p.values.next({
      name: te,
      values: { ...a }
    }), !s.mount && t();
  }, q = async (te) => {
    const ue = te.target;
    let le = ue.name;
    const se = jt(r, le), me = () => ue.type ? M4(se._f) : yce(te);
    if (se) {
      let pe, be;
      const Se = me(), Ae = te.type === Ox.BLUR || te.type === Ox.FOCUS_OUT, Ze = !amc(se._f) && !n.resolver && !jt(o.errors, le) && !se._f.deps || smc(Ae, jt(o.touchedFields, le), o.isSubmitted, g, f), Ge = uD(le, c, Ae);
      jr(a, le, Se), Ae ? (se._f.onBlur && se._f.onBlur(te), l && l(0)) : se._f.onChange && se._f.onChange(te);
      const rt = I(le, Se, Ae, !1), qe = !wc(rt) || Ge;
      if (!Ae && p.values.next({
        name: le,
        type: te.type,
        values: { ...a }
      }), Ze)
        return _.isValid && v(), qe && p.state.next({ name: le, ...Ge ? {} : rt });
      if (!Ae && Ge && p.state.next({ ...o }), $(!0), n.resolver) {
        const { errors: Xe } = await M([le]), lt = WW(o.errors, r, le), Et = WW(Xe, r, lt.name || le);
        pe = Et.error, le = Et.name, be = wc(Xe);
      } else
        pe = (await _D(se, a, h, n.shouldUseNativeValidation))[le], pe ? be = !1 : _.isValid && (be = await C(r, !0));
      se._f.deps && V(se._f.deps), D(le, be, pe, rt);
    }
  }, V = async (te, ue = {}) => {
    let le, se;
    const me = Tc(te);
    if ($(!0), n.resolver) {
      const pe = await N(Xr(te) ? te : me);
      le = wc(pe), se = te ? !me.some((be) => jt(pe, be)) : le;
    } else
      te ? (se = (await Promise.all(me.map(async (pe) => {
        const be = jt(r, pe);
        return await C(be && be._f ? { [pe]: be } : be);
      }))).every(Boolean), !(!se && !o.isValid) && v()) : se = le = await C(r);
    return p.state.next({
      ...!Kd(te) || _.isValid && le !== o.isValid ? {} : { name: te },
      ...n.resolver || !te ? { isValid: le } : {},
      errors: o.errors,
      isValidating: !1
    }), ue.shouldFocus && !se && Px(r, (pe) => pe && jt(o.errors, pe), te ? me : c.mount), se;
  }, F = (te) => {
    const ue = {
      ...i,
      ...s.mount ? a : {}
    };
    return Xr(te) ? ue : Kd(te) ? jt(ue, te) : te.map((le) => jt(ue, le));
  }, L = (te, ue) => ({
    invalid: !!jt((ue || o).errors, te),
    isDirty: !!jt((ue || o).dirtyFields, te),
    isTouched: !!jt((ue || o).touchedFields, te),
    error: jt((ue || o).errors, te)
  }), U = (te) => {
    te && Tc(te).forEach((ue) => Ji(o.errors, ue)), p.state.next({
      errors: te ? o.errors : {}
    });
  }, W = (te, ue, le) => {
    const se = (jt(r, te, { _f: {} })._f || {}).ref;
    jr(o.errors, te, {
      ...ue,
      ref: se
    }), p.state.next({
      name: te,
      errors: o.errors,
      isValid: !1
    }), le && le.shouldFocus && se && se.focus && se.focus();
  }, H = (te, ue) => Nh(te) ? p.values.subscribe({
    next: (le) => te(w(void 0, ue), le)
  }) : w(te, ue, !0), Q = (te, ue = {}) => {
    for (const le of te ? Tc(te) : c.mount)
      c.mount.delete(le), c.array.delete(le), jt(r, le) && (ue.keepValue || (Ji(r, le), Ji(a, le)), !ue.keepError && Ji(o.errors, le), !ue.keepDirty && Ji(o.dirtyFields, le), !ue.keepTouched && Ji(o.touchedFields, le), !n.shouldUnregister && !ue.keepDefaultValue && Ji(i, le));
    p.values.next({
      values: { ...a }
    }), p.state.next({
      ...o,
      ...ue.keepDirty ? { isDirty: x() } : {}
    }), !ue.keepIsValid && v();
  }, X = (te, ue = {}) => {
    let le = jt(r, te);
    const se = Rh(ue.disabled);
    return jr(r, te, {
      ...le || {},
      _f: {
        ...le && le._f ? le._f : { ref: { name: te } },
        name: te,
        mount: !0,
        ...ue
      }
    }), c.mount.add(te), le ? se && jr(a, te, ue.disabled ? void 0 : jt(a, te, M4(le._f))) : O(te, !0, ue.value), {
      ...se ? { disabled: ue.disabled } : {},
      ...n.shouldUseNativeValidation ? {
        required: !!ue.required,
        min: Sy(ue.min),
        max: Sy(ue.max),
        minLength: Sy(ue.minLength),
        maxLength: Sy(ue.maxLength),
        pattern: Sy(ue.pattern)
      } : {},
      name: te,
      onChange: q,
      onBlur: q,
      ref: (me) => {
        if (me) {
          X(te, ue), le = jt(r, te);
          const pe = Xr(me.value) && me.querySelectorAll && me.querySelectorAll("input,select,textarea")[0] || me, be = rmc(pe), Se = le._f.refs || [];
          if (be ? Se.find((Ae) => Ae === pe) : pe === le._f.ref)
            return;
          jr(r, te, {
            _f: {
              ...le._f,
              ...be ? {
                refs: [
                  ...Se.filter(N4),
                  pe,
                  ...Array.isArray(jt(i, te)) ? [{}] : []
                ],
                ref: { type: pe.type, name: te }
              } : { ref: pe }
            }
          }), O(te, !1, void 0, pe);
        } else
          le = jt(r, te, {}), le._f && (le._f.mount = !1), (n.shouldUnregister || ue.shouldUnregister) && !($ce(c.array, te) && s.action) && c.unMount.add(te);
      }
    };
  }, re = () => n.shouldFocusError && Px(r, (te) => te && jt(o.errors, te), c.mount), Z = (te, ue) => async (le) => {
    le && (le.preventDefault && le.preventDefault(), le.persist && le.persist());
    let se = kc(a);
    if (p.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: me, values: pe } = await M();
      o.errors = me, se = pe;
    } else
      await C(r);
    Ji(o.errors, "root"), wc(o.errors) ? (p.state.next({
      errors: {}
    }), await te(se, le)) : (ue && await ue({ ...o.errors }, le), re(), setTimeout(re)), p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: wc(o.errors),
      submitCount: o.submitCount + 1,
      errors: o.errors
    });
  }, ee = (te, ue = {}) => {
    jt(r, te) && (Xr(ue.defaultValue) ? j(te, jt(i, te)) : (j(te, ue.defaultValue), jr(i, te, ue.defaultValue)), ue.keepTouched || Ji(o.touchedFields, te), ue.keepDirty || (Ji(o.dirtyFields, te), o.isDirty = ue.defaultValue ? x(te, jt(i, te)) : x()), ue.keepError || (Ji(o.errors, te), _.isValid && v()), p.state.next({ ...o }));
  }, J = (te, ue = {}) => {
    const le = te || i, se = kc(le), me = te && !wc(te) ? se : i;
    if (ue.keepDefaultValues || (i = le), !ue.keepValues) {
      if (ue.keepDirtyValues || u)
        for (const pe of c.mount)
          jt(o.dirtyFields, pe) ? jr(me, pe, jt(a, pe)) : j(pe, jt(me, pe));
      else {
        if (c9 && Xr(te))
          for (const pe of c.mount) {
            const be = jt(r, pe);
            if (be && be._f) {
              const Se = Array.isArray(be._f.refs) ? be._f.refs[0] : be._f.ref;
              if (Ix(Se)) {
                const Ae = Se.closest("form");
                if (Ae) {
                  Ae.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      a = e.shouldUnregister ? ue.keepDefaultValues ? kc(i) : {} : se, p.array.next({
        values: me
      }), p.values.next({
        values: me
      });
    }
    c = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !s.mount && t(), s.mount = !_.isValid || !!ue.keepIsValid, s.watch = !!e.shouldUnregister, p.state.next({
      submitCount: ue.keepSubmitCount ? o.submitCount : 0,
      isDirty: ue.keepDirty ? o.isDirty : !!(ue.keepDefaultValues && !sf(te, i)),
      isSubmitted: ue.keepIsSubmitted ? o.isSubmitted : !1,
      dirtyFields: ue.keepDirtyValues ? o.dirtyFields : ue.keepDefaultValues && te ? D4(i, te) : {},
      touchedFields: ue.keepTouched ? o.touchedFields : {},
      errors: ue.keepErrors ? o.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, oe = (te, ue) => J(Nh(te) ? te(a) : te, ue), ce = (te, ue = {}) => {
    const le = jt(r, te), se = le && le._f;
    if (se) {
      const me = se.refs ? se.refs[0] : se.ref;
      me.focus && (me.focus(), ue.shouldSelect && me.select());
    }
  }, de = (te) => {
    o = {
      ...o,
      ...te
    };
  };
  return Nh(n.defaultValues) && n.defaultValues().then((te) => {
    oe(te, n.resetOptions), p.state.next({
      isLoading: !1
    });
  }), {
    control: {
      register: X,
      unregister: Q,
      getFieldState: L,
      _executeSchema: M,
      _getWatch: w,
      _getDirty: x,
      _updateValid: v,
      _removeUnmounted: P,
      _updateFieldArray: k,
      _getFieldArray: E,
      _reset: J,
      _updateFormState: de,
      _subjects: p,
      _proxyFormState: _,
      get _fields() {
        return r;
      },
      get _formValues() {
        return a;
      },
      get _stateFlags() {
        return s;
      },
      set _stateFlags(te) {
        s = te;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return c;
      },
      set _names(te) {
        c = te;
      },
      get _formState() {
        return o;
      },
      set _formState(te) {
        o = te;
      },
      get _options() {
        return n;
      },
      set _options(te) {
        n = {
          ...n,
          ...te
        };
      }
    },
    trigger: V,
    register: X,
    handleSubmit: Z,
    watch: H,
    setValue: j,
    getValues: F,
    reset: oe,
    resetField: ee,
    clearErrors: U,
    unregister: Q,
    setError: W,
    setFocus: ce,
    getFieldState: L
  };
}
function pd(e = {}) {
  const t = ve.useRef(), [n, o] = ve.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: !0,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: Nh(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...dmc(e, () => o((i) => ({ ...i }))),
    formState: n
  });
  const r = t.current.control;
  return r._options = e, JT({
    subject: r._subjects.state,
    next: (i) => {
      xce(i, r._proxyFormState, r._updateFormState, !0) && o({ ...r._formState });
    }
  }), ve.useEffect(() => {
    e.values && !sf(e.values, r._defaultValues) && r._reset(e.values, r._options.resetOptions);
  }, [e.values, r]), ve.useEffect(() => {
    r._stateFlags.mount || (r._updateValid(), r._stateFlags.mount = !0), r._stateFlags.watch && (r._stateFlags.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), t.current.formState = Sce(n, r), t.current;
}
var umc = { VITE_BOOKER_EMBED_API_URL: "https://api.cal.com/v2", VITE_BOOKER_EMBED_OAUTH_CLIENT_ID: "cm165l146000nqi1mrz8vscja", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const GW = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (d, u) => {
    const _ = typeof d == "function" ? d(t) : d;
    if (!Object.is(_, t)) {
      const p = t;
      t = u ?? (typeof _ != "object" || _ === null) ? _ : Object.assign({}, t, _), n.forEach((f) => f(t, p));
    }
  }, r = () => t, c = { setState: o, getState: r, getInitialState: () => l, subscribe: (d) => (n.add(d), () => n.delete(d)), destroy: () => {
    (umc ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, l = t = e(o, r, c);
  return c;
}, Mce = (e) => e ? GW(e) : GW;
var Lce = { exports: {} }, qce = {}, jce = { exports: {} }, Fce = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tv = ve;
function _mc(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var pmc = typeof Object.is == "function" ? Object.is : _mc, mmc = Tv.useState, fmc = Tv.useEffect, gmc = Tv.useLayoutEffect, hmc = Tv.useDebugValue;
function vmc(e, t) {
  var n = t(), o = mmc({ inst: { value: n, getSnapshot: t } }), r = o[0].inst, i = o[1];
  return gmc(function() {
    r.value = n, r.getSnapshot = t, L4(r) && i({ inst: r });
  }, [e, n, t]), fmc(function() {
    return L4(r) && i({ inst: r }), e(function() {
      L4(r) && i({ inst: r });
    });
  }, [e]), hmc(n), n;
}
function L4(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !pmc(e, n);
  } catch {
    return !0;
  }
}
function bmc(e, t) {
  return t();
}
var ymc = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? bmc : vmc;
Fce.useSyncExternalStore = Tv.useSyncExternalStore !== void 0 ? Tv.useSyncExternalStore : ymc;
jce.exports = Fce;
var $mc = jce.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XT = ve, wmc = $mc;
function kmc(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Smc = typeof Object.is == "function" ? Object.is : kmc, xmc = wmc.useSyncExternalStore, Emc = XT.useRef, Tmc = XT.useEffect, Amc = XT.useMemo, Cmc = XT.useDebugValue;
qce.useSyncExternalStoreWithSelector = function(e, t, n, o, r) {
  var i = Emc(null);
  if (i.current === null) {
    var a = { hasValue: !1, value: null };
    i.current = a;
  } else
    a = i.current;
  i = Amc(function() {
    function c(p) {
      if (!l) {
        if (l = !0, d = p, p = o(p), r !== void 0 && a.hasValue) {
          var f = a.value;
          if (r(f, p))
            return u = f;
        }
        return u = p;
      }
      if (f = u, Smc(d, p))
        return f;
      var g = o(p);
      return r !== void 0 && r(f, g) ? f : (d = p, u = g);
    }
    var l = !1, d, u, _ = n === void 0 ? null : n;
    return [function() {
      return c(t());
    }, _ === null ? void 0 : function() {
      return c(_());
    }];
  }, [t, n, o, r]);
  var s = xmc(e, i[0], i[1]);
  return Tmc(function() {
    a.hasValue = !0, a.value = s;
  }, [s]), Cmc(s), s;
};
Lce.exports = qce;
var zmc = Lce.exports;
const Vce = /* @__PURE__ */ Zr(zmc);
var Bce = { VITE_BOOKER_EMBED_API_URL: "https://api.cal.com/v2", VITE_BOOKER_EMBED_OAUTH_CLIENT_ID: "cm165l146000nqi1mrz8vscja", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: Omc } = ve, { useSyncExternalStoreWithSelector: Pmc } = Vce;
let HW = !1;
const Imc = (e) => e;
function _9(e, t = Imc, n) {
  (Bce ? "production" : void 0) !== "production" && n && !HW && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), HW = !0);
  const o = Pmc(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return Omc(o), o;
}
const KW = (e) => {
  (Bce ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? Mce(e) : e, n = (o, r) => _9(t, o, r);
  return Object.assign(n, t), n;
}, p9 = (e) => e ? KW(e) : KW, { useDebugValue: Rmc } = ve, { useSyncExternalStoreWithSelector: Nmc } = Vce, Dmc = (e) => e;
function Mmc(e, t = Dmc, n) {
  const o = Nmc(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return Rmc(o), o;
}
const YW = (e, t) => {
  const n = Mce(e), o = (r, i = t) => Mmc(n, r, i);
  return Object.assign(o, n), o;
}, Lmc = (e, t) => e ? YW(e, t) : YW;
var ti = {};
const qmc = ti.CALCOM_ENV || "production", AS = qmc === "production", Si = "https://app.cal.com", C$ = ti.NEXT_PUBLIC_WEBSITE_URL || "https://cal.com", Zp = ti.NEXT_PUBLIC_APP_NAME || "Cal.com", jmc = ti.NEXT_PUBLIC_COMPANY_NAME || "Cal.com, Inc.", ZW = new URL(Si).hostname.endsWith(".vercel.app") ? Si : ti.NEXT_PUBLIC_WEBSITE_URL || Si, Uce = new URL(Si).hostname.endsWith("cal.com") || new URL(Si).hostname.endsWith("cal.dev") || new URL(Si).hostname.endsWith("cal.qa") || new URL(Si).hostname.endsWith("cal-staging.com") || new URL(Si).hostname.endsWith("cal.eu");
new URL(Si).hostname.endsWith(".cal.dev") || new URL(Si).hostname.endsWith(".cal.qa") || new URL(Si).hostname.endsWith(".cal-staging.com");
const Fmc = [".cal.com", ".cal.dev", ".cal.eu", ".cal.qa"], Vmc = new URL(Si).hostname, dg = !Fmc.some((e) => Vmc.endsWith(e)), Bmc = ti.NEXT_PUBLIC_EMBED_LIB_URL || `${Si}/embed/embed.js`, l2 = 1e3, Dh = 1440, Mh = 1, Umc = parseInt(ti.NEXT_PUBLIC_QUERY_AVAILABLE_SLOTS_INTERVAL_SECONDS ?? "", 10) || 5 * 60, Wce = ti.NEXT_PUBLIC_INVALIDATE_AVAILABLE_SLOTS_ON_BOOKING_FORM === "1", Wmc = parseInt(ti.NEXT_PUBLIC_QUICK_AVAILABILITY_ROLLOUT ?? "", 10) || 0, Gce = "/avatar.svg", Gmc = "https://cal.com/roadmap", Hmc = "https://cal.com/download", Kmc = "https://go.cal.com/booking", Ymc = ti.NEXT_PUBLIC_MINUTES_TO_BOOK || "5", Hce = ti.NEXT_PUBLIC_ENABLE_PROFILE_SWITCHER === "1";
JSON.parse(`[${ti.ALLOWED_HOSTNAMES || ""}]`);
JSON.parse(`[${ti.RESERVED_SUBDOMAINS || ""}]`);
const Kce = "", m9 = "#292929", f9 = "#fafafa", Yce = 40;
var uie, _ie;
const Zmc = !!((_ie = (uie = globalThis.window) == null ? void 0 : uie.Meticulous) != null && _ie.isRunningAsTest), pD = parseInt(
  ti.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD ?? "0",
  0
), mD = ti.NEXT_PUBLIC_CLOUDFLARE_SITEKEY, Qmc = ti.NEXT_PUBLIC_CLOUDFLARE_USE_TURNSTILE_IN_BOOKER, QW = ti.NEXT_PUBLIC_WEBSITE_PRIVACY_POLICY_URL || "https://cal.com/privacy", JW = ti.NEXT_PUBLIC_WEBSITE_TERMS_URL || "https://cal.com/terms", fD = 61;
var pie;
(pie = ti.DIRECTORY_IDS_TO_LOG) != null && pie.split(",");
const Jmc = !!ti.NEXT_PUBLIC_DUB_PROGRAM_ID && ti.NEXT_PUBLIC_DUB_PROGRAM_ID !== "", Mx = "default_group_id", q4 = ti.NEXT_PUBLIC_CAL_AI_PHONE_NUMBER_MONTHLY_PRICE;
(() => {
  const e = q4 && q4.trim() !== "" ? Number(q4) : NaN;
  return Number.isFinite(e) ? e : 5;
})();
(() => {
  if (!ti.RETELL_AI_TEST_EVENT_TYPE_MAP)
    return null;
  try {
    return JSON.parse(ti.RETELL_AI_TEST_EVENT_TYPE_MAP);
  } catch (e) {
    return console.warn("Failed to parse RETELL_AI_TEST_EVENT_TYPE_MAP", e), null;
  }
})();
var Ho;
(function(e) {
  e.assertEqual = (r) => r;
  function t(r) {
  }
  e.assertIs = t;
  function n(r) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (r) => {
    const i = {};
    for (const a of r)
      i[a] = a;
    return i;
  }, e.getValidEnumValues = (r) => {
    const i = e.objectKeys(r).filter((s) => typeof r[r[s]] != "number"), a = {};
    for (const s of i)
      a[s] = r[s];
    return e.objectValues(a);
  }, e.objectValues = (r) => e.objectKeys(r).map(function(i) {
    return r[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const a in r)
      Object.prototype.hasOwnProperty.call(r, a) && i.push(a);
    return i;
  }, e.find = (r, i) => {
    for (const a of r)
      if (i(a))
        return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function o(r, i = " | ") {
    return r.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  e.joinValues = o, e.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(Ho || (Ho = {}));
var gD;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(gD || (gD = {}));
const Zt = Ho.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), vp = (e) => {
  switch (typeof e) {
    case "undefined":
      return Zt.undefined;
    case "string":
      return Zt.string;
    case "number":
      return isNaN(e) ? Zt.nan : Zt.number;
    case "boolean":
      return Zt.boolean;
    case "function":
      return Zt.function;
    case "bigint":
      return Zt.bigint;
    case "symbol":
      return Zt.symbol;
    case "object":
      return Array.isArray(e) ? Zt.array : e === null ? Zt.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Zt.promise : typeof Map < "u" && e instanceof Map ? Zt.map : typeof Set < "u" && e instanceof Set ? Zt.set : typeof Date < "u" && e instanceof Date ? Zt.date : Zt.object;
    default:
      return Zt.unknown;
  }
}, Ct = Ho.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Xmc = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class zc extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (o) => {
      this.issues = [...this.issues, o];
    }, this.addIssues = (o = []) => {
      this.issues = [...this.issues, ...o];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(i) {
      return i.message;
    }, o = { _errors: [] }, r = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(r);
        else if (a.code === "invalid_return_type")
          r(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          r(a.argumentsError);
        else if (a.path.length === 0)
          o._errors.push(n(a));
        else {
          let s = o, c = 0;
          for (; c < a.path.length; ) {
            const l = a.path[c];
            c === a.path.length - 1 ? (s[l] = s[l] || { _errors: [] }, s[l]._errors.push(n(a))) : s[l] = s[l] || { _errors: [] }, s = s[l], c++;
          }
        }
    };
    return r(this), o;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Ho.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, o = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : o.push(t(r));
    return { formErrors: o, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
zc.create = (e) => new zc(e);
const _w = (e, t) => {
  let n;
  switch (e.code) {
    case Ct.invalid_type:
      e.received === Zt.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Ct.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, Ho.jsonStringifyReplacer)}`;
      break;
    case Ct.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Ho.joinValues(e.keys, ", ")}`;
      break;
    case Ct.invalid_union:
      n = "Invalid input";
      break;
    case Ct.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Ho.joinValues(e.options)}`;
      break;
    case Ct.invalid_enum_value:
      n = `Invalid enum value. Expected ${Ho.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Ct.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case Ct.invalid_return_type:
      n = "Invalid function return type";
      break;
    case Ct.invalid_date:
      n = "Invalid date";
      break;
    case Ct.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : Ho.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case Ct.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case Ct.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case Ct.custom:
      n = "Invalid input";
      break;
    case Ct.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case Ct.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Ct.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, Ho.assertNever(e);
  }
  return { message: n };
};
let Zce = _w;
function efc(e) {
  Zce = e;
}
function Lx() {
  return Zce;
}
const qx = (e) => {
  const { data: t, path: n, errorMaps: o, issueData: r } = e, i = [...n, ...r.path || []], a = {
    ...r,
    path: i
  };
  let s = "";
  const c = o.filter((l) => !!l).slice().reverse();
  for (const l of c)
    s = l(a, { data: t, defaultError: s }).message;
  return {
    ...r,
    path: i,
    message: r.message || s
  };
}, tfc = [];
function en(e, t) {
  const n = qx({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      Lx(),
      _w
      // then global default map
    ].filter((o) => !!o)
  });
  e.common.issues.push(n);
}
class Xa {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const o = [];
    for (const r of n) {
      if (r.status === "aborted")
        return no;
      r.status === "dirty" && t.dirty(), o.push(r.value);
    }
    return { status: t.value, value: o };
  }
  static async mergeObjectAsync(t, n) {
    const o = [];
    for (const r of n)
      o.push({
        key: await r.key,
        value: await r.value
      });
    return Xa.mergeObjectSync(t, o);
  }
  static mergeObjectSync(t, n) {
    const o = {};
    for (const r of n) {
      const { key: i, value: a } = r;
      if (i.status === "aborted" || a.status === "aborted")
        return no;
      i.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || r.alwaysSet) && (o[i.value] = a.value);
    }
    return { status: t.value, value: o };
  }
}
const no = Object.freeze({
  status: "aborted"
}), Qce = (e) => ({ status: "dirty", value: e }), Os = (e) => ({ status: "valid", value: e }), hD = (e) => e.status === "aborted", vD = (e) => e.status === "dirty", pw = (e) => e.status === "valid", jx = (e) => typeof Promise < "u" && e instanceof Promise;
var $n;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})($n || ($n = {}));
class au {
  constructor(t, n, o, r) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = o, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const XW = (e, t) => {
  if (pw(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new zc(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function ao(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: o, description: r } = e;
  if (t && (n || o))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: r } : { errorMap: (a, s) => a.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: o ?? s.defaultError } : { message: n ?? s.defaultError }, description: r };
}
class fo {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return vp(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: vp(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Xa(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: vp(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (jx(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const o = this.safeParse(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  safeParse(t, n) {
    var o;
    const r = {
      common: {
        issues: [],
        async: (o = n == null ? void 0 : n.async) !== null && o !== void 0 ? o : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: vp(t)
    }, i = this._parseSync({ data: t, path: r.path, parent: r });
    return XW(r, i);
  }
  async parseAsync(t, n) {
    const o = await this.safeParseAsync(t, n);
    if (o.success)
      return o.data;
    throw o.error;
  }
  async safeParseAsync(t, n) {
    const o = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: vp(t)
    }, r = this._parse({ data: t, path: o.path, parent: o }), i = await (jx(r) ? r : Promise.resolve(r));
    return XW(o, i);
  }
  refine(t, n) {
    const o = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const a = t(r), s = () => i.addIssue({
        code: Ct.custom,
        ...o(r)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (s(), !1)) : a ? !0 : (s(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((o, r) => t(o) ? !0 : (r.addIssue(typeof n == "function" ? n(o, r) : n), !1));
  }
  _refinement(t) {
    return new ad({
      schema: this,
      typeName: Nn.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return f_.create(this, this._def);
  }
  nullable() {
    return jf.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return rd.create(this, this._def);
  }
  promise() {
    return Cv.create(this, this._def);
  }
  or(t) {
    return hw.create([this, t], this._def);
  }
  and(t) {
    return vw.create(this, t, this._def);
  }
  transform(t) {
    return new ad({
      ...ao(this._def),
      schema: this,
      typeName: Nn.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new kw({
      ...ao(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Nn.ZodDefault
    });
  }
  brand() {
    return new Xce({
      typeName: Nn.ZodBranded,
      type: this,
      ...ao(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Ux({
      ...ao(this._def),
      innerType: this,
      catchValue: n,
      typeName: Nn.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return U0.create(this, t);
  }
  readonly() {
    return Gx.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const nfc = /^c[^\s-]{8,}$/i, ofc = /^[a-z][a-z0-9]*$/, rfc = /^[0-9A-HJKMNP-TV-Z]{26}$/, ifc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, afc = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, sfc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let j4;
const cfc = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, lfc = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, dfc = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function ufc(e, t) {
  return !!((t === "v4" || !t) && cfc.test(e) || (t === "v6" || !t) && lfc.test(e));
}
class Ql extends fo {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Zt.string) {
      const i = this._getOrReturnCtx(t);
      return en(
        i,
        {
          code: Ct.invalid_type,
          expected: Zt.string,
          received: i.parsedType
        }
        //
      ), no;
    }
    const o = new Xa();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), o.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), o.dirty());
      else if (i.kind === "length") {
        const a = t.data.length > i.value, s = t.data.length < i.value;
        (a || s) && (r = this._getOrReturnCtx(t, r), a ? en(r, {
          code: Ct.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && en(r, {
          code: Ct.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), o.dirty());
      } else if (i.kind === "email")
        afc.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "email",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "emoji")
        j4 || (j4 = new RegExp(sfc, "u")), j4.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "emoji",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "uuid")
        ifc.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "uuid",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "cuid")
        nfc.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "cuid",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "cuid2")
        ofc.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "cuid2",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "ulid")
        rfc.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "ulid",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          r = this._getOrReturnCtx(t, r), en(r, {
            validation: "url",
            code: Ct.invalid_string,
            message: i.message
          }), o.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "regex",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), o.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), o.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), o.dirty()) : i.kind === "datetime" ? dfc(i).test(t.data) || (r = this._getOrReturnCtx(t, r), en(r, {
          code: Ct.invalid_string,
          validation: "datetime",
          message: i.message
        }), o.dirty()) : i.kind === "ip" ? ufc(t.data, i.version) || (r = this._getOrReturnCtx(t, r), en(r, {
          validation: "ip",
          code: Ct.invalid_string,
          message: i.message
        }), o.dirty()) : Ho.assertNever(i);
    return { status: o.value, value: t.data };
  }
  _regex(t, n, o) {
    return this.refinement((r) => t.test(r), {
      validation: n,
      code: Ct.invalid_string,
      ...$n.errToObj(o)
    });
  }
  _addCheck(t) {
    return new Ql({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...$n.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...$n.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...$n.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...$n.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...$n.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...$n.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...$n.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...$n.errToObj(t) });
  }
  datetime(t) {
    var n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      ...$n.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...$n.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...$n.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...$n.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...$n.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...$n.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...$n.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...$n.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, $n.errToObj(t));
  }
  trim() {
    return new Ql({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ql({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ql({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Ql.create = (e) => {
  var t;
  return new Ql({
    checks: [],
    typeName: Nn.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ao(e)
  });
};
function _fc(e, t) {
  const n = (e.toString().split(".")[1] || "").length, o = (t.toString().split(".")[1] || "").length, r = n > o ? n : o, i = parseInt(e.toFixed(r).replace(".", "")), a = parseInt(t.toFixed(r).replace(".", ""));
  return i % a / Math.pow(10, r);
}
class Qp extends fo {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Zt.number) {
      const i = this._getOrReturnCtx(t);
      return en(i, {
        code: Ct.invalid_type,
        expected: Zt.number,
        received: i.parsedType
      }), no;
    }
    let o;
    const r = new Xa();
    for (const i of this._def.checks)
      i.kind === "int" ? Ho.isInteger(t.data) || (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? _fc(t.data, i.value) !== 0 && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.not_finite,
        message: i.message
      }), r.dirty()) : Ho.assertNever(i);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, $n.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, $n.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, $n.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, $n.toString(n));
  }
  setLimit(t, n, o, r) {
    return new Qp({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: $n.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Qp({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: $n.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: $n.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: $n.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: $n.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: $n.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: $n.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: $n.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: $n.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: $n.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Ho.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const o of this._def.checks) {
      if (o.kind === "finite" || o.kind === "int" || o.kind === "multipleOf")
        return !0;
      o.kind === "min" ? (n === null || o.value > n) && (n = o.value) : o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Qp.create = (e) => new Qp({
  checks: [],
  typeName: Nn.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ao(e)
});
class Jp extends fo {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== Zt.bigint) {
      const i = this._getOrReturnCtx(t);
      return en(i, {
        code: Ct.invalid_type,
        expected: Zt.bigint,
        received: i.parsedType
      }), no;
    }
    let o;
    const r = new Xa();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (o = this._getOrReturnCtx(t, o), en(o, {
        code: Ct.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : Ho.assertNever(i);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, $n.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, $n.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, $n.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, $n.toString(n));
  }
  setLimit(t, n, o, r) {
    return new Jp({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: o,
          message: $n.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Jp({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: $n.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: $n.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: $n.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: $n.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: $n.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Jp.create = (e) => {
  var t;
  return new Jp({
    checks: [],
    typeName: Nn.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ao(e)
  });
};
class mw extends fo {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Zt.boolean) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.boolean,
        received: o.parsedType
      }), no;
    }
    return Os(t.data);
  }
}
mw.create = (e) => new mw({
  typeName: Nn.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ao(e)
});
class Lf extends fo {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Zt.date) {
      const i = this._getOrReturnCtx(t);
      return en(i, {
        code: Ct.invalid_type,
        expected: Zt.date,
        received: i.parsedType
      }), no;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return en(i, {
        code: Ct.invalid_date
      }), no;
    }
    const o = new Xa();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (r = this._getOrReturnCtx(t, r), en(r, {
        code: Ct.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), o.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (r = this._getOrReturnCtx(t, r), en(r, {
        code: Ct.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), o.dirty()) : Ho.assertNever(i);
    return {
      status: o.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Lf({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: $n.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: $n.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Lf.create = (e) => new Lf({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Nn.ZodDate,
  ...ao(e)
});
class Fx extends fo {
  _parse(t) {
    if (this._getType(t) !== Zt.symbol) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.symbol,
        received: o.parsedType
      }), no;
    }
    return Os(t.data);
  }
}
Fx.create = (e) => new Fx({
  typeName: Nn.ZodSymbol,
  ...ao(e)
});
class fw extends fo {
  _parse(t) {
    if (this._getType(t) !== Zt.undefined) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.undefined,
        received: o.parsedType
      }), no;
    }
    return Os(t.data);
  }
}
fw.create = (e) => new fw({
  typeName: Nn.ZodUndefined,
  ...ao(e)
});
class gw extends fo {
  _parse(t) {
    if (this._getType(t) !== Zt.null) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.null,
        received: o.parsedType
      }), no;
    }
    return Os(t.data);
  }
}
gw.create = (e) => new gw({
  typeName: Nn.ZodNull,
  ...ao(e)
});
class Av extends fo {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Os(t.data);
  }
}
Av.create = (e) => new Av({
  typeName: Nn.ZodAny,
  ...ao(e)
});
class Sf extends fo {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Os(t.data);
  }
}
Sf.create = (e) => new Sf({
  typeName: Nn.ZodUnknown,
  ...ao(e)
});
class x_ extends fo {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return en(n, {
      code: Ct.invalid_type,
      expected: Zt.never,
      received: n.parsedType
    }), no;
  }
}
x_.create = (e) => new x_({
  typeName: Nn.ZodNever,
  ...ao(e)
});
class Vx extends fo {
  _parse(t) {
    if (this._getType(t) !== Zt.undefined) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.void,
        received: o.parsedType
      }), no;
    }
    return Os(t.data);
  }
}
Vx.create = (e) => new Vx({
  typeName: Nn.ZodVoid,
  ...ao(e)
});
class rd extends fo {
  _parse(t) {
    const { ctx: n, status: o } = this._processInputParams(t), r = this._def;
    if (n.parsedType !== Zt.array)
      return en(n, {
        code: Ct.invalid_type,
        expected: Zt.array,
        received: n.parsedType
      }), no;
    if (r.exactLength !== null) {
      const a = n.data.length > r.exactLength.value, s = n.data.length < r.exactLength.value;
      (a || s) && (en(n, {
        code: a ? Ct.too_big : Ct.too_small,
        minimum: s ? r.exactLength.value : void 0,
        maximum: a ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), o.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (en(n, {
      code: Ct.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), o.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (en(n, {
      code: Ct.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), o.dirty()), n.common.async)
      return Promise.all([...n.data].map((a, s) => r.type._parseAsync(new au(n, a, n.path, s)))).then((a) => Xa.mergeArray(o, a));
    const i = [...n.data].map((a, s) => r.type._parseSync(new au(n, a, n.path, s)));
    return Xa.mergeArray(o, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new rd({
      ...this._def,
      minLength: { value: t, message: $n.toString(n) }
    });
  }
  max(t, n) {
    return new rd({
      ...this._def,
      maxLength: { value: t, message: $n.toString(n) }
    });
  }
  length(t, n) {
    return new rd({
      ...this._def,
      exactLength: { value: t, message: $n.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
rd.create = (e, t) => new rd({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Nn.ZodArray,
  ...ao(t)
});
function mh(e) {
  if (e instanceof si) {
    const t = {};
    for (const n in e.shape) {
      const o = e.shape[n];
      t[n] = f_.create(mh(o));
    }
    return new si({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof rd ? new rd({
      ...e._def,
      type: mh(e.element)
    }) : e instanceof f_ ? f_.create(mh(e.unwrap())) : e instanceof jf ? jf.create(mh(e.unwrap())) : e instanceof su ? su.create(e.items.map((t) => mh(t))) : e;
}
class si extends fo {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = Ho.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== Zt.object) {
      const l = this._getOrReturnCtx(t);
      return en(l, {
        code: Ct.invalid_type,
        expected: Zt.object,
        received: l.parsedType
      }), no;
    }
    const { status: o, ctx: r } = this._processInputParams(t), { shape: i, keys: a } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof x_ && this._def.unknownKeys === "strip"))
      for (const l in r.data)
        a.includes(l) || s.push(l);
    const c = [];
    for (const l of a) {
      const d = i[l], u = r.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: d._parse(new au(r, u, r.path, l)),
        alwaysSet: l in r.data
      });
    }
    if (this._def.catchall instanceof x_) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const d of s)
          c.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: r.data[d] }
          });
      else if (l === "strict")
        s.length > 0 && (en(r, {
          code: Ct.unrecognized_keys,
          keys: s
        }), o.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const d of s) {
        const u = r.data[d];
        c.push({
          key: { status: "valid", value: d },
          value: l._parse(
            new au(r, u, r.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const d of c) {
        const u = await d.key;
        l.push({
          key: u,
          value: await d.value,
          alwaysSet: d.alwaysSet
        });
      }
      return l;
    }).then((l) => Xa.mergeObjectSync(o, l)) : Xa.mergeObjectSync(o, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return $n.errToObj, new si({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, o) => {
          var r, i, a, s;
          const c = (a = (i = (r = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(r, n, o).message) !== null && a !== void 0 ? a : o.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = $n.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new si({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new si({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new si({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new si({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Nn.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new si({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return Ho.objectKeys(t).forEach((o) => {
      t[o] && this.shape[o] && (n[o] = this.shape[o]);
    }), new si({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return Ho.objectKeys(this.shape).forEach((o) => {
      t[o] || (n[o] = this.shape[o]);
    }), new si({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return mh(this);
  }
  partial(t) {
    const n = {};
    return Ho.objectKeys(this.shape).forEach((o) => {
      const r = this.shape[o];
      t && !t[o] ? n[o] = r : n[o] = r.optional();
    }), new si({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return Ho.objectKeys(this.shape).forEach((o) => {
      if (t && !t[o])
        n[o] = this.shape[o];
      else {
        let i = this.shape[o];
        for (; i instanceof f_; )
          i = i._def.innerType;
        n[o] = i;
      }
    }), new si({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Jce(Ho.objectKeys(this.shape));
  }
}
si.create = (e, t) => new si({
  shape: () => e,
  unknownKeys: "strip",
  catchall: x_.create(),
  typeName: Nn.ZodObject,
  ...ao(t)
});
si.strictCreate = (e, t) => new si({
  shape: () => e,
  unknownKeys: "strict",
  catchall: x_.create(),
  typeName: Nn.ZodObject,
  ...ao(t)
});
si.lazycreate = (e, t) => new si({
  shape: e,
  unknownKeys: "strip",
  catchall: x_.create(),
  typeName: Nn.ZodObject,
  ...ao(t)
});
class hw extends fo {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = this._def.options;
    function r(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const a = i.map((s) => new zc(s.ctx.common.issues));
      return en(n, {
        code: Ct.invalid_union,
        unionErrors: a
      }), no;
    }
    if (n.common.async)
      return Promise.all(o.map(async (i) => {
        const a = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: a
          }),
          ctx: a
        };
      })).then(r);
    {
      let i;
      const a = [];
      for (const c of o) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !i && (i = { result: d, ctx: l }), l.common.issues.length && a.push(l.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const s = a.map((c) => new zc(c));
      return en(n, {
        code: Ct.invalid_union,
        unionErrors: s
      }), no;
    }
  }
  get options() {
    return this._def.options;
  }
}
hw.create = (e, t) => new hw({
  options: e,
  typeName: Nn.ZodUnion,
  ...ao(t)
});
const CS = (e) => e instanceof yw ? CS(e.schema) : e instanceof ad ? CS(e.innerType()) : e instanceof $w ? [e.value] : e instanceof Xp ? e.options : e instanceof ww ? Object.keys(e.enum) : e instanceof kw ? CS(e._def.innerType) : e instanceof fw ? [void 0] : e instanceof gw ? [null] : null;
class eA extends fo {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Zt.object)
      return en(n, {
        code: Ct.invalid_type,
        expected: Zt.object,
        received: n.parsedType
      }), no;
    const o = this.discriminator, r = n.data[o], i = this.optionsMap.get(r);
    return i ? n.common.async ? i._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : i._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (en(n, {
      code: Ct.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [o]
    }), no);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, o) {
    const r = /* @__PURE__ */ new Map();
    for (const i of n) {
      const a = CS(i.shape[t]);
      if (!a)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of a) {
        if (r.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        r.set(s, i);
      }
    }
    return new eA({
      typeName: Nn.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: r,
      ...ao(o)
    });
  }
}
function bD(e, t) {
  const n = vp(e), o = vp(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === Zt.object && o === Zt.object) {
    const r = Ho.objectKeys(t), i = Ho.objectKeys(e).filter((s) => r.indexOf(s) !== -1), a = { ...e, ...t };
    for (const s of i) {
      const c = bD(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      a[s] = c.data;
    }
    return { valid: !0, data: a };
  } else if (n === Zt.array && o === Zt.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < e.length; i++) {
      const a = e[i], s = t[i], c = bD(a, s);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else
    return n === Zt.date && o === Zt.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class vw extends fo {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), r = (i, a) => {
      if (hD(i) || hD(a))
        return no;
      const s = bD(i.value, a.value);
      return s.valid ? ((vD(i) || vD(a)) && n.dirty(), { status: n.value, value: s.data }) : (en(o, {
        code: Ct.invalid_intersection_types
      }), no);
    };
    return o.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      }),
      this._def.right._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      })
    ]).then(([i, a]) => r(i, a)) : r(this._def.left._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }), this._def.right._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }));
  }
}
vw.create = (e, t, n) => new vw({
  left: e,
  right: t,
  typeName: Nn.ZodIntersection,
  ...ao(n)
});
class su extends fo {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Zt.array)
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.array,
        received: o.parsedType
      }), no;
    if (o.data.length < this._def.items.length)
      return en(o, {
        code: Ct.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), no;
    !this._def.rest && o.data.length > this._def.items.length && (en(o, {
      code: Ct.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...o.data].map((a, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new au(o, a, o.path, s)) : null;
    }).filter((a) => !!a);
    return o.common.async ? Promise.all(i).then((a) => Xa.mergeArray(n, a)) : Xa.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new su({
      ...this._def,
      rest: t
    });
  }
}
su.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new su({
    items: e,
    typeName: Nn.ZodTuple,
    rest: null,
    ...ao(t)
  });
};
class bw extends fo {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Zt.object)
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.object,
        received: o.parsedType
      }), no;
    const r = [], i = this._def.keyType, a = this._def.valueType;
    for (const s in o.data)
      r.push({
        key: i._parse(new au(o, s, o.path, s)),
        value: a._parse(new au(o, o.data[s], o.path, s))
      });
    return o.common.async ? Xa.mergeObjectAsync(n, r) : Xa.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, o) {
    return n instanceof fo ? new bw({
      keyType: t,
      valueType: n,
      typeName: Nn.ZodRecord,
      ...ao(o)
    }) : new bw({
      keyType: Ql.create(),
      valueType: t,
      typeName: Nn.ZodRecord,
      ...ao(n)
    });
  }
}
class Bx extends fo {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Zt.map)
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.map,
        received: o.parsedType
      }), no;
    const r = this._def.keyType, i = this._def.valueType, a = [...o.data.entries()].map(([s, c], l) => ({
      key: r._parse(new au(o, s, o.path, [l, "key"])),
      value: i._parse(new au(o, c, o.path, [l, "value"]))
    }));
    if (o.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const l = await c.key, d = await c.value;
          if (l.status === "aborted" || d.status === "aborted")
            return no;
          (l.status === "dirty" || d.status === "dirty") && n.dirty(), s.set(l.value, d.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of a) {
        const l = c.key, d = c.value;
        if (l.status === "aborted" || d.status === "aborted")
          return no;
        (l.status === "dirty" || d.status === "dirty") && n.dirty(), s.set(l.value, d.value);
      }
      return { status: n.value, value: s };
    }
  }
}
Bx.create = (e, t, n) => new Bx({
  valueType: t,
  keyType: e,
  typeName: Nn.ZodMap,
  ...ao(n)
});
class qf extends fo {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Zt.set)
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.set,
        received: o.parsedType
      }), no;
    const r = this._def;
    r.minSize !== null && o.data.size < r.minSize.value && (en(o, {
      code: Ct.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && o.data.size > r.maxSize.value && (en(o, {
      code: Ct.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function a(c) {
      const l = /* @__PURE__ */ new Set();
      for (const d of c) {
        if (d.status === "aborted")
          return no;
        d.status === "dirty" && n.dirty(), l.add(d.value);
      }
      return { status: n.value, value: l };
    }
    const s = [...o.data.values()].map((c, l) => i._parse(new au(o, c, o.path, l)));
    return o.common.async ? Promise.all(s).then((c) => a(c)) : a(s);
  }
  min(t, n) {
    return new qf({
      ...this._def,
      minSize: { value: t, message: $n.toString(n) }
    });
  }
  max(t, n) {
    return new qf({
      ...this._def,
      maxSize: { value: t, message: $n.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
qf.create = (e, t) => new qf({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Nn.ZodSet,
  ...ao(t)
});
class Lh extends fo {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Zt.function)
      return en(n, {
        code: Ct.invalid_type,
        expected: Zt.function,
        received: n.parsedType
      }), no;
    function o(s, c) {
      return qx({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Lx(),
          _w
        ].filter((l) => !!l),
        issueData: {
          code: Ct.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function r(s, c) {
      return qx({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Lx(),
          _w
        ].filter((l) => !!l),
        issueData: {
          code: Ct.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const i = { errorMap: n.common.contextualErrorMap }, a = n.data;
    if (this._def.returns instanceof Cv) {
      const s = this;
      return Os(async function(...c) {
        const l = new zc([]), d = await s._def.args.parseAsync(c, i).catch((p) => {
          throw l.addIssue(o(c, p)), l;
        }), u = await Reflect.apply(a, this, d);
        return await s._def.returns._def.type.parseAsync(u, i).catch((p) => {
          throw l.addIssue(r(u, p)), l;
        });
      });
    } else {
      const s = this;
      return Os(function(...c) {
        const l = s._def.args.safeParse(c, i);
        if (!l.success)
          throw new zc([o(c, l.error)]);
        const d = Reflect.apply(a, this, l.data), u = s._def.returns.safeParse(d, i);
        if (!u.success)
          throw new zc([r(d, u.error)]);
        return u.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Lh({
      ...this._def,
      args: su.create(t).rest(Sf.create())
    });
  }
  returns(t) {
    return new Lh({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, o) {
    return new Lh({
      args: t || su.create([]).rest(Sf.create()),
      returns: n || Sf.create(),
      typeName: Nn.ZodFunction,
      ...ao(o)
    });
  }
}
class yw extends fo {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
yw.create = (e, t) => new yw({
  getter: e,
  typeName: Nn.ZodLazy,
  ...ao(t)
});
class $w extends fo {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return en(n, {
        received: n.data,
        code: Ct.invalid_literal,
        expected: this._def.value
      }), no;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
$w.create = (e, t) => new $w({
  value: e,
  typeName: Nn.ZodLiteral,
  ...ao(t)
});
function Jce(e, t) {
  return new Xp({
    values: e,
    typeName: Nn.ZodEnum,
    ...ao(t)
  });
}
class Xp extends fo {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return en(n, {
        expected: Ho.joinValues(o),
        received: n.parsedType,
        code: Ct.invalid_type
      }), no;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const n = this._getOrReturnCtx(t), o = this._def.values;
      return en(n, {
        received: n.data,
        code: Ct.invalid_enum_value,
        options: o
      }), no;
    }
    return Os(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t) {
    return Xp.create(t);
  }
  exclude(t) {
    return Xp.create(this.options.filter((n) => !t.includes(n)));
  }
}
Xp.create = Jce;
class ww extends fo {
  _parse(t) {
    const n = Ho.getValidEnumValues(this._def.values), o = this._getOrReturnCtx(t);
    if (o.parsedType !== Zt.string && o.parsedType !== Zt.number) {
      const r = Ho.objectValues(n);
      return en(o, {
        expected: Ho.joinValues(r),
        received: o.parsedType,
        code: Ct.invalid_type
      }), no;
    }
    if (n.indexOf(t.data) === -1) {
      const r = Ho.objectValues(n);
      return en(o, {
        received: o.data,
        code: Ct.invalid_enum_value,
        options: r
      }), no;
    }
    return Os(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
ww.create = (e, t) => new ww({
  values: e,
  typeName: Nn.ZodNativeEnum,
  ...ao(t)
});
class Cv extends fo {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Zt.promise && n.common.async === !1)
      return en(n, {
        code: Ct.invalid_type,
        expected: Zt.promise,
        received: n.parsedType
      }), no;
    const o = n.parsedType === Zt.promise ? n.data : Promise.resolve(n.data);
    return Os(o.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Cv.create = (e, t) => new Cv({
  type: e,
  typeName: Nn.ZodPromise,
  ...ao(t)
});
class ad extends fo {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Nn.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t), r = this._def.effect || null, i = {
      addIssue: (a) => {
        en(o, a), a.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return o.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const a = r.transform(o.data, i);
      return o.common.issues.length ? {
        status: "dirty",
        value: o.data
      } : o.common.async ? Promise.resolve(a).then((s) => this._def.schema._parseAsync({
        data: s,
        path: o.path,
        parent: o
      })) : this._def.schema._parseSync({
        data: a,
        path: o.path,
        parent: o
      });
    }
    if (r.type === "refinement") {
      const a = (s) => {
        const c = r.refinement(s, i);
        if (o.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (o.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return s.status === "aborted" ? no : (s.status === "dirty" && n.dirty(), a(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((s) => s.status === "aborted" ? no : (s.status === "dirty" && n.dirty(), a(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (r.type === "transform")
      if (o.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        if (!pw(a))
          return a;
        const s = r.transform(a.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((a) => pw(a) ? Promise.resolve(r.transform(a.value, i)).then((s) => ({ status: n.value, value: s })) : a);
    Ho.assertNever(r);
  }
}
ad.create = (e, t, n) => new ad({
  schema: e,
  typeName: Nn.ZodEffects,
  effect: t,
  ...ao(n)
});
ad.createWithPreprocess = (e, t, n) => new ad({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Nn.ZodEffects,
  ...ao(n)
});
class f_ extends fo {
  _parse(t) {
    return this._getType(t) === Zt.undefined ? Os(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
f_.create = (e, t) => new f_({
  innerType: e,
  typeName: Nn.ZodOptional,
  ...ao(t)
});
class jf extends fo {
  _parse(t) {
    return this._getType(t) === Zt.null ? Os(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
jf.create = (e, t) => new jf({
  innerType: e,
  typeName: Nn.ZodNullable,
  ...ao(t)
});
class kw extends fo {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let o = n.data;
    return n.parsedType === Zt.undefined && (o = this._def.defaultValue()), this._def.innerType._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
kw.create = (e, t) => new kw({
  innerType: e,
  typeName: Nn.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ao(t)
});
class Ux extends fo {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: o.data,
      path: o.path,
      parent: {
        ...o
      }
    });
    return jx(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new zc(o.common.issues);
        },
        input: o.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new zc(o.common.issues);
        },
        input: o.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ux.create = (e, t) => new Ux({
  innerType: e,
  typeName: Nn.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ao(t)
});
class Wx extends fo {
  _parse(t) {
    if (this._getType(t) !== Zt.nan) {
      const o = this._getOrReturnCtx(t);
      return en(o, {
        code: Ct.invalid_type,
        expected: Zt.nan,
        received: o.parsedType
      }), no;
    }
    return { status: "valid", value: t.data };
  }
}
Wx.create = (e) => new Wx({
  typeName: Nn.ZodNaN,
  ...ao(e)
});
const pfc = Symbol("zod_brand");
class Xce extends fo {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), o = n.data;
    return this._def.type._parse({
      data: o,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class U0 extends fo {
  _parse(t) {
    const { status: n, ctx: o } = this._processInputParams(t);
    if (o.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return i.status === "aborted" ? no : i.status === "dirty" ? (n.dirty(), Qce(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: o.path,
          parent: o
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: o.data,
        path: o.path,
        parent: o
      });
      return r.status === "aborted" ? no : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: o.path,
        parent: o
      });
    }
  }
  static create(t, n) {
    return new U0({
      in: t,
      out: n,
      typeName: Nn.ZodPipeline
    });
  }
}
class Gx extends fo {
  _parse(t) {
    const n = this._def.innerType._parse(t);
    return pw(n) && (n.value = Object.freeze(n.value)), n;
  }
}
Gx.create = (e, t) => new Gx({
  innerType: e,
  typeName: Nn.ZodReadonly,
  ...ao(t)
});
const ele = (e, t = {}, n) => e ? Av.create().superRefine((o, r) => {
  var i, a;
  if (!e(o)) {
    const s = typeof t == "function" ? t(o) : typeof t == "string" ? { message: t } : t, c = (a = (i = s.fatal) !== null && i !== void 0 ? i : n) !== null && a !== void 0 ? a : !0, l = typeof s == "string" ? { message: s } : s;
    r.addIssue({ code: "custom", ...l, fatal: c });
  }
}) : Av.create(), mfc = {
  object: si.lazycreate
};
var Nn;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Nn || (Nn = {}));
const ffc = (e, t = {
  message: `Input not instance of ${e.name}`
}) => ele((n) => n instanceof e, t), tle = Ql.create, nle = Qp.create, gfc = Wx.create, hfc = Jp.create, ole = mw.create, vfc = Lf.create, bfc = Fx.create, yfc = fw.create, $fc = gw.create, wfc = Av.create, kfc = Sf.create, Sfc = x_.create, xfc = Vx.create, Efc = rd.create, Tfc = si.create, Afc = si.strictCreate, Cfc = hw.create, zfc = eA.create, Ofc = vw.create, Pfc = su.create, Ifc = bw.create, Rfc = Bx.create, Nfc = qf.create, Dfc = Lh.create, Mfc = yw.create, Lfc = $w.create, qfc = Xp.create, jfc = ww.create, Ffc = Cv.create, eG = ad.create, Vfc = f_.create, Bfc = jf.create, Ufc = ad.createWithPreprocess, Wfc = U0.create, Gfc = () => tle().optional(), Hfc = () => nle().optional(), Kfc = () => ole().optional(), Yfc = {
  string: (e) => Ql.create({ ...e, coerce: !0 }),
  number: (e) => Qp.create({ ...e, coerce: !0 }),
  boolean: (e) => mw.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Jp.create({ ...e, coerce: !0 }),
  date: (e) => Lf.create({ ...e, coerce: !0 })
}, Zfc = no;
var G = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: _w,
  setErrorMap: efc,
  getErrorMap: Lx,
  makeIssue: qx,
  EMPTY_PATH: tfc,
  addIssueToContext: en,
  ParseStatus: Xa,
  INVALID: no,
  DIRTY: Qce,
  OK: Os,
  isAborted: hD,
  isDirty: vD,
  isValid: pw,
  isAsync: jx,
  get util() {
    return Ho;
  },
  get objectUtil() {
    return gD;
  },
  ZodParsedType: Zt,
  getParsedType: vp,
  ZodType: fo,
  ZodString: Ql,
  ZodNumber: Qp,
  ZodBigInt: Jp,
  ZodBoolean: mw,
  ZodDate: Lf,
  ZodSymbol: Fx,
  ZodUndefined: fw,
  ZodNull: gw,
  ZodAny: Av,
  ZodUnknown: Sf,
  ZodNever: x_,
  ZodVoid: Vx,
  ZodArray: rd,
  ZodObject: si,
  ZodUnion: hw,
  ZodDiscriminatedUnion: eA,
  ZodIntersection: vw,
  ZodTuple: su,
  ZodRecord: bw,
  ZodMap: Bx,
  ZodSet: qf,
  ZodFunction: Lh,
  ZodLazy: yw,
  ZodLiteral: $w,
  ZodEnum: Xp,
  ZodNativeEnum: ww,
  ZodPromise: Cv,
  ZodEffects: ad,
  ZodTransformer: ad,
  ZodOptional: f_,
  ZodNullable: jf,
  ZodDefault: kw,
  ZodCatch: Ux,
  ZodNaN: Wx,
  BRAND: pfc,
  ZodBranded: Xce,
  ZodPipeline: U0,
  ZodReadonly: Gx,
  custom: ele,
  Schema: fo,
  ZodSchema: fo,
  late: mfc,
  get ZodFirstPartyTypeKind() {
    return Nn;
  },
  coerce: Yfc,
  any: wfc,
  array: Efc,
  bigint: hfc,
  boolean: ole,
  date: vfc,
  discriminatedUnion: zfc,
  effect: eG,
  enum: qfc,
  function: Dfc,
  instanceof: ffc,
  intersection: Ofc,
  lazy: Mfc,
  literal: Lfc,
  map: Rfc,
  nan: gfc,
  nativeEnum: jfc,
  never: Sfc,
  null: $fc,
  nullable: Bfc,
  number: nle,
  object: Tfc,
  oboolean: Kfc,
  onumber: Hfc,
  optional: Vfc,
  ostring: Gfc,
  pipeline: Wfc,
  preprocess: Ufc,
  promise: Ffc,
  record: Ifc,
  set: Nfc,
  strictObject: Afc,
  string: tle,
  symbol: bfc,
  transformer: eG,
  tuple: Pfc,
  undefined: yfc,
  union: Cfc,
  unknown: kfc,
  void: xfc,
  NEVER: Zfc,
  ZodIssueCode: Ct,
  quotelessJson: Xmc,
  ZodError: zc
});
function Qfc(e, t, n) {
  let o = !1, r = !1, i = !1, a = !1, s = !1;
  if (e.length >= 7 && (!n || e.length > 14) && (a = !0), n && e.length > 14 && (s = !0), e.match(/\d/) && (i = !0), e.match(/[a-z]/) && (r = !0), e.match(/[A-Z]/) && (o = !0), !t)
    return o && r && i && a && (n ? s : !0);
  let c = { caplow: o && r, num: i, min: a };
  return n && (c = { ...c, admin_min: s }), c;
}
const rle = (
  /* eslint-disable-next-line no-useless-escape */
  /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.']*)[A-Z0-9_+'-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i
), Jfc = 254, Xfc = G.string().max(Jfc, { message: "Email address is too long" }).regex(rle), ile = (e) => e.replace(/[^a-zA-Z0-9-_]/g, "-"), egc = G.object({
  type: G.string().optional(),
  properties: G.object({
    field: G.any().optional(),
    operator: G.any().optional(),
    value: G.any().optional(),
    valueSrc: G.any().optional(),
    valueError: G.array(G.union([G.string(), G.null()])).optional(),
    valueType: G.any().optional()
  }).optional()
  /*
   * TODO: (emrysal) This schema is good, but our DB contains invalid entries-
   *       instead of crashing on read we need to handle this on write first.
  type: z.union([z.literal("rule"), z.literal("rule_group")]),
  properties: z.object({
    // This is RAQB field that is used in the rules. The aluealue we provide here is used as a lookup key in RAQB_CONFIG.fields
    field: z.string(),
    // It could be any of the operators. There are many custom operators.
    operator: z.string(),
    // It is the value of the 'field' chosen for comparison in the rule
    // It might not be set if the operator needs nothing to compare with e.g. is_empty, is_not_empty\
    // It could be a 2D array for MultiSelect field
    value: z.array(z.union([z.string(), z.array(z.string()), z.null()])).optional(),
    // It is the source of the value. It might not be set if the value is coming from the field itself.
    valueSrc: z
      .union([z.literal("value"), z.literal("field"), z.literal("func"), z.literal("const")])
      .array()
      .optional(),
    // It is the error message that is shown when the value is not valid.
    valueError: z.array(z.union([z.string(), z.null()])).optional(),
    // Type of the value - can be text, number, boolean, date, time, datetime, select, multiselect, treeselect, treemultiselect and maybe more
    // We only use a few of them in our app
    valueType: z.array(z.string()).optional(),
  }),*/
}), tG = G.record(egc).superRefine((e, t) => {
  if (!e)
    return;
  const n = (o) => typeof o == "object" && o !== null;
  Object.entries(e).forEach(([, o]) => {
    const r = o;
    if (!n(r) || r.type !== "rule" || !n(r.properties))
      return;
    const i = r.properties.value || [], a = r.properties.valueSrc;
    if (!(i instanceof Array) || !(a instanceof Array) || !a.length)
      return;
    i.flat().filter((l) => l !== void 0).length || t.addIssue({
      code: G.ZodIssueCode.custom,
      message: "Looks like you are trying to create a rule with no value"
    });
  });
}), zS = G.union([
  G.object({
    id: G.string().optional(),
    type: G.literal("group"),
    children1: tG.optional(),
    properties: G.any()
  }),
  G.object({
    id: G.string().optional(),
    type: G.literal("switch_group"),
    children1: tG.optional(),
    properties: G.any()
  })
]), tgc = zS, g9 = (e, t) => {
  if (!e)
    return "";
  const n = e.toLowerCase().trim().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").replace(/[^.\p{L}\p{N}\p{Zs}\p{Emoji}]+/gu, "-").replace(/[\s_#]+/g, "-").replace(/^-+/, "").replace(/\.{2,}/g, ".").replace(/^\.+/, "").replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ""
  ).replace(/\s+/g, " ").replace(/-+/g, "-");
  return t ? n : n.replace(/-+$/, "").replace(/\.*$/, "");
}, xf = g9, aa = {
  ROUND_ROBIN: "ROUND_ROBIN",
  COLLECTIVE: "COLLECTIVE",
  MANAGED: "MANAGED"
}, ka = {
  UNLIMITED: "UNLIMITED",
  ROLLING: "ROLLING",
  ROLLING_WINDOW: "ROLLING_WINDOW",
  RANGE: "RANGE"
}, ngc = {
  USER: "USER",
  ADMIN: "ADMIN"
}, ogc = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
  OWNER: "OWNER"
}, F4 = {
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  AWAITING_HOST: "AWAITING_HOST"
}, rgc = {
  TEXT: "TEXT",
  TEXTLONG: "TEXTLONG",
  NUMBER: "NUMBER",
  BOOL: "BOOL",
  RADIO: "RADIO",
  PHONE: "PHONE"
}, ale = {
  BEFORE_EVENT: "BEFORE_EVENT",
  EVENT_CANCELLED: "EVENT_CANCELLED",
  NEW_EVENT: "NEW_EVENT",
  AFTER_EVENT: "AFTER_EVENT",
  RESCHEDULE_EVENT: "RESCHEDULE_EVENT",
  AFTER_HOSTS_CAL_VIDEO_NO_SHOW: "AFTER_HOSTS_CAL_VIDEO_NO_SHOW",
  AFTER_GUESTS_CAL_VIDEO_NO_SHOW: "AFTER_GUESTS_CAL_VIDEO_NO_SHOW",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  FORM_SUBMITTED_NO_EVENT: "FORM_SUBMITTED_NO_EVENT",
  BOOKING_REJECTED: "BOOKING_REJECTED",
  BOOKING_REQUESTED: "BOOKING_REQUESTED",
  BOOKING_PAYMENT_INITIATED: "BOOKING_PAYMENT_INITIATED",
  BOOKING_PAID: "BOOKING_PAID",
  BOOKING_NO_SHOW_UPDATED: "BOOKING_NO_SHOW_UPDATED"
}, yD = {
  EMAIL_HOST: "EMAIL_HOST",
  EMAIL_ATTENDEE: "EMAIL_ATTENDEE",
  SMS_ATTENDEE: "SMS_ATTENDEE",
  SMS_NUMBER: "SMS_NUMBER",
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
  WHATSAPP_ATTENDEE: "WHATSAPP_ATTENDEE",
  WHATSAPP_NUMBER: "WHATSAPP_NUMBER",
  CAL_AI_PHONE_CALL: "CAL_AI_PHONE_CALL"
}, nG = {
  CREATED_AT: "CREATED_AT",
  START_TIME: "START_TIME"
}, d2 = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  SINGLE_SELECT: "SINGLE_SELECT",
  MULTI_SELECT: "MULTI_SELECT"
}, oG = {
  DESCRIPTION: "DESCRIPTION",
  TITLE: "TITLE"
};
var qh = /* @__PURE__ */ ((e) => (e[e.YEARLY = 0] = "YEARLY", e[e.MONTHLY = 1] = "MONTHLY", e[e.WEEKLY = 2] = "WEEKLY", e[e.DAILY = 3] = "DAILY", e[e.HOURLY = 4] = "HOURLY", e[e.MINUTELY = 5] = "MINUTELY", e[e.SECONDLY = 6] = "SECONDLY", e))(qh || {}), pn = /* @__PURE__ */ ((e) => (e.MONTH_VIEW = "month_view", e.WEEK_VIEW = "week_view", e.COLUMN_VIEW = "column_view", e))(pn || {});
const nu = [
  "month_view",
  "week_view",
  "column_view"
  /* COLUMN_VIEW */
], rG = G.union([
  G.literal(nu[0]),
  G.literal(nu[1]),
  G.literal(nu[2])
]), sle = G.object({
  enabledLayouts: G.array(rG),
  defaultLayout: rG
}).nullable();
G.array(
  G.object({
    email: G.string().email(),
    name: G.string().optional(),
    teamId: G.number().optional(),
    teamName: G.string().optional(),
    role: G.enum(["MEMBER", "ADMIN"]).optional().default("MEMBER")
  })
);
G.array(
  G.object({
    id: G.number(),
    name: G.string(),
    isBeingMigrated: G.boolean(),
    // "slug" is null for new teams
    slug: G.string().nullable()
  })
);
const cle = {
  defaultLayout: "month_view",
  // if the user has no explicit layouts set (not in user profile and not in event settings), all layouts are enabled.
  enabledLayouts: nu
}, igc = G.enum(["hours", "minutes"]), lle = G.object({
  smartContractAddress: G.string().optional(),
  blockchainId: G.number().optional(),
  multipleDuration: G.number().array().optional(),
  giphyThankYouPage: G.string().optional(),
  additionalNotesRequired: G.boolean().optional(),
  disableSuccessPage: G.boolean().optional(),
  disableStandardEmails: G.object({
    all: G.object({
      host: G.boolean().optional(),
      attendee: G.boolean().optional()
    }).optional(),
    confirmation: G.object({
      host: G.boolean().optional(),
      attendee: G.boolean().optional()
    }).optional()
  }).optional(),
  managedEventConfig: G.object({
    unlockedFields: G.custom().optional()
  }).optional(),
  requiresConfirmationThreshold: G.object({
    time: G.number(),
    unit: igc
  }).optional(),
  config: G.object({
    useHostSchedulesForTeamEvent: G.boolean().optional()
  }).optional(),
  bookerLayouts: sle.optional()
}), agc = lle.merge(
  G.object({
    apps: G.record(G.string(), G.any()).optional()
  })
), dle = agc.nullable(), ule = lle.nullable(), tA = G.object({
  email: G.string(),
  attendeePhoneNumber: G.string().optional(),
  //TODO: Why don't we move name out of bookingResponses and let it be handled like user fields?
  name: G.union([
    G.string(),
    G.object({
      firstName: G.string(),
      lastName: G.string().optional()
    })
  ]),
  guests: G.array(G.string()).optional(),
  notes: G.string().optional(),
  location: G.object({
    optionValue: G.string(),
    value: G.string()
  }).optional(),
  smsReminderNumber: G.string().optional(),
  rescheduleReason: G.string().optional()
}).nullable(), sgc = G.array(
  G.object({
    // TODO: Couldn't find a way to make it a union of types from App Store locations
    // Creating a dynamic union by iterating over the object doesn't seem to make TS happy
    type: G.string(),
    address: G.string().optional(),
    link: G.string().url().optional(),
    displayLocationPublicly: G.boolean().optional(),
    hostPhoneNumber: G.string().optional(),
    credentialId: G.number().optional(),
    teamName: G.string().optional(),
    customLabel: G.string().optional()
  })
);
G.object({
  dtstart: G.date().optional(),
  interval: G.number(),
  count: G.number(),
  freq: G.nativeEnum(qh),
  until: G.date().optional(),
  tzid: G.string().optional()
}).nullable();
G.string().transform((e, t) => {
  const n = Date.parse(e);
  n || t.addIssue({
    code: G.ZodIssueCode.custom,
    message: "Invalid ISO Date"
  });
  const o = /* @__PURE__ */ new Date();
  return o.setTime(n), o;
});
G.object({
  lightEventTypeColor: G.string(),
  darkEventTypeColor: G.string()
}).nullable();
const cgc = G.string().trim().transform((e) => g9(e)).refine((e) => e.length >= 1, {
  message: "Please enter at least one character"
});
G.string().transform((e) => new Date(e));
G.union([
  G.string().transform((e, t) => {
    const n = parseInt(e);
    return isNaN(n) && t.addIssue({
      code: G.ZodIssueCode.custom,
      message: "Not a number"
    }), n;
  }),
  G.number().int()
]);
G.union([
  // string must be given & nonempty
  G.string().trim().min(1),
  // boolean must be true if set.
  G.boolean().refine((e) => e === !0)
]);
const lgc = G.object({
  platformClientId: G.string().optional(),
  platformRescheduleUrl: G.string().nullable().optional(),
  platformCancelUrl: G.string().nullable().optional(),
  platformBookingUrl: G.string().nullable().optional(),
  platformBookingLocation: G.string().optional(),
  areCalendarEventsEnabled: G.boolean().optional()
});
G.object({
  bookingId: G.number(),
  confirmed: G.boolean(),
  recurringEventId: G.string().optional(),
  reason: G.string().optional(),
  emailsEnabled: G.boolean().default(!0),
  platformClientParams: lgc.optional()
});
const _le = G.object({
  id: G.number().optional(),
  uid: G.string().optional(),
  // note(Lauris): allRemainingBookings will cancel all bookings that have start time greater than this moment.
  allRemainingBookings: G.boolean().optional(),
  // note(Lauris): cancelSubsequentBookings will cancel all bookings after one specified by id or uid.
  cancelSubsequentBookings: G.boolean().optional(),
  cancellationReason: G.string().optional(),
  skipCancellationReasonValidation: G.boolean().optional(),
  seatReferenceUid: G.string().optional(),
  cancelledBy: G.string().email({ message: "Invalid email" }).optional(),
  internalNote: G.object({
    id: G.number(),
    name: G.string(),
    cancellationReason: G.string().optional().nullable()
  }).optional().nullable()
});
G.object({
  seatReferenceUid: G.string()
});
_le.refine(
  (e) => !!e.id || !!e.uid,
  "At least one of the following required: 'id', 'uid'."
);
_le.extend({
  csrfToken: G.string().length(64, "Invalid CSRF token")
}).refine((e) => !!e.id || !!e.uid, "At least one of the following required: 'id', 'uid'.");
const dgc = G.object({
  connected: G.boolean().optional(),
  selectedParam: G.string().optional(),
  sleepValue: G.number().optional()
});
G.object({
  id: G.string(),
  thirdPartyRecurringEventId: G.string(),
  password: G.union([G.string(), G.undefined()]),
  onlineMeetingUrl: G.string().nullable(),
  iCalUID: G.string().optional()
}).passthrough();
const ple = G.object({
  appSlug: G.string().default("daily-video").optional(),
  appLink: G.string().optional()
});
G.object({
  proPaidForByTeamId: G.number().optional(),
  stripeCustomerId: G.string().optional(),
  vitalSettings: dgc.optional(),
  isPremium: G.boolean().optional(),
  sessionTimeout: G.number().optional(),
  // Minutes
  defaultConferencingApp: ple.optional(),
  defaultBookerLayouts: sle.optional(),
  emailChangeWaitingForVerification: G.string().transform((e) => e.toLowerCase()).optional(),
  migratedToOrgFrom: G.object({
    username: G.string().or(G.null()).optional(),
    lastMigrationTime: G.string().optional(),
    reverted: G.boolean().optional(),
    revertTime: G.string().optional()
  }).optional()
}).nullable();
G.object({
  isOrganizationVerified: G.boolean().optional(),
  isOrganizationConfigured: G.boolean().optional(),
  isAdminReviewed: G.boolean().optional(),
  orgAutoAcceptEmail: G.string().optional(),
  isAdminAPIEnabled: G.boolean().optional()
}).nullable();
var mle = /* @__PURE__ */ ((e) => (e.MONTHLY = "MONTHLY", e.ANNUALLY = "ANNUALLY", e))(mle || {});
const fle = G.object({
  defaultConferencingApp: ple.optional(),
  requestedSlug: G.string().or(G.null()),
  paymentId: G.string(),
  subscriptionId: G.string().nullable(),
  subscriptionItemId: G.string().nullable(),
  orgSeats: G.number().nullable(),
  orgPricePerSeat: G.number().nullable(),
  migratedToOrgFrom: G.object({
    teamSlug: G.string().or(G.null()).optional(),
    lastMigrationTime: G.string().optional(),
    reverted: G.boolean().optional(),
    lastRevertTime: G.string().optional()
  }).optional(),
  billingPeriod: G.nativeEnum(mle).optional()
});
fle.partial().nullable();
fle.extend({
  subscriptionId: G.string().refine((e) => e.startsWith("sub_"), {
    message: "subscriptionId must start with 'sub_'"
  }).nullable(),
  subscriptionItemId: G.string().refine((e) => e.startsWith("si_"), {
    message: "subscriptionItemId must start with 'si_'"
  }).nullable()
}).partial().nullable();
G.object({
  videoCallUrl: G.string().optional()
}).and(G.record(G.string())).nullable().describe("BookingMetadata");
const ugc = G.array(
  G.object({
    label: G.string(),
    type: G.string()
  })
);
G.object({
  id: G.number(),
  eventTypeId: G.number(),
  label: G.string(),
  type: G.nativeEnum(rgc),
  options: ugc.optional().nullable(),
  required: G.boolean(),
  placeholder: G.string(),
  hasToBeCreated: G.boolean().optional()
});
const _gc = G.object({
  id: G.string(),
  room_name: G.string(),
  start_ts: G.number(),
  status: G.string(),
  max_participants: G.number().optional(),
  duration: G.number(),
  share_token: G.string()
}).passthrough(), pgc = G.array(_gc);
G.union([
  G.object({
    total_count: G.number(),
    data: pgc
  }),
  G.object({})
]);
G.union([
  G.literal(""),
  G.string().url().regex(/^http(s)?:\/\/.*/)
]).optional();
G.object({
  // Applicable only for User Forms
  emailOwnerOnSubmission: G.boolean(),
  // Applicable only for Team Forms
  sendUpdatesTo: G.array(G.number()).optional(),
  sendToAll: G.boolean().optional()
}).nullable();
G.object({
  brand: G.string().default("#292929"),
  textBrand: G.string().default("#ffffff"),
  darkBrand: G.string().default("#fafafa"),
  textDarkBrand: G.string().default("#292929"),
  bookingHighlight: G.string().default("#10B981"),
  bookingLightest: G.string().default("#E1E1E1"),
  bookingLighter: G.string().default("#ACACAC"),
  bookingLight: G.string().default("#888888"),
  bookingMedian: G.string().default("#494949"),
  bookingDark: G.string().default("#313131"),
  bookingDarker: G.string().default("#292929"),
  fontName: G.string().default("Cal Sans"),
  fontSrc: G.string().default("https://cal.com/cal.ttf")
}).optional();
G.object({
  download_link: G.string().url()
});
G.object({
  recordingId: G.string(),
  bookingUID: G.string()
});
G.object({
  download_link: G.string()
});
const V4 = {
  title: !0,
  description: !0,
  interfaceLanguage: !0,
  isInstantEvent: !0,
  instantMeetingParameters: !0,
  instantMeetingExpiryTimeOffsetInSeconds: !0,
  aiPhoneCallConfig: !0,
  currency: !0,
  periodDays: !0,
  position: !0,
  price: !0,
  slug: !0,
  length: !0,
  offsetStart: !0,
  locations: !0,
  hidden: !0,
  availability: !0,
  recurringEvent: !0,
  customInputs: !0,
  disableGuests: !0,
  disableCancelling: !0,
  disableRescheduling: !0,
  allowReschedulingCancelledBookings: !0,
  requiresConfirmation: !0,
  canSendCalVideoTranscriptionEmails: !0,
  requiresConfirmationForFreeEmail: !0,
  requiresConfirmationWillBlockSlot: !0,
  eventName: !0,
  metadata: !0,
  children: !0,
  hideCalendarNotes: !0,
  hideCalendarEventDetails: !0,
  minimumBookingNotice: !0,
  beforeEventBuffer: !0,
  afterEventBuffer: !0,
  successRedirectUrl: !0,
  seatsPerTimeSlot: !0,
  seatsShowAttendees: !0,
  seatsShowAvailabilityCount: !0,
  forwardParamsSuccessRedirect: !0,
  periodType: !0,
  hashedLink: !0,
  webhooks: !0,
  periodStartDate: !0,
  periodEndDate: !0,
  destinationCalendar: !0,
  periodCountCalendarDays: !0,
  bookingLimits: !0,
  onlyShowFirstAvailableSlot: !0,
  showOptimizedSlots: !0,
  slotInterval: !0,
  scheduleId: !0,
  workflows: !0,
  bookingFields: !0,
  durationLimits: !0,
  maxActiveBookingsPerBooker: !0,
  maxActiveBookingPerBookerOfferReschedule: !0,
  lockTimeZoneToggleOnBookingPage: !0,
  lockedTimeZone: !0,
  requiresBookerEmailVerification: !0,
  assignAllTeamMembers: !0,
  isRRWeightsEnabled: !0,
  eventTypeColor: !0,
  allowReschedulingPastBookings: !0,
  hideOrganizerEmail: !0,
  rescheduleWithSameRoundRobinHost: !0,
  maxLeadThreshold: !0,
  customReplyToEmail: !0,
  bookingRequiresAuthentication: !0
}, mgc = {
  locations: V4.locations,
  scheduleId: V4.scheduleId,
  destinationCalendar: V4.destinationCalendar
}, gle = Xfc, fgc = (e) => gle.safeParse(e).success;
G.object({
  // Username is marked optional here because it's requirement depends on if it's the Organization invite or a team invite which isn't easily done in zod
  // It's better handled beyond zod in `validateAndGetCorrectedUsernameAndEmail`
  username: G.string().optional(),
  email: G.string().regex(rle, { message: "Invalid email" }),
  password: G.string().superRefine((e, t) => {
    const o = Qfc(e, !0, !1);
    Object.keys(o).map((r) => {
      o[r] || t.addIssue({
        code: G.ZodIssueCode.custom,
        path: [r],
        message: r
      });
    });
  }),
  language: G.string().optional(),
  token: G.string().optional()
});
G.object({
  email: gle,
  code: G.string()
});
G.coerce.date();
G.object({
  description: G.string().optional(),
  responses: tA
});
G.object({
  private_key: G.string(),
  client_email: G.string().optional(),
  client_id: G.string(),
  tenant_id: G.string().optional()
}).passthrough();
tgc.nullish();
const hle = G.enum([
  "name",
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "address",
  "multiemail",
  "select",
  "multiselect",
  "checkbox",
  "radio",
  "radioInput",
  "boolean",
  "url"
]), Hx = G.string().superRefine((e, t) => {
  const n = e.split(",").map((i) => i.trim()), o = /^(?:@?[a-z0-9-]+(?:\.[a-z]{2,})?)?(?:@[a-z0-9-]+\.[a-z]{2,})?$/;
  !n.some((i) => !o.test(i)) || t.addIssue({
    code: G.ZodIssueCode.custom,
    message: "Enter valid domain or email"
  });
}), ggc = G.enum([
  "system",
  // Can't be deleted, can't be hidden, name can't be edited, can't be marked optional
  "system-but-optional",
  // Can't be deleted. Name can't be edited. But can be hidden or be marked optional
  "system-but-hidden",
  // Can't be deleted, name can't be edited, will be shown
  "user",
  // Fully editable
  "user-readonly"
  // All fields are readOnly.
]), vle = G.object({
  name: G.string().transform(ile),
  type: hle,
  // TODO: We should make at least one of `defaultPlaceholder` and `placeholder` required. Do the same for label.
  label: G.string().optional(),
  labelAsSafeHtml: G.string().optional(),
  /**
   * It is the default label that will be used when a new field is created.
   * Note: It belongs in FieldsTypeConfig, so that changing defaultLabel in code can work for existing fields as well(for fields that are using the default label).
   * Supports translation
   */
  defaultLabel: G.string().optional(),
  placeholder: G.string().optional(),
  /**
   * It is the default placeholder that will be used when a new field is created.
   * Note: Same as defaultLabel, it belongs in FieldsTypeConfig
   * Supports translation
   */
  defaultPlaceholder: G.string().optional(),
  required: G.boolean().default(!1).optional(),
  /**
   * It is the list of options that is valid for a certain type of fields.
   *
   */
  options: G.array(
    G.object({
      label: G.string(),
      value: G.string(),
      price: G.coerce.number().min(0).optional()
    })
  ).optional(),
  /**
   * This is an alternate way to specify options when the options are stored elsewhere. Form Builder expects options to be present at `dataStore[getOptionsAt]`
   * This allows keeping a single source of truth in DB.
   */
  getOptionsAt: G.string().optional(),
  /**
   * For `radioInput` type of questions, it stores the input that is shown based on the user option selected.
   * e.g. If user is given a list of locations and he selects "Phone", then he will be shown a phone input
   */
  optionsInputs: G.record(
    G.object({
      // Support all types as needed
      // Must be a subset of `fieldTypeEnum`.TODO: Enforce it in TypeScript
      type: G.enum(["address", "phone", "text"]),
      required: G.boolean().optional(),
      placeholder: G.string().optional()
    })
  ).optional(),
  /**
   * It is the minimum number of characters that can be entered in the field.
   * It is used for types with `supportsLengthCheck= true`.
   * @default 0
   * @requires supportsLengthCheck = true
   */
  minLength: G.number().optional(),
  /**
   * It is the maximum number of characters that can be entered in the field.
   * It is used for types with `supportsLengthCheck= true`.
   * @requires supportsLengthCheck = true
   */
  maxLength: G.number().optional(),
  // Emails that needs to be excluded
  excludeEmails: Hx.optional(),
  // Emails that need to be required
  requireEmails: Hx.optional(),
  // Price associated with the field which works like addons which users can add to the booking
  price: G.coerce.number().min(0).optional()
}), ble = G.object({
  variants: G.record(
    G.object({
      /**
       * Variant Fields schema for a variant of the main field.
       * It doesn't support non text fields as of now
       **/
      fields: vle.omit({
        defaultLabel: !0,
        defaultPlaceholder: !0,
        options: !0,
        getOptionsAt: !0,
        optionsInputs: !0
      }).array()
    })
  )
}), yle = vle.merge(
  G.object({
    variant: G.string().optional(),
    variantsConfig: ble.optional(),
    views: G.object({
      label: G.string(),
      id: G.string(),
      description: G.string().optional()
    }).array().optional(),
    /**
     * It is used to hide fields such as location when there are less than two options
     */
    hideWhenJustOneOption: G.boolean().default(!1).optional(),
    hidden: G.boolean().optional(),
    editable: ggc.default("user").optional(),
    sources: G.array(
      G.object({
        // Unique ID for the `type`. If type is workflow, it's the workflow ID
        id: G.string(),
        type: G.union([G.literal("user"), G.literal("system"), G.string()]),
        label: G.string(),
        editUrl: G.string().optional(),
        // Mark if a field is required by this source or not. This allows us to set `field.required` based on all the sources' fieldRequired value
        fieldRequired: G.boolean().optional()
      })
    ).optional(),
    disableOnPrefill: G.boolean().default(!1).optional()
  })
), $le = G.array(yle);
$le.element.shape.type.Enum;
const tl = (e, t, n = !0) => {
  if (typeof window > "u")
    return;
  const o = new URL(window.location.href);
  if (o.searchParams.get(e) !== t) {
    if (t === "" || t === "null") {
      OS(e, n);
      return;
    } else
      o.searchParams.set(e, `${t}`);
    n ? window.history.replaceState({ ...window.history.state, as: o.href }, "", o.href) : window.history.pushState({ ...window.history.state, as: o.href }, "", o.href);
  }
}, Ha = (e) => {
  if (!(typeof window > "u"))
    return new URLSearchParams(window.location.search).get(e);
}, OS = (e, t = !0) => {
  if (typeof window > "u")
    return;
  const n = new URL(window.location.href);
  n.searchParams.get(e) && (n.searchParams.delete(e), t ? window.history.replaceState({ ...window.history.state, as: n.href }, "", n.href) : window.history.pushState({ ...window.history.state, as: n.href }, "", n.href));
}, wle = () => Lmc((e, t) => ({
  state: "loading",
  setState: (n) => e({ state: n }),
  layout: pn.MONTH_VIEW,
  setLayout: (n) => (["week_view", "column_view"].includes(n) && !t().selectedDate && e({ selectedDate: De().format("YYYY-MM-DD") }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("layout", n), e({ layout: n })),
  selectedDate: Ha("date") || null,
  setSelectedDate: ({ date: n, omitUpdatingParams: o = !1, preventMonthSwitching: r = !1 }) => {
    if (!n) {
      OS("date");
      return;
    }
    const i = De(t().selectedDate), a = De(n);
    e({ selectedDate: n }), !o && (!t().isPlatform || t().allowUpdatingUrlParams) && tl("date", n ?? ""), !r && a.month() !== i.month() && (e({ month: a.format("YYYY-MM") }), !o && (!t().isPlatform || t().allowUpdatingUrlParams) && tl("month", a.format("YYYY-MM")));
  },
  selectedDatesAndTimes: null,
  setSelectedDatesAndTimes: (n) => {
    e({ selectedDatesAndTimes: n });
  },
  addToSelectedDate: (n) => {
    const o = De(t().selectedDate);
    let r = o.add(n, "day");
    r.isBefore(De(), "day") && (r = De());
    const i = r.format("YYYY-MM-DD");
    r.month() !== o.month() && (e({ month: r.format("YYYY-MM") }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("month", r.format("YYYY-MM"))), e({ selectedDate: i }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("date", i);
  },
  username: null,
  eventSlug: null,
  eventId: null,
  rescheduledBy: null,
  verifiedEmail: null,
  setVerifiedEmail: (n) => {
    e({ verifiedEmail: n });
  },
  verificationCode: null,
  setVerificationCode: (n) => {
    e({ verificationCode: n });
  },
  month: Ha("month") || (Ha("date") && De(Ha("date")).isValid() ? De(Ha("date")).format("YYYY-MM") : null) || De().format("YYYY-MM"),
  setMonth: (n) => {
    if (!n) {
      OS("month");
      return;
    }
    e({ month: n, selectedTimeslot: null }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("month", n ?? ""), t().setSelectedDate({ date: null });
  },
  dayCount: pD > 0 ? pD : null,
  setDayCount: (n) => {
    e({ dayCount: n });
  },
  isTeamEvent: !1,
  seatedEventData: {
    seatsPerTimeSlot: void 0,
    attendees: void 0,
    bookingUid: void 0,
    showAvailableSeatsCount: !0
  },
  setSeatedEventData: (n) => {
    e({ seatedEventData: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("bookingUid", n.bookingUid ?? "null");
  },
  // This is different from timeZone in timePreferencesStore, because timeZone in timePreferencesStore is the preferred timezone of the booker,
  // it is the timezone configured through query param. So, this is in a way the preference of the person who shared the link.
  // it is the timezone configured through query param. So, this is in a way the preference of the person who shared the link.
  timezone: Ha("cal.tz") ?? null,
  setTimezone: (n) => {
    e({ timezone: n });
  },
  initialize: ({
    username: n,
    eventSlug: o,
    month: r,
    eventId: i,
    rescheduleUid: a = null,
    rescheduledBy: s = null,
    bookingUid: c = null,
    bookingData: l = null,
    layout: d,
    isTeamEvent: u,
    durationConfig: _,
    org: p,
    isInstantMeeting: f,
    timezone: g = null,
    teamMemberEmail: h,
    crmOwnerRecordType: b,
    crmAppSlug: v,
    crmRecordId: $,
    isPlatform: k = !1,
    allowUpdatingUrlParams: S = !0
  }) => {
    var I;
    const O = t().selectedDate;
    if (!(t().username === n && t().eventSlug === o && t().month === r && t().eventId === i && t().rescheduleUid === a && t().bookingUid === c && ((I = t().bookingData) == null ? void 0 : I.responses.email) === (l == null ? void 0 : l.responses.email) && t().layout === d && t().timezone === g && t().rescheduledBy === s && t().teamMemberEmail === h && t().crmOwnerRecordType === b && t().crmAppSlug === v && t().crmRecordId === $) && (e({
      username: n,
      eventSlug: o,
      eventId: i,
      org: p,
      rescheduleUid: a,
      rescheduledBy: s,
      bookingUid: c,
      bookingData: l,
      layout: d || pn.MONTH_VIEW,
      isTeamEvent: u || !1,
      durationConfig: _,
      timezone: g,
      // Preselect today's date in week / column view, since they use this to show the week title.
      selectedDate: O || (["week_view", "column_view"].includes(d) ? De().format("YYYY-MM-DD") : null),
      teamMemberEmail: h,
      crmOwnerRecordType: b,
      crmAppSlug: v,
      crmRecordId: $,
      isPlatform: k,
      allowUpdatingUrlParams: S
    }), _ != null && _.includes(Number(Ha("duration"))) ? e({
      selectedDuration: Number(Ha("duration"))
    }) : OS("duration"), a && l && e({ selectedTimeslot: null }), r && e({ month: r }), f)) {
      const D = De().format("YYYY-MM"), M = De().format("YYYY-MM-DD"), N = (/* @__PURE__ */ new Date()).toISOString();
      e({
        month: D,
        selectedDate: M,
        selectedTimeslot: N,
        isInstantMeeting: f
      }), (!k || S) && (tl("month", D), tl("date", M ?? ""), tl("slot", N ?? "", !1));
    }
  },
  durationConfig: null,
  selectedDuration: null,
  setSelectedDuration: (n) => {
    e({ selectedDuration: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("duration", n ?? "");
  },
  setBookingData: (n) => {
    e({ bookingData: n ?? null });
  },
  setRescheduleUid: (n) => {
    e({ rescheduleUid: n });
  },
  recurringEventCount: null,
  setRecurringEventCount: (n) => e({ recurringEventCount: n }),
  occurenceCount: null,
  setOccurenceCount: (n) => e({ occurenceCount: n }),
  rescheduleUid: null,
  bookingData: null,
  bookingUid: null,
  selectedTimeslot: Ha("slot") || null,
  tentativeSelectedTimeslots: [],
  setTentativeSelectedTimeslots: (n) => {
    e({ tentativeSelectedTimeslots: n });
  },
  setSelectedTimeslot: (n) => {
    e({ selectedTimeslot: n }), (!t().isPlatform || t().allowUpdatingUrlParams) && tl("slot", n ?? "", !1);
  },
  formValues: {},
  setFormValues: (n) => {
    e({ formValues: n });
  },
  org: null,
  setOrg: (n) => {
    e({ org: n });
  },
  isPlatform: !1,
  allowUpdatingUrlParams: !0
})), Ic = wle(), kle = ({
  username: e,
  eventSlug: t,
  month: n,
  eventId: o,
  rescheduleUid: r = null,
  rescheduledBy: i = null,
  bookingData: a = null,
  verifiedEmail: s = null,
  layout: c,
  isTeamEvent: l,
  durationConfig: d,
  org: u,
  isInstantMeeting: _,
  timezone: p = null,
  teamMemberEmail: f,
  crmOwnerRecordType: g,
  crmAppSlug: h,
  crmRecordId: b,
  isPlatform: v = !1,
  allowUpdatingUrlParams: $ = !0
}) => {
  const k = Ic((S) => S.initialize);
  Le(() => {
    k({
      username: e,
      eventSlug: t,
      month: n,
      eventId: o,
      rescheduleUid: r,
      rescheduledBy: i,
      bookingData: a,
      layout: c,
      isTeamEvent: l,
      org: u,
      verifiedEmail: s,
      durationConfig: d,
      isInstantMeeting: _,
      timezone: p,
      teamMemberEmail: f,
      crmOwnerRecordType: g,
      crmAppSlug: h,
      crmRecordId: b,
      isPlatform: v,
      allowUpdatingUrlParams: $
    });
  }, [
    k,
    u,
    e,
    t,
    n,
    o,
    r,
    i,
    a,
    c,
    l,
    s,
    d,
    _,
    p,
    f,
    g,
    h,
    b,
    v,
    $
  ]);
}, nA = No(null), Xv = ({ children: e }) => {
  const t = Ue();
  return t.current || (t.current = wle()), /* @__PURE__ */ m(nA.Provider, { value: t.current, children: e });
}, St = (e, t) => {
  const n = Pn(nA);
  if (!n)
    throw new Error("useBookerStoreContext must be used within BookerStoreProvider");
  return _9(n, e, t);
}, h9 = ({
  username: e,
  eventSlug: t,
  month: n,
  eventId: o,
  rescheduleUid: r = null,
  rescheduledBy: i = null,
  bookingData: a = null,
  verifiedEmail: s = null,
  layout: c,
  isTeamEvent: l,
  durationConfig: d,
  org: u,
  isInstantMeeting: _,
  timezone: p = null,
  teamMemberEmail: f,
  crmOwnerRecordType: g,
  crmAppSlug: h,
  crmRecordId: b,
  isPlatform: v = !1,
  allowUpdatingUrlParams: $ = !0
}) => {
  const k = Pn(nA);
  if (!k)
    throw new Error("useInitializeBookerStoreContext must be used within BookerStoreProvider");
  const S = _9(k, (O) => O.initialize);
  Le(() => {
    S({
      username: e,
      eventSlug: t,
      month: n,
      eventId: o,
      rescheduleUid: r,
      rescheduledBy: i,
      bookingData: a,
      layout: c,
      isTeamEvent: l,
      org: u,
      verifiedEmail: s,
      durationConfig: d,
      isInstantMeeting: _,
      timezone: p,
      teamMemberEmail: f,
      crmOwnerRecordType: g,
      crmAppSlug: h,
      crmRecordId: b,
      isPlatform: v,
      allowUpdatingUrlParams: $
    });
  }, [
    S,
    u,
    e,
    t,
    n,
    o,
    r,
    i,
    a,
    c,
    l,
    s,
    d,
    _,
    p,
    f,
    g,
    h,
    b,
    v,
    $
  ]);
}, Sle = "Dialog", [xle, efd] = os(Sle), [hgc, md] = xle(Sle), vgc = (e) => {
  const { __scopeDialog: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: a = !0 } = e, s = Ue(null), c = Ue(null), [l = !1, d] = jc({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ Pe(hgc, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: Cc(),
    titleId: Cc(),
    descriptionId: Cc(),
    open: l,
    onOpenChange: d,
    onOpenToggle: at(
      () => d(
        (u) => !u
      ),
      [
        d
      ]
    ),
    modal: a
  }, n);
}, bgc = "DialogTrigger", ygc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = md(bgc, n), i = or(t, r.triggerRef);
  return /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": v9(r.open)
  }, o, {
    ref: i,
    onClick: Bt(e.onClick, r.onOpenToggle)
  }));
}), Ele = "DialogPortal", [$gc, Tle] = xle(Ele, {
  forceMount: void 0
}), wgc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, i = md(Ele, t);
  return /* @__PURE__ */ Pe($gc, {
    scope: t,
    forceMount: n
  }, Dp.map(
    o,
    (a) => /* @__PURE__ */ Pe(rs, {
      present: n || i.open
    }, /* @__PURE__ */ Pe(Lq, {
      asChild: !0,
      container: r
    }, a))
  ));
}, $D = "DialogOverlay", kgc = /* @__PURE__ */ it((e, t) => {
  const n = Tle($D, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = md($D, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Pe(rs, {
    present: o || i.open
  }, /* @__PURE__ */ Pe(Sgc, We({}, r, {
    ref: t
  }))) : null;
}), Sgc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = md($D, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Pe(n9, {
      as: Df,
      allowPinchZoom: !0,
      shards: [
        r.contentRef
      ]
    }, /* @__PURE__ */ Pe(io.div, We({
      "data-state": v9(r.open)
    }, o, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...o.style
      }
    })))
  );
}), Sw = "DialogContent", xgc = /* @__PURE__ */ it((e, t) => {
  const n = Tle(Sw, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = md(Sw, e.__scopeDialog);
  return /* @__PURE__ */ Pe(rs, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ Pe(Egc, We({}, r, {
    ref: t
  })) : /* @__PURE__ */ Pe(Tgc, We({}, r, {
    ref: t
  })));
}), Egc = /* @__PURE__ */ it((e, t) => {
  const n = md(Sw, e.__scopeDialog), o = Ue(null), r = or(t, n.contentRef, o);
  return Le(() => {
    const i = o.current;
    if (i)
      return t9(i);
  }, []), /* @__PURE__ */ Pe(Ale, We({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Bt(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Bt(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && i.preventDefault();
    }),
    onFocusOutside: Bt(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), Tgc = /* @__PURE__ */ it((e, t) => {
  const n = md(Sw, e.__scopeDialog), o = Ue(!1), r = Ue(!1);
  return /* @__PURE__ */ Pe(Ale, We({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      o.current = !1, r.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
    }
  }));
}), Ale = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, ...a } = e, s = md(Sw, n), c = Ue(null), l = or(t, c);
  return Zq(), /* @__PURE__ */ Pe(Oi, null, /* @__PURE__ */ Pe(Qq, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Pe(jT, We({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": v9(s.open)
  }, a, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Agc = "DialogTitle", Cgc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = md(Agc, n);
  return /* @__PURE__ */ Pe(io.h2, We({
    id: r.titleId
  }, o, {
    ref: t
  }));
}), zgc = "DialogDescription", Ogc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = md(zgc, n);
  return /* @__PURE__ */ Pe(io.p, We({
    id: r.descriptionId
  }, o, {
    ref: t
  }));
}), Pgc = "DialogClose", Igc = /* @__PURE__ */ it((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = md(Pgc, n);
  return /* @__PURE__ */ Pe(io.button, We({
    type: "button"
  }, o, {
    ref: t,
    onClick: Bt(
      e.onClick,
      () => r.onOpenChange(!1)
    )
  }));
});
function v9(e) {
  return e ? "open" : "closed";
}
const Cle = vgc, zle = ygc, Ole = wgc, b9 = kgc, y9 = xgc, $9 = Cgc, w9 = Ogc, Ple = Igc, k9 = Cle, Ile = zle, Rgc = Ole, Rle = ({ children: e }) => /* @__PURE__ */ m(Ole, { className: "calcom-atoms", children: /* @__PURE__ */ m("div", { className: "calcom-atoms", children: e }) }), Nle = Cle, Dle = zle, Mle = b9, Lle = y9, qle = $9, jle = w9, S9 = Ple, Fle = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  b9,
  {
    ref: n,
    className: uo(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t
  }
));
Fle.displayName = b9.displayName;
const x9 = $e.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(Rgc, { children: /* @__PURE__ */ Y("div", { className: "calcom-atoms", children: [
  /* @__PURE__ */ m(Fle, {}),
  /* @__PURE__ */ Y(
    y9,
    {
      ref: o,
      className: uo(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ Y(Ple, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ m(ot, { name: "x", className: "h-4 w-4" }),
          /* @__PURE__ */ m("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }) }) }));
x9.displayName = y9.displayName;
const Vle = ({ className: e, ...t }) => /* @__PURE__ */ m("div", { className: uo("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
Vle.displayName = "DialogHeader";
const Ble = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  $9,
  {
    ref: n,
    className: uo("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Ble.displayName = $9.displayName;
const Ule = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  w9,
  {
    ref: n,
    className: uo("text-muted-foreground text-sm", e),
    ...t
  }
));
Ule.displayName = w9.displayName;
var wD = { exports: {} }, Wle = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, d) {
    for (var u in d)
      Object.defineProperty(l, u, {
        enumerable: !0,
        get: d[u]
      });
  }
  t(e, {
    AppRouterContext: function() {
      return r;
    },
    GlobalLayoutRouterContext: function() {
      return a;
    },
    LayoutRouterContext: function() {
      return i;
    },
    MissingSlotContext: function() {
      return c;
    },
    TemplateContext: function() {
      return s;
    }
  });
  const o = /* @__PURE__ */ sm._(ve), r = o.default.createContext(null), i = o.default.createContext(null), a = o.default.createContext(null), s = o.default.createContext(null), c = o.default.createContext(/* @__PURE__ */ new Set());
})(Wle);
var Gle = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(a, s) {
    for (var c in s)
      Object.defineProperty(a, c, {
        enumerable: !0,
        get: s[c]
      });
  }
  t(e, {
    PathParamsContext: function() {
      return i;
    },
    PathnameContext: function() {
      return r;
    },
    SearchParamsContext: function() {
      return o;
    }
  });
  const n = ve, o = (0, n.createContext)(null), r = (0, n.createContext)(null), i = (0, n.createContext)(null);
})(Gle);
var kD = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getSegmentValue", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function n(o) {
    return Array.isArray(o) ? o[1] : o;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(kD, kD.exports);
var Ngc = kD.exports, SD = { exports: {} }, xD = { exports: {} }, ED = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "RedirectStatusCode", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  var n = /* @__PURE__ */ function(o) {
    return o[o.SeeOther = 303] = "SeeOther", o[o.TemporaryRedirect = 307] = "TemporaryRedirect", o[o.PermanentRedirect = 308] = "PermanentRedirect", o;
  }({});
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(ED, ED.exports);
var Hle = ED.exports, TD = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(s, c) {
    for (var l in c)
      Object.defineProperty(s, l, {
        enumerable: !0,
        get: c[l]
      });
  }
  n(t, {
    REDIRECT_ERROR_CODE: function() {
      return r;
    },
    RedirectType: function() {
      return i;
    },
    isRedirectError: function() {
      return a;
    }
  });
  const o = Hle, r = "NEXT_REDIRECT";
  var i = /* @__PURE__ */ function(s) {
    return s.push = "push", s.replace = "replace", s;
  }({});
  function a(s) {
    if (typeof s != "object" || s === null || !("digest" in s) || typeof s.digest != "string")
      return !1;
    const c = s.digest.split(";"), [l, d] = c, u = c.slice(2, -2).join(";"), _ = c.at(-2), p = Number(_);
    return l === r && (d === "replace" || d === "push") && typeof u == "string" && !isNaN(p) && p in o.RedirectStatusCode;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(TD, TD.exports);
var E9 = TD.exports, B4 = {}, U4 = {}, W4 = {}, iG;
function T9() {
  return iG || (iG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var d in l)
        Object.defineProperty(c, d, {
          enumerable: !0,
          get: l[d]
        });
    }
    t(e, {
      bindSnapshot: function() {
        return a;
      },
      createAsyncLocalStorage: function() {
        return i;
      },
      createSnapshot: function() {
        return s;
      }
    });
    const n = Object.defineProperty(new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available"), "__NEXT_ERROR_CODE", {
      value: "E504",
      enumerable: !1,
      configurable: !0
    });
    class o {
      disable() {
        throw n;
      }
      getStore() {
      }
      run() {
        throw n;
      }
      exit() {
        throw n;
      }
      enterWith() {
        throw n;
      }
      static bind(l) {
        return l;
      }
    }
    const r = typeof globalThis < "u" && globalThis.AsyncLocalStorage;
    function i() {
      return r ? new r() : new o();
    }
    function a(c) {
      return r ? r.bind(c) : o.bind(c);
    }
    function s() {
      return r ? r.snapshot() : function(c, ...l) {
        return c(...l);
      };
    }
  }(W4)), W4;
}
var aG;
function Dgc() {
  return aG || (aG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, T9().createAsyncLocalStorage)();
  }(U4)), U4;
}
var sG;
function Mgc() {
  return sG || (sG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.actionAsyncStorageInstance;
      }
    });
    const t = Dgc();
  }(B4)), B4;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(_, p) {
    for (var f in p)
      Object.defineProperty(_, f, {
        enumerable: !0,
        get: p[f]
      });
  }
  n(t, {
    getRedirectError: function() {
      return a;
    },
    getRedirectStatusCodeFromError: function() {
      return u;
    },
    getRedirectTypeFromError: function() {
      return d;
    },
    getURLFromRedirectError: function() {
      return l;
    },
    permanentRedirect: function() {
      return c;
    },
    redirect: function() {
      return s;
    }
  });
  const o = Hle, r = E9, i = typeof window > "u" ? Mgc().actionAsyncStorage : void 0;
  function a(_, p, f) {
    f === void 0 && (f = o.RedirectStatusCode.TemporaryRedirect);
    const g = Object.defineProperty(new Error(r.REDIRECT_ERROR_CODE), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    return g.digest = r.REDIRECT_ERROR_CODE + ";" + p + ";" + _ + ";" + f + ";", g;
  }
  function s(_, p) {
    var f;
    throw p ?? (p = !(i == null || (f = i.getStore()) == null) && f.isAction ? r.RedirectType.push : r.RedirectType.replace), a(_, p, o.RedirectStatusCode.TemporaryRedirect);
  }
  function c(_, p) {
    throw p === void 0 && (p = r.RedirectType.replace), a(_, p, o.RedirectStatusCode.PermanentRedirect);
  }
  function l(_) {
    return (0, r.isRedirectError)(_) ? _.digest.split(";").slice(2, -2).join(";") : null;
  }
  function d(_) {
    if (!(0, r.isRedirectError)(_))
      throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0
      });
    return _.digest.split(";", 2)[1];
  }
  function u(_) {
    if (!(0, r.isRedirectError)(_))
      throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
        value: "E260",
        enumerable: !1,
        configurable: !0
      });
    return Number(_.digest.split(";").at(-2));
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(xD, xD.exports);
var Lgc = xD.exports, AD = { exports: {} }, CD = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(l, d) {
    for (var u in d)
      Object.defineProperty(l, u, {
        enumerable: !0,
        get: d[u]
      });
  }
  n(t, {
    HTTPAccessErrorStatus: function() {
      return o;
    },
    HTTP_ERROR_FALLBACK_ERROR_CODE: function() {
      return i;
    },
    getAccessFallbackErrorTypeByStatus: function() {
      return c;
    },
    getAccessFallbackHTTPStatus: function() {
      return s;
    },
    isHTTPAccessFallbackError: function() {
      return a;
    }
  });
  const o = {
    NOT_FOUND: 404,
    FORBIDDEN: 403,
    UNAUTHORIZED: 401
  }, r = new Set(Object.values(o)), i = "NEXT_HTTP_ERROR_FALLBACK";
  function a(l) {
    if (typeof l != "object" || l === null || !("digest" in l) || typeof l.digest != "string")
      return !1;
    const [d, u] = l.digest.split(";");
    return d === i && r.has(Number(u));
  }
  function s(l) {
    const d = l.digest.split(";")[1];
    return Number(d);
  }
  function c(l) {
    switch (l) {
      case 401:
        return "unauthorized";
      case 403:
        return "forbidden";
      case 404:
        return "not-found";
      default:
        return;
    }
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(CD, CD.exports);
var oA = CD.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "notFound", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const o = "" + oA.HTTP_ERROR_FALLBACK_ERROR_CODE + ";404";
  function r() {
    const i = Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw i.digest = o, i;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(AD, AD.exports);
var qgc = AD.exports, zD = { exports: {} };
(function(e, t) {
  var n = {};
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "forbidden", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const r = "" + oA.HTTP_ERROR_FALLBACK_ERROR_CODE + ";403";
  function i() {
    if (!n.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
      throw Object.defineProperty(new Error("`forbidden()` is experimental and only allowed to be enabled when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
        value: "E488",
        enumerable: !1,
        configurable: !0
      });
    const a = Object.defineProperty(new Error(r), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw a.digest = r, a;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(zD, zD.exports);
var jgc = zD.exports, OD = { exports: {} };
(function(e, t) {
  var n = {};
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "unauthorized", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const r = "" + oA.HTTP_ERROR_FALLBACK_ERROR_CODE + ";401";
  function i() {
    if (!n.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
      throw Object.defineProperty(new Error("`unauthorized()` is experimental and only allowed to be used when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
        value: "E411",
        enumerable: !1,
        configurable: !0
      });
    const a = Object.defineProperty(new Error(r), "__NEXT_ERROR_CODE", {
      value: "E394",
      enumerable: !1,
      configurable: !0
    });
    throw a.digest = r, a;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(OD, OD.exports);
var Fgc = OD.exports, PD = { exports: {} }, u2 = { exports: {} }, G4 = {}, cG;
function rA() {
  return cG || (cG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var s in a)
        Object.defineProperty(i, s, {
          enumerable: !0,
          get: a[s]
        });
    }
    t(e, {
      BailoutToCSRError: function() {
        return o;
      },
      isBailoutToCSRError: function() {
        return r;
      }
    });
    const n = "BAILOUT_TO_CLIENT_SIDE_RENDERING";
    class o extends Error {
      constructor(a) {
        super("Bail out to client-side rendering: " + a), this.reason = a, this.digest = n;
      }
    }
    function r(i) {
      return typeof i != "object" || i === null || !("digest" in i) ? !1 : i.digest === n;
    }
  }(G4)), G4;
}
var _2 = { exports: {} }, lG;
function Kle() {
  return lG || (lG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isNextRouterError", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = oA, o = E9;
    function r(i) {
      return (0, o.isRedirectError)(i) || (0, n.isHTTPAccessFallbackError)(i);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(_2, _2.exports)), _2.exports;
}
var dG;
function Vgc() {
  return dG || (dG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = rA(), o = Kle();
    function r(i) {
      if ((0, o.isNextRouterError)(i) || (0, n.isBailoutToCSRError)(i))
        throw i;
      i instanceof Error && "cause" in i && r(i.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(u2, u2.exports)), u2.exports;
}
var p2 = { exports: {} }, H4 = {}, uG;
function Yle() {
  return uG || (uG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, d) {
      for (var u in d)
        Object.defineProperty(l, u, {
          enumerable: !0,
          get: d[u]
        });
    }
    t(e, {
      isHangingPromiseRejectionError: function() {
        return n;
      },
      makeDevtoolsIOAwarePromise: function() {
        return c;
      },
      makeHangingPromise: function() {
        return a;
      }
    });
    function n(l) {
      return typeof l != "object" || l === null || !("digest" in l) ? !1 : l.digest === o;
    }
    const o = "HANGING_PROMISE_REJECTION";
    class r extends Error {
      constructor(d, u) {
        super(`During prerendering, ${u} rejects when the prerender is complete. Typically these errors are handled by React but if you move ${u} to a different context by using \`setTimeout\`, \`after\`, or similar functions you may observe this error and you should handle it in that context. This occurred at route "${d}".`), this.route = d, this.expression = u, this.digest = o;
      }
    }
    const i = /* @__PURE__ */ new WeakMap();
    function a(l, d, u) {
      if (l.aborted)
        return Promise.reject(new r(d, u));
      {
        const _ = new Promise((p, f) => {
          const g = f.bind(null, new r(d, u));
          let h = i.get(l);
          if (h)
            h.push(g);
          else {
            const b = [
              g
            ];
            i.set(l, b), l.addEventListener("abort", () => {
              for (let v = 0; v < b.length; v++)
                b[v]();
            }, {
              once: !0
            });
          }
        });
        return _.catch(s), _;
      }
    }
    function s() {
    }
    function c(l) {
      return new Promise((d) => {
        setTimeout(() => {
          d(l);
        }, 0);
      });
    }
  }(H4)), H4;
}
var K4 = {}, _G;
function Bgc() {
  return _G || (_G = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isPostpone", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = Symbol.for("react.postpone");
    function n(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
  }(K4)), K4;
}
var Y4 = {}, m2 = { exports: {} }, pG;
function Zle() {
  return pG || (pG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    n(t, {
      DynamicServerError: function() {
        return r;
      },
      isDynamicServerError: function() {
        return i;
      }
    });
    const o = "DYNAMIC_SERVER_USAGE";
    class r extends Error {
      constructor(s) {
        super("Dynamic server usage: " + s), this.description = s, this.digest = o;
      }
    }
    function i(a) {
      return typeof a != "object" || a === null || !("digest" in a) || typeof a.digest != "string" ? !1 : a.digest === o;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(m2, m2.exports)), m2.exports;
}
var f2 = { exports: {} }, mG;
function Ugc() {
  return mG || (mG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    n(t, {
      StaticGenBailoutError: function() {
        return r;
      },
      isStaticGenBailoutError: function() {
        return i;
      }
    });
    const o = "NEXT_STATIC_GEN_BAILOUT";
    class r extends Error {
      constructor(...s) {
        super(...s), this.code = o;
      }
    }
    function i(a) {
      return typeof a != "object" || a === null || !("code" in a) ? !1 : a.code === o;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(f2, f2.exports)), f2.exports;
}
var Z4 = {}, Q4 = {}, fG;
function Wgc() {
  return fG || (fG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workUnitAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, T9().createAsyncLocalStorage)();
  }(Q4)), Q4;
}
var g2 = { exports: {} }, gG;
function Ggc() {
  return gG || (gG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(k, S) {
      for (var O in S)
        Object.defineProperty(k, O, {
          enumerable: !0,
          get: S[O]
        });
    }
    n(t, {
      ACTION_HEADER: function() {
        return r;
      },
      FLIGHT_HEADERS: function() {
        return _;
      },
      NEXT_ACTION_NOT_FOUND_HEADER: function() {
        return $;
      },
      NEXT_DID_POSTPONE_HEADER: function() {
        return g;
      },
      NEXT_HMR_REFRESH_HASH_COOKIE: function() {
        return l;
      },
      NEXT_HMR_REFRESH_HEADER: function() {
        return c;
      },
      NEXT_IS_PRERENDER_HEADER: function() {
        return v;
      },
      NEXT_REWRITTEN_PATH_HEADER: function() {
        return h;
      },
      NEXT_REWRITTEN_QUERY_HEADER: function() {
        return b;
      },
      NEXT_ROUTER_PREFETCH_HEADER: function() {
        return a;
      },
      NEXT_ROUTER_SEGMENT_PREFETCH_HEADER: function() {
        return s;
      },
      NEXT_ROUTER_STALE_TIME_HEADER: function() {
        return f;
      },
      NEXT_ROUTER_STATE_TREE_HEADER: function() {
        return i;
      },
      NEXT_RSC_UNION_QUERY: function() {
        return p;
      },
      NEXT_URL: function() {
        return d;
      },
      RSC_CONTENT_TYPE_HEADER: function() {
        return u;
      },
      RSC_HEADER: function() {
        return o;
      }
    });
    const o = "rsc", r = "next-action", i = "next-router-state-tree", a = "next-router-prefetch", s = "next-router-segment-prefetch", c = "next-hmr-refresh", l = "__next_hmr_refresh_hash__", d = "next-url", u = "text/x-component", _ = [
      o,
      i,
      a,
      c,
      s
    ], p = "_rsc", f = "x-nextjs-stale-time", g = "x-nextjs-postponed", h = "x-nextjs-rewritten-path", b = "x-nextjs-rewritten-query", v = "x-nextjs-prerender", $ = "x-nextjs-action-not-found";
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(g2, g2.exports)), g2.exports;
}
var J4 = {}, hG;
function Qle() {
  return hG || (hG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "InvariantError", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    class t extends Error {
      constructor(o, r) {
        super("Invariant: " + (o.endsWith(".") ? o : o + ".") + " This is a bug in Next.js.", r), this.name = "InvariantError";
      }
    }
  }(J4)), J4;
}
var vG;
function Jle() {
  return vG || (vG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(g, h) {
      for (var b in h)
        Object.defineProperty(g, b, {
          enumerable: !0,
          get: h[b]
        });
    }
    t(e, {
      getCacheSignal: function() {
        return p;
      },
      getDraftModeProviderForCacheScope: function() {
        return _;
      },
      getHmrRefreshHash: function() {
        return l;
      },
      getPrerenderResumeDataCache: function() {
        return s;
      },
      getRenderResumeDataCache: function() {
        return c;
      },
      getRuntimeStagePromise: function() {
        return f;
      },
      getServerComponentsHmrCache: function() {
        return u;
      },
      isHmrRefresh: function() {
        return d;
      },
      throwForMissingRequestStore: function() {
        return i;
      },
      throwInvariantForMissingStore: function() {
        return a;
      },
      workUnitAsyncStorage: function() {
        return n.workUnitAsyncStorageInstance;
      }
    });
    const n = Wgc(), o = Ggc(), r = Qle();
    function i(g) {
      throw Object.defineProperty(new Error(`\`${g}\` was called outside a request scope. Read more: https://nextjs.org/docs/messages/next-dynamic-api-wrong-context`), "__NEXT_ERROR_CODE", {
        value: "E251",
        enumerable: !1,
        configurable: !0
      });
    }
    function a() {
      throw Object.defineProperty(new r.InvariantError("Expected workUnitAsyncStorage to have a store."), "__NEXT_ERROR_CODE", {
        value: "E696",
        enumerable: !1,
        configurable: !0
      });
    }
    function s(g) {
      switch (g.type) {
        case "prerender":
        case "prerender-runtime":
        case "prerender-ppr":
          return g.prerenderResumeDataCache;
        case "prerender-client":
          return g.prerenderResumeDataCache;
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return null;
        default:
          return g;
      }
    }
    function c(g) {
      switch (g.type) {
        case "request":
          return g.renderResumeDataCache;
        case "prerender":
        case "prerender-runtime":
        case "prerender-client":
          if (g.renderResumeDataCache)
            return g.renderResumeDataCache;
        case "prerender-ppr":
          return g.prerenderResumeDataCache;
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "prerender-legacy":
          return null;
        default:
          return g;
      }
    }
    function l(g, h) {
      if (g.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "prerender":
          case "prerender-runtime":
            return h.hmrRefreshHash;
          case "request":
            var b;
            return (b = h.cookies.get(o.NEXT_HMR_REFRESH_HASH_COOKIE)) == null ? void 0 : b.value;
        }
    }
    function d(g, h) {
      if (g.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "request":
            return h.isHmrRefresh ?? !1;
        }
      return !1;
    }
    function u(g, h) {
      if (g.dev)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "request":
            return h.serverComponentsHmrCache;
        }
    }
    function _(g, h) {
      if (g.isDraftMode)
        switch (h.type) {
          case "cache":
          case "private-cache":
          case "unstable-cache":
          case "prerender-runtime":
          case "request":
            return h.draftMode;
        }
    }
    function p(g) {
      switch (g.type) {
        case "prerender":
        case "prerender-client":
        case "prerender-runtime":
          return g.cacheSignal;
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return null;
        default:
          return g;
      }
    }
    function f(g) {
      switch (g.type) {
        case "prerender-runtime":
        case "private-cache":
          return g.runtimeStagePromise;
        case "prerender":
        case "prerender-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "unstable-cache":
          return null;
        default:
          return g;
      }
    }
  }(Z4)), Z4;
}
var X4 = {}, e3 = {}, bG;
function Hgc() {
  return bG || (bG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, T9().createAsyncLocalStorage)();
  }(e3)), e3;
}
var yG;
function Xle() {
  return yG || (yG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.workAsyncStorageInstance;
      }
    });
    const t = Hgc();
  }(X4)), X4;
}
var t3 = {}, $G;
function Kgc() {
  return $G || ($G = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, s) {
      for (var c in s)
        Object.defineProperty(a, c, {
          enumerable: !0,
          get: s[c]
        });
    }
    t(e, {
      METADATA_BOUNDARY_NAME: function() {
        return n;
      },
      OUTLET_BOUNDARY_NAME: function() {
        return r;
      },
      ROOT_LAYOUT_BOUNDARY_NAME: function() {
        return i;
      },
      VIEWPORT_BOUNDARY_NAME: function() {
        return o;
      }
    });
    const n = "__next_metadata_boundary__", o = "__next_viewport_boundary__", r = "__next_outlet_boundary__", i = "__next_root_layout_boundary__";
  }(t3)), t3;
}
var n3 = {}, wG;
function Ygc() {
  return wG || (wG = 1, function(e) {
    var t = {};
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function n(s, c) {
      for (var l in c)
        Object.defineProperty(s, l, {
          enumerable: !0,
          get: c[l]
        });
    }
    n(e, {
      atLeastOneTask: function() {
        return i;
      },
      scheduleImmediate: function() {
        return r;
      },
      scheduleOnNextTick: function() {
        return o;
      },
      waitAtLeastOneReactRenderTask: function() {
        return a;
      }
    });
    const o = (s) => {
      Promise.resolve().then(() => {
        t.NEXT_RUNTIME === "edge" ? setTimeout(s, 0) : process.nextTick(s);
      });
    }, r = (s) => {
      t.NEXT_RUNTIME === "edge" ? setTimeout(s, 0) : setImmediate(s);
    };
    function i() {
      return new Promise((s) => r(s));
    }
    function a() {
      return t.NEXT_RUNTIME === "edge" ? new Promise((s) => setTimeout(s, 0)) : new Promise((s) => setImmediate(s));
    }
  }(n3)), n3;
}
var kG;
function ede() {
  return kG || (kG = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(se, me) {
      for (var pe in me)
        Object.defineProperty(se, pe, {
          enumerable: !0,
          get: me[pe]
        });
    }
    t(e, {
      Postpone: function() {
        return N;
      },
      PreludeState: function() {
        return de;
      },
      abortAndThrowOnSynchronousRequestDataAccess: function() {
        return I;
      },
      abortOnSynchronousPlatformIOAccess: function() {
        return S;
      },
      accessedDynamicData: function() {
        return j;
      },
      annotateDynamicAccess: function() {
        return W;
      },
      consumeDynamicAccess: function() {
        return q;
      },
      createDynamicTrackingState: function() {
        return f;
      },
      createDynamicValidationState: function() {
        return g;
      },
      createHangingInputAbortSignal: function() {
        return U;
      },
      createRenderInBrowserAbortSignal: function() {
        return L;
      },
      delayUntilRuntimeStage: function() {
        return le;
      },
      formatDynamicAPIAccesses: function() {
        return V;
      },
      getFirstDynamicReason: function() {
        return h;
      },
      isDynamicPostpone: function() {
        return x;
      },
      isPrerenderInterruptedError: function() {
        return z;
      },
      logDisallowedDynamicError: function() {
        return te;
      },
      markCurrentScopeAsDynamic: function() {
        return b;
      },
      postponeWithTracking: function() {
        return C;
      },
      throwIfDisallowedDynamic: function() {
        return ue;
      },
      throwToInterruptStaticGeneration: function() {
        return v;
      },
      trackAllowedDynamicAccess: function() {
        return oe;
      },
      trackDynamicDataInDynamicRender: function() {
        return $;
      },
      trackSynchronousPlatformIOAccessInDev: function() {
        return O;
      },
      trackSynchronousRequestDataAccessInDev: function() {
        return M;
      },
      useDynamicRouteParams: function() {
        return H;
      },
      warnOnSyncDynamicError: function() {
        return D;
      }
    });
    const n = /* @__PURE__ */ _(ve), o = Zle(), r = Ugc(), i = Jle(), a = Xle(), s = Yle(), c = Kgc(), l = Ygc(), d = rA(), u = Qle();
    function _(se) {
      return se && se.__esModule ? se : {
        default: se
      };
    }
    const p = typeof n.default.unstable_postpone == "function";
    function f(se) {
      return {
        isDebugDynamicAccesses: se,
        dynamicAccesses: [],
        syncDynamicErrorWithStack: null
      };
    }
    function g() {
      return {
        hasSuspenseAboveBody: !1,
        hasDynamicMetadata: !1,
        hasDynamicViewport: !1,
        hasAllowedDynamic: !1,
        dynamicErrors: []
      };
    }
    function h(se) {
      var me;
      return (me = se.dynamicAccesses[0]) == null ? void 0 : me.expression;
    }
    function b(se, me, pe) {
      if (me)
        switch (me.type) {
          case "cache":
          case "unstable-cache":
            return;
          case "private-cache":
            return;
        }
      if (!(se.forceDynamic || se.forceStatic)) {
        if (se.dynamicShouldError)
          throw Object.defineProperty(new r.StaticGenBailoutError(`Route ${se.route} with \`dynamic = "error"\` couldn't be rendered statically because it used \`${pe}\`. See more info here: https://nextjs.org/docs/app/building-your-application/rendering/static-and-dynamic#dynamic-rendering`), "__NEXT_ERROR_CODE", {
            value: "E553",
            enumerable: !1,
            configurable: !0
          });
        if (me)
          switch (me.type) {
            case "prerender-ppr":
              return C(se.route, pe, me.dynamicTracking);
            case "prerender-legacy":
              me.revalidate = 0;
              const be = Object.defineProperty(new o.DynamicServerError(`Route ${se.route} couldn't be rendered statically because it used ${pe}. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
                value: "E550",
                enumerable: !1,
                configurable: !0
              });
              throw se.dynamicUsageDescription = pe, se.dynamicUsageStack = be.stack, be;
          }
      }
    }
    function v(se, me, pe) {
      const be = Object.defineProperty(new o.DynamicServerError(`Route ${me.route} couldn't be rendered statically because it used \`${se}\`. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
        value: "E558",
        enumerable: !1,
        configurable: !0
      });
      throw pe.revalidate = 0, me.dynamicUsageDescription = se, me.dynamicUsageStack = be.stack, be;
    }
    function $(se) {
      switch (se.type) {
        case "cache":
        case "unstable-cache":
          return;
        case "private-cache":
          return;
      }
    }
    function k(se, me, pe) {
      const be = `Route ${se} needs to bail out of prerendering at this point because it used ${me}.`, Se = T(be);
      pe.controller.abort(Se);
      const Ae = pe.dynamicTracking;
      Ae && Ae.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: Ae.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: me
      });
    }
    function S(se, me, pe, be) {
      const Se = be.dynamicTracking;
      k(se, me, be), Se && Se.syncDynamicErrorWithStack === null && (Se.syncDynamicErrorWithStack = pe);
    }
    function O(se) {
      se.prerenderPhase = !1;
    }
    function I(se, me, pe, be) {
      if (be.controller.signal.aborted === !1) {
        k(se, me, be);
        const Ae = be.dynamicTracking;
        Ae && Ae.syncDynamicErrorWithStack === null && (Ae.syncDynamicErrorWithStack = pe);
      }
      throw T(`Route ${se} needs to bail out of prerendering at this point because it used ${me}.`);
    }
    function D(se) {
      se.syncDynamicErrorWithStack && console.error(se.syncDynamicErrorWithStack);
    }
    const M = O;
    function N({ reason: se, route: me }) {
      const pe = i.workUnitAsyncStorage.getStore(), be = pe && pe.type === "prerender-ppr" ? pe.dynamicTracking : null;
      C(me, se, be);
    }
    function C(se, me, pe) {
      F(), pe && pe.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: pe.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: me
      }), n.default.unstable_postpone(P(se, me));
    }
    function P(se, me) {
      return `Route ${se} needs to bail out of prerendering at this point because it used ${me}. React throws this special object to indicate where. It should not be caught by your own try/catch. Learn more: https://nextjs.org/docs/messages/ppr-caught-error`;
    }
    function x(se) {
      return typeof se == "object" && se !== null && typeof se.message == "string" ? w(se.message) : !1;
    }
    function w(se) {
      return se.includes("needs to bail out of prerendering at this point because it used") && se.includes("Learn more: https://nextjs.org/docs/messages/ppr-caught-error");
    }
    if (w(P("%%%", "^^^")) === !1)
      throw Object.defineProperty(new Error("Invariant: isDynamicPostpone misidentified a postpone reason. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
        value: "E296",
        enumerable: !1,
        configurable: !0
      });
    const E = "NEXT_PRERENDER_INTERRUPTED";
    function T(se) {
      const me = Object.defineProperty(new Error(se), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return me.digest = E, me;
    }
    function z(se) {
      return typeof se == "object" && se !== null && se.digest === E && "name" in se && "message" in se && se instanceof Error;
    }
    function j(se) {
      return se.length > 0;
    }
    function q(se, me) {
      return se.dynamicAccesses.push(...me.dynamicAccesses), se.dynamicAccesses;
    }
    function V(se) {
      return se.filter((me) => typeof me.stack == "string" && me.stack.length > 0).map(({ expression: me, stack: pe }) => (pe = pe.split(`
`).slice(4).filter((be) => !(be.includes("node_modules/next/") || be.includes(" (<anonymous>)") || be.includes(" (node:"))).join(`
`), `Dynamic API Usage Debug - ${me}:
${pe}`));
    }
    function F() {
      if (!p)
        throw Object.defineProperty(new Error("Invariant: React.unstable_postpone is not defined. This suggests the wrong version of React was loaded. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
          value: "E224",
          enumerable: !1,
          configurable: !0
        });
    }
    function L() {
      const se = new AbortController();
      return se.abort(Object.defineProperty(new d.BailoutToCSRError("Render in Browser"), "__NEXT_ERROR_CODE", {
        value: "E721",
        enumerable: !1,
        configurable: !0
      })), se.signal;
    }
    function U(se) {
      switch (se.type) {
        case "prerender":
        case "prerender-runtime":
          const me = new AbortController();
          if (se.cacheSignal)
            se.cacheSignal.inputReady().then(() => {
              me.abort();
            });
          else {
            const pe = (0, i.getRuntimeStagePromise)(se);
            pe ? pe.then(() => (0, l.scheduleOnNextTick)(() => me.abort())) : (0, l.scheduleOnNextTick)(() => me.abort());
          }
          return me.signal;
        case "prerender-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
          return;
      }
    }
    function W(se, me) {
      const pe = me.dynamicTracking;
      pe && pe.dynamicAccesses.push({
        stack: pe.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: se
      });
    }
    function H(se) {
      const me = a.workAsyncStorage.getStore(), pe = i.workUnitAsyncStorage.getStore();
      if (me && pe)
        switch (pe.type) {
          case "prerender-client":
          case "prerender": {
            const be = pe.fallbackRouteParams;
            be && be.size > 0 && n.default.use((0, s.makeHangingPromise)(pe.renderSignal, me.route, se));
            break;
          }
          case "prerender-ppr": {
            const be = pe.fallbackRouteParams;
            if (be && be.size > 0)
              return C(me.route, se, pe.dynamicTracking);
            break;
          }
          case "prerender-runtime":
            throw Object.defineProperty(new u.InvariantError(`\`${se}\` was called during a runtime prerender. Next.js should be preventing ${se} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E771",
              enumerable: !1,
              configurable: !0
            });
          case "cache":
          case "private-cache":
            throw Object.defineProperty(new u.InvariantError(`\`${se}\` was called inside a cache scope. Next.js should be preventing ${se} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E745",
              enumerable: !1,
              configurable: !0
            });
        }
    }
    const Q = /\n\s+at Suspense \(<anonymous>\)/, X = "body|div|main|section|article|aside|header|footer|nav|form|p|span|h1|h2|h3|h4|h5|h6", re = new RegExp(`\\n\\s+at Suspense \\(<anonymous>\\)(?:(?!\\n\\s+at (?:${X}) \\(<anonymous>\\))[\\s\\S])*?\\n\\s+at ${c.ROOT_LAYOUT_BOUNDARY_NAME} \\([^\\n]*\\)`), Z = new RegExp(`\\n\\s+at ${c.METADATA_BOUNDARY_NAME}[\\n\\s]`), ee = new RegExp(`\\n\\s+at ${c.VIEWPORT_BOUNDARY_NAME}[\\n\\s]`), J = new RegExp(`\\n\\s+at ${c.OUTLET_BOUNDARY_NAME}[\\n\\s]`);
    function oe(se, me, pe, be) {
      if (!J.test(me))
        if (Z.test(me)) {
          pe.hasDynamicMetadata = !0;
          return;
        } else if (ee.test(me)) {
          pe.hasDynamicViewport = !0;
          return;
        } else if (re.test(me)) {
          pe.hasAllowedDynamic = !0, pe.hasSuspenseAboveBody = !0;
          return;
        } else if (Q.test(me)) {
          pe.hasAllowedDynamic = !0;
          return;
        } else if (be.syncDynamicErrorWithStack) {
          pe.dynamicErrors.push(be.syncDynamicErrorWithStack);
          return;
        } else {
          const Se = `Route "${se.route}": A component accessed data, headers, params, searchParams, or a short-lived cache without a Suspense boundary nor a "use cache" above it. See more info: https://nextjs.org/docs/messages/next-prerender-missing-suspense`, Ae = ce(Se, me);
          pe.dynamicErrors.push(Ae);
          return;
        }
    }
    function ce(se, me) {
      const pe = Object.defineProperty(new Error(se), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return pe.stack = pe.name + ": " + se + me, pe;
    }
    var de = /* @__PURE__ */ function(se) {
      return se[se.Full = 0] = "Full", se[se.Empty = 1] = "Empty", se[se.Errored = 2] = "Errored", se;
    }({});
    function te(se, me) {
      console.error(me), se.dev || (se.hasReadableErrorStacks ? console.error(`To get a more detailed stack trace and pinpoint the issue, start the app in development mode by running \`next dev\`, then open "${se.route}" in your browser to investigate the error.`) : console.error(`To get a more detailed stack trace and pinpoint the issue, try one of the following:
  - Start the app in development mode by running \`next dev\`, then open "${se.route}" in your browser to investigate the error.
  - Rerun the production build with \`next build --debug-prerender\` to generate better stack traces.`));
    }
    function ue(se, me, pe, be) {
      if (me !== 0) {
        if (pe.hasSuspenseAboveBody)
          return;
        if (be.syncDynamicErrorWithStack)
          throw te(se, be.syncDynamicErrorWithStack), new r.StaticGenBailoutError();
        const Se = pe.dynamicErrors;
        if (Se.length > 0) {
          for (let Ae = 0; Ae < Se.length; Ae++)
            te(se, Se[Ae]);
          throw new r.StaticGenBailoutError();
        }
        if (pe.hasDynamicViewport)
          throw console.error(`Route "${se.route}" has a \`generateViewport\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) without explicitly allowing fully dynamic rendering. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`), new r.StaticGenBailoutError();
        if (me === 1)
          throw console.error(`Route "${se.route}" did not produce a static shell and Next.js was unable to determine a reason. This is a bug in Next.js.`), new r.StaticGenBailoutError();
      } else if (pe.hasAllowedDynamic === !1 && pe.hasDynamicMetadata)
        throw console.error(`Route "${se.route}" has a \`generateMetadata\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) when the rest of the route does not. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`), new r.StaticGenBailoutError();
    }
    function le(se, me) {
      return se.runtimeStagePromise ? se.runtimeStagePromise.then(() => me) : me;
    }
  }(Y4)), Y4;
}
var SG;
function Zgc() {
  return SG || (SG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const n = Yle(), o = Bgc(), r = rA(), i = Kle(), a = ede(), s = Zle();
    function c(l) {
      if ((0, i.isNextRouterError)(l) || (0, r.isBailoutToCSRError)(l) || (0, s.isDynamicServerError)(l) || (0, a.isDynamicPostpone)(l) || (0, o.isPostpone)(l) || (0, n.isHangingPromiseRejectionError)(l))
        throw l;
      l instanceof Error && "cause" in l && c(l.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(p2, p2.exports)), p2.exports;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "unstable_rethrow", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const n = typeof window > "u" ? Zgc().unstable_rethrow : Vgc().unstable_rethrow;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(PD, PD.exports);
var Qgc = PD.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(_, p) {
    for (var f in p)
      Object.defineProperty(_, f, {
        enumerable: !0,
        get: p[f]
      });
  }
  n(t, {
    ReadonlyURLSearchParams: function() {
      return d;
    },
    RedirectType: function() {
      return r.RedirectType;
    },
    forbidden: function() {
      return a.forbidden;
    },
    notFound: function() {
      return i.notFound;
    },
    permanentRedirect: function() {
      return o.permanentRedirect;
    },
    redirect: function() {
      return o.redirect;
    },
    unauthorized: function() {
      return s.unauthorized;
    },
    unstable_isUnrecognizedActionError: function() {
      return u;
    },
    unstable_rethrow: function() {
      return c.unstable_rethrow;
    }
  });
  const o = Lgc, r = E9, i = qgc, a = jgc, s = Fgc, c = Qgc;
  class l extends Error {
    constructor() {
      super("Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams");
    }
  }
  class d extends URLSearchParams {
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    append() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    delete() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    set() {
      throw new l();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    sort() {
      throw new l();
    }
  }
  function u() {
    throw Object.defineProperty(new Error("`unstable_isUnrecognizedActionError` can only be used on the client."), "__NEXT_ERROR_CODE", {
      value: "E776",
      enumerable: !1,
      configurable: !0
    });
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(SD, SD.exports);
var Jgc = SD.exports, tde = {};
(function(e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(a, s) {
    for (var c in s)
      Object.defineProperty(a, c, {
        enumerable: !0,
        get: s[c]
      });
  }
  t(e, {
    ServerInsertedHTMLContext: function() {
      return r;
    },
    useServerInsertedHTML: function() {
      return i;
    }
  });
  const o = /* @__PURE__ */ q0._(ve), r = /* @__PURE__ */ o.default.createContext(null);
  function i(a) {
    const s = (0, o.useContext)(r);
    s && s(a);
  }
})(tde);
var ID = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(i, a) {
    for (var s in a)
      Object.defineProperty(i, s, {
        enumerable: !0,
        get: a[s]
      });
  }
  n(t, {
    UnrecognizedActionError: function() {
      return o;
    },
    unstable_isUnrecognizedActionError: function() {
      return r;
    }
  });
  class o extends Error {
    constructor(...a) {
      super(...a), this.name = "UnrecognizedActionError";
    }
  }
  function r(i) {
    return !!(i && typeof i == "object" && i instanceof o);
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(ID, ID.exports);
var Xgc = ID.exports, h2 = { exports: {} }, xG;
function ehc() {
  return xG || (xG = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "bailoutToClientRendering", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const n = rA(), o = Xle(), r = Jle();
    function i(a) {
      const s = o.workAsyncStorage.getStore();
      if (s != null && s.forceStatic)
        return;
      const c = r.workUnitAsyncStorage.getStore();
      if (c)
        switch (c.type) {
          case "prerender":
          case "prerender-runtime":
          case "prerender-client":
          case "prerender-ppr":
          case "prerender-legacy":
            throw Object.defineProperty(new n.BailoutToCSRError(a), "__NEXT_ERROR_CODE", {
              value: "E394",
              enumerable: !1,
              configurable: !0
            });
        }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(h2, h2.exports)), h2.exports;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n($, k) {
    for (var S in k)
      Object.defineProperty($, S, {
        enumerable: !0,
        get: k[S]
      });
  }
  n(t, {
    ReadonlyURLSearchParams: function() {
      return c.ReadonlyURLSearchParams;
    },
    RedirectType: function() {
      return c.RedirectType;
    },
    ServerInsertedHTMLContext: function() {
      return l.ServerInsertedHTMLContext;
    },
    forbidden: function() {
      return c.forbidden;
    },
    notFound: function() {
      return c.notFound;
    },
    permanentRedirect: function() {
      return c.permanentRedirect;
    },
    redirect: function() {
      return c.redirect;
    },
    unauthorized: function() {
      return c.unauthorized;
    },
    unstable_isUnrecognizedActionError: function() {
      return d.unstable_isUnrecognizedActionError;
    },
    unstable_rethrow: function() {
      return c.unstable_rethrow;
    },
    useParams: function() {
      return g;
    },
    usePathname: function() {
      return p;
    },
    useRouter: function() {
      return f;
    },
    useSearchParams: function() {
      return _;
    },
    useSelectedLayoutSegment: function() {
      return v;
    },
    useSelectedLayoutSegments: function() {
      return b;
    },
    useServerInsertedHTML: function() {
      return l.useServerInsertedHTML;
    }
  });
  const o = ve, r = Wle, i = Gle, a = Ngc, s = Yq, c = Jgc, l = tde, d = Xgc, u = typeof window > "u" ? ede().useDynamicRouteParams : void 0;
  function _() {
    const $ = (0, o.useContext)(i.SearchParamsContext), k = (0, o.useMemo)(() => $ ? new c.ReadonlyURLSearchParams($) : null, [
      $
    ]);
    if (typeof window > "u") {
      const { bailoutToClientRendering: S } = ehc();
      S("useSearchParams()");
    }
    return k;
  }
  function p() {
    return u == null || u("usePathname()"), (0, o.useContext)(i.PathnameContext);
  }
  function f() {
    const $ = (0, o.useContext)(r.AppRouterContext);
    if ($ === null)
      throw Object.defineProperty(new Error("invariant expected app router to be mounted"), "__NEXT_ERROR_CODE", {
        value: "E238",
        enumerable: !1,
        configurable: !0
      });
    return $;
  }
  function g() {
    return u == null || u("useParams()"), (0, o.useContext)(i.PathParamsContext);
  }
  function h($, k, S, O) {
    S === void 0 && (S = !0), O === void 0 && (O = []);
    let I;
    if (S)
      I = $[1][k];
    else {
      const C = $[1];
      var D;
      I = (D = C.children) != null ? D : Object.values(C)[0];
    }
    if (!I)
      return O;
    const M = I[0];
    let N = (0, a.getSegmentValue)(M);
    return !N || N.startsWith(s.PAGE_SEGMENT_KEY) ? O : (O.push(N), h(I, k, !1, O));
  }
  function b($) {
    $ === void 0 && ($ = "children"), u == null || u("useSelectedLayoutSegments()");
    const k = (0, o.useContext)(r.LayoutRouterContext);
    return k ? h(k.parentTree, $) : null;
  }
  function v($) {
    $ === void 0 && ($ = "children"), u == null || u("useSelectedLayoutSegment()");
    const k = b($);
    if (!k || k.length === 0)
      return null;
    const S = $ === "children" ? k[0] : k[k.length - 1];
    return S === s.DEFAULT_SEGMENT_KEY ? null : S;
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(wD, wD.exports);
var thc = wD.exports, Ro = thc;
const Zo = () => {
  const e = po();
  return !!(e != null && e.clientId);
}, O_ = () => {
  const e = Ro.useSearchParams() ?? new URLSearchParams(), t = Ro.useParams() ?? {}, n = new URLSearchParams(e.toString());
  return Object.getOwnPropertyNames(t).forEach((o) => {
    n.delete(o);
    const r = t[o] || "";
    (typeof r == "string" ? r.split("/") : r).forEach((a) => {
      n.append(o, a);
    });
  }), new Ro.ReadonlyURLSearchParams(n);
}, nhc = Yv(
  "fadeIn bg-default scroll-bar fixed left-1/2 top-1/2 z-50 w-[95vw] m-auto -translate-x-1/2 -translate-y-1/2 rounded-2xl text-left shadow-xl focus-visible:outline-none sm:align-middle",
  {
    variants: {
      size: {
        xl: "px-8 pt-8 sm:max-w-[90rem]",
        lg: "px-8 pt-8 sm:max-w-[70rem]",
        md: "px-8 pt-8 sm:max-w-[48rem]",
        default: "px-8 pt-8 sm:max-w-[35rem]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
function Ff(e) {
  const { children: t, ...n } = e;
  return /* @__PURE__ */ m(Nle, { ...n, children: t });
}
const Ei = ve.forwardRef(
  ({
    children: e,
    title: t,
    Icon: n,
    enableOverflow: o,
    forceOverlayWhenNoModal: r,
    type: i = "creation",
    preventCloseOnOutsideClick: a,
    ...s
  }, c) => /* @__PURE__ */ Y(Rle, { children: [
    r ? /* @__PURE__ */ m("div", { className: "fadeIn fixed inset-0 z-50  bg-neutral-800 bg-opacity-70 transition-opacity" }) : /* @__PURE__ */ m(Mle, { className: "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-80" }),
    /* @__PURE__ */ Y(
      Lle,
      {
        ...s,
        onPointerDownOutside: (l) => {
          a && l.preventDefault();
        },
        className: ae(
          nhc({ size: s.size }),
          "max-h-[95vh]",
          o ? "overflow-y-auto" : "overflow-visible",
          `${s.className || ""}`
        ),
        ref: c,
        children: [
          i === "creation" && /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ m(zv, { title: t, subtitle: s.description }),
            /* @__PURE__ */ m("div", { "data-testid": "dialog-creation", className: "flex flex-col", children: e })
          ] }),
          i === "confirmation" && /* @__PURE__ */ Y("div", { className: "flex", children: [
            n && /* @__PURE__ */ m("div", { className: "bg-emphasis flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full", children: /* @__PURE__ */ m(ot, { name: n, className: "text-emphasis h-4 w-4" }) }),
            /* @__PURE__ */ Y("div", { className: "ml-4 flex-grow", children: [
              /* @__PURE__ */ m(zv, { title: t, subtitle: s.description }),
              /* @__PURE__ */ m("div", { "data-testid": "dialog-confirmation", children: e })
            ] })
          ] }),
          !i && e
        ]
      }
    )
  ] })
);
function zv(e) {
  return e.title ? /* @__PURE__ */ Y("div", { className: "mb-4", children: [
    /* @__PURE__ */ m(
      "h2",
      {
        "data-testid": "dialog-title",
        className: "leading-20 text-semibold text-emphasis font-cal mb-1 text-xl",
        id: "modal-title",
        children: e.title
      }
    ),
    e.subtitle && /* @__PURE__ */ m("p", { className: "text-subtle text-sm", "data-testid": "dialog-subtitle", children: e.subtitle })
  ] }) : null;
}
function Fc(e) {
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "bg-muted border-muted bottom-0 -mx-8 mt-10 rounded-b-2xl border",
        e != null && e.noSticky ? "" : "sticky",
        e.className
      ),
      children: [
        e.showDivider && /* @__PURE__ */ m("div", { "data-testid": "divider", className: "border-subtle border-t" }),
        /* @__PURE__ */ m("div", { className: ae("flex justify-end space-x-2 px-8 py-4 font-sans rtl:space-x-reverse"), children: e.children })
      ]
    }
  );
}
Ei.displayName = "DialogContent";
const W0 = ve.forwardRef((e, t) => /* @__PURE__ */ m(Dle, { ...e, ref: t }));
W0.displayName = "DialogTrigger";
function ca(e) {
  const { t } = Fe(), { className: n, ...o } = e;
  return /* @__PURE__ */ m(S9, { asChild: !0, ...e.dialogCloseProps, children: /* @__PURE__ */ m(
    ut,
    {
      "data-testid": e["data-testid"] || "dialog-rejection",
      color: e.color || "minimal",
      className: ae(e.color === "destructive" && "destructive", n),
      ...o,
      children: e.children ? e.children : t("close")
    }
  ) });
}
function Vf(e) {
  return /* @__PURE__ */ m(Ei, { type: "creation", children: /* @__PURE__ */ m(ohc, { ...e }) });
}
const ohc = (e) => {
  const { t } = Fe(), {
    title: n,
    variety: o,
    confirmBtn: r = null,
    confirmBtnText: i = t("confirm"),
    cancelBtnText: a = t("cancel"),
    loadingText: s = t("loading"),
    isPending: c = !1,
    onConfirm: l,
    children: d
  } = e;
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y("div", { className: "flex", children: [
      o && /* @__PURE__ */ Y("div", { className: "mt-0.5 ltr:mr-3", children: [
        o === "danger" && /* @__PURE__ */ m("div", { className: "bg-error mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(ot, { name: "circle-alert", className: "h-5 w-5 text-red-600 dark:text-red-100" }) }),
        o === "warning" && /* @__PURE__ */ m("div", { className: "bg-attention mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(ot, { name: "circle-alert", className: "h-5 w-5 text-orange-600" }) }),
        o === "success" && /* @__PURE__ */ m("div", { className: "bg-success mx-auto rounded-full p-2 text-center", children: /* @__PURE__ */ m(ot, { name: "check", className: "h-5 w-5 text-green-600" }) })
      ] }),
      /* @__PURE__ */ Y("div", { className: "w-full", children: [
        /* @__PURE__ */ m(qle, { className: "font-cal text-emphasis mt-2 text-xl", children: n }),
        /* @__PURE__ */ m(jle, { className: "text-subtle text-sm", children: d })
      ] })
    ] }),
    /* @__PURE__ */ Y("div", { className: "my-5 flex flex-row-reverse gap-x-2 sm:my-8", children: [
      r || /* @__PURE__ */ m(
        ca,
        {
          color: "primary",
          loading: c,
          onClick: (u) => l && l(u),
          "data-testid": "dialog-confirmation",
          children: c ? s : i
        }
      ),
      /* @__PURE__ */ m(ca, { disabled: c, children: a })
    ] })
  ] });
};
function Gi(e) {
  return Zo() ? /* @__PURE__ */ m(k9, { ...e }) : /* @__PURE__ */ m(rhc, { ...e });
}
function rhc(e) {
  const t = Ro.useRouter(), n = Ro.usePathname(), o = O_(), r = new URLSearchParams(o.toString()), { children: i, name: a, ...s } = e, [c, l] = ze(
    s.open ? "OPEN" : "CLOSED"
    /* CLOSED */
  ), d = r.get("dialog") === a;
  if (a) {
    const u = ["dialog", ...e.clearQueryParamsOnClose || []];
    s.onOpenChange = (_) => {
      e.onOpenChange && e.onOpenChange(_), _ ? r.set("dialog", a) : (u.forEach((p) => {
        r.delete(p);
      }), t.push(`${n}?${r.toString()}`)), l(
        _ ? "OPEN" : "CLOSING"
        /* CLOSING */
      );
    }, c === "CLOSED" && d && l(
      "OPEN"
      /* OPEN */
    ), c === "CLOSING" && !d && l(
      "CLOSED"
      /* CLOSED */
    ), "open" in s || (s.open = c === "OPEN");
  }
  return /* @__PURE__ */ m(Ff, { ...s, children: i });
}
function l$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function EG(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Hn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EG(Object(n), !0).forEach(function(o) {
      l$(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EG(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function RD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function nde(e, t) {
  if (e) {
    if (typeof e == "string")
      return RD(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? RD(e, t) : void 0;
  }
}
function g_(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, o) {
    var r = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (r != null) {
      var i, a, s = [], c = !0, l = !1;
      try {
        for (r = r.call(n); !(c = (i = r.next()).done) && (s.push(i.value), !o || s.length !== o); c = !0)
          ;
      } catch (d) {
        l = !0, a = d;
      } finally {
        try {
          c || r.return == null || r.return();
        } finally {
          if (l)
            throw a;
        }
      }
      return s;
    }
  }(e, t) || nde(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ov(e, t) {
  if (e == null)
    return {};
  var n, o, r = function(a, s) {
    if (a == null)
      return {};
    var c, l, d = {}, u = Object.keys(a);
    for (l = 0; l < u.length; l++)
      c = u[l], s.indexOf(c) >= 0 || (d[c] = a[c]);
    return d;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
var ihc = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function On() {
  return On = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, On.apply(this, arguments);
}
function TG(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function ND(e, t) {
  return ND = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, ND(e, t);
}
function Kx(e) {
  return Kx = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Kx(e);
}
function Yx(e) {
  return Yx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yx(e);
}
function ahc(e, t) {
  if (t && (Yx(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return function(n) {
    if (n === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }(e);
}
function shc(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, o = Kx(e);
    if (t) {
      var r = Kx(this).constructor;
      n = Reflect.construct(o, arguments, r);
    } else
      n = o.apply(this, arguments);
    return ahc(this, n);
  };
}
function ode(e) {
  return function(t) {
    if (Array.isArray(t))
      return RD(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || nde(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
var chc = function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      i = o.tags.length === 0 ? o.insertionPoint ? o.insertionPoint.nextSibling : o.prepend ? o.container.firstChild : o.before : o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function(i) {
      var a = document.createElement("style");
      return a.setAttribute("data-emotion", i.key), i.nonce !== void 0 && a.setAttribute("nonce", i.nonce), a.appendChild(document.createTextNode("")), a.setAttribute("data-s", ""), a;
    }(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var r = function(i) {
        if (i.sheet)
          return i.sheet;
        for (var a = 0; a < document.styleSheets.length; a++)
          if (document.styleSheets[a].ownerNode === i)
            return document.styleSheets[a];
      }(o);
      try {
        r.insertRule(n, r.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Bs = "-ms-", AG = "-moz-", qr = "-webkit-", lhc = Math.abs, iA = String.fromCharCode, dhc = Object.assign;
function rde(e) {
  return e.trim();
}
function lr(e, t, n) {
  return e.replace(t, n);
}
function DD(e, t) {
  return e.indexOf(t);
}
function Us(e, t) {
  return 0 | e.charCodeAt(t);
}
function xw(e, t, n) {
  return e.slice(t, n);
}
function Md(e) {
  return e.length;
}
function A9(e) {
  return e.length;
}
function v2(e, t) {
  return t.push(e), e;
}
var aA = 1, Pv = 1, ide = 0, rc = 0, Ci = 0, eb = "";
function sA(e, t, n, o, r, i, a) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: aA, column: Pv, length: a, return: "" };
}
function xy(e, t) {
  return dhc(sA("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function uhc() {
  return Ci = rc > 0 ? Us(eb, --rc) : 0, Pv--, Ci === 10 && (Pv = 1, aA--), Ci;
}
function Oc() {
  return Ci = rc < ide ? Us(eb, rc++) : 0, Pv++, Ci === 10 && (Pv = 1, aA++), Ci;
}
function ou() {
  return Us(eb, rc);
}
function PS() {
  return rc;
}
function G0(e, t) {
  return xw(eb, e, t);
}
function Ew(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ade(e) {
  return aA = Pv = 1, ide = Md(eb = e), rc = 0, [];
}
function sde(e) {
  return eb = "", e;
}
function IS(e) {
  return rde(G0(rc - 1, MD(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function _hc(e) {
  for (; (Ci = ou()) && Ci < 33; )
    Oc();
  return Ew(e) > 2 || Ew(Ci) > 3 ? "" : " ";
}
function phc(e, t) {
  for (; --t && Oc() && !(Ci < 48 || Ci > 102 || Ci > 57 && Ci < 65 || Ci > 70 && Ci < 97); )
    ;
  return G0(e, PS() + (t < 6 && ou() == 32 && Oc() == 32));
}
function MD(e) {
  for (; Oc(); )
    switch (Ci) {
      case e:
        return rc;
      case 34:
      case 39:
        e !== 34 && e !== 39 && MD(Ci);
        break;
      case 40:
        e === 41 && MD(e);
        break;
      case 92:
        Oc();
    }
  return rc;
}
function mhc(e, t) {
  for (; Oc() && e + Ci !== 57 && (e + Ci !== 84 || ou() !== 47); )
    ;
  return "/*" + G0(t, rc - 1) + "*" + iA(e === 47 ? e : Oc());
}
function fhc(e) {
  for (; !Ew(ou()); )
    Oc();
  return G0(e, rc);
}
function CG(e) {
  return sde(RS("", null, null, null, [""], e = ade(e), 0, [0], e));
}
function RS(e, t, n, o, r, i, a, s, c) {
  for (var l = 0, d = 0, u = a, _ = 0, p = 0, f = 0, g = 1, h = 1, b = 1, v = 0, $ = "", k = r, S = i, O = o, I = $; h; )
    switch (f = v, v = Oc()) {
      case 40:
        if (f != 108 && I.charCodeAt(u - 1) == 58) {
          DD(I += lr(IS(v), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += IS(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += _hc(f);
        break;
      case 92:
        I += phc(PS() - 1, 7);
        continue;
      case 47:
        switch (ou()) {
          case 42:
          case 47:
            v2(ghc(mhc(Oc(), PS()), t, n), c);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * g:
        s[l++] = Md(I) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            h = 0;
          case 59 + d:
            p > 0 && Md(I) - u && v2(p > 32 ? OG(I + ";", o, n, u - 1) : OG(lr(I, " ", "") + ";", o, n, u - 2), c);
            break;
          case 59:
            I += ";";
          default:
            if (v2(O = zG(I, t, n, l, d, r, s, $, k = [], S = [], u), i), v === 123)
              if (d === 0)
                RS(I, t, O, O, k, i, u, s, S);
              else
                switch (_) {
                  case 100:
                  case 109:
                  case 115:
                    RS(e, O, O, o && v2(zG(e, O, O, 0, 0, r, s, $, r, k = [], u), S), r, S, u, s, o ? k : S);
                    break;
                  default:
                    RS(I, O, O, O, [""], S, 0, s, S);
                }
        }
        l = d = p = 0, g = b = 1, $ = I = "", u = a;
        break;
      case 58:
        u = 1 + Md(I), p = f;
      default:
        if (g < 1) {
          if (v == 123)
            --g;
          else if (v == 125 && g++ == 0 && uhc() == 125)
            continue;
        }
        switch (I += iA(v), v * g) {
          case 38:
            b = d > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            s[l++] = (Md(I) - 1) * b, b = 1;
            break;
          case 64:
            ou() === 45 && (I += IS(Oc())), _ = ou(), d = u = Md($ = I += fhc(PS())), v++;
            break;
          case 45:
            f === 45 && Md(I) == 2 && (g = 0);
        }
    }
  return i;
}
function zG(e, t, n, o, r, i, a, s, c, l, d) {
  for (var u = r - 1, _ = r === 0 ? i : [""], p = A9(_), f = 0, g = 0, h = 0; f < o; ++f)
    for (var b = 0, v = xw(e, u + 1, u = lhc(g = a[f])), $ = e; b < p; ++b)
      ($ = rde(g > 0 ? _[b] + " " + v : lr(v, /&\f/g, _[b]))) && (c[h++] = $);
  return sA(e, t, n, r === 0 ? "rule" : s, c, l, d);
}
function ghc(e, t, n) {
  return sA(e, t, n, "comm", iA(Ci), xw(e, 2, -2), 0);
}
function OG(e, t, n, o) {
  return sA(e, t, n, "decl", xw(e, 0, o), xw(e, o + 1, -1), o);
}
function cde(e, t) {
  switch (function(n, o) {
    return (((o << 2 ^ Us(n, 0)) << 2 ^ Us(n, 1)) << 2 ^ Us(n, 2)) << 2 ^ Us(n, 3);
  }(e, t)) {
    case 5103:
      return qr + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return qr + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return qr + e + AG + e + Bs + e + e;
    case 6828:
    case 4268:
      return qr + e + Bs + e + e;
    case 6165:
      return qr + e + Bs + "flex-" + e + e;
    case 5187:
      return qr + e + lr(e, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + e;
    case 5443:
      return qr + e + Bs + "flex-item-" + lr(e, /flex-|-self/, "") + e;
    case 4675:
      return qr + e + Bs + "flex-line-pack" + lr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return qr + e + Bs + lr(e, "shrink", "negative") + e;
    case 5292:
      return qr + e + Bs + lr(e, "basis", "preferred-size") + e;
    case 6060:
      return qr + "box-" + lr(e, "-grow", "") + qr + e + Bs + lr(e, "grow", "positive") + e;
    case 4554:
      return qr + lr(e, /([^-])(transform)/g, "$1-webkit-$2") + e;
    case 6187:
      return lr(lr(lr(e, /(zoom-|grab)/, qr + "$1"), /(image-set)/, qr + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return lr(e, /(image-set\([^]*)/, qr + "$1$`$1");
    case 4968:
      return lr(lr(e, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + qr + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return lr(e, /(.+)-inline(.+)/, qr + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Md(e) - 1 - t > 6)
        switch (Us(e, t + 1)) {
          case 109:
            if (Us(e, t + 4) !== 45)
              break;
          case 102:
            return lr(e, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + AG + (Us(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~DD(e, "stretch") ? cde(lr(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Us(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Us(e, Md(e) - 3 - (~DD(e, "!important") && 10))) {
        case 107:
          return lr(e, ":", ":" + qr) + e;
        case 101:
          return lr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + qr + (Us(e, 14) === 45 ? "inline-" : "") + "box$3$1" + qr + "$2$3$1" + Bs + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Us(e, t + 11)) {
        case 114:
          return qr + e + Bs + lr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return qr + e + Bs + lr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return qr + e + Bs + lr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return qr + e + Bs + e + e;
  }
  return e;
}
function Ef(e, t) {
  for (var n = "", o = A9(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function PG(e, t, n, o) {
  switch (e.type) {
    case "@import":
    case "decl":
      return e.return = e.return || e.value;
    case "comm":
      return "";
    case "@keyframes":
      return e.return = e.value + "{" + Ef(e.children, o) + "}";
    case "rule":
      e.value = e.props.join(",");
  }
  return Md(n = Ef(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function IG(e) {
  var t = A9(e);
  return function(n, o, r, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, o, r, i) || "";
    return a;
  };
}
function lde(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var RG, b2, hhc = function(e, t, n) {
  for (var o = 0, r = 0; o = r, r = ou(), o === 38 && r === 12 && (t[n] = 1), !Ew(r); )
    Oc();
  return G0(e, rc);
}, vhc = function(e, t) {
  return sde(function(n, o) {
    var r = -1, i = 44;
    do
      switch (Ew(i)) {
        case 0:
          i === 38 && ou() === 12 && (o[r] = 1), n[r] += hhc(rc - 1, o, r);
          break;
        case 2:
          n[r] += IS(i);
          break;
        case 4:
          if (i === 44) {
            n[++r] = ou() === 58 ? "&\f" : "", o[r] = n[r].length;
            break;
          }
        default:
          n[r] += iA(i);
      }
    while (i = Oc());
    return n;
  }(ade(e), t));
}, NG = /* @__PURE__ */ new WeakMap(), bhc = function(e) {
  if (e.type === "rule" && e.parent && !(e.length < 1)) {
    for (var t = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (!(n = n.parent))
        return;
    if ((e.props.length !== 1 || t.charCodeAt(0) === 58 || NG.get(n)) && !o) {
      NG.set(e, !0);
      for (var r = [], i = vhc(t, r), a = n.props, s = 0, c = 0; s < i.length; s++)
        for (var l = 0; l < a.length; l++, c++)
          e.props[c] = r[s] ? i[s].replace(/&\f/g, a[l]) : a[l] + " " + i[s];
    }
  }
}, yhc = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, NS = typeof document < "u", $hc = NS ? void 0 : (RG = function() {
  return lde(function() {
    var e = {};
    return function(t) {
      return e[t];
    };
  });
}, b2 = /* @__PURE__ */ new WeakMap(), function(e) {
  if (b2.has(e))
    return b2.get(e);
  var t = RG(e);
  return b2.set(e, t), t;
}), whc = [function(e, t, n, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case "decl":
        e.return = cde(e.value, e.length);
        break;
      case "@keyframes":
        return Ef([xy(e, { value: lr(e.value, "@", "@" + qr) })], o);
      case "rule":
        if (e.length)
          return function(r, i) {
            return r.map(i).join("");
          }(e.props, function(r) {
            switch (function(i, a) {
              return (i = a.exec(i)) ? i[0] : i;
            }(r, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Ef([xy(e, { props: [lr(r, /:(read-\w+)/, ":-moz-$1")] })], o);
              case "::placeholder":
                return Ef([xy(e, { props: [lr(r, /:(plac\w+)/, ":-webkit-input-$1")] }), xy(e, { props: [lr(r, /:(plac\w+)/, ":-moz-$1")] }), xy(e, { props: [lr(r, /:(plac\w+)/, Bs + "input-$1")] })], o);
            }
            return "";
          });
    }
}], dde = function(e) {
  var t = e.key;
  if (NS && t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      v.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = e.stylisPlugins || whc, r, i, a = {}, s = [];
  NS && (r = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function(v) {
    for (var $ = v.getAttribute("data-emotion").split(" "), k = 1; k < $.length; k++)
      a[$[k]] = !0;
    s.push(v);
  }));
  var c, l = [bhc, yhc];
  if (NS) {
    var d, u = [PG, (c = function(v) {
      d.insert(v);
    }, function(v) {
      v.root || (v = v.return) && c(v);
    })], _ = IG(l.concat(o, u));
    i = function(v, $, k, S) {
      d = k, Ef(CG(v ? v + "{" + $.styles + "}" : $.styles), _), S && (b.inserted[$.name] = !0);
    };
  } else {
    var p = [PG], f = IG(l.concat(o, p)), g = $hc(o)(t), h = function(v, $) {
      var k = $.name;
      return g[k] === void 0 && (g[k] = Ef(CG(v ? v + "{" + $.styles + "}" : $.styles), f)), g[k];
    };
    i = function(v, $, k, S) {
      var O = $.name, I = h(v, $);
      return b.compat === void 0 ? (S && (b.inserted[O] = !0), I) : S ? void (b.inserted[O] = I) : I;
    };
  }
  var b = { key: t, sheet: new chc({ key: t, container: r, nonce: e.nonce, speedy: e.speedy, prepend: e.prepend, insertionPoint: e.insertionPoint }), nonce: e.nonce, inserted: a, registered: {}, insert: i };
  return b.sheet.hydrate(s), b;
}, ude = { exports: {} }, gr = {}, la = typeof Symbol == "function" && Symbol.for, LD = la ? Symbol.for("react.element") : 60103, qD = la ? Symbol.for("react.portal") : 60106, DS = la ? Symbol.for("react.fragment") : 60107, MS = la ? Symbol.for("react.strict_mode") : 60108, LS = la ? Symbol.for("react.profiler") : 60114, qS = la ? Symbol.for("react.provider") : 60109, jS = la ? Symbol.for("react.context") : 60110, jD = la ? Symbol.for("react.async_mode") : 60111, Zx = la ? Symbol.for("react.concurrent_mode") : 60111, FS = la ? Symbol.for("react.forward_ref") : 60112, VS = la ? Symbol.for("react.suspense") : 60113, khc = la ? Symbol.for("react.suspense_list") : 60120, BS = la ? Symbol.for("react.memo") : 60115, US = la ? Symbol.for("react.lazy") : 60116, Shc = la ? Symbol.for("react.block") : 60121, xhc = la ? Symbol.for("react.fundamental") : 60117, Ehc = la ? Symbol.for("react.responder") : 60118, Thc = la ? Symbol.for("react.scope") : 60119;
function hc(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case LD:
        switch (e = e.type) {
          case jD:
          case Zx:
          case DS:
          case LS:
          case MS:
          case VS:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case jS:
              case FS:
              case US:
              case BS:
              case qS:
                return e;
              default:
                return t;
            }
        }
      case qD:
        return t;
    }
  }
}
function DG(e) {
  return hc(e) === Zx;
}
gr.AsyncMode = jD, gr.ConcurrentMode = Zx, gr.ContextConsumer = jS, gr.ContextProvider = qS, gr.Element = LD, gr.ForwardRef = FS, gr.Fragment = DS, gr.Lazy = US, gr.Memo = BS, gr.Portal = qD, gr.Profiler = LS, gr.StrictMode = MS, gr.Suspense = VS, gr.isAsyncMode = function(e) {
  return DG(e) || hc(e) === jD;
}, gr.isConcurrentMode = DG, gr.isContextConsumer = function(e) {
  return hc(e) === jS;
}, gr.isContextProvider = function(e) {
  return hc(e) === qS;
}, gr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === LD;
}, gr.isForwardRef = function(e) {
  return hc(e) === FS;
}, gr.isFragment = function(e) {
  return hc(e) === DS;
}, gr.isLazy = function(e) {
  return hc(e) === US;
}, gr.isMemo = function(e) {
  return hc(e) === BS;
}, gr.isPortal = function(e) {
  return hc(e) === qD;
}, gr.isProfiler = function(e) {
  return hc(e) === LS;
}, gr.isStrictMode = function(e) {
  return hc(e) === MS;
}, gr.isSuspense = function(e) {
  return hc(e) === VS;
}, gr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === DS || e === Zx || e === LS || e === MS || e === VS || e === khc || typeof e == "object" && e !== null && (e.$$typeof === US || e.$$typeof === BS || e.$$typeof === qS || e.$$typeof === jS || e.$$typeof === FS || e.$$typeof === xhc || e.$$typeof === Ehc || e.$$typeof === Thc || e.$$typeof === Shc);
}, gr.typeOf = hc;
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
ude.exports = gr;
var MG = ude.exports, LG = {};
LG[MG.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, LG[MG.Memo] = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 };
var FD = typeof document < "u";
function _de(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : o += r + " ";
  }), o;
}
var C9 = function(e, t, n) {
  var o = e.key + "-" + t.name;
  (n === !1 || FD === !1 && e.compat !== void 0) && e.registered[o] === void 0 && (e.registered[o] = t.styles);
}, z9 = function(e, t, n) {
  C9(e, t, n);
  var o = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var r = "", i = t;
    do {
      var a = e.insert(t === i ? "." + o : "", i, e.sheet, !0);
      FD || a === void 0 || (r += a), i = i.next;
    } while (i !== void 0);
    if (!FD && r.length !== 0)
      return r;
  }
}, Ahc = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, Chc = /[A-Z]|^ms/g, zhc = /_EMO_([^_]+?)_([^]*?)_EMO_/g, pde = function(e) {
  return e.charCodeAt(1) === 45;
}, qG = function(e) {
  return e != null && typeof e != "boolean";
}, o3 = lde(function(e) {
  return pde(e) ? e : e.replace(Chc, "-$&").toLowerCase();
}), jG = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(zhc, function(n, o, r) {
          return Ld = { name: o, styles: r, next: Ld }, o;
        });
  }
  return Ahc[e] === 1 || pde(e) || typeof t != "number" || t === 0 ? t : t + "px";
};
function z$(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (n.anim === 1)
        return Ld = { name: n.name, styles: n.styles, next: Ld }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Ld = { name: o.name, styles: o.styles, next: Ld }, o = o.next;
        var r = n.styles + ";";
        return r;
      }
      return function(c, l, d) {
        var u = "";
        if (Array.isArray(d))
          for (var _ = 0; _ < d.length; _++)
            u += z$(c, l, d[_]) + ";";
        else
          for (var p in d) {
            var f = d[p];
            if (typeof f != "object")
              l != null && l[f] !== void 0 ? u += p + "{" + l[f] + "}" : qG(f) && (u += o3(p) + ":" + jG(p, f) + ";");
            else if (!Array.isArray(f) || typeof f[0] != "string" || l != null && l[f[0]] !== void 0) {
              var g = z$(c, l, f);
              switch (p) {
                case "animation":
                case "animationName":
                  u += o3(p) + ":" + g + ";";
                  break;
                default:
                  u += p + "{" + g + "}";
              }
            } else
              for (var h = 0; h < f.length; h++)
                qG(f[h]) && (u += o3(p) + ":" + jG(p, f[h]) + ";");
          }
        return u;
      }(e, t, n);
    case "function":
      if (e !== void 0) {
        var i = Ld, a = n(e);
        return Ld = i, z$(e, t, a);
      }
      break;
  }
  if (t == null)
    return n;
  var s = t[n];
  return s !== void 0 ? s : n;
}
var Ld, FG = /label:\s*([^\s;\n{]+)\s*(;|$)/g, cA = function(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, r = "";
  Ld = void 0;
  var i = e[0];
  i == null || i.raw === void 0 ? (o = !1, r += z$(n, t, i)) : r += i[0];
  for (var a = 1; a < e.length; a++)
    r += z$(n, t, e[a]), o && (r += i[a]);
  FG.lastIndex = 0;
  for (var s, c = ""; (s = FG.exec(r)) !== null; )
    c += "-" + s[1];
  var l = function(d) {
    for (var u, _ = 0, p = 0, f = d.length; f >= 4; ++p, f -= 4)
      u = 1540483477 * (65535 & (u = 255 & d.charCodeAt(p) | (255 & d.charCodeAt(++p)) << 8 | (255 & d.charCodeAt(++p)) << 16 | (255 & d.charCodeAt(++p)) << 24)) + (59797 * (u >>> 16) << 16), _ = 1540483477 * (65535 & (u ^= u >>> 24)) + (59797 * (u >>> 16) << 16) ^ 1540483477 * (65535 & _) + (59797 * (_ >>> 16) << 16);
    switch (f) {
      case 3:
        _ ^= (255 & d.charCodeAt(p + 2)) << 16;
      case 2:
        _ ^= (255 & d.charCodeAt(p + 1)) << 8;
      case 1:
        _ = 1540483477 * (65535 & (_ ^= 255 & d.charCodeAt(p))) + (59797 * (_ >>> 16) << 16);
    }
    return (((_ = 1540483477 * (65535 & (_ ^= _ >>> 13)) + (59797 * (_ >>> 16) << 16)) ^ _ >>> 15) >>> 0).toString(36);
  }(r) + c;
  return { name: l, styles: r, next: Ld };
}, jh = typeof document < "u", O9 = {}.hasOwnProperty, Qx = No(typeof HTMLElement < "u" ? dde({ key: "css" }) : null);
Qx.Provider;
var lA = function(e) {
  return it(function(t, n) {
    var o = Pn(Qx);
    return e(t, o, n);
  });
};
jh || (lA = function(e) {
  return function(t) {
    var n = Pn(Qx);
    return n === null ? (n = dde({ key: "css" }), Pe(Qx.Provider, { value: n }, e(t, n))) : e(t, n);
  };
});
var P9 = No({}), Ohc = typeof document < "u", Phc = $e.useInsertionEffect ? $e.useInsertionEffect : function(e) {
  e();
};
function mde(e) {
  if (!Ohc)
    return e();
  Phc(e);
}
var VD = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Ihc = function(e, t) {
  var n = {};
  for (var o in t)
    O9.call(t, o) && (n[o] = t[o]);
  return n[VD] = e, n;
}, Rhc = function(e) {
  var t = e.cache, n = e.serialized, o = e.isStringTag;
  C9(t, n, o);
  var r = mde(function() {
    return z9(t, n, o);
  });
  if (!jh && r !== void 0) {
    for (var i, a = n.name, s = n.next; s !== void 0; )
      a += " " + s.name, s = s.next;
    return Pe("style", ((i = {})["data-emotion"] = t.key + " " + a, i.dangerouslySetInnerHTML = { __html: r }, i.nonce = t.sheet.nonce, i));
  }
  return null;
}, Nhc = lA(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[VD], i = [o], a = "";
  typeof e.className == "string" ? a = _de(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var s = cA(i, void 0, Pn(P9));
  a += t.key + "-" + s.name;
  var c = {};
  for (var l in e)
    !O9.call(e, l) || l === "css" || l === VD || (c[l] = e[l]);
  return c.ref = n, c.className = a, Pe(Oi, null, Pe(Rhc, { cache: t, serialized: s, isStringTag: typeof r == "string" }), Pe(r, c));
}), En = function(e, t) {
  var n = arguments;
  if (t == null || !O9.call(t, "css"))
    return Pe.apply(void 0, n);
  var o = n.length, r = new Array(o);
  r[0] = Nhc, r[1] = Ihc(e, t);
  for (var i = 2; i < o; i++)
    r[i] = n[i];
  return Pe.apply(null, r);
}, VG = $e.useInsertionEffect ? $e.useInsertionEffect : ts;
lA(function(e, t) {
  var n = e.styles, o = cA([n], void 0, Pn(P9));
  if (!jh) {
    for (var r, i = o.name, a = o.styles, s = o.next; s !== void 0; )
      i += " " + s.name, a += s.styles, s = s.next;
    var c = t.compat === !0, l = t.insert("", { name: i, styles: a }, t.sheet, c);
    return c ? null : Pe("style", ((r = {})["data-emotion"] = t.key + "-global " + i, r.dangerouslySetInnerHTML = { __html: l }, r.nonce = t.sheet.nonce, r));
  }
  var d = Ue();
  return VG(function() {
    var u = t.key + "-global", _ = new t.sheet.constructor({ key: u, nonce: t.sheet.nonce, container: t.sheet.container, speedy: t.sheet.isSpeedy }), p = !1, f = document.querySelector('style[data-emotion="' + u + " " + o.name + '"]');
    return t.sheet.tags.length && (_.before = t.sheet.tags[0]), f !== null && (p = !0, f.setAttribute("data-emotion", u), _.hydrate([f])), d.current = [_, p], function() {
      _.flush();
    };
  }, [t]), VG(function() {
    var u = d.current, _ = u[0];
    if (u[1])
      u[1] = !1;
    else {
      if (o.next !== void 0 && z9(t, o.next, !0), _.tags.length) {
        var p = _.tags[_.tags.length - 1].nextElementSibling;
        _.before = p, _.flush();
      }
      t.insert("", o, _, !1);
    }
  }, [t, o.name]), null;
});
function I9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return cA(t);
}
var Dhc = function e(t) {
  for (var n = t.length, o = 0, r = ""; o < n; o++) {
    var i = t[o];
    if (i != null) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(i))
            a = e(i);
          else
            for (var s in a = "", i)
              i[s] && s && (a && (a += " "), a += s);
          break;
        default:
          a = i;
      }
      a && (r && (r += " "), r += a);
    }
  }
  return r;
};
function Mhc(e, t, n) {
  var o = [], r = _de(e, o, n);
  return o.length < 2 ? n : r + t(o);
}
var Lhc = function(e) {
  var t, n = e.cache, o = e.serializedArr, r = mde(function() {
    for (var i = "", a = 0; a < o.length; a++) {
      var s = z9(n, o[a], !1);
      jh || s === void 0 || (i += s);
    }
    if (!jh)
      return i;
  });
  return jh || r.length === 0 ? null : Pe("style", ((t = {})["data-emotion"] = n.key + " " + o.map(function(i) {
    return i.name;
  }).join(" "), t.dangerouslySetInnerHTML = { __html: r }, t.nonce = n.sheet.nonce, t));
};
lA(function(e, t) {
  var n = !1, o = [], r = function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    var d = cA(c, t.registered);
    return o.push(d), C9(t, d, !1), t.key + "-" + d.name;
  }, i = { css: r, cx: function() {
    for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
      c[l] = arguments[l];
    return Mhc(t.registered, r, Dhc(c));
  }, theme: Pn(P9) }, a = e.children(i);
  return n = !0, Pe(Oi, null, Pe(Lhc, { cache: t, serializedArr: o }), a);
});
function Yd(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function fde(e) {
  return Yd(e).getComputedStyle(e);
}
const y2 = Math.round;
function gde(e) {
  return vde(e) ? (e.nodeName || "").toLowerCase() : "";
}
let $2;
function hde(e) {
  return e instanceof Yd(e).HTMLElement;
}
function Fh(e) {
  return e instanceof Yd(e).Element;
}
function vde(e) {
  return e instanceof Yd(e).Node;
}
function BG(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Yd(e).ShadowRoot || e instanceof ShadowRoot;
}
function bde(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = fde(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function qhc() {
  return !/^((?!chrome|android).)*safari/i.test(function() {
    if ($2)
      return $2;
    const e = navigator.userAgentData;
    return e && Array.isArray(e.brands) ? ($2 = e.brands.map((t) => t.brand + "/" + t.version).join(" "), $2) : navigator.userAgent;
  }());
}
function yde(e) {
  return Fh(e) ? e : e.contextElement;
}
const $de = { x: 1, y: 1 };
function r3(e) {
  const t = yde(e);
  if (!hde(t))
    return $de;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = function(c) {
    const l = fde(c);
    let d = parseFloat(l.width), u = parseFloat(l.height);
    const _ = c.offsetWidth, p = c.offsetHeight, f = y2(d) !== _ || y2(u) !== p;
    return f && (d = _, u = p), { width: d, height: u, fallback: f };
  }(t);
  let a = (i ? y2(n.width) : n.width) / o, s = (i ? y2(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function UG(e, t, n, o) {
  var r, i;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), s = yde(e);
  let c = $de;
  t && (o ? Fh(o) && (c = r3(o)) : c = r3(e));
  const l = s ? Yd(s) : window, d = !qhc() && n;
  let u = (a.left + (d && ((r = l.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / c.x, _ = (a.top + (d && ((i = l.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / c.y, p = a.width / c.x, f = a.height / c.y;
  if (s) {
    const g = Yd(s), h = o && Fh(o) ? Yd(o) : o;
    let b = g.frameElement;
    for (; b && o && h !== g; ) {
      const v = r3(b), $ = b.getBoundingClientRect(), k = getComputedStyle(b);
      $.x += (b.clientLeft + parseFloat(k.paddingLeft)) * v.x, $.y += (b.clientTop + parseFloat(k.paddingTop)) * v.y, u *= v.x, _ *= v.y, p *= v.x, f *= v.y, u += $.x, _ += $.y, b = Yd(b).frameElement;
    }
  }
  return { width: p, height: f, top: _, right: u + p, bottom: _ + f, left: u, x: u, y: _ };
}
function jhc(e) {
  if (gde(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || BG(e) && e.host || function(n) {
    return ((vde(n) ? n.ownerDocument : n.document) || window.document).documentElement;
  }(e);
  return BG(t) ? t.host : t;
}
function wde(e) {
  const t = jhc(e);
  return function(n) {
    return ["html", "body", "#document"].includes(gde(n));
  }(t) ? t.ownerDocument.body : hde(t) && bde(t) ? t : wde(t);
}
function WS(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = wde(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Yd(o);
  return r ? t.concat(i, i.visualViewport || [], bde(o) ? o : []) : t.concat(o, WS(o));
}
var BD = typeof document < "u" ? ts : Le, Fhc = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Jx = function() {
};
function Vhc(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function Bhc(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    o[r - 2] = arguments[r];
  var i = [].concat(o);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(Vhc(e, a)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var WG = function(e) {
  return t = e, Array.isArray(t) ? e.filter(Boolean) : Yx(e) === "object" && e !== null ? [e] : [];
  var t;
}, GG = function(e) {
  return e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, Hn({}, Ov(e, Fhc));
}, pi = function(e, t, n) {
  var o = e.cx, r = e.getStyles, i = e.getClassNames, a = e.className;
  return { css: r(t, e), className: o(n ?? {}, i(t, e), a) };
};
function dA(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function kde(e) {
  return dA(e) ? window.pageYOffset : e.scrollTop;
}
function Xx(e, t) {
  dA(e) ? window.scrollTo(0, t) : e.scrollTop = t;
}
function Uhc(e, t, n, o) {
  return n * ((e = e / o - 1) * e * e + 1) + t;
}
function w2(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Jx, r = kde(e), i = t - r, a = 10, s = 0;
  function c() {
    var l = Uhc(s += a, r, i, n);
    Xx(e, l), s < n ? window.requestAnimationFrame(c) : o(e);
  }
  c();
}
function HG(e, t) {
  var n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? Xx(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && Xx(e, Math.max(t.offsetTop - r, 0));
}
function KG() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
var Sde = !1, Whc = { get passive() {
  return Sde = !0;
} }, k2 = typeof window < "u" ? window : {};
k2.addEventListener && k2.removeEventListener && (k2.addEventListener("p", Jx, Whc), k2.removeEventListener("p", Jx, !1));
var Ghc = Sde;
function Hhc(e) {
  return e != null;
}
function S2(e, t, n) {
  return e ? t : n;
}
function Khc(e) {
  var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, i = e.shouldScroll, a = e.isFixedPosition, s = e.controlHeight, c = function(E) {
    var T = getComputedStyle(E), z = T.position === "absolute", j = /(auto|scroll)/;
    if (T.position === "fixed")
      return document.documentElement;
    for (var q = E; q = q.parentElement; )
      if (T = getComputedStyle(q), (!z || T.position !== "static") && j.test(T.overflow + T.overflowY + T.overflowX))
        return q;
    return document.documentElement;
  }(n), l = { placement: "bottom", maxHeight: t };
  if (!n || !n.offsetParent)
    return l;
  var d, u = c.getBoundingClientRect().height, _ = n.getBoundingClientRect(), p = _.bottom, f = _.height, g = _.top, h = n.offsetParent.getBoundingClientRect().top, b = a || dA(d = c) ? window.innerHeight : d.clientHeight, v = kde(c), $ = parseInt(getComputedStyle(n).marginBottom, 10), k = parseInt(getComputedStyle(n).marginTop, 10), S = h - k, O = b - g, I = S + v, D = u - v - g, M = p - b + v + $, N = v + g - k, C = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (O >= f)
        return { placement: "bottom", maxHeight: t };
      if (D >= f && !a)
        return i && w2(c, M, C), { placement: "bottom", maxHeight: t };
      if (!a && D >= o || a && O >= o)
        return i && w2(c, M, C), { placement: "bottom", maxHeight: a ? O - $ : D - $ };
      if (r === "auto" || a) {
        var P = t, x = a ? S : I;
        return x >= o && (P = Math.min(x - $ - s, t)), { placement: "top", maxHeight: P };
      }
      if (r === "bottom")
        return i && Xx(c, M), { placement: "bottom", maxHeight: t };
      break;
    case "top":
      if (S >= f)
        return { placement: "top", maxHeight: t };
      if (I >= f && !a)
        return i && w2(c, N, C), { placement: "top", maxHeight: t };
      if (!a && I >= o || a && S >= o) {
        var w = t;
        return (!a && I >= o || a && S >= o) && (w = a ? S - k : I - k), i && w2(c, N, C), { placement: "top", maxHeight: w };
      }
      return { placement: "bottom", maxHeight: t };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return l;
}
var xde = function(e) {
  return e === "auto" ? "bottom" : e;
}, Ede = No(null), Yhc = function(e) {
  var t = e.children, n = e.minMenuHeight, o = e.maxMenuHeight, r = e.menuPlacement, i = e.menuPosition, a = e.menuShouldScrollIntoView, s = e.theme, c = (Pn(Ede) || {}).setPortalPlacement, l = Ue(null), d = g_(ze(o), 2), u = d[0], _ = d[1], p = g_(ze(null), 2), f = p[0], g = p[1], h = s.spacing.controlHeight;
  return BD(function() {
    var b = l.current;
    if (b) {
      var v = i === "fixed", $ = Khc({ maxHeight: o, menuEl: b, minHeight: n, placement: r, shouldScroll: a && !v, isFixedPosition: v, controlHeight: h });
      _($.maxHeight), g($.placement), c == null || c($.placement);
    }
  }, [o, r, i, a, n, c, h]), t({ ref: l, placerProps: Hn(Hn({}, e), {}, { placement: f || xde(r), maxHeight: u }) });
}, Tde = function(e, t) {
  var n = e.theme, o = n.spacing.baseUnit, r = n.colors;
  return Hn({ textAlign: "center" }, t ? {} : { color: r.neutral40, padding: "".concat(2 * o, "px ").concat(3 * o, "px") });
}, Zhc = Tde, Qhc = Tde, Ade = function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "noOptionsMessage", { "menu-notice": !0, "menu-notice--no-options": !0 }), n), t);
};
Ade.defaultProps = { children: "No options" };
var Cde = function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "loadingMessage", { "menu-notice": !0, "menu-notice--loading": !0 }), n), t);
};
Cde.defaultProps = { children: "Loading..." };
var YG, Jhc = ["size"], i3, a3, Xhc = { name: "8mmkcg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0" }, zde = function(e) {
  var t = e.size, n = Ov(e, Jhc);
  return En("svg", On({ height: t, width: t, viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", css: Xhc }, n));
}, s3 = function(e) {
  return En(zde, On({ size: 20 }, e), En("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }));
}, ZG = function(e) {
  return En(zde, On({ size: 20 }, e), En("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" }));
}, Ode = function(e, t) {
  var n = e.isFocused, o = e.theme, r = o.spacing.baseUnit, i = o.colors;
  return Hn({ label: "indicatorContainer", display: "flex", transition: "color 150ms" }, t ? {} : { color: n ? i.neutral60 : i.neutral20, padding: 2 * r, ":hover": { color: n ? i.neutral80 : i.neutral40 } });
}, evc = Ode, tvc = Ode, nvc = function() {
  var e = I9.apply(void 0, arguments), t = "animation-" + e.name;
  return { name: t, styles: "@keyframes " + t + "{" + e.styles + "}", anim: 1, toString: function() {
    return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
  } };
}(YG || (i3 = [`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`], a3 || (a3 = i3.slice(0)), YG = Object.freeze(Object.defineProperties(i3, { raw: { value: Object.freeze(a3) } })))), c3 = function(e) {
  var t = e.delay, n = e.offset;
  return En("span", { css: I9({ animation: "".concat(nvc, " 1s ease-in-out ").concat(t, "ms infinite;"), backgroundColor: "currentColor", borderRadius: "1em", display: "inline-block", marginLeft: n ? "1em" : void 0, height: "1em", verticalAlign: "top", width: "1em" }, "", "") });
}, Pde = function(e) {
  var t = e.innerProps, n = e.isRtl;
  return En("div", On({}, pi(e, "loadingIndicator", { indicator: !0, "loading-indicator": !0 }), t), En(c3, { delay: 0, offset: n }), En(c3, { delay: 160, offset: !0 }), En(c3, { delay: 320, offset: !n }));
};
Pde.defaultProps = { size: 4 };
var ovc = ["data"], rvc = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ide = { gridArea: "1 / 2", font: "inherit", minWidth: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, ivc = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", "&:after": Hn({ content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre" }, Ide) }, avc = function(e) {
  return Hn({ label: "input", color: "inherit", background: 0, opacity: e ? 0 : 1, width: "100%" }, Ide);
}, QG = function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", n, t);
}, svc = { ClearIndicator: function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "clearIndicator", { indicator: !0, "clear-indicator": !0 }), n), t || En(s3, null));
}, Control: function(e) {
  var t = e.children, n = e.isDisabled, o = e.isFocused, r = e.innerRef, i = e.innerProps, a = e.menuIsOpen;
  return En("div", On({ ref: r }, pi(e, "control", { control: !0, "control--is-disabled": n, "control--is-focused": o, "control--menu-is-open": a }), i), t);
}, DropdownIndicator: function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "dropdownIndicator", { indicator: !0, "dropdown-indicator": !0 }), n), t || En(ZG, null));
}, DownChevron: ZG, CrossIcon: s3, Group: function(e) {
  var t = e.children, n = e.cx, o = e.getStyles, r = e.getClassNames, i = e.Heading, a = e.headingProps, s = e.innerProps, c = e.label, l = e.theme, d = e.selectProps;
  return En("div", On({}, pi(e, "group", { group: !0 }), s), En(i, On({}, a, { selectProps: d, theme: l, getStyles: o, getClassNames: r, cx: n }), c), En("div", null, t));
}, GroupHeading: function(e) {
  var t = GG(e);
  t.data;
  var n = Ov(t, ovc);
  return En("div", On({}, pi(e, "groupHeading", { "group-heading": !0 }), n));
}, IndicatorsContainer: function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "indicatorsContainer", { indicators: !0 }), n), t);
}, IndicatorSeparator: function(e) {
  var t = e.innerProps;
  return En("span", On({}, t, pi(e, "indicatorSeparator", { "indicator-separator": !0 })));
}, Input: function(e) {
  var t = e.cx, n = e.value, o = GG(e), r = o.innerRef, i = o.isDisabled, a = o.isHidden, s = o.inputClassName, c = Ov(o, rvc);
  return En("div", On({}, pi(e, "input", { "input-container": !0 }), { "data-value": n || "" }), En("input", On({ className: t({ input: !0 }, s), ref: r, style: avc(a), disabled: i }, c)));
}, LoadingIndicator: Pde, Menu: function(e) {
  var t = e.children, n = e.innerRef, o = e.innerProps;
  return En("div", On({}, pi(e, "menu", { menu: !0 }), { ref: n }, o), t);
}, MenuList: function(e) {
  var t = e.children, n = e.innerProps, o = e.innerRef, r = e.isMulti;
  return En("div", On({}, pi(e, "menuList", { "menu-list": !0, "menu-list--is-multi": r }), { ref: o }, n), t);
}, MenuPortal: function(e) {
  var t = e.appendTo, n = e.children, o = e.controlElement, r = e.innerProps, i = e.menuPlacement, a = e.menuPosition, s = Ue(null), c = Ue(null), l = g_(ze(xde(i)), 2), d = l[0], u = l[1], _ = Tt(function() {
    return { setPortalPlacement: u };
  }, []), p = g_(ze(null), 2), f = p[0], g = p[1], h = at(function() {
    if (o) {
      var k = function(I) {
        var D = I.getBoundingClientRect();
        return { bottom: D.bottom, height: D.height, left: D.left, right: D.right, top: D.top, width: D.width };
      }(o), S = a === "fixed" ? 0 : window.pageYOffset, O = k[d] + S;
      O === (f == null ? void 0 : f.offset) && k.left === (f == null ? void 0 : f.rect.left) && k.width === (f == null ? void 0 : f.rect.width) || g({ offset: O, rect: k });
    }
  }, [o, a, d, f == null ? void 0 : f.offset, f == null ? void 0 : f.rect.left, f == null ? void 0 : f.rect.width]);
  BD(function() {
    h();
  }, [h]);
  var b = at(function() {
    typeof c.current == "function" && (c.current(), c.current = null), o && s.current && (c.current = function(k, S, O, I) {
      I === void 0 && (I = {});
      const { ancestorScroll: D = !0, ancestorResize: M = !0, elementResize: N = !0, animationFrame: C = !1 } = I, P = D && !C, x = P || M ? [...Fh(k) ? WS(k) : k.contextElement ? WS(k.contextElement) : [], ...WS(S)] : [];
      x.forEach((z) => {
        P && z.addEventListener("scroll", O, { passive: !0 }), M && z.addEventListener("resize", O);
      });
      let w, E = null;
      if (N) {
        let z = !0;
        E = new ResizeObserver(() => {
          z || O(), z = !1;
        }), Fh(k) && !C && E.observe(k), Fh(k) || !k.contextElement || C || E.observe(k.contextElement), E.observe(S);
      }
      let T = C ? UG(k) : null;
      return C && function z() {
        const j = UG(k);
        !T || j.x === T.x && j.y === T.y && j.width === T.width && j.height === T.height || O(), T = j, w = requestAnimationFrame(z);
      }(), O(), () => {
        var z;
        x.forEach((j) => {
          P && j.removeEventListener("scroll", O), M && j.removeEventListener("resize", O);
        }), (z = E) == null || z.disconnect(), E = null, C && cancelAnimationFrame(w);
      };
    }(o, s.current, h, { elementResize: "ResizeObserver" in window }));
  }, [o, h]);
  BD(function() {
    b();
  }, [b]);
  var v = at(function(k) {
    s.current = k, b();
  }, [b]);
  if (!t && a !== "fixed" || !f)
    return null;
  var $ = En("div", On({ ref: v }, pi(Hn(Hn({}, e), {}, { offset: f.offset, position: a, rect: f.rect }), "menuPortal", { "menu-portal": !0 }), r), n);
  return En(Ede.Provider, { value: _ }, t ? Wv($, t) : $);
}, LoadingMessage: Cde, NoOptionsMessage: Ade, MultiValue: function(e) {
  var t = e.children, n = e.components, o = e.data, r = e.innerProps, i = e.isDisabled, a = e.removeProps, s = e.selectProps, c = n.Container, l = n.Label, d = n.Remove;
  return En(c, { data: o, innerProps: Hn(Hn({}, pi(e, "multiValue", { "multi-value": !0, "multi-value--is-disabled": i })), r), selectProps: s }, En(l, { data: o, innerProps: Hn({}, pi(e, "multiValueLabel", { "multi-value__label": !0 })), selectProps: s }, t), En(d, { data: o, innerProps: Hn(Hn({}, pi(e, "multiValueRemove", { "multi-value__remove": !0 })), {}, { "aria-label": "Remove ".concat(t || "option") }, a), selectProps: s }));
}, MultiValueContainer: QG, MultiValueLabel: QG, MultiValueRemove: function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({ role: "button" }, n), t || En(s3, { size: 14 }));
}, Option: function(e) {
  var t = e.children, n = e.isDisabled, o = e.isFocused, r = e.isSelected, i = e.innerRef, a = e.innerProps;
  return En("div", On({}, pi(e, "option", { option: !0, "option--is-disabled": n, "option--is-focused": o, "option--is-selected": r }), { ref: i, "aria-disabled": n }, a), t);
}, Placeholder: function(e) {
  var t = e.children, n = e.innerProps;
  return En("div", On({}, pi(e, "placeholder", { placeholder: !0 }), n), t);
}, SelectContainer: function(e) {
  var t = e.children, n = e.innerProps, o = e.isDisabled, r = e.isRtl;
  return En("div", On({}, pi(e, "container", { "--is-disabled": o, "--is-rtl": r }), n), t);
}, SingleValue: function(e) {
  var t = e.children, n = e.isDisabled, o = e.innerProps;
  return En("div", On({}, pi(e, "singleValue", { "single-value": !0, "single-value--is-disabled": n }), o), t);
}, ValueContainer: function(e) {
  var t = e.children, n = e.innerProps, o = e.isMulti, r = e.hasValue;
  return En("div", On({}, pi(e, "valueContainer", { "value-container": !0, "value-container--is-multi": o, "value-container--has-value": r }), n), t);
} }, JG = Number.isNaN || function(e) {
  return typeof e == "number" && e != e;
};
function cvc(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (o = e[n], r = t[n], !(o === r || JG(o) && JG(r)))
      return !1;
  var o, r;
  return !0;
}
for (var lvc = { name: "7pg0cj-a11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap" }, XG = function(e) {
  return En("span", On({ css: lvc }, e));
}, dvc = { guidance: function(e) {
  var t = e.isSearchable, n = e.isMulti, o = e.isDisabled, r = e.tabSelectsValue;
  switch (e.context) {
    case "menu":
      return "Use Up and Down to choose options".concat(o ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(r ? ", press Tab to select the option and exit the menu" : "", ".");
    case "input":
      return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "");
    case "value":
      return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
    default:
      return "";
  }
}, onChange: function(e) {
  var t = e.action, n = e.label, o = n === void 0 ? "" : n, r = e.labels, i = e.isDisabled;
  switch (t) {
    case "deselect-option":
    case "pop-value":
    case "remove-value":
      return "option ".concat(o, ", deselected.");
    case "clear":
      return "All selected options have been cleared.";
    case "initial-input-focus":
      return "option".concat(r.length > 1 ? "s" : "", " ").concat(r.join(","), ", selected.");
    case "select-option":
      return "option ".concat(o, i ? " is disabled. Select another option." : ", selected.");
    default:
      return "";
  }
}, onFocus: function(e) {
  var t = e.context, n = e.focused, o = e.options, r = e.label, i = r === void 0 ? "" : r, a = e.selectValue, s = e.isDisabled, c = e.isSelected, l = function(_, p) {
    return _ && _.length ? "".concat(_.indexOf(p) + 1, " of ").concat(_.length) : "";
  };
  if (t === "value" && a)
    return "value ".concat(i, " focused, ").concat(l(a, n), ".");
  if (t === "menu") {
    var d = s ? " disabled" : "", u = "".concat(c ? "selected" : "focused").concat(d);
    return "option ".concat(i, " ").concat(u, ", ").concat(l(o, n), ".");
  }
  return "";
}, onFilter: function(e) {
  var t = e.inputValue, n = e.resultsMessage;
  return "".concat(n).concat(t ? " for search term " + t : "", ".");
} }, uvc = function(e) {
  var t = e.ariaSelection, n = e.focusedOption, o = e.focusedValue, r = e.focusableOptions, i = e.isFocused, a = e.selectValue, s = e.selectProps, c = e.id, l = s.ariaLiveMessages, d = s.getOptionLabel, u = s.inputValue, _ = s.isMulti, p = s.isOptionDisabled, f = s.isSearchable, g = s.menuIsOpen, h = s.options, b = s.screenReaderStatus, v = s.tabSelectsValue, $ = s["aria-label"], k = s["aria-live"], S = Tt(function() {
    return Hn(Hn({}, dvc), l || {});
  }, [l]), O = Tt(function() {
    var x, w = "";
    if (t && S.onChange) {
      var E = t.option, T = t.options, z = t.removedValue, j = t.removedValues, q = t.value, V = z || E || (x = q, Array.isArray(x) ? null : x), F = V ? d(V) : "", L = T || j || void 0, U = L ? L.map(d) : [], W = Hn({ isDisabled: V && p(V, a), label: F, labels: U }, t);
      w = S.onChange(W);
    }
    return w;
  }, [t, S, p, a, d]), I = Tt(function() {
    var x = "", w = n || o, E = !!(n && a && a.includes(n));
    if (w && S.onFocus) {
      var T = { focused: w, label: d(w), isDisabled: p(w, a), isSelected: E, options: r, context: w === n ? "menu" : "value", selectValue: a };
      x = S.onFocus(T);
    }
    return x;
  }, [n, o, d, p, S, r, a]), D = Tt(function() {
    var x = "";
    if (g && h.length && S.onFilter) {
      var w = b({ count: r.length });
      x = S.onFilter({ inputValue: u, resultsMessage: w });
    }
    return x;
  }, [r, u, g, S, h, b]), M = Tt(function() {
    var x = "";
    if (S.guidance) {
      var w = o ? "value" : g ? "menu" : "input";
      x = S.guidance({ "aria-label": $, context: w, isDisabled: n && p(n, a), isMulti: _, isSearchable: f, tabSelectsValue: v });
    }
    return x;
  }, [$, n, o, _, p, f, g, S, a, v]), N = "".concat(I, " ").concat(D, " ").concat(M), C = En(Oi, null, En("span", { id: "aria-selection" }, O), En("span", { id: "aria-context" }, N)), P = (t == null ? void 0 : t.action) === "initial-input-focus";
  return En(Oi, null, En(XG, { id: c }, P && C), En(XG, { "aria-live": k, "aria-atomic": "false", "aria-relevant": "additions text" }, i && !P && C));
}, l3 = [{ base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" }, { base: "AA", letters: "Ꜳ" }, { base: "AE", letters: "ÆǼǢ" }, { base: "AO", letters: "Ꜵ" }, { base: "AU", letters: "Ꜷ" }, { base: "AV", letters: "ꜸꜺ" }, { base: "AY", letters: "Ꜽ" }, { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" }, { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" }, { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ" }, { base: "DZ", letters: "ǱǄ" }, { base: "Dz", letters: "ǲǅ" }, { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" }, { base: "F", letters: "FⒻＦḞƑꝻ" }, { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" }, { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" }, { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" }, { base: "J", letters: "JⒿＪĴɈ" }, { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" }, { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" }, { base: "LJ", letters: "Ǉ" }, { base: "Lj", letters: "ǈ" }, { base: "M", letters: "MⓂＭḾṀṂⱮƜ" }, { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" }, { base: "NJ", letters: "Ǌ" }, { base: "Nj", letters: "ǋ" }, { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" }, { base: "OI", letters: "Ƣ" }, { base: "OO", letters: "Ꝏ" }, { base: "OU", letters: "Ȣ" }, { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" }, { base: "Q", letters: "QⓆＱꝖꝘɊ" }, { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" }, { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" }, { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" }, { base: "TZ", letters: "Ꜩ" }, { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" }, { base: "V", letters: "VⓋＶṼṾƲꝞɅ" }, { base: "VY", letters: "Ꝡ" }, { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" }, { base: "X", letters: "XⓍＸẊẌ" }, { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" }, { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" }, { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" }, { base: "aa", letters: "ꜳ" }, { base: "ae", letters: "æǽǣ" }, { base: "ao", letters: "ꜵ" }, { base: "au", letters: "ꜷ" }, { base: "av", letters: "ꜹꜻ" }, { base: "ay", letters: "ꜽ" }, { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" }, { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" }, { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" }, { base: "dz", letters: "ǳǆ" }, { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" }, { base: "f", letters: "fⓕｆḟƒꝼ" }, { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" }, { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" }, { base: "hv", letters: "ƕ" }, { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" }, { base: "j", letters: "jⓙｊĵǰɉ" }, { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" }, { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" }, { base: "lj", letters: "ǉ" }, { base: "m", letters: "mⓜｍḿṁṃɱɯ" }, { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" }, { base: "nj", letters: "ǌ" }, { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" }, { base: "oi", letters: "ƣ" }, { base: "ou", letters: "ȣ" }, { base: "oo", letters: "ꝏ" }, { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" }, { base: "q", letters: "qⓠｑɋꝗꝙ" }, { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" }, { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" }, { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" }, { base: "tz", letters: "ꜩ" }, { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" }, { base: "v", letters: "vⓥｖṽṿʋꝟʌ" }, { base: "vy", letters: "ꝡ" }, { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" }, { base: "x", letters: "xⓧｘẋẍ" }, { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" }, { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" }], _vc = new RegExp("[" + l3.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), Rde = {}, d3 = 0; d3 < l3.length; d3++)
  for (var u3 = l3[d3], _3 = 0; _3 < u3.letters.length; _3++)
    Rde[u3.letters[_3]] = u3.base;
var Nde = function(e) {
  return e.replace(_vc, function(t) {
    return Rde[t];
  });
}, pvc = function(e, t) {
  t === void 0 && (t = cvc);
  var n = null;
  function o() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (n && n.lastThis === this && t(r, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, r);
    return n = { lastResult: a, lastArgs: r, lastThis: this }, a;
  }
  return o.clear = function() {
    n = null;
  }, o;
}(Nde), eH = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, mvc = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, fvc = ["innerRef"];
function gvc(e) {
  var t = e.innerRef, n = function(o) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    var s = Object.entries(o).filter(function(c) {
      var l = g_(c, 1)[0];
      return !i.includes(l);
    });
    return s.reduce(function(c, l) {
      var d = g_(l, 2), u = d[0], _ = d[1];
      return c[u] = _, c;
    }, {});
  }(Ov(e, fvc), "onExited", "in", "enter", "exit", "appear");
  return En("input", On({ ref: t }, n, { css: I9({ label: "dummyInput", background: 0, border: 0, caretColor: "transparent", fontSize: "inherit", gridArea: "1 / 1 / 2 / 3", outline: 0, padding: 0, width: 1, color: "transparent", left: -100, opacity: 0, position: "relative", transform: "scale(.01)" }, "", "") }));
}
var tH = ["boxSizing", "height", "overflow", "paddingRight", "position"], nH = { boxSizing: "border-box", overflow: "hidden", position: "relative", height: "100%" };
function oH(e) {
  e.preventDefault();
}
function rH(e) {
  e.stopPropagation();
}
function iH() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function aH() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var sH = !(typeof window > "u" || !window.document || !window.document.createElement), Ey = 0, Jg = { capture: !1, passive: !1 }, hvc = function() {
  return document.activeElement && document.activeElement.blur();
}, vvc = { name: "1kfdb0e", styles: "position:fixed;left:0;bottom:0;right:0;top:0" };
function bvc(e) {
  var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = function(a) {
    var s = a.isEnabled, c = a.onBottomArrive, l = a.onBottomLeave, d = a.onTopArrive, u = a.onTopLeave, _ = Ue(!1), p = Ue(!1), f = Ue(0), g = Ue(null), h = at(function(O, I) {
      if (g.current !== null) {
        var D = g.current, M = D.scrollTop, N = D.scrollHeight, C = D.clientHeight, P = g.current, x = I > 0, w = N - C - M, E = !1;
        w > I && _.current && (l && l(O), _.current = !1), x && p.current && (u && u(O), p.current = !1), x && I > w ? (c && !_.current && c(O), P.scrollTop = N, E = !0, _.current = !0) : !x && -I > M && (d && !p.current && d(O), P.scrollTop = 0, E = !0, p.current = !0), E && function(T) {
          T.preventDefault(), T.stopPropagation();
        }(O);
      }
    }, [c, l, d, u]), b = at(function(O) {
      h(O, O.deltaY);
    }, [h]), v = at(function(O) {
      f.current = O.changedTouches[0].clientY;
    }, []), $ = at(function(O) {
      var I = f.current - O.changedTouches[0].clientY;
      h(O, I);
    }, [h]), k = at(function(O) {
      if (O) {
        var I = !!Ghc && { passive: !1 };
        O.addEventListener("wheel", b, I), O.addEventListener("touchstart", v, I), O.addEventListener("touchmove", $, I);
      }
    }, [$, v, b]), S = at(function(O) {
      O && (O.removeEventListener("wheel", b, !1), O.removeEventListener("touchstart", v, !1), O.removeEventListener("touchmove", $, !1));
    }, [$, v, b]);
    return Le(function() {
      if (s) {
        var O = g.current;
        return k(O), function() {
          S(O);
        };
      }
    }, [s, k, S]), function(O) {
      g.current = O;
    };
  }({ isEnabled: o === void 0 || o, onBottomArrive: e.onBottomArrive, onBottomLeave: e.onBottomLeave, onTopArrive: e.onTopArrive, onTopLeave: e.onTopLeave }), i = function(a) {
    var s = a.isEnabled, c = a.accountForScrollbars, l = c === void 0 || c, d = Ue({}), u = Ue(null), _ = at(function(f) {
      if (sH) {
        var g = document.body, h = g && g.style;
        if (l && tH.forEach(function(k) {
          var S = h && h[k];
          d.current[k] = S;
        }), l && Ey < 1) {
          var b = parseInt(d.current.paddingRight, 10) || 0, v = document.body ? document.body.clientWidth : 0, $ = window.innerWidth - v + b || 0;
          Object.keys(nH).forEach(function(k) {
            var S = nH[k];
            h && (h[k] = S);
          }), h && (h.paddingRight = "".concat($, "px"));
        }
        g && aH() && (g.addEventListener("touchmove", oH, Jg), f && (f.addEventListener("touchstart", iH, Jg), f.addEventListener("touchmove", rH, Jg))), Ey += 1;
      }
    }, [l]), p = at(function(f) {
      if (sH) {
        var g = document.body, h = g && g.style;
        Ey = Math.max(Ey - 1, 0), l && Ey < 1 && tH.forEach(function(b) {
          var v = d.current[b];
          h && (h[b] = v);
        }), g && aH() && (g.removeEventListener("touchmove", oH, Jg), f && (f.removeEventListener("touchstart", iH, Jg), f.removeEventListener("touchmove", rH, Jg)));
      }
    }, [l]);
    return Le(function() {
      if (s) {
        var f = u.current;
        return _(f), function() {
          p(f);
        };
      }
    }, [s, _, p]), function(f) {
      u.current = f;
    };
  }({ isEnabled: n });
  return En(Oi, null, n && En("div", { onClick: hvc, css: vvc }), t(function(a) {
    r(a), i(a);
  }));
}
var yvc, $vc = { name: "1a0ro4n-requiredInput", styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%" }, wvc = function(e) {
  var t = e.name, n = e.onFocus;
  return En("input", { required: !0, name: t, tabIndex: -1, onFocus: n, css: $vc, value: "", onChange: function() {
  } });
}, kvc = { clearIndicator: tvc, container: function(e) {
  var t = e.isDisabled;
  return { label: "container", direction: e.isRtl ? "rtl" : void 0, pointerEvents: t ? "none" : void 0, position: "relative" };
}, control: function(e, t) {
  var n = e.isDisabled, o = e.isFocused, r = e.theme, i = r.colors, a = r.borderRadius;
  return Hn({ label: "control", alignItems: "center", cursor: "default", display: "flex", flexWrap: "wrap", justifyContent: "space-between", minHeight: r.spacing.controlHeight, outline: "0 !important", position: "relative", transition: "all 100ms" }, t ? {} : { backgroundColor: n ? i.neutral5 : i.neutral0, borderColor: n ? i.neutral10 : o ? i.primary : i.neutral20, borderRadius: a, borderStyle: "solid", borderWidth: 1, boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0, "&:hover": { borderColor: o ? i.primary : i.neutral30 } });
}, dropdownIndicator: evc, group: function(e, t) {
  var n = e.theme.spacing;
  return t ? {} : { paddingBottom: 2 * n.baseUnit, paddingTop: 2 * n.baseUnit };
}, groupHeading: function(e, t) {
  var n = e.theme, o = n.colors, r = n.spacing;
  return Hn({ label: "group", cursor: "default", display: "block" }, t ? {} : { color: o.neutral40, fontSize: "75%", fontWeight: 500, marginBottom: "0.25em", paddingLeft: 3 * r.baseUnit, paddingRight: 3 * r.baseUnit, textTransform: "uppercase" });
}, indicatorsContainer: function() {
  return { alignItems: "center", alignSelf: "stretch", display: "flex", flexShrink: 0 };
}, indicatorSeparator: function(e, t) {
  var n = e.isDisabled, o = e.theme, r = o.spacing.baseUnit, i = o.colors;
  return Hn({ label: "indicatorSeparator", alignSelf: "stretch", width: 1 }, t ? {} : { backgroundColor: n ? i.neutral10 : i.neutral20, marginBottom: 2 * r, marginTop: 2 * r });
}, input: function(e, t) {
  var n = e.isDisabled, o = e.value, r = e.theme, i = r.spacing, a = r.colors;
  return Hn(Hn({ visibility: n ? "hidden" : "visible", transform: o ? "translateZ(0)" : "" }, ivc), t ? {} : { margin: i.baseUnit / 2, paddingBottom: i.baseUnit / 2, paddingTop: i.baseUnit / 2, color: a.neutral80 });
}, loadingIndicator: function(e, t) {
  var n = e.isFocused, o = e.size, r = e.theme, i = r.colors, a = r.spacing.baseUnit;
  return Hn({ label: "loadingIndicator", display: "flex", transition: "color 150ms", alignSelf: "center", fontSize: o, lineHeight: 1, marginRight: o, textAlign: "center", verticalAlign: "middle" }, t ? {} : { color: n ? i.neutral60 : i.neutral20, padding: 2 * a });
}, loadingMessage: Qhc, menu: function(e, t) {
  var n, o = e.placement, r = e.theme, i = r.borderRadius, a = r.spacing, s = r.colors;
  return Hn((l$(n = { label: "menu" }, function(c) {
    return c ? { bottom: "top", top: "bottom" }[c] : "bottom";
  }(o), "100%"), l$(n, "position", "absolute"), l$(n, "width", "100%"), l$(n, "zIndex", 1), n), t ? {} : { backgroundColor: s.neutral0, borderRadius: i, boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)", marginBottom: a.menuGutter, marginTop: a.menuGutter });
}, menuList: function(e, t) {
  var n = e.maxHeight, o = e.theme.spacing.baseUnit;
  return Hn({ maxHeight: n, overflowY: "auto", position: "relative", WebkitOverflowScrolling: "touch" }, t ? {} : { paddingBottom: o, paddingTop: o });
}, menuPortal: function(e) {
  var t = e.rect, n = e.offset, o = e.position;
  return { left: t.left, position: o, top: n, width: t.width, zIndex: 1 };
}, multiValue: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.borderRadius, i = n.colors;
  return Hn({ label: "multiValue", display: "flex", minWidth: 0 }, t ? {} : { backgroundColor: i.neutral10, borderRadius: r / 2, margin: o.baseUnit / 2 });
}, multiValueLabel: function(e, t) {
  var n = e.theme, o = n.borderRadius, r = n.colors, i = e.cropWithEllipsis;
  return Hn({ overflow: "hidden", textOverflow: i || i === void 0 ? "ellipsis" : void 0, whiteSpace: "nowrap" }, t ? {} : { borderRadius: o / 2, color: r.neutral80, fontSize: "85%", padding: 3, paddingLeft: 6 });
}, multiValueRemove: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.borderRadius, i = n.colors, a = e.isFocused;
  return Hn({ alignItems: "center", display: "flex" }, t ? {} : { borderRadius: r / 2, backgroundColor: a ? i.dangerLight : void 0, paddingLeft: o.baseUnit, paddingRight: o.baseUnit, ":hover": { backgroundColor: i.dangerLight, color: i.danger } });
}, noOptionsMessage: Zhc, option: function(e, t) {
  var n = e.isDisabled, o = e.isFocused, r = e.isSelected, i = e.theme, a = i.spacing, s = i.colors;
  return Hn({ label: "option", cursor: "default", display: "block", fontSize: "inherit", width: "100%", userSelect: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }, t ? {} : { backgroundColor: r ? s.primary : o ? s.primary25 : "transparent", color: n ? s.neutral20 : r ? s.neutral0 : "inherit", padding: "".concat(2 * a.baseUnit, "px ").concat(3 * a.baseUnit, "px"), ":active": { backgroundColor: n ? void 0 : r ? s.primary : s.primary50 } });
}, placeholder: function(e, t) {
  var n = e.theme, o = n.spacing, r = n.colors;
  return Hn({ label: "placeholder", gridArea: "1 / 1 / 2 / 3" }, t ? {} : { color: r.neutral50, marginLeft: o.baseUnit / 2, marginRight: o.baseUnit / 2 });
}, singleValue: function(e, t) {
  var n = e.isDisabled, o = e.theme, r = o.spacing, i = o.colors;
  return Hn({ label: "singleValue", gridArea: "1 / 1 / 2 / 3", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, t ? {} : { color: n ? i.neutral40 : i.neutral80, marginLeft: r.baseUnit / 2, marginRight: r.baseUnit / 2 });
}, valueContainer: function(e, t) {
  var n = e.theme.spacing, o = e.isMulti, r = e.hasValue, i = e.selectProps.controlShouldRenderValue;
  return Hn({ alignItems: "center", display: o && r && i ? "flex" : "grid", flex: 1, flexWrap: "wrap", WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" }, t ? {} : { padding: "".concat(n.baseUnit / 2, "px ").concat(2 * n.baseUnit, "px") });
} }, p3 = { borderRadius: 4, colors: { primary: "#2684FF", primary75: "#4C9AFF", primary50: "#B2D4FF", primary25: "#DEEBFF", danger: "#DE350B", dangerLight: "#FFBDAD", neutral0: "hsl(0, 0%, 100%)", neutral5: "hsl(0, 0%, 95%)", neutral10: "hsl(0, 0%, 90%)", neutral20: "hsl(0, 0%, 80%)", neutral30: "hsl(0, 0%, 70%)", neutral40: "hsl(0, 0%, 60%)", neutral50: "hsl(0, 0%, 50%)", neutral60: "hsl(0, 0%, 40%)", neutral70: "hsl(0, 0%, 30%)", neutral80: "hsl(0, 0%, 20%)", neutral90: "hsl(0, 0%, 10%)" }, spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 } }, Svc = { "aria-live": "polite", backspaceRemovesValue: !0, blurInputOnSelect: KG(), captureMenuScroll: !KG(), classNames: {}, closeMenuOnSelect: !0, closeMenuOnScroll: !1, components: {}, controlShouldRenderValue: !0, escapeClearsValue: !1, filterOption: function(e, t) {
  if (e.data.__isNew__)
    return !0;
  var n = Hn({ ignoreCase: !0, ignoreAccents: !0, stringify: mvc, trim: !0, matchFrom: "any" }, yvc), o = n.ignoreCase, r = n.ignoreAccents, i = n.stringify, a = n.trim, s = n.matchFrom, c = a ? eH(t) : t, l = a ? eH(i(e)) : i(e);
  return o && (c = c.toLowerCase(), l = l.toLowerCase()), r && (c = pvc(c), l = Nde(l)), s === "start" ? l.substr(0, c.length) === c : l.indexOf(c) > -1;
}, formatGroupLabel: function(e) {
  return e.label;
}, getOptionLabel: function(e) {
  return e.label;
}, getOptionValue: function(e) {
  return e.value;
}, isDisabled: !1, isLoading: !1, isMulti: !1, isRtl: !1, isSearchable: !0, isOptionDisabled: function(e) {
  return !!e.isDisabled;
}, loadingMessage: function() {
  return "Loading...";
}, maxMenuHeight: 300, minMenuHeight: 140, menuIsOpen: !1, menuPlacement: "bottom", menuPosition: "absolute", menuShouldBlockScroll: !1, menuShouldScrollIntoView: !function() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}(), noOptionsMessage: function() {
  return "No options";
}, openMenuOnFocus: !1, openMenuOnClick: !0, options: [], pageSize: 5, placeholder: "Select...", screenReaderStatus: function(e) {
  var t = e.count;
  return "".concat(t, " result").concat(t !== 1 ? "s" : "", " available");
}, styles: {}, tabIndex: 0, tabSelectsValue: !0, unstyled: !1 };
function cH(e, t, n, o) {
  return { type: "option", data: t, isDisabled: Mde(e, t, n), isSelected: Lde(e, t, n), label: Dde(e, t), value: eE(e, t), index: o };
}
function lH(e, t) {
  return e.options.map(function(n, o) {
    if ("options" in n) {
      var r = n.options.map(function(a, s) {
        return cH(e, a, t, s);
      }).filter(function(a) {
        return uH(e, a);
      });
      return r.length > 0 ? { type: "group", data: n, options: r, index: o } : void 0;
    }
    var i = cH(e, n, t, o);
    return uH(e, i) ? i : void 0;
  }).filter(Hhc);
}
function dH(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, ode(n.options.map(function(o) {
      return o.data;
    }))) : t.push(n.data), t;
  }, []);
}
function uH(e, t) {
  var n = e.inputValue, o = n === void 0 ? "" : n, r = t.data, i = t.isSelected, a = t.label, s = t.value;
  return (!jde(e) || !i) && qde(e, { label: a, value: s, data: r }, o);
}
var Dde = function(e, t) {
  return e.getOptionLabel(t);
}, eE = function(e, t) {
  return e.getOptionValue(t);
};
function Mde(e, t, n) {
  return typeof e.isOptionDisabled == "function" && e.isOptionDisabled(t, n);
}
function Lde(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var o = eE(e, t);
  return n.some(function(r) {
    return eE(e, r) === o;
  });
}
function qde(e, t, n) {
  return !e.filterOption || e.filterOption(t, n);
}
var jde = function(e) {
  var t = e.hideSelectedOptions, n = e.isMulti;
  return t === void 0 ? n : t;
}, xvc = 1, Fde = function(e) {
  (function(a, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(s && s.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), s && ND(a, s);
  })(i, xie);
  var t, n, o, r = shc(i);
  function i(a) {
    var s;
    if (function(d, u) {
      if (!(d instanceof u))
        throw new TypeError("Cannot call a class as a function");
    }(this, i), (s = r.call(this, a)).state = { ariaSelection: null, focusedOption: null, focusedValue: null, inputIsHidden: !1, isFocused: !1, selectValue: [], clearFocusValueOnUpdate: !1, prevWasFocused: !1, inputIsHiddenAfterUpdate: void 0, prevProps: void 0 }, s.blockOptionHover = !1, s.isComposing = !1, s.commonProps = void 0, s.initialTouchX = 0, s.initialTouchY = 0, s.instancePrefix = "", s.openAfterFocus = !1, s.scrollToFocusedOptionOnUpdate = !1, s.userIsDragging = void 0, s.controlRef = null, s.getControlRef = function(d) {
      s.controlRef = d;
    }, s.focusedOptionRef = null, s.getFocusedOptionRef = function(d) {
      s.focusedOptionRef = d;
    }, s.menuListRef = null, s.getMenuListRef = function(d) {
      s.menuListRef = d;
    }, s.inputRef = null, s.getInputRef = function(d) {
      s.inputRef = d;
    }, s.focus = s.focusInput, s.blur = s.blurInput, s.onChange = function(d, u) {
      var _ = s.props, p = _.onChange, f = _.name;
      u.name = f, s.ariaOnChange(d, u), p(d, u);
    }, s.setValue = function(d, u, _) {
      var p = s.props, f = p.closeMenuOnSelect, g = p.isMulti, h = p.inputValue;
      s.onInputChange("", { action: "set-value", prevInputValue: h }), f && (s.setState({ inputIsHiddenAfterUpdate: !g }), s.onMenuClose()), s.setState({ clearFocusValueOnUpdate: !0 }), s.onChange(d, { action: u, option: _ });
    }, s.selectOption = function(d) {
      var u = s.props, _ = u.blurInputOnSelect, p = u.isMulti, f = u.name, g = s.state.selectValue, h = p && s.isOptionSelected(d, g), b = s.isOptionDisabled(d, g);
      if (h) {
        var v = s.getOptionValue(d);
        s.setValue(g.filter(function($) {
          return s.getOptionValue($) !== v;
        }), "deselect-option", d);
      } else {
        if (b)
          return void s.ariaOnChange(d, { action: "select-option", option: d, name: f });
        p ? s.setValue([].concat(ode(g), [d]), "select-option", d) : s.setValue(d, "select-option");
      }
      _ && s.blurInput();
    }, s.removeValue = function(d) {
      var u = s.props.isMulti, _ = s.state.selectValue, p = s.getOptionValue(d), f = _.filter(function(h) {
        return s.getOptionValue(h) !== p;
      }), g = S2(u, f, f[0] || null);
      s.onChange(g, { action: "remove-value", removedValue: d }), s.focusInput();
    }, s.clearValue = function() {
      var d = s.state.selectValue;
      s.onChange(S2(s.props.isMulti, [], null), { action: "clear", removedValues: d });
    }, s.popValue = function() {
      var d = s.props.isMulti, u = s.state.selectValue, _ = u[u.length - 1], p = u.slice(0, u.length - 1), f = S2(d, p, p[0] || null);
      s.onChange(f, { action: "pop-value", removedValue: _ });
    }, s.getValue = function() {
      return s.state.selectValue;
    }, s.cx = function() {
      for (var d = arguments.length, u = new Array(d), _ = 0; _ < d; _++)
        u[_] = arguments[_];
      return Bhc.apply(void 0, [s.props.classNamePrefix].concat(u));
    }, s.getOptionLabel = function(d) {
      return Dde(s.props, d);
    }, s.getOptionValue = function(d) {
      return eE(s.props, d);
    }, s.getStyles = function(d, u) {
      var _ = s.props.unstyled, p = kvc[d](u, _);
      p.boxSizing = "border-box";
      var f = s.props.styles[d];
      return f ? f(p, u) : p;
    }, s.getClassNames = function(d, u) {
      var _, p;
      return (_ = (p = s.props.classNames)[d]) === null || _ === void 0 ? void 0 : _.call(p, u);
    }, s.getElementId = function(d) {
      return "".concat(s.instancePrefix, "-").concat(d);
    }, s.getComponents = function() {
      return d = s.props, Hn(Hn({}, svc), d.components);
      var d;
    }, s.buildCategorizedOptions = function() {
      return lH(s.props, s.state.selectValue);
    }, s.getCategorizedOptions = function() {
      return s.props.menuIsOpen ? s.buildCategorizedOptions() : [];
    }, s.buildFocusableOptions = function() {
      return dH(s.buildCategorizedOptions());
    }, s.getFocusableOptions = function() {
      return s.props.menuIsOpen ? s.buildFocusableOptions() : [];
    }, s.ariaOnChange = function(d, u) {
      s.setState({ ariaSelection: Hn({ value: d }, u) });
    }, s.onMenuMouseDown = function(d) {
      d.button === 0 && (d.stopPropagation(), d.preventDefault(), s.focusInput());
    }, s.onMenuMouseMove = function(d) {
      s.blockOptionHover = !1;
    }, s.onControlMouseDown = function(d) {
      if (!d.defaultPrevented) {
        var u = s.props.openMenuOnClick;
        s.state.isFocused ? s.props.menuIsOpen ? d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && s.onMenuClose() : u && s.openMenu("first") : (u && (s.openAfterFocus = !0), s.focusInput()), d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && d.preventDefault();
      }
    }, s.onDropdownIndicatorMouseDown = function(d) {
      if (!(d && d.type === "mousedown" && d.button !== 0 || s.props.isDisabled)) {
        var u = s.props, _ = u.isMulti, p = u.menuIsOpen;
        s.focusInput(), p ? (s.setState({ inputIsHiddenAfterUpdate: !_ }), s.onMenuClose()) : s.openMenu("first"), d.preventDefault();
      }
    }, s.onClearIndicatorMouseDown = function(d) {
      d && d.type === "mousedown" && d.button !== 0 || (s.clearValue(), d.preventDefault(), s.openAfterFocus = !1, d.type === "touchend" ? s.focusInput() : setTimeout(function() {
        return s.focusInput();
      }));
    }, s.onScroll = function(d) {
      typeof s.props.closeMenuOnScroll == "boolean" ? d.target instanceof HTMLElement && dA(d.target) && s.props.onMenuClose() : typeof s.props.closeMenuOnScroll == "function" && s.props.closeMenuOnScroll(d) && s.props.onMenuClose();
    }, s.onCompositionStart = function() {
      s.isComposing = !0;
    }, s.onCompositionEnd = function() {
      s.isComposing = !1;
    }, s.onTouchStart = function(d) {
      var u = d.touches, _ = u && u.item(0);
      _ && (s.initialTouchX = _.clientX, s.initialTouchY = _.clientY, s.userIsDragging = !1);
    }, s.onTouchMove = function(d) {
      var u = d.touches, _ = u && u.item(0);
      if (_) {
        var p = Math.abs(_.clientX - s.initialTouchX), f = Math.abs(_.clientY - s.initialTouchY);
        s.userIsDragging = p > 5 || f > 5;
      }
    }, s.onTouchEnd = function(d) {
      s.userIsDragging || (s.controlRef && !s.controlRef.contains(d.target) && s.menuListRef && !s.menuListRef.contains(d.target) && s.blurInput(), s.initialTouchX = 0, s.initialTouchY = 0);
    }, s.onControlTouchEnd = function(d) {
      s.userIsDragging || s.onControlMouseDown(d);
    }, s.onClearIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onClearIndicatorMouseDown(d);
    }, s.onDropdownIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onDropdownIndicatorMouseDown(d);
    }, s.handleInputChange = function(d) {
      var u = s.props.inputValue, _ = d.currentTarget.value;
      s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange(_, { action: "input-change", prevInputValue: u }), s.props.menuIsOpen || s.onMenuOpen();
    }, s.onInputFocus = function(d) {
      s.props.onFocus && s.props.onFocus(d), s.setState({ inputIsHiddenAfterUpdate: !1, isFocused: !0 }), (s.openAfterFocus || s.props.openMenuOnFocus) && s.openMenu("first"), s.openAfterFocus = !1;
    }, s.onInputBlur = function(d) {
      var u = s.props.inputValue;
      s.menuListRef && s.menuListRef.contains(document.activeElement) ? s.inputRef.focus() : (s.props.onBlur && s.props.onBlur(d), s.onInputChange("", { action: "input-blur", prevInputValue: u }), s.onMenuClose(), s.setState({ focusedValue: null, isFocused: !1 }));
    }, s.onOptionHover = function(d) {
      s.blockOptionHover || s.state.focusedOption === d || s.setState({ focusedOption: d });
    }, s.shouldHideSelectedOptions = function() {
      return jde(s.props);
    }, s.onValueInputFocus = function(d) {
      d.preventDefault(), d.stopPropagation(), s.focus();
    }, s.onKeyDown = function(d) {
      var u = s.props, _ = u.isMulti, p = u.backspaceRemovesValue, f = u.escapeClearsValue, g = u.inputValue, h = u.isClearable, b = u.isDisabled, v = u.menuIsOpen, $ = u.onKeyDown, k = u.tabSelectsValue, S = u.openMenuOnFocus, O = s.state, I = O.focusedOption, D = O.focusedValue, M = O.selectValue;
      if (!(b || typeof $ == "function" && ($(d), d.defaultPrevented))) {
        switch (s.blockOptionHover = !0, d.key) {
          case "ArrowLeft":
            if (!_ || g)
              return;
            s.focusValue("previous");
            break;
          case "ArrowRight":
            if (!_ || g)
              return;
            s.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (g)
              return;
            if (D)
              s.removeValue(D);
            else {
              if (!p)
                return;
              _ ? s.popValue() : h && s.clearValue();
            }
            break;
          case "Tab":
            if (s.isComposing || d.shiftKey || !v || !k || !I || S && s.isOptionSelected(I, M))
              return;
            s.selectOption(I);
            break;
          case "Enter":
            if (d.keyCode === 229)
              break;
            if (v) {
              if (!I || s.isComposing)
                return;
              s.selectOption(I);
              break;
            }
            return;
          case "Escape":
            v ? (s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange("", { action: "menu-close", prevInputValue: g }), s.onMenuClose()) : h && f && s.clearValue();
            break;
          case " ":
            if (g)
              return;
            if (!v) {
              s.openMenu("first");
              break;
            }
            if (!I)
              return;
            s.selectOption(I);
            break;
          case "ArrowUp":
            v ? s.focusOption("up") : s.openMenu("last");
            break;
          case "ArrowDown":
            v ? s.focusOption("down") : s.openMenu("first");
            break;
          case "PageUp":
            if (!v)
              return;
            s.focusOption("pageup");
            break;
          case "PageDown":
            if (!v)
              return;
            s.focusOption("pagedown");
            break;
          case "Home":
            if (!v)
              return;
            s.focusOption("first");
            break;
          case "End":
            if (!v)
              return;
            s.focusOption("last");
            break;
          default:
            return;
        }
        d.preventDefault();
      }
    }, s.instancePrefix = "react-select-" + (s.props.instanceId || ++xvc), s.state.selectValue = WG(a.value), a.menuIsOpen && s.state.selectValue.length) {
      var c = s.buildFocusableOptions(), l = c.indexOf(s.state.selectValue[0]);
      s.state.focusedOption = c[l];
    }
    return s;
  }
  return t = i, n = [{ key: "componentDidMount", value: function() {
    this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && HG(this.menuListRef, this.focusedOptionRef);
  } }, { key: "componentDidUpdate", value: function(a) {
    var s = this.props, c = s.isDisabled, l = s.menuIsOpen, d = this.state.isFocused;
    (d && !c && a.isDisabled || d && l && !a.menuIsOpen) && this.focusInput(), d && c && !a.isDisabled ? this.setState({ isFocused: !1 }, this.onMenuClose) : d || c || !a.isDisabled || this.inputRef !== document.activeElement || this.setState({ isFocused: !0 }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (HG(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
  } }, { key: "componentWillUnmount", value: function() {
    this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "onMenuOpen", value: function() {
    this.props.onMenuOpen();
  } }, { key: "onMenuClose", value: function() {
    this.onInputChange("", { action: "menu-close", prevInputValue: this.props.inputValue }), this.props.onMenuClose();
  } }, { key: "onInputChange", value: function(a, s) {
    this.props.onInputChange(a, s);
  } }, { key: "focusInput", value: function() {
    this.inputRef && this.inputRef.focus();
  } }, { key: "blurInput", value: function() {
    this.inputRef && this.inputRef.blur();
  } }, { key: "openMenu", value: function(a) {
    var s = this, c = this.state, l = c.selectValue, d = c.isFocused, u = this.buildFocusableOptions(), _ = a === "first" ? 0 : u.length - 1;
    if (!this.props.isMulti) {
      var p = u.indexOf(l[0]);
      p > -1 && (_ = p);
    }
    this.scrollToFocusedOptionOnUpdate = !(d && this.menuListRef), this.setState({ inputIsHiddenAfterUpdate: !1, focusedValue: null, focusedOption: u[_] }, function() {
      return s.onMenuOpen();
    });
  } }, { key: "focusValue", value: function(a) {
    var s = this.state, c = s.selectValue, l = s.focusedValue;
    if (this.props.isMulti) {
      this.setState({ focusedOption: null });
      var d = c.indexOf(l);
      l || (d = -1);
      var u = c.length - 1, _ = -1;
      if (c.length) {
        switch (a) {
          case "previous":
            _ = d === 0 ? 0 : d === -1 ? u : d - 1;
            break;
          case "next":
            d > -1 && d < u && (_ = d + 1);
        }
        this.setState({ inputIsHidden: _ !== -1, focusedValue: c[_] });
      }
    }
  } }, { key: "focusOption", value: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", s = this.props.pageSize, c = this.state.focusedOption, l = this.getFocusableOptions();
    if (l.length) {
      var d = 0, u = l.indexOf(c);
      c || (u = -1), a === "up" ? d = u > 0 ? u - 1 : l.length - 1 : a === "down" ? d = (u + 1) % l.length : a === "pageup" ? (d = u - s) < 0 && (d = 0) : a === "pagedown" ? (d = u + s) > l.length - 1 && (d = l.length - 1) : a === "last" && (d = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({ focusedOption: l[d], focusedValue: null });
    }
  } }, { key: "getTheme", value: function() {
    return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(p3) : Hn(Hn({}, p3), this.props.theme) : p3;
  } }, { key: "getCommonProps", value: function() {
    var a = this.clearValue, s = this.cx, c = this.getStyles, l = this.getClassNames, d = this.getValue, u = this.selectOption, _ = this.setValue, p = this.props, f = p.isMulti, g = p.isRtl, h = p.options;
    return { clearValue: a, cx: s, getStyles: c, getClassNames: l, getValue: d, hasValue: this.hasValue(), isMulti: f, isRtl: g, options: h, selectOption: u, selectProps: p, setValue: _, theme: this.getTheme() };
  } }, { key: "hasValue", value: function() {
    return this.state.selectValue.length > 0;
  } }, { key: "hasOptions", value: function() {
    return !!this.getFocusableOptions().length;
  } }, { key: "isClearable", value: function() {
    var a = this.props, s = a.isClearable, c = a.isMulti;
    return s === void 0 ? c : s;
  } }, { key: "isOptionDisabled", value: function(a, s) {
    return Mde(this.props, a, s);
  } }, { key: "isOptionSelected", value: function(a, s) {
    return Lde(this.props, a, s);
  } }, { key: "filterOption", value: function(a, s) {
    return qde(this.props, a, s);
  } }, { key: "formatOptionLabel", value: function(a, s) {
    if (typeof this.props.formatOptionLabel == "function") {
      var c = this.props.inputValue, l = this.state.selectValue;
      return this.props.formatOptionLabel(a, { context: s, inputValue: c, selectValue: l });
    }
    return this.getOptionLabel(a);
  } }, { key: "formatGroupLabel", value: function(a) {
    return this.props.formatGroupLabel(a);
  } }, { key: "startListeningComposition", value: function() {
    document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
  } }, { key: "stopListeningComposition", value: function() {
    document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
  } }, { key: "startListeningToTouch", value: function() {
    document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
  } }, { key: "stopListeningToTouch", value: function() {
    document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
  } }, { key: "renderInput", value: function() {
    var a = this.props, s = a.isDisabled, c = a.isSearchable, l = a.inputId, d = a.inputValue, u = a.tabIndex, _ = a.form, p = a.menuIsOpen, f = a.required, g = this.getComponents().Input, h = this.state, b = h.inputIsHidden, v = h.ariaSelection, $ = this.commonProps, k = l || this.getElementId("input"), S = Hn(Hn(Hn({ "aria-autocomplete": "list", "aria-expanded": p, "aria-haspopup": !0, "aria-errormessage": this.props["aria-errormessage"], "aria-invalid": this.props["aria-invalid"], "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"], "aria-required": f, role: "combobox" }, p && { "aria-controls": this.getElementId("listbox"), "aria-owns": this.getElementId("listbox") }), !c && { "aria-readonly": !0 }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && { "aria-describedby": this.getElementId("live-region") } : { "aria-describedby": this.getElementId("placeholder") });
    return c ? $e.createElement(g, On({}, $, { autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", id: k, innerRef: this.getInputRef, isDisabled: s, isHidden: b, onBlur: this.onInputBlur, onChange: this.handleInputChange, onFocus: this.onInputFocus, spellCheck: "false", tabIndex: u, form: _, type: "text", value: d }, S)) : $e.createElement(gvc, On({ id: k, innerRef: this.getInputRef, onBlur: this.onInputBlur, onChange: Jx, onFocus: this.onInputFocus, disabled: s, tabIndex: u, inputMode: "none", form: _, value: "" }, S));
  } }, { key: "renderPlaceholderOrValue", value: function() {
    var a = this, s = this.getComponents(), c = s.MultiValue, l = s.MultiValueContainer, d = s.MultiValueLabel, u = s.MultiValueRemove, _ = s.SingleValue, p = s.Placeholder, f = this.commonProps, g = this.props, h = g.controlShouldRenderValue, b = g.isDisabled, v = g.isMulti, $ = g.inputValue, k = g.placeholder, S = this.state, O = S.selectValue, I = S.focusedValue, D = S.isFocused;
    if (!this.hasValue() || !h)
      return $ ? null : $e.createElement(p, On({}, f, { key: "placeholder", isDisabled: b, isFocused: D, innerProps: { id: this.getElementId("placeholder") } }), k);
    if (v)
      return O.map(function(N, C) {
        var P = N === I, x = "".concat(a.getOptionLabel(N), "-").concat(a.getOptionValue(N));
        return $e.createElement(c, On({}, f, { components: { Container: l, Label: d, Remove: u }, isFocused: P, isDisabled: b, key: x, index: C, removeProps: { onClick: function() {
          return a.removeValue(N);
        }, onTouchEnd: function() {
          return a.removeValue(N);
        }, onMouseDown: function(w) {
          w.preventDefault();
        } }, data: N }), a.formatOptionLabel(N, "value"));
      });
    if ($)
      return null;
    var M = O[0];
    return $e.createElement(_, On({}, f, { data: M, isDisabled: b }), this.formatOptionLabel(M, "value"));
  } }, { key: "renderClearIndicator", value: function() {
    var a = this.getComponents().ClearIndicator, s = this.commonProps, c = this.props, l = c.isDisabled, d = c.isLoading, u = this.state.isFocused;
    if (!this.isClearable() || !a || l || !this.hasValue() || d)
      return null;
    var _ = { onMouseDown: this.onClearIndicatorMouseDown, onTouchEnd: this.onClearIndicatorTouchEnd, "aria-hidden": "true" };
    return $e.createElement(a, On({}, s, { innerProps: _, isFocused: u }));
  } }, { key: "renderLoadingIndicator", value: function() {
    var a = this.getComponents().LoadingIndicator, s = this.commonProps, c = this.props, l = c.isDisabled, d = c.isLoading, u = this.state.isFocused;
    return a && d ? $e.createElement(a, On({}, s, { innerProps: { "aria-hidden": "true" }, isDisabled: l, isFocused: u })) : null;
  } }, { key: "renderIndicatorSeparator", value: function() {
    var a = this.getComponents(), s = a.DropdownIndicator, c = a.IndicatorSeparator;
    if (!s || !c)
      return null;
    var l = this.commonProps, d = this.props.isDisabled, u = this.state.isFocused;
    return $e.createElement(c, On({}, l, { isDisabled: d, isFocused: u }));
  } }, { key: "renderDropdownIndicator", value: function() {
    var a = this.getComponents().DropdownIndicator;
    if (!a)
      return null;
    var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused, d = { onMouseDown: this.onDropdownIndicatorMouseDown, onTouchEnd: this.onDropdownIndicatorTouchEnd, "aria-hidden": "true" };
    return $e.createElement(a, On({}, s, { innerProps: d, isDisabled: c, isFocused: l }));
  } }, { key: "renderMenu", value: function() {
    var a = this, s = this.getComponents(), c = s.Group, l = s.GroupHeading, d = s.Menu, u = s.MenuList, _ = s.MenuPortal, p = s.LoadingMessage, f = s.NoOptionsMessage, g = s.Option, h = this.commonProps, b = this.state.focusedOption, v = this.props, $ = v.captureMenuScroll, k = v.inputValue, S = v.isLoading, O = v.loadingMessage, I = v.minMenuHeight, D = v.maxMenuHeight, M = v.menuIsOpen, N = v.menuPlacement, C = v.menuPosition, P = v.menuPortalTarget, x = v.menuShouldBlockScroll, w = v.menuShouldScrollIntoView, E = v.noOptionsMessage, T = v.onMenuScrollToTop, z = v.onMenuScrollToBottom;
    if (!M)
      return null;
    var j, q = function(W, H) {
      var Q = W.type, X = W.data, re = W.isDisabled, Z = W.isSelected, ee = W.label, J = W.value, oe = b === X, ce = re ? void 0 : function() {
        return a.onOptionHover(X);
      }, de = re ? void 0 : function() {
        return a.selectOption(X);
      }, te = "".concat(a.getElementId("option"), "-").concat(H), ue = { id: te, onClick: de, onMouseMove: ce, onMouseOver: ce, tabIndex: -1 };
      return $e.createElement(g, On({}, h, { innerProps: ue, data: X, isDisabled: re, isSelected: Z, key: te, label: ee, type: Q, value: J, isFocused: oe, innerRef: oe ? a.getFocusedOptionRef : void 0 }), a.formatOptionLabel(W.data, "menu"));
    };
    if (this.hasOptions())
      j = this.getCategorizedOptions().map(function(W) {
        if (W.type === "group") {
          var H = W.data, Q = W.options, X = W.index, re = "".concat(a.getElementId("group"), "-").concat(X), Z = "".concat(re, "-heading");
          return $e.createElement(c, On({}, h, { key: re, data: H, options: Q, Heading: l, headingProps: { id: Z, data: W.data }, label: a.formatGroupLabel(W.data) }), W.options.map(function(ee) {
            return q(ee, "".concat(X, "-").concat(ee.index));
          }));
        }
        if (W.type === "option")
          return q(W, "".concat(W.index));
      });
    else if (S) {
      var V = O({ inputValue: k });
      if (V === null)
        return null;
      j = $e.createElement(p, h, V);
    } else {
      var F = E({ inputValue: k });
      if (F === null)
        return null;
      j = $e.createElement(f, h, F);
    }
    var L = { minMenuHeight: I, maxMenuHeight: D, menuPlacement: N, menuPosition: C, menuShouldScrollIntoView: w }, U = $e.createElement(Yhc, On({}, h, L), function(W) {
      var H = W.ref, Q = W.placerProps, X = Q.placement, re = Q.maxHeight;
      return $e.createElement(d, On({}, h, L, { innerRef: H, innerProps: { onMouseDown: a.onMenuMouseDown, onMouseMove: a.onMenuMouseMove, id: a.getElementId("listbox") }, isLoading: S, placement: X }), $e.createElement(bvc, { captureEnabled: $, onTopArrive: T, onBottomArrive: z, lockEnabled: x }, function(Z) {
        return $e.createElement(u, On({}, h, { innerRef: function(ee) {
          a.getMenuListRef(ee), Z(ee);
        }, isLoading: S, maxHeight: re, focusedOption: b }), j);
      }));
    });
    return P || C === "fixed" ? $e.createElement(_, On({}, h, { appendTo: P, controlElement: this.controlRef, menuPlacement: N, menuPosition: C }), U) : U;
  } }, { key: "renderFormField", value: function() {
    var a = this, s = this.props, c = s.delimiter, l = s.isDisabled, d = s.isMulti, u = s.name, _ = s.required, p = this.state.selectValue;
    if (u && !l) {
      if (_ && !this.hasValue())
        return $e.createElement(wvc, { name: u, onFocus: this.onValueInputFocus });
      if (d) {
        if (c) {
          var f = p.map(function(b) {
            return a.getOptionValue(b);
          }).join(c);
          return $e.createElement("input", { name: u, type: "hidden", value: f });
        }
        var g = p.length > 0 ? p.map(function(b, v) {
          return $e.createElement("input", { key: "i-".concat(v), name: u, type: "hidden", value: a.getOptionValue(b) });
        }) : $e.createElement("input", { name: u, type: "hidden", value: "" });
        return $e.createElement("div", null, g);
      }
      var h = p[0] ? this.getOptionValue(p[0]) : "";
      return $e.createElement("input", { name: u, type: "hidden", value: h });
    }
  } }, { key: "renderLiveRegion", value: function() {
    var a = this.commonProps, s = this.state, c = s.ariaSelection, l = s.focusedOption, d = s.focusedValue, u = s.isFocused, _ = s.selectValue, p = this.getFocusableOptions();
    return $e.createElement(uvc, On({}, a, { id: this.getElementId("live-region"), ariaSelection: c, focusedOption: l, focusedValue: d, isFocused: u, selectValue: _, focusableOptions: p }));
  } }, { key: "render", value: function() {
    var a = this.getComponents(), s = a.Control, c = a.IndicatorsContainer, l = a.SelectContainer, d = a.ValueContainer, u = this.props, _ = u.className, p = u.id, f = u.isDisabled, g = u.menuIsOpen, h = this.state.isFocused, b = this.commonProps = this.getCommonProps();
    return $e.createElement(l, On({}, b, { className: _, innerProps: { id: p, onKeyDown: this.onKeyDown }, isDisabled: f, isFocused: h }), this.renderLiveRegion(), $e.createElement(s, On({}, b, { innerRef: this.getControlRef, innerProps: { onMouseDown: this.onControlMouseDown, onTouchEnd: this.onControlTouchEnd }, isDisabled: f, isFocused: h, menuIsOpen: g }), $e.createElement(d, On({}, b, { isDisabled: f }), this.renderPlaceholderOrValue(), this.renderInput()), $e.createElement(c, On({}, b, { isDisabled: f }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
  } }], o = [{ key: "getDerivedStateFromProps", value: function(a, s) {
    var c = s.prevProps, l = s.clearFocusValueOnUpdate, d = s.inputIsHiddenAfterUpdate, u = s.ariaSelection, _ = s.isFocused, p = s.prevWasFocused, f = a.options, g = a.value, h = a.menuIsOpen, b = a.inputValue, v = a.isMulti, $ = WG(g), k = {};
    if (c && (g !== c.value || f !== c.options || h !== c.menuIsOpen || b !== c.inputValue)) {
      var S = h ? function(C, P) {
        return dH(lH(C, P));
      }(a, $) : [], O = l ? function(C, P) {
        var x = C.focusedValue, w = C.selectValue.indexOf(x);
        if (w > -1) {
          if (P.indexOf(x) > -1)
            return x;
          if (w < P.length)
            return P[w];
        }
        return null;
      }(s, $) : null, I = function(C, P) {
        var x = C.focusedOption;
        return x && P.indexOf(x) > -1 ? x : P[0];
      }(s, S);
      k = { selectValue: $, focusedOption: I, focusedValue: O, clearFocusValueOnUpdate: !1 };
    }
    var D = d != null && a !== c ? { inputIsHidden: d, inputIsHiddenAfterUpdate: void 0 } : {}, M = u, N = _ && p;
    return _ && !N && (M = { value: S2(v, $, $[0] || null), options: $, action: "initial-input-focus" }, N = !p), (u == null ? void 0 : u.action) === "initial-input-focus" && (M = null), Hn(Hn(Hn({}, k), D), {}, { prevProps: a, ariaSelection: M, prevWasFocused: N });
  } }], n && TG(t.prototype, n), o && TG(t, o), Object.defineProperty(t, "prototype", { writable: !1 }), i;
}();
Fde.defaultProps = Svc;
var Evc = it(function(e, t) {
  var n = function(o) {
    var r = o.defaultInputValue, i = r === void 0 ? "" : r, a = o.defaultMenuIsOpen, s = a !== void 0 && a, c = o.defaultValue, l = c === void 0 ? null : c, d = o.inputValue, u = o.menuIsOpen, _ = o.onChange, p = o.onInputChange, f = o.onMenuClose, g = o.onMenuOpen, h = o.value, b = Ov(o, ihc), v = g_(ze(d !== void 0 ? d : i), 2), $ = v[0], k = v[1], S = g_(ze(u !== void 0 ? u : s), 2), O = S[0], I = S[1], D = g_(ze(h !== void 0 ? h : l), 2), M = D[0], N = D[1], C = at(function(j, q) {
      typeof _ == "function" && _(j, q), N(j);
    }, [_]), P = at(function(j, q) {
      var V;
      typeof p == "function" && (V = p(j, q)), k(V !== void 0 ? V : j);
    }, [p]), x = at(function() {
      typeof g == "function" && g(), I(!0);
    }, [g]), w = at(function() {
      typeof f == "function" && f(), I(!1);
    }, [f]), E = d !== void 0 ? d : $, T = u !== void 0 ? u : O, z = h !== void 0 ? h : M;
    return Hn(Hn({}, b), {}, { inputValue: E, menuIsOpen: T, onChange: C, onInputChange: P, onMenuClose: w, onMenuOpen: x, value: z });
  }(e);
  return $e.createElement(Fde, On({ ref: t }, n));
}), Tvc = Evc;
const _H = (e, t, n) => {
  const [o, r] = e.split("/"), [i, a] = r.split(":");
  return Date.UTC(n, o - 1, i, a) - 36e5 * t;
};
var Vde = (e, t, n, o, r) => {
  const i = new Date(e).getUTCFullYear(), a = _H(t, r, i), s = _H(n, o, i);
  return e >= a && e < s;
}, Avc = (e) => {
  let t = e.timezones[e.tz];
  if (t === void 0)
    return console.warn("Warning: couldn't find timezone " + e.tz), 0;
  if (t.dst === void 0)
    return t.offset;
  let n = t.offset, o = t.offset + 1;
  t.hem === "n" && (o = n - 1);
  let r = t.dst.split("->");
  return Vde(e.epoch, r[0], r[1], n, o) === !0 ? n : o;
}, pH = { "9|s": "2/dili,2/jayapura", "9|n": "2/chita,2/khandyga,2/pyongyang,2/seoul,2/tokyo,11/palau,japan,rok", "9.5|s|04/03:03->10/02:02": "4/adelaide,4/broken_hill,4/south,4/yancowinna", "9.5|s": "4/darwin,4/north", "8|s|03/08:01->10/04:00": "12/casey", "8|s": "2/kuala_lumpur,2/makassar,2/singapore,4/perth,2/ujung_pandang,4/west,singapore", "8|n": "2/brunei,2/choibalsan,2/hong_kong,2/irkutsk,2/kuching,2/macau,2/manila,2/shanghai,2/taipei,2/ulaanbaatar,2/chongqing,2/chungking,2/harbin,2/macao,2/ulan_bator,hongkong,prc,roc", "8.75|s": "4/eucla", "7|s": "12/davis,2/jakarta,9/christmas", "7|n": "2/bangkok,2/barnaul,2/hovd,2/krasnoyarsk,2/novokuznetsk,2/novosibirsk,2/phnom_penh,2/pontianak,2/ho_chi_minh,2/tomsk,2/vientiane,2/saigon", "6|s": "12/vostok", "6|n": "2/almaty,2/bishkek,2/dhaka,2/omsk,2/qyzylorda,2/qostanay,2/thimphu,2/urumqi,9/chagos,2/dacca,2/kashgar,2/thimbu", "6.5|n": "2/yangon,9/cocos,2/rangoon", "5|s": "12/mawson,9/kerguelen", "5|n": "2/aqtau,2/aqtobe,2/ashgabat,2/atyrau,2/dushanbe,2/karachi,2/oral,2/samarkand,2/tashkent,2/yekaterinburg,9/maldives,2/ashkhabad", "5.75|n": "2/katmandu,2/kathmandu", "5.5|n": "2/kolkata,2/colombo,2/calcutta", "4|s": "9/reunion", "4|n": "2/baku,2/dubai,2/muscat,2/tbilisi,2/yerevan,8/astrakhan,8/samara,8/saratov,8/ulyanovsk,8/volgograd,2/volgograd,9/mahe,9/mauritius", "4.5|n|03/22:00->09/21:24": "2/tehran,iran", "4.5|n": "2/kabul", "3|s": "12/syowa,9/antananarivo", "3|n|03/27:03->10/30:04": "2/famagusta,2/nicosia,8/athens,8/bucharest,8/helsinki,8/kiev,8/mariehamn,8/riga,8/sofia,8/tallinn,8/uzhgorod,8/vilnius,8/zaporozhye,8/nicosia", "3|n|03/27:02->10/30:03": "8/chisinau,8/tiraspol", "3|n|03/27:00->10/29:24": "2/beirut", "3|n|03/27:00->10/28:01": "2/gaza,2/hebron", "3|n|03/25:02->10/30:02": "2/jerusalem,2/tel_aviv,israel", "3|n|03/25:00->10/27:24": "2/damascus", "3|n|02/25:00->10/28:01": "2/amman", "3|n": "0/addis_ababa,0/asmara,0/asmera,0/dar_es_salaam,0/djibouti,0/juba,0/kampala,0/mogadishu,0/nairobi,2/aden,2/baghdad,2/bahrain,2/kuwait,2/qatar,2/riyadh,8/istanbul,8/kirov,8/minsk,8/moscow,8/simferopol,9/comoro,9/mayotte,2/istanbul,turkey,w-su", "2|s|03/27:02->10/30:02": "12/troll", "2|s": "0/gaborone,0/harare,0/johannesburg,0/lubumbashi,0/lusaka,0/maputo,0/maseru,0/mbabane", "2|n|03/27:02->10/30:03": "0/ceuta,arctic/longyearbyen,8/amsterdam,8/andorra,8/belgrade,8/berlin,8/bratislava,8/brussels,8/budapest,8/busingen,8/copenhagen,8/gibraltar,8/ljubljana,8/luxembourg,8/madrid,8/malta,8/monaco,8/oslo,8/paris,8/podgorica,8/prague,8/rome,8/san_marino,8/sarajevo,8/skopje,8/stockholm,8/tirane,8/vaduz,8/vatican,8/vienna,8/warsaw,8/zagreb,8/zurich,3/jan_mayen,poland", "2|n": "0/blantyre,0/bujumbura,0/cairo,0/khartoum,0/kigali,0/tripoli,8/kaliningrad,egypt,libya", "1|s": "0/brazzaville,0/kinshasa,0/luanda,0/windhoek", "1|n|03/27:03->05/08:02": "0/casablanca,0/el_aaiun", "1|n|03/27:01->10/30:02": "3/canary,3/faroe,3/madeira,8/dublin,8/guernsey,8/isle_of_man,8/jersey,8/lisbon,8/london,3/faeroe,eire,8/belfast,gb-eire,gb,portugal", "1|n": "0/algiers,0/bangui,0/douala,0/lagos,0/libreville,0/malabo,0/ndjamena,0/niamey,0/porto-novo,0/tunis", "14|n": "11/kiritimati", "13|s|04/04:04->09/26:03": "11/apia", "13|s|01/15:02->11/05:03": "11/tongatapu", "13|n": "11/enderbury,11/fakaofo", "12|s|04/03:03->09/25:02": "12/mcmurdo,11/auckland,12/south_pole,nz", "12|s|01/17:03->11/14:02": "11/fiji", "12|n": "2/anadyr,2/kamchatka,2/srednekolymsk,11/funafuti,11/kwajalein,11/majuro,11/nauru,11/tarawa,11/wake,11/wallis,kwajalein", "12.75|s|04/03:03->04/03:02": "11/chatham,nz-chat", "11|s|04/03:03->10/02:02": "12/macquarie", "11|s": "11/bougainville", "11|n": "2/magadan,2/sakhalin,11/efate,11/guadalcanal,11/kosrae,11/noumea,11/pohnpei,11/ponape", "11.5|n|04/03:03->10/02:02": "11/norfolk", "10|s|04/03:03->10/02:02": "4/currie,4/hobart,4/melbourne,4/sydney,4/act,4/canberra,4/nsw,4/tasmania,4/victoria", "10|s": "12/dumontdurville,4/brisbane,4/lindeman,11/port_moresby,4/queensland", "10|n": "2/ust-nera,2/vladivostok,2/yakutsk,11/guam,11/saipan,11/chuuk,11/truk,11/yap", "10.5|s|04/03:01->10/02:02": "4/lord_howe,4/lhi", "0|n|03/27:00->10/30:01": "1/scoresbysund,3/azores", "0|n": "0/abidjan,0/accra,0/bamako,0/banjul,0/bissau,0/conakry,0/dakar,0/freetown,0/lome,0/monrovia,0/nouakchott,0/ouagadougou,0/sao_tome,1/danmarkshavn,3/reykjavik,3/st_helena,13/gmt,13/utc,0/timbuktu,13/greenwich,13/uct,13/universal,13/zulu,gmt-0,gmt+0,gmt0,greenwich,iceland,uct,universal,utc,zulu", "-9|n|03/13:02->11/06:02": "1/adak,1/atka,us/aleutian", "-9|n": "11/gambier", "-9.5|n": "11/marquesas", "-8|n|03/13:02->11/06:02": "1/anchorage,1/juneau,1/metlakatla,1/nome,1/sitka,1/yakutat,us/alaska", "-8|n": "11/pitcairn", "-7|n|03/13:02->11/06:02": "1/los_angeles,1/santa_isabel,1/tijuana,1/vancouver,1/ensenada,6/pacific,10/bajanorte,us/pacific-new,us/pacific", "-7|n|03/08:02->11/01:01": "1/dawson,1/whitehorse,6/yukon", "-7|n": "1/creston,1/dawson_creek,1/fort_nelson,1/hermosillo,1/phoenix,us/arizona", "-6|s|04/02:22->09/03:22": "11/easter,7/easterisland", "-6|n|04/03:02->10/30:02": "1/chihuahua,1/mazatlan,10/bajasur", "-6|n|03/13:02->11/06:02": "1/boise,1/cambridge_bay,1/denver,1/edmonton,1/inuvik,1/ojinaga,1/yellowknife,1/shiprock,6/mountain,navajo,us/mountain", "-6|n": "1/belize,1/costa_rica,1/el_salvador,1/guatemala,1/managua,1/regina,1/swift_current,1/tegucigalpa,11/galapagos,6/east-saskatchewan,6/saskatchewan", "-5|s": "1/lima,1/rio_branco,1/porto_acre,5/acre", "-5|n|04/03:02->10/30:02": "1/bahia_banderas,1/merida,1/mexico_city,1/monterrey,10/general", "-5|n|03/13:02->11/06:02": "1/chicago,1/matamoros,1/menominee,1/rainy_river,1/rankin_inlet,1/resolute,1/winnipeg,1/indiana/knox,1/indiana/tell_city,1/north_dakota/beulah,1/north_dakota/center,1/north_dakota/new_salem,1/knox_in,6/central,us/central,us/indiana-starke", "-5|n|03/12:03->11/05:01": "1/north_dakota", "-5|n": "1/bogota,1/cancun,1/cayman,1/coral_harbour,1/eirunepe,1/guayaquil,1/jamaica,1/panama,1/atikokan,jamaica", "-4|s|05/13:23->08/13:01": "12/palmer", "-4|s|04/02:24->09/04:00": "1/santiago,7/continental", "-4|s|03/26:24->10/02:00": "1/asuncion", "-4|s|02/16:24->11/03:00": "1/campo_grande,1/cuiaba", "-4|s": "1/la_paz,1/manaus,5/west", "-4|n|03/13:02->11/06:02": "1/detroit,1/grand_turk,1/indianapolis,1/iqaluit,1/louisville,1/montreal,1/nassau,1/new_york,1/nipigon,1/pangnirtung,1/port-au-prince,1/thunder_bay,1/toronto,1/indiana/marengo,1/indiana/petersburg,1/indiana/vevay,1/indiana/vincennes,1/indiana/winamac,1/kentucky/monticello,1/fort_wayne,1/indiana/indianapolis,1/kentucky/louisville,6/eastern,us/east-indiana,us/eastern,us/michigan", "-4|n|03/13:00->11/06:01": "1/havana,cuba", "-4|n|03/12:03->11/05:01": "1/indiana,1/kentucky", "-4|n": "1/anguilla,1/antigua,1/aruba,1/barbados,1/blanc-sablon,1/boa_vista,1/caracas,1/curacao,1/dominica,1/grenada,1/guadeloupe,1/guyana,1/kralendijk,1/lower_princes,1/marigot,1/martinique,1/montserrat,1/port_of_spain,1/porto_velho,1/puerto_rico,1/santo_domingo,1/st_barthelemy,1/st_kitts,1/st_lucia,1/st_thomas,1/st_vincent,1/tortola,1/virgin", "-3|s": "1/argentina,1/buenos_aires,1/catamarca,1/cordoba,1/fortaleza,1/jujuy,1/mendoza,1/montevideo,1/punta_arenas,1/sao_paulo,12/rothera,3/stanley,1/argentina/la_rioja,1/argentina/rio_gallegos,1/argentina/salta,1/argentina/san_juan,1/argentina/san_luis,1/argentina/tucuman,1/argentina/ushuaia,1/argentina/comodrivadavia,1/argentina/buenos_aires,1/argentina/catamarca,1/argentina/cordoba,1/argentina/jujuy,1/argentina/mendoza,1/argentina/rosario,1/rosario,5/east", "-3|n|03/13:02->11/06:02": "1/glace_bay,1/goose_bay,1/halifax,1/moncton,1/thule,3/bermuda,6/atlantic", "-3|n": "1/araguaina,1/bahia,1/belem,1/cayenne,1/maceio,1/paramaribo,1/recife,1/santarem", "-2|n|03/26:22->10/29:23": "1/nuuk,1/godthab", "-2|n|03/13:02->11/06:02": "1/miquelon", "-2|n": "1/noronha,3/south_georgia,5/denoronha", "-2.5|n|03/13:02->11/06:02": "1/st_johns,6/newfoundland", "-1|n": "3/cape_verde", "-11|n": "11/midway,11/niue,11/pago_pago,11/samoa,us/samoa", "-10|n": "11/honolulu,11/johnston,11/rarotonga,11/tahiti,us/hawaii" }, Cvc = ["africa", "america", "asia", "atlantic", "australia", "brazil", "canada", "chile", "europe", "indian", "mexico", "pacific", "antarctica", "etc"];
let Tw = {};
Object.keys(pH).forEach((e) => {
  let t = e.split("|"), n = { offset: Number(t[0]), hem: t[1] };
  t[2] && (n.dst = t[2]), pH[e].split(",").forEach((o) => {
    o = o.replace(/(^[0-9]+)\//, (r, i) => (i = Number(i), Cvc[i] + "/")), Tw[o] = n;
  });
}), Tw.utc = { offset: 0, hem: "n" };
for (let e = -14; e <= 14; e += 0.5) {
  let t = e;
  t > 0 && (t = "+" + t);
  let n = "etc/gmt" + t;
  Tw[n] = { offset: -1 * e, hem: "n" }, n = "utc/gmt" + t, Tw[n] = { offset: -1 * e, hem: "n" };
}
var Bde = Tw, zvc = () => {
  let e = (() => {
    if (typeof Intl > "u" || Intl.DateTimeFormat === void 0)
      return null;
    let t = Intl.DateTimeFormat();
    if (t === void 0 || t.resolvedOptions === void 0)
      return null;
    let n = t.resolvedOptions().timeZone;
    return n ? n.toLowerCase() : null;
  })();
  return e === null ? "utc" : e;
};
const Ovc = /(\-?[0-9]+)h(rs)?/i, Pvc = /(\-?[0-9]+)/, Ivc = /utc([\-+]?[0-9]+)/i, Rvc = /gmt([\-+]?[0-9]+)/i, x2 = function(e) {
  return (e = Number(e)) >= -13 && e <= 13 ? "etc/gmt" + (e = ((e *= -1) > 0 ? "+" : "") + e) : null;
};
var Nvc = function(e) {
  let t = e.match(Ovc);
  if (t !== null || (t = e.match(Ivc), t !== null))
    return x2(t[1]);
  if (t = e.match(Rvc), t !== null) {
    let n = -1 * Number(t[1]);
    return x2(n);
  }
  return t = e.match(Pvc), t !== null ? x2(t[1]) : null;
};
const Dvc = zvc(), mH = Object.keys(Bde).reduce((e, t) => {
  let n = t.split("/")[1] || "";
  return n = n.replace(/_/g, " "), e[n] = t, e;
}, {});
var tE = (e, t) => {
  if (!e)
    return Dvc;
  typeof e != "string" && console.error("Timezone must be a string - recieved: '", e, `'
`);
  let n = e.trim();
  if (n = n.toLowerCase(), t.hasOwnProperty(n) === !0 || (n = ((o) => (o = (o = (o = (o = (o = o.replace(/ time/g, "")).replace(/ (standard|daylight|summer)/g, "")).replace(/\b(east|west|north|south)ern/g, "$1")).replace(/\b(africa|america|australia)n/g, "$1")).replace(/\beuropean/g, "europe")).replace(/\islands/g, "island"))(n), t.hasOwnProperty(n) === !0))
    return n;
  if (mH.hasOwnProperty(n) === !0)
    return mH[n];
  if (/[0-9]/.test(n) === !0) {
    let o = Nvc(n);
    if (o)
      return o;
  }
  throw new Error("Spacetime: Cannot find timezone named: '" + e + "'. Please enter an IANA timezone id.");
};
function uA(e) {
  return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
}
function Ude(e) {
  return Object.prototype.toString.call(e) === "[object Date]" && !isNaN(e.valueOf());
}
function Vh(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Gn(e, t = 2) {
  return (e += "").length >= t ? e : new Array(t - e.length + 1).join("0") + e;
}
function qu(e) {
  let t = e % 10, n = e % 100;
  return t === 1 && n !== 11 ? e + "st" : t === 2 && n !== 12 ? e + "nd" : t === 3 && n !== 13 ? e + "rd" : e + "th";
}
function Bh(e) {
  return e = (e = String(e)).replace(/([0-9])(st|nd|rd|th)$/i, "$1"), parseInt(e, 10);
}
function Bf(e = "") {
  return (e = (e = (e = (e = e.toLowerCase().trim()).replace(/ies$/, "y")).replace(/s$/, "")).replace(/-/g, "")) === "day" || e === "days" ? "date" : e === "min" || e === "mins" ? "minute" : e;
}
function Ty(e) {
  return typeof e == "number" ? e : Ude(e) ? e.getTime() : e.epoch ? e.epoch : null;
}
function Zm(e, t) {
  return Vh(e) === !1 ? t.clone().set(e) : e;
}
function d$(e, t = "") {
  const n = e > 0 ? "+" : "-", o = Math.abs(e);
  return `${n}${Gn(parseInt("" + o, 10))}${t}${Gn(o % 1 * 60)}`;
}
const m3 = { year: (/* @__PURE__ */ new Date()).getFullYear(), month: 0, date: 1 };
var Mvc = { parseArray: (e, t, n) => {
  if (t.length === 0)
    return e;
  let o = ["year", "month", "date", "hour", "minute", "second", "millisecond"];
  for (let r = 0; r < o.length; r++) {
    let i = t[r] || n[o[r]] || m3[o[r]] || 0;
    e = e[o[r]](i);
  }
  return e;
}, parseObject: (e, t, n) => {
  if (Object.keys(t).length === 0)
    return e;
  t = Object.assign({}, m3, n, t);
  let o = Object.keys(t);
  for (let r = 0; r < o.length; r++) {
    let i = o[r];
    if (e[i] === void 0 || typeof e[i] != "function" || t[i] === null || t[i] === void 0 || t[i] === "")
      continue;
    let a = t[i] || n[i] || m3[i] || 0;
    e = e[i](a);
  }
  return e;
}, parseNumber: function(e, t) {
  return t > 0 && t < 25e8 && e.silent === !1 && (console.warn("  - Warning: You are setting the date to January 1970."), console.warn("       -   did input seconds instead of milliseconds?")), e.epoch = t, e;
} };
const Tm = function(e) {
  return e.epoch = Date.now(), Object.keys(e._today || {}).forEach((t) => {
    typeof e[t] == "function" && (e = e[t](e._today[t]));
  }), e;
}, UD = { now: (e) => Tm(e), today: (e) => Tm(e), tonight: (e) => e = (e = Tm(e)).hour(18), tomorrow: (e) => e = (e = (e = Tm(e)).add(1, "day")).startOf("day"), yesterday: (e) => e = (e = (e = Tm(e)).subtract(1, "day")).startOf("day"), christmas: (e) => {
  let t = Tm(e).year();
  return e = e.set([t, 11, 25, 18, 0, 0]);
}, "new years": (e) => {
  let t = Tm(e).year();
  return e = e.set([t, 11, 31, 18, 0, 0]);
} };
UD["new years eve"] = UD["new years"];
var fH = UD, Lvc = function(e) {
  return e = (e = (e = (e = e.replace(/\b(mon|tues?|wed|wednes|thur?s?|fri|sat|satur|sun)(day)?\b/i, "")).replace(/([0-9])(th|rd|st|nd)/, "$1")).replace(/,/g, "")).replace(/ +/g, " ").trim();
};
let Xu = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5 };
Xu.date = Xu.day, Xu.month = 25488e5, Xu.week = 6048e5, Xu.year = 3154e7, Object.keys(Xu).forEach((e) => {
  Xu[e + "s"] = Xu[e];
});
var ta = Xu;
const E2 = (e, t, n, o, r) => {
  let i = e.d[n]();
  if (i === t)
    return;
  let a = r === null ? null : e.d[r](), s = e.epoch, c = t - i;
  e.epoch += ta[o] * c, o === "day" && Math.abs(c) > 28 && t < 28 && (e.epoch += ta.hour), r !== null && a !== e.d[r]() && (e.epoch = s);
  const l = ta[o] / 2;
  for (; e.d[n]() < t; )
    e.epoch += l;
  for (; e.d[n]() > t; )
    e.epoch -= l;
  r !== null && a !== e.d[r]() && (e.epoch = s);
}, f3 = { year: { valid: (e) => e > -4e3 && e < 4e3, walkTo: (e, t) => E2(e, t, "getFullYear", "year", null) }, month: { valid: (e) => e >= 0 && e <= 11, walkTo: (e, t) => {
  let n = e.d, o = n.getMonth(), r = e.epoch, i = n.getFullYear();
  if (o === t)
    return;
  let a = t - o;
  for (e.epoch += ta.day * (28 * a), i !== e.d.getFullYear() && (e.epoch = r); e.d.getMonth() < t; )
    e.epoch += ta.day;
  for (; e.d.getMonth() > t; )
    e.epoch -= ta.day;
} }, date: { valid: (e) => e > 0 && e <= 31, walkTo: (e, t) => E2(e, t, "getDate", "day", "getMonth") }, hour: { valid: (e) => e >= 0 && e < 24, walkTo: (e, t) => E2(e, t, "getHours", "hour", "getDate") }, minute: { valid: (e) => e >= 0 && e < 60, walkTo: (e, t) => E2(e, t, "getMinutes", "minute", "getHours") }, second: { valid: (e) => e >= 0 && e < 60, walkTo: (e, t) => {
  e.epoch = e.seconds(t).epoch;
} }, millisecond: { valid: (e) => e >= 0 && e < 1e3, walkTo: (e, t) => {
  e.epoch = e.milliseconds(t).epoch;
} } };
var ur = (e, t) => {
  let n = Object.keys(f3), o = e.clone();
  for (let r = 0; r < n.length; r++) {
    let i = n[r], a = t[i];
    if (a === void 0 && (a = o[i]()), typeof a == "string" && (a = parseInt(a, 10)), !f3[i].valid(a))
      return e.epoch = null, void (e.silent === !1 && console.warn("invalid " + i + ": " + a));
    f3[i].walkTo(e, a);
  }
}, Uf = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
let Aw = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"], Cw = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function Ay() {
  return Aw;
}
function Wde() {
  return function() {
    const e = { sep: 8 };
    for (let t = 0; t < Aw.length; t++)
      e[Aw[t]] = t;
    for (let t = 0; t < Cw.length; t++)
      e[Cw[t]] = t;
    return e;
  }();
}
var qvc = (e, t) => {
  if (!t)
    return e;
  let n = 0;
  if (/^[\+-]?[0-9]{2}:[0-9]{2}$/.test(t) && (/:00/.test(t) === !0 && (t = t.replace(/:00/, "")), /:30/.test(t) === !0 && (t = t.replace(/:30/, ".5"))), /^[\+-]?[0-9]{4}$/.test(t) && (t = t.replace(/30$/, ".5")), n = parseFloat(t), Math.abs(n) > 100 && (n /= 100), n === 0 || t === "Z" || t === "z")
    return e.tz = "etc/gmt", e;
  n *= -1, n >= 0 && (n = "+" + n);
  let o = "etc/gmt" + n;
  return e.timezones[o] && (e.tz = o), e;
}, Es = (e, t = "") => {
  let n = (t = t.replace(/^\s+/, "").toLowerCase()).match(/([0-9]{1,2}):([0-9]{1,2}):?([0-9]{1,2})?[:\.]?([0-9]{1,4})?/);
  if (n !== null) {
    let o = Number(n[1]);
    if (o < 0 || o > 24)
      return e.startOf("day");
    let r = Number(n[2]);
    if (n[2].length < 2 || r < 0 || r > 59)
      return e.startOf("day");
    e = e.hour(o), e = e.minute(r), e = (e = e.seconds(n[3] || 0)).millisecond(function(a = "") {
      return (a = String(a)).length > 3 ? a = a.substr(0, 3) : a.length === 1 ? a += "00" : a.length === 2 && (a += "0"), Number(a) || 0;
    }(n[4]));
    let i = t.match(/[\b0-9] ?(am|pm)\b/);
    return i !== null && i[1] && (e = e.ampm(i[1])), e;
  }
  if (n = t.match(/([0-9]+) ?(am|pm)/), n !== null && n[1]) {
    let o = Number(n[1]);
    return o > 12 || o < 1 ? e.startOf("day") : e = (e = (e = e.hour(n[1] || 0)).ampm(n[2])).startOf("hour");
  }
  return e = e.startOf("day");
};
let gH = Wde();
const Ts = (e) => {
  if (Uf.hasOwnProperty(e.month) !== !0)
    return !1;
  if (e.month === 1)
    return !!(uA(e.year) && e.date <= 29) || e.date <= 28;
  let t = Uf[e.month] || 0;
  return e.date <= t;
}, l_ = (e = "", t) => {
  if (e = e.trim(), /^'[0-9][0-9]$/.test(e) === !0) {
    let o = Number(e.replace(/'/, ""));
    return o > 50 ? 1900 + o : 2e3 + o;
  }
  let n = parseInt(e, 10);
  return !n && t && (n = t.year), n = n || (/* @__PURE__ */ new Date()).getFullYear(), n;
}, qp = function(e) {
  return (e = e.toLowerCase().trim()) === "sept" ? gH.sep : gH[e];
};
var jvc = [{ reg: /^(\-?0?0?[0-9]{3,4})-([0-9]{1,2})-([0-9]{1,2})[T| ]([0-9.:]+)(Z|[0-9\-\+:]+)?$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: t[3] };
  return Ts(n) === !1 ? (e.epoch = null, e) : (qvc(e, t[5]), ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([0-9]{4})[\-\/\. ]([0-9]{1,2})[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: parseInt(t[3], 10) };
  return n.month >= 12 && (n.date = parseInt(t[2], 10), n.month = parseInt(t[3], 10) - 1), Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([0-9]{4})[\-\/\. ]([a-z]+)[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: l_(t[1], e._today), month: qp(t[2]), date: Bh(t[3] || "") };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }], Fvc = [{ reg: /^([0-9]{1,2})[\-\/.]([0-9]{1,2})[\-\/.]?([0-9]{4})?( [0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i, parse: (e, t) => {
  let n = parseInt(t[1], 10) - 1, o = parseInt(t[2], 10);
  (e.british || n >= 12) && (o = parseInt(t[1], 10), n = parseInt(t[2], 10) - 1);
  let r = { date: o, month: n, year: l_(t[3], e._today) || (/* @__PURE__ */ new Date()).getFullYear() };
  return Ts(r) === !1 ? (e.epoch = null, e) : (ur(e, r), e = Es(e, t[4]));
} }, { reg: /^([a-z]+)[\-\/\. ]([0-9]{1,2})[\-\/\. ]?([0-9]{4}|'[0-9]{2})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { year: l_(t[3], e._today), month: qp(t[1]), date: Bh(t[2] || "") };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{1,2})( [0-9]{4})?( ([0-9:]+( ?am| ?pm| ?gmt)?))?$/i, parse: (e, t) => {
  let n = { year: l_(t[3], e._today), month: qp(t[1]), date: Bh(t[2] || "") };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{1,2})( [0-9:]+)?( \+[0-9]{4})?( [0-9]{4})?$/i, parse: (e, t) => {
  let n = { year: l_(t[5], e._today), month: qp(t[1]), date: Bh(t[2] || "") };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[3]));
} }], Vvc = [{ reg: /^([0-9]{1,2})[\-\/]([a-z]+)[\-\/]?([0-9]{4})?$/i, parse: (e, t) => {
  let n = { year: l_(t[3], e._today), month: qp(t[2]), date: Bh(t[1] || "") };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([0-9]{1,2})( [a-z]+)( [0-9]{4}| '[0-9]{2})? ?([0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i, parse: (e, t) => {
  let n = { year: l_(t[3], e._today), month: qp(t[2]), date: Bh(t[1]) };
  return n.month && Ts(n) !== !1 ? (ur(e, n), e = Es(e, t[4])) : (e.epoch = null, e);
} }, { reg: /^([0-9]{1,2})[\. -/]([a-z]+)[\. -/]([0-9]{4})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i, parse: (e, t) => {
  let n = { date: Number(t[1]), month: qp(t[2]), year: Number(t[3]) };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = e.startOf("day"), e = Es(e, t[4]));
} }], Bvc = [{ reg: /^([0-9]{4})[\-\/]([0-9]{2})$/i, parse: (e, t) => {
  let n = { year: t[1], month: parseInt(t[2], 10) - 1, date: 1 };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^([a-z]+) ([0-9]{4})$/i, parse: (e, t) => {
  let n = { year: l_(t[2], e._today), month: qp(t[1]), date: e._today.date || 1 };
  return Ts(n) === !1 ? (e.epoch = null, e) : (ur(e, n), e = Es(e, t[4]));
} }, { reg: /^(q[0-9])( of)?( [0-9]{4})?/i, parse: (e, t) => {
  let n = t[1] || "";
  e = e.quarter(n);
  let o = t[3] || "";
  return o && (o = o.trim(), e = e.year(o)), e;
} }, { reg: /^(spring|summer|winter|fall|autumn)( of)?( [0-9]{4})?/i, parse: (e, t) => {
  let n = t[1] || "";
  e = e.season(n);
  let o = t[3] || "";
  return o && (o = o.trim(), e = e.year(o)), e;
} }, { reg: /^[0-9,]+ ?b\.?c\.?$/i, parse: (e, t) => {
  let n = t[0] || "";
  n = n.replace(/^([0-9,]+) ?b\.?c\.?$/i, "-$1");
  let o = /* @__PURE__ */ new Date(), r = { year: parseInt(n.trim(), 10), month: o.getMonth(), date: o.getDate() };
  return Ts(r) === !1 ? (e.epoch = null, e) : (ur(e, r), e = Es(e));
} }, { reg: /^[0-9,]+ ?(a\.?d\.?|c\.?e\.?)$/i, parse: (e, t) => {
  let n = t[0] || "";
  n = n.replace(/,/g, "");
  let o = /* @__PURE__ */ new Date(), r = { year: parseInt(n.trim(), 10), month: o.getMonth(), date: o.getDate() };
  return Ts(r) === !1 ? (e.epoch = null, e) : (ur(e, r), e = Es(e));
} }, { reg: /^[0-9]{4}( ?a\.?d\.?)?$/i, parse: (e, t) => {
  let n = e._today;
  n.month && !n.date && (n.date = 1);
  let o = /* @__PURE__ */ new Date(), r = { year: l_(t[0], n), month: n.month || o.getMonth(), date: n.date || o.getDate() };
  return Ts(r) === !1 ? (e.epoch = null, e) : (ur(e, r), e = Es(e));
} }], g3 = [].concat(jvc, Fvc, Vvc, Bvc), Uvc = function(e, t, n) {
  for (let o = 0; o < g3.length; o++) {
    let r = t.match(g3[o].reg);
    if (r) {
      let i = g3[o].parse(e, r, n);
      if (i !== null && i.isValid())
        return i;
    }
  }
  return e.silent === !1 && console.warn("Warning: couldn't parse date-string: '" + t + "'"), e.epoch = null, e;
};
const { parseArray: Wvc, parseObject: hH, parseNumber: Gvc } = Mvc, vH = { year: (/* @__PURE__ */ new Date()).getFullYear(), month: 0, date: 1 };
var Gde = (e, t) => {
  let n = e._today || vH;
  if (typeof t == "number")
    return Gvc(e, t);
  if (e.epoch = Date.now(), e._today && Vh(e._today) && Object.keys(e._today).length > 0) {
    let o = hH(e, n, vH);
    o.isValid() && (e.epoch = o.epoch);
  }
  return t == null || t === "" ? e : Ude(t) === !0 ? (e.epoch = t.getTime(), e) : function(o) {
    return Object.prototype.toString.call(o) === "[object Array]";
  }(t) === !0 ? e = Wvc(e, t, n) : Vh(t) === !0 ? t.epoch ? (e.epoch = t.epoch, e.tz = t.tz, e) : e = hH(e, t, n) : typeof t != "string" ? e : (t = Lvc(t), fH.hasOwnProperty(t) === !0 ? e = fH[t](e) : Uvc(e, t));
};
let WD = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], GD = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
function zw() {
  return WD;
}
function nE() {
  return GD;
}
const bH = { mo: 1, tu: 2, we: 3, th: 4, fr: 5, sa: 6, su: 7, tues: 2, weds: 3, wedn: 3, thur: 4, thurs: 4 };
let Hde = !0;
var yH = (e) => {
  let t = e.timezone().current.offset;
  return t ? d$(t, ":") : "Z";
};
const e_ = (e) => Hde ? function(t) {
  return t ? t[0].toUpperCase() + t.substr(1) : "";
}(e) : e, $h = { day: (e) => e_(e.dayName()), "day-short": (e) => e_(zw()[e.day()]), "day-number": (e) => e.day(), "day-ordinal": (e) => qu(e.day()), "day-pad": (e) => Gn(e.day()), date: (e) => e.date(), "date-ordinal": (e) => qu(e.date()), "date-pad": (e) => Gn(e.date()), month: (e) => e_(e.monthName()), "month-short": (e) => e_(Ay()[e.month()]), "month-number": (e) => e.month(), "month-ordinal": (e) => qu(e.month()), "month-pad": (e) => Gn(e.month()), "iso-month": (e) => Gn(e.month() + 1), year: (e) => {
  let t = e.year();
  return t > 0 ? t : (t = Math.abs(t), t + " BC");
}, "year-short": (e) => {
  let t = e.year();
  return t > 0 ? `'${String(e.year()).substr(2, 4)}` : (t = Math.abs(t), t + " BC");
}, "iso-year": (e) => {
  let t = e.year(), n = t < 0, o = Gn(Math.abs(t), 4);
  return n && (o = Gn(o, 6), o = "-" + o), o;
}, time: (e) => e.time(), "time-24": (e) => `${e.hour24()}:${Gn(e.minute())}`, hour: (e) => e.hour12(), "hour-pad": (e) => Gn(e.hour12()), "hour-24": (e) => e.hour24(), "hour-24-pad": (e) => Gn(e.hour24()), minute: (e) => e.minute(), "minute-pad": (e) => Gn(e.minute()), second: (e) => e.second(), "second-pad": (e) => Gn(e.second()), millisecond: (e) => e.millisecond(), "millisecond-pad": (e) => Gn(e.millisecond(), 3), ampm: (e) => e.ampm(), quarter: (e) => "Q" + e.quarter(), season: (e) => e.season(), era: (e) => e.era(), json: (e) => e.json(), timezone: (e) => e.timezone().name, offset: (e) => yH(e), numeric: (e) => `${e.year()}/${Gn(e.month() + 1)}/${Gn(e.date())}`, "numeric-us": (e) => `${Gn(e.month() + 1)}/${Gn(e.date())}/${e.year()}`, "numeric-uk": (e) => `${Gn(e.date())}/${Gn(e.month() + 1)}/${e.year()}`, "mm/dd": (e) => `${Gn(e.month() + 1)}/${Gn(e.date())}`, iso: (e) => `${e.format("iso-year")}-${Gn(e.month() + 1)}-${Gn(e.date())}T${Gn(e.h24())}:${Gn(e.minute())}:${Gn(e.second())}.${Gn(e.millisecond(), 3)}${yH(e)}`, "iso-short": (e) => {
  let t = Gn(e.month() + 1), n = Gn(e.date());
  var o;
  return `${(o = e.year()) >= 0 ? Gn(o, 4) : "-" + Gn(o = Math.abs(o), 4)}-${t}-${n}`;
}, "iso-utc": (e) => new Date(e.epoch).toISOString(), nice: (e) => `${Ay()[e.month()]} ${qu(e.date())}, ${e.time()}`, "nice-24": (e) => `${Ay()[e.month()]} ${qu(e.date())}, ${e.hour24()}:${Gn(e.minute())}`, "nice-year": (e) => `${Ay()[e.month()]} ${qu(e.date())}, ${e.year()}`, "nice-day": (e) => `${zw()[e.day()]} ${e_(Ay()[e.month()])} ${qu(e.date())}`, "nice-full": (e) => `${e.dayName()} ${e_(e.monthName())} ${qu(e.date())}, ${e.time()}`, "nice-full-24": (e) => `${e.dayName()} ${e_(e.monthName())} ${qu(e.date())}, ${e.hour24()}:${Gn(e.minute())}` }, $H = { "day-name": "day", "month-name": "month", "iso 8601": "iso", "time-h24": "time-24", "time-12": "time", "time-h12": "time", tz: "timezone", "day-num": "day-number", "month-num": "month-number", "month-iso": "iso-month", "year-iso": "iso-year", "nice-short": "nice", "nice-short-24": "nice-24", mdy: "numeric-us", dmy: "numeric-uk", ymd: "numeric", "yyyy/mm/dd": "numeric", "mm/dd/yyyy": "numeric-us", "dd/mm/yyyy": "numeric-us", "little-endian": "numeric-uk", "big-endian": "numeric", "day-nice": "nice-day" };
Object.keys($H).forEach((e) => $h[e] = $h[$H[e]]);
var h3 = (e, t = "") => {
  if (e.isValid() !== !0)
    return "";
  if ($h.hasOwnProperty(t)) {
    let n = $h[t](e) || "";
    return t !== "json" && (n = String(n), t !== "ampm" && (n = e_(n))), n;
  }
  if (t.indexOf("{") !== -1) {
    let n = /\{(.+?)\}/g;
    return t = t.replace(n, (o, r) => {
      if (r = r.toLowerCase().trim(), $h.hasOwnProperty(r)) {
        let i = String($h[r](e));
        return r !== "ampm" ? e_(i) : i;
      }
      return "";
    }), t;
  }
  return e.format("iso-short");
};
const oE = { G: (e) => e.era(), GG: (e) => e.era(), GGG: (e) => e.era(), GGGG: (e) => e.era() === "AD" ? "Anno Domini" : "Before Christ", y: (e) => e.year(), yy: (e) => Gn(Number(String(e.year()).substr(2, 4))), yyy: (e) => e.year(), yyyy: (e) => e.year(), yyyyy: (e) => "0" + e.year(), Q: (e) => e.quarter(), QQ: (e) => e.quarter(), QQQ: (e) => e.quarter(), QQQQ: (e) => e.quarter(), M: (e) => e.month() + 1, MM: (e) => Gn(e.month() + 1), MMM: (e) => e.format("month-short"), MMMM: (e) => e.format("month"), w: (e) => e.week(), ww: (e) => Gn(e.week()), d: (e) => e.date(), dd: (e) => Gn(e.date()), D: (e) => e.dayOfYear(), DD: (e) => Gn(e.dayOfYear()), DDD: (e) => Gn(e.dayOfYear(), 3), E: (e) => e.format("day-short"), EE: (e) => e.format("day-short"), EEE: (e) => e.format("day-short"), EEEE: (e) => e.format("day"), EEEEE: (e) => e.format("day")[0], e: (e) => e.day(), ee: (e) => e.day(), eee: (e) => e.format("day-short"), eeee: (e) => e.format("day"), eeeee: (e) => e.format("day")[0], a: (e) => e.ampm().toUpperCase(), aa: (e) => e.ampm().toUpperCase(), aaa: (e) => e.ampm().toUpperCase(), aaaa: (e) => e.ampm().toUpperCase(), h: (e) => e.h12(), hh: (e) => Gn(e.h12()), H: (e) => e.hour(), HH: (e) => Gn(e.hour()), m: (e) => e.minute(), mm: (e) => Gn(e.minute()), s: (e) => e.second(), ss: (e) => Gn(e.second()), SSS: (e) => Gn(e.millisecond(), 3), A: (e) => e.epoch - e.startOf("day").epoch, z: (e) => e.timezone().name, zz: (e) => e.timezone().name, zzz: (e) => e.timezone().name, zzzz: (e) => e.timezone().name, Z: (e) => d$(e.timezone().current.offset), ZZ: (e) => d$(e.timezone().current.offset), ZZZ: (e) => d$(e.timezone().current.offset), ZZZZ: (e) => d$(e.timezone().current.offset, ":") }, ju = (e, t, n) => {
  let o = e, r = t;
  for (let i = 0; i < n; i += 1)
    oE[o] = oE[r], o += e, r += t;
};
ju("q", "Q", 4), ju("L", "M", 4), ju("Y", "y", 4), ju("c", "e", 4), ju("k", "H", 2), ju("K", "h", 2), ju("S", "s", 2), ju("v", "z", 4), ju("V", "Z", 4);
var Hvc = (e, t) => {
  let n = t.split("");
  return n = function(o) {
    for (let r = 0; r < o.length; r += 1)
      if (o[r] === "'")
        for (let i = r + 1; i < o.length; i += 1) {
          if (o[i] && (o[r] += o[i]), o[i] === "'") {
            o[i] = null;
            break;
          }
          o[i] = null;
        }
    return o.filter((r) => r);
  }(n), n = function(o) {
    for (let r = 0; r < o.length; r += 1) {
      let i = o[r];
      for (let a = r + 1; a < o.length && o[a] === i; a += 1)
        o[r] += o[a], o[a] = null;
    }
    return (o = o.filter((r) => r)).map((r) => (r === "''" && (r = "'"), r));
  }(n), n.reduce((o, r) => (oE[r] !== void 0 ? o += oE[r](e) || "" : (/^'.{1,}'$/.test(r) && (r = r.replace(/'/g, "")), o += r), o), "");
};
const Kvc = ["year", "season", "quarter", "month", "week", "day", "quarterHour", "hour", "minute"], wH = function(e, t) {
  let n = e.clone().startOf(t), o = e.clone().endOf(t).epoch - n.epoch, r = (e.epoch - n.epoch) / o;
  return parseFloat(r.toFixed(2));
};
var Yvc = (e, t) => {
  if (t)
    return t = Bf(t), wH(e, t);
  let n = {};
  return Kvc.forEach((o) => {
    n[o] = wH(e, o);
  }), n;
}, Zvc = (e, t) => {
  let n = e.progress();
  return (t = Bf(t)) === "quarterhour" && (t = "quarterHour"), n[t] !== void 0 ? (n[t] > 0.5 && (e = e.add(1, t)), e = e.startOf(t)) : e.silent === !1 && console.warn("no known unit '" + t + "'"), e;
};
const kH = (e, t, n) => {
  let o = 0;
  for (e = e.clone(); e.isBefore(t); )
    e = e.add(1, n), o += 1;
  return e.isAfter(t, n) && (o -= 1), o;
};
var v3 = (e, t, n) => e.isBefore(t) ? kH(e, t, n) : -1 * kH(t, e, n), Qvc = function(e, t) {
  let n = t.epoch - e.epoch, o = { milliseconds: n, seconds: parseInt(n / 1e3, 10) };
  o.minutes = parseInt(o.seconds / 60, 10), o.hours = parseInt(o.minutes / 60, 10);
  let r = e.clone();
  return o.years = ((i, a) => {
    let s = a.year() - i.year();
    return (i = i.year(a.year())).isAfter(a) && (s -= 1), s;
  })(r, t), r = e.add(o.years, "year"), o.months = 12 * o.years, r = e.add(o.months, "month"), o.months += v3(r, t, "month"), o.weeks = 52 * o.years, r = e.add(o.weeks, "week"), o.weeks += v3(r, t, "week"), o.days = 7 * o.weeks, r = e.add(o.days, "day"), o.days += v3(r, t, "day"), o;
}, Jvc = function(e, t, n) {
  t = Zm(t, e);
  let o = !1;
  if (e.isAfter(t)) {
    let i = e;
    e = t, t = i, o = !0;
  }
  let r = Qvc(e, t);
  return o && (r = function(i) {
    return Object.keys(i).forEach((a) => {
      i[a] *= -1;
    }), i;
  }(r)), n ? (n = Bf(n), /s$/.test(n) !== !0 && (n += "s"), n === "dates" && (n = "days"), r[n]) : r;
};
const Xg = (e) => Math.abs(e) || 0;
var Xvc = function(e) {
  let t = "P";
  return t += Xg(e.years) + "Y", t += Xg(e.months) + "M", t += Xg(e.days) + "DT", t += Xg(e.hours) + "H", t += Xg(e.minutes) + "M", t += Xg(e.seconds) + "S", t;
};
const SH = { months: { almost: 10, over: 4 }, days: { almost: 25, over: 10 }, hours: { almost: 20, over: 8 }, minutes: { almost: 50, over: 20 }, seconds: { almost: 50, over: 20 } };
function xH(e, t) {
  return e === 1 && (t = t.slice(0, -1)), e + " " + t;
}
var ebc = function(e) {
  let t = null, n = null, o = [], r = [];
  return Object.keys(e).forEach((i, a, s) => {
    const c = Math.abs(e[i]);
    if (c === 0)
      return;
    o.push(c + i[0]);
    const l = xH(c, i);
    if (r.push(l), !t) {
      if (t = n = l, a > 4)
        return;
      const d = s[a + 1], u = Math.abs(e[d]);
      u > SH[d].almost ? (t = xH(c + 1, i), n = "almost " + t) : u > SH[d].over && (n = "over " + l);
    }
  }), { qualified: n, rounded: t, abbreviated: o, englishValues: r };
}, tbc = (e, t) => {
  const n = function(u, _) {
    const p = u.isBefore(_), f = p ? _ : u;
    let g = p ? u : _;
    g = g.clone();
    const h = { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    return Object.keys(h).forEach((b) => {
      if (g.isSame(f, b))
        return;
      let v = g.diff(f, b);
      g = g.add(v, b), h[b] = v;
    }), p && Object.keys(h).forEach((b) => {
      h[b] !== 0 && (h[b] *= -1);
    }), h;
  }(e, t = Zm(t, e));
  if (Object.keys(n).every((u) => !n[u]) === !0)
    return { diff: n, rounded: "now", qualified: "now", precise: "now", abbreviated: [], iso: "P0Y0M0DT0H0M0S", direction: "present" };
  let r, i = "future", { rounded: a, qualified: s, englishValues: c, abbreviated: l } = ebc(n);
  r = c.splice(0, 2).join(", "), e.isAfter(t) === !0 ? (a += " ago", s += " ago", r += " ago", i = "past") : (a = "in " + a, s = "in " + s, r = "in " + r);
  let d = Xvc(n);
  return { diff: n, rounded: a, qualified: s, precise: r, abbreviated: l, iso: d, direction: i };
}, Kl = { north: [["spring", 2, 1], ["summer", 5, 1], ["fall", 8, 1], ["autumn", 8, 1], ["winter", 11, 1]], south: [["fall", 2, 1], ["autumn", 2, 1], ["winter", 5, 1], ["spring", 8, 1], ["summer", 11, 1]] }, cf = [null, [0, 1], [3, 1], [6, 1], [9, 1]];
const Qm = { minute: (e) => (ur(e, { second: 0, millisecond: 0 }), e), quarterhour: (e) => {
  let t = e.minutes();
  return e = t >= 45 ? e.minutes(45) : t >= 30 ? e.minutes(30) : t >= 15 ? e.minutes(15) : e.minutes(0), ur(e, { second: 0, millisecond: 0 }), e;
}, hour: (e) => (ur(e, { minute: 0, second: 0, millisecond: 0 }), e), day: (e) => (ur(e, { hour: 0, minute: 0, second: 0, millisecond: 0 }), e), week: (e) => {
  let t = e.clone();
  return (e = e.day(e._weekStart)).isAfter(t) && (e = e.subtract(1, "week")), ur(e, { hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
}, month: (e) => (ur(e, { date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }), e), quarter: (e) => {
  let t = e.quarter();
  return cf[t] && ur(e, { month: cf[t][0], date: cf[t][1], hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
}, season: (e) => {
  let t = e.season(), n = "north";
  e.hemisphere() === "South" && (n = "south");
  for (let o = 0; o < Kl[n].length; o++)
    if (Kl[n][o][0] === t) {
      let r = e.year();
      return t === "winter" && e.month() < 3 && (r -= 1), ur(e, { year: r, month: Kl[n][o][1], date: Kl[n][o][2], hour: 0, minute: 0, second: 0, millisecond: 0 }), e;
    }
  return e;
}, year: (e) => (ur(e, { month: 0, date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }), e), decade: (e) => {
  let t = (e = e.startOf("year")).year(), n = 10 * parseInt(t / 10, 10);
  return e = e.year(n);
}, century: (e) => {
  let t = (e = e.startOf("year")).year(), n = 100 * parseInt(t / 100, 10);
  return e = e.year(n);
} };
Qm.date = Qm.day;
var nbc = function(e, t, n) {
  if (!t || !n)
    return [];
  if (t = Bf(t), n = e.clone().set(n), e.isAfter(n)) {
    let i = e;
    e = n, n = i;
  }
  let o = e.clone();
  (function(i) {
    return !!zw().find((a) => a === i) || !!nE().find((a) => a === i);
  })(t) ? (o = o.next(t), t = "week") : o.startOf(t).isBefore(e) && (o = o.next(t));
  let r = [];
  for (; o.isBefore(n); )
    r.push(o), o = o.add(1, t);
  return r;
}, Cy = (e) => {
  let t = e.timezones, n = e.tz;
  if (t.hasOwnProperty(n) === !1 && (n = tE(e.tz, t)), n === null)
    return e.silent === !1 && console.warn("Warn: could not find given or local timezone - '" + e.tz + "'"), { current: { epochShift: 0 } };
  let o = t[n], r = { name: (i = n, i = (i = (i = i[0].toUpperCase() + i.substr(1)).replace(/\/gmt/, "/GMT")).replace(/[\/_]([a-z])/gi, (l) => l.toUpperCase()), i), hasDst: !!o.dst, default_offset: o.offset, hemisphere: o.hem === "s" ? "South" : "North", current: {} };
  var i, a;
  if (r.hasDst) {
    let l = (a = o.dst) ? a.split("->") : [];
    r.change = { start: l[0], back: l[1] };
  }
  let s = o.offset, c = s;
  return r.hasDst === !0 && (c = r.hemisphere === "North" ? s - 1 : o.offset + 1), r.hasDst === !1 ? (r.current.offset = s, r.current.isDST = !1) : Vde(e.epoch, r.change.start, r.change.back, s, c) === !0 ? (r.current.offset = s, r.current.isDST = r.hemisphere === "North") : (r.current.offset = c, r.current.isDST = r.hemisphere === "South"), r;
};
const obc = ["century", "decade", "year", "month", "date", "day", "hour", "minute", "second", "millisecond"], Um = { set: function(e, t) {
  let n = this.clone();
  return n = Gde(n, e), t && (this.tz = tE(t)), n;
}, timezone: function() {
  return Cy(this);
}, isDST: function() {
  return Cy(this).current.isDST;
}, hasDST: function() {
  return Cy(this).hasDst;
}, offset: function() {
  return 60 * Cy(this).current.offset;
}, hemisphere: function() {
  return Cy(this).hemisphere;
}, format: function(e) {
  return h3(this, e);
}, unixFmt: function(e) {
  return Hvc(this, e);
}, startOf: function(e) {
  return ((t, n) => {
    let o = t.clone();
    return n = Bf(n), Qm[n] ? Qm[n](o) : n === "summer" || n === "winter" ? (o = o.season(n), Qm.season(o)) : o;
  })(this, e);
}, endOf: function(e) {
  return ((t, n) => {
    let o = t.clone();
    return n = Bf(n), Qm[n] && (o = Qm[n](o), o = o.add(1, n), o = o.subtract(1, "millisecond")), o;
  })(this, e);
}, leapYear: function() {
  return uA(this.year());
}, progress: function(e) {
  return Yvc(this, e);
}, nearest: function(e) {
  return Zvc(this, e);
}, diff: function(e, t) {
  return Jvc(this, e, t);
}, since: function(e) {
  return e || (e = this.clone().set()), tbc(this, e);
}, next: function(e) {
  return this.add(1, e).startOf(e);
}, last: function(e) {
  return this.subtract(1, e).startOf(e);
}, isValid: function() {
  return !(!this.epoch && this.epoch !== 0) && !isNaN(this.d.getTime());
}, goto: function(e) {
  let t = this.clone();
  return t.tz = tE(e, t.timezones), t;
}, every: function(e, t) {
  if (typeof e == "object" && typeof t == "string") {
    let n = t;
    t = e, e = n;
  }
  return nbc(this, e, t);
}, isAwake: function() {
  let e = this.hour();
  return !(e < 8 || e > 22);
}, isAsleep: function() {
  return !this.isAwake();
}, daysInMonth: function() {
  switch (this.month()) {
    case 0:
    case 2:
    case 4:
    case 6:
    case 7:
    case 9:
    case 11:
      return 31;
    case 1:
      return this.leapYear() ? 29 : 28;
    case 3:
    case 5:
    case 8:
    case 10:
      return 30;
    default:
      throw new Error("Invalid Month state.");
  }
}, log: function() {
  return console.log(""), console.log(h3(this, "nice-short")), this;
}, logYear: function() {
  return console.log(""), console.log(h3(this, "full-short")), this;
}, json: function() {
  return obc.reduce((e, t) => (e[t] = this[t](), e), {});
}, debug: function() {
  let e = this.timezone(), t = this.format("MM") + " " + this.format("date-ordinal") + " " + this.year();
  return t += `
     - ` + this.format("time"), console.log(`

`, t + `
     - ` + e.name + " (" + e.current.offset + ")"), this;
}, from: function(e) {
  return (e = this.clone().set(e)).since(this);
}, fromNow: function() {
  return this.clone().set(Date.now()).since(this);
}, weekStart: function(e) {
  if (typeof e == "number")
    return this._weekStart = e, this;
  if (typeof e == "string") {
    e = e.toLowerCase().trim();
    let t = zw().indexOf(e);
    t === -1 && (t = nE().indexOf(e)), t === -1 && (t = 1), this._weekStart = t;
  } else
    console.warn("Spacetime Error: Cannot understand .weekStart() input:", e);
  return this;
} };
Um.inDST = Um.isDST, Um.round = Um.nearest, Um.each = Um.every;
var EH = Um;
const h_ = (e) => (typeof e == "string" && (e = parseInt(e, 10)), e), b3 = ["year", "month", "date", "hour", "minute", "second", "millisecond"], R9 = (e, t, n) => {
  let o = b3.indexOf(n), r = b3.slice(o, b3.length);
  for (let i = 0; i < r.length; i++) {
    let a = t[r[i]]();
    e[r[i]](a);
  }
  return e;
}, jp = function(e, t, n, o) {
  return n === !0 && e.isBefore(t) ? e = e.add(1, o) : n === !1 && e.isAfter(t) && (e = e.minus(1, o)), e;
}, TH = function(e, t, n) {
  t = h_(t);
  let o = e.clone(), r = (e.minute() - t) * ta.minute;
  return e.epoch -= r, R9(e, o, "second"), (e = jp(e, o, n, "hour")).epoch;
}, y3 = function(e, t, n) {
  (t = h_(t)) >= 24 ? t = 24 : t < 0 && (t = 0);
  let o = e.clone(), r = e.hour() - t, i = r * ta.hour;
  return e.epoch -= i, e.date() !== o.date() && (e = o.clone(), r > 1 && (r -= 1), r < 1 && (r += 1), i = r * ta.hour, e.epoch -= i), ur(e, { hour: t }), R9(e, o, "minute"), (e = jp(e, o, n, "day")).epoch;
}, $3 = function(e, t) {
  return typeof t == "string" && /^'[0-9]{2}$/.test(t) && (t = t.replace(/'/, "").trim(), t = (t = Number(t)) > 30 ? 1900 + t : 2e3 + t), t = h_(t), ur(e, { year: t }), e.epoch;
};
let HD = "am", KD = "pm";
const rbc = { millisecond: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    return t.epoch = function(n, o) {
      o = h_(o);
      let r = n.millisecond() - o;
      return n.epoch - r;
    }(t, e), t;
  }
  return this.d.getMilliseconds();
}, second: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = function(o, r, i) {
      r = h_(r);
      let a = o.clone(), s = (o.second() - r) * ta.second;
      return o.epoch = o.epoch - s, (o = jp(o, a, i, "minute")).epoch;
    }(n, e, t), n;
  }
  return this.d.getSeconds();
}, minute: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = TH(n, e, t), n;
  }
  return this.d.getMinutes();
}, hour: function(e, t) {
  let n = this.d;
  if (e !== void 0) {
    let o = this.clone();
    return o.epoch = y3(o, e, t), o;
  }
  return n.getHours();
}, hourFloat: function(e, t) {
  if (e !== void 0) {
    let i = this.clone(), a = e % 1;
    a *= 60;
    let s = parseInt(e, 10);
    return i.epoch = y3(i, s, t), i.epoch = TH(i, a, t), i;
  }
  let n = this.d, o = n.getHours(), r = n.getMinutes();
  return r /= 60, o + r;
}, hour12: function(e, t) {
  let n = this.d;
  if (e !== void 0) {
    let r = this.clone(), i = (e = "" + e).match(/^([0-9]+)(am|pm)$/);
    if (i) {
      let a = parseInt(i[1], 10);
      i[2] === "pm" && (a += 12), r.epoch = y3(r, a, t);
    }
    return r;
  }
  let o = n.getHours();
  return o > 12 && (o -= 12), o === 0 && (o = 12), o;
}, time: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return e = e.toLowerCase().trim(), n.epoch = function(o, r, i) {
      let a = r.match(/([0-9]{1,2})[:h]([0-9]{1,2})(:[0-9]{1,2})? ?(am|pm)?/);
      if (!a) {
        if (a = r.match(/([0-9]{1,2}) ?(am|pm)/), !a)
          return o.epoch;
        a.splice(2, 0, "0"), a.splice(3, 0, "");
      }
      let s = !1, c = parseInt(a[1], 10), l = parseInt(a[2], 10);
      l >= 60 && (l = 59), c > 12 && (s = !0), s === !1 && (a[4] === "am" && c === 12 && (c = 0), a[4] === "pm" && c < 12 && (c += 12)), a[3] = a[3] || "", a[3] = a[3].replace(/:/, "");
      let d = parseInt(a[3], 10) || 0, u = o.clone();
      return o = (o = (o = (o = o.hour(c)).minute(l)).second(d)).millisecond(0), (o = jp(o, u, i, "day")).epoch;
    }(n, e, t), n;
  }
  return `${this.h12()}:${Gn(this.minute())}${this.ampm()}`;
}, ampm: function(e, t) {
  let n = HD, o = this.hour();
  if (o >= 12 && (n = KD), typeof e != "string")
    return n;
  let r = this.clone();
  return e = e.toLowerCase().trim(), o >= 12 && e === "am" ? (o -= 12, r.hour(o, t)) : o < 12 && e === "pm" ? (o += 12, r.hour(o, t)) : r;
}, dayTime: function(e, t) {
  if (e !== void 0) {
    const o = { morning: "7:00am", breakfast: "7:00am", noon: "12:00am", lunch: "12:00pm", afternoon: "2:00pm", evening: "6:00pm", dinner: "6:00pm", night: "11:00pm", midnight: "23:59pm" };
    let r = this.clone();
    return e = (e = e || "").toLowerCase(), o.hasOwnProperty(e) === !0 && (r = r.time(o[e], t)), r;
  }
  let n = this.hour();
  return n < 6 ? "night" : n < 12 ? "morning" : n < 17 ? "afternoon" : n < 22 ? "evening" : "night";
}, iso: function(e) {
  return e !== void 0 ? this.set(e) : this.format("iso");
} };
var ibc = rbc;
const abc = { date: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return (e = parseInt(e, 10)) && (n.epoch = function(o, r, i) {
      if ((r = h_(r)) > 28) {
        let s = o.month(), c = Uf[s];
        s === 1 && r === 29 && uA(o.year()) && (c = 29), r > c && (r = c);
      }
      r <= 0 && (r = 1);
      let a = o.clone();
      return ur(o, { date: r }), (o = jp(o, a, i, "month")).epoch;
    }(n, e, t)), n;
  }
  return this.d.getDate();
}, day: function(e, t) {
  if (e === void 0)
    return this.d.getDay();
  let n = this.clone(), o = e;
  typeof e == "string" && (e = e.toLowerCase(), bH.hasOwnProperty(e) ? o = bH[e] : (o = zw().indexOf(e), o === -1 && (o = nE().indexOf(e))));
  let r = this.d.getDay() - o;
  t === !0 && r > 0 && (r -= 7), t === !1 && r < 0 && (r += 7);
  let i = this.subtract(r, "days");
  return ur(i, { hour: n.hour(), minute: n.minute(), second: n.second() }), i;
}, dayName: function(e, t) {
  if (e === void 0)
    return nE()[this.day()];
  let n = this.clone();
  return n = n.day(e, t), n;
} };
var sbc = abc;
const AH = (e) => e = (e = (e = e.minute(0)).second(0)).millisecond(1), cbc = { dayOfYear: function(e, t) {
  if (e !== void 0) {
    let i = this.clone();
    return i.epoch = function(a, s, c) {
      s = h_(s);
      let l = a.clone();
      return (s -= 1) <= 0 ? s = 0 : s >= 365 && (s = 364), a = (a = a.startOf("year")).add(s, "day"), R9(a, l, "hour"), (a = jp(a, l, c, "year")).epoch;
    }(i, e, t), i;
  }
  let n, o = 0, r = this.d.getMonth();
  for (let i = 1; i <= r; i++)
    n = /* @__PURE__ */ new Date(), n.setDate(1), n.setFullYear(this.d.getFullYear()), n.setHours(1), n.setMinutes(1), n.setMonth(i), n.setHours(-2), o += n.getDate();
  return o + this.d.getDate();
}, week: function(e, t) {
  if (e !== void 0) {
    let s = this.clone();
    return s.epoch = function(c, l, d) {
      let u = c.clone();
      return l = h_(l), (c = (c = (c = c.month(0)).date(1)).day("monday")).monthName() === "december" && c.date() >= 28 && (c = c.add(1, "week")), l -= 1, c = c.add(l, "weeks"), (c = jp(c, u, d, "year")).epoch;
    }(this, e, t), s = AH(s), s;
  }
  let n = this.clone();
  n = n.month(0), n = n.date(1), n = AH(n), n = n.day("monday"), n.monthName() === "december" && n.date() >= 28 && (n = n.add(1, "week"));
  let o = 1;
  n.date() === 1 && (o = 0), n = n.minus(1, "second");
  const r = this.epoch;
  if (n.epoch > r)
    return 1;
  let i = 0, a = 4 * this.month();
  for (n.epoch += ta.week * a, i += a; i <= 52; i++) {
    if (n.epoch > r)
      return i + o;
    n = n.add(1, "week");
  }
  return 52;
}, month: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n.epoch = function(o, r, i) {
      typeof r == "string" && (r === "sept" && (r = "sep"), r = Wde()[r.toLowerCase()]), (r = h_(r)) >= 12 && (r = 11), r <= 0 && (r = 0);
      let a = o.date();
      a > Uf[r] && (a = Uf[r]);
      let s = o.clone();
      return ur(o, { month: r, d: a }), (o = jp(o, s, i, "year")).epoch;
    }(n, e, t), n;
  }
  return this.d.getMonth();
}, monthName: function(e, t) {
  if (e !== void 0) {
    let n = this.clone();
    return n = n.month(e, t), n;
  }
  return Cw[this.month()];
}, quarter: function(e, t) {
  if (e !== void 0 && (typeof e == "string" && (e = e.replace(/^q/i, ""), e = parseInt(e, 10)), cf[e])) {
    let o = this.clone(), r = cf[e][0];
    return o = o.month(r, t), o = o.date(1, t), o = o.startOf("day"), o;
  }
  let n = this.d.getMonth();
  for (let o = 1; o < cf.length; o++)
    if (n < cf[o][0])
      return o - 1;
  return 4;
}, season: function(e, t) {
  let n = "north";
  if (this.hemisphere() === "South" && (n = "south"), e !== void 0) {
    let r = this.clone();
    for (let i = 0; i < Kl[n].length; i++)
      e === Kl[n][i][0] && (r = r.month(Kl[n][i][1], t), r = r.date(1), r = r.startOf("day"));
    return r;
  }
  let o = this.d.getMonth();
  for (let r = 0; r < Kl[n].length - 1; r++)
    if (o >= Kl[n][r][1] && o < Kl[n][r + 1][1])
      return Kl[n][r][0];
  return "winter";
}, year: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    return t.epoch = $3(t, e), t;
  }
  return this.d.getFullYear();
}, era: function(e) {
  if (e !== void 0) {
    let t = this.clone();
    e = e.toLowerCase();
    let n = t.d.getFullYear();
    return e === "bc" && n > 0 && (t.epoch = $3(t, -1 * n)), e === "ad" && n < 0 && (t.epoch = $3(t, -1 * n)), t;
  }
  return this.d.getFullYear() < 0 ? "BC" : "AD";
}, decade: function(e) {
  if (e !== void 0) {
    if (!(e = (e = (e = String(e)).replace(/([0-9])'?s$/, "$1")).replace(/([0-9])(th|rd|st|nd)/, "$1")))
      return console.warn("Spacetime: Invalid decade input"), this;
    e.length === 2 && /[0-9][0-9]/.test(e) && (e = "19" + e);
    let t = Number(e);
    return isNaN(t) ? this : (t = 10 * Math.floor(t / 10), this.year(t));
  }
  return this.startOf("decade").year();
}, century: function(e) {
  if (e !== void 0) {
    typeof e == "string" && (e = (e = e.replace(/([0-9])(th|rd|st|nd)/, "$1")).replace(/([0-9]+) ?(b\.?c\.?|a\.?d\.?)/i, (o, r, i) => (i.match(/b\.?c\.?/i) && (r = "-" + r), r)), e = e.replace(/c$/, ""));
    let n = Number(e);
    return isNaN(e) ? (console.warn("Spacetime: Invalid century input"), this) : (n === 0 && (n = 1), n = n >= 0 ? 100 * (n - 1) : 100 * (n + 1), this.year(n));
  }
  let t = this.startOf("century").year();
  return t = Math.floor(t / 100), t < 0 ? t - 1 : t + 1;
}, millenium: function(e) {
  if (e !== void 0) {
    if (typeof e == "string" && (e = e.replace(/([0-9])(th|rd|st|nd)/, "$1"), e = Number(e), isNaN(e)))
      return console.warn("Spacetime: Invalid millenium input"), this;
    e > 0 && (e -= 1);
    let n = 1e3 * e;
    return n === 0 && (n = 1), this.year(n);
  }
  let t = Math.floor(this.year() / 1e3);
  return t >= 0 && (t += 1), t;
} };
var lbc = cbc;
const Zi = Object.assign({}, ibc, sbc, lbc);
Zi.milliseconds = Zi.millisecond, Zi.seconds = Zi.second, Zi.minutes = Zi.minute, Zi.hours = Zi.hour, Zi.hour24 = Zi.hour, Zi.h12 = Zi.hour12, Zi.h24 = Zi.hour24, Zi.days = Zi.day;
var dbc = (e) => {
  Object.keys(Zi).forEach((t) => {
    e.prototype[t] = Zi[t];
  });
};
const YD = function(e, t) {
  return e === 1 && uA(t) ? 29 : Uf[e];
}, ubc = (e, t) => {
  if (e.month > 0) {
    let n = parseInt(e.month / 12, 10);
    e.year = t.year() + n, e.month = e.month % 12;
  } else if (e.month < 0) {
    let n = Math.abs(e.month), o = parseInt(n / 12, 10);
    n % 12 != 0 && (o += 1), e.year = t.year() - o, e.month = e.month % 12, e.month = e.month + 12, e.month === 12 && (e.month = 0);
  }
  return e;
}, _bc = (e, t, n) => {
  let o = t.year(), r = t.month(), i = YD(r, o);
  for (; n > i; )
    n -= i, r += 1, r >= 12 && (r -= 12, o += 1), i = YD(r, o);
  return e.month = r, e.date = n, e;
}, pbc = (e, t, n) => {
  e.year = t.year(), e.month = t.month();
  let o = t.date();
  for (e.date = o - Math.abs(n); e.date < 1; ) {
    e.month -= 1, e.month < 0 && (e.month = 11, e.year -= 1);
    let r = YD(e.month, e.year);
    e.date += r;
  }
  return e;
}, Ll = ["millisecond", "second", "minute", "hour", "date", "month"];
let fp = { second: Ll.slice(0, 1), minute: Ll.slice(0, 2), quarterhour: Ll.slice(0, 2), hour: Ll.slice(0, 3), date: Ll.slice(0, 4), month: Ll.slice(0, 4), quarter: Ll.slice(0, 4), season: Ll.slice(0, 4), year: Ll, decade: Ll, century: Ll };
fp.week = fp.hour, fp.season = fp.date, fp.quarter = fp.date;
const mbc = { year: !0, quarter: !0, season: !0, month: !0, week: !0, date: !0 }, fbc = { month: !0, quarter: !0, season: !0, year: !0 };
var gbc = (e) => {
  e.prototype.add = function(t, n) {
    let o = this.clone();
    if (!n || t === 0)
      return o;
    let r = this.clone();
    if ((n = Bf(n)) === "millisecond")
      return o.epoch += t, o;
    n === "fortnight" && (t *= 2, n = "week"), ta[n] ? o.epoch += ta[n] * t : n === "week" || n === "weekend" ? o.epoch += ta.day * (7 * t) : n === "quarter" || n === "season" ? o.epoch += ta.month * (3 * t) : n === "quarterhour" && (o.epoch += 15 * ta.minute * t);
    let i = {};
    if (fp[n] && fp[n].forEach((a) => {
      i[a] = r[a]();
    }), mbc[n]) {
      const a = r.timezone().current.offset - o.timezone().current.offset;
      o.epoch += 3600 * a * 1e3;
    }
    if (n === "month" && (i.month = r.month() + t, i = ubc(i, r)), n === "week") {
      let a = r.date() + 7 * t;
      a <= 28 && a > 1 && (i.date = a);
    }
    if (n === "weekend" && o.dayName() !== "saturday")
      o = o.day("saturday", !0);
    else if (n === "date") {
      if (t < 0)
        i = pbc(i, r, t);
      else {
        let a = r.date() + t;
        i = _bc(i, r, a);
      }
      t !== 0 && r.isSame(o, "day") && (i.date = r.date() + t);
    } else if (n === "quarter") {
      if (i.month = r.month() + 3 * t, i.year = r.year(), i.month < 0) {
        let a = Math.floor(i.month / 12), s = i.month + 12 * Math.abs(a);
        i.month = s, i.year += a;
      } else if (i.month >= 12) {
        let a = Math.floor(i.month / 12);
        i.month = i.month % 12, i.year += a;
      }
      i.date = r.date();
    } else if (n === "year") {
      let a = r.year() + t, s = o.year();
      if (s < a) {
        let c = Math.floor(t / 4) || 1;
        o.epoch += Math.abs(ta.day * c);
      } else if (s > a) {
        let c = Math.floor(t / 4) || 1;
        o.epoch += ta.day * c;
      }
    } else
      n === "decade" ? i.year = o.year() + 10 : n === "century" && (i.year = o.year() + 100);
    if (fbc[n]) {
      let a = Uf[i.month];
      i.date = r.date(), i.date > a && (i.date = a);
    }
    return Object.keys(i).length > 1 && ur(o, i), o;
  }, e.prototype.subtract = function(t, n) {
    return this.clone().add(-1 * t, n);
  }, e.prototype.minus = e.prototype.subtract, e.prototype.plus = e.prototype.add;
};
const O$ = { millisecond: (e) => e.epoch, second: (e) => [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second()].join("-"), minute: (e) => [e.year(), e.month(), e.date(), e.hour(), e.minute()].join("-"), hour: (e) => [e.year(), e.month(), e.date(), e.hour()].join("-"), day: (e) => [e.year(), e.month(), e.date()].join("-"), week: (e) => [e.year(), e.week()].join("-"), month: (e) => [e.year(), e.month()].join("-"), quarter: (e) => [e.year(), e.quarter()].join("-"), year: (e) => e.year() };
O$.date = O$.day;
var hbc = (e) => {
  e.prototype.isSame = function(t, n, o = !0) {
    let r = this;
    if (!n)
      return null;
    if (typeof t == "string" && typeof n == "object") {
      let i = t;
      t = n, n = i;
    }
    return typeof t != "string" && typeof t != "number" || (t = new e(t, this.timezone.name)), n = n.replace(/s$/, ""), o === !0 && r.tz !== t.tz && ((t = t.clone()).tz = r.tz), O$[n] ? O$[n](r) === O$[n](t) : null;
  };
}, vbc = (e) => {
  const t = { isAfter: function(n) {
    let o = Ty(n = Zm(n, this));
    return o === null ? null : this.epoch > o;
  }, isBefore: function(n) {
    let o = Ty(n = Zm(n, this));
    return o === null ? null : this.epoch < o;
  }, isEqual: function(n) {
    let o = Ty(n = Zm(n, this));
    return o === null ? null : this.epoch === o;
  }, isBetween: function(n, o, r = !1) {
    n = Zm(n, this), o = Zm(o, this);
    let i = Ty(n);
    if (i === null)
      return null;
    let a = Ty(o);
    return a === null ? null : r ? this.isBetween(n, o) || this.isEqual(n) || this.isEqual(o) : i < this.epoch && this.epoch < a;
  } };
  Object.keys(t).forEach((n) => {
    e.prototype[n] = t[n];
  });
}, bbc = (e) => {
  const t = { i18n: (n) => {
    var o, r, i;
    Vh(n.days) && (o = n.days, WD = o.short || WD, GD = o.long || GD), Vh(n.months) && function(a) {
      Aw = a.short || Aw, Cw = a.long || Cw;
    }(n.months), i = n.useTitleCase, Object.prototype.toString.call(i) === "[object Boolean]" && (r = n.useTitleCase, Hde = r), Vh(n.ampm) && function(a) {
      HD = a.am || HD, KD = a.pm || KD;
    }(n.ampm);
  } };
  Object.keys(t).forEach((n) => {
    e.prototype[n] = t[n];
  });
};
let w3 = Bde;
const Wl = function(e, t, n = {}) {
  this.epoch = null, this.tz = tE(t, w3), this.silent = n.silent === void 0 || n.silent, this.british = n.dmy || n.british, this._weekStart = 1, n.weekStart !== void 0 && (this._weekStart = n.weekStart), this._today = {}, n.today !== void 0 && (this._today = n.today), Object.defineProperty(this, "d", { get: function() {
    let r = Avc(this), i = (new Date(this.epoch).getTimezoneOffset() || 0) + 60 * r;
    i = 60 * i * 1e3;
    let a = this.epoch + i;
    return new Date(a);
  } }), Object.defineProperty(this, "timezones", { get: () => w3, set: (r) => (w3 = r, r) });
  let o = Gde(this, e);
  this.epoch = o.epoch;
};
Object.keys(EH).forEach((e) => {
  Wl.prototype[e] = EH[e];
}), Wl.prototype.clone = function() {
  return new Wl(this.epoch, this.tz, { silent: this.silent, weekStart: this._weekStart, today: this._today, parsers: this.parsers });
}, Wl.prototype.toLocalDate = function() {
  return this.toNativeDate();
}, Wl.prototype.toNativeDate = function() {
  return new Date(this.epoch);
}, dbc(Wl), gbc(Wl), hbc(Wl), vbc(Wl), bbc(Wl);
var cl = Wl, ybc = (e, t) => {
  let n = new cl(null), o = new cl(null);
  n = n.time(e), o = t ? o.time(t) : n.add(59, "minutes");
  let r = n.hour(), i = o.hour();
  return Object.keys(n.timezones).filter((s) => {
    if (s.indexOf("/") === -1)
      return !1;
    let c = new cl(null, s), l = c.hour();
    return l >= r && l <= i && !(l === r && c.minute() < n.minute()) && !(l === i && c.minute() > o.minute());
  });
};
const vc = (e, t, n) => new cl(e, t, n), T2 = function(e) {
  let t = e._today || {};
  return Object.keys(t).forEach((n) => {
    e = e[n](t[n]);
  }), e;
};
vc.now = (e, t) => {
  let n = new cl((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = T2(n), n;
}, vc.today = (e, t) => {
  let n = new cl((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = T2(n), n.startOf("day");
}, vc.tomorrow = (e, t) => {
  let n = new cl((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = T2(n), n.add(1, "day").startOf("day");
}, vc.yesterday = (e, t) => {
  let n = new cl((/* @__PURE__ */ new Date()).getTime(), e, t);
  return n = T2(n), n.subtract(1, "day").startOf("day");
}, vc.extend = function(e = {}) {
  return Object.keys(e).forEach((t) => {
    cl.prototype[t] = e[t];
  }), this;
}, vc.timezones = function() {
  return new cl().timezones;
}, vc.max = function(e, t) {
  let n = new cl(null, e, t);
  return n.epoch = 864e13, n;
}, vc.min = function(e, t) {
  let n = new cl(null, e, t);
  return n.epoch = -864e13, n;
}, vc.whereIts = ybc, vc.version = "7.1.4", vc.plugin = vc.extend;
var k3 = vc, CH = function(e, t) {
  let n = Math.min(e.length, t.length);
  for (; n > 0; ) {
    const o = e.slice(0, n);
    if (o === t.slice(0, n))
      return o;
    n -= 1;
  }
  return "";
};
const ZD = function() {
  this.counts = {};
}, zH = { init: function(e) {
  this.counts[e] === void 0 && (this.counts[e] = 0);
}, add: function(e, t) {
  t === void 0 && (t = 1), this.init(e), this.counts[e] += t;
}, countOf: function(e) {
  return this.init(e), this.counts[e];
}, highest: function(e) {
  let t = [];
  const n = Object.keys(this.counts);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    t.push([r, this.counts[r]]);
  }
  return t.sort(function(o, r) {
    return r[1] - o[1];
  }), e && (t = t.slice(0, e)), t;
} };
Object.keys(zH).forEach(function(e) {
  ZD.prototype[e] = zH[e];
});
const QD = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", OH = QD.split("").reduce(function(e, t, n) {
  return e[t] = n, e;
}, {});
var wh = function(e) {
  if (QD[e] !== void 0)
    return QD[e];
  let t = 1, n = 36, o = "";
  for (; e >= n; e -= n, t++, n *= 36)
    ;
  for (; t--; ) {
    const r = e % 36;
    o = String.fromCharCode((r < 10 ? 48 : 55) + r) + o, e = (e - r) / 36;
  }
  return o;
}, JD = function(e) {
  if (OH[e] !== void 0)
    return OH[e];
  let t = 0, n = 1, o = 36, r = 1;
  for (; n < e.length; t += o, n++, o *= 36)
    ;
  for (let i = e.length - 1; i >= 0; i--, r *= 36) {
    let a = e.charCodeAt(i) - 48;
    a > 10 && (a -= 7), t += a * r;
  }
  return t;
};
const $bc = function(e, t) {
  let n = "", o = "";
  e.isTerminal(t) && (n += "!");
  const r = e.nodeProps(t);
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (typeof t[a] == "number") {
      n += o + a, o = ",";
      continue;
    }
    if (e.syms[t[a]._n]) {
      n += o + a + e.syms[t[a]._n], o = "";
      continue;
    }
    let s = wh(t._n - t[a]._n - 1 + e.symCount);
    t[a]._g && s.length >= t[a]._g.length && t[t[a]._g] === 1 ? (s = t[a]._g, n += o + a + s, o = ",") : (n += o + a + s, o = "");
  }
  return n;
}, Kde = function(e, t) {
  if (e.visited(t))
    return;
  const n = e.nodeProps(t, !0);
  for (let o = 0; o < n.length; o++) {
    const r = n[o], i = t._n - t[r]._n - 1;
    i < 36 && e.histRel.add(i), e.histAbs.add(t[r]._n, wh(i).length - 1), Kde(e, t[r]);
  }
}, Yde = function(e, t) {
  if (t._n !== void 0)
    return;
  const n = e.nodeProps(t, !0);
  for (let o = 0; o < n.length; o++)
    Yde(e, t[n[o]]);
  t._n = e.pos++, e.nodes.unshift(t);
}, wbc = new RegExp("[0-9A-Z,;!:|¦]"), kbc = { insertWords: function(e) {
  if (e !== void 0) {
    typeof e == "string" && (e = e.split(/[^a-zA-Z]+/));
    for (let t = 0; t < e.length; t++)
      e[t] = e[t].toLowerCase();
    (function(t) {
      t.sort();
      for (let n = 1; n < t.length; n++)
        t[n - 1] === t[n] && t.splice(n, 1);
    })(e);
    for (let t = 0; t < e.length; t++)
      e[t].match(wbc) === null && this.insert(e[t]);
  }
}, insert: function(e) {
  this._insert(e, this.root);
  const t = this.lastWord;
  if (this.lastWord = e, CH(e, t) === t)
    return;
  const n = this.uniqueNode(t, e, this.root);
  n && this.combineSuffixNode(n);
}, _insert: function(e, t) {
  let n, o;
  if (e.length === 0)
    return;
  const r = Object.keys(t);
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (n = CH(e, a), n.length !== 0)
      return a === n && typeof t[a] == "object" ? void this._insert(e.slice(n.length), t[a]) : a === e && typeof t[a] == "number" ? void 0 : (o = {}, o[a.slice(n.length)] = t[a], this.addTerminal(o, e = e.slice(n.length)), delete t[a], t[n] = o, void this.wordCount++);
  }
  this.addTerminal(t, e), this.wordCount++;
}, addTerminal: function(e, t) {
  if (t.length <= 1)
    return void (e[t] = 1);
  const n = {};
  e[t[0]] = n, this.addTerminal(n, t.slice(1));
}, nodeProps: function(e, t) {
  const n = [];
  for (const o in e)
    o !== "" && o[0] !== "_" && (t && typeof e[o] != "object" || n.push(o));
  return n.sort(), n;
}, optimize: function() {
  this.combineSuffixNode(this.root), this.prepDFS(), this.countDegree(this.root), this.prepDFS(), this.collapseChains(this.root);
}, combineSuffixNode: function(e) {
  if (e._c)
    return e;
  let t = [];
  this.isTerminal(e) && t.push("!");
  const n = this.nodeProps(e);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    typeof e[r] == "object" ? (e[r] = this.combineSuffixNode(e[r]), t.push(r), t.push(e[r]._c)) : t.push(r);
  }
  return t = t.join("-"), this.suffixes[t] || (this.suffixes[t] = e, e._c = this.cNext++, e);
}, prepDFS: function() {
  this.vCur++;
}, visited: function(e) {
  return e._v === this.vCur || (e._v = this.vCur, !1);
}, countDegree: function(e) {
  if (e._d === void 0 && (e._d = 0), e._d++, this.visited(e))
    return;
  const t = this.nodeProps(e, !0);
  for (let n = 0; n < t.length; n++)
    this.countDegree(e[t[n]]);
}, collapseChains: function(e) {
  let t, n, o, r;
  if (!this.visited(e)) {
    for (n = this.nodeProps(e), r = 0; r < n.length; r++)
      t = n[r], o = e[t], typeof o == "object" && (this.collapseChains(o), o._g === void 0 || o._d !== 1 && o._g.length !== 1 || (delete e[t], t += o._g, e[t] = o[o._g]));
    n.length !== 1 || this.isTerminal(e) || (e._g = t);
  }
}, isTerminal: function(e) {
  return !!e[""];
}, uniqueNode: function(e, t, n) {
  const o = this.nodeProps(n, !0);
  for (let r = 0; r < o.length; r++) {
    const i = o[r];
    if (i === e.slice(0, i.length))
      return i !== t.slice(0, i.length) ? n[i] : this.uniqueNode(e.slice(i.length), t.slice(i.length), n[i]);
  }
}, pack: function() {
  return function(e) {
    e.nodes = [], e.nodeCount = 0, e.syms = {}, e.symCount = 0, e.pos = 0, e.optimize(), e.histAbs = new ZD(), e.histRel = new ZD(), Yde(e, e.root), e.nodeCount = e.nodes.length, e.prepDFS(), Kde(e, e.root), e.symCount = function(t) {
      t.histAbs = t.histAbs.highest(36);
      const n = [];
      n[-1] = 0;
      let o = 0, r = 0;
      const i = 3 + wh(t.nodeCount).length;
      for (let a = 0; a < 36 && t.histAbs[a] !== void 0; a++)
        n[a] = t.histAbs[a][1] - i - t.histRel.countOf(36 - a - 1) + n[a - 1], n[a] >= o && (o = n[a], r = a + 1);
      return r;
    }(e);
    for (let t = 0; t < e.symCount; t++)
      e.syms[e.histAbs[t][0]] = wh(t);
    for (let t = 0; t < e.nodeCount; t++)
      e.nodes[t] = $bc(e, e.nodes[t]);
    for (let t = e.symCount - 1; t >= 0; t--)
      e.nodes.unshift(wh(t) + ":" + wh(e.nodeCount - e.histAbs[t][0] - 1));
    return e.nodes.join(";");
  }(this);
} };
Object.keys(kbc).forEach(function(e) {
});
const Sbc = function(e, t, n) {
  const o = JD(t);
  return o < e.symCount ? e.syms[o] : n + o + 1 - e.symCount;
}, xbc = /(\-?[0-9]+)h(rs)?/i, Ebc = /(\-?[0-9]+)/, Tbc = /utc([\-+]?[0-9]+)/i, Abc = /gmt([\-+]?[0-9]+)/i, A2 = function(e) {
  return (e = Number(e)) > -13 && e < 13 ? "Etc/GMT" + (e = ((e *= -1) > 0 ? "+" : "") + e) : null;
};
let ai = function(e) {
  const t = e.split("|").reduce((o, r) => {
    const i = r.split("¦");
    return o[i[0]] = i[1], o;
  }, {}), n = {};
  return Object.keys(t).forEach(function(o) {
    const r = function(i) {
      const a = { nodes: i.split(";"), syms: [], symCount: 0 };
      return i.match(":") && function(s) {
        const c = new RegExp("([0-9A-Z]+):([0-9A-Z]+)");
        for (let l = 0; l < s.nodes.length; l++) {
          const d = c.exec(s.nodes[l]);
          if (!d) {
            s.symCount = l;
            break;
          }
          s.syms[JD(d[1])] = JD(d[2]);
        }
        s.nodes = s.nodes.slice(s.symCount, s.nodes.length);
      }(a), function(s) {
        const c = [], l = (d, u) => {
          let _ = s.nodes[d];
          _[0] === "!" && (c.push(u), _ = _.slice(1));
          const p = _.split(/([A-Z0-9,]+)/g);
          for (let f = 0; f < p.length; f += 2) {
            const g = p[f], h = p[f + 1];
            if (!g)
              continue;
            const b = u + g;
            if (h === "," || h === void 0) {
              c.push(b);
              continue;
            }
            const v = Sbc(s, h, d);
            l(v, b);
          }
        };
        return l(0, ""), c;
      }(a);
    }(t[o]);
    o === "true" && (o = !0);
    for (let i = 0; i < r.length; i++) {
      const a = r[i];
      n.hasOwnProperty(a) === !0 ? Array.isArray(n[a]) === !1 ? n[a] = [n[a], o] : n[a].push(o) : n[a] = o;
    }
  }), n;
}("Africa/Abidjan¦a2bouake,daloa,san ped1t0yamoussouk1;g,ogo;ro;b0frica/timbuktu;idjan,obo|Africa/Algiers¦a5b3c2dz,oran,s1t0;ebessa,iaret;etif,idi bel abbes;hlef,onstantine;a0iskra,lida,oumerdas;b ezzouar,tna;lg0nnaba;eria,iers|Africa/Cairo¦a4bani suwayf,c3damanhur,eg2giza,halw6i1kafr ad dawwar,luxor,new c3port said,qina,s0tanta,zagazig;hibin al kawm,ohag,uez;dku,smail6;!ypt;airo;l2s0;w0yut;an; 1exandr0;ia;fayyum,m0;a0inya;hallah al kubra,nsurah|Africa/El_Aaiun¦e0laayoune,western sahara;h,l aaiun|Africa/Ceuta¦ceuta0;!melilla|Africa/Accra¦a2gh1kumasi,ta0;koradi,male;!ana;ccra,tsiaman|Africa/Bissau¦b1g0;uinea b0w;issau|Africa/Nairobi¦africa7e2kisumu,m1na0thika,yt;irobi,kuru;ayotte,ombasa;. africa standard 3a0ldoret;st0t; africa0ern africa;! 0;time; eastern,/asmera|Africa/Monrovia¦l0monrov1;iber0r;ia|Africa/Tripoli¦a3benghazi,l1misrat4t0zawi2;arhuna,ripoli;ib0y;ya;l khums,z zawiy0;ah|Africa/Casablanca¦a9casablanca,f8kenit7m4oujda angad,rabat,sa2t0;angier,e0;ma5touan;fi,le0;! al jadida;a1ekn3o0;hammedia,rocco;!rrakesh;ra;es;gadir,l hoceima|Africa/Maputo¦beira,c4ma2na1quelimane,z0;imbabwe,w;ca1mpu1;puto,to0;la;entral africa time,himoio|Africa/Windhoek¦africa central,na0windhoek;!mibia0;! standard time|Africa/Lagos¦aYbWcVeUgTiPjOkaMlKmHnFoCport harcourt,sBuAw0zarG;. central africa6a5est0; 0ern1;africa1central0; africa;! 0;s2t3;rCst,t;! s0;tandard t0;ime;gep,muah5yo;a9hagamu,okoto;kFn1w0yo;er5o;do,itsha;g,iger0newi;ia;a0in5ubi;idugu0kurdi;ri;agos,ek0;ki;du0no,tsi0;na;imeEos;badan,jebu ode,k1l0seAwo;a orangun,esa,or6;eAi7ot ekp0;ene;ombe,usau;bute ikorodu,fon alaaye,nugu;alabar,hakwama;auchi,en0;in;b2do1frica western,ku0tani;re; ekiti;a,eoku1u0;ja;ta|Africa/Khartoum¦a6c5el 4k2ny3omdurm1port sud1s0wad medani;d,inga,ud0;an;ass0hartoum,osti;ala;dae2fasher,obeid;at,entral africa;d damaz0l qadarif;in|Africa/Juba¦juba,s0winejok;outh sudan,s|Africa/Sao_Tome¦s0;ao tome,t|Africa/Ndjamena¦chad,n0td;'d0d0;jamena|Africa/Tunis¦sfax,t0;n,unis0;!ia|Africa/Johannesburg¦africa southern,bEcAd9east londBjohannesHk7newcastDp6r5s2tembisa,uitenhage,v1w0za;elkom,itbank;anderbijlpark,ereeniging;ast,o0prings;uth africa0weto;! standard time;andBichards bay,oodepoort;aarl,ietermaritzAort elizabeth,retoria;lerk0ruger0;sdorp;iepsloot,urb5;a1enturi0;on;pe town,rletonvil0;le;enoni,loemfontein,o1rakp0;an;ks0tshabelo;burg|America/Argentina/Buenos_Aires¦argentina/buenos aires|America/Argentina/Cordoba¦a0;merica/0rgentina/c1;c0rosario;ordoba|America/Argentina/Salta¦argentina/salta|America/Argentina/Jujuy¦a0;meric0rgentin0;a/jujuy|America/Argentina/Tucuman¦argentina/tucuman|America/Argentina/Catamarca¦a0;merica/0rgentina/c1;argentina/comodrivadavia,c0;atamarca|America/Argentina/La_Rioja¦argentina/la rioja|America/Argentina/San_Juan¦argentina/san juan|America/Argentina/Mendoza¦a0;meric0rgentin0;a/mendoza|America/Argentina/San_Luis¦argentina/san luis|America/Argentina/Rio_Gallegos¦argentina/rio gallegos|America/Argentina/Ushuaia¦argentina/ushuaia|America/Barbados¦b0;arbados,b|America/La_Paz¦bo1cochabamba,la paz,oruro,s0;anta cruz de la sierra,ucre;!livia0t;! time|America/Noronha¦atlantic islands,brazil/den0fernando de noronha standard time,n0;oronha|America/Belem¦ananindeua,belem,macapa,par0;auapebas,á (east) amapá|America/Fortaleza¦ca2fortaleza,imperatriz,j1m0natal,sao luis,teresina;aracanau,ossoro;oao pessoa,uazeiro do norte;mpina grande,ucaia|America/Recife¦caruaru,jaboatao2olinda,p0recife;aulista,e0;rnambuco,trolina;! dos guararapes|America/Araguaina¦araguaina,palmas,tocantins|America/Maceio¦a0maceio;lagoassergipe,racaju|America/Bahia¦bahia,camacari,feira de santa0itabu0salvador,vitoria da conquista;na|America/Sao_Paulo¦a14b0Tc0Md0Je0Hf0Fg0Ahortol09i05j02l01mXnVosasco,pLriFs4ta3uber2v0;i0olta redon18;amao,la velha,tor14;a0Ml06;boao da ser00uba0Y;a2e1oroNu0;maLzano;rXte lago0L;nt4o 0;bernardo do campo,carl03jo0leopolLpaulo,vicE;ao de meriti,se0;! do0; rio p8s camp00;a 1o0; andDs;barbara d'oes0Nluz0Rmar0R;beirao 3o0;! 0;cla0de janei0g6ver7;ro;das nev07p0;reto;asso fun8e7iraci6lanalti0Mo4r0;aia g1esidente prud0;en0E;ran0;de;nta grossa,rto aleg0;re;caW;lotYtro0D;do;iteroi,ov0;aJo hamburgo;a1o0;gi das cruzSntes clarD;ri0ua;l05n6;imei2ondri06;acarei,oinville,u0;iz de fo0ndi9;ra;ndaia2patin1ta0;bor6pevi,quaquece1;ga;tuG;andW;o3ravat2uaru0;ja,lh0;os;ai;iQvernador valadarC;loria5oz do0ran2; iguacu;. south america Gast south ameri0mbu;ca;i0uque de caxi8;adema,vi0;noL;a1o0uriti2;ntagem,tI;choeiro de itapemirBmp1no3rapicui0scavel,xias do sul;ba;in1os dos goytacaz0;es;as;a9e5lumenau,r0;!a0st,t;silia1zil0;!/east;! 0;standard time;l1t0;im;ford roxo,o horizon0;te;rueri,uru;lvora4merica3na2parecida de goi0;an0;ia;polis;na;da|America/Campo_Grande¦campo grande,mato grosso do sul|America/Cuiaba¦cuiaba,mato grosso,varzea grande|America/Santarem¦pará (west),santarem|America/Porto_Velho¦porto velho,rondônia|America/Boa_Vista¦amazon1boa vista,central brazil0roraima;!ian0;! standard time|America/Manaus¦am0brazil/west,manaus;azonas (east),t|America/Eirunepe¦a0eirunepe;cre standard time,mazonas (west)|America/Rio_Branco¦a0brazil/a0rio branco;cre|America/Nassau¦b0nassau;ahamas,s|America/Belize¦b0;elize,z|America/St_Johns¦canada/newfoundland,n0st johns;d2ewfoundland0st,t;! 0;labrador (southeast),standard time;dt,t|America/Halifax¦a2canada/atlantic,halifax,n1p0;ei,rince edward island;ew brunswick,ova scotia;dt,st,tlantic0;! - ns (most areas) pe|America/Glace_Bay¦atlantic - ns (cape breton),glace bay|America/Moncton¦atlantic - new brunswick,moncton|America/Goose_Bay¦atlantic - labrador (most areas),goose bay|America/Blanc-Sablon¦ast - qc (lower north shore),blanc sablon|America/Toronto¦america/moBb9ca7eastern - onqc (most areas),gatineau,hamilAkitchener,l4m3nepe2o0quebec,richmond hill,toronto,vaugh2windsor;n5sh0tt0;awa;an;arkham,ississauga,o7;av7on0;don on0gueuil;tario;!nada0;!/eastern;arrie,ramp0;ton;ntre0;al|America/Nipigon¦nipigon|America/Thunder_Bay¦eastern - on (thunder bay),thunder bay|America/Iqaluit¦eastern - nu (most east areas),iqaluit|America/Pangnirtung¦eastern - nu (pangnirtung),pangnirtung|America/Atikokan¦atikokan,est - on (atikokan) nu (coral h)|America/Winnipeg¦c0m1winnipeg;anada/central,entral - on (west) m0;anitoba|America/Rainy_River¦central - on (rainy rft frances),rainy river|America/Resolute¦central - nu (resolute),resolute|America/Rankin_Inlet¦central - nu (central),rankin inlet|America/Regina¦c1regina,saskat0;c1oon;anada/saskatc0st - sk (most areas);hewan|America/Swift_Current¦cst - sk (midwest),swift current|America/Edmonton¦alberta,ca0edmonton,mountain - ab bc (e) sk (w);lgary,nada/mountain|America/Cambridge_Bay¦cambridge bay,mountain - nu (west)|America/Yellowknife¦mountain - nt (central),yellowknife|America/Inuvik¦inuvik,mountain - nt (west)|America/Creston¦creston,mst - bc (creston)|America/Dawson_Creek¦dawson creek,mst - bc (dawson crft st john)|America/Fort_Nelson¦fort nelson,mst - bc (ft nelson)|America/Whitehorse¦canada/yukon,pacific - yukon (south),whitehorse|America/Dawson¦dawson,pacific - yukon (north)|America/Vancouver¦b2canada/pacific,ladn1okanagan,pacific - bc (most areas),surrey,v0yukon;ancouv0ictor2;er;ritish columb0urnaby;ia|America/Santiago¦a7c4iquique,la pintana,puente alto,rancagua,san3t1v0;alparaiso,ina del mar;alca0emuco;!huano; bernardo,tiago;hile1l0oncepcion;!st,t;! (most areas),/continental;ntofagasta,rica|America/Punta_Arenas¦punta arenas,region of magallanes|America/Bogota¦armenGbBc7dosquebradas,floridablanca,i6m5neiva,p3s1v0;alledupar,illavicencio;anta marCincelejo,o0;acha,ledad;a0erei9opayan;lmi8sto;anizales,edellin,onterA;bague,taguei;a2o0ucu6;!lombia0st,t;! standard time;li,rtagena;arran3ello,ogo2u0;caramanga,enaventu0;ra;ta;cabermeja,quilla;ia|America/Costa_Rica¦c0;osta rica,r|America/Havana¦arroyo naranjo,b7c2diez de octubre,guantan9h1las tunas,pinar del rio,sant0;a clara,iago de cuba;avana,olguin;amaguey,i2u0;!ba0;! standard time;e0udad camilo cie0;nfueg1;ay1oyer0;os;amo|America/Curacao¦curacao,s0;t maarten,x|America/Santo_Domingo¦bella vista,do5la romana,san0; pedro de macoris,t0;iago de los caballeros,o domingo0;! 0;e0oe0;ste;!minican republic|America/Guayaquil¦cuenca,ec1guayaquil,ma0quito,santo domingo de los colorados;chala,nta;!uador0;! 0;(mainland),time|America/Cayenne¦cayenne,french guiana1gf0;!t;! time|America/Nuuk¦america/godthab,nuuk|America/Danmarkshavn¦danmarkshavn,national park (east coast)|America/Scoresbysund¦e1greenland eastern,scoresbysund0;!/ittoqqortoormiit;ast greenland1g0;st,t;! standard time|America/Thule¦thule0;!/pituffik|America/Guatemala¦g0mixco,villa nueva;t,uatemala|America/Guyana¦g0;eorgetown,uyana1y0;!t;! time|America/Tegucigalpa¦h0san pedro sula,tegucigalpa;n,onduras|America/Port-au-Prince¦c2p0;etionville,ort 0;au prince,de paix;arrefour,roix des bouquets|America/Jamaica¦j1k0new k0;ingston;amaica,m|America/Martinique¦m0;artinique,q|America/Mexico_City¦a0Gb0EcVduran09ecatepec de morel07guQhPiNjalis0Ileon de los alda03mInHoGpEqDs9t4uruap01v2x1yucat01za0;catec09pop00;alapa de enriqu0Ki0Gochimil0G;e0illahermosa;nustiano carranza,racruz;a3e7la1o0uxt00;luRnaZ;huac,l0quepaque,xcaY;nepantXpT;bas09maulip01pachuW;an0oledad de graciano sanch0C; luis potosi,t0;a maria chimal0iago de q1;huN;ueretaD;achuca de soFoza rica de6ue0;bPrto vallarZ;axaGjo de agua;aucalpan02icolas rome9uevo le01;agdalena contrerRexico3i1orel0x;ia,os;choFguel0; h3;! city,/general;rap5xtapalu9zta0;cSpalapa;idalJ;a1erre0stavo adolfo made0;ro;dalajara,naj0;ua0;to;eFhiCiudad Ao3u0;au1ernava0;ca;htemoc,titlan izcalli;a4l2yo0;ac0;an;i0onia del valle;ma;cChui0tzacoalc2;la;lopez mate0nezahualcoyotl;os;ap1lpancin0;go;as;laya,ntral 0;mexic0time;an,o;enito6uenavis0;ta;capulco3guascalientes,lvaro obreg2zcapotz0;al0;co;on; de0; juar0;ez|America/Cancun¦cancun,eastern standard time - quintana roo|America/Merida¦c0merida;ampeche,entral time - campecheyucatán|America/Monterrey¦c5g4mon3sa1t0victoria de durango;ampico,orreon;ltillo,n0; nicolas de los garza,ta catarina;clova,terrey;omez palacio,uadalupe;entral time - durango coahuilanuevo leóntamaulipas (most areas),iudad 0;apodaca,general escobedo,madero,victoria|America/Matamoros¦central time us - coahuilanuevo leóntamaulipas (us border),heroica m0m0nuevo laredo,reynosa;atamoros|America/Mazatlan¦culiac1los mochis,m0tepic;azatl0exico/bajasur,ountain time - baja california surnayaritsinaloa;an|America/Chihuahua¦chihuahua,m0;exic1ountain 0;mexico,standard time (mexico),time - chihuahua (most areas);an pacific standard time,o pacific|America/Ojinaga¦ciudad juarez,mountain time us - chihuahua (us border),ojinaga|America/Hermosillo¦ciudad obregon,hermosillo,mountain standard time - sonora,nogales|America/Tijuana¦america/e1e1mexic0pacific time us - baja california,tijuana;ali,o/bajanorte;nsenada|America/Bahia_Banderas¦bahia0central time - bahía de0; banderas|America/Managua¦man1ni0;!car0;agua|America/Panama¦pa0san miguelito;!nama|America/Lima¦arequiAc6huanc9i5juliaca,lima,p2sant1t0;acna,rujillo;a anita   los ficus,iago de sur5;e0iura,ucall7;!ru0t;! standard time;ca,quitos;allao,hi1us0;co;cl0mbote;ayo;pa|America/Miquelon¦m8p6s0;aint pierre1t0; pierre a3. pierre & miquelon s2;! 0;a1s0;tandard time;nd1;ierre0m; m0;iquelon|America/Puerto_Rico¦atlantic standard time,bayamon,p0;r,uerto rico|America/Asuncion¦asuncion,c3p0san lorenzo;araguay1y0;!st,t;! standard time;apiata,iudad del este|America/Paramaribo¦paramaribo,s0;r1uriname0;! time;!t|America/El_Salvador¦el1s0;an0oyapango,v; salvador|America/Grand_Turk¦grand turk,t0;c,urks and caicos|America/Port_of_Spain¦america/virg0port of spa0;in|America/New_York¦a0Pb0Mc0Fd0Ee0Af06g04hialeah,i01jZkYlexingtonXmTnMoKpIquHrDsAt7u5v3w0yonkers;ashington1est 0inston salem,orcD;raEvirgin03;! dc;ermont,irginia0;! beach;nited states,s0;!/0J;a0enne1he bronx,oleD;llaha0mpa;ssee;outh 1t0;. petersburg,aten3;bo0AcC;a2hode1ichmo04och0;ester; is01;lei2;eens,intana roo;ennsylvanMhiladelphMittsbur0rovidence;gh;hio,rlan0;do;ew3or1y0;!c;folk,th c0;aroliD; 0ark,port news;hampshiWje8york0;! staS;a1eads,i0;ami,chig1;ine,nhatt0ryLssachusetts;an;! fayetN;entucky,nox9;acks2e0;rsey;ndia1r0;on5;na;eorg0reensboro;ia;ayette1l0ort lauderda2;!orida;vil0;le;ast0dt,st; flatbush,ern0;! 0;(most areas),standard time;elawa9urham;ape coral,h3incinnati,leve1o0;lumbus,nnecticut;la0;nd;a0esapeake;rlot0ttanooga;te;altimo1o0rooklyn,uffalo;st3;re;kr1merica 0tlanta;eastern;on|America/Detroit¦detroit,eastern - mi (most areas),grand rapids,us/michigan|America/Kentucky/Louisville¦america0kentucky0;/louisville|America/Kentucky/Monticello¦kentucky/monticello|America/Indiana/Indianapolis¦americ0indian0us/east-indiana;a/indianapolis|America/Indiana/Vincennes¦indiana/vincennes|America/Indiana/Winamac¦indiana/winamac|America/Indiana/Marengo¦indiana/marengo|America/Indiana/Petersburg¦indiana/petersburg|America/Indiana/Vevay¦indiana/vevay|America/Chicago¦aVbScQdPfort worth,gOhNiLkZlImBn7o6plano,s3t1us/02wi0;chiFsconsV;ex0ulsa;!as;a0hreveport,ou4t 1;int 0n antonio;louGpaul;klahoWmaha,verland park;ashLe1or0;th dako7;braska,w 0;orleans,south me6;adisMe5i1o0;biHntgomery;lwaukee,nne1ss0;issippi,ouri;apol6so0;ta;mph4;aredo,i0ouisiana,ubb1;ncoln,ttle r0;ock;llino0owa,rving;is;oustAunts5;arland,rand prairie;allAes moines;dt,entral0hicago,orpus christi,st;! (most areas);aton rouge,rowns0;vil0;le;laba7m5r1ust0;in;k1lingt0;on;ans0;as;arillo,erica 0;central;ma|America/Indiana/Tell_City¦indiana/tell city|America/Indiana/Knox¦indiana/knox,us/indiana-starke|America/Menominee¦central - mi (wisconsin border),menominee|America/North_Dakota/Center¦north dakota/center|America/North_Dakota/New_Salem¦north dakota/new salem|America/North_Dakota/Beulah¦north dakota/beulah|America/Denver¦a1colorado springs,denver,el paso,m0navajo,salt lake,us/mountain;dt,ountain (most areas),st;lbuquerque,merica/shiprock,urora|America/Boise¦america mountain,boise,mountain0;! 0;- id (south) or (east),standard time|America/Phoenix¦a8c7g5idaho,m4n3phoenix,s2t1u0wyoming;s/a7tah;empe,ucson;cottsd3inaloa,onora;ayarit,ew mexico;aryv1esa,onta4st - arizona (except navajo);ilbert,lend0;ale;handler,olorado;rizo0;na|America/Los_Angeles¦aZbaXcVfRgarden grove,hOirviNlJmoGnFoCp8r7s0tacoma,us/00washington state;a1eattle,f,p0tocktPunrise manor;okaLringF;cramenFn0; 1ta 0;aPclariR;bernardiNdiego,fran0jo4;!cisco;ancho cucamonga,eLiver5;a0dt,ort5st;cific1radi0;se;! standard time;ak1cean0regDxnard;side;land;evada,orth las6;des1reno0; valley;to;a1o0;ng4s angeles;!s0; vegas;ne;enders1untington0; beach;on;onta2re0;mont,s0;no;na;a2hula vis0;ta;ja ca0kersfield;lifornia;merica 0naheim;pacific|America/Anchorage¦a0us/alaska;h4k4laska0nchorage;! 1n0;! s1;(most areas),s0;tandard time;dt,st|America/Juneau¦alaska - juneau area,juneau|America/Sitka¦alaska - sitka area,sitka|America/Metlakatla¦alaska - annette island,metlakatla|America/Yakutat¦alaska - y0y0;akutat|America/Nome¦alaska (west),nome|America/Adak¦a0hawaii standard time,us/aleutian;dak,leutian islands,merica/atka|America/Montevideo¦montevideo2u0;ruguay1y0;!st,t;! standard time|America/Caracas¦alto barinJbarIcCguaAm7p6san5turmeEv0;alencia,e0;!nezuela0t;! 0n;standard t0t0;ime; cristobal,ta teresa del tuy;eta4uerto la cruz;a0ucumpiz;raca0turin;ibo,y;ren8ti0;re;a4iudad 2o1u0;a,m2;ro;bolivar,guay0;ana;bim1rac1;in0quisimeto,uta;as|Asia/Dubai¦a4dubai,g2musaff1om0ras al khaim1sharj1;!an;ah;st,ulf0;! standard time;bu dhabi,jman|Asia/Kabul¦af1herat,jalalabad,ka0mazar e sharif;bul,ndahar;!ghanistan0t;! 0;standard t0t0;ime|Asia/Yerevan¦a0caucasus1yerevan;m,rmenia0;! standard time|Asia/Baku¦az0baku,ganja,lankaran,sumqayit;!erbaijan0t;! standard time|Asia/Dhaka¦asia/dacca,bDcBd9jess8khul7mymensingh,na4pa3ra2s1t0;angail,ungi;aid8hib4ylhet;jshahi,ng7;b3ltan,r naogaon;gar5r0t3;ayan0singdi;ganj;na;ore;haka,inaj0;pur;hattogram,o0;milla,x's bazar;a0d,ogra;gerhat,ngladesh0rishal;! standard time|Asia/Brunei¦b0;dt,n1runei0;! darussalam time;!t|Asia/Thimphu¦asia/thimbu,b0thimphu;hutan0t;! time|Asia/Shanghai¦0:3I;1:38;2:36;3:39;4:3C;a3Eb31c2Nd2He30f2Cg26h1Qji1Ek1Bl0Ym0Wn0Tordos,p0Pq0Lrizh10s08t01wSxLyEz5;aoCh6i5ouc3unyi;bo,go0;a7en6ouk2u5; c3h33maWzh2;g2Vj1Izh2;b1Ung5o3D;jiakou5zh2;! shi xuanhua qu;ya0z27;an9i7u5;ci,e18n5;c3fu;b4c9n5ya0;cZgk2;c3g5ji,t2S;j17qu1sh16zh2;i6uc5;ha0;a6n5uyi0;di,gt2Nh1Fi0pu,t2Nx13ya0;m17n5;!g5ni0t0Eya0;t1ya0;aBe9u5;h6so0w1Bx5zh2;i,ue;a5u;i,n;i0Hn5;sh1zh2;fang5nxi1;di1;a8i6ong5;chuans0XhDli02sh1;an5eli0;j4sh0Z;i6ng5;gu,sh1;an,hec1Wyu1zh2;anmi0hAi8u5;i5zh2;h5zh2;ua;c5pi0;hu1;a7en6i5uangya14;jiaz15qi,y1;gli,ya0zh0G;n6o5s0I;gu1xi0;g5t2;h1Rqiu,rKyu;i5uan1J;aFn5o14qih0N;g5huangdH;dGh1N;an0Ting7rc,u5;ti1yang5;! H;ding0QxZ;an5eijYingbo;ch5ji0ni0to0ya0;a0o0;entoug2ianRuda5;njU;aEi8u5;anc3o6qi5;ao;he,ya0;a7jPn5upansh01;fTxia 5yi;chengguanI;n0Do5;c3y5;a0u1;i0Wn5ohek2;g5zh2;fa0;ai6un5;mi0sh1;fe0yu1;'1aAe9l4n6u5xi;jCt0W;an,c3g5i0zh2;de5li0zh2;zhE;ya0;musi,n8o5xi0;j6z5;uo;ia0;g5shF;m7xi;aFeBkt,ohhot,u5;a6i0Dlan ergi,m5n1;en;i7ng5y4;ga0s5;hi;'1b8n1;bi,f7ga0ng5ze;sh5ya0;ui;ei;i7n5rb4;d1g5;u,zh2;c3k2l5;ar;a9u5;an6i5li;l4ya0zh2;g5k2;do0yu1zh2;nsu,opi0;en7o6u5;ji1shQx4zh2;sh1;d2g5;hua0;a6eNong5;gu1hT;d6lian5ndo0qi0to0;!g;o5uk2;nghP;angHh5n,t;aAen7i5oYuG;fe0na5;! standard K;g5zh2;d5zho0;e,u;ng6o5;ya0zh2;ch7de,sh6zh5;i,ou;a,u;un;zh2;aBe5;i6n5;gbu,xi;'1h7jing5;! 5;time;ai;i7o5yan nur;di0t2;ou;c3sh1y4;an;he0;nAsia/5;ch6harb4;in;o5ungki0;ng5;qi0;da,qi0sh5ya0;an,un;ng|Asia/Urumqi¦a6changji,huoche5k3shihezi,turp2urumqi,xin1zh0;anjia4ongsh1;jiang time,yu0;an;a0orla;ramay,s2;ng;ksu,ral,sia/kas0;hgar|Asia/Nicosia¦cy0nicosia;!prus0;! (most areas)|Asia/Famagusta¦famagusta,northern cyprus|Asia/Tbilisi¦ge1kuta0tbil0;isi;!orgia0t;! 1n0;! 0;standard time|Asia/Hong_Kong¦h0kowloon,tsuen wan;k2ong0; kong0kong;! standard time;!st|Asia/Jakarta¦bScQdepPiNjKkediri,lJmGpArengasdengklPs4t2w0yogyakM;est0ib; indonesia,ern indonesia time;a0egal;n4sikmal3;ema4itubondo,outh tan3u0;kabumi,medaRra0;b0kF;aya;ge0;raN;a4e1robolinggo,urw0;akAokerto;ka1ma0rcut;laJtangsiantar;long2nbaru;daHl3mulaHruH;a1ed0;an;diun,laE;embaD;a0ember;k0mbi,vasumatra;arta;d,ndonesia0;! western;ok;i0urug;ampea,bino5leungsir,mahi,putat,rebon;a1e0injai,ogor;kasi,ngkulu;nd0tam;a0u1; aceh,r lampu0;ng|Asia/Pontianak¦borneo (westcentral),pontianak,tanjung pinang|Asia/Makassar¦b6c4denpa3indonesia central,k2l1ma0palu,samarinda,wita;kas2nado,taram;abuan bajo,oa jan7;endari,upang;sar;entral indonesia0ity of bal3;! time;a0orneo (eastsouth) sulawesi/celebesbalinusa tengarra timor (west);l0njarmasin;ikpap0;an|Asia/Jayapura¦ambon,east0indonesia eastern,jayapura,new guinea (west papua / irian jaya) malukus/moluccas,wit; indonesia,ern indonesia time|Asia/Jerusalem¦ashdod,beersheba,haifa,i2j0petah tiqwa,rishon leziyyon,tel aviv,west je1;e0mt;rusalem;d1l,srael0;! standard time;dt,t|Asia/Kolkata¦0:3C;1:3K;2:2D;3:3L;4:3I;5:38;a36b2Ec25d1Xe1Vf1Tg1Gh1Di19j14k0Ql0Lm0Dn06odis3KpWquthbull5rOsGtAu9v6warang2Nyamun1Q;a7el1Vi6;jayawa2Wsakha0IzianagD;doda2Prana12;daip0jja24lhasn1ttar pradesh;a9eYh8iru6umk0;chirap0Nnelve2p6vottiy0;a39p0;ane,iruvananthapur0Ooothuku2Zriss0;mb6njo1Y;ar0M;aCecunder4hAi9lst,o8r1Gu6;jan37r6;at,endr1D;l5nip2O;k3liguLngrau2rK;ahj20i6ri2Pya0M;mo1Nvaji08;har1Ylem,mbh25ng2t05ug0Z;a7e0Foh6;iJtak;ebare2iAj8m6nc1Htl0Burke37;ag6g6p0;und09;a6kot;hmund27sth2B;ch0p0;aAimp9roddat0u6;ducher24n6rn18;a6e;sa;ri;li,n8rbha7t6;ia2Vna;ni;chku2Ti6;ha2Gp22;a8e7izam4o6;i1Wwrang5;l0Tw del0Z;di2Kg8i0Fjaf2Fn6re2Oshik,vi mumb16;ded,g6;i,loi j1W;ercoil,p0;a9eerut,irz5o8u6yso0Z;lugu,mb11rwa1Jzaffar6;n1p0;nghyr,rad4;chili8d7harasht1Gleg08n6thu1Gu;ga0Jip0;hya,ur0W;patnH;a8u6;cknow,dhia6;na;l bahadur6t0; n1;aEhaCo9u6;kat7lt6rno1P;a2i;pal2;l6rXta,zhikode;h5ka1Kl6;am;nd6ragp0;wa;kina14l9marPnp0r6shmir,tih3;i7na6ol ba19;l,tW;mn1;lakuric04y12;a7han6odOunagadh;si;b0Sip0l7m6;mu,n1shedp0;andh3gHna;chalkaranji,mph0Jn6st;!d6;ia6o01;! standard time,n;a7is3ospet,u6;b2g2;o0Ip0ridw3;aDhazi4oAreater noi0Nu7wali6y05;or;jar0PlbarRnt0rg7wa6;ha12;aon;rak7sa6;ba;hp0;juw9n6ya;dh7g6;an1;in1;aka;ar6iroz4;id4rukh4;l6taw0M;loG;aBe9h7indigul,ombPurg6;!ap0;anb0Uul6;ia;hra dun,l6was;hi;rbhan6vange9;ga;a09h9o6uttack;ch7imbato6;re;in;a7enn6;ai;nd6pM;a6i0C;!nn1;aOeLhCiAor8rahm5u6;landshahr,rh6;anp0;iv2;li;d3har sharif,j5kan07l6;asp0imoD;aBi8op7u6;baneshw3sav6;al;l7wan6;di,i;ai,wa7;g7ratp0tpa6vn1yand3;ra;alp0;l6ngaluru;gaum,la6;ry;hBli,r7thin6;da;a7ddham6eilly;an;n1s6;at;a7rai6;gh;ramp0;gQhmLizawl,jmKkoRlHmDnant5rrBs7urang4va6;di;ans8ia/ca6;lcut6;ta;ol;ah;ap0;arnath,batt0r6;ava6its3oA;ti;ur;appuz7i6lah4w3;garh;ha;er;adn1ed4;ab6;ad;ag3;ar;arta6ra;la|Asia/Baghdad¦a4ba3dihok,erbil,i2k1mosul,na0ramadi;jaf,sirB;arbala,irkuk,uwait;q,raq;ghdad,sr9;bu ghurayb,d diw6l 5rab0s sulaym6;! 3i0;a0c;!n0;! 0;standard time;amar2basrah al qadim2falluj2hill2kut,mawsil al jadid2;an0;iy0;ah|Asia/Tehran¦aRbNgorgXhamWiKkCmaBn8orumiy7pasragad branch,q4rasht,s2t1varam6yazd,za0;hedWnjW;abHehrV;a0hirSirjU;bzevar,nandEri,v3;a0om;rchak,zv0;in;eh;a0eyshabur;jaf0zar0;ab4;layer,shh3;a4erman3ho0;meyni sErram0wy;ab0sD;ad;!shah;h1r0;aj;riz;r0sfahC;!an0dt,st;! standard time;a2irjand,o0uk9;jnu0ruje0;rd;b3ndar abbas;b4hv3m2r1zads0;hahr;ak,dabil;ol;az;ad0;an|Asia/Amman¦amm1irbid,jo0russeifa,wadi as sir,zarqa;!rd0;an|Asia/Tokyo¦0:11;1:19;a17ch15fu0Ygifu13h0Ni0Hj0EkYmSnLoJsEt8u7waka04y2;a5o2;k2no;kaic1Ao2;ha0Xsu0;maJo;ji,tsun0E;aka6o2sukuba;k4makom04y2;a0So2;hNna0ta;oro02us0Pyo04;m0Irazu0sa1tsu1;a4endZhi3o0u2;i0Yzu0;monose1zuo0;ita0Lk2ppoKsebo;ai,u05;dawa04i0Uka2sa0t0D;ya0Iza1;a5eyaga0Oi2umazu;i3shi2; tokyo0Hnomiya ha0F;ga0P;g2ha,ra0F;a2oW;no,o0sa1;a4i2orio0;na2to,yaza1;mirinkan,to;chiCeb3tsu2;do,m7ya06;as0H;aAi8o6u2y5;mam4r3shi2;ro;ashi1e,uG;oto;be,c0Bfu,ri2shigaJ;yaY;shiwa2takyushu;da;gosUkogawacho honmJmirenjaku,na7s4wa2;g2sa1;oe,uc05;hiZu2;g2kabe;ai;zaW;apan2dt,oetIp,st;! standard ti2;me;bara1chi3ta2wa1zu2;mi;ha4n2;omi2;ya;ra;a7i2oncho;meAr3t2;acP;a3os2;a1hiB;kaLtsu0;chi4kodate,mam2;at2;su;nohe,o2;ji;ji7ku2;i5o0s2ya3;hi2;ma;ka; sB;!sa5;i2ofu;ba,g4;geoshimo,k5mag3njo,omori,sahika2tsugi;wa;asa1;ki;as3i2;ta;hi|Asia/Bishkek¦bishkek,k0osh;g2yrgy0;stan,zstan0;! time;!t|Asia/Pyongyang¦chongjin,h5k3n2pyongya8s0won6;ariw0inui8unch'0;on;amp'o,orth korea;a0p;eso3nggye;a1ungnam,ye0;san;e1mhu0;ng;ju|Asia/Seoul¦anPbuMchHdaeGgChwaseoQiBjeAk7m6pohaFrok,s2u1wonJy0;aCeosu;ijeongbuPlsL;e1outh korea,u0;nEwH;joAo0;ngnamLul;asGokpo;imhae,orea0r,st,wangmyo7;! 0n 0;standard time;ju,on8;cCksBn6;angneu2oyaDu1wa0;ng5;mi,ns8riC;ng;gu,je4;angw3eon2in1un0;che2;ju;an,gju6;on;c1s0;an;heon2;san1ya0;ng0; si|Asia/Almaty¦a8central asia6east kazakhstan7k2nur sultan,p1s0taraz,ust kamenogorsk;emey,hymkent;avlodar,etropavl;a0z;ragandy,zakhstan0;! 0;(most areas),eastern;! standard0; time;lm0stana;aty,t|Asia/Qyzylorda¦kyzyl1qyzylorda0;!/kyzylorda/kzyl-0;orda|Asia/Qostanay¦k0q0;ostanay|Asia/Aqtobe¦a0;k1qt0;o1öbe/ak0;to0;be|Asia/Aqtau¦a1kazakhstan western,mangghystaū/mankis2west asia0;! standard3;lma1q0;tau; ata,-ata0; time|Asia/Atyrau¦atyra0;u,ū/atirau/gur'yev|Asia/Oral¦oral,west kazakhstan|Asia/Beirut¦bei2e1l0ra's bay2;b,ebanon;astern european standard time,urope eastern;rut|Asia/Colombo¦colombo,dehiwala mount lavinia,lk,moratuwa,sri lanka|Asia/Yangon¦asia/rango3b2kyain seikgyi township,m0nay pyi taw,pathein,sittwe,yang3;a0eiktila,m,onywa,yanmar;ndalay,wlamyine;ago,urma;on|Asia/Ulaanbaatar¦m2ula0;anbaatar0n bator,t;! standard time;n,ongolia0;! (most areas)|Asia/Hovd¦bayan-ölgiigovi-altaihovduvszavkhan,hov3w0;. mongolia 4est0; 0ern 0;mongolia;d0t;! 0;standard time|Asia/Choibalsan¦choibalsan,dornodsükhbaatar|Asia/Macau¦asia/macao,m0;acau,o|Asia/Kuala_Lumpur¦alor setar,bukit mertajEgeorge town,ipoh,johor bahDk8m4petali3s0taipiC;e1hah alDu0;ba1ngai petani;pa9remb7;ng jaya;ala0y;cca,ysia0;! 0;(peninsula),time;ampung baru suba3la3ota bha4ua0;la 1nt0;an;lumpur,terengganu;ng;ru;am|Asia/Kuching¦k2miri,s0tawau;a0ibu;bahsarawak,ndakan;ota kinabalu,uching|Asia/Kathmandu¦asia/kat3biratnagar,kath3n1p0;atan,okhara;epal,p0;!t;mandu|Asia/Manila¦an04bWcRdaPgeneral santOiMlJmCnaBoAp4quezIsan1ta0zamboanga;clobZguig,rlac,ytE; 1t0;a ro2ol;fernando,jose del monte,pab01;a3h1uerto prince0;sa;!ilippine0t; standard time,s;gadiRnalanoy,s0;ay,ig;longapo,rmoc;ga,votQ;a0eycauayN;balacat,gugpo poblaci4kati,l3n0;da1ila,silingLtamp0;ay;luyong,ue;ingDol6;on;a1egaspi,i0ucena;bertad,pa;pu lapu,s p4;l0mus;igCoiH;os;smar0v5;inB;a0ebu,otabato;b1gayan de oro,in5l0;amba,ooc6;anatu5uy0;ao;a4inan2u0;d0tu2;ta;!gon0;an;co1guio,tang0;as;lod,or;geles,tipo0;lo|Asia/Karachi¦bKchiniJdera ghaziHfaisalGgujraFhyderGislamGjhang sadr,kDlaCm7nawabshah,okaAp4quetta,ra3s0;a1h0ialkIukkM;ahkHekhupu8;ddiqDhiwal,rgodha;him yarDwalpindi;akistan1eshawar,k0;!t;! standard time;a3i1u0;lt9zaffar7;ngo0rpur khas;ra;lir cantonment,rd6;hore,rkana;a0otli;moke,rachi,s8;n5t;abad; kh0;an;ot;a1himber,ure0;wala;hawalp0ttagram;ur|Asia/Gaza¦gaza1p0;alestine,s;! strip|Asia/Hebron¦east jerusalem,hebron,west bank|Asia/Qatar¦ar rayyan,doha,qa0;!tar|Asia/Yekaterinburg¦chelyabin7eka5k4magnitogor7nizhn3or2perm,s1tyumen,ufa,yek0zlatoust;a4t;terlitamak,urgut;enburg,sk;evartov3y tagil;amensk ural'skiy,urgan;terinburg0;! standard time;sk|Asia/Omsk¦oms0;k0t;! standard time|Asia/Novosibirsk¦n0siber4;. central asia 4o0;rth central as2v0;osibirsk0t;! 1;ia;standard time|Asia/Barnaul¦b0;arnaul,iysk|Asia/Tomsk¦tomsk|Asia/Novokuznetsk¦kemerovo,novokuznet0prokop'yev0;sk|Asia/Krasnoyarsk¦kra0north asia1;snoyarsk0t;! standard time|Asia/Irkutsk¦angar2brat2irk0north asia east1ulan ude;t,utsk0;! standard time;sk|Asia/Chita¦chita|Asia/Yakutsk¦blagoveshchensk,yak0;t,utsk0;! standard time|Asia/Khandyga¦khandyga|Asia/Vladivostok¦k2vla0;divostok0t;! standard time;habarovsk0omsomolsk on amur;! vtoroy|Asia/Ust-Nera¦ust nera|Asia/Magadan¦mag0;adan0t;! standard time|Asia/Sakhalin¦sak0yuzhno sakhalinsk;halin0t;! standard time|Asia/Srednekolymsk¦chokurdakh,sre0;dnekolymsk0t;! standard time|Asia/Kamchatka¦kamchatka,pet0;ropavlovsk0t; kamchatsky,-kamchatski standard time|Asia/Anadyr¦ana0;dyr0t;! standard time|Asia/Riyadh¦a6burayd5dammam,ha4jedd5khamis mushait,me3najran,riyadh,sultan5ta2y0;anbu,e0;!men;'if,buk;cca,dina;'il,far al batin;ah;bha,l 0;hufuf,jubayl,kharj,mubarraz|Asia/Singapore¦s0woodlands;g1ingapore0;! standard time;!t|Asia/Damascus¦a4d3h2latak1sy0;!r0;ia;am2oms;amascus,eir ez zor;leppo,r raqq0;ah|Asia/Bangkok¦bangkok,ch8h6indochina3mueang nontha9na2pak kret,s0udon thani;amut prakan,e asia0i racha,outh east asia;! standard t3;khon ratchasima,m dinh;! 0;(most areas),t0;ime;a0ue;iphong,noi,t y2;iang m1on 0;buri;ai|Asia/Dushanbe¦dushanbe,t0;ajikistan1j0;!t;! time|Asia/Dili¦dili,east timor1tl0;!t;! time|Asia/Ashgabat¦as4t0;m2urkmen0;a3istan0;! standard time;!st,t;hga0ia/ashkhabad;bat|Asia/Taipei¦banqiao,h7k5roc,t0;a0w;i0oyu2;ch3n1pei0w1;! standard time;an;aohsi0eel0;ung;sinchu,ualien|Asia/Samarkand¦bukhara,nukus,qarshi,samarkand,uzbekistan 0;(west),standard time|Asia/Tashkent¦andij2namangan,qo`q2tashkent,uz0;!bekistan0t;! (east);on|Asia/Ho_Chi_Minh¦asia/saig4bien hoa,can tho,da 2ho chi minh,nha tr3qui nh4rach gia,sa dec,thi xa phu my,v0;ietnam0n,ung tau;! (south);lat,n0;ang;on|Atlantic/Bermuda¦b0;ermuda,m|Atlantic/Cape_Verde¦c0;a1v0;!t;bo verde,pe verde0;! standard time|Atlantic/Canary¦canary0las palmas de gran canaria,santa cruz de tenerife;! islands|Atlantic/Stanley¦f0stanley;alkland1k0;!st;! island0;!s0;! summer time|Atlantic/Faroe¦atlantic/faeroe,f0;aroe0o;! islands|Atlantic/South_Georgia¦gs,south georgia0;! time|Atlantic/Reykjavik¦i0reykjavik;celand,s|Atlantic/Madeira¦madeira0;! islands|Atlantic/Azores¦azo0hmt;res0st,t;! standard time|Australia/Lord_Howe¦australia/lhi,l0;h2ord howe0;! 0;island,standard time;dt,st|Australia/Hobart¦australia/1hobart,tasmania0;! (most areas);currie,tasmania|Australia/Melbourne¦australia/victoria,geelong,melbourne|Australia/Sydney¦au0c4new south wales (most areas),sydney,wollongong;!s0; east3tralia0;! eastern,/0n eastern 4;act,c0nsw;anberra;!ern0;! 0;standard time|Australia/Broken_Hill¦australia/yancowinna,broken hill,new south wales (yancowinna)|Australia/Brisbane¦a1brisbane,gold co3logan,queensland0townsville;! (most areas);e2ustralia0;/queensland,n e0;ast;dt,st|Australia/Lindeman¦lindeman,queensland (whitsunday islands)|Australia/Adelaide¦a2cen0south1;. australia 4tral0; australia;c3delaide,ustralia0; central,/south,n central0;! 0;standard time;dt,st|Australia/Darwin¦australia/north,darwin,northern territory|Australia/Perth¦a3perth,w0;. australia6est0; australia,ern australia0;! (most areas);ustralia1w0;dt,st; western,/west,n west0;!ern0; standard time|Australia/Eucla¦a0cw5eucla,western australia (eucla);cw6us0; central w2tralia0; centralwestern,n central western0;! 2;. 1e0;st;standard time;dt,st|Indian/Cocos¦c0;c3ocos0;! island0;!s0;! time;!t|Indian/Christmas¦c0;hristmas1x0;!t;! island0;! time|Indian/Chagos¦british indian ocean territory,c4i0;ndian 1o0;!t;c1ocean0;! time;hagos|Indian/Mauritius¦m0port louis;auritius1u0;!t;! standard time|Indian/Maldives¦m0;aldives1v0;!t;! time|Indian/Reunion¦r0;e1éunion0; time,crozetscattered islands;t,union|Indian/Mahe¦mahe,s0;c,eychelles0;! time|Indian/Kerguelen¦french southern2kerguelen1tf0;!t;!st paul islandamsterdam island;! 0;& antarctic time,and antarctic0;! lands|Europe/Andorra¦a0;d,ndorra|Europe/Tirane¦al1tiran0;a,e;!bania|Europe/Vienna¦a0donaustadt,favoriten,graz,linz,vienna;t,ustria|Europe/Brussels¦antwerpen,b0charleroi,gent,liege;e0russels;!lgium|Europe/Sofia¦b0plovdiv,sof2varna;g,u0;lgar0rgas;ia|Europe/Minsk¦b2h1m0viteb3;ahilyow,in2;omyel,rodna;abruy0elarus,rest,y;sk|Europe/Zurich¦geneve,li0swiss time,zurich;!echtenstein|Europe/Prague¦brno,ostrava,prague,s0;k,lovakia|Europe/Berlin¦a00bScQdOeMfrLgeJhaEkClAm4n3oberhaus04rostoBs1w0;andsbek,iesbad03uppert8;a0tuttgaL;arbrueck01xony;eue neustadt,uernbeY;a3e2iddle european,oenchengladba1u0;enst9ni0;ch;st,t;gdeSinz,nnheim,rienth0;al;eipzJuebe0;ck;a0iKoeln,rL;rlsruhe,ssJ;gPlle (saale),m1nnov0rM;er;burg0m;! 0;mitte,nord;lsenkirJrmany0;! (most areas);ankfurt am maDeiF;imsbuettArfu0ssH;rt;e,ortmund,resdFu0;esseldorf,isB;e0hemnitz;ntral europe,st,t;avaria,erl6iel5o2r0;aunschwe0emA;ig;chum0nn;! hord0;el;efeld;in;a2ltona,ugs0;bu0;rg;ch0;en|Europe/Copenhagen¦arhus,copenhagen,d0;enmark,k|Europe/Tallinn¦e0tallinn;e,stonia|Europe/Madrid¦aMbJcHeGfuenDgCjerez de la frontera,lBm8ovieFp6s1terrassa,v0zaragoza;alladol9igo;a1evilla,pain0;! (mainland);badell,n0; sebastian,t0; marti,ander,s montjuic;a0uente de vallecas;lma,mpD;a0ostolGurcF;dr0laga;id;atiEeganD;asteiz / vitorBijon,ran1;carral el par1labr0;ada;do;ixample,lche,s;a0iudad lineal;rabanchel,stello de la pla7;a0ilbao,urgos;da0rce0sque;lo4; coru3l0;cala de henar1icante,mer0;ia;es;na|Europe/Helsinki¦espoo,fi1helsinki,t0vantaa;ampere,urku;!nland|Europe/Paris¦bordeaux,ceDeurope central,frBl9m8n6paris,r3s0toulouE;aint 1t0; 0rasbourg;etienne;e1omance0;! A;ims,nn1;ant0i5ormandy;es;arsei1ontpellier;e havre,i0yon;lle;!an0;ce;ntral european 1rgy pontoi0;se;standard time|Europe/London¦a0Hb05c02dZeXgUhSiPjeOkingston upon hull,lJmHnBoxTp9reading,s1w0yF;arwick05igan,olverha7;heffield,o3t2u1w0;an4iH;ffolk,nderland,sUttM;afOoke on tre05;meUuth0;a1end on 0;sea;mptH;ly0orts0restG;mouth;ew4o0;r0ttinghamO;th0wD; y0amptonM;orkQ;castle upon tyne,port;ancheLi0;dlan4lton keynes;ancaMdn,e2i1o0ut6;nd5;ncolnKverP;e0icesterE;ds;!rsQ;psw1slingt0;on;ich;ampDert0;fordC;b1l0mt standard time;asgow,oucesterA;!-eA;dinburgh,s0urope/belI;sex;erby1o0udlF;rset;!sh5;a1ity of westmin0oventry,rawlC;ster;mbridge1rdiff;e8ir7lack5r2st,uckingham0;sh0;ire;adford,e1i0;st2tish;nt;po0;ol;kenhead,mingham;l1xl0;ey;fast;berdeen,rchway|Europe/Gibraltar¦gi0;!braltar|Europe/Athens¦athens,gr0thessaloniki;!eece|Europe/Budapest¦budapest,debrecen,hu0;!ngary|Europe/Dublin¦cork,dublin,eire,i0;e,reland|Europe/Rome¦b9c8florence,genoa,m7naples,p4rome,sicily,t2v0;a0eroA;!tican city;aran2rieste,u0;rin,scany;a1ra0;to;dova,lermo;essi3ilan;atan1orsica;ari,olog1resc0;ia;na|Europe/Vilnius¦k1l0vilnius;ithuania,t;aunas,laipeda|Europe/Luxembourg¦lu0;!xembourg|Europe/Riga¦e1kalt,l0riga;atvia,v;ast europe,e0;st,t|Europe/Monaco¦m0;c,onaco|Europe/Chisinau¦chisinau,europe/tiraspol,m0;d,oldova|Europe/Malta¦m0;alta,t|Europe/Amsterdam¦a3eindhov2groning2n1rot4t0utrecht;he hague,ilburg;etherlands,l;en;lmere stad,ms0;terdam|Europe/Oslo¦berg1oslo,s0;j,valbard and jan may0;en|Europe/Warsaw¦bDczestochowa,g9k7l5mokot8p3radFs2torun,w0zabrze;ars0rocl0;aw;osnowiec,zczec3;l,o0raga poludnie;land,znan;odz,ubl0;in;ato2iel3rak0;ow;d2li0;wi0;ce;ansk,ynia;i2y0;dgoszcz,t0;om;alystok,elsko biala|Europe/Lisbon¦amadora,europe western,lisbon,p2we0;st0t;! europe,ern european standard time;ort0t;o,ugal0;! (mainland)|Europe/Bucharest¦b3c2gala1iasi,oradea,ploies1ro0timisoara;!mania;ti;luj napoca,onstanta,raiova;ra0ucharest;ila,sov|Europe/Belgrade¦belgrade,n1pristina,s0;i,lovenia;is,ovi sad|Europe/Kaliningrad¦kaliningrad|Europe/Moscow¦ar0Cb09c06dzerzh05fet,grozn04ivano03kXlipet0EmQnMorel,pJrFs8t6v2w-su,y0zelenograd;a0oshkar oV;roslavl,sene01;asyl'evsky ostrHelikiLladi2o0ykhino zhulebS;l0ronezh;gograOogda;kavkaz,m07;a0uPver;ganrog,mbC;a4ever3hakhty,molen05ochi,t0yktyvkQ; 4a0;ryy osk0vrop0;ol;nRodvS;int 0rW;petersburg;ostov na donu,u1y0;azKbO;!ssia0;!n9;e1odolUsk0;ov;nza,trozavodS;a2izhn0ovorossiyR;ekamQi0;y novM;berezhnyye chelny,l'chik;a3dst,oscow1s0urmJ;d,k;! standar0;d time;khachka1r'0;ino;la;a2himki,ostroma,rasno0urG;d0gvargeisky;ar;l1z0;an;ininsk5uga;vo;yy;in8;entraln1he0;boksary,repovets;iy;el1ry0;an3;gorod;khangel'1mav0;ir;sk|Europe/Simferopol¦simferopol|Europe/Kirov¦kirov|Europe/Volgograd¦vol0;gograd,t,zhskiy|Europe/Astrakhan¦astrakhan|Europe/Saratov¦balakovo,saratov|Europe/Ulyanovsk¦ulyanovsk|Europe/Samara¦izhevsk,s0togliatti on the volga;am0yzran;ara0t;! standard time|Europe/Stockholm¦goeteborg,malmoe,s0;e,tockholm,weden|Europe/Istanbul¦a00bUcSdQeNgMiKkImDosmCs6t1u0v07zeytinburnu;eskuedYmrB;arsus,r3urkey0;! 0;standard t0t0;ime;!abzon,t;a3i1ultan0;beyJgazi;sIv0;as,erek;msun,n0;cakt5liurfa;aniye;a1er0uratpaH;kezefendi,sin;l0niF;atOt0;epe;a0irikkale,onMutahM;hramanmaras,rabaglFyseP;stanbul,zmi0;r,t;aziantep,ebze;lazig,rzurum,s0;en0kiC;l8yurt;eniz0iyarbakB;li;ankaCor0;lu,um;a1ur0;sa;gcil2hcelievl1likes5sak4t0;ikent,m9;er;ar;d5n2rnavutkoey,ta0;seh0;ir;kara,ta0;k0l0;ya;a1iyam0;an;na,paza0;ri|Europe/Kiev¦bila tserkHcherEdChorlBivano frankivDk7l6m4odessa,poltaHrivne,sumy,ternopil,u2vinnyts1z0;aporizhzh0hytomyr;ya;a,kraine0;! (most areas);a0ykolayB;ki5riupol;ut6v9;amyanske,h1iev,r0y8;emenchuk,opyv1yvyy rih;ark6erson,mel0;nytskyy;ivka;nipro,onet0;sk;kasy,ni0;h0vtsi;iv;va|Europe/Uzhgorod¦ruthenia,uzhgorod|Europe/Zaporozhye¦luhansk,sevastopol,zaporozh0;'ye/zaporizhia lugansk/luhansk (east),ye|Antarctica/Casey¦casey0;! time|Antarctica/Davis¦a1davis0;! time;ntarctica,q|Antarctica/DumontDUrville¦dumont0;-d0d1;'0’urville time;urville|Antarctica/Mawson¦mawson0;! time|Antarctica/Palmer¦chile standard time,palmer|Antarctica/Rothera¦rothera|Antarctica/Syowa¦syowa0;! time|Antarctica/Troll¦troll0;! research station|Antarctica/Vostok¦vost0;!ok0;! time|Antarctica/Macquarie¦macquarie0;! island|Pacific/Pago_Pago¦pa0samoamidway,us1;cific0go pago;/samoa|Pacific/Rarotonga¦c0rarotonga;k2ook0;! islands0;! standard time;!t|Pacific/Easter¦chile/easterisland,e0;as0mt;st,t0;!er0;! island0;! standard time|Pacific/Galapagos¦gal0;apagos,t,ápagos islands|Pacific/Fiji¦f0;iji1j0;!st,t;! standard time|Pacific/Chuuk¦chuuk1pacific/0;truk,y1;!/truky0;ap|Pacific/Pohnpei¦f3micro4p0;acific/1f,ohnpei0;!/0;ponape;m,rench poly0;nesia|Pacific/Kosrae¦kosrae0;! time|Pacific/Guam¦ch1guam,mp,northern mariana islands,west0; pacific1ern pacific;amorro0st;! standard time|Pacific/Tarawa¦gilbert islands0tarawa;! time|Pacific/Enderbury¦enderbury,phoenix islands0;! time|Pacific/Kiritimati¦ki3line islands0;! 0;standard t0t0;ime;!ri0;bati,timati0;! island|Pacific/Majuro¦m0;a0h;juro,rshall islands0;! (most areas)|Pacific/Kwajalein¦kwajalein,marshall islands time|Pacific/Noumea¦n0;c,ew caledonia0oumea;! standard time|Pacific/Nauru¦n0;auru0r;! time|Pacific/Niue¦n0;iue1u0;!t;! time|Pacific/Auckland¦auckland,christchurch,manukau,n0wellington;ew zealand1orth shore,z0;!dt,mt,st;! 0;standard t0t0;ime|Pacific/Chatham¦cha0nz-chat;dt,st,tham0;! 0;islands0s1;! s0;tandard time|Pacific/Tahiti¦society islands,tahiti0;! time|Pacific/Marquesas¦marquesas0;! 0;islands,standard t0t0;ime|Pacific/Gambier¦gambier0;! 0;islands,time|Pacific/Port_Moresby¦p0;apua new guinea0g,ort moresby;! (most areas)|Pacific/Bougainville¦bougainville,guinea0papua new guinea time;!n|Pacific/Pitcairn¦p0;itcairn0n;! time|Pacific/Palau¦p0;alau0w;! time|Pacific/Guadalcanal¦guadalcanal,s0;b,olomon0;! islands0;! time|Pacific/Fakaofo¦fakaofo,t0;k1okelau0;! time;!t|Pacific/Tongatapu¦nuku'alofa,to0;!nga0;! standard time,tapu|Pacific/Funafuti¦funafuti,t0;uvalu0v;! time|Pacific/Wake¦u2wake0;! island0;! time;m,s minor outlying islands|Pacific/Honolulu¦aleutian2h0pacific/johnston,us/hawaii;awaii0onolulu,st;! aleutian,-aleutian 1;! 0;standard time|Pacific/Efate¦efate,v0;anuatu0u;! standard time|Pacific/Wallis¦w0;allis0f;! 0;& futuna time,and futuna|Pacific/Apia¦apia,s2w0;est0s; samoa time,ern s0;amoa|ETC/GMT¦gmt|Etc/GMT¦coordinated universal1greenwich0;! mean0; time|Etc/UTC¦etc/uct,u0zulu;ct,niversal,tc|America/Argentina¦arNbKcHformosa,jGla EmBneuquen,pAquilmJr9sa1t0;ierra del fuego (tLucumán (tm);lta6n0; 2t0;a 0iago del estero;cruz (sc),fe;juan1luis0miguel de tucuman,salvador de jujuy;! (sl);! (sj);! (salpnqrn);esistencia,osario;araDilar,osadas;ar del p3e0oron;ndoza0rlo;! (mz);p0rioja (lr);lata;ose c paz,ujuy (jy);atamarca (ct) chubut (ch),or0;doba,rient0;es;ahia blanca,uenos aires0;! (bac0;f);!genti0;na|Australia/Currie¦tasmania (king island)|America/Godthab¦g3w0;est greenland1g0;st,t;! s3;l,reenland0;! 0;(most areas),s0western;tandard time|America/Kentucky¦eastern - ky (0louisville;louisville area),wayne)|America/Indiana¦central 3eastern - in (0fort wayne,indianapolis;crawfor1dadukmn),most areas),p0switzerlan1;i3ulaski);d);- in (0standard time;perry),star0;ke)|America/North_Dakota¦central - nd (0;m0oliv1;erc0orton rural);er)|Africa/Kinshasa¦c3ki2m0;a0bandaka;sina,tadi;kwit,nshasa;d,ongo|Africa/Luanda¦huambo,l0n'dalatando;obito,uanda|Africa/Addis_Ababa¦addis ababa,dire dawa,mek'ele,nazret|Africa/Dar_es_Salaam¦arusha,d1m0tanga,zanzibar;beya,orogoro,wanza;ar es salaam,odoma|Africa/Mogadishu¦berbera,hargeysa,jamaame,kismayo,m0;arka,ogadishu|Africa/Dakar¦dakar,pikine,t0;hies0ouba;! nones|Asia/Aden¦a0ibb,mukalla,sanaa,taiz;den,l hudaydah|Africa/Conakry¦c0;amayenne,onakry|Asia/Phnom_Penh¦ict,phnom penh,takeo|Africa/Harare¦bulawayo,chitungwiza,har0mut0;are|Indian/Antananarivo¦ant0toamasina;ananarivo,sirabe|Africa/Lubumbashi¦b3k2l1m0tshikapa;buji mayi,wene ditu;ikasi,ubumbashi;ananga,isanga1olwezi;e0ukavu;ni|Africa/Kampala¦kampala|Africa/Douala¦b1douala,edea,gar2kousseri,loum,m0ngaoundere,yaounde;ar1okolo;a1ert0;oua;foussam,menda|Africa/Bamako¦bamako|Africa/Brazzaville¦brazzaville,pointe noire|Africa/Lusaka¦k0lusaka,ndola;ab0it0;we|Africa/Ouagadougou¦bobo dioulasso,ouagadougou|Africa/Freetown¦freetown|Asia/Muscat¦muscat,seeb|Africa/Porto-Novo¦abomey calavi,coton0djoug0porto novo;ou|Africa/Niamey¦niamey,zinder|Africa/Lome¦lome|Africa/Kigali¦kigali|Europe/Zagreb¦split,zagreb|Europe/Sarajevo¦banja luka,sarajevo|Africa/Nouakchott¦nouakchott|Africa/Blantyre¦blantyre,lilongwe,mzuzu|Asia/Kuwait¦al ahmadi|Africa/Djibouti¦djibouti|Africa/Libreville¦libreville|Africa/Asmara¦asmara|Africa/Bangui¦bangui|Europe/Skopje¦skopje|Europe/Bratislava¦bratislava,kosice|Africa/Banjul¦serekunda|Africa/Bujumbura¦bujumbura|Europe/Ljubljana¦ljubljana|Europe/Podgorica¦podgorica|Africa/Gaborone¦gaborone|Asia/Vientiane¦vientiane|Asia/Saigon¦ho chi minh city|America/Port_Of_Spain¦vi0;!rgin islands|America/Port-au-prince¦h0;aiti,t|Pacific/Norfolk¦n0;f,orfolk 0;island0s1;! s0;tandard time|America/Buenos_Aires¦ar0;gentina standard time,st,t|Pacific/Midway¦s0;amoa standard time,dt,st|Asia/Katmandu¦nepal 0;standard t0t0;ime|Asia/Rangoon¦myanmar 0;standard t0t0;ime|Pacific/Truk¦chuuk time,truk|Pacific/Ponape¦ponape0;! time|America/Santa_Isabel¦mexico northwest,northwest mexico standard time,pacific 0;mexico,standard time (mexico)|Brazil/Acre¦act|Asia/Thimbu¦btt");
ai = Object.assign(ai, { "gmt+0": "etc/Gmt", "gmt-0": "etc/Gmt", gmt0: "etc/Gmt", "etc/gmt+0": "Etc/Gmt", "etc/gmt-0": "Etc/Gmt", "etc/gmt0": "Etc/Gmt", "msk-01 - kaliningrad": "Europe/Kaliningrad", "msk+00 - moscow area": "Europe/Moscow", "msk+00 - crimea": "Europe/Simferopol", "msk+00 - volgograd": "Europe/Volgograd", "msk+00 - kirov": "Europe/Kirov", "msk+01 - astrakhan": "Europe/Astrakhan", "msk+01 - saratov": "Europe/Saratov", "msk+01 - ulyanovsk": "Europe/Ulyanovsk", "msk+01 - samaraudmurtia": "Europe/Samara", "msk+02 - urals": "Asia/Yekaterinburg", "msk+03 - omsk": "Asia/Omsk", "msk+04 - novosibirsk": "Asia/Novosibirsk", "msk+04 - altai": "Asia/Barnaul", "msk+04 - tomsk": "Asia/Tomsk", "msk+04 - kemerovo": "Asia/Novokuznetsk", "msk+04 - krasnoyarsk area": "Asia/Krasnoyarsk", "msk+05 - irkutskburyatia": "Asia/Irkutsk", "msk+06 - zabaykalsky": "Asia/Chita", "msk+06 - lena river": "Asia/Yakutsk", "msk+06 - tomponskyust-maysky": "Asia/Khandyga", "msk+07 - amur river": "Asia/Vladivostok", "msk+07 - oymyakonsky": "Asia/Ust-Nera", "msk+08 - magadan": "Asia/Magadan", "msk+08 - sakhalin island": "Asia/Sakhalin", "msk+08 - sakha (e) north kuril is": "Asia/Srednekolymsk", "msk+09 - kamchatka": "Asia/Kamchatka", "msk+09 - bering sea": "Asia/Anadyr", "antarctica/south_pole": "Pacific/Auckland", "america/buenos_aires": "America/Argentina/Buenos_Aires", "america/coral_harbour": "America/Atikokan", "america/fort_wayne": "America/Indiana/Indianapolis", "america/knox_in": "America/Indiana/Knox", "america/porto_acre": "America/Rio_Branco", "america/santa_isabel": "America/Tijuana", "asia/tel_aviv": "Asia/Jerusalem", "asia/ujung_pandang": "Asia/Makassar", "asia/ulan_bator": "Asia/Ulaanbaatar", "atlantic/jan_mayen": "Europe/Oslo" }), Object.keys(ai).filter((e) => {
  let t = ai[e];
  typeof t == "string" && (t = t.toLowerCase(), ai[t] === void 0 && (ai[t] = ai[e]));
});
const Cbc = function(e) {
  if (!e)
    return null;
  if (e = e.toLowerCase().trim(), ai.hasOwnProperty(e))
    return ai[e];
  if (/[0-9]/.test(e)) {
    let n = function(o) {
      let r = o.match(xbc);
      if (r !== null || (r = o.match(Tbc), r !== null))
        return A2(r[1]);
      if (r = o.match(Abc), r !== null) {
        let i = -1 * Number(r[1]);
        return A2(i);
      }
      return r = o.match(Ebc), r !== null ? A2(r[1]) : null;
    }(e);
    if (n)
      return [n];
  }
  if (e = e.replace(/^in /g, "").replace(/ time/g, "").replace(/ (standard|daylight|summer)/g, "").replace(/ - .*/g, "").replace(/, .*/g, "").trim(), ai.hasOwnProperty(e))
    return ai[e];
  let t = e + " time";
  return ai.hasOwnProperty(t) ? ai[t] : (t = e + " standard time", ai.hasOwnProperty(t) ? ai[t] : (e = function(n) {
    return (n = (n = (n = (n = (n = n.replace(/\b(east|west|north|south)ern/g, "$1")).replace(/\b(africa|america|australia)n/g, "$1")).replace(/\beuropean/g, "europe")).replace(/\islands/g, "island")).replace(/.*\//g, "")).trim();
  }(e), ai.hasOwnProperty(e) ? ai[e] : (e = function(n) {
    return (n = n.replace(/\(.*\)/, "")).trim();
  }(e), ai.hasOwnProperty(e) ? ai[e] : (t = e + " time", ai.hasOwnProperty(t) ? ai[t] : (t = e + " standard time", ai.hasOwnProperty(t) ? ai[t] : null)))));
};
var zbc = [{ name: "India Time", abbr: null, aliases: ["india", "indian", "india standard time", "chennai", "kolkata", "mumbai", "new delhi"], ids: ["Asia/Kolkata", "Asia/Calcutta", "Asia/Colombo"], std: { name: "India Standard Time", abbr: "IST", offset: 5.5 }, dst: {}, long: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", hem: "n" }, { name: "China Time", abbr: null, aliases: ["china", "china standard time", "beijing", "chongqing", "hong kong", "urumqi"], ids: ["Asia/Shanghai", "Asia/Macau", "Asia/Urumqi"], std: { abbr: "CST", name: "China Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", hem: "n" }, { name: "Central European Time", abbr: null, aliases: ["europe central", "romance standard time", "brussels", "copenhagen", "madrid", "paris", "romance"], ids: ["Europe/Paris", "Africa/Ceuta", "Arctic/Longyearbyen", "Europe/Amsterdam", "Europe/Andorra", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Budapest", "Europe/Busingen", "Europe/Copenhagen", "Europe/Gibraltar", "Europe/Ljubljana", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Monaco", "Europe/Oslo", "Europe/Podgorica", "Europe/Prague", "Europe/Rome", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Skopje", "Europe/Stockholm", "Europe/Tirane", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zurich"], std: { abbr: "CET", name: "Central European Standard Time", offset: 1 }, dst: { abbr: "CEST", name: "Central European Summer Time", offset: 2 }, long: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", hem: "n" }, { name: "", dupe: !0, ids: ["America/Puerto_Rico", "America/Montserrat", "America/Port_of_Spain", "America/Santo_Domingo", "America/St_Barthelemy", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Tortola", "America/Grenada", "America/Guadeloupe", "America/Kralendijk", "America/Lower_Princes", "America/Marigot", "America/Martinique", "America/Anguilla", "America/Antigua", "America/Aruba", "America/Barbados", "America/Blanc-Sablon", "America/Curacao", "America/Dominica"], std: { name: "Atlantic Standard Time", abbr: "AST", offset: -4 }, dst: {}, hem: "n" }, { name: "Greenwich Mean Time", abbr: null, aliases: ["gmt", "zulu", "utc", "coordinated universal time"], ids: ["Etc/GMT", "Africa/Abidjan", "Africa/Accra", "Africa/Bamako", "Africa/Banjul", "Africa/Bissau", "Africa/Conakry", "Africa/Dakar", "Africa/Freetown", "Africa/Lome", "Africa/Monrovia", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Sao_Tome", "America/Danmarkshavn", "Atlantic/Reykjavik", "Atlantic/St_Helena", "Etc/UTC"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: {}, long: "(UTC) Coordinated Universal Time", hem: "n" }, { name: "Eastern European Time", abbr: null, aliases: ["europe eastern"], ids: ["Asia/Beirut", "Asia/Famagusta", "Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau", "Europe/Helsinki", "Europe/Kiev", "Europe/Mariehamn", "Europe/Riga", "Europe/Sofia", "Europe/Tallinn", "Europe/Uzhgorod", "Europe/Vilnius", "Europe/Zaporozhye"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, dst: { abbr: "EEST", name: "Eastern European Summer Time", offset: 3 }, hem: "n" }, { name: "", dupe: !0, ids: ["America/Indiana", "America/North_Dakota", "America/Belize", "America/Costa_Rica", "America/El_Salvador", "America/Guatemala", "America/Indiana/Knox", "America/Indiana/Tell_City", "America/Managua", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Regina", "America/Swift_Current", "America/Tegucigalpa"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, hem: "n" }, { name: "Eastern Time", abbr: "ET", aliases: ["america eastern", "eastern standard time", "eastern"], ids: ["America/New_York", "America/Detroit", "America/Grand_Turk", "America/Indianapolis", "America/Iqaluit", "America/Louisville", "America/Nassau", "America/Nipigon", "America/Pangnirtung", "America/Port-au-Prince", "America/Thunder_Bay", "America/Toronto", "America/Montreal", "America/Kentucky"], std: { name: "Eastern Standard Time", abbr: "EST", offset: -5 }, dst: { name: "Eastern Daylight Time", abbr: "EDT", offset: -4 }, long: "(UTC-05:00) Eastern Time (US & Canada)", hem: "n" }, { name: "Argentina Time", abbr: "ART", aliases: ["argentina", "arst", "argentina standard time", "buenos aires"], ids: ["America/Buenos_Aires", "America/Argentina/La_Rioja", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Catamarca", "America/Cordoba", "America/Jujuy", "America/Mendoza", "Antarctica/Rothera", "America/Argentina"], std: { name: "Argentina Standard Time", abbr: "ART", offset: -3 }, dst: {}, long: "(UTC-03:00) City of Buenos Aires", hem: "s" }, { name: "", dupe: !0, ids: ["America/Coral_Harbour", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Kentucky/Monticello", "America/Cancun", "America/Cayman", "America/Jamaica", "America/Panama"], std: { name: "Eastern Standard Time", abbr: "EST", offset: -5 }, hem: "n" }, { name: "East Africa Time", abbr: null, aliases: ["africa eastern", "e. africa standard time", "nairobi", "east africa", "eastern africa"], ids: ["Africa/Nairobi", "Africa/Addis_Ababa", "Africa/Asmera", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Kampala", "Africa/Mogadishu", "Indian/Comoro", "Indian/Mayotte"], std: { name: "East Africa Time", abbr: "EAT", offset: 3 }, dst: {}, long: "(UTC+03:00) Nairobi", hem: "n" }, { name: "West Africa Time", abbr: "WAT", aliases: ["africa western", "wast", "western africa", "w. central africa standard time", "west central africa", "w. central africa"], ids: ["Africa/Lagos", "Africa/Bangui", "Africa/Douala", "Africa/Libreville", "Africa/Malabo", "Africa/Ndjamena", "Africa/Niamey", "Africa/Porto-Novo"], std: { name: "West Africa Standard Time", abbr: "WAT", offset: 1 }, long: "(UTC+01:00) West Central Africa", hem: "n" }, { name: "Moscow Time", abbr: null, aliases: ["moscow", "russian standard time", "st. petersburg", "russian", "volgograd time"], ids: ["Europe/Moscow", "Europe/Astrakhan", "Europe/Minsk", "Europe/Simferopol", "Europe/Ulyanovsk", "Europe/Kirov", "Europe/Volgograd", "Asia/Volgograd"], std: { abbr: "MSK", name: "Moscow Standard Time", offset: 3 }, dst: {}, long: "(UTC+03:00) Moscow, St. Petersburg", hem: "n" }, { name: "Brasilia Time", abbr: null, aliases: ["brasilia", "e. south america standard time", "east south america"], ids: ["America/Sao_Paulo", "America/Araguaina", "America/Bahia", "America/Belem", "America/Fortaleza", "America/Maceio", "America/Recife", "America/Santarem"], std: { abbr: "BRT", name: "Brasilia Standard Time", offset: -3 }, dst: {}, long: "(UTC-03:00) Brasilia", hem: "s" }, { name: "Mountain Time", abbr: "MT", aliases: ["america mountain", "mountain standard time", "mountain"], ids: ["America/Boise", "America/Cambridge_Bay", "America/Denver", "America/Edmonton", "America/Inuvik", "America/Ojinaga", "America/Yellowknife"], std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, dst: { name: "Mountain Daylight Time", abbr: "MDT", offset: -6 }, long: "(UTC-07:00) Mountain Time (US & Canada)", hem: "n" }, { name: "Central Time", abbr: "CT", aliases: ["america central", "central standard time", "central"], ids: ["America/Chicago", "America/Matamoros", "America/Menominee", "America/Rainy_River", "America/Rankin_Inlet", "America/Resolute", "America/Winnipeg"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, dst: { name: "Central Daylight Time", abbr: "CDT", offset: -5 }, long: "(UTC-06:00) Central Time (US & Canada)", hem: "n" }, { name: "Central Africa Time", abbr: null, aliases: ["africa central", "namibia standard time", "windhoek", "namibia"], ids: ["Africa/Windhoek", "Africa/Gaborone", "Africa/Harare", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Maputo"], std: { name: "Central Africa Time", abbr: "CAT", offset: 2 }, dst: {}, long: "(UTC+02:00) Windhoek", hem: "s" }, { name: "Arabian Time", abbr: null, aliases: ["arabian", "arab standard time", "kuwait", "riyadh", "arab", "arabia", "arabic"], ids: ["Asia/Baghdad", "Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh"], std: { abbr: "AST", name: "Arabian Standard Time", offset: 3 }, dst: {}, long: "(UTC+03:00) Kuwait, Riyadh", hem: "n" }, { name: "Alaska Time", abbr: "AKT", aliases: ["alaska", "alaskan standard time", "alaskan"], ids: ["America/Anchorage", "America/Juneau", "America/Metlakatla", "America/Nome", "America/Sitka", "America/Yakutat"], std: { name: "Alaska Standard Time", abbr: "AKST", offset: -9 }, dst: { name: "Alaska Daylight Time", abbr: "AKDT", offset: -8 }, long: "(UTC-09:00) Alaska", hem: "n" }, { name: "Atlantic Time", abbr: "AT", aliases: ["atlantic", "atlantic standard time"], ids: ["America/Halifax", "America/Glace_Bay", "America/Goose_Bay", "America/Moncton", "America/Thule", "Atlantic/Bermuda"], std: { name: "Atlantic Standard Time", abbr: "AST", offset: -4 }, dst: { name: "Atlantic Daylight Time", abbr: "ADT", offset: -3 }, long: "(UTC-04:00) Atlantic Time (Canada)", hem: "n" }, { name: "British Time", abbr: null, aliases: ["gmt", "gmt standard time", "dublin", "edinburgh", "lisbon", "london"], ids: ["Europe/London", "Europe/Dublin", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: { name: "British Summer Time", abbr: "BST", offset: 1 }, long: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London", hem: "n" }, { name: "Central Africa Time", dupe: !0, ids: ["Africa/Blantyre", "Africa/Bujumbura", "Africa/Juba", "Africa/Khartoum", "Africa/Kigali"], std: { name: "Central Africa Time", abbr: "CAT", offset: 2 }, dst: {}, hem: "n" }, { name: "West Kazakhstan Time", abbr: null, aliases: ["kazakhstan western", "west asia standard time", "ashgabat", "tashkent", "west asia", "alma ata"], ids: ["Asia/Aqtau", "Asia/Aqtobe", "Asia/Atyrau", "Asia/Oral", "Asia/Qyzylorda"], std: { abbr: "ALMT", name: "Alma-Ata Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Ashgabat, Tashkent", hem: "n" }, { name: "Eastern Australia Time", abbr: "AET", aliases: ["australia eastern", "aus eastern standard time", "canberra", "melbourne", "sydney", "aus eastern", "aus east"], ids: ["Australia/Sydney", "Antarctica/Macquarie", "Australia/Currie", "Australia/Hobart", "Australia/Melbourne"], std: { name: "Australian Eastern Standard Time", abbr: "AEST", offset: 10 }, dst: { name: "Australian Eastern Daylight Time", abbr: "AEDT", offset: 11 }, long: "(UTC+10:00) Canberra, Melbourne, Sydney", hem: "s" }, { name: "Western European Time", abbr: null, aliases: ["europe western"], ids: ["Europe/Lisbon", "Atlantic/Canary", "Atlantic/Faeroe", "Atlantic/Madeira"], std: { abbr: "WET", name: "Western European Standard Time", offset: 0 }, dst: { abbr: "WEST", name: "Western European Summer Time", offset: 1 }, hem: "n" }, { name: "Indochina Time", abbr: null, aliases: ["indochina", "se asia standard time", "bangkok", "hanoi", "jakarta", "se asia", "south east asia"], ids: ["Asia/Bangkok", "Asia/Phnom_Penh", "Asia/Saigon", "Asia/Vientiane"], std: { abbr: "ICT", name: "Indochina Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Bangkok, Hanoi, Jakarta", hem: "n" }, { name: "", dupe: !0, abbr: "MT", std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, ids: ["America/Phoenix", "America/Creston", "America/Dawson_Creek", "America/Fort_Nelson"], hem: "n" }, { name: "Central Mexico Time", long: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", aliases: ["guadalajara", "mexico city", "monterrey", "central mexico", "central mexican"], ids: ["America/Mexico_City", "America/Merida", "America/Monterrey", "America/Bahia_Banderas"], std: { name: "Central Standard Time", abbr: "CST", offset: -6 }, dst: { name: "Central Daylight Time", abbr: "CDT", offset: -5 }, hem: "n" }, { name: "West Africa Time", dupe: !0, ids: ["Africa/Luanda", "Africa/Kinshasa", "Africa/Brazzaville"], std: { name: "West Africa Standard Time", abbr: "WAT", offset: 1 }, hem: "s" }, { name: "", dupe: !0, ids: ["Africa/Cairo", "Africa/Tripoli", "Europe/Kaliningrad"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "South Africa Time", abbr: null, aliases: ["africa southern", "south africa standard time", "harare", "pretoria", "south africa"], ids: ["Africa/Johannesburg", "Africa/Maseru", "Africa/Mbabane"], std: { name: "South Africa Standard Time", abbr: "SAST", offset: 2 }, dst: {}, long: "(UTC+02:00) Harare, Pretoria", hem: "s" }, { name: "Krasnoyarsk Time", abbr: null, aliases: ["krasnoyarsk", "north asia standard time", "north asia"], ids: ["Asia/Krasnoyarsk", "Asia/Novokuznetsk", "Asia/Barnaul"], std: { abbr: "KRAT", name: "Krasnoyarsk Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Krasnoyarsk", hem: "n" }, { name: "Yakutsk Time", abbr: null, aliases: ["yakutsk", "yakutsk standard time"], ids: ["Asia/Yakutsk", "Asia/Chita", "Asia/Khandyga"], std: { abbr: "YAKT", name: "Yakutsk Standard Time", offset: 9 }, dst: {}, long: "(UTC+09:00) Yakutsk", hem: "n" }, { name: "Pacific Time", abbr: "PT", aliases: ["america pacific", "pacific standard time", "pacific"], ids: ["America/Los_Angeles", "America/Tijuana", "America/Vancouver"], std: { name: "Pacific Standard Time", abbr: "PST", offset: -8 }, dst: { name: "Pacific Daylight Time", abbr: "PDT", offset: -7 }, long: "(UTC-08:00) Pacific Time (US & Canada)", hem: "n" }, { name: "Amazon Time", abbr: null, aliases: ["amazon", "central brazilian standard time", "cuiaba", "central brazilian", "central brazil"], ids: ["America/Boa_Vista", "America/Manaus", "America/Porto_Velho"], std: { abbr: "AMT", name: "Amazon Standard Time", offset: -4 }, dst: {}, long: "(UTC-04:00) Cuiaba", hem: "n" }, { name: "Morocco Standard Time", offset: 1, long: "(UTC+00:00) Casablanca", aliases: ["casablanca", "morocco"], ids: ["Africa/Casablanca", "Africa/El_Aaiun"], std: { abbr: "WET", name: "Western European Standard Time", offset: 1 }, dst: { abbr: "WEST", name: "Western European Summer Time", offset: 0 }, hem: "n" }, { name: "", dupe: !0, ids: ["Africa/Algiers", "Africa/Tunis"], std: { abbr: "CET", name: "Central European Standard Time", offset: 1 }, dst: { abbr: "CEST", name: "Central European Summer Time", offset: 2 }, hem: "n" }, { name: "", dupe: !0, ids: ["Asia/Gaza", "Asia/Hebron"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "", dupe: !0, ids: ["Asia/Damascus", "Asia/Amman"], std: { abbr: "EET", name: "Eastern European Standard Time", offset: 2 }, hem: "n" }, { name: "Gulf Time", abbr: null, aliases: ["gulf", "arabian standard time", "abu dhabi", "muscat", "arabian"], ids: ["Asia/Dubai", "Asia/Muscat"], std: { name: "Gulf Standard Time", abbr: "GST", offset: 4 }, dst: {}, long: "(UTC+04:00) Abu Dhabi, Muscat", hem: "n" }, { name: "Samara Time", abbr: null, aliases: ["samara", "russia time zone 3", "izhevsk"], ids: ["Europe/Samara", "Europe/Saratov"], std: { abbr: "SAMT", name: "Samara Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Izhevsk, Samara", hem: "n" }, { name: "Uzbekistan Time", abbr: null, aliases: ["uzbekistan"], ids: ["Asia/Samarkand", "Asia/Tashkent"], std: { abbr: "UZT", name: "Uzbekistan Standard Time", offset: 5 }, dst: {}, hem: "n" }, { name: "East Kazakhstan Time", abbr: null, aliases: ["kazakhstan eastern", "central asia standard time", "astana", "central asia"], ids: ["Asia/Almaty", "Asia/Qostanay"], std: { abbr: "ALMT", name: "East Kazakhstan Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Astana", hem: "n" }, { name: "Omsk Time", abbr: null, aliases: ["omsk", "omsk standard time"], ids: ["Asia/Omsk", "Asia/Tomsk"], std: { abbr: "OMST", name: "Omsk Standard Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Omsk", hem: "n" }, { name: "Western Indonesia Time", abbr: null, aliases: ["indonesia western"], ids: ["Asia/Jakarta", "Asia/Pontianak"], std: { name: "Western Indonesia Time", abbr: "WIB", offset: 7 }, dst: {}, hem: "s" }, { name: "Ulaanbaatar Time", abbr: null, aliases: ["mongolia", "ulaanbaatar standard time", "ulaanbaatar"], ids: ["Asia/Ulaanbaatar", "Asia/Choibalsan"], std: { abbr: "ULAT", name: "Ulaanbaatar Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Ulaanbaatar", hem: "n" }, { name: "Malaysia Time", abbr: null, aliases: ["malaysia"], ids: ["Asia/Kuala_Lumpur", "Asia/Kuching"], std: { name: "Malaysia Time", abbr: "MYT", offset: 8 }, dst: {}, hem: "s" }, { name: "Korean Time", abbr: null, aliases: ["korea", "korea standard time", "seoul"], ids: ["Asia/Seoul", "Asia/Pyongyang"], std: { abbr: "KST", name: "Korean Standard Time", offset: 9 }, dst: {}, long: "(UTC+09:00) Seoul", hem: "n" }, { name: "Central Australia Time", abbr: "ACT", aliases: ["australia central", "cen. australia standard time", "adelaide", "central australia"], ids: ["Australia/Adelaide", "Australia/Broken_Hill"], std: { name: "Australian Central Standard Time", abbr: "ACST", offset: 9.5 }, dst: { name: "Australian Central Daylight Time", abbr: "ACDT", offset: 10.5 }, long: "(UTC+09:30) Adelaide", hem: "s" }, { name: "Brisbane Time", dupe: !0, ids: ["Australia/Brisbane", "Australia/Lindeman"], std: { name: "Australian Eastern Standard Time", abbr: "AEST", offset: 10 }, hem: "s" }, { name: "Vladivostok Time", abbr: null, aliases: ["vladivostok", "vladivostok standard time"], ids: ["Asia/Vladivostok", "Asia/Ust-Nera"], std: { abbr: "VLAT", name: "Vladivostok Standard Time", offset: 10 }, dst: {}, long: "(UTC+10:00) Vladivostok", hem: "n" }, { name: "Chamorro Time", abbr: null, aliases: ["chamorro", "west pacific standard time", "guam", "port moresby", "west pacific", "western pacific"], ids: ["Pacific/Guam", "Pacific/Saipan"], std: { name: "Chamorro Standard Time", abbr: "ChST", offset: 10 }, dst: {}, long: "(UTC+10:00) Guam, Port Moresby", hem: "n" }, { name: "Papua New Guinea Time", abbr: null, aliases: ["papua new guinea", "guinea", "guinean"], ids: ["Pacific/Bougainville", "Pacific/Port_Moresby"], std: { abbr: "PGT", name: "Papua New Guinea Time", offset: 11 }, dst: {}, hem: "s" }, { name: "New Zealand Time", abbr: "NZT", aliases: ["new zealand", "new zealand standard time", "auckland", "wellington"], ids: ["Pacific/Auckland", "Antarctica/McMurdo"], std: { name: "New Zealand Standard Time", abbr: "NZST", offset: 12 }, dst: { name: "New Zealand Daylight Time", abbr: "NZDT", offset: 13 }, long: "(UTC+12:00) Auckland, Wellington", hem: "s" }, { name: "Marshall Islands Time", abbr: null, aliases: ["marshall islands"], ids: ["Pacific/Kwajalein", "Pacific/Majuro"], std: { abbr: "MHT", name: "Marshall Islands Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Samoa Time", abbr: "SST", aliases: ["samoa", "samoa standard time"], ids: ["Pacific/Midway", "Pacific/Pago_Pago"], std: { abbr: "SST", name: "Samoa Standard Time", offset: -11 }, dst: {}, long: "(UTC+13:00) Samoa", hem: "n" }, { name: "Hawaii-Aleutian Time", abbr: "HAT", aliases: ["hawaii aleutian", "aleutian standard time", "aleutian"], ids: ["Pacific/Honolulu", "Pacific/Johnston"], std: { name: "Hawaii-Aleutian Standard Time", abbr: "HAST", offset: -9 }, dst: { name: "Hawaii-Aleutian Daylight Time", abbr: "HADT", offset: -8 }, long: "(UTC-09:00) Aleutian Islands", hem: "n" }, { name: "", dupe: !0, std: { name: "Mountain Standard Time", abbr: "MST", offset: -7 }, ids: ["America/Dawson", "America/Whitehorse"], hem: "n" }, { name: "Mexican Pacific Time", abbr: "HPMX", aliases: ["mexico pacific", "mountain standard time (mexico)", "chihuahua", "la paz", "mazatlan", "mountain mexico"], ids: ["America/Chihuahua", "America/Mazatlan"], std: { name: "Mexican Pacific Standard Time", abbr: "HNPMX", offset: -7 }, dst: { name: "Mexican Pacific Daylight Time", abbr: "HEPMX", offset: -6 }, long: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", hem: "n" }, { name: "Colombia Time", abbr: "COT", aliases: ["colombia", "cost"], ids: ["America/Bogota", "Pacific/Galapagos"], std: { name: "Colombia Standard Time", abbr: "COT", offset: -5 }, dst: {}, hem: "n" }, { name: "Acre Time", abbr: null, aliases: ["acre"], ids: ["America/Eirunepe", "America/Rio_Branco"], std: { abbr: "ACT", name: "Acre Standard Time", offset: -5 }, dst: {}, hem: "n" }, { name: "", dupe: !0, ids: ["America/Campo_Grande", "America/Cuiaba"], std: { abbr: "AMT", name: "Amazon Standard Time", offset: -4 }, hem: "s" }, { name: "", dupe: !0, ids: ["Antarctica/Palmer", "America/Punta_Arenas"], std: { name: "Chile Standard Time", abbr: "CLT", offset: -3 }, hem: "s" }, { name: "Troll Time", dupe: !0, abbr: null, aliases: ["troll research station"], ids: ["Antarctica/Troll"], std: { name: "Greenwich Mean Time", abbr: "GMT", offset: 0 }, dst: {}, hem: "s" }, { name: "East Greenland Time", abbr: "HEG", aliases: ["greenland eastern"], ids: ["America/Scoresbysund"], std: { name: "East Greenland Standard Time", abbr: "HNEG", offset: 0 }, dst: { name: "East Greenland Summer Time", abbr: "HEEG", offset: 1 }, hem: "n" }, { name: "Israel Time", abbr: null, aliases: ["israel", "israel standard time", "jerusalem"], ids: ["Asia/Jerusalem"], std: { abbr: "IST", name: "Israel Standard Time", offset: 2 }, dst: { name: "Israel Daylight Time", offset: 3 }, long: "(UTC+02:00) Jerusalem", hem: "n" }, { name: "East Africa Time", dupe: !0, ids: ["Indian/Antananarivo"], std: { name: "East Africa Time", abbr: "EAT", offset: 3 }, dst: {}, hem: "s" }, { name: "Syowa Time", abbr: null, aliases: ["syowa"], ids: ["Antarctica/Syowa"], std: { abbr: "SYOT", name: "Syowa Time", offset: 3 }, dst: {}, hem: "s" }, { name: "Turkey Time", abbr: "TRT", aliases: ["turkey", "turkey standard time", "istanbul"], ids: ["Europe/Istanbul"], std: { name: "Turkey Time", abbr: "TRT", offset: 3 }, dst: {}, long: "(UTC+03:00) Istanbul", hem: "n" }, { name: "Iran Time", abbr: null, aliases: ["iran", "iran standard time", "tehran"], ids: ["Asia/Tehran"], std: { abbr: "IRST", name: "Iran Standard Time", offset: 3.5 }, dst: { abbr: "IRDT", name: "Iran Daylight Time", offset: 4.5 }, long: "(UTC+03:30) Tehran", hem: "n" }, { name: "Azerbaijan Time", abbr: null, aliases: ["azerbaijan", "azerbaijan standard time", "baku"], ids: ["Asia/Baku"], std: { abbr: "AZT", name: "Azerbaijan Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Baku", hem: "n" }, { name: "Georgia Time", abbr: "GET", aliases: ["georgia", "georgian standard time", "tbilisi", "georgian"], ids: ["Asia/Tbilisi"], std: { abbr: "GET", name: "Georgia Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Tbilisi", hem: "n" }, { name: "Armenia Time", abbr: "AMT", aliases: ["armenia", "caucasus standard time", "yerevan", "caucasus"], ids: ["Asia/Yerevan"], std: { abbr: "AMT", name: "Armenia Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Yerevan", hem: "n" }, { name: "Seychelles Time", abbr: null, aliases: ["seychelles"], ids: ["Indian/Mahe"], std: { abbr: "SCT", name: "Seychelles Time", offset: 4 }, dst: {}, hem: "n" }, { name: "Mauritius Time", abbr: null, aliases: ["mauritius", "mauritius standard time", "port louis"], ids: ["Indian/Mauritius"], std: { abbr: "MUT", name: "Mauritius Standard Time", offset: 4 }, dst: {}, long: "(UTC+04:00) Port Louis", hem: "n" }, { name: "Réunion Time", abbr: null, aliases: ["reunion"], ids: ["Indian/Reunion"], std: { abbr: "RET", name: "Réunion Time", offset: 4 }, dst: {}, hem: "s" }, { name: "Afghanistan Time", abbr: null, aliases: ["afghanistan", "afghanistan standard time", "kabul"], ids: ["Asia/Kabul"], std: { abbr: "AFT", name: "Afghanistan Time", offset: 4.5 }, dst: {}, long: "(UTC+04:30) Kabul", hem: "n" }, { name: "Mawson Time", abbr: null, aliases: ["mawson"], ids: ["Antarctica/Mawson"], std: { abbr: "MAWT", name: "Mawson Time", offset: 5 }, dst: {}, hem: "s" }, { name: "Turkmenistan Time", abbr: "TMT", aliases: ["turkmenistan", "tmst"], ids: ["Asia/Ashgabat"], std: { name: "Turkmenistan Standard Time", abbr: "TMT", offset: 5 }, dst: {}, hem: "n" }, { name: "Tajikistan Time", abbr: null, aliases: ["tajikistan"], ids: ["Asia/Dushanbe"], std: { abbr: "TJT", name: "Tajikistan Time", offset: 5 }, dst: {}, hem: "n" }, { name: "Pakistan Time", abbr: null, aliases: ["pakistan", "pakistan standard time", "islamabad", "karachi"], ids: ["Asia/Karachi"], std: { abbr: "PKT", name: "Pakistan Standard Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Islamabad, Karachi", hem: "n" }, { name: "Yekaterinburg Time", abbr: "YEKT", aliases: ["yekaterinburg", "ekaterinburg standard time", "ekaterinburg"], ids: ["Asia/Yekaterinburg"], std: { abbr: "YEKT", name: "Yekaterinburg Standard Time", offset: 5 }, dst: {}, long: "(UTC+05:00) Ekaterinburg", hem: "n" }, { name: "French Southern & Antarctic Time", abbr: null, aliases: ["french southern"], ids: ["Indian/Kerguelen"], std: { abbr: "TFT", name: "French Southern & Antarctic Time", offset: 5 }, dst: {}, hem: "s" }, { name: "Maldives Time", abbr: null, aliases: ["maldives"], ids: ["Indian/Maldives"], std: { abbr: "MVT", name: "Maldives Time", offset: 5 }, dst: {}, hem: "n" }, { name: "Nepal Time", abbr: null, aliases: ["nepal", "nepal standard time", "kathmandu"], ids: ["Asia/Katmandu"], std: { abbr: "NPT", name: "Nepal Time", offset: 5.75 }, dst: {}, long: "(UTC+05:45) Kathmandu", hem: "n" }, { name: "Vostok Time", abbr: null, aliases: ["vostok"], ids: ["Antarctica/Vostok"], std: { abbr: "MSK+4", name: "Vostok Time", offset: 6 }, dst: {}, hem: "s" }, { name: "Kyrgyzstan Time", abbr: null, aliases: ["kyrgystan"], ids: ["Asia/Bishkek"], std: { abbr: "KGT", name: "Kyrgyzstan Time", offset: 6 }, dst: {}, hem: "n" }, { name: "Bangladesh Time", abbr: "BST", aliases: ["bangladesh", "bangladesh standard time", "dhaka"], ids: ["Asia/Dhaka"], std: { abbr: "BST", name: "Bangladesh Standard Time", offset: 6 }, dst: {}, long: "(UTC+06:00) Dhaka", hem: "n" }, { name: "Bhutan Time", abbr: null, aliases: ["bhutan"], ids: ["Asia/Thimphu"], std: { name: "Bhutan Time", abbr: "BT", offset: 6 }, dst: {}, hem: "n" }, { name: "Indian Ocean Time", abbr: null, aliases: ["indian ocean", "indian chagos"], ids: ["Indian/Chagos"], std: { abbr: "IOT", name: "Indian Ocean Time", offset: 6 }, dst: {}, hem: "n" }, { name: "Myanmar Time", abbr: null, aliases: ["myanmar", "myanmar standard time"], ids: ["Asia/Rangoon"], std: { abbr: "MMT", name: "Myanmar Time", offset: 6.5 }, dst: {}, long: "(UTC+06:30) Yangon (Rangoon)", hem: "n" }, { name: "Cocos Islands Time", abbr: null, aliases: ["cocos"], ids: ["Indian/Cocos"], std: { abbr: "CCT", name: "Cocos Islands Time", offset: 6.5 }, dst: {}, hem: "n" }, { name: "Davis Time", abbr: null, aliases: ["davis"], ids: ["Antarctica/Davis"], std: { abbr: "DAVT", name: "Davis Time", offset: 7 }, dst: {}, hem: "s" }, { name: "Hovd Time", abbr: null, aliases: ["hovd", "w. mongolia standard time", "west mongolia", "western mongolia"], ids: ["Asia/Hovd"], std: { abbr: "HOVT", name: "Hovd Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Hovd", hem: "n" }, { name: "Novosibirsk Time", abbr: null, aliases: ["novosibirsk", "n. central asia standard time", "north central asia"], ids: ["Asia/Novosibirsk"], std: { abbr: "NOVT", name: "Novosibirsk Standard Time", offset: 7 }, dst: {}, long: "(UTC+07:00) Novosibirsk", hem: "n" }, { name: "Christmas Island Time", abbr: null, aliases: ["christmas"], ids: ["Indian/Christmas"], std: { abbr: "CXT", name: "Christmas Island Time", offset: 7 }, dst: {}, hem: "s" }, { name: "Brunei Darussalam Time", abbr: null, aliases: ["brunei"], ids: ["Asia/Brunei"], std: { abbr: "BNT", name: "Brunei Darussalam Time", offset: 8 }, dst: {}, hem: "n" }, { name: "Hong Kong Time", abbr: "HKT", aliases: ["hong kong", "hkst"], ids: ["Asia/Hong_Kong"], std: { name: "Hong Kong Standard Time", abbr: "HKT", offset: 8 }, dst: {}, hem: "n" }, { name: "Irkutsk Time", abbr: null, aliases: ["irkutsk", "north asia east standard time", "north asia east"], ids: ["Asia/Irkutsk"], std: { abbr: "IRKT", name: "Irkutsk Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Irkutsk", hem: "n" }, { name: "Central Indonesia Time", abbr: null, aliases: ["indonesia central"], ids: ["Asia/Makassar"], std: { name: "Central Indonesia Time", abbr: "WITA", offset: 8 }, dst: {}, hem: "s" }, { name: "Philippine Time", abbr: null, aliases: ["philippines"], ids: ["Asia/Manila"], std: { abbr: "PHST", name: "Philippine Standard Time", offset: 8 }, dst: {}, hem: "n" }, { name: "Singapore Time", abbr: null, aliases: ["singapore", "singapore standard time", "kuala lumpur"], ids: ["Asia/Singapore"], std: { name: "Singapore Standard Time", abbr: "SGT", offset: 8 }, dst: {}, long: "(UTC+08:00) Kuala Lumpur, Singapore", hem: "s" }, { name: "Taipei Time", abbr: null, aliases: ["taipei", "taipei standard time"], ids: ["Asia/Taipei"], std: { abbr: "CST", name: "Taipei Standard Time", offset: 8 }, dst: {}, long: "(UTC+08:00) Taipei", hem: "n" }, { name: "Western Australia Time", abbr: "AWT", aliases: ["australia western", "awdt", "w. australia standard time", "perth", "western australia", "west australia"], ids: ["Australia/Perth"], std: { name: "Australian Western Standard Time", abbr: "AWST", offset: 8 }, dst: {}, long: "(UTC+08:00) Perth", hem: "s" }, { name: "Australian Central Western Time", abbr: "ACWT", aliases: ["australia centralwestern", "acwdt", "aus central w. standard time", "eucla", "aus central west"], ids: ["Australia/Eucla"], std: { name: "Australian Central Western Standard Time", abbr: "ACWST", offset: 8.75 }, dst: {}, long: "(UTC+08:45) Eucla", hem: "s" }, { name: "East Timor Time", abbr: "TLT", aliases: ["east timor"], ids: ["Asia/Dili"], std: { abbr: "TLT", name: "East Timor Time", offset: 9 }, dst: {}, hem: "s" }, { name: "Eastern Indonesia Time", abbr: null, aliases: ["indonesia eastern"], ids: ["Asia/Jayapura"], std: { name: "Eastern Indonesia Time", abbr: "WIT", offset: 9 }, dst: {}, hem: "s" }, { name: "Japan Time", abbr: null, aliases: ["japan", "jdt", "tokyo standard time", "osaka", "sapporo", "tokyo"], ids: ["Asia/Tokyo"], std: { name: "Japan Standard Time", abbr: "JST", offset: 9 }, dst: {}, long: "(UTC+09:00) Osaka, Sapporo, Tokyo", hem: "n" }, { name: "Palau Time", abbr: null, aliases: ["palau"], ids: ["Pacific/Palau"], std: { abbr: "PWT", name: "Palau Time", offset: 9 }, dst: {}, hem: "n" }, { name: "", dupe: !0, ids: ["Australia/Darwin"], std: { name: "Australian Central Standard Time", abbr: "ACST", offset: 9.5 }, hem: "s" }, { name: "Dumont-d’Urville Time", abbr: null, aliases: ["dumontdurville"], ids: ["Antarctica/DumontDUrville"], std: { abbr: "CLST", name: "Dumont-d’Urville Time", offset: 10 }, dst: {}, hem: "s" }, { name: "Chuuk Time", abbr: null, aliases: ["truk"], ids: ["Pacific/Truk"], std: { abbr: "CHUT", name: "Chuuk Time", offset: 10 }, dst: {}, hem: "n" }, { name: "Lord Howe Time", abbr: "LHT", aliases: ["lord howe", "lord howe standard time"], ids: ["Australia/Lord_Howe"], std: { name: "Lord Howe Standard Time", abbr: "LHST", offset: 10.5 }, dst: { name: "Lord Howe Daylight Time", abbr: "LHDT", offset: 11.5 }, long: "(UTC+10:30) Lord Howe Island", hem: "s" }, { name: "Casey Time", abbr: "CAST", aliases: ["casey"], ids: ["Antarctica/Casey"], std: { abbr: "CAST", name: "Casey Time", offset: 11 }, dst: { name: "Casey Summer Time", offset: 8 }, hem: "s" }, { name: "Magadan Time", abbr: null, aliases: ["magadan", "magadan standard time"], ids: ["Asia/Magadan"], std: { abbr: "MAGT", name: "Magadan Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Magadan", hem: "n" }, { name: "Sakhalin Time", abbr: null, aliases: ["sakhalin", "sakhalin standard time"], ids: ["Asia/Sakhalin"], std: { abbr: "SAKT", name: "Sakhalin Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Sakhalin", hem: "n" }, { name: "Srednekolymsk Time", abbr: "SRET", aliases: ["srednekolymsk", "russia time zone 10", "chokurdakh"], ids: ["Asia/Srednekolymsk"], std: { abbr: "SRET", name: "Srednekolymsk Standard Time", offset: 11 }, dst: {}, long: "(UTC+11:00) Chokurdakh", hem: "n" }, { name: "Vanuatu Time", abbr: null, aliases: ["vanuatu"], ids: ["Pacific/Efate"], std: { abbr: "VUT", name: "Vanuatu Standard Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Solomon Islands Time", abbr: null, aliases: ["solomon"], ids: ["Pacific/Guadalcanal"], std: { abbr: "SBT", name: "Solomon Islands Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Kosrae Time", abbr: null, aliases: ["kosrae"], ids: ["Pacific/Kosrae"], std: { abbr: "KOST", name: "Kosrae Time", offset: 11 }, dst: {}, hem: "n" }, { name: "New Caledonia Time", abbr: null, aliases: ["new caledonia"], ids: ["Pacific/Noumea"], std: { abbr: "NCT", name: "New Caledonia Standard Time", offset: 11 }, dst: { name: "New Caledonia Summer Time" }, hem: "n" }, { name: "Ponape Time", abbr: null, aliases: ["ponape"], ids: ["Pacific/Ponape"], std: { abbr: "PONT", name: "Ponape Time", offset: 11 }, dst: {}, hem: "n" }, { name: "Anadyr Time", abbr: null, aliases: ["anadyr", "russia time zone 11", "petropavlovsk kamchatsky"], ids: ["Asia/Anadyr"], std: { abbr: "ANAT", name: "Anadyr Standard Time", offset: 12 }, dst: {}, long: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", hem: "n" }, { name: "Petropavlovsk-Kamchatski Time", abbr: null, aliases: ["kamchatka", "russia time zone 11", "anadyr", "petropavlovsk kamchatsky"], ids: ["Asia/Kamchatka"], std: { abbr: "PETT", name: "Petropavlovsk-Kamchatski Standard Time", offset: 12 }, dst: {}, long: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", hem: "n" }, { name: "Fiji Time", abbr: "FJT", aliases: ["fiji", "fiji standard time"], ids: ["Pacific/Fiji"], std: { abbr: "FJT", name: "Fiji Standard Time", offset: 12 }, dst: { abbr: "FJT", name: "Fiji Summer Time", offset: 13 }, long: "(UTC+12:00) Fiji", hem: "s" }, { name: "Tuvalu Time", abbr: "TVT", aliases: ["tuvalu"], ids: ["Pacific/Funafuti"], std: { abbr: "TVT", name: "Tuvalu Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Nauru Time", abbr: null, aliases: ["nauru"], ids: ["Pacific/Nauru"], std: { abbr: "NRT", name: "Nauru Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Norfolk Island Time", abbr: null, aliases: ["norfolk", "norfolk standard time", "norfolk island"], ids: ["Pacific/Norfolk"], std: { abbr: "NFT", name: "Norfolk Island Standard Time", offset: 12 }, dst: { abbr: "NFDT", name: "Norfolk Island Daylight Time", offset: 11 }, long: "(UTC+11:00) Norfolk Island", hem: "n" }, { name: "Gilbert Islands Time", abbr: null, aliases: ["gilbert islands"], ids: ["Pacific/Tarawa"], std: { abbr: "GILT", name: "Gilbert Islands Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Wake Island Time", abbr: null, aliases: ["wake"], ids: ["Pacific/Wake"], std: { abbr: "WAKT", name: "Wake Island Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Wallis & Futuna Time", abbr: null, aliases: ["wallis"], ids: ["Pacific/Wallis"], std: { abbr: "WFT", name: "Wallis & Futuna Time", offset: 12 }, dst: {}, hem: "n" }, { name: "Chatham Time", abbr: "CHAT", aliases: ["chatham", "chatham islands standard time", "chatham islands"], ids: ["Pacific/Chatham"], std: { name: "Chatham Standard Time", abbr: "CHAST", offset: 12.75 }, dst: { name: "Chatham Daylight Time", abbr: "CHADT", offset: 13.75 }, long: "(UTC+12:45) Chatham Islands", hem: "s" }, { name: "West Samoa Time", abbr: "WST", aliases: ["apia"], ids: ["Pacific/Apia"], std: { abbr: "WST", name: "West Samoa Time", offset: 13 }, dst: { abbr: "WST", name: "West Samoa Summer Time", offset: 14 }, hem: "s" }, { name: "Phoenix Islands Time", abbr: null, aliases: ["phoenix islands"], ids: ["Pacific/Enderbury"], std: { abbr: "PHOT", name: "Phoenix Islands Time", offset: 13 }, dst: {}, hem: "n" }, { name: "Tokelau Time", abbr: null, aliases: ["tokelau"], ids: ["Pacific/Fakaofo"], std: { abbr: "TKT", name: "Tokelau Time", offset: 13 }, dst: {}, hem: "n" }, { name: "Tonga Time", abbr: null, aliases: ["tonga", "tonga standard time", "nuku'alofa"], ids: ["Pacific/Tongatapu"], std: { abbr: "TOT", name: "Tonga Standard Time", offset: 13 }, dst: { name: "Tonga Summer Time", offset: 14 }, long: "(UTC+13:00) Nuku'alofa", hem: "s" }, { name: "Line Islands Time", abbr: null, aliases: ["line islands", "line islands standard time", "kiritimati island"], ids: ["Pacific/Kiritimati"], std: { abbr: "LINT", name: "Line Islands Time", offset: 14 }, dst: {}, long: "(UTC+14:00) Kiritimati Island", hem: "n" }, { name: "Niue Time", abbr: null, aliases: ["niue"], ids: ["Pacific/Niue"], std: { abbr: "NUT", name: "Niue Time", offset: -11 }, dst: {}, hem: "n" }, { name: "Cook Islands Time", abbr: "CKT", aliases: ["cook"], ids: ["Pacific/Rarotonga"], std: { abbr: "CKT", name: "Cook Islands Standard Time", offset: -10 }, dst: {}, hem: "n" }, { name: "Tahiti Time", abbr: null, aliases: ["tahiti"], ids: ["Pacific/Tahiti"], std: { abbr: "TAHT", name: "Tahiti Time", offset: -10 }, dst: {}, hem: "n" }, { name: "Marquesas Time", abbr: null, aliases: ["marquesas", "marquesas standard time"], ids: ["Pacific/Marquesas"], std: { abbr: "MART", name: "Marquesas Time", offset: -9.5 }, dst: {}, long: "(UTC-09:30) Marquesas Islands", hem: "n" }, { name: "Aleutian Standard Time", iso: "(UTC-10:00) Aleutian Islands", aliases: ["aleutian"], ids: ["America/Adak"], abbr: "HST", std: { name: "Hawaii Standard Time", abbr: "HST", offset: -10 }, dst: { name: "Hawaii Daylight Time", abbr: "HDT", offset: -9 }, hem: "n" }, { name: "Gambier Time", abbr: null, aliases: ["gambier", "utc-09", "coordinated universal time-09"], ids: ["Pacific/Gambier"], std: { abbr: "GAMT", name: "Gambier Time", offset: -9 }, dst: {}, long: "(UTC-09:00) Coordinated Universal Time-09", hem: "n" }, { name: "Pitcairn Time", abbr: null, aliases: ["pitcairn", "utc-08", "coordinated universal time-08"], ids: ["Pacific/Pitcairn"], std: { abbr: "PST", name: "Pitcairn Time", offset: -8 }, dst: {}, long: "(UTC-08:00) Coordinated Universal Time-08", hem: "n" }, { name: "", dupe: !0, ids: ["America/Hermosillo"], std: { name: "Mexican Pacific Standard Time", abbr: "HNPMX", offset: -7 }, hem: "n" }, { name: "Northwest Mexico Time", abbr: "HNOMX", aliases: ["mexico northwest", "pacific standard time (mexico)", "baja california", "pacific mexico"], ids: ["America/Santa_Isabel"], std: { name: "Northwest Mexico Standard Time", abbr: "HNNOMX", offset: -6 }, dst: { name: "Northwest Mexico Daylight Time", abbr: "HENOMX", offset: -5 }, long: "(UTC-08:00) Baja California", hem: "n" }, { name: "Easter Island Time", abbr: null, aliases: ["easter", "easter island standard time", "easter island"], ids: ["Pacific/Easter"], std: { name: "Easter Island Standard Time", abbr: "EAST", offset: -6 }, dst: { name: "Easter Island Summer Time", abbr: "EASST", offset: -5 }, long: "(UTC-06:00) Easter Island", hem: "s" }, { name: "Ecuador Time", abbr: null, aliases: ["ecuador"], ids: ["America/Guayaquil"], std: { name: "Ecuador Time", abbr: "ECT", offset: -5 }, dst: {}, hem: "n" }, { name: "Cuba Time", abbr: "HCU", aliases: ["cuba", "cuba standard time", "havana"], ids: ["America/Havana"], std: { name: "Cuba Standard Time", abbr: "HNCU", offset: -5 }, dst: { name: "Cuba Daylight Time", abbr: "HECU", offset: -4 }, long: "(UTC-05:00) Havana", hem: "n" }, { name: "Peru Time", abbr: null, aliases: ["peru"], ids: ["America/Lima"], std: { abbr: "PET", name: "Peru Standard Time", offset: -5 }, dst: {}, hem: "s" }, { name: "Paraguay Time", abbr: null, aliases: ["paraguay", "paraguay standard time", "asuncion"], ids: ["America/Asuncion"], std: { abbr: "PYT", name: "Paraguay Standard Time", offset: -4 }, dst: { name: "Paraguay Summer Time", offset: -3 }, long: "(UTC-04:00) Asuncion", hem: "s" }, { name: "Venezuela Time", abbr: null, aliases: ["venezuela", "venezuelan", "venezuela standard time", "caracas"], ids: ["America/Caracas"], std: { name: "Venezuela Time", abbr: "VET", offset: -4 }, dst: {}, long: "(UTC-04:00) Caracas", hem: "n" }, { name: "Guyana Time", abbr: null, aliases: ["guyana"], ids: ["America/Guyana"], std: { name: "Guyana Time", abbr: "GYT", offset: -4 }, dst: {}, hem: "n" }, { name: "Bolivia Time", abbr: null, aliases: ["bolivia"], ids: ["America/La_Paz"], std: { name: "Bolivia Time", abbr: "BOT", offset: -4 }, dst: {}, hem: "s" }, { name: "Newfoundland Time", abbr: "HTN", aliases: ["newfoundland", "newfoundland standard time"], ids: ["America/St_Johns"], std: { name: "Newfoundland Standard Time", abbr: "HNTN", offset: -3.5 }, dst: { name: "Newfoundland Daylight Time", abbr: "HETN", offset: -2.5 }, long: "(UTC-03:30) Newfoundland", hem: "n" }, { name: "French Guiana Time", abbr: null, aliases: ["french guiana"], ids: ["America/Cayenne"], std: { name: "French Guiana Time", abbr: "GFT", offset: -3 }, dst: {}, hem: "n" }, { name: "West Greenland Time", abbr: "HOG", aliases: ["greenland western", "greenland standard time", "greenland"], ids: ["America/Godthab"], std: { name: "West Greenland Standard Time", abbr: "HNOG", offset: -3 }, dst: { name: "West Greenland Summer Time", abbr: "HEOG", offset: -2 }, long: "(UTC-03:00) Greenland", hem: "n" }, { name: "St. Pierre & Miquelon Time", abbr: "HPM", aliases: ["pierre miquelon", "saint pierre standard time", "saint pierre and miquelon", "saint pierre"], ids: ["America/Miquelon"], std: { name: "St. Pierre & Miquelon Standard Time", abbr: "HNPM", offset: -3 }, dst: { name: "St. Pierre & Miquelon Daylight Time", abbr: "HEPM", offset: -2 }, long: "(UTC-03:00) Saint Pierre and Miquelon", hem: "n" }, { name: "Uruguay Time", abbr: "UYT", aliases: ["uruguay", "uyst", "montevideo standard time", "montevideo"], ids: ["America/Montevideo"], std: { name: "Uruguay Standard Time", abbr: "UYT", offset: -3 }, dst: {}, long: "(UTC-03:00) Montevideo", hem: "s" }, { name: "Suriname Time", abbr: null, aliases: ["suriname"], ids: ["America/Paramaribo"], std: { name: "Suriname Time", abbr: "SRT", offset: -3 }, dst: {}, hem: "n" }, { name: "Chile Time", abbr: "CLT", aliases: ["chile"], ids: ["America/Santiago"], std: { name: "Chile Standard Time", abbr: "CLT", offset: -3 }, dst: { name: "Chile Summer Time", abbr: "CLST", offset: -4 }, hem: "s" }, { name: "Falkland Islands Time", abbr: "FKT", aliases: ["falkland"], ids: ["Atlantic/Stanley"], std: { abbr: "FKST", name: "Falkland Islands Summer Time", offset: -3 }, dst: {}, hem: "s" }, { name: "Fernando de Noronha Time", abbr: null, aliases: ["noronha"], ids: ["America/Noronha"], std: { abbr: "FNT", name: "Fernando de Noronha Standard Time", offset: -2 }, dst: {}, hem: "n" }, { name: "South Georgia Time", abbr: null, aliases: ["south georgia"], ids: ["Atlantic/South_Georgia"], std: { abbr: "GST", name: "South Georgia Time", offset: -2 }, dst: {}, hem: "n" }, { name: "Azores Time", abbr: "AZOT", aliases: ["azores", "azores standard time"], ids: ["Atlantic/Azores"], std: { abbr: "AZOT", name: "Azores Standard Time", offset: -1 }, dst: { name: "Azores Summer Time", abbr: "AZOST", offset: 0 }, long: "(UTC-01:00) Azores", hem: "n" }, { name: "Cape Verde Time", abbr: null, aliases: ["cape verde", "cape verde standard time", "cabo verde"], ids: ["Atlantic/Cape_Verde"], std: { abbr: "CVT", name: "Cape Verde Standard Time", offset: -1 }, dst: {}, long: "(UTC-01:00) Cabo Verde Is.", hem: "n" }], Obc = { "asia/dili": "+9", "pacific/palau": "+9", "australia/west": "+8", "asia/ulan_bator": "+8/+7", "asia/choibalsan": "+8", "asia/chongqing": "+8", "asia/chungking": "+8", "asia/harbin": "+8", "asia/irkutsk": "+8", "asia/macao": "+8", "asia/ujung_pandang": "+8", "antarctica/davis": "+7", "indian/christmas": "+7", "asia/ho_chi_minh": "+7", "asia/hovd": "+7", "asia/novosibirsk": "+7", "asia/tomsk": "+7", "antarctica/vostok": "+6", "asia/dacca": "+6", "asia/dhaka": "+6", "asia/kashgar": "+6", "asia/omsk": "+6", "asia/thimbu": "+6", "asia/thimphu": "+6", "asia/urumqi": "+6", "indian/cocos": "+6.5", "antarctica/mawson": "+5", "indian/kerguelen": "+5", "asia/ashkhabad": "+5", "asia/dushanbe": "+5", "asia/yekaterinburg": "+5", "asia/kathmandu": "+5.75", "indian/reunion": "+4", "indian/mahe": "+4", "atlantic/jan_mayen": "+2/+1", "atlantic/faroe": "+1/0", "pacific/kiritimati": "+14", "pacific/apia": "+13/+12", "pacific/tongatapu": "+13/+12", "pacific/enderbury": "+13", "pacific/fakaofo": "+13", "antarctica/south_pole": "+12/+11", "pacific/norfolk": "+11.5/+10.5", "australia/lhi": "+10.5/+9.5", "etc/greenwich": "0", "etc/utc": "0", "etc/universal": "0", "etc/zulu": "0", "america/atka": "-9/-10", "pacific/gambier": "-9", "pacific/marquesas": "-9.5", "pacific/pitcairn": "-8", "america/ensenada": "-7/-8", "america/santa_isabel": "-7/-8", "mexico/bajanorte": "-7/-8", "canada/yukon": "-7/-8", "canada/east-saskatchewan": "-6", "antarctica/rothera": "-3", "atlantic/stanley": "-3", "america/nuuk": "-3/-4", "america/cayenne": "-3", "america/paramaribo": "-3", "america/rosario": "-3", "america/godthab": "-2/-3", "america/miquelon": "-2/-3", "america/noronha": "-2", "atlantic/south_georgia": "-2", "atlantic/cape_verde": "-1", "pacific/niue": "-11", "pacific/samoa": "-11", "pacific/rarotonga": "-10", "pacific/tahiti": "-10" };
const Zde = function(e) {
  let t = Cbc(e) || [];
  return typeof t == "string" && (t = [t]), t = t.map((n) => function(o) {
    if (!o)
      return null;
    let r = zbc.find((i) => i.ids.find((a) => a === o));
    if (!r) {
      let i = Obc[o.toLowerCase()];
      if (i !== void 0) {
        let a = `UTC${i}`, s = o.split(/\//), c = s[s.length - 1].replace(/\w\S*/g, function(l) {
          return l.charAt(0).toUpperCase() + l.substr(1).toLowerCase();
        });
        c = c.replace(/_/g, " "), c += " Time", r = { std: { name: c, abbr: a }, offset: null };
      } else {
        let a = o.replace(/^etc\//i, "");
        r = { std: { name: o, abbr: a }, offset: null };
      }
    }
    return { iana: o, standard: r.std || null, daylight: r.dst || null };
  }(n)), t;
};
Zde.prototype.version = "1.1.0";
var Pbc = Zde;
const Ibc = { "Pacific/Midway": "Midway Island, Samoa", "Pacific/Honolulu": "Hawaii", "America/Juneau": "Alaska", "America/Boise": "Mountain Time", "America/Dawson": "Dawson, Yukon", "America/Chihuahua": "Chihuahua, La Paz, Mazatlan", "America/Phoenix": "Arizona", "America/Chicago": "Central Time", "America/Regina": "Saskatchewan", "America/Mexico_City": "Guadalajara, Mexico City, Monterrey", "America/Belize": "Central America", "America/Detroit": "Eastern Time", "America/Bogota": "Bogota, Lima, Quito", "America/Caracas": "Caracas, La Paz", "America/Santiago": "Santiago", "America/St_Johns": "Newfoundland and Labrador", "America/Sao_Paulo": "Brasilia", "America/Tijuana": "Tijuana", "America/Montevideo": "Montevideo", "America/Argentina/Buenos_Aires": "Buenos Aires, Georgetown", "America/Godthab": "Greenland", "America/Los_Angeles": "Pacific Time", "Atlantic/Azores": "Azores", "Atlantic/Cape_Verde": "Cape Verde Islands", GMT: "UTC", "Europe/London": "Edinburgh, London", "Europe/Dublin": "Dublin", "Europe/Lisbon": "Lisbon", "Africa/Casablanca": "Casablanca, Monrovia", "Atlantic/Canary": "Canary Islands", "Europe/Belgrade": "Belgrade, Bratislava, Budapest, Ljubljana, Prague", "Europe/Sarajevo": "Sarajevo, Skopje, Warsaw, Zagreb", "Europe/Brussels": "Brussels, Copenhagen, Madrid, Paris", "Europe/Amsterdam": "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", "Africa/Algiers": "West Central Africa", "Europe/Bucharest": "Bucharest", "Africa/Cairo": "Cairo", "Europe/Helsinki": "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", "Europe/Athens": "Athens, Minsk", "Asia/Jerusalem": "Jerusalem", "Africa/Harare": "Harare, Pretoria", "Europe/Moscow": "Istanbul, Moscow, St. Petersburg, Volgograd", "Asia/Kuwait": "Kuwait, Riyadh", "Africa/Nairobi": "Nairobi", "Asia/Baghdad": "Baghdad", "Asia/Tehran": "Tehran", "Asia/Dubai": "Abu Dhabi, Muscat", "Asia/Baku": "Baku, Tbilisi, Yerevan", "Asia/Kabul": "Kabul", "Asia/Yekaterinburg": "Ekaterinburg", "Asia/Karachi": "Islamabad, Karachi, Tashkent", "Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi", "Asia/Kathmandu": "Kathmandu", "Asia/Dhaka": "Astana, Dhaka", "Asia/Colombo": "Sri Jayawardenepura", "Asia/Almaty": "Almaty, Novosibirsk", "Asia/Rangoon": "Yangon Rangoon", "Asia/Bangkok": "Bangkok, Hanoi, Jakarta", "Asia/Krasnoyarsk": "Krasnoyarsk", "Asia/Shanghai": "Beijing, Chongqing, Hong Kong SAR, Urumqi", "Asia/Kuala_Lumpur": "Kuala Lumpur, Singapore", "Asia/Taipei": "Taipei", "Australia/Perth": "Perth", "Asia/Irkutsk": "Irkutsk, Ulaanbaatar", "Asia/Seoul": "Seoul", "Asia/Tokyo": "Osaka, Sapporo, Tokyo", "Asia/Yakutsk": "Yakutsk", "Australia/Darwin": "Darwin", "Australia/Adelaide": "Adelaide", "Australia/Sydney": "Canberra, Melbourne, Sydney", "Australia/Brisbane": "Brisbane", "Australia/Hobart": "Hobart", "Asia/Vladivostok": "Vladivostok", "Pacific/Guam": "Guam, Port Moresby", "Asia/Magadan": "Magadan, Solomon Islands, New Caledonia", "Asia/Kamchatka": "Kamchatka, Marshall Islands", "Pacific/Fiji": "Fiji Islands", "Pacific/Auckland": "Auckland, Wellington", "Pacific/Tongatapu": "Nuku'alofa" }, Rbc = ({ value: e, onBlur: t, onChange: n, labelStyle: o = "original", timezones: r, ...i }) => {
  r || (r = Ibc);
  const a = $e.useMemo(() => Object.entries(r).reduce((c, l) => {
    var $, k, S, O;
    const d = k3.now(l[0]), u = d.timezone(), _ = Pbc(l[0]);
    let p = "", f = d.isDST() ? ($ = _[0].daylight) == null ? void 0 : $.abbr : (k = _[0].standard) == null ? void 0 : k.abbr, g = d.isDST() ? (S = _[0].daylight) == null ? void 0 : S.name : (O = _[0].standard) == null ? void 0 : O.name;
    const h = 60 * u.current.offset, b = (h / 60 ^ 0) + ":" + (h % 60 == 0 ? "00" : Math.abs(h % 60)), v = `(GMT${b.includes("-") ? b : `+${b}`}) ${l[1]}`;
    switch (o) {
      case "original":
        p = v;
        break;
      case "altName":
        p = `${v} ${g != null && g.length ? `(${g})` : ""}`;
        break;
      case "abbrev":
        p = `${v} ${(f == null ? void 0 : f.length) < 5 ? `(${f})` : ""}`;
        break;
      default:
        p = `${v}`;
    }
    return c.push({ value: u.name, label: p, offset: u.current.offset, abbrev: f, altName: g }), c;
  }, []).sort((c, l) => c.offset - l.offset), [o, r]);
  return $e.createElement(Tvc, { value: (s = e, typeof s == "object" && s.value && s.label ? s : typeof s == "string" ? a.find((c) => c.value === s) || s.indexOf("/") !== -1 && ((c) => {
    let l = k3.now("GMT");
    try {
      l = k3.now(c);
    } catch {
      return;
    }
    return a.filter((d) => d.offset === l.timezone().current.offset).map((d) => {
      let u = 0;
      return l.timezones[d.value.toLowerCase()] && !!l.timezones[d.value.toLowerCase()].dst === l.timezone().hasDst ? (d.value.toLowerCase().indexOf(l.tz.substring(l.tz.indexOf("/") + 1)) !== -1 && (u += 8), d.label.toLowerCase().indexOf(l.tz.substring(l.tz.indexOf("/") + 1)) !== -1 && (u += 4), d.value.toLowerCase().indexOf(l.tz.substring(0, l.tz.indexOf("/"))) && (u += 2), u += 1) : d.value === "GMT" && (u += 1), { tz: d, score: u };
    }).sort((d, u) => u.score - d.score).map(({ tz: d }) => d)[0];
  })(s) : s.value && !s.label ? a.find((c) => c.value === s.value) : void 0), onChange: (c) => {
    n && n(c);
  }, options: a, onBlur: t, ...i });
  var s;
};
function Nbc(e) {
  return [
    "null",
    "Africa/Malabo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "America/Anguilla",
    "America/Antigua",
    "America/Aruba",
    "America/Bahia",
    "America/Cayman",
    "America/Dominica",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Kralendijk",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Marigot",
    "America/Montserrat",
    "America/Nassau",
    "America/St_Barthelemy",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Tortola",
    "Antarctica/McMurdo",
    "Arctic/Longyearbyen",
    "Asia/Bahrain",
    "Atlantic/St_Helena",
    "Europe/Busingen",
    "Europe/Guernsey",
    "Europe/Isle_of_Man",
    "Europe/Mariehamn",
    "Europe/San_Marino",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Indian/Comoro",
    "Pacific/Saipan",
    "Africa/Asmara"
  ].includes(e);
}
const Dbc = (e, t) => t && e.label.toLowerCase().includes(t.toLowerCase()), Mbc = (e, t) => t.filter((n) => Dbc(n, e)), PH = (e) => Object.fromEntries(
  e.filter(({ timezone: t }) => t !== null && !Nbc(t)).map(({ label: t, timezone: n }) => [n, t])
), Lbc = (e) => e.replace(/^([-+])(0)(\d):00$/, (t, n, o, r) => `${n}${r}:00`), qbc = (e, t) => {
  const n = e.label.split(/[-+]/)[0].substring(1), o = e.label.split(") ")[1], r = ` ${n} ${Lbc(De.tz(void 0, e.value).format("Z"))}`;
  return t.length > 0 ? `${o}${r}` : `${e.value.replace(/_/g, " ")}${r}`;
};
var jbc = (
  /** @class */
  function() {
    function e() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, n) {
      this.keyToValue.set(t, n), this.valueToKey.set(n, t);
    }, e.prototype.getByKey = function(t) {
      return this.keyToValue.get(t);
    }, e.prototype.getByValue = function(t) {
      return this.valueToKey.get(t);
    }, e.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, e;
  }()
), Qde = (
  /** @class */
  function() {
    function e(t) {
      this.generateIdentifier = t, this.kv = new jbc();
    }
    return e.prototype.register = function(t, n) {
      this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
    }, e.prototype.clear = function() {
      this.kv.clear();
    }, e.prototype.getIdentifier = function(t) {
      return this.kv.getByValue(t);
    }, e.prototype.getValue = function(t) {
      return this.kv.getByKey(t);
    }, e;
  }()
), Fbc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, r) {
      o.__proto__ = r;
    } || function(o, r) {
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (o[i] = r[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), Vbc = (
  /** @class */
  function(e) {
    Fbc(t, e);
    function t() {
      var n = e.call(this, function(o) {
        return o.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return t.prototype.register = function(n, o) {
      typeof o == "object" ? (o.allowProps && this.classToAllowedProps.set(n, o.allowProps), e.prototype.register.call(this, n, o.identifier)) : e.prototype.register.call(this, n, o);
    }, t.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, t;
  }(Qde)
), P$ = new Vbc(), GS = new Qde(function(e) {
  var t;
  return (t = e.description) !== null && t !== void 0 ? t : "";
}), Bbc = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
};
function Ubc(e) {
  if ("values" in Object)
    return Object.values(e);
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function Wbc(e, t) {
  var n = Ubc(e);
  if ("find" in n)
    return n.find(t);
  for (var o = n, r = 0; r < o.length; r++) {
    var i = o[r];
    if (t(i))
      return i;
  }
}
function Iv(e, t) {
  Object.entries(e).forEach(function(n) {
    var o = Bbc(n, 2), r = o[0], i = o[1];
    return t(i, r);
  });
}
function HS(e, t) {
  return e.indexOf(t) !== -1;
}
function IH(e, t) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    if (t(o))
      return o;
  }
}
var S3 = {}, u$ = {
  register: function(e) {
    S3[e.name] = e;
  },
  findApplicable: function(e) {
    return Wbc(S3, function(t) {
      return t.isApplicable(e);
    });
  },
  findByName: function(e) {
    return S3[e];
  }
}, Gbc = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, Hbc = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
}, rE = [], Kbc = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  rE.push.apply(rE, Hbc([], Gbc(e)));
}, Jde = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}, Xde = function(e) {
  return typeof e > "u";
}, Ybc = function(e) {
  return e === null;
}, Ow = function(e) {
  return Jde(e) !== "Object" ? !1 : Object.getPrototypeOf(e) === null ? !0 : e === Object.prototype ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}, XD = function(e) {
  return Ow(e) && Object.keys(e).length === 0;
}, em = function(e) {
  return Array.isArray(e);
}, Zbc = function(e) {
  return typeof e == "string";
}, Qbc = function(e) {
  return typeof e == "number" && !isNaN(e);
}, Jbc = function(e) {
  return typeof e == "boolean";
}, Xbc = function(e) {
  return e instanceof RegExp;
}, iE = function(e) {
  return e instanceof Map;
}, aE = function(e) {
  return e instanceof Set;
}, eue = function(e) {
  return Jde(e) === "Symbol";
}, eyc = function(e) {
  return e instanceof Date && !isNaN(e.valueOf());
}, tyc = function(e) {
  return e instanceof Error;
}, RH = function(e) {
  return typeof e == "number" && isNaN(e);
}, NH = function(e) {
  return Jbc(e) || Ybc(e) || Xde(e) || Qbc(e) || Zbc(e) || eue(e);
}, nyc = function(e) {
  return typeof e == "bigint";
}, oyc = function(e) {
  return e === 1 / 0 || e === -1 / 0;
}, ryc = function(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}, tue = function(e) {
  return e.replace(/\./g, "\\.");
}, x3 = function(e) {
  return e.map(String).map(tue).join(".");
}, I$ = function(e) {
  for (var t = [], n = "", o = 0; o < e.length; o++) {
    var r = e.charAt(o), i = r === "\\" && e.charAt(o + 1) === ".";
    if (i) {
      n += ".", o++;
      continue;
    }
    var a = r === ".";
    if (a) {
      t.push(n), n = "";
      continue;
    }
    n += r;
  }
  var s = n;
  return t.push(s), t;
}, eM = function() {
  return eM = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, eM.apply(this, arguments);
}, tM = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, nM = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
};
function Fu(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var nue = [
  Fu(Xde, "undefined", function() {
    return null;
  }, function() {
  }),
  Fu(nyc, "bigint", function(e) {
    return e.toString();
  }, function(e) {
    return typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e);
  }),
  Fu(eyc, "Date", function(e) {
    return e.toISOString();
  }, function(e) {
    return new Date(e);
  }),
  Fu(tyc, "Error", function(e) {
    var t = {
      name: e.name,
      message: e.message
    };
    return rE.forEach(function(n) {
      t[n] = e[n];
    }), t;
  }, function(e) {
    var t = new Error(e.message);
    return t.name = e.name, t.stack = e.stack, rE.forEach(function(n) {
      t[n] = e[n];
    }), t;
  }),
  Fu(Xbc, "regexp", function(e) {
    return "" + e;
  }, function(e) {
    var t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  Fu(
    aE,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(e) {
      return nM([], tM(e.values()));
    },
    function(e) {
      return new Set(e);
    }
  ),
  Fu(iE, "map", function(e) {
    return nM([], tM(e.entries()));
  }, function(e) {
    return new Map(e);
  }),
  Fu(function(e) {
    return RH(e) || oyc(e);
  }, "number", function(e) {
    return RH(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity";
  }, Number),
  Fu(function(e) {
    return e === 0 && 1 / e === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number)
];
function _A(e, t, n, o) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: o
  };
}
var oue = _A(function(e) {
  if (eue(e)) {
    var t = !!GS.getIdentifier(e);
    return t;
  }
  return !1;
}, function(e) {
  var t = GS.getIdentifier(e);
  return ["symbol", t];
}, function(e) {
  return e.description;
}, function(e, t) {
  var n = GS.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), iyc = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(e, t) {
  return e[t.name] = t, e;
}, {}), rue = _A(ryc, function(e) {
  return ["typed-array", e.constructor.name];
}, function(e) {
  return nM([], tM(e));
}, function(e, t) {
  var n = iyc[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function iue(e) {
  if (e != null && e.constructor) {
    var t = !!P$.getIdentifier(e.constructor);
    return t;
  }
  return !1;
}
var aue = _A(iue, function(e) {
  var t = P$.getIdentifier(e.constructor);
  return ["class", t];
}, function(e) {
  var t = P$.getAllowedProps(e.constructor);
  if (!t)
    return eM({}, e);
  var n = {};
  return t.forEach(function(o) {
    n[o] = e[o];
  }), n;
}, function(e, t) {
  var n = P$.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(n.prototype), e);
}), sue = _A(function(e) {
  return !!u$.findApplicable(e);
}, function(e) {
  var t = u$.findApplicable(e);
  return ["custom", t.name];
}, function(e) {
  var t = u$.findApplicable(e);
  return t.serialize(e);
}, function(e, t) {
  var n = u$.findByName(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(e);
}), ayc = [aue, oue, sue, rue], DH = function(e) {
  var t = IH(ayc, function(o) {
    return o.isApplicable(e);
  });
  if (t)
    return {
      value: t.transform(e),
      type: t.annotation(e)
    };
  var n = IH(nue, function(o) {
    return o.isApplicable(e);
  });
  if (n)
    return {
      value: n.transform(e),
      type: n.annotation
    };
}, cue = {};
nue.forEach(function(e) {
  cue[e.annotation] = e;
});
var syc = function(e, t) {
  if (em(t))
    switch (t[0]) {
      case "symbol":
        return oue.untransform(e, t);
      case "class":
        return aue.untransform(e, t);
      case "custom":
        return sue.untransform(e, t);
      case "typed-array":
        return rue.untransform(e, t);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    var n = cue[t];
    if (!n)
      throw new Error("Unknown transformation: " + t);
    return n.untransform(e);
  }
}, C2 = function(e, t) {
  for (var n = e.keys(); t > 0; )
    n.next(), t--;
  return n.next().value;
};
function lue(e) {
  if (HS(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (HS(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (HS(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var cyc = function(e, t) {
  return lue(t), t.forEach(function(n) {
    e = e[n];
  }), e;
}, oM = function(e, t, n) {
  if (lue(t), t.length === 0)
    return n(e);
  for (var o = e, r = 0; r < t.length - 1; r++) {
    var i = t[r];
    if (em(o)) {
      var a = +i;
      o = o[a];
    } else if (Ow(o))
      o = o[i];
    else if (aE(o)) {
      var s = +i;
      o = C2(o, s);
    } else if (iE(o)) {
      var c = r === t.length - 2;
      if (c)
        break;
      var s = +i, l = +t[++r] == 0 ? "key" : "value", d = C2(o, s);
      switch (l) {
        case "key":
          o = d;
          break;
        case "value":
          o = o.get(d);
          break;
      }
    }
  }
  var u = t[t.length - 1];
  if ((em(o) || Ow(o)) && (o[u] = n(o[u])), aE(o)) {
    var _ = C2(o, +u), p = n(_);
    _ !== p && (o.delete(_), o.add(p));
  }
  if (iE(o)) {
    var s = +t[t.length - 2], f = C2(o, s), l = +u == 0 ? "key" : "value";
    switch (l) {
      case "key": {
        var g = n(f);
        o.set(g, o.get(f)), g !== f && o.delete(f);
        break;
      }
      case "value": {
        o.set(f, n(o.get(f)));
        break;
      }
    }
  }
  return e;
}, c_ = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var o = n.call(e), r, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; )
      i.push(r.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, Tp = function(e, t) {
  for (var n = 0, o = t.length, r = e.length; n < o; n++, r++)
    e[r] = t[n];
  return e;
};
function rM(e, t, n) {
  if (n === void 0 && (n = []), !!e) {
    if (!em(e)) {
      Iv(e, function(a, s) {
        return rM(a, t, Tp(Tp([], c_(n)), c_(I$(s))));
      });
      return;
    }
    var o = c_(e, 2), r = o[0], i = o[1];
    i && Iv(i, function(a, s) {
      rM(a, t, Tp(Tp([], c_(n)), c_(I$(s))));
    }), t(r, n);
  }
}
function lyc(e, t) {
  return rM(t, function(n, o) {
    e = oM(e, o, function(r) {
      return syc(r, n);
    });
  }), e;
}
function dyc(e, t) {
  function n(a, s) {
    var c = cyc(e, I$(s));
    a.map(I$).forEach(function(l) {
      e = oM(e, l, function() {
        return c;
      });
    });
  }
  if (em(t)) {
    var o = c_(t, 2), r = o[0], i = o[1];
    r.forEach(function(a) {
      e = oM(e, I$(a), function() {
        return e;
      });
    }), i && Iv(i, n);
  } else
    Iv(t, n);
  return e;
}
var uyc = function(e) {
  return Ow(e) || em(e) || iE(e) || aE(e) || iue(e);
};
function _yc(e, t, n) {
  var o = n.get(e);
  o ? o.push(t) : n.set(e, [t]);
}
function pyc(e) {
  var t = {}, n = void 0;
  return e.forEach(function(o) {
    if (!(o.length <= 1)) {
      var r = c_(o.map(function(s) {
        return s.map(String);
      }).sort(function(s, c) {
        return s.length - c.length;
      })), i = r[0], a = r.slice(1);
      i.length === 0 ? n = a.map(x3) : t[x3(i)] = a.map(x3);
    }
  }), n ? XD(t) ? [n] : [n, t] : XD(t) ? void 0 : t;
}
var due = function(e, t, n, o) {
  var r;
  if (n === void 0 && (n = []), o === void 0 && (o = []), NH(e) || _yc(e, n, t), !uyc(e)) {
    var i = DH(e);
    return i ? {
      transformedValue: i.value,
      annotations: [i.type]
    } : {
      transformedValue: e
    };
  }
  if (HS(o, e))
    return {
      transformedValue: null
    };
  var a = DH(e), s = (r = a == null ? void 0 : a.value) !== null && r !== void 0 ? r : e;
  NH(e) || (o = Tp(Tp([], c_(o)), [e]));
  var c = em(s) ? [] : {}, l = {};
  return Iv(s, function(d, u) {
    var _ = due(d, t, Tp(Tp([], c_(n)), [u]), o);
    c[u] = _.transformedValue, em(_.annotations) ? l[u] = _.annotations : Ow(_.annotations) && Iv(_.annotations, function(p, f) {
      l[tue(u) + "." + f] = p;
    });
  }), XD(l) ? {
    transformedValue: c,
    annotations: a ? [a.type] : void 0
  } : {
    transformedValue: c,
    annotations: a ? [a.type, l] : l
  };
};
function uue(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function myc(e) {
  return uue(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function MH(e) {
  return uue(e) === "Array";
}
function fyc(e, t, n, o, r) {
  const i = {}.propertyIsEnumerable.call(o, t) ? "enumerable" : "nonenumerable";
  i === "enumerable" && (e[t] = n), r && i === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function iM(e, t = {}) {
  if (MH(e))
    return e.map((r) => iM(r, t));
  if (!myc(e))
    return e;
  const n = Object.getOwnPropertyNames(e), o = Object.getOwnPropertySymbols(e);
  return [...n, ...o].reduce((r, i) => {
    if (MH(t.props) && !t.props.includes(i))
      return r;
    const a = e[i], s = iM(a, t);
    return fyc(r, i, s, e, t.nonenumerable), r;
  }, {});
}
var lf = function() {
  return lf = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, lf.apply(this, arguments);
}, _ue = function(e) {
  var t = /* @__PURE__ */ new Map(), n = due(e, t), o = {
    json: n.transformedValue
  };
  n.annotations && (o.meta = lf(lf({}, o.meta), { values: n.annotations }));
  var r = pyc(t);
  return r && (o.meta = lf(lf({}, o.meta), { referentialEqualities: r })), o;
}, pue = function(e) {
  var t = e.json, n = e.meta, o = iM(t);
  return n != null && n.values && (o = lyc(o, n.values)), n != null && n.referentialEqualities && (o = dyc(o, n.referentialEqualities)), o;
}, gyc = function(e) {
  return JSON.stringify(_ue(e));
}, hyc = function(e) {
  return pue(JSON.parse(e));
}, vyc = function(e, t) {
  return P$.register(e, t);
}, byc = function(e, t) {
  return GS.register(e, t);
}, yyc = function(e, t) {
  return u$.register(lf({ name: t }, e));
};
const $yc = {
  stringify: gyc,
  parse: hyc,
  serialize: _ue,
  deserialize: pue,
  registerClass: vyc,
  registerSymbol: byc,
  registerCustom: yyc,
  allowErrorProps: Kbc
};
function wyc(e) {
  return e;
}
function H0(e) {
  const t = {
    subscribe(n) {
      let o = null, r = !1, i = !1, a = !1;
      function s() {
        if (o === null) {
          a = !0;
          return;
        }
        i || (i = !0, typeof o == "function" ? o() : o && o.unsubscribe());
      }
      return o = e({
        next(c) {
          var l;
          r || (l = n.next) == null || l.call(n, c);
        },
        error(c) {
          var l;
          r || (r = !0, (l = n.error) == null || l.call(n, c), s());
        },
        complete() {
          var c;
          r || (r = !0, (c = n.complete) == null || c.call(n), s());
        }
      }), a && s(), {
        unsubscribe: s
      };
    },
    pipe(...n) {
      return kyc(n)(t);
    }
  };
  return t;
}
function kyc(e) {
  return e.length === 0 ? wyc : e.length === 1 ? e[0] : function(n) {
    return e.reduce((o, r) => r(o), n);
  };
}
class N9 extends Error {
  constructor(t) {
    super(t), this.name = "ObservableAbortError", Object.setPrototypeOf(this, N9.prototype);
  }
}
function Syc(e) {
  let t;
  return {
    promise: new Promise((o, r) => {
      let i = !1;
      function a() {
        i || (i = !0, r(new N9("This operation was aborted.")), s.unsubscribe());
      }
      const s = e.subscribe({
        next(c) {
          i = !0, o(c), a();
        },
        error(c) {
          i = !0, r(c), a();
        },
        complete() {
          i = !0, a();
        }
      });
      t = a;
    }),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    abort: t
  };
}
function xyc(e) {
  return (t) => {
    let n = 0, o = null;
    const r = [];
    function i() {
      o || (o = t.subscribe({
        next(s) {
          var c;
          for (const l of r)
            (c = l.next) == null || c.call(l, s);
        },
        error(s) {
          var c;
          for (const l of r)
            (c = l.error) == null || c.call(l, s);
        },
        complete() {
          var s;
          for (const c of r)
            (s = c.complete) == null || s.call(c);
        }
      }));
    }
    function a() {
      if (n === 0 && o) {
        const s = o;
        o = null, s.unsubscribe();
      }
    }
    return {
      subscribe(s) {
        return n++, r.push(s), i(), {
          unsubscribe() {
            n--, a();
            const c = r.findIndex((l) => l === s);
            c > -1 && r.splice(c, 1);
          }
        };
      }
    };
  };
}
function Eyc(e) {
  return (t) => ({
    subscribe(n) {
      return t.subscribe({
        next(o) {
          var r, i;
          (r = e.next) == null || r.call(e, o), (i = n.next) == null || i.call(n, o);
        },
        error(o) {
          var r, i;
          (r = e.error) == null || r.call(e, o), (i = n.error) == null || i.call(n, o);
        },
        complete() {
          var o, r;
          (o = e.complete) == null || o.call(e), (r = n.complete) == null || r.call(n);
        }
      });
    }
  });
}
function Tyc(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in e) {
    const o = e[n];
    t[o] = n;
  }
  return t;
}
function Pw(e) {
  return !!e && !Array.isArray(e) && typeof e == "object";
}
class Ayc extends Error {
}
function Cyc(e) {
  if (e instanceof Error)
    return e;
  const t = typeof e;
  if (!(t === "undefined" || t === "function" || e === null)) {
    if (t !== "object")
      return new Error(String(e));
    if (Pw(e)) {
      const n = new Ayc();
      for (const o in e)
        n[o] = e[o];
      return n;
    }
  }
}
const zyc = {
  /**
  * Invalid JSON was received by the server.
  * An error occurred on the server while parsing the JSON text.
  */
  PARSE_ERROR: -32700,
  /**
  * The JSON sent is not a valid Request object.
  */
  BAD_REQUEST: -32600,
  // Internal JSON-RPC error
  INTERNAL_SERVER_ERROR: -32603,
  NOT_IMPLEMENTED: -32603,
  // Implementation specific errors
  UNAUTHORIZED: -32001,
  FORBIDDEN: -32003,
  NOT_FOUND: -32004,
  METHOD_NOT_SUPPORTED: -32005,
  TIMEOUT: -32008,
  CONFLICT: -32009,
  PRECONDITION_FAILED: -32012,
  PAYLOAD_TOO_LARGE: -32013,
  UNPROCESSABLE_CONTENT: -32022,
  TOO_MANY_REQUESTS: -32029,
  CLIENT_CLOSED_REQUEST: -32099
};
Tyc(zyc);
const mue = () => {
};
function fue(e, t) {
  return new Proxy(mue, {
    get(o, r) {
      if (!(typeof r != "string" || r === "then"))
        return fue(e, [
          ...t,
          r
        ]);
    },
    apply(o, r, i) {
      const a = t[t.length - 1] === "apply";
      return e({
        args: a ? i.length >= 2 ? i[1] : [] : i,
        path: a ? t.slice(0, -1) : t
      });
    }
  });
}
const pA = (e) => fue(e, []), D9 = (e) => new Proxy(mue, {
  get(t, n) {
    if (!(typeof n != "string" || n === "then"))
      return e(n);
  }
});
var mie, fie, gie, hie, vie, bie;
typeof window > "u" || "Deno" in window || // eslint-disable-next-line @typescript-eslint/dot-notation
((fie = (mie = globalThis.process) == null ? void 0 : mie.env) == null ? void 0 : fie.NODE_ENV) === "test" || (hie = (gie = globalThis.process) == null ? void 0 : gie.env) != null && hie.JEST_WORKER_ID || (bie = (vie = globalThis.process) == null ? void 0 : vie.env) != null && bie.VITEST_WORKER_ID;
function Oyc(e, t) {
  if ("error" in e) {
    const o = t.deserialize(e.error);
    return {
      ok: !1,
      error: {
        ...e,
        error: o
      }
    };
  }
  return {
    ok: !0,
    result: {
      ...e.result,
      ...(!e.result.type || e.result.type === "data") && {
        type: "data",
        data: t.deserialize(e.result.data)
      }
    }
  };
}
class E3 extends Error {
  constructor() {
    super("Unable to transform response from server");
  }
}
function gue(e, t) {
  let n;
  try {
    n = Oyc(e, t);
  } catch {
    throw new E3();
  }
  if (!n.ok && (!Pw(n.error.error) || typeof n.error.error.code != "number"))
    throw new E3();
  if (n.ok && !Pw(n.result))
    throw new E3();
  return n;
}
function hue(e) {
  return H0((t) => {
    function n(r = 0, i = e.op) {
      const a = e.links[r];
      if (!a)
        throw new Error("No more links to execute - did you forget to add an ending link?");
      return a({
        op: i,
        next(c) {
          return n(r + 1, c);
        }
      });
    }
    return n().subscribe(t);
  });
}
function Pyc(e) {
  return e instanceof fl || /**
  * @deprecated
  * Delete in next major
  */
  e instanceof Error && e.name === "TRPCClientError";
}
function Iyc(e) {
  return Pw(e) && Pw(e.error) && typeof e.error.code == "number" && typeof e.error.message == "string";
}
class fl extends Error {
  static from(t, n = {}) {
    const o = t;
    return Pyc(o) ? (n.meta && (o.meta = {
      ...o.meta,
      ...n.meta
    }), o) : Iyc(o) ? new fl(o.error.message, {
      ...n,
      result: o
    }) : o instanceof Error ? new fl(o.message, {
      ...n,
      cause: Cyc(o)
    }) : new fl("Unknown error", {
      ...n,
      cause: o
    });
  }
  constructor(t, n) {
    var r, i;
    const o = n == null ? void 0 : n.cause;
    super(t, {
      cause: o
    }), this.meta = n == null ? void 0 : n.meta, this.cause = o, this.shape = (r = n == null ? void 0 : n.result) == null ? void 0 : r.error, this.data = (i = n == null ? void 0 : n.result) == null ? void 0 : i.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, fl.prototype);
  }
}
class vue {
  $request({ type: t, input: n, path: o, context: r = {} }) {
    return hue({
      links: this.links,
      op: {
        id: ++this.requestId,
        type: t,
        path: o,
        input: n,
        context: r
      }
    }).pipe(xyc());
  }
  requestAsPromise(t) {
    const n = this.$request(t), { promise: o, abort: r } = Syc(n);
    return new Promise((a, s) => {
      var c;
      (c = t.signal) == null || c.addEventListener("abort", r), o.then((l) => {
        a(l.result.data);
      }).catch((l) => {
        s(fl.from(l));
      });
    });
  }
  query(t, n, o) {
    return this.requestAsPromise({
      type: "query",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context,
      signal: o == null ? void 0 : o.signal
    });
  }
  mutation(t, n, o) {
    return this.requestAsPromise({
      type: "mutation",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context,
      signal: o == null ? void 0 : o.signal
    });
  }
  subscription(t, n, o) {
    return this.$request({
      type: "subscription",
      path: t,
      input: n,
      context: o == null ? void 0 : o.context
    }).subscribe({
      next(i) {
        var a, s, c;
        i.result.type === "started" ? (a = o.onStarted) == null || a.call(o) : i.result.type === "stopped" ? (s = o.onStopped) == null || s.call(o) : (c = o.onData) == null || c.call(o, i.result.data);
      },
      error(i) {
        var a;
        (a = o.onError) == null || a.call(o, i);
      },
      complete() {
        var i;
        (i = o.onComplete) == null || i.call(o);
      }
    });
  }
  constructor(t) {
    this.requestId = 0;
    const n = (() => {
      const o = t.transformer;
      return o ? "input" in o ? t.transformer : {
        input: o,
        output: o
      } : {
        input: {
          serialize: (r) => r,
          deserialize: (r) => r
        },
        output: {
          serialize: (r) => r,
          deserialize: (r) => r
        }
      };
    })();
    this.runtime = {
      transformer: {
        serialize: (o) => n.input.serialize(o),
        deserialize: (o) => n.output.deserialize(o)
      },
      combinedTransformer: n
    }, this.links = t.links.map((o) => o(this.runtime));
  }
}
function bue(e) {
  return new vue(e);
}
const Ryc = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, Nyc = (e) => Ryc[e];
function Dyc(e) {
  return D9((t) => e.hasOwnProperty(t) ? e[t] : t === "__untypedClient" ? e : pA(({ path: n, args: o }) => {
    const r = [
      t,
      ...n
    ], i = Nyc(r.pop()), a = r.join(".");
    return e[i](a, ...o);
  }));
}
function Myc(e) {
  return e.__untypedClient;
}
const LH = (e) => typeof e == "function";
function Lyc(e) {
  if (e)
    return e;
  if (typeof window < "u" && LH(window.fetch))
    return window.fetch;
  if (typeof globalThis < "u" && LH(globalThis.fetch))
    return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
const T3 = () => {
  throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
function A3(e) {
  let t = null, n = null;
  const o = () => {
    clearTimeout(n), n = null, t = null;
  };
  function r(s) {
    var d, u;
    const c = [
      []
    ];
    let l = 0;
    for (; ; ) {
      const _ = s[l];
      if (!_)
        break;
      const p = c[c.length - 1];
      if (_.aborted) {
        (d = _.reject) == null || d.call(_, new Error("Aborted")), l++;
        continue;
      }
      if (e.validate(p.concat(_).map((g) => g.key))) {
        p.push(_), l++;
        continue;
      }
      if (p.length === 0) {
        (u = _.reject) == null || u.call(_, new Error("Input is too big for a single dispatch")), l++;
        continue;
      }
      c.push([]);
    }
    return c;
  }
  function i() {
    const s = r(t);
    o();
    for (const c of s) {
      if (!c.length)
        continue;
      const l = {
        items: c,
        cancel: T3
      };
      for (const p of c)
        p.batch = l;
      const d = (p, f) => {
        var h;
        const g = l.items[p];
        (h = g.resolve) == null || h.call(g, f), g.batch = null, g.reject = null, g.resolve = null;
      }, { promise: u, cancel: _ } = e.fetch(l.items.map((p) => p.key), d);
      l.cancel = _, u.then((p) => {
        var f;
        for (let g = 0; g < p.length; g++) {
          const h = p[g];
          d(g, h);
        }
        for (const g of l.items)
          (f = g.reject) == null || f.call(g, new Error("Missing result")), g.batch = null;
      }).catch((p) => {
        var f;
        for (const g of l.items)
          (f = g.reject) == null || f.call(g, p), g.batch = null;
      });
    }
  }
  function a(s) {
    const c = {
      aborted: !1,
      key: s,
      batch: null,
      resolve: T3,
      reject: T3
    }, l = new Promise((u, _) => {
      c.reject = _, c.resolve = u, t || (t = []), t.push(c);
    });
    return n || (n = setTimeout(i)), {
      promise: l,
      cancel: () => {
        var u;
        c.aborted = !0, (u = c.batch) != null && u.items.every((_) => _.aborted) && (c.batch.cancel(), c.batch = null);
      }
    };
  }
  return {
    load: a
  };
}
function qyc(e) {
  return e || (typeof window < "u" && window.AbortController ? window.AbortController : typeof globalThis < "u" && globalThis.AbortController ? globalThis.AbortController : null);
}
function yue(e) {
  return {
    url: e.url.toString().replace(/\/$/, ""),
    fetch: e.fetch,
    AbortController: qyc(e.AbortController)
  };
}
function jyc(e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    t[n] = o;
  }
  return t;
}
const Fyc = {
  query: "GET",
  mutation: "POST"
};
function $ue(e) {
  return "input" in e ? e.runtime.transformer.serialize(e.input) : jyc(e.inputs.map((t) => e.runtime.transformer.serialize(t)));
}
const wue = (e) => {
  let t = e.url + "/" + e.path;
  const n = [];
  if ("inputs" in e && n.push("batch=1"), e.type === "query") {
    const o = $ue(e);
    o !== void 0 && n.push(`input=${encodeURIComponent(JSON.stringify(o))}`);
  }
  return n.length && (t += "?" + n.join("&")), t;
}, Vyc = (e) => {
  if (e.type === "query")
    return;
  const t = $ue(e);
  return t !== void 0 ? JSON.stringify(t) : void 0;
}, kue = (e) => Uyc({
  ...e,
  contentTypeHeader: "application/json",
  getUrl: wue,
  getBody: Vyc
});
async function Byc(e, t) {
  const n = e.getUrl(e), o = e.getBody(e), { type: r } = e, i = await (async () => {
    const s = await e.headers();
    return Symbol.iterator in s ? Object.fromEntries(s) : s;
  })();
  /* istanbul ignore if -- @preserve */
  if (r === "subscription")
    throw new Error("Subscriptions should use wsLink");
  const a = {
    ...e.contentTypeHeader ? {
      "content-type": e.contentTypeHeader
    } : {},
    ...e.batchModeHeader ? {
      "trpc-batch-mode": e.batchModeHeader
    } : {},
    ...i
  };
  return Lyc(e.fetch)(n, {
    method: Fyc[r],
    signal: t == null ? void 0 : t.signal,
    body: o,
    headers: a
  });
}
function Uyc(e) {
  const t = e.AbortController ? new e.AbortController() : null, n = {};
  let o = !1;
  return {
    promise: new Promise((a, s) => {
      Byc(e, t).then((c) => (n.response = c, o = !0, c.json())).then((c) => {
        n.responseJSON = c, a({
          json: c,
          meta: n
        });
      }).catch((c) => {
        o = !0, s(fl.from(c, {
          meta: n
        }));
      });
    }),
    cancel: () => {
      o || t == null || t.abort();
    }
  };
}
function Wyc(e) {
  return function(n) {
    const o = yue(n), r = n.maxURLLength ?? 1 / 0;
    return (i) => {
      const a = (u) => {
        const _ = (f) => {
          if (r === 1 / 0)
            return !0;
          const g = f.map((v) => v.path).join(","), h = f.map((v) => v.input);
          return wue({
            ...o,
            runtime: i,
            type: u,
            path: g,
            inputs: h
          }).length <= r;
        }, p = e({
          ...o,
          runtime: i,
          type: u,
          opts: n
        });
        return {
          validate: _,
          fetch: p
        };
      }, s = A3(a("query")), c = A3(a("mutation")), l = A3(a("subscription")), d = {
        query: s,
        subscription: l,
        mutation: c
      };
      return ({ op: u }) => H0((_) => {
        const p = d[u.type], { promise: f, cancel: g } = p.load(u);
        let h;
        return f.then((b) => {
          h = b;
          const v = gue(b.json, i.transformer);
          if (!v.ok) {
            _.error(fl.from(v.error, {
              meta: b.meta
            }));
            return;
          }
          _.next({
            context: b.meta,
            result: v.result
          }), _.complete();
        }).catch((b) => {
          _.error(fl.from(b, {
            meta: h == null ? void 0 : h.meta
          }));
        }), () => {
          g();
        };
      });
    };
  };
}
const Gyc = (e) => (t) => {
  const n = t.map((a) => a.path).join(","), o = t.map((a) => a.input), { promise: r, cancel: i } = kue({
    ...e,
    path: n,
    inputs: o,
    headers() {
      return e.opts.headers ? typeof e.opts.headers == "function" ? e.opts.headers({
        opList: t
      }) : e.opts.headers : {};
    }
  });
  return {
    promise: r.then((a) => (Array.isArray(a.json) ? a.json : t.map(() => a.json)).map((l) => ({
      meta: a.meta,
      json: l
    }))),
    cancel: i
  };
}, Hyc = Wyc(Gyc);
function Kyc(e) {
  return (t) => {
    const n = yue(t);
    return (o) => ({ op: r }) => H0((i) => {
      const { path: a, input: s, type: c } = r, { promise: l, cancel: d } = e.requester({
        ...n,
        runtime: o,
        type: c,
        path: a,
        input: s,
        headers() {
          return t.headers ? typeof t.headers == "function" ? t.headers({
            op: r
          }) : t.headers : {};
        }
      });
      let u;
      return l.then((_) => {
        u = _.meta;
        const p = gue(_.json, o.transformer);
        if (!p.ok) {
          i.error(fl.from(p.error, {
            meta: u
          }));
          return;
        }
        i.next({
          context: _.meta,
          result: p.result
        }), i.complete();
      }).catch((_) => {
        i.error(fl.from(_, {
          meta: u
        }));
      }), () => {
        d();
      };
    });
  };
}
const Yyc = Kyc({
  requester: kue
});
function Zyc(e) {
  return typeof FormData > "u" ? !1 : e instanceof FormData;
}
const C3 = {
  css: {
    query: [
      "72e3ff",
      "3fb0d8"
    ],
    mutation: [
      "c5a3fc",
      "904dfc"
    ],
    subscription: [
      "ff49e1",
      "d83fbe"
    ]
  },
  ansi: {
    regular: {
      // Cyan background, black and white text respectively
      query: [
        "\x1B[30;46m",
        "\x1B[97;46m"
      ],
      // Magenta background, black and white text respectively
      mutation: [
        "\x1B[30;45m",
        "\x1B[97;45m"
      ],
      // Green background, black and white text respectively
      subscription: [
        "\x1B[30;42m",
        "\x1B[97;42m"
      ]
    },
    bold: {
      query: [
        "\x1B[1;30;46m",
        "\x1B[1;97;46m"
      ],
      mutation: [
        "\x1B[1;30;45m",
        "\x1B[1;97;45m"
      ],
      subscription: [
        "\x1B[1;30;42m",
        "\x1B[1;97;42m"
      ]
    }
  }
};
function Qyc(e) {
  const { direction: t, type: n, path: o, id: r, input: i } = e, a = [], s = [];
  if (e.colorMode === "ansi") {
    const [u, _] = C3.ansi.regular[n], [p, f] = C3.ansi.bold[n], g = "\x1B[0m";
    return a.push(t === "up" ? u : _, t === "up" ? ">>" : "<<", n, t === "up" ? p : f, `#${r}`, o, g), t === "up" ? s.push({
      input: e.input
    }) : s.push({
      input: e.input,
      // strip context from result cause it's too noisy in terminal wihtout collapse mode
      result: "result" in e.result ? e.result.result : e.result,
      elapsedMs: e.elapsedMs
    }), {
      parts: a,
      args: s
    };
  }
  const [c, l] = C3.css[n], d = `
    background-color: #${t === "up" ? c : l};
    color: ${t === "up" ? "black" : "white"};
    padding: 2px;
  `;
  return a.push("%c", t === "up" ? ">>" : "<<", n, `#${r}`, `%c${o}%c`, "%O"), s.push(d, `${d}; font-weight: bold;`, `${d}; font-weight: normal;`), t === "up" ? s.push({
    input: i,
    context: e.context
  }) : s.push({
    input: i,
    result: e.result,
    elapsedMs: e.elapsedMs,
    context: e.context
  }), {
    parts: a,
    args: s
  };
}
const Jyc = ({ c: e = console, colorMode: t = "css" }) => (n) => {
  const o = n.input, r = Zyc(o) ? Object.fromEntries(o) : o, { parts: i, args: a } = Qyc({
    ...n,
    colorMode: t,
    input: r
  }), s = n.direction === "down" && n.result && (n.result instanceof Error || "error" in n.result.result) ? "error" : "log";
  e[s].apply(null, [
    i.join(" ")
  ].concat(a));
};
function Xyc(e = {}) {
  const { enabled: t = () => !0 } = e, n = e.colorMode ?? (typeof window > "u" ? "ansi" : "css"), { logger: o = Jyc({
    c: e.console,
    colorMode: n
  }) } = e;
  return () => ({ op: r, next: i }) => H0((a) => {
    t({
      ...r,
      direction: "up"
    }) && o({
      ...r,
      direction: "up"
    });
    const s = Date.now();
    function c(l) {
      const d = Date.now() - s;
      t({
        ...r,
        direction: "down",
        result: l
      }) && o({
        ...r,
        direction: "down",
        elapsedMs: d,
        result: l
      });
    }
    return i(r).pipe(Eyc({
      next(l) {
        c(l);
      },
      error(l) {
        c(l);
      }
    })).subscribe(a);
  });
}
function qH(e) {
  return Array.isArray(e) ? e : [
    e
  ];
}
function e$c(e) {
  return (t) => {
    const n = qH(e.true).map((r) => r(t)), o = qH(e.false).map((r) => r(t));
    return (r) => H0((i) => {
      const a = e.condition(r.op) ? n : o;
      return hue({
        op: r.op,
        links: a
      }).subscribe(i);
    });
  };
}
function t$c(e, t) {
  return pA(({ path: n, args: o }) => {
    const r = [
      e,
      ...n
    ], i = r.pop();
    if (i === "useMutation")
      return t[i](r, ...o);
    if (i === "_def")
      return {
        path: r
      };
    const [a, ...s] = o, c = s[0] || {};
    return t[i](r, a, c);
  });
}
const n$c = [
  "client",
  "ssrContext",
  "ssrState",
  "abortOnUnmount"
];
var yie;
const o$c = (yie = $e.createContext) == null ? void 0 : yie.call($e, null);
function Jm(e, t, n) {
  const o = e.flatMap((r) => r.split("."));
  if (!t && (!n || n === "any"))
    return o.length ? [
      o
    ] : [];
  if (n === "infinite" && t && typeof t == "object" && "cursor" in t) {
    const { cursor: r, ...i } = t;
    return [
      o,
      {
        input: i,
        type: "infinite"
      }
    ];
  }
  return [
    o,
    {
      ...typeof t < "u" && {
        input: t
      },
      ...n && n !== "any" && {
        type: n
      }
    }
  ];
}
const r$c = (e) => {
  switch (e) {
    case "fetch":
    case "ensureData":
    case "prefetch":
    case "getData":
    case "setData":
      return "query";
    case "fetchInfinite":
    case "prefetchInfinite":
    case "getInfiniteData":
    case "setInfiniteData":
      return "infinite";
    case "cancel":
    case "invalidate":
    case "refetch":
    case "reset":
      return "any";
  }
};
function i$c(e, t) {
  return pA((n) => {
    const o = [
      t,
      ...n.path
    ], r = o.pop(), i = [
      ...n.args
    ], a = i.shift(), s = r$c(r), c = Jm(o, a, s);
    return {
      fetch: () => e.fetchQuery(c, ...i),
      fetchInfinite: () => e.fetchInfiniteQuery(c, i[0]),
      prefetch: () => e.prefetchQuery(c, ...i),
      prefetchInfinite: () => e.prefetchInfiniteQuery(c, i[0]),
      ensureData: () => e.ensureQueryData(c, ...i),
      invalidate: () => e.invalidateQueries(c, ...i),
      reset: () => e.resetQueries(c, ...i),
      refetch: () => e.refetchQueries(c, ...i),
      cancel: () => e.cancelQuery(c, ...i),
      setData: () => {
        e.setQueryData(c, i[0], i[1]);
      },
      setInfiniteData: () => {
        e.setInfiniteQueryData(c, i[0], i[1]);
      },
      getData: () => e.getQueryData(c),
      getInfiniteData: () => e.getInfiniteQueryData(c)
    }[r]();
  });
}
function a$c(e) {
  return D9((t) => {
    const n = t;
    return n === "client" ? Dyc(e.client) : n$c.includes(n) ? e[n] : i$c(e, t);
  });
}
function jH(e) {
  return pA((t) => {
    const n = t.path, o = n.join("."), [r, i] = t.args;
    return {
      queryKey: Jm(n, r, "query"),
      queryFn: () => e.query(o, r, i == null ? void 0 : i.trpc),
      ...i
    };
  });
}
function Bd(e, t, n) {
  var i;
  const o = e[0], r = (i = e[1]) == null ? void 0 : i.input;
  return n && (r.cursor = n), [
    o.join("."),
    r,
    t == null ? void 0 : t.trpc
  ];
}
function zy(e) {
  const t = $e.useRef(e);
  return t.current.path = e.path, t.current;
}
function s$c(e) {
  const { client: t, queryClient: n } = e, o = t instanceof vue ? t : Myc(t);
  return {
    fetchQuery: (r, i) => n.fetchQuery({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Bd(r, i))
    }),
    fetchInfiniteQuery: (r, i) => n.fetchInfiniteQuery({
      ...i,
      queryKey: r,
      queryFn: ({ pageParam: a }) => o.query(...Bd(r, i, a)),
      initialPageParam: (i == null ? void 0 : i.initialCursor) ?? null
    }),
    prefetchQuery: (r, i) => n.prefetchQuery({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Bd(r, i))
    }),
    prefetchInfiniteQuery: (r, i) => n.prefetchInfiniteQuery({
      ...i,
      queryKey: r,
      queryFn: ({ pageParam: a }) => o.query(...Bd(r, i, a)),
      initialPageParam: (i == null ? void 0 : i.initialCursor) ?? null
    }),
    ensureQueryData: (r, i) => n.ensureQueryData({
      ...i,
      queryKey: r,
      queryFn: () => o.query(...Bd(r, i))
    }),
    invalidateQueries: (r, i, a) => n.invalidateQueries({
      ...i,
      queryKey: r
    }, a),
    resetQueries: (r, i, a) => n.resetQueries({
      ...i,
      queryKey: r
    }, a),
    refetchQueries: (r, i, a) => n.refetchQueries({
      ...i,
      queryKey: r
    }, a),
    cancelQuery: (r, i) => n.cancelQueries({
      queryKey: r
    }, i),
    setQueryData: (r, i, a) => n.setQueryData(r, i, a),
    getQueryData: (r) => n.getQueryData(r),
    setInfiniteQueryData: (r, i, a) => n.setQueryData(r, i, a),
    getInfiniteQueryData: (r) => n.getQueryData(r)
  };
}
function Sue(e) {
  var h, b;
  const t = ((b = (h = e == null ? void 0 : e.overrides) == null ? void 0 : h.useMutation) == null ? void 0 : b.onSuccess) ?? ((v) => v.originalFn()), n = (e == null ? void 0 : e.context) ?? o$c, o = (v) => bue(v), r = (v) => {
    const { abortOnUnmount: $ = !1, client: k, queryClient: S, ssrContext: O } = v, [I, D] = $e.useState(v.ssrState ?? !1), M = $e.useMemo(() => s$c({
      client: k,
      queryClient: S
    }), [
      k,
      S
    ]), N = $e.useMemo(() => ({
      abortOnUnmount: $,
      queryClient: S,
      client: k,
      ssrContext: O ?? null,
      ssrState: I,
      ...M
    }), [
      $,
      k,
      M,
      S,
      O,
      I
    ]);
    return $e.useEffect(() => {
      D((C) => C ? "mounted" : !1);
    }, []), /* @__PURE__ */ $e.createElement(n.Provider, {
      value: N
    }, v.children);
  };
  function i() {
    const v = $e.useContext(n);
    if (!v)
      throw new Error("Unable to find tRPC Context. Did you forget to wrap your App inside `withTRPC` HoC?");
    return v;
  }
  function a(v, $) {
    var O;
    const { queryClient: k, ssrState: S } = i();
    return S && S !== "mounted" && ((O = k.getQueryCache().find({
      queryKey: v
    })) == null ? void 0 : O.state.status) === "error" ? {
      retryOnMount: !1,
      ...$
    } : $;
  }
  function s(v, $, k) {
    var T, z;
    const S = i(), { abortOnUnmount: O, client: I, ssrState: D, queryClient: M, prefetchQuery: N } = S, C = Jm(v, $, "query"), P = M.getQueryDefaults(C);
    typeof window > "u" && D === "prepass" && ((T = k == null ? void 0 : k.trpc) == null ? void 0 : T.ssr) !== !1 && ((k == null ? void 0 : k.enabled) ?? (P == null ? void 0 : P.enabled)) !== !1 && !M.getQueryCache().find({
      queryKey: C
    }) && N(C, k);
    const x = a(C, {
      ...P,
      ...k
    }), w = ((z = k == null ? void 0 : k.trpc) == null ? void 0 : z.abortOnUnmount) ?? (e == null ? void 0 : e.abortOnUnmount) ?? O, E = go({
      ...x,
      queryKey: C,
      queryFn: (j) => {
        const q = {
          ...x,
          trpc: {
            ...x == null ? void 0 : x.trpc,
            ...w ? {
              signal: j.signal
            } : {}
          }
        };
        return I.query(...Bd(C, q));
      }
    }, M);
    return E.trpc = zy({
      path: v.join(".")
    }), E;
  }
  function c(v, $, k) {
    var M;
    const S = i(), O = Jm(v, $, "query"), I = ((M = k == null ? void 0 : k.trpc) == null ? void 0 : M.abortOnUnmount) ?? (e == null ? void 0 : e.abortOnUnmount) ?? S.abortOnUnmount, D = dCe({
      ...k,
      queryKey: O,
      queryFn: (N) => {
        const C = {
          trpc: {
            ...I ? {
              signal: N.signal
            } : {}
          }
        };
        return S.client.query(...Bd(O, C));
      }
    }, S.queryClient);
    return D.trpc = zy({
      path: v.join(".")
    }), [
      D.data,
      D
    ];
  }
  function l(v, $) {
    const { client: k } = i(), S = ns(), O = [
      v
    ], I = S.getMutationDefaults(O), D = Yo({
      ...$,
      mutationKey: O,
      mutationFn: (M) => k.mutation(...Bd([
        v,
        {
          input: M
        }
      ], $)),
      onSuccess(...M) {
        return t({
          originalFn: () => {
            var C, P;
            return ((C = $ == null ? void 0 : $.onSuccess) == null ? void 0 : C.call($, ...M)) ?? ((P = I == null ? void 0 : I.onSuccess) == null ? void 0 : P.call(I, ...M));
          },
          queryClient: S,
          meta: ($ == null ? void 0 : $.meta) ?? (I == null ? void 0 : I.meta) ?? {}
        });
      }
    }, S);
    return D.trpc = zy({
      path: v.join(".")
    }), D;
  }
  /* istanbul ignore next -- @preserve */
  function d(v, $, k) {
    const S = (k == null ? void 0 : k.enabled) ?? !0, O = Hp(Jm(v, $, "any")), { client: I } = i(), D = $e.useRef(k);
    D.current = k, $e.useEffect(() => {
      if (!S)
        return;
      let M = !1;
      const N = I.subscription(v.join("."), $ ?? void 0, {
        onStarted: () => {
          var C, P;
          M || (P = (C = D.current).onStarted) == null || P.call(C);
        },
        onData: (C) => {
          M || k.onData(C);
        },
        onError: (C) => {
          var P, x;
          M || (x = (P = D.current).onError) == null || x.call(P, C);
        }
      });
      return () => {
        M = !0, N.unsubscribe();
      };
    }, [
      O,
      S
    ]);
  }
  function u(v, $, k) {
    var E, T;
    const { client: S, ssrState: O, prefetchInfiniteQuery: I, queryClient: D, abortOnUnmount: M } = i(), N = Jm(v, $, "infinite"), C = D.getQueryDefaults(N);
    typeof window > "u" && O === "prepass" && ((E = k == null ? void 0 : k.trpc) == null ? void 0 : E.ssr) !== !1 && ((k == null ? void 0 : k.enabled) ?? (C == null ? void 0 : C.enabled)) !== !1 && !D.getQueryCache().find({
      queryKey: N
    }) && I(N, {
      ...C,
      ...k
    });
    const P = a(N, {
      ...C,
      ...k
    }), x = ((T = k == null ? void 0 : k.trpc) == null ? void 0 : T.abortOnUnmount) ?? M, w = fCe({
      ...P,
      initialPageParam: k.initialCursor ?? null,
      persister: k.persister,
      queryKey: N,
      queryFn: (z) => {
        const j = {
          ...P,
          trpc: {
            ...P == null ? void 0 : P.trpc,
            ...x ? {
              signal: z.signal
            } : {}
          }
        };
        return S.query(...Bd(N, j, z.pageParam ?? k.initialCursor));
      }
    }, D);
    return w.trpc = zy({
      path: v.join(".")
    }), w;
  }
  function _(v, $, k) {
    var C;
    const S = i(), O = Jm(v, $, "infinite"), I = S.queryClient.getQueryDefaults(O), D = a(O, {
      ...I,
      ...k
    }), M = ((C = k == null ? void 0 : k.trpc) == null ? void 0 : C.abortOnUnmount) ?? S.abortOnUnmount, N = uCe({
      ...k,
      initialPageParam: k.initialCursor ?? null,
      queryKey: O,
      queryFn: (P) => {
        const x = {
          ...D,
          trpc: {
            ...D == null ? void 0 : D.trpc,
            ...M ? {
              signal: P.signal
            } : {}
          }
        };
        return S.client.query(...Bd(O, x, P.pageParam ?? k.initialCursor));
      }
    }, S.queryClient);
    return N.trpc = zy({
      path: v.join(".")
    }), [
      N.data,
      N
    ];
  }
  return {
    Provider: r,
    createClient: o,
    useContext: i,
    useUtils: i,
    useQuery: s,
    useSuspenseQuery: c,
    useQueries: (v) => {
      var M;
      const { ssrState: $, queryClient: k, prefetchQuery: S, client: O } = i(), I = jH(O), D = v(I);
      if (typeof window > "u" && $ === "prepass")
        for (const N of D) {
          const C = N;
          ((M = C.trpc) == null ? void 0 : M.ssr) !== !1 && !k.getQueryCache().find({
            queryKey: C.queryKey
          }) && S(C.queryKey, C);
        }
      return Zie({
        queries: D.map((N) => ({
          ...N,
          queryKey: N.queryKey
        }))
      }, k);
    },
    useSuspenseQueries: (v) => {
      const { queryClient: $, client: k } = i(), S = jH(k), O = v(S), I = _Ce({
        queries: O.map((D) => ({
          ...D,
          queryKey: D.queryKey
        }))
      }, $);
      return [
        I.map((D) => D.data),
        I
      ];
    },
    useMutation: l,
    useSubscription: d,
    useDehydratedState: (v, $) => $e.useMemo(() => $ && v.runtime.transformer.deserialize($), [
      $,
      v
    ]),
    useInfiniteQuery: u,
    useSuspenseInfiniteQuery: _
  };
}
const FH = (e) => e.queryClient ?? new Mie(e.queryClientConfig);
function VH(e) {
  const t = e.state.error;
  if (t instanceof Error && t.name === "TRPCClientError") {
    const n = {
      message: t.message,
      data: t.data,
      shape: t.shape
    };
    return {
      ...e,
      state: {
        ...e.state,
        error: n
      }
    };
  }
  return e;
}
function c$c(e) {
  const { config: t } = e;
  return (n) => {
    const o = Sue(e), r = (a) => {
      var p;
      const [s] = ze(() => {
        if (a.trpc)
          return a.trpc;
        const f = t({}), g = FH(f), h = o.createClient(f);
        return {
          abortOnUnmount: f.abortOnUnmount,
          queryClient: g,
          trpcClient: h,
          ssrState: e.ssr ? "mounting" : !1,
          ssrContext: null
        };
      }), { queryClient: c, trpcClient: l, ssrState: d, ssrContext: u } = s, _ = o.useDehydratedState(l, (p = a.pageProps) == null ? void 0 : p.trpcState);
      return /* @__PURE__ */ ve.createElement(o.Provider, {
        abortOnUnmount: s.abortOnUnmount ?? !1,
        client: l,
        queryClient: c,
        ssrState: d,
        ssrContext: u
      }, /* @__PURE__ */ ve.createElement(Fie, {
        client: c
      }, /* @__PURE__ */ ve.createElement(pCe, {
        state: _
      }, /* @__PURE__ */ ve.createElement(n, Object.assign({}, a)))));
    };
    (n.getInitialProps ?? e.ssr) && (r.getInitialProps = async (a) => {
      var I, D;
      const c = await (async () => {
        if (typeof e.ssr == "function") {
          if (typeof window < "u")
            return !1;
          try {
            return await e.ssr({
              ctx: a.ctx
            });
          } catch {
            return !1;
          }
        }
        return e.ssr;
      })(), l = a.AppTree, d = !!a.Component, u = d ? a.ctx : a;
      let _ = {};
      if (n.getInitialProps) {
        const M = await n.getInitialProps(a);
        _ = {
          ...d ? M.pageProps ?? {} : M,
          ..._
        };
      }
      const p = (M) => d ? {
        pageProps: M
      } : M;
      if (typeof window < "u" || !c)
        return p(_);
      const f = t({
        ctx: u
      }), g = bue(f), h = FH(f), v = {
        pageProps: _,
        trpc: {
          config: f,
          trpcClient: g,
          queryClient: h,
          ssrState: "prepass",
          ssrContext: u
        }
      }, $ = await import("./server.browser-6clCAqw-.js").then((M) => M.s);
      for (; $.renderToString(/* @__PURE__ */ Pe(l, v)), !!h.isFetching(); )
        await new Promise((M) => {
          const N = h.getQueryCache().subscribe((C) => {
            (C == null ? void 0 : C.query.getObserversCount()) === 0 && (M(), N());
          });
        });
      const k = aCe(h, {
        shouldDehydrateQuery(M) {
          return !(M.state.fetchStatus === "idle" && M.state.status === "pending");
        }
      }), S = {
        ...k,
        queries: k.queries.map(VH),
        mutations: k.mutations.map(VH)
      };
      _.trpcState = g.runtime.combinedTransformer.output.serialize(S);
      const O = p(_);
      if ("responseMeta" in e) {
        const M = ((I = e.responseMeta) == null ? void 0 : I.call(e, {
          ctx: u,
          clientErrors: [
            ...k.queries,
            ...k.mutations
          ].map((N) => N.state.error).flatMap((N) => N instanceof Error && N.name === "TRPCClientError" ? [
            N
          ] : [])
        })) ?? {};
        for (const [N, C] of Object.entries(M.headers ?? {}))
          typeof C == "string" && ((D = u.res) == null || D.setHeader(N, C));
        M.status && u.res && (u.res.statusCode = M.status);
      }
      return O;
    });
    const i = n.displayName ?? n.name ?? "Component";
    return r.displayName = `withTRPC(${i})`, r;
  };
}
/* istanbul ignore file -- @preserve */
function l$c(e) {
  const t = Sue(e), n = c$c(e);
  return D9((o) => o === "useContext" || o === "useUtils" ? () => {
    const r = t.useUtils();
    return Tt(() => a$c(r), [
      r
    ]);
  } : o === "useQueries" ? t.useQueries : o === "useSuspenseQueries" ? t.useSuspenseQueries : o === "withTRPC" ? n : t$c(o, t));
}
const BH = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "appRoutingForms",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "dsync",
  "eventTypes",
  "eventTypesHeavy",
  "features",
  "i18n",
  "insights",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "saml",
  "slots",
  "teams",
  "organizations",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "workflows",
  "googleWorkspace",
  "oAuth",
  "attributes",
  "delegationCredential",
  "routingForms",
  "credits",
  "filterSegments",
  "aiVoiceAgent",
  "phoneNumber",
  "pbac"
];
var z2 = {};
const UH = (e) => (t) => {
  const n = t.op.path.split(".");
  let o, r = "";
  return n.length == 2 ? (o = n[0], r = n[1]) : (o = n[1], r = n.splice(2, n.length - 2).join(".")), e[o]({ ...t, op: { ...t.op, path: r } });
}, bo = l$c({
  config() {
    const e = typeof window < "u" ? "/api/trpc" : z2.VERCEL_URL ? `https://${z2.VERCEL_URL}/api/trpc` : "https://app.cal.com/api/trpc";
    return {
      /**
       * @link https://trpc.io/docs/links
       */
      links: [
        // adds pretty logs to your console in development and logs errors in production
        Xyc({
          enabled: (t) => typeof z2.NEXT_PUBLIC_LOGGER_LEVEL == "number" && z2.NEXT_PUBLIC_LOGGER_LEVEL >= 0 || t.direction === "down" && t.result instanceof Error
        }),
        e$c({
          // check for context property `skipBatch`
          condition: (t) => !!t.context.skipBatch,
          // when condition is true, use normal request
          true: (t) => {
            const n = Object.fromEntries(
              BH.map((o) => [o, Yyc({ url: `${e}/${o}` })(t)])
            );
            return UH(n);
          },
          // when condition is false, use batch request
          false: (t) => {
            const n = Object.fromEntries(
              BH.map((o) => [o, Hyc({ url: `${e}/${o}` })(t)])
            );
            return UH(n);
          }
        })
      ],
      /**
       * @link https://react-query.tanstack.com/reference/QueryClient
       */
      queryClientConfig: {
        defaultOptions: {
          queries: {
            /**
             * 1s should be enough to just keep identical query waterfalls low
             * @example if one page components uses a query that is also used further down the tree
             */
            staleTime: 1e3,
            /**
             * Retry `useQuery()` calls depending on this function
             */
            retry(t, n) {
              var a;
              const o = n, r = (a = o == null ? void 0 : o.data) == null ? void 0 : a.code;
              return r === "BAD_REQUEST" || r === "FORBIDDEN" || r === "UNAUTHORIZED" ? !1 : t < 3;
            }
          }
        }
      },
      /**
       * @link https://trpc.io/docs/data-transformers
       */
      transformer: $yc
    };
  },
  /**
   * @link https://trpc.io/docs/ssr
   */
  ssr: !1
});
function xue(e) {
  const t = Ue({
    value: e,
    previous: e
  });
  return Tt(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Eue = "Checkbox", [d$c, tfd] = os(Eue), [u$c, _$c] = d$c(Eue), p$c = /* @__PURE__ */ it((e, t) => {
  const { __scopeCheckbox: n, name: o, checked: r, defaultChecked: i, required: a, disabled: s, value: c = "on", onCheckedChange: l, ...d } = e, [u, _] = ze(null), p = or(
    t,
    ($) => _($)
  ), f = Ue(!1), g = u ? !!u.closest("form") : !0, [h = !1, b] = jc({
    prop: r,
    defaultProp: i,
    onChange: l
  }), v = Ue(h);
  return Le(() => {
    const $ = u == null ? void 0 : u.form;
    if ($) {
      const k = () => b(v.current);
      return $.addEventListener("reset", k), () => $.removeEventListener("reset", k);
    }
  }, [
    u,
    b
  ]), /* @__PURE__ */ Pe(u$c, {
    scope: n,
    state: h,
    disabled: s
  }, /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    role: "checkbox",
    "aria-checked": Tf(h) ? "mixed" : h,
    "aria-required": a,
    "data-state": Tue(h),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: c
  }, d, {
    ref: p,
    onKeyDown: Bt(e.onKeyDown, ($) => {
      $.key === "Enter" && $.preventDefault();
    }),
    onClick: Bt(e.onClick, ($) => {
      b(
        (k) => Tf(k) ? !0 : !k
      ), g && (f.current = $.isPropagationStopped(), f.current || $.stopPropagation());
    })
  })), g && /* @__PURE__ */ Pe(g$c, {
    control: u,
    bubbles: !f.current,
    name: o,
    value: c,
    checked: h,
    required: a,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), m$c = "CheckboxIndicator", f$c = /* @__PURE__ */ it((e, t) => {
  const { __scopeCheckbox: n, forceMount: o, ...r } = e, i = _$c(m$c, n);
  return /* @__PURE__ */ Pe(rs, {
    present: o || Tf(i.state) || i.state === !0
  }, /* @__PURE__ */ Pe(io.span, We({
    "data-state": Tue(i.state),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), g$c = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = Ue(null), a = xue(n), s = BT(t);
  return Le(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && u) {
      const _ = new Event("click", {
        bubbles: o
      });
      c.indeterminate = Tf(n), u.call(c, Tf(n) ? !1 : n), c.dispatchEvent(_);
    }
  }, [
    a,
    n,
    o
  ]), /* @__PURE__ */ Pe("input", We({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Tf(n) ? !1 : n
  }, r, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Tf(e) {
  return e === "indeterminate";
}
function Tue(e) {
  return Tf(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Aue = p$c, h$c = f$c;
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */
const {
  entries: Cue,
  setPrototypeOf: WH,
  isFrozen: v$c,
  getPrototypeOf: b$c,
  getOwnPropertyDescriptor: y$c
} = Object;
let {
  freeze: Ps,
  seal: $l,
  create: zue
} = Object, {
  apply: aM,
  construct: sM
} = typeof Reflect < "u" && Reflect;
Ps || (Ps = function(t) {
  return t;
});
$l || ($l = function(t) {
  return t;
});
aM || (aM = function(t, n, o) {
  return t.apply(n, o);
});
sM || (sM = function(t, n) {
  return new t(...n);
});
const O2 = Rc(Array.prototype.forEach), GH = Rc(Array.prototype.pop), Oy = Rc(Array.prototype.push), KS = Rc(String.prototype.toLowerCase), z3 = Rc(String.prototype.toString), HH = Rc(String.prototype.match), Py = Rc(String.prototype.replace), $$c = Rc(String.prototype.indexOf), w$c = Rc(String.prototype.trim), Gl = Rc(Object.prototype.hasOwnProperty), ps = Rc(RegExp.prototype.test), Iy = k$c(TypeError);
function Rc(e) {
  return function(t) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
      o[r - 1] = arguments[r];
    return aM(e, t, o);
  };
}
function k$c(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return sM(e, n);
  };
}
function xo(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : KS;
  WH && WH(e, null);
  let o = t.length;
  for (; o--; ) {
    let r = t[o];
    if (typeof r == "string") {
      const i = n(r);
      i !== r && (v$c(t) || (t[o] = i), r = i);
    }
    e[r] = !0;
  }
  return e;
}
function S$c(e) {
  for (let t = 0; t < e.length; t++)
    Gl(e, t) || (e[t] = null);
  return e;
}
function Wm(e) {
  const t = zue(null);
  for (const [n, o] of Cue(e))
    Gl(e, n) && (Array.isArray(o) ? t[n] = S$c(o) : o && typeof o == "object" && o.constructor === Object ? t[n] = Wm(o) : t[n] = o);
  return t;
}
function Ry(e, t) {
  for (; e !== null; ) {
    const o = y$c(e, t);
    if (o) {
      if (o.get)
        return Rc(o.get);
      if (typeof o.value == "function")
        return Rc(o.value);
    }
    e = b$c(e);
  }
  function n() {
    return null;
  }
  return n;
}
const KH = Ps(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), O3 = Ps(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), P3 = Ps(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), x$c = Ps(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), I3 = Ps(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), E$c = Ps(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), YH = Ps(["#text"]), ZH = Ps(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), R3 = Ps(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), QH = Ps(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), P2 = Ps(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), T$c = $l(/\{\{[\w\W]*|[\w\W]*\}\}/gm), A$c = $l(/<%[\w\W]*|[\w\W]*%>/gm), C$c = $l(/\$\{[\w\W]*}/gm), z$c = $l(/^data-[\-\w.\u00B7-\uFFFF]+$/), O$c = $l(/^aria-[\-\w]+$/), Oue = $l(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), P$c = $l(/^(?:\w+script|data):/i), I$c = $l(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Pue = $l(/^html$/i), R$c = $l(/^[a-z][.\w]*(-[.\w]+)+$/i);
var JH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: O$c,
  ATTR_WHITESPACE: I$c,
  CUSTOM_ELEMENT: R$c,
  DATA_ATTR: z$c,
  DOCTYPE_NAME: Pue,
  ERB_EXPR: A$c,
  IS_ALLOWED_URI: Oue,
  IS_SCRIPT_OR_DATA: P$c,
  MUSTACHE_EXPR: T$c,
  TMPLIT_EXPR: C$c
});
const Ny = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, N$c = function() {
  return typeof window > "u" ? null : window;
}, D$c = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let o = null;
  const r = "data-tt-policy-suffix";
  n && n.hasAttribute(r) && (o = n.getAttribute(r));
  const i = "dompurify" + (o ? "#" + o : "");
  try {
    return t.createPolicy(i, {
      createHTML(a) {
        return a;
      },
      createScriptURL(a) {
        return a;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, XH = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Iue() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : N$c();
  const t = (Mt) => Iue(Mt);
  if (t.version = "3.2.3", t.removed = [], !e || !e.document || e.document.nodeType !== Ny.document)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const o = n, r = o.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: a,
    Node: s,
    Element: c,
    NodeFilter: l,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: u,
    DOMParser: _,
    trustedTypes: p
  } = e, f = c.prototype, g = Ry(f, "cloneNode"), h = Ry(f, "remove"), b = Ry(f, "nextSibling"), v = Ry(f, "childNodes"), $ = Ry(f, "parentNode");
  if (typeof a == "function") {
    const Mt = n.createElement("template");
    Mt.content && Mt.content.ownerDocument && (n = Mt.content.ownerDocument);
  }
  let k, S = "";
  const {
    implementation: O,
    createNodeIterator: I,
    createDocumentFragment: D,
    getElementsByTagName: M
  } = n, {
    importNode: N
  } = o;
  let C = XH();
  t.isSupported = typeof Cue == "function" && typeof $ == "function" && O && O.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: P,
    ERB_EXPR: x,
    TMPLIT_EXPR: w,
    DATA_ATTR: E,
    ARIA_ATTR: T,
    IS_SCRIPT_OR_DATA: z,
    ATTR_WHITESPACE: j,
    CUSTOM_ELEMENT: q
  } = JH;
  let {
    IS_ALLOWED_URI: V
  } = JH, F = null;
  const L = xo({}, [...KH, ...O3, ...P3, ...I3, ...YH]);
  let U = null;
  const W = xo({}, [...ZH, ...R3, ...QH, ...P2]);
  let H = Object.seal(zue(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Q = null, X = null, re = !0, Z = !0, ee = !1, J = !0, oe = !1, ce = !0, de = !1, te = !1, ue = !1, le = !1, se = !1, me = !1, pe = !0, be = !1;
  const Se = "user-content-";
  let Ae = !0, Ze = !1, Ge = {}, rt = null;
  const qe = xo({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Xe = null;
  const lt = xo({}, ["audio", "video", "img", "source", "image", "track"]);
  let Et = null;
  const wt = xo({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), nn = "http://www.w3.org/1998/Math/MathML", Dt = "http://www.w3.org/2000/svg", mt = "http://www.w3.org/1999/xhtml";
  let bt = mt, gn = !1, an = null;
  const Mn = xo({}, [nn, Dt, mt], z3);
  let Ln = xo({}, ["mi", "mo", "mn", "ms", "mtext"]), un = xo({}, ["annotation-xml"]);
  const qo = xo({}, ["title", "style", "font", "a", "script"]);
  let cn = null;
  const ln = ["application/xhtml+xml", "text/html"], kn = "text/html";
  let gt = null, Ot = null;
  const _n = n.createElement("form"), wn = function(Ie) {
    return Ie instanceof RegExp || Ie instanceof Function;
  }, so = function() {
    let Ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Ot && Ot === Ie)) {
      if ((!Ie || typeof Ie != "object") && (Ie = {}), Ie = Wm(Ie), cn = // eslint-disable-next-line unicorn/prefer-includes
      ln.indexOf(Ie.PARSER_MEDIA_TYPE) === -1 ? kn : Ie.PARSER_MEDIA_TYPE, gt = cn === "application/xhtml+xml" ? z3 : KS, F = Gl(Ie, "ALLOWED_TAGS") ? xo({}, Ie.ALLOWED_TAGS, gt) : L, U = Gl(Ie, "ALLOWED_ATTR") ? xo({}, Ie.ALLOWED_ATTR, gt) : W, an = Gl(Ie, "ALLOWED_NAMESPACES") ? xo({}, Ie.ALLOWED_NAMESPACES, z3) : Mn, Et = Gl(Ie, "ADD_URI_SAFE_ATTR") ? xo(Wm(wt), Ie.ADD_URI_SAFE_ATTR, gt) : wt, Xe = Gl(Ie, "ADD_DATA_URI_TAGS") ? xo(Wm(lt), Ie.ADD_DATA_URI_TAGS, gt) : lt, rt = Gl(Ie, "FORBID_CONTENTS") ? xo({}, Ie.FORBID_CONTENTS, gt) : qe, Q = Gl(Ie, "FORBID_TAGS") ? xo({}, Ie.FORBID_TAGS, gt) : {}, X = Gl(Ie, "FORBID_ATTR") ? xo({}, Ie.FORBID_ATTR, gt) : {}, Ge = Gl(Ie, "USE_PROFILES") ? Ie.USE_PROFILES : !1, re = Ie.ALLOW_ARIA_ATTR !== !1, Z = Ie.ALLOW_DATA_ATTR !== !1, ee = Ie.ALLOW_UNKNOWN_PROTOCOLS || !1, J = Ie.ALLOW_SELF_CLOSE_IN_ATTR !== !1, oe = Ie.SAFE_FOR_TEMPLATES || !1, ce = Ie.SAFE_FOR_XML !== !1, de = Ie.WHOLE_DOCUMENT || !1, le = Ie.RETURN_DOM || !1, se = Ie.RETURN_DOM_FRAGMENT || !1, me = Ie.RETURN_TRUSTED_TYPE || !1, ue = Ie.FORCE_BODY || !1, pe = Ie.SANITIZE_DOM !== !1, be = Ie.SANITIZE_NAMED_PROPS || !1, Ae = Ie.KEEP_CONTENT !== !1, Ze = Ie.IN_PLACE || !1, V = Ie.ALLOWED_URI_REGEXP || Oue, bt = Ie.NAMESPACE || mt, Ln = Ie.MATHML_TEXT_INTEGRATION_POINTS || Ln, un = Ie.HTML_INTEGRATION_POINTS || un, H = Ie.CUSTOM_ELEMENT_HANDLING || {}, Ie.CUSTOM_ELEMENT_HANDLING && wn(Ie.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (H.tagNameCheck = Ie.CUSTOM_ELEMENT_HANDLING.tagNameCheck), Ie.CUSTOM_ELEMENT_HANDLING && wn(Ie.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (H.attributeNameCheck = Ie.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), Ie.CUSTOM_ELEMENT_HANDLING && typeof Ie.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (H.allowCustomizedBuiltInElements = Ie.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), oe && (Z = !1), se && (le = !0), Ge && (F = xo({}, YH), U = [], Ge.html === !0 && (xo(F, KH), xo(U, ZH)), Ge.svg === !0 && (xo(F, O3), xo(U, R3), xo(U, P2)), Ge.svgFilters === !0 && (xo(F, P3), xo(U, R3), xo(U, P2)), Ge.mathMl === !0 && (xo(F, I3), xo(U, QH), xo(U, P2))), Ie.ADD_TAGS && (F === L && (F = Wm(F)), xo(F, Ie.ADD_TAGS, gt)), Ie.ADD_ATTR && (U === W && (U = Wm(U)), xo(U, Ie.ADD_ATTR, gt)), Ie.ADD_URI_SAFE_ATTR && xo(Et, Ie.ADD_URI_SAFE_ATTR, gt), Ie.FORBID_CONTENTS && (rt === qe && (rt = Wm(rt)), xo(rt, Ie.FORBID_CONTENTS, gt)), Ae && (F["#text"] = !0), de && xo(F, ["html", "head", "body"]), F.table && (xo(F, ["tbody"]), delete Q.tbody), Ie.TRUSTED_TYPES_POLICY) {
        if (typeof Ie.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Iy('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof Ie.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Iy('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        k = Ie.TRUSTED_TYPES_POLICY, S = k.createHTML("");
      } else
        k === void 0 && (k = D$c(p, r)), k !== null && typeof S == "string" && (S = k.createHTML(""));
      Ps && Ps(Ie), Ot = Ie;
    }
  }, rn = xo({}, [...O3, ...P3, ...x$c]), Ht = xo({}, [...I3, ...E$c]), qn = function(Ie) {
    let tt = $(Ie);
    (!tt || !tt.tagName) && (tt = {
      namespaceURI: bt,
      tagName: "template"
    });
    const zt = KS(Ie.tagName), $t = KS(tt.tagName);
    return an[Ie.namespaceURI] ? Ie.namespaceURI === Dt ? tt.namespaceURI === mt ? zt === "svg" : tt.namespaceURI === nn ? zt === "svg" && ($t === "annotation-xml" || Ln[$t]) : !!rn[zt] : Ie.namespaceURI === nn ? tt.namespaceURI === mt ? zt === "math" : tt.namespaceURI === Dt ? zt === "math" && un[$t] : !!Ht[zt] : Ie.namespaceURI === mt ? tt.namespaceURI === Dt && !un[$t] || tt.namespaceURI === nn && !Ln[$t] ? !1 : !Ht[zt] && (qo[zt] || !rn[zt]) : !!(cn === "application/xhtml+xml" && an[Ie.namespaceURI]) : !1;
  }, Bn = function(Ie) {
    Oy(t.removed, {
      element: Ie
    });
    try {
      $(Ie).removeChild(Ie);
    } catch {
      h(Ie);
    }
  }, Or = function(Ie, tt) {
    try {
      Oy(t.removed, {
        attribute: tt.getAttributeNode(Ie),
        from: tt
      });
    } catch {
      Oy(t.removed, {
        attribute: null,
        from: tt
      });
    }
    if (tt.removeAttribute(Ie), Ie === "is")
      if (le || se)
        try {
          Bn(tt);
        } catch {
        }
      else
        try {
          tt.setAttribute(Ie, "");
        } catch {
        }
  }, oo = function(Ie) {
    let tt = null, zt = null;
    if (ue)
      Ie = "<remove></remove>" + Ie;
    else {
      const xe = HH(Ie, /^[\r\n\t ]+/);
      zt = xe && xe[0];
    }
    cn === "application/xhtml+xml" && bt === mt && (Ie = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Ie + "</body></html>");
    const $t = k ? k.createHTML(Ie) : Ie;
    if (bt === mt)
      try {
        tt = new _().parseFromString($t, cn);
      } catch {
      }
    if (!tt || !tt.documentElement) {
      tt = O.createDocument(bt, "template", null);
      try {
        tt.documentElement.innerHTML = gn ? S : $t;
      } catch {
      }
    }
    const In = tt.body || tt.documentElement;
    return Ie && zt && In.insertBefore(n.createTextNode(zt), In.childNodes[0] || null), bt === mt ? M.call(tt, de ? "html" : "body")[0] : de ? tt.documentElement : In;
  }, Zn = function(Ie) {
    return I.call(
      Ie.ownerDocument || Ie,
      Ie,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, st = function(Ie) {
    return Ie instanceof u && (typeof Ie.nodeName != "string" || typeof Ie.textContent != "string" || typeof Ie.removeChild != "function" || !(Ie.attributes instanceof d) || typeof Ie.removeAttribute != "function" || typeof Ie.setAttribute != "function" || typeof Ie.namespaceURI != "string" || typeof Ie.insertBefore != "function" || typeof Ie.hasChildNodes != "function");
  }, ft = function(Ie) {
    return typeof s == "function" && Ie instanceof s;
  };
  function yt(Mt, Ie, tt) {
    O2(Mt, (zt) => {
      zt.call(t, Ie, tt, Ot);
    });
  }
  const on = function(Ie) {
    let tt = null;
    if (yt(C.beforeSanitizeElements, Ie, null), st(Ie))
      return Bn(Ie), !0;
    const zt = gt(Ie.nodeName);
    if (yt(C.uponSanitizeElement, Ie, {
      tagName: zt,
      allowedTags: F
    }), Ie.hasChildNodes() && !ft(Ie.firstElementChild) && ps(/<[/\w]/g, Ie.innerHTML) && ps(/<[/\w]/g, Ie.textContent) || Ie.nodeType === Ny.progressingInstruction || ce && Ie.nodeType === Ny.comment && ps(/<[/\w]/g, Ie.data))
      return Bn(Ie), !0;
    if (!F[zt] || Q[zt]) {
      if (!Q[zt] && Nt(zt) && (H.tagNameCheck instanceof RegExp && ps(H.tagNameCheck, zt) || H.tagNameCheck instanceof Function && H.tagNameCheck(zt)))
        return !1;
      if (Ae && !rt[zt]) {
        const $t = $(Ie) || Ie.parentNode, In = v(Ie) || Ie.childNodes;
        if (In && $t) {
          const xe = In.length;
          for (let je = xe - 1; je >= 0; --je) {
            const pt = g(In[je], !0);
            pt.__removalCount = (Ie.__removalCount || 0) + 1, $t.insertBefore(pt, b(Ie));
          }
        }
      }
      return Bn(Ie), !0;
    }
    return Ie instanceof c && !qn(Ie) || (zt === "noscript" || zt === "noembed" || zt === "noframes") && ps(/<\/no(script|embed|frames)/i, Ie.innerHTML) ? (Bn(Ie), !0) : (oe && Ie.nodeType === Ny.text && (tt = Ie.textContent, O2([P, x, w], ($t) => {
      tt = Py(tt, $t, " ");
    }), Ie.textContent !== tt && (Oy(t.removed, {
      element: Ie.cloneNode()
    }), Ie.textContent = tt)), yt(C.afterSanitizeElements, Ie, null), !1);
  }, Ut = function(Ie, tt, zt) {
    if (pe && (tt === "id" || tt === "name") && (zt in n || zt in _n))
      return !1;
    if (!(Z && !X[tt] && ps(E, tt))) {
      if (!(re && ps(T, tt))) {
        if (!U[tt] || X[tt]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Nt(Ie) && (H.tagNameCheck instanceof RegExp && ps(H.tagNameCheck, Ie) || H.tagNameCheck instanceof Function && H.tagNameCheck(Ie)) && (H.attributeNameCheck instanceof RegExp && ps(H.attributeNameCheck, tt) || H.attributeNameCheck instanceof Function && H.attributeNameCheck(tt)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            tt === "is" && H.allowCustomizedBuiltInElements && (H.tagNameCheck instanceof RegExp && ps(H.tagNameCheck, zt) || H.tagNameCheck instanceof Function && H.tagNameCheck(zt)))
          )
            return !1;
        } else if (!Et[tt]) {
          if (!ps(V, Py(zt, j, ""))) {
            if (!((tt === "src" || tt === "xlink:href" || tt === "href") && Ie !== "script" && $$c(zt, "data:") === 0 && Xe[Ie])) {
              if (!(ee && !ps(z, Py(zt, j, "")))) {
                if (zt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Nt = function(Ie) {
    return Ie !== "annotation-xml" && HH(Ie, q);
  }, Kt = function(Ie) {
    yt(C.beforeSanitizeAttributes, Ie, null);
    const {
      attributes: tt
    } = Ie;
    if (!tt || st(Ie))
      return;
    const zt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: U,
      forceKeepAttr: void 0
    };
    let $t = tt.length;
    for (; $t--; ) {
      const In = tt[$t], {
        name: xe,
        namespaceURI: je,
        value: pt
      } = In, Jt = gt(xe);
      let Ye = xe === "value" ? pt : w$c(pt);
      if (zt.attrName = Jt, zt.attrValue = Ye, zt.keepAttr = !0, zt.forceKeepAttr = void 0, yt(C.uponSanitizeAttribute, Ie, zt), Ye = zt.attrValue, be && (Jt === "id" || Jt === "name") && (Or(xe, Ie), Ye = Se + Ye), ce && ps(/((--!?|])>)|<\/(style|title)/i, Ye)) {
        Or(xe, Ie);
        continue;
      }
      if (zt.forceKeepAttr || (Or(xe, Ie), !zt.keepAttr))
        continue;
      if (!J && ps(/\/>/i, Ye)) {
        Or(xe, Ie);
        continue;
      }
      oe && O2([P, x, w], (Co) => {
        Ye = Py(Ye, Co, " ");
      });
      const mn = gt(Ie.nodeName);
      if (Ut(mn, Jt, Ye)) {
        if (k && typeof p == "object" && typeof p.getAttributeType == "function" && !je)
          switch (p.getAttributeType(mn, Jt)) {
            case "TrustedHTML": {
              Ye = k.createHTML(Ye);
              break;
            }
            case "TrustedScriptURL": {
              Ye = k.createScriptURL(Ye);
              break;
            }
          }
        try {
          je ? Ie.setAttributeNS(je, xe, Ye) : Ie.setAttribute(xe, Ye), st(Ie) ? Bn(Ie) : GH(t.removed);
        } catch {
        }
      }
    }
    yt(C.afterSanitizeAttributes, Ie, null);
  }, At = function Mt(Ie) {
    let tt = null;
    const zt = Zn(Ie);
    for (yt(C.beforeSanitizeShadowDOM, Ie, null); tt = zt.nextNode(); )
      yt(C.uponSanitizeShadowNode, tt, null), on(tt), Kt(tt), tt.content instanceof i && Mt(tt.content);
    yt(C.afterSanitizeShadowDOM, Ie, null);
  };
  return t.sanitize = function(Mt) {
    let Ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tt = null, zt = null, $t = null, In = null;
    if (gn = !Mt, gn && (Mt = "<!-->"), typeof Mt != "string" && !ft(Mt))
      if (typeof Mt.toString == "function") {
        if (Mt = Mt.toString(), typeof Mt != "string")
          throw Iy("dirty is not a string, aborting");
      } else
        throw Iy("toString is not a function");
    if (!t.isSupported)
      return Mt;
    if (te || so(Ie), t.removed = [], typeof Mt == "string" && (Ze = !1), Ze) {
      if (Mt.nodeName) {
        const pt = gt(Mt.nodeName);
        if (!F[pt] || Q[pt])
          throw Iy("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Mt instanceof s)
      tt = oo("<!---->"), zt = tt.ownerDocument.importNode(Mt, !0), zt.nodeType === Ny.element && zt.nodeName === "BODY" || zt.nodeName === "HTML" ? tt = zt : tt.appendChild(zt);
    else {
      if (!le && !oe && !de && // eslint-disable-next-line unicorn/prefer-includes
      Mt.indexOf("<") === -1)
        return k && me ? k.createHTML(Mt) : Mt;
      if (tt = oo(Mt), !tt)
        return le ? null : me ? S : "";
    }
    tt && ue && Bn(tt.firstChild);
    const xe = Zn(Ze ? Mt : tt);
    for (; $t = xe.nextNode(); )
      on($t), Kt($t), $t.content instanceof i && At($t.content);
    if (Ze)
      return Mt;
    if (le) {
      if (se)
        for (In = D.call(tt.ownerDocument); tt.firstChild; )
          In.appendChild(tt.firstChild);
      else
        In = tt;
      return (U.shadowroot || U.shadowrootmode) && (In = N.call(o, In, !0)), In;
    }
    let je = de ? tt.outerHTML : tt.innerHTML;
    return de && F["!doctype"] && tt.ownerDocument && tt.ownerDocument.doctype && tt.ownerDocument.doctype.name && ps(Pue, tt.ownerDocument.doctype.name) && (je = "<!DOCTYPE " + tt.ownerDocument.doctype.name + `>
` + je), oe && O2([P, x, w], (pt) => {
      je = Py(je, pt, " ");
    }), k && me ? k.createHTML(je) : je;
  }, t.setConfig = function() {
    let Mt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    so(Mt), te = !0;
  }, t.clearConfig = function() {
    Ot = null, te = !1;
  }, t.isValidAttribute = function(Mt, Ie, tt) {
    Ot || so({});
    const zt = gt(Mt), $t = gt(Ie);
    return Ut(zt, $t, tt);
  }, t.addHook = function(Mt, Ie) {
    typeof Ie == "function" && Oy(C[Mt], Ie);
  }, t.removeHook = function(Mt) {
    return GH(C[Mt]);
  }, t.removeHooks = function(Mt) {
    C[Mt] = [];
  }, t.removeAllHooks = function() {
    C = XH();
  }, t;
}
var Rue = Iue();
function M9() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let ug = M9();
function Nue(e) {
  ug = e;
}
const R$ = { exec: () => null };
function Ar(e, t = "") {
  let n = typeof e == "string" ? e : e.source;
  const o = {
    replace: (r, i) => {
      let a = typeof i == "string" ? i : i.source;
      return a = a.replace(Cs.caret, "$1"), n = n.replace(r, a), o;
    },
    getRegex: () => new RegExp(n, t)
  };
  return o;
}
const Cs = {
  codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
  outputLinkReplace: /\\([\[\]])/g,
  indentCodeCompensation: /^(\s+)(?:```)/,
  beginningSpace: /^\s+/,
  endingHash: /#$/,
  startingSpaceChar: /^ /,
  endingSpaceChar: / $/,
  nonSpaceChar: /[^ ]/,
  newLineCharGlobal: /\n/g,
  tabCharGlobal: /\t/g,
  multipleSpaceGlobal: /\s+/g,
  blankLine: /^[ \t]*$/,
  doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
  blockquoteStart: /^ {0,3}>/,
  blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
  blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
  listReplaceTabs: /^\t+/,
  listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
  listIsTask: /^\[[ xX]\] /,
  listReplaceTask: /^\[[ xX]\] +/,
  anyLine: /\n.*\n/,
  hrefBrackets: /^<(.*)>$/,
  tableDelimiter: /[:|]/,
  tableAlignChars: /^\||\| *$/g,
  tableRowBlankLine: /\n[ \t]*$/,
  tableAlignRight: /^ *-+: *$/,
  tableAlignCenter: /^ *:-+: *$/,
  tableAlignLeft: /^ *:-+ *$/,
  startATag: /^<a /i,
  endATag: /^<\/a>/i,
  startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
  endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
  startAngleBracket: /^</,
  endAngleBracket: />$/,
  pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
  unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
  escapeTest: /[&<>"']/,
  escapeReplace: /[&<>"']/g,
  escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
  escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
  unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
  caret: /(^|[^\[])\^/g,
  percentDecode: /%25/g,
  findPipe: /\|/g,
  splitPipe: / \|/,
  slashPipe: /\\\|/g,
  carriageReturn: /\r\n|\r/g,
  spaceLine: /^ +$/gm,
  notSpaceStart: /^\S*/,
  endingNewline: /\n$/,
  listItemRegex: (e) => new RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
  nextBulletRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
  hrRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
  fencesBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
  headingBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
  htmlBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i")
}, M$c = /^(?:[ \t]*(?:\n|$))+/, L$c = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, q$c = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, K0 = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, j$c = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Due = /(?:[*+-]|\d{1,9}[.)])/, Mue = Ar(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, Due).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), L9 = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, F$c = /^[^\n]+/, q9 = /(?!\s*\])(?:\\.|[^\[\]\\])+/, V$c = Ar(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", q9).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), B$c = Ar(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Due).getRegex(), mA = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", j9 = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, U$c = Ar("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", j9).replace("tag", mA).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), Lue = Ar(L9).replace("hr", K0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", mA).getRegex(), W$c = Ar(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", Lue).getRegex(), F9 = {
  blockquote: W$c,
  code: L$c,
  def: V$c,
  fences: q$c,
  heading: j$c,
  hr: K0,
  html: U$c,
  lheading: Mue,
  list: B$c,
  newline: M$c,
  paragraph: Lue,
  table: R$,
  text: F$c
}, eK = Ar("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", K0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", mA).getRegex(), G$c = {
  ...F9,
  table: eK,
  paragraph: Ar(L9).replace("hr", K0).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", eK).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", mA).getRegex()
}, H$c = {
  ...F9,
  html: Ar(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", j9).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: R$,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: Ar(L9).replace("hr", K0).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Mue).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, que = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, K$c = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, jue = /^( {2,}|\\)\n(?!\s*$)/, Y$c = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, fA = /[\p{P}\p{S}]/u, V9 = /[\s\p{P}\p{S}]/u, Fue = /[^\s\p{P}\p{S}]/u, Z$c = Ar(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, V9).getRegex(), Q$c = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g, J$c = Ar(/^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, "u").replace(/punct/g, fA).getRegex(), X$c = Ar("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, Fue).replace(/punctSpace/g, V9).replace(/punct/g, fA).getRegex(), ewc = Ar("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, Fue).replace(/punctSpace/g, V9).replace(/punct/g, fA).getRegex(), twc = Ar(/\\(punct)/, "gu").replace(/punct/g, fA).getRegex(), nwc = Ar(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), owc = Ar(j9).replace("(?:-->|$)", "-->").getRegex(), rwc = Ar("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", owc).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), sE = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, iwc = Ar(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", sE).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Vue = Ar(/^!?\[(label)\]\[(ref)\]/).replace("label", sE).replace("ref", q9).getRegex(), Bue = Ar(/^!?\[(ref)\](?:\[\])?/).replace("ref", q9).getRegex(), awc = Ar("reflink|nolink(?!\\()", "g").replace("reflink", Vue).replace("nolink", Bue).getRegex(), B9 = {
  _backpedal: R$,
  // only used for GFM url
  anyPunctuation: twc,
  autolink: nwc,
  blockSkip: Q$c,
  br: jue,
  code: K$c,
  del: R$,
  emStrongLDelim: J$c,
  emStrongRDelimAst: X$c,
  emStrongRDelimUnd: ewc,
  escape: que,
  link: iwc,
  nolink: Bue,
  punctuation: Z$c,
  reflink: Vue,
  reflinkSearch: awc,
  tag: rwc,
  text: Y$c,
  url: R$
}, swc = {
  ...B9,
  link: Ar(/^!?\[(label)\]\((.*?)\)/).replace("label", sE).getRegex(),
  reflink: Ar(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", sE).getRegex()
}, cM = {
  ...B9,
  escape: Ar(que).replace("])", "~|])").getRegex(),
  url: Ar(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, cwc = {
  ...cM,
  br: Ar(jue).replace("{2,}", "*").getRegex(),
  text: Ar(cM.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, I2 = {
  normal: F9,
  gfm: G$c,
  pedantic: H$c
}, Dy = {
  normal: B9,
  gfm: cM,
  breaks: cwc,
  pedantic: swc
}, lwc = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, tK = (e) => lwc[e];
function Cd(e, t) {
  if (t) {
    if (Cs.escapeTest.test(e))
      return e.replace(Cs.escapeReplace, tK);
  } else if (Cs.escapeTestNoEncode.test(e))
    return e.replace(Cs.escapeReplaceNoEncode, tK);
  return e;
}
function nK(e) {
  try {
    e = encodeURI(e).replace(Cs.percentDecode, "%");
  } catch {
    return null;
  }
  return e;
}
function oK(e, t) {
  var i;
  const n = e.replace(Cs.findPipe, (a, s, c) => {
    let l = !1, d = s;
    for (; --d >= 0 && c[d] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), o = n.split(Cs.splitPipe);
  let r = 0;
  if (o[0].trim() || o.shift(), o.length > 0 && !((i = o.at(-1)) != null && i.trim()) && o.pop(), t)
    if (o.length > t)
      o.splice(t);
    else
      for (; o.length < t; )
        o.push("");
  for (; r < o.length; r++)
    o[r] = o[r].trim().replace(Cs.slashPipe, "|");
  return o;
}
function My(e, t, n) {
  const o = e.length;
  if (o === 0)
    return "";
  let r = 0;
  for (; r < o; ) {
    const i = e.charAt(o - r - 1);
    if (i === t && !n)
      r++;
    else if (i !== t && n)
      r++;
    else
      break;
  }
  return e.slice(0, o - r);
}
function dwc(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  let n = 0;
  for (let o = 0; o < e.length; o++)
    if (e[o] === "\\")
      o++;
    else if (e[o] === t[0])
      n++;
    else if (e[o] === t[1] && (n--, n < 0))
      return o;
  return -1;
}
function rK(e, t, n, o, r) {
  const i = t.href, a = t.title || null, s = e[1].replace(r.other.outputLinkReplace, "$1");
  if (e[0].charAt(0) !== "!") {
    o.state.inLink = !0;
    const c = {
      type: "link",
      raw: n,
      href: i,
      title: a,
      text: s,
      tokens: o.inlineTokens(s)
    };
    return o.state.inLink = !1, c;
  }
  return {
    type: "image",
    raw: n,
    href: i,
    title: a,
    text: s
  };
}
function uwc(e, t, n) {
  const o = e.match(n.other.indentCodeCompensation);
  if (o === null)
    return t;
  const r = o[1];
  return t.split(`
`).map((i) => {
    const a = i.match(n.other.beginningSpace);
    if (a === null)
      return i;
    const [s] = a;
    return s.length >= r.length ? i.slice(r.length) : i;
  }).join(`
`);
}
class cE {
  // set by the lexer
  constructor(t) {
    fr(this, "options");
    fr(this, "rules");
    // set by the lexer
    fr(this, "lexer");
    this.options = t || ug;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const o = n[0].replace(this.rules.other.codeRemoveIndent, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? o : My(o, `
`)
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const o = n[0], r = uwc(o, n[3] || "", this.rules);
      return {
        type: "code",
        raw: o,
        lang: n[2] ? n[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : n[2],
        text: r
      };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let o = n[2].trim();
      if (this.rules.other.endingHash.test(o)) {
        const r = My(o, "#");
        (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (o = r.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: o,
        tokens: this.lexer.inline(o)
      };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n)
      return {
        type: "hr",
        raw: My(n[0], `
`)
      };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      let o = My(n[0], `
`).split(`
`), r = "", i = "";
      const a = [];
      for (; o.length > 0; ) {
        let s = !1;
        const c = [];
        let l;
        for (l = 0; l < o.length; l++)
          if (this.rules.other.blockquoteStart.test(o[l]))
            c.push(o[l]), s = !0;
          else if (!s)
            c.push(o[l]);
          else
            break;
        o = o.slice(l);
        const d = c.join(`
`), u = d.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        r = r ? `${r}
${d}` : d, i = i ? `${i}
${u}` : u;
        const _ = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(u, a, !0), this.lexer.state.top = _, o.length === 0)
          break;
        const p = a.at(-1);
        if ((p == null ? void 0 : p.type) === "code")
          break;
        if ((p == null ? void 0 : p.type) === "blockquote") {
          const f = p, g = f.raw + `
` + o.join(`
`), h = this.blockquote(g);
          a[a.length - 1] = h, r = r.substring(0, r.length - f.raw.length) + h.raw, i = i.substring(0, i.length - f.text.length) + h.text;
          break;
        } else if ((p == null ? void 0 : p.type) === "list") {
          const f = p, g = f.raw + `
` + o.join(`
`), h = this.list(g);
          a[a.length - 1] = h, r = r.substring(0, r.length - p.raw.length) + h.raw, i = i.substring(0, i.length - f.raw.length) + h.raw, o = g.substring(a.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return {
        type: "blockquote",
        raw: r,
        tokens: a,
        text: i
      };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let o = n[1].trim();
      const r = o.length > 1, i = {
        type: "list",
        raw: "",
        ordered: r,
        start: r ? +o.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      o = r ? `\\d{1,9}\\${o.slice(-1)}` : `\\${o}`, this.options.pedantic && (o = r ? o : "[*+-]");
      const a = this.rules.other.listItemRegex(o);
      let s = !1;
      for (; t; ) {
        let l = !1, d = "", u = "";
        if (!(n = a.exec(t)) || this.rules.block.hr.test(t))
          break;
        d = n[0], t = t.substring(d.length);
        let _ = n[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (v) => " ".repeat(3 * v.length)), p = t.split(`
`, 1)[0], f = !_.trim(), g = 0;
        if (this.options.pedantic ? (g = 2, u = _.trimStart()) : f ? g = n[1].length + 1 : (g = n[2].search(this.rules.other.nonSpaceChar), g = g > 4 ? 1 : g, u = _.slice(g), g += n[1].length), f && this.rules.other.blankLine.test(p) && (d += p + `
`, t = t.substring(p.length + 1), l = !0), !l) {
          const v = this.rules.other.nextBulletRegex(g), $ = this.rules.other.hrRegex(g), k = this.rules.other.fencesBeginRegex(g), S = this.rules.other.headingBeginRegex(g), O = this.rules.other.htmlBeginRegex(g);
          for (; t; ) {
            const I = t.split(`
`, 1)[0];
            let D;
            if (p = I, this.options.pedantic ? (p = p.replace(this.rules.other.listReplaceNesting, "  "), D = p) : D = p.replace(this.rules.other.tabCharGlobal, "    "), k.test(p) || S.test(p) || O.test(p) || v.test(p) || $.test(p))
              break;
            if (D.search(this.rules.other.nonSpaceChar) >= g || !p.trim())
              u += `
` + D.slice(g);
            else {
              if (f || _.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || k.test(_) || S.test(_) || $.test(_))
                break;
              u += `
` + p;
            }
            !f && !p.trim() && (f = !0), d += I + `
`, t = t.substring(I.length + 1), _ = D.slice(g);
          }
        }
        i.loose || (s ? i.loose = !0 : this.rules.other.doubleBlankLine.test(d) && (s = !0));
        let h = null, b;
        this.options.gfm && (h = this.rules.other.listIsTask.exec(u), h && (b = h[0] !== "[ ] ", u = u.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
          type: "list_item",
          raw: d,
          task: !!h,
          checked: b,
          loose: !1,
          text: u,
          tokens: []
        }), i.raw += d;
      }
      const c = i.items.at(-1);
      c && (c.raw = c.raw.trimEnd(), c.text = c.text.trimEnd()), i.raw = i.raw.trimEnd();
      for (let l = 0; l < i.items.length; l++)
        if (this.lexer.state.top = !1, i.items[l].tokens = this.lexer.blockTokens(i.items[l].text, []), !i.loose) {
          const d = i.items[l].tokens.filter((_) => _.type === "space"), u = d.length > 0 && d.some((_) => this.rules.other.anyLine.test(_.raw));
          i.loose = u;
        }
      if (i.loose)
        for (let l = 0; l < i.items.length; l++)
          i.items[l].loose = !0;
      return i;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n)
      return {
        type: "html",
        block: !0,
        raw: n[0],
        pre: n[1] === "pre" || n[1] === "script" || n[1] === "style",
        text: n[0]
      };
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n) {
      const o = n[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = n[2] ? n[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : n[3];
      return {
        type: "def",
        tag: o,
        raw: n[0],
        href: r,
        title: i
      };
    }
  }
  table(t) {
    var s;
    const n = this.rules.block.table.exec(t);
    if (!n || !this.rules.other.tableDelimiter.test(n[2]))
      return;
    const o = oK(n[1]), r = n[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = (s = n[3]) != null && s.trim() ? n[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], a = {
      type: "table",
      raw: n[0],
      header: [],
      align: [],
      rows: []
    };
    if (o.length === r.length) {
      for (const c of r)
        this.rules.other.tableAlignRight.test(c) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(c) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(c) ? a.align.push("left") : a.align.push(null);
      for (let c = 0; c < o.length; c++)
        a.header.push({
          text: o[c],
          tokens: this.lexer.inline(o[c]),
          header: !0,
          align: a.align[c]
        });
      for (const c of i)
        a.rows.push(oK(c, a.header.length).map((l, d) => ({
          text: l,
          tokens: this.lexer.inline(l),
          header: !1,
          align: a.align[d]
        })));
      return a;
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const o = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: o,
        tokens: this.lexer.inline(o)
      };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: n[1]
      };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return !this.lexer.state.inLink && this.rules.other.startATag.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: n[0]
      };
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const o = n[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(o)) {
        if (!this.rules.other.endAngleBracket.test(o))
          return;
        const a = My(o.slice(0, -1), "\\");
        if ((o.length - a.length) % 2 === 0)
          return;
      } else {
        const a = dwc(n[2], "()");
        if (a > -1) {
          const c = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + a;
          n[2] = n[2].substring(0, a), n[0] = n[0].substring(0, c).trim(), n[3] = "";
        }
      }
      let r = n[2], i = "";
      if (this.options.pedantic) {
        const a = this.rules.other.pedanticHrefTitle.exec(r);
        a && (r = a[1], i = a[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(o) ? r = r.slice(1) : r = r.slice(1, -1)), rK(n, {
        href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
        title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
      }, n[0], this.lexer, this.rules);
    }
  }
  reflink(t, n) {
    let o;
    if ((o = this.rules.inline.reflink.exec(t)) || (o = this.rules.inline.nolink.exec(t))) {
      const r = (o[2] || o[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = n[r.toLowerCase()];
      if (!i) {
        const a = o[0].charAt(0);
        return {
          type: "text",
          raw: a,
          text: a
        };
      }
      return rK(o, i, o[0], this.lexer, this.rules);
    }
  }
  emStrong(t, n, o = "") {
    let r = this.rules.inline.emStrongLDelim.exec(t);
    if (!r || r[3] && o.match(this.rules.other.unicodeAlphaNumeric))
      return;
    if (!(r[1] || r[2] || "") || !o || this.rules.inline.punctuation.exec(o)) {
      const a = [...r[0]].length - 1;
      let s, c, l = a, d = 0;
      const u = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (u.lastIndex = 0, n = n.slice(-1 * t.length + a); (r = u.exec(n)) != null; ) {
        if (s = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !s)
          continue;
        if (c = [...s].length, r[3] || r[4]) {
          l += c;
          continue;
        } else if ((r[5] || r[6]) && a % 3 && !((a + c) % 3)) {
          d += c;
          continue;
        }
        if (l -= c, l > 0)
          continue;
        c = Math.min(c, c + l + d);
        const _ = [...r[0]][0].length, p = t.slice(0, a + r.index + _ + c);
        if (Math.min(a, c) % 2) {
          const g = p.slice(1, -1);
          return {
            type: "em",
            raw: p,
            text: g,
            tokens: this.lexer.inlineTokens(g)
          };
        }
        const f = p.slice(2, -2);
        return {
          type: "strong",
          raw: p,
          text: f,
          tokens: this.lexer.inlineTokens(f)
        };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let o = n[2].replace(this.rules.other.newLineCharGlobal, " ");
      const r = this.rules.other.nonSpaceChar.test(o), i = this.rules.other.startingSpaceChar.test(o) && this.rules.other.endingSpaceChar.test(o);
      return r && i && (o = o.substring(1, o.length - 1)), {
        type: "codespan",
        raw: n[0],
        text: o
      };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(t) {
    const n = this.rules.inline.autolink.exec(t);
    if (n) {
      let o, r;
      return n[2] === "@" ? (o = n[1], r = "mailto:" + o) : (o = n[1], r = o), {
        type: "link",
        raw: n[0],
        text: o,
        href: r,
        tokens: [
          {
            type: "text",
            raw: o,
            text: o
          }
        ]
      };
    }
  }
  url(t) {
    var o;
    let n;
    if (n = this.rules.inline.url.exec(t)) {
      let r, i;
      if (n[2] === "@")
        r = n[0], i = "mailto:" + r;
      else {
        let a;
        do
          a = n[0], n[0] = ((o = this.rules.inline._backpedal.exec(n[0])) == null ? void 0 : o[0]) ?? "";
        while (a !== n[0]);
        r = n[0], n[1] === "www." ? i = "http://" + n[0] : i = n[0];
      }
      return {
        type: "link",
        raw: n[0],
        text: r,
        href: i,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  inlineText(t) {
    const n = this.rules.inline.text.exec(t);
    if (n) {
      const o = this.lexer.state.inRawBlock;
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        escaped: o
      };
    }
  }
}
class gl {
  constructor(t) {
    fr(this, "tokens");
    fr(this, "options");
    fr(this, "state");
    fr(this, "tokenizer");
    fr(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || ug, this.options.tokenizer = this.options.tokenizer || new cE(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      other: Cs,
      block: I2.normal,
      inline: Dy.normal
    };
    this.options.pedantic ? (n.block = I2.pedantic, n.inline = Dy.pedantic) : this.options.gfm && (n.block = I2.gfm, this.options.breaks ? n.inline = Dy.breaks : n.inline = Dy.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: I2,
      inline: Dy
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new gl(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new gl(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(Cs.carriageReturn, `
`), this.blockTokens(t, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      const o = this.inlineQueue[n];
      this.inlineTokens(o.src, o.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(t, n = [], o = !1) {
    var r, i, a;
    for (this.options.pedantic && (t = t.replace(Cs.tabCharGlobal, "    ").replace(Cs.spaceLine, "")); t; ) {
      let s;
      if ((i = (r = this.options.extensions) == null ? void 0 : r.block) != null && i.some((l) => (s = l.call({ lexer: this }, t, n)) ? (t = t.substring(s.raw.length), n.push(s), !0) : !1))
        continue;
      if (s = this.tokenizer.space(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        s.raw.length === 1 && l !== void 0 ? l.raw += `
` : n.push(s);
        continue;
      }
      if (s = this.tokenizer.code(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "paragraph" || (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.at(-1).src = l.text) : n.push(s);
        continue;
      }
      if (s = this.tokenizer.fences(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.heading(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.hr(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.blockquote(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.list(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.html(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.def(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "paragraph" || (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.raw, this.inlineQueue.at(-1).src = l.text) : this.tokens.links[s.tag] || (this.tokens.links[s.tag] = {
          href: s.href,
          title: s.title
        });
        continue;
      }
      if (s = this.tokenizer.table(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.lheading(t)) {
        t = t.substring(s.raw.length), n.push(s);
        continue;
      }
      let c = t;
      if ((a = this.options.extensions) != null && a.startBlock) {
        let l = 1 / 0;
        const d = t.slice(1);
        let u;
        this.options.extensions.startBlock.forEach((_) => {
          u = _.call({ lexer: this }, d), typeof u == "number" && u >= 0 && (l = Math.min(l, u));
        }), l < 1 / 0 && l >= 0 && (c = t.substring(0, l + 1));
      }
      if (this.state.top && (s = this.tokenizer.paragraph(c))) {
        const l = n.at(-1);
        o && (l == null ? void 0 : l.type) === "paragraph" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = l.text) : n.push(s), o = c.length !== t.length, t = t.substring(s.raw.length);
        continue;
      }
      if (s = this.tokenizer.text(t)) {
        t = t.substring(s.raw.length);
        const l = n.at(-1);
        (l == null ? void 0 : l.type) === "text" ? (l.raw += `
` + s.raw, l.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = l.text) : n.push(s);
        continue;
      }
      if (t) {
        const l = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(l);
          break;
        } else
          throw new Error(l);
      }
    }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    var s, c, l;
    let o = t, r = null;
    if (this.tokens.links) {
      const d = Object.keys(this.tokens.links);
      if (d.length > 0)
        for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          d.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (r = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, r.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    let i = !1, a = "";
    for (; t; ) {
      i || (a = ""), i = !1;
      let d;
      if ((c = (s = this.options.extensions) == null ? void 0 : s.inline) != null && c.some((_) => (d = _.call({ lexer: this }, t, n)) ? (t = t.substring(d.raw.length), n.push(d), !0) : !1))
        continue;
      if (d = this.tokenizer.escape(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.tag(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.link(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.reflink(t, this.tokens.links)) {
        t = t.substring(d.raw.length);
        const _ = n.at(-1);
        d.type === "text" && (_ == null ? void 0 : _.type) === "text" ? (_.raw += d.raw, _.text += d.text) : n.push(d);
        continue;
      }
      if (d = this.tokenizer.emStrong(t, o, a)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.codespan(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.br(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.del(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (d = this.tokenizer.autolink(t)) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      if (!this.state.inLink && (d = this.tokenizer.url(t))) {
        t = t.substring(d.raw.length), n.push(d);
        continue;
      }
      let u = t;
      if ((l = this.options.extensions) != null && l.startInline) {
        let _ = 1 / 0;
        const p = t.slice(1);
        let f;
        this.options.extensions.startInline.forEach((g) => {
          f = g.call({ lexer: this }, p), typeof f == "number" && f >= 0 && (_ = Math.min(_, f));
        }), _ < 1 / 0 && _ >= 0 && (u = t.substring(0, _ + 1));
      }
      if (d = this.tokenizer.inlineText(u)) {
        t = t.substring(d.raw.length), d.raw.slice(-1) !== "_" && (a = d.raw.slice(-1)), i = !0;
        const _ = n.at(-1);
        (_ == null ? void 0 : _.type) === "text" ? (_.raw += d.raw, _.text += d.text) : n.push(d);
        continue;
      }
      if (t) {
        const _ = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(_);
          break;
        } else
          throw new Error(_);
      }
    }
    return n;
  }
}
class lE {
  // set by the parser
  constructor(t) {
    fr(this, "options");
    fr(this, "parser");
    this.options = t || ug;
  }
  space(t) {
    return "";
  }
  code({ text: t, lang: n, escaped: o }) {
    var a;
    const r = (a = (n || "").match(Cs.notSpaceStart)) == null ? void 0 : a[0], i = t.replace(Cs.endingNewline, "") + `
`;
    return r ? '<pre><code class="language-' + Cd(r) + '">' + (o ? i : Cd(i, !0)) + `</code></pre>
` : "<pre><code>" + (o ? i : Cd(i, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: t }) {
    return `<blockquote>
${this.parser.parse(t)}</blockquote>
`;
  }
  html({ text: t }) {
    return t;
  }
  heading({ tokens: t, depth: n }) {
    return `<h${n}>${this.parser.parseInline(t)}</h${n}>
`;
  }
  hr(t) {
    return `<hr>
`;
  }
  list(t) {
    const n = t.ordered, o = t.start;
    let r = "";
    for (let s = 0; s < t.items.length; s++) {
      const c = t.items[s];
      r += this.listitem(c);
    }
    const i = n ? "ol" : "ul", a = n && o !== 1 ? ' start="' + o + '"' : "";
    return "<" + i + a + `>
` + r + "</" + i + `>
`;
  }
  listitem(t) {
    var o;
    let n = "";
    if (t.task) {
      const r = this.checkbox({ checked: !!t.checked });
      t.loose ? ((o = t.tokens[0]) == null ? void 0 : o.type) === "paragraph" ? (t.tokens[0].text = r + " " + t.tokens[0].text, t.tokens[0].tokens && t.tokens[0].tokens.length > 0 && t.tokens[0].tokens[0].type === "text" && (t.tokens[0].tokens[0].text = r + " " + Cd(t.tokens[0].tokens[0].text), t.tokens[0].tokens[0].escaped = !0)) : t.tokens.unshift({
        type: "text",
        raw: r + " ",
        text: r + " ",
        escaped: !0
      }) : n += r + " ";
    }
    return n += this.parser.parse(t.tokens, !!t.loose), `<li>${n}</li>
`;
  }
  checkbox({ checked: t }) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: t }) {
    return `<p>${this.parser.parseInline(t)}</p>
`;
  }
  table(t) {
    let n = "", o = "";
    for (let i = 0; i < t.header.length; i++)
      o += this.tablecell(t.header[i]);
    n += this.tablerow({ text: o });
    let r = "";
    for (let i = 0; i < t.rows.length; i++) {
      const a = t.rows[i];
      o = "";
      for (let s = 0; s < a.length; s++)
        o += this.tablecell(a[s]);
      r += this.tablerow({ text: o });
    }
    return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + n + `</thead>
` + r + `</table>
`;
  }
  tablerow({ text: t }) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t) {
    const n = this.parser.parseInline(t.tokens), o = t.header ? "th" : "td";
    return (t.align ? `<${o} align="${t.align}">` : `<${o}>`) + n + `</${o}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens: t }) {
    return `<strong>${this.parser.parseInline(t)}</strong>`;
  }
  em({ tokens: t }) {
    return `<em>${this.parser.parseInline(t)}</em>`;
  }
  codespan({ text: t }) {
    return `<code>${Cd(t, !0)}</code>`;
  }
  br(t) {
    return "<br>";
  }
  del({ tokens: t }) {
    return `<del>${this.parser.parseInline(t)}</del>`;
  }
  link({ href: t, title: n, tokens: o }) {
    const r = this.parser.parseInline(o), i = nK(t);
    if (i === null)
      return r;
    t = i;
    let a = '<a href="' + t + '"';
    return n && (a += ' title="' + Cd(n) + '"'), a += ">" + r + "</a>", a;
  }
  image({ href: t, title: n, text: o }) {
    const r = nK(t);
    if (r === null)
      return Cd(o);
    t = r;
    let i = `<img src="${t}" alt="${o}"`;
    return n && (i += ` title="${Cd(n)}"`), i += ">", i;
  }
  text(t) {
    return "tokens" in t && t.tokens ? this.parser.parseInline(t.tokens) : "escaped" in t && t.escaped ? t.text : Cd(t.text);
  }
}
class U9 {
  // no need for block level renderers
  strong({ text: t }) {
    return t;
  }
  em({ text: t }) {
    return t;
  }
  codespan({ text: t }) {
    return t;
  }
  del({ text: t }) {
    return t;
  }
  html({ text: t }) {
    return t;
  }
  text({ text: t }) {
    return t;
  }
  link({ text: t }) {
    return "" + t;
  }
  image({ text: t }) {
    return "" + t;
  }
  br() {
    return "";
  }
}
class hl {
  constructor(t) {
    fr(this, "options");
    fr(this, "renderer");
    fr(this, "textRenderer");
    this.options = t || ug, this.options.renderer = this.options.renderer || new lE(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new U9();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new hl(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new hl(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    var r, i;
    let o = "";
    for (let a = 0; a < t.length; a++) {
      const s = t[a];
      if ((i = (r = this.options.extensions) == null ? void 0 : r.renderers) != null && i[s.type]) {
        const l = s, d = this.options.extensions.renderers[l.type].call({ parser: this }, l);
        if (d !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(l.type)) {
          o += d || "";
          continue;
        }
      }
      const c = s;
      switch (c.type) {
        case "space": {
          o += this.renderer.space(c);
          continue;
        }
        case "hr": {
          o += this.renderer.hr(c);
          continue;
        }
        case "heading": {
          o += this.renderer.heading(c);
          continue;
        }
        case "code": {
          o += this.renderer.code(c);
          continue;
        }
        case "table": {
          o += this.renderer.table(c);
          continue;
        }
        case "blockquote": {
          o += this.renderer.blockquote(c);
          continue;
        }
        case "list": {
          o += this.renderer.list(c);
          continue;
        }
        case "html": {
          o += this.renderer.html(c);
          continue;
        }
        case "paragraph": {
          o += this.renderer.paragraph(c);
          continue;
        }
        case "text": {
          let l = c, d = this.renderer.text(l);
          for (; a + 1 < t.length && t[a + 1].type === "text"; )
            l = t[++a], d += `
` + this.renderer.text(l);
          n ? o += this.renderer.paragraph({
            type: "paragraph",
            raw: d,
            text: d,
            tokens: [{ type: "text", raw: d, text: d, escaped: !0 }]
          }) : o += d;
          continue;
        }
        default: {
          const l = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(l), "";
          throw new Error(l);
        }
      }
    }
    return o;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n = this.renderer) {
    var r, i;
    let o = "";
    for (let a = 0; a < t.length; a++) {
      const s = t[a];
      if ((i = (r = this.options.extensions) == null ? void 0 : r.renderers) != null && i[s.type]) {
        const l = this.options.extensions.renderers[s.type].call({ parser: this }, s);
        if (l !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(s.type)) {
          o += l || "";
          continue;
        }
      }
      const c = s;
      switch (c.type) {
        case "escape": {
          o += n.text(c);
          break;
        }
        case "html": {
          o += n.html(c);
          break;
        }
        case "link": {
          o += n.link(c);
          break;
        }
        case "image": {
          o += n.image(c);
          break;
        }
        case "strong": {
          o += n.strong(c);
          break;
        }
        case "em": {
          o += n.em(c);
          break;
        }
        case "codespan": {
          o += n.codespan(c);
          break;
        }
        case "br": {
          o += n.br(c);
          break;
        }
        case "del": {
          o += n.del(c);
          break;
        }
        case "text": {
          o += n.text(c);
          break;
        }
        default: {
          const l = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(l), "";
          throw new Error(l);
        }
      }
    }
    return o;
  }
}
class N$ {
  constructor(t) {
    fr(this, "options");
    fr(this, "block");
    this.options = t || ug;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(t) {
    return t;
  }
  /**
   * Provide function to tokenize markdown
   */
  provideLexer() {
    return this.block ? gl.lex : gl.lexInline;
  }
  /**
   * Provide function to parse tokens
   */
  provideParser() {
    return this.block ? hl.parse : hl.parseInline;
  }
}
fr(N$, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
]));
class _wc {
  constructor(...t) {
    fr(this, "defaults", M9());
    fr(this, "options", this.setOptions);
    fr(this, "parse", this.parseMarkdown(!0));
    fr(this, "parseInline", this.parseMarkdown(!1));
    fr(this, "Parser", hl);
    fr(this, "Renderer", lE);
    fr(this, "TextRenderer", U9);
    fr(this, "Lexer", gl);
    fr(this, "Tokenizer", cE);
    fr(this, "Hooks", N$);
    this.use(...t);
  }
  /**
   * Run callback for every token
   */
  walkTokens(t, n) {
    var r, i;
    let o = [];
    for (const a of t)
      switch (o = o.concat(n.call(this, a)), a.type) {
        case "table": {
          const s = a;
          for (const c of s.header)
            o = o.concat(this.walkTokens(c.tokens, n));
          for (const c of s.rows)
            for (const l of c)
              o = o.concat(this.walkTokens(l.tokens, n));
          break;
        }
        case "list": {
          const s = a;
          o = o.concat(this.walkTokens(s.items, n));
          break;
        }
        default: {
          const s = a;
          (i = (r = this.defaults.extensions) == null ? void 0 : r.childTokens) != null && i[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((c) => {
            const l = s[c].flat(1 / 0);
            o = o.concat(this.walkTokens(l, n));
          }) : s.tokens && (o = o.concat(this.walkTokens(s.tokens, n)));
        }
      }
    return o;
  }
  use(...t) {
    const n = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((o) => {
      const r = { ...o };
      if (r.async = this.defaults.async || r.async || !1, o.extensions && (o.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const a = n.renderers[i.name];
          a ? n.renderers[i.name] = function(...s) {
            let c = i.renderer.apply(this, s);
            return c === !1 && (c = a.apply(this, s)), c;
          } : n.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const a = n[i.level];
          a ? a.unshift(i.tokenizer) : n[i.level] = [i.tokenizer], i.start && (i.level === "block" ? n.startBlock ? n.startBlock.push(i.start) : n.startBlock = [i.start] : i.level === "inline" && (n.startInline ? n.startInline.push(i.start) : n.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (n.childTokens[i.name] = i.childTokens);
      }), r.extensions = n), o.renderer) {
        const i = this.defaults.renderer || new lE(this.defaults);
        for (const a in o.renderer) {
          if (!(a in i))
            throw new Error(`renderer '${a}' does not exist`);
          if (["options", "parser"].includes(a))
            continue;
          const s = a, c = o.renderer[s], l = i[s];
          i[s] = (...d) => {
            let u = c.apply(i, d);
            return u === !1 && (u = l.apply(i, d)), u || "";
          };
        }
        r.renderer = i;
      }
      if (o.tokenizer) {
        const i = this.defaults.tokenizer || new cE(this.defaults);
        for (const a in o.tokenizer) {
          if (!(a in i))
            throw new Error(`tokenizer '${a}' does not exist`);
          if (["options", "rules", "lexer"].includes(a))
            continue;
          const s = a, c = o.tokenizer[s], l = i[s];
          i[s] = (...d) => {
            let u = c.apply(i, d);
            return u === !1 && (u = l.apply(i, d)), u;
          };
        }
        r.tokenizer = i;
      }
      if (o.hooks) {
        const i = this.defaults.hooks || new N$();
        for (const a in o.hooks) {
          if (!(a in i))
            throw new Error(`hook '${a}' does not exist`);
          if (["options", "block"].includes(a))
            continue;
          const s = a, c = o.hooks[s], l = i[s];
          N$.passThroughHooks.has(a) ? i[s] = (d) => {
            if (this.defaults.async)
              return Promise.resolve(c.call(i, d)).then((_) => l.call(i, _));
            const u = c.call(i, d);
            return l.call(i, u);
          } : i[s] = (...d) => {
            let u = c.apply(i, d);
            return u === !1 && (u = l.apply(i, d)), u;
          };
        }
        r.hooks = i;
      }
      if (o.walkTokens) {
        const i = this.defaults.walkTokens, a = o.walkTokens;
        r.walkTokens = function(s) {
          let c = [];
          return c.push(a.call(this, s)), i && (c = c.concat(i.call(this, s))), c;
        };
      }
      this.defaults = { ...this.defaults, ...r };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
  lexer(t, n) {
    return gl.lex(t, n ?? this.defaults);
  }
  parser(t, n) {
    return hl.parse(t, n ?? this.defaults);
  }
  parseMarkdown(t) {
    return (o, r) => {
      const i = { ...r }, a = { ...this.defaults, ...i }, s = this.onError(!!a.silent, !!a.async);
      if (this.defaults.async === !0 && i.async === !1)
        return s(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof o > "u" || o === null)
        return s(new Error("marked(): input parameter is undefined or null"));
      if (typeof o != "string")
        return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(o) + ", string expected"));
      a.hooks && (a.hooks.options = a, a.hooks.block = t);
      const c = a.hooks ? a.hooks.provideLexer() : t ? gl.lex : gl.lexInline, l = a.hooks ? a.hooks.provideParser() : t ? hl.parse : hl.parseInline;
      if (a.async)
        return Promise.resolve(a.hooks ? a.hooks.preprocess(o) : o).then((d) => c(d, a)).then((d) => a.hooks ? a.hooks.processAllTokens(d) : d).then((d) => a.walkTokens ? Promise.all(this.walkTokens(d, a.walkTokens)).then(() => d) : d).then((d) => l(d, a)).then((d) => a.hooks ? a.hooks.postprocess(d) : d).catch(s);
      try {
        a.hooks && (o = a.hooks.preprocess(o));
        let d = c(o, a);
        a.hooks && (d = a.hooks.processAllTokens(d)), a.walkTokens && this.walkTokens(d, a.walkTokens);
        let u = l(d, a);
        return a.hooks && (u = a.hooks.postprocess(u)), u;
      } catch (d) {
        return s(d);
      }
    };
  }
  onError(t, n) {
    return (o) => {
      if (o.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
        const r = "<p>An error occurred:</p><pre>" + Cd(o.message + "", !0) + "</pre>";
        return n ? Promise.resolve(r) : r;
      }
      if (n)
        return Promise.reject(o);
      throw o;
    };
  }
}
const Wf = new _wc();
function pr(e, t) {
  return Wf.parse(e, t);
}
pr.options = pr.setOptions = function(e) {
  return Wf.setOptions(e), pr.defaults = Wf.defaults, Nue(pr.defaults), pr;
};
pr.getDefaults = M9;
pr.defaults = ug;
pr.use = function(...e) {
  return Wf.use(...e), pr.defaults = Wf.defaults, Nue(pr.defaults), pr;
};
pr.walkTokens = function(e, t) {
  return Wf.walkTokens(e, t);
};
pr.parseInline = Wf.parseInline;
pr.Parser = hl;
pr.parser = hl.parse;
pr.Renderer = lE;
pr.TextRenderer = U9;
pr.Lexer = gl;
pr.lexer = gl.lex;
pr.Tokenizer = cE;
pr.Hooks = N$;
pr.parse = pr;
pr.options;
pr.setOptions;
pr.use;
pr.walkTokens;
pr.parseInline;
hl.parse;
gl.lex;
function gA(e) {
  if (!e)
    return "";
  pr.use({ async: !1 });
  const t = pr.parse(e);
  return Rue.sanitize(t);
}
const Uue = ve.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Aue,
  {
    ref: n,
    className: ae(
      "border-default data-[state=checked]:bg-brand-default data-[state=checked]:text-brand peer h-4 w-4 shrink-0 rounded-[4px] border ring-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed",
      e
    ),
    ...t,
    children: /* @__PURE__ */ m(h$c, { className: ae("flex items-center justify-center text-current"), children: /* @__PURE__ */ m(ot, { name: "check", className: "h-4 w-4" }) })
  }
));
Uue.displayName = Aue.displayName;
const Ta = it(
  ({ label: e, description: t, error: n, disabled: o, descriptionAsSafeHtml: r, ...i }, a) => {
    const s = !e || i.descriptionAsLabel, c = Cc();
    return /* @__PURE__ */ Y("div", { className: "block items-center sm:flex", children: [
      e && /* @__PURE__ */ m("div", { className: "min-w-48 mb-4 sm:mb-0", children: ve.createElement(
        s ? "div" : "label",
        {
          className: ae("flex text-sm font-medium text-emphasis"),
          ...s ? {} : {
            htmlFor: i.id ? i.id : c
          }
        },
        e
      ) }),
      /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m("div", { className: "hover:bg-subtle relative flex w-fit items-center rounded-md p-1", children: ve.createElement(
        s ? "label" : "div",
        {
          className: ae(
            "relative flex items-start",
            "text-emphasis",
            n && "text-error"
          )
        },
        /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ m("div", { className: "flex h-5 items-center", children: /* @__PURE__ */ m(
            "input",
            {
              ...i,
              ref: a,
              type: "checkbox",
              disabled: o,
              id: i.id ? i.id : c,
              className: ae(
                "text-emphasis focus:ring-emphasis dark:text-muted border-default bg-default focus:bg-default active:bg-default h-4 w-4 rounded transition checked:hover:bg-gray-600 focus:outline-none focus:ring-0 ltr:mr-2 rtl:ml-2",
                !n && o ? "cursor-not-allowed bg-gray-300 checked:bg-gray-300 hover:bg-gray-300 hover:checked:bg-gray-300" : "hover:bg-subtle hover:border-emphasis checked:bg-gray-800",
                n && "border-error hover:bg-error hover:border-error checked:bg-darkerror checked:hover:border-error checked:hover:bg-darkerror",
                i.className
              )
            }
          ) }),
          r ? /* @__PURE__ */ m(
            "span",
            {
              className: ae(
                "text-default ml-2 text-sm",
                !e && "font-medium",
                i.descriptionClassName
              ),
              dangerouslySetInnerHTML: {
                __html: gA(r)
              }
            }
          ) : /* @__PURE__ */ m(
            "span",
            {
              className: ae(
                "text-default ml-2 text-sm",
                !e && "font-medium",
                i.descriptionClassName
              ),
              children: t
            }
          )
        ] })
      ) }) })
    ] });
  }
);
Ta.displayName = "CheckboxField";
function iK(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? iK(Object(n), !0).forEach(function(o) {
      af(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : iK(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
var pwc = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function mwc(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, o = e.defaultMenuIsOpen, r = o === void 0 ? !1 : o, i = e.defaultValue, a = i === void 0 ? null : i, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, d = e.onInputChange, u = e.onMenuClose, _ = e.onMenuOpen, p = e.value, f = cg(e, pwc), g = ze(s !== void 0 ? s : n), h = od(g, 2), b = h[0], v = h[1], $ = ze(c !== void 0 ? c : r), k = od($, 2), S = k[0], O = k[1], I = ze(p !== void 0 ? p : a), D = od(I, 2), M = D[0], N = D[1], C = at(function(j, q) {
    typeof l == "function" && l(j, q), N(j);
  }, [l]), P = at(function(j, q) {
    var V;
    typeof d == "function" && (V = d(j, q)), v(V !== void 0 ? V : j);
  }, [d]), x = at(function() {
    typeof _ == "function" && _(), O(!0);
  }, [_]), w = at(function() {
    typeof u == "function" && u(), O(!1);
  }, [u]), E = s !== void 0 ? s : b, T = c !== void 0 ? c : S, z = p !== void 0 ? p : M;
  return Vn(Vn({}, f), {}, {
    inputValue: E,
    menuIsOpen: T,
    onChange: C,
    onInputChange: P,
    onMenuClose: w,
    onMenuOpen: x,
    value: z
  });
}
function lM(e, t) {
  return lM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, r) {
    return o.__proto__ = r, o;
  }, lM(e, t);
}
function Wue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && lM(e, t);
}
const fwc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wue
}, Symbol.toStringTag, { value: "Module" }));
function dE(e) {
  return dE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, dE(e);
}
function gwc() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function hwc(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vwc(e, t) {
  if (t && (S_(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hwc(e);
}
function bwc(e) {
  var t = gwc();
  return function() {
    var o = dE(e), r;
    if (t) {
      var i = dE(this).constructor;
      r = Reflect.construct(o, arguments, i);
    } else
      r = o.apply(this, arguments);
    return vwc(this, r);
  };
}
function ywc(e) {
  if (Array.isArray(e))
    return oD(e);
}
function $wc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function wwc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W9(e) {
  return ywc(e) || $wc(e) || Nse(e) || wwc();
}
const kwc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W9
}, Symbol.toStringTag, { value: "Module" }));
function Swc(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function xwc(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Ewc = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(xwc(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = Swc(r);
      try {
        i.insertRule(o, i.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Ba = "-ms-", uE = "-moz-", er = "-webkit-", Gue = "comm", G9 = "rule", H9 = "decl", Twc = "@import", Hue = "@keyframes", Awc = Math.abs, hA = String.fromCharCode, Cwc = Object.assign;
function zwc(e, t) {
  return (((t << 2 ^ Ys(e, 0)) << 2 ^ Ys(e, 1)) << 2 ^ Ys(e, 2)) << 2 ^ Ys(e, 3);
}
function Kue(e) {
  return e.trim();
}
function Owc(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function dr(e, t, n) {
  return e.replace(t, n);
}
function dM(e, t) {
  return e.indexOf(t);
}
function Ys(e, t) {
  return e.charCodeAt(t) | 0;
}
function Iw(e, t, n) {
  return e.slice(t, n);
}
function qd(e) {
  return e.length;
}
function K9(e) {
  return e.length;
}
function R2(e, t) {
  return t.push(e), e;
}
function Pwc(e, t) {
  return e.map(t).join("");
}
var vA = 1, Rv = 1, Yue = 0, ic = 0, zi = 0, tb = "";
function bA(e, t, n, o, r, i, a) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: vA, column: Rv, length: a, return: "" };
}
function Ly(e, t) {
  return Cwc(bA("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Iwc() {
  return zi;
}
function Rwc() {
  return zi = ic > 0 ? Ys(tb, --ic) : 0, Rv--, zi === 10 && (Rv = 1, vA--), zi;
}
function Pc() {
  return zi = ic < Yue ? Ys(tb, ic++) : 0, Rv++, zi === 10 && (Rv = 1, vA++), zi;
}
function ru() {
  return Ys(tb, ic);
}
function YS() {
  return ic;
}
function Y0(e, t) {
  return Iw(tb, e, t);
}
function Rw(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zue(e) {
  return vA = Rv = 1, Yue = qd(tb = e), ic = 0, [];
}
function Que(e) {
  return tb = "", e;
}
function ZS(e) {
  return Kue(Y0(ic - 1, uM(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Nwc(e) {
  for (; (zi = ru()) && zi < 33; )
    Pc();
  return Rw(e) > 2 || Rw(zi) > 3 ? "" : " ";
}
function Dwc(e, t) {
  for (; --t && Pc() && !(zi < 48 || zi > 102 || zi > 57 && zi < 65 || zi > 70 && zi < 97); )
    ;
  return Y0(e, YS() + (t < 6 && ru() == 32 && Pc() == 32));
}
function uM(e) {
  for (; Pc(); )
    switch (zi) {
      case e:
        return ic;
      case 34:
      case 39:
        e !== 34 && e !== 39 && uM(zi);
        break;
      case 40:
        e === 41 && uM(e);
        break;
      case 92:
        Pc();
        break;
    }
  return ic;
}
function Mwc(e, t) {
  for (; Pc() && e + zi !== 57; )
    if (e + zi === 84 && ru() === 47)
      break;
  return "/*" + Y0(t, ic - 1) + "*" + hA(e === 47 ? e : Pc());
}
function Lwc(e) {
  for (; !Rw(ru()); )
    Pc();
  return Y0(e, ic);
}
function qwc(e) {
  return Que(QS("", null, null, null, [""], e = Zue(e), 0, [0], e));
}
function QS(e, t, n, o, r, i, a, s, c) {
  for (var l = 0, d = 0, u = a, _ = 0, p = 0, f = 0, g = 1, h = 1, b = 1, v = 0, $ = "", k = r, S = i, O = o, I = $; h; )
    switch (f = v, v = Pc()) {
      case 40:
        if (f != 108 && I.charCodeAt(u - 1) == 58) {
          dM(I += dr(ZS(v), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += ZS(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += Nwc(f);
        break;
      case 92:
        I += Dwc(YS() - 1, 7);
        continue;
      case 47:
        switch (ru()) {
          case 42:
          case 47:
            R2(jwc(Mwc(Pc(), YS()), t, n), c);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * g:
        s[l++] = qd(I) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            h = 0;
          case 59 + d:
            p > 0 && qd(I) - u && R2(p > 32 ? sK(I + ";", o, n, u - 1) : sK(dr(I, " ", "") + ";", o, n, u - 2), c);
            break;
          case 59:
            I += ";";
          default:
            if (R2(O = aK(I, t, n, l, d, r, s, $, k = [], S = [], u), i), v === 123)
              if (d === 0)
                QS(I, t, O, O, k, i, u, s, S);
              else
                switch (_) {
                  case 100:
                  case 109:
                  case 115:
                    QS(e, O, O, o && R2(aK(e, O, O, 0, 0, r, s, $, r, k = [], u), S), r, S, u, s, o ? k : S);
                    break;
                  default:
                    QS(I, O, O, O, [""], S, 0, s, S);
                }
        }
        l = d = p = 0, g = b = 1, $ = I = "", u = a;
        break;
      case 58:
        u = 1 + qd(I), p = f;
      default:
        if (g < 1) {
          if (v == 123)
            --g;
          else if (v == 125 && g++ == 0 && Rwc() == 125)
            continue;
        }
        switch (I += hA(v), v * g) {
          case 38:
            b = d > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            s[l++] = (qd(I) - 1) * b, b = 1;
            break;
          case 64:
            ru() === 45 && (I += ZS(Pc())), _ = ru(), d = u = qd($ = I += Lwc(YS())), v++;
            break;
          case 45:
            f === 45 && qd(I) == 2 && (g = 0);
        }
    }
  return i;
}
function aK(e, t, n, o, r, i, a, s, c, l, d) {
  for (var u = r - 1, _ = r === 0 ? i : [""], p = K9(_), f = 0, g = 0, h = 0; f < o; ++f)
    for (var b = 0, v = Iw(e, u + 1, u = Awc(g = a[f])), $ = e; b < p; ++b)
      ($ = Kue(g > 0 ? _[b] + " " + v : dr(v, /&\f/g, _[b]))) && (c[h++] = $);
  return bA(e, t, n, r === 0 ? G9 : s, c, l, d);
}
function jwc(e, t, n) {
  return bA(e, t, n, Gue, hA(Iwc()), Iw(e, 2, -2), 0);
}
function sK(e, t, n, o) {
  return bA(e, t, n, H9, Iw(e, 0, o), Iw(e, o + 1, -1), o);
}
function Jue(e, t) {
  switch (zwc(e, t)) {
    case 5103:
      return er + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return er + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return er + e + uE + e + Ba + e + e;
    case 6828:
    case 4268:
      return er + e + Ba + e + e;
    case 6165:
      return er + e + Ba + "flex-" + e + e;
    case 5187:
      return er + e + dr(e, /(\w+).+(:[^]+)/, er + "box-$1$2" + Ba + "flex-$1$2") + e;
    case 5443:
      return er + e + Ba + "flex-item-" + dr(e, /flex-|-self/, "") + e;
    case 4675:
      return er + e + Ba + "flex-line-pack" + dr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return er + e + Ba + dr(e, "shrink", "negative") + e;
    case 5292:
      return er + e + Ba + dr(e, "basis", "preferred-size") + e;
    case 6060:
      return er + "box-" + dr(e, "-grow", "") + er + e + Ba + dr(e, "grow", "positive") + e;
    case 4554:
      return er + dr(e, /([^-])(transform)/g, "$1" + er + "$2") + e;
    case 6187:
      return dr(dr(dr(e, /(zoom-|grab)/, er + "$1"), /(image-set)/, er + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return dr(e, /(image-set\([^]*)/, er + "$1$`$1");
    case 4968:
      return dr(dr(e, /(.+:)(flex-)?(.*)/, er + "box-pack:$3" + Ba + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + er + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return dr(e, /(.+)-inline(.+)/, er + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (qd(e) - 1 - t > 6)
        switch (Ys(e, t + 1)) {
          case 109:
            if (Ys(e, t + 4) !== 45)
              break;
          case 102:
            return dr(e, /(.+:)(.+)-([^]+)/, "$1" + er + "$2-$3$1" + uE + (Ys(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~dM(e, "stretch") ? Jue(dr(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Ys(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Ys(e, qd(e) - 3 - (~dM(e, "!important") && 10))) {
        case 107:
          return dr(e, ":", ":" + er) + e;
        case 101:
          return dr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + er + (Ys(e, 14) === 45 ? "inline-" : "") + "box$3$1" + er + "$2$3$1" + Ba + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Ys(e, t + 11)) {
        case 114:
          return er + e + Ba + dr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return er + e + Ba + dr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return er + e + Ba + dr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return er + e + Ba + e + e;
  }
  return e;
}
function Uh(e, t) {
  for (var n = "", o = K9(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function Fwc(e, t, n, o) {
  switch (e.type) {
    case Twc:
    case H9:
      return e.return = e.return || e.value;
    case Gue:
      return "";
    case Hue:
      return e.return = e.value + "{" + Uh(e.children, o) + "}";
    case G9:
      e.value = e.props.join(",");
  }
  return qd(n = Uh(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function Vwc(e) {
  var t = K9(e);
  return function(n, o, r, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, o, r, i) || "";
    return a;
  };
}
function Bwc(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Uwc(e, t, n, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case H9:
        e.return = Jue(e.value, e.length);
        break;
      case Hue:
        return Uh([Ly(e, { value: dr(e.value, "@", "@" + er) })], o);
      case G9:
        if (e.length)
          return Pwc(e.props, function(r) {
            switch (Owc(r, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Uh([Ly(e, { props: [dr(r, /:(read-\w+)/, ":" + uE + "$1")] })], o);
              case "::placeholder":
                return Uh([
                  Ly(e, { props: [dr(r, /:(plac\w+)/, ":" + er + "input-$1")] }),
                  Ly(e, { props: [dr(r, /:(plac\w+)/, ":" + uE + "$1")] }),
                  Ly(e, { props: [dr(r, /:(plac\w+)/, Ba + "input-$1")] })
                ], o);
            }
            return "";
          });
    }
}
function Wwc(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Gwc = function(t, n, o) {
  for (var r = 0, i = 0; r = i, i = ru(), r === 38 && i === 12 && (n[o] = 1), !Rw(i); )
    Pc();
  return Y0(t, ic);
}, Hwc = function(t, n) {
  var o = -1, r = 44;
  do
    switch (Rw(r)) {
      case 0:
        r === 38 && ru() === 12 && (n[o] = 1), t[o] += Gwc(ic - 1, n, o);
        break;
      case 2:
        t[o] += ZS(r);
        break;
      case 4:
        if (r === 44) {
          t[++o] = ru() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      default:
        t[o] += hA(r);
    }
  while (r = Pc());
  return t;
}, Kwc = function(t, n) {
  return Que(Hwc(Zue(t), n));
}, cK = /* @__PURE__ */ new WeakMap(), Ywc = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, r = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !cK.get(o)) && !r) {
      cK.set(t, !0);
      for (var i = [], a = Kwc(n, i), s = o.props, c = 0, l = 0; c < a.length; c++)
        for (var d = 0; d < s.length; d++, l++)
          t.props[l] = i[c] ? a[c].replace(/&\f/g, s[d]) : s[d] + " " + a[c];
    }
  }
}, Zwc = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, Qwc = [Uwc], Jwc = function(t) {
  var n = t.key;
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(g) {
      var h = g.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || Qwc, i = {}, a, s = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var h = g.getAttribute("data-emotion").split(" "), b = 1; b < h.length; b++)
        i[h[b]] = !0;
      s.push(g);
    }
  );
  var c, l = [Ywc, Zwc];
  {
    var d, u = [Fwc, Bwc(function(g) {
      d.insert(g);
    })], _ = Vwc(l.concat(r, u)), p = function(h) {
      return Uh(qwc(h), _);
    };
    c = function(h, b, v, $) {
      d = v, p(h ? h + "{" + b.styles + "}" : b.styles), $ && (f.inserted[b.name] = !0);
    };
  }
  var f = {
    key: n,
    sheet: new Ewc({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return f.sheet.hydrate(s), f;
}, Xue = { exports: {} }, br = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var da = typeof Symbol == "function" && Symbol.for, Y9 = da ? Symbol.for("react.element") : 60103, Z9 = da ? Symbol.for("react.portal") : 60106, yA = da ? Symbol.for("react.fragment") : 60107, $A = da ? Symbol.for("react.strict_mode") : 60108, wA = da ? Symbol.for("react.profiler") : 60114, kA = da ? Symbol.for("react.provider") : 60109, SA = da ? Symbol.for("react.context") : 60110, Q9 = da ? Symbol.for("react.async_mode") : 60111, xA = da ? Symbol.for("react.concurrent_mode") : 60111, EA = da ? Symbol.for("react.forward_ref") : 60112, TA = da ? Symbol.for("react.suspense") : 60113, Xwc = da ? Symbol.for("react.suspense_list") : 60120, AA = da ? Symbol.for("react.memo") : 60115, CA = da ? Symbol.for("react.lazy") : 60116, e0c = da ? Symbol.for("react.block") : 60121, t0c = da ? Symbol.for("react.fundamental") : 60117, n0c = da ? Symbol.for("react.responder") : 60118, o0c = da ? Symbol.for("react.scope") : 60119;
function Vc(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case Y9:
        switch (e = e.type, e) {
          case Q9:
          case xA:
          case yA:
          case wA:
          case $A:
          case TA:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case SA:
              case EA:
              case CA:
              case AA:
              case kA:
                return e;
              default:
                return t;
            }
        }
      case Z9:
        return t;
    }
  }
}
function e_e(e) {
  return Vc(e) === xA;
}
br.AsyncMode = Q9;
br.ConcurrentMode = xA;
br.ContextConsumer = SA;
br.ContextProvider = kA;
br.Element = Y9;
br.ForwardRef = EA;
br.Fragment = yA;
br.Lazy = CA;
br.Memo = AA;
br.Portal = Z9;
br.Profiler = wA;
br.StrictMode = $A;
br.Suspense = TA;
br.isAsyncMode = function(e) {
  return e_e(e) || Vc(e) === Q9;
};
br.isConcurrentMode = e_e;
br.isContextConsumer = function(e) {
  return Vc(e) === SA;
};
br.isContextProvider = function(e) {
  return Vc(e) === kA;
};
br.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Y9;
};
br.isForwardRef = function(e) {
  return Vc(e) === EA;
};
br.isFragment = function(e) {
  return Vc(e) === yA;
};
br.isLazy = function(e) {
  return Vc(e) === CA;
};
br.isMemo = function(e) {
  return Vc(e) === AA;
};
br.isPortal = function(e) {
  return Vc(e) === Z9;
};
br.isProfiler = function(e) {
  return Vc(e) === wA;
};
br.isStrictMode = function(e) {
  return Vc(e) === $A;
};
br.isSuspense = function(e) {
  return Vc(e) === TA;
};
br.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === yA || e === xA || e === wA || e === $A || e === TA || e === Xwc || typeof e == "object" && e !== null && (e.$$typeof === CA || e.$$typeof === AA || e.$$typeof === kA || e.$$typeof === SA || e.$$typeof === EA || e.$$typeof === t0c || e.$$typeof === n0c || e.$$typeof === o0c || e.$$typeof === e0c);
};
br.typeOf = Vc;
Xue.exports = br;
var r0c = Xue.exports, J9 = r0c, i0c = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, a0c = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, s0c = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, t_e = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, X9 = {};
X9[J9.ForwardRef] = s0c;
X9[J9.Memo] = t_e;
function lK(e) {
  return J9.isMemo(e) ? t_e : X9[e.$$typeof] || i0c;
}
var c0c = Object.defineProperty, l0c = Object.getOwnPropertyNames, dK = Object.getOwnPropertySymbols, d0c = Object.getOwnPropertyDescriptor, u0c = Object.getPrototypeOf, uK = Object.prototype;
function n_e(e, t, n) {
  if (typeof t != "string") {
    if (uK) {
      var o = u0c(t);
      o && o !== uK && n_e(e, o, n);
    }
    var r = l0c(t);
    dK && (r = r.concat(dK(t)));
    for (var i = lK(e), a = lK(t), s = 0; s < r.length; ++s) {
      var c = r[s];
      if (!a0c[c] && !(n && n[c]) && !(a && a[c]) && !(i && i[c])) {
        var l = d0c(t, c);
        try {
          c0c(e, c, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var _0c = n_e;
const _K = /* @__PURE__ */ Zr(_0c);
var p0c = !0;
function m0c(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : o += r + " ";
  }), o;
}
var o_e = function(t, n, o) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  p0c === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, f0c = function(t, n, o) {
  o_e(t, n, o);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + r : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function g0c(e) {
  for (var t = 0, n, o = 0, r = e.length; r >= 4; ++o, r -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var h0c = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, v0c = /[A-Z]|^ms/g, b0c = /_EMO_([^_]+?)_([^]*?)_EMO_/g, r_e = function(t) {
  return t.charCodeAt(1) === 45;
}, pK = function(t) {
  return t != null && typeof t != "boolean";
}, N3 = /* @__PURE__ */ Wwc(function(e) {
  return r_e(e) ? e : e.replace(v0c, "-$&").toLowerCase();
}), mK = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(b0c, function(o, r, i) {
          return jd = {
            name: r,
            styles: i,
            next: jd
          }, r;
        });
  }
  return h0c[t] !== 1 && !r_e(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Nw(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return jd = {
          name: n.name,
          styles: n.styles,
          next: jd
        }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            jd = {
              name: o.name,
              styles: o.styles,
              next: jd
            }, o = o.next;
        var r = n.styles + ";";
        return r;
      }
      return y0c(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = jd, a = n(e);
        return jd = i, Nw(e, t, a);
      }
      break;
    }
  }
  if (t == null)
    return n;
  var s = t[n];
  return s !== void 0 ? s : n;
}
function y0c(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      o += Nw(e, t, n[r]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object")
        t != null && t[a] !== void 0 ? o += i + "{" + t[a] + "}" : pK(a) && (o += N3(i) + ":" + mK(i, a) + ";");
      else if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
        for (var s = 0; s < a.length; s++)
          pK(a[s]) && (o += N3(i) + ":" + mK(i, a[s]) + ";");
      else {
        var c = Nw(e, t, a);
        switch (i) {
          case "animation":
          case "animationName": {
            o += N3(i) + ":" + c + ";";
            break;
          }
          default:
            o += i + "{" + c + "}";
        }
      }
    }
  return o;
}
var fK = /label:\s*([^\s;\n{]+)\s*(;|$)/g, jd, i_e = function(t, n, o) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, i = "";
  jd = void 0;
  var a = t[0];
  a == null || a.raw === void 0 ? (r = !1, i += Nw(o, n, a)) : i += a[0];
  for (var s = 1; s < t.length; s++)
    i += Nw(o, n, t[s]), r && (i += a[s]);
  fK.lastIndex = 0;
  for (var c = "", l; (l = fK.exec(i)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    l[1];
  var d = g0c(i) + c;
  return {
    name: d,
    styles: i,
    next: jd
  };
}, ej = {}.hasOwnProperty, a_e = /* @__PURE__ */ No(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Jwc({
    key: "css"
  }) : null
);
a_e.Provider;
var $0c = function(t) {
  return /* @__PURE__ */ it(function(n, o) {
    var r = Pn(a_e);
    return t(n, r, o);
  });
}, w0c = /* @__PURE__ */ No({}), k0c = $e.useInsertionEffect ? $e.useInsertionEffect : function(t) {
  t();
};
function S0c(e) {
  k0c(e);
}
var _M = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", x0c = function(t, n) {
  var o = {};
  for (var r in n)
    ej.call(n, r) && (o[r] = n[r]);
  return o[_M] = t, o;
}, E0c = function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return o_e(n, o, r), S0c(function() {
    return f0c(n, o, r);
  }), null;
}, T0c = /* @__PURE__ */ $0c(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[_M], i = [o], a = "";
  typeof e.className == "string" ? a = m0c(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var s = i_e(i, void 0, Pn(w0c));
  a += t.key + "-" + s.name;
  var c = {};
  for (var l in e)
    ej.call(e, l) && l !== "css" && l !== _M && (c[l] = e[l]);
  return c.ref = n, c.className = a, /* @__PURE__ */ Pe(Oi, null, /* @__PURE__ */ Pe(E0c, {
    cache: t,
    serialized: s,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ Pe(r, c));
}), An = function(t, n) {
  var o = arguments;
  if (n == null || !ej.call(n, "css"))
    return Pe.apply(void 0, o);
  var r = o.length, i = new Array(r);
  i[0] = T0c, i[1] = x0c(t, n);
  for (var a = 2; a < r; a++)
    i[a] = o[a];
  return Pe.apply(null, i);
};
function tj() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return i_e(t);
}
var A0c = function() {
  var t = tj.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function C0c(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function z0c(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
const O0c = ["top", "right", "bottom", "left"];
O0c.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
function Zd(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function s_e(e) {
  return Zd(e).getComputedStyle(e);
}
function c_e(e) {
  return e instanceof Zd(e).Node;
}
function l_e(e) {
  return c_e(e) ? (e.nodeName || "").toLowerCase() : "";
}
let N2;
function P0c() {
  if (N2)
    return N2;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (N2 = e.brands.map((t) => t.brand + "/" + t.version).join(" "), N2) : navigator.userAgent;
}
function nj(e) {
  return e instanceof Zd(e).HTMLElement;
}
function Wh(e) {
  return e instanceof Zd(e).Element;
}
function gK(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Zd(e).ShadowRoot || e instanceof ShadowRoot;
}
function d_e(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = s_e(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function I0c() {
  return /^((?!chrome|android).)*safari/i.test(P0c());
}
function R0c(e) {
  return ["html", "body", "#document"].includes(l_e(e));
}
const _E = Math.round;
function N0c(e) {
  const t = s_e(e);
  let n = parseFloat(t.width), o = parseFloat(t.height);
  const r = nj(e), i = r ? e.offsetWidth : n, a = r ? e.offsetHeight : o, s = _E(n) !== i || _E(o) !== a;
  return s && (n = i, o = a), { width: n, height: o, fallback: s };
}
function u_e(e) {
  return Wh(e) ? e : e.contextElement;
}
const __e = { x: 1, y: 1 };
function D3(e) {
  const t = u_e(e);
  if (!nj(t))
    return __e;
  const n = t.getBoundingClientRect(), { width: o, height: r, fallback: i } = N0c(t);
  let a = (i ? _E(n.width) : n.width) / o, s = (i ? _E(n.height) : n.height) / r;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function hK(e, t, n, o) {
  var r, i;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), s = u_e(e);
  let c = __e;
  t && (o ? Wh(o) && (c = D3(o)) : c = D3(e));
  const l = s ? Zd(s) : window, d = I0c() && n;
  let u = (a.left + (d && ((r = l.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / c.x, _ = (a.top + (d && ((i = l.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / c.y, p = a.width / c.x, f = a.height / c.y;
  if (s) {
    const g = Zd(s), h = o && Wh(o) ? Zd(o) : o;
    let b = g.frameElement;
    for (; b && o && h !== g; ) {
      const v = D3(b), $ = b.getBoundingClientRect(), k = getComputedStyle(b);
      $.x += (b.clientLeft + parseFloat(k.paddingLeft)) * v.x, $.y += (b.clientTop + parseFloat(k.paddingTop)) * v.y, u *= v.x, _ *= v.y, p *= v.x, f *= v.y, u += $.x, _ += $.y, b = Zd(b).frameElement;
    }
  }
  return z0c({ width: p, height: f, x: u, y: _ });
}
function D0c(e) {
  return ((c_e(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function M0c(e) {
  if (l_e(e) === "html")
    return e;
  const t = e.assignedSlot || e.parentNode || gK(e) && e.host || D0c(e);
  return gK(t) ? t.host : t;
}
function p_e(e) {
  const t = M0c(e);
  return R0c(t) ? t.ownerDocument.body : nj(t) && d_e(t) ? t : p_e(t);
}
function JS(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = p_e(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Zd(o);
  return r ? t.concat(i, i.visualViewport || [], d_e(o) ? o : []) : t.concat(o, JS(o));
}
function L0c(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: a = !0, animationFrame: s = !1 } = o, c = r && !s, l = c || i ? [...Wh(e) ? JS(e) : e.contextElement ? JS(e.contextElement) : [], ...JS(t)] : [];
  l.forEach((p) => {
    c && p.addEventListener("scroll", n, { passive: !0 }), i && p.addEventListener("resize", n);
  });
  let d, u = null;
  a && (u = new ResizeObserver(() => {
    n();
  }), Wh(e) && !s && u.observe(e), Wh(e) || !e.contextElement || s || u.observe(e.contextElement), u.observe(t));
  let _ = s ? hK(e) : null;
  return s && function p() {
    const f = hK(e);
    !_ || f.x === _.x && f.y === _.y && f.width === _.width && f.height === _.height || n(), _ = f, d = requestAnimationFrame(p);
  }(), n(), () => {
    var p;
    l.forEach((f) => {
      c && f.removeEventListener("scroll", n), i && f.removeEventListener("resize", n);
    }), (p = u) == null || p.disconnect(), u = null, s && cancelAnimationFrame(d);
  };
}
var pM = ts, q0c = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], pE = function() {
};
function j0c(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function F0c(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    o[r - 2] = arguments[r];
  var i = [].concat(o);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(j0c(e, a)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var vK = function(t) {
  return Z0c(t) ? t.filter(Boolean) : S_(t) === "object" && t !== null ? [t] : [];
}, m_e = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = cg(t, q0c);
  return Vn({}, n);
}, bi = function(t, n, o) {
  var r = t.cx, i = t.getStyles, a = t.getClassNames, s = t.className;
  return {
    css: i(n, t),
    className: r(o ?? {}, a(n, t), s)
  };
};
function zA(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function V0c(e) {
  return zA(e) ? window.innerHeight : e.clientHeight;
}
function f_e(e) {
  return zA(e) ? window.pageYOffset : e.scrollTop;
}
function mE(e, t) {
  if (zA(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function B0c(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", o = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var r = e; r = r.parentElement; )
    if (t = getComputedStyle(r), !(n && t.position === "static") && o.test(t.overflow + t.overflowY + t.overflowX))
      return r;
  return document.documentElement;
}
function U0c(e, t, n, o) {
  return n * ((e = e / o - 1) * e * e + 1) + t;
}
function D2(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : pE, r = f_e(e), i = t - r, a = 10, s = 0;
  function c() {
    s += a;
    var l = U0c(s, r, i, n);
    mE(e, l), s < n ? window.requestAnimationFrame(c) : o(e);
  }
  c();
}
function bK(e, t) {
  var n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? mE(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && mE(e, Math.max(t.offsetTop - r, 0));
}
function W0c(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function yK() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function G0c() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var g_e = !1, H0c = {
  get passive() {
    return g_e = !0;
  }
}, M2 = typeof window < "u" ? window : {};
M2.addEventListener && M2.removeEventListener && (M2.addEventListener("p", pE, H0c), M2.removeEventListener("p", pE, !1));
var K0c = g_e;
function Y0c(e) {
  return e != null;
}
function Z0c(e) {
  return Array.isArray(e);
}
function L2(e, t, n) {
  return e ? t : n;
}
var Q0c = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    o[r - 1] = arguments[r];
  var i = Object.entries(t).filter(function(a) {
    var s = od(a, 1), c = s[0];
    return !o.includes(c);
  });
  return i.reduce(function(a, s) {
    var c = od(s, 2), l = c[0], d = c[1];
    return a[l] = d, a;
  }, {});
};
function J0c(e) {
  var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, i = e.shouldScroll, a = e.isFixedPosition, s = e.controlHeight, c = B0c(n), l = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return l;
  var d = c.getBoundingClientRect(), u = d.height, _ = n.getBoundingClientRect(), p = _.bottom, f = _.height, g = _.top, h = n.offsetParent.getBoundingClientRect(), b = h.top, v = a ? window.innerHeight : V0c(c), $ = f_e(c), k = parseInt(getComputedStyle(n).marginBottom, 10), S = parseInt(getComputedStyle(n).marginTop, 10), O = b - S, I = v - g, D = O + $, M = u - $ - g, N = p - v + $ + k, C = $ + g - S, P = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (I >= f)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (M >= f && !a)
        return i && D2(c, N, P), {
          placement: "bottom",
          maxHeight: t
        };
      if (!a && M >= o || a && I >= o) {
        i && D2(c, N, P);
        var x = a ? I - k : M - k;
        return {
          placement: "bottom",
          maxHeight: x
        };
      }
      if (r === "auto" || a) {
        var w = t, E = a ? O : D;
        return E >= o && (w = Math.min(E - k - s, t)), {
          placement: "top",
          maxHeight: w
        };
      }
      if (r === "bottom")
        return i && mE(c, N), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (O >= f)
        return {
          placement: "top",
          maxHeight: t
        };
      if (D >= f && !a)
        return i && D2(c, C, P), {
          placement: "top",
          maxHeight: t
        };
      if (!a && D >= o || a && O >= o) {
        var T = t;
        return (!a && D >= o || a && O >= o) && (T = a ? O - S : D - S), i && D2(c, C, P), {
          placement: "top",
          maxHeight: T
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return l;
}
function X0c(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var h_e = function(t) {
  return t === "auto" ? "bottom" : t;
}, ekc = function(t, n) {
  var o, r = t.placement, i = t.theme, a = i.borderRadius, s = i.spacing, c = i.colors;
  return Vn((o = {
    label: "menu"
  }, af(o, X0c(r), "100%"), af(o, "position", "absolute"), af(o, "width", "100%"), af(o, "zIndex", 1), o), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: a,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, v_e = /* @__PURE__ */ No(null), tkc = function(t) {
  var n = t.children, o = t.minMenuHeight, r = t.maxMenuHeight, i = t.menuPlacement, a = t.menuPosition, s = t.menuShouldScrollIntoView, c = t.theme, l = Pn(v_e) || {}, d = l.setPortalPlacement, u = Ue(null), _ = ze(r), p = od(_, 2), f = p[0], g = p[1], h = ze(null), b = od(h, 2), v = b[0], $ = b[1], k = c.spacing.controlHeight;
  return pM(function() {
    var S = u.current;
    if (S) {
      var O = a === "fixed", I = s && !O, D = J0c({
        maxHeight: r,
        menuEl: S,
        minHeight: o,
        placement: i,
        shouldScroll: I,
        isFixedPosition: O,
        controlHeight: k
      });
      g(D.maxHeight), $(D.placement), d == null || d(D.placement);
    }
  }, [r, i, a, s, o, d, k]), n({
    ref: u,
    placerProps: Vn(Vn({}, t), {}, {
      placement: v || h_e(i),
      maxHeight: f
    })
  });
}, nkc = function(t) {
  var n = t.children, o = t.innerRef, r = t.innerProps;
  return An("div", We({}, bi(t, "menu", {
    menu: !0
  }), {
    ref: o
  }, r), n);
}, okc = function(t, n) {
  var o = t.maxHeight, r = t.theme.spacing.baseUnit;
  return Vn({
    maxHeight: o,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: r,
    paddingTop: r
  });
}, rkc = function(t) {
  var n = t.children, o = t.innerProps, r = t.innerRef, i = t.isMulti;
  return An("div", We({}, bi(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: r
  }, o), n);
}, b_e = function(t, n) {
  var o = t.theme, r = o.spacing.baseUnit, i = o.colors;
  return Vn({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px")
  });
}, ikc = b_e, akc = b_e, y_e = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), n);
};
y_e.defaultProps = {
  children: "No options"
};
var $_e = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), n);
};
$_e.defaultProps = {
  children: "Loading..."
};
var skc = function(t) {
  var n = t.rect, o = t.offset, r = t.position;
  return {
    left: n.left,
    position: r,
    top: o,
    width: n.width,
    zIndex: 1
  };
}, ckc = function(t) {
  var n = t.appendTo, o = t.children, r = t.controlElement, i = t.innerProps, a = t.menuPlacement, s = t.menuPosition, c = Ue(null), l = Ue(null), d = ze(h_e(a)), u = od(d, 2), _ = u[0], p = u[1], f = Tt(function() {
    return {
      setPortalPlacement: p
    };
  }, []), g = ze(null), h = od(g, 2), b = h[0], v = h[1], $ = at(function() {
    if (r) {
      var I = W0c(r), D = s === "fixed" ? 0 : window.pageYOffset, M = I[_] + D;
      (M !== (b == null ? void 0 : b.offset) || I.left !== (b == null ? void 0 : b.rect.left) || I.width !== (b == null ? void 0 : b.rect.width)) && v({
        offset: M,
        rect: I
      });
    }
  }, [r, s, _, b == null ? void 0 : b.offset, b == null ? void 0 : b.rect.left, b == null ? void 0 : b.rect.width]);
  pM(function() {
    $();
  }, [$]);
  var k = at(function() {
    typeof l.current == "function" && (l.current(), l.current = null), r && c.current && (l.current = L0c(r, c.current, $, {
      elementResize: "ResizeObserver" in window
    }));
  }, [r, $]);
  pM(function() {
    k();
  }, [k]);
  var S = at(function(I) {
    c.current = I, k();
  }, [k]);
  if (!n && s !== "fixed" || !b)
    return null;
  var O = An("div", We({
    ref: S
  }, bi(Vn(Vn({}, t), {}, {
    offset: b.offset,
    position: s,
    rect: b.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), o);
  return An(v_e.Provider, {
    value: f
  }, n ? /* @__PURE__ */ Wv(O, n) : O);
}, lkc = function(t) {
  var n = t.isDisabled, o = t.isRtl;
  return {
    label: "container",
    direction: o ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, dkc = function(t) {
  var n = t.children, o = t.innerProps, r = t.isDisabled, i = t.isRtl;
  return An("div", We({}, bi(t, "container", {
    "--is-disabled": r,
    "--is-rtl": i
  }), o), n);
}, ukc = function(t, n) {
  var o = t.theme.spacing, r = t.isMulti, i = t.hasValue, a = t.selectProps.controlShouldRenderValue;
  return Vn({
    alignItems: "center",
    display: r && i && a ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(o.baseUnit / 2, "px ").concat(o.baseUnit * 2, "px")
  });
}, _kc = function(t) {
  var n = t.children, o = t.innerProps, r = t.isMulti, i = t.hasValue;
  return An("div", We({}, bi(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": r,
    "value-container--has-value": i
  }), o), n);
}, pkc = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, mkc = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "indicatorsContainer", {
    indicators: !0
  }), o), n);
}, $K, fkc = ["size"], gkc = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
}, w_e = function(t) {
  var n = t.size, o = cg(t, fkc);
  return An("svg", We({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: gkc
  }, o));
}, oj = function(t) {
  return An(w_e, We({
    size: 20
  }, t), An("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, k_e = function(t) {
  return An(w_e, We({
    size: 20
  }, t), An("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, S_e = function(t, n) {
  var o = t.isFocused, r = t.theme, i = r.spacing.baseUnit, a = r.colors;
  return Vn({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: o ? a.neutral60 : a.neutral20,
    padding: i * 2,
    ":hover": {
      color: o ? a.neutral80 : a.neutral40
    }
  });
}, hkc = S_e, vkc = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), o), n || An(k_e, null));
}, bkc = S_e, ykc = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), o), n || An(oj, null));
}, $kc = function(t, n) {
  var o = t.isDisabled, r = t.theme, i = r.spacing.baseUnit, a = r.colors;
  return Vn({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: o ? a.neutral10 : a.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, wkc = function(t) {
  var n = t.innerProps;
  return An("span", We({}, n, bi(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, kkc = A0c($K || ($K = C0c([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Skc = function(t, n) {
  var o = t.isFocused, r = t.size, i = t.theme, a = i.colors, s = i.spacing.baseUnit;
  return Vn({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: o ? a.neutral60 : a.neutral20,
    padding: s * 2
  });
}, M3 = function(t) {
  var n = t.delay, o = t.offset;
  return An("span", {
    css: /* @__PURE__ */ tj({
      animation: "".concat(kkc, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: o ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
}, x_e = function(t) {
  var n = t.innerProps, o = t.isRtl;
  return An("div", We({}, bi(t, "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), An(M3, {
    delay: 0,
    offset: o
  }), An(M3, {
    delay: 160,
    offset: !0
  }), An(M3, {
    delay: 320,
    offset: !o
  }));
};
x_e.defaultProps = {
  size: 4
};
var xkc = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, i = t.theme, a = i.colors, s = i.borderRadius, c = i.spacing;
  return Vn({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: o ? a.neutral5 : a.neutral0,
    borderColor: o ? a.neutral10 : r ? a.primary : a.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(a.primary) : void 0,
    "&:hover": {
      borderColor: r ? a.primary : a.neutral30
    }
  });
}, Ekc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, i = t.innerRef, a = t.innerProps, s = t.menuIsOpen;
  return An("div", We({
    ref: i
  }, bi(t, "control", {
    control: !0,
    "control--is-disabled": o,
    "control--is-focused": r,
    "control--menu-is-open": s
  }), a), n);
}, Tkc = ["data"], Akc = function(t, n) {
  var o = t.theme.spacing;
  return n ? {} : {
    paddingBottom: o.baseUnit * 2,
    paddingTop: o.baseUnit * 2
  };
}, Ckc = function(t) {
  var n = t.children, o = t.cx, r = t.getStyles, i = t.getClassNames, a = t.Heading, s = t.headingProps, c = t.innerProps, l = t.label, d = t.theme, u = t.selectProps;
  return An("div", We({}, bi(t, "group", {
    group: !0
  }), c), An(a, We({}, s, {
    selectProps: u,
    theme: d,
    getStyles: r,
    getClassNames: i,
    cx: o
  }), l), An("div", null, n));
}, zkc = function(t, n) {
  var o = t.theme, r = o.colors, i = o.spacing;
  return Vn({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: r.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Okc = function(t) {
  var n = m_e(t);
  n.data;
  var o = cg(n, Tkc);
  return An("div", We({}, bi(t, "groupHeading", {
    "group-heading": !0
  }), o));
}, Pkc = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ikc = function(t, n) {
  var o = t.isDisabled, r = t.value, i = t.theme, a = i.spacing, s = i.colors;
  return Vn(Vn({
    visibility: o ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, Rkc), n ? {} : {
    margin: a.baseUnit / 2,
    paddingBottom: a.baseUnit / 2,
    paddingTop: a.baseUnit / 2,
    color: s.neutral80
  });
}, E_e = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Rkc = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Vn({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, E_e)
}, Nkc = function(t) {
  return Vn({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, E_e);
}, Dkc = function(t) {
  var n = t.cx, o = t.value, r = m_e(t), i = r.innerRef, a = r.isDisabled, s = r.isHidden, c = r.inputClassName, l = cg(r, Pkc);
  return An("div", We({}, bi(t, "input", {
    "input-container": !0
  }), {
    "data-value": o || ""
  }), An("input", We({
    className: n({
      input: !0
    }, c),
    ref: i,
    style: Nkc(s),
    disabled: a
  }, l)));
}, Mkc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.borderRadius, a = o.colors;
  return Vn({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: a.neutral10,
    borderRadius: i / 2,
    margin: r.baseUnit / 2
  });
}, Lkc = function(t, n) {
  var o = t.theme, r = o.borderRadius, i = o.colors, a = t.cropWithEllipsis;
  return Vn({
    overflow: "hidden",
    textOverflow: a || a === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: r / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, qkc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.borderRadius, a = o.colors, s = t.isFocused;
  return Vn({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: s ? a.dangerLight : void 0,
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: a.dangerLight,
      color: a.danger
    }
  });
}, T_e = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", o, n);
}, jkc = T_e, Fkc = T_e;
function Vkc(e) {
  var t = e.children, n = e.innerProps;
  return An("div", We({
    role: "button"
  }, n), t || An(oj, {
    size: 14
  }));
}
var Bkc = function(t) {
  var n = t.children, o = t.components, r = t.data, i = t.innerProps, a = t.isDisabled, s = t.removeProps, c = t.selectProps, l = o.Container, d = o.Label, u = o.Remove;
  return An(l, {
    data: r,
    innerProps: Vn(Vn({}, bi(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": a
    })), i),
    selectProps: c
  }, An(d, {
    data: r,
    innerProps: Vn({}, bi(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), An(u, {
    data: r,
    innerProps: Vn(Vn({}, bi(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: c
  }));
}, Ukc = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, i = t.isSelected, a = t.theme, s = a.spacing, c = a.colors;
  return Vn({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? c.primary : r ? c.primary25 : "transparent",
    color: o ? c.neutral20 : i ? c.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: o ? void 0 : i ? c.primary : c.primary50
    }
  });
}, Wkc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, i = t.isSelected, a = t.innerRef, s = t.innerProps;
  return An("div", We({}, bi(t, "option", {
    option: !0,
    "option--is-disabled": o,
    "option--is-focused": r,
    "option--is-selected": i
  }), {
    ref: a,
    "aria-disabled": o
  }, s), n);
}, Gkc = function(t, n) {
  var o = t.theme, r = o.spacing, i = o.colors;
  return Vn({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  });
}, Hkc = function(t) {
  var n = t.children, o = t.innerProps;
  return An("div", We({}, bi(t, "placeholder", {
    placeholder: !0
  }), o), n);
}, Kkc = function(t, n) {
  var o = t.isDisabled, r = t.theme, i = r.spacing, a = r.colors;
  return Vn({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: o ? a.neutral40 : a.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, Ykc = function(t) {
  var n = t.children, o = t.isDisabled, r = t.innerProps;
  return An("div", We({}, bi(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": o
  }), r), n);
}, sd = {
  ClearIndicator: ykc,
  Control: Ekc,
  DropdownIndicator: vkc,
  DownChevron: k_e,
  CrossIcon: oj,
  Group: Ckc,
  GroupHeading: Okc,
  IndicatorsContainer: mkc,
  IndicatorSeparator: wkc,
  Input: Dkc,
  LoadingIndicator: x_e,
  Menu: nkc,
  MenuList: rkc,
  MenuPortal: ckc,
  LoadingMessage: $_e,
  NoOptionsMessage: y_e,
  MultiValue: Bkc,
  MultiValueContainer: jkc,
  MultiValueLabel: Fkc,
  MultiValueRemove: Vkc,
  Option: Wkc,
  Placeholder: Hkc,
  SelectContainer: dkc,
  SingleValue: Ykc,
  ValueContainer: _kc
}, Zkc = function(t) {
  return Vn(Vn({}, sd), t.components);
}, wK = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Qkc(e, t) {
  return !!(e === t || wK(e) && wK(t));
}
function Jkc(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Qkc(e[n], t[n]))
      return !1;
  return !0;
}
function Xkc(e, t) {
  t === void 0 && (t = Jkc);
  var n = null;
  function o() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (n && n.lastThis === this && t(r, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, r);
    return n = {
      lastResult: a,
      lastArgs: r,
      lastThis: this
    }, a;
  }
  return o.clear = function() {
    n = null;
  }, o;
}
var e1c = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
}, kK = function(t) {
  return An("span", We({
    css: e1c
  }, t));
}, t1c = {
  guidance: function(t) {
    var n = t.isSearchable, o = t.isMulti, r = t.isDisabled, i = t.tabSelectsValue, a = t.context;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options".concat(r ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(o ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, o = t.label, r = o === void 0 ? "" : o, i = t.labels, a = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return a ? "option ".concat(r, " is disabled. Select another option.") : "option ".concat(r, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, o = t.focused, r = t.options, i = t.label, a = i === void 0 ? "" : i, s = t.selectValue, c = t.isDisabled, l = t.isSelected, d = function(f, g) {
      return f && f.length ? "".concat(f.indexOf(g) + 1, " of ").concat(f.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(a, " focused, ").concat(d(s, o), ".");
    if (n === "menu") {
      var u = c ? " disabled" : "", _ = "".concat(l ? "selected" : "focused").concat(u);
      return "option ".concat(a, " ").concat(_, ", ").concat(d(r, o), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, o = t.resultsMessage;
    return "".concat(o).concat(n ? " for search term " + n : "", ".");
  }
}, n1c = function(t) {
  var n = t.ariaSelection, o = t.focusedOption, r = t.focusedValue, i = t.focusableOptions, a = t.isFocused, s = t.selectValue, c = t.selectProps, l = t.id, d = c.ariaLiveMessages, u = c.getOptionLabel, _ = c.inputValue, p = c.isMulti, f = c.isOptionDisabled, g = c.isSearchable, h = c.menuIsOpen, b = c.options, v = c.screenReaderStatus, $ = c.tabSelectsValue, k = c["aria-label"], S = c["aria-live"], O = Tt(function() {
    return Vn(Vn({}, t1c), d || {});
  }, [d]), I = Tt(function() {
    var w = "";
    if (n && O.onChange) {
      var E = n.option, T = n.options, z = n.removedValue, j = n.removedValues, q = n.value, V = function(X) {
        return Array.isArray(X) ? null : X;
      }, F = z || E || V(q), L = F ? u(F) : "", U = T || j || void 0, W = U ? U.map(u) : [], H = Vn({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: F && f(F, s),
        label: L,
        labels: W
      }, n);
      w = O.onChange(H);
    }
    return w;
  }, [n, O, f, s, u]), D = Tt(function() {
    var w = "", E = o || r, T = !!(o && s && s.includes(o));
    if (E && O.onFocus) {
      var z = {
        focused: E,
        label: u(E),
        isDisabled: f(E, s),
        isSelected: T,
        options: i,
        context: E === o ? "menu" : "value",
        selectValue: s
      };
      w = O.onFocus(z);
    }
    return w;
  }, [o, r, u, f, O, i, s]), M = Tt(function() {
    var w = "";
    if (h && b.length && O.onFilter) {
      var E = v({
        count: i.length
      });
      w = O.onFilter({
        inputValue: _,
        resultsMessage: E
      });
    }
    return w;
  }, [i, _, h, O, b, v]), N = Tt(function() {
    var w = "";
    if (O.guidance) {
      var E = r ? "value" : h ? "menu" : "input";
      w = O.guidance({
        "aria-label": k,
        context: E,
        isDisabled: o && f(o, s),
        isMulti: p,
        isSearchable: g,
        tabSelectsValue: $
      });
    }
    return w;
  }, [k, o, r, p, f, g, h, O, s, $]), C = "".concat(D, " ").concat(M, " ").concat(N), P = An(Oi, null, An("span", {
    id: "aria-selection"
  }, I), An("span", {
    id: "aria-context"
  }, C)), x = (n == null ? void 0 : n.action) === "initial-input-focus";
  return An(Oi, null, An(kK, {
    id: l
  }, x && P), An(kK, {
    "aria-live": S,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, a && !x && P));
}, mM = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], o1c = new RegExp("[" + mM.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), A_e = {};
for (var L3 = 0; L3 < mM.length; L3++)
  for (var q3 = mM[L3], j3 = 0; j3 < q3.letters.length; j3++)
    A_e[q3.letters[j3]] = q3.base;
var C_e = function(t) {
  return t.replace(o1c, function(n) {
    return A_e[n];
  });
}, r1c = Xkc(C_e), SK = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, i1c = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, z_e = function(t) {
  return function(n, o) {
    if (n.data.__isNew__)
      return !0;
    var r = Vn({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: i1c,
      trim: !0,
      matchFrom: "any"
    }, t), i = r.ignoreCase, a = r.ignoreAccents, s = r.stringify, c = r.trim, l = r.matchFrom, d = c ? SK(o) : o, u = c ? SK(s(n)) : s(n);
    return i && (d = d.toLowerCase(), u = u.toLowerCase()), a && (d = r1c(d), u = C_e(u)), l === "start" ? u.substr(0, d.length) === d : u.indexOf(d) > -1;
  };
}, a1c = ["innerRef"];
function s1c(e) {
  var t = e.innerRef, n = cg(e, a1c), o = Q0c(n, "onExited", "in", "enter", "exit", "appear");
  return An("input", We({
    ref: t
  }, o, {
    css: /* @__PURE__ */ tj({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var c1c = function(t) {
  t.preventDefault(), t.stopPropagation();
};
function l1c(e) {
  var t = e.isEnabled, n = e.onBottomArrive, o = e.onBottomLeave, r = e.onTopArrive, i = e.onTopLeave, a = Ue(!1), s = Ue(!1), c = Ue(0), l = Ue(null), d = at(function(h, b) {
    if (l.current !== null) {
      var v = l.current, $ = v.scrollTop, k = v.scrollHeight, S = v.clientHeight, O = l.current, I = b > 0, D = k - S - $, M = !1;
      D > b && a.current && (o && o(h), a.current = !1), I && s.current && (i && i(h), s.current = !1), I && b > D ? (n && !a.current && n(h), O.scrollTop = k, M = !0, a.current = !0) : !I && -b > $ && (r && !s.current && r(h), O.scrollTop = 0, M = !0, s.current = !0), M && c1c(h);
    }
  }, [n, o, r, i]), u = at(function(h) {
    d(h, h.deltaY);
  }, [d]), _ = at(function(h) {
    c.current = h.changedTouches[0].clientY;
  }, []), p = at(function(h) {
    var b = c.current - h.changedTouches[0].clientY;
    d(h, b);
  }, [d]), f = at(function(h) {
    if (h) {
      var b = K0c ? {
        passive: !1
      } : !1;
      h.addEventListener("wheel", u, b), h.addEventListener("touchstart", _, b), h.addEventListener("touchmove", p, b);
    }
  }, [p, _, u]), g = at(function(h) {
    h && (h.removeEventListener("wheel", u, !1), h.removeEventListener("touchstart", _, !1), h.removeEventListener("touchmove", p, !1));
  }, [p, _, u]);
  return Le(function() {
    if (t) {
      var h = l.current;
      return f(h), function() {
        g(h);
      };
    }
  }, [t, f, g]), function(h) {
    l.current = h;
  };
}
var xK = ["boxSizing", "height", "overflow", "paddingRight", "position"], EK = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function TK(e) {
  e.preventDefault();
}
function AK(e) {
  e.stopPropagation();
}
function CK() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function zK() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var OK = !!(typeof window < "u" && window.document && window.document.createElement), qy = 0, eh = {
  capture: !1,
  passive: !1
};
function d1c(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, o = n === void 0 ? !0 : n, r = Ue({}), i = Ue(null), a = at(function(c) {
    if (OK) {
      var l = document.body, d = l && l.style;
      if (o && xK.forEach(function(f) {
        var g = d && d[f];
        r.current[f] = g;
      }), o && qy < 1) {
        var u = parseInt(r.current.paddingRight, 10) || 0, _ = document.body ? document.body.clientWidth : 0, p = window.innerWidth - _ + u || 0;
        Object.keys(EK).forEach(function(f) {
          var g = EK[f];
          d && (d[f] = g);
        }), d && (d.paddingRight = "".concat(p, "px"));
      }
      l && zK() && (l.addEventListener("touchmove", TK, eh), c && (c.addEventListener("touchstart", CK, eh), c.addEventListener("touchmove", AK, eh))), qy += 1;
    }
  }, [o]), s = at(function(c) {
    if (OK) {
      var l = document.body, d = l && l.style;
      qy = Math.max(qy - 1, 0), o && qy < 1 && xK.forEach(function(u) {
        var _ = r.current[u];
        d && (d[u] = _);
      }), l && zK() && (l.removeEventListener("touchmove", TK, eh), c && (c.removeEventListener("touchstart", CK, eh), c.removeEventListener("touchmove", AK, eh)));
    }
  }, [o]);
  return Le(function() {
    if (t) {
      var c = i.current;
      return a(c), function() {
        s(c);
      };
    }
  }, [t, a, s]), function(c) {
    i.current = c;
  };
}
var u1c = function() {
  return document.activeElement && document.activeElement.blur();
}, _1c = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function p1c(e) {
  var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = o === void 0 ? !0 : o, i = e.onBottomArrive, a = e.onBottomLeave, s = e.onTopArrive, c = e.onTopLeave, l = l1c({
    isEnabled: r,
    onBottomArrive: i,
    onBottomLeave: a,
    onTopArrive: s,
    onTopLeave: c
  }), d = d1c({
    isEnabled: n
  }), u = function(p) {
    l(p), d(p);
  };
  return An(Oi, null, n && An("div", {
    onClick: u1c,
    css: _1c
  }), t(u));
}
var m1c = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
}, f1c = function(t) {
  var n = t.name, o = t.onFocus;
  return An("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: o,
    css: m1c,
    value: "",
    onChange: function() {
    }
  });
}, g1c = function(t) {
  return t.label;
}, h1c = function(t) {
  return t.label;
}, v1c = function(t) {
  return t.value;
}, b1c = function(t) {
  return !!t.isDisabled;
}, y1c = {
  clearIndicator: bkc,
  container: lkc,
  control: xkc,
  dropdownIndicator: hkc,
  group: Akc,
  groupHeading: zkc,
  indicatorsContainer: pkc,
  indicatorSeparator: $kc,
  input: Ikc,
  loadingIndicator: Skc,
  loadingMessage: akc,
  menu: ekc,
  menuList: okc,
  menuPortal: skc,
  multiValue: Mkc,
  multiValueLabel: Lkc,
  multiValueRemove: qkc,
  noOptionsMessage: ikc,
  option: Ukc,
  placeholder: Gkc,
  singleValue: Kkc,
  valueContainer: ukc
}, $1c = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, w1c = 4, O_e = 4, k1c = 38, S1c = O_e * 2, x1c = {
  baseUnit: O_e,
  controlHeight: k1c,
  menuGutter: S1c
}, F3 = {
  borderRadius: w1c,
  colors: $1c,
  spacing: x1c
}, E1c = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: yK(),
  captureMenuScroll: !yK(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: z_e(),
  formatGroupLabel: g1c,
  getOptionLabel: h1c,
  getOptionValue: v1c,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: b1c,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !G0c(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function PK(e, t, n, o) {
  var r = N_e(e, t, n), i = D_e(e, t, n), a = R_e(e, t), s = fE(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: r,
    isSelected: i,
    label: a,
    value: s,
    index: o
  };
}
function P_e(e, t) {
  return e.options.map(function(n, o) {
    if ("options" in n) {
      var r = n.options.map(function(a, s) {
        return PK(e, a, t, s);
      }).filter(function(a) {
        return IK(e, a);
      });
      return r.length > 0 ? {
        type: "group",
        data: n,
        options: r,
        index: o
      } : void 0;
    }
    var i = PK(e, n, t, o);
    return IK(e, i) ? i : void 0;
  }).filter(Y0c);
}
function I_e(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, W9(n.options.map(function(o) {
      return o.data;
    }))) : t.push(n.data), t;
  }, []);
}
function T1c(e, t) {
  return I_e(P_e(e, t));
}
function IK(e, t) {
  var n = e.inputValue, o = n === void 0 ? "" : n, r = t.data, i = t.isSelected, a = t.label, s = t.value;
  return (!L_e(e) || !i) && M_e(e, {
    label: a,
    value: s,
    data: r
  }, o);
}
function A1c(e, t) {
  var n = e.focusedValue, o = e.selectValue, r = o.indexOf(n);
  if (r > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (r < t.length)
      return t[r];
  }
  return null;
}
function C1c(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var R_e = function(t, n) {
  return t.getOptionLabel(n);
}, fE = function(t, n) {
  return t.getOptionValue(n);
};
function N_e(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function D_e(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var o = fE(e, t);
  return n.some(function(r) {
    return fE(e, r) === o;
  });
}
function M_e(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var L_e = function(t) {
  var n = t.hideSelectedOptions, o = t.isMulti;
  return n === void 0 ? o : n;
}, z1c = 1, q_e = /* @__PURE__ */ function(e) {
  Wue(n, e);
  var t = bwc(n);
  function n(o) {
    var r;
    if (Gq(this, n), r = t.call(this, o), r.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.instancePrefix = "", r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.controlRef = null, r.getControlRef = function(s) {
      r.controlRef = s;
    }, r.focusedOptionRef = null, r.getFocusedOptionRef = function(s) {
      r.focusedOptionRef = s;
    }, r.menuListRef = null, r.getMenuListRef = function(s) {
      r.menuListRef = s;
    }, r.inputRef = null, r.getInputRef = function(s) {
      r.inputRef = s;
    }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function(s, c) {
      var l = r.props, d = l.onChange, u = l.name;
      c.name = u, r.ariaOnChange(s, c), d(s, c);
    }, r.setValue = function(s, c, l) {
      var d = r.props, u = d.closeMenuOnSelect, _ = d.isMulti, p = d.inputValue;
      r.onInputChange("", {
        action: "set-value",
        prevInputValue: p
      }), u && (r.setState({
        inputIsHiddenAfterUpdate: !_
      }), r.onMenuClose()), r.setState({
        clearFocusValueOnUpdate: !0
      }), r.onChange(s, {
        action: c,
        option: l
      });
    }, r.selectOption = function(s) {
      var c = r.props, l = c.blurInputOnSelect, d = c.isMulti, u = c.name, _ = r.state.selectValue, p = d && r.isOptionSelected(s, _), f = r.isOptionDisabled(s, _);
      if (p) {
        var g = r.getOptionValue(s);
        r.setValue(_.filter(function(h) {
          return r.getOptionValue(h) !== g;
        }), "deselect-option", s);
      } else if (!f)
        d ? r.setValue([].concat(W9(_), [s]), "select-option", s) : r.setValue(s, "select-option");
      else {
        r.ariaOnChange(s, {
          action: "select-option",
          option: s,
          name: u
        });
        return;
      }
      l && r.blurInput();
    }, r.removeValue = function(s) {
      var c = r.props.isMulti, l = r.state.selectValue, d = r.getOptionValue(s), u = l.filter(function(p) {
        return r.getOptionValue(p) !== d;
      }), _ = L2(c, u, u[0] || null);
      r.onChange(_, {
        action: "remove-value",
        removedValue: s
      }), r.focusInput();
    }, r.clearValue = function() {
      var s = r.state.selectValue;
      r.onChange(L2(r.props.isMulti, [], null), {
        action: "clear",
        removedValues: s
      });
    }, r.popValue = function() {
      var s = r.props.isMulti, c = r.state.selectValue, l = c[c.length - 1], d = c.slice(0, c.length - 1), u = L2(s, d, d[0] || null);
      r.onChange(u, {
        action: "pop-value",
        removedValue: l
      });
    }, r.getValue = function() {
      return r.state.selectValue;
    }, r.cx = function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return F0c.apply(void 0, [r.props.classNamePrefix].concat(c));
    }, r.getOptionLabel = function(s) {
      return R_e(r.props, s);
    }, r.getOptionValue = function(s) {
      return fE(r.props, s);
    }, r.getStyles = function(s, c) {
      var l = r.props.unstyled, d = y1c[s](c, l);
      d.boxSizing = "border-box";
      var u = r.props.styles[s];
      return u ? u(d, c) : d;
    }, r.getClassNames = function(s, c) {
      var l, d;
      return (l = (d = r.props.classNames)[s]) === null || l === void 0 ? void 0 : l.call(d, c);
    }, r.getElementId = function(s) {
      return "".concat(r.instancePrefix, "-").concat(s);
    }, r.getComponents = function() {
      return Zkc(r.props);
    }, r.buildCategorizedOptions = function() {
      return P_e(r.props, r.state.selectValue);
    }, r.getCategorizedOptions = function() {
      return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
    }, r.buildFocusableOptions = function() {
      return I_e(r.buildCategorizedOptions());
    }, r.getFocusableOptions = function() {
      return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
    }, r.ariaOnChange = function(s, c) {
      r.setState({
        ariaSelection: Vn({
          value: s
        }, c)
      });
    }, r.onMenuMouseDown = function(s) {
      s.button === 0 && (s.stopPropagation(), s.preventDefault(), r.focusInput());
    }, r.onMenuMouseMove = function(s) {
      r.blockOptionHover = !1;
    }, r.onControlMouseDown = function(s) {
      if (!s.defaultPrevented) {
        var c = r.props.openMenuOnClick;
        r.state.isFocused ? r.props.menuIsOpen ? s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && r.onMenuClose() : c && r.openMenu("first") : (c && (r.openAfterFocus = !0), r.focusInput()), s.target.tagName !== "INPUT" && s.target.tagName !== "TEXTAREA" && s.preventDefault();
      }
    }, r.onDropdownIndicatorMouseDown = function(s) {
      if (!(s && s.type === "mousedown" && s.button !== 0) && !r.props.isDisabled) {
        var c = r.props, l = c.isMulti, d = c.menuIsOpen;
        r.focusInput(), d ? (r.setState({
          inputIsHiddenAfterUpdate: !l
        }), r.onMenuClose()) : r.openMenu("first"), s.preventDefault();
      }
    }, r.onClearIndicatorMouseDown = function(s) {
      s && s.type === "mousedown" && s.button !== 0 || (r.clearValue(), s.preventDefault(), r.openAfterFocus = !1, s.type === "touchend" ? r.focusInput() : setTimeout(function() {
        return r.focusInput();
      }));
    }, r.onScroll = function(s) {
      typeof r.props.closeMenuOnScroll == "boolean" ? s.target instanceof HTMLElement && zA(s.target) && r.props.onMenuClose() : typeof r.props.closeMenuOnScroll == "function" && r.props.closeMenuOnScroll(s) && r.props.onMenuClose();
    }, r.onCompositionStart = function() {
      r.isComposing = !0;
    }, r.onCompositionEnd = function() {
      r.isComposing = !1;
    }, r.onTouchStart = function(s) {
      var c = s.touches, l = c && c.item(0);
      l && (r.initialTouchX = l.clientX, r.initialTouchY = l.clientY, r.userIsDragging = !1);
    }, r.onTouchMove = function(s) {
      var c = s.touches, l = c && c.item(0);
      if (l) {
        var d = Math.abs(l.clientX - r.initialTouchX), u = Math.abs(l.clientY - r.initialTouchY), _ = 5;
        r.userIsDragging = d > _ || u > _;
      }
    }, r.onTouchEnd = function(s) {
      r.userIsDragging || (r.controlRef && !r.controlRef.contains(s.target) && r.menuListRef && !r.menuListRef.contains(s.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
    }, r.onControlTouchEnd = function(s) {
      r.userIsDragging || r.onControlMouseDown(s);
    }, r.onClearIndicatorTouchEnd = function(s) {
      r.userIsDragging || r.onClearIndicatorMouseDown(s);
    }, r.onDropdownIndicatorTouchEnd = function(s) {
      r.userIsDragging || r.onDropdownIndicatorMouseDown(s);
    }, r.handleInputChange = function(s) {
      var c = r.props.inputValue, l = s.currentTarget.value;
      r.setState({
        inputIsHiddenAfterUpdate: !1
      }), r.onInputChange(l, {
        action: "input-change",
        prevInputValue: c
      }), r.props.menuIsOpen || r.onMenuOpen();
    }, r.onInputFocus = function(s) {
      r.props.onFocus && r.props.onFocus(s), r.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
    }, r.onInputBlur = function(s) {
      var c = r.props.inputValue;
      if (r.menuListRef && r.menuListRef.contains(document.activeElement)) {
        r.inputRef.focus();
        return;
      }
      r.props.onBlur && r.props.onBlur(s), r.onInputChange("", {
        action: "input-blur",
        prevInputValue: c
      }), r.onMenuClose(), r.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, r.onOptionHover = function(s) {
      r.blockOptionHover || r.state.focusedOption === s || r.setState({
        focusedOption: s
      });
    }, r.shouldHideSelectedOptions = function() {
      return L_e(r.props);
    }, r.onValueInputFocus = function(s) {
      s.preventDefault(), s.stopPropagation(), r.focus();
    }, r.onKeyDown = function(s) {
      var c = r.props, l = c.isMulti, d = c.backspaceRemovesValue, u = c.escapeClearsValue, _ = c.inputValue, p = c.isClearable, f = c.isDisabled, g = c.menuIsOpen, h = c.onKeyDown, b = c.tabSelectsValue, v = c.openMenuOnFocus, $ = r.state, k = $.focusedOption, S = $.focusedValue, O = $.selectValue;
      if (!f && !(typeof h == "function" && (h(s), s.defaultPrevented))) {
        switch (r.blockOptionHover = !0, s.key) {
          case "ArrowLeft":
            if (!l || _)
              return;
            r.focusValue("previous");
            break;
          case "ArrowRight":
            if (!l || _)
              return;
            r.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (_)
              return;
            if (S)
              r.removeValue(S);
            else {
              if (!d)
                return;
              l ? r.popValue() : p && r.clearValue();
            }
            break;
          case "Tab":
            if (r.isComposing || s.shiftKey || !g || !b || !k || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            v && r.isOptionSelected(k, O))
              return;
            r.selectOption(k);
            break;
          case "Enter":
            if (s.keyCode === 229)
              break;
            if (g) {
              if (!k || r.isComposing)
                return;
              r.selectOption(k);
              break;
            }
            return;
          case "Escape":
            g ? (r.setState({
              inputIsHiddenAfterUpdate: !1
            }), r.onInputChange("", {
              action: "menu-close",
              prevInputValue: _
            }), r.onMenuClose()) : p && u && r.clearValue();
            break;
          case " ":
            if (_)
              return;
            if (!g) {
              r.openMenu("first");
              break;
            }
            if (!k)
              return;
            r.selectOption(k);
            break;
          case "ArrowUp":
            g ? r.focusOption("up") : r.openMenu("last");
            break;
          case "ArrowDown":
            g ? r.focusOption("down") : r.openMenu("first");
            break;
          case "PageUp":
            if (!g)
              return;
            r.focusOption("pageup");
            break;
          case "PageDown":
            if (!g)
              return;
            r.focusOption("pagedown");
            break;
          case "Home":
            if (!g)
              return;
            r.focusOption("first");
            break;
          case "End":
            if (!g)
              return;
            r.focusOption("last");
            break;
          default:
            return;
        }
        s.preventDefault();
      }
    }, r.instancePrefix = "react-select-" + (r.props.instanceId || ++z1c), r.state.selectValue = vK(o.value), o.menuIsOpen && r.state.selectValue.length) {
      var i = r.buildFocusableOptions(), a = i.indexOf(r.state.selectValue[0]);
      r.state.focusedOption = i[a];
    }
    return r;
  }
  return Hq(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && bK(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var i = this.props, a = i.isDisabled, s = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !a && r.isDisabled || // ensure focus is on the Input when the menu opens
      c && s && !r.menuIsOpen) && this.focusInput(), c && a && !r.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !a && r.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (bK(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(r, i) {
      this.props.onInputChange(r, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(r) {
      var i = this, a = this.state, s = a.selectValue, c = a.isFocused, l = this.buildFocusableOptions(), d = r === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var u = l.indexOf(s[0]);
        u > -1 && (d = u);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[d]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(r) {
      var i = this.state, a = i.selectValue, s = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = a.indexOf(s);
        s || (c = -1);
        var l = a.length - 1, d = -1;
        if (a.length) {
          switch (r) {
            case "previous":
              c === 0 ? d = 0 : c === -1 ? d = l : d = c - 1;
              break;
            case "next":
              c > -1 && c < l && (d = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: a[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, a = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var c = 0, l = s.indexOf(a);
        a || (l = -1), r === "up" ? c = l > 0 ? l - 1 : s.length - 1 : r === "down" ? c = (l + 1) % s.length : r === "pageup" ? (c = l - i, c < 0 && (c = 0)) : r === "pagedown" ? (c = l + i, c > s.length - 1 && (c = s.length - 1)) : r === "last" && (c = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[c],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(F3) : Vn(Vn({}, F3), this.props.theme) : F3;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var r = this.clearValue, i = this.cx, a = this.getStyles, s = this.getClassNames, c = this.getValue, l = this.selectOption, d = this.setValue, u = this.props, _ = u.isMulti, p = u.isRtl, f = u.options, g = this.hasValue();
      return {
        clearValue: r,
        cx: i,
        getStyles: a,
        getClassNames: s,
        getValue: c,
        hasValue: g,
        isMulti: _,
        isRtl: p,
        options: f,
        selectOption: l,
        selectProps: u,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var r = this.state.selectValue;
      return r.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var r = this.props, i = r.isClearable, a = r.isMulti;
      return i === void 0 ? a : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(r, i) {
      return N_e(this.props, r, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(r, i) {
      return D_e(this.props, r, i);
    }
  }, {
    key: "filterOption",
    value: function(r, i) {
      return M_e(this.props, r, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(r, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var a = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(r, {
          context: i,
          inputValue: a,
          selectValue: s
        });
      } else
        return this.getOptionLabel(r);
    }
  }, {
    key: "formatGroupLabel",
    value: function(r) {
      return this.props.formatGroupLabel(r);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var r = this.props, i = r.isDisabled, a = r.isSearchable, s = r.inputId, c = r.inputValue, l = r.tabIndex, d = r.form, u = r.menuIsOpen, _ = r.required, p = this.getComponents(), f = p.Input, g = this.state, h = g.inputIsHidden, b = g.ariaSelection, v = this.commonProps, $ = s || this.getElementId("input"), k = Vn(Vn(Vn({
          "aria-autocomplete": "list",
          "aria-expanded": u,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": _,
          role: "combobox"
        }, u && {
          "aria-controls": this.getElementId("listbox"),
          "aria-owns": this.getElementId("listbox")
        }), !a && {
          "aria-readonly": !0
        }), this.hasValue() ? (b == null ? void 0 : b.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return a ? /* @__PURE__ */ $e.createElement(f, We({}, v, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: $,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: h,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: d,
          type: "text",
          value: c
        }, k)) : /* @__PURE__ */ $e.createElement(s1c, We({
          id: $,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: pE,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: l,
          inputMode: "none",
          form: d,
          value: ""
        }, k));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var r = this, i = this.getComponents(), a = i.MultiValue, s = i.MultiValueContainer, c = i.MultiValueLabel, l = i.MultiValueRemove, d = i.SingleValue, u = i.Placeholder, _ = this.commonProps, p = this.props, f = p.controlShouldRenderValue, g = p.isDisabled, h = p.isMulti, b = p.inputValue, v = p.placeholder, $ = this.state, k = $.selectValue, S = $.focusedValue, O = $.isFocused;
      if (!this.hasValue() || !f)
        return b ? null : /* @__PURE__ */ $e.createElement(u, We({}, _, {
          key: "placeholder",
          isDisabled: g,
          isFocused: O,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), v);
      if (h)
        return k.map(function(D, M) {
          var N = D === S, C = "".concat(r.getOptionLabel(D), "-").concat(r.getOptionValue(D));
          return /* @__PURE__ */ $e.createElement(a, We({}, _, {
            components: {
              Container: s,
              Label: c,
              Remove: l
            },
            isFocused: N,
            isDisabled: g,
            key: C,
            index: M,
            removeProps: {
              onClick: function() {
                return r.removeValue(D);
              },
              onTouchEnd: function() {
                return r.removeValue(D);
              },
              onMouseDown: function(x) {
                x.preventDefault();
              }
            },
            data: D
          }), r.formatOptionLabel(D, "value"));
        });
      if (b)
        return null;
      var I = k[0];
      return /* @__PURE__ */ $e.createElement(d, We({}, _, {
        data: I,
        isDisabled: g
      }), this.formatOptionLabel(I, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var r = this.getComponents(), i = r.ClearIndicator, a = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || l)
        return null;
      var u = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ $e.createElement(i, We({}, a, {
        innerProps: u,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var r = this.getComponents(), i = r.LoadingIndicator, a = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, d = this.state.isFocused;
      if (!i || !l)
        return null;
      var u = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ $e.createElement(i, We({}, a, {
        innerProps: u,
        isDisabled: c,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var r = this.getComponents(), i = r.DropdownIndicator, a = r.IndicatorSeparator;
      if (!i || !a)
        return null;
      var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ $e.createElement(a, We({}, s, {
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var r = this.getComponents(), i = r.DropdownIndicator;
      if (!i)
        return null;
      var a = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ $e.createElement(i, We({}, a, {
        innerProps: l,
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var r = this, i = this.getComponents(), a = i.Group, s = i.GroupHeading, c = i.Menu, l = i.MenuList, d = i.MenuPortal, u = i.LoadingMessage, _ = i.NoOptionsMessage, p = i.Option, f = this.commonProps, g = this.state.focusedOption, h = this.props, b = h.captureMenuScroll, v = h.inputValue, $ = h.isLoading, k = h.loadingMessage, S = h.minMenuHeight, O = h.maxMenuHeight, I = h.menuIsOpen, D = h.menuPlacement, M = h.menuPosition, N = h.menuPortalTarget, C = h.menuShouldBlockScroll, P = h.menuShouldScrollIntoView, x = h.noOptionsMessage, w = h.onMenuScrollToTop, E = h.onMenuScrollToBottom;
      if (!I)
        return null;
      var T = function(U, W) {
        var H = U.type, Q = U.data, X = U.isDisabled, re = U.isSelected, Z = U.label, ee = U.value, J = g === Q, oe = X ? void 0 : function() {
          return r.onOptionHover(Q);
        }, ce = X ? void 0 : function() {
          return r.selectOption(Q);
        }, de = "".concat(r.getElementId("option"), "-").concat(W), te = {
          id: de,
          onClick: ce,
          onMouseMove: oe,
          onMouseOver: oe,
          tabIndex: -1
        };
        return /* @__PURE__ */ $e.createElement(p, We({}, f, {
          innerProps: te,
          data: Q,
          isDisabled: X,
          isSelected: re,
          key: de,
          label: Z,
          type: H,
          value: ee,
          isFocused: J,
          innerRef: J ? r.getFocusedOptionRef : void 0
        }), r.formatOptionLabel(U.data, "menu"));
      }, z;
      if (this.hasOptions())
        z = this.getCategorizedOptions().map(function(L) {
          if (L.type === "group") {
            var U = L.data, W = L.options, H = L.index, Q = "".concat(r.getElementId("group"), "-").concat(H), X = "".concat(Q, "-heading");
            return /* @__PURE__ */ $e.createElement(a, We({}, f, {
              key: Q,
              data: U,
              options: W,
              Heading: s,
              headingProps: {
                id: X,
                data: L.data
              },
              label: r.formatGroupLabel(L.data)
            }), L.options.map(function(re) {
              return T(re, "".concat(H, "-").concat(re.index));
            }));
          } else if (L.type === "option")
            return T(L, "".concat(L.index));
        });
      else if ($) {
        var j = k({
          inputValue: v
        });
        if (j === null)
          return null;
        z = /* @__PURE__ */ $e.createElement(u, f, j);
      } else {
        var q = x({
          inputValue: v
        });
        if (q === null)
          return null;
        z = /* @__PURE__ */ $e.createElement(_, f, q);
      }
      var V = {
        minMenuHeight: S,
        maxMenuHeight: O,
        menuPlacement: D,
        menuPosition: M,
        menuShouldScrollIntoView: P
      }, F = /* @__PURE__ */ $e.createElement(tkc, We({}, f, V), function(L) {
        var U = L.ref, W = L.placerProps, H = W.placement, Q = W.maxHeight;
        return /* @__PURE__ */ $e.createElement(c, We({}, f, V, {
          innerRef: U,
          innerProps: {
            onMouseDown: r.onMenuMouseDown,
            onMouseMove: r.onMenuMouseMove,
            id: r.getElementId("listbox")
          },
          isLoading: $,
          placement: H
        }), /* @__PURE__ */ $e.createElement(p1c, {
          captureEnabled: b,
          onTopArrive: w,
          onBottomArrive: E,
          lockEnabled: C
        }, function(X) {
          return /* @__PURE__ */ $e.createElement(l, We({}, f, {
            innerRef: function(Z) {
              r.getMenuListRef(Z), X(Z);
            },
            isLoading: $,
            maxHeight: Q,
            focusedOption: g
          }), z);
        }));
      });
      return N || M === "fixed" ? /* @__PURE__ */ $e.createElement(d, We({}, f, {
        appendTo: N,
        controlElement: this.controlRef,
        menuPlacement: D,
        menuPosition: M
      }), F) : F;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var r = this, i = this.props, a = i.delimiter, s = i.isDisabled, c = i.isMulti, l = i.name, d = i.required, u = this.state.selectValue;
      if (d && !this.hasValue() && !s)
        return /* @__PURE__ */ $e.createElement(f1c, {
          name: l,
          onFocus: this.onValueInputFocus
        });
      if (!(!l || s))
        if (c)
          if (a) {
            var _ = u.map(function(g) {
              return r.getOptionValue(g);
            }).join(a);
            return /* @__PURE__ */ $e.createElement("input", {
              name: l,
              type: "hidden",
              value: _
            });
          } else {
            var p = u.length > 0 ? u.map(function(g, h) {
              return /* @__PURE__ */ $e.createElement("input", {
                key: "i-".concat(h),
                name: l,
                type: "hidden",
                value: r.getOptionValue(g)
              });
            }) : /* @__PURE__ */ $e.createElement("input", {
              name: l,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ $e.createElement("div", null, p);
          }
        else {
          var f = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ $e.createElement("input", {
            name: l,
            type: "hidden",
            value: f
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var r = this.commonProps, i = this.state, a = i.ariaSelection, s = i.focusedOption, c = i.focusedValue, l = i.isFocused, d = i.selectValue, u = this.getFocusableOptions();
      return /* @__PURE__ */ $e.createElement(n1c, We({}, r, {
        id: this.getElementId("live-region"),
        ariaSelection: a,
        focusedOption: s,
        focusedValue: c,
        isFocused: l,
        selectValue: d,
        focusableOptions: u
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.getComponents(), i = r.Control, a = r.IndicatorsContainer, s = r.SelectContainer, c = r.ValueContainer, l = this.props, d = l.className, u = l.id, _ = l.isDisabled, p = l.menuIsOpen, f = this.state.isFocused, g = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ $e.createElement(s, We({}, g, {
        className: d,
        innerProps: {
          id: u,
          onKeyDown: this.onKeyDown
        },
        isDisabled: _,
        isFocused: f
      }), this.renderLiveRegion(), /* @__PURE__ */ $e.createElement(i, We({}, g, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: _,
        isFocused: f,
        menuIsOpen: p
      }), /* @__PURE__ */ $e.createElement(c, We({}, g, {
        isDisabled: _
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ $e.createElement(a, We({}, g, {
        isDisabled: _
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var a = i.prevProps, s = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, l = i.ariaSelection, d = i.isFocused, u = i.prevWasFocused, _ = r.options, p = r.value, f = r.menuIsOpen, g = r.inputValue, h = r.isMulti, b = vK(p), v = {};
      if (a && (p !== a.value || _ !== a.options || f !== a.menuIsOpen || g !== a.inputValue)) {
        var $ = f ? T1c(r, b) : [], k = s ? A1c(i, b) : null, S = C1c(i, $);
        v = {
          selectValue: b,
          focusedOption: S,
          focusedValue: k,
          clearFocusValueOnUpdate: !1
        };
      }
      var O = c != null && r !== a ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, I = l, D = d && u;
      return d && !D && (I = {
        value: L2(h, b, b[0] || null),
        options: b,
        action: "initial-input-focus"
      }, D = !u), (l == null ? void 0 : l.action) === "initial-input-focus" && (I = null), Vn(Vn(Vn({}, v), O), {}, {
        prevProps: r,
        ariaSelection: I,
        prevWasFocused: D
      });
    }
  }]), n;
}(xie);
q_e.defaultProps = E1c;
var O1c = /* @__PURE__ */ it(function(e, t) {
  var n = mwc(e);
  return /* @__PURE__ */ $e.createElement(q_e, We({
    ref: t
  }, n));
});
const P1c = O1c;
function Xn(e) {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ m(
    "label",
    {
      className: ae(
        "text-default text-emphasis mb-2 block text-sm font-medium leading-none",
        t
      ),
      ...n,
      children: e.children
    }
  );
}
const I1c = ({ message: e }) => /* @__PURE__ */ Y("div", { "data-testid": "field-error", className: "text-error mt-2 flex items-center gap-x-2 text-sm", children: [
  /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(ot, { name: "info", className: "h-3 w-3" }) }),
  /* @__PURE__ */ m("p", { children: e })
] });
function R1c({
  hintErrors: e,
  fieldName: t,
  t: n
}) {
  const o = Dn();
  if (!o)
    return null;
  const { formState: r } = o, i = r.errors[t];
  return !e && i && !i.message ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: Object.keys(i).map((a) => /* @__PURE__ */ m("li", { className: "text-blue-700", children: n(`${t}_hint_${a}`) }, a)) }) }) : e && i ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: e.map((a) => {
    const s = r.isSubmitted, c = i[a] || i.message;
    return /* @__PURE__ */ Y(
      "li",
      {
        "data-testid": "hint-error",
        className: c !== void 0 ? s ? "text-error" : "" : "text-green-600",
        children: [
          c !== void 0 ? s ? /* @__PURE__ */ m(
            ot,
            {
              name: "x",
              size: "12",
              strokeWidth: "3",
              className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
            }
          ) : /* @__PURE__ */ m(
            ot,
            {
              name: "circle",
              fill: "currentColor",
              size: "5",
              className: "inline-block ltr:mr-2 rtl:ml-2"
            }
          ) : /* @__PURE__ */ m(
            ot,
            {
              name: "check",
              size: "12",
              strokeWidth: "3",
              className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
            }
          ),
          n(`${t}_hint_${a}`)
        ]
      },
      a
    );
  }) }) }) : i ? /* @__PURE__ */ m(I1c, { message: i.message }) : e ? /* @__PURE__ */ m("div", { className: "text-gray text-default mt-2 flex items-center text-sm", children: /* @__PURE__ */ m("ul", { className: "ml-2", children: e.map((a) => {
    const s = r.dirtyFields[t];
    return /* @__PURE__ */ Y("li", { className: s ? "text-green-600" : "", children: [
      s ? /* @__PURE__ */ m(
        ot,
        {
          name: "check",
          size: "12",
          strokeWidth: "3",
          className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
        }
      ) : /* @__PURE__ */ m(ot, { name: "circle", fill: "currentColor", size: "5", className: "inline-block ltr:mr-2 rtl:ml-2" }),
      n(`${t}_hint_${a}`)
    ] }, a);
  }) }) }) : null;
}
const Z0 = Yv(
  [
    // Base styles
    "rounded-[10px] border",
    "leading-none font-normal",
    // Colors
    "bg-default",
    "border-default",
    "text-default",
    "placeholder:text-muted",
    // States
    "hover:border-emphasis",
    "focus:ring-0",
    "focus:shadow-outline-gray-focused",
    // Disabled state
    "disabled:bg-subtle",
    "disabled:hover:border-default",
    "disabled:cursor-not-allowed",
    // Shadow
    "shadow-outline-gray-rested",
    // Transitions
    "transition"
  ],
  {
    variants: {
      size: {
        sm: "h-7 px-2 py-1 text-xs",
        md: "h-8 px-3 py-2 text-sm"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), Sc = it(function({ isFullWidth: t = !0, size: n = "md", className: o, ...r }, i) {
  return /* @__PURE__ */ m(
    "input",
    {
      ...r,
      ref: i,
      className: ae(Z0({ size: n }), t && "w-full", o)
    }
  );
}), RK = ({
  children: e,
  className: t,
  error: n,
  onClickAddon: o,
  size: r = "md",
  position: i = "start"
}) => /* @__PURE__ */ m(
  "div",
  {
    onClick: o && o,
    className: ae(
      "flex flex-shrink-0 items-center justify-center whitespace-nowrap",
      o && "pointer-events-auto cursor-pointer disabled:hover:cursor-not-allowed",
      t
    ),
    children: /* @__PURE__ */ m(
      "span",
      {
        className: ae(
          "text-sm font-medium leading-none",
          n ? "text-error" : "text-muted peer-disabled:opacity-50"
        ),
        children: e
      }
    )
  }
), hi = it(function(t, n) {
  const o = N0(), { t: r, isLocaleReady: i, i18n: a } = Fe(), s = t.t || r, c = t.name || "", {
    label: l = s(c),
    labelProps: d,
    labelClassName: u,
    disabled: _,
    LockedIcon: p,
    placeholder: f = i && a.exists(`${c}_placeholder`) ? s(`${c}_placeholder`) : "",
    className: g,
    addOnLeading: h,
    addOnSuffix: b,
    addOnClassname: v,
    inputIsFullWidth: $,
    hint: k,
    type: S,
    hintErrors: O,
    labelSrOnly: I,
    noLabel: D,
    containerClassName: M,
    readOnly: N,
    showAsteriskIndicator: C,
    onClickAddon: P,
    t: x,
    dataTestid: w,
    size: E,
    ...T
  } = t, [z, j] = ze("");
  return /* @__PURE__ */ Y("div", { className: ae(M), children: [
    !!c && !D && /* @__PURE__ */ Y(
      Xn,
      {
        htmlFor: o,
        ...d,
        className: ae(u, I && "sr-only", t.error && "text-error"),
        children: [
          l,
          C && !N && T.required ? /* @__PURE__ */ m("span", { className: "text-default ml-1 font-medium", children: "*" }) : null,
          p
        ]
      }
    ),
    h || b ? /* @__PURE__ */ Y(
      "div",
      {
        dir: "ltr",
        className: ae(
          Z0({ size: E }),
          "group relative mb-1 flex min-w-0 items-center gap-1",
          "[&:focus-within]:border-subtle [&:focus-within]:ring-brand-default [&:focus-within]:ring-2",
          "[&:has(:disabled)]:bg-subtle [&:has(:disabled)]:hover:border-default [&:has(:disabled)]:cursor-not-allowed",
          $ && "w-full"
        ),
        children: [
          h && /* @__PURE__ */ m(RK, { size: E ?? "md", position: "start", className: ae(v), children: h }),
          /* @__PURE__ */ m(
            "input",
            {
              "data-testid": w ? `${w}-input` : "input-field",
              id: o,
              type: S,
              placeholder: f,
              className: ae(
                "w-full min-w-0 truncate border-0 bg-transparent focus:outline-none focus:ring-0",
                "text-default rounded-lg text-sm font-medium leading-none",
                "placeholder:text-muted disabled:cursor-not-allowed disabled:bg-transparent",
                h && "rounded-none pl-0.5 pr-0",
                b && "pl-0",
                g
              ),
              ...T,
              ...S == "search" && {
                onChange: (q) => {
                  j(q.target.value), t.onChange && t.onChange(q);
                },
                value: z
              },
              disabled: N || _,
              ref: n
            }
          ),
          b && /* @__PURE__ */ m(
            RK,
            {
              size: E ?? "md",
              position: "end",
              onClickAddon: P,
              className: ae(v),
              children: b
            }
          ),
          S === "search" && (z == null ? void 0 : z.toString().length) > 0 && /* @__PURE__ */ m(
            ot,
            {
              name: "x",
              className: "text-subtle absolute top-2.5 h-4 w-4 cursor-pointer ltr:right-2 rtl:left-2",
              onClick: (q) => {
                j(""), t.onChange && t.onChange(q);
              }
            }
          )
        ]
      }
    ) : /* @__PURE__ */ m(
      Sc,
      {
        id: o,
        type: S,
        placeholder: f,
        size: E,
        className: ae(
          g,
          S === "email" && "focus:border-subtle focus:ring-brand-default focus:ring-2",
          "disabled:bg-subtle disabled:hover:border-subtle disabled:cursor-not-allowed"
        ),
        ...T,
        readOnly: N,
        ref: n,
        isFullWidth: $,
        disabled: N || _
      }
    ),
    /* @__PURE__ */ m(R1c, { hintErrors: O, fieldName: c, t: s }),
    k && /* @__PURE__ */ m("div", { className: "text-default mt-2 flex items-center text-sm", children: k })
  ] });
}), Io = it(function(t, n) {
  return /* @__PURE__ */ m(hi, { ref: n, ...t });
}), N1c = Yv("font-medium inline-flex items-center justify-center rounded gap-x-1", {
  variants: {
    variant: {
      default: "bg-attention text-attention",
      warning: "bg-attention text-attention",
      orange: "bg-attention text-attention",
      success: "bg-success text-success",
      green: "bg-success text-success",
      gray: "bg-emphasis text-emphasis",
      blue: "bg-info text-info",
      red: "bg-error text-error",
      error: "bg-error text-error",
      grayWithoutHover: "bg-gray-100 text-gray-800 dark:bg-darkgray-200 dark:text-darkgray-800",
      purple: "bg-purple-50 text-purple-800"
    },
    size: {
      sm: "px-1 py-1 text-[10px] leading-none",
      md: "py-1 px-1.5 text-xs leading-none",
      lg: "py-1 px-1.5 text-sm leading-none rounded-lg"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
}), Nr = function(t) {
  const {
    customStartIcon: n,
    variant: o,
    className: r,
    size: i,
    startIcon: a,
    withDot: s,
    children: c,
    rounded: l,
    customDot: d,
    ...u
  } = t, _ = "onClick" in u && u.onClick !== void 0, p = a, f = ae(
    N1c({ variant: o, size: i }),
    l && "h-5 w-5 rounded-full p-0",
    r
  ), g = () => /* @__PURE__ */ Y(Ce, { children: [
    s ? /* @__PURE__ */ m("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "currentColor", "data-testid": "go-primitive-dot", children: /* @__PURE__ */ m("circle", { cx: "4", cy: "4", r: "4" }) }) : null,
    n || (p ? /* @__PURE__ */ m(
      ot,
      {
        name: p,
        "data-testid": "start-icon",
        className: "stroke-[3px]",
        style: { width: 12, height: 12 }
      }
    ) : null),
    c
  ] }), h = _ ? "button" : "div";
  return ve.createElement(h, { ...u, className: f }, /* @__PURE__ */ m(g, {}));
};
function D1c(e) {
  return typeof e == "object" && !Array.isArray(e);
}
const M1c = (e, t) => D1c(e == null ? void 0 : e.metadata) && !!(e != null && e.metadata) && t in e.metadata, L1c = M1c;
function q1c() {
  if (dg)
    return { isPending: !1, hasPaidPlan: !0 };
  const { data: e, isPending: t } = bo.viewer.teams.hasTeamPlan.useQuery(), { data: n, isPending: o } = bo.viewer.me.get.useQuery(), r = t || o, i = n && L1c(n, "isPremium") ? !!n.metadata.isPremium : !1, a = (e == null ? void 0 : e.hasTeamPlan) || i;
  return { isPending: r, hasPaidPlan: a, plan: e == null ? void 0 : e.plan };
}
function j1c() {
  const e = bo.viewer.teams.listInvites.useQuery();
  return { isPending: e.isPending, listInvites: e.data };
}
function nfd() {
  const { data: e, isPending: t } = bo.viewer.teams.hasTeamPlan.useQuery();
  return { isPending: t, hasTeamPlan: e == null ? void 0 : e.hasTeamPlan };
}
function F1c() {
  if (dg)
    return { isPending: !1, hasActiveTeamPlan: !0, isTrial: !1 };
  const { data: e, isPending: t } = bo.viewer.teams.hasActiveTeamPlan.useQuery();
  return { isPending: t, hasActiveTeamPlan: !!(e != null && e.isActive), isTrial: !!(e != null && e.isTrial) };
}
function V1c() {
  if (dg)
    return { isPending: !1, hasActiveTeamPlan: !0, isTrial: !1 };
  const { data: e, isPending: t } = bo.viewer.teams.hasActiveTeamPlan.useQuery({ ownerOnly: !0 });
  return { isPending: t, hasActiveTeamPlan: !!(e != null && e.isActive), isTrial: !!(e != null && e.isTrial) };
}
const Gm = function({
  checkForActiveStatus: t
}) {
  const { t: n } = Fe(), { hasPaidPlan: o } = q1c(), { hasActiveTeamPlan: r, isTrial: i } = F1c();
  if (o && (!t || r))
    return null;
  const a = n(i ? "trial_mode" : o ? "inactive_team_plan" : "upgrade"), s = n(i ? "limited_access_trial_mode" : o ? "inactive_team_plan_description" : "upgrade_to_enable_feature");
  return /* @__PURE__ */ m(Ao, { content: s, children: /* @__PURE__ */ m(Po, { href: o ? "" : "/teams", children: /* @__PURE__ */ m(Nr, { variant: "gray", children: a }) }) });
}, B1c = function({
  teamId: t,
  isOrganization: n = !1
}) {
  const { t: o } = Fe(), r = () => t ? n ? "/settings/organizations/billing" : `/settings/teams/${t}/billing` : "/settings/billing";
  return /* @__PURE__ */ m(Ao, { content: o("requires_credits_tooltip"), children: /* @__PURE__ */ m(Po, { href: r(), children: /* @__PURE__ */ m(Nr, { variant: "gray", className: "whitespace-nowrap", children: o("requires_credits") }) }) });
};
function gE({ content: e }) {
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(Ao, { side: "top", content: e, children: /* @__PURE__ */ m("span", { title: e, children: /* @__PURE__ */ m(ot, { name: "info", className: "text-subtle relative left-1 right-1 top-px mt-px h-4 w-4" }) }) }) });
}
const U1c = ({
  inputClassName: e,
  ...t
}) => /* @__PURE__ */ m(
  sd.Input,
  {
    inputClassName: ae(
      "focus:ring-0 focus:ring-offset-0 !text-default dark:!text-white",
      e
    ),
    ...t
  }
), W1c = ({
  ...e
}) => (
  // This gets styled in the select classNames prop now - handles overrides with styles vs className here doesn't
  /* @__PURE__ */ m(sd.Option, { ...e, children: /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ Y("span", { className: "w-full", "data-testid": `select-option-${e.value}`, children: [
      e.data.isCalAi ? /* @__PURE__ */ m(Nr, { startIcon: "sparkles", variant: "purple", className: "mr-1 hidden md:inline-flex", children: "Cal.ai" }) : /* @__PURE__ */ m(Ce, {}),
      e.label || /* @__PURE__ */ m(Ce, { children: " " })
    ] }),
    e.data.needsTeamsUpgrade ? /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 }) : e.data.needsCredits ? /* @__PURE__ */ m(
      B1c,
      {
        teamId: e.data.creditsTeamId,
        isOrganization: e.data.isOrganization
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    e.isSelected && /* @__PURE__ */ m(ot, { name: "check", className: "ml-2 h-4 w-4" })
  ] }) })
), G1c = (e) => {
  const t = e.selectProps["data-testid"] ?? "select-control";
  return /* @__PURE__ */ m("span", { "data-testid": t, children: /* @__PURE__ */ m(sd.Control, { ...e }) });
}, j_e = ({
  components: e,
  menuPlacement: t = "auto"
}) => ({
  menuPlacement: t,
  components: {
    Input: U1c,
    Option: W1c,
    Control: G1c,
    ...e
  },
  unstyled: !0
}), Tr = ({
  components: e,
  variant: t = "default",
  size: n = "md",
  grow: o = !0,
  ...r
}) => {
  const { classNames: i, innerClassNames: a, menuPlacement: s = "auto", ...c } = r, l = $e.useMemo(() => j_e({
    components: e || {},
    menuPlacement: s
  }), [e, s]), d = r.isMulti || r.isLoading || r.isClearable;
  return /* @__PURE__ */ m(
    P1c,
    {
      ...l,
      menuPlacement: s,
      styles: {
        control: (u) => ({
          ...u,
          minHeight: n === "sm" ? "28px" : "32px",
          height: o ? "auto" : n === "sm" ? "28px" : "32px"
        })
      },
      classNames: {
        input: () => ae("text-emphasis", a == null ? void 0 : a.input),
        option: (u) => ae(
          "bg-default flex cursor-pointer justify-between py-1.5 px-2 rounded-md text-default items-center",
          u.isFocused && "bg-subtle",
          u.isDisabled && "bg-muted",
          u.isSelected && "bg-emphasis text-default",
          a == null ? void 0 : a.option
        ),
        placeholder: (u) => ae("text-muted", u.isFocused && t !== "checkbox" && "hidden"),
        dropdownIndicator: () => ae("text-default", "w-4 h-4", "flex items-center justify-center "),
        control: (u) => ae(
          Z0({ size: n }),
          u.isMulti ? t === "checkbox" ? "px-3 h-fit" : u.hasValue ? "p-1 h-fit" : "px-3 h-fit" : n === "sm" ? "h-7 px-2 py-1" : "h-8 px-3 py-2",
          r.isDisabled && "bg-subtle",
          "rounded-[10px]",
          "[&:focus-within]:border-emphasis [&:focus-within]:shadow-outline-gray-focused [&:focus-within]:ring-0 !flex",
          a == null ? void 0 : a.control
        ),
        singleValue: () => ae("text-default placeholder:text-muted", a == null ? void 0 : a.singleValue),
        valueContainer: () => ae("text-default placeholder:text-muted flex gap-1", a == null ? void 0 : a.valueContainer),
        multiValue: () => ae(
          "font-medium inline-flex items-center justify-center rounded bg-emphasis text-emphasis leading-none text-xs",
          n == "sm" ? "px-1.5 py-[1px] rounded-md" : "py-1 px-1.5 leading-none rounded-lg"
        ),
        menu: () => ae(
          "rounded-lg bg-default text-sm leading-4 text-default mt-1 border border-subtle shadow-dropdown p-1",
          a == null ? void 0 : a.menu
        ),
        groupHeading: () => "leading-none text-xs text-muted p-2 font-medium ml-1",
        menuList: () => ae(
          "scroll-bar scrollbar-track-w-20 rounded-md flex flex-col space-y-[1px]",
          a == null ? void 0 : a.menuList
        ),
        indicatorsContainer: (u) => ae(
          "flex !items-start justify-center mt-0.5 h-full",
          u.selectProps.menuIsOpen ? d ? "[&>*:last-child]:rotate-180 [&>*:last-child]:transition-transform [&>*:last-child]:w-4 [&>*:last-child]:h-4" : "rotate-180 transition-transform w-4 h-4" : d ? "[&>*:last-child]:transition-transform [&>*:last-child]:w-4 [&>*:last-child]:h-4 text-default" : "transition-transform w-4 h-4 text-default"
        ),
        multiValueRemove: () => "text-default py-auto",
        ...i
      },
      ...c
    }
  );
}, rj = function(t) {
  var l;
  const { t: n } = Fe(), { label: o = n(t.name || ""), containerClassName: r, labelProps: i, className: a, ...s } = t, c = Cc();
  return /* @__PURE__ */ Y("div", { className: ae(r), children: [
    /* @__PURE__ */ m("div", { className: ae(a), children: !!o && /* @__PURE__ */ m(
      Xn,
      {
        htmlFor: c,
        ...i,
        className: ae(t.error && "text-error", (l = t.labelProps) == null ? void 0 : l.className),
        children: o
      }
    ) }),
    /* @__PURE__ */ m(Tr, { ...s })
  ] });
};
function ofd({
  required: e = !1,
  onChange: t,
  value: n,
  ...o
}) {
  const [r, i] = $e.useState(() => n instanceof Array || !n ? "" : n.value || ""), a = $e.useCallback((s) => {
    let c = "";
    s instanceof Array ? c = s.map((l) => l.value).join(",") : c = (s == null ? void 0 : s.value) || "", i(c);
  }, []);
  return $e.useEffect(() => {
    n && a(n);
  }, [n, a]), /* @__PURE__ */ Y("div", { className: ae("relative", o.className), children: [
    /* @__PURE__ */ m(
      Tr,
      {
        value: n,
        ...o,
        onChange: (s, ...c) => {
          a(s), t && t(s, ...c);
        }
      }
    ),
    e && /* @__PURE__ */ m(
      "input",
      {
        tabIndex: -1,
        autoComplete: "off",
        style: {
          opacity: 0,
          width: "100%",
          height: 1,
          position: "absolute"
        },
        value: r,
        onChange: () => {
        },
        required: e
      }
    )
  ] });
}
var F_e = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var a = typeof i;
          if (a === "string" || a === "number")
            o.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var s = n.apply(null, i);
              s && o.push(s);
            }
          } else if (a === "object")
            if (i.toString === Object.prototype.toString)
              for (var c in i)
                t.call(i, c) && i[c] && o.push(c);
            else
              o.push(i.toString());
        }
      }
      return o.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(F_e);
var cm = F_e.exports;
const ci = /* @__PURE__ */ Zr(cm), H1c = Yv("rounded-[10px] p-3", {
  variants: {
    severity: {
      neutral: "bg-default border-subtle border-[1px] text-default",
      info: "bg-semantic-info-subtle text-semantic-info",
      warning: "bg-semantic-attention-subtle text-semantic-attention",
      error: "bg-semantic-error-subtle text-semantic-error"
    }
  },
  defaultVariants: {
    severity: "neutral"
  }
}), sa = it((e, t) => {
  const { severity: n, iconClassName: o, CustomIcon: r, customIconColor: i } = e;
  return /* @__PURE__ */ m("div", { "data-testid": "alert", ref: t, className: H1c({ severity: n, className: e.className }), children: /* @__PURE__ */ Y("div", { className: "relative flex md:flex-row", children: [
    r ? /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: /* @__PURE__ */ m(
      ot,
      {
        name: r,
        "data-testid": "custom-icon",
        "aria-hidden": "true",
        className: ci("h4 mr-2 w-4", o, i ?? "text-default")
      }
    ) }) : /* @__PURE__ */ Y("div", { className: ci("mr-2 flex-shrink-0", e.title ? "" : "mt-0.5"), children: [
      n === "error" && /* @__PURE__ */ m(
        ot,
        {
          name: "circle-x",
          "data-testid": "circle-x",
          className: ci("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "warning" && /* @__PURE__ */ m(
        ot,
        {
          name: "triangle-alert",
          "data-testid": "alert-triangle",
          className: ci("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "info" && /* @__PURE__ */ m(
        ot,
        {
          name: "info",
          "data-testid": "info",
          className: ci("h4 w-4", o),
          "aria-hidden": "true"
        }
      ),
      n === "neutral" && /* @__PURE__ */ m(
        ot,
        {
          name: "info",
          "data-testid": "neutral",
          className: ci("text-default h4 w-4 fill-transparent", o),
          "aria-hidden": "true"
        }
      )
    ] }),
    /* @__PURE__ */ Y("div", { className: "flex flex-grow flex-col sm:flex-row", children: [
      /* @__PURE__ */ Y("div", { className: "space-y-1 ltr:ml-3 rtl:mr-3", children: [
        e.title && /* @__PURE__ */ m("h3", { className: "text-sm font-medium leading-none", children: e.title }),
        e.message && /* @__PURE__ */ m("div", { className: "text-sm leading-5", children: e.message })
      ] }),
      e.actions && /* @__PURE__ */ m("div", { className: "ml-auto mt-auto text-sm sm:mt-0 md:relative", children: e.actions })
    ] })
  ] }) });
});
sa.displayName = "Alert";
const K1c = it(function(t, n) {
  const { t: o } = Fe(), [r, i] = ze(!1), a = at(
    () => i(!r),
    [r, i]
  ), s = o(r ? "hide_password" : "show_password");
  return /* @__PURE__ */ m(
    hi,
    {
      type: r ? "text" : "password",
      placeholder: t.placeholder || "•••••••••••••",
      ref: n,
      ...t,
      className: ae(
        "addon-wrapper mb-0 ltr:border-r-0 ltr:pr-10 rtl:border-l-0 rtl:pl-10",
        t.className
      ),
      addOnSuffix: /* @__PURE__ */ m(Ao, { content: s, children: /* @__PURE__ */ Y(
        "button",
        {
          className: "text-emphasis h-9",
          tabIndex: -1,
          type: "button",
          onClick: () => a(),
          children: [
            r ? /* @__PURE__ */ m(ot, { name: "eye-off", className: "h-4 w-4 stroke-[2.5px]" }) : /* @__PURE__ */ m(ot, { name: "eye", className: "h-4 w-4 stroke-[2.5px]" }),
            /* @__PURE__ */ m("span", { className: "sr-only", children: s })
          ]
        }
      ) })
    }
  );
});
it(function(t, n) {
  return /* @__PURE__ */ m(
    Sc,
    {
      ref: n,
      type: "email",
      autoCapitalize: "none",
      autoComplete: "email",
      autoCorrect: "off",
      inputMode: "email",
      ...t
    }
  );
});
const V_e = it(function(t, n) {
  return /* @__PURE__ */ m(
    hi,
    {
      ref: n,
      type: "email",
      autoCapitalize: "none",
      autoComplete: "email",
      autoCorrect: "off",
      inputMode: "email",
      ...t
    }
  );
}), D$ = it(function(t, n) {
  return /* @__PURE__ */ m(
    "textarea",
    {
      ...t,
      ref: n,
      className: ae(Z0(), "min-h-[80px] w-full", t.className)
    }
  );
}), B_e = it(function(t, n) {
  var u, _, p;
  const o = N0(), { t: r } = Fe(), i = t.t || r, a = Dn(), {
    label: s = i(t.name),
    labelProps: c,
    /** Prevents displaying untranslated placeholder keys */
    placeholder: l = i(`${t.name}_placeholder`) !== `${t.name}_placeholder` ? `${t.name}_placeholder` : "",
    ...d
  } = t;
  return /* @__PURE__ */ Y("div", { children: [
    !!t.name && /* @__PURE__ */ m(Xn, { htmlFor: o, ...c, children: s }),
    /* @__PURE__ */ m(D$, { ref: n, placeholder: l, ...d }),
    ((_ = (u = a == null ? void 0 : a.formState) == null ? void 0 : u.errors[t.name]) == null ? void 0 : _.message) && /* @__PURE__ */ m(
      sa,
      {
        className: "mt-1",
        severity: "error",
        message: /* @__PURE__ */ m(Ce, { children: (p = a.formState.errors[t.name]) == null ? void 0 : p.message })
      }
    )
  ] });
}), Y1c = it(function(t, n) {
  return /* @__PURE__ */ m(
    Sc,
    {
      ref: n,
      type: "number",
      autoCapitalize: "none",
      autoComplete: "numeric",
      autoCorrect: "off",
      inputMode: "numeric",
      ...t
    }
  );
});
it(function(t, n) {
  return /* @__PURE__ */ m(
    hi,
    {
      ref: n,
      addOnLeading: /* @__PURE__ */ m(ot, { name: "search", className: "h-4 w-4 stroke-[2.5px]", "data-testid": "search-icon" }),
      placeholder: "Search",
      containerClassName: "mx-3 mt-2",
      ...t
    }
  );
});
const U_e = /* @__PURE__ */ new Set(), tc = /* @__PURE__ */ new WeakMap(), Gh = /* @__PURE__ */ new WeakMap(), Gf = /* @__PURE__ */ new WeakMap(), fM = /* @__PURE__ */ new WeakMap(), Z1c = /* @__PURE__ */ new WeakMap(), Nv = /* @__PURE__ */ new WeakMap(), hE = /* @__PURE__ */ new WeakMap(), _$ = /* @__PURE__ */ new WeakSet();
let tm;
const d_ = "__aa_tgt", gM = "__aa_del", Q1c = (e) => {
  const t = n2c(e);
  t && t.forEach((n) => o2c(n));
}, J1c = (e) => {
  e.forEach((t) => {
    t.target === tm && e2c(), tc.has(t.target) && _g(t.target);
  });
};
function X1c(e) {
  const t = fM.get(e);
  t == null || t.disconnect();
  let n = tc.get(e), o = 0;
  const r = 5;
  n || (n = Dv(e), tc.set(e, n));
  const { offsetWidth: i, offsetHeight: a } = tm, c = [
    n.top - r,
    i - (n.left + r + n.width),
    a - (n.top + r + n.height),
    n.left - r
  ].map((d) => `${-1 * Math.floor(d)}px`).join(" "), l = new IntersectionObserver(() => {
    ++o > 1 && _g(e);
  }, {
    root: tm,
    threshold: 1,
    rootMargin: c
  });
  l.observe(e), fM.set(e, l);
}
function _g(e) {
  clearTimeout(hE.get(e));
  const t = OA(e), n = typeof t == "function" ? 500 : t.duration;
  hE.set(e, setTimeout(async () => {
    const o = Gf.get(e);
    (!o || await o.finished) && (tc.set(e, Dv(e)), X1c(e));
  }, n));
}
function e2c() {
  clearTimeout(hE.get(tm)), hE.set(tm, setTimeout(() => {
    U_e.forEach((e) => K_e(e, (t) => W_e(() => _g(t))));
  }, 100));
}
function t2c(e) {
  setTimeout(() => {
    Z1c.set(e, setInterval(() => W_e(_g.bind(null, e)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function W_e(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let hM, kh;
typeof window < "u" && (tm = document.documentElement, hM = new MutationObserver(Q1c), kh = new ResizeObserver(J1c), kh.observe(tm));
function n2c(e) {
  return e.reduce((o, r) => [
    ...o,
    ...Array.from(r.addedNodes),
    ...Array.from(r.removedNodes)
  ], []).every((o) => o.nodeName === "#comment") ? !1 : e.reduce((o, r) => {
    if (o === !1)
      return !1;
    if (r.target instanceof Element) {
      if (V3(r.target), !o.has(r.target)) {
        o.add(r.target);
        for (let i = 0; i < r.target.children.length; i++) {
          const a = r.target.children.item(i);
          if (a) {
            if (gM in a)
              return !1;
            V3(r.target, a), o.add(a);
          }
        }
      }
      if (r.removedNodes.length)
        for (let i = 0; i < r.removedNodes.length; i++) {
          const a = r.removedNodes[i];
          if (gM in a)
            return !1;
          a instanceof Element && (o.add(a), V3(r.target, a), Gh.set(a, [
            r.previousSibling,
            r.nextSibling
          ]));
        }
    }
    return o;
  }, /* @__PURE__ */ new Set());
}
function V3(e, t) {
  !t && !(d_ in e) ? Object.defineProperty(e, d_, { value: e }) : t && !(d_ in t) && Object.defineProperty(t, d_, { value: e });
}
function o2c(e) {
  var t;
  const n = tm.contains(e), o = tc.has(e);
  n && Gh.has(e) && Gh.delete(e), Gf.has(e) && ((t = Gf.get(e)) === null || t === void 0 || t.cancel()), o && n ? r2c(e) : o && !n ? a2c(e) : i2c(e);
}
function zd(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function Dv(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    height: t.height
  };
}
function G_e(e, t, n) {
  let o = t.width, r = t.height, i = n.width, a = n.height;
  const s = getComputedStyle(e);
  if (s.getPropertyValue("box-sizing") === "content-box") {
    const l = zd(s.paddingTop) + zd(s.paddingBottom) + zd(s.borderTopWidth) + zd(s.borderBottomWidth), d = zd(s.paddingLeft) + zd(s.paddingRight) + zd(s.borderRightWidth) + zd(s.borderLeftWidth);
    o -= d, i -= d, r -= l, a -= l;
  }
  return [o, i, r, a].map(Math.round);
}
function OA(e) {
  return d_ in e && Nv.has(e[d_]) ? Nv.get(e[d_]) : { duration: 250, easing: "ease-in-out" };
}
function H_e(e) {
  if (d_ in e)
    return e[d_];
}
function ij(e) {
  const t = H_e(e);
  return t ? _$.has(t) : !1;
}
function K_e(e, ...t) {
  t.forEach((n) => n(e, Nv.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const o = e.children.item(n);
    o && t.forEach((r) => r(o, Nv.has(o)));
  }
}
function r2c(e) {
  const t = tc.get(e), n = Dv(e);
  if (!ij(e))
    return tc.set(e, n);
  let o;
  if (!t)
    return;
  const r = OA(e);
  if (typeof r != "function") {
    const i = t.left - n.left, a = t.top - n.top, [s, c, l, d] = G_e(e, t, n), u = {
      transform: `translate(${i}px, ${a}px)`
    }, _ = {
      transform: "translate(0, 0)"
    };
    s !== c && (u.width = `${s}px`, _.width = `${c}px`), l !== d && (u.height = `${l}px`, _.height = `${d}px`), o = e.animate([u, _], {
      duration: r.duration,
      easing: r.easing
    });
  } else
    o = new Animation(r(e, "remain", t, n)), o.play();
  Gf.set(e, o), tc.set(e, n), o.addEventListener("finish", _g.bind(null, e));
}
function i2c(e) {
  const t = Dv(e);
  tc.set(e, t);
  const n = OA(e);
  if (!ij(e))
    return;
  let o;
  typeof n != "function" ? o = e.animate([
    { transform: "scale(.98)", opacity: 0 },
    { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
    { transform: "scale(1)", opacity: 1 }
  ], {
    duration: n.duration * 1.5,
    easing: "ease-in"
  }) : (o = new Animation(n(e, "add", t)), o.play()), Gf.set(e, o), o.addEventListener("finish", _g.bind(null, e));
}
function a2c(e) {
  var t;
  if (!Gh.has(e) || !tc.has(e))
    return;
  const [n, o] = Gh.get(e);
  Object.defineProperty(e, gM, { value: !0 }), o && o.parentNode && o.parentNode instanceof Element ? o.parentNode.insertBefore(e, o) : n && n.parentNode ? n.parentNode.appendChild(e) : (t = H_e(e)) === null || t === void 0 || t.appendChild(e);
  function r() {
    var _;
    e.remove(), tc.delete(e), Gh.delete(e), Gf.delete(e), (_ = fM.get(e)) === null || _ === void 0 || _.disconnect();
  }
  if (!ij(e))
    return r();
  const [i, a, s, c] = s2c(e), l = OA(e), d = tc.get(e);
  let u;
  Object.assign(e.style, {
    position: "absolute",
    top: `${i}px`,
    left: `${a}px`,
    width: `${s}px`,
    height: `${c}px`,
    margin: 0,
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: 100
  }), typeof l != "function" ? u = e.animate([
    {
      transform: "scale(1)",
      opacity: 1
    },
    {
      transform: "scale(.98)",
      opacity: 0
    }
  ], { duration: l.duration, easing: "ease-out" }) : (u = new Animation(l(e, "remove", d)), u.play()), Gf.set(e, u), u.addEventListener("finish", r);
}
function s2c(e) {
  const t = tc.get(e), [n, , o] = G_e(e, t, Dv(e));
  let r = e.parentElement;
  for (; r && (getComputedStyle(r).position === "static" || r instanceof HTMLBodyElement); )
    r = r.parentElement;
  r || (r = document.body);
  const i = getComputedStyle(r), a = tc.get(r) || Dv(r), s = Math.round(t.top - a.top) - zd(i.borderTopWidth), c = Math.round(t.left - a.left) - zd(i.borderLeftWidth);
  return [s, c, n, o];
}
function c2c(e, t = {}) {
  return hM && kh && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && typeof t != "function" && !t.disrespectUserMotionPreference || (_$.add(e), getComputedStyle(e).position === "static" && Object.assign(e.style, { position: "relative" }), K_e(e, _g, t2c, (r) => kh == null ? void 0 : kh.observe(r)), typeof t == "function" ? Nv.set(e, t) : Nv.set(e, { duration: 250, easing: "ease-in-out", ...t }), hM.observe(e, { childList: !0 }), U_e.add(e))), Object.freeze({
    parent: e,
    enable: () => {
      _$.add(e);
    },
    disable: () => {
      _$.delete(e);
    },
    isEnabled: () => _$.has(e)
  });
}
function xl(e) {
  const t = Ue(null), [n, o] = ze(), r = (i) => {
    n && (i ? n.enable() : n.disable());
  };
  return Le(() => {
    t.current instanceof HTMLElement && o(c2c(t.current, e || {}));
  }, []), [t, r];
}
var XS = /* @__PURE__ */ ((e) => (e.PaymentCreationFailure = "payment_not_created_error", e.NoAvailableUsersFound = "no_available_users_found_error", e.ChargeCardFailure = "couldnt_charge_card_error", e.RequestBodyWithouEnd = "request_body_end_time_internal_error", e.AlreadySignedUpForBooking = "already_signed_up_for_this_booking_error", e.FixedHostsUnavailableForBooking = "fixed_hosts_unavailable_for_booking", e.RoundRobinHostsUnavailableForBooking = "round_robin_host_unavailable_for_booking", e.EventTypeNotFound = "event_type_not_found_error", e.BookingNotFound = "booking_not_found_error", e.BookingSeatsFull = "booking_seats_full_error", e.MissingPaymentCredential = "missing_payment_credential_error", e.MissingPaymentAppId = "missing_payment_app_id_error", e.NotEnoughAvailableSeats = "not_enough_available_seats_error", e.AvailabilityNotFoundInSchedule = "availability_not_found_in_schedule_error", e.CancelledBookingsCannotBeRescheduled = "cancelled_bookings_cannot_be_rescheduled", e.UnableToSubscribeToThePlatform = "unable_to_subscribe_to_the_platform", e.UpdatingOauthClientError = "updating_oauth_client_error", e.CreatingOauthClientError = "creating_oauth_client_error", e.BookingTimeOutOfBounds = "booking_time_out_of_bounds_error", e.BookingConflict = "booking_conflict_error", e.BookerLimitExceeded = "booker_limit_exceeded_error", e.BookerLimitExceededReschedule = "booker_limit_exceeded_error_reschedule", e.BookingNotAllowedByRestrictionSchedule = "booking_not_allowed_by_restriction_schedule_error", e.RestrictionScheduleNotFound = "restriction_schedule_not_found_error", e.EventTypeNoHosts = "event_type_no_hosts", e.RequestBodyInvalid = "request_body_invalid_error", e.PrivateLinkExpired = "private_link_expired", e.BookerEmailBlocked = "booker_email_blocked", e.BookerEmailRequiresLogin = "booker_email_requires_login", e.InvalidVerificationCode = "invalid_verification_code", e.UnableToValidateVerificationCode = "unable_to_validate_verification_code", e))(XS || {});
function l2c(e) {
  return e instanceof Error ? e : typeof e == "string" ? new Error(e, { cause: e }) : new Error(`Unhandled error of type '${typeof e}''`);
}
var d2c = (e) => {
  switch (e) {
    case "success":
      return p2c;
    case "info":
      return f2c;
    case "warning":
      return m2c;
    case "error":
      return g2c;
    default:
      return null;
  }
}, u2c = Array(12).fill(0), _2c = ({ visible: e, className: t }) => ve.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, ve.createElement("div", { className: "sonner-spinner" }, u2c.map((n, o) => ve.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${o}` })))), p2c = ve.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, ve.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), m2c = ve.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, ve.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), f2c = ve.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, ve.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), g2c = ve.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, ve.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), h2c = ve.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, ve.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), ve.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), v2c = () => {
  let [e, t] = ve.useState(document.hidden);
  return ve.useEffect(() => {
    let n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
}, vM = 1, b2c = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: n, ...o } = e, r = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : vM++, i = this.toasts.find((s) => s.id === r), a = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(r) && this.dismissedToasts.delete(r), i ? this.toasts = this.toasts.map((s) => s.id === r ? (this.publish({ ...s, ...e, id: r, title: n }), { ...s, ...e, id: r, dismissible: a, title: n }) : s) : this.addToast({ title: n, ...o, dismissible: a, id: r }), r;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((n) => n({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t)
        return;
      let n;
      t.loading !== void 0 && (n = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let o = e instanceof Promise ? e : e(), r = n !== void 0, i, a = o.then(async (c) => {
        if (i = ["resolve", c], ve.isValidElement(c))
          r = !1, this.create({ id: n, type: "default", message: c });
        else if ($2c(c) && !c.ok) {
          r = !1;
          let l = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, d = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description;
          this.create({ id: n, type: "error", message: l, description: d });
        } else if (t.success !== void 0) {
          r = !1;
          let l = typeof t.success == "function" ? await t.success(c) : t.success, d = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "success", message: l, description: d });
        }
      }).catch(async (c) => {
        if (i = ["reject", c], t.error !== void 0) {
          r = !1;
          let l = typeof t.error == "function" ? await t.error(c) : t.error, d = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "error", message: l, description: d });
        }
      }).finally(() => {
        var c;
        r && (this.dismiss(n), n = void 0), (c = t.finally) == null || c.call(t);
      }), s = () => new Promise((c, l) => a.then(() => i[0] === "reject" ? l(i[1]) : c(i[1])).catch(l));
      return typeof n != "string" && typeof n != "number" ? { unwrap: s } : Object.assign(n, { unwrap: s });
    }, this.custom = (e, t) => {
      let n = (t == null ? void 0 : t.id) || vM++;
      return this.create({ jsx: e(n), id: n, ...t }), n;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, Hs = new b2c(), y2c = (e, t) => {
  let n = (t == null ? void 0 : t.id) || vM++;
  return Hs.addToast({ title: e, ...t, id: n }), n;
}, $2c = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", w2c = y2c, k2c = () => Hs.toasts, S2c = () => Hs.getActiveToasts(), NK = Object.assign(w2c, { success: Hs.success, info: Hs.info, warning: Hs.warning, error: Hs.error, custom: Hs.custom, message: Hs.message, promise: Hs.promise, dismiss: Hs.dismiss, loading: Hs.loading }, { getHistory: k2c, getToasts: S2c });
function x2c(e, { insertAt: t } = {}) {
  if (!e || typeof document > "u")
    return;
  let n = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
  o.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
}
x2c(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function q2(e) {
  return e.label !== void 0;
}
var E2c = 3, T2c = "32px", A2c = "16px", DK = 4e3, C2c = 356, z2c = 14, O2c = 20, P2c = 200;
function ql(...e) {
  return e.filter(Boolean).join(" ");
}
function I2c(e) {
  let [t, n] = e.split("-"), o = [];
  return t && o.push(t), n && o.push(n), o;
}
var R2c = (e) => {
  var t, n, o, r, i, a, s, c, l, d, u;
  let { invert: _, toast: p, unstyled: f, interacting: g, setHeights: h, visibleToasts: b, heights: v, index: $, toasts: k, expanded: S, removeToast: O, defaultRichColors: I, closeButton: D, style: M, cancelButtonStyle: N, actionButtonStyle: C, className: P = "", descriptionClassName: x = "", duration: w, position: E, gap: T, loadingIcon: z, expandByDefault: j, classNames: q, icons: V, closeButtonAriaLabel: F = "Close toast", pauseWhenPageIsHidden: L } = e, [U, W] = ve.useState(null), [H, Q] = ve.useState(null), [X, re] = ve.useState(!1), [Z, ee] = ve.useState(!1), [J, oe] = ve.useState(!1), [ce, de] = ve.useState(!1), [te, ue] = ve.useState(!1), [le, se] = ve.useState(0), [me, pe] = ve.useState(0), be = ve.useRef(p.duration || w || DK), Se = ve.useRef(null), Ae = ve.useRef(null), Ze = $ === 0, Ge = $ + 1 <= b, rt = p.type, qe = p.dismissible !== !1, Xe = p.className || "", lt = p.descriptionClassName || "", Et = ve.useMemo(() => v.findIndex((gt) => gt.toastId === p.id) || 0, [v, p.id]), wt = ve.useMemo(() => {
    var gt;
    return (gt = p.closeButton) != null ? gt : D;
  }, [p.closeButton, D]), nn = ve.useMemo(() => p.duration || w || DK, [p.duration, w]), Dt = ve.useRef(0), mt = ve.useRef(0), bt = ve.useRef(0), gn = ve.useRef(null), [an, Mn] = E.split("-"), Ln = ve.useMemo(() => v.reduce((gt, Ot, _n) => _n >= Et ? gt : gt + Ot.height, 0), [v, Et]), un = v2c(), qo = p.invert || _, cn = rt === "loading";
  mt.current = ve.useMemo(() => Et * T + Ln, [Et, Ln]), ve.useEffect(() => {
    be.current = nn;
  }, [nn]), ve.useEffect(() => {
    re(!0);
  }, []), ve.useEffect(() => {
    let gt = Ae.current;
    if (gt) {
      let Ot = gt.getBoundingClientRect().height;
      return pe(Ot), h((_n) => [{ toastId: p.id, height: Ot, position: p.position }, ..._n]), () => h((_n) => _n.filter((wn) => wn.toastId !== p.id));
    }
  }, [h, p.id]), ve.useLayoutEffect(() => {
    if (!X)
      return;
    let gt = Ae.current, Ot = gt.style.height;
    gt.style.height = "auto";
    let _n = gt.getBoundingClientRect().height;
    gt.style.height = Ot, pe(_n), h((wn) => wn.find((so) => so.toastId === p.id) ? wn.map((so) => so.toastId === p.id ? { ...so, height: _n } : so) : [{ toastId: p.id, height: _n, position: p.position }, ...wn]);
  }, [X, p.title, p.description, h, p.id]);
  let ln = ve.useCallback(() => {
    ee(!0), se(mt.current), h((gt) => gt.filter((Ot) => Ot.toastId !== p.id)), setTimeout(() => {
      O(p);
    }, P2c);
  }, [p, O, h, mt]);
  ve.useEffect(() => {
    if (p.promise && rt === "loading" || p.duration === 1 / 0 || p.type === "loading")
      return;
    let gt;
    return S || g || L && un ? (() => {
      if (bt.current < Dt.current) {
        let Ot = (/* @__PURE__ */ new Date()).getTime() - Dt.current;
        be.current = be.current - Ot;
      }
      bt.current = (/* @__PURE__ */ new Date()).getTime();
    })() : be.current !== 1 / 0 && (Dt.current = (/* @__PURE__ */ new Date()).getTime(), gt = setTimeout(() => {
      var Ot;
      (Ot = p.onAutoClose) == null || Ot.call(p, p), ln();
    }, be.current)), () => clearTimeout(gt);
  }, [S, g, p, rt, L, un, ln]), ve.useEffect(() => {
    p.delete && ln();
  }, [ln, p.delete]);
  function kn() {
    var gt, Ot, _n;
    return V != null && V.loading ? ve.createElement("div", { className: ql(q == null ? void 0 : q.loader, (gt = p == null ? void 0 : p.classNames) == null ? void 0 : gt.loader, "sonner-loader"), "data-visible": rt === "loading" }, V.loading) : z ? ve.createElement("div", { className: ql(q == null ? void 0 : q.loader, (Ot = p == null ? void 0 : p.classNames) == null ? void 0 : Ot.loader, "sonner-loader"), "data-visible": rt === "loading" }, z) : ve.createElement(_2c, { className: ql(q == null ? void 0 : q.loader, (_n = p == null ? void 0 : p.classNames) == null ? void 0 : _n.loader), visible: rt === "loading" });
  }
  return ve.createElement("li", { tabIndex: 0, ref: Ae, className: ql(P, Xe, q == null ? void 0 : q.toast, (t = p == null ? void 0 : p.classNames) == null ? void 0 : t.toast, q == null ? void 0 : q.default, q == null ? void 0 : q[rt], (n = p == null ? void 0 : p.classNames) == null ? void 0 : n[rt]), "data-sonner-toast": "", "data-rich-colors": (o = p.richColors) != null ? o : I, "data-styled": !(p.jsx || p.unstyled || f), "data-mounted": X, "data-promise": !!p.promise, "data-swiped": te, "data-removed": Z, "data-visible": Ge, "data-y-position": an, "data-x-position": Mn, "data-index": $, "data-front": Ze, "data-swiping": J, "data-dismissible": qe, "data-type": rt, "data-invert": qo, "data-swipe-out": ce, "data-swipe-direction": H, "data-expanded": !!(S || j && X), style: { "--index": $, "--toasts-before": $, "--z-index": k.length - $, "--offset": `${Z ? le : mt.current}px`, "--initial-height": j ? "auto" : `${me}px`, ...M, ...p.style }, onDragEnd: () => {
    oe(!1), W(null), gn.current = null;
  }, onPointerDown: (gt) => {
    cn || !qe || (Se.current = /* @__PURE__ */ new Date(), se(mt.current), gt.target.setPointerCapture(gt.pointerId), gt.target.tagName !== "BUTTON" && (oe(!0), gn.current = { x: gt.clientX, y: gt.clientY }));
  }, onPointerUp: () => {
    var gt, Ot, _n, wn;
    if (ce || !qe)
      return;
    gn.current = null;
    let so = Number(((gt = Ae.current) == null ? void 0 : gt.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), rn = Number(((Ot = Ae.current) == null ? void 0 : Ot.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ht = (/* @__PURE__ */ new Date()).getTime() - ((_n = Se.current) == null ? void 0 : _n.getTime()), qn = U === "x" ? so : rn, Bn = Math.abs(qn) / Ht;
    if (Math.abs(qn) >= O2c || Bn > 0.11) {
      se(mt.current), (wn = p.onDismiss) == null || wn.call(p, p), Q(U === "x" ? so > 0 ? "right" : "left" : rn > 0 ? "down" : "up"), ln(), de(!0), ue(!1);
      return;
    }
    oe(!1), W(null);
  }, onPointerMove: (gt) => {
    var Ot, _n, wn, so;
    if (!gn.current || !qe || ((Ot = window.getSelection()) == null ? void 0 : Ot.toString().length) > 0)
      return;
    let rn = gt.clientY - gn.current.y, Ht = gt.clientX - gn.current.x, qn = (_n = e.swipeDirections) != null ? _n : I2c(E);
    !U && (Math.abs(Ht) > 1 || Math.abs(rn) > 1) && W(Math.abs(Ht) > Math.abs(rn) ? "x" : "y");
    let Bn = { x: 0, y: 0 };
    U === "y" ? (qn.includes("top") || qn.includes("bottom")) && (qn.includes("top") && rn < 0 || qn.includes("bottom") && rn > 0) && (Bn.y = rn) : U === "x" && (qn.includes("left") || qn.includes("right")) && (qn.includes("left") && Ht < 0 || qn.includes("right") && Ht > 0) && (Bn.x = Ht), (Math.abs(Bn.x) > 0 || Math.abs(Bn.y) > 0) && ue(!0), (wn = Ae.current) == null || wn.style.setProperty("--swipe-amount-x", `${Bn.x}px`), (so = Ae.current) == null || so.style.setProperty("--swipe-amount-y", `${Bn.y}px`);
  } }, wt && !p.jsx ? ve.createElement("button", { "aria-label": F, "data-disabled": cn, "data-close-button": !0, onClick: cn || !qe ? () => {
  } : () => {
    var gt;
    ln(), (gt = p.onDismiss) == null || gt.call(p, p);
  }, className: ql(q == null ? void 0 : q.closeButton, (r = p == null ? void 0 : p.classNames) == null ? void 0 : r.closeButton) }, (i = V == null ? void 0 : V.close) != null ? i : h2c) : null, p.jsx || bl(p.title) ? p.jsx ? p.jsx : typeof p.title == "function" ? p.title() : p.title : ve.createElement(ve.Fragment, null, rt || p.icon || p.promise ? ve.createElement("div", { "data-icon": "", className: ql(q == null ? void 0 : q.icon, (a = p == null ? void 0 : p.classNames) == null ? void 0 : a.icon) }, p.promise || p.type === "loading" && !p.icon ? p.icon || kn() : null, p.type !== "loading" ? p.icon || (V == null ? void 0 : V[rt]) || d2c(rt) : null) : null, ve.createElement("div", { "data-content": "", className: ql(q == null ? void 0 : q.content, (s = p == null ? void 0 : p.classNames) == null ? void 0 : s.content) }, ve.createElement("div", { "data-title": "", className: ql(q == null ? void 0 : q.title, (c = p == null ? void 0 : p.classNames) == null ? void 0 : c.title) }, typeof p.title == "function" ? p.title() : p.title), p.description ? ve.createElement("div", { "data-description": "", className: ql(x, lt, q == null ? void 0 : q.description, (l = p == null ? void 0 : p.classNames) == null ? void 0 : l.description) }, typeof p.description == "function" ? p.description() : p.description) : null), bl(p.cancel) ? p.cancel : p.cancel && q2(p.cancel) ? ve.createElement("button", { "data-button": !0, "data-cancel": !0, style: p.cancelButtonStyle || N, onClick: (gt) => {
    var Ot, _n;
    q2(p.cancel) && qe && ((_n = (Ot = p.cancel).onClick) == null || _n.call(Ot, gt), ln());
  }, className: ql(q == null ? void 0 : q.cancelButton, (d = p == null ? void 0 : p.classNames) == null ? void 0 : d.cancelButton) }, p.cancel.label) : null, bl(p.action) ? p.action : p.action && q2(p.action) ? ve.createElement("button", { "data-button": !0, "data-action": !0, style: p.actionButtonStyle || C, onClick: (gt) => {
    var Ot, _n;
    q2(p.action) && ((_n = (Ot = p.action).onClick) == null || _n.call(Ot, gt), !gt.defaultPrevented && ln());
  }, className: ql(q == null ? void 0 : q.actionButton, (u = p == null ? void 0 : p.classNames) == null ? void 0 : u.actionButton) }, p.action.label) : null));
};
function MK() {
  if (typeof window > "u" || typeof document > "u")
    return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function N2c(e, t) {
  let n = {};
  return [e, t].forEach((o, r) => {
    let i = r === 1, a = i ? "--mobile-offset" : "--offset", s = i ? A2c : T2c;
    function c(l) {
      ["top", "right", "bottom", "left"].forEach((d) => {
        n[`${a}-${d}`] = typeof l == "number" ? `${l}px` : l;
      });
    }
    typeof o == "number" || typeof o == "string" ? c(o) : typeof o == "object" ? ["top", "right", "bottom", "left"].forEach((l) => {
      o[l] === void 0 ? n[`${a}-${l}`] = s : n[`${a}-${l}`] = typeof o[l] == "number" ? `${o[l]}px` : o[l];
    }) : c(s);
  }), n;
}
var Y_e = it(function(e, t) {
  let { invert: n, position: o = "bottom-right", hotkey: r = ["altKey", "KeyT"], expand: i, closeButton: a, className: s, offset: c, mobileOffset: l, theme: d = "light", richColors: u, duration: _, style: p, visibleToasts: f = E2c, toastOptions: g, dir: h = MK(), gap: b = z2c, loadingIcon: v, icons: $, containerAriaLabel: k = "Notifications", pauseWhenPageIsHidden: S } = e, [O, I] = ve.useState([]), D = ve.useMemo(() => Array.from(new Set([o].concat(O.filter((L) => L.position).map((L) => L.position)))), [O, o]), [M, N] = ve.useState([]), [C, P] = ve.useState(!1), [x, w] = ve.useState(!1), [E, T] = ve.useState(d !== "system" ? d : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), z = ve.useRef(null), j = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), q = ve.useRef(null), V = ve.useRef(!1), F = ve.useCallback((L) => {
    I((U) => {
      var W;
      return (W = U.find((H) => H.id === L.id)) != null && W.delete || Hs.dismiss(L.id), U.filter(({ id: H }) => H !== L.id);
    });
  }, []);
  return ve.useEffect(() => Hs.subscribe((L) => {
    if (L.dismiss) {
      I((U) => U.map((W) => W.id === L.id ? { ...W, delete: !0 } : W));
      return;
    }
    setTimeout(() => {
      Uv.flushSync(() => {
        I((U) => {
          let W = U.findIndex((H) => H.id === L.id);
          return W !== -1 ? [...U.slice(0, W), { ...U[W], ...L }, ...U.slice(W + 1)] : [L, ...U];
        });
      });
    });
  }), []), ve.useEffect(() => {
    if (d !== "system") {
      T(d);
      return;
    }
    if (d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? T("dark") : T("light")), typeof window > "u")
      return;
    let L = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      L.addEventListener("change", ({ matches: U }) => {
        T(U ? "dark" : "light");
      });
    } catch {
      L.addListener(({ matches: W }) => {
        try {
          T(W ? "dark" : "light");
        } catch (H) {
          console.error(H);
        }
      });
    }
  }, [d]), ve.useEffect(() => {
    O.length <= 1 && P(!1);
  }, [O]), ve.useEffect(() => {
    let L = (U) => {
      var W, H;
      r.every((Q) => U[Q] || U.code === Q) && (P(!0), (W = z.current) == null || W.focus()), U.code === "Escape" && (document.activeElement === z.current || (H = z.current) != null && H.contains(document.activeElement)) && P(!1);
    };
    return document.addEventListener("keydown", L), () => document.removeEventListener("keydown", L);
  }, [r]), ve.useEffect(() => {
    if (z.current)
      return () => {
        q.current && (q.current.focus({ preventScroll: !0 }), q.current = null, V.current = !1);
      };
  }, [z.current]), ve.createElement("section", { ref: t, "aria-label": `${k} ${j}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, D.map((L, U) => {
    var W;
    let [H, Q] = L.split("-");
    return O.length ? ve.createElement("ol", { key: L, dir: h === "auto" ? MK() : h, tabIndex: -1, ref: z, className: s, "data-sonner-toaster": !0, "data-theme": E, "data-y-position": H, "data-lifted": C && O.length > 1 && !i, "data-x-position": Q, style: { "--front-toast-height": `${((W = M[0]) == null ? void 0 : W.height) || 0}px`, "--width": `${C2c}px`, "--gap": `${b}px`, ...p, ...N2c(c, l) }, onBlur: (X) => {
      V.current && !X.currentTarget.contains(X.relatedTarget) && (V.current = !1, q.current && (q.current.focus({ preventScroll: !0 }), q.current = null));
    }, onFocus: (X) => {
      X.target instanceof HTMLElement && X.target.dataset.dismissible === "false" || V.current || (V.current = !0, q.current = X.relatedTarget);
    }, onMouseEnter: () => P(!0), onMouseMove: () => P(!0), onMouseLeave: () => {
      x || P(!1);
    }, onDragEnd: () => P(!1), onPointerDown: (X) => {
      X.target instanceof HTMLElement && X.target.dataset.dismissible === "false" || w(!0);
    }, onPointerUp: () => w(!1) }, O.filter((X) => !X.position && U === 0 || X.position === L).map((X, re) => {
      var Z, ee;
      return ve.createElement(R2c, { key: X.id, icons: $, index: re, toast: X, defaultRichColors: u, duration: (Z = g == null ? void 0 : g.duration) != null ? Z : _, className: g == null ? void 0 : g.className, descriptionClassName: g == null ? void 0 : g.descriptionClassName, invert: n, visibleToasts: f, closeButton: (ee = g == null ? void 0 : g.closeButton) != null ? ee : a, interacting: x, position: L, style: g == null ? void 0 : g.style, unstyled: g == null ? void 0 : g.unstyled, classNames: g == null ? void 0 : g.classNames, cancelButtonStyle: g == null ? void 0 : g.cancelButtonStyle, actionButtonStyle: g == null ? void 0 : g.actionButtonStyle, removeToast: F, toasts: O.filter((J) => J.position == X.position), heights: M.filter((J) => J.position == X.position), setHeights: N, expandByDefault: i, gap: b, loadingIcon: v, expanded: C, pauseWhenPageIsHidden: S, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const LK = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ Y(
  "button",
  {
    className: ci(
      "data-testid-toast-success bg-default dark:bg-inverted text-emphasis dark:text-inverted shadow-elevation-low border-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-lg border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "check", className: "size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-success", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "x", className: "size-4 hover:cursor-pointer" }) })
    ]
  }
), D2c = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ Y(
  "button",
  {
    className: ci(
      "animate-fade-in-up bg-semantic-error-subtle text-semantic-error shadow-elevation-low border-semantic-error-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-md border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "info", className: "text-semantic-error  size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-error", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "x", className: "text-semantic-error size-4 hover:cursor-pointer" }) })
    ]
  }
), M2c = ({ message: e, onClose: t, toastId: n }) => /* @__PURE__ */ Y(
  "button",
  {
    className: ci(
      "animate-fade-in-up bg-semantic-attention-subtle text-semantic-attention shadow-elevation-low border-semantic-attention-subtle mb-2 flex h-auto items-center justify-between space-x-2 rounded-md border px-3 py-2.5 text-sm font-semibold rtl:space-x-reverse md:max-w-sm"
    ),
    onClick: () => t(n),
    children: [
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "info", className: "text-semantic-attention size-4" }) }),
      /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m("p", { "data-testid": "toast-warning", className: "m-0 w-full text-left", children: e }) }),
      /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ot, { name: "x", className: "text-semantic-attention size-4 hover:cursor-pointer" }) })
    ]
  }
), qK = 6e3;
function nr(e, t, n = qK) {
  const o = typeof n == "number" ? { duration: n } : n;
  o.duration || (o.duration = qK), o.position || (o.position = "bottom-center");
  const r = (a) => {
    NK.dismiss(a);
  }, i = {
    success: (a) => /* @__PURE__ */ m(LK, { message: e, onClose: r, toastId: a }),
    error: (a) => /* @__PURE__ */ m(D2c, { message: e, onClose: r, toastId: a }),
    warning: (a) => /* @__PURE__ */ m(M2c, { message: e, onClose: r, toastId: a })
  };
  return NK.custom(
    i[t] || ((a) => /* @__PURE__ */ m(LK, { message: e, onClose: r, toastId: a })),
    o
  );
}
const L2c = (e, t) => {
  const { form: n, handleSubmit: o, ...r } = e;
  return /* @__PURE__ */ m(kce, { ...n, children: /* @__PURE__ */ m(
    "form",
    {
      ref: t,
      onSubmit: (i) => {
        i.preventDefault(), i.stopPropagation(), n.handleSubmit(o)(i).catch((a) => {
          nr(`${l2c(a).message}`, "error");
        });
      },
      ...r,
      children: e.children
    }
  ) });
}, fd = it(L2c);
var bM = { exports: {} };
function q2c(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var B3 = {}, U3 = {}, jK;
function j2c() {
  return jK || (jK = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "LoadableContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ sm._(ve)).default.createContext(null);
  }(U3)), U3;
}
var FK;
function F2c() {
  return FK || (FK = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return p;
      }
    });
    const n = /* @__PURE__ */ sm._(ve), o = j2c();
    function r(f) {
      return f && f.default ? f.default : f;
    }
    const i = [], a = [];
    let s = !1;
    function c(f) {
      let g = f(), h = {
        loading: !0,
        loaded: null,
        error: null
      };
      return h.promise = g.then((b) => (h.loading = !1, h.loaded = b, b)).catch((b) => {
        throw h.loading = !1, h.error = b, b;
      }), h;
    }
    function l(f, g) {
      let h = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null
      }, g), b = null;
      function v() {
        if (!b) {
          const S = new d(f, h);
          b = {
            getCurrentValue: S.getCurrentValue.bind(S),
            subscribe: S.subscribe.bind(S),
            retry: S.retry.bind(S),
            promise: S.promise.bind(S)
          };
        }
        return b.promise();
      }
      if (typeof window > "u" && i.push(v), !s && typeof window < "u") {
        const S = h.webpack && typeof q2c.resolveWeak == "function" ? h.webpack() : h.modules;
        S && a.push((O) => {
          for (const I of S)
            if (O.includes(I))
              return v();
        });
      }
      function $() {
        v();
        const S = n.default.useContext(o.LoadableContext);
        S && Array.isArray(h.modules) && h.modules.forEach((O) => {
          S(O);
        });
      }
      function k(S, O) {
        $();
        const I = n.default.useSyncExternalStore(b.subscribe, b.getCurrentValue, b.getCurrentValue);
        return n.default.useImperativeHandle(O, () => ({
          retry: b.retry
        }), []), n.default.useMemo(() => I.loading || I.error ? /* @__PURE__ */ n.default.createElement(h.loading, {
          isLoading: I.loading,
          pastDelay: I.pastDelay,
          timedOut: I.timedOut,
          error: I.error,
          retry: b.retry
        }) : I.loaded ? /* @__PURE__ */ n.default.createElement(r(I.loaded), S) : null, [
          S,
          I
        ]);
      }
      return k.preload = () => v(), k.displayName = "LoadableComponent", /* @__PURE__ */ n.default.forwardRef(k);
    }
    class d {
      promise() {
        return this._res.promise;
      }
      retry() {
        this._clearTimeouts(), this._res = this._loadFn(this._opts.loader), this._state = {
          pastDelay: !1,
          timedOut: !1
        };
        const { _res: g, _opts: h } = this;
        g.loading && (typeof h.delay == "number" && (h.delay === 0 ? this._state.pastDelay = !0 : this._delay = setTimeout(() => {
          this._update({
            pastDelay: !0
          });
        }, h.delay)), typeof h.timeout == "number" && (this._timeout = setTimeout(() => {
          this._update({
            timedOut: !0
          });
        }, h.timeout))), this._res.promise.then(() => {
          this._update({}), this._clearTimeouts();
        }).catch((b) => {
          this._update({}), this._clearTimeouts();
        }), this._update({});
      }
      _update(g) {
        this._state = {
          ...this._state,
          error: this._res.error,
          loaded: this._res.loaded,
          loading: this._res.loading,
          ...g
        }, this._callbacks.forEach((h) => h());
      }
      _clearTimeouts() {
        clearTimeout(this._delay), clearTimeout(this._timeout);
      }
      getCurrentValue() {
        return this._state;
      }
      subscribe(g) {
        return this._callbacks.add(g), () => {
          this._callbacks.delete(g);
        };
      }
      constructor(g, h) {
        this._loadFn = g, this._opts = h, this._callbacks = /* @__PURE__ */ new Set(), this._delay = null, this._timeout = null, this.retry();
      }
    }
    function u(f) {
      return l(c, f);
    }
    function _(f, g) {
      let h = [];
      for (; f.length; ) {
        let b = f.pop();
        h.push(b(g));
      }
      return Promise.all(h).then(() => {
        if (f.length)
          return _(f, g);
      });
    }
    u.preloadAll = () => new Promise((f, g) => {
      _(i).then(f, g);
    }), u.preloadReady = (f) => (f === void 0 && (f = []), new Promise((g) => {
      const h = () => (s = !0, g());
      _(a, f).then(h, h);
    })), typeof window < "u" && (window.__NEXT_PRELOADREADY = u.preloadReady);
    const p = u;
  }(B3)), B3;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(d, u) {
    for (var _ in u)
      Object.defineProperty(d, _, {
        enumerable: !0,
        get: u[_]
      });
  }
  n(t, {
    /**
    * This function lets you dynamically import a component.
    * It uses [React.lazy()](https://react.dev/reference/react/lazy) with [Suspense](https://react.dev/reference/react/Suspense) under the hood.
    *
    * Read more: [Next.js Docs: `next/dynamic`](https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading#nextdynamic)
    */
    default: function() {
      return l;
    },
    noSSR: function() {
      return c;
    }
  });
  const o = sm, r = PT, i = /* @__PURE__ */ o._(F2c()), a = typeof window > "u";
  function s(d) {
    return {
      default: (d == null ? void 0 : d.default) || d
    };
  }
  function c(d, u) {
    if (delete u.webpack, delete u.modules, !a)
      return d(u);
    const _ = u.loading;
    return () => /* @__PURE__ */ (0, r.jsx)(_, {
      error: null,
      isLoading: !0,
      pastDelay: !1,
      timedOut: !1
    });
  }
  function l(d, u) {
    let _ = i.default, p = {
      // A loading component is not required, so we default it
      loading: (h) => {
        let { error: b, isLoading: v, pastDelay: $ } = h;
        return null;
      }
    };
    d instanceof Promise ? p.loader = () => d : typeof d == "function" ? p.loader = d : typeof d == "object" && (p = {
      ...p,
      ...d
    }), p = {
      ...p,
      ...u
    };
    const f = p.loader, g = () => f != null ? f().then(s) : Promise.resolve(s(() => null));
    return p.loadableGenerated && (p = {
      ...p,
      ...p.loadableGenerated
    }, delete p.loadableGenerated), typeof p.ssr == "boolean" && !p.ssr ? (delete p.webpack, delete p.modules, c(_, p)) : _({
      ...p,
      loader: g
    });
  }
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(bM, bM.exports);
var V2c = bM.exports, B2c = V2c;
const hn = /* @__PURE__ */ Zr(B2c), U2c = hn(
  () => import("./DateRangePicker-AvaT63ag.js").then((e) => e.DatePickerWithRange)
);
var aj = globalThis != null && globalThis.document ? $e.useLayoutEffect : () => {
};
const Z_e = "Popover", [Q_e, rfd] = os(Z_e, [
  Kv
]), sj = Kv(), [W2c, nb] = Q_e(Z_e), G2c = (e) => {
  const { __scopePopover: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: a = !1 } = e, s = sj(t), c = Ue(null), [l, d] = ze(!1), [u = !1, _] = jc({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ Pe(Nq, s, /* @__PURE__ */ Pe(W2c, {
    scope: t,
    contentId: Cc(),
    triggerRef: c,
    open: u,
    onOpenChange: _,
    onOpenToggle: at(
      () => _(
        (p) => !p
      ),
      [
        _
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: at(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: at(
      () => d(!1),
      []
    ),
    modal: a
  }, n));
}, H2c = "PopoverTrigger", K2c = /* @__PURE__ */ it((e, t) => {
  const { __scopePopover: n, ...o } = e, r = nb(H2c, n), i = sj(n), a = or(t, r.triggerRef), s = /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": epe(r.open)
  }, o, {
    ref: a,
    onClick: Bt(e.onClick, r.onOpenToggle)
  }));
  return r.hasCustomAnchor ? s : /* @__PURE__ */ Pe(Dq, We({
    asChild: !0
  }, i), s);
}), J_e = "PopoverPortal", [Y2c, Z2c] = Q_e(J_e, {
  forceMount: void 0
}), Q2c = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, i = nb(J_e, t);
  return /* @__PURE__ */ Pe(Y2c, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Pe(rs, {
    present: n || i.open
  }, /* @__PURE__ */ Pe(Lq, {
    asChild: !0,
    container: r
  }, o)));
}, Dw = "PopoverContent", J2c = /* @__PURE__ */ it((e, t) => {
  const n = Z2c(Dw, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, i = nb(Dw, e.__scopePopover);
  return /* @__PURE__ */ Pe(rs, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ Pe(X2c, We({}, r, {
    ref: t
  })) : /* @__PURE__ */ Pe(eSc, We({}, r, {
    ref: t
  })));
}), X2c = /* @__PURE__ */ it((e, t) => {
  const n = nb(Dw, e.__scopePopover), o = Ue(null), r = or(t, o), i = Ue(!1);
  return Le(() => {
    const a = o.current;
    if (a)
      return t9(a);
  }, []), /* @__PURE__ */ Pe(n9, {
    as: Df,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Pe(X_e, We({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Bt(e.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), i.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Bt(e.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Bt(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), eSc = /* @__PURE__ */ it((e, t) => {
  const n = nb(Dw, e.__scopePopover), o = Ue(!1), r = Ue(!1);
  return /* @__PURE__ */ Pe(X_e, We({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      o.current = !1, r.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
      const c = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
    }
  }));
}), X_e = /* @__PURE__ */ it((e, t) => {
  const { __scopePopover: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: d, ...u } = e, _ = nb(Dw, n), p = sj(n);
  return Zq(), /* @__PURE__ */ Pe(Qq, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Pe(jT, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => _.onOpenChange(!1)
  }, /* @__PURE__ */ Pe(Mq, We({
    "data-state": epe(_.open),
    role: "dialog",
    id: _.contentId
  }, p, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function epe(e) {
  return e ? "open" : "closed";
}
const tpe = G2c, npe = K2c, tSc = Q2c, ope = J2c, nSc = /* @__PURE__ */ it((e, t) => {
  const { pressed: n, defaultPressed: o = !1, onPressedChange: r, ...i } = e, [a = !1, s] = jc({
    prop: n,
    onChange: r,
    defaultProp: o
  });
  return /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    "aria-pressed": a,
    "data-state": a ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, i, {
    ref: t,
    onClick: Bt(e.onClick, () => {
      e.disabled || s(!a);
    })
  }));
}), oSc = /* @__PURE__ */ No(void 0);
function rSc(e) {
  const t = Pn(oSc);
  return e || t || "ltr";
}
const PA = "ToggleGroup", [rpe, ifd] = os(PA, [
  Zv
]), ipe = Zv(), iSc = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single") {
    const r = o;
    return /* @__PURE__ */ ve.createElement(aSc, We({}, r, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const r = o;
    return /* @__PURE__ */ ve.createElement(sSc, We({}, r, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${PA}\``);
}), [ape, spe] = rpe(PA), aSc = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, ...i } = e, [a, s] = jc({
    prop: n,
    defaultProp: o,
    onChange: r
  });
  return /* @__PURE__ */ ve.createElement(ape, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: a ? [
      a
    ] : [],
    onItemActivate: s,
    onItemDeactivate: ve.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ ve.createElement(cpe, We({}, i, {
    ref: t
  })));
}), sSc = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, ...i } = e, [a = [], s] = jc({
    prop: n,
    defaultProp: o,
    onChange: r
  }), c = ve.useCallback(
    (d) => s(
      (u = []) => [
        ...u,
        d
      ]
    ),
    [
      s
    ]
  ), l = ve.useCallback(
    (d) => s(
      (u = []) => u.filter(
        (_) => _ !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ ve.createElement(ape, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: a,
    onItemActivate: c,
    onItemDeactivate: l
  }, /* @__PURE__ */ ve.createElement(cpe, We({}, i, {
    ref: t
  })));
}), [cSc, lSc] = rpe(PA), cpe = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: o = !1, rovingFocus: r = !0, orientation: i, dir: a, loop: s = !0, ...c } = e, l = ipe(n), d = rSc(a), u = {
    role: "group",
    dir: d,
    ...c
  };
  return /* @__PURE__ */ ve.createElement(cSc, {
    scope: n,
    rovingFocus: r,
    disabled: o
  }, r ? /* @__PURE__ */ ve.createElement(Xq, We({
    asChild: !0
  }, l, {
    orientation: i,
    dir: d,
    loop: s
  }), /* @__PURE__ */ ve.createElement(io.div, We({}, u, {
    ref: t
  }))) : /* @__PURE__ */ ve.createElement(io.div, We({}, u, {
    ref: t
  })));
}), yM = "ToggleGroupItem", dSc = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const n = spe(yM, e.__scopeToggleGroup), o = lSc(yM, e.__scopeToggleGroup), r = ipe(e.__scopeToggleGroup), i = n.value.includes(e.value), a = o.disabled || e.disabled, s = {
    ...e,
    pressed: i,
    disabled: a
  }, c = ve.useRef(null);
  return o.rovingFocus ? /* @__PURE__ */ ve.createElement(e9, We({
    asChild: !0
  }, r, {
    focusable: !a,
    active: i,
    ref: c
  }), /* @__PURE__ */ ve.createElement(VK, We({}, s, {
    ref: t
  }))) : /* @__PURE__ */ ve.createElement(VK, We({}, s, {
    ref: t
  }));
}), VK = /* @__PURE__ */ ve.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: o, ...r } = e, i = spe(yM, n), a = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, s = i.type === "single" ? a : void 0;
  return /* @__PURE__ */ ve.createElement(nSc, We({}, s, r, {
    ref: t,
    onPressedChange: (c) => {
      c ? i.onItemActivate(o) : i.onItemDeactivate(o);
    }
  }));
}), uSc = iSc, _Sc = dSc, pSc = ({
  children: e,
  tooltipText: t
}) => t ? /* @__PURE__ */ m(Ao, { delayDuration: 150, sideOffset: 12, side: "bottom", content: t, children: e }) : /* @__PURE__ */ m(Ce, { children: e }), cj = ({
  options: e,
  onValueChange: t,
  isFullWidth: n,
  orientation: o = "horizontal",
  customClassNames: r,
  ...i
}) => /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
  uSc,
  {
    type: "single",
    ...i,
    orientation: o,
    onValueChange: t,
    style: {
      // @ts-expect-error --toggle-group-shadow is not a valid CSS property but can be a variable
      "--toggle-group-shadow": "0px 2px 3px 0px rgba(0, 0, 0, 0.03), 0px 2px 2px -1px rgba(0, 0, 0, 0.03)"
    },
    className: ae(
      "bg-subtle border-subtle rounded-[10px] border p-0.5",
      o === "horizontal" && "inline-flex gap-0.5 rtl:flex-row-reverse",
      o === "vertical" && "flex w-fit flex-col gap-0.5",
      i.className,
      n && "w-full",
      r
    ),
    children: e.map((a) => /* @__PURE__ */ m(pSc, { tooltipText: a.tooltip, children: /* @__PURE__ */ m(
      _Sc,
      {
        disabled: a.disabled,
        value: a.value,
        "data-testid": a.dataTestId ?? `toggle-group-item-${a.value}`,
        className: ae(
          "aria-checked:bg-default aria-checked:border-subtle rounded-lg border border-transparent p-1.5 text-sm leading-none transition aria-checked:shadow-[0px_2px_3px_0px_rgba(0,0,0,0.03),0px_2px_2px_-1px_rgba(0,0,0,0.03)]",
          a.disabled ? "text-gray-400 hover:cursor-not-allowed" : "text-default [&[aria-checked='false']]:hover:text-emphasis",
          n && "w-full"
        ),
        children: /* @__PURE__ */ Y(
          "div",
          {
            className: ae(
              "flex items-center gap-1",
              o === "horizontal" && "justify-center",
              o === "vertical" && "justify-start"
            ),
            children: [
              a.iconLeft && /* @__PURE__ */ m("span", { className: "flex h-4 w-4 items-center", children: a.iconLeft }),
              a.label
            ]
          }
        )
      }
    ) }, a.value))
  }
) });
function Vo(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Nc(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ys(e, t) {
  const n = Vo(e);
  return isNaN(t) ? Nc(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function cd(e, t) {
  const n = Vo(e);
  if (isNaN(t))
    return Nc(e, NaN);
  if (!t)
    return n;
  const o = n.getDate(), r = Nc(e, n.getTime());
  r.setMonth(n.getMonth() + t + 1, 0);
  const i = r.getDate();
  return o >= i ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    o
  ), n);
}
const lj = 6048e5, mSc = 864e5;
let fSc = {};
function ob() {
  return fSc;
}
function cu(e, t) {
  var s, c, l, d;
  const n = ob(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((d = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, r = Vo(e), i = r.getDay(), a = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - a), r.setHours(0, 0, 0, 0), r;
}
function Hf(e) {
  return cu(e, { weekStartsOn: 1 });
}
function lpe(e) {
  const t = Vo(e), n = t.getFullYear(), o = Nc(e, 0);
  o.setFullYear(n + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const r = Hf(o), i = Nc(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Hf(i);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function Mv(e) {
  const t = Vo(e);
  return t.setHours(0, 0, 0, 0), t;
}
function vE(e) {
  const t = Vo(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Qd(e, t) {
  const n = Mv(e), o = Mv(t), r = +n - vE(n), i = +o - vE(o);
  return Math.round((r - i) / mSc);
}
function gSc(e) {
  const t = lpe(e), n = Nc(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Hf(n);
}
function $M(e, t) {
  const n = t * 7;
  return ys(e, n);
}
function hSc(e, t) {
  return cd(e, t * 12);
}
function vSc(e) {
  let t;
  return e.forEach(function(n) {
    const o = Vo(n);
    (t === void 0 || t < o || isNaN(Number(o))) && (t = o);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function bSc(e) {
  let t;
  return e.forEach((n) => {
    const o = Vo(n);
    (!t || t > o || isNaN(+o)) && (t = o);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Qs(e, t) {
  const n = Mv(e), o = Mv(t);
  return +n == +o;
}
function dj(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ySc(e) {
  if (!dj(e) && typeof e != "number")
    return !1;
  const t = Vo(e);
  return !isNaN(Number(t));
}
function Mw(e, t) {
  const n = Vo(e), o = Vo(t), r = n.getFullYear() - o.getFullYear(), i = n.getMonth() - o.getMonth();
  return r * 12 + i;
}
function $Sc(e, t, n) {
  const o = cu(e, n), r = cu(t, n), i = +o - vE(o), a = +r - vE(r);
  return Math.round((i - a) / lj);
}
function uj(e) {
  const t = Vo(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function nc(e) {
  const t = Vo(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function dpe(e) {
  const t = Vo(e), n = Nc(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function _j(e, t) {
  var s, c, l, d;
  const n = ob(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((d = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, r = Vo(e), i = r.getDay(), a = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + a), r.setHours(23, 59, 59, 999), r;
}
function upe(e) {
  return _j(e, { weekStartsOn: 1 });
}
const wSc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, kSc = (e, t, n) => {
  let o;
  const r = wSc[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function W3(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const SSc = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, xSc = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ESc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TSc = {
  date: W3({
    formats: SSc,
    defaultWidth: "full"
  }),
  time: W3({
    formats: xSc,
    defaultWidth: "full"
  }),
  dateTime: W3({
    formats: ESc,
    defaultWidth: "full"
  })
}, ASc = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, CSc = (e, t, n, o) => ASc[e];
function jy(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      r = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[i];
  };
}
const zSc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, OSc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, PSc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ISc = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, RSc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, NSc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, DSc = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, MSc = {
  ordinalNumber: DSc,
  era: jy({
    values: zSc,
    defaultWidth: "wide"
  }),
  quarter: jy({
    values: OSc,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: jy({
    values: PSc,
    defaultWidth: "wide"
  }),
  day: jy({
    values: ISc,
    defaultWidth: "wide"
  }),
  dayPeriod: jy({
    values: RSc,
    defaultWidth: "wide",
    formattingValues: NSc,
    defaultFormattingWidth: "wide"
  })
};
function Fy(e) {
  return (t, n = {}) => {
    const o = n.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], i = t.match(r);
    if (!i)
      return null;
    const a = i[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? qSc(s, (u) => u.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      LSc(s, (u) => u.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(l)
    ) : l;
    const d = t.slice(a.length);
    return { value: l, rest: d };
  };
}
function LSc(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function qSc(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function jSc(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o)
      return null;
    const r = o[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(r.length);
    return { value: a, rest: s };
  };
}
const FSc = /^(\d+)(th|st|nd|rd)?/i, VSc = /\d+/i, BSc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, USc = {
  any: [/^b/i, /^(a|c)/i]
}, WSc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, GSc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HSc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, KSc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, YSc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ZSc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, QSc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, JSc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, XSc = {
  ordinalNumber: jSc({
    matchPattern: FSc,
    parsePattern: VSc,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Fy({
    matchPatterns: BSc,
    defaultMatchWidth: "wide",
    parsePatterns: USc,
    defaultParseWidth: "any"
  }),
  quarter: Fy({
    matchPatterns: WSc,
    defaultMatchWidth: "wide",
    parsePatterns: GSc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Fy({
    matchPatterns: HSc,
    defaultMatchWidth: "wide",
    parsePatterns: KSc,
    defaultParseWidth: "any"
  }),
  day: Fy({
    matchPatterns: YSc,
    defaultMatchWidth: "wide",
    parsePatterns: ZSc,
    defaultParseWidth: "any"
  }),
  dayPeriod: Fy({
    matchPatterns: QSc,
    defaultMatchWidth: "any",
    parsePatterns: JSc,
    defaultParseWidth: "any"
  })
}, _pe = {
  code: "en-US",
  formatDistance: kSc,
  formatLong: TSc,
  formatRelative: CSc,
  localize: MSc,
  match: XSc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function exc(e) {
  const t = Vo(e);
  return Qd(t, dpe(t)) + 1;
}
function ppe(e) {
  const t = Vo(e), n = +Hf(t) - +gSc(t);
  return Math.round(n / lj) + 1;
}
function mpe(e, t) {
  var d, u, _, p;
  const n = Vo(e), o = n.getFullYear(), r = ob(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((p = (_ = r.locale) == null ? void 0 : _.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = Nc(e, 0);
  a.setFullYear(o + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = cu(a, t), c = Nc(e, 0);
  c.setFullYear(o, 0, i), c.setHours(0, 0, 0, 0);
  const l = cu(c, t);
  return n.getTime() >= s.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function txc(e, t) {
  var s, c, l, d;
  const n = ob(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = mpe(e, t), i = Nc(e, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), cu(i, t);
}
function fpe(e, t) {
  const n = Vo(e), o = +cu(n, t) - +txc(n, t);
  return Math.round(o / lj) + 1;
}
function hr(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const ap = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return hr(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : hr(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return hr(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return hr(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return hr(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return hr(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return hr(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return hr(r, t.length);
  }
}, th = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, BK = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return ap.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const r = mpe(e, o), i = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const a = i % 100;
      return hr(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : hr(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = lpe(e);
    return hr(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return hr(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(o);
      case "QQ":
        return hr(o, 2);
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(o);
      case "qq":
        return hr(o, 2);
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ap.M(e, t);
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "L":
        return String(o + 1);
      case "LL":
        return hr(o + 1, 2);
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const r = fpe(e, o);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : hr(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = ppe(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : hr(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ap.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = exc(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : hr(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const r = e.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return hr(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const r = e.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return hr(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), r = o === 0 ? 7 : o;
    switch (t) {
      case "i":
        return String(r);
      case "ii":
        return hr(r, t.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o === 12 ? r = th.noon : o === 0 ? r = th.midnight : r = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let r;
    switch (o >= 17 ? r = th.evening : o >= 12 ? r = th.afternoon : o >= 4 ? r = th.morning : r = th.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return ap.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ap.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : hr(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : hr(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ap.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ap.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ap.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return WK(o);
      case "XXXX":
      case "XX":
        return Hm(o);
      case "XXXXX":
      case "XXX":
      default:
        return Hm(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return WK(o);
      case "xxxx":
      case "xx":
        return Hm(o);
      case "xxxxx":
      case "xxx":
      default:
        return Hm(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + UK(o, ":");
      case "OOOO":
      default:
        return "GMT" + Hm(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + UK(o, ":");
      case "zzzz":
      default:
        return "GMT" + Hm(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(e.getTime() / 1e3);
    return hr(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const o = e.getTime();
    return hr(o, t.length);
  }
};
function UK(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + t + hr(i, 2);
}
function WK(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + hr(Math.abs(e) / 60, 2) : Hm(e, t);
}
function Hm(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = hr(Math.trunc(o / 60), 2), i = hr(o % 60, 2);
  return n + r + t + i;
}
const GK = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, gpe = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, nxc = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return GK(e, t);
  let i;
  switch (o) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", GK(o, t)).replace("{{time}}", gpe(r, t));
}, oxc = {
  p: gpe,
  P: nxc
}, rxc = /^D+$/, ixc = /^Y+$/, axc = ["D", "DD", "YY", "YYYY"];
function sxc(e) {
  return rxc.test(e);
}
function cxc(e) {
  return ixc.test(e);
}
function lxc(e, t, n) {
  const o = dxc(e, t, n);
  if (console.warn(o), axc.includes(e))
    throw new RangeError(o);
}
function dxc(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const uxc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _xc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, pxc = /^'([^]*?)'?$/, mxc = /''/g, fxc = /[a-zA-Z]/;
function P_(e, t, n) {
  var d, u, _, p, f, g, h, b;
  const o = ob(), r = (n == null ? void 0 : n.locale) ?? o.locale ?? _pe, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (_ = o.locale) == null ? void 0 : _.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : g.weekStartsOn) ?? o.weekStartsOn ?? ((b = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = Vo(e);
  if (!ySc(s))
    throw new RangeError("Invalid time value");
  let c = t.match(_xc).map((v) => {
    const $ = v[0];
    if ($ === "p" || $ === "P") {
      const k = oxc[$];
      return k(v, r.formatLong);
    }
    return v;
  }).join("").match(uxc).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const $ = v[0];
    if ($ === "'")
      return { isToken: !1, value: gxc(v) };
    if (BK[$])
      return { isToken: !0, value: v };
    if ($.match(fxc))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + $ + "`"
      );
    return { isToken: !1, value: v };
  });
  r.localize.preprocessor && (c = r.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: r
  };
  return c.map((v) => {
    if (!v.isToken)
      return v.value;
    const $ = v.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && cxc($) || !(n != null && n.useAdditionalDayOfYearTokens) && sxc($)) && lxc($, t, String(e));
    const k = BK[$[0]];
    return k(s, $, r.localize, l);
  }).join("");
}
function gxc(e) {
  const t = e.match(pxc);
  return t ? t[1].replace(mxc, "'") : e;
}
function hxc(e) {
  const t = Vo(e), n = t.getFullYear(), o = t.getMonth(), r = Nc(e, 0);
  return r.setFullYear(n, o + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function vxc() {
  return Object.assign({}, ob());
}
function bxc(e) {
  return Math.trunc(+Vo(e) / 1e3);
}
function yxc(e) {
  const t = Vo(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function $xc(e, t) {
  return $Sc(
    yxc(e),
    nc(e),
    t
  ) + 1;
}
function wM(e, t) {
  const n = Vo(e), o = Vo(t);
  return n.getTime() > o.getTime();
}
function hpe(e, t) {
  const n = Vo(e), o = Vo(t);
  return +n < +o;
}
function pj(e, t) {
  const n = Vo(e), o = Vo(t);
  return n.getFullYear() === o.getFullYear() && n.getMonth() === o.getMonth();
}
function wxc(e, t) {
  const n = Vo(e), o = Vo(t);
  return n.getFullYear() === o.getFullYear();
}
function G3(e, t) {
  return ys(e, -t);
}
function H3(e, t) {
  const n = Vo(e), o = n.getFullYear(), r = n.getDate(), i = Nc(e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const a = hxc(i);
  return n.setMonth(t, Math.min(r, a)), n;
}
function HK(e, t) {
  const n = Vo(e);
  return isNaN(+n) ? Nc(e, NaN) : (n.setFullYear(t), n);
}
var Fn = function() {
  return Fn = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Fn.apply(this, arguments);
};
function kxc(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function vpe(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Q0(e) {
  return e.mode === "multiple";
}
function J0(e) {
  return e.mode === "range";
}
function IA(e) {
  return e.mode === "single";
}
var Sxc = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function xxc(e, t) {
  return P_(e, "LLLL y", t);
}
function Exc(e, t) {
  return P_(e, "d", t);
}
function Txc(e, t) {
  return P_(e, "LLLL", t);
}
function Axc(e) {
  return "".concat(e);
}
function Cxc(e, t) {
  return P_(e, "cccccc", t);
}
function zxc(e, t) {
  return P_(e, "yyyy", t);
}
var Oxc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: xxc,
  formatDay: Exc,
  formatMonthCaption: Txc,
  formatWeekNumber: Axc,
  formatWeekdayName: Cxc,
  formatYearCaption: zxc
}), Pxc = function(e, t, n) {
  return P_(e, "do MMMM (EEEE)", n);
}, Ixc = function() {
  return "Month: ";
}, Rxc = function() {
  return "Go to next month";
}, Nxc = function() {
  return "Go to previous month";
}, Dxc = function(e, t) {
  return P_(e, "cccc", t);
}, Mxc = function(e) {
  return "Week n. ".concat(e);
}, Lxc = function() {
  return "Year: ";
}, qxc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Pxc,
  labelMonthDropdown: Ixc,
  labelNext: Rxc,
  labelPrevious: Nxc,
  labelWeekNumber: Mxc,
  labelWeekday: Dxc,
  labelYearDropdown: Lxc
});
function jxc() {
  var e = "buttons", t = Sxc, n = _pe, o = {}, r = {}, i = 1, a = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: Oxc,
    labels: qxc,
    locale: n,
    modifiersClassNames: o,
    modifiers: r,
    numberOfMonths: i,
    styles: a,
    today: s,
    mode: "default"
  };
}
function Fxc(e) {
  var t = e.fromYear, n = e.toYear, o = e.fromMonth, r = e.toMonth, i = e.fromDate, a = e.toDate;
  return o ? i = nc(o) : t && (i = new Date(t, 0, 1)), r ? a = uj(r) : n && (a = new Date(n, 11, 31)), {
    fromDate: i ? Mv(i) : void 0,
    toDate: a ? Mv(a) : void 0
  };
}
var bpe = No(void 0);
function Vxc(e) {
  var t, n = e.initialProps, o = jxc(), r = Fxc(n), i = r.fromDate, a = r.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : o.captionLayout;
  s !== "buttons" && (!i || !a) && (s = "buttons");
  var c;
  (IA(n) || Q0(n) || J0(n)) && (c = n.onSelect);
  var l = Fn(Fn(Fn({}, o), n), { captionLayout: s, classNames: Fn(Fn({}, o.classNames), n.classNames), components: Fn({}, n.components), formatters: Fn(Fn({}, o.formatters), n.formatters), fromDate: i, labels: Fn(Fn({}, o.labels), n.labels), mode: n.mode || o.mode, modifiers: Fn(Fn({}, o.modifiers), n.modifiers), modifiersClassNames: Fn(Fn({}, o.modifiersClassNames), n.modifiersClassNames), onSelect: c, styles: Fn(Fn({}, o.styles), n.styles), toDate: a });
  return m(bpe.Provider, { value: l, children: e.children });
}
function Vr() {
  var e = Pn(bpe);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function ype(e) {
  var t = Vr(), n = t.locale, o = t.classNames, r = t.styles, i = t.formatters.formatCaption;
  return m("div", { className: o.caption_label, style: r.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: n }) });
}
function Bxc(e) {
  return m("svg", Fn({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: m("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function $pe(e) {
  var t, n, o = e.onChange, r = e.value, i = e.children, a = e.caption, s = e.className, c = e.style, l = Vr(), d = (n = (t = l.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : Bxc;
  return Y("div", { className: s, style: c, children: [m("span", { className: l.classNames.vhidden, children: e["aria-label"] }), m("select", { name: e.name, "aria-label": e["aria-label"], className: l.classNames.dropdown, style: l.styles.dropdown, value: r, onChange: o, children: i }), Y("div", { className: l.classNames.caption_label, style: l.styles.caption_label, "aria-hidden": "true", children: [a, m(d, { className: l.classNames.dropdown_icon, style: l.styles.dropdown_icon })] })] });
}
function Uxc(e) {
  var t, n = Vr(), o = n.fromDate, r = n.toDate, i = n.styles, a = n.locale, s = n.formatters.formatMonthCaption, c = n.classNames, l = n.components, d = n.labels.labelMonthDropdown;
  if (!o)
    return m(Ce, {});
  if (!r)
    return m(Ce, {});
  var u = [];
  if (wxc(o, r))
    for (var _ = nc(o), p = o.getMonth(); p <= r.getMonth(); p++)
      u.push(H3(_, p));
  else
    for (var _ = nc(/* @__PURE__ */ new Date()), p = 0; p <= 11; p++)
      u.push(H3(_, p));
  var f = function(h) {
    var b = Number(h.target.value), v = H3(nc(e.displayMonth), b);
    e.onChange(v);
  }, g = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : $pe;
  return m(g, { name: "months", "aria-label": d(), className: c.dropdown_month, style: i.dropdown_month, onChange: f, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: a }), children: u.map(function(h) {
    return m("option", { value: h.getMonth(), children: s(h, { locale: a }) }, h.getMonth());
  }) });
}
function Wxc(e) {
  var t, n = e.displayMonth, o = Vr(), r = o.fromDate, i = o.toDate, a = o.locale, s = o.styles, c = o.classNames, l = o.components, d = o.formatters.formatYearCaption, u = o.labels.labelYearDropdown, _ = [];
  if (!r)
    return m(Ce, {});
  if (!i)
    return m(Ce, {});
  for (var p = r.getFullYear(), f = i.getFullYear(), g = p; g <= f; g++)
    _.push(HK(dpe(/* @__PURE__ */ new Date()), g));
  var h = function(v) {
    var $ = HK(nc(n), Number(v.target.value));
    e.onChange($);
  }, b = (t = l == null ? void 0 : l.Dropdown) !== null && t !== void 0 ? t : $pe;
  return m(b, { name: "years", "aria-label": u(), className: c.dropdown_year, style: s.dropdown_year, onChange: h, value: n.getFullYear(), caption: d(n, { locale: a }), children: _.map(function(v) {
    return m("option", { value: v.getFullYear(), children: d(v, { locale: a }) }, v.getFullYear());
  }) });
}
function Gxc(e, t) {
  var n = ze(e), o = n[0], r = n[1], i = t === void 0 ? o : t;
  return [i, r];
}
function Hxc(e) {
  var t = e.month, n = e.defaultMonth, o = e.today, r = t || n || o || /* @__PURE__ */ new Date(), i = e.toDate, a = e.fromDate, s = e.numberOfMonths, c = s === void 0 ? 1 : s;
  if (i && Mw(i, r) < 0) {
    var l = -1 * (c - 1);
    r = cd(i, l);
  }
  return a && Mw(r, a) < 0 && (r = a), nc(r);
}
function Kxc() {
  var e = Vr(), t = Hxc(e), n = Gxc(t, e.month), o = n[0], r = n[1], i = function(a) {
    var s;
    if (!e.disableNavigation) {
      var c = nc(a);
      r(c), (s = e.onMonthChange) === null || s === void 0 || s.call(e, c);
    }
  };
  return [o, i];
}
function Yxc(e, t) {
  for (var n = t.reverseMonths, o = t.numberOfMonths, r = nc(e), i = nc(cd(r, o)), a = Mw(i, r), s = [], c = 0; c < a; c++) {
    var l = cd(r, c);
    s.push(l);
  }
  return n && (s = s.reverse()), s;
}
function Zxc(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, o = t.pagedNavigation, r = t.numberOfMonths, i = r === void 0 ? 1 : r, a = o ? i : 1, s = nc(e);
    if (!n)
      return cd(s, a);
    var c = Mw(n, e);
    if (!(c < i))
      return cd(s, a);
  }
}
function Qxc(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, o = t.pagedNavigation, r = t.numberOfMonths, i = r === void 0 ? 1 : r, a = o ? i : 1, s = nc(e);
    if (!n)
      return cd(s, -a);
    var c = Mw(s, n);
    if (!(c <= 0))
      return cd(s, -a);
  }
}
var wpe = No(void 0);
function Jxc(e) {
  var t = Vr(), n = Kxc(), o = n[0], r = n[1], i = Yxc(o, t), a = Zxc(o, t), s = Qxc(o, t), c = function(u) {
    return i.some(function(_) {
      return pj(u, _);
    });
  }, l = function(u, _) {
    c(u) || (_ && hpe(u, _) ? r(cd(u, 1 + t.numberOfMonths * -1)) : r(u));
  }, d = {
    currentMonth: o,
    displayMonths: i,
    goToMonth: r,
    goToDate: l,
    previousMonth: s,
    nextMonth: a,
    isDateDisplayed: c
  };
  return m(wpe.Provider, { value: d, children: e.children });
}
function X0() {
  var e = Pn(wpe);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function KK(e) {
  var t, n = Vr(), o = n.classNames, r = n.styles, i = n.components, a = X0().goToMonth, s = function(d) {
    a(cd(d, e.displayIndex ? -e.displayIndex : 0));
  }, c = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : ype, l = m(c, { id: e.id, displayMonth: e.displayMonth });
  return Y("div", { className: o.caption_dropdowns, style: r.caption_dropdowns, children: [m("div", { className: o.vhidden, children: l }), m(Uxc, { onChange: s, displayMonth: e.displayMonth }), m(Wxc, { onChange: s, displayMonth: e.displayMonth })] });
}
function Xxc(e) {
  return m("svg", Fn({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function eEc(e) {
  return m("svg", Fn({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: m("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var bE = it(function(e, t) {
  var n = Vr(), o = n.classNames, r = n.styles, i = [o.button_reset, o.button];
  e.className && i.push(e.className);
  var a = i.join(" "), s = Fn(Fn({}, r.button_reset), r.button);
  return e.style && Object.assign(s, e.style), m("button", Fn({}, e, { ref: t, type: "button", className: a, style: s }));
});
function tEc(e) {
  var t, n, o = Vr(), r = o.dir, i = o.locale, a = o.classNames, s = o.styles, c = o.labels, l = c.labelPrevious, d = c.labelNext, u = o.components;
  if (!e.nextMonth && !e.previousMonth)
    return m(Ce, {});
  var _ = l(e.previousMonth, { locale: i }), p = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), f = d(e.nextMonth, { locale: i }), g = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), h = (t = u == null ? void 0 : u.IconRight) !== null && t !== void 0 ? t : eEc, b = (n = u == null ? void 0 : u.IconLeft) !== null && n !== void 0 ? n : Xxc;
  return Y("div", { className: a.nav, style: s.nav, children: [!e.hidePrevious && m(bE, { name: "previous-month", "aria-label": _, className: p, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: r === "rtl" ? m(h, { className: a.nav_icon, style: s.nav_icon }) : m(b, { className: a.nav_icon, style: s.nav_icon }) }), !e.hideNext && m(bE, { name: "next-month", "aria-label": f, className: g, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: r === "rtl" ? m(b, { className: a.nav_icon, style: s.nav_icon }) : m(h, { className: a.nav_icon, style: s.nav_icon }) })] });
}
function YK(e) {
  var t = Vr().numberOfMonths, n = X0(), o = n.previousMonth, r = n.nextMonth, i = n.goToMonth, a = n.displayMonths, s = a.findIndex(function(f) {
    return pj(e.displayMonth, f);
  }), c = s === 0, l = s === a.length - 1, d = t > 1 && (c || !l), u = t > 1 && (l || !c), _ = function() {
    o && i(o);
  }, p = function() {
    r && i(r);
  };
  return m(tEc, { displayMonth: e.displayMonth, hideNext: d, hidePrevious: u, nextMonth: r, previousMonth: o, onPreviousClick: _, onNextClick: p });
}
function nEc(e) {
  var t, n = Vr(), o = n.classNames, r = n.disableNavigation, i = n.styles, a = n.captionLayout, s = n.components, c = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : ype, l;
  return r ? l = m(c, { id: e.id, displayMonth: e.displayMonth }) : a === "dropdown" ? l = m(KK, { displayMonth: e.displayMonth, id: e.id }) : a === "dropdown-buttons" ? l = Y(Ce, { children: [m(KK, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), m(YK, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : l = Y(Ce, { children: [m(c, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(YK, { displayMonth: e.displayMonth, id: e.id })] }), m("div", { className: o.caption, style: i.caption, children: l });
}
function oEc(e) {
  var t = Vr(), n = t.footer, o = t.styles, r = t.classNames.tfoot;
  return n ? m("tfoot", { className: r, style: o.tfoot, children: m("tr", { children: m("td", { colSpan: 8, children: n }) }) }) : m(Ce, {});
}
function rEc(e, t, n) {
  for (var o = n ? Hf(/* @__PURE__ */ new Date()) : cu(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), r = [], i = 0; i < 7; i++) {
    var a = ys(o, i);
    r.push(a);
  }
  return r;
}
function iEc() {
  var e = Vr(), t = e.classNames, n = e.styles, o = e.showWeekNumber, r = e.locale, i = e.weekStartsOn, a = e.ISOWeek, s = e.formatters.formatWeekdayName, c = e.labels.labelWeekday, l = rEc(r, i, a);
  return Y("tr", { style: n.head_row, className: t.head_row, children: [o && m("td", { style: n.head_cell, className: t.head_cell }), l.map(function(d, u) {
    return m("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": c(d, { locale: r }), children: s(d, { locale: r }) }, u);
  })] });
}
function aEc() {
  var e, t = Vr(), n = t.classNames, o = t.styles, r = t.components, i = (e = r == null ? void 0 : r.HeadRow) !== null && e !== void 0 ? e : iEc;
  return m("thead", { style: o.head, className: n.head, children: m(i, {}) });
}
function sEc(e) {
  var t = Vr(), n = t.locale, o = t.formatters.formatDay;
  return m(Ce, { children: o(e.date, { locale: n }) });
}
var mj = No(void 0);
function cEc(e) {
  if (!Q0(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return m(mj.Provider, { value: t, children: e.children });
  }
  return m(lEc, { initialProps: e.initialProps, children: e.children });
}
function lEc(e) {
  var t = e.initialProps, n = e.children, o = t.selected, r = t.min, i = t.max, a = function(l, d, u) {
    var _, p;
    (_ = t.onDayClick) === null || _ === void 0 || _.call(t, l, d, u);
    var f = !!(d.selected && r && (o == null ? void 0 : o.length) === r);
    if (!f) {
      var g = !!(!d.selected && i && (o == null ? void 0 : o.length) === i);
      if (!g) {
        var h = o ? vpe([], o, !0) : [];
        if (d.selected) {
          var b = h.findIndex(function(v) {
            return Qs(l, v);
          });
          h.splice(b, 1);
        } else
          h.push(l);
        (p = t.onSelect) === null || p === void 0 || p.call(t, h, l, d, u);
      }
    }
  }, s = {
    disabled: []
  };
  o && s.disabled.push(function(l) {
    var d = i && o.length > i - 1, u = o.some(function(_) {
      return Qs(_, l);
    });
    return !!(d && !u);
  });
  var c = {
    selected: o,
    onDayClick: a,
    modifiers: s
  };
  return m(mj.Provider, { value: c, children: n });
}
function fj() {
  var e = Pn(mj);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function dEc(e, t) {
  var n = t || {}, o = n.from, r = n.to;
  return o && r ? Qs(r, e) && Qs(o, e) ? void 0 : Qs(r, e) ? { from: r, to: void 0 } : Qs(o, e) ? void 0 : wM(o, e) ? { from: e, to: r } : { from: o, to: e } : r ? wM(e, r) ? { from: r, to: e } : { from: e, to: r } : o ? hpe(e, o) ? { from: e, to: o } : { from: o, to: e } : { from: e, to: void 0 };
}
var gj = No(void 0);
function uEc(e) {
  if (!J0(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return m(gj.Provider, { value: t, children: e.children });
  }
  return m(_Ec, { initialProps: e.initialProps, children: e.children });
}
function _Ec(e) {
  var t = e.initialProps, n = e.children, o = t.selected, r = o || {}, i = r.from, a = r.to, s = t.min, c = t.max, l = function(p, f, g) {
    var h, b;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, p, f, g);
    var v = dEc(p, o);
    (b = t.onSelect) === null || b === void 0 || b.call(t, v, p, f, g);
  }, d = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (d.range_start = [i], a ? (d.range_end = [a], Qs(i, a) || (d.range_middle = [
    {
      after: i,
      before: a
    }
  ])) : d.range_end = [i]) : a && (d.range_start = [a], d.range_end = [a]), s && (i && !a && d.disabled.push({
    after: G3(i, s - 1),
    before: ys(i, s - 1)
  }), i && a && d.disabled.push({
    after: i,
    before: ys(i, s - 1)
  }), !i && a && d.disabled.push({
    after: G3(a, s - 1),
    before: ys(a, s - 1)
  })), c) {
    if (i && !a && (d.disabled.push({
      before: ys(i, -c + 1)
    }), d.disabled.push({
      after: ys(i, c - 1)
    })), i && a) {
      var u = Qd(a, i) + 1, _ = c - u;
      d.disabled.push({
        before: G3(i, _)
      }), d.disabled.push({
        after: ys(a, _)
      });
    }
    !i && a && (d.disabled.push({
      before: ys(a, -c + 1)
    }), d.disabled.push({
      after: ys(a, c - 1)
    }));
  }
  return m(gj.Provider, { value: { selected: o, onDayClick: l, modifiers: d }, children: n });
}
function hj() {
  var e = Pn(gj);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function ex(e) {
  return Array.isArray(e) ? vpe([], e, !0) : e !== void 0 ? [e] : [];
}
function pEc(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var o = n[0], r = n[1];
    t[o] = ex(r);
  }), t;
}
var ld;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ld || (ld = {}));
var mEc = ld.Selected, Vu = ld.Disabled, fEc = ld.Hidden, gEc = ld.Today, K3 = ld.RangeEnd, Y3 = ld.RangeMiddle, Z3 = ld.RangeStart, hEc = ld.Outside;
function vEc(e, t, n) {
  var o, r = (o = {}, o[mEc] = ex(e.selected), o[Vu] = ex(e.disabled), o[fEc] = ex(e.hidden), o[gEc] = [e.today], o[K3] = [], o[Y3] = [], o[Z3] = [], o[hEc] = [], o);
  return e.fromDate && r[Vu].push({ before: e.fromDate }), e.toDate && r[Vu].push({ after: e.toDate }), Q0(e) ? r[Vu] = r[Vu].concat(t.modifiers[Vu]) : J0(e) && (r[Vu] = r[Vu].concat(n.modifiers[Vu]), r[Z3] = n.modifiers[Z3], r[Y3] = n.modifiers[Y3], r[K3] = n.modifiers[K3]), r;
}
var kpe = No(void 0);
function bEc(e) {
  var t = Vr(), n = fj(), o = hj(), r = vEc(t, n, o), i = pEc(t.modifiers), a = Fn(Fn({}, r), i);
  return m(kpe.Provider, { value: a, children: e.children });
}
function Spe() {
  var e = Pn(kpe);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function yEc(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function $Ec(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function wEc(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function kEc(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function SEc(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function xEc(e, t) {
  var n, o = t.from, r = t.to;
  if (o && r) {
    var i = Qd(r, o) < 0;
    i && (n = [r, o], o = n[0], r = n[1]);
    var a = Qd(e, o) >= 0 && Qd(r, e) >= 0;
    return a;
  }
  return r ? Qs(r, e) : o ? Qs(o, e) : !1;
}
function EEc(e) {
  return dj(e);
}
function TEc(e) {
  return Array.isArray(e) && e.every(dj);
}
function AEc(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (EEc(n))
      return Qs(e, n);
    if (TEc(n))
      return n.includes(e);
    if ($Ec(n))
      return xEc(e, n);
    if (SEc(n))
      return n.dayOfWeek.includes(e.getDay());
    if (yEc(n)) {
      var o = Qd(n.before, e), r = Qd(n.after, e), i = o > 0, a = r < 0, s = wM(n.before, n.after);
      return s ? a && i : i || a;
    }
    return wEc(n) ? Qd(e, n.after) > 0 : kEc(n) ? Qd(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function vj(e, t, n) {
  var o = Object.keys(t).reduce(function(i, a) {
    var s = t[a];
    return AEc(e, s) && i.push(a), i;
  }, []), r = {};
  return o.forEach(function(i) {
    return r[i] = !0;
  }), n && !pj(e, n) && (r.outside = !0), r;
}
function CEc(e, t) {
  for (var n = nc(e[0]), o = uj(e[e.length - 1]), r, i, a = n; a <= o; ) {
    var s = vj(a, t), c = !s.disabled && !s.hidden;
    if (!c) {
      a = ys(a, 1);
      continue;
    }
    if (s.selected)
      return a;
    s.today && !i && (i = a), r || (r = a), a = ys(a, 1);
  }
  return i || r;
}
var zEc = 365;
function xpe(e, t) {
  var n = t.moveBy, o = t.direction, r = t.context, i = t.modifiers, a = t.retry, s = a === void 0 ? { count: 0, lastFocused: e } : a, c = r.weekStartsOn, l = r.fromDate, d = r.toDate, u = r.locale, _ = {
    day: ys,
    week: $M,
    month: cd,
    year: hSc,
    startOfWeek: function(h) {
      return r.ISOWeek ? Hf(h) : cu(h, { locale: u, weekStartsOn: c });
    },
    endOfWeek: function(h) {
      return r.ISOWeek ? upe(h) : _j(h, { locale: u, weekStartsOn: c });
    }
  }, p = _[n](e, o === "after" ? 1 : -1);
  o === "before" && l ? p = vSc([l, p]) : o === "after" && d && (p = bSc([d, p]));
  var f = !0;
  if (i) {
    var g = vj(p, i);
    f = !g.disabled && !g.hidden;
  }
  return f ? p : s.count > zEc ? s.lastFocused : xpe(p, {
    moveBy: n,
    direction: o,
    context: r,
    modifiers: i,
    retry: Fn(Fn({}, s), { count: s.count + 1 })
  });
}
var Epe = No(void 0);
function OEc(e) {
  var t = X0(), n = Spe(), o = ze(), r = o[0], i = o[1], a = ze(), s = a[0], c = a[1], l = CEc(t.displayMonths, n), d = r ?? (s && t.isDateDisplayed(s)) ? s : l, u = function() {
    c(r), i(void 0);
  }, _ = function(h) {
    i(h);
  }, p = Vr(), f = function(h, b) {
    if (r) {
      var v = xpe(r, {
        moveBy: h,
        direction: b,
        context: p,
        modifiers: n
      });
      Qs(r, v) || (t.goToDate(v, r), _(v));
    }
  }, g = {
    focusedDay: r,
    focusTarget: d,
    blur: u,
    focus: _,
    focusDayAfter: function() {
      return f("day", "after");
    },
    focusDayBefore: function() {
      return f("day", "before");
    },
    focusWeekAfter: function() {
      return f("week", "after");
    },
    focusWeekBefore: function() {
      return f("week", "before");
    },
    focusMonthBefore: function() {
      return f("month", "before");
    },
    focusMonthAfter: function() {
      return f("month", "after");
    },
    focusYearBefore: function() {
      return f("year", "before");
    },
    focusYearAfter: function() {
      return f("year", "after");
    },
    focusStartOfWeek: function() {
      return f("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return f("endOfWeek", "after");
    }
  };
  return m(Epe.Provider, { value: g, children: e.children });
}
function bj() {
  var e = Pn(Epe);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function PEc(e, t) {
  var n = Spe(), o = vj(e, n, t);
  return o;
}
var yj = No(void 0);
function IEc(e) {
  if (!IA(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return m(yj.Provider, { value: t, children: e.children });
  }
  return m(REc, { initialProps: e.initialProps, children: e.children });
}
function REc(e) {
  var t = e.initialProps, n = e.children, o = function(i, a, s) {
    var c, l, d;
    if ((c = t.onDayClick) === null || c === void 0 || c.call(t, i, a, s), a.selected && !t.required) {
      (l = t.onSelect) === null || l === void 0 || l.call(t, void 0, i, a, s);
      return;
    }
    (d = t.onSelect) === null || d === void 0 || d.call(t, i, i, a, s);
  }, r = {
    selected: t.selected,
    onDayClick: o
  };
  return m(yj.Provider, { value: r, children: n });
}
function Tpe() {
  var e = Pn(yj);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function NEc(e, t) {
  var n = Vr(), o = Tpe(), r = fj(), i = hj(), a = bj(), s = a.focusDayAfter, c = a.focusDayBefore, l = a.focusWeekAfter, d = a.focusWeekBefore, u = a.blur, _ = a.focus, p = a.focusMonthBefore, f = a.focusMonthAfter, g = a.focusYearBefore, h = a.focusYearAfter, b = a.focusStartOfWeek, v = a.focusEndOfWeek, $ = function(z) {
    var j, q, V, F;
    IA(n) ? (j = o.onDayClick) === null || j === void 0 || j.call(o, e, t, z) : Q0(n) ? (q = r.onDayClick) === null || q === void 0 || q.call(r, e, t, z) : J0(n) ? (V = i.onDayClick) === null || V === void 0 || V.call(i, e, t, z) : (F = n.onDayClick) === null || F === void 0 || F.call(n, e, t, z);
  }, k = function(z) {
    var j;
    _(e), (j = n.onDayFocus) === null || j === void 0 || j.call(n, e, t, z);
  }, S = function(z) {
    var j;
    u(), (j = n.onDayBlur) === null || j === void 0 || j.call(n, e, t, z);
  }, O = function(z) {
    var j;
    (j = n.onDayMouseEnter) === null || j === void 0 || j.call(n, e, t, z);
  }, I = function(z) {
    var j;
    (j = n.onDayMouseLeave) === null || j === void 0 || j.call(n, e, t, z);
  }, D = function(z) {
    var j;
    (j = n.onDayPointerEnter) === null || j === void 0 || j.call(n, e, t, z);
  }, M = function(z) {
    var j;
    (j = n.onDayPointerLeave) === null || j === void 0 || j.call(n, e, t, z);
  }, N = function(z) {
    var j;
    (j = n.onDayTouchCancel) === null || j === void 0 || j.call(n, e, t, z);
  }, C = function(z) {
    var j;
    (j = n.onDayTouchEnd) === null || j === void 0 || j.call(n, e, t, z);
  }, P = function(z) {
    var j;
    (j = n.onDayTouchMove) === null || j === void 0 || j.call(n, e, t, z);
  }, x = function(z) {
    var j;
    (j = n.onDayTouchStart) === null || j === void 0 || j.call(n, e, t, z);
  }, w = function(z) {
    var j;
    (j = n.onDayKeyUp) === null || j === void 0 || j.call(n, e, t, z);
  }, E = function(z) {
    var j;
    switch (z.key) {
      case "ArrowLeft":
        z.preventDefault(), z.stopPropagation(), n.dir === "rtl" ? s() : c();
        break;
      case "ArrowRight":
        z.preventDefault(), z.stopPropagation(), n.dir === "rtl" ? c() : s();
        break;
      case "ArrowDown":
        z.preventDefault(), z.stopPropagation(), l();
        break;
      case "ArrowUp":
        z.preventDefault(), z.stopPropagation(), d();
        break;
      case "PageUp":
        z.preventDefault(), z.stopPropagation(), z.shiftKey ? g() : p();
        break;
      case "PageDown":
        z.preventDefault(), z.stopPropagation(), z.shiftKey ? h() : f();
        break;
      case "Home":
        z.preventDefault(), z.stopPropagation(), b();
        break;
      case "End":
        z.preventDefault(), z.stopPropagation(), v();
        break;
    }
    (j = n.onDayKeyDown) === null || j === void 0 || j.call(n, e, t, z);
  }, T = {
    onClick: $,
    onFocus: k,
    onBlur: S,
    onKeyDown: E,
    onKeyUp: w,
    onMouseEnter: O,
    onMouseLeave: I,
    onPointerEnter: D,
    onPointerLeave: M,
    onTouchCancel: N,
    onTouchEnd: C,
    onTouchMove: P,
    onTouchStart: x
  };
  return T;
}
function DEc() {
  var e = Vr(), t = Tpe(), n = fj(), o = hj(), r = IA(e) ? t.selected : Q0(e) ? n.selected : J0(e) ? o.selected : void 0;
  return r;
}
function MEc(e) {
  return Object.values(ld).includes(e);
}
function LEc(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(o) {
    var r = e.modifiersClassNames[o];
    if (r)
      n.push(r);
    else if (MEc(o)) {
      var i = e.classNames["day_".concat(o)];
      i && n.push(i);
    }
  }), n;
}
function qEc(e, t) {
  var n = Fn({}, e.styles.day);
  return Object.keys(t).forEach(function(o) {
    var r;
    n = Fn(Fn({}, n), (r = e.modifiersStyles) === null || r === void 0 ? void 0 : r[o]);
  }), n;
}
function jEc(e, t, n) {
  var o, r, i, a = Vr(), s = bj(), c = PEc(e, t), l = NEc(e, c), d = DEc(), u = !!(a.onDayClick || a.mode !== "default");
  Le(function() {
    var O;
    c.outside || s.focusedDay && u && Qs(s.focusedDay, e) && ((O = n.current) === null || O === void 0 || O.focus());
  }, [
    s.focusedDay,
    e,
    n,
    u,
    c.outside
  ]);
  var _ = LEc(a, c).join(" "), p = qEc(a, c), f = !!(c.outside && !a.showOutsideDays || c.hidden), g = (i = (r = a.components) === null || r === void 0 ? void 0 : r.DayContent) !== null && i !== void 0 ? i : sEc, h = m(g, { date: e, displayMonth: t, activeModifiers: c }), b = {
    style: p,
    className: _,
    children: h,
    role: "gridcell"
  }, v = s.focusTarget && Qs(s.focusTarget, e) && !c.outside, $ = s.focusedDay && Qs(s.focusedDay, e), k = Fn(Fn(Fn({}, b), (o = { disabled: c.disabled, role: "gridcell" }, o["aria-selected"] = c.selected, o.tabIndex = $ || v ? 0 : -1, o)), l), S = {
    isButton: u,
    isHidden: f,
    activeModifiers: c,
    selectedDays: d,
    buttonProps: k,
    divProps: b
  };
  return S;
}
function FEc(e) {
  var t = Ue(null), n = jEc(e.date, e.displayMonth, t);
  return n.isHidden ? m("div", { role: "gridcell" }) : n.isButton ? m(bE, Fn({ name: "day", ref: t }, n.buttonProps)) : m("div", Fn({}, n.divProps));
}
function VEc(e) {
  var t = e.number, n = e.dates, o = Vr(), r = o.onWeekNumberClick, i = o.styles, a = o.classNames, s = o.locale, c = o.labels.labelWeekNumber, l = o.formatters.formatWeekNumber, d = l(Number(t), { locale: s });
  if (!r)
    return m("span", { className: a.weeknumber, style: i.weeknumber, children: d });
  var u = c(Number(t), { locale: s }), _ = function(p) {
    r(t, n, p);
  };
  return m(bE, { name: "week-number", "aria-label": u, className: a.weeknumber, style: i.weeknumber, onClick: _, children: d });
}
function BEc(e) {
  var t, n, o = Vr(), r = o.styles, i = o.classNames, a = o.showWeekNumber, s = o.components, c = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : FEc, l = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : VEc, d;
  return a && (d = m("td", { className: i.cell, style: r.cell, children: m(l, { number: e.weekNumber, dates: e.dates }) })), Y("tr", { className: i.row, style: r.row, children: [d, e.dates.map(function(u) {
    return m("td", { className: i.cell, style: r.cell, role: "presentation", children: m(c, { displayMonth: e.displayMonth, date: u }) }, bxc(u));
  })] });
}
function ZK(e, t, n) {
  for (var o = n != null && n.ISOWeek ? upe(t) : _j(t, n), r = n != null && n.ISOWeek ? Hf(e) : cu(e, n), i = Qd(o, r), a = [], s = 0; s <= i; s++)
    a.push(ys(r, s));
  var c = a.reduce(function(l, d) {
    var u = n != null && n.ISOWeek ? ppe(d) : fpe(d, n), _ = l.find(function(p) {
      return p.weekNumber === u;
    });
    return _ ? (_.dates.push(d), l) : (l.push({
      weekNumber: u,
      dates: [d]
    }), l);
  }, []);
  return c;
}
function UEc(e, t) {
  var n = ZK(nc(e), uj(e), t);
  if (t != null && t.useFixedWeeks) {
    var o = $xc(e, t);
    if (o < 6) {
      var r = n[n.length - 1], i = r.dates[r.dates.length - 1], a = $M(i, 6 - o), s = ZK($M(i, 1), a, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function WEc(e) {
  var t, n, o, r = Vr(), i = r.locale, a = r.classNames, s = r.styles, c = r.hideHead, l = r.fixedWeeks, d = r.components, u = r.weekStartsOn, _ = r.firstWeekContainsDate, p = r.ISOWeek, f = UEc(e.displayMonth, {
    useFixedWeeks: !!l,
    ISOWeek: p,
    locale: i,
    weekStartsOn: u,
    firstWeekContainsDate: _
  }), g = (t = d == null ? void 0 : d.Head) !== null && t !== void 0 ? t : aEc, h = (n = d == null ? void 0 : d.Row) !== null && n !== void 0 ? n : BEc, b = (o = d == null ? void 0 : d.Footer) !== null && o !== void 0 ? o : oEc;
  return Y("table", { id: e.id, className: a.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!c && m(g, {}), m("tbody", { className: a.tbody, style: s.tbody, children: f.map(function(v) {
    return m(h, { displayMonth: e.displayMonth, dates: v.dates, weekNumber: v.weekNumber }, v.weekNumber);
  }) }), m(b, { displayMonth: e.displayMonth })] });
}
function GEc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var HEc = GEc() ? ts : Le, Q3 = !1, KEc = 0;
function QK() {
  return "react-day-picker-".concat(++KEc);
}
function YEc(e) {
  var t, n = e ?? (Q3 ? QK() : null), o = ze(n), r = o[0], i = o[1];
  return HEc(function() {
    r === null && i(QK());
  }, []), Le(function() {
    Q3 === !1 && (Q3 = !0);
  }, []), (t = e ?? r) !== null && t !== void 0 ? t : void 0;
}
function ZEc(e) {
  var t, n, o = Vr(), r = o.dir, i = o.classNames, a = o.styles, s = o.components, c = X0().displayMonths, l = YEc(o.id ? "".concat(o.id, "-").concat(e.displayIndex) : void 0), d = o.id ? "".concat(o.id, "-grid-").concat(e.displayIndex) : void 0, u = [i.month], _ = a.month, p = e.displayIndex === 0, f = e.displayIndex === c.length - 1, g = !p && !f;
  r === "rtl" && (t = [p, f], f = t[0], p = t[1]), p && (u.push(i.caption_start), _ = Fn(Fn({}, _), a.caption_start)), f && (u.push(i.caption_end), _ = Fn(Fn({}, _), a.caption_end)), g && (u.push(i.caption_between), _ = Fn(Fn({}, _), a.caption_between));
  var h = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : nEc;
  return Y("div", { className: u.join(" "), style: _, children: [m(h, { id: l, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), m(WEc, { id: d, "aria-labelledby": l, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function QEc(e) {
  var t = Vr(), n = t.classNames, o = t.styles;
  return m("div", { className: n.months, style: o.months, children: e.children });
}
function JEc(e) {
  var t, n, o = e.initialProps, r = Vr(), i = bj(), a = X0(), s = ze(!1), c = s[0], l = s[1];
  Le(function() {
    r.initialFocus && i.focusTarget && (c || (i.focus(i.focusTarget), l(!0)));
  }, [
    r.initialFocus,
    c,
    i.focus,
    i.focusTarget,
    i
  ]);
  var d = [r.classNames.root, r.className];
  r.numberOfMonths > 1 && d.push(r.classNames.multiple_months), r.showWeekNumber && d.push(r.classNames.with_weeknumber);
  var u = Fn(Fn({}, r.styles.root), r.style), _ = Object.keys(o).filter(function(f) {
    return f.startsWith("data-");
  }).reduce(function(f, g) {
    var h;
    return Fn(Fn({}, f), (h = {}, h[g] = o[g], h));
  }, {}), p = (n = (t = o.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : QEc;
  return m("div", Fn({ className: d.join(" "), style: u, dir: r.dir, id: r.id, nonce: o.nonce, title: o.title, lang: o.lang }, _, { children: m(p, { children: a.displayMonths.map(function(f, g) {
    return m(ZEc, { displayIndex: g, displayMonth: f }, g);
  }) }) }));
}
function XEc(e) {
  var t = e.children, n = kxc(e, ["children"]);
  return m(Vxc, { initialProps: n, children: m(Jxc, { children: m(IEc, { initialProps: n, children: m(cEc, { initialProps: n, children: m(uEc, { initialProps: n, children: m(bEc, { children: m(OEc, { children: t }) }) }) }) }) }) });
}
function eTc(e) {
  return m(XEc, Fn({}, e, { children: m(JEc, { initialProps: e }) }));
}
function Ape({
  className: e,
  classNames: t,
  fromDate: n,
  toDate: o,
  showOutsideDays: r = !0,
  ...i
}) {
  return /* @__PURE__ */ m(
    eTc,
    {
      fromDate: n,
      toDate: o || void 0,
      showOutsideDays: r,
      className: ae("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex pt-1 relative items-center justify-between",
        caption_label: "text-sm font-medium",
        nav: "flex items-center",
        head: "",
        head_row: "flex w-full items-center justify-between",
        head_cell: "w-8 md:w-11 h-8 text-sm font-medium text-default text-center",
        nav_button: ae(Cx({ color: "minimal", variant: "icon" })),
        table: "w-full border-collapse space-y-1",
        row: "flex w-full mt-0.5 gap-0.5",
        cell: "w-8 h-8 md:h-11 md:w-11 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: ae(
          Cx({ color: "minimal" }),
          "w-8 h-8 md:h-11 md:w-11 p-0 text-sm font-medium aria-selected:opacity-100 inline-flex items-center justify-center"
        ),
        day_range_end: "hover:!bg-inverted hover:!text-inverted",
        day_range_start: "hover:!bg-inverted hover:!text-inverted",
        day_selected: "bg-inverted text-inverted",
        day_today: "",
        day_outside: "",
        day_disabled: "text-muted opacity-50",
        day_range_middle: "aria-selected:bg-emphasis aria-selected:text-emphasis",
        day_hidden: "invisible",
        ...t
      },
      components: {
        CaptionLabel: (a) => /* @__PURE__ */ Y("div", { className: "px-2", children: [
          /* @__PURE__ */ Y("span", { className: "text-emphasis font-semibold leading-none", children: [
            De(a.displayMonth).format("MMMM"),
            " "
          ] }),
          /* @__PURE__ */ m("span", { className: "text-subtle font-medium leading-none", children: De(a.displayMonth).format("YYYY") })
        ] }),
        IconLeft: () => /* @__PURE__ */ m(ot, { name: "chevron-left", className: "h-4 w-4 stroke-2" }),
        IconRight: () => /* @__PURE__ */ m(ot, { name: "chevron-right", className: "h-4 w-4 stroke-2" })
      },
      ...i
    }
  );
}
Ape.displayName = "Calendar";
const tTc = ({ minDate: e, disabled: t, date: n, onDatesChange: o, className: r }) => {
  function i(c) {
    o == null || o(c ?? /* @__PURE__ */ new Date());
  }
  const s = /* @__PURE__ */ m(
    Ape,
    {
      initialFocus: !0,
      fromDate: e === null ? void 0 : e ?? /* @__PURE__ */ new Date(),
      mode: "single",
      defaultMonth: n,
      selected: n,
      onDayClick: (c) => i(c),
      numberOfMonths: 1,
      disabled: t
    }
  );
  return /* @__PURE__ */ m("div", { className: ae("grid gap-2", r), children: /* @__PURE__ */ Y(tpe, { children: [
    /* @__PURE__ */ m(npe, { asChild: !0, children: /* @__PURE__ */ m(
      ut,
      {
        "data-testid": "pick-date",
        color: "secondary",
        EndIcon: "calendar",
        className: ae("justify-between text-left font-normal", !n && "text-subtle"),
        children: n ? /* @__PURE__ */ m(Ce, { children: P_(n, "LLL dd, y") }) : /* @__PURE__ */ m("span", { children: "Pick a date" })
      }
    ) }),
    /* @__PURE__ */ m(
      ope,
      {
        className: "bg-default text-emphasis z-50 w-auto rounded-md border p-0 outline-none",
        align: "start",
        sideOffset: 4,
        children: s
      }
    )
  ] }) });
}, nTc = tTc;
function rb() {
  return (rb = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }).apply(this, arguments);
}
function RA(e, t) {
  if (e == null)
    return {};
  var n, o, r = {}, i = Object.keys(e);
  for (o = 0; o < i.length; o++)
    t.indexOf(n = i[o]) >= 0 || (r[n] = e[n]);
  return r;
}
function Lw(e) {
  var t = Ue(e), n = Ue(function(o) {
    t.current && t.current(o);
  });
  return t.current = e, n.current;
}
var qw = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, M$ = function(e) {
  return "touches" in e;
}, kM = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, JK = function(e, t, n) {
  var o = e.getBoundingClientRect(), r = M$(t) ? function(i, a) {
    for (var s = 0; s < i.length; s++)
      if (i[s].identifier === a)
        return i[s];
    return i[0];
  }(t.touches, n) : t;
  return { left: qw((r.pageX - (o.left + kM(e).pageXOffset)) / o.width), top: qw((r.pageY - (o.top + kM(e).pageYOffset)) / o.height) };
}, XK = function(e) {
  !M$(e) && e.preventDefault();
}, Cpe = ve.memo(function(e) {
  var t = e.onMove, n = e.onKey, o = RA(e, ["onMove", "onKey"]), r = Ue(null), i = Lw(t), a = Lw(n), s = Ue(null), c = Ue(!1), l = Tt(function() {
    var p = function(h) {
      XK(h), (M$(h) ? h.touches.length > 0 : h.buttons > 0) && r.current ? i(JK(r.current, h, s.current)) : g(!1);
    }, f = function() {
      return g(!1);
    };
    function g(h) {
      var b = c.current, v = kM(r.current), $ = h ? v.addEventListener : v.removeEventListener;
      $(b ? "touchmove" : "mousemove", p), $(b ? "touchend" : "mouseup", f);
    }
    return [function(h) {
      var b = h.nativeEvent, v = r.current;
      if (v && (XK(b), !function(k, S) {
        return S && !M$(k);
      }(b, c.current) && v)) {
        if (M$(b)) {
          c.current = !0;
          var $ = b.changedTouches || [];
          $.length && (s.current = $[0].identifier);
        }
        v.focus(), i(JK(v, b, s.current)), g(!0);
      }
    }, function(h) {
      var b = h.which || h.keyCode;
      b < 37 || b > 40 || (h.preventDefault(), a({ left: b === 39 ? 0.05 : b === 37 ? -0.05 : 0, top: b === 40 ? 0.05 : b === 38 ? -0.05 : 0 }));
    }, g];
  }, [a, i]), d = l[0], u = l[1], _ = l[2];
  return Le(function() {
    return _;
  }, [_]), ve.createElement("div", rb({}, o, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: r, onKeyDown: u, tabIndex: 0, role: "slider" }));
}), $j = function(e) {
  return e.filter(Boolean).join(" ");
}, zpe = function(e) {
  var t = e.color, n = e.left, o = e.top, r = o === void 0 ? 0.5 : o, i = $j(["react-colorful__pointer", e.className]);
  return ve.createElement("div", { className: i, style: { top: 100 * r + "%", left: 100 * n + "%" } }, ve.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, xa = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, oTc = function(e) {
  return cTc(SM(e));
}, SM = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? xa(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? xa(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, rTc = function(e) {
  return sTc(aTc(e));
}, iTc = function(e) {
  var t = e.s, n = e.v, o = e.a, r = (200 - t) * n / 100;
  return { h: xa(e.h), s: xa(r > 0 && r < 200 ? t * n / 100 / (r <= 100 ? r : 200 - r) * 100 : 0), l: xa(r / 2), a: xa(o, 2) };
}, xM = function(e) {
  var t = iTc(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, aTc = function(e) {
  var t = e.h, n = e.s, o = e.v, r = e.a;
  t = t / 360 * 6, n /= 100, o /= 100;
  var i = Math.floor(t), a = o * (1 - n), s = o * (1 - (t - i) * n), c = o * (1 - (1 - t + i) * n), l = i % 6;
  return { r: xa(255 * [o, s, a, a, c, o][l]), g: xa(255 * [c, o, o, s, a, a][l]), b: xa(255 * [a, a, c, o, o, s][l]), a: xa(r, 2) };
}, j2 = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, sTc = function(e) {
  var t = e.r, n = e.g, o = e.b, r = e.a, i = r < 1 ? j2(xa(255 * r)) : "";
  return "#" + j2(t) + j2(n) + j2(o) + i;
}, cTc = function(e) {
  var t = e.r, n = e.g, o = e.b, r = e.a, i = Math.max(t, n, o), a = i - Math.min(t, n, o), s = a ? i === t ? (n - o) / a : i === n ? 2 + (o - t) / a : 4 + (t - n) / a : 0;
  return { h: xa(60 * (s < 0 ? s + 6 : s)), s: xa(i ? a / i * 100 : 0), v: xa(i / 255 * 100), a: r };
}, lTc = ve.memo(function(e) {
  var t = e.hue, n = e.onChange, o = $j(["react-colorful__hue", e.className]);
  return ve.createElement("div", { className: o }, ve.createElement(Cpe, { onMove: function(r) {
    n({ h: 360 * r.left });
  }, onKey: function(r) {
    n({ h: qw(t + 360 * r.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": xa(t), "aria-valuemax": "360", "aria-valuemin": "0" }, ve.createElement(zpe, { className: "react-colorful__hue-pointer", left: t / 360, color: xM({ h: t, s: 100, v: 100, a: 1 }) })));
}), dTc = ve.memo(function(e) {
  var t = e.hsva, n = e.onChange, o = { backgroundColor: xM({ h: t.h, s: 100, v: 100, a: 1 }) };
  return ve.createElement("div", { className: "react-colorful__saturation", style: o }, ve.createElement(Cpe, { onMove: function(r) {
    n({ s: 100 * r.left, v: 100 - 100 * r.top });
  }, onKey: function(r) {
    n({ s: qw(t.s + 100 * r.left, 0, 100), v: qw(t.v - 100 * r.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + xa(t.s) + "%, Brightness " + xa(t.v) + "%" }, ve.createElement(zpe, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: xM(t) })));
}), Ope = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, uTc = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || Ope(SM(e), SM(t));
};
function _Tc(e, t, n) {
  var o = Lw(n), r = ze(function() {
    return e.toHsva(t);
  }), i = r[0], a = r[1], s = Ue({ color: t, hsva: i });
  Le(function() {
    if (!e.equal(t, s.current.color)) {
      var l = e.toHsva(t);
      s.current = { hsva: l, color: t }, a(l);
    }
  }, [t, e]), Le(function() {
    var l;
    Ope(i, s.current.hsva) || e.equal(l = e.fromHsva(i), s.current.color) || (s.current = { hsva: i, color: l }, o(l));
  }, [i, e, o]);
  var c = at(function(l) {
    a(function(d) {
      return Object.assign({}, d, l);
    });
  }, []);
  return [i, c];
}
var pTc = typeof window < "u" ? ts : Le, mTc = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, eY = /* @__PURE__ */ new Map(), fTc = function(e) {
  pTc(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !eY.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, eY.set(t, n);
      var o = mTc();
      o && n.setAttribute("nonce", o), t.head.appendChild(n);
    }
  }, []);
}, gTc = function(e) {
  var t = e.className, n = e.colorModel, o = e.color, r = o === void 0 ? n.defaultColor : o, i = e.onChange, a = RA(e, ["className", "colorModel", "color", "onChange"]), s = Ue(null);
  fTc(s);
  var c = _Tc(n, r, i), l = c[0], d = c[1], u = $j(["react-colorful", t]);
  return ve.createElement("div", rb({}, a, { ref: s, className: u }), ve.createElement(dTc, { hsva: l, onChange: d }), ve.createElement(lTc, { hue: l.h, onChange: d, className: "react-colorful__last-control" }));
}, hTc = { defaultColor: "000", toHsva: oTc, fromHsva: function(e) {
  return rTc({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: uTc }, vTc = function(e) {
  return ve.createElement(gTc, rb({}, e, { colorModel: hTc }));
}, bTc = /^#?([0-9A-F]{3,8})$/i, yTc = function(e) {
  var t = e.color, n = t === void 0 ? "" : t, o = e.onChange, r = e.onBlur, i = e.escape, a = e.validate, s = e.format, c = e.process, l = RA(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), d = ze(function() {
    return i(n);
  }), u = d[0], _ = d[1], p = Lw(o), f = Lw(r), g = at(function(b) {
    var v = i(b.target.value);
    _(v), a(v) && p(c ? c(v) : v);
  }, [i, c, a, p]), h = at(function(b) {
    a(b.target.value) || _(i(n)), f(b);
  }, [n, i, a, f]);
  return Le(function() {
    _(i(n));
  }, [n, i]), ve.createElement("input", rb({}, l, { value: s ? s(u) : u, spellCheck: "false", onChange: g, onBlur: h }));
}, tY = function(e) {
  return "#" + e;
}, $Tc = function(e) {
  var t = e.prefixed, n = e.alpha, o = RA(e, ["prefixed", "alpha"]), r = at(function(a) {
    return a.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
  }, [n]), i = at(function(a) {
    return function(s, c) {
      var l = bTc.exec(s), d = l ? l[1].length : 0;
      return d === 3 || d === 6 || !!c && d === 4 || !!c && d === 8;
    }(a, n);
  }, [n]);
  return ve.createElement(yTc, rb({}, o, { escape: r, format: t ? tY : void 0, process: tY, validate: i }));
};
function wTc(e) {
  const t = {};
  if (e === null)
    return t;
  for (const [n, o] of e)
    if (t.hasOwnProperty(n)) {
      let r = t[n];
      Array.isArray(r) || (r = [r]), r.push(o), t[n] = r;
    } else
      t[n] = o;
  return t;
}
function kTc({
  param: e,
  value: t,
  container: n
}) {
  const o = wTc(n.entries());
  if (!n.has(e))
    return !1;
  const r = o[e], i = Array.isArray(t) ? t : [t];
  return i.length !== r.length ? !1 : i.every((a) => r.includes(a));
}
function STc() {
  if (typeof window > "u" || window.isEmbed)
    return;
  const e = new URL(document.URL), t = e.searchParams.get("embed"), n = e.pathname.endsWith("/embed"), o = "", r = typeof t == "string" ? t : window.name.includes("cal-embed=") ? window.name.replace(/cal-embed=(.*)/, "$1").trim() : n ? o : null;
  window.isEmbed = () => typeof r == "string", window.getEmbedTheme = () => window.CalEmbed.embedStore.theme ? window.CalEmbed.embedStore.theme : new URL(document.URL).searchParams.get("theme"), window.getEmbedNamespace = () => r, window.CalEmbed = window.CalEmbed || {}, window.CalEmbed.applyCssVars = (i) => {
    const a = [];
    if (i)
      for (const [l, d] of Object.entries(i)) {
        a.push(`.${l} {`);
        for (const [u, _] of Object.entries(d))
          a.push(`--${u}: ${_} !important;`);
        a.push("}");
      }
    const s = document.head.querySelector("#embed-css-vars");
    if (s) {
      console.warn("Existing embed CSS Vars are being reset"), s.innerText = a.join(`
`);
      return;
    }
    const c = document.createElement("style");
    c.id = "embed-css-vars", c.innerText = a.join(`
`), document.head.appendChild(c);
  };
}
function nY(e, t) {
  const n = new window.CustomEvent(e, {
    detail: t
  });
  window.dispatchEvent(n);
}
class xTc {
  constructor(t) {
    fr(this, "namespace");
    t = t || "", this.namespace = t;
  }
  static parseAction(t) {
    if (!t)
      return null;
    const [n, o, r] = t.split(":");
    return n !== "CAL" ? null : {
      ns: o,
      type: r
    };
  }
  getFullActionName(t) {
    return this.namespace ? `CAL:${this.namespace}:${t}` : `CAL::${t}`;
  }
  fire(t, n) {
    const o = this.getFullActionName(t), r = {
      type: t,
      namespace: this.namespace,
      fullType: o,
      data: n
    };
    nY(o, r), nY(this.getFullActionName("*"), r);
  }
  on(t, n) {
    const o = this.getFullActionName(t);
    window.addEventListener(o, n);
  }
  off(t, n) {
    const o = this.getFullActionName(t);
    window.removeEventListener(o, n);
  }
}
let Kn = null;
typeof window < "u" && (STc(), Kn = new xTc(window.getEmbedNamespace()));
function Jl(e) {
  return setTimeout(e, 50);
}
function ETc() {
  return !!window._embedBookerState;
}
function Ppe() {
  return window._embedBookerState === "slotsDone";
}
function TTc() {
  return !!new URL(document.URL).searchParams.get("cal.embed.pageType");
}
function Ipe({ embedStore: e }) {
  return e.providedCorrectHeightToParent ? ETc() && TTc() ? Ppe() : !0 : !1;
}
function ATc({ embedStore: e }) {
  let t = null, n = null, o = !0, r = !1;
  Jl(function i() {
    if (document.readyState !== "complete") {
      Jl(i);
      return;
    }
    if (!r) {
      setTimeout(() => {
        r = !0, i();
      }, 100);
      return;
    }
    e.windowLoadEventFired || Kn == null || Kn.fire("__windowLoadComplete", {}), e.windowLoadEventFired = !0;
    const a = document.getElementsByClassName("main")[0] || document.getElementsByTagName("main")[0] || document.documentElement, s = document.documentElement.scrollHeight, c = document.documentElement.scrollWidth;
    if (!(a instanceof HTMLElement))
      throw new Error("Main element should be an HTMLElement");
    const l = getComputedStyle(a), d = Math.ceil(
      parseFloat(l.height) + parseFloat(l.marginTop) + parseFloat(l.marginBottom)
    ), u = Math.ceil(
      parseFloat(l.width) + parseFloat(l.marginLeft) + parseFloat(l.marginRight)
    ), _ = o ? s : d, p = o ? c : u;
    if (!_ || !p) {
      Jl(i);
      return;
    }
    (t !== _ || n !== p || !e.providedCorrectHeightToParent) && (t = _, n = p, Kn == null || Kn.fire("__dimensionChanged", {
      iframeHeight: _,
      iframeWidth: p,
      isFirstTime: o
    })), o || (e.providedCorrectHeightToParent = !0), o = !1, Jl(i);
  });
}
const CTc = async (e) => {
  const t = new URL(document.URL);
  let n = null;
  const r = t.searchParams.get("cal.queuedFormResponseId");
  if (!r)
    return null;
  if (r === "00000000-0000-0000-0000-000000000000")
    return 0;
  const { form: i, ...a } = e, s = await fetch("/api/routing-forms/queued-response", {
    method: "POST",
    body: JSON.stringify({ queuedFormResponseId: r, params: a })
  });
  if (!s.ok)
    return null;
  const l = (await s.json()).data.formResponseId;
  return l && (n = l), n;
};
var EM = /* @__PURE__ */ ((e) => (e[e.NOT_INITIALIZED = 0] = "NOT_INITIALIZED", e[e.INITIALIZED = 1] = "INITIALIZED", e))(EM || {});
const Rn = {
  connectVersion: 0,
  /**
   * Tracks whether the iframe is fully rendered or in progress of rendering.
   * In case of prerendering as well as non-prerendering, it would be "completed" after the iframe is fully rendered.
   */
  renderState: null,
  // Handles the commands of routing received from parent even when React hasn't initialized and nextRouter isn't available
  router: {
    /**
     * When we do the history push, it is possible that
     * - React might revert that change depending on in what state React is in while initializing
     * - So, we use a declarative approach to ensure that our requirement is continuously met
     */
    ensureQueryParamsInUrl({
      toBeThereParams: e,
      toRemoveParams: t
    }) {
      let n = !1;
      function o() {
        if (n)
          return { hasChanged: !1 };
        const s = new URL(document.URL);
        let c = !1;
        for (const [l, d] of Object.entries(e))
          c = !kTc({
            param: l,
            value: d,
            container: s.searchParams
          }), c && a({ key: l, value: d, url: s });
        return i({ keys: t, url: s }), c = c || t.length > 0, c && window.history.replaceState({}, "", s.toString()), Jl(o), {
          hasChanged: c
        };
      }
      const { hasChanged: r } = o();
      return {
        stopEnsuringQueryParamsInUrl: () => {
          n = !0;
        },
        hasChanged: r
      };
      function i({ keys: s, url: c }) {
        for (const l of s)
          c.searchParams.delete(l);
      }
      function a({ key: s, value: c, url: l }) {
        l.searchParams.delete(s), (Array.isArray(c) ? c : [c]).forEach((u) => {
          l.searchParams.append(s, u);
        });
      }
    }
  },
  state: 0,
  // Store all embed styles here so that as and when new elements are mounted, styles can be applied to it.
  styles: {},
  nonStyles: {},
  namespace: null,
  embedType: void 0,
  // Store all React State setters here.
  reactStylesStateSetters: {},
  reactNonStylesStateSetters: {},
  // Embed can show itself only after this is set to true
  providedCorrectHeightToParent: !1,
  windowLoadEventFired: !1,
  setTheme: void 0,
  theme: void 0,
  uiConfig: void 0,
  /**
   * We maintain a list of all setUiConfig setters that are in use at the moment so that we can update all those components.
   */
  setUiConfig: []
}, zTc = () => {
  const e = Ro.useSearchParams() ?? new URLSearchParams(), t = Ro.useParams() ?? {}, n = new URLSearchParams(e.toString());
  return Object.getOwnPropertyNames(t).forEach((o) => {
    n.delete(o);
    const r = t[o], i = typeof r == "string" ? r.split("/") : r;
    i == null || i.forEach((a) => {
      n.append(o, a);
    });
  }), new Ro.ReadonlyURLSearchParams(n);
}, OTc = [
  // so that Postmessage communication starts
  "__iframeReady",
  // so that iframe height is adjusted according to the content, and iframe is ready to be shown when needed
  "__dimensionChanged",
  // When this event is fired, the iframe is still in prerender state but is going to be moved out of prerender state
  "__connectInitiated"
  // For other events, we should consider introducing prerender specific events and not reuse existing events
];
let oY = !1;
const ib = typeof window < "u";
if (ib) {
  window.CalEmbed = (window == null ? void 0 : window.CalEmbed) || {}, window.CalEmbed.embedStore = Rn;
  const e = navigator.userAgent.toLowerCase();
  oY = e.includes("safari") && !e.includes("chrome"), oY && ks("Safari Detected: Using setTimeout instead of rAF");
}
function ks(...e) {
  if (ib) {
    const t = Dpe(), n = new URL(document.URL).searchParams, o = window.CalEmbed.__logQueue = window.CalEmbed.__logQueue || [];
    e.push({
      ns: t,
      url: document.URL
    }), e.unshift("CAL:"), o.push(e), n.get("debug") && console.log("Child:", ...e);
  }
}
const PTc = (e) => {
  Rn.styles = e;
  for (const [, t] of Object.entries(Rn.reactStylesStateSetters))
    t((n) => ({
      ...n,
      ...e
    }));
}, ITc = (e) => {
  Rn.nonStyles = e;
  for (const [, t] of Object.entries(Rn.reactStylesStateSetters))
    t((n) => ({
      ...n,
      ...e
    }));
}, Rpe = (e) => e.styles ? (Rn.reactStylesStateSetters[e.elementName] = e.setState, e.setState(Rn.styles || {}), () => {
  delete Rn.reactStylesStateSetters[e.elementName];
}) : (Rn.reactNonStylesStateSetters[e.elementName] = e.setState, e.setState(Rn.nonStyles || {}), () => {
  delete Rn.reactNonStylesStateSetters[e.elementName];
});
function Npe(e) {
  return typeof e < "u" && e !== null;
}
const RTc = (e) => {
  const t = ib ? new URL(document.URL) : null, n = (t == null ? void 0 : t.pathname) ?? "", o = (t == null ? void 0 : t.searchParams) ?? null, r = Ue(`${n}?${o}`);
  Le(() => {
    const i = `${n}?${o}`;
    r.current !== i && (r.current = i, e(i));
  }, [n, o, e]);
}, NTc = () => {
  const e = zTc(), [t, n] = ze(
    Rn.theme || (e == null ? void 0 : e.get("theme"))
  ), o = at(() => {
    Kn == null || Kn.fire("__routeChanged", {});
  }, []);
  return RTc(o), Rn.setTheme = n, t;
}, wj = () => {
  const [e, t] = ze(Rn.uiConfig || {});
  return Rn.setUiConfig.push(t), Le(() => () => {
    const n = Rn.setUiConfig.findIndex((o) => o === t);
    Rn.setUiConfig.splice(n, 1);
  }), e;
}, rY = (e) => {
  const [, t] = ze({});
  return Le(() => Rpe({ elementName: e, setState: t, styles: !0 }), []), (Rn.styles || {})[e] || {};
}, DTc = (e) => {
  const [, t] = ze({});
  return Le(() => Rpe({ elementName: e, setState: t, styles: !1 }), []), (Rn.nonStyles || {})[e] || {};
}, MTc = () => DTc("branding") || {};
function Dpe() {
  var e;
  if (Npe(Rn.namespace))
    return Rn.namespace;
  if (ib) {
    const t = ((e = window == null ? void 0 : window.getEmbedNamespace) == null ? void 0 : e.call(window)) ?? null;
    return Rn.namespace = t, t;
  }
}
function LTc() {
  if (Rn.embedType)
    return Rn.embedType;
  if (ib) {
    const e = new URL(document.URL);
    return Rn.embedType = e.searchParams.get("embedType");
  }
}
const fu = (e) => {
  const [t, n] = ze(e);
  return Le(() => {
    var i;
    const o = Dpe(), r = Npe(o);
    parent !== window && !r && ks(
      "Looks like you have iframed cal.com but not using Embed Snippet. Directly using an iframe isn't recommended."
    ), n(((i = window == null ? void 0 : window.isEmbed) == null ? void 0 : i.call(window)) || !1);
  }, []), t;
}, qTc = () => {
  const [e, t] = ze(null);
  return Le(() => {
    t(LTc());
  }, []), e;
};
function kj() {
  document.body.style.visibility !== "visible" && (document.body.style.visibility = "visible"), Jl(() => {
    kj();
  });
}
function jTc() {
  kj(), e();
  function e() {
    document.body.style.background === "transparent" && (document.body.style.background = "");
  }
}
async function FTc({
  newlyRecordedResponseId: e,
  toBeThereParams: t,
  toRemoveParams: n
}) {
  const { stopEnsuringQueryParamsInUrl: o } = Rn.router.ensureQueryParamsInUrl({
    toBeThereParams: {
      ...t,
      "cal.routingFormResponseId": e.toString()
    },
    toRemoveParams: n
  });
  o();
}
async function VTc() {
  return new Promise((e) => {
    (function t() {
      if (Rn.renderState !== "completed") {
        Jl(t);
        return;
      }
      e();
    })();
  });
}
const BTc = {
  ui: function(t) {
    var o;
    ks("Method: ui called", t);
    const n = t.styles;
    n && console.warn(
      "Cal.com Embed: `styles` prop is deprecated. Use `cssVarsPerTheme` instead to achieve the same effect. Here is a list of CSS variables that are supported. https://github.com/calcom/cal.com/blob/main/packages/config/tailwind-preset.js#L19"
    ), (o = n == null ? void 0 : n.body) != null && o.background && (document.body.style.background = n.body.background), t.theme && (Rn.theme = t.theme, Rn.setTheme && Rn.setTheme(t.theme)), t = {
      ...Rn.uiConfig,
      ...t
    }, t.cssVarsPerTheme && window.CalEmbed.applyCssVars(t.cssVarsPerTheme), t.colorScheme && Mpe(t.colorScheme), Rn.setUiConfig && HTc(t), PTc(n || {}), ITc(n || {});
  },
  parentKnowsIframeReady: (e) => {
    ks("Method: `parentKnowsIframeReady` called"), Jl(function t() {
      if (!Ipe({ embedStore: Rn })) {
        Jl(t);
        return;
      }
      kj(), ks("renderState is 'completed'"), Rn.renderState = "completed", Kn == null || Kn.fire("linkReady", {});
    });
  },
  /**
   * Connects new config to prerendered page
   */
  connect: async function({
    config: t,
    params: n
  }) {
    Kn == null || Kn.fire("__connectInitiated", {}), ks("Method: connect, requested with params", { config: t, params: n });
    const {
      iframeAttrs: o,
      "cal.embed.noSlotsFetchOnConnect": r,
      ...i
    } = t;
    Rn.providedCorrectHeightToParent = !1, r !== "true" && (ks("Method: connect, noSlotsFetchOnConnect is false. Requesting slots re-fetch"), Rn.connectVersion = Rn.connectVersion + 1);
    const a = Rn.connectVersion, s = {
      ...n,
      // Query params from config takes precedence over query params in url
      ...i,
      "cal.embed.connectVersion": a.toString()
    }, c = ["preload", "prerender", "cal.skipSlotsFetch"];
    await VTc(), ks("Method: connect, renderState is completed. Connecting"), await KTc({
      // We know after removing iframeAttrs, that it is of this type
      toBeThereParams: s,
      toRemoveParams: c
    });
    const l = await CTc(n);
    typeof l == "number" && await FTc({
      newlyRecordedResponseId: l,
      toBeThereParams: s,
      toRemoveParams: c
    });
  }
}, J3 = BTc, UTc = (e) => {
  parent.postMessage(
    {
      originator: "CAL",
      ...e
    },
    "*"
  );
};
function WTc() {
  var r, i, a;
  if (!ib)
    return;
  ks("Embed SDK loaded", { isEmbed: ((r = window == null ? void 0 : window.isEmbed) == null ? void 0 : r.call(window)) || !1 });
  const e = new URL(document.URL);
  Rn.theme = (i = window == null ? void 0 : window.getEmbedTheme) == null ? void 0 : i.call(window);
  const n = e.searchParams.get("ui.autoscroll") === "false";
  if (Rn.uiConfig = {
    // TODO: Add theme as well here
    colorScheme: e.searchParams.get("ui.color-scheme"),
    layout: e.searchParams.get("layout"),
    disableAutoScroll: n
  }, Mpe(Rn.uiConfig.colorScheme), top === window) {
    jTc(), ks("Embed SDK Skipped as we are in top");
    return;
  }
  const o = e.searchParams.get("cal.skipSlotsFetch") !== "true";
  ks(`Slots will ${o ? "" : "NOT "}be fetched`), window.addEventListener("message", (s) => {
    var d;
    const c = s.data;
    if (!c)
      return;
    const l = c.method;
    c.originator === "CAL" && typeof l == "string" && ((d = J3[l]) == null || d.call(J3, c.arg));
  }), document.addEventListener("click", (s) => {
    if (!s.target || !(s.target instanceof Node))
      return;
    const c = document.getElementsByClassName("main")[0] || document.getElementsByTagName("main")[0] || document.documentElement;
    s.target.contains(c) && (Kn == null || Kn.fire("__closeIframe", {}));
  }), Kn == null || Kn.on("*", (s) => {
    if (Lpe() && !OTc.includes(s.detail.type))
      return;
    const c = s.detail;
    ks(c), UTc(c);
  }), e.searchParams.get("preload") !== "true" && ((a = window == null ? void 0 : window.isEmbed) != null && a.call(window)) ? GTc() : ks("Preloaded scenario - Skipping initialization and setup as only assets need to be loaded");
}
function GTc() {
  if (Kn == null || Kn.fire("__iframeReady", {
    isPrerendering: Lpe()
  }), Rn.renderState = "inProgress", Rn.state !== EM.NOT_INITIALIZED) {
    ks("Embed Iframe already initialized");
    return;
  }
  Rn.state = EM.INITIALIZED, ks("Initializing embed-iframe");
  const e = window.CalComPageStatus;
  !e || e == "200" ? ATc({ embedStore: Rn }) : Kn == null || Kn.fire("linkFailed", {
    code: e,
    msg: "Problem loading the link",
    data: {
      url: document.URL
    }
  });
}
function HTc(e) {
  Rn.uiConfig = e, Rn.setUiConfig.forEach((t) => t(e));
}
function Mpe(e) {
  e && (document.documentElement.style.colorScheme = e);
}
async function KTc({
  toBeThereParams: e,
  toRemoveParams: t
}) {
  const { hasChanged: n, stopEnsuringQueryParamsInUrl: o } = Rn.router.ensureQueryParamsInUrl({
    toBeThereParams: e,
    toRemoveParams: t
  });
  let r = 0;
  return Ppe() && n && (r = 2), await new Promise((i) => {
    Jl(function a() {
      if (!Ipe({ embedStore: Rn }) || r > 0) {
        r--, Jl(a);
        return;
      }
      o(), Kn == null || Kn.fire("__connectCompleted", {}), Kn == null || Kn.fire("linkReady", {}), i();
    });
  }), {
    stopEnsuringQueryParamsInUrl: o
  };
}
const Lpe = () => new URL(document.URL).searchParams.get("prerender") === "true";
function YTc({
  bookerState: e,
  slotsQuery: t
}) {
  return e === "loading" ? "initializing" : t.isLoading ? "slotsLoading" : t.isPending || t.isSuccess ? "slotsDone" : t.isError ? "slotsLoadingError" : "slotsPending";
}
function TM({
  bookerState: e,
  slotsQuery: t
}) {
  if (typeof window > "u")
    return;
  const n = window, o = YTc({ bookerState: e, slotsQuery: t });
  n._embedBookerState = o;
}
WTc();
const yE = m9, $E = f9;
function X3(e, t) {
  return e && AM(e) ? e : t ? $E : yE;
}
function AM(e) {
  return /^#([0-9A-Fa-f]{3}){1,2}$/.test(e);
}
const iY = (e, t) => /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(e.replace("##", "#")) ? e : t;
function jw(e) {
  const t = e.replace("##", "#"), n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!n)
    throw new Error("Invalid Hex colour");
  const [, o, r, i] = n;
  return {
    r: parseInt(o, 16),
    g: parseInt(r, 16),
    b: parseInt(i, 16)
  };
}
function qpe(e, t, n) {
  const o = (r) => `0${r.toString(16)}`.slice(-2);
  return `#${o(e)}${o(t)}${o(n)}`;
}
function ZTc(e, t) {
  const n = jw(`#${e}`);
  if (!n)
    return "";
  const o = Math.round(n.r + (255 - n.r) * t), r = Math.round(n.g + (255 - n.g) * t), i = Math.round(n.b + (255 - n.b) * t);
  return qpe(o, r, i);
}
function QTc(e, t) {
  const n = jw(e);
  if (!n)
    return "";
  const o = Math.round(n.r * t), r = Math.round(n.g * t), i = Math.round(n.b * t);
  return qpe(o, r, i);
}
function aY(e, t) {
  return e ? (e = e.replace("#", ""), e.length === 3 && (e = e.split("").map(function(n) {
    return n + n;
  }).join("")), e) : t ? $E : yE;
}
const sY = (e) => {
  const t = {
    500: `#${e}`.replace("##", "#")
  }, n = {
    50: 0.95,
    100: 0.9,
    200: 0.75,
    300: 0.6,
    400: 0.3,
    600: 0.9,
    700: 0.75,
    800: 0.6,
    900: 0.49
  };
  return [50, 100, 200, 300, 400].forEach((o) => {
    t[o] = ZTc(e, n[o]);
  }), [600, 700, 800, 900].forEach((o) => {
    t[o] = QTc(e, n[o]);
  }), t;
};
function F2(e) {
  const { r: t, g: n, b: o } = jw(e);
  return (0.2126 * t + 0.7152 * n + 0.0722 * o) / 255 < 0.5 ? "#FFFFFF" : "#000000";
}
function cY(e, t) {
  const n = jw(e), o = jw(t), r = (0.2126 * n.r + 0.7152 * n.g + 0.0722 * n.b) / 255, i = (0.2126 * o.r + 0.7152 * o.g + 0.0722 * o.b) / 255;
  return (Math.max(r, i) + 0.05) / (Math.min(i, r) + 0.05) >= 4.5;
}
const JTc = ({
  lightVal: e = yE,
  darkVal: t = $E
}) => {
  e = MTc().brandColor || e, e = aY(e, !1), t = aY(t, !0);
  const o = sY(iY(e, yE)), r = sY(iY(t, $E));
  return {
    light: {
      "cal-brand": o[500],
      "cal-brand-emphasis": o[400],
      "cal-brand-subtle": o[200],
      "cal-brand-text": F2(o[500]),
      "cal-brand-accent": F2(o[500])
    },
    dark: {
      "cal-brand": r[500],
      "cal-brand-emphasis": r[600],
      "cal-brand-subtle": r[800],
      "cal-brand-text": F2(r[500]),
      "cal-brand-accent": F2(r[500])
    }
  };
}, XTc = JTc, eAc = (e) => {
  const t = AM(e.defaultValue) ? e.defaultValue : X3(e.defaultValue, !1), n = e.resetDefaultValue && (AM(e.resetDefaultValue) ? e.resetDefaultValue : X3(e.resetDefaultValue, !1)), [o, r] = ze(t);
  return /* @__PURE__ */ Y("div", { className: "mt-1 flex h-[38px] items-center justify-center", children: [
    /* @__PURE__ */ Y(tpe, { children: [
      /* @__PURE__ */ m("div", { className: "border-default min-w-9 flex h-full items-center justify-center border ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0", children: /* @__PURE__ */ m(npe, { asChild: !0, children: /* @__PURE__ */ m(
        "button",
        {
          className: "h-5 w-5 rounded-sm",
          "aria-label": "pick colors",
          style: { backgroundColor: o }
        }
      ) }) }),
      /* @__PURE__ */ m(tSc, { container: e.container, children: /* @__PURE__ */ m(ope, { align: e.popoverAlign ?? "center", sideOffset: 10, children: /* @__PURE__ */ m(
        vTc,
        {
          color: o,
          className: "!h-32 !w-32",
          onChange: (i) => {
            r(i), e.onChange(i);
          }
        }
      ) }) })
    ] }),
    /* @__PURE__ */ m(
      $Tc,
      {
        className: ae(
          "border-default text-default bg-default block h-full w-full border px-3 py-2 ltr:rounded-r-md rtl:rounded-l-md sm:text-sm",
          e.className
        ),
        color: o,
        onChange: (i) => {
          r(i), e.onChange(i);
        },
        type: "text"
      }
    ),
    n && o != n && /* @__PURE__ */ m("div", { className: "px-1", children: /* @__PURE__ */ m(
      ut,
      {
        color: "secondary",
        target: "_blank",
        variant: "icon",
        rel: "noreferrer",
        "aria-label": "Reset to default",
        StartIcon: "rotate-ccw",
        tooltip: "Reset to default",
        onClick: () => {
          r(X3(n, !1)), e.onChange(n);
        }
      }
    ) })
  ] });
}, L$ = eAc, tAc = globalThis != null && globalThis.document ? $e.useLayoutEffect : () => {
}, nAc = $e.useId || (() => {
});
let oAc = 0;
function rAc(e) {
  const [t, n] = $e.useState(nAc());
  return tAc(() => {
    e || n((o) => o ?? String(oAc++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function jpe(...e) {
  return (t) => e.forEach((n) => function(o, r) {
    typeof o == "function" ? o(r) : o != null && (o.current = r);
  }(n, t));
}
function iAc(...e) {
  return $e.useCallback(jpe(...e), e);
}
const Fpe = /* @__PURE__ */ $e.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  return $e.Children.toArray(n).some(lY) ? /* @__PURE__ */ $e.createElement($e.Fragment, null, $e.Children.map(n, (r) => lY(r) ? /* @__PURE__ */ $e.createElement(CM, We({}, o, { ref: t }), r.props.children) : r)) : /* @__PURE__ */ $e.createElement(CM, We({}, o, { ref: t }), n);
});
Fpe.displayName = "Slot";
const CM = /* @__PURE__ */ $e.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  return $e.isValidElement(n) ? /* @__PURE__ */ $e.cloneElement(n, { ...sAc(o, n.props), ref: jpe(t, n.ref) }) : $e.Children.count(n) > 1 ? $e.Children.only(null) : null;
});
CM.displayName = "SlotClone";
const aAc = ({ children: e }) => /* @__PURE__ */ $e.createElement($e.Fragment, null, e);
function lY(e) {
  return $e.isValidElement(e) && e.type === aAc;
}
function sAc(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? n[o] = (...a) => {
      i == null || i(...a), r == null || r(...a);
    } : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
const cAc = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((e, t) => ({ ...e, [t]: /* @__PURE__ */ $e.forwardRef((n, o) => {
  const { asChild: r, ...i } = n, a = r ? Fpe : t;
  return $e.useEffect(() => {
    window[Symbol.for("radix-ui")] = !0;
  }, []), /* @__PURE__ */ $e.createElement(a, We({}, i, { ref: o }));
}) }), {});
function lAc(e, t) {
  const n = /* @__PURE__ */ $e.createContext(t);
  function o(r) {
    const { children: i, ...a } = r, s = $e.useMemo(() => a, Object.values(a));
    return $e.createElement(n.Provider, { value: s }, i);
  }
  return o.displayName = e + "Provider", [o, function(r) {
    const i = $e.useContext(n);
    if (i)
      return i;
    if (t !== void 0)
      return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }];
}
const [dAc, afd] = lAc("Label", { id: void 0, controlRef: { current: null } }), uAc = /* @__PURE__ */ $e.forwardRef((e, t) => {
  const { htmlFor: n, id: o, ...r } = e, i = $e.useRef(null), a = $e.useRef(null), s = iAc(t, a), c = rAc(o);
  return $e.useEffect(() => {
    if (n) {
      const l = document.getElementById(n);
      if (a.current && l) {
        const d = () => l.getAttribute("aria-labelledby"), u = [c, d()].filter(Boolean).join(" ");
        return l.setAttribute("aria-labelledby", u), i.current = l, () => {
          var _;
          const p = (_ = d()) === null || _ === void 0 ? void 0 : _.replace(c, "");
          p === "" ? l.removeAttribute("aria-labelledby") : p && l.setAttribute("aria-labelledby", p);
        };
      }
    }
  }, [c, n]), /* @__PURE__ */ $e.createElement(dAc, { id: c, controlRef: i }, /* @__PURE__ */ $e.createElement(cAc.span, We({ role: "label", id: c }, r, { ref: s, onMouseDown: (l) => {
    var d;
    (d = e.onMouseDown) === null || d === void 0 || d.call(e, l), !l.defaultPrevented && l.detail > 1 && l.preventDefault();
  }, onClick: (l) => {
    var d;
    if ((d = e.onClick) === null || d === void 0 || d.call(e, l), !i.current || l.defaultPrevented)
      return;
    const u = i.current.contains(l.target), _ = l.isTrusted === !0;
    !u && _ && (i.current.click(), i.current.focus());
  } })));
}), _Ac = uAc;
function pAc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function mAc(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Vpe(...e) {
  return (t) => e.forEach((n) => mAc(n, t));
}
function fAc(...e) {
  return $e.useCallback(Vpe(...e), e);
}
function gAc(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = $e.createContext(a), c = n.length;
    n = [...n, a];
    function l(u) {
      const { scope: _, children: p, ...f } = u, g = (_ == null ? void 0 : _[e][c]) || s, h = $e.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ m(g.Provider, { value: h, children: p });
    }
    function d(u, _) {
      const p = (_ == null ? void 0 : _[e][c]) || s, f = $e.useContext(p);
      if (f)
        return f;
      if (a !== void 0)
        return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [l, d];
  }
  const r = () => {
    const i = n.map((a) => $e.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return $e.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [o, hAc(r, ...t)];
}
function hAc(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(i)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return $e.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Bpe(e) {
  const t = $e.useRef(e);
  return $e.useEffect(() => {
    t.current = e;
  }), $e.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function vAc({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, r] = bAc({ defaultProp: t, onChange: n }), i = e !== void 0, a = i ? e : o, s = Bpe(n), c = $e.useCallback(
    (l) => {
      if (i) {
        const u = typeof l == "function" ? l(e) : l;
        u !== e && s(u);
      } else
        r(l);
    },
    [i, e, r, s]
  );
  return [a, c];
}
function bAc({
  defaultProp: e,
  onChange: t
}) {
  const n = $e.useState(e), [o] = n, r = $e.useRef(o), i = Bpe(t);
  return $e.useEffect(() => {
    r.current !== o && (i(o), r.current = o);
  }, [o, r, i]), n;
}
function yAc(e) {
  const t = $e.useRef({ value: e, previous: e });
  return $e.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function $Ac(e) {
  const [t, n] = $e.useState(void 0);
  return aj(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Upe = $e.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = $e.Children.toArray(n), i = r.find(kAc);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? $e.Children.count(a) > 1 ? $e.Children.only(null) : $e.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ m(zM, { ...o, ref: t, children: $e.isValidElement(a) ? $e.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ m(zM, { ...o, ref: t, children: n });
});
Upe.displayName = "Slot";
var zM = $e.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if ($e.isValidElement(n)) {
    const r = xAc(n);
    return $e.cloneElement(n, {
      ...SAc(o, n.props),
      // @ts-ignore
      ref: t ? Vpe(t, r) : r
    });
  }
  return $e.Children.count(n) > 1 ? $e.Children.only(null) : null;
});
zM.displayName = "SlotClone";
var wAc = ({ children: e }) => /* @__PURE__ */ m(Ce, { children: e });
function kAc(e) {
  return $e.isValidElement(e) && e.type === wAc;
}
function SAc(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xAc(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var EAc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Wpe = EAc.reduce((e, t) => {
  const n = $e.forwardRef((o, r) => {
    const { asChild: i, ...a } = o, s = i ? Upe : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(s, { ...a, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Sj = "Switch", [TAc, sfd] = gAc(Sj), [AAc, CAc] = TAc(Sj), Gpe = $e.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      ...d
    } = e, [u, _] = $e.useState(null), p = fAc(t, (v) => _(v)), f = $e.useRef(!1), g = u ? !!u.closest("form") : !0, [h = !1, b] = vAc({
      prop: r,
      defaultProp: i,
      onChange: l
    });
    return /* @__PURE__ */ Y(AAc, { scope: n, checked: h, disabled: s, children: [
      /* @__PURE__ */ m(
        Wpe.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": h,
          "aria-required": a,
          "data-state": Ype(h),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...d,
          ref: p,
          onClick: pAc(e.onClick, (v) => {
            b(($) => !$), g && (f.current = v.isPropagationStopped(), f.current || v.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ m(
        zAc,
        {
          control: u,
          bubbles: !f.current,
          name: o,
          value: c,
          checked: h,
          required: a,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Gpe.displayName = Sj;
var Hpe = "SwitchThumb", Kpe = $e.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = CAc(Hpe, n);
    return /* @__PURE__ */ m(
      Wpe.span,
      {
        "data-state": Ype(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Kpe.displayName = Hpe;
var zAc = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = $e.useRef(null), a = yAc(n), s = $Ac(t);
  return $e.useEffect(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && u) {
      const _ = new Event("click", { bubbles: o });
      u.call(c, n), c.dispatchEvent(_);
    }
  }, [a, n, o]), /* @__PURE__ */ m(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...r,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Ype(e) {
  return e ? "checked" : "unchecked";
}
var OAc = Gpe, PAc = Kpe;
const IAc = ({ children: e, tooltip: t }) => t ? /* @__PURE__ */ m(Ao, { content: t, children: e }) : /* @__PURE__ */ m(Ce, { children: e }), Ri = (e) => {
  const {
    label: t,
    fitToHeight: n,
    classNames: o,
    labelOnLeading: r,
    LockedIcon: i,
    padding: a,
    size: s = "base",
    ...c
  } = e, l = Cc();
  return /* @__PURE__ */ m(IAc, { tooltip: e.tooltip, children: /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "flex h-auto w-fit flex-row items-center",
        n && "h-fit",
        r && "flex-row-reverse",
        a && "hover:bg-subtle rounded-md p-1.5",
        o == null ? void 0 : o.container
      ),
      children: [
        i && /* @__PURE__ */ m("div", { className: "mr-2", children: i }),
        /* @__PURE__ */ m(
          OAc,
          {
            ...c,
            id: l,
            className: ae(
              s === "sm" ? "h-3 w-[20px]" : "h-4 w-[28px]",
              "focus:ring-brand-default data-[state=checked]:bg-brand-default dark:data-[state=checked]:bg-brand-emphasis data-[state=unchecked]:bg-emphasis peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-inner transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
              s === "sm" ? "h-4 w-7" : "h-6 w-11",
              o == null ? void 0 : o.container
            ),
            children: /* @__PURE__ */ m(
              PAc,
              {
                className: ae(
                  "bg-default data-[state=checked]:bg-brand-accent shadow-switch-thumb pointer-events-none block rounded-full shadow-lg ring-0 transition-transform",
                  s === "sm" ? "h-3 w-3 data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0 rtl:data-[state=checked]:-translate-x-3" : "h-5 w-5 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 rtl:data-[state=checked]:-translate-x-5",
                  o == null ? void 0 : o.thumb
                )
              }
            )
          }
        ),
        t && /* @__PURE__ */ m(
          _Ac,
          {
            htmlFor: l,
            className: ae(
              "text-emphasis font-medium",
              s === "sm" ? "m-1 text-xs" : "ml-2 mt-1 text-sm",
              c.disabled ? "cursor-not-allowed opacity-25" : "cursor-pointer",
              r && "flex-1"
            ),
            children: t
          }
        )
      ]
    }
  ) });
};
function eo({
  checked: e,
  onCheckedChange: t,
  description: n,
  LockedIcon: o,
  Badge: r,
  title: i,
  children: a,
  disabled: s,
  tooltip: c,
  toggleSwitchAtTheEnd: l = !1,
  childrenClassName: d,
  switchContainerClassName: u,
  labelClassName: _,
  descriptionClassName: p,
  noIndentation: f = !1,
  hideSwitch: g,
  ...h
}) {
  const [b] = xl();
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m("div", { className: "flex w-full flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: /* @__PURE__ */ Y("fieldset", { className: "block w-full flex-col sm:flex", children: [
    l ? /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle flex justify-between space-x-3 rounded-lg border px-4 py-6 sm:px-6",
          e && a && "rounded-b-none",
          u
        ),
        children: [
          /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ Y("div", { className: "flex items-center gap-x-2", "data-testid": `${h["data-testid"]}-title`, children: [
              /* @__PURE__ */ Y(
                Xn,
                {
                  className: ae("mt-0.5 text-base font-semibold leading-none", _),
                  htmlFor: "",
                  children: [
                    i,
                    o
                  ]
                }
              ),
              r && /* @__PURE__ */ m("div", { className: "mb-2", children: r })
            ] }),
            n && /* @__PURE__ */ m(
              "p",
              {
                className: ae(
                  "text-default -mt-1.5 text-sm leading-normal",
                  p
                ),
                "data-testid": `${h["data-testid"]}-description`,
                children: n
              }
            )
          ] }),
          !g && /* @__PURE__ */ m("div", { className: "my-auto h-full", children: /* @__PURE__ */ m(
            Ri,
            {
              "data-testid": h["data-testid"],
              fitToHeight: !0,
              checked: e,
              onCheckedChange: t,
              disabled: s,
              tooltip: c
            }
          ) })
        ]
      }
    ) : /* @__PURE__ */ Y("div", { className: "flex space-x-3", children: [
      /* @__PURE__ */ m(
        Ri,
        {
          "data-testid": h["data-testid"],
          fitToHeight: !0,
          checked: e,
          onCheckedChange: t,
          disabled: s,
          tooltip: c
        }
      ),
      /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ Y(
          Xn,
          {
            className: ae("text-emphasis text-sm font-semibold leading-none", _),
            children: [
              i,
              " ",
              r || null,
              o
            ]
          }
        ),
        n && /* @__PURE__ */ m("p", { className: "text-default -mt-1.5 text-sm leading-normal", children: n })
      ] })
    ] }),
    a && /* @__PURE__ */ m("div", { className: ae(f ? "" : "lg:ml-14", d), ref: b, children: e && /* @__PURE__ */ m("div", { className: ae(!l && "mt-4"), children: a }) })
  ] }) }) });
}
const RAc = [
  { label: "San Francisco", timezone: "America/Los_Angeles" },
  { label: "Sao Francisco do Sul", timezone: "America/Sao_Paulo" },
  { label: "San Francisco de Macoris", timezone: "America/Santo_Domingo" },
  { label: "San Francisco Gotera", timezone: "America/El_Salvador" },
  { label: "Eastern Time - US & Canada", timezone: "America/New_York" },
  { label: "Pacific Time - US & Canada", timezone: "America/Los_Angeles" },
  { label: "Central Time - US & Canada", timezone: "America/Chicago" },
  { label: "Mountain Time - US & Canada", timezone: "America/Denver" },
  { label: "Atlantic Time - Canada", timezone: "America/Halifax" },
  { label: "Eastern European Time", timezone: "Europe/Bucharest" },
  { label: "Central European Time", timezone: "Europe/Berlin" },
  { label: "Western European Time", timezone: "Europe/London" },
  { label: "Australian Eastern Time", timezone: "Australia/Sydney" },
  { label: "Japan Standard Time", timezone: "Asia/Tokyo" },
  { label: "India Standard Time", timezone: "Asia/Kolkata" },
  { label: "Gulf Standard Time", timezone: "Asia/Dubai" },
  { label: "South Africa Standard Time", timezone: "Africa/Johannesburg" },
  { label: "Brazil Time", timezone: "America/Sao_Paulo" },
  { label: "Hawaii-Aleutian Standard Time", timezone: "Pacific/Honolulu" }
];
function xj(e) {
  const { data: t = [], isPending: n } = bo.viewer.timezones.cityTimezones.useQuery(
    {
      CalComVersion: Kce
    },
    {
      trpc: { context: { skipBatch: !0 } }
    }
  ), o = t.map(({ city: r, timezone: i }) => ({ label: r, timezone: i }));
  return /* @__PURE__ */ m(
    Zpe,
    {
      data: [...o, ...RAc],
      isPending: n,
      ...e
    }
  );
}
function Zpe({
  className: e,
  classNames: t,
  timezoneSelectCustomClassname: n,
  components: o,
  variant: r = "default",
  isPending: i,
  value: a,
  size: s = "md",
  grow: c = !1,
  isWebTimezoneSelect: l = !0,
  ...d
}) {
  const u = [...d.data || []], [_, p] = ze([]), f = (h) => {
    u && p(Mbc(h, u));
  }, g = Tt(() => j_e({
    components: o || {}
  }), [o]);
  return /* @__PURE__ */ m(
    Rbc,
    {
      value: a,
      className: `${e} ${n}`,
      "aria-label": "Timezone Select",
      isLoading: i,
      "data-testid": "timezone-select",
      isDisabled: i,
      ...g,
      timezones: {
        ...d.data ? PH(u) : {},
        ...l ? PH(_) : {}
      },
      styles: {
        control: (h) => ({
          ...h,
          minHeight: s === "sm" ? "28px" : "36px",
          height: c ? "h-auto " : s === "sm" ? "28px" : "36px"
        }),
        menuList: (h) => ({
          ...h,
          height: c ? "h-auto " : s === "sm" ? "200px" : "180px"
        })
      },
      onInputChange: f,
      ...d,
      onChange: (h) => {
        if (!d.onChange)
          return;
        if (!h) {
          d.onChange(h);
          return;
        }
        const v = {
          "America/Port_Of_Spain": "America/Port_of_Spain",
          "Africa/Porto-novo": "Africa/Porto-Novo",
          "Africa/Dar_Es_Salaam": "Africa/Dar_es_Salaam"
        }[h.value] || h.value;
        d.onChange({ ...h, value: v });
      },
      formatOptionLabel: (h) => /* @__PURE__ */ m("p", { className: "truncate", children: h.value.replace(/_/g, " ") }),
      getOptionLabel: (h) => qbc(h, _),
      classNames: {
        ...t,
        input: (h) => ae(
          "text-emphasis h-6 md:max-w-[145px] max-w-[250px]",
          (t == null ? void 0 : t.input) && t.input(h)
        ),
        option: (h) => ae(
          "bg-default py-2.5 px-3 rounded-md text-default ",
          h.isFocused && "bg-subtle",
          h.isDisabled && "bg-muted",
          h.isSelected && "bg-emphasis text-default",
          (t == null ? void 0 : t.option) && t.option(h)
        ),
        placeholder: (h) => ae("text-muted", h.isFocused && "hidden"),
        dropdownIndicator: () => "text-default",
        control: (h) => ae(
          Z0({ size: s }),
          h.isMulti ? h.hasValue ? "p-1 h-fit" : "px-3 h-fit" : s === "sm" ? "h-7 px-2" : "h-9 py-0 px-3",
          d.isDisabled && "bg-subtle",
          "rounded-[10px]",
          (t == null ? void 0 : t.control) && t.control(h)
        ),
        singleValue: (h) => ae(
          "text-emphasis placeholder:text-muted",
          (t == null ? void 0 : t.singleValue) && t.singleValue(h)
        ),
        valueContainer: (h) => ae(
          "text-emphasis placeholder:text-muted flex gap-1",
          (t == null ? void 0 : t.valueContainer) && t.valueContainer(h)
        ),
        multiValue: (h) => ae(
          "bg-subtle text-default rounded-md py-1.5 px-2 flex items-center text-sm leading-none",
          (t == null ? void 0 : t.multiValue) && t.multiValue(h)
        ),
        menu: (h) => ae(
          "rounded-md bg-default text-sm leading-4 text-default mt-1 border border-subtle",
          h.selectProps.menuIsOpen && "shadow-dropdown",
          // Add box-shadow when menu is open
          (t == null ? void 0 : t.menu) && t.menu(h)
        ),
        groupHeading: () => "leading-none text-xs uppercase text-default pl-2.5 pt-4 pb-2",
        menuList: (h) => ae(
          "scroll-bar scrollbar-track-w-20 rounded-md",
          (t == null ? void 0 : t.menuList) && t.menuList(h)
        ),
        indicatorsContainer: (h) => ae(
          h.selectProps.menuIsOpen ? h.isMulti ? "[&>*:last-child]:rotate-180 [&>*:last-child]:transition-transform" : "rotate-180 transition-transform" : "text-default",
          // Woo it adds another SVG here on multi for some reason
          (t == null ? void 0 : t.indicatorsContainer) && t.indicatorsContainer(h)
        ),
        multiValueRemove: () => "text-default py-auto ml-2",
        noOptionsMessage: () => "h-12 py-2 flex items-center justify-center"
      }
    }
  );
}
var dY = function(e, t, n) {
  if (e && "reportValidity" in e) {
    var o = jt(n, t);
    e.setCustomValidity(o && o.message || ""), e.reportValidity();
  }
}, Qpe = function(e, t) {
  var n = function(r) {
    var i = t.fields[r];
    i && i.ref && "reportValidity" in i.ref ? dY(i.ref, r, e) : i.refs && i.refs.forEach(function(a) {
      return dY(a, r, e);
    });
  };
  for (var o in t.fields)
    n(o);
}, NAc = function(e, t) {
  t.shouldUseNativeValidation && Qpe(e, t);
  var n = {};
  for (var o in e) {
    var r = jt(t.fields, o);
    jr(n, o, Object.assign(e[o], { ref: r && r.ref }));
  }
  return n;
}, DAc = function(e, t) {
  for (var n = {}; e.length; ) {
    var o = e[0], r = o.code, i = o.message, a = o.path.join(".");
    if (!n[a])
      if ("unionErrors" in o) {
        var s = o.unionErrors[0].errors[0];
        n[a] = { message: s.message, type: s.code };
      } else
        n[a] = { message: i, type: r };
    if ("unionErrors" in o && o.unionErrors.forEach(function(d) {
      return d.errors.forEach(function(u) {
        return e.push(u);
      });
    }), t) {
      var c = n[a].types, l = c && c[o.code];
      n[a] = Ace(a, t, n, r, l ? [].concat(l, o.message) : o.message);
    }
    e.shift();
  }
  return n;
}, ek = function(e, t, n) {
  return n === void 0 && (n = {}), function(o, r, i) {
    try {
      return Promise.resolve(function(a, s) {
        try {
          var c = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](o, t)).then(function(l) {
            return i.shouldUseNativeValidation && Qpe({}, i), { errors: {}, values: n.rawValues ? o : l };
          });
        } catch (l) {
          return s(l);
        }
        return c && c.then ? c.then(void 0, s) : c;
      }(0, function(a) {
        return { values: {}, errors: a.isEmpty ? {} : NAc(DAc(a.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
};
const MAc = G.object({
  eventTypeIds: G.array(G.number())
});
function Jpe({
  eventTypes: e,
  isEventTypesFetching: t,
  ...n
}) {
  const { t: o } = Fe(), r = pd({
    resolver: ek(MAc),
    defaultValues: {
      eventTypeIds: (e == null ? void 0 : e.map((s) => s.id)) ?? []
    }
  }), i = r.watch("eventTypeIds"), a = i.length === 0;
  return t || !open || !e ? null : /* @__PURE__ */ m(Gi, { name: "Bulk Default Location Update", open: n.open, onOpenChange: n.setOpen, children: /* @__PURE__ */ m(
    Ei,
    {
      type: "creation",
      title: o("default_conferencing_bulk_title"),
      description: n.description,
      enableOverflow: !0,
      children: /* @__PURE__ */ Y(
        fd,
        {
          form: r,
          handleSubmit: (s) => {
            n.bulkUpdateFunction({
              eventTypeIds: s.eventTypeIds,
              callback: () => n.setOpen(!1)
            });
          },
          children: [
            /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-2", children: [
              e.length > 0 && /* @__PURE__ */ m("div", { className: "flex items-center space-x-2 rounded-md px-3 pb-2.5 pt-1", children: /* @__PURE__ */ m(
                Ta,
                {
                  description: o("select_all"),
                  descriptionAsLabel: !0,
                  onChange: (s) => {
                    r.setValue("eventTypeIds", s.target.checked ? e.map((c) => c.id) : []);
                  },
                  checked: i.length === e.length
                }
              ) }),
              e.map((s) => /* @__PURE__ */ m("div", { className: "bg-muted flex items-center space-x-2 rounded-md px-3 py-2.5", children: /* @__PURE__ */ m(
                Ta,
                {
                  description: s.title,
                  descriptionAsLabel: !0,
                  checked: i.includes(s.id),
                  onChange: (c) => {
                    r.setValue(
                      "eventTypeIds",
                      c.target.checked ? [...i, s.id] : i.filter((l) => l !== s.id)
                    );
                  }
                }
              ) }, s.id))
            ] }),
            /* @__PURE__ */ Y(Fc, { showDivider: !0, className: "mt-10", children: [
              /* @__PURE__ */ m(
                ca,
                {
                  onClick: () => {
                    n.handleBulkEditDialogToggle();
                  }
                }
              ),
              /* @__PURE__ */ m(ut, { type: "submit", color: "primary", loading: n.isPending, disabled: a, children: o("update") })
            ] })
          ]
        }
      )
    }
  ) });
}
const gs = (e) => e instanceof Date ? De(e).format("YYYY-MM-DD") : e.format("YYYY-MM-DD"), Xpe = (e) => {
  const [t, n] = e instanceof Date ? [e.getFullYear(), e.getMonth()] : [e.year(), e.month()];
  return new Date(t, n + 1, 0).getDate();
}, LAc = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], eme = (e) => typeof e > "u" ? 0 : typeof e == "number" ? e >= 0 && e >= 6 ? e : 0 : LAc.indexOf(e) || 0, qAc = (e) => {
  const t = e.match(/([+-]\d{2}:\d{2})$/), n = t ? t[1] : "+00:00";
  return De(e).utcOffset(n);
};
G.string().transform(qAc);
function Fr(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size)
      return !1;
    for (const [o, r] of e)
      if (!Object.is(r, t.get(o)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size)
      return !1;
    for (const o of e)
      if (!t.has(o))
        return !1;
    return !0;
  }
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !1;
  for (const o of n)
    if (!Object.prototype.hasOwnProperty.call(t, o) || !Object.is(e[o], t[o]))
      return !1;
  return !0;
}
function jAc({
  browsingDate: e,
  minDate: t = /* @__PURE__ */ new Date(),
  includedDates: n
}) {
  const o = [], r = new Date(
    e.getFullYear(),
    e.getMonth(),
    Xpe(e)
  );
  for (
    let i = e > t ? e : t;
    // Check if date is before the last date of the month
    // or is the same day, in the same month, in the same year.
    i < r || De(i).isSame(r, "day");
    i = new Date(i.getFullYear(), i.getMonth(), i.getDate() + 1)
  )
    n && !n.includes(gs(i)) || o.push(gs(i));
  return o;
}
function ab(e, t = 0, n = "long") {
  return Array(7).fill(null).map((o, r) => Ej(e, r + t, n));
}
function Ej(e, t, n = "long") {
  return new Intl.DateTimeFormat(e, { weekday: n }).format(new Date(1970, 0, t + 4));
}
const Ks = ({
  as: e,
  className: t = "",
  children: n,
  loading: o = !1,
  /**
   * Assumes that the text needs translation by default and wait for it.
   */
  waitForTranslation: r = !0,
  /**
   * Classes that you need only in loading state
   */
  loadingClassName: i = "",
  ...a
}) => {
  const { isLocaleReady: s } = Fe();
  return o = (r ? !s : !1) || o, /* @__PURE__ */ m(
    e,
    {
      className: ae(
        o ? ae("font-size-0 bg-emphasis animate-pulse rounded-md text-transparent", i) : "",
        t
      ),
      ...a,
      children: n
    }
  );
}, Jn = ({
  className: e = "",
  invisible: t = !1,
  style: n
}) => /* @__PURE__ */ m(
  "span",
  {
    style: n,
    className: ae(
      "font-size-0 bg-emphasis inline-block animate-pulse rounded-md empty:before:inline-block empty:before:content-['']",
      e,
      t ? "invisible" : ""
    )
  }
), Tj = ({ children: e, as: t, className: n }) => /* @__PURE__ */ m(t || "div", { className: ae("animate-pulse", n), children: e }), uY = ({ className: e }) => /* @__PURE__ */ m(
  "li",
  {
    className: ae(
      "border-subtle group flex w-full items-center justify-between rounded-sm border px-[10px] py-3",
      e
    ),
    children: /* @__PURE__ */ m("div", { className: "flex-grow truncate text-sm", children: /* @__PURE__ */ Y("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ m(Jn, { className: "h-4 w-32" }),
      /* @__PURE__ */ m(Jn, { className: "h-4 w-4" })
    ] }) })
  }
);
function FAc() {
  return /* @__PURE__ */ m("div", { className: "loader border-brand-default dark:border-darkmodebrand", children: /* @__PURE__ */ m("span", { className: "loader-inner bg-brand dark:bg-darkmodebrand" }) });
}
const OM = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function PM(e, t, n, o = !1) {
  const r = String(t), i = (c, l) => `\x1B[${l[0]}m${c}\x1B[${l[1]}m`, a = (c, l) => l != null && typeof l == "string" ? i(c, OM[l]) : l != null && Array.isArray(l) ? l.reduce((d, u) => a(d, u), c) : l != null && l[c.trim()] != null ? a(c, l[c.trim()]) : l != null && l["*"] != null ? a(c, l["*"]) : c, s = null;
  return r.replace(/{{(.+?)}}/g, (c, l) => {
    var u;
    const d = n[l] != null ? String(n[l]) : o ? "" : c;
    return e.stylePrettyLogs ? a(d, ((u = e == null ? void 0 : e.prettyLogStyles) == null ? void 0 : u[l]) ?? s) + i("", OM.reset) : d;
  });
}
function nl(e, t = 2, n = 0) {
  return e != null && isNaN(e) ? "" : (e = e != null ? e + n : e, t === 2 ? e == null ? "--" : e < 10 ? "0" + e : e.toString() : e == null ? "---" : e < 10 ? "00" + e : e < 100 ? "0" + e : e.toString());
}
function VAc(e) {
  return {
    href: e.href,
    protocol: e.protocol,
    username: e.username,
    password: e.password,
    host: e.host,
    hostname: e.hostname,
    port: e.port,
    pathname: e.pathname,
    search: e.search,
    searchParams: [...e.searchParams].map(([t, n]) => ({ key: t, value: n })),
    hash: e.hash,
    origin: e.origin
  };
}
function tme(e) {
  const t = /* @__PURE__ */ new Set();
  return JSON.stringify(e, (n, o) => {
    if (typeof o == "object" && o !== null) {
      if (t.has(o))
        return "[Circular]";
      t.add(o);
    }
    return o;
  });
}
function Ka(e, t) {
  const n = {
    seen: [],
    stylize: nme
  };
  return t != null && ame(n, t), Sh(n.showHidden) && (n.showHidden = !1), Sh(n.depth) && (n.depth = 2), Sh(n.colors) && (n.colors = !0), Sh(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = UAc), wE(n, e, n.depth);
}
Ka.colors = OM;
Ka.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function BAc(e) {
  return typeof e == "boolean";
}
function Sh(e) {
  return e === void 0;
}
function nme(e) {
  return e;
}
function UAc(e, t) {
  var o, r, i, a;
  const n = Ka.styles[t];
  return n != null && ((r = (o = Ka == null ? void 0 : Ka.colors) == null ? void 0 : o[n]) == null ? void 0 : r[0]) != null && ((a = (i = Ka == null ? void 0 : Ka.colors) == null ? void 0 : i[n]) == null ? void 0 : a[1]) != null ? "\x1B[" + Ka.colors[n][0] + "m" + e + "\x1B[" + Ka.colors[n][1] + "m" : e;
}
function V2(e) {
  return typeof e == "function";
}
function ome(e) {
  return typeof e == "string";
}
function WAc(e) {
  return typeof e == "number";
}
function rme(e) {
  return e === null;
}
function ime(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function e6(e) {
  return NA(e) && Aj(e) === "[object RegExp]";
}
function NA(e) {
  return typeof e == "object" && e !== null;
}
function t6(e) {
  return NA(e) && (Aj(e) === "[object Error]" || e instanceof Error);
}
function _Y(e) {
  return NA(e) && Aj(e) === "[object Date]";
}
function Aj(e) {
  return Object.prototype.toString.call(e);
}
function GAc(e) {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}
function HAc(e, t, n, o, r) {
  const i = [];
  for (let a = 0, s = t.length; a < s; ++a)
    ime(t, String(a)) ? i.push(IM(e, t, n, o, String(a), !0)) : i.push("");
  return r.forEach((a) => {
    a.match(/^\d+$/) || i.push(IM(e, t, n, o, a, !0));
  }), i;
}
function n6(e) {
  return "[" + Error.prototype.toString.call(e) + "]";
}
function wE(e, t, n = 0) {
  if (e.customInspect && t != null && V2(t) && (t == null ? void 0 : t.inspect) !== Ka && !(t != null && t.constructor && (t == null ? void 0 : t.constructor.prototype) === t)) {
    if (typeof t.inspect != "function" && t.toString != null)
      return t.toString();
    let d = t == null ? void 0 : t.inspect(n, e);
    return ome(d) || (d = wE(e, d, n)), d;
  }
  const o = _p(e, t);
  if (o)
    return o;
  let r = Object.keys(t);
  const i = GAc(r);
  try {
    e.showHidden && Object.getOwnPropertyNames && (r = Object.getOwnPropertyNames(t));
  } catch {
  }
  if (t6(t) && (r.indexOf("message") >= 0 || r.indexOf("description") >= 0))
    return n6(t);
  if (r.length === 0)
    if (V2(e.stylize)) {
      if (V2(t)) {
        const d = t.name ? ": " + t.name : "";
        return e.stylize("[Function" + d + "]", "special");
      }
      if (e6(t))
        return e.stylize(RegExp.prototype.toString.call(t), "regexp");
      if (_Y(t))
        return e.stylize(Date.prototype.toISOString.call(t), "date");
      if (t6(t))
        return n6(t);
    } else
      return t;
  let a = "", s = !1, c = [`{
`, `
}`];
  if (Array.isArray(t) && (s = !0, c = [`[
`, `
]`]), V2(t) && (a = " [Function" + (t.name ? ": " + t.name : "") + "]"), e6(t) && (a = " " + RegExp.prototype.toString.call(t)), _Y(t) && (a = " " + Date.prototype.toUTCString.call(t)), t6(t) && (a = " " + n6(t)), r.length === 0 && (!s || t.length == 0))
    return c[0] + a + c[1];
  if (n < 0)
    return e6(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
  e.seen.push(t);
  let l;
  return s ? l = HAc(e, t, n, i, r) : l = r.map((d) => IM(e, t, n, i, d, s)), e.seen.pop(), KAc(l, a, c);
}
function IM(e, t, n, o, r, i) {
  let a, s, c = { value: void 0 };
  try {
    c.value = t[r];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (c = Object.getOwnPropertyDescriptor(t, r) || c);
  } catch {
  }
  if (c.get ? c.set ? s = e.stylize("[Getter/Setter]", "special") : s = e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), ime(o, r) || (a = "[" + r + "]"), s || (e.seen.indexOf(c.value) < 0 ? (rme(n) ? s = wE(e, c.value, void 0) : s = wE(e, c.value, n - 1), s.indexOf(`
`) > -1 && (i ? s = s.split(`
`).map((l) => "  " + l).join(`
`).substr(2) : s = `
` + s.split(`
`).map((l) => "   " + l).join(`
`))) : s = e.stylize("[Circular]", "special")), Sh(a)) {
    if (i && r.match(/^\d+$/))
      return s;
    a = JSON.stringify("" + r), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
  }
  return a + ": " + s;
}
function _p(e, t) {
  if (Sh(t))
    return e.stylize("undefined", "undefined");
  if (ome(t)) {
    const n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return e.stylize(n, "string");
  }
  if (WAc(t))
    return e.stylize("" + t, "number");
  if (BAc(t))
    return e.stylize("" + t, "boolean");
  if (rme(t))
    return e.stylize("null", "null");
}
function KAc(e, t, n) {
  return n[0] + (t === "" ? "" : t + `
`) + "  " + e.join(`,
  `) + " " + n[1];
}
function ame(e, t) {
  if (!t || !NA(t))
    return e;
  const n = { ...e }, o = { ...t }, r = Object.keys(t);
  let i = r.length;
  for (; i--; )
    n[r[i]] = o[r[i]];
  return e;
}
function YAc(e, ...t) {
  const n = {
    seen: [],
    stylize: nme
  };
  e != null && ame(n, e);
  const o = t[0];
  let r = 0, i = "", a = "";
  if (typeof o == "string") {
    if (t.length === 1)
      return o;
    let s, c = 0;
    for (let l = 0; l < o.length - 1; l++)
      if (o.charCodeAt(l) === 37) {
        const d = o.charCodeAt(++l);
        if (r + 1 !== t.length) {
          switch (d) {
            case 115: {
              const u = t[++r];
              typeof u == "number" || typeof u == "bigint" ? s = _p(n, u) : typeof u != "object" || u === null ? s = String(u) : s = Ka(u, {
                ...e,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              s = tme(t[++r]);
              break;
            case 100: {
              const u = t[++r];
              typeof u == "bigint" ? s = _p(n, u) : typeof u == "symbol" ? s = "NaN" : s = _p(n, u);
              break;
            }
            case 79:
              s = Ka(t[++r], e);
              break;
            case 111:
              s = Ka(t[++r], {
                ...e,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const u = t[++r];
              typeof u == "bigint" ? s = _p(n, u) : typeof u == "symbol" ? s = "NaN" : s = _p(n, parseInt(s));
              break;
            }
            case 102: {
              const u = t[++r];
              typeof u == "symbol" ? s = "NaN" : s = _p(n, parseInt(u));
              break;
            }
            case 99:
              r += 1, s = "";
              break;
            case 37:
              i += o.slice(c, l), c = l + 1;
              continue;
            default:
              continue;
          }
          c !== l - 1 && (i += o.slice(c, l - 1)), i += s, c = l + 1;
        } else
          d === 37 && (i += o.slice(c, l), c = l + 1);
      }
    c !== 0 && (r++, a = " ", c < o.length && (i += o.slice(c)));
  }
  for (; r < t.length; ) {
    const s = t[r];
    i += a, i += typeof s != "string" ? Ka(s, e) : s, a = " ", r++;
  }
  return i;
}
const ZAc = {
  getCallerStackFrame: sme,
  getErrorTrace: cme,
  getMeta: XAc,
  transportJSON: nCc,
  transportFormatted: tCc,
  isBuffer: oCc,
  isError: dme,
  prettyFormatLogObj: eCc,
  prettyFormatErrorObj: ume
};
var $ie;
const QAc = {
  runtime: [typeof window, typeof document].includes("undefined") ? "Generic" : "Browser",
  browser: ($ie = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : $ie.userAgent
}, JAc = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/;
function XAc(e, t, n, o, r, i) {
  return Object.assign({}, QAc, {
    name: r,
    parentNames: i,
    date: /* @__PURE__ */ new Date(),
    logLevelId: e,
    logLevelName: t,
    path: o ? void 0 : sme(n)
  });
}
function sme(e, t = Error()) {
  var n, o, r;
  return lme((r = (o = (n = t == null ? void 0 : t.stack) == null ? void 0 : n.split(`
`)) == null ? void 0 : o.filter((i) => !i.includes("Error: "))) == null ? void 0 : r[e]);
}
function cme(e) {
  var t, n, o;
  return (o = (n = (t = e == null ? void 0 : e.stack) == null ? void 0 : t.split(`
`)) == null ? void 0 : n.filter((r) => !r.includes("Error: "))) == null ? void 0 : o.reduce((r, i) => (r.push(lme(i)), r), []);
}
function lme(e) {
  var o;
  const t = (o = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : o.origin, n = {
    fullFilePath: void 0,
    fileName: void 0,
    fileNameWithLine: void 0,
    fileColumn: void 0,
    fileLine: void 0,
    filePath: void 0,
    filePathWithLine: void 0,
    method: void 0
  };
  if (e != null) {
    const r = e.match(JAc);
    if (r) {
      n.filePath = r[1].replace(/\?.*$/, ""), n.fullFilePath = `${t}${n.filePath}`;
      const i = n.filePath.split("/");
      n.fileName = i[i.length - 1], n.fileLine = r[2], n.fileColumn = r[3], n.filePathWithLine = `${n.filePath}:${n.fileLine}`, n.fileNameWithLine = `${n.fileName}:${n.fileLine}`;
    }
  }
  return n;
}
function dme(e) {
  return e instanceof Error;
}
function eCc(e, t) {
  return e.reduce((n, o) => (dme(o) ? n.errors.push(ume(o, t)) : n.args.push(o), n), { args: [], errors: [] });
}
function ume(e, t) {
  const n = cme(e).map((r) => PM(t, t.prettyErrorStackTemplate, { ...r }, !0)), o = {
    errorName: ` ${e.name} `,
    errorMessage: Object.getOwnPropertyNames(e).reduce((r, i) => (i !== "stack" && r.push(e[i]), r), []).join(", "),
    errorStack: n.join(`
`)
  };
  return PM(t, t.prettyErrorTemplate, o);
}
function tCc(e, t, n, o) {
  const r = (n.length > 0 && t.length > 0 ? `
` : "") + n.join(`
`);
  o.prettyInspectOptions.colors = o.stylePrettyLogs, console.log(e + YAc(o.prettyInspectOptions, ...t) + r);
}
function nCc(e) {
  console.log(tme(e));
}
function oCc(e) {
  return !1;
}
class rCc {
  constructor(t, n, o = 4) {
    var r, i, a, s, c, l, d, u;
    this.logObj = n, this.stackDepthLevel = o, this.runtime = ZAc, this.settings = {
      type: (t == null ? void 0 : t.type) ?? "pretty",
      name: t == null ? void 0 : t.name,
      parentNames: t == null ? void 0 : t.parentNames,
      minLevel: (t == null ? void 0 : t.minLevel) ?? 0,
      argumentsArrayName: t == null ? void 0 : t.argumentsArrayName,
      hideLogPositionForProduction: (t == null ? void 0 : t.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (t == null ? void 0 : t.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (t == null ? void 0 : t.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (t == null ? void 0 : t.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (t == null ? void 0 : t.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (t == null ? void 0 : t.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (t == null ? void 0 : t.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (t == null ? void 0 : t.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (t == null ? void 0 : t.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (t == null ? void 0 : t.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (t == null ? void 0 : t.metaProperty) ?? "_meta",
      maskPlaceholder: (t == null ? void 0 : t.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (t == null ? void 0 : t.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (t == null ? void 0 : t.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: t == null ? void 0 : t.maskValuesRegEx,
      prefix: [...(t == null ? void 0 : t.prefix) ?? []],
      attachedTransports: [...(t == null ? void 0 : t.attachedTransports) ?? []],
      overwrite: {
        mask: (r = t == null ? void 0 : t.overwrite) == null ? void 0 : r.mask,
        toLogObj: (i = t == null ? void 0 : t.overwrite) == null ? void 0 : i.toLogObj,
        addMeta: (a = t == null ? void 0 : t.overwrite) == null ? void 0 : a.addMeta,
        addPlaceholders: (s = t == null ? void 0 : t.overwrite) == null ? void 0 : s.addPlaceholders,
        formatMeta: (c = t == null ? void 0 : t.overwrite) == null ? void 0 : c.formatMeta,
        formatLogObj: (l = t == null ? void 0 : t.overwrite) == null ? void 0 : l.formatLogObj,
        transportFormatted: (d = t == null ? void 0 : t.overwrite) == null ? void 0 : d.transportFormatted,
        transportJSON: (u = t == null ? void 0 : t.overwrite) == null ? void 0 : u.transportJSON
      }
    };
  }
  log(t, n, ...o) {
    var u, _, p, f, g, h, b, v, $, k, S, O, I, D;
    if (t < this.settings.minLevel)
      return;
    const r = [...this.settings.prefix, ...o], i = ((u = this.settings.overwrite) == null ? void 0 : u.mask) != null ? (_ = this.settings.overwrite) == null ? void 0 : _.mask(r) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(r) : r, a = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, s = ((p = this.settings.overwrite) == null ? void 0 : p.toLogObj) != null ? (f = this.settings.overwrite) == null ? void 0 : f.toLogObj(i, a) : this._toLogObj(i, a), c = ((g = this.settings.overwrite) == null ? void 0 : g.addMeta) != null ? (h = this.settings.overwrite) == null ? void 0 : h.addMeta(s, t, n) : this._addMetaToLogObj(s, t, n);
    let l, d;
    return ((b = this.settings.overwrite) == null ? void 0 : b.formatMeta) != null && (l = (v = this.settings.overwrite) == null ? void 0 : v.formatMeta(c == null ? void 0 : c[this.settings.metaProperty])), (($ = this.settings.overwrite) == null ? void 0 : $.formatLogObj) != null && (d = (k = this.settings.overwrite) == null ? void 0 : k.formatLogObj(i, this.settings)), this.settings.type === "pretty" && (l = l ?? this._prettyFormatLogObjMeta(c == null ? void 0 : c[this.settings.metaProperty]), d = d ?? this.runtime.prettyFormatLogObj(i, this.settings)), l != null && d != null ? ((S = this.settings.overwrite) == null ? void 0 : S.transportFormatted) != null ? (O = this.settings.overwrite) == null || O.transportFormatted(l, d.args, d.errors, this.settings) : this.runtime.transportFormatted(l, d.args, d.errors, this.settings) : ((I = this.settings.overwrite) == null ? void 0 : I.transportJSON) != null ? (D = this.settings.overwrite) == null || D.transportJSON(c) : this.settings.type !== "hidden" && this.runtime.transportJSON(c), this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((M) => {
      M(c);
    }), c;
  }
  attachTransport(t) {
    this.settings.attachedTransports.push(t);
  }
  getSubLogger(t, n) {
    var i, a, s;
    const o = {
      ...this.settings,
      ...t,
      parentNames: ((i = this.settings) == null ? void 0 : i.parentNames) != null && ((a = this.settings) == null ? void 0 : a.name) != null ? [...this.settings.parentNames, this.settings.name] : ((s = this.settings) == null ? void 0 : s.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(t == null ? void 0 : t.prefix) ?? []]
    };
    return new this.constructor(o, n ?? this.logObj, this.stackDepthLevel);
  }
  _mask(t) {
    const n = this.settings.maskValuesOfKeysCaseInsensitive !== !0 ? this.settings.maskValuesOfKeys : this.settings.maskValuesOfKeys.map((o) => o.toLowerCase());
    return t == null ? void 0 : t.map((o) => this._recursiveCloneAndMaskValuesOfKeys(o, n));
  }
  _recursiveCloneAndMaskValuesOfKeys(t, n, o = []) {
    var r, i;
    if (o.includes(t))
      return { ...t };
    if (typeof t == "object" && t !== null && o.push(t), this.runtime.isError(t) || this.runtime.isBuffer(t))
      return t;
    if (t instanceof Map)
      return new Map(t);
    if (t instanceof Set)
      return new Set(t);
    if (Array.isArray(t))
      return t.map((a) => this._recursiveCloneAndMaskValuesOfKeys(a, n, o));
    if (t instanceof Date)
      return new Date(t.getTime());
    if (t instanceof URL)
      return VAc(t);
    if (t !== null && typeof t == "object") {
      const a = this.runtime.isError(t) ? this._cloneError(t) : Object.create(Object.getPrototypeOf(t));
      return Object.getOwnPropertyNames(t).reduce((s, c) => {
        var l;
        return s[c] = n.includes(((l = this.settings) == null ? void 0 : l.maskValuesOfKeysCaseInsensitive) !== !0 ? c : c.toLowerCase()) ? this.settings.maskPlaceholder : this._recursiveCloneAndMaskValuesOfKeys(t[c], n, o), s;
      }, a);
    } else {
      if (typeof t == "string") {
        let a = t;
        for (const s of ((r = this.settings) == null ? void 0 : r.maskValuesRegEx) || [])
          a = a.replace(s, ((i = this.settings) == null ? void 0 : i.maskPlaceholder) || "");
        return a;
      }
      return t;
    }
  }
  _recursiveCloneAndExecuteFunctions(t, n = []) {
    return this.isObjectOrArray(t) && n.includes(t) ? this.shallowCopy(t) : (this.isObjectOrArray(t) && n.push(t), Array.isArray(t) ? t.map((o) => this._recursiveCloneAndExecuteFunctions(o, n)) : t instanceof Date ? new Date(t.getTime()) : this.isObject(t) ? Object.getOwnPropertyNames(t).reduce((o, r) => {
      const i = Object.getOwnPropertyDescriptor(t, r);
      if (i) {
        Object.defineProperty(o, r, i);
        const a = t[r];
        o[r] = typeof a == "function" ? a() : this._recursiveCloneAndExecuteFunctions(a, n);
      }
      return o;
    }, Object.create(Object.getPrototypeOf(t))) : t);
  }
  isObjectOrArray(t) {
    return typeof t == "object" && t !== null;
  }
  isObject(t) {
    return typeof t == "object" && !Array.isArray(t) && t !== null;
  }
  shallowCopy(t) {
    return Array.isArray(t) ? [...t] : { ...t };
  }
  _toLogObj(t, n = {}) {
    return t = t == null ? void 0 : t.map((o) => this.runtime.isError(o) ? this._toErrorObject(o) : o), this.settings.argumentsArrayName == null ? t.length === 1 && !Array.isArray(t[0]) && this.runtime.isBuffer(t[0]) !== !0 && !(t[0] instanceof Date) ? n = typeof t[0] == "object" && t[0] != null ? { ...t[0], ...n } : { 0: t[0], ...n } : n = { ...n, ...t } : n = {
      ...n,
      [this.settings.argumentsArrayName]: t
    }, n;
  }
  _cloneError(t) {
    const n = new t.constructor();
    return Object.getOwnPropertyNames(t).forEach((o) => {
      n[o] = t[o];
    }), n;
  }
  _toErrorObject(t) {
    return {
      nativeError: t,
      name: t.name ?? "Error",
      message: t.message,
      stack: this.runtime.getErrorTrace(t)
    };
  }
  _addMetaToLogObj(t, n, o) {
    return {
      ...t,
      [this.settings.metaProperty]: this.runtime.getMeta(n, o, this.stackDepthLevel, this.settings.hideLogPositionForProduction, this.settings.name, this.settings.parentNames)
    };
  }
  _prettyFormatLogObjMeta(t) {
    var a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O, I, D, M, N, C;
    if (t == null)
      return "";
    let n = this.settings.prettyLogTemplate;
    const o = {};
    n.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? n = n.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : this.settings.prettyLogTimeZone === "UTC" ? (o.yyyy = ((a = t == null ? void 0 : t.date) == null ? void 0 : a.getUTCFullYear()) ?? "----", o.mm = nl((s = t == null ? void 0 : t.date) == null ? void 0 : s.getUTCMonth(), 2, 1), o.dd = nl((c = t == null ? void 0 : t.date) == null ? void 0 : c.getUTCDate(), 2), o.hh = nl((l = t == null ? void 0 : t.date) == null ? void 0 : l.getUTCHours(), 2), o.MM = nl((d = t == null ? void 0 : t.date) == null ? void 0 : d.getUTCMinutes(), 2), o.ss = nl((u = t == null ? void 0 : t.date) == null ? void 0 : u.getUTCSeconds(), 2), o.ms = nl((_ = t == null ? void 0 : t.date) == null ? void 0 : _.getUTCMilliseconds(), 3)) : (o.yyyy = ((p = t == null ? void 0 : t.date) == null ? void 0 : p.getFullYear()) ?? "----", o.mm = nl((f = t == null ? void 0 : t.date) == null ? void 0 : f.getMonth(), 2, 1), o.dd = nl((g = t == null ? void 0 : t.date) == null ? void 0 : g.getDate(), 2), o.hh = nl((h = t == null ? void 0 : t.date) == null ? void 0 : h.getHours(), 2), o.MM = nl((b = t == null ? void 0 : t.date) == null ? void 0 : b.getMinutes(), 2), o.ss = nl((v = t == null ? void 0 : t.date) == null ? void 0 : v.getSeconds(), 2), o.ms = nl(($ = t == null ? void 0 : t.date) == null ? void 0 : $.getMilliseconds(), 3));
    const r = this.settings.prettyLogTimeZone === "UTC" ? t == null ? void 0 : t.date : new Date(((k = t == null ? void 0 : t.date) == null ? void 0 : k.getTime()) - ((S = t == null ? void 0 : t.date) == null ? void 0 : S.getTimezoneOffset()) * 6e4);
    o.rawIsoStr = r == null ? void 0 : r.toISOString(), o.dateIsoStr = r == null ? void 0 : r.toISOString().replace("T", " ").replace("Z", ""), o.logLevelName = t == null ? void 0 : t.logLevelName, o.fileNameWithLine = ((O = t == null ? void 0 : t.path) == null ? void 0 : O.fileNameWithLine) ?? "", o.filePathWithLine = ((I = t == null ? void 0 : t.path) == null ? void 0 : I.filePathWithLine) ?? "", o.fullFilePath = ((D = t == null ? void 0 : t.path) == null ? void 0 : D.fullFilePath) ?? "";
    let i = (M = this.settings.parentNames) == null ? void 0 : M.join(this.settings.prettyErrorParentNamesSeparator);
    return i = i != null && (t == null ? void 0 : t.name) != null ? i + this.settings.prettyErrorParentNamesSeparator : void 0, o.name = (t == null ? void 0 : t.name) != null || i != null ? (i ?? "") + (t == null ? void 0 : t.name) : "", o.nameWithDelimiterPrefix = o.name.length > 0 ? this.settings.prettyErrorLoggerNameDelimiter + o.name : "", o.nameWithDelimiterSuffix = o.name.length > 0 ? o.name + this.settings.prettyErrorLoggerNameDelimiter : "", ((N = this.settings.overwrite) == null ? void 0 : N.addPlaceholders) != null && ((C = this.settings.overwrite) == null || C.addPlaceholders(t, o)), PM(this.settings, n, o);
  }
}
class iCc extends rCc {
  constructor(t, n) {
    const o = typeof window < "u" && typeof document < "u", r = o ? window.chrome !== void 0 && window.CSS !== void 0 && window.CSS.supports("color", "green") : !1, i = o ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
    t = t || {}, t.stylePrettyLogs = t.stylePrettyLogs && o && !r ? !1 : t.stylePrettyLogs, super(t, n, i ? 4 : 5);
  }
  log(t, n, ...o) {
    return super.log(t, n, ...o);
  }
  silly(...t) {
    return super.log(0, "SILLY", ...t);
  }
  trace(...t) {
    return super.log(1, "TRACE", ...t);
  }
  debug(...t) {
    return super.log(2, "DEBUG", ...t);
  }
  info(...t) {
    return super.log(3, "INFO", ...t);
  }
  warn(...t) {
    return super.log(4, "WARN", ...t);
  }
  error(...t) {
    return super.log(5, "ERROR", ...t);
  }
  fatal(...t) {
    return super.log(6, "FATAL", ...t);
  }
  getSubLogger(t, n) {
    return super.getSubLogger(t, n);
  }
}
var aCc = {};
const sCc = new iCc({
  minLevel: parseInt(aCc.NEXT_PUBLIC_LOGGER_LEVEL || "4"),
  maskValuesOfKeys: ["password", "passwordConfirmation", "credentials", "credential"],
  prettyLogTimeZone: AS ? "UTC" : "local",
  prettyErrorStackTemplate: `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
  // default
  prettyErrorTemplate: `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
  // default
  prettyLogTemplate: "{{hh}}:{{MM}}:{{ss}}:{{ms}} [{{logLevelName}}] ",
  // default with exclusion of `{{filePathWithLine}}`
  stylePrettyLogs: !AS,
  prettyLogStyles: {
    name: "yellow",
    dateIsoStr: "blue"
  },
  type: AS ? "json" : "pretty"
}), DA = sCc;
function Fw(e) {
  try {
    return e instanceof Error ? JSON.stringify(e.stack ?? e.message) : JSON.stringify(e);
  } catch {
    return e;
  }
}
function cCc({
  periodType: e,
  periodDays: t,
  periodCountCalendarDays: n,
  periodStartDate: o,
  periodEndDate: r,
  /**
   * These dates will be considered in the same utfcOffset as provided
   */
  allDatesWithBookabilityStatusInBookerTz: i,
  eventUtcOffset: a,
  bookerUtcOffset: s,
  /**
   * This is temporary till we find a way to provide allDatesWithBookabilityStatus in handleNewBooking without re-computing availability.
   * It is okay for handleNewBooking to pass it as true as the frontend won't allow selecting a timeslot that is out of bounds of ROLLING_WINDOW
   * But for the booking that happen through API, we absolutely need to check the ROLLING_WINDOW limits.
   */
  _skipRollingWindowCheck: c
}) {
  const l = De(), d = l.utcOffset(a), u = l.utcOffset(s);
  switch (t = t || 0, DA.getSubLogger({ prefix: ["calculatePeriodLimits"] }).debug(
    Fw({
      periodType: e,
      periodDays: t,
      periodCountCalendarDays: n,
      periodStartDate: o,
      periodEndDate: r,
      currentTime: d.format()
    })
  ), e) {
    case ka.ROLLING:
      return {
        endOfRollingPeriodEndDayInBookerTz: (n ? u.add(t, "days") : u.businessDaysAdd(t)).endOf("day"),
        startOfRangeStartDayInEventTz: null,
        endOfRangeEndDayInEventTz: null
      };
    case ka.ROLLING_WINDOW: {
      if (c)
        return {
          endOfRollingPeriodEndDayInBookerTz: null,
          startOfRangeStartDayInEventTz: null,
          endOfRangeEndDayInEventTz: null
        };
      if (!i)
        throw new Error("`allDatesWithBookabilityStatus` is required");
      return {
        endOfRollingPeriodEndDayInBookerTz: lCc({
          startDateInBookerTz: u,
          daysNeeded: t,
          allDatesWithBookabilityStatusInBookerTz: i,
          countNonBusinessDays: n
        }),
        startOfRangeStartDayInEventTz: null,
        endOfRangeEndDayInEventTz: null
      };
    }
    case ka.RANGE: {
      const p = De(o).utcOffset(a).startOf("day"), f = De(r).utcOffset(a).endOf("day");
      return {
        endOfRollingPeriodEndDayInBookerTz: null,
        startOfRangeStartDayInEventTz: p,
        endOfRangeEndDayInEventTz: f
      };
    }
  }
  return {
    endOfRollingPeriodEndDayInBookerTz: null,
    startOfRangeStartDayInEventTz: null,
    endOfRangeEndDayInEventTz: null
  };
}
function lCc({
  startDateInBookerTz: e,
  daysNeeded: t,
  allDatesWithBookabilityStatusInBookerTz: n,
  countNonBusinessDays: o
}) {
  var _;
  const r = DA.getSubLogger({ prefix: ["getRollingWindowEndDate"] });
  r.debug("called:", Fw({ startDay: e.format(), daysNeeded: t }));
  let i = 1, a;
  const s = e.startOf("day"), c = fD;
  let l = 0, d = s;
  for (; l < t && !(i > c); ) {
    const p = d.format("YYYY-MM-DD"), f = !!((_ = n[p]) != null && _.isBookable);
    f && (l++, a = d), r.silly(
      `Loop Iteration: ${i}`,
      Fw({
        iterationDayBeginning: d.format(),
        isBookable: f,
        bookableDaysCount: l,
        rollingEndDay: a == null ? void 0 : a.format(),
        allDatesWithBookabilityStatusInBookerTz: n
      })
    ), d = o ? d.add(1, "days") : d.businessDaysAdd(1), i++;
  }
  const u = (a ?? d).endOf("day");
  return r.debug("Returning rollingEndDay", u.format()), u;
}
function dCc({
  time: e,
  periodLimits: t
}) {
  const n = DA.getSubLogger({ prefix: ["isTimeViolatingFutureLimit"] }), o = new Date(e);
  if (t.endOfRollingPeriodEndDayInBookerTz) {
    const r = o.valueOf() > t.endOfRollingPeriodEndDayInBookerTz.valueOf();
    return r && n.warn(
      "Booking is out of bounds due to rolling period end day.",
      Fw({
        formattedDate: o.toISOString(),
        isAfterRollingEndDay: r,
        endOfRollingPeriodEndDayTs: t.endOfRollingPeriodEndDayInBookerTz.valueOf()
      })
    ), r;
  }
  if (t.startOfRangeStartDayInEventTz && t.endOfRangeEndDayInEventTz) {
    const r = o.valueOf() < t.startOfRangeStartDayInEventTz.valueOf(), i = o.valueOf() > t.endOfRangeEndDayInEventTz.valueOf();
    return (r || i) && n.warn(
      "Booking is out of bounds due to range start and end.",
      Fw({
        formattedDate: o.toISOString(),
        isBeforeRangeStart: r,
        isAfterRangeEnd: i,
        startOfRangeStartDayInEventTz: t.startOfRangeStartDayInEventTz.toDate().toISOString(),
        endOfRangeEndDayInEventTz: t.endOfRangeEndDayInEventTz.toDate().toISOString()
      })
    ), r || i;
  }
  return !1;
}
const uCc = (e, t) => {
  const { periodDays: n, periodType: o, periodCountCalendarDays: r, periodEndDate: i, periodStartDate: a } = t, s = cCc({
    periodType: o,
    periodDays: n,
    periodCountCalendarDays: r,
    periodStartDate: a,
    periodEndDate: i,
    allDatesWithBookabilityStatusInBookerTz: null,
    // Temporary workaround
    _skipRollingWindowCheck: !0,
    eventUtcOffset: 0,
    bookerUtcOffset: 0
  });
  return dCc({
    time: e.add(1, "month").startOf("month").toDate(),
    periodLimits: s
  });
}, _Cc = (e, t) => {
  const { t: n } = Fe();
  if (!e)
    return "";
  if (t.periodType === "ROLLING") {
    const o = t.periodCountCalendarDays ? n("calendar_days") : n("business_days");
    return n("no_availability_rolling", { days: `${t.periodDays} ${o}` });
  }
  return t.periodType === "RANGE" ? n("no_availability_range", { date: De(t.periodEndDate).format("MMMM D YYYY") }) : "";
}, pCc = ({
  month: e,
  nextMonthButton: t,
  browsingDate: n,
  periodData: o
}) => {
  const { t: r } = Fe(), [i, a] = ze(!0), s = uCc(n, o), c = _Cc(s, o), l = () => {
    a(!1);
  };
  return /* @__PURE__ */ m(
    Ff,
    {
      open: i,
      onOpenChange: (d) => {
        a(d);
      },
      children: /* @__PURE__ */ m(
        Ei,
        {
          title: r("no_availability_in_month", { month: e }),
          type: "creation",
          description: c,
          preventCloseOnOutsideClick: !1,
          children: /* @__PURE__ */ Y(Fc, { children: [
            /* @__PURE__ */ m(
              ca,
              {
                color: s ? "primary" : "secondary",
                onClick: l,
                "data-testid": "close_dialog_button",
                children: r("close")
              }
            ),
            !s && /* @__PURE__ */ m(
              ut,
              {
                color: "primary",
                onClick: t,
                "data-testid": "view_next_month",
                EndIcon: "arrow-right",
                children: r("view_next_month")
              }
            )
          ] })
        }
      )
    }
  );
}, mCc = pCc, fCc = ({
  date: e,
  active: t,
  disabled: n,
  away: o,
  emoji: r,
  customClassName: i,
  showMonthTooltip: a,
  isFirstDayOfNextMonth: s,
  ...c
}) => {
  const { t: l } = Fe(), d = rY("enabledDateButton"), u = rY("disabledDateButton"), _ = /* @__PURE__ */ Y(
    "button",
    {
      type: "button",
      style: n ? { ...u } : { ...d },
      className: ae(
        "disabled:text-bookinglighter absolute bottom-0 left-0 right-0 top-0 mx-auto w-full rounded-md border-2 border-transparent text-center text-sm font-medium transition disabled:cursor-default disabled:border-transparent disabled:font-light ",
        t ? "bg-brand-default text-brand" : n ? `${i ? "" : " text-mute"}` : `${i != null && i.dayActive ? `hover:border-brand-default ${i.dayActive}` : "hover:border-brand-default text-emphasis bg-emphasis"}`
      ),
      "data-testid": "day",
      "data-disabled": n,
      disabled: n,
      ...c,
      children: [
        o && /* @__PURE__ */ m("span", { "data-testid": "away-emoji", children: r }),
        !o && e.date(),
        e.isToday() && /* @__PURE__ */ m(
          "span",
          {
            className: ae(
              "bg-brand-default absolute left-1/2 top-1/2 flex h-[5px] w-[5px] -translate-x-1/2 translate-y-[8px] items-center justify-center rounded-full align-middle sm:translate-y-[12px]",
              t && "bg-brand-accent"
            ),
            children: /* @__PURE__ */ m("span", { className: "sr-only", children: l("today") })
          }
        )
      ]
    }
  ), p = a ? /* @__PURE__ */ m(Ao, { content: e.format("MMMM"), children: _ }) : _;
  return /* @__PURE__ */ Y(Ce, { children: [
    s && /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "absolute top-0 z-10 mx-auto w-fit rounded-full font-semibold uppercase tracking-wide",
          t ? "text-white" : "text-default",
          n && "bg-emphasis"
        ),
        style: {
          fontSize: "10px",
          lineHeight: "13px",
          padding: n ? "0 3px" : "3px 3px 3px 4px"
        },
        children: e.format("MMM")
      }
    ),
    p
  ] });
}, gCc = ({
  minDate: e,
  excludedDates: t = [],
  browsingDate: n,
  weekStart: o,
  DayComponent: r = fCc,
  selected: i,
  month: a,
  nextMonthButton: s,
  eventSlug: c,
  slots: l,
  customClassName: d,
  isBookingInPast: u,
  periodData: _,
  isCompact: p,
  showNoAvailabilityDialog: f = !0,
  ...g
}) => {
  const h = jAc({
    browsingDate: n.toDate(),
    minDate: e,
    includedDates: g.includedDates
  }), b = De(), v = n.startOf("month"), $ = b.isAfter(v.add(2, "week"));
  let k = [];
  const S = (P) => (n.set("date", P).day() - o + 7) % 7, O = Xpe(n), I = $ && !p;
  if (I) {
    const x = S(8);
    k = Array(x).fill(null);
    for (let z = 8; z <= O; z++)
      k.push(n.set("date", z));
    const w = k.length % 7, E = (w > 0 ? 7 - w : 0) + 7, T = n.add(1, "month");
    for (let z = 0; z < E; z++)
      k.push(T.set("date", 1 + z));
  } else {
    const P = S(1);
    k = Array(P).fill(null);
    for (let x = 1; x <= O; x++)
      k.push(n.set("date", x));
  }
  const [D] = St((P) => [P.selectedDatesAndTimes], Fr), M = (P) => Array.isArray(i) ? Array.isArray(i) && (i == null ? void 0 : i.some((x) => gs(x) === gs(P))) : i && gs(i) === gs(P) ? !0 : c && D && D[c] && Object.keys(D[c]).length > 0 ? Object.keys(D[c]).some((x) => gs(De(x)) === gs(P)) : !1, N = k.map((P) => {
    if (!P)
      return { day: null, disabled: !0 };
    const x = gs(P), w = (l == null ? void 0 : l[x]) || [], E = w.find((W) => W.away) || null, T = P.month() !== n.month(), z = $ && !p && T && P.date() === 1, j = h == null ? void 0 : h.includes(x), q = t.includes(x), V = w.some((W) => !W.away), L = w.length > 0 && w.every((W) => W.away), U = L ? !(E != null && E.toUser) : T ? !V : !j || q;
    return {
      day: P,
      disabled: U,
      away: L,
      emoji: E == null ? void 0 : E.emoji,
      isFirstDayOfNextMonth: z
    };
  });
  return Le(() => {
    var w;
    if (i instanceof Array)
      return;
    const P = (w = N.find((E) => !E.disabled)) == null ? void 0 : w.day, x = i ? N.some(({ day: E, disabled: T }) => {
      if (E && gs(E) === gs(i) && !T)
        return !0;
    }) : !1;
    if (!x && P) {
      const E = !(i != null && i.isValid());
      g.onChange(P, E);
    }
    x && g.onChange(De(i), !0), P || g.onChange(null);
  }), /* @__PURE__ */ Y(Ce, { children: [
    N.map(({ day: P, disabled: x, away: w, emoji: E, isFirstDayOfNextMonth: T }, z) => /* @__PURE__ */ m("div", { className: "relative w-full pt-[100%]", children: P === null ? /* @__PURE__ */ m("div", {}, `e-${z}`) : g.isLoading ? /* @__PURE__ */ m(
      "button",
      {
        className: "bg-muted text-muted absolute bottom-0 left-0 right-0 top-0 mx-auto flex w-full items-center justify-center rounded-sm border-transparent text-center font-medium opacity-90 transition",
        disabled: !0,
        children: /* @__PURE__ */ m(Jn, { className: "h-8 w-9" })
      },
      `e-${z}`
    ) : /* @__PURE__ */ m(
      r,
      {
        customClassName: {
          dayContainer: d == null ? void 0 : d.datePickerDate,
          dayActive: d == null ? void 0 : d.datePickerDateActive
        },
        date: P,
        onClick: () => {
          var j;
          g.onChange(P), (j = g == null ? void 0 : g.scrollToTimeSlots) == null || j.call(g);
        },
        disabled: x,
        active: M(P),
        away: w,
        emoji: E,
        showMonthTooltip: I && !x && P.month() !== n.month(),
        isFirstDayOfNextMonth: T
      }
    ) }, P === null ? `e-${z}` : `day-${P.format()}`)),
    !g.isLoading && !u && h && (h == null ? void 0 : h.length) === 0 && f && /* @__PURE__ */ m(
      mCc,
      {
        month: a,
        nextMonthButton: s,
        browsingDate: n,
        periodData: _
      }
    )
  ] });
}, _me = ({
  weekStart: e = 0,
  className: t,
  locale: n,
  selected: o,
  onMonthChange: r,
  slots: i,
  customClassNames: a,
  includedDates: s,
  periodData: c = {
    periodStartDate: null,
    periodEndDate: null,
    periodCountCalendarDays: null,
    periodDays: null,
    periodType: "UNLIMITED"
  },
  isCompact: l,
  showNoAvailabilityDialog: d,
  ...u
}) => {
  const _ = u.minDate, p = u.browsingDate || De().startOf("month"), f = _ && p.valueOf() < _.valueOf() ? De(_) : p, { i18n: g, t: h } = Fe(), b = St((S) => S.bookingData), v = b ? new Date(b.endTime) < /* @__PURE__ */ new Date() : !1, $ = (S) => {
    r && r(f.add(S, "month"));
  }, k = f ? new Intl.DateTimeFormat(g.language, { month: "long" }).format(
    new Date(f.year(), f.month())
  ) : null;
  return /* @__PURE__ */ Y("div", { className: t, children: [
    /* @__PURE__ */ Y("div", { className: "mb-1 flex items-center justify-between text-xl", children: [
      /* @__PURE__ */ m("span", { className: "text-default w-1/2 text-base", children: f ? /* @__PURE__ */ Y("time", { dateTime: f.format("YYYY-MM"), "data-testid": "selected-month-label", children: [
        /* @__PURE__ */ m(
          "strong",
          {
            className: ae("text-emphasis font-semibold", a == null ? void 0 : a.datePickerTitle),
            children: k
          }
        ),
        " ",
        /* @__PURE__ */ m("span", { className: ae("text-subtle font-medium", a == null ? void 0 : a.datePickerTitle), children: f.format("YYYY") })
      ] }) : /* @__PURE__ */ m(Jn, { className: "h-8 w-24" }) }),
      /* @__PURE__ */ m("div", { className: "text-emphasis", children: /* @__PURE__ */ Y("div", { className: "flex", children: [
        /* @__PURE__ */ m(
          ut,
          {
            className: ae(
              "group p-1 opacity-70 transition hover:opacity-100 rtl:rotate-180",
              !f.isAfter(De()) && "disabled:text-bookinglighter hover:bg-background hover:opacity-70",
              a == null ? void 0 : a.datePickerToggle
            ),
            onClick: () => $(-1),
            disabled: !f.isAfter(De()),
            "data-testid": "decrementMonth",
            color: "minimal",
            variant: "icon",
            StartIcon: "chevron-left",
            "aria-label": h("view_previous_month")
          }
        ),
        /* @__PURE__ */ m(
          ut,
          {
            className: ae(
              "group p-1 opacity-70 transition hover:opacity-100 rtl:rotate-180",
              `${a == null ? void 0 : a.datePickerToggle}`
            ),
            onClick: () => $(1),
            "data-testid": "incrementMonth",
            color: "minimal",
            variant: "icon",
            StartIcon: "chevron-right",
            "aria-label": h("view_next_month")
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ m("div", { className: "border-subtle mb-2 grid grid-cols-7 gap-4 border-b border-t text-center md:mb-0 md:border-0", children: ab(n, e, "short").map((S) => /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "text-emphasis my-4 text-xs font-medium uppercase tracking-widest",
          a == null ? void 0 : a.datePickerDays
        ),
        children: S
      },
      S
    )) }),
    /* @__PURE__ */ m("div", { className: "relative grid grid-cols-7 grid-rows-6 gap-1 text-center", children: /* @__PURE__ */ m(
      gCc,
      {
        customClassName: {
          datePickerDate: a == null ? void 0 : a.datePickersDates,
          datePickerDateActive: a == null ? void 0 : a.datePickerDatesActive
        },
        weekStart: e,
        selected: o,
        ...u,
        browsingDate: f,
        month: k,
        nextMonthButton: () => $(1),
        slots: i,
        includedDates: s,
        isBookingInPast: v,
        periodData: c,
        isCompact: l,
        showNoAvailabilityDialog: d
      }
    ) })
  ] });
}, pme = _me, hCc = {
  start: new Date((/* @__PURE__ */ new Date()).setUTCHours(9, 0, 0, 0)),
  end: new Date((/* @__PURE__ */ new Date()).setUTCHours(17, 0, 0, 0))
};
function mme(e, { locale: t, hour12: n }) {
  const o = (i) => i.days.slice(1).reduce(
    (s, c) => (s[s.length - 1].length === 1 && s[s.length - 1][0] === c - 1 ? s[s.length - 1].push(c) : s[s.length - 1][s[s.length - 1].length - 1] === c - 1 ? s[s.length - 1] = [s[s.length - 1][0], c] : s.push([c]), s),
    [[i.days[0]]]
  ).map((s) => s.map((c) => Ej(t, c, "short")).join(" - ")).join(", "), r = (i) => `${new Intl.DateTimeFormat(t, { hour: "numeric", minute: "numeric", hour12: n }).format(
    new Date(i.startTime.toISOString().slice(0, -1))
  )} - ${new Intl.DateTimeFormat(t, { hour: "numeric", minute: "numeric", hour12: n }).format(
    new Date(i.endTime.toISOString().slice(0, -1))
  )}`;
  return `${o(e)}, ${r(e)}`;
}
function tk() {
  return bo.viewer.me.get.useQuery(void 0, {
    retry(t) {
      return t > 3;
    }
  });
}
const El = Lpc, Bc = it(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    qpc,
    {
      ...t,
      className: ae(
        !t.asChild && `focus:bg-subtle hover:bg-muted text-default group-hover:text-emphasis inline-flex items-center rounded-md bg-transparent px-3 py-2 text-sm font-medium ring-0 transition ${e}`
      ),
      ref: n
    }
  )
);
Bc.displayName = "DropdownMenuTrigger";
const fme = jpc, Uc = it(
  ({ children: e, sideOffset: t = 2, align: n = "end", ...o }, r) => /* @__PURE__ */ m(
    Fpc,
    {
      align: n,
      ...o,
      sideOffset: t,
      className: ae(
        "shadow-dropdown bg-default border-subtle relative z-10 origin-top-right space-y-[1px] rounded-xl border p-1 text-sm",
        "w-[220px]",
        o.className
      ),
      ref: r,
      children: e
    }
  )
);
Uc.displayName = "DropdownMenuContent";
const Er = it(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    Vpc,
    {
      className: `focus:ring-brand-default hover:bg-subtle hover:text-emphasis text-default text-sm ring-inset first-of-type:rounded-t-[inherit] last-of-type:rounded-b-[inherit] hover:ring-0 focus:outline-none focus:ring-1 ${e}`,
      ...t,
      ref: n
    }
  )
);
Er.displayName = "DropdownMenuItem";
const vCc = it(
  ({ children: e, checked: t, onCheckedChange: n, ...o }, r) => /* @__PURE__ */ Y(
    Bpc,
    {
      ...o,
      checked: t,
      onCheckedChange: n,
      ref: r,
      className: "hover:text-emphasis text-default hover:bg-subtle flex flex-1 items-center space-x-2 px-3 py-2 hover:outline-none hover:ring-0 disabled:cursor-not-allowed",
      children: [
        /* @__PURE__ */ m("div", { className: "w-full", children: e }),
        !t && /* @__PURE__ */ m(
          "input",
          {
            "aria-disabled": !0,
            "aria-label": typeof e == "string" ? `Not active ${e}` : void 0,
            "aria-readonly": !0,
            checked: !1,
            type: "checkbox",
            className: "text-emphasis dark:text-muted focus:ring-emphasis border-default bg-default ml-auto h-4 w-4 rounded transition hover:cursor-pointer"
          }
        ),
        /* @__PURE__ */ m(uce, { asChild: !0, children: /* @__PURE__ */ m(
          "input",
          {
            "aria-disabled": !0,
            "aria-readonly": !0,
            "aria-label": typeof e == "string" ? `Active ${e}` : void 0,
            checked: !0,
            type: "checkbox",
            className: "text-emphasis dark:text-muted focus:ring-emphasis border-default bg-default h-4 w-4 rounded transition hover:cursor-pointer"
          }
        ) })
      ]
    }
  )
);
vCc.displayName = "DropdownMenuCheckboxItem";
const bCc = it(
  ({ children: e, ...t }, n) => /* @__PURE__ */ Y(Upc, { ...t, ref: n, children: [
    e,
    /* @__PURE__ */ m(uce, { children: /* @__PURE__ */ m(ot, { name: "circle-check" }) })
  ] })
);
bCc.displayName = "DropdownMenuRadioItem";
function gme({ href: e, ...t }) {
  const n = typeof e < "u", r = /* @__PURE__ */ m(n ? "a" : "button", { ...t });
  return n ? /* @__PURE__ */ m(Po, { href: e, legacyBehavior: !0, children: r }) : r;
}
const ei = (e) => {
  const { CustomStartIcon: t, StartIcon: n, EndIcon: o, children: r, color: i, childrenClassName: a, ...s } = e;
  return /* @__PURE__ */ m(
    gme,
    {
      ...s,
      className: ae(
        "hover:text-emphasis text-default inline-flex w-full items-center space-x-1 rounded-lg  p-2 disabled:cursor-not-allowed",
        i === "destructive" ? "hover:bg-error hover:text-error text-error" : "hover:bg-subtle",
        e.className
      ),
      children: /* @__PURE__ */ Y(Ce, { children: [
        t || n && /* @__PURE__ */ m(ot, { name: n, className: "mr-1 h-4 w-4" }),
        /* @__PURE__ */ m("div", { className: ae("w-full text-left text-sm font-medium leading-none", a), children: r }),
        o && /* @__PURE__ */ m(ot, { name: o, className: "h-4 w-4" })
      ] })
    }
  );
}, kE = it(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ m(
    Wpc,
    {
      className: ae("bg-emphasis -mx-1 my-1 h-px", e),
      ...t,
      ref: n
    }
  )
);
kE.displayName = "DropdownMenuSeparator";
var yCc = {};
const $Cc = ({
  name: e,
  weekday: t,
  control: n,
  CopyButton: o,
  disabled: r,
  labels: i,
  userTimeFormat: a,
  classNames: s
}) => {
  const { watch: c, setValue: l } = Dn(), d = c(e);
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "flex w-full flex-col gap-4 last:mb-0 sm:flex-row sm:gap-6 sm:px-0",
        s == null ? void 0 : s.scheduleDay
      ),
      "data-testid": t,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: ae(
              "flex h-[36px] items-center justify-between sm:w-32",
              s == null ? void 0 : s.labelAndSwitchContainer
            ),
            children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ Y("label", { className: "text-default flex flex-row items-center space-x-2 rtl:space-x-reverse", children: [
              /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
                Ri,
                {
                  disabled: !d || r,
                  defaultChecked: d && d.length > 0,
                  checked: d && !!d.length,
                  "data-testid": `${t}-switch`,
                  onCheckedChange: (u) => {
                    l(e, u ? [hCc] : []);
                  }
                }
              ) }),
              /* @__PURE__ */ m("span", { className: "inline-block min-w-[88px] text-sm capitalize", children: t })
            ] }) })
          }
        ),
        /* @__PURE__ */ Y(Ce, { children: [
          !d && /* @__PURE__ */ m(Jn, { className: "ml-1 mt-2.5 h-6 w-48" }),
          d.length > 0 && /* @__PURE__ */ Y("div", { className: "flex sm:gap-2", children: [
            /* @__PURE__ */ m(
              vme,
              {
                userTimeFormat: a,
                labels: i,
                control: n,
                name: e,
                disabled: r,
                classNames: {
                  dayRanges: s == null ? void 0 : s.dayRanges,
                  timeRangeField: s == null ? void 0 : s.timeRangeField,
                  timePicker: s == null ? void 0 : s.timePicker
                }
              }
            ),
            !r && /* @__PURE__ */ m("div", { className: "block", children: o })
          ] })
        ] })
      ]
    }
  );
}, wCc = ({
  getValuesFromDayRange: e,
  weekStart: t,
  labels: n
}) => {
  const { t: o } = Fe(), [r, i] = ze(!1), a = e.substring(0, e.lastIndexOf(".")), { setValue: s, getValues: c } = Dn();
  return /* @__PURE__ */ Y(El, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(
      ut,
      {
        className: ae(
          "text-default",
          r && "ring-brand-500 !bg-subtle outline-none ring-2 ring-offset-1"
        ),
        "data-testid": "copy-button",
        type: "button",
        tooltip: (n == null ? void 0 : n.copyTime) ?? o("copy_times_to_tooltip"),
        color: "minimal",
        variant: "icon",
        StartIcon: "copy"
      }
    ) }),
    /* @__PURE__ */ m(Uc, { align: "end", children: /* @__PURE__ */ m(
      ACc,
      {
        weekStart: t,
        disabled: parseInt(e.replace(`${a}.`, ""), 10),
        onClick: (l) => {
          l.forEach((d) => s(`${a}.${d}`, c(e))), i(!1);
        },
        onCancel: () => i(!1)
      }
    ) })
  ] });
}, kCc = (e) => {
  const t = tk(), { timeFormat: n } = t.data || { timeFormat: null };
  return /* @__PURE__ */ m(hme, { userTimeFormat: n, ...e });
}, hme = ({
  name: e,
  control: t,
  disabled: n,
  weekStart: o = 0,
  labels: r,
  userTimeFormat: i,
  classNames: a
}) => {
  const { i18n: s } = Fe();
  return /* @__PURE__ */ m("div", { className: ae("flex flex-col gap-4 p-2 sm:p-4", a == null ? void 0 : a.schedule), children: ab(s.language, o, "long").map((c, l) => {
    const d = (l + o) % 7, u = `${e}.${d}`;
    return /* @__PURE__ */ m(
      $Cc,
      {
        classNames: a,
        userTimeFormat: i,
        labels: r,
        disabled: n,
        name: u,
        weekday: c,
        control: t,
        CopyButton: /* @__PURE__ */ m(wCc, { weekStart: o, labels: r, getValuesFromDayRange: u })
      },
      c
    );
  }) });
}, vme = ({
  name: e,
  disabled: t,
  control: n,
  labels: o,
  userTimeFormat: r,
  classNames: i
}) => {
  const { t: a } = Fe(), { getValues: s } = Dn(), { remove: c, fields: l, prepend: d, append: u } = B0({
    control: n,
    name: e
  });
  return l.length ? /* @__PURE__ */ m("div", { className: ae("flex flex-col gap-2", i == null ? void 0 : i.dayRanges), children: l.map((_, p) => /* @__PURE__ */ m(Oi, { children: /* @__PURE__ */ Y("div", { className: "flex gap-1 last:mb-0 sm:gap-2", children: [
    /* @__PURE__ */ m(
      Wt,
      {
        name: `${e}.${p}`,
        render: ({ field: f }) => /* @__PURE__ */ m(
          xCc,
          {
            className: i == null ? void 0 : i.timeRangeField,
            userTimeFormat: r,
            timePickerClassNames: i == null ? void 0 : i.timePicker,
            ...f
          }
        )
      }
    ),
    p === 0 && /* @__PURE__ */ m(
      ut,
      {
        disabled: t,
        "data-testid": "add-time-availability",
        tooltip: (o == null ? void 0 : o.addTime) ?? a("add_time_availability"),
        className: "text-default",
        type: "button",
        color: "minimal",
        variant: "icon",
        StartIcon: "plus",
        onClick: () => {
          const f = TCc(
            s(`${e}.${l.length - 1}`),
            s(`${e}.0`)
          );
          f != null && f.append && u(f.append), f != null && f.prepend && d(f.prepend);
        }
      }
    ),
    p !== 0 && /* @__PURE__ */ m(SCc, { index: p, remove: c, className: "text-default border-none" })
  ] }) }, _.id)) }) : null;
}, SCc = ({
  index: e,
  remove: t,
  disabled: n,
  className: o,
  labels: r
}) => {
  const { t: i } = Fe();
  return /* @__PURE__ */ m(
    ut,
    {
      disabled: n,
      type: "button",
      variant: "icon",
      color: "destructive",
      StartIcon: "trash",
      onClick: () => t(e),
      className: o,
      tooltip: (r == null ? void 0 : r.deleteTime) ?? i("delete")
    }
  );
}, xCc = ({
  className: e,
  value: t,
  onChange: n,
  disabled: o,
  userTimeFormat: r,
  timePickerClassNames: i
}) => {
  const a = {
    control: i == null ? void 0 : i.container,
    singleValue: i == null ? void 0 : i.value,
    valueContainer: i == null ? void 0 : i.valueContainer,
    input: i == null ? void 0 : i.input,
    menu: i == null ? void 0 : i.dropdown
  };
  return /* @__PURE__ */ Y("div", { className: ae("flex flex-row gap-2 sm:gap-3", e), children: [
    /* @__PURE__ */ m(
      pY,
      {
        userTimeFormat: r,
        className: "block w-[90px] sm:w-[100px]",
        isDisabled: o,
        value: t.start,
        menuPlacement: "bottom",
        innerClassNames: a,
        onChange: (s) => {
          const c = new Date(s == null ? void 0 : s.value);
          if (c >= new Date(t.end)) {
            const l = new Date(s == null ? void 0 : s.value);
            l.setMinutes(l.getMinutes() + RM), n({ ...t, start: c, end: l });
          } else
            n({ ...t, start: c });
        }
      }
    ),
    /* @__PURE__ */ m("span", { className: "text-default w-2 self-center", children: " - " }),
    /* @__PURE__ */ m(
      pY,
      {
        userTimeFormat: r,
        className: "block w-[90px] rounded-md sm:w-[100px]",
        isDisabled: o,
        value: t.end,
        min: t.start,
        innerClassNames: a,
        menuPlacement: "bottom",
        onChange: (s) => {
          n({ ...t, end: new Date(s == null ? void 0 : s.value) });
        }
      }
    )
  ] });
}, pY = ({
  value: e,
  min: t,
  max: n,
  userTimeFormat: o,
  menuPlacement: r,
  ...i
}) => {
  const { options: a, filter: s } = ECc(o);
  Le(() => {
    s({ current: e });
  }, [s, e]);
  const [c, l] = ve.useState(""), d = ve.useMemo(() => z_e(), []), u = ve.useMemo(() => {
    var $;
    const _ = /^(\d{1,2})(a|p|am|pm)$/i, p = c.replaceAll(" ", "").match(_);
    if (!p)
      return a.filter(
        (k) => d({ ...k, data: k.label, value: k.label }, c)
      );
    const [, f, g] = p, h = g.toLowerCase(), b = a.filter((k) => k.label && k.label.toLowerCase().includes(h)).map((k) => {
      const S = k.label.toLowerCase(), O = S.indexOf(f);
      return { score: O >= 0 ? O + S.length : 1 / 0, option: k };
    }).sort((k, S) => k.score - S.score), v = ($ = b[0]) == null ? void 0 : $.score;
    return b.filter((k) => k.score === v).map((k) => k.option);
  }, [c, a, d]);
  return /* @__PURE__ */ m(
    Tr,
    {
      options: u,
      onMenuOpen: () => {
        t && s({ offset: t }), n && s({ limit: n }), !t && !n && s({ offset: 0, limit: 0 });
      },
      menuPlacement: r,
      value: a.find((_) => _.value === De(e).toDate().valueOf()),
      onMenuClose: () => s({ current: e }),
      components: { DropdownIndicator: () => null, IndicatorSeparator: () => null },
      onInputChange: l,
      filterOption: () => !0,
      ...i
    }
  );
}, RM = Number(yCc.NEXT_PUBLIC_AVAILABILITY_SCHEDULE_INTERVAL) || 15, ECc = (e) => {
  const [t, n] = ze([]), o = Tt(() => {
    const i = De().utc().endOf("day"), a = [];
    for (let s = De().utc().startOf("day"); s.isBefore(i); s = s.add(RM + (s.add(RM).isSame(s, "day") ? 0 : -1), "minutes"))
      a.push({
        value: s.toDate().valueOf(),
        label: De(s).utc().format(e === 12 ? "h:mma" : "HH:mm")
      });
    return a.push({
      value: i.toDate().valueOf(),
      label: De(i).utc().format(e === 12 ? "h:mma" : "HH:mm")
    }), a;
  }, [e]), r = at(
    ({ offset: i, limit: a, current: s }) => {
      if (s) {
        const c = o.find((l) => l.value === De(s).toDate().valueOf());
        c && n([c]);
      } else
        n(
          o.filter((c) => {
            const l = De(c.value);
            return (!a || l.isBefore(a)) && (!i || l.isAfter(i));
          })
        );
    },
    [o]
  );
  return { options: t, filter: r };
}, TCc = (e, t) => {
  const n = De(t.start).utc(), o = De(e.end).utc(), r = o.hour() === 23 ? De(o).add(59, "minutes").add(59, "seconds").add(999, "milliseconds") : De(o).add(1, "hour"), i = o.endOf("day");
  if (!o.isSame(i))
    return {
      append: {
        start: o.toDate(),
        end: r.isAfter(i) ? i.toDate() : r.toDate()
      }
    };
  const a = De(t.start).subtract(1, "hour"), s = n.startOf("day");
  if (!n.isSame(s))
    return {
      prepend: {
        start: a.isBefore(s) ? s.toDate() : a.toDate(),
        end: n.toDate()
      }
    };
}, ACc = ({
  disabled: e,
  onClick: t,
  onCancel: n,
  weekStart: o
}) => {
  const [r, i] = ze([]), { i18n: a, t: s } = Fe(), c = Ue([]);
  Le(() => (document.addEventListener("keydown", l), () => {
    document.removeEventListener("keydown", l);
  }), []);
  const l = (d) => {
    const u = c.current;
    if (!(d.key === "Tab" || d.key === "ArrowUp" || d.key === "ArrowDown" || d.key === "Enter") || !u.length)
      return;
    d.preventDefault();
    const p = document.activeElement;
    let f = u.findIndex((g) => g === p);
    if (d.key === "Enter") {
      if (f === -1)
        return;
      p.click();
      return;
    }
    f === -1 ? u[0].focus() : (d.key === "ArrowUp" ? f = (f - 1 + u.length) % u.length : (d.key === "ArrowDown" || d.key === "Tab") && (f = (f + 1) % u.length), u[f].focus());
  };
  return /* @__PURE__ */ Y("div", { className: "space-y-2 py-2", children: [
    /* @__PURE__ */ Y("div", { className: "p-2", children: [
      /* @__PURE__ */ m("p", { className: "h6 text-emphasis pb-3 pl-1 text-xs font-medium uppercase", children: s("copy_times_to") }),
      /* @__PURE__ */ Y("ol", { className: "space-y-2", children: [
        /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
          Ta,
          {
            description: s("select_all"),
            descriptionAsLabel: !0,
            value: s("select_all"),
            checked: r.length === 7,
            onChange: (d) => {
              d.target.checked ? i([0, 1, 2, 3, 4, 5, 6]) : d.target.checked || i([]);
            },
            ref: (d) => {
              d && c.current.push(d);
            }
          }
        ) }, "select all"),
        ab(a.language, o).map((d, u) => {
          const _ = (u + o) % 7;
          return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
            Ta,
            {
              description: d,
              descriptionAsLabel: !0,
              value: _,
              checked: r.includes(_) || e === _,
              disabled: e === _,
              onChange: (p) => {
                p.target.checked && !r.includes(_) ? i(r.concat([_])) : !p.target.checked && r.includes(_) && i(r.filter((f) => f !== _));
              },
              ref: (p) => {
                p && e !== _ && c.current.push(p);
              }
            }
          ) }, d);
        })
      ] })
    ] }),
    /* @__PURE__ */ m("hr", { className: "border-subtle" }),
    /* @__PURE__ */ Y("div", { className: "flex justify-end space-x-2 px-2 rtl:space-x-reverse", children: [
      /* @__PURE__ */ m(
        ut,
        {
          color: "minimal",
          onClick: () => n(),
          ref: (d) => {
            d && c.current.push(d);
          },
          children: s("cancel")
        }
      ),
      /* @__PURE__ */ m(
        ut,
        {
          color: "primary",
          onClick: () => t(r),
          ref: (d) => {
            d && c.current.push(d);
          },
          children: s("apply")
        }
      )
    ] })
  ] });
}, CCc = kCc, zCc = ({
  value: e,
  workingHours: t,
  excludedDates: n,
  onChange: o,
  userTimeFormat: r,
  weekStart: i,
  isDryRun: a = !1
}) => {
  const [s, c] = ze(), { t: l, i18n: d, isLocaleReady: u } = Fe(), [_, p] = ze(
    e && e[0].start.getUTCHours() === 0 && e[0].start.getUTCMinutes() === 0 && e[0].end.getUTCHours() === 0 && e[0].end.getUTCMinutes() === 0
  ), [f, g] = ze(e ? [De.utc(e[0].start)] : []), h = ($) => {
    if (f.some((k) => gs(k) === gs($))) {
      g(f.filter((k) => gs(k) !== gs($)));
      return;
    }
    if (!e) {
      g((k) => [...k, $]);
      return;
    }
    g([$]);
  }, b = (t || []).reduce(($, k) => (f[0] && k.days.includes(f[0].day()) && $.push({
    start: De.utc().startOf("day").add(k.startTime, "minute").toDate(),
    end: De.utc().startOf("day").add(k.endTime, "minute").toDate()
  }), $), []);
  b.length || b.push({
    start: De.utc().startOf("day").add(540, "minute").toDate(),
    end: De.utc().startOf("day").add(1020, "minute").toDate()
  });
  const v = pd({
    values: {
      range: e && e[0].start.valueOf() !== e[0].end.valueOf() ? e.map(($) => ({
        start: new Date(
          De.utc().hour($.start.getUTCHours()).minute($.start.getUTCMinutes()).second(0).format()
        ),
        end: new Date(
          De.utc().hour($.end.getUTCHours()).minute($.end.getUTCMinutes()).second(0).format()
        )
      })) : b
    }
  });
  return /* @__PURE__ */ Y(
    fd,
    {
      form: v,
      handleSubmit: ($) => {
        const k = [];
        if (f.length !== 0) {
          if (a) {
            g([]);
            return;
          }
          _ ? (f.map((S) => {
            k.push({
              start: S.utc(!0).startOf("day").toDate(),
              end: S.utc(!0).startOf("day").toDate()
            });
          }), o(k)) : (f.map((S) => {
            $.range.map((O) => {
              k.push({
                start: S.hour(O.start.getUTCHours()).minute(O.start.getUTCMinutes()).utc(!0).toDate(),
                end: S.hour(O.end.getUTCHours()).minute(O.end.getUTCMinutes()).utc(!0).toDate()
              });
            });
          }), o(k)), g([]);
        }
      },
      className: "p-6 sm:flex sm:p-0 xl:flex-row",
      children: [
        /* @__PURE__ */ Y("div", { className: "sm:border-subtle w-full sm:border-r sm:p-4 sm:pr-6 md:p-8", children: [
          /* @__PURE__ */ m(zv, { title: l("date_overrides_dialog_title") }),
          /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(
            pme,
            {
              excludedDates: n,
              weekStart: i,
              selected: f,
              onChange: ($) => {
                $ && h($);
              },
              onMonthChange: ($) => {
                c($);
              },
              browsingDate: s,
              locale: u ? d.language : "en"
            }
          ) })
        ] }),
        /* @__PURE__ */ m("div", { className: "relative mt-8 flex w-full flex-col sm:mt-0 sm:p-4 md:p-8", children: f[0] ? /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ Y("div", { className: "mb-4 flex-grow space-y-4", children: [
            /* @__PURE__ */ m("p", { className: "text-medium text-emphasis text-sm", children: l("date_overrides_dialog_which_hours") }),
            /* @__PURE__ */ m("div", { children: _ ? /* @__PURE__ */ m("p", { className: "text-subtle border-default rounded border p-2 text-sm", children: l("date_overrides_unavailable") }) : /* @__PURE__ */ m(vme, { name: "range", userTimeFormat: r }) }),
            /* @__PURE__ */ m(
              Ri,
              {
                label: l("date_overrides_mark_all_day_unavailable_one"),
                checked: _,
                onCheckedChange: p,
                "data-testid": "date-override-mark-unavailable"
              }
            )
          ] }),
          /* @__PURE__ */ Y("div", { className: "mt-4 flex flex-row-reverse sm:mt-0", children: [
            /* @__PURE__ */ m(
              ut,
              {
                className: "ml-2",
                color: "primary",
                type: "submit",
                onClick: () => {
                  nr(l("date_successfully_added"), "success", 500);
                },
                disabled: f.length === 0,
                "data-testid": "add-override-submit-btn",
                children: l(e ? "date_overrides_update_btn" : "date_overrides_save_btn")
              }
            ),
            /* @__PURE__ */ m(ca, {})
          ] })
        ] }) : /* @__PURE__ */ m("div", { className: "bottom-7 right-8 flex flex-row-reverse sm:absolute", children: /* @__PURE__ */ m(ca, {}) }) })
      ]
    }
  );
}, OCc = ({
  Trigger: e,
  excludedDates: t = [],
  userTimeFormat: n,
  weekStart: o = 0,
  className: r,
  ...i
}) => {
  const [a, s] = ze(!1);
  return /* @__PURE__ */ Y(Gi, { open: a, onOpenChange: s, children: [
    /* @__PURE__ */ m(W0, { asChild: !0, children: e }),
    /* @__PURE__ */ m(Ei, { enableOverflow: !0, size: "md", className: ae("p-0", r), children: /* @__PURE__ */ m(
      zCc,
      {
        excludedDates: t,
        weekStart: o,
        ...i,
        onClose: () => s(!1),
        userTimeFormat: n
      }
    ) })
  ] });
}, bme = OCc;
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function PCc() {
}
function mY(e, t, n) {
  const o = vxc(), r = NCc(e, n.timeZone, n.locale ?? o.locale);
  return "formatToParts" in r ? ICc(r, t) : RCc(r, t);
}
function ICc(e, t) {
  const n = e.formatToParts(t);
  for (let o = n.length - 1; o >= 0; --o)
    if (n[o].type === "timeZoneName")
      return n[o].value;
}
function RCc(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), o = / [\w-+ ]+$/.exec(n);
  return o ? o[0].substr(1) : "";
}
function NCc(e, t, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function DCc(e, t) {
  const n = FCc(t);
  return "formatToParts" in n ? LCc(n, e) : qCc(n, e);
}
const MCc = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function LCc(e, t) {
  try {
    const n = e.formatToParts(t), o = [];
    for (let r = 0; r < n.length; r++) {
      const i = MCc[n[r].type];
      i !== void 0 && (o[i] = parseInt(n[r].value, 10));
    }
    return o;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function qCc(e, t) {
  const n = e.format(t), o = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(o[3], 10),
    parseInt(o[1], 10),
    parseInt(o[2], 10),
    parseInt(o[4], 10),
    parseInt(o[5], 10),
    parseInt(o[6], 10)
  ];
}
const o6 = {}, fY = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), jCc = fY === "06/25/2014, 00:00:00" || fY === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function FCc(e) {
  return o6[e] || (o6[e] = jCc ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), o6[e];
}
function yme(e, t, n, o, r, i, a) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(o, r, i, a), s;
}
const gY = 36e5, VCc = 6e4, r6 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Cj(e, t, n) {
  if (!e)
    return 0;
  let o = r6.timezoneZ.exec(e);
  if (o)
    return 0;
  let r, i;
  if (o = r6.timezoneHH.exec(e), o)
    return r = parseInt(o[1], 10), hY(r) ? -(r * gY) : NaN;
  if (o = r6.timezoneHHMM.exec(e), o) {
    r = parseInt(o[2], 10);
    const a = parseInt(o[3], 10);
    return hY(r, a) ? (i = Math.abs(r) * gY + a * VCc, o[1] === "+" ? -i : i) : NaN;
  }
  if (WCc(e)) {
    t = new Date(t || Date.now());
    const a = n ? t : BCc(t), s = NM(a, e);
    return -(n ? s : UCc(t, s, e));
  }
  return NaN;
}
function BCc(e) {
  return yme(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function NM(e, t) {
  const n = DCc(e, t), o = yme(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let r = e.getTime();
  const i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, o - r;
}
function UCc(e, t, n) {
  let r = e.getTime() - t;
  const i = NM(new Date(r), n);
  if (t === i)
    return t;
  r -= i - t;
  const a = NM(new Date(r), n);
  return i === a ? i : Math.max(i, a);
}
function hY(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const vY = {};
function WCc(e) {
  if (vY[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), vY[e] = !0, !0;
  } catch {
    return !1;
  }
}
const GCc = 60 * 1e3, HCc = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = i6(n.timeZone, e);
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return bY(o);
      case "XXXX":
      case "XX":
        return fh(o);
      case "XXXXX":
      case "XXX":
      default:
        return fh(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = i6(n.timeZone, e);
    switch (t) {
      case "x":
        return bY(o);
      case "xxxx":
      case "xx":
        return fh(o);
      case "xxxxx":
      case "xxx":
      default:
        return fh(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = i6(n.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + KCc(o, ":");
      case "OOOO":
      default:
        return "GMT" + fh(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return mY("short", e, n);
      case "zzzz":
      default:
        return mY("long", e, n);
    }
  }
};
function i6(e, t) {
  const n = e ? Cj(e, t, !0) / GCc : (t == null ? void 0 : t.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function SE(e, t) {
  const n = e < 0 ? "-" : "";
  let o = Math.abs(e).toString();
  for (; o.length < t; )
    o = "0" + o;
  return n + o;
}
function fh(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = SE(Math.floor(o / 60), 2), i = SE(Math.floor(o % 60), 2);
  return n + r + t + i;
}
function bY(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + SE(Math.abs(e) / 60, 2) : fh(e, t);
}
function KCc(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.floor(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + t + SE(i, 2);
}
function yY(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const YCc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, a6 = 36e5, $Y = 6e4, ZCc = 2, As = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: YCc
};
function $me(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.additionalDigits == null ? ZCc : Number(t.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const o = QCc(e), { year: r, restDateString: i } = JCc(o.date, n), a = XCc(i, r);
  if (a === null || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (a) {
    const s = a.getTime();
    let c = 0, l;
    if (o.time && (c = ezc(o.time), c === null || isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timeZone || t.timeZone) {
      if (l = Cj(o.timeZone || t.timeZone, new Date(s + c)), isNaN(l))
        return /* @__PURE__ */ new Date(NaN);
    } else
      l = yY(new Date(s + c)), l = yY(new Date(s + c + l));
    return new Date(s + c + l);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function QCc(e) {
  const t = {};
  let n = As.dateTimePattern.exec(e), o;
  if (n ? (t.date = n[1], o = n[3]) : (n = As.datePattern.exec(e), n ? (t.date = n[1], o = n[2]) : (t.date = null, o = e)), o) {
    const r = As.timeZone.exec(o);
    r ? (t.time = o.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = o;
  }
  return t;
}
function JCc(e, t) {
  if (e) {
    const n = As.YYY[t], o = As.YYYYY[t];
    let r = As.YYYY.exec(e) || o.exec(e);
    if (r) {
      const i = r[1];
      return {
        year: parseInt(i, 10),
        restDateString: e.slice(i.length)
      };
    }
    if (r = As.YY.exec(e) || n.exec(e), r) {
      const i = r[1];
      return {
        year: parseInt(i, 10) * 100,
        restDateString: e.slice(i.length)
      };
    }
  }
  return {
    year: null
  };
}
function XCc(e, t) {
  if (t === null)
    return null;
  let n, o, r;
  if (!e || !e.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  let i = As.MM.exec(e);
  if (i)
    return n = /* @__PURE__ */ new Date(0), o = parseInt(i[1], 10) - 1, kY(t, o) ? (n.setUTCFullYear(t, o), n) : /* @__PURE__ */ new Date(NaN);
  if (i = As.DDD.exec(e), i) {
    n = /* @__PURE__ */ new Date(0);
    const a = parseInt(i[1], 10);
    return ozc(t, a) ? (n.setUTCFullYear(t, 0, a), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = As.MMDD.exec(e), i) {
    n = /* @__PURE__ */ new Date(0), o = parseInt(i[1], 10) - 1;
    const a = parseInt(i[2], 10);
    return kY(t, o, a) ? (n.setUTCFullYear(t, o, a), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = As.Www.exec(e), i)
    return r = parseInt(i[1], 10) - 1, SY(r) ? wY(t, r) : /* @__PURE__ */ new Date(NaN);
  if (i = As.WwwD.exec(e), i) {
    r = parseInt(i[1], 10) - 1;
    const a = parseInt(i[2], 10) - 1;
    return SY(r, a) ? wY(t, r, a) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function ezc(e) {
  let t, n, o = As.HH.exec(e);
  if (o)
    return t = parseFloat(o[1].replace(",", ".")), s6(t) ? t % 24 * a6 : NaN;
  if (o = As.HHMM.exec(e), o)
    return t = parseInt(o[1], 10), n = parseFloat(o[2].replace(",", ".")), s6(t, n) ? t % 24 * a6 + n * $Y : NaN;
  if (o = As.HHMMSS.exec(e), o) {
    t = parseInt(o[1], 10), n = parseInt(o[2], 10);
    const r = parseFloat(o[3].replace(",", "."));
    return s6(t, n, r) ? t % 24 * a6 + n * $Y + r * 1e3 : NaN;
  }
  return null;
}
function wY(e, t, n) {
  t = t || 0, n = n || 0;
  const o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  const r = o.getUTCDay() || 7, i = t * 7 + n + 1 - r;
  return o.setUTCDate(o.getUTCDate() + i), o;
}
const tzc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], nzc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function wme(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function kY(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const o = wme(e);
    if (o && n > nzc[t] || !o && n > tzc[t])
      return !1;
  }
  return !0;
}
function ozc(e, t) {
  if (t < 1)
    return !1;
  const n = wme(e);
  return !(n && t > 366 || !n && t > 365);
}
function SY(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function s6(e, t, n) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
const rzc = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function izc(e, t, n = {}) {
  t = String(t);
  const o = t.match(rzc);
  if (o) {
    const r = $me(n.originalDate || e, n);
    t = o.reduce(function(i, a) {
      if (a[0] === "'")
        return i;
      const s = i.indexOf(a), c = i[s - 1] === "'", l = i.replace(a, "'" + HCc[a[0]](r, a, n) + "'");
      return c ? l.substring(0, s - 1) + l.substring(s + 1) : l;
    }, t);
  }
  return P_(e, t, n);
}
function azc(e, t, n) {
  e = $me(e, n);
  const o = Cj(t, e, !0), r = new Date(e.getTime() - o), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), i.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), i;
}
function B2(e, t, n, o) {
  return o = {
    ...o,
    timeZone: t,
    originalDate: e
  }, izc(azc(e, t, { timeZone: o.timeZone }), n, o);
}
const szc = (e, t) => e.ranges[0].start > t.ranges[0].start ? 1 : -1, czc = ({
  workingHours: e,
  excludedDates: t = [],
  travelSchedules: n = [],
  userTimeFormat: o,
  hour12: r,
  replace: i,
  fields: a,
  weekStart: s = 0,
  handleAvailabilityUpdate: c = PCc,
  isDryRun: l = !1
}) => {
  const { t: d, i18n: u } = Fe(), _ = Zo(), p = a.reduce(
    (g, { id: h }, b) => ({ ...g, [h]: b }),
    {}
  );
  if (!a.length)
    return /* @__PURE__ */ m(Ce, {});
  const f = ({ start: g, end: h }) => _ ? `${B2(g, "UTC", "h:mm a")} - ${B2(h, "UTC", "h:mm a")}` : `${new Intl.DateTimeFormat(u.language, { hour: "numeric", minute: "numeric", hour12: r }).format(
    new Date(g.toISOString().slice(0, -1))
  )} - ${new Intl.DateTimeFormat(u.language, { hour: "numeric", minute: "numeric", hour12: r }).format(
    new Date(h.toISOString().slice(0, -1))
  )}`;
  return /* @__PURE__ */ m("ul", { className: "border-subtle rounded border", "data-testid": "date-overrides-list", children: a.sort(szc).map((g) => /* @__PURE__ */ Y("li", { className: "border-subtle flex justify-between border-b px-5 py-4 last:border-b-0", children: [
    /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ Y("h3", { className: "text-emphasis text-sm", children: [
        !_ && new Intl.DateTimeFormat(u.language, {
          weekday: "long",
          month: "long",
          day: "numeric",
          timeZone: "UTC"
        }).format(g.ranges[0].start),
        _ && B2(new Date(g.ranges[0].start), "UTC", "EEE MMM dd")
      ] }),
      g.ranges[0].start.valueOf() - g.ranges[0].end.valueOf() === 0 ? /* @__PURE__ */ m("p", { className: "text-subtle text-xs", children: d("unavailable") }) : g.ranges.map((h, b) => {
        var v;
        return /* @__PURE__ */ Y("p", { className: "text-subtle text-xs", children: [
          `${f(h)} ${((v = n.find(
            ($) => !De(g.ranges[0].start).isBefore($.startDate) && (!De(g.ranges[0].end).isAfter($.endDate) || !$.endDate)
          )) == null ? void 0 : v.timeZone.replace(/_/g, " ")) || ""}`,
          /* @__PURE__ */ m(Ce, {})
        ] }, b);
      })
    ] }),
    /* @__PURE__ */ Y("div", { className: "flex flex-row-reverse gap-5 space-x-2 rtl:space-x-reverse", children: [
      /* @__PURE__ */ m(
        bme,
        {
          userTimeFormat: o,
          excludedDates: t,
          workingHours: e,
          value: g.ranges.map((h) => ({
            start: new Date(h.start),
            end: new Date(h.end)
          })),
          weekStart: s,
          onChange: (h) => {
            l || (i([...a.filter((b) => b.id !== g.id), { ranges: h }]), delete p[g.id], c());
          },
          Trigger: /* @__PURE__ */ m(W0, { asChild: !0, children: /* @__PURE__ */ m(
            ut,
            {
              tooltip: d("edit"),
              className: "text-default h-5",
              color: "minimal",
              variant: "icon",
              StartIcon: "pencil"
            }
          ) })
        }
      ),
      /* @__PURE__ */ m(Ao, { content: "Delete", children: /* @__PURE__ */ m(
        ut,
        {
          className: "text-default h-5",
          "data-testid": "delete-button",
          title: d("date_overrides_delete_on_date", {
            date: _ ? B2(new Date(g.ranges[0].start), "UTC", "h:mm a") : new Intl.DateTimeFormat(u.language, {
              weekday: "long",
              month: "long",
              day: "numeric",
              timeZone: "UTC"
            }).format(g.ranges[0].start)
          }),
          color: "destructive",
          variant: "icon",
          StartIcon: "trash-2",
          onClick: () => {
            i([...a.filter((h) => h.id !== g.id)]), l || c();
          }
        }
      ) })
    ] })
  ] }, g.id)) });
}, lzc = czc;
var sc = {}, kme = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(kme);
var Rt = kme.exports;
const Yn = /* @__PURE__ */ Oa(Ddc);
var c6 = { exports: {} }, l6 = { exports: {} }, xY;
function Sme() {
  return xY || (xY = 1, function(e) {
    function t(n) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(l6)), l6.exports;
}
var EY;
function dzc() {
  return EY || (EY = 1, function(e) {
    var t = Sme().default;
    function n() {
      e.exports = n = function() {
        return r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var o, r = {}, i = Object.prototype, a = i.hasOwnProperty, s = Object.defineProperty || function(q, V, F) {
        q[V] = F.value;
      }, c = typeof Symbol == "function" ? Symbol : {}, l = c.iterator || "@@iterator", d = c.asyncIterator || "@@asyncIterator", u = c.toStringTag || "@@toStringTag";
      function _(q, V, F) {
        return Object.defineProperty(q, V, {
          value: F,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), q[V];
      }
      try {
        _({}, "");
      } catch {
        _ = function(F, L, U) {
          return F[L] = U;
        };
      }
      function p(q, V, F, L) {
        var U = V && V.prototype instanceof k ? V : k, W = Object.create(U.prototype), H = new z(L || []);
        return s(W, "_invoke", {
          value: x(q, F, H)
        }), W;
      }
      function f(q, V, F) {
        try {
          return {
            type: "normal",
            arg: q.call(V, F)
          };
        } catch (L) {
          return {
            type: "throw",
            arg: L
          };
        }
      }
      r.wrap = p;
      var g = "suspendedStart", h = "suspendedYield", b = "executing", v = "completed", $ = {};
      function k() {
      }
      function S() {
      }
      function O() {
      }
      var I = {};
      _(I, l, function() {
        return this;
      });
      var D = Object.getPrototypeOf, M = D && D(D(j([])));
      M && M !== i && a.call(M, l) && (I = M);
      var N = O.prototype = k.prototype = Object.create(I);
      function C(q) {
        ["next", "throw", "return"].forEach(function(V) {
          _(q, V, function(F) {
            return this._invoke(V, F);
          });
        });
      }
      function P(q, V) {
        function F(U, W, H, Q) {
          var X = f(q[U], q, W);
          if (X.type !== "throw") {
            var re = X.arg, Z = re.value;
            return Z && t(Z) == "object" && a.call(Z, "__await") ? V.resolve(Z.__await).then(function(ee) {
              F("next", ee, H, Q);
            }, function(ee) {
              F("throw", ee, H, Q);
            }) : V.resolve(Z).then(function(ee) {
              re.value = ee, H(re);
            }, function(ee) {
              return F("throw", ee, H, Q);
            });
          }
          Q(X.arg);
        }
        var L;
        s(this, "_invoke", {
          value: function(W, H) {
            function Q() {
              return new V(function(X, re) {
                F(W, H, X, re);
              });
            }
            return L = L ? L.then(Q, Q) : Q();
          }
        });
      }
      function x(q, V, F) {
        var L = g;
        return function(U, W) {
          if (L === b)
            throw new Error("Generator is already running");
          if (L === v) {
            if (U === "throw")
              throw W;
            return {
              value: o,
              done: !0
            };
          }
          for (F.method = U, F.arg = W; ; ) {
            var H = F.delegate;
            if (H) {
              var Q = w(H, F);
              if (Q) {
                if (Q === $)
                  continue;
                return Q;
              }
            }
            if (F.method === "next")
              F.sent = F._sent = F.arg;
            else if (F.method === "throw") {
              if (L === g)
                throw L = v, F.arg;
              F.dispatchException(F.arg);
            } else
              F.method === "return" && F.abrupt("return", F.arg);
            L = b;
            var X = f(q, V, F);
            if (X.type === "normal") {
              if (L = F.done ? v : h, X.arg === $)
                continue;
              return {
                value: X.arg,
                done: F.done
              };
            }
            X.type === "throw" && (L = v, F.method = "throw", F.arg = X.arg);
          }
        };
      }
      function w(q, V) {
        var F = V.method, L = q.iterator[F];
        if (L === o)
          return V.delegate = null, F === "throw" && q.iterator.return && (V.method = "return", V.arg = o, w(q, V), V.method === "throw") || F !== "return" && (V.method = "throw", V.arg = new TypeError("The iterator does not provide a '" + F + "' method")), $;
        var U = f(L, q.iterator, V.arg);
        if (U.type === "throw")
          return V.method = "throw", V.arg = U.arg, V.delegate = null, $;
        var W = U.arg;
        return W ? W.done ? (V[q.resultName] = W.value, V.next = q.nextLoc, V.method !== "return" && (V.method = "next", V.arg = o), V.delegate = null, $) : W : (V.method = "throw", V.arg = new TypeError("iterator result is not an object"), V.delegate = null, $);
      }
      function E(q) {
        var V = {
          tryLoc: q[0]
        };
        1 in q && (V.catchLoc = q[1]), 2 in q && (V.finallyLoc = q[2], V.afterLoc = q[3]), this.tryEntries.push(V);
      }
      function T(q) {
        var V = q.completion || {};
        V.type = "normal", delete V.arg, q.completion = V;
      }
      function z(q) {
        this.tryEntries = [{
          tryLoc: "root"
        }], q.forEach(E, this), this.reset(!0);
      }
      function j(q) {
        if (q || q === "") {
          var V = q[l];
          if (V)
            return V.call(q);
          if (typeof q.next == "function")
            return q;
          if (!isNaN(q.length)) {
            var F = -1, L = function U() {
              for (; ++F < q.length; )
                if (a.call(q, F))
                  return U.value = q[F], U.done = !1, U;
              return U.value = o, U.done = !0, U;
            };
            return L.next = L;
          }
        }
        throw new TypeError(t(q) + " is not iterable");
      }
      return S.prototype = O, s(N, "constructor", {
        value: O,
        configurable: !0
      }), s(O, "constructor", {
        value: S,
        configurable: !0
      }), S.displayName = _(O, u, "GeneratorFunction"), r.isGeneratorFunction = function(q) {
        var V = typeof q == "function" && q.constructor;
        return !!V && (V === S || (V.displayName || V.name) === "GeneratorFunction");
      }, r.mark = function(q) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(q, O) : (q.__proto__ = O, _(q, u, "GeneratorFunction")), q.prototype = Object.create(N), q;
      }, r.awrap = function(q) {
        return {
          __await: q
        };
      }, C(P.prototype), _(P.prototype, d, function() {
        return this;
      }), r.AsyncIterator = P, r.async = function(q, V, F, L, U) {
        U === void 0 && (U = Promise);
        var W = new P(p(q, V, F, L), U);
        return r.isGeneratorFunction(V) ? W : W.next().then(function(H) {
          return H.done ? H.value : W.next();
        });
      }, C(N), _(N, u, "Generator"), _(N, l, function() {
        return this;
      }), _(N, "toString", function() {
        return "[object Generator]";
      }), r.keys = function(q) {
        var V = Object(q), F = [];
        for (var L in V)
          F.push(L);
        return F.reverse(), function U() {
          for (; F.length; ) {
            var W = F.pop();
            if (W in V)
              return U.value = W, U.done = !1, U;
          }
          return U.done = !0, U;
        };
      }, r.values = j, z.prototype = {
        constructor: z,
        reset: function(V) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(T), !V)
            for (var F in this)
              F.charAt(0) === "t" && a.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = o);
        },
        stop: function() {
          this.done = !0;
          var V = this.tryEntries[0].completion;
          if (V.type === "throw")
            throw V.arg;
          return this.rval;
        },
        dispatchException: function(V) {
          if (this.done)
            throw V;
          var F = this;
          function L(re, Z) {
            return H.type = "throw", H.arg = V, F.next = re, Z && (F.method = "next", F.arg = o), !!Z;
          }
          for (var U = this.tryEntries.length - 1; U >= 0; --U) {
            var W = this.tryEntries[U], H = W.completion;
            if (W.tryLoc === "root")
              return L("end");
            if (W.tryLoc <= this.prev) {
              var Q = a.call(W, "catchLoc"), X = a.call(W, "finallyLoc");
              if (Q && X) {
                if (this.prev < W.catchLoc)
                  return L(W.catchLoc, !0);
                if (this.prev < W.finallyLoc)
                  return L(W.finallyLoc);
              } else if (Q) {
                if (this.prev < W.catchLoc)
                  return L(W.catchLoc, !0);
              } else {
                if (!X)
                  throw new Error("try statement without catch or finally");
                if (this.prev < W.finallyLoc)
                  return L(W.finallyLoc);
              }
            }
          }
        },
        abrupt: function(V, F) {
          for (var L = this.tryEntries.length - 1; L >= 0; --L) {
            var U = this.tryEntries[L];
            if (U.tryLoc <= this.prev && a.call(U, "finallyLoc") && this.prev < U.finallyLoc) {
              var W = U;
              break;
            }
          }
          W && (V === "break" || V === "continue") && W.tryLoc <= F && F <= W.finallyLoc && (W = null);
          var H = W ? W.completion : {};
          return H.type = V, H.arg = F, W ? (this.method = "next", this.next = W.finallyLoc, $) : this.complete(H);
        },
        complete: function(V, F) {
          if (V.type === "throw")
            throw V.arg;
          return V.type === "break" || V.type === "continue" ? this.next = V.arg : V.type === "return" ? (this.rval = this.arg = V.arg, this.method = "return", this.next = "end") : V.type === "normal" && F && (this.next = F), $;
        },
        finish: function(V) {
          for (var F = this.tryEntries.length - 1; F >= 0; --F) {
            var L = this.tryEntries[F];
            if (L.finallyLoc === V)
              return this.complete(L.completion, L.afterLoc), T(L), $;
          }
        },
        catch: function(V) {
          for (var F = this.tryEntries.length - 1; F >= 0; --F) {
            var L = this.tryEntries[F];
            if (L.tryLoc === V) {
              var U = L.completion;
              if (U.type === "throw") {
                var W = U.arg;
                T(L);
              }
              return W;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(V, F, L) {
          return this.delegate = {
            iterator: j(V),
            resultName: F,
            nextLoc: L
          }, this.method === "next" && (this.arg = o), $;
        }
      }, r;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(c6)), c6.exports;
}
var d6, TY;
function MA() {
  if (TY)
    return d6;
  TY = 1;
  var e = dzc()();
  d6 = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return d6;
}
const rr = /* @__PURE__ */ Oa(Ldc);
var u6 = { exports: {} }, AY;
function LA() {
  return AY || (AY = 1, function(e) {
    function t(o, r, i, a, s, c, l) {
      try {
        var d = o[c](l), u = d.value;
      } catch (_) {
        i(_);
        return;
      }
      d.done ? r(u) : Promise.resolve(u).then(a, s);
    }
    function n(o) {
      return function() {
        var r = this, i = arguments;
        return new Promise(function(a, s) {
          var c = o.apply(r, i);
          function l(u) {
            t(c, a, s, l, d, "next", u);
          }
          function d(u) {
            t(c, a, s, l, d, "throw", u);
          }
          l(void 0);
        });
      };
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(u6)), u6.exports;
}
const Tl = /* @__PURE__ */ Oa(ruc);
var Am = {}, Pr = {}, _6 = { exports: {} }, CY;
function ua() {
  return CY || (CY = 1, function(e) {
    function t(n) {
      if (n === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_6)), _6.exports;
}
const yr = /* @__PURE__ */ Oa(Qdc), $r = /* @__PURE__ */ Oa(Jdc), wr = /* @__PURE__ */ Oa(fwc);
var p6 = { exports: {} }, zY;
function kr() {
  return zY || (zY = 1, function(e) {
    var t = Sme().default, n = ua();
    function o(r, i) {
      if (i && (t(i) === "object" || typeof i == "function"))
        return i;
      if (i !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return n(r);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(p6)), p6.exports;
}
var m6 = { exports: {} }, OY;
function ir() {
  return OY || (OY = 1, function(e) {
    function t(n) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
        return r.__proto__ || Object.getPrototypeOf(r);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(m6)), m6.exports;
}
var f6 = { exports: {} }, g6 = { exports: {} }, PY;
function xme() {
  return PY || (PY = 1, function(e) {
    function t(n, o) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, a) {
        return i.__proto__ = a, i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n, o);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(g6)), g6.exports;
}
var h6 = { exports: {} }, IY;
function uzc() {
  return IY || (IY = 1, function(e) {
    function t(n) {
      return Function.toString.call(n).indexOf("[native code]") !== -1;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(h6)), h6.exports;
}
var v6 = { exports: {} }, b6 = { exports: {} }, RY;
function _zc() {
  return RY || (RY = 1, function(e) {
    function t() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(b6)), b6.exports;
}
var NY;
function pzc() {
  return NY || (NY = 1, function(e) {
    var t = xme(), n = _zc();
    function o(r, i, a) {
      return n() ? (e.exports = o = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = o = function(c, l, d) {
        var u = [null];
        u.push.apply(u, l);
        var _ = Function.bind.apply(c, u), p = new _();
        return d && t(p, d.prototype), p;
      }, e.exports.__esModule = !0, e.exports.default = e.exports), o.apply(null, arguments);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(v6)), v6.exports;
}
var DY;
function mzc() {
  return DY || (DY = 1, function(e) {
    var t = ir(), n = xme(), o = uzc(), r = pzc();
    function i(a) {
      var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e.exports = i = function(l) {
        if (l === null || !o(l))
          return l;
        if (typeof l != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (typeof s < "u") {
          if (s.has(l))
            return s.get(l);
          s.set(l, d);
        }
        function d() {
          return r(l, arguments, t(this).constructor);
        }
        return d.prototype = Object.create(l.prototype, {
          constructor: {
            value: d,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n(d, l);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, i(a);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(f6)), f6.exports;
}
var MY;
function fzc() {
  if (MY)
    return Pr;
  MY = 1;
  var e = Rt;
  Object.defineProperty(Pr, "__esModule", {
    value: !0
  }), Pr.UnsupportedStrategy = Pr.UnknownError = Pr.OAuthCallbackError = Pr.MissingSecret = Pr.MissingAuthorize = Pr.MissingAdapterMethods = Pr.MissingAdapter = Pr.MissingAPIRoute = Pr.InvalidCallbackUrl = Pr.AccountNotLinkedError = void 0, Pr.adapterErrorHandler = N, Pr.capitalize = D, Pr.eventsErrorHandler = M, Pr.upperSnake = I;
  var t = e(MA()), n = e(LA()), o = e(ua()), r = e(rr), i = e(yr), a = e($r), s = e(wr), c = e(kr()), l = e(ir()), d = e(mzc());
  function u(C) {
    var P = _();
    return function() {
      var w = (0, l.default)(C), E;
      if (P) {
        var T = (0, l.default)(this).constructor;
        E = Reflect.construct(w, arguments, T);
      } else
        E = w.apply(this, arguments);
      return (0, c.default)(this, E);
    };
  }
  function _() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var p = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x(w) {
      var E, T;
      return (0, i.default)(this, x), T = P.call(this, (E = w == null ? void 0 : w.message) !== null && E !== void 0 ? E : w), T.name = "UnknownError", T.code = w.code, w instanceof Error && (T.stack = w.stack), T;
    }
    return (0, a.default)(x, [{
      key: "toJSON",
      value: function() {
        return {
          name: this.name,
          message: this.message,
          stack: this.stack
        };
      }
    }]), x;
  }((0, d.default)(Error));
  Pr.UnknownError = p;
  var f = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "OAuthCallbackError"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.OAuthCallbackError = f;
  var g = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "AccountNotLinkedError"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.AccountNotLinkedError = g;
  var h = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "MissingAPIRouteError"), (0, r.default)((0, o.default)(w), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.MissingAPIRoute = h;
  var b = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "MissingSecretError"), (0, r.default)((0, o.default)(w), "code", "NO_SECRET"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.MissingSecret = b;
  var v = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "MissingAuthorizeError"), (0, r.default)((0, o.default)(w), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.MissingAuthorize = v;
  var $ = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "MissingAdapterError"), (0, r.default)((0, o.default)(w), "code", "EMAIL_REQUIRES_ADAPTER_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.MissingAdapter = $;
  var k = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "MissingAdapterMethodsError"), (0, r.default)((0, o.default)(w), "code", "MISSING_ADAPTER_METHODS_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.MissingAdapterMethods = k;
  var S = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "UnsupportedStrategyError"), (0, r.default)((0, o.default)(w), "code", "CALLBACK_CREDENTIALS_JWT_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.UnsupportedStrategy = S;
  var O = function(C) {
    (0, s.default)(x, C);
    var P = u(x);
    function x() {
      var w;
      (0, i.default)(this, x);
      for (var E = arguments.length, T = new Array(E), z = 0; z < E; z++)
        T[z] = arguments[z];
      return w = P.call.apply(P, [this].concat(T)), (0, r.default)((0, o.default)(w), "name", "InvalidCallbackUrl"), (0, r.default)((0, o.default)(w), "code", "INVALID_CALLBACK_URL_ERROR"), w;
    }
    return (0, a.default)(x);
  }(p);
  Pr.InvalidCallbackUrl = O;
  function I(C) {
    return C.replace(/([A-Z])/g, "_$1").toUpperCase();
  }
  function D(C) {
    return "".concat(C[0].toUpperCase()).concat(C.slice(1));
  }
  function M(C, P) {
    return Object.keys(C).reduce(function(x, w) {
      return x[w] = (0, n.default)(t.default.mark(function E() {
        var T, z = arguments;
        return t.default.wrap(function(q) {
          for (; ; )
            switch (q.prev = q.next) {
              case 0:
                return q.prev = 0, T = C[w], q.next = 4, T.apply(void 0, z);
              case 4:
                return q.abrupt("return", q.sent);
              case 7:
                q.prev = 7, q.t0 = q.catch(0), P.error("".concat(I(w), "_EVENT_ERROR"), q.t0);
              case 10:
              case "end":
                return q.stop();
            }
        }, E, null, [[0, 7]]);
      })), x;
    }, {});
  }
  function N(C, P) {
    if (C)
      return Object.keys(C).reduce(function(x, w) {
        return x[w] = (0, n.default)(t.default.mark(function E() {
          var T, z, j, q, V, F = arguments;
          return t.default.wrap(function(U) {
            for (; ; )
              switch (U.prev = U.next) {
                case 0:
                  for (U.prev = 0, T = F.length, z = new Array(T), j = 0; j < T; j++)
                    z[j] = F[j];
                  return P.debug("adapter_".concat(w), {
                    args: z
                  }), q = C[w], U.next = 6, q.apply(void 0, z);
                case 6:
                  return U.abrupt("return", U.sent);
                case 9:
                  throw U.prev = 9, U.t0 = U.catch(0), P.error("adapter_error_".concat(w), U.t0), V = new p(U.t0), V.name = "".concat(D(w), "Error"), V;
                case 15:
                case "end":
                  return U.stop();
              }
          }, E, null, [[0, 9]]);
        })), x;
      }, {});
  }
  return Pr;
}
var LY;
function gzc() {
  if (LY)
    return Am;
  LY = 1;
  var e = Rt;
  Object.defineProperty(Am, "__esModule", {
    value: !0
  }), Am.default = void 0, Am.proxyLogger = d, Am.setLogger = c;
  var t = e(rr), n = fzc();
  function o(u, _) {
    var p = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var f = Object.getOwnPropertySymbols(u);
      _ && (f = f.filter(function(g) {
        return Object.getOwnPropertyDescriptor(u, g).enumerable;
      })), p.push.apply(p, f);
    }
    return p;
  }
  function r(u) {
    for (var _ = 1; _ < arguments.length; _++) {
      var p = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? o(Object(p), !0).forEach(function(f) {
        (0, t.default)(u, f, p[f]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(p)) : o(Object(p)).forEach(function(f) {
        Object.defineProperty(u, f, Object.getOwnPropertyDescriptor(p, f));
      });
    }
    return u;
  }
  function i(u) {
    if (u instanceof Error && !(u instanceof n.UnknownError))
      return {
        message: u.message,
        stack: u.stack,
        name: u.name
      };
    if (a(u)) {
      var _;
      u.error = i(u.error), u.message = (_ = u.message) !== null && _ !== void 0 ? _ : u.error.message;
    }
    return u;
  }
  function a(u) {
    return !!(u != null && u.error);
  }
  var s = {
    error: function(_, p) {
      p = i(p), console.error("[next-auth][error][".concat(_, "]"), `
https://next-auth.js.org/errors#`.concat(_.toLowerCase()), p.message, p);
    },
    warn: function(_) {
      console.warn("[next-auth][warn][".concat(_, "]"), `
https://next-auth.js.org/warnings#`.concat(_.toLowerCase()));
    },
    debug: function(_, p) {
      console.log("[next-auth][debug][".concat(_, "]"), p);
    }
  };
  function c() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ = arguments.length > 1 ? arguments[1] : void 0;
    _ || (s.debug = function() {
    }), u.error && (s.error = u.error), u.warn && (s.warn = u.warn), u.debug && (s.debug = u.debug);
  }
  var l = s;
  Am.default = l;
  function d() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s, _ = arguments.length > 1 ? arguments[1] : void 0;
    try {
      if (typeof window > "u")
        return u;
      var p = {}, f = function(b) {
        p[b] = function(v, $) {
          s[b](v, $), b === "error" && ($ = i($)), $.client = !0;
          var k = "".concat(_, "/_log"), S = new URLSearchParams(r({
            level: b,
            code: v
          }, $));
          return navigator.sendBeacon ? navigator.sendBeacon(k, S) : fetch(k, {
            method: "POST",
            body: S,
            keepalive: !0
          });
        };
      };
      for (var g in u)
        f(g);
      return p;
    } catch {
      return s;
    }
  }
  return Am;
}
var U2 = {}, qY;
function hzc() {
  if (qY)
    return U2;
  qY = 1, Object.defineProperty(U2, "__esModule", {
    value: !0
  }), U2.default = e;
  function e(t) {
    var n;
    const o = new URL("http://localhost:3000/api/auth");
    t && !t.startsWith("http") && (t = `https://${t}`);
    const r = new URL((n = t) !== null && n !== void 0 ? n : o), i = (r.pathname === "/" ? o.pathname : r.pathname).replace(/\/$/, ""), a = `${r.origin}${i}`;
    return {
      origin: r.origin,
      host: r.host,
      path: i,
      base: a,
      toString: () => a
    };
  }
  return U2;
}
var Cm = {}, jY;
function vzc() {
  if (jY)
    return Cm;
  jY = 1;
  var e = Rt;
  Object.defineProperty(Cm, "__esModule", {
    value: !0
  }), Cm.BroadcastChannel = d, Cm.apiBaseUrl = c, Cm.fetchData = a, Cm.now = l;
  var t = e(MA()), n = e(rr), o = e(LA());
  function r(u, _) {
    var p = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var f = Object.getOwnPropertySymbols(u);
      _ && (f = f.filter(function(g) {
        return Object.getOwnPropertyDescriptor(u, g).enumerable;
      })), p.push.apply(p, f);
    }
    return p;
  }
  function i(u) {
    for (var _ = 1; _ < arguments.length; _++) {
      var p = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? r(Object(p), !0).forEach(function(f) {
        (0, n.default)(u, f, p[f]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(p)) : r(Object(p)).forEach(function(f) {
        Object.defineProperty(u, f, Object.getOwnPropertyDescriptor(p, f));
      });
    }
    return u;
  }
  function a(u, _, p) {
    return s.apply(this, arguments);
  }
  function s() {
    return s = (0, o.default)(t.default.mark(function u(_, p, f) {
      var g, h, b, v, $, k, S, O, I, D = arguments;
      return t.default.wrap(function(N) {
        for (; ; )
          switch (N.prev = N.next) {
            case 0:
              return g = D.length > 3 && D[3] !== void 0 ? D[3] : {}, h = g.ctx, b = g.req, v = b === void 0 ? h == null ? void 0 : h.req : b, $ = "".concat(c(p), "/").concat(_), N.prev = 2, S = {
                headers: i({
                  "Content-Type": "application/json"
                }, v != null && (k = v.headers) !== null && k !== void 0 && k.cookie ? {
                  cookie: v.headers.cookie
                } : {})
              }, v != null && v.body && (S.body = JSON.stringify(v.body), S.method = "POST"), N.next = 7, fetch($, S);
            case 7:
              return O = N.sent, N.next = 10, O.json();
            case 10:
              if (I = N.sent, O.ok) {
                N.next = 13;
                break;
              }
              throw I;
            case 13:
              return N.abrupt("return", Object.keys(I).length > 0 ? I : null);
            case 16:
              return N.prev = 16, N.t0 = N.catch(2), f.error("CLIENT_FETCH_ERROR", {
                error: N.t0,
                url: $
              }), N.abrupt("return", null);
            case 20:
            case "end":
              return N.stop();
          }
      }, u, null, [[2, 16]]);
    })), s.apply(this, arguments);
  }
  function c(u) {
    return typeof window > "u" ? "".concat(u.baseUrlServer).concat(u.basePathServer) : u.basePath;
  }
  function l() {
    return Math.floor(Date.now() / 1e3);
  }
  function d() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "nextauth.message";
    return {
      receive: function(p) {
        var f = function(h) {
          var b;
          if (h.key === u) {
            var v = JSON.parse((b = h.newValue) !== null && b !== void 0 ? b : "{}");
            (v == null ? void 0 : v.event) !== "session" || !(v != null && v.data) || p(v);
          }
        };
        return window.addEventListener("storage", f), function() {
          return window.removeEventListener("storage", f);
        };
      },
      post: function(p) {
        if (!(typeof window > "u"))
          try {
            localStorage.setItem(u, JSON.stringify(i(i({}, p), {}, {
              timestamp: l()
            })));
          } catch {
          }
      }
    };
  }
  return Cm;
}
var y6 = {}, FY;
function bzc() {
  return FY || (FY = 1, Object.defineProperty(y6, "__esModule", {
    value: !0
  })), y6;
}
(function(e) {
  var t = {}, n = Rt, o = Yn;
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = {
    SessionContext: !0,
    useSession: !0,
    getSession: !0,
    getCsrfToken: !0,
    getProviders: !0,
    signIn: !0,
    signOut: !0,
    SessionProvider: !0
  };
  e.SessionContext = void 0, e.SessionProvider = W, e.getCsrfToken = T, e.getProviders = j, e.getSession = w, e.signIn = V, e.signOut = L, e.useSession = x;
  var i = n(MA()), a = n(rr), s = n(LA()), c = n(Tl), l = S(ve), d = S(gzc()), u = n(hzc()), _ = vzc(), p = PT, f = bzc();
  Object.keys(f).forEach(function(H) {
    H === "default" || H === "__esModule" || Object.prototype.hasOwnProperty.call(r, H) || H in e && e[H] === f[H] || Object.defineProperty(e, H, {
      enumerable: !0,
      get: function() {
        return f[H];
      }
    });
  });
  var g, h, b, v, $;
  function k(H) {
    if (typeof WeakMap != "function")
      return null;
    var Q = /* @__PURE__ */ new WeakMap(), X = /* @__PURE__ */ new WeakMap();
    return (k = function(Z) {
      return Z ? X : Q;
    })(H);
  }
  function S(H, Q) {
    if (!Q && H && H.__esModule)
      return H;
    if (H === null || o(H) !== "object" && typeof H != "function")
      return { default: H };
    var X = k(Q);
    if (X && X.has(H))
      return X.get(H);
    var re = {}, Z = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var ee in H)
      if (ee !== "default" && Object.prototype.hasOwnProperty.call(H, ee)) {
        var J = Z ? Object.getOwnPropertyDescriptor(H, ee) : null;
        J && (J.get || J.set) ? Object.defineProperty(re, ee, J) : re[ee] = H[ee];
      }
    return re.default = H, X && X.set(H, re), re;
  }
  function O(H, Q) {
    var X = Object.keys(H);
    if (Object.getOwnPropertySymbols) {
      var re = Object.getOwnPropertySymbols(H);
      Q && (re = re.filter(function(Z) {
        return Object.getOwnPropertyDescriptor(H, Z).enumerable;
      })), X.push.apply(X, re);
    }
    return X;
  }
  function I(H) {
    for (var Q = 1; Q < arguments.length; Q++) {
      var X = arguments[Q] != null ? arguments[Q] : {};
      Q % 2 ? O(Object(X), !0).forEach(function(re) {
        (0, a.default)(H, re, X[re]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(H, Object.getOwnPropertyDescriptors(X)) : O(Object(X)).forEach(function(re) {
        Object.defineProperty(H, re, Object.getOwnPropertyDescriptor(X, re));
      });
    }
    return H;
  }
  var D = {
    baseUrl: (0, u.default)((g = t.NEXTAUTH_URL) !== null && g !== void 0 ? g : t.VERCEL_URL).origin,
    basePath: (0, u.default)(t.NEXTAUTH_URL).path,
    baseUrlServer: (0, u.default)((h = (b = t.NEXTAUTH_URL_INTERNAL) !== null && b !== void 0 ? b : t.NEXTAUTH_URL) !== null && h !== void 0 ? h : t.VERCEL_URL).origin,
    basePathServer: (0, u.default)((v = t.NEXTAUTH_URL_INTERNAL) !== null && v !== void 0 ? v : t.NEXTAUTH_URL).path,
    _lastSync: 0,
    _session: void 0,
    _getSession: function() {
    }
  }, M = (0, _.BroadcastChannel)(), N = (0, d.proxyLogger)(d.default, D.basePath);
  function C() {
    var H = l.useState(typeof navigator < "u" ? navigator.onLine : !1), Q = (0, c.default)(H, 2), X = Q[0], re = Q[1], Z = function() {
      return re(!0);
    }, ee = function() {
      return re(!1);
    };
    return l.useEffect(function() {
      return window.addEventListener("online", Z), window.addEventListener("offline", ee), function() {
        window.removeEventListener("online", Z), window.removeEventListener("offline", ee);
      };
    }, []), X;
  }
  var P = ($ = l.createContext) === null || $ === void 0 ? void 0 : $.call(l, void 0);
  e.SessionContext = P;
  function x(H) {
    if (!P)
      throw new Error("React Context is unavailable in Server Components");
    var Q = l.useContext(P), X = H ?? {}, re = X.required, Z = X.onUnauthenticated, ee = re && Q.status === "unauthenticated";
    return l.useEffect(function() {
      if (ee) {
        var J = "/api/auth/signin?".concat(new URLSearchParams({
          error: "SessionRequired",
          callbackUrl: window.location.href
        }));
        Z ? Z() : window.location.href = J;
      }
    }, [ee, Z]), ee ? {
      data: Q.data,
      update: Q.update,
      status: "loading"
    } : Q;
  }
  function w(H) {
    return E.apply(this, arguments);
  }
  function E() {
    return E = (0, s.default)(i.default.mark(function H(Q) {
      var X, re;
      return i.default.wrap(function(ee) {
        for (; ; )
          switch (ee.prev = ee.next) {
            case 0:
              return ee.next = 2, (0, _.fetchData)("session", D, N, Q);
            case 2:
              return re = ee.sent, (!((X = Q == null ? void 0 : Q.broadcast) !== null && X !== void 0) || X) && M.post({
                event: "session",
                data: {
                  trigger: "getSession"
                }
              }), ee.abrupt("return", re);
            case 5:
            case "end":
              return ee.stop();
          }
      }, H);
    })), E.apply(this, arguments);
  }
  function T(H) {
    return z.apply(this, arguments);
  }
  function z() {
    return z = (0, s.default)(i.default.mark(function H(Q) {
      var X;
      return i.default.wrap(function(Z) {
        for (; ; )
          switch (Z.prev = Z.next) {
            case 0:
              return Z.next = 2, (0, _.fetchData)("csrf", D, N, Q);
            case 2:
              return X = Z.sent, Z.abrupt("return", X == null ? void 0 : X.csrfToken);
            case 4:
            case "end":
              return Z.stop();
          }
      }, H);
    })), z.apply(this, arguments);
  }
  function j() {
    return q.apply(this, arguments);
  }
  function q() {
    return q = (0, s.default)(i.default.mark(function H() {
      return i.default.wrap(function(X) {
        for (; ; )
          switch (X.prev = X.next) {
            case 0:
              return X.next = 2, (0, _.fetchData)("providers", D, N);
            case 2:
              return X.abrupt("return", X.sent);
            case 3:
            case "end":
              return X.stop();
          }
      }, H);
    })), q.apply(this, arguments);
  }
  function V(H, Q, X) {
    return F.apply(this, arguments);
  }
  function F() {
    return F = (0, s.default)(i.default.mark(function H(Q, X, re) {
      var Z, ee, J, oe, ce, de, te, ue, le, se, me, pe, be, Se, Ae, Ze, Ge;
      return i.default.wrap(function(qe) {
        for (; ; )
          switch (qe.prev = qe.next) {
            case 0:
              return Z = X ?? {}, ee = Z.callbackUrl, J = ee === void 0 ? window.location.href : ee, oe = Z.redirect, ce = oe === void 0 ? !0 : oe, de = (0, _.apiBaseUrl)(D), qe.next = 4, j();
            case 4:
              if (te = qe.sent, te) {
                qe.next = 8;
                break;
              }
              return window.location.href = "".concat(de, "/error"), qe.abrupt("return");
            case 8:
              if (!(!Q || !(Q in te))) {
                qe.next = 11;
                break;
              }
              return window.location.href = "".concat(de, "/signin?").concat(new URLSearchParams({
                callbackUrl: J
              })), qe.abrupt("return");
            case 11:
              return ue = te[Q].type === "credentials", le = te[Q].type === "email", se = ue || le, me = "".concat(de, "/").concat(ue ? "callback" : "signin", "/").concat(Q), pe = "".concat(me, "?").concat(new URLSearchParams(re)), qe.t0 = fetch, qe.t1 = pe, qe.t2 = {
                "Content-Type": "application/x-www-form-urlencoded"
              }, qe.t3 = URLSearchParams, qe.t4 = I, qe.t5 = I({}, X), qe.t6 = {}, qe.next = 25, T();
            case 25:
              return qe.t7 = qe.sent, qe.t8 = J, qe.t9 = {
                csrfToken: qe.t7,
                callbackUrl: qe.t8,
                json: !0
              }, qe.t10 = (0, qe.t4)(qe.t5, qe.t6, qe.t9), qe.t11 = new qe.t3(qe.t10), qe.t12 = {
                method: "post",
                headers: qe.t2,
                body: qe.t11
              }, qe.next = 33, (0, qe.t0)(qe.t1, qe.t12);
            case 33:
              return be = qe.sent, qe.next = 36, be.json();
            case 36:
              if (Se = qe.sent, !(ce || !se)) {
                qe.next = 42;
                break;
              }
              return Ze = (Ae = Se.url) !== null && Ae !== void 0 ? Ae : J, window.location.href = Ze, Ze.includes("#") && window.location.reload(), qe.abrupt("return");
            case 42:
              if (Ge = new URL(Se.url).searchParams.get("error"), !be.ok) {
                qe.next = 46;
                break;
              }
              return qe.next = 46, D._getSession({
                event: "storage"
              });
            case 46:
              return qe.abrupt("return", {
                error: Ge,
                status: be.status,
                ok: be.ok,
                url: Ge ? null : Se.url
              });
            case 47:
            case "end":
              return qe.stop();
          }
      }, H);
    })), F.apply(this, arguments);
  }
  function L(H) {
    return U.apply(this, arguments);
  }
  function U() {
    return U = (0, s.default)(i.default.mark(function H(Q) {
      var X, re, Z, ee, J, oe, ce, de, te, ue;
      return i.default.wrap(function(se) {
        for (; ; )
          switch (se.prev = se.next) {
            case 0:
              return re = Q ?? {}, Z = re.callbackUrl, ee = Z === void 0 ? window.location.href : Z, J = (0, _.apiBaseUrl)(D), se.t0 = {
                "Content-Type": "application/x-www-form-urlencoded"
              }, se.t1 = URLSearchParams, se.next = 6, T();
            case 6:
              return se.t2 = se.sent, se.t3 = ee, se.t4 = {
                csrfToken: se.t2,
                callbackUrl: se.t3,
                json: !0
              }, se.t5 = new se.t1(se.t4), oe = {
                method: "post",
                headers: se.t0,
                body: se.t5
              }, se.next = 13, fetch("".concat(J, "/signout"), oe);
            case 13:
              return ce = se.sent, se.next = 16, ce.json();
            case 16:
              if (de = se.sent, M.post({
                event: "session",
                data: {
                  trigger: "signout"
                }
              }), !(!((X = Q == null ? void 0 : Q.redirect) !== null && X !== void 0) || X)) {
                se.next = 23;
                break;
              }
              return ue = (te = de.url) !== null && te !== void 0 ? te : ee, window.location.href = ue, ue.includes("#") && window.location.reload(), se.abrupt("return");
            case 23:
              return se.next = 25, D._getSession({
                event: "storage"
              });
            case 25:
              return se.abrupt("return", de);
            case 26:
            case "end":
              return se.stop();
          }
      }, H);
    })), U.apply(this, arguments);
  }
  function W(H) {
    if (!P)
      throw new Error("React Context is unavailable in Server Components");
    var Q = H.children, X = H.basePath, re = H.refetchInterval, Z = H.refetchWhenOffline;
    X && (D.basePath = X);
    var ee = H.session !== void 0;
    D._lastSync = ee ? (0, _.now)() : 0;
    var J = l.useState(function() {
      return ee && (D._session = H.session), H.session;
    }), oe = (0, c.default)(J, 2), ce = oe[0], de = oe[1], te = l.useState(!ee), ue = (0, c.default)(te, 2), le = ue[0], se = ue[1];
    l.useEffect(function() {
      return D._getSession = (0, s.default)(i.default.mark(function Se() {
        var Ae, Ze, Ge, rt = arguments;
        return i.default.wrap(function(Xe) {
          for (; ; )
            switch (Xe.prev = Xe.next) {
              case 0:
                if (Ae = rt.length > 0 && rt[0] !== void 0 ? rt[0] : {}, Ze = Ae.event, Xe.prev = 1, Ge = Ze === "storage", !(Ge || D._session === void 0)) {
                  Xe.next = 10;
                  break;
                }
                return D._lastSync = (0, _.now)(), Xe.next = 7, w({
                  broadcast: !Ge
                });
              case 7:
                return D._session = Xe.sent, de(D._session), Xe.abrupt("return");
              case 10:
                if (!(!Ze || D._session === null || (0, _.now)() < D._lastSync)) {
                  Xe.next = 12;
                  break;
                }
                return Xe.abrupt("return");
              case 12:
                return D._lastSync = (0, _.now)(), Xe.next = 15, w();
              case 15:
                D._session = Xe.sent, de(D._session), Xe.next = 22;
                break;
              case 19:
                Xe.prev = 19, Xe.t0 = Xe.catch(1), N.error("CLIENT_SESSION_ERROR", Xe.t0);
              case 22:
                return Xe.prev = 22, se(!1), Xe.finish(22);
              case 25:
              case "end":
                return Xe.stop();
            }
        }, Se, null, [[1, 19, 22, 25]]);
      })), D._getSession(), function() {
        D._lastSync = 0, D._session = void 0, D._getSession = function() {
        };
      };
    }, []), l.useEffect(function() {
      var Se = M.receive(function() {
        return D._getSession({
          event: "storage"
        });
      });
      return function() {
        return Se();
      };
    }, []), l.useEffect(function() {
      var Se = H.refetchOnWindowFocus, Ae = Se === void 0 ? !0 : Se, Ze = function() {
        Ae && document.visibilityState === "visible" && D._getSession({
          event: "visibilitychange"
        });
      };
      return document.addEventListener("visibilitychange", Ze, !1), function() {
        return document.removeEventListener("visibilitychange", Ze, !1);
      };
    }, [H.refetchOnWindowFocus]);
    var me = C(), pe = Z !== !1 || me;
    l.useEffect(function() {
      if (re && pe) {
        var Se = setInterval(function() {
          D._session && D._getSession({
            event: "poll"
          });
        }, re * 1e3);
        return function() {
          return clearInterval(Se);
        };
      }
    }, [re, pe]);
    var be = l.useMemo(function() {
      return {
        data: ce,
        status: le ? "loading" : ce ? "authenticated" : "unauthenticated",
        update: function(Ae) {
          return (0, s.default)(i.default.mark(function Ze() {
            var Ge;
            return i.default.wrap(function(qe) {
              for (; ; )
                switch (qe.prev = qe.next) {
                  case 0:
                    if (!(le || !ce)) {
                      qe.next = 2;
                      break;
                    }
                    return qe.abrupt("return");
                  case 2:
                    return se(!0), qe.t0 = _.fetchData, qe.t1 = D, qe.t2 = N, qe.next = 8, T();
                  case 8:
                    return qe.t3 = qe.sent, qe.t4 = Ae, qe.t5 = {
                      csrfToken: qe.t3,
                      data: qe.t4
                    }, qe.t6 = {
                      body: qe.t5
                    }, qe.t7 = {
                      req: qe.t6
                    }, qe.next = 15, (0, qe.t0)("session", qe.t1, qe.t2, qe.t7);
                  case 15:
                    return Ge = qe.sent, se(!1), Ge && (de(Ge), M.post({
                      event: "session",
                      data: {
                        trigger: "getSession"
                      }
                    })), qe.abrupt("return", Ge);
                  case 19:
                  case "end":
                    return qe.stop();
                }
            }, Ze);
          }))();
        }
      };
    }, [ce, le]);
    return (0, p.jsx)(P.Provider, {
      value: be,
      children: Q
    });
  }
})(sc);
function yzc(e = !1) {
  const { data: t, status: n } = sc.useSession(), o = n === "loading", r = Ro.useRouter();
  return Le(() => {
    if (!e && !o && !t) {
      const i = new URLSearchParams();
      i.set("callbackUrl", `${Si}${location.pathname}${location.search}`), r.replace(`/auth/login?${i.toString()}`);
    }
  }, [o, t, e]), {
    loading: o && !t,
    session: t
  };
}
const $zc = No(null);
function zj() {
  const e = Pn($zc);
  if (e === null)
    throw new Error("Error: useFlagMap was used outside of FeatureProvider.");
  return e;
}
const wzc = (e) => !e.completedOnboarding && !e.organizationId && De(e.createdDate).isAfter(kzc), kzc = De("September 1 2021").toISOString();
function Szc() {
  const e = Ro.useRouter(), { data: t, isLoading: n } = tk(), o = zj(), r = !(t != null && t.emailVerified) && (t == null ? void 0 : t.identityProvider) === "CAL" && o["email-verification"], i = t && wzc(t), a = !n && i && !r;
  return Le(() => {
    if (a) {
      const s = o["onboarding-v3"] ? "/onboarding/getting-started" : "/getting-started";
      e.replace(s);
    }
  }, [a, e, o]), {
    isLoading: n,
    shouldRedirectToOnboarding: i
  };
}
var xzc = Object.defineProperty, Ezc = (e, t, n) => t in e ? xzc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, nh = (e, t, n) => (Ezc(e, typeof t != "symbol" ? t + "" : t, n), n);
const Tzc = (e) => async (...t) => {
  try {
    return {
      ok: !0,
      data: await e(...t)
    };
  } catch (n) {
    return {
      ok: !1,
      error: n
    };
  }
};
class Azc {
  constructor() {
    nh(this, "queue", []), nh(this, "isExecuting", !1), nh(this, "add", (t) => {
      this.queue.push(t), this.run();
    }), nh(this, "runNext", async () => {
      if (this.isExecuting)
        return;
      const t = this.queue.shift();
      if (t) {
        this.isExecuting = !0;
        try {
          await t();
        } finally {
          this.isExecuting = !1, this.queue.length > 0 && this.runNext();
        }
      }
    }), nh(this, "run", async () => {
      !this.isExecuting && this.queue.length > 0 && await this.runNext();
    }), nh(this, "clear", () => {
      this.queue = [];
    });
  }
}
let Vy = !1, VY = !1;
const $6 = new Azc(), Czc = async (e, t) => {
  if (!window.formbricks) {
    const n = await fetch(`${e}/api/packages/${t}`);
    if (!n.ok)
      return { ok: !1, error: new Error(`Failed to load Formbricks ${t} SDK`) };
    const o = await n.text(), r = document.createElement("script");
    r.innerHTML = o, document.head.appendChild(r);
    const i = async () => new Promise((a, s) => {
      const c = setInterval(() => {
        window.formbricks && (clearInterval(c), a());
      }, 100);
      setTimeout(() => {
        clearInterval(c), s(new Error(`Formbricks ${t} SDK loading timed out`));
      }, 1e4);
    });
    try {
      return await i(), { ok: !0, data: void 0 };
    } catch (a) {
      return {
        ok: !1,
        error: new Error(a.message ?? `Failed to load Formbricks ${t} SDK`)
      };
    }
  }
  return { ok: !0, data: void 0 };
}, zzc = async (e, t, ...n) => {
  const o = async () => {
    try {
      return await window.formbricks[e](...n);
    } catch (r) {
      throw console.error(`🧱 Formbricks - Global error: ${r}`), r;
    }
  };
  if (VY) {
    if (window.formbricks && typeof window.formbricks[e] != "function") {
      console.error(
        `🧱 Formbricks - Global error: Formbricks ${t} SDK does not support method ${String(e)}`
      );
      return;
    }
    $6.add(o);
    return;
  } else if (Vy)
    $6.add(o);
  else if (e === "init") {
    Vy = !0;
    const r = async () => {
      const { apiHost: i } = n[0], a = await Tzc(Czc)(i, t);
      if (!a.ok) {
        Vy = !1, console.error(`🧱 Formbricks - Global error: ${a.error.message}`);
        return;
      }
      try {
        const s = await window.formbricks[e](...n);
        return VY = !0, Vy = !1, s;
      } catch (s) {
        throw Vy = !1, console.error(`🧱 Formbricks - Global error: ${s}`), s;
      }
    };
    $6.add(r);
  } else {
    console.error(
      "🧱 Formbricks - Global error: You need to call formbricks.init before calling any other method"
    );
    return;
  }
}, Ozc = {
  get(e, t, n) {
    return (...o) => zzc(t, "app", ...o);
  }
}, Pzc = new Proxy({}, Ozc);
var W2 = {};
const Izc = ({
  userId: e,
  attributes: t
}) => {
  const n = {};
  Object.entries(t).forEach(([o, r]) => {
    r != null && (n[o] = r);
  }), W2.NEXT_PUBLIC_FORMBRICKS_HOST_URL && W2.NEXT_PUBLIC_FORMBRICKS_ENVIRONMENT_ID && Pzc.init({
    environmentId: W2.NEXT_PUBLIC_FORMBRICKS_ENVIRONMENT_ID,
    apiHost: W2.NEXT_PUBLIC_FORMBRICKS_HOST_URL,
    debug: !1,
    userId: e,
    attributes: n
  });
}, Rzc = () => {
  const { data: e, isLoading: t } = tk(), { data: n, status: o } = sc.useSession();
  Le(() => {
    var r, i, a;
    !t && e && n && Izc({
      userId: e.id.toString(),
      attributes: {
        name: e == null ? void 0 : e.name,
        email: e.email,
        username: e == null ? void 0 : e.username,
        belongsToActiveTeam: (r = n.user.belongsToActiveTeam) == null ? void 0 : r.toString(),
        isOrganizationAdmin: (a = (i = e.organization) == null ? void 0 : i.isOrgAdmin) == null ? void 0 : a.toString()
      }
    });
  }, [t, e, o, n]);
};
var Jd = {}, Wo = {}, DM = Je && Je.__assign || function() {
  return DM = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, DM.apply(this, arguments);
}, Nzc = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), Dzc = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Mzc = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Nzc(t, e, n);
  return Dzc(t, e), t;
}, Lzc = Je && Je.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
};
Object.defineProperty(Wo, "__esModule", { value: !0 });
Wo.Priority = Wo.isModKey = Wo.shouldRejectKeystrokes = Wo.useThrottledValue = Wo.getScrollbarWidth = Wo.useIsomorphicLayout = Wo.noop = Wo.createAction = Wo.randomId = Wo.usePointerMovedSinceMount = Wo.useOuterClick = Wo.swallowEvent = void 0;
var Fp = Mzc(ve);
function qzc(e) {
  e.stopPropagation(), e.preventDefault();
}
Wo.swallowEvent = qzc;
function jzc(e, t) {
  var n = Fp.useRef(t);
  n.current = t, Fp.useEffect(function() {
    function o(r) {
      var i, a;
      !((i = e.current) === null || i === void 0) && i.contains(r.target) || // Add support for ReactShadowRoot
      // @ts-expect-error wrong types, the `host` property exists https://stackoverflow.com/a/25340456
      r.target === ((a = e.current) === null || a === void 0 ? void 0 : a.getRootNode().host) || (r.preventDefault(), r.stopPropagation(), n.current());
    }
    return window.addEventListener("pointerdown", o, !0), function() {
      return window.removeEventListener("pointerdown", o, !0);
    };
  }, [e]);
}
Wo.useOuterClick = jzc;
function Fzc() {
  var e = Fp.useState(!1), t = e[0], n = e[1];
  return Fp.useEffect(function() {
    function o() {
      n(!0);
    }
    if (!t)
      return window.addEventListener("pointermove", o), function() {
        return window.removeEventListener("pointermove", o);
      };
  }, [t]), t;
}
Wo.usePointerMovedSinceMount = Fzc;
function Eme() {
  return Math.random().toString(36).substring(2, 9);
}
Wo.randomId = Eme;
function Vzc(e) {
  return DM({ id: Eme() }, e);
}
Wo.createAction = Vzc;
function Tme() {
}
Wo.noop = Tme;
Wo.useIsomorphicLayout = typeof window > "u" ? Tme : Fp.useLayoutEffect;
function Bzc() {
  var e = document.createElement("div");
  e.style.visibility = "hidden", e.style.overflow = "scroll", document.body.appendChild(e);
  var t = document.createElement("div");
  e.appendChild(t);
  var n = e.offsetWidth - t.offsetWidth;
  return e.parentNode.removeChild(e), n;
}
Wo.getScrollbarWidth = Bzc;
function Uzc(e, t) {
  t === void 0 && (t = 100);
  var n = Fp.useState(e), o = n[0], r = n[1], i = Fp.useRef(Date.now());
  return Fp.useEffect(function() {
    if (t !== 0) {
      var a = setTimeout(function() {
        r(e), i.current = Date.now();
      }, i.current - (Date.now() - t));
      return function() {
        clearTimeout(a);
      };
    }
  }, [t, e]), t === 0 ? e : o;
}
Wo.useThrottledValue = Uzc;
function Wzc(e) {
  var t, n, o = e === void 0 ? { ignoreWhenFocused: [] } : e, r = o.ignoreWhenFocused, i = Lzc(["input", "textarea"], r, !0).map(function(c) {
    return c.toLowerCase();
  }), a = document.activeElement, s = a && (i.indexOf(a.tagName.toLowerCase()) !== -1 || ((t = a.attributes.getNamedItem("role")) === null || t === void 0 ? void 0 : t.value) === "textbox" || ((n = a.attributes.getNamedItem("contenteditable")) === null || n === void 0 ? void 0 : n.value) === "true");
  return s;
}
Wo.shouldRejectKeystrokes = Wzc;
var Gzc = typeof window > "u", Hzc = !Gzc && window.navigator.platform === "MacIntel";
function Kzc(e) {
  return Hzc ? e.metaKey : e.ctrlKey;
}
Wo.isModKey = Kzc;
Wo.Priority = {
  HIGH: 1,
  NORMAL: 0,
  LOW: -1
};
var Ame = {}, By = {}, w6 = {}, qA = {}, MM = { exports: {} };
(function(e, t) {
  (function(n, o) {
    o(t);
  })(Je, function(n) {
    var o = typeof WeakSet == "function", r = Object.keys;
    function i(N, C) {
      return N === C || N !== N && C !== C;
    }
    function a(N) {
      return N.constructor === Object || N.constructor == null;
    }
    function s(N) {
      return !!N && typeof N.then == "function";
    }
    function c(N) {
      return !!(N && N.$$typeof);
    }
    function l() {
      var N = [];
      return {
        add: function(C) {
          N.push(C);
        },
        has: function(C) {
          return N.indexOf(C) !== -1;
        }
      };
    }
    var d = /* @__PURE__ */ function(N) {
      return N ? function() {
        return /* @__PURE__ */ new WeakSet();
      } : l;
    }(o);
    function u(N) {
      return function(P) {
        var x = N || P;
        return function(E, T, z) {
          z === void 0 && (z = d());
          var j = !!E && typeof E == "object", q = !!T && typeof T == "object";
          if (j || q) {
            var V = j && z.has(E), F = q && z.has(T);
            if (V || F)
              return V && F;
            j && z.add(E), q && z.add(T);
          }
          return x(E, T, z);
        };
      };
    }
    function _(N, C, P, x) {
      var w = N.length;
      if (C.length !== w)
        return !1;
      for (; w-- > 0; )
        if (!P(N[w], C[w], x))
          return !1;
      return !0;
    }
    function p(N, C, P, x) {
      var w = N.size === C.size;
      if (w && N.size) {
        var E = {};
        N.forEach(function(T, z) {
          if (w) {
            var j = !1, q = 0;
            C.forEach(function(V, F) {
              !j && !E[q] && (j = P(z, F, x) && P(T, V, x), j && (E[q] = !0)), q++;
            }), w = j;
          }
        });
      }
      return w;
    }
    var f = "_owner", g = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
    function h(N, C, P, x) {
      var w = r(N), E = w.length;
      if (r(C).length !== E)
        return !1;
      if (E)
        for (var T = void 0; E-- > 0; ) {
          if (T = w[E], T === f) {
            var z = c(N), j = c(C);
            if ((z || j) && z !== j)
              return !1;
          }
          if (!g(C, T) || !P(N[T], C[T], x))
            return !1;
        }
      return !0;
    }
    function b(N, C) {
      return N.source === C.source && N.global === C.global && N.ignoreCase === C.ignoreCase && N.multiline === C.multiline && N.unicode === C.unicode && N.sticky === C.sticky && N.lastIndex === C.lastIndex;
    }
    function v(N, C, P, x) {
      var w = N.size === C.size;
      if (w && N.size) {
        var E = {};
        N.forEach(function(T) {
          if (w) {
            var z = !1, j = 0;
            C.forEach(function(q) {
              !z && !E[j] && (z = P(T, q, x), z && (E[j] = !0)), j++;
            }), w = z;
          }
        });
      }
      return w;
    }
    var $ = typeof Map == "function", k = typeof Set == "function";
    function S(N) {
      var C = (
        /* eslint-disable no-use-before-define */
        typeof N == "function" ? N(P) : P
      );
      function P(x, w, E) {
        if (x === w)
          return !0;
        if (x && w && typeof x == "object" && typeof w == "object") {
          if (a(x) && a(w))
            return h(x, w, C, E);
          var T = Array.isArray(x), z = Array.isArray(w);
          return T || z ? T === z && _(x, w, C, E) : (T = x instanceof Date, z = w instanceof Date, T || z ? T === z && i(x.getTime(), w.getTime()) : (T = x instanceof RegExp, z = w instanceof RegExp, T || z ? T === z && b(x, w) : s(x) || s(w) ? x === w : $ && (T = x instanceof Map, z = w instanceof Map, T || z) ? T === z && p(x, w, C, E) : k && (T = x instanceof Set, z = w instanceof Set, T || z) ? T === z && v(x, w, C, E) : h(x, w, C, E)));
        }
        return x !== x && w !== w;
      }
      return P;
    }
    var O = S(), I = S(function() {
      return i;
    }), D = S(u()), M = S(u(i));
    n.circularDeepEqual = D, n.circularShallowEqual = M, n.createCustomEqual = S, n.deepEqual = O, n.sameValueZeroEqual = i, n.shallowEqual = I, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(MM, MM.exports);
var Yzc = MM.exports, nk = {}, Zzc = "Invariant failed";
function Qzc(e, t) {
  if (!e)
    throw new Error(Zzc);
}
const Jzc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qzc
}, Symbol.toStringTag, { value: "Module" })), Cme = /* @__PURE__ */ Oa(Jzc);
var ok = {}, jA = {};
Object.defineProperty(jA, "__esModule", { value: !0 });
jA.Command = void 0;
var Xzc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var o = this;
      n === void 0 && (n = {}), this.perform = function() {
        var r = t.perform();
        if (typeof r == "function") {
          var i = n.history;
          i && (o.historyItem && i.remove(o.historyItem), o.historyItem = i.add({
            perform: t.perform,
            negate: r
          }), o.history = {
            undo: function() {
              return i.undo(o.historyItem);
            },
            redo: function() {
              return i.redo(o.historyItem);
            }
          });
        }
      };
    }
    return e;
  }()
);
jA.Command = Xzc;
var eOc = Je && Je.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ok, "__esModule", { value: !0 });
ok.ActionImpl = void 0;
var tOc = eOc(Cme), nOc = jA, oOc = Wo, rOc = function(e) {
  var t = e.keywords, n = t === void 0 ? "" : t, o = e.section, r = o === void 0 ? "" : o;
  return (n + " " + (typeof r == "string" ? r : r.name)).trim();
}, iOc = (
  /** @class */
  function() {
    function e(t, n) {
      var o = this, r;
      this.priority = oOc.Priority.NORMAL, this.ancestors = [], this.children = [], Object.assign(this, t), this.id = t.id, this.name = t.name, this.keywords = rOc(t);
      var i = t.perform;
      if (this.command = i && new nOc.Command({
        perform: function() {
          return i(o);
        }
      }, {
        history: n.history
      }), this.perform = (r = this.command) === null || r === void 0 ? void 0 : r.perform, t.parent) {
        var a = n.store[t.parent];
        (0, tOc.default)(a, "attempted to create an action whos parent: " + t.parent + " does not exist in the store."), a.addChild(this);
      }
    }
    return e.prototype.addChild = function(t) {
      t.ancestors.unshift(this);
      for (var n = this.parentActionImpl; n; )
        t.ancestors.unshift(n), n = n.parentActionImpl;
      this.children.push(t);
    }, e.prototype.removeChild = function(t) {
      var n = this, o = this.children.indexOf(t);
      o !== -1 && this.children.splice(o, 1), t.children && t.children.forEach(function(r) {
        n.removeChild(r);
      });
    }, Object.defineProperty(e.prototype, "parentActionImpl", {
      // easily access parentActionImpl after creation
      get: function() {
        return this.ancestors[this.ancestors.length - 1];
      },
      enumerable: !1,
      configurable: !0
    }), e.create = function(t, n) {
      return new e(t, n);
    }, e;
  }()
);
ok.ActionImpl = iOc;
var xE = Je && Je.__assign || function() {
  return xE = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, xE.apply(this, arguments);
}, aOc = Je && Je.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(nk, "__esModule", { value: !0 });
nk.ActionInterface = void 0;
var sOc = aOc(Cme), cOc = ok, lOc = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = []), n === void 0 && (n = {}), this.actions = {}, this.options = n, this.add(t);
    }
    return e.prototype.add = function(t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.parent && (0, sOc.default)(this.actions[o.parent], 'Attempted to create action "' + o.name + '" without registering its parent "' + o.parent + '" first.'), this.actions[o.id] = cOc.ActionImpl.create(o, {
          history: this.options.historyManager,
          store: this.actions
        });
      }
      return xE({}, this.actions);
    }, e.prototype.remove = function(t) {
      var n = this;
      return t.forEach(function(o) {
        var r = n.actions[o.id];
        if (r) {
          for (var i = r.children; i.length; ) {
            var a = i.pop();
            if (!a)
              return;
            delete n.actions[a.id], a.parentActionImpl && a.parentActionImpl.removeChild(a), a.children && i.push.apply(i, a.children);
          }
          r.parentActionImpl && r.parentActionImpl.removeChild(r), delete n.actions[o.id];
        }
      }), xE({}, this.actions);
    }, e;
  }()
);
nk.ActionInterface = lOc;
var Lv = {};
Object.defineProperty(Lv, "__esModule", { value: !0 });
Lv.history = Lv.HistoryItemImpl = void 0;
var dOc = Wo, zme = (
  /** @class */
  function() {
    function e(t) {
      this.perform = t.perform, this.negate = t.negate;
    }
    return e.create = function(t) {
      return new e(t);
    }, e;
  }()
);
Lv.HistoryItemImpl = zme;
var uOc = (
  /** @class */
  function() {
    function e() {
      return this.undoStack = [], this.redoStack = [], e.instance || (e.instance = this, this.init()), e.instance;
    }
    return e.prototype.init = function() {
      var t = this;
      typeof window > "u" || window.addEventListener("keydown", function(n) {
        var o;
        if (!(!t.redoStack.length && !t.undoStack.length || (0, dOc.shouldRejectKeystrokes)())) {
          var r = (o = n.key) === null || o === void 0 ? void 0 : o.toLowerCase();
          n.metaKey && r === "z" && n.shiftKey ? t.redo() : n.metaKey && r === "z" && t.undo();
        }
      });
    }, e.prototype.add = function(t) {
      var n = zme.create(t);
      return this.undoStack.push(n), n;
    }, e.prototype.remove = function(t) {
      var n = this.undoStack.findIndex(function(r) {
        return r === t;
      });
      if (n !== -1) {
        this.undoStack.splice(n, 1);
        return;
      }
      var o = this.redoStack.findIndex(function(r) {
        return r === t;
      });
      o !== -1 && this.redoStack.splice(o, 1);
    }, e.prototype.undo = function(t) {
      if (!t) {
        var n = this.undoStack.pop();
        return n ? (n == null || n.negate(), this.redoStack.push(n), n) : void 0;
      }
      var o = this.undoStack.findIndex(function(r) {
        return r === t;
      });
      if (o !== -1)
        return this.undoStack.splice(o, 1), t.negate(), this.redoStack.push(t), t;
    }, e.prototype.redo = function(t) {
      if (!t) {
        var n = this.redoStack.pop();
        return n ? (n == null || n.perform(), this.undoStack.push(n), n) : void 0;
      }
      var o = this.redoStack.findIndex(function(r) {
        return r === t;
      });
      if (o !== -1)
        return this.redoStack.splice(o, 1), t.perform(), this.undoStack.push(t), t;
    }, e.prototype.reset = function() {
      this.undoStack.splice(0), this.redoStack.splice(0);
    }, e;
  }()
), Ome = new uOc();
Lv.history = Ome;
Object.freeze(Ome);
var pg = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.VisualState = void 0, function(t) {
    t.animatingIn = "animating-in", t.showing = "showing", t.animatingOut = "animating-out", t.hidden = "hidden";
  }(e.VisualState || (e.VisualState = {}));
})(pg);
var Qi = Je && Je.__assign || function() {
  return Qi = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Qi.apply(this, arguments);
}, _Oc = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), pOc = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), mOc = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && _Oc(t, e, n);
  return pOc(t, e), t;
};
Object.defineProperty(qA, "__esModule", { value: !0 });
qA.useStore = void 0;
var fOc = Yzc, Bu = mOc(ve), gOc = nk, hOc = Lv, Uy = pg;
function vOc(e) {
  var t = Bu.useRef(Qi({ animations: {
    enterMs: 200,
    exitMs: 100
  } }, e.options)), n = Bu.useMemo(
    function() {
      return new gOc.ActionInterface(e.actions || [], {
        historyManager: t.current.enableHistory ? hOc.history : void 0
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), o = Bu.useState({
    searchQuery: "",
    currentRootActionId: null,
    visualState: Uy.VisualState.hidden,
    actions: Qi({}, n.actions),
    activeIndex: 0
  }), r = o[0], i = o[1], a = Bu.useRef(r);
  a.current = r;
  var s = Bu.useCallback(function() {
    return a.current;
  }, []), c = Bu.useMemo(function() {
    return new bOc(s);
  }, [s]);
  Bu.useEffect(function() {
    a.current = r, c.notify();
  }, [r, c]);
  var l = Bu.useCallback(function(d) {
    return i(function(u) {
      return Qi(Qi({}, u), { actions: n.add(d) });
    }), function() {
      i(function(_) {
        return Qi(Qi({}, _), { actions: n.remove(d) });
      });
    };
  }, [n]);
  return Bu.useMemo(function() {
    return {
      getState: s,
      query: {
        setCurrentRootAction: function(d) {
          i(function(u) {
            return Qi(Qi({}, u), { currentRootActionId: d });
          });
        },
        setVisualState: function(d) {
          i(function(u) {
            return Qi(Qi({}, u), { visualState: typeof d == "function" ? d(u.visualState) : d });
          });
        },
        setSearch: function(d) {
          return i(function(u) {
            return Qi(Qi({}, u), { searchQuery: d });
          });
        },
        registerActions: l,
        toggle: function() {
          return i(function(d) {
            return Qi(Qi({}, d), { visualState: [
              Uy.VisualState.animatingOut,
              Uy.VisualState.hidden
            ].includes(d.visualState) ? Uy.VisualState.animatingIn : Uy.VisualState.animatingOut });
          });
        },
        setActiveIndex: function(d) {
          return i(function(u) {
            return Qi(Qi({}, u), { activeIndex: typeof d == "number" ? d : d(u.activeIndex) });
          });
        }
      },
      options: t.current,
      subscribe: function(d, u) {
        return c.subscribe(d, u);
      }
    };
  }, [s, c, l]);
}
qA.useStore = vOc;
var bOc = (
  /** @class */
  function() {
    function e(t) {
      this.subscribers = [], this.getState = t;
    }
    return e.prototype.subscribe = function(t, n) {
      var o = this, r = new yOc(function() {
        return t(o.getState());
      }, n);
      return this.subscribers.push(r), this.unsubscribe.bind(this, r);
    }, e.prototype.unsubscribe = function(t) {
      if (this.subscribers.length) {
        var n = this.subscribers.indexOf(t);
        if (n > -1)
          return this.subscribers.splice(n, 1);
      }
    }, e.prototype.notify = function() {
      this.subscribers.forEach(function(t) {
        return t.collect();
      });
    }, e;
  }()
), yOc = (
  /** @class */
  function() {
    function e(t, n) {
      this.collector = t, this.onChange = n;
    }
    return e.prototype.collect = function() {
      try {
        var t = this.collector();
        (0, fOc.deepEqual)(t, this.collected) || (this.collected = t, this.onChange && this.onChange(this.collected));
      } catch (n) {
        console.warn(n);
      }
    }, e;
  }()
), Wy = {}, Oj = {};
Object.defineProperty(Oj, "__esModule", { value: !0 });
var $Oc = ["Shift", "Meta", "Alt", "Control"], wOc = 1e3, kOc = "keydown", SOc = typeof navigator == "object" && /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "Meta" : "Control";
function LM(e, t) {
  return typeof e.getModifierState == "function" ? e.getModifierState(t) : !1;
}
function xOc(e) {
  return e.trim().split(" ").map(function(t) {
    var n = t.split(/\b\+/), o = n.pop();
    return n = n.map(function(r) {
      return r === "$mod" ? SOc : r;
    }), [n, o];
  });
}
function EOc(e, t) {
  return /^[^A-Za-z0-9]$/.test(e.key) && t[1] === e.key ? !0 : !// Allow either the `event.key` or the `event.code`
  // MDN event.key: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
  // MDN event.code: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code
  (t[1].toUpperCase() !== e.key.toUpperCase() && t[1] !== e.code || // Ensure all the modifiers in the keybinding are pressed.
  t[0].find(function(n) {
    return !LM(e, n);
  }) || // KEYBINDING_MODIFIER_KEYS (Shift/Control/etc) change the meaning of a
  // keybinding. So if they are pressed but aren't part of the current
  // keybinding press, then we don't have a match.
  $Oc.find(function(n) {
    return !t[0].includes(n) && t[1] !== n && LM(e, n);
  }));
}
function TOc(e, t, n) {
  var o, r;
  n === void 0 && (n = {});
  var i = (o = n.timeout) !== null && o !== void 0 ? o : wOc, a = (r = n.event) !== null && r !== void 0 ? r : kOc, s = Object.keys(t).map(function(u) {
    return [xOc(u), t[u]];
  }), c = /* @__PURE__ */ new Map(), l = null, d = function(u) {
    u instanceof KeyboardEvent && (s.forEach(function(_) {
      var p = _[0], f = _[1], g = c.get(p), h = g || p, b = h[0], v = EOc(u, b);
      v ? h.length > 1 ? c.set(p, h.slice(1)) : (c.delete(p), f(u)) : LM(u, u.key) || c.delete(p);
    }), l && clearTimeout(l), l = setTimeout(c.clear.bind(c), i));
  };
  return e.addEventListener(a, d), function() {
    e.removeEventListener(a, d);
  };
}
Oj.default = TOc;
var BY;
function AOc() {
  if (BY)
    return Wy;
  BY = 1;
  var e = Je && Je.__createBinding || (Object.create ? function(h, b, v, $) {
    $ === void 0 && ($ = v), Object.defineProperty(h, $, { enumerable: !0, get: function() {
      return b[v];
    } });
  } : function(h, b, v, $) {
    $ === void 0 && ($ = v), h[$] = b[v];
  }), t = Je && Je.__setModuleDefault || (Object.create ? function(h, b) {
    Object.defineProperty(h, "default", { enumerable: !0, value: b });
  } : function(h, b) {
    h.default = b;
  }), n = Je && Je.__importStar || function(h) {
    if (h && h.__esModule)
      return h;
    var b = {};
    if (h != null)
      for (var v in h)
        v !== "default" && Object.prototype.hasOwnProperty.call(h, v) && e(b, h, v);
    return t(b, h), b;
  }, o = Je && Je.__importDefault || function(h) {
    return h && h.__esModule ? h : { default: h };
  };
  Object.defineProperty(Wy, "__esModule", { value: !0 }), Wy.InternalEvents = void 0;
  var r = n(ve), i = o(Oj), a = pg, s = lm(), c = Wo;
  function l() {
    return d(), u(), f(), g(), null;
  }
  Wy.InternalEvents = l;
  function d() {
    var h, b, v = (0, s.useKBar)(function(M) {
      return {
        visualState: M.visualState,
        showing: M.visualState !== a.VisualState.hidden
      };
    }), $ = v.query, k = v.options, S = v.visualState, O = v.showing;
    r.useEffect(function() {
      var M, N = k.toggleShortcut || "$mod+k", C = (0, i.default)(window, (M = {}, M[N] = function(P) {
        var x, w, E, T;
        P.defaultPrevented || (P.preventDefault(), $.toggle(), O ? (w = (x = k.callbacks) === null || x === void 0 ? void 0 : x.onClose) === null || w === void 0 || w.call(x) : (T = (E = k.callbacks) === null || E === void 0 ? void 0 : E.onOpen) === null || T === void 0 || T.call(E));
      }, M.Escape = function(P) {
        var x, w;
        O && (P.stopPropagation(), (w = (x = k.callbacks) === null || x === void 0 ? void 0 : x.onClose) === null || w === void 0 || w.call(x)), $.setVisualState(function(E) {
          return E === a.VisualState.hidden || E === a.VisualState.animatingOut ? E : a.VisualState.animatingOut;
        });
      }, M));
      return function() {
        C();
      };
    }, [k.callbacks, k.toggleShortcut, $, O]);
    var I = r.useRef(), D = r.useCallback(function(M) {
      var N, C, P = 0;
      M === a.VisualState.animatingIn && (P = ((N = k.animations) === null || N === void 0 ? void 0 : N.enterMs) || 0), M === a.VisualState.animatingOut && (P = ((C = k.animations) === null || C === void 0 ? void 0 : C.exitMs) || 0), clearTimeout(I.current), I.current = setTimeout(function() {
        var x = !1;
        $.setVisualState(function() {
          var w = M === a.VisualState.animatingIn ? a.VisualState.showing : a.VisualState.hidden;
          return w === a.VisualState.hidden && (x = !0), w;
        }), x && $.setCurrentRootAction(null);
      }, P);
    }, [(h = k.animations) === null || h === void 0 ? void 0 : h.enterMs, (b = k.animations) === null || b === void 0 ? void 0 : b.exitMs, $]);
    r.useEffect(function() {
      switch (S) {
        case a.VisualState.animatingIn:
        case a.VisualState.animatingOut:
          D(S);
          break;
      }
    }, [D, S]);
  }
  function u() {
    var h = (0, s.useKBar)(function($) {
      return {
        visualState: $.visualState
      };
    }), b = h.visualState, v = h.options;
    r.useEffect(function() {
      if (!v.disableDocumentLock)
        if (b === a.VisualState.animatingIn) {
          if (document.body.style.overflow = "hidden", !v.disableScrollbarManagement) {
            var $ = (0, c.getScrollbarWidth)(), k = getComputedStyle(document.body)["margin-right"];
            k && ($ += Number(k.replace(/\D/g, ""))), document.body.style.marginRight = $ + "px";
          }
        } else
          b === a.VisualState.hidden && (document.body.style.removeProperty("overflow"), v.disableScrollbarManagement || document.body.style.removeProperty("margin-right"));
    }, [
      v.disableDocumentLock,
      v.disableScrollbarManagement,
      b
    ]);
  }
  var _ = /* @__PURE__ */ new WeakSet();
  function p(h) {
    return function(b) {
      _.has(b) || (h(b), _.add(b));
    };
  }
  function f() {
    var h = (0, s.useKBar)(function(k) {
      return {
        actions: k.actions
      };
    }), b = h.actions, v = h.query, $ = h.options;
    r.useEffect(function() {
      for (var k, S = Object.keys(b).map(function(E) {
        return b[E];
      }), O = [], I = 0, D = S; I < D.length; I++) {
        var M = D[I];
        !((k = M.shortcut) === null || k === void 0) && k.length && O.push(M);
      }
      O = O.sort(function(E, T) {
        return T.shortcut.join(" ").length - E.shortcut.join(" ").length;
      });
      for (var N = {}, C = function(E) {
        var T = E.shortcut.join(" ");
        N[T] = p(function(z) {
          var j, q, V, F, L, U;
          (0, c.shouldRejectKeystrokes)() || (z.preventDefault(), !((j = E.children) === null || j === void 0) && j.length ? (v.setCurrentRootAction(E.id), v.toggle(), (V = (q = $.callbacks) === null || q === void 0 ? void 0 : q.onOpen) === null || V === void 0 || V.call(q)) : ((F = E.command) === null || F === void 0 || F.perform(), (U = (L = $.callbacks) === null || L === void 0 ? void 0 : L.onSelectAction) === null || U === void 0 || U.call(L, E)));
        });
      }, P = 0, x = O; P < x.length; P++) {
        var M = x[P];
        C(M);
      }
      var w = (0, i.default)(window, N, {
        timeout: 400
      });
      return function() {
        w();
      };
    }, [b, $.callbacks, v]);
  }
  function g() {
    var h = (0, s.useKBar)(function(v) {
      return {
        isShowing: v.visualState === a.VisualState.showing || v.visualState === a.VisualState.animatingIn
      };
    }).isShowing, b = r.useRef(null);
    r.useEffect(function() {
      if (h) {
        b.current = document.activeElement;
        return;
      }
      var v = document.activeElement;
      (v == null ? void 0 : v.tagName.toLowerCase()) === "input" && v.blur();
      var $ = b.current;
      $ && $.focus();
    }, [h]);
  }
  return Wy;
}
var UY;
function Pme() {
  return UY || (UY = 1, function(e) {
    var t = Je && Je.__createBinding || (Object.create ? function(c, l, d, u) {
      u === void 0 && (u = d), Object.defineProperty(c, u, { enumerable: !0, get: function() {
        return l[d];
      } });
    } : function(c, l, d, u) {
      u === void 0 && (u = d), c[u] = l[d];
    }), n = Je && Je.__setModuleDefault || (Object.create ? function(c, l) {
      Object.defineProperty(c, "default", { enumerable: !0, value: l });
    } : function(c, l) {
      c.default = l;
    }), o = Je && Je.__importStar || function(c) {
      if (c && c.__esModule)
        return c;
      var l = {};
      if (c != null)
        for (var d in c)
          d !== "default" && Object.prototype.hasOwnProperty.call(c, d) && t(l, c, d);
      return n(l, c), l;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.KBarProvider = e.KBarContext = void 0;
    var r = qA, i = o(ve), a = AOc();
    e.KBarContext = i.createContext({});
    var s = function(c) {
      var l = (0, r.useStore)(c);
      return i.createElement(
        e.KBarContext.Provider,
        { value: l },
        i.createElement(a.InternalEvents, null),
        c.children
      );
    };
    e.KBarProvider = s;
  }(w6)), w6;
}
var WY;
function lm() {
  if (WY)
    return By;
  WY = 1;
  var e = Je && Je.__assign || function() {
    return e = Object.assign || function(s) {
      for (var c, l = 1, d = arguments.length; l < d; l++) {
        c = arguments[l];
        for (var u in c)
          Object.prototype.hasOwnProperty.call(c, u) && (s[u] = c[u]);
      }
      return s;
    }, e.apply(this, arguments);
  }, t = Je && Je.__createBinding || (Object.create ? function(s, c, l, d) {
    d === void 0 && (d = l), Object.defineProperty(s, d, { enumerable: !0, get: function() {
      return c[l];
    } });
  } : function(s, c, l, d) {
    d === void 0 && (d = l), s[d] = c[l];
  }), n = Je && Je.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), o = Je && Je.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(By, "__esModule", { value: !0 }), By.useKBar = void 0;
  var r = o(ve), i = Pme();
  function a(s) {
    var c = r.useContext(i.KBarContext), l = c.query, d = c.getState, u = c.subscribe, _ = c.options, p = r.useRef(s == null ? void 0 : s(d())), f = r.useRef(s), g = r.useCallback(function($) {
      return e(e({}, $), { query: l, options: _ });
    }, [l, _]), h = r.useState(g(p.current)), b = h[0], v = h[1];
    return r.useEffect(function() {
      var $;
      return f.current && ($ = u(function(k) {
        return f.current(k);
      }, function(k) {
        return v(g(k));
      })), function() {
        $ && $();
      };
    }, [g, u]), b;
  }
  return By.useKBar = a, By;
}
var GY = 1, COc = 0.9, zOc = 0.3, k6 = 0.1, OOc = 0, S6 = 0.999, POc = 0.9999, IOc = 0.99, HY = /[\\\/\-_+.# \t"@\[\(\{&]/, ROc = /[\\\/\-_+.# \t"@\[\(\{&]/g;
function qM(e, t, n, o, r, i) {
  if (i === t.length)
    return r === e.length ? GY : IOc;
  for (var a = o.charAt(i), s = n.indexOf(a, r), c = 0, l, d, u; s >= 0; )
    l = qM(e, t, n, o, s + 1, i + 1), l > c && (s === r ? l *= GY : HY.test(e.charAt(s - 1)) ? (l *= COc, u = e.slice(r, s - 1).match(ROc), u && r > 0 && (l *= Math.pow(S6, u.length))) : HY.test(e.slice(r, s - 1)) ? (l *= OOc, r > 0 && (l *= Math.pow(S6, s - r))) : (l *= zOc, r > 0 && (l *= Math.pow(S6, s - r))), e.charAt(s) !== t.charAt(i) && (l *= POc)), l < k6 && n.charAt(s - 1) === o.charAt(i + 1) && n.charAt(s - 1) !== o.charAt(i) && (d = qM(e, t, n, o, s + 1, i + 2), d * k6 > l && (l = d * k6)), l > c && (c = l), s = n.indexOf(a, s + 1);
  return c;
}
function NOc(e, t) {
  return qM(e, t, e.toLowerCase(), t.toLowerCase(), 0, 0);
}
var DOc = NOc;
(function(e) {
  var t = Je && Je.__createBinding || (Object.create ? function(_, p, f, g) {
    g === void 0 && (g = f), Object.defineProperty(_, g, { enumerable: !0, get: function() {
      return p[f];
    } });
  } : function(_, p, f, g) {
    g === void 0 && (g = f), _[g] = p[f];
  }), n = Je && Je.__setModuleDefault || (Object.create ? function(_, p) {
    Object.defineProperty(_, "default", { enumerable: !0, value: p });
  } : function(_, p) {
    _.default = p;
  }), o = Je && Je.__importStar || function(_) {
    if (_ && _.__esModule)
      return _;
    var p = {};
    if (_ != null)
      for (var f in _)
        f !== "default" && Object.prototype.hasOwnProperty.call(_, f) && t(p, _, f);
    return n(p, _), p;
  }, r = Je && Je.__importDefault || function(_) {
    return _ && _.__esModule ? _ : { default: _ };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.useDeepMatches = e.useMatches = e.NO_GROUP = void 0;
  var i = o(ve), a = lm(), s = Wo, c = r(DOc);
  e.NO_GROUP = {
    name: "none",
    priority: s.Priority.NORMAL
  };
  function l(_, p) {
    return p.priority - _.priority;
  }
  function d() {
    var _ = (0, a.useKBar)(function(I) {
      return {
        search: I.searchQuery,
        actions: I.actions,
        rootActionId: I.currentRootActionId
      };
    }), p = _.search, f = _.actions, g = _.rootActionId, h = i.useMemo(function() {
      return Object.keys(f).reduce(function(I, D) {
        var M = f[D];
        if (!M.parent && !g && I.push(M), M.id === g)
          for (var N = 0; N < M.children.length; N++)
            I.push(M.children[N]);
        return I;
      }, []).sort(l);
    }, [f, g]), b = i.useCallback(function(I) {
      for (var D = [], M = 0; M < I.length; M++)
        D.push(I[M]);
      return function N(C, P) {
        P === void 0 && (P = D);
        for (var x = 0; x < C.length; x++)
          if (C[x].children.length > 0) {
            for (var w = C[x].children, E = 0; E < w.length; E++)
              P.push(w[E]);
            N(C[x].children, P);
          }
        return P;
      }(I);
    }, []), v = !p, $ = i.useMemo(function() {
      return v ? h : b(h);
    }, [b, h, v]), k = u($, p), S = i.useMemo(function() {
      for (var I, D, M = {}, N = [], C = [], P = 0; P < k.length; P++) {
        var x = k[P], w = x.action, E = x.score || s.Priority.NORMAL, T = {
          name: typeof w.section == "string" ? w.section : ((I = w.section) === null || I === void 0 ? void 0 : I.name) || e.NO_GROUP.name,
          priority: typeof w.section == "string" ? E : ((D = w.section) === null || D === void 0 ? void 0 : D.priority) || 0 + E
        };
        M[T.name] || (M[T.name] = [], N.push(T)), M[T.name].push({
          priority: w.priority + E,
          action: w
        });
      }
      C = N.sort(l).map(function(V) {
        return {
          name: V.name,
          actions: M[V.name].sort(l).map(function(F) {
            return F.action;
          })
        };
      });
      for (var z = [], P = 0; P < C.length; P++) {
        var j = C[P];
        j.name !== e.NO_GROUP.name && z.push(j.name);
        for (var q = 0; q < j.actions.length; q++)
          z.push(j.actions[q]);
      }
      return z;
    }, [k]), O = i.useMemo(function() {
      return g;
    }, [S]);
    return i.useMemo(function() {
      return {
        results: S,
        rootActionId: O
      };
    }, [O, S]);
  }
  e.useMatches = d;
  function u(_, p) {
    var f = i.useMemo(function() {
      return {
        filtered: _,
        search: p
      };
    }, [_, p]), g = (0, s.useThrottledValue)(f), h = g.filtered, b = g.search;
    return i.useMemo(function() {
      if (b.trim() === "")
        return h.map(function(O) {
          return { score: 0, action: O };
        });
      for (var v = [], $ = 0; $ < h.length; $++) {
        var k = h[$], S = (0, c.default)([k.name, k.keywords, k.subtitle].join(" "), b);
        S > 0 && v.push({ score: S, action: k });
      }
      return v;
    }, [h, b]);
  }
  e.useDeepMatches = d;
})(Ame);
var FA = {};
function MOc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var LOc = /* @__PURE__ */ MOc() ? ts : Le;
function qOc() {
  var e = ze(/* @__PURE__ */ Object.create(null)), t = e[1];
  return at(function() {
    t(/* @__PURE__ */ Object.create(null));
  }, []);
}
var KY = function(t) {
  var n = t.children, o = t.type, r = o === void 0 ? "reach-portal" : o, i = t.containerRef, a = Ue(null), s = Ue(null), c = qOc();
  return LOc(function() {
    if (a.current) {
      var l = a.current.ownerDocument, d = (i == null ? void 0 : i.current) || l.body;
      return s.current = l == null ? void 0 : l.createElement(r), d.appendChild(s.current), c(), function() {
        s.current && d && d.removeChild(s.current);
      };
    }
  }, [r, c, i]), s.current ? /* @__PURE__ */ Wv(n, s.current) : /* @__PURE__ */ Pe("span", {
    ref: a
  });
};
const jOc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Portal: KY,
  default: KY
}, Symbol.toStringTag, { value: "Module" })), FOc = /* @__PURE__ */ Oa(jOc);
var VOc = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), BOc = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), UOc = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && VOc(t, e, n);
  return BOc(t, e), t;
}, WOc = Je && Je.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(FA, "__esModule", { value: !0 });
FA.KBarPortal = void 0;
var GOc = WOc(FOc), HOc = UOc(ve), KOc = pg, YOc = lm();
function ZOc(e) {
  var t = (0, YOc.useKBar)(function(n) {
    return {
      showing: n.visualState !== KOc.VisualState.hidden
    };
  }).showing;
  return t ? HOc.createElement(GOc.default, null, e.children) : null;
}
FA.KBarPortal = ZOc;
var VA = {}, Vw = Je && Je.__assign || function() {
  return Vw = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Vw.apply(this, arguments);
}, QOc = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), JOc = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), XOc = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && QOc(t, e, n);
  return JOc(t, e), t;
}, e4c = Je && Je.__rest || function(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
};
Object.defineProperty(VA, "__esModule", { value: !0 });
VA.KBarPositioner = void 0;
var YY = XOc(ve), ZY = {
  position: "fixed",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  inset: "0px",
  padding: "14vh 16px 16px"
};
function t4c(e) {
  return e ? Vw(Vw({}, ZY), e) : ZY;
}
VA.KBarPositioner = YY.forwardRef(function(e, t) {
  var n = e.style, o = e.children, r = e4c(e, ["style", "children"]);
  return YY.createElement("div", Vw({ ref: t, style: t4c(n) }, r), o);
});
var Pj = {};
(function(e) {
  var t = Je && Je.__assign || function() {
    return t = Object.assign || function(u) {
      for (var _, p = 1, f = arguments.length; p < f; p++) {
        _ = arguments[p];
        for (var g in _)
          Object.prototype.hasOwnProperty.call(_, g) && (u[g] = _[g]);
      }
      return u;
    }, t.apply(this, arguments);
  }, n = Je && Je.__createBinding || (Object.create ? function(u, _, p, f) {
    f === void 0 && (f = p), Object.defineProperty(u, f, { enumerable: !0, get: function() {
      return _[p];
    } });
  } : function(u, _, p, f) {
    f === void 0 && (f = p), u[f] = _[p];
  }), o = Je && Je.__setModuleDefault || (Object.create ? function(u, _) {
    Object.defineProperty(u, "default", { enumerable: !0, value: _ });
  } : function(u, _) {
    u.default = _;
  }), r = Je && Je.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var _ = {};
    if (u != null)
      for (var p in u)
        p !== "default" && Object.prototype.hasOwnProperty.call(u, p) && n(_, u, p);
    return o(_, u), _;
  }, i = Je && Je.__rest || function(u, _) {
    var p = {};
    for (var f in u)
      Object.prototype.hasOwnProperty.call(u, f) && _.indexOf(f) < 0 && (p[f] = u[f]);
    if (u != null && typeof Object.getOwnPropertySymbols == "function")
      for (var g = 0, f = Object.getOwnPropertySymbols(u); g < f.length; g++)
        _.indexOf(f[g]) < 0 && Object.prototype.propertyIsEnumerable.call(u, f[g]) && (p[f[g]] = u[f[g]]);
    return p;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.KBarSearch = e.getListboxItemId = e.KBAR_LISTBOX = void 0;
  var a = r(ve), s = pg, c = lm();
  e.KBAR_LISTBOX = "kbar-listbox";
  var l = function(u) {
    return "kbar-listbox-item-" + u;
  };
  e.getListboxItemId = l;
  function d(u) {
    var _ = (0, c.useKBar)(function(D) {
      return {
        search: D.searchQuery,
        currentRootActionId: D.currentRootActionId,
        actions: D.actions,
        activeIndex: D.activeIndex,
        showing: D.visualState === s.VisualState.showing
      };
    }), p = _.query, f = _.search, g = _.actions, h = _.currentRootActionId, b = _.activeIndex, v = _.showing, $ = _.options, k = a.useRef(null), S = u.defaultPlaceholder, O = i(u, ["defaultPlaceholder"]);
    a.useEffect(function() {
      return p.setSearch(""), k.current.focus(), function() {
        return p.setSearch("");
      };
    }, [h, p]);
    var I = a.useMemo(function() {
      var D = S ?? "Type a command or search…";
      return h && g[h] ? g[h].name : D;
    }, [g, h, S]);
    return a.createElement("input", t({}, O, { ref: k, autoFocus: !0, autoComplete: "off", role: "combobox", spellCheck: "false", "aria-expanded": v, "aria-controls": e.KBAR_LISTBOX, "aria-activedescendant": (0, e.getListboxItemId)(b), value: f, placeholder: I, onChange: function(D) {
      var M, N, C;
      (M = u.onChange) === null || M === void 0 || M.call(u, D), p.setSearch(D.target.value), (C = (N = $ == null ? void 0 : $.callbacks) === null || N === void 0 ? void 0 : N.onQueryChange) === null || C === void 0 || C.call(N, D.target.value);
    }, onKeyDown: function(D) {
      var M;
      if ((M = u.onKeyDown) === null || M === void 0 || M.call(u, D), h && !f && D.key === "Backspace") {
        var N = g[h].parent;
        p.setCurrentRootAction(N);
      }
    } }));
  }
  e.KBarSearch = d;
})(Pj);
var BA = {};
function Xm() {
  return Xm = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Xm.apply(this, arguments);
}
function n4c(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
var o4c = ["bottom", "height", "left", "right", "top", "width"], r4c = function(t, n) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), o4c.some(function(o) {
    return t[o] !== n[o];
  });
}, pp = /* @__PURE__ */ new Map(), Ime, i4c = function e() {
  var t = [];
  pp.forEach(function(n, o) {
    var r = o.getBoundingClientRect();
    r4c(r, n.rect) && (n.rect = r, t.push(n));
  }), t.forEach(function(n) {
    n.callbacks.forEach(function(o) {
      return o(n.rect);
    });
  }), Ime = window.requestAnimationFrame(e);
};
function a4c(e, t) {
  return {
    observe: function() {
      var o = pp.size === 0;
      pp.has(e) ? pp.get(e).callbacks.push(t) : pp.set(e, {
        rect: void 0,
        hasRectChanged: !1,
        callbacks: [t]
      }), o && i4c();
    },
    unobserve: function() {
      var o = pp.get(e);
      if (o) {
        var r = o.callbacks.indexOf(t);
        r >= 0 && o.callbacks.splice(r, 1), o.callbacks.length || pp.delete(e), pp.size || cancelAnimationFrame(Ime);
      }
    }
  };
}
var EE = typeof window < "u" ? ve.useLayoutEffect : ve.useEffect;
function s4c(e, t) {
  t === void 0 && (t = {
    width: 0,
    height: 0
  });
  var n = ve.useState(e.current), o = n[0], r = n[1], i = ve.useReducer(c4c, t), a = i[0], s = i[1], c = ve.useRef(!1);
  return EE(function() {
    e.current !== o && r(e.current);
  }), EE(function() {
    if (o && !c.current) {
      c.current = !0;
      var l = o.getBoundingClientRect();
      s({
        rect: l
      });
    }
  }, [o]), ve.useEffect(function() {
    if (o) {
      var l = a4c(o, function(d) {
        s({
          rect: d
        });
      });
      return l.observe(), function() {
        l.unobserve();
      };
    }
  }, [o]), a;
}
function c4c(e, t) {
  var n = t.rect;
  return e.height !== n.height || e.width !== n.width ? n : e;
}
var l4c = function() {
  return 50;
}, d4c = function(t) {
  return t;
}, u4c = function(t, n) {
  var o = n ? "offsetWidth" : "offsetHeight";
  return t[o];
}, Rme = function(t) {
  for (var n = Math.max(t.start - t.overscan, 0), o = Math.min(t.end + t.overscan, t.size - 1), r = [], i = n; i <= o; i++)
    r.push(i);
  return r;
};
function _4c(e) {
  var t, n = e.size, o = n === void 0 ? 0 : n, r = e.estimateSize, i = r === void 0 ? l4c : r, a = e.overscan, s = a === void 0 ? 1 : a, c = e.paddingStart, l = c === void 0 ? 0 : c, d = e.paddingEnd, u = d === void 0 ? 0 : d, _ = e.parentRef, p = e.horizontal, f = e.scrollToFn, g = e.useObserver, h = e.initialRect, b = e.onScrollElement, v = e.scrollOffsetFn, $ = e.keyExtractor, k = $ === void 0 ? d4c : $, S = e.measureSize, O = S === void 0 ? u4c : S, I = e.rangeExtractor, D = I === void 0 ? Rme : I, M = p ? "width" : "height", N = p ? "scrollLeft" : "scrollTop", C = ve.useRef({
    scrollOffset: 0,
    measurements: []
  }), P = ve.useState(0), x = P[0], w = P[1];
  C.current.scrollOffset = x;
  var E = g || s4c, T = E(_, h), z = T[M];
  C.current.outerSize = z;
  var j = ve.useCallback(function(me) {
    _.current && (_.current[N] = me);
  }, [_, N]), q = f || j;
  f = ve.useCallback(function(me) {
    q(me, j);
  }, [j, q]);
  var V = ve.useState({}), F = V[0], L = V[1], U = ve.useCallback(function() {
    return L({});
  }, []), W = ve.useRef([]), H = ve.useMemo(function() {
    var me = W.current.length > 0 ? Math.min.apply(Math, W.current) : 0;
    W.current = [];
    for (var pe = C.current.measurements.slice(0, me), be = me; be < o; be++) {
      var Se = k(be), Ae = F[Se], Ze = pe[be - 1] ? pe[be - 1].end : l, Ge = typeof Ae == "number" ? Ae : i(be), rt = Ze + Ge;
      pe[be] = {
        index: be,
        start: Ze,
        size: Ge,
        end: rt,
        key: Se
      };
    }
    return pe;
  }, [i, F, l, o, k]), Q = (((t = H[o - 1]) == null ? void 0 : t.end) || l) + u;
  C.current.measurements = H, C.current.totalSize = Q;
  var X = b ? b.current : _.current, re = ve.useRef(v);
  re.current = v, EE(function() {
    if (!X) {
      w(0);
      return;
    }
    var me = function(be) {
      var Se = re.current ? re.current(be) : X[N];
      w(Se);
    };
    return me(), X.addEventListener("scroll", me, {
      capture: !1,
      passive: !0
    }), function() {
      X.removeEventListener("scroll", me);
    };
  }, [X, N]);
  var Z = m4c(C.current), ee = Z.start, J = Z.end, oe = ve.useMemo(function() {
    return D({
      start: ee,
      end: J,
      overscan: s,
      size: H.length
    });
  }, [ee, J, s, H.length, D]), ce = ve.useRef(O);
  ce.current = O;
  var de = ve.useMemo(function() {
    for (var me = [], pe = function(Ze, Ge) {
      var rt = oe[Ze], qe = H[rt], Xe = Xm(Xm({}, qe), {}, {
        measureRef: function(Et) {
          if (Et) {
            var wt = ce.current(Et, p);
            if (wt !== Xe.size) {
              var nn = C.current.scrollOffset;
              Xe.start < nn && j(nn + (wt - Xe.size)), W.current.push(rt), L(function(Dt) {
                var mt;
                return Xm(Xm({}, Dt), {}, (mt = {}, mt[Xe.key] = wt, mt));
              });
            }
          }
        }
      });
      me.push(Xe);
    }, be = 0, Se = oe.length; be < Se; be++)
      pe(be);
    return me;
  }, [oe, j, p, H]), te = ve.useRef(!1);
  EE(function() {
    te.current && L({}), te.current = !0;
  }, [i]);
  var ue = ve.useCallback(function(me, pe) {
    var be = pe === void 0 ? {} : pe, Se = be.align, Ae = Se === void 0 ? "start" : Se, Ze = C.current, Ge = Ze.scrollOffset, rt = Ze.outerSize;
    Ae === "auto" && (me <= Ge ? Ae = "start" : me >= Ge + rt ? Ae = "end" : Ae = "start"), Ae === "start" ? f(me) : Ae === "end" ? f(me - rt) : Ae === "center" && f(me - rt / 2);
  }, [f]), le = ve.useCallback(function(me, pe) {
    var be = pe === void 0 ? {} : pe, Se = be.align, Ae = Se === void 0 ? "auto" : Se, Ze = n4c(be, ["align"]), Ge = C.current, rt = Ge.measurements, qe = Ge.scrollOffset, Xe = Ge.outerSize, lt = rt[Math.max(0, Math.min(me, o - 1))];
    if (lt) {
      if (Ae === "auto")
        if (lt.end >= qe + Xe)
          Ae = "end";
        else if (lt.start <= qe)
          Ae = "start";
        else
          return;
      var Et = Ae === "center" ? lt.start + lt.size / 2 : Ae === "end" ? lt.end : lt.start;
      ue(Et, Xm({
        align: Ae
      }, Ze));
    }
  }, [ue, o]), se = ve.useCallback(function() {
    for (var me = arguments.length, pe = new Array(me), be = 0; be < me; be++)
      pe[be] = arguments[be];
    le.apply(void 0, pe), requestAnimationFrame(function() {
      le.apply(void 0, pe);
    });
  }, [le]);
  return {
    virtualItems: de,
    totalSize: Q,
    scrollToOffset: ue,
    scrollToIndex: se,
    measure: U
  };
}
var p4c = function(t, n, o, r) {
  for (; t <= n; ) {
    var i = (t + n) / 2 | 0, a = o(i);
    if (a < r)
      t = i + 1;
    else if (a > r)
      n = i - 1;
    else
      return i;
  }
  return t > 0 ? t - 1 : 0;
};
function m4c(e) {
  for (var t = e.measurements, n = e.outerSize, o = e.scrollOffset, r = t.length - 1, i = function(l) {
    return t[l].start;
  }, a = p4c(0, r, i, o), s = a; s < r && t[s].end < o + n; )
    s++;
  return {
    start: a,
    end: s
  };
}
const f4c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultRangeExtractor: Rme,
  useVirtual: _4c
}, Symbol.toStringTag, { value: "Module" })), g4c = /* @__PURE__ */ Oa(f4c);
var jM = Je && Je.__assign || function() {
  return jM = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, jM.apply(this, arguments);
}, h4c = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), v4c = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), b4c = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && h4c(t, e, n);
  return v4c(t, e), t;
};
Object.defineProperty(BA, "__esModule", { value: !0 });
BA.KBarResults = void 0;
var jl = b4c(ve), y4c = g4c, QY = Pj, $4c = lm(), w4c = Wo, G2 = 0, k4c = function(e) {
  var t = jl.useRef(null), n = jl.useRef(null), o = jl.useRef(e.items);
  o.current = e.items;
  var r = (0, y4c.useVirtual)({
    size: o.current.length,
    parentRef: n
  }), i = (0, $4c.useKBar)(function(f) {
    return {
      search: f.searchQuery,
      currentRootActionId: f.currentRootActionId,
      activeIndex: f.activeIndex
    };
  }), a = i.query, s = i.search, c = i.currentRootActionId, l = i.activeIndex, d = i.options;
  jl.useEffect(function() {
    var f = function(g) {
      var h;
      g.key === "ArrowUp" || g.ctrlKey && g.key === "p" ? (g.preventDefault(), a.setActiveIndex(function(b) {
        var v = b > G2 ? b - 1 : b;
        if (typeof o.current[v] == "string") {
          if (v === 0)
            return b;
          v -= 1;
        }
        return v;
      })) : g.key === "ArrowDown" || g.ctrlKey && g.key === "n" ? (g.preventDefault(), a.setActiveIndex(function(b) {
        var v = b < o.current.length - 1 ? b + 1 : b;
        if (typeof o.current[v] == "string") {
          if (v === o.current.length - 1)
            return b;
          v += 1;
        }
        return v;
      })) : g.key === "Enter" && (g.preventDefault(), (h = t.current) === null || h === void 0 || h.click());
    };
    return window.addEventListener("keydown", f), function() {
      return window.removeEventListener("keydown", f);
    };
  }, [a]);
  var u = r.scrollToIndex;
  jl.useEffect(function() {
    u(l, {
      // ensure that if the first item in the list is a group
      // name and we are focused on the second item, to not
      // scroll past that group, hiding it.
      align: l <= 1 ? "end" : "auto"
    });
  }, [l, u]), jl.useEffect(function() {
    a.setActiveIndex(
      // avoid setting active index on a group
      typeof e.items[G2] == "string" ? G2 + 1 : G2
    );
  }, [s, c, e.items, a]);
  var _ = jl.useCallback(function(f) {
    var g, h;
    typeof f != "string" && (f.command ? (f.command.perform(f), a.toggle()) : (a.setSearch(""), a.setCurrentRootAction(f.id)), (h = (g = d.callbacks) === null || g === void 0 ? void 0 : g.onSelectAction) === null || h === void 0 || h.call(g, f));
  }, [a, d]), p = (0, w4c.usePointerMovedSinceMount)();
  return jl.createElement(
    "div",
    { ref: n, style: {
      maxHeight: e.maxHeight || 400,
      position: "relative",
      overflow: "auto"
    } },
    jl.createElement("div", { role: "listbox", id: QY.KBAR_LISTBOX, style: {
      height: r.totalSize + "px",
      width: "100%"
    } }, r.virtualItems.map(function(f) {
      var g = o.current[f.index], h = typeof g != "string" && {
        onPointerMove: function() {
          return p && l !== f.index && a.setActiveIndex(f.index);
        },
        onPointerDown: function() {
          return a.setActiveIndex(f.index);
        },
        onClick: function() {
          return _(g);
        }
      }, b = f.index === l;
      return jl.createElement("div", jM({ ref: b ? t : null, id: (0, QY.getListboxItemId)(f.index), role: "option", "aria-selected": b, key: f.index, style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        transform: "translateY(" + f.start + "px)"
      } }, h), jl.cloneElement(e.onRender({
        item: g,
        active: b
      }), {
        ref: f.measureRef
      }));
    }))
  );
};
BA.KBarResults = k4c;
var UA = {}, S4c = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), x4c = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), E4c = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && S4c(t, e, n);
  return x4c(t, e), t;
};
Object.defineProperty(UA, "__esModule", { value: !0 });
UA.useRegisterActions = void 0;
var JY = E4c(ve), T4c = lm();
function A4c(e, t) {
  t === void 0 && (t = []);
  var n = (0, T4c.useKBar)().query, o = JY.useMemo(function() {
    return e;
  }, t);
  JY.useEffect(function() {
    if (o.length) {
      var r = n.registerActions(o);
      return function() {
        r();
      };
    }
  }, [n, o]);
}
UA.useRegisterActions = A4c;
var WA = {}, q$ = Je && Je.__assign || function() {
  return q$ = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, q$.apply(this, arguments);
}, C4c = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n), Object.defineProperty(e, o, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), z4c = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), O4c = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && C4c(t, e, n);
  return z4c(t, e), t;
};
Object.defineProperty(WA, "__esModule", { value: !0 });
WA.KBarAnimator = void 0;
var Uu = O4c(ve), oh = pg, P4c = lm(), I4c = Wo, XY = [
  {
    opacity: 0,
    transform: "scale(.99)"
  },
  { opacity: 1, transform: "scale(1.01)" },
  { opacity: 1, transform: "scale(1)" }
], R4c = [
  {
    transform: "scale(1)"
  },
  {
    transform: "scale(.98)"
  },
  {
    transform: "scale(1)"
  }
], N4c = function(e) {
  var t, n, o = e.children, r = e.style, i = e.className, a = (0, P4c.useKBar)(function(b) {
    return {
      visualState: b.visualState,
      currentRootActionId: b.currentRootActionId
    };
  }), s = a.visualState, c = a.currentRootActionId, l = a.query, d = a.options, u = Uu.useRef(null), _ = Uu.useRef(null), p = ((t = d == null ? void 0 : d.animations) === null || t === void 0 ? void 0 : t.enterMs) || 0, f = ((n = d == null ? void 0 : d.animations) === null || n === void 0 ? void 0 : n.exitMs) || 0;
  Uu.useEffect(function() {
    if (s !== oh.VisualState.showing) {
      var b = s === oh.VisualState.animatingIn ? p : f, v = u.current;
      v == null || v.animate(XY, {
        duration: b,
        easing: (
          // TODO: expose easing in options
          s === oh.VisualState.animatingOut ? "ease-in" : "ease-out"
        ),
        direction: s === oh.VisualState.animatingOut ? "reverse" : "normal",
        fill: "forwards"
      });
    }
  }, [d, s, p, f]);
  var g = Uu.useRef();
  Uu.useEffect(function() {
    if (s === oh.VisualState.showing) {
      var b = u.current, v = _.current;
      if (!b || !v)
        return;
      var $ = new ResizeObserver(function(k) {
        for (var S = 0, O = k; S < O.length; S++) {
          var I = O[S], D = I.contentRect;
          g.current || (g.current = D.height), b.animate([
            {
              height: g.current + "px"
            },
            {
              height: D.height + "px"
            }
          ], {
            duration: p / 2,
            // TODO: expose configs here
            easing: "ease-out",
            fill: "forwards"
          }), g.current = D.height;
        }
      });
      return $.observe(v), function() {
        $.unobserve(v);
      };
    }
  }, [s, d, p, f]);
  var h = Uu.useRef(!0);
  return Uu.useEffect(function() {
    if (h.current) {
      h.current = !1;
      return;
    }
    var b = u.current;
    b && b.animate(R4c, {
      duration: p,
      easing: "ease-out"
    });
  }, [c, p]), (0, I4c.useOuterClick)(u, function() {
    var b, v;
    l.setVisualState(oh.VisualState.animatingOut), (v = (b = d.callbacks) === null || b === void 0 ? void 0 : b.onClose) === null || v === void 0 || v.call(b);
  }), Uu.createElement(
    "div",
    { ref: u, style: q$(q$(q$({}, XY[0]), r), { pointerEvents: "auto" }), className: i },
    Uu.createElement("div", { ref: _ }, o)
  );
};
WA.KBarAnimator = N4c;
var Nme = {};
(function(e) {
  var t = Je && Je.__createBinding || (Object.create ? function(o, r, i, a) {
    a === void 0 && (a = i), Object.defineProperty(o, a, { enumerable: !0, get: function() {
      return r[i];
    } });
  } : function(o, r, i, a) {
    a === void 0 && (a = i), o[a] = r[i];
  }), n = Je && Je.__exportStar || function(o, r) {
    for (var i in o)
      i !== "default" && !Object.prototype.hasOwnProperty.call(r, i) && t(r, o, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(nk, e), n(ok, e);
})(Nme);
(function(e) {
  var t = Je && Je.__createBinding || (Object.create ? function(r, i, a, s) {
    s === void 0 && (s = a), Object.defineProperty(r, s, { enumerable: !0, get: function() {
      return i[a];
    } });
  } : function(r, i, a, s) {
    s === void 0 && (s = a), r[s] = i[a];
  }), n = Je && Je.__exportStar || function(r, i) {
    for (var a in r)
      a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, r, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Priority = e.createAction = void 0;
  var o = Wo;
  Object.defineProperty(e, "createAction", { enumerable: !0, get: function() {
    return o.createAction;
  } }), Object.defineProperty(e, "Priority", { enumerable: !0, get: function() {
    return o.Priority;
  } }), n(Ame, e), n(FA, e), n(VA, e), n(Pj, e), n(BA, e), n(lm(), e), n(UA, e), n(Pme(), e), n(WA, e), n(pg, e), n(Nme, e);
})(Jd);
const D4c = "Alby", M4c = "alby", L4c = "alby_payment", q4c = "icon.svg", j4c = "https://getalby.com", F4c = "payment", V4c = [
  "payment"
], B4c = "Alby", U4c = "support@getalby.com", W4c = "Your Bitcoin & Nostr companion for the web. Use Alby to charge Satoshi for your [Cal.com](https://cal.com) meetings.\r", G4c = "EventType", H4c = !1, K4c = !0, Y4c = "event-type-app-card", Z4c = "alby", Q4c = !1, J4c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: D4c,
  slug: M4c,
  type: L4c,
  logo: q4c,
  url: j4c,
  variant: F4c,
  categories: V4c,
  publisher: B4c,
  email: U4c,
  description: W4c,
  extendsFeature: G4c,
  isTemplate: H4c,
  __createdUsingCli: K4c,
  __template: Y4c,
  dirName: Z4c,
  isOAuth: Q4c
}, X4c = "Amie", e3c = "amie", t3c = "amie_other", n3c = "icon.svg", o3c = "https://cal.com", r3c = "other", i3c = [
  "calendar"
], a3c = "Cal.com, Inc.", s3c = "support@cal.com", c3c = "The joyful productivity app\r\r", l3c = !0, d3c = [
  "google-calendar"
], u3c = "amie", _3c = !1, p3c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: X4c,
  slug: e3c,
  type: t3c,
  logo: n3c,
  url: o3c,
  variant: r3c,
  categories: i3c,
  publisher: a3c,
  email: s3c,
  description: c3c,
  __createdUsingCli: l3c,
  dependencies: d3c,
  dirName: u3c,
  isOAuth: _3c
}, m3c = "https://json.schemastore.org/package.json", f3c = "@calcom/applecalendar", g3c = "0.0.0", h3c = "./index.ts", v3c = "Apple calendar runs both the macOS and iOS mobile operating systems. Offering online cloud backup of calendars using Apple’s iCloud service, it can sync with Google Calendar and Microsoft Exchange Server. Users can schedule events in their day that include time, location, duration, and extra notes.", b3c = {
  "@calcom/prisma": "workspace:*",
  "react-hook-form": "^7.43.3"
}, y3c = {
  "@calcom/types": "workspace:*"
}, $3c = {
  $schema: m3c,
  private: !0,
  name: f3c,
  version: g3c,
  main: h3c,
  description: v3c,
  dependencies: b3c,
  devDependencies: y3c
}, w3c = {
  name: "Apple Calendar",
  description: $3c.description,
  installed: !0,
  type: "apple_calendar",
  title: "Apple Calendar",
  variant: "calendar",
  categories: ["calendar"],
  category: "calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "apple-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "applecalendar",
  isOAuth: !1
}, k3c = "Attio", S3c = "attio", x3c = "attio_crm", E3c = "icon-dark.svg", T3c = "/apps/installed/crm", A3c = "crm", C3c = [
  "crm"
], z3c = "Cal.com, Inc.", O3c = "support@cal.com", P3c = "Attio is the AI-native CRM that builds, scales and grows your company to the next level.", I3c = !1, R3c = !0, N3c = "link-as-an-app", D3c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: k3c,
  slug: S3c,
  type: x3c,
  logo: E3c,
  url: T3c,
  variant: A3c,
  categories: C3c,
  publisher: z3c,
  email: O3c,
  description: P3c,
  isTemplate: I3c,
  __createdUsingCli: R3c,
  __template: N3c
}, M3c = "Autocheckin", L3c = "autocheckin", q3c = "autocheckin_automation", j3c = "icon.svg", F3c = "https://autocheckin.app", V3c = "automation", B3c = [
  "automation"
], U3c = "Patrick Goeler von Ravensburg", W3c = "patrickvongoeler@gmail.com", G3c = "You simply paste a [Cal.com](https://cal.com) link of someone, select a frequency and we will take care of the scheduling for you.\r\r", H3c = !1, K3c = !0, Y3c = "link-as-an-app", Z3c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: M3c,
  slug: L3c,
  type: q3c,
  logo: j3c,
  url: F3c,
  variant: V3c,
  categories: B3c,
  publisher: U3c,
  email: W3c,
  description: G3c,
  isTemplate: H3c,
  __createdUsingCli: K3c,
  __template: Y3c
}, Q3c = "BAA for HIPAA", J3c = "baa-for-hipaa", X3c = "baa-for-hipaa_other", e6c = "icon.svg", t6c = "https://cal.com/BAA", n6c = "other", o6c = [
  "other"
], r6c = "Cal.com, Inc.", i6c = "support@cal.com", a6c = "Request a signed Business Associate Agreement for your HIPAA compliance records", s6c = !1, c6c = !0, l6c = "link-as-an-app", d6c = {
  priceInUsd: 300,
  mode: "subscription"
}, u6c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Q3c,
  slug: J3c,
  type: X3c,
  logo: e6c,
  url: t6c,
  variant: n6c,
  categories: o6c,
  publisher: r6c,
  email: i6c,
  description: a6c,
  isTemplate: s6c,
  __createdUsingCli: c6c,
  __template: l6c,
  paid: d6c
}, _6c = "Basecamp3", p6c = "basecamp3", m6c = "basecamp3_other_calendar", f6c = "icon-dark.svg", g6c = "https://basecamp.com/", h6c = "other", v6c = [
  "other"
], b6c = "Jonathan D'mello", y6c = "support@cal.com", $6c = "Basecamp puts everything you need to get work done in one place. It’s the calm, organized way to manage projects, work with clients, and communicate company-wide.", w6c = "EventType", k6c = !1, S6c = !0, x6c = "event-type-app-card", E6c = "basecamp3", T6c = !0, A6c = {
  name: _6c,
  slug: p6c,
  type: m6c,
  logo: f6c,
  url: g6c,
  variant: h6c,
  categories: v6c,
  publisher: b6c,
  email: y6c,
  description: $6c,
  extendsFeature: w6c,
  isTemplate: k6c,
  __createdUsingCli: S6c,
  __template: x6c,
  dirName: E6c,
  isOAuth: T6c
}, C6c = "Bolna", z6c = "bolna", O6c = "bolna_automation", P6c = "icon-primary.svg", I6c = "https://playground.bolna.dev/auth/calcom", R6c = "automation", N6c = [
  "automation"
], D6c = "Bolna", M6c = "founders@bolna.dev", L6c = "24x7 AI receptionists to answer all inbound calls", q6c = !1, j6c = !0, F6c = "link-as-an-app", V6c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: C6c,
  slug: z6c,
  type: O6c,
  logo: P6c,
  url: I6c,
  variant: R6c,
  categories: N6c,
  publisher: D6c,
  email: M6c,
  description: L6c,
  isTemplate: q6c,
  __createdUsingCli: j6c,
  __template: F6c
}, B6c = "BTCPayServer", U6c = "btcpayserver", W6c = "btcpayserver_payment", G6c = "icon.svg", H6c = "https://btcpayserver.org", K6c = "payment", Y6c = [
  "payment"
], Z6c = "BTCPay Server Team", Q6c = "chat.btcpayserver.org", J6c = "BTCPay Server is a self-hosted open source Bitcoin payment processor. Start receiving bitcoin payments for your events and bookings.", X6c = "EventType", e5c = !1, t5c = !0, n5c = "event-type-app-card", o5c = {
  name: B6c,
  slug: U6c,
  type: W6c,
  logo: G6c,
  url: H6c,
  variant: K6c,
  categories: Y6c,
  publisher: Z6c,
  email: Q6c,
  description: J6c,
  extendsFeature: X6c,
  isTemplate: e5c,
  __createdUsingCli: t5c,
  __template: n5c
}, r5c = "https://json.schemastore.org/package.json", i5c = "@calcom/caldavcalendar", a5c = "0.0.0", s5c = "./index.ts", c5c = "Caldav is a protocol that allows different clients/servers to access scheduling information on remote servers as well as schedule meetings with other users on the same server or other servers. It extends WebDAV specification and uses iCalendar format for the data.", l5c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "react-hook-form": "^7.43.3"
}, d5c = {
  "@calcom/types": "workspace:*"
}, u5c = {
  $schema: r5c,
  private: !0,
  name: i5c,
  version: a5c,
  main: s5c,
  description: c5c,
  dependencies: l5c,
  devDependencies: d5c
}, _5c = {
  name: "CalDav (Beta)",
  description: u5c.description,
  installed: !0,
  type: "caldav_calendar",
  title: "CalDav (Beta)",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "caldav-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "caldavcalendar",
  isOAuth: !1
}, p5c = "Campfire", m5c = "campfire", f5c = "campfire_video", g5c = "icon.svg", h5c = "https://cal.com/", v5c = "conferencing", b5c = [
  "conferencing"
], y5c = "Cal.com, Inc.", $5c = "help@cal.com", w5c = "Feel connected with your remote team. Team events, new hire onboardings, coffee chats, all on Campfire. No more awkward Zoom calls.\r\r", k5c = !0, S5c = {
  location: {
    type: "integrations:campfire_video",
    label: "Campfire",
    linkType: "static",
    organizerInputPlaceholder: "https://party.campfire.to/your-team",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?party.campfire.to\\/[a-zA-Z0-9]*"
  }
}, x5c = !1, Dme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: p5c,
  slug: m5c,
  type: f5c,
  logo: g5c,
  url: h5c,
  variant: v5c,
  categories: b5c,
  publisher: y5c,
  email: $5c,
  description: w5c,
  __createdUsingCli: k5c,
  appData: S5c,
  isOAuth: x5c
}, E5c = "Chatbase", T5c = "chatbase", A5c = "chatbase_other", C5c = "icon-dark.svg", z5c = "https://www.chatbase.co/guide/cal", O5c = "other", P5c = [
  "other"
], I5c = "Chatbase", R5c = "sandra@chatbase.co", N5c = "Add [Cal.com](https://cal.com/) to your Chatbase AI Chatbot and accept bookings right inside chat.", D5c = !1, M5c = !0, L5c = "link-as-an-app", q5c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: E5c,
  slug: T5c,
  type: A5c,
  logo: C5c,
  url: z5c,
  variant: O5c,
  categories: P5c,
  publisher: I5c,
  email: R5c,
  description: N5c,
  isTemplate: D5c,
  __createdUsingCli: M5c,
  __template: L5c
}, j5c = "Clic", F5c = "clic", V5c = "check_in_automation", B5c = "icon.svg", U5c = "https://clicis.vercel.app", W5c = "automation", G5c = [
  "automation"
], H5c = "Chris Pacheco", K5c = "chrispacheco430@gmail.com", Y5c = "Create, List and Interact with Your Cal.com links and connections easily.\r\r", Z5c = !1, Q5c = !0, J5c = "link-as-an-app", X5c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: j5c,
  slug: F5c,
  type: V5c,
  logo: B5c,
  url: U5c,
  variant: W5c,
  categories: G5c,
  publisher: H5c,
  email: K5c,
  description: Y5c,
  isTemplate: Z5c,
  __createdUsingCli: Q5c,
  __template: J5c
}, ePc = "Close.com", tPc = "Close.com", nPc = "closecom", oPc = "closecom_crm", rPc = "icon.svg", iPc = "https://cal.com/", aPc = "crm", sPc = [
  "crm"
], cPc = "Cal.com, Inc.", lPc = "EventType", dPc = "help@cal.com", uPc = "Close is the inside sales CRM of choice for startups and SMBs. Make more calls, send more emails and close more deals starting today.", _Pc = !0, pPc = !0, mPc = "closecom", fPc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ePc,
  title: tPc,
  slug: nPc,
  type: oPc,
  logo: rPc,
  url: iPc,
  variant: aPc,
  categories: sPc,
  publisher: cPc,
  extendsFeature: lPc,
  email: dPc,
  description: uPc,
  __createdUsingCli: _Pc,
  isOAuth: pPc,
  dirName: mPc
}, gPc = "Notion Calendar", hPc = "cron", vPc = "cron_calendar", bPc = "logo.png", yPc = "https://github.com/miguelnietoa", $Pc = "calendar", wPc = [
  "calendar"
], kPc = "Miguel Nieto", SPc = "support@cal.com", xPc = "All of your commitments, now in one place.", EPc = !1, TPc = !0, APc = "link-as-an-app", CPc = [
  "google-calendar"
], zPc = !1, OPc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: gPc,
  slug: hPc,
  type: vPc,
  logo: bPc,
  url: yPc,
  variant: $Pc,
  categories: wPc,
  publisher: kPc,
  email: SPc,
  description: xPc,
  isTemplate: EPc,
  __createdUsingCli: TPc,
  __template: APc,
  dependencies: CPc,
  isOAuth: zPc
}, PPc = "@calcom/dailyvideo", IPc = "0.0.0", RPc = "./index.ts", NPc = "Cal Video is the in-house web-based video conferencing platform powered by Daily.co, which is minimalistic and lightweight, but has most of the features you need.", DPc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, MPc = {
  "@calcom/types": "workspace:*"
}, LPc = {
  private: !0,
  name: PPc,
  version: IPc,
  main: RPc,
  description: NPc,
  dependencies: DPc,
  devDependencies: MPc
};
var eZ = {};
const Mme = {
  name: "Cal Video",
  description: LPc.description,
  installed: !!eZ.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Cal.com",
  category: "conferencing",
  slug: "daily-video",
  title: "Cal Video",
  isGlobal: !0,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Cal Video"
    }
  },
  key: { apikey: eZ.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: !1
}, qPc = "Deel", jPc = "deel", FPc = "deel_other", VPc = "icon.svg", BPc = "https://go.cal.com/deel", UPc = "other", WPc = [
  "other"
], GPc = "Deel.com", HPc = "support@deel.com", KPc = "Integrate Deel with your Calendar and get automatic updates on key employee dates like PTO, start days, public holidays, and birthdays. No manual entry. No errors. Just a calendar that's always in sync with your team.", YPc = !1, ZPc = !0, QPc = "link-as-an-app", JPc = "deel", XPc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: qPc,
  slug: jPc,
  type: FPc,
  logo: VPc,
  url: BPc,
  variant: UPc,
  categories: WPc,
  publisher: GPc,
  email: HPc,
  description: KPc,
  isTemplate: YPc,
  __createdUsingCli: ZPc,
  __template: QPc,
  dirName: JPc
}, eIc = "Demodesk", tIc = "demodesk", nIc = "demodesk_conferencing", oIc = "icon.svg", rIc = "https://demodesk.com", iIc = "conferencing", aIc = [
  "conferencing"
], sIc = "Cal.com, Inc.", cIc = "support@cal.com", lIc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://demodesk.com/meet/mylink",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?demodesk.com\\/[a-zA-Z0-9]*"
  }
}, dIc = "Run Professional Video Meetings, Coach Sales Teams in Real-Time with AI, And Schedule Meetings on Auto-Pilot. 100% GDPR Compliant, Enterprise Ready.", uIc = !1, _Ic = !0, pIc = "event-type-location-video-static", Lme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: eIc,
  slug: tIc,
  type: nIc,
  logo: oIc,
  url: rIc,
  variant: iIc,
  categories: aIc,
  publisher: sIc,
  email: cIc,
  appData: lIc,
  description: dIc,
  isTemplate: uIc,
  __createdUsingCli: _Ic,
  __template: pIc
}, mIc = "dialpad", fIc = "dialpad", gIc = "dialpad_conferencing", hIc = "icon.svg", vIc = "https://meetings.dialpad.com/", bIc = "conferencing", yIc = [
  "conferencing"
], $Ic = "Cal.com", wIc = "help@cal.com", kIc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://meetings.dialpad.com/adb2002",
    urlRegExp: "^https:\\/\\/meetings\\.dialpad\\.com\\/[a-zA-Z0-9]+$"
  }
}, SIc = "A new way to meet, with built-in Ai", xIc = !1, EIc = !0, TIc = "event-type-location-video-static", qme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: mIc,
  slug: fIc,
  type: gIc,
  logo: hIc,
  url: vIc,
  variant: bIc,
  categories: yIc,
  publisher: $Ic,
  email: wIc,
  appData: kIc,
  description: SIc,
  isTemplate: xIc,
  __createdUsingCli: EIc,
  __template: TIc
}, AIc = "Discord", CIc = "discord", zIc = "discord_video", OIc = "icon.svg", PIc = "https://discord.com/", IIc = "conferencing", RIc = [
  "conferencing"
], NIc = "Cal.com, Inc.", DIc = "support@cal.com", MIc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://discord.gg/420gg69",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?discord\\.(gg|com)\\/[a-zA-Z0-9]+"
  }
}, LIc = "Copy your server invite link and start scheduling calls in Discord! Discord is a VoIP and instant messaging social platform. Users have the ability to communicate with voice calls, video calls, text messaging, media and files in private chats or as part of communities.", qIc = !1, jIc = !0, FIc = "event-type-location-video-static", VIc = !1, jme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: AIc,
  slug: CIc,
  type: zIc,
  logo: OIc,
  url: PIc,
  variant: IIc,
  categories: RIc,
  publisher: NIc,
  email: DIc,
  appData: MIc,
  description: LIc,
  isTemplate: qIc,
  __createdUsingCli: jIc,
  __template: FIc,
  isOAuth: VIc
}, BIc = "Dub", UIc = "dub", WIc = "dub_analytics", GIc = "icon-dark.svg", HIc = "https://dub.co", KIc = "analytics", YIc = [
  "analytics"
], ZIc = "Cal.com", QIc = "help@cal.com", JIc = "Dub is the modern link attribution platform for you to create short links, track conversion analytics, and run affiliate programs.", XIc = !1, eRc = !0, tRc = "basic", nRc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: BIc,
  slug: UIc,
  type: WIc,
  logo: GIc,
  url: HIc,
  variant: KIc,
  categories: YIc,
  publisher: ZIc,
  email: QIc,
  description: JIc,
  isTemplate: XIc,
  __createdUsingCli: eRc,
  __template: tRc
}, oRc = "8x8", rRc = "eightxeight", iRc = "eightxeight_video", aRc = "icon.svg", sRc = "https://github.com/shivamklr", cRc = "conferencing", lRc = [
  "conferencing"
], dRc = "Shivam Kalra", uRc = "shivamkalra98@gmail.com", _Rc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://8x8.vc/company",
    urlRegExp: "^(http|https)://(www\\.)?8x8.vc/[a-zA-Z0-9]*"
  }
}, pRc = "The best video conferencing solution for businesses of any size. Fully secure, reliable, packed with features and ridiculously simple to use.\r\r", mRc = !1, fRc = !0, gRc = "event-type-location-video-static", hRc = "eightxeight", vRc = !1, Fme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: oRc,
  slug: rRc,
  type: iRc,
  logo: aRc,
  url: sRc,
  variant: cRc,
  categories: lRc,
  publisher: dRc,
  email: uRc,
  appData: _Rc,
  description: pRc,
  isTemplate: mRc,
  __createdUsingCli: fRc,
  __template: gRc,
  dirName: hRc,
  isOAuth: vRc
}, bRc = "Element Call", yRc = "element-call", $Rc = "element-call_conferencing", wRc = "icon.svg", kRc = "https://github.com/suyash5053/", SRc = "conferencing", xRc = [
  "conferencing"
], ERc = "Suyash Srivastava", TRc = "suyashsrivastava5053@gmail.com", ARc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://call.element.io/",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?call.element.io/[a-zA-Z0-9]*"
  }
}, CRc = 'Element is an open-source communication platform that provides messaging, voice calling, and video conferencing capabilities. It is based on the Matrix protocol, which is a decentralized and federated messaging protocol designed to enable secure and interoperable communication across different platforms and services."', zRc = !1, ORc = !0, PRc = "event-type-location-video-static", IRc = "element-call", RRc = !1, Vme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: bRc,
  slug: yRc,
  type: $Rc,
  logo: wRc,
  url: kRc,
  variant: SRc,
  categories: xRc,
  publisher: ERc,
  email: TRc,
  appData: ARc,
  description: CRc,
  isTemplate: zRc,
  __createdUsingCli: ORc,
  __template: PRc,
  dirName: IRc,
  isOAuth: RRc
}, NRc = "ElevenLabs", DRc = "elevenlabs", MRc = "elevenlabs_automation", LRc = "icon-dark.svg", qRc = "https://elevenlabs.io/docs/conversational-ai/guides/integrations/cal-com", jRc = "automation", FRc = [
  "automation"
], VRc = "ElevenLabs", BRc = "support@elevenlabs.io", URc = "Create the most realistic speech with our AI audio platform", WRc = !1, GRc = !0, HRc = "link-as-an-app", KRc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: NRc,
  slug: DRc,
  type: MRc,
  logo: LRc,
  url: qRc,
  variant: jRc,
  categories: FRc,
  publisher: VRc,
  email: BRc,
  description: URc,
  isTemplate: WRc,
  __createdUsingCli: GRc,
  __template: HRc
}, YRc = "@calcom/exchange2013calendar", ZRc = "0.0.0", QRc = "./index.ts", JRc = "For calendars hosted on on-premises Microsoft Exchange 2013 servers", XRc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "ews-javascript-api": "^0.11.0",
  "react-hook-form": "^7.43.3"
}, eNc = {
  "@calcom/types": "workspace:*"
}, tNc = {
  private: !0,
  name: YRc,
  version: ZRc,
  main: QRc,
  description: JRc,
  dependencies: XRc,
  devDependencies: eNc
}, nNc = {
  name: "Microsoft Exchange 2013 Calendar",
  description: tNc.description,
  installed: !0,
  type: "exchange2013_calendar",
  title: "Microsoft Exchange 2013 Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  label: "Exchange Calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "exchange2013-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "exchange2013calendar",
  isOAuth: !1
}, oNc = "@calcom/exchange2016calendar", rNc = "0.0.0", iNc = "./index.ts", aNc = "For calendars hosted on on-premises Microsoft Exchange 2016 servers", sNc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/ui": "workspace:*",
  "ews-javascript-api": "^0.11.0",
  "react-hook-form": "^7.43.3"
}, cNc = {
  "@calcom/types": "workspace:*"
}, lNc = {
  private: !0,
  name: oNc,
  version: rNc,
  main: iNc,
  description: aNc,
  dependencies: sNc,
  devDependencies: cNc
}, dNc = {
  name: "Microsoft Exchange 2016 Calendar",
  description: lNc.description,
  installed: !0,
  type: "exchange2016_calendar",
  title: "Microsoft Exchange 2016 Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  label: "Exchange Calendar",
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "exchange2016-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "exchange2016calendar",
  isOAuth: !1
}, uNc = "Microsoft Exchange", _Nc = "Microsoft Exchange", pNc = "exchange", mNc = "exchangecalendar", fNc = "exchange_calendar", gNc = "icon.svg", hNc = "https://cal.com", vNc = "calendar", bNc = [
  "calendar"
], yNc = "Cal.com", $Nc = "help@cal.com", wNc = "Fetch Microsoft Exchange calendars and availabilities using Exchange Web Services (EWS).", kNc = !0, SNc = !1, xNc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  title: uNc,
  name: _Nc,
  slug: pNc,
  dirName: mNc,
  type: fNc,
  logo: gNc,
  url: hNc,
  variant: vNc,
  categories: bNc,
  publisher: yNc,
  email: $Nc,
  description: wNc,
  __createdUsingCli: kNc,
  isOAuth: SNc
}, ENc = "Facetime", TNc = "Facetime", ANc = "facetime", CNc = "facetime_video", zNc = "icon.svg", ONc = "https://github.com/Mythie", PNc = "conferencing", INc = [
  "conferencing"
], RNc = "Lucas Smith", NNc = "help@cal.com", DNc = "Facetime makes it super simple for collaborating teams to jump on a video call.", MNc = !0, LNc = {
  location: {
    linkType: "static",
    type: "integrations:facetime_video",
    label: "Facetime",
    organizerInputPlaceholder: "https://facetime.apple.com/join... link copied from the FaceTime app",
    urlRegExp: "^https?:\\/\\/facetime\\.apple\\.com\\/join.+$"
  }
}, qNc = !1, jNc = !1, Bme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ENc,
  title: TNc,
  slug: ANc,
  type: CNc,
  logo: zNc,
  url: ONc,
  variant: PNc,
  categories: INc,
  publisher: RNc,
  email: NNc,
  description: DNc,
  __createdUsingCli: MNc,
  appData: LNc,
  isTemplate: qNc,
  isOAuth: jNc
}, FNc = "Fathom", VNc = "fathom", BNc = "fathom_analytics", UNc = "icon.svg", WNc = "https://cal.com", GNc = "analytics", HNc = [
  "analytics"
], KNc = "Cal.com, Inc.", YNc = "help@cal.com", ZNc = "EventType", QNc = {
  tag: {
    scripts: [
      {
        src: "https://cdn.usefathom.com/script.js",
        attrs: {
          "data-site": "{TRACKING_ID}"
        }
      }
    ]
  }
}, JNc = "Fathom Analytics provides simple, privacy-focused website analytics. We're a GDPR-compliant, Google Analytics alternative.", XNc = !0, eDc = !1, Ume = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: FNc,
  slug: VNc,
  type: BNc,
  logo: UNc,
  url: WNc,
  variant: GNc,
  categories: HNc,
  publisher: KNc,
  email: YNc,
  extendsFeature: ZNc,
  appData: QNc,
  description: JNc,
  __createdUsingCli: XNc,
  isOAuth: eDc
}, tDc = "https://json.schemastore.org/package.json", nDc = "@calcom/feishucalendar", oDc = "0.0.0", rDc = "./index.ts", iDc = "Feishu Calendar is a time management and scheduling service developed by Feishu. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Feishu account on both mobile and web versions.", aDc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, sDc = {
  "@calcom/types": "workspace:*"
}, cDc = {
  $schema: tDc,
  private: !0,
  name: nDc,
  version: oDc,
  main: rDc,
  description: iDc,
  dependencies: aDc,
  devDependencies: sDc
}, lDc = {
  name: "Feishu Calendar",
  description: cDc.description,
  installed: !0,
  type: "feishu_calendar",
  title: "Feishu Calendar",
  variant: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Feishu",
  slug: "feishu-calendar",
  url: "https://feishu.cn/",
  email: "alan@larksuite.com",
  dirName: "feishucalendar"
}, dDc = "fonio.ai", uDc = "fonio-ai", _Dc = "fonio-ai_automation", pDc = "icon.png", mDc = "https://docs.fonio.ai/Tools/Terminbuchung", fDc = "automation", gDc = [
  "automation"
], hDc = "fonio GmbH", vDc = "info@fonio.ai", bDc = "Der KI-Telefonassistent auf Deutsch\r", yDc = !1, $Dc = !0, wDc = "link-as-an-app", kDc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: dDc,
  slug: uDc,
  type: _Dc,
  logo: pDc,
  url: mDc,
  variant: fDc,
  categories: gDc,
  publisher: hDc,
  email: vDc,
  description: bDc,
  isTemplate: yDc,
  __createdUsingCli: $Dc,
  __template: wDc
}, SDc = "Framer", xDc = "framer", EDc = "framer_other", TDc = "icon-dark.svg", ADc = "https://www.framer.com/updates/cal-com", CDc = "other", zDc = [
  "other"
], ODc = "Framer B.V.", PDc = "benjamin@framer.com", IDc = "Add Cal.com to Framer, the design tool for websites. Design freely, publish fast, and scale with CMS, SEO, analytics, and more.", RDc = !1, NDc = !0, DDc = "link-as-an-app", MDc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: SDc,
  slug: xDc,
  type: EDc,
  logo: TDc,
  url: ADc,
  variant: CDc,
  categories: zDc,
  publisher: ODc,
  email: PDc,
  description: IDc,
  isTemplate: RDc,
  __createdUsingCli: NDc,
  __template: DDc
}, LDc = "Google Analytics", qDc = "ga4", jDc = "ga4_analytics", FDc = "icon.svg", VDc = "https://marketingplatform.google.com", BDc = "analytics", UDc = [
  "analytics"
], WDc = "Cal.com, Inc.", GDc = "support@cal.com", HDc = "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic, currently as a platform inside the Google Marketing Platform brand.", KDc = "EventType", YDc = {
  tag: {
    scripts: [
      {
        src: "https://www.googletagmanager.com/gtag/js?id={TRACKING_ID}",
        attrs: {}
      },
      {
        content: `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '{TRACKING_ID}', {'cookie_flags': 'SameSite=None;Secure'});`
      }
    ]
  }
}, ZDc = !0, QDc = !1, Wme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: LDc,
  slug: qDc,
  type: jDc,
  logo: FDc,
  url: VDc,
  variant: BDc,
  categories: UDc,
  publisher: WDc,
  email: GDc,
  description: HDc,
  extendsFeature: KDc,
  appData: YDc,
  __createdUsingCli: ZDc,
  isOAuth: QDc
}, JDc = "https://json.schemastore.org/package.json", XDc = "@calcom/giphy", eMc = "0.0.0", tMc = "./index.ts", nMc = "GIPHY is your top source for the best & newest GIFs & Animated Stickers online. Find everything from funny GIFs, reaction GIFs, unique GIFs and more.", oMc = {
  "@calcom/prisma": "workspace:*"
}, rMc = {
  "@calcom/types": "workspace:*"
}, iMc = {
  $schema: JDc,
  private: !0,
  name: XDc,
  version: eMc,
  main: tMc,
  description: nMc,
  dependencies: oMc,
  devDependencies: rMc
}, aMc = {
  name: "Giphy",
  description: iMc.description,
  installed: !0,
  categories: ["other"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "giphy",
  title: "Giphy",
  type: "giphy_other",
  url: "https://cal.com/apps/giphy",
  variant: "other",
  extendsFeature: "EventType",
  email: "help@cal.com",
  dirName: "giphy",
  isOAuth: !1
}, Gme = (e) => {
  try {
    const t = JSON.parse(e);
    if (t && typeof t == "object")
      return t;
  } catch (t) {
    console.log("Invalid JSON:", t);
  }
  return !1;
}, sMc = "https://json.schemastore.org/package.json", cMc = "@calcom/googlecalendar", lMc = "0.0.0", dMc = "./index.ts", uMc = "Google Calendar is a time management and scheduling service developed by Google. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Gmail account on both mobile and web versions.", _Mc = {
  "@calcom/prisma": "workspace:*",
  "@googleapis/calendar": "^9.7.9"
}, pMc = {
  "@calcom/types": "workspace:*"
}, mMc = {
  $schema: sMc,
  private: !0,
  name: cMc,
  version: lMc,
  main: dMc,
  description: uMc,
  dependencies: _Mc,
  devDependencies: pMc
};
var tZ = {};
const fMc = {
  name: "Google Calendar",
  description: mMc.description,
  installed: !!(tZ.GOOGLE_API_CREDENTIALS && Gme(tZ.GOOGLE_API_CREDENTIALS)),
  type: "google_calendar",
  title: "Google Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "google-calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  dirName: "googlecalendar",
  isOAuth: !0,
  delegationCredential: {
    // This is unused at the moment but should be used in future
    // For now, we have hardcoded imports in the codebase that are supported with Google Workspace(i.e. Google Calendar and Google Meet)
    workspacePlatformSlug: "google"
  }
}, gMc = "https://json.schemastore.org/package.json", hMc = "@calcom/googlevideo", vMc = "0.0.0", bMc = "./index.ts", yMc = "Google Meet is Google's web-based video conferencing platform, designed to compete with major conferencing platforms.", $Mc = {
  "@calcom/prisma": "workspace:*"
}, wMc = {
  "@calcom/types": "workspace:*"
}, kMc = {
  $schema: gMc,
  private: !0,
  name: hMc,
  version: vMc,
  main: bMc,
  description: yMc,
  dependencies: $Mc,
  devDependencies: wMc
};
var nZ = {};
const Hme = {
  name: "Google Meet",
  description: kMc.description,
  installed: !!(nZ.GOOGLE_API_CREDENTIALS && Gme(nZ.GOOGLE_API_CREDENTIALS)),
  slug: "google-meet",
  category: "conferencing",
  categories: ["conferencing"],
  type: "google_video",
  title: "Google Meet",
  variant: "conferencing",
  logo: "logo.webp",
  publisher: "Cal.com",
  url: "https://cal.com/",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:google:meet",
      label: "Google Meet"
    }
  },
  dirName: "googlevideo",
  dependencies: ["google-calendar"],
  isOAuth: !1
}, SMc = "Granola", xMc = "granola", EMc = "granola_other", TMc = "icon.svg", AMc = "https://go.cal.com/granola", CMc = "other", zMc = [
  "other"
], OMc = "Granola inc", PMc = "hey@granola.so", IMc = "The AI notepad for people in back-to-back meetings for MacOS", RMc = !1, NMc = !0, DMc = "link-as-an-app", MMc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: SMc,
  slug: xMc,
  type: EMc,
  logo: TMc,
  url: AMc,
  variant: CMc,
  categories: zMc,
  publisher: OMc,
  email: PMc,
  description: IMc,
  isTemplate: RMc,
  __createdUsingCli: NMc,
  __template: DMc
}, LMc = "Greetmate.ai", qMc = "greetmate-ai", jMc = "greetmate-ai_automation", FMc = "icon-dark.svg", VMc = "https://www.greetmate.ai", BMc = "automation", UMc = [
  "automation"
], WMc = "Greetmate Inc.", GMc = "support@greetmate.ai", HMc = "Connect [Cal.com](https://cal.com/) to [Greetmate.ai](https://www.greetmate.ai/) and enable appointment scheduling for your AI agents.", KMc = !1, YMc = !0, ZMc = "link-as-an-app", QMc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: LMc,
  slug: qMc,
  type: jMc,
  logo: FMc,
  url: VMc,
  variant: BMc,
  categories: UMc,
  publisher: WMc,
  email: GMc,
  description: HMc,
  isTemplate: KMc,
  __createdUsingCli: YMc,
  __template: ZMc
}, JMc = "Google Tag Manager", XMc = "gtm", eLc = "gtm_analytics", tLc = "icon.svg", nLc = "https://tagmanager.google.com", oLc = "analytics", rLc = [
  "analytics"
], iLc = "Black Lemon", aLc = "support@blacklemon.dk", sLc = "App to install Google Tag Manager", cLc = "EventType", lLc = {
  tag: {
    scripts: [
      {
        content: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','{TRACKING_ID}');"
      }
    ],
    pushEventScript: {
      content: "function $pushEvent(event) {window.dataLayer.push({ event: event.name, ...event.data })}"
    }
  }
}, dLc = !1, uLc = !0, _Lc = "booking-pages-tag", pLc = !1, Kme = {
  name: JMc,
  slug: XMc,
  type: eLc,
  logo: tLc,
  url: nLc,
  variant: oLc,
  categories: rLc,
  publisher: iLc,
  email: aLc,
  description: sLc,
  extendsFeature: cLc,
  appData: lLc,
  isTemplate: dLc,
  __createdUsingCli: uLc,
  __template: _Lc,
  isOAuth: pLc
}, mLc = "HitPay", fLc = "hitpay", gLc = "hitpay_payment", hLc = "icon.svg", vLc = "https://hitpayapp.com", bLc = "payment", yLc = [
  "payment"
], $Lc = "HitPay", wLc = "support@hit-pay.com", kLc = "HitPay's Cal.com payment integration combines powerful scheduling with seamless local payment acceptance. Our online scheduling software integration is built for customers in APAC, supporting their favorite e-wallets and banking apps.", SLc = "EventType", xLc = !1, ELc = !0, TLc = "event-type-app-card", ALc = "hitpay", CLc = !0, zLc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: mLc,
  slug: fLc,
  type: gLc,
  logo: hLc,
  url: vLc,
  variant: bLc,
  categories: yLc,
  publisher: $Lc,
  email: wLc,
  description: kLc,
  extendsFeature: SLc,
  isTemplate: xLc,
  __createdUsingCli: ELc,
  __template: TLc,
  dirName: ALc,
  isOAuth: CLc
}, OLc = "Horizon Workrooms", PLc = "horizon-workrooms", ILc = "horizon-workrooms_conferencing", RLc = "icon.svg", NLc = "https://forwork.meta.com/de/en/horizon-workrooms/", DLc = "conferencing", MLc = [
  "conferencing"
], LLc = "Cal.com, Inc", qLc = "support@cal.com", jLc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://workrooms.workplace.com/groupcall/LINK:uALeBBTZbdBowT",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?workrooms.workplace.com\\/[a-zA-Z0-9]*"
  }
}, FLc = "Workrooms is an immersive virtual space, where you and your team can work better together, from anywhere", VLc = !1, BLc = !0, ULc = "event-type-location-video-static", Yme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: OLc,
  slug: PLc,
  type: ILc,
  logo: RLc,
  url: NLc,
  variant: DLc,
  categories: MLc,
  publisher: LLc,
  email: qLc,
  appData: jLc,
  description: FLc,
  isTemplate: VLc,
  __createdUsingCli: BLc,
  __template: ULc
}, WLc = "@calcom/hubspot", GLc = "0.0.0", HLc = "./index.ts", KLc = "HubSpot is a cloud-based CRM designed to help align sales and marketing teams, foster sales enablement, boost ROI and optimize your inbound marketing strategy to generate more, qualified leads.", YLc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@hubspot/api-client": "^6.0.1"
}, ZLc = {
  "@calcom/types": "workspace:*"
}, QLc = {
  private: !0,
  name: WLc,
  version: GLc,
  main: HLc,
  description: KLc,
  dependencies: YLc,
  devDependencies: ZLc
};
var JLc = {};
const XLc = {
  name: "HubSpot CRM",
  installed: !!JLc.HUBSPOT_CLIENT_ID,
  description: QLc.description,
  type: "hubspot_crm",
  variant: "crm",
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://hubspot.com/",
  categories: ["crm"],
  label: "HubSpot CRM",
  slug: "hubspot",
  extendsFeature: "EventType",
  title: "HubSpot CRM",
  email: "help@cal.com",
  dirName: "hubspot",
  isOAuth: !0
}, eqc = "@calcom/huddle01video", tqc = "0.0.0", nqc = "./index.ts", oqc = "Huddle01 is a new video conferencing software native to Web3 and is comparable to a decentralized version of Zoom. It supports conversations for NFT communities, DAOs, Builders and also has features such as token gating, NFTs as avatars, Web3 Login + ENS and recording over IPFS.", rqc = {
  "@calcom/lib": "workspace:*"
}, iqc = {
  "@calcom/types": "workspace:*"
}, aqc = {
  private: !0,
  name: eqc,
  version: tqc,
  main: nqc,
  description: oqc,
  dependencies: rqc,
  devDependencies: iqc
}, Zme = {
  name: "Huddle01",
  description: aqc.description,
  installed: !0,
  type: "huddle01_video",
  variant: "conferencing",
  categories: ["video", "conferencing"],
  logo: "icon.svg",
  publisher: "huddle01.com",
  url: "https://huddle01.com",
  category: "conferencing",
  slug: "huddle01",
  title: "Huddle01",
  isGlobal: !1,
  email: "support@huddle01.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:huddle01_video",
      label: "Huddle01 Video"
    }
  },
  dirName: "huddle01video",
  concurrentMeetings: !0,
  isOAuth: !1
}, sqc = "ICS Feed", cqc = "ICS Feed", lqc = "ics-feed", dqc = "ics-feedcalendar", uqc = "ics-feed_calendar", _qc = "icon.svg", pqc = "calendar", mqc = [
  "calendar"
], fqc = "Cal.com, Inc.", gqc = "help@cal.com", hqc = "Import events from an ICS Feed into [Cal.com](https://cal.com).", vqc = !1, bqc = !0, yqc = {
  name: sqc,
  title: cqc,
  slug: lqc,
  dirName: dqc,
  type: uqc,
  logo: _qc,
  variant: pqc,
  categories: mqc,
  publisher: fqc,
  email: gqc,
  description: hqc,
  isTemplate: vqc,
  __createdUsingCli: bqc
}, $qc = "Insihts", wqc = "insihts", kqc = "insihts_analytics", Sqc = "icon.svg", xqc = "https://cal.com/", Eqc = "analytics", Tqc = [
  "analytics"
], Aqc = "Cal.com, Inc.", Cqc = "help@cal.com", zqc = "Insihts is an all-in-one platform for businesses looking to track user behavior, optimize workflows, and make data-driven decisions. Whether you are a marketer, product manager, or part of a customer success team, Insihts provides the tools you need to succeed.", Oqc = "EventType", Pqc = {
  tag: {
    scripts: [
      {
        src: "https://collector.insihts.com/script.js",
        attrs: {
          "data-website-id": "{SITE_ID}"
        }
      }
    ]
  }
}, Iqc = !1, Rqc = !0, Nqc = "booking-pages-tag", Qme = {
  name: $qc,
  slug: wqc,
  type: kqc,
  logo: Sqc,
  url: xqc,
  variant: Eqc,
  categories: Tqc,
  publisher: Aqc,
  email: Cqc,
  description: zqc,
  extendsFeature: Oqc,
  appData: Pqc,
  isTemplate: Iqc,
  __createdUsingCli: Rqc,
  __template: Nqc
}, Dqc = "Intercom", Mqc = "intercom", Lqc = "intercom_automation", qqc = "icon.svg", jqc = "https://github.com/vachmara", Fqc = "automation", Vqc = [
  "automation"
], Bqc = "Valentin Chmara", Uqc = "valentinchmara@gmail.com", Wqc = "Enhance your scheduling and appointment management experience with the Intercom Integration for [Cal.com](https://cal.com).", Gqc = !1, Hqc = !0, Kqc = "basic", Yqc = "intercom", Zqc = !0, Qqc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Dqc,
  slug: Mqc,
  type: Lqc,
  logo: qqc,
  url: jqc,
  variant: Fqc,
  categories: Vqc,
  publisher: Bqc,
  email: Uqc,
  description: Wqc,
  isTemplate: Gqc,
  __createdUsingCli: Hqc,
  __template: Kqc,
  dirName: Yqc,
  isOAuth: Zqc
}, Jqc = "Jelly", Xqc = "jelly", e9c = "jelly_conferencing", t9c = "icon.svg", n9c = "https://jellyjelly.com", o9c = "conferencing", r9c = [
  "conferencing"
], i9c = "Jelly", a9c = "support@jellyjelly.com", s9c = {
  location: {
    type: "integrations:{SLUG}_conferencing",
    label: "{TITLE}",
    linkType: "dynamic"
  }
}, c9c = "JellyPhone is a video calling tool with a stacked rolodex. You can cut short podcasts for Tik Tok and Instagram and publish in seconds. Connect with amazing people.", l9c = !1, d9c = !0, u9c = "event-type-location-video-static", Jme = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Jqc,
  slug: Xqc,
  type: e9c,
  logo: t9c,
  url: n9c,
  variant: o9c,
  categories: r9c,
  publisher: i9c,
  email: a9c,
  appData: s9c,
  description: c9c,
  isTemplate: l9c,
  __createdUsingCli: d9c,
  __template: u9c
}, _9c = "@calcom/jitsivideo", p9c = "0.0.0", m9c = "./index.ts", f9c = "Jitsi is a free open-source video conferencing software for web and mobile. Make a call, launch on your own servers, integrate into your app, and more.", g9c = {
  "@calcom/lib": "workspace:*"
}, h9c = {
  "@calcom/types": "workspace:*"
}, v9c = {
  private: !0,
  name: _9c,
  version: p9c,
  main: m9c,
  description: f9c,
  dependencies: g9c,
  devDependencies: h9c
}, Xme = {
  name: "Jitsi Video",
  description: v9c.description,
  installed: !0,
  type: "jitsi_video",
  variant: "conferencing",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://jitsi.org/",
  slug: "jitsi",
  title: "Jitsi Meet",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:jitsi",
      label: "Jitsi Video"
    }
  },
  dirName: "jitsivideo",
  concurrentMeetings: !0,
  isOAuth: !1
}, b9c = "https://json.schemastore.org/package.json", y9c = "@calcom/larkcalendar", $9c = "0.0.0", w9c = "./index.ts", k9c = "Lark Calendar is a time management and scheduling service developed by Lark. Allows users to create and edit events, with options available for type and time. Available to anyone that has a Lark account on both mobile and web versions.", S9c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, x9c = {
  "@calcom/types": "workspace:*"
}, E9c = {
  $schema: b9c,
  private: !0,
  name: y9c,
  version: $9c,
  main: w9c,
  description: k9c,
  dependencies: S9c,
  devDependencies: x9c
}, T9c = {
  name: "Lark Calendar",
  description: E9c.description,
  installed: !0,
  type: "lark_calendar",
  title: "Lark Calendar",
  variant: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Lark",
  slug: "lark-calendar",
  url: "https://larksuite.com/",
  email: "alan@larksuite.com",
  dirName: "larkcalendar",
  isOAuth: !0
}, A9c = "Lindy", C9c = "lindy", z9c = "lindy_automation", O9c = "icon-dark.svg", P9c = "https://www.lindy.ai/integrations/cal-com", I9c = "automation", R9c = [
  "automation"
], N9c = "Lindy", D9c = "flo@lindy.ai", M9c = "Build AI agents in minutes to automate workflows, save time and grow your business", L9c = !1, q9c = !0, j9c = "link-as-an-app", F9c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: A9c,
  slug: C9c,
  type: z9c,
  logo: O9c,
  url: P9c,
  variant: I9c,
  categories: R9c,
  publisher: N9c,
  email: D9c,
  description: M9c,
  isTemplate: L9c,
  __createdUsingCli: q9c,
  __template: j9c
}, V9c = "Linear", B9c = "linear", U9c = "linear_other", W9c = "icon.svg", G9c = "https://linear.app", H9c = "other", K9c = [
  "other"
], Y9c = "Linear", Z9c = "support@linear.app", Q9c = "Linear is a better way to build products. Connect your calendar to automate your status", J9c = !1, X9c = !0, ejc = [
  "google-calendar"
], tjc = "link-as-an-app", njc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: V9c,
  slug: B9c,
  type: U9c,
  logo: W9c,
  url: G9c,
  variant: H9c,
  categories: K9c,
  publisher: Y9c,
  email: Z9c,
  description: Q9c,
  isTemplate: J9c,
  __createdUsingCli: X9c,
  dependencies: ejc,
  __template: tjc
}, ojc = "Make", rjc = "make", ijc = "make_automation", ajc = "icon.svg", sjc = "https://github.com/aar2dee2", cjc = "automation", ljc = [
  "automation"
], djc = "aar2dee2", ujc = "support@cal.com", _jc = "From tasks and workflows to apps and systems, build and automate anything in one powerful visual platform.", pjc = !1, mjc = !0, fjc = "basic", gjc = "icon.svg", hjc = "make", vjc = !1, bjc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: ojc,
  slug: rjc,
  type: ijc,
  logo: ajc,
  url: sjc,
  variant: cjc,
  categories: ljc,
  publisher: djc,
  email: ujc,
  description: _jc,
  isTemplate: pjc,
  __createdUsingCli: mjc,
  __template: fjc,
  imageSrc: gjc,
  dirName: hjc,
  isOAuth: vjc
}, yjc = "Matomo", $jc = "matomo", wjc = "matomo_analytics", kjc = "icon.svg", Sjc = "https://cal.com/", xjc = "analytics", Ejc = [
  "analytics"
], Tjc = "Cal.com, Inc.", Ajc = "help@cal.com", Cjc = "Google Analytics alternative that protects your data and your customers' privacy", zjc = "EventType", Ojc = {
  tag: {
    scripts: [
      {
        src: "{MATOMO_URL}/matomo.js",
        attrs: {}
      },
      {
        content: `var _paq = window._paq || [];
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u='{MATOMO_URL}/';  
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '{SITE_ID}']);  
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();`
      }
    ]
  }
}, Pjc = !1, Ijc = !0, Rjc = "booking-pages-tag", efe = {
  name: yjc,
  slug: $jc,
  type: wjc,
  logo: kjc,
  url: Sjc,
  variant: xjc,
  categories: Ejc,
  publisher: Tjc,
  email: Ajc,
  description: Cjc,
  extendsFeature: zjc,
  appData: Ojc,
  isTemplate: Pjc,
  __createdUsingCli: Ijc,
  __template: Rjc
}, Njc = "Meta Pixel", Djc = "metapixel", Mjc = "metapixel_analytics", Ljc = "icon.svg", qjc = "https://github.com/regexyl", jjc = "analytics", Fjc = [
  "analytics"
], Vjc = "Regina Liu", Bjc = "info@regexyl.com", Ujc = "Add Meta Pixel to your bookings page to measure, optimize and build audiences for your ad campaigns.", Wjc = "EventType", Gjc = !1, Hjc = !0, Kjc = "event-type-app-card", Yjc = {
  tag: {
    scripts: [
      {
        content: "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','{TRACKING_ID}');fbq('trackCustom','CalcomView');"
      }
    ]
  }
}, Zjc = !1, tfe = {
  name: Njc,
  slug: Djc,
  type: Mjc,
  logo: Ljc,
  url: qjc,
  variant: jjc,
  categories: Fjc,
  publisher: Vjc,
  email: Bjc,
  description: Ujc,
  extendsFeature: Wjc,
  isTemplate: Gjc,
  __createdUsingCli: Hjc,
  __template: Kjc,
  appData: Yjc,
  isOAuth: Zjc
}, Qjc = "Millis AI", Jjc = "millis-ai", Xjc = "millis-ai_automation", eFc = "icon.png", tFc = "https://docs.millis.ai/tutorials/create-voice-agent-for-appointment-scheduling", nFc = "automation", oFc = [
  "automation"
], rFc = "Millis AI", iFc = "thach@millis.ai", aFc = "Build next-gen voice agents with 500ms latency\r", sFc = !1, cFc = !0, lFc = "link-as-an-app", dFc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Qjc,
  slug: Jjc,
  type: Xjc,
  logo: eFc,
  url: tFc,
  variant: nFc,
  categories: oFc,
  publisher: rFc,
  email: iFc,
  description: aFc,
  isTemplate: sFc,
  __createdUsingCli: cFc,
  __template: lFc
}, uFc = "Mirotalk", _Fc = "mirotalk", pFc = "mirotalk_video", mFc = "icon.svg", fFc = "https://cal.com/", gFc = "conferencing", hFc = [
  "conferencing"
], vFc = "Cal.com, Inc.", bFc = "support@cal.com", yFc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://p2p.mirotalk.com/join/80085ShinyPhone",
    urlRegExp: "^(http|https):\\/\\/(p2p|sfu)\\.mirotalk\\.com\\/join\\/[a-zA-Z0-9._-]+$"
  }
}, $Fc = "Peer to peer real-time video conferences, optimized for small groups. Unlimited time, unlimited rooms each having 5-8 participants.", wFc = !1, kFc = !0, SFc = "event-type-location-video-static", xFc = "mirotalk", EFc = !1, nfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: uFc,
  slug: _Fc,
  type: pFc,
  logo: mFc,
  url: fFc,
  variant: gFc,
  categories: hFc,
  publisher: vFc,
  email: bFc,
  appData: yFc,
  description: $Fc,
  isTemplate: wFc,
  __createdUsingCli: kFc,
  __template: SFc,
  dirName: xFc,
  isOAuth: EFc
}, TFc = "Mock Payment App", AFc = "mock-payment-app", CFc = "mock-payment-app_payment", zFc = "icon.svg", OFc = "https://example.com/link", PFc = "payment", IFc = [
  "payment"
], RFc = "Intuita", NFc = "greg@intuita.io", DFc = "The mock payment app for tests", MFc = !1, LFc = !0, qFc = "basic", jFc = "mock-payment-app", FFc = "EventType", VFc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: TFc,
  slug: AFc,
  type: CFc,
  logo: zFc,
  url: OFc,
  variant: PFc,
  categories: IFc,
  publisher: RFc,
  email: NFc,
  description: DFc,
  isTemplate: MFc,
  __createdUsingCli: LFc,
  __template: qFc,
  dirName: jFc,
  extendsFeature: FFc
}, BFc = "Monobot CX", UFc = "monobot", WFc = "monobot_automation", GFc = "icon.svg", HFc = "https://monobot.ai/?ref=cal.com", KFc = "automation", YFc = [
  "automation"
], ZFc = "Monobot CX", QFc = "contact@monobot.ai", JFc = "Crafting your personalized AI-driven assistant is easy and fast.", XFc = !1, e8c = !0, t8c = "link-as-an-app", n8c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: BFc,
  slug: UFc,
  type: WFc,
  logo: GFc,
  url: HFc,
  variant: KFc,
  categories: YFc,
  publisher: ZFc,
  email: QFc,
  description: JFc,
  isTemplate: XFc,
  __createdUsingCli: e8c,
  __template: t8c
}, o8c = "n8n", r8c = "n8n", i8c = "n8n_automation", a8c = "icon.svg", s8c = "https://cal.com/", c8c = "automation", l8c = [
  "automation"
], d8c = "Cal.com, Inc.", u8c = "help@cal.com", _8c = "Automate without limits. The workflow automation platform that doesn't box you in, that you never outgrow", p8c = !0, m8c = !1, f8c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: o8c,
  slug: r8c,
  type: i8c,
  logo: a8c,
  url: s8c,
  variant: c8c,
  categories: l8c,
  publisher: d8c,
  email: u8c,
  description: _8c,
  __createdUsingCli: p8c,
  isOAuth: m8c
}, g8c = "Nextcloud Talk", h8c = "nextcloudtalk", v8c = "nextcloudtalk_video", b8c = "icon.svg", y8c = "https://nextcloud.com/talk", $8c = "conferencing", w8c = [
  "conferencing"
], k8c = "Cal.com", S8c = "help@cal.com", x8c = {
  location: {
    type: "integrations:{SLUG}_conferencing",
    label: "{TITLE}",
    linkType: "dynamic"
  }
}, E8c = "Nextcloud Talk is a fully self hosted, on-premises audio/video and chat communication service. It features web and mobile apps and is designed to offer the highest degree of security while being easy to use.", T8c = !1, A8c = !0, ofe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: g8c,
  slug: h8c,
  type: v8c,
  logo: b8c,
  url: y8c,
  variant: $8c,
  categories: w8c,
  publisher: k8c,
  email: S8c,
  appData: x8c,
  description: E8c,
  isTemplate: T8c,
  __createdUsingCli: A8c
}, C8c = "https://json.schemastore.org/package.json", z8c = "@calcom/office365calendar", O8c = "0.0.0", P8c = "./index.ts", I8c = "Microsoft Office 365 is a suite of apps that helps you stay connected with others and get things done. It includes but is not limited to Microsoft Word, PowerPoint, Excel, Teams, OneNote and OneDrive. Office 365 allows you to work remotely with others on a team and collaborate in an online environment. Both web versions and desktop/mobile applications are available.", R8c = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  msw: "^2.7.0",
  "windows-iana": "^5.1.0"
}, N8c = {
  "@calcom/types": "workspace:*"
}, D8c = {
  $schema: C8c,
  private: !0,
  name: z8c,
  version: O8c,
  main: P8c,
  description: I8c,
  dependencies: R8c,
  devDependencies: N8c
}, M8c = {
  name: "Outlook Calendar",
  description: D8c.description,
  type: "office365_calendar",
  title: "Outlook Calendar",
  variant: "calendar",
  category: "calendar",
  categories: ["calendar"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "office365-calendar",
  dirName: "office365calendar",
  url: "https://cal.com/",
  email: "help@cal.com",
  isOAuth: !0
}, L8c = "Microsoft 365/Teams (Requires work/school account)", q8c = "Microsoft Teams is a business communication platform and collaborative workspace included in Microsoft 365. It offers workspace chat and video conferencing, file storage, and application integration. Both web versions and desktop/mobile applications are available. NOTE: MUST HAVE A WORK / SCHOOL ACCOUNT", j8c = "office365_video", F8c = "conferencing", V8c = "icon.svg", B8c = "Cal.com", U8c = "https://www.microsoft.com/en-ca/microsoft-teams/group-chat-software", W8c = !0, G8c = 4.3, H8c = 69, K8c = [
  "conferencing"
], Y8c = "msteams", Z8c = "MS Teams (Requires work/school account)", Q8c = !0, J8c = "help@cal.com", X8c = {
  location: {
    linkType: "dynamic",
    type: "integrations:office365_video",
    label: "MS Teams"
  }
}, e7c = "office365video", t7c = [
  "office365-calendar"
], n7c = !0, o7c = !0, rfe = {
  name: L8c,
  description: q8c,
  type: j8c,
  variant: F8c,
  logo: V8c,
  publisher: B8c,
  url: U8c,
  verified: W8c,
  rating: G8c,
  reviews: H8c,
  categories: K8c,
  slug: Y8c,
  title: Z8c,
  trending: Q8c,
  email: J8c,
  appData: X8c,
  dirName: e7c,
  dependencies: t7c,
  concurrentMeetings: n7c,
  isOAuth: o7c
}, r7c = "Paypal", i7c = "paypal", a7c = "paypal_payment", s7c = "icon.svg", c7c = "https://paypal.com", l7c = "payment", d7c = [
  "payment"
], u7c = "Cal.com", _7c = "support@cal.com", p7c = "Paypal payment app by [Cal.com](https://cal.com)", m7c = "EventType", f7c = !1, g7c = !0, h7c = "icon.svg", v7c = "event-type-app-card", b7c = "paypal", y7c = !0, $7c = {
  name: r7c,
  slug: i7c,
  type: a7c,
  logo: s7c,
  url: c7c,
  variant: l7c,
  categories: d7c,
  publisher: u7c,
  email: _7c,
  description: p7c,
  extendsFeature: m7c,
  isTemplate: f7c,
  __createdUsingCli: g7c,
  imageSrc: h7c,
  __template: v7c,
  dirName: b7c,
  isOAuth: y7c
}, w7c = "Ping.gg", k7c = "Ping.gg", S7c = "ping", x7c = "ping_video", E7c = "icon.svg", T7c = "https://ping.gg", A7c = "conferencing", C7c = [
  "conferencing"
], z7c = "Ping.gg", O7c = "support@ping.gg", P7c = "Ping.gg makes high quality video collaborations easier than ever. Think 'Zoom for streamers and creators'. Join a call in 3 clicks, manage audio and video like a pro, and copy-paste your guests straight into OBS", I7c = !0, R7c = {
  location: {
    linkType: "static",
    type: "integrations:ping_video",
    label: "Ping.gg",
    organizerInputPlaceholder: "https://www.ping.gg/call/theo",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?ping.gg\\/call\\/[a-zA-Z0-9]*"
  }
}, N7c = !1, ife = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: w7c,
  title: k7c,
  slug: S7c,
  type: x7c,
  logo: E7c,
  url: T7c,
  variant: A7c,
  categories: C7c,
  publisher: z7c,
  email: O7c,
  description: P7c,
  __createdUsingCli: I7c,
  appData: R7c,
  isOAuth: N7c
}, D7c = "Pipedream", M7c = "pipedream", L7c = "pipedream_automation", q7c = "icon.svg", j7c = "https://pipedream.com/apps/cal-com", F7c = "automation", V7c = [
  "automation"
], B7c = "Pipedream, Inc.", U7c = "support@pipedream.com", W7c = "Connect APIs, remarkably fast. Stop writing boilerplate code, struggling with authentication and managing infrastructure. Start connecting APIs with code-level control when you need it — and no code when you don't", G7c = !0, H7c = !1, K7c = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: D7c,
  slug: M7c,
  type: L7c,
  logo: q7c,
  url: j7c,
  variant: F7c,
  categories: V7c,
  publisher: B7c,
  email: U7c,
  description: W7c,
  __createdUsingCli: G7c,
  isOAuth: H7c
}, Y7c = "Pipedrive CRM", Z7c = "pipedrive-crm", Q7c = "pipedrive-crm_crm", J7c = "icon.svg", X7c = "https://revert.dev", eVc = "crm", tVc = [
  "crm"
], nVc = "EventType", oVc = "Revert.dev ", rVc = "jatin@revert.dev", iVc = "Founded in 2010, Pipedrive is an easy and effective sales CRM that drives small business growth.\r\rToday, Pipedrive is used by revenue teams at more than 100,000 companies worldwide. Pipedrive is headquartered in New York and has offices across Europe and the US.\r\rThe company is backed by majority holder Vista Equity Partners, Bessemer Venture Partners, Insight Partners, Atomico, and DTCP.\r\rLearn more at www.pipedrive.com.", aVc = !1, sVc = !0, cVc = "basic", lVc = "pipedrive-crm", dVc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: Y7c,
  slug: Z7c,
  type: Q7c,
  logo: J7c,
  url: X7c,
  variant: eVc,
  categories: tVc,
  extendsFeature: nVc,
  publisher: oVc,
  email: rVc,
  description: iVc,
  isTemplate: aVc,
  __createdUsingCli: sVc,
  __template: cVc,
  dirName: lVc
}, uVc = "Plausible", _Vc = "plausible", pVc = "plausible_analytics", mVc = "icon.svg", fVc = "https://cal.com/", gVc = "analytics", hVc = [
  "analytics"
], vVc = "Cal.com, Inc.", bVc = "help@cal.com", yVc = "EventType", $Vc = {
  tag: {
    scripts: [
      {
        src: "{PLAUSIBLE_URL}",
        attrs: {
          "data-domain": "{TRACKING_ID}"
        }
      }
    ]
  }
}, wVc = "Simple, privacy-friendly Google Analytics alternative.", kVc = !0, SVc = !1, afe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: uVc,
  slug: _Vc,
  type: pVc,
  logo: mVc,
  url: fVc,
  variant: gVc,
  categories: hVc,
  publisher: vVc,
  email: bVc,
  extendsFeature: yVc,
  appData: $Vc,
  description: wVc,
  __createdUsingCli: kVc,
  isOAuth: SVc
}, xVc = "Posthog", EVc = "posthog", TVc = "posthog_analytics", AVc = "icon.svg", CVc = "https://posthog.com", zVc = "analytics", OVc = [
  "analytics"
], PVc = "Cal.com, Inc.", IVc = "help@cal.com", RVc = "PostHog is the all-in-one platform for building better products - with product analytics, feature flags, session recordings, a/b testing, heatmaps, and more.", NVc = "EventType", DVc = {
  tag: {
    scripts: [
      {
        content: "!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split('.');2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement('script')).type='text/javascript',p.async=!0,p.src=s.api_host.replace('.i.posthog.com','-assets.i.posthog.com')+'/static/array.js',(r=t.getElementsByTagName('script')[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a='posthog',u.people=u.people||[],u.toString=function(t){var e='posthog';return'posthog'!==a&&(e+='.'+a),t||(e+=' (stub)'),e},u.people.toString=function(){return u.toString(1)+'.people (stub)'},o='capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId'.split(' '),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);posthog.init('{TRACKING_ID}',{api_host:'{API_HOST}'})"
      }
    ]
  }
}, MVc = !1, LVc = !0, qVc = "booking-pages-tag", sfe = {
  name: xVc,
  slug: EVc,
  type: TVc,
  logo: AVc,
  url: CVc,
  variant: zVc,
  categories: OVc,
  publisher: PVc,
  email: IVc,
  description: RVc,
  extendsFeature: NVc,
  appData: DVc,
  isTemplate: MVc,
  __createdUsingCli: LVc,
  __template: qVc
}, jVc = "QR Code", FVc = "qr_code", VVc = "qr_code_other", BVc = "icon.svg", UVc = "https://cal.com/", WVc = "other", GVc = [
  "other"
], HVc = "EventType", KVc = "Cal.com, Inc.", YVc = "support@cal.com", ZVc = "Easily generate a QR code for your links to print, share, or embed.", QVc = !0, JVc = !1, XVc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: jVc,
  slug: FVc,
  type: VVc,
  logo: BVc,
  url: UVc,
  variant: WVc,
  categories: GVc,
  extendsFeature: HVc,
  publisher: KVc,
  email: YVc,
  description: ZVc,
  __createdUsingCli: QVc,
  isOAuth: JVc
}, eBc = "Raycast", tBc = "raycast", nBc = "raycast_other", oBc = "icon.svg", rBc = "https://github.com/eluce2", iBc = "other", aBc = [
  "automation"
], sBc = "Eric Luce", cBc = "info@restlessmindstech.com", lBc = "Quickly share your [Cal.com](https://cal.com) meeting links with Raycast", dBc = !0, uBc = !1, _Bc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: eBc,
  slug: tBc,
  type: nBc,
  logo: oBc,
  url: rBc,
  variant: iBc,
  categories: aBc,
  publisher: sBc,
  email: cBc,
  description: lBc,
  __createdUsingCli: dBc,
  isOAuth: uBc
}, pBc = "Retell AI", mBc = "retell-ai", fBc = "retell-ai_automation", gBc = "icon-dark.svg", hBc = "https://go.cal.com/retellai", vBc = "automation", bBc = [
  "automation"
], yBc = "Retell AI", $Bc = "founders@retellai.com", wBc = "Supercharge your Call Operations with AI \r", kBc = !1, SBc = !0, xBc = "link-as-an-app", EBc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: pBc,
  slug: mBc,
  type: fBc,
  logo: gBc,
  url: hBc,
  variant: vBc,
  categories: bBc,
  publisher: yBc,
  email: $Bc,
  description: wBc,
  isTemplate: kBc,
  __createdUsingCli: SBc,
  __template: xBc
}, TBc = "Riverside", ABc = "riverside", CBc = "riverside_video", zBc = "icon-dark.svg", OBc = "https://cal.com/", PBc = "conferencing", IBc = [
  "conferencing"
], RBc = "Cal.com, Inc.", NBc = "help@cal.com", DBc = "Your online recording studio. The easiest way to record podcasts and videos in studio quality from anywhere. All from the browser.", MBc = !0, LBc = {
  location: {
    label: "Riverside Video",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?riverside.fm\\/studio\\/[a-zA-Z0-9]*",
    type: "integrations:riverside_video",
    linkType: "static"
  }
}, qBc = !1, cfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: TBc,
  slug: ABc,
  type: CBc,
  logo: zBc,
  url: OBc,
  variant: PBc,
  categories: IBc,
  publisher: RBc,
  email: NBc,
  description: DBc,
  __createdUsingCli: MBc,
  appData: LBc,
  isOAuth: qBc
}, jBc = "Roam", FBc = "roam", VBc = "roam_conferencing", BBc = "icon.png", UBc = "https://ro.am", WBc = "conferencing", GBc = [
  "conferencing"
], HBc = "Roam HQ, Inc.", KBc = "support@ro.am", YBc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://ro.am/r/#/p/yHwFBQrRTMuptqKYo_wu8A/huzRiHnR-np4RGYKV-c0pQ",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?ro.am\\/[a-zA-Z0-9]*"
  }
}, ZBc = "Roam is Your Whole Company in one HQ\r", QBc = !1, JBc = !0, XBc = "event-type-location-video-static", lfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: jBc,
  slug: FBc,
  type: VBc,
  logo: BBc,
  url: UBc,
  variant: WBc,
  categories: GBc,
  publisher: HBc,
  email: KBc,
  appData: YBc,
  description: ZBc,
  isTemplate: QBc,
  __createdUsingCli: JBc,
  __template: XBc
}, eUc = "Routing", tUc = "Routing", nUc = !0, oUc = "routing-forms", rUc = "routing-forms_other", iUc = "icon-dark.svg", aUc = "https://cal.com/resources/feature/routing-forms", sUc = "other", cUc = [
  "automation"
], lUc = "Cal.com, Inc.", dUc = "/routing", uUc = "help@cal.com", _Uc = !0, pUc = {
  upgradeUrl: "/routing"
}, mUc = "It would allow a booker to connect with the right person or choose the right event, faster. It would work by taking inputs from the booker and using that data to route to the correct booker/event as configured by Cal user", fUc = !0, gUc = !1, hUc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: eUc,
  title: tUc,
  isGlobal: nUc,
  slug: oUc,
  type: rUc,
  logo: iUc,
  url: aUc,
  variant: sUc,
  categories: cUc,
  publisher: lUc,
  simplePath: dUc,
  email: uUc,
  licenseRequired: _Uc,
  teamsPlanRequired: pUc,
  description: mUc,
  __createdUsingCli: fUc,
  isOAuth: gUc
}, vUc = "Salesforce", bUc = "salesforce", yUc = "salesforce_crm", $Uc = "icon.png", wUc = "https://cal.com/", kUc = "crm", SUc = [
  "crm"
], xUc = "EventType", EUc = "Cal.com, Inc.", TUc = "help@cal.com", AUc = "Salesforce (Sales Cloud) is a cloud-based application designed to help your salespeople sell smarter and faster by centralizing customer information, logging their interactions with your company, and automating many of the tasks salespeople do every day.", CUc = !0, zUc = !0, OUc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: vUc,
  slug: bUc,
  type: yUc,
  logo: $Uc,
  url: wUc,
  variant: kUc,
  categories: SUc,
  extendsFeature: xUc,
  publisher: EUc,
  email: TUc,
  description: AUc,
  __createdUsingCli: CUc,
  isOAuth: zUc
}, PUc = "Salesroom", IUc = "salesroom", RUc = "salesroom_conferencing", NUc = "icon.svg", DUc = "https://salesroom.com/", MUc = "conferencing", LUc = [
  "conferencing"
], qUc = "Cal.com, Inc.", jUc = "support@cal.com", FUc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://user.sr.chat",
    urlRegExp: "^https:\\/\\/.+\\.sr\\.chat"
  }
}, VUc = "Unlock real-time AI and take your sales game to the next level", BUc = !1, UUc = !0, WUc = "event-type-location-video-static", dfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: PUc,
  slug: IUc,
  type: RUc,
  logo: NUc,
  url: DUc,
  variant: MUc,
  categories: LUc,
  publisher: qUc,
  email: jUc,
  appData: FUc,
  description: VUc,
  isTemplate: BUc,
  __createdUsingCli: UUc,
  __template: WUc
}, GUc = "Sendgrid", HUc = "sendgrid", KUc = "sendgrid_other_calendar", YUc = "logo.png", ZUc = "https://cal.com/", QUc = "other_calendar", JUc = [
  "other"
], XUc = "Cal.com, Inc.", eWc = "help@cal.com", tWc = "SendGrid delivers your transactional and marketing emails through the world's largest cloud-based email delivery platform.", nWc = !0, oWc = !1, rWc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: GUc,
  slug: HUc,
  type: KUc,
  logo: YUc,
  url: ZUc,
  variant: QUc,
  categories: JUc,
  publisher: XUc,
  email: eWc,
  description: tWc,
  __createdUsingCli: nWc,
  isOAuth: oWc
}, iWc = "Shimmer Video", aWc = "shimmervideo", sWc = "shimmer_video", cWc = "icon.png", lWc = "https://shimmer.care", dWc = "conferencing", uWc = [
  "conferencing"
], _Wc = "Shimmer.care", pWc = "support@shimmer.care", mWc = "The #1 Expert ADHD Coach. Weekly calls and in-app support so that you can reach your full potential", fWc = !1, gWc = !0, hWc = "basic", vWc = {
  location: {
    linkType: "dynamic",
    type: "integrations:shimmer_video",
    label: "Shimmer Video"
  }
}, ufe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: iWc,
  slug: aWc,
  type: sWc,
  logo: cWc,
  url: lWc,
  variant: dWc,
  categories: uWc,
  publisher: _Wc,
  email: pWc,
  description: mWc,
  isTemplate: fWc,
  __createdUsingCli: gWc,
  __template: hWc,
  appData: vWc
}, bWc = "Signal", yWc = "signal", $Wc = "signal_video", wWc = "icon.svg", kWc = "https://cal.com/", SWc = "messaging", xWc = [
  "messaging"
], EWc = "Cal.com, Inc.", TWc = "support@cal.com", AWc = "Schedule a chat with your guests or have a Signal Video call.", CWc = !0, zWc = {
  location: {
    type: "integrations:signal_video",
    label: "Signal",
    linkType: "static",
    organizerInputPlaceholder: "https://signal.me/#p/+11234567890",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?signal.me\\/[a-zA-Z0-9]*"
  }
}, OWc = !1, _fe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: bWc,
  slug: yWc,
  type: $Wc,
  logo: wWc,
  url: kWc,
  variant: SWc,
  categories: xWc,
  publisher: EWc,
  email: TWc,
  description: AWc,
  __createdUsingCli: CWc,
  appData: zWc,
  isOAuth: OWc
}, PWc = "Sirius Video", IWc = "sirius_video", RWc = "sirius_video_video", NWc = "icon-dark.svg", DWc = "https://cal.com/", MWc = "conferencing", LWc = [
  "conferencing"
], qWc = "Cal.com, Inc.", jWc = "support@cal.com", FWc = "Video meetings made for music.\rCreate your own virtual music classroom, easily.", VWc = !0, BWc = {
  location: {
    type: "integrations:sirius_video_video",
    label: "Sirius Video",
    linkType: "static",
    organizerInputPlaceholder: "https://sirius.video/sebastian",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?sirius.video\\/[a-zA-Z0-9]*"
  }
}, UWc = !1, pfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: PWc,
  slug: IWc,
  type: RWc,
  logo: NWc,
  url: DWc,
  variant: MWc,
  categories: LWc,
  publisher: qWc,
  email: jWc,
  description: FWc,
  __createdUsingCli: VWc,
  appData: BWc,
  isOAuth: UWc
}, WWc = "Skype", GWc = "skype", HWc = "skype_conferencing", KWc = "icon.svg", YWc = "https://github.com/anikdhabal/", ZWc = "conferencing", QWc = [
  "conferencing"
], JWc = "Anik Dhabal Babu", XWc = "adhabl2002@gmail.com", eGc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://join.skype.com/",
    urlRegExp: "https://join\\.skype\\.com/[a-zA-Z0-9]*"
  }
}, tGc = "Skype is for connecting with the people that matter most in your life and work. It's built for both one-on-one and group conversations and works wherever you are – via mobile, PC and Alexa. Skype messaging and HD voice and video calling will help you share experiences and get things done with others.", nGc = !1, oGc = !0, rGc = "event-type-location-video-static", mfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: WWc,
  slug: GWc,
  type: HWc,
  logo: KWc,
  url: YWc,
  variant: ZWc,
  categories: QWc,
  publisher: JWc,
  email: XWc,
  appData: eGc,
  description: tGc,
  isTemplate: nGc,
  __createdUsingCli: oGc,
  __template: rGc
}, iGc = "https://json.schemastore.org/package.json", aGc = "AGPLv3 (see LICENSE file)", sGc = "@calcom/stripepayment", cGc = "0.0.0", lGc = "./index.ts", dGc = "A Saas company a payment processing software, and application programming interfaces for e-commerce websites and mobile applications.", uGc = {
  downgrade: "ts-node ./downgrade.ts"
}, _Gc = {
  "@calcom/app-store": "workspace:*",
  "@calcom/dayjs": "workspace:*",
  "@calcom/emails": "workspace:*",
  "@calcom/features": "workspace:*",
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*",
  "@calcom/types": "workspace:*",
  "@stripe/react-stripe-js": "^1.10.0",
  "@stripe/stripe-js": "^1.35.0",
  stripe: "^9.16.0",
  uuid: "^8.3.2",
  zod: "^3.22.4"
}, pGc = {
  "@calcom/types": "workspace:*",
  "ts-node": "^10.9.1"
}, mGc = {
  $schema: iGc,
  private: !0,
  license: aGc,
  name: sGc,
  version: cGc,
  main: lGc,
  description: dGc,
  scripts: uGc,
  dependencies: _Gc,
  devDependencies: pGc
};
var x6 = {};
const fGc = {
  name: "Stripe",
  description: mGc.description,
  installed: !!(x6.STRIPE_CLIENT_ID && x6.NEXT_PUBLIC_STRIPE_PUBLIC_KEY && x6.STRIPE_PRIVATE_KEY),
  slug: "stripe",
  category: "payment",
  categories: ["payment"],
  logo: "icon.svg",
  publisher: "Cal.com",
  title: "Stripe",
  type: "stripe_payment",
  url: "https://cal.com/",
  docsUrl: "https://stripe.com/docs",
  variant: "payment",
  extendsFeature: "EventType",
  email: "help@cal.com",
  dirName: "stripepayment",
  isOAuth: !0
}, gGc = "Sylaps", hGc = "Sylaps", vGc = "sylapsvideo", bGc = "sylaps_video", yGc = "icon.svg", $Gc = "https://sylaps.com", wGc = "conferencing", kGc = [
  "conferencing"
], SGc = "Sylaps Inc", xGc = "support@sylaps.com", EGc = "Free Audio and Video Conferencing, Online Collaboration, Screen Sharing on web browser, mobile and desktop.", TGc = !0, AGc = {
  location: {
    linkType: "dynamic",
    type: "integrations:sylaps_video",
    label: "Sylaps"
  }
}, CGc = !1, ffe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: gGc,
  title: hGc,
  slug: vGc,
  type: bGc,
  logo: yGc,
  url: $Gc,
  variant: wGc,
  categories: kGc,
  publisher: SGc,
  email: xGc,
  description: EGc,
  __createdUsingCli: TGc,
  appData: AGc,
  isOAuth: CGc
}, zGc = "Synthflow", OGc = "synthflow", PGc = "synthflow_automation", IGc = "icon.svg", RGc = "https://synthflow.ai/integrations/calcom", NGc = "automation", DGc = [
  "automation"
], MGc = "Synthflow.ai", LGc = "albert@synthflow.ai", qGc = "Effortless Human-Like AI Phone Calls and Scheduling", jGc = !1, FGc = !0, VGc = "link-as-an-app", BGc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: zGc,
  slug: OGc,
  type: PGc,
  logo: IGc,
  url: RGc,
  variant: NGc,
  categories: DGc,
  publisher: MGc,
  email: LGc,
  description: qGc,
  isTemplate: jGc,
  __createdUsingCli: FGc,
  __template: VGc
}, UGc = "@calcom/tandemvideo", WGc = "0.0.0", GGc = "./index.ts", HGc = "Tandem is a new virtual office space that allows teams to effortlessly connect as though they are in a physical office, online. Through co-working rooms, available statuses, live real-time video call, and chat options, you can see who’s around, talk and collaborate in one click. It works cross-platform with both desktop and mobile versions.", KGc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, YGc = {
  "@calcom/types": "workspace:*"
}, ZGc = {
  private: !0,
  name: UGc,
  version: WGc,
  main: GGc,
  description: HGc,
  dependencies: KGc,
  devDependencies: YGc
}, gfe = {
  name: "Tandem Video",
  description: ZGc.description,
  type: "tandem_video",
  title: "Tandem Video",
  variant: "conferencing",
  categories: ["conferencing"],
  slug: "tandem",
  category: "conferencing",
  logo: "icon.svg",
  publisher: "",
  url: "",
  isGlobal: !1,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:tandem",
      label: "Tandem Video"
    }
  },
  dirName: "tandemvideo",
  isOAuth: !0
}, QGc = "Telegram", JGc = "telegram", XGc = "telegram_video", eHc = "icon.svg", tHc = "https://cal.com/", nHc = "messaging", oHc = [
  "messaging"
], rHc = "Cal.com, Inc.", iHc = "support@cal.com", aHc = "Schedule a chat with your guests or have a Telegram Video call.", sHc = !0, cHc = {
  location: {
    type: "integrations:telegram_video",
    label: "Telegram",
    linkType: "static",
    organizerInputPlaceholder: "https://t.me/MyUsername",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?t.me\\/[a-zA-Z0-9]*"
  }
}, hfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: QGc,
  slug: JGc,
  type: XGc,
  logo: eHc,
  url: tHc,
  variant: nHc,
  categories: oHc,
  publisher: rHc,
  email: iHc,
  description: aHc,
  __createdUsingCli: sHc,
  appData: cHc
}, lHc = "telli", dHc = "telli", uHc = "telli_automation", _Hc = "icon-dark.svg", pHc = "https://www.telli.com/en/caldotcom", mHc = "automation", fHc = [
  "automation"
], gHc = "telli technologies GmbH", hHc = "founders@telli.so", vHc = "telli AI agents reach your customers, make calls independently & enhance your customer experience - fully integrated into [Cal.com](https://cal.com).", bHc = !1, yHc = !0, $Hc = "link-as-an-app", wHc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: lHc,
  slug: dHc,
  type: uHc,
  logo: _Hc,
  url: pHc,
  variant: mHc,
  categories: fHc,
  publisher: gHc,
  email: hHc,
  description: vHc,
  isTemplate: bHc,
  __createdUsingCli: yHc,
  __template: $Hc
}, kHc = "Basic", SHc = "basic", xHc = "basic_other", EHc = "icon.svg", THc = "https://example.com/link", AHc = "other", CHc = [
  "other"
], zHc = "Cal.com, Inc.", OHc = "support@cal.com", PHc = "It is a template for an app that can be installed and provides no other feature.", IHc = !0, RHc = !0, NHc = "link-as-an-app", DHc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: kHc,
  slug: SHc,
  type: xHc,
  logo: EHc,
  url: THc,
  variant: AHc,
  categories: CHc,
  publisher: zHc,
  email: OHc,
  description: PHc,
  isTemplate: IHc,
  __createdUsingCli: RHc,
  __template: NHc
}, MHc = "Booking Pages Tag", LHc = "booking-pages-tag", qHc = "booking-pages-tag_analytics", jHc = "icon.svg", FHc = "https://example.com/link", VHc = "analytics", BHc = [
  "analytics"
], UHc = "Cal.com, Inc.", WHc = "support@cal.com", GHc = "It is a template demoing a Booking Pages tracking app like GA4, Fathom and Plausible.", HHc = "EventType", KHc = {
  tag: {
    scripts: [
      {
        src: "https://cdn.example.com/script.js",
        attrs: {
          "data-site": "{TRACKING_ID}"
        }
      }
    ]
  }
}, YHc = !0, ZHc = !0, vfe = {
  name: MHc,
  slug: LHc,
  type: qHc,
  logo: jHc,
  url: FHc,
  variant: VHc,
  categories: BHc,
  publisher: UHc,
  email: WHc,
  description: GHc,
  extendsFeature: HHc,
  appData: KHc,
  isTemplate: YHc,
  __createdUsingCli: ZHc
}, QHc = "EventType AppCard", JHc = "event-type-app-card", XHc = "event-type-app-card_other", eKc = "icon.svg", tKc = "https://example.com/link", nKc = "other", oKc = [
  "other"
], rKc = "Cal.com, Inc.", iKc = "support@cal.com", aKc = "A template showcasing how an app with EventType AppCard can be built e.g. Giphy, QR Code", sKc = "EventType", cKc = !0, lKc = !0, dKc = {
  name: QHc,
  slug: JHc,
  type: XHc,
  logo: eKc,
  url: tKc,
  variant: nKc,
  categories: oKc,
  publisher: rKc,
  email: iKc,
  description: aKc,
  extendsFeature: sKc,
  isTemplate: cKc,
  __createdUsingCli: lKc
}, uKc = "EventType Location Video - Static", _Kc = "event-type-location-video-static", pKc = "event-type-location-video-static_video", mKc = "icon.svg", fKc = "https://example.com/link", gKc = "conferencing", hKc = [
  "conferencing"
], vKc = "Cal.com Inc", bKc = "support@cal.com", yKc = {
  location: {
    type: "integrations:{SLUG}_video",
    label: "{TITLE}",
    linkType: "static",
    organizerInputPlaceholder: "https://video.app/mylink",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?video.app\\/[a-zA-Z0-9]*"
  }
}, $Kc = "It is a template showing how to add a static URL EventType location e.g. Around, Whereby", wKc = !0, kKc = !0, bfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: uKc,
  slug: _Kc,
  type: pKc,
  logo: mKc,
  url: fKc,
  variant: gKc,
  categories: hKc,
  publisher: vKc,
  email: bKc,
  appData: yKc,
  description: $Kc,
  isTemplate: wKc,
  __createdUsingCli: kKc
}, SKc = "General App Settings", xKc = "general-app-settings", EKc = "general-app-settings_other", TKc = "icon.svg", AKc = "https://example.com/link", CKc = "other", zKc = [
  "other"
], OKc = "Cal.com Inc", PKc = "support@cal.com", IKc = "It is a template showing how an App can have settings in installed section that configures the app globally e.g. Weather in your Calendar", RKc = !0, NKc = !0, DKc = {
  name: SKc,
  slug: xKc,
  type: EKc,
  logo: TKc,
  url: AKc,
  variant: CKc,
  categories: zKc,
  publisher: OKc,
  email: PKc,
  description: IKc,
  isTemplate: RKc,
  __createdUsingCli: NKc
}, MKc = "Link as An App", LKc = "link-as-an-app", qKc = "link-as-an-app_other", jKc = "icon.svg", FKc = "https://example.com/link", VKc = "other", BKc = [
  "other"
], UKc = "Cal.com, Inc.", WKc = "support@cal.com", GKc = "It's a template showing how an app, that is just a link to some webpage, can be made e.g. Pipedream, Amie, Vimcal.", HKc = !0, KKc = !0, YKc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: MKc,
  slug: LKc,
  type: qKc,
  logo: jKc,
  url: FKc,
  variant: VKc,
  categories: BKc,
  publisher: UKc,
  email: WKc,
  description: GKc,
  isTemplate: HKc,
  __createdUsingCli: KKc
}, ZKc = "Twipla", QKc = "twipla", JKc = "twipla_analytics", XKc = "icon.svg", eYc = "https://cal.com/", tYc = "analytics", nYc = [
  "analytics"
], oYc = "Cal.com, Inc.", rYc = "help@cal.com", iYc = "Twipla.com, formerly known as Visitor Analytics, is a website intelligence platform that helps you understand how visitors interact with your website.", aYc = "EventType", sYc = {
  tag: {
    scripts: [
      {
        content: `(function(v, i, s, a, t) {
  v[t] = v[t] || function() {
    (v[t].v = v[t].v || []).push(arguments);
  };
  if (!v._visaSettings) {
    v._visaSettings = {};
  }
  v._visaSettings[a] = {
    v: '1.0',
    s: a,
    a: '1',
    t: t
  };
  var b = i.getElementsByTagName('body')[0];
  var p = i.createElement('script');
  p.defer = 1;
  p.async = 1;
  p.src = s + '?s=' + a;
  b.appendChild(p);
})(window, document, '//app-worker.visitor-analytics.io/main.js', '{SITE_ID}', 'va');`
      }
    ]
  }
}, cYc = !1, lYc = !0, dYc = "booking-pages-tag", yfe = {
  name: ZKc,
  slug: QKc,
  type: JKc,
  logo: XKc,
  url: eYc,
  variant: tYc,
  categories: nYc,
  publisher: oYc,
  email: rYc,
  description: iYc,
  extendsFeature: aYc,
  appData: sYc,
  isTemplate: cYc,
  __createdUsingCli: lYc,
  __template: dYc
}, uYc = "Umami", _Yc = "umami", pYc = "umami_analytics", mYc = "icon.svg", fYc = "https://cal.com/", gYc = "analytics", hYc = [
  "analytics"
], vYc = "Cal.com, Inc.", bYc = "help@cal.com", yYc = "Umami makes it easy to collect, analyze, and understand your web data — while maintaining visitor privacy and data ownership.", $Yc = "EventType", wYc = {
  tag: {
    scripts: [
      {
        src: "{SCRIPT_URL}",
        attrs: {
          "data-website-id": "{SITE_ID}"
        }
      }
    ]
  }
}, kYc = !1, SYc = !0, xYc = "booking-pages-tag", $fe = {
  name: uYc,
  slug: _Yc,
  type: pYc,
  logo: mYc,
  url: fYc,
  variant: gYc,
  categories: hYc,
  publisher: vYc,
  email: bYc,
  description: yYc,
  extendsFeature: $Yc,
  appData: wYc,
  isTemplate: kYc,
  __createdUsingCli: SYc,
  __template: xYc
}, EYc = "Vimcal", TYc = "vimcal", AYc = "vimcal_other", CYc = "icon.svg", zYc = "https://cal.com/", OYc = "other", PYc = [
  "calendar"
], IYc = "Cal.com, Inc.", RYc = "support@cal.com", NYc = "The world's fastest calendar, beautifully designed for a remote world\r", DYc = !0, MYc = [
  "google-calendar"
], LYc = !1, qYc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: EYc,
  slug: TYc,
  type: AYc,
  logo: CYc,
  url: zYc,
  variant: OYc,
  categories: PYc,
  publisher: IYc,
  email: RYc,
  description: NYc,
  __createdUsingCli: DYc,
  dependencies: MYc,
  isOAuth: LYc
}, jYc = "https://json.schemastore.org/package.json", FYc = "@calcom/vital", VYc = "0.1.0", BYc = "./index.ts", UYc = "Connect your health data or wearables to trigger actions on your calendar.", WYc = {
  "@calcom/prisma": "workspace:*",
  "@tryvital/vital-node": "^1.4.6",
  queue: "^6.0.2"
}, GYc = {
  "@calcom/types": "workspace:*"
}, HYc = {
  $schema: jYc,
  private: !0,
  name: FYc,
  version: VYc,
  main: BYc,
  description: UYc,
  dependencies: WYc,
  devDependencies: GYc
}, KYc = {
  name: "Vital",
  description: HYc.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  logo: "icon-dark.svg",
  label: "Vital",
  publisher: "Vital",
  slug: "vital-automation",
  title: "Vital",
  type: "vital_other",
  url: "https://tryvital.io",
  variant: "other",
  email: "support@tryvital.io",
  dirName: "vital",
  isOAuth: !0
}, YYc = "Weather in your Calendar", ZYc = "weather_in_your_calendar", QYc = "weather_in_your_calendar_other", JYc = "icon.svg", XYc = "https://github.com/vejnoe", eZc = "other", tZc = [
  "other"
], nZc = "Andreas Vejnø Andersen", oZc = "info@vejnoe.dk", rZc = "Get the local weather forecast with icons in your calendar\r\r", iZc = !0, aZc = !1, sZc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: YYc,
  slug: ZYc,
  type: QYc,
  logo: JYc,
  url: XYc,
  variant: eZc,
  categories: tZc,
  publisher: nZc,
  email: oZc,
  description: rZc,
  __createdUsingCli: iZc,
  isOAuth: aZc
}, cZc = "Webex", lZc = "Webex", dZc = "webex", uZc = "webex_video", _Zc = "/icon.ico", pZc = "/icon.ico", mZc = "https://github.com/aar2dee2", fZc = "conferencing", gZc = [
  "conferencing"
], hZc = "aar2dee2", vZc = "support@cal.com", bZc = "Create meetings with Cisco Webex", yZc = {
  location: {
    linkType: "dynamic",
    type: "integrations:webex_video",
    label: "Webex"
  }
}, $Zc = !1, wZc = !0, kZc = "basic", SZc = !0, xZc = !0, wfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: cZc,
  title: lZc,
  slug: dZc,
  type: uZc,
  imageSrc: _Zc,
  logo: pZc,
  url: mZc,
  variant: fZc,
  categories: gZc,
  publisher: hZc,
  email: vZc,
  description: bZc,
  appData: yZc,
  isTemplate: $Zc,
  __createdUsingCli: wZc,
  __template: kZc,
  concurrentMeetings: SZc,
  isAuth: xZc
}, EZc = "WhatsApp", TZc = "whatsapp", AZc = "whatsapp_video", CZc = "icon.svg", zZc = "https://cal.com/", OZc = "messaging", PZc = [
  "messaging"
], IZc = "Cal.com, Inc.", RZc = "support@cal.com", NZc = "Schedule a chat with your guests or have a WhatsApp Video call.", DZc = !0, MZc = {
  location: {
    type: "integrations:whatsapp_video",
    label: "WhatsApp",
    linkType: "static",
    organizerInputPlaceholder: "https://wa.me/send?phone=1234567890",
    urlRegExp: "^http(s)?:\\/\\/(www\\.)?wa.me\\/[a-zA-Z0-9]*"
  }
}, LZc = !1, kfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: EZc,
  slug: TZc,
  type: AZc,
  logo: CZc,
  url: zZc,
  variant: OZc,
  categories: PZc,
  publisher: IZc,
  email: RZc,
  description: NZc,
  __createdUsingCli: DZc,
  appData: MZc,
  isAuth: LZc
}, qZc = "Whereby", jZc = "Whereby", FZc = "whereby", VZc = "whereby_video", BZc = "icon-dark.svg", UZc = "https://cal.com/", WZc = "conferencing", GZc = [
  "conferencing"
], HZc = "Cal.com, Inc.", KZc = "help@cal.com", YZc = "Whereby makes it super simple for collaborating teams to jump on a video call.", ZZc = !0, QZc = {
  location: {
    linkType: "static",
    type: "integrations:whereby_video",
    label: "Whereby Video",
    organizerInputPlaceholder: "https://www.whereby.com/cal",
    urlRegExp: "^(?:https?://)?(?:(?!.*-\\.)(?:\\w+(-\\w+)*\\.))*whereby\\.com(/[\\w\\-._~:?#\\[\\]@!$&'()*+,;%=]+)*$"
  }
}, JZc = !1, Sfe = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: qZc,
  title: jZc,
  slug: FZc,
  type: VZc,
  logo: BZc,
  url: UZc,
  variant: WZc,
  categories: GZc,
  publisher: HZc,
  email: KZc,
  description: YZc,
  __createdUsingCli: ZZc,
  appData: QZc,
  isAuth: JZc
}, XZc = "https://json.schemastore.org/package.json", eQc = "WipeMyCal", tQc = "0.1.0", nQc = "./index.ts", oQc = "Wipe My Cal is a Cal.com exclusive app that redefines what it looks like to reschedule multiple meetings at the same time. Simply install the app, and select ‘Wipe’ for whatever date you need to mass reschedule. Handle emergencies, unexpected sick days and last minute events with the simple click of a button.", rQc = {
  "@calcom/prisma": "workspace:*",
  queue: "^6.0.2"
}, iQc = {
  "@calcom/types": "workspace:*"
}, oZ = {
  $schema: XZc,
  private: !0,
  name: eQc,
  version: tQc,
  main: nQc,
  description: oQc,
  dependencies: rQc,
  devDependencies: iQc
}, aQc = {
  name: oZ.name,
  description: oZ.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  // If using static next public folder, can then be referenced from the base URL (/).
  logo: "icon-dark.svg",
  publisher: "Cal.com",
  slug: "wipe-my-cal",
  title: "Wipe my cal",
  type: "wipemycal_other",
  url: "https://cal.com/apps/wipe-my-cal",
  variant: "other",
  email: "help@cal.com",
  dirName: "wipemycalother",
  isOAuth: !1
}, sQc = "Wordpress", cQc = "wordpress", lQc = "wordpress_other", dQc = "icon-dark.svg", uQc = "https://github.com/calcom/wp-plugin", _Qc = "other", pQc = [
  "other"
], mQc = "Cal.com, Inc.", fQc = "support@cal.com", gQc = "Embedded booking pages right into your wordpress page", hQc = !0, vQc = !1, bQc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: sQc,
  slug: cQc,
  type: lQc,
  logo: dQc,
  url: uQc,
  variant: _Qc,
  categories: pQc,
  publisher: mQc,
  email: fQc,
  description: gQc,
  __createdUsingCli: hQc,
  isAuth: vQc
}, yQc = "https://json.schemastore.org/package.json", $Qc = "@calcom/zapier", wQc = "0.0.0", kQc = "./index.ts", SQc = "Workflow automation for everyone. Use the Cal.com Zapier app to trigger your workflows when a booking is created, rescheduled, or cancelled, or after a meeting ends.", xQc = {
  "@calcom/lib": "workspace:*",
  "node-schedule": "2.1.0"
}, EQc = {
  "@calcom/types": "workspace:*",
  "@types/node-schedule": "^2.1.0"
}, TQc = {
  $schema: yQc,
  private: !0,
  name: $Qc,
  version: wQc,
  main: kQc,
  description: SQc,
  dependencies: xQc,
  devDependencies: EQc
}, AQc = {
  name: "Zapier",
  description: TQc.description,
  installed: !0,
  category: "automation",
  categories: ["automation"],
  logo: "icon.svg",
  publisher: "Cal.com",
  slug: "zapier",
  title: "Zapier",
  type: "zapier_automation",
  url: "https://cal.com/apps/zapier",
  variant: "automation",
  email: "help@cal.com",
  dirName: "zapier",
  isOAuth: !1
}, CQc = "Zoho Bigin", zQc = "zoho-bigin", OQc = "zoho-bigin_crm", PQc = "zohobigin.svg", IQc = "https://github.com/ShaneMaglangit", RQc = "crm", NQc = [
  "crm"
], DQc = "EventType", MQc = "Shane Maglangit", LQc = "help@cal.com", qQc = "Bigin easily transforms your day-to-day customer processes into actionable pipelines. From qualifying leads to closing deals to managing important after-sales operations—Bigin connects your different teams to work together so that you can offer the best possible experience to your customers. Say goodbye to missing follow-ups, manual data entry, lack of team communication, and information silos.", jQc = !1, FQc = !0, VQc = "basic", BQc = "ZohoBigin.modules.events.ALL,ZohoBigin.modules.contacts.ALL", UQc = !0, WQc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: CQc,
  slug: zQc,
  type: OQc,
  logo: PQc,
  url: IQc,
  variant: RQc,
  categories: NQc,
  extendsFeature: DQc,
  publisher: MQc,
  email: LQc,
  description: qQc,
  isTemplate: jQc,
  __createdUsingCli: FQc,
  __template: VQc,
  scope: BQc,
  isOAuth: UQc
}, GQc = "Zoho Calendar", HQc = "Zoho Calendar is an online business calendar that makes scheduling easy for you. You can use it to stay on top of your schedule and also share calendars with your team to keep everyone on the same page.", KQc = "zohocalendar", YQc = "zoho_calendar", ZQc = "Zoho Calendar", QQc = "calendar", JQc = "calendar", XQc = [
  "calendar"
], eJc = "icon.svg", tJc = "Cal.com", nJc = "https://cal.com/", oJc = "help@cal.com", rJc = !0, iJc = {
  name: GQc,
  description: HQc,
  slug: KQc,
  type: YQc,
  title: ZQc,
  variant: QQc,
  category: JQc,
  categories: XQc,
  logo: eJc,
  publisher: tJc,
  url: nJc,
  email: oJc,
  isAuth: rJc
}, aJc = "ZohoCRM", sJc = "zohocrm", cJc = "zohocrm_crm", lJc = "icon.svg", dJc = "https://github.com/jatinsandilya", uJc = "crm", _Jc = [
  "crm"
], pJc = "EventType", mJc = "Jatin Sandilya", fJc = "help@cal.com", gJc = "Zoho CRM is a cloud-based application designed to help your salespeople sell smarter and faster by centralizing customer information, logging their interactions with your company, and automating many of the tasks salespeople do every day", hJc = !1, vJc = !0, bJc = "basic", yJc = !0, $Jc = {
  "/*": "Don't modify slug - If required, do it using cli edit command",
  name: aJc,
  slug: sJc,
  type: cJc,
  logo: lJc,
  url: dJc,
  variant: uJc,
  categories: _Jc,
  extendsFeature: pJc,
  publisher: mJc,
  email: fJc,
  description: gJc,
  isTemplate: hJc,
  __createdUsingCli: vJc,
  __template: bJc,
  isOAuth: yJc
}, wJc = "@calcom/zoomvideo", kJc = "0.0.0", SJc = "./index.ts", xJc = "Zoom is a secure and reliable video platform that supports all of your online communication needs. It can provide everything from one on one meetings, chat, phone, webinars, and large-scale online events. Available with both desktop, web, and mobile versions.", EJc = {
  "@calcom/lib": "workspace:*",
  "@calcom/prisma": "workspace:*"
}, TJc = {
  "@calcom/types": "workspace:*"
}, AJc = {
  private: !0,
  name: wJc,
  version: kJc,
  main: SJc,
  description: xJc,
  dependencies: EJc,
  devDependencies: TJc
}, xfe = {
  linkType: "dynamic",
  name: "Zoom Video",
  description: AJc.description,
  type: "zoom_video",
  categories: ["conferencing"],
  variant: "conferencing",
  logo: "icon.svg",
  publisher: "Cal.com",
  url: "https://zoom.us/",
  category: "conferencing",
  slug: "zoom",
  title: "Zoom Video",
  email: "help@cal.com",
  appData: {
    location: {
      default: !1,
      linkType: "dynamic",
      type: "integrations:zoom",
      label: "Zoom Video"
    }
  },
  dirName: "zoomvideo",
  isOAuth: !0
}, CJc = {
  alby: J4c,
  amie: p3c,
  applecalendar: w3c,
  attio: D3c,
  autocheckin: Z3c,
  "baa-for-hipaa": u6c,
  basecamp3: A6c,
  bolna: V6c,
  btcpayserver: o5c,
  caldavcalendar: _5c,
  campfire: Dme,
  chatbase: q5c,
  clic: X5c,
  closecom: fPc,
  cron: OPc,
  dailyvideo: Mme,
  deel: XPc,
  demodesk: Lme,
  dialpad: qme,
  discord: jme,
  dub: nRc,
  eightxeight: Fme,
  "element-call": Vme,
  elevenlabs: KRc,
  exchange2013calendar: nNc,
  exchange2016calendar: dNc,
  exchangecalendar: xNc,
  facetime: Bme,
  fathom: Ume,
  feishucalendar: lDc,
  "fonio-ai": kDc,
  framer: MDc,
  ga4: Wme,
  giphy: aMc,
  googlecalendar: fMc,
  googlevideo: Hme,
  granola: MMc,
  "greetmate-ai": QMc,
  gtm: Kme,
  hitpay: zLc,
  "horizon-workrooms": Yme,
  hubspot: XLc,
  huddle01video: Zme,
  "ics-feedcalendar": yqc,
  insihts: Qme,
  intercom: Qqc,
  jelly: Jme,
  jitsivideo: Xme,
  larkcalendar: T9c,
  lindy: F9c,
  linear: njc,
  make: bjc,
  matomo: efe,
  metapixel: tfe,
  "millis-ai": dFc,
  mirotalk: nfe,
  "mock-payment-app": VFc,
  monobot: n8c,
  n8n: f8c,
  nextcloudtalk: ofe,
  office365calendar: M8c,
  office365video: rfe,
  paypal: $7c,
  ping: ife,
  pipedream: K7c,
  "pipedrive-crm": dVc,
  plausible: afe,
  posthog: sfe,
  qr_code: XVc,
  raycast: _Bc,
  "retell-ai": EBc,
  riverside: cfe,
  roam: lfe,
  "routing-forms": hUc,
  salesforce: OUc,
  salesroom: dfe,
  sendgrid: rWc,
  shimmervideo: ufe,
  signal: _fe,
  sirius_video: pfe,
  skype: mfe,
  stripepayment: fGc,
  sylapsvideo: ffe,
  synthflow: BGc,
  tandemvideo: gfe,
  telegram: hfe,
  telli: wHc,
  basic: DHc,
  "booking-pages-tag": vfe,
  "event-type-app-card": dKc,
  "event-type-location-video-static": bfe,
  "general-app-settings": DKc,
  "link-as-an-app": YKc,
  twipla: yfe,
  umami: $fe,
  vimcal: qYc,
  vital: KYc,
  weather_in_your_calendar: sZc,
  webex: wfe,
  whatsapp: kfe,
  whereby: Sfe,
  wipemycalother: aQc,
  wordpress: bQc,
  zapier: AQc,
  "zoho-bigin": WQc,
  zohocalendar: iJc,
  zohocrm: $Jc,
  zoomvideo: xfe
};
function zJc(e, t) {
  const n = `${t.isTemplate ? "templates/" : ""}${t.dirName}`;
  let o = e;
  return !e.startsWith("/app-store/") && !/^https?/.test(e) && (o = `/app-store/${n}/${e}`), o;
}
const Efe = (e) => {
  const t = "dirName" in e ? e.dirName : e.slug;
  if (!t)
    throw new Error(`Couldn't derive dirName for app ${e.name}`);
  const n = {
    appData: null,
    dirName: t,
    __template: "",
    ...e
  };
  return n.logo = zJc(n.logo, {
    dirName: t,
    isTemplate: n.isTemplate
  }), n;
}, Tfe = {};
for (const [e, t] of Object.entries(CJc))
  Tfe[e] = Efe(t);
const Afe = typeof window < "u" ? navigator.userAgent.indexOf("Mac") != -1 : !1;
var Cfe = {};
const TE = Cfe.NEXT_PUBLIC_MINTLIFY_CHAT_API_KEY, AE = Cfe.NEXT_PUBLIC_CHAT_API_URL, OJc = async () => {
  if (!TE || !AE)
    return;
  const e = await fetch(`${AE}/topic`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${TE}`
    }
  });
  if (!e.ok)
    return;
  const t = await e.json();
  if (t && typeof t == "object" && "topicId" in t && typeof t.topicId == "string")
    return t.topicId;
}, PJc = async ({
  topicId: e,
  userQuery: t,
  onChunkReceived: n
}) => {
  if (!TE || !AE)
    return;
  const o = await fetch(
    `
${AE}/message`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TE}`
      },
      body: JSON.stringify({ message: t, topicId: e })
    }
  );
  if (!o.ok || !o.body)
    throw Error(o.statusText);
  const r = o.body.getReader();
  for (; ; ) {
    const { done: i, value: a } = await r.read();
    if (i) {
      const c = new TextDecoder().decode(a);
      n(c, o.headers.get("X-Mintlify-Base-Url") ?? "", !0);
      return;
    }
    const s = new TextDecoder().decode(a);
    n(s);
  }
}, IJc = async (e, t, n) => {
  let o = null, r = "";
  try {
    if (n || (o = await OJc()), !o)
      return {
        id: o,
        error: "Error creating topic. Please try again later"
      };
    await PJc({
      topicId: o,
      onChunkReceived: e,
      userQuery: t
    });
  } catch (i) {
    i instanceof Error ? r = i.message : r = "k_bar_ai_error";
  }
  return {
    id: o,
    error: r
  };
}, RJc = (e) => {
  if (!("metadata" in e && e.metadata && "title" in e.metadata && "link" in e && typeof e.link == "string"))
    return "";
  const t = e.metadata.title, n = zfe(e.link);
  if (t && typeof t == "string") {
    const o = t.toLowerCase().replaceAll(" ", "-").replaceAll(/[^a-zA-Z0-9-_#]/g, "");
    return `${n}#${o}`;
  }
  return n;
};
function NJc(e) {
  try {
    const t = JSON.parse(e ?? "[]"), n = new Map(
      t.map((o, r) => {
        const i = o.metadata.title ?? "", a = {
          citationNumber: r,
          title: o.metadata.title ?? "",
          url: RJc(o)
        };
        return [i, a];
      })
    );
    return Array.from(n.values());
  } catch {
    return [];
  }
}
function zfe(e) {
  return e.startsWith("/") ? e : `/${e}`;
}
function DJc(e, t) {
  if (t.startsWith("https://"))
    return t;
  const n = zfe(t);
  return `${e}${n}`;
}
var MJc = {};
const LJc = ({ searchText: e, aiResponse: t, setAiResponse: n }) => {
  const { t: o } = Fe(), [r, i] = ze(""), [a, s] = ze(MJc.NEXT_PUBLIC_DOCS_URL ?? ""), [c, l] = ze(!1), [d, u] = ze(""), _ = (g, h, b) => {
    n((v) => v + g), h && s(h), b && l(!1);
  }, p = NJc(t.split("||")[1]) ?? [], f = t.split("||")[0] ?? "";
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y(
      "div",
      {
        onClick: async () => {
          if (c)
            return;
          l(!0), n(""), u("");
          const { id: g, error: h } = await IJc(_, e, r);
          g ? i(g) : h && (l(!1), u(h));
        },
        className: ae(
          "hover:bg-subtle flex items-center gap-3 px-4 py-2 transition",
          c ? "cursor-not-allowed" : "cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(ot, { name: "star" }) }),
          /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ Y("div", { children: [
              o("can_you_tell_me_about"),
              " ",
              /* @__PURE__ */ m("span", { className: "font-bold", children: e })
            ] }),
            /* @__PURE__ */ m("div", { className: "text-subtle text-sm", children: o("use_ai_to_answer_your_questions") })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ Y("div", { className: "px-2 px-4 text-sm", children: [
      d && /* @__PURE__ */ m("p", { className: "mt-1 text-xs text-red-500", children: d }),
      c && t === "" ? /* @__PURE__ */ m(Tj, { children: /* @__PURE__ */ m(Jn, { className: "h-12 w-full" }) }) : /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("div", { dangerouslySetInnerHTML: { __html: gA(f) } }),
        /* @__PURE__ */ m("div", { className: "my-1 flex flex-wrap gap-2", children: a && p.map((g) => {
          if (g.title) {
            const h = DJc(a, g.url);
            return /* @__PURE__ */ m("a", { href: h, target: "_blank", children: /* @__PURE__ */ m("div", { className: "flex h-6 items-center gap-1 rounded-md bg-gray-100 px-1.5 text-xs text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700", children: g.title }) }, h);
          }
          return null;
        }) })
      ] })
    ] })
  ] });
};
var rZ = {};
const qJc = Object.values(Tfe).map(({ name: e, slug: t }) => ({
  id: t,
  name: e,
  section: "Installable Apps",
  keywords: `app ${e}`
})), jJc = () => {
  var r;
  const e = Ro.useRouter(), { data: t } = bo.viewer.eventTypes.getEventTypesFromGroup.useInfiniteQuery(
    {
      limit: 10,
      group: { teamId: null, parentId: null }
    },
    {
      refetchOnWindowFocus: !1,
      staleTime: 1 * 60 * 60 * 1e3,
      getNextPageParam: (i) => i.nextCursor
    }
  ), n = ((r = t == null ? void 0 : t.pages) == null ? void 0 : r.flatMap((i) => {
    var a;
    return ((a = i == null ? void 0 : i.eventTypes) == null ? void 0 : a.map((s) => ({
      id: `event-type-${s.id}`,
      name: s.title,
      section: "event_types_page_title",
      keywords: "event types",
      perform: () => e.push(`/event-types/${s.id}`)
    }))) ?? [];
  })) ?? [], o = n != null && n.length ? n : [];
  return Jd.useRegisterActions(o);
}, FJc = ({ children: e }) => {
  const t = Ro.useRouter(), n = Tt(() => {
    const o = qJc.map((r) => ({
      ...r,
      perform: () => t.push(`/apps/${r.id}`)
    }));
    return [
      {
        id: "workflows",
        name: "workflows",
        section: "workflows",
        shortcut: ["w", "f"],
        keywords: "workflows automation",
        perform: () => t.push("/workflows")
      },
      {
        id: "event-types",
        name: "event_types_page_title",
        section: "event_types_page_title",
        shortcut: ["e", "t"],
        keywords: "event types",
        perform: () => t.push("/event-types")
      },
      {
        id: "app-store",
        name: "app_store",
        section: "apps",
        shortcut: ["a", "s"],
        keywords: "app store",
        perform: () => t.push("/apps")
      },
      {
        id: "upcoming-bookings",
        name: "upcoming",
        section: "bookings",
        shortcut: ["u", "b"],
        keywords: "upcoming bookings",
        perform: () => t.push("/bookings/upcoming")
      },
      {
        id: "recurring-bookings",
        name: "recurring",
        section: "bookings",
        shortcut: ["r", "b"],
        keywords: "recurring bookings",
        perform: () => t.push("/bookings/recurring")
      },
      {
        id: "past-bookings",
        name: "past",
        section: "bookings",
        shortcut: ["p", "b"],
        keywords: "past bookings",
        perform: () => t.push("/bookings/past")
      },
      {
        id: "cancelled-bookings",
        name: "cancelled",
        section: "bookings",
        shortcut: ["c", "b"],
        keywords: "cancelled bookings",
        perform: () => t.push("/bookings/cancelled")
      },
      {
        id: "schedule",
        name: "availability",
        section: "availability",
        shortcut: ["s", "a"],
        keywords: "schedule availability",
        perform: () => t.push("/availability")
      },
      {
        id: "profile",
        name: "profile",
        section: "profile",
        shortcut: ["p", "s"],
        keywords: "setting profile",
        perform: () => t.push("/settings/my-account/profile")
      },
      {
        id: "avatar",
        name: "change_avatar",
        section: "profile",
        shortcut: ["c", "a"],
        keywords: "remove change modify avatar",
        perform: () => t.push("/settings/my-account/profile")
      },
      {
        id: "timezone",
        name: "timezone",
        section: "profile",
        shortcut: ["c", "t"],
        keywords: "change modify timezone",
        perform: () => t.push("/settings/my-account/general")
      },
      {
        id: "brand-color",
        name: "brand_color",
        section: "profile",
        shortcut: ["b", "c"],
        keywords: "change modify brand color",
        perform: () => t.push("/settings/my-account/appearance")
      },
      {
        id: "teams",
        name: "teams",
        shortcut: ["t", "s"],
        keywords: "add manage modify team",
        perform: () => t.push("/settings/teams")
      },
      {
        id: "password",
        name: "change_password",
        section: "security",
        shortcut: ["c", "p"],
        keywords: "change modify password",
        perform: () => t.push("/settings/security/password")
      },
      {
        id: "two-factor",
        name: "two_factor_auth",
        section: "security",
        shortcut: ["t", "f", "a"],
        keywords: "two factor authentication",
        perform: () => t.push("/settings/security/two-factor-auth")
      },
      {
        id: "impersonation",
        name: "user_impersonation_heading",
        section: "security",
        shortcut: ["u", "i"],
        keywords: "user impersonation",
        perform: () => t.push("/settings/security/impersonation")
      },
      {
        id: "license",
        name: "choose_a_license",
        section: "admin",
        shortcut: ["u", "l"],
        keywords: "license",
        perform: () => t.push("/auth/setup?step=1")
      },
      {
        id: "webhooks",
        name: "Webhooks",
        section: "developer",
        shortcut: ["w", "h"],
        keywords: "webhook automation",
        perform: () => t.push("/settings/developer/webhooks")
      },
      {
        id: "api-keys",
        name: "api_keys",
        section: "developer",
        shortcut: ["a", "p", "i"],
        keywords: "api keys",
        perform: () => t.push("/settings/developer/api-keys")
      },
      {
        id: "billing",
        name: "manage_billing",
        section: "billing",
        shortcut: ["m", "b"],
        keywords: "billing view manage",
        perform: () => t.push("/settings/billing")
      },
      ...o
    ];
  }, []);
  return /* @__PURE__ */ m(Jd.KBarProvider, { actions: n, children: e });
}, VJc = () => {
  const { t: e } = Fe();
  jJc();
  const [t, n] = ze(""), [o, r] = ze(""), i = rZ.NEXT_PUBLIC_MINTLIFY_CHAT_API_KEY && rZ.NEXT_PUBLIC_CHAT_API_URL;
  return /* @__PURE__ */ m(Jd.KBarPortal, { children: /* @__PURE__ */ Y(Jd.KBarPositioner, { className: "overflow-scroll", children: [
    /* @__PURE__ */ Y(Jd.KBarAnimator, { className: "bg-default z-10 w-full max-w-screen-sm overflow-hidden rounded-md shadow-lg", children: [
      /* @__PURE__ */ Y("div", { className: "border-subtle flex items-center justify-center border-b", children: [
        /* @__PURE__ */ m(ot, { name: "search", className: "text-default mx-3 h-4 w-4" }),
        /* @__PURE__ */ m(
          Jd.KBarSearch,
          {
            defaultPlaceholder: e("kbar_search_placeholder"),
            className: "bg-default placeholder:text-subtle text-default w-full rounded-sm py-2.5 focus-visible:outline-none",
            value: t,
            onChange: (a) => {
              n(a.currentTarget.value.trim()), o && r("");
            }
          }
        )
      ] }),
      i && t && /* @__PURE__ */ m(LJc, { aiResponse: o, setAiResponse: r, searchText: t }),
      /* @__PURE__ */ m(UJc, {}),
      /* @__PURE__ */ Y("div", { className: "text-subtle border-subtle hidden items-center space-x-1 border-t px-2 py-1.5 text-xs sm:flex", children: [
        /* @__PURE__ */ m(ot, { name: "arrow-up", className: "h-4 w-4" }),
        /* @__PURE__ */ m(ot, { name: "arrow-down", className: "h-4 w-4" }),
        " ",
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("navigate") }),
        /* @__PURE__ */ m(ot, { name: "corner-down-left", className: "h-4 w-4" }),
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("open") }),
        Afe ? /* @__PURE__ */ m(ot, { name: "command", className: "h-3 w-3" }) : "CTRL",
        /* @__PURE__ */ m("span", { className: "pr-1", children: "+ K " }),
        /* @__PURE__ */ m("span", { className: "pr-2", children: e("close") })
      ] })
    ] }),
    /* @__PURE__ */ m("div", { className: "z-1 fixed inset-0 bg-neutral-800 bg-opacity-70" })
  ] }) });
}, Ij = () => {
  const { query: e } = Jd.useKBar();
  return e ? /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(Ao, { side: "right", content: Afe ? "⌘ + K" : "CTRL + K", children: /* @__PURE__ */ m(
    "button",
    {
      color: "minimal",
      onClick: e.toggle,
      className: "text-default hover:bg-subtle todesktop:hover:!bg-transparent lg:hover:bg-emphasis lg:hover:text-emphasis group flex rounded-md px-3 py-2 text-sm font-medium transition lg:px-2",
      children: /* @__PURE__ */ m(ot, { name: "search", className: "h-4 w-4 flex-shrink-0 text-inherit" })
    }
  ) }) }) : null;
}, BJc = (e) => {
  const t = e.shortcuts;
  return /* @__PURE__ */ m("span", { className: "space-x-1", children: t == null ? void 0 : t.map((n) => /* @__PURE__ */ m(
    "kbd",
    {
      className: "bg-default hover:bg-subtle text-emphasis rounded-sm border px-2 py-1 transition",
      children: n
    },
    n
  )) });
};
function UJc() {
  const { results: e } = Jd.useMatches(), { t } = Fe();
  return /* @__PURE__ */ m(
    Jd.KBarResults,
    {
      items: e,
      onRender: ({ item: n, active: o }) => typeof n == "string" ? /* @__PURE__ */ m("div", { className: "bg-default text-emphasis p-4 text-xs font-bold uppercase", children: t(n) }) : /* @__PURE__ */ Y(
        "div",
        {
          style: {
            background: o ? "var(--cal-bg-subtle)" : "var(--cal-bg-default)",
            borderLeft: o ? "2px solid var(--cal-border)" : "2px solid transparent",
            color: "var(--cal-text)"
          },
          className: "flex items-center justify-between px-4 py-2.5 text-sm transition hover:cursor-pointer",
          children: [
            /* @__PURE__ */ m("span", { children: t(n.name) }),
            /* @__PURE__ */ m(BJc, { shortcuts: n.shortcut })
          ]
        }
      )
    }
  );
}
var wie;
(wie = De.tz.guess()) == null || wie.indexOf("Europe");
const Kf = De.tz.guess() !== "Etc/Unknown" ? De.tz.guess() : "Europe/London";
function Ofe(e, t) {
  document.cookie = `calcom-timezone-dialog=1;max-age=${De().add(e[0], e[1]).unix() - De().unix()}`, t && nr(t, "success");
}
const WJc = () => {
  const { t: e, isLocaleReady: t } = Fe();
  if (!t)
    return null;
  const n = bo.useUtils(), o = Kf.replace("_", " "), r = async () => {
    nr(
      e("updated_timezone_to", { formattedCurrentTz: o, interpolation: { escapeValue: !1 } }),
      "success"
    ), await n.viewer.me.invalidate();
  }, i = () => {
    nr(e("couldnt_update_timezone"), "error");
  }, a = bo.viewer.me.updateProfile.useMutation({
    onSuccess: r,
    onError: i
  }), s = () => {
    a.mutate({
      timeZone: Kf
    });
  };
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      zv,
      {
        title: e("update_timezone_question"),
        subtitle: e("update_timezone_description", {
          formattedCurrentTz: o,
          interpolation: { escapeValue: !1 }
        })
      }
    ),
    /* @__PURE__ */ m("div", { className: "mb-8" }),
    /* @__PURE__ */ Y(Fc, { showDivider: !0, children: [
      /* @__PURE__ */ m(ca, { onClick: () => Ofe([3, "months"], e("we_wont_show_again")), color: "secondary", children: e("dont_update") }),
      /* @__PURE__ */ m(ca, { onClick: () => s(), color: "primary", children: e("update_timezone") })
    ] })
  ] });
};
function GJc() {
  var i;
  const { data: e } = bo.viewer.me.get.useQuery(), [t, n] = ze(!1), { data: o, status: r } = sc.useSession();
  return Le(() => {
    var a;
    !(e != null && e.timeZone) || r !== "authenticated" || (a = o == null ? void 0 : o.user) != null && a.impersonatedBy || De.tz(void 0, Kf).utcOffset() !== De.tz(void 0, e.timeZone).utcOffset() && n(!0);
  }, [e == null ? void 0 : e.timeZone, r, (i = o == null ? void 0 : o.user) == null ? void 0 : i.impersonatedBy]), { open: t, setOpen: n };
}
function HJc() {
  const { open: e, setOpen: t } = GJc(), { t: n } = Fe();
  return /* @__PURE__ */ m(Gi, { open: e, onOpenChange: t, children: /* @__PURE__ */ m(Ei, { type: "creation", onInteractOutside: () => {
    Ofe([1, "day"], n("we_wont_show_again"));
  }, children: /* @__PURE__ */ m(WJc, {}) }) });
}
function KJc() {
  const [e, t] = ze(!1);
  return Le(() => {
    typeof window < "u" && document && (document.cookie.split(";").find((o) => o.trim().startsWith("calcom-timezone-dialog")) || t(!0));
  }, []), e ? /* @__PURE__ */ m(HJc, {}) : null;
}
class YJc extends ve.Component {
  constructor(t) {
    super(t), this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(t, n) {
    this.setState({ error: t, errorInfo: n });
  }
  render() {
    return this.state.error !== null && "digest" in this.state.error && this.state.error.digest === "NEXT_NOT_FOUND" ? this.props.children : this.state.errorInfo ? /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("h2", { children: this.props.message || "Something went wrong." }),
      /* @__PURE__ */ m("details", { style: { whiteSpace: "pre-wrap" }, children: this.state.error && this.state.error.toString() })
    ] }) : this.props.children;
  }
}
const Pfe = YJc, wo = {
  getItem(e) {
    try {
      return window.localStorage.getItem(e);
    } catch {
      return null;
    }
  },
  setItem(e, t) {
    try {
      window.localStorage.setItem(e, t);
    } catch {
      return;
    }
  },
  removeItem: (e) => {
    try {
      window.localStorage.removeItem(e);
    } catch {
      return;
    }
  }
}, iZ = {
  getItem(e) {
    try {
      return window.sessionStorage.getItem(e);
    } catch {
      return null;
    }
  },
  setItem(e, t) {
    try {
      window.sessionStorage.setItem(e, t);
    } catch {
      return;
    }
  },
  removeItem: (e) => {
    try {
      window.sessionStorage.removeItem(e);
    } catch {
      return;
    }
  }
};
function ZJc() {
  const { t: e } = Fe(), t = Ro.usePathname(), [n, o] = ze(() => typeof window > "u" ? !0 : !wo.getItem("calai-banner-dismissed")), r = () => {
    wo.setItem("calai-banner-dismissed", "true"), o(!1);
  }, i = () => {
    window.open("/workflow/new?action=calAi&templateWorkflowId=wf-11", "_blank");
  };
  return !n || !(t === "/workflows" || t === "/event-types" || t === "/bookings/upcoming") ? null : /* @__PURE__ */ Y("div", { className: "bg-launch-dark relative mb-6 w-full overflow-hidden rounded-lg text-white", children: [
    /* @__PURE__ */ m(
      "button",
      {
        onClick: r,
        className: "absolute right-2 top-2 z-10 rounded-[10px] p-2",
        "aria-label": "Close banner",
        children: /* @__PURE__ */ m(ot, { name: "x", className: "h-4 w-4 text-white" })
      }
    ),
    /* @__PURE__ */ Y("div", { className: "flex flex-col md:flex-row", children: [
      /* @__PURE__ */ Y("div", { className: "flex-1 p-6 pr-6 lg:p-8", children: [
        /* @__PURE__ */ m("h2", { className: "font-cal font-subtle text-lg", children: e("supercharge_your_workflows_with_cal_ai") }),
        /* @__PURE__ */ m("p", { className: "text-subtle mb-4 text-sm", children: e("supercharge_your_workflows_with_cal_ai_description") }),
        /* @__PURE__ */ m(
          "button",
          {
            onClick: i,
            className: "rounded-[10px] bg-gradient-to-b from-[#6349EA] to-[#875FE0] px-5 py-2 text-sm font-medium text-white hover:from-[#5A42D1] hover:to-[#7B6FD7]",
            children: e("try_now")
          }
        )
      ] }),
      /* @__PURE__ */ m("img", { src: "/cal-ai-banner.svg", alt: "Cal.ai Banner", className: "mt-auto hidden h-40 md:block" })
    ] })
  ] });
}
var aZ = {};
DA.getSubLogger({
  prefix: ["orgDomains.ts"]
});
function QJc() {
  var t;
  if (!AS && aZ.LOCAL_TESTING_DOMAIN_VERCEL)
    return aZ.LOCAL_TESTING_DOMAIN_VERCEL;
  const e = (t = Si.replace("https://", "")) == null ? void 0 : t.replace("http://", "").split(".");
  return e.length === 3 ? e.slice(1).join(".") : e.join(".");
}
function JJc(e, t = { protocol: !0 }) {
  return e ? `${t.protocol ? `${new URL(C$).protocol}//` : ""}${e}.${QJc()}` : t.protocol ? C$ : C$.replace("https://", "").replace("http://", "");
}
const qv = (e, t) => JJc(e ?? "", t);
function GA(e, t) {
  return e || `https://eu.ui-avatars.com/api/?background=fff&color=f9f9f9&bold=true&background=000000&name=${encodeURIComponent(
    t || ""
  )}`;
}
function XJc(e, t = []) {
  let n = [];
  function o(i, a) {
    const s = $e.createContext(a), c = n.length;
    n = [...n, a];
    const l = (u) => {
      var b;
      const { scope: _, children: p, ...f } = u, g = ((b = _ == null ? void 0 : _[e]) == null ? void 0 : b[c]) || s, h = $e.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ m(g.Provider, { value: h, children: p });
    };
    l.displayName = i + "Provider";
    function d(u, _) {
      var g;
      const p = ((g = _ == null ? void 0 : _[e]) == null ? void 0 : g[c]) || s, f = $e.useContext(p);
      if (f)
        return f;
      if (a !== void 0)
        return a;
      throw new Error(`\`${u}\` must be used within \`${i}\``);
    }
    return [l, d];
  }
  const r = () => {
    const i = n.map((a) => $e.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || i;
      return $e.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [o, eXc(r, ...t)];
}
function eXc(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(i) {
      const a = o.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(i)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return $e.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function tXc(e) {
  const t = $e.useRef(e);
  return $e.useEffect(() => {
    t.current = e;
  }), $e.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function sZ(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function nXc(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const i = sZ(r, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const i = o[r];
          typeof i == "function" ? i() : sZ(e[r], null);
        }
      };
  };
}
var Ife = $e.forwardRef((e, t) => {
  const { children: n, ...o } = e, r = $e.Children.toArray(n), i = r.find(rXc);
  if (i) {
    const a = i.props.children, s = r.map((c) => c === i ? $e.Children.count(a) > 1 ? $e.Children.only(null) : $e.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ m(FM, { ...o, ref: t, children: $e.isValidElement(a) ? $e.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ m(FM, { ...o, ref: t, children: n });
});
Ife.displayName = "Slot";
var FM = $e.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if ($e.isValidElement(n)) {
    const r = aXc(n), i = iXc(o, n.props);
    return n.type !== $e.Fragment && (i.ref = t ? nXc(t, r) : r), $e.cloneElement(n, i);
  }
  return $e.Children.count(n) > 1 ? $e.Children.only(null) : null;
});
FM.displayName = "SlotClone";
var oXc = ({ children: e }) => /* @__PURE__ */ m(Ce, { children: e });
function rXc(e) {
  return $e.isValidElement(e) && e.type === oXc;
}
function iXc(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      i(...s), r(...s);
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function aXc(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var sXc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Rj = sXc.reduce((e, t) => {
  const n = $e.forwardRef((o, r) => {
    const { asChild: i, ...a } = o, s = i ? Ife : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(s, { ...a, ref: r });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Nj = "Avatar", [cXc, cfd] = XJc(Nj), [lXc, Rfe] = cXc(Nj), Nfe = $e.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...o } = e, [r, i] = $e.useState("idle");
    return /* @__PURE__ */ m(
      lXc,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ m(Rj.span, { ...o, ref: t })
      }
    );
  }
);
Nfe.displayName = Nj;
var Dfe = "AvatarImage", Mfe = $e.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: o, onLoadingStatusChange: r = () => {
    }, ...i } = e, a = Rfe(Dfe, n), s = dXc(o, i.referrerPolicy), c = tXc((l) => {
      r(l), a.onImageLoadingStatusChange(l);
    });
    return aj(() => {
      s !== "idle" && c(s);
    }, [s, c]), s === "loaded" ? /* @__PURE__ */ m(Rj.img, { ...i, ref: t, src: o }) : null;
  }
);
Mfe.displayName = Dfe;
var Lfe = "AvatarFallback", qfe = $e.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: o, ...r } = e, i = Rfe(Lfe, n), [a, s] = $e.useState(o === void 0);
    return $e.useEffect(() => {
      if (o !== void 0) {
        const c = window.setTimeout(() => s(!0), o);
        return () => window.clearTimeout(c);
      }
    }, [o]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ m(Rj.span, { ...r, ref: t }) : null;
  }
);
qfe.displayName = Lfe;
function dXc(e, t) {
  const [n, o] = $e.useState("idle");
  return aj(() => {
    if (!e) {
      o("error");
      return;
    }
    let r = !0;
    const i = new window.Image(), a = (s) => () => {
      r && o(s);
    };
    return o("loading"), i.onload = a("loaded"), i.onerror = a("error"), i.src = e, t && (i.referrerPolicy = t), () => {
      r = !1;
    };
  }, [e, t]), n;
}
var uXc = Nfe, _Xc = Mfe, pXc = qfe;
const mXc = Yv(
  "bg-emphasis border-default relative inline-flex aspect-square items-center justify-center border align-top",
  {
    variants: {
      size: {
        xs: "w-4 h-4 min-w-4 min-h-4 max-h-4",
        // 16px
        xsm: "w-5 h-5 min-w-5 min-h-5",
        // 20px
        sm: "w-6 h-6 min-w-6 min-h-6",
        // 24px
        md: "w-8 h-8 min-w-8 min-h-8",
        // 32px
        mdLg: "w-10 h-10 min-w-10 min-h-10",
        // 40px
        lg: "w-16 h-16 min-w-16 min-h-16",
        // 64px
        xl: "w-24 h-24 min-w-24 min-h-24"
        // 96px
      },
      shape: {
        circle: "rounded-full",
        square: ""
      }
    },
    defaultVariants: {
      size: "md",
      shape: "circle"
    },
    compoundVariants: [
      {
        size: ["xs", "xsm", "sm"],
        shape: "square",
        className: "rounded"
      },
      {
        size: ["md"],
        shape: "square",
        className: "rounded-md"
      },
      {
        size: ["mdLg", "lg", "xl"],
        shape: "square",
        className: "rounded-[10px]"
      }
    ]
  }
);
function wl(e) {
  const { imageSrc: t, size: n = "md", alt: o, title: r, href: i, indicator: a } = e, s = mXc({ size: n, shape: e.shape }), c = ae("aspect-square rounded-full", s);
  let l = /* @__PURE__ */ m(
    uXc,
    {
      "data-testid": e == null ? void 0 : e["data-testid"],
      className: ae(
        s,
        a ? "overflow-visible" : "overflow-hidden",
        e.className
      ),
      children: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(
          _Xc,
          {
            src: t ?? void 0,
            alt: o,
            className: ae("aspect-square", s)
          }
        ),
        /* @__PURE__ */ m(
          pXc,
          {
            delayMs: 600,
            asChild: e.asChild,
            className: "flex h-full items-center justify-center",
            children: /* @__PURE__ */ m(Ce, { children: e.fallback ? e.fallback : /* @__PURE__ */ m("img", { src: Gce, alt: o, className: c }) })
          }
        ),
        a
      ] })
    }
  );
  return i && (l = /* @__PURE__ */ m(Po, { "data-testid": "avatar-href", href: i, children: l })), r ? /* @__PURE__ */ m(wOe, { children: /* @__PURE__ */ m(Ao, { content: r, children: l }) }) : /* @__PURE__ */ m(Ce, { children: l });
}
const jfe = (e) => e != null && e.avatarUrl ? G.string().url().safeParse(e.avatarUrl).success ? e.avatarUrl : ZW + e.avatarUrl : ZW + Gce, Ffe = function(t) {
  const n = t.items.length, o = t.truncateAfter || 4, r = t.items.filter((a) => a.image).slice(0, o), i = n - r.length;
  return r.length ? /* @__PURE__ */ Y("ul", { className: ae("flex items-center", t.className), children: [
    r.map((a, s) => /* @__PURE__ */ m("li", { className: "-mr-1 inline-block", children: /* @__PURE__ */ m(
      wl,
      {
        "data-testid": "avatar",
        className: "border-subtle",
        imageSrc: a.image,
        title: a.title,
        alt: a.alt || "",
        size: t.size,
        href: a.href
      }
    ) }, s)),
    i > 0 && /* @__PURE__ */ m(
      "li",
      {
        className: ae(
          "bg-inverted relative -mr-1 inline-flex justify-center  overflow-hidden rounded-full",
          t.size === "sm" ? "min-w-6 h-6" : "min-w-16 h-16"
        ),
        children: /* @__PURE__ */ Y(
          "span",
          {
            className: ae(
              " text-inverted m-auto flex h-full w-full items-center justify-center text-center",
              t.size === "sm" ? "text-[12px]" : "text-2xl"
            ),
            children: [
              "+",
              t.hideTruncatedAvatarsCount ? null : i
            ]
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ m(Ce, {});
};
function fXc(e) {
  const { users: t, organization: n, disableHref: o = !1, ...r } = e, a = [
    {
      // We don't want booker to be able to see the list of other users or teams inside the embed
      href: fu() || o ? null : qv(n.slug),
      image: GA(n.logoUrl, n.name),
      alt: n.name || void 0,
      title: n.name
    }
  ].concat(
    t.map((s) => ({
      href: o ? null : `${s.bookerUrl}/${s.username}?redirect=false`,
      image: jfe(s),
      alt: s.name || void 0,
      title: s.name || s.username || ""
    }))
  );
  return /* @__PURE__ */ m(Ffe, { ...r, items: a });
}
const CE = "", cZ = CE ? `-${CE.slice(0, 7)}` : "", gXc = `v.${Kce}-${dg ? "sh" : "h"}`;
function hXc() {
  const [e, t] = ze(!1);
  return Le(() => {
    t(!0);
  }, []), /* @__PURE__ */ Y("small", { className: "text-default mx-3 mb-2 mt-1 hidden text-[0.5rem] opacity-50 lg:block", children: [
    "© ",
    (/* @__PURE__ */ new Date()).getFullYear(),
    " ",
    /* @__PURE__ */ m(Po, { href: "https://go.cal.com/credits", target: "_blank", className: "hover:underline", children: jmc }),
    " ",
    e && /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ m(Po, { href: "https://go.cal.com/releases", target: "_blank", className: "hover:underline", children: gXc }),
      CE && Uce ? /* @__PURE__ */ m(
        Po,
        {
          href: `https://github.com/calcom/cal.com/commit/${CE}`,
          target: "_blank",
          className: "hover:underline",
          children: cZ
        }
      ) : cZ
    ] })
  ] });
}
function Vfe({
  small: e,
  icon: t,
  inline: n = !0,
  className: o,
  src: r = "/api/logo"
}) {
  return /* @__PURE__ */ m("h3", { className: ae("logo", n && "inline", o), children: /* @__PURE__ */ m("strong", { children: t ? /* @__PURE__ */ m("img", { className: "mx-auto w-9 dark:invert", alt: "Cal", title: "Cal", src: `${r}?type=icon` }) : /* @__PURE__ */ m(
    "img",
    {
      className: ae(e ? "h-4 w-auto" : "h-5 w-auto", "dark:invert"),
      alt: "Cal",
      title: "Cal",
      src: r
    }
  ) }) });
}
function vXc() {
  const { t: e } = Fe(), { data: t } = bo.viewer.me.bookingUnconfirmedCount.useQuery();
  return t ? /* @__PURE__ */ m(Po, { href: "/bookings/unconfirmed", children: /* @__PURE__ */ m(
    Nr,
    {
      rounded: !0,
      title: e("unconfirmed_bookings_tooltip"),
      variant: "orange",
      className: "cursor-pointer hover:bg-orange-800 hover:text-orange-100",
      children: t
    }
  ) }) : null;
}
const bXc = No(null);
function Bfe() {
  const e = Pn(bXc);
  if (!e)
    throw new Error("Error: useOrgBranding was used outside of OrgBrandingProvider.");
  return e.orgBrand;
}
function yXc() {
  const { isPending: e, listInvites: t } = j1c(), { t: n } = Fe();
  return e || !t || t.length === 0 ? null : /* @__PURE__ */ m(Nr, { variant: "default", children: n("invite_team_notifcation_badge") });
}
const $Xc = (e) => {
  const [t, n] = ze(!1);
  return Le(() => {
    const o = window.matchMedia(e);
    o.matches !== t && n(o.matches);
    const r = () => n(o.matches);
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [t, e]), t;
}, zE = $Xc, wXc = (e, t) => e in t;
function Ufe(e) {
  const t = zj();
  return wXc(e.name, t) ? t[e.name] : !0;
}
const kXc = (e) => {
  const [t, n] = ze(!1);
  return Le(() => {
    const r = iZ.getItem(`nav-expansion-${e}`);
    r !== null && n(JSON.parse(r));
  }, [e]), [t, (r) => {
    n(r), iZ.setItem(`nav-expansion-${e}`, JSON.stringify(r));
  }];
}, SXc = () => {
  const e = Ro.usePathname(), t = Ro.useSearchParams(), n = Ue(null);
  return Le(() => {
    n.current = e;
  }, [e]), (r) => {
    if (r.preserveQueryParams && r.preserveQueryParams({ prevPathname: n.current, nextPathname: r.href })) {
      const i = t.toString();
      return i ? `${r.href}?${i}` : r.href;
    }
    return r.href;
  };
}, VM = ({ isChild: e, item: t, pathname: n }) => e ? t.href === n : t.href ? (n == null ? void 0 : n.startsWith(t.href)) ?? !1 : !1, Wfe = (e) => {
  var k, S;
  const { item: t, isChild: n } = e, { t: o, isLocaleReady: r } = Fe(), i = Ro.usePathname(), a = t.isCurrent || VM, s = a({ isChild: !!n, item: t, pathname: i }), c = Ufe(e.item), [l, d] = kXc(t.name), u = SXc(), _ = zE("(max-width: 1024px)"), [p, f] = ze(!1);
  if (!c)
    return null;
  const g = t.child && t.child.length > 0, h = g && ((k = t.child) == null ? void 0 : k.some((O) => a({ isChild: !0, item: O, pathname: i }))), b = l || h || a({ pathname: i, isChild: n, item: t }), v = g && !h;
  return /* @__PURE__ */ Y(Oi, { children: [
    g && !n ? /* @__PURE__ */ m(
      Ao,
      {
        side: "right",
        open: p,
        content: g ? /* @__PURE__ */ Y("div", { className: "pointer-events-auto flex flex-col space-y-1 p-1", children: [
          /* @__PURE__ */ m("span", { className: "text-subtle px-2 text-xs font-semibold uppercase tracking-wide", children: o(t.name) }),
          /* @__PURE__ */ m("div", { className: "flex flex-col", children: (S = t.child) == null ? void 0 : S.map((O) => {
            const I = typeof O.isCurrent == "function" ? O.isCurrent({ isChild: !0, item: O, pathname: i }) : VM({ isChild: !0, item: O, pathname: i });
            return /* @__PURE__ */ m(
              Po,
              {
                href: u(O),
                "aria-current": I ? "page" : void 0,
                onClick: () => f(!1),
                className: ae(
                  "group relative block rounded-md px-3 py-1 text-sm font-medium",
                  I ? "bg-emphasis text-white" : "hover:bg-emphasis text-mute hover:text-emphasis"
                ),
                children: o(O.name)
              },
              O.name
            );
          }) })
        ] }) : o(t.name),
        className: "lg:hidden",
        children: /* @__PURE__ */ Y(
          "button",
          {
            "data-test-id": t.name,
            "aria-label": o(t.name),
            "aria-expanded": l,
            "aria-current": s ? "page" : void 0,
            onClick: () => {
              d(!l), _ && g && f(!p);
            },
            className: ae(
              "todesktop:py-[7px] text-default group flex w-full items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
              "[&[aria-current='page']]:!bg-transparent",
              "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm",
              r ? "hover:bg-subtle todesktop:[&[aria-current='page']]:bg-emphasis todesktop:hover:bg-transparent hover:text-emphasis" : ""
            ),
            children: [
              t.icon && /* @__PURE__ */ m(
                ot,
                {
                  name: t.isLoading ? "rotate-cw" : t.icon,
                  className: ae(
                    "todesktop:!text-blue-500 mr-2 h-4 w-4 flex-shrink-0 rtl:ml-2 md:ltr:mx-auto lg:ltr:mr-2",
                    t.isLoading && "animate-spin"
                  ),
                  "aria-hidden": "true"
                }
              ),
              r ? /* @__PURE__ */ Y(
                "span",
                {
                  className: "hidden w-full justify-between truncate text-ellipsis lg:flex",
                  "data-testid": `${t.name}-test`,
                  children: [
                    o(t.name),
                    t.badge && t.badge
                  ]
                }
              ) : /* @__PURE__ */ m(Jn, { className: "h-[20px] w-full" }),
              v && /* @__PURE__ */ m(ot, { name: l ? "chevron-up" : "chevron-down", className: "ml-auto h-4 w-4" })
            ]
          }
        )
      }
    ) : /* @__PURE__ */ m(Ao, { side: "right", content: o(t.name), className: "lg:hidden", children: /* @__PURE__ */ Y(
      Po,
      {
        "data-test-id": t.name,
        href: n ? u(t) : t.href,
        "aria-label": o(t.name),
        target: t.target,
        className: ae(
          "todesktop:py-[7px] text-default group flex items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
          t.child ? "[&[aria-current='page']]:!bg-transparent" : "[&[aria-current='page']]:bg-emphasis",
          n ? `[&[aria-current='page']]:text-emphasis [&[aria-current='page']]:bg-emphasis hidden h-8 pl-16 lg:flex lg:pl-11 ${e.index === 0 ? "mt-0" : "mt-px"}` : "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm",
          r ? "hover:bg-subtle todesktop:[&[aria-current='page']]:bg-emphasis todesktop:hover:bg-transparent hover:text-emphasis" : ""
        ),
        "aria-current": s ? "page" : void 0,
        children: [
          t.icon && /* @__PURE__ */ m(
            ot,
            {
              name: t.isLoading ? "rotate-cw" : t.icon,
              className: ae(
                "todesktop:!text-blue-500 mr-2 h-4 w-4 flex-shrink-0 rtl:ml-2 md:ltr:mx-auto lg:ltr:mr-2 [&[aria-current='page']]:text-inherit",
                t.isLoading && "animate-spin"
              ),
              "aria-hidden": "true",
              "aria-current": s ? "page" : void 0
            }
          ),
          r ? /* @__PURE__ */ Y(
            "span",
            {
              className: "hidden w-full justify-between truncate text-ellipsis lg:flex",
              "data-testid": `${t.name}-test`,
              children: [
                o(t.name),
                t.badge && t.badge
              ]
            }
          ) : /* @__PURE__ */ m(Jn, { className: "h-[20px] w-full" }),
          t.name === "workflows" && /* @__PURE__ */ m(Nr, { startIcon: "sparkles", variant: "purple", children: "Cal.ai" })
        ]
      }
    ) }),
    t.child && b && t.child.map((O, I) => /* @__PURE__ */ m(Wfe, { index: I, item: O, isChild: !0 }, O.name))
  ] });
}, xXc = (e) => {
  const { item: t, isChild: n } = e, o = Ro.usePathname(), { t: r, isLocaleReady: i } = Fe(), s = (t.isCurrent || VM)({ isChild: !!n, item: t, pathname: o });
  return Ufe(e.item) ? /* @__PURE__ */ Y(
    Po,
    {
      href: t.href,
      target: t.target,
      className: "[&[aria-current='page']]:text-emphasis hover:text-default text-muted relative my-2 min-w-0 flex-1 overflow-hidden rounded-md !bg-transparent p-1 text-center text-xs font-medium focus:z-10 sm:text-sm",
      "aria-current": s ? "page" : void 0,
      children: [
        t.badge && /* @__PURE__ */ m("div", { className: "absolute right-1 top-1", children: t.badge }),
        t.icon && /* @__PURE__ */ m(
          ot,
          {
            name: t.icon,
            className: "[&[aria-current='page']]:text-emphasis  mx-auto mb-1 block h-5 w-5 flex-shrink-0 text-center text-inherit",
            "aria-hidden": "true",
            "aria-current": s ? "page" : void 0
          }
        ),
        i ? /* @__PURE__ */ m("span", { className: "block truncate", children: r(t.name) }) : /* @__PURE__ */ m(Jn, {})
      ]
    },
    t.name
  ) : null;
}, j$ = "more", Gy = ({
  prevPathname: e,
  nextPathname: t
}) => !!(e != null && e.startsWith("/bookings/")) && t.startsWith("/bookings/"), EXc = (e) => [
  {
    name: "event_types_page_title",
    href: "/event-types",
    icon: "link"
  },
  {
    name: "bookings",
    href: "/bookings/upcoming",
    icon: "calendar",
    badge: /* @__PURE__ */ m(vXc, {}),
    isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/bookings")) ?? !1,
    child: [
      {
        name: "upcoming",
        href: "/bookings/upcoming",
        preserveQueryParams: Gy,
        isCurrent: ({ pathname: t }) => t === "/bookings/upcoming"
      },
      {
        name: "unconfirmed",
        href: "/bookings/unconfirmed",
        preserveQueryParams: Gy,
        isCurrent: ({ pathname: t }) => t === "/bookings/unconfirmed"
      },
      {
        name: "recurring",
        href: "/bookings/recurring",
        preserveQueryParams: Gy,
        isCurrent: ({ pathname: t }) => t === "/bookings/recurring"
      },
      {
        name: "past",
        href: "/bookings/past",
        preserveQueryParams: Gy,
        isCurrent: ({ pathname: t }) => t === "/bookings/past"
      },
      {
        name: "cancelled",
        href: "/bookings/cancelled",
        preserveQueryParams: Gy,
        isCurrent: ({ pathname: t }) => t === "/bookings/cancelled"
      }
    ]
  },
  {
    name: "availability",
    href: "/availability",
    icon: "clock"
  },
  ...e ? [
    {
      name: "members",
      href: `/settings/organizations/${e.slug}/members`,
      icon: "building",
      moreOnMobile: !0
    }
  ] : [],
  {
    name: "teams",
    href: "/teams",
    icon: "users",
    badge: /* @__PURE__ */ m(yXc, {}),
    moreOnMobile: !0
  },
  {
    name: "apps",
    href: "/apps",
    icon: "grid-3x3",
    moreOnMobile: !0,
    isCurrent: ({ pathname: t, item: n }) => ((t == null ? void 0 : t.startsWith(n.href)) ?? !1) && !((t == null ? void 0 : t.includes("routing-forms/")) ?? !1),
    child: [
      {
        name: "app_store",
        href: "/apps",
        isCurrent: ({ pathname: t, item: n }) => ((t == null ? void 0 : t.startsWith(n.href)) ?? !1) && !((t == null ? void 0 : t.includes("routing-forms/")) ?? !1) && !((t == null ? void 0 : t.includes("/installed")) ?? !1)
      },
      {
        name: "installed_apps",
        href: "/apps/installed/calendar",
        isCurrent: ({ pathname: t }) => ((t == null ? void 0 : t.startsWith("/apps/installed/")) ?? !1) || ((t == null ? void 0 : t.startsWith("/v2/apps/installed/")) ?? !1)
      }
    ]
  },
  {
    name: j$,
    href: "/more",
    icon: "ellipsis"
  },
  {
    name: "routing",
    href: "/routing",
    icon: "split",
    isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/routing")) ?? !1,
    moreOnMobile: !0
  },
  {
    name: "workflows",
    href: "/workflows",
    icon: "zap",
    moreOnMobile: !0
  },
  {
    name: "insights",
    href: "/insights",
    icon: "chart-bar",
    isCurrent: ({ pathname: t, item: n }) => (t == null ? void 0 : t.startsWith(n.href)) ?? !1,
    moreOnMobile: !0,
    child: [
      {
        name: "bookings",
        href: "/insights",
        isCurrent: ({ pathname: t }) => t === "/insights"
      },
      {
        name: "routing",
        href: "/insights/routing",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/routing")) ?? !1
      },
      {
        name: "router_position",
        href: "/insights/router-position",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/router-position")) ?? !1
      },
      {
        name: "call_history",
        href: "/insights/call-history",
        // icon: "phone",
        isCurrent: ({ pathname: t }) => (t == null ? void 0 : t.startsWith("/insights/call-history")) ?? !1
      }
    ]
  }
], TXc = [
  {
    name: "Dashboard",
    href: "/settings/platform/",
    icon: "layout-dashboard"
  },
  {
    name: "Documentation",
    href: "https://docs.cal.com/docs/platform",
    icon: "chart-bar",
    target: "_blank"
  },
  {
    name: "API reference",
    href: "https://api.cal.com/v2/docs#/",
    icon: "terminal",
    target: "_blank"
  },
  {
    name: "Atoms",
    href: "https://docs.cal.com/docs/platform#atoms",
    icon: "atom",
    target: "_blank"
  },
  {
    name: j$,
    href: "https://docs.cal.com/docs/platform/faq",
    icon: "ellipsis",
    target: "_blank"
  },
  {
    name: "Billing",
    href: "/settings/platform/billing",
    icon: "credit-card",
    moreOnMobile: !0
  },
  {
    name: "Members",
    href: "/settings/platform/members",
    icon: "users",
    moreOnMobile: !0
  },
  {
    name: "Managed Users",
    href: "/settings/platform/managed-users",
    icon: "users",
    moreOnMobile: !0
  }
], Gfe = (e = !1) => {
  const t = Bfe();
  return Tt(() => {
    const n = e ? TXc : EXc(t), o = n.filter((a) => a.name !== j$), r = n.filter(
      (a) => !a.moreOnMobile && !a.onlyDesktop || a.name === j$
    ), i = n.filter(
      (a) => a.moreOnMobile && !a.onlyDesktop && a.name !== j$
    );
    return { desktopNavigationItems: o, mobileNavigationBottomItems: r, mobileNavigationMoreItems: i };
  }, [e, t]);
}, AXc = ({ isPlatformNavigation: e = !1 }) => {
  const { desktopNavigationItems: t } = Gfe(e);
  return /* @__PURE__ */ Y("nav", { className: "mt-2 flex-1 md:px-2 lg:mt-4 lg:px-0", children: [
    t.map((n) => /* @__PURE__ */ m(Wfe, { item: n }, n.name)),
    /* @__PURE__ */ m("div", { className: "text-subtle mt-0.5 lg:hidden", children: /* @__PURE__ */ m(Ij, {}) })
  ] });
};
function CXc({
  isPlatformNavigation: e = !1
}) {
  const { status: t } = sc.useSession();
  return t !== "authenticated" ? null : /* @__PURE__ */ m(zXc, { isPlatformNavigation: e });
}
const zXc = ({ isPlatformNavigation: e = !1 }) => {
  const t = fu(), { mobileNavigationBottomItems: n } = Gfe(e);
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      "nav",
      {
        className: ae(
          "pwa:pb-[max(0.25rem,env(safe-area-inset-bottom))] pwa:-mx-2 bg-muted border-subtle fixed bottom-0 left-0 z-30 flex w-full border-t bg-opacity-40 px-1 shadow backdrop-blur-md md:hidden",
          t && "hidden"
        ),
        children: n.map((o) => /* @__PURE__ */ m(xXc, { item: o }, o.name))
      }
    ),
    /* @__PURE__ */ m("div", { className: "block pt-12 md:hidden" })
  ] });
};
function OXc({
  publicPageUrl: e,
  isAdmin: t,
  user: n
}) {
  const { t: o } = Fe(), { isTrial: r } = V1c(), i = bo.useUtils(), a = bo.viewer.teams.skipTeamTrials.useMutation({
    onSuccess: () => {
      i.viewer.teams.hasActiveTeamPlan.invalidate(), nr(o("team_trials_skipped_successfully"), "success");
    },
    onError: () => {
      nr(o("something_went_wrong"), "error");
    }
  });
  return [
    // Render above to prevent layout shift as much as possible
    r ? {
      name: "skip_trial",
      href: "",
      isLoading: a.isPending,
      icon: "clock",
      onClick: (s) => {
        s.preventDefault(), a.mutate({});
      }
    } : null,
    {
      name: "view_public_page",
      href: e,
      icon: "external-link",
      target: "__blank"
    },
    {
      name: "copy_public_page_link",
      href: "",
      onClick: (s) => {
        s.preventDefault(), navigator.clipboard.writeText(e), nr(o("link_copied"), "success");
      },
      icon: "copy"
    },
    Jmc ? {
      name: "referral_text",
      href: "/refer",
      icon: "gift"
    } : null,
    t ? {
      name: "impersonation",
      href: "/settings/admin/impersonation",
      icon: "lock"
    } : null,
    {
      name: "settings",
      href: n != null && n.org ? "/settings/organizations/profile" : "/settings/my-account/profile",
      icon: "settings"
    }
  ].filter(Boolean);
}
function PXc() {
  const e = Ro.usePathname(), t = Ro.useSearchParams();
  return Tt(
    () => `${e}${t ? `?${t.toString()}` : ""}`,
    [e, t]
  );
}
function IXc() {
  const e = Ro.useRouter(), t = PXc();
  return () => {
    "refresh" in e && e.refresh(), e.replace(t);
  };
}
function RXc() {
  const { update: e, data: t } = sc.useSession(), { data: n } = bo.viewer.me.get.useQuery(), [o, r] = ze(!1), i = IXc();
  if (!n || !Hce || !t)
    return null;
  const a = n.profiles.map((c) => {
    let l;
    return c.organization ? l = c.organization.name : l = t.user.name, {
      label: l,
      value: c.upId
    };
  }), s = a.find((c) => c.value === t.upId) || a[0];
  return /* @__PURE__ */ Y(El, { open: o, children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, onClick: () => r((c) => !c), children: /* @__PURE__ */ m(
      "button",
      {
        "data-testid": "user-dropdown-trigger-button",
        className: ae(
          "hover:bg-emphasis todesktop:!bg-transparent group mx-0 flex w-full cursor-pointer appearance-none items-center rounded-full px-2 py-1.5 text-left outline-none transition focus:outline-none focus:ring-0 md:rounded-none lg:rounded"
        ),
        children: /* @__PURE__ */ Y("span", { className: "flex w-full flex-grow items-center justify-around gap-2 text-sm font-medium leading-none", children: [
          /* @__PURE__ */ m(wl, { alt: s.label || "", size: "xsm" }),
          /* @__PURE__ */ m("span", { className: "block w-20 overflow-hidden overflow-ellipsis whitespace-nowrap", children: s.label }),
          /* @__PURE__ */ m(
            ot,
            {
              name: "chevron-down",
              className: "group-hover:text-subtle text-muted h-4 w-4 flex-shrink-0 transition rtl:mr-4",
              "aria-hidden": "true"
            }
          )
        ] })
      }
    ) }),
    /* @__PURE__ */ m(fme, { children: /* @__PURE__ */ Y(
      Uc,
      {
        align: "start",
        onInteractOutside: () => {
          r(!1);
        },
        className: "min-w-56 hariom group overflow-hidden rounded-md",
        children: [
          /* @__PURE__ */ m(Er, { className: "p-3 uppercase", children: /* @__PURE__ */ m("span", { children: "Switch to" }) }),
          a.map((c) => {
            const l = s.value === c.value;
            return /* @__PURE__ */ m(
              Er,
              {
                onClick: () => {
                  r(!1), !l && e({
                    upId: c.value
                  }).then(() => {
                    i();
                  });
                },
                className: ae("flex w-full", l ? "bg-subtle text-emphasis" : ""),
                children: /* @__PURE__ */ Y(
                  ei,
                  {
                    type: "button",
                    childrenClassName: ae("flex w-full justify-between items-center"),
                    children: [
                      /* @__PURE__ */ Y("span", { children: [
                        /* @__PURE__ */ m(wl, { alt: c.label || "", size: "xsm" }),
                        /* @__PURE__ */ m("span", { className: "ml-2", children: c.label })
                      ] }),
                      l ? /* @__PURE__ */ m(ot, { name: "check", className: "ml-2 inline h-4 w-4", "aria-hidden": "true" }) : null
                    ]
                  }
                )
              },
              c.value
            );
          })
        ]
      }
    ) })
  ] });
}
const NXc = (e, t) => go({
  queryKey: ["check-team-billing", e],
  queryFn: async () => (await (await fetch(`/api/v2/billing/${e}/check`, {
    method: "get",
    headers: { "Content-type": "application/json" }
  })).json()).data,
  enabled: !!e && !!t,
  staleTime: 5e3
});
function DXc() {
  return bo.viewer.me.platformMe.useQuery(void 0, {
    retry(t) {
      return t > 3;
    },
    // 5 minutes
    staleTime: 3e5
  });
}
const MXc = () => {
  var l, d;
  const {
    data: e,
    isLoading: t,
    refetch: n
  } = DXc(), {
    data: o,
    isFetching: r,
    refetch: i
  } = NXc(e == null ? void 0 : e.organizationId, ((l = e == null ? void 0 : e.organization) == null ? void 0 : l.isPlatform) ?? !1), a = ((d = e == null ? void 0 : e.organization) == null ? void 0 : d.isPlatform) ?? !1, s = o == null ? void 0 : o.valid, c = e == null ? void 0 : e.organizationId;
  return {
    isUserLoading: t,
    isUserBillingDataLoading: r,
    isPlatformUser: a,
    isPaidUser: s,
    userBillingData: o,
    userOrgId: c,
    refetchTeamBilling: i,
    refetchPlatformUser: n
  };
};
var BM = { exports: {} }, E6 = {}, lZ;
function LXc() {
  return lZ || (lZ = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "HeadManagerContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (/* @__PURE__ */ sm._(ve)).default.createContext({});
  }(E6)), E6;
}
var H2 = { exports: {} }, dZ;
function qXc() {
  return dZ || (dZ = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "setAttributesFromProps", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const n = {
      acceptCharset: "accept-charset",
      className: "class",
      htmlFor: "for",
      httpEquiv: "http-equiv",
      noModule: "noModule"
    }, o = [
      "onLoad",
      "onReady",
      "dangerouslySetInnerHTML",
      "children",
      "onError",
      "strategy",
      "stylesheets"
    ];
    function r(a) {
      return [
        "async",
        "defer",
        "noModule"
      ].includes(a);
    }
    function i(a, s) {
      for (const [c, l] of Object.entries(s)) {
        if (!s.hasOwnProperty(c) || o.includes(c) || l === void 0)
          continue;
        const d = n[c] || c.toLowerCase();
        a.tagName === "SCRIPT" && r(d) ? a[d] = !!l : a.setAttribute(d, String(l)), (l === !1 || a.tagName === "SCRIPT" && r(d) && (!l || l === "false")) && (a.setAttribute(d, ""), a.removeAttribute(d));
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  }(H2, H2.exports)), H2.exports;
}
(function(e, t) {
  "use client";
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(S, O) {
    for (var I in O)
      Object.defineProperty(S, I, {
        enumerable: !0,
        get: O[I]
      });
  }
  n(t, {
    default: function() {
      return k;
    },
    handleClientScriptLoad: function() {
      return g;
    },
    initScriptLoader: function() {
      return v;
    }
  });
  const o = sm, r = q0, i = PT, a = /* @__PURE__ */ o._(Uv), s = /* @__PURE__ */ r._(ve), c = LXc(), l = qXc(), d = Use(), u = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Set(), p = (S) => {
    if (a.default.preinit) {
      S.forEach((O) => {
        a.default.preinit(O, {
          as: "style"
        });
      });
      return;
    }
    if (typeof window < "u") {
      let O = document.head;
      S.forEach((I) => {
        let D = document.createElement("link");
        D.type = "text/css", D.rel = "stylesheet", D.href = I, O.appendChild(D);
      });
    }
  }, f = (S) => {
    const { src: O, id: I, onLoad: D = () => {
    }, onReady: M = null, dangerouslySetInnerHTML: N, children: C = "", strategy: P = "afterInteractive", onError: x, stylesheets: w } = S, E = I || O;
    if (E && _.has(E))
      return;
    if (u.has(O)) {
      _.add(E), u.get(O).then(D, x);
      return;
    }
    const T = () => {
      M && M(), _.add(E);
    }, z = document.createElement("script"), j = new Promise((q, V) => {
      z.addEventListener("load", function(F) {
        q(), D && D.call(this, F), T();
      }), z.addEventListener("error", function(F) {
        V(F);
      });
    }).catch(function(q) {
      x && x(q);
    });
    N ? (z.innerHTML = N.__html || "", T()) : C ? (z.textContent = typeof C == "string" ? C : Array.isArray(C) ? C.join("") : "", T()) : O && (z.src = O, u.set(O, j)), (0, l.setAttributesFromProps)(z, S), P === "worker" && z.setAttribute("type", "text/partytown"), z.setAttribute("data-nscript", P), w && p(w), document.body.appendChild(z);
  };
  function g(S) {
    const { strategy: O = "afterInteractive" } = S;
    O === "lazyOnload" ? window.addEventListener("load", () => {
      (0, d.requestIdleCallback)(() => f(S));
    }) : f(S);
  }
  function h(S) {
    document.readyState === "complete" ? (0, d.requestIdleCallback)(() => f(S)) : window.addEventListener("load", () => {
      (0, d.requestIdleCallback)(() => f(S));
    });
  }
  function b() {
    [
      ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
      ...document.querySelectorAll('[data-nscript="beforePageRender"]')
    ].forEach((O) => {
      const I = O.id || O.getAttribute("src");
      _.add(I);
    });
  }
  function v(S) {
    S.forEach(g), b();
  }
  function $(S) {
    const { id: O, src: I = "", onLoad: D = () => {
    }, onReady: M = null, strategy: N = "afterInteractive", onError: C, stylesheets: P, ...x } = S;
    let { updateScripts: w, scripts: E, getIsSsr: T, appDir: z, nonce: j } = (0, s.useContext)(c.HeadManagerContext);
    j = x.nonce || j;
    const q = (0, s.useRef)(!1);
    (0, s.useEffect)(() => {
      const F = O || I;
      q.current || (M && F && _.has(F) && M(), q.current = !0);
    }, [
      M,
      O,
      I
    ]);
    const V = (0, s.useRef)(!1);
    if ((0, s.useEffect)(() => {
      V.current || (N === "afterInteractive" ? f(S) : N === "lazyOnload" && h(S), V.current = !0);
    }, [
      S,
      N
    ]), (N === "beforeInteractive" || N === "worker") && (w ? (E[N] = (E[N] || []).concat([
      {
        id: O,
        src: I,
        onLoad: D,
        onReady: M,
        onError: C,
        ...x,
        nonce: j
      }
    ]), w(E)) : T && T() ? _.add(O || I) : T && !T() && f({
      ...S,
      nonce: j
    })), z) {
      if (P && P.forEach((F) => {
        a.default.preinit(F, {
          as: "style"
        });
      }), N === "beforeInteractive")
        return I ? (a.default.preload(I, x.integrity ? {
          as: "script",
          integrity: x.integrity,
          nonce: j,
          crossOrigin: x.crossOrigin
        } : {
          as: "script",
          nonce: j,
          crossOrigin: x.crossOrigin
        }), /* @__PURE__ */ (0, i.jsx)("script", {
          nonce: j,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              I,
              {
                ...x,
                id: O
              }
            ]) + ")"
          }
        })) : (x.dangerouslySetInnerHTML && (x.children = x.dangerouslySetInnerHTML.__html, delete x.dangerouslySetInnerHTML), /* @__PURE__ */ (0, i.jsx)("script", {
          nonce: j,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              0,
              {
                ...x,
                id: O
              }
            ]) + ")"
          }
        }));
      N === "afterInteractive" && I && a.default.preload(I, x.integrity ? {
        as: "script",
        integrity: x.integrity,
        nonce: j,
        crossOrigin: x.crossOrigin
      } : {
        as: "script",
        nonce: j,
        crossOrigin: x.crossOrigin
      });
    }
    return null;
  }
  Object.defineProperty($, "__nextScript", {
    value: !0
  });
  const k = $;
  (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
})(BM, BM.exports);
var jXc = BM.exports, FXc = jXc;
const Hfe = /* @__PURE__ */ Zr(FXc);
var Kfe = {};
const uZ = G.string().min(1), Yfe = Kfe.NEXT_PUBLIC_FRESHCHAT_HOST, Zfe = Kfe.NEXT_PUBLIC_FRESHCHAT_TOKEN;
uZ.safeParse(Yfe).success && uZ.safeParse(Zfe).success;
function VXc() {
  const { data: e } = bo.viewer.me.get.useQuery();
  return /* @__PURE__ */ m(
    Hfe,
    {
      id: "fresh-chat-sdk",
      src: "https://wchat.freshchat.com/js/widget.js",
      onLoad: () => {
        window.fcWidget.init({
          token: Zfe,
          host: Yfe,
          externalId: e == null ? void 0 : e.id,
          lastName: e == null ? void 0 : e.name,
          email: e == null ? void 0 : e.email,
          meta: {
            username: e == null ? void 0 : e.username
          },
          open: !0
        });
      }
    }
  );
}
const BXc = No({ active: !1, setActive: () => {
} });
function UXc(e) {
  const [t, n] = ze(!1);
  return /* @__PURE__ */ Y(BXc.Provider, { value: { active: t, setActive: n }, children: [
    e.children,
    t && /* @__PURE__ */ m(VXc, {})
  ] });
}
function tx({ small: e }) {
  const { isPlatformUser: t } = MXc(), { t: n } = Fe(), { data: o, isPending: r } = tk(), i = Ro.usePathname(), a = i == null ? void 0 : i.startsWith("/settings/platform");
  Le(() => {
    const _ = window.Beacon;
    _ && _("session-data", {
      username: (o == null ? void 0 : o.username) || "Unknown",
      screenResolution: `${screen.width}x${screen.height}`
    });
  });
  const [s, c] = ze(!1), [l, d] = ze(!1), u = (_) => {
    _ == null || _.preventDefault(), _ == null || _.stopPropagation(), d(!0), c(!1);
  };
  return Le(() => {
    !s && l && (setTimeout(() => {
      var _;
      (_ = window.Support) == null || _.open();
    }, 0), d(!1));
  }, [s, l]), !o && !r ? null : /* @__PURE__ */ Y(El, { open: s, children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, onClick: () => c((_) => !_), disabled: r, children: /* @__PURE__ */ Y(
      "button",
      {
        "data-testid": "user-dropdown-trigger-button",
        className: ae(
          "hover:bg-emphasis todesktop:!bg-transparent group mx-0 flex w-full cursor-pointer appearance-none items-center rounded-full text-left outline-none transition focus:outline-none focus:ring-0 md:rounded-none lg:rounded",
          e ? "p-2" : "px-2 py-1.5"
        ),
        children: [
          /* @__PURE__ */ Y(
            "span",
            {
              className: ae(
                e ? "h-4 w-4" : "h-5 w-5 ltr:mr-2 rtl:ml-2",
                "relative flex-shrink-0 rounded-full"
              ),
              children: [
                /* @__PURE__ */ m(
                  wl,
                  {
                    size: e ? "xs" : "xsm",
                    imageSrc: (o == null ? void 0 : o.avatarUrl) ?? (o == null ? void 0 : o.avatar),
                    alt: o != null && o.username ? `${o.username} Avatar` : "Nameless User Avatar",
                    className: "overflow-hidden"
                  }
                ),
                /* @__PURE__ */ m(
                  "span",
                  {
                    className: ae(
                      "border-muted absolute -bottom-1 -right-1 rounded-full border bg-green-500",
                      e ? "-bottom-0.5 -right-0.5 h-2.5 w-2.5" : "-bottom-0.5 -right-0 h-2 w-2"
                    )
                  }
                )
              ]
            }
          ),
          !e && /* @__PURE__ */ Y("span", { className: "flex flex-grow items-center gap-2", children: [
            /* @__PURE__ */ m("span", { className: "w-24 flex-shrink-0 text-sm leading-none", children: /* @__PURE__ */ m("span", { className: "text-emphasis block truncate py-0.5 font-medium leading-normal", children: r ? "Loading..." : (o == null ? void 0 : o.name) ?? "Nameless User" }) }),
            /* @__PURE__ */ m(
              ot,
              {
                name: "chevron-down",
                className: "group-hover:text-subtle text-muted h-4 w-4 flex-shrink-0 transition rtl:mr-4",
                "aria-hidden": "true"
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ m(fme, { children: /* @__PURE__ */ m(UXc, { children: /* @__PURE__ */ m(
      Uc,
      {
        align: "start",
        onInteractOutside: () => {
          c(!1);
        },
        className: "group overflow-hidden rounded-md",
        children: /* @__PURE__ */ Y(Ce, { children: [
          !a && /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(ot, { name: "user", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/profile",
                children: n("my_profile")
              }
            ) }),
            /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(ot, { name: "settings", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/general",
                children: n("my_settings")
              }
            ) }),
            /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                CustomStartIcon: /* @__PURE__ */ m(ot, { name: "moon", className: "text-default h-4 w-4", "aria-hidden": "true" }),
                href: "/settings/my-account/out-of-office",
                children: n("out_of_office")
              }
            ) }),
            /* @__PURE__ */ m(kE, {})
          ] }),
          /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(ei, { StartIcon: "map", target: "_blank", href: Gmc, children: n("visit_roadmap") }) }),
          /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
            ei,
            {
              type: "button",
              StartIcon: "circle-help",
              "aria-hidden": "true",
              onClick: u,
              children: n("help")
            }
          ) }),
          !a && /* @__PURE__ */ m(Er, { className: "todesktop:hidden hidden lg:flex", children: /* @__PURE__ */ m(ei, { StartIcon: "download", target: "_blank", rel: "noreferrer", href: Hmc, children: n("download_desktop_app") }) }),
          !a && t && /* @__PURE__ */ m(Er, { className: "todesktop:hidden hidden lg:flex", children: /* @__PURE__ */ m(ei, { StartIcon: "blocks", target: "_blank", rel: "noreferrer", href: "/settings/platform", children: "Platform" }) }),
          /* @__PURE__ */ m(kE, {}),
          /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
            ei,
            {
              type: "button",
              StartIcon: "log-out",
              "aria-hidden": "true",
              onClick: () => {
                sc.signOut({ callbackUrl: "/auth/logout" });
              },
              children: n("sign_out")
            }
          ) })
        ] })
      }
    ) }) })
  ] });
}
const WXc = hn(() => import("./index-6bsFojHJ.js").then((e) => e.Tips), {
  ssr: !1
});
function GXc({ bannersHeight: e, isPlatformUser: t = !1 }) {
  const { status: n, data: o } = sc.useSession();
  return n !== "loading" && n !== "authenticated" ? null : /* @__PURE__ */ m(HXc, { isPlatformUser: t, bannersHeight: e, user: o == null ? void 0 : o.user });
}
function HXc({ bannersHeight: e, user: t }) {
  var u, _;
  const n = sc.useSession(), { t: o, isLocaleReady: r } = Fe(), i = Ro.usePathname(), a = i == null ? void 0 : i.startsWith("/settings/platform"), s = ((u = n.data) == null ? void 0 : u.user.role) === ngc.ADMIN, c = `${qv(((_ = t == null ? void 0 : t.org) == null ? void 0 : _.slug) ?? null)}/${t == null ? void 0 : t.orgAwareUsername}`, l = OXc({
    publicPageUrl: c,
    isAdmin: s,
    user: t
  }), d = {
    maxHeight: `calc(100vh - ${e}px)`,
    top: `${e}px`
  };
  return /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ Y(
    "aside",
    {
      style: a ? {} : d,
      className: ae(
        "bg-muted border-muted fixed left-0 hidden h-full w-14 flex-col overflow-y-auto overflow-x-hidden border-r md:sticky md:flex lg:w-56 lg:px-3",
        !a && "max-h-screen"
      ),
      children: [
        /* @__PURE__ */ Y("div", { className: "flex h-full flex-col justify-between py-3 lg:pt-4", children: [
          /* @__PURE__ */ Y("header", { className: "todesktop:-mt-3 todesktop:flex-col-reverse todesktop:[-webkit-app-region:drag] items-center justify-between md:hidden lg:flex", children: [
            t != null && t.org ? Hce ? /* @__PURE__ */ m(RXc, {}) : /* @__PURE__ */ m(Po, { href: "/settings/organizations/profile", className: "w-full px-1.5", children: /* @__PURE__ */ Y("div", { className: "flex items-center gap-2 font-medium", children: [
              /* @__PURE__ */ m(
                wl,
                {
                  alt: `${t.org.name} logo`,
                  imageSrc: GA(t.org.logoUrl, t.org.name),
                  size: "xsm"
                }
              ),
              /* @__PURE__ */ m("p", { className: "text line-clamp-1 text-sm", children: /* @__PURE__ */ m("span", { children: t.org.name }) })
            ] }) }) : /* @__PURE__ */ Y("div", { "data-testid": "user-dropdown-trigger", className: "todesktop:mt-4 w-full", children: [
              /* @__PURE__ */ m("span", { className: "hidden lg:inline", children: /* @__PURE__ */ m(tx, {}) }),
              /* @__PURE__ */ m("span", { className: "hidden md:inline lg:hidden", children: /* @__PURE__ */ m(tx, { small: !0 }) })
            ] }),
            /* @__PURE__ */ Y("div", { className: "flex w-full justify-end rtl:space-x-reverse", children: [
              /* @__PURE__ */ m(
                "button",
                {
                  color: "minimal",
                  onClick: () => window.history.back(),
                  className: "todesktop:block hover:text-emphasis text-subtle group hidden text-sm font-medium",
                  children: /* @__PURE__ */ m(
                    ot,
                    {
                      name: "arrow-left",
                      className: "group-hover:text-emphasis text-subtle h-4 w-4 flex-shrink-0"
                    }
                  )
                }
              ),
              /* @__PURE__ */ m(
                "button",
                {
                  color: "minimal",
                  onClick: () => window.history.forward(),
                  className: "todesktop:block hover:text-emphasis text-subtle group hidden text-sm font-medium",
                  children: /* @__PURE__ */ m(
                    ot,
                    {
                      name: "arrow-right",
                      className: "group-hover:text-emphasis text-subtle h-4 w-4 flex-shrink-0"
                    }
                  )
                }
              ),
              !!(t != null && t.org) && /* @__PURE__ */ m("div", { "data-testid": "user-dropdown-trigger", className: "flex items-center", children: /* @__PURE__ */ m(tx, { small: !0 }) }),
              /* @__PURE__ */ m(Ij, {})
            ] })
          ] }),
          /* @__PURE__ */ m(Po, { href: "/event-types", className: "text-center md:inline lg:hidden", children: /* @__PURE__ */ m(Vfe, { small: !0, icon: !0 }) }),
          /* @__PURE__ */ m(AXc, { isPlatformNavigation: a })
        ] }),
        !a && /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ m("div", { className: "overflow-hidden", children: /* @__PURE__ */ m(WXc, {}) }),
          l.map((p, f) => /* @__PURE__ */ m(Ao, { side: "right", content: o(p.name), className: "lg:hidden", children: /* @__PURE__ */ Y(
            gme,
            {
              id: p.name,
              href: p.href || void 0,
              "aria-label": o(p.name),
              target: p.target,
              className: ae(
                "text-left",
                "[&[aria-current='page']]:bg-emphasis text-default justify-right group flex items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
                "[&[aria-current='page']]:text-emphasis mt-0.5 w-full text-sm",
                r ? "hover:bg-emphasis hover:text-emphasis" : "",
                f === 0 && "mt-3"
              ),
              onClick: p.onClick,
              children: [
                !!p.icon && /* @__PURE__ */ m(
                  ot,
                  {
                    name: p.isLoading ? "rotate-cw" : p.icon,
                    className: ae(
                      "h-4 w-4 flex-shrink-0 [&[aria-current='page']]:text-inherit",
                      "me-3 md:mx-auto lg:ltr:mr-2 lg:rtl:ml-2",
                      p.isLoading && "animate-spin"
                    ),
                    "aria-hidden": "true"
                  }
                ),
                r ? /* @__PURE__ */ m("span", { className: "hidden w-full justify-between lg:flex", children: /* @__PURE__ */ m("div", { className: "flex", children: o(p.name) }) }) : /* @__PURE__ */ m(Jn, { className: "h-[20px] w-full" })
              ]
            }
          ) }, p.name)),
          !Zmc && /* @__PURE__ */ m(hXc, {})
        ] })
      ]
    }
  ) });
}
function KXc() {
  const { status: e } = sc.useSession();
  return e !== "authenticated" ? null : /* @__PURE__ */ m(YXc, {});
}
function YXc() {
  const e = fu(), { t } = Fe();
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(
    "nav",
    {
      style: e ? { display: "none" } : {},
      className: "bg-muted border-subtle sticky top-0 z-40 flex w-full items-center justify-between border-b bg-opacity-50 px-4 py-1.5 backdrop-blur-lg sm:p-4 md:hidden",
      children: [
        /* @__PURE__ */ m(Po, { href: "/event-types", children: /* @__PURE__ */ m(Vfe, {}) }),
        /* @__PURE__ */ Y("div", { className: "flex items-center gap-2 self-center", children: [
          /* @__PURE__ */ m("span", { className: "hover:bg-muted hover:text-emphasis text-default group flex items-center rounded-full text-sm font-medium transition lg:hidden", children: /* @__PURE__ */ m(Ij, {}) }),
          /* @__PURE__ */ Y("button", { className: "hover:bg-muted hover:text-subtle text-muted rounded-full p-1 transition focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2", children: [
            /* @__PURE__ */ m("span", { className: "sr-only", children: t("settings") }),
            /* @__PURE__ */ m(Po, { href: "/settings/my-account/profile", children: /* @__PURE__ */ m(ot, { name: "settings", className: "text-default h-4 w-4", "aria-hidden": "true" }) })
          ] }),
          /* @__PURE__ */ m(tx, { small: !0 })
        ] })
      ]
    }
  ) });
}
const ZXc = {
  default: "bg-gradient-primary",
  warning: "bg-orange-400",
  error: "bg-red-400"
}, T6 = {
  className: "text-emphasis h-4 w-4 stroke-[2.5px]"
};
function mg(e) {
  const { icon: t, variant: n = "default", text: o, actions: r } = e, a = (() => {
    switch (n) {
      case "error":
        return /* @__PURE__ */ m(ot, { ...T6, name: "triangle-alert", "data-testid": "variant-error" });
      case "warning":
        return /* @__PURE__ */ m(ot, { ...T6, name: "info", "data-testid": "variant-warning" });
      default:
        return null;
    }
  })();
  return /* @__PURE__ */ m(
    "div",
    {
      "data-testid": "banner",
      style: { minHeight: Yce },
      className: ci(
        "flex w-full items-start justify-between gap-8 px-4 py-2 text-center lg:items-center",
        ZXc[n]
      ),
      children: /* @__PURE__ */ Y("div", { className: "flex flex-1 flex-col items-start justify-center gap-2 px-1 py-0.5 lg:flex-row lg:items-center", children: [
        /* @__PURE__ */ Y("p", { className: "text-emphasis flex flex-col items-start justify-center gap-2 text-left font-sans text-sm font-medium leading-4 lg:flex-row lg:items-center", children: [
          t ? /* @__PURE__ */ m(ot, { ...T6, name: t, "data-testid": "variant-default" }) : a,
          o
        ] }),
        r && /* @__PURE__ */ m("div", { className: "text-sm font-medium", children: r })
      ] })
    }
  );
}
function QXc({ data: e }) {
  var r, i;
  const { t } = Fe();
  if (!(e != null && e.user.impersonatedBy))
    return null;
  const n = e.user.impersonatedBy.id, o = e.user.impersonatedBy.role == "ADMIN" || ((i = (r = e.user) == null ? void 0 : r.org) == null ? void 0 : i.id);
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
    mg,
    {
      text: t("impersonating_user_warning", { user: e.user.orgAwareUsername || e.user.username }),
      variant: "warning",
      actions: o ? /* @__PURE__ */ m(
        "form",
        {
          onSubmit: (a) => {
            a.preventDefault(), sc.signIn("impersonation-auth", { returnToId: n });
          },
          children: /* @__PURE__ */ m("button", { className: "text-emphasis hover:underline", "data-testid": "stop-impersonating-button", children: t("impersonating_stop_instructions") })
        }
      ) : /* @__PURE__ */ m("a", { className: "border-b border-b-black", href: "/auth/logout", children: t("impersonating_stop_instructions") })
    }
  ) });
}
function JXc({ data: e }) {
  const { t } = Fe(), n = Ro.useRouter(), o = Zo(), r = bo.viewer.organizations.publish.useMutation({
    onSuccess(a) {
      n.push(a.url);
    },
    onError: (a) => {
      nr(a.message, "error");
    }
  });
  if (!e)
    return null;
  const [i] = e;
  return !i || o ? null : /* @__PURE__ */ m(
    mg,
    {
      text: t("org_upgrade_banner_description", { teamName: i.team.name }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "button",
        {
          "data-testid": "upgrade_org_banner_button",
          className: "border-b border-b-black",
          onClick: () => {
            r.mutate();
          },
          children: t("upgrade_banner_action")
        }
      )
    }
  );
}
const XXc = {
  lg: "12px",
  base: "8px",
  sm: "10px",
  xs: "8px"
};
function HA({ children: e, combined: t = !1, containerProps: n }) {
  var s;
  const o = ve.Children.toArray(e)[0], r = ((s = o == null ? void 0 : o.props) == null ? void 0 : s.size) || "base", i = XXc[r];
  return /* @__PURE__ */ m(
    "div",
    {
      ...n,
      style: t ? { "--btn-group-radius": i } : void 0,
      className: ae(
        "flex",
        t ? "[&>*:first-child]:rounded-l-[var(--btn-group-radius)] rtl:[&>*:first-child]:rounded-l-none rtl:[&>*:first-child]:rounded-r-[var(--btn-group-radius)] [&>*:last-child]:rounded-r-[var(--btn-group-radius)] rtl:[&>*:last-child]:rounded-l-[var(--btn-group-radius)] rtl:[&>*:last-child]:rounded-r-none [&>*:not(:first-child)]:-ml-[1px] [&>*]:rounded-none [&>*]:border hover:[&>*]:z-[1]" : "space-x-2 rtl:space-x-reverse",
        n == null ? void 0 : n.className
      ),
      children: e
    }
  );
}
function sb({
  Icon: e,
  customIcon: t,
  avatar: n,
  headline: o,
  description: r,
  buttonText: i,
  buttonOnClick: a,
  buttonRaw: s,
  border: c = !0,
  dashedBorder: l = !0,
  className: d,
  iconClassName: u,
  iconWrapperClassName: _,
  limitWidth: p = !0
}) {
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(
    "div",
    {
      "data-testid": "empty-screen",
      className: ae(
        "flex w-full select-none flex-col items-center justify-center rounded-lg p-7 lg:p-20",
        c && "border-subtle border",
        l && "border-dashed",
        d
      ),
      children: [
        n ? /* @__PURE__ */ m("div", { className: "flex h-[72px] w-[72px] items-center justify-center rounded-full", children: n }) : null,
        e ? /* @__PURE__ */ m(
          "div",
          {
            className: ae(
              "bg-emphasis flex h-[72px] w-[72px] items-center justify-center rounded-full ",
              _
            ),
            children: /* @__PURE__ */ m(
              ot,
              {
                name: e,
                className: ae("text-default inline-block h-10 w-10 stroke-[1.3px]", u)
              }
            )
          }
        ) : null,
        t ? /* @__PURE__ */ m(Ce, { children: t }) : null,
        /* @__PURE__ */ Y("div", { className: `flex ${p ? "max-w-[420px]" : ""}  flex-col items-center`, children: [
          /* @__PURE__ */ m(
            "h2",
            {
              className: ae(
                "text-semibold font-cal text-emphasis text-center text-xl normal-nums",
                e && "mt-6",
                !r && "mb-8"
              ),
              children: o
            }
          ),
          r && /* @__PURE__ */ m("div", { className: "text-default mb-8 mt-3 text-center text-sm font-normal leading-6", children: r }),
          a && i && /* @__PURE__ */ m(ut, { onClick: (f) => a(f), children: i }),
          s
        ] })
      ]
    }
  ) });
}
function eel(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var Qfe = eel;
function tel(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = Array(o); ++n < o; )
    r[n] = t(e[n], n, e);
  return r;
}
var Dj = tel;
function nel(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var oel = nel, rel = typeof Je == "object" && Je && Je.Object === Object && Je, Jfe = rel, iel = Jfe, ael = typeof self == "object" && self && self.Object === Object && self, sel = iel || ael || Function("return this")(), gd = sel, cel = gd, lel = cel.Symbol, cb = lel, _Z = cb, Xfe = Object.prototype, del = Xfe.hasOwnProperty, uel = Xfe.toString, Hy = _Z ? _Z.toStringTag : void 0;
function _el(e) {
  var t = del.call(e, Hy), n = e[Hy];
  try {
    e[Hy] = void 0;
    var o = !0;
  } catch {
  }
  var r = uel.call(e);
  return o && (t ? e[Hy] = n : delete e[Hy]), r;
}
var pel = _el, mel = Object.prototype, fel = mel.toString;
function gel(e) {
  return fel.call(e);
}
var hel = gel, pZ = cb, vel = pel, bel = hel, yel = "[object Null]", $el = "[object Undefined]", mZ = pZ ? pZ.toStringTag : void 0;
function wel(e) {
  return e == null ? e === void 0 ? $el : yel : mZ && mZ in Object(e) ? vel(e) : bel(e);
}
var lb = wel;
function kel(e) {
  return e != null && typeof e == "object";
}
var I_ = kel, Sel = lb, xel = I_, Eel = "[object Arguments]";
function Tel(e) {
  return xel(e) && Sel(e) == Eel;
}
var Ael = Tel, fZ = Ael, Cel = I_, ege = Object.prototype, zel = ege.hasOwnProperty, Oel = ege.propertyIsEnumerable, Pel = fZ(/* @__PURE__ */ function() {
  return arguments;
}()) ? fZ : function(e) {
  return Cel(e) && zel.call(e, "callee") && !Oel.call(e, "callee");
}, KA = Pel, Iel = Array.isArray, hd = Iel, OE = { exports: {} };
function Rel() {
  return !1;
}
var Nel = Rel;
OE.exports;
(function(e, t) {
  var n = gd, o = Nel, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, a = i && i.exports === r, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || o;
  e.exports = l;
})(OE, OE.exports);
var YA = OE.exports, Del = 9007199254740991, Mel = /^(?:0|[1-9]\d*)$/;
function Lel(e, t) {
  var n = typeof e;
  return t = t ?? Del, !!t && (n == "number" || n != "symbol" && Mel.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ZA = Lel, qel = 9007199254740991;
function jel(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= qel;
}
var Mj = jel, Fel = lb, Vel = Mj, Bel = I_, Uel = "[object Arguments]", Wel = "[object Array]", Gel = "[object Boolean]", Hel = "[object Date]", Kel = "[object Error]", Yel = "[object Function]", Zel = "[object Map]", Qel = "[object Number]", Jel = "[object Object]", Xel = "[object RegExp]", etl = "[object Set]", ttl = "[object String]", ntl = "[object WeakMap]", otl = "[object ArrayBuffer]", rtl = "[object DataView]", itl = "[object Float32Array]", atl = "[object Float64Array]", stl = "[object Int8Array]", ctl = "[object Int16Array]", ltl = "[object Int32Array]", dtl = "[object Uint8Array]", utl = "[object Uint8ClampedArray]", _tl = "[object Uint16Array]", ptl = "[object Uint32Array]", Gr = {};
Gr[itl] = Gr[atl] = Gr[stl] = Gr[ctl] = Gr[ltl] = Gr[dtl] = Gr[utl] = Gr[_tl] = Gr[ptl] = !0;
Gr[Uel] = Gr[Wel] = Gr[otl] = Gr[Gel] = Gr[rtl] = Gr[Hel] = Gr[Kel] = Gr[Yel] = Gr[Zel] = Gr[Qel] = Gr[Jel] = Gr[Xel] = Gr[etl] = Gr[ttl] = Gr[ntl] = !1;
function mtl(e) {
  return Bel(e) && Vel(e.length) && !!Gr[Fel(e)];
}
var ftl = mtl;
function gtl(e) {
  return function(t) {
    return e(t);
  };
}
var Lj = gtl, PE = { exports: {} };
PE.exports;
(function(e, t) {
  var n = Jfe, o = t && !t.nodeType && t, r = o && !0 && e && !e.nodeType && e, i = r && r.exports === o, a = i && n.process, s = function() {
    try {
      var c = r && r.require && r.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(PE, PE.exports);
var qj = PE.exports, htl = ftl, vtl = Lj, gZ = qj, hZ = gZ && gZ.isTypedArray, btl = hZ ? vtl(hZ) : htl, jj = btl, ytl = oel, $tl = KA, wtl = hd, ktl = YA, Stl = ZA, xtl = jj, Etl = Object.prototype, Ttl = Etl.hasOwnProperty;
function Atl(e, t) {
  var n = wtl(e), o = !n && $tl(e), r = !n && !o && ktl(e), i = !n && !o && !r && xtl(e), a = n || o || r || i, s = a ? ytl(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || Ttl.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Stl(l, c))) && s.push(l);
  return s;
}
var tge = Atl, Ctl = Object.prototype;
function ztl(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Ctl;
  return e === n;
}
var Fj = ztl;
function Otl(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var nge = Otl, Ptl = nge, Itl = Ptl(Object.keys, Object), Rtl = Itl, Ntl = Fj, Dtl = Rtl, Mtl = Object.prototype, Ltl = Mtl.hasOwnProperty;
function qtl(e) {
  if (!Ntl(e))
    return Dtl(e);
  var t = [];
  for (var n in Object(e))
    Ltl.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var jtl = qtl;
function Ftl(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Al = Ftl, Vtl = lb, Btl = Al, Utl = "[object AsyncFunction]", Wtl = "[object Function]", Gtl = "[object GeneratorFunction]", Htl = "[object Proxy]";
function Ktl(e) {
  if (!Btl(e))
    return !1;
  var t = Vtl(e);
  return t == Wtl || t == Gtl || t == Utl || t == Htl;
}
var Vj = Ktl, Ytl = Vj, Ztl = Mj;
function Qtl(e) {
  return e != null && Ztl(e.length) && !Ytl(e);
}
var QA = Qtl, Jtl = tge, Xtl = jtl, enl = QA;
function tnl(e) {
  return enl(e) ? Jtl(e) : Xtl(e);
}
var R_ = tnl;
const nnl = /* @__PURE__ */ No(void 0), onl = { setTheme: (e) => {
}, themes: [] }, rnl = () => {
  var e;
  return (e = Pn(nnl)) !== null && e !== void 0 ? e : onl;
};
function oge(e, t = !1) {
  if (typeof window < "u") {
    const s = wo.getItem("app-theme");
    e = e ?? s ?? "system";
  }
  const { resolvedTheme: n, setTheme: o, forcedTheme: r, theme: i } = rnl(), a = NTc();
  if (Le(() => {
    if (t || e === void 0)
      return;
    const s = a ? a === "auto" ? "system" : a : e;
    !s || s === i || o(s);
  }, [e, o, a]), t)
    return {
      resolvedTheme: n,
      forcedTheme: r,
      activeTheme: i
    };
}
function lfd() {
  const e = oge(null, !0);
  if (!e)
    throw new Error("useTheme must have a return value here");
  return e;
}
const inl = ({
  i18nKey: e,
  components: t = [],
  t: n,
  values: o = {},
  children: r,
  parent: i
}) => {
  const a = { ...o }, s = n(e, a);
  if (!s && r)
    return /* @__PURE__ */ m(Ce, { children: r });
  if (!s)
    return /* @__PURE__ */ m(Ce, {});
  let c;
  return Array.isArray(t) && t.length > 0 ? c = snl(s, t) : anl(t) && Object.keys(t).length > 0 ? c = cnl(s, t) : c = Ud(s), i ? /* @__PURE__ */ m(i, { children: c }) : /* @__PURE__ */ m(Ce, { children: c });
}, anl = (e) => e !== null && typeof e == "object" && !Array.isArray(e), snl = (e, t) => {
  const n = [];
  let o = "";
  const r = (a) => {
    for (let s = 0; s < a.length; s++) {
      if (a[s] === "<" && /\d/.test(a[s + 1])) {
        let c = "", l = s + 1;
        for (; l < a.length && /\d/.test(a[l]); )
          c += a[l], l++;
        if (l < a.length && a[l] === ">") {
          o && (n.push(...Ud(o)), o = "");
          const d = `</${c}>`, u = i(a.substring(l + 1), c);
          if (u !== null) {
            const _ = parseInt(c, 10);
            if (_ < t.length) {
              const p = t[_];
              bl(p) ? n.push(
                w_(
                  p,
                  {
                    ...p.props || {},
                    key: p.key || `comp-${_}`
                  },
                  ...Ud(u)
                )
              ) : n.push(...Ud(u));
            } else
              n.push(...Ud(u));
            s = l + u.length + d.length;
            continue;
          }
        }
      }
      o += a[s];
    }
    o && n.push(...Ud(o));
  }, i = (a, s) => {
    let c = 1, l = "";
    for (let d = 0; d < a.length; d++) {
      if (a[d] === "<" && a.substring(d + 1, d + 1 + s.length) === s && a[d + 1 + s.length] === ">") {
        c++, l += a.substring(d, d + 2 + s.length), d += 1 + s.length;
        continue;
      }
      if (a[d] === "<" && a.substring(d + 1, d + 2 + s.length) === `/${s}` && a[d + 2 + s.length] === ">") {
        if (c--, c === 0)
          return l;
        l += a.substring(d, d + 3 + s.length), d += 2 + s.length;
        continue;
      }
      l += a[d];
    }
    return null;
  };
  return r(e), n.length > 0 ? n : [e];
}, cnl = (e, t) => {
  let n = e;
  const o = {};
  Object.keys(t).forEach((c) => {
    const l = new RegExp(`{{\\s*${c}\\s*}}`, "g");
    n = n.replace(l, (d) => {
      const u = `__INTERP_${c}_${Math.random().toString(36).substring(2)}__`;
      return bl(t[c]) && (o[u] = w_(t[c], {
        ...t[c].props || {},
        key: t[c].key || `interp-${c}`
      })), u;
    });
  }), Object.keys(t).forEach((c) => {
    const l = new RegExp(`<${c}>(.*?)<\\/${c}>`, "gs");
    n = n.replace(l, (d, u) => {
      const _ = `__TAG_${c}_${Math.random().toString(36).substring(2)}__`;
      if (bl(t[c])) {
        const p = Ud(u);
        o[_] = w_(
          t[c],
          {
            ...t[c].props || {},
            key: t[c].key || `tag-${c}`
          },
          ...p.length > 1 ? p : [u]
        );
      }
      return _;
    });
  });
  const r = [];
  let i = 0;
  const a = /__(?:INTERP|TAG)_[^_]+_[a-z0-9]+__/g;
  let s;
  for (; (s = a.exec(n)) !== null; ) {
    const [c] = s, l = s.index;
    if (l > i) {
      const d = n.substring(i, l);
      r.push(...Ud(d));
    }
    o[c] && r.push(o[c]), i = l + c.length;
  }
  if (i < n.length) {
    const c = n.substring(i);
    r.push(...Ud(c));
  }
  return r.length > 0 ? r : [n];
}, Ud = (e) => {
  if (!e || typeof e != "string")
    return [e].filter(Boolean);
  if (!/<[a-z][\s\S]*>/i.test(e))
    return [e];
  const t = [
    { tag: "strong", component: "strong" },
    { tag: "b", component: "b" },
    { tag: "i", component: "i" },
    { tag: "em", component: "em" },
    { tag: "p", component: "p" },
    { tag: "br", component: "br", selfClosing: !0 },
    { tag: "div", component: "div" },
    { tag: "span", component: "span" },
    { tag: "ul", component: "ul" },
    { tag: "ol", component: "ol" },
    { tag: "li", component: "li" }
  ];
  let n = e;
  const o = {};
  if (t.forEach(({ tag: c, component: l, selfClosing: d }) => {
    if (d) {
      const u = new RegExp(`<${c}\\s*\\/>`, "g");
      n = n.replace(u, (_) => {
        const p = `__HTML_${c}_${Math.random().toString(36).substring(2)}__`;
        return o[p] = Pe(l, { key: p }), p;
      });
    } else {
      const u = new RegExp(`<${c}>(.*?)<\\/${c}>`, "gs");
      n = n.replace(u, (_, p) => {
        const f = `__HTML_${c}_${Math.random().toString(36).substring(2)}__`, g = Ud(p);
        return o[f] = Pe(
          l,
          { key: f },
          ...g.length > 1 ? g : [p]
        ), f;
      });
    }
  }), Object.keys(o).length === 0)
    return [n];
  const r = [];
  let i = 0;
  const a = /__HTML_[^_]+_[a-z0-9]+__/g;
  let s;
  for (; (s = a.exec(n)) !== null; ) {
    const [c] = s, l = s.index;
    l > i && r.push(n.substring(i, l)), o[c] && r.push(o[c]), i = l + c.length;
  }
  return i < n.length && r.push(n.substring(i)), r.length > 0 ? r : [n];
}, Dc = inl, lnl = ({
  orgSlug: e,
  teamSlug: t
}, n) => {
  const o = qv(e, n);
  return t = t || "", e ? `${o}/${t}` : `${o}/team/${t}`;
};
function dnl({ data: e }) {
  const { t } = Fe(), n = Ro.useRouter(), o = bo.viewer.teams.publish.useMutation({
    onSuccess(i) {
      n.push(i.url);
    },
    onError: (i) => {
      nr(i.message, "error");
    }
  });
  if (!e)
    return null;
  const [r] = e;
  return r ? /* @__PURE__ */ m(
    mg,
    {
      text: t("team_upgrade_banner_description", { teamName: r.team.name }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "button",
        {
          className: "border-b border-b-black",
          onClick: () => {
            o.mutate({ teamId: r.team.id });
          },
          children: t("upgrade_banner_action")
        }
      )
    }
  ) : null;
}
function unl({ data: e }) {
  const { t } = Fe();
  return (e == null ? void 0 : e.user.role) !== "INACTIVE_ADMIN" ? null : /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
    mg,
    {
      text: t("invalid_admin_password", { user: e.user.username }),
      variant: "warning",
      actions: /* @__PURE__ */ m(Po, { href: "/settings/security/password", className: "border-b border-b-black", children: t("change_password_admin") })
    }
  ) });
}
function _nl({ data: e }) {
  const { t } = Fe();
  return e ? /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
    mg,
    {
      text: `${t("something_went_wrong")} ${t("calendar_error")}`,
      variant: "error",
      actions: /* @__PURE__ */ m(Po, { href: "/apps/installed/calendar", className: "border-b border-b-black", children: t("check_here") })
    }
  ) }) : null;
}
function pnl({ data: e }) {
  return e.length === 0 ? null : /* @__PURE__ */ m("div", { children: e.map((t) => /* @__PURE__ */ m(mnl, { name: t.name, slug: t.slug }, t.slug)) });
}
function mnl({ name: e, slug: t }) {
  const { t: n } = Fe(), o = Ro.useRouter(), r = () => {
    o.push(`/apps/${t}`);
  };
  return /* @__PURE__ */ m(
    mg,
    {
      text: ` ${n("invalid_credential", { appName: e })} `,
      variant: "warning",
      actions: /* @__PURE__ */ m("button", { className: "border-b border-b-black", onClick: r, children: n("invalid_credential_action") })
    }
  );
}
function fnl({ data: e }) {
  const t = zj(), { t: n } = Fe(), o = bo.viewer.auth.resendVerifyEmail.useMutation();
  return !e || !t["email-verification"] ? null : /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
    mg,
    {
      icon: "mail",
      text: n("verify_email_banner_body", { appName: Zp }),
      variant: "warning",
      actions: /* @__PURE__ */ m(
        "a",
        {
          className: "underline hover:cursor-pointer",
          onClick: () => {
            o.mutate(), nr(n("email_sent"), "success");
          },
          children: n("resend_email")
        }
      )
    }
  ) });
}
const zm = {
  teamUpgradeBanner: (e) => /* @__PURE__ */ m(dnl, { ...e }),
  orgUpgradeBanner: (e) => /* @__PURE__ */ m(JXc, { ...e }),
  verifyEmailBanner: (e) => /* @__PURE__ */ m(fnl, { ...e }),
  adminPasswordBanner: (e) => /* @__PURE__ */ m(unl, { ...e }),
  impersonationBanner: (e) => /* @__PURE__ */ m(QXc, { ...e }),
  calendarCredentialBanner: (e) => /* @__PURE__ */ m(_nl, { ...e }),
  invalidAppCredentialBanners: (e) => /* @__PURE__ */ m(pnl, { ...e })
}, gnl = ({ banners: e }) => /* @__PURE__ */ m("div", { className: "sticky top-0 z-10 w-full divide-y divide-black", children: Object.keys(e).map((t) => {
  if (t === "teamUpgradeBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "orgUpgradeBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "verifyEmailBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "adminPasswordBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "impersonationBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "calendarCredentialBanner") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  } else if (t === "invalidAppCredentialBanners") {
    const n = zm[t];
    return /* @__PURE__ */ m(n, { data: e[t] }, t);
  }
}) }), hnl = () => {
  var s;
  const { data: e, isPending: t } = bo.viewer.me.getUserTopBanners.useQuery(), { data: n } = sc.useSession();
  if (t || !n)
    return null;
  const o = (n == null ? void 0 : n.user.role) === "INACTIVE_ADMIN", r = (s = n == null ? void 0 : n.user.impersonatedBy) == null ? void 0 : s.id;
  return Object.assign({}, e, {
    adminPasswordBanner: o ? n : null,
    impersonationBanner: r ? n : null
  });
}, vnl = (e) => Tt(() => {
  const n = e && Object.entries(e).filter(([o, r]) => r && (!Array.isArray(r) || r.length > 0));
  return ((n == null ? void 0 : n.length) ?? 0) * Yce;
}, [e]), bnl = () => {
  const e = hnl(), t = vnl(e);
  return { banners: e, bannersHeight: t };
}, ynl = (e) => {
  Le(() => {
    Object.entries(e).forEach(([t, n]) => {
      if (!n)
        return;
      if (t === "root") {
        const i = document.documentElement;
        Object.entries(n).forEach(([a, s]) => {
          i.style.setProperty(`--${a}`, s);
        });
        return;
      }
      const o = document.querySelectorAll(`.${t}`);
      Object.entries(n).forEach(([i, a]) => {
        o.forEach((s) => {
          s.style.setProperty(`--${i}`, a);
        });
      });
    });
  }, [e]);
}, $nl = () => {
  const { data: e } = tk(), t = XTc({
    lightVal: e == null ? void 0 : e.brandColor,
    darkVal: e == null ? void 0 : e.darkBrandColor
  });
  ynl(t), oge(e == null ? void 0 : e.appTheme);
}, rge = (e) => {
  const { banners: t, bannersHeight: n } = bnl();
  return Ro.usePathname(), Rzc(), /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(Y_e, { position: "bottom-right" }) }),
    /* @__PURE__ */ m(KJc, {}),
    /* @__PURE__ */ Y("div", { className: "flex min-h-screen flex-col", children: [
      t && !e.isPlatformUser && /* @__PURE__ */ m(gnl, { banners: t }),
      /* @__PURE__ */ Y("div", { className: "flex flex-1", "data-testid": "dashboard-shell", children: [
        e.SidebarContainer ? w_(e.SidebarContainer, { bannersHeight: n }) : /* @__PURE__ */ m(GXc, { isPlatformUser: e.isPlatformUser, bannersHeight: n }),
        /* @__PURE__ */ m("div", { className: "flex w-0 flex-1 flex-col", children: /* @__PURE__ */ m(Snl, { ...e }) })
      ] })
    ] })
  ] });
}, ige = ({ children: e, withKBar: t = !1 }) => t ? /* @__PURE__ */ Y(FJc, { children: [
  e,
  /* @__PURE__ */ m(VJc, {})
] }) : /* @__PURE__ */ m(Ce, { children: e }), wnl = (e) => {
  const { status: t } = sc.useSession();
  return /* @__PURE__ */ m(ige, { withKBar: t === "authenticated", children: /* @__PURE__ */ m(rge, { ...e }) });
};
function age(e) {
  return yzc(e.isPublic), Szc(), $nl(), e.isPublic ? /* @__PURE__ */ m(wnl, { ...e }) : /* @__PURE__ */ m(ige, { withKBar: !0, children: /* @__PURE__ */ m(rge, { ...e }) });
}
function knl(e) {
  const t = Ro.useRouter(), { isLocaleReady: n } = Fe();
  return /* @__PURE__ */ Y(Ce, { children: [
    (e.heading || !!e.backPath) && /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "bg-default sticky top-0 z-10 mb-0 flex items-center py-2 md:mb-6 md:mt-0",
          e.smallHeading ? "lg:mb-7" : "lg:mb-8"
        ),
        children: [
          !!e.backPath && /* @__PURE__ */ m(
            ut,
            {
              variant: "icon",
              size: "sm",
              color: "minimal",
              onClick: () => typeof e.backPath == "string" ? t.push(e.backPath) : t.back(),
              StartIcon: "arrow-left",
              "aria-label": "Go Back",
              className: "rounded-md ltr:mr-2 rtl:ml-2",
              "data-testid": "go-back-button"
            }
          ),
          e.heading && /* @__PURE__ */ Y(
            "header",
            {
              className: ae(e.large && "py-8", "flex w-full max-w-full items-center truncate"),
              children: [
                e.HeadingLeftIcon && /* @__PURE__ */ m("div", { className: "ltr:mr-4", children: e.HeadingLeftIcon }),
                /* @__PURE__ */ Y(
                  "div",
                  {
                    className: ae("w-full truncate ltr:mr-4 rtl:ml-4 md:block", e.headerClassName),
                    children: [
                      e.heading && /* @__PURE__ */ m(
                        "h3",
                        {
                          className: ae(
                            "font-cal text-emphasis max-w-28 sm:max-w-72 md:max-w-80 hidden truncate text-lg font-semibold tracking-wide sm:text-xl md:block xl:max-w-full",
                            e.smallHeading ? "text-base" : "text-xl"
                          ),
                          children: n ? e.heading : /* @__PURE__ */ m(Jn, { invisible: !0 })
                        }
                      ),
                      e.subtitle && /* @__PURE__ */ m("p", { className: "text-default hidden text-sm md:block", "data-testid": "subtitle", children: n ? e.subtitle : /* @__PURE__ */ m(Jn, { invisible: !0 }) })
                    ]
                  }
                ),
                e.beforeCTAactions,
                e.CTA && /* @__PURE__ */ m(
                  "div",
                  {
                    className: ae(
                      e.backPath ? "relative" : "pwa:bottom-[max(7rem,_calc(5rem_+_env(safe-area-inset-bottom)))] fixed bottom-20 z-40 ltr:right-4 rtl:left-4 md:z-auto md:ltr:right-0 md:rtl:left-0",
                      "flex-shrink-0 [-webkit-app-region:no-drag] md:relative md:bottom-auto md:right-auto"
                    ),
                    children: n && e.CTA
                  }
                ),
                e.actions && e.actions
              ]
            }
          )
        ]
      }
    ),
    e.afterHeading && /* @__PURE__ */ m(Ce, { children: e.afterHeading }),
    /* @__PURE__ */ m("div", { className: ae(e.flexChildrenContainer && "flex flex-1 flex-col"), children: e.children })
  ] });
}
function Snl({
  isPlatformUser: e,
  MobileNavigationContainer: t = /* @__PURE__ */ m(CXc, { isPlatformNavigation: e }),
  TopNavContainer: n = /* @__PURE__ */ m(KXc, {}),
  ...o
}) {
  return /* @__PURE__ */ Y("main", { className: "bg-default relative z-0 flex-1 pb-8 focus:outline-none", children: [
    n,
    /* @__PURE__ */ Y("div", { className: "max-w-full p-2 sm:py-4 lg:px-6", children: [
      /* @__PURE__ */ m(ZJc, {}),
      /* @__PURE__ */ m(Pfe, { children: o.withoutMain ? o.children : /* @__PURE__ */ m(knl, { ...o, children: o.children }) }),
      o.backPath ? null : t
    ] })
  ] });
}
function Bj(e = "Sunday") {
  const n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(e);
  return n !== -1 ? n : 0;
}
function sge(e, t = "Sunday") {
  return (n, o) => {
    const r = ab(e, Bj(t), "short"), i = (a) => {
      for (let s = 0; s < r.length; s++)
        if (a.includes(r[s]))
          return s;
      return -1;
    };
    return i(n) - i(o);
  };
}
function IE({ className: e, ...t }) {
  return e = ae("mx-3 text-muted", e), /* @__PURE__ */ m(
    "svg",
    {
      className: e,
      ...t,
      width: "2",
      height: "16",
      viewBox: "0 0 2 16",
      ry: "6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ m("rect", { width: "2", height: "16", rx: "1", fill: "currentColor" })
    }
  );
}
const xnl = function({
  value: t,
  onChange: n,
  isReady: o,
  disabled: r = !1,
  ...i
}) {
  const [a, s] = ze(!1);
  return /* @__PURE__ */ m("div", { className: "group pointer-events-auto relative truncate", onClick: () => s(!r), children: /* @__PURE__ */ m("div", { className: ci(!r && "cursor-pointer", "flex items-center"), children: /* @__PURE__ */ Y("label", { className: "min-w-8 relative inline-block", children: [
    /* @__PURE__ */ Y("span", { className: "whitespace-pre text-xl tracking-normal text-transparent", children: [
      t,
      " "
    ] }),
    /* @__PURE__ */ m(
      "input",
      {
        ...i,
        disabled: r,
        type: "text",
        value: t,
        required: !0,
        className: ci(
          !r && "hover:text-default focus:text-emphasis cursor-pointer focus:outline-none focus:ring-0",
          "text-emphasis absolute left-0 top-0 w-full truncate border-none bg-transparent p-0 align-top text-xl ",
          i.className
        ),
        onFocus: (l) => {
          s(!r), i.onFocus && i.onFocus(l);
        },
        onBlur: (l) => {
          s(!1), i.onBlur && i.onBlur(l);
        },
        onChange: (l) => n && n(l.target.value)
      }
    ),
    !a && o && !r && /* @__PURE__ */ m(ot, { name: "pencil", className: "text-subtle group-hover:text-subtle -mt-px ml-1 inline  h-3 w-3" })
  ] }) }) });
}, cge = (e) => /* @__PURE__ */ Y("div", { className: uo(e.headerClassName, "flex flex-col px-10 py-4"), children: [
  /* @__PURE__ */ Y("div", { className: "mb-6 flex items-center justify-between md:mb-6 md:mt-0 lg:mb-8", children: [
    /* @__PURE__ */ Y("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ m("div", { children: e.heading }),
      /* @__PURE__ */ m("div", { className: "text-default text-sm", children: e.subtitle })
    ] }),
    /* @__PURE__ */ m("div", { children: e.CTA })
  ] }),
  /* @__PURE__ */ m("div", { children: e.children })
] }), Enl = () => {
  const e = "/timezones", { isLoading: t, data: n } = go({
    queryKey: ["city-timezones"],
    queryFn: () => He == null ? void 0 : He.get(e).then((o) => {
      if (o.data.status === qt)
        return o.data.data;
      throw new Error(o.data.error.message);
    })
  });
  return { isLoading: t, data: n };
}, Tnl = Enl, vZ = (e) => e.map(({ city: t, timezone: n }) => ({
  label: t,
  timezone: n
})), Anl = (e, t) => t.filter(
  (n) => e.includes(n.timezone)
);
function Uj(e) {
  const { isLoading: t, data: n } = Tnl(), o = Tt(() => {
    if (e.timeZones) {
      const r = Anl(e.timeZones, n ?? []);
      return vZ(r);
    } else if (n && !t)
      return vZ(n);
    return [];
  }, [n, e.timeZones, t]);
  return /* @__PURE__ */ m(
    Zpe,
    {
      ...e,
      data: o,
      isPending: t,
      isWebTimezoneSelect: !1
    }
  );
}
const bZ = ({
  disabled: e,
  buttonClassName: t,
  isPending: n,
  onDeleteConfirmed: o,
  handleDelete: r
}) => {
  const { t: i } = Fe();
  return /* @__PURE__ */ Y(Gi, { children: [
    /* @__PURE__ */ m(W0, { asChild: !0, children: /* @__PURE__ */ m(
      ut,
      {
        StartIcon: "trash",
        variant: "icon",
        color: "destructive",
        "aria-label": i("delete"),
        className: t,
        disabled: e,
        tooltip: i(e ? "requires_at_least_one_schedule" : "delete"),
        tooltipSide: "bottom"
      }
    ) }),
    /* @__PURE__ */ m(
      Vf,
      {
        isPending: n,
        variety: "danger",
        title: i("delete_schedule"),
        confirmBtnText: i("delete"),
        loadingText: i("delete"),
        onConfirm: () => {
          r(), o == null || o();
        },
        children: i("delete_schedule_description")
      }
    )
  ] });
}, Cnl = () => {
  const e = m_({ name: "dateOverrides" });
  return Tt(() => e == null ? void 0 : e.map((t) => De(t.ranges[0].start).utc().format("YYYY-MM-DD")), [e]);
}, znl = ({
  workingHours: e,
  userTimeFormat: t,
  travelSchedules: n,
  weekStart: o,
  overridesModalClassNames: r,
  classNames: i,
  handleSubmit: a,
  isDryRun: s = !1
}) => {
  const { append: c, replace: l, fields: d } = B0({
    name: "dateOverrides"
  }), { getValues: u } = Dn(), _ = Cnl(), { t: p } = Fe(), f = () => {
    const g = u();
    s || a(g);
  };
  return /* @__PURE__ */ Y("div", { className: uo("p-6", i == null ? void 0 : i.container), children: [
    /* @__PURE__ */ Y("h3", { className: uo("text-emphasis font-medium leading-6", i == null ? void 0 : i.title), children: [
      p("date_overrides"),
      " ",
      /* @__PURE__ */ m(Ao, { content: p("date_overrides_info"), children: /* @__PURE__ */ m("span", { className: "inline-block align-middle", children: /* @__PURE__ */ m(ot, { name: "info", className: "h-4 w-4" }) }) })
    ] }),
    /* @__PURE__ */ m("p", { className: uo("text-subtle mb-4 text-sm", i == null ? void 0 : i.description), children: p("date_overrides_subtitle") }),
    /* @__PURE__ */ Y("div", { className: "space-y-2", children: [
      /* @__PURE__ */ m(
        lzc,
        {
          excludedDates: _,
          replace: l,
          fields: d,
          weekStart: o,
          workingHours: e,
          userTimeFormat: t,
          hour12: t === 12,
          travelSchedules: n,
          handleAvailabilityUpdate: f,
          isDryRun: s
        }
      ),
      /* @__PURE__ */ m(
        bme,
        {
          className: r,
          workingHours: e,
          excludedDates: _,
          onChange: (g) => {
            g.forEach((h) => c({ ranges: [h] })), f();
          },
          userTimeFormat: t,
          weekStart: o,
          isDryRun: s,
          Trigger: /* @__PURE__ */ m(
            ut,
            {
              className: i == null ? void 0 : i.button,
              color: "secondary",
              StartIcon: "plus",
              "data-testid": "add-override",
              children: p("add_an_override")
            }
          )
        }
      )
    ] })
  ] });
}, Onl = ({ open: e, children: t }) => /* @__PURE__ */ m(
  "div",
  {
    className: ae(
      e ? "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-70 sm:hidden" : ""
    ),
    children: /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "bg-default fixed right-0 z-20 flex h-screen w-80 flex-col space-y-2 overflow-x-hidden rounded-md px-2 pb-3 transition-transform",
          e ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        ),
        children: e ? t : null
      }
    )
  }
), Pnl = it(
  function(t, n) {
    var q;
    const {
      schedule: o,
      travelSchedules: r,
      handleDelete: i,
      isDeleting: a,
      isLoading: s,
      isSaving: c,
      timeFormat: l,
      weekStart: d,
      backPath: u,
      handleSubmit: _,
      isPlatform: p = !1,
      customClassNames: f,
      disableEditableHeading: g = !1,
      enableOverrides: h = !1,
      onFormStateChange: b,
      bulkUpdateModalProps: v,
      allowSetToDefault: $ = !0,
      allowDelete: k = !0,
      callbacksRef: S,
      isDryRun: O
    } = t, [I, D] = ze(!1), { t: M, i18n: N } = Fe(), C = pd({
      defaultValues: {
        ...o,
        schedule: o.availability || []
      }
    }), P = m_({
      control: C.control
    });
    Le(() => {
      b && P && b(P);
    }, [P, b]);
    const [x, w, E] = Tt(() => p ? [cge, hme, Uj] : [age, CCc, xj], [p]), T = Ue(null), z = at(
      (V) => {
        S && V && (S.current = V), T.current ? T.current.click() : C.handleSubmit(async (F) => {
          var L, U, W, H;
          try {
            await _(F), (U = (L = S == null ? void 0 : S.current) == null ? void 0 : L.onSuccess) == null || U.call(L);
          } catch (Q) {
            (H = (W = S == null ? void 0 : S.current) == null ? void 0 : W.onError) == null || H.call(W, Q);
          }
        })();
      },
      [C, _, S]
    ), j = at(async () => ({
      isValid: await C.trigger(),
      errors: C.formState.errors
    }), [C]);
    return Eie(
      n,
      () => ({
        validateForm: j,
        handleFormSubmit: z
      }),
      [j, z]
    ), /* @__PURE__ */ m(
      x,
      {
        headerClassName: uo(f == null ? void 0 : f.containerClassName),
        backPath: u,
        title: o.name ? `${o.name} | ${M("availability")}` : M("availability"),
        heading: /* @__PURE__ */ m(
          Wt,
          {
            control: C.control,
            name: "name",
            render: ({ field: V }) => /* @__PURE__ */ m(
              xnl,
              {
                className: uo(f == null ? void 0 : f.editableHeadingClassName),
                isReady: !s,
                disabled: g,
                ...V,
                "data-testid": "availablity-title"
              }
            )
          }
        ),
        subtitle: o ? o.schedule.filter((V) => !!V.days.length).map(
          (V) => mme(V, {
            locale: N.language,
            hour12: l === 12
          })
        ).sort(sge(N.language, d)).map((V, F) => /* @__PURE__ */ Y("span", { className: uo(f == null ? void 0 : f.subtitlesClassName), children: [
          V,
          /* @__PURE__ */ m("br", {})
        ] }, F)) : /* @__PURE__ */ m(Jn, { className: "h-4 w-48" }),
        CTA: /* @__PURE__ */ Y("div", { className: uo(f == null ? void 0 : f.ctaClassName, "flex items-center justify-end"), children: [
          /* @__PURE__ */ m("div", { className: "sm:hover:bg-muted hidden items-center rounded-md px-2 transition sm:flex", children: !I && $ ? /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              Ks,
              {
                as: Xn,
                htmlFor: "hiddenSwitch",
                className: "mt-2 cursor-pointer self-center pe-2",
                loadingClassName: "me-4",
                waitForTranslation: !p,
                children: M("set_to_default")
              }
            ),
            /* @__PURE__ */ m(
              Wt,
              {
                control: C.control,
                name: "isDefault",
                render: ({ field: { value: V, onChange: F } }) => {
                  var L, U;
                  return /* @__PURE__ */ m(
                    Ri,
                    {
                      id: "hiddenSwitch",
                      classNames: {
                        container: uo((L = f == null ? void 0 : f.hiddenSwitchClassname) == null ? void 0 : L.container),
                        thumb: uo((U = f == null ? void 0 : f.hiddenSwitchClassname) == null ? void 0 : U.thumb)
                      },
                      disabled: c || o.isDefault,
                      checked: V,
                      onCheckedChange: (W) => {
                        F(W), v == null || v.setIsOpen(W);
                      }
                    }
                  );
                }
              }
            ),
            /* @__PURE__ */ m(IE, { className: "hidden sm:inline" })
          ] }) : null }),
          v && (v == null ? void 0 : v.isOpen) && /* @__PURE__ */ m(
            Jpe,
            {
              isPending: v == null ? void 0 : v.isSaving,
              open: v == null ? void 0 : v.isOpen,
              setOpen: v.setIsOpen,
              bulkUpdateFunction: v == null ? void 0 : v.save,
              description: M("default_schedules_bulk_description"),
              eventTypes: v == null ? void 0 : v.eventTypes,
              isEventTypesFetching: v == null ? void 0 : v.isEventTypesFetching,
              handleBulkEditDialogToggle: v.handleBulkEditDialogToggle
            }
          ),
          k && /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              bZ,
              {
                buttonClassName: uo("hidden me-2 sm:inline", f == null ? void 0 : f.deleteButtonClassname),
                disabled: o.isLastSchedule,
                isPending: a,
                handleDelete: i
              }
            ),
            /* @__PURE__ */ m(IE, { className: "hidden sm:inline" })
          ] }),
          /* @__PURE__ */ m(Onl, { open: I, children: /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            "div",
            {
              className: ae(
                I ? "fadeIn fixed inset-0 z-50 bg-neutral-800 bg-opacity-70 transition-opacity dark:bg-opacity-70 sm:hidden" : ""
              ),
              children: /* @__PURE__ */ Y(
                "div",
                {
                  className: ae(
                    "bg-default fixed right-0 z-20 flex h-screen w-80 flex-col space-y-2 overflow-x-hidden rounded-md px-2 pb-3 transition-transform",
                    I ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
                  ),
                  children: [
                    /* @__PURE__ */ Y("div", { className: "flex flex-row items-center pt-16", children: [
                      /* @__PURE__ */ m(ut, { StartIcon: "arrow-left", color: "minimal", onClick: () => D(!1) }),
                      /* @__PURE__ */ m("p", { className: "-ml-2", children: M("availability_settings") }),
                      k && /* @__PURE__ */ m(
                        bZ,
                        {
                          buttonClassName: uo("ml-16 inline", f == null ? void 0 : f.deleteButtonClassname),
                          disabled: o.isLastSchedule,
                          isPending: a,
                          handleDelete: i,
                          onDeleteConfirmed: () => {
                            D(!1);
                          }
                        }
                      )
                    ] }),
                    /* @__PURE__ */ Y("div", { className: "flex flex-col px-2 py-2", children: [
                      /* @__PURE__ */ m(Ks, { as: Xn, waitForTranslation: !p, children: M("name") }),
                      /* @__PURE__ */ m(
                        Wt,
                        {
                          control: C.control,
                          name: "name",
                          render: ({ field: V }) => /* @__PURE__ */ m(
                            "input",
                            {
                              className: "hover:border-emphasis dark:focus:border-emphasis border-default bg-default placeholder:text-muted text-emphasis focus:ring-brand-default disabled:bg-subtle disabled:hover:border-subtle focus:border-subtle mb-2 block h-9 w-full rounded-md border px-3 py-2 text-sm leading-4 focus:outline-none focus:ring-2 disabled:cursor-not-allowed",
                              ...V
                            }
                          )
                        }
                      )
                    ] }),
                    /* @__PURE__ */ m("div", { className: "flex h-9 flex-row-reverse items-center justify-end gap-3 px-2", children: $ && /* @__PURE__ */ Y(Ce, { children: [
                      /* @__PURE__ */ m(
                        Ks,
                        {
                          as: Xn,
                          htmlFor: "hiddenSwitch",
                          className: "mt-2 cursor-pointer self-center pr-2 sm:inline",
                          waitForTranslation: !p,
                          children: M("set_to_default")
                        }
                      ),
                      /* @__PURE__ */ m(
                        Wt,
                        {
                          control: C.control,
                          name: "isDefault",
                          render: ({ field: { value: V, onChange: F } }) => {
                            var L, U;
                            return /* @__PURE__ */ m(
                              Ri,
                              {
                                classNames: {
                                  container: uo((L = f == null ? void 0 : f.hiddenSwitchClassname) == null ? void 0 : L.container),
                                  thumb: uo((U = f == null ? void 0 : f.hiddenSwitchClassname) == null ? void 0 : U.thumb)
                                },
                                id: "hiddenSwitch",
                                disabled: c || V,
                                checked: V,
                                onCheckedChange: F
                              }
                            );
                          }
                        }
                      )
                    ] }) }),
                    /* @__PURE__ */ m("div", { className: "min-w-40 col-span-3 space-y-2 px-2 py-4 lg:col-span-1", children: /* @__PURE__ */ Y("div", { className: "xl:max-w-80 w-full pr-4 sm:ml-0 sm:mr-36 sm:p-0", children: [
                      /* @__PURE__ */ Y("div", { children: [
                        /* @__PURE__ */ m(
                          Ks,
                          {
                            as: Xn,
                            htmlFor: "timeZone-sm-viewport",
                            className: "mb-0 inline-block leading-none",
                            waitForTranslation: !p,
                            children: M("timezone")
                          }
                        ),
                        /* @__PURE__ */ m(
                          Wt,
                          {
                            control: C.control,
                            name: "timeZone",
                            render: ({ field: { onChange: V, value: F } }) => F ? /* @__PURE__ */ m(
                              E,
                              {
                                inputId: "timeZone-sm-viewport",
                                value: F,
                                className: uo(
                                  "focus:border-brand-default border-default mt-1 block w-72 rounded-md text-sm",
                                  f == null ? void 0 : f.timezoneSelectClassName
                                ),
                                onChange: (L) => V(L.value)
                              }
                            ) : /* @__PURE__ */ m(uY, { className: "mt-1 w-72" })
                          }
                        )
                      ] }),
                      !p && /* @__PURE__ */ Y(Ce, { children: [
                        /* @__PURE__ */ m("hr", { className: "border-subtle my-7" }),
                        /* @__PURE__ */ Y("div", { className: "rounded-md md:block", children: [
                          /* @__PURE__ */ m(
                            Ks,
                            {
                              as: "h3",
                              className: "mb-0 inline-block text-sm font-medium",
                              waitForTranslation: !p,
                              children: M("something_doesnt_look_right")
                            }
                          ),
                          /* @__PURE__ */ m("div", { className: "mt-3 flex", children: /* @__PURE__ */ m(
                            Ks,
                            {
                              as: ut,
                              href: "/availability/troubleshoot",
                              color: "secondary",
                              waitForTranslation: !p,
                              children: M("launch_troubleshooter")
                            }
                          ) })
                        ] })
                      ] })
                    ] }) })
                  ]
                }
              )
            }
          ) }) }),
          /* @__PURE__ */ m("div", { className: "border-default border-l-2" }),
          /* @__PURE__ */ m(
            ut,
            {
              ref: T,
              className: "ml-4 lg:ml-0",
              type: "submit",
              form: "availability-form",
              loading: c,
              children: M("save")
            }
          ),
          /* @__PURE__ */ m(
            ut,
            {
              className: "ml-3 sm:hidden",
              StartIcon: "ellipsis-vertical",
              variant: "icon",
              color: "secondary",
              onClick: () => D(!0)
            }
          )
        ] }),
        children: /* @__PURE__ */ m("div", { className: "mt-4 w-full md:mt-0", children: /* @__PURE__ */ Y(
          fd,
          {
            form: C,
            id: "availability-form",
            handleSubmit: async (V) => {
              _(V);
            },
            className: uo(f == null ? void 0 : f.formClassName, "flex flex-col sm:mx-0 xl:flex-row xl:space-x-6"),
            children: [
              /* @__PURE__ */ Y("div", { className: "flex-1 flex-row xl:mr-0", children: [
                /* @__PURE__ */ m(
                  "div",
                  {
                    className: uo(
                      "border-subtle mb-6 rounded-md border",
                      (q = f == null ? void 0 : f.scheduleClassNames) == null ? void 0 : q.scheduleContainer
                    ),
                    children: /* @__PURE__ */ m("div", { children: typeof d == "string" && /* @__PURE__ */ m(
                      w,
                      {
                        labels: {
                          addTime: M("add_time_availability"),
                          copyTime: M("copy_times_to"),
                          deleteTime: M("delete")
                        },
                        classNames: f != null && f.scheduleClassNames ? { ...f.scheduleClassNames } : {},
                        control: C.control,
                        name: "schedule",
                        userTimeFormat: l,
                        weekStart: [
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday"
                        ].indexOf(d)
                      }
                    ) })
                  }
                ),
                h && /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(
                  znl,
                  {
                    isDryRun: O,
                    workingHours: o.workingHours,
                    userTimeFormat: l,
                    handleSubmit: _,
                    travelSchedules: r,
                    weekStart: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(
                      d
                    ),
                    overridesModalClassNames: f == null ? void 0 : f.overridesModalClassNames,
                    classNames: f == null ? void 0 : f.dateOverrideClassNames
                  }
                ) })
              ] }),
              /* @__PURE__ */ m("div", { className: "min-w-40 col-span-3 hidden space-y-2 md:block lg:col-span-1", children: /* @__PURE__ */ Y("div", { className: "xl:max-w-80 w-full pr-4 sm:ml-0 sm:mr-36 sm:p-0", children: [
                /* @__PURE__ */ Y("div", { children: [
                  /* @__PURE__ */ m(
                    Ks,
                    {
                      as: Xn,
                      htmlFor: "timeZone-lg-viewport",
                      className: "mb-0 inline-block leading-none",
                      waitForTranslation: !p,
                      children: M("timezone")
                    }
                  ),
                  /* @__PURE__ */ m(
                    Wt,
                    {
                      name: "timeZone",
                      render: ({ field: { onChange: V, value: F } }) => F ? /* @__PURE__ */ m(
                        E,
                        {
                          inputId: "timeZone-lg-viewport",
                          value: F,
                          className: "focus:border-brand-default border-default mt-1 block w-72 rounded-md text-sm",
                          onChange: (L) => V(L.value)
                        }
                      ) : /* @__PURE__ */ m(uY, { className: "mt-1 w-72" })
                    }
                  )
                ] }),
                p ? /* @__PURE__ */ m(Ce, {}) : /* @__PURE__ */ Y(Ce, { children: [
                  /* @__PURE__ */ m("hr", { className: "border-subtle my-6 mr-8" }),
                  /* @__PURE__ */ Y("div", { className: "rounded-md", children: [
                    /* @__PURE__ */ m(
                      Ks,
                      {
                        as: "h3",
                        className: "mb-0 inline-block text-sm font-medium",
                        waitForTranslation: !p,
                        children: M("something_doesnt_look_right")
                      }
                    ),
                    /* @__PURE__ */ m("div", { className: "mt-3 flex", children: /* @__PURE__ */ m(
                      Ks,
                      {
                        as: ut,
                        href: "/availability/troubleshoot",
                        color: "secondary",
                        waitForTranslation: !p,
                        children: M("launch_troubleshooter")
                      }
                    ) })
                  ] })
                ] })
              ] }) })
            ]
          }
        ) })
      }
    );
  }
), dfd = it(function(t, n) {
  var E;
  const {
    id: o,
    customClassNames: r,
    onDeleteError: i,
    onDeleteSuccess: a,
    onUpdateError: s,
    onUpdateSuccess: c,
    disableEditableHeading: l = !1,
    enableOverrides: d = !1,
    onBeforeUpdate: u,
    onFormStateChange: _,
    allowDelete: p,
    allowSetToDefault: f,
    disableToasts: g,
    isDryRun: h = !1,
    noScheduleChildren: b,
    loadingStateChildren: v
  } = t, { isLoading: $, data: k } = gce(o), { data: S } = sg(), { timeFormat: O } = (S == null ? void 0 : S.data) || { timeFormat: null }, { toast: I } = C_(), { mutate: D, isPending: M } = vce({
    onSuccess: (T) => {
      a == null || a(T), g || I({
        description: "Schedule deleted successfully"
      });
    },
    onError: (T) => {
      i == null || i(T), g || I({
        description: "Could not delete schedule"
      });
    }
  }), N = Ue({}), { mutate: C, isPending: P } = hce({
    onSuccess: (T) => {
      var z, j;
      c == null || c(T), g || I({
        description: "Schedule updated successfully"
      }), (j = (z = N.current) == null ? void 0 : z.onSuccess) == null || j.call(z);
    },
    onError: (T) => {
      var z, j;
      s == null || s(T), g || I({
        description: "Could not update schedule"
      }), (j = (z = N.current) == null ? void 0 : z.onError) == null || j.call(z, T);
    }
  }), x = async (T) => {
    await D({ id: T });
  }, w = async (T, z) => {
    let j = !0;
    u && (j = await u(z)), j && C({
      scheduleId: T,
      body: {
        ...z,
        dateOverrides: z.dateOverrides.flatMap((q) => q.ranges)
      }
    });
  };
  return $ ? /* @__PURE__ */ m(Ce, { children: v || /* @__PURE__ */ m("div", { className: "px-10 py-4 text-xl", children: "Loading..." }) }) : k ? /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    Pnl,
    {
      ref: n,
      disableEditableHeading: l,
      handleDelete: () => {
        h && I({
          description: "Schedule deleted successfully"
        }), !h && k.id && x(k.id);
      },
      handleSubmit: async (T) => {
        h && I({
          description: "Schedule updated successfully"
        }), !h && k.id && w(k.id, T);
      },
      weekStart: ((E = S == null ? void 0 : S.data) == null ? void 0 : E.weekStart) || "Sunday",
      timeFormat: O,
      enableOverrides: d,
      isLoading: $,
      schedule: {
        name: k.name,
        id: k.id,
        isLastSchedule: k.isLastSchedule,
        isDefault: k.isDefault,
        workingHours: k.workingHours,
        dateOverrides: k.dateOverrides,
        timeZone: k.timeZone,
        availability: k.availability,
        schedule: k.schedule.reduce(
          (T, z) => [
            ...T,
            { days: z.days, startTime: new Date(z.startTime), endTime: new Date(z.endTime) }
          ],
          []
        ) || []
      },
      isDeleting: M,
      isSaving: P,
      backPath: "",
      isPlatform: !0,
      customClassNames: r,
      allowDelete: p,
      allowSetToDefault: f,
      onFormStateChange: _,
      callbacksRef: N,
      isDryRun: h
    }
  ) }) : b ? /* @__PURE__ */ m(Ce, { children: b }) : /* @__PURE__ */ m("div", { className: "px-10 py-4 text-xl", children: "No user schedule present" });
});
var Inl = gd, Rnl = function() {
  return Inl.Date.now();
}, Nnl = Rnl, Dnl = /\s/;
function Mnl(e) {
  for (var t = e.length; t-- && Dnl.test(e.charAt(t)); )
    ;
  return t;
}
var Lnl = Mnl, qnl = Lnl, jnl = /^\s+/;
function Fnl(e) {
  return e && e.slice(0, qnl(e) + 1).replace(jnl, "");
}
var Vnl = Fnl, Bnl = lb, Unl = I_, Wnl = "[object Symbol]";
function Gnl(e) {
  return typeof e == "symbol" || Unl(e) && Bnl(e) == Wnl;
}
var JA = Gnl, Hnl = Vnl, yZ = Al, Knl = JA, $Z = NaN, Ynl = /^[-+]0x[0-9a-f]+$/i, Znl = /^0b[01]+$/i, Qnl = /^0o[0-7]+$/i, Jnl = parseInt;
function Xnl(e) {
  if (typeof e == "number")
    return e;
  if (Knl(e))
    return $Z;
  if (yZ(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = yZ(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Hnl(e);
  var n = Znl.test(e);
  return n || Qnl.test(e) ? Jnl(e.slice(2), n ? 2 : 8) : Ynl.test(e) ? $Z : +e;
}
var lge = Xnl, eol = Al, A6 = Nnl, wZ = lge, tol = "Expected a function", nol = Math.max, ool = Math.min;
function rol(e, t, n) {
  var o, r, i, a, s, c, l = 0, d = !1, u = !1, _ = !0;
  if (typeof e != "function")
    throw new TypeError(tol);
  t = wZ(t) || 0, eol(n) && (d = !!n.leading, u = "maxWait" in n, i = u ? nol(wZ(n.maxWait) || 0, t) : i, _ = "trailing" in n ? !!n.trailing : _);
  function p(O) {
    var I = o, D = r;
    return o = r = void 0, l = O, a = e.apply(D, I), a;
  }
  function f(O) {
    return l = O, s = setTimeout(b, t), d ? p(O) : a;
  }
  function g(O) {
    var I = O - c, D = O - l, M = t - I;
    return u ? ool(M, i - D) : M;
  }
  function h(O) {
    var I = O - c, D = O - l;
    return c === void 0 || I >= t || I < 0 || u && D >= i;
  }
  function b() {
    var O = A6();
    if (h(O))
      return v(O);
    s = setTimeout(b, g(O));
  }
  function v(O) {
    return s = void 0, _ && o ? p(O) : (o = r = void 0, a);
  }
  function $() {
    s !== void 0 && clearTimeout(s), l = 0, o = c = r = s = void 0;
  }
  function k() {
    return s === void 0 ? a : v(A6());
  }
  function S() {
    var O = A6(), I = h(O);
    if (o = arguments, r = this, c = O, I) {
      if (s === void 0)
        return f(c);
      if (u)
        return clearTimeout(s), s = setTimeout(b, t), p(c);
    }
    return s === void 0 && (s = setTimeout(b, t)), a;
  }
  return S.cancel = $, S.flush = k, S;
}
var iol = rol;
const aol = /* @__PURE__ */ Zr(iol), dge = No({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), XA = No({}), Wj = No(null), eC = typeof document < "u", RE = eC ? ts : Le, Gj = No({ strict: !1 });
function sol(e, t, n, o) {
  const { visualElement: r } = Pn(XA), i = Pn(Gj), a = Pn(Wj), s = Pn(dge).reducedMotion, c = Ue();
  o = o || i.renderer, !c.current && o && (c.current = o(e, {
    visualState: t,
    parent: r,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: s
  }));
  const l = c.current;
  return Tie(() => {
    l && l.update(n, a);
  }), RE(() => {
    l && l.render();
  }), Le(() => {
    l && l.updateFeatures();
  }), (window.HandoffAppearAnimations ? RE : Le)(() => {
    l && l.animationState && l.animationState.animateChanges();
  }), l;
}
function uge(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function col(e, t, n) {
  return at(
    (o) => {
      o && e.mount && e.mount(o), t && (o ? t.mount(o) : t.unmount()), n && (typeof n == "function" ? n(o) : uge(n) && (n.current = o));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function Bw(e) {
  return typeof e == "string" || Array.isArray(e);
}
function tC(e) {
  return typeof e == "object" && typeof e.start == "function";
}
const Hj = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Kj = ["initial", ...Hj];
function nC(e) {
  return tC(e.animate) || Kj.some((t) => Bw(e[t]));
}
function _ge(e) {
  return !!(nC(e) || e.variants);
}
function lol(e, t) {
  if (nC(e)) {
    const { initial: n, animate: o } = e;
    return {
      initial: n === !1 || Bw(n) ? n : void 0,
      animate: Bw(o) ? o : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function dol(e) {
  const { initial: t, animate: n } = lol(e, Pn(XA));
  return Tt(() => ({ initial: t, animate: n }), [kZ(t), kZ(n)]);
}
function kZ(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const SZ = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Uw = {};
for (const e in SZ)
  Uw[e] = {
    isEnabled: (t) => SZ[e].some((n) => !!t[n])
  };
function UM(e) {
  for (const t in e)
    Uw[t] = {
      ...Uw[t],
      ...e[t]
    };
}
const pge = No({}), uol = No({}), _ol = Symbol.for("motionComponentSymbol");
function pol({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: o, Component: r }) {
  e && UM(e);
  function i(s, c) {
    let l;
    const d = {
      ...Pn(dge),
      ...s,
      layoutId: mol(s)
    }, { isStatic: u } = d, _ = dol(s), p = o(s, u);
    if (!u && eC) {
      _.visualElement = sol(r, p, d, t);
      const f = Pn(uol), g = Pn(Gj).strict;
      _.visualElement && (l = _.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        d,
        g,
        e,
        f
      ));
    }
    return $e.createElement(
      XA.Provider,
      { value: _ },
      l && _.visualElement ? $e.createElement(l, { visualElement: _.visualElement, ...d }) : null,
      n(r, s, col(p, _.visualElement, c), p, u, _.visualElement)
    );
  }
  const a = it(i);
  return a[_ol] = r, a;
}
function mol({ layoutId: e }) {
  const t = Pn(pge).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function fol(e) {
  function t(o, r = {}) {
    return pol(e(o, r));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, r) => (n.has(r) || n.set(r, t(r)), n.get(r))
  });
}
const gol = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Yj(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(gol.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const hol = {}, rk = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], fg = new Set(rk);
function mge(e, { layout: t, layoutId: n }) {
  return fg.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!hol[e] || e === "opacity");
}
const es = (e) => !!(e && e.getVelocity), vol = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, bol = rk.length;
function yol(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, o, r) {
  let i = "";
  for (let a = 0; a < bol; a++) {
    const s = rk[a];
    if (e[s] !== void 0) {
      const c = vol[s] || s;
      i += `${c}(${e[s]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), r ? i = r(e, o ? "" : i) : n && o && (i = "none"), i;
}
const fge = (e) => (t) => typeof t == "string" && t.startsWith(e), gge = fge("--"), WM = fge("var(--"), $ol = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, wol = (e, t) => t && typeof e == "number" ? t.transform(e) : e, jv = (e, t, n) => Math.min(Math.max(n, e), t), gg = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, F$ = {
  ...gg,
  transform: (e) => jv(0, 1, e)
}, K2 = {
  ...gg,
  default: 1
}, V$ = (e) => Math.round(e * 1e5) / 1e5, oC = /(-)?([\d]*\.?[\d])+/g, hge = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, kol = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function ik(e) {
  return typeof e == "string";
}
const ak = (e) => ({
  test: (t) => ik(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), mp = ak("deg"), Hh = ak("%"), Wn = ak("px"), Sol = ak("vh"), xol = ak("vw"), xZ = {
  ...Hh,
  parse: (e) => Hh.parse(e) / 100,
  transform: (e) => Hh.transform(e * 100)
}, EZ = {
  ...gg,
  transform: Math.round
}, vge = {
  // Border props
  borderWidth: Wn,
  borderTopWidth: Wn,
  borderRightWidth: Wn,
  borderBottomWidth: Wn,
  borderLeftWidth: Wn,
  borderRadius: Wn,
  radius: Wn,
  borderTopLeftRadius: Wn,
  borderTopRightRadius: Wn,
  borderBottomRightRadius: Wn,
  borderBottomLeftRadius: Wn,
  // Positioning props
  width: Wn,
  maxWidth: Wn,
  height: Wn,
  maxHeight: Wn,
  size: Wn,
  top: Wn,
  right: Wn,
  bottom: Wn,
  left: Wn,
  // Spacing props
  padding: Wn,
  paddingTop: Wn,
  paddingRight: Wn,
  paddingBottom: Wn,
  paddingLeft: Wn,
  margin: Wn,
  marginTop: Wn,
  marginRight: Wn,
  marginBottom: Wn,
  marginLeft: Wn,
  // Transform props
  rotate: mp,
  rotateX: mp,
  rotateY: mp,
  rotateZ: mp,
  scale: K2,
  scaleX: K2,
  scaleY: K2,
  scaleZ: K2,
  skew: mp,
  skewX: mp,
  skewY: mp,
  distance: Wn,
  translateX: Wn,
  translateY: Wn,
  translateZ: Wn,
  x: Wn,
  y: Wn,
  z: Wn,
  perspective: Wn,
  transformPerspective: Wn,
  opacity: F$,
  originX: xZ,
  originY: xZ,
  originZ: Wn,
  // Misc
  zIndex: EZ,
  // SVG
  fillOpacity: F$,
  strokeOpacity: F$,
  numOctaves: EZ
};
function Zj(e, t, n, o) {
  const { style: r, vars: i, transform: a, transformOrigin: s } = e;
  let c = !1, l = !1, d = !0;
  for (const u in t) {
    const _ = t[u];
    if (gge(u)) {
      i[u] = _;
      continue;
    }
    const p = vge[u], f = wol(_, p);
    if (fg.has(u)) {
      if (c = !0, a[u] = f, !d)
        continue;
      _ !== (p.default || 0) && (d = !1);
    } else
      u.startsWith("origin") ? (l = !0, s[u] = f) : r[u] = f;
  }
  if (t.transform || (c || o ? r.transform = yol(e.transform, n, d, o) : r.transform && (r.transform = "none")), l) {
    const { originX: u = "50%", originY: _ = "50%", originZ: p = 0 } = s;
    r.transformOrigin = `${u} ${_} ${p}`;
  }
}
const Qj = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function bge(e, t, n) {
  for (const o in t)
    !es(t[o]) && !mge(o, n) && (e[o] = t[o]);
}
function Eol({ transformTemplate: e }, t, n) {
  return Tt(() => {
    const o = Qj();
    return Zj(o, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, o.vars, o.style);
  }, [t]);
}
function Tol(e, t, n) {
  const o = e.style || {}, r = {};
  return bge(r, o, e), Object.assign(r, Eol(e, t, n)), e.transformValues ? e.transformValues(r) : r;
}
function Aol(e, t, n) {
  const o = {}, r = Tol(e, t, n);
  return e.drag && e.dragListener !== !1 && (o.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (o.tabIndex = 0), o.style = r, o;
}
const Col = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function NE(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || Col.has(e);
}
let yge = (e) => !NE(e);
function zol(e) {
  e && (yge = (t) => t.startsWith("on") ? !NE(t) : e(t));
}
try {
  zol(require("@emotion/is-prop-valid").default);
} catch {
}
function Ool(e, t, n) {
  const o = {};
  for (const r in e)
    r === "values" && typeof e.values == "object" || (yge(r) || n === !0 && NE(r) || !t && !NE(r) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && r.startsWith("onDrag")) && (o[r] = e[r]);
  return o;
}
function TZ(e, t, n) {
  return typeof e == "string" ? e : Wn.transform(t + n * e);
}
function Pol(e, t, n) {
  const o = TZ(t, e.x, e.width), r = TZ(n, e.y, e.height);
  return `${o} ${r}`;
}
const Iol = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Rol = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Nol(e, t, n = 1, o = 0, r = !0) {
  e.pathLength = 1;
  const i = r ? Iol : Rol;
  e[i.offset] = Wn.transform(-o);
  const a = Wn.transform(t), s = Wn.transform(n);
  e[i.array] = `${a} ${s}`;
}
function Jj(e, {
  attrX: t,
  attrY: n,
  attrScale: o,
  originX: r,
  originY: i,
  pathLength: a,
  pathSpacing: s = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, d, u, _) {
  if (Zj(e, l, d, _), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: f, dimensions: g } = e;
  p.transform && (g && (f.transform = p.transform), delete p.transform), g && (r !== void 0 || i !== void 0 || f.transform) && (f.transformOrigin = Pol(g, r !== void 0 ? r : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), o !== void 0 && (p.scale = o), a !== void 0 && Nol(p, a, s, c, !1);
}
const $ge = () => ({
  ...Qj(),
  attrs: {}
}), Xj = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Dol(e, t, n, o) {
  const r = Tt(() => {
    const i = $ge();
    return Jj(i, t, { enableHardwareAcceleration: !1 }, Xj(o), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    bge(i, e.style, e), r.style = { ...i, ...r.style };
  }
  return r;
}
function Mol(e = !1) {
  return (n, o, r, { latestValues: i }, a) => {
    const c = (Yj(n) ? Dol : Aol)(o, i, a, n), d = {
      ...Ool(o, typeof n == "string", e),
      ...c,
      ref: r
    }, { children: u } = o, _ = Tt(() => es(u) ? u.get() : u, [u]);
    return Pe(n, {
      ...d,
      children: _
    });
  };
}
const eF = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function wge(e, { style: t, vars: n }, o, r) {
  Object.assign(e.style, t, r && r.getProjectionStyles(o));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const kge = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Sge(e, t, n, o) {
  wge(e, t, void 0, o);
  for (const r in t.attrs)
    e.setAttribute(kge.has(r) ? r : eF(r), t.attrs[r]);
}
function tF(e, t) {
  const { style: n } = e, o = {};
  for (const r in n)
    (es(n[r]) || t.style && es(t.style[r]) || mge(r, e)) && (o[r] = n[r]);
  return o;
}
function xge(e, t) {
  const n = tF(e, t);
  for (const o in e)
    if (es(e[o]) || es(t[o])) {
      const r = rk.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      n[r] = e[o];
    }
  return n;
}
function nF(e, t, n, o = {}, r = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, o, r)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, o, r)), t;
}
function DE(e) {
  const t = Ue(null);
  return t.current === null && (t.current = e()), t.current;
}
const ME = (e) => Array.isArray(e), Lol = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), qol = (e) => ME(e) ? e[e.length - 1] || 0 : e;
function jol(e) {
  const t = es(e) ? e.get() : e;
  return Lol(t) ? t.toValue() : t;
}
function Fol({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, o, r, i) {
  const a = {
    latestValues: Vol(o, r, i, e),
    renderState: t()
  };
  return n && (a.mount = (s) => n(o, s, a)), a;
}
const Ege = (e) => (t, n) => {
  const o = Pn(XA), r = Pn(Wj), i = () => Fol(e, t, o, r);
  return n ? i() : DE(i);
};
function Vol(e, t, n, o) {
  const r = {}, i = o(e, {});
  for (const _ in i)
    r[_] = jol(i[_]);
  let { initial: a, animate: s } = e;
  const c = nC(e), l = _ge(e);
  t && l && !c && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let d = n ? n.initial === !1 : !1;
  d = d || a === !1;
  const u = d ? s : a;
  return u && typeof u != "boolean" && !tC(u) && (Array.isArray(u) ? u : [u]).forEach((p) => {
    const f = nF(e, p);
    if (!f)
      return;
    const { transitionEnd: g, transition: h, ...b } = f;
    for (const v in b) {
      let $ = b[v];
      if (Array.isArray($)) {
        const k = d ? $.length - 1 : 0;
        $ = $[k];
      }
      $ !== null && (r[v] = $);
    }
    for (const v in g)
      r[v] = g[v];
  }), r;
}
const Bol = {
  useVisualState: Ege({
    scrapeMotionValuesFromProps: xge,
    createRenderState: $ge,
    onMount: (e, t, { renderState: n, latestValues: o }) => {
      try {
        n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Jj(n, o, { enableHardwareAcceleration: !1 }, Xj(t.tagName), e.transformTemplate), Sge(t, n);
    }
  })
}, Uol = {
  useVisualState: Ege({
    scrapeMotionValuesFromProps: tF,
    createRenderState: Qj
  })
};
function Wol(e, { forwardMotionProps: t = !1 }, n, o) {
  return {
    ...Yj(e) ? Bol : Uol,
    preloadedFeatures: n,
    useRender: Mol(t),
    createVisualElement: o,
    Component: e
  };
}
function df(e, t, n, o = { passive: !0 }) {
  return e.addEventListener(t, n, o), () => e.removeEventListener(t, n);
}
const Gol = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function Tge(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const Hol = (e) => (t) => Gol(t) && e(t, Tge(t));
function nx(e, t, n, o) {
  return df(e, t, Hol(n), o);
}
const Kol = (e, t) => (n) => t(e(n)), Af = (...e) => e.reduce(Kol);
function Age(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const AZ = Age("dragHorizontal"), CZ = Age("dragVertical");
function Yol(e) {
  let t = !1;
  if (e === "y")
    t = CZ();
  else if (e === "x")
    t = AZ();
  else {
    const n = AZ(), o = CZ();
    n && o ? t = () => {
      n(), o();
    } : (n && n(), o && o());
  }
  return t;
}
function Cge() {
  const e = Yol(!0);
  return e ? (e(), !1) : !0;
}
class db {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function Zol(e) {
  let t = [], n = [], o = 0, r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, l = !1, d = !1) => {
      const u = d && r, _ = u ? t : n;
      return l && a.add(c), _.indexOf(c) === -1 && (_.push(c), u && r && (o = t.length)), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      const l = n.indexOf(c);
      l !== -1 && n.splice(l, 1), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (r) {
        i = !0;
        return;
      }
      if (r = !0, [t, n] = [n, t], n.length = 0, o = t.length, o)
        for (let l = 0; l < o; l++) {
          const d = t[l];
          d(c), a.has(d) && (s.schedule(d), e());
        }
      r = !1, i && (i = !1, s.process(c));
    }
  };
  return s;
}
const Wd = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
}, Qol = 40;
let GM = !0, Ww = !1;
const rC = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], oF = rC.reduce((e, t) => (e[t] = Zol(() => Ww = !0), e), {}), Jol = (e) => oF[e].process(Wd), zge = (e) => {
  Ww = !1, Wd.delta = GM ? 1e3 / 60 : Math.max(Math.min(e - Wd.timestamp, Qol), 1), Wd.timestamp = e, Wd.isProcessing = !0, rC.forEach(Jol), Wd.isProcessing = !1, Ww && (GM = !1, requestAnimationFrame(zge));
}, Xol = () => {
  Ww = !0, GM = !0, Wd.isProcessing || requestAnimationFrame(zge);
}, Js = rC.reduce((e, t) => {
  const n = oF[t];
  return e[t] = (o, r = !1, i = !1) => (Ww || Xol(), n.schedule(o, r, i)), e;
}, {});
function LE(e) {
  rC.forEach((t) => oF[t].cancel(e));
}
function zZ(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), o = "onHover" + (t ? "Start" : "End"), r = (i, a) => {
    if (i.type === "touch" || Cge())
      return;
    const s = e.getProps();
    e.animationState && s.whileHover && e.animationState.setActive("whileHover", t), s[o] && Js.update(() => s[o](i, a));
  };
  return nx(e.current, n, r, {
    passive: !e.getProps()[o]
  });
}
class erl extends db {
  mount() {
    this.unmount = Af(zZ(this.node, !0), zZ(this.node, !1));
  }
  unmount() {
  }
}
class trl extends db {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Af(df(this.node.current, "focus", () => this.onFocus()), df(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Oge = (e, t) => t ? e === t ? !0 : Oge(e, t.parentElement) : !1, Zs = (e) => e;
function C6(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, Tge(n));
}
class nrl extends db {
  constructor() {
    super(...arguments), this.removeStartListeners = Zs, this.removeEndListeners = Zs, this.removeAccessibleListeners = Zs, this.startPointerPress = (t, n) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const o = this.node.getProps(), i = nx(window, "pointerup", (s, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: d } = this.node.getProps();
        Js.update(() => {
          Oge(this.node.current, s.target) ? l && l(s, c) : d && d(s, c);
        });
      }, { passive: !(o.onTap || o.onPointerUp) }), a = nx(window, "pointercancel", (s, c) => this.cancelPress(s, c), { passive: !(o.onTapCancel || o.onPointerCancel) });
      this.removeEndListeners = Af(i, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const a = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || C6("up", (c, l) => {
            const { onTap: d } = this.node.getProps();
            d && Js.update(() => d(c, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = df(this.node.current, "keyup", a), C6("down", (s, c) => {
          this.startPress(s, c);
        });
      }, n = df(this.node.current, "keydown", t), o = () => {
        this.isPressing && C6("cancel", (i, a) => this.cancelPress(i, a));
      }, r = df(this.node.current, "blur", o);
      this.removeAccessibleListeners = Af(n, r);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: o, whileTap: r } = this.node.getProps();
    r && this.node.animationState && this.node.animationState.setActive("whileTap", !0), o && Js.update(() => o(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Cge();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: o } = this.node.getProps();
    o && Js.update(() => o(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = nx(this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), o = df(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Af(n, o);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const HM = /* @__PURE__ */ new WeakMap(), z6 = /* @__PURE__ */ new WeakMap(), orl = (e) => {
  const t = HM.get(e.target);
  t && t(e);
}, rrl = (e) => {
  e.forEach(orl);
};
function irl({ root: e, ...t }) {
  const n = e || document;
  z6.has(n) || z6.set(n, {});
  const o = z6.get(n), r = JSON.stringify(t);
  return o[r] || (o[r] = new IntersectionObserver(rrl, { root: e, ...t })), o[r];
}
function arl(e, t, n) {
  const o = irl(t);
  return HM.set(e, n), o.observe(e), () => {
    HM.delete(e), o.unobserve(e);
  };
}
const srl = {
  some: 0,
  all: 1
};
class crl extends db {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: o, amount: r = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: o,
      threshold: typeof r == "number" ? r : srl[r]
    }, s = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, i && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: d, onViewportLeave: u } = this.node.getProps(), _ = l ? d : u;
      _ && _(c);
    };
    return arl(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(lrl(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function lrl({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const drl = {
  inView: {
    Feature: crl
  },
  tap: {
    Feature: nrl
  },
  focus: {
    Feature: trl
  },
  hover: {
    Feature: erl
  }
};
function Pge(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let o = 0; o < n; o++)
    if (t[o] !== e[o])
      return !1;
  return !0;
}
function url(e) {
  const t = {};
  return e.values.forEach((n, o) => t[o] = n.get()), t;
}
function _rl(e) {
  const t = {};
  return e.values.forEach((n, o) => t[o] = n.getVelocity()), t;
}
function iC(e, t, n) {
  const o = e.getProps();
  return nF(o, t, n !== void 0 ? n : o.custom, url(e), _rl(e));
}
const prl = "framerAppearId", mrl = "data-" + eF(prl);
let frl = Zs, aC = Zs;
const Vp = (e) => e * 1e3, v_ = (e) => e / 1e3, grl = {
  current: !1
}, Ige = (e) => Array.isArray(e) && typeof e[0] == "number";
function Rge(e) {
  return !!(!e || typeof e == "string" && Nge[e] || Ige(e) || Array.isArray(e) && e.every(Rge));
}
const p$ = ([e, t, n, o]) => `cubic-bezier(${e}, ${t}, ${n}, ${o})`, Nge = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: p$([0, 0.65, 0.55, 1]),
  circOut: p$([0.55, 0, 1, 0.45]),
  backIn: p$([0.31, 0.01, 0.66, -0.59]),
  backOut: p$([0.33, 1.53, 0.69, 0.99])
};
function Dge(e) {
  if (e)
    return Ige(e) ? p$(e) : Array.isArray(e) ? e.map(Dge) : Nge[e];
}
function hrl(e, t, n, { delay: o = 0, duration: r, repeat: i = 0, repeatType: a = "loop", ease: s, times: c } = {}) {
  const l = { [t]: n };
  c && (l.offset = c);
  const d = Dge(s);
  return Array.isArray(d) && (l.easing = d), e.animate(l, {
    delay: o,
    duration: r,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
const OZ = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, O6 = {}, Mge = {};
for (const e in OZ)
  Mge[e] = () => (O6[e] === void 0 && (O6[e] = OZ[e]()), O6[e]);
function vrl(e, { repeat: t, repeatType: n = "loop" }) {
  const o = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[o];
}
const Lge = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, brl = 1e-7, yrl = 12;
function $rl(e, t, n, o, r) {
  let i, a, s = 0;
  do
    a = t + (n - t) / 2, i = Lge(a, o, r) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > brl && ++s < yrl);
  return a;
}
function ub(e, t, n, o) {
  if (e === t && n === o)
    return Zs;
  const r = (i) => $rl(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : Lge(r(i), t, o);
}
const wrl = ub(0.42, 0, 1, 1), krl = ub(0, 0, 0.58, 1), qge = ub(0.42, 0, 0.58, 1), jge = (e) => Array.isArray(e) && typeof e[0] != "number", Fge = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Vge = (e) => (t) => 1 - e(1 - t), Bge = (e) => 1 - Math.sin(Math.acos(e)), Uge = Vge(Bge), Srl = Fge(Uge), Wge = ub(0.33, 1.53, 0.69, 0.99), rF = Vge(Wge), xrl = Fge(rF), Erl = (e) => (e *= 2) < 1 ? 0.5 * rF(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Trl = {
  linear: Zs,
  easeIn: wrl,
  easeInOut: qge,
  easeOut: krl,
  circIn: Bge,
  circInOut: Srl,
  circOut: Uge,
  backIn: rF,
  backInOut: xrl,
  backOut: Wge,
  anticipate: Erl
}, PZ = (e) => {
  if (Array.isArray(e)) {
    aC(e.length === 4);
    const [t, n, o, r] = e;
    return ub(t, n, o, r);
  } else if (typeof e == "string")
    return Trl[e];
  return e;
}, iF = (e, t) => (n) => !!(ik(n) && kol.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), Gge = (e, t, n) => (o) => {
  if (!ik(o))
    return o;
  const [r, i, a, s] = o.match(oC);
  return {
    [e]: parseFloat(r),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, Arl = (e) => jv(0, 255, e), P6 = {
  ...gg,
  transform: (e) => Math.round(Arl(e))
}, uf = {
  test: iF("rgb", "red"),
  parse: Gge("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: o = 1 }) => "rgba(" + P6.transform(e) + ", " + P6.transform(t) + ", " + P6.transform(n) + ", " + V$(F$.transform(o)) + ")"
};
function Crl(e) {
  let t = "", n = "", o = "", r = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), o = e.substring(5, 7), r = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), o = e.substring(3, 4), r = e.substring(4, 5), t += t, n += n, o += o, r += r), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(o, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const KM = {
  test: iF("#"),
  parse: Crl,
  transform: uf.transform
}, xh = {
  test: iF("hsl", "hue"),
  parse: Gge("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: o = 1 }) => "hsla(" + Math.round(e) + ", " + Hh.transform(V$(t)) + ", " + Hh.transform(V$(n)) + ", " + V$(F$.transform(o)) + ")"
}, fs = {
  test: (e) => uf.test(e) || KM.test(e) || xh.test(e),
  parse: (e) => uf.test(e) ? uf.parse(e) : xh.test(e) ? xh.parse(e) : KM.parse(e),
  transform: (e) => ik(e) ? e : e.hasOwnProperty("red") ? uf.transform(e) : xh.transform(e)
}, sk = (e, t, n) => -n * e + n * t + e;
function I6(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function zrl({ hue: e, saturation: t, lightness: n, alpha: o }) {
  e /= 360, t /= 100, n /= 100;
  let r = 0, i = 0, a = 0;
  if (!t)
    r = i = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
    r = I6(c, s, e + 1 / 3), i = I6(c, s, e), a = I6(c, s, e - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: o
  };
}
const R6 = (e, t, n) => {
  const o = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - o) + o));
}, Orl = [KM, uf, xh], Prl = (e) => Orl.find((t) => t.test(e));
function IZ(e) {
  const t = Prl(e);
  let n = t.parse(e);
  return t === xh && (n = zrl(n)), n;
}
const Hge = (e, t) => {
  const n = IZ(e), o = IZ(t), r = { ...n };
  return (i) => (r.red = R6(n.red, o.red, i), r.green = R6(n.green, o.green, i), r.blue = R6(n.blue, o.blue, i), r.alpha = sk(n.alpha, o.alpha, i), uf.transform(r));
};
function Irl(e) {
  var t, n;
  return isNaN(e) && ik(e) && (((t = e.match(oC)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(hge)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const Kge = {
  regex: $ol,
  countKey: "Vars",
  token: "${v}",
  parse: Zs
}, Yge = {
  regex: hge,
  countKey: "Colors",
  token: "${c}",
  parse: fs.parse
}, Zge = {
  regex: oC,
  countKey: "Numbers",
  token: "${n}",
  parse: gg.parse
};
function N6(e, { regex: t, countKey: n, token: o, parse: r }) {
  const i = e.tokenised.match(t);
  i && (e["num" + n] = i.length, e.tokenised = e.tokenised.replace(t, o), e.values.push(...i.map(r)));
}
function qE(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && N6(n, Kge), N6(n, Yge), N6(n, Zge), n;
}
function Qge(e) {
  return qE(e).values;
}
function Jge(e) {
  const { values: t, numColors: n, numVars: o, tokenised: r } = qE(e), i = t.length;
  return (a) => {
    let s = r;
    for (let c = 0; c < i; c++)
      c < o ? s = s.replace(Kge.token, a[c]) : c < o + n ? s = s.replace(Yge.token, fs.transform(a[c])) : s = s.replace(Zge.token, V$(a[c]));
    return s;
  };
}
const Rrl = (e) => typeof e == "number" ? 0 : e;
function Nrl(e) {
  const t = Qge(e);
  return Jge(e)(t.map(Rrl));
}
const _b = {
  test: Irl,
  parse: Qge,
  createTransformer: Jge,
  getAnimatableNone: Nrl
}, Xge = (e, t) => (n) => `${n > 0 ? t : e}`;
function ehe(e, t) {
  return typeof e == "number" ? (n) => sk(e, t, n) : fs.test(e) ? Hge(e, t) : e.startsWith("var(") ? Xge(e, t) : nhe(e, t);
}
const the = (e, t) => {
  const n = [...e], o = n.length, r = e.map((i, a) => ehe(i, t[a]));
  return (i) => {
    for (let a = 0; a < o; a++)
      n[a] = r[a](i);
    return n;
  };
}, Drl = (e, t) => {
  const n = { ...e, ...t }, o = {};
  for (const r in n)
    e[r] !== void 0 && t[r] !== void 0 && (o[r] = ehe(e[r], t[r]));
  return (r) => {
    for (const i in o)
      n[i] = o[i](r);
    return n;
  };
}, nhe = (e, t) => {
  const n = _b.createTransformer(t), o = qE(e), r = qE(t);
  return o.numVars === r.numVars && o.numColors === r.numColors && o.numNumbers >= r.numNumbers ? Af(the(o.values, r.values), n) : Xge(e, t);
}, aF = (e, t, n) => {
  const o = t - e;
  return o === 0 ? 1 : (n - e) / o;
}, RZ = (e, t) => (n) => sk(e, t, n);
function Mrl(e) {
  return typeof e == "number" ? RZ : typeof e == "string" ? fs.test(e) ? Hge : nhe : Array.isArray(e) ? the : typeof e == "object" ? Drl : RZ;
}
function Lrl(e, t, n) {
  const o = [], r = n || Mrl(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let s = r(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] || Zs : t;
      s = Af(c, s);
    }
    o.push(s);
  }
  return o;
}
function ohe(e, t, { clamp: n = !0, ease: o, mixer: r } = {}) {
  const i = e.length;
  if (aC(i === t.length), i === 1)
    return () => t[0];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = Lrl(t, o, r), s = a.length, c = (l) => {
    let d = 0;
    if (s > 1)
      for (; d < e.length - 2 && !(l < e[d + 1]); d++)
        ;
    const u = aF(e[d], e[d + 1], l);
    return a[d](u);
  };
  return n ? (l) => c(jv(e[0], e[i - 1], l)) : c;
}
function rhe(e, t) {
  const n = e[e.length - 1];
  for (let o = 1; o <= t; o++) {
    const r = aF(0, t, o);
    e.push(sk(n, 1, r));
  }
}
function ihe(e) {
  const t = [0];
  return rhe(t, e.length - 1), t;
}
function qrl(e, t) {
  return e.map((n) => n * t);
}
function jrl(e, t) {
  return e.map(() => t || qge).splice(0, e.length - 1);
}
function jE({ duration: e = 300, keyframes: t, times: n, ease: o = "easeInOut" }) {
  const r = jge(o) ? o.map(PZ) : PZ(o), i = {
    done: !1,
    value: t[0]
  }, a = qrl(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : ihe(t),
    e
  ), s = ohe(a, t, {
    ease: Array.isArray(r) ? r : jrl(t, r)
  });
  return {
    calculatedDuration: e,
    next: (c) => (i.value = s(c), i.done = c >= e, i)
  };
}
function ahe(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Frl = 5;
function she(e, t, n) {
  const o = Math.max(t - Frl, 0);
  return ahe(n - e(o), t - o);
}
const D6 = 1e-3, Vrl = 0.01, NZ = 10, Brl = 0.05, Url = 1;
function Wrl({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: o = 1 }) {
  let r, i;
  frl(e <= Vp(NZ));
  let a = 1 - t;
  a = jv(Brl, Url, a), e = jv(Vrl, NZ, v_(e)), a < 1 ? (r = (l) => {
    const d = l * a, u = d * e, _ = d - n, p = YM(l, a), f = Math.exp(-u);
    return D6 - _ / p * f;
  }, i = (l) => {
    const u = l * a * e, _ = u * n + n, p = Math.pow(a, 2) * Math.pow(l, 2) * e, f = Math.exp(-u), g = YM(Math.pow(l, 2), a);
    return (-r(l) + D6 > 0 ? -1 : 1) * ((_ - p) * f) / g;
  }) : (r = (l) => {
    const d = Math.exp(-l * e), u = (l - n) * e + 1;
    return -D6 + d * u;
  }, i = (l) => {
    const d = Math.exp(-l * e), u = (n - l) * (e * e);
    return d * u;
  });
  const s = 5 / e, c = Hrl(r, i, s);
  if (e = Vp(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * o;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(o * l),
      duration: e
    };
  }
}
const Grl = 12;
function Hrl(e, t, n) {
  let o = n;
  for (let r = 1; r < Grl; r++)
    o = o - e(o) / t(o);
  return o;
}
function YM(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Krl = ["duration", "bounce"], Yrl = ["stiffness", "damping", "mass"];
function DZ(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Zrl(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!DZ(e, Yrl) && DZ(e, Krl)) {
    const n = Wrl(e);
    t = {
      ...t,
      ...n,
      velocity: 0,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function sF({ keyframes: e, restDelta: t, restSpeed: n, ...o }) {
  const r = e[0], i = e[e.length - 1], a = { done: !1, value: r }, { stiffness: s, damping: c, mass: l, velocity: d, duration: u, isResolvedFromDuration: _ } = Zrl(o), p = d ? -v_(d) : 0, f = c / (2 * Math.sqrt(s * l)), g = i - r, h = v_(Math.sqrt(s / l)), b = Math.abs(g) < 5;
  n || (n = b ? 0.01 : 2), t || (t = b ? 5e-3 : 0.5);
  let v;
  if (f < 1) {
    const $ = YM(h, f);
    v = (k) => {
      const S = Math.exp(-f * h * k);
      return i - S * ((p + f * h * g) / $ * Math.sin($ * k) + g * Math.cos($ * k));
    };
  } else if (f === 1)
    v = ($) => i - Math.exp(-h * $) * (g + (p + h * g) * $);
  else {
    const $ = h * Math.sqrt(f * f - 1);
    v = (k) => {
      const S = Math.exp(-f * h * k), O = Math.min($ * k, 300);
      return i - S * ((p + f * h * g) * Math.sinh(O) + $ * g * Math.cosh(O)) / $;
    };
  }
  return {
    calculatedDuration: _ && u || null,
    next: ($) => {
      const k = v($);
      if (_)
        a.done = $ >= u;
      else {
        let S = p;
        $ !== 0 && (f < 1 ? S = she(v, $, k) : S = 0);
        const O = Math.abs(S) <= n, I = Math.abs(i - k) <= t;
        a.done = O && I;
      }
      return a.value = a.done ? i : k, a;
    }
  };
}
function MZ({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: o = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: a, min: s, max: c, restDelta: l = 0.5, restSpeed: d }) {
  const u = e[0], _ = {
    done: !1,
    value: u
  }, p = (D) => s !== void 0 && D < s || c !== void 0 && D > c, f = (D) => s === void 0 ? c : c === void 0 || Math.abs(s - D) < Math.abs(c - D) ? s : c;
  let g = n * t;
  const h = u + g, b = a === void 0 ? h : a(h);
  b !== h && (g = b - u);
  const v = (D) => -g * Math.exp(-D / o), $ = (D) => b + v(D), k = (D) => {
    const M = v(D), N = $(D);
    _.done = Math.abs(M) <= l, _.value = _.done ? b : N;
  };
  let S, O;
  const I = (D) => {
    p(_.value) && (S = D, O = sF({
      keyframes: [_.value, f(_.value)],
      velocity: she($, D, _.value),
      damping: r,
      stiffness: i,
      restDelta: l,
      restSpeed: d
    }));
  };
  return I(0), {
    calculatedDuration: null,
    next: (D) => {
      let M = !1;
      return !O && S === void 0 && (M = !0, k(D), I(D)), S !== void 0 && D > S ? O.next(D - S) : (!M && k(D), _);
    }
  };
}
const Qrl = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Js.update(t, !0),
    stop: () => LE(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Wd.isProcessing ? Wd.timestamp : performance.now()
  };
}, ZM = 2e4;
function QM(e) {
  let t = 0;
  const n = 50;
  let o = e.next(t);
  for (; !o.done && t < ZM; )
    t += n, o = e.next(t);
  return t >= ZM ? 1 / 0 : t;
}
const Jrl = {
  decay: MZ,
  inertia: MZ,
  tween: jE,
  keyframes: jE,
  spring: sF
};
function FE({ autoplay: e = !0, delay: t = 0, driver: n = Qrl, keyframes: o, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: s = "loop", onPlay: c, onStop: l, onComplete: d, onUpdate: u, ..._ }) {
  let p = 1, f = !1, g, h;
  const b = () => {
    g && g(), h = new Promise((F) => {
      g = F;
    });
  };
  b();
  let v;
  const $ = Jrl[r] || jE;
  let k;
  $ !== jE && typeof o[0] != "number" && (k = ohe([0, 100], o, {
    clamp: !1
  }), o = [0, 100]);
  const S = $({ ..._, keyframes: o });
  let O;
  s === "mirror" && (O = $({
    ..._,
    keyframes: [...o].reverse(),
    velocity: -(_.velocity || 0)
  }));
  let I = "idle", D = null, M = null, N = null;
  S.calculatedDuration === null && i && (S.calculatedDuration = QM(S));
  const { calculatedDuration: C } = S;
  let P = 1 / 0, x = 1 / 0;
  C !== null && (P = C + a, x = P * (i + 1) - a);
  let w = 0;
  const E = (F) => {
    if (M === null)
      return;
    p > 0 && (M = Math.min(M, F)), D !== null ? w = D : w = (F - M) * p;
    const L = w - t, U = L < 0;
    w = Math.max(L, 0), I === "finished" && D === null && (w = x);
    let W = w, H = S;
    if (i) {
      const Z = w / P;
      let ee = Math.floor(Z), J = Z % 1;
      !J && Z >= 1 && (J = 1), J === 1 && ee--, ee = Math.min(ee, i + 1);
      const oe = !!(ee % 2);
      oe && (s === "reverse" ? (J = 1 - J, a && (J -= a / P)) : s === "mirror" && (H = O));
      let ce = jv(0, 1, J);
      w > x && (ce = s === "reverse" && oe ? 1 : 0), W = ce * P;
    }
    const Q = U ? { done: !1, value: o[0] } : H.next(W);
    k && (Q.value = k(Q.value));
    let { done: X } = Q;
    !U && C !== null && (X = w >= x);
    const re = D === null && (I === "finished" || I === "running" && X || p < 0 && w <= 0);
    return u && u(Q.value), re && j(), Q;
  }, T = () => {
    v && v.stop(), v = void 0;
  }, z = () => {
    I = "idle", T(), b(), M = N = null;
  }, j = () => {
    I = "finished", d && d(), T(), b();
  }, q = () => {
    if (f)
      return;
    v || (v = n(E));
    const F = v.now();
    c && c(), D !== null ? M = F - D : (!M || I === "finished") && (M = F), N = M, D = null, I = "running", v.start();
  };
  e && q();
  const V = {
    then(F, L) {
      return h.then(F, L);
    },
    get time() {
      return v_(w);
    },
    set time(F) {
      F = Vp(F), w = F, D !== null || !v || p === 0 ? D = F : M = v.now() - F / p;
    },
    get duration() {
      const F = S.calculatedDuration === null ? QM(S) : S.calculatedDuration;
      return v_(F);
    },
    get speed() {
      return p;
    },
    set speed(F) {
      F === p || !v || (p = F, V.time = v_(w));
    },
    get state() {
      return I;
    },
    play: q,
    pause: () => {
      I = "paused", D = w;
    },
    stop: () => {
      f = !0, I !== "idle" && (I = "idle", l && l(), z());
    },
    cancel: () => {
      N !== null && E(N), z();
    },
    complete: () => {
      I = "finished";
    },
    sample: (F) => (M = 0, E(F))
  };
  return V;
}
const Xrl = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), Y2 = 10, eil = 2e4, til = (e, t) => t.type === "spring" || e === "backgroundColor" || !Rge(t.ease);
function nil(e, t, { onUpdate: n, onComplete: o, ...r }) {
  if (!(Mge.waapi() && Xrl.has(t) && !r.repeatDelay && r.repeatType !== "mirror" && r.damping !== 0 && r.type !== "inertia"))
    return !1;
  let a = !1, s, c;
  const l = () => {
    c = new Promise((b) => {
      s = b;
    });
  };
  l();
  let { keyframes: d, duration: u = 300, ease: _, times: p } = r;
  if (til(t, r)) {
    const b = FE({
      ...r,
      repeat: 0,
      delay: 0
    });
    let v = { done: !1, value: d[0] };
    const $ = [];
    let k = 0;
    for (; !v.done && k < eil; )
      v = b.sample(k), $.push(v.value), k += Y2;
    p = void 0, d = $, u = k - Y2, _ = "linear";
  }
  const f = hrl(e.owner.current, t, d, {
    ...r,
    duration: u,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: _,
    times: p
  }), g = () => f.cancel(), h = () => {
    Js.update(g), s(), l();
  };
  return f.onfinish = () => {
    e.set(vrl(d, r)), o && o(), h();
  }, {
    then(b, v) {
      return c.then(b, v);
    },
    get time() {
      return v_(f.currentTime || 0);
    },
    set time(b) {
      f.currentTime = Vp(b);
    },
    get speed() {
      return f.playbackRate;
    },
    set speed(b) {
      f.playbackRate = b;
    },
    get duration() {
      return v_(u);
    },
    play: () => {
      a || (f.play(), LE(g));
    },
    pause: () => f.pause(),
    stop: () => {
      if (a = !0, f.playState === "idle")
        return;
      const { currentTime: b } = f;
      if (b) {
        const v = FE({
          ...r,
          autoplay: !1
        });
        e.setWithVelocity(v.sample(b - Y2).value, v.sample(b).value, Y2);
      }
      h();
    },
    complete: () => f.finish(),
    cancel: h
  };
}
function oil({ keyframes: e, delay: t, onUpdate: n, onComplete: o }) {
  const r = () => (n && n(e[e.length - 1]), o && o(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Zs,
    pause: Zs,
    stop: Zs,
    then: (i) => (i(), Promise.resolve()),
    cancel: Zs,
    complete: Zs
  });
  return t ? FE({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: r
  }) : r();
}
const ril = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, iil = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), ail = {
  type: "keyframes",
  duration: 0.8
}, sil = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, cil = (e, { keyframes: t }) => t.length > 2 ? ail : fg.has(e) ? e.startsWith("scale") ? iil(t[1]) : ril : sil, JM = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(_b.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), lil = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function dil(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [o] = n.match(oC) || [];
  if (!o)
    return e;
  const r = n.replace(o, "");
  let i = lil.has(t) ? 1 : 0;
  return o !== n && (i *= 100), t + "(" + i + r + ")";
}
const uil = /([a-z-]*)\(.*?\)/g, XM = {
  ..._b,
  getAnimatableNone: (e) => {
    const t = e.match(uil);
    return t ? t.map(dil).join(" ") : e;
  }
}, _il = {
  ...vge,
  // Color props
  color: fs,
  backgroundColor: fs,
  outlineColor: fs,
  fill: fs,
  stroke: fs,
  // Border props
  borderColor: fs,
  borderTopColor: fs,
  borderRightColor: fs,
  borderBottomColor: fs,
  borderLeftColor: fs,
  filter: XM,
  WebkitFilter: XM
}, cF = (e) => _il[e];
function che(e, t) {
  let n = cF(e);
  return n !== XM && (n = _b), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const lhe = (e) => /^0[^.\s]+$/.test(e);
function pil(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || lhe(e);
}
function mil(e, t, n, o) {
  const r = JM(t, n);
  let i;
  Array.isArray(n) ? i = [...n] : i = [null, n];
  const a = o.from !== void 0 ? o.from : e.get();
  let s;
  const c = [];
  for (let l = 0; l < i.length; l++)
    i[l] === null && (i[l] = l === 0 ? a : i[l - 1]), pil(i[l]) ? c.push(l) : typeof i[l] == "string" && (s = i[l]);
  if (r && c.length && s)
    for (let l = 0; l < c.length; l++) {
      const d = c[l];
      i[d] = che(t, s);
    }
  return i;
}
function fil({ when: e, delay: t, delayChildren: n, staggerChildren: o, staggerDirection: r, repeat: i, repeatType: a, repeatDelay: s, from: c, elapsed: l, ...d }) {
  return !!Object.keys(d).length;
}
function gil(e, t) {
  return e[t] || e.default || e;
}
const dhe = (e, t, n, o = {}) => (r) => {
  const i = gil(o, e) || {}, a = i.delay || o.delay || 0;
  let { elapsed: s = 0 } = o;
  s = s - Vp(a);
  const c = mil(t, e, n, i), l = c[0], d = c[c.length - 1], u = JM(e, l), _ = JM(e, d);
  let p = {
    keyframes: c,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -s,
    onUpdate: (f) => {
      t.set(f), i.onUpdate && i.onUpdate(f);
    },
    onComplete: () => {
      r(), i.onComplete && i.onComplete();
    }
  };
  if (fil(i) || (p = {
    ...p,
    ...cil(e, p)
  }), p.duration && (p.duration = Vp(p.duration)), p.repeatDelay && (p.repeatDelay = Vp(p.repeatDelay)), !u || !_ || grl.current || i.type === !1)
    return oil(p);
  if (t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate) {
    const f = nil(t, e, p);
    if (f)
      return f;
  }
  return FE(p);
};
function VE(e) {
  return !!(es(e) && e.add);
}
const hil = (e) => /^\-?\d*\.?\d+$/.test(e);
function vil(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function uhe(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class _he {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return vil(this.subscriptions, t), () => uhe(this.subscriptions, t);
  }
  notify(t, n, o) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](t, n, o);
      else
        for (let i = 0; i < r; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, o);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const bil = (e) => !isNaN(parseFloat(e));
class yil {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.12.8", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (o, r = !0) => {
      this.prev = this.current, this.current = o;
      const { delta: i, timestamp: a } = Wd;
      this.lastUpdated !== a && (this.timeDelta = i, this.lastUpdated = a, Js.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), r && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Js.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: o }) => {
      o !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = bil(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new _he());
    const o = this.events[t].add(n);
    return t === "change" ? () => {
      o(), Js.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : o;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, o) {
    this.set(n), this.prev = t, this.timeDelta = o;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      ahe(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Fv(e, t) {
  return new yil(e, t);
}
const phe = (e) => (t) => t.test(e), $il = {
  test: (e) => e === "auto",
  parse: (e) => e
}, mhe = [gg, Wn, Hh, mp, xol, Sol, $il], Ky = (e) => mhe.find(phe(e)), wil = [...mhe, fs, _b], kil = (e) => wil.find(phe(e));
function Sil(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Fv(n));
}
function xil(e, t) {
  const n = iC(e, t);
  let { transitionEnd: o = {}, transition: r = {}, ...i } = n ? e.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...o };
  for (const a in i) {
    const s = qol(i[a]);
    Sil(e, a, s);
  }
}
function Eil(e, t, n) {
  var o, r;
  const i = Object.keys(t).filter((s) => !e.hasValue(s)), a = i.length;
  if (a)
    for (let s = 0; s < a; s++) {
      const c = i[s], l = t[c];
      let d = null;
      Array.isArray(l) && (d = l[0]), d === null && (d = (r = (o = n[c]) !== null && o !== void 0 ? o : e.readValue(c)) !== null && r !== void 0 ? r : t[c]), d != null && (typeof d == "string" && (hil(d) || lhe(d)) ? d = parseFloat(d) : !kil(d) && _b.test(l) && (d = che(c, l)), e.addValue(c, Fv(d, { owner: e })), n[c] === void 0 && (n[c] = d), d !== null && e.setBaseTarget(c, d));
    }
}
function Til(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function Ail(e, t, n) {
  const o = {};
  for (const r in e) {
    const i = Til(r, t);
    if (i !== void 0)
      o[r] = i;
    else {
      const a = n.getValue(r);
      a && (o[r] = a.get());
    }
  }
  return o;
}
function Cil({ protectedKeys: e, needsAnimating: t }, n) {
  const o = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, o;
}
function lF(e, t, { delay: n = 0, transitionOverride: o, type: r } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...s } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  o && (i = o);
  const l = [], d = r && e.animationState && e.animationState.getState()[r];
  for (const u in s) {
    const _ = e.getValue(u), p = s[u];
    if (!_ || p === void 0 || d && Cil(d, u))
      continue;
    const f = { delay: n, elapsed: 0, ...i };
    if (window.HandoffAppearAnimations && !_.hasAnimated) {
      const h = e.getProps()[mrl];
      h && (f.elapsed = window.HandoffAppearAnimations(h, u, _, Js));
    }
    _.start(dhe(u, _, p, e.shouldReduceMotion && fg.has(u) ? { type: !1 } : f));
    const g = _.animation;
    VE(c) && (c.add(u), g.then(() => c.remove(u))), l.push(g);
  }
  return a && Promise.all(l).then(() => {
    a && xil(e, a);
  }), l;
}
function eL(e, t, n = {}) {
  const o = iC(e, t, n.custom);
  let { transition: r = e.getDefaultTransition() || {} } = o || {};
  n.transitionOverride && (r = n.transitionOverride);
  const i = o ? () => Promise.all(lF(e, o, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: l = 0, staggerChildren: d, staggerDirection: u } = r;
    return zil(e, t, l + c, d, u, n);
  } : () => Promise.resolve(), { when: s } = r;
  if (s) {
    const [c, l] = s === "beforeChildren" ? [i, a] : [a, i];
    return c().then(() => l());
  } else
    return Promise.all([i(), a(n.delay)]);
}
function zil(e, t, n = 0, o = 0, r = 1, i) {
  const a = [], s = (e.variantChildren.size - 1) * o, c = r === 1 ? (l = 0) => l * o : (l = 0) => s - l * o;
  return Array.from(e.variantChildren).sort(Oil).forEach((l, d) => {
    l.notify("AnimationStart", t), a.push(eL(l, t, {
      ...i,
      delay: n + c(d)
    }).then(() => l.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function Oil(e, t) {
  return e.sortNodePosition(t);
}
function Pil(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let o;
  if (Array.isArray(t)) {
    const r = t.map((i) => eL(e, i, n));
    o = Promise.all(r);
  } else if (typeof t == "string")
    o = eL(e, t, n);
  else {
    const r = typeof t == "function" ? iC(e, t, n.custom) : t;
    o = Promise.all(lF(e, r, n));
  }
  return o.then(() => e.notify("AnimationComplete", t));
}
const Iil = [...Hj].reverse(), Ril = Hj.length;
function Nil(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: o }) => Pil(e, n, o)));
}
function Dil(e) {
  let t = Nil(e);
  const n = Lil();
  let o = !0;
  const r = (c, l) => {
    const d = iC(e, l);
    if (d) {
      const { transition: u, transitionEnd: _, ...p } = d;
      c = { ...c, ...p, ..._ };
    }
    return c;
  };
  function i(c) {
    t = c(e);
  }
  function a(c, l) {
    const d = e.getProps(), u = e.getVariantContext(!0) || {}, _ = [], p = /* @__PURE__ */ new Set();
    let f = {}, g = 1 / 0;
    for (let b = 0; b < Ril; b++) {
      const v = Iil[b], $ = n[v], k = d[v] !== void 0 ? d[v] : u[v], S = Bw(k), O = v === l ? $.isActive : null;
      O === !1 && (g = b);
      let I = k === u[v] && k !== d[v] && S;
      if (I && o && e.manuallyAnimateOnMount && (I = !1), $.protectedKeys = { ...f }, // If it isn't active and hasn't *just* been set as inactive
      !$.isActive && O === null || // If we didn't and don't have any defined prop for this animation type
      !k && !$.prevProp || // Or if the prop doesn't define an animation
      tC(k) || typeof k == "boolean")
        continue;
      const D = Mil($.prevProp, k);
      let M = D || // If we're making this variant active, we want to always make it active
      v === l && $.isActive && !I && S || // If we removed a higher-priority variant (i is in reverse order)
      b > g && S;
      const N = Array.isArray(k) ? k : [k];
      let C = N.reduce(r, {});
      O === !1 && (C = {});
      const { prevResolvedValues: P = {} } = $, x = {
        ...P,
        ...C
      }, w = (E) => {
        M = !0, p.delete(E), $.needsAnimating[E] = !0;
      };
      for (const E in x) {
        const T = C[E], z = P[E];
        f.hasOwnProperty(E) || (T !== z ? ME(T) && ME(z) ? !Pge(T, z) || D ? w(E) : $.protectedKeys[E] = !0 : T !== void 0 ? w(E) : p.add(E) : T !== void 0 && p.has(E) ? w(E) : $.protectedKeys[E] = !0);
      }
      $.prevProp = k, $.prevResolvedValues = C, $.isActive && (f = { ...f, ...C }), o && e.blockInitialAnimation && (M = !1), M && !I && _.push(...N.map((E) => ({
        animation: E,
        options: { type: v, ...c }
      })));
    }
    if (p.size) {
      const b = {};
      p.forEach((v) => {
        const $ = e.getBaseTarget(v);
        $ !== void 0 && (b[v] = $);
      }), _.push({ animation: b });
    }
    let h = !!_.length;
    return o && d.initial === !1 && !e.manuallyAnimateOnMount && (h = !1), o = !1, h ? t(_) : Promise.resolve();
  }
  function s(c, l, d) {
    var u;
    if (n[c].isActive === l)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((p) => {
      var f;
      return (f = p.animationState) === null || f === void 0 ? void 0 : f.setActive(c, l);
    }), n[c].isActive = l;
    const _ = a(d, c);
    for (const p in n)
      n[p].protectedKeys = {};
    return _;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: i,
    getState: () => n
  };
}
function Mil(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Pge(t, e) : !1;
}
function Om(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Lil() {
  return {
    animate: Om(!0),
    whileInView: Om(),
    whileHover: Om(),
    whileTap: Om(),
    whileDrag: Om(),
    whileFocus: Om(),
    exit: Om()
  };
}
class qil extends db {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = Dil(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), tC(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let jil = 0;
class Fil extends db {
  constructor() {
    super(...arguments), this.id = jil++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: o } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: o ?? this.node.getProps().custom });
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Vil = {
  animation: {
    Feature: qil
  },
  exit: {
    Feature: Fil
  }
}, LZ = () => ({ min: 0, max: 0 }), fhe = () => ({
  x: LZ(),
  y: LZ()
});
function Bil({ top: e, left: t, right: n, bottom: o }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: o }
  };
}
function Uil(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), o = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: o.y,
    right: o.x
  };
}
function Wil(e, t) {
  return Bil(Uil(e.getBoundingClientRect(), t));
}
function Gil(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function ghe(e, t, n) {
  const o = es(e) ? e : Fv(e);
  return o.start(dhe("", o, t, n)), o.animation;
}
const Hil = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Kil(e) {
  const t = Hil.exec(e);
  if (!t)
    return [,];
  const [, n, o] = t;
  return [n, o];
}
function tL(e, t, n = 1) {
  const [o, r] = Kil(e);
  if (!o)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(o);
  return i ? i.trim() : WM(r) ? tL(r, t, n + 1) : r;
}
function Yil(e, { ...t }, n) {
  const o = e.current;
  if (!(o instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((r) => {
    const i = r.get();
    if (!WM(i))
      return;
    const a = tL(i, o);
    a && r.set(a);
  });
  for (const r in t) {
    const i = t[r];
    if (!WM(i))
      continue;
    const a = tL(i, o);
    a && (t[r] = a, n || (n = {}), n[r] === void 0 && (n[r] = i));
  }
  return { target: t, transitionEnd: n };
}
const Zil = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), hhe = (e) => Zil.has(e), Qil = (e) => Object.keys(e).some(hhe), qZ = (e) => e === gg || e === Wn, jZ = (e, t) => parseFloat(e.split(", ")[t]), FZ = (e, t) => (n, { transform: o }) => {
  if (o === "none" || !o)
    return 0;
  const r = o.match(/^matrix3d\((.+)\)$/);
  if (r)
    return jZ(r[1], t);
  {
    const i = o.match(/^matrix\((.+)\)$/);
    return i ? jZ(i[1], e) : 0;
  }
}, Jil = /* @__PURE__ */ new Set(["x", "y", "z"]), Xil = rk.filter((e) => !Jil.has(e));
function eal(e) {
  const t = [];
  return Xil.forEach((n) => {
    const o = e.getValue(n);
    o !== void 0 && (t.push([n, o.get()]), o.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const VZ = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: FZ(4, 13),
  y: FZ(5, 14)
}, tal = (e, t, n) => {
  const o = t.measureViewportBox(), r = t.current, i = getComputedStyle(r), { display: a } = i, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((l) => {
    s[l] = VZ[l](o, i);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((l) => {
    const d = t.getValue(l);
    d && d.jump(s[l]), e[l] = VZ[l](c, i);
  }), e;
}, nal = (e, t, n = {}, o = {}) => {
  t = { ...t }, o = { ...o };
  const r = Object.keys(t).filter(hhe);
  let i = [], a = !1;
  const s = [];
  if (r.forEach((c) => {
    const l = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let d = n[c], u = Ky(d);
    const _ = t[c];
    let p;
    if (ME(_)) {
      const f = _.length, g = _[0] === null ? 1 : 0;
      d = _[g], u = Ky(d);
      for (let h = g; h < f && _[h] !== null; h++)
        p ? aC(Ky(_[h]) === p) : p = Ky(_[h]);
    } else
      p = Ky(_);
    if (u !== p)
      if (qZ(u) && qZ(p)) {
        const f = l.get();
        typeof f == "string" && l.set(parseFloat(f)), typeof _ == "string" ? t[c] = parseFloat(_) : Array.isArray(_) && p === Wn && (t[c] = _.map(parseFloat));
      } else
        u != null && u.transform && (p != null && p.transform) && (d === 0 || _ === 0) ? d === 0 ? l.set(p.transform(d)) : t[c] = u.transform(_) : (a || (i = eal(e), a = !0), s.push(c), o[c] = o[c] !== void 0 ? o[c] : t[c], l.jump(_));
  }), s.length) {
    const c = s.indexOf("height") >= 0 ? window.pageYOffset : null, l = tal(t, e, s);
    return i.length && i.forEach(([d, u]) => {
      e.getValue(d).set(u);
    }), e.render(), eC && c !== null && window.scrollTo({ top: c }), { target: l, transitionEnd: o };
  } else
    return { target: t, transitionEnd: o };
};
function oal(e, t, n, o) {
  return Qil(t) ? nal(e, t, n, o) : { target: t, transitionEnd: o };
}
const ral = (e, t, n, o) => {
  const r = Yil(e, t, o);
  return t = r.target, o = r.transitionEnd, oal(e, t, n, o);
}, BE = { current: null }, dF = { current: !1 };
function vhe() {
  if (dF.current = !0, !!eC)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => BE.current = e.matches;
      e.addListener(t), t();
    } else
      BE.current = !1;
}
function ial(e, t, n) {
  const { willChange: o } = t;
  for (const r in t) {
    const i = t[r], a = n[r];
    if (es(i))
      e.addValue(r, i), VE(o) && o.add(r);
    else if (es(a))
      e.addValue(r, Fv(i, { owner: e })), VE(o) && o.remove(r);
    else if (a !== i)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        !s.hasAnimated && s.set(i);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Fv(s !== void 0 ? s : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Gw = /* @__PURE__ */ new WeakMap(), bhe = Object.keys(Uw), aal = bhe.length, BZ = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], sal = Kj.length;
class cal {
  constructor({ parent: t, props: n, presenceContext: o, reducedMotionConfig: r, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Js.render(this.render, !1, !0);
    const { latestValues: s, renderState: c } = i;
    this.latestValues = s, this.baseTarget = { ...s }, this.initialValues = n.initial ? { ...s } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = o, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = r, this.options = a, this.isControllingVariants = nC(n), this.isVariantNode = _ge(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: l, ...d } = this.scrapeMotionValuesFromProps(n, {});
    for (const u in d) {
      const _ = d[u];
      s[u] !== void 0 && es(_) && (_.set(s[u], !1), VE(l) && l.add(u));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, Gw.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, o) => this.bindToMotionValue(o, n)), dF.current || vhe(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : BE.current, this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Gw.delete(this.current), this.projection && this.projection.unmount(), LE(this.notifyUpdate), LE(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const o = fg.has(t), r = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Js.update(this.notifyUpdate, !1, !0), o && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      r(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, o, r, i) {
    let a, s;
    for (let c = 0; c < aal; c++) {
      const l = bhe[c], { isEnabled: d, Feature: u, ProjectionNode: _, MeasureLayout: p } = Uw[l];
      _ && (a = _), d(n) && (!this.features[l] && u && (this.features[l] = new u(this)), p && (s = p));
    }
    if (!this.projection && a) {
      this.projection = new a(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: l, drag: d, dragConstraints: u, layoutScroll: _, layoutRoot: p } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: l,
        alwaysMeasureLayout: !!d || u && uge(u),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: i,
        layoutScroll: _,
        layoutRoot: p
      });
    }
    return s;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update(this.props, this.prevProps) : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : fhe();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let o = 0; o < BZ.length; o++) {
      const r = BZ[o];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const i = t["on" + r];
      i && (this.propEventSubscriptions[r] = this.on(r, i));
    }
    this.prevMotionValues = ial(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const o = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (o.initial = this.props.initial), o;
    }
    const n = {};
    for (let o = 0; o < sal; o++) {
      const r = Kj[o], i = this.props[r];
      (Bw(i) || i === !1) && (n[r] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let o = this.values.get(t);
    return o === void 0 && n !== void 0 && (o = Fv(n, { owner: this }), this.addValue(t, o)), o;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: o } = this.props, r = typeof o == "string" || typeof o == "object" ? (n = nF(this.props, o)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (o && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !es(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new _he()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class yhe extends cal {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: o }) {
    delete n[t], delete o[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...o }, { transformValues: r }, i) {
    let a = Ail(o, t || {}, this);
    if (r && (n && (n = r(n)), o && (o = r(o)), a && (a = r(a))), i) {
      Eil(this, o, a);
      const s = ral(this, o, a, n);
      n = s.transitionEnd, o = s.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...o
    };
  }
}
function lal(e) {
  return window.getComputedStyle(e);
}
class $he extends yhe {
  readValueFromInstance(t, n) {
    if (fg.has(n)) {
      const o = cF(n);
      return o && o.default || 0;
    } else {
      const o = lal(t), r = (gge(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Wil(t, n);
  }
  build(t, n, o, r) {
    Zj(t, n, o, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return tF(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    es(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, o, r) {
    wge(t, n, o, r);
  }
}
class whe extends yhe {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (fg.has(n)) {
      const o = cF(n);
      return o && o.default || 0;
    }
    return n = kge.has(n) ? n : eF(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return fhe();
  }
  scrapeMotionValuesFromProps(t, n) {
    return xge(t, n);
  }
  build(t, n, o, r) {
    Jj(t, n, o, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, o, r) {
    Sge(t, n, o, r);
  }
  mount(t) {
    this.isSVGTag = Xj(t.tagName), super.mount(t);
  }
}
const dal = (e, t) => Yj(e) ? new whe(t, { enableHardwareAcceleration: !1 }) : new $he(t, { enableHardwareAcceleration: !0 }), Hw = fol(Wol);
function khe() {
  const e = Ue(!1);
  return RE(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function ual() {
  const e = khe(), [t, n] = ze(0), o = at(() => {
    e.current && n(t + 1);
  }, [t]);
  return [at(() => Js.postRender(o), [o]), t];
}
class _al extends $e.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const o = this.props.sizeRef.current;
      o.height = n.offsetHeight || 0, o.width = n.offsetWidth || 0, o.top = n.offsetTop, o.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function pal({ children: e, isPresent: t }) {
  const n = N0(), o = Ue(null), r = Ue({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return Tie(() => {
    const { width: i, height: a, top: s, left: c } = r.current;
    if (t || !o.current || !i || !a)
      return;
    o.current.dataset.motionPopId = n;
    const l = document.createElement("style");
    return document.head.appendChild(l), l.sheet && l.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${a}px !important;
            top: ${s}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(l);
    };
  }, [t]), $e.createElement(_al, { isPresent: t, childRef: o, sizeRef: r }, $e.cloneElement(e, { ref: o }));
}
const M6 = ({ children: e, initial: t, isPresent: n, onExitComplete: o, custom: r, presenceAffectsLayout: i, mode: a }) => {
  const s = DE(mal), c = N0(), l = Tt(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: r,
      onExitComplete: (d) => {
        s.set(d, !0);
        for (const u of s.values())
          if (!u)
            return;
        o && o();
      },
      register: (d) => (s.set(d, !1), () => s.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [n]
  );
  return Tt(() => {
    s.forEach((d, u) => s.set(u, !1));
  }, [n]), $e.useEffect(() => {
    !n && !s.size && o && o();
  }, [n]), a === "popLayout" && (e = $e.createElement(pal, { isPresent: n }, e)), $e.createElement(Wj.Provider, { value: l }, e);
};
function mal() {
  return /* @__PURE__ */ new Map();
}
function She(e) {
  return Le(() => () => e(), []);
}
const gh = (e) => e.key || "";
function fal(e, t) {
  e.forEach((n) => {
    const o = gh(n);
    t.set(o, n);
  });
}
function gal(e) {
  const t = [];
  return Dp.forEach(e, (n) => {
    bl(n) && t.push(n);
  }), t;
}
const xhe = ({ children: e, custom: t, initial: n = !0, onExitComplete: o, exitBeforeEnter: r, presenceAffectsLayout: i = !0, mode: a = "sync" }) => {
  let [s] = ual();
  const c = Pn(pge).forceRender;
  c && (s = c);
  const l = khe(), d = gal(e);
  let u = d;
  const _ = /* @__PURE__ */ new Set(), p = Ue(u), f = Ue(/* @__PURE__ */ new Map()).current, g = Ue(!0);
  if (RE(() => {
    g.current = !1, fal(d, f), p.current = u;
  }), She(() => {
    g.current = !0, f.clear(), _.clear();
  }), g.current)
    return $e.createElement($e.Fragment, null, u.map(($) => $e.createElement(M6, { key: gh($), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: i, mode: a }, $)));
  u = [...u];
  const h = p.current.map(gh), b = d.map(gh), v = h.length;
  for (let $ = 0; $ < v; $++) {
    const k = h[$];
    b.indexOf(k) === -1 && _.add(k);
  }
  return a === "wait" && _.size && (u = []), _.forEach(($) => {
    if (b.indexOf($) !== -1)
      return;
    const k = f.get($);
    if (!k)
      return;
    const S = h.indexOf($), O = () => {
      f.delete($), _.delete($);
      const I = p.current.findIndex((D) => D.key === $);
      if (p.current.splice(I, 1), !_.size) {
        if (p.current = d, l.current === !1)
          return;
        s(), o && o();
      }
    };
    u.splice(S, 0, $e.createElement(M6, { key: gh(k), isPresent: !1, onExitComplete: O, custom: t, presenceAffectsLayout: i, mode: a }, k));
  }), u = u.map(($) => {
    const k = $.key;
    return _.has(k) ? $ : $e.createElement(M6, { key: gh($), isPresent: !0, presenceAffectsLayout: i, mode: a }, $);
  }), $e.createElement($e.Fragment, null, _.size ? u : u.map(($) => w_($)));
};
function hal({ children: e, features: t, strict: n = !1 }) {
  const [, o] = ze(!L6(t)), r = Ue(void 0);
  if (!L6(t)) {
    const { renderer: i, ...a } = t;
    r.current = i, UM(a);
  }
  return Le(() => {
    L6(t) && t().then(({ renderer: i, ...a }) => {
      UM(a), r.current = i, o(!0);
    });
  }, []), $e.createElement(Gj.Provider, { value: { renderer: r.current, strict: n } }, e);
}
function L6(e) {
  return typeof e == "function";
}
const val = {
  renderer: dal,
  ...Vil,
  ...drl
};
function Ehe(e, t, n) {
  var o;
  if (typeof e == "string") {
    let r = document;
    t && (aC(!!t.current), r = t.current), n ? ((o = n[e]) !== null && o !== void 0 || (n[e] = r.querySelectorAll(e)), e = n[e]) : e = r.querySelectorAll(e);
  } else
    e instanceof Element && (e = [e]);
  return Array.from(e || []);
}
function bal() {
  !dF.current && vhe();
  const [e] = ze(BE.current);
  return e;
}
class The {
  constructor(t) {
    this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let o = 0; o < this.animations.length; o++)
      this.animations[o][t] = n;
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  stop() {
    this.runAll("stop");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function yal(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function $al(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = Gil(e) ? new whe(t, {
    enableHardwareAcceleration: !1
  }) : new $he(t, {
    enableHardwareAcceleration: !0
  });
  n.mount(e), Gw.set(e, n);
}
function wal(e, t = 100) {
  const n = sF({ keyframes: [0, t], ...e }), o = Math.min(QM(n), ZM);
  return {
    type: "keyframes",
    ease: (r) => n.next(o * r).value / t,
    duration: v_(o)
  };
}
function UZ(e, t, n, o) {
  var r;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (r = o.get(t)) !== null && r !== void 0 ? r : e;
}
const kal = (e, t, n) => {
  const o = t - e;
  return ((n - e) % o + o) % o + e;
};
function Sal(e, t) {
  return jge(e) ? e[kal(0, e.length, t)] : e;
}
function xal(e, t, n) {
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    r.at > t && r.at < n && (uhe(e, r), o--);
  }
}
function Eal(e, t, n, o, r, i) {
  xal(e, r, i);
  for (let a = 0; a < t.length; a++)
    e.push({
      value: t[a],
      at: sk(r, i, o[a]),
      easing: Sal(n, a)
    });
}
function Tal(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const Aal = "easeInOut";
function Cal(e, { defaultTransition: t = {}, ...n } = {}, o) {
  const r = t.duration || 0.3, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = {}, c = /* @__PURE__ */ new Map();
  let l = 0, d = 0, u = 0;
  for (let _ = 0; _ < e.length; _++) {
    const p = e[_];
    if (typeof p == "string") {
      c.set(p, d);
      continue;
    } else if (!Array.isArray(p)) {
      c.set(p.name, UZ(d, p.at, l, c));
      continue;
    }
    let [f, g, h = {}] = p;
    h.at !== void 0 && (d = UZ(d, h.at, l, c));
    let b = 0;
    const v = ($, k, S, O = 0, I = 0) => {
      const D = zal($), { delay: M = 0, times: N = ihe(D), type: C = "keyframes", ...P } = k;
      let { ease: x = t.ease || "easeOut", duration: w } = k;
      const E = typeof M == "function" ? M(O, I) : M, T = D.length;
      if (T <= 2 && C === "spring") {
        let V = 100;
        if (T === 2 && Ial(D)) {
          const U = D[1] - D[0];
          V = Math.abs(U);
        }
        const F = { ...P };
        w !== void 0 && (F.duration = Vp(w));
        const L = wal(F, V);
        x = L.ease, w = L.duration;
      }
      w ?? (w = r);
      const z = d + E, j = z + w;
      N.length === 1 && N[0] === 0 && (N[1] = 1);
      const q = N.length - D.length;
      q > 0 && rhe(N, q), D.length === 1 && D.unshift(null), Eal(S, D, x, N, z, j), b = Math.max(E + w, b), u = Math.max(j, u);
    };
    if (es(f)) {
      const $ = WZ(f, a);
      v(g, h, GZ("default", $));
    } else {
      const $ = Ehe(f, o, s), k = $.length;
      for (let S = 0; S < k; S++) {
        g = g, h = h;
        const O = $[S], I = WZ(O, a);
        for (const D in g)
          v(g[D], Oal(h, D), GZ(D, I), S, k);
      }
      l = d, d += b;
    }
  }
  return a.forEach((_, p) => {
    for (const f in _) {
      const g = _[f];
      g.sort(Tal);
      const h = [], b = [], v = [];
      for (let k = 0; k < g.length; k++) {
        const { at: S, value: O, easing: I } = g[k];
        h.push(O), b.push(aF(0, u, S)), v.push(I || "easeOut");
      }
      b[0] !== 0 && (b.unshift(0), h.unshift(h[0]), v.unshift(Aal)), b[b.length - 1] !== 1 && (b.push(1), h.push(null)), i.has(p) || i.set(p, {
        keyframes: {},
        transition: {}
      });
      const $ = i.get(p);
      $.keyframes[f] = h, $.transition[f] = {
        ...t,
        duration: u,
        ease: v,
        times: b,
        ...n
      };
    }
  }), i;
}
function WZ(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function GZ(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function zal(e) {
  return Array.isArray(e) ? e : [e];
}
function Oal(e, t) {
  return e[t] ? { ...e, ...e[t] } : { ...e };
}
const Pal = (e) => typeof e == "number", Ial = (e) => e.every(Pal);
function Ahe(e, t, n, o) {
  const r = Ehe(e, o), i = r.length, a = [];
  for (let s = 0; s < i; s++) {
    const c = r[s];
    Gw.has(c) || $al(c);
    const l = Gw.get(c), d = { ...n };
    typeof d.delay == "function" && (d.delay = d.delay(s, i)), a.push(...lF(l, { ...t, transition: d }, {}));
  }
  return new The(a);
}
const Ral = (e) => Array.isArray(e) && Array.isArray(e[0]);
function Nal(e, t, n) {
  const o = [];
  return Cal(e, t, n).forEach(({ keyframes: i, transition: a }, s) => {
    let c;
    es(s) ? c = ghe(s, i.default, a.default) : c = Ahe(s, i, a), o.push(c);
  }), new The(o);
}
const Dal = (e) => {
  function t(n, o, r) {
    let i;
    return Ral(n) ? i = Nal(n, o, e) : yal(o) ? i = Ahe(n, o, r, e) : i = ghe(n, o, r), e && e.animations.push(i), i;
  }
  return t;
};
function Mal() {
  const e = DE(() => ({
    current: null,
    animations: []
  })), t = DE(() => Dal(e));
  return She(() => {
    e.animations.forEach((n) => n.stop());
  }), [e, t];
}
var Lal = (e) => {
  let t = e;
  for (; t = t.parentElement; ) {
    const n = getComputedStyle(t, null).getPropertyValue("overflow-y");
    if (t === document.body)
      return window;
    if (n === "auto" || n === "scroll" || n === "overlay")
      return t;
  }
  return window;
}, Che = (e) => e.firstChild ? e.firstChild.offsetParent === e : !0, qal = (e, t) => {
  let n = e, o = 0;
  Che(t) || (o += e.offsetTop - t.offsetTop, t = e.offsetParent, o += -e.offsetTop);
  do
    o += n.offsetTop, n = n.offsetParent;
  while (n && n !== t);
  return o;
}, jal = (e) => {
  let t = e.parentElement;
  for (; t && getComputedStyle(t, null).getPropertyValue("display") === "contents"; )
    t = t.parentElement;
  return t || window;
}, Kw = null;
typeof CSS < "u" && CSS.supports && (CSS.supports("position", "sticky") ? Kw = "sticky" : CSS.supports("position", "-webkit-sticky") && (Kw = "-webkit-sticky"));
var UE = !1;
try {
  const e = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get() {
      UE = { passive: !0 };
    }
  }), t = () => {
  };
  window.addEventListener("testPassive", t, e), window.removeEventListener("testPassive", t, e);
} catch {
}
var q6 = (e) => {
  const { el: t, onChange: n, unsubs: o, measure: r } = e;
  if (t === window) {
    const i = () => ({ top: 0, left: 0, height: window.innerHeight, width: window.innerWidth }), a = r(i()), s = () => {
      Object.assign(a, r(i())), n();
    };
    return window.addEventListener("resize", s, UE), o.push(() => window.removeEventListener("resize", s)), a;
  } else {
    const i = r(t.getBoundingClientRect()), a = () => {
      Object.assign(i, r(t.getBoundingClientRect())), n();
    }, s = new ResizeObserver(a);
    return s.observe(t), o.push(() => s.disconnect()), i;
  }
}, Fal = (e) => {
  const t = getComputedStyle(e, null), n = parseInt(t.getPropertyValue("padding-top"), 10), o = parseInt(t.getPropertyValue("padding-bottom"), 10);
  return { top: n, bottom: o };
}, Val = (e, t, n) => {
  const { bottom: o, offsetBottom: r, offsetTop: i } = n, a = Lal(e);
  let s = !1;
  const c = () => {
    s || requestAnimationFrame(() => {
      const I = u();
      I !== $ && k(I), s = !1;
    }), s = !0;
  };
  let l = a === window ? window.scrollY : a.scrollTop;
  const d = (I) => {
    const { offsetTop: D, height: M } = p, { naturalTop: N } = h, { height: C } = b;
    return I + D + M >= N + C + v + r;
  }, u = () => {
    const { height: I } = p, { height: D } = b;
    return D + i + r <= I ? 3 : d(l) ? 1 : 2;
  }, _ = a !== window && Che(a), p = q6({
    el: a,
    onChange: c,
    unsubs: t,
    measure: ({ height: I, top: D }) => ({
      height: I,
      offsetTop: _ ? D : 0
    })
  }), f = jal(e), g = f === window ? { top: 0, bottom: 0 } : Fal(f), h = q6({
    el: f,
    onChange: c,
    unsubs: t,
    measure: ({ height: I }) => ({
      height: I - g.top - g.bottom,
      naturalTop: f === window ? 0 : qal(f, a) + g.top + p.offsetTop
    })
  }), b = q6({
    el: e,
    onChange: c,
    unsubs: t,
    measure: ({ height: I }) => ({ height: I })
  });
  let v = 0, $ = u();
  const k = (I) => {
    const D = $;
    if ($ = I, D === 2 && (v = -1), I === 3) {
      e.style.position = Kw, o ? e.style.bottom = `${r}px` : e.style.top = `${i}px`;
      return;
    }
    const { height: M, offsetTop: N } = p, { height: C, naturalTop: P } = h, { height: x } = b;
    if (I === 2)
      if (e.style.position = "relative", v = D === 0 ? Math.max(0, N + l - P + i) : Math.max(
        0,
        N + l + M - (P + x + r)
      ), o) {
        const w = Math.max(0, C - x - v);
        e.style.bottom = `${w}px`;
      } else
        e.style.top = `${v}px`;
    else
      e.style.position = Kw, I === 1 ? o ? e.style.bottom = `${r}px` : e.style.top = `${M - x - r}px` : o ? e.style.bottom = `${M - x - r}px` : e.style.top = `${i}px`;
  };
  k($);
  const S = (I) => {
    if (I === l)
      return;
    const D = I - l;
    if (l = I, $ === 3)
      return;
    const { offsetTop: M, height: N } = p, { naturalTop: C, height: P } = h, { height: x } = b;
    if (D > 0)
      if ($ === 0) {
        if (I + M + i > C) {
          const w = Math.max(0, M + l - C + i);
          I + M + N <= C + x + w + r ? k(
            2
            /* relative */
          ) : k(
            1
            /* stickyBottom */
          );
        }
      } else
        $ === 2 && d(I) && k(
          1
          /* stickyBottom */
        );
    else if ($ === 1) {
      if (M + I + N < C + P + r) {
        const w = Math.max(
          0,
          M + l + N - (C + x + r)
        );
        M + I + i >= C + w ? k(
          2
          /* relative */
        ) : k(
          0
          /* stickyTop */
        );
      }
    } else
      $ === 2 && M + I + i < C + v && k(
        0
        /* stickyTop */
      );
  }, O = a === window ? () => S(window.scrollY) : () => S(a.scrollTop);
  a.addEventListener("scroll", O, UE), a.addEventListener("mousewheel", O, UE), t.push(
    () => a.removeEventListener("scroll", O),
    () => a.removeEventListener("mousewheel", O)
  );
}, Bal = ({
  offsetTop: e = 0,
  offsetBottom: t = 0,
  bottom: n = !1
} = {}) => {
  const [o, r] = ze(null);
  return Le(() => {
    if (!o || !Kw)
      return;
    const i = [];
    return Val(o, i, { offsetBottom: t, offsetTop: e, bottom: n }), () => {
      i.forEach((a) => a());
    };
  }, [o, t, e, n]), r;
}, Ual = (e) => {
  const { offsetTop: t, offsetBottom: n, bottom: o, children: r, className: i, style: a } = e, s = Bal({ offsetTop: t, offsetBottom: n, bottom: o });
  return /* @__PURE__ */ m("div", { className: i, style: a, ref: s, children: r });
}, Wal = Ual;
const zhe = (e, t, n) => {
  var c, l;
  const o = e.metadata, r = (o == null ? void 0 : o.apps) && o.apps[t];
  if (r)
    return (n ? !0 : r.enabled) ? {
      ...r,
      // We should favor eventType's price and currency over appMetadata's price and currency
      price: e.price || r.price || null,
      currency: e.currency || r.currency || null,
      // trackingId is legacy way to store value for TRACKING_ID. So, we need to support both.
      TRACKING_ID: r.TRACKING_ID || r.trackingId || null
    } : null;
  const a = {
    stripe: {
      enabled: !!e.price,
      // Price default is 0 in DB. So, it would always be non nullish.
      price: e.price,
      // Currency default is "usd" in DB.So, it would also be available always
      currency: e.currency,
      paymentOption: "ON_BOOKING"
    },
    giphy: {
      enabled: !!((c = e.metadata) != null && c.giphyThankYouPage),
      thankYouPage: ((l = e.metadata) == null ? void 0 : l.giphyThankYouPage) || ""
    }
  }[t];
  return (n ? !0 : a == null ? void 0 : a.enabled) ? a : null;
}, Gal = {
  campfire: Dme,
  dailyvideo: Mme,
  demodesk: Lme,
  dialpad: qme,
  discord: jme,
  eightxeight: Fme,
  "element-call": Vme,
  facetime: Bme,
  fathom: Ume,
  ga4: Wme,
  googlevideo: Hme,
  gtm: Kme,
  "horizon-workrooms": Yme,
  huddle01video: Zme,
  insihts: Qme,
  jelly: Jme,
  jitsivideo: Xme,
  matomo: efe,
  metapixel: tfe,
  mirotalk: nfe,
  nextcloudtalk: ofe,
  office365video: rfe,
  ping: ife,
  plausible: afe,
  posthog: sfe,
  riverside: cfe,
  roam: lfe,
  salesroom: dfe,
  shimmervideo: ufe,
  signal: _fe,
  sirius_video: pfe,
  skype: mfe,
  sylapsvideo: ffe,
  tandemvideo: gfe,
  telegram: hfe,
  "booking-pages-tag": vfe,
  "event-type-location-video-static": bfe,
  twipla: yfe,
  umami: $fe,
  webex: wfe,
  whatsapp: kfe,
  whereby: Sfe,
  zoomvideo: xfe
}, uF = {};
for (const [e, t] of Object.entries(Gal))
  uF[e] = Efe(t);
const Ohe = "cal_analytics_app_", Hal = ({ tag: e, appId: t }) => {
  var n, o;
  return e.pushEventScript ? {
    ...e.pushEventScript,
    // In case of complex pushEvent implementations, we could think about exporting a pushEvent function from the analytics app maybe but for now this should suffice
    content: (o = (n = e.pushEventScript) == null ? void 0 : n.content) == null ? void 0 : o.replace("$pushEvent", `${Ohe}_${t}`)
  } : e.pushEventScript;
};
function Kal(e) {
  return Object.entries(uF).reduce(
    (t, n) => {
      var a;
      const [o, r] = n, i = zhe(e, o);
      return !i || !((a = r.appData) != null && a.tag) || (t[o] = {
        meta: r,
        eventTypeAppData: i
      }), t;
    },
    {}
  );
}
function Yal(e) {
  const { type: t, ...n } = e.detail;
  return t.startsWith("__") ? !1 : (Object.entries(window).forEach(([o, r]) => {
    if (!o.startsWith(Ohe) || typeof r != "function")
      return;
    const i = window[o];
    i({
      name: t,
      data: n
    });
  }), window.opener && window.opener.postMessage(
    {
      type: `CAL:${t}`,
      ...n
    },
    "*"
  ), !0);
}
function Zal({
  eventType: e
}) {
  const t = Kal(e);
  return /* @__PURE__ */ m(Ce, { children: Object.entries(t).map(([n, { meta: o, eventTypeAppData: r }]) => {
    const i = o.appData.tag, a = (c) => {
      if (!c)
        return c;
      const l = /\{([A-Z_\d]+)\}/g;
      let d;
      for (; d = l.exec(c); ) {
        const u = d[1];
        r[u] && (c = c.replace(
          new RegExp(`{${u}}`, "g"),
          r[u]
        ));
      }
      return c;
    }, s = Hal({ tag: i, appId: n });
    return i.scripts.concat(s ? [s] : []).map((c, l) => {
      const d = {}, u = c.attrs || {};
      return Object.entries(u).forEach(([_, p]) => {
        typeof p == "string" && (p = a(p)), d[_] = p;
      }), /* @__PURE__ */ m(
        Hfe,
        {
          "data-testid": `cal-analytics-app-${n}`,
          src: a(c.src),
          id: `${n}-${l}`,
          dangerouslySetInnerHTML: {
            __html: a(c.content) || ""
          },
          ...d,
          defer: !0
        },
        `${n}-${l}`
      );
    });
  }) });
}
typeof window < "u" && (Kn == null || Kn.on("*", Yal));
const Phe = () => {
  const e = po();
  return !!(e != null && e.clientId && (e != null && e.isEmbed));
}, Qal = ({
  logoOnly: e,
  hasValidLicense: t
}) => {
  const { t: n } = Fe(), o = fu();
  return /* @__PURE__ */ m("div", { className: `p-2 text-center text-xs sm:text-right${o ? " max-w-3xl" : ""}`, children: /* @__PURE__ */ Y(Po, { href: Kmc, target: "_blank", className: "text-subtle", children: [
    !e && /* @__PURE__ */ Y(Ce, { children: [
      n("powered_by"),
      " "
    ] }),
    Zp === "Cal.com" || !t ? /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
      "img",
      {
        className: "-mt-px inline h-[10px] w-auto dark:invert",
        src: "https://app.cal.com/api/logo",
        alt: "Cal.com Logo"
      }
    ) }) : /* @__PURE__ */ m("span", { className: "text-emphasis font-semibold opacity-50 hover:opacity-100", children: Zp })
  ] }) });
};
var sC = {}, Jal = Je && Je.__createBinding || (Object.create ? function(e, t, n, o) {
  o === void 0 && (o = n);
  var r = Object.getOwnPropertyDescriptor(t, n);
  (!r || ("get" in r ? !t.__esModule : r.writable || r.configurable)) && (r = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, o, r);
} : function(e, t, n, o) {
  o === void 0 && (o = n), e[o] = t[n];
}), Xal = Je && Je.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), esl = Je && Je.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Jal(t, e, n);
  return Xal(t, e), t;
};
Object.defineProperty(sC, "__esModule", { value: !0 });
sC.useTurnstile = void 0;
const ef = esl(ve), B$ = typeof globalThis < "u" ? globalThis : window;
let Bp = typeof B$.turnstile < "u" ? "ready" : "unloaded", Ihe, nL;
const Rhe = new Promise((e, t) => {
  nL = { resolve: e, reject: t }, Bp === "ready" && e(void 0);
});
{
  const e = "cf__reactTurnstileOnLoad", t = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  Ihe = () => {
    if (Bp === "unloaded") {
      Bp = "loading", B$[e] = () => {
        nL.resolve(), Bp = "ready", delete B$[e];
      };
      const n = `${t}?onload=${e}&render=explicit`, o = document.createElement("script");
      o.src = n, o.async = !0, o.addEventListener("error", () => {
        nL.reject("Failed to load Turnstile."), delete B$[e];
      }), document.head.appendChild(o);
    }
    return Rhe;
  };
}
function tsl({ id: e, className: t, style: n, sitekey: o, action: r, cData: i, theme: a, language: s, tabIndex: c, responseField: l, responseFieldName: d, size: u, fixedSize: _, retry: p, retryInterval: f, refreshExpired: g, appearance: h, execution: b, userRef: v, onVerify: $, onLoad: k, onError: S, onExpire: O, onTimeout: I, onAfterInteractive: D, onBeforeInteractive: M, onUnsupported: N }) {
  const C = (0, ef.useRef)(null), P = (0, ef.useState)({
    onVerify: $,
    onLoad: k,
    onError: S,
    onExpire: O,
    onTimeout: I,
    onAfterInteractive: D,
    onBeforeInteractive: M,
    onUnsupported: N
  })[0], x = v ?? C;
  return (0, ef.useEffect)(() => {
    if (!x.current)
      return;
    let w = !1, E = "";
    return (async () => {
      var T, z;
      if (Bp !== "ready")
        try {
          await Ihe();
        } catch (V) {
          (T = P.onError) === null || T === void 0 || T.call(P, V);
          return;
        }
      if (w || !x.current)
        return;
      let j;
      const q = {
        sitekey: o,
        action: r,
        cData: i,
        theme: a,
        language: s,
        tabindex: c,
        "response-field": l,
        "response-field-name": d,
        size: u,
        retry: p,
        "retry-interval": f,
        "refresh-expired": g,
        appearance: h,
        execution: b,
        callback: (V) => {
          var F;
          return (F = P.onVerify) === null || F === void 0 ? void 0 : F.call(P, V, j);
        },
        "error-callback": (V) => {
          var F;
          return (F = P.onError) === null || F === void 0 ? void 0 : F.call(P, V, j);
        },
        "expired-callback": (V) => {
          var F;
          return (F = P.onExpire) === null || F === void 0 ? void 0 : F.call(P, V, j);
        },
        "timeout-callback": () => {
          var V;
          return (V = P.onTimeout) === null || V === void 0 ? void 0 : V.call(P, j);
        },
        "after-interactive-callback": () => {
          var V;
          return (V = P.onAfterInteractive) === null || V === void 0 ? void 0 : V.call(P, j);
        },
        "before-interactive-callback": () => {
          var V;
          return (V = P.onBeforeInteractive) === null || V === void 0 ? void 0 : V.call(P, j);
        },
        "unsupported-callback": () => {
          var V;
          return (V = P.onUnsupported) === null || V === void 0 ? void 0 : V.call(P, j);
        }
      };
      E = window.turnstile.render(x.current, q), j = osl(E), (z = P.onLoad) === null || z === void 0 || z.call(P, E, j);
    })(), () => {
      w = !0, E && window.turnstile.remove(E);
    };
  }, [
    o,
    r,
    i,
    a,
    s,
    c,
    l,
    d,
    u,
    p,
    f,
    g,
    h,
    b
  ]), (0, ef.useEffect)(() => {
    P.onVerify = $, P.onLoad = k, P.onError = S, P.onExpire = O, P.onTimeout = I, P.onAfterInteractive = D, P.onBeforeInteractive = M, P.onUnsupported = N;
  }, [
    $,
    k,
    S,
    O,
    I,
    D,
    M,
    N
  ]), ef.default.createElement("div", { ref: x, id: e, className: t, style: _ ? {
    ...n ?? {},
    width: u === "compact" ? "130px" : "300px",
    height: u === "compact" ? "120px" : "65px"
  } : n });
}
var nsl = sC.default = tsl;
function osl(e) {
  return {
    execute: (t) => window.turnstile.execute(e, t),
    reset: () => window.turnstile.reset(e),
    getResponse: () => window.turnstile.getResponse(e),
    isExpired: () => window.turnstile.isExpired(e)
  };
}
function rsl() {
  const [e, t] = (0, ef.useState)(Bp);
  return (0, ef.useEffect)(() => {
    Bp !== "ready" && Rhe.then(() => t(Bp));
  }, []), B$.turnstile;
}
sC.useTurnstile = rsl;
var isl = {};
function asl(e) {
  return !mD || isl.NEXT_PUBLIC_IS_E2E ? null : /* @__PURE__ */ m(nsl, { ...e, sitekey: mD, theme: "auto" });
}
const ssl = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68])))\\d{6}|(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68]))))\\d{6}|9(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|9(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|9(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["510\\d{4}|(?:6\\d|7[0-5])\\d{5}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|7(?:4[0-2]|6[0-5]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["(?:60\\d|[7-9]0[1-9])\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1[013-5]|2\\d|3[4-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-4]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[36]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0178]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-7]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function csl(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(ssl), e.apply(this, n);
}
function oL(e) {
  "@babel/helpers - typeof";
  return oL = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oL(e);
}
function HZ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function lsl(e, t, n) {
  return t && HZ(e.prototype, t), n && HZ(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dsl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function usl(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yw(e, t);
}
function _sl(e) {
  var t = Dhe();
  return function() {
    var o = Zw(e), r;
    if (t) {
      var i = Zw(this).constructor;
      r = Reflect.construct(o, arguments, i);
    } else
      r = o.apply(this, arguments);
    return psl(this, r);
  };
}
function psl(e, t) {
  if (t && (oL(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nhe(e);
}
function Nhe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rL(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return rL = function(o) {
    if (o === null || !msl(o))
      return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(o))
        return t.get(o);
      t.set(o, r);
    }
    function r() {
      return ox(o, arguments, Zw(this).constructor);
    }
    return r.prototype = Object.create(o.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), Yw(r, o);
  }, rL(e);
}
function ox(e, t, n) {
  return Dhe() ? ox = Reflect.construct : ox = function(r, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var c = Function.bind.apply(r, s), l = new c();
    return a && Yw(l, a.prototype), l;
  }, ox.apply(null, arguments);
}
function Dhe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function msl(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Yw(e, t) {
  return Yw = Object.setPrototypeOf || function(o, r) {
    return o.__proto__ = r, o;
  }, Yw(e, t);
}
function Zw(e) {
  return Zw = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Zw(e);
}
var o_ = /* @__PURE__ */ function(e) {
  usl(n, e);
  var t = _sl(n);
  function n(o) {
    var r;
    return dsl(this, n), r = t.call(this, o), Object.setPrototypeOf(Nhe(r), n.prototype), r.name = r.constructor.name, r;
  }
  return lsl(n);
}(/* @__PURE__ */ rL(Error)), _F = 2, fsl = 17, gsl = 3, dd = "0-9０-９٠-٩۰-۹", hsl = "-‐-―−ー－", vsl = "／/", bsl = "．.", ysl = "  ­​⁠　", $sl = "()（）［］\\[\\]", wsl = "~⁓∼～", WE = "".concat(hsl).concat(vsl).concat(bsl).concat(ysl).concat($sl).concat(wsl), pF = "+＋";
function KZ(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), o = t[0].split("."), r = 0; r < 3; r++) {
    var i = Number(n[r]), a = Number(o[r]);
    if (i > a)
      return 1;
    if (a > i)
      return -1;
    if (!isNaN(i) && isNaN(a))
      return 1;
    if (isNaN(i) && !isNaN(a))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var ksl = {}.constructor;
function rx(e) {
  return e != null && e.constructor === ksl;
}
function iL(e) {
  "@babel/helpers - typeof";
  return iL = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, iL(e);
}
function cC(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function YZ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function lC(e, t, n) {
  return t && YZ(e.prototype, t), n && YZ(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Ssl = "1.2.0", xsl = "1.7.35", ZZ = " ext. ", Esl = /^\d+$/, Is = /* @__PURE__ */ function() {
  function e(t) {
    cC(this, e), zsl(t), this.metadata = t, Mhe.call(this, t);
  }
  return lC(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, o) {
      if (n && Esl.test(n) && (o = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new QZ(this.getCountryMetadata(n), this);
      } else if (o) {
        if (!this.hasCallingCode(o))
          throw new Error("Unknown calling code: ".concat(o));
        this.numberingPlan = new QZ(this.getNumberingPlanMetadata(o), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var o = this.countryCallingCodes()[n];
      if (o)
        return o.length === 1 && o[0].length === 3 ? void 0 : o;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var o = this.getCountryCodesForCallingCode(n);
      if (o)
        return o[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var o = this.getCountryCodeForCallingCode(n);
      if (o)
        return this.getCountryMetadata(o);
      if (this.nonGeographic()) {
        var r = this.nonGeographic()[n];
        if (r)
          return r;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), QZ = /* @__PURE__ */ function() {
  function e(t, n) {
    cC(this, e), this.globalMetadataObject = n, this.metadata = t, Mhe.call(this, n.metadata);
  }
  return lC(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, o = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return o.map(function(r) {
        return new Tsl(r, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && JZ(this.types(), n))
        return new Csl(JZ(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? ZZ : this.metadata[13] || ZZ;
    }
  }]), e;
}(), Tsl = /* @__PURE__ */ function() {
  function e(t, n) {
    cC(this, e), this._format = t, this.metadata = n;
  }
  return lC(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Asl.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Asl = /^\(?\$1\)?$/, Csl = /* @__PURE__ */ function() {
  function e(t, n) {
    cC(this, e), this.type = t, this.metadata = n;
  }
  return lC(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function JZ(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function zsl(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!rx(e) || !rx(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(rx(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Osl(e) + ": " + e, "."));
}
var Osl = function(t) {
  return iL(t);
};
function mF(e, t) {
  if (t = new Is(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Psl(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Mhe(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? KZ(t, Ssl) === -1 ? this.v2 = !0 : KZ(t, xsl) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Isl = ";ext=", rh = function(t) {
  return "([".concat(dd, "]{1,").concat(t, "})");
};
function Lhe(e) {
  var t = "20", n = "15", o = "9", r = "6", i = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", l = "(?:[xｘ#＃~～]|int|ｉｎｔ)", d = "[- ]+", u = "[  \\t]*", _ = "(?:,{2}|;)", p = Isl + rh(t), f = i + c + a + rh(t) + s, g = i + l + a + rh(o) + s, h = d + rh(r) + "#", b = u + _ + a + rh(n) + s, v = u + "(?:,)+" + a + rh(o) + s;
  return p + "|" + f + "|" + g + "|" + h + "|" + b + "|" + v;
}
var Rsl = "[" + dd + "]{" + _F + "}", Nsl = "[" + pF + "]{0,1}(?:[" + WE + "]*[" + dd + "]){3,}[" + WE + dd + "]*", Dsl = new RegExp("^[" + pF + "]{0,1}(?:[" + WE + "]*[" + dd + "]){1,2}$", "i"), Msl = Nsl + // Phone number extensions
"(?:" + Lhe() + ")?", Lsl = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Rsl + "$|^" + Msl + "$",
  "i"
);
function qsl(e) {
  return e.length >= _F && Lsl.test(e);
}
function jsl(e) {
  return Dsl.test(e);
}
var XZ = new RegExp("(?:" + Lhe() + ")$", "i");
function Fsl(e) {
  var t = e.search(XZ);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), o = e.match(XZ), r = 1; r < o.length; ) {
    if (o[r])
      return {
        number: n,
        ext: o[r]
      };
    r++;
  }
}
var Vsl = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Bsl(e) {
  return Vsl[e];
}
function Usl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Wsl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wsl(e, t) {
  if (e) {
    if (typeof e == "string")
      return eQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return eQ(e, t);
  }
}
function eQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function tQ(e) {
  for (var t = "", n = Usl(e.split("")), o; !(o = n()).done; ) {
    var r = o.value;
    t += Gsl(r, t) || "";
  }
  return t;
}
function Gsl(e, t, n) {
  if (e === "+") {
    if (t) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return Bsl(e);
}
function Hsl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ksl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ksl(e, t) {
  if (e) {
    if (typeof e == "string")
      return nQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nQ(e, t);
  }
}
function nQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Ysl(e, t) {
  for (var n = e.slice(), o = Hsl(t), r; !(r = o()).done; ) {
    var i = r.value;
    e.indexOf(i) < 0 && n.push(i);
  }
  return n.sort(function(a, s) {
    return a - s;
  });
}
function fF(e, t) {
  return qhe(e, void 0, t);
}
function qhe(e, t, n) {
  var o = n.type(t), r = o && o.possibleLengths() || n.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return qhe(e, "MOBILE", n);
    var i = n.type("MOBILE");
    i && (r = Ysl(r, i.possibleLengths()));
  } else if (t && !o)
    return "INVALID_LENGTH";
  var a = e.length, s = r[0];
  return s === a ? "IS_POSSIBLE" : s > a ? "TOO_SHORT" : r[r.length - 1] < a ? "TOO_LONG" : r.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Zsl(e, t, n) {
  if (t === void 0 && (t = {}), n = new Is(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return jhe(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function jhe(e, t) {
  switch (fF(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function E_(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Qsl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Jsl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jsl(e, t) {
  if (e) {
    if (typeof e == "string")
      return oQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return oQ(e, t);
  }
}
function oQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
var Xsl = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function gF(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new Is(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var o = t.v2 ? e.nationalNumber : e.phone;
    if (E_(o, n.nationalNumberPattern())) {
      if (j6(o, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || j6(o, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = Qsl(Xsl), i; !(i = r()).done; ) {
        var a = i.value;
        if (j6(o, a, n))
          return a;
      }
    }
  }
}
function j6(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : E_(e, t.pattern());
}
function ecl(e, t, n) {
  if (t = t || {}, n = new Is(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return gF(e, t, n.metadata) !== void 0;
  var o = t.v2 ? e.nationalNumber : e.phone;
  return E_(o, n.nationalNumberPattern());
}
function tcl(e, t, n) {
  var o = new Is(n), r = o.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(i) {
    return ncl(t, i, n);
  }) : [];
}
function ncl(e, t, n) {
  var o = new Is(n);
  return o.selectNumberingPlan(t), o.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function ocl(e) {
  return e.replace(new RegExp("[".concat(WE, "]+"), "g"), " ").trim();
}
var rcl = /(\$\d)/;
function icl(e, t, n) {
  var o = n.useInternationalFormat, r = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), o ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && t.nationalPrefixFormattingRule() ? t.format().replace(rcl, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return o ? ocl(i) : i;
}
var acl = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function scl(e, t, n) {
  var o = new Is(n);
  if (o.selectNumberingPlan(e, t), o.defaultIDDPrefix())
    return o.defaultIDDPrefix();
  if (acl.test(o.IDDPrefix()))
    return o.IDDPrefix();
}
function ccl(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function lcl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = dcl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dcl(e, t) {
  if (e) {
    if (typeof e == "string")
      return rQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rQ(e, t);
  }
}
function rQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function iQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function aQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? iQ(Object(n), !0).forEach(function(o) {
      ucl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : iQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function ucl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var sQ = {
  formatExtension: function(t, n, o) {
    return "".concat(t).concat(o.ext()).concat(n);
  }
};
function _cl(e, t, n, o) {
  if (n ? n = aQ(aQ({}, sQ), n) : n = sQ, o = new Is(o), e.country && e.country !== "001") {
    if (!o.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    o.country(e.country);
  } else if (e.countryCallingCode)
    o.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var r = o.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, a;
  switch (t) {
    case "NATIONAL":
      return i ? (a = GE(i, e.carrierCode, "NATIONAL", o, n), F6(a, e.ext, o, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (a = GE(i, null, "INTERNATIONAL", o, n), a = "+".concat(r, " ").concat(a), F6(a, e.ext, o, n.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(i);
    case "RFC3966":
      return ccl({
        number: "+".concat(r).concat(i),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = mcl(i, e.carrierCode, r, n.fromCountry, o);
      return F6(s, e.ext, o, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function GE(e, t, n, o, r) {
  var i = pcl(o.formats(), e);
  return i ? icl(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: t,
    metadata: o
  }) : e;
}
function pcl(e, t) {
  for (var n = lcl(e), o; !(o = n()).done; ) {
    var r = o.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var i = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (E_(t, r.pattern()))
      return r;
  }
}
function F6(e, t, n, o) {
  return t ? o(e, t, n) : e;
}
function mcl(e, t, n, o, r) {
  var i = mF(o, r.metadata);
  if (i === n) {
    var a = GE(e, t, "NATIONAL", r);
    return n === "1" ? n + " " + a : a;
  }
  var s = scl(o, void 0, r.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(GE(e, null, "INTERNATIONAL", r));
}
function cQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function lQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cQ(Object(n), !0).forEach(function(o) {
      fcl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function fcl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gcl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dQ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function hcl(e, t, n) {
  return t && dQ(e.prototype, t), n && dQ(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var vcl = /* @__PURE__ */ function() {
  function e(t, n, o) {
    if (gcl(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!o)
      throw new TypeError("`metadata` not passed");
    var r = ycl(t, o), i = r.country, a = r.countryCallingCode;
    this.country = i, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return o;
    };
  }
  return hcl(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : tcl(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Zsl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return ecl(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Is(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return gF(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, o) {
      return _cl(this, n, o ? lQ(lQ({}, o), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), bcl = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function ycl(e, t) {
  var n, o, r = new Is(t);
  return bcl(e) ? (n = e, r.selectNumberingPlan(n), o = r.countryCallingCode()) : o = e, {
    country: n,
    countryCallingCode: o
  };
}
var $cl = new RegExp("([" + dd + "])");
function wcl(e, t, n, o) {
  if (t) {
    var r = new Is(o);
    r.selectNumberingPlan(t, n);
    var i = new RegExp(r.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var a = e.match($cl);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function kcl(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), o = n.exec(e);
    if (o) {
      var r, i, a = o.length - 1, s = a > 0 && o[a];
      if (t.nationalPrefixTransformRule() && s)
        r = e.replace(n, t.nationalPrefixTransformRule()), a > 1 && (i = o[1]);
      else {
        var c = o[0];
        r = e.slice(c.length), s && (i = o[1]);
      }
      var l;
      if (s) {
        var d = e.indexOf(o[1]), u = e.slice(0, d);
        u === t.numberingPlan.nationalPrefix() && (l = t.numberingPlan.nationalPrefix());
      } else
        l = o[0];
      return {
        nationalNumber: r,
        nationalPrefix: l,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function aL(e, t) {
  var n = kcl(e, t), o = n.carrierCode, r = n.nationalNumber;
  if (r !== e) {
    if (!Scl(e, r, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !xcl(r, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: o
  };
}
function Scl(e, t, n) {
  return !(E_(e, n.nationalNumberPattern()) && !E_(t, n.nationalNumberPattern()));
}
function xcl(e, t) {
  switch (fF(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Ecl(e, t, n, o) {
  var r = t ? mF(t, o) : n;
  if (e.indexOf(r) === 0) {
    o = new Is(o), o.selectNumberingPlan(t, n);
    var i = e.slice(r.length), a = aL(i, o), s = a.nationalNumber, c = aL(e, o), l = c.nationalNumber;
    if (!E_(l, o.nationalNumberPattern()) && E_(s, o.nationalNumberPattern()) || fF(l, o) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: i
      };
  }
  return {
    number: e
  };
}
function Tcl(e, t, n, o) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var i = wcl(e, t, n, o);
    if (i && i !== e)
      r = !0, e = "+" + i;
    else {
      if (t || n) {
        var a = Ecl(e, t, n, o), s = a.countryCallingCode, c = a.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  o = new Is(o);
  for (var l = 2; l - 1 <= gsl && l <= e.length; ) {
    var d = e.slice(1, l);
    if (o.hasCallingCode(d))
      return o.selectNumberingPlan(d), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: d,
        number: e.slice(l)
      };
    l++;
  }
  return {};
}
function Acl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ccl(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ccl(e, t) {
  if (e) {
    if (typeof e == "string")
      return uQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return uQ(e, t);
  }
}
function uQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function zcl(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var o = t.metadata;
  o = new Is(o);
  for (var r = Acl(n), i; !(i = r()).done; ) {
    var a = i.value;
    if (o.country(a), o.leadingDigits()) {
      if (e && e.search(o.leadingDigits()) === 0)
        return a;
    } else if (gF({
      phone: e,
      country: a
    }, void 0, o.metadata))
      return a;
  }
}
var Ocl = !1;
function Pcl(e, t) {
  var n = t.nationalNumber, o = t.defaultCountry, r = t.metadata;
  if (Ocl && r.isNonGeographicCallingCode(e))
    return "001";
  var i = r.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : zcl(n, {
      countries: i,
      defaultCountry: o,
      metadata: r.metadata
    });
}
var Fhe = "+", Icl = "[\\-\\.\\(\\)]?", _Q = "([" + dd + "]|" + Icl + ")", Rcl = "^\\" + Fhe + _Q + "*[" + dd + "]" + _Q + "*$", Ncl = new RegExp(Rcl, "g"), sL = dd, Dcl = "[" + sL + "]+((\\-)*[" + sL + "])*", Mcl = "a-zA-Z", Lcl = "[" + Mcl + "]+((\\-)*[" + sL + "])*", qcl = "^(" + Dcl + "\\.)*" + Lcl + "\\.?$", jcl = new RegExp(qcl, "g"), pQ = "tel:", cL = ";phone-context=", Fcl = ";isub=";
function Vcl(e) {
  var t = e.indexOf(cL);
  if (t < 0)
    return null;
  var n = t + cL.length;
  if (n >= e.length)
    return "";
  var o = e.indexOf(";", n);
  return o >= 0 ? e.substring(n, o) : e.substring(n);
}
function Bcl(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Ncl.test(e) || jcl.test(e);
}
function Ucl(e, t) {
  var n = t.extractFormattedPhoneNumber, o = Vcl(e);
  if (!Bcl(o))
    throw new o_("NOT_A_NUMBER");
  var r;
  if (o === null)
    r = n(e) || "";
  else {
    r = "", o.charAt(0) === Fhe && (r += o);
    var i = e.indexOf(pQ), a;
    i >= 0 ? a = i + pQ.length : a = 0;
    var s = e.indexOf(cL);
    r += e.substring(a, s);
  }
  var c = r.indexOf(Fcl);
  if (c > 0 && (r = r.substring(0, c)), r !== "")
    return r;
}
var Wcl = 250, Gcl = new RegExp("[" + pF + dd + "]"), Hcl = new RegExp("[^" + dd + "#]+$");
function Kcl(e, t, n) {
  if (t = t || {}, n = new Is(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new o_("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var o = Zcl(e, t.v2, t.extract), r = o.number, i = o.ext, a = o.error;
  if (!r) {
    if (t.v2)
      throw a === "TOO_SHORT" ? new o_("TOO_SHORT") : new o_("NOT_A_NUMBER");
    return {};
  }
  var s = Jcl(r, t.defaultCountry, t.defaultCallingCode, n), c = s.country, l = s.nationalNumber, d = s.countryCallingCode, u = s.countryCallingCodeSource, _ = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new o_("INVALID_COUNTRY");
    return {};
  }
  if (!l || l.length < _F) {
    if (t.v2)
      throw new o_("TOO_SHORT");
    return {};
  }
  if (l.length > fsl) {
    if (t.v2)
      throw new o_("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new vcl(d, l, n.metadata);
    return c && (p.country = c), _ && (p.carrierCode = _), i && (p.ext = i), p.__countryCallingCodeSource = u, p;
  }
  var f = (t.extended ? n.hasSelectedNumberingPlan() : c) ? E_(l, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: c,
    countryCallingCode: d,
    carrierCode: _,
    valid: f,
    possible: f ? !0 : !!(t.extended === !0 && n.possibleLengths() && jhe(l, n)),
    phone: l,
    ext: i
  } : f ? Qcl(c, l, i) : {};
}
function Ycl(e, t, n) {
  if (e) {
    if (e.length > Wcl) {
      if (n)
        throw new o_("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var o = e.search(Gcl);
    if (!(o < 0))
      return e.slice(o).replace(Hcl, "");
  }
}
function Zcl(e, t, n) {
  var o = Ucl(e, {
    extractFormattedPhoneNumber: function(a) {
      return Ycl(a, n, t);
    }
  });
  if (!o)
    return {};
  if (!qsl(o))
    return jsl(o) ? {
      error: "TOO_SHORT"
    } : {};
  var r = Fsl(o);
  return r.ext ? r : {
    number: o
  };
}
function Qcl(e, t, n) {
  var o = {
    country: e,
    phone: t
  };
  return n && (o.ext = n), o;
}
function Jcl(e, t, n, o) {
  var r = Tcl(tQ(e), t, n, o.metadata), i = r.countryCallingCodeSource, a = r.countryCallingCode, s = r.number, c;
  if (a)
    o.selectNumberingPlan(a);
  else if (s && (t || n))
    o.selectNumberingPlan(t, n), t && (c = t), a = n || mF(t, o.metadata);
  else
    return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: a
    };
  var l = aL(tQ(s), o), d = l.nationalNumber, u = l.carrierCode, _ = Pcl(a, {
    nationalNumber: d,
    defaultCountry: t,
    metadata: o
  });
  return _ && (c = _, _ === "001" || o.country(c)), {
    country: c,
    countryCallingCode: a,
    countryCallingCodeSource: i,
    nationalNumber: d,
    carrierCode: u
  };
}
function mQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function fQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mQ(Object(n), !0).forEach(function(o) {
      Xcl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Xcl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ell(e, t, n) {
  return Kcl(e, fQ(fQ({}, t), {}, {
    v2: !0
  }), n);
}
function gQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function tll(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gQ(Object(n), !0).forEach(function(o) {
      nll(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function nll(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oll(e, t) {
  return sll(e) || all(e, t) || ill(e, t) || rll();
}
function rll() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ill(e, t) {
  if (e) {
    if (typeof e == "string")
      return hQ(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return hQ(e, t);
  }
}
function hQ(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function all(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], r = !0, i = !1, a, s;
    try {
      for (n = n.call(e); !(r = (a = n.next()).done) && (o.push(a.value), !(t && o.length === t)); r = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return o;
  }
}
function sll(e) {
  if (Array.isArray(e))
    return e;
}
function cll(e) {
  var t = Array.prototype.slice.call(e), n = oll(t, 4), o = n[0], r = n[1], i = n[2], a = n[3], s, c, l;
  if (typeof o == "string")
    s = o;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    a ? (c = i, l = a) : (c = void 0, l = i), r && (c = tll({
      defaultCountry: r
    }, c));
  else if (rx(r))
    i ? (c = r, l = i) : l = r;
  else
    throw new Error("Invalid second argument: ".concat(r));
  return {
    text: s,
    options: c,
    metadata: l
  };
}
function vQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function bQ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vQ(Object(n), !0).forEach(function(o) {
      lll(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function lll(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dll(e, t, n) {
  t && t.defaultCountry && !Psl(t.defaultCountry, n) && (t = bQ(bQ({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return ell(e, t, n);
  } catch (o) {
    if (!(o instanceof o_))
      throw o;
  }
}
function yQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function $Q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yQ(Object(n), !0).forEach(function(o) {
      ull(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yQ(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function ull(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _ll() {
  var e = cll(arguments), t = e.text, n = e.options, o = e.metadata;
  n = $Q($Q({}, n), {}, {
    extract: !1
  });
  var r = dll(t, n, o);
  return r && r.isValid() || !1;
}
function Qw() {
  return csl(_ll, arguments);
}
const Ua = {
  name: "variants",
  email: "text",
  phone: "text",
  address: "text",
  text: "text",
  number: "text",
  textarea: "text",
  select: "select",
  multiselect: "multiselect",
  multiemail: "textList",
  radioInput: "objectiveWithInput",
  checkbox: "multiselect",
  radio: "select",
  boolean: "boolean",
  url: "text"
}, pll = {
  // This won't be stored in DB. It allows UI to be configured from the codebase for all existing booking fields stored in DB as well
  // Candidates for this are:
  // - Anything that you want to show in App UI only.
  // - Default values that are shown in UI that are supposed to be changed for existing bookingFields as well if user is using default values
  name: {
    label: "Name",
    value: "name",
    isTextType: !0,
    systemOnly: !0,
    variantsConfig: {
      toggleLabel: 'Split "Full name" into "First name" and "Last name"',
      defaultVariant: "fullName",
      variants: {
        firstAndLastName: {
          label: "first_last_name",
          fieldsMap: {
            firstName: {
              defaultLabel: "first_name",
              canChangeRequirability: !1
            },
            lastName: {
              defaultLabel: "last_name",
              canChangeRequirability: !0
            }
          }
        },
        fullName: {
          label: "your_name",
          fieldsMap: {
            fullName: {
              defaultLabel: "your_name",
              defaultPlaceholder: "example_name",
              canChangeRequirability: !1
            }
          }
        }
      },
      defaultValue: {
        variants: {
          firstAndLastName: {
            // Configures variant fields
            // This array form(in comparison to a generic component form) has the benefit that we can allow configuring placeholder, label, required etc. for each variant
            // Doing this in a generic component form would require a lot of work in terms of supporting variables maybe that would be read by the component.
            fields: [
              {
                // This name won't be configurable by user. User can always configure the main field name
                name: "firstName",
                type: "text",
                required: !0
              },
              {
                name: "lastName",
                type: "text",
                required: !1
              }
            ]
          },
          fullName: {
            fields: [
              {
                name: "fullName",
                type: "text",
                label: "your_name",
                required: !0
              }
            ]
          }
        }
      }
    }
  },
  email: {
    label: "Email",
    value: "email",
    isTextType: !0
  },
  phone: {
    label: "Phone",
    value: "phone",
    isTextType: !0
  },
  address: {
    label: "Address",
    value: "address",
    isTextType: !0
  },
  text: {
    label: "Short Text",
    value: "text",
    isTextType: !0
  },
  number: {
    label: "Number",
    value: "number",
    isTextType: !0,
    supportsPricing: !0
  },
  textarea: {
    label: "Long Text",
    value: "textarea",
    isTextType: !0,
    supportsLengthCheck: {
      // Keep it as small as possible. It is easier to change to a higher value but coming back to a lower value(due to any reason) would be problematic for users who have saved higher value.
      maxLength: 1e3
    }
  },
  select: {
    label: "Select",
    value: "select",
    needsOptions: !0,
    isTextType: !0,
    optionsSupportPricing: !0
  },
  multiselect: {
    label: "MultiSelect",
    value: "multiselect",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  multiemail: {
    label: "Multiple Emails",
    value: "multiemail",
    isTextType: !0
  },
  radioInput: {
    label: "Radio Input",
    value: "radioInput",
    isTextType: !1,
    systemOnly: !0
    // This is false currently because we don't want to show the options for Location field right now. It is the only field with type radioInput.
    // needsOptions: true,
  },
  checkbox: {
    label: "Checkbox Group",
    value: "checkbox",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  radio: {
    label: "Radio Group",
    value: "radio",
    needsOptions: !0,
    isTextType: !1,
    optionsSupportPricing: !0
  },
  boolean: {
    label: "Checkbox",
    value: "boolean",
    isTextType: !1,
    supportsPricing: !0
  },
  url: {
    label: "URL",
    value: "url",
    isTextType: !0
  }
}, Ea = pll;
Object.entries(Ea).forEach(([e, t]) => {
  t.propsType = Ua[e];
});
const Vhe = (e, t) => e === "firstAndLastName" ? fll(t) : mll(t), mll = (e) => {
  if (!e)
    return "";
  let t = "";
  return typeof e == "string" ? t = e : (t = e.firstName, e.lastName && (t = `${t} ${e.lastName}`)), t;
};
function fll(e) {
  let t;
  if (e = e || "", typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      const o = e.split(" ").map((a) => a.trim()), r = o[0], i = o.slice(1).join(" ");
      t = { firstName: r, lastName: i };
    }
  else
    t = e;
  return t;
}
function gll(e, t) {
  return Object.entries(e).reduce((n, [o, r]) => {
    const i = r.fields.map((a) => {
      const s = a.label ?? "", c = a.placeholder ?? "";
      return {
        ...a,
        label: t(s),
        placeholder: t(c)
      };
    });
    return n[o] = {
      ...r,
      fields: i
    }, n;
  }, {});
}
const hF = (e) => {
  var i;
  const t = e.variantsConfig, n = Ea[e.type];
  if (!n)
    throw new Error(`Invalid field.type ${e.type}}`);
  const o = (i = n == null ? void 0 : n.variantsConfig) == null ? void 0 : i.defaultValue, r = t || o;
  if (n.propsType === "variants" && !r)
    throw new Error("propsType variants must have variantsConfig");
  return r;
}, hll = (e, t) => {
  const n = hF(e);
  if (!n)
    return n;
  const o = gll(n.variants, t);
  return {
    ...n,
    variants: o
  };
}, wQ = () => G.string().refine((e) => e.trim().length > 0);
G.object({
  label: G.string(),
  value: hle,
  isTextType: G.boolean().default(!1).optional(),
  systemOnly: G.boolean().default(!1).optional(),
  needsOptions: G.boolean().default(!1).optional(),
  supportsLengthCheck: G.object({
    maxLength: G.number()
  }).optional(),
  supportsPricing: G.boolean().default(!1).optional(),
  optionsSupportPricing: G.boolean().default(!1).optional(),
  propsType: G.enum([
    "text",
    "textList",
    "select",
    "multiselect",
    "boolean",
    "objectiveWithInput",
    "variants"
  ]),
  // It is the config that can tweak what an existing or a new field shows in the App UI or booker UI.
  variantsConfig: G.object({
    /**
     * This is the default variant that will be used when a new field is created.
     */
    defaultVariant: G.string(),
    /**
     *  Used only when there are 2 variants, so that UI can be simplified by showing a switch(with this label) instead of a Select
     */
    toggleLabel: G.string().optional(),
    variants: G.record(
      G.object({
        /**
         * That's how the variant would be labelled in App UI. This label represents the field in booking questions' list
         * Supports translation
         */
        label: G.string(),
        fieldsMap: G.record(
          G.object({
            /**
             * Supports translation
             */
            defaultLabel: G.string().optional(),
            /**
             * Supports translation
             */
            defaultPlaceholder: G.string().optional(),
            /**
             * Decides if a variant field's required property can be changed or not
             */
            canChangeRequirability: G.boolean().default(!0).optional()
          })
        )
      })
    ),
    /**
     * This is the default configuration for the field.
     */
    defaultValue: ble.optional()
  }).optional()
}).refine((e) => {
  if (!e.variantsConfig)
    return;
  const t = e.variantsConfig;
  if (!t.variants[t.defaultVariant])
    throw new Error(`defaultVariant: ${t.defaultVariant} is not in variants`);
  return !0;
});
G.array(yle);
const kQ = {
  name: {
    preprocess: ({ response: e, field: t }) => {
      var i;
      const n = Ea[t.type], o = t.variant || ((i = n == null ? void 0 : n.variantsConfig) == null ? void 0 : i.defaultVariant);
      let r;
      if (!o)
        throw new Error("`variant` must be there for the field with `variantsConfig`");
      return o !== "firstAndLastName" && o !== "fullName" ? r = "fullName" : r = o, Vhe(r, e);
    },
    superRefine: ({ field: e, response: t, isPartialSchema: n, ctx: o, m: r }) => {
      var u;
      const i = G.string(), a = Ea[e.type], s = e.variant || ((u = a == null ? void 0 : a.variantsConfig) == null ? void 0 : u.defaultVariant);
      if (!s)
        throw new Error("`variant` must be there for the field with `variantsConfig`");
      const c = hF(e);
      if (!c)
        throw new Error("variantsConfig must be there for `name` field");
      const l = c.variants[s].fields, d = ["text"];
      if (l.length === 1) {
        const _ = l[0];
        if (d.includes(_.type)) {
          (_.required && !n ? wQ() : i).safeParse(t).success || o.addIssue({ code: G.ZodIssueCode.custom, message: r("Invalid string") });
          return;
        } else
          throw new Error(`Unsupported field.type with variants: ${_.type}`);
      }
      l.forEach((_) => {
        const p = _.required && !n ? wQ() : i;
        if (!d.includes(_.type))
          throw new Error(`Unsupported field.type with variants: ${_.type}`);
        const f = t;
        if (_.required && (!n && !f[_.name] && o.addIssue({ code: G.ZodIssueCode.custom, message: r("error_required_field") }), !p.safeParse(f[_.name]).success)) {
          o.addIssue({ code: G.ZodIssueCode.custom, message: r("Invalid string") });
          return;
        }
      });
    }
  },
  textarea: {
    preprocess: ({ response: e }) => e.trim(),
    superRefine: ({ field: e, response: t, ctx: n, m: o }) => {
      var d;
      const r = Ea[e.type], i = t ?? "", a = e.maxLength ?? ((d = r.supportsLengthCheck) == null ? void 0 : d.maxLength), s = e.minLength ?? 0;
      if (!a)
        throw new Error("maxLength must be there for textarea field");
      const c = i.length > a, l = i.length < s;
      if (c) {
        n.addIssue({
          code: G.ZodIssueCode.custom,
          message: o(`Max. ${a} characters allowed`)
        });
        return;
      }
      if (l) {
        n.addIssue({
          code: G.ZodIssueCode.custom,
          message: o(`Min. ${s} characters required`)
        });
        return;
      }
    }
  },
  url: {
    preprocess: ({ response: e }) => e.trim(),
    superRefine: ({ response: e, ctx: t, m: n }) => {
      const o = e ?? "", r = G.string().url();
      if (o.match(/^https?:\/[^\/]/)) {
        t.addIssue({
          code: G.ZodIssueCode.custom,
          message: n("url_validation_error")
        });
        return;
      }
      if (r.safeParse(o).success)
        return;
      if (/^[a-z0-9.-]+\.[a-z]{2,}(\/.*)?$/i.test(o)) {
        const a = `https://${o}`;
        if (r.safeParse(a).success)
          return;
      }
      t.addIssue({
        code: G.ZodIssueCode.custom,
        message: n("url_validation_error")
      });
    }
  }
}, vll = G.union([
  G.string(),
  G.boolean(),
  G.string().array(),
  G.object({
    optionValue: G.string(),
    value: G.string()
  }),
  // For variantsConfig case
  G.record(G.string())
]), bll = G.record(vll), yll = bll, SQ = (e) => e ? e.replace(/^ +/, "+") : "", $ll = ({ bookingFields: e, view: t }) => {
  const n = tA.unwrap().partial().and(yll);
  return vF({ schema: n, bookingFields: e, isPartialSchema: !0, view: t });
};
function wll({ bookingFields: e, view: t }) {
  const n = tA.and(G.record(G.any()));
  return vF({ schema: n, bookingFields: e, isPartialSchema: !1, view: t });
}
function kll({ bookingFields: e, view: t }) {
  const n = tA.and(G.record(G.any()));
  return vF({ schema: n, bookingFields: e, isPartialSchema: !1, view: t, checkOptional: !0 });
}
function vF({
  schema: e,
  bookingFields: t,
  isPartialSchema: n,
  view: o,
  checkOptional: r = !1
}) {
  const i = G.preprocess(
    (a) => {
      const s = G.record(G.any()).nullable().parse(a) || {}, c = {};
      return t ? (t.forEach((l) => {
        const d = s[l.name];
        if (d === void 0)
          return;
        const u = l.views;
        if (!(o === "ALL_VIEWS" ? !0 : u ? u.find((f) => f.id === o) : !0))
          return;
        const p = kQ[l.type];
        if (p) {
          c[l.name] = p.preprocess({
            response: d,
            isPartialSchema: n,
            field: l
          });
          return;
        }
        if (l.type === "boolean")
          c[l.name] = d === "true" || d === !0;
        else if (l.type === "multiemail" || l.type === "checkbox" || l.type === "multiselect")
          c[l.name] = d instanceof Array ? d : [d];
        else if (l.type === "radioInput" && typeof d == "string") {
          let f = {
            optionValue: "",
            value: ""
          };
          try {
            f = JSON.parse(d);
          } catch {
          }
          const g = l.optionsInputs, h = g == null ? void 0 : g[f.value];
          h && h.type === "phone" && (f.optionValue = SQ(f.optionValue)), c[l.name] = f;
        } else
          l.type === "phone" ? c[l.name] = SQ(d) : c[l.name] = d;
      }), {
        ...s,
        ...c
      }) : s;
    },
    e.superRefine(async (a, s) => {
      var _, p, f;
      if (!t)
        return;
      const c = t.find((g) => g.name === "attendeePhoneNumber"), l = c == null ? void 0 : c.hidden, d = t.find((g) => g.name === "email");
      !!(d != null && d.hidden) && !l && (a.email = "");
      for (const g of t) {
        const h = a[g.name], b = G.string(), v = n ? G.string() : G.string().refine(fgc), $ = n ? G.string() : G.string().refine(async (C) => Qw(C)), k = (C) => `{${g.name}}${C}`, S = g.views, O = o === "ALL_VIEWS" ? !0 : S ? S.find((C) => C.id === o) : !0;
        let I = g.hidden;
        const D = ((_ = g.options) == null ? void 0 : _.length) ?? 0;
        g.hideWhenJustOneOption && (I = I || D <= 1);
        let M = !1;
        if (!I && O && (M = r || !!g.required), (n || !M) && h === void 0)
          continue;
        if (M && !n && !h) {
          s.addIssue({ code: G.ZodIssueCode.custom, message: k("error_required_field") });
          return;
        }
        if (g.type === "email") {
          if (!g.hidden && (r || g.required)) {
            v.safeParse(h).success || s.addIssue({
              code: G.ZodIssueCode.custom,
              message: k("email_validation_error")
            });
            const C = h;
            (((p = g.excludeEmails) == null ? void 0 : p.split(",").map((T) => T.trim())) || []).find((T) => C.includes(T)) && s.addIssue({
              code: G.ZodIssueCode.custom,
              message: k("exclude_emails_match_found_error_message")
            });
            const w = ((f = g.requireEmails) == null ? void 0 : f.split(",").map((T) => T.trim()).filter(Boolean)) || [], E = w.find((T) => C.includes(T));
            w.length > 0 && !E && s.addIssue({
              code: G.ZodIssueCode.custom,
              message: k("require_emails_no_match_found_error_message")
            });
          }
          continue;
        }
        const N = kQ[g.type];
        if (N) {
          N.superRefine({
            response: h,
            ctx: s,
            m: k,
            field: g,
            isPartialSchema: n
          });
          continue;
        }
        if (g.type === "multiemail") {
          const C = v.array().safeParse(h);
          if (M && (!h || h.length === 0)) {
            s.addIssue({ code: G.ZodIssueCode.custom, message: k("error_required_field") });
            continue;
          }
          if (!C.success) {
            if (g.name === "guests" && h.every((x) => x === "")) {
              a[g.name] = [];
              continue;
            }
            s.addIssue({
              code: G.ZodIssueCode.custom,
              message: k("email_validation_error")
            });
            continue;
          }
          const P = C.data;
          P.sort().some((x, w) => {
            if (x === P[w + 1])
              return s.addIssue({ code: G.ZodIssueCode.custom, message: k("duplicate_email") }), !0;
          });
          continue;
        }
        if (g.type === "multiselect") {
          if (M && (!h || h.length === 0)) {
            s.addIssue({ code: G.ZodIssueCode.custom, message: k("error_required_field") });
            continue;
          }
          b.array().safeParse(h).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("Invalid array of strings") });
          continue;
        }
        if (g.type === "checkbox") {
          b.array().safeParse(h).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("Invalid array of strings") });
          continue;
        }
        if (g.type === "phone") {
          const C = M || h && h.trim() !== "";
          !g.hidden && C && ((await $.safeParseAsync(h)).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("invalid_number") }));
          continue;
        }
        if (g.type === "boolean") {
          G.boolean().safeParse(h).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("Invalid Boolean") });
          continue;
        }
        if (g.type === "radioInput") {
          if (g.optionsInputs) {
            const C = h == null ? void 0 : h.optionValue, P = g.optionsInputs[h == null ? void 0 : h.value], x = P == null ? void 0 : P.type;
            if (
              // Either the field is required or there is a radio selected, we need to check if the optionInput is required or not.
              (M || h != null && h.value) && r || P != null && P.required && !C
            ) {
              s.addIssue({ code: G.ZodIssueCode.custom, message: k("error_required_field") });
              return;
            }
            C && x === "phone" && ((await $.safeParseAsync(C)).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("invalid_number") }));
          }
          continue;
        }
        if (["address", "text", "select", "number", "radio", "textarea"].includes(g.type)) {
          b.safeParse(h).success || s.addIssue({ code: G.ZodIssueCode.custom, message: k("Invalid string") });
          continue;
        }
        s.addIssue({
          code: G.ZodIssueCode.custom,
          message: `Can't parse unknown booking field type: ${g.type}`
        });
      }
    })
  );
  return n ? i.catch(function(a) {
    return console.error("Failed to preprocess query params, prefilling will be skipped", a == null ? void 0 : a.error), {};
  }) : i;
}
const Sll = (e, t, n, o, r, i) => {
  const a = e.getValues(), [s, c] = ze(!1), l = Ic((d) => d.rescheduleUid);
  return Le(() => {
    t === "selecting_time" && (!n && !o) && (async () => {
      if (!r || i && i.length > 1) {
        c(!1);
        return;
      }
      try {
        const p = await kll({
          bookingFields: r,
          view: l ? "reschedule" : "booking"
        }).safeParseAsync(a.responses);
        c(p.success);
      } catch {
        c(!1);
      }
    })();
  }, [a, r, l, t, o, n]), s;
}, xll = Sll, Ell = (e) => {
  if (typeof e > "u")
    return [];
  const t = [];
  return Object.keys(e).forEach((n) => {
    e[n].some((o) => !(o != null && o.away && !o.toUser) && e[n].length > 0) && t.push(n);
  }), t;
}, dC = (e) => Tt(() => Ell(e), [e]), Tll = () => {
  if (typeof window > "u")
    return !1;
  const e = navigator.userAgent.toLowerCase();
  return e.includes("safari") && !e.includes("chrome");
}, All = (e) => {
  const n = e.getBoundingClientRect().top;
  Kn == null || Kn.fire("__scrollByDistance", {
    distance: n
  });
}, Bhe = (e, t) => {
  requestAnimationFrame(() => {
    if (e === 1) {
      t();
      return;
    }
    requestAnimationFrame(() => Bhe(e - 1, t));
  });
}, Cll = (e, t = !1) => {
  const n = e.getBoundingClientRect().top;
  if (e.scrollIntoView({ behavior: "smooth" }), !t)
    return;
  const o = Tll();
  Bhe(2, () => {
    const r = e.getBoundingClientRect().top;
    o && !(n !== r) && All(e);
  });
};
function zll(e) {
  const { t } = Fe(), n = e.orgSlug || e.teamSlug;
  return /* @__PURE__ */ m("div", { className: "m-8 flex items-center justify-center", children: /* @__PURE__ */ m(
    sb,
    {
      avatar: /* @__PURE__ */ m(wl, { alt: n ?? "", imageSrc: GA(e.logoUrl, n), size: "lg" }),
      headline: t("team_is_unpublished", {
        team: e.name,
        interpolation: {
          // This is needed because React automatically escapes special characters like apostrophes
          // for security (XSS prevention), but we want to display the actual apostrophe in the UI
          escapeValue: !1
        }
      }),
      description: t(`${e.orgSlug ? "org" : "team"}_is_unpublished_description`)
    }
  ) });
}
var Uhe = {};
(function(e) {
  e.__esModule = !0;
  var t = ve;
  function n(r) {
    for (var i = r.acceptedCharacters, a = r.length, s = r.value, c = r.onChange, l = o(s, a), d = t.useRef(Array.from({ length: a })), u = t.useRef(Array.from({ length: a })), _ = [], p = function(g) {
      var h = u.current[g] = u.current[g] || function(v) {
        d.current[g] = v || void 0;
      }, b = l[g] === " " ? "" : l[g];
      _.push({
        ref: h,
        value: b,
        onClick: function(v) {
          var $ = v.currentTarget;
          window.requestAnimationFrame(function() {
            $.setSelectionRange(0, 1);
          });
        },
        onFocus: function(v) {
          var $ = v.currentTarget;
          $.setSelectionRange(0, 1);
        },
        onKeyDown: function(v) {
          switch (v.key) {
            case "Backspace":
              if (v.preventDefault(), b)
                c(l.substring(0, g) + " " + l.substring(g + 1));
              else if (g > 0) {
                c(l.substring(0, g - 1) + " " + l.substring(g));
                var $ = d.current[g - 1];
                $ && $.focus();
              }
              break;
            case "ArrowUp":
            case "ArrowLeft":
              if (v.preventDefault(), g > 0) {
                var k = d.current[g - 1];
                k && (k.focus(), window.requestAnimationFrame(function() {
                  k.setSelectionRange(0, 1);
                }));
              }
              break;
            case "ArrowDown":
            case "ArrowRight":
              if (v.preventDefault(), g + 1 < a) {
                var S = d.current[g + 1];
                S && (S.focus(), window.requestAnimationFrame(function() {
                  S.setSelectionRange(0, 1);
                }));
              }
              break;
            default:
              if (v.key.length === 1 && !(v.metaKey || v.altKey || v.ctrlKey) && (v.preventDefault(), i.test(v.key)))
                if (c(l.substring(0, g) + v.key + l.substring(g + 1)), g + 1 < a) {
                  var O = d.current[g + 1];
                  O && (O.focus(), window.requestAnimationFrame(function() {
                    O.setSelectionRange(0, 1);
                  }));
                } else {
                  var I = v.currentTarget;
                  window.requestAnimationFrame(function() {
                    I.setSelectionRange(0, 1);
                  });
                }
          }
        },
        onChange: function(v) {
          var $ = v.target.value.split("").filter(function(S) {
            return i.test(S);
          }).join("");
          if (c((l.substring(0, g) + $ + l.substring(g + $.length)).substr(0, a)), g < a - 1) {
            var k = d.current[g + $.length < a ? g + $.length : a - 1];
            k && (k.focus(), window.requestAnimationFrame(function() {
              k.setSelectionRange(0, 1);
            }));
          }
        }
      });
    }, f = 0; f < a; f++)
      p(f);
    return _;
  }
  e.default = n;
  function o(r, i) {
    for (; r.length < i; )
      r += " ";
    return r.substr(0, i);
  }
})(Uhe);
const Oll = /* @__PURE__ */ Zr(Uhe), Whe = ({
  isOpenDialog: e,
  setIsOpenDialog: t,
  email: n,
  isUserSessionRequiredToVerify: o = !0,
  verifyCodeWithSessionNotRequired: r,
  verifyCodeWithSessionRequired: i,
  resetErrors: a,
  setIsPending: s,
  isPending: c,
  error: l
}) => {
  const { t: d } = Fe(), [u, _] = ze(""), [p, f] = ze(!1), g = St(($) => $.setVerificationCode), h = Oll({
    acceptedCharacters: /^[0-9]$/,
    length: 6,
    value: u,
    onChange: at(($) => {
      a(), _($);
    }, [])
  }), b = at(() => {
    a(), s(!0), o ? i(u, n) : r(u, n), g(u), f(!0);
  }, [
    a,
    s,
    o,
    i,
    u,
    n,
    r
  ]);
  Le(() => {
    p || l || c || !/^\d{6}$/.test(u.trim()) || b();
  }, [l, c, u, b, p]), Le(() => _(""), [e]);
  const v = "h-12 w-12 !text-xl text-center";
  return /* @__PURE__ */ m(
    Gi,
    {
      open: e,
      onOpenChange: () => {
        _(""), a();
      },
      children: /* @__PURE__ */ m(Ei, { className: "sm:max-w-md", children: /* @__PURE__ */ m("div", { className: "flex flex-row", children: /* @__PURE__ */ Y("div", { className: "w-full", children: [
        /* @__PURE__ */ m(zv, { title: d("verify_your_email"), subtitle: d("enter_digit_code", { email: n }) }),
        /* @__PURE__ */ m(Xn, { htmlFor: "code", children: d("code") }),
        /* @__PURE__ */ Y("div", { className: "flex flex-row justify-between", children: [
          /* @__PURE__ */ m(
            Sc,
            {
              className: v,
              name: "2fa1",
              inputMode: "decimal",
              ...h[0],
              autoFocus: !0,
              autoComplete: "one-time-code"
            }
          ),
          /* @__PURE__ */ m(Sc, { className: v, name: "2fa2", inputMode: "decimal", ...h[1] }),
          /* @__PURE__ */ m(Sc, { className: v, name: "2fa3", inputMode: "decimal", ...h[2] }),
          /* @__PURE__ */ m(Sc, { className: v, name: "2fa4", inputMode: "decimal", ...h[3] }),
          /* @__PURE__ */ m(Sc, { className: v, name: "2fa5", inputMode: "decimal", ...h[4] }),
          /* @__PURE__ */ m(Sc, { className: v, name: "2fa6", inputMode: "decimal", ...h[5] })
        ] }),
        l && /* @__PURE__ */ Y("div", { className: "mt-2 flex items-center gap-x-2 text-sm text-red-700", children: [
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(ot, { name: "info", className: "h-3 w-3" }) }),
          /* @__PURE__ */ m("p", { children: l })
        ] }),
        /* @__PURE__ */ Y(Fc, { noSticky: !0, children: [
          /* @__PURE__ */ m(ca, { onClick: () => t(!1) }),
          /* @__PURE__ */ m(ut, { type: "submit", onClick: b, loading: c, children: d("submit") })
        ] })
      ] }) }) })
    }
  );
}, Cr = G.object({
  enabled: G.boolean().optional(),
  credentialId: G.number().optional(),
  appCategories: G.array(G.string()).optional()
});
G.object({});
const Pll = G.object({
  label: G.string(),
  value: G.string()
});
G.array(Pll);
const xQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Ill = [
  xQ[0].value,
  ...xQ.slice(1).map((e) => e.value)
];
G.enum(Ill);
const Rll = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: G.string().optional(),
    enabled: G.boolean().optional(),
    credentialId: G.number().optional()
  })
);
G.object({
  client_id: G.string(),
  client_secret: G.string()
});
const Nll = Cr.merge(G.object({}));
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1),
  user_agent: G.string().min(1)
});
const Dll = G.object({
  label: G.string(),
  value: G.string()
});
G.array(Dll);
const EQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Mll = [
  EQ[0].value,
  ...EQ.slice(1).map((e) => e.value)
];
G.enum(Mll);
const Lll = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: G.string().optional(),
    enabled: G.boolean().optional(),
    credentialId: G.number().optional()
  })
);
G.object({});
const qll = Cr;
G.object({
  client_id: G.string(),
  client_secret: G.string()
});
G.object({
  api_key: G.string().min(1),
  scale_plan: G.string().default("false")
});
const jll = G.object({});
G.object({
  id: G.string()
});
G.object({
  id: G.string(),
  preset: G.string(),
  status: G.string(),
  transcription: G.array(
    G.object({
      format: G.string(),
      link: G.string().url()
    })
  )
});
G.object({
  redirect_uris: G.string(),
  client_id: G.string(),
  client_secret: G.string()
});
const Fll = G.object({}), Vll = Cr.merge(
  G.object({
    trackingId: G.string().default("").optional()
  })
);
G.object({});
const Bll = G.object({});
G.object({
  app_id: G.string().min(1),
  app_secret: G.string().min(1),
  open_verfication_token: G.string().min(1)
});
const Ull = Cr.merge(
  G.object({
    trackingId: G.string().default("").optional()
  })
);
G.object({});
const Wll = Cr.merge(
  G.object({
    thankYouPage: G.string().optional()
  })
);
G.object({
  app_key: G.string().min(1)
});
const Gll = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1),
  redirect_uris: G.union([
    G.string().url().array(),
    G.string().url().transform((e) => [e])
  ])
});
const Hll = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1),
  redirect_uris: G.union([
    G.string().url().array(),
    G.string().url().transform((e) => [e])
  ])
});
const Kll = Cr.merge(
  G.object({
    trackingId: G.string().transform((e) => {
      let t = e.trim();
      return t = t.startsWith("GTM-") ? t : `GTM-${t}`, t;
    })
  })
);
G.object({});
const TQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], Yll = [
  TQ[0].value,
  ...TQ.slice(1).map((e) => e.value)
];
G.enum(Yll);
const Zll = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: G.string().optional(),
    enabled: G.boolean().optional()
  })
);
G.object({});
const Qll = Cr;
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const Jll = Cr.merge(
  G.object({
    SITE_ID: G.string().optional(),
    SCRIPT_URL: G.string().optional()
  })
);
G.object({});
const Xll = G.object({});
G.object({
  client_id: G.string(),
  client_secret: G.string()
});
const edl = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
G.object({
  jitsiHost: G.string().optional(),
  jitsiPathPattern: G.string().optional()
});
const tdl = G.object({}), ndl = G.object({});
G.object({
  app_id: G.string().min(1),
  app_secret: G.string().min(1),
  open_verfication_token: G.string().min(1)
});
const odl = G.object({});
G.object({
  invite_link: G.string().min(1)
});
const rdl = Cr.merge(
  G.object({
    MATOMO_URL: G.string().optional(),
    SITE_ID: G.string().optional()
  })
);
G.object({});
const idl = Cr.merge(
  G.object({
    trackingId: G.string().default("").optional()
  })
);
G.object({});
const adl = G.object({
  label: G.string(),
  value: G.string()
});
G.array(adl);
const AQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
], sdl = [
  AQ[0].value,
  ...AQ.slice(1).map((e) => e.value)
];
G.enum(sdl);
const cdl = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: G.string().optional(),
    enabled: G.boolean().optional()
  })
);
G.object({});
G.object({
  nextcloudTalkHost: G.string(),
  nextcloudTalkPattern: G.string().optional(),
  nextcloudTalkClientId: G.string(),
  nextcloudTalkClientSecret: G.string()
});
const ldl = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const ddl = G.object({
  client_id: G.string(),
  client_secret: G.string()
});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const udl = G.object({
  client_id: G.string(),
  client_secret: G.string()
}), _dl = G.object({
  label: G.string(),
  value: G.string()
});
G.array(_dl);
const CQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  }
  // @TODO: not required right now
  // {
  //   label: "hold_option",
  //   value: "HOLD",
  // },
], pdl = [
  CQ[0].value,
  ...CQ.slice(1).map((e) => e.value)
];
G.enum(pdl);
const mdl = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: G.string().optional(),
    enabled: G.boolean().optional()
  })
);
G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const fdl = Cr, gdl = Cr.merge(
  G.object({
    PLAUSIBLE_URL: G.string().optional().default("https://plausible.io/js/script.js").or(G.undefined()),
    trackingId: G.string().default("").optional()
  })
);
G.object({});
const hdl = Cr.merge(
  G.object({
    TRACKING_ID: G.string().optional(),
    API_HOST: G.string().optional()
  })
);
G.object({});
const vdl = Cr;
G.object({});
var m$ = /* @__PURE__ */ ((e) => (e.CONTACT = "Contact", e.LEAD = "Lead", e.ACCOUNT = "Account", e.EVENT = "Event", e))(m$ || {}), bF = /* @__PURE__ */ ((e) => (e.EVERY_BOOKING = "every_booking", e.FIELD_EMPTY = "field_empty", e))(bF || {}), yF = /* @__PURE__ */ ((e) => (e.DATE = "date", e.TEXT = "string", e.PHONE = "phone", e.CUSTOM = "custom", e.PICKLIST = "picklist", e.CHECKBOX = "boolean", e.DATETIME = "datetime", e.TEXTAREA = "textarea", e))(yF || {}), bdl = /* @__PURE__ */ ((e) => (e.BOOKING_START_DATE = "booking_start_date", e.BOOKING_CREATED_DATE = "booking_created_date", e.BOOKING_CANCEL_DATE = "booking_cancel_date", e))(bdl || {});
const lL = G.object({
  value: G.union([G.string(), G.boolean()]),
  fieldType: G.nativeEnum(yF),
  whenToWrite: G.nativeEnum(bF)
});
G.object({
  field: G.string(),
  fieldType: G.nativeEnum(yF),
  value: G.union([G.string(), G.boolean()]),
  whenToWrite: G.nativeEnum(bF)
});
const ydl = G.record(G.string(), lL), $dl = G.object({
  rrSkipToAccountLookupField: G.boolean().optional(),
  rrSKipToAccountLookupFieldName: G.string().optional()
}).optional();
G.object({
  writeToRecordObject: ydl.optional()
});
G.any().refine((e) => typeof e == "boolean" || e === void 0).optional();
const wdl = Cr.extend({
  roundRobinLeadSkip: G.boolean().optional(),
  roundRobinSkipCheckRecordOn: G.nativeEnum(m$).default(m$.CONTACT).optional(),
  ifFreeEmailDomainSkipOwnerCheck: G.boolean().optional(),
  roundRobinSkipFallbackToLeadOwner: G.boolean().optional(),
  skipContactCreation: G.boolean().optional(),
  createEventOn: G.nativeEnum(m$).default(m$.CONTACT).optional(),
  createNewContactUnderAccount: G.boolean().optional(),
  createLeadIfAccountNull: G.boolean().optional(),
  onBookingWriteToEventObject: G.boolean().optional(),
  onBookingWriteToEventObjectMap: G.record(G.any()).optional(),
  createEventOnLeadCheckForContact: G.boolean().optional(),
  onBookingChangeRecordOwner: G.boolean().optional(),
  onBookingChangeRecordOwnerName: G.string().optional(),
  sendNoShowAttendeeData: G.boolean().optional(),
  sendNoShowAttendeeDataField: G.string().optional(),
  onBookingWriteToRecord: G.boolean().optional(),
  onBookingWriteToRecordFields: G.record(G.string(), lL).optional(),
  ignoreGuests: G.boolean().optional(),
  onCancelWriteToEventRecord: G.boolean().optional(),
  onCancelWriteToEventRecordFields: G.record(G.string(), lL).optional()
});
G.object({
  consumer_key: G.string().min(1),
  consumer_secret: G.string().min(1)
});
const kdl = {
  salesforce: $dl
}, $F = G.object({
  id: G.string(),
  label: G.string(),
  identifier: G.string().optional(),
  placeholder: G.string().optional(),
  type: G.string(),
  /**
   * @deprecated in favour of `options`
   */
  selectText: G.string().optional(),
  required: G.boolean().optional(),
  deleted: G.boolean().optional(),
  options: G.array(
    G.object({
      label: G.string(),
      // To keep backwards compatibility with the options generated from legacy selectText, we allow saving null as id
      // It helps in differentiating whether the routing logic should consider the option.label as value or option.id as value.
      // This is important for legacy routes which has option.label saved in conditions and it must keep matching with the value of the option
      id: G.string().or(G.null())
    })
  ).optional()
}), Ghe = $F.extend({
  routerId: G.string()
}), Sdl = G.union([Ghe, $F]);
G.array(Sdl).optional();
const Hhe = $F, xdl = Ghe.extend({
  routerField: Hhe,
  router: G.object({
    name: G.string(),
    description: G.string(),
    id: G.string()
  })
}), Edl = G.union([Hhe, xdl]);
G.array(Edl).optional();
var Khe = /* @__PURE__ */ ((e) => (e.CustomPageMessage = "customPageMessage", e.ExternalRedirectUrl = "externalRedirectUrl", e.EventTypeRedirectUrl = "eventTypeRedirectUrl", e))(Khe || {});
const Tdl = G.nativeEnum(Khe), Adl = G.object({
  skipContactOwner: G.boolean().optional(),
  salesforce: kdl.salesforce
}).nullish(), Yhe = G.object({
  id: G.string(),
  name: G.string().optional(),
  attributeIdForWeights: G.string().optional(),
  attributeRoutingConfig: Adl,
  // TODO: It should be renamed to formFieldsQueryValue but it would take some effort
  /**
   * RAQB query value for form fields
   * BRANDED to ensure we don't give it Attributes
   */
  queryValue: zS.brand(),
  /**
   * RAQB query value for attributes. It is only applicable for Team Events as it is used to find matching team members
   * BRANDED to ensure we don't give it Form Fields
   */
  attributesQueryValue: zS.optional(),
  /**
   * RAQB query value for fallback of `attributesQueryValue`
   * BRANDED to ensure we don't give it Form Fields, It needs Attributes
   */
  fallbackAttributesQueryValue: zS.optional(),
  /**
   * Whether the route is a fallback if no other routes match
   */
  isFallback: G.boolean().optional(),
  action: G.object({
    type: Tdl,
    eventTypeId: G.number().optional(),
    value: G.string()
  })
}), Cdl = Yhe, Zhe = G.object({
  // This is the id of the Form being used as router
  id: G.string(),
  name: G.string().optional(),
  isRouter: G.literal(!0)
}), Qhe = G.union([Yhe, Zhe]), zdl = Zhe.extend({
  //TODO: Extend it from form
  name: G.string(),
  description: G.string().nullable(),
  routes: G.array(G.union([Qhe, G.null()]))
});
G.union([G.array(Qhe), G.null()]).optional();
const Odl = G.union([Cdl, zdl]);
G.union([G.array(Odl), G.null()]).optional();
const Pdl = G.any();
G.object({});
G.record(
  G.object({
    label: G.string().optional(),
    value: G.union([G.string(), G.number(), G.array(G.string())])
  })
);
G.object({
  api_key: G.string(),
  api_route: G.string()
});
const Idl = G.object({});
var Jhe = /* @__PURE__ */ ((e) => (e.NEVER = "never", e.ALWAYS = "always", e.DAYS = "days", e))(Jhe || {});
const zQ = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING"
  },
  {
    label: "hold_option",
    value: "HOLD"
  }
], Rdl = [
  zQ[0].value,
  ...zQ.slice(1).map((e) => e.value)
], Ndl = G.enum(Rdl), Ddl = G.enum(["minutes", "hours", "days"]), Mdl = Cr.merge(
  G.object({
    price: G.number(),
    currency: G.string(),
    paymentOption: Ndl.optional(),
    enabled: G.boolean().optional(),
    refundPolicy: G.nativeEnum(Jhe).optional(),
    refundDaysCount: G.number().optional(),
    refundCountCalendarDays: G.boolean().optional(),
    autoChargeNoShowFeeIfCancelled: G.boolean().optional(),
    autoChargeNoShowFeeTimeValue: G.number().optional(),
    autoChargeNoShowFeeTimeUnit: Ddl.optional()
  })
);
G.object({
  client_id: G.string().startsWith("ca_").min(1),
  client_secret: G.string().startsWith("sk_").min(1),
  public_key: G.string().startsWith("pk_").min(1),
  webhook_secret: G.string().startsWith("whsec_").min(1)
});
const Ldl = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1),
  base_url: G.string().min(1)
});
const qdl = Cr.merge(
  G.object({
    trackingId: G.string()
  })
);
G.object({});
const jdl = Cr.merge(
  G.object({
    isSunrise: G.boolean()
  })
);
G.object({});
const Fdl = Cr.merge(
  G.object({
    SITE_ID: G.string().optional()
  })
);
G.object({});
const Vdl = Cr.merge(
  G.object({
    SITE_ID: G.string().optional(),
    SCRIPT_URL: G.string().optional()
  })
);
G.object({});
const Bdl = G.object({});
G.object({
  mode: G.string().min(1),
  region: G.string().min(1),
  api_key: G.string().min(1),
  webhook_secret: G.string().min(1)
});
const Udl = G.object({});
G.object({
  client_id: G.string().min(64),
  client_secret: G.string().min(64)
});
const Wdl = Cr.merge(
  G.object({
    isSunrise: G.boolean()
  })
);
G.object({});
const Gdl = G.object({});
G.object({
  invite_link: G.string().min(1)
});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const Hdl = Cr, Kdl = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const Ydl = Cr, Zdl = G.object({});
G.object({
  client_id: G.string().min(1),
  client_secret: G.string().min(1)
});
const Qdl = {
  alby: Rll,
  basecamp3: Nll,
  btcpayserver: Lll,
  closecom: qll,
  dailyvideo: jll,
  dub: Fll,
  fathom: Vll,
  feishucalendar: Bll,
  ga4: Ull,
  giphy: Wll,
  googlecalendar: Gll,
  googlevideo: Hll,
  gtm: Kll,
  hitpay: Zll,
  hubspot: Qll,
  insihts: Jll,
  intercom: Xll,
  jelly: edl,
  jitsivideo: tdl,
  larkcalendar: ndl,
  make: odl,
  matomo: rdl,
  metapixel: idl,
  "mock-payment-app": cdl,
  nextcloudtalk: ldl,
  office365calendar: ddl,
  office365video: udl,
  paypal: mdl,
  "pipedrive-crm": fdl,
  plausible: gdl,
  posthog: hdl,
  qr_code: vdl,
  "routing-forms": Pdl,
  salesforce: wdl,
  shimmervideo: Idl,
  stripe: Mdl,
  tandemvideo: Ldl,
  "booking-pages-tag": qdl,
  "event-type-app-card": jdl,
  twipla: Fdl,
  umami: Vdl,
  vital: Bdl,
  webex: Udl,
  wordpress: Wdl,
  zapier: Gdl,
  "zoho-bigin": Hdl,
  zohocalendar: Kdl,
  zohocrm: Ydl,
  zoomvideo: Zdl
}, Jdl = G.object(Qdl).partial(), Xdl = Jdl.optional(), wF = ule.unwrap().merge(
  G.object({
    apps: Xdl
  })
).nullable();
function nm(e, t) {
  var a;
  const n = {
    ...e,
    metadata: wF.parse(e.metadata)
  }, o = (a = n.metadata) == null ? void 0 : a.apps;
  if (!o)
    return { enabled: !1, price: 0, currency: "usd", appId: null };
  const r = Object.keys(o).filter(
    (s) => {
      var c, l;
      return ((c = o[s]) == null ? void 0 : c.price) && ((l = o[s]) == null ? void 0 : l.enabled);
    }
  );
  let i = null;
  for (const s of r) {
    const c = zhe(n, s, t);
    c && i === null && (i = {
      ...c,
      appId: s
    });
  }
  return i || {
    enabled: !1,
    price: 0,
    currency: "usd",
    appId: null,
    paymentOption: "ON_BOOKING",
    credentialId: void 0,
    refundPolicy: void 0,
    refundDaysCount: void 0,
    refundCountCalendarDays: void 0
  };
}
function eul(e) {
  const { className: t, currency: n } = e;
  return n !== "BTC" ? /* @__PURE__ */ m(ot, { name: "credit-card", className: t }) : /* @__PURE__ */ m(y4e, { className: t });
}
var Zl = /* @__PURE__ */ ((e) => (e[e.DURATION = 0] = "DURATION", e[e.LOCATION = 1] = "LOCATION", e[e.REQUIRES_CONFIRMATION = 2] = "REQUIRES_CONFIRMATION", e[e.OCCURENCES = 3] = "OCCURENCES", e[e.PRICE = 4] = "PRICE", e))(Zl || {});
const tul = "integrations:google:meet", nul = "integrations:daily", oul = tul;
var Xhe = /* @__PURE__ */ ((e) => (e.AttendeeInPerson = "attendeeInPerson", e.InPerson = "inPerson", e.Phone = "phone", e.UserPhone = "userPhone", e.Link = "link", e.Conferencing = "conferencing", e.SomewhereElse = "somewhereElse", e))(Xhe || {});
const rul = [
  {
    default: !0,
    type: "attendeeInPerson",
    label: "in_person_attendee_address",
    variable: "address",
    organizerInputType: null,
    messageForOrganizer: "Cal will ask your invitee to enter an address before scheduling.",
    attendeeInputType: "attendeeAddress",
    attendeeInputPlaceholder: "enter_address",
    defaultValueVariable: "attendeeAddress",
    iconUrl: "/map-pin-dark.svg",
    category: "in person",
    linkType: "static"
  },
  {
    default: !0,
    type: "somewhereElse",
    label: "custom_attendee_location",
    variable: "address",
    organizerInputType: null,
    messageForOrganizer: "Cal will ask your invitee to enter any location before scheduling.",
    attendeeInputType: "somewhereElse",
    attendeeInputPlaceholder: "any_location",
    defaultValueVariable: "somewhereElse",
    iconUrl: "/message-pin.svg",
    category: "other",
    linkType: "static"
  },
  {
    default: !0,
    type: "inPerson",
    label: "in_person",
    organizerInputType: "text",
    messageForOrganizer: "Provide an Address or Place",
    // HACK:
    variable: "locationAddress",
    defaultValueVariable: "address",
    iconUrl: "/map-pin-dark.svg",
    category: "in person",
    linkType: "static"
  },
  {
    default: !0,
    type: "conferencing",
    iconUrl: "/link.svg",
    organizerInputType: null,
    label: "organizer_default_conferencing_app",
    variable: "hostDefault",
    defaultValueVariable: "hostDefault",
    category: "conferencing",
    messageForOrganizer: "",
    linkType: "static",
    supportsCustomLabel: !0
  },
  {
    default: !0,
    type: "link",
    label: "link_meeting",
    organizerInputType: "text",
    organizerInputLabel: "meeting_link",
    variable: "locationLink",
    messageForOrganizer: "Provide a Meeting Link",
    defaultValueVariable: "link",
    iconUrl: "/link.svg",
    category: "other",
    linkType: "static",
    supportsCustomLabel: !0
  },
  {
    default: !0,
    type: "phone",
    label: "attendee_phone_number",
    variable: "phone",
    organizerInputType: null,
    attendeeInputType: "phone",
    attendeeInputPlaceholder: "enter_phone_number",
    defaultValueVariable: "phone",
    messageForOrganizer: "Cal will ask your invitee to enter a phone number before scheduling.",
    // This isn't inputType phone because organizer doesn't need to provide it.
    // inputType: "phone"
    iconUrl: "/phone.svg",
    category: "phone",
    linkType: "static"
  },
  {
    default: !0,
    type: "userPhone",
    label: "organizer_phone_number",
    messageForOrganizer: "Provide your phone number",
    organizerInputType: "phone",
    organizerInputLabel: "phone_number",
    variable: "locationPhoneNumber",
    defaultValueVariable: "hostPhoneNumber",
    iconUrl: "/phone.svg",
    category: "phone",
    linkType: "static"
  }
], iul = [
  "in_person_attendee_address",
  "in_person",
  "attendee_phone_number",
  "link_meeting",
  "organizer_phone_number",
  "organizer_default_conferencing_app",
  "somewhere_else",
  "custom_attendee_location"
], eve = {}, kF = [];
var kie, Sie;
for (const [e, t] of Object.entries(uF)) {
  const n = (kie = t.appData) == null ? void 0 : kie.location;
  if (n) {
    for (const [r, i] of Object.entries(n))
      typeof i == "string" && (n[r] = i.replace(/{SLUG}/g, t.slug).replace(/{TITLE}/g, t.name));
    const o = {
      ...n,
      messageForOrganizer: n.messageForOrganizer || `Set ${n.label} link`,
      iconUrl: t.logo,
      // For All event location apps, locationLink is where we store the input
      // TODO: locationLink and link seems redundant. We can modify the code to keep just one of them.
      variable: n.variable || "locationLink",
      defaultValueVariable: n.defaultValueVariable || "link"
    };
    o.linkType === "static" ? (o.organizerInputType = n.organizerInputType || "text", (Sie = o.organizerInputPlaceholder) != null && Sie.match(/https?:\/\//) && (o.organizerInputPlaceholder = ` ${o.organizerInputPlaceholder}`)) : o.organizerInputType = null, eve[e] = o.type, kF.push({
      ...o
    });
  }
}
const SF = [...rul, ...kF], aul = (e) => kF.find((t) => t.type === e), Xs = (e) => SF.find((t) => t.type === e), sul = (e) => e ? SF.find((t) => {
  if (!(t.default || t.linkType == "dynamic" || !t.urlRegExp))
    return new RegExp(t.urlRegExp).test(e);
}) : null, OQ = (e) => Xs(e) || sul(e);
({ ...Xhe, ...eve });
const cul = (e, t) => {
  if (!e)
    return t("no_location");
  const n = Xs(e), o = n == null ? void 0 : n.default;
  return n ? o ? t(n.label) : `${n.label}` : e || "";
}, tve = (e) => {
  const t = Xs(e.type);
  if (!t)
    return null;
  const n = t.defaultValueVariable;
  return n ? e[n] || t.label : (console.error(`defaultValueVariable not set for ${e.type}`), "");
};
function lul(e, t, n) {
  const o = Xs(e);
  let r = e;
  if (o && !o.default && o.linkType === "dynamic") {
    const i = n === F4.ACCEPTED;
    n === F4.CANCELLED || n === F4.REJECTED ? r == t("web_conference") : i ? r = `${cul(e, t)}: ${t(
      "meeting_url_in_confirmation_email"
    )}` : r = t("web_conferencing_details_to_follow");
  }
  return r;
}
const xF = (e, t, n) => {
  if (!t)
    return null;
  const o = G.string().default("").parse(tve(e));
  return e.type.startsWith("integrations:") ? t.label : iul.includes(o) ? n(o) : o;
}, dul = () => {
  const e = [], t = SF.filter((n) => !!n.organizerInputType);
  return t == null || t.forEach((n) => e.push(n.type)), e;
}, uul = (e) => G.array(
  G.object({
    type: G.string(),
    address: G.string().optional(),
    link: G.string().url().optional(),
    phone: G.string().refine((t) => Qw(t)).optional(),
    hostPhoneNumber: G.string().refine((t) => Qw(t)).optional(),
    displayLocationPublicly: G.boolean().optional(),
    credentialId: G.number().optional(),
    teamName: G.string().optional()
  }).passthrough().superRefine((t, n) => {
    if (t != null && t.link) {
      const o = t.link, r = Xs(t.type);
      if (r && !r.default && r.linkType === "static" && r.urlRegExp) {
        if (!G.string().regex(new RegExp(r.urlRegExp)).safeParse(o).success) {
          const s = r.organizerInputPlaceholder;
          n.addIssue({
            code: G.ZodIssueCode.custom,
            path: [(r == null ? void 0 : r.defaultValueVariable) ?? "link"],
            message: e("invalid_url_error_message", {
              label: r.label,
              sampleUrl: s ?? "https://cal.com"
            })
          });
        }
        return;
      }
      G.string().url().optional().safeParse(o).success || n.addIssue({
        code: G.ZodIssueCode.custom,
        path: [(r == null ? void 0 : r.defaultValueVariable) ?? "link"],
        message: "Invalid URL"
      });
    }
  })
).optional();
function nve(e, t) {
  return e != null && e.includes("-dark") || !(e != null && e.startsWith("/app-store")) ? t ? "invert dark:invert-0" : "dark:invert" : "";
}
const _ul = (e) => !!e;
function ove({
  eventLocationType: e,
  isTooltip: t
}) {
  const n = Zo();
  return /* @__PURE__ */ m(
    "img",
    {
      src: `${n ? "https://app.cal.com" : ""}${e.iconUrl}`,
      className: ae(nve(e == null ? void 0 : e.iconUrl, t), "me-[10px] h-4 w-4"),
      alt: `${e.label} icon`
    }
  );
}
function pul({ locations: e }) {
  const { t } = Fe();
  return /* @__PURE__ */ Y("div", { className: "my-2 me-2 flex w-full flex-col space-y-3 break-words", children: [
    /* @__PURE__ */ m("p", { children: t("select_on_next_step") }),
    e.map(
      (n, o) => {
        const r = Xs(n.type);
        if (!r)
          return null;
        const i = n.customLabel || xF(n, r, t);
        return /* @__PURE__ */ Y("div", { className: "font-sm flex flex-row items-center", children: [
          /* @__PURE__ */ m(ove, { eventLocationType: r, isTooltip: !0 }),
          /* @__PURE__ */ m("p", { className: "line-clamp-1", children: i })
        ] }, `${n.type}-${o}`);
      }
    )
  ] });
}
function mul({ locations: e }) {
  const { t } = Fe(), n = Zo(), r = e.map(
    (i, a) => {
      const s = Xs(i.type);
      if (!s)
        return null;
      const c = (i == null ? void 0 : i.customLabel) || xF(i, s, t);
      return /* @__PURE__ */ Y("div", { className: "flex flex-row items-center text-sm font-medium", children: [
        s.iconUrl === "/link.svg" ? /* @__PURE__ */ m(ot, { name: "link", className: "text-default h-4 w-4 ltr:mr-[10px] rtl:ml-[10px]" }) : /* @__PURE__ */ m(ove, { eventLocationType: s, isTooltip: !1 }),
        /* @__PURE__ */ m(Ao, { content: c, children: /* @__PURE__ */ m("p", { className: "line-clamp-1", children: c }) })
      ] }, `${i.type}-${a}`);
    }
  ).filter(_ul);
  return r.length > 1 ? /* @__PURE__ */ Y("div", { className: "flex flex-row items-center text-sm font-medium", children: [
    n ? /* @__PURE__ */ m(ot, { name: "map-pin", className: ae("me-[10px] h-4 w-4 opacity-70 dark:invert") }) : /* @__PURE__ */ m(
      "img",
      {
        src: "/map-pin-dark.svg",
        className: ae("me-[10px] h-4 w-4 opacity-70 dark:invert"),
        alt: "map-pin"
      }
    ),
    /* @__PURE__ */ m(Ao, { content: /* @__PURE__ */ m(pul, { locations: e }), children: /* @__PURE__ */ m("p", { className: "line-clamp-1", children: t("location_options", {
      locationCount: r.length
    }) }) })
  ] }) : r.length === 1 ? /* @__PURE__ */ m("div", { className: "text-default mr-6 flex w-full flex-col space-y-4 break-words text-sm rtl:mr-2", children: r }) : null;
}
function V6(e, t) {
  if (t) {
    window.open(e, "_blank");
    return;
  }
  window.location.href = e;
}
function ful(e, t) {
  const n = Ro.usePathname(), o = `${Si}${n}`;
  return Yo({
    ...t,
    mutationFn: async (i) => {
      var h, b, v;
      let a;
      const s = i && i.teamId ? i.teamId : void 0, c = i && i.defaultInstall ? i.defaultInstall : void 0, l = t != null && t.returnTo ? t.returnTo : i && i.returnTo ? i.returnTo : void 0;
      if (i === "" ? a = e : a = i.type, a != null && a.endsWith("_other_calendar") && (a = a.split("_other_calendar")[0]), t != null && t.installGoogleVideo && a !== "google_calendar")
        throw new Error("Could not install Google Meet");
      const d = {
        onErrorReturnTo: o,
        fromApp: !0,
        ...s && { teamId: s },
        ...a === "google_calendar" && { installGoogleVideo: t == null ? void 0 : t.installGoogleVideo },
        ...l && { returnTo: l },
        ...c && { defaultInstall: c }
      }, u = JSON.stringify(d), _ = gul({
        stateStr: u,
        teamId: s,
        returnTo: l
      }), p = await fetch(`/api/integrations/${a}/add${_}`);
      if (!p.ok) {
        const $ = await p.json();
        throw new Error($.message || "Something went wrong");
      }
      const f = await p.json();
      return /https?:\/\//.test(f == null ? void 0 : f.url) && !((h = f == null ? void 0 : f.url) != null && h.startsWith(window.location.origin)) ? (V6(f.url, f.newTab), { setupPending: !f.newTab, message: f.message }) : f.url ? (V6(f.url, f.newTab), {
        setupPending: ((b = f == null ? void 0 : f.url) == null ? void 0 : b.endsWith("/setup")) || ((v = f == null ? void 0 : f.url) == null ? void 0 : v.includes("/apps/installation/event-types")),
        message: f.message
      }) : l ? (V6(l, !1), { setupPending: !0, message: f.message }) : { setupPending: !1, message: f.message };
    }
  });
}
const gul = ({
  stateStr: e,
  teamId: t,
  returnTo: n
}) => {
  const o = new URL("https://example.com");
  return o.searchParams.append("state", e), t !== void 0 && o.searchParams.append("teamId", t.toString()), n && o.searchParams.append("returnTo", n), o.search;
};
function hul(e, t) {
  let n = t[e];
  if (n)
    return e;
  const o = e.substring(0, e.lastIndexOf("_"));
  if (n = t[o], n)
    return o;
  const r = e.substring(0, e.lastIndexOf("_")) + e.substring(e.lastIndexOf("_") + 1);
  if (n = t[r], n)
    return r;
  const i = e.replace(/_/g, "");
  return n = t[i], n ? i : e;
}
const PQ = {
  exchange2013calendar: hn(() => import("./InstallAppButton-Xl44Eys-.js")),
  exchange2016calendar: hn(() => import("./InstallAppButton-8GmTBNzV.js")),
  office365video: hn(() => import("./InstallAppButton-tED6MA4x.js")),
  vital: hn(() => import("./InstallAppButton-JXhBVaYJ.js"))
}, vul = {
  "general-app-settings": hn(
    () => import("./AppSettingsInterface-5ccYT4YK.js")
  ),
  weather_in_your_calendar: hn(
    () => import("./AppSettingsInterface-1VG9yRmX.js")
  ),
  zapier: hn(() => import("./AppSettingsInterface-7fMHRoTt.js"))
}, bul = {
  alby: hn(() => import("./EventTypeAppCardInterface-AwCFtu0i.js")),
  basecamp3: hn(() => import("./EventTypeAppCardInterface-YlosxFDt.js")),
  btcpayserver: hn(() => import("./EventTypeAppCardInterface-XJCj8viJ.js")),
  closecom: hn(() => import("./EventTypeAppCardInterface-A0R2Zrzu.js")),
  fathom: hn(() => import("./EventTypeAppCardInterface-ejBkd_PD.js")),
  ga4: hn(() => import("./EventTypeAppCardInterface-533txrWR.js")),
  giphy: hn(() => import("./EventTypeAppCardInterface-Joa7ghXo.js")),
  gtm: hn(() => import("./EventTypeAppCardInterface-2nyah6aL.js")),
  hitpay: hn(() => import("./EventTypeAppCardInterface-EGDQbhKF.js")),
  hubspot: hn(() => import("./EventTypeAppCardInterface-oa8_FlOs.js")),
  insihts: hn(() => import("./EventTypeAppCardInterface-L6ILJNgu.js")),
  matomo: hn(() => import("./EventTypeAppCardInterface-yaDE3Hhr.js")),
  metapixel: hn(() => import("./EventTypeAppCardInterface-TPUqMlom.js")),
  "mock-payment-app": hn(() => import("./EventTypeAppCardInterface-lvEgOcQm.js")),
  paypal: hn(() => import("./EventTypeAppCardInterface-gLvUEDc4.js")),
  "pipedrive-crm": hn(() => import("./EventTypeAppCardInterface-G4AHOdBc.js")),
  plausible: hn(() => import("./EventTypeAppCardInterface-l3l21REQ.js")),
  posthog: hn(() => import("./EventTypeAppCardInterface-Ay3WLq5q.js")),
  qr_code: hn(() => import("./EventTypeAppCardInterface-zTd8gwij.js")),
  salesforce: hn(() => import("./EventTypeAppCardInterface-BGfeNJyQ.js")),
  stripepayment: hn(() => import("./EventTypeAppCardInterface-BYENKxKb.js")),
  "booking-pages-tag": hn(
    () => import("./EventTypeAppCardInterface-I4h9rph3.js")
  ),
  "event-type-app-card": hn(
    () => import("./EventTypeAppCardInterface-K4OHLVq9.js")
  ),
  twipla: hn(() => import("./EventTypeAppCardInterface-8xy1uUqA.js")),
  umami: hn(() => import("./EventTypeAppCardInterface-16Svea1R.js")),
  "zoho-bigin": hn(() => import("./EventTypeAppCardInterface-ueFADJg2.js")),
  zohocrm: hn(() => import("./EventTypeAppCardInterface-nrkly6rQ.js"))
};
hn(() => import("./EventTypeAppSettingsInterface-oberfR8v.js")), hn(() => import("./EventTypeAppSettingsInterface-TlO5TVYX.js")), hn(() => import("./EventTypeAppSettingsInterface-__hm1tDu.js")), hn(() => import("./EventTypeAppSettingsInterface-6sO-QTP6.js")), hn(() => import("./EventTypeAppSettingsInterface-gnaLzdwT.js")), hn(() => import("./EventTypeAppSettingsInterface-z5iMQkwK.js")), hn(() => import("./EventTypeAppSettingsInterface-0caEcaUv.js")), hn(() => import("./EventTypeAppSettingsInterface-0dQHUVa4.js")), hn(() => import("./EventTypeAppSettingsInterface-q0xc3hTj.js")), hn(() => import("./EventTypeAppSettingsInterface-dHflb4ux.js")), hn(() => import("./EventTypeAppSettingsInterface-A7a6mixC.js")), hn(() => import("./EventTypeAppSettingsInterface-xcau5Skk.js")), hn(() => import("./EventTypeAppSettingsInterface-Nyao8oEh.js"));
const yul = (e) => {
  var r;
  const t = ful(null, e.options), n = hul(e.type, PQ), o = PQ[n];
  return o ? /* @__PURE__ */ m(
    o,
    {
      render: e.render,
      onChanged: e.onChanged,
      disableInstall: e.disableInstall
    }
  ) : /* @__PURE__ */ m(Ce, { children: e.render({
    useDefaultComponent: !0,
    disabled: e.disableInstall,
    onClick: () => {
      t.mutate({ type: e.type });
    },
    loading: (r = t.data) == null ? void 0 : r.setupPending
  }) });
}, rve = (e) => /* @__PURE__ */ m("div", { className: e.wrapperClassName, children: /* @__PURE__ */ m(yul, { ...e }) });
function $ul() {
  var r, i;
  const e = Ue(null), [t, n] = ze({
    left: !1,
    right: !1
  });
  return Le(() => {
    const a = e.current;
    if (a) {
      const s = a.scrollLeft <= 0, c = a.scrollWidth <= a.clientWidth + a.scrollLeft;
      n({
        left: !s,
        right: !c
      });
    }
  }, [(r = e.current) == null ? void 0 : r.scrollWidth, (i = e.current) == null ? void 0 : i.clientWidth]), { ref: e, calculateScroll: (a) => {
    const s = a.currentTarget, c = s.scrollWidth <= s.clientWidth + s.scrollLeft + 1;
    n({
      left: s.scrollLeft > 0,
      right: !c
    });
  }, leftVisible: t.left, rightVisible: t.right };
}
const dL = (e, t) => {
  if (!e)
    return null;
  const n = Math.floor(e / 60);
  e %= 60;
  let o = "";
  e > 0 && (o = e === 1 ? t("minute_one_short", { count: 1 }) : t("multiple_duration_timeUnit_short", { count: e, unit: "minute" }));
  let r = "";
  return n > 0 && (r = n === 1 ? t("hour_one_short", { count: 1 }) : t("multiple_duration_timeUnit_short", { count: n, unit: "hour" })), r && o ? `${r} ${o}` : r || o;
}, wul = ({
  event: e
}) => {
  var g, h, b;
  const { t } = Fe(), n = Ue([]);
  Zo();
  const [o, r, i] = St((v) => [
    v.selectedDuration,
    v.setSelectedDuration,
    v.state
  ]), { ref: a, calculateScroll: s, leftVisible: c, rightVisible: l } = $ul(), d = () => {
    a.current && (a.current.scrollLeft -= 100);
  }, u = () => {
    a.current && (a.current.scrollLeft += 100);
  }, _ = "isDynamic" in e && e.isDynamic, p = fu();
  if (Le(() => {
    var v;
    !o && ((v = e.metadata) != null && v.multipleDuration || _) && r(e.length);
  }, [o, r, (g = e.metadata) == null ? void 0 : g.multipleDuration, e.length, _]), Le(() => {
    const v = setTimeout(() => {
      var $;
      p || o && n.current[o] && (($ = n.current[o]) == null || $.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      }));
    }, 100);
    return () => clearTimeout(v);
  }, [o, p]), !((h = e == null ? void 0 : e.metadata) != null && h.multipleDuration) && !_)
    return /* @__PURE__ */ m(Ce, { children: dL(e.length, t) });
  const f = ((b = e == null ? void 0 : e.metadata) == null ? void 0 : b.multipleDuration) || [15, 30, 60, 90];
  return o ? /* @__PURE__ */ Y("div", { className: "border-default relative mr-5 flex flex-row items-center justify-between rounded-md border", children: [
    c && /* @__PURE__ */ Y("button", { onClick: d, className: "absolute bottom-0 left-0 flex", children: [
      /* @__PURE__ */ m("div", { className: "bg-default flex h-9 w-5 items-center justify-end rounded-md", children: /* @__PURE__ */ m(ot, { name: "chevron-left", className: "text-subtle h-4 w-4" }) }),
      /* @__PURE__ */ m("div", { className: "to-default flex h-9 w-5 bg-gradient-to-l from-transparent" })
    ] }),
    /* @__PURE__ */ m(
      "ul",
      {
        className: "bg-default no-scrollbar flex max-w-full items-center gap-0.5 overflow-x-auto rounded-md p-1",
        onScroll: (v) => s(v),
        ref: a,
        children: f.filter((v) => i !== "booking" || v === o).map((v, $) => /* @__PURE__ */ m(
          "li",
          {
            "data-testId": `multiple-choice-${v}mins`,
            "data-active": o === v ? "true" : "false",
            onClick: () => r(v),
            ref: (k) => n.current[v] = k,
            className: ae(
              o === v ? "bg-emphasis" : "hover:text-emphasis",
              "text-default cursor-pointer rounded-[4px] px-3 py-1.5 text-sm leading-tight transition"
            ),
            children: /* @__PURE__ */ m("div", { className: "w-max", children: dL(v, t) })
          },
          $
        ))
      }
    ),
    l && /* @__PURE__ */ Y("button", { onClick: u, className: "absolute bottom-0 right-0 flex", children: [
      /* @__PURE__ */ m("div", { className: "to-default flex h-9 w-5 bg-gradient-to-r from-transparent" }),
      /* @__PURE__ */ m("div", { className: "bg-default flex h-9 w-5 items-center justify-end rounded-md", children: /* @__PURE__ */ m(ot, { name: "chevron-right", className: "text-subtle h-4 w-4" }) })
    ] })
  ] }) : null;
};
var uL = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU"
], $s = (
  /** @class */
  function() {
    function e(t, n) {
      if (n === 0)
        throw new Error("Can't create weekday with n == 0");
      this.weekday = t, this.n = n;
    }
    return e.fromStr = function(t) {
      return new e(uL.indexOf(t));
    }, e.prototype.nth = function(t) {
      return this.n === t ? this : new e(this.weekday, t);
    }, e.prototype.equals = function(t) {
      return this.weekday === t.weekday && this.n === t.n;
    }, e.prototype.toString = function() {
      var t = uL[this.weekday];
      return this.n && (t = (this.n > 0 ? "+" : "") + String(this.n) + t), t;
    }, e.prototype.getJsWeekday = function() {
      return this.weekday === 6 ? 0 : this.weekday + 1;
    }, e;
  }()
), Ai = function(e) {
  return e != null;
}, Od = function(e) {
  return typeof e == "number";
}, IQ = function(e) {
  return typeof e == "string" && uL.includes(e);
}, Ac = Array.isArray, gu = function(e, t) {
  t === void 0 && (t = e), arguments.length === 1 && (t = e, e = 0);
  for (var n = [], o = e; o < t; o++)
    n.push(o);
  return n;
}, Uo = function(e, t) {
  var n = 0, o = [];
  if (Ac(e))
    for (; n < t; n++)
      o[n] = [].concat(e);
  else
    for (; n < t; n++)
      o[n] = e;
  return o;
}, kul = function(e) {
  return Ac(e) ? e : [e];
};
function ih(e, t, n) {
  n === void 0 && (n = " ");
  var o = String(e);
  return t = t >> 0, o.length > t ? String(o) : (t = t - o.length, t > n.length && (n += Uo(n, t / n.length)), n.slice(0, t) + String(o));
}
var Sul = function(e, t, n) {
  var o = e.split(t);
  return n ? o.slice(0, n).concat([o.slice(n).join(t)]) : o;
}, dl = function(e, t) {
  var n = e % t;
  return n * t < 0 ? n + t : n;
}, B6 = function(e, t) {
  return { div: Math.floor(e / t), mod: dl(e, t) };
}, Fd = function(e) {
  return !Ai(e) || e.length === 0;
}, na = function(e) {
  return !Fd(e);
}, Rr = function(e, t) {
  return na(e) && e.indexOf(t) !== -1;
}, _f;
(function(e) {
  e.MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], e.ONE_DAY = 1e3 * 60 * 60 * 24, e.MAXYEAR = 9999, e.ORDINAL_BASE = new Date(Date.UTC(1970, 0, 1)), e.PY_WEEKDAYS = [6, 0, 1, 2, 3, 4, 5], e.getYearDay = function(t) {
    var n = new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate());
    return Math.ceil((n.valueOf() - new Date(t.getUTCFullYear(), 0, 1).valueOf()) / e.ONE_DAY) + 1;
  }, e.isLeapYear = function(t) {
    return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
  }, e.isDate = function(t) {
    return t instanceof Date;
  }, e.isValidDate = function(t) {
    return e.isDate(t) && !isNaN(t.getTime());
  }, e.tzOffset = function(t) {
    return t.getTimezoneOffset() * 60 * 1e3;
  }, e.daysBetween = function(t, n) {
    var o = t.getTime() - e.tzOffset(t), r = n.getTime() - e.tzOffset(n), i = o - r;
    return Math.round(i / e.ONE_DAY);
  }, e.toOrdinal = function(t) {
    return e.daysBetween(t, e.ORDINAL_BASE);
  }, e.fromOrdinal = function(t) {
    return new Date(e.ORDINAL_BASE.getTime() + t * e.ONE_DAY);
  }, e.getMonthDays = function(t) {
    var n = t.getUTCMonth();
    return n === 1 && e.isLeapYear(t.getUTCFullYear()) ? 29 : e.MONTH_DAYS[n];
  }, e.getWeekday = function(t) {
    return e.PY_WEEKDAYS[t.getUTCDay()];
  }, e.monthRange = function(t, n) {
    var o = new Date(Date.UTC(t, n, 1));
    return [e.getWeekday(o), e.getMonthDays(o)];
  }, e.combine = function(t, n) {
    return n = n || t, new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
  }, e.clone = function(t) {
    var n = new Date(t.getTime());
    return n;
  }, e.cloneDates = function(t) {
    for (var n = [], o = 0; o < t.length; o++)
      n.push(e.clone(t[o]));
    return n;
  }, e.sort = function(t) {
    t.sort(function(n, o) {
      return n.getTime() - o.getTime();
    });
  }, e.timeToUntilString = function(t, n) {
    n === void 0 && (n = !0);
    var o = new Date(t);
    return [
      ih(o.getUTCFullYear().toString(), 4, "0"),
      ih(o.getUTCMonth() + 1, 2, "0"),
      ih(o.getUTCDate(), 2, "0"),
      "T",
      ih(o.getUTCHours(), 2, "0"),
      ih(o.getUTCMinutes(), 2, "0"),
      ih(o.getUTCSeconds(), 2, "0"),
      n ? "Z" : ""
    ].join("");
  }, e.untilStringToDate = function(t) {
    var n = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/, o = n.exec(t);
    if (!o)
      throw new Error("Invalid UNTIL value: ".concat(t));
    return new Date(Date.UTC(parseInt(o[1], 10), parseInt(o[2], 10) - 1, parseInt(o[3], 10), parseInt(o[5], 10) || 0, parseInt(o[6], 10) || 0, parseInt(o[7], 10) || 0));
  };
})(_f || (_f = {}));
const To = _f;
var Eh = (
  /** @class */
  function() {
    function e(t, n) {
      this.minDate = null, this.maxDate = null, this._result = [], this.total = 0, this.method = t, this.args = n, t === "between" ? (this.maxDate = n.inc ? n.before : new Date(n.before.getTime() - 1), this.minDate = n.inc ? n.after : new Date(n.after.getTime() + 1)) : t === "before" ? this.maxDate = n.inc ? n.dt : new Date(n.dt.getTime() - 1) : t === "after" && (this.minDate = n.inc ? n.dt : new Date(n.dt.getTime() + 1));
    }
    return e.prototype.accept = function(t) {
      ++this.total;
      var n = this.minDate && t < this.minDate, o = this.maxDate && t > this.maxDate;
      if (this.method === "between") {
        if (n)
          return !0;
        if (o)
          return !1;
      } else if (this.method === "before") {
        if (o)
          return !1;
      } else if (this.method === "after")
        return n ? !0 : (this.add(t), !1);
      return this.add(t);
    }, e.prototype.add = function(t) {
      return this._result.push(t), !0;
    }, e.prototype.getValue = function() {
      var t = this._result;
      switch (this.method) {
        case "all":
        case "between":
          return t;
        case "before":
        case "after":
        default:
          return t.length ? t[t.length - 1] : null;
      }
    }, e.prototype.clone = function() {
      return new e(this.method, this.args);
    }, e;
  }()
), _L = function(e, t) {
  return _L = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
    n.__proto__ = o;
  } || function(n, o) {
    for (var r in o)
      Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
  }, _L(e, t);
};
function EF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  _L(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Mc = function() {
  return Mc = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Mc.apply(this, arguments);
};
function Lt(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var RQ = (
  /** @class */
  function(e) {
    EF(t, e);
    function t(n, o, r) {
      var i = e.call(this, n, o) || this;
      return i.iterator = r, i;
    }
    return t.prototype.add = function(n) {
      return this.iterator(n, this._result.length) ? (this._result.push(n), !0) : !1;
    }, t;
  }(Eh)
), HE = {
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  tokens: {
    SKIP: /^[ \r\n\t]+|^\.$/,
    number: /^[1-9][0-9]*/,
    numberAsText: /^(one|two|three)/i,
    every: /^every/i,
    "day(s)": /^days?/i,
    "weekday(s)": /^weekdays?/i,
    "week(s)": /^weeks?/i,
    "hour(s)": /^hours?/i,
    "minute(s)": /^minutes?/i,
    "month(s)": /^months?/i,
    "year(s)": /^years?/i,
    on: /^(on|in)/i,
    at: /^(at)/i,
    the: /^the/i,
    first: /^first/i,
    second: /^second/i,
    third: /^third/i,
    nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
    last: /^last/i,
    for: /^for/i,
    "time(s)": /^times?/i,
    until: /^(un)?til/i,
    monday: /^mo(n(day)?)?/i,
    tuesday: /^tu(e(s(day)?)?)?/i,
    wednesday: /^we(d(n(esday)?)?)?/i,
    thursday: /^th(u(r(sday)?)?)?/i,
    friday: /^fr(i(day)?)?/i,
    saturday: /^sa(t(urday)?)?/i,
    sunday: /^su(n(day)?)?/i,
    january: /^jan(uary)?/i,
    february: /^feb(ruary)?/i,
    march: /^mar(ch)?/i,
    april: /^apr(il)?/i,
    may: /^may/i,
    june: /^june?/i,
    july: /^july?/i,
    august: /^aug(ust)?/i,
    september: /^sep(t(ember)?)?/i,
    october: /^oct(ober)?/i,
    november: /^nov(ember)?/i,
    december: /^dec(ember)?/i,
    comma: /^(,\s*|(and|or)\s*)+/i
  }
}, NQ = function(e, t) {
  return e.indexOf(t) !== -1;
}, xul = function(e) {
  return e.toString();
}, Eul = function(e, t, n) {
  return "".concat(t, " ").concat(n, ", ").concat(e);
}, N_ = (
  /** @class */
  function() {
    function e(t, n, o, r) {
      if (n === void 0 && (n = xul), o === void 0 && (o = HE), r === void 0 && (r = Eul), this.text = [], this.language = o || HE, this.gettext = n, this.dateFormatter = r, this.rrule = t, this.options = t.options, this.origOptions = t.origOptions, this.origOptions.bymonthday) {
        var i = [].concat(this.options.bymonthday), a = [].concat(this.options.bynmonthday);
        i.sort(function(d, u) {
          return d - u;
        }), a.sort(function(d, u) {
          return u - d;
        }), this.bymonthday = i.concat(a), this.bymonthday.length || (this.bymonthday = null);
      }
      if (Ai(this.origOptions.byweekday)) {
        var s = Ac(this.origOptions.byweekday) ? this.origOptions.byweekday : [this.origOptions.byweekday], c = String(s);
        this.byweekday = {
          allWeeks: s.filter(function(d) {
            return !d.n;
          }),
          someWeeks: s.filter(function(d) {
            return !!d.n;
          }),
          isWeekdays: c.indexOf("MO") !== -1 && c.indexOf("TU") !== -1 && c.indexOf("WE") !== -1 && c.indexOf("TH") !== -1 && c.indexOf("FR") !== -1 && c.indexOf("SA") === -1 && c.indexOf("SU") === -1,
          isEveryDay: c.indexOf("MO") !== -1 && c.indexOf("TU") !== -1 && c.indexOf("WE") !== -1 && c.indexOf("TH") !== -1 && c.indexOf("FR") !== -1 && c.indexOf("SA") !== -1 && c.indexOf("SU") !== -1
        };
        var l = function(d, u) {
          return d.weekday - u.weekday;
        };
        this.byweekday.allWeeks.sort(l), this.byweekday.someWeeks.sort(l), this.byweekday.allWeeks.length || (this.byweekday.allWeeks = null), this.byweekday.someWeeks.length || (this.byweekday.someWeeks = null);
      } else
        this.byweekday = null;
    }
    return e.isFullyConvertible = function(t) {
      var n = !0;
      if (!(t.options.freq in e.IMPLEMENTED) || t.origOptions.until && t.origOptions.count)
        return !1;
      for (var o in t.origOptions) {
        if (NQ(["dtstart", "wkst", "freq"], o))
          return !0;
        if (!NQ(e.IMPLEMENTED[t.options.freq], o))
          return !1;
      }
      return n;
    }, e.prototype.isFullyConvertible = function() {
      return e.isFullyConvertible(this.rrule);
    }, e.prototype.toString = function() {
      var t = this.gettext;
      if (!(this.options.freq in e.IMPLEMENTED))
        return t("RRule error: Unable to fully convert this rrule to text");
      if (this.text = [t("every")], this[jn.FREQUENCIES[this.options.freq]](), this.options.until) {
        this.add(t("until"));
        var n = this.options.until;
        this.add(this.dateFormatter(n.getUTCFullYear(), this.language.monthNames[n.getUTCMonth()], n.getUTCDate()));
      } else
        this.options.count && this.add(t("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? t("times") : t("time"));
      return this.isFullyConvertible() || this.add(t("(~ approximate)")), this.text.join("");
    }, e.prototype.HOURLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("hours") : t("hour"));
    }, e.prototype.MINUTELY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("minutes") : t("minute"));
    }, e.prototype.DAILY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.byweekday && this.byweekday.isWeekdays ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(this.plural(this.options.interval) ? t("days") : t("day")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday ? this._byweekday() : this.origOptions.byhour && this._byhour();
    }, e.prototype.WEEKLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? t("weeks") : t("week")), this.byweekday && this.byweekday.isWeekdays ? this.options.interval === 1 ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(t("on")).add(t("weekdays")) : this.byweekday && this.byweekday.isEveryDay ? this.add(this.plural(this.options.interval) ? t("days") : t("day")) : (this.options.interval === 1 && this.add(t("week")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday());
    }, e.prototype.MONTHLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()).add(t("months")), this.plural(this.options.interval) && this.add(t("in"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("months") : t("month"))), this.bymonthday ? this._bymonthday() : this.byweekday && this.byweekday.isWeekdays ? this.add(t("on")).add(t("weekdays")) : this.byweekday && this._byweekday();
    }, e.prototype.YEARLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()), this.add(t("years"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("years") : t("year"))), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.options.byyearday && this.add(t("on the")).add(this.list(this.options.byyearday, this.nth, t("and"))).add(t("day")), this.options.byweekno && this.add(t("in")).add(this.plural(this.options.byweekno.length) ? t("weeks") : t("week")).add(this.list(this.options.byweekno, void 0, t("and")));
    }, e.prototype._bymonthday = function() {
      var t = this.gettext;
      this.byweekday && this.byweekday.allWeeks ? this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, t("or"))).add(t("the")).add(this.list(this.bymonthday, this.nth, t("or"))) : this.add(t("on the")).add(this.list(this.bymonthday, this.nth, t("and")));
    }, e.prototype._byweekday = function() {
      var t = this.gettext;
      this.byweekday.allWeeks && !this.byweekday.isWeekdays && this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext)), this.byweekday.someWeeks && (this.byweekday.allWeeks && this.add(t("and")), this.add(t("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, t("and"))));
    }, e.prototype._byhour = function() {
      var t = this.gettext;
      this.add(t("at")).add(this.list(this.origOptions.byhour, void 0, t("and")));
    }, e.prototype._bymonth = function() {
      this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")));
    }, e.prototype.nth = function(t) {
      t = parseInt(t.toString(), 10);
      var n, o = this.gettext;
      if (t === -1)
        return o("last");
      var r = Math.abs(t);
      switch (r) {
        case 1:
        case 21:
        case 31:
          n = r + o("st");
          break;
        case 2:
        case 22:
          n = r + o("nd");
          break;
        case 3:
        case 23:
          n = r + o("rd");
          break;
        default:
          n = r + o("th");
      }
      return t < 0 ? n + " " + o("last") : n;
    }, e.prototype.monthtext = function(t) {
      return this.language.monthNames[t - 1];
    }, e.prototype.weekdaytext = function(t) {
      var n = Od(t) ? (t + 1) % 7 : t.getJsWeekday();
      return (t.n ? this.nth(t.n) + " " : "") + this.language.dayNames[n];
    }, e.prototype.plural = function(t) {
      return t % 100 !== 1;
    }, e.prototype.add = function(t) {
      return this.text.push(" "), this.text.push(t), this;
    }, e.prototype.list = function(t, n, o, r) {
      var i = this;
      r === void 0 && (r = ","), Ac(t) || (t = [t]);
      var a = function(c, l, d) {
        for (var u = "", _ = 0; _ < c.length; _++)
          _ !== 0 && (_ === c.length - 1 ? u += " " + d + " " : u += l + " "), u += c[_];
        return u;
      };
      n = n || function(c) {
        return c.toString();
      };
      var s = function(c) {
        return n && n.call(i, c);
      };
      return o ? a(t.map(s), r, o) : t.map(s).join(r + " ");
    }, e;
  }()
), Tul = (
  /** @class */
  function() {
    function e(t) {
      this.done = !0, this.rules = t;
    }
    return e.prototype.start = function(t) {
      return this.text = t, this.done = !1, this.nextSymbol();
    }, e.prototype.isDone = function() {
      return this.done && this.symbol === null;
    }, e.prototype.nextSymbol = function() {
      var t, n;
      this.symbol = null, this.value = null;
      do {
        if (this.done)
          return !1;
        var o = void 0;
        t = null;
        for (var r in this.rules) {
          o = this.rules[r];
          var i = o.exec(this.text);
          i && (t === null || i[0].length > t[0].length) && (t = i, n = r);
        }
        if (t != null && (this.text = this.text.substr(t[0].length), this.text === "" && (this.done = !0)), t == null) {
          this.done = !0, this.symbol = null, this.value = null;
          return;
        }
      } while (n === "SKIP");
      return this.symbol = n, this.value = t, !0;
    }, e.prototype.accept = function(t) {
      if (this.symbol === t) {
        if (this.value) {
          var n = this.value;
          return this.nextSymbol(), n;
        }
        return this.nextSymbol(), !0;
      }
      return !1;
    }, e.prototype.acceptNumber = function() {
      return this.accept("number");
    }, e.prototype.expect = function(t) {
      if (this.accept(t))
        return !0;
      throw new Error("expected " + t + " but found " + this.symbol);
    }, e;
  }()
);
function ive(e, t) {
  t === void 0 && (t = HE);
  var n = {}, o = new Tul(t.tokens);
  if (!o.start(e))
    return null;
  return r(), n;
  function r() {
    o.expect("every");
    var _ = o.acceptNumber();
    if (_ && (n.interval = parseInt(_[0], 10)), o.isDone())
      throw new Error("Unexpected end");
    switch (o.symbol) {
      case "day(s)":
        n.freq = jn.DAILY, o.nextSymbol() && (a(), u());
        break;
      case "weekday(s)":
        n.freq = jn.WEEKLY, n.byweekday = [jn.MO, jn.TU, jn.WE, jn.TH, jn.FR], o.nextSymbol(), u();
        break;
      case "week(s)":
        n.freq = jn.WEEKLY, o.nextSymbol() && (i(), u());
        break;
      case "hour(s)":
        n.freq = jn.HOURLY, o.nextSymbol() && (i(), u());
        break;
      case "minute(s)":
        n.freq = jn.MINUTELY, o.nextSymbol() && (i(), u());
        break;
      case "month(s)":
        n.freq = jn.MONTHLY, o.nextSymbol() && (i(), u());
        break;
      case "year(s)":
        n.freq = jn.YEARLY, o.nextSymbol() && (i(), u());
        break;
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        n.freq = jn.WEEKLY;
        var p = o.symbol.substr(0, 2).toUpperCase();
        if (n.byweekday = [jn[p]], !o.nextSymbol())
          return;
        for (; o.accept("comma"); ) {
          if (o.isDone())
            throw new Error("Unexpected end");
          var f = c();
          if (!f)
            throw new Error("Unexpected symbol " + o.symbol + ", expected weekday");
          n.byweekday.push(jn[f]), o.nextSymbol();
        }
        d(), u();
        break;
      case "january":
      case "february":
      case "march":
      case "april":
      case "may":
      case "june":
      case "july":
      case "august":
      case "september":
      case "october":
      case "november":
      case "december":
        if (n.freq = jn.YEARLY, n.bymonth = [s()], !o.nextSymbol())
          return;
        for (; o.accept("comma"); ) {
          if (o.isDone())
            throw new Error("Unexpected end");
          var g = s();
          if (!g)
            throw new Error("Unexpected symbol " + o.symbol + ", expected month");
          n.bymonth.push(g), o.nextSymbol();
        }
        i(), u();
        break;
      default:
        throw new Error("Unknown symbol");
    }
  }
  function i() {
    var _ = o.accept("on"), p = o.accept("the");
    if (_ || p)
      do {
        var f = l(), g = c(), h = s();
        if (f)
          g ? (o.nextSymbol(), n.byweekday || (n.byweekday = []), n.byweekday.push(jn[g].nth(f))) : (n.bymonthday || (n.bymonthday = []), n.bymonthday.push(f), o.accept("day(s)"));
        else if (g)
          o.nextSymbol(), n.byweekday || (n.byweekday = []), n.byweekday.push(jn[g]);
        else if (o.symbol === "weekday(s)")
          o.nextSymbol(), n.byweekday || (n.byweekday = [jn.MO, jn.TU, jn.WE, jn.TH, jn.FR]);
        else if (o.symbol === "week(s)") {
          o.nextSymbol();
          var b = o.acceptNumber();
          if (!b)
            throw new Error("Unexpected symbol " + o.symbol + ", expected week number");
          for (n.byweekno = [parseInt(b[0], 10)]; o.accept("comma"); ) {
            if (b = o.acceptNumber(), !b)
              throw new Error("Unexpected symbol " + o.symbol + "; expected monthday");
            n.byweekno.push(parseInt(b[0], 10));
          }
        } else if (h)
          o.nextSymbol(), n.bymonth || (n.bymonth = []), n.bymonth.push(h);
        else
          return;
      } while (o.accept("comma") || o.accept("the") || o.accept("on"));
  }
  function a() {
    var _ = o.accept("at");
    if (_)
      do {
        var p = o.acceptNumber();
        if (!p)
          throw new Error("Unexpected symbol " + o.symbol + ", expected hour");
        for (n.byhour = [parseInt(p[0], 10)]; o.accept("comma"); ) {
          if (p = o.acceptNumber(), !p)
            throw new Error("Unexpected symbol " + o.symbol + "; expected hour");
          n.byhour.push(parseInt(p[0], 10));
        }
      } while (o.accept("comma") || o.accept("at"));
  }
  function s() {
    switch (o.symbol) {
      case "january":
        return 1;
      case "february":
        return 2;
      case "march":
        return 3;
      case "april":
        return 4;
      case "may":
        return 5;
      case "june":
        return 6;
      case "july":
        return 7;
      case "august":
        return 8;
      case "september":
        return 9;
      case "october":
        return 10;
      case "november":
        return 11;
      case "december":
        return 12;
      default:
        return !1;
    }
  }
  function c() {
    switch (o.symbol) {
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        return o.symbol.substr(0, 2).toUpperCase();
      default:
        return !1;
    }
  }
  function l() {
    switch (o.symbol) {
      case "last":
        return o.nextSymbol(), -1;
      case "first":
        return o.nextSymbol(), 1;
      case "second":
        return o.nextSymbol(), o.accept("last") ? -2 : 2;
      case "third":
        return o.nextSymbol(), o.accept("last") ? -3 : 3;
      case "nth":
        var _ = parseInt(o.value[1], 10);
        if (_ < -366 || _ > 366)
          throw new Error("Nth out of range: " + _);
        return o.nextSymbol(), o.accept("last") ? -_ : _;
      default:
        return !1;
    }
  }
  function d() {
    o.accept("on"), o.accept("the");
    var _ = l();
    if (_)
      for (n.bymonthday = [_], o.nextSymbol(); o.accept("comma"); ) {
        if (_ = l(), !_)
          throw new Error("Unexpected symbol " + o.symbol + "; expected monthday");
        n.bymonthday.push(_), o.nextSymbol();
      }
  }
  function u() {
    if (o.symbol === "until") {
      var _ = Date.parse(o.text);
      if (!_)
        throw new Error("Cannot parse until date:" + o.text);
      n.until = new Date(_);
    } else
      o.accept("for") && (n.count = parseInt(o.value[0], 10), o.expect("number"));
  }
}
var Go;
(function(e) {
  e[e.YEARLY = 0] = "YEARLY", e[e.MONTHLY = 1] = "MONTHLY", e[e.WEEKLY = 2] = "WEEKLY", e[e.DAILY = 3] = "DAILY", e[e.HOURLY = 4] = "HOURLY", e[e.MINUTELY = 5] = "MINUTELY", e[e.SECONDLY = 6] = "SECONDLY";
})(Go || (Go = {}));
function TF(e) {
  return e < Go.HOURLY;
}
var Aul = function(e, t) {
  return t === void 0 && (t = HE), new jn(ive(e, t) || void 0);
}, pb = [
  "count",
  "until",
  "interval",
  "byweekday",
  "bymonthday",
  "bymonth"
];
N_.IMPLEMENTED = [];
N_.IMPLEMENTED[Go.HOURLY] = pb;
N_.IMPLEMENTED[Go.MINUTELY] = pb;
N_.IMPLEMENTED[Go.DAILY] = ["byhour"].concat(pb);
N_.IMPLEMENTED[Go.WEEKLY] = pb;
N_.IMPLEMENTED[Go.MONTHLY] = pb;
N_.IMPLEMENTED[Go.YEARLY] = ["byweekno", "byyearday"].concat(pb);
var Cul = function(e, t, n, o) {
  return new N_(e, t, n, o).toString();
}, zul = N_.isFullyConvertible, KE = (
  /** @class */
  function() {
    function e(t, n, o, r) {
      this.hour = t, this.minute = n, this.second = o, this.millisecond = r || 0;
    }
    return e.prototype.getHours = function() {
      return this.hour;
    }, e.prototype.getMinutes = function() {
      return this.minute;
    }, e.prototype.getSeconds = function() {
      return this.second;
    }, e.prototype.getMilliseconds = function() {
      return this.millisecond;
    }, e.prototype.getTime = function() {
      return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1e3 + this.millisecond;
    }, e;
  }()
), Oul = (
  /** @class */
  function(e) {
    EF(t, e);
    function t(n, o, r, i, a, s, c) {
      var l = e.call(this, i, a, s, c) || this;
      return l.year = n, l.month = o, l.day = r, l;
    }
    return t.fromDate = function(n) {
      return new this(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate(), n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.valueOf() % 1e3);
    }, t.prototype.getWeekday = function() {
      return _f.getWeekday(new Date(this.getTime()));
    }, t.prototype.getTime = function() {
      return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    }, t.prototype.getDay = function() {
      return this.day;
    }, t.prototype.getMonth = function() {
      return this.month;
    }, t.prototype.getYear = function() {
      return this.year;
    }, t.prototype.addYears = function(n) {
      this.year += n;
    }, t.prototype.addMonths = function(n) {
      if (this.month += n, this.month > 12) {
        var o = Math.floor(this.month / 12), r = dl(this.month, 12);
        this.month = r, this.year += o, this.month === 0 && (this.month = 12, --this.year);
      }
    }, t.prototype.addWeekly = function(n, o) {
      o > this.getWeekday() ? this.day += -(this.getWeekday() + 1 + (6 - o)) + n * 7 : this.day += -(this.getWeekday() - o) + n * 7, this.fixDay();
    }, t.prototype.addDaily = function(n) {
      this.day += n, this.fixDay();
    }, t.prototype.addHours = function(n, o, r) {
      for (o && (this.hour += Math.floor((23 - this.hour) / n) * n); ; ) {
        this.hour += n;
        var i = B6(this.hour, 24), a = i.div, s = i.mod;
        if (a && (this.hour = s, this.addDaily(a)), Fd(r) || Rr(r, this.hour))
          break;
      }
    }, t.prototype.addMinutes = function(n, o, r, i) {
      for (o && (this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / n) * n); ; ) {
        this.minute += n;
        var a = B6(this.minute, 60), s = a.div, c = a.mod;
        if (s && (this.minute = c, this.addHours(s, !1, r)), (Fd(r) || Rr(r, this.hour)) && (Fd(i) || Rr(i, this.minute)))
          break;
      }
    }, t.prototype.addSeconds = function(n, o, r, i, a) {
      for (o && (this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / n) * n); ; ) {
        this.second += n;
        var s = B6(this.second, 60), c = s.div, l = s.mod;
        if (c && (this.second = l, this.addMinutes(c, !1, r, i)), (Fd(r) || Rr(r, this.hour)) && (Fd(i) || Rr(i, this.minute)) && (Fd(a) || Rr(a, this.second)))
          break;
      }
    }, t.prototype.fixDay = function() {
      if (!(this.day <= 28)) {
        var n = _f.monthRange(this.year, this.month - 1)[1];
        if (!(this.day <= n))
          for (; this.day > n; ) {
            if (this.day -= n, ++this.month, this.month === 13 && (this.month = 1, ++this.year, this.year > _f.MAXYEAR))
              return;
            n = _f.monthRange(this.year, this.month - 1)[1];
          }
      }
    }, t.prototype.add = function(n, o) {
      var r = n.freq, i = n.interval, a = n.wkst, s = n.byhour, c = n.byminute, l = n.bysecond;
      switch (r) {
        case Go.YEARLY:
          return this.addYears(i);
        case Go.MONTHLY:
          return this.addMonths(i);
        case Go.WEEKLY:
          return this.addWeekly(i, a);
        case Go.DAILY:
          return this.addDaily(i);
        case Go.HOURLY:
          return this.addHours(i, o, s);
        case Go.MINUTELY:
          return this.addMinutes(i, o, s, c);
        case Go.SECONDLY:
          return this.addSeconds(i, o, s, c, l);
      }
    }, t;
  }(KE)
);
function ave(e) {
  for (var t = [], n = Object.keys(e), o = 0, r = n; o < r.length; o++) {
    var i = r[o];
    Rr(s_l, i) || t.push(i), To.isDate(e[i]) && !To.isValidDate(e[i]) && t.push(i);
  }
  if (t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Mc({}, e);
}
function Pul(e) {
  var t = Mc(Mc({}, AF), ave(e));
  if (Ai(t.byeaster) && (t.freq = jn.YEARLY), !(Ai(t.freq) && jn.FREQUENCIES[t.freq]))
    throw new Error("Invalid frequency: ".concat(t.freq, " ").concat(e.freq));
  if (t.dtstart || (t.dtstart = new Date((/* @__PURE__ */ new Date()).setMilliseconds(0))), Ai(t.wkst) ? Od(t.wkst) || (t.wkst = t.wkst.weekday) : t.wkst = jn.MO.weekday, Ai(t.bysetpos)) {
    Od(t.bysetpos) && (t.bysetpos = [t.bysetpos]);
    for (var n = 0; n < t.bysetpos.length; n++) {
      var o = t.bysetpos[n];
      if (o === 0 || !(o >= -366 && o <= 366))
        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
    }
  }
  if (!(t.byweekno || na(t.byweekno) || na(t.byyearday) || t.bymonthday || na(t.bymonthday) || Ai(t.byweekday) || Ai(t.byeaster)))
    switch (t.freq) {
      case jn.YEARLY:
        t.bymonth || (t.bymonth = t.dtstart.getUTCMonth() + 1), t.bymonthday = t.dtstart.getUTCDate();
        break;
      case jn.MONTHLY:
        t.bymonthday = t.dtstart.getUTCDate();
        break;
      case jn.WEEKLY:
        t.byweekday = [To.getWeekday(t.dtstart)];
        break;
    }
  if (Ai(t.bymonth) && !Ac(t.bymonth) && (t.bymonth = [t.bymonth]), Ai(t.byyearday) && !Ac(t.byyearday) && Od(t.byyearday) && (t.byyearday = [t.byyearday]), !Ai(t.bymonthday))
    t.bymonthday = [], t.bynmonthday = [];
  else if (Ac(t.bymonthday)) {
    for (var r = [], i = [], n = 0; n < t.bymonthday.length; n++) {
      var o = t.bymonthday[n];
      o > 0 ? r.push(o) : o < 0 && i.push(o);
    }
    t.bymonthday = r, t.bynmonthday = i;
  } else
    t.bymonthday < 0 ? (t.bynmonthday = [t.bymonthday], t.bymonthday = []) : (t.bynmonthday = [], t.bymonthday = [t.bymonthday]);
  if (Ai(t.byweekno) && !Ac(t.byweekno) && (t.byweekno = [t.byweekno]), !Ai(t.byweekday))
    t.bynweekday = null;
  else if (Od(t.byweekday))
    t.byweekday = [t.byweekday], t.bynweekday = null;
  else if (IQ(t.byweekday))
    t.byweekday = [$s.fromStr(t.byweekday).weekday], t.bynweekday = null;
  else if (t.byweekday instanceof $s)
    !t.byweekday.n || t.freq > jn.MONTHLY ? (t.byweekday = [t.byweekday.weekday], t.bynweekday = null) : (t.bynweekday = [[t.byweekday.weekday, t.byweekday.n]], t.byweekday = null);
  else {
    for (var a = [], s = [], n = 0; n < t.byweekday.length; n++) {
      var c = t.byweekday[n];
      if (Od(c)) {
        a.push(c);
        continue;
      } else if (IQ(c)) {
        a.push($s.fromStr(c).weekday);
        continue;
      }
      !c.n || t.freq > jn.MONTHLY ? a.push(c.weekday) : s.push([c.weekday, c.n]);
    }
    t.byweekday = na(a) ? a : null, t.bynweekday = na(s) ? s : null;
  }
  return Ai(t.byhour) ? Od(t.byhour) && (t.byhour = [t.byhour]) : t.byhour = t.freq < jn.HOURLY ? [t.dtstart.getUTCHours()] : null, Ai(t.byminute) ? Od(t.byminute) && (t.byminute = [t.byminute]) : t.byminute = t.freq < jn.MINUTELY ? [t.dtstart.getUTCMinutes()] : null, Ai(t.bysecond) ? Od(t.bysecond) && (t.bysecond = [t.bysecond]) : t.bysecond = t.freq < jn.SECONDLY ? [t.dtstart.getUTCSeconds()] : null, { parsedOptions: t };
}
function Iul(e) {
  var t = e.dtstart.getTime() % 1e3;
  if (!TF(e.freq))
    return [];
  var n = [];
  return e.byhour.forEach(function(o) {
    e.byminute.forEach(function(r) {
      e.bysecond.forEach(function(i) {
        n.push(new KE(o, r, i, t));
      });
    });
  }), n;
}
function pL(e) {
  var t = e.split(`
`).map(Rul).filter(function(n) {
    return n !== null;
  });
  return Mc(Mc({}, t[0]), t[1]);
}
function YE(e) {
  var t = {}, n = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(e);
  if (!n)
    return t;
  var o = n[1], r = n[2];
  return o && (t.tzid = o), t.dtstart = To.untilStringToDate(r), t;
}
function Rul(e) {
  if (e = e.replace(/^\s+|\s+$/, ""), !e.length)
    return null;
  var t = /^([A-Z]+?)[:;]/.exec(e.toUpperCase());
  if (!t)
    return DQ(e);
  var n = t[1];
  switch (n.toUpperCase()) {
    case "RRULE":
    case "EXRULE":
      return DQ(e);
    case "DTSTART":
      return YE(e);
    default:
      throw new Error("Unsupported RFC prop ".concat(n, " in ").concat(e));
  }
}
function DQ(e) {
  var t = e.replace(/^RRULE:/i, ""), n = YE(t), o = e.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
  return o.forEach(function(r) {
    var i = r.split("="), a = i[0], s = i[1];
    switch (a.toUpperCase()) {
      case "FREQ":
        n.freq = Go[s.toUpperCase()];
        break;
      case "WKST":
        n.wkst = Yl[s.toUpperCase()];
        break;
      case "COUNT":
      case "INTERVAL":
      case "BYSETPOS":
      case "BYMONTH":
      case "BYMONTHDAY":
      case "BYYEARDAY":
      case "BYWEEKNO":
      case "BYHOUR":
      case "BYMINUTE":
      case "BYSECOND":
        var c = Nul(s), l = a.toLowerCase();
        n[l] = c;
        break;
      case "BYWEEKDAY":
      case "BYDAY":
        n.byweekday = Dul(s);
        break;
      case "DTSTART":
      case "TZID":
        var d = YE(e);
        n.tzid = d.tzid, n.dtstart = d.dtstart;
        break;
      case "UNTIL":
        n.until = To.untilStringToDate(s);
        break;
      case "BYEASTER":
        n.byeaster = Number(s);
        break;
      default:
        throw new Error("Unknown RRULE property '" + a + "'");
    }
  }), n;
}
function Nul(e) {
  if (e.indexOf(",") !== -1) {
    var t = e.split(",");
    return t.map(MQ);
  }
  return MQ(e);
}
function MQ(e) {
  return /^[+-]?\d+$/.test(e) ? Number(e) : e;
}
function Dul(e) {
  var t = e.split(",");
  return t.map(function(n) {
    if (n.length === 2)
      return Yl[n];
    var o = n.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
    if (!o || o.length < 3)
      throw new SyntaxError("Invalid weekday string: ".concat(n));
    var r = Number(o[1]), i = o[2], a = Yl[i].weekday;
    return new $s(a, r);
  });
}
var ZE = (
  /** @class */
  function() {
    function e(t, n) {
      if (isNaN(t.getTime()))
        throw new RangeError("Invalid date passed to DateWithZone");
      this.date = t, this.tzid = n;
    }
    return Object.defineProperty(e.prototype, "isUTC", {
      get: function() {
        return !this.tzid || this.tzid.toUpperCase() === "UTC";
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toString = function() {
      var t = To.timeToUntilString(this.date.getTime(), this.isUTC);
      return this.isUTC ? ":".concat(t) : ";TZID=".concat(this.tzid, ":").concat(t);
    }, e.prototype.getTime = function() {
      return this.date.getTime();
    }, e.prototype.rezonedDate = function() {
      var t;
      if (this.isUTC)
        return this.date;
      var n = Intl.DateTimeFormat().resolvedOptions().timeZone, o = new Date(this.date.toLocaleString(void 0, { timeZone: n })), r = new Date(this.date.toLocaleString(void 0, { timeZone: (t = this.tzid) !== null && t !== void 0 ? t : "UTC" })), i = r.getTime() - o.getTime();
      return new Date(this.date.getTime() - i);
    }, e;
  }()
);
function mL(e) {
  for (var t = [], n = "", o = Object.keys(e), r = Object.keys(AF), i = 0; i < o.length; i++)
    if (o[i] !== "tzid" && Rr(r, o[i])) {
      var a = o[i].toUpperCase(), s = e[o[i]], c = "";
      if (!(!Ai(s) || Ac(s) && !s.length)) {
        switch (a) {
          case "FREQ":
            c = jn.FREQUENCIES[e.freq];
            break;
          case "WKST":
            Od(s) ? c = new $s(s).toString() : c = s.toString();
            break;
          case "BYWEEKDAY":
            a = "BYDAY", c = kul(s).map(function(p) {
              return p instanceof $s ? p : Ac(p) ? new $s(p[0], p[1]) : new $s(p);
            }).toString();
            break;
          case "DTSTART":
            n = Mul(s, e.tzid);
            break;
          case "UNTIL":
            c = To.timeToUntilString(s, !e.tzid);
            break;
          default:
            if (Ac(s)) {
              for (var l = [], d = 0; d < s.length; d++)
                l[d] = String(s[d]);
              c = l.toString();
            } else
              c = String(s);
        }
        c && t.push([a, c]);
      }
    }
  var u = t.map(function(p) {
    var f = p[0], g = p[1];
    return "".concat(f, "=").concat(g.toString());
  }).join(";"), _ = "";
  return u !== "" && (_ = "RRULE:".concat(u)), [n, _].filter(function(p) {
    return !!p;
  }).join(`
`);
}
function Mul(e, t) {
  return e ? "DTSTART" + new ZE(new Date(e), t).toString() : "";
}
function Lul(e, t) {
  return Array.isArray(e) ? !Array.isArray(t) || e.length !== t.length ? !1 : e.every(function(n, o) {
    return n.getTime() === t[o].getTime();
  }) : e instanceof Date ? t instanceof Date && e.getTime() === t.getTime() : e === t;
}
var qul = (
  /** @class */
  function() {
    function e() {
      this.all = !1, this.before = [], this.after = [], this.between = [];
    }
    return e.prototype._cacheAdd = function(t, n, o) {
      n && (n = n instanceof Date ? To.clone(n) : To.cloneDates(n)), t === "all" ? this.all = n : (o._value = n, this[t].push(o));
    }, e.prototype._cacheGet = function(t, n) {
      var o = !1, r = n ? Object.keys(n) : [], i = function(d) {
        for (var u = 0; u < r.length; u++) {
          var _ = r[u];
          if (!Lul(n[_], d[_]))
            return !0;
        }
        return !1;
      }, a = this[t];
      if (t === "all")
        o = this.all;
      else if (Ac(a))
        for (var s = 0; s < a.length; s++) {
          var c = a[s];
          if (!(r.length && i(c))) {
            o = c._value;
            break;
          }
        }
      if (!o && this.all) {
        for (var l = new Eh(t, n), s = 0; s < this.all.length && l.accept(this.all[s]); s++)
          ;
        o = l.getValue(), this._cacheAdd(t, o, n);
      }
      return Ac(o) ? To.cloneDates(o) : o instanceof Date ? To.clone(o) : o;
    }, e;
  }()
), jul = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Uo(1, 31), !0), Uo(2, 28), !0), Uo(3, 31), !0), Uo(4, 30), !0), Uo(5, 31), !0), Uo(6, 30), !0), Uo(7, 31), !0), Uo(8, 31), !0), Uo(9, 30), !0), Uo(10, 31), !0), Uo(11, 30), !0), Uo(12, 31), !0), Uo(1, 7), !0), Ful = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Uo(1, 31), !0), Uo(2, 29), !0), Uo(3, 31), !0), Uo(4, 30), !0), Uo(5, 31), !0), Uo(6, 30), !0), Uo(7, 31), !0), Uo(8, 31), !0), Uo(9, 30), !0), Uo(10, 31), !0), Uo(11, 30), !0), Uo(12, 31), !0), Uo(1, 7), !0), Vul = gu(1, 29), Bul = gu(1, 30), Ap = gu(1, 31), Ya = gu(1, 32), Uul = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Ya, !0), Bul, !0), Ya, !0), Ap, !0), Ya, !0), Ap, !0), Ya, !0), Ya, !0), Ap, !0), Ya, !0), Ap, !0), Ya, !0), Ya.slice(0, 7), !0), Wul = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Ya, !0), Vul, !0), Ya, !0), Ap, !0), Ya, !0), Ap, !0), Ya, !0), Ya, !0), Ap, !0), Ya, !0), Ap, !0), Ya, !0), Ya.slice(0, 7), !0), Gul = gu(-28, 0), Hul = gu(-29, 0), Cp = gu(-30, 0), Za = gu(-31, 0), Kul = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Za, !0), Hul, !0), Za, !0), Cp, !0), Za, !0), Cp, !0), Za, !0), Za, !0), Cp, !0), Za, !0), Cp, !0), Za, !0), Za.slice(0, 7), !0), Yul = Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt(Lt([], Za, !0), Gul, !0), Za, !0), Cp, !0), Za, !0), Cp, !0), Za, !0), Za, !0), Cp, !0), Za, !0), Cp, !0), Za, !0), Za.slice(0, 7), !0), Zul = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], Qul = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], LQ = function() {
  for (var e = [], t = 0; t < 55; t++)
    e = e.concat(gu(7));
  return e;
}();
function Jul(e, t) {
  var n = new Date(Date.UTC(e, 0, 1)), o = To.isLeapYear(e) ? 366 : 365, r = To.isLeapYear(e + 1) ? 366 : 365, i = To.toOrdinal(n), a = To.getWeekday(n), s = Mc(Mc({ yearlen: o, nextyearlen: r, yearordinal: i, yearweekday: a }, Xul(e)), { wnomask: null });
  if (Fd(t.byweekno))
    return s;
  s.wnomask = Uo(0, o + 7);
  var c, l, d = c = dl(7 - a + t.wkst, 7);
  d >= 4 ? (d = 0, l = s.yearlen + dl(a - t.wkst, 7)) : l = o - d;
  for (var u = Math.floor(l / 7), _ = dl(l, 7), p = Math.floor(u + _ / 4), f = 0; f < t.byweekno.length; f++) {
    var g = t.byweekno[f];
    if (g < 0 && (g += p + 1), g > 0 && g <= p) {
      var h = void 0;
      g > 1 ? (h = d + (g - 1) * 7, d !== c && (h -= 7 - c)) : h = d;
      for (var b = 0; b < 7 && (s.wnomask[h] = 1, h++, s.wdaymask[h] !== t.wkst); b++)
        ;
    }
  }
  if (Rr(t.byweekno, 1)) {
    var h = d + p * 7;
    if (d !== c && (h -= 7 - c), h < o)
      for (var f = 0; f < 7 && (s.wnomask[h] = 1, h += 1, s.wdaymask[h] !== t.wkst); f++)
        ;
  }
  if (d) {
    var v = void 0;
    if (Rr(t.byweekno, -1))
      v = -1;
    else {
      var $ = To.getWeekday(new Date(Date.UTC(e - 1, 0, 1))), k = dl(7 - $.valueOf() + t.wkst, 7), S = To.isLeapYear(e - 1) ? 366 : 365, O = void 0;
      k >= 4 ? (k = 0, O = S + dl($ - t.wkst, 7)) : O = o - d, v = Math.floor(52 + dl(O, 7) / 4);
    }
    if (Rr(t.byweekno, v))
      for (var h = 0; h < d; h++)
        s.wnomask[h] = 1;
  }
  return s;
}
function Xul(e) {
  var t = To.isLeapYear(e) ? 366 : 365, n = new Date(Date.UTC(e, 0, 1)), o = To.getWeekday(n);
  return t === 365 ? {
    mmask: jul,
    mdaymask: Wul,
    nmdaymask: Yul,
    wdaymask: LQ.slice(o),
    mrange: Qul
  } : {
    mmask: Ful,
    mdaymask: Uul,
    nmdaymask: Kul,
    wdaymask: LQ.slice(o),
    mrange: Zul
  };
}
function e_l(e, t, n, o, r, i) {
  var a = {
    lastyear: e,
    lastmonth: t,
    nwdaymask: []
  }, s = [];
  if (i.freq === jn.YEARLY)
    if (Fd(i.bymonth))
      s = [[0, n]];
    else
      for (var c = 0; c < i.bymonth.length; c++)
        t = i.bymonth[c], s.push(o.slice(t - 1, t + 1));
  else
    i.freq === jn.MONTHLY && (s = [o.slice(t - 1, t + 1)]);
  if (Fd(s))
    return a;
  a.nwdaymask = Uo(0, n);
  for (var c = 0; c < s.length; c++)
    for (var l = s[c], d = l[0], u = l[1] - 1, _ = 0; _ < i.bynweekday.length; _++) {
      var p = void 0, f = i.bynweekday[_], g = f[0], h = f[1];
      h < 0 ? (p = u + (h + 1) * 7, p -= dl(r[p] - g, 7)) : (p = d + (h - 1) * 7, p += dl(7 - r[p] + g, 7)), d <= p && p <= u && (a.nwdaymask[p] = 1);
    }
  return a;
}
function t_l(e, t) {
  t === void 0 && (t = 0);
  var n = e % 19, o = Math.floor(e / 100), r = e % 100, i = Math.floor(o / 4), a = o % 4, s = Math.floor((o + 8) / 25), c = Math.floor((o - s + 1) / 3), l = Math.floor(19 * n + o - i - c + 15) % 30, d = Math.floor(r / 4), u = r % 4, _ = Math.floor(32 + 2 * a + 2 * d - l - u) % 7, p = Math.floor((n + 11 * l + 22 * _) / 451), f = Math.floor((l + _ - 7 * p + 114) / 31), g = (l + _ - 7 * p + 114) % 31 + 1, h = Date.UTC(e, f - 1, g + t), b = Date.UTC(e, 0, 1);
  return [Math.ceil((h - b) / (1e3 * 60 * 60 * 24))];
}
var n_l = (
  /** @class */
  function() {
    function e(t) {
      this.options = t;
    }
    return e.prototype.rebuild = function(t, n) {
      var o = this.options;
      if (t !== this.lastyear && (this.yearinfo = Jul(t, o)), na(o.bynweekday) && (n !== this.lastmonth || t !== this.lastyear)) {
        var r = this.yearinfo, i = r.yearlen, a = r.mrange, s = r.wdaymask;
        this.monthinfo = e_l(t, n, i, a, s, o);
      }
      Ai(o.byeaster) && (this.eastermask = t_l(t, o.byeaster));
    }, Object.defineProperty(e.prototype, "lastyear", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastyear : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastmonth", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastmonth : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "yearlen", {
      get: function() {
        return this.yearinfo.yearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "yearordinal", {
      get: function() {
        return this.yearinfo.yearordinal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mrange", {
      get: function() {
        return this.yearinfo.mrange;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "wdaymask", {
      get: function() {
        return this.yearinfo.wdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mmask", {
      get: function() {
        return this.yearinfo.mmask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "wnomask", {
      get: function() {
        return this.yearinfo.wnomask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nwdaymask", {
      get: function() {
        return this.monthinfo ? this.monthinfo.nwdaymask : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextyearlen", {
      get: function() {
        return this.yearinfo.nextyearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "mdaymask", {
      get: function() {
        return this.yearinfo.mdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nmdaymask", {
      get: function() {
        return this.yearinfo.nmdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.ydayset = function() {
      return [gu(this.yearlen), 0, this.yearlen];
    }, e.prototype.mdayset = function(t, n) {
      for (var o = this.mrange[n - 1], r = this.mrange[n], i = Uo(null, this.yearlen), a = o; a < r; a++)
        i[a] = a;
      return [i, o, r];
    }, e.prototype.wdayset = function(t, n, o) {
      for (var r = Uo(null, this.yearlen + 7), i = To.toOrdinal(new Date(Date.UTC(t, n - 1, o))) - this.yearordinal, a = i, s = 0; s < 7 && (r[i] = i, ++i, this.wdaymask[i] !== this.options.wkst); s++)
        ;
      return [r, a, i];
    }, e.prototype.ddayset = function(t, n, o) {
      var r = Uo(null, this.yearlen), i = To.toOrdinal(new Date(Date.UTC(t, n - 1, o))) - this.yearordinal;
      return r[i] = i, [r, i, i + 1];
    }, e.prototype.htimeset = function(t, n, o, r) {
      var i = this, a = [];
      return this.options.byminute.forEach(function(s) {
        a = a.concat(i.mtimeset(t, s, o, r));
      }), To.sort(a), a;
    }, e.prototype.mtimeset = function(t, n, o, r) {
      var i = this.options.bysecond.map(function(a) {
        return new KE(t, n, a, r);
      });
      return To.sort(i), i;
    }, e.prototype.stimeset = function(t, n, o, r) {
      return [new KE(t, n, o, r)];
    }, e.prototype.getdayset = function(t) {
      switch (t) {
        case Go.YEARLY:
          return this.ydayset.bind(this);
        case Go.MONTHLY:
          return this.mdayset.bind(this);
        case Go.WEEKLY:
          return this.wdayset.bind(this);
        case Go.DAILY:
          return this.ddayset.bind(this);
        default:
          return this.ddayset.bind(this);
      }
    }, e.prototype.gettimeset = function(t) {
      switch (t) {
        case Go.HOURLY:
          return this.htimeset.bind(this);
        case Go.MINUTELY:
          return this.mtimeset.bind(this);
        case Go.SECONDLY:
          return this.stimeset.bind(this);
      }
    }, e;
  }()
);
function o_l(e, t, n, o, r, i) {
  for (var a = [], s = 0; s < e.length; s++) {
    var c = void 0, l = void 0, d = e[s];
    d < 0 ? (c = Math.floor(d / t.length), l = dl(d, t.length)) : (c = Math.floor((d - 1) / t.length), l = dl(d - 1, t.length));
    for (var u = [], _ = n; _ < o; _++) {
      var p = i[_];
      Ai(p) && u.push(p);
    }
    var f = void 0;
    c < 0 ? f = u.slice(c)[0] : f = u[c];
    var g = t[l], h = To.fromOrdinal(r.yearordinal + f), b = To.combine(h, g);
    Rr(a, b) || a.push(b);
  }
  return To.sort(a), a;
}
function sve(e, t) {
  var n = t.dtstart, o = t.freq, r = t.interval, i = t.until, a = t.bysetpos, s = t.count;
  if (s === 0 || r === 0)
    return Wu(e);
  var c = Oul.fromDate(n), l = new n_l(t);
  l.rebuild(c.year, c.month);
  for (var d = a_l(l, c, t); ; ) {
    var u = l.getdayset(o)(c.year, c.month, c.day), _ = u[0], p = u[1], f = u[2], g = i_l(_, p, f, l, t);
    if (na(a))
      for (var h = o_l(a, d, p, f, l, _), b = 0; b < h.length; b++) {
        var v = h[b];
        if (i && v > i)
          return Wu(e);
        if (v >= n) {
          var $ = qQ(v, t);
          if (!e.accept($) || s && (--s, !s))
            return Wu(e);
        }
      }
    else
      for (var b = p; b < f; b++) {
        var k = _[b];
        if (Ai(k))
          for (var S = To.fromOrdinal(l.yearordinal + k), O = 0; O < d.length; O++) {
            var I = d[O], v = To.combine(S, I);
            if (i && v > i)
              return Wu(e);
            if (v >= n) {
              var $ = qQ(v, t);
              if (!e.accept($) || s && (--s, !s))
                return Wu(e);
            }
          }
      }
    if (t.interval === 0 || (c.add(t, g), c.year > To.MAXYEAR))
      return Wu(e);
    TF(o) || (d = l.gettimeset(o)(c.hour, c.minute, c.second, 0)), l.rebuild(c.year, c.month);
  }
}
function r_l(e, t, n) {
  var o = n.bymonth, r = n.byweekno, i = n.byweekday, a = n.byeaster, s = n.bymonthday, c = n.bynmonthday, l = n.byyearday;
  return na(o) && !Rr(o, e.mmask[t]) || na(r) && !e.wnomask[t] || na(i) && !Rr(i, e.wdaymask[t]) || na(e.nwdaymask) && !e.nwdaymask[t] || a !== null && !Rr(e.eastermask, t) || (na(s) || na(c)) && !Rr(s, e.mdaymask[t]) && !Rr(c, e.nmdaymask[t]) || na(l) && (t < e.yearlen && !Rr(l, t + 1) && !Rr(l, -e.yearlen + t) || t >= e.yearlen && !Rr(l, t + 1 - e.yearlen) && !Rr(l, -e.nextyearlen + t - e.yearlen));
}
function qQ(e, t) {
  return new ZE(e, t.tzid).rezonedDate();
}
function Wu(e) {
  return e.getValue();
}
function i_l(e, t, n, o, r) {
  for (var i = !1, a = t; a < n; a++) {
    var s = e[a];
    i = r_l(o, s, r), i && (e[s] = null);
  }
  return i;
}
function a_l(e, t, n) {
  var o = n.freq, r = n.byhour, i = n.byminute, a = n.bysecond;
  return TF(o) ? Iul(n) : o >= jn.HOURLY && na(r) && !Rr(r, t.hour) || o >= jn.MINUTELY && na(i) && !Rr(i, t.minute) || o >= jn.SECONDLY && na(a) && !Rr(a, t.second) ? [] : e.gettimeset(o)(t.hour, t.minute, t.second, t.millisecond);
}
var Yl = {
  MO: new $s(0),
  TU: new $s(1),
  WE: new $s(2),
  TH: new $s(3),
  FR: new $s(4),
  SA: new $s(5),
  SU: new $s(6)
}, AF = {
  freq: Go.YEARLY,
  dtstart: null,
  interval: 1,
  wkst: Yl.MO,
  count: null,
  until: null,
  tzid: null,
  bysetpos: null,
  bymonth: null,
  bymonthday: null,
  bynmonthday: null,
  byyearday: null,
  byweekno: null,
  byweekday: null,
  bynweekday: null,
  byhour: null,
  byminute: null,
  bysecond: null,
  byeaster: null
}, s_l = Object.keys(AF), jn = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = {}), n === void 0 && (n = !1), this._cache = n ? null : new qul(), this.origOptions = ave(t);
      var o = Pul(t).parsedOptions;
      this.options = o;
    }
    return e.parseText = function(t, n) {
      return ive(t, n);
    }, e.fromText = function(t, n) {
      return Aul(t, n);
    }, e.fromString = function(t) {
      return new e(e.parseString(t) || void 0);
    }, e.prototype._iter = function(t) {
      return sve(t, this.options);
    }, e.prototype._cacheGet = function(t, n) {
      return this._cache ? this._cache._cacheGet(t, n) : !1;
    }, e.prototype._cacheAdd = function(t, n, o) {
      if (this._cache)
        return this._cache._cacheAdd(t, n, o);
    }, e.prototype.all = function(t) {
      if (t)
        return this._iter(new RQ("all", {}, t));
      var n = this._cacheGet("all");
      return n === !1 && (n = this._iter(new Eh("all", {})), this._cacheAdd("all", n)), n;
    }, e.prototype.between = function(t, n, o, r) {
      if (o === void 0 && (o = !1), !To.isValidDate(t) || !To.isValidDate(n))
        throw new Error("Invalid date passed in to RRule.between");
      var i = {
        before: n,
        after: t,
        inc: o
      };
      if (r)
        return this._iter(new RQ("between", i, r));
      var a = this._cacheGet("between", i);
      return a === !1 && (a = this._iter(new Eh("between", i)), this._cacheAdd("between", a, i)), a;
    }, e.prototype.before = function(t, n) {
      if (n === void 0 && (n = !1), !To.isValidDate(t))
        throw new Error("Invalid date passed in to RRule.before");
      var o = { dt: t, inc: n }, r = this._cacheGet("before", o);
      return r === !1 && (r = this._iter(new Eh("before", o)), this._cacheAdd("before", r, o)), r;
    }, e.prototype.after = function(t, n) {
      if (n === void 0 && (n = !1), !To.isValidDate(t))
        throw new Error("Invalid date passed in to RRule.after");
      var o = { dt: t, inc: n }, r = this._cacheGet("after", o);
      return r === !1 && (r = this._iter(new Eh("after", o)), this._cacheAdd("after", r, o)), r;
    }, e.prototype.count = function() {
      return this.all().length;
    }, e.prototype.toString = function() {
      return mL(this.origOptions);
    }, e.prototype.toText = function(t, n, o) {
      return Cul(this, t, n, o);
    }, e.prototype.isFullyConvertibleToText = function() {
      return zul(this);
    }, e.prototype.clone = function() {
      return new e(this.origOptions);
    }, e.FREQUENCIES = [
      "YEARLY",
      "MONTHLY",
      "WEEKLY",
      "DAILY",
      "HOURLY",
      "MINUTELY",
      "SECONDLY"
    ], e.YEARLY = Go.YEARLY, e.MONTHLY = Go.MONTHLY, e.WEEKLY = Go.WEEKLY, e.DAILY = Go.DAILY, e.HOURLY = Go.HOURLY, e.MINUTELY = Go.MINUTELY, e.SECONDLY = Go.SECONDLY, e.MO = Yl.MO, e.TU = Yl.TU, e.WE = Yl.WE, e.TH = Yl.TH, e.FR = Yl.FR, e.SA = Yl.SA, e.SU = Yl.SU, e.parseString = pL, e.optionsToString = mL, e;
  }()
);
function c_l(e, t, n, o, r, i) {
  var a = {}, s = e.accept;
  function c(_, p) {
    n.forEach(function(f) {
      f.between(_, p, !0).forEach(function(g) {
        a[Number(g)] = !0;
      });
    });
  }
  r.forEach(function(_) {
    var p = new ZE(_, i).rezonedDate();
    a[Number(p)] = !0;
  }), e.accept = function(_) {
    var p = Number(_);
    return isNaN(p) ? s.call(this, _) : !a[p] && (c(new Date(p - 1), new Date(p + 1)), !a[p]) ? (a[p] = !0, s.call(this, _)) : !0;
  }, e.method === "between" && (c(e.args.after, e.args.before), e.accept = function(_) {
    var p = Number(_);
    return a[p] ? !0 : (a[p] = !0, s.call(this, _));
  });
  for (var l = 0; l < o.length; l++) {
    var d = new ZE(o[l], i).rezonedDate();
    if (!e.accept(new Date(d.getTime())))
      break;
  }
  t.forEach(function(_) {
    sve(e, _.options);
  });
  var u = e._result;
  switch (To.sort(u), e.method) {
    case "all":
    case "between":
      return u;
    case "before":
      return u.length && u[u.length - 1] || null;
    case "after":
    default:
      return u.length && u[0] || null;
  }
}
var jQ = {
  dtstart: null,
  cache: !1,
  unfold: !1,
  forceset: !1,
  compatible: !1,
  tzid: null
};
function l_l(e, t) {
  var n = [], o = [], r = [], i = [], a = YE(e), s = a.dtstart, c = a.tzid, l = m_l(e, t.unfold);
  return l.forEach(function(d) {
    var u;
    if (d) {
      var _ = p_l(d), p = _.name, f = _.parms, g = _.value;
      switch (p.toUpperCase()) {
        case "RRULE":
          if (f.length)
            throw new Error("unsupported RRULE parm: ".concat(f.join(",")));
          n.push(pL(d));
          break;
        case "RDATE":
          var h = (u = /RDATE(?:;TZID=([^:=]+))?/i.exec(d)) !== null && u !== void 0 ? u : [], b = h[1];
          b && !c && (c = b), o = o.concat(VQ(g, f));
          break;
        case "EXRULE":
          if (f.length)
            throw new Error("unsupported EXRULE parm: ".concat(f.join(",")));
          r.push(pL(g));
          break;
        case "EXDATE":
          i = i.concat(VQ(g, f));
          break;
        case "DTSTART":
          break;
        default:
          throw new Error("unsupported property: " + p);
      }
    }
  }), {
    dtstart: s,
    tzid: c,
    rrulevals: n,
    rdatevals: o,
    exrulevals: r,
    exdatevals: i
  };
}
function d_l(e, t) {
  var n = l_l(e, t), o = n.rrulevals, r = n.rdatevals, i = n.exrulevals, a = n.exdatevals, s = n.dtstart, c = n.tzid, l = t.cache === !1;
  if (t.compatible && (t.forceset = !0, t.unfold = !0), t.forceset || o.length > 1 || r.length || i.length || a.length) {
    var d = new g_l(l);
    return d.dtstart(s), d.tzid(c || void 0), o.forEach(function(_) {
      d.rrule(new jn(U6(_, s, c), l));
    }), r.forEach(function(_) {
      d.rdate(_);
    }), i.forEach(function(_) {
      d.exrule(new jn(U6(_, s, c), l));
    }), a.forEach(function(_) {
      d.exdate(_);
    }), t.compatible && t.dtstart && d.rdate(s), d;
  }
  var u = o[0] || {};
  return new jn(U6(u, u.dtstart || t.dtstart || s, u.tzid || t.tzid || c), l);
}
function FQ(e, t) {
  return t === void 0 && (t = {}), d_l(e, u_l(t));
}
function U6(e, t, n) {
  return Mc(Mc({}, e), { dtstart: t, tzid: n });
}
function u_l(e) {
  var t = [], n = Object.keys(e), o = Object.keys(jQ);
  if (n.forEach(function(r) {
    Rr(o, r) || t.push(r);
  }), t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Mc(Mc({}, jQ), e);
}
function __l(e) {
  if (e.indexOf(":") === -1)
    return {
      name: "RRULE",
      value: e
    };
  var t = Sul(e, ":", 1), n = t[0], o = t[1];
  return {
    name: n,
    value: o
  };
}
function p_l(e) {
  var t = __l(e), n = t.name, o = t.value, r = n.split(";");
  if (!r)
    throw new Error("empty property name");
  return {
    name: r[0].toUpperCase(),
    parms: r.slice(1),
    value: o
  };
}
function m_l(e, t) {
  if (t === void 0 && (t = !1), e = e && e.trim(), !e)
    throw new Error("Invalid empty string");
  if (!t)
    return e.split(/\s/);
  for (var n = e.split(`
`), o = 0; o < n.length; ) {
    var r = n[o] = n[o].replace(/\s+$/g, "");
    r ? o > 0 && r[0] === " " ? (n[o - 1] += r.slice(1), n.splice(o, 1)) : o += 1 : n.splice(o, 1);
  }
  return n;
}
function f_l(e) {
  e.forEach(function(t) {
    if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(t))
      throw new Error("unsupported RDATE/EXDATE parm: " + t);
  });
}
function VQ(e, t) {
  return f_l(t), e.split(",").map(function(n) {
    return To.untilStringToDate(n);
  });
}
function BQ(e) {
  var t = this;
  return function(n) {
    if (n !== void 0 && (t["_".concat(e)] = n), t["_".concat(e)] !== void 0)
      return t["_".concat(e)];
    for (var o = 0; o < t._rrule.length; o++) {
      var r = t._rrule[o].origOptions[e];
      if (r)
        return r;
    }
  };
}
var g_l = (
  /** @class */
  function(e) {
    EF(t, e);
    function t(n) {
      n === void 0 && (n = !1);
      var o = e.call(this, {}, n) || this;
      return o.dtstart = BQ.apply(o, ["dtstart"]), o.tzid = BQ.apply(o, ["tzid"]), o._rrule = [], o._rdate = [], o._exrule = [], o._exdate = [], o;
    }
    return t.prototype._iter = function(n) {
      return c_l(n, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    }, t.prototype.rrule = function(n) {
      UQ(n, this._rrule);
    }, t.prototype.exrule = function(n) {
      UQ(n, this._exrule);
    }, t.prototype.rdate = function(n) {
      WQ(n, this._rdate);
    }, t.prototype.exdate = function(n) {
      WQ(n, this._exdate);
    }, t.prototype.rrules = function() {
      return this._rrule.map(function(n) {
        return FQ(n.toString());
      });
    }, t.prototype.exrules = function() {
      return this._exrule.map(function(n) {
        return FQ(n.toString());
      });
    }, t.prototype.rdates = function() {
      return this._rdate.map(function(n) {
        return new Date(n.getTime());
      });
    }, t.prototype.exdates = function() {
      return this._exdate.map(function(n) {
        return new Date(n.getTime());
      });
    }, t.prototype.valueOf = function() {
      var n = [];
      return !this._rrule.length && this._dtstart && (n = n.concat(mL({ dtstart: this._dtstart }))), this._rrule.forEach(function(o) {
        n = n.concat(o.toString().split(`
`));
      }), this._exrule.forEach(function(o) {
        n = n.concat(o.toString().split(`
`).map(function(r) {
          return r.replace(/^RRULE:/, "EXRULE:");
        }).filter(function(r) {
          return !/^DTSTART/.test(r);
        }));
      }), this._rdate.length && n.push(GQ("RDATE", this._rdate, this.tzid())), this._exdate.length && n.push(GQ("EXDATE", this._exdate, this.tzid())), n;
    }, t.prototype.toString = function() {
      return this.valueOf().join(`
`);
    }, t.prototype.clone = function() {
      var n = new t(!!this._cache);
      return this._rrule.forEach(function(o) {
        return n.rrule(o.clone());
      }), this._exrule.forEach(function(o) {
        return n.exrule(o.clone());
      }), this._rdate.forEach(function(o) {
        return n.rdate(new Date(o.getTime()));
      }), this._exdate.forEach(function(o) {
        return n.exdate(new Date(o.getTime()));
      }), n;
    }, t;
  }(jn)
);
function UQ(e, t) {
  if (!(e instanceof jn))
    throw new TypeError(String(e) + " is not RRule instance");
  Rr(t.map(String), String(e)) || t.push(e);
}
function WQ(e, t) {
  if (!(e instanceof Date))
    throw new TypeError(String(e) + " is not Date instance");
  Rr(t.map(Number), Number(e)) || (t.push(e), To.sort(t));
}
function GQ(e, t, n) {
  var o = !n || n.toUpperCase() === "UTC", r = o ? "".concat(e, ":") : "".concat(e, ";TZID=").concat(n, ":"), i = t.map(function(a) {
    return To.timeToUntilString(a.valueOf(), o);
  }).join(",");
  return "".concat(r).concat(i);
}
const cve = "timeOption.is24hClock";
var Yf = /* @__PURE__ */ ((e) => (e.TWELVE_HOUR = "h:mma", e.TWENTY_FOUR_HOUR = "HH:mm", e))(Yf || {});
const fL = (e) => wo.setItem(cve, e.toString()), h_l = () => {
  const e = wo.getItem(cve);
  return e === null ? null : e === "true";
}, lve = () => {
  const e = h_l();
  return e === !0 ? !0 : e === !1 ? !1 : new Intl.DateTimeFormat(void 0, { hour: "numeric" }).format(0).match(/M/i) ? (fL(!1), !1) : (fL(!0), !0);
}, dve = lve() ? "HH:mm" : "h:mma", v_l = /^(.*)([+-])(\d{2}):(\d{2})|(Z)$/;
function b_l(e, t, n, o) {
  if (typeof e != "string")
    return De(e, t, n, o);
  const r = e.match(v_l);
  if (r === null)
    return;
  if (r[0] === "Z")
    return De(
      e,
      {
        utc: !0,
        ...typeof t == "string" ? { format: t } : { ...t }
      },
      n,
      o
    );
  const [, i, a, s, c] = r, l = parseInt(s) * 60 + parseInt(c, 10), d = a === "+" ? l : -l;
  return De(
    i,
    {
      $offset: d,
      ...typeof t == "string" ? { format: t } : { ...t }
    },
    n,
    o
  );
}
const y_l = (e, t, n, o) => {
  const r = b_l(e);
  return r != null && r.isValid() ? `${r == null ? void 0 : r.format(
    o != null && o.withDefaultTimeFormat ? Yf.TWELVE_HOUR : (o == null ? void 0 : o.selectedTimeFormat) || dve
  )}, ${De(e).toDate().toLocaleString(t, { dateStyle: "full", timeZone: n })}` : "Invalid date";
}, uve = ({
  startDate: e,
  timeZone: t,
  recurringEvent: n,
  recurringCount: o,
  selectedTimeFormat: r,
  withDefaultTimeFormat: i
}, a) => {
  const { count: s, ...c } = n || {}, l = new jn({
    ...c,
    count: o,
    dtstart: new Date(De(e).valueOf())
  }), d = De(e).utcOffset(), u = l.all().map((p) => De.utc(p).add(d - De(p).utcOffset(), "minute"));
  return [u.map((p) => y_l(p.tz(t), a, t, { selectedTimeFormat: r, withDefaultTimeFormat: i })), u.map((p) => p.toDate())];
}, $_l = ({
  t: e,
  recurringEvent: t
}) => t.interval && t.freq >= 0 ? e("every_for_freq", {
  freq: `${t.interval > 1 ? t.interval : ""} ${e(
    qh[t.freq].toString().toLowerCase(),
    {
      count: t.interval
    }
  )}`
}) : "", HQ = "timeOption.preferredTimeZone", w_l = p9((e) => ({
  timeFormat: dve,
  setTimeFormat: (t) => {
    fL(t === Yf.TWENTY_FOUR_HOUR), e({ timeFormat: t });
  },
  timezone: wo.getItem(HQ) || Kf,
  setTimezone: (t) => {
    wo.setItem(HQ, t), e({ timezone: t });
  }
})), lu = w_l, k_l = ({
  storeTimezone: e,
  bookerUserPreferredTimezone: t
}) => e ?? t, vd = () => {
  const [e] = St((r) => [r.timezone], Fr), { timezone: t, timeFormat: n } = lu();
  return {
    timezone: k_l({
      storeTimezone: e,
      bookerUserPreferredTimezone: t
    }),
    timeFormat: n,
    timezoneFromBookerStore: e,
    timezoneFromTimePreferences: t
  };
}, S_l = ({ event: e }) => {
  var f;
  const t = ((f = e.recurringEvent) == null ? void 0 : f.count) || null, { t: n, i18n: o } = Fe(), [r, i, a, s] = St((g) => [
    g.setRecurringEventCount,
    g.recurringEventCount,
    g.setOccurenceCount,
    g.occurenceCount
  ]), c = St((g) => g.selectedTimeslot), l = St((g) => g.state), { timezone: d, timeFormat: u } = vd(), [_, p] = ze(!1);
  if (Le(() => {
    var g;
    (g = e.recurringEvent) != null && g.count && (a(s || e.recurringEvent.count), r(i || e.recurringEvent.count), s && (s > e.recurringEvent.count || s < 1) && p(!0));
  }, [r, e.recurringEvent, i, a, s]), !e.recurringEvent)
    return null;
  if (l === "booking" && i && c) {
    const [g] = uve(
      {
        startDate: c,
        timeZone: d,
        recurringEvent: e.recurringEvent,
        recurringCount: i,
        selectedTimeFormat: u
      },
      o.language
    );
    return /* @__PURE__ */ Y("div", { "data-testid": "recurring-dates", children: [
      g.slice(0, 5).map((h, b) => /* @__PURE__ */ m("p", { children: h }, b)),
      g.length > 5 && /* @__PURE__ */ m(
        Ao,
        {
          content: g.slice(5).map((h, b) => /* @__PURE__ */ m("p", { children: h }, b)),
          children: /* @__PURE__ */ Y("p", { className: " text-sm", children: [
            "+ ",
            n("plus_more", { count: g.length - 5 })
          ] })
        }
      )
    ] });
  }
  return /* @__PURE__ */ Y(Ce, { children: [
    $_l({ t: n, recurringEvent: e.recurringEvent }),
    /* @__PURE__ */ m("br", {}),
    /* @__PURE__ */ m(
      Sc,
      {
        className: "my-1 mr-3 inline-flex h-[26px] w-[46px] px-1 py-0",
        type: "number",
        min: "1",
        max: e.recurringEvent.count,
        defaultValue: s || e.recurringEvent.count,
        "data-testid": "occurrence-input",
        onChange: (g) => {
          const h = /^(?=.*[0-9])\S+$/, b = parseInt(g.target.value);
          a(b), !h.test(g.target.value) || b < 1 || t && b > t ? (p(!0), r(t)) : (p(!1), r(b));
        }
      }
    ),
    n("occurrence", {
      count: i || e.recurringEvent.count
    }),
    _ && /* @__PURE__ */ m("div", { className: "-ml-4 mr-4 mt-2 flex", children: /* @__PURE__ */ m(sa, { severity: "warning", title: n("enter_number_between_range", { maxOccurences: t }) }) })
  ] });
}, _ve = [
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF"
], ufd = (e, t) => _ve.includes(t.toUpperCase()) ? e : Math.round(e * 100), x_l = (e, t) => _ve.includes(t.toUpperCase()) ? e : e / 100, pve = (e) => {
  try {
    const o = Intl.NumberFormat("en", { style: "currency", currency: e }).formatToParts(1).find((r) => r.type === "currency");
    return (o == null ? void 0 : o.value) || "$";
  } catch {
    return console.warn(`Failed to get currency symbol for ${e}, falling back to $`), "$";
  }
}, E_l = (e, t, n = "en") => {
  switch (t) {
    case "BTC":
      return `${e} sats`;
    default:
      return t = (t == null ? void 0 : t.toUpperCase()) || "USD", `${Intl.NumberFormat(n, {
        style: "currency",
        currency: t
      }).format(x_l(e, t))}`;
  }
}, T_l = hn(
  () => import("./AlbyPriceComponent-9oW3P2T3.js").then((e) => e.AlbyPriceComponent),
  {
    ssr: !1
  }
), mve = ({ price: e, currency: t, displayAlternateSymbol: n = !0 }) => {
  if (e === 0)
    return null;
  const o = E_l(e, t);
  return t !== "BTC" ? /* @__PURE__ */ m(Ce, { children: o }) : /* @__PURE__ */ m(
    T_l,
    {
      displaySymbol: n,
      price: e,
      formattedPrice: o
    }
  );
}, A_l = [
  Zl.REQUIRES_CONFIRMATION,
  Zl.DURATION,
  Zl.OCCURENCES,
  Zl.LOCATION,
  Zl.PRICE
], Gd = ({
  customIcon: e,
  icon: t,
  iconUrl: n,
  children: o,
  highlight: r,
  contentClassName: i,
  className: a,
  isDark: s,
  ...c
}) => ve.Children.count(o) ? /* @__PURE__ */ Y(
  "div",
  {
    className: ae(
      "flex items-start justify-start text-sm",
      r ? "text-emphasis" : "text-text",
      a
    ),
    ...c,
    children: [
      n ? /* @__PURE__ */ m(
        "img",
        {
          src: n,
          alt: "",
          className: ae(
            "mr-2 mt-[2px] h-4 w-4 flex-shrink-0",
            s === void 0 && "[filter:invert(0.5)_brightness(0.5)]",
            (s === void 0 || s) && "dark:[filter:invert(0.65)_brightness(0.9)]"
          )
        }
      ) : /* @__PURE__ */ m(Ce, { children: e || !!t && /* @__PURE__ */ m(ot, { name: t, className: "relative z-20 mr-2 mt-[2px] h-4 w-4 flex-shrink-0 rtl:ml-2" }) }),
      /* @__PURE__ */ m("div", { className: ae("relative z-10 max-w-full break-words", i), children: o })
    ]
  }
) : null, C_l = ({ event: e, blocks: t = A_l }) => {
  const { t: n } = Fe(), o = Ic((i) => i.rescheduleUid), r = Ic((i) => i.isInstantMeeting);
  return /* @__PURE__ */ m(Ce, { children: t.map((i) => {
    var a;
    if (typeof i == "function")
      return /* @__PURE__ */ m(Oi, { children: i(e) }, i.name);
    switch (i) {
      case Zl.DURATION:
        return /* @__PURE__ */ m(Gd, { icon: "clock", className: "items-center", children: /* @__PURE__ */ m(wul, { event: e }) }, i);
      case Zl.LOCATION:
        return !((a = e == null ? void 0 : e.locations) != null && a.length) || r ? null : /* @__PURE__ */ m(Gd, { children: /* @__PURE__ */ m(mul, { locations: e.locations }) }, i);
      case Zl.REQUIRES_CONFIRMATION:
        return e.requiresConfirmation ? /* @__PURE__ */ m(Gd, { icon: "square-check", children: n("requires_confirmation") }, i) : null;
      case Zl.OCCURENCES:
        return !e.recurringEvent || o ? null : /* @__PURE__ */ m(Gd, { icon: "refresh-ccw", children: /* @__PURE__ */ m(S_l, { event: e }) }, i);
      case Zl.PRICE:
        const s = nm(e);
        return e.price <= 0 || s.price <= 0 ? null : /* @__PURE__ */ m(
          Gd,
          {
            customIcon: /* @__PURE__ */ m(
              eul,
              {
                className: "relative z-20 mr-2 mt-[2px] h-4 w-4 flex-shrink-0 rtl:ml-2",
                currency: e.currency
              }
            ),
            children: /* @__PURE__ */ m(
              mve,
              {
                price: s.price,
                currency: e.currency,
                displayAlternateSymbol: !1
              }
            )
          },
          i
        );
    }
  }) });
}, z_l = ({ children: e, as: t, className: n }) => /* @__PURE__ */ m(
  t || "h1",
  {
    "data-testid": "event-title",
    className: ae("text-text break-words text-xl font-semibold", n),
    children: e
  }
), O_l = () => /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ m(Jn, { className: "h-6 w-6 rounded-full" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-5 w-32" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-8 w-48" }),
  /* @__PURE__ */ m("div", { className: "mt-8", children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ Y("div", { className: "mb-2 flex flex-row items-center", children: [
    /* @__PURE__ */ m(Jn, { className: "mr-3 h-5 w-5 rounded-full" }),
    /* @__PURE__ */ m(Jn, { className: ae("h-6", t > 1 ? "w-24" : "w-32") })
  ] }, t)) })
] }), P_l = ({
  schedulingType: e,
  users: t,
  profile: n,
  entity: o,
  isPrivateLink: r,
  roundRobinHideOrgAndTeam: i
}) => {
  const a = Ic((f) => f.username), s = !!(a && a.indexOf("+") > -1), c = fu(), l = Zo(), u = e !== aa.ROUND_ROBIN ? t : [], _ = n.name && e === aa.ROUND_ROBIN || !t.length || n.name !== t[0].name && e === aa.COLLECTIVE;
  if (e === aa.ROUND_ROBIN && i)
    return /* @__PURE__ */ m("div", { className: "h-6" });
  const p = s || !n.image && !o.logoUrl || !o.teamSlug ? [] : [
    {
      // We don't want booker to be able to see the list of other users or teams inside the embed
      href: c || l || r || o.hideProfileLink ? null : o.teamSlug ? lnl({ orgSlug: o.orgSlug, teamSlug: o.teamSlug }) : qv(o.orgSlug),
      image: o.logoUrl ?? n.image ?? "",
      alt: o.name ?? n.name ?? "",
      title: o.name ?? n.name ?? ""
    }
  ];
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      Ffe,
      {
        size: "sm",
        className: "border-muted",
        items: [
          ...p,
          ...u.map((f) => {
            var g, h, b;
            return {
              href: l || r || o.hideProfileLink ? null : `${qv(((h = (g = f.profile) == null ? void 0 : g.organization) == null ? void 0 : h.slug) ?? null)}/${(b = f.profile) == null ? void 0 : b.username}?redirect=false`,
              alt: f.name || "",
              title: f.name || "",
              image: jfe(f)
            };
          })
        ]
      }
    ),
    /* @__PURE__ */ m("p", { className: "text-subtle mt-2 text-sm font-semibold", children: _ ? n.name : u.map((f) => f.name).filter((f) => f).join(", ") })
  ] });
};
function I_l(e) {
  const { className: t, currency: n } = e;
  return /* @__PURE__ */ m(ot, { name: n !== "BTC" ? "credit-card" : "zap", className: t });
}
const KQ = globalThis != null && globalThis.document ? ts : () => {
}, fve = "Popper", [gve, hve] = os(fve), [R_l, vve] = gve(fve), N_l = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = ze(null);
  return /* @__PURE__ */ Pe(R_l, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, D_l = "PopperAnchor", M_l = /* @__PURE__ */ it((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = vve(D_l, n), a = Ue(null), s = or(t, a);
  return Le(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || a.current);
  }), o ? null : /* @__PURE__ */ Pe(io.div, We({}, r, {
    ref: s
  }));
}), bve = "PopperContent", [L_l, _fd] = gve(bve), q_l = /* @__PURE__ */ it((e, t) => {
  var n, o, r, i, a, s, c, l;
  const { __scopePopper: d, side: u = "bottom", sideOffset: _ = 0, align: p = "center", alignOffset: f = 0, arrowPadding: g = 0, avoidCollisions: h = !0, collisionBoundary: b = [], collisionPadding: v = 0, sticky: $ = "partial", hideWhenDetached: k = !1, updatePositionStrategy: S = "optimized", onPlaced: O, ...I } = e, D = vve(bve, d), [M, N] = ze(null), C = or(
    t,
    (te) => N(te)
  ), [P, x] = ze(null), w = BT(P), E = (n = w == null ? void 0 : w.width) !== null && n !== void 0 ? n : 0, T = (o = w == null ? void 0 : w.height) !== null && o !== void 0 ? o : 0, z = u + (p !== "center" ? "-" + p : ""), j = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, q = Array.isArray(b) ? b : [
    b
  ], V = q.length > 0, F = {
    padding: j,
    boundary: q.filter(j_l),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: V
  }, { refs: L, floatingStyles: U, placement: W, isPositioned: H, middlewareData: Q } = Nae({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: z,
    whileElementsMounted: (...te) => Pae(...te, {
      animationFrame: S === "always"
    }),
    elements: {
      reference: D.anchor
    },
    middleware: [
      bae({
        mainAxis: _ + T,
        alignmentAxis: f
      }),
      h && $ae({
        mainAxis: !0,
        crossAxis: !1,
        limiter: $ === "partial" ? wae() : void 0,
        ...F
      }),
      h && hae({
        ...F
      }),
      kae({
        ...F,
        apply: ({ elements: te, rects: ue, availableWidth: le, availableHeight: se }) => {
          const { width: me, height: pe } = ue.reference, be = te.floating.style;
          be.setProperty("--radix-popper-available-width", `${le}px`), be.setProperty("--radix-popper-available-height", `${se}px`), be.setProperty("--radix-popper-anchor-width", `${me}px`), be.setProperty("--radix-popper-anchor-height", `${pe}px`);
        }
      }),
      P && Iae({
        element: P,
        padding: g
      }),
      F_l({
        arrowWidth: E,
        arrowHeight: T
      }),
      k && vae({
        strategy: "referenceHidden",
        ...F
      })
    ]
  }), [X, re] = yve(W), Z = Ui(O);
  KQ(() => {
    H && (Z == null || Z());
  }, [
    H,
    Z
  ]);
  const ee = (r = Q.arrow) === null || r === void 0 ? void 0 : r.x, J = (i = Q.arrow) === null || i === void 0 ? void 0 : i.y, oe = ((a = Q.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [ce, de] = ze();
  return KQ(() => {
    M && de(window.getComputedStyle(M).zIndex);
  }, [
    M
  ]), /* @__PURE__ */ Pe("div", {
    ref: L.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...U,
      transform: H ? U.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ce,
      "--radix-popper-transform-origin": [
        (s = Q.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = Q.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Pe(L_l, {
    scope: d,
    placedSide: X,
    onArrowChange: x,
    arrowX: ee,
    arrowY: J,
    shouldHideArrow: oe
  }, /* @__PURE__ */ Pe(io.div, We({
    "data-side": X,
    "data-align": re
  }, I, {
    ref: C,
    style: {
      ...I.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: H ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = Q.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function j_l(e) {
  return e !== null;
}
const F_l = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, a;
    const { placement: s, rects: c, middlewareData: l } = t, u = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, _ = u ? 0 : e.arrowWidth, p = u ? 0 : e.arrowHeight, [f, g] = yve(s), h = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], b = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + _ / 2, v = ((i = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + p / 2;
    let $ = "", k = "";
    return f === "bottom" ? ($ = u ? h : `${b}px`, k = `${-p}px`) : f === "top" ? ($ = u ? h : `${b}px`, k = `${c.floating.height + p}px`) : f === "right" ? ($ = `${-p}px`, k = u ? h : `${v}px`) : f === "left" && ($ = `${c.floating.width + p}px`, k = u ? h : `${v}px`), {
      data: {
        x: $,
        y: k
      }
    };
  }
});
function yve(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const V_l = N_l, B_l = M_l, U_l = q_l, W_l = /* @__PURE__ */ it((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ Uv.createPortal(/* @__PURE__ */ Pe(io.div, We({}, r, {
    ref: t
  })), o) : null;
}), gL = "dismissableLayer.update", G_l = "dismissableLayer.pointerDownOutside", H_l = "dismissableLayer.focusOutside";
let YQ;
const K_l = /* @__PURE__ */ No({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Y_l = /* @__PURE__ */ it((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: c, ...l } = e, d = Pn(K_l), [u, _] = ze(null), p = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, f] = ze({}), g = or(
    t,
    (D) => _(D)
  ), h = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = h.indexOf(b), $ = u ? h.indexOf(u) : -1, k = d.layersWithOutsidePointerEventsDisabled.size > 0, S = $ >= v, O = Z_l((D) => {
    const M = D.target, N = [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    );
    !S || N || (i == null || i(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p), I = Q_l((D) => {
    const M = D.target;
    [
      ...d.branches
    ].some(
      (C) => C.contains(M)
    ) || (a == null || a(D), s == null || s(D), D.defaultPrevented || c == null || c());
  }, p);
  return Pq((D) => {
    $ === d.layers.size - 1 && (r == null || r(D), !D.defaultPrevented && c && (D.preventDefault(), c()));
  }, p), Le(() => {
    if (u)
      return o && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (YQ = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), ZQ(), () => {
        o && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = YQ);
      };
  }, [
    u,
    p,
    o,
    d
  ]), Le(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), ZQ());
  }, [
    u,
    d
  ]), Le(() => {
    const D = () => f({});
    return document.addEventListener(gL, D), () => document.removeEventListener(gL, D);
  }, []), /* @__PURE__ */ Pe(io.div, We({}, l, {
    ref: g,
    style: {
      pointerEvents: k ? S ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Bt(e.onFocusCapture, I.onFocusCapture),
    onBlurCapture: Bt(e.onBlurCapture, I.onBlurCapture),
    onPointerDownCapture: Bt(e.onPointerDownCapture, O.onPointerDownCapture)
  }));
});
function Z_l(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1), r = Ue(() => {
  });
  return Le(() => {
    const i = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          $ve(G_l, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Q_l(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ui(e), o = Ue(!1);
  return Le(() => {
    const r = (i) => {
      i.target && !o.current && $ve(H_l, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ZQ() {
  const e = new CustomEvent(gL);
  document.dispatchEvent(e);
}
function $ve(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? L0(r, i) : r.dispatchEvent(i);
}
let W6;
const wve = "HoverCard", [kve, pfd] = os(wve, [
  hve
]), CF = hve(), [J_l, uC] = kve(wve), X_l = (e) => {
  const { __scopeHoverCard: t, children: n, open: o, defaultOpen: r, onOpenChange: i, openDelay: a = 700, closeDelay: s = 300 } = e, c = CF(t), l = Ue(0), d = Ue(0), u = Ue(!1), _ = Ue(!1), [p = !1, f] = jc({
    prop: o,
    defaultProp: r,
    onChange: i
  }), g = at(() => {
    clearTimeout(d.current), l.current = window.setTimeout(
      () => f(!0),
      a
    );
  }, [
    a,
    f
  ]), h = at(() => {
    clearTimeout(l.current), !u.current && !_.current && (d.current = window.setTimeout(
      () => f(!1),
      s
    ));
  }, [
    s,
    f
  ]), b = at(
    () => f(!1),
    [
      f
    ]
  );
  return Le(() => () => {
    clearTimeout(l.current), clearTimeout(d.current);
  }, []), /* @__PURE__ */ Pe(J_l, {
    scope: t,
    open: p,
    onOpenChange: f,
    onOpen: g,
    onClose: h,
    onDismiss: b,
    hasSelectionRef: u,
    isPointerDownOnContentRef: _
  }, /* @__PURE__ */ Pe(V_l, c, n));
}, epl = "HoverCardTrigger", tpl = /* @__PURE__ */ it((e, t) => {
  const { __scopeHoverCard: n, ...o } = e, r = uC(epl, n), i = CF(n);
  return /* @__PURE__ */ Pe(B_l, We({
    asChild: !0
  }, i), /* @__PURE__ */ Pe(io.a, We({
    "data-state": r.open ? "open" : "closed"
  }, o, {
    ref: t,
    onPointerEnter: Bt(e.onPointerEnter, QE(r.onOpen)),
    onPointerLeave: Bt(e.onPointerLeave, QE(r.onClose)),
    onFocus: Bt(e.onFocus, r.onOpen),
    onBlur: Bt(e.onBlur, r.onClose),
    onTouchStart: Bt(
      e.onTouchStart,
      (a) => a.preventDefault()
    )
  })));
}), Sve = "HoverCardPortal", [npl, opl] = kve(Sve, {
  forceMount: void 0
}), rpl = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: o, container: r } = e, i = uC(Sve, t);
  return /* @__PURE__ */ Pe(npl, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Pe(rs, {
    present: n || i.open
  }, /* @__PURE__ */ Pe(W_l, {
    asChild: !0,
    container: r
  }, o)));
}, hL = "HoverCardContent", ipl = /* @__PURE__ */ it((e, t) => {
  const n = opl(hL, e.__scopeHoverCard), { forceMount: o = n.forceMount, ...r } = e, i = uC(hL, e.__scopeHoverCard);
  return /* @__PURE__ */ Pe(rs, {
    present: o || i.open
  }, /* @__PURE__ */ Pe(apl, We({
    "data-state": i.open ? "open" : "closed"
  }, r, {
    onPointerEnter: Bt(e.onPointerEnter, QE(i.onOpen)),
    onPointerLeave: Bt(e.onPointerLeave, QE(i.onClose)),
    ref: t
  })));
}), apl = /* @__PURE__ */ it((e, t) => {
  const { __scopeHoverCard: n, onEscapeKeyDown: o, onPointerDownOutside: r, onFocusOutside: i, onInteractOutside: a, ...s } = e, c = uC(hL, n), l = CF(n), d = Ue(null), u = or(t, d), [_, p] = ze(!1);
  return Le(() => {
    if (_) {
      const f = document.body;
      return W6 = f.style.userSelect || f.style.webkitUserSelect, f.style.userSelect = "none", f.style.webkitUserSelect = "none", () => {
        f.style.userSelect = W6, f.style.webkitUserSelect = W6;
      };
    }
  }, [
    _
  ]), Le(() => {
    if (d.current) {
      const f = () => {
        p(!1), c.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var g;
          ((g = document.getSelection()) === null || g === void 0 ? void 0 : g.toString()) !== "" && (c.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", f), () => {
        document.removeEventListener("pointerup", f), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [
    c.isPointerDownOnContentRef,
    c.hasSelectionRef
  ]), Le(() => {
    d.current && spl(d.current).forEach(
      (g) => g.setAttribute("tabindex", "-1")
    );
  }), /* @__PURE__ */ Pe(Y_l, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onInteractOutside: a,
    onEscapeKeyDown: o,
    onPointerDownOutside: r,
    onFocusOutside: Bt(i, (f) => {
      f.preventDefault();
    }),
    onDismiss: c.onDismiss
  }, /* @__PURE__ */ Pe(U_l, We({}, l, s, {
    onPointerDown: Bt(s.onPointerDown, (f) => {
      f.currentTarget.contains(f.target) && p(!0), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !0;
    }),
    ref: u,
    style: {
      ...s.style,
      userSelect: _ ? "text" : void 0,
      // Safari requires prefix
      WebkitUserSelect: _ ? "text" : void 0,
      "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
      "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
      "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
    }
  })));
});
function QE(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function spl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
const cpl = X_l, lpl = tpl, dpl = rpl, upl = ipl, xve = (e) => {
  const { t } = Fe(), { fromUser: n, toUser: o, emoji: r = "🏝️", borderDashed: i = !0, date: a, className: s } = e, c = O_(), l = Ro.useRouter();
  return !n || !o ? null : /* @__PURE__ */ m("div", { className: ae("relative h-full pb-5", s), children: /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "flex h-full flex-col items-center justify-start rounded-md border bg-white px-4 py-4 font-normal dark:bg-transparent",
        i && "border-dashed"
      ),
      children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis flex h-14 w-14 flex-col items-center justify-center rounded-full", children: /* @__PURE__ */ m("span", { className: "m-auto text-center text-lg", children: r }) }),
        /* @__PURE__ */ Y("div", { className: "space-y-2 text-center", children: [
          /* @__PURE__ */ m("p", { className: "mt-2 text-base font-bold", children: t("ooo_user_is_ooo", { displayName: n.displayName }) }),
          (n == null ? void 0 : n.displayName) && (o == null ? void 0 : o.displayName) && /* @__PURE__ */ m("p", { className: "text-center text-sm", children: /* @__PURE__ */ m(
            Dc,
            {
              t,
              i18nKey: "ooo_slots_returning",
              values: { displayName: o.displayName },
              components: [/* @__PURE__ */ m("strong", { children: "username" }, "username")]
            }
          ) })
        ] }),
        (o == null ? void 0 : o.id) && /* @__PURE__ */ m(
          ut,
          {
            className: "mt-8 max-w-[90%]",
            variant: "button",
            color: "secondary",
            onClick: () => {
              const d = c.get("month"), u = c.get("layout"), _ = c.get("date") || a;
              l.push(
                `/${o.username}?${d ? `month=${d}&` : ""}date=${_}${u ? `&layout=${u}` : ""}`
              );
            },
            children: /* @__PURE__ */ m("span", { className: "block overflow-hidden text-ellipsis whitespace-nowrap", children: t("ooo_slots_book_with", { displayName: o.displayName }) })
          }
        )
      ]
    }
  ) });
}, Cf = p9((e) => ({
  overlayBusyDates: void 0,
  setOverlayBusyDates: (t) => {
    e({ overlayBusyDates: t });
  },
  calendarSettingsOverlayModal: !1,
  setCalendarSettingsOverlayModal: (t) => {
    e({ calendarSettingsOverlayModal: t });
  },
  continueWithProviderModal: !1,
  setContinueWithProviderModal: (t) => {
    e({ continueWithProviderModal: t });
  }
}));
function QQ(e) {
  const t = e.getHours().toString().padStart(2, "0"), n = e.getMinutes().toString().padStart(2, "0");
  return `${t}:${n}`;
}
function _pl({
  start: e,
  selectedDuration: t,
  offset: n
}) {
  const o = Cf((s) => s.overlayBusyDates);
  let r = null, i = null;
  return { isOverlapping: o && o.some((s) => {
    const c = De(s.start), l = De(s.end), d = De(e.add(n, "hours")).add(t ?? 0, "minute"), u = (d.isSame(c) || d.isAfter(c)) && e.add(n, "hours") < l && d > c;
    return r = u ? QQ(c.toDate()) : null, i = u ? QQ(l.toDate()) : null, u;
  }), overlappingTimeStart: r, overlappingTimeEnd: i };
}
const Eve = ({
  showExact: e = !0,
  bookedSeats: t,
  totalSeats: n,
  variant: o = "whole"
}) => {
  const { t: r } = Fe(), i = n - t, a = t / n >= 0.5, s = t / n >= 0.83;
  return /* @__PURE__ */ m("span", { className: "truncate", children: e ? `${i}${o === "fraction" ? ` / ${n}` : ""} ${r("seats_available", {
    count: i
  })}` : s ? r("seats_nearly_full") : a ? r("seats_half_full") : r("seats_available", {
    count: i
  }) });
}, ppl = ({
  slot: e,
  seatsPerTimeSlot: t,
  selectedSlots: n,
  onTimeSelect: o,
  showAvailableSeatsCount: r,
  event: i,
  customClassNames: a,
  loadingStates: s,
  renderConfirmNotVerifyEmailButtonCond: c,
  isVerificationCodeSending: l,
  skipConfirmStep: d,
  shouldRenderCaptcha: u,
  watchedCfToken: _,
  handleSlotClick: p,
  onTentativeTimeSelect: f,
  unavailableTimeSlots: g = [],
  confirmButtonDisabled: h,
  confirmStepClassNames: b
}) => {
  const { t: v } = Fe(), { data: $ } = i, k = Tt(() => {
    if (!($ != null && $.price))
      return !1;
    const H = nm($);
    return ($ == null ? void 0 : $.price) > 0 && !Number.isNaN(H.price) && H.price > 0;
  }, [$]), S = Ha("overlayCalendar") === "true" || wo.getItem("overlayCalendarSwitchDefault"), { timeFormat: O, timezone: I } = vd(), D = St((H) => H.bookingData), M = St((H) => H.layout), N = !!t, C = De.utc(e.time).tz(I), P = !!(N && e.attendees && e.attendees >= t), x = e.attendees && t && e.attendees / t >= 0.5, E = e.attendees && t && e.attendees / t >= 0.83 ? "bg-rose-600" : x ? "bg-yellow-500" : "bg-emerald-400", T = De(), j = (T.tz(I).utcOffset() - T.utcOffset()) / 60, q = St((H) => H.selectedTimeslot), { isOverlapping: V, overlappingTimeEnd: F, overlappingTimeStart: L } = _pl({
    start: C,
    selectedDuration: ($ == null ? void 0 : $.length) ?? 0,
    offset: j
  }), U = () => {
    p && p(e, V), f && f({
      time: e.time,
      attendees: e.attendees || 0,
      seatsPerTimeSlot: t
    });
  }, W = g.includes(e.time);
  return /* @__PURE__ */ m(xhe, { children: /* @__PURE__ */ Y("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ Y(
      ut,
      {
        disabled: P || !!(e.bookingUid && e.bookingUid === (D == null ? void 0 : D.uid)) || (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking) || d && !!u && !_ || W,
        "data-testid": "time",
        "data-disabled": P,
        "data-time": e.time,
        onClick: U,
        className: ae(
          "hover:border-brand-default min-h-9 mb-2 flex h-auto w-full flex-grow flex-col justify-center py-2",
          (n == null ? void 0 : n.includes(e.time)) && "border-brand-default",
          `${a}`
        ),
        color: "secondary",
        children: [
          /* @__PURE__ */ Y("div", { className: "flex items-center gap-2", children: [
            !N && S && /* @__PURE__ */ m(
              "span",
              {
                className: ae(
                  "inline-block h-2 w-2 rounded-full",
                  V ? "bg-rose-600" : "bg-emerald-400"
                )
              }
            ),
            C.format(O)
          ] }),
          P && /* @__PURE__ */ m("p", { className: "text-sm", children: v("booking_full") }),
          N && !P && /* @__PURE__ */ Y("p", { className: "flex items-center text-sm", children: [
            /* @__PURE__ */ m(
              "span",
              {
                className: ae(E, "mr-1 inline-block h-2 w-2 rounded-full"),
                "aria-hidden": !0
              }
            ),
            /* @__PURE__ */ m(
              Eve,
              {
                showExact: !!r,
                totalSeats: t,
                bookedSeats: e.attendees || 0
              }
            )
          ] })
        ]
      },
      e.time
    ),
    !!e.showConfirmButton && /* @__PURE__ */ Y(cpl, { children: [
      /* @__PURE__ */ m(lpl, { asChild: !0, children: /* @__PURE__ */ m(Hw.div, { initial: { width: 0 }, animate: { width: "auto" }, exit: { width: 0 }, children: /* @__PURE__ */ m(
        ut,
        {
          variant: M === "column_view" ? "icon" : "button",
          StartIcon: M === "column_view" ? "chevron-right" : void 0,
          type: "button",
          className: b == null ? void 0 : b.confirmButton,
          onClick: () => o && o(e.time, (e == null ? void 0 : e.attendees) || 0, t, e.bookingUid),
          "data-testid": "skip-confirm-book-button",
          disabled: W || !!u && !_ || (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking) || h,
          color: "primary",
          loading: q === e.time && (s == null ? void 0 : s.creatingBooking) || (s == null ? void 0 : s.creatingRecurringBooking) || l || (s == null ? void 0 : s.creatingInstantBooking),
          children: M === "column_view" ? "" : v(W ? "timeslot_unavailable_short" : c ? k ? "pay_and_book" : "confirm" : "verify_email_button")
        }
      ) }, e.time) }),
      V && /* @__PURE__ */ m(dpl, { children: /* @__PURE__ */ m(upl, { side: "top", align: "end", sideOffset: 2, children: /* @__PURE__ */ Y("div", { className: "text-emphasis bg-inverted w-[var(--booker-timeslots-width)] rounded-md p-3", children: [
        /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ m("p", { children: "Busy" }) }),
        /* @__PURE__ */ Y("p", { className: "text-muted", children: [
          L,
          " - ",
          F
        ] })
      ] }) }) })
    ] })
  ] }) });
}, Tve = ({
  slots: e,
  showTimeFormatToggle: t = !0,
  className: n,
  ...o
}) => {
  const { t: r } = Fe();
  if (e.every((c) => c.away))
    return /* @__PURE__ */ m(G6, { ...e[0] });
  const a = e[0] && e[0].away, s = e[e.length - 1] && e[e.length - 1].away;
  return /* @__PURE__ */ m("div", { className: ae("text-default flex flex-col", n), children: /* @__PURE__ */ Y("div", { className: "h-full pb-4", children: [
    !e.length && /* @__PURE__ */ Y(
      "div",
      {
        "data-testId": "no-slots-available",
        className: "bg-subtle border-subtle flex h-full flex-col items-center rounded-md border p-6 dark:bg-transparent",
        children: [
          /* @__PURE__ */ m(ot, { name: "calendar-x-2", className: "text-muted mb-2 h-4 w-4" }),
          /* @__PURE__ */ m("p", { className: ae("text-muted", t ? "-mt-1 text-lg" : "text-sm"), children: r("all_booked_today") })
        ]
      }
    ),
    a && !s && /* @__PURE__ */ m(G6, { ...e[0] }),
    e.map((c) => c.away ? null : /* @__PURE__ */ m(ppl, { slot: c, ...o }, c.time)),
    s && !a && /* @__PURE__ */ m(G6, { ...e[e.length - 1], className: "pb-0" })
  ] }) });
}, G6 = (e) => {
  const t = Zo(), { fromUser: n, toUser: o, reason: r, emoji: i, time: a, className: s = "" } = e;
  return t ? /* @__PURE__ */ m(Ce, {}) : /* @__PURE__ */ m(
    xve,
    {
      fromUser: n,
      toUser: o,
      date: De(a).format("YYYY-MM-DD"),
      reason: r,
      emoji: i,
      borderDashed: !0,
      className: s
    }
  );
}, mpl = () => /* @__PURE__ */ m("div", { className: "flex w-[20%] flex-col only:w-full", children: Array.from({ length: Math.floor(Math.random() * 6) + 1 }).map((e, t) => /* @__PURE__ */ m(Jn, { className: "mb-4 h-6 w-full" }, t)) });
var Z2, fpl = new Uint8Array(16);
function Ave() {
  if (!Z2 && (Z2 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Z2))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Z2(fpl);
}
const gpl = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function _C(e) {
  return typeof e == "string" && gpl.test(e);
}
var ba = [];
for (var H6 = 0; H6 < 256; ++H6)
  ba.push((H6 + 256).toString(16).substr(1));
function pC(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (ba[e[t + 0]] + ba[e[t + 1]] + ba[e[t + 2]] + ba[e[t + 3]] + "-" + ba[e[t + 4]] + ba[e[t + 5]] + "-" + ba[e[t + 6]] + ba[e[t + 7]] + "-" + ba[e[t + 8]] + ba[e[t + 9]] + "-" + ba[e[t + 10]] + ba[e[t + 11]] + ba[e[t + 12]] + ba[e[t + 13]] + ba[e[t + 14]] + ba[e[t + 15]]).toLowerCase();
  if (!_C(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var JQ, K6, Y6 = 0, Z6 = 0;
function hpl(e, t, n) {
  var o = t && n || 0, r = t || new Array(16);
  e = e || {};
  var i = e.node || JQ, a = e.clockseq !== void 0 ? e.clockseq : K6;
  if (i == null || a == null) {
    var s = e.random || (e.rng || Ave)();
    i == null && (i = JQ = [s[0] | 1, s[1], s[2], s[3], s[4], s[5]]), a == null && (a = K6 = (s[6] << 8 | s[7]) & 16383);
  }
  var c = e.msecs !== void 0 ? e.msecs : Date.now(), l = e.nsecs !== void 0 ? e.nsecs : Z6 + 1, d = c - Y6 + (l - Z6) / 1e4;
  if (d < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (d < 0 || c > Y6) && e.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Y6 = c, Z6 = l, K6 = a, c += 122192928e5;
  var u = ((c & 268435455) * 1e4 + l) % 4294967296;
  r[o++] = u >>> 24 & 255, r[o++] = u >>> 16 & 255, r[o++] = u >>> 8 & 255, r[o++] = u & 255;
  var _ = c / 4294967296 * 1e4 & 268435455;
  r[o++] = _ >>> 8 & 255, r[o++] = _ & 255, r[o++] = _ >>> 24 & 15 | 16, r[o++] = _ >>> 16 & 255, r[o++] = a >>> 8 | 128, r[o++] = a & 255;
  for (var p = 0; p < 6; ++p)
    r[o + p] = i[p];
  return t || pC(r);
}
function Cve(e) {
  if (!_C(e))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = t & 255, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = t & 255, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = t & 255, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = t & 255, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = t & 255, n;
}
function vpl(e) {
  e = unescape(encodeURIComponent(e));
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n));
  return t;
}
var bpl = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", ypl = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function zve(e, t, n) {
  function o(r, i, a, s) {
    if (typeof r == "string" && (r = vpl(r)), typeof i == "string" && (i = Cve(i)), i.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + r.length);
    if (c.set(i), c.set(r, i.length), c = n(c), c[6] = c[6] & 15 | t, c[8] = c[8] & 63 | 128, a) {
      s = s || 0;
      for (var l = 0; l < 16; ++l)
        a[s + l] = c[l];
      return a;
    }
    return pC(c);
  }
  try {
    o.name = e;
  } catch {
  }
  return o.DNS = bpl, o.URL = ypl, o;
}
function $pl(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      e[n] = t.charCodeAt(n);
  }
  return wpl(kpl(Spl(e), e.length * 8));
}
function wpl(e) {
  for (var t = [], n = e.length * 32, o = "0123456789abcdef", r = 0; r < n; r += 8) {
    var i = e[r >> 5] >>> r % 32 & 255, a = parseInt(o.charAt(i >>> 4 & 15) + o.charAt(i & 15), 16);
    t.push(a);
  }
  return t;
}
function Ove(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function kpl(e, t) {
  e[t >> 5] |= 128 << t % 32, e[Ove(t) - 1] = t;
  for (var n = 1732584193, o = -271733879, r = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
    var s = n, c = o, l = r, d = i;
    n = qa(n, o, r, i, e[a], 7, -680876936), i = qa(i, n, o, r, e[a + 1], 12, -389564586), r = qa(r, i, n, o, e[a + 2], 17, 606105819), o = qa(o, r, i, n, e[a + 3], 22, -1044525330), n = qa(n, o, r, i, e[a + 4], 7, -176418897), i = qa(i, n, o, r, e[a + 5], 12, 1200080426), r = qa(r, i, n, o, e[a + 6], 17, -1473231341), o = qa(o, r, i, n, e[a + 7], 22, -45705983), n = qa(n, o, r, i, e[a + 8], 7, 1770035416), i = qa(i, n, o, r, e[a + 9], 12, -1958414417), r = qa(r, i, n, o, e[a + 10], 17, -42063), o = qa(o, r, i, n, e[a + 11], 22, -1990404162), n = qa(n, o, r, i, e[a + 12], 7, 1804603682), i = qa(i, n, o, r, e[a + 13], 12, -40341101), r = qa(r, i, n, o, e[a + 14], 17, -1502002290), o = qa(o, r, i, n, e[a + 15], 22, 1236535329), n = ja(n, o, r, i, e[a + 1], 5, -165796510), i = ja(i, n, o, r, e[a + 6], 9, -1069501632), r = ja(r, i, n, o, e[a + 11], 14, 643717713), o = ja(o, r, i, n, e[a], 20, -373897302), n = ja(n, o, r, i, e[a + 5], 5, -701558691), i = ja(i, n, o, r, e[a + 10], 9, 38016083), r = ja(r, i, n, o, e[a + 15], 14, -660478335), o = ja(o, r, i, n, e[a + 4], 20, -405537848), n = ja(n, o, r, i, e[a + 9], 5, 568446438), i = ja(i, n, o, r, e[a + 14], 9, -1019803690), r = ja(r, i, n, o, e[a + 3], 14, -187363961), o = ja(o, r, i, n, e[a + 8], 20, 1163531501), n = ja(n, o, r, i, e[a + 13], 5, -1444681467), i = ja(i, n, o, r, e[a + 2], 9, -51403784), r = ja(r, i, n, o, e[a + 7], 14, 1735328473), o = ja(o, r, i, n, e[a + 12], 20, -1926607734), n = Fa(n, o, r, i, e[a + 5], 4, -378558), i = Fa(i, n, o, r, e[a + 8], 11, -2022574463), r = Fa(r, i, n, o, e[a + 11], 16, 1839030562), o = Fa(o, r, i, n, e[a + 14], 23, -35309556), n = Fa(n, o, r, i, e[a + 1], 4, -1530992060), i = Fa(i, n, o, r, e[a + 4], 11, 1272893353), r = Fa(r, i, n, o, e[a + 7], 16, -155497632), o = Fa(o, r, i, n, e[a + 10], 23, -1094730640), n = Fa(n, o, r, i, e[a + 13], 4, 681279174), i = Fa(i, n, o, r, e[a], 11, -358537222), r = Fa(r, i, n, o, e[a + 3], 16, -722521979), o = Fa(o, r, i, n, e[a + 6], 23, 76029189), n = Fa(n, o, r, i, e[a + 9], 4, -640364487), i = Fa(i, n, o, r, e[a + 12], 11, -421815835), r = Fa(r, i, n, o, e[a + 15], 16, 530742520), o = Fa(o, r, i, n, e[a + 2], 23, -995338651), n = Va(n, o, r, i, e[a], 6, -198630844), i = Va(i, n, o, r, e[a + 7], 10, 1126891415), r = Va(r, i, n, o, e[a + 14], 15, -1416354905), o = Va(o, r, i, n, e[a + 5], 21, -57434055), n = Va(n, o, r, i, e[a + 12], 6, 1700485571), i = Va(i, n, o, r, e[a + 3], 10, -1894986606), r = Va(r, i, n, o, e[a + 10], 15, -1051523), o = Va(o, r, i, n, e[a + 1], 21, -2054922799), n = Va(n, o, r, i, e[a + 8], 6, 1873313359), i = Va(i, n, o, r, e[a + 15], 10, -30611744), r = Va(r, i, n, o, e[a + 6], 15, -1560198380), o = Va(o, r, i, n, e[a + 13], 21, 1309151649), n = Va(n, o, r, i, e[a + 4], 6, -145523070), i = Va(i, n, o, r, e[a + 11], 10, -1120210379), r = Va(r, i, n, o, e[a + 2], 15, 718787259), o = Va(o, r, i, n, e[a + 9], 21, -343485551), n = zp(n, s), o = zp(o, c), r = zp(r, l), i = zp(i, d);
  }
  return [n, o, r, i];
}
function Spl(e) {
  if (e.length === 0)
    return [];
  for (var t = e.length * 8, n = new Uint32Array(Ove(t)), o = 0; o < t; o += 8)
    n[o >> 5] |= (e[o / 8] & 255) << o % 32;
  return n;
}
function zp(e, t) {
  var n = (e & 65535) + (t & 65535), o = (e >> 16) + (t >> 16) + (n >> 16);
  return o << 16 | n & 65535;
}
function xpl(e, t) {
  return e << t | e >>> 32 - t;
}
function mC(e, t, n, o, r, i) {
  return zp(xpl(zp(zp(t, e), zp(o, i)), r), n);
}
function qa(e, t, n, o, r, i, a) {
  return mC(t & n | ~t & o, e, t, r, i, a);
}
function ja(e, t, n, o, r, i, a) {
  return mC(t & o | n & ~o, e, t, r, i, a);
}
function Fa(e, t, n, o, r, i, a) {
  return mC(t ^ n ^ o, e, t, r, i, a);
}
function Va(e, t, n, o, r, i, a) {
  return mC(n ^ (t | ~o), e, t, r, i, a);
}
var Epl = zve("v3", 48, $pl);
const Tpl = Epl;
function U$(e, t, n) {
  e = e || {};
  var o = e.random || (e.rng || Ave)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, t) {
    n = n || 0;
    for (var r = 0; r < 16; ++r)
      t[n + r] = o[r];
    return t;
  }
  return pC(o);
}
function Apl(e, t, n, o) {
  switch (e) {
    case 0:
      return t & n ^ ~t & o;
    case 1:
      return t ^ n ^ o;
    case 2:
      return t & n ^ t & o ^ n & o;
    case 3:
      return t ^ n ^ o;
  }
}
function Q6(e, t) {
  return e << t | e >>> 32 - t;
}
function Cpl(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var o = unescape(encodeURIComponent(e));
    e = [];
    for (var r = 0; r < o.length; ++r)
      e.push(o.charCodeAt(r));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c) {
    for (var l = new Uint32Array(16), d = 0; d < 16; ++d)
      l[d] = e[c * 64 + d * 4] << 24 | e[c * 64 + d * 4 + 1] << 16 | e[c * 64 + d * 4 + 2] << 8 | e[c * 64 + d * 4 + 3];
    s[c] = l;
  }
  s[a - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var u = 0; u < a; ++u) {
    for (var _ = new Uint32Array(80), p = 0; p < 16; ++p)
      _[p] = s[u][p];
    for (var f = 16; f < 80; ++f)
      _[f] = Q6(_[f - 3] ^ _[f - 8] ^ _[f - 14] ^ _[f - 16], 1);
    for (var g = n[0], h = n[1], b = n[2], v = n[3], $ = n[4], k = 0; k < 80; ++k) {
      var S = Math.floor(k / 20), O = Q6(g, 5) + Apl(S, h, b, v) + $ + t[S] + _[k] >>> 0;
      $ = v, v = b, b = Q6(h, 30) >>> 0, h = g, g = O;
    }
    n[0] = n[0] + g >>> 0, n[1] = n[1] + h >>> 0, n[2] = n[2] + b >>> 0, n[3] = n[3] + v >>> 0, n[4] = n[4] + $ >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var zpl = zve("v5", 80, Cpl);
const vL = zpl, Opl = "00000000-0000-0000-0000-000000000000";
function Ppl(e) {
  if (!_C(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const Ipl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: Opl,
  parse: Cve,
  stringify: pC,
  v1: hpl,
  v3: Tpl,
  v4: U$,
  v5: vL,
  validate: _C,
  version: Ppl
}, Symbol.toStringTag, { value: "Module" })), zF = (e) => e.get("cal.isBookingDryRun") === "true", OF = (e) => {
  const t = e.get("cal.routedTeamMemberIds");
  return typeof t == "string" ? t.split(",").filter(Boolean).map((o) => parseInt(o, 10)) : null;
}, bL = ({
  values: e,
  event: t,
  date: n,
  duration: o,
  timeZone: r,
  language: i,
  rescheduleUid: a,
  rescheduledBy: s,
  username: c,
  metadata: l,
  bookingUid: d,
  seatReferenceUid: u,
  hashedLink: _,
  teamMemberEmail: p,
  crmOwnerRecordType: f,
  crmAppSlug: g,
  crmRecordId: h,
  orgSlug: b,
  routingFormSearchParams: v,
  isDryRunProp: $,
  verificationCode: k
}) => {
  const S = new URLSearchParams(v ?? window.location.search), O = OF(S), I = S.get("cal.routingFormResponseId"), D = I ? Number(I) : void 0, M = S.get("cal.skipContactOwner") === "true", N = S.get("cal.reroutingFormResponses"), C = $ !== void 0 ? $ : zF(S), P = S == null ? void 0 : S.get("cal.cache"), x = P ? P === "true" : void 0, w = S == null ? void 0 : S.get("dub_id");
  return {
    ...e,
    user: c,
    start: De(n).format(),
    end: De(n).add(o || t.length, "minute").format(),
    eventTypeId: t.id,
    eventTypeSlug: t.slug,
    timeZone: r,
    language: i,
    rescheduleUid: a,
    rescheduledBy: s,
    metadata: l || {},
    hasHashedBookingLink: !!_,
    bookingUid: d,
    seatReferenceUid: u,
    hashedLink: _,
    teamMemberEmail: p,
    crmOwnerRecordType: f,
    crmAppSlug: g,
    crmRecordId: h,
    orgSlug: b,
    routedTeamMemberIds: O,
    routingFormResponseId: D,
    skipContactOwner: M,
    // In case of rerouting, the form responses are actually the responses that we need to update.
    reroutingFormResponses: N ? JSON.parse(N) : void 0,
    _isDryRun: C,
    _shouldServeCache: x,
    dub_id: w,
    verificationCode: k
  };
}, Rpl = (e, t, n) => {
  const o = U$(), [, r] = uve(
    {
      startDate: e.date,
      timeZone: e.timeZone,
      recurringEvent: e.event.recurringEvent,
      recurringCount: t,
      withDefaultTimeFormat: !0
    },
    e.language
  ), i = bL({ ...e, bookingUid: void 0 });
  return r.map((a) => ({
    ...i,
    start: De(a).format(),
    end: De(a).add(e.duration || e.event.length, "minute").format(),
    recurringEventId: o,
    schedulingType: e.event.schedulingType || void 0,
    recurringCount: r.length,
    tracking: n
  }));
}, Pve = ({ customClassName: e }) => {
  const t = lu((r) => r.timeFormat), n = lu((r) => r.setTimeFormat), { t: o } = Fe();
  return /* @__PURE__ */ m(
    cj,
    {
      customClassNames: e,
      onValueChange: (r) => {
        r && r !== t && n(r);
      },
      defaultValue: t,
      value: t,
      options: [
        { value: Yf.TWELVE_HOUR, label: o("12_hour_short") },
        { value: Yf.TWENTY_FOUR_HOUR, label: o("24_hour_short") }
      ]
    }
  );
}, Ive = ({
  date: e,
  showTimeFormatToggle: t = !0,
  availableMonth: n,
  customClassNames: o
}) => {
  const { t: r, i18n: i } = Fe(), [a] = St((d) => [d.layout], Fr), s = a === pn.COLUMN_VIEW, c = a === pn.MONTH_VIEW, l = De().isSame(e, "day");
  return /* @__PURE__ */ Y(
    "header",
    {
      className: ae(
        "dark:bg-muted dark:before:bg-muted mb-3 flex w-full flex-row items-center font-medium",
        "bg-default before:bg-default",
        o == null ? void 0 : o.availableTimeSlotsHeaderContainer
      ),
      children: [
        /* @__PURE__ */ Y(
          "span",
          {
            className: ae(
              s && "w-full text-center",
              s ? "text-subtle text-xs uppercase" : "text-emphasis font-semibold"
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: ae(
                    l && !(o != null && o.availableTimeSlotsTitle) && "!text-default",
                    o == null ? void 0 : o.availableTimeSlotsTitle
                  ),
                  children: Ej(i.language, Number(e.format("d")), "short")
                }
              ),
              /* @__PURE__ */ Y(
                "span",
                {
                  className: ae(
                    s && l && "bg-brand-default text-brand ml-2",
                    "inline-flex items-center justify-center rounded-3xl px-1 pt-0.5 font-medium",
                    c ? `text-default text-sm ${o == null ? void 0 : o.availableTimeSlotsTitle}` : `text-xs ${o == null ? void 0 : o.availableTimeSlotsTitle}`
                  ),
                  children: [
                    e.format("DD"),
                    n && `, ${n}`
                  ]
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ m("div", { className: "ml-auto rtl:mr-auto", children: /* @__PURE__ */ m(Pve, { customClassName: o == null ? void 0 : o.availableTimeSlotsTimeFormatToggle }) })
      ]
    }
  );
}, Npl = (e, t) => Tt(() => !e || typeof t > "u" ? [] : t[e] || [], [e, t]), Dpl = (e, t) => {
  const [n, o] = ze([]), r = at((i) => {
    o(
      (a) => a.map(({ date: s, slots: c }) => ({
        date: s,
        slots: c.map((l) => ({
          ...l,
          showConfirmButton: l.time === i.time ? !(i != null && i.showConfirmButton) : !1
        }))
      }))
    );
  }, []);
  return Le(() => {
    if (t === void 0) {
      o([]);
      return;
    }
    const i = e.filter((a) => a !== null).map((a) => ({
      slots: t[`${a}`] || [],
      date: a
    }));
    o(i);
  }, [JSON.stringify(e), JSON.stringify(t)]), { slotsPerDay: n, setSlotsPerDay: o, toggleConfirmButton: r };
}, Mpl = ({
  extraDays: e,
  limitHeight: t,
  showAvailableSeatsCount: n,
  schedule: o,
  isLoading: r,
  customClassNames: i,
  skipConfirmStep: a,
  seatsPerTimeSlot: s,
  onSubmit: c,
  unavailableTimeSlots: l,
  confirmButtonDisabled: d,
  confirmStepClassNames: u,
  onAvailableTimeSlotSelect: _,
  ...p
}) => {
  const f = St((T) => T.selectedDate), g = St((T) => T.setSeatedEventData), h = f || De().format("YYYY-MM-DD"), [b] = St((T) => [T.layout]), v = b === pn.COLUMN_VIEW, $ = Ue(null), { setTentativeSelectedTimeslots: k, tentativeSelectedTimeslots: S } = St((T) => ({
    setTentativeSelectedTimeslots: T.setTentativeSelectedTimeslots,
    tentativeSelectedTimeslots: T.tentativeSelectedTimeslots
  })), O = ({
    time: T,
    attendees: z,
    seatsPerTimeSlot: j,
    bookingUid: q
  }) => {
    k([T]);
  }, I = o == null ? void 0 : o.data, M = dC(I == null ? void 0 : I.slots).filter(
    (T) => De(f).diff(T, "day") <= 0
  ), N = Tt(() => e ? M.length > 0 ? M.slice(0, e) : [] : [h], [h, e, M]), { slotsPerDay: C, toggleConfirmButton: P } = Dpl(N, I == null ? void 0 : I.slots), x = Ha("overlayCalendar") === "true" || wo.getItem("overlayCalendarSwitchDefault"), w = at(
    (T, z, j, q) => {
      Wce && (o == null || o.invalidate()), k([]), j && g({
        seatsPerTimeSlot: j,
        attendees: z,
        bookingUid: q,
        showAvailableSeatsCount: n
      }), _(T);
      const V = !l.includes(T);
      a && V && c(T);
    },
    [
      c,
      g,
      a,
      n,
      l,
      o,
      k,
      _
    ]
  ), E = at(
    (T, z) => {
      x && z || a ? P(T) : w(
        T.time,
        (T == null ? void 0 : T.attendees) || 0,
        s,
        T.bookingUid
      );
    },
    [x, w, s, a, P]
  );
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m("div", { className: ae("flex", `${i == null ? void 0 : i.availableTimeSlotsContainer}`), children: r ? /* @__PURE__ */ m("div", { className: "mb-3 h-8" }) : C.length > 0 && C.map((T) => /* @__PURE__ */ m(
      Ive,
      {
        customClassNames: {
          availableTimeSlotsHeaderContainer: i == null ? void 0 : i.availableTimeSlotsHeaderContainer,
          availableTimeSlotsTitle: i == null ? void 0 : i.availableTimeSlotsTitle,
          availableTimeSlotsTimeFormatToggle: i == null ? void 0 : i.availableTimeSlotsTimeFormatToggle
        },
        date: De(T.date),
        showTimeFormatToggle: !v,
        availableMonth: De(f).format("MM") !== De(T.date).format("MM") ? De(T.date).format("MMM") : void 0
      },
      T.date
    )) }),
    /* @__PURE__ */ Y(
      "div",
      {
        ref: $,
        className: ae(
          t && "scroll-bar flex-grow overflow-auto md:h-[400px]",
          !t && "flex h-full w-full flex-row gap-4",
          `${i == null ? void 0 : i.availableTimeSlotsContainer}`
        ),
        children: [
          r && // Shows exact amount of days as skeleton.
          Array.from({ length: 1 + (e ?? 0) }).map((T, z) => /* @__PURE__ */ m(mpl, {}, z)),
          !r && C.length > 0 && C.map((T) => /* @__PURE__ */ m("div", { className: "scroll-bar h-full w-full overflow-y-auto overflow-x-hidden", children: /* @__PURE__ */ m(
            Tve,
            {
              className: i == null ? void 0 : i.availableTimeSlotsContainer,
              customClassNames: i == null ? void 0 : i.availableTimes,
              showTimeFormatToggle: !v,
              onTimeSelect: w,
              onTentativeTimeSelect: O,
              unavailableTimeSlots: l,
              slots: T.slots,
              showAvailableSeatsCount: n,
              skipConfirmStep: a,
              seatsPerTimeSlot: s,
              handleSlotClick: E,
              confirmButtonDisabled: d,
              confirmStepClassNames: u,
              ...p
            }
          ) }, T.date))
        ]
      }
    )
  ] });
}, Rve = ({ date: e, timeFormat: t, timeZone: n, language: o }) => {
  const r = new Date(e), i = new Intl.DateTimeFormat(o, {
    timeZone: n,
    dateStyle: "full"
  }).format(r), a = new Intl.DateTimeFormat(o, {
    timeZone: n,
    timeStyle: "short",
    hour12: t === Yf.TWELVE_HOUR
  }).format(r).toLowerCase();
  return { date: i, time: a };
}, Lpl = ({
  date: e,
  duration: t,
  timeFormat: n,
  timeZone: o,
  language: r
}) => {
  const i = new Date(e), a = t ? new Date(new Date(e).setMinutes(i.getMinutes() + t)) : i, s = new Intl.DateTimeFormat(r, {
    timeZone: o,
    dateStyle: "full"
  }).formatRange(i, a), c = new Intl.DateTimeFormat(r, {
    timeZone: o,
    timeStyle: "short",
    hour12: n === Yf.TWELVE_HOUR
  }).formatRange(i, a).toLowerCase();
  return { date: s, time: c };
}, XQ = (e) => {
  const t = Lpl(e);
  return /* @__PURE__ */ Y(Ce, { children: [
    t.date,
    /* @__PURE__ */ m("br", {}),
    t.time
  ] });
}, qpl = (e) => {
  const t = Rve(e);
  return /* @__PURE__ */ Y(Ce, { children: [
    t.date,
    ", ",
    t.time
  ] });
}, jpl = (e) => !!e, Fpl = jpl;
function Nve(e, t) {
  return e.map((n) => {
    const o = Xs(n.type), r = tve(n);
    if (typeof r != "string" || !o)
      return null;
    const i = o.type;
    return {
      // XYZ: is considered a namespace in i18next https://www.i18next.com/principles/namespaces and thus it gets cleaned up.
      label: n.customLabel || xF(n, o, t) || r,
      value: i,
      inputPlaceholder: t((o == null ? void 0 : o.attendeeInputPlaceholder) || "")
    };
  }).filter(Fpl);
}
var fC = function(e) {
  var t = e.as, n = e.errors, o = e.name, r = e.message, i = e.render, a = function(_, p) {
    if (_ == null)
      return {};
    var f, g, h = {}, b = Object.keys(_);
    for (g = 0; g < b.length; g++)
      p.indexOf(f = b[g]) >= 0 || (h[f] = _[f]);
    return h;
  }(e, ["as", "errors", "name", "message", "render"]), s = Dn(), c = jt(n || s.formState.errors, o);
  if (!c)
    return null;
  var l = c.message, d = c.types, u = Object.assign({}, a, { children: l || r });
  return $e.isValidElement(t) ? $e.cloneElement(t, u) : i ? i({ message: l || r, messages: d }) : $e.createElement(t || $e.Fragment, u);
};
const gC = hn(
  async () => (await import("./index-D6s7-q99.js")).SelectWithValidation
), Vpl = (e) => {
  const { value: t, setValue: n, readOnly: o, placeholder: r, maxLength: i, customProps: a, ...s } = e;
  return /* @__PURE__ */ m(
    D$,
    {
      value: t || "",
      placeholder: r,
      className: "mb-2",
      disabled: o,
      onChange: (d) => {
        const u = d.target.value;
        n(u);
      },
      maxLength: i,
      ...a,
      ...s
    }
  );
}, Bpl = (e) => {
  const {
    value: t,
    noLabel: n,
    setValue: o,
    readOnly: r,
    placeholder: i,
    customProps: a,
    type: s = "text",
    ...c
  } = e;
  return /* @__PURE__ */ m(
    Io,
    {
      size: "sm",
      containerClassName: "w-full mb-2",
      type: s,
      value: t || "",
      noLabel: n,
      placeholder: i,
      disabled: r,
      onChange: (u) => {
        const _ = u.target.value;
        o(_);
      },
      ...c,
      ...a
    }
  );
};
function Upl({ value: e, setValue: t, ...n }) {
  return /* @__PURE__ */ m(
    Io,
    {
      size: "sm",
      type: "number",
      labelSrOnly: n.noLabel,
      containerClassName: "w-full",
      className: "mb-2",
      value: e,
      onChange: (o) => {
        t(o.target.value);
      },
      ...n
    }
  );
}
const Wpl = ({
  listValues: e,
  setValue: t,
  value: n,
  ...o
}) => {
  if (!e)
    return null;
  const r = e.map((a) => ({
    label: a.title,
    value: a.value
  })), i = r.filter((a) => n == null ? void 0 : n.includes(a.value));
  return i.length === 0 && (n != null && n.length) && t([]), /* @__PURE__ */ m(
    gC,
    {
      size: "sm",
      "aria-label": "multi-select-dropdown",
      className: "mb-2",
      onChange: (a) => {
        t(a == null ? void 0 : a.map((s) => s.value));
      },
      value: i,
      isMulti: !0,
      isDisabled: o.readOnly,
      options: r,
      ...o
    }
  );
};
function Gpl({ listValues: e, setValue: t, value: n, ...o }) {
  if (!e)
    return null;
  const r = e.map((a) => ({
    label: a.title,
    value: a.value
  })), i = r.find((a) => a.value === n);
  return !i && n && t(""), /* @__PURE__ */ m(
    gC,
    {
      size: "sm",
      "aria-label": "select-dropdown",
      className: "data-testid-select mb-2",
      onChange: (a) => {
        a && t(a.value);
      },
      isDisabled: o.readOnly,
      value: i,
      options: r,
      ...o
    }
  );
}
function Hpl({ config: e, type: t, label: n, onClick: o, readonly: r }) {
  const { t: i } = Fe();
  if (t === "delRule" || t == "delGroup")
    return /* @__PURE__ */ m("button", { className: "ml-5", children: /* @__PURE__ */ m(ot, { name: "trash", className: "text-subtle m-0 h-4 w-4", onClick: o }) });
  let a = "";
  return t === "addRule" ? (n = e != null && e.operators.__calReporting ? i("add_filter") : i("add_rule"), a = "add-rule") : t == "addGroup" && (n = i("add_rule_group"), a = "add-rule-group"), /* @__PURE__ */ m(
    ut,
    {
      size: "sm",
      StartIcon: "plus",
      "data-testid": a,
      type: "button",
      color: "minimal",
      disabled: r,
      onClick: o,
      children: n
    }
  );
}
function Kpl({ children: e }) {
  return e instanceof Array ? /* @__PURE__ */ m(Ce, { children: e.map((t, n) => t ? /* @__PURE__ */ m("div", { children: t }, n) : null) }) : null;
}
function Ypl({ not: e, setNot: t, config: n, conjunctionOptions: o, setConjunction: r, disabled: i }) {
  if (!n || !o)
    return null;
  const a = Object.keys(o).length, s = i, { forceShowConj: c } = n.settings, l = c || a > 1 && !s, d = [
    { label: "All", value: "all" },
    { label: "Any", value: "any" },
    { label: "None", value: "none" }
  ];
  return l ? (() => {
    const { checked: _ } = o.AND, { checked: p } = o.OR, f = e;
    let g = _ ? "all" : p ? "any" : "all";
    f && (g = g == "any" ? "none" : "all");
    const h = d.find((v) => v.value === g), b = n.operators.__calReporting ? "Query where" : "If booker selects";
    return /* @__PURE__ */ Y("div", { className: "mb-[1px] flex items-center text-sm", children: [
      /* @__PURE__ */ m("span", { children: b }),
      /* @__PURE__ */ m(
        gC,
        {
          className: "flex px-2",
          size: "sm",
          defaultValue: h,
          options: d,
          onChange: (v) => {
            v && (v.value === "all" ? (r("AND"), t(!1)) : v.value === "any" ? (r("OR"), t(!1)) : v.value === "none" && (r("OR"), t(!0)));
          }
        }
      )
    ] });
  })() : null;
}
const Zpl = function(t) {
  const { items: n, setField: o, selectedKey: r } = t, i = n.map((s) => ({
    ...s,
    value: s.key
  })), a = i.find((s) => s.value === r);
  return /* @__PURE__ */ m(
    gC,
    {
      size: "sm",
      className: "data-testid-field-select  mb-2",
      menuPosition: "fixed",
      onChange: (s) => {
        s && o(s.value);
      },
      defaultValue: a,
      options: i
    }
  );
}, Qpl = ({ children: e }) => e, Km = {
  TextWidget: Bpl,
  TextAreaWidget: Vpl,
  SelectWidget: Gpl,
  NumberWidget: Upl,
  MultiSelectWidget: Wpl,
  FieldSelect: Zpl,
  Button: Hpl,
  ButtonGroup: Kpl,
  Conjs: Ypl,
  Provider: Qpl
}, Jpl = hn(
  () => import("./PhoneInput-Ugj5tpUu.js")
), Dve = Jpl, Xpl = hn(
  () => import("./AddressInput-XLZv7IiA.js")
), eml = Xpl, tml = /* @__PURE__ */ No(void 0);
function nml(e) {
  const t = Pn(tml);
  return e || t || "ltr";
}
const Mve = "Radio", [oml, Lve] = os(Mve), [rml, iml] = oml(Mve), aml = /* @__PURE__ */ it((e, t) => {
  const { __scopeRadio: n, name: o, checked: r = !1, required: i, disabled: a, value: s = "on", onCheck: c, ...l } = e, [d, u] = ze(null), _ = or(
    t,
    (g) => u(g)
  ), p = Ue(!1), f = d ? !!d.closest("form") : !0;
  return /* @__PURE__ */ Pe(rml, {
    scope: n,
    checked: r,
    disabled: a
  }, /* @__PURE__ */ Pe(io.button, We({
    type: "button",
    role: "radio",
    "aria-checked": r,
    "data-state": qve(r),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: s
  }, l, {
    ref: _,
    onClick: Bt(e.onClick, (g) => {
      r || c == null || c(), f && (p.current = g.isPropagationStopped(), p.current || g.stopPropagation());
    })
  })), f && /* @__PURE__ */ Pe(lml, {
    control: d,
    bubbles: !p.current,
    name: o,
    value: s,
    checked: r,
    required: i,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), sml = "RadioIndicator", cml = /* @__PURE__ */ it((e, t) => {
  const { __scopeRadio: n, forceMount: o, ...r } = e, i = iml(sml, n);
  return /* @__PURE__ */ Pe(rs, {
    present: o || i.checked
  }, /* @__PURE__ */ Pe(io.span, We({
    "data-state": qve(i.checked),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t
  })));
}), lml = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = Ue(null), a = xue(n), s = BT(t);
  return Le(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== n && u) {
      const _ = new Event("click", {
        bubbles: o
      });
      u.call(c, n), c.dispatchEvent(_);
    }
  }, [
    a,
    n,
    o
  ]), /* @__PURE__ */ Pe("input", We({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, r, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function qve(e) {
  return e ? "checked" : "unchecked";
}
const dml = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], jve = "RadioGroup", [uml, mfd] = os(jve, [
  Zv,
  Lve
]), Fve = Zv(), Vve = Lve(), [_ml, pml] = uml(jve), mml = /* @__PURE__ */ it((e, t) => {
  const { __scopeRadioGroup: n, name: o, defaultValue: r, value: i, required: a = !1, disabled: s = !1, orientation: c, dir: l, loop: d = !0, onValueChange: u, ..._ } = e, p = Fve(n), f = nml(l), [g, h] = jc({
    prop: i,
    defaultProp: r,
    onChange: u
  });
  return /* @__PURE__ */ Pe(_ml, {
    scope: n,
    name: o,
    required: a,
    disabled: s,
    value: g,
    onValueChange: h
  }, /* @__PURE__ */ Pe(Xq, We({
    asChild: !0
  }, p, {
    orientation: c,
    dir: f,
    loop: d
  }), /* @__PURE__ */ Pe(io.div, We({
    role: "radiogroup",
    "aria-required": a,
    "aria-orientation": c,
    "data-disabled": s ? "" : void 0,
    dir: f
  }, _, {
    ref: t
  }))));
}), fml = "RadioGroupItem", gml = /* @__PURE__ */ it((e, t) => {
  const { __scopeRadioGroup: n, disabled: o, ...r } = e, i = pml(fml, n), a = i.disabled || o, s = Fve(n), c = Vve(n), l = Ue(null), d = or(t, l), u = i.value === r.value, _ = Ue(!1);
  return Le(() => {
    const p = (g) => {
      dml.includes(g.key) && (_.current = !0);
    }, f = () => _.current = !1;
    return document.addEventListener("keydown", p), document.addEventListener("keyup", f), () => {
      document.removeEventListener("keydown", p), document.removeEventListener("keyup", f);
    };
  }, []), /* @__PURE__ */ Pe(e9, We({
    asChild: !0
  }, s, {
    focusable: !a,
    active: u
  }), /* @__PURE__ */ Pe(aml, We({
    disabled: a,
    required: i.required,
    checked: u
  }, c, r, {
    name: i.name,
    ref: d,
    onCheck: () => i.onValueChange(r.value),
    onKeyDown: Bt((p) => {
      p.key === "Enter" && p.preventDefault();
    }),
    onFocus: Bt(r.onFocus, () => {
      var p;
      _.current && ((p = l.current) === null || p === void 0 || p.click());
    })
  })));
}), hml = /* @__PURE__ */ it((e, t) => {
  const { __scopeRadioGroup: n, ...o } = e, r = Vve(n);
  return /* @__PURE__ */ Pe(cml, We({}, r, o, {
    ref: t
  }));
}), ck = mml, lk = gml, dk = hml, vml = ({ children: e, className: t, classNames: n, ...o }) => {
  const r = Cc(), i = o.id ?? r;
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "border-subtle [&:has(input:checked)]:border-emphasis relative flex items-start rounded-[10px] border ",
        t
      ),
      children: [
        /* @__PURE__ */ m(
          lk,
          {
            id: i,
            ...o,
            className: ae(
              "hover:bg-subtle disabled:hover:bg-default border-default focus:ring-emphasis absolute left-3 top-[0.9rem] mt-0.5 h-4 w-4 flex-shrink-0 rounded-full border transition focus:ring-2 disabled:cursor-not-allowed",
              o.disabled && "opacity-60"
            ),
            children: /* @__PURE__ */ m(
              dk,
              {
                className: ae(
                  "after:bg-default dark:after:bg-inverted relative flex h-full w-full items-center justify-center rounded-full bg-black after:h-[6px] after:w-[6px] after:rounded-full after:content-['']",
                  o.disabled ? "after:bg-muted" : "bg-black"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ m("label", { htmlFor: i, className: ae("text-default p-4 pl-10 pt-3", n == null ? void 0 : n.container), children: e })
      ]
    }
  );
}, bml = ({
  children: e,
  className: t,
  onValueChange: n,
  ...o
}) => /* @__PURE__ */ m(ck, { className: t, onValueChange: n, ...o, children: e }), Up = vml, PF = bml, yml = (e) => /* @__PURE__ */ m(ck, { ...e, children: e.children }), $ml = (e) => /* @__PURE__ */ m(
  lk,
  {
    ...e,
    className: ae(
      "hover:bg-subtle border-default dark:checked:bg-brand-default dark:hover:bg-subtle dark:checked:hover:bg-brand-default focus:ring-brand-default hover:border-emphasis me-1.5 mt-0.5 h-4 w-4 flex-shrink-0 rounded-full border text-[--cal-brand] transition focus:border-0 focus:ring-1",
      e.disabled && "opacity-60"
    ),
    children: e.children
  }
), wml = ({ disabled: e }) => /* @__PURE__ */ m(
  dk,
  {
    className: ae(
      "after:bg-default dark:after:bg-brand-accent relative flex h-full w-full items-center justify-center rounded-full bg-black after:h-[6px] after:w-[6px] after:rounded-full after:content-['']",
      e ? "after:bg-muted" : "bg-brand-default"
    )
  }
), kml = (e) => /* @__PURE__ */ m(
  "label",
  {
    ...e,
    className: ae(
      "text-emphasis ms-2 w-full text-sm font-medium leading-5",
      e.disabled && "text-subtle"
    )
  }
), yL = ({
  label: e,
  disabled: t,
  id: n,
  value: o,
  className: r,
  withPadding: i
}) => /* @__PURE__ */ Y(
  "div",
  {
    className: ae(
      "flex items-start",
      i && "hover:bg-subtle cursor-pointer rounded-lg p-1.5",
      r
    ),
    children: [
      /* @__PURE__ */ m($ml, { value: o, disabled: t, id: n, children: /* @__PURE__ */ m(wml, { disabled: t }) }),
      /* @__PURE__ */ m(kml, { htmlFor: n, disabled: t, children: e })
    ]
  }
), Sml = {
  boolean: (e) => typeof e == "boolean",
  multiselect: (e) => e instanceof Array && e.every((t) => typeof t == "string"),
  objectiveWithInput: (e) => typeof e == "object" && e !== null ? "value" in e : !1,
  select: (e) => typeof e == "string",
  text: (e) => typeof e == "string",
  textList: (e) => e instanceof Array && e.every((t) => typeof t == "string"),
  variants: (e) => typeof e == "object" && e !== null || typeof e == "string"
}, xml = {
  text: {
    propsType: Ua.text,
    factory: (e) => /* @__PURE__ */ m(Km.TextWidget, { id: e.name, noLabel: !0, ...e })
  },
  textarea: {
    propsType: Ua.textarea,
    // TODO: Make rows configurable in the form builder
    factory: (e) => /* @__PURE__ */ m(Km.TextAreaWidget, { id: e.name, rows: 3, ...e })
  },
  number: {
    propsType: Ua.number,
    factory: (e) => /* @__PURE__ */ m(Km.NumberWidget, { id: e.name, noLabel: !0, ...e })
  },
  name: {
    propsType: Ua.name,
    // Keep special "name" type field and later build split(FirstName and LastName) variant of it.
    factory: (e) => {
      const { variant: t = "fullName" } = e, n = (i, a) => {
        let s = e.value;
        typeof s != "object" && (s = {}), e.setValue({
          ...s,
          [i]: a
        });
      };
      if (!e.variants)
        throw new Error("'variants' is required for 'name' type of field");
      if (t !== "firstAndLastName" && t !== "fullName")
        throw new Error(`Invalid variant name '${t}' for 'name' type of field`);
      const o = Vhe(t, e.value);
      if (t === "fullName") {
        if (typeof o != "string")
          throw new Error("Invalid value for 'fullName' variant");
        const a = e.variants[t].fields[0];
        return /* @__PURE__ */ m(
          hi,
          {
            name: "name",
            showAsteriskIndicator: !0,
            placeholder: a.placeholder,
            label: a.label,
            containerClassName: "w-full",
            readOnly: e.readOnly,
            value: o,
            required: a.required,
            type: "text",
            autoComplete: "name",
            onChange: (s) => {
              e.setValue(s.target.value);
            }
          }
        );
      }
      const r = e.variants[t];
      if (typeof o != "object")
        throw new Error("Invalid value for 'fullName' variant");
      return /* @__PURE__ */ m("div", { className: "flex space-x-4", children: r.fields.map((i) => /* @__PURE__ */ m(
        hi,
        {
          className: "!mb-0",
          showAsteriskIndicator: !0,
          name: i.name,
          readOnly: e.readOnly,
          placeholder: i.placeholder,
          label: i.label,
          containerClassName: `w-full testid-${i.name}`,
          value: o[i.name],
          required: i.required,
          type: "text",
          autoComplete: i.name === "firstName" ? "given-name" : i.name === "lastName" ? "family-name" : void 0,
          onChange: (a) => n(i.name, a.target.value)
        },
        i.name
      )) });
    }
  },
  phone: {
    propsType: Ua.phone,
    factory: ({ setValue: e, readOnly: t, ...n }) => n ? /* @__PURE__ */ m(
      Dve,
      {
        disabled: t,
        onChange: (o) => {
          e(o);
        },
        ...n
      }
    ) : /* @__PURE__ */ m("div", {})
  },
  email: {
    propsType: Ua.email,
    factory: (e) => e ? /* @__PURE__ */ m(
      hi,
      {
        type: "email",
        id: e.name,
        noLabel: !0,
        autoComplete: "email",
        ...e,
        onChange: (t) => e.setValue(t.target.value)
      }
    ) : /* @__PURE__ */ m("div", {})
  },
  address: {
    propsType: Ua.address,
    factory: (e) => /* @__PURE__ */ m(
      eml,
      {
        id: e.name,
        onChange: (t) => {
          e.setValue(t);
        },
        ...e,
        disabled: e.readOnly
      }
    )
  },
  multiemail: {
    propsType: Ua.multiemail,
    //TODO: Make it a ui component
    factory: function({ value: t, readOnly: n, label: o, setValue: r, ...i }) {
      const a = i.placeholder, { t: s } = Fe();
      return t = t || [], /* @__PURE__ */ Y(Ce, { children: [
        t.length ? /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ m("label", { htmlFor: "guests", className: "text-default  mb-1 block text-sm font-medium", children: o }),
          /* @__PURE__ */ m("ul", { children: t.map((c, l) => /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
            V_e,
            {
              id: `${i.name}.${l}`,
              disabled: n,
              value: t[l],
              onChange: (d) => {
                t[l] = d.target.value.toLowerCase(), r(t);
              },
              placeholder: a,
              label: /* @__PURE__ */ m(Ce, {}),
              required: !0,
              onClickAddon: () => {
                t.splice(l, 1), r(t);
              },
              addOnSuffix: n ? null : /* @__PURE__ */ m(Ao, { content: "Remove email", children: /* @__PURE__ */ m("button", { className: "m-1", type: "button", children: /* @__PURE__ */ m(ot, { name: "x", width: 12, className: "text-default" }) }) })
            }
          ) }, l)) }),
          !n && /* @__PURE__ */ m(
            ut,
            {
              "data-testid": "add-another-guest",
              type: "button",
              color: "minimal",
              StartIcon: "user-plus",
              className: "my-2.5",
              onClick: () => {
                t.push(""), r(t);
              },
              children: s("add_another")
            }
          )
        ] }) : /* @__PURE__ */ m(Ce, {}),
        !t.length && !n && /* @__PURE__ */ m(
          ut,
          {
            "data-testid": "add-guests",
            color: "minimal",
            variant: "button",
            StartIcon: "user-plus",
            onClick: () => {
              t.push(""), r(t);
            },
            className: "mr-auto h-fit whitespace-normal text-left",
            children: /* @__PURE__ */ m("span", { className: "flex-1", children: o })
          }
        )
      ] });
    }
  },
  multiselect: {
    propsType: Ua.multiselect,
    factory: (e) => {
      const t = {
        ...e,
        listValues: e.options.map((n) => ({ title: n.label, value: n.value }))
      };
      return /* @__PURE__ */ m(Km.MultiSelectWidget, { id: e.name, ...t });
    }
  },
  select: {
    propsType: Ua.select,
    factory: (e) => {
      const t = {
        ...e,
        listValues: e.options.map((n) => ({ title: n.label, value: n.value }))
      };
      return /* @__PURE__ */ m(Km.SelectWidget, { id: e.name, ...t });
    }
  },
  checkbox: {
    propsType: Ua.checkbox,
    factory: ({ options: e, readOnly: t, setValue: n, value: o }) => (o = o || [], /* @__PURE__ */ m("div", { children: e.map((r, i) => /* @__PURE__ */ Y("label", { className: "block", children: [
      /* @__PURE__ */ m(
        Uue,
        {
          disabled: t,
          onCheckedChange: (a) => {
            const s = o.filter((c) => c !== r.value);
            a && s.push(r.value), n(s);
          },
          value: r.value,
          checked: o.includes(r.value)
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-emphasis me-2 ms-2 text-sm", children: r.label ?? "" })
    ] }, i)) }))
  },
  radio: {
    propsType: Ua.radio,
    factory: ({ setValue: e, name: t, value: n, options: o, readOnly: r }) => /* @__PURE__ */ m(
      yml,
      {
        disabled: r,
        value: n,
        onValueChange: (i) => {
          e(i);
        },
        children: /* @__PURE__ */ m(Ce, { children: o.map((i, a) => /* @__PURE__ */ m(
          yL,
          {
            label: i.label,
            value: i.label,
            id: `${t}.option.${a}.radio`
          },
          `option.${a}.radio`
        )) })
      }
    )
  },
  radioInput: {
    propsType: Ua.radioInput,
    factory: function({
      name: t,
      label: n,
      options: o,
      optionsInputs: r,
      value: i,
      setValue: a,
      readOnly: s,
      translatedDefaultLabel: c
    }) {
      var _;
      Le(() => {
        var p;
        i || a({
          value: (p = o[0]) == null ? void 0 : p.value,
          optionValue: ""
        });
      }, [o, a, i]);
      const { t: l } = Fe(), d = (p, f) => p && f ? f !== p : !1, u = (p) => p ? p.search(/^https?:\/\//) !== -1 ? /* @__PURE__ */ m("a", { href: p, target: "_blank", children: /* @__PURE__ */ m("span", { className: "underline", children: p }) }) : p : "";
      return /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "mb-2", children: o.length > 1 ? o.map((p, f) => /* @__PURE__ */ Y("label", { className: "mb-1 flex items-center", children: [
          /* @__PURE__ */ m(
            "input",
            {
              type: "radio",
              disabled: s,
              name: t,
              className: "bg-default after:bg-default border-emphasis focus:ring-brand-default hover:bg-subtle hover:after:bg-subtle dark:checked:after:bg-brand-accent flex h-4 w-4 cursor-pointer items-center justify-center text-[--cal-brand] transition after:h-[6px] after:w-[6px] after:rounded-full after:content-[''] after:hover:block focus:ring-2 focus:ring-offset-0 ltr:mr-2 rtl:ml-2 dark:checked:hover:text-[--cal-brand]",
              value: p.value,
              onChange: (g) => {
                a({
                  value: g.target.value,
                  optionValue: ""
                });
              },
              checked: (i == null ? void 0 : i.value) === p.value
            }
          ),
          /* @__PURE__ */ m("span", { className: "text-emphasis me-2 ms-2 text-sm", children: p.value === "somewhereElse" ? l("somewhere_else") : u(p.label) ?? "" }),
          /* @__PURE__ */ m("span", { children: p.value === "phone" && /* @__PURE__ */ m(gE, { content: l("number_in_international_format") }) })
        ] }, f)) : (
          // Use the only option itself to determine if the field is required or not.
          /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(Xn, { className: "flex items-center", children: [
            o[0].value === "somewhereElse" ? c : u(
              d(n, c) ? n : o[0].label
            ),
            !s && ((_ = r[o[0].value]) != null && _.required) ? /* @__PURE__ */ m("span", { className: "text-default -mb-2 ml-1 text-sm font-medium", children: "*" }) : null,
            o[0].value === "phone" && /* @__PURE__ */ m(gE, { content: l("number_in_international_format") })
          ] }) })
        ) }) }),
        (() => {
          const p = r[i == null ? void 0 : i.value];
          return p ? /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
            Uve,
            {
              readOnly: !!s,
              field: {
                ...p,
                name: "optionField"
              },
              value: i == null ? void 0 : i.optionValue,
              setValue: (f) => {
                a({
                  value: i == null ? void 0 : i.value,
                  optionValue: f || ""
                });
              }
            }
          ) }) : null;
        })()
      ] });
    }
  },
  boolean: {
    propsType: Ua.boolean,
    factory: ({ readOnly: e, name: t, label: n, value: o, setValue: r }) => /* @__PURE__ */ m("div", { className: "flex", children: /* @__PURE__ */ m(
      Ta,
      {
        name: t,
        onChange: (i) => {
          i.target.checked ? r(!0) : r(!1);
        },
        placeholder: "",
        checked: o,
        disabled: e,
        description: "",
        descriptionAsSafeHtml: n ?? ""
      }
    ) })
  },
  url: {
    propsType: Ua.url,
    factory: (e) => /* @__PURE__ */ m(Km.TextWidget, { type: "url", autoComplete: "url", noLabel: !0, ...e })
  }
}, hC = ["boolean", "radio"];
function Eml(e) {
  const t = {};
  if (e === null)
    return t;
  for (const [n, o] of e)
    if (t.hasOwnProperty(n)) {
      let r = t[n];
      Array.isArray(r) || (r = [r]), r.push(o), t[n] = r;
    } else
      t[n] = o;
  return t;
}
const Tml = () => {
  const e = O_();
  return Eml((e == null ? void 0 : e.entries()) ?? null);
}, Bve = (e) => e == null ? void 0 : e.replace(/\{([^}]+)\}.*/, "$1");
function eJ(e) {
  return Array.isArray(e) ? e : [e];
}
function Aml(e, t) {
  return !!e.find((n) => t.find((o) => (o == null ? void 0 : o.toString()) == (n == null ? void 0 : n.toString())));
}
function Cml(e, t) {
  if (typeof t == "string")
    return (e == null ? void 0 : e.toString()) == (t == null ? void 0 : t.toString());
  const n = eJ(t), o = eJ(e);
  return Aml(n, o);
}
const zml = (e) => {
  var _, p, f, g, h;
  const { getValues: t, formState: n } = Dn(), o = Tml();
  if (!e.disableOnPrefill || (p = (_ = n.dirtyFields) == null ? void 0 : _.responses) != null && p[e.name])
    return !1;
  const r = ((f = t()) == null ? void 0 : f.responses) || {}, i = e.type !== "radioInput" && !e.variantsConfig, a = ((h = (g = n == null ? void 0 : n.errors) == null ? void 0 : g.responses) == null ? void 0 : h.message) || "";
  if (Bve(a) === e.name)
    return !1;
  const c = o[e.name], l = r[e.name];
  if (!i && d(c) && d(l))
    return e.type === "radioInput" ? u({ value: l, optionsInputs: e.optionsInputs }) : !0;
  if (!d(l) || !o)
    return !1;
  if (c == (l == null ? void 0 : l.toString()))
    return !0;
  return Cml(c, l);
  function d(b) {
    return b != null && b !== "";
  }
  function u({
    value: b,
    optionsInputs: v
  }) {
    return (v == null ? void 0 : v[b.value]) ? !!b.value && !!b.optionValue : !!b.value;
  }
}, Oml = (e) => e.labelAsSafeHtml ? /* @__PURE__ */ m(
  "span",
  {
    dangerouslySetInnerHTML: { __html: gA(e.labelAsSafeHtml) }
  }
) : /* @__PURE__ */ m("span", { children: e.label }), Pml = ({
  field: e,
  readOnly: t,
  className: n
}) => {
  const { t: o } = Fe(), { control: r, formState: i } = Dn(), { hidden: a, placeholder: s, label: c, noLabel: l, translatedDefaultLabel: d } = Rml(
    e,
    o
  ), u = zml(e);
  return /* @__PURE__ */ m("div", { "data-fob-field-name": e.name, className: ae(n, a ? "hidden" : ""), children: /* @__PURE__ */ m(
    Wt,
    {
      control: r,
      name: `responses.${e.name}`,
      render: ({ field: { value: _, onChange: p }, fieldState: { error: f } }) => /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ m(
          Uve,
          {
            field: { ...e, label: c, placeholder: s, hidden: a },
            value: _,
            readOnly: t || u,
            setValue: (g) => {
              p(g);
            },
            noLabel: l,
            translatedDefaultLabel: d
          }
        ),
        /* @__PURE__ */ m(
          fC,
          {
            name: "responses",
            errors: i.errors,
            render: ({ message: g }) => (g = g || "", !(Bve(g) === e.name) && !f ? null : (g = g.replace(/\{[^}]+\}(.*)/, "$1").trim(), a && console.error(`Error message for hidden field:${e.name} => ${g}`), /* @__PURE__ */ Y(
              "div",
              {
                "data-testid": `error-message-${e.name}`,
                className: "mt-2 flex items-center text-sm text-red-700 ",
                children: [
                  /* @__PURE__ */ m(ot, { name: "info", className: "h-3 w-3 ltr:mr-2 rtl:ml-2" }),
                  /* @__PURE__ */ m("p", { children: o(g || "invalid_input") })
                ]
              }
            )))
          }
        )
      ] })
    }
  ) });
};
function Iml(e) {
  throw new Error(`Don't know how to handle ${JSON.stringify(e)}`);
}
const ah = ({
  field: e,
  children: t,
  readOnly: n,
  htmlFor: o,
  noLabel: r = !1
}) => {
  const { t: i } = Fe();
  return /* @__PURE__ */ Y("div", { children: [
    r ? null : e.type !== "boolean" && e.type !== "multiemail" && e.label && /* @__PURE__ */ m("div", { className: "mb-2 flex items-center", children: /* @__PURE__ */ Y(Xn, { className: "!mb-0 flex items-center", htmlFor: o, children: [
      Oml(e),
      /* @__PURE__ */ m("span", { className: "text-emphasis -mb-1 ml-1 text-sm font-medium leading-none", children: !n && e.required ? "*" : "" }),
      e.type === "phone" && /* @__PURE__ */ m(gE, { content: i("number_in_international_format") })
    ] }) }),
    t,
    e.name === "smsReminderNumber" && /* @__PURE__ */ m("div", { className: "text-sm text-gray-500", children: i("sms_workflow_consent") })
  ] });
};
function Rml(e, t) {
  var s;
  let n = !1, o = !!e.hidden;
  if (e.type === "radioInput") {
    const c = e.options;
    if ((c == null ? void 0 : c.length) === 1) {
      if (!e.optionsInputs)
        throw new Error("radioInput must have optionsInputs");
      e.optionsInputs[c[0].value] ? n = !0 : o = !0;
    }
  }
  if (hC.includes(e.type) && e.labelAsSafeHtml === void 0)
    throw new Error(`${e.name}:${e.type} type must have labelAsSafeHtml set`);
  const r = t(e.defaultLabel || ""), i = e.labelAsSafeHtml || e.label || r, a = e.placeholder || t(e.defaultPlaceholder || "");
  return (s = e.variantsConfig) != null && s.variants && Object.entries(e.variantsConfig.variants).forEach(([c, l]) => {
    l.fields.forEach((d) => {
      var p, f, g, h;
      const u = (p = Ea[e.type]) == null ? void 0 : p.variantsConfig, _ = (h = (g = (f = u == null ? void 0 : u.variants) == null ? void 0 : f[c]) == null ? void 0 : g.fieldsMap[d.name]) == null ? void 0 : h.defaultLabel;
      d.label = d.label || t(_ || "");
    });
  }), { hidden: o, placeholder: a, label: i, noLabel: n, translatedDefaultLabel: r };
}
const Uve = ({
  field: e,
  value: t,
  setValue: n,
  readOnly: o,
  noLabel: r,
  translatedDefaultLabel: i
}) => {
  const a = e.type || "text", s = xml[a], { t: c } = Fe();
  if (t !== void 0 && !((d, u) => Sml[u](d))(t, s.propsType))
    throw new Error(
      `Value ${t} is not valid for type ${s.propsType} for field ${e.name}`
    );
  if (s.propsType === "text")
    return /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        minLength: e.minLength,
        maxLength: e.maxLength,
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n
      }
    ) });
  if (s.propsType === "boolean")
    return /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n,
        placeholder: e.placeholder
      }
    ) });
  if (s.propsType === "textList")
    return /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        name: e.name,
        label: e.label,
        readOnly: o,
        value: t,
        setValue: n
      }
    ) });
  if (s.propsType === "select") {
    if (!e.options)
      throw new Error("Field options is not defined");
    return /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        readOnly: o,
        value: t,
        name: e.name,
        placeholder: e.placeholder,
        setValue: n,
        options: e.options.map((d) => ({ ...d, title: d.label }))
      }
    ) });
  }
  if (s.propsType === "multiselect") {
    if (!e.options)
      throw new Error("Field options is not defined");
    return /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        name: e.name,
        readOnly: o,
        value: t,
        setValue: n,
        options: e.options.map((d) => ({ ...d, title: d.label }))
      }
    ) });
  }
  if (s.propsType === "objectiveWithInput") {
    if (!e.options)
      throw new Error("Field options is not defined");
    if (!e.optionsInputs)
      throw new Error("Field optionsInputs is not defined");
    const d = e.options;
    return e.options.length ? /* @__PURE__ */ m(ah, { field: e, htmlFor: e.name, readOnly: o, noLabel: r, children: /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        readOnly: o,
        name: e.name,
        label: e.label,
        value: t,
        setValue: n,
        optionsInputs: e.optionsInputs,
        options: d,
        required: e.required,
        translatedDefaultLabel: i
      }
    ) }) : null;
  }
  if (s.propsType === "variants") {
    const d = hll(e, c);
    return d ? /* @__PURE__ */ m(
      s.factory,
      {
        placeholder: e.placeholder,
        readOnly: o,
        name: e.name,
        variant: e.variant,
        value: t,
        setValue: n,
        variants: d.variants
      }
    ) : null;
  }
  return Iml(s), null;
}, Pm = G.enum([
  "name",
  "email",
  "location",
  "title",
  "notes",
  "guests",
  "rescheduleReason",
  "smsReminderNumber",
  "attendeePhoneNumber",
  "aiAgentCallPhoneNumber"
]), Nml = ({
  fields: e,
  locations: t,
  rescheduleUid: n,
  isDynamicGroupBooking: o,
  bookingData: r,
  isPaidEvent: i,
  paymentCurrency: a = "USD"
}) => {
  const { t: s, i18n: c } = Fe(), { watch: l, setValue: d } = Dn(), u = l("responses.location"), _ = n ? "reschedule" : "", p = Ic((b) => b.isInstantMeeting), f = (b, v) => `${b} (${Intl.NumberFormat(c.language, {
    style: "currency",
    currency: a
  }).format(v)})`, g = (b) => {
    var k;
    if (!((k = Ea[b.type]) != null && k.supportsPricing) || !b.label || !b.price)
      return b;
    const v = typeof b.price == "string" ? parseFloat(b.price) : b.price, $ = f(b.label, v);
    return {
      ...b,
      label: $,
      ...hC.includes(b.type) && b.labelAsSafeHtml ? { labelAsSafeHtml: gA($) } : { labelAsSafeHtml: void 0 }
    };
  }, h = (b) => {
    var v;
    return !((v = Ea[b.type]) != null && v.optionsSupportPricing) || !b.options ? b : {
      ...b,
      options: b.options.map(($) => {
        const k = $, S = k.price;
        return S ? {
          ...k,
          label: f(k.label, S)
        } : k;
      })
    };
  };
  return (
    // TODO: It might make sense to extract this logic into BookingFields config, that would allow to quickly configure system fields and their editability in fresh booking and reschedule booking view
    // The logic here intends to make modifications to booking fields based on the way we want to specifically show Booking Form
    /* @__PURE__ */ m("div", { children: e.map((b, v) => {
      var M, N;
      if (p && b.name === "location")
        return null;
      const $ = (b.editable === "system" || b.editable === "system-but-optional") && !!n && r !== null;
      let S = b.editable === "user-readonly" || $, O = !!b.hidden;
      const I = b.views;
      if (I && !I.find((C) => C.id === _))
        return null;
      if (b.name === Pm.Enum.rescheduleReason) {
        if (r === null)
          return null;
        S = !1;
      }
      if (b.name === Pm.Enum.smsReminderNumber) {
        if ((u == null ? void 0 : u.value) === "phone")
          return d(`responses.${Pm.Enum.smsReminderNumber}`, u == null ? void 0 : u.optionValue), null;
        S = !1;
      }
      if (b.name === Pm.Enum.guests && (S = !1, O = o ? !0 : !!b.hidden), b.name === Pm.Enum.notes && r !== null)
        return null;
      if (b.name === Pm.Enum.location && (S = !1), b.name === Pm.Enum.location && b.type === "radioInput") {
        if (!b.optionsInputs)
          throw new Error("radioInput must have optionsInputs");
        const C = b.optionsInputs, P = Nve(t, s);
        P.forEach((x) => {
          const w = C[x.value];
          w && (w.placeholder = x.inputPlaceholder);
        }), b.options = P.filter(
          (x) => !!x
        );
      }
      if (b != null && b.options) {
        const C = dul(), P = {};
        b.options.forEach((x) => {
          x.value in P ? P[x.value]++ : P[x.value] = 1;
        }), b.options = b.options.map((x) => ({
          ...x,
          value: C.includes(x.value) && P[x.value] > 1 ? x.label : x.value
        }));
      }
      let D = b;
      return i && ((M = Ea[b.type]) != null && M.supportsPricing && (D = g(b)), (N = Ea[b.type]) != null && N.optionsSupportPricing && (D = h(D))), /* @__PURE__ */ m(
        Pml,
        {
          className: "mb-4",
          field: { ...D, hidden: O },
          readOnly: S
        },
        v
      );
    }) })
  );
}, Dml = () => /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ m(Jn, { className: "h-7 w-32" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "mt-4 h-7 w-28" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ Y("div", { className: "mt-12 flex h-7 w-full flex-row items-center gap-4", children: [
    /* @__PURE__ */ m(Jn, { className: "inline h-4 w-4 rounded-full" }),
    /* @__PURE__ */ m(Jn, { className: "inline h-7 w-32" })
  ] }),
  /* @__PURE__ */ Y("div", { className: "mt-2 flex h-7 w-full flex-row items-center gap-4", children: [
    /* @__PURE__ */ m(Jn, { className: "inline h-4 w-4 rounded-full" }),
    /* @__PURE__ */ m(Jn, { className: "inline h-7 w-28" })
  ] }),
  /* @__PURE__ */ m(Jn, { className: "mt-8 h-7 w-32" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "mt-4 h-7 w-28" }),
  /* @__PURE__ */ m(Jn, { className: "mt-2 h-7 w-full" }),
  /* @__PURE__ */ Y("div", { className: "mt-6 flex flex-row gap-3", children: [
    /* @__PURE__ */ m(Jn, { className: "ml-auto h-8 w-20" }),
    /* @__PURE__ */ m(Jn, { className: "h-8 w-20" })
  ] })
] }), Mml = ({
  onCancel: e,
  eventQuery: t,
  onSubmit: n,
  errorRef: o,
  errors: r,
  loadingStates: i,
  renderConfirmNotVerifyEmailButtonCond: a,
  bookingForm: s,
  children: c,
  extraOptions: l,
  isVerificationCodeSending: d,
  isPlatform: u = !1,
  isTimeslotUnavailable: _,
  shouldRenderCaptcha: p,
  confirmButtonDisabled: f,
  classNames: g,
  timeslot: h
}) => {
  const b = t.data, v = St((T) => T.setFormValues), $ = St((T) => T.bookingData), k = St((T) => T.rescheduleUid), S = St((T) => T.username), O = St((T) => T.isInstantMeeting), I = Phe(), { timeFormat: D, timezone: M } = vd(), [N] = ze(null), { t: C, i18n: P } = Fe(), x = Tt(() => {
    if (!(b != null && b.price))
      return !1;
    const T = nm(b);
    return (b == null ? void 0 : b.price) > 0 && !Number.isNaN(T.price) && T.price > 0;
  }, [b]), w = Tt(() => {
    var T;
    return b && ((T = nm(b)) == null ? void 0 : T.currency) || "USD";
  }, [b]);
  if (t.isError)
    return /* @__PURE__ */ m(sa, { severity: "warning", message: C("error_booking_event") });
  if (t.isPending || !t.data)
    return /* @__PURE__ */ m(Dml, {});
  if (!h)
    return /* @__PURE__ */ m(
      sb,
      {
        headline: C("timeslot_missing_title"),
        description: C("timeslot_missing_description"),
        Icon: "calendar",
        buttonText: C("timeslot_missing_cta"),
        buttonOnClick: e
      }
    );
  if (!b)
    return console.warn("No event type found for event", l), /* @__PURE__ */ m(sa, { severity: "warning", message: C("error_booking_event") });
  const E = s.watch("cfToken");
  return /* @__PURE__ */ Y("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ Y(
      fd,
      {
        className: "flex h-full flex-col",
        onChange: () => {
          const T = s.getValues();
          v(T);
        },
        form: s,
        handleSubmit: n,
        noValidate: !0,
        children: [
          /* @__PURE__ */ m(
            Nml,
            {
              isDynamicGroupBooking: !!(S && S.indexOf("+") > -1),
              fields: b.bookingFields,
              locations: b.locations,
              rescheduleUid: k || void 0,
              bookingData: $,
              isPaidEvent: x,
              paymentCurrency: w
            }
          ),
          r.hasFormErrors || r.hasDataErrors ? /* @__PURE__ */ m("div", { "data-testid": "booking-fail", children: /* @__PURE__ */ m(
            sa,
            {
              ref: o,
              className: "my-2",
              severity: "info",
              title: C(k ? "reschedule_fail" : "booking_fail"),
              message: Lml({
                globalError: r.formErrors,
                dataError: r.dataErrors,
                t: C,
                responseVercelIdHeader: N,
                timeFormat: D,
                timezone: M,
                language: P.language
              })
            }
          ) }) : _ ? /* @__PURE__ */ m("div", { "data-testid": "slot-not-allowed-to-book", children: /* @__PURE__ */ m(
            sa,
            {
              severity: "info",
              title: C("unavailable_timeslot_title"),
              message: /* @__PURE__ */ m(
                Dc,
                {
                  t: C,
                  i18nKey: "timeslot_unavailable_book_a_new_time",
                  components: [
                    /* @__PURE__ */ m(
                      "button",
                      {
                        type: "button",
                        className: "underline",
                        onClick: e,
                        children: "Please select a new time"
                      },
                      "please-select-a-new-time-button"
                    )
                  ]
                }
              )
            }
          ) }) : null,
          !u && /* @__PURE__ */ m("div", { className: "text-subtle my-3 w-full text-xs", children: /* @__PURE__ */ m(
            Dc,
            {
              t: C,
              i18nKey: "signing_up_terms",
              components: [
                /* @__PURE__ */ m(
                  Po,
                  {
                    className: "text-emphasis hover:underline",
                    href: `${JW}`,
                    target: "_blank",
                    children: "Terms"
                  },
                  "terms"
                ),
                /* @__PURE__ */ m(
                  Po,
                  {
                    className: "text-emphasis hover:underline",
                    href: `${QW}`,
                    target: "_blank",
                    children: "Privacy Policy."
                  },
                  "privacy"
                )
              ]
            }
          ) }),
          I && /* @__PURE__ */ Y("div", { className: "text-subtle my-3 w-full text-xs", children: [
            C("proceeding_agreement"),
            " ",
            /* @__PURE__ */ m(
              Po,
              {
                className: "text-emphasis hover:underline",
                href: `${JW}`,
                target: "_blank",
                children: C("terms")
              },
              "terms"
            ),
            " ",
            C("and"),
            " ",
            /* @__PURE__ */ m(
              Po,
              {
                className: "text-emphasis hover:underline",
                href: `${QW}`,
                target: "_blank",
                children: C("privacy_policy")
              },
              "privacy"
            ),
            "."
          ] }),
          /* @__PURE__ */ m("div", { className: "modalsticky mt-auto flex justify-end space-x-2 rtl:space-x-reverse", children: O ? /* @__PURE__ */ m(ut, { type: "submit", color: "primary", loading: i.creatingInstantBooking, children: C(x ? "pay_and_book" : "confirm") }) : /* @__PURE__ */ Y(Ce, { children: [
            !!e && /* @__PURE__ */ m(
              ut,
              {
                color: "minimal",
                type: "button",
                onClick: e,
                "data-testid": "back",
                className: g == null ? void 0 : g.backButton,
                children: C("back")
              }
            ),
            /* @__PURE__ */ m(
              ut,
              {
                type: "submit",
                color: "primary",
                disabled: !!p && !E || _ || f,
                loading: i.creatingBooking || i.creatingRecurringBooking || d,
                className: g == null ? void 0 : g.confirmButton,
                "data-testid": k && $ ? "confirm-reschedule-button" : "confirm-book-button",
                children: C(k && $ ? "reschedule" : a ? x ? "pay_and_book" : "confirm" : "verify_email_button")
              }
            )
          ] }) })
        ]
      }
    ),
    c
  ] });
}, Lml = ({
  globalError: e,
  dataError: t,
  t: n,
  responseVercelIdHeader: o,
  timeFormat: r,
  timezone: i,
  language: a
}) => {
  var u;
  if (e)
    return e == null ? void 0 : e.message;
  const s = t;
  let c = "", l = 0;
  if (s.message === XS.BookerLimitExceededReschedule) {
    const _ = Rve({
      date: s.data.startTime,
      timeFormat: r,
      timeZone: i,
      language: a
    });
    c = `${_.date} ${_.time}`;
  }
  s.message === XS.BookerLimitExceeded && ((u = s.data) != null && u.count) && (l = s.data.count);
  const d = s.message === XS.BookerLimitExceeded ? "booker_upcoming_limit_reached" : s.message;
  return s != null && s.message ? /* @__PURE__ */ Y(Ce, { children: [
    o ?? "",
    " ",
    n(d, { date: c, count: l })
  ] }) : /* @__PURE__ */ m(Ce, { children: n("can_you_try_again") });
}, qml = "use-event-by-id", jml = (e) => {
  const t = `/${Pi.eventTypes}/${e}`;
  return go({
    queryKey: [qml, e],
    queryFn: () => He == null ? void 0 : He.get(t).then((n) => {
      if (n.data.status === qt)
        return n.data.data;
      throw new Error(n.data.error.message);
    })
  });
}, IF = ({
  month: e,
  monthCount: t,
  selectedDate: n,
  dayCount: o,
  prefetchNextMonth: r
}) => {
  const i = De(), a = e ? De(e) : i, s = a.add(t || 1, "month");
  let c, l;
  return o && o > 0 ? n ? (c = De(n).toISOString(), l = De(n).add(o, "day").toISOString()) : a.month() === i.month() ? (c = i.startOf("day").toISOString(), l = i.startOf("day").add(o, "day").toISOString()) : (c = a.startOf("month").toISOString(), l = a.startOf("month").add(o, "day").toISOString()) : (c = a.startOf("month").toISOString(), l = (r ? s : a).endOf("month").toISOString()), [c, l];
}, Fml = {
  metadata: null,
  theme: null,
  credentials: [],
  username: "john.doe",
  timeZone: "",
  bufferTime: 0,
  availability: [],
  id: 0,
  startTime: 0,
  endTime: 0,
  allSelectedCalendars: [],
  userLevelSelectedCalendars: [],
  schedules: [],
  defaultScheduleId: null,
  locale: "en",
  email: "john.doe@example.com",
  name: "John doe",
  destinationCalendar: null,
  hideBranding: !0,
  brandColor: "#797979",
  darkBrandColor: "#efefef",
  allowDynamicBooking: !0,
  timeFormat: 12,
  travelSchedules: [],
  locked: !1,
  isPlatformManaged: !1
}, Vml = [], Bml = {
  isDynamic: !0,
  periodCountCalendarDays: !0,
  periodStartDate: null,
  periodEndDate: null,
  beforeEventBuffer: 0,
  afterEventBuffer: 0,
  periodType: ka.UNLIMITED,
  periodDays: null,
  slotInterval: null,
  offsetStart: 0,
  locations: [{ type: nul }],
  customInputs: Vml,
  disableGuests: !0,
  minimumBookingNotice: 120,
  schedule: null,
  timeZone: null,
  successRedirectUrl: "",
  forwardParamsSuccessRedirect: !0,
  teamId: null,
  scheduleId: null,
  availability: [],
  price: 0,
  currency: "usd",
  schedulingType: aa.COLLECTIVE,
  seatsPerTimeSlot: null,
  seatsShowAttendees: null,
  seatsShowAvailabilityCount: null,
  disableCancelling: !1,
  disableRescheduling: !1,
  onlyShowFirstAvailableSlot: !1,
  allowReschedulingPastBookings: !1,
  allowReschedulingCancelledBookings: !1,
  hideOrganizerEmail: !1,
  showOptimizedSlots: !1,
  id: 0,
  hideCalendarNotes: !1,
  hideCalendarEventDetails: !1,
  recurringEvent: null,
  destinationCalendar: null,
  team: null,
  lockTimeZoneToggleOnBookingPage: !1,
  lockedTimeZone: null,
  requiresConfirmation: !1,
  requiresConfirmationForFreeEmail: !1,
  requiresBookerEmailVerification: !1,
  bookingLimits: null,
  maxActiveBookingsPerBooker: null,
  maxActiveBookingPerBookerOfferReschedule: !1,
  durationLimits: null,
  hidden: !1,
  userId: 0,
  parentId: null,
  parent: null,
  owner: null,
  workflows: [],
  users: [Fml],
  hosts: [],
  subsetOfHosts: [],
  metadata: dle.parse({}),
  bookingFields: [],
  assignAllTeamMembers: !1,
  assignRRMembersUsingSegment: !1,
  rrSegmentQueryValue: null,
  isRRWeightsEnabled: !1,
  rescheduleWithSameRoundRobinHost: !1,
  useEventTypeDestinationCalendarEmail: !1,
  secondaryEmailId: null,
  secondaryEmail: null,
  autoTranslateDescriptionEnabled: !1,
  fieldTranslations: [],
  maxLeadThreshold: null,
  includeNoShowInRRCalculation: !1,
  useEventLevelSelectedCalendars: !1,
  rrResetInterval: null,
  rrTimestampBasis: null,
  interfaceLanguage: null,
  customReplyToEmail: null,
  restrictionScheduleId: null,
  useBookerTimezone: !1,
  profileId: null,
  profile: null,
  requiresConfirmationWillBlockSlot: !1,
  canSendCalVideoTranscriptionEmails: !1,
  instantMeetingExpiryTimeOffsetInSeconds: 0,
  instantMeetingScheduleId: null,
  instantMeetingParameters: [],
  eventTypeColor: null,
  hostGroups: [],
  bookingRequiresAuthentication: !1,
  createdAt: null,
  updatedAt: null
};
({
  ...Bml,
  metadata: wF.parse({ multipleDuration: [15, 30, 45, 60, 90] })
});
const Uml = (e) => Array.isArray(e) ? e : e ? [e] : [], T_ = (e) => {
  e = Uml(e);
  const t = e.map((n) => n.replace(/( |%20|%2b)/gi, "+").split("+")).flat().filter(Boolean);
  return Array.prototype.concat(...t.map((n) => xf(n)));
}, Wml = "get-available-slots", Gml = ({
  enabled: e,
  ...t
}) => go({
  queryKey: [
    Wml,
    t.startTime,
    t.endTime,
    t.eventTypeId,
    t.eventTypeSlug,
    t.isTeamEvent ?? !1,
    t.teamId ?? !1,
    t.usernameList,
    t.routedTeamMemberIds,
    t.skipContactOwner,
    t._shouldServeCache,
    t.teamMemberEmail,
    t.embedConnectVersion ?? !1
  ],
  queryFn: () => _ae.get("/api/v2/slots/available", {
    params: t
  }).then((o) => {
    if (o.data.status === "success")
      return o.data.data;
    throw new Error(o.data.error.message);
  }),
  enabled: e
}), tJ = ({
  eventId: e,
  eventSlug: t
}) => ({
  eventId: e,
  eventSlug: t
}), Hml = ({
  month: e,
  timezone: t,
  username: n,
  eventSlug: o,
  eventId: r,
  selectedDate: i,
  prefetchNextMonth: a,
  duration: s,
  monthCount: c,
  dayCount: l,
  rescheduleUid: d,
  isTeamEvent: u,
  orgSlug: _,
  teamMemberEmail: p,
  useApiV2: f = !1,
  enabled: g = !0
}) => {
  const h = Ic((V) => V.state), [b, v] = IF({
    month: e,
    monthCount: c,
    dayCount: l,
    prefetchNextMonth: a,
    selectedDate: i
  }), $ = Ro.useSearchParams(), k = $ ? OF(new URLSearchParams($.toString())) : null, S = $ ? $.get("cal.skipContactOwner") === "true" : !1, O = $ == null ? void 0 : $.get("cal.cache"), I = O ? O === "true" : void 0, D = bo.useUtils(), M = $ == null ? void 0 : $.get("cal.routingFormResponseId"), N = $ == null ? void 0 : $.get("cal.queuedFormResponseId"), C = $ == null ? void 0 : $.get("email"), P = ($ == null ? void 0 : $.get("cal.skipSlotsFetch")) === "true", x = M ? parseInt(M, 10) : void 0, w = ($ == null ? void 0 : $.get("cal.embed.connectVersion")) || "0", E = {
    isTeamEvent: u,
    usernameList: T_(n ?? ""),
    // Prioritize slug over id, since slug is the first value we get available.
    // If we have a slug, we don't need to fetch the id.
    // TODO: are queries using eventTypeId faster? Even tho we lost time fetching the id with the slug.
    ...o ? { eventTypeSlug: o } : { eventTypeId: r ?? 0 },
    // @TODO: Old code fetched 2 days ago if we were fetching the current month.
    // Do we want / need to keep that behavior?
    startTime: b,
    // if `prefetchNextMonth` is true, two months are fetched at once.
    endTime: v,
    timeZone: t,
    duration: s ? `${s}` : void 0,
    rescheduleUid: d,
    orgSlug: _,
    teamMemberEmail: p,
    routedTeamMemberIds: k,
    skipContactOwner: S,
    _shouldServeCache: I,
    ...N ? { queuedFormResponseId: N } : { routingFormResponseId: x },
    email: C,
    // Ensures that connectVersion causes a refresh of the data
    ...w ? { embedConnectVersion: w } : {},
    _isDryRun: $ ? zF($) : !1
  }, T = {
    trpc: {
      context: {
        skipBatch: !0
      }
    },
    // It allows people who might not have the tab in focus earlier, to get latest available slots
    // It might not work correctly in iframes, so we have refetchInterval to take care of that.
    // But where it works, it should give user latest availability even if they come back to tab before refetchInterval.
    refetchOnWindowFocus: !0,
    // It allows long sitting users to get latest available slots
    refetchInterval: Umc * 1e3,
    enabled: !P && !!n && !!e && !!t && // Should only wait for one or the other, not both.
    (!!o || !!r || r === 0) && g
  }, z = f && !!u && T.enabled, j = Gml({
    ...E,
    enabled: z,
    duration: E.duration ? Number(E.duration) : void 0,
    routedTeamMemberIds: E.routedTeamMemberIds ?? void 0,
    teamMemberEmail: E.teamMemberEmail ?? void 0,
    eventTypeId: r ?? void 0
  }), q = bo.viewer.slots.getSchedule.useQuery(E, {
    ...T,
    // Only enable if we're not using API V2
    enabled: T.enabled && !z
  });
  return z && !j.failureReason ? (TM({
    bookerState: h,
    slotsQuery: j
  }), j.isSuccess && r && o && (Kn == null || Kn.fire(
    "availabilityLoaded",
    tJ({ eventId: r, eventSlug: o })
  )), {
    ...j,
    /**
     * Invalidates the request and resends it regardless of any other configuration including staleTime
     */
    invalidate: () => j.refetch()
  }) : (TM({
    bookerState: h,
    slotsQuery: q
  }), q.isSuccess && r && o && (Kn == null || Kn.fire(
    "availabilityLoaded",
    tJ({ eventId: r, eventSlug: o })
  )), {
    ...q,
    /**
     * Invalidates the request and resends it regardless of any other configuration including staleTime
     */
    invalidate: () => D.viewer.slots.getSchedule.invalidate(E)
  });
}, Wve = (e) => {
  const [t, n, o, r] = St(
    (a) => [a.username, a.eventSlug, a.isTeamEvent, a.org],
    Fr
  ), i = bo.viewer.public.event.useQuery(
    {
      username: t ?? "",
      eventSlug: n ?? "",
      isTeamEvent: o,
      org: r ?? null,
      fromRedirectOfNonOrgLink: e == null ? void 0 : e.fromRedirectOfNonOrgLink
    },
    {
      refetchOnWindowFocus: !1,
      enabled: !(e != null && e.disabled) && !!t && !!n
    }
  );
  return {
    data: i == null ? void 0 : i.data,
    isSuccess: i == null ? void 0 : i.isSuccess,
    isError: i == null ? void 0 : i.isError,
    isPending: i == null ? void 0 : i.isPending
  };
}, Kml = ({
  prefetchNextMonth: e,
  username: t,
  eventSlug: n,
  eventId: o,
  month: r,
  duration: i,
  monthCount: a,
  dayCount: s,
  selectedDate: c,
  orgSlug: l,
  teamMemberEmail: d,
  isTeamEvent: u,
  useApiV2: _ = !0
} = {}) => {
  const { timezone: p } = vd(), [f, g, h, b] = St(
    (S) => [S.username, S.eventSlug, S.month, S.selectedDuration],
    Fr
  ), v = O_(), $ = v == null ? void 0 : v.get("rescheduleUid"), k = Hml({
    username: f ?? t,
    eventSlug: g ?? n,
    eventId: o,
    timezone: p,
    selectedDate: c,
    prefetchNextMonth: e,
    monthCount: a,
    dayCount: s,
    rescheduleUid: $,
    month: h ?? r,
    duration: b ?? i,
    isTeamEvent: u,
    orgSlug: l,
    teamMemberEmail: d,
    useApiV2: _
  });
  return {
    data: k == null ? void 0 : k.data,
    isPending: k == null ? void 0 : k.isPending,
    isError: k == null ? void 0 : k.isError,
    isSuccess: k == null ? void 0 : k.isSuccess,
    isLoading: k == null ? void 0 : k.isLoading,
    invalidate: k == null ? void 0 : k.invalidate
  };
}, Yml = ({ children: e, onCancel: t }) => {
  const { data: n } = Wve();
  return /* @__PURE__ */ m(Gve, { child: e, eventLength: n == null ? void 0 : n.length, onCancel: t });
}, Zml = ({
  children: e,
  onCancel: t
}) => {
  const n = St((r) => r.eventId), { data: o } = jml(n);
  return /* @__PURE__ */ m(Gve, { child: e, eventLength: o == null ? void 0 : o.lengthInMinutes, onCancel: t });
}, Gve = ({
  child: e,
  eventLength: t
}) => {
  const { i18n: n, t: o } = Fe(), r = St((c) => c.selectedTimeslot), i = St((c) => c.selectedDuration), { timeFormat: a, timezone: s } = vd();
  return r ? /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y("h1", { className: "font-cal text-emphasis text-xl leading-5", children: [
      o("confirm_your_details"),
      " "
    ] }),
    /* @__PURE__ */ Y("div", { className: "my-4 flex flex-wrap gap-2 rounded-md leading-none", children: [
      /* @__PURE__ */ m(Nr, { variant: "grayWithoutHover", startIcon: "calendar", size: "lg", children: /* @__PURE__ */ m(
        qpl,
        {
          date: r,
          timeFormat: a,
          timeZone: s,
          language: n.language
        }
      ) }),
      (i || t) && /* @__PURE__ */ m(Nr, { variant: "grayWithoutHover", startIcon: "clock", size: "lg", children: /* @__PURE__ */ m("span", { children: dL(i || t, o) }) })
    ] }),
    e
  ] }) : null;
}, Qml = ({
  visible: e,
  onCancel: t,
  children: n
}) => {
  const o = Zo();
  return /* @__PURE__ */ m(Gi, { open: e, onOpenChange: t, children: /* @__PURE__ */ m(
    Ei,
    {
      type: void 0,
      enableOverflow: !0,
      className: "[&_.modalsticky]:border-t-subtle [&_.modalsticky]:bg-default max-h-[80vh] pb-0 [&_.modalsticky]:sticky [&_.modalsticky]:bottom-0 [&_.modalsticky]:left-0 [&_.modalsticky]:right-0 [&_.modalsticky]:-mx-8 [&_.modalsticky]:border-t [&_.modalsticky]:px-8 [&_.modalsticky]:py-4",
      children: o ? /* @__PURE__ */ m(Zml, { onCancel: t, children: n }) : /* @__PURE__ */ m(Yml, { onCancel: t, children: n })
    }
  ) });
}, Jml = ({
  browsingDate: e,
  nonEmptyScheduleDays: t,
  onMonthChange: n,
  isLoading: o
}) => {
  if (o)
    return {
      moveToNextMonthOnNoAvailability: () => {
      }
    };
  const r = t.filter(
    (a) => De(a).isSame(e, "month")
  );
  return {
    moveToNextMonthOnNoAvailability: () => {
      const a = De().startOf("month").format("YYYY-MM"), s = e.format("YYYY-MM");
      a != s || r.length || n(e.add(1, "month"));
    }
  };
}, nJ = ({
  event: e,
  slots: t = {},
  isLoading: n,
  classNames: o,
  scrollToTimeSlots: r,
  showNoAvailabilityDialog: i
}) => {
  var $, k, S;
  const { i18n: a } = Fe(), [s, c, l] = St(
    (O) => [O.month, O.selectedDate, O.layout],
    Fr
  ), [d, u, _] = St(
    (O) => [O.setSelectedDate, O.setMonth, O.setDayCount],
    Fr
  ), p = (O) => {
    u(O.format("YYYY-MM")), d({ date: O.format("YYYY-MM-DD") }), _(null);
  }, f = dC(t), g = s ? De(s) : De().startOf("month"), { moveToNextMonthOnNoAvailability: h } = Jml({
    browsingDate: g,
    nonEmptyScheduleDays: f,
    onMonthChange: p,
    isLoading: n ?? !0
  });
  h();
  const b = l !== "month_view" && l !== "mobile", v = {
    periodType: "UNLIMITED",
    periodStartDate: null,
    periodEndDate: null,
    periodDays: null,
    periodCountCalendarDays: !1,
    ...(e == null ? void 0 : e.data) && {
      periodType: e.data.periodType,
      periodStartDate: e.data.periodStartDate,
      periodEndDate: e.data.periodEndDate,
      periodDays: e.data.periodDays,
      periodCountCalendarDays: e.data.periodCountCalendarDays
    }
  };
  return /* @__PURE__ */ m(
    _me,
    {
      customClassNames: {
        datePickerTitle: o == null ? void 0 : o.datePickerTitle,
        datePickerDays: o == null ? void 0 : o.datePickerDays,
        datePickersDates: o == null ? void 0 : o.datePickerDate,
        datePickerDatesActive: o == null ? void 0 : o.datePickerDatesActive,
        datePickerToggle: o == null ? void 0 : o.datePickerToggle
      },
      className: o == null ? void 0 : o.datePickerContainer,
      isLoading: n,
      onChange: (O, I) => {
        d({
          date: O === null ? O : O.format("YYYY-MM-DD"),
          omitUpdatingParams: I,
          preventMonthSwitching: !b
          // Prevent month switching when in monthly view
        });
      },
      onMonthChange: p,
      includedDates: f,
      locale: a.language,
      browsingDate: s ? De(s) : void 0,
      selected: De(c),
      weekStart: eme((S = (k = ($ = e == null ? void 0 : e.data) == null ? void 0 : $.subsetOfUsers) == null ? void 0 : k[0]) == null ? void 0 : S.weekStart),
      slots: t,
      scrollToTimeSlots: r,
      periodData: v,
      isCompact: b,
      showNoAvailabilityDialog: i
    }
  );
}, Xml = ({ isEmbed: e }) => {
  const { t } = Fe(), [n, o] = ze(!0);
  return n ? /* @__PURE__ */ m(
    "div",
    {
      onClick: () => o(!1),
      className: `bg-default border-subtle fixed left-1/2 ${e ? "top-0" : "top-4"} z-50 -translate-x-1/2 transform cursor-pointer items-center gap-3 rounded-xl border p-3 text-sm shadow-md`,
      children: /* @__PURE__ */ Y("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ m(ot, { name: "info", className: "h-5 w-5 text-orange-500" }) }),
        /* @__PURE__ */ m("div", { className: "text-emphasis font-medium", "data-testid": "dry-run-msg", children: t("dry_run_mode_active") })
      ] })
    }
  ) : null;
};
var ar = {};
const efl = "Á", tfl = "á", nfl = "Ă", ofl = "ă", rfl = "∾", ifl = "∿", afl = "∾̳", sfl = "Â", cfl = "â", lfl = "´", dfl = "А", ufl = "а", _fl = "Æ", pfl = "æ", mfl = "⁡", ffl = "𝔄", gfl = "𝔞", hfl = "À", vfl = "à", bfl = "ℵ", yfl = "ℵ", $fl = "Α", wfl = "α", kfl = "Ā", Sfl = "ā", xfl = "⨿", Efl = "&", Tfl = "&", Afl = "⩕", Cfl = "⩓", zfl = "∧", Ofl = "⩜", Pfl = "⩘", Ifl = "⩚", Rfl = "∠", Nfl = "⦤", Dfl = "∠", Mfl = "⦨", Lfl = "⦩", qfl = "⦪", jfl = "⦫", Ffl = "⦬", Vfl = "⦭", Bfl = "⦮", Ufl = "⦯", Wfl = "∡", Gfl = "∟", Hfl = "⊾", Kfl = "⦝", Yfl = "∢", Zfl = "Å", Qfl = "⍼", Jfl = "Ą", Xfl = "ą", egl = "𝔸", tgl = "𝕒", ngl = "⩯", ogl = "≈", rgl = "⩰", igl = "≊", agl = "≋", sgl = "'", cgl = "⁡", lgl = "≈", dgl = "≊", ugl = "Å", _gl = "å", pgl = "𝒜", mgl = "𝒶", fgl = "≔", ggl = "*", hgl = "≈", vgl = "≍", bgl = "Ã", ygl = "ã", $gl = "Ä", wgl = "ä", kgl = "∳", Sgl = "⨑", xgl = "≌", Egl = "϶", Tgl = "‵", Agl = "∽", Cgl = "⋍", zgl = "∖", Ogl = "⫧", Pgl = "⊽", Igl = "⌅", Rgl = "⌆", Ngl = "⌅", Dgl = "⎵", Mgl = "⎶", Lgl = "≌", qgl = "Б", jgl = "б", Fgl = "„", Vgl = "∵", Bgl = "∵", Ugl = "∵", Wgl = "⦰", Ggl = "϶", Hgl = "ℬ", Kgl = "ℬ", Ygl = "Β", Zgl = "β", Qgl = "ℶ", Jgl = "≬", Xgl = "𝔅", ehl = "𝔟", thl = "⋂", nhl = "◯", ohl = "⋃", rhl = "⨀", ihl = "⨁", ahl = "⨂", shl = "⨆", chl = "★", lhl = "▽", dhl = "△", uhl = "⨄", _hl = "⋁", phl = "⋀", mhl = "⤍", fhl = "⧫", ghl = "▪", hhl = "▴", vhl = "▾", bhl = "◂", yhl = "▸", $hl = "␣", whl = "▒", khl = "░", Shl = "▓", xhl = "█", Ehl = "=⃥", Thl = "≡⃥", Ahl = "⫭", Chl = "⌐", zhl = "𝔹", Ohl = "𝕓", Phl = "⊥", Ihl = "⊥", Rhl = "⋈", Nhl = "⧉", Dhl = "┐", Mhl = "╕", Lhl = "╖", qhl = "╗", jhl = "┌", Fhl = "╒", Vhl = "╓", Bhl = "╔", Uhl = "─", Whl = "═", Ghl = "┬", Hhl = "╤", Khl = "╥", Yhl = "╦", Zhl = "┴", Qhl = "╧", Jhl = "╨", Xhl = "╩", evl = "⊟", tvl = "⊞", nvl = "⊠", ovl = "┘", rvl = "╛", ivl = "╜", avl = "╝", svl = "└", cvl = "╘", lvl = "╙", dvl = "╚", uvl = "│", _vl = "║", pvl = "┼", mvl = "╪", fvl = "╫", gvl = "╬", hvl = "┤", vvl = "╡", bvl = "╢", yvl = "╣", $vl = "├", wvl = "╞", kvl = "╟", Svl = "╠", xvl = "‵", Evl = "˘", Tvl = "˘", Avl = "¦", Cvl = "𝒷", zvl = "ℬ", Ovl = "⁏", Pvl = "∽", Ivl = "⋍", Rvl = "⧅", Nvl = "\\", Dvl = "⟈", Mvl = "•", Lvl = "•", qvl = "≎", jvl = "⪮", Fvl = "≏", Vvl = "≎", Bvl = "≏", Uvl = "Ć", Wvl = "ć", Gvl = "⩄", Hvl = "⩉", Kvl = "⩋", Yvl = "∩", Zvl = "⋒", Qvl = "⩇", Jvl = "⩀", Xvl = "ⅅ", ebl = "∩︀", tbl = "⁁", nbl = "ˇ", obl = "ℭ", rbl = "⩍", ibl = "Č", abl = "č", sbl = "Ç", cbl = "ç", lbl = "Ĉ", dbl = "ĉ", ubl = "∰", _bl = "⩌", pbl = "⩐", mbl = "Ċ", fbl = "ċ", gbl = "¸", hbl = "¸", vbl = "⦲", bbl = "¢", ybl = "·", $bl = "·", wbl = "𝔠", kbl = "ℭ", Sbl = "Ч", xbl = "ч", Ebl = "✓", Tbl = "✓", Abl = "Χ", Cbl = "χ", zbl = "ˆ", Obl = "≗", Pbl = "↺", Ibl = "↻", Rbl = "⊛", Nbl = "⊚", Dbl = "⊝", Mbl = "⊙", Lbl = "®", qbl = "Ⓢ", jbl = "⊖", Fbl = "⊕", Vbl = "⊗", Bbl = "○", Ubl = "⧃", Wbl = "≗", Gbl = "⨐", Hbl = "⫯", Kbl = "⧂", Ybl = "∲", Zbl = "”", Qbl = "’", Jbl = "♣", Xbl = "♣", eyl = ":", tyl = "∷", nyl = "⩴", oyl = "≔", ryl = "≔", iyl = ",", ayl = "@", syl = "∁", cyl = "∘", lyl = "∁", dyl = "ℂ", uyl = "≅", _yl = "⩭", pyl = "≡", myl = "∮", fyl = "∯", gyl = "∮", hyl = "𝕔", vyl = "ℂ", byl = "∐", yyl = "∐", $yl = "©", wyl = "©", kyl = "℗", Syl = "∳", xyl = "↵", Eyl = "✗", Tyl = "⨯", Ayl = "𝒞", Cyl = "𝒸", zyl = "⫏", Oyl = "⫑", Pyl = "⫐", Iyl = "⫒", Ryl = "⋯", Nyl = "⤸", Dyl = "⤵", Myl = "⋞", Lyl = "⋟", qyl = "↶", jyl = "⤽", Fyl = "⩈", Vyl = "⩆", Byl = "≍", Uyl = "∪", Wyl = "⋓", Gyl = "⩊", Hyl = "⊍", Kyl = "⩅", Yyl = "∪︀", Zyl = "↷", Qyl = "⤼", Jyl = "⋞", Xyl = "⋟", e$l = "⋎", t$l = "⋏", n$l = "¤", o$l = "↶", r$l = "↷", i$l = "⋎", a$l = "⋏", s$l = "∲", c$l = "∱", l$l = "⌭", d$l = "†", u$l = "‡", _$l = "ℸ", p$l = "↓", m$l = "↡", f$l = "⇓", g$l = "‐", h$l = "⫤", v$l = "⊣", b$l = "⤏", y$l = "˝", $$l = "Ď", w$l = "ď", k$l = "Д", S$l = "д", x$l = "‡", E$l = "⇊", T$l = "ⅅ", A$l = "ⅆ", C$l = "⤑", z$l = "⩷", O$l = "°", P$l = "∇", I$l = "Δ", R$l = "δ", N$l = "⦱", D$l = "⥿", M$l = "𝔇", L$l = "𝔡", q$l = "⥥", j$l = "⇃", F$l = "⇂", V$l = "´", B$l = "˙", U$l = "˝", W$l = "`", G$l = "˜", H$l = "⋄", K$l = "⋄", Y$l = "⋄", Z$l = "♦", Q$l = "♦", J$l = "¨", X$l = "ⅆ", ewl = "ϝ", twl = "⋲", nwl = "÷", owl = "÷", rwl = "⋇", iwl = "⋇", awl = "Ђ", swl = "ђ", cwl = "⌞", lwl = "⌍", dwl = "$", uwl = "𝔻", _wl = "𝕕", pwl = "¨", mwl = "˙", fwl = "⃜", gwl = "≐", hwl = "≑", vwl = "≐", bwl = "∸", ywl = "∔", $wl = "⊡", wwl = "⌆", kwl = "∯", Swl = "¨", xwl = "⇓", Ewl = "⇐", Twl = "⇔", Awl = "⫤", Cwl = "⟸", zwl = "⟺", Owl = "⟹", Pwl = "⇒", Iwl = "⊨", Rwl = "⇑", Nwl = "⇕", Dwl = "∥", Mwl = "⤓", Lwl = "↓", qwl = "↓", jwl = "⇓", Fwl = "⇵", Vwl = "̑", Bwl = "⇊", Uwl = "⇃", Wwl = "⇂", Gwl = "⥐", Hwl = "⥞", Kwl = "⥖", Ywl = "↽", Zwl = "⥟", Qwl = "⥗", Jwl = "⇁", Xwl = "↧", e0l = "⊤", t0l = "⤐", n0l = "⌟", o0l = "⌌", r0l = "𝒟", i0l = "𝒹", a0l = "Ѕ", s0l = "ѕ", c0l = "⧶", l0l = "Đ", d0l = "đ", u0l = "⋱", _0l = "▿", p0l = "▾", m0l = "⇵", f0l = "⥯", g0l = "⦦", h0l = "Џ", v0l = "џ", b0l = "⟿", y0l = "É", $0l = "é", w0l = "⩮", k0l = "Ě", S0l = "ě", x0l = "Ê", E0l = "ê", T0l = "≖", A0l = "≕", C0l = "Э", z0l = "э", O0l = "⩷", P0l = "Ė", I0l = "ė", R0l = "≑", N0l = "ⅇ", D0l = "≒", M0l = "𝔈", L0l = "𝔢", q0l = "⪚", j0l = "È", F0l = "è", V0l = "⪖", B0l = "⪘", U0l = "⪙", W0l = "∈", G0l = "⏧", H0l = "ℓ", K0l = "⪕", Y0l = "⪗", Z0l = "Ē", Q0l = "ē", J0l = "∅", X0l = "∅", ekl = "◻", tkl = "∅", nkl = "▫", okl = " ", rkl = " ", ikl = " ", akl = "Ŋ", skl = "ŋ", ckl = " ", lkl = "Ę", dkl = "ę", ukl = "𝔼", _kl = "𝕖", pkl = "⋕", mkl = "⧣", fkl = "⩱", gkl = "ε", hkl = "Ε", vkl = "ε", bkl = "ϵ", ykl = "≖", $kl = "≕", wkl = "≂", kkl = "⪖", Skl = "⪕", xkl = "⩵", Ekl = "=", Tkl = "≂", Akl = "≟", Ckl = "⇌", zkl = "≡", Okl = "⩸", Pkl = "⧥", Ikl = "⥱", Rkl = "≓", Nkl = "ℯ", Dkl = "ℰ", Mkl = "≐", Lkl = "⩳", qkl = "≂", jkl = "Η", Fkl = "η", Vkl = "Ð", Bkl = "ð", Ukl = "Ë", Wkl = "ë", Gkl = "€", Hkl = "!", Kkl = "∃", Ykl = "∃", Zkl = "ℰ", Qkl = "ⅇ", Jkl = "ⅇ", Xkl = "≒", e1l = "Ф", t1l = "ф", n1l = "♀", o1l = "ﬃ", r1l = "ﬀ", i1l = "ﬄ", a1l = "𝔉", s1l = "𝔣", c1l = "ﬁ", l1l = "◼", d1l = "▪", u1l = "fj", _1l = "♭", p1l = "ﬂ", m1l = "▱", f1l = "ƒ", g1l = "𝔽", h1l = "𝕗", v1l = "∀", b1l = "∀", y1l = "⋔", $1l = "⫙", w1l = "ℱ", k1l = "⨍", S1l = "½", x1l = "⅓", E1l = "¼", T1l = "⅕", A1l = "⅙", C1l = "⅛", z1l = "⅔", O1l = "⅖", P1l = "¾", I1l = "⅗", R1l = "⅜", N1l = "⅘", D1l = "⅚", M1l = "⅝", L1l = "⅞", q1l = "⁄", j1l = "⌢", F1l = "𝒻", V1l = "ℱ", B1l = "ǵ", U1l = "Γ", W1l = "γ", G1l = "Ϝ", H1l = "ϝ", K1l = "⪆", Y1l = "Ğ", Z1l = "ğ", Q1l = "Ģ", J1l = "Ĝ", X1l = "ĝ", e2l = "Г", t2l = "г", n2l = "Ġ", o2l = "ġ", r2l = "≥", i2l = "≧", a2l = "⪌", s2l = "⋛", c2l = "≥", l2l = "≧", d2l = "⩾", u2l = "⪩", _2l = "⩾", p2l = "⪀", m2l = "⪂", f2l = "⪄", g2l = "⋛︀", h2l = "⪔", v2l = "𝔊", b2l = "𝔤", y2l = "≫", $2l = "⋙", w2l = "⋙", k2l = "ℷ", S2l = "Ѓ", x2l = "ѓ", E2l = "⪥", T2l = "≷", A2l = "⪒", C2l = "⪤", z2l = "⪊", O2l = "⪊", P2l = "⪈", I2l = "≩", R2l = "⪈", N2l = "≩", D2l = "⋧", M2l = "𝔾", L2l = "𝕘", q2l = "`", j2l = "≥", F2l = "⋛", V2l = "≧", B2l = "⪢", U2l = "≷", W2l = "⩾", G2l = "≳", H2l = "𝒢", K2l = "ℊ", Y2l = "≳", Z2l = "⪎", Q2l = "⪐", J2l = "⪧", X2l = "⩺", eSl = ">", tSl = ">", nSl = "≫", oSl = "⋗", rSl = "⦕", iSl = "⩼", aSl = "⪆", sSl = "⥸", cSl = "⋗", lSl = "⋛", dSl = "⪌", uSl = "≷", _Sl = "≳", pSl = "≩︀", mSl = "≩︀", fSl = "ˇ", gSl = " ", hSl = "½", vSl = "ℋ", bSl = "Ъ", ySl = "ъ", $Sl = "⥈", wSl = "↔", kSl = "⇔", SSl = "↭", xSl = "^", ESl = "ℏ", TSl = "Ĥ", ASl = "ĥ", CSl = "♥", zSl = "♥", OSl = "…", PSl = "⊹", ISl = "𝔥", RSl = "ℌ", NSl = "ℋ", DSl = "⤥", MSl = "⤦", LSl = "⇿", qSl = "∻", jSl = "↩", FSl = "↪", VSl = "𝕙", BSl = "ℍ", USl = "―", WSl = "─", GSl = "𝒽", HSl = "ℋ", KSl = "ℏ", YSl = "Ħ", ZSl = "ħ", QSl = "≎", JSl = "≏", XSl = "⁃", exl = "‐", txl = "Í", nxl = "í", oxl = "⁣", rxl = "Î", ixl = "î", axl = "И", sxl = "и", cxl = "İ", lxl = "Е", dxl = "е", uxl = "¡", _xl = "⇔", pxl = "𝔦", mxl = "ℑ", fxl = "Ì", gxl = "ì", hxl = "ⅈ", vxl = "⨌", bxl = "∭", yxl = "⧜", $xl = "℩", wxl = "Ĳ", kxl = "ĳ", Sxl = "Ī", xxl = "ī", Exl = "ℑ", Txl = "ⅈ", Axl = "ℐ", Cxl = "ℑ", zxl = "ı", Oxl = "ℑ", Pxl = "⊷", Ixl = "Ƶ", Rxl = "⇒", Nxl = "℅", Dxl = "∞", Mxl = "⧝", Lxl = "ı", qxl = "⊺", jxl = "∫", Fxl = "∬", Vxl = "ℤ", Bxl = "∫", Uxl = "⊺", Wxl = "⋂", Gxl = "⨗", Hxl = "⨼", Kxl = "⁣", Yxl = "⁢", Zxl = "Ё", Qxl = "ё", Jxl = "Į", Xxl = "į", eEl = "𝕀", tEl = "𝕚", nEl = "Ι", oEl = "ι", rEl = "⨼", iEl = "¿", aEl = "𝒾", sEl = "ℐ", cEl = "∈", lEl = "⋵", dEl = "⋹", uEl = "⋴", _El = "⋳", pEl = "∈", mEl = "⁢", fEl = "Ĩ", gEl = "ĩ", hEl = "І", vEl = "і", bEl = "Ï", yEl = "ï", $El = "Ĵ", wEl = "ĵ", kEl = "Й", SEl = "й", xEl = "𝔍", EEl = "𝔧", TEl = "ȷ", AEl = "𝕁", CEl = "𝕛", zEl = "𝒥", OEl = "𝒿", PEl = "Ј", IEl = "ј", REl = "Є", NEl = "є", DEl = "Κ", MEl = "κ", LEl = "ϰ", qEl = "Ķ", jEl = "ķ", FEl = "К", VEl = "к", BEl = "𝔎", UEl = "𝔨", WEl = "ĸ", GEl = "Х", HEl = "х", KEl = "Ќ", YEl = "ќ", ZEl = "𝕂", QEl = "𝕜", JEl = "𝒦", XEl = "𝓀", eTl = "⇚", tTl = "Ĺ", nTl = "ĺ", oTl = "⦴", rTl = "ℒ", iTl = "Λ", aTl = "λ", sTl = "⟨", cTl = "⟪", lTl = "⦑", dTl = "⟨", uTl = "⪅", _Tl = "ℒ", pTl = "«", mTl = "⇤", fTl = "⤟", gTl = "←", hTl = "↞", vTl = "⇐", bTl = "⤝", yTl = "↩", $Tl = "↫", wTl = "⤹", kTl = "⥳", STl = "↢", xTl = "⤙", ETl = "⤛", TTl = "⪫", ATl = "⪭", CTl = "⪭︀", zTl = "⤌", OTl = "⤎", PTl = "❲", ITl = "{", RTl = "[", NTl = "⦋", DTl = "⦏", MTl = "⦍", LTl = "Ľ", qTl = "ľ", jTl = "Ļ", FTl = "ļ", VTl = "⌈", BTl = "{", UTl = "Л", WTl = "л", GTl = "⤶", HTl = "“", KTl = "„", YTl = "⥧", ZTl = "⥋", QTl = "↲", JTl = "≤", XTl = "≦", eAl = "⟨", tAl = "⇤", nAl = "←", oAl = "←", rAl = "⇐", iAl = "⇆", aAl = "↢", sAl = "⌈", cAl = "⟦", lAl = "⥡", dAl = "⥙", uAl = "⇃", _Al = "⌊", pAl = "↽", mAl = "↼", fAl = "⇇", gAl = "↔", hAl = "↔", vAl = "⇔", bAl = "⇆", yAl = "⇋", $Al = "↭", wAl = "⥎", kAl = "↤", SAl = "⊣", xAl = "⥚", EAl = "⋋", TAl = "⧏", AAl = "⊲", CAl = "⊴", zAl = "⥑", OAl = "⥠", PAl = "⥘", IAl = "↿", RAl = "⥒", NAl = "↼", DAl = "⪋", MAl = "⋚", LAl = "≤", qAl = "≦", jAl = "⩽", FAl = "⪨", VAl = "⩽", BAl = "⩿", UAl = "⪁", WAl = "⪃", GAl = "⋚︀", HAl = "⪓", KAl = "⪅", YAl = "⋖", ZAl = "⋚", QAl = "⪋", JAl = "⋚", XAl = "≦", eCl = "≶", tCl = "≶", nCl = "⪡", oCl = "≲", rCl = "⩽", iCl = "≲", aCl = "⥼", sCl = "⌊", cCl = "𝔏", lCl = "𝔩", dCl = "≶", uCl = "⪑", _Cl = "⥢", pCl = "↽", mCl = "↼", fCl = "⥪", gCl = "▄", hCl = "Љ", vCl = "љ", bCl = "⇇", yCl = "≪", $Cl = "⋘", wCl = "⌞", kCl = "⇚", SCl = "⥫", xCl = "◺", ECl = "Ŀ", TCl = "ŀ", ACl = "⎰", CCl = "⎰", zCl = "⪉", OCl = "⪉", PCl = "⪇", ICl = "≨", RCl = "⪇", NCl = "≨", DCl = "⋦", MCl = "⟬", LCl = "⇽", qCl = "⟦", jCl = "⟵", FCl = "⟵", VCl = "⟸", BCl = "⟷", UCl = "⟷", WCl = "⟺", GCl = "⟼", HCl = "⟶", KCl = "⟶", YCl = "⟹", ZCl = "↫", QCl = "↬", JCl = "⦅", XCl = "𝕃", ezl = "𝕝", tzl = "⨭", nzl = "⨴", ozl = "∗", rzl = "_", izl = "↙", azl = "↘", szl = "◊", czl = "◊", lzl = "⧫", dzl = "(", uzl = "⦓", _zl = "⇆", pzl = "⌟", mzl = "⇋", fzl = "⥭", gzl = "‎", hzl = "⊿", vzl = "‹", bzl = "𝓁", yzl = "ℒ", $zl = "↰", wzl = "↰", kzl = "≲", Szl = "⪍", xzl = "⪏", Ezl = "[", Tzl = "‘", Azl = "‚", Czl = "Ł", zzl = "ł", Ozl = "⪦", Pzl = "⩹", Izl = "<", Rzl = "<", Nzl = "≪", Dzl = "⋖", Mzl = "⋋", Lzl = "⋉", qzl = "⥶", jzl = "⩻", Fzl = "◃", Vzl = "⊴", Bzl = "◂", Uzl = "⦖", Wzl = "⥊", Gzl = "⥦", Hzl = "≨︀", Kzl = "≨︀", Yzl = "¯", Zzl = "♂", Qzl = "✠", Jzl = "✠", Xzl = "↦", eOl = "↦", tOl = "↧", nOl = "↤", oOl = "↥", rOl = "▮", iOl = "⨩", aOl = "М", sOl = "м", cOl = "—", lOl = "∺", dOl = "∡", uOl = " ", _Ol = "ℳ", pOl = "𝔐", mOl = "𝔪", fOl = "℧", gOl = "µ", hOl = "*", vOl = "⫰", bOl = "∣", yOl = "·", $Ol = "⊟", wOl = "−", kOl = "∸", SOl = "⨪", xOl = "∓", EOl = "⫛", TOl = "…", AOl = "∓", COl = "⊧", zOl = "𝕄", OOl = "𝕞", POl = "∓", IOl = "𝓂", ROl = "ℳ", NOl = "∾", DOl = "Μ", MOl = "μ", LOl = "⊸", qOl = "⊸", jOl = "∇", FOl = "Ń", VOl = "ń", BOl = "∠⃒", UOl = "≉", WOl = "⩰̸", GOl = "≋̸", HOl = "ŉ", KOl = "≉", YOl = "♮", ZOl = "ℕ", QOl = "♮", JOl = " ", XOl = "≎̸", e4l = "≏̸", t4l = "⩃", n4l = "Ň", o4l = "ň", r4l = "Ņ", i4l = "ņ", a4l = "≇", s4l = "⩭̸", c4l = "⩂", l4l = "Н", d4l = "н", u4l = "–", _4l = "⤤", p4l = "↗", m4l = "⇗", f4l = "↗", g4l = "≠", h4l = "≐̸", v4l = "​", b4l = "​", y4l = "​", $4l = "​", w4l = "≢", k4l = "⤨", S4l = "≂̸", x4l = "≫", E4l = "≪", T4l = `
`, A4l = "∄", C4l = "∄", z4l = "𝔑", O4l = "𝔫", P4l = "≧̸", I4l = "≱", R4l = "≱", N4l = "≧̸", D4l = "⩾̸", M4l = "⩾̸", L4l = "⋙̸", q4l = "≵", j4l = "≫⃒", F4l = "≯", V4l = "≯", B4l = "≫̸", U4l = "↮", W4l = "⇎", G4l = "⫲", H4l = "∋", K4l = "⋼", Y4l = "⋺", Z4l = "∋", Q4l = "Њ", J4l = "њ", X4l = "↚", e3l = "⇍", t3l = "‥", n3l = "≦̸", o3l = "≰", r3l = "↚", i3l = "⇍", a3l = "↮", s3l = "⇎", c3l = "≰", l3l = "≦̸", d3l = "⩽̸", u3l = "⩽̸", _3l = "≮", p3l = "⋘̸", m3l = "≴", f3l = "≪⃒", g3l = "≮", h3l = "⋪", v3l = "⋬", b3l = "≪̸", y3l = "∤", $3l = "⁠", w3l = " ", k3l = "𝕟", S3l = "ℕ", x3l = "⫬", E3l = "¬", T3l = "≢", A3l = "≭", C3l = "∦", z3l = "∉", O3l = "≠", P3l = "≂̸", I3l = "∄", R3l = "≯", N3l = "≱", D3l = "≧̸", M3l = "≫̸", L3l = "≹", q3l = "⩾̸", j3l = "≵", F3l = "≎̸", V3l = "≏̸", B3l = "∉", U3l = "⋵̸", W3l = "⋹̸", G3l = "∉", H3l = "⋷", K3l = "⋶", Y3l = "⧏̸", Z3l = "⋪", Q3l = "⋬", J3l = "≮", X3l = "≰", e6l = "≸", t6l = "≪̸", n6l = "⩽̸", o6l = "≴", r6l = "⪢̸", i6l = "⪡̸", a6l = "∌", s6l = "∌", c6l = "⋾", l6l = "⋽", d6l = "⊀", u6l = "⪯̸", _6l = "⋠", p6l = "∌", m6l = "⧐̸", f6l = "⋫", g6l = "⋭", h6l = "⊏̸", v6l = "⋢", b6l = "⊐̸", y6l = "⋣", $6l = "⊂⃒", w6l = "⊈", k6l = "⊁", S6l = "⪰̸", x6l = "⋡", E6l = "≿̸", T6l = "⊃⃒", A6l = "⊉", C6l = "≁", z6l = "≄", O6l = "≇", P6l = "≉", I6l = "∤", R6l = "∦", N6l = "∦", D6l = "⫽⃥", M6l = "∂̸", L6l = "⨔", q6l = "⊀", j6l = "⋠", F6l = "⊀", V6l = "⪯̸", B6l = "⪯̸", U6l = "⤳̸", W6l = "↛", G6l = "⇏", H6l = "↝̸", K6l = "↛", Y6l = "⇏", Z6l = "⋫", Q6l = "⋭", J6l = "⊁", X6l = "⋡", e5l = "⪰̸", t5l = "𝒩", n5l = "𝓃", o5l = "∤", r5l = "∦", i5l = "≁", a5l = "≄", s5l = "≄", c5l = "∤", l5l = "∦", d5l = "⋢", u5l = "⋣", _5l = "⊄", p5l = "⫅̸", m5l = "⊈", f5l = "⊂⃒", g5l = "⊈", h5l = "⫅̸", v5l = "⊁", b5l = "⪰̸", y5l = "⊅", $5l = "⫆̸", w5l = "⊉", k5l = "⊃⃒", S5l = "⊉", x5l = "⫆̸", E5l = "≹", T5l = "Ñ", A5l = "ñ", C5l = "≸", z5l = "⋪", O5l = "⋬", P5l = "⋫", I5l = "⋭", R5l = "Ν", N5l = "ν", D5l = "#", M5l = "№", L5l = " ", q5l = "≍⃒", j5l = "⊬", F5l = "⊭", V5l = "⊮", B5l = "⊯", U5l = "≥⃒", W5l = ">⃒", G5l = "⤄", H5l = "⧞", K5l = "⤂", Y5l = "≤⃒", Z5l = "<⃒", Q5l = "⊴⃒", J5l = "⤃", X5l = "⊵⃒", ePl = "∼⃒", tPl = "⤣", nPl = "↖", oPl = "⇖", rPl = "↖", iPl = "⤧", aPl = "Ó", sPl = "ó", cPl = "⊛", lPl = "Ô", dPl = "ô", uPl = "⊚", _Pl = "О", pPl = "о", mPl = "⊝", fPl = "Ő", gPl = "ő", hPl = "⨸", vPl = "⊙", bPl = "⦼", yPl = "Œ", $Pl = "œ", wPl = "⦿", kPl = "𝔒", SPl = "𝔬", xPl = "˛", EPl = "Ò", TPl = "ò", APl = "⧁", CPl = "⦵", zPl = "Ω", OPl = "∮", PPl = "↺", IPl = "⦾", RPl = "⦻", NPl = "‾", DPl = "⧀", MPl = "Ō", LPl = "ō", qPl = "Ω", jPl = "ω", FPl = "Ο", VPl = "ο", BPl = "⦶", UPl = "⊖", WPl = "𝕆", GPl = "𝕠", HPl = "⦷", KPl = "“", YPl = "‘", ZPl = "⦹", QPl = "⊕", JPl = "↻", XPl = "⩔", eIl = "∨", tIl = "⩝", nIl = "ℴ", oIl = "ℴ", rIl = "ª", iIl = "º", aIl = "⊶", sIl = "⩖", cIl = "⩗", lIl = "⩛", dIl = "Ⓢ", uIl = "𝒪", _Il = "ℴ", pIl = "Ø", mIl = "ø", fIl = "⊘", gIl = "Õ", hIl = "õ", vIl = "⨶", bIl = "⨷", yIl = "⊗", $Il = "Ö", wIl = "ö", kIl = "⌽", SIl = "‾", xIl = "⏞", EIl = "⎴", TIl = "⏜", AIl = "¶", CIl = "∥", zIl = "∥", OIl = "⫳", PIl = "⫽", IIl = "∂", RIl = "∂", NIl = "П", DIl = "п", MIl = "%", LIl = ".", qIl = "‰", jIl = "⊥", FIl = "‱", VIl = "𝔓", BIl = "𝔭", UIl = "Φ", WIl = "φ", GIl = "ϕ", HIl = "ℳ", KIl = "☎", YIl = "Π", ZIl = "π", QIl = "⋔", JIl = "ϖ", XIl = "ℏ", eRl = "ℎ", tRl = "ℏ", nRl = "⨣", oRl = "⊞", rRl = "⨢", iRl = "+", aRl = "∔", sRl = "⨥", cRl = "⩲", lRl = "±", dRl = "±", uRl = "⨦", _Rl = "⨧", pRl = "±", mRl = "ℌ", fRl = "⨕", gRl = "𝕡", hRl = "ℙ", vRl = "£", bRl = "⪷", yRl = "⪻", $Rl = "≺", wRl = "≼", kRl = "⪷", SRl = "≺", xRl = "≼", ERl = "≺", TRl = "⪯", ARl = "≼", CRl = "≾", zRl = "⪯", ORl = "⪹", PRl = "⪵", IRl = "⋨", RRl = "⪯", NRl = "⪳", DRl = "≾", MRl = "′", LRl = "″", qRl = "ℙ", jRl = "⪹", FRl = "⪵", VRl = "⋨", BRl = "∏", URl = "∏", WRl = "⌮", GRl = "⌒", HRl = "⌓", KRl = "∝", YRl = "∝", ZRl = "∷", QRl = "∝", JRl = "≾", XRl = "⊰", eNl = "𝒫", tNl = "𝓅", nNl = "Ψ", oNl = "ψ", rNl = " ", iNl = "𝔔", aNl = "𝔮", sNl = "⨌", cNl = "𝕢", lNl = "ℚ", dNl = "⁗", uNl = "𝒬", _Nl = "𝓆", pNl = "ℍ", mNl = "⨖", fNl = "?", gNl = "≟", hNl = '"', vNl = '"', bNl = "⇛", yNl = "∽̱", $Nl = "Ŕ", wNl = "ŕ", kNl = "√", SNl = "⦳", xNl = "⟩", ENl = "⟫", TNl = "⦒", ANl = "⦥", CNl = "⟩", zNl = "»", ONl = "⥵", PNl = "⇥", INl = "⤠", RNl = "⤳", NNl = "→", DNl = "↠", MNl = "⇒", LNl = "⤞", qNl = "↪", jNl = "↬", FNl = "⥅", VNl = "⥴", BNl = "⤖", UNl = "↣", WNl = "↝", GNl = "⤚", HNl = "⤜", KNl = "∶", YNl = "ℚ", ZNl = "⤍", QNl = "⤏", JNl = "⤐", XNl = "❳", eDl = "}", tDl = "]", nDl = "⦌", oDl = "⦎", rDl = "⦐", iDl = "Ř", aDl = "ř", sDl = "Ŗ", cDl = "ŗ", lDl = "⌉", dDl = "}", uDl = "Р", _Dl = "р", pDl = "⤷", mDl = "⥩", fDl = "”", gDl = "”", hDl = "↳", vDl = "ℜ", bDl = "ℛ", yDl = "ℜ", $Dl = "ℝ", wDl = "ℜ", kDl = "▭", SDl = "®", xDl = "®", EDl = "∋", TDl = "⇋", ADl = "⥯", CDl = "⥽", zDl = "⌋", ODl = "𝔯", PDl = "ℜ", IDl = "⥤", RDl = "⇁", NDl = "⇀", DDl = "⥬", MDl = "Ρ", LDl = "ρ", qDl = "ϱ", jDl = "⟩", FDl = "⇥", VDl = "→", BDl = "→", UDl = "⇒", WDl = "⇄", GDl = "↣", HDl = "⌉", KDl = "⟧", YDl = "⥝", ZDl = "⥕", QDl = "⇂", JDl = "⌋", XDl = "⇁", eMl = "⇀", tMl = "⇄", nMl = "⇌", oMl = "⇉", rMl = "↝", iMl = "↦", aMl = "⊢", sMl = "⥛", cMl = "⋌", lMl = "⧐", dMl = "⊳", uMl = "⊵", _Ml = "⥏", pMl = "⥜", mMl = "⥔", fMl = "↾", gMl = "⥓", hMl = "⇀", vMl = "˚", bMl = "≓", yMl = "⇄", $Ml = "⇌", wMl = "‏", kMl = "⎱", SMl = "⎱", xMl = "⫮", EMl = "⟭", TMl = "⇾", AMl = "⟧", CMl = "⦆", zMl = "𝕣", OMl = "ℝ", PMl = "⨮", IMl = "⨵", RMl = "⥰", NMl = ")", DMl = "⦔", MMl = "⨒", LMl = "⇉", qMl = "⇛", jMl = "›", FMl = "𝓇", VMl = "ℛ", BMl = "↱", UMl = "↱", WMl = "]", GMl = "’", HMl = "’", KMl = "⋌", YMl = "⋊", ZMl = "▹", QMl = "⊵", JMl = "▸", XMl = "⧎", eLl = "⧴", tLl = "⥨", nLl = "℞", oLl = "Ś", rLl = "ś", iLl = "‚", aLl = "⪸", sLl = "Š", cLl = "š", lLl = "⪼", dLl = "≻", uLl = "≽", _Ll = "⪰", pLl = "⪴", mLl = "Ş", fLl = "ş", gLl = "Ŝ", hLl = "ŝ", vLl = "⪺", bLl = "⪶", yLl = "⋩", $Ll = "⨓", wLl = "≿", kLl = "С", SLl = "с", xLl = "⊡", ELl = "⋅", TLl = "⩦", ALl = "⤥", CLl = "↘", zLl = "⇘", OLl = "↘", PLl = "§", ILl = ";", RLl = "⤩", NLl = "∖", DLl = "∖", MLl = "✶", LLl = "𝔖", qLl = "𝔰", jLl = "⌢", FLl = "♯", VLl = "Щ", BLl = "щ", ULl = "Ш", WLl = "ш", GLl = "↓", HLl = "←", KLl = "∣", YLl = "∥", ZLl = "→", QLl = "↑", JLl = "­", XLl = "Σ", eql = "σ", tql = "ς", nql = "ς", oql = "∼", rql = "⩪", iql = "≃", aql = "≃", sql = "⪞", cql = "⪠", lql = "⪝", dql = "⪟", uql = "≆", _ql = "⨤", pql = "⥲", mql = "←", fql = "∘", gql = "∖", hql = "⨳", vql = "⧤", bql = "∣", yql = "⌣", $ql = "⪪", wql = "⪬", kql = "⪬︀", Sql = "Ь", xql = "ь", Eql = "⌿", Tql = "⧄", Aql = "/", Cql = "𝕊", zql = "𝕤", Oql = "♠", Pql = "♠", Iql = "∥", Rql = "⊓", Nql = "⊓︀", Dql = "⊔", Mql = "⊔︀", Lql = "√", qql = "⊏", jql = "⊑", Fql = "⊏", Vql = "⊑", Bql = "⊐", Uql = "⊒", Wql = "⊐", Gql = "⊒", Hql = "□", Kql = "□", Yql = "⊓", Zql = "⊏", Qql = "⊑", Jql = "⊐", Xql = "⊒", e9l = "⊔", t9l = "▪", n9l = "□", o9l = "▪", r9l = "→", i9l = "𝒮", a9l = "𝓈", s9l = "∖", c9l = "⌣", l9l = "⋆", d9l = "⋆", u9l = "☆", _9l = "★", p9l = "ϵ", m9l = "ϕ", f9l = "¯", g9l = "⊂", h9l = "⋐", v9l = "⪽", b9l = "⫅", y9l = "⊆", $9l = "⫃", w9l = "⫁", k9l = "⫋", S9l = "⊊", x9l = "⪿", E9l = "⥹", T9l = "⊂", A9l = "⋐", C9l = "⊆", z9l = "⫅", O9l = "⊆", P9l = "⊊", I9l = "⫋", R9l = "⫇", N9l = "⫕", D9l = "⫓", M9l = "⪸", L9l = "≻", q9l = "≽", j9l = "≻", F9l = "⪰", V9l = "≽", B9l = "≿", U9l = "⪰", W9l = "⪺", G9l = "⪶", H9l = "⋩", K9l = "≿", Y9l = "∋", Z9l = "∑", Q9l = "∑", J9l = "♪", X9l = "¹", ejl = "²", tjl = "³", njl = "⊃", ojl = "⋑", rjl = "⪾", ijl = "⫘", ajl = "⫆", sjl = "⊇", cjl = "⫄", ljl = "⊃", djl = "⊇", ujl = "⟉", _jl = "⫗", pjl = "⥻", mjl = "⫂", fjl = "⫌", gjl = "⊋", hjl = "⫀", vjl = "⊃", bjl = "⋑", yjl = "⊇", $jl = "⫆", wjl = "⊋", kjl = "⫌", Sjl = "⫈", xjl = "⫔", Ejl = "⫖", Tjl = "⤦", Ajl = "↙", Cjl = "⇙", zjl = "↙", Ojl = "⤪", Pjl = "ß", Ijl = "	", Rjl = "⌖", Njl = "Τ", Djl = "τ", Mjl = "⎴", Ljl = "Ť", qjl = "ť", jjl = "Ţ", Fjl = "ţ", Vjl = "Т", Bjl = "т", Ujl = "⃛", Wjl = "⌕", Gjl = "𝔗", Hjl = "𝔱", Kjl = "∴", Yjl = "∴", Zjl = "∴", Qjl = "Θ", Jjl = "θ", Xjl = "ϑ", eFl = "ϑ", tFl = "≈", nFl = "∼", oFl = "  ", rFl = " ", iFl = " ", aFl = "≈", sFl = "∼", cFl = "Þ", lFl = "þ", dFl = "˜", uFl = "∼", _Fl = "≃", pFl = "≅", mFl = "≈", fFl = "⨱", gFl = "⊠", hFl = "×", vFl = "⨰", bFl = "∭", yFl = "⤨", $Fl = "⌶", wFl = "⫱", kFl = "⊤", SFl = "𝕋", xFl = "𝕥", EFl = "⫚", TFl = "⤩", AFl = "‴", CFl = "™", zFl = "™", OFl = "▵", PFl = "▿", IFl = "◃", RFl = "⊴", NFl = "≜", DFl = "▹", MFl = "⊵", LFl = "◬", qFl = "≜", jFl = "⨺", FFl = "⃛", VFl = "⨹", BFl = "⧍", UFl = "⨻", WFl = "⏢", GFl = "𝒯", HFl = "𝓉", KFl = "Ц", YFl = "ц", ZFl = "Ћ", QFl = "ћ", JFl = "Ŧ", XFl = "ŧ", e8l = "≬", t8l = "↞", n8l = "↠", o8l = "Ú", r8l = "ú", i8l = "↑", a8l = "↟", s8l = "⇑", c8l = "⥉", l8l = "Ў", d8l = "ў", u8l = "Ŭ", _8l = "ŭ", p8l = "Û", m8l = "û", f8l = "У", g8l = "у", h8l = "⇅", v8l = "Ű", b8l = "ű", y8l = "⥮", $8l = "⥾", w8l = "𝔘", k8l = "𝔲", S8l = "Ù", x8l = "ù", E8l = "⥣", T8l = "↿", A8l = "↾", C8l = "▀", z8l = "⌜", O8l = "⌜", P8l = "⌏", I8l = "◸", R8l = "Ū", N8l = "ū", D8l = "¨", M8l = "_", L8l = "⏟", q8l = "⎵", j8l = "⏝", F8l = "⋃", V8l = "⊎", B8l = "Ų", U8l = "ų", W8l = "𝕌", G8l = "𝕦", H8l = "⤒", K8l = "↑", Y8l = "↑", Z8l = "⇑", Q8l = "⇅", J8l = "↕", X8l = "↕", e7l = "⇕", t7l = "⥮", n7l = "↿", o7l = "↾", r7l = "⊎", i7l = "↖", a7l = "↗", s7l = "υ", c7l = "ϒ", l7l = "ϒ", d7l = "Υ", u7l = "υ", _7l = "↥", p7l = "⊥", m7l = "⇈", f7l = "⌝", g7l = "⌝", h7l = "⌎", v7l = "Ů", b7l = "ů", y7l = "◹", $7l = "𝒰", w7l = "𝓊", k7l = "⋰", S7l = "Ũ", x7l = "ũ", E7l = "▵", T7l = "▴", A7l = "⇈", C7l = "Ü", z7l = "ü", O7l = "⦧", P7l = "⦜", I7l = "ϵ", R7l = "ϰ", N7l = "∅", D7l = "ϕ", M7l = "ϖ", L7l = "∝", q7l = "↕", j7l = "⇕", F7l = "ϱ", V7l = "ς", B7l = "⊊︀", U7l = "⫋︀", W7l = "⊋︀", G7l = "⫌︀", H7l = "ϑ", K7l = "⊲", Y7l = "⊳", Z7l = "⫨", Q7l = "⫫", J7l = "⫩", X7l = "В", eVl = "в", tVl = "⊢", nVl = "⊨", oVl = "⊩", rVl = "⊫", iVl = "⫦", aVl = "⊻", sVl = "∨", cVl = "⋁", lVl = "≚", dVl = "⋮", uVl = "|", _Vl = "‖", pVl = "|", mVl = "‖", fVl = "∣", gVl = "|", hVl = "❘", vVl = "≀", bVl = " ", yVl = "𝔙", $Vl = "𝔳", wVl = "⊲", kVl = "⊂⃒", SVl = "⊃⃒", xVl = "𝕍", EVl = "𝕧", TVl = "∝", AVl = "⊳", CVl = "𝒱", zVl = "𝓋", OVl = "⫋︀", PVl = "⊊︀", IVl = "⫌︀", RVl = "⊋︀", NVl = "⊪", DVl = "⦚", MVl = "Ŵ", LVl = "ŵ", qVl = "⩟", jVl = "∧", FVl = "⋀", VVl = "≙", BVl = "℘", UVl = "𝔚", WVl = "𝔴", GVl = "𝕎", HVl = "𝕨", KVl = "℘", YVl = "≀", ZVl = "≀", QVl = "𝒲", JVl = "𝓌", XVl = "⋂", eBl = "◯", tBl = "⋃", nBl = "▽", oBl = "𝔛", rBl = "𝔵", iBl = "⟷", aBl = "⟺", sBl = "Ξ", cBl = "ξ", lBl = "⟵", dBl = "⟸", uBl = "⟼", _Bl = "⋻", pBl = "⨀", mBl = "𝕏", fBl = "𝕩", gBl = "⨁", hBl = "⨂", vBl = "⟶", bBl = "⟹", yBl = "𝒳", $Bl = "𝓍", wBl = "⨆", kBl = "⨄", SBl = "△", xBl = "⋁", EBl = "⋀", TBl = "Ý", ABl = "ý", CBl = "Я", zBl = "я", OBl = "Ŷ", PBl = "ŷ", IBl = "Ы", RBl = "ы", NBl = "¥", DBl = "𝔜", MBl = "𝔶", LBl = "Ї", qBl = "ї", jBl = "𝕐", FBl = "𝕪", VBl = "𝒴", BBl = "𝓎", UBl = "Ю", WBl = "ю", GBl = "ÿ", HBl = "Ÿ", KBl = "Ź", YBl = "ź", ZBl = "Ž", QBl = "ž", JBl = "З", XBl = "з", eUl = "Ż", tUl = "ż", nUl = "ℨ", oUl = "​", rUl = "Ζ", iUl = "ζ", aUl = "𝔷", sUl = "ℨ", cUl = "Ж", lUl = "ж", dUl = "⇝", uUl = "𝕫", _Ul = "ℤ", pUl = "𝒵", mUl = "𝓏", fUl = "‍", gUl = "‌", hUl = {
  Aacute: efl,
  aacute: tfl,
  Abreve: nfl,
  abreve: ofl,
  ac: rfl,
  acd: ifl,
  acE: afl,
  Acirc: sfl,
  acirc: cfl,
  acute: lfl,
  Acy: dfl,
  acy: ufl,
  AElig: _fl,
  aelig: pfl,
  af: mfl,
  Afr: ffl,
  afr: gfl,
  Agrave: hfl,
  agrave: vfl,
  alefsym: bfl,
  aleph: yfl,
  Alpha: $fl,
  alpha: wfl,
  Amacr: kfl,
  amacr: Sfl,
  amalg: xfl,
  amp: Efl,
  AMP: Tfl,
  andand: Afl,
  And: Cfl,
  and: zfl,
  andd: Ofl,
  andslope: Pfl,
  andv: Ifl,
  ang: Rfl,
  ange: Nfl,
  angle: Dfl,
  angmsdaa: Mfl,
  angmsdab: Lfl,
  angmsdac: qfl,
  angmsdad: jfl,
  angmsdae: Ffl,
  angmsdaf: Vfl,
  angmsdag: Bfl,
  angmsdah: Ufl,
  angmsd: Wfl,
  angrt: Gfl,
  angrtvb: Hfl,
  angrtvbd: Kfl,
  angsph: Yfl,
  angst: Zfl,
  angzarr: Qfl,
  Aogon: Jfl,
  aogon: Xfl,
  Aopf: egl,
  aopf: tgl,
  apacir: ngl,
  ap: ogl,
  apE: rgl,
  ape: igl,
  apid: agl,
  apos: sgl,
  ApplyFunction: cgl,
  approx: lgl,
  approxeq: dgl,
  Aring: ugl,
  aring: _gl,
  Ascr: pgl,
  ascr: mgl,
  Assign: fgl,
  ast: ggl,
  asymp: hgl,
  asympeq: vgl,
  Atilde: bgl,
  atilde: ygl,
  Auml: $gl,
  auml: wgl,
  awconint: kgl,
  awint: Sgl,
  backcong: xgl,
  backepsilon: Egl,
  backprime: Tgl,
  backsim: Agl,
  backsimeq: Cgl,
  Backslash: zgl,
  Barv: Ogl,
  barvee: Pgl,
  barwed: Igl,
  Barwed: Rgl,
  barwedge: Ngl,
  bbrk: Dgl,
  bbrktbrk: Mgl,
  bcong: Lgl,
  Bcy: qgl,
  bcy: jgl,
  bdquo: Fgl,
  becaus: Vgl,
  because: Bgl,
  Because: Ugl,
  bemptyv: Wgl,
  bepsi: Ggl,
  bernou: Hgl,
  Bernoullis: Kgl,
  Beta: Ygl,
  beta: Zgl,
  beth: Qgl,
  between: Jgl,
  Bfr: Xgl,
  bfr: ehl,
  bigcap: thl,
  bigcirc: nhl,
  bigcup: ohl,
  bigodot: rhl,
  bigoplus: ihl,
  bigotimes: ahl,
  bigsqcup: shl,
  bigstar: chl,
  bigtriangledown: lhl,
  bigtriangleup: dhl,
  biguplus: uhl,
  bigvee: _hl,
  bigwedge: phl,
  bkarow: mhl,
  blacklozenge: fhl,
  blacksquare: ghl,
  blacktriangle: hhl,
  blacktriangledown: vhl,
  blacktriangleleft: bhl,
  blacktriangleright: yhl,
  blank: $hl,
  blk12: whl,
  blk14: khl,
  blk34: Shl,
  block: xhl,
  bne: Ehl,
  bnequiv: Thl,
  bNot: Ahl,
  bnot: Chl,
  Bopf: zhl,
  bopf: Ohl,
  bot: Phl,
  bottom: Ihl,
  bowtie: Rhl,
  boxbox: Nhl,
  boxdl: Dhl,
  boxdL: Mhl,
  boxDl: Lhl,
  boxDL: qhl,
  boxdr: jhl,
  boxdR: Fhl,
  boxDr: Vhl,
  boxDR: Bhl,
  boxh: Uhl,
  boxH: Whl,
  boxhd: Ghl,
  boxHd: Hhl,
  boxhD: Khl,
  boxHD: Yhl,
  boxhu: Zhl,
  boxHu: Qhl,
  boxhU: Jhl,
  boxHU: Xhl,
  boxminus: evl,
  boxplus: tvl,
  boxtimes: nvl,
  boxul: ovl,
  boxuL: rvl,
  boxUl: ivl,
  boxUL: avl,
  boxur: svl,
  boxuR: cvl,
  boxUr: lvl,
  boxUR: dvl,
  boxv: uvl,
  boxV: _vl,
  boxvh: pvl,
  boxvH: mvl,
  boxVh: fvl,
  boxVH: gvl,
  boxvl: hvl,
  boxvL: vvl,
  boxVl: bvl,
  boxVL: yvl,
  boxvr: $vl,
  boxvR: wvl,
  boxVr: kvl,
  boxVR: Svl,
  bprime: xvl,
  breve: Evl,
  Breve: Tvl,
  brvbar: Avl,
  bscr: Cvl,
  Bscr: zvl,
  bsemi: Ovl,
  bsim: Pvl,
  bsime: Ivl,
  bsolb: Rvl,
  bsol: Nvl,
  bsolhsub: Dvl,
  bull: Mvl,
  bullet: Lvl,
  bump: qvl,
  bumpE: jvl,
  bumpe: Fvl,
  Bumpeq: Vvl,
  bumpeq: Bvl,
  Cacute: Uvl,
  cacute: Wvl,
  capand: Gvl,
  capbrcup: Hvl,
  capcap: Kvl,
  cap: Yvl,
  Cap: Zvl,
  capcup: Qvl,
  capdot: Jvl,
  CapitalDifferentialD: Xvl,
  caps: ebl,
  caret: tbl,
  caron: nbl,
  Cayleys: obl,
  ccaps: rbl,
  Ccaron: ibl,
  ccaron: abl,
  Ccedil: sbl,
  ccedil: cbl,
  Ccirc: lbl,
  ccirc: dbl,
  Cconint: ubl,
  ccups: _bl,
  ccupssm: pbl,
  Cdot: mbl,
  cdot: fbl,
  cedil: gbl,
  Cedilla: hbl,
  cemptyv: vbl,
  cent: bbl,
  centerdot: ybl,
  CenterDot: $bl,
  cfr: wbl,
  Cfr: kbl,
  CHcy: Sbl,
  chcy: xbl,
  check: Ebl,
  checkmark: Tbl,
  Chi: Abl,
  chi: Cbl,
  circ: zbl,
  circeq: Obl,
  circlearrowleft: Pbl,
  circlearrowright: Ibl,
  circledast: Rbl,
  circledcirc: Nbl,
  circleddash: Dbl,
  CircleDot: Mbl,
  circledR: Lbl,
  circledS: qbl,
  CircleMinus: jbl,
  CirclePlus: Fbl,
  CircleTimes: Vbl,
  cir: Bbl,
  cirE: Ubl,
  cire: Wbl,
  cirfnint: Gbl,
  cirmid: Hbl,
  cirscir: Kbl,
  ClockwiseContourIntegral: Ybl,
  CloseCurlyDoubleQuote: Zbl,
  CloseCurlyQuote: Qbl,
  clubs: Jbl,
  clubsuit: Xbl,
  colon: eyl,
  Colon: tyl,
  Colone: nyl,
  colone: oyl,
  coloneq: ryl,
  comma: iyl,
  commat: ayl,
  comp: syl,
  compfn: cyl,
  complement: lyl,
  complexes: dyl,
  cong: uyl,
  congdot: _yl,
  Congruent: pyl,
  conint: myl,
  Conint: fyl,
  ContourIntegral: gyl,
  copf: hyl,
  Copf: vyl,
  coprod: byl,
  Coproduct: yyl,
  copy: $yl,
  COPY: wyl,
  copysr: kyl,
  CounterClockwiseContourIntegral: Syl,
  crarr: xyl,
  cross: Eyl,
  Cross: Tyl,
  Cscr: Ayl,
  cscr: Cyl,
  csub: zyl,
  csube: Oyl,
  csup: Pyl,
  csupe: Iyl,
  ctdot: Ryl,
  cudarrl: Nyl,
  cudarrr: Dyl,
  cuepr: Myl,
  cuesc: Lyl,
  cularr: qyl,
  cularrp: jyl,
  cupbrcap: Fyl,
  cupcap: Vyl,
  CupCap: Byl,
  cup: Uyl,
  Cup: Wyl,
  cupcup: Gyl,
  cupdot: Hyl,
  cupor: Kyl,
  cups: Yyl,
  curarr: Zyl,
  curarrm: Qyl,
  curlyeqprec: Jyl,
  curlyeqsucc: Xyl,
  curlyvee: e$l,
  curlywedge: t$l,
  curren: n$l,
  curvearrowleft: o$l,
  curvearrowright: r$l,
  cuvee: i$l,
  cuwed: a$l,
  cwconint: s$l,
  cwint: c$l,
  cylcty: l$l,
  dagger: d$l,
  Dagger: u$l,
  daleth: _$l,
  darr: p$l,
  Darr: m$l,
  dArr: f$l,
  dash: g$l,
  Dashv: h$l,
  dashv: v$l,
  dbkarow: b$l,
  dblac: y$l,
  Dcaron: $$l,
  dcaron: w$l,
  Dcy: k$l,
  dcy: S$l,
  ddagger: x$l,
  ddarr: E$l,
  DD: T$l,
  dd: A$l,
  DDotrahd: C$l,
  ddotseq: z$l,
  deg: O$l,
  Del: P$l,
  Delta: I$l,
  delta: R$l,
  demptyv: N$l,
  dfisht: D$l,
  Dfr: M$l,
  dfr: L$l,
  dHar: q$l,
  dharl: j$l,
  dharr: F$l,
  DiacriticalAcute: V$l,
  DiacriticalDot: B$l,
  DiacriticalDoubleAcute: U$l,
  DiacriticalGrave: W$l,
  DiacriticalTilde: G$l,
  diam: H$l,
  diamond: K$l,
  Diamond: Y$l,
  diamondsuit: Z$l,
  diams: Q$l,
  die: J$l,
  DifferentialD: X$l,
  digamma: ewl,
  disin: twl,
  div: nwl,
  divide: owl,
  divideontimes: rwl,
  divonx: iwl,
  DJcy: awl,
  djcy: swl,
  dlcorn: cwl,
  dlcrop: lwl,
  dollar: dwl,
  Dopf: uwl,
  dopf: _wl,
  Dot: pwl,
  dot: mwl,
  DotDot: fwl,
  doteq: gwl,
  doteqdot: hwl,
  DotEqual: vwl,
  dotminus: bwl,
  dotplus: ywl,
  dotsquare: $wl,
  doublebarwedge: wwl,
  DoubleContourIntegral: kwl,
  DoubleDot: Swl,
  DoubleDownArrow: xwl,
  DoubleLeftArrow: Ewl,
  DoubleLeftRightArrow: Twl,
  DoubleLeftTee: Awl,
  DoubleLongLeftArrow: Cwl,
  DoubleLongLeftRightArrow: zwl,
  DoubleLongRightArrow: Owl,
  DoubleRightArrow: Pwl,
  DoubleRightTee: Iwl,
  DoubleUpArrow: Rwl,
  DoubleUpDownArrow: Nwl,
  DoubleVerticalBar: Dwl,
  DownArrowBar: Mwl,
  downarrow: Lwl,
  DownArrow: qwl,
  Downarrow: jwl,
  DownArrowUpArrow: Fwl,
  DownBreve: Vwl,
  downdownarrows: Bwl,
  downharpoonleft: Uwl,
  downharpoonright: Wwl,
  DownLeftRightVector: Gwl,
  DownLeftTeeVector: Hwl,
  DownLeftVectorBar: Kwl,
  DownLeftVector: Ywl,
  DownRightTeeVector: Zwl,
  DownRightVectorBar: Qwl,
  DownRightVector: Jwl,
  DownTeeArrow: Xwl,
  DownTee: e0l,
  drbkarow: t0l,
  drcorn: n0l,
  drcrop: o0l,
  Dscr: r0l,
  dscr: i0l,
  DScy: a0l,
  dscy: s0l,
  dsol: c0l,
  Dstrok: l0l,
  dstrok: d0l,
  dtdot: u0l,
  dtri: _0l,
  dtrif: p0l,
  duarr: m0l,
  duhar: f0l,
  dwangle: g0l,
  DZcy: h0l,
  dzcy: v0l,
  dzigrarr: b0l,
  Eacute: y0l,
  eacute: $0l,
  easter: w0l,
  Ecaron: k0l,
  ecaron: S0l,
  Ecirc: x0l,
  ecirc: E0l,
  ecir: T0l,
  ecolon: A0l,
  Ecy: C0l,
  ecy: z0l,
  eDDot: O0l,
  Edot: P0l,
  edot: I0l,
  eDot: R0l,
  ee: N0l,
  efDot: D0l,
  Efr: M0l,
  efr: L0l,
  eg: q0l,
  Egrave: j0l,
  egrave: F0l,
  egs: V0l,
  egsdot: B0l,
  el: U0l,
  Element: W0l,
  elinters: G0l,
  ell: H0l,
  els: K0l,
  elsdot: Y0l,
  Emacr: Z0l,
  emacr: Q0l,
  empty: J0l,
  emptyset: X0l,
  EmptySmallSquare: ekl,
  emptyv: tkl,
  EmptyVerySmallSquare: nkl,
  emsp13: okl,
  emsp14: rkl,
  emsp: ikl,
  ENG: akl,
  eng: skl,
  ensp: ckl,
  Eogon: lkl,
  eogon: dkl,
  Eopf: ukl,
  eopf: _kl,
  epar: pkl,
  eparsl: mkl,
  eplus: fkl,
  epsi: gkl,
  Epsilon: hkl,
  epsilon: vkl,
  epsiv: bkl,
  eqcirc: ykl,
  eqcolon: $kl,
  eqsim: wkl,
  eqslantgtr: kkl,
  eqslantless: Skl,
  Equal: xkl,
  equals: Ekl,
  EqualTilde: Tkl,
  equest: Akl,
  Equilibrium: Ckl,
  equiv: zkl,
  equivDD: Okl,
  eqvparsl: Pkl,
  erarr: Ikl,
  erDot: Rkl,
  escr: Nkl,
  Escr: Dkl,
  esdot: Mkl,
  Esim: Lkl,
  esim: qkl,
  Eta: jkl,
  eta: Fkl,
  ETH: Vkl,
  eth: Bkl,
  Euml: Ukl,
  euml: Wkl,
  euro: Gkl,
  excl: Hkl,
  exist: Kkl,
  Exists: Ykl,
  expectation: Zkl,
  exponentiale: Qkl,
  ExponentialE: Jkl,
  fallingdotseq: Xkl,
  Fcy: e1l,
  fcy: t1l,
  female: n1l,
  ffilig: o1l,
  fflig: r1l,
  ffllig: i1l,
  Ffr: a1l,
  ffr: s1l,
  filig: c1l,
  FilledSmallSquare: l1l,
  FilledVerySmallSquare: d1l,
  fjlig: u1l,
  flat: _1l,
  fllig: p1l,
  fltns: m1l,
  fnof: f1l,
  Fopf: g1l,
  fopf: h1l,
  forall: v1l,
  ForAll: b1l,
  fork: y1l,
  forkv: $1l,
  Fouriertrf: w1l,
  fpartint: k1l,
  frac12: S1l,
  frac13: x1l,
  frac14: E1l,
  frac15: T1l,
  frac16: A1l,
  frac18: C1l,
  frac23: z1l,
  frac25: O1l,
  frac34: P1l,
  frac35: I1l,
  frac38: R1l,
  frac45: N1l,
  frac56: D1l,
  frac58: M1l,
  frac78: L1l,
  frasl: q1l,
  frown: j1l,
  fscr: F1l,
  Fscr: V1l,
  gacute: B1l,
  Gamma: U1l,
  gamma: W1l,
  Gammad: G1l,
  gammad: H1l,
  gap: K1l,
  Gbreve: Y1l,
  gbreve: Z1l,
  Gcedil: Q1l,
  Gcirc: J1l,
  gcirc: X1l,
  Gcy: e2l,
  gcy: t2l,
  Gdot: n2l,
  gdot: o2l,
  ge: r2l,
  gE: i2l,
  gEl: a2l,
  gel: s2l,
  geq: c2l,
  geqq: l2l,
  geqslant: d2l,
  gescc: u2l,
  ges: _2l,
  gesdot: p2l,
  gesdoto: m2l,
  gesdotol: f2l,
  gesl: g2l,
  gesles: h2l,
  Gfr: v2l,
  gfr: b2l,
  gg: y2l,
  Gg: $2l,
  ggg: w2l,
  gimel: k2l,
  GJcy: S2l,
  gjcy: x2l,
  gla: E2l,
  gl: T2l,
  glE: A2l,
  glj: C2l,
  gnap: z2l,
  gnapprox: O2l,
  gne: P2l,
  gnE: I2l,
  gneq: R2l,
  gneqq: N2l,
  gnsim: D2l,
  Gopf: M2l,
  gopf: L2l,
  grave: q2l,
  GreaterEqual: j2l,
  GreaterEqualLess: F2l,
  GreaterFullEqual: V2l,
  GreaterGreater: B2l,
  GreaterLess: U2l,
  GreaterSlantEqual: W2l,
  GreaterTilde: G2l,
  Gscr: H2l,
  gscr: K2l,
  gsim: Y2l,
  gsime: Z2l,
  gsiml: Q2l,
  gtcc: J2l,
  gtcir: X2l,
  gt: eSl,
  GT: tSl,
  Gt: nSl,
  gtdot: oSl,
  gtlPar: rSl,
  gtquest: iSl,
  gtrapprox: aSl,
  gtrarr: sSl,
  gtrdot: cSl,
  gtreqless: lSl,
  gtreqqless: dSl,
  gtrless: uSl,
  gtrsim: _Sl,
  gvertneqq: pSl,
  gvnE: mSl,
  Hacek: fSl,
  hairsp: gSl,
  half: hSl,
  hamilt: vSl,
  HARDcy: bSl,
  hardcy: ySl,
  harrcir: $Sl,
  harr: wSl,
  hArr: kSl,
  harrw: SSl,
  Hat: xSl,
  hbar: ESl,
  Hcirc: TSl,
  hcirc: ASl,
  hearts: CSl,
  heartsuit: zSl,
  hellip: OSl,
  hercon: PSl,
  hfr: ISl,
  Hfr: RSl,
  HilbertSpace: NSl,
  hksearow: DSl,
  hkswarow: MSl,
  hoarr: LSl,
  homtht: qSl,
  hookleftarrow: jSl,
  hookrightarrow: FSl,
  hopf: VSl,
  Hopf: BSl,
  horbar: USl,
  HorizontalLine: WSl,
  hscr: GSl,
  Hscr: HSl,
  hslash: KSl,
  Hstrok: YSl,
  hstrok: ZSl,
  HumpDownHump: QSl,
  HumpEqual: JSl,
  hybull: XSl,
  hyphen: exl,
  Iacute: txl,
  iacute: nxl,
  ic: oxl,
  Icirc: rxl,
  icirc: ixl,
  Icy: axl,
  icy: sxl,
  Idot: cxl,
  IEcy: lxl,
  iecy: dxl,
  iexcl: uxl,
  iff: _xl,
  ifr: pxl,
  Ifr: mxl,
  Igrave: fxl,
  igrave: gxl,
  ii: hxl,
  iiiint: vxl,
  iiint: bxl,
  iinfin: yxl,
  iiota: $xl,
  IJlig: wxl,
  ijlig: kxl,
  Imacr: Sxl,
  imacr: xxl,
  image: Exl,
  ImaginaryI: Txl,
  imagline: Axl,
  imagpart: Cxl,
  imath: zxl,
  Im: Oxl,
  imof: Pxl,
  imped: Ixl,
  Implies: Rxl,
  incare: Nxl,
  in: "∈",
  infin: Dxl,
  infintie: Mxl,
  inodot: Lxl,
  intcal: qxl,
  int: jxl,
  Int: Fxl,
  integers: Vxl,
  Integral: Bxl,
  intercal: Uxl,
  Intersection: Wxl,
  intlarhk: Gxl,
  intprod: Hxl,
  InvisibleComma: Kxl,
  InvisibleTimes: Yxl,
  IOcy: Zxl,
  iocy: Qxl,
  Iogon: Jxl,
  iogon: Xxl,
  Iopf: eEl,
  iopf: tEl,
  Iota: nEl,
  iota: oEl,
  iprod: rEl,
  iquest: iEl,
  iscr: aEl,
  Iscr: sEl,
  isin: cEl,
  isindot: lEl,
  isinE: dEl,
  isins: uEl,
  isinsv: _El,
  isinv: pEl,
  it: mEl,
  Itilde: fEl,
  itilde: gEl,
  Iukcy: hEl,
  iukcy: vEl,
  Iuml: bEl,
  iuml: yEl,
  Jcirc: $El,
  jcirc: wEl,
  Jcy: kEl,
  jcy: SEl,
  Jfr: xEl,
  jfr: EEl,
  jmath: TEl,
  Jopf: AEl,
  jopf: CEl,
  Jscr: zEl,
  jscr: OEl,
  Jsercy: PEl,
  jsercy: IEl,
  Jukcy: REl,
  jukcy: NEl,
  Kappa: DEl,
  kappa: MEl,
  kappav: LEl,
  Kcedil: qEl,
  kcedil: jEl,
  Kcy: FEl,
  kcy: VEl,
  Kfr: BEl,
  kfr: UEl,
  kgreen: WEl,
  KHcy: GEl,
  khcy: HEl,
  KJcy: KEl,
  kjcy: YEl,
  Kopf: ZEl,
  kopf: QEl,
  Kscr: JEl,
  kscr: XEl,
  lAarr: eTl,
  Lacute: tTl,
  lacute: nTl,
  laemptyv: oTl,
  lagran: rTl,
  Lambda: iTl,
  lambda: aTl,
  lang: sTl,
  Lang: cTl,
  langd: lTl,
  langle: dTl,
  lap: uTl,
  Laplacetrf: _Tl,
  laquo: pTl,
  larrb: mTl,
  larrbfs: fTl,
  larr: gTl,
  Larr: hTl,
  lArr: vTl,
  larrfs: bTl,
  larrhk: yTl,
  larrlp: $Tl,
  larrpl: wTl,
  larrsim: kTl,
  larrtl: STl,
  latail: xTl,
  lAtail: ETl,
  lat: TTl,
  late: ATl,
  lates: CTl,
  lbarr: zTl,
  lBarr: OTl,
  lbbrk: PTl,
  lbrace: ITl,
  lbrack: RTl,
  lbrke: NTl,
  lbrksld: DTl,
  lbrkslu: MTl,
  Lcaron: LTl,
  lcaron: qTl,
  Lcedil: jTl,
  lcedil: FTl,
  lceil: VTl,
  lcub: BTl,
  Lcy: UTl,
  lcy: WTl,
  ldca: GTl,
  ldquo: HTl,
  ldquor: KTl,
  ldrdhar: YTl,
  ldrushar: ZTl,
  ldsh: QTl,
  le: JTl,
  lE: XTl,
  LeftAngleBracket: eAl,
  LeftArrowBar: tAl,
  leftarrow: nAl,
  LeftArrow: oAl,
  Leftarrow: rAl,
  LeftArrowRightArrow: iAl,
  leftarrowtail: aAl,
  LeftCeiling: sAl,
  LeftDoubleBracket: cAl,
  LeftDownTeeVector: lAl,
  LeftDownVectorBar: dAl,
  LeftDownVector: uAl,
  LeftFloor: _Al,
  leftharpoondown: pAl,
  leftharpoonup: mAl,
  leftleftarrows: fAl,
  leftrightarrow: gAl,
  LeftRightArrow: hAl,
  Leftrightarrow: vAl,
  leftrightarrows: bAl,
  leftrightharpoons: yAl,
  leftrightsquigarrow: $Al,
  LeftRightVector: wAl,
  LeftTeeArrow: kAl,
  LeftTee: SAl,
  LeftTeeVector: xAl,
  leftthreetimes: EAl,
  LeftTriangleBar: TAl,
  LeftTriangle: AAl,
  LeftTriangleEqual: CAl,
  LeftUpDownVector: zAl,
  LeftUpTeeVector: OAl,
  LeftUpVectorBar: PAl,
  LeftUpVector: IAl,
  LeftVectorBar: RAl,
  LeftVector: NAl,
  lEg: DAl,
  leg: MAl,
  leq: LAl,
  leqq: qAl,
  leqslant: jAl,
  lescc: FAl,
  les: VAl,
  lesdot: BAl,
  lesdoto: UAl,
  lesdotor: WAl,
  lesg: GAl,
  lesges: HAl,
  lessapprox: KAl,
  lessdot: YAl,
  lesseqgtr: ZAl,
  lesseqqgtr: QAl,
  LessEqualGreater: JAl,
  LessFullEqual: XAl,
  LessGreater: eCl,
  lessgtr: tCl,
  LessLess: nCl,
  lesssim: oCl,
  LessSlantEqual: rCl,
  LessTilde: iCl,
  lfisht: aCl,
  lfloor: sCl,
  Lfr: cCl,
  lfr: lCl,
  lg: dCl,
  lgE: uCl,
  lHar: _Cl,
  lhard: pCl,
  lharu: mCl,
  lharul: fCl,
  lhblk: gCl,
  LJcy: hCl,
  ljcy: vCl,
  llarr: bCl,
  ll: yCl,
  Ll: $Cl,
  llcorner: wCl,
  Lleftarrow: kCl,
  llhard: SCl,
  lltri: xCl,
  Lmidot: ECl,
  lmidot: TCl,
  lmoustache: ACl,
  lmoust: CCl,
  lnap: zCl,
  lnapprox: OCl,
  lne: PCl,
  lnE: ICl,
  lneq: RCl,
  lneqq: NCl,
  lnsim: DCl,
  loang: MCl,
  loarr: LCl,
  lobrk: qCl,
  longleftarrow: jCl,
  LongLeftArrow: FCl,
  Longleftarrow: VCl,
  longleftrightarrow: BCl,
  LongLeftRightArrow: UCl,
  Longleftrightarrow: WCl,
  longmapsto: GCl,
  longrightarrow: HCl,
  LongRightArrow: KCl,
  Longrightarrow: YCl,
  looparrowleft: ZCl,
  looparrowright: QCl,
  lopar: JCl,
  Lopf: XCl,
  lopf: ezl,
  loplus: tzl,
  lotimes: nzl,
  lowast: ozl,
  lowbar: rzl,
  LowerLeftArrow: izl,
  LowerRightArrow: azl,
  loz: szl,
  lozenge: czl,
  lozf: lzl,
  lpar: dzl,
  lparlt: uzl,
  lrarr: _zl,
  lrcorner: pzl,
  lrhar: mzl,
  lrhard: fzl,
  lrm: gzl,
  lrtri: hzl,
  lsaquo: vzl,
  lscr: bzl,
  Lscr: yzl,
  lsh: $zl,
  Lsh: wzl,
  lsim: kzl,
  lsime: Szl,
  lsimg: xzl,
  lsqb: Ezl,
  lsquo: Tzl,
  lsquor: Azl,
  Lstrok: Czl,
  lstrok: zzl,
  ltcc: Ozl,
  ltcir: Pzl,
  lt: Izl,
  LT: Rzl,
  Lt: Nzl,
  ltdot: Dzl,
  lthree: Mzl,
  ltimes: Lzl,
  ltlarr: qzl,
  ltquest: jzl,
  ltri: Fzl,
  ltrie: Vzl,
  ltrif: Bzl,
  ltrPar: Uzl,
  lurdshar: Wzl,
  luruhar: Gzl,
  lvertneqq: Hzl,
  lvnE: Kzl,
  macr: Yzl,
  male: Zzl,
  malt: Qzl,
  maltese: Jzl,
  Map: "⤅",
  map: Xzl,
  mapsto: eOl,
  mapstodown: tOl,
  mapstoleft: nOl,
  mapstoup: oOl,
  marker: rOl,
  mcomma: iOl,
  Mcy: aOl,
  mcy: sOl,
  mdash: cOl,
  mDDot: lOl,
  measuredangle: dOl,
  MediumSpace: uOl,
  Mellintrf: _Ol,
  Mfr: pOl,
  mfr: mOl,
  mho: fOl,
  micro: gOl,
  midast: hOl,
  midcir: vOl,
  mid: bOl,
  middot: yOl,
  minusb: $Ol,
  minus: wOl,
  minusd: kOl,
  minusdu: SOl,
  MinusPlus: xOl,
  mlcp: EOl,
  mldr: TOl,
  mnplus: AOl,
  models: COl,
  Mopf: zOl,
  mopf: OOl,
  mp: POl,
  mscr: IOl,
  Mscr: ROl,
  mstpos: NOl,
  Mu: DOl,
  mu: MOl,
  multimap: LOl,
  mumap: qOl,
  nabla: jOl,
  Nacute: FOl,
  nacute: VOl,
  nang: BOl,
  nap: UOl,
  napE: WOl,
  napid: GOl,
  napos: HOl,
  napprox: KOl,
  natural: YOl,
  naturals: ZOl,
  natur: QOl,
  nbsp: JOl,
  nbump: XOl,
  nbumpe: e4l,
  ncap: t4l,
  Ncaron: n4l,
  ncaron: o4l,
  Ncedil: r4l,
  ncedil: i4l,
  ncong: a4l,
  ncongdot: s4l,
  ncup: c4l,
  Ncy: l4l,
  ncy: d4l,
  ndash: u4l,
  nearhk: _4l,
  nearr: p4l,
  neArr: m4l,
  nearrow: f4l,
  ne: g4l,
  nedot: h4l,
  NegativeMediumSpace: v4l,
  NegativeThickSpace: b4l,
  NegativeThinSpace: y4l,
  NegativeVeryThinSpace: $4l,
  nequiv: w4l,
  nesear: k4l,
  nesim: S4l,
  NestedGreaterGreater: x4l,
  NestedLessLess: E4l,
  NewLine: T4l,
  nexist: A4l,
  nexists: C4l,
  Nfr: z4l,
  nfr: O4l,
  ngE: P4l,
  nge: I4l,
  ngeq: R4l,
  ngeqq: N4l,
  ngeqslant: D4l,
  nges: M4l,
  nGg: L4l,
  ngsim: q4l,
  nGt: j4l,
  ngt: F4l,
  ngtr: V4l,
  nGtv: B4l,
  nharr: U4l,
  nhArr: W4l,
  nhpar: G4l,
  ni: H4l,
  nis: K4l,
  nisd: Y4l,
  niv: Z4l,
  NJcy: Q4l,
  njcy: J4l,
  nlarr: X4l,
  nlArr: e3l,
  nldr: t3l,
  nlE: n3l,
  nle: o3l,
  nleftarrow: r3l,
  nLeftarrow: i3l,
  nleftrightarrow: a3l,
  nLeftrightarrow: s3l,
  nleq: c3l,
  nleqq: l3l,
  nleqslant: d3l,
  nles: u3l,
  nless: _3l,
  nLl: p3l,
  nlsim: m3l,
  nLt: f3l,
  nlt: g3l,
  nltri: h3l,
  nltrie: v3l,
  nLtv: b3l,
  nmid: y3l,
  NoBreak: $3l,
  NonBreakingSpace: w3l,
  nopf: k3l,
  Nopf: S3l,
  Not: x3l,
  not: E3l,
  NotCongruent: T3l,
  NotCupCap: A3l,
  NotDoubleVerticalBar: C3l,
  NotElement: z3l,
  NotEqual: O3l,
  NotEqualTilde: P3l,
  NotExists: I3l,
  NotGreater: R3l,
  NotGreaterEqual: N3l,
  NotGreaterFullEqual: D3l,
  NotGreaterGreater: M3l,
  NotGreaterLess: L3l,
  NotGreaterSlantEqual: q3l,
  NotGreaterTilde: j3l,
  NotHumpDownHump: F3l,
  NotHumpEqual: V3l,
  notin: B3l,
  notindot: U3l,
  notinE: W3l,
  notinva: G3l,
  notinvb: H3l,
  notinvc: K3l,
  NotLeftTriangleBar: Y3l,
  NotLeftTriangle: Z3l,
  NotLeftTriangleEqual: Q3l,
  NotLess: J3l,
  NotLessEqual: X3l,
  NotLessGreater: e6l,
  NotLessLess: t6l,
  NotLessSlantEqual: n6l,
  NotLessTilde: o6l,
  NotNestedGreaterGreater: r6l,
  NotNestedLessLess: i6l,
  notni: a6l,
  notniva: s6l,
  notnivb: c6l,
  notnivc: l6l,
  NotPrecedes: d6l,
  NotPrecedesEqual: u6l,
  NotPrecedesSlantEqual: _6l,
  NotReverseElement: p6l,
  NotRightTriangleBar: m6l,
  NotRightTriangle: f6l,
  NotRightTriangleEqual: g6l,
  NotSquareSubset: h6l,
  NotSquareSubsetEqual: v6l,
  NotSquareSuperset: b6l,
  NotSquareSupersetEqual: y6l,
  NotSubset: $6l,
  NotSubsetEqual: w6l,
  NotSucceeds: k6l,
  NotSucceedsEqual: S6l,
  NotSucceedsSlantEqual: x6l,
  NotSucceedsTilde: E6l,
  NotSuperset: T6l,
  NotSupersetEqual: A6l,
  NotTilde: C6l,
  NotTildeEqual: z6l,
  NotTildeFullEqual: O6l,
  NotTildeTilde: P6l,
  NotVerticalBar: I6l,
  nparallel: R6l,
  npar: N6l,
  nparsl: D6l,
  npart: M6l,
  npolint: L6l,
  npr: q6l,
  nprcue: j6l,
  nprec: F6l,
  npreceq: V6l,
  npre: B6l,
  nrarrc: U6l,
  nrarr: W6l,
  nrArr: G6l,
  nrarrw: H6l,
  nrightarrow: K6l,
  nRightarrow: Y6l,
  nrtri: Z6l,
  nrtrie: Q6l,
  nsc: J6l,
  nsccue: X6l,
  nsce: e5l,
  Nscr: t5l,
  nscr: n5l,
  nshortmid: o5l,
  nshortparallel: r5l,
  nsim: i5l,
  nsime: a5l,
  nsimeq: s5l,
  nsmid: c5l,
  nspar: l5l,
  nsqsube: d5l,
  nsqsupe: u5l,
  nsub: _5l,
  nsubE: p5l,
  nsube: m5l,
  nsubset: f5l,
  nsubseteq: g5l,
  nsubseteqq: h5l,
  nsucc: v5l,
  nsucceq: b5l,
  nsup: y5l,
  nsupE: $5l,
  nsupe: w5l,
  nsupset: k5l,
  nsupseteq: S5l,
  nsupseteqq: x5l,
  ntgl: E5l,
  Ntilde: T5l,
  ntilde: A5l,
  ntlg: C5l,
  ntriangleleft: z5l,
  ntrianglelefteq: O5l,
  ntriangleright: P5l,
  ntrianglerighteq: I5l,
  Nu: R5l,
  nu: N5l,
  num: D5l,
  numero: M5l,
  numsp: L5l,
  nvap: q5l,
  nvdash: j5l,
  nvDash: F5l,
  nVdash: V5l,
  nVDash: B5l,
  nvge: U5l,
  nvgt: W5l,
  nvHarr: G5l,
  nvinfin: H5l,
  nvlArr: K5l,
  nvle: Y5l,
  nvlt: Z5l,
  nvltrie: Q5l,
  nvrArr: J5l,
  nvrtrie: X5l,
  nvsim: ePl,
  nwarhk: tPl,
  nwarr: nPl,
  nwArr: oPl,
  nwarrow: rPl,
  nwnear: iPl,
  Oacute: aPl,
  oacute: sPl,
  oast: cPl,
  Ocirc: lPl,
  ocirc: dPl,
  ocir: uPl,
  Ocy: _Pl,
  ocy: pPl,
  odash: mPl,
  Odblac: fPl,
  odblac: gPl,
  odiv: hPl,
  odot: vPl,
  odsold: bPl,
  OElig: yPl,
  oelig: $Pl,
  ofcir: wPl,
  Ofr: kPl,
  ofr: SPl,
  ogon: xPl,
  Ograve: EPl,
  ograve: TPl,
  ogt: APl,
  ohbar: CPl,
  ohm: zPl,
  oint: OPl,
  olarr: PPl,
  olcir: IPl,
  olcross: RPl,
  oline: NPl,
  olt: DPl,
  Omacr: MPl,
  omacr: LPl,
  Omega: qPl,
  omega: jPl,
  Omicron: FPl,
  omicron: VPl,
  omid: BPl,
  ominus: UPl,
  Oopf: WPl,
  oopf: GPl,
  opar: HPl,
  OpenCurlyDoubleQuote: KPl,
  OpenCurlyQuote: YPl,
  operp: ZPl,
  oplus: QPl,
  orarr: JPl,
  Or: XPl,
  or: eIl,
  ord: tIl,
  order: nIl,
  orderof: oIl,
  ordf: rIl,
  ordm: iIl,
  origof: aIl,
  oror: sIl,
  orslope: cIl,
  orv: lIl,
  oS: dIl,
  Oscr: uIl,
  oscr: _Il,
  Oslash: pIl,
  oslash: mIl,
  osol: fIl,
  Otilde: gIl,
  otilde: hIl,
  otimesas: vIl,
  Otimes: bIl,
  otimes: yIl,
  Ouml: $Il,
  ouml: wIl,
  ovbar: kIl,
  OverBar: SIl,
  OverBrace: xIl,
  OverBracket: EIl,
  OverParenthesis: TIl,
  para: AIl,
  parallel: CIl,
  par: zIl,
  parsim: OIl,
  parsl: PIl,
  part: IIl,
  PartialD: RIl,
  Pcy: NIl,
  pcy: DIl,
  percnt: MIl,
  period: LIl,
  permil: qIl,
  perp: jIl,
  pertenk: FIl,
  Pfr: VIl,
  pfr: BIl,
  Phi: UIl,
  phi: WIl,
  phiv: GIl,
  phmmat: HIl,
  phone: KIl,
  Pi: YIl,
  pi: ZIl,
  pitchfork: QIl,
  piv: JIl,
  planck: XIl,
  planckh: eRl,
  plankv: tRl,
  plusacir: nRl,
  plusb: oRl,
  pluscir: rRl,
  plus: iRl,
  plusdo: aRl,
  plusdu: sRl,
  pluse: cRl,
  PlusMinus: lRl,
  plusmn: dRl,
  plussim: uRl,
  plustwo: _Rl,
  pm: pRl,
  Poincareplane: mRl,
  pointint: fRl,
  popf: gRl,
  Popf: hRl,
  pound: vRl,
  prap: bRl,
  Pr: yRl,
  pr: $Rl,
  prcue: wRl,
  precapprox: kRl,
  prec: SRl,
  preccurlyeq: xRl,
  Precedes: ERl,
  PrecedesEqual: TRl,
  PrecedesSlantEqual: ARl,
  PrecedesTilde: CRl,
  preceq: zRl,
  precnapprox: ORl,
  precneqq: PRl,
  precnsim: IRl,
  pre: RRl,
  prE: NRl,
  precsim: DRl,
  prime: MRl,
  Prime: LRl,
  primes: qRl,
  prnap: jRl,
  prnE: FRl,
  prnsim: VRl,
  prod: BRl,
  Product: URl,
  profalar: WRl,
  profline: GRl,
  profsurf: HRl,
  prop: KRl,
  Proportional: YRl,
  Proportion: ZRl,
  propto: QRl,
  prsim: JRl,
  prurel: XRl,
  Pscr: eNl,
  pscr: tNl,
  Psi: nNl,
  psi: oNl,
  puncsp: rNl,
  Qfr: iNl,
  qfr: aNl,
  qint: sNl,
  qopf: cNl,
  Qopf: lNl,
  qprime: dNl,
  Qscr: uNl,
  qscr: _Nl,
  quaternions: pNl,
  quatint: mNl,
  quest: fNl,
  questeq: gNl,
  quot: hNl,
  QUOT: vNl,
  rAarr: bNl,
  race: yNl,
  Racute: $Nl,
  racute: wNl,
  radic: kNl,
  raemptyv: SNl,
  rang: xNl,
  Rang: ENl,
  rangd: TNl,
  range: ANl,
  rangle: CNl,
  raquo: zNl,
  rarrap: ONl,
  rarrb: PNl,
  rarrbfs: INl,
  rarrc: RNl,
  rarr: NNl,
  Rarr: DNl,
  rArr: MNl,
  rarrfs: LNl,
  rarrhk: qNl,
  rarrlp: jNl,
  rarrpl: FNl,
  rarrsim: VNl,
  Rarrtl: BNl,
  rarrtl: UNl,
  rarrw: WNl,
  ratail: GNl,
  rAtail: HNl,
  ratio: KNl,
  rationals: YNl,
  rbarr: ZNl,
  rBarr: QNl,
  RBarr: JNl,
  rbbrk: XNl,
  rbrace: eDl,
  rbrack: tDl,
  rbrke: nDl,
  rbrksld: oDl,
  rbrkslu: rDl,
  Rcaron: iDl,
  rcaron: aDl,
  Rcedil: sDl,
  rcedil: cDl,
  rceil: lDl,
  rcub: dDl,
  Rcy: uDl,
  rcy: _Dl,
  rdca: pDl,
  rdldhar: mDl,
  rdquo: fDl,
  rdquor: gDl,
  rdsh: hDl,
  real: vDl,
  realine: bDl,
  realpart: yDl,
  reals: $Dl,
  Re: wDl,
  rect: kDl,
  reg: SDl,
  REG: xDl,
  ReverseElement: EDl,
  ReverseEquilibrium: TDl,
  ReverseUpEquilibrium: ADl,
  rfisht: CDl,
  rfloor: zDl,
  rfr: ODl,
  Rfr: PDl,
  rHar: IDl,
  rhard: RDl,
  rharu: NDl,
  rharul: DDl,
  Rho: MDl,
  rho: LDl,
  rhov: qDl,
  RightAngleBracket: jDl,
  RightArrowBar: FDl,
  rightarrow: VDl,
  RightArrow: BDl,
  Rightarrow: UDl,
  RightArrowLeftArrow: WDl,
  rightarrowtail: GDl,
  RightCeiling: HDl,
  RightDoubleBracket: KDl,
  RightDownTeeVector: YDl,
  RightDownVectorBar: ZDl,
  RightDownVector: QDl,
  RightFloor: JDl,
  rightharpoondown: XDl,
  rightharpoonup: eMl,
  rightleftarrows: tMl,
  rightleftharpoons: nMl,
  rightrightarrows: oMl,
  rightsquigarrow: rMl,
  RightTeeArrow: iMl,
  RightTee: aMl,
  RightTeeVector: sMl,
  rightthreetimes: cMl,
  RightTriangleBar: lMl,
  RightTriangle: dMl,
  RightTriangleEqual: uMl,
  RightUpDownVector: _Ml,
  RightUpTeeVector: pMl,
  RightUpVectorBar: mMl,
  RightUpVector: fMl,
  RightVectorBar: gMl,
  RightVector: hMl,
  ring: vMl,
  risingdotseq: bMl,
  rlarr: yMl,
  rlhar: $Ml,
  rlm: wMl,
  rmoustache: kMl,
  rmoust: SMl,
  rnmid: xMl,
  roang: EMl,
  roarr: TMl,
  robrk: AMl,
  ropar: CMl,
  ropf: zMl,
  Ropf: OMl,
  roplus: PMl,
  rotimes: IMl,
  RoundImplies: RMl,
  rpar: NMl,
  rpargt: DMl,
  rppolint: MMl,
  rrarr: LMl,
  Rrightarrow: qMl,
  rsaquo: jMl,
  rscr: FMl,
  Rscr: VMl,
  rsh: BMl,
  Rsh: UMl,
  rsqb: WMl,
  rsquo: GMl,
  rsquor: HMl,
  rthree: KMl,
  rtimes: YMl,
  rtri: ZMl,
  rtrie: QMl,
  rtrif: JMl,
  rtriltri: XMl,
  RuleDelayed: eLl,
  ruluhar: tLl,
  rx: nLl,
  Sacute: oLl,
  sacute: rLl,
  sbquo: iLl,
  scap: aLl,
  Scaron: sLl,
  scaron: cLl,
  Sc: lLl,
  sc: dLl,
  sccue: uLl,
  sce: _Ll,
  scE: pLl,
  Scedil: mLl,
  scedil: fLl,
  Scirc: gLl,
  scirc: hLl,
  scnap: vLl,
  scnE: bLl,
  scnsim: yLl,
  scpolint: $Ll,
  scsim: wLl,
  Scy: kLl,
  scy: SLl,
  sdotb: xLl,
  sdot: ELl,
  sdote: TLl,
  searhk: ALl,
  searr: CLl,
  seArr: zLl,
  searrow: OLl,
  sect: PLl,
  semi: ILl,
  seswar: RLl,
  setminus: NLl,
  setmn: DLl,
  sext: MLl,
  Sfr: LLl,
  sfr: qLl,
  sfrown: jLl,
  sharp: FLl,
  SHCHcy: VLl,
  shchcy: BLl,
  SHcy: ULl,
  shcy: WLl,
  ShortDownArrow: GLl,
  ShortLeftArrow: HLl,
  shortmid: KLl,
  shortparallel: YLl,
  ShortRightArrow: ZLl,
  ShortUpArrow: QLl,
  shy: JLl,
  Sigma: XLl,
  sigma: eql,
  sigmaf: tql,
  sigmav: nql,
  sim: oql,
  simdot: rql,
  sime: iql,
  simeq: aql,
  simg: sql,
  simgE: cql,
  siml: lql,
  simlE: dql,
  simne: uql,
  simplus: _ql,
  simrarr: pql,
  slarr: mql,
  SmallCircle: fql,
  smallsetminus: gql,
  smashp: hql,
  smeparsl: vql,
  smid: bql,
  smile: yql,
  smt: $ql,
  smte: wql,
  smtes: kql,
  SOFTcy: Sql,
  softcy: xql,
  solbar: Eql,
  solb: Tql,
  sol: Aql,
  Sopf: Cql,
  sopf: zql,
  spades: Oql,
  spadesuit: Pql,
  spar: Iql,
  sqcap: Rql,
  sqcaps: Nql,
  sqcup: Dql,
  sqcups: Mql,
  Sqrt: Lql,
  sqsub: qql,
  sqsube: jql,
  sqsubset: Fql,
  sqsubseteq: Vql,
  sqsup: Bql,
  sqsupe: Uql,
  sqsupset: Wql,
  sqsupseteq: Gql,
  square: Hql,
  Square: Kql,
  SquareIntersection: Yql,
  SquareSubset: Zql,
  SquareSubsetEqual: Qql,
  SquareSuperset: Jql,
  SquareSupersetEqual: Xql,
  SquareUnion: e9l,
  squarf: t9l,
  squ: n9l,
  squf: o9l,
  srarr: r9l,
  Sscr: i9l,
  sscr: a9l,
  ssetmn: s9l,
  ssmile: c9l,
  sstarf: l9l,
  Star: d9l,
  star: u9l,
  starf: _9l,
  straightepsilon: p9l,
  straightphi: m9l,
  strns: f9l,
  sub: g9l,
  Sub: h9l,
  subdot: v9l,
  subE: b9l,
  sube: y9l,
  subedot: $9l,
  submult: w9l,
  subnE: k9l,
  subne: S9l,
  subplus: x9l,
  subrarr: E9l,
  subset: T9l,
  Subset: A9l,
  subseteq: C9l,
  subseteqq: z9l,
  SubsetEqual: O9l,
  subsetneq: P9l,
  subsetneqq: I9l,
  subsim: R9l,
  subsub: N9l,
  subsup: D9l,
  succapprox: M9l,
  succ: L9l,
  succcurlyeq: q9l,
  Succeeds: j9l,
  SucceedsEqual: F9l,
  SucceedsSlantEqual: V9l,
  SucceedsTilde: B9l,
  succeq: U9l,
  succnapprox: W9l,
  succneqq: G9l,
  succnsim: H9l,
  succsim: K9l,
  SuchThat: Y9l,
  sum: Z9l,
  Sum: Q9l,
  sung: J9l,
  sup1: X9l,
  sup2: ejl,
  sup3: tjl,
  sup: njl,
  Sup: ojl,
  supdot: rjl,
  supdsub: ijl,
  supE: ajl,
  supe: sjl,
  supedot: cjl,
  Superset: ljl,
  SupersetEqual: djl,
  suphsol: ujl,
  suphsub: _jl,
  suplarr: pjl,
  supmult: mjl,
  supnE: fjl,
  supne: gjl,
  supplus: hjl,
  supset: vjl,
  Supset: bjl,
  supseteq: yjl,
  supseteqq: $jl,
  supsetneq: wjl,
  supsetneqq: kjl,
  supsim: Sjl,
  supsub: xjl,
  supsup: Ejl,
  swarhk: Tjl,
  swarr: Ajl,
  swArr: Cjl,
  swarrow: zjl,
  swnwar: Ojl,
  szlig: Pjl,
  Tab: Ijl,
  target: Rjl,
  Tau: Njl,
  tau: Djl,
  tbrk: Mjl,
  Tcaron: Ljl,
  tcaron: qjl,
  Tcedil: jjl,
  tcedil: Fjl,
  Tcy: Vjl,
  tcy: Bjl,
  tdot: Ujl,
  telrec: Wjl,
  Tfr: Gjl,
  tfr: Hjl,
  there4: Kjl,
  therefore: Yjl,
  Therefore: Zjl,
  Theta: Qjl,
  theta: Jjl,
  thetasym: Xjl,
  thetav: eFl,
  thickapprox: tFl,
  thicksim: nFl,
  ThickSpace: oFl,
  ThinSpace: rFl,
  thinsp: iFl,
  thkap: aFl,
  thksim: sFl,
  THORN: cFl,
  thorn: lFl,
  tilde: dFl,
  Tilde: uFl,
  TildeEqual: _Fl,
  TildeFullEqual: pFl,
  TildeTilde: mFl,
  timesbar: fFl,
  timesb: gFl,
  times: hFl,
  timesd: vFl,
  tint: bFl,
  toea: yFl,
  topbot: $Fl,
  topcir: wFl,
  top: kFl,
  Topf: SFl,
  topf: xFl,
  topfork: EFl,
  tosa: TFl,
  tprime: AFl,
  trade: CFl,
  TRADE: zFl,
  triangle: OFl,
  triangledown: PFl,
  triangleleft: IFl,
  trianglelefteq: RFl,
  triangleq: NFl,
  triangleright: DFl,
  trianglerighteq: MFl,
  tridot: LFl,
  trie: qFl,
  triminus: jFl,
  TripleDot: FFl,
  triplus: VFl,
  trisb: BFl,
  tritime: UFl,
  trpezium: WFl,
  Tscr: GFl,
  tscr: HFl,
  TScy: KFl,
  tscy: YFl,
  TSHcy: ZFl,
  tshcy: QFl,
  Tstrok: JFl,
  tstrok: XFl,
  twixt: e8l,
  twoheadleftarrow: t8l,
  twoheadrightarrow: n8l,
  Uacute: o8l,
  uacute: r8l,
  uarr: i8l,
  Uarr: a8l,
  uArr: s8l,
  Uarrocir: c8l,
  Ubrcy: l8l,
  ubrcy: d8l,
  Ubreve: u8l,
  ubreve: _8l,
  Ucirc: p8l,
  ucirc: m8l,
  Ucy: f8l,
  ucy: g8l,
  udarr: h8l,
  Udblac: v8l,
  udblac: b8l,
  udhar: y8l,
  ufisht: $8l,
  Ufr: w8l,
  ufr: k8l,
  Ugrave: S8l,
  ugrave: x8l,
  uHar: E8l,
  uharl: T8l,
  uharr: A8l,
  uhblk: C8l,
  ulcorn: z8l,
  ulcorner: O8l,
  ulcrop: P8l,
  ultri: I8l,
  Umacr: R8l,
  umacr: N8l,
  uml: D8l,
  UnderBar: M8l,
  UnderBrace: L8l,
  UnderBracket: q8l,
  UnderParenthesis: j8l,
  Union: F8l,
  UnionPlus: V8l,
  Uogon: B8l,
  uogon: U8l,
  Uopf: W8l,
  uopf: G8l,
  UpArrowBar: H8l,
  uparrow: K8l,
  UpArrow: Y8l,
  Uparrow: Z8l,
  UpArrowDownArrow: Q8l,
  updownarrow: J8l,
  UpDownArrow: X8l,
  Updownarrow: e7l,
  UpEquilibrium: t7l,
  upharpoonleft: n7l,
  upharpoonright: o7l,
  uplus: r7l,
  UpperLeftArrow: i7l,
  UpperRightArrow: a7l,
  upsi: s7l,
  Upsi: c7l,
  upsih: l7l,
  Upsilon: d7l,
  upsilon: u7l,
  UpTeeArrow: _7l,
  UpTee: p7l,
  upuparrows: m7l,
  urcorn: f7l,
  urcorner: g7l,
  urcrop: h7l,
  Uring: v7l,
  uring: b7l,
  urtri: y7l,
  Uscr: $7l,
  uscr: w7l,
  utdot: k7l,
  Utilde: S7l,
  utilde: x7l,
  utri: E7l,
  utrif: T7l,
  uuarr: A7l,
  Uuml: C7l,
  uuml: z7l,
  uwangle: O7l,
  vangrt: P7l,
  varepsilon: I7l,
  varkappa: R7l,
  varnothing: N7l,
  varphi: D7l,
  varpi: M7l,
  varpropto: L7l,
  varr: q7l,
  vArr: j7l,
  varrho: F7l,
  varsigma: V7l,
  varsubsetneq: B7l,
  varsubsetneqq: U7l,
  varsupsetneq: W7l,
  varsupsetneqq: G7l,
  vartheta: H7l,
  vartriangleleft: K7l,
  vartriangleright: Y7l,
  vBar: Z7l,
  Vbar: Q7l,
  vBarv: J7l,
  Vcy: X7l,
  vcy: eVl,
  vdash: tVl,
  vDash: nVl,
  Vdash: oVl,
  VDash: rVl,
  Vdashl: iVl,
  veebar: aVl,
  vee: sVl,
  Vee: cVl,
  veeeq: lVl,
  vellip: dVl,
  verbar: uVl,
  Verbar: _Vl,
  vert: pVl,
  Vert: mVl,
  VerticalBar: fVl,
  VerticalLine: gVl,
  VerticalSeparator: hVl,
  VerticalTilde: vVl,
  VeryThinSpace: bVl,
  Vfr: yVl,
  vfr: $Vl,
  vltri: wVl,
  vnsub: kVl,
  vnsup: SVl,
  Vopf: xVl,
  vopf: EVl,
  vprop: TVl,
  vrtri: AVl,
  Vscr: CVl,
  vscr: zVl,
  vsubnE: OVl,
  vsubne: PVl,
  vsupnE: IVl,
  vsupne: RVl,
  Vvdash: NVl,
  vzigzag: DVl,
  Wcirc: MVl,
  wcirc: LVl,
  wedbar: qVl,
  wedge: jVl,
  Wedge: FVl,
  wedgeq: VVl,
  weierp: BVl,
  Wfr: UVl,
  wfr: WVl,
  Wopf: GVl,
  wopf: HVl,
  wp: KVl,
  wr: YVl,
  wreath: ZVl,
  Wscr: QVl,
  wscr: JVl,
  xcap: XVl,
  xcirc: eBl,
  xcup: tBl,
  xdtri: nBl,
  Xfr: oBl,
  xfr: rBl,
  xharr: iBl,
  xhArr: aBl,
  Xi: sBl,
  xi: cBl,
  xlarr: lBl,
  xlArr: dBl,
  xmap: uBl,
  xnis: _Bl,
  xodot: pBl,
  Xopf: mBl,
  xopf: fBl,
  xoplus: gBl,
  xotime: hBl,
  xrarr: vBl,
  xrArr: bBl,
  Xscr: yBl,
  xscr: $Bl,
  xsqcup: wBl,
  xuplus: kBl,
  xutri: SBl,
  xvee: xBl,
  xwedge: EBl,
  Yacute: TBl,
  yacute: ABl,
  YAcy: CBl,
  yacy: zBl,
  Ycirc: OBl,
  ycirc: PBl,
  Ycy: IBl,
  ycy: RBl,
  yen: NBl,
  Yfr: DBl,
  yfr: MBl,
  YIcy: LBl,
  yicy: qBl,
  Yopf: jBl,
  yopf: FBl,
  Yscr: VBl,
  yscr: BBl,
  YUcy: UBl,
  yucy: WBl,
  yuml: GBl,
  Yuml: HBl,
  Zacute: KBl,
  zacute: YBl,
  Zcaron: ZBl,
  zcaron: QBl,
  Zcy: JBl,
  zcy: XBl,
  Zdot: eUl,
  zdot: tUl,
  zeetrf: nUl,
  ZeroWidthSpace: oUl,
  Zeta: rUl,
  zeta: iUl,
  zfr: aUl,
  Zfr: sUl,
  ZHcy: cUl,
  zhcy: lUl,
  zigrarr: dUl,
  zopf: uUl,
  Zopf: _Ul,
  Zscr: pUl,
  zscr: mUl,
  zwj: fUl,
  zwnj: gUl
};
var Hve = hUl, RF = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, mb = {}, oJ = {};
function vUl(e) {
  var t, n, o = oJ[e];
  if (o)
    return o;
  for (o = oJ[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), /^[0-9a-z]$/i.test(n) ? o.push(n) : o.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  for (t = 0; t < e.length; t++)
    o[e.charCodeAt(t)] = e[t];
  return o;
}
function vC(e, t, n) {
  var o, r, i, a, s, c = "";
  for (typeof t != "string" && (n = t, t = vC.defaultChars), typeof n > "u" && (n = !0), s = vUl(t), o = 0, r = e.length; o < r; o++) {
    if (i = e.charCodeAt(o), n && i === 37 && o + 2 < r && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) {
      c += e.slice(o, o + 3), o += 2;
      continue;
    }
    if (i < 128) {
      c += s[i];
      continue;
    }
    if (i >= 55296 && i <= 57343) {
      if (i >= 55296 && i <= 56319 && o + 1 < r && (a = e.charCodeAt(o + 1), a >= 56320 && a <= 57343)) {
        c += encodeURIComponent(e[o] + e[o + 1]), o++;
        continue;
      }
      c += "%EF%BF%BD";
      continue;
    }
    c += encodeURIComponent(e[o]);
  }
  return c;
}
vC.defaultChars = ";/?:@&=+$,-_.!~*'()#";
vC.componentChars = "-_.!~*'()";
var bUl = vC, rJ = {};
function yUl(e) {
  var t, n, o = rJ[e];
  if (o)
    return o;
  for (o = rJ[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), o.push(n);
  for (t = 0; t < e.length; t++)
    n = e.charCodeAt(t), o[n] = "%" + ("0" + n.toString(16).toUpperCase()).slice(-2);
  return o;
}
function bC(e, t) {
  var n;
  return typeof t != "string" && (t = bC.defaultChars), n = yUl(t), e.replace(/(%[a-f0-9]{2})+/gi, function(o) {
    var r, i, a, s, c, l, d, u = "";
    for (r = 0, i = o.length; r < i; r += 3) {
      if (a = parseInt(o.slice(r + 1, r + 3), 16), a < 128) {
        u += n[a];
        continue;
      }
      if ((a & 224) === 192 && r + 3 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), (s & 192) === 128)) {
        d = a << 6 & 1984 | s & 63, d < 128 ? u += "��" : u += String.fromCharCode(d), r += 3;
        continue;
      }
      if ((a & 240) === 224 && r + 6 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), c = parseInt(o.slice(r + 7, r + 9), 16), (s & 192) === 128 && (c & 192) === 128)) {
        d = a << 12 & 61440 | s << 6 & 4032 | c & 63, d < 2048 || d >= 55296 && d <= 57343 ? u += "���" : u += String.fromCharCode(d), r += 6;
        continue;
      }
      if ((a & 248) === 240 && r + 9 < i && (s = parseInt(o.slice(r + 4, r + 6), 16), c = parseInt(o.slice(r + 7, r + 9), 16), l = parseInt(o.slice(r + 10, r + 12), 16), (s & 192) === 128 && (c & 192) === 128 && (l & 192) === 128)) {
        d = a << 18 & 1835008 | s << 12 & 258048 | c << 6 & 4032 | l & 63, d < 65536 || d > 1114111 ? u += "����" : (d -= 65536, u += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), r += 9;
        continue;
      }
      u += "�";
    }
    return u;
  });
}
bC.defaultChars = ";/?:@&=+$,#";
bC.componentChars = "";
var $Ul = bC, wUl = function(t) {
  var n = "";
  return n += t.protocol || "", n += t.slashes ? "//" : "", n += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? n += "[" + t.hostname + "]" : n += t.hostname || "", n += t.port ? ":" + t.port : "", n += t.pathname || "", n += t.search || "", n += t.hash || "", n;
};
function JE() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
var kUl = /^([a-z0-9.+-]+:)/i, SUl = /:[0-9]*$/, xUl = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, EUl = ["<", ">", '"', "`", " ", "\r", `
`, "	"], TUl = ["{", "}", "|", "\\", "^", "`"].concat(EUl), AUl = ["'"].concat(TUl), iJ = ["%", "/", "?", ";", "#"].concat(AUl), aJ = ["/", "?", "#"], CUl = 255, sJ = /^[+a-z0-9A-Z_-]{0,63}$/, zUl = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, cJ = {
  javascript: !0,
  "javascript:": !0
}, lJ = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function OUl(e, t) {
  if (e && e instanceof JE)
    return e;
  var n = new JE();
  return n.parse(e, t), n;
}
JE.prototype.parse = function(e, t) {
  var n, o, r, i, a, s = e;
  if (s = s.trim(), !t && e.split("#").length === 1) {
    var c = xUl.exec(s);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  var l = kUl.exec(s);
  if (l && (l = l[0], r = l.toLowerCase(), this.protocol = l, s = s.substr(l.length)), (t || l || s.match(/^\/\/[^@\/]+@[^@\/]+/)) && (a = s.substr(0, 2) === "//", a && !(l && cJ[l]) && (s = s.substr(2), this.slashes = !0)), !cJ[l] && (a || l && !lJ[l])) {
    var d = -1;
    for (n = 0; n < aJ.length; n++)
      i = s.indexOf(aJ[n]), i !== -1 && (d === -1 || i < d) && (d = i);
    var u, _;
    for (d === -1 ? _ = s.lastIndexOf("@") : _ = s.lastIndexOf("@", d), _ !== -1 && (u = s.slice(0, _), s = s.slice(_ + 1), this.auth = u), d = -1, n = 0; n < iJ.length; n++)
      i = s.indexOf(iJ[n]), i !== -1 && (d === -1 || i < d) && (d = i);
    d === -1 && (d = s.length), s[d - 1] === ":" && d--;
    var p = s.slice(0, d);
    s = s.slice(d), this.parseHost(p), this.hostname = this.hostname || "";
    var f = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!f) {
      var g = this.hostname.split(/\./);
      for (n = 0, o = g.length; n < o; n++) {
        var h = g[n];
        if (h && !h.match(sJ)) {
          for (var b = "", v = 0, $ = h.length; v < $; v++)
            h.charCodeAt(v) > 127 ? b += "x" : b += h[v];
          if (!b.match(sJ)) {
            var k = g.slice(0, n), S = g.slice(n + 1), O = h.match(zUl);
            O && (k.push(O[1]), S.unshift(O[2])), S.length && (s = S.join(".") + s), this.hostname = k.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > CUl && (this.hostname = ""), f && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  var I = s.indexOf("#");
  I !== -1 && (this.hash = s.substr(I), s = s.slice(0, I));
  var D = s.indexOf("?");
  return D !== -1 && (this.search = s.substr(D), s = s.slice(0, D)), s && (this.pathname = s), lJ[r] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
JE.prototype.parseHost = function(e) {
  var t = SUl.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
var PUl = OUl;
mb.encode = bUl;
mb.decode = $Ul;
mb.format = wUl;
mb.parse = PUl;
var Im = {}, J6, dJ;
function Kve() {
  return dJ || (dJ = 1, J6 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), J6;
}
var X6, uJ;
function Yve() {
  return uJ || (uJ = 1, X6 = /[\0-\x1F\x7F-\x9F]/), X6;
}
var e5, _J;
function IUl() {
  return _J || (_J = 1, e5 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), e5;
}
var t5, pJ;
function Zve() {
  return pJ || (pJ = 1, t5 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), t5;
}
var mJ;
function RUl() {
  return mJ || (mJ = 1, Im.Any = Kve(), Im.Cc = Yve(), Im.Cf = IUl(), Im.P = RF, Im.Z = Zve()), Im;
}
(function(e) {
  function t(w) {
    return Object.prototype.toString.call(w);
  }
  function n(w) {
    return t(w) === "[object String]";
  }
  var o = Object.prototype.hasOwnProperty;
  function r(w, E) {
    return o.call(w, E);
  }
  function i(w) {
    var E = Array.prototype.slice.call(arguments, 1);
    return E.forEach(function(T) {
      if (T) {
        if (typeof T != "object")
          throw new TypeError(T + "must be object");
        Object.keys(T).forEach(function(z) {
          w[z] = T[z];
        });
      }
    }), w;
  }
  function a(w, E, T) {
    return [].concat(w.slice(0, E), T, w.slice(E + 1));
  }
  function s(w) {
    return !(w >= 55296 && w <= 57343 || w >= 64976 && w <= 65007 || (w & 65535) === 65535 || (w & 65535) === 65534 || w >= 0 && w <= 8 || w === 11 || w >= 14 && w <= 31 || w >= 127 && w <= 159 || w > 1114111);
  }
  function c(w) {
    if (w > 65535) {
      w -= 65536;
      var E = 55296 + (w >> 10), T = 56320 + (w & 1023);
      return String.fromCharCode(E, T);
    }
    return String.fromCharCode(w);
  }
  var l = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, d = /&([a-z#][a-z0-9]{1,31});/gi, u = new RegExp(l.source + "|" + d.source, "gi"), _ = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i, p = Hve;
  function f(w, E) {
    var T = 0;
    return r(p, E) ? p[E] : E.charCodeAt(0) === 35 && _.test(E) && (T = E[1].toLowerCase() === "x" ? parseInt(E.slice(2), 16) : parseInt(E.slice(1), 10), s(T)) ? c(T) : w;
  }
  function g(w) {
    return w.indexOf("\\") < 0 ? w : w.replace(l, "$1");
  }
  function h(w) {
    return w.indexOf("\\") < 0 && w.indexOf("&") < 0 ? w : w.replace(u, function(E, T, z) {
      return T || f(E, z);
    });
  }
  var b = /[&<>"]/, v = /[&<>"]/g, $ = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
  };
  function k(w) {
    return $[w];
  }
  function S(w) {
    return b.test(w) ? w.replace(v, k) : w;
  }
  var O = /[.?*+^$[\]\\(){}|-]/g;
  function I(w) {
    return w.replace(O, "\\$&");
  }
  function D(w) {
    switch (w) {
      case 9:
      case 32:
        return !0;
    }
    return !1;
  }
  function M(w) {
    if (w >= 8192 && w <= 8202)
      return !0;
    switch (w) {
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 32:
      case 160:
      case 5760:
      case 8239:
      case 8287:
      case 12288:
        return !0;
    }
    return !1;
  }
  var N = RF;
  function C(w) {
    return N.test(w);
  }
  function P(w) {
    switch (w) {
      case 33:
      case 34:
      case 35:
      case 36:
      case 37:
      case 38:
      case 39:
      case 40:
      case 41:
      case 42:
      case 43:
      case 44:
      case 45:
      case 46:
      case 47:
      case 58:
      case 59:
      case 60:
      case 61:
      case 62:
      case 63:
      case 64:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 123:
      case 124:
      case 125:
      case 126:
        return !0;
      default:
        return !1;
    }
  }
  function x(w) {
    return w = w.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (w = w.replace(/ẞ/g, "ß")), w.toLowerCase().toUpperCase();
  }
  e.lib = {}, e.lib.mdurl = mb, e.lib.ucmicro = RUl(), e.assign = i, e.isString = n, e.has = r, e.unescapeMd = g, e.unescapeAll = h, e.isValidEntityCode = s, e.fromCodePoint = c, e.escapeHtml = S, e.arrayReplaceAt = a, e.isSpace = D, e.isWhiteSpace = M, e.isMdAsciiPunct = P, e.isPunctChar = C, e.escapeRE = I, e.normalizeReference = x;
})(ar);
var yC = {}, NUl = function(t, n, o) {
  var r, i, a, s, c = -1, l = t.posMax, d = t.pos;
  for (t.pos = n + 1, r = 1; t.pos < l; ) {
    if (a = t.src.charCodeAt(t.pos), a === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (s = t.pos, t.md.inline.skipToken(t), a === 91) {
      if (s === t.pos - 1)
        r++;
      else if (o)
        return t.pos = d, -1;
    }
  }
  return i && (c = t.pos), t.pos = d, c;
}, fJ = ar.unescapeAll, DUl = function(t, n, o) {
  var r, i, a = 0, s = n, c = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (t.charCodeAt(n) === 60) {
    for (n++; n < o; ) {
      if (r = t.charCodeAt(n), r === 10 || r === 60)
        return c;
      if (r === 62)
        return c.pos = n + 1, c.str = fJ(t.slice(s + 1, n)), c.ok = !0, c;
      if (r === 92 && n + 1 < o) {
        n += 2;
        continue;
      }
      n++;
    }
    return c;
  }
  for (i = 0; n < o && (r = t.charCodeAt(n), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && n + 1 < o) {
      if (t.charCodeAt(n + 1) === 32)
        break;
      n += 2;
      continue;
    }
    if (r === 40 && (i++, i > 32))
      return c;
    if (r === 41) {
      if (i === 0)
        break;
      i--;
    }
    n++;
  }
  return s === n || i !== 0 || (c.str = fJ(t.slice(s, n)), c.lines = a, c.pos = n, c.ok = !0), c;
}, MUl = ar.unescapeAll, LUl = function(t, n, o) {
  var r, i, a = 0, s = n, c = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (n >= o || (i = t.charCodeAt(n), i !== 34 && i !== 39 && i !== 40))
    return c;
  for (n++, i === 40 && (i = 41); n < o; ) {
    if (r = t.charCodeAt(n), r === i)
      return c.pos = n + 1, c.lines = a, c.str = MUl(t.slice(s + 1, n)), c.ok = !0, c;
    if (r === 40 && i === 41)
      return c;
    r === 10 ? a++ : r === 92 && n + 1 < o && (n++, t.charCodeAt(n) === 10 && a++), n++;
  }
  return c;
};
yC.parseLinkLabel = NUl;
yC.parseLinkDestination = DUl;
yC.parseLinkTitle = LUl;
var qUl = ar.assign, jUl = ar.unescapeAll, Zf = ar.escapeHtml, hu = {};
hu.code_inline = function(e, t, n, o, r) {
  var i = e[t];
  return "<code" + r.renderAttrs(i) + ">" + Zf(e[t].content) + "</code>";
};
hu.code_block = function(e, t, n, o, r) {
  var i = e[t];
  return "<pre" + r.renderAttrs(i) + "><code>" + Zf(e[t].content) + `</code></pre>
`;
};
hu.fence = function(e, t, n, o, r) {
  var i = e[t], a = i.info ? jUl(i.info).trim() : "", s = "", c = "", l, d, u, _, p;
  return a && (u = a.split(/(\s+)/g), s = u[0], c = u.slice(2).join("")), n.highlight ? l = n.highlight(i.content, s, c) || Zf(i.content) : l = Zf(i.content), l.indexOf("<pre") === 0 ? l + `
` : a ? (d = i.attrIndex("class"), _ = i.attrs ? i.attrs.slice() : [], d < 0 ? _.push(["class", n.langPrefix + s]) : (_[d] = _[d].slice(), _[d][1] += " " + n.langPrefix + s), p = {
    attrs: _
  }, "<pre><code" + r.renderAttrs(p) + ">" + l + `</code></pre>
`) : "<pre><code" + r.renderAttrs(i) + ">" + l + `</code></pre>
`;
};
hu.image = function(e, t, n, o, r) {
  var i = e[t];
  return i.attrs[i.attrIndex("alt")][1] = r.renderInlineAsText(i.children, n, o), r.renderToken(e, t, n);
};
hu.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
hu.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
hu.text = function(e, t) {
  return Zf(e[t].content);
};
hu.html_block = function(e, t) {
  return e[t].content;
};
hu.html_inline = function(e, t) {
  return e[t].content;
};
function fb() {
  this.rules = qUl({}, hu);
}
fb.prototype.renderAttrs = function(t) {
  var n, o, r;
  if (!t.attrs)
    return "";
  for (r = "", n = 0, o = t.attrs.length; n < o; n++)
    r += " " + Zf(t.attrs[n][0]) + '="' + Zf(t.attrs[n][1]) + '"';
  return r;
};
fb.prototype.renderToken = function(t, n, o) {
  var r, i = "", a = !1, s = t[n];
  return s.hidden ? "" : (s.block && s.nesting !== -1 && n && t[n - 1].hidden && (i += `
`), i += (s.nesting === -1 ? "</" : "<") + s.tag, i += this.renderAttrs(s), s.nesting === 0 && o.xhtmlOut && (i += " /"), s.block && (a = !0, s.nesting === 1 && n + 1 < t.length && (r = t[n + 1], (r.type === "inline" || r.hidden || r.nesting === -1 && r.tag === s.tag) && (a = !1))), i += a ? `>
` : ">", i);
};
fb.prototype.renderInline = function(e, t, n) {
  for (var o, r = "", i = this.rules, a = 0, s = e.length; a < s; a++)
    o = e[a].type, typeof i[o] < "u" ? r += i[o](e, a, t, n, this) : r += this.renderToken(e, a, t);
  return r;
};
fb.prototype.renderInlineAsText = function(e, t, n) {
  for (var o = "", r = 0, i = e.length; r < i; r++)
    e[r].type === "text" ? o += e[r].content : e[r].type === "image" ? o += this.renderInlineAsText(e[r].children, t, n) : e[r].type === "softbreak" && (o += `
`);
  return o;
};
fb.prototype.render = function(e, t, n) {
  var o, r, i, a = "", s = this.rules;
  for (o = 0, r = e.length; o < r; o++)
    i = e[o].type, i === "inline" ? a += this.renderInline(e[o].children, t, n) : typeof s[i] < "u" ? a += s[e[o].type](e, o, t, n, this) : a += this.renderToken(e, o, t, n);
  return a;
};
var FUl = fb;
function bd() {
  this.__rules__ = [], this.__cache__ = null;
}
bd.prototype.__find__ = function(e) {
  for (var t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
bd.prototype.__compile__ = function() {
  var e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(o) {
      t.indexOf(o) < 0 && t.push(o);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(o) {
      o.enabled && (n && o.alt.indexOf(n) < 0 || e.__cache__[n].push(o.fn));
    });
  });
};
bd.prototype.at = function(e, t, n) {
  var o = this.__find__(e), r = n || {};
  if (o === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[o].fn = t, this.__rules__[o].alt = r.alt || [], this.__cache__ = null;
};
bd.prototype.before = function(e, t, n, o) {
  var r = this.__find__(e), i = o || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
bd.prototype.after = function(e, t, n, o) {
  var r = this.__find__(e), i = o || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
bd.prototype.push = function(e, t, n) {
  var o = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: o.alt || []
  }), this.__cache__ = null;
};
bd.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var n = [];
  return e.forEach(function(o) {
    var r = this.__find__(o);
    if (r < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[r].enabled = !0, n.push(o);
  }, this), this.__cache__ = null, n;
};
bd.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
bd.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  var n = [];
  return e.forEach(function(o) {
    var r = this.__find__(o);
    if (r < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[r].enabled = !1, n.push(o);
  }, this), this.__cache__ = null, n;
};
bd.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
var NF = bd, VUl = /\r\n?|\n/g, BUl = /\0/g, UUl = function(t) {
  var n;
  n = t.src.replace(VUl, `
`), n = n.replace(BUl, "�"), t.src = n;
}, WUl = function(t) {
  var n;
  t.inlineMode ? (n = new t.Token("inline", "", 0), n.content = t.src, n.map = [0, 1], n.children = [], t.tokens.push(n)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}, GUl = function(t) {
  var n = t.tokens, o, r, i;
  for (r = 0, i = n.length; r < i; r++)
    o = n[r], o.type === "inline" && t.md.inline.parse(o.content, t.md, t.env, o.children);
}, HUl = ar.arrayReplaceAt;
function KUl(e) {
  return /^<a[>\s]/i.test(e);
}
function YUl(e) {
  return /^<\/a\s*>/i.test(e);
}
var ZUl = function(t) {
  var n, o, r, i, a, s, c, l, d, u, _, p, f, g, h, b, v = t.tokens, $;
  if (t.md.options.linkify) {
    for (o = 0, r = v.length; o < r; o++)
      if (!(v[o].type !== "inline" || !t.md.linkify.pretest(v[o].content)))
        for (i = v[o].children, f = 0, n = i.length - 1; n >= 0; n--) {
          if (s = i[n], s.type === "link_close") {
            for (n--; i[n].level !== s.level && i[n].type !== "link_open"; )
              n--;
            continue;
          }
          if (s.type === "html_inline" && (KUl(s.content) && f > 0 && f--, YUl(s.content) && f++), !(f > 0) && s.type === "text" && t.md.linkify.test(s.content)) {
            for (d = s.content, $ = t.md.linkify.match(d), c = [], p = s.level, _ = 0, $.length > 0 && $[0].index === 0 && n > 0 && i[n - 1].type === "text_special" && ($ = $.slice(1)), l = 0; l < $.length; l++)
              g = $[l].url, h = t.md.normalizeLink(g), t.md.validateLink(h) && (b = $[l].text, $[l].schema ? $[l].schema === "mailto:" && !/^mailto:/i.test(b) ? b = t.md.normalizeLinkText("mailto:" + b).replace(/^mailto:/, "") : b = t.md.normalizeLinkText(b) : b = t.md.normalizeLinkText("http://" + b).replace(/^http:\/\//, ""), u = $[l].index, u > _ && (a = new t.Token("text", "", 0), a.content = d.slice(_, u), a.level = p, c.push(a)), a = new t.Token("link_open", "a", 1), a.attrs = [["href", h]], a.level = p++, a.markup = "linkify", a.info = "auto", c.push(a), a = new t.Token("text", "", 0), a.content = b, a.level = p, c.push(a), a = new t.Token("link_close", "a", -1), a.level = --p, a.markup = "linkify", a.info = "auto", c.push(a), _ = $[l].lastIndex);
            _ < d.length && (a = new t.Token("text", "", 0), a.content = d.slice(_), a.level = p, c.push(a)), v[o].children = i = HUl(i, n, c);
          }
        }
  }
}, Qve = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, QUl = /\((c|tm|r)\)/i, JUl = /\((c|tm|r)\)/ig, XUl = {
  c: "©",
  r: "®",
  tm: "™"
};
function eWl(e, t) {
  return XUl[t.toLowerCase()];
}
function tWl(e) {
  var t, n, o = 0;
  for (t = e.length - 1; t >= 0; t--)
    n = e[t], n.type === "text" && !o && (n.content = n.content.replace(JUl, eWl)), n.type === "link_open" && n.info === "auto" && o--, n.type === "link_close" && n.info === "auto" && o++;
}
function nWl(e) {
  var t, n, o = 0;
  for (t = e.length - 1; t >= 0; t--)
    n = e[t], n.type === "text" && !o && Qve.test(n.content) && (n.content = n.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), n.type === "link_open" && n.info === "auto" && o--, n.type === "link_close" && n.info === "auto" && o++;
}
var oWl = function(t) {
  var n;
  if (t.md.options.typographer)
    for (n = t.tokens.length - 1; n >= 0; n--)
      t.tokens[n].type === "inline" && (QUl.test(t.tokens[n].content) && tWl(t.tokens[n].children), Qve.test(t.tokens[n].content) && nWl(t.tokens[n].children));
}, gJ = ar.isWhiteSpace, hJ = ar.isPunctChar, vJ = ar.isMdAsciiPunct, rWl = /['"]/, bJ = /['"]/g, yJ = "’";
function Q2(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function iWl(e, t) {
  var n, o, r, i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O;
  for (k = [], n = 0; n < e.length; n++) {
    for (o = e[n], c = e[n].level, v = k.length - 1; v >= 0 && !(k[v].level <= c); v--)
      ;
    if (k.length = v + 1, o.type === "text") {
      r = o.content, a = 0, s = r.length;
      e:
        for (; a < s && (bJ.lastIndex = a, i = bJ.exec(r), !!i); ) {
          if (h = b = !0, a = i.index + 1, $ = i[0] === "'", d = 32, i.index - 1 >= 0)
            d = r.charCodeAt(i.index - 1);
          else
            for (v = n - 1; v >= 0 && !(e[v].type === "softbreak" || e[v].type === "hardbreak"); v--)
              if (e[v].content) {
                d = e[v].content.charCodeAt(e[v].content.length - 1);
                break;
              }
          if (u = 32, a < s)
            u = r.charCodeAt(a);
          else
            for (v = n + 1; v < e.length && !(e[v].type === "softbreak" || e[v].type === "hardbreak"); v++)
              if (e[v].content) {
                u = e[v].content.charCodeAt(0);
                break;
              }
          if (_ = vJ(d) || hJ(String.fromCharCode(d)), p = vJ(u) || hJ(String.fromCharCode(u)), f = gJ(d), g = gJ(u), g ? h = !1 : p && (f || _ || (h = !1)), f ? b = !1 : _ && (g || p || (b = !1)), u === 34 && i[0] === '"' && d >= 48 && d <= 57 && (b = h = !1), h && b && (h = _, b = p), !h && !b) {
            $ && (o.content = Q2(o.content, i.index, yJ));
            continue;
          }
          if (b) {
            for (v = k.length - 1; v >= 0 && (l = k[v], !(k[v].level < c)); v--)
              if (l.single === $ && k[v].level === c) {
                l = k[v], $ ? (S = t.md.options.quotes[2], O = t.md.options.quotes[3]) : (S = t.md.options.quotes[0], O = t.md.options.quotes[1]), o.content = Q2(o.content, i.index, O), e[l.token].content = Q2(
                  e[l.token].content,
                  l.pos,
                  S
                ), a += O.length - 1, l.token === n && (a += S.length - 1), r = o.content, s = r.length, k.length = v;
                continue e;
              }
          }
          h ? k.push({
            token: n,
            pos: i.index,
            single: $,
            level: c
          }) : b && $ && (o.content = Q2(o.content, i.index, yJ));
        }
    }
  }
}
var aWl = function(t) {
  var n;
  if (t.md.options.typographer)
    for (n = t.tokens.length - 1; n >= 0; n--)
      t.tokens[n].type !== "inline" || !rWl.test(t.tokens[n].content) || iWl(t.tokens[n].children, t);
}, sWl = function(t) {
  var n, o, r, i, a, s, c = t.tokens;
  for (n = 0, o = c.length; n < o; n++)
    if (c[n].type === "inline") {
      for (r = c[n].children, a = r.length, i = 0; i < a; i++)
        r[i].type === "text_special" && (r[i].type = "text");
      for (i = s = 0; i < a; i++)
        r[i].type === "text" && i + 1 < a && r[i + 1].type === "text" ? r[i + 1].content = r[i].content + r[i + 1].content : (i !== s && (r[s] = r[i]), s++);
      i !== s && (r.length = s);
    }
};
function gb(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
gb.prototype.attrIndex = function(t) {
  var n, o, r;
  if (!this.attrs)
    return -1;
  for (n = this.attrs, o = 0, r = n.length; o < r; o++)
    if (n[o][0] === t)
      return o;
  return -1;
};
gb.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
gb.prototype.attrSet = function(t, n) {
  var o = this.attrIndex(t), r = [t, n];
  o < 0 ? this.attrPush(r) : this.attrs[o] = r;
};
gb.prototype.attrGet = function(t) {
  var n = this.attrIndex(t), o = null;
  return n >= 0 && (o = this.attrs[n][1]), o;
};
gb.prototype.attrJoin = function(t, n) {
  var o = this.attrIndex(t);
  o < 0 ? this.attrPush([t, n]) : this.attrs[o][1] = this.attrs[o][1] + " " + n;
};
var DF = gb, cWl = DF;
function Jve(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
Jve.prototype.Token = cWl;
var lWl = Jve, dWl = NF, n5 = [
  ["normalize", UUl],
  ["block", WUl],
  ["inline", GUl],
  ["linkify", ZUl],
  ["replacements", oWl],
  ["smartquotes", aWl],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", sWl]
];
function MF() {
  this.ruler = new dWl();
  for (var e = 0; e < n5.length; e++)
    this.ruler.push(n5[e][0], n5[e][1]);
}
MF.prototype.process = function(e) {
  var t, n, o;
  for (o = this.ruler.getRules(""), t = 0, n = o.length; t < n; t++)
    o[t](e);
};
MF.prototype.State = lWl;
var uWl = MF, o5 = ar.isSpace;
function r5(e, t) {
  var n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  return e.src.slice(n, o);
}
function $J(e) {
  var t = [], n = 0, o = e.length, r, i = !1, a = 0, s = "";
  for (r = e.charCodeAt(n); n < o; )
    r === 124 && (i ? (s += e.substring(a, n - 1), a = n) : (t.push(s + e.substring(a, n)), s = "", a = n + 1)), i = r === 92, n++, r = e.charCodeAt(n);
  return t.push(s + e.substring(a)), t;
}
var _Wl = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O;
  if (n + 2 > o || (d = n + 1, t.sCount[d] < t.blkIndent) || t.sCount[d] - t.blkIndent >= 4 || (s = t.bMarks[d] + t.tShift[d], s >= t.eMarks[d]) || (S = t.src.charCodeAt(s++), S !== 124 && S !== 45 && S !== 58) || s >= t.eMarks[d] || (O = t.src.charCodeAt(s++), O !== 124 && O !== 45 && O !== 58 && !o5(O)) || S === 45 && o5(O))
    return !1;
  for (; s < t.eMarks[d]; ) {
    if (i = t.src.charCodeAt(s), i !== 124 && i !== 45 && i !== 58 && !o5(i))
      return !1;
    s++;
  }
  for (a = r5(t, n + 1), u = a.split("|"), f = [], c = 0; c < u.length; c++) {
    if (g = u[c].trim(), !g) {
      if (c === 0 || c === u.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(g))
      return !1;
    g.charCodeAt(g.length - 1) === 58 ? f.push(g.charCodeAt(0) === 58 ? "center" : "right") : g.charCodeAt(0) === 58 ? f.push("left") : f.push("");
  }
  if (a = r5(t, n).trim(), a.indexOf("|") === -1 || t.sCount[n] - t.blkIndent >= 4 || (u = $J(a), u.length && u[0] === "" && u.shift(), u.length && u[u.length - 1] === "" && u.pop(), _ = u.length, _ === 0 || _ !== f.length))
    return !1;
  if (r)
    return !0;
  for (v = t.parentType, t.parentType = "table", k = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), p.map = h = [n, 0], p = t.push("thead_open", "thead", 1), p.map = [n, n + 1], p = t.push("tr_open", "tr", 1), p.map = [n, n + 1], c = 0; c < u.length; c++)
    p = t.push("th_open", "th", 1), f[c] && (p.attrs = [["style", "text-align:" + f[c]]]), p = t.push("inline", "", 0), p.content = u[c].trim(), p.children = [], p = t.push("th_close", "th", -1);
  for (p = t.push("tr_close", "tr", -1), p = t.push("thead_close", "thead", -1), d = n + 2; d < o && !(t.sCount[d] < t.blkIndent); d++) {
    for ($ = !1, c = 0, l = k.length; c < l; c++)
      if (k[c](t, d, o, !0)) {
        $ = !0;
        break;
      }
    if ($ || (a = r5(t, d).trim(), !a) || t.sCount[d] - t.blkIndent >= 4)
      break;
    for (u = $J(a), u.length && u[0] === "" && u.shift(), u.length && u[u.length - 1] === "" && u.pop(), d === n + 2 && (p = t.push("tbody_open", "tbody", 1), p.map = b = [n + 2, 0]), p = t.push("tr_open", "tr", 1), p.map = [d, d + 1], c = 0; c < _; c++)
      p = t.push("td_open", "td", 1), f[c] && (p.attrs = [["style", "text-align:" + f[c]]]), p = t.push("inline", "", 0), p.content = u[c] ? u[c].trim() : "", p.children = [], p = t.push("td_close", "td", -1);
    p = t.push("tr_close", "tr", -1);
  }
  return b && (p = t.push("tbody_close", "tbody", -1), b[1] = d), p = t.push("table_close", "table", -1), h[1] = d, t.parentType = v, t.line = d, !0;
}, pWl = function(t, n, o) {
  var r, i, a;
  if (t.sCount[n] - t.blkIndent < 4)
    return !1;
  for (i = r = n + 1; r < o; ) {
    if (t.isEmpty(r)) {
      r++;
      continue;
    }
    if (t.sCount[r] - t.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  return t.line = i, a = t.push("code_block", "code", 0), a.content = t.getLines(n, i, 4 + t.blkIndent, !1) + `
`, a.map = [n, t.line], !0;
}, mWl = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _ = !1, p = t.bMarks[n] + t.tShift[n], f = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || p + 3 > f || (i = t.src.charCodeAt(p), i !== 126 && i !== 96) || (l = p, p = t.skipChars(p, i), a = p - l, a < 3) || (u = t.src.slice(l, p), s = t.src.slice(p, f), i === 96 && s.indexOf(String.fromCharCode(i)) >= 0))
    return !1;
  if (r)
    return !0;
  for (c = n; c++, !(c >= o || (p = l = t.bMarks[c] + t.tShift[c], f = t.eMarks[c], p < f && t.sCount[c] < t.blkIndent)); )
    if (t.src.charCodeAt(p) === i && !(t.sCount[c] - t.blkIndent >= 4) && (p = t.skipChars(p, i), !(p - l < a) && (p = t.skipSpaces(p), !(p < f)))) {
      _ = !0;
      break;
    }
  return a = t.sCount[n], t.line = c + (_ ? 1 : 0), d = t.push("fence", "code", 0), d.info = s, d.content = t.getLines(n + 1, c, a, !0), d.markup = u, d.map = [n, t.line], !0;
}, wJ = ar.isSpace, fWl = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O, I, D, M = t.lineMax, N = t.bMarks[n] + t.tShift[n], C = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || t.src.charCodeAt(N++) !== 62)
    return !1;
  if (r)
    return !0;
  for (c = p = t.sCount[n] + 1, t.src.charCodeAt(N) === 32 ? (N++, c++, p++, i = !1, k = !0) : t.src.charCodeAt(N) === 9 ? (k = !0, (t.bsCount[n] + p) % 4 === 3 ? (N++, c++, p++, i = !1) : i = !0) : k = !1, f = [t.bMarks[n]], t.bMarks[n] = N; N < C && (a = t.src.charCodeAt(N), wJ(a)); ) {
    a === 9 ? p += 4 - (p + t.bsCount[n] + (i ? 1 : 0)) % 4 : p++;
    N++;
  }
  for (g = [t.bsCount[n]], t.bsCount[n] = t.sCount[n] + 1 + (k ? 1 : 0), d = N >= C, v = [t.sCount[n]], t.sCount[n] = p - c, $ = [t.tShift[n]], t.tShift[n] = N - t.bMarks[n], O = t.md.block.ruler.getRules("blockquote"), b = t.parentType, t.parentType = "blockquote", _ = n + 1; _ < o && (D = t.sCount[_] < t.blkIndent, N = t.bMarks[_] + t.tShift[_], C = t.eMarks[_], !(N >= C)); _++) {
    if (t.src.charCodeAt(N++) === 62 && !D) {
      for (c = p = t.sCount[_] + 1, t.src.charCodeAt(N) === 32 ? (N++, c++, p++, i = !1, k = !0) : t.src.charCodeAt(N) === 9 ? (k = !0, (t.bsCount[_] + p) % 4 === 3 ? (N++, c++, p++, i = !1) : i = !0) : k = !1, f.push(t.bMarks[_]), t.bMarks[_] = N; N < C && (a = t.src.charCodeAt(N), wJ(a)); ) {
        a === 9 ? p += 4 - (p + t.bsCount[_] + (i ? 1 : 0)) % 4 : p++;
        N++;
      }
      d = N >= C, g.push(t.bsCount[_]), t.bsCount[_] = t.sCount[_] + 1 + (k ? 1 : 0), v.push(t.sCount[_]), t.sCount[_] = p - c, $.push(t.tShift[_]), t.tShift[_] = N - t.bMarks[_];
      continue;
    }
    if (d)
      break;
    for (S = !1, s = 0, l = O.length; s < l; s++)
      if (O[s](t, _, o, !0)) {
        S = !0;
        break;
      }
    if (S) {
      t.lineMax = _, t.blkIndent !== 0 && (f.push(t.bMarks[_]), g.push(t.bsCount[_]), $.push(t.tShift[_]), v.push(t.sCount[_]), t.sCount[_] -= t.blkIndent);
      break;
    }
    f.push(t.bMarks[_]), g.push(t.bsCount[_]), $.push(t.tShift[_]), v.push(t.sCount[_]), t.sCount[_] = -1;
  }
  for (h = t.blkIndent, t.blkIndent = 0, I = t.push("blockquote_open", "blockquote", 1), I.markup = ">", I.map = u = [n, 0], t.md.block.tokenize(t, n, _), I = t.push("blockquote_close", "blockquote", -1), I.markup = ">", t.lineMax = M, t.parentType = b, u[1] = t.line, s = 0; s < $.length; s++)
    t.bMarks[s + n] = f[s], t.tShift[s + n] = $[s], t.sCount[s + n] = v[s], t.bsCount[s + n] = g[s];
  return t.blkIndent = h, !0;
}, gWl = ar.isSpace, hWl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], d = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || (i = t.src.charCodeAt(l++), i !== 42 && i !== 45 && i !== 95))
    return !1;
  for (a = 1; l < d; ) {
    if (s = t.src.charCodeAt(l++), s !== i && !gWl(s))
      return !1;
    s === i && a++;
  }
  return a < 3 ? !1 : (r || (t.line = n + 1, c = t.push("hr", "hr", 0), c.map = [n, t.line], c.markup = Array(a + 1).join(String.fromCharCode(i))), !0);
}, Xve = ar.isSpace;
function kJ(e, t) {
  var n, o, r, i;
  return o = e.bMarks[t] + e.tShift[t], r = e.eMarks[t], n = e.src.charCodeAt(o++), n !== 42 && n !== 45 && n !== 43 || o < r && (i = e.src.charCodeAt(o), !Xve(i)) ? -1 : o;
}
function SJ(e, t) {
  var n, o = e.bMarks[t] + e.tShift[t], r = o, i = e.eMarks[t];
  if (r + 1 >= i || (n = e.src.charCodeAt(r++), n < 48 || n > 57))
    return -1;
  for (; ; ) {
    if (r >= i)
      return -1;
    if (n = e.src.charCodeAt(r++), n >= 48 && n <= 57) {
      if (r - o >= 10)
        return -1;
      continue;
    }
    if (n === 41 || n === 46)
      break;
    return -1;
  }
  return r < i && (n = e.src.charCodeAt(r), !Xve(n)) ? -1 : r;
}
function vWl(e, t) {
  var n, o, r = e.level + 2;
  for (n = t + 2, o = e.tokens.length - 2; n < o; n++)
    e.tokens[n].level === r && e.tokens[n].type === "paragraph_open" && (e.tokens[n + 2].hidden = !0, e.tokens[n].hidden = !0, n += 2);
}
var bWl = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S, O, I, D, M, N, C, P, x, w, E, T, z = !1, j = !0;
  if (t.sCount[n] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[n] - t.listIndent >= 4 && t.sCount[n] < t.blkIndent)
    return !1;
  if (r && t.parentType === "paragraph" && t.sCount[n] >= t.blkIndent && (z = !0), (C = SJ(t, n)) >= 0) {
    if (u = !0, x = t.bMarks[n] + t.tShift[n], b = Number(t.src.slice(x, C - 1)), z && b !== 1)
      return !1;
  } else if ((C = kJ(t, n)) >= 0)
    u = !1;
  else
    return !1;
  if (z && t.skipSpaces(C) >= t.eMarks[n])
    return !1;
  if (h = t.src.charCodeAt(C - 1), r)
    return !0;
  for (g = t.tokens.length, u ? (T = t.push("ordered_list_open", "ol", 1), b !== 1 && (T.attrs = [["start", b]])) : T = t.push("bullet_list_open", "ul", 1), T.map = f = [n, 0], T.markup = String.fromCharCode(h), $ = n, P = !1, E = t.md.block.ruler.getRules("list"), O = t.parentType, t.parentType = "list"; $ < o; ) {
    for (N = C, v = t.eMarks[$], d = k = t.sCount[$] + C - (t.bMarks[n] + t.tShift[n]); N < v; ) {
      if (i = t.src.charCodeAt(N), i === 9)
        k += 4 - (k + t.bsCount[$]) % 4;
      else if (i === 32)
        k++;
      else
        break;
      N++;
    }
    if (a = N, a >= v ? l = 1 : l = k - d, l > 4 && (l = 1), c = d + l, T = t.push("list_item_open", "li", 1), T.markup = String.fromCharCode(h), T.map = _ = [n, 0], u && (T.info = t.src.slice(x, C - 1)), M = t.tight, D = t.tShift[n], I = t.sCount[n], S = t.listIndent, t.listIndent = t.blkIndent, t.blkIndent = c, t.tight = !0, t.tShift[n] = a - t.bMarks[n], t.sCount[n] = k, a >= v && t.isEmpty(n + 1) ? t.line = Math.min(t.line + 2, o) : t.md.block.tokenize(t, n, o, !0), (!t.tight || P) && (j = !1), P = t.line - n > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = S, t.tShift[n] = D, t.sCount[n] = I, t.tight = M, T = t.push("list_item_close", "li", -1), T.markup = String.fromCharCode(h), $ = n = t.line, _[1] = $, a = t.bMarks[n], $ >= o || t.sCount[$] < t.blkIndent || t.sCount[n] - t.blkIndent >= 4)
      break;
    for (w = !1, s = 0, p = E.length; s < p; s++)
      if (E[s](t, $, o, !0)) {
        w = !0;
        break;
      }
    if (w)
      break;
    if (u) {
      if (C = SJ(t, $), C < 0)
        break;
      x = t.bMarks[$] + t.tShift[$];
    } else if (C = kJ(t, $), C < 0)
      break;
    if (h !== t.src.charCodeAt(C - 1))
      break;
  }
  return u ? T = t.push("ordered_list_close", "ol", -1) : T = t.push("bullet_list_close", "ul", -1), T.markup = String.fromCharCode(h), f[1] = $, t.line = $, t.parentType = O, j && vWl(t, g), !0;
}, yWl = ar.normalizeReference, J2 = ar.isSpace, $Wl = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _, p, f, g, h, b, v, $, k, S = 0, O = t.bMarks[n] + t.tShift[n], I = t.eMarks[n], D = n + 1;
  if (t.sCount[n] - t.blkIndent >= 4 || t.src.charCodeAt(O) !== 91)
    return !1;
  for (; ++O < I; )
    if (t.src.charCodeAt(O) === 93 && t.src.charCodeAt(O - 1) !== 92) {
      if (O + 1 === I || t.src.charCodeAt(O + 1) !== 58)
        return !1;
      break;
    }
  for (c = t.lineMax, $ = t.md.block.ruler.getRules("reference"), f = t.parentType, t.parentType = "reference"; D < c && !t.isEmpty(D); D++)
    if (!(t.sCount[D] - t.blkIndent > 3) && !(t.sCount[D] < 0)) {
      for (v = !1, d = 0, u = $.length; d < u; d++)
        if ($[d](t, D, c, !0)) {
          v = !0;
          break;
        }
      if (v)
        break;
    }
  for (b = t.getLines(n, D, t.blkIndent, !1).trim(), I = b.length, O = 1; O < I; O++) {
    if (i = b.charCodeAt(O), i === 91)
      return !1;
    if (i === 93) {
      p = O;
      break;
    } else
      i === 10 ? S++ : i === 92 && (O++, O < I && b.charCodeAt(O) === 10 && S++);
  }
  if (p < 0 || b.charCodeAt(p + 1) !== 58)
    return !1;
  for (O = p + 2; O < I; O++)
    if (i = b.charCodeAt(O), i === 10)
      S++;
    else if (!J2(i))
      break;
  if (g = t.md.helpers.parseLinkDestination(b, O, I), !g.ok || (l = t.md.normalizeLink(g.str), !t.md.validateLink(l)))
    return !1;
  for (O = g.pos, S += g.lines, a = O, s = S, h = O; O < I; O++)
    if (i = b.charCodeAt(O), i === 10)
      S++;
    else if (!J2(i))
      break;
  for (g = t.md.helpers.parseLinkTitle(b, O, I), O < I && h !== O && g.ok ? (k = g.str, O = g.pos, S += g.lines) : (k = "", O = a, S = s); O < I && (i = b.charCodeAt(O), !!J2(i)); )
    O++;
  if (O < I && b.charCodeAt(O) !== 10 && k)
    for (k = "", O = a, S = s; O < I && (i = b.charCodeAt(O), !!J2(i)); )
      O++;
  return O < I && b.charCodeAt(O) !== 10 || (_ = yWl(b.slice(1, p)), !_) ? !1 : (r || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[_] > "u" && (t.env.references[_] = { title: k, href: l }), t.parentType = f, t.line = n + S + 1), !0);
}, wWl = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], $C = {}, kWl = "[a-zA-Z_:][a-zA-Z0-9:._-]*", SWl = "[^\"'=<>`\\x00-\\x20]+", xWl = "'[^']*'", EWl = '"[^"]*"', TWl = "(?:" + SWl + "|" + xWl + "|" + EWl + ")", AWl = "(?:\\s+" + kWl + "(?:\\s*=\\s*" + TWl + ")?)", ebe = "<[A-Za-z][A-Za-z0-9\\-]*" + AWl + "*\\s*\\/?>", tbe = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", CWl = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", zWl = "<[?][\\s\\S]*?[?]>", OWl = "<![A-Z]+\\s+[^>]*>", PWl = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", IWl = new RegExp("^(?:" + ebe + "|" + tbe + "|" + CWl + "|" + zWl + "|" + OWl + "|" + PWl + ")"), RWl = new RegExp("^(?:" + ebe + "|" + tbe + ")");
$C.HTML_TAG_RE = IWl;
$C.HTML_OPEN_CLOSE_TAG_RE = RWl;
var NWl = wWl, DWl = $C.HTML_OPEN_CLOSE_TAG_RE, sh = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + NWl.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(DWl.source + "\\s*$"), /^$/, !1]
], MWl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], d = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(l) !== 60)
    return !1;
  for (c = t.src.slice(l, d), i = 0; i < sh.length && !sh[i][0].test(c); i++)
    ;
  if (i === sh.length)
    return !1;
  if (r)
    return sh[i][2];
  if (a = n + 1, !sh[i][1].test(c)) {
    for (; a < o && !(t.sCount[a] < t.blkIndent); a++)
      if (l = t.bMarks[a] + t.tShift[a], d = t.eMarks[a], c = t.src.slice(l, d), sh[i][1].test(c)) {
        c.length !== 0 && a++;
        break;
      }
  }
  return t.line = a, s = t.push("html_block", "", 0), s.map = [n, a], s.content = t.getLines(n, a, t.blkIndent, !0), !0;
}, xJ = ar.isSpace, LWl = function(t, n, o, r) {
  var i, a, s, c, l = t.bMarks[n] + t.tShift[n], d = t.eMarks[n];
  if (t.sCount[n] - t.blkIndent >= 4 || (i = t.src.charCodeAt(l), i !== 35 || l >= d))
    return !1;
  for (a = 1, i = t.src.charCodeAt(++l); i === 35 && l < d && a <= 6; )
    a++, i = t.src.charCodeAt(++l);
  return a > 6 || l < d && !xJ(i) ? !1 : (r || (d = t.skipSpacesBack(d, l), s = t.skipCharsBack(d, 35, l), s > l && xJ(t.src.charCodeAt(s - 1)) && (d = s), t.line = n + 1, c = t.push("heading_open", "h" + String(a), 1), c.markup = "########".slice(0, a), c.map = [n, t.line], c = t.push("inline", "", 0), c.content = t.src.slice(l, d).trim(), c.map = [n, t.line], c.children = [], c = t.push("heading_close", "h" + String(a), -1), c.markup = "########".slice(0, a)), !0);
}, qWl = function(t, n, o) {
  var r, i, a, s, c, l, d, u, _, p = n + 1, f, g = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[n] - t.blkIndent >= 4)
    return !1;
  for (f = t.parentType, t.parentType = "paragraph"; p < o && !t.isEmpty(p); p++)
    if (!(t.sCount[p] - t.blkIndent > 3)) {
      if (t.sCount[p] >= t.blkIndent && (l = t.bMarks[p] + t.tShift[p], d = t.eMarks[p], l < d && (_ = t.src.charCodeAt(l), (_ === 45 || _ === 61) && (l = t.skipChars(l, _), l = t.skipSpaces(l), l >= d)))) {
        u = _ === 61 ? 1 : 2;
        break;
      }
      if (!(t.sCount[p] < 0)) {
        for (i = !1, a = 0, s = g.length; a < s; a++)
          if (g[a](t, p, o, !0)) {
            i = !0;
            break;
          }
        if (i)
          break;
      }
    }
  return u ? (r = t.getLines(n, p, t.blkIndent, !1).trim(), t.line = p + 1, c = t.push("heading_open", "h" + String(u), 1), c.markup = String.fromCharCode(_), c.map = [n, t.line], c = t.push("inline", "", 0), c.content = r, c.map = [n, t.line - 1], c.children = [], c = t.push("heading_close", "h" + String(u), -1), c.markup = String.fromCharCode(_), t.parentType = f, !0) : !1;
}, jWl = function(t, n) {
  var o, r, i, a, s, c, l = n + 1, d = t.md.block.ruler.getRules("paragraph"), u = t.lineMax;
  for (c = t.parentType, t.parentType = "paragraph"; l < u && !t.isEmpty(l); l++)
    if (!(t.sCount[l] - t.blkIndent > 3) && !(t.sCount[l] < 0)) {
      for (r = !1, i = 0, a = d.length; i < a; i++)
        if (d[i](t, l, u, !0)) {
          r = !0;
          break;
        }
      if (r)
        break;
    }
  return o = t.getLines(n, l, t.blkIndent, !1).trim(), t.line = l, s = t.push("paragraph_open", "p", 1), s.map = [n, t.line], s = t.push("inline", "", 0), s.content = o, s.map = [n, t.line], s.children = [], s = t.push("paragraph_close", "p", -1), t.parentType = c, !0;
}, nbe = DF, wC = ar.isSpace;
function vu(e, t, n, o) {
  var r, i, a, s, c, l, d, u;
  for (this.src = e, this.md = t, this.env = n, this.tokens = o, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", i = this.src, u = !1, a = s = l = d = 0, c = i.length; s < c; s++) {
    if (r = i.charCodeAt(s), !u)
      if (wC(r)) {
        l++, r === 9 ? d += 4 - d % 4 : d++;
        continue;
      } else
        u = !0;
    (r === 10 || s === c - 1) && (r !== 10 && s++, this.bMarks.push(a), this.eMarks.push(s), this.tShift.push(l), this.sCount.push(d), this.bsCount.push(0), u = !1, l = 0, d = 0, a = s + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
vu.prototype.push = function(e, t, n) {
  var o = new nbe(e, t, n);
  return o.block = !0, n < 0 && this.level--, o.level = this.level, n > 0 && this.level++, this.tokens.push(o), o;
};
vu.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
vu.prototype.skipEmptyLines = function(t) {
  for (var n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
vu.prototype.skipSpaces = function(t) {
  for (var n, o = this.src.length; t < o && (n = this.src.charCodeAt(t), !!wC(n)); t++)
    ;
  return t;
};
vu.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!wC(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
vu.prototype.skipChars = function(t, n) {
  for (var o = this.src.length; t < o && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
vu.prototype.skipCharsBack = function(t, n, o) {
  if (t <= o)
    return t;
  for (; t > o; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
vu.prototype.getLines = function(t, n, o, r) {
  var i, a, s, c, l, d, u, _ = t;
  if (t >= n)
    return "";
  for (d = new Array(n - t), i = 0; _ < n; _++, i++) {
    for (a = 0, u = c = this.bMarks[_], _ + 1 < n || r ? l = this.eMarks[_] + 1 : l = this.eMarks[_]; c < l && a < o; ) {
      if (s = this.src.charCodeAt(c), wC(s))
        s === 9 ? a += 4 - (a + this.bsCount[_]) % 4 : a++;
      else if (c - u < this.tShift[_])
        a++;
      else
        break;
      c++;
    }
    a > o ? d[i] = new Array(a - o + 1).join(" ") + this.src.slice(c, l) : d[i] = this.src.slice(c, l);
  }
  return d.join("");
};
vu.prototype.Token = nbe;
var FWl = vu, VWl = NF, X2 = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", _Wl, ["paragraph", "reference"]],
  ["code", pWl],
  ["fence", mWl, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", fWl, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", hWl, ["paragraph", "reference", "blockquote", "list"]],
  ["list", bWl, ["paragraph", "reference", "blockquote"]],
  ["reference", $Wl],
  ["html_block", MWl, ["paragraph", "reference", "blockquote"]],
  ["heading", LWl, ["paragraph", "reference", "blockquote"]],
  ["lheading", qWl],
  ["paragraph", jWl]
];
function kC() {
  this.ruler = new VWl();
  for (var e = 0; e < X2.length; e++)
    this.ruler.push(X2[e][0], X2[e][1], { alt: (X2[e][2] || []).slice() });
}
kC.prototype.tokenize = function(e, t, n) {
  for (var o, r, i = this.ruler.getRules(""), a = i.length, s = t, c = !1, l = e.md.options.maxNesting; s < n && (e.line = s = e.skipEmptyLines(s), !(s >= n || e.sCount[s] < e.blkIndent)); ) {
    if (e.level >= l) {
      e.line = n;
      break;
    }
    for (r = 0; r < a && (o = i[r](e, s, n, !1), !o); r++)
      ;
    e.tight = !c, e.isEmpty(e.line - 1) && (c = !0), s = e.line, s < n && e.isEmpty(s) && (c = !0, s++, e.line = s);
  }
};
kC.prototype.parse = function(e, t, n, o) {
  var r;
  e && (r = new this.State(e, t, n, o), this.tokenize(r, r.line, r.lineMax));
};
kC.prototype.State = FWl;
var BWl = kC;
function UWl(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
var WWl = function(t, n) {
  for (var o = t.pos; o < t.posMax && !UWl(t.src.charCodeAt(o)); )
    o++;
  return o === t.pos ? !1 : (n || (t.pending += t.src.slice(t.pos, o)), t.pos = o, !0);
}, GWl = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, HWl = function(t, n) {
  var o, r, i, a, s, c, l, d;
  return !t.md.options.linkify || t.linkLevel > 0 || (o = t.pos, r = t.posMax, o + 3 > r) || t.src.charCodeAt(o) !== 58 || t.src.charCodeAt(o + 1) !== 47 || t.src.charCodeAt(o + 2) !== 47 || (i = t.pending.match(GWl), !i) || (a = i[1], s = t.md.linkify.matchAtStart(t.src.slice(o - a.length)), !s) || (c = s.url, c = c.replace(/\*+$/, ""), l = t.md.normalizeLink(c), !t.md.validateLink(l)) ? !1 : (n || (t.pending = t.pending.slice(0, -a.length), d = t.push("link_open", "a", 1), d.attrs = [["href", l]], d.markup = "linkify", d.info = "auto", d = t.push("text", "", 0), d.content = t.md.normalizeLinkText(c), d = t.push("link_close", "a", -1), d.markup = "linkify", d.info = "auto"), t.pos += c.length - a.length, !0);
}, KWl = ar.isSpace, YWl = function(t, n) {
  var o, r, i, a = t.pos;
  if (t.src.charCodeAt(a) !== 10)
    return !1;
  if (o = t.pending.length - 1, r = t.posMax, !n)
    if (o >= 0 && t.pending.charCodeAt(o) === 32)
      if (o >= 1 && t.pending.charCodeAt(o - 1) === 32) {
        for (i = o - 1; i >= 1 && t.pending.charCodeAt(i - 1) === 32; )
          i--;
        t.pending = t.pending.slice(0, i), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (a++; a < r && KWl(t.src.charCodeAt(a)); )
    a++;
  return t.pos = a, !0;
}, ZWl = ar.isSpace, LF = [];
for (var EJ = 0; EJ < 256; EJ++)
  LF.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  LF[e.charCodeAt(0)] = 1;
});
var QWl = function(t, n) {
  var o, r, i, a, s, c = t.pos, l = t.posMax;
  if (t.src.charCodeAt(c) !== 92 || (c++, c >= l))
    return !1;
  if (o = t.src.charCodeAt(c), o === 10) {
    for (n || t.push("hardbreak", "br", 0), c++; c < l && (o = t.src.charCodeAt(c), !!ZWl(o)); )
      c++;
    return t.pos = c, !0;
  }
  return a = t.src[c], o >= 55296 && o <= 56319 && c + 1 < l && (r = t.src.charCodeAt(c + 1), r >= 56320 && r <= 57343 && (a += t.src[c + 1], c++)), i = "\\" + a, n || (s = t.push("text_special", "", 0), o < 256 && LF[o] !== 0 ? s.content = a : s.content = i, s.markup = i, s.info = "escape"), t.pos = c + 1, !0;
}, JWl = function(t, n) {
  var o, r, i, a, s, c, l, d, u = t.pos, _ = t.src.charCodeAt(u);
  if (_ !== 96)
    return !1;
  for (o = u, u++, r = t.posMax; u < r && t.src.charCodeAt(u) === 96; )
    u++;
  if (i = t.src.slice(o, u), l = i.length, t.backticksScanned && (t.backticks[l] || 0) <= o)
    return n || (t.pending += i), t.pos += l, !0;
  for (s = c = u; (s = t.src.indexOf("`", c)) !== -1; ) {
    for (c = s + 1; c < r && t.src.charCodeAt(c) === 96; )
      c++;
    if (d = c - s, d === l)
      return n || (a = t.push("code_inline", "code", 0), a.markup = i, a.content = t.src.slice(u, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), t.pos = c, !0;
    t.backticks[d] = s;
  }
  return t.backticksScanned = !0, n || (t.pending += i), t.pos += l, !0;
}, SC = {};
SC.tokenize = function(t, n) {
  var o, r, i, a, s, c = t.pos, l = t.src.charCodeAt(c);
  if (n || l !== 126 || (r = t.scanDelims(t.pos, !0), a = r.length, s = String.fromCharCode(l), a < 2))
    return !1;
  for (a % 2 && (i = t.push("text", "", 0), i.content = s, a--), o = 0; o < a; o += 2)
    i = t.push("text", "", 0), i.content = s + s, t.delimiters.push({
      marker: l,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: r.can_open,
      close: r.can_close
    });
  return t.pos += r.length, !0;
};
function TJ(e, t) {
  var n, o, r, i, a, s = [], c = t.length;
  for (n = 0; n < c; n++)
    r = t[n], r.marker === 126 && r.end !== -1 && (i = t[r.end], a = e.tokens[r.token], a.type = "s_open", a.tag = "s", a.nesting = 1, a.markup = "~~", a.content = "", a = e.tokens[i.token], a.type = "s_close", a.tag = "s", a.nesting = -1, a.markup = "~~", a.content = "", e.tokens[i.token - 1].type === "text" && e.tokens[i.token - 1].content === "~" && s.push(i.token - 1));
  for (; s.length; ) {
    for (n = s.pop(), o = n + 1; o < e.tokens.length && e.tokens[o].type === "s_close"; )
      o++;
    o--, n !== o && (a = e.tokens[o], e.tokens[o] = e.tokens[n], e.tokens[n] = a);
  }
}
SC.postProcess = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (TJ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && TJ(t, o[n].delimiters);
};
var xC = {};
xC.tokenize = function(t, n) {
  var o, r, i, a = t.pos, s = t.src.charCodeAt(a);
  if (n || s !== 95 && s !== 42)
    return !1;
  for (r = t.scanDelims(t.pos, s === 42), o = 0; o < r.length; o++)
    i = t.push("text", "", 0), i.content = String.fromCharCode(s), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: s,
      // Total length of these series of delimiters.
      //
      length: r.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: r.can_open,
      close: r.can_close
    });
  return t.pos += r.length, !0;
};
function AJ(e, t) {
  var n, o, r, i, a, s, c = t.length;
  for (n = c - 1; n >= 0; n--)
    o = t[n], !(o.marker !== 95 && o.marker !== 42) && o.end !== -1 && (r = t[o.end], s = n > 0 && t[n - 1].end === o.end + 1 && // check that first two markers match and adjacent
    t[n - 1].marker === o.marker && t[n - 1].token === o.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[o.end + 1].token === r.token + 1, a = String.fromCharCode(o.marker), i = e.tokens[o.token], i.type = s ? "strong_open" : "em_open", i.tag = s ? "strong" : "em", i.nesting = 1, i.markup = s ? a + a : a, i.content = "", i = e.tokens[r.token], i.type = s ? "strong_close" : "em_close", i.tag = s ? "strong" : "em", i.nesting = -1, i.markup = s ? a + a : a, i.content = "", s && (e.tokens[t[n - 1].token].content = "", e.tokens[t[o.end + 1].token].content = "", n--));
}
xC.postProcess = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (AJ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && AJ(t, o[n].delimiters);
};
var XWl = ar.normalizeReference, i5 = ar.isSpace, eGl = function(t, n) {
  var o, r, i, a, s, c, l, d, u, _ = "", p = "", f = t.pos, g = t.posMax, h = t.pos, b = !0;
  if (t.src.charCodeAt(t.pos) !== 91 || (s = t.pos + 1, a = t.md.helpers.parseLinkLabel(t, t.pos, !0), a < 0))
    return !1;
  if (c = a + 1, c < g && t.src.charCodeAt(c) === 40) {
    for (b = !1, c++; c < g && (r = t.src.charCodeAt(c), !(!i5(r) && r !== 10)); c++)
      ;
    if (c >= g)
      return !1;
    if (h = c, l = t.md.helpers.parseLinkDestination(t.src, c, t.posMax), l.ok) {
      for (_ = t.md.normalizeLink(l.str), t.md.validateLink(_) ? c = l.pos : _ = "", h = c; c < g && (r = t.src.charCodeAt(c), !(!i5(r) && r !== 10)); c++)
        ;
      if (l = t.md.helpers.parseLinkTitle(t.src, c, t.posMax), c < g && h !== c && l.ok)
        for (p = l.str, c = l.pos; c < g && (r = t.src.charCodeAt(c), !(!i5(r) && r !== 10)); c++)
          ;
    }
    (c >= g || t.src.charCodeAt(c) !== 41) && (b = !0), c++;
  }
  if (b) {
    if (typeof t.env.references > "u")
      return !1;
    if (c < g && t.src.charCodeAt(c) === 91 ? (h = c + 1, c = t.md.helpers.parseLinkLabel(t, c), c >= 0 ? i = t.src.slice(h, c++) : c = a + 1) : c = a + 1, i || (i = t.src.slice(s, a)), d = t.env.references[XWl(i)], !d)
      return t.pos = f, !1;
    _ = d.href, p = d.title;
  }
  return n || (t.pos = s, t.posMax = a, u = t.push("link_open", "a", 1), u.attrs = o = [["href", _]], p && o.push(["title", p]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, u = t.push("link_close", "a", -1)), t.pos = c, t.posMax = g, !0;
}, tGl = ar.normalizeReference, a5 = ar.isSpace, nGl = function(t, n) {
  var o, r, i, a, s, c, l, d, u, _, p, f, g, h = "", b = t.pos, v = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91 || (c = t.pos + 2, s = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1), s < 0))
    return !1;
  if (l = s + 1, l < v && t.src.charCodeAt(l) === 40) {
    for (l++; l < v && (r = t.src.charCodeAt(l), !(!a5(r) && r !== 10)); l++)
      ;
    if (l >= v)
      return !1;
    for (g = l, u = t.md.helpers.parseLinkDestination(t.src, l, t.posMax), u.ok && (h = t.md.normalizeLink(u.str), t.md.validateLink(h) ? l = u.pos : h = ""), g = l; l < v && (r = t.src.charCodeAt(l), !(!a5(r) && r !== 10)); l++)
      ;
    if (u = t.md.helpers.parseLinkTitle(t.src, l, t.posMax), l < v && g !== l && u.ok)
      for (_ = u.str, l = u.pos; l < v && (r = t.src.charCodeAt(l), !(!a5(r) && r !== 10)); l++)
        ;
    else
      _ = "";
    if (l >= v || t.src.charCodeAt(l) !== 41)
      return t.pos = b, !1;
    l++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (l < v && t.src.charCodeAt(l) === 91 ? (g = l + 1, l = t.md.helpers.parseLinkLabel(t, l), l >= 0 ? a = t.src.slice(g, l++) : l = s + 1) : l = s + 1, a || (a = t.src.slice(c, s)), d = t.env.references[tGl(a)], !d)
      return t.pos = b, !1;
    h = d.href, _ = d.title;
  }
  return n || (i = t.src.slice(c, s), t.md.inline.parse(
    i,
    t.md,
    t.env,
    f = []
  ), p = t.push("image", "img", 0), p.attrs = o = [["src", h], ["alt", ""]], p.children = f, p.content = i, _ && o.push(["title", _])), t.pos = l, t.posMax = v, !0;
}, oGl = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, rGl = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/, iGl = function(t, n) {
  var o, r, i, a, s, c, l = t.pos;
  if (t.src.charCodeAt(l) !== 60)
    return !1;
  for (s = t.pos, c = t.posMax; ; ) {
    if (++l >= c || (a = t.src.charCodeAt(l), a === 60))
      return !1;
    if (a === 62)
      break;
  }
  return o = t.src.slice(s + 1, l), rGl.test(o) ? (r = t.md.normalizeLink(o), t.md.validateLink(r) ? (n || (i = t.push("link_open", "a", 1), i.attrs = [["href", r]], i.markup = "autolink", i.info = "auto", i = t.push("text", "", 0), i.content = t.md.normalizeLinkText(o), i = t.push("link_close", "a", -1), i.markup = "autolink", i.info = "auto"), t.pos += o.length + 2, !0) : !1) : oGl.test(o) ? (r = t.md.normalizeLink("mailto:" + o), t.md.validateLink(r) ? (n || (i = t.push("link_open", "a", 1), i.attrs = [["href", r]], i.markup = "autolink", i.info = "auto", i = t.push("text", "", 0), i.content = t.md.normalizeLinkText(o), i = t.push("link_close", "a", -1), i.markup = "autolink", i.info = "auto"), t.pos += o.length + 2, !0) : !1) : !1;
}, aGl = $C.HTML_TAG_RE;
function sGl(e) {
  return /^<a[>\s]/i.test(e);
}
function cGl(e) {
  return /^<\/a\s*>/i.test(e);
}
function lGl(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
var dGl = function(t, n) {
  var o, r, i, a, s = t.pos;
  return !t.md.options.html || (i = t.posMax, t.src.charCodeAt(s) !== 60 || s + 2 >= i) || (o = t.src.charCodeAt(s + 1), o !== 33 && o !== 63 && o !== 47 && !lGl(o)) || (r = t.src.slice(s).match(aGl), !r) ? !1 : (n || (a = t.push("html_inline", "", 0), a.content = t.src.slice(s, s + r[0].length), sGl(a.content) && t.linkLevel++, cGl(a.content) && t.linkLevel--), t.pos += r[0].length, !0);
}, CJ = Hve, uGl = ar.has, _Gl = ar.isValidEntityCode, zJ = ar.fromCodePoint, pGl = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, mGl = /^&([a-z][a-z0-9]{1,31});/i, fGl = function(t, n) {
  var o, r, i, a, s = t.pos, c = t.posMax;
  if (t.src.charCodeAt(s) !== 38 || s + 1 >= c)
    return !1;
  if (o = t.src.charCodeAt(s + 1), o === 35) {
    if (i = t.src.slice(s).match(pGl), i)
      return n || (r = i[1][0].toLowerCase() === "x" ? parseInt(i[1].slice(1), 16) : parseInt(i[1], 10), a = t.push("text_special", "", 0), a.content = _Gl(r) ? zJ(r) : zJ(65533), a.markup = i[0], a.info = "entity"), t.pos += i[0].length, !0;
  } else if (i = t.src.slice(s).match(mGl), i && uGl(CJ, i[1]))
    return n || (a = t.push("text_special", "", 0), a.content = CJ[i[1]], a.markup = i[0], a.info = "entity"), t.pos += i[0].length, !0;
  return !1;
};
function OJ(e, t) {
  var n, o, r, i, a, s, c, l, d = {}, u = t.length;
  if (u) {
    var _ = 0, p = -2, f = [];
    for (n = 0; n < u; n++)
      if (r = t[n], f.push(0), (t[_].marker !== r.marker || p !== r.token - 1) && (_ = n), p = r.token, r.length = r.length || 0, !!r.close) {
        for (d.hasOwnProperty(r.marker) || (d[r.marker] = [-1, -1, -1, -1, -1, -1]), a = d[r.marker][(r.open ? 3 : 0) + r.length % 3], o = _ - f[_] - 1, s = o; o > a; o -= f[o] + 1)
          if (i = t[o], i.marker === r.marker && i.open && i.end < 0 && (c = !1, (i.close || r.open) && (i.length + r.length) % 3 === 0 && (i.length % 3 !== 0 || r.length % 3 !== 0) && (c = !0), !c)) {
            l = o > 0 && !t[o - 1].open ? f[o - 1] + 1 : 0, f[n] = n - o + l, f[o] = l, r.open = !1, i.end = n, i.close = !1, s = -1, p = -2;
            break;
          }
        s !== -1 && (d[r.marker][(r.open ? 3 : 0) + (r.length || 0) % 3] = s);
      }
  }
}
var gGl = function(t) {
  var n, o = t.tokens_meta, r = t.tokens_meta.length;
  for (OJ(t, t.delimiters), n = 0; n < r; n++)
    o[n] && o[n].delimiters && OJ(t, o[n].delimiters);
}, hGl = function(t) {
  var n, o, r = 0, i = t.tokens, a = t.tokens.length;
  for (n = o = 0; n < a; n++)
    i[n].nesting < 0 && r--, i[n].level = r, i[n].nesting > 0 && r++, i[n].type === "text" && n + 1 < a && i[n + 1].type === "text" ? i[n + 1].content = i[n].content + i[n + 1].content : (n !== o && (i[o] = i[n]), o++);
  n !== o && (i.length = o);
}, qF = DF, PJ = ar.isWhiteSpace, IJ = ar.isPunctChar, RJ = ar.isMdAsciiPunct;
function uk(e, t, n, o) {
  this.src = e, this.env = n, this.md = t, this.tokens = o, this.tokens_meta = Array(o.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
uk.prototype.pushPending = function() {
  var e = new qF("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
uk.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  var o = new qF(e, t, n), r = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), o.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], r = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(o), this.tokens_meta.push(r), o;
};
uk.prototype.scanDelims = function(e, t) {
  var n = e, o, r, i, a, s, c, l, d, u, _ = !0, p = !0, f = this.posMax, g = this.src.charCodeAt(e);
  for (o = e > 0 ? this.src.charCodeAt(e - 1) : 32; n < f && this.src.charCodeAt(n) === g; )
    n++;
  return i = n - e, r = n < f ? this.src.charCodeAt(n) : 32, l = RJ(o) || IJ(String.fromCharCode(o)), u = RJ(r) || IJ(String.fromCharCode(r)), c = PJ(o), d = PJ(r), d ? _ = !1 : u && (c || l || (_ = !1)), c ? p = !1 : l && (d || u || (p = !1)), t ? (a = _, s = p) : (a = _ && (!p || l), s = p && (!_ || u)), {
    can_open: a,
    can_close: s,
    length: i
  };
};
uk.prototype.Token = qF;
var vGl = uk, NJ = NF, s5 = [
  ["text", WWl],
  ["linkify", HWl],
  ["newline", YWl],
  ["escape", QWl],
  ["backticks", JWl],
  ["strikethrough", SC.tokenize],
  ["emphasis", xC.tokenize],
  ["link", eGl],
  ["image", nGl],
  ["autolink", iGl],
  ["html_inline", dGl],
  ["entity", fGl]
], c5 = [
  ["balance_pairs", gGl],
  ["strikethrough", SC.postProcess],
  ["emphasis", xC.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", hGl]
];
function _k() {
  var e;
  for (this.ruler = new NJ(), e = 0; e < s5.length; e++)
    this.ruler.push(s5[e][0], s5[e][1]);
  for (this.ruler2 = new NJ(), e = 0; e < c5.length; e++)
    this.ruler2.push(c5[e][0], c5[e][1]);
}
_k.prototype.skipToken = function(e) {
  var t, n, o = e.pos, r = this.ruler.getRules(""), i = r.length, a = e.md.options.maxNesting, s = e.cache;
  if (typeof s[o] < "u") {
    e.pos = s[o];
    return;
  }
  if (e.level < a)
    for (n = 0; n < i && (e.level++, t = r[n](e, !0), e.level--, !t); n++)
      ;
  else
    e.pos = e.posMax;
  t || e.pos++, s[o] = e.pos;
};
_k.prototype.tokenize = function(e) {
  for (var t, n, o = this.ruler.getRules(""), r = o.length, i = e.posMax, a = e.md.options.maxNesting; e.pos < i; ) {
    if (e.level < a)
      for (n = 0; n < r && (t = o[n](e, !1), !t); n++)
        ;
    if (t) {
      if (e.pos >= i)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
_k.prototype.parse = function(e, t, n, o) {
  var r, i, a, s = new this.State(e, t, n, o);
  for (this.tokenize(s), i = this.ruler2.getRules(""), a = i.length, r = 0; r < a; r++)
    i[r](s);
};
_k.prototype.State = vGl;
var bGl = _k, l5, DJ;
function yGl() {
  return DJ || (DJ = 1, l5 = function(e) {
    var t = {};
    e = e || {}, t.src_Any = Kve().source, t.src_Cc = Yve().source, t.src_Z = Zve().source, t.src_P = RF.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
    var n = "[><｜]";
    return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
  }), l5;
}
function $L(e) {
  var t = Array.prototype.slice.call(arguments, 1);
  return t.forEach(function(n) {
    n && Object.keys(n).forEach(function(o) {
      e[o] = n[o];
    });
  }), e;
}
function EC(e) {
  return Object.prototype.toString.call(e);
}
function $Gl(e) {
  return EC(e) === "[object String]";
}
function wGl(e) {
  return EC(e) === "[object Object]";
}
function kGl(e) {
  return EC(e) === "[object RegExp]";
}
function MJ(e) {
  return EC(e) === "[object Function]";
}
function SGl(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
var obe = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function xGl(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || obe.hasOwnProperty(n);
  }, !1);
}
var EGl = {
  "http:": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(o) ? o.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(o) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : o.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      var o = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(o) ? o.match(n.re.mailto)[0].length : 0;
    }
  }
}, TGl = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", AGl = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function CGl(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function zGl(e) {
  return function(t, n) {
    var o = t.slice(n);
    return e.test(o) ? o.match(e)[0].length : 0;
  };
}
function LJ() {
  return function(e, t) {
    t.normalize(e);
  };
}
function XE(e) {
  var t = e.re = yGl()(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(TGl), n.push(t.src_xn), t.src_tlds = n.join("|");
  function o(s) {
    return s.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(o(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(o(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(o(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(o(t.tpl_host_fuzzy_test), "i");
  var r = [];
  e.__compiled__ = {};
  function i(s, c) {
    throw new Error('(LinkifyIt) Invalid schema "' + s + '": ' + c);
  }
  Object.keys(e.__schemas__).forEach(function(s) {
    var c = e.__schemas__[s];
    if (c !== null) {
      var l = { validate: null, link: null };
      if (e.__compiled__[s] = l, wGl(c)) {
        kGl(c.validate) ? l.validate = zGl(c.validate) : MJ(c.validate) ? l.validate = c.validate : i(s, c), MJ(c.normalize) ? l.normalize = c.normalize : c.normalize ? i(s, c) : l.normalize = LJ();
        return;
      }
      if ($Gl(c)) {
        r.push(s);
        return;
      }
      i(s, c);
    }
  }), r.forEach(function(s) {
    e.__compiled__[e.__schemas__[s]] && (e.__compiled__[s].validate = e.__compiled__[e.__schemas__[s]].validate, e.__compiled__[s].normalize = e.__compiled__[e.__schemas__[s]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: LJ() };
  var a = Object.keys(e.__compiled__).filter(function(s) {
    return s.length > 0 && e.__compiled__[s];
  }).map(SGl).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), CGl(e);
}
function OGl(e, t) {
  var n = e.__index__, o = e.__last_index__, r = e.__text_cache__.slice(n, o);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = o + t, this.raw = r, this.text = r, this.url = r;
}
function wL(e, t) {
  var n = new OGl(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function Lc(e, t) {
  if (!(this instanceof Lc))
    return new Lc(e, t);
  t || xGl(e) && (t = e, e = {}), this.__opts__ = $L({}, obe, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = $L({}, EGl, e), this.__compiled__ = {}, this.__tlds__ = AGl, this.__tlds_replaced__ = !1, this.re = {}, XE(this);
}
Lc.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, XE(this), this;
};
Lc.prototype.set = function(t) {
  return this.__opts__ = $L(this.__opts__, t), this;
};
Lc.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  var n, o, r, i, a, s, c, l, d;
  if (this.re.schema_test.test(t)) {
    for (c = this.re.schema_search, c.lastIndex = 0; (n = c.exec(t)) !== null; )
      if (i = this.testSchemaAt(t, n[2], c.lastIndex), i) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + i;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = t.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (o = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (a = o.index + o[1].length, (this.__index__ < 0 || a < this.__index__) && (this.__schema__ = "", this.__index__ = a, this.__last_index__ = o.index + o[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (d = t.indexOf("@"), d >= 0 && (r = t.match(this.re.email_fuzzy)) !== null && (a = r.index + r[1].length, s = r.index + r[0].length, (this.__index__ < 0 || a < this.__index__ || a === this.__index__ && s > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = a, this.__last_index__ = s))), this.__index__ >= 0;
};
Lc.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
Lc.prototype.testSchemaAt = function(t, n, o) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, o, this) : 0;
};
Lc.prototype.match = function(t) {
  var n = 0, o = [];
  this.__index__ >= 0 && this.__text_cache__ === t && (o.push(wL(this, n)), n = this.__last_index__);
  for (var r = n ? t.slice(n) : t; this.test(r); )
    o.push(wL(this, n)), r = r.slice(this.__last_index__), n += this.__last_index__;
  return o.length ? o : null;
};
Lc.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return null;
  var n = this.re.schema_at_start.exec(t);
  if (!n)
    return null;
  var o = this.testSchemaAt(t, n[2], n[0].length);
  return o ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + o, wL(this, 0)) : null;
};
Lc.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(o, r, i) {
    return o !== i[r - 1];
  }).reverse(), XE(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, XE(this), this);
};
Lc.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
Lc.prototype.onCompile = function() {
};
var PGl = Lc;
const Kh = 2147483647, Xd = 36, jF = 1, Jw = 26, IGl = 38, RGl = 700, rbe = 72, ibe = 128, abe = "-", NGl = /^xn--/, DGl = /[^\0-\x7E]/, MGl = /[\x2E\u3002\uFF0E\uFF61]/g, LGl = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, d5 = Xd - jF, eu = Math.floor, u5 = String.fromCharCode;
function tf(e) {
  throw new RangeError(LGl[e]);
}
function qGl(e, t) {
  const n = [];
  let o = e.length;
  for (; o--; )
    n[o] = t(e[o]);
  return n;
}
function sbe(e, t) {
  const n = e.split("@");
  let o = "";
  n.length > 1 && (o = n[0] + "@", e = n[1]), e = e.replace(MGl, ".");
  const r = e.split("."), i = qGl(r, t).join(".");
  return o + i;
}
function FF(e) {
  const t = [];
  let n = 0;
  const o = e.length;
  for (; n < o; ) {
    const r = e.charCodeAt(n++);
    if (r >= 55296 && r <= 56319 && n < o) {
      const i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((r & 1023) << 10) + (i & 1023) + 65536) : (t.push(r), n--);
    } else
      t.push(r);
  }
  return t;
}
const cbe = (e) => String.fromCodePoint(...e), jGl = function(e) {
  return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : Xd;
}, qJ = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, lbe = function(e, t, n) {
  let o = 0;
  for (e = n ? eu(e / RGl) : e >> 1, e += eu(e / t); e > d5 * Jw >> 1; o += Xd)
    e = eu(e / d5);
  return eu(o + (d5 + 1) * e / (e + IGl));
}, VF = function(e) {
  const t = [], n = e.length;
  let o = 0, r = ibe, i = rbe, a = e.lastIndexOf(abe);
  a < 0 && (a = 0);
  for (let s = 0; s < a; ++s)
    e.charCodeAt(s) >= 128 && tf("not-basic"), t.push(e.charCodeAt(s));
  for (let s = a > 0 ? a + 1 : 0; s < n; ) {
    let c = o;
    for (let d = 1, u = Xd; ; u += Xd) {
      s >= n && tf("invalid-input");
      const _ = jGl(e.charCodeAt(s++));
      (_ >= Xd || _ > eu((Kh - o) / d)) && tf("overflow"), o += _ * d;
      const p = u <= i ? jF : u >= i + Jw ? Jw : u - i;
      if (_ < p)
        break;
      const f = Xd - p;
      d > eu(Kh / f) && tf("overflow"), d *= f;
    }
    const l = t.length + 1;
    i = lbe(o - c, l, c == 0), eu(o / l) > Kh - r && tf("overflow"), r += eu(o / l), o %= l, t.splice(o++, 0, r);
  }
  return String.fromCodePoint(...t);
}, BF = function(e) {
  const t = [];
  e = FF(e);
  let n = e.length, o = ibe, r = 0, i = rbe;
  for (const c of e)
    c < 128 && t.push(u5(c));
  let a = t.length, s = a;
  for (a && t.push(abe); s < n; ) {
    let c = Kh;
    for (const d of e)
      d >= o && d < c && (c = d);
    const l = s + 1;
    c - o > eu((Kh - r) / l) && tf("overflow"), r += (c - o) * l, o = c;
    for (const d of e)
      if (d < o && ++r > Kh && tf("overflow"), d == o) {
        let u = r;
        for (let _ = Xd; ; _ += Xd) {
          const p = _ <= i ? jF : _ >= i + Jw ? Jw : _ - i;
          if (u < p)
            break;
          const f = u - p, g = Xd - p;
          t.push(
            u5(qJ(p + f % g, 0))
          ), u = eu(f / g);
        }
        t.push(u5(qJ(u, 0))), i = lbe(r, l, s == a), r = 0, ++s;
      }
    ++r, ++o;
  }
  return t.join("");
}, dbe = function(e) {
  return sbe(e, function(t) {
    return NGl.test(t) ? VF(t.slice(4).toLowerCase()) : t;
  });
}, ube = function(e) {
  return sbe(e, function(t) {
    return DGl.test(t) ? "xn--" + BF(t) : t;
  });
}, FGl = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.1.0",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: FF,
    encode: cbe
  },
  decode: VF,
  encode: BF,
  toASCII: ube,
  toUnicode: dbe
}, VGl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: VF,
  default: FGl,
  encode: BF,
  toASCII: ube,
  toUnicode: dbe,
  ucs2decode: FF,
  ucs2encode: cbe
}, Symbol.toStringTag, { value: "Module" })), BGl = /* @__PURE__ */ Oa(VGl);
var UGl = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 100
    // Internal protection, recursion limit
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, WGl = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, GGl = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, W$ = ar, HGl = yC, KGl = FUl, YGl = uWl, ZGl = BWl, QGl = bGl, JGl = PGl, pf = mb, _be = BGl, XGl = {
  default: UGl,
  zero: WGl,
  commonmark: GGl
}, eHl = /^(vbscript|javascript|file|data):/, tHl = /^data:image\/(gif|png|jpeg|webp);/;
function nHl(e) {
  var t = e.trim().toLowerCase();
  return eHl.test(t) ? !!tHl.test(t) : !0;
}
var pbe = ["http:", "https:", "mailto:"];
function oHl(e) {
  var t = pf.parse(e, !0);
  if (t.hostname && (!t.protocol || pbe.indexOf(t.protocol) >= 0))
    try {
      t.hostname = _be.toASCII(t.hostname);
    } catch {
    }
  return pf.encode(pf.format(t));
}
function rHl(e) {
  var t = pf.parse(e, !0);
  if (t.hostname && (!t.protocol || pbe.indexOf(t.protocol) >= 0))
    try {
      t.hostname = _be.toUnicode(t.hostname);
    } catch {
    }
  return pf.decode(pf.format(t), pf.decode.defaultChars + "%");
}
function kl(e, t) {
  if (!(this instanceof kl))
    return new kl(e, t);
  t || W$.isString(e) || (t = e || {}, e = "default"), this.inline = new QGl(), this.block = new ZGl(), this.core = new YGl(), this.renderer = new KGl(), this.linkify = new JGl(), this.validateLink = nHl, this.normalizeLink = oHl, this.normalizeLinkText = rHl, this.utils = W$, this.helpers = W$.assign({}, HGl), this.options = {}, this.configure(e), t && this.set(t);
}
kl.prototype.set = function(e) {
  return W$.assign(this.options, e), this;
};
kl.prototype.configure = function(e) {
  var t = this, n;
  if (W$.isString(e) && (n = e, e = XGl[n], !e))
    throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(o) {
    e.components[o].rules && t[o].ruler.enableOnly(e.components[o].rules), e.components[o].rules2 && t[o].ruler2.enableOnly(e.components[o].rules2);
  }), this;
};
kl.prototype.enable = function(e, t) {
  var n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  var o = e.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (o.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + o);
  return this;
};
kl.prototype.disable = function(e, t) {
  var n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  var o = e.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (o.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + o);
  return this;
};
kl.prototype.use = function(e) {
  var t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
kl.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  var n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
kl.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
kl.prototype.parseInline = function(e, t) {
  var n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
kl.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var iHl = kl, aHl = iHl;
const sHl = /* @__PURE__ */ Zr(aHl), TC = new sHl("default", { html: !0, breaks: !0, linkify: !0 });
typeof window > "u" && console.warn(
  "`markdownToSafeHTMLClient` should not be used on the server side. use markdownToSafeHTML instead"
);
function UF(e) {
  if (!e)
    return "";
  const t = TC.render(e);
  let o = Rue.sanitize(t).replace(
    /<ul>/g,
    "<ul style='list-style-type: disc; list-style-position: inside; margin-left: 12px; margin-bottom: 4px'>"
  ).replace(
    /<ol>/g,
    "<ol style='list-style-type: decimal; list-style-position: inside; margin-left: 12px; margin-bottom: 4px'>"
  ).replace(/<a\s+href=/g, "<a target='_blank' class='text-blue-500 hover:text-blue-600' href=");
  return o = o.replace(
    /<li>([^<]+|<strong>.*?<\/strong>)<\/li>\s*<li>\s*<ul([^>]*)>([\s\S]*?)<\/ul>\s*<\/li>/g,
    "<li>$1<ul$2>$3</ul></li>"
  ), o;
}
const cHl = 1.2, lHl = {
  source: "en",
  targets: [
    "ar",
    "az",
    "bg",
    "bn",
    "ca",
    "cs",
    "da",
    "de",
    "el",
    "es",
    "es-419",
    "eu",
    "et",
    "fi",
    "fr",
    "he",
    "hu",
    "it",
    "ja",
    "km",
    "ko",
    "nl",
    "no",
    "pl",
    "pt-BR",
    "pt",
    "ro",
    "ru",
    "sk-SK",
    "sr",
    "sv",
    "tr",
    "uk",
    "vi",
    "zh-CN",
    "zh-TW"
  ]
}, dHl = {
  json: {
    include: [
      "apps/web/public/static/locales/[locale]/common.json"
    ]
  }
}, uHl = "https://lingo.dev/schema/i18n.json", jJ = {
  version: cHl,
  locale: lHl,
  buckets: dHl,
  $schema: uHl
}, eS = {
  variants: {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: 20 }
  },
  initial: "hidden",
  exit: "hidden",
  animate: "visible",
  transition: { ease: "easeInOut", delay: 0.1 }
}, _5 = {
  variants: {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 20 }
  },
  initial: "hidden",
  exit: "hidden",
  animate: "visible",
  transition: { ease: "easeInOut", delay: 0.1 }
}, FJ = {
  mobile: {
    default: {
      width: "100%",
      minHeight: "0px",
      gridTemplateAreas: `
          "meta"
          "header"
          "main"
          "timeslots"
        `,
      gridTemplateColumns: "100%",
      gridTemplateRows: "minmax(min-content,max-content) 1fr"
    }
  },
  month_view: {
    default: {
      width: "calc(var(--booker-meta-width) + var(--booker-main-width))",
      minHeight: "450px",
      height: "auto",
      gridTemplateAreas: `
      "meta main main"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) var(--booker-main-width)",
      gridTemplateRows: "1fr 0fr"
    },
    selecting_time: {
      width: "calc(var(--booker-meta-width) + var(--booker-main-width) + var(--booker-timeslots-width))",
      minHeight: "450px",
      height: "auto",
      gridTemplateAreas: `
      "meta main timeslots"
      "meta main timeslots"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr var(--booker-timeslots-width)",
      gridTemplateRows: "1fr 0fr"
    }
  },
  week_view: {
    default: {
      width: "100vw",
      minHeight: "100vh",
      height: "auto",
      gridTemplateAreas: `
      "meta header header"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr",
      gridTemplateRows: "70px auto"
    }
  },
  column_view: {
    default: {
      width: "100vw",
      minHeight: "100vh",
      height: "auto",
      gridTemplateAreas: `
      "meta header header"
      "meta main main"
      `,
      gridTemplateColumns: "var(--booker-meta-width) 1fr",
      gridTemplateRows: "70px auto"
    }
  }
}, _Hl = (e, t, n = !1) => {
  const o = (r) => n ? "" : r;
  return [
    // Size settings are abstracted on their own lines purely for readability.
    // General sizes, used always
    "[--booker-timeslots-width:240px] lg:[--booker-timeslots-width:280px]",
    // Small calendar defaults
    e === pn.MONTH_VIEW && o("[--booker-meta-width:240px]"),
    // Meta column gets wider in booking view to fit the full date on a single row in case
    // of a multi occurrence event. Also makes form less wide, which also looks better.
    e === pn.MONTH_VIEW && t === "booking" && `[--booker-main-width:420px] ${o("lg:[--booker-meta-width:340px]")}`,
    // Smaller meta when not in booking view.
    e === pn.MONTH_VIEW && t !== "booking" && `[--booker-main-width:480px] ${o("lg:[--booker-meta-width:280px]")}`,
    // Fullscreen view settings.
    e !== pn.MONTH_VIEW && `[--booker-main-width:480px] [--booker-meta-width:340px] ${o(
      "lg:[--booker-meta-width:424px]"
    )}`
  ];
}, pHl = (e, t) => {
  var a;
  const n = bal(), [o, r] = Mal(), i = typeof window < "u" && ((a = window == null ? void 0 : window.isEmbed) == null ? void 0 : a.call(window));
  return Le(() => {
    const s = FJ[e][t] || FJ[e].default;
    if (!o.current)
      return;
    const c = {
      height: (s == null ? void 0 : s.height) || "auto"
    }, l = {
      // Width is animated by the css class instead of via framer motion,
      // because css is better at animating the calcs, framer motion might
      // make some mistakes in that.
      gridTemplateAreas: s == null ? void 0 : s.gridTemplateAreas,
      width: (s == null ? void 0 : s.width) || "auto",
      gridTemplateColumns: s == null ? void 0 : s.gridTemplateColumns,
      gridTemplateRows: s == null ? void 0 : s.gridTemplateRows,
      minHeight: s == null ? void 0 : s.minHeight
    };
    if (n || e === "mobile" || i) {
      const d = { ...l, ...c };
      Object.keys(d).forEach((u) => {
        u === "height" ? o.current.style.height = c.height === "100vh" && i ? "100%" : c.height : o.current.style[u] = d[u];
      });
    } else
      Object.keys(l).forEach((d) => {
        o.current.style[d] = l[d];
      }), r(o.current, c, {
        duration: 0.5,
        ease: ub(0.4, 0, 0.2, 1)
      });
  }, [r, i, o, e, n, t]), o;
}, tS = {
  mobile: {
    // Desktop tablet feels weird on mobile layout,
    // but this is simply here to make the types a lot easier..
    desktop: 0,
    tablet: 0
  },
  [pn.MONTH_VIEW]: {
    desktop: 0,
    tablet: 0
  },
  [pn.WEEK_VIEW]: {
    desktop: 7,
    tablet: 4
  },
  [pn.COLUMN_VIEW]: {
    desktop: 6,
    tablet: 2
  }
}, mHl = hn(
  () => import("./index-GeV5zNpe.js").then((e) => e.TimezoneSelect),
  {
    ssr: !1
  }
), VJ = (e, t, n) => {
  var r;
  const o = jJ.locale.targets.concat([jJ.locale.source]);
  return (r = e == null ? void 0 : e.find(
    (i) => i.field === t && o.includes(i.targetLocale) && (n === i.targetLocale || n.split("-")[0] === i.targetLocale)
  )) == null ? void 0 : r.translatedText;
}, fHl = ({
  event: e,
  isPending: t,
  isPlatform: n = !0,
  isPrivateLink: o,
  classNames: r,
  locale: i,
  timeZones: a,
  children: s,
  selectedTimeslot: c,
  roundRobinHideOrgAndTeam: l
}) => {
  const { timeFormat: d, timezone: u } = vd(), [_] = lu((j) => [j.setTimezone]), [p] = St((j) => [j.setTimezone], Fr), f = St((j) => j.selectedDuration), g = St((j) => j.state), h = St((j) => j.bookingData), b = St((j) => j.rescheduleUid), [v, $] = St(
    (j) => [j.seatedEventData, j.setSeatedEventData],
    Fr
  ), { i18n: k, t: S } = Fe(), O = wj(), D = fu() ? O.hideEventTypeDetails : !1, [M] = Tt(
    () => n ? [Uj] : [mHl],
    [n]
  );
  if (Le(() => {
    var j;
    if (e != null && e.lockTimeZoneToggleOnBookingPage) {
      const q = e.lockedTimeZone || ((j = e.schedule) == null ? void 0 : j.timeZone);
      q && _(q);
    }
  }, [e, _]), D)
    return null;
  const N = (v == null ? void 0 : v.attendees) || (h == null ? void 0 : h.attendees.length), C = (v == null ? void 0 : v.seatsPerTimeSlot) || (e == null ? void 0 : e.seatsPerTimeSlot), P = N && C && N / C >= 0.5, w = N && C && N / C >= 0.83 ? "text-rose-600" : P ? "text-yellow-500" : "text-bookinghighlight", E = i ?? navigator.language, T = VJ(
    (e == null ? void 0 : e.fieldTranslations) ?? [],
    oG.DESCRIPTION,
    E
  ), z = VJ(
    (e == null ? void 0 : e.fieldTranslations) ?? [],
    oG.TITLE,
    E
  );
  return /* @__PURE__ */ Y("div", { className: `${(r == null ? void 0 : r.eventMetaContainer) || ""} relative z-10 p-6`, "data-testid": "event-meta", children: [
    t && /* @__PURE__ */ m(Hw.div, { ..._5, initial: "visible", layout: !0, children: /* @__PURE__ */ m(O_l, {}) }),
    !t && !!e && /* @__PURE__ */ Y(Hw.div, { ..._5, layout: !0, transition: { ..._5.transition, delay: 0.3 }, children: [
      /* @__PURE__ */ m(
        P_l,
        {
          schedulingType: e.schedulingType,
          users: e.subsetOfUsers,
          profile: e.profile,
          entity: e.entity,
          isPrivateLink: o,
          roundRobinHideOrgAndTeam: l
        }
      ),
      /* @__PURE__ */ m(z_l, { className: `${r == null ? void 0 : r.eventMetaTitle} my-2`, children: z ?? (e == null ? void 0 : e.title) }),
      (e.description || T) && /* @__PURE__ */ m(
        Gd,
        {
          "data-testid": "event-meta-description",
          contentClassName: "mb-8 break-words max-w-full max-h-[180px] scroll-bar pr-4",
          children: /* @__PURE__ */ m(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: UF(T ?? e.description)
              }
            }
          )
        }
      ),
      /* @__PURE__ */ Y("div", { className: "space-y-4 font-medium rtl:-mr-2", children: [
        b && h && /* @__PURE__ */ Y(Gd, { icon: "calendar", children: [
          S("former_time"),
          /* @__PURE__ */ m("br", {}),
          /* @__PURE__ */ m("span", { className: "line-through", "data-testid": "former_time_p", children: /* @__PURE__ */ m(
            XQ,
            {
              date: h.startTime.toString(),
              duration: null,
              timeFormat: d,
              timeZone: u,
              language: k.language
            }
          ) })
        ] }),
        c && /* @__PURE__ */ m(Gd, { icon: "calendar", children: /* @__PURE__ */ m(
          XQ,
          {
            date: c,
            duration: f || e.length,
            timeFormat: d,
            timeZone: u,
            language: k.language
          }
        ) }),
        /* @__PURE__ */ m(C_l, { event: e }),
        /* @__PURE__ */ m(
          Gd,
          {
            className: "cursor-pointer [&_.current-timezone:before]:focus-within:opacity-100 [&_.current-timezone:before]:hover:opacity-100",
            contentClassName: "relative max-w-[90%]",
            icon: "globe",
            children: g === "booking" ? /* @__PURE__ */ m(Ce, { children: u }) : /* @__PURE__ */ m(
              "span",
              {
                className: `current-timezone before:bg-subtle min-w-32 -mt-[2px] flex h-6 max-w-full items-center justify-start before:absolute before:inset-0 before:bottom-[-3px] before:left-[-30px] before:top-[-3px] before:w-[calc(100%_+_35px)] before:rounded-md before:py-3 before:opacity-0 before:transition-opacity ${e.lockTimeZoneToggleOnBookingPage ? "cursor-not-allowed" : ""}`,
                "data-testid": "event-meta-current-timezone",
                children: /* @__PURE__ */ m(
                  M,
                  {
                    timeZones: a,
                    menuPosition: "absolute",
                    timezoneSelectCustomClassname: r == null ? void 0 : r.eventMetaTimezoneSelect,
                    classNames: {
                      control: () => "!min-h-0 p-0 w-full border-0 bg-transparent focus-within:ring-0 shadow-none!",
                      menu: () => "!w-64 max-w-[90vw] mb-1 ",
                      singleValue: () => "text-text py-1",
                      indicatorsContainer: () => "ml-auto",
                      container: () => "max-w-full"
                    },
                    value: e.lockTimeZoneToggleOnBookingPage ? e.lockedTimeZone || Kf : u,
                    onChange: ({ value: j }) => {
                      _(j), p(j);
                    },
                    isDisabled: e.lockTimeZoneToggleOnBookingPage
                  }
                )
              }
            )
          }
        ),
        g === "booking" && C && N ? /* @__PURE__ */ m(Gd, { icon: "user", className: `${w}`, children: /* @__PURE__ */ m("div", { className: "text-bookinghighlight flex items-start text-sm", children: /* @__PURE__ */ m("p", { children: /* @__PURE__ */ m(
          Eve,
          {
            showExact: !!v.showAvailableSeatsCount,
            totalSeats: C,
            bookedSeats: N || 0,
            variant: "fraction"
          }
        ) }) }) }) : null
      ] }),
      s && /* @__PURE__ */ m("div", { className: r == null ? void 0 : r.eventMetaChildren, children: s })
    ] })
  ] });
};
var BJ = {};
function gHl(e) {
  const { t } = Fe(), [n, o] = ze(!1);
  return !e.visible || BJ.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD == "0" && pD == 0 || !BJ.NEXT_PUBLIC_BOOKER_NUMBER_OF_DAYS_TO_LOAD || n && !e.isScheduleLoading || e.isScheduleLoading || !e.dayCount ? null : /* @__PURE__ */ Y("div", { className: "bg-default border-subtle mt-6 flex w-1/2 min-w-0 items-center justify-between rounded-[32px] border p-3 text-sm leading-none shadow-sm lg:w-1/3", children: [
    /* @__PURE__ */ Y("div", { className: "flex items-center gap-2 overflow-x-hidden", children: [
      /* @__PURE__ */ m(ot, { name: "info", className: "text-default h-4 w-4" }),
      /* @__PURE__ */ m("p", { className: "w-full  leading-none", children: t("having_trouble_finding_time") })
    ] }),
    /* @__PURE__ */ Y(
      "button",
      {
        className: "inline-flex items-center gap-2 font-medium",
        onClick: (r) => {
          r.preventDefault(), e.onButtonClick(), o(!0);
        },
        children: [
          t("show_more"),
          " ",
          /* @__PURE__ */ m(ot, { name: "arrow-right", className: "h-4 w-4" })
        ]
      }
    )
  ] });
}
const hHl = (e, t) => {
  const o = De().startOf("week").format("YYYY-MM-DD"), r = St((i) => i.setSelectedDate);
  Le(() => {
    e && t && r({ date: o, omitUpdatingParams: !0 });
  }, []);
};
function mbe({
  extraDays: e,
  isMobile: t,
  enabledLayouts: n,
  nextSlots: o,
  eventSlug: r,
  isMyLink: i,
  renderOverlay: a,
  isCalendarView: s
}) {
  const { t: c, i18n: l } = Fe(), d = fu(), u = Zo(), [_, p] = St((C) => [C.layout, C.setLayout], Fr), f = St((C) => C.selectedDate), g = St((C) => C.setSelectedDate), h = St((C) => C.addToSelectedDate), b = s !== void 0 ? !s : _ === pn.MONTH_VIEW, v = De(), $ = f ? De(f) : v, k = Tt(() => {
    const C = v.diff($, "days");
    return C > 3 || C < -3;
  }, [v, $]);
  hHl(u, s ?? !1);
  const S = at(
    (C) => {
      _ === C || !C || p(C);
    },
    [p, _]
  );
  if (t || !n)
    return null;
  if (b)
    return /* @__PURE__ */ Y("div", { className: "flex gap-2", children: [
      i && !d ? /* @__PURE__ */ m(Ao, { content: c("troubleshooter_tooltip"), side: "bottom", children: /* @__PURE__ */ m(
        ut,
        {
          color: "primary",
          target: "_blank",
          href: `${Si}/availability/troubleshoot?eventType=${r}`,
          children: c("need_help")
        }
      ) }) : a == null ? void 0 : a(),
      /* @__PURE__ */ m(
        p5,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: S
        }
      )
    ] });
  const O = $.add(_ === pn.COLUMN_VIEW ? e : e - 1, "days"), I = () => $.format("MMM") === O.format("MMM"), D = () => $.format("YYYY") === O.format("YYYY"), M = new Intl.DateTimeFormat(l.language ?? "en", { month: "short" });
  return /* @__PURE__ */ Y("div", { className: "border-default relative z-10 flex border-b px-5 py-4 ltr:border-l rtl:border-r", children: [
    /* @__PURE__ */ Y("div", { className: "flex items-center gap-5 rtl:flex-grow", children: [
      /* @__PURE__ */ m(() => /* @__PURE__ */ Y("h3", { className: "min-w-[150px] text-base font-semibold leading-4", children: [
        M.format($.toDate()),
        " ",
        $.format("D"),
        !D() && /* @__PURE__ */ Y("span", { className: "text-subtle", children: [
          ", ",
          $.format("YYYY"),
          " "
        ] }),
        "-",
        " ",
        !I() && M.format(O.toDate()),
        " ",
        O.format("D"),
        ",",
        " ",
        /* @__PURE__ */ m("span", { className: "text-subtle", children: D() ? $.format("YYYY") : O.format("YYYY") })
      ] }), {}),
      /* @__PURE__ */ Y(HA, { children: [
        /* @__PURE__ */ m(
          ut,
          {
            className: "group rtl:ml-1 rtl:rotate-180",
            variant: "icon",
            color: "minimal",
            StartIcon: "chevron-left",
            "aria-label": "Previous Day",
            onClick: () => h(_ === pn.COLUMN_VIEW ? -o : -e)
          }
        ),
        /* @__PURE__ */ m(
          ut,
          {
            className: "group rtl:mr-1 rtl:rotate-180",
            variant: "icon",
            color: "minimal",
            StartIcon: "chevron-right",
            "aria-label": "Next Day",
            onClick: () => h(_ === pn.COLUMN_VIEW ? o : e)
          }
        ),
        k && /* @__PURE__ */ m(
          ut,
          {
            className: "capitalize ltr:ml-2 rtl:mr-2",
            color: "secondary",
            onClick: () => {
              const C = (s ? v.startOf("week") : v).format("YYYY-MM-DD");
              g({ date: C });
            },
            children: c("today")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ Y("div", { className: "ml-auto flex gap-2", children: [
      a == null ? void 0 : a(),
      /* @__PURE__ */ m(Pve, {}),
      /* @__PURE__ */ m("div", { className: "fixed top-4 ltr:right-4 rtl:left-4", children: /* @__PURE__ */ m(
        p5,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: S
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "pointer-events-none opacity-0", "aria-hidden": !0, children: /* @__PURE__ */ m(
        p5,
        {
          layout: _,
          enabledLayouts: n,
          onLayoutToggle: S
        }
      ) })
    ] })
  ] });
}
const vHl = ({
  onLayoutToggle: e,
  layout: t,
  enabledLayouts: n
}) => {
  const o = fu(), r = Zo(), { t: i } = Fe(), a = Tt(() => [
    {
      value: pn.MONTH_VIEW,
      label: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(ot, { name: "calendar", width: "16", height: "16" }),
        /* @__PURE__ */ Y("span", { className: "sr-only", children: [
          "$",
          i("switch_monthly")
        ] })
      ] }),
      tooltip: i("switch_monthly")
    },
    {
      value: pn.WEEK_VIEW,
      label: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(ot, { name: "grid-3x3", width: "16", height: "16" }),
        /* @__PURE__ */ Y("span", { className: "sr-only", children: [
          "$",
          i("switch_weekly")
        ] })
      ] }),
      tooltip: i("switch_weekly")
    },
    {
      value: pn.COLUMN_VIEW,
      label: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(ot, { name: "columns-3", width: "16", height: "16" }),
        /* @__PURE__ */ Y("span", { className: "sr-only", children: [
          "$",
          i("switch_columnview")
        ] })
      ] }),
      tooltip: i("switch_columnview")
    }
  ].filter((s) => n == null ? void 0 : n.includes(s.value)), [i, n]);
  return o || r ? null : /* @__PURE__ */ m(cj, { onValueChange: e, defaultValue: t, options: a });
}, p5 = ({
  enabledLayouts: e,
  onLayoutToggle: t,
  layout: n
}) => e.length <= 1 ? null : /* @__PURE__ */ m(vHl, { onLayoutToggle: t, layout: n, enabledLayouts: e }), bHl = ({ onConnectNow: e, event: t, cooldownMs: n = 0 }) => {
  const { t: o } = Fe(), r = n > 0;
  return /* @__PURE__ */ Y("div", { className: " bg-default border-subtle mx-2 block items-center gap-3 rounded-xl border p-[6px] text-sm shadow-sm delay-1000 sm:flex", children: [
    /* @__PURE__ */ Y("div", { className: "flex items-center gap-3 ps-1", children: [
      /* @__PURE__ */ Y("div", { className: "relative", children: [
        /* @__PURE__ */ m(
          fXc,
          {
            size: "sm",
            className: "border-muted",
            organization: {
              slug: t.entity.orgSlug,
              name: t.entity.name || "",
              logoUrl: t.entity.logoUrl ?? null
            },
            users: t.subsetOfUsers.slice(0, 2),
            disableHref: !0
          }
        ),
        /* @__PURE__ */ m("div", { className: "border-muted absolute -bottom-0.5 -right-1 h-2 w-2 rounded-full border bg-green-500" })
      ] }),
      /* @__PURE__ */ m("div", { children: o("dont_want_to_wait") })
    ] }),
    /* @__PURE__ */ m("div", { className: "mt-2 flex items-center gap-3 sm:mt-0", children: r ? /* @__PURE__ */ m(Ao, { content: o("just_connected_description"), children: /* @__PURE__ */ m("span", { className: "inline-flex", children: /* @__PURE__ */ m(
      ut,
      {
        disabled: r,
        color: "primary",
        onClick: () => {
          e();
        },
        size: "sm",
        className: "w-full justify-center rounded-lg sm:w-auto",
        children: o("connect_now")
      }
    ) }) }) : /* @__PURE__ */ m(
      ut,
      {
        color: "primary",
        onClick: () => {
          e();
        },
        size: "sm",
        className: "w-full justify-center rounded-lg sm:w-auto",
        children: o("connect_now")
      }
    ) })
  ] });
}, fbe = ({ schedule: e, eventDuration: t }) => Tt(() => {
  const n = {};
  if (!e || !e.slots)
    return n;
  for (const o in e.slots)
    n[o] = e.slots[o].map((r) => {
      const { time: i, ...a } = r;
      return {
        start: De(i).toDate(),
        end: De(i).add(t, "minutes").toDate(),
        ...a
      };
    });
  return n;
}, [e, t]);
function UJ(e = 0, t, n = 6) {
  const o = t;
  for (; o.getDay() !== e; )
    o.setDate(o.getDate() - 1);
  return {
    startDate: o,
    endDate: new Date(o.getTime() + n * 24 * 60 * 60 * 1e3)
  };
}
function yHl({
  day: e,
  gridCellIdx: t,
  totalGridCells: n,
  selectionLength: o,
  startHour: r,
  timezone: i
}) {
  const c = (o + 1) * 60 / n * t;
  return De(e).tz(i).startOf("day").add(c, "minutes").add(r, "hours");
}
function $Hl(e, t) {
  const n = [];
  let o = De(e).hour(0).minute(0).second(0).millisecond(0);
  n.push(o);
  const r = De(t).hour(0).minute(0).second(0).millisecond(0);
  for (; o.isBefore(r); )
    n.push(o.add(1, "day")), o = o.add(1, "day");
  return n.slice(0, 7);
}
function wHl(e, t, n) {
  const o = [];
  let r = De("1970-01-01").tz(n).hour(e);
  o.push(r);
  const i = De("1970-01-01").tz(n).hour(t);
  for (; r.isBefore(i); )
    o.push(r.add(1, "hour")), r = r.add(1, "hour");
  return o;
}
function kHl(e) {
  e.sort((n, o) => n.start.getTime() - o.start.getTime());
  const t = [];
  for (let n = 0; n < e.length; n++)
    if (t.length === 0)
      t.push(e[n]);
    else {
      const o = t[t.length - 1], r = e[n];
      o.end.getTime() >= r.start.getTime() ? o.end = r.end : t.push(r);
    }
  return t;
}
const SHl = {
  view: "week",
  startDate: UJ(0, /* @__PURE__ */ new Date()).startDate,
  endDate: UJ(0, /* @__PURE__ */ new Date()).endDate,
  events: [],
  startHour: 0,
  endHour: 23,
  gridCellsPerHour: 4,
  timezone: Kf,
  showBackgroundPattern: !0,
  showBorder: !0,
  borderColor: "default"
}, Wa = p9((e) => ({
  ...SHl,
  setView: (t) => e({ view: t }),
  setStartDate: (t) => e({ startDate: t }),
  setEndDate: (t) => e({ endDate: t }),
  setEvents: (t) => e({ events: t }),
  // This looks a bit odd but init state only overrides the public props + actions as we don't want to override our internal state
  initState: (t) => {
    let n = t.events;
    t.sortEvents && (n = t.events.sort((r, i) => De(r.start).valueOf() - De(i.start).valueOf()));
    const o = kHl(t.blockingDates || []);
    e({
      ...t,
      blockingDates: o,
      events: n
    });
  },
  setSelectedEvent: (t) => e({ selectedEvent: t }),
  handleDateChange: (t) => e((n) => {
    var s, c;
    const { startDate: o, endDate: r } = n;
    if (t === "INCREMENT") {
      const l = De(o).add(1, n.view).toDate(), d = De(r).add(1, n.view).toDate();
      return n.minDate && l < n.minDate || n.maxDate && d > n.maxDate ? {
        startDate: o,
        endDate: r
      } : ((s = n.onDateChange) == null || s.call(n, l, d), {
        startDate: l,
        endDate: d
      });
    }
    const i = De(o).subtract(1, n.view).toDate(), a = De(r).subtract(1, n.view).toDate();
    return (c = n.onDateChange) == null || c.call(n, i, a), {
      startDate: i,
      endDate: a
    };
  })
}));
function xHl({ showBorder: e, borderColor: t, days: n, containerNavRef: o }) {
  const { i18n: r } = Fe(), i = (a) => new Intl.DateTimeFormat(r.language, { weekday: "short" }).format(a.toDate());
  return /* @__PURE__ */ Y(
    "div",
    {
      ref: o,
      className: ae(
        "bg-default dark:bg-default sticky top-[var(--calendar-dates-sticky-offset,0px)] z-[80] flex-none border-b sm:pr-8",
        t === "subtle" ? "border-b-subtle" : "border-b-default",
        e && (t === "subtle" ? "border-r-subtle border-r" : "border-r-default border-r")
      ),
      children: [
        /* @__PURE__ */ m("div", { className: "text-subtle flex leading-6 sm:hidden", "data-dayslength": n.length, children: n.map((a) => {
          const s = De().isSame(a, "day");
          return /* @__PURE__ */ Y(
            "button",
            {
              type: "button",
              className: "flex flex-1 flex-col items-center pb-3 pt-2",
              children: [
                a.format("dd"),
                " ",
                /* @__PURE__ */ m(
                  "span",
                  {
                    className: ae(
                      "text-emphasis mt-1 flex h-8 w-8 items-center justify-center font-medium",
                      s && "bg-inverted text-inverted rounded-sm"
                    ),
                    children: a.format("D")
                  }
                )
              ]
            },
            a.toString()
          );
        }) }),
        /* @__PURE__ */ Y("div", { className: "text-subtle -mr-px hidden auto-cols-fr leading-6 sm:flex", children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: ae(
                "col-end-1 w-16",
                e && (t === "subtle" ? "border-l-subtle border-l" : "border-l-default border-l")
              )
            }
          ),
          n.map((a) => {
            const s = De().isSame(a, "day");
            return /* @__PURE__ */ m(
              "div",
              {
                className: ae(
                  "flex flex-1 items-center justify-center py-3 text-xs font-medium uppercase",
                  s && "text-default"
                ),
                children: /* @__PURE__ */ Y("span", { children: [
                  i(a),
                  " ",
                  /* @__PURE__ */ m(
                    "span",
                    {
                      className: ae(
                        "items-center justify-center p-1",
                        s && "bg-brand-default text-brand rounded-md"
                      ),
                      children: a.format("DD")
                    }
                  )
                ] })
              },
              a.toString()
            );
          })
        ] })
      ]
    }
  );
}
function EHl(e, t, n) {
  const o = e * 60;
  return t * 60 + n - o;
}
function THl({ timezone: e }) {
  const { timeFormat: t } = lu(), n = Ue(null), [o, r] = ze(!1), [i, a] = ze(null), { startHour: s, endHour: c } = Wa((l) => ({
    startHour: l.startHour || 0,
    endHour: l.endHour || 23
  }));
  return Le(() => {
    const l = De().tz(e), d = l.hour(), u = l.minute();
    (d > c || d < s) && a(null);
    const _ = EHl(s, d, u);
    a(_), !(!n.current || o) && setTimeout(() => {
      var p;
      (p = n == null ? void 0 : n.current) == null || p.scrollIntoView({ block: "center" }), r(!0);
    }, 100);
  }, [s, c, o, e]), /* @__PURE__ */ Y(
    "div",
    {
      ref: n,
      className: "absolute top-0 z-40 flex h-px items-center justify-center text-xs",
      "aria-hidden": "true",
      style: {
        top: `calc(${i}*var(--one-minute-height) + var(--calendar-offset-top))`,
        zIndex: 70
      },
      children: [
        /* @__PURE__ */ m("div", { className: "w-16 pr-2 text-right", children: De().tz(e).format(t) }),
        /* @__PURE__ */ m("div", { className: "bg-inverted h-3 w-px" }),
        /* @__PURE__ */ m("div", { className: "bg-inverted h-px w-screen" })
      ]
    }
  );
}
function AHl(e) {
  const t = yHl({
    day: e.day,
    gridCellIdx: e.gridCellIdx,
    totalGridCells: e.totalGridCells,
    selectionLength: e.selectionLength,
    startHour: e.startHour,
    timezone: e.timezone
  }), n = (t.hour() - e.startHour) * 60 + t.minute();
  return /* @__PURE__ */ m(gbe, { topOffsetMinutes: n, timeSlot: De(t).tz(e.timezone) });
}
function CHl({ timezone: e, availableSlots: t, day: n, startHour: o }) {
  var c;
  const i = De(n).format("YYYY-MM-DD"), a = t && t[i], s = Tt(() => {
    const l = [];
    let d = -1, u = -1, _ = !0, p = 0;
    if (a == null || a.forEach((f, g) => {
      const h = De(f.start).tz(e), b = (h.hour() - o) * 60 + h.minute();
      l.push({ slot: f, topOffsetMinutes: b }), f.away ? (d === -1 && (d = g), u = g) : _ = !1;
    }), _ && d !== -1) {
      const f = a[d], g = a[u];
      return p = De(g.end).diff(De(f.start), "minutes"), f.toUser == null ? null : {
        slots: l,
        startEndTimeDuration: p,
        firstSlot: f,
        timezone: e
      };
    }
    return { slots: l, startEndTimeDuration: p };
  }, [a, o, e]);
  if (s === null)
    return null;
  if (s.startEndTimeDuration) {
    const { firstSlot: l, startEndTimeDuration: d } = s;
    return /* @__PURE__ */ m(
      zHl,
      {
        timeSlot: De(l == null ? void 0 : l.start).tz(s.timezone),
        topOffsetMinutes: (c = s.slots[0]) == null ? void 0 : c.topOffsetMinutes,
        startEndTimeDuration: d,
        children: /* @__PURE__ */ m(
          xve,
          {
            fromUser: l == null ? void 0 : l.fromUser,
            toUser: l == null ? void 0 : l.toUser,
            reason: l == null ? void 0 : l.reason,
            emoji: l == null ? void 0 : l.emoji,
            borderDashed: !1,
            date: i,
            className: "pb-0"
          }
        )
      }
    );
  }
  return /* @__PURE__ */ m(Ce, { children: s.slots.map((l, d) => /* @__PURE__ */ m(
    gbe,
    {
      timeSlot: De(l.slot.start).tz(e),
      topOffsetMinutes: l.topOffsetMinutes
    },
    d
  )) });
}
function gbe({ isDisabled: e, topOffsetMinutes: t, timeSlot: n }) {
  const { timeFormat: o } = lu(), { onEmptyCellClick: r, hoverEventDuration: i } = Wa(
    (a) => ({
      onEmptyCellClick: a.onEmptyCellClick,
      hoverEventDuration: a.hoverEventDuration
    }),
    Fr
  );
  return /* @__PURE__ */ m(
    "div",
    {
      className: ae(
        "group flex w-[calc(100%-1px)] items-center justify-center",
        e && "pointer-events-none",
        !e && "bg-default dark:bg-muted",
        t && "absolute"
      ),
      "data-disabled": e,
      "data-slot": n.toISOString(),
      "data-testid": "calendar-empty-cell",
      style: {
        height: `calc(${i}*var(--one-minute-height))`,
        overflow: "visible",
        top: t ? `calc(${t}*var(--one-minute-height))` : void 0
      },
      onClick: () => {
        r == null || r(n.toDate());
      },
      children: !e && i !== 0 && /* @__PURE__ */ m(
        "div",
        {
          className: ae(
            "opacity-4 bg-brand-default hover:bg-brand-default text-brand dark:border-emphasis absolute hidden rounded-[4px] p-[6px] text-xs font-semibold leading-5 group-hover:flex group-hover:cursor-pointer",
            i && i > 15 && "items-start pt-3",
            i && i < 15 && "items-center"
          ),
          style: {
            height: `calc(${i}*var(--one-minute-height) - 2px)`,
            zIndex: 80,
            // @TODO: This used to be 90% as per Sean's work. I think this was needed when
            // multiple events are stacked next to each other. We might need to add this back later.
            width: "calc(100% - 2px)"
          },
          children: /* @__PURE__ */ m("div", { className: "overflow-ellipsis leading-[0]", children: n.format(o) })
        }
      )
    }
  );
}
function zHl({
  timeSlot: e,
  children: t,
  topOffsetMinutes: n,
  startEndTimeDuration: o
}) {
  return /* @__PURE__ */ m(
    "div",
    {
      className: ae(
        "bg-default dark:bg-muted group absolute z-[65] flex w-[calc(100%-1px)] items-center justify-center"
      ),
      "data-slot": e.toISOString(),
      style: {
        top: n ? `calc(${n}*var(--one-minute-height))` : void 0,
        overflow: "visible"
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          className: ae(
            "dark:border-emphasis bg-default dark:bg-muted cursor-pointer rounded-[4px] p-[6px] text-xs font-semibold dark:text-white"
          ),
          style: {
            height: `calc(${o}*var(--one-minute-height) - 2px)`,
            width: "calc(100% - 2px)"
          },
          children: t
        }
      )
    }
  );
}
function hbe(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (t = 0; t < r; t++)
        e[t] && (n = hbe(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function OHl() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++)
    (e = arguments[n]) && (t = hbe(e)) && (o && (o += " "), o += t);
  return o;
}
const WJ = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, GJ = OHl, PHl = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null)
    return GJ(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((l) => {
    const d = n == null ? void 0 : n[l], u = i == null ? void 0 : i[l];
    if (d === null)
      return null;
    const _ = WJ(d) || WJ(u);
    return r[l][_];
  }), s = n && Object.entries(n).reduce((l, d) => {
    let [u, _] = d;
    return _ === void 0 || (l[u] = _), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, d) => {
    let { class: u, className: _, ...p } = d;
    return Object.entries(p).every((f) => {
      let [g, h] = f;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...s
      }[g]) : {
        ...i,
        ...s
      }[g] === h;
    }) ? [
      ...l,
      u,
      _
    ] : l;
  }, []);
  return GJ(e, a, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, IHl = PHl(
  "group flex h-full w-full overflow-x-hidden overflow-y-auto rounded-[6px] px-[6px] text-xs leading-5 opacity-80 border-default font-medium",
  {
    variants: {
      status: {
        ACCEPTED: "bg-subtle hover:bg-emphasis text-emphasis border-[1px] border-default",
        PENDING: "bg-muted text-emphasis border-[1px] border-dashed border-default",
        REJECTED: "bg-muted border-[1px] text-subtle line-through",
        CANCELLED: "bg-muted border-[1px] text-subtle line-through",
        AWAITING_HOST: "bg-muted text-emphasis border-[1px] border-dashed border-default"
      },
      disabled: {
        true: "hover:cursor-default",
        false: "hover:cursor-pointer"
      },
      selected: {
        true: "bg-inverted text-inverted border-[1px] border-transparent",
        false: ""
      }
    }
  }
);
function RHl({
  event: e,
  currentlySelectedEventId: t,
  eventDuration: n,
  disabled: o,
  onEventClick: r
}) {
  var c, l;
  const i = t === e.id, { options: a } = e, s = r ? "button" : "div";
  return /* @__PURE__ */ m(Ao, { content: e.title, children: /* @__PURE__ */ Y(
    s,
    {
      onClick: () => r == null ? void 0 : r(e),
      className: ae(
        IHl({
          status: a == null ? void 0 : a.status,
          disabled: o,
          selected: i
        }),
        a == null ? void 0 : a.className
      ),
      children: [
        (a == null ? void 0 : a.color) && /* @__PURE__ */ m(
          "div",
          {
            className: "-ml-1.5 mr-1.5 h-full w-[3px] shrink-0",
            style: { backgroundColor: a.color }
          }
        ),
        /* @__PURE__ */ Y("div", { className: ae("flex", n > 30 && "flex-col py-1"), children: [
          /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "flex w-full gap-2 overflow-hidden overflow-ellipsis whitespace-nowrap text-left leading-4",
                n <= 30 && "items-center"
              ),
              children: [
                /* @__PURE__ */ m("span", { children: e.title }),
                n <= 30 && !((c = e.options) != null && c.hideTime) && /* @__PURE__ */ Y("p", { className: "text-subtle mt-1 w-full whitespace-nowrap text-left text-[10px] leading-none", children: [
                  De(e.start).format("HH:mm"),
                  " - ",
                  De(e.end).format("HH:mm")
                ] })
              ]
            }
          ),
          n > 30 && !((l = e.options) != null && l.hideTime) && /* @__PURE__ */ Y("p", { className: "text-subtle mt-1 text-left text-[10px] leading-none", children: [
            De(e.start).format("HH:mm"),
            " - ",
            De(e.end).format("HH:mm")
          ] }),
          n > 45 && e.description && /* @__PURE__ */ m("p", { className: "text-subtle mt-1 text-left text-[10px] leading-none", children: e.description })
        ] })
      ]
    }
  ) });
}
function NHl({ day: e }) {
  const { startHour: t, events: n, eventOnClick: o } = Wa(
    (i) => ({
      startHour: i.startHour,
      events: i.events,
      eventOnClick: i.onEventClick
    }),
    Fr
  ), r = Ue(null);
  return /* @__PURE__ */ m(Ce, { children: n.filter((i) => {
    var a;
    return De(i.start).isSame(e, "day") && !((a = i.options) != null && a.allDay);
  }).map((i, a, s) => {
    var $;
    let c = 90, l = 0, d = 0, u = 61;
    const _ = De(i.start), p = De(i.end), f = p.diff(_, "minutes"), h = (_.hour() - (t || 0)) * 60 + _.minute(), b = s[a + 1], v = s[a - 1];
    if (r.current ? f > r.current.duration && _.isBetween(r.current.start, r.current.end) && (r.current = {
      idx: a,
      start: _.toDate(),
      end: p.toDate(),
      duration: f
    }) : r.current = {
      idx: a,
      start: _.toDate(),
      end: p.toDate(),
      duration: f
    }, r.current.idx !== a) {
      if (b) {
        const k = De(b.start);
        (k.isBetween(r.current.start, r.current.end) || k.isBetween(_.add(-5, "minutes"), _.add(5, "minutes"))) && (u = 65, l = "auto", d = 4, c = c / 2);
      } else if (v) {
        const k = De(v.start);
        k.isBetween(r.current.start, r.current.end) ? (u = 65, l = "auto", d = 4) : _.isBetween(k.add(5, "minutes"), k.add(-5, "minutes")) && (u = 65, d = 4, c = c / 2);
      }
    }
    return /* @__PURE__ */ m(
      "div",
      {
        className: "absolute inset-x-1 ",
        "data-testid": ($ = i.options) == null ? void 0 : $["data-test-id"],
        style: {
          marginLeft: l,
          zIndex: u,
          right: `calc(${d}% - 1px)`,
          width: `${c}%`,
          top: `calc(${h}*var(--one-minute-height))`,
          height: `calc(${f}*var(--one-minute-height))`
        },
        children: /* @__PURE__ */ m(RHl, { event: i, eventDuration: f, onEventClick: o })
      },
      `${i.id}-${_.toISOString()}`
    );
  }) });
}
const HJ = ve.forwardRef(function({ offsetHeight: t, gridStopsPerDay: n, children: o, zIndex: r }, i) {
  return /* @__PURE__ */ m(
    "ol",
    {
      ref: i,
      className: "scheduler-grid-row-template col-start-1 col-end-2 row-start-1 grid auto-cols-auto text-[0px] sm:pr-8",
      style: { marginTop: t || "var(--gridDefaultSize)", zIndex: r },
      "data-gridstopsperday": n,
      children: o
    }
  );
});
function DHl() {
  const { startDate: e, endDate: t, handleDateChange: n } = Wa((o) => ({
    startDate: De(o.startDate),
    endDate: De(o.endDate),
    handleDateChange: o.handleDateChange
  }));
  return /* @__PURE__ */ Y("header", { className: "flex flex-none flex-col justify-between py-4 sm:flex-row sm:items-center", children: [
    /* @__PURE__ */ Y("h1", { className: "text-emphasis text-xl font-semibold", children: [
      e.format("MMM DD"),
      "-",
      t.format("DD"),
      /* @__PURE__ */ Y("span", { className: "text-subtle", children: [
        ",",
        e.format("YYYY")
      ] })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex items-center space-x-2 rtl:space-x-reverse", children: /* @__PURE__ */ Y(HA, { combined: !0, children: [
      /* @__PURE__ */ m(
        ut,
        {
          StartIcon: "chevron-left",
          variant: "icon",
          color: "secondary",
          "aria-label": "Previous Week",
          onClick: () => {
            n("DECREMENT");
          }
        }
      ),
      /* @__PURE__ */ m(
        ut,
        {
          StartIcon: "chevron-right",
          variant: "icon",
          color: "secondary",
          "aria-label": "Next Week",
          onClick: () => {
            n("INCREMENT");
          }
        }
      )
    ] }) })
  ] });
}
const MHl = ({
  hours: e,
  containerOffsetRef: t,
  borderColor: n
}) => {
  const { timeFormat: o } = lu(), r = e[e.length - 1].add(1, "hour").minute(0).format(o), i = N0();
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "pointer-events-none relative z-[60] col-start-1 col-end-2 row-start-1 grid divide-y",
        n === "subtle" ? "divide-subtle" : "divide-default"
      ),
      style: {
        gridTemplateRows: `repeat(${e.length}, minmax(var(--gridDefaultSize),1fr)`
      },
      children: [
        /* @__PURE__ */ m("div", { className: "row-end-1 h-[--calendar-offset-top] ", ref: t }),
        e.map((a) => /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "text-muted sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 rtl:-mr-14", children: a.minute(0).format(o) }) }, `${i}-${a.get("hour")}`)),
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "text-muted sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 rtl:-mr-14", children: r }) }, `${i}-${r}`)
      ]
    }
  );
}, LHl = ({ className: e }) => /* @__PURE__ */ m(
  "div",
  {
    className: ae(
      "fixed left-[calc(50%+calc(var(--booker-meta-width,0px)/2))] top-1/2 z-[80] h-10 w-10 -translate-x-1/2 -translate-y-1/2",
      e
    ),
    children: /* @__PURE__ */ Y("svg", { className: "h-10 w-10", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ m(
        "path",
        {
          className: "fill-default",
          d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
          opacity: ".25"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          className: "animate-spinning fill-emphasis origin-center",
          d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        }
      )
    ] })
  }
), qHl = ({ days: e, borderColor: t }) => {
  const n = () => {
    let r = "en";
    if (typeof window < "u" && typeof navigator < "u") {
      const i = navigator.language;
      r = new Intl.Locale(i).language;
    }
    return ["ar", "he", "fa", "ur"].includes(r);
  }, o = n() ? "rtl" : "ltr";
  return /* @__PURE__ */ m(
    "div",
    {
      className: ae(
        "pointer-events-none relative z-[60] col-start-1 col-end-2 row-start-1 grid auto-cols-auto grid-rows-1 divide-x sm:pr-8",
        t === "subtle" ? "divide-subtle" : "divide-default"
      ),
      dir: o,
      style: {
        direction: o
      },
      children: e.map((r, i) => /* @__PURE__ */ m(
        "div",
        {
          className: "row-span-full",
          style: {
            gridColumnStart: n() ? e.length - i : i + 1
          }
        },
        `Key_vertical_${i}`
      ))
    }
  );
};
function vbe(e) {
  var S, O;
  const t = Ue(null), n = Ue(null), o = Ue(null), r = Ue(null), i = Wa((I) => I.initState), a = Wa((I) => I.startDate), s = Wa((I) => I.endDate), c = Wa((I) => I.startHour || 0), l = Wa((I) => I.endHour || 23), d = Wa((I) => I.gridCellsPerHour || 4), u = Wa((I) => I.availableTimeslots), _ = Wa((I) => I.hideHeader), p = Wa((I) => I.timezone), f = Wa((I) => I.showBackgroundPattern), g = Wa((I) => I.showBorder ?? !0), h = Wa((I) => I.borderColor ?? "default"), b = Tt(() => $Hl(a, s), [a, s]), v = Tt(
    () => wHl(c || 0, l || 23, p),
    [c, l, p]
  ), $ = v.length * d, k = 58;
  return Le(() => {
    i(e);
  }, [e, i]), /* @__PURE__ */ m(jHl, { children: /* @__PURE__ */ Y(
    "div",
    {
      className: ae("scheduler-wrapper flex h-full w-full flex-col"),
      style: {
        "--one-minute-height": `calc(${k}px/60)`,
        "--gridDefaultSize": `${k}px`
      },
      children: [
        _ !== !0 && /* @__PURE__ */ m(DHl, {}),
        e.isPending && /* @__PURE__ */ m(LHl, {}),
        /* @__PURE__ */ m(
          "div",
          {
            ref: t,
            className: "bg-default dark:bg-muted relative isolate flex h-full flex-auto flex-col",
            children: /* @__PURE__ */ Y(
              "div",
              {
                style: { width: "165%" },
                className: "flex h-full max-w-full flex-none flex-col sm:max-w-none md:max-w-full",
                children: [
                  /* @__PURE__ */ m(
                    xHl,
                    {
                      containerNavRef: n,
                      days: b,
                      showBorder: g,
                      borderColor: h
                    }
                  ),
                  /* @__PURE__ */ Y("div", { className: "relative flex flex-auto", children: [
                    /* @__PURE__ */ m(THl, { timezone: p }),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        className: ae(
                          "bg-default dark:bg-muted ring-muted sticky left-0 z-10 w-16 flex-none ring-1",
                          g && (h === "subtle" ? "border-subtle border-l border-r" : "border-default border-l border-r")
                        )
                      }
                    ),
                    /* @__PURE__ */ Y(
                      "div",
                      {
                        className: "grid flex-auto grid-cols-1 grid-rows-1 [--disabled-gradient-background:#F8F9FB] [--disabled-gradient-foreground:#E6E7EB] dark:[--disabled-gradient-background:#262626] dark:[--disabled-gradient-foreground:#393939]",
                        style: f === !1 ? void 0 : {
                          backgroundColor: "var(--disabled-gradient-background)",
                          background: "repeating-linear-gradient(-45deg, var(--disabled-gradient-background), var(--disabled-gradient-background) 2.5px, var(--disabled-gradient-foreground) 2.5px, var(--disabled-gradient-foreground) 5px)"
                        },
                        children: [
                          /* @__PURE__ */ m(
                            MHl,
                            {
                              hours: v,
                              numberOfGridStopsPerCell: d,
                              containerOffsetRef: o,
                              borderColor: h
                            }
                          ),
                          /* @__PURE__ */ m(qHl, { days: b, borderColor: h }),
                          /* @__PURE__ */ m(
                            HJ,
                            {
                              offsetHeight: (S = o.current) == null ? void 0 : S.offsetHeight,
                              gridStopsPerDay: $,
                              children: b.map((I, D) => /* @__PURE__ */ m("li", { className: "relative", style: { gridColumnStart: D + 1 }, children: /* @__PURE__ */ m(NHl, { day: I }) }, I.toISOString()))
                            }
                          ),
                          /* @__PURE__ */ m(
                            HJ,
                            {
                              ref: r,
                              offsetHeight: (O = o.current) == null ? void 0 : O.offsetHeight,
                              gridStopsPerDay: $,
                              children: /* @__PURE__ */ m(Ce, { children: [...Array(b.length)].map((I, D) => /* @__PURE__ */ m(
                                "li",
                                {
                                  className: "relative",
                                  style: {
                                    gridRow: `1 / span ${$}`
                                  },
                                  children: u ? /* @__PURE__ */ m(
                                    CHl,
                                    {
                                      timezone: p,
                                      day: b[D],
                                      startHour: c,
                                      availableSlots: u
                                    },
                                    b[D].toISOString()
                                  ) : /* @__PURE__ */ m(Ce, { children: [...Array($)].map((M, N) => {
                                    const C = `${D}-${N}`;
                                    return /* @__PURE__ */ m(
                                      AHl,
                                      {
                                        day: b[D],
                                        gridCellIdx: N,
                                        totalGridCells: $,
                                        selectionLength: l - c,
                                        startHour: c,
                                        timezone: p
                                      },
                                      C
                                    );
                                  }) })
                                },
                                D
                              )) })
                            }
                          )
                        ]
                      }
                    )
                  ] })
                ]
              }
            )
          }
        )
      ]
    }
  ) });
}
const jHl = ({ children: e }) => /* @__PURE__ */ Y(Ce, { children: [
  /* @__PURE__ */ Y("div", { className: "flex h-full flex-col items-center justify-center sm:hidden", children: [
    /* @__PURE__ */ m("h1", { className: "text-2xl font-bold", children: "Mobile not supported yet " }),
    /* @__PURE__ */ m("p", { className: "text-subtle", children: "Please use a desktop browser to view this page" })
  ] }),
  /* @__PURE__ */ m("div", { className: "hidden h-full sm:block", children: e })
] }), FHl = ({
  extraDays: e,
  schedule: t,
  isLoading: n,
  event: o
}) => {
  var g;
  const r = St((h) => h.selectedDate), i = St((h) => h.setSelectedTimeslot), a = St((h) => h.selectedDuration), s = Cf((h) => h.overlayBusyDates), c = Ha("overlayCalendar") === "true" || (wo == null ? void 0 : wo.getItem("overlayCalendarSwitchDefault")), { timezone: l } = vd(), d = a || ((g = o == null ? void 0 : o.data) == null ? void 0 : g.length) || 30, u = fbe({ schedule: t, eventDuration: d }), _ = r ? De(r).toDate() : De().toDate(), p = De(_).add(e - 1, "day").toDate();
  Le(() => {
  }, [c]);
  const f = Tt(() => !s || !c ? [] : s.map((h, b) => ({
    id: b,
    start: De(h.start).toDate(),
    end: De(h.end).toDate(),
    title: "Busy",
    options: {
      status: "ACCEPTED"
    }
  })), [s, c]);
  return /* @__PURE__ */ m("div", { className: "h-full [--calendar-dates-sticky-offset:66px]", children: /* @__PURE__ */ m(
    vbe,
    {
      isPending: n,
      availableTimeslots: u,
      startHour: 0,
      endHour: 23,
      events: f,
      startDate: _,
      endDate: p,
      onEmptyCellClick: (h) => i(h.toISOString()),
      gridCellsPerHour: 60 / d,
      hoverEventDuration: d,
      hideHeader: !0,
      timezone: l
    }
  ) });
};
function bbe(e, t) {
  const [n, o] = ze(() => {
    const l = wo.getItem(e);
    return l ? new Set(JSON.parse(l)) : new Set(t);
  });
  return Le(() => {
    wo.setItem(e, JSON.stringify(Array.from(n)));
  }, [e, n]), { set: n, addValue: (l) => {
    o((d) => new Set(d).add(l));
  }, removeById: (l) => {
    o((d) => {
      const u = new Set(d);
      return u.forEach((_) => {
        _.externalId === l && u.delete(_);
      }), u;
    });
  }, toggleValue: (l) => {
    let d = /* @__PURE__ */ new Set();
    return o((u) => {
      const _ = new Set(u);
      let p = !1;
      return _.forEach((f) => {
        f.externalId === l.externalId && (p = !0, _.delete(f));
      }), p || _.add(l), d = _, _;
    }), d;
  }, hasItem: (l) => Array.from(n).some((d) => d.externalId === l.externalId), clearSet: () => {
    o(() => /* @__PURE__ */ new Set()), wo.removeItem(e);
  } };
}
const VHl = ({
  connectedCalendars: e,
  overlayBusyDates: t,
  onToggleCalendar: n
}) => {
  const { set: o, toggleValue: r, hasItem: i } = bbe("toggledConnectedCalendars", []), [a, s] = ze(!1), [c, l] = Cf(
    (g) => [g.continueWithProviderModal, g.setContinueWithProviderModal],
    Fr
  ), [d, u] = Cf(
    (g) => [g.calendarSettingsOverlayModal, g.setCalendarSettingsOverlayModal],
    Fr
  ), _ = Cf((g) => g.setOverlayBusyDates), { timezone: p } = lu();
  return Le(() => {
    if (t) {
      const g = De(), b = (g.tz(p).utcOffset() - g.utcOffset()) / 60, v = t.map(($) => ({
        ...$,
        start: De($.start).add(b, "hours").toDate(),
        end: De($.end).add(b, "hours").toDate()
      }));
      _(v);
    }
  }, [t]), Le(() => {
    e && o.size === 0 && !a && (e.forEach((g) => {
      var h;
      (h = g.calendars) == null || h.forEach((b) => {
        const v = { credentialId: g.credentialId, externalId: b.externalId };
        b.primary && r(v);
      });
    }), s(!0));
  }, [i, o, a]), {
    isOpenOverlayContinueModal: c,
    isOpenOverlaySettingsModal: d,
    handleCloseContinueModal: (g) => l(g),
    handleCloseSettingsModal: (g) => u(g),
    handleToggleConnectedCalendar: (g, h) => {
      const b = r({
        credentialId: h,
        externalId: g
      });
      _([]), n(b);
    },
    checkIsCalendarToggled: (g, h) => i({
      credentialId: h,
      externalId: g
    })
  };
};
function BHl(e) {
  const { t } = Fe();
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(Gi, { open: e.open, onOpenChange: e.onClose, children: /* @__PURE__ */ Y(
    Ei,
    {
      type: "creation",
      title: t("overlay_my_calendar"),
      description: t("overlay_my_calendar_toc"),
      children: [
        /* @__PURE__ */ m("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ m(
          ut,
          {
            "data-testid": "overlay-calendar-continue-button",
            onClick: () => {
              e.onContinue();
            },
            className: "gap w-full items-center justify-center font-semibold",
            StartIcon: "calendar-search",
            children: t("continue_with", { appName: Zp })
          }
        ) }),
        /* @__PURE__ */ m(Fc, { children: /* @__PURE__ */ m(Ce, {}) })
      ]
    }
  ) }) });
}
function WF(e) {
  return /* @__PURE__ */ m(
    "ul",
    {
      "data-testid": "list",
      ...e,
      className: ae(
        "mx-0 rounded-sm sm:overflow-hidden ",
        // Add rounded top and bottom if roundContainer is true
        e.roundContainer && "[&>*:first-child]:rounded-t-md [&>*:last-child]:rounded-b-md ",
        !e.noBorderTreatment && "border-subtle divide-subtle divide-y rounded-md border border-l border-r ",
        e.className
      ),
      children: e.children
    }
  );
}
function UHl(e) {
  const { href: t, expanded: n, rounded: o = !0, ...r } = e, a = Pe(
    t ? "a" : "li",
    {
      ...r,
      className: ae(
        "items-center bg-default min-w-0 flex-1 flex border-neutral-200 p-4 sm:mx-0 md:border md:p-4 xl:mt-0 border-subtle",
        n ? "my-2 border" : "border -mb-px last:mb-0",
        // Pass rounded false to not round the corners -> Useful when used in list we can use roundedContainer to create the right design
        o ? "rounded-md" : "rounded-none",
        e.className,
        (e.onClick || t) && "hover:bg-muted"
      ),
      "data-testid": "list-item"
    },
    e.children
  );
  return t ? /* @__PURE__ */ m(Po, { passHref: !0, href: t, legacyBehavior: !0, children: a }) : a;
}
function WHl(e) {
  const { component: t = "span", ...n } = e;
  return Pe(
    t,
    {
      ...n,
      className: ae("text-sm font-medium text-emphasis truncate", e.className),
      "data-testid": "list-item-title"
    },
    e.children
  );
}
function kL(e) {
  const { component: t = "span", ...n } = e;
  return Pe(
    t,
    {
      ...n,
      className: ae("text-sm text-subtle truncate prose", e.className),
      "data-testid": "list-item-text"
    },
    e.children
  );
}
const GHl = () => /* @__PURE__ */ m(Tj, { children: /* @__PURE__ */ Y("div", { className: "border-subtle mt-3 space-y-4 rounded-xl border px-4 py-4 ", children: [
  /* @__PURE__ */ m(Jn, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "h-4 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "h-4 w-full" })
] }) });
function HHl({
  connectedCalendars: e,
  isLoading: t,
  open: n,
  onClose: o,
  onClickNoCalendar: r,
  onToggleConnectedCalendar: i,
  checkIsCalendarToggled: a
}) {
  const { t: s } = Fe(), c = Zo();
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(Gi, { open: n, onOpenChange: o, children: /* @__PURE__ */ Y(
    Ei,
    {
      enableOverflow: !0,
      type: "creation",
      title: "Calendar Settings",
      className: "pb-4",
      description: s("view_overlay_calendar_events"),
      children: [
        /* @__PURE__ */ m("div", { className: "no-scrollbar max-h-full overflow-y-scroll ", children: t ? /* @__PURE__ */ m(GHl, {}) : /* @__PURE__ */ m(Ce, { children: e.length === 0 ? /* @__PURE__ */ m(
          sb,
          {
            Icon: "calendar",
            headline: s("no_calendar_installed"),
            description: s("no_calendar_installed_description"),
            buttonText: s("add_a_calendar"),
            buttonOnClick: r
          }
        ) : /* @__PURE__ */ m(Ce, { children: e.map((l) => /* @__PURE__ */ Y(Oi, { children: [
          l.error && !l.calendars && /* @__PURE__ */ m(sa, { severity: "error", title: l.error.message }),
          (l == null ? void 0 : l.error) === void 0 && l.calendars && /* @__PURE__ */ Y(UHl, { className: "flex-col rounded-md", children: [
            /* @__PURE__ */ Y("div", {
              className: "flex w-full flex-1 items-center space-x-3 pb-4 rtl:space-x-reverse",
              // eslint-disable-next-line @next/next/no-img-element
              children: [
                l.integration.logo && /* @__PURE__ */ m(
                  "img",
                  {
                    className: ae(
                      "h-10 w-10",
                      l.integration.logo.includes("-dark") && "dark:invert"
                    ),
                    src: c ? `https://app.cal.com${l.integration.logo}` : l.integration.logo,
                    alt: `${l.integration.title} logo`
                  }
                ),
                /* @__PURE__ */ Y("div", { className: "flex-grow truncate pl-2", children: [
                  /* @__PURE__ */ m(WHl, { component: "h3", className: "space-x-2 rtl:space-x-reverse", children: /* @__PURE__ */ m(Po, { href: `/apps/${l.integration.slug}`, children: l.integration.name || l.integration.title }) }),
                  /* @__PURE__ */ m(kL, { component: "p", children: l.primary.email })
                ] })
              ]
            }),
            /* @__PURE__ */ m("div", { className: "border-subtle w-full border-t pt-4", children: /* @__PURE__ */ m("ul", { className: "space-y-4", children: l.calendars.map((d, u) => {
              const _ = d.integrationTitle ?? `calendar-switch-${u}`;
              return /* @__PURE__ */ Y("li", { className: "flex gap-3", children: [
                /* @__PURE__ */ m(
                  Ri,
                  {
                    id: _,
                    checked: a(d.externalId, l.credentialId),
                    onCheckedChange: () => {
                      i(d.externalId, l.credentialId);
                    }
                  }
                ),
                /* @__PURE__ */ m("label", { htmlFor: _, children: d.name })
              ] }, _);
            }) }) })
          ] })
        ] }, l.credentialId)) }) }) }),
        /* @__PURE__ */ m("div", { className: "mt-4 flex gap-2 self-end", children: /* @__PURE__ */ m(ca, { children: s("done") }) })
      ]
    }
  ) }) });
}
function KHl({ enabled: e, hasSession: t, onStateChange: n }) {
  const { t: o } = Fe(), r = Cf((c) => c.setContinueWithProviderModal), i = Cf(
    (c) => c.setCalendarSettingsOverlayModal
  ), a = St((c) => c.layout), s = e;
  return Le(() => {
    !t && s && (n(!1), r(!0));
  }, [t, s, r, n]), /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "hidden gap-2",
        a === "week_view" || a === "column_view" ? "xl:flex" : "md:flex"
      ),
      children: [
        /* @__PURE__ */ Y("div", { className: "flex items-center gap-2 pr-2", children: [
          /* @__PURE__ */ m(
            Ri,
            {
              "data-testid": "overlay-calendar-switch",
              checked: s,
              id: "overlayCalendar",
              onCheckedChange: (c) => {
                t ? n(c) : r(c);
              }
            }
          ),
          /* @__PURE__ */ m(
            "label",
            {
              htmlFor: "overlayCalendar",
              className: "text-emphasis text-sm font-medium leading-none hover:cursor-pointer",
              children: o("overlay_my_calendar")
            }
          )
        ] }),
        t && /* @__PURE__ */ m(
          ut,
          {
            size: "base",
            "data-testid": "overlay-calendar-settings-button",
            variant: "icon",
            color: "secondary",
            StartIcon: "settings",
            onClick: () => {
              i(!0);
            }
          }
        )
      ]
    }
  );
}
const YHl = ({
  connectedCalendars: e,
  overlayBusyDates: t,
  onToggleCalendar: n,
  isOverlayCalendarEnabled: o,
  loadingConnectedCalendar: r,
  handleClickNoCalendar: i,
  handleSwitchStateChange: a,
  handleClickContinue: s,
  hasSession: c
}) => {
  const l = Zo(), {
    handleCloseContinueModal: d,
    handleCloseSettingsModal: u,
    isOpenOverlayContinueModal: _,
    isOpenOverlaySettingsModal: p,
    handleToggleConnectedCalendar: f,
    checkIsCalendarToggled: g
  } = VHl({ connectedCalendars: e, overlayBusyDates: t, onToggleCalendar: n });
  return Le(() => {
    o && d(!1);
  }, [o, d]), l && (e == null ? void 0 : e.length) === 0 ? null : /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      KHl,
      {
        enabled: o,
        hasSession: c,
        onStateChange: a
      }
    ),
    !l && /* @__PURE__ */ m(
      BHl,
      {
        open: _ && !o,
        onClose: d,
        onContinue: s
      }
    ),
    /* @__PURE__ */ m(
      HHl,
      {
        connectedCalendars: e,
        open: p,
        onClose: u,
        isLoading: r,
        onToggleConnectedCalendar: f,
        onClickNoCalendar: () => {
          i();
        },
        checkIsCalendarToggled: g
      }
    )
  ] });
}, nS = (e) => {
  const t = "/o";
  return e.returnValue = t, t;
}, ZHl = ({
  bookingId: e,
  onGoBack: t,
  expiryTime: n,
  instantVideoMeetingUrl: o,
  orgName: r
}) => {
  const { t: i } = Fe(), [a, s] = ze(u()), [c, l] = ze(!1), d = Ro.useRouter();
  function u() {
    const p = De(), g = De(n).diff(p);
    return Math.max(g, 0);
  }
  Le(() => {
    if (!n)
      return;
    const p = setInterval(() => {
      s(u()), l(n && new Date(n) < /* @__PURE__ */ new Date());
    }, 1e3);
    return () => {
      clearInterval(p);
    };
  }, [n]);
  const _ = (p) => {
    const f = De.duration(p), g = f.seconds();
    return `${f.minutes()}m ${g}s`;
  };
  return Le(() => {
    if (!n || c || o) {
      window.removeEventListener("beforeunload", nS);
      return;
    }
    return window.addEventListener("beforeunload", nS), () => {
      window.removeEventListener("beforeunload", nS);
    };
  }, [n, c, o]), Le(() => {
    o && (window.removeEventListener("beforeunload", nS), d.push(o));
  }, [o]), /* @__PURE__ */ m(Gi, { open: !!e && !!n, children: /* @__PURE__ */ m(Ei, { enableOverflow: !0, className: "py-8", children: /* @__PURE__ */ m("div", { children: c ? /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ m("p", { className: "font-medium", children: i("please_book_a_time_sometime_later") }),
    /* @__PURE__ */ m(
      ut,
      {
        className: "mt-4",
        onClick: () => {
          t();
        },
        color: "primary",
        children: i("schedule_instead")
      }
    )
  ] }) : /* @__PURE__ */ Y("div", { className: "text-center", children: [
    /* @__PURE__ */ m("p", { className: "font-medium", children: i("connecting_you_to_someone", { orgName: r }) }),
    /* @__PURE__ */ m("p", { className: "font-bold", children: i("please_do_not_close_this_tab") }),
    /* @__PURE__ */ m("p", { className: "mt-2 font-medium", children: i("please_schedule_future_call", {
      seconds: _(a)
    }) }),
    /* @__PURE__ */ m("div", { className: "mt-4 h-[414px]", children: /* @__PURE__ */ m("iframe", { className: "mx-auto h-full w-[276px] rounded-lg", src: "https://cal.games/" }) })
  ] }) }) }) });
}, KJ = {
  calendar: "[grid-area:calendar]",
  main: "[grid-area:main]",
  meta: "[grid-area:meta]",
  timeslots: "[grid-area:timeslots]",
  header: "[grid-area:header]"
}, gp = it(function({ children: t, area: n, visible: o, className: r, ...i }, a) {
  const s = St((l) => l.layout);
  let c;
  return typeof n == "string" ? c = KJ[n] : c = KJ[n[s] || n.default], !o && typeof o < "u" ? null : /* @__PURE__ */ m(Hw.div, { ref: a, className: ae(c, r), layout: !0, ...i, children: t });
}), QHl = ({ children: e, title: t }) => /* @__PURE__ */ m("div", { className: "mx-auto w-full max-w-2xl", children: /* @__PURE__ */ Y("div", { className: "border-subtle bg-default dark:bg-muted overflow-hidden rounded-lg border p-10", children: [
  /* @__PURE__ */ m("h2", { className: "font-cal mb-4 text-3xl", children: t }),
  e
] }) }), JHl = () => {
  const { t: e } = Fe();
  return /* @__PURE__ */ m(QHl, { title: e("404_page_not_found"), children: /* @__PURE__ */ m("p", { className: "max-w-[50ch]", children: e("booker_event_not_found") }) });
}, XHl = (e) => {
  var t;
  return typeof document > "u" ? null : (t = document.cookie.split(";").find((n) => n.trim().startsWith(`${e}=`))) == null ? void 0 : t.split("=")[1];
};
var eKl = {};
const tKl = ({ percentage: e }) => {
  if (eKl.NEXT_PUBLIC_IS_E2E || e >= 100)
    return !0;
  const t = XHl("uid");
  if (!t)
    return !1;
  const n = t.slice(-4);
  return parseInt(n, 16) % 100 < e;
}, nKl = () => {
  const e = Ue(
    tKl({ percentage: Wmc })
  );
  return Le(() => {
    console.log("QuickAvailabilityCheck feature enabled:", e.current);
  }, []), e.current;
}, SL = (e) => e.length < 16 ? !1 : e[4] === "-" && e[7] === "-" && e[10] === "T" && e[13] === ":", oKl = ({
  slotTimeInIso: e,
  slotToCheckInIso: t
}) => {
  if (e === t)
    return !0;
  if (!SL(e) || !SL(t))
    return console.log("Invalid ISO string format detected", { slotTimeInIso: e, slotToCheckInIso: t }), !0;
  const n = e.slice(0, 16), o = t.slice(0, 16);
  return n === o;
};
function m5(e, t) {
  return e ? e.some((n) => oKl({ slotTimeInIso: n.time, slotToCheckInIso: t })) : !1;
}
function rKl({
  scheduleData: e,
  dateInGMT: t,
  slotToCheckInIso: n
}) {
  const o = De(t).subtract(1, "day").format("YYYY-MM-DD"), r = De(t).add(1, "day").format("YYYY-MM-DD"), i = e.slots[t], a = e.slots[o], s = e.slots[r];
  return !!(m5(i, n) || m5(a, n) || m5(s, n));
}
const iKl = ({
  scheduleData: e,
  slotToCheckInIso: t,
  quickAvailabilityChecks: n
}) => {
  if (n && n.some(
    (i) => i.utcStartIso === t && i.status !== "available"
  ))
    return !1;
  if (!e)
    return !0;
  const r = SL(t) ? t.split("T")[0] : null;
  return r ? rKl({
    scheduleData: e,
    dateInGMT: r,
    slotToCheckInIso: t
  }) : !0;
};
var aKl = {};
const sKl = ({
  username: e,
  eventSlug: t,
  hideBranding: n = !1,
  entity: o,
  isInstantMeeting: r = !1,
  onGoBackInstantMeeting: i,
  onConnectNowInstantMeeting: a,
  onOverlayClickNoCalendar: s,
  onClickOverlayContinue: c,
  onOverlaySwitchStateChange: l,
  sessionUsername: d,
  rescheduleUid: u,
  hasSession: _,
  extraOptions: p,
  bookings: f,
  verifyEmail: g,
  slots: h,
  calendars: b,
  bookerForm: v,
  event: $,
  bookerLayout: k,
  schedule: S,
  verifyCode: O,
  isPlatform: I,
  orgBannerUrl: D,
  customClassNames: M,
  areInstantMeetingParametersSet: N = !1,
  userLocale: C,
  hasValidLicense: P,
  isBookingDryRun: x,
  renderCaptcha: w,
  hashedLink: E,
  confirmButtonDisabled: T,
  timeZones: z,
  eventMetaChildren: j,
  roundRobinHideOrgAndTeam: q,
  showNoAvailabilityDialog: V
}) => {
  var At, Mt, Ie, tt, zt, $t, In, xe, je, pt, Jt;
  const F = O_(), L = Phe(), [U, W] = St(
    (Ye) => [Ye.state, Ye.setState],
    Fr
  ), H = St((Ye) => Ye.selectedDate), {
    shouldShowFormInDialog: Q,
    hasDarkBackground: X,
    extraDays: re,
    columnViewExtraDays: Z,
    isMobile: ee,
    layout: J,
    hideEventTypeDetails: oe,
    isEmbed: ce,
    bookerLayouts: de
  } = k, [te, ue] = St(
    (Ye) => [Ye.seatedEventData, Ye.setSeatedEventData],
    Fr
  ), { selectedTimeslot: le, setSelectedTimeslot: se, allSelectedTimeslots: me } = h, [pe, be] = St(
    (Ye) => [Ye.dayCount, Ye.setDayCount],
    Fr
  ), Se = dC((At = S == null ? void 0 : S.data) == null ? void 0 : At.slots).filter(
    (Ye) => De(H).diff(Ye, "day") <= 0
  ), Ae = 7, Ze = Se.length < re ? (re - Se.length + 1) * Ae : Se.length === re ? Ae : 0, Ge = Se.slice(0, re + 1);
  Se.length !== 0 && (Z.current = Math.abs(De(H).diff(Ge[Ge.length - 2], "day")) + Ze);
  const rt = Math.abs(De(H).diff(Ge[Ge.length - 1], "day")) + Ze, qe = pHl(J, U), Xe = Ue(null), lt = nKl(), Et = ee ? "div" : Wal, { bookerFormErrorRef: wt, key: nn, formEmail: Dt, bookingForm: mt, errors: bt } = v, {
    handleBookEvent: gn,
    errors: an,
    loadingStates: Mn,
    expiryTime: Ln,
    instantVideoMeetingUrl: un,
    instantConnectCooldownMs: qo
  } = f, cn = mt.watch("cfToken"), {
    isEmailVerificationModalVisible: ln,
    setEmailVerificationModalVisible: kn,
    handleVerifyEmail: gt,
    renderConfirmNotVerifyEmailButtonCond: Ot,
    isVerificationCodeSending: _n
  } = g, {
    overlayBusyDates: wn,
    isOverlayCalendarEnabled: so,
    connectedCalendars: rn,
    loadingConnectedCalendar: Ht,
    onToggleCalendar: qn
  } = b, Bn = Ue(!1), Or = wj(), oo = () => {
    ee && !Bn.current && Xe.current && !Or.disableAutoScroll && (Cll(Xe.current, ce), Bn.current = !0);
  }, Zn = xll(
    mt,
    U,
    r,
    J == pn.WEEK_VIEW,
    (Mt = $ == null ? void 0 : $.data) == null ? void 0 : Mt.bookingFields,
    (Ie = $ == null ? void 0 : $.data) == null ? void 0 : Ie.locations
  ), st = !!(!aKl.NEXT_PUBLIC_IS_E2E && w && mD && Qmc === "1" && (U === "booking" || U === "selecting_time" && Zn)), ft = (Ye) => {
    se(Ye);
  };
  TM({ bookerState: U, slotsQuery: S }), Le(() => {
    if ($.isPending)
      return W("loading");
    if (!H)
      return W("selecting_date");
    if (!le)
      return W("selecting_time");
    const Ye = !r && J !== pn.WEEK_VIEW;
    return W(le && Zn && Ye ? "selecting_time" : "booking");
  }, [$, H, le, W, Zn, J, r]);
  const yt = lt ? me.filter((Ye) => !iKl({
    scheduleData: (S == null ? void 0 : S.data) ?? null,
    slotToCheckInIso: Ye,
    quickAvailabilityChecks: h.quickAvailabilityChecks
  })) : [], on = Ha("slot");
  Le(() => {
    se(on || null);
  }, [on, se]);
  const Ut = (Ye) => Ot ? gn(Ye) : gt(), Nt = Tt(() => {
    var Ye, mn, Co, zo;
    return U === "booking" ? /* @__PURE__ */ m(
      Mml,
      {
        timeslot: le,
        shouldRenderCaptcha: st,
        onCancel: () => {
          se(null), Wce && (S == null || S.invalidate()), te.bookingUid && ue({ ...te, bookingUid: void 0, attendees: void 0 });
        },
        onSubmit: () => Ot ? gn() : gt(),
        errorRef: wt,
        errors: { ...bt, ...an },
        isTimeslotUnavailable: !r && yt.includes(le || ""),
        loadingStates: Mn,
        renderConfirmNotVerifyEmailButtonCond: Ot,
        bookingForm: mt,
        eventQuery: $,
        extraOptions: p,
        isVerificationCodeSending: _n,
        confirmButtonDisabled: T,
        classNames: {
          confirmButton: (Ye = M == null ? void 0 : M.confirmStep) == null ? void 0 : Ye.confirmButton,
          backButton: (mn = M == null ? void 0 : M.confirmStep) == null ? void 0 : mn.backButton
        },
        isPlatform: I,
        children: /* @__PURE__ */ m(Ce, { children: !I && /* @__PURE__ */ m(
          ZHl,
          {
            expiryTime: Ln,
            bookingId: parseInt(Ha("bookingId") || "0"),
            instantVideoMeetingUrl: un,
            onGoBack: () => {
              i();
            },
            orgName: (zo = (Co = $.data) == null ? void 0 : Co.entity) == null ? void 0 : zo.name
          }
        ) })
      },
      nn
    ) : /* @__PURE__ */ m(Ce, {});
  }, [
    wt,
    un,
    U,
    mt,
    an,
    $,
    Ln,
    p,
    bt,
    gn,
    gt,
    nn,
    Mn,
    i,
    Ot,
    te,
    ue,
    se,
    I,
    st,
    _n,
    yt
  ]);
  return o.considerUnpublished && !u ? /* @__PURE__ */ m(zll, { ...o }) : $.isSuccess && !$.data ? /* @__PURE__ */ m(JHl, {}) : U === "loading" ? null : /* @__PURE__ */ Y(Ce, { children: [
    $.data && !I ? /* @__PURE__ */ m(Zal, { eventType: $.data }) : /* @__PURE__ */ m(Ce, {}),
    (x || zF(F)) && /* @__PURE__ */ m(Xml, { isEmbed: ce }),
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          // In a popup embed, if someone clicks outside the main(having main class or main tag), it closes the embed
          "main",
          "text-default flex min-h-full w-full flex-col items-center",
          J === pn.MONTH_VIEW && !ce && "my-20 ",
          J === pn.MONTH_VIEW ? "overflow-visible" : "overflow-clip",
          `${M == null ? void 0 : M.bookerWrapper}`
        ),
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              ref: qe,
              "data-testid": "booker-container",
              className: ae(
                ..._Hl(J, U, oe),
                "bg-default dark:bg-muted grid max-w-full items-start dark:[color-scheme:dark] sm:transition-[width] sm:duration-300 sm:motion-reduce:transition-none md:flex-row",
                // We remove border only when the content covers entire viewport. Because in embed, it can almost never be the case that it covers entire viewport, we show the border there
                (J === pn.MONTH_VIEW || ce) && "border-subtle rounded-md",
                !ce && "sm:transition-[width] sm:duration-300",
                ce && J === pn.MONTH_VIEW && "border-booker sm:border-booker-width",
                !ce && J === pn.MONTH_VIEW && "border-subtle border",
                `${M == null ? void 0 : M.bookerContainer}`
              ),
              children: /* @__PURE__ */ Y(xhe, { children: [
                !r && /* @__PURE__ */ m(
                  gp,
                  {
                    area: "header",
                    className: ae(
                      J === pn.MONTH_VIEW && "fixed top-4 z-10 ltr:right-4 rtl:left-4",
                      (J === pn.COLUMN_VIEW || J === pn.WEEK_VIEW) && "bg-default dark:bg-muted sticky top-0 z-10"
                    ),
                    children: I && J === pn.MONTH_VIEW ? /* @__PURE__ */ m(Ce, {}) : /* @__PURE__ */ m(
                      mbe,
                      {
                        isMyLink: e === d,
                        eventSlug: t,
                        enabledLayouts: de.enabledLayouts,
                        extraDays: J === pn.COLUMN_VIEW ? Z.current : re,
                        isMobile: ee,
                        nextSlots: rt,
                        renderOverlay: () => ce ? /* @__PURE__ */ m(Ce, {}) : /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
                          YHl,
                          {
                            isOverlayCalendarEnabled: so,
                            connectedCalendars: rn,
                            loadingConnectedCalendar: Ht,
                            overlayBusyDates: wn,
                            onToggleCalendar: qn,
                            hasSession: _,
                            handleClickContinue: c,
                            handleSwitchStateChange: l,
                            handleClickNoCalendar: () => {
                              s();
                            }
                          }
                        ) })
                      }
                    )
                  }
                ),
                /* @__PURE__ */ m(Et, { className: ae("relative z-10 flex [grid-area:meta]"), children: /* @__PURE__ */ Y(
                  gp,
                  {
                    area: "meta",
                    className: "max-w-screen flex w-full flex-col md:w-[var(--booker-meta-width)]",
                    children: [
                      !oe && D && /* @__PURE__ */ m(
                        "img",
                        {
                          loading: "eager",
                          className: "-mb-9 h-16 object-cover object-top ltr:rounded-tl-md rtl:rounded-tr-md sm:h-auto",
                          alt: "org banner",
                          src: D
                        }
                      ),
                      !oe && /* @__PURE__ */ m(
                        fHl,
                        {
                          selectedTimeslot: le,
                          classNames: {
                            eventMetaContainer: (tt = M == null ? void 0 : M.eventMetaCustomClassNames) == null ? void 0 : tt.eventMetaContainer,
                            eventMetaTitle: (zt = M == null ? void 0 : M.eventMetaCustomClassNames) == null ? void 0 : zt.eventMetaTitle,
                            eventMetaTimezoneSelect: ($t = M == null ? void 0 : M.eventMetaCustomClassNames) == null ? void 0 : $t.eventMetaTimezoneSelect
                          },
                          event: $.data,
                          isPending: $.isPending,
                          isPlatform: I,
                          isPrivateLink: !!E,
                          locale: C,
                          timeZones: z,
                          roundRobinHideOrgAndTeam: q,
                          children: j
                        }
                      ),
                      J !== pn.MONTH_VIEW && !(J === "mobile" && U === "booking") && /* @__PURE__ */ m("div", { className: "mt-auto px-5 py-3", children: /* @__PURE__ */ m(
                        nJ,
                        {
                          classNames: M == null ? void 0 : M.datePickerCustomClassNames,
                          event: $,
                          slots: (In = S == null ? void 0 : S.data) == null ? void 0 : In.slots,
                          isLoading: S.isPending,
                          scrollToTimeSlots: oo,
                          showNoAvailabilityDialog: V
                        }
                      ) })
                    ]
                  }
                ) }, "meta"),
                /* @__PURE__ */ m(
                  gp,
                  {
                    area: "main",
                    className: "sticky top-0 ml-[-1px] h-full p-6 md:w-[var(--booker-main-width)] md:border-l",
                    ...eS,
                    visible: U === "booking" && !Q,
                    children: Nt
                  },
                  "book-event-form"
                ),
                /* @__PURE__ */ m(
                  gp,
                  {
                    area: "main",
                    visible: U !== "booking" && J === pn.MONTH_VIEW,
                    ...eS,
                    initial: "visible",
                    className: "md:border-subtle ml-[-1px] h-full flex-shrink px-5 py-3 md:border-l lg:w-[var(--booker-main-width)]",
                    children: /* @__PURE__ */ m(
                      nJ,
                      {
                        classNames: M == null ? void 0 : M.datePickerCustomClassNames,
                        event: $,
                        slots: (xe = S == null ? void 0 : S.data) == null ? void 0 : xe.slots,
                        isLoading: S.isPending,
                        scrollToTimeSlots: oo,
                        showNoAvailabilityDialog: V
                      }
                    )
                  },
                  "datepicker"
                ),
                /* @__PURE__ */ m(
                  gp,
                  {
                    area: "main",
                    visible: J === pn.WEEK_VIEW,
                    className: "border-subtle sticky top-0 ml-[-1px] h-full md:border-l",
                    ...eS,
                    children: /* @__PURE__ */ m(
                      FHl,
                      {
                        extraDays: re,
                        schedule: S.data,
                        isLoading: S.isPending,
                        event: $
                      }
                    )
                  },
                  "large-calendar"
                ),
                /* @__PURE__ */ m(
                  gp,
                  {
                    area: { default: "main", month_view: "timeslots" },
                    visible: J !== pn.WEEK_VIEW && U === "selecting_time" || J === pn.COLUMN_VIEW,
                    className: ae(
                      "border-subtle rtl:border-default flex h-full w-full flex-col overflow-x-auto px-5 py-3 pb-0 rtl:border-r ltr:md:border-l",
                      J === pn.MONTH_VIEW && "h-full overflow-hidden md:w-[var(--booker-timeslots-width)]",
                      J !== pn.MONTH_VIEW && "sticky top-0"
                    ),
                    ref: Xe,
                    ...eS,
                    children: /* @__PURE__ */ m(
                      Mpl,
                      {
                        onAvailableTimeSlotSelect: ft,
                        customClassNames: M == null ? void 0 : M.availableTimeSlotsCustomClassNames,
                        extraDays: re,
                        limitHeight: J === pn.MONTH_VIEW,
                        schedule: S,
                        isLoading: S.isPending,
                        seatsPerTimeSlot: (je = $.data) == null ? void 0 : je.seatsPerTimeSlot,
                        unavailableTimeSlots: yt,
                        showAvailableSeatsCount: (pt = $.data) == null ? void 0 : pt.seatsShowAvailabilityCount,
                        event: $,
                        loadingStates: Mn,
                        renderConfirmNotVerifyEmailButtonCond: Ot,
                        isVerificationCodeSending: _n,
                        onSubmit: Ut,
                        skipConfirmStep: Zn,
                        shouldRenderCaptcha: st,
                        watchedCfToken: cn,
                        confirmButtonDisabled: T,
                        confirmStepClassNames: M == null ? void 0 : M.confirmStep
                      }
                    )
                  },
                  "timeslots"
                )
              ] })
            }
          ),
          /* @__PURE__ */ m(
            gHl,
            {
              visible: U !== "booking" && J === pn.MONTH_VIEW && !ee,
              dayCount: pe,
              isScheduleLoading: S.isLoading,
              onButtonClick: () => {
                be(null);
              }
            }
          ),
          U !== "booking" && ((Jt = $.data) == null ? void 0 : Jt.showInstantEventConnectNowModal) && N && /* @__PURE__ */ m(
            "div",
            {
              className: ae(
                "animate-fade-in-up  z-40 my-2 opacity-0",
                J === pn.MONTH_VIEW && ce ? "" : "fixed bottom-2"
              ),
              style: { animationDelay: "1s" },
              children: /* @__PURE__ */ m(
                bHl,
                {
                  event: $.data,
                  cooldownMs: qo,
                  onConnectNow: () => {
                    a();
                  }
                }
              )
            }
          ),
          st && /* @__PURE__ */ m("div", { className: "mb-6 mt-auto pt-6", children: /* @__PURE__ */ m(
            asl,
            {
              appearance: "interaction-only",
              onVerify: (Ye) => {
                mt.setValue("cfToken", Ye);
              }
            }
          ) }),
          !n && (!I || L) && !st && /* @__PURE__ */ m(
            Hw.span,
            {
              className: ae(
                "mb-6 mt-auto pt-6 [&_img]:h-[15px]",
                X ? "dark" : "",
                J === pn.MONTH_VIEW ? "block" : "hidden"
              ),
              children: /* @__PURE__ */ m(Qal, { logoOnly: !0, hasValidLicense: P })
            },
            "logo"
          )
        ]
      }
    ),
    /* @__PURE__ */ m(Ce, { children: O && Dt ? /* @__PURE__ */ m(
      Whe,
      {
        isOpenDialog: ln,
        setIsOpenDialog: kn,
        email: Dt,
        isUserSessionRequiredToVerify: !1,
        verifyCodeWithSessionNotRequired: O.verifyCodeWithSessionNotRequired,
        verifyCodeWithSessionRequired: O.verifyCodeWithSessionRequired,
        error: O.error,
        resetErrors: O.resetErrors,
        isPending: O.isPending,
        setIsPending: O.setIsPending
      }
    ) : /* @__PURE__ */ m(Ce, {}) }),
    /* @__PURE__ */ m(
      Qml,
      {
        onCancel: () => se(null),
        visible: U === "booking" && Q,
        children: Nt
      }
    ),
    /* @__PURE__ */ m(Y_e, { position: "bottom-right" })
  ] });
}, cKl = (e) => /* @__PURE__ */ m(hal, { strict: !0, features: val, children: /* @__PURE__ */ m(sKl, { ...e }) }), f5 = (e) => nu.find((t) => t === e), ybe = (e) => {
  const [t, n] = St((b) => [b.layout, b.setLayout], Fr), o = fu(), r = zE("(max-width: 768px)"), i = zE("(max-width: 1024px)"), a = wj(), s = o ? r ? "mobile" : f5(a.layout) || t : t, c = i ? tS[s].tablet : tS[s].desktop, l = qTc(), d = o && l !== "inline", u = Ue(
    i ? tS[s].tablet : tS[s].desktop
  ), _ = e || cle, p = o && f5(a.layout) || _.defaultLayout;
  Le(() => {
    r && s !== "mobile" ? n("mobile") : !r && s === "mobile" && n(p);
  }, [r, n, s, p]), Le(() => {
    var v;
    const b = Ha("layout");
    if (!r && !o && f5(b) && ((v = _ == null ? void 0 : _.enabledLayouts) != null && v.length) && b !== t) {
      const $ = _.enabledLayouts.find((k) => k === b);
      $ && n($);
    }
  }, [_, n, t, o, r]);
  const g = {
    // mobile supports showing the Form without Dialog
    mobile: !o,
    // We don't show Dialog in month_view currently. Can be easily toggled though as it supports no-dialog Form
    month_view: !1,
    // week_view doesn't support no-dialog Form
    // When it's supported, disable it for embed
    week_view: !0,
    // column_view doesn't support no-dialog Form
    // When it's supported, disable it for embed
    column_view: !0
  }[s], h = o ? a.hideEventTypeDetails : !1;
  return {
    shouldShowFormInDialog: g,
    hasDarkBackground: d,
    extraDays: c,
    columnViewExtraDays: u,
    isMobile: r,
    isEmbed: o,
    isTablet: i,
    layout: s,
    defaultLayout: p,
    hideEventTypeDetails: h,
    bookerLayouts: _
  };
};
function lKl(e) {
  return Object.entries(e).sort(([t], [n]) => t.localeCompare(n)).map(([t, n]) => Array.isArray(n) ? `${t}:${n.sort().join(",")}` : `${t}:${n}`).join("|");
}
const g5 = ({
  values: e,
  hasSession: t,
  stableHashExtraOptions: n
}) => `${Object.keys(e).length}_${t ? 1 : 0}_${e.bookingId ?? 0}_${n}`;
function dKl({
  eventType: e,
  rescheduleUid: t,
  isRescheduling: n,
  email: o,
  name: r,
  username: i,
  hasSession: a,
  extraOptions: s,
  prefillFormParams: c,
  clientId: l
}) {
  const d = lKl(s), [u, _] = ze({
    values: {},
    key: ""
  }), p = Ic((g) => g.bookingData), f = Ic((g) => g.formValues);
  return Le(() => {
    (async function() {
      if (Object.keys(f).length) {
        _({
          values: f,
          key: g5({ values: f, hasSession: a, stableHashExtraOptions: d })
        });
        return;
      }
      if (!(e != null && e.bookingFields))
        return {};
      const h = await $ll({
        bookingFields: e.bookingFields,
        view: t ? "reschedule" : "booking"
      }).parseAsync({
        ...s,
        name: c.name,
        // `guest` because we need to support legacy URL with `guest` query param support
        // `guests` because the `name` of the corresponding bookingField is `guests`
        guests: c.guests
      }), b = {
        email: t && p && p.attendees.length > 0 ? p == null ? void 0 : p.attendees[0].email : h.email ? h.email : o ?? "",
        name: t && p && p.attendees.length > 0 ? p == null ? void 0 : p.attendees[0].name : h.name ? h.name : r ?? i ?? ""
      };
      if (l && (b.email = b.email.replace(`+${l}`, "")), !n) {
        const k = {
          responses: {}
        }, S = e.bookingFields.reduce((O, I) => ({
          ...O,
          [I.name]: h[I.name] || void 0
        }), {});
        k.responses = {
          ...S,
          name: b.name,
          email: b.email ?? ""
        }, _({
          values: k,
          key: g5({ values: k, hasSession: a, stableHashExtraOptions: d })
        });
      }
      if (!t && !p)
        return {};
      const v = {
        responses: {},
        bookingId: p == null ? void 0 : p.id
      }, $ = e.bookingFields.reduce((k, S) => ({
        ...k,
        [S.name]: p == null ? void 0 : p.responses[S.name]
      }), {});
      v.responses = {
        ...$,
        name: b.name,
        email: b.email ?? ""
      }, _({
        values: v,
        key: g5({ values: v, hasSession: a, stableHashExtraOptions: d })
      });
    })();
  }, [
    e == null ? void 0 : e.bookingFields,
    f,
    n,
    p,
    p == null ? void 0 : p.id,
    t,
    o,
    r,
    i,
    c,
    // We need to have extraOptions as a dep so that any change in query params can update the form values, but extraOptions itself isn't stable and changes reference on every render
    d
  ]), u;
}
const uKl = ({
  event: e,
  sessionEmail: t,
  sessionName: n,
  sessionUsername: o,
  hasSession: r,
  extraOptions: i,
  prefillFormParams: a,
  clientId: s
}) => {
  const c = Ic((S) => S.rescheduleUid), l = Ic((S) => S.bookingData), { t: d } = Fe(), u = Ue(null), _ = G.object({
    responses: e ? wll({
      bookingFields: e.bookingFields,
      view: c ? "reschedule" : "booking"
    }) : (
      // Fallback until event is loaded.
      G.object({})
    )
  }).passthrough(), p = !!c && !!l, { values: f, key: g } = dKl({
    eventType: e,
    rescheduleUid: c,
    isRescheduling: p,
    email: t,
    name: n,
    username: o,
    hasSession: r,
    extraOptions: i,
    prefillFormParams: a,
    clientId: s
  }), h = pd({
    defaultValues: f,
    resolver: ek(
      // Since this isn't set to strict we only validate the fields in the schema
      _,
      {},
      {
        // bookingFormSchema is an async schema, so inform RHF to do async validation.
        mode: "async"
      }
    )
  });
  Le(() => {
    h.reset(f);
  }, [g]);
  const b = h.watch("responses.email"), v = h.watch("responses.name"), $ = () => {
    if (h.clearErrors(), !e) {
      h.setError("globalError", { message: d("error_booking_event") });
      return;
    }
  }, k = {
    hasFormErrors: !!h.formState.errors.globalError,
    formErrors: h.formState.errors.globalError
  };
  return {
    bookingForm: h,
    bookerFormErrorRef: u,
    key: g,
    formEmail: b,
    formName: v,
    beforeVerifyEmail: $,
    formErrors: k,
    errors: k
  };
}, _Kl = (e, t) => {
  const n = Number.isFinite(e), o = Number.isFinite(t);
  return !(!n || !o || e === t);
}, pKl = (e, t, n, o, r) => {
  const i = _Kl(n, o), a = e === pn.WEEK_VIEW, s = e === pn.COLUMN_VIEW, c = t === "selecting_time";
  if (i && (s || !a && c && !r))
    return 2;
}, YJ = (e, t) => !(isNaN(e) || isNaN(t) || e === t), mKl = (e, t) => {
  const n = De(e).isValid(), o = De(t).startOf("month").add(2, "week"), r = De().isSame(De(t), "month");
  return !!(De().isAfter(o) && (!n || r));
}, fKl = (e, t, n, o, r, i, a) => e === pn.WEEK_VIEW ? !!a && YJ(n, o) : e === pn.COLUMN_VIEW ? YJ(n, r) : e === pn.MONTH_VIEW || e === "mobile" ? mKl(t, i) : !1, $be = ({ date: e, month: t, bookerLayout: n, bookerState: o }) => {
  const r = De(e).month(), i = De(e).add(1, "month").month(), a = De(e).add(n.extraDays, "day").month(), s = De(e).add(n.columnViewExtraDays.current, "day").month(), c = fKl(
    n.layout,
    e,
    r,
    a,
    s,
    t,
    n.extraDays
  ), l = pKl(
    n.layout,
    o,
    i,
    s,
    c
  );
  return {
    prefetchNextMonth: c,
    monthCount: l
  };
}, gKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.post("/bookings", o).then((r) => {
    if (r.data.status === qt)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), hKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.post("/bookings/instant", o).then((r) => {
    if (r.data.status === qt)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), vKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.post("/bookings/recurring", o).then((r) => r.data),
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), wbe = "user-booking", bKl = (e = {
  onSuccess: () => {
  },
  onError: () => {
  },
  uid: ""
}) => {
  const { isInit: t } = po(), n = `/${Pi.bookings}/${e.uid}/reschedule`;
  return go({
    queryKey: [wbe, e.uid],
    queryFn: () => He.get(n).then((r) => {
      var a, s;
      if (r.data.status === qt)
        return (a = e.onSuccess) == null || a.call(
          e,
          r.data.data
        ), r.data.data;
      const i = new Error(r.data.error.message);
      throw (s = e.onError) == null || s.call(e, i), i;
    }).catch((r) => {
      var i;
      (i = e.onError) == null || i.call(e, r);
    }),
    enabled: t && !!(e != null && e.uid)
  });
};
function yKl(e) {
  if (!e)
    return;
  const n = Object.fromEntries(
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].map((o) => [o, e.get(o) ?? void 0])
  );
  return Object.values(n).every((o) => o === void 0) ? void 0 : n;
}
const $Kl = ({
  bookingForm: e,
  event: t,
  metadata: n,
  hashedLink: o,
  handleBooking: r,
  handleInstantBooking: i,
  handleRecBooking: a,
  locationUrl: s,
  routingFormSearchParams: c,
  isBookingDryRun: l
}) => {
  const d = Zo(), u = St((z) => z.setFormValues), _ = St((z) => z.selectedTimeslot), p = St((z) => z.selectedDuration), { timezone: f } = vd(), g = St((z) => z.rescheduleUid), h = St((z) => z.rescheduledBy), { t: b, i18n: v } = Fe(), $ = St((z) => z.username), k = St((z) => z.recurringEventCount), S = St((z) => z.bookingData), O = St((z) => z.seatedEventData), I = St((z) => z.isInstantMeeting), D = St((z) => z.org), M = St((z) => z.teamMemberEmail), N = St((z) => z.crmOwnerRecordType), C = St((z) => z.crmAppSlug), P = St((z) => z.crmRecordId), x = St((z) => z.verificationCode), w = (z) => {
    const j = z != null && z.message ? b(z.message) : b("can_you_try_again");
    nr(j, "error");
  }, E = Ro.useSearchParams();
  return (z) => {
    var F, L, U, W;
    const j = e.getValues(), q = z ?? _, V = z && !d ? { onError: w } : void 0;
    if (q) {
      if (u({}), e.clearErrors(), !(t != null && t.data)) {
        e.setError("globalError", { message: b("error_booking_event") });
        return;
      }
      const H = t.data.isDynamic ? p || t.data.length : p && ((L = (F = t.data.metadata) == null ? void 0 : F.multipleDuration) != null && L.includes(p)) ? p : t.data.length, Q = {
        values: j,
        duration: H,
        event: t.data,
        date: q,
        timeZone: f,
        language: v.language,
        rescheduleUid: g || void 0,
        rescheduledBy: h || void 0,
        bookingUid: S && S.uid || (O == null ? void 0 : O.bookingUid) || void 0,
        username: $ || "",
        metadata: n,
        hashedLink: o,
        teamMemberEmail: M,
        crmOwnerRecordType: N,
        crmAppSlug: C,
        crmRecordId: P,
        orgSlug: D || void 0,
        routingFormSearchParams: c,
        isDryRunProp: l,
        verificationCode: x || void 0
      }, X = yKl(E);
      I ? i(bL(Q), V) : (W = (U = t.data) == null ? void 0 : U.recurringEvent) != null && W.freq && k && !g ? a(
        Rpl(Q, k, X),
        V
      ) : r({ ...bL(Q), locationUrl: s, tracking: X }, V), u({}), e.clearErrors();
    }
  };
}, wKl = "get-public-event", kbe = ({ username: e, eventSlug: t, isTeamEvent: n, teamId: o, selectedDuration: r }) => {
  const { organizationId: i } = po(), a = Tt(() => T_(e ?? "").length > 1, [e]), s = `/atoms/${Pi.eventTypes}/${t}/public`;
  return go({
    queryKey: [wKl, e, t, n, o, i],
    queryFn: () => {
      const l = {
        isTeamEvent: n,
        teamId: o,
        username: T_(e ?? "").join("+")
      };
      return i !== 0 && (l.orgId = i), He == null ? void 0 : He.get(s, {
        params: l
      }).then((d) => {
        if (d.data.status === qt)
          return a && r && d.data.data && (d.data.data.length = r), d.data.data;
        throw new Error(d.data.error.message);
      });
    }
  });
}, kKl = "get-available-slots", Sbe = ({
  enabled: e,
  ...t
}) => go({
  queryKey: [
    kKl,
    t.startTime,
    t.endTime,
    t.eventTypeId,
    t.eventTypeSlug,
    t.isTeamEvent ?? !1,
    t.teamId ?? !1,
    t.usernameList,
    t.routedTeamMemberIds,
    t.skipContactOwner,
    t._shouldServeCache,
    t.teamMemberEmail
  ],
  queryFn: () => He.get("/slots/available", {
    params: t
  }).then((o) => {
    if (o.data.status === qt)
      return o.data.data;
    throw new Error(o.data.error.message);
  }),
  enabled: e
}), SKl = "get-calendars-busy-times", xKl = ({ onError: e, enabled: t, ...n }) => {
  var r;
  return go({
    queryKey: [
      SKl,
      ((r = n == null ? void 0 : n.calendarsToLoad) == null ? void 0 : r.length) ?? 0,
      n.dateFrom ?? "",
      n.dateTo ?? "",
      n.loggedInUsersTz
    ],
    queryFn: () => He.get("/calendars/busy-times", {
      params: n
    }).then((i) => {
      if (i.data.status === qt)
        return i.data;
      throw e == null || e(), new Error(i.data.error.message);
    }),
    enabled: t && !!n.dateFrom && !!n.dateTo
  });
};
let ZJ = null;
const EKl = () => {
  function e(n) {
    ZJ = n;
  }
  function t() {
    return ZJ;
  }
  return [t(), e];
}, TKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.delete("/slots/selected-slot", {
    params: o
  }).then((r) => {
    if (r.data.status === qt)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), AKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.post("/slots/reserve", o).then((r) => {
    if (r.data.status === qt)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), CKl = (e, {
  onReserveSlotSuccess: t,
  onReserveSlotError: n,
  onDeleteSlotSuccess: o,
  onDeleteSlotError: r,
  isBookingDryRun: i,
  handleSlotReservation: a
} = {}) => {
  var v;
  const s = St(($) => $.selectedDuration), [c, l] = St(
    ($) => [$.selectedTimeslot, $.setSelectedTimeslot],
    Fr
  ), [d, u] = EKl(), _ = AKl({
    onSuccess: ($) => {
      u($.data), t == null || t($);
    },
    onError: n
  }), p = St(($) => $.seatedEventData), f = TKl({
    onSuccess: o,
    onError: r
  }), g = () => {
    e != null && e.data && f.mutate({ uid: d ?? void 0 });
  }, h = () => {
    var $, k;
    if (($ = e == null ? void 0 : e.data) != null && $.id && c && (s || (k = e == null ? void 0 : e.data) != null && k.length)) {
      if (a) {
        a(c);
        return;
      }
      _.mutate({
        slotUtcStartDate: De(c).utc().format(),
        eventTypeId: e.data.id,
        slotUtcEndDate: De(c).utc().add(s || e.data.length, "minutes").format(),
        _isDryRun: i,
        bookingUid: p.bookingUid || void 0
      });
    }
  }, b = St(($) => $.selectedTimeslot);
  return Le(() => {
    h();
    const $ = setInterval(() => {
      h();
    }, parseInt(Ymc) * 60 * 1e3 - 2e3);
    return () => {
      g(), clearInterval($);
    };
  }, [(v = e == null ? void 0 : e.data) == null ? void 0 : v.id, b]), {
    selectedTimeslot: c,
    setSelectedTimeslot: l,
    setSlotReservationId: u,
    slotReservationId: d,
    handleReserveSlot: h,
    handleRemoveSlot: g,
    // TODO: implement slot no longer available feature
    allSelectedTimeslots: []
  };
}, xbe = ({ onSuccess: e }) => {
  const [t, n] = ze(!1), [o, r] = ze(""), [i, a] = ze(""), [s, c] = ze(!1), l = Yo({
    mutationFn: (p) => He.post(
      "/atoms/verification/email/verify-code-authenticated",
      p
    ).then((f) => {
      var g;
      if (f.data.status === qt)
        return f.data;
      throw new Error(((g = f.data.error) == null ? void 0 : g.message) || "Invalid verification code");
    }),
    onSuccess: (p) => {
      n(!1), c(p.data.verified), e(p.data.verified);
    },
    onError: (p) => {
      var f, g, h, b, v;
      n(!1), c(!1), (g = (f = p.error) == null ? void 0 : f.message) != null && g.includes("invalid") || (b = (h = p.error) == null ? void 0 : h.message) != null && b.includes("Invalid") ? r("Code provided is invalid") : r(((v = p.error) == null ? void 0 : v.message) || "Verification failed");
    }
  }), d = Yo({
    mutationFn: (p) => He.post("/atoms/verification/email/verify-code", p).then((f) => {
      var g;
      if (f.data.status === qt)
        return f.data;
      throw new Error(((g = f.data.error) == null ? void 0 : g.message) || "Invalid verification code");
    }),
    onSuccess: (p) => {
      n(!1), c(p.data.verified), e(p.data.verified);
    },
    onError: (p) => {
      var f, g, h, b, v;
      n(!1), c(!1), (g = (f = p.error) == null ? void 0 : f.message) != null && g.includes("invalid") || (b = (h = p.error) == null ? void 0 : h.message) != null && b.includes("Invalid") ? r("Code provided is invalid") : r(((v = p.error) == null ? void 0 : v.message) || "Verification failed");
    }
  });
  return {
    verifyCodeWithSessionRequired: (p, f) => {
      l.mutate({ code: p, email: f });
    },
    verifyCodeWithSessionNotRequired: (p, f) => {
      d.mutate({ code: p, email: f });
    },
    isPending: t,
    setIsPending: n,
    error: o,
    value: i,
    hasVerified: s,
    setValue: a,
    setHasVerified: c,
    resetErrors: () => r("")
  };
};
function zKl(e, t) {
  const [n, o] = ze(e);
  return Le(() => {
    const r = setTimeout(() => {
      o(e);
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [e, t]), n;
}
const Ebe = ({
  email: e,
  name: t,
  requiresBookerEmailVerification: n,
  onVerifyEmail: o
}) => {
  const [r, i] = ze(!1), a = Ic((g) => g.verifiedEmail), s = Ic((g) => g.setVerifiedEmail), c = zKl(e, 600), { data: l } = sg(), { data: d } = go({
    queryKey: ["isEmailVerificationRequired", c],
    queryFn: () => {
      var g;
      return He == null ? void 0 : He.get("/atoms/verification/email/check", {
        params: {
          email: c,
          userSessionEmail: ((g = l == null ? void 0 : l.data) == null ? void 0 : g.email) || ""
        }
      }).then((h) => {
        if (h.data.status === qt)
          return h.data.data;
        throw new Error(h.data.error.message);
      });
    },
    enabled: !!c
  }), u = Yo({
    mutationFn: (g) => He.post("/atoms/verification/email/send-code", g).then((h) => {
      var b;
      if (h.data.status === qt)
        return h.data;
      throw new Error(((b = h.data.error) == null ? void 0 : b.message) || "Failed to send verification email");
    }),
    onSuccess: () => {
      i(!0);
    },
    onError: (g) => {
      console.error("Failed to send verification email:", g);
    }
  }), _ = () => {
    o == null || o(), u.mutate({
      email: e,
      username: typeof t == "string" ? t : t == null ? void 0 : t.firstName
    });
  }, p = u.isPending;
  return {
    handleVerifyEmail: _,
    isEmailVerificationModalVisible: r,
    setEmailVerificationModalVisible: i,
    setVerifiedEmail: s,
    renderConfirmNotVerifyEmailButtonCond: !!(!n && !d || e && a && a === e),
    isVerificationCodeSending: p
  };
}, OKl = (e) => {
  var Zn, st, ft, yt, on, Ut, Nt, Kt, At, Mt, Ie, tt, zt, $t, In, xe, je, pt, Jt;
  const {
    view: t = "MONTH_VIEW",
    bannerUrl: n,
    routingFormSearchParams: o,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    preventEventTypeRedirect: s,
    onBookerStateChange: c,
    allowUpdatingUrlParams: l = !1,
    confirmButtonDisabled: d,
    isBookingDryRun: u,
    handleSlotReservation: _,
    onTimeslotsLoaded: p,
    startTime: f,
    showNoAvailabilityDialog: g,
    silentlyHandleCalendarFailures: h = !1,
    hideEventMetadata: b = !1
  } = e, v = pn[t], { clientId: $ } = po(), k = e.isTeamEvent ? e.teamId : void 0, [S, O] = St(
    (Ye) => [Ye.state, Ye.setState],
    Fr
  ), I = St((Ye) => Ye.setSelectedDate), D = St((Ye) => Ye.setSelectedDuration), M = St((Ye) => Ye.setBookingData), N = St((Ye) => Ye.setOrg), C = St((Ye) => Ye.bookingData), P = St((Ye) => Ye.setSelectedTimeslot), x = St((Ye) => Ye.setMonth), w = St((Ye) => Ye.selectedDuration), [E, T] = ze(
    !!((Zn = wo == null ? void 0 : wo.getItem) != null && Zn.call(wo, "overlayCalendarSwitchDefault"))
  ), z = Ue(null), j = Pn(nA), q = at((Ye) => Object.fromEntries(
    Object.entries(Ye).filter(([mn, Co]) => typeof Co != "function")
  ), []), V = Tt(() => aol(
    (Ye, mn) => {
      const Co = z.current;
      (!Co || JSON.stringify(Co) !== JSON.stringify(Ye)) && (mn(Ye), z.current = Ye);
    },
    50
  ), []);
  Le(() => {
    if (!c || !j)
      return;
    const Ye = j.subscribe((Co) => {
      const zo = q(Co);
      V(zo, c);
    }), mn = q(j.getState());
    return c(mn), z.current = mn, () => {
      Ye(), V.cancel();
    };
  }, [c, q, V, j]), bKl({
    uid: e.rescheduleUid ?? e.bookingUid ?? "",
    onSuccess: (Ye) => {
      M(Ye);
    }
  });
  const F = ns(), L = Tt(() => e.username ? Tbe(e.username) : "", [e.username]);
  Le(() => {
    D(e.duration ?? null);
  }, [e.duration]), Le(() => {
    var Ye;
    N(((Ye = e.entity) == null ? void 0 : Ye.orgSlug) ?? null);
  }, [(st = e.entity) == null ? void 0 : st.orgSlug]);
  const U = Tt(() => T_(L ?? "").length > 1, [L]), W = kbe({
    username: L,
    eventSlug: e.eventSlug,
    isTeamEvent: e.isTeamEvent,
    teamId: k,
    selectedDuration: w
  }), H = ybe((yt = (ft = W.data) == null ? void 0 : ft.profile) == null ? void 0 : yt.bookerLayouts);
  kle({
    ...e,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    crmRecordId: e.crmRecordId,
    eventId: (on = W == null ? void 0 : W.data) == null ? void 0 : on.id,
    rescheduleUid: e.rescheduleUid ?? null,
    bookingUid: e.bookingUid ?? null,
    layout: v,
    org: (Ut = e.entity) == null ? void 0 : Ut.orgSlug,
    username: L,
    bookingData: C,
    isPlatform: !0,
    allowUpdatingUrlParams: l
  }), h9({
    ...e,
    teamMemberEmail: r,
    crmAppSlug: i,
    crmOwnerRecordType: a,
    crmRecordId: e.crmRecordId,
    eventId: (Nt = W == null ? void 0 : W.data) == null ? void 0 : Nt.id,
    rescheduleUid: e.rescheduleUid ?? null,
    bookingUid: e.bookingUid ?? null,
    layout: v,
    org: (Kt = e.entity) == null ? void 0 : Kt.orgSlug,
    username: L,
    bookingData: C,
    isPlatform: !0,
    allowUpdatingUrlParams: l
  });
  const [Q] = St((Ye) => [Ye.dayCount, Ye.setDayCount], Fr), X = St((Ye) => Ye.selectedDate), re = St((Ye) => Ye.month), Z = St((Ye) => Ye.eventSlug), { data: ee } = sg(), J = !!ee, { name: oe, guests: ce, ...de } = e.defaultFormValues ?? {}, te = Tt(() => oe || (de.firstName ? `${de.firstName} ${de.lastName}` : null), [oe, de]), ue = Tt(() => ({
    name: te,
    guests: ce ?? []
  }), [oe, ce]), le = Tt(() => de, [de]), se = De(X).format("YYYY-MM-DD"), { prefetchNextMonth: me, monthCount: pe } = $be({
    date: se,
    month: re,
    bookerLayout: H,
    bookerState: S
  }), { timezone: be } = lu(), [Se, Ae] = IF({
    month: re,
    monthCount: pe,
    dayCount: Q,
    prefetchNextMonth: me,
    selectedDate: X
  }), Ze = f && De(f).isAfter(De(Se)) ? De(f).toISOString() : Se, Ge = Ae, [rt, qe] = ze({});
  Le(() => {
    var Ds, xu;
    const Ye = o ? new URLSearchParams(o) : new URLSearchParams(window.location.search), mn = OF(Ye), Co = Ye.get("cal.skipContactOwner") === "true", zo = Ye == null ? void 0 : Ye.get("cal.cache"), Di = zo ? zo === "true" : void 0, Ti = ((Ds = Ye == null ? void 0 : Ye.get("cal.isBookingDryRun")) == null ? void 0 : Ds.toLowerCase()) === "true" || ((xu = Ye == null ? void 0 : Ye.get("cal.sandbox")) == null ? void 0 : xu.toLowerCase()) === "true";
    qe({
      ...Co ? { skipContactOwner: Co } : {},
      ...mn ? { routedTeamMemberIds: mn } : {},
      ...Di ? { _shouldServeCache: Di } : {},
      ...Ti ? { isBookingDryRun: Ti } : {}
    });
  }, [o]);
  const Xe = Sbe({
    usernameList: T_(L),
    eventTypeId: ((At = W == null ? void 0 : W.data) == null ? void 0 : At.id) ?? 0,
    startTime: Ze,
    endTime: Ge,
    timeZone: be,
    duration: w ?? void 0,
    rescheduleUid: e.rescheduleUid,
    teamMemberEmail: r ?? void 0,
    ...e.isTeamEvent ? {
      isTeamEvent: e.isTeamEvent,
      teamId: k
    } : {},
    enabled: !!(k || L) && !!re && !!be && !(W != null && W.isPending) && !!((Mt = W == null ? void 0 : W.data) != null && Mt.id),
    orgSlug: ((Ie = e.entity) == null ? void 0 : Ie.orgSlug) ?? void 0,
    eventTypeSlug: U ? "dynamic" : Z || "",
    _silentCalendarFailures: h,
    ...rt
  });
  Le(() => {
    Xe.data && !Xe.isPending && !Xe.error && p && p(Xe.data.slots);
  }, [Xe.data, Xe.isPending, Xe.error, p]);
  const lt = uKl({
    event: W == null ? void 0 : W.data,
    sessionEmail: (tt = ee == null ? void 0 : ee.data) != null && tt.email && $ ? ee.data.email.replace(`+${$}`, "") : (zt = ee == null ? void 0 : ee.data) == null ? void 0 : zt.email,
    sessionUsername: ($t = ee == null ? void 0 : ee.data) == null ? void 0 : $t.username,
    sessionName: (In = ee == null ? void 0 : ee.data) == null ? void 0 : In.username,
    hasSession: J,
    extraOptions: le ?? {},
    prefillFormParams: ue,
    clientId: $
  }), {
    mutate: Et,
    isPending: wt,
    error: nn,
    isError: Dt
  } = gKl({
    onSuccess: (Ye) => {
      var mn, Co, zo, Di, Ti;
      (mn = Ye == null ? void 0 : Ye.data) != null && mn.isDryRun && ((Co = e == null ? void 0 : e.onDryRunSuccess) == null || Co.call(e)), Xe.refetch(), (zo = e.onCreateBookingSuccess) == null || zo.call(e, Ye), !s && ((Di = W == null ? void 0 : W.data) != null && Di.successRedirectUrl) && (window.location.href = (Ti = W == null ? void 0 : W.data) == null ? void 0 : Ti.successRedirectUrl);
    },
    onError: e.onCreateBookingError
  }), {
    mutate: mt,
    isPending: bt,
    error: gn,
    isError: an
  } = vKl({
    onSuccess: (Ye) => {
      var mn, Co, zo, Di, Ti, Ds;
      (Co = (mn = Ye == null ? void 0 : Ye.data) == null ? void 0 : mn[0]) != null && Co.isDryRun && ((zo = e == null ? void 0 : e.onDryRunSuccess) == null || zo.call(e)), Xe.refetch(), (Di = e.onCreateRecurringBookingSuccess) == null || Di.call(e, Ye), (Ti = W == null ? void 0 : W.data) != null && Ti.successRedirectUrl && (window.location.href = (Ds = W == null ? void 0 : W.data) == null ? void 0 : Ds.successRedirectUrl);
    },
    onError: e.onCreateRecurringBookingError
  }), {
    mutate: Mn,
    isPending: Ln,
    error: un,
    isError: qo
  } = hKl({
    onSuccess: (Ye) => {
      var mn;
      Xe.refetch(), (mn = e.onCreateInstantBookingSuccess) == null || mn.call(e, Ye);
    },
    onError: e.onCreateInstantBookingError
  }), cn = CKl(W, {
    onReserveSlotSuccess: e.onReserveSlotSuccess,
    onReserveSlotError: e.onReserveSlotError,
    onDeleteSlotSuccess: e.onDeleteSlotSuccess,
    onDeleteSlotError: e.onDeleteSlotError,
    isBookingDryRun: e.isBookingDryRun ? e.isBookingDryRun : rt == null ? void 0 : rt.isBookingDryRun,
    handleSlotReservation: _
  }), ln = Ebe({
    email: lt.formEmail,
    name: lt.formName,
    requiresBookerEmailVerification: (xe = W == null ? void 0 : W.data) == null ? void 0 : xe.requiresBookerEmailVerification,
    onVerifyEmail: lt.beforeVerifyEmail
  }), kn = xbe({
    onSuccess: () => {
      lt.formEmail && (ln.setVerifiedEmail(lt.formEmail), ln.setEmailVerificationModalVisible(!1), Bn());
    }
  }), { data: gt, isPending: Ot } = Qv({
    enabled: J
  }), _n = gt, { set: wn, clearSet: so } = bbe("toggledConnectedCalendars", []), [rn, Ht] = ze(
    Array.from(wn).map((Ye) => ({
      credentialId: Ye.credentialId,
      externalId: Ye.externalId
    }))
  ), { data: qn } = xKl({
    loggedInUsersTz: be,
    dateFrom: X,
    dateTo: X,
    calendarsToLoad: rn,
    onError: () => {
      so();
    },
    enabled: !!(J && E && (rn == null ? void 0 : rn.length) > 0)
  }), Bn = $Kl({
    event: W,
    bookingForm: lt.bookingForm,
    hashedLink: e.hashedLink,
    metadata: e.metadata ?? {},
    handleBooking: (e == null ? void 0 : e.handleCreateBooking) ?? Et,
    handleInstantBooking: Mn,
    handleRecBooking: (e == null ? void 0 : e.handleCreateRecurringBooking) ?? mt,
    locationUrl: e.locationUrl,
    routingFormSearchParams: o,
    isBookingDryRun: u ?? (rt == null ? void 0 : rt.isBookingDryRun)
  }), Or = at(
    (Ye) => {
      T(Ye), Ye ? wo == null || wo.setItem("overlayCalendarSwitchDefault", "true") : wo == null || wo.removeItem("overlayCalendarSwitchDefault");
    },
    [T]
  ), oo = Tt(
    () => De(e.selectedDate).format("YYYY-MM-DD"),
    [e.selectedDate]
  );
  return Le(() => {
    I({ date: oo, omitUpdatingParams: !0 });
  }, [oo]), Le(() => () => {
    cn.handleRemoveSlot(), O("loading"), I({ date: null }), P(null), D(null), N(null), x(null), e.rescheduleUid && (F.removeQueries({
      queryKey: [wbe, e.rescheduleUid],
      exact: !0
    }), M(null));
  }, []), Le(() => {
    var Ye;
    E && t === "MONTH_VIEW" && (wo == null || wo.removeItem("overlayCalendarSwitchDefault")), T(!!((Ye = wo == null ? void 0 : wo.getItem) != null && Ye.call(wo, "overlayCalendarSwitchDefault")));
  }, [t, E]), /* @__PURE__ */ m(Ii, { customClassName: (je = e == null ? void 0 : e.customClassNames) == null ? void 0 : je.atomsWrapper, children: /* @__PURE__ */ m(
    cKl,
    {
      timeZones: e.timeZones,
      teamMemberEmail: r,
      crmAppSlug: i,
      crmOwnerRecordType: a,
      customClassNames: e.customClassNames,
      eventSlug: e.eventSlug,
      username: L,
      showNoAvailabilityDialog: g,
      entity: ((pt = W == null ? void 0 : W.data) == null ? void 0 : pt.entity) ?? {
        considerUnpublished: !1,
        orgSlug: void 0,
        teamSlug: void 0,
        name: void 0
      },
      rescheduleUid: e.rescheduleUid ?? null,
      rescheduledBy: e.rescheduledBy ?? null,
      bookingUid: e.bookingUid ?? null,
      isRedirect: !1,
      confirmButtonDisabled: d,
      fromUserNameRedirected: "",
      hasSession: J,
      onGoBackInstantMeeting: function() {
        throw new Error("Function not implemented.");
      },
      onConnectNowInstantMeeting: function() {
        throw new Error("Function not implemented.");
      },
      onOverlayClickNoCalendar: function() {
        throw new Error("Function not implemented.");
      },
      onClickOverlayContinue: function() {
        throw new Error("Function not implemented.");
      },
      onOverlaySwitchStateChange: Or,
      extraOptions: le ?? {},
      bookings: {
        handleBookEvent: (Ye) => {
          Bn(Ye);
        },
        expiryTime: void 0,
        bookingForm: lt.bookingForm,
        bookerFormErrorRef: lt.bookerFormErrorRef,
        errors: {
          hasDataErrors: Dt || an || qo,
          dataErrors: nn || gn || un
        },
        loadingStates: {
          creatingBooking: wt,
          creatingRecurringBooking: bt,
          creatingInstantBooking: Ln
        },
        instantVideoMeetingUrl: void 0
      },
      slots: cn,
      calendars: {
        overlayBusyDates: qn == null ? void 0 : qn.data,
        isOverlayCalendarEnabled: E,
        connectedCalendars: (_n == null ? void 0 : _n.connectedCalendars) || [],
        loadingConnectedCalendar: Ot,
        onToggleCalendar: (Ye) => {
          const mn = Array.from(Ye ?? []);
          Ht(mn);
        }
      },
      verifyEmail: ln,
      bookerForm: lt,
      event: W,
      schedule: Xe,
      orgBannerUrl: n ?? ((Jt = W.data) == null ? void 0 : Jt.bannerUrl),
      bookerLayout: { ...H, hideEventTypeDetails: b },
      verifyCode: kn,
      isPlatform: !0,
      hasValidLicense: !0,
      isBookingDryRun: u ?? (rt == null ? void 0 : rt.isBookingDryRun),
      eventMetaChildren: e.eventMetaChildren,
      roundRobinHideOrgAndTeam: e.roundRobinHideOrgAndTeam
    }
  ) });
}, QJ = (e) => /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(OKl, { ...e }) });
function Tbe(e) {
  return typeof e == "string" ? e : e.join("+");
}
const PKl = "use-event-types", ffd = (e) => {
  const t = `/${Pi.eventTypes}?username=${e}`;
  return go({
    queryKey: [PKl, e],
    queryFn: () => He == null ? void 0 : He.get(t).then((n) => {
      if (n.data.status === qt)
        return n.data.data;
      throw new Error(n.data.error.message);
    })
  });
}, IKl = "use-team-event-types", gfd = (e) => {
  const { organizationId: t } = po(), n = `/organizations/${t}/teams/${e}/event-types`;
  return go({
    queryKey: [IKl, t, e],
    queryFn: () => He == null ? void 0 : He.get(n).then((o) => {
      if (o.data.status === qt)
        return o.data.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!t && !!e
  });
}, RKl = "use-event-type", NKl = (e, t, n) => {
  const o = e, r = t, i = Tt(() => T_(o ?? "").length > 1, [o]);
  return go({
    queryKey: [RKl, e, t],
    queryFn: async () => {
      if (!n)
        return i ? He.get(
          `/${Pi.eventTypes}?usernames=${encodeURIComponent(T_(e).join(","))}`
        ).then((s) => {
          if (s.data.status === qt)
            return s.data.data;
          throw new Error(s.data.error.message);
        }) : He.get(
          `/${Pi.eventTypes}?username=${o}&eventSlug=${r}`
        ).then((s) => {
          if (s.data.status === qt)
            return s.data.data;
          throw new Error(s.data.error.message);
        });
    }
  });
}, hfd = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => He.post(`/bookings/${o.uid}/cancel`, o).then((r) => {
    if (r.data.status === qt)
      return r.data;
    throw new Error(r.data.error.message);
  }),
  onSuccess: (o) => {
    o.status === qt ? e == null || e() : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), vfd = (e) => {
  const t = `/${Pi.bookings}/${e}`, n = {
    [Gv]: Qie
  };
  return go({
    queryKey: ["use-booking", e],
    queryFn: async () => He.get(t, { headers: n }).then((r) => {
      var i, a;
      if (r.data.status === qt)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    }),
    enabled: !!e
  });
}, DKl = "use-bookings", MKl = (e) => {
  const t = `/${Pi.bookings}`, n = {
    [Gv]: Qie
  };
  return go({
    queryKey: [DKl, ...GF(e)],
    queryFn: async () => He.get(t, {
      params: e,
      headers: n
    }).then((r) => {
      var i, a;
      if (r.data.status === qt)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    })
  });
};
function GF(e) {
  return [
    e.status,
    e.attendeeEmail,
    e.attendeeName,
    e.eventTypeIds,
    e.eventTypeId,
    e.teamsIds,
    e.teamId,
    e.afterStart,
    e.beforeEnd,
    e.afterCreatedAt,
    e.beforeCreatedAt,
    e.afterUpdatedAt,
    e.beforeUpdatedAt,
    e.sortStart,
    e.sortEnd,
    e.sortCreated,
    e.sortUpdatedAt,
    e.take,
    e.skip
  ];
}
const Abe = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  onCheckError: r,
  redir: i,
  initialData: a,
  isMultiCalendar: s = !1,
  tooltipSide: c,
  tooltip: l,
  isClickable: d,
  isDryRun: u
}) => {
  const { t: _ } = Fe();
  return /* @__PURE__ */ m(
    pce,
    {
      label: e || _("outlook_connect_atom_label"),
      alreadyConnectedLabel: t || _("outlook_connect_atom_already_connected_label"),
      loadingLabel: n || _("outlook_connect_atom_loading_label"),
      calendar: bCe,
      className: o,
      onCheckError: r,
      redir: i,
      initialData: a,
      isMultiCalendar: s,
      tooltipSide: c,
      tooltip: l,
      isClickable: d,
      isDryRun: u
    }
  );
}, Cbe = ({
  label: e,
  alreadyConnectedLabel: t,
  loadingLabel: n,
  className: o,
  initialData: r,
  isMultiCalendar: i = !1,
  tooltip: a,
  tooltipSide: s = "bottom",
  isClickable: c,
  onSuccess: l,
  isDryRun: d = !1
}) => {
  const { t: u } = Fe(), _ = pd({
    defaultValues: {
      username: "",
      password: ""
    }
  }), { toast: p } = C_(), { allowConnect: f, checked: g, refetch: h } = _ce({
    calendar: "apple",
    initialData: r
  }), [b, v] = ze(!1);
  let $ = e || u("apple_connect_atom_label");
  const { mutate: k, isPending: S } = Ypc({
    onSuccess: (D) => {
      D.status === qt && (_.reset(), v(!1), h(), p({
        description: "Calendar credentials added successfully"
      }), l == null || l());
    },
    onError: (D) => {
      p({
        description: `Error: ${D}`
      });
    }
  }), O = !g, I = O || !f;
  return O ? $ = n || u("apple_connect_atom_loading_label") : f || ($ = t || u("apple_connect_atom_already_connected_label")), /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(k9, { open: b, children: [
    /* @__PURE__ */ m(Ile, { asChild: !0, children: /* @__PURE__ */ Y(Ce, { children: [
      i && /* @__PURE__ */ m(
        ut,
        {
          StartIcon: "calendar-days",
          color: "primary",
          disabled: c ? !1 : O,
          tooltip: a || /* @__PURE__ */ m(mce, { calendarInstance: "apple" }),
          tooltipSide: s,
          tooltipOffset: 10,
          tooltipClassName: "p-0 text-inherit bg-inherit",
          className: uo("", !I && "cursor-pointer", "border-none md:rounded-md", o),
          onClick: () => v(!0),
          children: $
        }
      ),
      !i && /* @__PURE__ */ m(
        ut,
        {
          StartIcon: "calendar-days",
          color: "primary",
          disabled: I,
          className: uo(
            "",
            I && "cursor-not-allowed",
            !I && "cursor-pointer",
            "border-none md:rounded-md",
            o
          ),
          onClick: () => v(!0),
          children: $
        }
      )
    ] }) }),
    /* @__PURE__ */ Y(x9, { className: "bg-default text-default", children: [
      /* @__PURE__ */ Y(Vle, { children: [
        /* @__PURE__ */ m(Ble, { children: "Connect to Apple Server" }),
        /* @__PURE__ */ Y(Ule, { children: [
          "Generate an app specific password to use with Cal.com at",
          " ",
          /* @__PURE__ */ m("span", { className: "font-bold", children: "https://appleid.apple.com/account/manage" }),
          ". Your credentials will be stored and encrypted."
        ] })
      ] }),
      /* @__PURE__ */ Y(
        fd,
        {
          form: _,
          handleSubmit: async (D) => {
            const { username: M, password: N } = D;
            d ? (_.reset(), v(!1), p({
              description: "Calendar credentials added successfully"
            }), l == null || l()) : await k({ calendar: "apple", username: M, password: N });
          },
          children: [
            /* @__PURE__ */ Y(
              "fieldset",
              {
                className: "space-y-4",
                disabled: _.formState.isSubmitting,
                "data-testid": "apple-calendar-form",
                children: [
                  /* @__PURE__ */ m(
                    Io,
                    {
                      required: !0,
                      type: "text",
                      ..._.register("username"),
                      label: "Apple ID",
                      placeholder: "appleid@domain.com",
                      "data-testid": "apple-calendar-email"
                    }
                  ),
                  /* @__PURE__ */ m(
                    K1c,
                    {
                      required: !0,
                      ..._.register("password"),
                      label: "Password",
                      placeholder: "•••••••••••••",
                      autoComplete: "password",
                      "data-testid": "apple-calendar-password"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ Y("div", { className: "mt-5 justify-end space-x-2 rtl:space-x-reverse sm:mt-4 sm:flex", children: [
              /* @__PURE__ */ m(
                ut,
                {
                  disabled: S,
                  type: "button",
                  color: "secondary",
                  className: "md:rounded-md",
                  onClick: () => v(!1),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ m(
                ut,
                {
                  disabled: S,
                  type: "submit",
                  className: "border-none md:rounded-md",
                  loading: _.formState.isSubmitting,
                  "data-testid": "apple-calendar-login-button",
                  children: "Save"
                }
              )
            ] })
          ]
        }
      )
    ] })
  ] }) });
}, bfd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppleCalendar: Cbe,
  GoogleCalendar: fce,
  OutlookCalendar: Abe
}, Symbol.toStringTag, { value: "Module" })), LKl = ({ routingFormUrl: e }) => Tt(() => {
  if (e) {
    const n = new URL(e), o = n.pathname.split("/");
    if (o.length < 2)
      throw new Error("Invalid routing form url.");
    const r = o[o.length - 1], i = o[1] === "team", a = i ? void 0 : o[1], s = n.searchParams;
    if (!r)
      throw new Error("Event type slug is not defined within the routing form url");
    if (!i && !a)
      throw new Error("username not defined within the routing form url");
    const c = {
      ...s.get("firstName") && {
        firstName: s.get("firstName") ?? void 0
      },
      ...s.get("lastName") && {
        lastName: s.get("lastName") ?? void 0
      },
      ...s.get("name") && {
        name: s.get("name") ?? void 0
      },
      ...s.get("email") && {
        email: s.get("email") ?? void 0
      },
      ...s.get("notes") && {
        notes: s.get("notes") ?? void 0
      },
      ...s.get("rescheduleReason") && {
        rescheduleReason: s.get("rescheduleReason") ?? void 0
      },
      ...s.get("guests") && {
        guests: s.getAll("guests") ?? void 0
      }
    };
    return { ...{
      organizationId: s.get("cal.orgId") ? Number(s.get("cal.orgId")) : void 0,
      teamId: s.get("cal.teamId") ? Number(s.get("cal.teamId")) : void 0,
      username: a,
      eventTypeSlug: r,
      ...s.get("cal.routedTeamMemberIds") && {
        "cal.routedTeamMemberIds": s.get("cal.routedTeamMemberIds") ?? void 0
      },
      ...s.get("cal.reroutingFormResponses") && {
        "cal.reroutingFormResponses": s.get("cal.reroutingFormResponses") ?? void 0
      },
      ...s.get("cal.skipContactOwner") && {
        "cal.skipContactOwner": s.get("cal.skipContactOwner") ?? void 0
      },
      ...s.get("cal.isBookingDryRun") && {
        "cal.isBookingDryRun": s.get("cal.isBookingDryRun") ?? void 0
      },
      ...s.get("cal.cache") && {
        "cal.cache": s.get("cal.cache") ?? void 0
      },
      ...s.get("cal.routingFormResponseId") && {
        "cal.routingFormResponseId": s.get("cal.routingFormResponseId") ?? void 0
      },
      ...s.get("cal.salesforce.rrSkipToAccountLookupField") && {
        "cal.salesforce.rrSkipToAccountLookupField": s.get("cal.salesforce.rrSkipToAccountLookupField") ?? void 0
      },
      ...s.get("cal.teamMemberEmail") && {
        teamMemberEmail: s.get("cal.teamMemberEmail") ?? void 0
      },
      ...s.get("cal.crmOwnerRecordType") && {
        crmOwnerRecordType: s.get("cal.crmOwnerRecordType") ?? void 0
      },
      ...s.get("cal.crmAppSlug") && {
        crmAppSlug: s.get("cal.crmAppSlug") ?? void 0
      }
    }, defaultFormValues: c };
  }
}, [e]), qKl = (e) => {
  const t = LKl(e);
  if (e != null && e.routingFormUrl && t) {
    const {
      organizationId: n,
      teamId: o,
      eventTypeSlug: r,
      username: i,
      defaultFormValues: a,
      teamMemberEmail: s,
      crmOwnerRecordType: c,
      crmAppSlug: l,
      ...d
    } = t, { onDryRunSuccess: u, ..._ } = e;
    return /* @__PURE__ */ m(
      qU,
      {
        clientId: "cm165l146000nqi1mrz8vscja",
        isEmbed: !0,
        organizationId: n,
        options: {
          apiUrl: "https://api.cal.com/v2"
        },
        children: /* @__PURE__ */ m(
          QJ,
          {
            ...o ? {
              eventSlug: r,
              isTeamEvent: !0,
              teamId: o || 0,
              username: ""
            } : {
              eventSlug: r,
              username: i ?? "",
              isTeamEvent: !1
            },
            routingFormSearchParams: d,
            defaultFormValues: a,
            teamMemberEmail: s,
            crmOwnerRecordType: c,
            crmAppSlug: l,
            onDryRunSuccess: () => {
              u ? u() : window.location.href = "https://app.cal.com/booking/dry-run-successful";
            },
            ..._
          }
        )
      }
    );
  }
  return (e == null ? void 0 : e.routingFormUrl) === void 0 ? /* @__PURE__ */ m(
    qU,
    {
      clientId: "cm165l146000nqi1mrz8vscja",
      isEmbed: !0,
      organizationId: e == null ? void 0 : e.organizationId,
      options: {
        apiUrl: "https://api.cal.com/v2"
      },
      children: /* @__PURE__ */ m(QJ, { ...e })
    }
  ) : /* @__PURE__ */ m(Ce, {});
}, jKl = ve.memo(
  ({
    formId: e,
    formResponsesURLParams: t,
    onExternalRedirect: n,
    onDisplayBookerEmbed: o,
    renderMessage: r,
    onSubmitFormStart: i,
    onSubmitFormEnd: a,
    renderLoader: s,
    bookerProps: c
  }) => {
    const [l, d] = ze(), [u, _] = ze(), [p, f] = ze(), [g, h] = ze();
    ve.useEffect(() => {
      if (!l) {
        d(!0), h(!1), f(void 0), _("");
        const v = "https://api.cal.com/v2";
        i == null || i(), fetch(`${v}/router/forms/${e}/submit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: t ? JSON.stringify(Object.fromEntries(t)) : void 0
        }).then(async ($) => {
          var S;
          const k = await $.json();
          k.redirect ? _(k.data) : f({ message: ((S = k.data) == null ? void 0 : S.message) ?? "" });
        }).catch(($) => {
          console.error($), h(!0);
        }).finally(() => {
          d(!1), a == null || a();
        });
      }
    }, []);
    const b = !!u;
    if (l && s)
      return /* @__PURE__ */ m(Ce, { children: s == null ? void 0 : s(l) });
    if (l || g)
      return /* @__PURE__ */ m(Ce, {});
    if (!l && b && u) {
      const v = new URLSearchParams(u);
      if (v.get("cal.action") === "eventTypeRedirectUrl")
        return o == null || o(), /* @__PURE__ */ m(qKl, { routingFormUrl: u, ...c });
      if (v.get("cal.action") === "externalRedirectUrl")
        return n == null || n(), window.location.href = u, /* @__PURE__ */ m(Ce, {});
    }
    return !b && (p != null && p.message) ? r ? /* @__PURE__ */ m(Ce, { children: r(p == null ? void 0 : p.message) }) : /* @__PURE__ */ m("div", { className: "mx-auto my-0 max-w-3xl md:my-24", children: /* @__PURE__ */ m("div", { className: "w-full max-w-4xl ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m("div", { className: "text-default bg-default -mx-4 rounded-sm border border-neutral-200 p-4 py-6 sm:mx-0 sm:px-8", children: /* @__PURE__ */ m("div", { children: p == null ? void 0 : p.message }) }) }) }) : /* @__PURE__ */ m(Ce, {});
  }
);
jKl.displayName = "RouterAtom";
const FKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: (r) => {
      const { id: i, calendar: a } = r, s = {
        id: i
      };
      return He.post(`/calendars/${a}/disconnect`, s).then((c) => c.data);
    },
    onSuccess: (r) => {
      r.status === qt ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [s9] });
    }
  });
}, VKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => {
    const { delegationCredentialId: r, ...i } = o;
    return He.post("/selected-calendars", {
      ...i,
      ...r ? { delegationCredentialId: r } : {}
    }).then((a) => a.data);
  },
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), BKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => Yo({
  mutationFn: (o) => {
    const { credentialId: r, externalId: i, integration: a, delegationCredentialId: s } = o;
    return He.delete(
      `/selected-calendars?credentialId=${r}&integration=${a}&externalId=${encodeURIComponent(
        i
      )}${s ? `&delegationCredentialId=${s}` : ""}`
    ).then((c) => c.data);
  },
  onSuccess: (o) => {
    o.status === qt ? e == null || e(o) : t == null || t(o);
  },
  onError: (o) => {
    t == null || t(o);
  }
}), UKl = "use-teams", WKl = () => {
  const { organizationId: e } = po(), t = `/organizations/${e}/teams/me`;
  return go({
    queryKey: [UKl, e],
    queryFn: async () => He == null ? void 0 : He.get(t).then((o) => {
      if (o.data.status === qt)
        return o.data.data;
      throw new Error(o.data.error.message);
    }),
    enabled: !!e
  });
};
function zbe(e) {
  var r, i, a;
  const { query: t } = e, { isLocaleReady: n } = Fe(), o = e.customLoader || /* @__PURE__ */ m(FAc, {});
  return n ? t.status === "pending" ? ((i = e.loading) == null ? void 0 : i.call(e, t)) ?? o : t.status === "success" ? "empty" in e && (t.data == null || Array.isArray(t.data) && t.data.length === 0) ? e.empty(t) : e.success(t) : t.status === "error" ? ((a = e.error) == null ? void 0 : a.call(e, t)) ?? /* @__PURE__ */ m(sa, { severity: "error", title: "Something went wrong", message: t.error.message }) : null : ((r = e.loading) == null ? void 0 : r.call(e, t.status === "pending" ? t : null)) ?? o;
}
const GKl = (e) => {
  const { t } = Fe(), {
    logo: n,
    title: o,
    description: r,
    actions: i,
    isDefault: a,
    isTemplate: s,
    invalidCredential: c,
    children: l,
    credentialOwner: d,
    className: u,
    classNameObject: _,
    highlight: p
  } = e;
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        p && "dark:bg-muted bg-yellow-100",
        u || (_ == null ? void 0 : _.container)
      ),
      children: [
        /* @__PURE__ */ Y("div", { className: "flex items-start gap-x-3 px-4 py-4 sm:px-6", children: [
          n ? /* @__PURE__ */ m(
            "img",
            {
              className: ae(n.includes("-dark") && "dark:invert", "h-10 w-10 flex-shrink-0"),
              src: n,
              alt: `${o} logo`
            }
          ) : null,
          /* @__PURE__ */ Y("div", { className: "flex min-w-0 grow flex-col gap-y-1", children: [
            /* @__PURE__ */ Y("div", { className: "flex items-center gap-x-2", children: [
              /* @__PURE__ */ m(
                "h3",
                {
                  className: ae("text-emphasis truncate text-sm font-semibold", _ == null ? void 0 : _.title),
                  children: o
                }
              ),
              /* @__PURE__ */ Y("div", { className: "flex flex-shrink-0 items-center gap-x-2", children: [
                a && /* @__PURE__ */ m(Nr, { variant: "green", children: t("default") }),
                s && /* @__PURE__ */ m(Nr, { variant: "red", children: "Template" })
              ] })
            ] }),
            /* @__PURE__ */ m(
              kL,
              {
                component: "p",
                className: ae("whitespace-normal break-words", _ == null ? void 0 : _.description),
                children: r
              }
            ),
            c && /* @__PURE__ */ Y("div", { className: "flex gap-x-2 pt-2", children: [
              /* @__PURE__ */ m(ot, { name: "circle-alert", className: "h-8 w-8 flex-shrink-0 text-red-500 sm:h-4 sm:w-4" }),
              /* @__PURE__ */ m(kL, { component: "p", className: "whitespace-pre-wrap break-words text-red-500", children: t("invalid_credential", { appName: o }) })
            ] })
          ] }),
          d && /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: /* @__PURE__ */ m(Nr, { variant: "gray", children: /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              wl,
              {
                className: "mr-2",
                alt: d.name || "Nameless",
                size: "xs",
                imageSrc: GA(d.avatar, d == null ? void 0 : d.name)
              }
            ),
            d.name
          ] }) }) }),
          i && /* @__PURE__ */ m("div", { className: "flex-shrink-0", children: i })
        ] }),
        /* @__PURE__ */ m("div", { className: "w-full", children: l })
      ]
    }
  );
};
function HKl(e) {
  const {
    externalId: t,
    name: n,
    isLoading: o,
    translations: r = {
      spanText: "Adding events to"
    },
    children: i
  } = e;
  return /* @__PURE__ */ Y("div", { className: ae("my-2 flex flex-row items-center"), children: [
    /* @__PURE__ */ m("div", { className: "flex pl-2", children: i }),
    /* @__PURE__ */ m("label", { className: "ml-3 text-sm font-medium leading-5", htmlFor: t, children: n }),
    !!e.destination && /* @__PURE__ */ Y("span", { className: "bg-subtle text-default ml-8 inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-normal sm:ml-4", children: [
      /* @__PURE__ */ m(ot, { name: "arrow-left", className: "h-4 w-4" }),
      r.spanText
    ] }),
    o && /* @__PURE__ */ m(ot, { name: "rotate-cw", className: "text-muted h-4 w-4 animate-spin ltr:ml-1 rtl:mr-1" })
  ] });
}
const KKl = ({
  label: e,
  trashIcon: t,
  isGlobal: n,
  isModalOpen: o = !1,
  onModalOpen: r,
  onDeletionConfirmation: i,
  buttonProps: a,
  disabled: s
}) => {
  const { t: c } = Fe();
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(Ff, { open: o, onOpenChange: r, children: [
    /* @__PURE__ */ m(W0, { asChild: !0, children: /* @__PURE__ */ m(
      ut,
      {
        color: (a == null ? void 0 : a.color) || "destructive",
        StartIcon: t ? "trash" : void 0,
        size: "base",
        variant: t && !e ? "icon" : "button",
        disabled: n || s,
        ...a,
        children: e
      }
    ) }),
    /* @__PURE__ */ m(
      Vf,
      {
        variety: "danger",
        title: c("remove_app"),
        confirmBtnText: c("yes_remove_app"),
        onConfirm: i,
        children: /* @__PURE__ */ m("p", { className: "mt-5", children: c("are_you_sure_you_want_to_remove_this_app") })
      }
    )
  ] }) });
}, xL = (e) => /* @__PURE__ */ m("div", { className: uo("border-subtle mt-6 rounded-lg border", e.classNames), children: e.children }), YKl = ({
  classNames: e = "mx-5 mb-6",
  calendarRedirectUrls: t,
  allowDelete: n,
  isDryRun: o,
  classNamesObject: r
}) => {
  const { t: i } = Fe(), a = Qv({});
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
    zbe,
    {
      query: a,
      success: ({ data: s }) => {
        var l;
        const c = s.destinationCalendar.externalId;
        return s.connectedCalendars.length ? /* @__PURE__ */ Y(xL, { classNames: (r == null ? void 0 : r.container) || e, children: [
          /* @__PURE__ */ m(
            JJ,
            {
              classNames: r == null ? void 0 : r.header,
              calendarRedirectUrls: t,
              isDryRun: o
            }
          ),
          /* @__PURE__ */ m(
            WF,
            {
              noBorderTreatment: !0,
              className: ((l = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : l.container) || "p-6 pt-2",
              children: s.connectedCalendars.map((d) => {
                var u, _, p, f, g, h, b, v, $, k, S, O, I, D, M, N, C;
                return d.calendars && d.calendars.length > 0 ? /* @__PURE__ */ m(
                  GKl,
                  {
                    shouldHighlight: !0,
                    slug: d.integration.slug,
                    title: d.integration.name,
                    logo: `https://app.cal.com${d.integration.logo}`,
                    description: ((u = d.primary) == null ? void 0 : u.email) ?? d.integration.description,
                    classNameObject: {
                      container: ae(
                        "border-subtle mt-4 rounded-lg border",
                        (p = (_ = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : _.selectedCalendar) == null ? void 0 : p.container
                      ),
                      title: (h = (g = (f = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : f.selectedCalendar) == null ? void 0 : g.header) == null ? void 0 : h.title,
                      description: ($ = (v = (b = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : b.selectedCalendar) == null ? void 0 : v.header) == null ? void 0 : $.description
                    },
                    actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: n && !d.delegationCredentialId && /* @__PURE__ */ m(
                      XJ,
                      {
                        credentialId: d.credentialId,
                        trashIcon: !0,
                        buttonProps: { className: "border border-default" },
                        slug: d.integration.slug,
                        isDryRun: o
                      }
                    ) }),
                    children: /* @__PURE__ */ Y(
                      "div",
                      {
                        className: ae(
                          "border-subtle border-t",
                          (O = (S = (k = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : k.selectedCalendar) == null ? void 0 : S.body) == null ? void 0 : O.container
                        ),
                        children: [
                          /* @__PURE__ */ m(
                            "p",
                            {
                              className: ae(
                                "text-subtle px-5 pt-4 text-sm",
                                (M = (D = (I = r == null ? void 0 : r.selectedCalendarsListClassNames) == null ? void 0 : I.selectedCalendar) == null ? void 0 : D.body) == null ? void 0 : M.description
                              ),
                              children: i("toggle_calendars_conflict")
                            }
                          ),
                          /* @__PURE__ */ m("ul", { className: "space-y-4 px-5 py-4", children: (N = d.calendars) == null ? void 0 : N.map((P) => /* @__PURE__ */ m(
                            ZKl,
                            {
                              externalId: P.externalId,
                              title: P.name || "Nameless calendar",
                              name: P.name || "Nameless calendar",
                              type: d.integration.type,
                              isChecked: P.isSelected,
                              destination: P.externalId === c,
                              credentialId: P.credentialId,
                              delegationCredentialId: d.delegationCredentialId,
                              eventTypeId: null,
                              isDryRun: o
                            },
                            P.externalId
                          )) })
                        ]
                      }
                    )
                  },
                  `list-${d.credentialId}-${d.integration.slug}`
                ) : /* @__PURE__ */ m(
                  sa,
                  {
                    severity: "warning",
                    title: i("something_went_wrong"),
                    message: /* @__PURE__ */ m("span", { children: ((C = d.error) == null ? void 0 : C.message) || i("calendar_error") }),
                    iconClassName: "h-10 w-10 ml-2 mr-1 mt-0.5",
                    actions: !d.delegationCredentialId && /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
                      XJ,
                      {
                        credentialId: d.credentialId,
                        trashIcon: !0,
                        buttonProps: { className: "border border-default" },
                        slug: d.integration.slug,
                        isDryRun: o
                      }
                    ) })
                  },
                  `alert-${d.credentialId}`
                );
              })
            }
          )
        ] }) : /* @__PURE__ */ Y(xL, { classNames: (r == null ? void 0 : r.container) || e, children: [
          /* @__PURE__ */ m(
            JJ,
            {
              classNames: r == null ? void 0 : r.header,
              calendarRedirectUrls: t,
              isDryRun: o
            }
          ),
          /* @__PURE__ */ m(
            "h1",
            {
              className: ae(
                "px-6 py-4 text-base leading-5",
                r == null ? void 0 : r.noSelectedCalendarsMessage
              ),
              children: "No connected calendars found."
            }
          )
        ] });
      }
    }
  ) }) });
}, JJ = ({
  calendarRedirectUrls: e,
  isDryRun: t,
  classNames: n
}) => {
  const { t: o } = Fe();
  return /* @__PURE__ */ m("div", { className: ae("border-subtle border-b p-6", n == null ? void 0 : n.container), children: /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("h4", { className: ae("text-emphasis text-base font-semibold leading-5", n == null ? void 0 : n.title), children: o("check_for_conflicts") }),
      /* @__PURE__ */ m("p", { className: ae("text-default text-sm leading-tight", n == null ? void 0 : n.description), children: o("select_calendars") })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex flex-col xl:flex-row xl:space-x-5", children: /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m(
      QKl,
      {
        calendarRedirectUrls: e,
        isDryRun: t
      }
    ) }) })
  ] }) });
}, XJ = (e) => {
  const { t } = Fe(), { onSuccess: n, credentialId: o, slug: r } = e, [i, a] = ze(!1), { toast: s } = C_(), { mutate: c } = FKl({
    onSuccess: () => {
      s({
        description: t("app_removed_successfully")
      }), a(!1), n && n();
    },
    onError: () => {
      s({
        description: t("error_removing_app")
      }), a(!1);
    }
  });
  return /* @__PURE__ */ m(
    KKl,
    {
      onDeletionConfirmation: async () => {
        !e.isDryRun && a(!1), e.isDryRun && s({
          description: t("app_removed_successfully")
        }), !e.isDryRun && r && await c({
          calendar: r.split("-")[0],
          id: o
        });
      },
      ...e,
      isModalOpen: i,
      onModalOpen: () => a((l) => !l)
    }
  );
}, ZKl = (e) => {
  const { isChecked: t, title: n, credentialId: o, type: r, externalId: i, delegationCredentialId: a } = e, [s, c] = ze(t), { toast: l } = C_(), { mutate: d, isPending: u } = VKl({
    onError: (g) => {
      l({
        description: `Something went wrong while adding calendar - ${n}. ${g}`
      });
    }
  }), { mutate: _, isPending: p } = BKl(
    {
      onError: (g) => {
        l({
          description: `Something went wrong while removing calendar - ${n}. ${g}`
        });
      }
    }
  ), f = async ({
    isOn: g,
    credentialId: h,
    integration: b,
    externalId: v
  }) => {
    g ? await d({ credentialId: h, integration: b, externalId: v, delegationCredentialId: a }) : await _({
      credentialId: h,
      integration: b,
      externalId: v,
      delegationCredentialId: a
    });
  };
  return /* @__PURE__ */ m(
    HKl,
    {
      destination: e.destination,
      ...e,
      isChecked: s,
      isLoading: u || p,
      children: /* @__PURE__ */ m(
        Ri,
        {
          checked: s,
          id: i,
          onCheckedChange: async () => {
            c((g) => !g), e.isDryRun || await f({
              isOn: !s,
              credentialId: o,
              externalId: i,
              integration: r
            });
          }
        }
      )
    }
  );
}, QKl = ({
  calendarRedirectUrls: e,
  isDryRun: t
}) => {
  const { t: n } = Fe(), { refetch: o } = Qv({});
  return /* @__PURE__ */ Y(El, { modal: !1, children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { StartIcon: "plus", color: "secondary", className: "md:rounded-md", children: n("add") }) }),
    /* @__PURE__ */ m(Uc, { className: "w-auto", children: /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        fce,
        {
          isDryRun: t,
          isMultiCalendar: !0,
          isClickable: !0,
          tooltip: /* @__PURE__ */ m(Ce, {}),
          redir: (e == null ? void 0 : e.google) ?? window.location.href,
          label: n("add_calendar_label", { calendar: "Google" }),
          loadingLabel: n("add_calendar_label", { calendar: "Google" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Google" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        Abe,
        {
          isDryRun: t,
          isMultiCalendar: !0,
          isClickable: !0,
          tooltip: /* @__PURE__ */ m(Ce, {}),
          redir: (e == null ? void 0 : e.outlook) ?? window.location.href,
          label: n("add_calendar_label", { calendar: "Outlook" }),
          loadingLabel: n("add_calendar_label", { calendar: "Outlook" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Outlook" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
        Cbe,
        {
          isDryRun: t,
          onSuccess: o,
          isClickable: !0,
          isMultiCalendar: !0,
          tooltip: /* @__PURE__ */ m(Ce, {}),
          label: n("add_calendar_label", { calendar: "Apple" }),
          loadingLabel: n("add_calendar_label", { calendar: "Apple" }),
          alreadyConnectedLabel: n("add_calendar_label", { calendar: "Apple" }),
          className: "hover:bg-subtle hover:text-default cursor-pointer border-none bg-inherit text-inherit md:rounded-md"
        }
      ) })
    ] }) })
  ] });
}, JKl = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: (r) => He.put("/destination-calendars", r).then((i) => i.data),
    onSuccess: (r) => {
      r.status === qt ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    },
    onSettled: () => {
      n.invalidateQueries({ queryKey: [s9] });
    }
  });
}, Obe = ({ ...e }) => {
  const { label: t, subtitle: n } = e.data;
  return /* @__PURE__ */ Y(sd.SingleValue, { ...e, className: "flex space-x-1", children: [
    /* @__PURE__ */ m("p", { children: t }),
    " ",
    /* @__PURE__ */ m("p", { className: " text-subtle", children: n })
  ] });
}, Pbe = ({ ...e }) => {
  const { label: t } = e.data;
  return /* @__PURE__ */ m(sd.Option, { ...e, children: /* @__PURE__ */ Y("div", { className: "flex", children: [
    /* @__PURE__ */ m("span", { className: "mr-auto", children: t }),
    e.isSelected && /* @__PURE__ */ m(ot, { name: "check", className: "ml-2 h-4 w-4" })
  ] }) });
}, XKl = ({
  onChange: e,
  isPending: t,
  value: n,
  hidePlaceholder: o,
  hideAdvancedText: r,
  maxWidth: i,
  calendarsQueryData: a,
  customClassNames: s
}) => {
  const { t: c } = Fe(), l = a == null ? void 0 : a.connectedCalendars, d = a == null ? void 0 : a.destinationCalendar, [u, _] = ze(null), p = (g = !1) => g ? {} : {
    alignItems: "center",
    width: "100%",
    display: "flex",
    ":before": {
      content: `'${c("create_events_on")}:'`,
      display: "block",
      marginRight: 8
    }
  };
  if (Le(() => {
    var h, b;
    const g = l == null ? void 0 : l.map((v) => v.calendars ?? []).flat().find((v) => v.externalId === n);
    if (g) {
      const v = l == null ? void 0 : l.find(
        ($) => {
          var k;
          return (k = $.calendars) == null ? void 0 : k.some((S) => S.externalId === g.externalId);
        }
      );
      _({
        value: `${g.integration}:${g.externalId}`,
        label: `${g.name} ` || "",
        subtitle: `(${(h = v == null ? void 0 : v.integration.title) == null ? void 0 : h.replace(/calendar/i, "")} - ${(b = v == null ? void 0 : v.primary) == null ? void 0 : b.name})`
      });
    }
  }, [l]), !(l != null && l.length))
    return null;
  const f = (l == null ? void 0 : l.map((g) => {
    var h, b, v, $;
    return {
      key: g.credentialId,
      label: `${(h = g.integration.title) == null ? void 0 : h.replace(/calendar/i, "")} (${((b = g.primary) == null ? void 0 : b.integration) === "office365_calendar" ? (v = g.primary) == null ? void 0 : v.email : ($ = g.primary) == null ? void 0 : $.name})`,
      options: (g.calendars ?? []).filter((k) => k.readOnly === !1).map((k) => {
        var S, O;
        return {
          label: ` ${k.name} `,
          subtitle: `(${(S = g == null ? void 0 : g.integration.title) == null ? void 0 : S.replace(/calendar/i, "")} - ${(O = g == null ? void 0 : g.primary) == null ? void 0 : O.name})`,
          value: `${k.integration}:${k.externalId}`
        };
      })
    };
  })) ?? [];
  return /* @__PURE__ */ Y(
    "div",
    {
      className: "relative table w-full table-fixed",
      title: `${c("create_events_on")}: ${(u == null ? void 0 : u.label) || ""}`,
      children: [
        /* @__PURE__ */ m(
          Tr,
          {
            name: "primarySelectedCalendar",
            placeholder: o ? /* @__PURE__ */ Y("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
              /* @__PURE__ */ m(Nr, { variant: "blue", children: "Default" }),
              " ",
              (d == null ? void 0 : d.name) && `${d.name} (${d == null ? void 0 : d.integrationTitle} - ${d.primaryEmail})`
            ] }) : `${c("create_events_on")}`,
            options: f,
            styles: {
              placeholder: (g) => ({ ...g, ...p(o) }),
              singleValue: (g) => ({ ...g, ...p(o) }),
              control: (g) => ({
                ...g,
                "@media only screen and (min-width: 640px)": {
                  ...g["@media only screen and (min-width: 640px)"],
                  maxWidth: i
                }
              })
            },
            isSearchable: !1,
            className: ci(
              "border-default my-2 block w-full min-w-0 flex-1 rounded-none rounded-r-sm text-sm",
              s == null ? void 0 : s.select
            ),
            innerClassNames: s == null ? void 0 : s.innerClassNames,
            onChange: (g) => {
              if (_(g), !g)
                return;
              const [h, b] = g.value.split(/:(.+)/);
              e({
                integration: h,
                externalId: b
              });
            },
            isLoading: t,
            value: u,
            components: { SingleValue: Obe, Option: Pbe },
            isMulti: !1
          }
        ),
        r ? null : /* @__PURE__ */ m("p", { className: "text-sm leading-tight", children: c("you_can_override_calendar_in_advanced_tab") })
      ]
    }
  );
}, eX = (e = !1, t = "Create events on") => e ? {} : {
  alignItems: "center",
  width: "100%",
  display: "flex",
  ":before": {
    content: t,
    display: "block",
    marginRight: 8
  }
}, eYl = ({
  connectedCalendars: e,
  destinationCalendar: t,
  onChange: n,
  isPending: o,
  value: r,
  hidePlaceholder: i,
  hideAdvancedText: a,
  maxWidth: s
}) => {
  const { t: c } = Fe(), [l, d] = ze(null);
  Le(() => {
    var p, f;
    const _ = e.map((g) => g.calendars ?? []).flat().find((g) => g.externalId === r);
    if (_) {
      const g = e.find(
        (h) => {
          var b;
          return (b = h.calendars) == null ? void 0 : b.some((v) => v.externalId === _.externalId);
        }
      );
      d({
        value: `${_.integration}:${_.externalId}`,
        label: `${_.name} ` || "",
        subtitle: `(${(p = g == null ? void 0 : g.integration.title) == null ? void 0 : p.replace(/calendar/i, "")} - ${(f = g == null ? void 0 : g.primary) == null ? void 0 : f.name})`
      });
    }
  }, [e]);
  const u = Tt(() => e.map((_) => {
    var p, f, g, h;
    return {
      key: _.credentialId,
      label: `${(p = _.integration.title) == null ? void 0 : p.replace(/calendar/i, "")} (${((f = _.primary) == null ? void 0 : f.integration) === "office365_calendar" ? (g = _.primary) == null ? void 0 : g.email : (h = _.primary) == null ? void 0 : h.name})`,
      options: (_.calendars ?? []).filter((b) => b.readOnly === !1).map((b) => {
        var v, $;
        return {
          label: ` ${b.name} `,
          subtitle: `(${(v = _ == null ? void 0 : _.integration.title) == null ? void 0 : v.replace(/calendar/i, "")} - ${($ = _ == null ? void 0 : _.primary) == null ? void 0 : $.name})`,
          value: `${b.integration}:${b.externalId}`,
          delegationCredentialId: b.delegationCredentialId || void 0
        };
      })
    };
  }) ?? [], [e]);
  return /* @__PURE__ */ Y(
    "div",
    {
      className: "relative table w-full table-fixed",
      title: `${c("create_events_on")}: ${(l == null ? void 0 : l.label) || ""}`,
      children: [
        /* @__PURE__ */ m(
          Tr,
          {
            name: "primarySelectedCalendar",
            placeholder: i ? /* @__PURE__ */ Y("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
              /* @__PURE__ */ m(Nr, { variant: "blue", children: "Default" }),
              " ",
              (t == null ? void 0 : t.primaryEmail) && `${t.name} (${t == null ? void 0 : t.integrationTitle} - ${t.primaryEmail})`
            ] }) : `${c("create_events_on")}`,
            options: u,
            styles: {
              placeholder: (_) => ({
                ..._,
                ...eX(i, `'${c("create_events_on")}:'`)
              }),
              singleValue: (_) => ({
                ..._,
                ...eX(i, `'${c("create_events_on")}:'`)
              }),
              control: (_) => ({
                ..._,
                "@media only screen and (min-width: 640px)": {
                  ..._["@media only screen and (min-width: 640px)"],
                  maxWidth: s
                }
              })
            },
            isSearchable: !1,
            className: ae(
              "border-default my-2 block w-full min-w-0 flex-1 rounded-none rounded-r-sm text-sm"
            ),
            onChange: (_) => {
              if (d(_), !_)
                return;
              const [p, f] = _.value.split(/:(.+)/);
              n({
                integration: p,
                externalId: f,
                delegationCredentialId: _.delegationCredentialId
              });
            },
            isLoading: o,
            value: l,
            components: { SingleValue: Obe, Option: Pbe },
            isMulti: !1
          }
        ),
        a ? null : /* @__PURE__ */ m("p", { className: "text-sm leading-tight", children: c("you_can_override_calendar_in_advanced_tab") })
      ]
    }
  );
}, tYl = (e) => {
  var n, o;
  const { t } = Fe();
  return /* @__PURE__ */ Y(
    "div",
    {
      className: uo(
        "border-subtle mb-6 mt-8 rounded-lg border",
        (e == null ? void 0 : e.classNames) || ((n = e == null ? void 0 : e.classNamesObject) == null ? void 0 : n.container)
      ),
      children: [
        /* @__PURE__ */ m(nYl, { classNames: (o = e.classNamesObject) == null ? void 0 : o.header }),
        /* @__PURE__ */ m("div", { className: "border-t", children: /* @__PURE__ */ m("div", { className: "border-subtle flex w-full flex-col space-y-3 border-y-0 p-6", children: /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ m(Xn, { className: "text-default mb-0 font-medium", children: t("add_events_to") }),
          /* @__PURE__ */ m(eYl, { ...e })
        ] }) }) })
      ]
    }
  );
}, nYl = ({ classNames: e }) => {
  const { t } = Fe();
  return /* @__PURE__ */ Y("div", { className: uo("p-6", e == null ? void 0 : e.container), children: [
    /* @__PURE__ */ m("h2", { className: uo("text-emphasis mb-1 text-base font-bold leading-5 tracking-wide", e == null ? void 0 : e.title), children: t("add_to_calendar") }),
    /* @__PURE__ */ m("p", { className: uo("text-subtle text-sm leading-tight", e == null ? void 0 : e.description), children: t("add_to_calendar_description") })
  ] });
}, oYl = ({
  statusLoader: e,
  classNames: t = "mx-5",
  classNamesObject: n,
  isDryRun: o = !1
}) => {
  var s;
  const r = Qv({}), { mutate: i, isPending: a } = JKl();
  return r.isLoading ? /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(Ce, { children: [
    e,
    !e && /* @__PURE__ */ m("h1", { className: "m-5 text-xl font-semibold", children: "Loading..." })
  ] }) }) : !((s = r.data) != null && s.connectedCalendars) || r.data.connectedCalendars.length < 1 ? null : /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    tYl,
    {
      classNames: t,
      classNamesObject: n,
      connectedCalendars: r.data.connectedCalendars,
      destinationCalendar: r.data.destinationCalendar,
      value: r.data.destinationCalendar.externalId,
      hidePlaceholder: !0,
      hideAdvancedText: !0,
      onChange: async ({ externalId: c, integration: l, delegationCredentialId: d }) => {
        o || await i({
          integration: l,
          externalId: c,
          delegationCredentialId: d
        });
      },
      isPending: a
    }
  ) });
}, yfd = ({
  classNames: e,
  calendarRedirectUrls: t,
  allowDelete: n = !0,
  isDryRun: o
}) => /* @__PURE__ */ Y("div", { className: e == null ? void 0 : e.calendarSettingsCustomClassnames, children: [
  /* @__PURE__ */ m(
    oYl,
    {
      statusLoader: /* @__PURE__ */ m(Ce, {}),
      classNames: e == null ? void 0 : e.destinationCalendarSettingsCustomClassnames,
      classNamesObject: e == null ? void 0 : e.destinationCalendarSettingsClassNames,
      isDryRun: o
    }
  ),
  /* @__PURE__ */ m(
    YKl,
    {
      classNames: e == null ? void 0 : e.selectedCalendarSettingsCustomClassnames,
      calendarRedirectUrls: t,
      allowDelete: n,
      isDryRun: o,
      classNamesObject: e == null ? void 0 : e.selectedCalendarSettingsClassNames
    }
  )
] });
var rYl = hd, iYl = JA, aYl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, sYl = /^\w*$/;
function cYl(e, t) {
  if (rYl(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || iYl(e) ? !0 : sYl.test(e) || !aYl.test(e) || t != null && e in Object(t);
}
var HF = cYl, lYl = gd, dYl = lYl["__core-js_shared__"], uYl = dYl, h5 = uYl, tX = function() {
  var e = /[^.]+$/.exec(h5 && h5.keys && h5.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _Yl(e) {
  return !!tX && tX in e;
}
var pYl = _Yl, v5, nX;
function Ibe() {
  if (nX)
    return v5;
  nX = 1;
  var e = Function.prototype, t = e.toString;
  function n(o) {
    if (o != null) {
      try {
        return t.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return v5 = n, v5;
}
var mYl = Vj, fYl = pYl, gYl = Al, hYl = Ibe(), vYl = /[\\^$.*+?()[\]{}|]/g, bYl = /^\[object .+?Constructor\]$/, yYl = Function.prototype, $Yl = Object.prototype, wYl = yYl.toString, kYl = $Yl.hasOwnProperty, SYl = RegExp(
  "^" + wYl.call(kYl).replace(vYl, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function xYl(e) {
  if (!gYl(e) || fYl(e))
    return !1;
  var t = mYl(e) ? SYl : bYl;
  return t.test(hYl(e));
}
var EYl = xYl;
function TYl(e, t) {
  return e == null ? void 0 : e[t];
}
var AYl = TYl, CYl = EYl, zYl = AYl;
function OYl(e, t) {
  var n = zYl(e, t);
  return CYl(n) ? n : void 0;
}
var hg = OYl, PYl = hg, IYl = PYl(Object, "create"), AC = IYl, oX = AC;
function RYl() {
  this.__data__ = oX ? oX(null) : {}, this.size = 0;
}
var NYl = RYl;
function DYl(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var MYl = DYl, LYl = AC, qYl = "__lodash_hash_undefined__", jYl = Object.prototype, FYl = jYl.hasOwnProperty;
function VYl(e) {
  var t = this.__data__;
  if (LYl) {
    var n = t[e];
    return n === qYl ? void 0 : n;
  }
  return FYl.call(t, e) ? t[e] : void 0;
}
var BYl = VYl, UYl = AC, WYl = Object.prototype, GYl = WYl.hasOwnProperty;
function HYl(e) {
  var t = this.__data__;
  return UYl ? t[e] !== void 0 : GYl.call(t, e);
}
var KYl = HYl, YYl = AC, ZYl = "__lodash_hash_undefined__";
function QYl(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = YYl && t === void 0 ? ZYl : t, this;
}
var JYl = QYl, XYl = NYl, eZl = MYl, tZl = BYl, nZl = KYl, oZl = JYl;
function hb(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
hb.prototype.clear = XYl;
hb.prototype.delete = eZl;
hb.prototype.get = tZl;
hb.prototype.has = nZl;
hb.prototype.set = oZl;
var rZl = hb;
function iZl() {
  this.__data__ = [], this.size = 0;
}
var aZl = iZl, b5, rX;
function pk() {
  if (rX)
    return b5;
  rX = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return b5 = e, b5;
}
var sZl = pk();
function cZl(e, t) {
  for (var n = e.length; n--; )
    if (sZl(e[n][0], t))
      return n;
  return -1;
}
var CC = cZl, lZl = CC, dZl = Array.prototype, uZl = dZl.splice;
function _Zl(e) {
  var t = this.__data__, n = lZl(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : uZl.call(t, n, 1), --this.size, !0;
}
var pZl = _Zl, mZl = CC;
function fZl(e) {
  var t = this.__data__, n = mZl(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var gZl = fZl, hZl = CC;
function vZl(e) {
  return hZl(this.__data__, e) > -1;
}
var bZl = vZl, yZl = CC;
function $Zl(e, t) {
  var n = this.__data__, o = yZl(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var wZl = $Zl, kZl = aZl, SZl = pZl, xZl = gZl, EZl = bZl, TZl = wZl;
function vb(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
vb.prototype.clear = kZl;
vb.prototype.delete = SZl;
vb.prototype.get = xZl;
vb.prototype.has = EZl;
vb.prototype.set = TZl;
var zC = vb, AZl = hg, CZl = gd, zZl = AZl(CZl, "Map"), KF = zZl, iX = rZl, OZl = zC, PZl = KF;
function IZl() {
  this.size = 0, this.__data__ = {
    hash: new iX(),
    map: new (PZl || OZl)(),
    string: new iX()
  };
}
var RZl = IZl;
function NZl(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var DZl = NZl, MZl = DZl;
function LZl(e, t) {
  var n = e.__data__;
  return MZl(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var OC = LZl, qZl = OC;
function jZl(e) {
  var t = qZl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var FZl = jZl, VZl = OC;
function BZl(e) {
  return VZl(this, e).get(e);
}
var UZl = BZl, WZl = OC;
function GZl(e) {
  return WZl(this, e).has(e);
}
var HZl = GZl, KZl = OC;
function YZl(e, t) {
  var n = KZl(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var ZZl = YZl, QZl = RZl, JZl = FZl, XZl = UZl, eQl = HZl, tQl = ZZl;
function bb(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
bb.prototype.clear = QZl;
bb.prototype.delete = JZl;
bb.prototype.get = XZl;
bb.prototype.has = eQl;
bb.prototype.set = tQl;
var YF = bb, Rbe = YF, nQl = "Expected a function";
function ZF(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(nQl);
  var n = function() {
    var o = arguments, r = t ? t.apply(this, o) : o[0], i = n.cache;
    if (i.has(r))
      return i.get(r);
    var a = e.apply(this, o);
    return n.cache = i.set(r, a) || i, a;
  };
  return n.cache = new (ZF.Cache || Rbe)(), n;
}
ZF.Cache = Rbe;
var oQl = ZF, rQl = oQl, iQl = 500;
function aQl(e) {
  var t = rQl(e, function(o) {
    return n.size === iQl && n.clear(), o;
  }), n = t.cache;
  return t;
}
var sQl = aQl, cQl = sQl, lQl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, dQl = /\\(\\)?/g, uQl = cQl(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(lQl, function(n, o, r, i) {
    t.push(r ? i.replace(dQl, "$1") : o || n);
  }), t;
}), _Ql = uQl, aX = cb, pQl = Dj, mQl = hd, fQl = JA, gQl = 1 / 0, sX = aX ? aX.prototype : void 0, cX = sX ? sX.toString : void 0;
function Nbe(e) {
  if (typeof e == "string")
    return e;
  if (mQl(e))
    return pQl(e, Nbe) + "";
  if (fQl(e))
    return cX ? cX.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -gQl ? "-0" : t;
}
var Dbe = Nbe, hQl = Dbe;
function vQl(e) {
  return e == null ? "" : hQl(e);
}
var Mbe = vQl, bQl = hd, yQl = HF, $Ql = _Ql, wQl = Mbe;
function kQl(e, t) {
  return bQl(e) ? e : yQl(e, t) ? [e] : $Ql(wQl(e));
}
var yb = kQl, SQl = JA, xQl = 1 / 0;
function EQl(e) {
  if (typeof e == "string" || SQl(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -xQl ? "-0" : t;
}
var $b = EQl, TQl = yb, AQl = $b;
function CQl(e, t) {
  t = TQl(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[AQl(t[n++])];
  return n && n == o ? e : void 0;
}
var PC = CQl, zQl = PC;
function OQl(e, t, n) {
  var o = e == null ? void 0 : zQl(e, t);
  return o === void 0 ? n : o;
}
var Lbe = OQl;
const PQl = /* @__PURE__ */ Zr(Lbe), IQl = (e, [t, n], o, r, i = { simple: !1 }) => e ? /* @__PURE__ */ m(
  Ri,
  {
    "data-testid": `locked-indicator-${o}`,
    onCheckedChange: (a) => {
      n({
        ...t,
        [o]: a
      }), r(o, !a || void 0);
    },
    checked: t[o],
    size: "sm"
  }
) : null, RQl = (e, t, [n, o], r, i, a, s = { simple: !1 }) => {
  const c = n[i], l = r(c ? "locked" : "unlocked"), d = r(
    `${c ? "locked" : "unlocked"}_fields_${t ? "admin" : "member"}_description`
  );
  return (t || e) && /* @__PURE__ */ m(Ao, { content: /* @__PURE__ */ m(Ce, { children: d }), children: /* @__PURE__ */ m("div", { className: "inline", children: /* @__PURE__ */ Y(
    Nr,
    {
      variant: c ? "gray" : "green",
      className: ae(
        "ml-2 transform justify-between p-1",
        t && !s.simple && "w-28"
      ),
      children: [
        !s.simple && /* @__PURE__ */ Y("span", { className: "inline-flex", children: [
          /* @__PURE__ */ m(ot, { name: c ? "lock" : "lock-open", className: "text-subtle h-3 w-3" }),
          /* @__PURE__ */ m("span", { className: "ml-1 font-medium", children: l })
        ] }),
        t && /* @__PURE__ */ m(
          Ri,
          {
            "data-testid": `locked-indicator-${i}`,
            onCheckedChange: (u) => {
              o({
                ...n,
                [i]: u
              }), a(i, !u || void 0);
            },
            checked: c,
            size: "sm"
          }
        )
      ]
    }
  ) }) });
}, NQl = ({
  eventType: e,
  translate: t,
  formMethods: n
}) => {
  var b, v;
  const { setValue: o, getValues: r } = n, [i, a] = ze({}), s = ule.parse(e.metadata), c = ((b = s == null ? void 0 : s.managedEventConfig) == null ? void 0 : b.unlockedFields) !== void 0 && ((v = s == null ? void 0 : s.managedEventConfig) == null ? void 0 : v.unlockedFields) || {}, l = e.schedulingType === aa.MANAGED, d = (s == null ? void 0 : s.managedEventConfig) !== void 0 && e.schedulingType !== aa.MANAGED, u = ($, k) => {
    const S = "metadata.managedEventConfig.unlockedFields", O = r(S);
    O && (k === void 0 ? (delete O[$], o(S, { ...O }, { shouldDirty: !0 })) : o(
      S,
      {
        ...O,
        [$]: k
      },
      { shouldDirty: !0 }
    ));
  }, _ = ($) => {
    var S, O;
    let k = l || d;
    if ($.includes("."))
      k = k && PQl(c, $) === void 0;
    else {
      const I = (O = (S = r("metadata")) == null ? void 0 : S.managedEventConfig) == null ? void 0 : O.unlockedFields, D = !!(I != null && I[$]);
      k = k && !D;
    }
    return k;
  }, p = ($, k) => (typeof i[$] > "u" && a({
    ...i,
    [$]: _($)
  }), RQl(
    d,
    l,
    [i, a],
    t,
    $,
    u,
    k
  ));
  return {
    shouldLockIndicator: p,
    shouldLockDisableProps: ($, k) => (typeof i[$] > "u" && a({
      ...i,
      [$]: _($)
    }), {
      disabled: !l && (s == null ? void 0 : s.managedEventConfig) !== void 0 && c[$] === void 0,
      LockedIcon: p($, k),
      isLocked: i[$]
    }),
    useLockedLabel: ($, k) => {
      typeof i[$] > "u" && a({
        ...i,
        [$]: _($)
      });
      const S = i[$];
      return {
        disabled: !l && (s == null ? void 0 : s.managedEventConfig) !== void 0 && c[$] === void 0,
        LockedIcon: p($, k),
        isLocked: S
      };
    },
    useLockedSwitch: ($, k = { simple: !1 }) => (typeof i[$] > "u" && a({
      ...i,
      [$]: _($)
    }), () => IQl(l, [i, a], $, u, k)),
    isManagedEventType: l,
    isChildrenManagedEventType: d
  };
}, dm = NQl, DQl = globalThis != null && globalThis.document ? ts : () => {
}, qbe = "Collapsible", [MQl, $fd] = os(qbe), [LQl, jbe] = MQl(qbe), G$ = /* @__PURE__ */ it((e, t) => {
  const { __scopeCollapsible: n, open: o, defaultOpen: r, disabled: i, onOpenChange: a, ...s } = e, [c = !1, l] = jc({
    prop: o,
    defaultProp: r,
    onChange: a
  });
  return /* @__PURE__ */ Pe(LQl, {
    scope: n,
    disabled: i,
    contentId: Cc(),
    open: c,
    onOpenToggle: at(
      () => l(
        (d) => !d
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ Pe(io.div, We({
    "data-state": Vbe(c),
    "data-disabled": i ? "" : void 0
  }, s, {
    ref: t
  })));
}), Fbe = "CollapsibleContent", H$ = /* @__PURE__ */ it((e, t) => {
  const { forceMount: n, ...o } = e, r = jbe(Fbe, e.__scopeCollapsible);
  return /* @__PURE__ */ Pe(
    rs,
    {
      present: n || r.open
    },
    ({ present: i }) => /* @__PURE__ */ Pe(qQl, We({}, o, {
      ref: t,
      present: i
    }))
  );
}), qQl = /* @__PURE__ */ it((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...i } = e, a = jbe(Fbe, n), [s, c] = ze(o), l = Ue(null), d = or(t, l), u = Ue(0), _ = u.current, p = Ue(0), f = p.current, g = a.open || s, h = Ue(g), b = Ue();
  return Le(() => {
    const v = requestAnimationFrame(
      () => h.current = !1
    );
    return () => cancelAnimationFrame(v);
  }, []), DQl(() => {
    const v = l.current;
    if (v) {
      b.current = b.current || {
        transitionDuration: v.style.transitionDuration,
        animationName: v.style.animationName
      }, v.style.transitionDuration = "0s", v.style.animationName = "none";
      const $ = v.getBoundingClientRect();
      u.current = $.height, p.current = $.width, h.current || (v.style.transitionDuration = b.current.transitionDuration, v.style.animationName = b.current.animationName), c(o);
    }
  }, [
    a.open,
    o
  ]), /* @__PURE__ */ Pe(io.div, We({
    "data-state": Vbe(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !g
  }, i, {
    ref: d,
    style: {
      "--radix-collapsible-content-height": _ ? `${_}px` : void 0,
      "--radix-collapsible-content-width": f ? `${f}px` : void 0,
      ...e.style
    }
  }), g && r);
});
function Vbe(e) {
  return e ? "open" : "closed";
}
const Bbe = (e, t) => {
  const n = Ro.usePathname(), o = O_(), r = o == null ? void 0 : o.toString();
  let i;
  return r ? i = `${n}?${r}` : i = n, t ? i ? i === e : !1 : i ? i.includes(e) : !1;
}, jQl = function({
  name: e,
  href: t,
  linkShallow: n,
  linkScroll: o,
  avatar: r,
  matchFullPath: i,
  ...a
}) {
  const s = Bbe(t, i) || (a == null ? void 0 : a.isActive), { t: c } = Fe();
  return /* @__PURE__ */ Y(
    Po,
    {
      onClick: (l) => {
        a.onClick && (l.preventDefault(), a.onClick(e));
      },
      href: t,
      shallow: n,
      scroll: o,
      "aria-disabled": a.disabled ? "true" : void 0,
      className: ae(
        s ? "bg-subtle text-emphasis" : "hover:bg-muted hover:text-default text-subtle",
        "inline-flex h-fit items-center justify-center whitespace-nowrap rounded-md p-2 text-sm font-medium leading-none transition md:mb-0",
        a.disabled && "pointer-events-none !opacity-30",
        a.className
      ),
      target: a.target ? a.target : void 0,
      "data-testid": `horizontal-tab-${a["data-testid"]}`,
      "aria-current": s ? "page" : void 0,
      children: [
        a.icon && /* @__PURE__ */ m(
          ot,
          {
            name: a.icon,
            className: ae("-ml-0.5 me-2 hidden h-4 w-4 text-inherit sm:inline-block"),
            "aria-hidden": "true"
          }
        ),
        r && /* @__PURE__ */ m(wl, { size: "xs", imageSrc: r, alt: "avatar", className: "-ml-0.5 me-1" }),
        " ",
        c(e)
      ]
    },
    e
  );
}, FQl = jQl, VQl = function({ tabs: e, linkShallow: t, linkScroll: n, actions: o, ...r }) {
  return /* @__PURE__ */ Y("div", { className: "mb-4 max-w-full lg:mb-5", children: [
    /* @__PURE__ */ m(
      "nav",
      {
        className: "no-scrollbar flex space-x-0.5 overflow-x-scroll rounded-md",
        "aria-label": "Tabs",
        ...r,
        children: e.map((i, a) => /* @__PURE__ */ Pe(FQl, { ...i, key: a, linkShallow: t, linkScroll: n }))
      }
    ),
    o && o
  ] });
}, Ube = VQl, Wbe = ({
  name: e,
  href: t,
  info: n,
  isChild: o,
  disableChevron: r,
  linkShallow: i,
  linkScroll: a,
  ...s
}) => {
  var d;
  const c = Bbe(t) || (s == null ? void 0 : s.isActive), { t: l } = Fe();
  return /* @__PURE__ */ m(Oi, { children: !s.hidden && /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y(
      Po,
      {
        onClick: (u) => {
          s.onClick && (u.preventDefault(), s.onClick(e));
        },
        href: t,
        shallow: i,
        scroll: a,
        "aria-disabled": s.disabled ? "true" : void 0,
        target: s.isExternalLink ? "_blank" : "_self",
        className: ae(
          s.textClassNames || "text-default text-sm font-medium leading-none",
          "hover:bg-subtle [&[aria-current='page']]:bg-subtle [&[aria-current='page']]:text-emphasis group-hover:text-default group flex w-full flex-row items-center rounded-md p-2 transition ",
          s.disabled && "pointer-events-none !opacity-30",
          (o || !s.icon) && "ml-7",
          s.className
        ),
        "data-testid": `vertical-tab-${s["data-testid"]}`,
        "aria-current": c ? "page" : void 0,
        children: [
          s.icon && /* @__PURE__ */ m(
            ot,
            {
              name: s.icon,
              className: ae("me-2 h-4 w-4", s.iconClassName),
              "data-testid": "icon-component"
            }
          ),
          /* @__PURE__ */ Y("div", { className: "h-fit min-w-0 flex-1", children: [
            /* @__PURE__ */ Y("span", { className: "flex items-center gap-2", children: [
              l(e),
              s.isExternalLink ? /* @__PURE__ */ m(ot, { name: "external-link", "data-testid": "external-link" }) : null
            ] }),
            n && // TODO: I don't think having apps-info as a data-test-id is right here as this is meant to be dumb component.
            /* @__PURE__ */ m("p", { "data-testid": "apps-info", className: "mt-1 text-xs font-normal", children: n })
          ] }),
          !r && c && /* @__PURE__ */ m("div", { className: "ml-auto self-center", children: /* @__PURE__ */ m(
            ot,
            {
              name: "chevron-right",
              width: 20,
              height: 20,
              className: "text-default h-auto w-[20px] stroke-[1.5px]",
              "data-testid": "chevron-right"
            }
          ) })
        ]
      },
      e
    ),
    (d = s.children) == null ? void 0 : d.map((u) => /* @__PURE__ */ m(Wbe, { ...u, isChild: !0 }, u.name))
  ] }) }, e);
}, BQl = Wbe, UQl = function({
  tabs: e,
  className: t = "",
  sticky: n,
  linkShallow: o,
  linkScroll: r,
  itemClassname: i,
  iconClassName: a,
  ...s
}) {
  return /* @__PURE__ */ Y(
    "nav",
    {
      className: ae(
        `no-scrollbar flex flex-col space-y-0.5 overflow-scroll ${t}`,
        n && "sticky top-0 -mt-7"
      ),
      style: {
        maxWidth: "256px"
      },
      "aria-label": "Tabs",
      ...s,
      children: [
        n && /* @__PURE__ */ m("div", { className: "pt-6" }),
        s.children,
        e.map((c, l) => /* @__PURE__ */ Pe(
          BQl,
          {
            ...c,
            key: l,
            linkShallow: o,
            linkScroll: r,
            className: i,
            iconClassName: a
          }
        ))
      ]
    }
  );
}, WQl = UQl, QF = () => {
  const e = Bfe();
  return (e == null ? void 0 : e.fullDomain) ?? Si;
}, IC = Bmc, GQl = `${Si}/embed/preview.html`;
var f$ = /* @__PURE__ */ ((e) => (e.auto = "auto", e.light = "light", e.dark = "dark", e))(f$ || {});
function HQl({
  namespace: e,
  mainApiName: t
}) {
  return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(e) ? `${t}.ns.${e}` : `${t}.ns["${e}"]`;
}
function KQl({ mainApiName: e }) {
  return e;
}
function Gbe({ mainApiName: e }) {
  return KQl({ mainApiName: e });
}
function EL({
  namespace: e,
  mainApiName: t
}) {
  return HQl({ mainApiName: t, namespace: e });
}
const Vv = (e) => (e.match(/^\d+$/) && (e = `${e}%`), e), y5 = (e) => dg || e !== Si && e !== C$, YQl = {
  react: {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = Vv(n.width), a = Vv(n.height), s = `${r ? `namespace="${r}"` : ""}`, c = $5(r);
      return Gu`
import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${c ? JSON.stringify(c) : ""});
      ${t}
    })();
  }, [])
  return <Cal ${s}
    calLink="${e}"
    style={{width:"${i}",height:"${a}",overflow:"scroll"}}
    config={${JSON.stringify(n.config)}}
    ${y5(o) ? `calOrigin="${o}"` : ""}
    ${dg ? `embedJsUrl="${IC}"` : ""}
  />;
};`;
    },
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = $5(r), a = JSON.stringify({
        calLink: e,
        ...y5(o) ? { calOrigin: o } : null,
        ...n
      });
      return Gu`
import { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${i ? JSON.stringify(i) : ""});
      ${Gbe({ mainApiName: "cal" })}("floatingButton", ${a});
      ${t}
    })();
  }, [])
};`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = $5(r);
      return Gu`
import { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi(${i ? JSON.stringify(i) : ""});
      ${t}
    })();
  }, [])
  return <button data-cal-namespace="${r}"
    data-cal-link="${e}"
    ${y5(o) ? `data-cal-origin="${o}"` : ""}
    ${`data-cal-config='${JSON.stringify(n.config)}'`}
  >Click me</button>;
};`;
    },
    headless: () => null
  },
  "react-atom": {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Gu`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
// For example: type BookerProps = { eventTypeSlug: string; calUsername: string; /* other props */ };
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Gu`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      var i;
      return Gu`
import { BookerEmbed } from "@calcom/atoms";

// You might need to define or import BookerProps depending on your setup
export default function Booker( props : BookerProps ) {
  return (
    <>
      <BookerEmbed
        // Use the parsed username and event slug from calLink
        eventSlug={eventSlug}
        // layout can be of three types: COLUMN_VIEW, MONTH_VIEW or WEEK_VIEW, 
        // you can choose whichever you prefer
        view="${((i = n.config) == null ? void 0 : i.layout) || "MONTH_VIEW"}"
        username={calUsername}
        customClassNames={{
          bookerContainer: "border-subtle border",
        }}
        onCreateBookingSuccess={() => {
          console.log("booking created successfully");
        }}
      />
    </>
  );
};`;
    },
    headless: () => null
  },
  HTML: {
    inline: ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => Gu`${EL({ namespace: r, mainApiName: "Cal" })}("inline", {
    elementOrSelector:"#my-cal-inline-${r}",
    config: ${JSON.stringify(n.config)},
    calLink: "${e}",
  });

  ${t}`,
    "floating-popup": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => {
      const i = JSON.stringify({
        calLink: e,
        ...n
      });
      return Gu`${EL({
        namespace: r,
        mainApiName: "Cal"
      })}("floatingButton", ${i}); 
  ${t}`;
    },
    "element-click": ({
      calLink: e,
      uiInstructionCode: t,
      previewState: n,
      embedCalOrigin: o,
      namespace: r
    }) => Gu`
  // Important: Please add the following attributes to the element that should trigger the calendar to open upon clicking.
  // \`data-cal-link="${e}"\`
  // data-cal-namespace="${r}"
  // \`data-cal-config='${JSON.stringify(n.config)}'\`

  ${t}`,
    headless: () => null
  }
}, Gu = (e, ...t) => {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (o >= t.length) {
      n.push(r);
      continue;
    }
    const i = t[o], a = [];
    let s = "";
    i.split(`
`).forEach((l) => {
      a.push(l);
    });
    const c = r.split(`
`).at(-1).match(/(^[\t ]*).*$/);
    c && (s = c[1]), n.push(r + a.join(`
${s}`));
  }
  return n.join("");
};
function $5(e) {
  const t = dg ? IC : void 0;
  return e ? { namespace: e, embedLibUrl: t } : { embedLibUrl: t };
}
function ZQl({
  light: e,
  dark: t
}) {
  const o = Object.entries({ light: e, dark: t }).reduce((r, [i, a]) => {
    if (!Object.values(a).some(Boolean))
      return r;
    const s = Object.fromEntries(
      Object.entries(a).filter(([c, l]) => !!l)
    );
    return {
      ...r,
      [i]: s
    };
  }, {});
  if (Object.keys(o).length !== 0)
    return o;
}
function Hbe({
  brandColor: e,
  darkBrandColor: t
}) {
  return ZQl({
    light: { "cal-brand": e },
    dark: { "cal-brand": t }
  });
}
const QQl = () => {
  const { t: e } = Fe();
  return [
    {
      title: e("inline_embed"),
      subtitle: e("load_inline_content"),
      type: "inline",
      illustration: /* @__PURE__ */ Y(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24.5", y: "51", width: "139", height: "163", rx: "1.5", fill: "#F8F8F8" }),
            /* @__PURE__ */ m("rect", { opacity: "0.8", x: "48", y: "74.5", width: "80", height: "8", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "48", y: "86.5", width: "48", height: "4", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "99.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "99.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "113.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "125.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m(
              "path",
              {
                d: "M61 124.5H67V122.5H61V124.5ZM68 125.5V131.5H70V125.5H68ZM67 132.5H61V134.5H67V132.5ZM60 131.5V125.5H58V131.5H60ZM61 132.5C60.4477 132.5 60 132.052 60 131.5H58C58 133.157 59.3431 134.5 61 134.5V132.5ZM68 131.5C68 132.052 67.5523 132.5 67 132.5V134.5C68.6569 134.5 70 133.157 70 131.5H68ZM67 124.5C67.5523 124.5 68 124.948 68 125.5H70C70 123.843 68.6569 122.5 67 122.5V124.5ZM61 122.5C59.3431 122.5 58 123.843 58 125.5H60C60 124.948 60.4477 124.5 61 124.5V122.5Z",
                fill: "#3E3E3E"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "73", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "125.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "137.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "137.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "137.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "149.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "149.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "121", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "133", y: "149.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "49", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "61", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "73", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "85", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "97", y: "161.5", width: "6", height: "6", rx: "1", fill: "#3E3E3E" }),
            /* @__PURE__ */ m("rect", { x: "109", y: "161.5", width: "6", height: "6", rx: "1", fill: "#C6C6C6" }),
            /* @__PURE__ */ m("rect", { x: "24.5", y: "51", width: "139", height: "163", rx: "6", stroke: "#292929" }),
            /* @__PURE__ */ m("rect", { x: "176", y: "50.5", width: "108", height: "164", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "226.5", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" })
          ]
        }
      )
    },
    {
      title: e("floating_pop_up_button"),
      subtitle: e("floating_button_trigger_modal"),
      type: "floating-popup",
      illustration: /* @__PURE__ */ Y(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "50.5", width: "120", height: "76", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "138.5", width: "120", height: "76", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "156", y: "50.5", width: "128", height: "164", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "226.5", width: "260", height: "38.5", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "226", y: "223.5", width: "66", height: "26", rx: "6", fill: "#292929" }),
            /* @__PURE__ */ m("rect", { x: "242", y: "235.5", width: "34", height: "2", rx: "1", fill: "white" })
          ]
        }
      )
    },
    {
      title: e("pop_up_element_click"),
      subtitle: e("open_dialog_with_element_click"),
      type: "element-click",
      illustration: /* @__PURE__ */ Y(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m(
              "path",
              {
                d: "M0 1.99999C0 0.895423 0.895431 0 2 0H306C307.105 0 308 0.895431 308 2V263C308 264.105 307.105 265 306 265H2C0.895431 265 0 264.105 0 263V1.99999Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ m("rect", { x: "24", y: "0.50293", width: "260", height: "24", rx: "6", fill: "#F3F4F6" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "35", width: "259", height: "192", rx: "5.5", fill: "#F9FAFB" }),
            /* @__PURE__ */ Y("g", { filter: "url(#filter0_i_3223_14162)", children: [
              /* @__PURE__ */ m("rect", { opacity: "0.8", x: "40", y: "99", width: "24", height: "24", rx: "2", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "127", width: "48", height: "8", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "139", width: "82", height: "8", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "151", width: "34", height: "4", rx: "1", fill: "#E5E7EB" }),
              /* @__PURE__ */ m("rect", { x: "40", y: "159", width: "34", height: "4", rx: "1", fill: "#E5E7EB" })
            ] }),
            /* @__PURE__ */ m("rect", { x: "152", y: "48", width: "2", height: "169", rx: "2", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { opacity: "0.8", x: "176", y: "84", width: "80", height: "8", rx: "2", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "176", y: "96", width: "48", height: "4", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "109", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "109", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "123", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "135", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "187.3", y: "133.4", width: "9", height: "9", rx: "1.5", stroke: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "135", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "147", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "147", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "147", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "159", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "159", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "249", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "261", y: "159", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "177", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "189", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "201", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "213", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "225", y: "171", width: "6", height: "6", rx: "1", fill: "#0D121D" }),
            /* @__PURE__ */ m("rect", { x: "237", y: "171", width: "6", height: "6", rx: "1", fill: "#E5E7EB" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "35", width: "259", height: "192", rx: "5.5", stroke: "#101010" }),
            /* @__PURE__ */ m("rect", { x: "24", y: "241.503", width: "260", height: "24", rx: "6", fill: "#F3F4F6" })
          ]
        }
      )
    },
    {
      title: e("email_embed"),
      subtitle: e("add_times_to_your_email"),
      type: "email",
      illustration: /* @__PURE__ */ Y(
        "svg",
        {
          width: "100%",
          height: "100%",
          className: "rounded-md",
          viewBox: "0 0 308 265",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ Y("g", { "clip-path": "url(#clip0_457_1339)", children: [
              /* @__PURE__ */ m("rect", { width: "308", height: "265", rx: "8", fill: "white" }),
              /* @__PURE__ */ m("rect", { width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "19", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "38", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "57", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "76", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "95", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "114", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "133", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "152", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "171", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "190", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "209", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "228", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ m("rect", { y: "247", width: "308", height: "18", rx: "4", fill: "#F3F4F6" }),
              /* @__PURE__ */ Y("g", { "clip-path": "url(#clip1_457_1339)", children: [
                /* @__PURE__ */ m("rect", { x: "107", y: "64", width: "189", height: "189", rx: "6", fill: "white" }),
                /* @__PURE__ */ m("g", { "clip-path": "url(#clip2_457_1339)", children: /* @__PURE__ */ m(
                  "path",
                  {
                    d: "M124.671 75.5243C124.671 75.1018 124.325 74.756 123.902 74.756H117.756C117.334 74.756 116.988 75.1018 116.988 75.5243M124.671 75.5243V80.1341C124.671 80.5567 124.325 80.9024 123.902 80.9024H117.756C117.334 80.9024 116.988 80.5567 116.988 80.1341V75.5243M124.671 75.5243L120.829 78.2134L116.988 75.5243",
                    stroke: "#9CA3AF",
                    "stroke-width": "1.15244",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                ) }),
                /* @__PURE__ */ m("rect", { x: "130.049", y: "75.5244", width: "92.1951", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "130.049", y: "84.7439", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#E5E7EB" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "107",
                    y: "98.5732",
                    width: "189",
                    height: "1.15244",
                    rx: "0.576219",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "113.555", width: "92.1951", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "122.774", width: "42.6402", height: "4.60976", rx: "2.30488", fill: "#E5E7EB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "136.604", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "145.171", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "160.805", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "169.372", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "185.006", width: "55.3171", height: "4.60976", rx: "2.30488", fill: "#D1D5DB" }),
                /* @__PURE__ */ m("rect", { x: "116.719", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "142.073", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "167.427", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "192.781", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m("rect", { x: "218.134", y: "193.573", width: "22.0488", height: "5.91463", rx: "2.95732", stroke: "#9CA3AF" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "107",
                    y: "223.037",
                    width: "189",
                    height: "1.15244",
                    rx: "0.576219",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m("rect", { width: "189", height: "28.811", transform: "translate(107 224.189)", fill: "#F9FAFB" }),
                /* @__PURE__ */ m("rect", { x: "116.219", y: "233.985", width: "23.0488", height: "9.21951", rx: "2.30488", fill: "#9CA3AF" }),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "141.573",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "153.098",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                ),
                /* @__PURE__ */ m(
                  "rect",
                  {
                    opacity: "0.8",
                    x: "164.622",
                    y: "233.985",
                    width: "9.21951",
                    height: "9.21951",
                    rx: "2.30488",
                    fill: "#E5E7EB"
                  }
                )
              ] }),
              /* @__PURE__ */ m(
                "rect",
                {
                  x: "106.424",
                  y: "63.4238",
                  width: "190.152",
                  height: "190.152",
                  rx: "6.57622",
                  stroke: "#101010",
                  "stroke-width": "1.15244"
                }
              )
            ] }),
            /* @__PURE__ */ m("rect", { x: "0.5", y: "0.5", width: "307", height: "264", rx: "7.5", stroke: "#E5E7EB" }),
            /* @__PURE__ */ Y("defs", { children: [
              /* @__PURE__ */ m("clipPath", { id: "clip0_457_1339", children: /* @__PURE__ */ m("rect", { width: "308", height: "265", rx: "8", fill: "white" }) }),
              /* @__PURE__ */ m("clipPath", { id: "clip1_457_1339", children: /* @__PURE__ */ m("rect", { x: "107", y: "64", width: "189", height: "189", rx: "6", fill: "white" }) }),
              /* @__PURE__ */ m("clipPath", { id: "clip2_457_1339", children: /* @__PURE__ */ m("rect", { width: "9.21951", height: "9.21951", fill: "white", transform: "translate(116.219 73.2195)" }) })
            ] })
          ]
        }
      )
    }
  ];
}, w5 = () => QF();
var g$ = /* @__PURE__ */ ((e) => (e.HTML = "embed-code", e.IFRAME_REACT = "embed-react", e.ATOM_REACT = "embed-atom-react", e))(g$ || {});
const JQl = [
  {
    name: "HTML (iframe)",
    href: "embedTabName=embed-code",
    icon: "code",
    type: "code",
    "data-testid": "HTML",
    Component: it(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = Fe(), s = tJl(r), c = w5();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("place_where_cal_widget_appear", { appName: Zp }) }) }),
        /* @__PURE__ */ m(
          D$,
          {
            "data-testid": "embed-code",
            ref: i,
            name: "embed-code",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            style: { resize: "none", overflow: "auto" },
            readOnly: !0,
            value: `<!-- Cal ${t} embed code begins -->
${t === "inline" ? `<div style="width:${Vv(o.inline.width)};height:${Vv(
              o.inline.height
            )};overflow:scroll" id="my-cal-inline-${r}"></div>
` : ""}<script type="text/javascript">
  ${s}
  ${k5({
              embedFramework: "HTML",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: c,
              namespace: r
            })}
  <\/script>
  <!-- Cal ${t} embed code ends -->`
          }
        ),
        /* @__PURE__ */ m("p", { className: "text-subtle hidden text-sm", children: a("need_help_embedding") })
      ] });
    })
  },
  {
    name: "React (iframe)",
    href: "embedTabName=embed-react",
    "data-testid": "react",
    icon: "code",
    type: "code",
    Component: it(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = Fe(), s = w5();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("create_update_react_component") }),
        /* @__PURE__ */ m(
          D$,
          {
            "data-testid": "embed-react",
            ref: i,
            name: "embed-react",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            readOnly: !0,
            style: { resize: "none", overflow: "auto" },
            value: `/* First make sure that you have installed the package */

/* If you are using yarn */
// yarn add @calcom/embed-react

/* If you are using npm */
// npm install @calcom/embed-react
  ${k5({
              embedFramework: "react",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: s,
              namespace: r
            })}
  `
          }
        )
      ] });
    })
  },
  {
    name: "React (Atom)",
    href: "embedTabName=embed-atom-react",
    "data-testid": "react-atom",
    icon: "code",
    type: "code",
    Component: it(function({ embedType: t, calLink: n, previewState: o, namespace: r }, i) {
      const { t: a } = Fe(), s = w5();
      return i instanceof Function || !i || i.current && !(i.current instanceof HTMLTextAreaElement) ? null : /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("small", { className: "text-subtle flex py-2", children: a("create_update_react_component") }),
        /* @__PURE__ */ m(
          D$,
          {
            "data-testid": "embed-atom-react",
            ref: i,
            name: "embed-atom-react",
            className: "text-default bg-default h-[calc(100%-50px)] font-mono",
            readOnly: !0,
            style: { resize: "none", overflow: "auto" },
            value: `/* First make sure that you have installed the package */

/* If you are using yarn */
// yarn add @calcom/atoms

/* If you are using npm */
// npm install @calcom/atoms
${k5({
              embedFramework: "react-atom",
              embedType: t,
              calLink: n,
              previewState: o,
              embedCalOrigin: s,
              namespace: r
            })}`
          }
        )
      ] });
    })
  },
  {
    name: "Preview",
    href: "embedTabName=embed-preview",
    icon: "trello",
    type: "iframe",
    "data-testid": "Preview",
    Component: it(function({ calLink: t, embedType: n }, o) {
      const r = QF(), i = `${GQl}?embedType=${n}&calLink=${t}&embedLibUrl=${IC}&bookerUrl=${r}`;
      return o instanceof Function || !o || o.current && !(o.current instanceof HTMLIFrameElement) ? null : /* @__PURE__ */ m(
        "iframe",
        {
          ref: o,
          "data-testid": "embed-preview",
          className: "rounded-md border",
          width: "100%",
          height: "100%",
          src: i
        },
        i
      );
    })
  }
], k5 = ({
  embedFramework: e,
  embedType: t,
  calLink: n,
  embedCalOrigin: o,
  previewState: r,
  namespace: i
}) => {
  const a = YQl[e];
  if (!a)
    throw new Error(`No code available for the framework:${e}`);
  if (t === "email")
    return "";
  let s;
  const c = {
    theme: r.theme,
    brandColor: r.palette.brandColor,
    darkBrandColor: r.palette.darkBrandColor,
    hideEventTypeDetails: r.hideEventTypeDetails,
    layout: r.layout
  };
  if (e === "react" ? s = {
    ...c,
    apiName: Gbe({ mainApiName: "cal" })
  } : s = {
    ...c,
    apiName: EL({ namespace: i, mainApiName: "Cal" })
  }, !a[t])
    throw new Error(`Code not available for framework:${e} and embedType:${t}`);
  const l = {
    calLink: n,
    uiInstructionCode: XQl(s),
    embedCalOrigin: o,
    namespace: i
  };
  return t === "inline" ? a[t]({
    ...l,
    previewState: r.inline
  }) : t === "floating-popup" ? a[t]({
    ...l,
    previewState: r.floatingPopup
  }) : t === "element-click" ? a[t]({
    ...l,
    previewState: r.elementClick
  }) : t === "headless" ? a[t]() : "";
}, XQl = ({
  apiName: e,
  theme: t,
  brandColor: n,
  darkBrandColor: o,
  hideEventTypeDetails: r,
  layout: i
}) => (t = t !== "auto" ? t : void 0, eJl({
  apiName: e,
  instructionName: "ui",
  instructionArg: {
    theme: t,
    cssVarsPerTheme: Hbe({ brandColor: n, darkBrandColor: o }),
    hideEventTypeDetails: r,
    layout: i
  }
})), eJl = ({
  apiName: e,
  instructionName: t,
  instructionArg: n
}) => `${e}("${t}", ${JSON.stringify(n)});`;
function tJl(e) {
  const t = QF();
  return `(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "${IC}", "init");
Cal("init", ${e ? `"${e}",` : ""} {origin:"${t}"});
`;
}
const nJl = No(null);
function JF(e) {
  const t = Pn(nJl);
  if (e) {
    if (!t)
      throw new Error("useEmbedDialogCtx must be used within an EmbedDialogProvider");
    return t;
  } else
    return {
      embedState: null,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      setEmbedState: (n) => {
      }
    };
}
function Kbe(e = !1) {
  const t = O_(), { embedState: n } = JF(e);
  return e ? {
    embedType: (n == null ? void 0 : n.embedType) ?? null,
    embedUrl: (n == null ? void 0 : n.embedUrl) ?? "",
    namespace: (n == null ? void 0 : n.namespace) ?? "",
    embedTabName: (n == null ? void 0 : n.embedTabName) ?? null,
    eventId: (n == null ? void 0 : n.eventId) ?? null,
    date: (n == null ? void 0 : n.date) ?? null,
    month: (n == null ? void 0 : n.month) ?? null
  } : {
    embedType: (t == null ? void 0 : t.get("embedType")) ?? null,
    embedUrl: (t == null ? void 0 : t.get("embedUrl")) || "",
    namespace: (t == null ? void 0 : t.get("namespace")) || "",
    embedTabName: (t == null ? void 0 : t.get("embedTabName")) || "",
    eventId: (t == null ? void 0 : t.get("eventId")) || "",
    date: (t == null ? void 0 : t.get("date")) || "",
    month: (t == null ? void 0 : t.get("month")) || ""
  };
}
const Ybe = [
  "embedType",
  "embedTabName",
  "embedUrl",
  "eventId",
  "namespace",
  "date",
  "month"
];
function Zbe({
  timezoneFromBookerStore: e,
  timezoneFromTimePreferences: t,
  userSettingsTimezone: n
}) {
  return e ?? n ?? t;
}
function oJl() {
  const e = Ro.useRouter(), t = O_(), n = Ro.usePathname();
  return { goto: (i) => {
    const a = new URLSearchParams(t.toString());
    a.delete("slug"), a.delete("pages"), Object.keys(i).forEach((s) => {
      a.set(s, i[s]);
    }), e.push(`${n}?${a.toString()}`);
  }, removeQueryParams: (i) => {
    const a = new URLSearchParams(t.toString());
    i.forEach((s) => {
      a.delete(s);
    }), e.push(`${n}?${a.toString()}`);
  } };
}
function XF(e = !1) {
  const { goto: t, removeQueryParams: n } = oJl(), { setEmbedState: o } = JF(e);
  return { gotoState: (s) => {
    if (e)
      o((c) => ({
        ...c,
        embedType: s.embedType ?? (c == null ? void 0 : c.embedType) ?? null,
        embedTabName: s.embedTabName ?? (c == null ? void 0 : c.embedTabName) ?? null,
        embedUrl: s.embedUrl ?? (c == null ? void 0 : c.embedUrl) ?? null,
        eventId: s.eventId ?? (c == null ? void 0 : c.eventId) ?? null,
        namespace: s.namespace ?? (c == null ? void 0 : c.namespace) ?? null,
        date: s.date ?? (c == null ? void 0 : c.date) ?? null,
        month: s.month ?? (c == null ? void 0 : c.month) ?? null
      }));
    else {
      const c = Object.fromEntries(
        Object.entries(s).filter(([l, d]) => d !== null)
      );
      t(c);
    }
  }, resetState: () => {
    e ? o(null) : n(["dialog", ...Ybe]);
  }, gotoEmbedTypeSelectionState: () => {
    e ? o((s) => ({
      ...s,
      embedType: null,
      embedTabName: null,
      embedUrl: (s == null ? void 0 : s.embedUrl) ?? null,
      eventId: (s == null ? void 0 : s.eventId) ?? null,
      namespace: (s == null ? void 0 : s.namespace) ?? null,
      date: (s == null ? void 0 : s.date) ?? null,
      month: (s == null ? void 0 : s.month) ?? null
    })) : n(["embedType", "embedTabName"]);
  } };
}
const rJl = ({
  children: e,
  ...t
}) => /* @__PURE__ */ Y(sd.Control, { ...t, children: [
  /* @__PURE__ */ m(ot, { name: "sun", className: "text-subtle mr-2 h-4 w-4" }),
  e
] }), iJl = ({
  types: e,
  noQueryParamMode: t
}) => {
  const { t: n } = Fe(), { gotoState: o } = XF(t);
  return /* @__PURE__ */ Y(Ei, { className: "rounded-lg p-10", type: "creation", size: "lg", children: [
    /* @__PURE__ */ Y("div", { className: "mb-2", children: [
      /* @__PURE__ */ m("h3", { className: "font-cal text-emphasis mb-2 text-2xl font-semibold leading-none", id: "modal-title", children: n("how_you_want_add_cal_site", { appName: Zp }) }),
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("p", { className: "text-subtle text-sm", children: n("choose_ways_put_cal_site", { appName: Zp }) }) })
    ] }),
    /* @__PURE__ */ m("div", { className: "items-start space-y-2 md:flex md:space-y-0", children: e.map((r, i) => /* @__PURE__ */ Y(
      "button",
      {
        className: "hover:bg-subtle bg-muted	w-full self-stretch rounded-md border border-transparent p-6 text-left transition hover:rounded-md ltr:mr-4 ltr:last:mr-0 rtl:ml-4 rtl:last:ml-0 lg:w-1/3",
        "data-testid": r.type,
        onClick: () => {
          r.type === "headless" ? window.open("https://cal.com/help/routing/headless-routing", "_blank") : o({
            embedType: r.type
          });
        },
        children: [
          /* @__PURE__ */ m("div", { className: "bg-default order-none box-border flex-none rounded-md border border-solid transition dark:bg-transparent dark:invert", children: r.illustration }),
          /* @__PURE__ */ m("div", { className: "text-emphasis mt-4 font-semibold", children: r.title }),
          /* @__PURE__ */ m("p", { className: "text-subtle mt-2 text-sm", children: r.subtitle })
        ]
      },
      i
    )) })
  ] });
}, aJl = ({
  eventType: e,
  username: t,
  orgSlug: n,
  isTeamEvent: o,
  selectedDuration: r,
  setSelectedDuration: i,
  userSettingsTimezone: a
}) => {
  var C, P, x, w, E, T;
  const { t: s, i18n: c } = Fe(), { timezoneFromBookerStore: l, timezoneFromTimePreferences: d } = vd(), u = Zbe({
    timezoneFromBookerStore: l,
    timezoneFromTimePreferences: d,
    userSettingsTimezone: a
  });
  kle({
    username: t,
    eventSlug: (e == null ? void 0 : e.slug) ?? "",
    eventId: e == null ? void 0 : e.id,
    layout: pn.MONTH_VIEW,
    org: n,
    isTeamEvent: o
  }), h9({
    username: t,
    eventSlug: (e == null ? void 0 : e.slug) ?? "",
    eventId: e == null ? void 0 : e.id,
    layout: pn.MONTH_VIEW,
    org: n,
    isTeamEvent: o
  });
  const [_, p, f] = St(
    (z) => [z.month, z.selectedDate, z.selectedDatesAndTimes],
    Fr
  ), [g, h, b, v, $] = St(
    (z) => [
      z.setSelectedDate,
      z.setMonth,
      z.setSelectedDatesAndTimes,
      z.setSelectedTimeslot,
      z.setTimezone
    ],
    Fr
  ), k = Wve(), S = Kml({
    orgSlug: n,
    eventId: e == null ? void 0 : e.id,
    isTeamEvent: o,
    duration: r,
    useApiV2: !1
  }), O = dC((C = S == null ? void 0 : S.data) == null ? void 0 : C.slots), I = (z) => {
    const { time: j } = z;
    if (!e)
      return null;
    if (f && f[e.slug]) {
      const q = f[e.slug], V = q[p] ?? [];
      if (V != null && V.includes(j)) {
        if ((V == null ? void 0 : V.length) > 1) {
          const L = {
            ...f,
            [e.slug]: {
              ...q,
              [p]: V == null ? void 0 : V.filter((U) => U !== j)
            }
          };
          b(L);
        } else {
          const L = { ...q };
          delete L[p], v(null), b({
            ...f,
            [e.slug]: L
          });
        }
        return;
      }
      const F = {
        ...f,
        [e.slug]: {
          ...q,
          [p]: [...V, j]
        }
      };
      b(F);
    } else
      b(f ? {
        ...f,
        [e.slug]: { [p]: [j] }
      } : { [e.slug]: { [p]: [j] } });
    v(j);
  }, D = Npl(p, (P = S == null ? void 0 : S.data) == null ? void 0 : P.slots);
  if (!e)
    return null;
  r || i(e.length);
  const N = (((x = e == null ? void 0 : e.metadata) == null ? void 0 : x.multipleDuration) ?? []).map((z) => ({
    label: `${z} ${s("minutes")}`,
    value: z
  }));
  return /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium", children: /* @__PURE__ */ m(G$, { open: !0, children: /* @__PURE__ */ Y(H$, { children: [
      /* @__PURE__ */ m("div", { className: "text-default text-sm", children: s("select_date") }),
      /* @__PURE__ */ m(
        pme,
        {
          isLoading: S.isPending,
          onChange: (z) => {
            g({ date: z === null ? z : z.format("YYYY-MM-DD") });
          },
          onMonthChange: (z) => {
            h(z.format("YYYY-MM")), g({ date: z.format("YYYY-MM-DD") });
          },
          includedDates: O,
          locale: c.language,
          browsingDate: _ ? De(_) : void 0,
          selected: De(p),
          weekStart: eme((T = (E = (w = k == null ? void 0 : k.data) == null ? void 0 : w.subsetOfUsers) == null ? void 0 : E[0]) == null ? void 0 : T.weekStart),
          eventSlug: e == null ? void 0 : e.slug
        }
      )
    ] }) }) }),
    p ? /* @__PURE__ */ m("div", { className: "mt-[9px] font-medium ", children: p ? /* @__PURE__ */ Y("div", { className: "flex h-full w-full flex-col gap-4", children: [
      /* @__PURE__ */ m(Ive, { date: De(p) }),
      /* @__PURE__ */ m(
        Tve,
        {
          className: "w-full",
          selectedSlots: e.slug && f && f[e.slug] && f[e.slug][p] ? f[e.slug][p] : void 0,
          handleSlotClick: I,
          slots: D,
          showAvailableSeatsCount: e.seatsShowAvailabilityCount,
          event: k
        }
      )
    ] }) : null }) : null,
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium ", children: /* @__PURE__ */ m(G$, { open: !0, children: /* @__PURE__ */ Y(H$, { children: [
      /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: s("duration") }),
      N.length > 0 ? /* @__PURE__ */ m(
        Tr,
        {
          value: N.find((z) => z.value === r),
          options: N,
          onChange: (z) => {
            i(z == null ? void 0 : z.value), b({});
          }
        }
      ) : /* @__PURE__ */ m(
        Io,
        {
          disabled: !0,
          label: s("duration"),
          defaultValue: (e == null ? void 0 : e.length) ?? 15,
          addOnSuffix: /* @__PURE__ */ m(Ce, { children: s("minutes") })
        }
      )
    ] }) }) }),
    /* @__PURE__ */ m("div", { className: "mb-[9px] font-medium ", children: /* @__PURE__ */ m(G$, { open: !0, children: /* @__PURE__ */ Y(H$, { children: [
      /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: s("timezone") }),
      /* @__PURE__ */ m(xj, { id: "timezone", value: u, onChange: ({ value: z }) => $(z) })
    ] }) }) })
  ] });
}, sJl = ({
  eventType: e,
  emailContentRef: t,
  username: n,
  month: o,
  selectedDateAndTime: r,
  calLink: i,
  selectedDuration: a,
  userSettingsTimezone: s
}) => {
  const { t: c } = Fe(), { timeFormat: l, timezoneFromBookerStore: d, timezoneFromTimePreferences: u } = vd(), _ = Zbe({
    timezoneFromBookerStore: d,
    timezoneFromTimePreferences: u,
    userSettingsTimezone: s
  });
  return e ? /* @__PURE__ */ m("div", { className: "flex h-full items-center justify-center border p-5 last:font-medium", children: /* @__PURE__ */ Y("div", { className: "border bg-white p-4", children: [
    /* @__PURE__ */ Y(
      "div",
      {
        style: {
          paddingBottom: "3px",
          fontSize: "13px",
          color: "black",
          lineHeight: "1.4",
          minWidth: "30vw",
          maxHeight: "50vh",
          overflowY: "auto",
          backgroundColor: "white"
        },
        ref: t,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              style: {
                fontStyle: "normal",
                fontSize: "20px",
                fontWeight: "bold",
                lineHeight: "19px",
                marginTop: "15px",
                marginBottom: "15px"
              },
              children: /* @__PURE__ */ Y("b", { style: { color: "black" }, children: [
                " ",
                e.title
              ] })
            }
          ),
          /* @__PURE__ */ Y(
            "div",
            {
              style: {
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#333333"
              },
              children: [
                c("duration"),
                ": ",
                /* @__PURE__ */ Y("b", { style: { color: "black" }, children: [
                  a,
                  " mins"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ Y(
            "span",
            {
              style: {
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#333333"
              },
              children: [
                c("timezone"),
                ": ",
                /* @__PURE__ */ m("b", { style: { color: "black" }, children: _ })
              ]
            }
          ) }) }),
          /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ Y(Ce, { children: [
            r && Object.keys(r).sort().map((p) => {
              var h;
              const f = r[p][0], g = De(f).tz(_).format("dddd, MMMM D, YYYY");
              return /* @__PURE__ */ m(
                "table",
                {
                  style: {
                    marginTop: "16px",
                    textAlign: "left",
                    borderCollapse: "collapse",
                    borderSpacing: "0px"
                  },
                  children: /* @__PURE__ */ Y("tbody", { children: [
                    /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m("td", { style: { textAlign: "left", marginTop: "16px" }, children: /* @__PURE__ */ Y(
                      "span",
                      {
                        style: {
                          fontSize: "14px",
                          lineHeight: "16px",
                          paddingBottom: "8px",
                          color: "rgb(26, 26, 26)",
                          fontWeight: "bold"
                        },
                        children: [
                          g,
                          " "
                        ]
                      }
                    ) }) }),
                    /* @__PURE__ */ m("tr", { children: /* @__PURE__ */ m("td", { children: /* @__PURE__ */ m("table", { style: { borderCollapse: "separate", borderSpacing: "0px 4px" }, children: /* @__PURE__ */ m("tbody", { children: /* @__PURE__ */ m("tr", { style: { height: "25px" }, children: ((h = r[p]) == null ? void 0 : h.length) > 0 && r[p].map((b) => {
                      const v = `${e.bookerUrl}/${e.teamId !== null ? "team/" : ""}${n}/${e.slug}?duration=${a}&date=${p}&month=${o}&slot=${b}&cal.tz=${_}`;
                      return /* @__PURE__ */ m(
                        "td",
                        {
                          style: {
                            padding: "0px",
                            width: "64px",
                            display: "inline-block",
                            marginRight: "4px",
                            marginBottom: "4px",
                            height: "24px",
                            border: "1px solid #111827",
                            borderRadius: "3px"
                          },
                          children: /* @__PURE__ */ m("table", { style: { height: "21px" }, children: /* @__PURE__ */ m("tbody", { children: /* @__PURE__ */ Y("tr", { style: { height: "21px" }, children: [
                            /* @__PURE__ */ m("td", { style: { width: "7px" } }),
                            /* @__PURE__ */ m(
                              "td",
                              {
                                style: {
                                  width: "50px",
                                  textAlign: "center",
                                  marginRight: "1px"
                                },
                                children: /* @__PURE__ */ m(
                                  "a",
                                  {
                                    href: v,
                                    className: "spot",
                                    style: {
                                      fontFamily: '"Proxima Nova", sans-serif',
                                      textDecoration: "none",
                                      textAlign: "center",
                                      color: "#111827",
                                      fontSize: "12px",
                                      lineHeight: "16px"
                                    },
                                    children: /* @__PURE__ */ Y(
                                      "b",
                                      {
                                        style: {
                                          fontWeight: "normal",
                                          textDecoration: "none"
                                        },
                                        children: [
                                          De.utc(b).tz(_).format(l),
                                          " "
                                        ]
                                      }
                                    )
                                  }
                                )
                              }
                            )
                          ] }) }) })
                        },
                        b
                      );
                    }) }) }) }) }) })
                  ] })
                },
                p
              );
            }),
            /* @__PURE__ */ m("div", { style: { marginTop: "13px" }, children: /* @__PURE__ */ m(
              "a",
              {
                className: "more",
                "data-testid": "see_all_available_times",
                href: `${e.bookerUrl}/${i}?cal.tz=${_}`,
                style: {
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "black"
                },
                children: c("see_all_available_times")
              }
            ) })
          ] }) }),
          /* @__PURE__ */ Y(
            "div",
            {
              className: "w-full text-right",
              style: {
                borderTop: "1px solid #CCCCCC",
                marginTop: "8px",
                paddingTop: "8px"
              },
              children: [
                /* @__PURE__ */ m("span", { children: c("powered_by") }),
                " ",
                /* @__PURE__ */ m("b", { style: { color: "black" }, children: /* @__PURE__ */ m("span", { children: " Cal.com" }) })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ m("b", { style: { color: "black" } })
  ] }) }) : null;
}, cJl = ({
  embedType: e,
  embedUrl: t,
  tabs: n,
  namespace: o,
  eventTypeHideOptionDisabled: r,
  types: i,
  defaultBrandColor: a,
  noQueryParamMode: s
}) => {
  var te, ue;
  const { t: c } = Fe(), l = O_(), d = Ro.usePathname(), { resetState: u, gotoState: _, gotoEmbedTypeSelectionState: p } = XF(s), f = Ue(null), g = Ue(null), h = Ue(null), { data: b } = sc.useSession(), [v, $] = St(
    (le) => [le.month, le.selectedDatesAndTimes],
    Fr
  ), k = Kbe(s), S = k.eventId, O = parseInt(S ?? "", 10), I = decodeURIComponent(t), { data: D } = bo.viewer.eventTypes.get.useQuery(
    { id: O },
    { enabled: !Number.isNaN(O) && e === "email", refetchOnWindowFocus: !1 }
  ), { data: M } = bo.viewer.me.get.useQuery(), N = D != null && D.team ? D.team.slug : null, C = (le) => {
    const se = new URLSearchParams(l.toString()), [me, pe] = le.split("=");
    return se.set(me, pe), `${(d == null ? void 0 : d.split("?")[0]) ?? ""}?${se.toString()}`;
  }, P = n.map((le) => {
    const { href: se, ...me } = le, pe = se.split("=")[1];
    return {
      ...me,
      isActive: pe === k.embedTabName,
      ...s ? {
        onClick: () => {
          _({ embedTabName: pe });
        },
        // We still pass the href(which is unique) so that all the tabs aren't marked as active
        href: le.href
      } : {
        href: C(le.href)
      }
    };
  }), x = {};
  n.filter((le) => le.type === "code").forEach((le) => {
    x[le.name] = IAe();
  });
  const w = Ue(x), E = i.find((le) => le.type === e), [T, z] = ze(D == null ? void 0 : D.eventType.length), [j, q] = ze(!0), [V, F] = ze(!0), L = {
    layout: pn.MONTH_VIEW
  }, U = (le) => le === "brandColor" ? (a == null ? void 0 : a.brandColor) ?? m9 : le === "darkBrandColor" ? (a == null ? void 0 : a.darkBrandColor) ?? f9 : "#000000", [W, H] = ze({
    inline: {
      width: "100%",
      height: "100%",
      config: L
    },
    theme: f$.auto,
    layout: L.layout,
    floatingPopup: {
      config: L
    },
    elementClick: {
      config: L
    },
    hideEventTypeDetails: !1,
    palette: {
      brandColor: (a == null ? void 0 : a.brandColor) ?? null,
      darkBrandColor: (a == null ? void 0 : a.darkBrandColor) ?? null
    }
  }), Q = () => {
    u();
  };
  if (k.embedTabName || _({
    embedTabName: "embed-code"
  }), !E || !t)
    return Q(), null;
  const X = (le) => {
    H((se) => ({
      ...se,
      palette: {
        ...se.palette,
        ...le
      }
    }));
  }, re = (le) => {
    var se, me;
    (me = (se = f.current) == null ? void 0 : se.contentWindow) == null || me.postMessage(
      {
        mode: "cal:preview",
        type: "instruction",
        instruction: le
      },
      "*"
    );
  }, Z = ({ width: le, height: se }) => {
    var me, pe;
    (pe = (me = f.current) == null ? void 0 : me.contentWindow) == null || pe.postMessage(
      {
        mode: "cal:preview",
        type: "inlineEmbedDimensionUpdate",
        data: {
          width: Vv(le),
          height: Vv(se)
        }
      },
      "*"
    );
  };
  re({
    name: "ui",
    arg: {
      theme: W.theme,
      layout: W.layout,
      hideEventTypeDetails: W.hideEventTypeDetails,
      cssVarsPerTheme: Hbe({
        brandColor: W.palette.brandColor,
        darkBrandColor: W.palette.darkBrandColor
      })
    }
  });
  const ee = () => {
    const le = h.current;
    if (le !== null) {
      const se = document.createRange();
      se.selectNode(le);
      const me = window.getSelection();
      me && (me.removeAllRanges(), me.addRange(se), document.execCommand("copy"), me.removeAllRanges()), nr(c("code_copied"), "success");
    }
  };
  e === "floating-popup" && re({
    name: "floatingButton",
    arg: {
      attributes: {
        id: "my-floating-button"
      },
      ...W.floatingPopup
    }
  }), e === "inline" && Z({
    width: W.inline.width,
    height: W.inline.height
  });
  const J = [
    { value: f$.auto, label: "Auto" },
    { value: f$.dark, label: "Dark Theme" },
    { value: f$.light, label: "Light Theme" }
  ], oe = [
    { value: pn.MONTH_VIEW, label: c("bookerlayout_month_view") },
    { value: pn.WEEK_VIEW, label: c("bookerlayout_week_view") },
    { value: pn.COLUMN_VIEW, label: c("bookerlayout_column_view") }
  ], ce = [
    {
      value: "bottom-right",
      label: "Bottom right"
    },
    {
      value: "bottom-left",
      label: "Bottom left"
    }
  ], de = n.find((le) => le.name === "Preview");
  return /* @__PURE__ */ m(
    Ei,
    {
      enableOverflow: !0,
      ref: g,
      className: "rounded-lg p-0.5 sm:max-w-[80rem]",
      type: "creation",
      children: /* @__PURE__ */ Y("div", { className: "flex", children: [
        /* @__PURE__ */ Y("div", { className: "bg-muted flex h-[95vh] w-1/3 flex-col overflow-y-auto p-8", children: [
          /* @__PURE__ */ Y(
            "h3",
            {
              className: "text-emphasis mb-2.5 flex items-center text-xl font-semibold leading-5",
              id: "modal-title",
              children: [
                /* @__PURE__ */ m("button", { className: "h-6 w-6", onClick: p, children: /* @__PURE__ */ m(ot, { name: "arrow-left", className: "mr-4 w-4" }) }),
                E.title
              ]
            }
          ),
          /* @__PURE__ */ m("h4", { className: "text-subtle mb-6 text-sm font-normal", children: E.subtitle }),
          D != null && D.eventType && e === "email" ? /* @__PURE__ */ m(
            aJl,
            {
              eventType: D == null ? void 0 : D.eventType,
              username: N ?? (b == null ? void 0 : b.user.username),
              userSettingsTimezone: M == null ? void 0 : M.timeZone,
              orgSlug: (ue = (te = b == null ? void 0 : b.user) == null ? void 0 : te.org) == null ? void 0 : ue.slug,
              isTeamEvent: !!N,
              selectedDuration: T,
              setSelectedDuration: z
            }
          ) : /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ m("div", { className: ci("font-medium", e === "element-click" ? "hidden" : ""), children: /* @__PURE__ */ m(
              G$,
              {
                open: j,
                onOpenChange: () => q((le) => !le),
                children: /* @__PURE__ */ Y(H$, { className: "text-sm", children: [
                  e === "inline" && k.embedTabName !== g$.ATOM_REACT && /* @__PURE__ */ Y("div", { children: [
                    /* @__PURE__ */ m("div", { className: "text-default mb-[9px] text-sm", children: "Window sizing" }),
                    /* @__PURE__ */ Y("div", { className: "justify-left mb-6 flex items-center !font-normal ", children: [
                      /* @__PURE__ */ m("div", { className: "mr-[9px]", children: /* @__PURE__ */ m(
                        Io,
                        {
                          labelProps: { className: "hidden" },
                          className: "focus:ring-offset-0",
                          required: !0,
                          value: W.inline.width,
                          onChange: (le) => {
                            H((se) => {
                              const me = le.target.value || "100%";
                              return {
                                ...se,
                                inline: {
                                  ...se.inline,
                                  width: me
                                }
                              };
                            });
                          },
                          addOnLeading: /* @__PURE__ */ m(Ce, { children: "W" })
                        }
                      ) }),
                      /* @__PURE__ */ m(
                        Io,
                        {
                          labelProps: { className: "hidden" },
                          className: "focus:ring-offset-0",
                          value: W.inline.height,
                          required: !0,
                          onChange: (le) => {
                            const se = le.target.value || "100%";
                            H((me) => ({
                              ...me,
                              inline: {
                                ...me.inline,
                                height: se
                              }
                            }));
                          },
                          addOnLeading: /* @__PURE__ */ m(Ce, { children: "H" })
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ Y(
                    "div",
                    {
                      className: ci(
                        "items-center justify-between",
                        e === "floating-popup" ? "text-emphasis" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m("div", { className: "mb-2 text-sm", children: "Button text" }),
                        /* @__PURE__ */ m(
                          Io,
                          {
                            labelProps: { className: "hidden" },
                            onChange: (le) => {
                              H((se) => ({
                                ...se,
                                floatingPopup: {
                                  ...se.floatingPopup,
                                  buttonText: le.target.value
                                }
                              }));
                            },
                            defaultValue: c("book_my_cal"),
                            required: !0
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ Y(
                    "div",
                    {
                      className: ci(
                        "mt-4 flex items-center justify-start",
                        e === "floating-popup" ? "text-emphasis space-x-2 rtl:space-x-reverse" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m(
                          Ri,
                          {
                            defaultChecked: !0,
                            onCheckedChange: (le) => {
                              H((se) => ({
                                ...se,
                                floatingPopup: {
                                  ...se.floatingPopup,
                                  hideButtonIcon: !le
                                }
                              }));
                            }
                          }
                        ),
                        /* @__PURE__ */ m("div", { className: "text-default my-2 text-sm", children: "Display calendar icon" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ Y(
                    "div",
                    {
                      className: ci(
                        "mt-4 items-center justify-between",
                        e === "floating-popup" ? "text-emphasis" : "hidden"
                      ),
                      children: [
                        /* @__PURE__ */ m("div", { className: "mb-2", children: "Position of button" }),
                        /* @__PURE__ */ m(
                          Tr,
                          {
                            onChange: (le) => {
                              H((se) => ({
                                ...se,
                                floatingPopup: {
                                  ...se.floatingPopup,
                                  buttonPosition: le == null ? void 0 : le.value
                                }
                              }));
                            },
                            defaultValue: ce[0],
                            options: ce
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ Y("div", { className: "mt-3 flex flex-col xl:flex-row xl:justify-between", children: [
                    /* @__PURE__ */ Y("div", { className: ci("mt-4", e === "floating-popup" ? "" : "hidden"), children: [
                      /* @__PURE__ */ m("div", { className: "whitespace-nowrap", children: "Button color" }),
                      /* @__PURE__ */ m("div", { className: "mt-2 w-40 xl:mt-0 xl:w-full", children: /* @__PURE__ */ m(
                        L$,
                        {
                          className: "w-[130px]",
                          popoverAlign: "start",
                          container: (g == null ? void 0 : g.current) ?? void 0,
                          defaultValue: "#000000",
                          onChange: (le) => {
                            H((se) => ({
                              ...se,
                              floatingPopup: {
                                ...se.floatingPopup,
                                buttonColor: le
                              }
                            }));
                          }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ Y("div", { className: ci("mt-4", e === "floating-popup" ? "" : "hidden"), children: [
                      /* @__PURE__ */ m("div", { className: "whitespace-nowrap", children: "Text color" }),
                      /* @__PURE__ */ m("div", { className: "mb-6 mt-2 w-40 xl:mt-0 xl:w-full", children: /* @__PURE__ */ m(
                        L$,
                        {
                          className: "w-[130px]",
                          popoverAlign: "start",
                          container: (g == null ? void 0 : g.current) ?? void 0,
                          defaultValue: "#000000",
                          onChange: (le) => {
                            H((se) => ({
                              ...se,
                              floatingPopup: {
                                ...se.floatingPopup,
                                buttonTextColor: le
                              }
                            }));
                          }
                        }
                      ) })
                    ] })
                  ] })
                ] })
              }
            ) }),
            /* @__PURE__ */ m("div", { className: "font-medium", children: /* @__PURE__ */ m(
              G$,
              {
                open: V,
                onOpenChange: () => F((le) => !le),
                children: /* @__PURE__ */ m(H$, { children: /* @__PURE__ */ Y("div", { className: "text-sm", children: [
                  k.embedTabName !== g$.ATOM_REACT && /* @__PURE__ */ Y(Xn, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: "EmbedTheme" }),
                    /* @__PURE__ */ m(
                      Tr,
                      {
                        className: "w-full",
                        defaultValue: J[0],
                        components: {
                          Control: rJl,
                          IndicatorSeparator: () => null
                        },
                        onChange: (le) => {
                          le && H((se) => {
                            const me = (pe) => ({
                              ...pe ?? {},
                              theme: le.value
                            });
                            return {
                              ...se,
                              inline: {
                                ...se.inline,
                                config: me(se.inline.config)
                              },
                              floatingPopup: {
                                ...se.floatingPopup,
                                config: me(se.floatingPopup.config)
                              },
                              elementClick: {
                                ...se.elementClick,
                                config: me(se.elementClick.config)
                              },
                              // Keep updating top-level theme for preview iframe
                              theme: le.value
                            };
                          });
                        },
                        options: J
                      }
                    )
                  ] }),
                  !r && k.embedTabName !== g$.ATOM_REACT ? /* @__PURE__ */ Y("div", { className: "mb-6 flex items-center justify-start space-x-2 rtl:space-x-reverse", children: [
                    /* @__PURE__ */ m(
                      Ri,
                      {
                        checked: W.hideEventTypeDetails,
                        onCheckedChange: (le) => {
                          H((se) => ({
                            ...se,
                            hideEventTypeDetails: le
                          }));
                        }
                      }
                    ),
                    /* @__PURE__ */ m("div", { className: "text-default text-sm", children: c("hide_eventtype_details") })
                  ] }) : null,
                  k.embedTabName !== g$.ATOM_REACT && [
                    { name: "brandColor", title: "light_brand_color" },
                    { name: "darkBrandColor", title: "dark_brand_color" }
                    // { name: "lightColor", title: "Light Color" },
                    // { name: "lighterColor", title: "Lighter Color" },
                    // { name: "lightestColor", title: "Lightest Color" },
                    // { name: "highlightColor", title: "Highlight Color" },
                    // { name: "medianColor", title: "Median Color" },
                  ].map((le) => /* @__PURE__ */ Y(Xn, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: c(le.title) }),
                    /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m(
                      L$,
                      {
                        popoverAlign: "start",
                        container: (g == null ? void 0 : g.current) ?? void 0,
                        defaultValue: U(le.name),
                        onChange: (se) => {
                          X({
                            [le.name]: se
                          });
                        }
                      }
                    ) })
                  ] }, le.name)),
                  /* @__PURE__ */ Y(Xn, { className: "mb-6", children: [
                    /* @__PURE__ */ m("div", { className: "mb-2", children: c("layout") }),
                    /* @__PURE__ */ m(
                      Tr,
                      {
                        className: "w-full",
                        defaultValue: oe[0],
                        onChange: (le) => {
                          le && H((se) => {
                            const me = (pe) => ({
                              ...pe ?? {},
                              layout: le.value
                            });
                            return {
                              ...se,
                              inline: {
                                ...se.inline,
                                config: me(se.inline.config)
                              },
                              floatingPopup: {
                                ...se.floatingPopup,
                                config: me(se.floatingPopup.config)
                              },
                              elementClick: {
                                ...se.elementClick,
                                config: me(se.elementClick.config)
                              },
                              // Keep updating top-level layout for preview iframe
                              layout: le.value
                            };
                          });
                        },
                        options: oe
                      }
                    )
                  ] })
                ] }) })
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ Y("div", { className: "flex h-[95vh] w-2/3 flex-col px-8 pt-8", children: [
          /* @__PURE__ */ m(
            Ube,
            {
              "data-testid": "embed-tabs",
              tabs: e === "email" ? P.filter((le) => le.name === "Preview") : P.filter((le) => le.name !== "Preview"),
              linkShallow: !0
            }
          ),
          /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ Y("div", { className: "flex h-full flex-col", children: [
              n.map((le) => {
                if (e !== "email")
                  return le.name === "Preview" ? null : /* @__PURE__ */ Y(
                    "div",
                    {
                      className: ci(
                        k.embedTabName === le.href.split("=")[1] ? "flex-1" : "hidden"
                      ),
                      children: [
                        le.type === "code" && /* @__PURE__ */ m(
                          le.Component,
                          {
                            namespace: o,
                            embedType: e,
                            calLink: I,
                            previewState: W,
                            ref: w.current[le.name]
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: k.embedTabName === "embed-preview" ? "mt-2 block" : "hidden"
                          }
                        )
                      ]
                    },
                    le.href
                  );
                if (!(e === "email" && (le.name !== "Preview" || !(D != null && D.eventType))))
                  return /* @__PURE__ */ Y("div", { className: ci("flex flex-grow flex-col"), children: [
                    /* @__PURE__ */ m("div", { className: "flex h-[55vh] flex-grow flex-col", children: /* @__PURE__ */ m(
                      sJl,
                      {
                        selectedDuration: T,
                        calLink: I,
                        eventType: D == null ? void 0 : D.eventType,
                        emailContentRef: h,
                        username: N ?? (b == null ? void 0 : b.user.username),
                        userSettingsTimezone: M == null ? void 0 : M.timeZone,
                        month: v,
                        selectedDateAndTime: $ ? $[D == null ? void 0 : D.eventType.slug] : {}
                      }
                    ) }),
                    /* @__PURE__ */ m("div", { className: k.embedTabName === "embed-preview" ? "mt-2 block" : "hidden" })
                  ] }, le.href);
              }),
              e !== "email" && de && /* @__PURE__ */ m("div", { className: "flex-1", children: /* @__PURE__ */ m(
                de.Component,
                {
                  namespace: o,
                  embedType: e,
                  calLink: I,
                  previewState: W,
                  ref: f
                }
              ) })
            ] }),
            /* @__PURE__ */ Y(Fc, { className: "mt-10 flex-row-reverse gap-x-2", showDivider: !0, children: [
              /* @__PURE__ */ m(ca, {}),
              /* @__PURE__ */ m(
                ut,
                {
                  type: "submit",
                  onClick: () => {
                    var le;
                    if (e === "email")
                      ee();
                    else {
                      const se = k.embedTabName, me = (le = n.find(
                        (be) => be.href === `embedTabName=${se}`
                      )) == null ? void 0 : le.name;
                      if (!me)
                        return;
                      const pe = w.current[me].current;
                      if (!pe)
                        return;
                      navigator.clipboard.writeText(pe.value), nr(c("code_copied"), "success");
                    }
                  },
                  children: c(e === "email" ? "copy" : "copy_code")
                }
              )
            ] })
          ] })
        ] })
      ] })
    }
  );
}, lJl = ({
  types: e,
  tabs: t,
  eventTypeHideOptionDisabled: n,
  defaultBrandColor: o,
  noQueryParamMode: r = !1
}) => {
  const { embedState: i, setEmbedState: a } = JF(r), s = Kbe(r), c = () => {
    r && a(null);
  };
  return /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(
    Gi,
    {
      ...r ? {
        open: i !== null,
        onOpenChange: (l) => !l && c()
      } : {
        // Must not set name when noQueryParam mode as required by Dialog component
        name: "embed",
        clearQueryParamsOnClose: Ybe
      },
      children: s.embedType ? /* @__PURE__ */ m(
        cJl,
        {
          embedType: s.embedType,
          embedUrl: s.embedUrl,
          namespace: s.namespace,
          tabs: t,
          types: e,
          eventTypeHideOptionDisabled: n,
          defaultBrandColor: o,
          noQueryParamMode: r
        }
      ) : /* @__PURE__ */ m(iJl, { types: e, noQueryParamMode: r })
    }
  ) });
}, dJl = ({
  embedUrl: e,
  children: t,
  className: n = "",
  as: o,
  eventId: r,
  namespace: i,
  noQueryParamMode: a,
  ...s
}) => {
  const { gotoState: c } = XF(a);
  return n = ci("hidden lg:inline-flex", n), /* @__PURE__ */ m(
    o ?? ut,
    {
      ...s,
      className: n,
      "data-test-embed-url": e,
      "data-testid": "embed",
      type: "button",
      onClick: () => {
        c({
          dialog: "embed",
          eventId: r ? r.toString() : "",
          namespace: i,
          embedUrl: e
        });
      },
      children: t
    }
  );
}, uJl = () => {
  const e = QQl(), { data: t } = bo.viewer.me.get.useQuery();
  return /* @__PURE__ */ m(
    lJl,
    {
      types: e,
      tabs: JQl,
      eventTypeHideOptionDisabled: !1,
      defaultBrandColor: t ? { brandColor: t.brandColor, darkBrandColor: t.darkBrandColor } : null
    }
  );
}, _Jl = (e) => /* @__PURE__ */ m(dJl, { ...e });
function pJl({
  isManagedEvent: e,
  eventTypeId: t,
  open: n,
  onOpenChange: o,
  onDelete: r,
  isDeleting: i
}) {
  const { t: a } = Fe();
  return /* @__PURE__ */ m(Gi, { open: n, onOpenChange: o, children: /* @__PURE__ */ m(
    Vf,
    {
      isPending: i,
      variety: "danger",
      title: a(`delete${e}_event_type`),
      confirmBtnText: a("confirm_delete_event_type"),
      loadingText: a("confirm_delete_event_type"),
      onConfirm: (s) => {
        s.preventDefault(), r(t);
      },
      children: /* @__PURE__ */ m("p", { className: "mt-5", children: e ? /* @__PURE__ */ Y("ul", { className: "ml-4 list-disc", children: [
        /* @__PURE__ */ m("li", { children: a("delete_managed_event_type_description_1") }),
        /* @__PURE__ */ m("li", { children: a("delete_managed_event_type_description_2") })
      ] }) : a("delete_event_type_description") })
    }
  ) });
}
function mJl({
  children: e,
  eventType: t,
  currentUserMembership: n,
  team: o,
  disableBorder: r,
  isUpdateMutationLoading: i,
  formMethods: a,
  isUserOrganizationAdmin: s,
  bookerUrl: c,
  onDelete: l,
  isDeleting: d,
  isPlatform: u,
  tabsNavigation: _,
  allowDelete: p = !0,
  saveButtonRef: f
}) {
  var P, x, w, E, T;
  const { t: g } = Fe(), h = (w = (x = (P = t.team) == null ? void 0 : P.parent) == null ? void 0 : x.organizationSettings) == null ? void 0 : w.lockEventTypeCreationForUsers, [b, v] = ze(!1), $ = (n == null ? void 0 : n.role) !== "MEMBER" || !n || a.getValues("schedulingType") === aa.MANAGED || s, { isManagedEventType: k, isChildrenManagedEventType: S } = dm({
    eventType: t,
    translate: g,
    formMethods: a
  }), O = _, I = `${c}/${o ? `${o.parentId ? "" : "team/"}${o.slug}` : a.getValues("users")[0].username}/${t.slug}`, D = `${o ? `team/${o.slug}` : a.getValues("users")[0].username}/${a.getValues("slug")}`, M = a.getValues("schedulingType") === aa.MANAGED ? "_managed" : "", [N] = Tt(() => u ? [cge] : [age], [u]), C = (E = t.team) == null ? void 0 : E.id;
  return /* @__PURE__ */ Y(
    N,
    {
      backPath: C ? `/event-types?teamId=${C}` : "/event-types",
      title: `${t.title} | ${g("event_type")}`,
      heading: t.title,
      CTA: /* @__PURE__ */ Y("div", { className: "flex items-center justify-end", children: [
        !((T = a.getValues("metadata")) != null && T.managedEventConfig) && /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "sm:hover:bg-muted hidden cursor-pointer items-center rounded-md transition",
                a.watch("hidden") ? "pl-2" : "",
                "lg:flex"
              ),
              children: [
                a.watch("hidden") && /* @__PURE__ */ m(
                  Ks,
                  {
                    as: Xn,
                    htmlFor: "hiddenSwitch",
                    className: "mt-2 hidden cursor-pointer self-center whitespace-nowrap pr-2 sm:inline",
                    children: g("hidden")
                  }
                ),
                /* @__PURE__ */ m(
                  Ao,
                  {
                    sideOffset: 4,
                    content: a.watch("hidden") ? g("show_eventtype_on_profile") : g("hide_from_profile"),
                    side: "bottom",
                    children: /* @__PURE__ */ m("div", { className: "self-center rounded-md p-2", children: /* @__PURE__ */ m(
                      Ri,
                      {
                        id: "hiddenSwitch",
                        disabled: h,
                        checked: !a.watch("hidden"),
                        onCheckedChange: (z) => {
                          a.setValue("hidden", !z, { shouldDirty: !0 });
                        }
                      }
                    ) })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(IE, { className: "hidden lg:block" })
        ] }),
        /* @__PURE__ */ Y(HA, { combined: !0, containerProps: { className: "border-default hidden lg:flex" }, children: [
          !k && /* @__PURE__ */ Y(Ce, { children: [
            !u && /* @__PURE__ */ m(Ao, { content: g("preview"), side: "bottom", sideOffset: 4, children: /* @__PURE__ */ m(
              ut,
              {
                color: "secondary",
                "data-testid": "preview-button",
                target: "_blank",
                variant: "icon",
                href: I,
                rel: "noreferrer",
                StartIcon: "external-link"
              }
            ) }),
            !u && /* @__PURE__ */ m(
              ut,
              {
                color: "secondary",
                variant: "icon",
                StartIcon: "link",
                tooltip: g("copy_link"),
                tooltipSide: "bottom",
                tooltipOffset: 4,
                onClick: () => {
                  navigator.clipboard.writeText(I), nr("Link copied!", "success");
                }
              }
            ),
            !u && /* @__PURE__ */ m(
              _Jl,
              {
                embedUrl: encodeURIComponent(D),
                StartIcon: "code",
                color: "secondary",
                variant: "icon",
                namespace: t.slug,
                tooltip: g("embed"),
                tooltipSide: "bottom",
                tooltipOffset: 4,
                eventId: a.getValues("id")
              }
            )
          ] }),
          !S && p && /* @__PURE__ */ m(
            ut,
            {
              color: "destructive",
              variant: "icon",
              StartIcon: "trash",
              tooltip: g("delete"),
              tooltipSide: "bottom",
              tooltipOffset: 4,
              disabled: !$,
              onClick: () => v(!0)
            }
          )
        ] }),
        (!u || u && p) && /* @__PURE__ */ m(IE, { className: "hidden lg:block" }),
        /* @__PURE__ */ Y(El, { children: [
          /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { className: "lg:hidden", StartIcon: "ellipsis", variant: "icon", color: "secondary" }) }),
          /* @__PURE__ */ Y(Uc, { style: { minWidth: "200px" }, children: [
            /* @__PURE__ */ m(Er, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ei,
              {
                target: "_blank",
                type: "button",
                StartIcon: "external-link",
                href: I,
                rel: "noreferrer",
                children: g("preview")
              }
            ) }),
            /* @__PURE__ */ m(Er, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                StartIcon: "link",
                onClick: () => {
                  navigator.clipboard.writeText(I), nr("Link copied!", "success");
                },
                children: g("copy_link")
              }
            ) }),
            p && /* @__PURE__ */ m(Er, { className: "focus:ring-muted", children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                color: "destructive",
                StartIcon: "trash",
                disabled: !$,
                onClick: () => v(!0),
                children: g("delete")
              }
            ) }),
            /* @__PURE__ */ m(kE, {}),
            /* @__PURE__ */ Y("div", { className: "hover:bg-subtle flex h-9 cursor-pointer flex-row items-center justify-between px-4 py-2 transition", children: [
              /* @__PURE__ */ m(
                Ks,
                {
                  as: Xn,
                  htmlFor: "hiddenSwitch",
                  className: "mt-2 inline cursor-pointer self-center pr-2 ",
                  children: a.watch("hidden") ? g("show_eventtype_on_profile") : g("hide_from_profile")
                }
              ),
              /* @__PURE__ */ m(
                Ri,
                {
                  id: "hiddenSwitch",
                  checked: !a.watch("hidden"),
                  onCheckedChange: (z) => {
                    a.setValue("hidden", !z, { shouldDirty: !0 });
                  }
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ m("div", { className: "border-default border-l-2" }),
        /* @__PURE__ */ m(
          ut,
          {
            ref: f,
            className: "ml-4 lg:ml-0",
            type: "submit",
            loading: i,
            disabled: !a.formState.isDirty,
            "data-testid": "update-eventtype",
            form: "event-type-form",
            children: g("save")
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ m(IT, { fallback: /* @__PURE__ */ m("div", { className: "flex h-64 items-center justify-center", children: /* @__PURE__ */ m(ot, { name: "loader", className: "h-5 w-5 animate-spin" }) }), children: /* @__PURE__ */ Y("div", { className: "flex flex-col xl:flex-row xl:space-x-6", children: [
          /* @__PURE__ */ m("div", { className: "hidden xl:block", children: /* @__PURE__ */ m(
            WQl,
            {
              className: "primary-navigation w-64",
              tabs: O,
              sticky: !0,
              linkShallow: !0,
              itemClassname: "items-start"
            }
          ) }),
          /* @__PURE__ */ m("div", { className: "p-2 md:mx-0 md:p-0 xl:hidden", children: /* @__PURE__ */ m(Ube, { tabs: O, linkShallow: !0 }) }),
          /* @__PURE__ */ m("div", { className: "w-full ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(
            "div",
            {
              className: ae(
                "bg-default border-subtle  mt-4 rounded-md sm:mx-0 xl:mt-0",
                r ? "border-0 " : "p-2 md:border md:p-6"
              ),
              children: e
            }
          ) })
        ] }) }),
        /* @__PURE__ */ m(
          pJl,
          {
            eventTypeId: t.id,
            isManagedEvent: M,
            open: b,
            onOpenChange: v,
            onDelete: l,
            isDeleting: d
          }
        ),
        !u && /* @__PURE__ */ m(uJl, {})
      ]
    }
  );
}
const fJl = ({
  formMethods: e,
  isPlatform: t,
  tabName: n,
  eventType: o,
  team: r,
  currentUserMembership: i,
  tabMap: a,
  isUpdating: s,
  isUserOrganizationAdmin: c,
  onDelete: l,
  isDeleting: d,
  tabsNavigation: u,
  handleSubmit: _,
  children: p,
  allowDelete: f = !0,
  saveButtonRef: g
}) => {
  const [h] = xl();
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      mJl,
      {
        eventType: o,
        team: r,
        isUpdateMutationLoading: s,
        formMethods: e,
        disableBorder: !0,
        currentUserMembership: i,
        bookerUrl: o.bookerUrl,
        isUserOrganizationAdmin: c,
        onDelete: l,
        isDeleting: d,
        isPlatform: t,
        allowDelete: f,
        tabsNavigation: u,
        saveButtonRef: g,
        children: /* @__PURE__ */ m(fd, { form: e, id: "event-type-form", handleSubmit: _, children: /* @__PURE__ */ m("div", { ref: h, children: a[n] }) })
      }
    ),
    p
  ] });
};
function gJl(e) {
  const { t } = Fe(), { slugExistsChildrenDialogOpen: n, slug: o, onOpenChange: r, isPending: i, onConfirm: a } = e;
  return /* @__PURE__ */ m(Ff, { open: n.length > 0, onOpenChange: r, children: /* @__PURE__ */ Y(
    Vf,
    {
      isPending: i,
      variety: "warning",
      title: t("managed_event_dialog_title", {
        slug: o,
        count: n.length
      }),
      confirmBtnText: t("managed_event_dialog_confirm_button", {
        count: n.length
      }),
      cancelBtnText: t("go_back"),
      onConfirm: a,
      children: [
        /* @__PURE__ */ m("p", { className: "mt-5", children: /* @__PURE__ */ m(
          Dc,
          {
            t,
            i18nKey: n.length > 1 ? "managed_event_dialog_information_other" : "managed_event_dialog_information_one",
            values: {
              names: `${n.map((s) => s.owner.name).slice(0, -1).join(", ")} ${n.length > 1 ? t("and") : ""} ${n.map((s) => s.owner.name).slice(-1)}`,
              slug: o
            }
          }
        ) }),
        " ",
        /* @__PURE__ */ m("p", { className: "mt-5", children: t("managed_event_dialog_clarification") })
      ]
    }
  ) });
}
const hJl = ({ onSuccess: e, onError: t, onSettled: n }) => Yo({
  onSuccess: e,
  onError: t,
  onSettled: n,
  mutationFn: (o) => {
    if (!o)
      throw new Error("Event type id is required");
    const r = `/${Pi.eventTypes}/${o}`;
    return He == null ? void 0 : He.delete(r).then((i) => {
      if (i.data.status === qt)
        return i.data.data;
      throw new Error(i.data.error.message);
    });
  }
}), vJl = ({
  onSuccess: e,
  onError: t,
  onSettled: n
}) => {
  const { organizationId: o } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: ({ eventTypeId: r, teamId: i }) => {
      if (!r)
        throw new Error("Event type id is required");
      if (!i)
        throw new Error("team id is required");
      if (!o)
        throw new Error("organization id is required");
      const a = `/organizations/${o}/teams/${i}/${Pi.eventTypes}/${r}`;
      return He == null ? void 0 : He.delete(a).then((s) => {
        if (s.data.status === qt)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, TL = "use-event-by-id", bJl = (e) => {
  const t = `/atoms/${Pi.eventTypes}/${e}`, { isInit: n, accessToken: o } = po();
  return go({
    queryKey: [TL, e],
    queryFn: () => He == null ? void 0 : He.get(t).then((r) => {
      if (r.data.status === qt)
        return r.data.data;
      throw new Error(r.data.error.message);
    }),
    enabled: !!e && n && !!o
  });
}, yJl = ({
  onSuccess: e = () => {
  },
  onError: t = () => {
  },
  onSettled: n = () => {
  },
  teamId: o
}) => {
  const { organizationId: r } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i.id)
        throw new Error("Event type id is required");
      let a = `/atoms/${Pi.eventTypes}/${i.id}`;
      return o && (a = `/atoms/organizations/${r}/teams/${o}/${Pi.eventTypes}/${i.id}`), He == null ? void 0 : He.patch(a, i).then((s) => {
        if (s.data.status === qt)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, $Jl = (e, t = !1) => {
  let n = 0;
  for (const o in e == null ? void 0 : e.apps) {
    const r = e == null ? void 0 : e.apps[o];
    "appCategories" in r ? r.appCategories.includes("payment") && r.enabled && n++ : "price" in r && r.enabled && n++;
  }
  return t ? n >= 1 : n > 1;
}, wJl = $Jl, Qbe = G.enum(["CHECK_IN_APPOINTMENT", "CUSTOM_TEMPLATE"]), Jbe = G.object({
  yourPhoneNumber: G.string().refine((e) => Qw(e)),
  numberToCall: G.string().refine((e) => Qw(e)),
  calApiKey: G.string().trim().min(1, {
    message: "Please enter CAL API Key"
  }),
  eventTypeId: G.number(),
  enabled: G.boolean().default(!1),
  templateType: Qbe
}), kJl = Jbe.merge(
  G.object({
    schedulerName: G.string().min(1).optional().nullable(),
    guestName: G.string().optional().transform((e) => e || void 0),
    guestEmail: G.string().optional().transform((e) => e || void 0),
    guestCompany: G.string().optional().transform((e) => e || void 0),
    beginMessage: G.string().optional(),
    generalPrompt: G.string().optional()
  })
);
G.object({
  phone_number: G.string(),
  agent_id: G.string().optional(),
  nickname: G.string(),
  inbound_agent_id: G.string(),
  outbound_agent_id: G.string(),
  error_message: G.string().optional()
}).passthrough();
G.object({
  call_id: G.string(),
  agent_id: G.string().optional()
}).passthrough();
Jbe.merge(
  G.object({
    schedulerName: G.string().min(1)
  })
), kJl.omit({ generalPrompt: !0 }).merge(
  G.object({
    generalPrompt: G.string()
  })
);
const SJl = G.enum([
  "name",
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "address",
  "multiemail",
  "select",
  "multiselect",
  "checkbox",
  "radio",
  "radioInput",
  "boolean"
]), xJl = G.enum([
  "schedulerName",
  "generalPrompt",
  "guestName",
  "guestEmail",
  "guestCompany",
  "beginMessage"
]), EJl = G.object({
  type: SJl,
  name: xJl,
  required: G.boolean(),
  defaultLabel: G.string(),
  placeholder: G.string(),
  variableName: G.string().optional()
});
G.array(EJl);
G.object({
  llm_id: G.string(),
  llm_websocket_url: G.string().optional(),
  inbound_dynamic_variables_webhook_url: G.string().optional()
}).passthrough();
G.object({
  general_prompt: G.string(),
  begin_message: G.string().nullable().optional(),
  llm_id: G.string(),
  llm_websocket_url: G.string().optional(),
  inbound_dynamic_variables_webhook_url: G.string().optional(),
  general_tools: G.array(
    G.object({
      name: G.string(),
      type: G.string(),
      cal_api_key: G.string().optional(),
      event_type_id: G.number().optional(),
      timezone: G.string().optional()
    }).passthrough()
  ),
  states: G.array(
    G.object({
      name: G.string(),
      tools: G.array(
        G.object({
          name: G.string(),
          type: G.string(),
          cal_api_key: G.string().optional(),
          event_type_id: G.number().optional(),
          timezone: G.string().optional()
        }).passthrough()
      )
    }).passthrough()
  ).nullable().optional()
}).passthrough();
G.object({
  phone_number: G.string(),
  phone_number_type: G.string(),
  phone_number_pretty: G.string(),
  inbound_agent_id: G.string().optional().nullable(),
  outbound_agent_id: G.string().optional().nullable(),
  inbound_agent_version: G.number().optional().nullable(),
  outbound_agent_version: G.number().optional().nullable(),
  area_code: G.number().optional().nullable(),
  nickname: G.string(),
  inbound_webhook_url: G.string().url().optional().nullable(),
  last_modification_timestamp: G.number()
});
G.object({
  agent_id: G.string(),
  agent_name: G.string()
});
Qbe.enum.CHECK_IN_APPOINTMENT + "";
const TJl = `## You are helping user set up a call with the support team. The appointment is 15 min long. You are a pleasant and friendly.

  ## Style Guardrails
  Be Concise: Respond succinctly, addressing one topic at most.
  Embrace Variety: Use diverse language and rephrasing to enhance clarity without repeating content.
  Be Conversational: Use everyday language, making the chat feel like talking to a friend.
  Be Proactive: Lead the conversation, often wrapping up with a question or next-step suggestion.
  Avoid multiple questions in a single response.
  Get clarity: If the user only partially answers a question, or if the answer is unclear, keep asking to get clarity.
  Use a colloquial way of referring to the date (like Friday, Jan 14th, or Tuesday, Jan 12th, 2024 at 8am).
  If you are saying a time like 8:00 AM, just say 8 AM and omit the trailing zeros.

  ## Response Guideline
  Adapt and Guess: Try to understand transcripts that may contain transcription errors. Avoid mentioning "transcription error" in the response.
  Stay in Character: Keep conversations within your role'''s scope, guiding them back creatively without repeating.
  Ensure Fluid Dialogue: Respond in a role-appropriate, direct manner to maintain a smooth conversation flow.

  ## Schedule Rule
  Current time is {{current_time}}. You only schedule time in current calendar year, you cannot schedule time that'''s in the past.

  ## Task Steps
  1. I am here to learn more about your issue and help schedule an appointment with our support team.
  2. If {{ATTENDEE_EMAIL}} is not unknown then Use name {{ATTENDEE_NAME}} and email {{ATTENDEE_EMAIL}} for creating booking else Ask for user name and email and Confirm the name and email with user by reading it back to user.
  3. Ask user for "When would you want to meet with one of our representatives".
  4. Call function check_availability_{{eventTypeId}} to check for availability in the user provided time range.
    - if availability exists, inform user about the availability range (do not repeat the detailed available slot) and ask user to choose from it. Make sure user chose a slot within detailed available slot.
    - if availability does not exist, ask user to select another time range for the appointment, repeat this step 3.
  5. Confirm the date and time selected by user: "Just to confirm, you want to book the appointment at ...".
  6. Once confirmed, you can use {{user_number}} if it is not unknown else ask user for phone number in international format and use it for creating booking if it is a required field and call function book_appointment_{{eventTypeId}} to book the appointment.
    - if booking returned booking detail, it means booking is successful, proceed to step 7.
    - if booking returned error message, let user know why the booking was not successful, and maybe start over with step 3.
  7. Inform the user booking is successful, and ask if user have any questions. Answer them if there are any.
  8. After all questions answered, call function end_call to hang up.`, AJl = "Hi. How are you doing?";
function Xbe({
  hosts: e,
  hostGroups: t
}) {
  const n = {}, o = t && t.length > 0;
  return o ? t.forEach((r) => {
    n[r.id] = [];
  }) : n[Mx] = [], e.forEach((r) => {
    const i = o && r.groupId ? r.groupId : Mx;
    n[i] && n[i].push(r);
  }), n;
}
function e8(e, t) {
  return e.filter(
    (n) => t && (!n.groupId || n.groupId !== t) || !t && n.groupId
  );
}
function eye({ t: e }) {
  return /* @__PURE__ */ m(
    Dc,
    {
      t: e,
      i18nKey: "weights_description",
      components: [
        /* @__PURE__ */ m(
          Po,
          {
            className: "underline underline-offset-2",
            target: "_blank",
            href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#weights",
            children: "Learn more"
          },
          "weights_description"
        )
      ]
    }
  );
}
const CJl = (e) => {
  const { t } = Fe(), { isOpenDialog: n, setIsOpenDialog: o, option: r, options: i, onChange: a, customClassNames: s } = e, { getValues: c } = Dn(), l = [
    { label: t("lowest"), value: 0 },
    { label: t("low"), value: 1 },
    { label: t("medium"), value: 2 },
    { label: t("high"), value: 3 },
    { label: t("highest"), value: 4 }
  ], [d, u] = ze(), _ = () => {
    if (d) {
      const p = c("hosts"), f = c("isRRWeightsEnabled"), g = c("hostGroups"), h = p.filter((I) => !I.isFixed), b = Xbe({ hosts: h, hostGroups: g });
      let v = [];
      const $ = b[r.groupId ?? Mx];
      $ && (v = $.map((I) => ({
        ...r,
        value: I.userId.toString(),
        priority: I.userId === parseInt(r.value, 10) ? d.value : I.priority,
        isFixed: !1,
        weight: I.weight,
        groupId: I.groupId,
        userId: I.userId
      })).sort((I, D) => Xw(I, D, f)));
      const O = [...e8(h, r.groupId).map((I) => ({
        ...r,
        value: I.userId.toString(),
        priority: I.priority,
        weight: I.weight,
        isFixed: I.isFixed,
        groupId: I.groupId,
        userId: I.userId
      })), ...v];
      a(O);
    }
    o(!1);
  };
  return /* @__PURE__ */ m(Gi, { open: n, onOpenChange: o, children: /* @__PURE__ */ Y(Ei, { title: t("set_priority"), children: [
    /* @__PURE__ */ Y("div", { className: ae("mb-4", s == null ? void 0 : s.container), children: [
      /* @__PURE__ */ m(Xn, { className: s == null ? void 0 : s.label, children: t("priority_for_user", { userName: r.label }) }),
      /* @__PURE__ */ m(
        Tr,
        {
          defaultValue: l[r.priority ?? 2],
          className: s == null ? void 0 : s.select,
          innerClassNames: s == null ? void 0 : s.innerClassNames,
          value: d,
          onChange: (p) => u(p ?? l[2]),
          options: l
        }
      )
    ] }),
    /* @__PURE__ */ Y(Fc, { children: [
      /* @__PURE__ */ m(ca, { onClick: () => u(void 0) }),
      /* @__PURE__ */ m(ut, { onClick: _, className: s == null ? void 0 : s.confirmButton, children: t("confirm") })
    ] })
  ] }) });
};
function Xw(e, t, n) {
  const o = e.weight ?? 100, r = e.priority ?? 2, i = t.weight ?? 100, a = t.priority ?? 2;
  return n ? o === i ? a - r : i - o : a - r;
}
const zJl = (e) => {
  var _, p, f, g;
  const { t } = Fe(), { isOpenDialog: n, setIsOpenDialog: o, option: r, options: i, onChange: a, customClassNames: s } = e, { getValues: c } = Dn(), [l, d] = ze(), u = () => {
    if (l) {
      const h = c("hosts"), b = c("isRRWeightsEnabled"), v = c("hostGroups"), $ = h.filter((P) => !P.isFixed), k = Xbe({ hosts: $, hostGroups: v }), S = (P) => P.userId === parseInt(r.value, 10) ? { ...P, weight: l } : P;
      let O = [];
      const I = k[r.groupId ?? Mx];
      I && (O = I.map((P) => {
        const x = i.find((E) => E.value === P.userId.toString());
        return {
          ...S(P),
          avatar: (x == null ? void 0 : x.avatar) ?? "",
          label: (x == null ? void 0 : x.label) ?? P.userId.toString()
        };
      }).sort((P, x) => Xw(P, x, b)));
      const D = O.map((P) => ({
        avatar: P.avatar,
        label: P.label,
        value: P.userId.toString(),
        priority: P.priority,
        weight: P.weight,
        isFixed: P.isFixed,
        groupId: P.groupId
      })), C = [...e8($, r.groupId).map((P) => {
        const x = i.find((w) => w.value === P.userId.toString());
        return {
          avatar: (x == null ? void 0 : x.avatar) ?? "",
          label: (x == null ? void 0 : x.label) ?? P.userId.toString(),
          value: P.userId.toString(),
          priority: P.priority,
          weight: P.weight,
          isFixed: P.isFixed,
          groupId: P.groupId
        };
      }), ...D];
      a(C);
    }
    o(!1);
  };
  return /* @__PURE__ */ m(Gi, { open: n, onOpenChange: o, children: /* @__PURE__ */ Y(Ei, { title: t("set_weight"), description: /* @__PURE__ */ m(eye, { t }), children: [
    /* @__PURE__ */ Y("div", { className: ae("mb-4 mt-2", s == null ? void 0 : s.container), children: [
      /* @__PURE__ */ m(Xn, { className: s == null ? void 0 : s.label, children: t("weight_for_user", { userName: r.label }) }),
      /* @__PURE__ */ m("div", { className: ae("w-36", (_ = s == null ? void 0 : s.weightInput) == null ? void 0 : _.container), children: /* @__PURE__ */ m(
        Io,
        {
          required: !0,
          min: 0,
          className: (p = s == null ? void 0 : s.weightInput) == null ? void 0 : p.input,
          labelClassName: (f = s == null ? void 0 : s.weightInput) == null ? void 0 : f.label,
          addOnClassname: (g = s == null ? void 0 : s.weightInput) == null ? void 0 : g.addOn,
          label: t("Weight"),
          value: l,
          defaultValue: r.weight ?? 100,
          type: "number",
          onChange: (h) => d(parseInt(h.target.value)),
          addOnSuffix: /* @__PURE__ */ m(Ce, { children: "%" })
        }
      ) })
    ] }),
    /* @__PURE__ */ Y(Fc, { children: [
      /* @__PURE__ */ m(ca, { onClick: () => d(void 0) }),
      /* @__PURE__ */ m(ut, { onClick: u, className: s == null ? void 0 : s.confirmButton, children: t("confirm") })
    ] })
  ] }) });
}, OJl = G.object({
  firstName: G.string(),
  lastName: G.string().optional()
});
function PJl(e) {
  return typeof e == "string" ? e : typeof e == "object" && OJl.parse(e) ? `${e.firstName} ${e.lastName}`.trim() : "Nameless";
}
function tye(e, t = !1) {
  var l;
  const n = PJl(e.attendeeName);
  if (!e.eventName)
    return e.t("event_between_users", {
      eventName: e.eventType,
      host: e.teamName || e.host,
      attendeeName: n,
      interpolation: {
        escapeValue: !1
      }
    });
  let o = e.eventName, r = e.location || "";
  if (e.eventName.includes("{Location}") || e.eventName.includes("{LOCATION}")) {
    const d = OQ(e.location);
    d && (r = d.label), o = o.replace("{Location}", r), o = o.replace("{LOCATION}", r);
  }
  let i = o.replaceAll("{Event type title}", e.eventType).replaceAll("{Scheduler}", n).replaceAll("{Organiser}", e.host).replaceAll("{Organiser first name}", e.host.split(" ")[0]).replaceAll("{USER}", n).replaceAll("{ATTENDEE}", n).replaceAll("{HOST}", e.host).replaceAll("{HOST/ATTENDEE}", t ? e.host : n).replaceAll("{Event duration}", `${String(e.eventDuration)} mins`).replaceAll(
    "{Scheduler first name}",
    n === e.t("scheduler") ? "{Scheduler first name}" : n.split(" ")[0]
  );
  const { bookingFields: a } = e || {}, { name: s } = a || {};
  s && typeof s == "object" && !Array.isArray(s) && typeof s.lastName == "string" && (i = i.replaceAll("{Scheduler last name}", s.lastName.toString()));
  const c = (l = i.match(/\{(.+?)}/g)) == null ? void 0 : l.map((d) => d.replace("{", "").replace("}", ""));
  return c == null || c.forEach((d) => {
    var _, p;
    if (!e.bookingFields)
      return;
    const u = e.bookingFields[d];
    if (u) {
      let f;
      if (typeof u == "object") {
        if ("value" in u) {
          const g = (_ = u.value) == null ? void 0 : _.toString();
          f = d === "location" && ((p = OQ(g)) == null ? void 0 : p.label) || g;
        } else if (d === "name" && "firstName" in u) {
          const g = "lastName" in u ? u.lastName : "";
          f = `${u.firstName} ${g}`.trim();
        }
      } else
        f = u.toString();
      i = i.replace(`{${d}}`, f || "");
    } else
      i = i.replace(`{${d}}`, "");
  }), i;
}
const nye = (e, t) => {
  let n = [];
  t && (n = Object.keys(t).map((i) => `{${i}}`));
  const o = n.concat([
    "{Event type title}",
    "{Organiser}",
    "{Scheduler}",
    "{Location}",
    "{Organiser first name}",
    "{Scheduler first name}",
    "{Scheduler last name}",
    "{Event duration}",
    //allowed for fallback reasons
    "{LOCATION}",
    "{HOST/ATTENDEE}",
    "{HOST}",
    "{ATTENDEE}",
    "{USER}"
  ]), r = e.match(/\{([^}]+)\}/g);
  if (r != null && r.length) {
    for (const i of r)
      if (!o.includes(i))
        return i;
  }
  return !0;
}, eT = ["PER_DAY", "PER_WEEK", "PER_MONTH", "PER_YEAR"];
function IJl(e) {
  return ["day", "week", "month", "year"].includes(e);
}
function RJl(e) {
  const t = e.split("_")[1].toLowerCase();
  if (IJl(t))
    return t;
  throw new Error(`Invalid interval limit key: ${e}`);
}
const lX = (e) => {
  const t = Object.entries(e).sort(([, o], [, r]) => o - r).map(([o]) => o), n = eT.filter((o) => t.includes(o));
  return t.every((o, r) => n[r] === o);
}, NJl = (e) => {
  if (e === null)
    return;
  if (!((e == null ? void 0 : e.enabledLayouts.length) > 0))
    return "bookerlayout_error_min_one_enabled";
  if (!(e == null ? void 0 : e.enabledLayouts.find(
    (i) => i === e.defaultLayout
  )))
    return "bookerlayout_error_default_not_enabled";
  const o = e == null ? void 0 : e.enabledLayouts.every(
    (i) => nu.includes(i)
  ), r = nu.includes(e.defaultLayout);
  if (!o || !r)
    return "bookerlayout_error_unknown_layout";
}, DJl = ({
  eventType: e,
  onSubmit: t,
  onFormStateChange: n
}) => {
  const { t: o } = Fe(), [r] = ze({
    startDate: new Date(e.periodStartDate || Date.now()),
    endDate: new Date(e.periodEndDate || Date.now())
  }), i = Tt(() => {
    var g, h, b, v, $, k, S, O, I, D;
    return {
      title: e.title,
      id: e.id,
      slug: e.slug,
      afterEventBuffer: e.afterEventBuffer,
      beforeEventBuffer: e.beforeEventBuffer,
      eventName: e.eventName || "",
      scheduleName: e.scheduleName,
      periodDays: e.periodDays,
      requiresBookerEmailVerification: e.requiresBookerEmailVerification,
      seatsPerTimeSlot: e.seatsPerTimeSlot,
      seatsShowAttendees: e.seatsShowAttendees,
      seatsShowAvailabilityCount: e.seatsShowAvailabilityCount,
      lockTimeZoneToggleOnBookingPage: e.lockTimeZoneToggleOnBookingPage,
      lockedTimeZone: e.lockedTimeZone || null,
      locations: e.locations || [],
      destinationCalendar: e.destinationCalendar,
      recurringEvent: e.recurringEvent || null,
      isInstantEvent: e.isInstantEvent,
      instantMeetingParameters: e.instantMeetingParameters || [],
      instantMeetingExpiryTimeOffsetInSeconds: e.instantMeetingExpiryTimeOffsetInSeconds,
      description: e.description ?? void 0,
      schedule: e.schedule || void 0,
      instantMeetingSchedule: e.instantMeetingSchedule || void 0,
      bookingLimits: e.bookingLimits || void 0,
      onlyShowFirstAvailableSlot: e.onlyShowFirstAvailableSlot || void 0,
      durationLimits: e.durationLimits || void 0,
      length: e.length,
      hidden: e.hidden,
      multiplePrivateLinks: e.hashedLink.map((M) => ({
        link: M.link,
        expiresAt: M.expiresAt,
        maxUsageCount: M.maxUsageCount
      })),
      eventTypeColor: e.eventTypeColor || null,
      periodDates: {
        startDate: r.startDate,
        endDate: r.endDate
      },
      hideCalendarNotes: e.hideCalendarNotes,
      hideCalendarEventDetails: e.hideCalendarEventDetails,
      offsetStart: e.offsetStart,
      bookingFields: e.bookingFields,
      periodType: e.periodType,
      periodCountCalendarDays: !!e.periodCountCalendarDays,
      schedulingType: e.schedulingType,
      requiresConfirmation: e.requiresConfirmation,
      canSendCalVideoTranscriptionEmails: e.canSendCalVideoTranscriptionEmails,
      requiresConfirmationWillBlockSlot: e.requiresConfirmationWillBlockSlot,
      requiresConfirmationForFreeEmail: e.requiresConfirmationForFreeEmail,
      slotInterval: e.slotInterval,
      minimumBookingNotice: e.minimumBookingNotice,
      allowReschedulingPastBookings: e.allowReschedulingPastBookings,
      hideOrganizerEmail: e.hideOrganizerEmail,
      metadata: e.metadata,
      hosts: e.hosts.sort((M, N) => Xw(M, N, e.isRRWeightsEnabled)),
      hostGroups: e.hostGroups || [],
      successRedirectUrl: e.successRedirectUrl || "",
      forwardParamsSuccessRedirect: e.forwardParamsSuccessRedirect,
      users: e.users,
      useEventTypeDestinationCalendarEmail: e.useEventTypeDestinationCalendarEmail,
      secondaryEmailId: (e == null ? void 0 : e.secondaryEmailId) || -1,
      children: e.children.map((M) => {
        var N, C;
        return {
          ...M,
          created: !0,
          owner: {
            ...M.owner,
            eventTypeSlugs: ((C = (N = e.team) == null ? void 0 : N.members.find((P) => P.user.id === M.owner.id)) == null ? void 0 : C.user.eventTypes.map((P) => P.slug).filter((P) => P !== e.slug)) ?? []
          }
        };
      }),
      seatsPerTimeSlotEnabled: e.seatsPerTimeSlot,
      autoTranslateDescriptionEnabled: e.autoTranslateDescriptionEnabled,
      rescheduleWithSameRoundRobinHost: e.rescheduleWithSameRoundRobinHost,
      assignAllTeamMembers: e.assignAllTeamMembers,
      assignRRMembersUsingSegment: e.assignRRMembersUsingSegment,
      rrSegmentQueryValue: e.rrSegmentQueryValue,
      aiPhoneCallConfig: {
        generalPrompt: ((g = e.aiPhoneCallConfig) == null ? void 0 : g.generalPrompt) ?? TJl,
        enabled: (h = e.aiPhoneCallConfig) == null ? void 0 : h.enabled,
        beginMessage: ((b = e.aiPhoneCallConfig) == null ? void 0 : b.beginMessage) ?? AJl,
        guestName: (v = e.aiPhoneCallConfig) == null ? void 0 : v.guestName,
        guestEmail: ($ = e.aiPhoneCallConfig) == null ? void 0 : $.guestEmail,
        guestCompany: (k = e.aiPhoneCallConfig) == null ? void 0 : k.guestCompany,
        yourPhoneNumber: (S = e.aiPhoneCallConfig) == null ? void 0 : S.yourPhoneNumber,
        numberToCall: (O = e.aiPhoneCallConfig) == null ? void 0 : O.numberToCall,
        templateType: ((I = e.aiPhoneCallConfig) == null ? void 0 : I.templateType) ?? "CUSTOM_TEMPLATE",
        schedulerName: (D = e.aiPhoneCallConfig) == null ? void 0 : D.schedulerName
      },
      isRRWeightsEnabled: e.isRRWeightsEnabled,
      maxLeadThreshold: e.maxLeadThreshold,
      includeNoShowInRRCalculation: e.includeNoShowInRRCalculation,
      useEventLevelSelectedCalendars: e.useEventLevelSelectedCalendars,
      customReplyToEmail: e.customReplyToEmail || null,
      calVideoSettings: e.calVideoSettings,
      maxActiveBookingsPerBooker: e.maxActiveBookingsPerBooker || null,
      maxActiveBookingPerBookerOfferReschedule: e.maxActiveBookingPerBookerOfferReschedule,
      showOptimizedSlots: e.showOptimizedSlots ?? !1
    };
  }, [e, r]), a = pd({
    defaultValues: i,
    resolver: ek(
      G.object({
        // Length if string, is converted to a number or it can be a number
        // Make it optional because it's not submitted from all tabs of the page
        eventName: G.string().superRefine((g, h) => {
          const b = {};
          a.getValues("bookingFields").forEach(({ name: k }) => {
            b[k] = k;
          });
          const $ = nye(g, b);
          $ !== !0 && h.addIssue({
            code: G.ZodIssueCode.custom,
            message: o("invalid_event_name_variables", { item: $ })
          });
        }).optional(),
        length: G.union([G.string().transform((g) => +g), G.number()]).optional(),
        offsetStart: G.union([G.string().transform((g) => +g), G.number()]).optional(),
        bookingFields: $le,
        locations: uul(o),
        calVideoSettings: G.object({
          redirectUrlOnExit: G.string().url().nullish(),
          disableRecordingForOrganizer: G.boolean().nullable(),
          disableRecordingForGuests: G.boolean().nullable(),
          enableAutomaticTranscription: G.boolean().nullable(),
          enableAutomaticRecordingForOrganizer: G.boolean().nullable(),
          disableTranscriptionForGuests: G.boolean().nullable(),
          disableTranscriptionForOrganizer: G.boolean().nullable()
        }).optional().nullable()
      }).passthrough()
    )
  }), {
    formState: { isDirty: s, dirtyFields: c }
  } = a, l = a.watch(), d = (g) => g !== null && typeof g == "object" && !Array.isArray(g), u = (g) => Array.isArray(g), _ = (g, h) => {
    const b = h.split(".");
    let v = g;
    for (let $ = 0; $ < b.length; $++) {
      const k = v[b[$]];
      if (k === void 0)
        return;
      v = k;
    }
    return v;
  }, p = (g) => {
    if (!s)
      return {};
    const h = (v) => {
      if (c[v] === !0)
        return !0;
      const $ = _(c, v);
      if (d($))
        for (const k in $) {
          if ($[k] === !0)
            return !0;
          if (d($[k]) || u($[k])) {
            const S = `${v}.${k}`;
            if (h(S))
              return !0;
          }
        }
      if (u($)) {
        for (const k of $)
          if (d(k))
            for (const S in k) {
              if (k[S] === !0)
                return !0;
              if (d(k[S]) || u(k[S])) {
                const O = `${v}.${S}`;
                if (h(O))
                  return !0;
              }
            }
          else if (k === !0)
            return !0;
      }
      return !1;
    }, b = {};
    return Object.keys(c).forEach((v) => {
      const $ = v;
      b[$] = void 0, h($) && (b[$] = g[$]);
    }), b;
  }, f = async (g) => {
    var te, ue, le;
    const { children: h } = g, b = p(g), v = Object.keys(b).length !== 0, {
      periodDates: $,
      periodCountCalendarDays: k,
      beforeEventBuffer: S,
      afterEventBuffer: O,
      seatsPerTimeSlot: I,
      seatsShowAttendees: D,
      seatsShowAvailabilityCount: M,
      bookingLimits: N,
      onlyShowFirstAvailableSlot: C,
      durationLimits: P,
      recurringEvent: x,
      eventTypeColor: w,
      customReplyToEmail: E,
      locations: T,
      metadata: z,
      customInputs: j,
      assignAllTeamMembers: q,
      // We don't need to send send these values to the backend
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      seatsPerTimeSlotEnabled: V,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      minimumBookingNoticeInDurationType: F,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      bookerLayouts: L,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      multipleDurationEnabled: U,
      length: W,
      ...H
    } = b;
    if (W && !Number(W))
      throw new Error(o("event_setup_length_error"));
    const Q = I === void 0 ? e.seatsPerTimeSlot : I, X = x === void 0 ? e.recurringEvent : x;
    if (Q && X)
      throw new Error(o("recurring_event_seats_error"));
    if (N && !lX(N))
      throw new Error(o("event_setup_booking_limits_error"));
    if (P && !lX(P))
      throw new Error(o("event_setup_duration_limits_error"));
    const re = NJl((z == null ? void 0 : z.bookerLayouts) || null);
    if (re)
      throw new Error(o(re));
    if ((z == null ? void 0 : z.multipleDuration) !== void 0) {
      if ((z == null ? void 0 : z.multipleDuration.length) < 1)
        throw new Error(o("event_setup_multiple_duration_error"));
      if (W !== void 0 && !W && !((te = z == null ? void 0 : z.multipleDuration) != null && te.includes(W)))
        throw new Error(o("event_setup_multiple_duration_default_error"));
    }
    if (wJl(z))
      throw new Error(o("event_setup_multiple_payment_apps_error"));
    if (((le = (ue = z == null ? void 0 : z.apps) == null ? void 0 : ue.stripe) == null ? void 0 : le.paymentOption) === "HOLD" && I)
      throw new Error(o("seats_and_no_show_fee_error"));
    const { availability: Z, users: ee, scheduleName: J, ...oe } = H, ce = {
      ...oe,
      length: W,
      locations: T,
      recurringEvent: x,
      periodStartDate: $ == null ? void 0 : $.startDate,
      periodEndDate: $ == null ? void 0 : $.endDate,
      periodCountCalendarDays: k,
      id: e.id,
      beforeEventBuffer: S,
      afterEventBuffer: O,
      bookingLimits: N,
      onlyShowFirstAvailableSlot: C,
      durationLimits: P,
      eventTypeColor: w,
      customReplyToEmail: E,
      seatsPerTimeSlot: I,
      seatsShowAttendees: D,
      seatsShowAvailabilityCount: M,
      metadata: z,
      customInputs: j,
      children: h,
      assignAllTeamMembers: q,
      multiplePrivateLinks: g.multiplePrivateLinks,
      aiPhoneCallConfig: oe.aiPhoneCallConfig ? { ...oe.aiPhoneCallConfig, templateType: oe.aiPhoneCallConfig.templateType } : void 0
    }, de = Object.entries(ce).reduce((se, [me, pe]) => (pe !== void 0 && (se[me] = pe), se), {});
    v && t({ ...de, id: e.id });
  };
  return Le(() => {
    n && n({
      isDirty: s,
      dirtyFields: c,
      values: l
    });
  }, [s, c, l, n]), { form: a, handleSubmit: f };
};
function MJl({
  assignedUsers: e,
  hosts: t,
  isManagedEventType: n,
  assignAllTeamMembers: o
}) {
  return o ? !1 : n ? e.length === 0 : t.length === 0;
}
const LJl = ({
  isTeamEventTypeDeleted: e,
  isleavingWithoutAssigningHosts: t,
  isTeamEventType: n,
  assignedUsers: o,
  hosts: r,
  assignAllTeamMembers: i,
  isManagedEventType: a,
  onError: s,
  onStart: c,
  onEnd: l,
  watchTrigger: d
}) => {
  Le(() => {
    const u = (_) => {
      const p = _.split("/");
      e || n && !t && (_ === "/event-types" || p[1] !== "event-types") && MJl({
        assignedUsers: o,
        hosts: r,
        assignAllTeamMembers: i,
        isManagedEventType: a
      }) && (s == null || s(_));
    };
    return c == null || c(u), () => {
      l == null || l(u);
    };
  }, [d, r, o, i, s, c, l]);
}, qJl = ({ formMethods: e, eventType: t, team: n, tabs: o }) => {
  var $;
  const [r, i] = ze(""), [a, s] = ze(o[0]);
  Le(() => {
    const k = window.location.href;
    i(k);
  }, []);
  const { t: c } = Fe(), l = e.watch("length"), d = ($ = e.watch("metadata")) == null ? void 0 : $.multipleDuration, u = e.watch("schedulingType"), _ = e.watch("children").length, p = e.watch("availability"), { isManagedEventType: f, isChildrenManagedEventType: g } = dm({
    eventType: t,
    translate: c,
    formMethods: e
  }), b = nm(t).price > 0;
  return { tabsNavigation: Tt(() => {
    const k = jJl({
      t: c,
      length: l,
      multipleDuration: d,
      id: e.getValues("id"),
      tabs: o,
      url: r,
      onClick: (S) => {
        s(S);
      },
      currentTab: a
    });
    return !b && o.includes("recurring") && k.splice(3, 0, {
      name: c("recurring"),
      onClick: () => s("recurring"),
      isActive: a === "recurring",
      href: `${r}?tabName=recurring`,
      icon: "repeat",
      info: c("recurring_event_tab_description"),
      "data-testid": "recurring"
    }), o.includes("availability") && k.splice(1, 0, {
      name: c("availability"),
      onClick: () => s("availability"),
      isActive: a === "availability",
      href: `${r}?tabName=availability`,
      icon: "calendar",
      info: f || g ? e.getValues("schedule") === null ? c("members_default_schedule") : g ? `${e.getValues("scheduleName") ? `${e.getValues("scheduleName")} - ${c("managed")}` : c("default_schedule_name")}` : e.getValues("scheduleName") ?? c("default_schedule_name") : e.getValues("scheduleName") ?? c("default_schedule_name"),
      "data-testid": "availability"
    }), n && o.includes("team") && k.splice(2, 0, {
      name: c("assignment"),
      onClick: () => s("team"),
      isActive: a === "team",
      href: `${r}?tabName=team`,
      icon: "users",
      info: `${c((u == null ? void 0 : u.toLowerCase()) ?? "")}${f ? ` - ${c("number_member", { count: _ || 0 })}` : ""}`,
      "data-testid": "assignment"
    }), k;
  }, [
    c,
    p,
    f,
    g,
    n,
    l,
    b,
    d,
    e.getValues("id"),
    u,
    _,
    r,
    o,
    a
  ]), currentTab: a };
};
function jJl({ length: e, multipleDuration: t, t: n, tabs: o, url: r, onClick: i, currentTab: a }) {
  const s = (t == null ? void 0 : t.map((l) => ` ${l}`)) || e, c = [];
  return o.includes("setup") && c.push({
    name: n("basics"),
    onClick: () => i("setup"),
    isActive: a === "setup",
    href: `${r}?tabName=setup`,
    icon: "link",
    info: `${s} ${n("minute_timeUnit")}`,
    // TODO: Get this from props
    "data-testid": "basics"
  }), o.includes("limits") && c.push({
    name: n("event_limit_tab_title"),
    onClick: () => i("limits"),
    isActive: a === "limits",
    href: `${r}?tabName=limits`,
    icon: "clock",
    info: n("event_limit_tab_description"),
    "data-testid": "event_limit_tab_title"
  }), o.includes("advanced") && c.push({
    name: n("event_advanced_tab_title"),
    onClick: () => i("advanced"),
    isActive: a === "advanced",
    href: `${r}?tabName=advanced`,
    icon: "sliders-vertical",
    info: n("event_advanced_tab_description"),
    "data-testid": "event_advanced_tab_title"
  }), o.includes("payments") && c.push({
    name: n("payments"),
    onClick: () => i("payments"),
    isActive: a === "payments",
    href: `${r}?tabName=payments`,
    icon: "credit-card",
    info: n("event_payments_tab_description"),
    "data-testid": "payments"
  }), c;
}
function oye(e) {
  const t = Zo(), n = Tt(
    () => hn(
      () => t ? import("./AppListCardPlatformWrapper-_fuIku6m.js") : import("./AppListCardWebWrapper-KxhUj5a7.js"),
      {
        ssr: !1
        // Prevents SSR issues if needed
      }
    ),
    [t]
  );
  return /* @__PURE__ */ m(n, { ...e });
}
function dX({
  credentialId: e,
  integrationType: t,
  cacheUpdatedAt: n,
  onSuccess: o,
  delegationCredentialId: r,
  disableConnectionModification: i
}) {
  const { t: a } = Fe(), [s, c] = ze(!1), [l, d] = ze(!1), [u, _] = ze(!1), p = bo.viewer.calendars.deleteCache.useMutation({
    onSuccess: () => {
      nr(a("cache_deleted_successfully"), "success"), o == null || o();
    },
    onError: () => {
      nr(a("error_deleting_cache"), "error");
    }
  }), f = bo.useUtils(), g = bo.viewer.credentials.delete.useMutation({
    onSuccess: () => {
      nr(a("app_removed_successfully"), "success"), o == null || o();
    },
    onError: () => {
      nr(a("error_removing_app"), "error");
    },
    async onSettled() {
      await f.viewer.calendars.connectedCalendars.invalidate(), await f.viewer.apps.integrations.invalidate();
    }
  }), h = t === hCe, b = !r && !i, v = h && n;
  return !b && !v ? null : /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y(El, { open: s, onOpenChange: c, children: [
      /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { type: "button", variant: "icon", color: "secondary", StartIcon: "ellipsis" }) }),
      /* @__PURE__ */ Y(Uc, { children: [
        v && /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ m(Er, { className: "focus:ring-muted", children: /* @__PURE__ */ Y("div", { className: "px-2 py-1", children: [
            /* @__PURE__ */ m("div", { className: "text-sm font-medium text-gray-900 dark:text-white", children: a("cache_status") }),
            /* @__PURE__ */ m("div", { className: "text-xs text-gray-500 dark:text-white", children: a("cache_last_updated", {
              timestamp: new Intl.DateTimeFormat("en-US", {
                dateStyle: "short",
                timeStyle: "short"
              }).format(new Date(n)),
              interpolation: { escapeValue: !1 }
            }) })
          ] }) }),
          /* @__PURE__ */ m(Er, { className: "outline-none", children: /* @__PURE__ */ m(
            ei,
            {
              type: "button",
              color: "destructive",
              StartIcon: "trash",
              onClick: () => {
                d(!0), c(!1);
              },
              children: a("delete_cached_data")
            }
          ) })
        ] }),
        b && v && /* @__PURE__ */ m("hr", { className: "my-1" }),
        b && /* @__PURE__ */ m(Er, { className: "outline-none", children: /* @__PURE__ */ m(
          ei,
          {
            type: "button",
            color: "destructive",
            StartIcon: "trash",
            onClick: () => {
              _(!0), c(!1);
            },
            children: a("remove_app")
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ m(Ff, { open: l, onOpenChange: d, children: /* @__PURE__ */ m(
      Vf,
      {
        variety: "danger",
        title: a("delete_cached_data"),
        confirmBtnText: a("yes_delete_cache"),
        onConfirm: () => {
          p.mutate({ credentialId: e }), d(!1);
        },
        children: a("confirm_delete_cache")
      }
    ) }),
    /* @__PURE__ */ m(Ff, { open: u, onOpenChange: _, children: /* @__PURE__ */ m(
      Vf,
      {
        variety: "danger",
        title: a("remove_app"),
        confirmBtnText: a("yes_remove_app"),
        onConfirm: () => {
          g.mutate({ id: e }), _(!1);
        },
        children: a("are_you_sure_you_want_to_remove_this_app")
      }
    ) })
  ] });
}
const FJl = ({ isPending: e }) => {
  const { t } = Fe(), [n] = bo.viewer.apps.integrations.useSuspenseQuery({ variant: "calendar", onlyInstalled: !0 }), o = n.items.map((r) => ({
    label: r.name,
    slug: r.slug,
    image: r.logo,
    type: r.type
  }));
  return o.push({
    label: "Add new calendars",
    slug: "add-new",
    image: "",
    type: "new_other"
  }), /* @__PURE__ */ Y(El, { modal: !1, children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { StartIcon: "plus", color: "secondary", ...e && { loading: e }, children: t("add") }) }),
    /* @__PURE__ */ m(Uc, { children: o.map((r) => /* @__PURE__ */ m(Er, { className: "focus:outline-none", children: r.slug === "add-new" ? /* @__PURE__ */ m(ei, { StartIcon: "plus", color: "minimal", href: "/apps/categories/calendar", children: t("install_new_calendar_app") }) : /* @__PURE__ */ m(
      rve,
      {
        type: r.type,
        render: (i) => {
          const a = { ...i };
          return /* @__PURE__ */ m(ei, { ...a, color: "minimal", type: "button", children: /* @__PURE__ */ Y("span", { className: "flex items-center gap-x-2", children: [
            r.image && /* @__PURE__ */ m("img", { className: "h-5 w-5", src: r.image, alt: r.label }),
            `${t("add")} ${r.label}`
          ] }) });
        }
      }
    ) }, r.slug)) })
  ] });
}, VJl = FJl, BJl = (e) => {
  const {
    title: t,
    externalId: n,
    type: o,
    isChecked: r,
    name: i,
    credentialId: a,
    delegationCredentialId: s,
    eventTypeId: c,
    disabled: l
  } = e, [d, u] = ze(r), _ = bo.useUtils(), { t: p } = Fe(), f = Yo({
    mutationFn: async ({ isOn: g }) => {
      const h = {
        integration: o,
        externalId: n,
        ...s && { delegationCredentialId: s },
        // new URLSearchParams does not accept numbers
        credentialId: String(a),
        ...c ? { eventTypeId: String(c) } : {}
      };
      if (g) {
        if (!(await fetch("/api/availability/calendar", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(h)
        })).ok)
          throw new Error("Something went wrong");
      } else if (!(await fetch(`/api/availability/calendar?${new URLSearchParams(h)}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        }
      })).ok)
        throw new Error("Something went wrong");
    },
    async onSettled() {
      await _.viewer.apps.integrations.invalidate(), await _.viewer.calendars.connectedCalendars.invalidate();
    },
    onError() {
      u(!1), nr(`Something went wrong when toggling "${t}"`, "error");
    }
  });
  return /* @__PURE__ */ Y("div", { className: ae("my-2 flex flex-row items-center"), children: [
    /* @__PURE__ */ m("div", { className: "flex pl-2", children: /* @__PURE__ */ m(
      Ri,
      {
        id: n,
        checked: d,
        disabled: l || f.isPending,
        onCheckedChange: async (g) => {
          u(g), await f.mutate({ isOn: g });
        }
      }
    ) }),
    /* @__PURE__ */ m(
      "label",
      {
        className: ae(
          "ml-3 break-all text-sm font-medium leading-5",
          l ? "cursor-not-allowed opacity-25" : "cursor-pointer"
        ),
        htmlFor: n,
        children: i
      }
    ),
    !!e.destination && /* @__PURE__ */ Y("span", { className: "bg-subtle text-default ml-8 inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-normal sm:ml-4", children: [
      /* @__PURE__ */ m(ot, { name: "arrow-left", className: "h-4 w-4" }),
      p("adding_events_to")
    ] }),
    f.isPending && /* @__PURE__ */ m(ot, { name: "rotate-cw", className: "text-muted h-4 w-4 animate-spin ltr:ml-1 rtl:mr-1" })
  ] });
};
var h$ = /* @__PURE__ */ ((e) => (e.User = "user", e.EventType = "eventType", e))(h$ || {});
const UJl = ({
  fromOnboarding: e = !1,
  scope: t,
  items: n,
  disableConnectionModification: o,
  eventTypeId: r,
  onChanged: i,
  destinationCalendarId: a,
  isDisabled: s
}) => {
  const { t: c } = Fe(), l = t === "eventType";
  return /* @__PURE__ */ m(WF, { noBorderTreatment: !0, className: "p-6 pt-2", children: n.map((d) => {
    var u, _;
    return d.calendars && d.calendars.length > 0 ? /* @__PURE__ */ m(
      oye,
      {
        shouldHighlight: !0,
        slug: d.integration.slug,
        title: d.integration.name,
        logo: d.integration.logo,
        description: ((u = d.primary) == null ? void 0 : u.email) ?? d.integration.description,
        className: "border-subtle mt-4 rounded-lg border",
        actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
          dX,
          {
            credentialId: d.credentialId,
            integrationType: d.integration.type,
            cacheUpdatedAt: d.cacheUpdatedAt,
            onSuccess: i,
            delegationCredentialId: d.delegationCredentialId,
            disableConnectionModification: o
          }
        ) }),
        children: /* @__PURE__ */ m("div", { className: "border-subtle border-t", children: !e && /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ m("p", { className: "text-subtle px-5 pt-4 text-sm", children: c("toggle_calendars_conflict") }),
          /* @__PURE__ */ m("ul", { className: "space-y-4 px-5 py-4", children: (_ = d.calendars) == null ? void 0 : _.map((p) => /* @__PURE__ */ m(
            BJl,
            {
              disabled: s,
              externalId: p.externalId,
              title: p.name || "Nameless calendar",
              name: p.name || "Nameless calendar",
              type: d.integration.type,
              isChecked: p.isSelected,
              destination: p.externalId === a,
              credentialId: p.credentialId,
              eventTypeId: l ? r : null,
              delegationCredentialId: d.delegationCredentialId || null
            },
            p.externalId
          )) })
        ] }) })
      },
      `list-${d.credentialId}-${t}`
    ) : /* @__PURE__ */ m(
      sa,
      {
        severity: "warning",
        title: c("something_went_wrong"),
        message: /* @__PURE__ */ Y("span", { children: [
          /* @__PURE__ */ m(Po, { href: `/apps/${d.integration.slug}`, children: d.integration.name }),
          ": ",
          c("calendar_error")
        ] }),
        iconClassName: "h-10 w-10 ml-2 mr-1 mt-0.5",
        actions: /* @__PURE__ */ m("div", { className: "flex w-32 justify-end", children: /* @__PURE__ */ m(
          dX,
          {
            credentialId: d.credentialId,
            integrationType: d.integration.type,
            cacheUpdatedAt: d.cacheUpdatedAt,
            onSuccess: i,
            delegationCredentialId: d.delegationCredentialId,
            disableConnectionModification: o
          }
        ) })
      },
      `alert-${d.credentialId}`
    );
  }) });
}, WJl = (e) => {
  var u, _, p;
  const {
    scope: t = "user",
    setScope: n = () => {
    },
    disabledScope: o,
    disableConnectionModification: r,
    eventTypeId: i = null
  } = e, a = bo.viewer.calendars.connectedCalendars.useQuery(
    {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      eventTypeId: t === "eventType" ? i : null
    },
    {
      suspense: !0,
      refetchOnWindowFocus: !1
    }
  ), { isPending: s } = e, c = !!e.eventTypeId, l = o ? o === t : !1, d = l || r;
  return /* @__PURE__ */ m("div", { children: /* @__PURE__ */ Y(xL, { classNames: e.classNames, children: [
    /* @__PURE__ */ m(
      GJl,
      {
        isConnectedCalendarsPresent: !!((u = a.data) != null && u.connectedCalendars.length),
        isPending: s,
        showScopeSelector: c,
        setScope: n,
        scope: t,
        shouldDisableConnectionModification: d
      }
    ),
    (_ = a.data) != null && _.connectedCalendars && ((p = a.data) == null ? void 0 : p.connectedCalendars.length) > 0 ? /* @__PURE__ */ m(
      UJl,
      {
        fromOnboarding: e.fromOnboarding,
        scope: t,
        disableConnectionModification: r,
        onChanged: e.onChanged,
        eventTypeId: i,
        items: a.data.connectedCalendars,
        isDisabled: l
      }
    ) : null
  ] }) });
}, uX = () => /* @__PURE__ */ Y("div", { className: "border-subtle mt-6 rounded-lg border", children: [
  /* @__PURE__ */ m("div", { className: "border-subtle border-b p-6", children: /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
      /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-4 w-48 animate-pulse rounded-md" })
    ] }),
    /* @__PURE__ */ m("div", { className: "bg-emphasis h-8 w-32 animate-pulse rounded-md" })
  ] }) }),
  /* @__PURE__ */ m("div", { className: "p-6 pt-2", children: /* @__PURE__ */ Y("div", { className: "border-subtle mt-4 rounded-lg border p-4", children: [
    /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-10 w-10 animate-pulse rounded-md" }),
      /* @__PURE__ */ Y("div", { className: "ml-4 space-y-2", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" })
      ] })
    ] }),
    /* @__PURE__ */ Y("div", { className: "border-subtle mt-4 space-y-4 border-t pt-4", children: [
      /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-64 animate-pulse rounded-md" }),
      /* @__PURE__ */ m("div", { className: "space-y-2", children: [1, 2, 3].map((e) => /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-6 w-10 animate-pulse rounded-md" })
      ] }, e)) })
    ] })
  ] }) })
] }), GJl = (e) => {
  const { t } = Fe(), n = [
    {
      label: "User",
      value: "user"
      /* User */
    },
    {
      label: "Event Type",
      value: "eventType"
      /* EventType */
    }
  ], o = n.find((r) => r.value === e.scope);
  return /* @__PURE__ */ Y("div", { className: "border-subtle border-b p-6", children: [
    /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ m("h4", { className: "text-emphasis text-base font-semibold leading-5", children: t("check_for_conflicts") }),
        /* @__PURE__ */ m("p", { className: "text-default text-sm leading-tight", children: t("select_calendars") })
      ] }),
      !e.shouldDisableConnectionModification && /* @__PURE__ */ m("div", { className: "flex flex-col xl:flex-row xl:space-x-5", children: e.isConnectedCalendarsPresent && /* @__PURE__ */ m("div", { className: "flex items-center", children: /* @__PURE__ */ m(VJl, { isPending: e.isPending }) }) })
    ] }),
    e.showScopeSelector && /* @__PURE__ */ Y("div", { className: "mt-2 flex flex-row items-center space-x-2", children: [
      /* @__PURE__ */ m("span", { className: "text-default text-sm", children: "Using" }),
      /* @__PURE__ */ m(
        Tr,
        {
          onChange: (r) => {
            r && e.setScope(r.value);
          },
          value: o,
          options: n
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-default text-sm", children: "settings" })
    ] })
  ] });
};
function HJl(e) {
  return !!e.find(
    (t) => t.trigger === ale.NEW_EVENT && !!t.steps.find((n) => n.action === yD.EMAIL_HOST)
  );
}
function KJl(e) {
  return !!e.find(
    (t) => t.trigger === ale.NEW_EVENT && !!t.steps.find(
      (n) => n.action === yD.EMAIL_ATTENDEE || n.action === yD.SMS_ATTENDEE
    )
  );
}
const YJl = ({
  options: e = [],
  value: t = [],
  isRRWeightsEnabled: n,
  customClassNames: o,
  groupId: r,
  ...i
}) => {
  var b, v, $;
  const a = Zo(), [s, c] = ze(!1), [l, d] = ze(!1), [u, _] = ze(t[0] ?? null), { t: p } = Fe(), [f] = xl(), g = r ? t.filter((k) => k.groupId === r) : t, h = (k) => {
    const O = [...e8(t, r), ...k.map((I) => ({ ...I, groupId: r }))];
    i.onChange(O);
  };
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      Tr,
      {
        ...i,
        name: i.name,
        placeholder: i.placeholder || p("select"),
        isSearchable: !0,
        options: e,
        value: g,
        onChange: h,
        isMulti: !0,
        className: (b = o == null ? void 0 : o.hostsSelect) == null ? void 0 : b.select,
        innerClassNames: {
          ...(v = o == null ? void 0 : o.hostsSelect) == null ? void 0 : v.innerClassNames,
          control: "rounded-md"
        }
      }
    ),
    /* @__PURE__ */ m(
      "ul",
      {
        className: ae(
          "mb-4 mt-3 rounded-md",
          g.length >= 1 && "border-subtle border",
          ($ = o == null ? void 0 : o.selectedHostList) == null ? void 0 : $.container
        ),
        ref: f,
        children: g.map((k, S) => {
          var O, I, D, M, N, C, P, x, w, E, T, z;
          return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(
            "li",
            {
              className: ae(
                `flex px-3 py-2 ${S === g.length - 1 ? "" : "border-subtle border-b"}`,
                (I = (O = o == null ? void 0 : o.selectedHostList) == null ? void 0 : O.listItem) == null ? void 0 : I.container
              ),
              children: [
                !a && /* @__PURE__ */ m(wl, { size: "sm", imageSrc: k.avatar, alt: k.label }),
                a && /* @__PURE__ */ m(
                  ot,
                  {
                    name: "user",
                    className: ae(
                      "mt-0.5 h-4 w-4",
                      (M = (D = o == null ? void 0 : o.selectedHostList) == null ? void 0 : D.listItem) == null ? void 0 : M.avatar
                    )
                  }
                ),
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: ae(
                      "text-emphasis my-auto ms-3 text-sm",
                      (C = (N = o == null ? void 0 : o.selectedHostList) == null ? void 0 : N.listItem) == null ? void 0 : C.name
                    ),
                    children: k.label
                  }
                ),
                /* @__PURE__ */ Y("div", { className: "ml-auto flex items-center", children: [
                  k && !k.isFixed ? /* @__PURE__ */ Y(Ce, { children: [
                    /* @__PURE__ */ m(Ao, { content: p("change_priority"), children: /* @__PURE__ */ m(
                      ut,
                      {
                        color: "minimal",
                        onClick: () => {
                          c(!0), _(k);
                        },
                        className: ae(
                          "mr-6 h-2 p-0 text-sm hover:bg-transparent",
                          _X(k.priority).color,
                          (x = (P = o == null ? void 0 : o.selectedHostList) == null ? void 0 : P.listItem) == null ? void 0 : x.changePriorityButton
                        ),
                        children: p(_X(k.priority).text)
                      }
                    ) }),
                    n ? /* @__PURE__ */ Y(
                      ut,
                      {
                        color: "minimal",
                        className: ae(
                          "mr-6 h-2 w-4 p-0 text-sm hover:bg-transparent",
                          (E = (w = o == null ? void 0 : o.selectedHostList) == null ? void 0 : w.listItem) == null ? void 0 : E.changeWeightButton
                        ),
                        onClick: () => {
                          d(!0), _(k);
                        },
                        children: [
                          k.weight ?? 100,
                          "%"
                        ]
                      }
                    ) : /* @__PURE__ */ m(Ce, {})
                  ] }) : /* @__PURE__ */ m(Ce, {}),
                  /* @__PURE__ */ m(
                    ot,
                    {
                      name: "x",
                      onClick: () => i.onChange(t.filter((j) => j.value !== k.value)),
                      className: ae(
                        "my-auto ml-2 h-4 w-4",
                        (z = (T = o == null ? void 0 : o.selectedHostList) == null ? void 0 : T.listItem) == null ? void 0 : z.removeButton
                      )
                    }
                  )
                ] })
              ]
            },
            k.value
          ) });
        })
      }
    ),
    u && !u.isFixed ? /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ m(
        CJl,
        {
          isOpenDialog: s,
          setIsOpenDialog: c,
          option: u,
          options: e,
          onChange: i.onChange,
          customClassNames: o == null ? void 0 : o.priorityDialog
        }
      ),
      /* @__PURE__ */ m(
        zJl,
        {
          isOpenDialog: l,
          setIsOpenDialog: d,
          option: u,
          options: e,
          onChange: i.onChange,
          customClassNames: o == null ? void 0 : o.weightDialog
        }
      )
    ] }) : /* @__PURE__ */ m(Ce, {})
  ] });
}, _X = (e) => {
  switch (e) {
    case 0:
      return { text: "lowest", color: "text-gray-300" };
    case 1:
      return { text: "low", color: "text-gray-400" };
    case 2:
      return { text: "medium", color: "text-gray-500" };
    case 3:
      return { text: "high", color: "text-gray-600" };
    case 4:
      return { text: "highest", color: "text-gray-700" };
    default:
      return { text: "medium", color: "text-gray-500" };
  }
}, ZJl = YJl, QJl = ({
  permissions: e,
  teamSlug: t,
  teamId: n,
  form: o,
  urlPrefix: r,
  isPending: i,
  handleSubmit: a,
  isManagedEventType: s,
  SubmitButton: c
}) => {
  const l = Zo(), { t: d } = Fe(), { register: u, setValue: _, formState: p } = o, { canCreateEventType: f } = e;
  return /* @__PURE__ */ Y(fd, { form: o, handleSubmit: a, children: [
    /* @__PURE__ */ Y("div", { className: "mb-6 mt-1 space-y-6", children: [
      /* @__PURE__ */ m(
        Io,
        {
          type: "hidden",
          labelProps: { style: { display: "none" } },
          ...u("teamId", { valueAsNumber: !0 }),
          value: n
        }
      ),
      /* @__PURE__ */ m(
        Io,
        {
          label: d("title"),
          placeholder: d("quick_chat"),
          "data-testid": "event-type-quick-chat",
          ...u("title"),
          onChange: (g) => {
            o.setValue("title", g == null ? void 0 : g.target.value), p.touchedFields.slug === void 0 && o.setValue("slug", xf(g == null ? void 0 : g.target.value));
          }
        }
      ),
      r && r.length >= 21 ? /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ m(
          Io,
          {
            label: l ? "Slug" : `${d("url")}: ${r}`,
            required: !0,
            addOnLeading: l ? void 0 : /* @__PURE__ */ m(Ao, { content: s ? d("username_placeholder") : `team/${t}`, children: /* @__PURE__ */ Y("span", { className: "max-w-24 md:max-w-56", children: [
              "/",
              s ? d("username_placeholder") : `team/${t}`,
              "/"
            ] }) }),
            ...u("slug"),
            onChange: (g) => {
              o.setValue("slug", xf(g == null ? void 0 : g.target.value), { shouldTouch: !0 });
            }
          }
        ),
        s && !l && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: d("managed_event_url_clarification") })
      ] }) : /* @__PURE__ */ Y("div", { children: [
        /* @__PURE__ */ m(
          Io,
          {
            label: l ? "Slug" : d("url"),
            required: !0,
            addOnLeading: l ? void 0 : /* @__PURE__ */ m(
              Ao,
              {
                content: `${r}/${s ? d("username_placeholder") : `team/${t}`}/`,
                children: /* @__PURE__ */ Y("span", { className: "max-w-24 md:max-w-56", children: [
                  r,
                  "/",
                  s ? d("username_placeholder") : `team/${t}`,
                  "/"
                ] })
              }
            ),
            ...u("slug"),
            onChange: (g) => {
              o.setValue("slug", xf(g == null ? void 0 : g.target.value), { shouldTouch: !0 });
            }
          }
        ),
        s && !l && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: d("managed_event_url_clarification") })
      ] }),
      /* @__PURE__ */ Y("div", { className: "mb-4", children: [
        /* @__PURE__ */ m("label", { htmlFor: "schedulingType", className: "text-default block text-sm font-bold", children: d("assignment") }),
        p.errors.schedulingType && /* @__PURE__ */ m(sa, { className: "mt-1", severity: "error", message: p.errors.schedulingType.message }),
        /* @__PURE__ */ Y(
          PF,
          {
            onValueChange: (g) => {
              _("schedulingType", g);
            },
            className: ae("mt-1 flex gap-4", f && "flex-col"),
            children: [
              /* @__PURE__ */ Y(
                Up,
                {
                  ...u("schedulingType"),
                  value: aa.COLLECTIVE,
                  className: ae("w-full text-sm", !f && "w-1/2"),
                  classNames: { container: ae(f && "w-full") },
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: d("collective") }),
                    /* @__PURE__ */ m("p", { children: d("collective_description") })
                  ]
                }
              ),
              /* @__PURE__ */ Y(
                Up,
                {
                  ...u("schedulingType"),
                  value: aa.ROUND_ROBIN,
                  className: ae("text-sm", !f && "w-1/2"),
                  classNames: { container: ae(f && "w-full") },
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: d("round_robin") }),
                    /* @__PURE__ */ m("p", { children: d("round_robin_description") })
                  ]
                }
              ),
              f && /* @__PURE__ */ Y(
                Up,
                {
                  ...u("schedulingType"),
                  value: aa.MANAGED,
                  className: ae("text-sm", !f && "w-1/2"),
                  classNames: { container: ae(f && "w-full") },
                  "data-testid": "managed-event-type",
                  children: [
                    /* @__PURE__ */ m("strong", { className: "mb-1 block", children: d("managed_event") }),
                    /* @__PURE__ */ m("p", { children: d("managed_event_description") })
                  ]
                }
              )
            ]
          }
        )
      ] })
    ] }),
    c(i)
  ] });
};
G.object({
  id: G.number(),
  slug: G.string(),
  title: G.string().min(1),
  description: G.string(),
  length: G.number(),
  teamId: G.number().nullish()
}).strict();
const JJl = G.object({
  disableRecordingForGuests: G.boolean().nullish(),
  disableRecordingForOrganizer: G.boolean().nullish(),
  enableAutomaticTranscription: G.boolean().nullish(),
  enableAutomaticRecordingForOrganizer: G.boolean().nullish(),
  disableTranscriptionForGuests: G.boolean().nullish(),
  disableTranscriptionForOrganizer: G.boolean().nullish(),
  redirectUrlOnExit: G.string().url().nullish()
}).optional().nullable(), XJl = G.object({
  title: G.string().min(1),
  slug: cgc,
  description: G.string().nullish(),
  length: G.number().int(),
  hidden: G.boolean(),
  teamId: G.number().int().nullish(),
  schedulingType: G.nativeEnum(aa).nullish(),
  locations: sgc,
  metadata: dle.optional(),
  disableGuests: G.boolean().optional(),
  slotInterval: G.number().min(0).nullish(),
  minimumBookingNotice: G.number().int().min(0).optional(),
  beforeEventBuffer: G.number().int().min(0).optional(),
  afterEventBuffer: G.number().int().min(0).optional(),
  scheduleId: G.number().int().optional(),
  calVideoSettings: JJl
}).partial({ hidden: !0, locations: !0 }).refine((e) => e.teamId ? e.teamId && e.schedulingType : !0, {
  path: ["schedulingType"],
  message: "You must select a scheduling type for team events"
}), eXl = () => {
  const e = pd({
    defaultValues: {
      length: 15
    },
    resolver: ek(XJl)
  }), t = e.watch("schedulingType"), n = t === aa.MANAGED;
  return Le(() => {
    n ? e.setValue("metadata.managedEventConfig.unlockedFields", mgc) : e.setValue("metadata", null);
  }, [t]), { form: e, isManagedEventType: n };
};
function tXl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      n.hasOwnProperty(o) && (e[o] = n[o]);
  }
  return e;
}
function AL(e, t) {
  return Array(t + 1).join(e);
}
function nXl(e) {
  return e.replace(/^\n*/, "");
}
function oXl(e) {
  for (var t = e.length; t > 0 && e[t - 1] === `
`; )
    t--;
  return e.substring(0, t);
}
var rXl = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function t8(e) {
  return n8(e, rXl);
}
var rye = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function iye(e) {
  return n8(e, rye);
}
function iXl(e) {
  return sye(e, rye);
}
var aye = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function aXl(e) {
  return n8(e, aye);
}
function sXl(e) {
  return sye(e, aye);
}
function n8(e, t) {
  return t.indexOf(e.nodeName) >= 0;
}
function sye(e, t) {
  return e.getElementsByTagName && t.some(function(n) {
    return e.getElementsByTagName(n).length;
  });
}
var is = {};
is.paragraph = {
  filter: "p",
  replacement: function(e) {
    return `

` + e + `

`;
  }
};
is.lineBreak = {
  filter: "br",
  replacement: function(e, t, n) {
    return n.br + `
`;
  }
};
is.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(e, t, n) {
    var o = Number(t.nodeName.charAt(1));
    if (n.headingStyle === "setext" && o < 3) {
      var r = AL(o === 1 ? "=" : "-", e.length);
      return `

` + e + `
` + r + `

`;
    } else
      return `

` + AL("#", o) + " " + e + `

`;
  }
};
is.blockquote = {
  filter: "blockquote",
  replacement: function(e) {
    return e = e.replace(/^\n+|\n+$/g, ""), e = e.replace(/^/gm, "> "), `

` + e + `

`;
  }
};
is.list = {
  filter: ["ul", "ol"],
  replacement: function(e, t) {
    var n = t.parentNode;
    return n.nodeName === "LI" && n.lastElementChild === t ? `
` + e : `

` + e + `

`;
  }
};
is.listItem = {
  filter: "li",
  replacement: function(e, t, n) {
    e = e.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var o = n.bulletListMarker + "   ", r = t.parentNode;
    if (r.nodeName === "OL") {
      var i = r.getAttribute("start"), a = Array.prototype.indexOf.call(r.children, t);
      o = (i ? Number(i) + a : a + 1) + ".  ";
    }
    return o + e + (t.nextSibling && !/\n$/.test(e) ? `
` : "");
  }
};
is.indentedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "indented" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    return `

    ` + t.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
is.fencedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "fenced" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    for (var o = t.firstChild.getAttribute("class") || "", r = (o.match(/language-(\S+)/) || [null, ""])[1], i = t.firstChild.textContent, a = n.fence.charAt(0), s = 3, c = new RegExp("^" + a + "{3,}", "gm"), l; l = c.exec(i); )
      l[0].length >= s && (s = l[0].length + 1);
    var d = AL(a, s);
    return `

` + d + r + `
` + i.replace(/\n$/, "") + `
` + d + `

`;
  }
};
is.horizontalRule = {
  filter: "hr",
  replacement: function(e, t, n) {
    return `

` + n.hr + `

`;
  }
};
is.inlineLink = {
  filter: function(e, t) {
    return t.linkStyle === "inlined" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t) {
    var n = t.getAttribute("href");
    n && (n = n.replace(/([()])/g, "\\$1"));
    var o = tT(t.getAttribute("title"));
    return o && (o = ' "' + o.replace(/"/g, '\\"') + '"'), "[" + e + "](" + n + o + ")";
  }
};
is.referenceLink = {
  filter: function(e, t) {
    return t.linkStyle === "referenced" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t, n) {
    var o = t.getAttribute("href"), r = tT(t.getAttribute("title"));
    r && (r = ' "' + r + '"');
    var i, a;
    switch (n.linkReferenceStyle) {
      case "collapsed":
        i = "[" + e + "][]", a = "[" + e + "]: " + o + r;
        break;
      case "shortcut":
        i = "[" + e + "]", a = "[" + e + "]: " + o + r;
        break;
      default:
        var s = this.references.length + 1;
        i = "[" + e + "][" + s + "]", a = "[" + s + "]: " + o + r;
    }
    return this.references.push(a), i;
  },
  references: [],
  append: function(e) {
    var t = "";
    return this.references.length && (t = `

` + this.references.join(`
`) + `

`, this.references = []), t;
  }
};
is.emphasis = {
  filter: ["em", "i"],
  replacement: function(e, t, n) {
    return e.trim() ? n.emDelimiter + e + n.emDelimiter : "";
  }
};
is.strong = {
  filter: ["strong", "b"],
  replacement: function(e, t, n) {
    return e.trim() ? n.strongDelimiter + e + n.strongDelimiter : "";
  }
};
is.code = {
  filter: function(e) {
    var t = e.previousSibling || e.nextSibling, n = e.parentNode.nodeName === "PRE" && !t;
    return e.nodeName === "CODE" && !n;
  },
  replacement: function(e) {
    if (!e)
      return "";
    e = e.replace(/\r?\n|\r/g, " ");
    for (var t = /^`|^ .*?[^ ].* $|`$/.test(e) ? " " : "", n = "`", o = e.match(/`+/gm) || []; o.indexOf(n) !== -1; )
      n = n + "`";
    return n + t + e + t + n;
  }
};
is.image = {
  filter: "img",
  replacement: function(e, t) {
    var n = tT(t.getAttribute("alt")), o = t.getAttribute("src") || "", r = tT(t.getAttribute("title")), i = r ? ' "' + r + '"' : "";
    return o ? "![" + n + "](" + o + i + ")" : "";
  }
};
function tT(e) {
  return e ? e.replace(/(\n+\s*)+/g, `
`) : "";
}
function cye(e) {
  this.options = e, this._keep = [], this._remove = [], this.blankRule = {
    replacement: e.blankReplacement
  }, this.keepReplacement = e.keepReplacement, this.defaultRule = {
    replacement: e.defaultReplacement
  }, this.array = [];
  for (var t in e.rules)
    this.array.push(e.rules[t]);
}
cye.prototype = {
  add: function(e, t) {
    this.array.unshift(t);
  },
  keep: function(e) {
    this._keep.unshift({
      filter: e,
      replacement: this.keepReplacement
    });
  },
  remove: function(e) {
    this._remove.unshift({
      filter: e,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(e) {
    if (e.isBlank)
      return this.blankRule;
    var t;
    return (t = S5(this.array, e, this.options)) || (t = S5(this._keep, e, this.options)) || (t = S5(this._remove, e, this.options)) ? t : this.defaultRule;
  },
  forEach: function(e) {
    for (var t = 0; t < this.array.length; t++)
      e(this.array[t], t);
  }
};
function S5(e, t, n) {
  for (var o = 0; o < e.length; o++) {
    var r = e[o];
    if (cXl(r, t, n))
      return r;
  }
}
function cXl(e, t, n) {
  var o = e.filter;
  if (typeof o == "string") {
    if (o === t.nodeName.toLowerCase())
      return !0;
  } else if (Array.isArray(o)) {
    if (o.indexOf(t.nodeName.toLowerCase()) > -1)
      return !0;
  } else if (typeof o == "function") {
    if (o.call(e, t, n))
      return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function lXl(e) {
  var t = e.element, n = e.isBlock, o = e.isVoid, r = e.isPre || function(u) {
    return u.nodeName === "PRE";
  };
  if (!(!t.firstChild || r(t))) {
    for (var i = null, a = !1, s = null, c = pX(s, t, r); c !== t; ) {
      if (c.nodeType === 3 || c.nodeType === 4) {
        var l = c.data.replace(/[ \r\n\t]+/g, " ");
        if ((!i || / $/.test(i.data)) && !a && l[0] === " " && (l = l.substr(1)), !l) {
          c = x5(c);
          continue;
        }
        c.data = l, i = c;
      } else if (c.nodeType === 1)
        n(c) || c.nodeName === "BR" ? (i && (i.data = i.data.replace(/ $/, "")), i = null, a = !1) : o(c) || r(c) ? (i = null, a = !0) : i && (a = !1);
      else {
        c = x5(c);
        continue;
      }
      var d = pX(s, c, r);
      s = c, c = d;
    }
    i && (i.data = i.data.replace(/ $/, ""), i.data || x5(i));
  }
}
function x5(e) {
  var t = e.nextSibling || e.parentNode;
  return e.parentNode.removeChild(e), t;
}
function pX(e, t, n) {
  return e && e.parentNode === t || n(t) ? t.nextSibling || t.parentNode : t.firstChild || t.nextSibling || t.parentNode;
}
var o8 = typeof window < "u" ? window : {};
function dXl() {
  var e = o8.DOMParser, t = !1;
  try {
    new e().parseFromString("", "text/html") && (t = !0);
  } catch {
  }
  return t;
}
function uXl() {
  var e = function() {
  };
  return _Xl() ? e.prototype.parseFromString = function(t) {
    var n = new window.ActiveXObject("htmlfile");
    return n.designMode = "on", n.open(), n.write(t), n.close(), n;
  } : e.prototype.parseFromString = function(t) {
    var n = document.implementation.createHTMLDocument("");
    return n.open(), n.write(t), n.close(), n;
  }, e;
}
function _Xl() {
  var e = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    o8.ActiveXObject && (e = !0);
  }
  return e;
}
var pXl = dXl() ? o8.DOMParser : uXl();
function mXl(e, t) {
  var n;
  if (typeof e == "string") {
    var o = fXl().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + e + "</x-turndown>",
      "text/html"
    );
    n = o.getElementById("turndown-root");
  } else
    n = e.cloneNode(!0);
  return lXl({
    element: n,
    isBlock: t8,
    isVoid: iye,
    isPre: t.preformattedCode ? gXl : null
  }), n;
}
var E5;
function fXl() {
  return E5 = E5 || new pXl(), E5;
}
function gXl(e) {
  return e.nodeName === "PRE" || e.nodeName === "CODE";
}
function hXl(e, t) {
  return e.isBlock = t8(e), e.isCode = e.nodeName === "CODE" || e.parentNode.isCode, e.isBlank = vXl(e), e.flankingWhitespace = bXl(e, t), e;
}
function vXl(e) {
  return !iye(e) && !aXl(e) && /^\s*$/i.test(e.textContent) && !iXl(e) && !sXl(e);
}
function bXl(e, t) {
  if (e.isBlock || t.preformattedCode && e.isCode)
    return { leading: "", trailing: "" };
  var n = yXl(e.textContent);
  return n.leadingAscii && mX("left", e, t) && (n.leading = n.leadingNonAscii), n.trailingAscii && mX("right", e, t) && (n.trailing = n.trailingNonAscii), { leading: n.leading, trailing: n.trailing };
}
function yXl(e) {
  var t = e.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: t[1],
    // whole string for whitespace-only strings
    leadingAscii: t[2],
    leadingNonAscii: t[3],
    trailing: t[4],
    // empty for whitespace-only strings
    trailingNonAscii: t[5],
    trailingAscii: t[6]
  };
}
function mX(e, t, n) {
  var o, r, i;
  return e === "left" ? (o = t.previousSibling, r = / $/) : (o = t.nextSibling, r = /^ /), o && (o.nodeType === 3 ? i = r.test(o.nodeValue) : n.preformattedCode && o.nodeName === "CODE" ? i = !1 : o.nodeType === 1 && !t8(o) && (i = r.test(o.textContent))), i;
}
var $Xl = Array.prototype.reduce, wXl = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function nT(e) {
  if (!(this instanceof nT))
    return new nT(e);
  var t = {
    rules: is,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(n, o) {
      return o.isBlock ? `

` : "";
    },
    keepReplacement: function(n, o) {
      return o.isBlock ? `

` + o.outerHTML + `

` : o.outerHTML;
    },
    defaultReplacement: function(n, o) {
      return o.isBlock ? `

` + n + `

` : n;
    }
  };
  this.options = tXl({}, t, e), this.rules = new cye(this.options);
}
nT.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */
  turndown: function(e) {
    if (!xXl(e))
      throw new TypeError(
        e + " is not a string, or an element/document/fragment node."
      );
    if (e === "")
      return "";
    var t = lye.call(this, new mXl(e, this.options));
    return kXl.call(this, t);
  },
  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */
  use: function(e) {
    if (Array.isArray(e))
      for (var t = 0; t < e.length; t++)
        this.use(e[t]);
    else if (typeof e == "function")
      e(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  addRule: function(e, t) {
    return this.rules.add(e, t), this;
  },
  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  keep: function(e) {
    return this.rules.keep(e), this;
  },
  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  remove: function(e) {
    return this.rules.remove(e), this;
  },
  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */
  escape: function(e) {
    return wXl.reduce(function(t, n) {
      return t.replace(n[0], n[1]);
    }, e);
  }
};
function lye(e) {
  var t = this;
  return $Xl.call(e.childNodes, function(n, o) {
    o = new hXl(o, t.options);
    var r = "";
    return o.nodeType === 3 ? r = o.isCode ? o.nodeValue : t.escape(o.nodeValue) : o.nodeType === 1 && (r = SXl.call(t, o)), dye(n, r);
  }, "");
}
function kXl(e) {
  var t = this;
  return this.rules.forEach(function(n) {
    typeof n.append == "function" && (e = dye(e, n.append(t.options)));
  }), e.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function SXl(e) {
  var t = this.rules.forNode(e), n = lye.call(this, e), o = e.flankingWhitespace;
  return (o.leading || o.trailing) && (n = n.trim()), o.leading + t.replacement(n, e, this.options) + o.trailing;
}
function dye(e, t) {
  var n = oXl(e), o = nXl(t), r = Math.max(e.length - n.length, t.length - o.length), i = `

`.substring(0, r);
  return n + i + o;
}
function xXl(e) {
  return e != null && (typeof e == "string" || e.nodeType && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11));
}
const RC = new nT();
function r8(e) {
  let t = RC.turndown(e);
  return t = t.replaceAll("[<p><br></p>]", ""), t === "<p><br></p>" && (t = ""), t;
}
RC.addRule("shiftEnter", {
  filter: function(e) {
    return e.nodeName === "BR" && !!uye(e);
  },
  replacement: function() {
    return "<br>";
  }
});
RC.addRule("enter", {
  filter: function(e) {
    return e.nodeName === "BR" && !uye(e);
  },
  replacement: function() {
    return "<p><br></p>";
  }
});
RC.addRule("ignoreEmphasized", {
  filter: "em",
  replacement: function(e) {
    return e;
  }
});
function uye(e) {
  let t = e;
  for (; t != null && t.nodeType !== 1; )
    t = t.parentElement || t.parentNode;
  return t && t.nodeType === 1 && t.parentElement && t.parentElement.childNodes.length !== 1;
}
var Ni = {}, _ye = { exports: {} };
(function(e) {
  var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var n = function(o) {
    var r = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, i = 0, a = {}, s = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: o.Prism && o.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: o.Prism && o.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function v($) {
          return $ instanceof c ? new c($.type, v($.content), $.alias) : Array.isArray($) ? $.map(v) : $.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(v) {
          return Object.prototype.toString.call(v).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(v) {
          return v.__id || Object.defineProperty(v, "__id", { value: ++i }), v.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function v($, k) {
          k = k || {};
          var S, O;
          switch (s.util.type($)) {
            case "Object":
              if (O = s.util.objId($), k[O])
                return k[O];
              S = /** @type {Record<string, any>} */
              {}, k[O] = S;
              for (var I in $)
                $.hasOwnProperty(I) && (S[I] = v($[I], k));
              return (
                /** @type {any} */
                S
              );
            case "Array":
              return O = s.util.objId($), k[O] ? k[O] : (S = [], k[O] = S, /** @type {Array} */
              /** @type {any} */
              $.forEach(function(D, M) {
                S[M] = v(D, k);
              }), /** @type {any} */
              S);
            default:
              return $;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(v) {
          for (; v; ) {
            var $ = r.exec(v.className);
            if ($)
              return $[1].toLowerCase();
            v = v.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(v, $) {
          v.className = v.className.replace(RegExp(r, "gi"), ""), v.classList.add("language-" + $);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document && 1 < 2)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (S) {
            var v = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(S.stack) || [])[1];
            if (v) {
              var $ = document.getElementsByTagName("script");
              for (var k in $)
                if ($[k].src == v)
                  return $[k];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(v, $, k) {
          for (var S = "no-" + $; v; ) {
            var O = v.classList;
            if (O.contains($))
              return !0;
            if (O.contains(S))
              return !1;
            v = v.parentElement;
          }
          return !!k;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: a,
        plaintext: a,
        text: a,
        txt: a,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(v, $) {
          var k = s.util.clone(s.languages[v]);
          for (var S in $)
            k[S] = $[S];
          return k;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(v, $, k, S) {
          S = S || /** @type {any} */
          s.languages;
          var O = S[v], I = {};
          for (var D in O)
            if (O.hasOwnProperty(D)) {
              if (D == $)
                for (var M in k)
                  k.hasOwnProperty(M) && (I[M] = k[M]);
              k.hasOwnProperty(D) || (I[D] = O[D]);
            }
          var N = S[v];
          return S[v] = I, s.languages.DFS(s.languages, function(C, P) {
            P === N && C != v && (this[C] = I);
          }), I;
        },
        // Traverse a language definition with Depth First Search
        DFS: function v($, k, S, O) {
          O = O || {};
          var I = s.util.objId;
          for (var D in $)
            if ($.hasOwnProperty(D)) {
              k.call($, D, $[D], S || D);
              var M = $[D], N = s.util.type(M);
              N === "Object" && !O[I(M)] ? (O[I(M)] = !0, v(M, k, null, O)) : N === "Array" && !O[I(M)] && (O[I(M)] = !0, v(M, k, D, O));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(v, $) {
        s.highlightAllUnder(document, v, $);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(v, $, k) {
        var S = {
          callback: k,
          container: v,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        s.hooks.run("before-highlightall", S), S.elements = Array.prototype.slice.apply(S.container.querySelectorAll(S.selector)), s.hooks.run("before-all-elements-highlight", S);
        for (var O = 0, I; I = S.elements[O++]; )
          s.highlightElement(I, $ === !0, S.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(v, $, k) {
        var S = s.util.getLanguage(v), O = s.languages[S];
        s.util.setLanguage(v, S);
        var I = v.parentElement;
        I && I.nodeName.toLowerCase() === "pre" && s.util.setLanguage(I, S);
        var D = v.textContent, M = {
          element: v,
          language: S,
          grammar: O,
          code: D
        };
        function N(P) {
          M.highlightedCode = P, s.hooks.run("before-insert", M), M.element.innerHTML = M.highlightedCode, s.hooks.run("after-highlight", M), s.hooks.run("complete", M), k && k.call(M.element);
        }
        if (s.hooks.run("before-sanity-check", M), I = M.element.parentElement, I && I.nodeName.toLowerCase() === "pre" && !I.hasAttribute("tabindex") && I.setAttribute("tabindex", "0"), !M.code) {
          s.hooks.run("complete", M), k && k.call(M.element);
          return;
        }
        if (s.hooks.run("before-highlight", M), !M.grammar) {
          N(s.util.encode(M.code));
          return;
        }
        if ($ && o.Worker) {
          var C = new Worker(s.filename);
          C.onmessage = function(P) {
            N(P.data);
          }, C.postMessage(JSON.stringify({
            language: M.language,
            code: M.code,
            immediateClose: !0
          }));
        } else
          N(s.highlight(M.code, M.grammar, M.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(v, $, k) {
        var S = {
          code: v,
          grammar: $,
          language: k
        };
        if (s.hooks.run("before-tokenize", S), !S.grammar)
          throw new Error('The language "' + S.language + '" has no grammar.');
        return S.tokens = s.tokenize(S.code, S.grammar), s.hooks.run("after-tokenize", S), c.stringify(s.util.encode(S.tokens), S.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(v, $) {
        var k = $.rest;
        if (k) {
          for (var S in k)
            $[S] = k[S];
          delete $.rest;
        }
        var O = new u();
        return _(O, O.head, v), d(v, O, $, O.head, 0), f(O);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(v, $) {
          var k = s.hooks.all;
          k[v] = k[v] || [], k[v].push($);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(v, $) {
          var k = s.hooks.all[v];
          if (!(!k || !k.length))
            for (var S = 0, O; O = k[S++]; )
              O($);
        }
      },
      Token: c
    };
    o.Prism = s;
    function c(v, $, k, S) {
      this.type = v, this.content = $, this.alias = k, this.length = (S || "").length | 0;
    }
    c.stringify = function v($, k) {
      if (typeof $ == "string")
        return $;
      if (Array.isArray($)) {
        var S = "";
        return $.forEach(function(N) {
          S += v(N, k);
        }), S;
      }
      var O = {
        type: $.type,
        content: v($.content, k),
        tag: "span",
        classes: ["token", $.type],
        attributes: {},
        language: k
      }, I = $.alias;
      I && (Array.isArray(I) ? Array.prototype.push.apply(O.classes, I) : O.classes.push(I)), s.hooks.run("wrap", O);
      var D = "";
      for (var M in O.attributes)
        D += " " + M + '="' + (O.attributes[M] || "").replace(/"/g, "&quot;") + '"';
      return "<" + O.tag + ' class="' + O.classes.join(" ") + '"' + D + ">" + O.content + "</" + O.tag + ">";
    };
    function l(v, $, k, S) {
      v.lastIndex = $;
      var O = v.exec(k);
      if (O && S && O[1]) {
        var I = O[1].length;
        O.index += I, O[0] = O[0].slice(I);
      }
      return O;
    }
    function d(v, $, k, S, O, I) {
      for (var D in k)
        if (!(!k.hasOwnProperty(D) || !k[D])) {
          var M = k[D];
          M = Array.isArray(M) ? M : [M];
          for (var N = 0; N < M.length; ++N) {
            if (I && I.cause == D + "," + N)
              return;
            var C = M[N], P = C.inside, x = !!C.lookbehind, w = !!C.greedy, E = C.alias;
            if (w && !C.pattern.global) {
              var T = C.pattern.toString().match(/[imsuy]*$/)[0];
              C.pattern = RegExp(C.pattern.source, T + "g");
            }
            for (var z = C.pattern || C, j = S.next, q = O; j !== $.tail && !(I && q >= I.reach); q += j.value.length, j = j.next) {
              var V = j.value;
              if ($.length > v.length)
                return;
              if (!(V instanceof c)) {
                var F = 1, L;
                if (w) {
                  if (L = l(z, q, v, x), !L || L.index >= v.length)
                    break;
                  var Q = L.index, U = L.index + L[0].length, W = q;
                  for (W += j.value.length; Q >= W; )
                    j = j.next, W += j.value.length;
                  if (W -= j.value.length, q = W, j.value instanceof c)
                    continue;
                  for (var H = j; H !== $.tail && (W < U || typeof H.value == "string"); H = H.next)
                    F++, W += H.value.length;
                  F--, V = v.slice(q, W), L.index -= q;
                } else if (L = l(z, 0, V, x), !L)
                  continue;
                var Q = L.index, X = L[0], re = V.slice(0, Q), Z = V.slice(Q + X.length), ee = q + V.length;
                I && ee > I.reach && (I.reach = ee);
                var J = j.prev;
                re && (J = _($, J, re), q += re.length), p($, J, F);
                var oe = new c(D, P ? s.tokenize(X, P) : X, E, X);
                if (j = _($, J, oe), Z && _($, j, Z), F > 1) {
                  var ce = {
                    cause: D + "," + N,
                    reach: ee
                  };
                  d(v, $, k, j.prev, q, ce), I && ce.reach > I.reach && (I.reach = ce.reach);
                }
              }
            }
          }
        }
    }
    function u() {
      var v = { value: null, prev: null, next: null }, $ = { value: null, prev: v, next: null };
      v.next = $, this.head = v, this.tail = $, this.length = 0;
    }
    function _(v, $, k) {
      var S = $.next, O = { value: k, prev: $, next: S };
      return $.next = O, S.prev = O, v.length++, O;
    }
    function p(v, $, k) {
      for (var S = $.next, O = 0; O < k && S !== v.tail; O++)
        S = S.next;
      $.next = S, S.prev = $, v.length -= O;
    }
    function f(v) {
      for (var $ = [], k = v.head.next; k !== v.tail; )
        $.push(k.value), k = k.next;
      return $;
    }
    if (!o.document)
      return o.addEventListener && (s.disableWorkerMessageHandler || o.addEventListener("message", function(v) {
        var $ = JSON.parse(v.data), k = $.language, S = $.code, O = $.immediateClose;
        o.postMessage(s.highlight(S, s.languages[k], k)), O && o.close();
      }, !1)), s;
    var g = s.util.currentScript();
    g && (s.filename = g.src, g.hasAttribute("data-manual") && (s.manual = !0));
    function h() {
      s.manual || s.highlightAll();
    }
    if (!s.manual) {
      var b = document.readyState;
      b === "loading" || b === "interactive" && g && g.defer ? document.addEventListener("DOMContentLoaded", h) : window.requestAnimationFrame ? window.requestAnimationFrame(h) : window.setTimeout(h, 16);
    }
    return s;
  }(t);
  e.exports && (e.exports = n), typeof Je < "u" && (Je.Prism = n), n.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(o) {
    o.type === "entity" && (o.attributes.title = o.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(n.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(r, i) {
      var a = {};
      a["language-" + i] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: n.languages[i]
      }, a.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var s = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: a
        }
      };
      s["language-" + i] = {
        pattern: /[\s\S]+/,
        inside: n.languages[i]
      };
      var c = {};
      c[r] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return r;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: s
      }, n.languages.insertBefore("markup", "cdata", c);
    }
  }), Object.defineProperty(n.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(o, r) {
      n.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + o + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [r, "language-" + r],
                inside: n.languages[r]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml, function(o) {
    var r = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    o.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp("\\burl\\((?:" + r.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + r.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + r.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: r,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, o.languages.css.atrule.inside.rest = o.languages.css;
    var i = o.languages.markup;
    i && (i.tag.addInlined("style", "css"), i.tag.addAttribute("style", "css"));
  }(n), n.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }, n.languages.javascript = n.languages.extend("clike", {
    "class-name": [
      n.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(
        // lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: n.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: n.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: n.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: n.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: n.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), n.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: n.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), n.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), n.languages.js = n.languages.javascript, function() {
    if (typeof n > "u" || typeof document > "u")
      return;
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    var o = "Loading…", r = function(g, h) {
      return "✖ Error " + g + " while fetching file: " + h;
    }, i = "✖ Error: File does not exist or is empty", a = {
      js: "javascript",
      py: "python",
      rb: "ruby",
      ps1: "powershell",
      psm1: "powershell",
      sh: "bash",
      bat: "batch",
      h: "c",
      tex: "latex"
    }, s = "data-src-status", c = "loading", l = "loaded", d = "failed", u = "pre[data-src]:not([" + s + '="' + l + '"]):not([' + s + '="' + c + '"])';
    function _(g, h, b) {
      var v = new XMLHttpRequest();
      v.open("GET", g, !0), v.onreadystatechange = function() {
        v.readyState == 4 && (v.status < 400 && v.responseText ? h(v.responseText) : v.status >= 400 ? b(r(v.status, v.statusText)) : b(i));
      }, v.send(null);
    }
    function p(g) {
      var h = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(g || "");
      if (h) {
        var b = Number(h[1]), v = h[2], $ = h[3];
        return v ? $ ? [b, Number($)] : [b, void 0] : [b, b];
      }
    }
    n.hooks.add("before-highlightall", function(g) {
      g.selector += ", " + u;
    }), n.hooks.add("before-sanity-check", function(g) {
      var h = (
        /** @type {HTMLPreElement} */
        g.element
      );
      if (h.matches(u)) {
        g.code = "", h.setAttribute(s, c);
        var b = h.appendChild(document.createElement("CODE"));
        b.textContent = o;
        var v = h.getAttribute("data-src"), $ = g.language;
        if ($ === "none") {
          var k = (/\.(\w+)$/.exec(v) || [, "none"])[1];
          $ = a[k] || k;
        }
        n.util.setLanguage(b, $), n.util.setLanguage(h, $);
        var S = n.plugins.autoloader;
        S && S.loadLanguages($), _(
          v,
          function(O) {
            h.setAttribute(s, l);
            var I = p(h.getAttribute("data-range"));
            if (I) {
              var D = O.split(/\r\n?|\n/g), M = I[0], N = I[1] == null ? D.length : I[1];
              M < 0 && (M += D.length), M = Math.max(0, Math.min(M - 1, D.length)), N < 0 && (N += D.length), N = Math.max(0, Math.min(N, D.length)), O = D.slice(M, N).join(`
`), h.hasAttribute("data-start") || h.setAttribute("data-start", String(M + 1));
            }
            b.textContent = O, n.highlightElement(b);
          },
          function(O) {
            h.setAttribute(s, d), b.textContent = O;
          }
        );
      }
    }), n.plugins.fileHighlight = {
      /**
       * Executes the File Highlight plugin for all matching `pre` elements under the given container.
       *
       * Note: Elements which are already loaded or currently loading will not be touched by this method.
       *
       * @param {ParentNode} [container=document]
       */
      highlight: function(h) {
        for (var b = (h || document).querySelectorAll(u), v = 0, $; $ = b[v++]; )
          n.highlightElement($);
      }
    };
    var f = !1;
    n.fileHighlight = function() {
      f || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), f = !0), n.plugins.fileHighlight.highlight.apply(this, arguments);
    };
  }();
})(_ye);
var EXl = _ye.exports;
Prism.languages.clike = {
  comment: [
    {
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    },
    {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }
  ],
  string: {
    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
    lookbehind: !0,
    inside: {
      punctuation: /[.\\]/
    }
  },
  keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
  boolean: /\b(?:false|true)\b/,
  function: /\b\w+(?=\()/,
  number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
  operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
  punctuation: /[{}[\];(),.:]/
};
Prism.languages.javascript = Prism.languages.extend("clike", {
  "class-name": [
    Prism.languages.clike["class-name"],
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: !0
    }
  ],
  keyword: [
    {
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    },
    {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }
  ],
  // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
  function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
  number: {
    pattern: RegExp(
      /(^|[^\w$])/.source + "(?:" + // constant
      (/NaN|Infinity/.source + "|" + // binary integer
      /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
      /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
      /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
      /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
      /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
    ),
    lookbehind: !0
  },
  operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore("javascript", "keyword", {
  regex: {
    pattern: RegExp(
      // lookbehind
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
      // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
      // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
      // with the only syntax, so we have to define 2 different regex patterns.
      /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
      /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
      /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
    ),
    lookbehind: !0,
    greedy: !0,
    inside: {
      "regex-source": {
        pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
        lookbehind: !0,
        alias: "language-regex",
        inside: Prism.languages.regex
      },
      "regex-delimiter": /^\/|\/$/,
      "regex-flags": /^[a-z]+$/
    }
  },
  // This must be declared before keyword because we use "function" inside the look-forward
  "function-variable": {
    pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
    alias: "function"
  },
  parameter: [
    {
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    }
  ],
  constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore("javascript", "string", {
  hashbang: {
    pattern: /^#!.*/,
    greedy: !0,
    alias: "comment"
  },
  "template-string": {
    pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
    greedy: !0,
    inside: {
      "template-punctuation": {
        pattern: /^`|`$/,
        alias: "string"
      },
      interpolation: {
        pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
        lookbehind: !0,
        inside: {
          "interpolation-punctuation": {
            pattern: /^\$\{|\}$/,
            alias: "punctuation"
          },
          rest: Prism.languages.javascript
        }
      },
      string: /[\s\S]+/
    }
  },
  "string-property": {
    pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
    lookbehind: !0,
    greedy: !0,
    alias: "property"
  }
});
Prism.languages.insertBefore("javascript", "operator", {
  "literal-property": {
    pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
    lookbehind: !0,
    alias: "property"
  }
});
Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(
  /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
  "javascript"
));
Prism.languages.js = Prism.languages.javascript;
Prism.languages.markup = {
  comment: {
    pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
    greedy: !0
  },
  prolog: {
    pattern: /<\?[\s\S]+?\?>/,
    greedy: !0
  },
  doctype: {
    // https://www.w3.org/TR/xml/#NT-doctypedecl
    pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
    greedy: !0,
    inside: {
      "internal-subset": {
        pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      punctuation: /^<!|>$|[[\]]/,
      "doctype-tag": /^DOCTYPE/i,
      name: /[^\s<>'"]+/
    }
  },
  cdata: {
    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
    greedy: !0
  },
  tag: {
    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
    greedy: !0,
    inside: {
      tag: {
        pattern: /^<\/?[^\s>\/]+/,
        inside: {
          punctuation: /^<\/?/,
          namespace: /^[^\s>\/:]+:/
        }
      },
      "special-attr": [],
      "attr-value": {
        pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
        inside: {
          punctuation: [
            {
              pattern: /^=/,
              alias: "attr-equals"
            },
            /"|'/
          ]
        }
      },
      punctuation: /\/?>/,
      "attr-name": {
        pattern: /[^\s>\/]+/,
        inside: {
          namespace: /^[^\s>\/:]+:/
        }
      }
    }
  },
  entity: [
    {
      pattern: /&[\da-z]{1,8};/i,
      alias: "named-entity"
    },
    /&#x?[\da-f]{1,8};/i
  ]
};
Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity;
Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup;
Prism.hooks.add("wrap", function(e) {
  e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
});
Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
  /**
   * Adds an inlined language to markup.
   *
   * An example of an inlined language is CSS with `<style>` tags.
   *
   * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addInlined('style', 'css');
   */
  value: function(t, n) {
    var o = {};
    o["language-" + n] = {
      pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
      lookbehind: !0,
      inside: Prism.languages[n]
    }, o.cdata = /^<!\[CDATA\[|\]\]>$/i;
    var r = {
      "included-cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        inside: o
      }
    };
    r["language-" + n] = {
      pattern: /[\s\S]+/,
      inside: Prism.languages[n]
    };
    var i = {};
    i[t] = {
      pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
        return t;
      }), "i"),
      lookbehind: !0,
      greedy: !0,
      inside: r
    }, Prism.languages.insertBefore("markup", "cdata", i);
  }
});
Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
  /**
   * Adds an pattern to highlight languages embedded in HTML attributes.
   *
   * An example of an inlined language is CSS with `style` attributes.
   *
   * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addAttribute('style', 'css');
   */
  value: function(e, t) {
    Prism.languages.markup.tag.inside["special-attr"].push({
      pattern: RegExp(
        /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
        "i"
      ),
      lookbehind: !0,
      inside: {
        "attr-name": /^[^\s=]+/,
        "attr-value": {
          pattern: /=[\s\S]+/,
          inside: {
            value: {
              pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
              lookbehind: !0,
              alias: [t, "language-" + t],
              inside: Prism.languages[t]
            },
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        }
      }
    });
  }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend("markup", {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;
(function(e) {
  var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function n(d) {
    return d = d.replace(/<inner>/g, function() {
      return t;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + d + ")");
  }
  var o = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, r = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return o;
  }), i = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
  e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
    "front-matter-block": {
      pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        punctuation: /^---|---$/,
        "front-matter": {
          pattern: /\S+(?:\s+\S+)*/,
          alias: ["yaml", "language-yaml"],
          inside: e.languages.yaml
        }
      }
    },
    blockquote: {
      // > ...
      pattern: /^>(?:[\t ]*>)*/m,
      alias: "punctuation"
    },
    table: {
      pattern: RegExp("^" + r + i + "(?:" + r + ")*", "m"),
      inside: {
        "table-data-rows": {
          pattern: RegExp("^(" + r + i + ")(?:" + r + ")*$"),
          lookbehind: !0,
          inside: {
            "table-data": {
              pattern: RegExp(o),
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        },
        "table-line": {
          pattern: RegExp("^(" + r + ")" + i + "$"),
          lookbehind: !0,
          inside: {
            punctuation: /\||:?-{3,}:?/
          }
        },
        "table-header-row": {
          pattern: RegExp("^" + r + "$"),
          inside: {
            "table-header": {
              pattern: RegExp(o),
              alias: "important",
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        }
      }
    },
    code: [
      {
        // Prefixed by 4 spaces or 1 tab and preceded by an empty line
        pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
        lookbehind: !0,
        alias: "keyword"
      },
      {
        // ```optional language
        // code block
        // ```
        pattern: /^```[\s\S]*?^```$/m,
        greedy: !0,
        inside: {
          "code-block": {
            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
            lookbehind: !0
          },
          "code-language": {
            pattern: /^(```).+/,
            lookbehind: !0
          },
          punctuation: /```/
        }
      }
    ],
    title: [
      {
        // title 1
        // =======
        // title 2
        // -------
        pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
        alias: "important",
        inside: {
          punctuation: /==+$|--+$/
        }
      },
      {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#.+/m,
        lookbehind: !0,
        alias: "important",
        inside: {
          punctuation: /^#+|#+$/
        }
      }
    ],
    hr: {
      // ***
      // ---
      // * * *
      // -----------
      pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    list: {
      // * item
      // + item
      // - item
      // 1. item
      pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    "url-reference": {
      // [id]: http://example.com "Optional title"
      // [id]: http://example.com 'Optional title'
      // [id]: http://example.com (Optional title)
      // [id]: <http://example.com> "Optional title"
      pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
      inside: {
        variable: {
          pattern: /^(!?\[)[^\]]+/,
          lookbehind: !0
        },
        string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
        punctuation: /^[\[\]!:]|[<>]/
      },
      alias: "url"
    },
    bold: {
      // **strong**
      // __strong__
      // allow one nested instance of italic text using the same delimiter
      pattern: n(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^..)[\s\S]+(?=..$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /\*\*|__/
      }
    },
    italic: {
      // *em*
      // _em_
      // allow one nested instance of bold text using the same delimiter
      pattern: n(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^.)[\s\S]+(?=.$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /[*_]/
      }
    },
    strike: {
      // ~~strike through~~
      // ~strike~
      // eslint-disable-next-line regexp/strict
      pattern: n(/(~~?)(?:(?!~)<inner>)+\2/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^~~?)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /~~?/
      }
    },
    "code-snippet": {
      // `code`
      // ``code``
      pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
      lookbehind: !0,
      greedy: !0,
      alias: ["code", "keyword"]
    },
    url: {
      // [example](http://example.com "Optional title")
      // [example][id]
      // [example] [id]
      pattern: n(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        operator: /^!/,
        content: {
          pattern: /(^\[)[^\]]+(?=\])/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        variable: {
          pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
          lookbehind: !0
        },
        url: {
          pattern: /(^\]\()[^\s)]+/,
          lookbehind: !0
        },
        string: {
          pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
          lookbehind: !0
        }
      }
    }
  }), ["url", "bold", "italic", "strike"].forEach(function(d) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(u) {
      d !== u && (e.languages.markdown[d].inside.content.inside[u] = e.languages.markdown[u]);
    });
  }), e.hooks.add("after-tokenize", function(d) {
    if (d.language !== "markdown" && d.language !== "md")
      return;
    function u(_) {
      if (!(!_ || typeof _ == "string"))
        for (var p = 0, f = _.length; p < f; p++) {
          var g = _[p];
          if (g.type !== "code") {
            u(g.content);
            continue;
          }
          var h = g.content[1], b = g.content[3];
          if (h && b && h.type === "code-language" && b.type === "code-block" && typeof h.content == "string") {
            var v = h.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
            v = (/[a-z][\w-]*/i.exec(v) || [""])[0].toLowerCase();
            var $ = "language-" + v;
            b.alias ? typeof b.alias == "string" ? b.alias = [b.alias, $] : b.alias.push($) : b.alias = [$];
          }
        }
    }
    u(d.tokens);
  }), e.hooks.add("wrap", function(d) {
    if (d.type === "code-block") {
      for (var u = "", _ = 0, p = d.classes.length; _ < p; _++) {
        var f = d.classes[_], g = /language-(.+)/.exec(f);
        if (g) {
          u = g[1];
          break;
        }
      }
      var h = e.languages[u];
      if (h)
        d.content = e.highlight(l(d.content), h, u);
      else if (u && u !== "none" && e.plugins.autoloader) {
        var b = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
        d.attributes.id = b, e.plugins.autoloader.loadLanguages(u, function() {
          var v = document.getElementById(b);
          v && (v.innerHTML = e.highlight(v.textContent, e.languages[u], u));
        });
      }
    }
  });
  var a = RegExp(e.languages.markup.tag.pattern.source, "gi"), s = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"'
  }, c = String.fromCodePoint || String.fromCharCode;
  function l(d) {
    var u = d.replace(a, "");
    return u = u.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(_, p) {
      if (p = p.toLowerCase(), p[0] === "#") {
        var f;
        return p[1] === "x" ? f = parseInt(p.slice(2), 16) : f = Number(p.slice(1)), c(f);
      } else {
        var g = s[p];
        return g || _;
      }
    }), u;
  }
  e.languages.md = e.languages.markdown;
})(Prism);
Prism.languages.c = Prism.languages.extend("clike", {
  comment: {
    pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: !0
  },
  string: {
    // https://en.cppreference.com/w/c/language/string_literal
    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
    lookbehind: !0
  },
  keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
  function: /\b[a-z_]\w*(?=\s*\()/i,
  number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
  operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
Prism.languages.insertBefore("c", "string", {
  char: {
    // https://en.cppreference.com/w/c/language/character_constant
    pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
    greedy: !0
  }
});
Prism.languages.insertBefore("c", "string", {
  macro: {
    // allow for multiline macro definitions
    // spaces after the # character compile fine with gcc
    pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
    lookbehind: !0,
    greedy: !0,
    alias: "property",
    inside: {
      string: [
        {
          // highlight the path of the include statement as a string
          pattern: /^(#\s*include\s*)<[^>]+>/,
          lookbehind: !0
        },
        Prism.languages.c.string
      ],
      char: Prism.languages.c.char,
      comment: Prism.languages.c.comment,
      "macro-name": [
        {
          pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
          lookbehind: !0
        },
        {
          pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
          lookbehind: !0,
          alias: "function"
        }
      ],
      // highlight macro directives as keywords
      directive: {
        pattern: /^(#\s*)[a-z]+/,
        lookbehind: !0,
        alias: "keyword"
      },
      "directive-hash": /^#/,
      punctuation: /##|\\(?=[\r\n])/,
      expression: {
        pattern: /\S[\s\S]*/,
        inside: Prism.languages.c
      }
    }
  }
});
Prism.languages.insertBefore("c", "function", {
  // highlight predefined macros as constants
  constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete Prism.languages.c.boolean;
(function(e) {
  var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
  e.languages.css = {
    comment: /\/\*[\s\S]*?\*\//,
    atrule: {
      pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
      inside: {
        rule: /^@[\w-]+/,
        "selector-function-argument": {
          pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
          lookbehind: !0,
          alias: "selector"
        },
        keyword: {
          pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
          lookbehind: !0
        }
        // See rest below
      }
    },
    url: {
      // https://drafts.csswg.org/css-values-3/#urls
      pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
      greedy: !0,
      inside: {
        function: /^url/i,
        punctuation: /^\(|\)$/,
        string: {
          pattern: RegExp("^" + t.source + "$"),
          alias: "url"
        }
      }
    },
    selector: {
      pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"),
      lookbehind: !0
    },
    string: {
      pattern: t,
      greedy: !0
    },
    property: {
      pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
      lookbehind: !0
    },
    important: /!important\b/i,
    function: {
      pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
      lookbehind: !0
    },
    punctuation: /[(){};:,]/
  }, e.languages.css.atrule.inside.rest = e.languages.css;
  var n = e.languages.markup;
  n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
})(Prism);
Prism.languages.objectivec = Prism.languages.extend("c", {
  string: {
    pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    greedy: !0
  },
  keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
  operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
delete Prism.languages.objectivec["class-name"];
Prism.languages.objc = Prism.languages.objectivec;
Prism.languages.sql = {
  comment: {
    pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
    lookbehind: !0
  },
  variable: [
    {
      pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
      greedy: !0
    },
    /@[\w.$]+/
  ],
  string: {
    pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
    greedy: !0,
    lookbehind: !0
  },
  identifier: {
    pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
    greedy: !0,
    lookbehind: !0,
    inside: {
      punctuation: /^`|`$/
    }
  },
  function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
  // Should we highlight user defined functions too?
  keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
  boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
  number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
  operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
  punctuation: /[;[\]()`,.]/
};
Prism.languages.python = {
  comment: {
    pattern: /(^|[^\\])#.*/,
    lookbehind: !0,
    greedy: !0
  },
  "string-interpolation": {
    pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
    greedy: !0,
    inside: {
      interpolation: {
        // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
        pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
        lookbehind: !0,
        inside: {
          "format-spec": {
            pattern: /(:)[^:(){}]+(?=\}$)/,
            lookbehind: !0
          },
          "conversion-option": {
            pattern: /![sra](?=[:}]$)/,
            alias: "punctuation"
          },
          rest: null
        }
      },
      string: /[\s\S]+/
    }
  },
  "triple-quoted-string": {
    pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
    greedy: !0,
    alias: "string"
  },
  string: {
    pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
    greedy: !0
  },
  function: {
    pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
    lookbehind: !0
  },
  "class-name": {
    pattern: /(\bclass\s+)\w+/i,
    lookbehind: !0
  },
  decorator: {
    pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
    lookbehind: !0,
    alias: ["annotation", "punctuation"],
    inside: {
      punctuation: /\./
    }
  },
  keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
  builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
  boolean: /\b(?:False|None|True)\b/,
  number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
  operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
  punctuation: /[{}[\];(),.:]/
};
Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python;
Prism.languages.py = Prism.languages.python;
(function(e) {
  for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, n = 0; n < 2; n++)
    t = t.replace(/<self>/g, function() {
      return t;
    });
  t = t.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), e.languages.rust = {
    comment: [
      {
        pattern: RegExp(/(^|[^\\])/.source + t),
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
      greedy: !0
    },
    char: {
      pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
      greedy: !0
    },
    attribute: {
      pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
      greedy: !0,
      alias: "attr-name",
      inside: {
        string: null
        // see below
      }
    },
    // Closure params should not be confused with bitwise OR |
    "closure-params": {
      pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        "closure-punctuation": {
          pattern: /^\||\|$/,
          alias: "punctuation"
        },
        rest: null
        // see below
      }
    },
    "lifetime-annotation": {
      pattern: /'\w+/,
      alias: "symbol"
    },
    "fragment-specifier": {
      pattern: /(\$\w+:)[a-z]+/,
      lookbehind: !0,
      alias: "punctuation"
    },
    variable: /\$\w+/,
    "function-definition": {
      pattern: /(\bfn\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    "type-definition": {
      pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
      lookbehind: !0,
      alias: "class-name"
    },
    "module-declaration": [
      {
        pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
        lookbehind: !0,
        alias: "namespace"
      },
      {
        pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
        lookbehind: !0,
        alias: "namespace",
        inside: {
          punctuation: /::/
        }
      }
    ],
    keyword: [
      // https://github.com/rust-lang/reference/blob/master/src/keywords.md
      /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
      // primitives and str
      // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
      /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
    ],
    // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
    // and Rust's naming conventions recommend snake_case anyway.
    // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
    function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
    macro: {
      pattern: /\b\w+!/,
      alias: "property"
    },
    constant: /\b[A-Z_][A-Z_\d]+\b/,
    "class-name": /\b[A-Z]\w*\b/,
    namespace: {
      pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
      inside: {
        punctuation: /::/
      }
    },
    // Hex, oct, bin, dec numbers with visual separators and type suffix
    number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
    boolean: /\b(?:false|true)\b/,
    punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
    operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
  }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
})(Prism);
Prism.languages.swift = {
  comment: {
    // Nested comments are supported up to 2 levels
    pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
    lookbehind: !0,
    greedy: !0
  },
  "string-literal": [
    // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
    {
      pattern: RegExp(
        /(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
          // see below
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\\($/,
          alias: "punctuation"
        },
        punctuation: /\\(?=[\r\n])/,
        string: /[\s\S]+/
      }
    },
    {
      pattern: RegExp(
        /(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
          // see below
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\#+\($/,
          alias: "punctuation"
        },
        string: /[\s\S]+/
      }
    }
  ],
  directive: {
    // directives with conditions
    pattern: RegExp(
      /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
    ),
    alias: "property",
    inside: {
      "directive-name": /^#\w+/,
      boolean: /\b(?:false|true)\b/,
      number: /\b\d+(?:\.\d+)*\b/,
      operator: /!|&&|\|\||[<>]=?/,
      punctuation: /[(),]/
    }
  },
  literal: {
    pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
    alias: "constant"
  },
  "other-directive": {
    pattern: /#\w+\b/,
    alias: "property"
  },
  attribute: {
    pattern: /@\w+/,
    alias: "atrule"
  },
  "function-definition": {
    pattern: /(\bfunc\s+)\w+/,
    lookbehind: !0,
    alias: "function"
  },
  label: {
    // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
    pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
    lookbehind: !0,
    alias: "important"
  },
  keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
  boolean: /\b(?:false|true)\b/,
  nil: {
    pattern: /\bnil\b/,
    alias: "constant"
  },
  "short-argument": /\$\d+\b/,
  omit: {
    pattern: /\b_\b/,
    alias: "keyword"
  },
  number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
  // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
  "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
  function: /\b[a-z_]\w*(?=\s*\()/i,
  constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
  // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
  // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
  // This regex only supports ASCII operators.
  operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
  punctuation: /[{}[\]();,.:\\]/
};
Prism.languages.swift["string-literal"].forEach(function(e) {
  e.inside.interpolation.inside = Prism.languages.swift;
});
(function(e) {
  e.languages.typescript = e.languages.extend("javascript", {
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
      lookbehind: !0,
      greedy: !0,
      inside: null
      // see below
    },
    builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
  }), e.languages.typescript.keyword.push(
    /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
    // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
    // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/
  ), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
  var t = e.languages.extend("typescript", {});
  delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
    decorator: {
      pattern: /@[$\w\xA0-\uFFFF]+/,
      inside: {
        at: {
          pattern: /^@/,
          alias: "operator"
        },
        function: /^[\s\S]+/
      }
    },
    "generic-function": {
      // e.g. foo<T extends "bar" | "baz">( ...
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
      greedy: !0,
      inside: {
        function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
        generic: {
          pattern: /<[\s\S]+/,
          // everything after the first <
          alias: "class-name",
          inside: t
        }
      }
    }
  }), e.languages.ts = e.languages.typescript;
})(Prism);
(function(e) {
  var t = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, n = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, o = {
    pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
    lookbehind: !0,
    inside: {
      namespace: {
        pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /\./
    }
  };
  e.languages.java = e.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": [
      o,
      {
        // variables, parameters, and constructor references
        // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
        pattern: RegExp(/(^|[^\w.])/.source + n + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
        lookbehind: !0,
        inside: o.inside
      },
      {
        // class names based on keyword
        // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
        pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + n + /[A-Z]\w*\b/.source),
        lookbehind: !0,
        inside: o.inside
      }
    ],
    keyword: t,
    function: [
      e.languages.clike.function,
      {
        pattern: /(::\s*)[a-z_]\w*/,
        lookbehind: !0
      }
    ],
    number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
    operator: {
      pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
      lookbehind: !0
    }
  }), e.languages.insertBefore("java", "string", {
    "triple-quoted-string": {
      // http://openjdk.java.net/jeps/355#Description
      pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
      greedy: !0,
      alias: "string"
    },
    char: {
      pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
      greedy: !0
    }
  }), e.languages.insertBefore("java", "class-name", {
    annotation: {
      pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
      lookbehind: !0,
      alias: "punctuation"
    },
    generics: {
      pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
      inside: {
        "class-name": o,
        keyword: t,
        punctuation: /[<>(),.:]/,
        operator: /[?&|]/
      }
    },
    import: [
      {
        pattern: RegExp(/(\bimport\s+)/.source + n + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
        lookbehind: !0,
        inside: {
          namespace: o.inside.namespace,
          punctuation: /\./,
          operator: /\*/,
          "class-name": /\w+/
        }
      },
      {
        pattern: RegExp(/(\bimport\s+static\s+)/.source + n + /(?:\w+|\*)(?=\s*;)/.source),
        lookbehind: !0,
        alias: "static",
        inside: {
          namespace: o.inside.namespace,
          static: /\b\w+$/,
          punctuation: /\./,
          operator: /\*/,
          "class-name": /\w+/
        }
      }
    ],
    namespace: {
      pattern: RegExp(
        /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
          return t.source;
        })
      ),
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }
  });
})(Prism);
(function(e) {
  var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, n = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return t.source;
  });
  e.languages.cpp = e.languages.extend("c", {
    "class-name": [
      {
        pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
          return t.source;
        })),
        lookbehind: !0
      },
      // This is intended to capture the class name of method implementations like:
      //   void foo::bar() const {}
      // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
      // it starts with an uppercase letter. This approximation should give decent results.
      /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
      // This will capture the class name before destructors like:
      //   Foo::~Foo() {}
      /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
      // This also intends to capture the class name of method implementations but here the class has template
      // parameters, so it can't be a namespace (until C++ adds generic namespaces).
      /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
    ],
    keyword: t,
    number: {
      pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
      greedy: !0
    },
    operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
    boolean: /\b(?:false|true)\b/
  }), e.languages.insertBefore("cpp", "string", {
    module: {
      // https://en.cppreference.com/w/cpp/language/modules
      pattern: RegExp(
        /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
        /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
        /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
          return n;
        }) + ")"
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        string: /^[<"][\s\S]+/,
        operator: /:/,
        punctuation: /\./
      }
    },
    "raw-string": {
      pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
      alias: "string",
      greedy: !0
    }
  }), e.languages.insertBefore("cpp", "keyword", {
    "generic-function": {
      pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
      inside: {
        function: /^\w+/,
        generic: {
          pattern: /<[\s\S]+/,
          alias: "class-name",
          inside: e.languages.cpp
        }
      }
    }
  }), e.languages.insertBefore("cpp", "operator", {
    "double-colon": {
      pattern: /::/,
      alias: "punctuation"
    }
  }), e.languages.insertBefore("cpp", "class-name", {
    // the base clause is an optional list of parent classes
    // https://en.cppreference.com/w/cpp/language/class
    "base-clause": {
      pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
      lookbehind: !0,
      greedy: !0,
      inside: e.languages.extend("cpp", {})
    }
  }), e.languages.insertBefore("inside", "double-colon", {
    // All untokenized words that are not namespaces should be class names
    "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
  }, e.languages.cpp["base-clause"]);
})(Prism);
var Pa = {}, _a = {}, vt = {};
let i8 = {}, pye = {}, e0 = {}, K$ = {}, CL = {}, Yh = {}, a8 = {}, zL = {}, t0 = {}, n0 = {}, Op = {}, s8 = {}, c8 = {}, mye = {}, fye = {}, gye = {}, hye = {}, vye = {}, bye = {}, yye = {}, oT = {}, $ye = {}, wye = {}, kye = {}, Sye = {}, xye = {}, Eye = {}, Tye = {}, Aye = {}, Cye = {}, l8 = {}, d8 = {}, zye = {}, Oye = {}, Pye = {};
function Yt(e) {
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?code=${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let D_ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", TXl = D_ && "documentMode" in document ? document.documentMode : null, Vs = D_ && /Mac|iPod|iPhone|iPad/.test(navigator.platform), Qf = D_ && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), rT = D_ && "InputEvent" in window && !TXl ? "getTargetRanges" in new window.InputEvent("input") : !1, u8 = D_ && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), _8 = D_ && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, AXl = D_ && /^(?=.*Chrome).*/i.test(navigator.userAgent), p8 = D_ && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !AXl, NC = u8 || _8 || p8 ? " " : "​", CXl = Qf ? " " : NC, zXl = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, OXl = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, zf = { bold: 1, code: 16, highlight: 128, italic: 2, strikethrough: 4, subscript: 32, superscript: 64, underline: 8 }, PXl = { directionless: 1, unmergeable: 2 }, fX = { center: 2, end: 6, justify: 4, left: 1, right: 3, start: 5 }, IXl = { 2: "center", 6: "end", 4: "justify", 1: "left", 3: "right", 5: "start" }, RXl = { normal: 0, segmented: 2, token: 1 }, NXl = { 0: "normal", 2: "segmented", 1: "token" }, OL = !1, m8 = 0;
function DXl(e) {
  m8 = e.timeStamp;
}
function T5(e, t, n) {
  return t.__lexicalLineBreak === e || e[`__lexicalKey_${n._key}`] !== void 0;
}
function MXl(e) {
  return e.getEditorState().read(() => {
    let t = Kr();
    return t !== null ? t.clone() : null;
  });
}
function Iye(e, t, n) {
  OL = !0;
  let o = 100 < performance.now() - m8;
  try {
    qc(e, () => {
      let r = Kr() || MXl(e);
      var i = /* @__PURE__ */ new Map(), a = e.getRootElement(), s = e._editorState, c = e._blockCursorElement;
      let l = !1, d = "";
      for (var u = 0; u < t.length; u++) {
        var _ = t[u], p = _.type, f = _.target, g = fk(f, s);
        if (!(g === null && f !== a || Hr(g))) {
          if (p === "characterData") {
            if (_ = o && Xt(g))
              e: {
                _ = r, p = f;
                var h = g;
                if (to(_)) {
                  var b = _.anchor.getNode();
                  if (b.is(h) && _.format !== b.getFormat()) {
                    _ = !1;
                    break e;
                  }
                }
                _ = p.nodeType === 3 && h.isAttached();
              }
            _ && (h = bu(e._window), p = _ = null, h !== null && h.anchorNode === f && (_ = h.anchorOffset, p = h.focusOffset), f = f.nodeValue, f !== null && v8(g, f, _, p, !1));
          } else if (p === "childList") {
            for (l = !0, p = _.addedNodes, h = 0; h < p.length; h++) {
              b = p[h];
              var v = jye(b), $ = b.parentNode;
              $ == null || b === c || v !== null || b.nodeName === "BR" && T5(b, $, e) || (Qf && (v = b.innerText || b.nodeValue) && (d += v), $.removeChild(b));
            }
            if (_ = _.removedNodes, p = _.length, 0 < p) {
              for (h = 0, b = 0; b < p; b++)
                $ = _[b], ($.nodeName === "BR" && T5($, f, e) || c === $) && (f.appendChild($), h++);
              p !== h && (f === a && (g = s._nodeMap.get("root")), i.set(f, g));
            }
          }
        }
      }
      if (0 < i.size)
        for (let [k, S] of i)
          if (kt(S))
            for (i = S.getChildrenKeys(), a = k.firstChild, s = 0; s < i.length; s++)
              c = e.getElementByKey(i[s]), c !== null && (a == null ? (k.appendChild(c), a = c) : a !== c && k.replaceChild(c, a), a = a.nextSibling);
          else
            Xt(S) && S.markDirty();
      if (i = n.takeRecords(), 0 < i.length) {
        for (a = 0; a < i.length; a++)
          for (c = i[a], s = c.addedNodes, c = c.target, u = 0; u < s.length; u++)
            g = s[u], f = g.parentNode, f == null || g.nodeName !== "BR" || T5(g, c, e) || f.removeChild(g);
        n.takeRecords();
      }
      r !== null && (l && (r.dirty = !0, om(r)), Qf && Uye(e) && r.insertRawText(d));
    });
  } finally {
    OL = !1;
  }
}
function Rye(e) {
  let t = e._observer;
  if (t !== null) {
    let n = t.takeRecords();
    Iye(e, n, t);
  }
}
function Nye(e) {
  m8 === 0 && MC(e).addEventListener("textInput", DXl, !0), e._observer = new MutationObserver((t, n) => {
    Iye(e, t, n);
  });
}
let LXl = 1, qXl = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
};
function Dye(e) {
  let t = document.activeElement;
  if (t === null)
    return !1;
  let n = t.nodeName;
  return Hr(fk(e)) && (n === "INPUT" || n === "TEXTAREA" || t.contentEditable === "true" && t.__lexicalEditor == null);
}
function mk(e, t, n) {
  let o = e.getRootElement();
  try {
    return o !== null && o.contains(t) && o.contains(n) && t !== null && !Dye(t) && f8(t) === e;
  } catch {
    return !1;
  }
}
function f8(e) {
  for (; e != null; ) {
    let t = e.__lexicalEditor;
    if (t != null)
      return t;
    e = DC(e);
  }
  return null;
}
function PL(e) {
  return e.isToken() || e.isSegmented();
}
function iT(e) {
  for (; e != null; ) {
    if (e.nodeType === 3)
      return e;
    e = e.firstChild;
  }
  return null;
}
function Mye(e, t, n) {
  return t = zf[t], e & t && (n === null || !(n & t)) ? e ^ t : n === null || n & t ? e | t : e;
}
function Lye(e) {
  return Xt(e) || s0(e) || Hr(e);
}
function qye(e, t) {
  if (t != null)
    e.__key = t;
  else {
    xs(), 99 < a0 && Yt(14), t = xi();
    var n = yu(), o = "" + LXl++;
    n._nodeMap.set(o, e), kt(e) ? t._dirtyElements.set(o, !0) : t._dirtyLeaves.add(o), t._cloneNotNeeded.add(o), t._dirtyType = 1, e.__key = o;
  }
}
function Of(e) {
  var t = e.getParent();
  if (t !== null) {
    let r = e.getWritable();
    t = t.getWritable();
    var n = e.getPreviousSibling();
    if (e = e.getNextSibling(), n === null)
      if (e !== null) {
        var o = e.getWritable();
        t.__first = e.__key, o.__prev = null;
      } else
        t.__first = null;
    else {
      if (o = n.getWritable(), e !== null) {
        let i = e.getWritable();
        i.__prev = o.__key, o.__next = i.__key;
      } else
        o.__next = null;
      r.__prev = null;
    }
    e === null ? n !== null ? (e = n.getWritable(), t.__last = n.__key, e.__next = null) : t.__last = null : (e = e.getWritable(), n !== null ? (n = n.getWritable(), n.__next = e.__key, e.__prev = n.__key) : e.__prev = null, r.__next = null), t.__size--, r.__parent = null;
  }
}
function aT(e) {
  99 < a0 && Yt(14);
  var t = e.getLatest(), n = t.__parent, o = yu();
  let r = xi(), i = o._nodeMap;
  if (o = r._dirtyElements, n !== null)
    e:
      for (; n !== null; ) {
        if (o.has(n))
          break e;
        let a = i.get(n);
        if (a === void 0)
          break;
        o.set(n, !1), n = a.__parent;
      }
  t = t.__key, r._dirtyType = 1, kt(e) ? o.set(t, !0) : r._dirtyLeaves.add(t);
}
function Sa(e) {
  xs();
  var t = xi();
  let n = t._compositionKey;
  e !== n && (t._compositionKey = e, n !== null && (t = oa(n), t !== null && t.getWritable()), e !== null && (e = oa(e), e !== null && e.getWritable()));
}
function Pp() {
  return wb() ? null : xi()._compositionKey;
}
function oa(e, t) {
  return e = (t || yu())._nodeMap.get(e), e === void 0 ? null : e;
}
function jye(e, t) {
  let n = xi();
  return e = e[`__lexicalKey_${n._key}`], e !== void 0 ? oa(e, t) : null;
}
function fk(e, t) {
  for (; e != null; ) {
    let n = jye(e, t);
    if (n !== null)
      return n;
    e = DC(e);
  }
  return null;
}
function Fye(e) {
  let t = Object.assign({}, e._decorators);
  return e._pendingDecorators = t;
}
function gX(e) {
  return e.read(() => M_().getTextContent());
}
function jXl(e, t) {
  qc(e, () => {
    var n = yu();
    if (!n.isEmpty())
      if (t === "root")
        M_().markDirty();
      else {
        n = n._nodeMap;
        for (let [, o] of n)
          o.markDirty();
      }
  }, e._pendingEditorState === null ? { tag: "history-merge" } : void 0);
}
function M_() {
  return yu()._nodeMap.get("root");
}
function om(e) {
  xs();
  let t = yu();
  e !== null && (e.dirty = !0, e._cachedNodes = null), t._selection = e;
}
function Th(e) {
  var t = xi(), n;
  e: {
    for (n = e; n != null; ) {
      let o = n[`__lexicalKey_${t._key}`];
      if (o !== void 0) {
        n = o;
        break e;
      }
      n = DC(n);
    }
    n = null;
  }
  return n === null ? (t = t.getRootElement(), e === t ? oa("root") : null) : oa(n);
}
function Vye(e) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(e);
}
function g8(e) {
  let t = [];
  for (; e !== null; )
    t.push(e), e = e._parentEditor;
  return t;
}
function Bye() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function h8(e, t, n) {
  if (t = bu(t._window), t !== null) {
    var o = t.anchorNode, { anchorOffset: r, focusOffset: i } = t;
    if (o !== null && (t = o.nodeType === 3 ? o.nodeValue : null, o = fk(o), t !== null && Xt(o))) {
      if (o.canContainTabs()) {
        var a = t.includes("	");
        if (n && 0 < n.length && a) {
          a = n.length;
          let s = r + a - 1, c = t.slice(0, s);
          t = t.slice(s, t.length), t = `${c}${n}${t}`, r += a, i += a;
        }
      }
      t === NC && n && (a = n.length, t = n, i = r = a), t !== null && v8(o, t, r, i, e);
    }
  }
}
function v8(e, t, n, o, r) {
  let i = e;
  if (i.isAttached() && (r || !i.isDirty())) {
    var a = i.isComposing();
    if (e = t, (a || r) && t[t.length - 1] === NC && (e = t.slice(0, -1)), t = i.getTextContent(), r || e !== t)
      if (e === "")
        if (Sa(null), u8 || _8 || p8)
          i.remove();
        else {
          let l = xi();
          setTimeout(() => {
            l.update(() => {
              i.isAttached() && i.remove();
            });
          }, 20);
        }
      else {
        r = i.getParent(), t = vk();
        var s = Pp(), c = i.getKey();
        i.isToken() || s !== null && c === s && !a || r !== null && to(t) && !r.canInsertTextBefore() && t.anchor.offset === 0 ? i.markDirty() : (a = Kr(), to(a) && n !== null && o !== null && (a.setTextNodeRange(
          i,
          n,
          i,
          o
        ), i.isSegmented() && (n = i.getTextContent(), n = wa(n), i.replace(n), i = n)), i.setTextContent(e));
      }
  }
}
function FXl(e, t) {
  if (t.isSegmented())
    return !0;
  if (!e.isCollapsed())
    return !1;
  e = e.anchor.offset;
  let n = t.getParentOrThrow(), o = t.isToken();
  return e === 0 ? ((e = !t.canInsertTextBefore() || !n.canInsertTextBefore() || o) || (t = t.getPreviousSibling(), e = (Xt(t) || kt(t) && t.isInline()) && !t.canInsertTextAfter()), e) : e === t.getTextContentSize() ? !t.canInsertTextAfter() || !n.canInsertTextAfter() || o : !1;
}
function Y$(e, t) {
  var n = e[t];
  return typeof n == "string" ? (n = n.split(" "), e[t] = n) : n;
}
function b8(e, t, n, o, r) {
  n.size !== 0 && (n = o.__key, t = t.get(o.__type), t === void 0 && Yt(33), o = t.klass, t = e.get(o), t === void 0 && (t = /* @__PURE__ */ new Map(), e.set(o, t)), e = t.get(n), o = e === "destroyed" && r === "created", (e === void 0 || o) && t.set(n, o ? "updated" : r));
}
function hX(e, t, n) {
  let o = e.getParent(), r = n;
  return o !== null && (t && n === 0 ? (r = e.getIndexWithinParent(), e = o) : t || n !== e.getChildrenSize() || (r = e.getIndexWithinParent() + 1, e = o)), e.getChildAtIndex(t ? r - 1 : r);
}
function IL(e, t) {
  var n = e.offset;
  return e.type === "element" ? (e = e.getNode(), hX(e, t, n)) : (e = e.getNode(), t && n === 0 || !t && n === e.getTextContentSize() ? (n = t ? e.getPreviousSibling() : e.getNextSibling(), n === null ? hX(e.getParentOrThrow(), t, e.getIndexWithinParent() + (t ? 0 : 1)) : n) : null);
}
function Uye(e) {
  return e = (e = MC(e).event) && e.inputType, e === "insertFromPaste" || e === "insertFromPasteAsQuotation";
}
function sT(e) {
  return !ec(e) && !e.isLastChild() && !e.isInline();
}
function cT(e, t) {
  return e = e._keyToDOMMap.get(t), e === void 0 && Yt(75), e;
}
function DC(e) {
  return e = e.assignedSlot || e.parentElement, e !== null && e.nodeType === 11 ? e.host : e;
}
function VXl(e, t = 0) {
  if (t !== 0 && Yt(1), t = Kr(), !to(t) || !kt(e))
    return t;
  let { anchor: n, focus: o } = t, r = n.getNode(), i = o.getNode();
  return lT(r, e) && n.set(e.__key, 0, "element"), lT(i, e) && o.set(e.__key, 0, "element"), t;
}
function lT(e, t) {
  for (e = e.getParent(); e !== null; ) {
    if (e.is(t))
      return !0;
    e = e.getParent();
  }
  return !1;
}
function MC(e) {
  return e = e._window, e === null && Yt(78), e;
}
function Wye(e) {
  for (e = e.getParentOrThrow(); e !== null && !Xl(e); )
    e = e.getParentOrThrow();
  return e;
}
function Xl(e) {
  return ec(e) || kt(e) && e.isShadowRoot();
}
function Gye(e) {
  return e = e.constructor.clone(e), qye(e, null), e;
}
function LC(e) {
  var t = xi();
  let n = e.constructor.getType();
  return t = t._nodes.get(n), t === void 0 && Yt(97), t = t.replace, t !== null ? (t = t(e), t instanceof e.constructor || Yt(98), t) : e;
}
function A5(e, t) {
  e = e.getParent(), !ec(e) || kt(t) || Hr(t) || Yt(99);
}
function C5(e) {
  return (Hr(e) || kt(e) && !e.canBeEmpty()) && !e.isInline();
}
function RL(e, t, n) {
  n.style.removeProperty("caret-color"), t._blockCursorElement = null, t = e.parentElement, t !== null && t.removeChild(e);
}
function bu(e) {
  return D_ ? (e || window).getSelection() : null;
}
function Hye(e, t) {
  let n = e.getChildAtIndex(t);
  n == null && (n = e), Xl(e) && Yt(102);
  let o = (a) => {
    const s = a.getParentOrThrow(), c = Xl(s), l = a !== n || c ? Gye(a) : a;
    if (c)
      return a.insertAfter(l), [a, l, l];
    const [d, u, _] = o(s);
    return a = a.getNextSiblings(), _.append(l, ...a), [d, u, l];
  }, [r, i] = o(n);
  return [r, i];
}
function dT(e, t) {
  for (; e !== M_() && e != null; ) {
    if (t(e))
      return e;
    e = e.getParent();
  }
  return null;
}
function BXl(e) {
  let t = [], n = [e];
  for (; 0 < n.length; ) {
    let o = n.pop();
    o === void 0 && Yt(112), kt(o) && n.unshift(...o.getChildren()), o !== e && t.push(o);
  }
  return t;
}
function Kye(e, t, n, o, r) {
  for (e = e.getFirstChild(); e !== null; ) {
    let i = e.__key;
    e !== void 0 && e.__parent === t && (kt(e) && Kye(e, i, n, o, r), n.has(i) || r.delete(i), o.delete(i)), e = e.isAttached() ? e.getNextSibling() : null;
  }
}
function UXl(e, t, n, o) {
  e = e._nodeMap, t = t._nodeMap;
  for (let r of n) {
    let i = t.get(r);
    i === void 0 || i.isAttached() || (e.has(r) || n.delete(r), t.delete(r));
  }
  for (let [r] of o)
    n = t.get(r), n === void 0 || n.isAttached() || (kt(n) && Kye(n, r, e, t, o), e.has(r) || o.delete(r), t.delete(r));
}
function vX(e, t) {
  let n = e.__mode, o = e.__format;
  e = e.__style;
  let r = t.__mode, i = t.__format;
  return t = t.__style, (n === null || n === r) && (o === null || o === i) && (e === null || e === t);
}
function bX(e, t) {
  let n = e.mergeWithSibling(t), o = xi()._normalizedNodes;
  return o.add(e.__key), o.add(t.__key), n;
}
function Yye(e) {
  if (e.__text === "" && e.isSimpleText() && !e.isUnmergeable())
    e.remove();
  else {
    for (var t; (t = e.getPreviousSibling()) !== null && Xt(t) && t.isSimpleText() && !t.isUnmergeable(); )
      if (t.__text === "")
        t.remove();
      else {
        vX(t, e) && (e = bX(t, e));
        break;
      }
    for (var n; (n = e.getNextSibling()) !== null && Xt(n) && n.isSimpleText() && !n.isUnmergeable(); )
      if (n.__text === "")
        n.remove();
      else {
        vX(e, n) && bX(e, n);
        break;
      }
  }
}
function Zye(e) {
  return yX(e.anchor), yX(e.focus), e;
}
function yX(e) {
  for (; e.type === "element"; ) {
    var t = e.getNode(), n = e.offset;
    if (n === t.getChildrenSize() ? (t = t.getChildAtIndex(n - 1), n = !0) : (t = t.getChildAtIndex(n), n = !1), Xt(t)) {
      e.set(t.__key, n ? t.getTextContentSize() : 0, "text");
      break;
    } else if (!kt(t))
      break;
    e.set(t.__key, n ? t.getChildrenSize() : 0, "element");
  }
}
let Vi = "", Ss = "", r_ = "", rm, Qa, o0, Qye = !1, y8 = !1, qC, ix = null, NL, DL, Jf, im, ML, r0;
function ax(e, t) {
  let n = Jf.get(e);
  if (t !== null) {
    let o = jL(e);
    o.parentNode === t && t.removeChild(o);
  }
  im.has(e) || Qa._keyToDOMMap.delete(e), kt(n) && (e = uT(n, Jf), LL(e, 0, e.length - 1, null)), n !== void 0 && b8(r0, o0, qC, n, "destroyed");
}
function LL(e, t, n, o) {
  for (; t <= n; ++t) {
    let r = e[t];
    r !== void 0 && ax(r, o);
  }
}
function Rm(e, t) {
  e.setProperty("text-align", t);
}
function Jye(e, t) {
  var n = rm.theme.indent;
  if (typeof n == "string") {
    let o = e.classList.contains(n);
    0 < t && !o ? e.classList.add(n) : 1 > t && o && e.classList.remove(n);
  }
  n = getComputedStyle(e).getPropertyValue("--lexical-indent-base-value") || "40px", e.style.setProperty("padding-inline-start", t === 0 ? "" : `calc(${t} * ${n})`);
}
function Xye(e, t) {
  e = e.style, t === 0 ? Rm(e, "") : t === 1 ? Rm(e, "left") : t === 2 ? Rm(e, "center") : t === 3 ? Rm(e, "right") : t === 4 ? Rm(e, "justify") : t === 5 ? Rm(e, "start") : t === 6 && Rm(e, "end");
}
function sx(e, t, n) {
  let o = im.get(e);
  o === void 0 && Yt(60);
  let r = o.createDOM(rm, Qa);
  var i = Qa._keyToDOMMap;
  if (r["__lexicalKey_" + Qa._key] = e, i.set(e, r), Xt(o) ? r.setAttribute("data-lexical-text", "true") : Hr(o) && r.setAttribute("data-lexical-decorator", "true"), kt(o)) {
    if (e = o.__indent, i = o.__size, e !== 0 && Jye(r, e), i !== 0) {
      --i, e = uT(o, im);
      var a = Ss;
      Ss = "", qL(e, o, 0, i, r, null), t$e(o, r), Ss = a;
    }
    e = o.__format, e !== 0 && Xye(r, e), o.isInline() || e$e(null, o, r), sT(o) && (Vi += `

`, r_ += `

`);
  } else
    i = o.getTextContent(), Hr(o) ? (a = o.decorate(Qa, rm), a !== null && n$e(e, a), r.contentEditable = "false") : Xt(o) && (o.isDirectionless() || (Ss += i)), Vi += i, r_ += i;
  return t !== null && (n != null ? t.insertBefore(r, n) : (n = t.__lexicalLineBreak, n != null ? t.insertBefore(r, n) : t.appendChild(r))), b8(r0, o0, qC, o, "created"), r;
}
function qL(e, t, n, o, r, i) {
  let a = Vi;
  for (Vi = ""; n <= o; ++n)
    sx(e[n], r, i);
  sT(t) && (Vi += `

`), r.__lexicalTextContent = Vi, Vi = a + Vi;
}
function $X(e, t) {
  return e = t.get(e), s0(e) || Hr(e) && e.isInline();
}
function e$e(e, t, n) {
  e = e !== null && (e.__size === 0 || $X(e.__last, Jf)), t = t.__size === 0 || $X(t.__last, im), e ? t || (t = n.__lexicalLineBreak, t != null && n.removeChild(t), n.__lexicalLineBreak = null) : t && (t = document.createElement("br"), n.__lexicalLineBreak = t, n.appendChild(t));
}
function t$e(e, t) {
  var n = t.__lexicalDir;
  if (t.__lexicalDirTextContent !== Ss || n !== ix) {
    let i = Ss === "";
    if (i)
      var o = ix;
    else
      o = Ss, o = zXl.test(o) ? "rtl" : OXl.test(o) ? "ltr" : null;
    if (o !== n) {
      let a = t.classList, s = rm.theme;
      var r = n !== null ? s[n] : void 0;
      let c = o !== null ? s[o] : void 0;
      r !== void 0 && (typeof r == "string" && (r = r.split(" "), r = s[n] = r), a.remove(...r)), o === null || i && o === "ltr" ? t.removeAttribute("dir") : (c !== void 0 && (typeof c == "string" && (n = c.split(" "), c = s[o] = n), c !== void 0 && a.add(...c)), t.dir = o), y8 || (e.getWritable().__dir = o);
    }
    ix = o, t.__lexicalDirTextContent = Ss, t.__lexicalDir = o;
  }
}
function uT(e, t) {
  let n = [];
  for (e = e.__first; e !== null; ) {
    let o = t.get(e);
    o === void 0 && Yt(101), n.push(e), e = o.__next;
  }
  return n;
}
function v$(e, t) {
  var n = Jf.get(e), o = im.get(e);
  n !== void 0 && o !== void 0 || Yt(61);
  var r = Qye || DL.has(e) || NL.has(e);
  let i = cT(Qa, e);
  if (n === o && !r)
    return kt(n) ? (o = i.__lexicalTextContent, o !== void 0 && (Vi += o, r_ += o), o = i.__lexicalDirTextContent, o !== void 0 && (Ss += o)) : (o = n.getTextContent(), Xt(n) && !n.isDirectionless() && (Ss += o), r_ += o, Vi += o), i;
  if (n !== o && r && b8(r0, o0, qC, o, "updated"), o.updateDOM(n, i, rm))
    return o = sx(e, null, null), t === null && Yt(62), t.replaceChild(o, i), ax(e, null), o;
  if (kt(n) && kt(o)) {
    if (e = o.__indent, e !== n.__indent && Jye(i, e), e = o.__format, e !== n.__format && Xye(i, e), r) {
      e = o, r = Ss, Ss = "", t = Vi;
      var a = n.__size, s = e.__size;
      if (Vi = "", a === 1 && s === 1) {
        var c = n.__first, l = e.__first;
        if (c === l)
          v$(c, i);
        else {
          var d = jL(c);
          l = sx(l, null, null), i.replaceChild(l, d), ax(c, null);
        }
      } else {
        l = uT(n, Jf);
        var u = uT(e, im);
        if (a === 0)
          s !== 0 && qL(u, e, 0, s - 1, i, null);
        else if (s === 0)
          a !== 0 && (c = i.__lexicalLineBreak == null, LL(l, 0, a - 1, c ? null : i), c && (i.textContent = ""));
        else {
          var _ = l;
          l = u, u = a - 1, a = s - 1;
          let f = i.firstChild, g = 0;
          for (s = 0; g <= u && s <= a; ) {
            var p = _[g];
            let h = l[s];
            if (p === h)
              f = z5(v$(h, i)), g++, s++;
            else {
              c === void 0 && (c = new Set(_)), d === void 0 && (d = new Set(l));
              let b = d.has(p), v = c.has(h);
              b ? (v ? (p = cT(Qa, h), p === f ? f = z5(v$(h, i)) : (f != null ? i.insertBefore(p, f) : i.appendChild(p), v$(h, i)), g++) : sx(h, i, f), s++) : (f = z5(jL(p)), ax(p, i), g++);
            }
          }
          c = g > u, d = s > a, c && !d ? (c = l[a + 1], c = c === void 0 ? null : Qa.getElementByKey(c), qL(l, e, s, a, i, c)) : d && !c && LL(_, g, u, i);
        }
      }
      sT(e) && (Vi += `

`), i.__lexicalTextContent = Vi, Vi = t + Vi, t$e(e, i), Ss = r, ec(o) || o.isInline() || e$e(n, o, i);
    }
    sT(o) && (Vi += `

`, r_ += `

`);
  } else
    n = o.getTextContent(), Hr(o) ? (r = o.decorate(Qa, rm), r !== null && n$e(e, r)) : Xt(o) && !o.isDirectionless() && (Ss += n), Vi += n, r_ += n;
  return !y8 && ec(o) && o.__cachedText !== r_ && (o = o.getWritable(), o.__cachedText = r_), i;
}
function n$e(e, t) {
  let n = Qa._pendingDecorators, o = Qa._decorators;
  if (n === null) {
    if (o[e] === t)
      return;
    n = Fye(Qa);
  }
  n[e] = t;
}
function z5(e) {
  return e = e.nextSibling, e !== null && e === Qa._blockCursorElement && (e = e.nextSibling), e;
}
function jL(e) {
  return e = ML.get(e), e === void 0 && Yt(75), e;
}
let Hu = Object.freeze({}), FL = [["keydown", JXl], ["pointerdown", GXl], ["compositionstart", ZXl], ["compositionend", QXl], ["input", YXl], ["click", WXl], ["cut", Hu], ["copy", Hu], ["dragstart", Hu], ["dragover", Hu], ["dragend", Hu], ["paste", Hu], ["focus", Hu], ["blur", Hu], ["drop", Hu]];
rT && FL.push(["beforeinput", (e, t) => KXl(e, t)]);
let i0 = 0, o$e = 0, r$e = 0, hh = null, Z$ = 0, VL = !1, BL = !1, Q$ = !1, b$ = !1, i$e = [0, "", 0, "root", 0];
function a$e(e, t, n, o, r) {
  let i = e.anchor, a = e.focus, s = i.getNode();
  var c = xi();
  let l = bu(c._window), d = l !== null ? l.anchorNode : null, u = i.key;
  c = c.getElementByKey(u);
  let _ = n.length;
  return u !== a.key || !Xt(s) || (!r && (!rT || r$e < o + 50) || s.isDirty() && 2 > _ || Vye(n)) && i.offset !== a.offset && !s.isComposing() || PL(s) || s.isDirty() && 1 < _ || (r || !rT) && c !== null && !s.isComposing() && d !== iT(c) || l !== null && t !== null && (!t.collapsed || t.startContainer !== l.anchorNode || t.startOffset !== l.anchorOffset) || s.getFormat() !== e.format || s.getStyle() !== e.style || FXl(e, s);
}
function wX(e, t) {
  return e !== null && e.nodeValue !== null && e.nodeType === 3 && t !== 0 && t !== e.nodeValue.length;
}
function kX(e, t, n) {
  let { anchorNode: o, anchorOffset: r, focusNode: i, focusOffset: a } = e;
  VL && (VL = !1, wX(o, r) && wX(i, a)) || qc(t, () => {
    if (!n)
      om(null);
    else if (mk(t, o, i)) {
      var s = Kr();
      if (to(s)) {
        var c = s.anchor, l = c.getNode();
        if (s.isCollapsed()) {
          e.type === "Range" && e.anchorNode === e.focusNode && (s.dirty = !0);
          var d = MC(t).event;
          d = d ? d.timeStamp : performance.now();
          let [u, _, p, f, g] = i$e;
          d < g + 200 && c.offset === p && c.key === f ? (s.format = u, s.style = _) : c.type === "text" ? (s.format = l.getFormat(), s.style = l.getStyle()) : c.type === "element" && (s.format = 0, s.style = "");
        } else {
          c = 255, l = !1, d = s.getNodes();
          let u = d.length;
          for (let _ = 0; _ < u; _++) {
            let p = d[_];
            if (Xt(p) && (l = !0, c &= p.getFormat(), c === 0))
              break;
          }
          s.format = l ? c : 0;
        }
      }
      Qt(t, i8, void 0);
    }
  });
}
function WXl(e, t) {
  qc(t, () => {
    let n = Kr(), o = bu(t._window), r = vk();
    if (to(n)) {
      let i = n.anchor, a = i.getNode();
      o && i.type === "element" && i.offset === 0 && n.isCollapsed() && !ec(a) && M_().getChildrenSize() === 1 && a.getTopLevelElementOrThrow().isEmpty() && r !== null && n.is(r) && (o.removeAllRanges(), n.dirty = !0);
    }
    Qt(t, pye, e);
  });
}
function GXl(e, t) {
  let n = e.target;
  e = e.pointerType, n instanceof Node && e !== "touch" && qc(t, () => {
    Hr(fk(n)) || (BL = !0);
  });
}
function s$e(e) {
  return e.getTargetRanges ? (e = e.getTargetRanges(), e.length === 0 ? null : e[0]) : null;
}
function HXl(e, t) {
  return e !== t || kt(e) || kt(t) || !e.isToken() || !t.isToken();
}
function KXl(e, t) {
  let n = e.inputType, o = s$e(e);
  n === "deleteCompositionText" || Qf && Uye(t) || n !== "insertCompositionText" && qc(t, () => {
    let r = Kr();
    if (n === "deleteContentBackward") {
      if (r === null) {
        var i = vk();
        if (!to(i))
          return;
        om(i.clone());
      }
      if (to(r)) {
        o$e === 229 && e.timeStamp < i0 + 30 && t.isComposing() && r.anchor.key === r.focus.key ? (Sa(null), i0 = 0, setTimeout(() => {
          qc(t, () => {
            Sa(null);
          });
        }, 30), to(r) && (i = r.anchor.getNode(), i.markDirty(), r.format = i.getFormat(), r.style = i.getStyle())) : (e.preventDefault(), Qt(t, e0, !0));
        return;
      }
    }
    if (to(r)) {
      i = e.data, hh !== null && h8(!1, t, hh), r.dirty && hh === null || !r.isCollapsed() || ec(r.anchor.getNode()) || o === null || r.applyDOMRange(o), hh = null;
      var a = r.focus, s = r.anchor.getNode();
      if (a = a.getNode(), n === "insertText" || n === "insertTranspose")
        i === `
` ? (e.preventDefault(), Qt(t, K$, !1)) : i === `

` ? (e.preventDefault(), Qt(t, CL, void 0)) : i == null && e.dataTransfer ? (i = e.dataTransfer.getData("text/plain"), e.preventDefault(), r.insertRawText(i)) : i != null && a$e(r, o, i, e.timeStamp, !0) ? (e.preventDefault(), Qt(t, Yh, i)) : hh = i, r$e = e.timeStamp;
      else
        switch (e.preventDefault(), n) {
          case "insertFromYank":
          case "insertFromDrop":
          case "insertReplacementText":
            Qt(t, Yh, e);
            break;
          case "insertFromComposition":
            Sa(null), Qt(t, Yh, e);
            break;
          case "insertLineBreak":
            Sa(null), Qt(t, K$, !1);
            break;
          case "insertParagraph":
            Sa(null), Q$ ? (Q$ = !1, Qt(t, K$, !1)) : Qt(t, CL, void 0);
            break;
          case "insertFromPaste":
          case "insertFromPasteAsQuotation":
            Qt(t, a8, e);
            break;
          case "deleteByComposition":
            HXl(s, a) && Qt(t, zL, void 0);
            break;
          case "deleteByDrag":
          case "deleteByCut":
            Qt(t, zL, void 0);
            break;
          case "deleteContent":
            Qt(t, e0, !1);
            break;
          case "deleteWordBackward":
            Qt(
              t,
              t0,
              !0
            );
            break;
          case "deleteWordForward":
            Qt(t, t0, !1);
            break;
          case "deleteHardLineBackward":
          case "deleteSoftLineBackward":
            Qt(t, n0, !0);
            break;
          case "deleteContentForward":
          case "deleteHardLineForward":
          case "deleteSoftLineForward":
            Qt(t, n0, !1);
            break;
          case "formatStrikeThrough":
            Qt(t, Op, "strikethrough");
            break;
          case "formatBold":
            Qt(t, Op, "bold");
            break;
          case "formatItalic":
            Qt(t, Op, "italic");
            break;
          case "formatUnderline":
            Qt(t, Op, "underline");
            break;
          case "historyUndo":
            Qt(t, s8, void 0);
            break;
          case "historyRedo":
            Qt(t, c8, void 0);
        }
    }
  });
}
function YXl(e, t) {
  e.stopPropagation(), qc(t, () => {
    var n = Kr(), o = e.data, r = s$e(e);
    if (o != null && to(n) && a$e(n, r, o, e.timeStamp, !1)) {
      b$ && (UL(t, o), b$ = !1);
      var i = n.anchor, a = i.getNode();
      if (r = bu(t._window), r === null)
        return;
      let s = i.offset;
      (i = rT && !n.isCollapsed() && Xt(a) && r.anchorNode !== null) && (a = a.getTextContent().slice(0, s) + o + a.getTextContent().slice(s + n.focus.offset), r = r.anchorNode, i = a === (r.nodeType === 3 ? r.nodeValue : null)), i || Qt(t, Yh, o), o = o.length, Qf && 1 < o && e.inputType === "insertCompositionText" && !t.isComposing() && (n.anchor.offset -= o), u8 || _8 || p8 || !t.isComposing() || (i0 = 0, Sa(null));
    } else
      h8(!1, t, o !== null ? o : void 0), b$ && (UL(t, o || void 0), b$ = !1);
    xs(), n = xi(), Rye(n);
  }), hh = null;
}
function ZXl(e, t) {
  qc(t, () => {
    let n = Kr();
    if (to(n) && !t.isComposing()) {
      let o = n.anchor, r = n.anchor.getNode();
      Sa(o.key), (e.timeStamp < i0 + 30 || o.type === "element" || !n.isCollapsed() || r.getFormat() !== n.format || r.getStyle() !== n.style) && Qt(t, Yh, CXl);
    }
  });
}
function UL(e, t) {
  var n = e._compositionKey;
  if (Sa(null), n !== null && t != null) {
    if (t === "") {
      t = oa(n), e = iT(e.getElementByKey(n)), e !== null && e.nodeValue !== null && Xt(t) && v8(t, e.nodeValue, null, null, !0);
      return;
    }
    if (t[t.length - 1] === `
` && (n = Kr(), to(n))) {
      t = n.focus, n.anchor.set(t.key, t.offset, t.type), Qt(e, oT, null);
      return;
    }
  }
  h8(!0, e, t);
}
function QXl(e, t) {
  Qf ? b$ = !0 : qc(t, () => {
    UL(t, e.data);
  });
}
function JXl(e, t) {
  if (i0 = e.timeStamp, o$e = e.keyCode, !t.isComposing()) {
    var { keyCode: n, shiftKey: o, ctrlKey: r, metaKey: i, altKey: a } = e;
    if (!Qt(t, mye, e)) {
      if (n !== 39 || r || i || a)
        if (n !== 39 || a || o || !r && !i)
          if (n !== 37 || r || i || a)
            if (n !== 37 || a || o || !r && !i)
              if (n !== 38 || r || i)
                if (n !== 40 || r || i)
                  if (n === 13 && o)
                    Q$ = !0, Qt(t, oT, e);
                  else if (n === 32)
                    Qt(t, $ye, e);
                  else if (Vs && r && n === 79)
                    e.preventDefault(), Q$ = !0, Qt(t, K$, !0);
                  else if (n !== 13 || o) {
                    var s = Vs ? a || i ? !1 : n === 8 || n === 72 && r : r || a || i ? !1 : n === 8;
                    s ? n === 8 ? Qt(t, wye, e) : (e.preventDefault(), Qt(t, e0, !0)) : n === 27 ? Qt(
                      t,
                      kye,
                      e
                    ) : (s = Vs ? o || a || i ? !1 : n === 46 || n === 68 && r : r || a || i ? !1 : n === 46, s ? n === 46 ? Qt(t, Sye, e) : (e.preventDefault(), Qt(t, e0, !1)) : n === 8 && (Vs ? a : r) ? (e.preventDefault(), Qt(t, t0, !0)) : n === 46 && (Vs ? a : r) ? (e.preventDefault(), Qt(t, t0, !1)) : Vs && i && n === 8 ? (e.preventDefault(), Qt(t, n0, !0)) : Vs && i && n === 46 ? (e.preventDefault(), Qt(t, n0, !1)) : n === 66 && !a && (Vs ? i : r) ? (e.preventDefault(), Qt(t, Op, "bold")) : n === 85 && !a && (Vs ? i : r) ? (e.preventDefault(), Qt(t, Op, "underline")) : n === 73 && !a && (Vs ? i : r) ? (e.preventDefault(), Qt(t, Op, "italic")) : n !== 9 || a || r || i ? n === 90 && !o && (Vs ? i : r) ? (e.preventDefault(), Qt(t, s8, void 0)) : (s = Vs ? n === 90 && i && o : n === 89 && r || n === 90 && r && o, s ? (e.preventDefault(), Qt(t, c8, void 0)) : hk(t._editorState._selection) && (s = o ? !1 : n === 67 ? Vs ? i : r : !1, s ? (e.preventDefault(), Qt(t, l8, e)) : (s = o ? !1 : n === 88 ? Vs ? i : r : !1, s && (e.preventDefault(), Qt(t, d8, e))))) : Qt(t, xye, e));
                  } else
                    Q$ = !1, Qt(t, oT, e);
                else
                  Qt(t, yye, e);
              else
                Qt(t, bye, e);
            else
              Qt(t, vye, e);
          else
            Qt(t, hye, e);
        else
          Qt(t, gye, e);
      else
        Qt(t, fye, e);
      (r || o || a || i) && Qt(t, Pye, e);
    }
  }
}
function c$e(e) {
  let t = e.__lexicalEventHandles;
  return t === void 0 && (t = [], e.__lexicalEventHandles = t), t;
}
let Zh = /* @__PURE__ */ new Map();
function l$e(e) {
  e = e.target;
  let t = bu(e == null ? null : e.nodeType === 9 ? e.defaultView : e.ownerDocument.defaultView);
  if (t !== null) {
    var n = f8(t.anchorNode);
    if (n !== null) {
      BL && (BL = !1, qc(n, () => {
        var a = vk(), s = t.anchorNode;
        s !== null && (s = s.nodeType, s === 1 || s === 3) && (a = p$e(a, t, n), om(a));
      })), e = g8(n), e = e[e.length - 1];
      var o = e._key, r = Zh.get(o), i = r || e;
      i !== n && kX(t, i, !1), kX(t, n, !0), n !== e ? Zh.set(o, n) : r && Zh.delete(o);
    }
  }
}
function XXl(e, t) {
  Z$ === 0 && e.ownerDocument.addEventListener("selectionchange", l$e), Z$++, e.__lexicalEditor = t;
  let n = c$e(e);
  for (let o = 0; o < FL.length; o++) {
    let [r, i] = FL[o], a = typeof i == "function" ? (s) => {
      s._lexicalHandled !== !0 && (s._lexicalHandled = !0, t.isEditable() && i(s, t));
    } : (s) => {
      if (s._lexicalHandled !== !0 && (s._lexicalHandled = !0, t.isEditable()))
        switch (r) {
          case "cut":
            return Qt(t, d8, s);
          case "copy":
            return Qt(t, l8, s);
          case "paste":
            return Qt(t, a8, s);
          case "dragstart":
            return Qt(t, Tye, s);
          case "dragover":
            return Qt(t, Aye, s);
          case "dragend":
            return Qt(
              t,
              Cye,
              s
            );
          case "focus":
            return Qt(t, zye, s);
          case "blur":
            return Qt(t, Oye, s);
          case "drop":
            return Qt(t, Eye, s);
        }
    };
    e.addEventListener(r, a), n.push(() => {
      e.removeEventListener(r, a);
    });
  }
}
function WL(e, t, n) {
  xs();
  var o = e.__key;
  let r = e.getParent();
  if (r !== null) {
    var i = VXl(e), a = !1;
    if (to(i) && t) {
      let s = i.anchor, c = i.focus;
      s.key === o && (pT(s, e, r, e.getPreviousSibling(), e.getNextSibling()), a = !0), c.key === o && (pT(c, e, r, e.getPreviousSibling(), e.getNextSibling()), a = !0);
    }
    to(i) && t && !a ? (o = e.getIndexWithinParent(), Of(e), _T(i, r, o, -1)) : Of(e), n || Xl(r) || r.canBeEmpty() || !r.isEmpty() || WL(r, t), t && ec(r) && r.isEmpty() && r.selectEnd();
  }
}
class gk {
  static getType() {
    Yt(64);
  }
  static clone() {
    Yt(65);
  }
  constructor(t) {
    this.__type = this.constructor.getType(), this.__next = this.__prev = this.__parent = null, qye(this, t);
  }
  getType() {
    return this.__type;
  }
  isAttached() {
    for (var t = this.__key; t !== null; ) {
      if (t === "root")
        return !0;
      if (t = oa(t), t === null)
        break;
      t = t.__parent;
    }
    return !1;
  }
  isSelected(t) {
    if (t = t || Kr(), t == null)
      return !1;
    let n = t.getNodes().some((o) => o.__key === this.__key);
    return Xt(this) ? n : to(t) && t.anchor.type === "element" && t.focus.type === "element" && t.anchor.key === t.focus.key && t.anchor.offset === t.focus.offset ? !1 : n;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    var t = this.getParent();
    if (t === null)
      return -1;
    t = t.getFirstChild();
    let n = 0;
    for (; t !== null; ) {
      if (this.is(t))
        return n;
      n++, t = t.getNextSibling();
    }
    return -1;
  }
  getParent() {
    let t = this.getLatest().__parent;
    return t === null ? null : oa(t);
  }
  getParentOrThrow() {
    let t = this.getParent();
    return t === null && Yt(66), t;
  }
  getTopLevelElement() {
    let t = this;
    for (; t !== null; ) {
      let n = t.getParent();
      if (Xl(n))
        return t;
      t = n;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    let t = this.getTopLevelElement();
    return t === null && Yt(67), t;
  }
  getParents() {
    let t = [], n = this.getParent();
    for (; n !== null; )
      t.push(n), n = n.getParent();
    return t;
  }
  getParentKeys() {
    let t = [], n = this.getParent();
    for (; n !== null; )
      t.push(n.__key), n = n.getParent();
    return t;
  }
  getPreviousSibling() {
    let t = this.getLatest().__prev;
    return t === null ? null : oa(t);
  }
  getPreviousSiblings() {
    let t = [];
    var n = this.getParent();
    if (n === null)
      return t;
    for (n = n.getFirstChild(); n !== null && !n.is(this); )
      t.push(n), n = n.getNextSibling();
    return t;
  }
  getNextSibling() {
    let t = this.getLatest().__next;
    return t === null ? null : oa(t);
  }
  getNextSiblings() {
    let t = [], n = this.getNextSibling();
    for (; n !== null; )
      t.push(n), n = n.getNextSibling();
    return t;
  }
  getCommonAncestor(t) {
    let n = this.getParents();
    var o = t.getParents();
    kt(this) && n.unshift(this), kt(t) && o.unshift(t), t = n.length;
    var r = o.length;
    if (t === 0 || r === 0 || n[t - 1] !== o[r - 1])
      return null;
    for (o = new Set(o), r = 0; r < t; r++) {
      let i = n[r];
      if (o.has(i))
        return i;
    }
    return null;
  }
  is(t) {
    return t == null ? !1 : this.__key === t.__key;
  }
  isBefore(t) {
    if (this === t)
      return !1;
    if (t.isParentOf(this))
      return !0;
    if (this.isParentOf(t))
      return !1;
    var n = this.getCommonAncestor(t);
    let o = this;
    for (; ; ) {
      var r = o.getParentOrThrow();
      if (r === n) {
        r = o.getIndexWithinParent();
        break;
      }
      o = r;
    }
    for (o = t; ; ) {
      if (t = o.getParentOrThrow(), t === n) {
        n = o.getIndexWithinParent();
        break;
      }
      o = t;
    }
    return r < n;
  }
  isParentOf(t) {
    let n = this.__key;
    if (n === t.__key)
      return !1;
    for (; t !== null; ) {
      if (t.__key === n)
        return !0;
      t = t.getParent();
    }
    return !1;
  }
  getNodesBetween(t) {
    let n = this.isBefore(t), o = [], r = /* @__PURE__ */ new Set();
    for (var i = this; ; ) {
      var a = i.__key;
      if (r.has(a) || (r.add(a), o.push(i)), i === t)
        break;
      if (a = kt(i) ? n ? i.getFirstChild() : i.getLastChild() : null, a !== null)
        i = a;
      else if (a = n ? i.getNextSibling() : i.getPreviousSibling(), a !== null)
        i = a;
      else {
        if (i = i.getParentOrThrow(), r.has(i.__key) || o.push(i), i === t)
          break;
        a = i;
        do
          a === null && Yt(68), i = n ? a.getNextSibling() : a.getPreviousSibling(), a = a.getParent(), a !== null && (i !== null || r.has(a.__key) || o.push(a));
        while (i === null);
      }
    }
    return n || o.reverse(), o;
  }
  isDirty() {
    let t = xi()._dirtyLeaves;
    return t !== null && t.has(this.__key);
  }
  getLatest() {
    let t = oa(this.__key);
    return t === null && Yt(113), t;
  }
  getWritable() {
    xs();
    var t = yu(), n = xi();
    t = t._nodeMap;
    let o = this.__key, r = this.getLatest(), i = r.__parent;
    n = n._cloneNotNeeded;
    var a = Kr();
    return a !== null && (a._cachedNodes = null), n.has(o) ? (aT(r), r) : (a = r.constructor.clone(r), a.__parent = i, a.__next = r.__next, a.__prev = r.__prev, kt(r) && kt(a) ? (a.__first = r.__first, a.__last = r.__last, a.__size = r.__size, a.__indent = r.__indent, a.__format = r.__format, a.__dir = r.__dir) : Xt(r) && Xt(a) && (a.__format = r.__format, a.__style = r.__style, a.__mode = r.__mode, a.__detail = r.__detail), n.add(o), a.__key = o, aT(a), t.set(o, a), a);
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM() {
    Yt(70);
  }
  updateDOM() {
    Yt(71);
  }
  exportDOM(t) {
    return { element: this.createDOM(t._config, t) };
  }
  exportJSON() {
    Yt(72);
  }
  static importJSON() {
    Yt(18);
  }
  static transform() {
    return null;
  }
  remove(t) {
    WL(this, !0, t);
  }
  replace(t, n) {
    xs();
    var o = Kr();
    o !== null && (o = o.clone()), A5(this, t);
    let r = this.getLatest(), i = this.__key, a = t.__key, s = t.getWritable();
    t = this.getParentOrThrow().getWritable();
    let c = t.__size;
    Of(s);
    let l = r.getPreviousSibling(), d = r.getNextSibling(), u = r.__prev, _ = r.__next, p = r.__parent;
    return WL(r, !1, !0), l === null ? t.__first = a : l.getWritable().__next = a, s.__prev = u, d === null ? t.__last = a : d.getWritable().__prev = a, s.__next = _, s.__parent = p, t.__size = c, n && this.getChildren().forEach((f) => {
      s.append(f);
    }), to(o) && (om(o), n = o.anchor, o = o.focus, n.key === i && SX(n, s), o.key === i && SX(o, s)), Pp() === i && Sa(a), s;
  }
  insertAfter(t, n = !0) {
    xs(), A5(this, t);
    var o = this.getWritable();
    let r = t.getWritable();
    var i = r.getParent();
    let a = Kr();
    var s = !1, c = !1;
    if (i !== null) {
      var l = t.getIndexWithinParent();
      Of(r), to(a) && (c = i.__key, s = a.anchor, i = a.focus, s = s.type === "element" && s.key === c && s.offset === l + 1, c = i.type === "element" && i.key === c && i.offset === l + 1);
    }
    i = this.getNextSibling(), l = this.getParentOrThrow().getWritable();
    let d = r.__key, u = o.__next;
    return i === null ? l.__last = d : i.getWritable().__prev = d, l.__size++, o.__next = d, r.__next = u, r.__prev = o.__key, r.__parent = o.__parent, n && to(a) && (n = this.getIndexWithinParent(), _T(a, l, n + 1), o = l.__key, s && a.anchor.set(o, n + 2, "element"), c && a.focus.set(o, n + 2, "element")), t;
  }
  insertBefore(t, n = !0) {
    xs(), A5(this, t);
    var o = this.getWritable();
    let r = t.getWritable(), i = r.__key;
    Of(r);
    let a = this.getPreviousSibling(), s = this.getParentOrThrow().getWritable(), c = o.__prev, l = this.getIndexWithinParent();
    return a === null ? s.__first = i : a.getWritable().__next = i, s.__size++, o.__prev = i, r.__prev = c, r.__next = o.__key, r.__parent = o.__parent, o = Kr(), n && to(o) && (n = this.getParentOrThrow(), _T(o, n, l)), t;
  }
  isParentRequired() {
    return !1;
  }
  createParentElementNode() {
    return Xf();
  }
  selectPrevious(t, n) {
    xs();
    let o = this.getPreviousSibling(), r = this.getParentOrThrow();
    return o === null ? r.select(0, 0) : kt(o) ? o.select() : Xt(o) ? o.select(t, n) : (t = o.getIndexWithinParent() + 1, r.select(t, t));
  }
  selectNext(t, n) {
    xs();
    let o = this.getNextSibling(), r = this.getParentOrThrow();
    return o === null ? r.select() : kt(o) ? o.select(0, 0) : Xt(o) ? o.select(t, n) : (t = o.getIndexWithinParent(), r.select(t, t));
  }
  markDirty() {
    this.getWritable();
  }
}
class du {
  constructor(t, n, o) {
    this._selection = null, this.key = t, this.offset = n, this.type = o;
  }
  is(t) {
    return this.key === t.key && this.offset === t.offset && this.type === t.type;
  }
  isBefore(t) {
    let n = this.getNode(), o = t.getNode(), r = this.offset;
    if (t = t.offset, kt(n)) {
      var i = n.getDescendantByIndex(r);
      n = i ?? n;
    }
    return kt(o) && (i = o.getDescendantByIndex(t), o = i ?? o), n === o ? r < t : n.isBefore(o);
  }
  getNode() {
    let t = oa(this.key);
    return t === null && Yt(20), t;
  }
  set(t, n, o) {
    let r = this._selection, i = this.key;
    this.key = t, this.offset = n, this.type = o, wb() || (Pp() === i && Sa(t), r !== null && (r._cachedNodes = null, r.dirty = !0));
  }
}
function O5(e, t) {
  let n = t.__key, o = e.offset, r = "element";
  if (Xt(t))
    r = "text", t = t.getTextContentSize(), o > t && (o = t);
  else if (!kt(t)) {
    var i = t.getNextSibling();
    Xt(i) ? (n = i.__key, o = 0, r = "text") : (i = t.getParent()) && (n = i.__key, o = t.getIndexWithinParent() + 1);
  }
  e.set(n, o, r);
}
function SX(e, t) {
  if (kt(t)) {
    let n = t.getLastDescendant();
    kt(n) || Xt(n) ? O5(e, n) : O5(e, t);
  } else
    O5(e, t);
}
function xX(e, t, n, o) {
  let r = e.getNode(), i = r.getChildAtIndex(e.offset), a = wa(), s = ec(r) ? Xf().append(a) : a;
  a.setFormat(n), a.setStyle(o), i === null ? r.append(s) : i.insertBefore(s), e.is(t) && t.set(a.__key, 0, "text"), e.set(a.__key, 0, "text");
}
function hp(e, t, n, o) {
  e.key = t, e.offset = n, e.type = o;
}
class jC {
  constructor(t) {
    this.dirty = !1, this._nodes = t, this._cachedNodes = null;
  }
  is(t) {
    if (!hk(t))
      return !1;
    let n = this._nodes, o = t._nodes;
    return n.size === o.size && Array.from(n).every((r) => o.has(r));
  }
  add(t) {
    this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
  }
  delete(t) {
    this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(t) {
    return this._nodes.has(t);
  }
  clone() {
    return new jC(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(t, n) {
    let o = this.getNodes(), r = o.length;
    var i = o[r - 1];
    if (Xt(i))
      i = i.select();
    else {
      let a = i.getIndexWithinParent() + 1;
      i = i.getParentOrThrow().select(a, a);
    }
    for (i.insertNodes(t, n), t = 0; t < r; t++)
      o[t].remove();
    return !0;
  }
  getNodes() {
    var t = this._cachedNodes;
    if (t !== null)
      return t;
    var n = this._nodes;
    t = [];
    for (let o of n)
      n = oa(o), n !== null && t.push(n);
    return wb() || (this._cachedNodes = t), t;
  }
  getTextContent() {
    let t = this.getNodes(), n = "";
    for (let o = 0; o < t.length; o++)
      n += t[o].getTextContent();
    return n;
  }
}
function to(e) {
  return e instanceof vg;
}
class FC {
  constructor(t, n, o) {
    this.gridKey = t, this.anchor = n, this.focus = o, this.dirty = !1, this._cachedNodes = null, n._selection = this, o._selection = this;
  }
  is(t) {
    return $8(t) ? this.gridKey === t.gridKey && this.anchor.is(t.anchor) && this.focus.is(t.focus) : !1;
  }
  set(t, n, o) {
    this.dirty = !0, this.gridKey = t, this.anchor.key = n, this.focus.key = o, this._cachedNodes = null;
  }
  clone() {
    return new FC(this.gridKey, this.anchor, this.focus);
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getCharacterOffsets() {
    return cx(this);
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(t, n) {
    let o = this.focus.getNode();
    return Zye(o.select(0, o.getChildrenSize())).insertNodes(t, n);
  }
  getShape() {
    var t = oa(this.anchor.key);
    t === null && Yt(21);
    var n = t.getIndexWithinParent();
    t = t.getParentOrThrow().getIndexWithinParent();
    var o = oa(this.focus.key);
    o === null && Yt(22);
    var r = o.getIndexWithinParent();
    let i = o.getParentOrThrow().getIndexWithinParent();
    return o = Math.min(n, r), n = Math.max(n, r), r = Math.min(t, i), t = Math.max(t, i), { fromX: Math.min(o, n), fromY: Math.min(r, t), toX: Math.max(o, n), toY: Math.max(r, t) };
  }
  getNodes() {
    function t(h) {
      let {
        cell: b,
        startColumn: v,
        startRow: $
      } = h;
      c = Math.min(c, v), l = Math.min(l, $), d = Math.max(d, v + b.__colSpan - 1), u = Math.max(u, $ + b.__rowSpan - 1);
    }
    var n = this._cachedNodes;
    if (n !== null)
      return n;
    var o = this.anchor.getNode();
    n = this.focus.getNode(), o = dT(o, tu);
    var r = dT(n, tu);
    tu(o) || Yt(103), tu(r) || Yt(104), n = o.getParent(), c0(n) || Yt(105), n = n.getParent(), x8(n) || Yt(106);
    let [i, a, s] = m$e(n, o, r), c = Math.min(a.startColumn, s.startColumn), l = Math.min(a.startRow, s.startRow), d = Math.max(a.startColumn + a.cell.__colSpan - 1, s.startColumn + s.cell.__colSpan - 1), u = Math.max(a.startRow + a.cell.__rowSpan - 1, s.startRow + s.cell.__rowSpan - 1);
    o = c, r = l;
    for (var _ = c, p = l; c < o || l < r || d > _ || u > p; ) {
      if (c < o) {
        var f = p - r;
        --o;
        for (var g = 0; g <= f; g++)
          t(i[r + g][o]);
      }
      if (l < r)
        for (f = _ - o, --r, g = 0; g <= f; g++)
          t(i[r][o + g]);
      if (d > _)
        for (f = p - r, _ += 1, g = 0; g <= f; g++)
          t(i[r + g][_]);
      if (u > p)
        for (f = _ - o, p += 1, g = 0; g <= f; g++)
          t(i[p][o + g]);
    }
    for (n = [n], o = null, r = l; r <= u; r++)
      for (_ = c; _ <= d; _++)
        ({ cell: p } = i[r][_]), f = p.getParent(), c0(f) || Yt(107), f !== o && n.push(f), n.push(p, ...BXl(p)), o = f;
    return wb() || (this._cachedNodes = n), n;
  }
  getTextContent() {
    let t = this.getNodes(), n = "";
    for (let o = 0; o < t.length; o++)
      n += t[o].getTextContent();
    return n;
  }
}
function $8(e) {
  return e instanceof FC;
}
class vg {
  constructor(t, n, o, r) {
    this.anchor = t, this.focus = n, this.dirty = !1, this.format = o, this.style = r, this._cachedNodes = null, t._selection = this, n._selection = this;
  }
  is(t) {
    return to(t) ? this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style : !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    var t = this._cachedNodes;
    if (t !== null)
      return t;
    t = this.anchor;
    var n = this.focus, o = t.isBefore(n), r = o ? t : n;
    o = o ? n : t, t = r.getNode(), n = o.getNode();
    let i = r.offset;
    return r = o.offset, kt(t) && (o = t.getDescendantByIndex(i), t = o ?? t), kt(n) && (o = n.getDescendantByIndex(r), o !== null && o !== t && n.getChildAtIndex(r) === o && (o = o.getPreviousSibling()), n = o ?? n), t = t.is(n) ? kt(t) && 0 < t.getChildrenSize() ? [] : [t] : t.getNodesBetween(n), wb() || (this._cachedNodes = t), t;
  }
  setTextNodeRange(t, n, o, r) {
    hp(this.anchor, t.__key, n, "text"), hp(this.focus, o.__key, r, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    let t = this.getNodes();
    if (t.length === 0)
      return "";
    let n = t[0], o = t[t.length - 1], r = this.anchor, i = this.focus, a = r.isBefore(i), [s, c] = cx(this), l = "", d = !0;
    for (let u = 0; u < t.length; u++) {
      let _ = t[u];
      if (kt(_) && !_.isInline())
        d || (l += `
`), d = !_.isEmpty();
      else if (d = !1, Xt(_)) {
        let p = _.getTextContent();
        _ === n ? _ === o ? (r.type !== "element" || i.type !== "element" || i.offset === r.offset) && (p = s < c ? p.slice(s, c) : p.slice(c, s)) : p = a ? p.slice(s) : p.slice(c) : _ === o && (p = a ? p.slice(0, c) : p.slice(0, s)), l += p;
      } else
        !Hr(_) && !s0(_) || _ === o && this.isCollapsed() || (l += _.getTextContent());
    }
    return l;
  }
  applyDOMRange(t) {
    let n = xi(), o = n.getEditorState()._selection;
    if (t = u$e(t.startContainer, t.startOffset, t.endContainer, t.endOffset, n, o), t !== null) {
      var [r, i] = t;
      hp(this.anchor, r.key, r.offset, r.type), hp(this.focus, i.key, i.offset, i.type), this._cachedNodes = null;
    }
  }
  clone() {
    let t = this.anchor, n = this.focus;
    return new vg(new du(t.key, t.offset, t.type), new du(n.key, n.offset, n.type), this.format, this.style);
  }
  toggleFormat(t) {
    this.format = Mye(this.format, t, null), this.dirty = !0;
  }
  setStyle(t) {
    this.style = t, this.dirty = !0;
  }
  hasFormat(t) {
    return (this.format & zf[t]) !== 0;
  }
  insertRawText(t) {
    let n = t.split(/\r?\n/);
    if (n.length === 1)
      this.insertText(t);
    else {
      t = [];
      let o = n.length;
      for (let r = 0; r < o; r++) {
        let i = n[r];
        i !== "" && t.push(wa(i)), r !== o - 1 && t.push(Bv());
      }
      this.insertNodes(t);
    }
  }
  insertText(t) {
    var n = this.anchor, o = this.focus, r = this.isCollapsed() || n.isBefore(o), i = this.format, a = this.style;
    r && n.type === "element" ? xX(n, o, i, a) : r || o.type !== "element" || xX(o, n, i, a);
    var s = this.getNodes(), c = s.length, l = r ? o : n;
    o = (r ? n : o).offset;
    var d = l.offset;
    n = s[0], Xt(n) || Yt(26), r = n.getTextContent().length;
    var u = n.getParentOrThrow(), _ = s[c - 1];
    if (this.isCollapsed() && o === r && (n.isSegmented() || n.isToken() || !n.canInsertTextAfter() || !u.canInsertTextAfter() && n.getNextSibling() === null)) {
      var p = n.getNextSibling();
      if ((!Xt(p) || PL(p)) && (p = wa(), p.setFormat(i), u.canInsertTextAfter() ? n.insertAfter(p) : u.insertAfter(p)), p.select(0, 0), n = p, t !== "") {
        this.insertText(t);
        return;
      }
    } else if (this.isCollapsed() && o === 0 && (n.isSegmented() || n.isToken() || !n.canInsertTextBefore() || !u.canInsertTextBefore() && n.getPreviousSibling() === null)) {
      if (p = n.getPreviousSibling(), (!Xt(p) || PL(p)) && (p = wa(), p.setFormat(i), u.canInsertTextBefore() ? n.insertBefore(p) : u.insertBefore(p)), p.select(), n = p, t !== "") {
        this.insertText(t);
        return;
      }
    } else if (n.isSegmented() && o !== r)
      u = wa(n.getTextContent()), u.setFormat(i), n.replace(u), n = u;
    else if (!(this.isCollapsed() || t === "" || (p = _.getParent(), u.canInsertTextBefore() && u.canInsertTextAfter() && (!kt(p) || p.canInsertTextBefore() && p.canInsertTextAfter())))) {
      this.insertText(""), d$e(this.anchor, this.focus, null), this.insertText(t);
      return;
    }
    if (c === 1)
      if (n.isToken())
        t = wa(t), t.select(), n.replace(t);
      else {
        if (s = n.getFormat(), c = n.getStyle(), o === d && (s !== i || c !== a))
          if (n.getTextContent() === "")
            n.setFormat(i), n.setStyle(a);
          else {
            s = wa(t), s.setFormat(i), s.setStyle(a), s.select(), o === 0 ? n.insertBefore(s, !1) : ([c] = n.splitText(o), c.insertAfter(s, !1)), s.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length);
            return;
          }
        n = n.spliceText(o, d - o, t, !0), n.getTextContent() === "" ? n.remove() : this.anchor.type === "text" && (n.isComposing() ? this.anchor.offset -= t.length : (this.format = s, this.style = c));
      }
    else {
      if (i = /* @__PURE__ */ new Set([...n.getParentKeys(), ..._.getParentKeys()]), p = kt(n) ? n : n.getParentOrThrow(), a = kt(_) ? _ : _.getParentOrThrow(), u = _, !p.is(a) && a.isInline())
        do
          u = a, a = a.getParentOrThrow();
        while (a.isInline());
      l.type === "text" && (d !== 0 || _.getTextContent() === "") || l.type === "element" && _.getIndexWithinParent() < d ? Xt(_) && !_.isToken() && d !== _.getTextContentSize() ? (_.isSegmented() && (l = wa(_.getTextContent()), _.replace(l), _ = l), _ = _.spliceText(0, d, ""), i.add(_.__key)) : (l = _.getParentOrThrow(), l.canBeEmpty() || l.getChildrenSize() !== 1 ? _.remove() : l.remove()) : i.add(_.__key), l = a.getChildren(), d = new Set(s), _ = p.is(a), p = p.isInline() && n.getNextSibling() === null ? p : n;
      for (let f = l.length - 1; 0 <= f; f--) {
        let g = l[f];
        if (g.is(n) || kt(g) && g.isParentOf(n))
          break;
        g.isAttached() && (!d.has(g) || g.is(u) ? _ || p.insertAfter(g, !1) : g.remove());
      }
      if (!_)
        for (l = a, d = null; l !== null; )
          a = l.getChildren(), _ = a.length, (_ === 0 || a[_ - 1].is(d)) && (i.delete(l.__key), d = l), l = l.getParent();
      for (n.isToken() ? o === r ? n.select() : (t = wa(t), t.select(), n.replace(t)) : (n = n.spliceText(o, r - o, t, !0), n.getTextContent() === "" ? n.remove() : n.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length)), t = 1; t < c; t++)
        n = s[t], i.has(n.__key) || n.remove();
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(t) {
    if (this.isCollapsed())
      this.toggleFormat(t), Sa(null);
    else {
      var n = this.getNodes(), o = [];
      for (var r of n)
        Xt(r) && o.push(r);
      var i = o.length;
      if (i === 0)
        this.toggleFormat(t), Sa(null);
      else {
        r = this.anchor;
        var a = this.focus, s = this.isBackward();
        n = s ? a : r, r = s ? r : a;
        var c = 0, l = o[0];
        if (a = n.type === "element" ? 0 : n.offset, n.type === "text" && a === l.getTextContentSize() && (c = 1, l = o[1], a = 0), l != null) {
          s = l.getFormatFlags(t, null);
          var d = i - 1, u = o[d];
          if (i = r.type === "text" ? r.offset : u.getTextContentSize(), l.is(u))
            a !== i && (a === 0 && i === l.getTextContentSize() ? l.setFormat(s) : (t = l.splitText(a, i), t = a === 0 ? t[0] : t[1], t.setFormat(s), n.type === "text" && n.set(t.__key, 0, "text"), r.type === "text" && r.set(t.__key, i - a, "text")), this.format = s);
          else {
            a !== 0 && ([, l] = l.splitText(a), a = 0), l.setFormat(s);
            var _ = u.getFormatFlags(t, s);
            for (0 < i && (i !== u.getTextContentSize() && ([u] = u.splitText(i)), u.setFormat(_)), c += 1; c < d; c++) {
              let p = o[c];
              if (!p.isToken()) {
                let f = p.getFormatFlags(t, _);
                p.setFormat(f);
              }
            }
            n.type === "text" && n.set(l.__key, a, "text"), r.type === "text" && r.set(u.__key, i, "text"), this.format = s | _;
          }
        }
      }
    }
  }
  insertNodes(t, n) {
    if (!this.isCollapsed()) {
      var o = this.isBackward() ? this.anchor : this.focus, r = o.getNode().getNextSibling();
      if (r = r ? r.getKey() : null, o = (o = o.getNode().getPreviousSibling()) ? o.getKey() : null, this.removeText(), this.isCollapsed() && this.focus.type === "element") {
        if (this.focus.key === r && this.focus.offset === 0) {
          var i = wa();
          this.focus.getNode().insertBefore(i);
        } else
          this.focus.key === o && this.focus.offset === this.focus.getNode().getChildrenSize() && (i = wa(), this.focus.getNode().insertAfter(i));
        i && (this.focus.set(i.__key, 0, "text"), this.anchor.set(i.__key, 0, "text"));
      }
    }
    i = this.anchor, o = i.offset;
    var a = i.getNode();
    r = a, i.type === "element" && (i = i.getNode(), r = i.getChildAtIndex(o - 1), r = r === null ? i : r), i = [];
    var s = a.getNextSiblings(), c = Xl(a) ? null : a.getTopLevelElementOrThrow();
    if (Xt(a))
      if (r = a.getTextContent().length, o === 0 && r !== 0)
        r = a.getPreviousSibling(), r = r !== null ? r : a.getParentOrThrow(), i.push(a);
      else if (o === r)
        r = a;
      else {
        if (a.isToken())
          return !1;
        [r, a] = a.splitText(o), i.push(a);
      }
    a = r, i.push(...s), s = t[0];
    var l = !1, d = null;
    for (let f = 0; f < t.length; f++) {
      var u = t[f];
      if (Xl(r) || Hr(r) || !kt(u) || u.isInline())
        l && !kt(u) && !Hr(u) && Xl(r.getParent()) && Yt(28);
      else {
        if (u.is(s)) {
          if (kt(r) && r.isEmpty() && r.canReplaceWith(u)) {
            r.replace(u), r = u, l = !0;
            continue;
          }
          if (l = u.getFirstDescendant(), Lye(l)) {
            for (var _ = l.getParentOrThrow(); _.isInline(); )
              _ = _.getParentOrThrow();
            if (d = _.getChildren(), l = d.length, kt(r)) {
              var p = r.getFirstChild();
              for (let g = 0; g < l; g++) {
                let h = d[g];
                p === null ? r.append(h) : p.insertAfter(h), p = h;
              }
            } else {
              for (p = l - 1; 0 <= p; p--)
                r.insertAfter(d[p]);
              r = r.getParentOrThrow();
            }
            if (d = d[l - 1], _.remove(), l = !0, _.is(u))
              continue;
          }
        }
        Xt(r) && (c === null && Yt(27), r = c);
      }
      l = !1, kt(r) && !r.isInline() ? (d = u, Hr(u) && !u.isInline() ? r = r.insertAfter(u, !1) : kt(u) ? (u.canBeEmpty() || !u.isEmpty()) && (ec(r) ? (_ = r.getChildAtIndex(o), _ !== null ? _.insertBefore(u) : r.append(u), r = u) : u.isInline() ? (r.append(u), r = u) : r = r.insertAfter(u, !1)) : (_ = r.getFirstChild(), _ !== null ? _.insertBefore(u) : r.append(u), r = u)) : !kt(u) || kt(u) && u.isInline() || Hr(r) && !r.isInline() ? (d = u, to(this) && Hr(u) && (kt(r) || Xt(r)) && !u.isInline() ? (Xt(r) ? (_ = r.getParentOrThrow(), [r] = r.splitText(o), r = r.getIndexWithinParent() + 1) : (_ = r, r = o), [, r] = Hye(_, r), r = r.insertBefore(u)) : r = r.insertAfter(u, !1)) : (u = r.getParentOrThrow(), s0(r) && r.remove(), r = u, f--);
    }
    if (n && (Xt(a) ? a.select() : (t = r.getPreviousSibling(), Xt(t) ? t.select() : (t = r.getIndexWithinParent(), r.getParentOrThrow().select(t, t)))), kt(r)) {
      if (t = Xt(d) ? d : kt(d) && d.isInline() ? d.getLastDescendant() : r.getLastDescendant(), n || (t === null ? r.select() : Xt(t) ? t.getTextContent() === "" ? t.selectPrevious() : t.select() : t.selectNext()), i.length !== 0)
        for (n = r, t = i.length - 1; 0 <= t; t--)
          o = i[t], c = o.getParentOrThrow(), !kt(r) || zX(o) || Hr(o) && (!o.isInline() || o.isIsolated()) ? kt(r) || zX(o) ? kt(o) && !o.canInsertAfter(r) ? (a = c.constructor.clone(c), kt(a) || Yt(29), a.append(o), r.insertAfter(a)) : r.insertAfter(o) : (r.insertBefore(o), r = o) : (n === r ? r.append(o) : r.insertBefore(o), r = o), c.isEmpty() && !c.canBeEmpty() && c.remove();
    } else
      n || (Xt(r) ? r.select() : (n = r.getParentOrThrow(), t = r.getIndexWithinParent() + 1, n.select(t, t)));
    return !0;
  }
  insertParagraph() {
    this.isCollapsed() || this.removeText();
    var t = this.anchor, n = t.offset, o = [];
    if (t.type === "text") {
      var r = t.getNode(), i = r.getNextSiblings().reverse(), a = r.getParentOrThrow(), s = a.isInline(), c = s ? a.getTextContentSize() : r.getTextContentSize();
      n === 0 ? i.push(r) : (s && (o = a.getNextSiblings()), n === c || s && n === r.getTextContentSize() || ([, r] = r.splitText(n), i.push(r)));
    } else {
      if (a = t.getNode(), Xl(a)) {
        i = Xf(), o = a.getChildAtIndex(n), i.select(), o !== null ? o.insertBefore(i, !1) : a.append(i);
        return;
      }
      i = a.getChildren().slice(n).reverse();
    }
    if (r = i.length, n === 0 && 0 < r && a.isInline()) {
      if (o = a.getParentOrThrow(), i = o.insertNewAfter(this, !1), kt(i))
        for (o = o.getChildren(), a = 0; a < o.length; a++)
          i.append(o[a]);
    } else if (s = a.insertNewAfter(this, !1), s === null)
      this.insertLineBreak();
    else if (kt(s))
      if (c = a.getFirstChild(), n === 0 && (a.is(t.getNode()) || c && c.is(t.getNode())) && 0 < r)
        a.insertBefore(s);
      else {
        if (a = null, n = o.length, t = s.getParentOrThrow(), 0 < n)
          for (c = 0; c < n; c++)
            t.append(o[c]);
        if (r !== 0)
          for (o = 0; o < r; o++)
            n = i[o], a === null ? s.append(n) : a.insertBefore(n), a = n;
        s.canBeEmpty() || s.getChildrenSize() !== 0 ? s.selectStart() : (s.selectPrevious(), s.remove());
      }
  }
  insertLineBreak(t) {
    let n = Bv();
    var o = this.anchor;
    o.type === "element" && (o = o.getNode(), ec(o) && this.insertParagraph()), t ? this.insertNodes([n], !0) : this.insertNodes([n]) && n.selectNext(0, 0);
  }
  getCharacterOffsets() {
    return cx(this);
  }
  extract() {
    var t = this.getNodes(), n = t.length, o = n - 1, r = this.anchor;
    let i = this.focus;
    var a = t[0];
    let s = t[o], [c, l] = cx(this);
    return n === 0 ? [] : n === 1 ? Xt(a) && !this.isCollapsed() ? (t = c > l ? l : c, o = a.splitText(t, c > l ? c : l), t = t === 0 ? o[0] : o[1], t != null ? [t] : []) : [a] : (n = r.isBefore(i), Xt(a) && (r = n ? c : l, r === a.getTextContentSize() ? t.shift() : r !== 0 && ([, a] = a.splitText(r), t[0] = a)), Xt(s) && (a = s.getTextContent().length, n = n ? l : c, n === 0 ? t.pop() : n !== a && ([s] = s.splitText(n), t[o] = s)), t);
  }
  modify(t, n, o) {
    var r = this.focus, i = this.anchor, a = t === "move", s = IL(r, n);
    if (Hr(s) && !s.isIsolated())
      a && s.isKeyboardSelectable() ? (n = GL(), n.add(s.__key), om(n)) : (t = n ? s.getPreviousSibling() : s.getNextSibling(), Xt(t) ? (s = t.__key, n = n ? t.getTextContent().length : 0, r.set(s, n, "text"), a && i.set(s, n, "text")) : (o = s.getParentOrThrow(), kt(t) ? (o = t.__key, s = n ? t.getChildrenSize() : 0) : (s = s.getIndexWithinParent(), o = o.__key, n || s++), r.set(o, s, "element"), a && i.set(o, s, "element")));
    else if (i = xi(), r = bu(i._window)) {
      var c = i._blockCursorElement, l = i._rootElement;
      if (l === null || c === null || !kt(s) || s.isInline() || s.canBeEmpty() || RL(c, i, l), r.modify(t, n ? "backward" : "forward", o), 0 < r.rangeCount && (s = r.getRangeAt(0), i = this.anchor.getNode(), i = ec(i) ? i : Wye(i), this.applyDOMRange(s), this.dirty = !0, !a)) {
        for (a = this.getNodes(), t = [], o = !1, c = 0; c < a.length; c++)
          l = a[c], lT(l, i) ? t.push(l) : o = !0;
        o && 0 < t.length && (n ? (n = t[0], kt(n) ? n.selectStart() : n.getParentOrThrow().selectStart()) : (n = t[t.length - 1], kt(n) ? n.selectEnd() : n.getParentOrThrow().selectEnd())), (r.anchorNode !== s.startContainer || r.anchorOffset !== s.startOffset) && (n = this.focus, a = this.anchor, r = a.key, s = a.offset, i = a.type, hp(a, n.key, n.offset, n.type), hp(
          n,
          r,
          s,
          i
        ), this._cachedNodes = null);
      }
    }
  }
  deleteCharacter(t) {
    if (this.isCollapsed()) {
      var n = this.anchor, o = this.focus, r = n.getNode();
      if (!t && (n.type === "element" && kt(r) && n.offset === r.getChildrenSize() || n.type === "text" && n.offset === r.getTextContentSize())) {
        var i = r.getParent();
        if (i = r.getNextSibling() || (i === null ? null : i.getNextSibling()), kt(i) && !i.canExtractContents())
          return;
      }
      if (i = IL(o, t), Hr(i) && !i.isIsolated()) {
        i.isKeyboardSelectable() && kt(r) && r.getChildrenSize() === 0 ? (r.remove(), t = GL(), t.add(i.__key), om(t)) : i.remove();
        return;
      }
      if (this.modify(
        "extend",
        t,
        "character"
      ), this.isCollapsed()) {
        if (t && n.offset === 0 && (n.type === "element" ? n.getNode() : n.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        if (i = o.type === "text" ? o.getNode() : null, r = n.type === "text" ? n.getNode() : null, i !== null && i.isSegmented()) {
          if (n = o.offset, o = i.getTextContentSize(), i.is(r) || t && n !== o || !t && n !== 0) {
            TX(i, t, n);
            return;
          }
        } else if (r !== null && r.isSegmented() && (n = n.offset, o = r.getTextContentSize(), r.is(i) || t && n !== 0 || !t && n !== o)) {
          TX(r, t, n);
          return;
        }
        if (r = this.anchor, i = this.focus, n = r.getNode(), o = i.getNode(), n === o && r.type === "text" && i.type === "text") {
          var a = r.offset, s = i.offset;
          let c = a < s;
          o = c ? a : s, s = c ? s : a, a = s - 1, o !== a && (n = n.getTextContent().slice(o, s), Vye(n) || (t ? i.offset = a : r.offset = a));
        }
      }
    }
    r = this.isCollapsed(), this.removeText(), t && !r && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0 && (t = this.anchor.getNode(), t.isEmpty() && ec(t.getParent()) && t.getIndexWithinParent() === 0 && t.collapseAtStart(this));
  }
  deleteLine(t) {
    this.isCollapsed() && (this.anchor.type === "text" && this.modify(
      "extend",
      t,
      "lineboundary"
    ), (t ? this.focus : this.anchor).offset === 0 && this.modify("extend", t, "character")), this.removeText();
  }
  deleteWord(t) {
    this.isCollapsed() && this.modify("extend", t, "word"), this.removeText();
  }
}
function hk(e) {
  return e instanceof jC;
}
function EX(e) {
  let t = e.offset;
  return e.type === "text" ? t : (e = e.getNode(), t === e.getChildrenSize() ? e.getTextContent().length : 0);
}
function cx(e) {
  let t = e.anchor;
  return e = e.focus, t.type === "element" && e.type === "element" && t.key === e.key && t.offset === e.offset ? [0, 0] : [EX(t), EX(e)];
}
function TX(e, t, n) {
  let o = e.getTextContent().split(/(?=\s)/g), r = o.length, i = 0, a = 0;
  for (let s = 0; s < r; s++) {
    let c = o[s], l = s === r - 1;
    if (a = i, i += c.length, t && i === n || i > n || l) {
      o.splice(s, 1), l && (a = void 0);
      break;
    }
  }
  t = o.join("").trim(), t === "" ? e.remove() : (e.setTextContent(t), e.select(a, a));
}
function AX(e, t, n, o) {
  var r = t;
  if (e.nodeType === 1) {
    let s = !1;
    var i = e.childNodes, a = i.length;
    r === a && (s = !0, r = a - 1);
    let c = i[r];
    if (a = !1, c === o._blockCursorElement ? (c = i[r + 1], a = !0) : o._blockCursorElement !== null && r--, o = Th(c), Xt(o))
      r = s ? o.getTextContentSize() : 0;
    else {
      if (i = Th(e), i === null)
        return null;
      if (kt(i) ? (e = i.getChildAtIndex(r), (t = kt(e)) && (t = e.getParent(), t = n === null || t === null || !t.canBeEmpty() || t !== n.getNode()), t && (n = s ? e.getLastDescendant() : e.getFirstDescendant(), n === null ? (i = e, r = 0) : (e = n, i = kt(e) ? e : e.getParentOrThrow())), Xt(e) ? (o = e, i = null, r = s ? e.getTextContentSize() : 0) : e !== i && s && !a && r++) : (r = i.getIndexWithinParent(), r = t === 0 && Hr(i) && Th(e) === i ? r : r + 1, i = i.getParentOrThrow()), kt(i))
        return new du(i.__key, r, "element");
    }
  } else
    o = Th(e);
  return Xt(o) ? new du(o.__key, r, "text") : null;
}
function CX(e, t, n) {
  var o = e.offset, r = e.getNode();
  o === 0 ? (o = r.getPreviousSibling(), r = r.getParent(), t ? (n || !t) && o === null && kt(r) && r.isInline() && (t = r.getPreviousSibling(), Xt(t) && (e.key = t.__key, e.offset = t.getTextContent().length)) : kt(o) && !n && o.isInline() ? (e.key = o.__key, e.offset = o.getChildrenSize(), e.type = "element") : Xt(o) && (e.key = o.__key, e.offset = o.getTextContent().length)) : o === r.getTextContent().length && (o = r.getNextSibling(), r = r.getParent(), t && kt(o) && o.isInline() ? (e.key = o.__key, e.offset = 0, e.type = "element") : (n || t) && o === null && kt(r) && r.isInline() && !r.canInsertTextAfter() && (t = r.getNextSibling(), Xt(t) && (e.key = t.__key, e.offset = 0)));
}
function d$e(e, t, n) {
  if (e.type === "text" && t.type === "text") {
    var o = e.isBefore(t);
    let r = e.is(t);
    CX(e, o, r), CX(t, !o, r), r && (t.key = e.key, t.offset = e.offset, t.type = e.type), o = xi(), o.isComposing() && o._compositionKey !== e.key && to(n) && (o = n.anchor, n = n.focus, hp(e, o.key, o.offset, o.type), hp(t, n.key, n.offset, n.type));
  }
}
function u$e(e, t, n, o, r, i) {
  return e === null || n === null || !mk(r, e, n) || (t = AX(e, t, to(i) ? i.anchor : null, r), t === null) || (o = AX(n, o, to(i) ? i.focus : null, r), o === null || t.type === "element" && o.type === "element" && (e = Th(e), n = Th(n), Hr(e) && Hr(n))) ? null : (d$e(t, o, i), [t, o]);
}
function zX(e) {
  return kt(e) && !e.isInline();
}
function _$e(e, t, n, o, r, i) {
  let a = yu();
  return e = new vg(new du(e, t, r), new du(n, o, i), 0, ""), e.dirty = !0, a._selection = e;
}
function GL() {
  return new jC(/* @__PURE__ */ new Set());
}
function eed(e) {
  let t = e.getEditorState()._selection, n = bu(e._window);
  return hk(t) || $8(t) ? t.clone() : p$e(t, n, e);
}
function p$e(e, t, n) {
  var o = n._window;
  if (o === null)
    return null;
  var r = o.event, i = r ? r.type : void 0;
  o = i === "selectionchange", r = !OL && (o || i === "beforeinput" || i === "compositionstart" || i === "compositionend" || i === "click" && r && r.detail === 3 || i === "drop" || i === void 0);
  let a;
  if (!to(e) || r) {
    if (t === null)
      return null;
    if (r = t.anchorNode, i = t.focusNode, a = t.anchorOffset, t = t.focusOffset, o && to(e) && !mk(n, r, i))
      return e.clone();
  } else
    return e.clone();
  if (n = u$e(r, a, i, t, n, e), n === null)
    return null;
  let [s, c] = n;
  return new vg(s, c, to(e) ? e.format : 0, to(e) ? e.style : "");
}
function Kr() {
  return yu()._selection;
}
function vk() {
  return xi()._editorState._selection;
}
function _T(e, t, n, o = 1) {
  var r = e.anchor, i = e.focus, a = r.getNode(), s = i.getNode();
  if (t.is(a) || t.is(s))
    if (a = t.__key, e.isCollapsed())
      t = r.offset, n <= t && (n = Math.max(0, t + o), r.set(a, n, "element"), i.set(a, n, "element"), OX(e));
    else {
      var c = e.isBackward();
      s = c ? i : r;
      var l = s.getNode();
      r = c ? r : i, i = r.getNode(), t.is(l) && (l = s.offset, n <= l && s.set(a, Math.max(0, l + o), "element")), t.is(i) && (t = r.offset, n <= t && r.set(a, Math.max(0, t + o), "element")), OX(e);
    }
}
function OX(e) {
  var t = e.anchor, n = t.offset;
  let o = e.focus;
  var r = o.offset, i = t.getNode(), a = o.getNode();
  if (e.isCollapsed())
    kt(i) && (a = i.getChildrenSize(), a = (r = n >= a) ? i.getChildAtIndex(a - 1) : i.getChildAtIndex(n), Xt(a) && (n = 0, r && (n = a.getTextContentSize()), t.set(a.__key, n, "text"), o.set(a.__key, n, "text")));
  else {
    if (kt(i)) {
      let s = i.getChildrenSize();
      n = (e = n >= s) ? i.getChildAtIndex(s - 1) : i.getChildAtIndex(n), Xt(n) && (i = 0, e && (i = n.getTextContentSize()), t.set(n.__key, i, "text"));
    }
    kt(a) && (n = a.getChildrenSize(), r = (t = r >= n) ? a.getChildAtIndex(n - 1) : a.getChildAtIndex(r), Xt(r) && (a = 0, t && (a = r.getTextContentSize()), o.set(r.__key, a, "text")));
  }
}
function ted(e, t) {
  if (t = t.getEditorState()._selection, e = e._selection, to(e)) {
    var n = e.anchor;
    let o = e.focus, r;
    n.type === "text" && (r = n.getNode(), r.selectionTransform(t, e)), o.type === "text" && (n = o.getNode(), r !== n && n.selectionTransform(t, e));
  }
}
function pT(e, t, n, o, r) {
  let i = null, a = 0, s = null;
  o !== null ? (i = o.__key, Xt(o) ? (a = o.getTextContentSize(), s = "text") : kt(o) && (a = o.getChildrenSize(), s = "element")) : r !== null && (i = r.__key, Xt(r) ? s = "text" : kt(r) && (s = "element")), i !== null && s !== null ? e.set(i, a, s) : (a = t.getIndexWithinParent(), a === -1 && (a = n.getChildrenSize()), e.set(n.__key, a, "element"));
}
function PX(e, t, n, o, r) {
  e.type === "text" ? (e.key = n, t || (e.offset += r)) : e.offset > o.getIndexWithinParent() && --e.offset;
}
function m$e(e, t, n) {
  let o = [], r = null, i = null;
  e = e.getChildren();
  for (let d = 0; d < e.length; d++) {
    var a = e[d];
    c0(a) || Yt(108);
    var s = a.getChildren();
    a = 0;
    for (let u of s) {
      for (tu(u) || Yt(109); o[d] !== void 0 && o[d][a] !== void 0; )
        a++;
      s = d;
      var c = a, l = u;
      let _ = { cell: l, startColumn: c, startRow: s }, p = l.__rowSpan, f = l.__colSpan;
      for (let g = 0; g < p; g++) {
        o[s + g] === void 0 && (o[s + g] = []);
        for (let h = 0; h < f; h++)
          o[s + g][c + h] = _;
      }
      t.is(l) && (r = _), n.is(l) && (i = _), a += u.__colSpan;
    }
  }
  return r === null && Yt(110), i === null && Yt(111), [o, r, i];
}
let ra = null, ia = null, oc = !1, P5 = !1, a0 = 0, IX = { characterData: !0, childList: !0, subtree: !0 };
function wb() {
  return oc || ra !== null && ra._readOnly;
}
function xs() {
  oc && Yt(13);
}
function yu() {
  return ra === null && Yt(15), ra;
}
function xi() {
  return ia === null && Yt(16), ia;
}
function RX(e, t, n) {
  var o = t.__type;
  let r = e._nodes.get(o);
  for (r === void 0 && Yt(30), e = n.get(o), e === void 0 && (e = Array.from(r.transforms), n.set(o, e)), n = e.length, o = 0; o < n && (e[o](t), t.isAttached()); o++)
    ;
}
function ned(e, t) {
  t = t._dirtyLeaves, e = e._nodeMap;
  for (let n of t)
    t = e.get(n), Xt(t) && t.isAttached() && t.isSimpleText() && !t.isUnmergeable() && Yye(t);
}
function oed(e, t) {
  let n = t._dirtyLeaves, o = t._dirtyElements;
  e = e._nodeMap;
  let r = Pp(), i = /* @__PURE__ */ new Map();
  var a = n;
  let s = a.size;
  for (var c = o, l = c.size; 0 < s || 0 < l; ) {
    if (0 < s) {
      t._dirtyLeaves = /* @__PURE__ */ new Set();
      for (let d of a)
        a = e.get(d), Xt(a) && a.isAttached() && a.isSimpleText() && !a.isUnmergeable() && Yye(a), a !== void 0 && a !== void 0 && a.__key !== r && a.isAttached() && RX(t, a, i), n.add(d);
      if (a = t._dirtyLeaves, s = a.size, 0 < s) {
        a0++;
        continue;
      }
    }
    t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements = /* @__PURE__ */ new Map();
    for (let d of c)
      c = d[0], l = d[1], (c === "root" || l) && (a = e.get(c), a !== void 0 && a !== void 0 && a.__key !== r && a.isAttached() && RX(t, a, i), o.set(c, l));
    a = t._dirtyLeaves, s = a.size, c = t._dirtyElements, l = c.size, a0++;
  }
  t._dirtyLeaves = n, t._dirtyElements = o;
}
function w8(e, t) {
  var n = t.get(e.type);
  if (n === void 0 && Yt(17), n = n.klass, e.type !== n.getType() && Yt(18), n = n.importJSON(e), e = e.children, kt(n) && Array.isArray(e))
    for (let o = 0; o < e.length; o++) {
      let r = w8(e[o], t);
      n.append(r);
    }
  return n;
}
function NX(e, t) {
  let n = ra, o = oc, r = ia;
  ra = e, oc = !0, ia = null;
  try {
    return t();
  } finally {
    ra = n, oc = o, ia = r;
  }
}
function Pf(e) {
  let t = e._pendingEditorState, n = e._rootElement, o = e._headless || n === null;
  if (t !== null) {
    var r = e._editorState, i = r._selection, a = t._selection, s = e._dirtyType !== 0, c = ra, l = oc, d = ia, u = e._updating, _ = e._observer, p = null;
    if (e._pendingEditorState = null, e._editorState = t, !o && s && _ !== null) {
      ia = e, ra = t, oc = !1, e._updating = !0;
      try {
        let ue = e._dirtyType, le = e._dirtyElements, se = e._dirtyLeaves;
        _.disconnect();
        var f = ue, g = le, h = se;
        Ss = r_ = Vi = "", Qye = f === 2, ix = null, Qa = e, rm = e._config, o0 = e._nodes, qC = Qa._listeners.mutation, NL = g, DL = h, Jf = r._nodeMap, im = t._nodeMap, y8 = t._readOnly, ML = new Map(e._keyToDOMMap);
        let me = /* @__PURE__ */ new Map();
        r0 = me, v$("root", null), r0 = ML = rm = im = Jf = DL = NL = o0 = Qa = void 0, p = me;
      } catch (ue) {
        if (ue instanceof Error && e._onError(ue), P5)
          throw ue;
        v$e(e, null, n, t), Nye(e), e._dirtyType = 2, P5 = !0, Pf(e), P5 = !1;
        return;
      } finally {
        _.observe(n, IX), e._updating = u, ra = c, oc = l, ia = d;
      }
    }
    t._readOnly || (t._readOnly = !0);
    var b = e._dirtyLeaves, v = e._dirtyElements, $ = e._normalizedNodes, k = e._updateTags, S = e._deferred;
    s && (e._dirtyType = 0, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements = /* @__PURE__ */ new Map(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set());
    var O = e._decorators, I = e._pendingDecorators || O, D = t._nodeMap, M;
    for (M in I)
      D.has(M) || (I === O && (I = Fye(e)), delete I[M]);
    var N = o ? null : bu(e._window);
    if (e._editable && N !== null && (s || a === null || a.dirty)) {
      ia = e, ra = t;
      try {
        if (_ !== null && _.disconnect(), s || a === null || a.dirty) {
          let ue = e._blockCursorElement;
          ue !== null && RL(ue, e, n);
          e: {
            let le = N.anchorNode, se = N.focusNode, me = N.anchorOffset, pe = N.focusOffset, be = document.activeElement;
            if (!(k.has("collaboration") && be !== n || be !== null && Dye(be)))
              if (to(a)) {
                var C = a.anchor, P = a.focus, x = C.key, w = P.key, E = cT(e, x), T = cT(e, w), z = C.offset, j = P.offset, q = a.format, V = a.style, F = a.isCollapsed(), L = E, U = T, W = !1;
                if (C.type === "text") {
                  L = iT(E);
                  let Se = C.getNode();
                  W = Se.getFormat() !== q || Se.getStyle() !== V;
                } else
                  to(i) && i.anchor.type === "text" && (W = !0);
                if (P.type === "text" && (U = iT(T)), L !== null && U !== null) {
                  if (F && (i === null || W || to(i) && (i.format !== q || i.style !== V))) {
                    var H = performance.now();
                    i$e = [q, V, z, x, H];
                  }
                  if (me === z && pe === j && le === L && se === U && (N.type !== "Range" || !F) && (be !== null && n.contains(be) || n.focus({ preventScroll: !0 }), C.type !== "element"))
                    break e;
                  try {
                    N.setBaseAndExtent(L, z, U, j);
                  } catch {
                  }
                  if (!k.has("skip-scroll-into-view") && a.isCollapsed() && n !== null && n === document.activeElement) {
                    let Se = a instanceof vg && a.anchor.type === "element" ? L.childNodes[z] || null : 0 < N.rangeCount ? N.getRangeAt(0) : null;
                    if (Se !== null) {
                      let Ae = Se.getBoundingClientRect(), Ze = n.ownerDocument, Ge = Ze.defaultView;
                      if (Ge !== null)
                        for (var { top: Q, bottom: X } = Ae, re, Z, ee = n; ee !== null; ) {
                          let rt = ee === Ze.body;
                          if (rt)
                            re = 0, Z = MC(e).innerHeight;
                          else {
                            let Xe = ee.getBoundingClientRect();
                            re = Xe.top, Z = Xe.bottom;
                          }
                          let qe = 0;
                          if (Q < re ? qe = -(re - Q) : X > Z && (qe = X - Z), qe !== 0)
                            if (rt)
                              Ge.scrollBy(0, qe);
                            else {
                              let Xe = ee.scrollTop;
                              ee.scrollTop += qe;
                              let lt = ee.scrollTop - Xe;
                              Q -= lt, X -= lt;
                            }
                          if (rt)
                            break;
                          ee = DC(ee);
                        }
                    }
                  }
                  VL = !0;
                }
              } else
                i !== null && mk(e, le, se) && N.removeAllRanges();
          }
        }
        e: {
          let ue = e._blockCursorElement;
          if (to(a) && a.isCollapsed() && a.anchor.type === "element" && n.contains(document.activeElement)) {
            let le = a.anchor, se = le.getNode(), me = le.offset, pe = se.getChildrenSize(), be = !1, Se = null;
            if (me === pe) {
              let Ae = se.getChildAtIndex(me - 1);
              C5(Ae) && (be = !0);
            } else {
              let Ae = se.getChildAtIndex(me);
              if (C5(Ae)) {
                let Ze = Ae.getPreviousSibling();
                (Ze === null || C5(Ze)) && (be = !0, Se = e.getElementByKey(Ae.__key));
              }
            }
            if (be) {
              let Ae = e.getElementByKey(se.__key);
              if (ue === null) {
                let Ze = e._config.theme, Ge = document.createElement("div");
                Ge.contentEditable = "false", Ge.setAttribute("data-lexical-cursor", "true");
                let rt = Ze.blockCursor;
                if (rt !== void 0) {
                  if (typeof rt == "string") {
                    let qe = rt.split(" ");
                    rt = Ze.blockCursor = qe;
                  }
                  rt !== void 0 && Ge.classList.add(...rt);
                }
                e._blockCursorElement = ue = Ge;
              }
              n.style.caretColor = "transparent", Se === null ? Ae.appendChild(ue) : Ae.insertBefore(ue, Se);
              break e;
            }
          }
          ue !== null && RL(ue, e, n);
        }
        _ !== null && _.observe(n, IX);
      } finally {
        ia = d, ra = c;
      }
    }
    if (p !== null) {
      var J = p;
      let ue = Array.from(e._listeners.mutation), le = ue.length;
      for (let se = 0; se < le; se++) {
        let [me, pe] = ue[se], be = J.get(pe);
        be !== void 0 && me(be, { dirtyLeaves: b, updateTags: k });
      }
    }
    to(a) || a === null || i !== null && i.is(a) || e.dispatchCommand(i8, void 0);
    var oe = e._pendingDecorators;
    oe !== null && (e._decorators = oe, e._pendingDecorators = null, J$("decorator", e, !0, oe));
    var ce = gX(r), de = gX(t);
    if (ce !== de && J$("textcontent", e, !0, de), J$("update", e, !0, { dirtyElements: v, dirtyLeaves: b, editorState: t, normalizedNodes: $, prevEditorState: r, tags: k }), e._deferred = [], S.length !== 0) {
      let ue = e._updating;
      e._updating = !0;
      try {
        for (let le = 0; le < S.length; le++)
          S[le]();
      } finally {
        e._updating = ue;
      }
    }
    var te = e._updates;
    if (te.length !== 0) {
      let ue = te.shift();
      if (ue) {
        let [le, se] = ue;
        f$e(e, le, se);
      }
    }
  }
}
function J$(e, t, n, ...o) {
  let r = t._updating;
  t._updating = n;
  try {
    let i = Array.from(t._listeners[e]);
    for (e = 0; e < i.length; e++)
      i[e].apply(null, o);
  } finally {
    t._updating = r;
  }
}
function Qt(e, t, n) {
  if (e._updating === !1 || ia !== e) {
    let i = !1;
    return e.update(() => {
      i = Qt(e, t, n);
    }), i;
  }
  let o = g8(e);
  for (let i = 4; 0 <= i; i--)
    for (let a = 0; a < o.length; a++) {
      var r = o[a]._commands.get(t);
      if (r !== void 0 && (r = r[i], r !== void 0)) {
        r = Array.from(r);
        let s = r.length;
        for (let c = 0; c < s; c++)
          if (r[c](n, e) === !0)
            return !0;
      }
    }
  return !1;
}
function DX(e, t) {
  let n = e._updates;
  for (t = t || !1; n.length !== 0; ) {
    var o = n.shift();
    if (o) {
      let [r, i] = o, a;
      i !== void 0 && (o = i.onUpdate, a = i.tag, i.skipTransforms && (t = !0), o && e._deferred.push(o), a && e._updateTags.add(a)), r();
    }
  }
  return t;
}
function f$e(e, t, n) {
  let o = e._updateTags;
  var r, i = r = !1;
  if (n !== void 0) {
    var a = n.onUpdate;
    r = n.tag, r != null && o.add(r), r = n.skipTransforms || !1, i = n.discrete || !1;
  }
  a && e._deferred.push(a), n = e._editorState, a = e._pendingEditorState;
  let s = !1;
  (a === null || a._readOnly) && (a = e._pendingEditorState = new VC(new Map((a || n)._nodeMap)), s = !0), a._flushSync = i, i = ra;
  let c = oc, l = ia, d = e._updating;
  ra = a, oc = !1, e._updating = !0, ia = e;
  try {
    s && (e._headless ? n._selection != null && (a._selection = n._selection.clone()) : a._selection = eed(e));
    let u = e._compositionKey;
    t(), r = DX(e, r), ted(a, e), e._dirtyType !== 0 && (r ? ned(a, e) : oed(a, e), DX(e), UXl(n, a, e._dirtyLeaves, e._dirtyElements)), u !== e._compositionKey && (a._flushSync = !0);
    let _ = a._selection;
    if (to(_)) {
      let p = a._nodeMap, f = _.focus.key;
      p.get(_.anchor.key) !== void 0 && p.get(f) !== void 0 || Yt(19);
    } else
      hk(_) && _._nodes.size === 0 && (a._selection = null);
  } catch (u) {
    u instanceof Error && e._onError(u), e._pendingEditorState = n, e._dirtyType = 2, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), Pf(e);
    return;
  } finally {
    ra = i, oc = c, ia = l, e._updating = d, a0 = 0;
  }
  e._dirtyType !== 0 || red(a, e) ? a._flushSync ? (a._flushSync = !1, Pf(e)) : s && qXl(() => {
    Pf(e);
  }) : (a._flushSync = !1, s && (o.clear(), e._deferred = [], e._pendingEditorState = null));
}
function qc(e, t, n) {
  e._updating ? e._updates.push([t, n]) : f$e(e, t, n);
}
class g$e extends gk {
  constructor(t) {
    super(t);
  }
  decorate() {
    Yt(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
}
function Hr(e) {
  return e instanceof g$e;
}
class bg extends gk {
  constructor(t) {
    super(t), this.__last = this.__first = null, this.__indent = this.__format = this.__size = 0, this.__dir = null;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    let t = this.getFormat();
    return IXl[t] || "";
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    let t = [], n = this.getFirstChild();
    for (; n !== null; )
      t.push(n), n = n.getNextSibling();
    return t;
  }
  getChildrenKeys() {
    let t = [], n = this.getFirstChild();
    for (; n !== null; )
      t.push(n.__key), n = n.getNextSibling();
    return t;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    let t = xi()._dirtyElements;
    return t !== null && t.has(this.__key);
  }
  isLastChild() {
    let t = this.getLatest(), n = this.getParentOrThrow().getLastChild();
    return n !== null && n.is(t);
  }
  getAllTextNodes() {
    let t = [], n = this.getFirstChild();
    for (; n !== null; ) {
      if (Xt(n) && t.push(n), kt(n)) {
        let o = n.getAllTextNodes();
        t.push(...o);
      }
      n = n.getNextSibling();
    }
    return t;
  }
  getFirstDescendant() {
    let t = this.getFirstChild();
    for (; t !== null; ) {
      if (kt(t)) {
        let n = t.getFirstChild();
        if (n !== null) {
          t = n;
          continue;
        }
      }
      break;
    }
    return t;
  }
  getLastDescendant() {
    let t = this.getLastChild();
    for (; t !== null; ) {
      if (kt(t)) {
        let n = t.getLastChild();
        if (n !== null) {
          t = n;
          continue;
        }
      }
      break;
    }
    return t;
  }
  getDescendantByIndex(t) {
    let n = this.getChildren(), o = n.length;
    return t >= o ? (t = n[o - 1], kt(t) && t.getLastDescendant() || t || null) : (t = n[t], kt(t) && t.getFirstDescendant() || t || null);
  }
  getFirstChild() {
    let t = this.getLatest().__first;
    return t === null ? null : oa(t);
  }
  getFirstChildOrThrow() {
    let t = this.getFirstChild();
    return t === null && Yt(45), t;
  }
  getLastChild() {
    let t = this.getLatest().__last;
    return t === null ? null : oa(t);
  }
  getLastChildOrThrow() {
    let t = this.getLastChild();
    return t === null && Yt(96), t;
  }
  getChildAtIndex(t) {
    var n = this.getChildrenSize();
    let o;
    if (t < n / 2) {
      for (o = this.getFirstChild(), n = 0; o !== null && n <= t; ) {
        if (n === t)
          return o;
        o = o.getNextSibling(), n++;
      }
      return null;
    }
    for (o = this.getLastChild(), --n; o !== null && n >= t; ) {
      if (n === t)
        return o;
      o = o.getPreviousSibling(), n--;
    }
    return null;
  }
  getTextContent() {
    let t = "", n = this.getChildren(), o = n.length;
    for (let r = 0; r < o; r++) {
      let i = n[r];
      t += i.getTextContent(), kt(i) && r !== o - 1 && !i.isInline() && (t += `

`);
    }
    return t;
  }
  getTextContentSize() {
    let t = 0, n = this.getChildren(), o = n.length;
    for (let r = 0; r < o; r++) {
      let i = n[r];
      t += i.getTextContentSize(), kt(i) && r !== o - 1 && !i.isInline() && (t += 2);
    }
    return t;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(t) {
    return t !== "" ? (t = fX[t], (this.getFormat() & t) !== 0) : !1;
  }
  select(t, n) {
    xs();
    let o = Kr(), r = t, i = n;
    var a = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (t === 0 && n === 0) {
        if (t = this.getFirstChild(), Xt(t) || kt(t))
          return t.select(0, 0);
      } else if (!(t !== void 0 && t !== a || n !== void 0 && n !== a) && (t = this.getLastChild(), Xt(t) || kt(t)))
        return t.select();
    }
    if (r === void 0 && (r = a), i === void 0 && (i = a), a = this.__key, to(o))
      o.anchor.set(a, r, "element"), o.focus.set(a, i, "element"), o.dirty = !0;
    else
      return _$e(a, r, a, i, "element", "element");
    return o;
  }
  selectStart() {
    let t = this.getFirstDescendant();
    return kt(t) || Xt(t) ? t.select(0, 0) : t !== null ? t.selectPrevious() : this.select(0, 0);
  }
  selectEnd() {
    let t = this.getLastDescendant();
    return kt(t) || Xt(t) ? t.select() : t !== null ? t.selectNext() : this.select();
  }
  clear() {
    let t = this.getWritable();
    return this.getChildren().forEach((n) => n.remove()), t;
  }
  append(...t) {
    return this.splice(
      this.getChildrenSize(),
      0,
      t
    );
  }
  setDirection(t) {
    let n = this.getWritable();
    return n.__dir = t, n;
  }
  setFormat(t) {
    return this.getWritable().__format = t !== "" ? fX[t] : 0, this;
  }
  setIndent(t) {
    return this.getWritable().__indent = t, this;
  }
  splice(t, n, o) {
    let r = o.length, i = this.getChildrenSize(), a = this.getWritable(), s = a.__key;
    var c = [], l = [];
    let d = this.getChildAtIndex(t + n), u = null, _ = i - n + r;
    if (t !== 0)
      if (t === i)
        u = this.getLastChild();
      else {
        var p = this.getChildAtIndex(t);
        p !== null && (u = p.getPreviousSibling());
      }
    if (0 < n) {
      var f = u === null ? this.getFirstChild() : u.getNextSibling();
      for (p = 0; p < n; p++) {
        f === null && Yt(100);
        var g = f.getNextSibling(), h = f.__key;
        f = f.getWritable(), Of(f), l.push(h), f = g;
      }
    }
    for (p = u, g = 0; g < r; g++) {
      h = o[g], p !== null && h.is(p) && (u = p = p.getPreviousSibling()), f = h.getWritable(), f.__parent === s && _--, Of(f);
      let b = h.__key;
      p === null ? (a.__first = b, f.__prev = null) : (p = p.getWritable(), p.__next = b, f.__prev = p.__key), h.__key === s && Yt(76), f.__parent = s, c.push(b), p = h;
    }
    if (t + n === i ? p !== null && (p.getWritable().__next = null, a.__last = p.__key) : d !== null && (t = d.getWritable(), p !== null ? (n = p.getWritable(), t.__prev = p.__key, n.__next = d.__key) : t.__prev = null), a.__size = _, l.length && (t = Kr(), to(t))) {
      l = new Set(l), c = new Set(c);
      let { anchor: b, focus: v } = t;
      MX(b, l, c) && pT(b, b.getNode(), this, u, d), MX(v, l, c) && pT(v, v.getNode(), this, u, d), _ !== 0 || this.canBeEmpty() || Xl(this) || this.remove();
    }
    return a;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter() {
    return null;
  }
  canInsertTab() {
    return !1;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart() {
    return !1;
  }
  excludeFromCopy() {
    return !1;
  }
  canExtractContents() {
    return !0;
  }
  canReplaceWith() {
    return !0;
  }
  canInsertAfter() {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith() {
    return !1;
  }
  extractWithChild() {
    return !1;
  }
}
function kt(e) {
  return e instanceof bg;
}
function MX(e, t, n) {
  for (e = e.getNode(); e; ) {
    let o = e.__key;
    if (t.has(o) && !n.has(o))
      return !0;
    e = e.getParent();
  }
  return !1;
}
class kb extends bg {
  static getType() {
    return "root";
  }
  static clone() {
    return new kb();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    Yt(51);
  }
  getTextContent() {
    let t = this.__cachedText;
    return !wb() && xi()._dirtyType !== 0 || t === null ? super.getTextContent() : t;
  }
  remove() {
    Yt(52);
  }
  replace() {
    Yt(53);
  }
  insertBefore() {
    Yt(54);
  }
  insertAfter() {
    Yt(55);
  }
  updateDOM() {
    return !1;
  }
  append(...t) {
    for (let n = 0; n < t.length; n++) {
      let o = t[n];
      kt(o) || Hr(o) || Yt(56);
    }
    return super.append(...t);
  }
  static importJSON(t) {
    let n = M_();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
}
function ec(e) {
  return e instanceof kb;
}
function red(e, t) {
  if (t = t.getEditorState()._selection, e = e._selection, e !== null) {
    if (e.dirty || !e.is(t))
      return !0;
  } else if (t !== null)
    return !0;
  return !1;
}
function k8() {
  return new VC(/* @__PURE__ */ new Map([["root", new kb()]]));
}
function h$e(e) {
  let t = e.exportJSON();
  t.type !== e.constructor.getType() && Yt(58);
  let n = t.children;
  if (kt(e)) {
    Array.isArray(n) || Yt(59), e = e.getChildren();
    for (let o = 0; o < e.length; o++) {
      let r = h$e(e[o]);
      n.push(r);
    }
  }
  return t;
}
class VC {
  constructor(t, n) {
    this._nodeMap = t, this._selection = n || null, this._readOnly = this._flushSync = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(t) {
    return NX(this, t);
  }
  clone(t) {
    return t = new VC(this._nodeMap, t === void 0 ? this._selection : t), t._readOnly = !0, t;
  }
  toJSON() {
    return NX(this, () => ({ root: h$e(M_()) }));
  }
}
class Sb extends gk {
  static getType() {
    return "linebreak";
  }
  static clone(t) {
    return new Sb(t.__key);
  }
  constructor(t) {
    super(t);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (t) => {
      let n = t.parentElement;
      return n != null && n.firstChild === t && n.lastChild === t ? null : { conversion: ied, priority: 0 };
    } };
  }
  static importJSON() {
    return Bv();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
}
function ied() {
  return { node: Bv() };
}
function Bv() {
  return LC(new Sb());
}
function s0(e) {
  return e instanceof Sb;
}
function I5(e, t) {
  return t & 16 ? "code" : t & 128 ? "mark" : t & 32 ? "sub" : t & 64 ? "sup" : null;
}
function R5(e, t) {
  return t & 1 ? "strong" : t & 2 ? "em" : "span";
}
function N5(e, t, n, o, r) {
  e = o.classList, o = Y$(r, "base"), o !== void 0 && e.add(...o), o = Y$(r, "underlineStrikethrough");
  let i = !1, a = t & 8 && t & 4;
  var s = n & 8 && n & 4;
  o !== void 0 && (s ? (i = !0, a || e.add(...o)) : a && e.remove(...o));
  for (let c in zf)
    s = zf[c], o = Y$(r, c), o !== void 0 && (n & s ? !i || c !== "underline" && c !== "strikethrough" ? (!(t & s) || a && c === "underline" || c === "strikethrough") && e.add(...o) : t & s && e.remove(...o) : t & s && e.remove(...o));
}
function D5(e, t, n) {
  let o = t.firstChild;
  if (n = n.isComposing(), e += n ? NC : "", o == null)
    t.textContent = e;
  else if (t = o.nodeValue, t !== e)
    if (n || Qf) {
      n = t.length;
      let r = e.length, i = 0, a = 0;
      for (; i < n && i < r && t[i] === e[i]; )
        i++;
      for (; a + i < n && a + i < r && t[n - a - 1] === e[r - a - 1]; )
        a++;
      e = [i, n - i - a, e.slice(i, r - a)];
      let [s, c, l] = e;
      c !== 0 && o.deleteData(s, c), o.insertData(s, l);
    } else
      o.nodeValue = e;
}
function oS(e, t) {
  return t = document.createElement(t), t.appendChild(e), t;
}
class xb extends gk {
  static getType() {
    return "text";
  }
  static clone(t) {
    return new xb(t.__text, t.__key);
  }
  constructor(t, n) {
    super(n), this.__text = t, this.__format = 0, this.__style = "", this.__detail = this.__mode = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    let t = this.getLatest();
    return NXl[t.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === Pp();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return (this.getLatest().__detail & 1) !== 0;
  }
  isUnmergeable() {
    return (this.getLatest().__detail & 2) !== 0;
  }
  hasFormat(t) {
    return t = zf[t], (this.getFormat() & t) !== 0;
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(t, n) {
    let o = this.getLatest().__format;
    return Mye(o, t, n);
  }
  createDOM(t) {
    var n = this.__format, o = I5(this, n);
    let r = R5(this, n), i = document.createElement(o === null ? r : o), a = i;
    return o !== null && (a = document.createElement(r), i.appendChild(a)), o = a, D5(this.__text, o, this), t = t.theme.text, t !== void 0 && N5(r, 0, n, o, t), n = this.__style, n !== "" && (i.style.cssText = n), i;
  }
  updateDOM(t, n, o) {
    let r = this.__text;
    var i = t.__format, a = this.__format, s = I5(this, i);
    let c = I5(this, a);
    var l = R5(this, i);
    let d = R5(this, a);
    return (s === null ? l : s) !== (c === null ? d : c) ? !0 : s === c && l !== d ? (i = n.firstChild, i == null && Yt(48), t = s = document.createElement(d), D5(r, t, this), o = o.theme.text, o !== void 0 && N5(d, 0, a, t, o), n.replaceChild(s, i), !1) : (l = n, c !== null && s !== null && (l = n.firstChild, l == null && Yt(49)), D5(r, l, this), o = o.theme.text, o !== void 0 && i !== a && N5(d, i, a, l, o), a = this.__style, t.__style !== a && (n.style.cssText = a), !1);
  }
  static importDOM() {
    return { "#text": () => ({ conversion: led, priority: 0 }), b: () => ({ conversion: ced, priority: 0 }), br: () => ({ conversion: sed, priority: 0 }), code: () => ({ conversion: sp, priority: 0 }), em: () => ({ conversion: sp, priority: 0 }), i: () => ({ conversion: sp, priority: 0 }), s: () => ({ conversion: sp, priority: 0 }), span: () => ({ conversion: aed, priority: 0 }), strong: () => ({ conversion: sp, priority: 0 }), sub: () => ({ conversion: sp, priority: 0 }), sup: () => ({
      conversion: sp,
      priority: 0
    }), u: () => ({ conversion: sp, priority: 0 }) };
  }
  static importJSON(t) {
    let n = wa(t.text);
    return n.setFormat(t.format), n.setDetail(t.detail), n.setMode(t.mode), n.setStyle(t.style), n;
  }
  exportDOM(t) {
    return { element: t } = super.exportDOM(t), t !== null && (this.hasFormat("bold") && (t = oS(t, "b")), this.hasFormat("italic") && (t = oS(t, "i")), this.hasFormat("strikethrough") && (t = oS(t, "s")), this.hasFormat("underline") && (t = oS(t, "u"))), { element: t };
  }
  exportJSON() {
    return {
      detail: this.getDetail(),
      format: this.getFormat(),
      mode: this.getMode(),
      style: this.getStyle(),
      text: this.getTextContent(),
      type: "text",
      version: 1
    };
  }
  selectionTransform() {
  }
  setFormat(t) {
    let n = this.getWritable();
    return n.__format = typeof t == "string" ? zf[t] : t, n;
  }
  setDetail(t) {
    let n = this.getWritable();
    return n.__detail = typeof t == "string" ? PXl[t] : t, n;
  }
  setStyle(t) {
    let n = this.getWritable();
    return n.__style = t, n;
  }
  toggleFormat(t) {
    return t = zf[t], this.setFormat(this.getFormat() ^ t);
  }
  toggleDirectionless() {
    let t = this.getWritable();
    return t.__detail ^= 1, t;
  }
  toggleUnmergeable() {
    let t = this.getWritable();
    return t.__detail ^= 2, t;
  }
  setMode(t) {
    if (t = RXl[t], this.__mode === t)
      return this;
    let n = this.getWritable();
    return n.__mode = t, n;
  }
  setTextContent(t) {
    if (this.__text === t)
      return this;
    let n = this.getWritable();
    return n.__text = t, n;
  }
  select(t, n) {
    xs();
    let o = Kr();
    var r = this.getTextContent();
    let i = this.__key;
    if (typeof r == "string" ? (r = r.length, t === void 0 && (t = r), n === void 0 && (n = r)) : n = t = 0, to(o))
      r = Pp(), r !== o.anchor.key && r !== o.focus.key || Sa(i), o.setTextNodeRange(this, t, this, n);
    else
      return _$e(i, t, i, n, "text", "text");
    return o;
  }
  spliceText(t, n, o, r) {
    let i = this.getWritable(), a = i.__text, s = o.length, c = t;
    0 > c && (c = s + c, 0 > c && (c = 0));
    let l = Kr();
    return r && to(l) && (t += s, l.setTextNodeRange(i, t, i, t)), n = a.slice(0, c) + o + a.slice(c + n), i.__text = n, i;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  canContainTabs() {
    return !1;
  }
  splitText(...t) {
    xs();
    var n = this.getLatest(), o = n.getTextContent(), r = n.__key, i = Pp(), a = new Set(t);
    t = [];
    for (var s = o.length, c = "", l = 0; l < s; l++)
      c !== "" && a.has(l) && (t.push(c), c = ""), c += o[l];
    if (c !== "" && t.push(c), a = t.length, a === 0)
      return [];
    if (t[0] === o)
      return [n];
    var d = t[0];
    o = n.getParentOrThrow(), l = n.getFormat();
    let u = n.getStyle(), _ = n.__detail;
    s = !1, n.isSegmented() ? (c = wa(d), c.__format = l, c.__style = u, c.__detail = _, s = !0) : (c = n.getWritable(), c.__text = d), n = Kr(), c = [c], d = d.length;
    for (let g = 1; g < a; g++) {
      var p = t[g], f = p.length;
      p = wa(p).getWritable(), p.__format = l, p.__style = u, p.__detail = _;
      let h = p.__key;
      if (f = d + f, to(n)) {
        let b = n.anchor, v = n.focus;
        b.key === r && b.type === "text" && b.offset > d && b.offset <= f && (b.key = h, b.offset -= d, n.dirty = !0), v.key === r && v.type === "text" && v.offset > d && v.offset <= f && (v.key = h, v.offset -= d, n.dirty = !0);
      }
      i === r && Sa(h), d = f, c.push(p);
    }
    return r = this.getPreviousSibling(), i = this.getNextSibling(), r !== null && aT(r), i !== null && aT(i), r = o.getWritable(), i = this.getIndexWithinParent(), s ? (r.splice(i, 0, c), this.remove()) : r.splice(i, 1, c), to(n) && _T(n, o, i, a - 1), c;
  }
  mergeWithSibling(t) {
    var n = t === this.getPreviousSibling();
    n || t === this.getNextSibling() || Yt(50);
    var o = this.__key;
    let r = t.__key, i = this.__text, a = i.length;
    Pp() === r && Sa(o);
    let s = Kr();
    if (to(s)) {
      let c = s.anchor, l = s.focus;
      c !== null && c.key === r && (PX(c, n, o, t, a), s.dirty = !0), l !== null && l.key === r && (PX(l, n, o, t, a), s.dirty = !0);
    }
    return o = t.__text, this.setTextContent(n ? o + i : i + o), n = this.getWritable(), t.remove(), n;
  }
  isTextEntity() {
    return !1;
  }
}
function aed(e) {
  let t = e.style.fontWeight === "700", n = e.style.textDecoration === "line-through", o = e.style.fontStyle === "italic", r = e.style.textDecoration === "underline", i = e.style.verticalAlign;
  return { forChild: (a) => (Xt(a) && (t && a.toggleFormat("bold"), n && a.toggleFormat("strikethrough"), o && a.toggleFormat("italic"), r && a.toggleFormat("underline"), i === "sub" && a.toggleFormat("subscript"), i === "super" && a.toggleFormat("superscript")), a), node: null };
}
function sed() {
  return { node: Bv() };
}
function ced(e) {
  let t = e.style.fontWeight === "normal";
  return { forChild: (n) => (Xt(n) && !t && n.toggleFormat("bold"), n), node: null };
}
function led(e, t, n) {
  return e = e.textContent || "", !n && /\n/.test(e) && (e = e.replace(/\r?\n/gm, " "), e.trim().length === 0) ? { node: null } : { node: wa(e) };
}
let ded = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function sp(e) {
  let t = ded[e.nodeName.toLowerCase()];
  return t === void 0 ? { node: null } : { forChild: (n) => (Xt(n) && !n.hasFormat(t) && n.toggleFormat(t), n), node: null };
}
function wa(e = "") {
  return LC(new xb(e));
}
function Xt(e) {
  return e instanceof xb;
}
class Eb extends bg {
  static getType() {
    return "paragraph";
  }
  static clone(t) {
    return new Eb(t.__key);
  }
  createDOM(t) {
    let n = document.createElement("p");
    return t = Y$(t.theme, "paragraph"), t !== void 0 && n.classList.add(...t), n;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { p: () => ({ conversion: ued, priority: 0 }) };
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t && this.isEmpty() && t.append(document.createElement("br")), t) {
      var n = this.getFormatType();
      t.style.textAlign = n, (n = this.getDirection()) && (t.dir = n), n = this.getIndent(), 0 < n && (t.style.textIndent = `${20 * n}px`);
    }
    return { element: t };
  }
  static importJSON(t) {
    let n = Xf();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "paragraph", version: 1 };
  }
  insertNewAfter(t, n) {
    t = Xf();
    let o = this.getDirection();
    return t.setDirection(o), this.insertAfter(t, n), t;
  }
  collapseAtStart() {
    let t = this.getChildren();
    if (t.length === 0 || Xt(t[0]) && t[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null)
        return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null)
        return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function ued(e) {
  let t = Xf();
  return e.style && (t.setFormat(e.style.textAlign), e = parseInt(e.style.textIndent, 10) / 20, 0 < e && t.setIndent(e)), { node: t };
}
function Xf() {
  return LC(new Eb());
}
function v$e(e, t, n, o) {
  let r = e._keyToDOMMap;
  r.clear(), e._editorState = k8(), e._pendingEditorState = o, e._compositionKey = null, e._dirtyType = 0, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set(), e._updates = [], e._blockCursorElement = null, o = e._observer, o !== null && (o.disconnect(), e._observer = null), t !== null && (t.textContent = ""), n !== null && (n.textContent = "", r.set("root", n));
}
function _ed(e) {
  let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
  return e.forEach((o) => {
    if (o = o.klass.importDOM != null ? o.klass.importDOM.bind(o.klass) : null, o != null && !n.has(o)) {
      n.add(o);
      var r = o();
      r !== null && Object.keys(r).forEach((i) => {
        let a = t.get(i);
        a === void 0 && (a = [], t.set(i, a)), a.push(r[i]);
      });
    }
  }), t;
}
class ped {
  constructor(t, n, o, r, i, a) {
    this._parentEditor = n, this._rootElement = null, this._editorState = t, this._compositionKey = this._pendingEditorState = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = r, this._nodes = o, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = Bye(), this._onError = i, this._htmlConversions = a, this._editable = !0, this._headless = n !== null && n._headless, this._blockCursorElement = this._window = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(t) {
    let n = this._listeners.update;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerEditableListener(t) {
    let n = this._listeners.editable;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerDecoratorListener(t) {
    let n = this._listeners.decorator;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerTextContentListener(t) {
    let n = this._listeners.textcontent;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerRootListener(t) {
    let n = this._listeners.root;
    return t(this._rootElement, null), n.add(t), () => {
      t(null, this._rootElement), n.delete(t);
    };
  }
  registerCommand(t, n, o) {
    o === void 0 && Yt(35);
    let r = this._commands;
    r.has(t) || r.set(t, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    let i = r.get(t);
    i === void 0 && Yt(36);
    let a = i[o];
    return a.add(n), () => {
      a.delete(n), i.every((s) => s.size === 0) && r.delete(t);
    };
  }
  registerMutationListener(t, n) {
    this._nodes.get(t.getType()) === void 0 && Yt(37);
    let o = this._listeners.mutation;
    return o.set(n, t), () => {
      o.delete(n);
    };
  }
  registerNodeTransformToKlass(t, n) {
    return t = t.getType(), t = this._nodes.get(t), t === void 0 && Yt(37), t.transforms.add(n), t;
  }
  registerNodeTransform(t, n) {
    var o = this.registerNodeTransformToKlass(t, n);
    let r = [o];
    return o = o.replaceWithKlass, o != null && (o = this.registerNodeTransformToKlass(o, n), r.push(o)), jXl(this, t.getType()), () => {
      r.forEach((i) => i.transforms.delete(n));
    };
  }
  hasNodes(t) {
    for (let n = 0; n < t.length; n++) {
      let o = t[n].getType();
      if (!this._nodes.has(o))
        return !1;
    }
    return !0;
  }
  dispatchCommand(t, n) {
    return Qt(this, t, n);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(t) {
    let n = this._rootElement;
    if (t !== n) {
      let i = Y$(this._config.theme, "root");
      var o = this._pendingEditorState || this._editorState;
      if (this._rootElement = t, v$e(this, n, t, o), n !== null) {
        if (!this._config.disableEvents) {
          if (Z$ !== 0 && (Z$--, Z$ === 0 && n.ownerDocument.removeEventListener(
            "selectionchange",
            l$e
          )), o = n.__lexicalEditor, o != null) {
            if (o._parentEditor !== null) {
              var r = g8(o);
              r = r[r.length - 1]._key, Zh.get(r) === o && Zh.delete(r);
            } else
              Zh.delete(o._key);
            n.__lexicalEditor = null;
          }
          for (o = c$e(n), r = 0; r < o.length; r++)
            o[r]();
          n.__lexicalEventHandles = [];
        }
        i != null && n.classList.remove(...i);
      }
      t !== null ? (o = (o = t.ownerDocument) && o.defaultView || null, r = t.style, r.userSelect = "text", r.whiteSpace = "pre-wrap", r.wordBreak = "break-word", t.setAttribute("data-lexical-editor", "true"), this._window = o, this._dirtyType = 2, Nye(this), this._updateTags.add("history-merge"), Pf(this), this._config.disableEvents || XXl(t, this), i != null && t.classList.add(...i)) : this._window = null, J$("root", this, !1, t, n);
    }
  }
  getElementByKey(t) {
    return this._keyToDOMMap.get(t) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(t, n) {
    t.isEmpty() && Yt(38), Rye(this);
    let o = this._pendingEditorState, r = this._updateTags;
    n = n !== void 0 ? n.tag : null, o === null || o.isEmpty() || (n != null && r.add(n), Pf(this)), this._pendingEditorState = t, this._dirtyType = 2, this._dirtyElements.set(
      "root",
      !1
    ), this._compositionKey = null, n != null && r.add(n), Pf(this);
  }
  parseEditorState(t, n) {
    t = typeof t == "string" ? JSON.parse(t) : t;
    let o = k8(), r = ra, i = oc, a = ia, s = this._dirtyElements, c = this._dirtyLeaves, l = this._cloneNotNeeded, d = this._dirtyType;
    this._dirtyElements = /* @__PURE__ */ new Map(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyType = 0, ra = o, oc = !1, ia = this;
    try {
      w8(t.root, this._nodes), n && n(), o._readOnly = !0;
    } catch (u) {
      u instanceof Error && this._onError(u);
    } finally {
      this._dirtyElements = s, this._dirtyLeaves = c, this._cloneNotNeeded = l, this._dirtyType = d, ra = r, oc = i, ia = a;
    }
    return o;
  }
  update(t, n) {
    qc(this, t, n);
  }
  focus(t, n = {}) {
    let o = this._rootElement;
    o !== null && (o.setAttribute("autocapitalize", "off"), qc(this, () => {
      let r = Kr(), i = M_();
      r !== null ? r.dirty = !0 : i.getChildrenSize() !== 0 && (n.defaultSelection === "rootStart" ? i.selectStart() : i.selectEnd());
    }, { onUpdate: () => {
      o.removeAttribute("autocapitalize"), t && t();
    }, tag: "focus" }), this._pendingEditorState === null && o.removeAttribute("autocapitalize"));
  }
  blur() {
    var t = this._rootElement;
    t !== null && t.blur(), t = bu(this._window), t !== null && t.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(t) {
    this._editable !== t && (this._editable = t, J$("editable", this, !0, t));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
class S8 extends bg {
  constructor(t, n) {
    super(n), this.__colSpan = t, this.__rowSpan = 1;
  }
  exportJSON() {
    return { ...super.exportJSON(), colSpan: this.__colSpan };
  }
  setColSpan(t) {
    return this.getWritable().__colSpan = t, this;
  }
  setRowSpan(t) {
    return this.getWritable().__rowSpan = t, this;
  }
}
function tu(e) {
  return e instanceof S8;
}
class b$e extends bg {
}
function x8(e) {
  return e instanceof b$e;
}
class y$e extends bg {
}
function c0(e) {
  return e instanceof y$e;
}
vt.$addUpdateTag = function(e) {
  xs(), xi()._updateTags.add(e);
};
vt.$applyNodeReplacement = LC;
vt.$copyNode = Gye;
vt.$createLineBreakNode = Bv;
vt.$createNodeSelection = GL;
vt.$createParagraphNode = Xf;
vt.$createRangeSelection = function() {
  let e = new du("root", 0, "element"), t = new du("root", 0, "element");
  return new vg(e, t, 0, "");
};
vt.$createTextNode = wa;
vt.$getAdjacentNode = IL;
vt.$getNearestNodeFromDOMNode = fk;
vt.$getNearestRootOrShadowRoot = Wye;
vt.$getNodeByKey = oa;
vt.$getPreviousSelection = vk;
vt.$getRoot = M_;
vt.$getSelection = Kr;
vt.$getTextContent = function() {
  let e = Kr();
  return e === null ? "" : e.getTextContent();
};
vt.$hasAncestor = lT;
vt.$insertNodes = function(e, t) {
  let n = Kr();
  return n === null && (n = M_().selectEnd()), n.insertNodes(e, t);
};
vt.$isDecoratorNode = Hr;
vt.$isElementNode = kt;
vt.$isInlineElementOrDecoratorNode = function(e) {
  return kt(e) && e.isInline() || Hr(e) && e.isInline();
};
vt.$isLeafNode = Lye;
vt.$isLineBreakNode = s0;
vt.$isNodeSelection = hk;
vt.$isParagraphNode = function(e) {
  return e instanceof Eb;
};
vt.$isRangeSelection = to;
vt.$isRootNode = ec;
vt.$isRootOrShadowRoot = Xl;
vt.$isTextNode = Xt;
vt.$nodesOfType = function(e) {
  var t = yu();
  let n = t._readOnly, o = e.getType();
  t = t._nodeMap;
  let r = [];
  for (let [, i] of t)
    i instanceof e && i.__type === o && (n || i.isAttached()) && r.push(i);
  return r;
};
vt.$normalizeSelection__EXPERIMENTAL = Zye;
vt.$parseSerializedNode = function(e) {
  return w8(e, xi()._nodes);
};
vt.$setCompositionKey = Sa;
vt.$setSelection = om;
vt.$splitNode = Hye;
vt.BLUR_COMMAND = Oye;
vt.CAN_REDO_COMMAND = {};
vt.CAN_UNDO_COMMAND = {};
vt.CLEAR_EDITOR_COMMAND = {};
vt.CLEAR_HISTORY_COMMAND = {};
vt.CLICK_COMMAND = pye;
vt.COMMAND_PRIORITY_CRITICAL = 4;
vt.COMMAND_PRIORITY_EDITOR = 0;
vt.COMMAND_PRIORITY_HIGH = 3;
vt.COMMAND_PRIORITY_LOW = 1;
vt.COMMAND_PRIORITY_NORMAL = 2;
vt.CONTROLLED_TEXT_INSERTION_COMMAND = Yh;
vt.COPY_COMMAND = l8;
vt.CUT_COMMAND = d8;
vt.DELETE_CHARACTER_COMMAND = e0;
vt.DELETE_LINE_COMMAND = n0;
vt.DELETE_WORD_COMMAND = t0;
vt.DEPRECATED_$computeGridMap = m$e;
vt.DEPRECATED_$createGridSelection = function() {
  let e = new du("root", 0, "element"), t = new du("root", 0, "element");
  return new FC("root", e, t);
};
vt.DEPRECATED_$getNodeTriplet = function(e) {
  if (!(e instanceof S8)) {
    if (e instanceof gk) {
      if (e = dT(e, tu), !tu(e))
        throw Error("Expected to find a parent GridCellNode");
    } else if (e = dT(e.getNode(), tu), !tu(e))
      throw Error("Expected to find a parent GridCellNode");
  }
  let t = e.getParent();
  if (!c0(t))
    throw Error("Expected GridCellNode to have a parent GridRowNode");
  let n = t.getParent();
  if (!x8(n))
    throw Error("Expected GridRowNode to have a parent GridNode");
  return [e, t, n];
};
vt.DEPRECATED_$isGridCellNode = tu;
vt.DEPRECATED_$isGridNode = x8;
vt.DEPRECATED_$isGridRowNode = c0;
vt.DEPRECATED_$isGridSelection = $8;
vt.DEPRECATED_GridCellNode = S8;
vt.DEPRECATED_GridNode = b$e;
vt.DEPRECATED_GridRowNode = y$e;
vt.DRAGEND_COMMAND = Cye;
vt.DRAGOVER_COMMAND = Aye;
vt.DRAGSTART_COMMAND = Tye;
vt.DROP_COMMAND = Eye;
vt.DecoratorNode = g$e;
vt.ElementNode = bg;
vt.FOCUS_COMMAND = zye;
vt.FORMAT_ELEMENT_COMMAND = {};
vt.FORMAT_TEXT_COMMAND = Op;
vt.INDENT_CONTENT_COMMAND = {};
vt.INSERT_LINE_BREAK_COMMAND = K$;
vt.INSERT_PARAGRAPH_COMMAND = CL;
vt.KEY_ARROW_DOWN_COMMAND = yye;
vt.KEY_ARROW_LEFT_COMMAND = hye;
vt.KEY_ARROW_RIGHT_COMMAND = fye;
vt.KEY_ARROW_UP_COMMAND = bye;
vt.KEY_BACKSPACE_COMMAND = wye;
vt.KEY_DELETE_COMMAND = Sye;
vt.KEY_DOWN_COMMAND = mye;
vt.KEY_ENTER_COMMAND = oT;
vt.KEY_ESCAPE_COMMAND = kye;
vt.KEY_MODIFIER_COMMAND = Pye;
vt.KEY_SPACE_COMMAND = $ye;
vt.KEY_TAB_COMMAND = xye;
vt.LineBreakNode = Sb;
vt.MOVE_TO_END = gye;
vt.MOVE_TO_START = vye;
vt.OUTDENT_CONTENT_COMMAND = {};
vt.PASTE_COMMAND = a8;
vt.ParagraphNode = Eb;
vt.REDO_COMMAND = c8;
vt.REMOVE_TEXT_COMMAND = zL;
vt.RootNode = kb;
vt.SELECTION_CHANGE_COMMAND = i8;
vt.TextNode = xb;
vt.UNDO_COMMAND = s8;
vt.createCommand = function() {
  return {};
};
vt.createEditor = function(e) {
  var t = e || {}, n = ia, o = t.theme || {};
  let r = e === void 0 ? n : t.parentEditor || null, i = t.disableEvents || !1, a = k8(), s = t.namespace || (r !== null ? r._config.namespace : Bye()), c = t.editorState, l = [kb, xb, Sb, Eb, ...t.nodes || []], d = t.onError;
  if (t = t.editable !== void 0 ? t.editable : !0, e === void 0 && n !== null)
    e = n._nodes;
  else
    for (e = /* @__PURE__ */ new Map(), n = 0; n < l.length; n++) {
      let _ = l[n], p = null;
      var u = null;
      typeof _ != "function" && (u = _, _ = u.replace, p = u.with, u = u.withKlass ? u.withKlass : null);
      let f = _.getType(), g = _.transform(), h = /* @__PURE__ */ new Set();
      g !== null && h.add(g), e.set(f, { klass: _, replace: p, replaceWithKlass: u, transforms: h });
    }
  return o = new ped(a, r, e, { disableEvents: i, namespace: s, theme: o }, d || console.error, _ed(e), t), c !== void 0 && (o._pendingEditorState = c, o._dirtyType = 2), o;
};
vt.getNearestEditorFromDOMNode = f8;
vt.isSelectionWithinEditor = mk;
const med = vt;
var yn = med, Tn = yn;
let mT = /* @__PURE__ */ new Map();
function LX(e) {
  for (; e != null; ) {
    if (e.nodeType === Node.TEXT_NODE)
      return e;
    e = e.firstChild;
  }
  return null;
}
function qX(e) {
  let t = e.parentNode;
  if (t == null)
    throw Error("Should never happen");
  return [t, Array.from(t.childNodes).indexOf(e)];
}
function $$e(e) {
  let t = {};
  e = e.split(";");
  for (let n of e)
    if (n !== "") {
      let [o, r] = n.split(/:([^]+)/);
      t[o.trim()] = r.trim();
    }
  return t;
}
function fT(e) {
  let t = mT.get(e);
  return t === void 0 && (t = $$e(e), mT.set(e, t)), t;
}
function fed(e) {
  let t = "";
  for (let n in e)
    n && (t += `${n}: ${e[n]};`);
  return t;
}
function ch(e, t) {
  var n = fT("getStyle" in e ? e.getStyle() : e.style);
  t = Object.entries(t).reduce((o, [r, i]) => (i === null ? delete o[r] : o[r] = i, o), { ...n }), n = fed(t), e.setStyle(n), mT.set(n, t);
}
function ged(e) {
  for (; e !== null && !Tn.$isRootOrShadowRoot(e); ) {
    let t = e.getLatest(), n = e.getParent();
    t.getChildrenSize() === 0 && e.remove(!0), e = n;
  }
}
function M5(e, t, n, o, r = null) {
  if (t.length !== 0) {
    var i = t[0], a = /* @__PURE__ */ new Map(), s = [];
    i = Tn.$isElementNode(i) ? i : i.getParentOrThrow(), i.isInline() && (i = i.getParentOrThrow());
    for (var c = !1; i !== null; ) {
      var l = i.getPreviousSibling();
      if (l !== null) {
        i = l, c = !0;
        break;
      }
      if (i = i.getParentOrThrow(), Tn.$isRootOrShadowRoot(i))
        break;
    }
    l = /* @__PURE__ */ new Set();
    for (var d = 0; d < n; d++) {
      var u = t[d];
      Tn.$isElementNode(u) && u.getChildrenSize() === 0 && l.add(u.getKey());
    }
    var _ = /* @__PURE__ */ new Set();
    for (d = 0; d < n; d++) {
      u = t[d];
      var p = u.getParent();
      if (p !== null && p.isInline() && (p = p.getParent()), p !== null && Tn.$isLeafNode(u) && !_.has(u.getKey())) {
        if (u = p.getKey(), a.get(u) === void 0) {
          let f = o();
          f.setFormat(p.getFormatType()), f.setIndent(p.getIndent()), s.push(f), a.set(u, f), p.getChildren().forEach((g) => {
            f.append(g), _.add(g.getKey()), Tn.$isElementNode(g) && g.getChildrenKeys().forEach((h) => _.add(h));
          }), ged(p);
        }
      } else
        l.has(u.getKey()) && (p = o(), p.setFormat(u.getFormatType()), p.setIndent(u.getIndent()), s.push(p), u.remove(!0));
    }
    if (r !== null)
      for (t = 0; t < s.length; t++)
        r.append(s[t]);
    if (t = null, Tn.$isRootOrShadowRoot(i))
      if (c)
        if (r !== null)
          i.insertAfter(r);
        else
          for (r = s.length - 1; 0 <= r; r--)
            i.insertAfter(s[r]);
      else if (c = i.getFirstChild(), Tn.$isElementNode(c) && (i = c), c === null)
        if (r)
          i.append(r);
        else
          for (r = 0; r < s.length; r++)
            c = s[r], i.append(c), t = c;
      else if (r !== null)
        c.insertBefore(r);
      else
        for (i = 0; i < s.length; i++)
          r = s[i], c.insertBefore(r), t = r;
    else if (r)
      i.insertAfter(r);
    else
      for (r = s.length - 1; 0 <= r; r--)
        c = s[r], i.insertAfter(c), t = c;
    s = Tn.$getPreviousSelection(), Tn.$isRangeSelection(s) && s.anchor.getNode().isAttached() && s.focus.getNode().isAttached() ? Tn.$setSelection(s.clone()) : t !== null ? t.selectEnd() : e.dirty = !0;
  }
}
function w$e(e, t, n, o) {
  e.modify(t ? "extend" : "move", n, o);
}
function k$e(e) {
  return e = e.anchor.getNode(), (Tn.$isRootNode(e) ? e : e.getParentOrThrow()).getDirection() === "rtl";
}
_a.$addNodeStyle = function(e) {
  e = e.getStyle();
  let t = $$e(e);
  mT.set(e, t);
};
_a.$cloneWithProperties = function(e) {
  e = e.getLatest();
  let t = e.constructor.clone(e);
  return t.__parent = e.__parent, t.__next = e.__next, t.__prev = e.__prev, Tn.$isElementNode(e) && Tn.$isElementNode(t) ? (t.__first = e.__first, t.__last = e.__last, t.__size = e.__size, t.__format = e.__format, t.__indent = e.__indent, t.__dir = e.__dir, t) : (Tn.$isTextNode(e) && Tn.$isTextNode(t) && (t.__format = e.__format, t.__style = e.__style, t.__mode = e.__mode, t.__detail = e.__detail), t);
};
_a.$getSelectionStyleValueForProperty = function(e, t, n = "") {
  let o = null, r = e.getNodes();
  var i = e.anchor, a = e.focus, s = e.isBackward();
  let c = s ? a.offset : i.offset;
  if (i = s ? a.getNode() : i.getNode(), e.style !== "" && (e = fT(e.style), e !== null && t in e))
    return e[t];
  for (e = 0; e < r.length; e++) {
    var l = r[e];
    if ((e === 0 || c !== 0 || !l.is(i)) && Tn.$isTextNode(l)) {
      if (a = t, s = n, l = l.getStyle(), l = fT(l), a = l !== null && l[a] || s, o === null)
        o = a;
      else if (o !== a) {
        o = "";
        break;
      }
    }
  }
  return o === null ? n : o;
};
_a.$isAtNodeEnd = function(e) {
  return e.type === "text" ? e.offset === e.getNode().getTextContentSize() : e.offset === e.getNode().getChildrenSize();
};
_a.$isParentElementRTL = k$e;
_a.$moveCaretSelection = w$e;
_a.$moveCharacter = function(e, t, n) {
  let o = k$e(e);
  w$e(e, t, n ? !o : o, "character");
};
_a.$patchStyleText = function(e, t) {
  var n = e.getNodes();
  let o = n.length - 1, r = n[0], i = n[o];
  if (e.isCollapsed())
    ch(e, t);
  else {
    var a = e.anchor, s = e.focus, c = r.getTextContent().length, l = s.offset, d = a.offset, u = a.isBefore(s), _ = u ? d : l;
    e = u ? l : d;
    var p = u ? a.type : s.type, f = u ? s.type : a.type;
    if (a = u ? s.key : a.key, Tn.$isTextNode(r) && _ === c && (s = r.getNextSibling(), Tn.$isTextNode(s) && (_ = d = 0, r = s)), n.length === 1)
      Tn.$isTextNode(r) && (_ = p === "element" ? 0 : d > l ? l : d, e = f === "element" ? c : d > l ? d : l, _ !== e && (_ === 0 && e === c ? (ch(r, t), r.select(_, e)) : (n = r.splitText(
        _,
        e
      ), n = _ === 0 ? n[0] : n[1], ch(n, t), n.select(0, e - _))));
    else
      for (Tn.$isTextNode(r) && _ < r.getTextContentSize() && (_ !== 0 && (r = r.splitText(_)[1]), ch(r, t)), Tn.$isTextNode(i) && (_ = i.getTextContent().length, i.__key !== a && e !== 0 && (e = _), e !== _ && ([i] = i.splitText(e)), e !== 0 && ch(i, t)), e = 1; e < o; e++)
        _ = n[e], c = _.getKey(), Tn.$isTextNode(_) && c !== r.getKey() && c !== i.getKey() && !_.isToken() && ch(_, t);
  }
};
_a.$selectAll = function(e) {
  let t = e.anchor;
  e = e.focus;
  var n = t.getNode().getTopLevelElementOrThrow().getParentOrThrow();
  let o = n.getFirstDescendant();
  n = n.getLastDescendant();
  let r = "element", i = "element", a = 0;
  Tn.$isTextNode(o) ? r = "text" : Tn.$isElementNode(o) || o === null || (o = o.getParentOrThrow()), Tn.$isTextNode(n) ? (i = "text", a = n.getTextContentSize()) : Tn.$isElementNode(n) || n === null || (n = n.getParentOrThrow()), o && n && (t.set(o.getKey(), 0, r), e.set(n.getKey(), a, i));
};
_a.$setBlocksType = function(e, t) {
  if (e.anchor.key === "root") {
    t = t();
    var n = Tn.$getRoot();
    (e = n.getFirstChild()) ? e.replace(t, !0) : n.append(t);
  } else
    for (n = e.getNodes(), e = e.anchor.getNode().getParentOrThrow(), n.indexOf(e) === -1 && n.push(e), e.isInline() && (e = e.getParentOrThrow(), n.indexOf(e) === -1 && n.push(e)), e = 0; e < n.length; e++) {
      let i = n[e];
      var o = i;
      if (!Tn.$isElementNode(o) || Tn.$isRootOrShadowRoot(o))
        o = !1;
      else {
        var r = o.getFirstChild();
        r = r === null || Tn.$isTextNode(r) || r.isInline(), o = !o.isInline() && o.canBeEmpty() !== !1 && r;
      }
      o && (o = t(), o.setFormat(i.getFormatType()), o.setIndent(i.getIndent()), i.replace(o, !0));
    }
};
_a.$shouldOverrideDefaultCharacterSelection = function(e, t) {
  return e = Tn.$getAdjacentNode(e.focus, t), Tn.$isDecoratorNode(e) && !e.isIsolated() || Tn.$isElementNode(e) && !e.isInline() && !e.canBeEmpty();
};
_a.$sliceSelectedTextNodeContent = function(e, t) {
  if (t.isSelected() && !t.isSegmented() && !t.isToken() && (Tn.$isRangeSelection(e) || Tn.DEPRECATED_$isGridSelection(e))) {
    var n = e.anchor.getNode(), o = e.focus.getNode(), r = t.is(n), i = t.is(o);
    if (r || i) {
      r = e.isBackward();
      let [a, s] = e.getCharacterOffsets();
      e = n.is(o), i = t.is(r ? o : n), o = t.is(r ? n : o), n = 0;
      let c;
      e ? (n = a > s ? s : a, c = a > s ? a : s) : i ? (n = r ? s : a, c = void 0) : o && (r = r ? a : s, n = 0, c = r), t.__text = t.__text.slice(n, c);
    }
  }
  return t;
};
_a.$wrapNodes = function(e, t, n = null) {
  var o = e.getNodes();
  let r = o.length;
  var i = e.anchor;
  if (r === 0 || r === 1 && i.type === "element" && i.getNode().getChildrenSize() === 0) {
    e = i.type === "text" ? i.getNode().getParentOrThrow() : i.getNode(), o = e.getChildren();
    let s = t();
    s.setFormat(e.getFormatType()), s.setIndent(e.getIndent()), o.forEach((c) => s.append(c)), n && (s = n.append(s)), e.replace(s);
  } else {
    i = null;
    var a = [];
    for (let s = 0; s < r; s++) {
      let c = o[s];
      Tn.$isRootOrShadowRoot(c) ? (M5(e, a, a.length, t, n), a = [], i = c) : i === null || i !== null && Tn.$hasAncestor(
        c,
        i
      ) ? a.push(c) : (M5(e, a, a.length, t, n), a = [c]);
    }
    M5(e, a, a.length, t, n);
  }
};
_a.createDOMRange = function(e, t, n, o, r) {
  let i = t.getKey(), a = o.getKey(), s = document.createRange(), c = e.getElementByKey(i);
  if (e = e.getElementByKey(a), Tn.$isTextNode(t) && (c = LX(c)), Tn.$isTextNode(o) && (e = LX(e)), t === void 0 || o === void 0 || c === null || e === null)
    return null;
  c.nodeName === "BR" && ([c, n] = qX(c)), e.nodeName === "BR" && ([e, r] = qX(e)), t = c.firstChild, c === e && t != null && t.nodeName === "BR" && n === 0 && r === 0 && (r = 1);
  try {
    s.setStart(c, n), s.setEnd(e, r);
  } catch {
    return null;
  }
  return !s.collapsed || n === r && i === a || (s.setStart(e, r), s.setEnd(
    c,
    n
  )), s;
};
_a.createRectsFromDOMRange = function(e, t) {
  var n = e.getRootElement();
  if (n === null)
    return [];
  e = n.getBoundingClientRect(), n = getComputedStyle(n), n = parseFloat(n.paddingLeft) + parseFloat(n.paddingRight), t = Array.from(t.getClientRects());
  let o = t.length, r;
  for (let i = 0; i < o; i++) {
    let a = t[i], s = a.width + n === e.width;
    r && r.top === a.top && r.left === a.left && r.width === a.width && r.height === a.height || s ? (t.splice(i--, 1), o--) : r = a;
  }
  return t;
};
_a.getStyleObjectFromCSS = fT;
_a.trimTextContentFromAnchor = function(e, t, n) {
  let o = t.getNode();
  if (Tn.$isElementNode(o)) {
    var r = o.getDescendantByIndex(t.offset);
    r !== null && (o = r);
  }
  for (; 0 < n && o !== null; ) {
    var i = o.getPreviousSibling(), a = 0;
    if (i === null) {
      r = o.getParentOrThrow();
      for (var s = r.getPreviousSibling(); s === null; ) {
        if (r = r.getParent(), r === null) {
          i = null;
          break;
        }
        s = r.getPreviousSibling();
      }
      r !== null && (a = r.isInline() ? 0 : 2, i = Tn.$isElementNode(s) ? s.getLastDescendant() : s);
    }
    if (s = o.getTextContent(), s === "" && Tn.$isElementNode(o) && !o.isInline() && (s = `

`), r = o.getTextContentSize(), !Tn.$isTextNode(o) || n >= r)
      s = o.getParent(), o.remove(), s == null || s.getChildrenSize() !== 0 || Tn.$isRootNode(s) || s.remove(), n -= r + a, o = i;
    else {
      let c = o.getKey();
      a = e.getEditorState().read(() => {
        const d = Tn.$getNodeByKey(c);
        return Tn.$isTextNode(d) && d.isSimpleText() ? d.getTextContent() : null;
      }), i = r - n;
      let l = s.slice(0, i);
      a !== null && a !== s ? (n = Tn.$getPreviousSelection(), r = o, o.isSimpleText() ? o.setTextContent(a) : (r = Tn.$createTextNode(a), o.replace(r)), Tn.$isRangeSelection(n) && n.isCollapsed() && (n = n.anchor.offset, r.select(n, n))) : o.isSimpleText() ? (a = t.key === c, s = t.offset, s < n && (s = r), n = a ? s - n : 0, r = a ? s : i, a && n === 0 ? ([n] = o.splitText(n, r), n.remove()) : ([, n] = o.splitText(n, r), n.remove())) : (n = Tn.$createTextNode(l), o.replace(n)), n = 0;
    }
  }
};
const hed = _a;
var b_ = hed, ved = b_, ea = yn;
function S$e(e, t) {
  for (let n of t)
    if (e.type.startsWith(n))
      return !0;
  return !1;
}
function x$e(e, t) {
  for (; e !== ea.$getRoot() && e != null; ) {
    if (t(e))
      return e;
    e = e.getParent();
  }
  return null;
}
function E$e(e) {
  return e.nodeType === 1;
}
Pa.$splitNode = ea.$splitNode;
Pa.$dfs = function(e, t) {
  let n = [];
  e = (e || ea.$getRoot()).getLatest(), t = t || (ea.$isElementNode(e) ? e.getLastDescendant() : e);
  for (var o = e, r = 0; (o = o.getParent()) !== null; )
    r++;
  for (o = r; e !== null && !e.is(t); )
    if (n.push({ depth: o, node: e }), ea.$isElementNode(e) && 0 < e.getChildrenSize())
      e = e.getFirstChild(), o++;
    else
      for (r = null; r === null && e !== null; )
        r = e.getNextSibling(), r === null ? (e = e.getParent(), o--) : e = r;
  return e !== null && e.is(t) && n.push({ depth: o, node: e }), n;
};
Pa.$findMatchingParent = x$e;
Pa.$getNearestBlockElementAncestorOrThrow = function(e) {
  if (e = x$e(e, (t) => ea.$isElementNode(t) && !t.isInline()), !ea.$isElementNode(e))
    throw Error("Minified Lexical error #4; visit https://lexical.dev/docs/error?code=4 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  return e;
};
Pa.$getNearestNodeOfType = function(e, t) {
  for (; e != null; ) {
    if (e instanceof t)
      return e;
    e = e.getParent();
  }
  return null;
};
Pa.$insertNodeToNearestRoot = function(e) {
  var t = ea.$getSelection();
  if (ea.$isRangeSelection(t)) {
    var { focus: n } = t;
    if (t = n.getNode(), n = n.offset, ea.$isRootOrShadowRoot(t))
      n = t.getChildAtIndex(n), n == null ? t.append(e) : n.insertBefore(e), e.selectNext();
    else {
      let o, r;
      ea.$isTextNode(t) ? (o = t.getParentOrThrow(), r = t.getIndexWithinParent(), 0 < n && (r += 1, t.splitText(n))) : (o = t, r = n), [, t] = ea.$splitNode(o, r), t.insertBefore(e), t.selectStart();
    }
  } else
    ea.$isNodeSelection(t) || ea.DEPRECATED_$isGridSelection(t) ? (t = t.getNodes(), t[t.length - 1].getTopLevelElementOrThrow().insertAfter(e)) : ea.$getRoot().append(e), t = ea.$createParagraphNode(), e.insertAfter(t), t.select();
  return e.getLatest();
};
Pa.$restoreEditorState = function(e, t) {
  let n = /* @__PURE__ */ new Map(), o = e._pendingEditorState;
  for (let [r, i] of t._nodeMap) {
    let a = ved.$cloneWithProperties(i);
    ea.$isTextNode(a) && (a.__text = i.__text), n.set(r, a);
  }
  o && (o._nodeMap = n), e._dirtyType = 2, e = t._selection, ea.$setSelection(e === null ? null : e.clone());
};
Pa.$wrapNodeInElement = function(e, t) {
  return t = t(), e.replace(t), t.append(e), t;
};
Pa.addClassNamesToElement = function(e, ...t) {
  t.forEach((n) => {
    typeof n == "string" && (n = n.split(" ").filter((o) => o !== ""), e.classList.add(...n));
  });
};
Pa.isHTMLAnchorElement = function(e) {
  return E$e(e) && e.tagName === "A";
};
Pa.isHTMLElement = E$e;
Pa.isMimeType = S$e;
Pa.mediaFileReader = function(e, t) {
  let n = e[Symbol.iterator]();
  return new Promise((o, r) => {
    let i = [], a = () => {
      const { done: s, value: c } = n.next();
      if (s)
        return o(i);
      const l = new FileReader();
      l.addEventListener("error", r), l.addEventListener("load", () => {
        const d = l.result;
        typeof d == "string" && i.push({ file: c, result: d }), a();
      }), S$e(c, t) ? l.readAsDataURL(c) : a();
    };
    a();
  });
};
Pa.mergeRegister = function(...e) {
  return () => {
    e.forEach((t) => t());
  };
};
Pa.registerNestedElementResolver = function(e, t, n, o) {
  return e.registerNodeTransform(t, (r) => {
    e: {
      for (var i = r.getChildren(), a = 0; a < i.length; a++)
        if (i[a] instanceof t) {
          i = null;
          break e;
        }
      for (i = r; i !== null; )
        if (a = i, i = i.getParent(), i instanceof t) {
          i = { child: a, parent: i };
          break e;
        }
      i = null;
    }
    if (i !== null) {
      const { child: s, parent: c } = i;
      if (s.is(r)) {
        if (o(c, r), r = s.getNextSiblings(), i = r.length, c.insertAfter(s), i !== 0) {
          a = n(c), s.insertAfter(a);
          for (let l = 0; l < i; l++)
            a.append(r[l]);
        }
        c.canBeEmpty() || c.getChildrenSize() !== 0 || c.remove();
      }
    }
  });
};
Pa.removeClassNamesFromElement = function(e, ...t) {
  t.forEach((n) => {
    typeof n == "string" && e.classList.remove(...n.split(" "));
  });
};
const bed = Pa;
var za = bed, Qh = EXl, Jh = za, sn = yn;
let jX = (e) => e != null && Qh.languages.hasOwnProperty(e) ? e : void 0;
function T$e(e, t) {
  for (let n of e.childNodes) {
    if (Jh.isHTMLElement(n) && n.tagName === t)
      return !0;
    T$e(n, t);
  }
  return !1;
}
let Xh = class A$e extends sn.ElementNode {
  static getType() {
    return "code";
  }
  static clone(t) {
    return new A$e(t.__language, t.__key);
  }
  constructor(t, n) {
    super(n), this.__language = jX(t);
  }
  createDOM(t) {
    let n = document.createElement("code");
    return Jh.addClassNamesToElement(n, t.theme.code), n.setAttribute("spellcheck", "false"), (t = this.getLanguage()) && n.setAttribute("data-highlight-language", t), n;
  }
  updateDOM(t, n) {
    let o = this.__language;
    return t = t.__language, o ? o !== t && n.setAttribute("data-highlight-language", o) : t && n.removeAttribute("data-highlight-language"), !1;
  }
  static importDOM() {
    return { code: (t) => t.textContent != null && (/\r?\n/.test(t.textContent) || T$e(t, "BR")) ? { conversion: FX, priority: 1 } : null, div: () => ({ conversion: yed, priority: 1 }), pre: () => ({ conversion: FX, priority: 0 }), table: (t) => L5(t) ? { conversion: $ed, priority: 3 } : null, td: (t) => {
      let n = t.closest("table");
      return t.classList.contains("js-file-line") ? { conversion: wed, priority: 3 } : n && L5(n) ? { conversion: VX, priority: 3 } : null;
    }, tr: (t) => (t = t.closest("table")) && L5(t) ? { conversion: VX, priority: 3 } : null };
  }
  static importJSON(t) {
    let n = Tb(t.language);
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), language: this.getLanguage(), type: "code", version: 1 };
  }
  insertNewAfter(t, n = !0) {
    var o = this.getChildren(), r = o.length;
    if (2 <= r && o[r - 1].getTextContent() === `
` && o[r - 2].getTextContent() === `
` && t.isCollapsed() && t.anchor.key === this.__key && t.anchor.offset === r)
      return o[r - 1].remove(), o[r - 2].remove(), t = sn.$createParagraphNode(), this.insertAfter(t, n), t;
    if (n = t.anchor.getNode(), r = d0(n), r != null) {
      for (o = 0, r = r.getTextContent(); o < r.length && /[\t ]/.test(r[o]); )
        o += 1;
      if (0 < o)
        return o = r.substring(0, o), o = If(o), n.insertAfter(o), t.insertNodes([sn.$createLineBreakNode()]), o.select(), o;
    }
    return null;
  }
  canInsertTab() {
    let t = sn.$getSelection();
    return !!(sn.$isRangeSelection(t) && t.isCollapsed());
  }
  canIndent() {
    return !1;
  }
  collapseAtStart() {
    let t = sn.$createParagraphNode();
    return this.getChildren().forEach((n) => t.append(n)), this.replace(t), !0;
  }
  setLanguage(t) {
    this.getWritable().__language = jX(t);
  }
  getLanguage() {
    return this.getLatest().__language;
  }
};
function Tb(e) {
  return sn.$applyNodeReplacement(new Xh(e));
}
function BC(e) {
  return e instanceof Xh;
}
function FX() {
  return { node: Tb(), preformatted: !0 };
}
function yed(e) {
  let t = e.style.fontFamily.match("monospace") !== null;
  return t || ked(e) ? { after: (n) => {
    let o = e.parentNode;
    return o != null && e !== o.lastChild && n.push(sn.$createLineBreakNode()), n;
  }, node: t ? Tb() : null, preformatted: t } : { node: null };
}
function $ed() {
  return { node: Tb(), preformatted: !0 };
}
function VX() {
  return { node: null };
}
function wed(e) {
  return { after: (t) => (e.parentNode && e.parentNode.nextSibling && t.push(sn.$createLineBreakNode()), t), node: null };
}
function ked(e) {
  for (e = e.parentElement; e !== null; ) {
    if (e.style.fontFamily.match("monospace") !== null)
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function L5(e) {
  return e.classList.contains("js-file-line-container");
}
let C$e = { c: "C", clike: "C-like", cpp: "C++", css: "CSS", html: "HTML", java: "Java", js: "JavaScript", markdown: "Markdown", objc: "Objective-C", plain: "Plain Text", py: "Python", rust: "Rust", sql: "SQL", swift: "Swift", typescript: "TypeScript", xml: "XML" }, z$e = { cpp: "cpp", java: "java", javascript: "js", md: "markdown", plaintext: "plain", python: "py", text: "plain", ts: "typescript" };
function O$e(e) {
  return z$e[e] || e;
}
let l0 = class P$e extends sn.TextNode {
  constructor(t, n, o) {
    super(t, o), this.__highlightType = n;
  }
  static getType() {
    return "code-highlight";
  }
  static clone(t) {
    return new P$e(t.__text, t.__highlightType || void 0, t.__key);
  }
  getHighlightType() {
    return this.getLatest().__highlightType;
  }
  createDOM(t) {
    let n = super.createDOM(t);
    return t = q5(t.theme, this.__highlightType), Jh.addClassNamesToElement(n, t), n;
  }
  updateDOM(t, n, o) {
    let r = super.updateDOM(t, n, o);
    return t = q5(o.theme, t.__highlightType), o = q5(o.theme, this.__highlightType), t !== o && (t && Jh.removeClassNamesFromElement(
      n,
      t
    ), o && Jh.addClassNamesToElement(n, o)), r;
  }
  static importJSON(t) {
    let n = If(t.text, t.highlightType);
    return n.setFormat(t.format), n.setDetail(t.detail), n.setMode(t.mode), n.setStyle(t.style), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), highlightType: this.getHighlightType(), type: "code-highlight", version: 1 };
  }
  setFormat() {
    return this;
  }
  isParentRequired() {
    return !0;
  }
  createParentElementNode() {
    return Tb();
  }
};
function q5(e, t) {
  return t && e && e.codeHighlight && e.codeHighlight[t];
}
function If(e, t) {
  return sn.$applyNodeReplacement(new l0(e, t));
}
function Aa(e) {
  return e instanceof l0;
}
function d0(e) {
  let t = null, n = e.getPreviousSiblings();
  for (n.push(e); 0 < n.length && (e = n.pop(), Aa(e) && (t = e), !sn.$isLineBreakNode(e)); )
    ;
  return t;
}
function HL(e) {
  let t = null, n = e.getNextSiblings();
  for (n.unshift(e); 0 < n.length && (e = n.shift(), Aa(e) && (t = e), !sn.$isLineBreakNode(e)); )
    ;
  return t;
}
let I$e = { defaultLanguage: "javascript", tokenize(e, t) {
  return Qh.tokenize(e, Qh.languages[t || ""] || Qh.languages[this.defaultLanguage]);
} };
function gT(e, t) {
  var n = e.length;
  let o = -1;
  if (t)
    for (t = 0; t < n; t++) {
      let r = e[t];
      if (r !== " " && r !== "	") {
        o = t;
        break;
      }
    }
  else
    for (--n; -1 < n; n--)
      if (t = e[n], t !== " " && t !== "	") {
        o = n;
        break;
      }
  return o;
}
function R$e(e) {
  let t = null, n = -1;
  var o = e.getPreviousSiblings();
  for (o.push(e); 0 < o.length; ) {
    var r = o.pop();
    if (Aa(r)) {
      var i = r.getTextContent();
      i = gT(i, !0), i !== -1 && (t = r, n = i);
    }
    if (sn.$isLineBreakNode(r))
      break;
  }
  if (t === null)
    for (e = e.getNextSiblings(); 0 < e.length; ) {
      if (o = e.shift(), Aa(o) && (r = o.getTextContent(), r = gT(r, !0), r !== -1)) {
        t = o, n = r;
        break;
      }
      if (sn.$isLineBreakNode(o))
        break;
    }
  return { node: t, offset: n };
}
function N$e(e) {
  let t = null, n = -1;
  var o = e.getNextSiblings();
  for (o.unshift(e); 0 < o.length; ) {
    var r = o.shift();
    if (Aa(r)) {
      var i = r.getTextContent();
      i = gT(i, !1), i !== -1 && (t = r, n = i + 1);
    }
    if (sn.$isLineBreakNode(r))
      break;
  }
  if (t === null)
    for (e = e.getPreviousSiblings(); 0 < e.length; ) {
      if (o = e.pop(), Aa(o) && (r = o.getTextContent(), r = gT(r, !1), r !== -1)) {
        t = o, n = r + 1;
        break;
      }
      if (sn.$isLineBreakNode(o))
        break;
    }
  return { node: t, offset: n };
}
function BX(e, t, n) {
  let o = e.getParent();
  BC(o) ? D$e(o, t, n) : Aa(e) && e.replace(sn.$createTextNode(e.__text));
}
let j5 = /* @__PURE__ */ new Set();
function D$e(e, t, n) {
  let o = e.getKey();
  j5.has(o) || (j5.add(o), e.getLanguage() === void 0 && e.setLanguage(n.defaultLanguage), t.update(() => {
    Sed(o, () => {
      var r = sn.$getNodeByKey(o);
      if (!BC(r) || !r.isAttached())
        return !1;
      var i = r.getTextContent();
      i = n.tokenize(i, r.getLanguage() || n.defaultLanguage), i = M$e(i);
      var a = r.getChildren();
      for (r = 0; r < a.length && UX(a[r], i[r]); )
        r++;
      var s = a.length;
      let c = i.length, l = Math.min(s, c) - r, d = 0;
      for (; d < l; )
        if (d++, !UX(a[s - d], i[c - d])) {
          d--;
          break;
        }
      a = r, s -= d, i = i.slice(r, c - d);
      let { from: u, to: _, nodesForReplacement: p } = { from: a, nodesForReplacement: i, to: s };
      return u !== _ || p.length ? (e.splice(u, _ - u, p), !0) : !1;
    });
  }, { onUpdate: () => {
    j5.delete(o);
  }, skipTransforms: !0 }));
}
function M$e(e) {
  let t = [];
  return e.forEach((n) => {
    if (typeof n == "string") {
      n = n.split(`
`);
      for (var o = 0; o < n.length; o++) {
        let r = n[o];
        r.length && t.push(If(r)), o < n.length - 1 && t.push(sn.$createLineBreakNode());
      }
    } else
      ({ content: o } = n), typeof o == "string" ? t.push(If(o, n.type)) : Array.isArray(o) && o.length === 1 && typeof o[0] == "string" ? t.push(If(o[0], n.type)) : Array.isArray(o) && t.push(...M$e(o));
  }), t;
}
function Sed(e, t) {
  if (e = sn.$getNodeByKey(e), BC(e) && e.isAttached()) {
    var n = sn.$getSelection();
    if (sn.$isRangeSelection(n)) {
      n = n.anchor;
      var o = n.offset, r = n.type === "element" && sn.$isLineBreakNode(e.getChildAtIndex(n.offset - 1)), i = 0;
      if (!r) {
        let a = n.getNode();
        i = o + a.getPreviousSiblings().reduce((s, c) => s + c.getTextContentSize(), 0);
      }
      t() && (r ? n.getNode().select(o, o) : e.getChildren().some((a) => {
        let s = sn.$isTextNode(a);
        if (s || sn.$isLineBreakNode(a)) {
          let c = a.getTextContentSize();
          if (s && c >= i)
            return a.select(i, i), !0;
          i -= c;
        }
        return !1;
      }));
    } else
      t();
  }
}
function UX(e, t) {
  return Aa(e) && Aa(t) ? e.__text === t.__text && e.__highlightType === t.__highlightType : !!(sn.$isLineBreakNode(e) && sn.$isLineBreakNode(t));
}
function WX(e) {
  var t = sn.$getSelection();
  if (!sn.$isRangeSelection(t) || t.isCollapsed())
    return !1;
  t = t.getNodes();
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    if (!Aa(o) && !sn.$isLineBreakNode(o))
      return !1;
  }
  for (n = d0(t[0]), n != null && GX(n, e), n = 1; n < t.length; n++)
    o = t[n], sn.$isLineBreakNode(t[n - 1]) && Aa(o) && GX(o, e);
  return !0;
}
function GX(e, t) {
  let n = e.getTextContent();
  t === sn.INDENT_CONTENT_COMMAND ? 0 < n.length && /\s/.test(n[0]) ? e.setTextContent("	" + n) : (t = If("	"), e.insertBefore(t)) : n.indexOf("	") === 0 && (n.length === 1 ? e.remove() : e.setTextContent(n.substring(1)));
}
function HX(e, t) {
  let n = sn.$getSelection();
  if (!sn.$isRangeSelection(n))
    return !1;
  let { anchor: o, focus: r } = n, i = o.offset, a = r.offset, s = o.getNode(), c = r.getNode();
  var l = e === sn.KEY_ARROW_UP_COMMAND;
  if (!Aa(s) || !Aa(c))
    return !1;
  if (!t.altKey) {
    if (n.isCollapsed()) {
      if (e = s.getParentOrThrow(), l && i === 0 && s.getPreviousSibling() === null) {
        if (e.getPreviousSibling() === null)
          return e.selectPrevious(), t.preventDefault(), !0;
      } else if (!l && i === s.getTextContentSize() && s.getNextSibling() === null && e.getNextSibling() === null)
        return e.selectNext(), t.preventDefault(), !0;
    }
    return !1;
  }
  var d = d0(s);
  let u = HL(c);
  if (d == null || u == null)
    return !1;
  let _ = d.getNodesBetween(u);
  for (let f = 0; f < _.length; f++) {
    let g = _[f];
    if (!Aa(g) && !sn.$isLineBreakNode(g))
      return !1;
  }
  if (t.preventDefault(), t.stopPropagation(), t = l ? d.getPreviousSibling() : u.getNextSibling(), !sn.$isLineBreakNode(t) || (d = l ? t.getPreviousSibling() : t.getNextSibling(), d == null))
    return !0;
  l = l ? d0(d) : HL(d);
  let p = l ?? d;
  return t.remove(), _.forEach((f) => f.remove()), e === sn.KEY_ARROW_UP_COMMAND ? (_.forEach((f) => p.insertBefore(f)), p.insertBefore(t)) : (p.insertAfter(t), p = t, _.forEach((f) => {
    p.insertAfter(f), p = f;
  })), n.setTextNodeRange(s, i, c, a), !0;
}
function KX(e, t) {
  let n = sn.$getSelection();
  if (!sn.$isRangeSelection(n))
    return !1;
  let { anchor: o, focus: r } = n, i = o.getNode(), a = r.getNode();
  if (e = e === sn.MOVE_TO_START, !Aa(i) || !Aa(a))
    return !1;
  let s, c;
  return e ? { node: s, offset: c } = R$e(a) : { node: s, offset: c } = N$e(a), s !== null && c !== -1 && n.setTextNodeRange(s, c, s, c), t.preventDefault(), t.stopPropagation(), !0;
}
Ni.$createCodeHighlightNode = If;
Ni.$createCodeNode = Tb;
Ni.$isCodeHighlightNode = Aa;
Ni.$isCodeNode = BC;
Ni.CODE_LANGUAGE_FRIENDLY_NAME_MAP = C$e;
Ni.CODE_LANGUAGE_MAP = z$e;
Ni.CodeHighlightNode = l0;
Ni.CodeNode = Xh;
Ni.DEFAULT_CODE_LANGUAGE = "javascript";
Ni.PrismTokenizer = I$e;
Ni.getCodeLanguages = () => Object.keys(Qh.languages).filter((e) => typeof Qh.languages[e] != "function").sort();
Ni.getDefaultCodeLanguage = () => "javascript";
Ni.getEndOfCodeInLine = N$e;
Ni.getFirstCodeHighlightNodeOfLine = d0;
Ni.getLanguageFriendlyName = function(e) {
  return e = O$e(e), C$e[e] || e;
};
Ni.getLastCodeHighlightNodeOfLine = HL;
Ni.getStartOfCodeInLine = R$e;
Ni.normalizeCodeLang = O$e;
Ni.registerCodeHighlighting = function(e, t) {
  if (!e.hasNodes([Xh, l0]))
    throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
  return t == null && (t = I$e), Jh.mergeRegister(
    e.registerMutationListener(Xh, (n) => {
      e.update(() => {
        for (let [i, a] of n)
          if (a !== "destroyed") {
            var o = sn.$getNodeByKey(i);
            if (o !== null)
              e: {
                var r = o;
                if (o = e.getElementByKey(r.getKey()), o === null)
                  break e;
                r = r.getChildren();
                let s = r.length;
                if (s === o.__cachedChildrenLength)
                  break e;
                o.__cachedChildrenLength = s;
                let c = "1", l = 1;
                for (let d = 0; d < s; d++)
                  sn.$isLineBreakNode(r[d]) && (c += `
` + ++l);
                o.setAttribute("data-gutter", c);
              }
          }
      });
    }),
    e.registerNodeTransform(Xh, (n) => D$e(n, e, t)),
    e.registerNodeTransform(sn.TextNode, (n) => BX(n, e, t)),
    e.registerNodeTransform(l0, (n) => BX(n, e, t)),
    e.registerCommand(sn.INDENT_CONTENT_COMMAND, () => WX(sn.INDENT_CONTENT_COMMAND), sn.COMMAND_PRIORITY_LOW),
    e.registerCommand(sn.OUTDENT_CONTENT_COMMAND, () => WX(sn.OUTDENT_CONTENT_COMMAND), sn.COMMAND_PRIORITY_LOW),
    e.registerCommand(sn.KEY_ARROW_UP_COMMAND, (n) => HX(sn.KEY_ARROW_UP_COMMAND, n), sn.COMMAND_PRIORITY_LOW),
    e.registerCommand(sn.KEY_ARROW_DOWN_COMMAND, (n) => HX(sn.KEY_ARROW_DOWN_COMMAND, n), sn.COMMAND_PRIORITY_LOW),
    e.registerCommand(sn.MOVE_TO_END, (n) => KX(sn.MOVE_TO_END, n), sn.COMMAND_PRIORITY_LOW),
    e.registerCommand(sn.MOVE_TO_START, (n) => KX(sn.MOVE_TO_START, n), sn.COMMAND_PRIORITY_LOW)
  );
};
const xed = Ni;
var KL = xed, L_ = {}, L$e = za, iu = yn;
let UC = class q$e extends iu.ElementNode {
  static getType() {
    return "link";
  }
  static clone(t) {
    return new q$e(t.__url, { rel: t.__rel, target: t.__target }, t.__key);
  }
  constructor(t, n = {}, o) {
    super(o);
    let { target: r = null, rel: i = null } = n;
    this.__url = t, this.__target = r, this.__rel = i;
  }
  createDOM(t) {
    let n = document.createElement("a");
    return n.href = this.__url, this.__target !== null && (n.target = this.__target), this.__rel !== null && (n.rel = this.__rel), L$e.addClassNamesToElement(n, t.theme.link), n;
  }
  updateDOM(t, n) {
    let o = this.__url, r = this.__target, i = this.__rel;
    return o !== t.__url && (n.href = o), r !== t.__target && (r ? n.target = r : n.removeAttribute("target")), i !== t.__rel && (i ? n.rel = i : n.removeAttribute("rel")), !1;
  }
  static importDOM() {
    return { a: () => ({ conversion: Eed, priority: 1 }) };
  }
  static importJSON(t) {
    let n = u0(t.url, { rel: t.rel, target: t.target });
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), rel: this.getRel(), target: this.getTarget(), type: "link", url: this.getURL(), version: 1 };
  }
  getURL() {
    return this.getLatest().__url;
  }
  setURL(t) {
    this.getWritable().__url = t;
  }
  getTarget() {
    return this.getLatest().__target;
  }
  setTarget(t) {
    this.getWritable().__target = t;
  }
  getRel() {
    return this.getLatest().__rel;
  }
  setRel(t) {
    this.getWritable().__rel = t;
  }
  insertNewAfter(t, n = !0) {
    return t = this.getParentOrThrow().insertNewAfter(t, n), iu.$isElementNode(t) ? (n = u0(this.__url, { rel: this.__rel, target: this.__target }), t.append(n), n) : null;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(t, n) {
    if (!iu.$isRangeSelection(n))
      return !1;
    t = n.anchor.getNode();
    let o = n.focus.getNode();
    return this.isParentOf(t) && this.isParentOf(o) && 0 < n.getTextContent().length;
  }
};
function Eed(e) {
  let t = null;
  if (L$e.isHTMLAnchorElement(e)) {
    let n = e.textContent;
    n !== null && n !== "" && (t = u0(e.getAttribute("href") || "", { rel: e.getAttribute("rel"), target: e.getAttribute("target") }));
  }
  return { node: t };
}
function u0(e, t) {
  return iu.$applyNodeReplacement(new UC(e, t));
}
function nf(e) {
  return e instanceof UC;
}
let E8 = class j$e extends UC {
  static getType() {
    return "autolink";
  }
  static clone(t) {
    return new j$e(t.__url, { rel: t.__rel, target: t.__target }, t.__key);
  }
  static importJSON(t) {
    let n = YL(t.url, { rel: t.rel, target: t.target });
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  static importDOM() {
    return null;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "autolink", version: 1 };
  }
  insertNewAfter(t, n = !0) {
    return t = this.getParentOrThrow().insertNewAfter(t, n), iu.$isElementNode(t) ? (n = YL(this.__url, {
      rel: this._rel,
      target: this.__target
    }), t.append(n), n) : null;
  }
};
function YL(e, t) {
  return iu.$applyNodeReplacement(new E8(e, t));
}
let Ted = iu.createCommand("TOGGLE_LINK_COMMAND");
function Aed(e) {
  return Ced(e, (t) => nf(t));
}
function Ced(e, t) {
  for (; e !== null && (e = e.getParent()) !== null && !t(e); )
    ;
  return e;
}
L_.$createAutoLinkNode = YL;
L_.$createLinkNode = u0;
L_.$isAutoLinkNode = function(e) {
  return e instanceof E8;
};
L_.$isLinkNode = nf;
L_.AutoLinkNode = E8;
L_.LinkNode = UC;
L_.TOGGLE_LINK_COMMAND = Ted;
L_.toggleLink = function(e, t = {}) {
  let { target: n } = t, o = t.rel === void 0 ? "noopener" : t.rel;
  if (t = iu.$getSelection(), iu.$isRangeSelection(t))
    if (t = t.extract(), e === null)
      t.forEach((i) => {
        if (i = i.getParent(), nf(i)) {
          let a = i.getChildren();
          for (let s = 0; s < a.length; s++)
            i.insertBefore(a[s]);
          i.remove();
        }
      });
    else {
      if (t.length === 1) {
        var r = t[0];
        if (r = nf(r) ? r : Aed(r), r !== null) {
          r.setURL(e), n !== void 0 && r.setTarget(n), o !== null && r.setRel(o);
          return;
        }
      }
      let i = null, a = null;
      t.forEach((s) => {
        var c = s.getParent();
        if (c !== a && c !== null && (!iu.$isElementNode(s) || s.isInline()))
          if (nf(c))
            a = c, c.setURL(e), n !== void 0 && c.setTarget(n), o !== null && a.setRel(o);
          else if (c.is(i) || (i = c, a = u0(e, { rel: o, target: n }), nf(c) ? s.getPreviousSibling() === null ? c.insertBefore(a) : c.insertAfter(a) : s.insertBefore(a)), nf(s)) {
            if (!s.is(a)) {
              if (a !== null) {
                c = s.getChildren();
                for (let l = 0; l < c.length; l++)
                  a.append(c[l]);
              }
              s.remove();
            }
          } else
            a !== null && a.append(s);
      });
    }
};
const zed = L_;
var vl = zed, Rs = {}, tr = yn, eg = za;
function bk(e) {
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?code=${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function F$e(e) {
  let t = 1;
  for (e = e.getParent(); e != null; ) {
    if (li(e)) {
      if (e = e.getParent(), Eo(e)) {
        t++, e = e.getParent();
        continue;
      }
      bk(40);
    }
    break;
  }
  return t;
}
function ZL(e) {
  e = e.getParent(), Eo(e) || bk(40);
  let t = e;
  for (; t !== null; )
    t = t.getParent(), Eo(t) && (e = t);
  return e;
}
function V$e(e) {
  let t = [];
  e = e.getChildren().filter(li);
  for (let n = 0; n < e.length; n++) {
    let o = e[n], r = o.getFirstChild();
    Eo(r) ? t = t.concat(V$e(r)) : t.push(o);
  }
  return t;
}
function Pd(e) {
  return li(e) && Eo(e.getFirstChild());
}
function Oed(e) {
  for (; e.getNextSibling() == null && e.getPreviousSibling() == null; ) {
    let t = e.getParent();
    if (t == null || !li(e) && !Eo(e))
      break;
    e = t;
  }
  e.remove();
}
function YX(e) {
  return Sl().append(e);
}
function B$e(e, t) {
  return li(e) && (t.length === 0 || t.length === 1 && e.is(t[0]) && e.getChildrenSize() === 0);
}
function tg(e, t) {
  e.splice(e.getChildrenSize(), 0, t);
}
function ZX(e, t) {
  if (Eo(e))
    return e;
  let n = e.getPreviousSibling(), o = e.getNextSibling(), r = Sl();
  return r.setFormat(e.getFormatType()), r.setIndent(e.getIndent()), tg(r, e.getChildren()), Eo(n) && t === n.getListType() ? (n.append(r), e.remove(), Eo(o) && t === o.getListType() && (tg(n, o.getChildren()), o.remove()), n) : Eo(o) && t === o.getListType() ? (o.getFirstChildOrThrow().insertBefore(r), e.remove(), o) : (t = zs(t), t.append(r), e.replace(t), hs(t), t);
}
function U$e(e, t) {
  var n = e.getLastChild();
  let o = t.getFirstChild();
  n && o && Pd(n) && Pd(o) && (U$e(n.getFirstChild(), o.getFirstChild()), o.remove()), n = t.getChildren(), 0 < n.length && (e.append(...n), hs(e)), t.remove();
}
function hs(e, t) {
  if (e = t || e.getChildren(), e !== void 0)
    for (t = 0; t < e.length; t++) {
      let i = e[t];
      if (li(i)) {
        let a = i.getValue();
        var n = i, o = n.getParent(), r = 1;
        for (o != null && (Eo(o) ? r = o.getStart() : bk(44)), n = n.getPreviousSiblings(), o = 0; o < n.length; o++) {
          let s = n[o];
          li(s) && !Eo(s.getFirstChild()) && r++;
        }
        a !== r && i.setValue(r);
      }
    }
}
function Ped(e) {
  if (!Pd(e)) {
    var t = e.getParent(), n = t ? t.getParent() : void 0, o = n ? n.getParent() : void 0;
    if (Eo(o) && li(n) && Eo(t)) {
      var r = t ? t.getFirstChild() : void 0, i = t ? t.getLastChild() : void 0;
      if (e.is(r))
        n.insertBefore(e), t.isEmpty() && n.remove();
      else if (e.is(i))
        n.insertAfter(e), t.isEmpty() && n.remove();
      else {
        var a = t.getListType();
        r = Sl();
        let s = zs(a);
        r.append(s), e.getPreviousSiblings().forEach((c) => s.append(c)), i = Sl(), a = zs(a), i.append(a), tg(a, e.getNextSiblings()), n.insertBefore(r), n.insertAfter(i), n.replace(e);
      }
      hs(t), hs(o);
    }
  }
}
let WC = class QL extends tr.ElementNode {
  static getType() {
    return "listitem";
  }
  static clone(t) {
    return new QL(t.__value, t.__checked, t.__key);
  }
  constructor(t, n, o) {
    super(o), this.__value = t === void 0 ? 1 : t, this.__checked = n;
  }
  createDOM(t) {
    let n = document.createElement("li"), o = this.getParent();
    return Eo(o) && o.getListType() === "check" && JX(n, this, null), n.value = this.__value, QX(n, t.theme, this), n;
  }
  updateDOM(t, n, o) {
    let r = this.getParent();
    return Eo(r) && r.getListType() === "check" && JX(n, this, t), n.value = this.__value, QX(n, o.theme, this), !1;
  }
  static transform() {
    return (t) => {
      let n = t.getParent();
      Eo(n) && (hs(n), n.getListType() !== "check" && t.getChecked() != null && t.setChecked(void 0));
    };
  }
  static importDOM() {
    return { li: () => ({ conversion: Ied, priority: 0 }) };
  }
  static importJSON(t) {
    let n = new QL(t.value, t.checked);
    return n.setFormat(t.format), n.getWritable().__indent = t.indent, n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), checked: this.getChecked(), type: "listitem", value: this.getValue(), version: 1 };
  }
  append(...t) {
    for (let n = 0; n < t.length; n++) {
      let o = t[n];
      if (tr.$isElementNode(o) && this.canMergeWith(o)) {
        let r = o.getChildren();
        this.append(...r), o.remove();
      } else
        super.append(o);
    }
    return this;
  }
  replace(t, n) {
    if (li(t))
      return super.replace(t);
    this.setIndent(0);
    let o = this.getParentOrThrow();
    if (!Eo(o))
      return t;
    if (o.__first === this.getKey())
      o.insertBefore(t);
    else if (o.__last === this.getKey())
      o.insertAfter(t);
    else {
      let r = zs(o.getListType()), i = this.getNextSibling();
      for (; i; ) {
        let a = i;
        i = i.getNextSibling(), r.append(a);
      }
      o.insertAfter(t), t.insertAfter(r);
    }
    return n && this.getChildren().forEach((r) => {
      t.append(r);
    }), this.remove(), o.getChildrenSize() === 0 && o.remove(), t;
  }
  insertAfter(t, n = !0) {
    var o = this.getParentOrThrow();
    Eo(o) || bk(39);
    var r = this.getNextSiblings();
    if (li(t))
      return n = super.insertAfter(t, n), t = t.getParentOrThrow(), Eo(t) && hs(t), n;
    if (Eo(t) && t.getListType() === o.getListType()) {
      for (o = t, t = t.getChildren(), r = t.length - 1; 0 <= r; r--)
        o = t[r], this.insertAfter(o, n);
      return o;
    }
    if (o.insertAfter(t, n), r.length !== 0) {
      let i = zs(o.getListType());
      r.forEach((a) => i.append(a)), t.insertAfter(i, n);
    }
    return t;
  }
  remove(t) {
    let n = this.getPreviousSibling(), o = this.getNextSibling();
    super.remove(t), n && o && Pd(n) && Pd(o) ? (U$e(n.getFirstChild(), o.getFirstChild()), o.remove()) : o && (t = o.getParent(), Eo(t) && hs(t));
  }
  insertNewAfter(t, n = !0) {
    return t = Sl(this.__checked == null ? void 0 : !1), this.insertAfter(t, n), t;
  }
  collapseAtStart(t) {
    let n = tr.$createParagraphNode();
    this.getChildren().forEach((a) => n.append(a));
    var o = this.getParentOrThrow(), r = o.getParentOrThrow();
    let i = li(r);
    return o.getChildrenSize() === 1 ? i ? (o.remove(), r.select()) : (o.insertBefore(n), o.remove(), o = t.anchor, t = t.focus, r = n.getKey(), o.type === "element" && o.getNode().is(this) && o.set(r, o.offset, "element"), t.type === "element" && t.getNode().is(this) && t.set(r, t.offset, "element")) : (o.insertBefore(n), this.remove()), !0;
  }
  getValue() {
    return this.getLatest().__value;
  }
  setValue(t) {
    this.getWritable().__value = t;
  }
  getChecked() {
    return this.getLatest().__checked;
  }
  setChecked(t) {
    this.getWritable().__checked = t;
  }
  toggleChecked() {
    this.setChecked(!this.__checked);
  }
  getIndent() {
    var t = this.getParent();
    if (t === null)
      return this.getLatest().__indent;
    t = t.getParentOrThrow();
    let n = 0;
    for (; li(t); )
      t = t.getParentOrThrow().getParentOrThrow(), n++;
    return n;
  }
  setIndent(t) {
    if (!(typeof t == "number" && -1 < t))
      throw Error("Invalid indent value.");
    let n = this.getIndent();
    for (; n !== t; )
      if (n < t) {
        e: {
          var o = /* @__PURE__ */ new Set();
          if (Pd(this) || o.has(this.getKey()))
            break e;
          let s = this.getParent();
          var r = this.getNextSibling(), i = this.getPreviousSibling();
          if (Pd(r) && Pd(i)) {
            if (i = i.getFirstChild(), Eo(i)) {
              i.append(this);
              var a = r.getFirstChild();
              Eo(a) && (a = a.getChildren(), tg(i, a), r.remove(), o.add(r.getKey())), hs(i);
            }
          } else
            Pd(r) ? (r = r.getFirstChild(), Eo(r) && (o = r.getFirstChild(), o !== null && o.insertBefore(this), hs(r))) : Pd(i) ? (r = i.getFirstChild(), Eo(r) && (r.append(this), hs(r))) : Eo(s) && (o = Sl(), a = zs(s.getListType()), o.append(a), a.append(this), i ? i.insertAfter(o) : r ? r.insertBefore(o) : s.append(o), hs(a));
          Eo(s) && hs(s);
        }
        n++;
      } else
        Ped(this), n--;
    return this;
  }
  insertBefore(t) {
    if (li(t)) {
      let n = this.getParentOrThrow();
      if (Eo(n)) {
        let o = this.getNextSiblings();
        hs(n, o);
      }
    }
    return super.insertBefore(t);
  }
  canInsertAfter(t) {
    return li(t);
  }
  canReplaceWith(t) {
    return li(t);
  }
  canMergeWith(t) {
    return tr.$isParagraphNode(t) || li(t);
  }
  extractWithChild(t, n) {
    if (!tr.$isRangeSelection(n))
      return !1;
    t = n.anchor.getNode();
    let o = n.focus.getNode();
    return this.isParentOf(t) && this.isParentOf(o) && this.getTextContent().length === n.getTextContent().length;
  }
  isParentRequired() {
    return !0;
  }
  createParentElementNode() {
    return zs("bullet");
  }
};
function QX(e, t, n) {
  let o = [], r = [];
  var i = (t = t.list) ? t.listitem : void 0;
  if (t && t.nested)
    var a = t.nested.listitem;
  if (i !== void 0 && (i = i.split(" "), o.push(...i)), t) {
    i = n.getParent(), i = Eo(i) && i.getListType() === "check";
    let s = n.getChecked();
    i && !s || r.push(t.listitemUnchecked), i && s || r.push(t.listitemChecked), i && o.push(s ? t.listitemChecked : t.listitemUnchecked);
  }
  a !== void 0 && (a = a.split(" "), n.getChildren().some((s) => Eo(s)) ? o.push(...a) : r.push(...a)), 0 < r.length && eg.removeClassNamesFromElement(e, ...r), 0 < o.length && eg.addClassNamesToElement(
    e,
    ...o
  );
}
function JX(e, t, n) {
  Eo(t.getFirstChild()) ? (e.removeAttribute("role"), e.removeAttribute("tabIndex"), e.removeAttribute("aria-checked")) : (e.setAttribute("role", "checkbox"), e.setAttribute("tabIndex", "-1"), n && t.__checked === n.__checked || e.setAttribute("aria-checked", t.getChecked() ? "true" : "false"));
}
function Ied(e) {
  return e = eg.isHTMLElement(e) && e.getAttribute("aria-checked") === "true", { node: Sl(e) };
}
function Sl(e) {
  return tr.$applyNodeReplacement(new WC(void 0, e));
}
function li(e) {
  return e instanceof WC;
}
let T8 = class W$e extends tr.ElementNode {
  static getType() {
    return "list";
  }
  static clone(t) {
    return new W$e(t.__listType || tee[t.__tag], t.__start, t.__key);
  }
  constructor(t, n, o) {
    super(o), this.__listType = t = tee[t] || t, this.__tag = t === "number" ? "ol" : "ul", this.__start = n;
  }
  getTag() {
    return this.__tag;
  }
  getListType() {
    return this.__listType;
  }
  getStart() {
    return this.__start;
  }
  createDOM(t) {
    let n = document.createElement(this.__tag);
    return this.__start !== 1 && n.setAttribute("start", String(this.__start)), n.__lexicalListType = this.__listType, XX(n, t.theme, this), n;
  }
  updateDOM(t, n, o) {
    return t.__tag !== this.__tag ? !0 : (XX(n, o.theme, this), !1);
  }
  static importDOM() {
    return { ol: () => ({ conversion: eee, priority: 0 }), ul: () => ({ conversion: eee, priority: 0 }) };
  }
  static importJSON(t) {
    let n = zs(t.listType, t.start);
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportDOM(t) {
    return { element: t } = super.exportDOM(t), t && (this.__start !== 1 && t.setAttribute("start", String(this.__start)), this.__listType === "check" && t.setAttribute("__lexicalListType", "check")), { element: t };
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      listType: this.getListType(),
      start: this.getStart(),
      tag: this.getTag(),
      type: "list",
      version: 1
    };
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
  append(...t) {
    for (let o = 0; o < t.length; o++) {
      var n = t[o];
      if (li(n))
        super.append(n);
      else {
        let r = Sl();
        Eo(n) || tr.$isElementNode(n) && (n = tr.$createTextNode(n.getTextContent())), r.append(n), super.append(r);
      }
    }
    return hs(this), this;
  }
  extractWithChild(t) {
    return li(t);
  }
};
function XX(e, t, n) {
  let o = [], r = [];
  var i = t.list;
  if (i !== void 0) {
    let s = i[`${n.__tag}Depth`] || [];
    t = F$e(n) - 1;
    let c = t % s.length;
    var a = s[c];
    let l = i[n.__tag], d;
    if (i = i.nested, i !== void 0 && i.list && (d = i.list), l !== void 0 && o.push(l), a !== void 0)
      for (a = a.split(" "), o.push(...a), a = 0; a < s.length; a++)
        a !== c && r.push(n.__tag + a);
    d !== void 0 && (n = d.split(" "), 1 < t ? o.push(...n) : r.push(...n));
  }
  0 < r.length && eg.removeClassNamesFromElement(e, ...r), 0 < o.length && eg.addClassNamesToElement(e, ...o);
}
function Red(e) {
  let t = [];
  for (let o = 0; o < e.length; o++) {
    var n = e[o];
    li(n) ? (t.push(n), n = n.getChildren(), 1 < n.length && n.forEach((r) => {
      Eo(r) && t.push(YX(r));
    })) : t.push(YX(n));
  }
  return t;
}
function eee(e) {
  let t = e.nodeName.toLowerCase(), n = null;
  return t === "ol" ? n = zs("number", e.start) : t === "ul" && (n = eg.isHTMLElement(e) && e.getAttribute("__lexicallisttype") === "check" ? zs("check") : zs("bullet")), { after: Red, node: n };
}
let tee = { ol: "number", ul: "bullet" };
function zs(e, t = 1) {
  return tr.$applyNodeReplacement(new T8(e, t));
}
function Eo(e) {
  return e instanceof T8;
}
let Ned = tr.createCommand("INSERT_UNORDERED_LIST_COMMAND"), Ded = tr.createCommand("INSERT_ORDERED_LIST_COMMAND"), Med = tr.createCommand("INSERT_CHECK_LIST_COMMAND"), Led = tr.createCommand("REMOVE_LIST_COMMAND");
Rs.$createListItemNode = Sl;
Rs.$createListNode = zs;
Rs.$getListDepth = F$e;
Rs.$handleListInsertParagraph = function() {
  var e = tr.$getSelection();
  if (!tr.$isRangeSelection(e) || !e.isCollapsed() || (e = e.anchor.getNode(), !li(e) || e.getTextContent() !== ""))
    return !1;
  var t = ZL(e), n = e.getParent();
  Eo(n) || bk(40);
  let o = n.getParent(), r;
  if (tr.$isRootOrShadowRoot(o))
    r = tr.$createParagraphNode(), t.insertAfter(r);
  else if (li(o))
    r = Sl(), o.insertAfter(r);
  else
    return !1;
  if (r.select(), t = e.getNextSiblings(), 0 < t.length) {
    let i = zs(n.getListType());
    tr.$isParagraphNode(r) ? r.insertAfter(i) : (n = Sl(), n.append(i), r.insertAfter(n)), t.forEach((a) => {
      a.remove(), i.append(a);
    });
  }
  return Oed(e), !0;
};
Rs.$isListItemNode = li;
Rs.$isListNode = Eo;
Rs.INSERT_CHECK_LIST_COMMAND = Med;
Rs.INSERT_ORDERED_LIST_COMMAND = Ded;
Rs.INSERT_UNORDERED_LIST_COMMAND = Ned;
Rs.ListItemNode = WC;
Rs.ListNode = T8;
Rs.REMOVE_LIST_COMMAND = Led;
Rs.insertList = function(e, t) {
  e.update(() => {
    var n = tr.$getSelection();
    if (tr.$isRangeSelection(n) || tr.DEPRECATED_$isGridSelection(n)) {
      var o = n.getNodes();
      n = n.anchor.getNode();
      var r = n.getParent();
      if (B$e(n, o))
        o = zs(t), tr.$isRootOrShadowRoot(r) ? (n.replace(o), r = Sl(), tr.$isElementNode(n) && (r.setFormat(n.getFormatType()), r.setIndent(n.getIndent())), o.append(r)) : li(n) && (n = n.getParentOrThrow(), tg(o, n.getChildren()), n.replace(o));
      else
        for (n = /* @__PURE__ */ new Set(), r = 0; r < o.length; r++) {
          var i = o[r];
          if (tr.$isElementNode(i) && i.isEmpty() && !n.has(i.getKey()))
            ZX(
              i,
              t
            );
          else if (tr.$isLeafNode(i))
            for (i = i.getParent(); i != null; ) {
              let s = i.getKey();
              if (Eo(i)) {
                if (!n.has(s)) {
                  var a = zs(t);
                  tg(a, i.getChildren()), i.replace(a), hs(a), n.add(s);
                }
                break;
              } else {
                if (a = i.getParent(), tr.$isRootOrShadowRoot(a) && !n.has(s)) {
                  n.add(s), ZX(i, t);
                  break;
                }
                i = a;
              }
            }
        }
    }
  });
};
Rs.removeList = function(e) {
  e.update(() => {
    let t = tr.$getSelection();
    if (tr.$isRangeSelection(t)) {
      var n = /* @__PURE__ */ new Set(), o = t.getNodes(), r = t.anchor.getNode();
      if (B$e(r, o))
        n.add(ZL(r));
      else
        for (r = 0; r < o.length; r++) {
          var i = o[r];
          tr.$isLeafNode(i) && (i = eg.$getNearestNodeOfType(i, WC), i != null && n.add(ZL(i)));
        }
      for (let a of n) {
        n = a, o = V$e(a);
        for (let s of o)
          o = tr.$createParagraphNode(), tg(o, s.getChildren()), n.insertAfter(o), n = o, s.__key === t.anchor.key && t.anchor.set(o.getKey(), 0, "element"), s.__key === t.focus.key && t.focus.set(o.getKey(), 0, "element"), s.remove();
        a.remove();
      }
    }
  });
};
const qed = Rs;
var ul = qed, ni = {}, $u = {}, q_ = {}, A8 = {}, nee = b_, Ah = yn;
function G$e(e, t, n, o = null) {
  let r = o != null ? t.isSelected() : !0, i = Ah.$isElementNode(t) && t.excludeFromCopy("html");
  var a = t;
  o !== null && (a = nee.$cloneWithProperties(t), a = Ah.$isTextNode(a) && o != null ? nee.$sliceSelectedTextNodeContent(o, a) : a);
  let s = Ah.$isElementNode(a) ? a.getChildren() : [], { element: c, after: l } = a.exportDOM(e);
  if (!c)
    return !1;
  let d = new DocumentFragment();
  for (let u = 0; u < s.length; u++) {
    let _ = s[u], p = G$e(e, _, d, o);
    !r && Ah.$isElementNode(t) && p && t.extractWithChild(_, o, "html") && (r = !0);
  }
  return r && !i ? (c.append(d), n.append(c), l && (e = l.call(
    a,
    c
  )) && c.replaceWith(e)) : n.append(d), r;
}
let H$e = /* @__PURE__ */ new Set(["STYLE"]);
function K$e(e, t, n = /* @__PURE__ */ new Map(), o, r = !1) {
  let i = [];
  if (H$e.has(e.nodeName))
    return i;
  let a = null;
  var { nodeName: s } = e, c = t._htmlConversions.get(s.toLowerCase());
  if (s = null, c !== void 0)
    for (l of c)
      c = l(e), c !== null && (s === null || s.priority < c.priority) && (s = c);
  var l = (l = s !== null ? s.conversion : null) ? l(e, void 0, r) : null;
  if (s = null, l !== null) {
    if (s = l.after, a = l.node, a !== null) {
      for (var [, d] of n)
        if (a = d(a, o), !a)
          break;
      a && i.push(a);
    }
    l.forChild != null && n.set(e.nodeName, l.forChild);
  }
  for (e = e.childNodes, o = [], d = 0; d < e.length; d++)
    o.push(...K$e(
      e[d],
      t,
      new Map(n),
      a,
      r || (l && l.preformatted) === !0
    ));
  return s != null && (o = s(o)), a == null ? i = i.concat(o) : Ah.$isElementNode(a) && a.append(...o), i;
}
A8.$generateHtmlFromNodes = function(e, t) {
  if (typeof document > "u" || typeof window > "u")
    throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  let n = document.createElement("div"), o = Ah.$getRoot().getChildren();
  for (let r = 0; r < o.length; r++)
    G$e(e, o[r], n, t);
  return n.innerHTML;
};
A8.$generateNodesFromDOM = function(e, t) {
  let n = [];
  t = t.body ? t.body.childNodes : [];
  for (let r = 0; r < t.length; r++) {
    var o = t[r];
    H$e.has(o.nodeName) || (o = K$e(o, e), o !== null && (n = n.concat(o)));
  }
  return n;
};
const jed = A8;
var lx = jed, Y$e = lx, JL = b_, X$ = za, Qn = yn;
function i_(e) {
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?code=${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function Z$e(e) {
  let t = Qn.$getSelection();
  if (t == null)
    throw Error("Expected valid LexicalSelection");
  return Qn.$isRangeSelection(t) && t.isCollapsed() || t.getNodes().length === 0 ? "" : Y$e.$generateHtmlFromNodes(e, t);
}
function Q$e(e) {
  let t = Qn.$getSelection();
  if (t == null)
    throw Error("Expected valid LexicalSelection");
  return Qn.$isRangeSelection(t) && t.isCollapsed() || t.getNodes().length === 0 ? null : JSON.stringify(X$e(e, t));
}
function XL(e, t, n) {
  (Qn.DEPRECATED_$isGridSelection(n) || X$.$findMatchingParent(n.anchor.getNode(), (o) => Qn.DEPRECATED_$isGridCellNode(o)) !== null && X$.$findMatchingParent(n.focus.getNode(), (o) => Qn.DEPRECATED_$isGridCellNode(o)) !== null) && t.length === 1 && Qn.DEPRECATED_$isGridNode(t[0]) ? Ved(t, n, !1, e) : Fed(t, n);
}
function Fed(e, t) {
  let n = [], o = null;
  for (let r = 0; r < e.length; r++) {
    let i = e[r], a = Qn.$isLineBreakNode(i);
    if (a || Qn.$isDecoratorNode(i) && i.isInline() || Qn.$isElementNode(i) && i.isInline() || Qn.$isTextNode(i) || i.isParentRequired()) {
      if (o === null && (o = i.createParentElementNode(), n.push(o), a))
        continue;
      o !== null && o.append(i);
    } else
      n.push(i), o = null;
  }
  Qn.$isRangeSelection(t) ? t.insertNodes(n) : Qn.DEPRECATED_$isGridSelection(t) && (e = t.anchor.getNode(), Qn.DEPRECATED_$isGridCellNode(e) || i_(41), e.append(...n));
}
function Ved(e, t, n, o) {
  e.length === 1 && Qn.DEPRECATED_$isGridNode(e[0]) || i_(42);
  var r = e[0];
  e = r.getChildren(), n = r.getFirstChildOrThrow().getChildrenSize();
  var i = r.getChildrenSize(), a = X$.$findMatchingParent(t.anchor.getNode(), (p) => Qn.DEPRECATED_$isGridCellNode(p));
  t = (r = a && X$.$findMatchingParent(a, (p) => Qn.DEPRECATED_$isGridRowNode(p))) && X$.$findMatchingParent(r, (p) => Qn.DEPRECATED_$isGridNode(p)), Qn.DEPRECATED_$isGridCellNode(a) && Qn.DEPRECATED_$isGridRowNode(r) && Qn.DEPRECATED_$isGridNode(t) || i_(43);
  var s = r.getIndexWithinParent(), c = Math.min(t.getChildrenSize() - 1, s + i - 1);
  i = a.getIndexWithinParent(), a = Math.min(r.getChildrenSize() - 1, i + n - 1), n = Math.min(i, a), r = Math.min(s, c), i = Math.max(i, a), s = Math.max(s, c), c = t.getChildren(), a = 0;
  let l, d;
  for (let p = r; p <= s; p++) {
    var u = c[p];
    Qn.DEPRECATED_$isGridRowNode(u) || i_(24);
    var _ = e[a];
    Qn.DEPRECATED_$isGridRowNode(_) || i_(24), u = u.getChildren(), _ = _.getChildren();
    let f = 0;
    for (let g = n; g <= i; g++) {
      let h = u[g];
      Qn.DEPRECATED_$isGridCellNode(h) || i_(25);
      let b = _[f];
      Qn.DEPRECATED_$isGridCellNode(b) || i_(25), p === r && g === n ? l = h.getKey() : p === s && g === i && (d = h.getKey());
      let v = h.getChildren();
      b.getChildren().forEach(($) => {
        Qn.$isTextNode($) && Qn.$createParagraphNode().append($), h.append($);
      }), v.forEach(($) => $.remove()), f++;
    }
    a++;
  }
  l && d && (e = Qn.DEPRECATED_$createGridSelection(), e.set(t.getKey(), l, d), Qn.$setSelection(e), o.dispatchCommand(Qn.SELECTION_CHANGE_COMMAND, void 0));
}
function J$e(e, t, n, o = []) {
  let r = t != null ? n.isSelected(t) : !0, i = Qn.$isElementNode(n) && n.excludeFromCopy("html");
  var a = n;
  if (t !== null) {
    var s = JL.$cloneWithProperties(n);
    a = s = Qn.$isTextNode(s) && t != null ? JL.$sliceSelectedTextNodeContent(t, s) : s;
  }
  let c = Qn.$isElementNode(a) ? a.getChildren() : [];
  var l = a;
  s = l.exportJSON(), s.type !== l.constructor.getType() && i_(58);
  var d = s.children;
  for (Qn.$isElementNode(l) && (Array.isArray(d) || i_(59)), Qn.$isTextNode(a) && (a = a.__text, 0 < a.length ? s.text = a : r = !1), a = 0; a < c.length; a++)
    l = c[a], d = J$e(e, t, l, s.children), !r && Qn.$isElementNode(n) && d && n.extractWithChild(l, t, "clone") && (r = !0);
  if (r && !i)
    o.push(s);
  else if (Array.isArray(s.children))
    for (e = 0; e < s.children.length; e++)
      o.push(s.children[e]);
  return r;
}
function X$e(e, t) {
  let n = [], o = Qn.$getRoot().getChildren();
  for (let r = 0; r < o.length; r++)
    J$e(e, t, o[r], n);
  return { namespace: e._config.namespace, nodes: n };
}
function ewe(e) {
  let t = [];
  for (let n = 0; n < e.length; n++) {
    let o = Qn.$parseSerializedNode(e[n]);
    Qn.$isTextNode(o) && JL.$addNodeStyle(o), t.push(o);
  }
  return t;
}
let lh = null;
function oee(e, t) {
  var n = window.getSelection();
  if (!n)
    return !1;
  var o = n.anchorNode;
  if (n = n.focusNode, o !== null && n !== null && !Qn.isSelectionWithinEditor(e, o, n) || (t.preventDefault(), t = t.clipboardData, o = Qn.$getSelection(), t === null || o === null))
    return !1;
  n = Z$e(e), e = Q$e(e);
  let r = "";
  return o !== null && (r = o.getTextContent()), n !== null && t.setData("text/html", n), e !== null && t.setData("application/x-lexical-editor", e), t.setData("text/plain", r), !0;
}
q_.$generateJSONFromSelectedNodes = X$e;
q_.$generateNodesFromSerializedNodes = ewe;
q_.$getHtmlContent = Z$e;
q_.$getLexicalContent = Q$e;
q_.$insertDataTransferForPlainText = function(e, t) {
  e = e.getData("text/plain"), e != null && t.insertRawText(e);
};
q_.$insertDataTransferForRichText = function(e, t, n) {
  var o = e.getData("application/x-lexical-editor");
  if (o)
    try {
      let i = JSON.parse(o);
      if (i.namespace === n._config.namespace && Array.isArray(i.nodes)) {
        let a = ewe(i.nodes);
        return XL(n, a, t);
      }
    } catch {
    }
  if (o = e.getData("text/html"))
    try {
      var r = new DOMParser().parseFromString(o, "text/html");
      let i = Y$e.$generateNodesFromDOM(n, r);
      return XL(n, i, t);
    } catch {
    }
  if (e = e.getData("text/plain"), e != null)
    if (Qn.$isRangeSelection(t))
      for (e = e.split(/\r?\n/), n = e.length, r = 0; r < n; r++)
        t.insertText(e[r]), r < n - 1 && t.insertParagraph();
    else
      t.insertRawText(e);
};
q_.$insertGeneratedNodes = XL;
q_.copyToClipboard = async function(e, t) {
  if (lh !== null)
    return !1;
  if (t !== null)
    return new Promise((i) => {
      e.update(() => {
        i(oee(e, t));
      });
    });
  var n = e.getRootElement();
  let o = document.getSelection();
  if (n === null || o === null)
    return !1;
  let r = document.createElement("span");
  return r.style.cssText = "position: fixed; top: -1000px;", r.append(document.createTextNode("#")), n.append(r), n = new Range(), n.setStart(r, 0), n.setEnd(r, 1), o.removeAllRanges(), o.addRange(n), new Promise((i) => {
    let a = e.registerCommand(Qn.COPY_COMMAND, (s) => (s instanceof ClipboardEvent && (a(), lh !== null && (window.clearTimeout(lh), lh = null), i(oee(e, s))), !0), Qn.COMMAND_PRIORITY_CRITICAL);
    lh = window.setTimeout(() => {
      a(), lh = null, i(!1);
    }, 50), document.execCommand("copy"), r.remove();
  });
};
const Bed = q_;
var Ued = Bed, hT = Ued, rS = b_, ev = za, Qe = yn;
function ree(e, t) {
  return typeof document.caretRangeFromPoint < "u" ? (e = document.caretRangeFromPoint(e, t), e === null ? null : { node: e.startContainer, offset: e.startOffset }) : document.caretPositionFromPoint !== "undefined" ? (e = document.caretPositionFromPoint(e, t), e === null ? null : { node: e.offsetNode, offset: e.offset }) : null;
}
let Ab = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Wed = Ab && "documentMode" in document ? document.documentMode : null, Ged = Ab && "InputEvent" in window && !Wed ? "getTargetRanges" in new window.InputEvent("input") : !1, Hed = Ab && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), Ked = Ab && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Yed = Ab && /^(?=.*Chrome).*/i.test(navigator.userAgent), Zed = Ab && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !Yed, eq = Qe.createCommand("DRAG_DROP_PASTE_FILE"), C8 = class twe extends Qe.ElementNode {
  static getType() {
    return "quote";
  }
  static clone(t) {
    return new twe(t.__key);
  }
  constructor(t) {
    super(t);
  }
  createDOM(t) {
    let n = document.createElement("blockquote");
    return ev.addClassNamesToElement(n, t.theme.quote), n;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { blockquote: () => ({ conversion: Qed, priority: 0 }) };
  }
  static importJSON(t) {
    let n = z8();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "quote" };
  }
  insertNewAfter(t, n) {
    t = Qe.$createParagraphNode();
    let o = this.getDirection();
    return t.setDirection(o), this.insertAfter(t, n), t;
  }
  collapseAtStart() {
    let t = Qe.$createParagraphNode();
    return this.getChildren().forEach((n) => t.append(n)), this.replace(t), !0;
  }
};
function z8() {
  return Qe.$applyNodeReplacement(new C8());
}
let O8 = class nwe extends Qe.ElementNode {
  static getType() {
    return "heading";
  }
  static clone(t) {
    return new nwe(t.__tag, t.__key);
  }
  constructor(t, n) {
    super(n), this.__tag = t;
  }
  getTag() {
    return this.__tag;
  }
  createDOM(t) {
    let n = this.__tag, o = document.createElement(n);
    return t = t.theme.heading, t !== void 0 && ev.addClassNamesToElement(o, t[n]), o;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { h1: () => ({ conversion: dh, priority: 0 }), h2: () => ({ conversion: dh, priority: 0 }), h3: () => ({ conversion: dh, priority: 0 }), h4: () => ({ conversion: dh, priority: 0 }), h5: () => ({
      conversion: dh,
      priority: 0
    }), h6: () => ({ conversion: dh, priority: 0 }), p: (t) => (t = t.firstChild, t !== null && iee(t) ? { conversion: () => ({ node: null }), priority: 3 } : null), span: (t) => iee(t) ? { conversion: () => ({ node: Ch("h1") }), priority: 3 } : null };
  }
  static importJSON(t) {
    let n = Ch(t.tag);
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), tag: this.getTag(), type: "heading", version: 1 };
  }
  insertNewAfter(t, n = !0) {
    t = t ? t.anchor.offset : 0, t = 0 < t && t < this.getTextContentSize() ? Ch(this.getTag()) : Qe.$createParagraphNode();
    let o = this.getDirection();
    return t.setDirection(o), this.insertAfter(t, n), t;
  }
  collapseAtStart() {
    let t = this.isEmpty() ? Qe.$createParagraphNode() : Ch(this.getTag());
    return this.getChildren().forEach((n) => t.append(n)), this.replace(t), !0;
  }
  extractWithChild() {
    return !0;
  }
};
function iee(e) {
  return e.nodeName.toLowerCase() === "span" ? e.style.fontSize === "26pt" : !1;
}
function dh(e) {
  e = e.nodeName.toLowerCase();
  let t = null;
  return (e === "h1" || e === "h2" || e === "h3" || e === "h4" || e === "h5" || e === "h6") && (t = Ch(e)), { node: t };
}
function Qed() {
  return { node: z8() };
}
function Ch(e) {
  return Qe.$applyNodeReplacement(new O8(e));
}
function Jed(e, t) {
  e.preventDefault(), t.update(() => {
    let n = Qe.$getSelection(), o = e instanceof InputEvent || e instanceof KeyboardEvent ? null : e.clipboardData;
    o != null && (Qe.$isRangeSelection(n) || Qe.DEPRECATED_$isGridSelection(n)) && hT.$insertDataTransferForRichText(o, n, t);
  }, { tag: "paste" });
}
async function Xed(e, t) {
  await hT.copyToClipboard(t, e instanceof ClipboardEvent ? e : null), t.update(() => {
    let n = Qe.$getSelection();
    Qe.$isRangeSelection(n) ? n.removeText() : Qe.$isNodeSelection(n) && n.getNodes().forEach((o) => o.remove());
  });
}
function y$(e) {
  let t = null;
  if (e instanceof DragEvent ? t = e.dataTransfer : e instanceof ClipboardEvent && (t = e.clipboardData), t === null)
    return [!1, [], !1];
  var n = t.types;
  return e = n.includes("Files"), n = n.includes("text/html") || n.includes("text/plain"), [e, Array.from(t.files), n];
}
function aee(e, t) {
  var n = Qe.$getSelection();
  if (Qe.$isRangeSelection(n)) {
    var o = /* @__PURE__ */ new Set();
    n = n.getNodes();
    for (let r = 0; r < n.length; r++) {
      let i = n[r], a = i.getKey();
      if (o.has(a))
        continue;
      let s = ev.$getNearestBlockElementAncestorOrThrow(i), c = s.getKey();
      s.canInsertTab() ? (e(i), o.add(a)) : s.canIndent() && !o.has(c) && (o.add(c), t(s));
    }
  }
}
function iS(e) {
  return e = Qe.$getNearestNodeFromDOMNode(e), Qe.$isDecoratorNode(e);
}
$u.$createHeadingNode = Ch;
$u.$createQuoteNode = z8;
$u.$isHeadingNode = function(e) {
  return e instanceof O8;
};
$u.$isQuoteNode = function(e) {
  return e instanceof C8;
};
$u.DRAG_DROP_PASTE = eq;
$u.HeadingNode = O8;
$u.QuoteNode = C8;
$u.eventFiles = y$;
$u.registerRichText = function(e) {
  return ev.mergeRegister(
    e.registerCommand(Qe.CLICK_COMMAND, () => {
      const t = Qe.$getSelection();
      return Qe.$isNodeSelection(t) ? (t.clear(), !0) : !1;
    }, 0),
    e.registerCommand(Qe.DELETE_CHARACTER_COMMAND, (t) => {
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (n.deleteCharacter(t), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.DELETE_WORD_COMMAND, (t) => {
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (n.deleteWord(t), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.DELETE_LINE_COMMAND, (t) => {
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (n.deleteLine(t), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.CONTROLLED_TEXT_INSERTION_COMMAND, (t) => {
      const n = Qe.$getSelection();
      if (typeof t == "string")
        Qe.$isRangeSelection(n) ? n.insertText(t) : Qe.DEPRECATED_$isGridSelection(n);
      else {
        if (!Qe.$isRangeSelection(n) && !Qe.DEPRECATED_$isGridSelection(n))
          return !1;
        const o = t.dataTransfer;
        o != null ? hT.$insertDataTransferForRichText(o, n, e) : Qe.$isRangeSelection(n) && (t = t.data) && n.insertText(t);
      }
      return !0;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.REMOVE_TEXT_COMMAND, () => {
      const t = Qe.$getSelection();
      return Qe.$isRangeSelection(t) ? (t.removeText(), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.FORMAT_TEXT_COMMAND, (t) => {
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (n.formatText(t), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.FORMAT_ELEMENT_COMMAND, (t) => {
      var n = Qe.$getSelection();
      if (!Qe.$isRangeSelection(n) && !Qe.$isNodeSelection(n))
        return !1;
      n = n.getNodes();
      for (const o of n)
        ev.$getNearestBlockElementAncestorOrThrow(o).setFormat(t);
      return !0;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.INSERT_LINE_BREAK_COMMAND, (t) => {
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (n.insertLineBreak(t), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.INSERT_PARAGRAPH_COMMAND, () => {
      const t = Qe.$getSelection();
      return Qe.$isRangeSelection(t) ? (t.insertParagraph(), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      Qe.INDENT_CONTENT_COMMAND,
      () => (aee(() => {
        e.dispatchCommand(Qe.CONTROLLED_TEXT_INSERTION_COMMAND, "	");
      }, (t) => {
        const n = t.getIndent();
        n !== 10 && t.setIndent(n + 1);
      }), !0),
      Qe.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Qe.OUTDENT_CONTENT_COMMAND, () => (aee((t) => {
      Qe.$isTextNode(t) && (t = t.getTextContent(), t[t.length - 1] === "	" && e.dispatchCommand(Qe.DELETE_CHARACTER_COMMAND, !0));
    }, (t) => {
      const n = t.getIndent();
      n !== 0 && t.setIndent(n - 1);
    }), !0), Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_ARROW_UP_COMMAND, (t) => {
      var n = Qe.$getSelection();
      if (Qe.$isNodeSelection(n) && !iS(t.target)) {
        if (t = n.getNodes(), 0 < t.length)
          return t[0].selectPrevious(), !0;
      } else if (Qe.$isRangeSelection(n)) {
        if (n = Qe.$getAdjacentNode(n.focus, !0), Qe.$isDecoratorNode(n) && !n.isIsolated() && !n.isInline())
          return n.selectPrevious(), t.preventDefault(), !0;
        if (Qe.$isElementNode(n) && !n.isInline() && !n.canBeEmpty())
          return n.select(), t.preventDefault(), !0;
      }
      return !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_ARROW_DOWN_COMMAND, (t) => {
      var n = Qe.$getSelection();
      if (Qe.$isNodeSelection(n)) {
        if (t = n.getNodes(), 0 < t.length)
          return t[0].selectNext(
            0,
            0
          ), !0;
      } else if (Qe.$isRangeSelection(n)) {
        let o = n.focus;
        if (o.key === "root" && o.offset === Qe.$getRoot().getChildrenSize())
          return t.preventDefault(), !0;
        if (n = Qe.$getAdjacentNode(n.focus, !1), Qe.$isDecoratorNode(n) && !n.isIsolated() && !n.isInline())
          return n.selectNext(), t.preventDefault(), !0;
      }
      return !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_ARROW_LEFT_COMMAND, (t) => {
      const n = Qe.$getSelection();
      if (Qe.$isNodeSelection(n)) {
        var o = n.getNodes();
        if (0 < o.length)
          return t.preventDefault(), o[0].selectPrevious(), !0;
      }
      return Qe.$isRangeSelection(n) && rS.$shouldOverrideDefaultCharacterSelection(n, !0) ? (o = t.shiftKey, t.preventDefault(), rS.$moveCharacter(n, o, !0), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_ARROW_RIGHT_COMMAND, (t) => {
      const n = Qe.$getSelection();
      if (Qe.$isNodeSelection(n) && !iS(t.target)) {
        var o = n.getNodes();
        if (0 < o.length)
          return t.preventDefault(), o[0].selectNext(0, 0), !0;
      }
      return Qe.$isRangeSelection(n) ? (o = t.shiftKey, rS.$shouldOverrideDefaultCharacterSelection(n, !1) ? (t.preventDefault(), rS.$moveCharacter(n, o, !1), !0) : !1) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_BACKSPACE_COMMAND, (t) => {
      if (iS(t.target))
        return !1;
      const n = Qe.$getSelection();
      if (!Qe.$isRangeSelection(n))
        return !1;
      t.preventDefault(), { anchor: t } = n;
      const o = t.getNode();
      return n.isCollapsed() && t.offset === 0 && !Qe.$isRootNode(o) && 0 < ev.$getNearestBlockElementAncestorOrThrow(o).getIndent() ? e.dispatchCommand(Qe.OUTDENT_CONTENT_COMMAND, void 0) : e.dispatchCommand(Qe.DELETE_CHARACTER_COMMAND, !0);
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_DELETE_COMMAND, (t) => {
      if (iS(t.target))
        return !1;
      const n = Qe.$getSelection();
      return Qe.$isRangeSelection(n) ? (t.preventDefault(), e.dispatchCommand(Qe.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.KEY_ENTER_COMMAND, (t) => {
      const n = Qe.$getSelection();
      if (!Qe.$isRangeSelection(n))
        return !1;
      if (t !== null) {
        if ((Ked || Hed || Zed) && Ged)
          return !1;
        if (t.preventDefault(), t.shiftKey)
          return e.dispatchCommand(Qe.INSERT_LINE_BREAK_COMMAND, !1);
      }
      return e.dispatchCommand(Qe.INSERT_PARAGRAPH_COMMAND, void 0);
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      Qe.KEY_ESCAPE_COMMAND,
      () => {
        const t = Qe.$getSelection();
        return Qe.$isRangeSelection(t) ? (e.blur(), !0) : !1;
      },
      Qe.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Qe.DROP_COMMAND, (t) => {
      const [, n] = y$(t);
      if (0 < n.length) {
        var o = ree(t.clientX, t.clientY);
        if (o !== null) {
          const { offset: i, node: a } = o;
          var r = Qe.$getNearestNodeFromDOMNode(a);
          if (r !== null) {
            if (o = Qe.$createRangeSelection(), Qe.$isTextNode(r))
              o.anchor.set(r.getKey(), i, "text"), o.focus.set(r.getKey(), i, "text");
            else {
              const s = r.getParentOrThrow().getKey();
              r = r.getIndexWithinParent() + 1, o.anchor.set(
                s,
                r,
                "element"
              ), o.focus.set(s, r, "element");
            }
            o = Qe.$normalizeSelection__EXPERIMENTAL(o), Qe.$setSelection(o);
          }
          e.dispatchCommand(eq, n);
        }
        return t.preventDefault(), !0;
      }
      return t = Qe.$getSelection(), !!Qe.$isRangeSelection(t);
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.DRAGSTART_COMMAND, (t) => {
      [t] = y$(t);
      const n = Qe.$getSelection();
      return !(t && !Qe.$isRangeSelection(n));
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.DRAGOVER_COMMAND, (t) => {
      var [n] = y$(t);
      const o = Qe.$getSelection();
      return n && !Qe.$isRangeSelection(o) ? !1 : (n = ree(t.clientX, t.clientY), n !== null && (n = Qe.$getNearestNodeFromDOMNode(n.node), Qe.$isDecoratorNode(n) && t.preventDefault()), !0);
    }, Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.COPY_COMMAND, (t) => (hT.copyToClipboard(e, t instanceof ClipboardEvent ? t : null), !0), Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.CUT_COMMAND, (t) => (Xed(t, e), !0), Qe.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Qe.PASTE_COMMAND, (t) => {
      const [, n, o] = y$(t);
      if (0 < n.length && !o)
        return e.dispatchCommand(eq, n), !0;
      const r = Qe.$getSelection();
      return Qe.$isRangeSelection(r) || Qe.DEPRECATED_$isGridSelection(r) ? (Jed(t, e), !0) : !1;
    }, Qe.COMMAND_PRIORITY_EDITOR)
  );
};
const etd = $u;
var Rf = etd, Lo = yn, ew = KL, Ca = ul, Ip = Rf, ttd = za, F5 = vl;
function tq(e, t) {
  let n = {};
  for (let o of e)
    e = t(o), n[e] ? n[e].push(o) : n[e] = [o];
  return n;
}
function P8(e) {
  return e = tq(e, (t) => t.type), { element: e.element || [], textFormat: e["text-format"] || [], textMatch: e["text-match"] || [] };
}
let vT = /[!-/:-@[-`{-~\s]/;
function ntd(e) {
  let t = P8(e), n = t.textFormat.filter((o) => o.format.length === 1);
  return (o) => {
    let r = [];
    o = (o || Lo.$getRoot()).getChildren();
    for (let i of o)
      o = otd(i, t.element, n, t.textMatch), o != null && r.push(o);
    return r.join(`

`);
  };
}
function otd(e, t, n, o) {
  for (let r of t)
    if (t = r.export(e, (i) => bT(i, n, o)), t != null)
      return t;
  return Lo.$isElementNode(e) ? bT(e, n, o) : Lo.$isDecoratorNode(e) ? e.getTextContent() : null;
}
function bT(e, t, n) {
  let o = [];
  e = e.getChildren();
  e:
    for (let r of e) {
      for (let i of n)
        if (e = i.export(r, (a) => bT(a, t, n), (a, s) => see(a, s, t)), e != null) {
          o.push(e);
          continue e;
        }
      Lo.$isLineBreakNode(r) ? o.push(`
`) : Lo.$isTextNode(r) ? o.push(see(r, r.getTextContent(), t)) : Lo.$isElementNode(r) ? o.push(bT(r, t, n)) : Lo.$isDecoratorNode(r) && o.push(r.getTextContent());
    }
  return o.join("");
}
function see(e, t, n) {
  let o = t.trim(), r = o, i = /* @__PURE__ */ new Set();
  for (let s of n) {
    n = s.format[0];
    let c = s.tag;
    if (V5(e, n) && !i.has(n)) {
      i.add(n);
      var a = cee(e, !0);
      V5(a, n) || (r = c + r), a = cee(e, !1), V5(a, n) || (r += c);
    }
  }
  return t.replace(o, r);
}
function cee(e, t) {
  let n = t ? e.getPreviousSibling() : e.getNextSibling();
  for (n || (e = e.getParentOrThrow(), e.isInline() && (n = t ? e.getPreviousSibling() : e.getNextSibling())); n; ) {
    if (Lo.$isElementNode(n)) {
      if (!n.isInline())
        break;
      if (e = t ? n.getLastDescendant() : n.getFirstDescendant(), Lo.$isTextNode(e))
        return e;
      n = t ? n.getPreviousSibling() : n.getNextSibling();
    }
    if (Lo.$isTextNode(n))
      return n;
    if (!Lo.$isElementNode(n))
      break;
  }
  return null;
}
function V5(e, t) {
  return Lo.$isTextNode(e) && e.hasFormat(t);
}
let Cb = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", rtd = Cb && "documentMode" in document ? document.documentMode : null;
Cb && "InputEvent" in window && !rtd && "getTargetRanges" in new window.InputEvent("input");
let lee = Cb && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), dee = Cb && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, itd = Cb && /^(?=.*Chrome).*/i.test(navigator.userAgent), uee = Cb && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !itd, atd = /^\s{0,3}$/, _ee = /^```(\w{1,10})?\s?$/;
function std(e) {
  let t = P8(e), n = ltd(t.textFormat);
  return (o, r) => {
    o = o.split(`
`);
    var i = o.length;
    r = r || Lo.$getRoot(), r.clear();
    for (let f = 0; f < i; f++) {
      var a = o[f];
      e: {
        var s = o, c = f, l = r, d = s[c].match(_ee);
        if (d) {
          for (var u = c, _ = s.length; ++u < _; )
            if (s[u].match(_ee)) {
              d = ew.$createCodeNode(d[1]), s = Lo.$createTextNode(s.slice(c + 1, u).join(`
`)), d.append(s), l.append(d), l = [d, u];
              break e;
            }
        }
        l = [null, c];
      }
      let [g, h] = l;
      if (g != null)
        f = h;
      else {
        l = a, _ = r;
        var p = t.element;
        u = n, s = t.textMatch, c = l.trim(), d = Lo.$createTextNode(c), a = Lo.$createParagraphNode(), a.append(d), _.append(a);
        for (let { regExp: b, replace: v } of p)
          if (_ = l.match(b)) {
            d.setTextContent(l.slice(_[0].length)), v(a, [d], _, !0);
            break;
          }
        dx(d, u, s), a.isAttached() && 0 < c.length && (l = a.getPreviousSibling(), Lo.$isParagraphNode(l) || Ip.$isQuoteNode(l) || Ca.$isListNode(l)) && (u = l, Ca.$isListNode(l) && (l = l.getLastDescendant(), u = l == null ? null : ttd.$findMatchingParent(l, Ca.$isListItemNode)), u != null && 0 < u.getTextContentSize() && (u.splice(u.getChildrenSize(), 0, [Lo.$createLineBreakNode(), ...a.getChildren()]), a.remove()));
      }
    }
    o = r.getChildren();
    for (let f of o)
      o = f, Lo.$isParagraphNode(o) ? (i = o.getFirstChild(), o = i == null || o.getChildrenSize() === 1 && Lo.$isTextNode(i) && atd.test(i.getTextContent())) : o = !1, o && f.remove();
  };
}
function dx(e, t, n) {
  var o = e.getTextContent();
  let r = ctd(o, t);
  if (r) {
    var i, a;
    if (r[0] === o)
      var s = e;
    else {
      o = r.index || 0;
      let c = o + r[0].length;
      o === 0 ? [s, i] = e.splitText(c) : [a, s, i] = e.splitText(o, c);
    }
    if (s.setTextContent(r[2]), e = t.transformersByTag[r[1]])
      for (let c of e.format)
        s.hasFormat(c) || s.toggleFormat(c);
    s.hasFormat("code") || dx(s, t, n), a && dx(a, t, n), i && dx(i, t, n);
  } else
    owe(e, n);
}
function owe(e, t) {
  e:
    for (; e; ) {
      for (let n of t) {
        let o = e.getTextContent().match(n.importRegExp);
        if (!o)
          continue;
        let r = o.index || 0, i = r + o[0].length, a, s, c;
        r === 0 ? [a, e] = e.splitText(i) : [s, a, c] = e.splitText(r, i), s && owe(s, t), c && (e = c), n.replace(a, o);
        continue e;
      }
      break;
    }
}
function ctd(e, t) {
  var n = e.match(t.openTagsRegExp);
  if (n == null)
    return null;
  for (let i of n) {
    var o = i.replace(/^\s/, "");
    if (n = t.fullMatchRegExpByTag[o], n != null && (n = e.match(n), o = t.transformersByTag[o], n != null && o != null)) {
      if (o.intraword !== !1)
        return n;
      var { index: r = 0 } = n;
      if (o = e[r - 1], r = e[r + n[0].length], !(o && !vT.test(o) || r && !vT.test(r)))
        return n;
    }
  }
  return null;
}
function ltd(e) {
  let t = {}, n = {}, o = [];
  for (let r of e) {
    ({ tag: e } = r), t[e] = r;
    let i = e.replace(/(\*|\^|\+)/g, "\\$1");
    o.push(i), n[e] = lee || dee || uee ? new RegExp(`(${i})(?![${i}\\s])(.*?[^${i}\\s])${i}(?!${i})`) : new RegExp(`(?<![\\\\${i}])(${i})((\\\\${i})?.*?[^${i}\\s](\\\\${i})?)((?<!\\\\)|(?<=\\\\\\\\))(${i})(?![\\\\${i}])`);
  }
  return { fullMatchRegExpByTag: n, openTagsRegExp: new RegExp((lee || dee || uee ? "" : "(?<![\\\\])") + "(" + o.join("|") + ")", "g"), transformersByTag: t };
}
function pee(e, t, n) {
  let o = n.length;
  for (; t >= o; t--) {
    let r = t - o;
    if (rwe(e, r, n, 0, o) && e[r + o] !== " ")
      return r;
  }
  return -1;
}
function rwe(e, t, n, o, r) {
  for (let i = 0; i < r; i++)
    if (e[t + i] !== n[o + i])
      return !1;
  return !0;
}
let iwe = (e) => (t, n, o) => {
  o = e(o), o.append(...n), t.replace(o), o.select(0, 0);
}, I8 = (e) => (t, n, o) => {
  var r = t.getPreviousSibling();
  const i = Ca.$createListItemNode(e === "check" ? o[3] === "x" : void 0);
  Ca.$isListNode(r) && r.getListType() === e ? (r.append(i), t.remove()) : (r = Ca.$createListNode(e, e === "number" ? Number(o[2]) : void 0), r.append(i), t.replace(r)), i.append(...n), i.select(0, 0), (t = Math.floor(o[1].length / 4)) && i.setIndent(t);
}, GC = (e, t, n) => {
  const o = [];
  var r = e.getChildren();
  let i = 0;
  for (const s of r)
    if (Ca.$isListItemNode(s)) {
      if (s.getChildrenSize() === 1 && (r = s.getFirstChild(), Ca.$isListNode(r))) {
        o.push(GC(r, t, n + 1));
        continue;
      }
      r = " ".repeat(4 * n);
      var a = e.getListType();
      a = a === "number" ? `${e.getStart() + i}. ` : a === "check" ? `- [${s.getChecked() ? "x" : " "}] ` : "- ", o.push(r + a + t(s)), i++;
    }
  return o.join(`
`);
}, awe = { dependencies: [Ip.HeadingNode], export: (e, t) => {
  if (!Ip.$isHeadingNode(e))
    return null;
  const n = Number(e.getTag().slice(1));
  return "#".repeat(n) + " " + t(e);
}, regExp: /^(#{1,6})\s/, replace: iwe((e) => Ip.$createHeadingNode("h" + e[1].length)), type: "element" }, swe = {
  dependencies: [Ip.QuoteNode],
  export: (e, t) => {
    if (!Ip.$isQuoteNode(e))
      return null;
    e = t(e).split(`
`), t = [];
    for (const n of e)
      t.push("> " + n);
    return t.join(`
`);
  },
  regExp: /^>\s/,
  replace: (e, t, n, o) => {
    if (o && (n = e.getPreviousSibling(), Ip.$isQuoteNode(n))) {
      n.splice(n.getChildrenSize(), 0, [Lo.$createLineBreakNode(), ...t]), n.select(0, 0), e.remove();
      return;
    }
    n = Ip.$createQuoteNode(), n.append(...t), e.replace(n), n.select(0, 0);
  },
  type: "element"
}, cwe = { dependencies: [ew.CodeNode], export: (e) => {
  if (!ew.$isCodeNode(e))
    return null;
  const t = e.getTextContent();
  return "```" + (e.getLanguage() || "") + (t ? `
` + t : "") + "\n```";
}, regExp: /^```(\w{1,10})?\s/, replace: iwe((e) => ew.$createCodeNode(e ? e[1] : void 0)), type: "element" }, lwe = { dependencies: [Ca.ListNode, Ca.ListItemNode], export: (e, t) => Ca.$isListNode(e) ? GC(e, t, 0) : null, regExp: /^(\s*)[-*+]\s/, replace: I8("bullet"), type: "element" }, dtd = { dependencies: [Ca.ListNode, Ca.ListItemNode], export: (e, t) => Ca.$isListNode(e) ? GC(e, t, 0) : null, regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i, replace: I8("check"), type: "element" }, dwe = { dependencies: [Ca.ListNode, Ca.ListItemNode], export: (e, t) => Ca.$isListNode(e) ? GC(e, t, 0) : null, regExp: /^(\s*)(\d{1,})\.\s/, replace: I8("number"), type: "element" }, uwe = { format: ["code"], tag: "`", type: "text-format" }, _we = { format: ["highlight"], tag: "==", type: "text-format" }, pwe = { format: ["bold", "italic"], tag: "***", type: "text-format" }, mwe = { format: ["bold", "italic"], intraword: !1, tag: "___", type: "text-format" }, fwe = { format: ["bold"], tag: "**", type: "text-format" }, gwe = { format: ["bold"], intraword: !1, tag: "__", type: "text-format" }, hwe = { format: ["strikethrough"], tag: "~~", type: "text-format" }, vwe = { format: ["italic"], tag: "*", type: "text-format" }, bwe = { format: ["italic"], intraword: !1, tag: "_", type: "text-format" }, ywe = { dependencies: [F5.LinkNode], export: (e, t, n) => {
  if (!F5.$isLinkNode(e))
    return null;
  t = `[${e.getTextContent()}](${e.getURL()})`;
  const o = e.getFirstChild();
  return e.getChildrenSize() === 1 && Lo.$isTextNode(o) ? n(o, t) : t;
}, importRegExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))/, regExp: /(?:\[([^[]+)\])(?:\(([^()]+)\))$/, replace: (e, t) => {
  const [, n, o] = t;
  t = F5.$createLinkNode(o);
  const r = Lo.$createTextNode(n);
  r.setFormat(e.getFormat()), t.append(r), e.replace(t);
}, trigger: ")", type: "text-match" }, $we = [awe, swe, cwe, lwe, dwe], wwe = [uwe, pwe, mwe, fwe, gwe, _we, vwe, bwe, hwe], kwe = [ywe], HC = [...$we, ...wwe, ...kwe];
ni.$convertFromMarkdownString = function(e, t = HC, n) {
  return std(t)(e, n);
};
ni.$convertToMarkdownString = function(e = HC, t) {
  return ntd(e)(t);
};
ni.BOLD_ITALIC_STAR = pwe;
ni.BOLD_ITALIC_UNDERSCORE = mwe;
ni.BOLD_STAR = fwe;
ni.BOLD_UNDERSCORE = gwe;
ni.CHECK_LIST = dtd;
ni.CODE = cwe;
ni.ELEMENT_TRANSFORMERS = $we;
ni.HEADING = awe;
ni.HIGHLIGHT = _we;
ni.INLINE_CODE = uwe;
ni.ITALIC_STAR = vwe;
ni.ITALIC_UNDERSCORE = bwe;
ni.LINK = ywe;
ni.ORDERED_LIST = dwe;
ni.QUOTE = swe;
ni.STRIKETHROUGH = hwe;
ni.TEXT_FORMAT_TRANSFORMERS = wwe;
ni.TEXT_MATCH_TRANSFORMERS = kwe;
ni.TRANSFORMERS = HC;
ni.UNORDERED_LIST = lwe;
ni.registerMarkdownShortcuts = function(e, t = HC) {
  let n = P8(t), o = tq(n.textFormat, ({ tag: i }) => i[i.length - 1]), r = tq(n.textMatch, ({ trigger: i }) => i);
  for (let i of t)
    if (t = i.type, (t === "element" || t === "text-match") && !e.hasNodes(i.dependencies))
      throw Error("Minified Lexical error #79; visit https://lexical.dev/docs/error?code=79 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  return e.registerUpdateListener(({ tags: i, dirtyLeaves: a, editorState: s, prevEditorState: c }) => {
    if (!i.has("historic")) {
      var l = s.read(Lo.$getSelection);
      if (i = c.read(Lo.$getSelection), Lo.$isRangeSelection(i) && Lo.$isRangeSelection(l) && l.isCollapsed()) {
        c = l.anchor.key;
        var d = l.anchor.offset, u = s._nodeMap.get(c);
        Lo.$isTextNode(u) && a.has(c) && (d === 1 || d === i.anchor.offset + 1) && e.update(() => {
          if (!u.hasFormat("code")) {
            var _ = u.getParent();
            if (_ !== null && !ew.$isCodeNode(_)) {
              var p = l.anchor.offset;
              e: {
                var f = n.element, g = _.getParent();
                if (Lo.$isRootOrShadowRoot(g) && _.getFirstChild() === u && (g = u.getTextContent(), g[p - 1] === " ")) {
                  for (let {
                    regExp: S,
                    replace: O
                  } of f)
                    if ((f = g.match(S)) && f[0].length === p) {
                      g = u.getNextSiblings();
                      let [I, D] = u.splitText(p);
                      I.remove(), g = D ? [D, ...g] : g, O(_, g, f, !1), _ = !0;
                      break e;
                    }
                }
                _ = !1;
              }
              if (!_) {
                e: {
                  if (f = u.getTextContent(), _ = r[f[p - 1]], _ != null) {
                    p < f.length && (f = f.slice(0, p));
                    for (b of _)
                      if (_ = f.match(b.regExp), _ !== null) {
                        f = _.index || 0, g = f + _[0].length;
                        var h = void 0;
                        f === 0 ? [h] = u.splitText(g) : [, h] = u.splitText(f, g), h.selectNext(0, 0), b.replace(h, _);
                        var b = !0;
                        break e;
                      }
                  }
                  b = !1;
                }
                if (!b)
                  e: {
                    g = u.getTextContent(), --p;
                    var v = g[p];
                    if (b = o[v])
                      for (let S of b) {
                        var { tag: $ } = S;
                        b = $.length;
                        let O = p - b + 1;
                        if (!(1 < b && !rwe(g, O, $, 0, b) || g[O - 1] === " ") && (h = g[p + 1], S.intraword !== !1 || !h || vT.test(h))) {
                          _ = h = u, f = pee(g, O, $);
                          for (var k = _; 0 > f && (k = k.getPreviousSibling()) && !Lo.$isLineBreakNode(k); )
                            Lo.$isTextNode(k) && (f = k.getTextContent(), _ = k, f = pee(f, f.length, $));
                          if (!(0 > f || _ === h && f + b === O || ($ = _.getTextContent(), 0 < f && $[f - 1] === v || (k = $[f - 1], S.intraword === !1 && k && !vT.test(k))))) {
                            g = h.getTextContent(), g = g.slice(0, O) + g.slice(p + 1), h.setTextContent(g), g = _ === h ? g : $, _.setTextContent(g.slice(0, f) + g.slice(f + b)), g = Lo.$getSelection(), v = Lo.$createRangeSelection(), Lo.$setSelection(v), p = p - b * (_ === h ? 2 : 1) + 1, v.anchor.set(_.__key, f, "text"), v.focus.set(h.__key, p, "text");
                            for (let I of S.format)
                              v.hasFormat(I) || v.formatText(I);
                            v.anchor.set(v.focus.key, v.focus.offset, v.focus.type);
                            for (let I of S.format)
                              v.hasFormat(I) && v.toggleFormat(I);
                            Lo.$isRangeSelection(g) && (v.format = g.format);
                            break e;
                          }
                        }
                      }
                  }
              }
            }
          }
        });
      }
    }
  });
};
const utd = ni;
var nq = utd, Swe = {}, KC = {}, xwe = ve;
let Ewe = xwe.createContext(null);
KC.LexicalComposerContext = Ewe;
KC.createLexicalComposerContext = function(e, t) {
  let n = null;
  return e != null && (n = e[1]), { getTheme: function() {
    return t ?? (n != null ? n.getTheme() : null);
  } };
};
KC.useLexicalComposerContext = function() {
  let e = xwe.useContext(Ewe);
  if (e == null)
    throw Error("Minified Lexical error #8; visit https://lexical.dev/docs/error?code=8 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
  return e;
};
const _td = KC;
var Ia = _td, mee = Ia, $$ = yn, yT = ve;
let Twe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
var ptd = Twe ? yT.useLayoutEffect : yT.useEffect;
let aS = { tag: "history-merge" };
function mtd(e, t) {
  if (t !== null) {
    if (t === void 0)
      e.update(() => {
        var n = $$.$getRoot();
        if (n.isEmpty()) {
          let o = $$.$createParagraphNode();
          n.append(o), n = Twe ? document.activeElement : null, ($$.$getSelection() !== null || n !== null && n === e.getRootElement()) && o.select();
        }
      }, aS);
    else if (t !== null)
      switch (typeof t) {
        case "string":
          let n = e.parseEditorState(t);
          e.setEditorState(n, aS);
          break;
        case "object":
          e.setEditorState(t, aS);
          break;
        case "function":
          e.update(() => {
            $$.$getRoot().isEmpty() && t(e);
          }, aS);
      }
  }
}
Swe.LexicalComposer = function({ initialConfig: e, children: t }) {
  let n = yT.useMemo(() => {
    const { theme: o, namespace: r, editor__DEPRECATED: i, nodes: a, onError: s, editorState: c } = e, l = mee.createLexicalComposerContext(null, o);
    let d = i || null;
    if (d === null) {
      const u = $$.createEditor({ editable: !1, namespace: r, nodes: a, onError: (_) => s(_, u), theme: o });
      mtd(u, c), d = u;
    }
    return [d, l];
  }, []);
  return ptd(() => {
    let o = e.editable, [r] = n;
    r.setEditable(o !== void 0 ? o : !0);
  }, []), yT.createElement(mee.LexicalComposerContext.Provider, { value: n }, t);
};
const ftd = Swe;
var gtd = ftd, Awe = {}, htd = Ia, tw = ve, vtd = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? tw.useLayoutEffect : tw.useEffect;
Awe.ContentEditable = function({ ariaActiveDescendant: e, ariaAutoComplete: t, ariaControls: n, ariaDescribedBy: o, ariaExpanded: r, ariaLabel: i, ariaLabelledBy: a, ariaMultiline: s, ariaOwns: c, ariaRequired: l, autoCapitalize: d, className: u, id: _, role: p = "textbox", spellCheck: f = !0, style: g, tabIndex: h, "data-testid": b }) {
  let [v] = htd.useLexicalComposerContext(), [$, k] = tw.useState(!1), S = tw.useCallback((O) => {
    v.setRootElement(O);
  }, [v]);
  return vtd(() => (k(v.isEditable()), v.registerEditableListener((O) => {
    k(O);
  })), [v]), tw.createElement(
    "div",
    { "aria-activedescendant": $ ? e : void 0, "aria-autocomplete": $ ? t : "none", "aria-controls": $ ? n : void 0, "aria-describedby": o, "aria-expanded": $ && p === "combobox" ? !!r : void 0, "aria-label": i, "aria-labelledby": a, "aria-multiline": s, "aria-owns": $ ? c : void 0, "aria-required": l, autoCapitalize: d, className: u, contentEditable: $, "data-testid": b, id: _, ref: S, role: $ ? p : void 0, spellCheck: f, style: g, tabIndex: h }
  );
};
const btd = Awe;
var ytd = btd, nw = ve;
function oq(e, t) {
  return oq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, oq(e, t);
}
function $td(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, oq(e, t);
}
function wtd(e, t) {
  return e === void 0 && (e = []), t === void 0 && (t = []), e.length !== t.length || e.some(function(n, o) {
    return !Object.is(n, t[o]);
  });
}
var fee = { error: null }, ktd = function(e) {
  function t() {
    for (var o, r = arguments.length, i = Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    return o = e.call.apply(e, [this].concat(i)) || this, o.state = fee, o.resetErrorBoundary = function() {
      for (var s, c = arguments.length, l = Array(c), d = 0; d < c; d++)
        l[d] = arguments[d];
      o.props.onReset == null || (s = o.props).onReset.apply(s, l), o.reset();
    }, o;
  }
  $td(t, e), t.getDerivedStateFromError = function(o) {
    return { error: o };
  };
  var n = t.prototype;
  return n.reset = function() {
    this.setState(fee);
  }, n.componentDidCatch = function(o, r) {
    var i, a;
    (i = (a = this.props).onError) == null || i.call(a, o, r);
  }, n.componentDidUpdate = function(o, r) {
    var i = this.props.resetKeys;
    if (this.state.error !== null && r.error !== null && wtd(o.resetKeys, i)) {
      var a, s;
      (a = (s = this.props).onResetKeysChange) == null || a.call(s, o.resetKeys, i), this.reset();
    }
  }, n.render = function() {
    var o = this.state.error, r = this.props, i = r.fallbackRender, a = r.FallbackComponent;
    if (r = r.fallback, o !== null) {
      if (o = { error: o, resetErrorBoundary: this.resetErrorBoundary }, nw.isValidElement(r))
        return r;
      if (typeof i == "function")
        return i(o);
      if (a)
        return nw.createElement(a, o);
      throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, t;
}(nw.Component), Std = function({ children: e, onError: t }) {
  return nw.createElement(ktd, { fallback: nw.createElement("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" } }, "An error was thrown."), onError: t }, e);
};
const xtd = Std;
var Etd = xtd;
const Ttd = /* @__PURE__ */ Zr(Etd);
var R8 = {}, N8 = {}, Atd = za, Ir = yn;
function Ctd(e, t, n, o, r) {
  if (e === null || n.size === 0 && o.size === 0 && !r)
    return 0;
  var i = t._selection, a = e._selection;
  if (r)
    return 1;
  if (!(Ir.$isRangeSelection(i) && Ir.$isRangeSelection(a) && a.isCollapsed() && i.isCollapsed()))
    return 0;
  r = t._nodeMap;
  let s = [];
  for (let c of n)
    n = r.get(c), n !== void 0 && s.push(n);
  for (let [c, l] of o)
    l && (o = r.get(c), o === void 0 || Ir.$isRootNode(o) || s.push(o));
  return s.length === 0 ? 0 : 1 < s.length ? (o = t._nodeMap, t = o.get(i.anchor.key), a = o.get(a.anchor.key), t && a && !e._nodeMap.has(t.__key) && Ir.$isTextNode(t) && t.__text.length === 1 && i.anchor.offset === 1 ? 2 : 0) : (t = s[0], e = e._nodeMap.get(t.__key), !Ir.$isTextNode(e) || !Ir.$isTextNode(t) || e.__mode !== t.__mode || (e = e.__text, t = t.__text, e === t) || (i = i.anchor, a = a.anchor, i.key !== a.key || i.type !== "text") ? 0 : (i = i.offset, a = a.offset, e = t.length - e.length, e === 1 && a === i - 1 ? 2 : e === -1 && a === i + 1 ? 3 : e === -1 && a === i ? 4 : 0));
}
function ztd(e, t) {
  let n = Date.now(), o = 0;
  return (r, i, a, s, c, l) => {
    let d = Date.now();
    if (l.has("historic"))
      return o = 0, n = d, 2;
    let u = Ctd(r, i, s, c, e.isComposing()), _ = (() => {
      var p = a === null || a.editor === e, f = l.has("history-push");
      if (!f && p && l.has("history-merge"))
        return 0;
      if (r === null)
        return 1;
      var g = i._selection;
      if (!(0 < s.size || 0 < c.size))
        return g !== null ? 0 : 2;
      if (f === !1 && u !== 0 && u === o && d < n + t && p)
        return 0;
      if (s.size === 1) {
        {
          f = Array.from(s)[0], p = r._nodeMap.get(f), f = i._nodeMap.get(f), g = r._selection;
          let h = i._selection, b = !1;
          Ir.$isRangeSelection(g) && Ir.$isRangeSelection(h) && (b = g.anchor.type === "element" && g.focus.type === "element" && h.anchor.type === "text" && h.focus.type === "text"), p = !b && Ir.$isTextNode(p) && Ir.$isTextNode(f) ? p.__type === f.__type && p.__text === f.__text && p.__mode === f.__mode && p.__detail === f.__detail && p.__style === f.__style && p.__format === f.__format && p.__parent === f.__parent : !1;
        }
        if (p)
          return 0;
      }
      return 1;
    })();
    return n = d, o = u, _;
  };
}
N8.createEmptyHistoryState = function() {
  return { current: null, redoStack: [], undoStack: [] };
};
N8.registerHistory = function(e, t, n) {
  let o = ztd(e, n);
  n = ({ editorState: a, prevEditorState: s, dirtyLeaves: c, dirtyElements: l, tags: d }) => {
    const u = t.current, _ = t.redoStack, p = t.undoStack, f = u === null ? null : u.editorState;
    if (u === null || a !== f) {
      if (c = o(s, a, u, c, l, d), c === 1)
        _.length !== 0 && (t.redoStack = [], e.dispatchCommand(Ir.CAN_REDO_COMMAND, !1)), u !== null && (p.push({ ...u, undoSelection: s.read(Ir.$getSelection) }), e.dispatchCommand(Ir.CAN_UNDO_COMMAND, !0));
      else if (c === 2)
        return;
      t.current = { editor: e, editorState: a };
    }
  };
  let r = Atd.mergeRegister(
    e.registerCommand(
      Ir.UNDO_COMMAND,
      () => {
        let a = t.redoStack, s = t.undoStack;
        if (s.length !== 0) {
          let c = t.current, l = s.pop();
          c !== null && (a.push(c), e.dispatchCommand(Ir.CAN_REDO_COMMAND, !0)), s.length === 0 && e.dispatchCommand(Ir.CAN_UNDO_COMMAND, !1), t.current = l || null, l && l.editor.setEditorState(l.editorState.clone(l.undoSelection), { tag: "historic" });
        }
        return !0;
      },
      Ir.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Ir.REDO_COMMAND, () => {
      let a = t.redoStack;
      var s = t.undoStack;
      if (a.length !== 0) {
        let c = t.current;
        c !== null && (s.push(c), e.dispatchCommand(Ir.CAN_UNDO_COMMAND, !0)), s = a.pop(), a.length === 0 && e.dispatchCommand(Ir.CAN_REDO_COMMAND, !1), t.current = s || null, s && s.editor.setEditorState(s.editorState, { tag: "historic" });
      }
      return !0;
    }, Ir.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ir.CLEAR_EDITOR_COMMAND, () => (t.undoStack = [], t.redoStack = [], t.current = null, !1), Ir.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ir.CLEAR_HISTORY_COMMAND, () => (t.undoStack = [], t.redoStack = [], t.current = null, e.dispatchCommand(Ir.CAN_REDO_COMMAND, !1), e.dispatchCommand(Ir.CAN_UNDO_COMMAND, !1), !0), Ir.COMMAND_PRIORITY_EDITOR),
    e.registerUpdateListener(n)
  ), i = e.registerUpdateListener(n);
  return () => {
    r(), i();
  };
};
const Otd = N8;
var Ptd = Otd, Itd = Ia, rq = Ptd, gee = ve;
function Rtd(e, t, n = 1e3) {
  let o = gee.useMemo(() => t || rq.createEmptyHistoryState(), [t]);
  gee.useEffect(() => rq.registerHistory(e, o, n), [n, e, o]);
}
R8.createEmptyHistoryState = rq.createEmptyHistoryState;
R8.HistoryPlugin = function({ externalHistoryState: e }) {
  let [t] = Itd.useLexicalComposerContext();
  return Rtd(t, e), null;
};
const Ntd = R8;
var Dtd = Ntd, Cwe = {}, uh = vl, Mtd = Ia, Ltd = za, _h = yn, qtd = ve;
Cwe.LinkPlugin = function({ validateUrl: e }) {
  let [t] = Mtd.useLexicalComposerContext();
  return qtd.useEffect(() => {
    if (!t.hasNodes([uh.LinkNode]))
      throw Error("LinkPlugin: LinkNode not registered on editor");
    return Ltd.mergeRegister(t.registerCommand(uh.TOGGLE_LINK_COMMAND, (n) => {
      if (n === null)
        return uh.toggleLink(n), !0;
      if (typeof n == "string")
        return e === void 0 || e(n) ? (uh.toggleLink(n), !0) : !1;
      let { url: o, target: r, rel: i } = n;
      return uh.toggleLink(o, { rel: i, target: r }), !0;
    }, _h.COMMAND_PRIORITY_LOW), e !== void 0 ? t.registerCommand(
      _h.PASTE_COMMAND,
      (n) => {
        let o = _h.$getSelection();
        if (!_h.$isRangeSelection(o) || o.isCollapsed() || !(n instanceof ClipboardEvent) || n.clipboardData == null)
          return !1;
        let r = n.clipboardData.getData("text");
        return e(r) ? o.getNodes().some((i) => _h.$isElementNode(i)) ? !1 : (t.dispatchCommand(uh.TOGGLE_LINK_COMMAND, r), n.preventDefault(), !0) : !1;
      },
      _h.COMMAND_PRIORITY_LOW
    ) : () => {
    });
  }, [t, e]), null;
};
const jtd = Cwe;
var Ftd = jtd, zwe = {}, t_ = ul, Vtd = Ia, Owe = ve, Btd = za, Yy = yn;
function Utd(e) {
  Owe.useEffect(() => Btd.mergeRegister(e.registerCommand(t_.INSERT_ORDERED_LIST_COMMAND, () => (t_.insertList(e, "number"), !0), Yy.COMMAND_PRIORITY_LOW), e.registerCommand(t_.INSERT_UNORDERED_LIST_COMMAND, () => (t_.insertList(e, "bullet"), !0), Yy.COMMAND_PRIORITY_LOW), e.registerCommand(t_.REMOVE_LIST_COMMAND, () => (t_.removeList(e), !0), Yy.COMMAND_PRIORITY_LOW), e.registerCommand(Yy.INSERT_PARAGRAPH_COMMAND, () => !!t_.$handleListInsertParagraph(), Yy.COMMAND_PRIORITY_LOW)), [e]);
}
zwe.ListPlugin = function() {
  let [e] = Vtd.useLexicalComposerContext();
  return Owe.useEffect(() => {
    if (!e.hasNodes([t_.ListNode, t_.ListItemNode]))
      throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
  }, [e]), Utd(e), null;
};
const Wtd = zwe;
var Gtd = Wtd, D8 = {}, yk = {}, Pwe = {}, Htd = Ia, Ym = yn, sS = ve;
function hee(e, t) {
  return e.getEditorState().read(() => {
    let n = Ym.$getNodeByKey(t);
    return n === null ? !1 : n.isSelected();
  });
}
Pwe.useLexicalNodeSelection = function(e) {
  let [t] = Htd.useLexicalComposerContext(), [n, o] = sS.useState(() => hee(t, e));
  sS.useEffect(() => {
    let a = !0, s = t.registerUpdateListener(() => {
      a && o(hee(t, e));
    });
    return () => {
      a = !1, s();
    };
  }, [t, e]);
  let r = sS.useCallback((a) => {
    t.update(() => {
      let s = Ym.$getSelection();
      Ym.$isNodeSelection(s) || (s = Ym.$createNodeSelection(), Ym.$setSelection(s)), a ? s.add(e) : s.delete(e);
    });
  }, [t, e]), i = sS.useCallback(() => {
    t.update(() => {
      const a = Ym.$getSelection();
      Ym.$isNodeSelection(a) && a.clear();
    });
  }, [t]);
  return [n, r, i];
};
const Ktd = Pwe;
var Ytd = Ktd, Ztd = Ia, Qtd = Ytd, Jtd = za, ol = yn, ux = ve;
let Xtd = ol.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
function end({ nodeKey: e }) {
  let [t] = Ztd.useLexicalComposerContext(), [n, o, r] = Qtd.useLexicalNodeSelection(e), i = ux.useCallback((a) => (n && ol.$isNodeSelection(ol.$getSelection()) && (a.preventDefault(), a = ol.$getNodeByKey(e), Rwe(a) && a.remove(), o(!1)), !1), [n, e, o]);
  return ux.useEffect(() => Jtd.mergeRegister(t.registerCommand(ol.CLICK_COMMAND, (a) => {
    let s = t.getElementByKey(e);
    return a.target === s ? (a.shiftKey || r(), o(!n), !0) : !1;
  }, ol.COMMAND_PRIORITY_LOW), t.registerCommand(ol.KEY_DELETE_COMMAND, i, ol.COMMAND_PRIORITY_LOW), t.registerCommand(
    ol.KEY_BACKSPACE_COMMAND,
    i,
    ol.COMMAND_PRIORITY_LOW
  )), [r, t, n, e, i, o]), ux.useEffect(() => {
    let a = t.getElementByKey(e);
    a !== null && (a.className = n ? "selected" : "");
  }, [t, n, e]), null;
}
let M8 = class Iwe extends ol.DecoratorNode {
  static getType() {
    return "horizontalrule";
  }
  static clone(t) {
    return new Iwe(t.__key);
  }
  static importJSON() {
    return L8();
  }
  static importDOM() {
    return { hr: () => ({ conversion: tnd, priority: 0 }) };
  }
  exportJSON() {
    return { type: "horizontalrule", version: 1 };
  }
  exportDOM() {
    return { element: document.createElement("hr") };
  }
  createDOM() {
    return document.createElement("hr");
  }
  getTextContent() {
    return `
`;
  }
  isInline() {
    return !1;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return ux.createElement(end, { nodeKey: this.__key });
  }
};
function tnd() {
  return { node: L8() };
}
function L8() {
  return ol.$applyNodeReplacement(new M8());
}
function Rwe(e) {
  return e instanceof M8;
}
yk.$createHorizontalRuleNode = L8;
yk.$isHorizontalRuleNode = Rwe;
yk.HorizontalRuleNode = M8;
yk.INSERT_HORIZONTAL_RULE_COMMAND = Xtd;
const nnd = yk;
var ond = nnd, Nwe = nq, rnd = Ia, B5 = ond, ind = ve;
let Dwe = [{ dependencies: [B5.HorizontalRuleNode], export: (e) => B5.$isHorizontalRuleNode(e) ? "***" : null, regExp: /^(---|\*\*\*|___)\s?$/, replace: (e, t, n, o) => {
  t = B5.$createHorizontalRuleNode(), o || e.getNextSibling() != null ? e.replace(t) : e.insertBefore(t), t.selectNext();
}, type: "element" }, ...Nwe.TRANSFORMERS];
D8.DEFAULT_TRANSFORMERS = Dwe;
D8.MarkdownShortcutPlugin = function({ transformers: e = Dwe }) {
  let [t] = rnd.useLexicalComposerContext();
  return ind.useEffect(() => Nwe.registerMarkdownShortcuts(t, e), [t, e]), null;
};
const and = D8;
var snd = and, Mwe = {}, cnd = Ia, ow = ve, lnd = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ow.useLayoutEffect : ow.useEffect;
function dnd(e) {
  let [t] = cnd.useLexicalComposerContext(), n = ow.useMemo(() => e(t), [t, e]), o = ow.useRef(n.initialValueFn()), [r, i] = ow.useState(o.current);
  return lnd(() => {
    let { initialValueFn: a, subscribe: s } = n, c = a();
    return o.current !== c && (o.current = c, i(c)), s((l) => {
      o.current = l, i(l);
    });
  }, [n, e]), r;
}
function und(e) {
  return { initialValueFn: () => e.isEditable(), subscribe: (t) => e.registerEditableListener(t) };
}
var _nd = function() {
  return dnd(und);
};
const pnd = _nd;
var mnd = pnd, um = {}, ws = yn;
function q8(e, t = !0) {
  return e ? !1 : (e = Lwe(), t && (e = e.trim()), e === "");
}
function Lwe() {
  return ws.$getRoot().getTextContent();
}
function qwe(e) {
  if (!q8(e, !1))
    return !1;
  e = ws.$getRoot().getChildren();
  let t = e.length;
  if (1 < t)
    return !1;
  for (let o = 0; o < t; o++) {
    var n = e[o];
    if (ws.$isDecoratorNode(n))
      return !1;
    if (ws.$isElementNode(n)) {
      if (!ws.$isParagraphNode(n) || n.__indent !== 0)
        return !1;
      n = n.getChildren();
      let r = n.length;
      for (let i = 0; i < r; i++)
        if (!ws.$isTextNode(n[o]))
          return !1;
    }
  }
  return !0;
}
um.$canShowPlaceholder = qwe;
um.$canShowPlaceholderCurry = function(e) {
  return () => qwe(e);
};
um.$findTextIntersectionFromCharacters = function(e, t) {
  var n = e.getFirstChild();
  e = 0;
  e:
    for (; n !== null; ) {
      if (ws.$isElementNode(n)) {
        var o = n.getFirstChild();
        if (o !== null) {
          n = o;
          continue;
        }
      } else if (ws.$isTextNode(n)) {
        if (o = n.getTextContentSize(), e + o > t)
          return { node: n, offset: t - e };
        e += o;
      }
      if (o = n.getNextSibling(), o !== null)
        n = o;
      else {
        for (n = n.getParent(); n !== null; ) {
          if (o = n.getNextSibling(), o !== null) {
            n = o;
            continue e;
          }
          n = n.getParent();
        }
        break;
      }
    }
  return null;
};
um.$isRootTextContentEmpty = q8;
um.$isRootTextContentEmptyCurry = function(e, t) {
  return () => q8(e, t);
};
um.$rootTextContent = Lwe;
um.registerLexicalTextEntity = function(e, t, n, o) {
  let r = (a) => {
    const s = ws.$createTextNode(a.getTextContent());
    s.setFormat(a.getFormat()), a.replace(s);
  }, i = e.registerNodeTransform(ws.TextNode, (a) => {
    if (a.isSimpleText()) {
      var s = a.getPreviousSibling(), c = a.getTextContent(), l = a;
      if (ws.$isTextNode(s)) {
        var d = s.getTextContent(), u = t(d + c);
        if (s instanceof n) {
          if (u === null || s.getLatest().__mode !== 0) {
            r(s);
            return;
          }
          if (u = u.end - d.length, 0 < u) {
            l = c.slice(0, u), l = d + l, s.select(), s.setTextContent(l), u === c.length ? a.remove() : (s = c.slice(u), a.setTextContent(s));
            return;
          }
        } else if (u === null || u.start < d.length)
          return;
      }
      for (; ; ) {
        if (a = t(c), c = u = a === null ? "" : c.slice(a.end), u === "") {
          if (d = l.getNextSibling(), ws.$isTextNode(d)) {
            if (u = l.getTextContent() + d.getTextContent(), u = t(u), u === null) {
              d instanceof n ? r(d) : d.markDirty();
              break;
            } else if (u.start !== 0)
              break;
          }
        } else if (d = t(u), d !== null && d.start === 0)
          break;
        if (a === null)
          break;
        if (a.start === 0 && ws.$isTextNode(s) && s.isTextEntity())
          continue;
        let _;
        if (a.start === 0 ? [_, l] = l.splitText(a.end) : [, _, l] = l.splitText(a.start, a.end), a = o(_), _.replace(a), l == null)
          break;
      }
    }
  });
  return e = e.registerNodeTransform(n, (a) => {
    var s = a.getTextContent();
    const c = t(s);
    c === null || c.start !== 0 ? r(a) : s.length > c.end ? a.splitText(c.end) : (s = a.getPreviousSibling(), ws.$isTextNode(s) && s.isTextEntity() && (r(s), r(a)), s = a.getNextSibling(), ws.$isTextNode(s) && s.isTextEntity() && (r(s), a instanceof n && r(a)));
  }), [i, e];
};
const fnd = um;
var gnd = fnd, jwe = {}, cS = yn;
jwe.registerDragonSupport = function(e) {
  let t = window.location.origin, n = (o) => {
    if (o.origin === t) {
      var r = e.getRootElement();
      if (document.activeElement === r && (r = o.data, typeof r == "string")) {
        try {
          var i = JSON.parse(r);
        } catch {
          return;
        }
        if (i && i.protocol === "nuanria_messaging" && i.type === "request" && (i = i.payload) && i.functionId === "makeChanges" && (i = i.args)) {
          const [a, s, c, l, d] = i;
          e.update(() => {
            const u = cS.$getSelection();
            if (cS.$isRangeSelection(u)) {
              var _ = u.anchor;
              let p = _.getNode(), f = 0, g = 0;
              cS.$isTextNode(p) && 0 <= a && 0 <= s && (f = a, g = a + s, u.setTextNodeRange(p, f, p, g)), (f !== g || c !== "") && (u.insertRawText(c), p = _.getNode()), cS.$isTextNode(p) && (f = l, g = l + d, _ = p.getTextContentSize(), f = f > _ ? _ : f, g = g > _ ? _ : g, u.setTextNodeRange(p, f, p, g)), o.stopImmediatePropagation();
            }
          });
        }
      }
    }
  };
  return window.addEventListener("message", n, !0), () => {
    window.removeEventListener("message", n, !0);
  };
};
const hnd = jwe;
var vnd = hnd, Fwe = Ia, bnd = mnd, _l = ve, ynd = gnd, Vwe = za, vee = Uv, $nd = vnd, wnd = Rf, j8 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? _l.useLayoutEffect : _l.useEffect;
function bee(e) {
  return e.getEditorState().read(ynd.$canShowPlaceholderCurry(e.isComposing()));
}
function knd(e) {
  let [t, n] = _l.useState(() => bee(e));
  return j8(() => {
    function o() {
      let r = bee(e);
      n(r);
    }
    return o(), Vwe.mergeRegister(e.registerUpdateListener(() => {
      o();
    }), e.registerEditableListener(() => {
      o();
    }));
  }, [e]), t;
}
function Snd(e, t) {
  let [n, o] = _l.useState(() => e.getDecorators());
  return j8(() => e.registerDecoratorListener((r) => {
    vee.flushSync(() => {
      o(r);
    });
  }), [e]), _l.useEffect(() => {
    o(e.getDecorators());
  }, [e]), _l.useMemo(() => {
    let r = [], i = Object.keys(n);
    for (let s = 0; s < i.length; s++) {
      var a = i[s];
      let c = _l.createElement(t, { onError: (l) => e._onError(l) }, _l.createElement(_l.Suspense, { fallback: null }, n[a]));
      a = e.getElementByKey(a), a !== null && r.push(vee.createPortal(c, a));
    }
    return r;
  }, [t, n, e]);
}
function xnd(e) {
  j8(() => Vwe.mergeRegister(wnd.registerRichText(e), $nd.registerDragonSupport(e)), [e]);
}
function End({ content: e }) {
  var [t] = Fwe.useLexicalComposerContext();
  t = knd(t);
  let n = bnd();
  return t ? typeof e == "function" ? e(n) : e : null;
}
Mwe.RichTextPlugin = function({ contentEditable: e, placeholder: t, ErrorBoundary: n }) {
  let [o] = Fwe.useLexicalComposerContext();
  return n = Snd(o, n), xnd(o), _l.createElement(_l.Fragment, null, e, _l.createElement(End, { content: t }), n);
};
const Tnd = Mwe;
var And = Tnd, sr = {}, Ke = yn, mi = za;
let vi = { BOTH: 3, COLUMN: 2, NO_STATUS: 0, ROW: 1 }, F8 = class Bwe extends Ke.DEPRECATED_GridCellNode {
  static getType() {
    return "tablecell";
  }
  static clone(t) {
    let n = new Bwe(t.__headerState, t.__colSpan, t.__width, t.__key);
    return n.__rowSpan = t.__rowSpan, n;
  }
  static importDOM() {
    return { td: () => ({ conversion: yee, priority: 0 }), th: () => ({ conversion: yee, priority: 0 }) };
  }
  static importJSON(t) {
    return uu(t.headerState, t.colSpan, t.width || void 0);
  }
  constructor(t = vi.NO_STATUS, n = 1, o, r) {
    super(n, r), this.__headerState = t, this.__width = o;
  }
  createDOM(t) {
    let n = document.createElement(this.getTag());
    return this.__width && (n.style.width = `${this.__width}px`), this.__colSpan !== 1 && (n.colSpan = this.__colSpan), this.__rowSpan !== 1 && (n.rowSpan = this.__rowSpan), mi.addClassNamesToElement(n, t.theme.tableCell, this.hasHeader() && t.theme.tableCellHeader), n;
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t) {
      let n = this.getParentOrThrow().getChildrenSize();
      t.style.border = "1px solid black", this.__colSpan !== 1 && (t.colSpan = this.__colSpan), this.__rowSpan !== 1 && (t.rowSpan = this.__rowSpan), t.style.width = `${this.getWidth() || Math.max(90, 700 / n)}px`, t.style.verticalAlign = "top", t.style.textAlign = "start", this.hasHeader() && (t.style.backgroundColor = "#f2f3f5");
    }
    return { element: t };
  }
  exportJSON() {
    return { ...super.exportJSON(), colSpan: super.__colSpan, headerState: this.__headerState, type: "tablecell", width: this.getWidth() };
  }
  getTag() {
    return this.hasHeader() ? "th" : "td";
  }
  setHeaderStyles(t) {
    return this.getWritable().__headerState = t, this.__headerState;
  }
  getHeaderStyles() {
    return this.getLatest().__headerState;
  }
  setWidth(t) {
    return this.getWritable().__width = t, this.__width;
  }
  getWidth() {
    return this.getLatest().__width;
  }
  toggleHeaderStyle(t) {
    let n = this.getWritable();
    return n.__headerState = (n.__headerState & t) === t ? n.__headerState - t : n.__headerState + t, n;
  }
  hasHeaderState(t) {
    return (this.getHeaderStyles() & t) === t;
  }
  hasHeader() {
    return this.getLatest().__headerState !== vi.NO_STATUS;
  }
  updateDOM(t) {
    return t.__headerState !== this.__headerState || t.__width !== this.__width || t.__colSpan !== this.__colSpan || t.__rowSpan !== this.__rowSpan;
  }
  isShadowRoot() {
    return !0;
  }
  collapseAtStart() {
    return !0;
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
};
function yee(e) {
  var t = e.nodeName.toLowerCase();
  return t = uu(t === "th" ? vi.ROW : vi.NO_STATUS), t.__colSpan = e.colSpan, t.__rowSpan = e.rowSpan, { forChild: (n, o) => Mo(o) && !Ke.$isElementNode(n) ? (o = Ke.$createParagraphNode(), Ke.$isLineBreakNode(n) && n.getTextContent() === `
` ? null : (o.append(n), o)) : n, node: t };
}
function uu(e, t = 1, n) {
  return Ke.$applyNodeReplacement(new F8(e, t, n));
}
function Mo(e) {
  return e instanceof F8;
}
let V8 = class Uwe extends Ke.DEPRECATED_GridRowNode {
  static getType() {
    return "tablerow";
  }
  static clone(t) {
    return new Uwe(t.__height, t.__key);
  }
  static importDOM() {
    return { tr: () => ({ conversion: Cnd, priority: 0 }) };
  }
  static importJSON(t) {
    return ng(t.height);
  }
  constructor(t, n) {
    super(n), this.__height = t;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "tablerow", version: 1 };
  }
  createDOM(t) {
    let n = document.createElement("tr");
    return this.__height && (n.style.height = `${this.__height}px`), mi.addClassNamesToElement(n, t.theme.tableRow), n;
  }
  isShadowRoot() {
    return !0;
  }
  setHeight(t) {
    return this.getWritable().__height = t, this.__height;
  }
  getHeight() {
    return this.getLatest().__height;
  }
  updateDOM(t) {
    return t.__height !== this.__height;
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
};
function Cnd() {
  return { node: ng() };
}
function ng(e) {
  return Ke.$applyNodeReplacement(new V8(e));
}
function og(e) {
  return e instanceof V8;
}
function $T(e) {
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?code=${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let znd = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Wwe = class {
  constructor(t, n) {
    this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = n, this.editor = t, this.grid = { cells: [], columns: 0, rows: 0 }, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
  }
  getGrid() {
    return this.grid;
  }
  removeListeners() {
    Array.from(this.listenersToRemove).forEach((t) => t());
  }
  trackTableGrid() {
    let t = new MutationObserver((n) => {
      this.editor.update(() => {
        var o = !1;
        for (let r = 0; r < n.length; r++) {
          const i = n[r].target.nodeName;
          if (i === "TABLE" || i === "TR") {
            o = !0;
            break;
          }
        }
        if (o) {
          if (o = this.editor.getElementByKey(this.tableNodeKey), !o)
            throw Error("Expected to find TableElement in DOM");
          this.grid = px(o);
        }
      });
    });
    this.editor.update(() => {
      let n = this.editor.getElementByKey(this.tableNodeKey);
      if (!n)
        throw Error("Expected to find TableElement in DOM");
      this.grid = px(n), t.observe(n, { childList: !0, subtree: !0 });
    });
  }
  clearHighlight() {
    this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), this.editor.update(() => {
      var t = Ke.$getNodeByKey(this.tableNodeKey);
      if (!tv(t))
        throw Error("Expected TableNode.");
      if (t = this.editor.getElementByKey(this.tableNodeKey), !t)
        throw Error("Expected to find TableElement in DOM");
      t = px(t), lS(t, null), Ke.$setSelection(null), this.editor.dispatchCommand(
        Ke.SELECTION_CHANGE_COMMAND,
        void 0
      );
    });
  }
  enableHighlightStyle() {
    this.editor.update(() => {
      let t = this.editor.getElementByKey(this.tableNodeKey);
      if (!t)
        throw Error("Expected to find TableElement in DOM");
      t.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
    });
  }
  disableHighlightStyle() {
    this.editor.update(() => {
      let t = this.editor.getElementByKey(this.tableNodeKey);
      if (!t)
        throw Error("Expected to find TableElement in DOM");
      t.classList.add("disable-selection"), this.hasHijackedSelectionStyles = !0;
    });
  }
  updateTableGridSelection(t) {
    t != null && t.gridKey === this.tableNodeKey ? (this.gridSelection = t, this.isHighlightingCells = !0, this.disableHighlightStyle(), lS(this.grid, this.gridSelection)) : t == null && this.clearHighlight();
  }
  setFocusCellForSelection(t, n = !1) {
    this.editor.update(() => {
      var o = Ke.$getNodeByKey(this.tableNodeKey);
      if (!tv(o))
        throw Error("Expected TableNode.");
      if (!this.editor.getElementByKey(this.tableNodeKey))
        throw Error("Expected to find TableElement in DOM");
      o = t.x;
      let r = t.y;
      if (this.focusCell = t, this.anchorCell !== null) {
        let i = znd ? (this.editor._window || window).getSelection() : null;
        i && i.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
      }
      if (!this.isHighlightingCells && (this.anchorX !== o || this.anchorY !== r || n))
        this.isHighlightingCells = !0, this.disableHighlightStyle();
      else if (o === this.focusX && r === this.focusY)
        return;
      this.focusX = o, this.focusY = r, this.isHighlightingCells && (o = Ke.$getNearestNodeFromDOMNode(t.elem), this.gridSelection != null && this.anchorCellNodeKey != null && Mo(o) && (o = o.getKey(), this.gridSelection = this.gridSelection.clone() || Ke.DEPRECATED_$createGridSelection(), this.focusCellNodeKey = o, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), Ke.$setSelection(this.gridSelection), this.editor.dispatchCommand(Ke.SELECTION_CHANGE_COMMAND, void 0), lS(this.grid, this.gridSelection)));
    });
  }
  setAnchorCellForSelection(t) {
    this.isHighlightingCells = !1, this.anchorCell = t, this.anchorX = t.x, this.anchorY = t.y, this.editor.update(() => {
      var n = Ke.$getNearestNodeFromDOMNode(t.elem);
      Mo(n) && (n = n.getKey(), this.gridSelection = Ke.DEPRECATED_$createGridSelection(), this.anchorCellNodeKey = n);
    });
  }
  formatCells(t) {
    this.editor.update(() => {
      let n = Ke.$getSelection();
      Ke.DEPRECATED_$isGridSelection(n) || $T(11);
      let o = Ke.$createRangeSelection(), r = o.anchor, i = o.focus;
      n.getNodes().forEach((a) => {
        Mo(a) && a.getTextContentSize() !== 0 && (r.set(a.getKey(), 0, "element"), i.set(a.getKey(), a.getChildrenSize(), "element"), o.formatText(t));
      }), Ke.$setSelection(n), this.editor.dispatchCommand(Ke.SELECTION_CHANGE_COMMAND, void 0);
    });
  }
  clearText() {
    this.editor.update(() => {
      let t = Ke.$getNodeByKey(this.tableNodeKey);
      if (!tv(t))
        throw Error("Expected TableNode.");
      var n = Ke.$getSelection();
      Ke.DEPRECATED_$isGridSelection(n) || $T(11), n = n.getNodes().filter(Mo), n.length === this.grid.columns * this.grid.rows ? (t.selectPrevious(), t.remove(), Ke.$getRoot().selectStart()) : (n.forEach((o) => {
        if (Ke.$isElementNode(o)) {
          let r = Ke.$createParagraphNode(), i = Ke.$createTextNode();
          r.append(i), o.append(r), o.getChildren().forEach((a) => {
            a !== r && a.remove();
          });
        }
      }), lS(this.grid, null), Ke.$setSelection(null), this.editor.dispatchCommand(Ke.SELECTION_CHANGE_COMMAND, void 0));
    });
  }
};
function _x(e) {
  for (; e != null; ) {
    let t = e.nodeName;
    if (t === "TD" || t === "TH") {
      if (e = e._cell, e === void 0)
        break;
      return e;
    }
    e = e.parentNode;
  }
  return null;
}
function px(e) {
  let t = [], n = { cells: t, columns: 0, rows: 0 };
  var o = e.firstChild;
  let r = e = 0;
  for (t.length = 0; o != null; ) {
    var i = o.nodeName;
    if (i === "TD" || i === "TH")
      i = { elem: o, highlighted: !1, x: e, y: r }, o._cell = i, t[r] === void 0 && (t[r] = []), t[r][e] = i;
    else if (i = o.firstChild, i != null) {
      o = i;
      continue;
    }
    if (i = o.nextSibling, i != null)
      e++, o = i;
    else if (i = o.parentNode, i != null) {
      if (o = i.nextSibling, o == null)
        break;
      r++, e = 0;
    }
  }
  return n.columns = e + 1, n.rows = r + 1, n;
}
function lS(e, t) {
  let n = [], o = new Set(t ? t.getNodes() : []);
  return B8(e, (r, i) => {
    let a = r.elem;
    o.has(i) ? (r.highlighted = !0, a.style.setProperty("background-color", "rgb(172, 206, 247)"), a.style.setProperty("caret-color", "transparent"), n.push(r)) : (r.highlighted = !1, a.style.removeProperty("background-color"), a.style.removeProperty("caret-color"), a.getAttribute("style") || a.removeAttribute("style"));
  }), n;
}
function B8(e, t) {
  ({ cells: e } = e);
  for (let n = 0; n < e.length; n++) {
    let o = e[n];
    for (let r = 0; r < o.length; r++) {
      let i = o[r], a = Ke.$getNearestNodeFromDOMNode(i.elem);
      a !== null && t(i, a, { x: r, y: n });
    }
  }
}
function $ee(e) {
  e.disableHighlightStyle(), B8(e.grid, (t) => {
    let n = t.elem;
    t.highlighted = !0, n.style.setProperty("background-color", "rgb(172, 206, 247)"), n.style.setProperty("caret-color", "transparent");
  });
}
function Ond(e) {
  e.enableHighlightStyle(), B8(e.grid, (t) => {
    let n = t.elem;
    t.highlighted = !1, n.style.removeProperty("background-color"), n.style.removeProperty("caret-color"), n.getAttribute("style") || n.removeAttribute("style");
  });
}
let Zy = (e, t, n, o, r) => {
  const i = r === "forward";
  switch (r) {
    case "backward":
    case "forward":
      return n !== (i ? e.grid.columns - 1 : 0) ? dS(t.getCellNodeFromCordsOrThrow(n + (i ? 1 : -1), o, e.grid)) : o !== (i ? e.grid.rows - 1 : 0) ? dS(t.getCellNodeFromCordsOrThrow(i ? 0 : e.grid.columns - 1, o + (i ? 1 : -1), e.grid)) : i ? t.selectNext() : t.selectPrevious(), !0;
    case "up":
      return o !== 0 ? dS(t.getCellNodeFromCordsOrThrow(n, o - 1, e.grid)) : t.selectPrevious(), !0;
    case "down":
      return o !== e.grid.rows - 1 ? dS(t.getCellNodeFromCordsOrThrow(n, o + 1, e.grid)) : t.selectNext(), !0;
    default:
      return !1;
  }
}, cp = (e, t, n, o, r) => {
  const i = r === "forward";
  switch (r) {
    case "backward":
    case "forward":
      return n !== (i ? e.grid.columns - 1 : 0) && e.setFocusCellForSelection(t.getCellFromCordsOrThrow(n + (i ? 1 : -1), o, e.grid)), !0;
    case "up":
      return o !== 0 ? (e.setFocusCellForSelection(t.getCellFromCordsOrThrow(n, o - 1, e.grid)), !0) : !1;
    case "down":
      return o !== e.grid.rows - 1 ? (e.setFocusCellForSelection(t.getCellFromCordsOrThrow(n, o + 1, e.grid)), !0) : !1;
    default:
      return !1;
  }
};
function Ku(e, t) {
  if (Ke.$isRangeSelection(e) || Ke.DEPRECATED_$isGridSelection(e)) {
    let n = t.isParentOf(e.anchor.getNode());
    return e = t.isParentOf(e.focus.getNode()), n && e;
  }
  return !1;
}
function dS(e) {
  let t = e.getChildren().find((n) => Ke.$isParagraphNode(n));
  Ke.$isParagraphNode(t) ? t.selectEnd() : e.selectEnd();
}
class $k extends Ke.DEPRECATED_GridNode {
  static getType() {
    return "table";
  }
  static clone(t) {
    return new $k(t.__key);
  }
  static importDOM() {
    return { table: () => ({ conversion: Pnd, priority: 1 }) };
  }
  static importJSON() {
    return YC();
  }
  constructor(t) {
    super(t);
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "table", version: 1 };
  }
  createDOM(t) {
    let n = document.createElement("table");
    return mi.addClassNamesToElement(n, t.theme.table), n;
  }
  updateDOM() {
    return !1;
  }
  exportDOM(t) {
    return { ...super.exportDOM(t), after: (n) => {
      if (n) {
        let o = n.cloneNode(), r = document.createElement("colgroup"), i = document.createElement("tbody");
        if (i.append(...n.children), n = this.getFirstChildOrThrow(), !og(n))
          throw Error("Expected to find row node.");
        n = n.getChildrenSize();
        for (let a = 0; a < n; a++) {
          let s = document.createElement("col");
          r.append(s);
        }
        return o.replaceChildren(r, i), o;
      }
    } };
  }
  canExtractContents() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isShadowRoot() {
    return !0;
  }
  getCordsFromCellNode(t, n) {
    let { rows: o, cells: r } = n;
    for (n = 0; n < o; n++) {
      var i = r[n];
      if (i == null)
        throw Error(`Row not found at y:${n}`);
      if (i = i.findIndex(({ elem: a }) => Ke.$getNearestNodeFromDOMNode(a) === t), i !== -1)
        return { x: i, y: n };
    }
    throw Error("Cell not found in table.");
  }
  getCellFromCords(t, n, o) {
    return { cells: o } = o, n = o[n], n == null ? null : (t = n[t], t ?? null);
  }
  getCellFromCordsOrThrow(t, n, o) {
    if (t = this.getCellFromCords(t, n, o), !t)
      throw Error("Cell not found at cords.");
    return t;
  }
  getCellNodeFromCords(t, n, o) {
    return t = this.getCellFromCords(t, n, o), t == null ? null : (t = Ke.$getNearestNodeFromDOMNode(t.elem), Mo(t) ? t : null);
  }
  getCellNodeFromCordsOrThrow(t, n, o) {
    if (t = this.getCellNodeFromCords(t, n, o), !t)
      throw Error("Node at cords not TableCellNode.");
    return t;
  }
  canSelectBefore() {
    return !0;
  }
  canIndent() {
    return !1;
  }
}
function Pnd() {
  return { node: YC() };
}
function YC() {
  return Ke.$applyNodeReplacement(new $k());
}
function tv(e) {
  return e instanceof $k;
}
function U8(e) {
  if (e = mi.$findMatchingParent(e, (t) => og(t)), og(e))
    return e;
  throw Error("Expected table cell to be inside of table row.");
}
function W8(e) {
  if (e = mi.$findMatchingParent(e, (t) => tv(t)), tv(e))
    return e;
  throw Error("Expected table cell to be inside of table.");
}
function Gwe(e, t) {
  let n = W8(e), { x: o, y: r } = n.getCordsFromCellNode(e, t);
  return { above: n.getCellNodeFromCords(o, r - 1, t), below: n.getCellNodeFromCords(o, r + 1, t), left: n.getCellNodeFromCords(o - 1, r, t), right: n.getCellNodeFromCords(o + 1, r, t) };
}
function wT(e) {
  if (e = e.getFirstDescendant(), e === null)
    throw Error("Unexpected empty cell");
  e.getParentOrThrow().selectStart();
}
let Ind = Ke.createCommand("INSERT_TABLE_COMMAND");
sr.$createTableCellNode = uu;
sr.$createTableNode = YC;
sr.$createTableNodeWithDimensions = function(e, t, n = !0) {
  let o = YC();
  for (let i = 0; i < e; i++) {
    let a = ng();
    for (let s = 0; s < t; s++) {
      var r = vi.NO_STATUS;
      typeof n == "object" ? (i === 0 && n.rows && (r |= vi.ROW), s === 0 && n.columns && (r |= vi.COLUMN)) : n && (i === 0 && (r |= vi.ROW), s === 0 && (r |= vi.COLUMN)), r = uu(r);
      let c = Ke.$createParagraphNode();
      c.append(Ke.$createTextNode()), r.append(c), a.append(r);
    }
    o.append(a);
  }
  return o;
};
sr.$createTableRowNode = ng;
sr.$deleteTableColumn = function(e, t) {
  let n = e.getChildren();
  for (let r = 0; r < n.length; r++) {
    var o = n[r];
    if (og(o)) {
      if (o = o.getChildren(), t >= o.length || 0 > t)
        throw Error("Table column target index out of range");
      o[t].remove();
    }
  }
  return e;
};
sr.$deleteTableColumn__EXPERIMENTAL = function() {
  var e = Ke.$getSelection();
  if (!Ke.$isRangeSelection(e) && !Ke.DEPRECATED_$isGridSelection(e))
    throw Error("Expected a RangeSelection or GridSelection");
  var t = e.anchor.getNode();
  e = e.focus.getNode();
  let [n, , o] = Ke.DEPRECATED_$getNodeTriplet(t);
  [t] = Ke.DEPRECATED_$getNodeTriplet(e);
  let [r, i, a] = Ke.DEPRECATED_$computeGridMap(o, n, t);
  var { startColumn: s } = i;
  let { startRow: c, startColumn: l } = a;
  e = Math.min(s, l), s = Math.max(s + n.__colSpan - 1, l + t.__colSpan - 1);
  let d = s - e + 1;
  if (r[0].length === s - e + 1)
    o.selectPrevious(), o.remove();
  else {
    var u = r.length;
    for (let _ = 0; _ < u; _++)
      for (let p = e; p <= s; p++) {
        let { cell: f, startColumn: g } = r[_][p];
        g < e ? p === e && f.setColSpan(f.__colSpan - Math.min(d, f.__colSpan - (e - g))) : g + f.__colSpan - 1 > s ? p === s && f.setColSpan(f.__colSpan - (s - g + 1)) : f.remove();
      }
    e = r[c], t = e[l + t.__colSpan], t !== void 0 ? ({ cell: t } = t, wT(t)) : ({ cell: t } = e[l - 1], wT(t));
  }
};
sr.$deleteTableRow__EXPERIMENTAL = function() {
  var e = Ke.$getSelection();
  if (!Ke.$isRangeSelection(e) && !Ke.DEPRECATED_$isGridSelection(e))
    throw Error("Expected a RangeSelection or GridSelection");
  var t = e.anchor.getNode();
  e = e.focus.getNode();
  let [n, , o] = Ke.DEPRECATED_$getNodeTriplet(t);
  [e] = Ke.DEPRECATED_$getNodeTriplet(e);
  let [r, i, a] = Ke.DEPRECATED_$computeGridMap(o, n, e);
  ({ startRow: t } = i);
  var { startRow: s } = a;
  if (e = s + e.__rowSpan - 1, r.length === e - t + 1)
    o.remove();
  else {
    s = r[0].length;
    var c = r[e + 1], l = o.getChildAtIndex(e + 1);
    if (!Ke.DEPRECATED_$isGridRowNode(l))
      throw Error(`Expected GridNode childAtIndex(${String(e + 1)}) to be RowNode`);
    for (let p = e; p >= t; p--) {
      for (var d = s - 1; 0 <= d; d--) {
        let { cell: f, startRow: g, startColumn: h } = r[p][d];
        if (h === d && (p === t && g < t && f.setRowSpan(f.__rowSpan - (g - t)), g >= t && g + f.__rowSpan - 1 > e))
          if (f.setRowSpan(f.__rowSpan - (e - g + 1)), d === 0) {
            var u = l, _ = f;
            let b = u.getFirstChild();
            b !== null ? u.insertBefore(b) : u.append(_);
          } else
            ({ cell: u } = c[d - 1]), u.insertAfter(f);
      }
      if (d = o.getChildAtIndex(p), !Ke.DEPRECATED_$isGridRowNode(d))
        throw Error(`Expected GridNode childAtIndex(${String(p)}) to be RowNode`);
      d.remove();
    }
    c !== void 0 ? ({ cell: t } = c[0], wT(t)) : ({ cell: t } = r[t - 1][0], wT(t));
  }
};
sr.$getElementGridForTableNode = function(e, t) {
  if (e = e.getElementByKey(t.getKey()), e == null)
    throw Error("Table Element Not Found");
  return px(e);
};
sr.$getTableCellNodeFromLexicalNode = function(e) {
  return e = mi.$findMatchingParent(e, (t) => Mo(t)), Mo(e) ? e : null;
};
sr.$getTableColumnIndexFromTableCellNode = function(e) {
  return U8(e).getChildren().findIndex((t) => t.is(e));
};
sr.$getTableNodeFromLexicalNodeOrThrow = W8;
sr.$getTableRowIndexFromTableCellNode = function(e) {
  let t = U8(e);
  return W8(t).getChildren().findIndex((n) => n.is(t));
};
sr.$getTableRowNodeFromTableCellNodeOrThrow = U8;
sr.$insertTableColumn = function(e, t, n = !0, o, r) {
  let i = e.getChildren();
  for (let c = 0; c < i.length; c++) {
    let l = i[c];
    if (og(l))
      for (let d = 0; d < o; d++) {
        var a = l.getChildren();
        if (t >= a.length || 0 > t)
          throw Error("Table column target index out of range");
        a = a[t], Mo(a) || $T(12);
        let { left: u, right: _ } = Gwe(a, r);
        var s = vi.NO_STATUS;
        (u && u.hasHeaderState(vi.ROW) || _ && _.hasHeaderState(vi.ROW)) && (s |= vi.ROW), s = uu(s), s.append(Ke.$createParagraphNode()), n ? a.insertAfter(s) : a.insertBefore(s);
      }
  }
  return e;
};
sr.$insertTableColumn__EXPERIMENTAL = function(e = !0) {
  var t = Ke.$getSelection();
  if (!Ke.$isRangeSelection(t) && !Ke.DEPRECATED_$isGridSelection(t))
    throw Error("Expected a RangeSelection or GridSelection");
  t = t.focus.getNode();
  let [n, , o] = Ke.DEPRECATED_$getNodeTriplet(t), [r, i] = Ke.DEPRECATED_$computeGridMap(o, n, n);
  t = r.length;
  var { startColumn: a } = i;
  if (e)
    for (e = a + n.__colSpan - 1, a = 0; a < t; a++) {
      let { cell: s, startColumn: c } = r[a][e];
      c + s.__colSpan - 1 <= e ? s.insertAfter(uu(vi.NO_STATUS)) : s.setColSpan(s.__colSpan + 1);
    }
  else
    for (e = 0; e < t; e++) {
      let { cell: s, startColumn: c } = r[e][a];
      c === a ? s.insertBefore(uu(vi.NO_STATUS)) : s.setColSpan(s.__colSpan + 1);
    }
};
sr.$insertTableRow = function(e, t, n = !0, o, r) {
  var i = e.getChildren();
  if (t >= i.length || 0 > t)
    throw Error("Table row target index out of range");
  if (t = i[t], og(t))
    for (i = 0; i < o; i++) {
      let s = t.getChildren(), c = s.length, l = ng();
      for (let d = 0; d < c; d++) {
        var a = s[d];
        Mo(a) || $T(12);
        let { above: u, below: _ } = Gwe(a, r);
        a = vi.NO_STATUS;
        let p = u && u.getWidth() || _ && _.getWidth() || void 0;
        (u && u.hasHeaderState(vi.COLUMN) || _ && _.hasHeaderState(vi.COLUMN)) && (a |= vi.COLUMN), a = uu(a, 1, p), a.append(Ke.$createParagraphNode()), l.append(a);
      }
      n ? t.insertAfter(l) : t.insertBefore(l);
    }
  else
    throw Error("Row before insertion index does not exist.");
  return e;
};
sr.$insertTableRow__EXPERIMENTAL = function(e = !0) {
  var t = Ke.$getSelection();
  if (!Ke.$isRangeSelection(t) && !Ke.DEPRECATED_$isGridSelection(t))
    throw Error("Expected a RangeSelection or GridSelection");
  t = t.focus.getNode();
  let [n, , o] = Ke.DEPRECATED_$getNodeTriplet(t), [r, i] = Ke.DEPRECATED_$computeGridMap(o, n, n);
  t = r[0].length;
  var { startRow: a } = i;
  if (e) {
    e = a + n.__rowSpan - 1;
    var s = r[e];
    a = ng();
    for (var c = 0; c < t; c++) {
      let { cell: l, startRow: d } = s[c];
      d + l.__rowSpan - 1 <= e ? a.append(uu(vi.NO_STATUS)) : l.setRowSpan(l.__rowSpan + 1);
    }
    if (t = o.getChildAtIndex(e), !Ke.DEPRECATED_$isGridRowNode(t))
      throw Error("focusEndRow is not a GridRowNode");
    t.insertAfter(a);
  } else {
    for (s = r[a], e = ng(), c = 0; c < t; c++) {
      let { cell: l, startRow: d } = s[c];
      d === a ? e.append(uu(vi.NO_STATUS)) : l.setRowSpan(l.__rowSpan + 1);
    }
    if (t = o.getChildAtIndex(a), !Ke.DEPRECATED_$isGridRowNode(t))
      throw Error("focusEndRow is not a GridRowNode");
    t.insertBefore(e);
  }
};
sr.$isTableCellNode = Mo;
sr.$isTableNode = tv;
sr.$isTableRowNode = og;
sr.$removeTableRowAtIndex = function(e, t) {
  let n = e.getChildren();
  if (t >= n.length || 0 > t)
    throw Error("Expected table cell to be inside of table row.");
  return n[t].remove(), e;
};
sr.INSERT_TABLE_COMMAND = Ind;
sr.TableCellHeaderStates = vi;
sr.TableCellNode = F8;
sr.TableNode = $k;
sr.TableRowNode = V8;
sr.TableSelection = Wwe;
sr.applyTableHandlers = function(e, t, n) {
  let o = n.getRootElement();
  if (o === null)
    throw Error("No root element.");
  let r = new Wwe(n, e.getKey());
  t.__lexicalTableSelection = r;
  let i = !1, a = !1;
  t.addEventListener("dblclick", (u) => {
    let _ = _x(u.target);
    _ !== null && (u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), r.setAnchorCellForSelection(_), r.setFocusCellForSelection(_, !0), i = !1);
  }), t.addEventListener("mousedown", (u) => {
    setTimeout(() => {
      if (u.button === 0) {
        var _ = _x(u.target);
        _ !== null && (u.preventDefault(), u.stopPropagation(), u.stopImmediatePropagation(), r.setAnchorCellForSelection(_));
      }
    }, 0);
  }), t.addEventListener("mousemove", (u) => {
    if (a && (u.preventDefault(), u.stopPropagation(), u.stopImmediatePropagation()), i) {
      let _ = _x(u.target);
      if (_ !== null) {
        let p = _.x, f = _.y;
        i && (r.anchorX !== p || r.anchorY !== f || r.isHighlightingCells) && (u.preventDefault(), r.setFocusCellForSelection(_));
      }
    }
  }), t.addEventListener("mouseleave", () => {
  });
  let s = (u) => {
    u.button === 0 && n.update(() => {
      var _ = Ke.$getSelection();
      const p = u.target;
      if (p instanceof Node) {
        if (Ke.DEPRECATED_$isGridSelection(_) && _.gridKey === r.tableNodeKey && o.contains(p))
          return r.clearHighlight();
        _ = Ke.$getNearestNodeFromDOMNode(p), _ !== null && mi.$findMatchingParent(_, Ke.DEPRECATED_$isGridNode) && (i = !0);
      }
    });
  };
  window.addEventListener("mousedown", s), r.listenersToRemove.add(() => window.removeEventListener("mousedown", s));
  let c = (u) => {
    i && (u.preventDefault(), u.stopPropagation()), i = !1;
  };
  window.addEventListener("mouseup", c), r.listenersToRemove.add(() => window.removeEventListener("mouseup", c)), t.addEventListener("mouseup", c), r.listenersToRemove.add(() => t.removeEventListener("mouseup", c)), r.listenersToRemove.add(n.registerCommand(Ke.KEY_ARROW_DOWN_COMMAND, (u) => {
    var _ = Ke.$getSelection();
    if (!Ku(_, e))
      return !1;
    if (Ke.$isRangeSelection(_)) {
      if (_.isCollapsed()) {
        var p = mi.$findMatchingParent(_.anchor.getNode(), (g) => Mo(g));
        if (!Mo(p))
          return !1;
        var f = e.getCordsFromCellNode(p, r.grid);
        if (_ = mi.$findMatchingParent(_.anchor.getNode(), (g) => Ke.$isElementNode(g)), _ == null)
          throw Error("Expected BlockNode Parent");
        if ((p = p.getLastChild()) && _.isParentOf(p) || _ === p || u.shiftKey)
          return u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), u.shiftKey ? (r.setAnchorCellForSelection(e.getCellFromCordsOrThrow(f.x, f.y, r.grid)), cp(r, e, f.x, f.y, "down")) : Zy(r, e, f.x, f.y, "down");
      }
    } else if (Ke.DEPRECATED_$isGridSelection(_) && u.shiftKey)
      return f = _.focus.getNode(), Mo(f) ? (f = e.getCordsFromCellNode(f, r.grid), u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), cp(r, e, f.x, f.y, "down")) : !1;
    return !1;
  }, Ke.COMMAND_PRIORITY_HIGH)), r.listenersToRemove.add(n.registerCommand(
    Ke.KEY_ARROW_UP_COMMAND,
    (u) => {
      var _ = Ke.$getSelection();
      if (!Ku(_, e))
        return !1;
      if (Ke.$isRangeSelection(_)) {
        if (_.isCollapsed()) {
          var p = mi.$findMatchingParent(_.anchor.getNode(), (g) => Mo(g));
          if (!Mo(p))
            return !1;
          var f = e.getCordsFromCellNode(p, r.grid);
          if (_ = mi.$findMatchingParent(_.anchor.getNode(), (g) => Ke.$isElementNode(g)), _ == null)
            throw Error("Expected BlockNode Parent");
          if ((p = p.getLastChild()) && _.isParentOf(p) || _ === p || u.shiftKey)
            return u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), u.shiftKey ? (r.setAnchorCellForSelection(e.getCellFromCordsOrThrow(
              f.x,
              f.y,
              r.grid
            )), cp(r, e, f.x, f.y, "up")) : Zy(r, e, f.x, f.y, "up");
        }
      } else if (Ke.DEPRECATED_$isGridSelection(_) && u.shiftKey)
        return f = _.focus.getNode(), Mo(f) ? (f = e.getCordsFromCellNode(f, r.grid), u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), cp(r, e, f.x, f.y, "up")) : !1;
      return !1;
    },
    Ke.COMMAND_PRIORITY_HIGH
  )), r.listenersToRemove.add(n.registerCommand(Ke.KEY_ARROW_LEFT_COMMAND, (u) => {
    var _ = Ke.$getSelection();
    if (!Ku(_, e))
      return !1;
    if (Ke.$isRangeSelection(_)) {
      if (_.isCollapsed()) {
        var p = mi.$findMatchingParent(
          _.anchor.getNode(),
          (f) => Mo(f)
        );
        if (!Mo(p))
          return !1;
        if (p = e.getCordsFromCellNode(p, r.grid), mi.$findMatchingParent(_.anchor.getNode(), (f) => Ke.$isElementNode(f)) == null)
          throw Error("Expected BlockNode Parent");
        if (_.anchor.offset === 0 || u.shiftKey)
          return u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), u.shiftKey ? (r.setAnchorCellForSelection(e.getCellFromCordsOrThrow(p.x, p.y, r.grid)), cp(r, e, p.x, p.y, "backward")) : Zy(r, e, p.x, p.y, "backward");
      }
    } else if (Ke.DEPRECATED_$isGridSelection(_) && u.shiftKey)
      return _ = _.focus.getNode(), Mo(_) ? (_ = e.getCordsFromCellNode(_, r.grid), u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), cp(r, e, _.x, _.y, "backward")) : !1;
    return !1;
  }, Ke.COMMAND_PRIORITY_HIGH)), r.listenersToRemove.add(n.registerCommand(
    Ke.KEY_ARROW_RIGHT_COMMAND,
    (u) => {
      var _ = Ke.$getSelection();
      if (!Ku(_, e))
        return !1;
      if (Ke.$isRangeSelection(_)) {
        if (_.isCollapsed()) {
          var p = mi.$findMatchingParent(_.anchor.getNode(), (f) => Mo(f));
          if (!Mo(p))
            return !1;
          if (p = e.getCordsFromCellNode(p, r.grid), mi.$findMatchingParent(_.anchor.getNode(), (f) => Ke.$isElementNode(f)) == null)
            throw Error("Expected BlockNode Parent");
          if (_.anchor.offset === _.anchor.getNode().getTextContentSize() || u.shiftKey)
            return u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), u.shiftKey ? (r.setAnchorCellForSelection(e.getCellFromCordsOrThrow(p.x, p.y, r.grid)), cp(r, e, p.x, p.y, "forward")) : Zy(r, e, p.x, p.y, "forward");
        }
      } else if (Ke.DEPRECATED_$isGridSelection(_) && u.shiftKey)
        return _ = _.focus.getNode(), Mo(_) ? (_ = e.getCordsFromCellNode(_, r.grid), u.preventDefault(), u.stopImmediatePropagation(), u.stopPropagation(), cp(r, e, _.x, _.y, "forward")) : !1;
      return !1;
    },
    Ke.COMMAND_PRIORITY_HIGH
  ));
  let l = (u) => () => {
    var _ = Ke.$getSelection();
    if (!Ku(_, e))
      return !1;
    if (Ke.DEPRECATED_$isGridSelection(_))
      return r.clearText(), !0;
    if (Ke.$isRangeSelection(_)) {
      const g = mi.$findMatchingParent(_.anchor.getNode(), (h) => Mo(h));
      if (!Mo(g))
        return !1;
      var p = _.anchor.getNode(), f = _.focus.getNode();
      if (p = e.isParentOf(p), f = e.isParentOf(f), p && !f || f && !p)
        return r.clearText(), !0;
      if (p = (f = mi.$findMatchingParent(_.anchor.getNode(), (h) => Ke.$isElementNode(h))) && mi.$findMatchingParent(f, (h) => Ke.$isElementNode(h) && Mo(h.getParent())), !Ke.$isElementNode(p) || !Ke.$isElementNode(f))
        return !1;
      if (u === Ke.DELETE_LINE_COMMAND && p.getPreviousSibling() === null)
        return !0;
      if ((u === Ke.DELETE_CHARACTER_COMMAND || u === Ke.DELETE_WORD_COMMAND) && _.isCollapsed() && _.anchor.offset === 0 && f !== p) {
        _ = f.getChildren();
        const h = Ke.$createParagraphNode();
        return _.forEach((b) => h.append(b)), f.replace(h), f.getWritable().__parent = g.getKey(), !0;
      }
    }
    return !1;
  };
  [Ke.DELETE_WORD_COMMAND, Ke.DELETE_LINE_COMMAND, Ke.DELETE_CHARACTER_COMMAND].forEach((u) => {
    r.listenersToRemove.add(n.registerCommand(
      u,
      l(u),
      Ke.COMMAND_PRIORITY_CRITICAL
    ));
  });
  let d = (u) => {
    const _ = Ke.$getSelection();
    return Ku(_, e) ? Ke.DEPRECATED_$isGridSelection(_) ? (u.preventDefault(), u.stopPropagation(), r.clearText(), !0) : (Ke.$isRangeSelection(_) && (u = mi.$findMatchingParent(_.anchor.getNode(), (p) => Mo(p)), Mo(u)), !1) : !1;
  };
  return r.listenersToRemove.add(n.registerCommand(Ke.KEY_BACKSPACE_COMMAND, d, Ke.COMMAND_PRIORITY_CRITICAL)), r.listenersToRemove.add(n.registerCommand(Ke.KEY_DELETE_COMMAND, d, Ke.COMMAND_PRIORITY_CRITICAL)), r.listenersToRemove.add(n.registerCommand(
    Ke.FORMAT_TEXT_COMMAND,
    (u) => {
      let _ = Ke.$getSelection();
      return Ku(_, e) ? Ke.DEPRECATED_$isGridSelection(_) ? (r.formatCells(u), !0) : (Ke.$isRangeSelection(_) && (u = mi.$findMatchingParent(_.anchor.getNode(), (p) => Mo(p)), Mo(u)), !1) : !1;
    },
    Ke.COMMAND_PRIORITY_CRITICAL
  )), r.listenersToRemove.add(n.registerCommand(
    Ke.CONTROLLED_TEXT_INSERTION_COMMAND,
    () => {
      var u = Ke.$getSelection();
      return Ku(u, e) && (Ke.DEPRECATED_$isGridSelection(u) ? r.clearHighlight() : Ke.$isRangeSelection(u) && (u = mi.$findMatchingParent(u.anchor.getNode(), (_) => Mo(_)), Mo(u))), !1;
    },
    Ke.COMMAND_PRIORITY_CRITICAL
  )), r.listenersToRemove.add(n.registerCommand(Ke.KEY_TAB_COMMAND, (u) => {
    var _ = Ke.$getSelection();
    if (!Ku(_, e))
      return !1;
    if (Ke.$isRangeSelection(_)) {
      let p = mi.$findMatchingParent(_.anchor.getNode(), (f) => Mo(f));
      if (!Mo(p))
        return !1;
      if (_.isCollapsed())
        return _ = e.getCordsFromCellNode(p, r.grid), u.preventDefault(), Zy(r, e, _.x, _.y, u.shiftKey ? "backward" : "forward"), !0;
    }
    return !1;
  }, Ke.COMMAND_PRIORITY_HIGH)), r.listenersToRemove.add(n.registerCommand(Ke.FOCUS_COMMAND, () => e.isSelected(), Ke.COMMAND_PRIORITY_HIGH)), r.listenersToRemove.add(n.registerCommand(Ke.SELECTION_CHANGE_COMMAND, () => {
    let u = Ke.$getSelection();
    var _ = Ke.$getPreviousSelection();
    if (u && Ke.$isRangeSelection(u) && !u.isCollapsed()) {
      var p = u.anchor.getNode(), f = u.focus.getNode();
      p = e.isParentOf(p);
      var g = e.isParentOf(f);
      if (f = p && !g || g && !p, p = p && g && !e.isSelected(), f)
        return _ = u.isBackward(), p = Ke.$createRangeSelection(), f = e.getKey(), p.anchor.set(u.anchor.key, u.anchor.offset, u.anchor.type), p.focus.set(f, _ ? 0 : e.getChildrenSize(), "element"), a = !0, Ke.$setSelection(p), $ee(r), !0;
      if (p && ({ grid: p } = r, u.getNodes().filter(Mo).length === p.rows * p.columns)) {
        p = Ke.DEPRECATED_$createGridSelection(), f = e.getKey(), g = e.getFirstChildOrThrow().getFirstChild();
        let h = e.getLastChildOrThrow().getLastChild();
        if (g != null && h != null)
          return p.set(f, g.getKey(), h.getKey()), Ke.$setSelection(p), r.updateTableGridSelection(p), !0;
      }
    }
    return u && !u.is(_) && (Ke.DEPRECATED_$isGridSelection(u) || Ke.DEPRECATED_$isGridSelection(_)) && r.gridSelection && !r.gridSelection.is(_) ? (Ke.DEPRECATED_$isGridSelection(u) && u.gridKey === r.tableNodeKey ? r.updateTableGridSelection(u) : !Ke.DEPRECATED_$isGridSelection(u) && Ke.DEPRECATED_$isGridSelection(_) && _.gridKey === r.tableNodeKey && r.updateTableGridSelection(null), !1) : (r.hasHijackedSelectionStyles && !e.isSelected() ? (Ond(r), a = !1) : !r.hasHijackedSelectionStyles && e.isSelected() && $ee(r), !1);
  }, Ke.COMMAND_PRIORITY_CRITICAL)), r;
};
sr.getCellFromTarget = _x;
sr.getTableSelectionFromTableElement = function(e) {
  return e.__lexicalTableSelection;
};
const Rnd = sr;
var U5 = Rnd;
const Nnd = {
  placeholder: "editor-placeholder",
  paragraph: "editor-paragraph",
  heading: {
    h1: "editor-heading-h1",
    h2: "editor-heading-h2",
    h6: "editor-heading-h6"
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem"
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-listitem"
  },
  image: "editor-image",
  link: "editor-link",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic"
  }
}, Dnd = Nnd;
class wk extends yn.TextNode {
  static getType() {
    return "variable";
  }
  static clone(t) {
    return new wk(t.__text, t.__key);
  }
  constructor(t, n) {
    super(t, n);
  }
  createDOM(t) {
    const n = super.createDOM(t);
    return n.className = "bg-info", n.setAttribute("data-lexical-variable", "true"), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "variable",
      version: 1
    };
  }
  isTextEntity() {
    return !0;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function Hwe(e = "") {
  const t = new wk(e);
  return t.setMode("segmented").toggleDirectionless(), yn.$applyNodeReplacement(t);
}
var j_ = {}, ZC = Ia, wee = za, fi = yn, _r = ve, Mnd = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? _r.useLayoutEffect : _r.useEffect;
let Lnd = class {
  constructor(t) {
    this.key = t, this.ref = { current: null }, this.setRefElement = this.setRefElement.bind(this);
  }
  setRefElement(t) {
    this.ref = { current: t };
  }
}, kee = (e) => {
  var t = document.getElementById("typeahead-menu");
  if (t && (t = t.querySelector(".typeahead-popover"))) {
    var n = t.getBoundingClientRect();
    n.top + n.height > window.innerHeight && t.scrollIntoView({ block: "center" }), 0 > n.top && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
  }
};
function qnd(e, t) {
  var n = window.getSelection();
  if (n === null || !n.isCollapsed)
    return !1;
  let o = n.anchorNode;
  if (n = n.anchorOffset, o == null || n == null)
    return !1;
  try {
    t.setStart(o, e), t.setEnd(o, n);
  } catch {
    return !1;
  }
  return !0;
}
function jnd(e) {
  let t = null;
  return e.getEditorState().read(() => {
    var n = fi.$getSelection();
    if (fi.$isRangeSelection(n)) {
      var o = n.anchor;
      o.type !== "text" ? t = null : (n = o.getNode(), n.isSimpleText() ? (o = o.offset, t = n.getTextContent().slice(0, o)) : t = null);
    }
  }), t;
}
function Fnd(e, t) {
  if (e = fi.$getSelection(), !fi.$isRangeSelection(e) || !e.isCollapsed())
    return null;
  var n = e.anchor;
  if (n.type !== "text" || (e = n.getNode(), !e.isSimpleText()))
    return null;
  n = n.offset;
  let o = e.getTextContent().slice(0, n);
  var r = t.matchingString;
  t = t.replaceableString.length;
  for (let a = t; a <= r.length; a++)
    o.substr(-a) === r.substr(0, a) && (t = a);
  if (t = n - t, 0 > t)
    return null;
  let i;
  return t === 0 ? [i] = e.splitText(n) : [, i] = e.splitText(t, n), i;
}
function Vnd(e, t) {
  return t !== 0 ? !1 : e.getEditorState().read(() => {
    var n = fi.$getSelection();
    return fi.$isRangeSelection(n) ? (n = n.anchor.getNode().getPreviousSibling(), fi.$isTextNode(n) && n.isTextEntity()) : !1;
  });
}
function Kwe(e) {
  _r.startTransition ? _r.startTransition(e) : e();
}
function Ywe(e, t) {
  let n = getComputedStyle(e), o = n.position === "absolute";
  if (t = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, n.position === "fixed")
    return document.body;
  for (; e = e.parentElement; )
    if (n = getComputedStyle(e), (!o || n.position !== "static") && t.test(n.overflow + n.overflowY + n.overflowX))
      return e;
  return document.body;
}
function See(e, t) {
  return e = e.getBoundingClientRect(), t = t.getBoundingClientRect(), e.top > t.top && e.top < t.bottom;
}
function Zwe(e, t, n, o) {
  let [r] = ZC.useLexicalComposerContext();
  _r.useEffect(() => {
    if (t != null && e != null) {
      let i = r.getRootElement(), a = i != null ? Ywe(i, !1) : document.body, s = !1, c = See(t, a), l = function() {
        s || (window.requestAnimationFrame(function() {
          n(), s = !1;
        }), s = !0);
        const u = See(t, a);
        u !== c && (c = u, o != null && o(u));
      }, d = new ResizeObserver(n);
      return window.addEventListener("resize", n), document.addEventListener("scroll", l, { capture: !0, passive: !0 }), d.observe(t), () => {
        d.unobserve(t), window.removeEventListener("resize", n), document.removeEventListener(
          "scroll",
          l
        );
      };
    }
  }, [t, r, o, n, e]);
}
let iq = fi.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
function Qwe({ close: e, editor: t, anchorElementRef: n, resolution: o, options: r, menuRenderFn: i, onSelectOption: a }) {
  let [s, c] = _r.useState(null);
  _r.useEffect(() => {
    c(0);
  }, [o.match.matchingString]);
  let l = _r.useCallback((_) => {
    t.update(() => {
      const p = Fnd(t, o.match);
      a(_, p, e, o.match.matchingString);
    });
  }, [e, t, o.match, a]), d = _r.useCallback((_) => {
    const p = t.getRootElement();
    p !== null && (p.setAttribute("aria-activedescendant", "typeahead-item-" + _), c(_));
  }, [t]);
  _r.useEffect(
    () => () => {
      let _ = t.getRootElement();
      _ !== null && _.removeAttribute("aria-activedescendant");
    },
    [t]
  ), Mnd(() => {
    r === null ? c(null) : s === null && d(0);
  }, [r, s, d]), _r.useEffect(() => wee.mergeRegister(t.registerCommand(iq, ({ option: _ }) => _.ref && _.ref.current != null ? (kee(_.ref.current), !0) : !1, fi.COMMAND_PRIORITY_LOW)), [t, d]), _r.useEffect(() => wee.mergeRegister(
    t.registerCommand(fi.KEY_ARROW_DOWN_COMMAND, (_) => {
      if (r !== null && r.length && s !== null) {
        let p = s !== r.length - 1 ? s + 1 : 0;
        d(p);
        let f = r[p];
        f.ref != null && f.ref.current && t.dispatchCommand(iq, { index: p, option: f }), _.preventDefault(), _.stopImmediatePropagation();
      }
      return !0;
    }, fi.COMMAND_PRIORITY_LOW),
    t.registerCommand(fi.KEY_ARROW_UP_COMMAND, (_) => {
      if (r !== null && r.length && s !== null) {
        var p = s !== 0 ? s - 1 : r.length - 1;
        d(p), p = r[p], p.ref != null && p.ref.current && kee(p.ref.current), _.preventDefault(), _.stopImmediatePropagation();
      }
      return !0;
    }, fi.COMMAND_PRIORITY_LOW),
    t.registerCommand(fi.KEY_ESCAPE_COMMAND, (_) => (_.preventDefault(), _.stopImmediatePropagation(), e(), !0), fi.COMMAND_PRIORITY_LOW),
    t.registerCommand(fi.KEY_TAB_COMMAND, (_) => r === null || s === null || r[s] == null ? !1 : (_.preventDefault(), _.stopImmediatePropagation(), l(r[s]), !0), fi.COMMAND_PRIORITY_LOW),
    t.registerCommand(fi.KEY_ENTER_COMMAND, (_) => r === null || s === null || r[s] == null ? !1 : (_ !== null && (_.preventDefault(), _.stopImmediatePropagation()), l(r[s]), !0), fi.COMMAND_PRIORITY_LOW)
  ), [l, e, t, r, s, d]);
  let u = _r.useMemo(() => ({ options: r, selectOptionAndCleanUp: l, selectedIndex: s, setHighlightedIndex: c }), [l, s, r]);
  return i(n, u, o.match.matchingString);
}
function Jwe(e, t, n) {
  let [o] = ZC.useLexicalComposerContext(), r = _r.useRef(document.createElement("div")), i = _r.useCallback(() => {
    const s = o.getRootElement(), c = r.current;
    if (s !== null && e !== null) {
      const { left: l, top: d, width: u, height: _ } = e.getRect();
      c.style.top = `${d + window.pageYOffset}px`, c.style.left = `${l + window.pageXOffset}px`, c.style.height = `${_}px`, c.style.width = `${u}px`, c.isConnected || (n != null && (c.className = n), c.setAttribute("aria-label", "Typeahead menu"), c.setAttribute("id", "typeahead-menu"), c.setAttribute(
        "role",
        "listbox"
      ), c.style.display = "block", c.style.position = "absolute", document.body.append(c)), r.current = c, s.setAttribute("aria-controls", "typeahead-menu");
    }
  }, [o, e, n]);
  _r.useEffect(() => {
    let s = o.getRootElement();
    if (e !== null)
      return i(), () => {
        s !== null && s.removeAttribute("aria-controls");
        let c = r.current;
        c !== null && c.isConnected && c.remove();
      };
  }, [o, i, e]);
  let a = _r.useCallback((s) => {
    e !== null && (s || t(null));
  }, [e, t]);
  return Zwe(e, r.current, i, a), r;
}
j_.LexicalNodeMenuPlugin = function({ options: e, nodeKey: t, onClose: n, onOpen: o, onSelectOption: r, menuRenderFn: i, anchorClassName: a }) {
  let [s] = ZC.useLexicalComposerContext(), [c, l] = _r.useState(null);
  a = Jwe(c, l, a);
  let d = _r.useCallback(() => {
    l(null), n != null && c !== null && n();
  }, [n, c]), u = _r.useCallback((p) => {
    l(p), o != null && c === null && o(p);
  }, [o, c]), _ = _r.useCallback(() => {
    t ? s.update(() => {
      const p = fi.$getNodeByKey(t), f = s.getElementByKey(t);
      if (p != null && f != null) {
        const g = p.getTextContent();
        c != null && c.match.matchingString === g || Kwe(() => u({ getRect: () => f.getBoundingClientRect(), match: { leadOffset: g.length, matchingString: g, replaceableString: g } }));
      }
    }) : t == null && c != null && d();
  }, [d, s, t, u, c]);
  return _r.useEffect(() => {
    _();
  }, [_, t]), _r.useEffect(() => {
    if (t != null)
      return s.registerUpdateListener(({ dirtyElements: p }) => {
        p.get(t) && _();
      });
  }, [s, _, t]), c === null || s === null ? null : _r.createElement(Qwe, { close: d, resolution: c, editor: s, anchorElementRef: a, options: e, menuRenderFn: i, onSelectOption: r });
};
j_.LexicalTypeaheadMenuPlugin = function({ options: e, onQueryChange: t, onSelectOption: n, onOpen: o, onClose: r, menuRenderFn: i, triggerFn: a, anchorClassName: s }) {
  let [c] = ZC.useLexicalComposerContext(), [l, d] = _r.useState(null);
  s = Jwe(l, d, s);
  let u = _r.useCallback(() => {
    d(null), r != null && l !== null && r();
  }, [r, l]), _ = _r.useCallback((p) => {
    d(p), o != null && l === null && o(p);
  }, [o, l]);
  return _r.useEffect(() => {
    let p = c.registerUpdateListener(() => {
      c.getEditorState().read(() => {
        const f = document.createRange(), g = fi.$getSelection(), h = jnd(c);
        if (fi.$isRangeSelection(g) && g.isCollapsed() && h !== null && f !== null) {
          var b = a(h, c);
          t(b ? b.matchingString : null), b === null || Vnd(c, b.leadOffset) || qnd(b.leadOffset, f) === null ? u() : Kwe(() => _({ getRect: () => f.getBoundingClientRect(), match: b }));
        } else
          u();
      });
    });
    return () => {
      p();
    };
  }, [c, a, t, l, u, _]), l === null || c === null ? null : _r.createElement(Qwe, { close: u, resolution: l, editor: c, anchorElementRef: s, options: e, menuRenderFn: i, onSelectOption: n });
};
j_.PUNCTUATION = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`;
j_.SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND = iq;
j_.TypeaheadOption = Lnd;
j_.getScrollParent = Ywe;
j_.useBasicTypeaheadTriggerMatch = function(e, { minLength: t = 1, maxLength: n = 75 }) {
  return _r.useCallback((o) => {
    if (o = new RegExp("(^|\\s|\\()([" + e + "]((?:[^" + (e + `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;\\s]){0,`) + n + "}))$").exec(o), o !== null) {
      let r = o[1], i = o[3];
      if (i.length >= t)
        return { leadOffset: o.index + r.length, matchingString: i, replaceableString: o[2] };
    }
    return null;
  }, [n, t, e]);
};
j_.useDynamicPositioning = Zwe;
const Bnd = j_;
var aq = Bnd;
function Und(e) {
  const t = e.getTextContent(), n = /\{[^}]+\}/g;
  let o;
  for (let r = 0; r < t.length; r++)
    if (n.lastIndex = r, o = n.exec(t), o !== null) {
      const i = o[0], a = o.index;
      r = a + i.length - 1;
      let s;
      a === 0 ? [s] = e.splitText(a + i.length) : [, s] = e.splitText(a, a + i.length);
      const c = Hwe(i);
      return s.replace(c), c;
    }
  return null;
}
function Wnd(e) {
  Le(() => {
    if (!e.hasNodes([wk])) {
      console.error("VariableNode is not registered in the editor");
      return;
    }
    return e.registerNodeTransform(yn.TextNode, (t) => {
      let n = t;
      for (; n !== null; ) {
        if (!n.isSimpleText())
          return;
        n = Und(n);
      }
    });
  }, [e]);
}
class Gnd extends aq.TypeaheadOption {
  constructor(n) {
    super(n);
    fr(this, "name");
    this.name = n;
  }
}
function Hnd({ variables: e }) {
  const { t } = Fe(), [n] = Ia.useLexicalComposerContext();
  Wnd(n);
  const [o, r] = ze(null), i = aq.useBasicTypeaheadTriggerMatch("{", {
    minLength: 0
  }), a = Tt(() => e.filter((c) => c.toLowerCase().includes((o == null ? void 0 : o.toLowerCase()) ?? "")).map((c) => new Gnd(c)), [e, o]), s = at(
    (c, l, d) => {
      n.update(() => {
        const u = Hwe(
          `{${t(`${c.name}_variable`).toUpperCase().replace(/ /g, "_")}}`
        );
        l && l.replace(u), u.select(), d();
      });
    },
    [n, t]
  );
  return /* @__PURE__ */ m(
    aq.LexicalTypeaheadMenuPlugin,
    {
      onQueryChange: r,
      onSelectOption: s,
      triggerFn: i,
      options: a,
      menuRenderFn: (c, { selectedIndex: l, selectOptionAndCleanUp: d, setHighlightedIndex: u }) => c.current && a.length ? Wv(
        /* @__PURE__ */ m(
          "div",
          {
            className: ae(
              "shadow-dropdown bg-default border-subtle mt-5 w-64 overflow-hidden rounded-md border",
              "typeahead-popover"
              // class required by Lexical
            ),
            children: /* @__PURE__ */ m("ul", { className: "max-h-64 list-none overflow-y-scroll md:max-h-80", children: a.map((_, p) => /* @__PURE__ */ Y(
              "li",
              {
                id: `typeahead-item-${p}`,
                "aria-selected": l === p,
                tabIndex: -1,
                className: "focus:ring-brand-800 hover:bg-subtle hover:text-emphasis text-default aria-selected:bg-subtle aria-selected:text-emphasis cursor-pointer px-4 py-2 text-sm outline-none ring-inset transition first-of-type:rounded-t-[inherit] last-of-type:rounded-b-[inherit] focus:outline-none focus:ring-1",
                ref: _.setRefElement,
                role: "option",
                onClick: () => {
                  u(p), d(_);
                },
                onMouseEnter: () => {
                  u(p);
                },
                children: [
                  /* @__PURE__ */ m("p", { className: "text-sm font-semibold", children: `{${t(`${_.name}_variable`).toUpperCase().replace(/ /g, "_")}}` }),
                  /* @__PURE__ */ m("span", { className: "text-default text-sm", children: t(`${_.name}_info`) })
                ]
              },
              _.key
            )) })
          }
        ),
        c.current
      ) : null
    }
  );
}
var G8 = {}, Nm = vl, Knd = Ia, Ynd = za, y_ = yn, Znd = ve;
function Xwe(e, t) {
  for (let n = 0; n < t.length; n++) {
    let o = t[n](e);
    if (o)
      return o;
  }
  return null;
}
let of = /[.,;\s]/;
function e0e(e) {
  e = e.getPreviousSibling(), y_.$isElementNode(e) && (e = e.getLastDescendant());
  var t;
  return !(t = e === null || y_.$isLineBreakNode(e)) && (t = y_.$isTextNode(e)) && (e = e.getTextContent(), t = of.test(e[e.length - 1])), t;
}
function t0e(e) {
  return e = e.getNextSibling(), y_.$isElementNode(e) && (e = e.getFirstDescendant()), e === null || y_.$isLineBreakNode(e) || y_.$isTextNode(e) && of.test(e.getTextContent()[0]);
}
function W5(e, t, n) {
  var o = e.getChildren();
  let r = o.length;
  for (let i = 0; i < r; i++) {
    let a = o[i];
    if (!y_.$isTextNode(a) || !a.isSimpleText()) {
      mx(e), n(null, e.getURL());
      return;
    }
  }
  o = e.getTextContent(), t = Xwe(o, t), t === null || t.text !== o ? (mx(e), n(null, e.getURL())) : e0e(e) && t0e(e) ? (o = e.getURL(), o !== t.url && (e.setURL(t.url), n(t.url, o)), t.attributes && (o = e.getRel(), o !== t.attributes.rel && (e.setRel(t.attributes.rel || null), n(t.attributes.rel || null, o)), o = e.getTarget(), o !== t.attributes.target && (e.setTarget(t.attributes.target || null), n(t.attributes.target || null, o)))) : (mx(e), n(null, e.getURL()));
}
function mx(e) {
  let t = e.getChildren();
  var n = t.length;
  for (--n; 0 <= n; n--)
    e.insertAfter(t[n]);
  return e.remove(), t.map((o) => o.getLatest());
}
function Qnd(e, t, n) {
  Znd.useEffect(() => {
    if (!e.hasNodes([Nm.AutoLinkNode]))
      throw Error("Minified Lexical error #77; visit https://lexical.dev/docs/error?code=77 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
    let o = (r, i) => {
      n && n(r, i);
    };
    return Ynd.mergeRegister(e.registerNodeTransform(y_.TextNode, (r) => {
      var i = r.getParentOrThrow(), a = r.getPreviousSibling();
      if (Nm.$isAutoLinkNode(i))
        W5(i, t, o);
      else if (!Nm.$isLinkNode(i)) {
        if (r.isSimpleText() && (of.test(r.getTextContent()[0]) || !Nm.$isAutoLinkNode(a))) {
          a = i = r.getTextContent();
          let p = 0, f = r;
          for (var s; (s = Xwe(a, t)) && s !== null; ) {
            let g = s.index, h = s.length, b = g + h;
            var c = p + g, l = p + b, d = i, u = r;
            if ((0 < c ? of.test(d[c - 1]) : e0e(u)) && (l < d.length ? of.test(d[l]) : t0e(u))) {
              var _ = void 0;
              p + g === 0 ? [_, f] = f.splitText(p + h) : [, _, f] = f.splitText(p + g, p + g + h), c = Nm.$createAutoLinkNode(s.url, s.attributes), l = y_.$createTextNode(s.text), l.setFormat(_.getFormat()), l.setDetail(_.getDetail()), c.append(l), _.replace(c), n && n(s.url, null), p = 0;
            } else
              p += b;
            a = a.substring(b);
          }
        }
        i = r.getPreviousSibling(), s = r.getNextSibling(), _ = r.getTextContent(), Nm.$isAutoLinkNode(i) && !of.test(_[0]) && (i.append(r), W5(i, t, o), r = i.getURL(), n && n(null, r)), Nm.$isAutoLinkNode(s) && !of.test(_[_.length - 1]) && (mx(s), W5(s, t, o), r = s.getURL(), n && n(null, r));
      }
    }));
  }, [e, t, n]);
}
G8.AutoLinkPlugin = function({ matchers: e, onChange: t }) {
  let [n] = Knd.useLexicalComposerContext();
  return Qnd(n, e, t), null;
};
G8.createLinkMatcherWithRegExp = function(e, t = (n) => n) {
  return (n) => {
    let o = e.exec(n);
    return o === null ? null : { index: o.index, length: o[0].length, text: o[0], url: t(n) };
  };
};
const Jnd = G8;
var Xnd = Jnd;
const eod = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/, tod = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, nod = [
  (e) => {
    const t = eod.exec(e);
    return t && {
      index: t.index,
      length: t[0].length,
      text: t[0],
      url: t[0]
    };
  },
  (e) => {
    const t = tod.exec(e);
    return t && {
      index: t.index,
      length: t[0].length,
      text: t[0],
      url: `mailto:${t[0]}`
    };
  }
];
function ood() {
  return /* @__PURE__ */ m(Xnd.AutoLinkPlugin, { matchers: nod });
}
function rod({ editable: e }) {
  const [t] = Ia.useLexicalComposerContext();
  return t.setEditable(e), null;
}
function iod({ setText: e, plainText: t }) {
  const [n] = Ia.useLexicalComposerContext();
  return Le(() => n.registerUpdateListener(({ editorState: o }) => {
    o.read(() => {
      if (t) {
        const r = yn.$getRoot().getTextContent();
        e(r);
      }
    });
  }), [t]), null;
}
const aod = (e) => {
  const { t } = Fe(), [n, o] = ze(""), r = zE("(max-width: 640px)"), i = Tt(() => {
    const a = n.trim().toLowerCase();
    return a ? e.variables.filter((s) => {
      const c = s.toLowerCase(), l = t(`${s}_variable`).toLowerCase(), d = t(`${s}_info`).toLowerCase();
      return c.includes(a) || l.includes(a) || d.includes(a);
    }) : e.variables;
  }, [e.variables, n, t]);
  return /* @__PURE__ */ Y(
    El,
    {
      onOpenChange: (a) => {
        a || o("");
      },
      children: [
        /* @__PURE__ */ m(Bc, { "aria-label": "Add variable", className: "focus:bg-muted pt-[6px]", children: /* @__PURE__ */ m("div", { className: "items-center", children: e.isTextEditor ? /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ Y("div", { className: "hidden sm:flex", children: [
            t("add_variable"),
            /* @__PURE__ */ m(ot, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
          ] }),
          /* @__PURE__ */ m("div", { className: "block sm:hidden", children: e.addVariableButtonTop ? /* @__PURE__ */ Y("div", { className: "flex", children: [
            t("add_variable"),
            /* @__PURE__ */ m(ot, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
          ] }) : "+" })
        ] }) : /* @__PURE__ */ Y("div", { className: "flex", children: [
          t("add_variable"),
          /* @__PURE__ */ m(ot, { name: "chevron-down", className: "ml-1 mt-[2px] h-4 w-4" })
        ] }) }) }),
        /* @__PURE__ */ m(Uc, { className: "w-52", children: /* @__PURE__ */ Y("div", { className: "space-y-2 p-1", children: [
          /* @__PURE__ */ m("div", { className: "text-muted ml-1 text-left text-xs font-medium tracking-wide", children: t("add_dynamic_variables") }),
          /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
            Sc,
            {
              type: "text",
              size: "sm",
              value: n,
              onChange: (a) => o(a.target.value),
              placeholder: t("search_variables"),
              "aria-label": t("search_variables"),
              className: "border-subtle bg-default focus:ring-brand-800 w-full rounded-md border px-3 py-2 text-sm outline-none focus:ring-1"
            }
          ) }),
          /* @__PURE__ */ m("div", { className: "max-h-64 overflow-y-auto overflow-x-hidden md:max-h-80", children: i.length === 0 ? /* @__PURE__ */ m("div", { className: "text-subtle px-4 py-2 text-center text-sm", children: t("no_variables_found") }) : i.map((a) => /* @__PURE__ */ m(Er, { className: "w-full p-1 hover:ring-0", children: /* @__PURE__ */ m(
            "div",
            {
              className: "w-full cursor-pointer rounded-md text-left transition-colors",
              onClick: () => {
                e.addVariable(t(`${a}_variable`)), o("");
              },
              children: /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ m(
                  "div",
                  {
                    className: ae(
                      "text-default font-mono text-sm",
                      r ? "break-all" : "truncate"
                    ),
                    children: `{${t(`${a}_variable`).toUpperCase().replace(/ /g, "_")}}`
                  }
                ),
                /* @__PURE__ */ m("div", { className: "text-muted hidden text-xs sm:block", children: t(`${a}_info`) })
              ] })
            },
            a
          ) }, a)) })
        ] }) })
      ]
    }
  );
}, n0e = 1, G5 = {
  paragraph: "Normal",
  ol: "Numbered List",
  ul: "Bulleted List",
  h1: "Large Heading",
  h2: "Small Heading"
};
function xee(e, t) {
  if (t === null)
    e.style.opacity = "0", e.style.top = "-1000px", e.style.left = "-1000px";
  else {
    e.style.opacity = "1";
    let n = t.top + t.height + window.pageYOffset + 10, o = t.left + window.pageXOffset - e.offsetWidth / 2 + t.width / 2;
    const r = window.innerWidth, i = window.innerHeight, a = e.offsetWidth || 300, s = e.offsetHeight || 100;
    o < 10 ? o = 10 : o + a > r - 10 && (o = r - a - 10), n + s > window.pageYOffset + i - 10 && (n = t.top + window.pageYOffset - s - 10, n < window.pageYOffset + 10 && (n = window.pageYOffset + 10)), e.style.top = `${n}px`, e.style.left = `${o}px`;
  }
}
function sod({ editor: e }) {
  const t = Ue(null), n = Ue(!1), o = Ue(null), [r, i] = ze(""), [a, s] = ze(!0), [c, l] = ze(
    null
  ), d = at(() => {
    const u = yn.$getSelection();
    if (yn.$isRangeSelection(u)) {
      const h = o0e(u), b = h.getParent();
      vl.$isLinkNode(b) ? i(b.getURL()) : vl.$isLinkNode(h) ? i(h.getURL()) : i("");
    }
    const _ = t.current, p = window.getSelection(), f = document.activeElement;
    if (_ === null)
      return;
    const g = e.getRootElement();
    if (u !== null && !(p != null && p.isCollapsed) && g !== null && g.contains((p == null ? void 0 : p.anchorNode) || null)) {
      const h = p == null ? void 0 : p.getRangeAt(0);
      let b;
      if ((p == null ? void 0 : p.anchorNode) === g) {
        let v = g;
        for (; v.firstElementChild != null; )
          v = v.firstElementChild;
        b = v.getBoundingClientRect();
      } else
        b = h == null ? void 0 : h.getBoundingClientRect();
      n.current || xee(_, b || null), l(u);
    } else
      (!f || f.className !== "link-input") && (xee(_, null), l(null), s(!1), i(""));
    return !0;
  }, [e]);
  return Le(() => za.mergeRegister(
    e.registerUpdateListener(({ editorState: u }) => {
      u.read(() => {
        d();
      });
    }),
    e.registerCommand(
      yn.SELECTION_CHANGE_COMMAND,
      () => (d(), !0),
      n0e
    )
  ), [e, d]), Le(() => {
    e.getEditorState().read(() => {
      d();
    });
  }, [e, d]), Le(() => {
    a && o.current && o.current.focus();
  }, [a]), /* @__PURE__ */ m("div", { ref: t, className: "link-editor", children: a ? /* @__PURE__ */ m(
    "input",
    {
      ref: o,
      className: "link-input",
      value: r,
      onChange: (u) => {
        i(u.target.value);
      },
      onKeyDown: (u) => {
        u.key === "Enter" ? (u.preventDefault(), c !== null && (r !== "" && e.dispatchCommand(vl.TOGGLE_LINK_COMMAND, r), s(!1))) : u.key === "Escape" && (u.preventDefault(), s(!1));
      }
    }
  ) : /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y("div", { className: "link-input", children: [
    /* @__PURE__ */ m("a", { href: r, target: "_blank", rel: "noopener noreferrer", children: r }),
    /* @__PURE__ */ m(
      "div",
      {
        className: "link-edit",
        role: "button",
        tabIndex: 0,
        onMouseDown: (u) => u.preventDefault(),
        onClick: () => {
          s(!0);
        }
      }
    )
  ] }) }) });
}
function o0e(e) {
  const t = e.anchor, n = e.focus, o = e.anchor.getNode(), r = e.focus.getNode();
  return o === r ? o : e.isBackward() ? b_.$isAtNodeEnd(n) ? o : r : b_.$isAtNodeEnd(t) ? r : o;
}
function cod(e) {
  var k, S, O, I;
  const [t] = Ia.useLexicalComposerContext(), n = Ue(null), [o, r] = ze("paragraph"), [i, a] = ze(!1), [s, c] = ze(!1), [l, d] = ze(!1), u = () => {
    o !== "paragraph" && t.update(() => {
      const D = yn.$getSelection();
      yn.$isRangeSelection(D) && b_.$wrapNodes(D, () => yn.$createParagraphNode());
    });
  }, _ = () => {
    o !== "h1" && t.update(() => {
      const D = yn.$getSelection();
      yn.$isRangeSelection(D) && b_.$wrapNodes(D, () => Rf.$createHeadingNode("h1"));
    });
  }, p = () => {
    o !== "h2" && t.update(() => {
      const D = yn.$getSelection();
      yn.$isRangeSelection(D) && b_.$wrapNodes(D, () => Rf.$createHeadingNode("h2"));
    });
  }, f = () => {
    o !== "ul" ? t.dispatchCommand(ul.INSERT_UNORDERED_LIST_COMMAND, void 0) : t.dispatchCommand(ul.REMOVE_LIST_COMMAND, void 0);
  }, g = () => {
    o !== "ol" ? t.dispatchCommand(ul.INSERT_ORDERED_LIST_COMMAND, void 0) : t.dispatchCommand(ul.REMOVE_LIST_COMMAND, void 0);
  }, h = (D) => {
    switch (D) {
      case "paragraph":
        u();
        break;
      case "ul":
        f();
        break;
      case "ol":
        g();
        break;
      case "h1":
        _();
        break;
      case "h2":
        p();
        break;
    }
  }, b = at(() => {
    const D = yn.$getSelection();
    if (yn.$isRangeSelection(D)) {
      const M = D.anchor.getNode(), N = M.getKey() === "root" ? M : M.getTopLevelElementOrThrow(), C = N.getKey();
      if (t.getElementByKey(C) !== null)
        if (ul.$isListNode(N)) {
          const E = za.$getNearestNodeOfType(M, ul.ListNode), T = E ? E.getTag() : N.getTag();
          r(T);
        } else {
          const E = Rf.$isHeadingNode(N) ? N.getTag() : N.getType();
          r(E);
        }
      c(D.hasFormat("bold")), d(D.hasFormat("italic"));
      const x = o0e(D), w = x.getParent();
      vl.$isLinkNode(w) || vl.$isLinkNode(x) ? a(!0) : a(!1);
    }
  }, [t]), v = (D) => {
    t.update(() => {
      const M = yn.$getSelection();
      yn.$isRangeSelection(M) && t.update(() => {
        const N = `{${D.toUpperCase().replace(/ /g, "_")}}`;
        M == null || M.insertRawText(N);
      });
    });
  };
  Le(() => {
    e.firstRender || t.update(() => {
      const D = yn.$getRoot();
      D && t.update(() => {
        const N = new DOMParser().parseFromString(e.getText(), "text/html"), C = lx.$generateNodesFromDOM(t, N), P = yn.$createParagraphNode();
        D.clear().append(P), P.select(), yn.$insertNodes(C);
      });
    });
  }, [e.updateTemplate]), Le(() => {
    e.setFirstRender && (e.setFirstRender(!1), t.update(() => {
      if (yn.$getRoot().getTextContent().trim())
        return;
      const N = new DOMParser().parseFromString(e.getText(), "text/html"), C = lx.$generateNodesFromDOM(t, N);
      yn.$getRoot().select();
      try {
        yn.$insertNodes(C);
      } catch {
        const P = yn.$createParagraphNode();
        C.forEach((x) => P.append(x)), yn.$getRoot().append(P);
      }
      t.registerUpdateListener(({ editorState: P, prevEditorState: x }) => {
        P.read(() => {
          const w = lx.$generateHtmlFromNodes(t).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
          e.setText(
            w.replace(
              /<p\s+class="editor-paragraph"[^>]*>\s*<br>\s*<\/p>/g,
              "<p class='editor-paragraph'></p>"
            )
          );
        }), x._selection || t.blur();
      });
    }));
  }, []), Le(() => za.mergeRegister(
    t.registerUpdateListener(({ editorState: D }) => {
      D.read(() => {
        b();
      });
    }),
    t.registerCommand(
      yn.SELECTION_CHANGE_COMMAND,
      (D, M) => (b(), !1),
      n0e
    )
  ), [t, b]);
  const $ = at(() => {
    i ? t.dispatchCommand(vl.TOGGLE_LINK_COMMAND, null) : t.dispatchCommand(vl.TOGGLE_LINK_COMMAND, "https://");
  }, [t, i]);
  return e.editable ? /* @__PURE__ */ m("div", { className: "toolbar flex", ref: n, children: /* @__PURE__ */ Y(Ce, { children: [
    !((k = e.excludedToolbarItems) != null && k.includes("blockType")) && /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(El, { children: [
      /* @__PURE__ */ m(Bc, { className: "text-subtle", children: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("span", { className: `icon${o}` }),
        /* @__PURE__ */ m("span", { className: "text text-default hidden sm:flex", children: G5[o] }),
        /* @__PURE__ */ m(ot, { name: "chevron-down", className: "text-default ml-2 h-4 w-4" })
      ] }) }),
      /* @__PURE__ */ m(Uc, { align: "start", children: Object.keys(G5).map((D) => /* @__PURE__ */ m(Er, { className: "outline-none hover:ring-0 focus:ring-0", children: /* @__PURE__ */ m(
        ut,
        {
          color: "minimal",
          type: "button",
          onClick: () => h(D),
          className: ci(
            "w-full rounded-none focus:ring-0",
            o === D ? "bg-subtle w-full" : ""
          ),
          children: /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m("span", { className: `icon block-type ${D}` }),
            /* @__PURE__ */ m("span", { children: G5[D] })
          ] })
        }
      ) }, D)) })
    ] }) }),
    /* @__PURE__ */ Y("div", { className: "flex gap-1", children: [
      !((S = e.excludedToolbarItems) != null && S.includes("bold")) && /* @__PURE__ */ m(
        ut,
        {
          "aria-label": "Bold",
          color: "minimal",
          variant: "icon",
          type: "button",
          StartIcon: "bold",
          onClick: () => {
            t.dispatchCommand(yn.FORMAT_TEXT_COMMAND, "bold");
          },
          className: s ? "bg-subtle" : ""
        }
      ),
      !((O = e.excludedToolbarItems) != null && O.includes("italic")) && /* @__PURE__ */ m(
        ut,
        {
          "aria-label": "Italic",
          color: "minimal",
          variant: "icon",
          type: "button",
          StartIcon: "italic",
          onClick: () => {
            t.dispatchCommand(yn.FORMAT_TEXT_COMMAND, "italic");
          },
          className: l ? "bg-subtle" : ""
        }
      ),
      !((I = e.excludedToolbarItems) != null && I.includes("link")) && /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(
          ut,
          {
            "aria-label": "Link",
            color: "minimal",
            variant: "icon",
            type: "button",
            StartIcon: "link",
            onClick: $,
            className: i ? "bg-subtle" : ""
          }
        ),
        i && Wv(/* @__PURE__ */ m(sod, { editor: t }), document.body),
        " "
      ] })
    ] }),
    e.variables && /* @__PURE__ */ m("div", { className: `${e.addVariableButtonTop ? "-mt-10" : ""} ml-auto`, children: /* @__PURE__ */ m(
      aod,
      {
        addVariable: v,
        isTextEditor: !0,
        variables: e.variables || [],
        addVariableButtonTop: e.addVariableButtonTop
      }
    ) })
  ] }) }) : null;
}
const lod = () => {
  const [e] = Ia.useLexicalComposerContext();
  return Le(() => {
    const t = e.registerCommand(
      yn.KEY_ENTER_COMMAND,
      (n) => {
        const o = yn.$getSelection();
        if (yn.$isRangeSelection(o)) {
          const r = o.anchor.getNode();
          if (ul.$isListItemNode(r) || ul.$isListItemNode(r.getParent()))
            return !1;
          n.preventDefault();
          const i = yn.$createLineBreakNode();
          return o.insertNodes([i]), !0;
        }
        return !1;
      },
      yn.COMMAND_PRIORITY_HIGH
    );
    return () => {
      t();
    };
  }, [e]), null;
}, dod = lod, uod = {
  theme: Dnd,
  onError(e) {
    throw e;
  },
  namespace: "",
  nodes: [
    Rf.HeadingNode,
    ul.ListNode,
    ul.ListItemNode,
    Rf.QuoteNode,
    KL.CodeNode,
    KL.CodeHighlightNode,
    U5.TableNode,
    U5.TableCellNode,
    U5.TableRowNode,
    vl.AutoLinkNode,
    vl.LinkNode,
    wk
  ]
}, H8 = (e) => {
  const t = e.editable ?? !0, n = e.plainText ?? !1;
  return /* @__PURE__ */ Y("div", { className: "editor rounded-md", children: [
    e.label && /* @__PURE__ */ m(
      "label",
      {
        onClick: () => {
          const o = document.getElementById("custom-editor");
          o == null || o.focus();
        },
        className: "mb-1 block text-sm font-medium leading-6",
        children: e.label
      }
    ),
    /* @__PURE__ */ Y(gtd.LexicalComposer, { initialConfig: { ...uod }, children: [
      /* @__PURE__ */ Y("div", { className: "editor-container hover:border-emphasis focus-within:ring-brand-default !rounded-lg p-0 transition focus-within:ring-2 focus-within:ring-offset-0", children: [
        /* @__PURE__ */ m(
          cod,
          {
            getText: e.getText,
            setText: e.setText,
            editable: t,
            excludedToolbarItems: e.excludedToolbarItems,
            variables: e.variables,
            addVariableButtonTop: e.addVariableButtonTop,
            updateTemplate: e.updateTemplate,
            firstRender: e.firstRender,
            setFirstRender: e.setFirstRender
          }
        ),
        /* @__PURE__ */ Y(
          "div",
          {
            className: ae("editor-inner scroll-bar overflow-x-hidden", !t && "!bg-subtle"),
            style: { height: e.height, maxHeight: e.maxHeight },
            children: [
              /* @__PURE__ */ m(
                And.RichTextPlugin,
                {
                  contentEditable: /* @__PURE__ */ m(
                    ytd.ContentEditable,
                    {
                      id: "custom-editor",
                      readOnly: !t,
                      style: { height: e.height },
                      className: "editor-input focus:outline-none",
                      "data-testid": "editor-input"
                    }
                  ),
                  placeholder: e != null && e.placeholder ? /* @__PURE__ */ m("div", { className: "text-muted -mt-11 p-3 text-sm", children: e.placeholder }) : null,
                  ErrorBoundary: Ttd
                }
              ),
              /* @__PURE__ */ m(Gtd.ListPlugin, {}),
              /* @__PURE__ */ m(Ftd.LinkPlugin, {}),
              /* @__PURE__ */ m(ood, {}),
              /* @__PURE__ */ m(dod, {}),
              e != null && e.variables ? /* @__PURE__ */ m(Hnd, { variables: e.variables }) : null,
              /* @__PURE__ */ m(Dtd.HistoryPlugin, {}),
              /* @__PURE__ */ m(
                snd.MarkdownShortcutPlugin,
                {
                  transformers: e.disableLists ? nq.TRANSFORMERS.filter((o, r) => {
                    if (r !== 3 && r !== 4)
                      return o;
                  }) : nq.TRANSFORMERS
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ m(rod, { editable: t }),
      /* @__PURE__ */ m(iod, { setText: e.setText, plainText: n })
    ] })
  ] });
};
function _od({
  form: e,
  isManagedEventType: t,
  handleSubmit: n,
  pageSlug: o,
  isPending: r,
  urlPrefix: i,
  SubmitButton: a
}) {
  const s = Zo(), { t: c } = Fe(), [l, d] = ze(!0), { register: u } = e;
  return /* @__PURE__ */ Y(
    fd,
    {
      form: e,
      handleSubmit: (_) => {
        n(_);
      },
      children: [
        /* @__PURE__ */ Y("div", { className: "mt-3 space-y-6 pb-11", children: [
          /* @__PURE__ */ m(
            Io,
            {
              label: c("title"),
              placeholder: c("quick_chat"),
              "data-testid": "event-type-quick-chat",
              ...u("title"),
              onChange: (_) => {
                e.setValue("title", _ == null ? void 0 : _.target.value), e.formState.touchedFields.slug === void 0 && e.setValue("slug", xf(_ == null ? void 0 : _.target.value));
              }
            }
          ),
          i && i.length >= 21 ? /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ m(
              Io,
              {
                label: s ? "Slug" : `${c("url")}: ${i}`,
                required: !0,
                addOnLeading: s ? void 0 : /* @__PURE__ */ m("span", { className: "max-w-24 md:max-w-56", children: `/${t ? c("username_placeholder") : o}/` }),
                containerClassName: "[&>div]:gap-0",
                className: "pl-0",
                ...u("slug"),
                onChange: (_) => {
                  e.setValue("slug", xf(_ == null ? void 0 : _.target.value), { shouldTouch: !0 });
                }
              }
            ),
            t && !s && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: c("managed_event_url_clarification") })
          ] }) : /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ m(
              Io,
              {
                label: s ? "Slug" : c("url"),
                required: !0,
                addOnLeading: s ? void 0 : /* @__PURE__ */ m(
                  Ao,
                  {
                    content: `${i}/${t ? c("username_placeholder") : o}/`,
                    children: /* @__PURE__ */ m("span", { className: "max-w-24 md:max-w-56", children: `${i}/${t ? c("username_placeholder") : o}/` })
                  }
                ),
                containerClassName: "[&>div]:gap-0",
                className: "pl-0",
                ...u("slug"),
                onChange: (_) => {
                  e.setValue("slug", xf(_ == null ? void 0 : _.target.value), { shouldTouch: !0 });
                }
              }
            ),
            t && !s && /* @__PURE__ */ m("p", { className: "mt-2 text-sm text-gray-600", children: c("managed_event_url_clarification") })
          ] }),
          /* @__PURE__ */ Y(Ce, { children: [
            s ? /* @__PURE__ */ m(B_e, { ...u("description"), placeholder: c("quick_video_meeting") }) : /* @__PURE__ */ m(
              H8,
              {
                label: c("description"),
                getText: () => TC.render(e.getValues("description") || ""),
                setText: (_) => e.setValue("description", r8(_)),
                excludedToolbarItems: ["blockType", "link"],
                placeholder: c("quick_video_meeting"),
                firstRender: l,
                setFirstRender: d,
                maxHeight: "200px"
              }
            ),
            /* @__PURE__ */ m("div", { className: "relative", children: /* @__PURE__ */ m(
              Io,
              {
                type: "number",
                required: !0,
                min: Mh,
                max: Dh,
                placeholder: "15",
                label: c("duration"),
                className: "pr-4",
                ...u("length", {
                  valueAsNumber: !0,
                  min: {
                    value: Mh,
                    message: c("duration_min_error", { min: Mh })
                  },
                  max: {
                    value: Dh,
                    message: c("duration_max_error", { max: Dh })
                  }
                }),
                addOnSuffix: c("minutes").toLowerCase()
              }
            ) })
          ] })
        ] }),
        a(r)
      ]
    }
  );
}
const Ga = ({ t: e, i18nKey: t, href: n }) => {
  if (!Uce) {
    const o = e(t).replace(/<0>[\s\S]*?<\/0>/g, "").trim();
    return /* @__PURE__ */ m(Ce, { children: o });
  }
  return /* @__PURE__ */ m(
    Dc,
    {
      t: e,
      i18nKey: t,
      components: [
        /* @__PURE__ */ m(
          Po,
          {
            className: "underline underline-offset-2",
            target: "_blank",
            rel: "noopener noreferrer",
            href: n,
            children: "Learn more"
          },
          t
        )
      ]
    }
  );
}, pod = /* @__PURE__ */ Oa(Ipl);
function K8(e, t) {
  if (!e || !t || !e.length || !t.length)
    throw new Error("Bad alphabet");
  this.srcAlphabet = e, this.dstAlphabet = t;
}
K8.prototype.convert = function(e) {
  var t, n, o, r = {}, i = this.srcAlphabet.length, a = this.dstAlphabet.length, s = e.length, c = typeof e == "string" ? "" : [];
  if (!this.isValid(e))
    throw new Error('Number "' + e + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
  if (this.srcAlphabet === this.dstAlphabet)
    return e;
  for (t = 0; t < s; t++)
    r[t] = this.srcAlphabet.indexOf(e[t]);
  do {
    for (n = 0, o = 0, t = 0; t < s; t++)
      n = n * i + r[t], n >= a ? (r[o++] = parseInt(n / a, 10), n = n % a) : o > 0 && (r[o++] = 0);
    s = o, c = this.dstAlphabet.slice(n, n + 1).concat(c);
  } while (o !== 0);
  return c;
};
K8.prototype.isValid = function(e) {
  for (var t = 0; t < e.length; ++t)
    if (this.srcAlphabet.indexOf(e[t]) === -1)
      return !1;
  return !0;
};
var mod = K8, fod = mod;
function kk(e, t) {
  var n = new fod(e, t);
  return function(o) {
    return n.convert(o);
  };
}
kk.BIN = "01";
kk.OCT = "01234567";
kk.DEC = "0123456789";
kk.HEX = "0123456789abcdef";
var god = kk;
const { v4: H5 } = pod, uS = god, K5 = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ", hod = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~", vod = {
  consistentLength: !0
};
let Y5;
const Eee = (e, t, n) => {
  const o = t(e.toLowerCase().replace(/-/g, ""));
  return !n || !n.consistentLength ? o : o.padStart(
    n.shortIdLength,
    n.paddingChar
  );
}, bod = (e, t) => {
  const o = t(e).padStart(32, "0").match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
  return [o[1], o[2], o[3], o[4], o[5]].join("-");
}, yod = (e) => Math.ceil(Math.log(2 ** 128) / Math.log(e));
var $od = (() => {
  const e = (t, n) => {
    const o = t || K5, r = { ...vod, ...n };
    if ([...new Set(Array.from(o))].length !== o.length)
      throw new Error("The provided Alphabet has duplicate characters resulting in unreliable results");
    const i = yod(o.length), a = {
      shortIdLength: i,
      consistentLength: r.consistentLength,
      paddingChar: o[0]
    }, s = uS(uS.HEX, o), c = uS(o, uS.HEX), l = () => Eee(H5(), s, a), d = {
      new: l,
      generate: l,
      uuid: H5,
      fromUUID: (u) => Eee(u, s, a),
      toUUID: (u) => bod(u, c),
      alphabet: o,
      maxLength: i
    };
    return Object.freeze(d), d;
  };
  return e.constants = {
    flickrBase58: K5,
    cookieBase90: hod
  }, e.uuid = H5, e.generate = () => (Y5 || (Y5 = e(K5).generate), Y5()), e;
})();
const wod = /* @__PURE__ */ Zr($od), r0e = (e) => {
  const t = wod(), n = `${e}:${(/* @__PURE__ */ new Date()).getTime()}`;
  return t.fromUUID(vL(n, vL.URL));
};
function kod(e) {
  var t, n, o, r, i, a, s, c;
  if (e != null && e.userId && ((t = e == null ? void 0 : e.owner) != null && t.timeZone))
    return e.owner.timeZone;
  if (e != null && e.teamId) {
    if (e.hosts && e.hosts.length > 0 && ((o = (n = e.hosts[0]) == null ? void 0 : n.user) != null && o.timeZone))
      return e.hosts[0].user.timeZone;
    if ((r = e.team) != null && r.members && e.team.members.length > 0 && ((a = (i = e.team.members[0]) == null ? void 0 : i.user) != null && a.timeZone))
      return (c = (s = e.team.members[0]) == null ? void 0 : s.user) == null ? void 0 : c.timeZone;
  }
  return De.tz.guess();
}
function Sod(e, t) {
  if (!e)
    return !1;
  if (t) {
    const n = De().tz(t);
    return De(e).tz(t).isBefore(n);
  } else {
    const n = De();
    return De(e).isBefore(n);
  }
}
function xod(e, t) {
  return !t || t <= 0 ? !1 : e >= t;
}
function Eod(e, t) {
  return e.expiresAt ? Sod(e.expiresAt, t) : xod(e.usageCount || 0, e.maxUsageCount);
}
function Tod() {
  const [e, t] = ze(!1), n = () => {
  }, o = (a, s = {}) => {
    const { onSuccess: c = n, onFailure: l = n } = s;
    typeof navigator < "u" && navigator.clipboard ? navigator.clipboard.writeText(a).then(() => {
      t(!0), c();
    }).catch((d) => {
      l(), console.error("Copy to clipboard failed:", d);
    }) : (console.warn(
      `You need to use a secure context to use clipboard 
 Please use the following link: `,
      a
    ), l());
  }, r = () => {
    t(!1);
  }, i = (a, s = {}) => {
    var d;
    const { onSuccess: c = n, onFailure: l = n } = s;
    if ((d = navigator.clipboard) != null && d.write) {
      const u = new ClipboardItem({
        "text/plain": a.then((_) => new Blob([_], { type: "text/plain" })).catch(() => (l(), ""))
      });
      navigator.clipboard.write([u]), c();
    } else
      a.then((u) => o(u, s)).catch(() => l());
  };
  return Le(() => {
    if (e) {
      const a = setTimeout(r, 3e3);
      return () => clearTimeout(a);
    }
  }, [e]), { isCopied: e, copyToClipboard: o, resetCopyStatus: r, fetchAndCopyToClipboard: i };
}
const Aod = ({
  team: e,
  bookerUrl: t,
  setMultiplePrivateLinksVisible: n,
  userTimeZone: o
}) => {
  const r = Dn(), { t: i } = Fe(), { copyToClipboard: a } = Tod(), [s] = xl(), [c, l] = ze(!1), [d, u] = ze(null), [_, p] = ze("usage"), [f, g] = ze(/* @__PURE__ */ new Date()), [h, b] = ze(1), v = (k, S, O, I) => {
    if (k === null)
      return;
    const M = (r.getValues("multiplePrivateLinks") || []).map(
      (N) => typeof N == "string" ? { link: N, expiresAt: null, maxUsageCount: 1, usageCount: 0 } : N
    );
    if (S === "time") {
      const C = De(O || f).format("YYYY-MM-DD"), P = De.utc(`${C}T23:59:59.999Z`).toDate();
      M[k] = {
        ...M[k],
        expiresAt: P,
        maxUsageCount: null
      };
    } else
      S === "usage" && (M[k] = {
        ...M[k],
        expiresAt: null,
        maxUsageCount: I !== void 0 ? I : h
      });
    r.setValue("multiplePrivateLinks", M, {
      shouldDirty: !0,
      shouldTouch: !0,
      shouldValidate: !0
    });
  }, $ = (k, S) => {
    if (u(k), S.expiresAt) {
      p("time");
      const O = De.utc(S.expiresAt).format("YYYY-MM-DD");
      g(De(O).toDate());
    } else
      p("usage"), b(S.maxUsageCount ?? 1);
    l(!0);
  };
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      Wt,
      {
        name: "multiplePrivateLinks",
        control: r.control,
        render: ({ field: { value: k, onChange: S } }) => {
          k || (k = []);
          const O = k.map(
            (w) => typeof w == "string" ? { link: w, expiresAt: null, maxUsageCount: null, usageCount: 0 } : w
          ), { data: I } = bo.viewer.eventTypes.getHashedLinks.useQuery(
            { linkIds: O.map((w) => w.link) },
            {
              enabled: O.length > 0,
              refetchOnMount: !0
            }
          ), D = new Map((I == null ? void 0 : I.map((w) => [w.linkId, w])) || []), M = () => {
            var z, j;
            const w = ((j = (z = r.getValues("users")) == null ? void 0 : z[0]) == null ? void 0 : j.id) ?? (e == null ? void 0 : e.id);
            if (!w)
              return;
            const E = {
              link: r0e(w),
              expiresAt: null,
              maxUsageCount: 1,
              usageCount: 0
            }, T = [...O, E];
            S(T);
          }, N = (w) => {
            const E = [...O];
            E.splice(w, 1), S(E), E.length === 0 && n && n(!1);
          }, C = (w) => {
            const E = D.get(w.link), T = (E == null ? void 0 : E.usageCount) ?? (w.usageCount || 0);
            return Eod(
              {
                expiresAt: w.expiresAt,
                maxUsageCount: w.maxUsageCount,
                usageCount: T
              },
              o
            );
          }, P = (w, E) => {
            const T = C(w), z = E ?? (w.usageCount || 0);
            if (w.expiresAt) {
              const j = De.utc(w.expiresAt).format("MMM DD, YYYY");
              return T ? i("link_expired_on_date", { date: j }) : i("expires_on_date", { date: j });
            } else if (w.maxUsageCount !== void 0 && w.maxUsageCount !== null && !isNaN(Number(w.maxUsageCount))) {
              const j = w.maxUsageCount, q = j - z;
              return T ? i("usage_limit_reached") : q === 1 ? i("remainder_of_maximum_use_left_singular", {
                remainder: q,
                maximum: j
              }) : i("remainder_of_maximum_uses_left_plural", {
                remainder: q,
                maximum: j
              });
            }
            return i("remainder_of_maximum_use_left_singular", {
              remainder: "1",
              maximum: "1"
            });
          }, x = O.map((w, E) => {
            const T = C(w), z = !!w.expiresAt, j = z ? new Date(w.expiresAt).getTime() : null;
            return {
              val: w,
              originalIndex: E,
              expired: T,
              hasExpiry: z,
              expiryTime: j
            };
          }).sort((w, E) => w.expired !== E.expired ? w.expired ? 1 : -1 : !w.expired && !E.expired ? w.hasExpiry !== E.hasExpiry ? w.hasExpiry ? -1 : 1 : w.hasExpiry && E.hasExpiry ? w.expiryTime - E.expiryTime : E.originalIndex - w.originalIndex : w.originalIndex - E.originalIndex);
          return /* @__PURE__ */ Y("ul", { ref: s, children: [
            x.map(({ val: w, originalIndex: E }, T) => {
              const z = `${t}/d/${w.link}/${r.getValues("slug")}`, j = D.get(w.link), q = (j == null ? void 0 : j.usageCount) ?? (w.usageCount || 0), V = C(w), F = P(w, q);
              return /* @__PURE__ */ Y("li", { "data-testid": "add-single-use-link", className: "mb-4 flex flex-col", children: [
                /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
                  /* @__PURE__ */ m(
                    Io,
                    {
                      containerClassName: ae("w-full"),
                      disabled: V,
                      value: z,
                      readOnly: !0,
                      className: ae(V ? "bg-red-50 text-gray-400" : "bg-gray-50"),
                      "data-testid": "private-link-url",
                      addOnSuffix: V ? /* @__PURE__ */ m(Nr, { "data-testid": "private-link-expired", variant: "red", children: i("expired") }) : /* @__PURE__ */ m(Ao, { content: i("copy_link"), children: /* @__PURE__ */ m(
                        ut,
                        {
                          type: "button",
                          color: "minimal",
                          size: "sm",
                          StartIcon: "copy",
                          onClick: () => {
                            a(z), nr(i("link_copied"), "success");
                          }
                        }
                      ) })
                    }
                  ),
                  /* @__PURE__ */ Y("div", { className: "ml-2 flex items-center", children: [
                    !V && /* @__PURE__ */ m(
                      ut,
                      {
                        type: "button",
                        color: "minimal",
                        variant: "icon",
                        StartIcon: "settings",
                        "data-testid": "private-link-settings",
                        onClick: () => $(E, w)
                      }
                    ),
                    /* @__PURE__ */ m(
                      ut,
                      {
                        "data-testid": `remove-private-link-${E}`,
                        variant: "icon",
                        type: "button",
                        StartIcon: "trash-2",
                        color: "destructive",
                        className: "ml-1 border-none",
                        onClick: () => N(E)
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ m("div", { "data-testid": "private-link-description", className: "mt-1 text-sm text-gray-500", children: F })
              ] }, w.link);
            }),
            /* @__PURE__ */ m(
              ut,
              {
                color: "minimal",
                StartIcon: "plus",
                onClick: M,
                "data-testid": "add-private-link-button",
                children: i("add_a_multiple_private_link")
              }
            )
          ] });
        }
      }
    ),
    /* @__PURE__ */ m(Ff, { open: c, onOpenChange: l, children: /* @__PURE__ */ Y(Ei, { title: i("link_settings"), type: "creation", children: [
      /* @__PURE__ */ m("div", { className: "mb-4 space-y-4", children: /* @__PURE__ */ Y(
        PF,
        {
          className: "space-y-2",
          value: _,
          "data-testid": "private-link-radio-group",
          onValueChange: (k) => {
            p(k);
          },
          children: [
            /* @__PURE__ */ Y(Up, { value: "usage", "data-testid": "private-link-usage", className: "w-full text-sm", children: [
              /* @__PURE__ */ m("strong", { className: "mb-1 block", children: i("usage_based_expiration") }),
              /* @__PURE__ */ m("p", { children: _ !== "usage" ? i("usage_based_generic_expiration_description") : i(
                h === 1 ? "usage_based_expiration_description" : "usage_based_expiration_description_plural",
                { count: h || 0 }
              ) }),
              _ === "usage" && /* @__PURE__ */ m("div", { className: "mt-2 w-[180px]", children: /* @__PURE__ */ m(
                Y1c,
                {
                  required: !0,
                  min: 1,
                  "data-testid": "private-link-usage-count",
                  placeholder: i("number_of_uses"),
                  value: h === null ? "" : h,
                  onChange: (k) => {
                    const S = k.target.value === "" ? null : parseInt(k.target.value);
                    k.target.value === "" ? b(null) : !isNaN(Number(S)) && Number(S) > 0 && b(S);
                  }
                }
              ) })
            ] }),
            /* @__PURE__ */ Y(Up, { "data-testid": "private-link-time", value: "time", className: "w-full text-sm", children: [
              /* @__PURE__ */ m("strong", { className: "mb-1 block", children: i("time_based_expiration") }),
              _ !== "time" ? i("time_based_generic_expiration_description") : i("time_based_expiration_description", {
                date: De(f).format("MMM DD, YYYY")
              }),
              _ === "time" && /* @__PURE__ */ m("div", { className: "mt-2 w-[180px]", children: /* @__PURE__ */ m(
                nTc,
                {
                  "data-testid": "private-link-expiration-date",
                  date: f,
                  onDatesChange: (k) => {
                    g(k);
                  }
                }
              ) })
            ] })
          ]
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "mb-4 mt-4 flex justify-end", children: /* @__PURE__ */ m(
        ut,
        {
          type: "button",
          color: "primary",
          "data-testid": "private-link-expiration-settings-save",
          onClick: () => {
            _ === "time" ? v(d, "time", f) : v(d, "usage", void 0, h), l(!1);
          },
          children: i("save")
        }
      ) })
    ] }) })
  ] });
}, Cod = (e) => ile(e);
function i0e(e) {
  return Ea[e.watch("type") || "text"];
}
const a0e = (e) => {
  const t = Ea[e.type];
  return e.name === "location" ? { ...t, label: "Location" } : t;
}, zod = function({
  title: t,
  description: n,
  addFieldLabel: o,
  formProp: r,
  disabled: i,
  LockedIcon: a,
  dataStore: s,
  shouldConsiderRequired: c,
  showPriceField: l,
  paymentCurrency: d = "USD",
  showPhoneAndEmailToggle: u = !1
}) {
  const _ = Dn(), [p] = xl(), { t: f } = Fe(), { fields: g, swap: h, remove: b, update: v, append: $ } = B0({
    control: _.control,
    // HACK: It allows any property name to be used for instead of `fields` property name
    name: r
  }), [k, S] = ze({
    isOpen: !1,
    fieldIndex: -1,
    data: {}
  }), O = () => {
    S({
      isOpen: !0,
      fieldIndex: -1,
      data: null
    });
  }, I = (M, N) => {
    S({
      isOpen: !0,
      fieldIndex: M,
      data: N
    });
  }, D = (M) => {
    b(M);
  };
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ Y("div", { className: "text-default text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: [
        t,
        a
      ] }),
      /* @__PURE__ */ Y("div", { className: "flex items-start justify-between", children: [
        /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: n }),
        u && /* @__PURE__ */ m(
          cj,
          {
            value: (() => {
              const M = g.find((C) => C.name === "attendeePhoneNumber"), N = g.find((C) => C.name === "email");
              return M && !M.hidden && M.required && !(N != null && N.required) ? "phone" : "email";
            })(),
            options: [
              {
                value: "email",
                label: "Email",
                iconLeft: /* @__PURE__ */ m(ot, { name: "mail", className: "h-4 w-4" })
              },
              {
                value: "phone",
                label: "Phone",
                iconLeft: /* @__PURE__ */ m(ot, { name: "phone", className: "h-4 w-4" })
              }
            ],
            onValueChange: (M) => {
              const N = g.findIndex((P) => P.name === "attendeePhoneNumber"), C = g.findIndex((P) => P.name === "email");
              M === "email" ? (v(C, {
                ...g[C],
                hidden: !1,
                required: !0
              }), v(N, {
                ...g[N],
                hidden: !0,
                required: !1
              })) : M === "phone" && (v(C, {
                ...g[C],
                hidden: !0,
                required: !1
              }), v(N, {
                ...g[N],
                hidden: !1,
                required: !0
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ m("p", { className: "text-default mt-5 text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: f("questions") }),
      /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: f("all_info_your_booker_provide") }),
      /* @__PURE__ */ m("ul", { ref: p, className: "border-subtle divide-subtle mt-4 divide-y rounded-md border", children: g.map((M, N) => {
        var U, W;
        let C = M.options ?? null;
        const P = [...M.sources || []], x = c ? c(M) : M.required;
        if (!C && M.getOptionsAt) {
          const {
            source: { label: H },
            value: Q
          } = s.options[M.getOptionsAt] ?? [];
          C = Q, C.forEach((X) => {
            P.push({
              id: X.value,
              label: H,
              type: "system"
            });
          });
        }
        hC.includes(M.type) && (M = { ...M, labelAsSafeHtml: UF(M.label ?? "") });
        const w = (C == null ? void 0 : C.length) ?? 0, T = !!((W = M.optionsInputs) == null ? void 0 : W[(U = C == null ? void 0 : C[0]) == null ? void 0 : U.value]);
        if (M.hideWhenJustOneOption && w <= 1 && !T)
          return null;
        const z = a0e(M), j = M.editable === "system-but-optional", q = M.editable === "system-but-hidden", V = M.editable === "system", F = !V && !j && !q;
        if (!z)
          throw new Error(`Invalid field type - ${M.type}`);
        const L = P.reduce((H, Q) => {
          const X = H[Q.label] || [];
          return Q.type === "user" || Q.type === "default" || (X.push(Q), H[Q.label] = X), H;
        }, {});
        return /* @__PURE__ */ Y(
          "li",
          {
            "data-testid": `field-${M.name}`,
            className: "hover:bg-muted group relative flex items-center justify-between p-4 transition",
            children: [
              !i && /* @__PURE__ */ Y(Ce, { children: [
                N >= 1 && /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    className: "bg-default text-muted hover:text-emphasis disabled:hover:text-muted border-subtle hover:border-emphasis invisible absolute -left-[12px] -ml-4 -mt-4 mb-4 hidden h-6 w-6 scale-0 items-center justify-center rounded-md border p-1 transition-all hover:shadow disabled:hover:border-inherit disabled:hover:shadow-none group-hover:visible group-hover:scale-100 sm:ml-0 sm:flex",
                    onClick: () => h(N, N - 1),
                    children: /* @__PURE__ */ m(ot, { name: "arrow-up", className: "h-5 w-5" })
                  }
                ),
                N < g.length - 1 && /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    className: "bg-default text-muted hover:border-emphasis border-subtle hover:text-emphasis disabled:hover:text-muted invisible absolute -left-[12px] -ml-4 mt-8 hidden h-6 w-6 scale-0 items-center justify-center rounded-md border p-1 transition-all hover:shadow disabled:hover:border-inherit disabled:hover:shadow-none group-hover:visible group-hover:scale-100 sm:ml-0 sm:flex",
                    onClick: () => h(N, N + 1),
                    children: /* @__PURE__ */ m(ot, { name: "arrow-down", className: "h-5 w-5" })
                  }
                )
              ] }),
              /* @__PURE__ */ Y("div", { children: [
                /* @__PURE__ */ Y("div", { className: "mr-4 flex flex-col lg:flex-row lg:items-center", children: [
                  /* @__PURE__ */ m("div", { className: "text-default text-sm font-semibold ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(Nod, { field: M }) }),
                  /* @__PURE__ */ Y("div", { className: "flex items-center space-x-2", children: [
                    M.hidden ? (
                      // Hidden field can't be required, so we don't need to show the Optional badge
                      /* @__PURE__ */ m(Nr, { variant: "grayWithoutHover", children: f("hidden") })
                    ) : /* @__PURE__ */ m(Nr, { variant: "grayWithoutHover", "data-testid": x ? "required" : "optional", children: f(x ? "required" : "optional") }),
                    Object.entries(L).map(([H, Q], X) => (
                      // We don't know how to pluralize `sourceLabel` because it can be anything
                      /* @__PURE__ */ Y(Nr, { variant: "blue", children: [
                        Q.length,
                        " ",
                        Q.length === 1 ? H : `${H}s`
                      ] }, X)
                    ))
                  ] })
                ] }),
                /* @__PURE__ */ m("p", { className: "text-subtle max-w-[280px] break-words pt-1 text-sm sm:max-w-[500px]", children: z.label })
              ] }),
              M.editable !== "user-readonly" && !i && /* @__PURE__ */ Y("div", { className: "flex items-center space-x-2", children: [
                !V && !q && !i && /* @__PURE__ */ m(
                  Ri,
                  {
                    "data-testid": "toggle-field",
                    disabled: V,
                    checked: !M.hidden,
                    onCheckedChange: (H) => {
                      v(N, { ...M, hidden: !H });
                    },
                    tooltip: f("show_on_booking_page")
                  }
                ),
                F && /* @__PURE__ */ m(
                  ut,
                  {
                    "data-testid": "delete-field-action",
                    color: "destructive",
                    disabled: !F,
                    variant: "icon",
                    onClick: () => {
                      D(N);
                    },
                    StartIcon: "trash-2"
                  }
                ),
                /* @__PURE__ */ m(
                  ut,
                  {
                    "data-testid": "edit-field-action",
                    color: "secondary",
                    onClick: () => {
                      I(N, M);
                    },
                    children: f("edit")
                  }
                )
              ] })
            ]
          },
          M.name
        );
      }) }),
      !i && /* @__PURE__ */ m(
        ut,
        {
          color: "minimal",
          "data-testid": "add-field",
          onClick: O,
          className: "mt-4",
          StartIcon: "plus",
          children: o
        }
      )
    ] }),
    k.isOpen && /* @__PURE__ */ m(
      Iod,
      {
        dialog: k,
        onOpenChange: (M) => S({
          isOpen: M,
          fieldIndex: -1,
          data: null
        }),
        handleSubmit: (M) => {
          const N = M.type || "text", C = !k.data;
          if (M.name === "guests" && N !== "multiemail") {
            nr(f("guests_field_must_be_multiemail"), "error");
            return;
          }
          if (C && g.some((P) => P.name === M.name)) {
            nr(f("form_builder_field_already_exists"), "error");
            return;
          }
          if (k.data)
            v(k.fieldIndex, M);
          else {
            const P = {
              ...M,
              type: N,
              sources: [
                {
                  label: "User",
                  type: "user",
                  id: "user",
                  fieldRequired: M.required
                }
              ]
            };
            P.editable = P.editable || "user", $(P);
          }
          S({
            isOpen: !1,
            fieldIndex: -1,
            data: null
          });
        },
        shouldConsiderRequired: c,
        showPriceField: l,
        paymentCurrency: d
      }
    )
  ] });
};
function Ood({
  label: e = "Options",
  value: t,
  onChange: n = () => {
  },
  className: o = "",
  readOnly: r = !1,
  showPrice: i = !1,
  paymentCurrency: a
}) {
  const { t: s } = Fe(), [c] = xl();
  return t || n([
    {
      label: "Option 1",
      value: "Option 1"
    },
    {
      label: "Option 2",
      value: "Option 2"
    }
  ]), /* @__PURE__ */ Y("div", { className: o, children: [
    /* @__PURE__ */ m(Xn, { children: e }),
    /* @__PURE__ */ Y("div", { className: "bg-muted rounded-md p-4", "data-testid": "options-container", children: [
      /* @__PURE__ */ m("ul", { ref: c, className: "flex flex-col gap-3", children: t == null ? void 0 : t.map((l, d) => /* @__PURE__ */ m("li", { children: /* @__PURE__ */ Y("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ Y("div", { className: "relative flex-grow", children: [
          /* @__PURE__ */ m(
            Sc,
            {
              required: !0,
              value: l.label,
              onChange: (u) => {
                const _ = [...t || []];
                _.splice(d, 1, {
                  label: u.target.value,
                  value: u.target.value.trim()
                }), n(_);
              },
              readOnly: r,
              placeholder: s("enter_option", { index: d + 1 }),
              className: t.length > 2 && !r ? "pr-8" : ""
            }
          ),
          t.length > 2 && !r && /* @__PURE__ */ m(
            ut,
            {
              type: "button",
              className: "absolute right-1 top-1/2 -translate-y-1/2 hover:!bg-transparent focus:!bg-transparent focus:!outline-none focus:!ring-0",
              size: "sm",
              color: "minimal",
              StartIcon: "x",
              onClick: () => {
                if (!t)
                  return;
                const u = [...t || []];
                u.splice(d, 1), n(u);
              }
            }
          )
        ] }),
        i && /* @__PURE__ */ m("div", { className: "w-24", children: /* @__PURE__ */ m(
          hi,
          {
            type: "number",
            min: 0,
            step: "0.01",
            value: l.price,
            onChange: (u) => {
              const _ = u.target.value, p = _ === "" ? void 0 : Number(_), f = [...t || []];
              f[d] = {
                ...l,
                price: p
              }, n(f);
            },
            readOnly: r,
            placeholder: "0",
            addOnLeading: pve(a)
          }
        ) })
      ] }) }, d)) }),
      !r && /* @__PURE__ */ m(
        ut,
        {
          color: "minimal",
          "data-testid": "add-option",
          className: "mt-3",
          onClick: () => {
            const l = [...t || []];
            l.push({ label: "", value: "", price: 0 }), n(l);
          },
          StartIcon: "plus",
          children: "Add an Option"
        }
      )
    ] })
  ] });
}
const Pod = ({ fieldForm: e }) => {
  const { t } = Fe(), [n, o] = ze(!0);
  return /* @__PURE__ */ Y("div", { className: "mt-6", children: [
    /* @__PURE__ */ m(Xn, { children: t("label") }),
    /* @__PURE__ */ m(
      H8,
      {
        getText: () => TC.render(e.getValues("label") || ""),
        setText: (r) => {
          e.setValue("label", r8(r), { shouldDirty: !0 });
        },
        excludedToolbarItems: ["blockType", "bold", "italic"],
        disableLists: !0,
        firstRender: n,
        setFirstRender: o,
        placeholder: t(e.getValues("defaultLabel") || "")
      }
    )
  ] });
};
function Iod({
  dialog: e,
  onOpenChange: t,
  handleSubmit: n,
  shouldConsiderRequired: o,
  showPriceField: r,
  paymentCurrency: i
}) {
  const { t: a } = Fe(), s = Zo(), c = pd({
    defaultValues: e.data || {}
    //resolver: zodResolver(fieldSchema),
  }), l = c.getValues("type");
  Le(() => {
    if (!l)
      return;
    const f = hF({
      type: l,
      variantsConfig: c.getValues("variantsConfig")
    });
    c.setValue("variantsConfig", f);
  }, [c]);
  const d = !!e.data, u = i0e(c), _ = c.watch("variantsConfig"), p = Object.values(Ea);
  return c.getValues("name"), /* @__PURE__ */ m(Gi, { open: e.isOpen, onOpenChange: t, modal: !1, children: /* @__PURE__ */ m(Ei, { className: "max-h-none", "data-testid": "edit-field-dialog", forceOverlayWhenNoModal: !0, children: /* @__PURE__ */ Y(fd, { id: "form-builder", form: c, handleSubmit: n, children: [
    /* @__PURE__ */ Y("div", { className: "h-auto max-h-[85vh] overflow-auto", children: [
      /* @__PURE__ */ m(zv, { title: a("add_a_booking_question"), subtitle: a("booking_questions_description") }),
      /* @__PURE__ */ m(
        rj,
        {
          defaultValue: Ea.text,
          "data-testid": "test-field-type",
          id: "test-field-type",
          isDisabled: c.getValues("editable") === "system" || c.getValues("editable") === "system-but-optional",
          onChange: (f) => {
            const g = f == null ? void 0 : f.value;
            g && c.setValue("type", g, { shouldDirty: !0 });
          },
          value: e.data ? a0e(e.data) : Ea[l],
          options: p.filter((f) => !f.systemOnly),
          label: a("input_type")
        }
      ),
      (() => {
        if (!_)
          return /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              hi,
              {
                required: !0,
                ...c.register("name"),
                containerClassName: "mt-6",
                onChange: (f) => {
                  c.setValue("name", Cod(f.target.value || ""), {
                    shouldDirty: !0
                  });
                },
                disabled: c.getValues("editable") === "system" || c.getValues("editable") === "system-but-optional",
                label: a("identifier")
              }
            ),
            /* @__PURE__ */ m(
              Ta,
              {
                description: a("disable_input_if_prefilled"),
                ...c.register("disableOnPrefill", { setValueAs: Boolean })
              }
            ),
            /* @__PURE__ */ m("div", { children: l === "boolean" && !s ? /* @__PURE__ */ m(Pod, { fieldForm: c }) : /* @__PURE__ */ m(
              hi,
              {
                ...c.register("label"),
                required: !["system", "system-but-optional"].includes(c.getValues("editable") || ""),
                placeholder: a(c.getValues("defaultLabel") || ""),
                containerClassName: "mt-6",
                label: a("label")
              }
            ) }),
            u != null && u.isTextType ? /* @__PURE__ */ m(
              hi,
              {
                ...c.register("placeholder"),
                containerClassName: "mt-6",
                label: a("placeholder"),
                placeholder: a(c.getValues("defaultPlaceholder") || "")
              }
            ) : null,
            u != null && u.needsOptions && !c.getValues("getOptionsAt") ? /* @__PURE__ */ m(
              Wt,
              {
                name: "options",
                render: ({ field: { value: f, onChange: g } }) => /* @__PURE__ */ m(
                  Ood,
                  {
                    onChange: g,
                    value: f,
                    className: "mt-6",
                    showPrice: r && u.optionsSupportPricing,
                    paymentCurrency: i
                  }
                )
              }
            ) : null,
            u != null && u.supportsLengthCheck ? /* @__PURE__ */ m(Rod, { containerClassName: "mt-6", fieldForm: c }) : null,
            l === "email" && /* @__PURE__ */ m(
              hi,
              {
                ...c.register("requireEmails"),
                containerClassName: "mt-6",
                onChange: (f) => {
                  var g;
                  try {
                    Hx.parse(f.target.value), c.clearErrors("requireEmails");
                  } catch (h) {
                    h instanceof zc && c.setError("requireEmails", {
                      message: ((g = h.errors[0]) == null ? void 0 : g.message) || "Invalid input"
                    });
                  }
                },
                label: a("require_emails_that_contain"),
                placeholder: "gmail.com, hotmail.com, ..."
              }
            ),
            l === "email" && /* @__PURE__ */ m(
              hi,
              {
                ...c.register("excludeEmails"),
                containerClassName: "mt-6",
                onChange: (f) => {
                  var g;
                  try {
                    Hx.parse(f.target.value), c.clearErrors("excludeEmails");
                  } catch (h) {
                    h instanceof zc && c.setError("excludeEmails", {
                      message: ((g = h.errors[0]) == null ? void 0 : g.message) || "Invalid input"
                    });
                  }
                },
                label: a("exclude_emails_that_contain"),
                placeholder: "gmail.com, hotmail.com, ..."
              }
            ),
            r && u.supportsPricing && /* @__PURE__ */ m(
              hi,
              {
                ...c.register("price"),
                containerClassName: "mt-6",
                label: a("price"),
                type: "number",
                min: 0,
                placeholder: "0",
                addOnLeading: pve(i)
              }
            ),
            /* @__PURE__ */ m("div", { className: "mt-6", children: /* @__PURE__ */ m(
              Wt,
              {
                name: "required",
                control: c.control,
                render: ({ field: { value: f, onChange: g } }) => {
                  let h = o ? o(c.getValues()) : f;
                  return h === void 0 && (h = !0, g(h)), /* @__PURE__ */ m(
                    Ta,
                    {
                      "data-testid": "field-required",
                      disabled: c.getValues("editable") === "system",
                      checked: h,
                      onChange: (b) => {
                        g(b.target.checked);
                      },
                      description: a("make_field_required")
                    }
                  );
                }
              }
            ) })
          ] });
        if (!u.isTextType)
          throw new Error("Variants are currently supported only with text type");
        return /* @__PURE__ */ m(Mod, { variantsConfig: _, fieldForm: c });
      })()
    ] }),
    /* @__PURE__ */ Y(Fc, { className: "relative", children: [
      /* @__PURE__ */ m(ca, { color: "secondary", children: a("cancel") }),
      /* @__PURE__ */ m(ut, { "data-testid": "field-add-save", type: "submit", children: a(d ? "save" : "add") })
    ] })
  ] }) }) });
}
function Rod({
  fieldForm: e,
  containerClassName: t = "",
  className: n,
  ...o
}) {
  const { t: r } = Fe(), i = i0e(e);
  if (!i.supportsLengthCheck)
    return null;
  const a = i.supportsLengthCheck, s = a.maxLength;
  return /* @__PURE__ */ Y("div", { className: ae("grid grid-cols-2 gap-4", n), ...o, children: [
    /* @__PURE__ */ m(
      hi,
      {
        ...e.register("minLength", {
          valueAsNumber: !0
        }),
        defaultValue: 0,
        containerClassName: t,
        label: r("min_characters"),
        type: "number",
        onChange: (c) => {
          e.setValue("minLength", parseInt(c.target.value ?? 0)), e.trigger("maxLength");
        },
        min: 0,
        max: e.getValues("maxLength") || s
      }
    ),
    /* @__PURE__ */ m(
      hi,
      {
        ...e.register("maxLength", {
          valueAsNumber: !0
        }),
        defaultValue: s,
        containerClassName: t,
        label: r("max_characters"),
        type: "number",
        onChange: (c) => {
          a && (e.setValue("maxLength", parseInt(c.target.value ?? s)), e.trigger("minLength"));
        },
        min: e.getValues("minLength") || 0,
        max: s
      }
    )
  ] });
}
function Nod({ field: e }) {
  var d, u, _;
  const { t } = Fe(), n = Ea[e.type], o = n == null ? void 0 : n.variantsConfig, r = o == null ? void 0 : o.variants, i = e.variantsConfig, a = i == null ? void 0 : i.variants, s = o == null ? void 0 : o.defaultVariant;
  if (!r || !i)
    return hC.includes(e.type) ? /* @__PURE__ */ m(
      "span",
      {
        dangerouslySetInnerHTML: {
          // Derive from field.label because label might change in b/w and field.labelAsSafeHtml will not be updated.
          __html: UF(e.label || t(e.defaultLabel || "") || "")
        }
      }
    ) : /* @__PURE__ */ m("span", { children: e.label || t(e.defaultLabel || "") });
  const c = e.variant || s;
  if (!c)
    throw new Error(
      `Field has \`variantsConfig\` but no \`defaultVariant\`${JSON.stringify(o)}`
    );
  const l = ((_ = (u = (d = a == null ? void 0 : a[c]) == null ? void 0 : d.fields) == null ? void 0 : u[0]) == null ? void 0 : _.label) || "";
  return /* @__PURE__ */ m("span", { children: t(l) });
}
function Dod() {
  return null;
}
function Mod({
  fieldForm: e,
  variantsConfig: t
}) {
  var f;
  const { t: n } = Fe();
  if (!t)
    throw new Error("VariantFields component needs variantsConfig");
  const o = (f = Ea[e.getValues("type")]) == null ? void 0 : f.variantsConfig;
  if (!o)
    throw new Error("Configuration Issue: FieldType doesn't have `variantsConfig`");
  const r = n(o.toggleLabel || ""), i = o.defaultVariant, a = Object.keys(t.variants), s = a.filter((g) => g !== i);
  if (s.length > 1 && r)
    throw new Error("More than one other variant. Remove toggleLabel ");
  const c = s[0], l = e.watch("variant") || i, d = t.variants[l].fields, u = d.length === 1, _ = l === i, p = a.length === 2;
  return /* @__PURE__ */ Y(Ce, { children: [
    p ? /* @__PURE__ */ m(
      Ri,
      {
        classNames: { container: "mt-1" },
        checked: !_,
        label: r,
        "data-testid": "variant-toggle",
        onCheckedChange: (g) => {
          e.setValue("variant", g ? c : i);
        },
        tooltip: n("Toggle Variant")
      }
    ) : /* @__PURE__ */ m(Dod, {}),
    /* @__PURE__ */ m(
      hi,
      {
        required: !0,
        ...e.register("name"),
        containerClassName: "mt-6",
        disabled: e.getValues("editable") === "system" || e.getValues("editable") === "system-but-optional",
        label: n("identifier")
      }
    ),
    /* @__PURE__ */ m("div", { className: "mt-2", children: /* @__PURE__ */ m(
      Ta,
      {
        description: n("disable_input_if_prefilled"),
        ...e.register("disableOnPrefill", { setValueAs: Boolean })
      }
    ) }),
    /* @__PURE__ */ m(
      "ul",
      {
        className: ae(
          u ? "" : "border-subtle divide-subtle mt-2 divide-y rounded-md border"
        ),
        children: d.map((g, h) => {
          const b = `variantsConfig.variants.${l}.fields.${h}`, $ = o.variants[l].fieldsMap[g.name];
          return /* @__PURE__ */ Y("li", { className: ae(u ? "" : "p-4"), children: [
            !u && /* @__PURE__ */ Y(Xn, { className: "flex justify-between", children: [
              /* @__PURE__ */ m("span", { children: `Field ${h + 1}` }),
              /* @__PURE__ */ m("span", { className: "text-muted", children: g.name })
            ] }),
            /* @__PURE__ */ m(
              hi,
              {
                ...e.register(`${b}.label`),
                value: g.label || "",
                placeholder: n(($ == null ? void 0 : $.defaultLabel) || ""),
                containerClassName: "mt-6",
                label: n("label")
              }
            ),
            /* @__PURE__ */ Pe(
              hi,
              {
                ...e.register(`${b}.placeholder`),
                key: g.name,
                value: g.placeholder || "",
                containerClassName: "mt-6",
                label: n("placeholder"),
                placeholder: n(($ == null ? void 0 : $.defaultPlaceholder) || "")
              }
            ),
            /* @__PURE__ */ m("div", { className: "mt-6", children: /* @__PURE__ */ m(
              Wt,
              {
                name: `${b}.required`,
                control: e.control,
                render: ({ field: { onChange: k } }) => /* @__PURE__ */ m(
                  Ta,
                  {
                    "data-testid": "field-required",
                    disabled: !($ != null && $.canChangeRequirability),
                    checked: g.required,
                    onChange: (S) => {
                      k(S.target.checked);
                    },
                    description: n("make_field_required")
                  }
                )
              }
            ) })
          ] }, g.name);
        })
      }
    )
  ] });
}
const Lod = ({
  align: e = "start",
  children: t,
  className: n
}) => /* @__PURE__ */ m(
  "div",
  {
    className: ae(
      "border-subtle bg-muted flex rounded-b-lg border px-6 py-4",
      e === "end" && "justify-end",
      n
    ),
    children: t
  }
), qod = Lod, Tee = "metadata.bookerLayouts", jod = ({
  title: e,
  description: t,
  name: n,
  fallbackToUserSettings: o,
  isDark: r,
  isDisabled: i = !1,
  isOuterBorder: a = !1,
  isLoading: s = !1,
  user: c,
  isUserLoading: l
}) => {
  const { control: d, getValues: u } = Dn(), { t: _ } = Fe(), p = o && !u(n || Tee) || !1;
  return /* @__PURE__ */ Y("div", { className: ae(a && "border-subtle rounded-lg border p-6"), children: [
    /* @__PURE__ */ Y("div", { className: ae(a ? "pb-5" : "border-subtle rounded-t-xl border p-6"), children: [
      /* @__PURE__ */ m(Xn, { className: ae("mb-1 font-semibold", a ? "text-sm" : "text-base"), children: e || _("layout") }),
      /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: t || _("bookerlayout_description") })
    ] }),
    /* @__PURE__ */ m(
      Wt,
      {
        control: p ? void 0 : d,
        name: n || Tee,
        render: ({ field: { value: f, onChange: g } }) => /* @__PURE__ */ Y(Ce, { children: [
          /* @__PURE__ */ m(
            Fod,
            {
              showUserSettings: p,
              settings: f,
              onChange: g,
              isDark: r,
              isOuterBorder: a,
              user: c,
              isUserLoading: l
            }
          ),
          !a && /* @__PURE__ */ m(qod, { align: "end", children: /* @__PURE__ */ m(ut, { loading: s, type: "submit", disabled: i, color: "primary", children: _("update") }) })
        ] })
      }
    )
  ] });
}, Fod = ({
  settings: e,
  onChange: t,
  showUserSettings: n,
  isDark: o,
  isOuterBorder: r,
  user: i,
  isUserLoading: a
}) => {
  const { t: s } = Fe(), [c, l] = ze(!1), d = n && !c, u = d ? i == null ? void 0 : i.defaultBookerLayouts : e, _ = (u == null ? void 0 : u.defaultLayout) || pn.MONTH_VIEW, p = nu.reduce((b, v) => (b[v] = u != null && u.enabledLayouts ? u.enabledLayouts.indexOf(v) > -1 : cle.enabledLayouts.indexOf(v) > -1, b), {}), f = at(
    (b, v) => {
      const $ = Object.keys(p).filter((O) => b === O ? v === !0 : p[O] === !0), k = $.indexOf(_) === -1, S = $[0];
      t({
        enabledLayouts: $,
        // If default layout is toggled off, we set the default layout to the first enabled layout
        // if there's none enabled, we set it to month view.
        defaultLayout: k ? S || pn.MONTH_VIEW : _
      });
    },
    [_, t, p]
  ), g = at(
    (b) => {
      t({
        enabledLayouts: Object.keys(p).filter(
          (v) => p[v] === !0
        ),
        defaultLayout: b
      });
    },
    [p, t]
  ), h = () => {
    l(!0), i != null && i.defaultBookerLayouts && t(i.defaultBookerLayouts);
  };
  return /* @__PURE__ */ Y("div", { className: ae("space-y-5", !r && "border-subtle border-x px-6 py-8"), children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "flex flex-col gap-5 transition-opacity sm:flex-row sm:gap-3",
          d && "pointer-events-none opacity-40",
          d && a && "animate-pulse"
        ),
        children: nu.map((b) => /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ Y("label", { children: [
          /* @__PURE__ */ m(
            "img",
            {
              className: "mb-3 w-full max-w-none cursor-pointer",
              src: `/bookerlayout_${b}${o ? "_dark" : ""}.svg`,
              alt: "Layout preview"
            }
          ),
          /* @__PURE__ */ m(
            Ta,
            {
              value: b,
              name: `bookerlayout_${b}`,
              description: s(`bookerlayout_${b}`),
              checked: p[b],
              onChange: (v) => f(b, v.target.checked)
            }
          )
        ] }) }, b))
      }
    ),
    /* @__PURE__ */ Y(
      "div",
      {
        hidden: Object.values(p).filter((b) => b === !0).length <= 1,
        className: ae(
          "transition-opacity",
          d && "pointer-events-none opacity-40",
          d && a && "animate-pulse"
        ),
        children: [
          /* @__PURE__ */ m(Xn, { children: s("bookerlayout_default_title") }),
          /* @__PURE__ */ m(
            ck,
            {
              className: "border-subtle flex w-full gap-2 rounded-md border p-1",
              defaultValue: _,
              onValueChange: (b) => g(b),
              children: nu.map((b) => /* @__PURE__ */ Y(
                lk,
                {
                  className: "aria-checked:bg-emphasis hover:[&:not(:disabled)]:bg-subtle focus:[&:not(:disabled)]:bg-subtle w-full rounded-[4px] p-1 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40",
                  disabled: p[b] === !1,
                  value: b,
                  children: [
                    s(`bookerlayout_${b}`),
                    /* @__PURE__ */ m(dk, {})
                  ]
                },
                b
              ))
            },
            _
          )
        ]
      }
    ),
    d && /* @__PURE__ */ m("p", { className: "text-sm", children: /* @__PURE__ */ m(
      Dc,
      {
        t: s,
        i18nKey: "bookerlayout_override_global_settings",
        components: [
          /* @__PURE__ */ m(
            Po,
            {
              target: "_blank",
              href: "/settings/my-account/appearance",
              className: "underline",
              children: "Appearance"
            },
            "appearance-link"
          ),
          /* @__PURE__ */ m(
            ut,
            {
              onClick: h,
              color: "minimal",
              className: "h-fit p-0 font-normal underline hover:bg-transparent focus-visible:bg-transparent",
              children: "Override"
            },
            "override-button"
          )
        ]
      }
    ) })
  ] });
}, Vod = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
function Bod(e, t) {
  const [n, o] = e.split("@");
  return `${n}+${t}@${o}`;
}
const Uod = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const { clientId: n } = po();
  return Yo({
    mutationFn: (r) => {
      const { email: i } = r, a = Bod(i, n);
      return He.post("/atoms/emails/verified-emails", {
        email: a
      }).then((s) => s.data);
    },
    onSuccess: (r) => {
      r.status === qt ? e == null || e(r) : t == null || t(r);
    },
    onError: (r) => {
      t == null || t(r);
    }
  });
}, Wod = "use-get-verified-emails", s0e = (e) => {
  const t = `/atoms/emails/verified-emails${e ? `?teamId=${e}` : ""}`, { isInit: n, accessToken: o } = po();
  return go({
    queryKey: [Wod, e],
    queryFn: () => He == null ? void 0 : He.get(t).then((r) => {
      if (r.data.status === qt)
        return r.data.data;
      throw new Error(r.data.error.message);
    }),
    enabled: n && !!o,
    staleTime: 5e3
  });
}, God = ({ username: e, showToast: t }) => {
  const { t: n } = Fe(), [o, r] = ze(""), [i, a] = ze(!1), { refetch: s } = s0e(), { mutateAsync: c } = Uod({
    onSuccess: () => {
      s(), t(n("email_verified"), "success");
    },
    onError: () => {
      t(n("something_went_wrong"), "error");
    }
  }), l = Ebe({
    email: o,
    name: e || n("there"),
    requiresBookerEmailVerification: !0
  }), { handleVerifyEmail: d } = l, u = xbe({
    onSuccess: async () => {
      a(!1), r(""), await c({
        email: o
      });
    }
  });
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ Y("div", { className: "border-subtle border border-t-0 p-6", children: [
      /* @__PURE__ */ m(
        Xn,
        {
          className: ae("text-emphasis mb-2 block text-sm font-medium leading-none"),
          htmlFor: "add-verified-emails",
          children: n("add_verified_emails")
        }
      ),
      /* @__PURE__ */ m(
        Io,
        {
          id: "add-verified-emails",
          containerClassName: ae("w-full"),
          value: o,
          onChange: (_) => r(_.target.value),
          "data-testid": "add-verified-emails",
          addOnSuffix: /* @__PURE__ */ m(Ao, { content: n("add_verified_email"), children: /* @__PURE__ */ m(
            ut,
            {
              type: "button",
              color: "minimal",
              size: "sm",
              StartIcon: "arrow-right",
              onClick: () => {
                o && Vod(o) && (a(!0), d());
              }
            }
          ) })
        }
      )
    ] }),
    /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
      Whe,
      {
        isOpenDialog: i,
        setIsOpenDialog: a,
        email: o,
        isUserSessionRequiredToVerify: !1,
        verifyCodeWithSessionNotRequired: u.verifyCodeWithSessionNotRequired,
        verifyCodeWithSessionRequired: u.verifyCodeWithSessionRequired,
        error: u.error,
        resetErrors: u.resetErrors,
        isPending: u.isPending,
        setIsPending: u.setIsPending
      }
    ) })
  ] });
}, Hod = God, Kod = (e) => {
  var g, h, b, v, $, k, S, O, I, D, M, N, C, P, x, w, E, T, z, j, q, V, F, L, U, W, H, Q, X, re, Z, ee, J, oe, ce, de, te, ue, le, se, me, pe, be, Se, Ae, Ze, Ge, rt, qe, Xe, lt, Et, wt, nn, Dt, mt, bt, gn, an, Mn, Ln, un, qo;
  const { t } = Fe(), { placeHolder: n, close: o, setValue: r, event: i, isNameFieldSplit: a, customClassNames: s } = e, { register: c, handleSubmit: l, watch: d, getValues: u } = Dn(), _ = (cn) => {
    r(cn.customEventName), o();
  }, p = tye({ ...i, eventName: d("customEventName") }), f = d("customEventName") === "" ? p : n;
  return /* @__PURE__ */ Y(
    "form",
    {
      id: "custom-event-name",
      onSubmit: (cn) => {
        cn.preventDefault(), cn.stopPropagation(), u("customEventName") === "" && r(""), l(_)(cn);
      },
      children: [
        /* @__PURE__ */ m(
          Io,
          {
            label: t("event_name_in_calendar"),
            type: "text",
            placeholder: f,
            ...c("customEventName", {
              validate: (cn) => {
                const ln = nye(cn, i.bookingFields);
                return typeof ln == "string" ? t("invalid_event_name_variables", { item: ln }) : ln;
              }
            }),
            containerClassName: (g = s == null ? void 0 : s.eventNameInput) == null ? void 0 : g.container,
            labelClassName: (h = s == null ? void 0 : s.eventNameInput) == null ? void 0 : h.label,
            className: ae("mb-0", (b = s == null ? void 0 : s.eventNameInput) == null ? void 0 : b.input)
          }
        ),
        /* @__PURE__ */ Y("div", { className: "pt-6 text-sm", children: [
          /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "bg-subtle mb-6 rounded-md p-2",
                (v = s == null ? void 0 : s.availableVariables) == null ? void 0 : v.container
              ),
              children: [
                /* @__PURE__ */ m(
                  "h1",
                  {
                    className: ae(
                      "text-emphasis mb-2 ml-1 font-medium",
                      ($ = s == null ? void 0 : s.availableVariables) == null ? void 0 : $.header
                    ),
                    children: t("available_variables")
                  }
                ),
                /* @__PURE__ */ Y(
                  "div",
                  {
                    className: ae(
                      "scroll-bar h-[216px] overflow-y-auto",
                      (k = s == null ? void 0 : s.availableVariables) == null ? void 0 : k.scrollArea
                    ),
                    children: [
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (O = (S = s == null ? void 0 : s.availableVariables) == null ? void 0 : S.variableItem) == null ? void 0 : O.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (D = (I = s == null ? void 0 : s.availableVariables) == null ? void 0 : I.variableItem) == null ? void 0 : D.variableName
                                ),
                                children: "{Event type title}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (N = (M = s == null ? void 0 : s.availableVariables) == null ? void 0 : M.variableItem) == null ? void 0 : N.variableDescription
                                ),
                                children: t("event_name_info")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (P = (C = s == null ? void 0 : s.availableVariables) == null ? void 0 : C.variableItem) == null ? void 0 : P.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (w = (x = s == null ? void 0 : s.availableVariables) == null ? void 0 : x.variableItem) == null ? void 0 : w.variableName
                                ),
                                children: "{Event duration}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (T = (E = s == null ? void 0 : s.availableVariables) == null ? void 0 : E.variableItem) == null ? void 0 : T.variableDescription
                                ),
                                children: t("event_duration_info")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (j = (z = s == null ? void 0 : s.availableVariables) == null ? void 0 : z.variableItem) == null ? void 0 : j.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (V = (q = s == null ? void 0 : s.availableVariables) == null ? void 0 : q.variableItem) == null ? void 0 : V.variableName
                                ),
                                children: "{Organiser}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (L = (F = s == null ? void 0 : s.availableVariables) == null ? void 0 : F.variableItem) == null ? void 0 : L.variableDescription
                                ),
                                children: t("your_full_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (W = (U = s == null ? void 0 : s.availableVariables) == null ? void 0 : U.variableItem) == null ? void 0 : W.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (Q = (H = s == null ? void 0 : s.availableVariables) == null ? void 0 : H.variableItem) == null ? void 0 : Q.variableName
                                ),
                                children: "{Organiser first name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (re = (X = s == null ? void 0 : s.availableVariables) == null ? void 0 : X.variableItem) == null ? void 0 : re.variableDescription
                                ),
                                children: t("organizer_first_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (ee = (Z = s == null ? void 0 : s.availableVariables) == null ? void 0 : Z.variableItem) == null ? void 0 : ee.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (oe = (J = s == null ? void 0 : s.availableVariables) == null ? void 0 : J.variableItem) == null ? void 0 : oe.variableName
                                ),
                                children: "{Scheduler}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (de = (ce = s == null ? void 0 : s.availableVariables) == null ? void 0 : ce.variableItem) == null ? void 0 : de.variableDescription
                                ),
                                children: t("scheduler_full_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (ue = (te = s == null ? void 0 : s.availableVariables) == null ? void 0 : te.variableItem) == null ? void 0 : ue.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (se = (le = s == null ? void 0 : s.availableVariables) == null ? void 0 : le.variableItem) == null ? void 0 : se.variableName
                                ),
                                children: "{Scheduler first name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (pe = (me = s == null ? void 0 : s.availableVariables) == null ? void 0 : me.variableItem) == null ? void 0 : pe.variableDescription
                                ),
                                children: t("scheduler_first_name")
                              }
                            )
                          ]
                        }
                      ),
                      a && /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (Se = (be = s == null ? void 0 : s.availableVariables) == null ? void 0 : be.variableItem) == null ? void 0 : Se.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (Ze = (Ae = s == null ? void 0 : s.availableVariables) == null ? void 0 : Ae.variableItem) == null ? void 0 : Ze.variableName
                                ),
                                children: "{Scheduler last name}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (rt = (Ge = s == null ? void 0 : s.availableVariables) == null ? void 0 : Ge.variableItem) == null ? void 0 : rt.variableDescription
                                ),
                                children: t("scheduler_last_name")
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ Y(
                        "div",
                        {
                          className: ae(
                            "mb-2.5 flex items-start font-normal",
                            (Xe = (qe = s == null ? void 0 : s.availableVariables) == null ? void 0 : qe.variableItem) == null ? void 0 : Xe.container
                          ),
                          children: [
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                  (Et = (lt = s == null ? void 0 : s.availableVariables) == null ? void 0 : lt.variableItem) == null ? void 0 : Et.variableName
                                ),
                                children: "{Location}"
                              }
                            ),
                            /* @__PURE__ */ m(
                              "p",
                              {
                                className: ae(
                                  "text-emphasis min-w-0 flex-1",
                                  (nn = (wt = s == null ? void 0 : s.availableVariables) == null ? void 0 : wt.variableItem) == null ? void 0 : nn.variableDescription
                                ),
                                children: t("location_info")
                              }
                            )
                          ]
                        }
                      ),
                      i.bookingFields && /* @__PURE__ */ m(
                        "p",
                        {
                          className: ae(
                            "text-subtle mb-2 ml-1 font-medium",
                            (Dt = s == null ? void 0 : s.availableVariables) == null ? void 0 : Dt.bookingFieldsHeader
                          ),
                          children: t("booking_question_response_variables")
                        }
                      ),
                      i.bookingFields && Object.keys(i.bookingFields).map((cn, ln) => {
                        var kn, gt, Ot, _n, wn, so, rn, Ht;
                        return /* @__PURE__ */ Y(
                          "div",
                          {
                            className: ae(
                              "mb-2.5 flex items-start font-normal",
                              (gt = (kn = s == null ? void 0 : s.availableVariables) == null ? void 0 : kn.bookingFieldItem) == null ? void 0 : gt.container
                            ),
                            children: [
                              /* @__PURE__ */ m(
                                "p",
                                {
                                  className: ae(
                                    "text-subtle ml-1 mr-5 w-40 flex-shrink-0",
                                    (_n = (Ot = s == null ? void 0 : s.availableVariables) == null ? void 0 : Ot.bookingFieldItem) == null ? void 0 : _n.fieldName
                                  ),
                                  children: `{${cn}}`
                                }
                              ),
                              /* @__PURE__ */ m(
                                "p",
                                {
                                  className: ae(
                                    "text-emphasis min-w-0 flex-1 capitalize",
                                    (so = (wn = s == null ? void 0 : s.availableVariables) == null ? void 0 : wn.bookingFieldItem) == null ? void 0 : so.fieldValue
                                  ),
                                  children: (Ht = (rn = i.bookingFields) == null ? void 0 : rn[cn]) == null ? void 0 : Ht.toString()
                                }
                              )
                            ]
                          },
                          ln
                        );
                      })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(
            "h1",
            {
              className: ae(
                "mb-2 text-[14px] font-medium leading-4",
                (mt = s == null ? void 0 : s.previewSection) == null ? void 0 : mt.header
              ),
              children: t("preview")
            }
          ),
          /* @__PURE__ */ m(
            "div",
            {
              className: ae(
                "flex h-[212px] w-full rounded-md border-y bg-cover bg-center dark:invert",
                (bt = s == null ? void 0 : s.previewSection) == null ? void 0 : bt.previewContainer
              ),
              style: {
                backgroundImage: "url(/calendar-preview.svg)"
              },
              children: /* @__PURE__ */ m("div", { className: "m-auto flex items-center justify-center self-stretch", children: /* @__PURE__ */ Y(
                "div",
                {
                  className: ae(
                    "bg-subtle ml-11 mt-3 box-border h-[110px] w-[120px] flex-col items-start gap-1 rounded-md border border-solid border-black text-[12px] leading-3",
                    (an = (gn = s == null ? void 0 : s.previewSection) == null ? void 0 : gn.previewEventBox) == null ? void 0 : an.container
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "p",
                      {
                        className: ae(
                          "text-emphasis overflow-hidden text-ellipsis p-1.5 font-medium",
                          (Ln = (Mn = s == null ? void 0 : s.previewSection) == null ? void 0 : Mn.previewEventBox) == null ? void 0 : Ln.eventName
                        ),
                        children: p
                      }
                    ),
                    /* @__PURE__ */ m(
                      "p",
                      {
                        className: ae(
                          "text-default ml-1.5 text-[10px] font-normal",
                          (qo = (un = s == null ? void 0 : s.previewSection) == null ? void 0 : un.previewEventBox) == null ? void 0 : qo.eventTime
                        ),
                        children: "8 - 10 AM"
                      }
                    )
                  ]
                }
              ) })
            }
          )
        ] })
      ]
    }
  );
}, Yod = (e) => {
  const { t } = Fe(), { defaultValue: n, placeHolder: o, close: r, setValue: i, event: a, isNameFieldSplit: s, customClassNames: c } = e, l = pd({
    defaultValues: {
      customEventName: n
    }
  });
  return /* @__PURE__ */ m(Gi, { open: !0, onOpenChange: r, children: /* @__PURE__ */ Y(
    Ei,
    {
      title: t("custom_event_name"),
      description: t("custom_event_name_description"),
      type: "creation",
      enableOverflow: !0,
      children: [
        /* @__PURE__ */ m(kce, { ...l, children: /* @__PURE__ */ m(
          Kod,
          {
            event: a,
            close: r,
            setValue: i,
            placeHolder: o,
            defaultValue: n,
            isNameFieldSplit: s,
            customClassNames: c
          }
        ) }),
        /* @__PURE__ */ Y(Fc, { children: [
          /* @__PURE__ */ m(ca, { children: t("cancel") }),
          /* @__PURE__ */ m(ut, { form: "custom-event-name", type: "submit", color: "primary", children: t("create") })
        ] })
      ]
    }
  ) });
}, Zod = Yod, Aee = ({
  checked: e,
  onCheckedChange: t,
  recipient: n,
  t: o,
  customClassNames: r
}) => {
  var u, _, p, f, g, h, b, v, $, k;
  const [i, a] = ze(!1), [s, c] = ze(""), l = o("confirm", { defaultValue: "confirm" }), d = o(n === "attendees" ? "disable_all_emails_to_attendees" : "disable_all_emails_to_hosts");
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ m(Gi, { open: i, onOpenChange: (S) => a(S), children: /* @__PURE__ */ Y(
      Ei,
      {
        title: d,
        Icon: "circle-alert",
        className: (u = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : u.container,
        children: [
          /* @__PURE__ */ m(
            "p",
            {
              className: ae("text-default text-sm", (_ = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : _.description),
              children: /* @__PURE__ */ m(Dc, { t: o, i18nKey: "disable_attendees_emails_description", values: { recipient: n } })
            }
          ),
          /* @__PURE__ */ m(
            "p",
            {
              className: ae(
                "text-default mb-1 mt-2 text-sm",
                (f = (p = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : p.confirmInput) == null ? void 0 : f.label
              ),
              children: o("type_confirm_to_continue")
            }
          ),
          /* @__PURE__ */ m(
            hi,
            {
              value: s,
              onChange: (S) => {
                c(S.target.value);
              }
            }
          ),
          /* @__PURE__ */ Y(Fc, { className: (h = (g = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : g.dialogFooter) == null ? void 0 : h.container, children: [
            /* @__PURE__ */ m(ca, { className: (v = (b = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : b.dialogFooter) == null ? void 0 : v.cancelButton }),
            /* @__PURE__ */ m(
              ut,
              {
                disabled: s.toLowerCase() !== l.toLowerCase(),
                onClick: () => {
                  t(!0), a(!1);
                },
                className: (k = ($ = r == null ? void 0 : r.confirmationDialog) == null ? void 0 : $.dialogFooter) == null ? void 0 : k.confirmButton,
                children: o("disable_email")
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ m(
      eo,
      {
        labelClassName: ae("text-sm", r == null ? void 0 : r.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: ae(
          "border-subtle rounded-lg border py-6 px-4 sm:px-6",
          r == null ? void 0 : r.container
        ),
        descriptionClassName: r == null ? void 0 : r.description,
        title: d,
        description: o("disable_all_emails_description"),
        checked: !!e,
        onCheckedChange: () => e ? t(!e) : a(!0)
      }
    )
  ] });
};
function Qod({
  metadata: e,
  eventType: t,
  requiresConfirmation: n,
  onRequiresConfirmation: o,
  seatsEnabled: r,
  customClassNames: i
}) {
  const { t: a } = Fe(), [s, c] = ze(
    e == null ? void 0 : e.requiresConfirmationThreshold
  ), l = { time: 30, unit: "minutes" }, d = Dn();
  Le(() => {
    n || d.setValue("metadata.requiresConfirmationThreshold", void 0, { shouldDirty: !0 });
  }, [n]);
  const { shouldLockDisableProps: u } = dm({ eventType: t, translate: a, formMethods: d }), _ = u("requiresConfirmation"), p = [
    { label: a("minute_timeUnit"), value: "minutes" },
    { label: a("hour_timeUnit"), value: "hours" }
  ], f = p.find(
    (b) => {
      var v;
      return b.value === (((v = e == null ? void 0 : e.requiresConfirmationThreshold) == null ? void 0 : v.unit) ?? l.unit);
    }
  ), g = d.getValues("requiresConfirmationWillBlockSlot"), h = d.getValues("requiresConfirmationForFreeEmail");
  return /* @__PURE__ */ m("div", { className: "block items-start sm:flex", children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m(
    Wt,
    {
      name: "requiresConfirmation",
      control: d.control,
      render: () => {
        var b, v, $, k, S, O, I, D;
        return /* @__PURE__ */ m(
          eo,
          {
            labelClassName: ae("text-sm", i == null ? void 0 : i.label),
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: ae(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              n && "rounded-b-none",
              i == null ? void 0 : i.container
            ),
            childrenClassName: ae("lg:ml-0", i == null ? void 0 : i.children),
            descriptionClassName: i == null ? void 0 : i.description,
            title: a("requires_confirmation"),
            "data-testid": "requires-confirmation",
            disabled: r || _.disabled,
            tooltip: r ? a("seat_options_doesnt_support_confirmation") : void 0,
            description: /* @__PURE__ */ m(
              Ga,
              {
                t: a,
                i18nKey: "requires_confirmation_description",
                href: "https://cal.com/help/event-types/how-to-requires"
              }
            ),
            checked: n,
            LockedIcon: _.LockedIcon,
            onCheckedChange: (M) => {
              d.setValue("requiresConfirmation", M, { shouldDirty: !0 }), M || (d.setValue("requiresConfirmationWillBlockSlot", !1, { shouldDirty: !0 }), d.setValue("requiresConfirmationForFreeEmail", !1, { shouldDirty: !0 })), o(M);
            },
            children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              ck,
              {
                defaultValue: n ? s === void 0 ? "always" : "notice" : void 0,
                onValueChange: (M) => {
                  M === "always" ? (d.setValue("requiresConfirmation", !0, { shouldDirty: !0 }), o(!0), d.setValue("metadata.requiresConfirmationThreshold", void 0, {
                    shouldDirty: !0
                  }), c(void 0)) : M === "notice" && (d.setValue("requiresConfirmation", !0, { shouldDirty: !0 }), o(!0), d.setValue(
                    "metadata.requiresConfirmationThreshold",
                    s || l,
                    { shouldDirty: !0 }
                  ));
                },
                children: /* @__PURE__ */ Y(
                  "div",
                  {
                    className: ae(
                      "flex flex-col flex-wrap justify-start gap-y-2",
                      i == null ? void 0 : i.radioGroupContainer
                    ),
                    children: [
                      (s === void 0 || !_.disabled) && /* @__PURE__ */ m(
                        yL,
                        {
                          label: a("always"),
                          disabled: _.disabled,
                          id: "always",
                          value: "always",
                          className: i == null ? void 0 : i.alwaysConfirmationRadio
                        }
                      ),
                      (s !== void 0 || !_.disabled) && /* @__PURE__ */ Y(Ce, { children: [
                        /* @__PURE__ */ m(
                          yL,
                          {
                            disabled: _.disabled,
                            className: ae(
                              "items-center",
                              (b = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : b.container
                            ),
                            label: /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
                              Dc,
                              {
                                t: a,
                                i18nKey: "when_booked_with_less_than_notice",
                                components: [
                                  /* @__PURE__ */ Y(
                                    "div",
                                    {
                                      className: "mx-2 inline-flex items-center",
                                      children: [
                                        /* @__PURE__ */ m(
                                          Sc,
                                          {
                                            type: "number",
                                            min: 1,
                                            disabled: _.disabled,
                                            onChange: (M) => {
                                              var C;
                                              const N = Number((C = M.target) == null ? void 0 : C.value);
                                              c({
                                                unit: (s == null ? void 0 : s.unit) ?? l.unit,
                                                time: N
                                              }), d.setValue(
                                                "metadata.requiresConfirmationThreshold.time",
                                                N,
                                                { shouldDirty: !0 }
                                              );
                                            },
                                            className: ae(
                                              "border-default h-9! !m-0 block w-16 rounded-r-none border-r-0 text-sm [appearance:textfield] focus:z-10 focus:border-r",
                                              (v = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : v.timeInput
                                            ),
                                            defaultValue: (($ = e == null ? void 0 : e.requiresConfirmationThreshold) == null ? void 0 : $.time) || 30
                                          }
                                        ),
                                        /* @__PURE__ */ m(
                                          "label",
                                          {
                                            className: ae(
                                              _.disabled && "cursor-not-allowed"
                                            ),
                                            children: /* @__PURE__ */ m(
                                              Tr,
                                              {
                                                inputId: "notice",
                                                options: p,
                                                isSearchable: !1,
                                                isDisabled: _.disabled,
                                                className: (k = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : k.timeUnitSelect,
                                                innerClassNames: {
                                                  control: "rounded-l-none max-h-4 px-3 bg-subtle py-1"
                                                },
                                                onChange: (M) => {
                                                  c({
                                                    time: (s == null ? void 0 : s.time) ?? l.time,
                                                    unit: M == null ? void 0 : M.value
                                                  }), d.setValue(
                                                    "metadata.requiresConfirmationThreshold.unit",
                                                    M == null ? void 0 : M.value,
                                                    { shouldDirty: !0 }
                                                  );
                                                },
                                                defaultValue: f
                                              }
                                            )
                                          }
                                        )
                                      ]
                                    },
                                    "when_booked_with_less_than_notice"
                                  )
                                ]
                              }
                            ) }),
                            id: "notice",
                            value: "notice"
                          }
                        ),
                        /* @__PURE__ */ Y("div", { className: "-ml-1 space-y-2", children: [
                          /* @__PURE__ */ m(
                            Ta,
                            {
                              checked: g,
                              descriptionAsLabel: !0,
                              description: a("requires_confirmation_will_block_slot_description"),
                              className: (S = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : S.checkbox,
                              descriptionClassName: (O = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : O.checkboxDescription,
                              onChange: (M) => {
                                d.setValue("requiresConfirmationWillBlockSlot", M.target.checked, {
                                  shouldDirty: !0
                                });
                              }
                            }
                          ),
                          /* @__PURE__ */ m(
                            Ta,
                            {
                              checked: h,
                              descriptionAsLabel: !0,
                              description: a("require_confirmation_for_free_email"),
                              className: (I = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : I.checkbox,
                              descriptionClassName: (D = i == null ? void 0 : i.conditionalConfirmationRadio) == null ? void 0 : D.checkboxDescription,
                              onChange: (M) => {
                                d.setValue("requiresConfirmationForFreeEmail", M.target.checked, {
                                  shouldDirty: !0
                                });
                              }
                            }
                          )
                        ] })
                      ] })
                    ]
                  }
                )
              }
            ) })
          }
        );
      }
    }
  ) }) });
}
const Cee = {
  DestinationCalendarSettings({
    showConnectedCalendarSettings: e,
    customClassNames: t,
    calendarsQuery: n,
    eventNameLocked: o,
    eventNamePlaceholder: r,
    setShowEventNameTip: i,
    verifiedSecondaryEmails: a,
    userEmail: s,
    isTeamEventType: c,
    showToast: l
  }) {
    var g, h, b, v, $, k, S, O, I, D, M, N, C;
    const { t: d } = Fe(), u = Dn(), [_, p] = ze(
      u.getValues("useEventTypeDestinationCalendarEmail")
    ), f = u.getValues("secondaryEmailId") || -1;
    return /* @__PURE__ */ Y("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
        e && /* @__PURE__ */ Y(
          "div",
          {
            className: ae(
              "flex w-full flex-col",
              (g = t == null ? void 0 : t.destinationCalendar) == null ? void 0 : g.container
            ),
            children: [
              /* @__PURE__ */ m(
                Xn,
                {
                  className: ae(
                    "text-emphasis mb-0 font-medium",
                    (h = t == null ? void 0 : t.destinationCalendar) == null ? void 0 : h.label
                  ),
                  children: d("add_to_calendar")
                }
              ),
              /* @__PURE__ */ m(
                Wt,
                {
                  name: "destinationCalendar",
                  render: ({ field: { onChange: P, value: x } }) => /* @__PURE__ */ m(
                    XKl,
                    {
                      value: x ? x.externalId : void 0,
                      onChange: P,
                      hidePlaceholder: !0,
                      hideAdvancedText: !0,
                      calendarsQueryData: n.data,
                      customClassNames: t == null ? void 0 : t.destinationCalendar
                    }
                  )
                }
              ),
              /* @__PURE__ */ m("p", { className: "text-subtle text-sm", children: d("select_which_cal") })
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: ae("w-full", (b = t == null ? void 0 : t.eventName) == null ? void 0 : b.container), children: /* @__PURE__ */ m(
          Io,
          {
            label: d("event_name_in_calendar"),
            labelClassName: (v = t == null ? void 0 : t.eventName) == null ? void 0 : v.label,
            addOnClassname: ($ = t == null ? void 0 : t.eventName) == null ? void 0 : $.addOn,
            className: (k = t == null ? void 0 : t.eventName) == null ? void 0 : k.input,
            type: "text",
            ...o,
            placeholder: r,
            ...u.register("eventName"),
            addOnSuffix: /* @__PURE__ */ m(
              ut,
              {
                color: "minimal",
                size: "sm",
                "aria-label": "edit custom name",
                className: "hover:stroke-3 hover:text-emphasis min-w-fit !py-0 px-0 hover:bg-transparent",
                onClick: () => i((P) => !P),
                children: /* @__PURE__ */ m(ot, { name: "pencil", className: "h-4 w-4" })
              }
            )
          }
        ) })
      ] }),
      /* @__PURE__ */ Y("div", { className: "space-y-2", children: [
        e && /* @__PURE__ */ m("div", { className: ae("w-full", (S = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : S.container), children: /* @__PURE__ */ m(
          Ri,
          {
            tooltip: d("if_enabled_email_address_as_organizer"),
            label: /* @__PURE__ */ Y(Ce, { children: [
              d("display_add_to_calendar_organizer"),
              /* @__PURE__ */ m(
                ot,
                {
                  name: "info",
                  className: "text-default hover:text-attention hover:bg-attention ms-1 inline h-4 w-4 rounded-md"
                }
              )
            ] }),
            checked: _,
            onCheckedChange: (P) => {
              p(P), u.setValue("useEventTypeDestinationCalendarEmail", P, {
                shouldDirty: !0
              }), P && l(d("reconnect_calendar_to_use"), "warning");
            }
          }
        ) }),
        !e && /* @__PURE__ */ m("p", { className: "text-emphasis mb-2 block text-sm font-medium leading-none", children: d("add_to_calendar") }),
        !_ && a.length > 0 && !c && /* @__PURE__ */ Y("div", { className: ae("flex w-full flex-col", e && "pl-11"), children: [
          /* @__PURE__ */ m(
            rj,
            {
              placeholder: f === -1 && /* @__PURE__ */ Y("span", { className: "text-default min-w-0 overflow-hidden truncate whitespace-nowrap", children: [
                /* @__PURE__ */ m(Nr, { variant: "blue", children: d("default") }),
                " ",
                s
              ] }),
              className: (I = (O = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : O.emailSelect) == null ? void 0 : I.select,
              containerClassName: (M = (D = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : D.emailSelect) == null ? void 0 : M.container,
              onChange: (P) => u.setValue("secondaryEmailId", P == null ? void 0 : P.value, { shouldDirty: !0 }),
              value: a.find(
                (P) => f !== -1 && P.value === f
              ),
              options: a
            }
          ),
          /* @__PURE__ */ m(
            "p",
            {
              className: ae(
                "text-subtle mt-2 text-sm",
                (C = (N = t == null ? void 0 : t.addToCalendarEmailOrganizer) == null ? void 0 : N.emailSelect) == null ? void 0 : C.displayEmailLabel
              ),
              children: d("display_email_as_organizer")
            }
          )
        ] })
      ] })
    ] });
  },
  DestinationCalendarSettingsSkeleton() {
    return /* @__PURE__ */ Y("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
        /* @__PURE__ */ Y("div", { className: "flex w-full flex-col", children: [
          /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-10 w-full animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-4 w-48 animate-pulse rounded-md" })
        ] }),
        /* @__PURE__ */ Y("div", { className: "w-full", children: [
          /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-32 animate-pulse rounded-md" }),
          /* @__PURE__ */ m("div", { className: "bg-emphasis mt-2 h-10 w-full animate-pulse rounded-md" })
        ] })
      ] }),
      /* @__PURE__ */ Y("div", { className: "space-y-2", children: [
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-6 w-64 animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-10 w-full animate-pulse rounded-md" }),
        /* @__PURE__ */ m("div", { className: "bg-emphasis h-4 w-48 animate-pulse rounded-md" })
      ] })
    ] });
  }
}, c0e = {
  CalendarSettingsSkeleton() {
    return /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m(Cee.DestinationCalendarSettingsSkeleton, {}),
      /* @__PURE__ */ m(uX, {})
    ] });
  },
  CalendarSettings({
    eventType: e,
    calendarsQuery: t,
    verifiedSecondaryEmails: n,
    userEmail: o,
    isTeamEventType: r,
    isChildrenManagedEventType: i,
    customClassNames: a,
    eventNameLocked: s,
    eventNamePlaceholder: c,
    setShowEventNameTip: l,
    showToast: d
  }) {
    var v, $;
    const u = Dn(), _ = Zo(), p = !r || i, f = t.isPending, g = !!((v = t.data) != null && v.connectedCalendars.length) && p, h = u.getValues("useEventLevelSelectedCalendars") ? h$.EventType : h$.User, b = ($ = t.data) == null ? void 0 : $.destinationCalendar;
    return f && p ? /* @__PURE__ */ m(c0e.CalendarSettingsSkeleton, {}) : /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m(
        Cee.DestinationCalendarSettings,
        {
          verifiedSecondaryEmails: n,
          userEmail: o,
          isTeamEventType: r,
          calendarsQuery: t,
          eventNameLocked: s,
          eventNamePlaceholder: c,
          setShowEventNameTip: l,
          showToast: d,
          showConnectedCalendarSettings: g,
          customClassNames: a
        }
      ),
      /* @__PURE__ */ m("div", { children: p ? g && /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(IT, { fallback: /* @__PURE__ */ m(uX, {}), children: !_ && /* @__PURE__ */ m(
        WJl,
        {
          eventTypeId: e.id,
          disabledScope: h$.User,
          disableConnectionModification: !0,
          scope: h,
          destinationCalendarId: b == null ? void 0 : b.externalId,
          setScope: (k) => {
            const S = k === h$.EventType;
            u.setValue("useEventLevelSelectedCalendars", S, {
              shouldDirty: !0
            });
          }
        }
      ) }) }) : null })
    ] });
  }
}, Jod = ({
  eventType: e,
  team: t,
  calendarsQuery: n,
  user: o,
  isUserLoading: r,
  showToast: i,
  showBookerLayoutSelector: a,
  customClassNames: s,
  verifiedEmails: c,
  orgId: l,
  localeOptions: d
}) => {
  var so, rn, Ht, qn, Bn, Or, oo, Zn;
  const u = Zo(), _ = po(), p = Dn(), { t: f } = Fe(), [g, h] = ze(!1), [b, v] = ze(!1), [$, k] = ze(!1), [S, O] = ze(
    !!p.getValues("multiplePrivateLinks") && ((so = p.getValues("multiplePrivateLinks")) == null ? void 0 : so.length) !== 0
  ), [I, D] = ze(
    !!p.getValues("interfaceLanguage")
  ), [M, N] = ze(!!p.getValues("successRedirectUrl")), C = {}, P = e.workflows.map((st) => st.workflow), x = (o == null ? void 0 : o.theme) === "dark" || !(o != null && o.theme) && typeof document < "u" && document.documentElement.classList.contains("dark");
  p.getValues().bookingFields.forEach(({ name: st }) => {
    C[st] = `${st} input`;
  });
  const w = p.getValues().bookingFields.find((st) => st.name === "name"), E = (w && w.variant === "firstAndLastName") ?? !1, T = {
    attendeeName: f("scheduler"),
    eventType: p.getValues("title"),
    eventName: p.getValues("eventName"),
    host: ((rn = p.getValues("users")[0]) == null ? void 0 : rn.name) || "Nameless",
    bookingFields: C,
    eventDuration: p.getValues("length"),
    t: f
  }, [z, j] = ze(
    p.getValues("requiresConfirmation")
  ), q = p.watch("seatsPerTimeSlotEnabled"), V = (p.getValues("locations") || []).length > 1, F = ((Bn = (qn = (Ht = p.getValues("metadata")) == null ? void 0 : Ht.apps) == null ? void 0 : qn.stripe) == null ? void 0 : Bn.enabled) === !0 && ((Zn = (oo = (Or = p.getValues("metadata")) == null ? void 0 : Or.apps) == null ? void 0 : oo.stripe) == null ? void 0 : Zn.paymentOption) === "HOLD", L = !!p.getValues("recurringEvent"), U = d && d.length > 0 ? [{ label: f("visitors_browser_language"), value: "" }, ...d] : [], W = e.schedulingType && e.schedulingType === aa.ROUND_ROBIN, H = (st) => {
    const ft = p.getValues("bookingFields");
    p.setValue(
      "bookingFields",
      ft.map((yt) => yt.name === "guests" ? {
        ...yt,
        hidden: !st,
        editable: st ? "system-but-optional" : "system-but-hidden"
      } : yt),
      { shouldDirty: !0 }
    );
  }, { isChildrenManagedEventType: Q, isManagedEventType: X, shouldLockDisableProps: re, shouldLockIndicator: Z } = dm({
    eventType: e,
    translate: f,
    formMethods: p
  }), ee = tye({
    ...T,
    eventName: p.watch("eventName")
  }), J = re("successRedirectUrl"), oe = re("seatsPerTimeSlotEnabled"), ce = re("requiresBookerEmailVerification"), de = re("canSendCalVideoTranscriptionEmails"), te = re("hideCalendarNotes"), ue = re("hideCalendarEventDetails"), le = re("eventTypeColor"), se = re("lockTimeZoneToggleOnBookingPage"), me = re("multiplePrivateLinks"), pe = re("allowReschedulingPastBookings"), be = re("hideOrganizerEmail"), Se = re("customReplyToEmail"), Ae = re("disableCancelling"), Ze = re("disableRescheduling"), Ge = re(
    "allowReschedulingCancelledBookings"
  ), { isLocked: rt, ...qe } = re("eventName");
  X && (me.disabled = !0);
  const [Xe, lt] = ze(e.disableCancelling || !1), [Et, wt] = ze(e.disableRescheduling || !1), [nn, Dt] = ze(
    e.allowReschedulingCancelledBookings ?? !1
  ), mt = re("showOptimizedSlots"), bt = () => h(!1), [gn, an] = ze(!!e.eventTypeColor), Mn = p.watch("customReplyToEmail"), [Ln, un] = ze(
    e.eventTypeColor || {
      lightEventTypeColor: m9,
      darkEventTypeColor: f9
    }
  ), qo = kod({
    userId: e.userId,
    teamId: e.teamId,
    hosts: e.hosts,
    owner: e.owner,
    team: e.team
  });
  let cn = [
    {
      label: (o == null ? void 0 : o.email) || "",
      value: -1
    },
    ...((o == null ? void 0 : o.secondaryEmails) || []).filter((st) => !!st.emailVerified).map((st) => ({ label: st.email, value: st.id }))
  ];
  const ln = (st, ft) => st.replace(`+${ft}`, "");
  let kn = (o == null ? void 0 : o.email) || "";
  u && _.clientId && (cn = cn.map((st) => ({
    ...st,
    label: ln(st.label, _.clientId)
  })), kn = ln(kn, _.clientId));
  const gt = p.watch("metadata"), Ot = Tt(() => nm({
    price: 0,
    currency: "",
    metadata: gt
  }), [gt]), _n = Tt(
    () => !Number.isNaN(Ot.price) && Ot.price > 0,
    [Ot]
  ), wn = Tt(() => u ? Uj : xj, [u]);
  return /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-4", children: [
    /* @__PURE__ */ m(
      c0e.CalendarSettings,
      {
        verifiedSecondaryEmails: cn,
        userEmail: kn,
        calendarsQuery: n,
        isTeamEventType: !!t,
        isChildrenManagedEventType: Q,
        customClassNames: s,
        eventNameLocked: qe,
        eventNamePlaceholder: ee,
        setShowEventNameTip: h,
        showToast: i,
        eventType: e
      }
    ),
    a && /* @__PURE__ */ m(
      jod,
      {
        fallbackToUserSettings: !0,
        isDark: x,
        isOuterBorder: !0,
        user: o,
        isUserLoading: r
      }
    ),
    /* @__PURE__ */ Y("div", { className: "border-subtle bg-muted rounded-lg border p-1", children: [
      /* @__PURE__ */ Y("div", { className: "p-5", children: [
        /* @__PURE__ */ m("div", { className: "text-default text-sm font-semibold leading-none ltr:mr-1 rtl:ml-1", children: f("booking_questions_title") }),
        /* @__PURE__ */ m("p", { className: "text-subtle mt-1 max-w-[280px] break-words text-sm sm:max-w-[500px]", children: /* @__PURE__ */ m(
          Ga,
          {
            t: f,
            i18nKey: "booking_questions_description",
            href: "https://cal.com/help/event-types/booking-questions"
          }
        ) })
      ] }),
      /* @__PURE__ */ m("div", { className: "border-subtle bg-default rounded-lg border p-5", children: /* @__PURE__ */ m(
        zod,
        {
          showPhoneAndEmailToggle: !0,
          title: f("confirmation"),
          description: f("what_booker_should_provide"),
          addFieldLabel: f("add_a_booking_question"),
          formProp: "bookingFields",
          ...re("bookingFields"),
          dataStore: {
            options: {
              locations: {
                // FormBuilder doesn't handle plural for non-english languages. So, use english(Location) only. This is similar to 'Workflow'
                source: { label: "Location" },
                value: Nve(p.getValues("locations") ?? [], f)
              }
            }
          },
          shouldConsiderRequired: (st) => st.name === "location" ? !0 : st.required,
          showPriceField: _n,
          paymentCurrency: (Ot == null ? void 0 : Ot.currency) || "usd"
        }
      ) })
    ] }),
    /* @__PURE__ */ m(
      Qod,
      {
        eventType: e,
        seatsEnabled: q,
        metadata: p.getValues("metadata"),
        requiresConfirmation: z,
        requiresConfirmationWillBlockSlot: p.getValues("requiresConfirmationWillBlockSlot"),
        onRequiresConfirmation: j,
        customClassNames: s == null ? void 0 : s.requiresConfirmation
      }
    ),
    !u && /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ m(
        Wt,
        {
          name: "disableCancelling",
          render: ({ field: { onChange: st } }) => /* @__PURE__ */ m(
            eo,
            {
              labelClassName: "text-sm",
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              title: f("disable_cancelling"),
              "data-testid": "disable-cancelling-toggle",
              ...Ae,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "description_disable_cancelling",
                  href: "https://cal.com/help/event-types/disable-canceling-rescheduling#disable-cancelling"
                }
              ),
              checked: Xe,
              onCheckedChange: (ft) => {
                lt(ft), st(ft);
              }
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Wt,
        {
          name: "disableRescheduling",
          render: ({ field: { onChange: st } }) => /* @__PURE__ */ m(
            eo,
            {
              labelClassName: "text-sm",
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              title: f("disable_rescheduling"),
              "data-testid": "disable-rescheduling-toggle",
              ...Ze,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "description_disable_rescheduling",
                  href: "https://cal.com/help/event-types/disable-canceling-rescheduling#disable-rescheduling"
                }
              ),
              checked: Et,
              onCheckedChange: (ft) => {
                wt(ft), st(ft);
              }
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "canSendCalVideoTranscriptionEmails",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae(
                "text-sm",
                (yt = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : yt.label
              ),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : on.container
              ),
              title: f("send_cal_video_transcription_emails"),
              "data-testid": "send-cal-video-transcription-emails",
              ...de,
              description: f("description_send_cal_video_transcription_emails"),
              descriptionClassName: (Ut = s == null ? void 0 : s.canSendCalVideoTranscriptionEmails) == null ? void 0 : Ut.description,
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          );
        }
      }
    ),
    !u && /* @__PURE__ */ m(
      Wt,
      {
        name: "autoTranslateDescriptionEnabled",
        render: ({ field: { value: st, onChange: ft } }) => /* @__PURE__ */ m(
          eo,
          {
            labelClassName: "text-sm",
            title: f("translate_description_button"),
            checked: st,
            onCheckedChange: (yt) => ft(yt),
            disabled: !l,
            tooltip: l ? void 0 : f("orgs_upgrade_to_enable_feature"),
            "data-testid": "ai_translation_toggle",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
            description: f("translate_description_button_description")
          }
        )
      }
    ),
    !u && /* @__PURE__ */ m(
      Wt,
      {
        name: "interfaceLanguage",
        control: p.control,
        defaultValue: e.interfaceLanguage ?? "",
        render: ({ field: { value: st, onChange: ft } }) => /* @__PURE__ */ m(
          eo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: ae(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              I && "rounded-b-none"
            ),
            childrenClassName: "lg:ml-0",
            "data-testid": "event-interface-language-toggle",
            title: f("interface_language"),
            description: f("interface_language_description"),
            checked: I,
            ...Z("interfaceLanguage"),
            onCheckedChange: (yt) => {
              D(yt), yt ? p.setValue("interfaceLanguage", "", { shouldDirty: !0 }) : p.setValue("interfaceLanguage", null, { shouldDirty: !0 });
            },
            children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              Tr,
              {
                "data-testid": "event-interface-language",
                className: "capitalize",
                options: U,
                onChange: (yt) => {
                  ft(yt == null ? void 0 : yt.value);
                },
                value: U.find((yt) => yt.value === st)
              }
            ) })
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "requiresBookerEmailVerification",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : on.container
              ),
              title: f("requires_booker_email_verification"),
              "data-testid": "requires-booker-email-verification",
              ...ce,
              description: f("description_requires_booker_email_verification"),
              descriptionClassName: (Ut = s == null ? void 0 : s.bookerEmailVerification) == null ? void 0 : Ut.description,
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "hideCalendarNotes",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.calendarNotes) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.calendarNotes) == null ? void 0 : on.container
              ),
              descriptionClassName: (Ut = s == null ? void 0 : s.calendarNotes) == null ? void 0 : Ut.description,
              "data-testid": "disable-notes",
              title: f("disable_notes"),
              ...te,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "disable_notes_description",
                  href: "https://cal.com/help/event-types/hide-notes"
                }
              ),
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "hideCalendarEventDetails",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : on.container
              ),
              descriptionClassName: (Ut = s == null ? void 0 : s.eventDetailsVisibility) == null ? void 0 : Ut.description,
              title: f("hide_calendar_event_details"),
              ...ue,
              description: f("description_hide_calendar_event_details"),
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "successRedirectUrl",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut, Nt, Kt, At, Mt, Ie, tt, zt, $t, In, xe;
          return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                M && "rounded-b-none",
                (on = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : on.container
              ),
              childrenClassName: ae("lg:ml-0", (Ut = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Ut.children),
              descriptionClassName: (Nt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Nt.description,
              title: f("redirect_success_booking"),
              "data-testid": "redirect-success-booking",
              ...J,
              description: f("redirect_url_description"),
              checked: M,
              onCheckedChange: (je) => {
                N(je), ft(je ? st : "");
              },
              children: /* @__PURE__ */ Y(
                "div",
                {
                  className: ae(
                    "border-subtle rounded-b-lg border border-t-0 p-6",
                    (At = (Kt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Kt.redirectUrlInput) == null ? void 0 : At.container
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      Io,
                      {
                        className: ae("w-full", (Ie = (Mt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Mt.redirectUrlInput) == null ? void 0 : Ie.input),
                        label: f("redirect_success_booking"),
                        labelClassName: (zt = (tt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : tt.redirectUrlInput) == null ? void 0 : zt.label,
                        labelSrOnly: !0,
                        disabled: J.disabled,
                        placeholder: f("external_redirect_url"),
                        "data-testid": "external-redirect-url",
                        required: M,
                        type: "text",
                        ...p.register("successRedirectUrl")
                      }
                    ),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        className: ae(
                          "mt-4",
                          (In = ($t = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : $t.forwardParamsCheckbox) == null ? void 0 : In.container
                        ),
                        children: /* @__PURE__ */ m(
                          Wt,
                          {
                            name: "forwardParamsSuccessRedirect",
                            render: ({ field: { value: je, onChange: pt } }) => {
                              var Jt, Ye, mn, Co;
                              return /* @__PURE__ */ m(
                                Ta,
                                {
                                  description: f("forward_params_redirect"),
                                  disabled: J.disabled,
                                  className: (Ye = (Jt = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : Jt.forwardParamsCheckbox) == null ? void 0 : Ye.checkbox,
                                  descriptionClassName: (Co = (mn = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : mn.forwardParamsCheckbox) == null ? void 0 : Co.description,
                                  onChange: (zo) => pt(zo),
                                  checked: je
                                }
                              );
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        className: ae(
                          "p-1 text-sm text-orange-600",
                          p.getValues("successRedirectUrl") ? "block" : "hidden",
                          (xe = s == null ? void 0 : s.bookingRedirect) == null ? void 0 : xe.error
                        ),
                        "data-testid": "redirect-url-warning",
                        children: f("redirect_url_warning")
                      }
                    )
                  ]
                }
              )
            }
          ) });
        }
      }
    ),
    !u && /* @__PURE__ */ m(
      Wt,
      {
        name: "multiplePrivateLinks",
        render: () => /* @__PURE__ */ m(
          eo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: ae(
              "border-subtle rounded-lg border py-6 px-4 sm:px-6",
              S && "rounded-b-none"
            ),
            childrenClassName: "lg:ml-0",
            "data-testid": "multiplePrivateLinksCheck",
            title: f("multiple_private_links_title"),
            ...me,
            description: /* @__PURE__ */ m(
              Ga,
              {
                t: f,
                i18nKey: "multiple_private_links_description",
                href: "https://cal.com/help/event-types/private-links"
              }
            ),
            tooltip: X ? f("managed_event_field_parent_control_disabled") : "",
            checked: S,
            onCheckedChange: (st) => {
              var ft;
              st ? p.setValue(
                "multiplePrivateLinks",
                [r0e(((ft = p.getValues("users")[0]) == null ? void 0 : ft.id) ?? (t == null ? void 0 : t.id))],
                { shouldDirty: !0 }
              ) : p.setValue("multiplePrivateLinks", [], { shouldDirty: !0 }), O(st);
            },
            children: !X && /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
              Aod,
              {
                team: t,
                bookerUrl: e.bookerUrl,
                setMultiplePrivateLinksVisible: O,
                userTimeZone: qo
              }
            ) })
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "seatsPerTimeSlotEnabled",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut, Nt;
          return /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              eo,
              {
                labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : yt.label),
                toggleSwitchAtTheEnd: !0,
                switchContainerClassName: ae(
                  "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                  st && "rounded-b-none",
                  (on = s == null ? void 0 : s.seatsOptions) == null ? void 0 : on.container
                ),
                childrenClassName: ae("lg:ml-0", (Ut = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Ut.children),
                descriptionClassName: (Nt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Nt.description,
                "data-testid": "offer-seats-toggle",
                title: f("offer_seats"),
                ...oe,
                description: /* @__PURE__ */ m(
                  Ga,
                  {
                    t: f,
                    i18nKey: "offer_seats_description",
                    href: "https://cal.com/help/event-types/offer-seats"
                  }
                ),
                checked: st,
                disabled: F || V || !q && L,
                tooltip: V ? f("multilocation_doesnt_support_seats") : F ? f("no_show_fee_doesnt_support_seats") : L ? f("recurring_event_doesnt_support_seats") : void 0,
                onCheckedChange: (Kt) => {
                  Kt ? (H(!1), p.setValue("requiresConfirmation", !1, { shouldDirty: !0 }), j(!1), p.setValue("metadata.multipleDuration", void 0, { shouldDirty: !0 }), p.setValue("seatsPerTimeSlot", e.seatsPerTimeSlot ?? 2, {
                    shouldDirty: !0
                  })) : (p.setValue("seatsPerTimeSlot", null), H(!0)), ft(Kt);
                },
                children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                  Wt,
                  {
                    name: "seatsPerTimeSlot",
                    render: ({ field: { value: Kt, onChange: At } }) => {
                      var Mt, Ie, tt, zt, $t, In, xe, je, pt, Jt;
                      return /* @__PURE__ */ Y("div", { children: [
                        /* @__PURE__ */ m(
                          Io,
                          {
                            required: !0,
                            name: "seatsPerTimeSlot",
                            labelSrOnly: !0,
                            label: f("number_of_seats"),
                            type: "number",
                            disabled: oe.disabled,
                            value: Kt > l2 ? l2 : Kt ?? 1,
                            step: 1,
                            placeholder: "1",
                            min: 1,
                            max: l2,
                            containerClassName: ae(
                              "max-w-80",
                              (Mt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Mt.seatsInput.container
                            ),
                            addOnClassname: (Ie = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Ie.seatsInput.addOn,
                            className: (zt = (tt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : tt.seatsInput) == null ? void 0 : zt.input,
                            labelClassName: (In = ($t = s == null ? void 0 : s.seatsOptions) == null ? void 0 : $t.seatsInput) == null ? void 0 : In.label,
                            addOnSuffix: f("seats"),
                            onChange: (Ye) => {
                              const mn = parseInt(Ye.target.value);
                              At(Math.min(mn, l2));
                            },
                            "data-testid": "seats-per-time-slot"
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: ae(
                              "mt-4",
                              (je = (xe = s == null ? void 0 : s.seatsOptions) == null ? void 0 : xe.showAttendeesCheckbox) == null ? void 0 : je.container
                            ),
                            children: /* @__PURE__ */ m(
                              Wt,
                              {
                                name: "seatsShowAttendees",
                                render: ({ field: { value: Ye, onChange: mn } }) => {
                                  var Co, zo, Di, Ti;
                                  return /* @__PURE__ */ m(
                                    Ta,
                                    {
                                      "data-testid": "show-attendees",
                                      description: f("show_attendees"),
                                      className: (zo = (Co = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Co.showAttendeesCheckbox) == null ? void 0 : zo.checkbox,
                                      descriptionClassName: (Ti = (Di = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Di.showAttendeesCheckbox) == null ? void 0 : Ti.description,
                                      disabled: oe.disabled,
                                      onChange: (Ds) => mn(Ds),
                                      checked: Ye
                                    }
                                  );
                                }
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ m(
                          "div",
                          {
                            className: ae(
                              "mt-2",
                              (Jt = (pt = s == null ? void 0 : s.seatsOptions) == null ? void 0 : pt.showAvalableSeatCountCheckbox) == null ? void 0 : Jt.container
                            ),
                            children: /* @__PURE__ */ m(
                              Wt,
                              {
                                name: "seatsShowAvailabilityCount",
                                render: ({ field: { value: Ye, onChange: mn } }) => {
                                  var Co, zo, Di, Ti;
                                  return /* @__PURE__ */ m(
                                    Ta,
                                    {
                                      description: f("show_available_seats_count"),
                                      disabled: oe.disabled,
                                      onChange: (Ds) => mn(Ds),
                                      checked: Ye,
                                      className: (zo = (Co = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Co.showAvalableSeatCountCheckbox) == null ? void 0 : zo.checkbox,
                                      descriptionClassName: (Ti = (Di = s == null ? void 0 : s.seatsOptions) == null ? void 0 : Di.showAvalableSeatCountCheckbox) == null ? void 0 : Ti.description
                                    }
                                  );
                                }
                              }
                            )
                          }
                        )
                      ] });
                    }
                  }
                ) })
              }
            ),
            F && /* @__PURE__ */ m(sa, { severity: "warning", title: f("seats_and_no_show_fee_error") })
          ] });
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "hideOrganizerEmail",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : on.container
              ),
              title: f("hide_organizer_email"),
              ...be,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "hide_organizer_email_description",
                  href: "https://cal.com/help/event-types/hideorganizersemail#hide-organizers-email"
                }
              ),
              descriptionClassName: (Ut = s == null ? void 0 : s.hideOrganizerEmail) == null ? void 0 : Ut.description,
              checked: st,
              onCheckedChange: (Nt) => ft(Nt),
              "data-testid": "hide-organizer-email"
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "lockTimeZoneToggleOnBookingPage",
        render: ({ field: { value: st, onChange: ft } }) => {
          var Ut, Nt, Kt;
          const yt = p.getValues("lockedTimeZone"), on = st && (!(e.lockTimeZoneToggleOnBookingPage && !e.lockedTimeZone) || !!yt);
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (Ut = s == null ? void 0 : s.timezoneLock) == null ? void 0 : Ut.label),
              descriptionClassName: (Nt = s == null ? void 0 : s.timezoneLock) == null ? void 0 : Nt.description,
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (Kt = s == null ? void 0 : s.timezoneLock) == null ? void 0 : Kt.container,
                on && "rounded-b-none"
              ),
              title: f("lock_timezone_toggle_on_booking_page"),
              ...se,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "description_lock_timezone_toggle_on_booking_page",
                  href: "https://cal.com/help/event-types/timezone-lock"
                }
              ),
              checked: st,
              onCheckedChange: (At) => {
                ft(At);
                const Mt = At ? e.lockedTimeZone ?? "Europe/London" : null;
                p.setValue("lockedTimeZone", Mt, { shouldDirty: !0 });
              },
              "data-testid": "lock-timezone-toggle",
              childrenClassName: "lg:ml-0",
              children: on && /* @__PURE__ */ m("div", { className: "border-subtle flex flex-col gap-6 rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
                Wt,
                {
                  name: "lockedTimeZone",
                  control: p.control,
                  render: ({ field: { value: At } }) => /* @__PURE__ */ Y(Ce, { children: [
                    /* @__PURE__ */ m(Xn, { className: "text-default mb-2 block text-sm font-medium", children: /* @__PURE__ */ m(Ce, { children: f("timezone") }) }),
                    /* @__PURE__ */ m(
                      wn,
                      {
                        id: "lockedTimeZone",
                        value: At ?? "Europe/London",
                        onChange: (Mt) => {
                          Mt && p.setValue("lockedTimeZone", Mt.value, { shouldDirty: !0 });
                        }
                      }
                    )
                  ] })
                }
              ) }) })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "allowReschedulingPastBookings",
        render: ({ field: { value: st, onChange: ft } }) => /* @__PURE__ */ m(
          eo,
          {
            labelClassName: ae("text-sm"),
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: ae("border-subtle rounded-lg border py-6 px-4 sm:px-6"),
            title: f("allow_rescheduling_past_events"),
            ...pe,
            description: /* @__PURE__ */ m(
              Ga,
              {
                t: f,
                i18nKey: "allow_rescheduling_past_events_description",
                href: "https://cal.com/help/event-types/allow-rescheduling"
              }
            ),
            checked: st,
            onCheckedChange: (yt) => ft(yt)
          }
        )
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "allowReschedulingCancelledBookings",
        render: ({ field: { onChange: st } }) => /* @__PURE__ */ m(
          eo,
          {
            labelClassName: "text-sm",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: "border-subtle rounded-lg border py-6 px-4 sm:px-6",
            title: f("allow_rescheduling_cancelled_bookings"),
            "data-testid": "allow-rescheduling-cancelled-bookings-toggle",
            ...Ge,
            description: f("description_allow_rescheduling_cancelled_bookings"),
            checked: nn,
            onCheckedChange: (ft) => {
              Dt(ft), st(ft);
            }
          }
        )
      }
    ),
    /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
      Wt,
      {
        name: "customReplyToEmail",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut, Nt, Kt;
          return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                !!st && "rounded-b-none",
                (on = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : on.container
              ),
              descriptionClassName: (Ut = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : Ut.description,
              childrenClassName: ae("lg:ml-0", (Nt = s == null ? void 0 : s.customReplyToEmail) == null ? void 0 : Nt.children),
              title: f("custom_reply_to_email_title"),
              ...Se,
              "data-testid": "custom-reply-to-email",
              description: f("custom_reply_to_email_description"),
              checked: !!Mn,
              onCheckedChange: (At) => {
                ft(
                  At && (Mn || e.customReplyToEmail || (c == null ? void 0 : c[0])) || null
                );
              },
              children: [
                u && /* @__PURE__ */ m(Hod, { username: ((Kt = e.users[0]) == null ? void 0 : Kt.name) || "there", showToast: i }),
                /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                  rj,
                  {
                    className: "w-full",
                    label: f("custom_reply_to_email_title"),
                    required: !!Mn,
                    placeholder: f("select_verified_email"),
                    "data-testid": "custom-reply-to-email-input",
                    value: st ? { label: st, value: st } : void 0,
                    onChange: (At) => ft((At == null ? void 0 : At.value) || null),
                    options: (c == null ? void 0 : c.map((At) => ({ label: At, value: At }))) || []
                  }
                ) })
              ]
            }
          ) });
        }
      }
    ) }),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "eventTypeColor",
        render: () => {
          var st, ft, yt, on, Ut, Nt;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (st = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : st.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                gn && "rounded-b-none",
                (ft = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : ft.container
              ),
              title: f("event_type_color"),
              ...le,
              description: f("event_type_color_description"),
              descriptionClassName: (yt = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : yt.description,
              checked: gn,
              onCheckedChange: (Kt) => {
                const At = Kt ? Ln : null;
                p.setValue("eventTypeColor", At, {
                  shouldDirty: !0
                }), an(Kt);
              },
              childrenClassName: ae("lg:ml-0", (on = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : on.children),
              children: /* @__PURE__ */ Y("div", { className: "border-subtle flex flex-col gap-6 rounded-b-lg border border-t-0 p-6", children: [
                /* @__PURE__ */ Y("div", { children: [
                  /* @__PURE__ */ m("p", { className: "text-default mb-2 block text-sm font-medium", children: f("light_event_type_color") }),
                  /* @__PURE__ */ m(
                    L$,
                    {
                      defaultValue: Ln.lightEventTypeColor,
                      onChange: (Kt) => {
                        const At = {
                          ...Ln,
                          lightEventTypeColor: Kt
                        };
                        p.setValue("eventTypeColor", At, { shouldDirty: !0 }), un(At), cY("#ffffff", Kt) ? k(!1) : k(!0);
                      }
                    }
                  ),
                  $ ? /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
                    sa,
                    {
                      severity: "warning",
                      className: (Ut = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : Ut.warningText,
                      message: f("event_type_color_light_theme_contrast_error")
                    }
                  ) }) : null
                ] }),
                /* @__PURE__ */ Y("div", { className: "mt-6 sm:mt-0", children: [
                  /* @__PURE__ */ m("p", { className: "text-default mb-2 block text-sm font-medium", children: f("dark_event_type_color") }),
                  /* @__PURE__ */ m(
                    L$,
                    {
                      defaultValue: Ln.darkEventTypeColor,
                      onChange: (Kt) => {
                        const At = {
                          ...Ln,
                          darkEventTypeColor: Kt
                        };
                        p.setValue("eventTypeColor", At, { shouldDirty: !0 }), un(At), cY("#101010", Kt) ? v(!1) : v(!0);
                      }
                    }
                  ),
                  b ? /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
                    sa,
                    {
                      severity: "warning",
                      className: (Nt = s == null ? void 0 : s.eventTypeColors) == null ? void 0 : Nt.warningText,
                      message: f("event_type_color_dark_theme_contrast_error")
                    }
                  ) }) : null
                ] })
              ] })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "showOptimizedSlots",
        render: ({ field: { onChange: st, value: ft } }) => {
          const yt = ft;
          return /* @__PURE__ */ m(
            eo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: "text-sm",
              title: f("show_optimized_slots"),
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: f,
                  i18nKey: "show_optimized_slots_description",
                  href: "https://cal.com/help/event-types/optimized-slots#optimized-slots"
                }
              ),
              checked: yt,
              ...mt,
              onCheckedChange: (on) => {
                st(on ?? !1);
              },
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                yt && "rounded-b-none"
              )
            }
          );
        }
      }
    ),
    W && /* @__PURE__ */ m(
      Wt,
      {
        name: "rescheduleWithSameRoundRobinHost",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : on.container
              ),
              title: f("reschedule_with_same_round_robin_host_title"),
              description: f("reschedule_with_same_round_robin_host_description"),
              descriptionClassName: (Ut = s == null ? void 0 : s.roundRobinReschedule) == null ? void 0 : Ut.description,
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          );
        }
      }
    ),
    KJl(P) && /* @__PURE__ */ m(
      Wt,
      {
        name: "metadata.disableStandardEmails.confirmation.attendee",
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.emailNotifications) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.emailNotifications) == null ? void 0 : on.container
              ),
              title: f("disable_attendees_confirmation_emails"),
              description: f("disable_attendees_confirmation_emails_description"),
              descriptionClassName: (Ut = s == null ? void 0 : s.emailNotifications) == null ? void 0 : Ut.description,
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          ) });
        }
      }
    ),
    HJl(P) && /* @__PURE__ */ m(
      Wt,
      {
        name: "metadata.disableStandardEmails.confirmation.host",
        defaultValue: !!p.getValues("seatsPerTimeSlot"),
        render: ({ field: { value: st, onChange: ft } }) => {
          var yt, on, Ut;
          return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (yt = s == null ? void 0 : s.emailNotifications) == null ? void 0 : yt.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle rounded-lg border py-6 px-4 sm:px-6",
                (on = s == null ? void 0 : s.emailNotifications) == null ? void 0 : on.container
              ),
              descriptionClassName: (Ut = s == null ? void 0 : s.emailNotifications) == null ? void 0 : Ut.description,
              title: f("disable_host_confirmation_emails"),
              description: f("disable_host_confirmation_emails_description"),
              checked: st,
              onCheckedChange: (Nt) => ft(Nt)
            }
          ) });
        }
      }
    ),
    (t == null ? void 0 : t.parentId) && /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ m(
        Wt,
        {
          name: "metadata.disableStandardEmails.all.attendee",
          render: ({ field: { value: st, onChange: ft } }) => /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            Aee,
            {
              checked: st,
              onCheckedChange: ft,
              recipient: "attendees",
              customClassNames: s == null ? void 0 : s.emailNotifications,
              t: f
            }
          ) })
        }
      ),
      /* @__PURE__ */ m(
        Wt,
        {
          name: "metadata.disableStandardEmails.all.host",
          defaultValue: !!p.getValues("seatsPerTimeSlot"),
          render: ({ field: { value: st, onChange: ft } }) => /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
            Aee,
            {
              checked: st,
              onCheckedChange: ft,
              recipient: "hosts",
              customClassNames: s == null ? void 0 : s.emailNotifications,
              t: f
            }
          ) })
        }
      )
    ] }),
    g && /* @__PURE__ */ m(
      Zod,
      {
        close: bt,
        setValue: (st) => p.setValue("eventName", st, { shouldDirty: !0 }),
        defaultValue: p.getValues("eventName"),
        placeHolder: ee,
        isNameFieldSplit: E,
        event: T,
        customClassNames: s == null ? void 0 : s.customEventTypeModal
      }
    )
  ] });
}, Xod = (e) => {
  var i;
  const { isPending: t, data: n, error: o } = Qv({}), { data: r } = s0e((i = e.team) == null ? void 0 : i.id);
  return /* @__PURE__ */ m(
    Jod,
    {
      ...e,
      calendarsQuery: { data: n, isPending: t, error: o },
      showBookerLayoutSelector: !1,
      verifiedEmails: r
    }
  );
}, erd = Xod, trd = ({ className: e }) => /* @__PURE__ */ m(
  "li",
  {
    className: ae(
      "border-subtle group flex w-full items-center justify-between rounded-sm border px-[10px] py-3",
      e
    ),
    children: /* @__PURE__ */ m("div", { className: "flex-grow truncate text-sm", children: /* @__PURE__ */ Y("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ m(Jn, { className: "h-4 w-32" }),
      /* @__PURE__ */ m(Jn, { className: "h-4 w-4" })
    ] }) })
  }
), l0e = it(
  ({ label: e, description: t, informationIconText: n, ...o }, r) => {
    const i = !e || o.descriptionAsLabel;
    return /* @__PURE__ */ Y("div", { className: "block items-center sm:flex", children: [
      e && /* @__PURE__ */ m("div", { className: "min-w-48 mb-4 sm:mb-0", children: ve.createElement(
        i ? "div" : "label",
        {
          className: "flex text-sm font-medium text-default",
          ...i ? {} : {
            htmlFor: o.id
          }
        },
        e
      ) }),
      /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ Y("div", { className: "relative flex items-start", children: [
        ve.createElement(
          i ? "label" : "div",
          {
            className: ae(
              "relative flex items-start",
              i ? "text-default" : "text-emphasis"
            )
          },
          /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m("div", { className: "flex h-5 items-center", children: /* @__PURE__ */ m(
              "input",
              {
                ...o,
                ref: r,
                type: "checkbox",
                className: "text-emphasis focus:ring-emphasis dark:text-muted border-default bg-default h-4 w-4 rounded transition"
              }
            ) }),
            /* @__PURE__ */ m("span", { className: "ms-2 text-sm", children: t })
          ] })
        ),
        n && /* @__PURE__ */ m(gE, { content: n })
      ] }) })
    ] });
  }
);
l0e.displayName = "CheckboxField";
const QC = l0e, d0e = ({ ...e }) => {
  const { label: t, isDefault: n, isManaged: o = !1 } = e.data, { t: r } = Fe();
  return /* @__PURE__ */ Y(sd.Option, { ...e, children: [
    /* @__PURE__ */ m("span", { children: t }),
    n && /* @__PURE__ */ m(Nr, { variant: "blue", className: "ml-2", children: r("default") }),
    o && /* @__PURE__ */ m(Nr, { variant: "gray", className: "ml-2", children: r("managed") })
  ] });
}, u0e = ({ ...e }) => {
  const { label: t, isDefault: n, isManaged: o = !1 } = e.data, { t: r } = Fe();
  return /* @__PURE__ */ Y(sd.SingleValue, { ...e, children: [
    /* @__PURE__ */ m("span", { children: t }),
    n && /* @__PURE__ */ m(Nr, { variant: "blue", className: "ml-2", children: r("default") }),
    o && /* @__PURE__ */ m(Nr, { variant: "gray", className: "ml-2", children: r("managed") })
  ] });
}, kT = (e, t) => Intl.DateTimeFormat(void 0, {
  hour: "numeric",
  minute: "numeric",
  hourCycle: t ? "h12" : "h24"
}).format(new Date(De.utc(e).format("YYYY-MM-DDTHH:mm:ss"))), _0e = Aie(
  ({
    scheduleQueryData: e,
    isSchedulePending: t,
    user: n,
    editAvailabilityRedirectUrl: o,
    customClassNames: r
  }) => {
    const i = n == null ? void 0 : n.timeFormat, { t: a, i18n: s } = Fe(), c = Bj(n == null ? void 0 : n.weekStart), l = (d) => {
      var u;
      return ((u = e == null ? void 0 : e.schedule) == null ? void 0 : u.filter((_) => _.days.includes((d + c) % 7))) || [];
    };
    return /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("div", { className: ae("border-subtle space-y-4 border-x p-6", r == null ? void 0 : r.tableContainer), children: /* @__PURE__ */ m("ol", { className: ae("table border-collapse text-sm", r == null ? void 0 : r.table), children: ab(s.language, c, "long").map((d, u) => {
        const _ = !!l(u).length;
        return /* @__PURE__ */ Y(
          "li",
          {
            className: ae(
              "my-6 flex border-transparent last:mb-2",
              r == null ? void 0 : r.tableRow
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: ae(
                    "w-20 font-medium sm:w-32 ",
                    _ ? "text-default" : "text-subtle line-through",
                    r == null ? void 0 : r.day
                  ),
                  children: d
                }
              ),
              t ? /* @__PURE__ */ m(Jn, { className: "block h-5 w-60" }) : _ ? /* @__PURE__ */ m("div", { className: "space-y-3 text-right", children: l(u).map((p, f) => /* @__PURE__ */ Y(
                "div",
                {
                  className: ae(
                    "text-default flex items-center leading-4",
                    r == null ? void 0 : r.dayAvailabilityContainer
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "span",
                      {
                        className: ae(
                          "w-16 sm:w-28 sm:text-left",
                          r == null ? void 0 : r.dayAvailabilityFrom
                        ),
                        children: kT(p.startTime, i === 12)
                      }
                    ),
                    /* @__PURE__ */ m("span", { className: ae("ms-4", r == null ? void 0 : r.dayAvailabilitySeperator), children: "-" }),
                    /* @__PURE__ */ m("div", { className: ae("ml-6 sm:w-28", r == null ? void 0 : r.dayAvailabilityTo), children: kT(p.endTime, i === 12) })
                  ]
                },
                f
              )) }) : /* @__PURE__ */ m(
                "span",
                {
                  className: ae("text-subtle ml-6 sm:ml-0", r == null ? void 0 : r.dayUnavailable),
                  children: a("unavailable")
                }
              )
            ]
          },
          d
        );
      }) }) }),
      /* @__PURE__ */ Y("div", { className: "bg-muted border-subtle flex flex-col items-center gap-2 rounded-b-md border p-6 sm:flex-row sm:items-center sm:justify-between", children: [
        /* @__PURE__ */ m("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ Y("span", { className: "text-default flex items-center justify-center text-center text-sm sm:justify-start", children: [
          /* @__PURE__ */ m(ot, { name: "globe", className: "h-3.5 w-3.5 ltr:mr-2 rtl:ml-2" }),
          (e == null ? void 0 : e.timeZone) || /* @__PURE__ */ m(Jn, { className: "block h-5 w-32" })
        ] }) }),
        !!(e != null && e.id) && !e.isManaged && !e.readOnly && !!o && /* @__PURE__ */ m(
          ut,
          {
            href: o,
            disabled: t,
            color: "minimal",
            EndIcon: "external-link",
            target: "_blank",
            rel: "noopener noreferrer",
            children: a("edit_availability")
          }
        )
      ] })
    ] });
  }
);
_0e.displayName = "EventTypeScheduleDetails";
const p0e = Aie(
  ({
    scheduleQueryData: e,
    isSchedulePending: t,
    user: n,
    restrictionScheduleRedirectUrl: o,
    customClassNames: r,
    useBookerTimezone: i
  }) => {
    const a = n == null ? void 0 : n.timeFormat, { t: s, i18n: c } = Fe(), l = Dn(), { setValue: d, watch: u } = l, _ = Bj(n == null ? void 0 : n.weekStart), p = (g) => {
      var h;
      return ((h = e == null ? void 0 : e.schedule) == null ? void 0 : h.filter((b) => b.days.includes((g + _) % 7))) || [];
    }, f = u("useBookerTimezone");
    return Le(() => {
      f === void 0 && d("useBookerTimezone", i || !1, { shouldDirty: !1 });
    }, [f, d, i]), /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("div", { className: ae("border-subtle space-y-4 border-x p-6", r == null ? void 0 : r.tableContainer), children: /* @__PURE__ */ m("ol", { className: ae("table border-collapse text-sm", r == null ? void 0 : r.table), children: ab(c.language, _, "long").map((g, h) => {
        const b = !!p(h).length;
        return /* @__PURE__ */ Y(
          "li",
          {
            className: ae(
              "my-6 flex border-transparent last:mb-2",
              r == null ? void 0 : r.tableRow
            ),
            children: [
              /* @__PURE__ */ m(
                "span",
                {
                  className: ae(
                    "w-20 font-medium sm:w-32 ",
                    b ? "text-default" : "text-subtle line-through",
                    r == null ? void 0 : r.day
                  ),
                  children: g
                }
              ),
              t ? /* @__PURE__ */ m(Jn, { className: "block h-5 w-60" }) : b ? /* @__PURE__ */ m("div", { className: "space-y-3 text-right", children: p(h).map((v, $) => /* @__PURE__ */ Y(
                "div",
                {
                  className: ae(
                    "text-default flex items-center leading-4",
                    r == null ? void 0 : r.dayAvailabilityContainer
                  ),
                  children: [
                    /* @__PURE__ */ m(
                      "span",
                      {
                        className: ae(
                          "w-16 sm:w-28 sm:text-left",
                          r == null ? void 0 : r.dayAvailabilityFrom
                        ),
                        children: kT(v.startTime, a === 12)
                      }
                    ),
                    /* @__PURE__ */ m("span", { className: ae("ms-4", r == null ? void 0 : r.dayAvailabilitySeperator), children: "-" }),
                    /* @__PURE__ */ m("div", { className: ae("ml-6 sm:w-28", r == null ? void 0 : r.dayAvailabilityTo), children: kT(v.endTime, a === 12) })
                  ]
                },
                $
              )) }) : /* @__PURE__ */ m(
                "span",
                {
                  className: ae("text-subtle ml-6 sm:ml-0", r == null ? void 0 : r.dayUnavailable),
                  children: s("unavailable")
                }
              )
            ]
          },
          g
        );
      }) }) }),
      /* @__PURE__ */ Y("div", { className: "bg-muted border-subtle flex flex-col justify-center gap-2 rounded-b-md border p-6 sm:flex-row sm:justify-between", children: [
        /* @__PURE__ */ Y("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ Y(
            "span",
            {
              className: ae(
                "text-default flex items-center justify-center text-sm sm:justify-start",
                f && "text-muted line-through"
              ),
              children: [
                /* @__PURE__ */ m(
                  ot,
                  {
                    name: "globe",
                    className: ae("h-3.5 w-3.5 ltr:mr-2 rtl:ml-2", f && "text-muted")
                  }
                ),
                (e == null ? void 0 : e.timeZone) || /* @__PURE__ */ m(Jn, { className: "block h-5 w-32" })
              ]
            }
          ),
          /* @__PURE__ */ m("div", { className: "ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ m(
            QC,
            {
              checked: f,
              disabled: t,
              description: s("use_booker_timezone"),
              informationIconText: s("use_booker_timezone_info"),
              onChange: (g) => {
                d("useBookerTimezone", g.target.checked, { shouldDirty: !0 });
              }
            }
          ) })
        ] }),
        !!(e != null && e.id) && !e.isManaged && !e.readOnly && !!o && /* @__PURE__ */ m(
          ut,
          {
            href: o,
            disabled: t,
            color: "minimal",
            EndIcon: "external-link",
            target: "_blank",
            rel: "noopener noreferrer",
            children: s("edit_availability")
          }
        )
      ] })
    ] });
  }
);
p0e.displayName = "EventTypeRestrictionScheduleDetails";
const sq = ({
  eventType: e,
  schedulesQueryData: t,
  isSchedulesPending: n,
  customClassNames: o,
  fieldName: r = "schedule",
  scheduleQueryData: i,
  restrictionScheduleQueryData: a,
  isSchedulePending: s,
  isRestrictionSchedulePending: c,
  restrictionScheduleRedirectUrl: l,
  ...d
}) => {
  var M;
  const { t: u } = Fe(), _ = Dn(), { shouldLockIndicator: p, shouldLockDisableProps: f, isManagedEventType: g, isChildrenManagedEventType: h } = dm({ eventType: e, translate: u, formMethods: _ }), { watch: b, setValue: v } = _, $ = r === "restrictionSchedule" ? "restrictionScheduleId" : r, k = b($);
  if (Le(() => {
    var N, C;
    if (t && k !== 0 && !k) {
      let P;
      if (r === "restrictionSchedule" ? P = e.restrictionScheduleId || ((N = t.find((x) => x.isDefault)) == null ? void 0 : N.id) : P = g ? 0 : (C = t.find((x) => x.isDefault)) == null ? void 0 : C.id, !P && P !== 0)
        return;
      v($, P, {
        shouldDirty: !0
      });
    }
  }, [k, t]), n || !t)
    return /* @__PURE__ */ m(trd, {});
  const S = t.map((N) => ({
    value: N.id,
    label: N.name,
    isDefault: N.isDefault,
    isManaged: !1
  }));
  g && S.push({
    value: 0,
    label: u("members_default_schedule"),
    isDefault: !1,
    isManaged: !1
  }), h && k && !t.find((N) => N.id === k) ? S.push({
    value: k,
    label: e.scheduleName ?? u("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  }) : e.schedule && !t.find((N) => N.id === e.schedule) && S.push({
    value: e.schedule,
    label: e.scheduleName ?? u("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  }), r === "restrictionSchedule" && e.restrictionScheduleId && !t.find((N) => N.id === e.restrictionScheduleId) && S.push({
    value: e.restrictionScheduleId,
    label: e.restrictionScheduleName ?? u("default_schedule_name"),
    isDefault: !1,
    isManaged: !1
  });
  const O = r === "restrictionSchedule" ? S.filter((N) => N.value !== e.schedule) : S, I = r === "schedule" ? i : a, D = r === "schedule" ? s : c;
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle rounded-t-md border p-6",
          o == null ? void 0 : o.availabilitySectionContainer
        ),
        children: [
          /* @__PURE__ */ Y(
            "label",
            {
              htmlFor: "availability",
              className: ae(
                "text-default mb-2 block text-sm font-medium leading-none",
                (M = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : M.label
              ),
              children: [
                u("availability"),
                (g || h) && p($)
              ]
            }
          ),
          /* @__PURE__ */ m(
            Wt,
            {
              name: $,
              render: ({ field: { onChange: N, value: C } }) => {
                var x, w;
                const P = O.find(
                  (E) => E.value === C
                );
                return /* @__PURE__ */ m(
                  Tr,
                  {
                    placeholder: u("select"),
                    options: O,
                    isDisabled: f($).disabled,
                    isSearchable: !1,
                    onChange: (E) => {
                      E && (N(E.value), r === "restrictionSchedule" && E.value && v("restrictionScheduleId", E.value, { shouldDirty: !0 }));
                    },
                    className: ae(
                      "block w-full min-w-0 flex-1 rounded-sm text-sm",
                      (x = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : x.select
                    ),
                    value: P,
                    components: { Option: d0e, SingleValue: u0e },
                    isMulti: !1,
                    innerClassNames: (w = o == null ? void 0 : o.availabilitySelect) == null ? void 0 : w.innerClassNames
                  }
                );
              }
            }
          )
        ]
      }
    ),
    k !== 0 && (r === "schedule" || r === "restrictionSchedule") ? r === "restrictionSchedule" ? /* @__PURE__ */ m(
      p0e,
      {
        ...d,
        scheduleQueryData: I,
        isSchedulePending: D,
        customClassNames: o == null ? void 0 : o.availabilityTable,
        useBookerTimezone: e.useBookerTimezone,
        restrictionScheduleRedirectUrl: l
      }
    ) : /* @__PURE__ */ m(
      _0e,
      {
        ...d,
        scheduleQueryData: I,
        isSchedulePending: D,
        customClassNames: o == null ? void 0 : o.availabilityTable
      }
    ) : g && r === "schedule" && /* @__PURE__ */ m("p", { className: "!mt-2 ml-1 text-sm text-gray-600", children: u("members_default_schedule_description") })
  ] });
}, nrd = ({
  host: e,
  index: t,
  teamMembers: n,
  hostScheduleQuery: o,
  customClassNames: r
}) => {
  const { t: i } = Fe(), a = Zo(), s = Dn(), { getValues: c } = s, { data: l, isPending: d } = o({
    userId: e.userId
  }), u = l == null ? void 0 : l.schedules, _ = u == null ? void 0 : u.map((v) => ({
    value: v.id,
    label: v.name,
    isDefault: v.isDefault,
    isManaged: !1
  })), p = c(`hosts.${t}.scheduleId`), f = _ == null ? void 0 : _.find(
    (v) => {
      var $;
      return p ? v.value === p : v.value === (($ = u == null ? void 0 : u.find((k) => k.isDefault)) == null ? void 0 : $.id);
    }
  ), g = n.find((v) => v.id === e.userId), h = g == null ? void 0 : g.avatar, b = g == null ? void 0 : g.name;
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y("div", { className: ae("flex w-full items-center", r == null ? void 0 : r.labelContainer), children: [
      !a && /* @__PURE__ */ m(wl, { size: "sm", imageSrc: h, alt: b || "" }),
      a && /* @__PURE__ */ m(ot, { name: "user", className: ae("h-4 w-4", r == null ? void 0 : r.labelAvatar) }),
      /* @__PURE__ */ m("p", { className: ae("text-emphasis my-auto ms-3 text-sm", r == null ? void 0 : r.label), children: b })
    ] }),
    /* @__PURE__ */ m("div", { className: "flex w-full flex-col pt-2", children: d ? /* @__PURE__ */ m(b4e, { className: "mt-2 h-6 w-6" }) : /* @__PURE__ */ m(
      Wt,
      {
        name: `hosts.${t}.scheduleId`,
        render: ({ field: v }) => /* @__PURE__ */ m(
          Tr,
          {
            placeholder: i("select"),
            options: _,
            isSearchable: !1,
            onChange: ($) => {
              v.onChange(($ == null ? void 0 : $.value) || null);
            },
            className: ae(
              "block w-full min-w-0 flex-1 rounded-sm text-sm",
              r == null ? void 0 : r.select
            ),
            innerClassNames: r == null ? void 0 : r.innerClassNames,
            value: f,
            components: { Option: d0e, SingleValue: u0e },
            isMulti: !1,
            isDisabled: d
          }
        )
      }
    ) })
  ] });
}, ord = ({
  teamMembers: e,
  hostSchedulesQuery: t,
  customClassNames: n
}) => {
  const { t: o } = Fe(), { watch: r } = Dn(), [i] = xl(), a = r("hosts");
  return /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "border-subtle flex flex-col rounded-md",
        n == null ? void 0 : n.teamAvailibilityContainer
      ),
      children: [
        /* @__PURE__ */ Y(
          "div",
          {
            className: ae(
              "border-subtle mt-5 rounded-t-md border p-6 pb-5",
              n == null ? void 0 : n.chooseHostSchedulesLabelContainer
            ),
            children: [
              /* @__PURE__ */ m(
                Xn,
                {
                  className: ae("mb-1 text-sm font-semibold", n == null ? void 0 : n.chooseHostSchedulesLabel),
                  children: o("choose_hosts_schedule")
                }
              ),
              /* @__PURE__ */ m(
                "p",
                {
                  className: ae(
                    "text-subtle max-w-full break-words text-sm leading-tight",
                    n == null ? void 0 : n.chooseHostSchedulesLabelDescription
                  ),
                  children: o("hosts_schedule_description")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-md border border-t-0 p-6", children: a && a.length > 0 ? /* @__PURE__ */ m(
          "ul",
          {
            className: ae("mb-4 mt-3 rounded-md", a.length >= 1 && "border-subtle border"),
            ref: i,
            children: a == null ? void 0 : a.map((s, c) => {
              var l;
              return /* @__PURE__ */ m(
                "li",
                {
                  className: ae(
                    `flex flex-col px-3 py-2 ${c === a.length - 1 ? "" : "border-subtle border-b"}`,
                    (l = n == null ? void 0 : n.teamMemberSchedule) == null ? void 0 : l.container
                  ),
                  children: /* @__PURE__ */ m(
                    nrd,
                    {
                      host: s,
                      index: c,
                      teamMembers: e,
                      hostScheduleQuery: t,
                      customClassNames: n == null ? void 0 : n.teamMemberSchedule
                    }
                  )
                },
                s.userId
              );
            })
          }
        ) : /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: o("no_hosts_description") }) })
      ]
    }
  ) });
}, rrd = (e) => {
  const { setValue: t } = Dn(), [n, o] = ze(!e), r = () => {
    t("schedule", null, { shouldDirty: !!e });
  };
  return {
    useHostSchedulesForTeamEvent: n,
    toggleScheduleState: (a) => {
      const s = !a;
      o(s), s && r();
    }
  };
}, ird = (e) => {
  const { setValue: t } = Dn(), [n, o] = ze(!!e);
  return {
    restrictScheduleForHosts: n,
    toggleRestrictScheduleState: (i) => {
      o(i), i || (t("restrictionScheduleId", null, { shouldDirty: !0 }), t("useBookerTimezone", !1, { shouldDirty: !0 }));
    }
  };
}, ard = ({
  eventType: e,
  customClassNames: t,
  isRestrictionScheduleEnabled: n,
  ...o
}) => {
  const { t: r } = Fe(), i = Zo(), { useHostSchedulesForTeamEvent: a, toggleScheduleState: s } = rrd(e.schedule), { restrictScheduleForHosts: c, toggleRestrictScheduleState: l } = ird(
    e.restrictionScheduleId
  );
  return /* @__PURE__ */ Y("div", { className: "space-y-4", children: [
    /* @__PURE__ */ Y("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: [
      /* @__PURE__ */ m(
        eo,
        {
          checked: !a,
          onCheckedChange: s,
          title: r("choose_common_schedule_team_event"),
          description: r("choose_common_schedule_team_event_description"),
          children: /* @__PURE__ */ m(
            sq,
            {
              customClassNames: t == null ? void 0 : t.userAvailability,
              eventType: e,
              fieldName: "schedule",
              ...o
            }
          )
        }
      ),
      a && /* @__PURE__ */ m("div", { className: "lg:ml-14", children: /* @__PURE__ */ m(
        ord,
        {
          teamMembers: o.teamMembers,
          hostSchedulesQuery: o.hostSchedulesQuery,
          customClassNames: t == null ? void 0 : t.teamAvailability
        }
      ) })
    ] }),
    !i && n ? /* @__PURE__ */ m("div", { className: "border-subtle space-y-6 rounded-lg border p-6", children: /* @__PURE__ */ m(
      eo,
      {
        checked: c,
        onCheckedChange: l,
        title: r("choose_restriction_schedule"),
        description: r("restriction_schedule_description"),
        children: /* @__PURE__ */ m(
          sq,
          {
            customClassNames: t == null ? void 0 : t.userAvailability,
            eventType: e,
            fieldName: "restrictionSchedule",
            ...o
          }
        )
      }
    ) }) : /* @__PURE__ */ m(Ce, {})
  ] });
}, srd = ({ eventType: e, isTeamEvent: t, ...n }) => {
  var o;
  return t && e.schedulingType !== aa.MANAGED ? /* @__PURE__ */ m(ard, { eventType: e, ...n }) : /* @__PURE__ */ m(
    sq,
    {
      eventType: e,
      ...n,
      customClassNames: (o = n == null ? void 0 : n.customClassNames) == null ? void 0 : o.userAvailability
    }
  );
}, crd = "user-schedules", lrd = () => {
  const { isInit: e } = po(), t = `/${Pi.availability}`, { isLoading: n, error: o, data: r } = go({
    queryKey: [crd],
    queryFn: () => He.get(t, {
      headers: { [Gv]: gCe }
    }).then((i) => {
      var a;
      if (i.data.status === qt)
        return i.data.data;
      throw new Error((a = i.data.error) == null ? void 0 : a.message);
    }),
    enabled: e
  });
  return { isLoading: n, error: o, data: r };
}, drd = "use-team-members", urd = ({ teamId: e }) => {
  const { organizationId: t } = po();
  return go({
    queryKey: [drd, t, e],
    queryFn: async () => {
      const o = `/organizations/${t}/teams/${e}/memberships`;
      return He == null ? void 0 : He.get(o).then((r) => {
        if (r.data.status === qt)
          return r.data.data;
        throw new Error(r.data.error.message);
      });
    },
    enabled: !!t && !!e
  });
}, _rd = "use-atom-host-schedule-by-id", prd = ({ userId: e, teamId: t }) => {
  const { organizationId: n, userId: o } = po();
  return go({
    queryKey: [_rd, n, e],
    queryFn: async () => {
      const i = `/organizations/${n}/teams/${t}/users/${e}/schedules`;
      return He == null ? void 0 : He.get(i).then((a) => {
        var s, c;
        if (a.data.status === qt)
          return { schedules: a.data.data.map((d) => ({
            id: d.id,
            name: d.name,
            isDefault: d.isDefault,
            userId: d.ownerId,
            readOnly: o !== e
          })) };
        throw new Error(((c = (s = a.data) == null ? void 0 : s.error) == null ? void 0 : c.message) ?? "Error while getting host schedules");
      });
    },
    enabled: !!n && !!t && !!e
  });
}, mrd = ({
  user: e,
  teamId: t,
  ...n
}) => {
  const r = Dn().watch("schedule"), { isLoading: i, data: a } = gce(r == null ? void 0 : r.toString()), { data: s, isLoading: c } = lrd(), l = prd, { data: d } = urd({ teamId: t });
  return a ? /* @__PURE__ */ m(
    srd,
    {
      ...n,
      user: e,
      teamMembers: (d == null ? void 0 : d.map((u) => ({
        avatar: u.user.avatarUrl ?? "",
        id: u.userId,
        name: u.user.name
      }))) ?? [],
      schedulesQueryData: s,
      isSchedulesPending: c,
      isSchedulePending: i,
      hostSchedulesQuery: ({ userId: u }) => l({ userId: u, teamId: t }),
      scheduleQueryData: {
        ...a,
        isManaged: a.isManaged,
        readOnly: a.readOnly,
        id: a.id,
        timeZone: a.timeZone,
        schedule: (a.schedule || []).map((u) => ({
          id: u.id ?? null,
          startTime: new Date(u.startTime),
          endTime: new Date(u.endTime),
          userId: u.userId ?? null,
          eventTypeId: u.eventTypeId ?? null,
          scheduleId: u.scheduleId ?? null,
          date: u.date ? new Date(u.date) : null,
          days: u.days
        }))
      }
    }
  ) : /* @__PURE__ */ m(Ce, {});
}, frd = mrd, grd = () => [5, 10, 15, 20, 30, 45, 60, 90, 120], cq = 60, lq = 1440, zee = 24;
function Oee(e, t, n) {
  const r = {
    minutes_minutes: () => n,
    minutes_hours: () => n / cq,
    minutes_days: () => n / lq,
    hours_minutes: () => n * cq,
    hours_hours: () => n,
    hours_days: () => n * zee,
    days_minutes: () => n * lq,
    days_hours: () => n * zee,
    days_days: () => n
  }[`${e}_${t}`], i = r();
  return Math.ceil(i);
}
function Pee(e) {
  return e % lq === 0 ? "days" : e % cq === 0 ? "hours" : "minutes";
}
function hrd({
  maxActiveBookingsPerBookerLocked: e
}) {
  const { t } = Fe(), n = Dn(), [o, r] = ze(
    (n.getValues("maxActiveBookingsPerBooker") ?? 0) > 0
  ), i = !!n.getValues("recurringEvent"), a = n.watch(
    "maxActiveBookingPerBookerOfferReschedule"
  );
  return /* @__PURE__ */ m(
    Wt,
    {
      name: "maxActiveBookingsPerBooker",
      render: ({ field: { onChange: s, value: c } }) => {
        const l = o;
        return /* @__PURE__ */ m(
          eo,
          {
            labelClassName: ae("text-sm"),
            ...e,
            disabled: i || e.disabled,
            tooltip: i ? t("recurring_event_doesnt_support_booker_booking_limit") : "",
            toggleSwitchAtTheEnd: !0,
            switchContainerClassName: ae(
              "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
              l && "rounded-b-none"
            ),
            childrenClassName: ae("lg:ml-0"),
            title: t("booker_upcoming_limit"),
            description: /* @__PURE__ */ m(
              Ga,
              {
                t,
                i18nKey: "booker_booking_limit_description",
                href: "https://cal.com/help/event-types/booker-active-booking-limit"
              }
            ),
            checked: l,
            onCheckedChange: (d) => {
              s(d ? 1 : null), r((u) => !u);
            },
            children: /* @__PURE__ */ Y("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: [
              /* @__PURE__ */ m(
                Io,
                {
                  required: !0,
                  type: "number",
                  value: c ?? "",
                  disabled: e.disabled,
                  onChange: (d) => {
                    s(d.target.value === "" ? null : parseInt(d.target.value, 10));
                  },
                  min: 1,
                  step: 1,
                  containerClassName: ae("max-w-80"),
                  addOnSuffix: "bookings",
                  "data-testid": "booker-booking-limit-input"
                }
              ),
              /* @__PURE__ */ m(
                Ta,
                {
                  checked: !!a,
                  descriptionAsLabel: !0,
                  description: t("reschedule_last_booking_offer"),
                  disabled: e.disabled,
                  onChange: (d) => {
                    n.setValue("maxActiveBookingPerBookerOfferReschedule", d.target.checked, {
                      shouldDirty: !0
                    });
                  }
                }
              )
            ] })
          }
        );
      }
    }
  );
}
const vrd = (e) => e === ka.ROLLING_WINDOW ? {
  value: ka.ROLLING,
  rollingExcludeUnavailableDays: !0
} : e === ka.ROLLING ? {
  value: ka.ROLLING,
  rollingExcludeUnavailableDays: !1
} : {
  value: e,
  rollingExcludeUnavailableDays: null
}, m0e = (e) => e.value === ka.ROLLING && e.rollingExcludeUnavailableDays === !0 ? ka.ROLLING_WINDOW : e.value;
function brd({
  isDisabled: e,
  formMethods: t,
  radioValue: n,
  customClassNames: o
}) {
  const { t: r } = Fe();
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "text-default mb-2 flex flex-col items-start text-sm sm:flex-row sm:items-center",
        o == null ? void 0 : o.wrapper
      ),
      children: [
        /* @__PURE__ */ Y("div", { className: "flex w-full items-center sm:w-auto", children: [
          !e && /* @__PURE__ */ m(
            lk,
            {
              id: n,
              value: n,
              className: "min-w-4 bg-default border-default flex h-4 w-4 cursor-pointer items-center rounded-full border focus:border-2 focus:outline-none ltr:mr-2 rtl:ml-2",
              children: /* @__PURE__ */ m(dk, { className: "after:bg-inverted relative flex h-4 w-4 items-center justify-center after:block after:h-2 after:w-2 after:rounded-full" })
            }
          ),
          /* @__PURE__ */ m("span", { children: r("within_date_range") })
        ] }),
        /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(
          "div",
          {
            className: ae(
              "me-2 ms-0 mt-2 w-full sm:ms-2 sm:mt-0 sm:w-auto",
              o == null ? void 0 : o.datePickerWraper
            ),
            children: /* @__PURE__ */ m(
              Wt,
              {
                name: "periodDates",
                render: ({ field: { onChange: i } }) => /* @__PURE__ */ m(
                  U2c,
                  {
                    dates: {
                      startDate: t.getValues("periodDates").startDate,
                      endDate: t.getValues("periodDates").endDate
                    },
                    disabled: e,
                    onDatesChange: ({ startDate: a, endDate: s }) => {
                      i({
                        startDate: a,
                        endDate: s
                      });
                    },
                    className: o == null ? void 0 : o.datePicker
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  );
}
function yrd({
  radioValue: e,
  isDisabled: t,
  formMethods: n,
  onChange: o,
  rollingExcludeUnavailableDays: r,
  customClassNames: i
}) {
  var d, u;
  const { t: a } = Fe(), s = [
    { value: 0, label: a("business_days") },
    { value: 1, label: a("calendar_days") }
  ], c = () => s.find((_) => _.value === (n.getValues("periodCountCalendarDays") === !0 ? 1 : 0)), l = n.watch("periodDays");
  return /* @__PURE__ */ Y(
    "div",
    {
      className: ae(
        "text-default mb-2 flex flex-wrap items-baseline text-sm",
        i == null ? void 0 : i.container
      ),
      children: [
        !t && /* @__PURE__ */ m(
          lk,
          {
            id: e,
            value: e,
            className: "min-w-4 bg-default border-default flex h-4 w-4 cursor-pointer items-center rounded-full border focus:border-2 focus:outline-none ltr:mr-2 rtl:ml-2",
            children: /* @__PURE__ */ m(dk, { className: "after:bg-inverted relative flex h-4 w-4 items-center justify-center after:block after:h-2 after:w-2 after:rounded-full" })
          }
        ),
        /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              Io,
              {
                labelSrOnly: !0,
                type: "number",
                className: ae(
                  "border-default my-0 block w-16 text-sm [appearance:textfield]",
                  i == null ? void 0 : i.textField
                ),
                placeholder: "30",
                disabled: t,
                min: 0,
                max: r ? fD : void 0,
                ...n.register("periodDays", { valueAsNumber: !0 })
              }
            ),
            /* @__PURE__ */ m(
              Tr,
              {
                options: s,
                isSearchable: !1,
                isDisabled: t,
                onChange: o,
                name: "periodCoundCalendarDays",
                value: c(),
                defaultValue: c(),
                className: ae(
                  "!mt-0 ml-2 w-28 shrink sm:w-36",
                  (d = i == null ? void 0 : i.periodTypeSelect) == null ? void 0 : d.select
                ),
                innerClassNames: (u = i == null ? void 0 : i.periodTypeSelect) == null ? void 0 : u.innerClassNames
              }
            ),
            /* @__PURE__ */ Y("span", { className: "me-2 ms-2", children: [
              " ",
              a("into_the_future")
            ] })
          ] }),
          /* @__PURE__ */ m("div", { className: "-ml-6 flex flex-col py-2", children: /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              QC,
              {
                checked: !!r,
                disabled: t,
                description: a("always_show_x_days", {
                  x: l
                }),
                onChange: (_) => {
                  const p = _.target.checked;
                  n.setValue(
                    "periodDays",
                    Math.min(l, fD)
                  ), n.setValue(
                    "periodType",
                    m0e({
                      value: ka.ROLLING,
                      rollingExcludeUnavailableDays: p
                    }),
                    { shouldDirty: !0 }
                  );
                }
              }
            ),
            /* @__PURE__ */ m(
              Ao,
              {
                content: a("always_show_x_days_description", {
                  x: l
                }),
                children: /* @__PURE__ */ m(
                  ot,
                  {
                    name: "info",
                    className: "text-default hover:text-attention hover:bg-attention ms-1 inline h-4 w-4 rounded-md"
                  }
                )
              }
            )
          ] }) })
        ] })
      ]
    }
  );
}
const $rd = ve.forwardRef(function({ customClassNames: t, ...n }, o) {
  const { t: r } = Fe(), { setValue: i, getValues: a } = Dn(), s = [
    {
      label: r("minutes"),
      value: "minutes"
    },
    {
      label: r("hours"),
      value: "hours"
    },
    {
      label: r("days"),
      value: "days"
    }
  ], [c, l] = ze({
    type: Pee(a(n.name)),
    value: Oee(
      "minutes",
      Pee(a(n.name)),
      a(n.name)
    )
  });
  return Le(() => {
    i(
      n.name,
      Oee(
        c.type,
        "minutes",
        c.value
      ),
      { shouldDirty: !0 }
    );
  }, [c, i, n.name]), /* @__PURE__ */ Y("div", { className: "flex items-end justify-end", children: [
    /* @__PURE__ */ Y("div", { className: "w-1/2 md:w-full", children: [
      /* @__PURE__ */ m(
        hi,
        {
          required: !0,
          disabled: n.disabled,
          defaultValue: c.value,
          onChange: (d) => l({
            ...c,
            value: parseInt(d.target.value || "0", 10)
          }),
          label: r("minimum_booking_notice"),
          type: "number",
          placeholder: "0",
          className: ae("mb-0 h-9 ltr:mr-2 rtl:ml-2", t == null ? void 0 : t.input),
          min: 0
        }
      ),
      /* @__PURE__ */ m("input", { type: "hidden", ref: o, ...n })
    ] }),
    /* @__PURE__ */ m(
      Tr,
      {
        isSearchable: !1,
        isDisabled: n.disabled,
        className: ae(
          "mb-0 ml-2 h-9 w-full capitalize md:min-w-[150px] md:max-w-[200px]",
          t == null ? void 0 : t.select
        ),
        innerClassNames: t == null ? void 0 : t.innerClassNames,
        defaultValue: s.find(
          (d) => d.value === c.type
        ),
        onChange: (d) => {
          d && l({
            ...c,
            type: d.value
          });
        },
        options: s
      }
    )
  ] });
}), wrd = ({ eventType: e, customClassNames: t }) => {
  var v, $, k, S, O, I, D, M, N, C, P, x, w, E, T, z, j, q, V, F, L, U, W, H, Q, X, re, Z, ee, J;
  const { t: n, i18n: o } = Fe(), r = Dn();
  r.getValues("recurringEvent");
  const { shouldLockIndicator: i, shouldLockDisableProps: a } = dm({
    eventType: e,
    translate: n,
    formMethods: r
  }), s = a("bookingLimits"), c = a("durationLimits"), l = a("onlyShowFirstAvailableSlot"), d = a("periodType"), u = a("offsetStart"), _ = a("maxActiveBookingsPerBooker"), [p, f] = ze(r.getValues("offsetStart") > 0);
  ze(
    (r.getValues("maxActiveBookingsPerBooker") ?? 0) > 0
  );
  const g = r.watch("offsetStart"), h = /* @__PURE__ */ new Date();
  h.setHours(9, 0, 0, 0);
  const b = new Date(h.getTime() + g * 60 * 1e3);
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle space-y-6 rounded-lg border p-6",
          (v = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : v.container
        ),
        children: [
          /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-4  lg:flex-row lg:space-x-4 lg:space-y-0", children: [
            /* @__PURE__ */ Y(
              "div",
              {
                className: ae(
                  "w-full",
                  (k = ($ = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : $.beforeBufferSelect) == null ? void 0 : k.container
                ),
                children: [
                  /* @__PURE__ */ Y(
                    Xn,
                    {
                      htmlFor: "beforeBufferTime",
                      className: (O = (S = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : S.beforeBufferSelect) == null ? void 0 : O.label,
                      children: [
                        n("before_event"),
                        i("beforeBufferTime")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Wt,
                    {
                      name: "beforeEventBuffer",
                      render: ({ field: { onChange: oe, value: ce } }) => {
                        var te, ue, le, se;
                        const de = [
                          {
                            label: n("event_buffer_default"),
                            value: 0
                          },
                          ...grd().map((me) => ({
                            label: `${me} ${n("minutes")}`,
                            value: me
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Tr,
                          {
                            isSearchable: !1,
                            onChange: (me) => {
                              me && oe(me.value);
                            },
                            isDisabled: a("beforeBufferTime").disabled,
                            defaultValue: de.find((me) => me.value === ce) || de[0],
                            options: de,
                            className: ae(
                              (ue = (te = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : te.beforeBufferSelect) == null ? void 0 : ue.select
                            ),
                            innerClassNames: (se = (le = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : le.beforeBufferSelect) == null ? void 0 : se.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ Y(
              "div",
              {
                className: ae(
                  "w-full",
                  (D = (I = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : I.afterBufferSelect) == null ? void 0 : D.container
                ),
                children: [
                  /* @__PURE__ */ Y(
                    Xn,
                    {
                      htmlFor: "afterBufferTime",
                      className: (N = (M = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : M.afterBufferSelect) == null ? void 0 : N.label,
                      children: [
                        n("after_event"),
                        i("afterBufferTime")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Wt,
                    {
                      name: "afterEventBuffer",
                      render: ({ field: { onChange: oe, value: ce } }) => {
                        var te, ue, le, se;
                        const de = [
                          {
                            label: n("event_buffer_default"),
                            value: 0
                          },
                          ...[5, 10, 15, 20, 30, 45, 60, 90, 120].map((me) => ({
                            label: `${me} ${n("minutes")}`,
                            value: me
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Tr,
                          {
                            isSearchable: !1,
                            onChange: (me) => {
                              me && oe(me.value);
                            },
                            isDisabled: a("afterBufferTime").disabled,
                            defaultValue: de.find((me) => me.value === ce) || de[0],
                            options: de,
                            className: ae(
                              (ue = (te = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : te.afterBufferSelect) == null ? void 0 : ue.select
                            ),
                            innerClassNames: (se = (le = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : le.afterBufferSelect) == null ? void 0 : se.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ Y("div", { className: "flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0", children: [
            /* @__PURE__ */ Y(
              "div",
              {
                className: ae(
                  "w-full",
                  (P = (C = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : C.minimumNoticeInput) == null ? void 0 : P.container
                ),
                children: [
                  /* @__PURE__ */ Y(
                    Xn,
                    {
                      htmlFor: "minimumBookingNotice",
                      className: (w = (x = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : x.minimumNoticeInput) == null ? void 0 : w.label,
                      children: [
                        n("minimum_booking_notice"),
                        i("minimumBookingNotice")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    $rd,
                    {
                      customClassNames: (E = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : E.minimumNoticeInput,
                      disabled: a("minimumBookingNotice").disabled,
                      ...r.register("minimumBookingNotice")
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ Y(
              "div",
              {
                className: ae(
                  "w-full",
                  (z = (T = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : T.timeSlotIntervalSelect) == null ? void 0 : z.container
                ),
                children: [
                  /* @__PURE__ */ Y(
                    Xn,
                    {
                      htmlFor: "slotInterval",
                      className: (q = (j = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : j.timeSlotIntervalSelect) == null ? void 0 : q.label,
                      children: [
                        n("slot_interval"),
                        i("slotInterval")
                      ]
                    }
                  ),
                  /* @__PURE__ */ m(
                    Wt,
                    {
                      name: "slotInterval",
                      render: () => {
                        var ce, de, te, ue;
                        const oe = [
                          {
                            label: n("slot_interval_default"),
                            value: -1
                          },
                          ...[5, 10, 15, 20, 30, 45, 60, 75, 90, 105, 120].map((le) => ({
                            label: `${le} ${n("minutes")}`,
                            value: le
                          }))
                        ];
                        return /* @__PURE__ */ m(
                          Tr,
                          {
                            isSearchable: !1,
                            isDisabled: a("slotInterval").disabled,
                            onChange: (le) => {
                              r.setValue("slotInterval", le && (le.value || 0) > 0 ? le.value : null, {
                                shouldDirty: !0
                              });
                            },
                            defaultValue: oe.find(
                              (le) => le.value === r.getValues("slotInterval")
                            ) || oe[0],
                            options: oe,
                            className: (de = (ce = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : ce.timeSlotIntervalSelect) == null ? void 0 : de.select,
                            innerClassNames: (ue = (te = t == null ? void 0 : t.bufferAndNoticeSection) == null ? void 0 : te.timeSlotIntervalSelect) == null ? void 0 : ue.innerClassNames
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "bookingLimits",
        render: ({ field: { value: oe } }) => {
          var de, te, ue, le, se, me;
          const ce = Object.keys(oe ?? {}).length > 0;
          return /* @__PURE__ */ m(
            eo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: ae("text-sm", (de = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : de.label),
              title: n("limit_booking_frequency"),
              ...s,
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: n,
                  i18nKey: "limit_booking_frequency_description",
                  href: "https://cal.com/help/event-types/booking-frequency"
                }
              ),
              checked: ce,
              onCheckedChange: (pe) => {
                pe ? r.setValue(
                  "bookingLimits",
                  {
                    PER_DAY: 1
                  },
                  { shouldDirty: !0 }
                ) : r.setValue("bookingLimits", {}, { shouldDirty: !0 });
              },
              switchContainerClassName: ae(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                ce && "rounded-b-none",
                (te = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : te.container
              ),
              childrenClassName: ae("lg:ml-0", (ue = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : ue.children),
              descriptionClassName: (le = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : le.description,
              children: /* @__PURE__ */ m(
                "div",
                {
                  className: ae(
                    "border-subtle rounded-b-lg border border-t-0 p-6",
                    (se = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : se.intervalLimitContainer
                  ),
                  children: /* @__PURE__ */ m(
                    Iee,
                    {
                      disabled: s.disabled,
                      propertyName: "bookingLimits",
                      defaultLimit: 1,
                      step: 1,
                      customClassNames: (me = t == null ? void 0 : t.bookingFrequencyLimit) == null ? void 0 : me.intervalLimitItem
                    }
                  )
                }
              )
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "onlyShowFirstAvailableSlot",
        render: ({ field: { onChange: oe, value: ce } }) => {
          var te, ue, le, se;
          const de = ce;
          return /* @__PURE__ */ m(
            eo,
            {
              toggleSwitchAtTheEnd: !0,
              labelClassName: ae("text-sm", (te = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : te.label),
              title: n("only_show_first_available_slot"),
              description: n("only_show_first_available_slot_description"),
              checked: de,
              ...l,
              onCheckedChange: (me) => {
                oe(me ?? !1);
              },
              switchContainerClassName: ae(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                de && "rounded-b-none",
                (ue = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : ue.container
              ),
              childrenClassName: (le = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : le.children,
              descriptionClassName: (se = t == null ? void 0 : t.firstAvailableSlotOnly) == null ? void 0 : se.description
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "durationLimits",
        render: ({ field: { onChange: oe, value: ce } }) => {
          var te, ue, le, se, me;
          const de = Object.keys(ce ?? {}).length > 0;
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (te = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : te.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                de && "rounded-b-none",
                (ue = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : ue.container
              ),
              childrenClassName: ae("lg:ml-0", (le = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : le.children),
              descriptionClassName: (se = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : se.description,
              title: n("limit_total_booking_duration"),
              description: n("limit_total_booking_duration_description"),
              ...c,
              checked: de,
              onCheckedChange: (pe) => {
                oe(pe ? {
                  PER_DAY: 60
                } : {});
              },
              children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ m(
                Iee,
                {
                  propertyName: "durationLimits",
                  defaultLimit: 60,
                  disabled: c.disabled,
                  step: 15,
                  textFieldSuffix: n("minutes"),
                  customClassNames: (me = t == null ? void 0 : t.totalDurationLimit) == null ? void 0 : me.intervalLimitItem
                }
              ) })
            }
          );
        }
      }
    ),
    /* @__PURE__ */ m(
      hrd,
      {
        maxActiveBookingsPerBookerLocked: _
      }
    ),
    /* @__PURE__ */ m(
      Wt,
      {
        name: "periodType",
        render: ({ field: { onChange: oe, value: ce } }) => {
          var le, se, me, pe, be, Se;
          const de = ce && ce !== "UNLIMITED", { value: te, rollingExcludeUnavailableDays: ue } = vrd(
            r.watch("periodType")
          );
          return /* @__PURE__ */ m(
            eo,
            {
              labelClassName: ae("text-sm", (le = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : le.label),
              toggleSwitchAtTheEnd: !0,
              switchContainerClassName: ae(
                "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
                de && "rounded-b-none",
                (se = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : se.container
              ),
              childrenClassName: ae("lg:ml-0", (me = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : me.children),
              descriptionClassName: (pe = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : pe.description,
              title: n("limit_future_bookings"),
              description: /* @__PURE__ */ m(
                Ga,
                {
                  t: n,
                  i18nKey: "limit_future_bookings_description",
                  href: "https://cal.com/help/event-types/limit-future-bookings"
                }
              ),
              ...d,
              checked: de,
              onCheckedChange: (Ae) => (Ae && !r.getValues("periodDays") && r.setValue("periodDays", 30, { shouldDirty: !0 }), oe(Ae ? ka.ROLLING : ka.UNLIMITED)),
              children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: /* @__PURE__ */ Y(
                ck,
                {
                  value: te,
                  onValueChange: (Ae) => {
                    r.setValue(
                      "periodType",
                      m0e({
                        value: Ae,
                        rollingExcludeUnavailableDays: r.getValues("rollingExcludeUnavailableDays")
                      }),
                      {
                        shouldDirty: !0
                      }
                    );
                  },
                  children: [
                    (d.disabled ? te === ka.ROLLING : !0) && /* @__PURE__ */ m(
                      yrd,
                      {
                        rollingExcludeUnavailableDays: !!ue,
                        radioValue: ka.ROLLING,
                        isDisabled: d.disabled,
                        formMethods: r,
                        customClassNames: (be = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : be.rollingLimit,
                        onChange: (Ae) => {
                          r.setValue("periodCountCalendarDays", (Ae == null ? void 0 : Ae.value) === 1, {
                            shouldDirty: !0
                          });
                        }
                      }
                    ),
                    (d.disabled ? te === ka.RANGE : !0) && /* @__PURE__ */ m(
                      brd,
                      {
                        radioValue: ka.RANGE,
                        customClassNames: (Se = t == null ? void 0 : t.futureBookingLimit) == null ? void 0 : Se.rangeLimit,
                        isDisabled: d.disabled,
                        formMethods: r
                      }
                    )
                  ]
                }
              ) })
            }
          );
        }
      }
    ),
    r.getValues("offsetStart") > 0 && /* @__PURE__ */ m(
      eo,
      {
        labelClassName: ae("text-sm", (V = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : V.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: ae(
          "border-subtle mt-6 rounded-lg border py-6 px-4 sm:px-6",
          p && "rounded-b-none",
          (F = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : F.container
        ),
        childrenClassName: ae("lg:ml-0", (L = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : L.children),
        title: n("offset_toggle"),
        descriptionClassName: (U = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : U.description,
        description: n("offset_toggle_description"),
        ...u,
        checked: p,
        onCheckedChange: (oe) => {
          f(oe), oe || r.setValue("offsetStart", 0, { shouldDirty: !0 });
        },
        children: /* @__PURE__ */ m("div", { className: ae("border-subtle rounded-b-lg border border-t-0 p-6"), children: /* @__PURE__ */ m(
          Io,
          {
            required: !0,
            type: "number",
            containerClassName: ae(
              "max-w-80",
              (H = (W = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : W.offsetInput) == null ? void 0 : H.container
            ),
            labelClassName: (X = (Q = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : Q.offsetInput) == null ? void 0 : X.label,
            addOnClassname: (Z = (re = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : re.offsetInput) == null ? void 0 : Z.addOn,
            className: (J = (ee = t == null ? void 0 : t.offsetStartTimes) == null ? void 0 : ee.offsetInput) == null ? void 0 : J.input,
            label: n("offset_start"),
            ...r.register("offsetStart", { setValueAs: (oe) => Number(oe) }),
            addOnSuffix: /* @__PURE__ */ m(Ce, { children: n("minutes") }),
            hint: n("offset_start_description", {
              originalTime: h.toLocaleTimeString(o.language, { timeStyle: "short" }),
              adjustedTime: b.toLocaleTimeString(o.language, { timeStyle: "short" })
            })
          }
        ) })
      }
    )
  ] });
}, dq = eT.map((e) => ({
  value: e,
  label: `Per ${RJl(e)}`
})), krd = ({
  limitKey: e,
  step: t,
  value: n,
  textFieldSuffix: o,
  selectOptions: r,
  hasDeleteButton: i,
  disabled: a,
  onDelete: s,
  onLimitChange: c,
  onIntervalSelect: l,
  customClassNames: d
}) => {
  var u, _;
  return /* @__PURE__ */ Y(
    "div",
    {
      "data-testid": "add-limit",
      className: ae(
        "mb-4 flex w-full min-w-0 items-center gap-x-2 text-sm rtl:space-x-reverse",
        d == null ? void 0 : d.container
      ),
      children: [
        /* @__PURE__ */ m(
          Io,
          {
            required: !0,
            type: "number",
            containerClassName: o ? "w-32 sm:w-44 -mb-1 shrink" : "w-14 sm:w-16 mb-0 shrink",
            className: ae("mb-0", d == null ? void 0 : d.limitText),
            placeholder: `${n}`,
            disabled: a,
            min: t,
            step: t,
            defaultValue: n,
            addOnSuffix: o,
            onChange: (p) => c(e, parseInt(p.target.value || "0", 10))
          }
        ),
        /* @__PURE__ */ m(
          Tr,
          {
            options: r,
            isSearchable: !1,
            isDisabled: a,
            defaultValue: dq.find((p) => p.value === e),
            onChange: l,
            className: ae("w-36", (u = d == null ? void 0 : d.limitSelect) == null ? void 0 : u.select),
            innerClassNames: (_ = d == null ? void 0 : d.limitSelect) == null ? void 0 : _.innerClassNames
          }
        ),
        i && !a && /* @__PURE__ */ m(
          ut,
          {
            variant: "icon",
            StartIcon: "trash-2",
            color: "destructive",
            className: ae("border-none", d == null ? void 0 : d.addLimitButton),
            onClick: () => s(e)
          }
        )
      ]
    },
    e
  );
}, Iee = ({
  propertyName: e,
  defaultLimit: t,
  step: n,
  textFieldSuffix: o,
  disabled: r,
  customClassNames: i
}) => {
  const { watch: a, setValue: s, control: c } = Dn(), l = a(e), { t: d } = Fe(), [u] = xl();
  return /* @__PURE__ */ m(
    Wt,
    {
      name: e,
      control: c,
      render: ({ field: { value: _, onChange: p } }) => {
        const f = _, g = () => {
          if (!f || !l)
            return;
          const h = Object.keys(l), [b] = Object.values(dq).filter(
            (v) => !h.includes(v.value)
          );
          !b || !h.length || s(
            e,
            // TODO: Remove @ts-ignore, type error no longer exists in later TS versions.
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            {
              ...l,
              [b.value]: t
            },
            { shouldDirty: !0 }
          );
        };
        return /* @__PURE__ */ Y("ul", { ref: u, children: [
          f && l && Object.entries(f).sort(([h], [b]) => eT.indexOf(h) - eT.indexOf(b)).map(([h, b]) => {
            const v = h;
            return /* @__PURE__ */ m(
              krd,
              {
                limitKey: v,
                step: n,
                value: b,
                disabled: r,
                textFieldSuffix: o,
                hasDeleteButton: Object.keys(f).length > 1,
                selectOptions: dq.filter(
                  ($) => !Object.keys(f).includes($.value)
                ),
                onLimitChange: ($, k) => (
                  // @ts-expect-error FIXME Fix these typings
                  s(`${e}.${$}`, k, { shouldDirty: !0 })
                ),
                onDelete: ($) => {
                  const k = f;
                  delete k[$], p(k);
                },
                onIntervalSelect: ($) => {
                  const k = f, S = l[v];
                  delete k[v];
                  const O = {
                    ...k,
                    // Set limit to new selected value (in the example above this means we set the limit to per_week here).
                    [$ == null ? void 0 : $.value]: S
                  };
                  p(O);
                },
                customClassNames: i
              },
              h
            );
          }),
          f && Object.keys(f).length <= 3 && !r && /* @__PURE__ */ m(ut, { color: "minimal", StartIcon: "plus", onClick: g, children: d("add_limit") })
        ] });
      }
    }
  );
}, Srd = (e) => /* @__PURE__ */ m(wrd, { ...e }), xrd = Srd, f0e = ve.createContext({
  getAppData: () => ({}),
  setAppData: () => ({})
}), Sfd = () => ve.useContext(f0e), Erd = f0e;
function g0e(e) {
  const { componentMap: t, slug: n, wrapperClassName: o, ...r } = e, i = n === "stripe" ? "stripepayment" : n;
  if (!t[i])
    return null;
  const a = t[i];
  return /* @__PURE__ */ m("div", { className: o || "", children: /* @__PURE__ */ m(a, { ...r }) });
}
const Ree = (e) => {
  const { app: t, getAppData: n, setAppData: o, LockedIcon: r, disabled: i, onAppInstallSuccess: a } = e;
  return /* @__PURE__ */ m(Pfe, { message: `There is some problem with ${t.name} App`, children: /* @__PURE__ */ m(Erd.Provider, { value: { getAppData: n, setAppData: o, LockedIcon: r, disabled: i }, children: /* @__PURE__ */ m(
    g0e,
    {
      slug: t.slug === "stripe" ? "stripepayment" : t.slug,
      componentMap: bul,
      ...e,
      onAppInstallSuccess: a
    }
  ) }) });
}, Trd = () => {
  var a;
  const e = Dn(), t = ((a = e.watch("metadata")) == null ? void 0 : a.apps) || {}, n = (s) => {
    e.setValue(
      "metadata",
      {
        ...e.getValues("metadata"),
        apps: s
      },
      { shouldDirty: !0 }
    );
  }, o = (s) => function(c) {
    const l = t[s] || {};
    return c ? l[c] : l;
  }, r = e.getValues("metadata");
  return { getAppDataGetter: o, getAppDataSetter: (s, c, l) => function(d, u) {
    var f;
    const _ = ((f = e.getValues("metadata")) == null ? void 0 : f.apps) || {}, p = _[s];
    n({
      ..._,
      [s]: {
        ...p,
        [d]: u,
        credentialId: l,
        appCategories: c
      }
    });
  }, eventTypeFormMetadata: r };
}, Ard = Trd, Nee = "get-stripe-check", h0e = ({ teamId: e, onCheckError: t, initialData: n, onCheckSuccess: o }) => {
  var _, p;
  const { isInit: r, accessToken: i, organizationId: a } = po(), s = ns();
  let c = "/stripe/check";
  e && a && (c = `/organizations/${a}/teams/${e}/stripe/check`);
  const {
    data: l,
    refetch: d,
    isLoading: u
  } = go({
    queryKey: [Nee, e, a],
    enabled: r && !!i,
    queryFn: () => He == null ? void 0 : He.get(c).then(({ data: f }) => f.status === qt ? (o == null || o(), { status: qt, data: { allowConnect: !1, checked: !0 } }) : (t == null || t(f), { status: Kp, data: { allowConnect: !0, checked: !0 } })).catch((f) => (t == null || t(f), { status: Kp, data: { allowConnect: !0, checked: !0 } })),
    initialData: n
  });
  return {
    allowConnect: ((_ = l == null ? void 0 : l.data) == null ? void 0 : _.allowConnect) ?? !1,
    checked: ((p = l == null ? void 0 : l.data) == null ? void 0 : p.checked) ?? !1,
    refetch: () => {
      s.setQueryData([Nee, e, a], {
        status: qt,
        data: { allowConnect: !1, checked: !1 }
      }), d();
    },
    isLoading: u
  };
}, Crd = (e, t, n) => {
  const { organizationId: o } = po();
  let r = "/stripe/connect";
  n && o && (r = `/organizations/${o}/teams/${n}/stripe/connect`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return go({
    queryKey: ["get-stripe-connect-redirect-uri", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => He == null ? void 0 : He.get(a).then(({ data: s }) => {
      if (s.status === qt)
        return s.data.authUrl;
      if (s.status === Kp)
        throw new Error(s.error.message);
      return "";
    })
  });
}, zrd = (e, t, n) => {
  const { refetch: o } = Crd(e, t, n);
  return { connect: async () => {
    const i = await o();
    i.data && (window.location.href = i.data);
  } };
}, Ord = ({
  teamId: e,
  icon: t,
  color: n,
  isClickable: o,
  label: r,
  className: i,
  loadingLabel: a,
  alreadyConnectedLabel: s,
  redir: c,
  errorRedir: l,
  onCheckError: d,
  initialData: u,
  onCheckSuccess: _
}) => {
  const { t: p } = Fe();
  let f = r || p("stripe_connect_atom_label");
  const { connect: g } = zrd(c, l, e), { allowConnect: h, checked: b, isLoading: v } = h0e({
    onCheckError: d,
    onCheckSuccess: _,
    initialData: u,
    teamId: e
  }), $ = !b || !h;
  return b ? h || (f = s || p("stripe_connect_atom_already_connected_label")) : f = a || p("stripe_connect_atom_loading_label"), /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    ut,
    {
      StartIcon: t || "credit-card",
      color: n || "primary",
      disabled: o ? !1 : $,
      className: uo(
        "",
        "md:rounded-md",
        i,
        v && "animate-pulse bg-gray-200",
        $ && "cursor-not-allowed",
        !$ && "cursor-pointer"
      ),
      onClick: () => g(),
      children: f
    }
  ) });
}, Prd = "use-event-app-integration", Ird = (e, t) => {
  const n = `/atoms/event-types-app/${e}${t ? `?teamId=${t}` : ""}`, { isInit: o, accessToken: r } = po();
  return go({
    queryKey: [Prd, e],
    queryFn: () => He == null ? void 0 : He.get(n).then((i) => {
      if (i.data.status === qt)
        return i.data.data;
      throw new Error(i.data.error.message);
    }),
    enabled: !!e && o && !!r
  });
}, Rrd = ({ eventType: e }) => {
  const { allowConnect: t, checked: n } = h0e({ teamId: e.teamId }), o = !n || !t;
  return n ? /* @__PURE__ */ m("div", { children: o ? /* @__PURE__ */ m(Nrd, { eventType: e }) : /* @__PURE__ */ m(
    sb,
    {
      Icon: "grid-3x3",
      headline: "Stripe not connected",
      description: "You need to connect Stripe to use this feature. Please click on the button below to connect.",
      buttonRaw: /* @__PURE__ */ m(
        Ord,
        {
          teamId: e.teamId,
          label: "Connect to Stripe",
          loadingLabel: "Connect to Stripe",
          alreadyConnectedLabel: "Connect to Stripe",
          isClickable: !0,
          color: "secondary",
          redir: window.location.href
        }
      )
    }
  ) }) : /* @__PURE__ */ m("div", { children: "Checking..." });
}, Nrd = ({ eventType: e }) => {
  const { getAppDataGetter: t, getAppDataSetter: n, eventTypeFormMetadata: o } = Ard(), { data: r, isLoading: i } = Ird("stripe", e.teamId), a = {
    ...r == null ? void 0 : r.app,
    logo: `https://app.cal.com${r == null ? void 0 : r.app.logo}`
  };
  if (i || !r)
    return null;
  if (a.teams && a.teams.length > 0) {
    const s = a.teams.find((c) => c.teamId === e.teamId);
    return s ? /* @__PURE__ */ m(
      Ree,
      {
        getAppData: t(a.slug),
        setAppData: n(
          a.slug,
          a.categories,
          s.credentialId
        ),
        app: {
          ...a,
          credentialOwner: {
            name: s.name,
            avatar: s.logoUrl,
            teamId: s.teamId,
            credentialId: s.credentialId
          }
        },
        eventType: e,
        eventTypeFormMetadata: o
      },
      (a.slug ?? r.app.slug) + s.credentialId
    ) : null;
  }
  return /* @__PURE__ */ m(
    Ree,
    {
      getAppData: t(a.slug),
      setAppData: n(
        a.slug,
        a.categories,
        a.userCredentialIds && a.userCredentialIds[0]
      ),
      app: a,
      eventType: e,
      eventTypeFormMetadata: o
    },
    a.slug
  );
}, Drd = Rrd;
function Mrd({
  eventType: e,
  paymentEnabled: t,
  customClassNames: n
}) {
  var _, p, f, g, h, b, v, $, k, S, O, I;
  const { t: o } = Fe(), r = Dn(), [i, a] = ze(
    r.getValues("recurringEvent")
  ), s = !!r.getValues("seatsPerTimeSlot"), c = !!r.getValues("maxActiveBookingsPerBooker"), l = Object.entries(qh).filter(([D, M]) => isNaN(Number(D)) && Number(M) < 3).map(([D, M]) => ({
    label: o(`${D.toString().toLowerCase()}`, { count: i == null ? void 0 : i.interval }),
    value: M.toString()
  })), { shouldLockDisableProps: d } = dm({ eventType: e, translate: o, formMethods: r }), u = d("recurringEvent");
  return /* @__PURE__ */ m("div", { className: ae("block items-start sm:flex", n == null ? void 0 : n.container), children: /* @__PURE__ */ m("div", { className: t ? "" : "w-full", children: t ? /* @__PURE__ */ m(
    sa,
    {
      severity: "warning",
      className: n == null ? void 0 : n.paymentAlert,
      title: o("warning_payment_recurring_event")
    }
  ) : /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      sa,
      {
        className: ae("mb-4", n == null ? void 0 : n.experimentalAlert),
        severity: "warning",
        title: "Experimental: Recurring Events are currently experimental and causes some issues sometimes when checking for availability. We are working on fixing this."
      }
    ),
    /* @__PURE__ */ m(
      eo,
      {
        labelClassName: ae("text-sm", (_ = n == null ? void 0 : n.recurringToggle) == null ? void 0 : _.label),
        toggleSwitchAtTheEnd: !0,
        switchContainerClassName: ae(
          "border-subtle rounded-lg border py-6 px-4 sm:px-6",
          i !== null && "rounded-b-none",
          (p = n == null ? void 0 : n.recurringToggle) == null ? void 0 : p.container
        ),
        childrenClassName: ae("lg:ml-0", (f = n == null ? void 0 : n.recurringToggle) == null ? void 0 : f.children),
        descriptionClassName: (g = n == null ? void 0 : n.recurringToggle) == null ? void 0 : g.description,
        title: o("recurring_event"),
        ...u,
        description: /* @__PURE__ */ m(
          Ga,
          {
            t: o,
            i18nKey: "recurring_event_description",
            href: "https://cal.com/help/event-types/recurring-events"
          }
        ),
        checked: !!i,
        "data-testid": "recurring-event-check",
        disabled: !i && s || c,
        tooltip: s ? o("seats_doesnt_support_recurring") : c ? o("booking_limit_per_booker_doesnt_support_recurring") : void 0,
        onCheckedChange: (D) => {
          if (!D)
            r.setValue("recurringEvent", null, { shouldDirty: !0 }), a(null);
          else {
            const M = e.recurringEvent || {
              interval: 1,
              count: 12,
              freq: qh.WEEKLY
            };
            r.setValue("recurringEvent", M, { shouldDirty: !0 }), a(M);
          }
        },
        children: /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-lg border border-t-0 p-6", children: i && /* @__PURE__ */ Y("div", { "data-testid": "recurring-event-collapsible", className: "text-sm", children: [
          /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
            /* @__PURE__ */ m(
              "p",
              {
                className: ae(
                  "text-emphasis ltr:mr-2 rtl:ml-2",
                  (h = n == null ? void 0 : n.frequencyInput) == null ? void 0 : h.label
                ),
                children: o("repeats_every")
              }
            ),
            /* @__PURE__ */ m(
              Io,
              {
                disabled: u.disabled,
                type: "number",
                min: "1",
                max: "20",
                className: ae("mb-0", (b = n == null ? void 0 : n.frequencyInput) == null ? void 0 : b.input),
                defaultValue: i.interval,
                onChange: (D) => {
                  const M = {
                    ...i,
                    interval: parseInt(D == null ? void 0 : D.target.value)
                  };
                  r.setValue("recurringEvent", M, { shouldDirty: !0 }), a(M);
                }
              }
            ),
            /* @__PURE__ */ m(
              Tr,
              {
                options: l,
                value: l[i.freq],
                isSearchable: !1,
                className: ae(
                  "w-18 ml-2 block min-w-0 rounded-md text-sm",
                  (v = n == null ? void 0 : n.frequencyUnitSelect) == null ? void 0 : v.select
                ),
                innerClassNames: ($ = n == null ? void 0 : n.frequencyUnitSelect) == null ? void 0 : $.innerClassNames,
                isDisabled: u.disabled,
                onChange: (D) => {
                  const M = {
                    ...i,
                    freq: parseInt((D == null ? void 0 : D.value) || `${qh.WEEKLY}`)
                  };
                  r.setValue("recurringEvent", M, { shouldDirty: !0 }), a(M);
                }
              }
            )
          ] }),
          /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "mt-4 flex items-center",
                (k = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : k.container
              ),
              children: [
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: ae(
                      "text-emphasis ltr:mr-2 rtl:ml-2",
                      (S = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : S.labelText
                    ),
                    children: o("for_a_maximum_of")
                  }
                ),
                /* @__PURE__ */ m(
                  Io,
                  {
                    disabled: u.disabled,
                    type: "number",
                    min: "1",
                    max: "24",
                    defaultValue: i.count,
                    className: ae("mb-0", (O = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : O.countInput),
                    onChange: (D) => {
                      const M = {
                        ...i,
                        count: parseInt(D == null ? void 0 : D.target.value)
                      };
                      r.setValue("recurringEvent", M, { shouldDirty: !0 }), a(M);
                    }
                  }
                ),
                /* @__PURE__ */ m(
                  "p",
                  {
                    className: ae(
                      "text-emphasis ltr:ml-2 rtl:mr-2",
                      (I = n == null ? void 0 : n.maxEventsInput) == null ? void 0 : I.suffixText
                    ),
                    children: o("events", {
                      count: i.count
                    })
                  }
                )
              ]
            }
          )
        ] }) })
      }
    )
  ] }) }) });
}
const Lrd = ({ eventType: e, customClassNames: t }) => {
  const o = nm({
    ...e,
    metadata: wF.parse(e.metadata)
  }).price > 0;
  return /* @__PURE__ */ m(
    Mrd,
    {
      paymentEnabled: o,
      eventType: e,
      customClassNames: t
    }
  );
}, qrd = (e) => /* @__PURE__ */ m(Lrd, { ...e }), jrd = qrd, Dee = ({
  icon: e,
  label: t,
  value: n,
  customClassNames: o
}) => {
  const r = Zo(), i = (a) => {
    switch (a) {
      case "phone":
        return /* @__PURE__ */ m(ot, { name: "phone", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "userPhone":
        return /* @__PURE__ */ m(ot, { name: "phone", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "inPerson":
        return /* @__PURE__ */ m(ot, { name: "map-pin", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "attendeeInPerson":
        return /* @__PURE__ */ m(ot, { name: "map-pin", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "link":
        return /* @__PURE__ */ m(ot, { name: "link", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      case "somewhereElse":
        return /* @__PURE__ */ m(ot, { name: "map", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
      default:
        return /* @__PURE__ */ m(ot, { name: "video", className: ae("h-3.5 w-3.5", o == null ? void 0 : o.optionIcon) });
    }
  };
  return r ? /* @__PURE__ */ Y("div", { className: ae("flex items-center gap-3", o == null ? void 0 : o.optionWrapper), children: [
    i(n),
    /* @__PURE__ */ m("span", { className: ae("text-sm font-medium", o == null ? void 0 : o.optionLabel), children: t })
  ] }) : /* @__PURE__ */ Y("div", { className: "flex items-center gap-3", children: [
    e && /* @__PURE__ */ m("img", { src: e, alt: "cover", className: ae("h-3.5 w-3.5", nve(e)) }),
    /* @__PURE__ */ m("span", { className: ae(" text-sm font-medium"), children: t })
  ] });
};
function Mee({
  customClassNames: e,
  ...t
}) {
  const n = Zo();
  return /* @__PURE__ */ m(
    Tr,
    {
      name: "location",
      id: "location-select",
      "data-testid": "location-select",
      components: {
        Option: (o) => /* @__PURE__ */ m(sd.Option, { ...o, children: /* @__PURE__ */ m("div", { "data-testid": `location-select-item-${o.data.value}`, children: /* @__PURE__ */ m(
          Dee,
          {
            icon: o.data.icon,
            label: o.data.label,
            value: o.data.value,
            customClassNames: e
          }
        ) }) }),
        SingleValue: (o) => /* @__PURE__ */ m(sd.SingleValue, { ...o, children: /* @__PURE__ */ m("div", { "data-testid": `location-select-item-${o.data.value}`, children: /* @__PURE__ */ m(
          Dee,
          {
            icon: o.data.icon,
            label: o.data.label,
            value: o.data.value,
            customClassNames: e
          }
        ) }) })
      },
      formatOptionLabel: (o, r) => /* @__PURE__ */ Y("div", { className: "flex items-center gap-3", children: [
        o.icon && !n && /* @__PURE__ */ m(
          "img",
          {
            src: o.icon,
            alt: "app-icon",
            className: ae(o.icon.includes("-dark") && "dark:invert", "h-5 w-5")
          }
        ),
        /* @__PURE__ */ m("span", { children: o.label })
      ] }),
      formatGroupLabel: (o) => /* @__PURE__ */ m("p", { className: ae("text-default text-xs font-medium", e == null ? void 0 : e.groupLabel), children: o.label }),
      ...t
    }
  );
}
const Frd = ({ children: e }) => /* @__PURE__ */ m("div", { className: "bg-muted mt-2 space-y-2 rounded-lg p-4", children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ m("div", { className: "flex flex-col gap-4", children: e }) }) }), v0e = Frd, Vrd = ({ calVideoSettings: e }) => {
  var s;
  const { t } = Fe(), n = Dn(), o = Zo(), [r, i] = ze(!1), [a] = xl();
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(Ao, { content: "expandable", side: "right", className: "lg:hidden", children: /* @__PURE__ */ Y(
      "button",
      {
        "aria-expanded": r,
        onClick: () => i(!r),
        className: ae(
          "todesktop:py-[7px] text-default group flex w-full items-center rounded-md px-2 py-1.5 text-sm font-medium transition",
          "[&[aria-current='page']]:!bg-transparent",
          "[&[aria-current='page']]:text-emphasis mt-0.5 text-sm"
        ),
        children: [
          /* @__PURE__ */ m("span", { className: "hidden w-full justify-between truncate text-ellipsis lg:flex", children: t(r ? "hide_advanced_settings" : "show_advanced_settings") }),
          /* @__PURE__ */ m(ot, { name: r ? "chevron-up" : "chevron-down", className: "ml-auto h-4 w-4" })
        ]
      }
    ) }),
    /* @__PURE__ */ m("div", { ref: a, children: r && /* @__PURE__ */ Y(v0e, { children: [
      /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.disableRecordingForGuests",
          defaultValue: !!(e != null && e.disableRecordingForGuests),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("disable_recording_for_guests"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.disableRecordingForOrganizer",
          defaultValue: !!(e != null && e.disableRecordingForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("disable_recording_for_organizer"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.enableAutomaticRecordingForOrganizer",
          defaultValue: !!(e != null && e.enableAutomaticRecordingForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("enable_automatic_recording"),
              labelClassName: "text-sm",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.enableAutomaticTranscription",
          defaultValue: !!(e != null && e.enableAutomaticTranscription),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("enable_automatic_transcription"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.disableTranscriptionForGuests",
          defaultValue: !!(e != null && e.disableTranscriptionForGuests),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("disable_transcription_for_guests"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      !o && /* @__PURE__ */ m(
        Wt,
        {
          name: "calVideoSettings.disableTranscriptionForOrganizer",
          defaultValue: !!(e != null && e.disableTranscriptionForOrganizer),
          render: ({ field: { onChange: c, value: l } }) => /* @__PURE__ */ m(
            eo,
            {
              title: t("disable_transcription_for_organizer"),
              labelClassName: "text-sm leading-6 whitespace-normal break-words",
              checked: l,
              onCheckedChange: c,
              Badge: /* @__PURE__ */ m(Gm, { checkForActiveStatus: !0 })
            }
          )
        }
      ),
      /* @__PURE__ */ m(
        Io,
        {
          label: t("enter_redirect_url_on_exit_description"),
          defaultValue: (e == null ? void 0 : e.redirectUrlOnExit) || "",
          "data-testid": "calVideoSettings.redirectUrlOnExit",
          containerClassName: "mt-4",
          className: "leading-6",
          ...n.register("calVideoSettings.redirectUrlOnExit", {
            setValueAs: (c) => !c || c.trim() === "" ? null : c
          })
        }
      ),
      /* @__PURE__ */ m(
        fC,
        {
          errors: (s = n.formState.errors) == null ? void 0 : s.calVideoSettings,
          name: "redirectUrlOnExit",
          className: ae("text-error text-sm"),
          as: "div",
          id: "calVideoSettings.redirectUrlOnExit-error"
        }
      )
    ] }) })
  ] });
}, Brd = Vrd, Urd = (e) => {
  const { t } = Fe(), { eventLocationType: n, index: o, customClassNames: r, disableLocationProp: i, label: a, ...s } = e;
  if (Dn(), (n == null ? void 0 : n.organizerInputType) === "text") {
    const { defaultValue: c, ...l } = s;
    return /* @__PURE__ */ m(
      Wt,
      {
        name: `locations.${o}.${n.defaultValueVariable}`,
        defaultValue: c,
        render: ({ field: { onChange: d, value: u } }) => /* @__PURE__ */ m(
          Io,
          {
            label: a ? t(a) : null,
            name: `locations[${o}].${n.defaultValueVariable}`,
            placeholder: t(n.organizerInputPlaceholder || ""),
            type: "text",
            required: !0,
            onChange: d,
            value: u,
            ...i ? { disabled: !0 } : {},
            className: ae("my-0", r == null ? void 0 : r.addressInput),
            ...l
          }
        )
      }
    );
  } else if ((n == null ? void 0 : n.organizerInputType) === "phone") {
    const { defaultValue: c, ...l } = s;
    return /* @__PURE__ */ m(
      Wt,
      {
        name: `locations.${o}.${n.defaultValueVariable}`,
        defaultValue: c,
        render: ({ field: { onChange: d, value: u } }) => /* @__PURE__ */ m(
          Dve,
          {
            required: !0,
            disabled: i,
            placeholder: t(n.organizerInputPlaceholder || ""),
            name: `locations[${o}].${n.defaultValueVariable}`,
            className: r == null ? void 0 : r.phoneInput,
            value: u,
            onChange: d,
            ...l
          }
        )
      }
    );
  }
  return null;
}, b0e = Urd, Wrd = ({
  field: e,
  index: t,
  disableLocationProp: n,
  customClassNames: o
}) => {
  var u, _, p, f, g, h;
  const { t: r } = Fe(), { getValues: i, control: a, formState: s } = Dn(), { update: c } = B0({
    control: a,
    name: "locations"
  }), l = e, d = Xs(e.type);
  return d ? /* @__PURE__ */ Y(v0e, { children: [
    /* @__PURE__ */ m(
      b0e,
      {
        label: "organizerInputLabel" in d ? d == null ? void 0 : d.organizerInputLabel : null,
        "data-testid": `${d.type}-location-input`,
        defaultValue: l ? l[d.defaultValueVariable] : void 0,
        eventLocationType: d,
        index: t,
        customClassNames: (u = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : u.locationInput,
        disableLocationProp: n
      }
    ),
    /* @__PURE__ */ m(
      fC,
      {
        errors: (p = (_ = s.errors) == null ? void 0 : _.locations) == null ? void 0 : p[t],
        name: d.defaultValueVariable,
        className: ae(
          "text-error my-1 ml-6 text-sm",
          (f = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : f.errorMessage
        ),
        as: "div",
        id: "location-error"
      }
    ),
    d.organizerInputType && /* @__PURE__ */ m(
      QC,
      {
        name: `locations[${t}].displayLocationPublicly`,
        "data-testid": "display-location",
        disabled: n,
        defaultChecked: l == null ? void 0 : l.displayLocationPublicly,
        description: r("display_location_label"),
        className: (h = (g = o == null ? void 0 : o.organizerContactInput) == null ? void 0 : g.publicDisplayCheckbox) == null ? void 0 : h.checkbox,
        onChange: (b) => {
          const v = i("locations")[t];
          c(t, {
            ...v,
            displayLocationPublicly: b.target.checked
          });
        },
        informationIconText: r("display_location_info_badge")
      }
    ),
    (d == null ? void 0 : d.supportsCustomLabel) && /* @__PURE__ */ m(
      Io,
      {
        label: r("location_custom_label_input_label"),
        name: `locations[${t}].customLabel`,
        type: "text",
        defaultValue: l == null ? void 0 : l.customLabel,
        onChange: (b) => {
          const v = i("locations")[t];
          c(t, {
            ...v,
            customLabel: b.target.value
          });
        }
      }
    )
  ] }) : null;
}, Grd = Wrd, Hrd = (e, t) => {
  for (const n of t) {
    const o = n.options.find((r) => r.value === e);
    if (o)
      return o;
  }
}, Krd = ({
  eventType: e,
  locationOptions: t
}) => {
  const n = e.locations && e.locations.length > 0 && t.some((r) => r.options.find((i) => i.value === e.locations[0].type)), o = e.locations && e.locations.length > 0 && !n && {
    slug: e.locations[0].type.replace("integrations:", "").replace(":", "-").replace("_video", ""),
    name: e.locations[0].type.replace("integrations:", "").replace(":", " ").replace("_video", "").split(" ").map((r) => r[0].toUpperCase() + r.slice(1)).join(" ")
  };
  return { locationAvailable: n, locationDetails: o };
}, Yrd = ({
  isChildrenManagedEventType: e,
  disableLocationProp: t,
  isManagedEventType: n,
  getValues: o,
  setValue: r,
  control: i,
  formState: a,
  team: s,
  eventType: c,
  prefillLocation: l,
  customClassNames: d,
  ...u
}) => {
  var w, E, T;
  const { t: _ } = Fe(), {
    fields: p,
    append: f,
    remove: g,
    update: h
  } = B0({
    control: i,
    name: "locations"
  }), b = u.locationOptions.map((z) => {
    const j = z.options.filter((q) => s != null && s.id ? !0 : q.label !== _("organizer_default_conferencing_app"));
    return {
      ...z,
      options: j
    };
  }), [v] = xl(), $ = !!o("seatsPerTimeSlot"), k = ((w = o("locations")) == null ? void 0 : w.filter((z) => !!Xs(z.type))) || [], S = n ? (E = b.find((z) => z.label === _("default"))) == null ? void 0 : E.options[0] : void 0, { locationDetails: O, locationAvailable: I } = Krd({
    eventType: c,
    locationOptions: u.locationOptions
  }), [D, M] = ze(!1), N = S || null, [C, P] = ze(
    N
  );
  Le(() => {
    if (l) {
      const z = l.value;
      !k.find((q) => q.type === z) && !$ && (f({
        type: z,
        credentialId: l == null ? void 0 : l.credentialId
      }), P(l));
    }
  }, [l, $, k, f]);
  const x = Zo();
  return /* @__PURE__ */ Y("div", { className: ae("w-full", d == null ? void 0 : d.container), children: [
    /* @__PURE__ */ Y("ul", { ref: v, className: ae("space-y-2"), children: [
      p.map((z, j) => {
        var U, W, H, Q, X, re, Z, ee, J;
        const q = Xs(z.type), V = z, F = z.type === "integrations:daily", L = Hrd(z.type, b);
        return /* @__PURE__ */ Y("li", { children: [
          /* @__PURE__ */ Y("div", { className: "flex w-full items-center", children: [
            /* @__PURE__ */ m(
              Mee,
              {
                name: `locations[${j}].type`,
                placeholder: _("select"),
                options: b,
                isDisabled: t,
                defaultValue: L,
                isSearchable: !1,
                className: ae(
                  "block min-w-0 flex-1 rounded-sm text-sm",
                  (U = d == null ? void 0 : d.locationSelect) == null ? void 0 : U.selectWrapper
                ),
                customClassNames: d == null ? void 0 : d.locationSelect,
                menuPlacement: "auto",
                onChange: (oe) => {
                  if (M(!1), oe != null && oe.value) {
                    const ce = oe.value, de = Xs(ce);
                    if (!de)
                      return;
                    const te = de.organizerInputType || !(k != null && k.find((le) => le.type === ce)), ue = (de == null ? void 0 : de.organizerInputType) === "text" && de.defaultValueVariable === "link";
                    te ? h(j, {
                      type: ce,
                      ...oe.credentialId && {
                        credentialId: oe.credentialId,
                        teamName: oe.teamName ?? void 0
                      },
                      ...ue && {
                        link: ""
                      }
                    }) : (h(j, {
                      type: z.type,
                      ...z.credentialId && {
                        credentialId: z.credentialId,
                        teamName: z.teamName ?? void 0
                      }
                    }), nr(_("location_already_exists"), "warning"));
                  }
                }
              }
            ),
            !(t && e) && /* @__PURE__ */ m(
              "button",
              {
                "data-testid": `delete-locations.${j}.type`,
                className: ae("min-h-9 block h-9 px-2", d == null ? void 0 : d.removeLocationButton),
                type: "button",
                onClick: () => {
                  g(j), P(null);
                },
                "aria-label": _("remove"),
                children: /* @__PURE__ */ m("div", { className: "h-4 w-4", children: /* @__PURE__ */ m(
                  ot,
                  {
                    name: "x",
                    className: ae(
                      "border-l-1 hover:text-emphasis text-subtle h-4 w-4",
                      d == null ? void 0 : d.removeLocationIcon
                    )
                  }
                ) })
              }
            )
          ] }),
          F && !x && /* @__PURE__ */ m(Brd, {}),
          q != null && q.supportsCustomLabel && (q != null && q.type) ? /* @__PURE__ */ m(
            Grd,
            {
              field: z,
              index: j,
              disableLocationProp: t,
              customClassNames: d
            }
          ) : q != null && q.organizerInputType ? /* @__PURE__ */ Y("div", { className: "mt-2 space-y-2", children: [
            /* @__PURE__ */ Y("div", { className: "w-full", children: [
              /* @__PURE__ */ Y("div", { className: "flex gap-2", children: [
                /* @__PURE__ */ m("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ m(ot, { name: "corner-down-right", className: "h-4 w-4" }) }),
                /* @__PURE__ */ m(
                  b0e,
                  {
                    "data-testid": `${q.type}-location-input`,
                    defaultValue: V ? V[q.defaultValueVariable] : void 0,
                    eventLocationType: q,
                    index: j,
                    customClassNames: (W = d == null ? void 0 : d.organizerContactInput) == null ? void 0 : W.locationInput,
                    disableLocationProp: t
                  }
                )
              ] }),
              /* @__PURE__ */ m(
                fC,
                {
                  errors: (Q = (H = a.errors) == null ? void 0 : H.locations) == null ? void 0 : Q[j],
                  name: q.defaultValueVariable,
                  className: ae(
                    "text-error my-1 ml-6 text-sm",
                    (X = d == null ? void 0 : d.organizerContactInput) == null ? void 0 : X.errorMessage
                  ),
                  as: "div",
                  id: "location-error"
                }
              )
            ] }),
            /* @__PURE__ */ m(
              "div",
              {
                className: ae(
                  "ml-6",
                  (Z = (re = d == null ? void 0 : d.organizerContactInput) == null ? void 0 : re.publicDisplayCheckbox) == null ? void 0 : Z.container
                ),
                children: /* @__PURE__ */ m(
                  QC,
                  {
                    name: `locations[${j}].displayLocationPublicly`,
                    "data-testid": "display-location",
                    disabled: t,
                    defaultChecked: V == null ? void 0 : V.displayLocationPublicly,
                    description: _("display_location_label"),
                    className: (J = (ee = d == null ? void 0 : d.organizerContactInput) == null ? void 0 : ee.publicDisplayCheckbox) == null ? void 0 : J.checkbox,
                    onChange: (oe) => {
                      const ce = o("locations")[j];
                      h(j, {
                        ...ce,
                        displayLocationPublicly: oe.target.checked
                      });
                    },
                    informationIconText: _("display_location_info_badge")
                  }
                )
              }
            )
          ] }) : null
        ] }, z.id);
      }),
      (k.length === 0 || D) && /* @__PURE__ */ m("div", { className: "flex", children: /* @__PURE__ */ m(
        Mee,
        {
          defaultMenuIsOpen: D,
          placeholder: _("select"),
          options: b,
          value: C,
          isDisabled: t,
          defaultValue: S,
          isSearchable: !1,
          className: ae(
            "block w-full min-w-0 flex-1 rounded-sm text-sm",
            (T = d == null ? void 0 : d.locationSelect) == null ? void 0 : T.selectWrapper
          ),
          customClassNames: d == null ? void 0 : d.locationSelect,
          menuPlacement: "auto",
          onChange: (z) => {
            if (M(!1), z != null && z.value) {
              const j = z.value, q = Xs(j);
              if (!q)
                return;
              q.organizerInputType || !k.find((F) => F.type === j) ? (f({
                type: j,
                ...z.credentialId && {
                  credentialId: z.credentialId,
                  teamName: z.teamName ?? void 0
                }
              }), P(z)) : (nr(_("location_already_exists"), "warning"), P(null));
            }
          }
        }
      ) }),
      k.some(
        (z) => {
          var j;
          return z.type === oul && ((j = u.destinationCalendar) == null ? void 0 : j.integration) !== "google_calendar";
        }
      ) && /* @__PURE__ */ Y("div", { className: "text-default flex items-center text-sm", children: [
        /* @__PURE__ */ m("div", { className: "mr-1.5 h-3 w-3", children: /* @__PURE__ */ m(ot, { name: "check", className: "h-3 w-3" }) }),
        /* @__PURE__ */ m("p", { className: "text-default text-sm", children: /* @__PURE__ */ m(
          Dc,
          {
            t: _,
            i18nKey: "event_type_requires_google_calendar",
            components: [
              /* @__PURE__ */ m(
                Po,
                {
                  className: "cursor-pointer text-blue-500 underline",
                  href: "/apps/google-calendar",
                  children: "here"
                },
                "event_type_requires_google_calendar"
              )
            ]
          }
        ) })
      ] }),
      e && !I && O && /* @__PURE__ */ Y("p", { className: "pl-1 text-sm leading-none text-red-600", children: [
        _("app_not_connected", { appName: O.name }),
        " ",
        /* @__PURE__ */ m("a", { className: "underline", href: `${Si}/apps/${O.slug}`, children: _("connect_now") })
      ] }),
      k.length > 0 && !t && //  && !isChildrenManagedEventType : Add this to hide add-location button only when location is disabled by Admin
      /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(
        ut,
        {
          "data-testid": "add-location",
          StartIcon: "plus",
          color: "minimal",
          disabled: $,
          className: ae(d == null ? void 0 : d.addLocationButton),
          tooltip: $ ? _("seats_option_doesnt_support_multi_location") : void 0,
          onClick: () => M(!0),
          children: _("add_location")
        }
      ) })
    ] }),
    u.showAppStoreLink && !x && /* @__PURE__ */ m("p", { className: "text-default mt-2 text-sm", children: /* @__PURE__ */ m(
      Dc,
      {
        t: _,
        i18nKey: "cant_find_the_right_conferencing_app_visit_our_app_store",
        components: [
          /* @__PURE__ */ m(
            Po,
            {
              className: "cursor-pointer text-blue-500 underline",
              href: "/apps/categories/conferencing",
              children: "App Store"
            },
            "cant_find_the_right_conferencing_app_visit_our_app_store"
          )
        ]
      }
    ) })
  ] });
}, Zrd = Yrd, Qrd = (e) => {
  var P, x, w, E, T, z, j, q, V, F, L, U, W, H, Q, X, re, Z, ee, J, oe, ce, de, te, ue, le, se, me, pe, be, Se, Ae, Ze, Ge, rt, qe, Xe, lt, Et, wt, nn, Dt, mt, bt, gn, an, Mn, Ln, un, qo, cn, ln, kn, gt, Ot, _n, wn, so, rn;
  const { t } = Fe(), n = Zo(), o = Dn(), { eventType: r, team: i, urlPrefix: a, hasOrgBranding: s, customClassNames: c, orgId: l } = e, [d, u] = ze(
    (P = o.getValues("metadata")) == null ? void 0 : P.multipleDuration
  ), [_, p] = ze(!0), f = o.watch("seatsPerTimeSlotEnabled"), g = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    50,
    60,
    75,
    80,
    90,
    120,
    150,
    180,
    240,
    300,
    360,
    420,
    480
  ].map((Ht) => ({
    value: Ht,
    label: t("multiple_duration_mins", { count: Ht })
  })), [h, b] = ze(g.filter((Ht) => d == null ? void 0 : d.includes(Ht.value))), [v, $] = ze(
    h.find((Ht) => Ht.value === o.getValues("length")) ?? null
  ), { isChildrenManagedEventType: k, isManagedEventType: S, shouldLockIndicator: O, shouldLockDisableProps: I } = dm({ eventType: r, translate: t, formMethods: o }), D = I("length"), M = I("description"), N = I("slug"), C = I("title");
  return /* @__PURE__ */ m("div", { children: /* @__PURE__ */ Y("div", { className: ae("space-y-4", c == null ? void 0 : c.wrapper), children: [
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle space-y-6 rounded-lg border p-6",
          (x = c == null ? void 0 : c.titleSection) == null ? void 0 : x.container
        ),
        children: [
          /* @__PURE__ */ m(
            Io,
            {
              required: !0,
              containerClassName: ae((E = (w = c == null ? void 0 : c.titleSection) == null ? void 0 : w.titleInput) == null ? void 0 : E.container),
              labelClassName: ae((z = (T = c == null ? void 0 : c.titleSection) == null ? void 0 : T.titleInput) == null ? void 0 : z.label),
              className: ae((q = (j = c == null ? void 0 : c.titleSection) == null ? void 0 : j.titleInput) == null ? void 0 : q.input),
              label: t("title"),
              ...S || k ? C : {},
              defaultValue: r.title,
              "data-testid": "event-title",
              ...o.register("title")
            }
          ),
          /* @__PURE__ */ m("div", { children: n ? /* @__PURE__ */ m(
            B_e,
            {
              ...o.register("description", {
                disabled: M.disabled
              }),
              placeholder: t("quick_video_meeting"),
              className: (F = (V = c == null ? void 0 : c.titleSection) == null ? void 0 : V.descriptionInput) == null ? void 0 : F.input,
              labelProps: {
                className: (U = (L = c == null ? void 0 : c.titleSection) == null ? void 0 : L.descriptionInput) == null ? void 0 : U.label
              }
            }
          ) : /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ Y(Xn, { htmlFor: "editor", children: [
              t("description"),
              (S || k) && O("description")
            ] }),
            /* @__PURE__ */ m(
              H8,
              {
                getText: () => TC.render(o.getValues("description") || ""),
                setText: (Ht) => o.setValue("description", r8(Ht), { shouldDirty: !0 }),
                excludedToolbarItems: ["blockType"],
                placeholder: t("quick_video_meeting"),
                editable: !M.disabled,
                firstRender: _,
                setFirstRender: p
              }
            )
          ] }) }),
          /* @__PURE__ */ m(
            Io,
            {
              required: !0,
              label: n ? "Slug" : t("URL"),
              ...S || k ? N : {},
              defaultValue: r.slug,
              "data-testid": "event-slug",
              containerClassName: ae(
                "[&>div]:gap-0",
                (H = (W = c == null ? void 0 : c.titleSection) == null ? void 0 : W.urlInput) == null ? void 0 : H.container
              ),
              labelClassName: ae((X = (Q = c == null ? void 0 : c.titleSection) == null ? void 0 : Q.urlInput) == null ? void 0 : X.label),
              className: ae("pl-0", (Z = (re = c == null ? void 0 : c.titleSection) == null ? void 0 : re.urlInput) == null ? void 0 : Z.input),
              addOnLeading: n ? void 0 : /* @__PURE__ */ Y(Ce, { children: [
                a,
                "/",
                S ? t("username_placeholder") : i ? (s ? "" : "team/") + i.slug : o.getValues("users")[0].username,
                "/"
              ] }),
              ...o.register("slug", {
                setValueAs: (Ht) => g9(Ht)
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle rounded-lg border p-6",
          (ee = c == null ? void 0 : c.durationSection) == null ? void 0 : ee.container
        ),
        children: [
          d ? /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "space-y-6",
                (ce = (oe = (J = c == null ? void 0 : c.durationSection) == null ? void 0 : J.multipleDuration) == null ? void 0 : oe.availableDurationsSelect) == null ? void 0 : ce.container
              ),
              children: [
                /* @__PURE__ */ Y("div", { children: [
                  /* @__PURE__ */ m(
                    Ks,
                    {
                      as: Xn,
                      loadingClassName: "w-16",
                      className: (ue = (te = (de = c == null ? void 0 : c.durationSection) == null ? void 0 : de.multipleDuration) == null ? void 0 : te.availableDurationsSelect) == null ? void 0 : ue.label,
                      children: t("available_durations")
                    }
                  ),
                  /* @__PURE__ */ m(
                    Tr,
                    {
                      isMulti: !0,
                      defaultValue: h,
                      name: "metadata.multipleDuration",
                      isSearchable: !1,
                      isDisabled: D.disabled,
                      className: ae(
                        "h-auto !min-h-[36px] text-sm",
                        (me = (se = (le = c == null ? void 0 : c.durationSection) == null ? void 0 : le.multipleDuration) == null ? void 0 : se.availableDurationsSelect) == null ? void 0 : me.select
                      ),
                      innerClassNames: (Se = (be = (pe = c == null ? void 0 : c.durationSection) == null ? void 0 : pe.multipleDuration) == null ? void 0 : be.availableDurationsSelect) == null ? void 0 : Se.innerClassNames,
                      options: g,
                      value: h,
                      onChange: (Ht) => {
                        let qn = [...Ht];
                        qn = qn.sort((Or, oo) => (Or == null ? void 0 : Or.value) - (oo == null ? void 0 : oo.value));
                        const Bn = qn.map((Or) => Or.value);
                        u(Bn), b(qn), qn.find((Or) => Or.value === (v == null ? void 0 : v.value)) || (qn.length > 0 ? ($(qn[0]), o.setValue("length", qn[0].value, { shouldDirty: !0 })) : $(null)), qn.length === 1 && v === null && ($(qn[0]), o.setValue("length", qn[0].value, { shouldDirty: !0 })), o.setValue("metadata.multipleDuration", Bn, { shouldDirty: !0 });
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ Y(
                  "div",
                  {
                    className: (Ge = (Ze = (Ae = c == null ? void 0 : c.durationSection) == null ? void 0 : Ae.multipleDuration) == null ? void 0 : Ze.defaultDurationSelect) == null ? void 0 : Ge.container,
                    children: [
                      /* @__PURE__ */ Y(
                        Ks,
                        {
                          as: Xn,
                          loadingClassName: "w-16",
                          className: (Xe = (qe = (rt = c == null ? void 0 : c.durationSection) == null ? void 0 : rt.multipleDuration) == null ? void 0 : qe.defaultDurationSelect) == null ? void 0 : Xe.label,
                          children: [
                            t("default_duration"),
                            O("length")
                          ]
                        }
                      ),
                      /* @__PURE__ */ m(
                        Tr,
                        {
                          value: v,
                          isSearchable: !1,
                          name: "length",
                          className: ae(
                            "text-sm",
                            (wt = (Et = (lt = c == null ? void 0 : c.durationSection) == null ? void 0 : lt.multipleDuration) == null ? void 0 : Et.defaultDurationSelect) == null ? void 0 : wt.select
                          ),
                          innerClassNames: (mt = (Dt = (nn = c == null ? void 0 : c.durationSection) == null ? void 0 : nn.multipleDuration) == null ? void 0 : Dt.defaultDurationSelect) == null ? void 0 : mt.innerClassNames,
                          isDisabled: D.disabled,
                          noOptionsMessage: () => t("default_duration_no_options"),
                          options: h,
                          onChange: (Ht) => {
                            $(
                              h.find((qn) => qn.value === (Ht == null ? void 0 : Ht.value)) ?? null
                            ), Ht && o.setValue("length", Ht.value, { shouldDirty: !0 });
                          }
                        }
                      )
                    ]
                  }
                )
              ]
            }
          ) : /* @__PURE__ */ m(
            Io,
            {
              required: !0,
              type: "number",
              containerClassName: ae(
                (gn = (bt = c == null ? void 0 : c.durationSection) == null ? void 0 : bt.singleDurationInput) == null ? void 0 : gn.container
              ),
              labelClassName: ae((Mn = (an = c == null ? void 0 : c.durationSection) == null ? void 0 : an.singleDurationInput) == null ? void 0 : Mn.label),
              className: ae((un = (Ln = c == null ? void 0 : c.durationSection) == null ? void 0 : Ln.singleDurationInput) == null ? void 0 : un.input),
              "data-testid": "duration",
              ...S || k ? D : {},
              label: t("duration"),
              defaultValue: o.getValues("length") ?? 15,
              ...o.register("length", {
                valueAsNumber: !0,
                min: {
                  value: Mh,
                  message: t("duration_min_error", { min: Mh })
                },
                max: {
                  value: Dh,
                  message: t("duration_max_error", { max: Dh })
                }
              }),
              addOnSuffix: /* @__PURE__ */ m(Ce, { children: t("minutes") }),
              min: Mh,
              max: Dh
            }
          ),
          !D.disabled && /* @__PURE__ */ m("div", { className: "!mt-4 [&_label]:my-1 [&_label]:font-normal", children: /* @__PURE__ */ m(
            eo,
            {
              title: t("allow_multiple_durations"),
              checked: d !== void 0,
              disabled: f,
              tooltip: f ? t("seat_options_doesnt_multiple_durations") : void 0,
              labelClassName: (cn = (qo = c == null ? void 0 : c.durationSection) == null ? void 0 : qo.selectDurationToggle) == null ? void 0 : cn.label,
              descriptionClassName: (kn = (ln = c == null ? void 0 : c.durationSection) == null ? void 0 : ln.selectDurationToggle) == null ? void 0 : kn.description,
              switchContainerClassName: (Ot = (gt = c == null ? void 0 : c.durationSection) == null ? void 0 : gt.selectDurationToggle) == null ? void 0 : Ot.container,
              childrenClassName: (wn = (_n = c == null ? void 0 : c.durationSection) == null ? void 0 : _n.selectDurationToggle) == null ? void 0 : wn.children,
              onCheckedChange: () => {
                d !== void 0 ? (u(void 0), b([]), $(null), o.setValue("metadata.multipleDuration", void 0, { shouldDirty: !0 }), o.setValue("length", r.length, { shouldDirty: !0 })) : (u([]), o.setValue("metadata.multipleDuration", [], { shouldDirty: !0 }), o.setValue("length", 0, { shouldDirty: !0 }));
              }
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "border-subtle rounded-lg border p-6",
          (so = c == null ? void 0 : c.locationSection) == null ? void 0 : so.container
        ),
        children: /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ Y(
            Ks,
            {
              as: Xn,
              loadingClassName: "w-16",
              htmlFor: "locations",
              className: (rn = c == null ? void 0 : c.locationSection) == null ? void 0 : rn.label,
              children: [
                t("location"),
                O("locations")
              ]
            }
          ),
          /* @__PURE__ */ m(
            Wt,
            {
              name: "locations",
              control: o.control,
              defaultValue: r.locations || [],
              render: () => /* @__PURE__ */ m(
                Zrd,
                {
                  showAppStoreLink: !0,
                  isChildrenManagedEventType: k,
                  isManagedEventType: S,
                  disableLocationProp: I("locations").disabled,
                  getValues: o.getValues,
                  setValue: o.setValue,
                  control: o.control,
                  formState: o.formState,
                  ...e,
                  customClassNames: c == null ? void 0 : c.locationSection
                }
              )
            }
          )
        ] })
      }
    )
  ] }) });
}, Jrd = (e) => /* @__PURE__ */ m(Qrd, { ...e, urlPrefix: "", hasOrgBranding: !1 }), Xrd = Jrd, eid = ({ ...e }) => /* @__PURE__ */ m(_1e, { ...e }), tid = ({ ...e }) => (bo.useUtils().viewer.appRoutingForms.getAttributesForTeam.prefetch({
  teamId: e.teamId
}), /* @__PURE__ */ m(_1e, { ...e }));
var Wp = {}, Z5 = {}, y0e = { exports: {} }, nid = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", oid = nid, rid = oid;
function $0e() {
}
function w0e() {
}
w0e.resetWarningCache = $0e;
var iid = function() {
  function e(o, r, i, a, s, c) {
    if (c !== rid) {
      var l = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw l.name = "Invariant Violation", l;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: w0e,
    resetWarningCache: $0e
  };
  return n.PropTypes = n, n;
};
y0e.exports = iid();
var di = y0e.exports;
const xfd = /* @__PURE__ */ Zr(di);
var Q5 = {}, J5 = { exports: {} }, Lee;
function Ra() {
  return Lee || (Lee = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(Je, function() {
      var n = Array.prototype.slice;
      function o(R, K) {
        K && (R.prototype = Object.create(K.prototype)), R.prototype.constructor = R;
      }
      function r(R) {
        return c(R) ? R : ce(R);
      }
      o(i, r);
      function i(R) {
        return l(R) ? R : de(R);
      }
      o(a, r);
      function a(R) {
        return d(R) ? R : te(R);
      }
      o(s, r);
      function s(R) {
        return c(R) && !u(R) ? R : ue(R);
      }
      function c(R) {
        return !!(R && R[p]);
      }
      function l(R) {
        return !!(R && R[f]);
      }
      function d(R) {
        return !!(R && R[g]);
      }
      function u(R) {
        return l(R) || d(R);
      }
      function _(R) {
        return !!(R && R[h]);
      }
      r.isIterable = c, r.isKeyed = l, r.isIndexed = d, r.isAssociative = u, r.isOrdered = _, r.Keyed = i, r.Indexed = a, r.Set = s;
      var p = "@@__IMMUTABLE_ITERABLE__@@", f = "@@__IMMUTABLE_KEYED__@@", g = "@@__IMMUTABLE_INDEXED__@@", h = "@@__IMMUTABLE_ORDERED__@@", b = "delete", v = 5, $ = 1 << v, k = $ - 1, S = {}, O = { value: !1 }, I = { value: !1 };
      function D(R) {
        return R.value = !1, R;
      }
      function M(R) {
        R && (R.value = !0);
      }
      function N() {
      }
      function C(R, K) {
        K = K || 0;
        for (var ie = Math.max(0, R.length - K), _e = new Array(ie), ge = 0; ge < ie; ge++)
          _e[ge] = R[ge + K];
        return _e;
      }
      function P(R) {
        return R.size === void 0 && (R.size = R.__iterate(w)), R.size;
      }
      function x(R, K) {
        if (typeof K != "number") {
          var ie = K >>> 0;
          if ("" + ie !== K || ie === 4294967295)
            return NaN;
          K = ie;
        }
        return K < 0 ? P(R) + K : K;
      }
      function w() {
        return !0;
      }
      function E(R, K, ie) {
        return (R === 0 || ie !== void 0 && R <= -ie) && (K === void 0 || ie !== void 0 && K >= ie);
      }
      function T(R, K) {
        return j(R, K, 0);
      }
      function z(R, K) {
        return j(R, K, K);
      }
      function j(R, K, ie) {
        return R === void 0 ? ie : R < 0 ? Math.max(0, K + R) : K === void 0 ? R : Math.min(K, R);
      }
      var q = 0, V = 1, F = 2, L = typeof Symbol == "function" && Symbol.iterator, U = "@@iterator", W = L || U;
      function H(R) {
        this.next = R;
      }
      H.prototype.toString = function() {
        return "[Iterator]";
      }, H.KEYS = q, H.VALUES = V, H.ENTRIES = F, H.prototype.inspect = H.prototype.toSource = function() {
        return this.toString();
      }, H.prototype[W] = function() {
        return this;
      };
      function Q(R, K, ie, _e) {
        var ge = R === 0 ? K : R === 1 ? ie : [K, ie];
        return _e ? _e.value = ge : _e = {
          value: ge,
          done: !1
        }, _e;
      }
      function X() {
        return { value: void 0, done: !0 };
      }
      function re(R) {
        return !!J(R);
      }
      function Z(R) {
        return R && typeof R.next == "function";
      }
      function ee(R) {
        var K = J(R);
        return K && K.call(R);
      }
      function J(R) {
        var K = R && (L && R[L] || R[U]);
        if (typeof K == "function")
          return K;
      }
      function oe(R) {
        return R && typeof R.length == "number";
      }
      o(ce, r);
      function ce(R) {
        return R == null ? Ze() : c(R) ? R.toSeq() : qe(R);
      }
      ce.of = function() {
        return ce(arguments);
      }, ce.prototype.toSeq = function() {
        return this;
      }, ce.prototype.toString = function() {
        return this.__toString("Seq {", "}");
      }, ce.prototype.cacheResult = function() {
        return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
      }, ce.prototype.__iterate = function(R, K) {
        return lt(this, R, K, !0);
      }, ce.prototype.__iterator = function(R, K) {
        return Et(this, R, K, !0);
      }, o(de, ce);
      function de(R) {
        return R == null ? Ze().toKeyedSeq() : c(R) ? l(R) ? R.toSeq() : R.fromEntrySeq() : Ge(R);
      }
      de.prototype.toKeyedSeq = function() {
        return this;
      }, o(te, ce);
      function te(R) {
        return R == null ? Ze() : c(R) ? l(R) ? R.entrySeq() : R.toIndexedSeq() : rt(R);
      }
      te.of = function() {
        return te(arguments);
      }, te.prototype.toIndexedSeq = function() {
        return this;
      }, te.prototype.toString = function() {
        return this.__toString("Seq [", "]");
      }, te.prototype.__iterate = function(R, K) {
        return lt(this, R, K, !1);
      }, te.prototype.__iterator = function(R, K) {
        return Et(this, R, K, !1);
      }, o(ue, ce);
      function ue(R) {
        return (R == null ? Ze() : c(R) ? l(R) ? R.entrySeq() : R : rt(R)).toSetSeq();
      }
      ue.of = function() {
        return ue(arguments);
      }, ue.prototype.toSetSeq = function() {
        return this;
      }, ce.isSeq = Se, ce.Keyed = de, ce.Set = ue, ce.Indexed = te;
      var le = "@@__IMMUTABLE_SEQ__@@";
      ce.prototype[le] = !0, o(se, te);
      function se(R) {
        this._array = R, this.size = R.length;
      }
      se.prototype.get = function(R, K) {
        return this.has(R) ? this._array[x(this, R)] : K;
      }, se.prototype.__iterate = function(R, K) {
        for (var ie = this._array, _e = ie.length - 1, ge = 0; ge <= _e; ge++)
          if (R(ie[K ? _e - ge : ge], ge, this) === !1)
            return ge + 1;
        return ge;
      }, se.prototype.__iterator = function(R, K) {
        var ie = this._array, _e = ie.length - 1, ge = 0;
        return new H(
          function() {
            return ge > _e ? X() : Q(R, ge, ie[K ? _e - ge++ : ge++]);
          }
        );
      }, o(me, de);
      function me(R) {
        var K = Object.keys(R);
        this._object = R, this._keys = K, this.size = K.length;
      }
      me.prototype.get = function(R, K) {
        return K !== void 0 && !this.has(R) ? K : this._object[R];
      }, me.prototype.has = function(R) {
        return this._object.hasOwnProperty(R);
      }, me.prototype.__iterate = function(R, K) {
        for (var ie = this._object, _e = this._keys, ge = _e.length - 1, ke = 0; ke <= ge; ke++) {
          var Te = _e[K ? ge - ke : ke];
          if (R(ie[Te], Te, this) === !1)
            return ke + 1;
        }
        return ke;
      }, me.prototype.__iterator = function(R, K) {
        var ie = this._object, _e = this._keys, ge = _e.length - 1, ke = 0;
        return new H(function() {
          var Te = _e[K ? ge - ke : ke];
          return ke++ > ge ? X() : Q(R, Te, ie[Te]);
        });
      }, me.prototype[h] = !0, o(pe, te);
      function pe(R) {
        this._iterable = R, this.size = R.length || R.size;
      }
      pe.prototype.__iterateUncached = function(R, K) {
        if (K)
          return this.cacheResult().__iterate(R, K);
        var ie = this._iterable, _e = ee(ie), ge = 0;
        if (Z(_e))
          for (var ke; !(ke = _e.next()).done && R(ke.value, ge++, this) !== !1; )
            ;
        return ge;
      }, pe.prototype.__iteratorUncached = function(R, K) {
        if (K)
          return this.cacheResult().__iterator(R, K);
        var ie = this._iterable, _e = ee(ie);
        if (!Z(_e))
          return new H(X);
        var ge = 0;
        return new H(function() {
          var ke = _e.next();
          return ke.done ? ke : Q(R, ge++, ke.value);
        });
      }, o(be, te);
      function be(R) {
        this._iterator = R, this._iteratorCache = [];
      }
      be.prototype.__iterateUncached = function(R, K) {
        if (K)
          return this.cacheResult().__iterate(R, K);
        for (var ie = this._iterator, _e = this._iteratorCache, ge = 0; ge < _e.length; )
          if (R(_e[ge], ge++, this) === !1)
            return ge;
        for (var ke; !(ke = ie.next()).done; ) {
          var Te = ke.value;
          if (_e[ge] = Te, R(Te, ge++, this) === !1)
            break;
        }
        return ge;
      }, be.prototype.__iteratorUncached = function(R, K) {
        if (K)
          return this.cacheResult().__iterator(R, K);
        var ie = this._iterator, _e = this._iteratorCache, ge = 0;
        return new H(function() {
          if (ge >= _e.length) {
            var ke = ie.next();
            if (ke.done)
              return ke;
            _e[ge] = ke.value;
          }
          return Q(R, ge, _e[ge++]);
        });
      };
      function Se(R) {
        return !!(R && R[le]);
      }
      var Ae;
      function Ze() {
        return Ae || (Ae = new se([]));
      }
      function Ge(R) {
        var K = Array.isArray(R) ? new se(R).fromEntrySeq() : Z(R) ? new be(R).fromEntrySeq() : re(R) ? new pe(R).fromEntrySeq() : typeof R == "object" ? new me(R) : void 0;
        if (!K)
          throw new TypeError(
            "Expected Array or iterable object of [k, v] entries, or keyed object: " + R
          );
        return K;
      }
      function rt(R) {
        var K = Xe(R);
        if (!K)
          throw new TypeError(
            "Expected Array or iterable object of values: " + R
          );
        return K;
      }
      function qe(R) {
        var K = Xe(R) || typeof R == "object" && new me(R);
        if (!K)
          throw new TypeError(
            "Expected Array or iterable object of values, or keyed object: " + R
          );
        return K;
      }
      function Xe(R) {
        return oe(R) ? new se(R) : Z(R) ? new be(R) : re(R) ? new pe(R) : void 0;
      }
      function lt(R, K, ie, _e) {
        var ge = R._cache;
        if (ge) {
          for (var ke = ge.length - 1, Te = 0; Te <= ke; Te++) {
            var Ve = ge[ie ? ke - Te : Te];
            if (K(Ve[1], _e ? Ve[0] : Te, R) === !1)
              return Te + 1;
          }
          return Te;
        }
        return R.__iterateUncached(K, ie);
      }
      function Et(R, K, ie, _e) {
        var ge = R._cache;
        if (ge) {
          var ke = ge.length - 1, Te = 0;
          return new H(function() {
            var Ve = ge[ie ? ke - Te : Te];
            return Te++ > ke ? X() : Q(K, _e ? Ve[0] : Te - 1, Ve[1]);
          });
        }
        return R.__iteratorUncached(K, ie);
      }
      function wt(R, K) {
        return K ? nn(K, R, "", { "": R }) : Dt(R);
      }
      function nn(R, K, ie, _e) {
        return Array.isArray(K) ? R.call(_e, ie, te(K).map(function(ge, ke) {
          return nn(R, ge, ke, K);
        })) : mt(K) ? R.call(_e, ie, de(K).map(function(ge, ke) {
          return nn(R, ge, ke, K);
        })) : K;
      }
      function Dt(R) {
        return Array.isArray(R) ? te(R).map(Dt).toList() : mt(R) ? de(R).map(Dt).toMap() : R;
      }
      function mt(R) {
        return R && (R.constructor === Object || R.constructor === void 0);
      }
      function bt(R, K) {
        if (R === K || R !== R && K !== K)
          return !0;
        if (!R || !K)
          return !1;
        if (typeof R.valueOf == "function" && typeof K.valueOf == "function") {
          if (R = R.valueOf(), K = K.valueOf(), R === K || R !== R && K !== K)
            return !0;
          if (!R || !K)
            return !1;
        }
        return !!(typeof R.equals == "function" && typeof K.equals == "function" && R.equals(K));
      }
      function gn(R, K) {
        if (R === K)
          return !0;
        if (!c(K) || R.size !== void 0 && K.size !== void 0 && R.size !== K.size || R.__hash !== void 0 && K.__hash !== void 0 && R.__hash !== K.__hash || l(R) !== l(K) || d(R) !== d(K) || _(R) !== _(K))
          return !1;
        if (R.size === 0 && K.size === 0)
          return !0;
        var ie = !u(R);
        if (_(R)) {
          var _e = R.entries();
          return K.every(function(et, nt) {
            var we = _e.next().value;
            return we && bt(we[1], et) && (ie || bt(we[0], nt));
          }) && _e.next().done;
        }
        var ge = !1;
        if (R.size === void 0)
          if (K.size === void 0)
            typeof R.cacheResult == "function" && R.cacheResult();
          else {
            ge = !0;
            var ke = R;
            R = K, K = ke;
          }
        var Te = !0, Ve = K.__iterate(function(et, nt) {
          if (ie ? !R.has(et) : ge ? !bt(et, R.get(nt, S)) : !bt(R.get(nt, S), et))
            return Te = !1, !1;
        });
        return Te && R.size === Ve;
      }
      o(an, te);
      function an(R, K) {
        if (!(this instanceof an))
          return new an(R, K);
        if (this._value = R, this.size = K === void 0 ? 1 / 0 : Math.max(0, K), this.size === 0) {
          if (Mn)
            return Mn;
          Mn = this;
        }
      }
      an.prototype.toString = function() {
        return this.size === 0 ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
      }, an.prototype.get = function(R, K) {
        return this.has(R) ? this._value : K;
      }, an.prototype.includes = function(R) {
        return bt(this._value, R);
      }, an.prototype.slice = function(R, K) {
        var ie = this.size;
        return E(R, K, ie) ? this : new an(this._value, z(K, ie) - T(R, ie));
      }, an.prototype.reverse = function() {
        return this;
      }, an.prototype.indexOf = function(R) {
        return bt(this._value, R) ? 0 : -1;
      }, an.prototype.lastIndexOf = function(R) {
        return bt(this._value, R) ? this.size : -1;
      }, an.prototype.__iterate = function(R, K) {
        for (var ie = 0; ie < this.size; ie++)
          if (R(this._value, ie, this) === !1)
            return ie + 1;
        return ie;
      }, an.prototype.__iterator = function(R, K) {
        var ie = this, _e = 0;
        return new H(
          function() {
            return _e < ie.size ? Q(R, _e++, ie._value) : X();
          }
        );
      }, an.prototype.equals = function(R) {
        return R instanceof an ? bt(this._value, R._value) : gn(R);
      };
      var Mn;
      function Ln(R, K) {
        if (!R)
          throw new Error(K);
      }
      o(un, te);
      function un(R, K, ie) {
        if (!(this instanceof un))
          return new un(R, K, ie);
        if (Ln(ie !== 0, "Cannot step a Range by 0"), R = R || 0, K === void 0 && (K = 1 / 0), ie = ie === void 0 ? 1 : Math.abs(ie), K < R && (ie = -ie), this._start = R, this._end = K, this._step = ie, this.size = Math.max(0, Math.ceil((K - R) / ie - 1) + 1), this.size === 0) {
          if (qo)
            return qo;
          qo = this;
        }
      }
      un.prototype.toString = function() {
        return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
      }, un.prototype.get = function(R, K) {
        return this.has(R) ? this._start + x(this, R) * this._step : K;
      }, un.prototype.includes = function(R) {
        var K = (R - this._start) / this._step;
        return K >= 0 && K < this.size && K === Math.floor(K);
      }, un.prototype.slice = function(R, K) {
        return E(R, K, this.size) ? this : (R = T(R, this.size), K = z(K, this.size), K <= R ? new un(0, 0) : new un(this.get(R, this._end), this.get(K, this._end), this._step));
      }, un.prototype.indexOf = function(R) {
        var K = R - this._start;
        if (K % this._step === 0) {
          var ie = K / this._step;
          if (ie >= 0 && ie < this.size)
            return ie;
        }
        return -1;
      }, un.prototype.lastIndexOf = function(R) {
        return this.indexOf(R);
      }, un.prototype.__iterate = function(R, K) {
        for (var ie = this.size - 1, _e = this._step, ge = K ? this._start + ie * _e : this._start, ke = 0; ke <= ie; ke++) {
          if (R(ge, ke, this) === !1)
            return ke + 1;
          ge += K ? -_e : _e;
        }
        return ke;
      }, un.prototype.__iterator = function(R, K) {
        var ie = this.size - 1, _e = this._step, ge = K ? this._start + ie * _e : this._start, ke = 0;
        return new H(function() {
          var Te = ge;
          return ge += K ? -_e : _e, ke > ie ? X() : Q(R, ke++, Te);
        });
      }, un.prototype.equals = function(R) {
        return R instanceof un ? this._start === R._start && this._end === R._end && this._step === R._step : gn(this, R);
      };
      var qo;
      o(cn, r);
      function cn() {
        throw TypeError("Abstract");
      }
      o(ln, cn);
      function ln() {
      }
      o(kn, cn);
      function kn() {
      }
      o(gt, cn);
      function gt() {
      }
      cn.Keyed = ln, cn.Indexed = kn, cn.Set = gt;
      var Ot = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(K, ie) {
        K = K | 0, ie = ie | 0;
        var _e = K & 65535, ge = ie & 65535;
        return _e * ge + ((K >>> 16) * ge + _e * (ie >>> 16) << 16 >>> 0) | 0;
      };
      function _n(R) {
        return R >>> 1 & 1073741824 | R & 3221225471;
      }
      function wn(R) {
        if (R === !1 || R === null || R === void 0 || typeof R.valueOf == "function" && (R = R.valueOf(), R === !1 || R === null || R === void 0))
          return 0;
        if (R === !0)
          return 1;
        var K = typeof R;
        if (K === "number") {
          if (R !== R || R === 1 / 0)
            return 0;
          var ie = R | 0;
          for (ie !== R && (ie ^= R * 4294967295); R > 4294967295; )
            R /= 4294967295, ie ^= R;
          return _n(ie);
        }
        if (K === "string")
          return R.length > yt ? so(R) : rn(R);
        if (typeof R.hashCode == "function")
          return R.hashCode();
        if (K === "object")
          return Ht(R);
        if (typeof R.toString == "function")
          return rn(R.toString());
        throw new Error("Value type " + K + " cannot be hashed.");
      }
      function so(R) {
        var K = Nt[R];
        return K === void 0 && (K = rn(R), Ut === on && (Ut = 0, Nt = {}), Ut++, Nt[R] = K), K;
      }
      function rn(R) {
        for (var K = 0, ie = 0; ie < R.length; ie++)
          K = 31 * K + R.charCodeAt(ie) | 0;
        return _n(K);
      }
      function Ht(R) {
        var K;
        if (oo && (K = Zn.get(R), K !== void 0) || (K = R[ft], K !== void 0) || !Bn && (K = R.propertyIsEnumerable && R.propertyIsEnumerable[ft], K !== void 0 || (K = Or(R), K !== void 0)))
          return K;
        if (K = ++st, st & 1073741824 && (st = 0), oo)
          Zn.set(R, K);
        else {
          if (qn !== void 0 && qn(R) === !1)
            throw new Error("Non-extensible objects are not allowed as keys.");
          if (Bn)
            Object.defineProperty(R, ft, {
              enumerable: !1,
              configurable: !1,
              writable: !1,
              value: K
            });
          else if (R.propertyIsEnumerable !== void 0 && R.propertyIsEnumerable === R.constructor.prototype.propertyIsEnumerable)
            R.propertyIsEnumerable = function() {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            }, R.propertyIsEnumerable[ft] = K;
          else if (R.nodeType !== void 0)
            R[ft] = K;
          else
            throw new Error("Unable to set a non-enumerable property on object.");
        }
        return K;
      }
      var qn = Object.isExtensible, Bn = function() {
        try {
          return Object.defineProperty({}, "@", {}), !0;
        } catch {
          return !1;
        }
      }();
      function Or(R) {
        if (R && R.nodeType > 0)
          switch (R.nodeType) {
            case 1:
              return R.uniqueID;
            case 9:
              return R.documentElement && R.documentElement.uniqueID;
          }
      }
      var oo = typeof WeakMap == "function", Zn;
      oo && (Zn = /* @__PURE__ */ new WeakMap());
      var st = 0, ft = "__immutablehash__";
      typeof Symbol == "function" && (ft = Symbol(ft));
      var yt = 16, on = 255, Ut = 0, Nt = {};
      function Kt(R) {
        Ln(
          R !== 1 / 0,
          "Cannot perform this action with an infinite size."
        );
      }
      o(At, ln);
      function At(R) {
        return R == null ? zo() : Mt(R) && !_(R) ? R : zo().withMutations(function(K) {
          var ie = i(R);
          Kt(ie.size), ie.forEach(function(_e, ge) {
            return K.set(ge, _e);
          });
        });
      }
      At.of = function() {
        var R = n.call(arguments, 0);
        return zo().withMutations(function(K) {
          for (var ie = 0; ie < R.length; ie += 2) {
            if (ie + 1 >= R.length)
              throw new Error("Missing value for key: " + R[ie]);
            K.set(R[ie], R[ie + 1]);
          }
        });
      }, At.prototype.toString = function() {
        return this.__toString("Map {", "}");
      }, At.prototype.get = function(R, K) {
        return this._root ? this._root.get(0, void 0, R, K) : K;
      }, At.prototype.set = function(R, K) {
        return Di(this, R, K);
      }, At.prototype.setIn = function(R, K) {
        return this.updateIn(R, S, function() {
          return K;
        });
      }, At.prototype.remove = function(R) {
        return Di(this, R, S);
      }, At.prototype.deleteIn = function(R) {
        return this.updateIn(R, function() {
          return S;
        });
      }, At.prototype.update = function(R, K, ie) {
        return arguments.length === 1 ? R(this) : this.updateIn([R], K, ie);
      }, At.prototype.updateIn = function(R, K, ie) {
        ie || (ie = K, K = void 0);
        var _e = Wk(
          this,
          zg(R),
          K,
          ie
        );
        return _e === S ? void 0 : _e;
      }, At.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : zo();
      }, At.prototype.merge = function() {
        return xg(this, void 0, arguments);
      }, At.prototype.mergeWith = function(R) {
        var K = n.call(arguments, 1);
        return xg(this, R, K);
      }, At.prototype.mergeIn = function(R) {
        var K = n.call(arguments, 1);
        return this.updateIn(
          R,
          zo(),
          function(ie) {
            return typeof ie.merge == "function" ? ie.merge.apply(ie, K) : K[K.length - 1];
          }
        );
      }, At.prototype.mergeDeep = function() {
        return xg(this, Mb, arguments);
      }, At.prototype.mergeDeepWith = function(R) {
        var K = n.call(arguments, 1);
        return xg(this, pm(R), K);
      }, At.prototype.mergeDeepIn = function(R) {
        var K = n.call(arguments, 1);
        return this.updateIn(
          R,
          zo(),
          function(ie) {
            return typeof ie.mergeDeep == "function" ? ie.mergeDeep.apply(ie, K) : K[K.length - 1];
          }
        );
      }, At.prototype.sort = function(R) {
        return oi(Au(this, R));
      }, At.prototype.sortBy = function(R, K) {
        return oi(Au(this, K, R));
      }, At.prototype.withMutations = function(R) {
        var K = this.asMutable();
        return R(K), K.wasAltered() ? K.__ensureOwner(this.__ownerID) : this;
      }, At.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new N());
      }, At.prototype.asImmutable = function() {
        return this.__ensureOwner();
      }, At.prototype.wasAltered = function() {
        return this.__altered;
      }, At.prototype.__iterator = function(R, K) {
        return new pt(this, R, K);
      }, At.prototype.__iterate = function(R, K) {
        var ie = this, _e = 0;
        return this._root && this._root.iterate(function(ge) {
          return _e++, R(ge[1], ge[0], ie);
        }, K), _e;
      }, At.prototype.__ensureOwner = function(R) {
        return R === this.__ownerID ? this : R ? mn(this.size, this._root, R, this.__hash) : (this.__ownerID = R, this.__altered = !1, this);
      };
      function Mt(R) {
        return !!(R && R[Ie]);
      }
      At.isMap = Mt;
      var Ie = "@@__IMMUTABLE_MAP__@@", tt = At.prototype;
      tt[Ie] = !0, tt[b] = tt.remove, tt.removeIn = tt.deleteIn;
      function zt(R, K) {
        this.ownerID = R, this.entries = K;
      }
      zt.prototype.get = function(R, K, ie, _e) {
        for (var ge = this.entries, ke = 0, Te = ge.length; ke < Te; ke++)
          if (bt(ie, ge[ke][0]))
            return ge[ke][1];
        return _e;
      }, zt.prototype.update = function(R, K, ie, _e, ge, ke, Te) {
        for (var Ve = ge === S, et = this.entries, nt = 0, we = et.length; nt < we && !bt(_e, et[nt][0]); nt++)
          ;
        var Me = nt < we;
        if (Me ? et[nt][1] === ge : Ve)
          return this;
        if (M(Te), (Ve || !Me) && M(ke), !(Ve && et.length === 1)) {
          if (!Me && !Ve && et.length >= Gk)
            return Bk(R, et, _e, ge);
          var Ne = R && R === this.ownerID, _t = Ne ? et : C(et);
          return Me ? Ve ? nt === we - 1 ? _t.pop() : _t[nt] = _t.pop() : _t[nt] = [_e, ge] : _t.push([_e, ge]), Ne ? (this.entries = _t, this) : new zt(R, _t);
        }
      };
      function $t(R, K, ie) {
        this.ownerID = R, this.bitmap = K, this.nodes = ie;
      }
      $t.prototype.get = function(R, K, ie, _e) {
        K === void 0 && (K = wn(ie));
        var ge = 1 << ((R === 0 ? K : K >>> R) & k), ke = this.bitmap;
        return ke & ge ? this.nodes[qb(ke & ge - 1)].get(R + v, K, ie, _e) : _e;
      }, $t.prototype.update = function(R, K, ie, _e, ge, ke, Te) {
        ie === void 0 && (ie = wn(_e));
        var Ve = (K === 0 ? ie : ie >>> K) & k, et = 1 << Ve, nt = this.bitmap, we = (nt & et) !== 0;
        if (!we && ge === S)
          return this;
        var Me = qb(nt & et - 1), Ne = this.nodes, _t = we ? Ne[Me] : void 0, Pt = Ti(_t, R, K + v, ie, _e, ge, ke, Te);
        if (Pt === _t)
          return this;
        if (!we && Pt && Ne.length >= Vb)
          return Db(R, Ne, nt, Ve, Pt);
        if (we && !Pt && Ne.length === 2 && Ds(Ne[Me ^ 1]))
          return Ne[Me ^ 1];
        if (we && Pt && Ne.length === 1 && Ds(Pt))
          return Pt;
        var fn = R && R === this.ownerID, Jo = we ? Pt ? nt : nt ^ et : nt | et, $o = we ? Pt ? jb(Ne, Me, Pt, fn) : $z(Ne, Me, fn) : Fb(Ne, Me, Pt, fn);
        return fn ? (this.bitmap = Jo, this.nodes = $o, this) : new $t(R, Jo, $o);
      };
      function In(R, K, ie) {
        this.ownerID = R, this.count = K, this.nodes = ie;
      }
      In.prototype.get = function(R, K, ie, _e) {
        K === void 0 && (K = wn(ie));
        var ge = (R === 0 ? K : K >>> R) & k, ke = this.nodes[ge];
        return ke ? ke.get(R + v, K, ie, _e) : _e;
      }, In.prototype.update = function(R, K, ie, _e, ge, ke, Te) {
        ie === void 0 && (ie = wn(_e));
        var Ve = (K === 0 ? ie : ie >>> K) & k, et = ge === S, nt = this.nodes, we = nt[Ve];
        if (et && !we)
          return this;
        var Me = Ti(we, R, K + v, ie, _e, ge, ke, Te);
        if (Me === we)
          return this;
        var Ne = this.count;
        if (!we)
          Ne++;
        else if (!Me && (Ne--, Ne < Bb))
          return Uk(R, nt, Ne, Ve);
        var _t = R && R === this.ownerID, Pt = jb(nt, Ve, Me, _t);
        return _t ? (this.count = Ne, this.nodes = Pt, this) : new In(R, Ne, Pt);
      };
      function xe(R, K, ie) {
        this.ownerID = R, this.keyHash = K, this.entries = ie;
      }
      xe.prototype.get = function(R, K, ie, _e) {
        for (var ge = this.entries, ke = 0, Te = ge.length; ke < Te; ke++)
          if (bt(ie, ge[ke][0]))
            return ge[ke][1];
        return _e;
      }, xe.prototype.update = function(R, K, ie, _e, ge, ke, Te) {
        ie === void 0 && (ie = wn(_e));
        var Ve = ge === S;
        if (ie !== this.keyHash)
          return Ve ? this : (M(Te), M(ke), xu(this, R, K, ie, [_e, ge]));
        for (var et = this.entries, nt = 0, we = et.length; nt < we && !bt(_e, et[nt][0]); nt++)
          ;
        var Me = nt < we;
        if (Me ? et[nt][1] === ge : Ve)
          return this;
        if (M(Te), (Ve || !Me) && M(ke), Ve && we === 2)
          return new je(R, this.keyHash, et[nt ^ 1]);
        var Ne = R && R === this.ownerID, _t = Ne ? et : C(et);
        return Me ? Ve ? nt === we - 1 ? _t.pop() : _t[nt] = _t.pop() : _t[nt] = [_e, ge] : _t.push([_e, ge]), Ne ? (this.entries = _t, this) : new xe(R, this.keyHash, _t);
      };
      function je(R, K, ie) {
        this.ownerID = R, this.keyHash = K, this.entry = ie;
      }
      je.prototype.get = function(R, K, ie, _e) {
        return bt(ie, this.entry[0]) ? this.entry[1] : _e;
      }, je.prototype.update = function(R, K, ie, _e, ge, ke, Te) {
        var Ve = ge === S, et = bt(_e, this.entry[0]);
        if (et ? ge === this.entry[1] : Ve)
          return this;
        if (M(Te), Ve) {
          M(ke);
          return;
        }
        return et ? R && R === this.ownerID ? (this.entry[1] = ge, this) : new je(R, this.keyHash, [_e, ge]) : (M(ke), xu(this, R, K, wn(_e), [_e, ge]));
      }, zt.prototype.iterate = xe.prototype.iterate = function(R, K) {
        for (var ie = this.entries, _e = 0, ge = ie.length - 1; _e <= ge; _e++)
          if (R(ie[K ? ge - _e : _e]) === !1)
            return !1;
      }, $t.prototype.iterate = In.prototype.iterate = function(R, K) {
        for (var ie = this.nodes, _e = 0, ge = ie.length - 1; _e <= ge; _e++) {
          var ke = ie[K ? ge - _e : _e];
          if (ke && ke.iterate(R, K) === !1)
            return !1;
        }
      }, je.prototype.iterate = function(R, K) {
        return R(this.entry);
      }, o(pt, H);
      function pt(R, K, ie) {
        this._type = K, this._reverse = ie, this._stack = R._root && Ye(R._root);
      }
      pt.prototype.next = function() {
        for (var R = this._type, K = this._stack; K; ) {
          var ie = K.node, _e = K.index++, ge;
          if (ie.entry) {
            if (_e === 0)
              return Jt(R, ie.entry);
          } else if (ie.entries) {
            if (ge = ie.entries.length - 1, _e <= ge)
              return Jt(R, ie.entries[this._reverse ? ge - _e : _e]);
          } else if (ge = ie.nodes.length - 1, _e <= ge) {
            var ke = ie.nodes[this._reverse ? ge - _e : _e];
            if (ke) {
              if (ke.entry)
                return Jt(R, ke.entry);
              K = this._stack = Ye(ke, K);
            }
            continue;
          }
          K = this._stack = this._stack.__prev;
        }
        return X();
      };
      function Jt(R, K) {
        return Q(R, K[0], K[1]);
      }
      function Ye(R, K) {
        return {
          node: R,
          index: 0,
          __prev: K
        };
      }
      function mn(R, K, ie, _e) {
        var ge = Object.create(tt);
        return ge.size = R, ge._root = K, ge.__ownerID = ie, ge.__hash = _e, ge.__altered = !1, ge;
      }
      var Co;
      function zo() {
        return Co || (Co = mn(0));
      }
      function Di(R, K, ie) {
        var _e, ge;
        if (R._root) {
          var ke = D(O), Te = D(I);
          if (_e = Ti(R._root, R.__ownerID, 0, void 0, K, ie, ke, Te), !Te.value)
            return R;
          ge = R.size + (ke.value ? ie === S ? -1 : 1 : 0);
        } else {
          if (ie === S)
            return R;
          ge = 1, _e = new zt(R.__ownerID, [[K, ie]]);
        }
        return R.__ownerID ? (R.size = ge, R._root = _e, R.__hash = void 0, R.__altered = !0, R) : _e ? mn(ge, _e) : zo();
      }
      function Ti(R, K, ie, _e, ge, ke, Te, Ve) {
        return R ? R.update(K, ie, _e, ge, ke, Te, Ve) : ke === S ? R : (M(Ve), M(Te), new je(K, _e, [ge, ke]));
      }
      function Ds(R) {
        return R.constructor === je || R.constructor === xe;
      }
      function xu(R, K, ie, _e, ge) {
        if (R.keyHash === _e)
          return new xe(K, _e, [R.entry, ge]);
        var ke = (ie === 0 ? R.keyHash : R.keyHash >>> ie) & k, Te = (ie === 0 ? _e : _e >>> ie) & k, Ve, et = ke === Te ? [xu(R, K, ie + v, _e, ge)] : (Ve = new je(K, _e, ge), ke < Te ? [R, Ve] : [Ve, R]);
        return new $t(K, 1 << ke | 1 << Te, et);
      }
      function Bk(R, K, ie, _e) {
        R || (R = new N());
        for (var ge = new je(R, wn(ie), [ie, _e]), ke = 0; ke < K.length; ke++) {
          var Te = K[ke];
          ge = ge.update(R, 0, void 0, Te[0], Te[1]);
        }
        return ge;
      }
      function Uk(R, K, ie, _e) {
        for (var ge = 0, ke = 0, Te = new Array(ie), Ve = 0, et = 1, nt = K.length; Ve < nt; Ve++, et <<= 1) {
          var we = K[Ve];
          we !== void 0 && Ve !== _e && (ge |= et, Te[ke++] = we);
        }
        return new $t(R, ge, Te);
      }
      function Db(R, K, ie, _e, ge) {
        for (var ke = 0, Te = new Array($), Ve = 0; ie !== 0; Ve++, ie >>>= 1)
          Te[Ve] = ie & 1 ? K[ke++] : void 0;
        return Te[_e] = ge, new In(R, ke + 1, Te);
      }
      function xg(R, K, ie) {
        for (var _e = [], ge = 0; ge < ie.length; ge++) {
          var ke = ie[ge], Te = i(ke);
          c(ke) || (Te = Te.map(function(Ve) {
            return wt(Ve);
          })), _e.push(Te);
        }
        return Lb(R, K, _e);
      }
      function Mb(R, K, ie) {
        return R && R.mergeDeep && c(K) ? R.mergeDeep(K) : bt(R, K) ? R : K;
      }
      function pm(R) {
        return function(K, ie, _e) {
          if (K && K.mergeDeepWith && c(ie))
            return K.mergeDeepWith(R, ie);
          var ge = R(K, ie, _e);
          return bt(K, ge) ? K : ge;
        };
      }
      function Lb(R, K, ie) {
        return ie = ie.filter(function(_e) {
          return _e.size !== 0;
        }), ie.length === 0 ? R : R.size === 0 && !R.__ownerID && ie.length === 1 ? R.constructor(ie[0]) : R.withMutations(function(_e) {
          for (var ge = K ? function(Te, Ve) {
            _e.update(
              Ve,
              S,
              function(et) {
                return et === S ? Te : K(et, Te, Ve);
              }
            );
          } : function(Te, Ve) {
            _e.set(Ve, Te);
          }, ke = 0; ke < ie.length; ke++)
            ie[ke].forEach(ge);
        });
      }
      function Wk(R, K, ie, _e) {
        var ge = R === S, ke = K.next();
        if (ke.done) {
          var Te = ge ? ie : R, Ve = _e(Te);
          return Ve === Te ? R : Ve;
        }
        Ln(
          ge || R && R.set,
          "invalid keyPath"
        );
        var et = ke.value, nt = ge ? S : R.get(et, S), we = Wk(
          nt,
          K,
          ie,
          _e
        );
        return we === nt ? R : we === S ? R.remove(et) : (ge ? zo() : R).set(et, we);
      }
      function qb(R) {
        return R = R - (R >> 1 & 1431655765), R = (R & 858993459) + (R >> 2 & 858993459), R = R + (R >> 4) & 252645135, R = R + (R >> 8), R = R + (R >> 16), R & 127;
      }
      function jb(R, K, ie, _e) {
        var ge = _e ? R : C(R);
        return ge[K] = ie, ge;
      }
      function Fb(R, K, ie, _e) {
        var ge = R.length + 1;
        if (_e && K + 1 === ge)
          return R[K] = ie, R;
        for (var ke = new Array(ge), Te = 0, Ve = 0; Ve < ge; Ve++)
          Ve === K ? (ke[Ve] = ie, Te = -1) : ke[Ve] = R[Ve + Te];
        return ke;
      }
      function $z(R, K, ie) {
        var _e = R.length - 1;
        if (ie && K === _e)
          return R.pop(), R;
        for (var ge = new Array(_e), ke = 0, Te = 0; Te < _e; Te++)
          Te === K && (ke = 1), ge[Te] = R[Te + ke];
        return ge;
      }
      var Gk = $ / 4, Vb = $ / 2, Bb = $ / 4;
      o(Bo, kn);
      function Bo(R) {
        var K = Hb();
        if (R == null)
          return K;
        if (Ub(R))
          return R;
        var ie = a(R), _e = ie.size;
        return _e === 0 ? K : (Kt(_e), _e > 0 && _e < $ ? W_(0, _e, v, null, new Ol(ie.toArray())) : K.withMutations(function(ge) {
          ge.setSize(_e), ie.forEach(function(ke, Te) {
            return ge.set(Te, ke);
          });
        }));
      }
      Bo.of = function() {
        return this(arguments);
      }, Bo.prototype.toString = function() {
        return this.__toString("List [", "]");
      }, Bo.prototype.get = function(R, K) {
        if (R = x(this, R), R >= 0 && R < this.size) {
          R += this._origin;
          var ie = Kk(this, R);
          return ie && ie.array[R & k];
        }
        return K;
      }, Bo.prototype.set = function(R, K) {
        return wz(this, R, K);
      }, Bo.prototype.remove = function(R) {
        return this.has(R) ? R === 0 ? this.shift() : R === this.size - 1 ? this.pop() : this.splice(R, 1) : this;
      }, Bo.prototype.insert = function(R, K) {
        return this.splice(R, 0, K);
      }, Bo.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = v, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : Hb();
      }, Bo.prototype.push = function() {
        var R = arguments, K = this.size;
        return this.withMutations(function(ie) {
          wd(ie, 0, K + R.length);
          for (var _e = 0; _e < R.length; _e++)
            ie.set(K + _e, R[_e]);
        });
      }, Bo.prototype.pop = function() {
        return wd(this, 0, -1);
      }, Bo.prototype.unshift = function() {
        var R = arguments;
        return this.withMutations(function(K) {
          wd(K, -R.length);
          for (var ie = 0; ie < R.length; ie++)
            K.set(ie, R[ie]);
        });
      }, Bo.prototype.shift = function() {
        return wd(this, 1);
      }, Bo.prototype.merge = function() {
        return Tg(this, void 0, arguments);
      }, Bo.prototype.mergeWith = function(R) {
        var K = n.call(arguments, 1);
        return Tg(this, R, K);
      }, Bo.prototype.mergeDeep = function() {
        return Tg(this, Mb, arguments);
      }, Bo.prototype.mergeDeepWith = function(R) {
        var K = n.call(arguments, 1);
        return Tg(this, pm(R), K);
      }, Bo.prototype.setSize = function(R) {
        return wd(this, 0, R);
      }, Bo.prototype.slice = function(R, K) {
        var ie = this.size;
        return E(R, K, ie) ? this : wd(
          this,
          T(R, ie),
          z(K, ie)
        );
      }, Bo.prototype.__iterator = function(R, K) {
        var ie = 0, _e = Gb(this, K);
        return new H(function() {
          var ge = _e();
          return ge === U_ ? X() : Q(R, ie++, ge);
        });
      }, Bo.prototype.__iterate = function(R, K) {
        for (var ie = 0, _e = Gb(this, K), ge; (ge = _e()) !== U_ && R(ge, ie++, this) !== !1; )
          ;
        return ie;
      }, Bo.prototype.__ensureOwner = function(R) {
        return R === this.__ownerID ? this : R ? W_(this._origin, this._capacity, this._level, this._root, this._tail, R, this.__hash) : (this.__ownerID = R, this);
      };
      function Ub(R) {
        return !!(R && R[Wb]);
      }
      Bo.isList = Ub;
      var Wb = "@@__IMMUTABLE_LIST__@@", ma = Bo.prototype;
      ma[Wb] = !0, ma[b] = ma.remove, ma.setIn = tt.setIn, ma.deleteIn = ma.removeIn = tt.removeIn, ma.update = tt.update, ma.updateIn = tt.updateIn, ma.mergeIn = tt.mergeIn, ma.mergeDeepIn = tt.mergeDeepIn, ma.withMutations = tt.withMutations, ma.asMutable = tt.asMutable, ma.asImmutable = tt.asImmutable, ma.wasAltered = tt.wasAltered;
      function Ol(R, K) {
        this.array = R, this.ownerID = K;
      }
      Ol.prototype.removeBefore = function(R, K, ie) {
        if (ie === K ? 1 << K : this.array.length === 0)
          return this;
        var _e = ie >>> K & k;
        if (_e >= this.array.length)
          return new Ol([], R);
        var ge = _e === 0, ke;
        if (K > 0) {
          var Te = this.array[_e];
          if (ke = Te && Te.removeBefore(R, K - v, ie), ke === Te && ge)
            return this;
        }
        if (ge && !ke)
          return this;
        var Ve = G_(this, R);
        if (!ge)
          for (var et = 0; et < _e; et++)
            Ve.array[et] = void 0;
        return ke && (Ve.array[_e] = ke), Ve;
      }, Ol.prototype.removeAfter = function(R, K, ie) {
        if (ie === (K ? 1 << K : 0) || this.array.length === 0)
          return this;
        var _e = ie - 1 >>> K & k;
        if (_e >= this.array.length)
          return this;
        var ge;
        if (K > 0) {
          var ke = this.array[_e];
          if (ge = ke && ke.removeAfter(R, K - v, ie), ge === ke && _e === this.array.length - 1)
            return this;
        }
        var Te = G_(this, R);
        return Te.array.splice(_e + 1), ge && (Te.array[_e] = ge), Te;
      };
      var U_ = {};
      function Gb(R, K) {
        var ie = R._origin, _e = R._capacity, ge = Eu(_e), ke = R._tail;
        return Te(R._root, R._level, 0);
        function Te(nt, we, Me) {
          return we === 0 ? Ve(nt, Me) : et(nt, we, Me);
        }
        function Ve(nt, we) {
          var Me = we === ge ? ke && ke.array : nt && nt.array, Ne = we > ie ? 0 : ie - we, _t = _e - we;
          return _t > $ && (_t = $), function() {
            if (Ne === _t)
              return U_;
            var Pt = K ? --_t : Ne++;
            return Me && Me[Pt];
          };
        }
        function et(nt, we, Me) {
          var Ne, _t = nt && nt.array, Pt = Me > ie ? 0 : ie - Me >> we, fn = (_e - Me >> we) + 1;
          return fn > $ && (fn = $), function() {
            do {
              if (Ne) {
                var Jo = Ne();
                if (Jo !== U_)
                  return Jo;
                Ne = null;
              }
              if (Pt === fn)
                return U_;
              var $o = K ? --fn : Pt++;
              Ne = Te(
                _t && _t[$o],
                we - v,
                Me + ($o << we)
              );
            } while (!0);
          };
        }
      }
      function W_(R, K, ie, _e, ge, ke, Te) {
        var Ve = Object.create(ma);
        return Ve.size = K - R, Ve._origin = R, Ve._capacity = K, Ve._level = ie, Ve._root = _e, Ve._tail = ge, Ve.__ownerID = ke, Ve.__hash = Te, Ve.__altered = !1, Ve;
      }
      var Hk;
      function Hb() {
        return Hk || (Hk = W_(0, 0, v));
      }
      function wz(R, K, ie) {
        if (K = x(R, K), K !== K)
          return R;
        if (K >= R.size || K < 0)
          return R.withMutations(function(Te) {
            K < 0 ? wd(Te, K).set(0, ie) : wd(Te, 0, K + 1).set(K, ie);
          });
        K += R._origin;
        var _e = R._tail, ge = R._root, ke = D(I);
        return K >= Eu(R._capacity) ? _e = Eg(_e, R.__ownerID, 0, K, ie, ke) : ge = Eg(ge, R.__ownerID, R._level, K, ie, ke), ke.value ? R.__ownerID ? (R._root = ge, R._tail = _e, R.__hash = void 0, R.__altered = !0, R) : W_(R._origin, R._capacity, R._level, ge, _e) : R;
      }
      function Eg(R, K, ie, _e, ge, ke) {
        var Te = _e >>> ie & k, Ve = R && Te < R.array.length;
        if (!Ve && ge === void 0)
          return R;
        var et;
        if (ie > 0) {
          var nt = R && R.array[Te], we = Eg(nt, K, ie - v, _e, ge, ke);
          return we === nt ? R : (et = G_(R, K), et.array[Te] = we, et);
        }
        return Ve && R.array[Te] === ge ? R : (M(ke), et = G_(R, K), ge === void 0 && Te === et.array.length - 1 ? et.array.pop() : et.array[Te] = ge, et);
      }
      function G_(R, K) {
        return K && R && K === R.ownerID ? R : new Ol(R ? R.array.slice() : [], K);
      }
      function Kk(R, K) {
        if (K >= Eu(R._capacity))
          return R._tail;
        if (K < 1 << R._level + v) {
          for (var ie = R._root, _e = R._level; ie && _e > 0; )
            ie = ie.array[K >>> _e & k], _e -= v;
          return ie;
        }
      }
      function wd(R, K, ie) {
        K !== void 0 && (K = K | 0), ie !== void 0 && (ie = ie | 0);
        var _e = R.__ownerID || new N(), ge = R._origin, ke = R._capacity, Te = ge + K, Ve = ie === void 0 ? ke : ie < 0 ? ke + ie : ge + ie;
        if (Te === ge && Ve === ke)
          return R;
        if (Te >= Ve)
          return R.clear();
        for (var et = R._level, nt = R._root, we = 0; Te + we < 0; )
          nt = new Ol(nt && nt.array.length ? [void 0, nt] : [], _e), et += v, we += 1 << et;
        we && (Te += we, ge += we, Ve += we, ke += we);
        for (var Me = Eu(ke), Ne = Eu(Ve); Ne >= 1 << et + v; )
          nt = new Ol(nt && nt.array.length ? [nt] : [], _e), et += v;
        var _t = R._tail, Pt = Ne < Me ? Kk(R, Ve - 1) : Ne > Me ? new Ol([], _e) : _t;
        if (_t && Ne > Me && Te < ke && _t.array.length) {
          nt = G_(nt, _e);
          for (var fn = nt, Jo = et; Jo > v; Jo -= v) {
            var $o = Me >>> Jo & k;
            fn = fn.array[$o] = G_(fn.array[$o], _e);
          }
          fn.array[Me >>> v & k] = _t;
        }
        if (Ve < ke && (Pt = Pt && Pt.removeAfter(_e, 0, Ve)), Te >= Ne)
          Te -= Ne, Ve -= Ne, et = v, nt = null, Pt = Pt && Pt.removeBefore(_e, 0, Te);
        else if (Te > ge || Ne < Me) {
          for (we = 0; nt; ) {
            var Q_ = Te >>> et & k;
            if (Q_ !== Ne >>> et & k)
              break;
            Q_ && (we += (1 << et) * Q_), et -= v, nt = nt.array[Q_];
          }
          nt && Te > ge && (nt = nt.removeBefore(_e, et, Te - we)), nt && Ne < Me && (nt = nt.removeAfter(_e, et, Ne - we)), we && (Te -= we, Ve -= we);
        }
        return R.__ownerID ? (R.size = Ve - Te, R._origin = Te, R._capacity = Ve, R._level = et, R._root = nt, R._tail = Pt, R.__hash = void 0, R.__altered = !0, R) : W_(Te, Ve, et, nt, Pt);
      }
      function Tg(R, K, ie) {
        for (var _e = [], ge = 0, ke = 0; ke < ie.length; ke++) {
          var Te = ie[ke], Ve = a(Te);
          Ve.size > ge && (ge = Ve.size), c(Te) || (Ve = Ve.map(function(et) {
            return wt(et);
          })), _e.push(Ve);
        }
        return ge > R.size && (R = R.setSize(ge)), Lb(R, K, _e);
      }
      function Eu(R) {
        return R < $ ? 0 : R - 1 >>> v << v;
      }
      o(oi, At);
      function oi(R) {
        return R == null ? Ag() : Yk(R) ? R : Ag().withMutations(function(K) {
          var ie = i(R);
          Kt(ie.size), ie.forEach(function(_e, ge) {
            return K.set(ge, _e);
          });
        });
      }
      oi.of = function() {
        return this(arguments);
      }, oi.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
      }, oi.prototype.get = function(R, K) {
        var ie = this._map.get(R);
        return ie !== void 0 ? this._list.get(ie)[1] : K;
      }, oi.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Ag();
      }, oi.prototype.set = function(R, K) {
        return xr(this, R, K);
      }, oi.prototype.remove = function(R) {
        return xr(this, R, S);
      }, oi.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
      }, oi.prototype.__iterate = function(R, K) {
        var ie = this;
        return this._list.__iterate(
          function(_e) {
            return _e && R(_e[1], _e[0], ie);
          },
          K
        );
      }, oi.prototype.__iterator = function(R, K) {
        return this._list.fromEntrySeq().__iterator(R, K);
      }, oi.prototype.__ensureOwner = function(R) {
        if (R === this.__ownerID)
          return this;
        var K = this._map.__ensureOwner(R), ie = this._list.__ensureOwner(R);
        return R ? Kb(K, ie, R, this.__hash) : (this.__ownerID = R, this._map = K, this._list = ie, this);
      };
      function Yk(R) {
        return Mt(R) && _(R);
      }
      oi.isOrderedMap = Yk, oi.prototype[h] = !0, oi.prototype[b] = oi.prototype.remove;
      function Kb(R, K, ie, _e) {
        var ge = Object.create(oi.prototype);
        return ge.size = R ? R.size : 0, ge._map = R, ge._list = K, ge.__ownerID = ie, ge.__hash = _e, ge;
      }
      var Zk;
      function Ag() {
        return Zk || (Zk = Kb(zo(), Hb()));
      }
      function xr(R, K, ie) {
        var _e = R._map, ge = R._list, ke = _e.get(K), Te = ke !== void 0, Ve, et;
        if (ie === S) {
          if (!Te)
            return R;
          ge.size >= $ && ge.size >= _e.size * 2 ? (et = ge.filter(function(nt, we) {
            return nt !== void 0 && ke !== we;
          }), Ve = et.toKeyedSeq().map(function(nt) {
            return nt[0];
          }).flip().toMap(), R.__ownerID && (Ve.__ownerID = et.__ownerID = R.__ownerID)) : (Ve = _e.remove(K), et = ke === ge.size - 1 ? ge.pop() : ge.set(ke, void 0));
        } else if (Te) {
          if (ie === ge.get(ke)[1])
            return R;
          Ve = _e, et = ge.set(ke, [K, ie]);
        } else
          Ve = _e.set(K, ge.size), et = ge.set(ge.size, [K, ie]);
        return R.__ownerID ? (R.size = Ve.size, R._map = Ve, R._list = et, R.__hash = void 0, R) : Kb(Ve, et);
      }
      o(ho, de);
      function ho(R, K) {
        this._iter = R, this._useKeys = K, this.size = R.size;
      }
      ho.prototype.get = function(R, K) {
        return this._iter.get(R, K);
      }, ho.prototype.has = function(R) {
        return this._iter.has(R);
      }, ho.prototype.valueSeq = function() {
        return this._iter.valueSeq();
      }, ho.prototype.reverse = function() {
        var R = this, K = Yb(this, !0);
        return this._useKeys || (K.valueSeq = function() {
          return R._iter.toSeq().reverse();
        }), K;
      }, ho.prototype.map = function(R, K) {
        var ie = this, _e = Jk(this, R, K);
        return this._useKeys || (_e.valueSeq = function() {
          return ie._iter.toSeq().map(R, K);
        }), _e;
      }, ho.prototype.__iterate = function(R, K) {
        var ie = this, _e;
        return this._iter.__iterate(
          this._useKeys ? function(ge, ke) {
            return R(ge, ke, ie);
          } : (_e = K ? ls(this) : 0, function(ge) {
            return R(ge, K ? --_e : _e++, ie);
          }),
          K
        );
      }, ho.prototype.__iterator = function(R, K) {
        if (this._useKeys)
          return this._iter.__iterator(R, K);
        var ie = this._iter.__iterator(V, K), _e = K ? ls(this) : 0;
        return new H(function() {
          var ge = ie.next();
          return ge.done ? ge : Q(R, K ? --_e : _e++, ge.value, ge);
        });
      }, ho.prototype[h] = !0, o(H_, te);
      function H_(R) {
        this._iter = R, this.size = R.size;
      }
      H_.prototype.includes = function(R) {
        return this._iter.includes(R);
      }, H_.prototype.__iterate = function(R, K) {
        var ie = this, _e = 0;
        return this._iter.__iterate(function(ge) {
          return R(ge, _e++, ie);
        }, K);
      }, H_.prototype.__iterator = function(R, K) {
        var ie = this._iter.__iterator(V, K), _e = 0;
        return new H(function() {
          var ge = ie.next();
          return ge.done ? ge : Q(R, _e++, ge.value, ge);
        });
      }, o(K_, ue);
      function K_(R) {
        this._iter = R, this.size = R.size;
      }
      K_.prototype.has = function(R) {
        return this._iter.includes(R);
      }, K_.prototype.__iterate = function(R, K) {
        var ie = this;
        return this._iter.__iterate(function(_e) {
          return R(_e, _e, ie);
        }, K);
      }, K_.prototype.__iterator = function(R, K) {
        var ie = this._iter.__iterator(V, K);
        return new H(function() {
          var _e = ie.next();
          return _e.done ? _e : Q(R, _e.value, _e.value, _e);
        });
      }, o(Y_, de);
      function Y_(R) {
        this._iter = R, this.size = R.size;
      }
      Y_.prototype.entrySeq = function() {
        return this._iter.toSeq();
      }, Y_.prototype.__iterate = function(R, K) {
        var ie = this;
        return this._iter.__iterate(function(_e) {
          if (_e) {
            t1(_e);
            var ge = c(_e);
            return R(
              ge ? _e.get(1) : _e[1],
              ge ? _e.get(0) : _e[0],
              ie
            );
          }
        }, K);
      }, Y_.prototype.__iterator = function(R, K) {
        var ie = this._iter.__iterator(V, K);
        return new H(function() {
          for (; ; ) {
            var _e = ie.next();
            if (_e.done)
              return _e;
            var ge = _e.value;
            if (ge) {
              t1(ge);
              var ke = c(ge);
              return Q(
                R,
                ke ? ge.get(0) : ge[0],
                ke ? ge.get(1) : ge[1],
                _e
              );
            }
          }
        });
      }, H_.prototype.cacheResult = ho.prototype.cacheResult = K_.prototype.cacheResult = Y_.prototype.cacheResult = Hc;
      function Qk(R) {
        var K = cc(R);
        return K._iter = R, K.size = R.size, K.flip = function() {
          return R;
        }, K.reverse = function() {
          var ie = R.reverse.apply(this);
          return ie.flip = function() {
            return R.reverse();
          }, ie;
        }, K.has = function(ie) {
          return R.includes(ie);
        }, K.includes = function(ie) {
          return R.has(ie);
        }, K.cacheResult = Hc, K.__iterateUncached = function(ie, _e) {
          var ge = this;
          return R.__iterate(function(ke, Te) {
            return ie(Te, ke, ge) !== !1;
          }, _e);
        }, K.__iteratorUncached = function(ie, _e) {
          if (ie === F) {
            var ge = R.__iterator(ie, _e);
            return new H(function() {
              var ke = ge.next();
              if (!ke.done) {
                var Te = ke.value[0];
                ke.value[0] = ke.value[1], ke.value[1] = Te;
              }
              return ke;
            });
          }
          return R.__iterator(
            ie === V ? q : V,
            _e
          );
        }, K;
      }
      function Jk(R, K, ie) {
        var _e = cc(R);
        return _e.size = R.size, _e.has = function(ge) {
          return R.has(ge);
        }, _e.get = function(ge, ke) {
          var Te = R.get(ge, S);
          return Te === S ? ke : K.call(ie, Te, ge, R);
        }, _e.__iterateUncached = function(ge, ke) {
          var Te = this;
          return R.__iterate(
            function(Ve, et, nt) {
              return ge(K.call(ie, Ve, et, nt), et, Te) !== !1;
            },
            ke
          );
        }, _e.__iteratorUncached = function(ge, ke) {
          var Te = R.__iterator(F, ke);
          return new H(function() {
            var Ve = Te.next();
            if (Ve.done)
              return Ve;
            var et = Ve.value, nt = et[0];
            return Q(
              ge,
              nt,
              K.call(ie, et[1], nt, R),
              Ve
            );
          });
        }, _e;
      }
      function Yb(R, K) {
        var ie = cc(R);
        return ie._iter = R, ie.size = R.size, ie.reverse = function() {
          return R;
        }, R.flip && (ie.flip = function() {
          var _e = Qk(R);
          return _e.reverse = function() {
            return R.flip();
          }, _e;
        }), ie.get = function(_e, ge) {
          return R.get(K ? _e : -1 - _e, ge);
        }, ie.has = function(_e) {
          return R.has(K ? _e : -1 - _e);
        }, ie.includes = function(_e) {
          return R.includes(_e);
        }, ie.cacheResult = Hc, ie.__iterate = function(_e, ge) {
          var ke = this;
          return R.__iterate(function(Te, Ve) {
            return _e(Te, Ve, ke);
          }, !ge);
        }, ie.__iterator = function(_e, ge) {
          return R.__iterator(_e, !ge);
        }, ie;
      }
      function Zb(R, K, ie, _e) {
        var ge = cc(R);
        return _e && (ge.has = function(ke) {
          var Te = R.get(ke, S);
          return Te !== S && !!K.call(ie, Te, ke, R);
        }, ge.get = function(ke, Te) {
          var Ve = R.get(ke, S);
          return Ve !== S && K.call(ie, Ve, ke, R) ? Ve : Te;
        }), ge.__iterateUncached = function(ke, Te) {
          var Ve = this, et = 0;
          return R.__iterate(function(nt, we, Me) {
            if (K.call(ie, nt, we, Me))
              return et++, ke(nt, _e ? we : et - 1, Ve);
          }, Te), et;
        }, ge.__iteratorUncached = function(ke, Te) {
          var Ve = R.__iterator(F, Te), et = 0;
          return new H(function() {
            for (; ; ) {
              var nt = Ve.next();
              if (nt.done)
                return nt;
              var we = nt.value, Me = we[0], Ne = we[1];
              if (K.call(ie, Ne, Me, R))
                return Q(ke, _e ? Me : et++, Ne, nt);
            }
          });
        }, ge;
      }
      function kz(R, K, ie) {
        var _e = At().asMutable();
        return R.__iterate(function(ge, ke) {
          _e.update(
            K.call(ie, ge, ke, R),
            0,
            function(Te) {
              return Te + 1;
            }
          );
        }), _e.asImmutable();
      }
      function Mi(R, K, ie) {
        var _e = l(R), ge = (_(R) ? oi() : At()).asMutable();
        R.__iterate(function(Te, Ve) {
          ge.update(
            K.call(ie, Te, Ve, R),
            function(et) {
              return et = et || [], et.push(_e ? [Ve, Te] : Te), et;
            }
          );
        });
        var ke = n1(R);
        return ge.map(function(Te) {
          return co(R, ke(Te));
        });
      }
      function mm(R, K, ie, _e) {
        var ge = R.size;
        if (K !== void 0 && (K = K | 0), ie !== void 0 && (ie === 1 / 0 ? ie = ge : ie = ie | 0), E(K, ie, ge))
          return R;
        var ke = T(K, ge), Te = z(ie, ge);
        if (ke !== ke || Te !== Te)
          return mm(R.toSeq().cacheResult(), K, ie, _e);
        var Ve = Te - ke, et;
        Ve === Ve && (et = Ve < 0 ? 0 : Ve);
        var nt = cc(R);
        return nt.size = et === 0 ? et : R.size && et || void 0, !_e && Se(R) && et >= 0 && (nt.get = function(we, Me) {
          return we = x(this, we), we >= 0 && we < et ? R.get(we + ke, Me) : Me;
        }), nt.__iterateUncached = function(we, Me) {
          var Ne = this;
          if (et === 0)
            return 0;
          if (Me)
            return this.cacheResult().__iterate(we, Me);
          var _t = 0, Pt = !0, fn = 0;
          return R.__iterate(function(Jo, $o) {
            if (!(Pt && (Pt = _t++ < ke)))
              return fn++, we(Jo, _e ? $o : fn - 1, Ne) !== !1 && fn !== et;
          }), fn;
        }, nt.__iteratorUncached = function(we, Me) {
          if (et !== 0 && Me)
            return this.cacheResult().__iterator(we, Me);
          var Ne = et !== 0 && R.__iterator(we, Me), _t = 0, Pt = 0;
          return new H(function() {
            for (; _t++ < ke; )
              Ne.next();
            if (++Pt > et)
              return X();
            var fn = Ne.next();
            return _e || we === V ? fn : we === q ? Q(we, Pt - 1, void 0, fn) : Q(we, Pt - 1, fn.value[1], fn);
          });
        }, nt;
      }
      function Tu(R, K, ie) {
        var _e = cc(R);
        return _e.__iterateUncached = function(ge, ke) {
          var Te = this;
          if (ke)
            return this.cacheResult().__iterate(ge, ke);
          var Ve = 0;
          return R.__iterate(
            function(et, nt, we) {
              return K.call(ie, et, nt, we) && ++Ve && ge(et, nt, Te);
            }
          ), Ve;
        }, _e.__iteratorUncached = function(ge, ke) {
          var Te = this;
          if (ke)
            return this.cacheResult().__iterator(ge, ke);
          var Ve = R.__iterator(F, ke), et = !0;
          return new H(function() {
            if (!et)
              return X();
            var nt = Ve.next();
            if (nt.done)
              return nt;
            var we = nt.value, Me = we[0], Ne = we[1];
            return K.call(ie, Ne, Me, Te) ? ge === F ? nt : Q(ge, Me, Ne, nt) : (et = !1, X());
          });
        }, _e;
      }
      function Qb(R, K, ie, _e) {
        var ge = cc(R);
        return ge.__iterateUncached = function(ke, Te) {
          var Ve = this;
          if (Te)
            return this.cacheResult().__iterate(ke, Te);
          var et = !0, nt = 0;
          return R.__iterate(function(we, Me, Ne) {
            if (!(et && (et = K.call(ie, we, Me, Ne))))
              return nt++, ke(we, _e ? Me : nt - 1, Ve);
          }), nt;
        }, ge.__iteratorUncached = function(ke, Te) {
          var Ve = this;
          if (Te)
            return this.cacheResult().__iterator(ke, Te);
          var et = R.__iterator(F, Te), nt = !0, we = 0;
          return new H(function() {
            var Me, Ne, _t;
            do {
              if (Me = et.next(), Me.done)
                return _e || ke === V ? Me : ke === q ? Q(ke, we++, void 0, Me) : Q(ke, we++, Me.value[1], Me);
              var Pt = Me.value;
              Ne = Pt[0], _t = Pt[1], nt && (nt = K.call(ie, _t, Ne, Ve));
            } while (nt);
            return ke === F ? Me : Q(ke, Ne, _t, Me);
          });
        }, ge;
      }
      function Jb(R, K) {
        var ie = l(R), _e = [R].concat(K).map(function(Te) {
          return c(Te) ? ie && (Te = i(Te)) : Te = ie ? Ge(Te) : rt(Array.isArray(Te) ? Te : [Te]), Te;
        }).filter(function(Te) {
          return Te.size !== 0;
        });
        if (_e.length === 0)
          return R;
        if (_e.length === 1) {
          var ge = _e[0];
          if (ge === R || ie && l(ge) || d(R) && d(ge))
            return ge;
        }
        var ke = new se(_e);
        return ie ? ke = ke.toKeyedSeq() : d(R) || (ke = ke.toSetSeq()), ke = ke.flatten(!0), ke.size = _e.reduce(
          function(Te, Ve) {
            if (Te !== void 0) {
              var et = Ve.size;
              if (et !== void 0)
                return Te + et;
            }
          },
          0
        ), ke;
      }
      function cs(R, K, ie) {
        var _e = cc(R);
        return _e.__iterateUncached = function(ge, ke) {
          var Te = 0, Ve = !1;
          function et(nt, we) {
            var Me = this;
            nt.__iterate(function(Ne, _t) {
              return (!K || we < K) && c(Ne) ? et(Ne, we + 1) : ge(Ne, ie ? _t : Te++, Me) === !1 && (Ve = !0), !Ve;
            }, ke);
          }
          return et(R, 0), Te;
        }, _e.__iteratorUncached = function(ge, ke) {
          var Te = R.__iterator(ge, ke), Ve = [], et = 0;
          return new H(function() {
            for (; Te; ) {
              var nt = Te.next();
              if (nt.done !== !1) {
                Te = Ve.pop();
                continue;
              }
              var we = nt.value;
              if (ge === F && (we = we[1]), (!K || Ve.length < K) && c(we))
                Ve.push(Te), Te = we.__iterator(ge, ke);
              else
                return ie ? nt : Q(ge, et++, we, nt);
            }
            return X();
          });
        }, _e;
      }
      function Xk(R, K, ie) {
        var _e = n1(R);
        return R.toSeq().map(
          function(ge, ke) {
            return _e(K.call(ie, ge, ke, R));
          }
        ).flatten(!0);
      }
      function e1(R, K) {
        var ie = cc(R);
        return ie.size = R.size && R.size * 2 - 1, ie.__iterateUncached = function(_e, ge) {
          var ke = this, Te = 0;
          return R.__iterate(
            function(Ve, et) {
              return (!Te || _e(K, Te++, ke) !== !1) && _e(Ve, Te++, ke) !== !1;
            },
            ge
          ), Te;
        }, ie.__iteratorUncached = function(_e, ge) {
          var ke = R.__iterator(V, ge), Te = 0, Ve;
          return new H(function() {
            return (!Ve || Te % 2) && (Ve = ke.next(), Ve.done) ? Ve : Te % 2 ? Q(_e, Te++, K) : Q(_e, Te++, Ve.value, Ve);
          });
        }, ie;
      }
      function Au(R, K, ie) {
        K || (K = gm);
        var _e = l(R), ge = 0, ke = R.toSeq().map(
          function(Te, Ve) {
            return [Ve, Te, ge++, ie ? ie(Te, Ve, R) : Te];
          }
        ).toArray();
        return ke.sort(function(Te, Ve) {
          return K(Te[3], Ve[3]) || Te[2] - Ve[2];
        }).forEach(
          _e ? function(Te, Ve) {
            ke[Ve].length = 2;
          } : function(Te, Ve) {
            ke[Ve] = Te[1];
          }
        ), _e ? de(ke) : d(R) ? te(ke) : ue(ke);
      }
      function fm(R, K, ie) {
        if (K || (K = gm), ie) {
          var _e = R.toSeq().map(function(ge, ke) {
            return [ge, ie(ge, ke, R)];
          }).reduce(function(ge, ke) {
            return Xb(K, ge[1], ke[1]) ? ke : ge;
          });
          return _e && _e[0];
        } else
          return R.reduce(function(ge, ke) {
            return Xb(K, ge, ke) ? ke : ge;
          });
      }
      function Xb(R, K, ie) {
        var _e = R(ie, K);
        return _e === 0 && ie !== K && (ie == null || ie !== ie) || _e > 0;
      }
      function Cg(R, K, ie) {
        var _e = cc(R);
        return _e.size = new se(ie).map(function(ge) {
          return ge.size;
        }).min(), _e.__iterate = function(ge, ke) {
          for (var Te = this.__iterator(V, ke), Ve, et = 0; !(Ve = Te.next()).done && ge(Ve.value, et++, this) !== !1; )
            ;
          return et;
        }, _e.__iteratorUncached = function(ge, ke) {
          var Te = ie.map(
            function(nt) {
              return nt = r(nt), ee(ke ? nt.reverse() : nt);
            }
          ), Ve = 0, et = !1;
          return new H(function() {
            var nt;
            return et || (nt = Te.map(function(we) {
              return we.next();
            }), et = nt.some(function(we) {
              return we.done;
            })), et ? X() : Q(
              ge,
              Ve++,
              K.apply(null, nt.map(function(we) {
                return we.value;
              }))
            );
          });
        }, _e;
      }
      function co(R, K) {
        return Se(R) ? K : R.constructor(K);
      }
      function t1(R) {
        if (R !== Object(R))
          throw new TypeError("Expected [K, V] tuple: " + R);
      }
      function ls(R) {
        return Kt(R.size), P(R);
      }
      function n1(R) {
        return l(R) ? i : d(R) ? a : s;
      }
      function cc(R) {
        return Object.create(
          (l(R) ? de : d(R) ? te : ue).prototype
        );
      }
      function Hc() {
        return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : ce.prototype.cacheResult.call(this);
      }
      function gm(R, K) {
        return R > K ? 1 : R < K ? -1 : 0;
      }
      function zg(R) {
        var K = ee(R);
        if (!K) {
          if (!oe(R))
            throw new TypeError("Expected iterable or array-like: " + R);
          K = ee(r(R));
        }
        return K;
      }
      o(yo, ln);
      function yo(R, K) {
        var ie, _e = function(Te) {
          if (Te instanceof _e)
            return Te;
          if (!(this instanceof _e))
            return new _e(Te);
          if (!ie) {
            ie = !0;
            var Ve = Object.keys(R);
            ey(ge, Ve), ge.size = Ve.length, ge._name = K, ge._keys = Ve, ge._defaultValues = R;
          }
          this._map = At(Te);
        }, ge = _e.prototype = Object.create(Mr);
        return ge.constructor = _e, _e;
      }
      yo.prototype.toString = function() {
        return this.__toString(o1(this) + " {", "}");
      }, yo.prototype.has = function(R) {
        return this._defaultValues.hasOwnProperty(R);
      }, yo.prototype.get = function(R, K) {
        if (!this.has(R))
          return K;
        var ie = this._defaultValues[R];
        return this._map ? this._map.get(R, ie) : ie;
      }, yo.prototype.clear = function() {
        if (this.__ownerID)
          return this._map && this._map.clear(), this;
        var R = this.constructor;
        return R._empty || (R._empty = Z_(this, zo()));
      }, yo.prototype.set = function(R, K) {
        if (!this.has(R))
          throw new Error('Cannot set unknown key "' + R + '" on ' + o1(this));
        if (this._map && !this._map.has(R)) {
          var ie = this._defaultValues[R];
          if (K === ie)
            return this;
        }
        var _e = this._map && this._map.set(R, K);
        return this.__ownerID || _e === this._map ? this : Z_(this, _e);
      }, yo.prototype.remove = function(R) {
        if (!this.has(R))
          return this;
        var K = this._map && this._map.remove(R);
        return this.__ownerID || K === this._map ? this : Z_(this, K);
      }, yo.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, yo.prototype.__iterator = function(R, K) {
        var ie = this;
        return i(this._defaultValues).map(function(_e, ge) {
          return ie.get(ge);
        }).__iterator(R, K);
      }, yo.prototype.__iterate = function(R, K) {
        var ie = this;
        return i(this._defaultValues).map(function(_e, ge) {
          return ie.get(ge);
        }).__iterate(R, K);
      }, yo.prototype.__ensureOwner = function(R) {
        if (R === this.__ownerID)
          return this;
        var K = this._map && this._map.__ensureOwner(R);
        return R ? Z_(this, K, R) : (this.__ownerID = R, this._map = K, this);
      };
      var Mr = yo.prototype;
      Mr[b] = Mr.remove, Mr.deleteIn = Mr.removeIn = tt.removeIn, Mr.merge = tt.merge, Mr.mergeWith = tt.mergeWith, Mr.mergeIn = tt.mergeIn, Mr.mergeDeep = tt.mergeDeep, Mr.mergeDeepWith = tt.mergeDeepWith, Mr.mergeDeepIn = tt.mergeDeepIn, Mr.setIn = tt.setIn, Mr.update = tt.update, Mr.updateIn = tt.updateIn, Mr.withMutations = tt.withMutations, Mr.asMutable = tt.asMutable, Mr.asImmutable = tt.asImmutable;
      function Z_(R, K, ie) {
        var _e = Object.create(Object.getPrototypeOf(R));
        return _e._map = K, _e.__ownerID = ie, _e;
      }
      function o1(R) {
        return R._name || R.constructor.name || "Record";
      }
      function ey(R, K) {
        try {
          K.forEach(Sz.bind(void 0, R));
        } catch {
        }
      }
      function Sz(R, K) {
        Object.defineProperty(R, K, {
          get: function() {
            return this.get(K);
          },
          set: function(ie) {
            Ln(this.__ownerID, "Cannot set on an immutable record."), this.set(K, ie);
          }
        });
      }
      o(Lr, gt);
      function Lr(R) {
        return R == null ? Og() : ty(R) && !_(R) ? R : Og().withMutations(function(K) {
          var ie = s(R);
          Kt(ie.size), ie.forEach(function(_e) {
            return K.add(_e);
          });
        });
      }
      Lr.of = function() {
        return this(arguments);
      }, Lr.fromKeys = function(R) {
        return this(i(R).keySeq());
      }, Lr.prototype.toString = function() {
        return this.__toString("Set {", "}");
      }, Lr.prototype.has = function(R) {
        return this._map.has(R);
      }, Lr.prototype.add = function(R) {
        return kd(this, this._map.set(R, !0));
      }, Lr.prototype.remove = function(R) {
        return kd(this, this._map.remove(R));
      }, Lr.prototype.clear = function() {
        return kd(this, this._map.clear());
      }, Lr.prototype.union = function() {
        var R = n.call(arguments, 0);
        return R = R.filter(function(K) {
          return K.size !== 0;
        }), R.length === 0 ? this : this.size === 0 && !this.__ownerID && R.length === 1 ? this.constructor(R[0]) : this.withMutations(function(K) {
          for (var ie = 0; ie < R.length; ie++)
            s(R[ie]).forEach(function(_e) {
              return K.add(_e);
            });
        });
      }, Lr.prototype.intersect = function() {
        var R = n.call(arguments, 0);
        if (R.length === 0)
          return this;
        R = R.map(function(ie) {
          return s(ie);
        });
        var K = this;
        return this.withMutations(function(ie) {
          K.forEach(function(_e) {
            R.every(function(ge) {
              return ge.includes(_e);
            }) || ie.remove(_e);
          });
        });
      }, Lr.prototype.subtract = function() {
        var R = n.call(arguments, 0);
        if (R.length === 0)
          return this;
        R = R.map(function(ie) {
          return s(ie);
        });
        var K = this;
        return this.withMutations(function(ie) {
          K.forEach(function(_e) {
            R.some(function(ge) {
              return ge.includes(_e);
            }) && ie.remove(_e);
          });
        });
      }, Lr.prototype.merge = function() {
        return this.union.apply(this, arguments);
      }, Lr.prototype.mergeWith = function(R) {
        var K = n.call(arguments, 1);
        return this.union.apply(this, K);
      }, Lr.prototype.sort = function(R) {
        return Ms(Au(this, R));
      }, Lr.prototype.sortBy = function(R, K) {
        return Ms(Au(this, K, R));
      }, Lr.prototype.wasAltered = function() {
        return this._map.wasAltered();
      }, Lr.prototype.__iterate = function(R, K) {
        var ie = this;
        return this._map.__iterate(function(_e, ge) {
          return R(ge, ge, ie);
        }, K);
      }, Lr.prototype.__iterator = function(R, K) {
        return this._map.map(function(ie, _e) {
          return _e;
        }).__iterator(R, K);
      }, Lr.prototype.__ensureOwner = function(R) {
        if (R === this.__ownerID)
          return this;
        var K = this._map.__ensureOwner(R);
        return R ? this.__make(K, R) : (this.__ownerID = R, this._map = K, this);
      };
      function ty(R) {
        return !!(R && R[ny]);
      }
      Lr.isSet = ty;
      var ny = "@@__IMMUTABLE_SET__@@", Ki = Lr.prototype;
      Ki[ny] = !0, Ki[b] = Ki.remove, Ki.mergeDeep = Ki.merge, Ki.mergeDeepWith = Ki.mergeWith, Ki.withMutations = tt.withMutations, Ki.asMutable = tt.asMutable, Ki.asImmutable = tt.asImmutable, Ki.__empty = Og, Ki.__make = r1;
      function kd(R, K) {
        return R.__ownerID ? (R.size = K.size, R._map = K, R) : K === R._map ? R : K.size === 0 ? R.__empty() : R.__make(K);
      }
      function r1(R, K) {
        var ie = Object.create(Ki);
        return ie.size = R ? R.size : 0, ie._map = R, ie.__ownerID = K, ie;
      }
      var oy;
      function Og() {
        return oy || (oy = r1(zo()));
      }
      o(Ms, Lr);
      function Ms(R) {
        return R == null ? vm() : Pg(R) ? R : vm().withMutations(function(K) {
          var ie = s(R);
          Kt(ie.size), ie.forEach(function(_e) {
            return K.add(_e);
          });
        });
      }
      Ms.of = function() {
        return this(arguments);
      }, Ms.fromKeys = function(R) {
        return this(i(R).keySeq());
      }, Ms.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
      };
      function Pg(R) {
        return ty(R) && _(R);
      }
      Ms.isOrderedSet = Pg;
      var hm = Ms.prototype;
      hm[h] = !0, hm.__empty = vm, hm.__make = i1;
      function i1(R, K) {
        var ie = Object.create(hm);
        return ie.size = R ? R.size : 0, ie._map = R, ie.__ownerID = K, ie;
      }
      var Ig;
      function vm() {
        return Ig || (Ig = i1(Ag()));
      }
      o(ui, kn);
      function ui(R) {
        return R == null ? Rg() : ry(R) ? R : Rg().unshiftAll(R);
      }
      ui.of = function() {
        return this(arguments);
      }, ui.prototype.toString = function() {
        return this.__toString("Stack [", "]");
      }, ui.prototype.get = function(R, K) {
        var ie = this._head;
        for (R = x(this, R); ie && R--; )
          ie = ie.next;
        return ie ? ie.value : K;
      }, ui.prototype.peek = function() {
        return this._head && this._head.value;
      }, ui.prototype.push = function() {
        if (arguments.length === 0)
          return this;
        for (var R = this.size + arguments.length, K = this._head, ie = arguments.length - 1; ie >= 0; ie--)
          K = {
            value: arguments[ie],
            next: K
          };
        return this.__ownerID ? (this.size = R, this._head = K, this.__hash = void 0, this.__altered = !0, this) : Pl(R, K);
      }, ui.prototype.pushAll = function(R) {
        if (R = a(R), R.size === 0)
          return this;
        Kt(R.size);
        var K = this.size, ie = this._head;
        return R.reverse().forEach(function(_e) {
          K++, ie = {
            value: _e,
            next: ie
          };
        }), this.__ownerID ? (this.size = K, this._head = ie, this.__hash = void 0, this.__altered = !0, this) : Pl(K, ie);
      }, ui.prototype.pop = function() {
        return this.slice(1);
      }, ui.prototype.unshift = function() {
        return this.push.apply(this, arguments);
      }, ui.prototype.unshiftAll = function(R) {
        return this.pushAll(R);
      }, ui.prototype.shift = function() {
        return this.pop.apply(this, arguments);
      }, ui.prototype.clear = function() {
        return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Rg();
      }, ui.prototype.slice = function(R, K) {
        if (E(R, K, this.size))
          return this;
        var ie = T(R, this.size), _e = z(K, this.size);
        if (_e !== this.size)
          return kn.prototype.slice.call(this, R, K);
        for (var ge = this.size - ie, ke = this._head; ie--; )
          ke = ke.next;
        return this.__ownerID ? (this.size = ge, this._head = ke, this.__hash = void 0, this.__altered = !0, this) : Pl(ge, ke);
      }, ui.prototype.__ensureOwner = function(R) {
        return R === this.__ownerID ? this : R ? Pl(this.size, this._head, R, this.__hash) : (this.__ownerID = R, this.__altered = !1, this);
      }, ui.prototype.__iterate = function(R, K) {
        if (K)
          return this.reverse().__iterate(R);
        for (var ie = 0, _e = this._head; _e && R(_e.value, ie++, this) !== !1; )
          _e = _e.next;
        return ie;
      }, ui.prototype.__iterator = function(R, K) {
        if (K)
          return this.reverse().__iterator(R);
        var ie = 0, _e = this._head;
        return new H(function() {
          if (_e) {
            var ge = _e.value;
            return _e = _e.next, Q(R, ie++, ge);
          }
          return X();
        });
      };
      function ry(R) {
        return !!(R && R[Da]);
      }
      ui.isStack = ry;
      var Da = "@@__IMMUTABLE_STACK__@@", Sd = ui.prototype;
      Sd[Da] = !0, Sd.withMutations = tt.withMutations, Sd.asMutable = tt.asMutable, Sd.asImmutable = tt.asImmutable, Sd.wasAltered = tt.wasAltered;
      function Pl(R, K, ie, _e) {
        var ge = Object.create(Sd);
        return ge.size = R, ge._head = K, ge.__ownerID = ie, ge.__hash = _e, ge.__altered = !1, ge;
      }
      var iy;
      function Rg() {
        return iy || (iy = Pl(0));
      }
      function Kc(R, K) {
        var ie = function(_e) {
          R.prototype[_e] = K[_e];
        };
        return Object.keys(K).forEach(ie), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(K).forEach(ie), R;
      }
      r.Iterator = H, Kc(r, {
        // ### Conversion to other types
        toArray: function() {
          Kt(this.size);
          var R = new Array(this.size || 0);
          return this.valueSeq().__iterate(function(K, ie) {
            R[ie] = K;
          }), R;
        },
        toIndexedSeq: function() {
          return new H_(this);
        },
        toJS: function() {
          return this.toSeq().map(
            function(R) {
              return R && typeof R.toJS == "function" ? R.toJS() : R;
            }
          ).__toJS();
        },
        toJSON: function() {
          return this.toSeq().map(
            function(R) {
              return R && typeof R.toJSON == "function" ? R.toJSON() : R;
            }
          ).__toJS();
        },
        toKeyedSeq: function() {
          return new ho(this, !0);
        },
        toMap: function() {
          return At(this.toKeyedSeq());
        },
        toObject: function() {
          Kt(this.size);
          var R = {};
          return this.__iterate(function(K, ie) {
            R[ie] = K;
          }), R;
        },
        toOrderedMap: function() {
          return oi(this.toKeyedSeq());
        },
        toOrderedSet: function() {
          return Ms(l(this) ? this.valueSeq() : this);
        },
        toSet: function() {
          return Lr(l(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
          return new K_(this);
        },
        toSeq: function() {
          return d(this) ? this.toIndexedSeq() : l(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
          return ui(l(this) ? this.valueSeq() : this);
        },
        toList: function() {
          return Bo(l(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
          return "[Iterable]";
        },
        __toString: function(R, K) {
          return this.size === 0 ? R + K : R + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + K;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
          var R = n.call(arguments, 0);
          return co(this, Jb(this, R));
        },
        includes: function(R) {
          return this.some(function(K) {
            return bt(K, R);
          });
        },
        entries: function() {
          return this.__iterator(F);
        },
        every: function(R, K) {
          Kt(this.size);
          var ie = !0;
          return this.__iterate(function(_e, ge, ke) {
            if (!R.call(K, _e, ge, ke))
              return ie = !1, !1;
          }), ie;
        },
        filter: function(R, K) {
          return co(this, Zb(this, R, K, !0));
        },
        find: function(R, K, ie) {
          var _e = this.findEntry(R, K);
          return _e ? _e[1] : ie;
        },
        forEach: function(R, K) {
          return Kt(this.size), this.__iterate(K ? R.bind(K) : R);
        },
        join: function(R) {
          Kt(this.size), R = R !== void 0 ? "" + R : ",";
          var K = "", ie = !0;
          return this.__iterate(function(_e) {
            ie ? ie = !1 : K += R, K += _e != null ? _e.toString() : "";
          }), K;
        },
        keys: function() {
          return this.__iterator(q);
        },
        map: function(R, K) {
          return co(this, Jk(this, R, K));
        },
        reduce: function(R, K, ie) {
          Kt(this.size);
          var _e, ge;
          return arguments.length < 2 ? ge = !0 : _e = K, this.__iterate(function(ke, Te, Ve) {
            ge ? (ge = !1, _e = ke) : _e = R.call(ie, _e, ke, Te, Ve);
          }), _e;
        },
        reduceRight: function(R, K, ie) {
          var _e = this.toKeyedSeq().reverse();
          return _e.reduce.apply(_e, arguments);
        },
        reverse: function() {
          return co(this, Yb(this, !0));
        },
        slice: function(R, K) {
          return co(this, mm(this, R, K, !0));
        },
        some: function(R, K) {
          return !this.every(Il(R), K);
        },
        sort: function(R) {
          return co(this, Au(this, R));
        },
        values: function() {
          return this.__iterator(V);
        },
        // ### More sequential methods
        butLast: function() {
          return this.slice(0, -1);
        },
        isEmpty: function() {
          return this.size !== void 0 ? this.size === 0 : !this.some(function() {
            return !0;
          });
        },
        count: function(R, K) {
          return P(
            R ? this.toSeq().filter(R, K) : this
          );
        },
        countBy: function(R, K) {
          return kz(this, R, K);
        },
        equals: function(R) {
          return gn(this, R);
        },
        entrySeq: function() {
          var R = this;
          if (R._cache)
            return new se(R._cache);
          var K = R.toSeq().map(Ez).toIndexedSeq();
          return K.fromEntrySeq = function() {
            return R.toSeq();
          }, K;
        },
        filterNot: function(R, K) {
          return this.filter(Il(R), K);
        },
        findEntry: function(R, K, ie) {
          var _e = ie;
          return this.__iterate(function(ge, ke, Te) {
            if (R.call(K, ge, ke, Te))
              return _e = [ke, ge], !1;
          }), _e;
        },
        findKey: function(R, K) {
          var ie = this.findEntry(R, K);
          return ie && ie[0];
        },
        findLast: function(R, K, ie) {
          return this.toKeyedSeq().reverse().find(R, K, ie);
        },
        findLastEntry: function(R, K, ie) {
          return this.toKeyedSeq().reverse().findEntry(R, K, ie);
        },
        findLastKey: function(R, K) {
          return this.toKeyedSeq().reverse().findKey(R, K);
        },
        first: function() {
          return this.find(w);
        },
        flatMap: function(R, K) {
          return co(this, Xk(this, R, K));
        },
        flatten: function(R) {
          return co(this, cs(this, R, !0));
        },
        fromEntrySeq: function() {
          return new Y_(this);
        },
        get: function(R, K) {
          return this.find(function(ie, _e) {
            return bt(_e, R);
          }, void 0, K);
        },
        getIn: function(R, K) {
          for (var ie = this, _e = zg(R), ge; !(ge = _e.next()).done; ) {
            var ke = ge.value;
            if (ie = ie && ie.get ? ie.get(ke, S) : S, ie === S)
              return K;
          }
          return ie;
        },
        groupBy: function(R, K) {
          return Mi(this, R, K);
        },
        has: function(R) {
          return this.get(R, S) !== S;
        },
        hasIn: function(R) {
          return this.getIn(R, S) !== S;
        },
        isSubset: function(R) {
          return R = typeof R.includes == "function" ? R : r(R), this.every(function(K) {
            return R.includes(K);
          });
        },
        isSuperset: function(R) {
          return R = typeof R.isSubset == "function" ? R : r(R), R.isSubset(this);
        },
        keyOf: function(R) {
          return this.findKey(function(K) {
            return bt(K, R);
          });
        },
        keySeq: function() {
          return this.toSeq().map(xz).toIndexedSeq();
        },
        last: function() {
          return this.toSeq().reverse().first();
        },
        lastKeyOf: function(R) {
          return this.toKeyedSeq().reverse().keyOf(R);
        },
        max: function(R) {
          return fm(this, R);
        },
        maxBy: function(R, K) {
          return fm(this, K, R);
        },
        min: function(R) {
          return fm(this, R ? a1(R) : sy);
        },
        minBy: function(R, K) {
          return fm(this, K ? a1(K) : sy, R);
        },
        rest: function() {
          return this.slice(1);
        },
        skip: function(R) {
          return this.slice(Math.max(0, R));
        },
        skipLast: function(R) {
          return co(this, this.toSeq().reverse().skip(R).reverse());
        },
        skipWhile: function(R, K) {
          return co(this, Qb(this, R, K, !0));
        },
        skipUntil: function(R, K) {
          return this.skipWhile(Il(R), K);
        },
        sortBy: function(R, K) {
          return co(this, Au(this, K, R));
        },
        take: function(R) {
          return this.slice(0, Math.max(0, R));
        },
        takeLast: function(R) {
          return co(this, this.toSeq().reverse().take(R).reverse());
        },
        takeWhile: function(R, K) {
          return co(this, Tu(this, R, K));
        },
        takeUntil: function(R, K) {
          return this.takeWhile(Il(R), K);
        },
        valueSeq: function() {
          return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
          return this.__hash || (this.__hash = xd(this));
        }
        // ### Internal
        // abstract __iterate(fn, reverse)
        // abstract __iterator(type, reverse)
      });
      var fa = r.prototype;
      fa[p] = !0, fa[W] = fa.values, fa.__toJS = fa.toArray, fa.__toStringMapper = s1, fa.inspect = fa.toSource = function() {
        return this.toString();
      }, fa.chain = fa.flatMap, fa.contains = fa.includes, Kc(i, {
        // ### More sequential methods
        flip: function() {
          return co(this, Qk(this));
        },
        mapEntries: function(R, K) {
          var ie = this, _e = 0;
          return co(
            this,
            this.toSeq().map(
              function(ge, ke) {
                return R.call(K, [ke, ge], _e++, ie);
              }
            ).fromEntrySeq()
          );
        },
        mapKeys: function(R, K) {
          var ie = this;
          return co(
            this,
            this.toSeq().flip().map(
              function(_e, ge) {
                return R.call(K, _e, ge, ie);
              }
            ).flip()
          );
        }
      });
      var Ng = i.prototype;
      Ng[f] = !0, Ng[W] = fa.entries, Ng.__toJS = fa.toObject, Ng.__toStringMapper = function(R, K) {
        return JSON.stringify(K) + ": " + s1(R);
      }, Kc(a, {
        // ### Conversion to other types
        toKeyedSeq: function() {
          return new ho(this, !1);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(R, K) {
          return co(this, Zb(this, R, K, !1));
        },
        findIndex: function(R, K) {
          var ie = this.findEntry(R, K);
          return ie ? ie[0] : -1;
        },
        indexOf: function(R) {
          var K = this.keyOf(R);
          return K === void 0 ? -1 : K;
        },
        lastIndexOf: function(R) {
          var K = this.lastKeyOf(R);
          return K === void 0 ? -1 : K;
        },
        reverse: function() {
          return co(this, Yb(this, !1));
        },
        slice: function(R, K) {
          return co(this, mm(this, R, K, !1));
        },
        splice: function(R, K) {
          var ie = arguments.length;
          if (K = Math.max(K | 0, 0), ie === 0 || ie === 2 && !K)
            return this;
          R = T(R, R < 0 ? this.count() : this.size);
          var _e = this.slice(0, R);
          return co(
            this,
            ie === 1 ? _e : _e.concat(C(arguments, 2), this.slice(R + K))
          );
        },
        // ### More collection methods
        findLastIndex: function(R, K) {
          var ie = this.findLastEntry(R, K);
          return ie ? ie[0] : -1;
        },
        first: function() {
          return this.get(0);
        },
        flatten: function(R) {
          return co(this, cs(this, R, !1));
        },
        get: function(R, K) {
          return R = x(this, R), R < 0 || this.size === 1 / 0 || this.size !== void 0 && R > this.size ? K : this.find(function(ie, _e) {
            return _e === R;
          }, void 0, K);
        },
        has: function(R) {
          return R = x(this, R), R >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || R < this.size : this.indexOf(R) !== -1);
        },
        interpose: function(R) {
          return co(this, e1(this, R));
        },
        interleave: function() {
          var R = [this].concat(C(arguments)), K = Cg(this.toSeq(), te.of, R), ie = K.flatten(!0);
          return K.size && (ie.size = K.size * R.length), co(this, ie);
        },
        keySeq: function() {
          return un(0, this.size);
        },
        last: function() {
          return this.get(-1);
        },
        skipWhile: function(R, K) {
          return co(this, Qb(this, R, K, !1));
        },
        zip: function() {
          var R = [this].concat(C(arguments));
          return co(this, Cg(this, ay, R));
        },
        zipWith: function(R) {
          var K = C(arguments);
          return K[0] = this, co(this, Cg(this, R, K));
        }
      }), a.prototype[g] = !0, a.prototype[h] = !0, Kc(s, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(R, K) {
          return this.has(R) ? R : K;
        },
        includes: function(R) {
          return this.has(R);
        },
        // ### More sequential methods
        keySeq: function() {
          return this.valueSeq();
        }
      }), s.prototype.has = fa.includes, s.prototype.contains = s.prototype.includes, Kc(de, i.prototype), Kc(te, a.prototype), Kc(ue, s.prototype), Kc(ln, i.prototype), Kc(kn, a.prototype), Kc(gt, s.prototype);
      function xz(R, K) {
        return K;
      }
      function Ez(R, K) {
        return [K, R];
      }
      function Il(R) {
        return function() {
          return !R.apply(this, arguments);
        };
      }
      function a1(R) {
        return function() {
          return -R.apply(this, arguments);
        };
      }
      function s1(R) {
        return typeof R == "string" ? JSON.stringify(R) : String(R);
      }
      function ay() {
        return C(arguments);
      }
      function sy(R, K) {
        return R < K ? 1 : R > K ? -1 : 0;
      }
      function xd(R) {
        if (R.size === 1 / 0)
          return 0;
        var K = _(R), ie = l(R), _e = K ? 1 : 0, ge = R.__iterate(
          ie ? K ? function(ke, Te) {
            _e = 31 * _e + c1(wn(ke), wn(Te)) | 0;
          } : function(ke, Te) {
            _e = _e + c1(wn(ke), wn(Te)) | 0;
          } : K ? function(ke) {
            _e = 31 * _e + wn(ke) | 0;
          } : function(ke) {
            _e = _e + wn(ke) | 0;
          }
        );
        return Dg(ge, _e);
      }
      function Dg(R, K) {
        return K = Ot(K, 3432918353), K = Ot(K << 15 | K >>> -15, 461845907), K = Ot(K << 13 | K >>> -13, 5), K = (K + 3864292196 | 0) ^ R, K = Ot(K ^ K >>> 16, 2246822507), K = Ot(K ^ K >>> 13, 3266489909), K = _n(K ^ K >>> 16), K;
      }
      function c1(R, K) {
        return R ^ K + 2654435769 + (R << 6) + (R >> 2) | 0;
      }
      var Tz = {
        Iterable: r,
        Seq: ce,
        Collection: cn,
        Map: At,
        OrderedMap: oi,
        List: Bo,
        Stack: ui,
        Set: Lr,
        OrderedSet: Ms,
        Record: yo,
        Range: un,
        Repeat: an,
        is: bt,
        fromJS: wt
      };
      return Tz;
    });
  }(J5)), J5.exports;
}
var Fo = {};
const Wc = /* @__PURE__ */ Oa(kwc);
var qee;
function yg() {
  if (qee)
    return Fo;
  qee = 1;
  var e = Rt;
  Object.defineProperty(Fo, "__esModule", {
    value: !0
  }), Fo.removePathsInTree = Fo.removeIsLockedInTree = Fo.isEmptyTree = Fo.hasChildren = Fo.getTreeBadFields = Fo.getTotalRulesCountInTree = Fo.getTotalReordableNodesCountInTree = Fo.getSwitchValues = Fo.getLightTree = Fo.getItemByPath = Fo.getFlatTree = Fo.fixPathsInTree = Fo.fixEmptyGroupsInTree = Fo.expandTreeSubpath = Fo.expandTreePath = void 0;
  var t = e(Wc), n = e(rr), o = e(Ra()), r = function(k) {
    for (var S = arguments.length, O = new Array(S > 1 ? S - 1 : 0), I = 1; I < S; I++)
      O[I - 1] = arguments[I];
    return k.interpose("children1").withMutations(function(D) {
      return D.skip(1), D.push.apply(D, O), D;
    });
  };
  Fo.expandTreePath = r;
  var i = function(k) {
    for (var S = arguments.length, O = new Array(S > 1 ? S - 1 : 0), I = 1; I < S; I++)
      O[I - 1] = arguments[I];
    return k.interpose("children1").withMutations(function(D) {
      return D.push.apply(D, O), D;
    });
  };
  Fo.expandTreeSubpath = i;
  var a = function(k, S) {
    var O = new o.default.OrderedMap((0, n.default)({}, k.get("id"), k)), I = k;
    return S.forEach(function(D) {
      I = O.get(D), O = I.get("children1");
    }), I;
  };
  Fo.getItemByPath = a;
  var s = function(k) {
    var S = k;
    function O(I, D) {
      var M = D.push(I.get("id"));
      I.get("path") && (S = S.removeIn(r(M, "path")));
      var N = I.get("children1");
      N && N.map(function(C, P) {
        O(C, M);
      });
    }
    return O(k, new o.default.List()), S;
  };
  Fo.removePathsInTree = s;
  var c = function(k) {
    var S = k;
    function O(I, D) {
      var M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, N = D.push(I.get("id")), C = I.getIn(["properties", "isLocked"]);
      M && C && (S = S.deleteIn(r(N, "properties", "isLocked")));
      var P = I.get("children1");
      P && P.map(function(x, w) {
        O(x, N, C || M);
      });
    }
    return O(k, new o.default.List()), S;
  };
  Fo.removeIsLockedInTree = c;
  var l = function(k) {
    var S = k;
    function O(I, D, M, N) {
      if (I) {
        var C = I.get("path"), P = I.get("id"), x = P || N, w = D.push(x);
        (!C || !C.equals(w)) && (S = S.setIn(r(w, "path"), w)), P || (S = S.setIn(r(w, "id"), x));
        var E = I.get("children1");
        E && (E.constructor.name == "Map" && (S = S.setIn(r(w, "children1"), new o.default.OrderedMap(E))), E.map(function(T, z) {
          O(T, w, M + 1, z);
        }));
      }
    }
    return O(k, new o.default.List(), 0), S;
  };
  Fo.fixPathsInTree = l;
  var d = function(k) {
    var S = k;
    function O(I, D, M, N) {
      if (!I)
        return !1;
      var C = I.get("id") || N, P = D.push(C), x = I.get("children1");
      if (x) {
        var w = x.map(function(E, T) {
          return O(E, P, M + 1, T);
        }).reduce(function(E, T) {
          return E && T;
        }, !0);
        if ((x.size == 0 || w) && M > 0)
          return S = S.deleteIn(r(P)), !0;
      }
      return !1;
    }
    return O(k, new o.default.List(), 0), S;
  };
  Fo.fixEmptyGroupsInTree = d;
  var u = function(k) {
    var S = [], O = {}, I = 0;
    function D(x, w, E, T, z, j, q, V, F) {
      var L = x.get("type"), U = x.get("collapsed"), W = x.get("id"), H = x.get("children1"), Q = x.getIn(["properties", "isLocked"]), X = H ? H.map(function(te, ue) {
        return ue;
      }) : null, re = L == "rule_group", Z = !z && (!H || re), ee = S.length, J = I;
      if (S.push(W), E || (I += 1), q.height = (q.height || 0) + 1, O[W] = {
        type: L,
        parent: w.length ? w[w.length - 1] : null,
        parentType: V,
        caseId: L == "case_group" ? W : F,
        isDefaultCase: L == "case_group" && !H,
        path: w.concat(W),
        lev: j,
        leaf: !H,
        index: ee,
        id: W,
        children: X,
        leafsCount: 0,
        _top: ee,
        _height: ce - ee,
        top: E ? null : J,
        height: de,
        bottom: (E ? null : J) + de,
        collapsed: U,
        node: x,
        isLocked: Q || T
      }, H) {
        var oe = {};
        H.map(function(te, ue) {
          D(te, w.concat(W), E || U, T || Q, z || re, j + 1, oe, L, L == "case_group" ? W : F);
        }), U || (q.height = (q.height || 0) + (oe.height || 0));
      }
      F && Z && O[F].leafsCount++;
      var ce = S.length, de = q.height;
      Object.assign(O[W], {
        _height: ce - ee,
        height: de,
        bottom: (E ? null : J) + de
      });
    }
    D(k, [], !1, !1, !1, 0, {}, null, null);
    for (var M = 0; M < S.length; M++) {
      var N = M > 0 ? S[M - 1] : null, C = M < S.length - 1 ? S[M + 1] : null, P = O[S[M]];
      P.prev = N, P.next = C;
    }
    return {
      flat: S,
      items: O
    };
  };
  Fo.getFlatTree = u;
  var _ = function(k) {
    if (!k)
      return -1;
    var S = 0;
    function O(I, D, M) {
      var N, C, P;
      typeof I.get == "function" ? (N = I.get("id"), C = I.get("children1"), P = I.get("type")) : (N = I.id, C = I.children1, P = I.type);
      var x = P == "rule_group";
      S++, C && !x && C.map(function(w, E) {
        O(w, D.concat(N));
      });
    }
    return O(k, []), S - 1;
  };
  Fo.getTotalReordableNodesCountInTree = _;
  var p = function(k) {
    if (!k)
      return -1;
    var S = 0;
    function O(I, D, M) {
      var N, C, P;
      typeof I.get == "function" ? (N = I.get("id"), C = I.get("children1"), P = I.get("type")) : (N = I.id, C = I.children1, P = I.type);
      var x = P == "rule_group";
      C && !x ? C.map(function(w, E) {
        O(w, D.concat(N));
      }) : S++;
    }
    return O(k, []), S;
  };
  Fo.getTotalRulesCountInTree = p;
  var f = function(k) {
    var S = [];
    function O(I, D, M) {
      var N = I.get("id"), C = I.get("children1"), P = I.getIn(["properties", "valueError"]), x = I.getIn(["properties", "field"]);
      P && P.size > 0 && P.filter(function(w) {
        return w != null;
      }).size > 0 && S.push(x), C && C.map(function(w, E) {
        O(w, D.concat(N));
      });
    }
    return k && O(k, []), Array.from(new Set(S));
  };
  Fo.getTreeBadFields = f;
  var g = function(k) {
    var S = k;
    function O(I, D) {
      I.path && delete I.path, D && delete I.id;
      var M = I.properties;
      M && M.operatorOptions == null && delete M.operatorOptions;
      var N = I.children1;
      if (N)
        for (var C in N)
          O(N[C], C);
    }
    return O(k, null), S;
  };
  Fo.getLightTree = g;
  var h = function(k) {
    var S = [], O = k.get("children1");
    return O && O.map(function(I) {
      var D = I.getIn(["properties", "value"]), M;
      D && D.size == 1 ? (M = D.get(0), Array.isArray(M) && M.length == 0 && (M = null)) : M = null, S = [].concat((0, t.default)(S), [M]);
    }), S;
  };
  Fo.getSwitchValues = h;
  var b = function(k) {
    return !k.get("children1") || k.get("children1").size == 0;
  };
  Fo.isEmptyTree = b;
  var v = function(k, S) {
    return k.getIn(r(S, "children1")).size > 0;
  };
  return Fo.hasChildren = v, Fo;
}
var ii = {}, X5 = {}, jee;
function _m() {
  return jee || (jee = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = 0, n = function() {
      var r = ((/* @__PURE__ */ new Date()).getTime().toString(16) + "FF").substr(0, 11), i = "ssssssss-xxxx-4xxx-yxxx-x".replace(/[xys]/g, function(a) {
        var s = a === "s" ? Math.floor(Math.random() * 16) : t++ & 15, c = a === "x" ? s : s & 3 | 8;
        return c.toString(16);
      });
      return i + r;
    };
    e.default = n;
  }(X5)), X5;
}
var qi = {}, eP, Fee;
function aid() {
  if (Fee)
    return eP;
  Fee = 1;
  var e = zC;
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return eP = t, eP;
}
var tP, Vee;
function sid() {
  if (Vee)
    return tP;
  Vee = 1;
  function e(t) {
    var n = this.__data__, o = n.delete(t);
    return this.size = n.size, o;
  }
  return tP = e, tP;
}
var nP, Bee;
function cid() {
  if (Bee)
    return nP;
  Bee = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return nP = e, nP;
}
var oP, Uee;
function lid() {
  if (Uee)
    return oP;
  Uee = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return oP = e, oP;
}
var rP, Wee;
function did() {
  if (Wee)
    return rP;
  Wee = 1;
  var e = zC, t = KF, n = YF, o = 200;
  function r(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < o - 1)
        return c.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(c);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return rP = r, rP;
}
var iP, Gee;
function JC() {
  if (Gee)
    return iP;
  Gee = 1;
  var e = zC, t = aid(), n = sid(), o = cid(), r = lid(), i = did();
  function a(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = o, a.prototype.has = r, a.prototype.set = i, iP = a, iP;
}
var aP, Hee;
function k0e() {
  if (Hee)
    return aP;
  Hee = 1;
  var e = hg, t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return aP = t, aP;
}
var sP, Kee;
function XC() {
  if (Kee)
    return sP;
  Kee = 1;
  var e = k0e();
  function t(n, o, r) {
    o == "__proto__" && e ? e(n, o, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : n[o] = r;
  }
  return sP = t, sP;
}
var cP, Yee;
function S0e() {
  if (Yee)
    return cP;
  Yee = 1;
  var e = XC(), t = pk();
  function n(o, r, i) {
    (i !== void 0 && !t(o[r], i) || i === void 0 && !(r in o)) && e(o, r, i);
  }
  return cP = n, cP;
}
var lP, Zee;
function uid() {
  if (Zee)
    return lP;
  Zee = 1;
  function e(t) {
    return function(n, o, r) {
      for (var i = -1, a = Object(n), s = r(n), c = s.length; c--; ) {
        var l = s[t ? c : ++i];
        if (o(a[l], l, a) === !1)
          break;
      }
      return n;
    };
  }
  return lP = e, lP;
}
var dP, Qee;
function x0e() {
  if (Qee)
    return dP;
  Qee = 1;
  var e = uid(), t = e();
  return dP = t, dP;
}
var w$ = { exports: {} };
w$.exports;
var Jee;
function E0e() {
  return Jee || (Jee = 1, function(e, t) {
    var n = gd, o = t && !t.nodeType && t, r = o && !0 && e && !e.nodeType && e, i = r && r.exports === o, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function c(l, d) {
      if (d)
        return l.slice();
      var u = l.length, _ = s ? s(u) : new l.constructor(u);
      return l.copy(_), _;
    }
    e.exports = c;
  }(w$, w$.exports)), w$.exports;
}
var uP, Xee;
function T0e() {
  if (Xee)
    return uP;
  Xee = 1;
  var e = gd, t = e.Uint8Array;
  return uP = t, uP;
}
var _P, ete;
function Y8() {
  if (ete)
    return _P;
  ete = 1;
  var e = T0e();
  function t(n) {
    var o = new n.constructor(n.byteLength);
    return new e(o).set(new e(n)), o;
  }
  return _P = t, _P;
}
var pP, tte;
function A0e() {
  if (tte)
    return pP;
  tte = 1;
  var e = Y8();
  function t(n, o) {
    var r = o ? e(n.buffer) : n.buffer;
    return new n.constructor(r, n.byteOffset, n.length);
  }
  return pP = t, pP;
}
var mP, nte;
function _id() {
  if (nte)
    return mP;
  nte = 1;
  var e = Al, t = Object.create, n = /* @__PURE__ */ function() {
    function o() {
    }
    return function(r) {
      if (!e(r))
        return {};
      if (t)
        return t(r);
      o.prototype = r;
      var i = new o();
      return o.prototype = void 0, i;
    };
  }();
  return mP = n, mP;
}
var fP, ote;
function Z8() {
  if (ote)
    return fP;
  ote = 1;
  var e = nge, t = e(Object.getPrototypeOf, Object);
  return fP = t, fP;
}
var gP, rte;
function C0e() {
  if (rte)
    return gP;
  rte = 1;
  var e = _id(), t = Z8(), n = Fj;
  function o(r) {
    return typeof r.constructor == "function" && !n(r) ? e(t(r)) : {};
  }
  return gP = o, gP;
}
var hP, ite;
function pid() {
  if (ite)
    return hP;
  ite = 1;
  var e = QA, t = I_;
  function n(o) {
    return t(o) && e(o);
  }
  return hP = n, hP;
}
var vP, ate;
function z0e() {
  if (ate)
    return vP;
  ate = 1;
  var e = lb, t = Z8(), n = I_, o = "[object Object]", r = Function.prototype, i = Object.prototype, a = r.toString, s = i.hasOwnProperty, c = a.call(Object);
  function l(d) {
    if (!n(d) || e(d) != o)
      return !1;
    var u = t(d);
    if (u === null)
      return !0;
    var _ = s.call(u, "constructor") && u.constructor;
    return typeof _ == "function" && _ instanceof _ && a.call(_) == c;
  }
  return vP = l, vP;
}
var bP, ste;
function O0e() {
  if (ste)
    return bP;
  ste = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return bP = e, bP;
}
var yP, cte;
function Q8() {
  if (cte)
    return yP;
  cte = 1;
  var e = XC(), t = pk(), n = Object.prototype, o = n.hasOwnProperty;
  function r(i, a, s) {
    var c = i[a];
    (!(o.call(i, a) && t(c, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return yP = r, yP;
}
var $P, lte;
function zb() {
  if (lte)
    return $P;
  lte = 1;
  var e = Q8(), t = XC();
  function n(o, r, i, a) {
    var s = !i;
    i || (i = {});
    for (var c = -1, l = r.length; ++c < l; ) {
      var d = r[c], u = a ? a(i[d], o[d], d, i, o) : void 0;
      u === void 0 && (u = o[d]), s ? t(i, d, u) : e(i, d, u);
    }
    return i;
  }
  return $P = n, $P;
}
var wP, dte;
function mid() {
  if (dte)
    return wP;
  dte = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var o in Object(t))
        n.push(o);
    return n;
  }
  return wP = e, wP;
}
var kP, ute;
function fid() {
  if (ute)
    return kP;
  ute = 1;
  var e = Al, t = Fj, n = mid(), o = Object.prototype, r = o.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), c = [];
    for (var l in a)
      l == "constructor" && (s || !r.call(a, l)) || c.push(l);
    return c;
  }
  return kP = i, kP;
}
var SP, _te;
function Sk() {
  if (_te)
    return SP;
  _te = 1;
  var e = tge, t = fid(), n = QA;
  function o(r) {
    return n(r) ? e(r, !0) : t(r);
  }
  return SP = o, SP;
}
var xP, pte;
function gid() {
  if (pte)
    return xP;
  pte = 1;
  var e = zb(), t = Sk();
  function n(o) {
    return e(o, t(o));
  }
  return xP = n, xP;
}
var EP, mte;
function hid() {
  if (mte)
    return EP;
  mte = 1;
  var e = S0e(), t = E0e(), n = A0e(), o = Qfe, r = C0e(), i = KA, a = hd, s = pid(), c = YA, l = Vj, d = Al, u = z0e(), _ = jj, p = O0e(), f = gid();
  function g(h, b, v, $, k, S, O) {
    var I = p(h, v), D = p(b, v), M = O.get(D);
    if (M) {
      e(h, v, M);
      return;
    }
    var N = S ? S(I, D, v + "", h, b, O) : void 0, C = N === void 0;
    if (C) {
      var P = a(D), x = !P && c(D), w = !P && !x && _(D);
      N = D, P || x || w ? a(I) ? N = I : s(I) ? N = o(I) : x ? (C = !1, N = t(D, !0)) : w ? (C = !1, N = n(D, !0)) : N = [] : u(D) || i(D) ? (N = I, i(I) ? N = f(I) : (!d(I) || l(I)) && (N = r(D))) : C = !1;
    }
    C && (O.set(D, N), k(N, D, $, S, O), O.delete(D)), e(h, v, N);
  }
  return EP = g, EP;
}
var TP, fte;
function P0e() {
  if (fte)
    return TP;
  fte = 1;
  var e = JC(), t = S0e(), n = x0e(), o = hid(), r = Al, i = Sk(), a = O0e();
  function s(c, l, d, u, _) {
    c !== l && n(l, function(p, f) {
      if (_ || (_ = new e()), r(p))
        o(c, l, f, d, s, u, _);
      else {
        var g = u ? u(a(c, f), p, f + "", c, l, _) : void 0;
        g === void 0 && (g = p), t(c, f, g);
      }
    }, i);
  }
  return TP = s, TP;
}
var AP, gte;
function J8() {
  if (gte)
    return AP;
  gte = 1;
  function e(t) {
    return t;
  }
  return AP = e, AP;
}
var CP, hte;
function vid() {
  if (hte)
    return CP;
  hte = 1;
  function e(t, n, o) {
    switch (o.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, o[0]);
      case 2:
        return t.call(n, o[0], o[1]);
      case 3:
        return t.call(n, o[0], o[1], o[2]);
    }
    return t.apply(n, o);
  }
  return CP = e, CP;
}
var zP, vte;
function I0e() {
  if (vte)
    return zP;
  vte = 1;
  var e = vid(), t = Math.max;
  function n(o, r, i) {
    return r = t(r === void 0 ? o.length - 1 : r, 0), function() {
      for (var a = arguments, s = -1, c = t(a.length - r, 0), l = Array(c); ++s < c; )
        l[s] = a[r + s];
      s = -1;
      for (var d = Array(r + 1); ++s < r; )
        d[s] = a[s];
      return d[r] = i(l), e(o, this, d);
    };
  }
  return zP = n, zP;
}
var OP, bte;
function bid() {
  if (bte)
    return OP;
  bte = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return OP = e, OP;
}
var PP, yte;
function yid() {
  if (yte)
    return PP;
  yte = 1;
  var e = bid(), t = k0e(), n = J8(), o = t ? function(r, i) {
    return t(r, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return PP = o, PP;
}
var IP, $te;
function $id() {
  if ($te)
    return IP;
  $te = 1;
  var e = 800, t = 16, n = Date.now;
  function o(r) {
    var i = 0, a = 0;
    return function() {
      var s = n(), c = t - (s - a);
      if (a = s, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return r.apply(void 0, arguments);
    };
  }
  return IP = o, IP;
}
var RP, wte;
function R0e() {
  if (wte)
    return RP;
  wte = 1;
  var e = yid(), t = $id(), n = t(e);
  return RP = n, RP;
}
var NP, kte;
function wid() {
  if (kte)
    return NP;
  kte = 1;
  var e = J8(), t = I0e(), n = R0e();
  function o(r, i) {
    return n(t(r, i, e), r + "");
  }
  return NP = o, NP;
}
var DP, Ste;
function N0e() {
  if (Ste)
    return DP;
  Ste = 1;
  var e = pk(), t = QA, n = ZA, o = Al;
  function r(i, a, s) {
    if (!o(s))
      return !1;
    var c = typeof a;
    return (c == "number" ? t(s) && n(a, s.length) : c == "string" && a in s) ? e(s[a], i) : !1;
  }
  return DP = r, DP;
}
var MP, xte;
function D0e() {
  if (xte)
    return MP;
  xte = 1;
  var e = wid(), t = N0e();
  function n(o) {
    return e(function(r, i) {
      var a = -1, s = i.length, c = s > 1 ? i[s - 1] : void 0, l = s > 2 ? i[2] : void 0;
      for (c = o.length > 3 && typeof c == "function" ? (s--, c) : void 0, l && t(i[0], i[1], l) && (c = s < 3 ? void 0 : c, s = 1), r = Object(r); ++a < s; ) {
        var d = i[a];
        d && o(r, d, a, c);
      }
      return r;
    });
  }
  return MP = n, MP;
}
var LP, Ete;
function kid() {
  if (Ete)
    return LP;
  Ete = 1;
  var e = P0e(), t = D0e(), n = t(function(o, r, i) {
    e(o, r, i);
  });
  return LP = n, LP;
}
var qP, Tte;
function Sid() {
  if (Tte)
    return qP;
  Tte = 1;
  var e = P0e(), t = D0e(), n = t(function(o, r, i, a) {
    e(o, r, i, a);
  });
  return qP = n, qP;
}
var Qy = {}, jP = {}, FP = {}, Xo = {}, xn = {}, Ate;
function Sr() {
  if (Ate)
    return xn;
  Ate = 1;
  var e = {}, t = Rt, n = Yn;
  Object.defineProperty(xn, "__esModule", {
    value: !0
  }), xn.applyToJS = U, xn.mapListValues = xn.logger = xn.listValuesToArray = xn.isJsonLogic = xn.isImmutable = xn.immutableEqual = xn.getValueInListValues = xn.getTitleInListValues = xn.getLogger = xn.getItemInListValues = xn.getFirstDefined = xn.flatizeTreeData = xn.escapeRegExp = xn.eqSet = xn.eqArrSet = xn.defaultValue = xn.defaultTreeDataMap = xn.deepEqual = void 0, xn.mergeArraysSmart = H, xn.shallowEqual = xn.removePrefixPath = xn.normalizeListValues = void 0, xn.sleep = F, xn.toImmutableList = W, xn.truncateString = void 0;
  var o = t(Tl), r = t(Wc), i = t(Yn), a = c(Ra());
  function s(ee) {
    if (typeof WeakMap != "function")
      return null;
    var J = /* @__PURE__ */ new WeakMap(), oe = /* @__PURE__ */ new WeakMap();
    return (s = function(de) {
      return de ? oe : J;
    })(ee);
  }
  function c(ee, J) {
    if (!J && ee && ee.__esModule)
      return ee;
    if (ee === null || n(ee) !== "object" && typeof ee != "function")
      return { default: ee };
    var oe = s(J);
    if (oe && oe.has(ee))
      return oe.get(ee);
    var ce = {}, de = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var te in ee)
      if (te !== "default" && Object.prototype.hasOwnProperty.call(ee, te)) {
        var ue = de ? Object.getOwnPropertyDescriptor(ee, te) : null;
        ue && (ue.get || ue.set) ? Object.defineProperty(ce, te, ue) : ce[te] = ee[te];
      }
    return ce.default = ee, oe && oe.set(ee, ce), ce;
  }
  function l(ee, J) {
    var oe = typeof Symbol < "u" && ee[Symbol.iterator] || ee["@@iterator"];
    if (!oe) {
      if (Array.isArray(ee) || (oe = d(ee)) || J && ee && typeof ee.length == "number") {
        oe && (ee = oe);
        var ce = 0, de = function() {
        };
        return { s: de, n: function() {
          return ce >= ee.length ? { done: !0 } : { done: !1, value: ee[ce++] };
        }, e: function(me) {
          throw me;
        }, f: de };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var te = !0, ue = !1, le;
    return { s: function() {
      oe = oe.call(ee);
    }, n: function() {
      var me = oe.next();
      return te = me.done, me;
    }, e: function(me) {
      ue = !0, le = me;
    }, f: function() {
      try {
        !te && oe.return != null && oe.return();
      } finally {
        if (ue)
          throw le;
      }
    } };
  }
  function d(ee, J) {
    if (ee) {
      if (typeof ee == "string")
        return u(ee, J);
      var oe = Object.prototype.toString.call(ee).slice(8, -1);
      if (oe === "Object" && ee.constructor && (oe = ee.constructor.name), oe === "Map" || oe === "Set")
        return Array.from(ee);
      if (oe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(oe))
        return u(ee, J);
    }
  }
  function u(ee, J) {
    (J == null || J > ee.length) && (J = ee.length);
    for (var oe = 0, ce = new Array(J); oe < J; oe++)
      ce[oe] = ee[oe];
    return ce;
  }
  var _ = function(J, oe) {
    return typeof J > "u" ? oe : J;
  };
  xn.defaultValue = _;
  var p = function(J, oe, ce) {
    if (!oe || J.length <= oe)
      return J;
    var de = J.substr(0, oe - 1);
    return (ce ? de.substr(0, de.lastIndexOf(" ")) : de) + "...";
  };
  xn.truncateString = p;
  var f = function(J, oe) {
    return J === oe ? !0 : J.equals(oe);
  };
  xn.immutableEqual = f;
  var g = function(J, oe) {
    return J === oe ? !0 : a.Map.isMap(J) ? J.equals(oe) : JSON.stringify(J) == JSON.stringify(oe);
  };
  xn.deepEqual = g;
  var h = function(J, oe) {
    if (J.size !== oe.size)
      return !1;
    var ce = l(J), de;
    try {
      for (ce.s(); !(de = ce.n()).done; ) {
        var te = de.value;
        if (!oe.has(te))
          return !1;
      }
    } catch (ue) {
      ce.e(ue);
    } finally {
      ce.f();
    }
    return !0;
  };
  xn.eqSet = h;
  var b = function(J, oe) {
    return h(new Set(J), new Set(oe));
  };
  xn.eqArrSet = b;
  var v = function(J, oe) {
    var ce = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return J === oe ? !0 : Array.isArray(J) ? $(J, oe, ce) : a.Map.isMap(J) ? J.equals(oe) : (0, i.default)(J) == "object" ? k(J, oe, ce) : J === oe;
  };
  xn.shallowEqual = v;
  function $(ee, J) {
    var oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (ee === J)
      return !0;
    if (!ee || !J)
      return !1;
    var ce = ee.length;
    if (J.length !== ce)
      return !1;
    for (var de = 0; de < ce; de++) {
      var te = oe ? v(ee[de], J[de], oe) : ee[de] === J[de];
      if (!te)
        return !1;
    }
    return !0;
  }
  function k(ee, J) {
    var oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (ee === J)
      return !0;
    if (!ee || !J)
      return !1;
    var ce = Object.keys(ee), de = Object.keys(J), te = ce.length;
    if (de.length !== te)
      return !1;
    for (var ue = 0; ue < te; ue++) {
      var le = ce[ue], se = oe ? v(ee[le], J[le], oe) : ee[le] === J[le];
      if (!se)
        return !1;
    }
    return !0;
  }
  var S = function(J) {
    return J.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&");
  };
  xn.escapeRegExp = S;
  var O = function(J) {
    return (0, i.default)(J) == "object" && J !== null;
  }, I = function(J, oe) {
    return O(J) ? J : {
      value: J,
      title: oe !== void 0 ? oe : J
    };
  }, D = function(J) {
    if (!O(J))
      return J;
    if (Array.isArray(J))
      return J.map(function(te) {
        return I(te);
      });
    var oe = [];
    for (var ce in J) {
      var de = J[ce];
      oe.push(I(ce, de));
    }
    return oe;
  };
  xn.listValuesToArray = D;
  var M = function(J, oe) {
    if (Array.isArray(J)) {
      var ce = J.map(function(de) {
        return I(de);
      });
      return ce.find(function(de) {
        return de.value === oe;
      }) || ce.find(function(de) {
        return "".concat(de.value) === oe;
      });
    } else
      return J[oe] !== void 0 ? I(oe, J[oe]) : void 0;
  };
  xn.getItemInListValues = M;
  var N = function(J, oe) {
    if (J == null)
      return oe;
    var ce = M(J, oe);
    return ce !== void 0 ? ce.title : oe;
  };
  xn.getTitleInListValues = N;
  var C = function(J, oe) {
    if (J == null)
      return oe;
    var ce = M(J, oe);
    return ce !== void 0 ? ce.value : oe;
  };
  xn.getValueInListValues = C;
  var P = function(J, oe) {
    var ce = [];
    if (Array.isArray(J)) {
      var de = l(J), te;
      try {
        for (de.s(); !(te = de.n()).done; ) {
          var ue = te.value, le = oe(I(ue));
          le != null && ce.push(le);
        }
      } catch (pe) {
        de.e(pe);
      } finally {
        de.f();
      }
    } else
      for (var se in J) {
        var me = oe(I(se, J[se]));
        me != null && ce.push(me);
      }
    return ce;
  };
  xn.mapListValues = P;
  var x = {
    id: "value",
    pId: "parent",
    rootPId: void 0
  };
  xn.defaultTreeDataMap = x;
  var w = function(J) {
    var oe = x, ce, de, te = function le(se, me, pe) {
      if (se.children) {
        pe == 1 && (se[oe.pId] = oe.rootPId);
        var be = se.children.length, Se = l(se.children), Ae;
        try {
          for (Se.s(); !(Ae = Se.n()).done; ) {
            var Ze = Ae.value;
            Ze[oe.pId] = se[oe.id], ce++, me.splice(ce, 0, Ze), de++, le(Ze, me, pe + 1);
          }
        } catch (Ge) {
          Se.e(Ge);
        } finally {
          Se.f();
        }
        delete se.children, be == 0 && (me.splice(ce, 1), ce--, de--);
      }
    };
    if (Array.isArray(J))
      for (de = J.length, ce = 0; ce < de; ce++) {
        var ue = J[ce];
        O(ue) && (ue[oe.pId] !== void 0 && ue[oe.pId] != oe.rootPId || te(ue, J, 1));
      }
    return J;
  };
  xn.flatizeTreeData = w;
  var E = function ee(J, oe) {
    var ce = x, de = M(J, oe), te = de ? de[ce.pId] : void 0, ue = te ? J.find(function(le) {
      return le[ce.id] === te;
    }) : void 0;
    return ue ? [ue.value].concat((0, r.default)(ee(J, ue.value))) : [];
  }, T = function(J, oe) {
    var ce = x, de = M(J, oe);
    return de ? J.filter(function(te) {
      return te[ce.pId] === de[ce.id];
    }).map(function(te) {
      return te.value;
    }) : [];
  }, z = function(J, oe, ce) {
    var de = l(J), te;
    try {
      for (de.s(); !(te = de.n()).done; ) {
        var ue = te.value;
        if (ue.path = E(J, ue.value), oe.treeSelectOnlyLeafs != !1) {
          var le = T(J, ue.value);
          ce || (ue.selectable = le.length == 0);
        }
      }
    } catch (se) {
      de.e(se);
    } finally {
      de.f();
    }
    return J;
  }, j = function(J, oe, ce) {
    var de = ["treeselect", "treemultiselect"].includes(oe), te = ["multiselect", "treemultiselect"].includes(oe);
    return de && (J = D(J), J = w(J), J = z(J, ce, te)), J;
  };
  xn.normalizeListValues = j;
  var q = function(J, oe) {
    if (!J)
      return J;
    for (var ce = !0, de = 0; de < oe.length; de++) {
      var te = oe[de];
      if (!(J[de] !== void 0 && te == J[de])) {
        ce = !1;
        break;
      }
    }
    return ce ? J.slice(oe.length) : J;
  };
  xn.removePrefixPath = q;
  var V = function(J) {
    return (0, i.default)(J) === "object" && J !== null && !Array.isArray(J) && Object.keys(J).length === 1;
  };
  xn.isJsonLogic = V;
  function F(ee) {
    return new Promise(function(J) {
      setTimeout(J, ee);
    });
  }
  var L = function(J) {
    return (0, i.default)(J) === "object" && J !== null && typeof J.toJS == "function";
  };
  xn.isImmutable = L;
  function U(ee) {
    return L(ee) ? ee.toJS() : ee;
  }
  function W(ee) {
    return L(ee) ? ee : new a.default.List(ee);
  }
  function H(ee, J) {
    return ee || (ee = []), J || (J = []), J.map(function(oe) {
      return [oe, ee.indexOf(oe)];
    }).map(function(oe, ce, de) {
      var te = (0, o.default)(oe, 2), ue = te[0], le = te[1];
      if (le == -1) {
        var se = de.slice(ce + 1), me = de.slice(0, ce), pe = me.reverse().find(function(Se) {
          var Ae = (0, o.default)(Se, 2);
          Ae[0];
          var Ze = Ae[1];
          return Ze != -1;
        }), be = se.find(function(Se) {
          var Ae = (0, o.default)(Se, 2);
          Ae[0];
          var Ze = Ae[1];
          return Ze != -1;
        });
        return be ? [ue, "before", be[0]] : pe ? [ue, "after", pe[0]] : [ue, "append", null];
      } else
        return null;
    }).filter(function(oe) {
      return oe !== null;
    }).reduce(function(oe, ce) {
      var de = (0, o.default)(ce, 3), te = de[0], ue = de[1], le = de[2], se = oe.indexOf(le);
      return oe.indexOf(te) == -1 && (se > -1 ? oe.splice(se + (ue == "after" ? 1 : 0), 0, te) : oe.splice(ue == "append" ? 1 / 0 : 0, 0, te)), oe;
    }, ee.slice());
  }
  var Q = function() {
    return process && e && !1;
  }, X = function() {
    var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, oe = J ?? Q();
    return oe ? console : {
      error: function() {
      },
      log: function() {
      },
      warn: function() {
      },
      debug: function() {
      },
      info: function() {
      }
    };
  };
  xn.getLogger = X;
  var re = function() {
    for (var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], oe, ce = 0; ce < J.length; ce++) {
      var de = J[ce];
      if (de !== void 0) {
        oe = de;
        break;
      }
    }
    return oe;
  };
  xn.getFirstDefined = re;
  var Z = X();
  return xn.logger = Z, xn;
}
var Dm = {}, VP, Cte;
function xid() {
  if (Cte)
    return VP;
  Cte = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length; ++o < r && n(t[o], o, t) !== !1; )
      ;
    return t;
  }
  return VP = e, VP;
}
var BP, zte;
function Eid() {
  if (zte)
    return BP;
  zte = 1;
  var e = zb(), t = R_;
  function n(o, r) {
    return o && e(r, t(r), o);
  }
  return BP = n, BP;
}
var UP, Ote;
function Tid() {
  if (Ote)
    return UP;
  Ote = 1;
  var e = zb(), t = Sk();
  function n(o, r) {
    return o && e(r, t(r), o);
  }
  return UP = n, UP;
}
var WP, Pte;
function Aid() {
  if (Pte)
    return WP;
  Pte = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length, i = 0, a = []; ++o < r; ) {
      var s = t[o];
      n(s, o, t) && (a[i++] = s);
    }
    return a;
  }
  return WP = e, WP;
}
var GP, Ite;
function M0e() {
  if (Ite)
    return GP;
  Ite = 1;
  function e() {
    return [];
  }
  return GP = e, GP;
}
var HP, Rte;
function X8() {
  if (Rte)
    return HP;
  Rte = 1;
  var e = Aid(), t = M0e(), n = Object.prototype, o = n.propertyIsEnumerable, r = Object.getOwnPropertySymbols, i = r ? function(a) {
    return a == null ? [] : (a = Object(a), e(r(a), function(s) {
      return o.call(a, s);
    }));
  } : t;
  return HP = i, HP;
}
var KP, Nte;
function Cid() {
  if (Nte)
    return KP;
  Nte = 1;
  var e = zb(), t = X8();
  function n(o, r) {
    return e(o, t(o), r);
  }
  return KP = n, KP;
}
var YP, Dte;
function e7() {
  if (Dte)
    return YP;
  Dte = 1;
  function e(t, n) {
    for (var o = -1, r = n.length, i = t.length; ++o < r; )
      t[i + o] = n[o];
    return t;
  }
  return YP = e, YP;
}
var ZP, Mte;
function L0e() {
  if (Mte)
    return ZP;
  Mte = 1;
  var e = e7(), t = Z8(), n = X8(), o = M0e(), r = Object.getOwnPropertySymbols, i = r ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : o;
  return ZP = i, ZP;
}
var QP, Lte;
function zid() {
  if (Lte)
    return QP;
  Lte = 1;
  var e = zb(), t = L0e();
  function n(o, r) {
    return e(o, t(o), r);
  }
  return QP = n, QP;
}
var JP, qte;
function q0e() {
  if (qte)
    return JP;
  qte = 1;
  var e = e7(), t = hd;
  function n(o, r, i) {
    var a = r(o);
    return t(o) ? a : e(a, i(o));
  }
  return JP = n, JP;
}
var XP, jte;
function j0e() {
  if (jte)
    return XP;
  jte = 1;
  var e = q0e(), t = X8(), n = R_;
  function o(r) {
    return e(r, n, t);
  }
  return XP = o, XP;
}
var eI, Fte;
function t7() {
  if (Fte)
    return eI;
  Fte = 1;
  var e = q0e(), t = L0e(), n = Sk();
  function o(r) {
    return e(r, n, t);
  }
  return eI = o, eI;
}
var tI, Vte;
function Oid() {
  if (Vte)
    return tI;
  Vte = 1;
  var e = hg, t = gd, n = e(t, "DataView");
  return tI = n, tI;
}
var nI, Bte;
function Pid() {
  if (Bte)
    return nI;
  Bte = 1;
  var e = hg, t = gd, n = e(t, "Promise");
  return nI = n, nI;
}
var oI, Ute;
function Iid() {
  if (Ute)
    return oI;
  Ute = 1;
  var e = hg, t = gd, n = e(t, "Set");
  return oI = n, oI;
}
var rI, Wte;
function Rid() {
  if (Wte)
    return rI;
  Wte = 1;
  var e = hg, t = gd, n = e(t, "WeakMap");
  return rI = n, rI;
}
var iI, Gte;
function ez() {
  if (Gte)
    return iI;
  Gte = 1;
  var e = Oid(), t = KF, n = Pid(), o = Iid(), r = Rid(), i = lb, a = Ibe(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", d = "[object Set]", u = "[object WeakMap]", _ = "[object DataView]", p = a(e), f = a(t), g = a(n), h = a(o), b = a(r), v = i;
  return (e && v(new e(new ArrayBuffer(1))) != _ || t && v(new t()) != s || n && v(n.resolve()) != l || o && v(new o()) != d || r && v(new r()) != u) && (v = function($) {
    var k = i($), S = k == c ? $.constructor : void 0, O = S ? a(S) : "";
    if (O)
      switch (O) {
        case p:
          return _;
        case f:
          return s;
        case g:
          return l;
        case h:
          return d;
        case b:
          return u;
      }
    return k;
  }), iI = v, iI;
}
var aI, Hte;
function Nid() {
  if (Hte)
    return aI;
  Hte = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(o) {
    var r = o.length, i = new o.constructor(r);
    return r && typeof o[0] == "string" && t.call(o, "index") && (i.index = o.index, i.input = o.input), i;
  }
  return aI = n, aI;
}
var sI, Kte;
function Did() {
  if (Kte)
    return sI;
  Kte = 1;
  var e = Y8();
  function t(n, o) {
    var r = o ? e(n.buffer) : n.buffer;
    return new n.constructor(r, n.byteOffset, n.byteLength);
  }
  return sI = t, sI;
}
var cI, Yte;
function Mid() {
  if (Yte)
    return cI;
  Yte = 1;
  var e = /\w*$/;
  function t(n) {
    var o = new n.constructor(n.source, e.exec(n));
    return o.lastIndex = n.lastIndex, o;
  }
  return cI = t, cI;
}
var lI, Zte;
function Lid() {
  if (Zte)
    return lI;
  Zte = 1;
  var e = cb, t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function o(r) {
    return n ? Object(n.call(r)) : {};
  }
  return lI = o, lI;
}
var dI, Qte;
function qid() {
  if (Qte)
    return dI;
  Qte = 1;
  var e = Y8(), t = Did(), n = Mid(), o = Lid(), r = A0e(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", c = "[object Number]", l = "[object RegExp]", d = "[object Set]", u = "[object String]", _ = "[object Symbol]", p = "[object ArrayBuffer]", f = "[object DataView]", g = "[object Float32Array]", h = "[object Float64Array]", b = "[object Int8Array]", v = "[object Int16Array]", $ = "[object Int32Array]", k = "[object Uint8Array]", S = "[object Uint8ClampedArray]", O = "[object Uint16Array]", I = "[object Uint32Array]";
  function D(M, N, C) {
    var P = M.constructor;
    switch (N) {
      case p:
        return e(M);
      case i:
      case a:
        return new P(+M);
      case f:
        return t(M, C);
      case g:
      case h:
      case b:
      case v:
      case $:
      case k:
      case S:
      case O:
      case I:
        return r(M, C);
      case s:
        return new P();
      case c:
      case u:
        return new P(M);
      case l:
        return n(M);
      case d:
        return new P();
      case _:
        return o(M);
    }
  }
  return dI = D, dI;
}
var uI, Jte;
function jid() {
  if (Jte)
    return uI;
  Jte = 1;
  var e = ez(), t = I_, n = "[object Map]";
  function o(r) {
    return t(r) && e(r) == n;
  }
  return uI = o, uI;
}
var _I, Xte;
function Fid() {
  if (Xte)
    return _I;
  Xte = 1;
  var e = jid(), t = Lj, n = qj, o = n && n.isMap, r = o ? t(o) : e;
  return _I = r, _I;
}
var pI, ene;
function Vid() {
  if (ene)
    return pI;
  ene = 1;
  var e = ez(), t = I_, n = "[object Set]";
  function o(r) {
    return t(r) && e(r) == n;
  }
  return pI = o, pI;
}
var mI, tne;
function Bid() {
  if (tne)
    return mI;
  tne = 1;
  var e = Vid(), t = Lj, n = qj, o = n && n.isSet, r = o ? t(o) : e;
  return mI = r, mI;
}
var fI, nne;
function Uid() {
  if (nne)
    return fI;
  nne = 1;
  var e = JC(), t = xid(), n = Q8(), o = Eid(), r = Tid(), i = E0e(), a = Qfe, s = Cid(), c = zid(), l = j0e(), d = t7(), u = ez(), _ = Nid(), p = qid(), f = C0e(), g = hd, h = YA, b = Fid(), v = Al, $ = Bid(), k = R_, S = Sk(), O = 1, I = 2, D = 4, M = "[object Arguments]", N = "[object Array]", C = "[object Boolean]", P = "[object Date]", x = "[object Error]", w = "[object Function]", E = "[object GeneratorFunction]", T = "[object Map]", z = "[object Number]", j = "[object Object]", q = "[object RegExp]", V = "[object Set]", F = "[object String]", L = "[object Symbol]", U = "[object WeakMap]", W = "[object ArrayBuffer]", H = "[object DataView]", Q = "[object Float32Array]", X = "[object Float64Array]", re = "[object Int8Array]", Z = "[object Int16Array]", ee = "[object Int32Array]", J = "[object Uint8Array]", oe = "[object Uint8ClampedArray]", ce = "[object Uint16Array]", de = "[object Uint32Array]", te = {};
  te[M] = te[N] = te[W] = te[H] = te[C] = te[P] = te[Q] = te[X] = te[re] = te[Z] = te[ee] = te[T] = te[z] = te[j] = te[q] = te[V] = te[F] = te[L] = te[J] = te[oe] = te[ce] = te[de] = !0, te[x] = te[w] = te[U] = !1;
  function ue(le, se, me, pe, be, Se) {
    var Ae, Ze = se & O, Ge = se & I, rt = se & D;
    if (me && (Ae = be ? me(le, pe, be, Se) : me(le)), Ae !== void 0)
      return Ae;
    if (!v(le))
      return le;
    var qe = g(le);
    if (qe) {
      if (Ae = _(le), !Ze)
        return a(le, Ae);
    } else {
      var Xe = u(le), lt = Xe == w || Xe == E;
      if (h(le))
        return i(le, Ze);
      if (Xe == j || Xe == M || lt && !be) {
        if (Ae = Ge || lt ? {} : f(le), !Ze)
          return Ge ? c(le, r(Ae, le)) : s(le, o(Ae, le));
      } else {
        if (!te[Xe])
          return be ? le : {};
        Ae = p(le, Xe, Ze);
      }
    }
    Se || (Se = new e());
    var Et = Se.get(le);
    if (Et)
      return Et;
    Se.set(le, Ae), $(le) ? le.forEach(function(Dt) {
      Ae.add(ue(Dt, se, me, Dt, le, Se));
    }) : b(le) && le.forEach(function(Dt, mt) {
      Ae.set(mt, ue(Dt, se, me, mt, le, Se));
    });
    var wt = rt ? Ge ? d : l : Ge ? S : k, nn = qe ? void 0 : wt(le);
    return t(nn || le, function(Dt, mt) {
      nn && (mt = Dt, Dt = le[mt]), n(Ae, mt, ue(Dt, se, me, mt, le, Se));
    }), Ae;
  }
  return fI = ue, fI;
}
var gI, one;
function xk() {
  if (one)
    return gI;
  one = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return gI = e, gI;
}
var hI, rne;
function Wid() {
  if (rne)
    return hI;
  rne = 1;
  function e(t, n, o) {
    var r = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), o = o > i ? i : o, o < 0 && (o += i), i = n > o ? 0 : o - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++r < i; )
      a[r] = t[r + n];
    return a;
  }
  return hI = e, hI;
}
var vI, ine;
function Gid() {
  if (ine)
    return vI;
  ine = 1;
  var e = PC, t = Wid();
  function n(o, r) {
    return r.length < 2 ? o : e(o, t(r, 0, -1));
  }
  return vI = n, vI;
}
var bI, ane;
function Hid() {
  if (ane)
    return bI;
  ane = 1;
  var e = yb, t = xk(), n = Gid(), o = $b;
  function r(i, a) {
    return a = e(a, i), i = n(i, a), i == null || delete i[o(t(a))];
  }
  return bI = r, bI;
}
var yI, sne;
function Kid() {
  if (sne)
    return yI;
  sne = 1;
  var e = z0e();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return yI = t, yI;
}
var $I, cne;
function Yid() {
  if (cne)
    return $I;
  cne = 1;
  var e = cb, t = KA, n = hd, o = e ? e.isConcatSpreadable : void 0;
  function r(i) {
    return n(i) || t(i) || !!(o && i && i[o]);
  }
  return $I = r, $I;
}
var wI, lne;
function Zid() {
  if (lne)
    return wI;
  lne = 1;
  var e = e7(), t = Yid();
  function n(o, r, i, a, s) {
    var c = -1, l = o.length;
    for (i || (i = t), s || (s = []); ++c < l; ) {
      var d = o[c];
      r > 0 && i(d) ? r > 1 ? n(d, r - 1, i, a, s) : e(s, d) : a || (s[s.length] = d);
    }
    return s;
  }
  return wI = n, wI;
}
var kI, dne;
function Qid() {
  if (dne)
    return kI;
  dne = 1;
  var e = Zid();
  function t(n) {
    var o = n == null ? 0 : n.length;
    return o ? e(n, 1) : [];
  }
  return kI = t, kI;
}
var SI, une;
function F0e() {
  if (une)
    return SI;
  une = 1;
  var e = Qid(), t = I0e(), n = R0e();
  function o(r) {
    return n(t(r, void 0, e), r + "");
  }
  return SI = o, SI;
}
var xI, _ne;
function F_() {
  if (_ne)
    return xI;
  _ne = 1;
  var e = Dj, t = Uid(), n = Hid(), o = yb, r = zb(), i = Kid(), a = F0e(), s = t7(), c = 1, l = 2, d = 4, u = a(function(_, p) {
    var f = {};
    if (_ == null)
      return f;
    var g = !1;
    p = e(p, function(b) {
      return b = o(b, _), g || (g = b.length > 1), b;
    }), r(_, s(_), f), g && (f = t(f, c | l | d, i));
    for (var h = p.length; h--; )
      n(f, p[h]);
    return f;
  });
  return xI = u, xI;
}
var pne;
function Ek() {
  if (pne)
    return Dm;
  pne = 1;
  var e = Rt;
  Object.defineProperty(Dm, "__esModule", {
    value: !0
  }), Dm.validateValue = Dm.validateTree = void 0;
  var t = e(Wc), n = e(Tl), o = e(Yn), r = Br(), i = Hi(), a = Sr(), s = Ns(), c = e(F_()), l = Ra(), d = function(O) {
    return (0, o.default)(O) == "object" && O !== null && Array.isArray(O) ? "array" : (0, o.default)(O);
  }, u = function(O, I) {
    return d(O) == I || I == "number" && !isNaN(O);
  }, _ = function(O, I, D, M, N, C) {
    N === void 0 && (N = D.settings.removeEmptyGroupsOnLoad), C === void 0 && (C = D.settings.removeIncompleteRulesOnLoad);
    var P = {
      config: D,
      oldConfig: M,
      removeEmptyGroups: N,
      removeIncompleteRules: C
    };
    return p(O, [], null, {}, P);
  };
  Dm.validateTree = _;
  function p(S, O, I, D, M) {
    var N = S.get("type"), C = S.get("children1");
    return (N === "group" || N === "rule_group" || N == "case_group" || N == "switch_group") && C && C.size ? f(S, O, I, D, M) : N === "rule" ? g(S, O, I, D, M) : S;
  }
  function f(S, O, I, D, M) {
    var N = M.removeEmptyGroups, C = S.get("id"), P = S.get("children1"), x = P;
    !C && I && (C = I, S = S.set("id", C), D.sanitized = !0);
    var w = {};
    P = P.map(function(T, z) {
      return p(T, O.concat(C), z, w, M);
    }), N && (P = P.filter(function(T) {
      return T != null;
    }));
    var E = w.sanitized || x.size != P.size;
    return !P.size && N && O.length && (E = !0, S = void 0), E && (D.sanitized = !0), E && S && (S = S.set("children1", P)), S;
  }
  function g(S, O, I, D, M) {
    var N = M.removeIncompleteRules, C = M.config, P = M.oldConfig, x = C.settings.showErrorMessage, w = S.get("id"), E = S.get("properties"), T = E.get("field") || null, z = E.get("operator") || null, j = E.get("operatorOptions"), q = E.get("valueSrc"), V = E.get("value"), F = E.get("valueError"), L = {
      field: T,
      operator: z,
      operatorOptions: j ? j.toJS() : {},
      valueSrc: q ? q.toJS() : null,
      value: V ? V.toJS() : null,
      valueError: F ? F.toJS() : null
    };
    T && z && V && V.includes(void 0), !w && I && (w = I, S = S.set("id", w), D.sanitized = !0);
    var U = T ? (0, r.getFieldConfig)(C, T) : null;
    T && !U && (a.logger.warn("No config for field ".concat(T)), T = null), T == null && (E = ["operator", "operatorOptions", "valueSrc", "value"].reduce(function(ce, de) {
      return ce.delete(de);
    }, E), z = null), (z == "range_between" || z == "range_not_between") && (z = z == "range_between" ? "between" : "not_between", console.info("Fixed operator ".concat(E.get("operator"), " to ").concat(z)), E = E.set("operator", z));
    var W = z ? (0, r.getOperatorConfig)(C, z, T) : null;
    z && !W && (console.warn("No config for operator ".concat(z)), z = null);
    var H = T ? (0, i.getOperatorsForField)(C, T) : [];
    H ? z && H.indexOf(z) == -1 && (z == "is_empty" || z == "is_not_empty" ? (z = z == "is_empty" ? "is_null" : "is_not_null", console.info("Fixed operator ".concat(E.get("operator"), " to ").concat(z, " for ").concat(T)), E = E.set("operator", z)) : (console.warn("Operator ".concat(z, " is not supported for field ").concat(T)), z = null)) : (console.warn("Type of field ".concat(T, " is not supported")), z = null), z == null && (E = E.delete("operatorOptions"), E = E.delete("valueSrc"), E = E.delete("value")), j = E.get("operatorOptions"), z && (0, a.defaultValue)(W.cardinality, 1), !z || j && !W.options ? (j = null, E = E.delete("operatorOptions")) : z && !j && W.options && (j = (0, s.defaultOperatorOptions)(C, z, T), E = E.set("operatorOptions", j)), q = E.get("valueSrc"), V = E.get("value");
    var Q = (0, i.getNewValueForFieldOp)(C, P, E, T, z, null, !0), X = Q.newValue, re = Q.newValueSrc, Z = Q.newValueError;
    V = X, q = re, F = Z, E = E.set("value", V), E = E.set("valueSrc", q), x && (E = E.set("valueError", F));
    var ee = {
      field: T,
      operator: z,
      operatorOptions: j ? j.toJS() : {},
      valueSrc: q ? q.toJS() : null,
      value: V ? V.toJS() : null,
      valueError: F ? F.toJS() : null
    }, J = !(0, a.deepEqual)(L, ee), oe = T && z && V && !V.includes(void 0);
    return J && (D.sanitized = !0), !oe && N ? S = void 0 : J && (S = S.set("properties", E)), S;
  }
  var h = function(O, I, D, M, N, C, P, x) {
    var w = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, E = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1, T = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : !0, z = null, j = N;
    if (N != null) {
      if (P == "field") {
        var q = $(I, D, N, P, C, x, O), V = (0, n.default)(q, 2);
        z = V[0], j = V[1];
      } else if (P == "func") {
        var F = k(I, D, N, P, C, x, O, M, E, w), L = (0, n.default)(F, 2);
        z = L[0], j = L[1];
      } else if (P == "value" || !P) {
        var U = v(I, D, N, P, C, x, O, M, E, w), W = (0, n.default)(U, 2);
        z = W[0], j = W[1];
      }
      if (!z) {
        (0, r.getFieldConfig)(O, D);
        var H = (0, i.getWidgetForFieldOp)(O, D, M, P), Q = M ? (0, r.getOperatorConfig)(O, M, D) : null, X = (0, c.default)((0, r.getFieldWidgetConfig)(O, D, M, H, P), ["factory"]), re = P == "field" ? (0, r.getFieldConfig)(O, N) : null, Z = X, ee = X.validateValue;
        if (typeof ee == "function") {
          var J = [j, Z, M, Q];
          P == "field" && J.push(re);
          var oe = ee.apply(void 0, J);
          typeof oe == "boolean" ? oe == !1 && (z = "Invalid value") : z = oe;
        }
      }
    }
    return T && z && console.warn("[RAQB validate]", "Field ".concat(D, ": ").concat(z)), [z, z ? N : j];
  };
  Dm.validateValue = h;
  var b = function(O, I) {
    var D = l.List.isList(O) ? O.toJS() : O instanceof Array ? (0, t.default)(O) : void 0;
    if (D) {
      for (var M = 0; M < D.length; M++) {
        var N = (0, a.getItemInListValues)(I, D[M]);
        if (N == null)
          return ["Value ".concat(O[M], " is not in list of values"), D];
        D[M] = N.value;
      }
      return [null, D];
    } else {
      var C = (0, a.getItemInListValues)(I, O);
      return C == null ? ["Value ".concat(O, " is not in list of values"), O] : (O = C.value, [null, O]);
    }
  }, v = function(O, I, D, M, N, C, P) {
    var x = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    if (I) {
      var w = (0, r.getFieldConfig)(P, I), E = (0, i.getWidgetForFieldOp)(P, I, x, M), T = P.widgets[E], z = T.type, j = T.jsType, q = w.fieldSettings;
      if (N != z)
        return ["Value should have type ".concat(z, ", but got value of type ").concat(N), D];
      if (j && !u(D, j) && !q.listValues)
        return ["Value should have JS type ".concat(j, ", but got value of type ").concat((0, o.default)(D)), D];
      if (q) {
        var V = C || q.listValues;
        if (V && !q.allowCustomValues)
          return b(D, V);
        if (q.min != null && D < q.min)
          return ["Value ".concat(D, " < min ").concat(q.min), D];
        if (q.max != null && D > q.max)
          return ["Value ".concat(D, " > max ").concat(q.max), D];
      }
    }
    return [null, D];
  }, $ = function(O, I, D, M, N, C, P) {
    var x = P.settings.fieldSeparator, w = (0, o.default)(I) == "object" && (I == null ? void 0 : I._isFuncArg), E = Array.isArray(O) ? O.join(x) : O, T = Array.isArray(D) ? D.join(x) : D, z = (0, r.getFieldConfig)(P, D);
    return z ? T == E && !w ? ["Can't compare field ".concat(O, " with itself"), D] : N && N != z.type ? ["Field ".concat(D, " is of type ").concat(z.type, ", but expected ").concat(N), D] : [null, D] : ["Unknown field ".concat(D), D];
  }, k = function(O, I, D, M, N, C, P) {
    var x = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, w = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, E = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1, T = D;
    if (D) {
      var z = D.get("func");
      if (z) {
        var j = (0, r.getFuncConfig)(P, z);
        if (j) {
          if (N && j.returnType != N)
            return ["Function ".concat(z, " should return value of type ").concat(j.returnType, ", but got ").concat(N), D];
          for (var q in j.args) {
            var V = j.args[q], F = T.get("args"), L = F ? F.get(q) : void 0, U = (0, r.getFieldConfig)(P, V), W = L ? L.get("value") : void 0, H = L ? L.get("valueSrc") : void 0;
            if (W !== void 0) {
              var Q = h(P, O, U, x, W, V.type, H, C, E, w, !1), X = (0, n.default)(Q, 2), re = X[0], Z = X[1];
              if (re !== null)
                if (E)
                  T = T.deleteIn(["args", q]), V.defaultValue !== void 0 && (T = T.setIn(["args", q, "value"], V.defaultValue), T = T.setIn(["args", q, "valueSrc"], "value"));
                else
                  return ["Invalid value of arg ".concat(q, " for func ").concat(z, ": ").concat(re), D];
              else
                Z !== W && (T = T.setIn(["args", q, "value"], Z));
            } else if (w && V.defaultValue === void 0 && !E)
              return ["Value of arg ".concat(q, " for func ").concat(z, " is required"), D];
          }
        } else
          return ["Unknown function ".concat(z), D];
      }
    }
    return [null, T];
  };
  return Dm;
}
var mne;
function Hi() {
  if (mne)
    return Xo;
  mne = 1;
  var e = Rt;
  Object.defineProperty(Xo, "__esModule", {
    value: !0
  }), Xo.getWidgetsForFieldOp = Xo.getWidgetForFieldOp = Xo.getValueSourcesForFieldOp = Xo.getValueLabel = Xo.getOperatorsForField = Xo.getNewValueForFieldOp = Xo.getFuncPathLabels = Xo.getFirstOperator = Xo.getFirstField = Xo.getFieldPathLabels = Xo.getFieldPath = Xo.getFieldPartsConfigs = Xo.formatFieldName = Xo.filterValueSourcesForField = void 0;
  var t = e(Yn), n = e(Wc), o = e(Tl), r = Br(), i = Sr(), a = e(Ra()), s = Ek(), c = e(xk()), l = ["select", "multiselect", "treeselect", "treemultiselect"], d = function(N) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, P = arguments.length > 2 ? arguments[2] : void 0, x = arguments.length > 3 ? arguments[3] : void 0, w = arguments.length > 4 ? arguments[4] : void 0, E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, T = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !0;
    C || (C = N);
    var z = P.get("field"), j = P.get("operator"), q = P.get("value"), V = P.get("valueSrc", new a.default.List()), F = P.get("valueType", new a.default.List()), L = P.get("asyncListValues"), U = N.settings, W = U.convertableWidgets, H = U.clearValueOnChangeField, Q = U.clearValueOnChangeOp, X = U.showErrorMessage, re = (0, r.getOperatorConfig)(N, w, x), Z = w ? (0, i.defaultValue)(re.cardinality, 1) : null, ee = (0, r.getFieldConfig)(C, z), J = (0, r.getFieldConfig)(N, x), oe = z && j && w && q != null && (!E || E == "field" && !H || E == "operator" && !Q) && ee && J && ee.type == J.type;
    oe && l.includes(ee.type) && E == "field" && (oe = !1);
    for (var ce = 0; ce < Z; ce++) {
      var de = V.get(ce) || null, te = I(C, z, j, de), ue = I(N, x, w, de), le = de == "value" ? te : I(C, z, j, "value"), se = de == "value" ? ue : I(N, x, w, "value"), me = se == le || (W[le] || []).includes(se);
      me || (oe = !1);
    }
    j != w && [j, w].includes("proximity") && (oe = !1);
    var pe = (0, r.getFieldWidgetConfig)(N, x, w, null, V.first()), be = O(N, x, w), Se = {}, Ae = Array.from({
      length: Z
    }, function() {
      return null;
    });
    if (oe)
      for (var Ze = function(mt) {
        var bt = q.get(mt), gn = F.get(mt) || null, an = V.get(mt) || null, Mn = be.find(function(Ot) {
          return Ot == an;
        }) != null;
        !Mn && mt > 0 && an == null && (Mn = !0);
        var Ln = !T, un = L, qo = (0, s.validateValue)(N, x, x, w, bt, gn, an, un, T, Ln), cn = (0, o.default)(qo, 2), ln = cn[0], kn = cn[1], gt = !ln;
        if (!gt && X && E != "field")
          Ae[mt] = ln;
        else {
          if (!Mn || !gt)
            return oe = !1, "break";
          T && kn !== bt && (Se[mt] = kn);
        }
      }, Ge = 0; Ge < Z; Ge++) {
        var rt = Ze(Ge);
        if (rt === "break")
          break;
      }
    var qe = null, Xe = null, lt = null, Et = null;
    if (qe = new a.default.List(Array.from({
      length: Z
    }, function(Dt, mt) {
      var bt = void 0;
      if (oe)
        mt < q.size && (bt = q.get(mt), Se[mt] !== void 0 && (bt = Se[mt]));
      else if (Z == 1) {
        var gn;
        bt = (0, i.getFirstDefined)([J == null ? void 0 : J.defaultValue, J == null || (gn = J.fieldSettings) === null || gn === void 0 ? void 0 : gn.defaultValue, pe == null ? void 0 : pe.defaultValue]);
      }
      return bt;
    })), Xe = new a.default.List(Array.from({
      length: Z
    }, function(Dt, mt) {
      var bt = null;
      return oe ? mt < V.size && (bt = V.get(mt)) : (be.length == 1 || be.length > 1) && (bt = be[0]), bt;
    })), X) {
      if (re && re.validateValues && Xe.toJS().filter(function(Dt) {
        return Dt == "value" || Dt == null;
      }).length == Z) {
        var wt = pe && pe.toJS ? qe.toJS().map(function(Dt) {
          return pe.toJS(Dt, pe);
        }) : qe.toJS(), nn = re.validateValues(wt);
        X && Ae.push(nn);
      }
      Et = new a.default.List(Ae);
    }
    return lt = new a.default.List(Array.from({
      length: Z
    }, function(Dt, mt) {
      var bt = null;
      return oe ? mt < F.size && (bt = F.get(mt)) : Z == 1 && pe && pe.type !== void 0 ? bt = pe.type : Z == 1 && J && J.type !== void 0 && (bt = J.type == "!group" ? "number" : J.type), bt;
    })), {
      canReuseValue: oe,
      newValue: qe,
      newValueSrc: Xe,
      newValueType: lt,
      newValueError: Et,
      operatorCardinality: Z
    };
  };
  Xo.getNewValueForFieldOp = d;
  var u = function(N) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, P = N.settings.fieldSeparator, x = typeof C == "string" ? C.split(P) : C, w = C ? (0, r.getFieldRawConfig)(N, C) : N, E = w, T = null, z = [];
    do {
      var j = E === N ? N.fields : E.subfields;
      if (!j || !Object.keys(j).length) {
        E = T = null;
        break;
      }
      T = Object.keys(j)[0], z.push(T), E = j[T];
    } while (E.type == "!struct" || E.type == "!group");
    return (x || []).concat(z).join(P);
  };
  Xo.getFirstField = u;
  var _ = function(N, C) {
    var P = (0, r.getFieldConfig)(N, C), x = P ? P.operators : [];
    return x;
  };
  Xo.getOperatorsForField = _;
  var p = function(N, C) {
    var P = _(N, C);
    return P ? P[0] : null;
  };
  Xo.getFirstOperator = p;
  var f = function(N, C) {
    var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (!N)
      return null;
    var x = C.settings.fieldSeparator, w = Array.isArray(N) ? N : N.split(x);
    return P ? w : w.map(function(E, T, z) {
      return z.slice(0, T + 1);
    }).map(function(E) {
      return E.join(x);
    });
  };
  Xo.getFieldPath = f;
  var g = function(N, C) {
    var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return h(N, C, P, "funcs", "subfields");
  };
  Xo.getFuncPathLabels = g;
  var h = function(N, C) {
    var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, x = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "fields", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "subfields";
    if (!N)
      return null;
    var E = C.settings.fieldSeparator, T = Array.isArray(N) ? N : N.split(E), z = P ? Array.isArray(P) ? P : P.split(E) : [];
    return T.slice(z.length).map(function(j, q, V) {
      return V.slice(0, q + 1);
    }).map(function(j) {
      return [].concat((0, n.default)(z), (0, n.default)(j)).join(E);
    }).map(function(j) {
      var q = (0, r.getFieldRawConfig)(C, j, x, w);
      return q && q.label || q && (0, c.default)(j.split(E));
    }).filter(function(j) {
      return j != null;
    });
  };
  Xo.getFieldPathLabels = h;
  var b = function(N, C) {
    var P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!N)
      return null;
    var x = P && (0, r.getFieldRawConfig)(C, P) || null, w = C.settings.fieldSeparator, E = Array.isArray(N) ? N : N.split(w), T = P ? Array.isArray(P) ? P : P.split(w) : [];
    return E.slice(T.length).map(function(z, j, q) {
      return q.slice(0, j + 1);
    }).map(function(z) {
      return {
        part: [].concat((0, n.default)(T), (0, n.default)(z)).join(w),
        key: z[z.length - 1]
      };
    }).map(function(z) {
      var j = z.part, q = z.key, V = (0, r.getFieldRawConfig)(C, j);
      return {
        key: q,
        cnf: V
      };
    }).map(function(z, j, q) {
      var V = z.key, F = z.cnf, L = j > 0 ? q[j - 1].cnf : x;
      return [V, F, L];
    });
  };
  Xo.getFieldPartsConfigs = b;
  var v = function(N, C, P, x) {
    var w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, E = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, T = C && (0, t.default)(C) == "object" && !!C.func && !!C.arg, z = N.settings.showLabels, j = (0, r.getFieldConfig)(N, C), q = (0, r.getFieldWidgetConfig)(N, C, P, null, w) || {}, V = (0, r.getOperatorConfig)(N, P, C) || {}, F = E ? 1 : V.cardinality, L = null;
    if (F > 1) {
      var U = q.valueLabels || V.valueLabels;
      U && (L = U[x]), L && (0, t.default)(L) != "object" && (L = {
        label: L,
        placeholder: L
      }), L || (L = {
        label: N.settings.valueLabel + " " + (x + 1),
        placeholder: N.settings.valuePlaceholder + " " + (x + 1)
      });
    } else {
      var W = q.valueLabel, H = q.valuePlaceholder;
      T && (W || (W = j.label || C.arg), !H && !z && (H = j.label || C.arg)), L = {
        label: W || N.settings.valueLabel,
        placeholder: H || N.settings.valuePlaceholder
      };
    }
    return L;
  };
  Xo.getValueLabel = v;
  function $(M, N) {
    var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, P = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, x = [], w = [];
    if (!N)
      return {
        widgets: x,
        valueSrcs: w
      };
    var E = (0, t.default)(N) == "object" && (!!N.func && !!N.arg || N._isFuncArg), T = (0, r.getFieldConfig)(M, N), z = C ? M.operators[C] : null;
    if (T && T.widgets) {
      var j = function(L) {
        var U = T.widgets[L], W = M.widgets[L].valueSrc || "value", H = !0;
        if (L == "field" && (H = H && S(M, ["field"], T).length > 0), L == "func" && (H = H && S(M, ["func"], T).length > 0), P == "value" && !U.operators && !E && N != "!case_value" && (H = !1), U.operators && C && (H = H && U.operators.indexOf(C) != -1), P && P != W && P != "const" && (H = !1), z && z.cardinality == 0 && W != "value" && (H = !1), H) {
          x.push(L);
          var Q = T.valueSources && T.valueSources.indexOf(W) != -1;
          z && z.valueSources && z.valueSources.indexOf(W) == -1 && (Q = !1), Q && !w.find(function(X) {
            return X == W;
          }) && w.push(W);
        }
      };
      for (var q in T.widgets)
        j(q);
    }
    var V = function(L) {
      var U = 0;
      return T.preferWidgets ? T.preferWidgets.includes(L) && (U += 10 - T.preferWidgets.indexOf(L)) : L == T.mainWidget && (U += 100), L == "field" && (U -= 1), L == "func" && (U -= 2), U;
    };
    return x.sort(function(F, L) {
      return V(L) - V(F);
    }), {
      widgets: x,
      valueSrcs: w
    };
  }
  var k = function(N, C, P) {
    var x = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = $(N, C, P, x), E = w.widgets;
    return E;
  };
  Xo.getWidgetsForFieldOp = k;
  var S = function(N, C, P) {
    return P ? C.filter(function(x) {
      var w = !0;
      if (x == "field" && N._fieldsCntByType) {
        var E = P._isFuncArg ? 0 : 1;
        w = w && N._fieldsCntByType[P.type] > E;
      }
      return x == "func" && (N._funcsCntByType && (w = w && !!N._funcsCntByType[P.type]), P.funcs && (w = w && P.funcs.length > 0)), w;
    }) : C;
  };
  Xo.filterValueSourcesForField = S;
  var O = function(N, C, P) {
    var x = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = $(N, C, P, null), E = w.valueSrcs, T = S(N, E, x);
    return T;
  };
  Xo.getValueSourcesForFieldOp = O;
  var I = function(N, C, P) {
    var x = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, w = $(N, C, P, x), E = w.widgets, T = null;
    return E.length && (T = E[0]), T;
  };
  Xo.getWidgetForFieldOp = I;
  var D = function(N, C, P) {
    var x = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (N) {
      var w = (0, r.getFieldConfig)(C, N) || {}, E = C.settings.fieldSeparator, T = Array.isArray(N) ? N : N.split(E), z = Array.isArray(N) ? N.join(E) : N;
      if (w.tableName) {
        var j = (0, n.default)(T);
        j[0] = w.tableName, z = j.join(E);
      }
      if (w.fieldName && (z = w.fieldName), x) {
        var q = (0, r.getFieldConfig)(C, x) || {}, V = x;
        q.fieldName && (V = q.fieldName), z.indexOf(V + E) == 0 ? z = z.slice((V + E).length) : P.errors.push("Can't cut group ".concat(V, " from field ").concat(z));
      }
      return z;
    }
  };
  return Xo.formatFieldName = D, Xo;
}
var Fl = {}, EI, fne;
function Jid() {
  if (fne)
    return EI;
  fne = 1;
  var e = x0e(), t = R_;
  function n(o, r) {
    return o && e(o, r, t);
  }
  return EI = n, EI;
}
var TI, gne;
function Xid() {
  if (gne)
    return TI;
  gne = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return TI = t, TI;
}
var AI, hne;
function ead() {
  if (hne)
    return AI;
  hne = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return AI = e, AI;
}
var CI, vne;
function tad() {
  if (vne)
    return CI;
  vne = 1;
  var e = YF, t = Xid(), n = ead();
  function o(r) {
    var i = -1, a = r == null ? 0 : r.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(r[i]);
  }
  return o.prototype.add = o.prototype.push = t, o.prototype.has = n, CI = o, CI;
}
var zI, bne;
function nad() {
  if (bne)
    return zI;
  bne = 1;
  function e(t, n) {
    for (var o = -1, r = t == null ? 0 : t.length; ++o < r; )
      if (n(t[o], o, t))
        return !0;
    return !1;
  }
  return zI = e, zI;
}
var OI, yne;
function oad() {
  if (yne)
    return OI;
  yne = 1;
  function e(t, n) {
    return t.has(n);
  }
  return OI = e, OI;
}
var PI, $ne;
function V0e() {
  if ($ne)
    return PI;
  $ne = 1;
  var e = tad(), t = nad(), n = oad(), o = 1, r = 2;
  function i(a, s, c, l, d, u) {
    var _ = c & o, p = a.length, f = s.length;
    if (p != f && !(_ && f > p))
      return !1;
    var g = u.get(a), h = u.get(s);
    if (g && h)
      return g == s && h == a;
    var b = -1, v = !0, $ = c & r ? new e() : void 0;
    for (u.set(a, s), u.set(s, a); ++b < p; ) {
      var k = a[b], S = s[b];
      if (l)
        var O = _ ? l(S, k, b, s, a, u) : l(k, S, b, a, s, u);
      if (O !== void 0) {
        if (O)
          continue;
        v = !1;
        break;
      }
      if ($) {
        if (!t(s, function(I, D) {
          if (!n($, D) && (k === I || d(k, I, c, l, u)))
            return $.push(D);
        })) {
          v = !1;
          break;
        }
      } else if (!(k === S || d(k, S, c, l, u))) {
        v = !1;
        break;
      }
    }
    return u.delete(a), u.delete(s), v;
  }
  return PI = i, PI;
}
var II, wne;
function rad() {
  if (wne)
    return II;
  wne = 1;
  function e(t) {
    var n = -1, o = Array(t.size);
    return t.forEach(function(r, i) {
      o[++n] = [i, r];
    }), o;
  }
  return II = e, II;
}
var RI, kne;
function iad() {
  if (kne)
    return RI;
  kne = 1;
  function e(t) {
    var n = -1, o = Array(t.size);
    return t.forEach(function(r) {
      o[++n] = r;
    }), o;
  }
  return RI = e, RI;
}
var NI, Sne;
function aad() {
  if (Sne)
    return NI;
  Sne = 1;
  var e = cb, t = T0e(), n = pk(), o = V0e(), r = rad(), i = iad(), a = 1, s = 2, c = "[object Boolean]", l = "[object Date]", d = "[object Error]", u = "[object Map]", _ = "[object Number]", p = "[object RegExp]", f = "[object Set]", g = "[object String]", h = "[object Symbol]", b = "[object ArrayBuffer]", v = "[object DataView]", $ = e ? e.prototype : void 0, k = $ ? $.valueOf : void 0;
  function S(O, I, D, M, N, C, P) {
    switch (D) {
      case v:
        if (O.byteLength != I.byteLength || O.byteOffset != I.byteOffset)
          return !1;
        O = O.buffer, I = I.buffer;
      case b:
        return !(O.byteLength != I.byteLength || !C(new t(O), new t(I)));
      case c:
      case l:
      case _:
        return n(+O, +I);
      case d:
        return O.name == I.name && O.message == I.message;
      case p:
      case g:
        return O == I + "";
      case u:
        var x = r;
      case f:
        var w = M & a;
        if (x || (x = i), O.size != I.size && !w)
          return !1;
        var E = P.get(O);
        if (E)
          return E == I;
        M |= s, P.set(O, I);
        var T = o(x(O), x(I), M, N, C, P);
        return P.delete(O), T;
      case h:
        if (k)
          return k.call(O) == k.call(I);
    }
    return !1;
  }
  return NI = S, NI;
}
var DI, xne;
function sad() {
  if (xne)
    return DI;
  xne = 1;
  var e = j0e(), t = 1, n = Object.prototype, o = n.hasOwnProperty;
  function r(i, a, s, c, l, d) {
    var u = s & t, _ = e(i), p = _.length, f = e(a), g = f.length;
    if (p != g && !u)
      return !1;
    for (var h = p; h--; ) {
      var b = _[h];
      if (!(u ? b in a : o.call(a, b)))
        return !1;
    }
    var v = d.get(i), $ = d.get(a);
    if (v && $)
      return v == a && $ == i;
    var k = !0;
    d.set(i, a), d.set(a, i);
    for (var S = u; ++h < p; ) {
      b = _[h];
      var O = i[b], I = a[b];
      if (c)
        var D = u ? c(I, O, b, a, i, d) : c(O, I, b, i, a, d);
      if (!(D === void 0 ? O === I || l(O, I, s, c, d) : D)) {
        k = !1;
        break;
      }
      S || (S = b == "constructor");
    }
    if (k && !S) {
      var M = i.constructor, N = a.constructor;
      M != N && "constructor" in i && "constructor" in a && !(typeof M == "function" && M instanceof M && typeof N == "function" && N instanceof N) && (k = !1);
    }
    return d.delete(i), d.delete(a), k;
  }
  return DI = r, DI;
}
var MI, Ene;
function cad() {
  if (Ene)
    return MI;
  Ene = 1;
  var e = JC(), t = V0e(), n = aad(), o = sad(), r = ez(), i = hd, a = YA, s = jj, c = 1, l = "[object Arguments]", d = "[object Array]", u = "[object Object]", _ = Object.prototype, p = _.hasOwnProperty;
  function f(g, h, b, v, $, k) {
    var S = i(g), O = i(h), I = S ? d : r(g), D = O ? d : r(h);
    I = I == l ? u : I, D = D == l ? u : D;
    var M = I == u, N = D == u, C = I == D;
    if (C && a(g)) {
      if (!a(h))
        return !1;
      S = !0, M = !1;
    }
    if (C && !M)
      return k || (k = new e()), S || s(g) ? t(g, h, b, v, $, k) : n(g, h, I, b, v, $, k);
    if (!(b & c)) {
      var P = M && p.call(g, "__wrapped__"), x = N && p.call(h, "__wrapped__");
      if (P || x) {
        var w = P ? g.value() : g, E = x ? h.value() : h;
        return k || (k = new e()), $(w, E, b, v, k);
      }
    }
    return C ? (k || (k = new e()), o(g, h, b, v, $, k)) : !1;
  }
  return MI = f, MI;
}
var LI, Tne;
function B0e() {
  if (Tne)
    return LI;
  Tne = 1;
  var e = cad(), t = I_;
  function n(o, r, i, a, s) {
    return o === r ? !0 : o == null || r == null || !t(o) && !t(r) ? o !== o && r !== r : e(o, r, i, a, n, s);
  }
  return LI = n, LI;
}
var qI, Ane;
function lad() {
  if (Ane)
    return qI;
  Ane = 1;
  var e = JC(), t = B0e(), n = 1, o = 2;
  function r(i, a, s, c) {
    var l = s.length, d = l, u = !c;
    if (i == null)
      return !d;
    for (i = Object(i); l--; ) {
      var _ = s[l];
      if (u && _[2] ? _[1] !== i[_[0]] : !(_[0] in i))
        return !1;
    }
    for (; ++l < d; ) {
      _ = s[l];
      var p = _[0], f = i[p], g = _[1];
      if (u && _[2]) {
        if (f === void 0 && !(p in i))
          return !1;
      } else {
        var h = new e();
        if (c)
          var b = c(f, g, p, i, a, h);
        if (!(b === void 0 ? t(g, f, n | o, c, h) : b))
          return !1;
      }
    }
    return !0;
  }
  return qI = r, qI;
}
var jI, Cne;
function U0e() {
  if (Cne)
    return jI;
  Cne = 1;
  var e = Al;
  function t(n) {
    return n === n && !e(n);
  }
  return jI = t, jI;
}
var FI, zne;
function dad() {
  if (zne)
    return FI;
  zne = 1;
  var e = U0e(), t = R_;
  function n(o) {
    for (var r = t(o), i = r.length; i--; ) {
      var a = r[i], s = o[a];
      r[i] = [a, s, e(s)];
    }
    return r;
  }
  return FI = n, FI;
}
var VI, One;
function W0e() {
  if (One)
    return VI;
  One = 1;
  function e(t, n) {
    return function(o) {
      return o == null ? !1 : o[t] === n && (n !== void 0 || t in Object(o));
    };
  }
  return VI = e, VI;
}
var BI, Pne;
function uad() {
  if (Pne)
    return BI;
  Pne = 1;
  var e = lad(), t = dad(), n = W0e();
  function o(r) {
    var i = t(r);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === r || e(a, r, i);
    };
  }
  return BI = o, BI;
}
var UI, Ine;
function _ad() {
  if (Ine)
    return UI;
  Ine = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return UI = e, UI;
}
var WI, Rne;
function pad() {
  if (Rne)
    return WI;
  Rne = 1;
  var e = yb, t = KA, n = hd, o = ZA, r = Mj, i = $b;
  function a(s, c, l) {
    c = e(c, s);
    for (var d = -1, u = c.length, _ = !1; ++d < u; ) {
      var p = i(c[d]);
      if (!(_ = s != null && l(s, p)))
        break;
      s = s[p];
    }
    return _ || ++d != u ? _ : (u = s == null ? 0 : s.length, !!u && r(u) && o(p, u) && (n(s) || t(s)));
  }
  return WI = a, WI;
}
var GI, Nne;
function G0e() {
  if (Nne)
    return GI;
  Nne = 1;
  var e = _ad(), t = pad();
  function n(o, r) {
    return o != null && t(o, r, e);
  }
  return GI = n, GI;
}
var HI, Dne;
function mad() {
  if (Dne)
    return HI;
  Dne = 1;
  var e = B0e(), t = Lbe, n = G0e(), o = HF, r = U0e(), i = W0e(), a = $b, s = 1, c = 2;
  function l(d, u) {
    return o(d) && r(u) ? i(a(d), u) : function(_) {
      var p = t(_, d);
      return p === void 0 && p === u ? n(_, d) : e(u, p, s | c);
    };
  }
  return HI = l, HI;
}
var KI, Mne;
function fad() {
  if (Mne)
    return KI;
  Mne = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return KI = e, KI;
}
var YI, Lne;
function gad() {
  if (Lne)
    return YI;
  Lne = 1;
  var e = PC;
  function t(n) {
    return function(o) {
      return e(o, n);
    };
  }
  return YI = t, YI;
}
var ZI, qne;
function had() {
  if (qne)
    return ZI;
  qne = 1;
  var e = fad(), t = gad(), n = HF, o = $b;
  function r(i) {
    return n(i) ? e(o(i)) : t(i);
  }
  return ZI = r, ZI;
}
var QI, jne;
function H0e() {
  if (jne)
    return QI;
  jne = 1;
  var e = uad(), t = mad(), n = J8(), o = hd, r = had();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? o(a) ? t(a[0], a[1]) : e(a) : r(a);
  }
  return QI = i, QI;
}
var JI, Fne;
function tz() {
  if (Fne)
    return JI;
  Fne = 1;
  var e = XC(), t = Jid(), n = H0e();
  function o(r, i) {
    var a = {};
    return i = n(i, 3), t(r, function(s, c, l) {
      e(a, c, i(s, c, l));
    }), a;
  }
  return JI = o, JI;
}
var Vne;
function Na() {
  if (Vne)
    return Fl;
  Vne = 1;
  var e = Rt;
  Object.defineProperty(Fl, "__esModule", {
    value: !0
  }), Fl.useOnPropsChanged = Fl.pureShouldComponentUpdate = Fl.liteShouldComponentUpdate = Fl.bindActionCreators = void 0;
  var t = e(ve), n = e(tz()), o = Sr(), r = function(d, u) {
    return function(_, p) {
      var f = d.props, g = d.state, h = _ != f || p != g;
      if (h && g == p && f != _) {
        var b = [];
        for (var v in _) {
          var $ = _[v] != f[v];
          $ && (u[v] == "ignore" ? $ = !1 : u[v] == "shallow_deep" ? $ = !(0, o.shallowEqual)(_[v], f[v], !0) : u[v] == "shallow" ? $ = !(0, o.shallowEqual)(_[v], f[v]) : typeof u[v] == "function" && ($ = u[v](_[v], f[v], p))), $ && b.push(v);
        }
        b.length || (h = !1);
      }
      return h;
    };
  };
  Fl.liteShouldComponentUpdate = r;
  var i = function(d) {
    return function(u, _) {
      return !(0, o.shallowEqual)(d.props, u) || !(0, o.shallowEqual)(d.state, _);
    };
  };
  Fl.pureShouldComponentUpdate = i;
  var a = function() {
    var d = t.default.version.split(".").map(parseInt.bind(null, 10));
    return d[0] == 16 && d[1] >= 3 || d[0] > 16;
  }, s = function(d) {
    a ? d.UNSAFE_componentWillReceiveProps = function(u) {
      d.onPropsChanged(u);
    } : d.componentWillReceiveProps = function(u) {
      d.onPropsChanged(u);
    };
  };
  Fl.useOnPropsChanged = s;
  var c = function(d, u, _) {
    return (0, n.default)(d, function(p) {
      return function() {
        for (var f = arguments.length, g = new Array(f), h = 0; h < f; h++)
          g[h] = arguments[h];
        return _(p.apply(void 0, [u].concat(g)));
      };
    });
  };
  return Fl.bindActionCreators = c, Fl;
}
var XI = { exports: {} }, Bne;
function nz() {
  return Bne || (Bne = 1, function(e) {
    var t = function() {
      function n(_, p) {
        return p != null && _ instanceof p;
      }
      var o;
      try {
        o = Map;
      } catch {
        o = function() {
        };
      }
      var r;
      try {
        r = Set;
      } catch {
        r = function() {
        };
      }
      var i;
      try {
        i = Promise;
      } catch {
        i = function() {
        };
      }
      function a(_, p, f, g, h) {
        typeof p == "object" && (f = p.depth, g = p.prototype, h = p.includeNonEnumerable, p = p.circular);
        var b = [], v = [], $ = typeof Buffer < "u";
        typeof p > "u" && (p = !0), typeof f > "u" && (f = 1 / 0);
        function k(S, O) {
          if (S === null)
            return null;
          if (O === 0)
            return S;
          var I, D;
          if (typeof S != "object")
            return S;
          if (n(S, o))
            I = new o();
          else if (n(S, r))
            I = new r();
          else if (n(S, i))
            I = new i(function(z, j) {
              S.then(function(q) {
                z(k(q, O - 1));
              }, function(q) {
                j(k(q, O - 1));
              });
            });
          else if (a.__isArray(S))
            I = [];
          else if (a.__isRegExp(S))
            I = new RegExp(S.source, u(S)), S.lastIndex && (I.lastIndex = S.lastIndex);
          else if (a.__isDate(S))
            I = new Date(S.getTime());
          else {
            if ($ && Buffer.isBuffer(S))
              return Buffer.allocUnsafe ? I = Buffer.allocUnsafe(S.length) : I = new Buffer(S.length), S.copy(I), I;
            n(S, Error) ? I = Object.create(S) : typeof g > "u" ? (D = Object.getPrototypeOf(S), I = Object.create(D)) : (I = Object.create(g), D = g);
          }
          if (p) {
            var M = b.indexOf(S);
            if (M != -1)
              return v[M];
            b.push(S), v.push(I);
          }
          n(S, o) && S.forEach(function(z, j) {
            var q = k(j, O - 1), V = k(z, O - 1);
            I.set(q, V);
          }), n(S, r) && S.forEach(function(z) {
            var j = k(z, O - 1);
            I.add(j);
          });
          for (var N in S) {
            var C;
            D && (C = Object.getOwnPropertyDescriptor(D, N)), !(C && C.set == null) && (I[N] = k(S[N], O - 1));
          }
          if (Object.getOwnPropertySymbols)
            for (var P = Object.getOwnPropertySymbols(S), N = 0; N < P.length; N++) {
              var x = P[N], w = Object.getOwnPropertyDescriptor(S, x);
              w && !w.enumerable && !h || (I[x] = k(S[x], O - 1), w.enumerable || Object.defineProperty(I, x, {
                enumerable: !1
              }));
            }
          if (h)
            for (var E = Object.getOwnPropertyNames(S), N = 0; N < E.length; N++) {
              var T = E[N], w = Object.getOwnPropertyDescriptor(S, T);
              w && w.enumerable || (I[T] = k(S[T], O - 1), Object.defineProperty(I, T, {
                enumerable: !1
              }));
            }
          return I;
        }
        return k(_, f);
      }
      a.clonePrototype = function(p) {
        if (p === null)
          return null;
        var f = function() {
        };
        return f.prototype = p, new f();
      };
      function s(_) {
        return Object.prototype.toString.call(_);
      }
      a.__objToStr = s;
      function c(_) {
        return typeof _ == "object" && s(_) === "[object Date]";
      }
      a.__isDate = c;
      function l(_) {
        return typeof _ == "object" && s(_) === "[object Array]";
      }
      a.__isArray = l;
      function d(_) {
        return typeof _ == "object" && s(_) === "[object RegExp]";
      }
      a.__isRegExp = d;
      function u(_) {
        var p = "";
        return _.global && (p += "g"), _.ignoreCase && (p += "i"), _.multiline && (p += "m"), p;
      }
      return a.__getRegExpFlags = u, a;
    }();
    e.exports && (e.exports = t);
  }(XI)), XI.exports;
}
var Une;
function vad() {
  return Une || (Une = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = k(ve), u = t(di), _ = Br(), p = Hi(), f = Sr(), g = Na(), h = t(xk()), b = t(R_), v = t(nz());
    function $(N) {
      if (typeof WeakMap != "function")
        return null;
      var C = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
      return ($ = function(w) {
        return w ? P : C;
      })(N);
    }
    function k(N, C) {
      if (!C && N && N.__esModule)
        return N;
      if (N === null || n(N) !== "object" && typeof N != "function")
        return { default: N };
      var P = $(C);
      if (P && P.has(N))
        return P.get(N);
      var x = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in N)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(N, E)) {
          var T = w ? Object.getOwnPropertyDescriptor(N, E) : null;
          T && (T.get || T.set) ? Object.defineProperty(x, E, T) : x[E] = N[E];
        }
      return x.default = N, P && P.set(N, x), x;
    }
    function S(N, C) {
      var P = Object.keys(N);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(N);
        C && (x = x.filter(function(w) {
          return Object.getOwnPropertyDescriptor(N, w).enumerable;
        })), P.push.apply(P, x);
      }
      return P;
    }
    function O(N) {
      for (var C = 1; C < arguments.length; C++) {
        var P = arguments[C] != null ? arguments[C] : {};
        C % 2 ? S(Object(P), !0).forEach(function(x) {
          (0, o.default)(N, x, P[x]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(P)) : S(Object(P)).forEach(function(x) {
          Object.defineProperty(N, x, Object.getOwnPropertyDescriptor(P, x));
        });
      }
      return N;
    }
    function I(N) {
      var C = D();
      return function() {
        var x = (0, l.default)(N), w;
        if (C) {
          var E = (0, l.default)(this).constructor;
          w = Reflect.construct(x, arguments, E);
        } else
          w = x.apply(this, arguments);
        return (0, c.default)(this, w);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = /* @__PURE__ */ function(N) {
      (0, s.default)(P, N);
      var C = I(P);
      function P(x) {
        var w;
        return (0, r.default)(this, P), w = C.call(this, x), (0, g.useOnPropsChanged)((0, a.default)(w)), w.onPropsChanged(x), w;
      }
      return (0, i.default)(P, [{
        key: "onPropsChanged",
        value: function(w) {
          var E = this.props, T = ["config", "field", "operator", "isFuncArg", "parentField"], z = ["config", "field", "operator", "value", "placeholder", "isFuncArg", "parentField"], j = !this.items || T.map(function(V) {
            return w[V] !== E[V];
          }).filter(function(V) {
            return V;
          }).length > 0, q = !this.meta || z.map(function(V) {
            return w[V] !== E[V];
          }).filter(function(V) {
            return V;
          }).length > 0;
          j && (this.items = this.getItems(w)), q && (this.meta = this.getMeta(w));
        }
      }, {
        key: "getItems",
        value: function(w) {
          var E = w.config, T = w.field, z = w.operator, j = w.parentField, q = w.isFuncArg, V = w.fieldDefinition, F = E.settings.canCompareFieldWithField, L = E.settings.fieldSeparator, U = typeof j == "string" ? j.split(L) : j, W = j ? (0, _.getFieldConfig)(E, j) : null, H = j ? W && W.subfields : E.fields, Q = this.filterFields(E, H, T, j, U, z, F, q, V), X = this.buildOptions(U, E, Q, U);
          return X;
        }
      }, {
        key: "getMeta",
        value: function(w) {
          var E = w.config, T = w.field;
          w.operator;
          var z = w.value, j = w.placeholder, q = w.isFuncArg, V = w.parentField, F = E.settings, L = F.fieldPlaceholder, U = F.fieldSeparatorDisplay, W = z, H = !!z, Q = (0, _.getFieldConfig)(E, T), X = Q.widgets.field, re = X && X.widgetProps || {}, Z = H ? null : q && j || re.valuePlaceholder || L, ee = H ? (0, _.getFieldConfig)(E, W) : null, J = ee || {}, oe = (0, p.getFieldPath)(W, E), ce = (0, p.getFieldPath)(W, E, !0), de = this.getFieldLabel(ee, W, E), te = (0, p.getFieldPathLabels)(W, E), ue = te ? te.join(U) : null;
          (ue == de || V) && (ue = null);
          var le = J.label2;
          return {
            placeholder: Z,
            selectedKey: W,
            selectedKeys: oe,
            selectedPath: ce,
            selectedLabel: de,
            selectedOpts: J,
            selectedAltLabel: le,
            selectedFullLabel: ue
          };
        }
      }, {
        key: "filterFields",
        value: function(w, E, T, z, j, q, V, F, L) {
          E = (0, v.default)(E);
          var U = w.settings.fieldSeparator, W = (0, _.getFieldConfig)(w, T), H, Q = (0, p.getWidgetForFieldOp)(w, T, q, "value");
          if (F && L)
            H = L.type;
          else if (Q) {
            var X = w.widgets[Q], re = X.type;
            H = re;
          } else
            H = W.type;
          function Z(ee, J) {
            for (var oe in ee) {
              var ce = ee[oe].subfields, de = (J || []).concat(oe), te = de.join(U), ue = (0, _.getFieldConfig)(w, te);
              if (!ue)
                delete ee[oe];
              else if (ue.type == "!struct" || ue.type == "!group")
                Z(ce, de) == 0 && delete ee[oe];
              else {
                var le = ue.type == H && (F ? !0 : te != T), se = V || w.settings.canCompareFieldWithField;
                se && (le = le && se(T, W, te, ue, q)), le || delete ee[oe];
              }
            }
            return (0, b.default)(ee).length;
          }
          return Z(E, j || []), E;
        }
      }, {
        key: "buildOptions",
        value: function(w, E, T) {
          var z = this, j = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, q = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
          if (!T)
            return null;
          var V = E.settings, F = V.fieldSeparator, L = V.fieldSeparatorDisplay, U = j ? j.join(F) + F : "";
          return (0, b.default)(T).map(function(W) {
            var H = T[W], Q = z.getFieldLabel(H, W, E), X = (0, p.getFieldPathLabels)(W, E), re = X.join(L);
            (re == Q || w) && (re = null);
            var Z = H.label2, ee = H.tooltip, J = (j || []).concat(W);
            if (!H.hideForCompare)
              return H.type == "!struct" || H.type == "!group" ? {
                key: W,
                path: U + W,
                label: Q,
                fullLabel: re,
                altLabel: Z,
                tooltip: ee,
                items: z.buildOptions(w, E, H.subfields, J, Q)
              } : {
                key: W,
                path: U + W,
                label: Q,
                fullLabel: re,
                altLabel: Z,
                tooltip: ee,
                grouplabel: q
              };
          }).filter(function(W) {
            return !!W;
          });
        }
      }, {
        key: "getFieldLabel",
        value: function(w, E, T) {
          if (!E)
            return null;
          var z = T.settings.fieldSeparator, j = T.settings.maxLabelsLength, q = Array.isArray(E) ? E : E.split(z), V = w.label || (0, h.default)(q);
          return V = (0, f.truncateString)(V, j), V;
        }
      }, {
        key: "render",
        value: function() {
          var w = this.props, E = w.config, T = w.customProps, z = w.setValue, j = w.readonly, q = w.id, V = w.groupId, F = E.settings.renderField, L = O({
            config: E,
            customProps: T,
            setField: z,
            readonly: j,
            items: this.items,
            id: q,
            groupId: V
          }, this.meta);
          return F(L);
        }
      }]), P;
    }(d.PureComponent);
    e.default = M, M.propTypes = {
      id: u.default.string,
      groupId: u.default.string,
      setValue: u.default.func.isRequired,
      config: u.default.object.isRequired,
      field: u.default.string.isRequired,
      value: u.default.string,
      operator: u.default.string,
      customProps: u.default.object,
      readonly: u.default.bool,
      parentField: u.default.string
    };
  }(FP)), FP;
}
var eR = {};
const pa = /* @__PURE__ */ Oa(hze);
var tR = {}, Wne;
function bad() {
  return Wne || (Wne = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = k(ve), u = t(di), _ = Br(), p = Hi(), f = Sr(), g = Na(), h = t(xk()), b = t(R_), v = t(nz());
    function $(N) {
      if (typeof WeakMap != "function")
        return null;
      var C = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
      return ($ = function(w) {
        return w ? P : C;
      })(N);
    }
    function k(N, C) {
      if (!C && N && N.__esModule)
        return N;
      if (N === null || n(N) !== "object" && typeof N != "function")
        return { default: N };
      var P = $(C);
      if (P && P.has(N))
        return P.get(N);
      var x = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in N)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(N, E)) {
          var T = w ? Object.getOwnPropertyDescriptor(N, E) : null;
          T && (T.get || T.set) ? Object.defineProperty(x, E, T) : x[E] = N[E];
        }
      return x.default = N, P && P.set(N, x), x;
    }
    function S(N, C) {
      var P = Object.keys(N);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(N);
        C && (x = x.filter(function(w) {
          return Object.getOwnPropertyDescriptor(N, w).enumerable;
        })), P.push.apply(P, x);
      }
      return P;
    }
    function O(N) {
      for (var C = 1; C < arguments.length; C++) {
        var P = arguments[C] != null ? arguments[C] : {};
        C % 2 ? S(Object(P), !0).forEach(function(x) {
          (0, o.default)(N, x, P[x]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(P)) : S(Object(P)).forEach(function(x) {
          Object.defineProperty(N, x, Object.getOwnPropertyDescriptor(P, x));
        });
      }
      return N;
    }
    function I(N) {
      var C = D();
      return function() {
        var x = (0, l.default)(N), w;
        if (C) {
          var E = (0, l.default)(this).constructor;
          w = Reflect.construct(x, arguments, E);
        } else
          w = x.apply(this, arguments);
        return (0, c.default)(this, w);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = /* @__PURE__ */ function(N) {
      (0, s.default)(P, N);
      var C = I(P);
      function P(x) {
        var w;
        return (0, r.default)(this, P), w = C.call(this, x), (0, g.useOnPropsChanged)((0, a.default)(w)), w.onPropsChanged(x), w;
      }
      return (0, i.default)(P, [{
        key: "onPropsChanged",
        value: function(w) {
          var E = this.props, T = ["config", "field", "operator"], z = ["config", "field", "value"], j = !this.items || T.map(function(V) {
            return w[V] !== E[V];
          }).filter(function(V) {
            return V;
          }).length > 0, q = !this.meta || z.map(function(V) {
            return w[V] !== E[V];
          }).filter(function(V) {
            return V;
          }).length > 0;
          q && (this.meta = this.getMeta(w)), j && (this.items = this.getItems(w));
        }
      }, {
        key: "getItems",
        value: function(w) {
          var E = w.config, T = w.field, z = w.operator, j = w.parentFuncs, q = E.settings.canUseFuncForField, V = this.filterFuncs(E, E.funcs, T, z, q, j), F = this.buildOptions(E, V);
          return F;
        }
      }, {
        key: "getMeta",
        value: function(w) {
          var E = w.config, T = w.field, z = w.value, j = E.settings, q = j.funcPlaceholder, V = j.fieldSeparatorDisplay, F = z, L = !!z, U = (0, _.getFieldConfig)(E, T), W = U.widgets.field;
          W && W.widgetProps;
          var H = L ? null : q, Q = L ? (0, _.getFuncConfig)(E, F) : null, X = Q || {}, re = (0, p.getFieldPath)(F, E), Z = (0, p.getFieldPath)(F, E, !0), ee = this.getFuncLabel(Q, F, E), J = (0, p.getFuncPathLabels)(F, E), oe = J ? J.join(V) : null;
          return oe == ee && (oe = null), {
            placeholder: H,
            selectedKey: F,
            selectedKeys: re,
            selectedPath: Z,
            selectedLabel: ee,
            selectedOpts: X,
            selectedFullLabel: oe
          };
        }
      }, {
        key: "filterFuncs",
        value: function(w, E, T, z, j, q) {
          E = (0, v.default)(E);
          var V = w.settings.fieldSeparator, F = (0, _.getFieldConfig)(w, T), L, U = (0, p.getWidgetForFieldOp)(w, T, z, "value");
          if (U) {
            var W = w.widgets[U], H = W.type;
            L = H;
          } else
            L = F.type;
          function Q(X, re) {
            for (var Z in X) {
              var ee = X[Z].subfields, J = (re || []).concat(Z), oe = J.join(V), ce = (0, _.getFuncConfig)(w, oe);
              if (ce.type == "!struct")
                Q(ee, J) == 0 && delete X[Z];
              else {
                var de = ce.returnType == L;
                F.funcs && (de = de && F.funcs.includes(oe)), j && (de = de && j(T, F, oe, ce, z)), q && q.includes(oe) && (de = !1), de || delete X[Z];
              }
            }
            return (0, b.default)(X).length;
          }
          return Q(E, []), E;
        }
      }, {
        key: "buildOptions",
        value: function(w, E) {
          var T = this, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, j = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
          if (!E)
            return null;
          var q = w.settings, V = q.fieldSeparator, F = q.fieldSeparatorDisplay, L = z ? z.join(V) + V : "";
          return (0, b.default)(E).map(function(U) {
            var W = E[U], H = T.getFuncLabel(W, U, w), Q = (0, p.getFuncPathLabels)(U, w), X = Q.join(F);
            X == H && (X = null);
            var re = W.tooltip, Z = (z || []).concat(U);
            return W.type == "!struct" ? {
              key: U,
              path: L + U,
              label: H,
              fullLabel: X,
              tooltip: re,
              items: T.buildOptions(w, W.subfields, Z, H)
            } : {
              key: U,
              path: L + U,
              label: H,
              fullLabel: X,
              tooltip: re,
              grouplabel: j
            };
          });
        }
      }, {
        key: "getFuncLabel",
        value: function(w, E, T) {
          if (!E)
            return null;
          var z = T.settings.fieldSeparator, j = T.settings.maxLabelsLength, q = Array.isArray(E) ? E : E.split(z), V = w.label || (0, h.default)(q);
          return V = (0, f.truncateString)(V, j), V;
        }
      }, {
        key: "render",
        value: function() {
          var w = this.props, E = w.config, T = w.customProps, z = w.setValue, j = w.readonly, q = w.id, V = w.groupId, F = E.settings.renderFunc, L = O({
            config: E,
            customProps: T,
            readonly: j,
            setField: z,
            items: this.items,
            id: q,
            groupId: V
          }, this.meta);
          return F(L);
        }
      }]), P;
    }(d.PureComponent);
    e.default = M, M.propTypes = {
      id: u.default.string,
      groupId: u.default.string,
      config: u.default.object.isRequired,
      field: u.default.string.isRequired,
      operator: u.default.string,
      customProps: u.default.object,
      value: u.default.string,
      setValue: u.default.func.isRequired,
      readonly: u.default.bool,
      parentFuncs: u.default.array
    };
  }(tR)), tR;
}
var nR = {}, oR, Gne;
function yad() {
  if (Gne)
    return oR;
  Gne = 1;
  var e = Math.ceil, t = Math.max;
  function n(o, r, i, a) {
    for (var s = -1, c = t(e((r - o) / (i || 1)), 0), l = Array(c); c--; )
      l[a ? c : ++s] = o, o += i;
    return l;
  }
  return oR = n, oR;
}
var rR, Hne;
function K0e() {
  if (Hne)
    return rR;
  Hne = 1;
  var e = lge, t = 1 / 0, n = 17976931348623157e292;
  function o(r) {
    if (!r)
      return r === 0 ? r : 0;
    if (r = e(r), r === t || r === -t) {
      var i = r < 0 ? -1 : 1;
      return i * n;
    }
    return r === r ? r : 0;
  }
  return rR = o, rR;
}
var iR, Kne;
function $ad() {
  if (Kne)
    return iR;
  Kne = 1;
  var e = yad(), t = N0e(), n = K0e();
  function o(r) {
    return function(i, a, s) {
      return s && typeof s != "number" && t(i, a, s) && (a = s = void 0), i = n(i), a === void 0 ? (a = i, i = 0) : a = n(a), s = s === void 0 ? i < a ? 1 : -1 : n(s), e(i, a, s, r);
    };
  }
  return iR = o, iR;
}
var aR, Yne;
function Y0e() {
  if (Yne)
    return aR;
  Yne = 1;
  var e = $ad(), t = e();
  return aR = t, aR;
}
var sR, Zne;
function wad() {
  if (Zne)
    return sR;
  Zne = 1;
  var e = Q8(), t = yb, n = ZA, o = Al, r = $b;
  function i(a, s, c, l) {
    if (!o(a))
      return a;
    s = t(s, a);
    for (var d = -1, u = s.length, _ = u - 1, p = a; p != null && ++d < u; ) {
      var f = r(s[d]), g = c;
      if (f === "__proto__" || f === "constructor" || f === "prototype")
        return a;
      if (d != _) {
        var h = p[f];
        g = l ? l(h, f, p) : void 0, g === void 0 && (g = o(h) ? h : n(s[d + 1]) ? [] : {});
      }
      e(p, f, g), p = p[f];
    }
    return a;
  }
  return sR = i, sR;
}
var cR, Qne;
function Z0e() {
  if (Qne)
    return cR;
  Qne = 1;
  var e = PC, t = wad(), n = yb;
  function o(r, i, a) {
    for (var s = -1, c = i.length, l = {}; ++s < c; ) {
      var d = i[s], u = e(r, d);
      a(u, d) && t(l, n(d, r), u);
    }
    return l;
  }
  return cR = o, cR;
}
var lR, Jne;
function kad() {
  if (Jne)
    return lR;
  Jne = 1;
  var e = Z0e(), t = G0e();
  function n(o, r) {
    return e(o, r, function(i, a) {
      return t(o, a);
    });
  }
  return lR = n, lR;
}
var dR, Xne;
function $g() {
  if (Xne)
    return dR;
  Xne = 1;
  var e = kad(), t = F0e(), n = t(function(o, r) {
    return o == null ? {} : e(o, r);
  });
  return dR = n, dR;
}
var uR = {};
const Tk = /* @__PURE__ */ Oa(qdc);
var eoe;
function Sad() {
  return eoe || (eoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Tk);
    t(ve);
    var o = Sr(), r = ["factory"], i = function(s) {
      var c = s.delta, l = s.isFuncArg;
      s.valueSrc;
      var d = s.value, u = s.valueError, _ = s.asyncListValues, p = s.isSpecialRange, f = s.fieldDefinition;
      s.widget;
      var g = s.widgetDefinition, h = s.widgetValueLabel, b = s.valueLabels, v = s.textSeparators, $ = s.setValueHandler, k = s.config, S = s.field, O = s.operator, I = s.readonly, D = s.parentField, M = s.parentFuncs, N = s.id, C = s.groupId, P = g.factory, x = (0, n.default)(g, r), w = l && f.valueSources && f.valueSources.length == 1 && f.valueSources[0] == "const", E = f.defaultValue;
      if (!P)
        return "?";
      var T = p ? [d.get(0), d.get(1)] : d ? d.get(c) : void 0, z = u && (p ? [u.get(0), u.get(1)] : u.get(c)) || null;
      p && T[0] === void 0 && T[1] === void 0 && (T = void 0);
      var j = f || {}, q = j.fieldSettings, V = Object.assign({}, x, q, {
        config: k,
        field: S,
        parentField: D,
        parentFuncs: M,
        fieldDefinition: f,
        operator: O,
        delta: c,
        isSpecialRange: p,
        isFuncArg: l,
        value: T,
        valueError: z,
        label: h.label,
        placeholder: h.placeholder,
        placeholders: b ? b.placeholder : null,
        textSeparators: v,
        setValue: $,
        readonly: I,
        asyncListValues: _,
        id: N,
        groupId: C
      });
      return w && E ? typeof E == "boolean" ? E ? V.labelYes || "YES" : V.labelNo || "NO" : q.listValues ? Array.isArray(E) ? E.map(function(F) {
        return (0, o.getTitleInListValues)(q.listValues, F) || F;
      }).join(", ") : (0, o.getTitleInListValues)(q.listValues, E) || E : "" + E : P(V);
    };
    e.default = i;
  }(uR)), uR;
}
var Vl = {}, toe;
function wu() {
  if (toe)
    return Vl;
  toe = 1;
  var e = Rt;
  Object.defineProperty(Vl, "__esModule", {
    value: !0
  }), Vl.dummyFn = Vl.DragIcon = Vl.ConfirmFn = Vl.Col = void 0;
  var t = e(pa), n = e(Tk), o = e(ve), r = ["children"], i = function(d) {
    var u = d.children, _ = (0, n.default)(d, r);
    return /* @__PURE__ */ o.default.createElement("div", _, u);
  };
  Vl.Col = i;
  var a = function() {
  };
  Vl.dummyFn = a;
  var s = function() {
    return /* @__PURE__ */ o.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "gray",
      width: "18px",
      height: "18px"
    }, /* @__PURE__ */ o.default.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), /* @__PURE__ */ o.default.createElement("path", {
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }));
  };
  Vl.DragIcon = s;
  var c = function(d) {
    return function(u) {
      var _ = u.config.settings.useConfirm, p = _ ? _() : null;
      return /* @__PURE__ */ o.default.createElement(d, (0, t.default)({}, u, {
        confirmFn: p
      }));
    };
  };
  return Vl.ConfirmFn = c, Vl;
}
var noe;
function oz() {
  return noe || (noe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(pa), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = O(ve), u = t(di), _ = t(Y0e()), p = Br(), f = Hi(), g = Sr(), h = Na(), b = t($g()), v = t(Ra()), $ = t(Sad()), k = wu();
    function S(C) {
      if (typeof WeakMap != "function")
        return null;
      var P = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap();
      return (S = function(E) {
        return E ? x : P;
      })(C);
    }
    function O(C, P) {
      if (!P && C && C.__esModule)
        return C;
      if (C === null || n(C) !== "object" && typeof C != "function")
        return { default: C };
      var x = S(P);
      if (x && x.has(C))
        return x.get(C);
      var w = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var T in C)
        if (T !== "default" && Object.prototype.hasOwnProperty.call(C, T)) {
          var z = E ? Object.getOwnPropertyDescriptor(C, T) : null;
          z && (z.get || z.set) ? Object.defineProperty(w, T, z) : w[T] = C[T];
        }
      return w.default = C, x && x.set(C, w), w;
    }
    function I(C) {
      var P = D();
      return function() {
        var w = (0, l.default)(C), E;
        if (P) {
          var T = (0, l.default)(this).constructor;
          E = Reflect.construct(w, arguments, T);
        } else
          E = w.apply(this, arguments);
        return (0, c.default)(this, E);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = {
      cardinality: 1
    }, N = /* @__PURE__ */ function(C) {
      (0, s.default)(x, C);
      var P = I(x);
      function x(w) {
        var E;
        return (0, r.default)(this, x), E = P.call(this, w), E._setValue = function(T, z, j, q, V, F) {
          if (T && Array.isArray(q)) {
            var L = [E.props.value.get(0), E.props.value.get(1)];
            L[0] != q[0] && E.props.setValue(0, q[0], j, V, F), L[1] != q[1] && E.props.setValue(1, q[1], j, V, F);
          } else
            E.props.setValue(z, q, j, V, F);
        }, E._onChangeValueSrc = function(T, z) {
          E.props.setValueSrc(T, z);
        }, E.renderWidget = function(T, z, j) {
          var q = j.config, V = j.isFuncArg, F = j.leftField, L = j.operator, U = j.value, W = j.valueError, H = j.readonly, Q = j.parentField, X = j.parentFuncs, re = j.id, Z = j.groupId, ee = q.settings, J = z.widgets, oe = z.iValues, ce = z.aField, de = V ? oe : U, te = V ? F : ce, ue = J[T], le = ue.valueSrc, se = ue.valueLabel, me = ee.showLabels ? /* @__PURE__ */ d.default.createElement("label", {
            className: "rule--label"
          }, se.label) : null;
          return /* @__PURE__ */ d.default.createElement("div", {
            key: "widget-" + te + "-" + T,
            className: "widget--widget"
          }, le == "func" ? null : me, /* @__PURE__ */ d.default.createElement($.default, (0, o.default)({
            id: re,
            groupId: Z,
            valueSrc: le,
            delta: T,
            value: de,
            valueError: W,
            isFuncArg: V
          }, (0, b.default)(z, ["isSpecialRange", "fieldDefinition", "asyncListValues"]), (0, b.default)(J[T], ["widget", "widgetDefinition", "widgetValueLabel", "valueLabels", "textSeparators", "setValueHandler"]), {
            config: q,
            field: te,
            parentField: Q,
            parentFuncs: X,
            operator: L,
            readonly: H
          })));
        }, E.renderValueSources = function(T, z, j) {
          var q = j.config, V = j.isFuncArg, F = j.leftField, L = j.operator, U = j.readonly, W = q.settings, H = z.valueSources, Q = z.widgets, X = z.aField, re = V ? F : X, Z = Q[T], ee = Z.valueSrc, J = Z.setValueSrcHandler, oe = W.valueSourcesInfo, ce = W.renderValueSources, de = H.map(function(ue) {
            return [ue, {
              label: oe[ue].label
            }];
          }), te = W.showLabels ? /* @__PURE__ */ d.default.createElement("label", {
            className: "rule--label"
          }, " ") : null;
          return H.length > 1 && !U && /* @__PURE__ */ d.default.createElement("div", {
            key: "valuesrc-" + re + "-" + T,
            className: "widget--valuesrc"
          }, te, /* @__PURE__ */ d.default.createElement(ce, {
            key: "valuesrc-" + T,
            delta: T,
            valueSources: de,
            valueSrc: ee,
            config: q,
            field: re,
            operator: L,
            setValueSrc: J,
            readonly: U,
            title: W.valueSourcesPopupTitle
          }));
        }, E.renderSep = function(T, z, j) {
          var q = j.config, V = z.widgets, F = q.settings, L = V[T].sepText, U = F.showLabels ? /* @__PURE__ */ d.default.createElement("label", {
            className: "rule--label"
          }, " ") : null;
          return L && /* @__PURE__ */ d.default.createElement("div", {
            key: "widget-separators-" + T,
            className: "widget--sep"
          }, U, /* @__PURE__ */ d.default.createElement("span", null, L));
        }, E.renderWidgetDelta = function(T) {
          var z = E.renderSep(T, E.meta, E.props), j = E.renderValueSources(T, E.meta, E.props), q = E.renderWidget(T, E.meta, E.props);
          return [z, j, q];
        }, (0, h.useOnPropsChanged)((0, a.default)(E)), E.onPropsChanged(w), E;
      }
      return (0, i.default)(x, [{
        key: "onPropsChanged",
        value: function(E) {
          var T = this.props, z = ["config", "field", "fieldFunc", "fieldArg", "leftField", "operator", "valueSrc", "isFuncArg", "asyncListValues"], j = !this.meta || z.map(function(q) {
            return E[q] !== T[q] || q == "isFuncArg" && E.isFuncArg && E.value !== T.value;
          }).filter(function(q) {
            return q;
          }).length > 0;
          j && (this.meta = this.getMeta(E));
        }
      }, {
        key: "getMeta",
        value: function(E) {
          var T = this, z = E.config, j = E.field, q = E.fieldFunc, V = E.fieldArg, F = E.operator, L = E.valueSrc, U = E.value, W = E.isForRuleGruop, H = E.isCaseValue, Q = E.isFuncArg, X = E.leftField, re = E.asyncListValues, Z = Q ? {
            func: q,
            arg: V
          } : j, ee = L, J = U;
          (Q || W || H) && (ee = v.default.List([L]), J = v.default.List([U]));
          var oe = (0, p.getFieldConfig)(z, Z), ce = (0, f.getWidgetForFieldOp)(z, Z, F);
          (0, f.getWidgetsForFieldOp)(z, Z, F);
          var de = Q ? M : (0, p.getOperatorConfig)(z, F, Z);
          if ((oe == null || de == null) && !H)
            return null;
          var te = de == null ? void 0 : de.isSpecialRange, ue = te && (ee.get(0) == "field" || ee.get(1) == "field"), le = te && !ue, se = le ? 1 : (0, g.defaultValue)(de == null ? void 0 : de.cardinality, 1);
          if (se === 0)
            return null;
          var me = (0, f.getValueSourcesForFieldOp)(z, Z, F, oe, Q ? X : null), pe = (0, _.default)(0, se).map(function(be) {
            var Se, Ae = ee.get(be) || null, Ze = (0, f.getWidgetForFieldOp)(z, Z, F, Ae), Ge = (0, p.getFieldWidgetConfig)(z, Z, F, Ze, Ae);
            ue && (Ze = Ge.singleWidget, Ge = (0, p.getFieldWidgetConfig)(z, Z, F, Ze, Ae));
            var rt = (Se = Ge) === null || Se === void 0 ? void 0 : Se.type, qe = (0, f.getValueLabel)(z, Z, F, be, Ae, le), Xe = (0, f.getValueLabel)(z, Z, F, be, null, le), lt = de != null && de.textSeparators ? de == null ? void 0 : de.textSeparators[be] : null, Et = T._onChangeValueSrc.bind(T, be), wt = null, nn = null;
            te && (wt = [(0, f.getValueLabel)(z, Z, F, 0), (0, f.getValueLabel)(z, Z, F, 1)], wt = {
              placeholder: [wt[0].placeholder, wt[1].placeholder],
              label: [wt[0].label, wt[1].label]
            }, nn = de == null ? void 0 : de.textSeparators);
            var Dt = T._setValue.bind(T, te, be, rt);
            return {
              valueSrc: Ae,
              valueLabel: qe,
              widget: Ze,
              sepText: lt,
              setValueSrcHandler: Et,
              widgetDefinition: Ge,
              widgetValueLabel: Xe,
              valueLabels: wt,
              textSeparators: nn,
              setValueHandler: Dt
            };
          });
          return {
            defaultWidget: ce,
            fieldDefinition: oe,
            operatorDefinition: de,
            isSpecialRange: le,
            cardinality: se,
            valueSources: me,
            widgets: pe,
            iValues: J,
            //correct for isFuncArg
            aField: Z,
            //correct for isFuncArg
            asyncListValues: re
          };
        }
      }, {
        key: "render",
        value: function() {
          if (!this.meta)
            return null;
          var E = this.meta, T = E.defaultWidget, z = E.cardinality;
          if (!T)
            return null;
          var j = T;
          return /* @__PURE__ */ d.default.createElement(k.Col, {
            className: "rule--widget rule--widget--".concat(j.toUpperCase()),
            key: "widget-col-" + j
          }, (0, _.default)(0, z).map(this.renderWidgetDelta));
        }
      }]), x;
    }(d.PureComponent);
    e.default = N, N.propTypes = {
      config: u.default.object.isRequired,
      value: u.default.any,
      //instanceOf(Immutable.List)
      valueSrc: u.default.any,
      //instanceOf(Immutable.List)
      valueError: u.default.any,
      field: u.default.string,
      operator: u.default.string,
      readonly: u.default.bool,
      asyncListValues: u.default.array,
      id: u.default.string,
      groupId: u.default.string,
      //actions
      setValue: u.default.func,
      setValueSrc: u.default.func,
      // for isFuncArg
      isFuncArg: u.default.bool,
      fieldFunc: u.default.string,
      fieldArg: u.default.string,
      leftField: u.default.string,
      // for RuleGroupExt
      isForRuleGruop: u.default.bool,
      parentField: u.default.string,
      // for func in func
      parentFuncs: u.default.array,
      // for case_value
      isCaseValue: u.default.bool
    };
  }(nR)), nR;
}
var mc = {}, ooe;
function wg() {
  if (ooe)
    return mc;
  ooe = 1;
  var e = Rt;
  Object.defineProperty(mc, "__esModule", {
    value: !0
  }), mc.setFunc = mc.setArgValueSrc = mc.setArgValue = mc.completeValue = mc.completeFuncValue = void 0;
  var t = e(Yn), n = Br(), o = Hi(), r = e(Ra()), i = function(p) {
    return (0, t.default)(p) == "object" && p !== null && !Array.isArray(p);
  }, a = function(p, f, g) {
    return f == "func" ? s(p, g) : p;
  };
  mc.completeValue = a;
  var s = function(p, f) {
    var g = function(b) {
      if (b) {
        var v = b.get("func"), $ = v && (0, n.getFuncConfig)(f, v);
        if ($) {
          var k = b, S = !1;
          for (var O in $.args) {
            var I = $.args[O], D = I.valueSources, M = I.isOptional, N = I.defaultValue, C = (0, o.filterValueSourcesForField)(f, D, I), P = k.get("args"), x = C.length == 1 ? C[0] : void 0, w = P ? P.get(O) : void 0, E = w ? w.get("value") : void 0, T = (w ? w.get("valueSrc") : void 0) || x;
            if (E !== void 0) {
              var z = a(E, T, f);
              if (z === void 0 || (z !== E && (k = k.setIn(["args", O, "value"], z)), S))
                return;
            } else if (N !== void 0 && !i(N))
              k = k.setIn(["args", O, "value"], l(I)), k = k.setIn(["args", O, "valueSrc"], "value");
            else if (M)
              S = !0;
            else
              return;
          }
          return k;
        }
      }
    };
    return g(p);
  };
  mc.completeFuncValue = s;
  var c = function(p, f, g) {
    var h = g.settings.fieldSeparator;
    p = p || new r.default.Map(), Array.isArray(f) && (f = f.join(h)), p = p.set("func", f), p = p.set("args", new r.default.Map());
    var b = f && (0, n.getFuncConfig)(g, f);
    if (b)
      for (var v in b.args) {
        var $ = b.args[v], k = $.valueSources, S = $.defaultValue, O = (0, o.filterValueSourcesForField)(g, k, $), I = O.length ? O[0] : void 0, D = S ? i(S) && S.func ? "func" : "value" : void 0, M = D || I;
        S !== void 0 && (p = p.setIn(["args", v, "value"], l($))), M && (p = p.setIn(["args", v, "valueSrc"], M));
      }
    return p;
  };
  mc.setFunc = c;
  var l = function(p) {
    var f = p.defaultValue;
    return i(f) && !r.default.Map.isMap(f) && f.func ? r.default.fromJS(f, function(g, h) {
      return r.default.Iterable.isIndexed(h) ? h.toList() : h.toOrderedMap();
    }) : f;
  }, d = function(p, f, g, h, b) {
    if (p && p.get("func")) {
      p = p.setIn(["args", f, "value"], g);
      var v = h.valueSources, $ = (0, o.filterValueSourcesForField)(b, v, h), k = $.length == 1 ? $[0] : void 0;
      k && (p = p.setIn(["args", f, "valueSrc"], k));
    }
    return p;
  };
  mc.setArgValue = d;
  var u = function(p, f, g, h, b) {
    return p && p.get("func") && (p = p.setIn(["args", f], new r.default.Map({
      valueSrc: g
    }))), p;
  };
  return mc.setArgValueSrc = u, mc;
}
var roe;
function xad() {
  return roe || (roe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(pa), r = t(Wc), i = t(yr), a = t($r), s = t(ua()), c = t(wr), l = t(kr()), d = t(ir()), u = k(ve), _ = t(di), p = t(bad()), f = Br(), g = t(oz()), h = wu(), b = wg(), v = Na();
    function $(M) {
      if (typeof WeakMap != "function")
        return null;
      var N = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
      return ($ = function(x) {
        return x ? C : N;
      })(M);
    }
    function k(M, N) {
      if (!N && M && M.__esModule)
        return M;
      if (M === null || n(M) !== "object" && typeof M != "function")
        return { default: M };
      var C = $(N);
      if (C && C.has(M))
        return C.get(M);
      var P = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in M)
        if (w !== "default" && Object.prototype.hasOwnProperty.call(M, w)) {
          var E = x ? Object.getOwnPropertyDescriptor(M, w) : null;
          E && (E.get || E.set) ? Object.defineProperty(P, w, E) : P[w] = M[w];
        }
      return P.default = M, C && C.set(M, P), P;
    }
    function S(M) {
      var N = O();
      return function() {
        var P = (0, d.default)(M), x;
        if (N) {
          var w = (0, d.default)(this).constructor;
          x = Reflect.construct(P, arguments, w);
        } else
          x = P.apply(this, arguments);
        return (0, l.default)(this, x);
      };
    }
    function O() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var I = /* @__PURE__ */ function(M) {
      (0, c.default)(C, M);
      var N = S(C);
      function C(P) {
        var x;
        return (0, i.default)(this, C), x = N.call(this, P), x.setFunc = function(w) {
          x.props.setValue((0, b.setFunc)(x.props.value, w, x.props.config));
        }, x.setArgValue = function(w, E) {
          var T = x.props.config, z = x.meta.funcDefinition, j = z.args, q = j[w];
          x.props.setValue((0, b.setArgValue)(x.props.value, w, E, q, T));
        }, x.setArgValueSrc = function(w, E) {
          var T = x.props.config, z = x.meta.funcDefinition, j = z.args, q = j[w];
          x.props.setValue((0, b.setArgValueSrc)(x.props.value, w, E, q, T));
        }, x.renderFuncSelect = function() {
          var w = x.props, E = w.config, T = w.field, z = w.operator, j = w.customProps, q = w.value, V = w.readonly, F = w.parentFuncs, L = w.id, U = w.groupId, W = q ? q.get("func") : null, H = {
            value: W,
            setValue: x.setFunc,
            config: E,
            field: T,
            operator: z,
            customProps: j,
            readonly: V,
            parentFuncs: F,
            id: L,
            groupId: U
          }, Q = E.settings, X = Q.showLabels, re = Q.funcLabel, Z = X ? /* @__PURE__ */ u.default.createElement("label", {
            className: "rule--label"
          }, re) : null;
          return /* @__PURE__ */ u.default.createElement(h.Col, {
            key: "func",
            className: "rule--func"
          }, Z, /* @__PURE__ */ u.default.createElement(p.default, H));
        }, x.renderArgLabel = function(w, E) {
          var T = E.valueSources, z = E.type, j = E.showPrefix, q = E.label, V = x.props.config, F = T && T.length == 1 && T[0] == "const", L = !V.settings.showLabels && (z == "boolean" || F) && j;
          return L ? /* @__PURE__ */ u.default.createElement(h.Col, {
            className: "rule--func--arg-label"
          }, q || w) : null;
        }, x.renderArgLabelSep = function(w, E) {
          var T = E.valueSources, z = E.type, j = E.showPrefix, q = x.props.config, V = T && T.length == 1 && T[0] == "const", F = !q.settings.showLabels && (z == "boolean" || V) && j;
          return F ? /* @__PURE__ */ u.default.createElement(h.Col, {
            className: "rule--func--arg-label-sep"
          }, ":") : null;
        }, x.renderArgVal = function(w, E, T) {
          var z = x.props, j = z.config, q = z.field;
          z.operator;
          var V = z.value, F = z.readonly, L = z.parentFuncs, U = z.id, W = z.groupId, H = V ? V.getIn(["args", E]) : null, Q = H ? H.get("value") : void 0, X = T.valueSources.length == 1 ? T.valueSources[0] : void 0, re = H ? H.get("valueSrc") || X || "value" : X, Z = {
            config: j,
            fieldFunc: w,
            fieldArg: E,
            leftField: q,
            operator: null,
            value: Q,
            valueSrc: re,
            setValue: x.setArgValue,
            setValueSrc: x.setArgValueSrc,
            funcKey: w,
            argKey: E,
            argDefinition: T,
            readonly: F,
            parentFuncs: L,
            id: U,
            groupId: W
          };
          return /* @__PURE__ */ u.default.createElement(h.Col, {
            className: "rule--func--arg-value"
          }, /* @__PURE__ */ u.default.createElement(D, Z));
        }, x.renderArgSep = function(w, E, T, z) {
          var j = z.renderSeps;
          return T ? /* @__PURE__ */ u.default.createElement(h.Col, {
            className: "rule--func--arg-sep"
          }, j ? j[T - 1] : ", ") : null;
        }, x.renderBracketBefore = function(w) {
          var E = w.renderBrackets;
          return /* @__PURE__ */ u.default.createElement(h.Col, {
            key: "before_args",
            className: "rule--func--bracket-before"
          }, E ? E[0] : "(");
        }, x.renderBracketAfter = function(w) {
          var E = w.renderBrackets;
          return /* @__PURE__ */ u.default.createElement(h.Col, {
            key: "after_args",
            className: "rule--func--bracket-after"
          }, E ? E[1] : ")");
        }, x.renderFuncArgs = function() {
          var w = x.meta, E = w.funcDefinition, T = w.funcKey;
          if (!T)
            return null;
          var z = E.args;
          return z ? /* @__PURE__ */ u.default.createElement(u.default.Fragment, null, x.renderBracketBefore(E), /* @__PURE__ */ u.default.createElement(h.Col, {
            key: "args",
            className: "rule--func--args"
          }, Object.keys(z).map(function(j, q) {
            return /* @__PURE__ */ u.default.createElement(h.Col, {
              key: "arg-".concat(j, "-").concat(q),
              className: "rule--func--arg"
            }, x.renderArgSep(j, z[j], q, E), x.renderArgLabel(j, z[j]), x.renderArgLabelSep(j, z[j]), x.renderArgVal(T, j, z[j]));
          })), x.renderBracketAfter(E)) : null;
        }, (0, v.useOnPropsChanged)((0, s.default)(x)), x.onPropsChanged(P), x;
      }
      return (0, a.default)(C, [{
        key: "onPropsChanged",
        value: function(x) {
          var w = this.props, E = ["config", "field", "operator", "value"], T = !this.meta || E.map(function(z) {
            return x[z] !== w[z];
          }).filter(function(z) {
            return z;
          }).length > 0;
          T && (this.meta = this.getMeta(x));
        }
      }, {
        key: "getMeta",
        value: function(x) {
          var w = x.config;
          x.field, x.operator;
          var E = x.value, T = E ? E.get("func") : null, z = T ? (0, f.getFuncConfig)(w, T) : null;
          return {
            funcDefinition: z,
            funcKey: T
          };
        }
      }, {
        key: "render",
        value: function() {
          return /* @__PURE__ */ u.default.createElement(h.Col, {
            className: "rule--func--wrapper"
          }, this.renderFuncSelect(), this.renderFuncArgs());
        }
      }]), C;
    }(u.PureComponent);
    e.default = I, I.propTypes = {
      id: _.default.string,
      groupId: _.default.string,
      config: _.default.object.isRequired,
      field: _.default.string.isRequired,
      operator: _.default.string,
      customProps: _.default.object,
      value: _.default.object,
      //instanceOf(Immutable.Map) //with keys 'func' and `args`
      setValue: _.default.func.isRequired,
      readonly: _.default.bool,
      parentFuncs: _.default.array
    };
    var D = /* @__PURE__ */ function(M) {
      (0, c.default)(C, M);
      var N = S(C);
      function C() {
        var P;
        (0, i.default)(this, C);
        for (var x = arguments.length, w = new Array(x), E = 0; E < x; E++)
          w[E] = arguments[E];
        return P = N.call.apply(N, [this].concat(w)), P.setValue = function(T, z, j) {
          var q = P.props, V = q.setValue, F = q.argKey;
          V(F, z);
        }, P.setValueSrc = function(T, z, j) {
          var q = P.props, V = q.setValueSrc, F = q.argKey;
          V(F, z);
        }, P;
      }
      return (0, a.default)(C, [{
        key: "render",
        value: function() {
          var x = this.props, w = x.funcKey, E = x.parentFuncs;
          return /* @__PURE__ */ u.default.createElement(g.default, (0, o.default)({}, this.props, {
            setValue: this.setValue,
            setValueSrc: this.setValueSrc,
            isFuncArg: !0,
            parentFuncs: [].concat((0, r.default)(E || []), [w])
          }));
        }
      }]), C;
    }(u.PureComponent);
    D.propTypes = {
      funcKey: _.default.string.isRequired,
      argKey: _.default.string.isRequired,
      setValue: _.default.func.isRequired,
      setValueSrc: _.default.func.isRequired,
      readonly: _.default.bool,
      parentFuncs: _.default.array,
      id: _.default.string,
      groupId: _.default.string
    };
  }(eR)), eR;
}
var _R = {}, pR = {}, ioe;
function Ead() {
  return ioe || (ioe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = t(_m()), i = function(s) {
      var c = s.value, l = s.setValue;
      s.config;
      var d = s.labelYes, u = s.labelNo, _ = s.readonly, p = s.customProps, f = p === void 0 ? {} : p, g = f.radioYes || {}, h = f.radioNo || {}, b = function(S) {
        return l(S.target.value == "true");
      }, v = (0, r.default)(), $ = (0, r.default)();
      return /* @__PURE__ */ o.default.createElement(o.default.Fragment, null, /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: v,
        type: "radio",
        id: v,
        value: !0,
        checked: !!c,
        disabled: _,
        onChange: b
      }, g)), /* @__PURE__ */ o.default.createElement("label", {
        style: {
          display: "inline"
        },
        key: v + "label",
        htmlFor: v
      }, d), /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: $,
        type: "radio",
        id: $,
        value: !1,
        checked: !c,
        disabled: _,
        onChange: b
      }, h)), /* @__PURE__ */ o.default.createElement("label", {
        style: {
          display: "inline"
        },
        key: $ + "label",
        htmlFor: $
      }, u));
    };
    e.default = i;
  }(pR)), pR;
}
var mR = {}, aoe;
function Tad() {
  return aoe || (aoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, d = a.placeholder, u = a.maxLength, _ = a.customProps, p = function(h) {
        var b = h.target.value;
        b === "" && (b = void 0), c(b);
      }, f = s || "";
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "text",
        value: f,
        placeholder: d,
        disabled: l,
        onChange: p,
        maxLength: u
      }, _));
    };
    e.default = r;
  }(mR)), mR;
}
var fR = {}, soe;
function Aad() {
  return soe || (soe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, d = a.placeholder, u = a.maxLength;
      a.maxRows;
      var _ = a.fullWidth, p = a.customProps, f = function(b) {
        var v = b.target.value;
        v === "" && (v = void 0), c(v);
      }, g = s || "";
      return /* @__PURE__ */ o.default.createElement("textarea", (0, n.default)({
        value: g,
        placeholder: d,
        disabled: l,
        onChange: f,
        maxLength: u,
        style: {
          width: _ ? "100%" : void 0
        }
      }, p));
    };
    e.default = r;
  }(fR)), fR;
}
var gR = {};
//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Q0e;
function Gt() {
  return Q0e.apply(null, arguments);
}
function Cad(e) {
  Q0e = e;
}
function ud(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Nf(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ko(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function n7(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Ko(e, t))
      return !1;
  return !0;
}
function Ws(e) {
  return e === void 0;
}
function A_(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Ak(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function J0e(e, t) {
  var n = [], o, r = e.length;
  for (o = 0; o < r; ++o)
    n.push(t(e[o], o));
  return n;
}
function Rp(e, t) {
  for (var n in t)
    Ko(t, n) && (e[n] = t[n]);
  return Ko(t, "toString") && (e.toString = t.toString), Ko(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ku(e, t, n, o) {
  return wke(e, t, n, o, !0).utc();
}
function zad() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function _o(e) {
  return e._pf == null && (e._pf = zad()), e._pf;
}
var uq;
Array.prototype.some ? uq = Array.prototype.some : uq = function(e) {
  var t = Object(this), n = t.length >>> 0, o;
  for (o = 0; o < n; o++)
    if (o in t && e.call(this, t[o], o, t))
      return !0;
  return !1;
};
function o7(e) {
  if (e._isValid == null) {
    var t = _o(e), n = uq.call(t.parsedDateParts, function(r) {
      return r != null;
    }), o = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
    if (e._strict && (o = o && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = o;
    else
      return o;
  }
  return e._isValid;
}
function rz(e) {
  var t = ku(NaN);
  return e != null ? Rp(_o(t), e) : _o(t).userInvalidated = !0, t;
}
var coe = Gt.momentProperties = [], hR = !1;
function r7(e, t) {
  var n, o, r, i = coe.length;
  if (Ws(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ws(t._i) || (e._i = t._i), Ws(t._f) || (e._f = t._f), Ws(t._l) || (e._l = t._l), Ws(t._strict) || (e._strict = t._strict), Ws(t._tzm) || (e._tzm = t._tzm), Ws(t._isUTC) || (e._isUTC = t._isUTC), Ws(t._offset) || (e._offset = t._offset), Ws(t._pf) || (e._pf = _o(t)), Ws(t._locale) || (e._locale = t._locale), i > 0)
    for (n = 0; n < i; n++)
      o = coe[n], r = t[o], Ws(r) || (e[o] = r);
  return e;
}
function Ck(e) {
  r7(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), hR === !1 && (hR = !0, Gt.updateOffset(this), hR = !1);
}
function _d(e) {
  return e instanceof Ck || e != null && e._isAMomentObject != null;
}
function X0e(e) {
  Gt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Cl(e, t) {
  var n = !0;
  return Rp(function() {
    if (Gt.deprecationHandler != null && Gt.deprecationHandler(null, e), n) {
      var o = [], r, i, a, s = arguments.length;
      for (i = 0; i < s; i++) {
        if (r = "", typeof arguments[i] == "object") {
          r += `
[` + i + "] ";
          for (a in arguments[0])
            Ko(arguments[0], a) && (r += a + ": " + arguments[0][a] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[i];
        o.push(r);
      }
      X0e(
        e + `
Arguments: ` + Array.prototype.slice.call(o).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var loe = {};
function eke(e, t) {
  Gt.deprecationHandler != null && Gt.deprecationHandler(e, t), loe[e] || (X0e(t), loe[e] = !0);
}
Gt.suppressDeprecationWarnings = !1;
Gt.deprecationHandler = null;
function Su(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Oad(e) {
  var t, n;
  for (n in e)
    Ko(e, n) && (t = e[n], Su(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function _q(e, t) {
  var n = Rp({}, e), o;
  for (o in t)
    Ko(t, o) && (Nf(e[o]) && Nf(t[o]) ? (n[o] = {}, Rp(n[o], e[o]), Rp(n[o], t[o])) : t[o] != null ? n[o] = t[o] : delete n[o]);
  for (o in e)
    Ko(e, o) && !Ko(t, o) && Nf(e[o]) && (n[o] = Rp({}, n[o]));
  return n;
}
function i7(e) {
  e != null && this.set(e);
}
var pq;
Object.keys ? pq = Object.keys : pq = function(e) {
  var t, n = [];
  for (t in e)
    Ko(e, t) && n.push(t);
  return n;
};
var Pad = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Iad(e, t, n) {
  var o = this._calendar[e] || this._calendar.sameElse;
  return Su(o) ? o.call(t, n) : o;
}
function _u(e, t, n) {
  var o = "" + Math.abs(e), r = t - o.length, i = e >= 0;
  return (i ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + o;
}
var a7 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, _S = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, vR = {}, nv = {};
function vn(e, t, n, o) {
  var r = o;
  typeof o == "string" && (r = function() {
    return this[o]();
  }), e && (nv[e] = r), t && (nv[t[0]] = function() {
    return _u(r.apply(this, arguments), t[1], t[2]);
  }), n && (nv[n] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      e
    );
  });
}
function Rad(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Nad(e) {
  var t = e.match(a7), n, o;
  for (n = 0, o = t.length; n < o; n++)
    nv[t[n]] ? t[n] = nv[t[n]] : t[n] = Rad(t[n]);
  return function(r) {
    var i = "", a;
    for (a = 0; a < o; a++)
      i += Su(t[a]) ? t[a].call(r, e) : t[a];
    return i;
  };
}
function fx(e, t) {
  return e.isValid() ? (t = tke(t, e.localeData()), vR[t] = vR[t] || Nad(t), vR[t](e)) : e.localeData().invalidDate();
}
function tke(e, t) {
  var n = 5;
  function o(r) {
    return t.longDateFormat(r) || r;
  }
  for (_S.lastIndex = 0; n >= 0 && _S.test(e); )
    e = e.replace(
      _S,
      o
    ), _S.lastIndex = 0, n -= 1;
  return e;
}
var Dad = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Mad(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(a7).map(function(o) {
    return o === "MMMM" || o === "MM" || o === "DD" || o === "dddd" ? o.slice(1) : o;
  }).join(""), this._longDateFormat[e]);
}
var Lad = "Invalid date";
function qad() {
  return this._invalidDate;
}
var jad = "%d", Fad = /\d{1,2}/;
function Vad(e) {
  return this._ordinal.replace("%d", e);
}
var Bad = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Uad(e, t, n, o) {
  var r = this._relativeTime[n];
  return Su(r) ? r(e, t, n, o) : r.replace(/%d/i, e);
}
function Wad(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return Su(n) ? n(t) : n.replace(/%s/i, t);
}
var rw = {};
function as(e, t) {
  var n = e.toLowerCase();
  rw[n] = rw[n + "s"] = rw[t] = e;
}
function zl(e) {
  return typeof e == "string" ? rw[e] || rw[e.toLowerCase()] : void 0;
}
function s7(e) {
  var t = {}, n, o;
  for (o in e)
    Ko(e, o) && (n = zl(o), n && (t[n] = e[o]));
  return t;
}
var nke = {};
function ss(e, t) {
  nke[e] = t;
}
function Gad(e) {
  var t = [], n;
  for (n in e)
    Ko(e, n) && t.push({ unit: n, priority: nke[n] });
  return t.sort(function(o, r) {
    return o.priority - r.priority;
  }), t;
}
function iz(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function pl(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function ko(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = pl(t)), n;
}
function Ob(e, t) {
  return function(n) {
    return n != null ? (oke(this, e, n), Gt.updateOffset(this, t), this) : ST(this, e);
  };
}
function ST(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function oke(e, t, n) {
  e.isValid() && !isNaN(n) && (t === "FullYear" && iz(e.year()) && e.month() === 1 && e.date() === 29 ? (n = ko(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    n,
    e.month(),
    uz(n, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
}
function Had(e) {
  return e = zl(e), Su(this[e]) ? this[e]() : this;
}
function Kad(e, t) {
  if (typeof e == "object") {
    e = s7(e);
    var n = Gad(e), o, r = n.length;
    for (o = 0; o < r; o++)
      this[n[o].unit](e[n[o].unit]);
  } else if (e = zl(e), Su(this[e]))
    return this[e](t);
  return this;
}
var rke = /\d/, Gc = /\d\d/, ike = /\d{3}/, c7 = /\d{4}/, az = /[+-]?\d{6}/, Qr = /\d\d?/, ake = /\d\d\d\d?/, ske = /\d\d\d\d\d\d?/, sz = /\d{1,3}/, l7 = /\d{1,4}/, cz = /[+-]?\d{1,6}/, Pb = /\d+/, lz = /[+-]?\d+/, Yad = /Z|[+-]\d\d:?\d\d/gi, dz = /Z|[+-]\d\d(?::?\d\d)?/gi, Zad = /[+-]?\d+(\.\d{1,3})?/, zk = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, xT;
xT = {};
function tn(e, t, n) {
  xT[e] = Su(t) ? t : function(o, r) {
    return o && n ? n : t;
  };
}
function Qad(e, t) {
  return Ko(xT, e) ? xT[e](t._strict, t._locale) : new RegExp(Jad(e));
}
function Jad(e) {
  return xc(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, o, r, i) {
        return n || o || r || i;
      }
    )
  );
}
function xc(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var mq = {};
function zr(e, t) {
  var n, o = t, r;
  for (typeof e == "string" && (e = [e]), A_(t) && (o = function(i, a) {
    a[t] = ko(i);
  }), r = e.length, n = 0; n < r; n++)
    mq[e[n]] = o;
}
function Ok(e, t) {
  zr(e, function(n, o, r, i) {
    r._w = r._w || {}, t(n, r._w, r, i);
  });
}
function Xad(e, t, n) {
  t != null && Ko(mq, e) && mq[e](t, n._a, n, e);
}
var Ja = 0, u_ = 1, Hd = 2, Bi = 3, ed = 4, __ = 5, mf = 6, esd = 7, tsd = 8;
function nsd(e, t) {
  return (e % t + t) % t;
}
var ki;
Array.prototype.indexOf ? ki = Array.prototype.indexOf : ki = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function uz(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = nsd(t, 12);
  return e += (t - n) / 12, n === 1 ? iz(e) ? 29 : 28 : 31 - n % 7 % 2;
}
vn("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
vn("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
vn("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
as("month", "M");
ss("month", 8);
tn("M", Qr);
tn("MM", Qr, Gc);
tn("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
tn("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
zr(["M", "MM"], function(e, t) {
  t[u_] = ko(e) - 1;
});
zr(["MMM", "MMMM"], function(e, t, n, o) {
  var r = n._locale.monthsParse(e, o, n._strict);
  r != null ? t[u_] = r : _o(n).invalidMonth = e;
});
var osd = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), cke = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), lke = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, rsd = zk, isd = zk;
function asd(e, t) {
  return e ? ud(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || lke).test(t) ? "format" : "standalone"][e.month()] : ud(this._months) ? this._months : this._months.standalone;
}
function ssd(e, t) {
  return e ? ud(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[lke.test(t) ? "format" : "standalone"][e.month()] : ud(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function csd(e, t, n) {
  var o, r, i, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], o = 0; o < 12; ++o)
      i = ku([2e3, o]), this._shortMonthsParse[o] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[o] = this.months(i, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (r = ki.call(this._shortMonthsParse, a), r !== -1 ? r : null) : (r = ki.call(this._longMonthsParse, a), r !== -1 ? r : null) : t === "MMM" ? (r = ki.call(this._shortMonthsParse, a), r !== -1 ? r : (r = ki.call(this._longMonthsParse, a), r !== -1 ? r : null)) : (r = ki.call(this._longMonthsParse, a), r !== -1 ? r : (r = ki.call(this._shortMonthsParse, a), r !== -1 ? r : null));
}
function lsd(e, t, n) {
  var o, r, i;
  if (this._monthsParseExact)
    return csd.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), o = 0; o < 12; o++) {
    if (r = ku([2e3, o]), n && !this._longMonthsParse[o] && (this._longMonthsParse[o] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[o] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[o] && (i = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[o] = new RegExp(i.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[o].test(e))
      return o;
    if (n && t === "MMM" && this._shortMonthsParse[o].test(e))
      return o;
    if (!n && this._monthsParse[o].test(e))
      return o;
  }
}
function dke(e, t) {
  var n;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = ko(t);
    else if (t = e.localeData().monthsParse(t), !A_(t))
      return e;
  }
  return n = Math.min(e.date(), uz(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
}
function uke(e) {
  return e != null ? (dke(this, e), Gt.updateOffset(this, !0), this) : ST(this, "Month");
}
function dsd() {
  return uz(this.year(), this.month());
}
function usd(e) {
  return this._monthsParseExact ? (Ko(this, "_monthsRegex") || _ke.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Ko(this, "_monthsShortRegex") || (this._monthsShortRegex = rsd), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function _sd(e) {
  return this._monthsParseExact ? (Ko(this, "_monthsRegex") || _ke.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Ko(this, "_monthsRegex") || (this._monthsRegex = isd), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function _ke() {
  function e(a, s) {
    return s.length - a.length;
  }
  var t = [], n = [], o = [], r, i;
  for (r = 0; r < 12; r++)
    i = ku([2e3, r]), t.push(this.monthsShort(i, "")), n.push(this.months(i, "")), o.push(this.months(i, "")), o.push(this.monthsShort(i, ""));
  for (t.sort(e), n.sort(e), o.sort(e), r = 0; r < 12; r++)
    t[r] = xc(t[r]), n[r] = xc(n[r]);
  for (r = 0; r < 24; r++)
    o[r] = xc(o[r]);
  this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
vn("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? _u(e, 4) : "+" + e;
});
vn(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
vn(0, ["YYYY", 4], 0, "year");
vn(0, ["YYYYY", 5], 0, "year");
vn(0, ["YYYYYY", 6, !0], 0, "year");
as("year", "y");
ss("year", 1);
tn("Y", lz);
tn("YY", Qr, Gc);
tn("YYYY", l7, c7);
tn("YYYYY", cz, az);
tn("YYYYYY", cz, az);
zr(["YYYYY", "YYYYYY"], Ja);
zr("YYYY", function(e, t) {
  t[Ja] = e.length === 2 ? Gt.parseTwoDigitYear(e) : ko(e);
});
zr("YY", function(e, t) {
  t[Ja] = Gt.parseTwoDigitYear(e);
});
zr("Y", function(e, t) {
  t[Ja] = parseInt(e, 10);
});
function iw(e) {
  return iz(e) ? 366 : 365;
}
Gt.parseTwoDigitYear = function(e) {
  return ko(e) + (ko(e) > 68 ? 1900 : 2e3);
};
var pke = Ob("FullYear", !0);
function psd() {
  return iz(this.year());
}
function msd(e, t, n, o, r, i, a) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, o, r, i, a), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, o, r, i, a), s;
}
function _0(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function ET(e, t, n) {
  var o = 7 + t - n, r = (7 + _0(e, 0, o).getUTCDay() - t) % 7;
  return -r + o - 1;
}
function mke(e, t, n, o, r) {
  var i = (7 + n - o) % 7, a = ET(e, o, r), s = 1 + 7 * (t - 1) + i + a, c, l;
  return s <= 0 ? (c = e - 1, l = iw(c) + s) : s > iw(e) ? (c = e + 1, l = s - iw(e)) : (c = e, l = s), {
    year: c,
    dayOfYear: l
  };
}
function p0(e, t, n) {
  var o = ET(e.year(), t, n), r = Math.floor((e.dayOfYear() - o - 1) / 7) + 1, i, a;
  return r < 1 ? (a = e.year() - 1, i = r + $_(a, t, n)) : r > $_(e.year(), t, n) ? (i = r - $_(e.year(), t, n), a = e.year() + 1) : (a = e.year(), i = r), {
    week: i,
    year: a
  };
}
function $_(e, t, n) {
  var o = ET(e, t, n), r = ET(e + 1, t, n);
  return (iw(e) - o + r) / 7;
}
vn("w", ["ww", 2], "wo", "week");
vn("W", ["WW", 2], "Wo", "isoWeek");
as("week", "w");
as("isoWeek", "W");
ss("week", 5);
ss("isoWeek", 5);
tn("w", Qr);
tn("ww", Qr, Gc);
tn("W", Qr);
tn("WW", Qr, Gc);
Ok(
  ["w", "ww", "W", "WW"],
  function(e, t, n, o) {
    t[o.substr(0, 1)] = ko(e);
  }
);
function fsd(e) {
  return p0(e, this._week.dow, this._week.doy).week;
}
var gsd = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function hsd() {
  return this._week.dow;
}
function vsd() {
  return this._week.doy;
}
function bsd(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function ysd(e) {
  var t = p0(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
vn("d", 0, "do", "day");
vn("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
vn("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
vn("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
vn("e", 0, 0, "weekday");
vn("E", 0, 0, "isoWeekday");
as("day", "d");
as("weekday", "e");
as("isoWeekday", "E");
ss("day", 11);
ss("weekday", 11);
ss("isoWeekday", 11);
tn("d", Qr);
tn("e", Qr);
tn("E", Qr);
tn("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
tn("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
tn("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Ok(["dd", "ddd", "dddd"], function(e, t, n, o) {
  var r = n._locale.weekdaysParse(e, o, n._strict);
  r != null ? t.d = r : _o(n).invalidWeekday = e;
});
Ok(["d", "e", "E"], function(e, t, n, o) {
  t[o] = ko(e);
});
function $sd(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function wsd(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function d7(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var ksd = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), fke = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Ssd = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), xsd = zk, Esd = zk, Tsd = zk;
function Asd(e, t) {
  var n = ud(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? d7(n, this._week.dow) : e ? n[e.day()] : n;
}
function Csd(e) {
  return e === !0 ? d7(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function zsd(e) {
  return e === !0 ? d7(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Osd(e, t, n) {
  var o, r, i, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], o = 0; o < 7; ++o)
      i = ku([2e3, 1]).day(o), this._minWeekdaysParse[o] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[o] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[o] = this.weekdays(i, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (r = ki.call(this._weekdaysParse, a), r !== -1 ? r : null) : t === "ddd" ? (r = ki.call(this._shortWeekdaysParse, a), r !== -1 ? r : null) : (r = ki.call(this._minWeekdaysParse, a), r !== -1 ? r : null) : t === "dddd" ? (r = ki.call(this._weekdaysParse, a), r !== -1 || (r = ki.call(this._shortWeekdaysParse, a), r !== -1) ? r : (r = ki.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : t === "ddd" ? (r = ki.call(this._shortWeekdaysParse, a), r !== -1 || (r = ki.call(this._weekdaysParse, a), r !== -1) ? r : (r = ki.call(this._minWeekdaysParse, a), r !== -1 ? r : null)) : (r = ki.call(this._minWeekdaysParse, a), r !== -1 || (r = ki.call(this._weekdaysParse, a), r !== -1) ? r : (r = ki.call(this._shortWeekdaysParse, a), r !== -1 ? r : null));
}
function Psd(e, t, n) {
  var o, r, i;
  if (this._weekdaysParseExact)
    return Osd.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), o = 0; o < 7; o++) {
    if (r = ku([2e3, 1]).day(o), n && !this._fullWeekdaysParse[o] && (this._fullWeekdaysParse[o] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[o] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[o] || (i = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[o] = new RegExp(i.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[o].test(e))
      return o;
    if (n && t === "ddd" && this._shortWeekdaysParse[o].test(e))
      return o;
    if (n && t === "dd" && this._minWeekdaysParse[o].test(e))
      return o;
    if (!n && this._weekdaysParse[o].test(e))
      return o;
  }
}
function Isd(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = $sd(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Rsd(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Nsd(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = wsd(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Dsd(e) {
  return this._weekdaysParseExact ? (Ko(this, "_weekdaysRegex") || u7.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Ko(this, "_weekdaysRegex") || (this._weekdaysRegex = xsd), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Msd(e) {
  return this._weekdaysParseExact ? (Ko(this, "_weekdaysRegex") || u7.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Ko(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Esd), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Lsd(e) {
  return this._weekdaysParseExact ? (Ko(this, "_weekdaysRegex") || u7.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Ko(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Tsd), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function u7() {
  function e(d, u) {
    return u.length - d.length;
  }
  var t = [], n = [], o = [], r = [], i, a, s, c, l;
  for (i = 0; i < 7; i++)
    a = ku([2e3, 1]).day(i), s = xc(this.weekdaysMin(a, "")), c = xc(this.weekdaysShort(a, "")), l = xc(this.weekdays(a, "")), t.push(s), n.push(c), o.push(l), r.push(s), r.push(c), r.push(l);
  t.sort(e), n.sort(e), o.sort(e), r.sort(e), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + o.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function _7() {
  return this.hours() % 12 || 12;
}
function qsd() {
  return this.hours() || 24;
}
vn("H", ["HH", 2], 0, "hour");
vn("h", ["hh", 2], 0, _7);
vn("k", ["kk", 2], 0, qsd);
vn("hmm", 0, 0, function() {
  return "" + _7.apply(this) + _u(this.minutes(), 2);
});
vn("hmmss", 0, 0, function() {
  return "" + _7.apply(this) + _u(this.minutes(), 2) + _u(this.seconds(), 2);
});
vn("Hmm", 0, 0, function() {
  return "" + this.hours() + _u(this.minutes(), 2);
});
vn("Hmmss", 0, 0, function() {
  return "" + this.hours() + _u(this.minutes(), 2) + _u(this.seconds(), 2);
});
function gke(e, t) {
  vn(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
gke("a", !0);
gke("A", !1);
as("hour", "h");
ss("hour", 13);
function hke(e, t) {
  return t._meridiemParse;
}
tn("a", hke);
tn("A", hke);
tn("H", Qr);
tn("h", Qr);
tn("k", Qr);
tn("HH", Qr, Gc);
tn("hh", Qr, Gc);
tn("kk", Qr, Gc);
tn("hmm", ake);
tn("hmmss", ske);
tn("Hmm", ake);
tn("Hmmss", ske);
zr(["H", "HH"], Bi);
zr(["k", "kk"], function(e, t, n) {
  var o = ko(e);
  t[Bi] = o === 24 ? 0 : o;
});
zr(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
zr(["h", "hh"], function(e, t, n) {
  t[Bi] = ko(e), _o(n).bigHour = !0;
});
zr("hmm", function(e, t, n) {
  var o = e.length - 2;
  t[Bi] = ko(e.substr(0, o)), t[ed] = ko(e.substr(o)), _o(n).bigHour = !0;
});
zr("hmmss", function(e, t, n) {
  var o = e.length - 4, r = e.length - 2;
  t[Bi] = ko(e.substr(0, o)), t[ed] = ko(e.substr(o, 2)), t[__] = ko(e.substr(r)), _o(n).bigHour = !0;
});
zr("Hmm", function(e, t, n) {
  var o = e.length - 2;
  t[Bi] = ko(e.substr(0, o)), t[ed] = ko(e.substr(o));
});
zr("Hmmss", function(e, t, n) {
  var o = e.length - 4, r = e.length - 2;
  t[Bi] = ko(e.substr(0, o)), t[ed] = ko(e.substr(o, 2)), t[__] = ko(e.substr(r));
});
function jsd(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Fsd = /[ap]\.?m?\.?/i, Vsd = Ob("Hours", !0);
function Bsd(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var vke = {
  calendar: Pad,
  longDateFormat: Dad,
  invalidDate: Lad,
  ordinal: jad,
  dayOfMonthOrdinalParse: Fad,
  relativeTime: Bad,
  months: osd,
  monthsShort: cke,
  week: gsd,
  weekdays: ksd,
  weekdaysMin: Ssd,
  weekdaysShort: fke,
  meridiemParse: Fsd
}, Jr = {}, Jy = {}, m0;
function Usd(e, t) {
  var n, o = Math.min(e.length, t.length);
  for (n = 0; n < o; n += 1)
    if (e[n] !== t[n])
      return n;
  return o;
}
function doe(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Wsd(e) {
  for (var t = 0, n, o, r, i; t < e.length; ) {
    for (i = doe(e[t]).split("-"), n = i.length, o = doe(e[t + 1]), o = o ? o.split("-") : null; n > 0; ) {
      if (r = _z(i.slice(0, n).join("-")), r)
        return r;
      if (o && o.length >= n && Usd(i, o) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return m0;
}
function Gsd(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function _z(e) {
  var t = null, n;
  if (Jr[e] === void 0 && typeof module < "u" && module && module.exports && Gsd(e))
    try {
      t = m0._abbr, n = require, n("./locale/" + e), Gp(t);
    } catch {
      Jr[e] = null;
    }
  return Jr[e];
}
function Gp(e, t) {
  var n;
  return e && (Ws(t) ? n = V_(e) : n = p7(e, t), n ? m0 = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), m0._abbr;
}
function p7(e, t) {
  if (t !== null) {
    var n, o = vke;
    if (t.abbr = e, Jr[e] != null)
      eke(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), o = Jr[e]._config;
    else if (t.parentLocale != null)
      if (Jr[t.parentLocale] != null)
        o = Jr[t.parentLocale]._config;
      else if (n = _z(t.parentLocale), n != null)
        o = n._config;
      else
        return Jy[t.parentLocale] || (Jy[t.parentLocale] = []), Jy[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return Jr[e] = new i7(_q(o, t)), Jy[e] && Jy[e].forEach(function(r) {
      p7(r.name, r.config);
    }), Gp(e), Jr[e];
  } else
    return delete Jr[e], null;
}
function Hsd(e, t) {
  if (t != null) {
    var n, o, r = vke;
    Jr[e] != null && Jr[e].parentLocale != null ? Jr[e].set(_q(Jr[e]._config, t)) : (o = _z(e), o != null && (r = o._config), t = _q(r, t), o == null && (t.abbr = e), n = new i7(t), n.parentLocale = Jr[e], Jr[e] = n), Gp(e);
  } else
    Jr[e] != null && (Jr[e].parentLocale != null ? (Jr[e] = Jr[e].parentLocale, e === Gp() && Gp(e)) : Jr[e] != null && delete Jr[e]);
  return Jr[e];
}
function V_(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return m0;
  if (!ud(e)) {
    if (t = _z(e), t)
      return t;
    e = [e];
  }
  return Wsd(e);
}
function Ksd() {
  return pq(Jr);
}
function m7(e) {
  var t, n = e._a;
  return n && _o(e).overflow === -2 && (t = n[u_] < 0 || n[u_] > 11 ? u_ : n[Hd] < 1 || n[Hd] > uz(n[Ja], n[u_]) ? Hd : n[Bi] < 0 || n[Bi] > 24 || n[Bi] === 24 && (n[ed] !== 0 || n[__] !== 0 || n[mf] !== 0) ? Bi : n[ed] < 0 || n[ed] > 59 ? ed : n[__] < 0 || n[__] > 59 ? __ : n[mf] < 0 || n[mf] > 999 ? mf : -1, _o(e)._overflowDayOfYear && (t < Ja || t > Hd) && (t = Hd), _o(e)._overflowWeeks && t === -1 && (t = esd), _o(e)._overflowWeekday && t === -1 && (t = tsd), _o(e).overflow = t), e;
}
var Ysd = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Zsd = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Qsd = /Z|[+-]\d\d(?::?\d\d)?/, pS = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], bR = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Jsd = /^\/?Date\((-?\d+)/i, Xsd = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, ecd = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function bke(e) {
  var t, n, o = e._i, r = Ysd.exec(o) || Zsd.exec(o), i, a, s, c, l = pS.length, d = bR.length;
  if (r) {
    for (_o(e).iso = !0, t = 0, n = l; t < n; t++)
      if (pS[t][1].exec(r[1])) {
        a = pS[t][0], i = pS[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (r[3]) {
      for (t = 0, n = d; t < n; t++)
        if (bR[t][1].exec(r[3])) {
          s = (r[2] || " ") + bR[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!i && s != null) {
      e._isValid = !1;
      return;
    }
    if (r[4])
      if (Qsd.exec(r[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (s || "") + (c || ""), g7(e);
  } else
    e._isValid = !1;
}
function tcd(e, t, n, o, r, i) {
  var a = [
    ncd(e),
    cke.indexOf(t),
    parseInt(n, 10),
    parseInt(o, 10),
    parseInt(r, 10)
  ];
  return i && a.push(parseInt(i, 10)), a;
}
function ncd(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function ocd(e) {
  return e.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function rcd(e, t, n) {
  if (e) {
    var o = fke.indexOf(e), r = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (o !== r)
      return _o(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function icd(e, t, n) {
  if (e)
    return ecd[e];
  if (t)
    return 0;
  var o = parseInt(n, 10), r = o % 100, i = (o - r) / 100;
  return i * 60 + r;
}
function yke(e) {
  var t = Xsd.exec(ocd(e._i)), n;
  if (t) {
    if (n = tcd(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !rcd(t[1], n, e))
      return;
    e._a = n, e._tzm = icd(t[8], t[9], t[10]), e._d = _0.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), _o(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function acd(e) {
  var t = Jsd.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (bke(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (yke(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Gt.createFromInputFallback(e);
}
Gt.createFromInputFallback = Cl(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function vh(e, t, n) {
  return e ?? t ?? n;
}
function scd(e) {
  var t = new Date(Gt.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function f7(e) {
  var t, n, o = [], r, i, a;
  if (!e._d) {
    for (r = scd(e), e._w && e._a[Hd] == null && e._a[u_] == null && ccd(e), e._dayOfYear != null && (a = vh(e._a[Ja], r[Ja]), (e._dayOfYear > iw(a) || e._dayOfYear === 0) && (_o(e)._overflowDayOfYear = !0), n = _0(a, 0, e._dayOfYear), e._a[u_] = n.getUTCMonth(), e._a[Hd] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = o[t] = r[t];
    for (; t < 7; t++)
      e._a[t] = o[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Bi] === 24 && e._a[ed] === 0 && e._a[__] === 0 && e._a[mf] === 0 && (e._nextDay = !0, e._a[Bi] = 0), e._d = (e._useUTC ? _0 : msd).apply(
      null,
      o
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Bi] = 24), e._w && typeof e._w.d < "u" && e._w.d !== i && (_o(e).weekdayMismatch = !0);
  }
}
function ccd(e) {
  var t, n, o, r, i, a, s, c, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (i = 1, a = 4, n = vh(
    t.GG,
    e._a[Ja],
    p0(Yr(), 1, 4).year
  ), o = vh(t.W, 1), r = vh(t.E, 1), (r < 1 || r > 7) && (c = !0)) : (i = e._locale._week.dow, a = e._locale._week.doy, l = p0(Yr(), i, a), n = vh(t.gg, e._a[Ja], l.year), o = vh(t.w, l.week), t.d != null ? (r = t.d, (r < 0 || r > 6) && (c = !0)) : t.e != null ? (r = t.e + i, (t.e < 0 || t.e > 6) && (c = !0)) : r = i), o < 1 || o > $_(n, i, a) ? _o(e)._overflowWeeks = !0 : c != null ? _o(e)._overflowWeekday = !0 : (s = mke(n, o, r, i, a), e._a[Ja] = s.year, e._dayOfYear = s.dayOfYear);
}
Gt.ISO_8601 = function() {
};
Gt.RFC_2822 = function() {
};
function g7(e) {
  if (e._f === Gt.ISO_8601) {
    bke(e);
    return;
  }
  if (e._f === Gt.RFC_2822) {
    yke(e);
    return;
  }
  e._a = [], _o(e).empty = !0;
  var t = "" + e._i, n, o, r, i, a, s = t.length, c = 0, l, d;
  for (r = tke(e._f, e._locale).match(a7) || [], d = r.length, n = 0; n < d; n++)
    i = r[n], o = (t.match(Qad(i, e)) || [])[0], o && (a = t.substr(0, t.indexOf(o)), a.length > 0 && _o(e).unusedInput.push(a), t = t.slice(
      t.indexOf(o) + o.length
    ), c += o.length), nv[i] ? (o ? _o(e).empty = !1 : _o(e).unusedTokens.push(i), Xad(i, o, e)) : e._strict && !o && _o(e).unusedTokens.push(i);
  _o(e).charsLeftOver = s - c, t.length > 0 && _o(e).unusedInput.push(t), e._a[Bi] <= 12 && _o(e).bigHour === !0 && e._a[Bi] > 0 && (_o(e).bigHour = void 0), _o(e).parsedDateParts = e._a.slice(0), _o(e).meridiem = e._meridiem, e._a[Bi] = lcd(
    e._locale,
    e._a[Bi],
    e._meridiem
  ), l = _o(e).era, l !== null && (e._a[Ja] = e._locale.erasConvertYear(l, e._a[Ja])), f7(e), m7(e);
}
function lcd(e, t, n) {
  var o;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (o = e.isPM(n), o && t < 12 && (t += 12), !o && t === 12 && (t = 0)), t);
}
function dcd(e) {
  var t, n, o, r, i, a, s = !1, c = e._f.length;
  if (c === 0) {
    _o(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < c; r++)
    i = 0, a = !1, t = r7({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[r], g7(t), o7(t) && (a = !0), i += _o(t).charsLeftOver, i += _o(t).unusedTokens.length * 10, _o(t).score = i, s ? i < o && (o = i, n = t) : (o == null || i < o || a) && (o = i, n = t, a && (s = !0));
  Rp(e, n || t);
}
function ucd(e) {
  if (!e._d) {
    var t = s7(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = J0e(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(o) {
        return o && parseInt(o, 10);
      }
    ), f7(e);
  }
}
function _cd(e) {
  var t = new Ck(m7($ke(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function $ke(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || V_(e._l), t === null || n === void 0 && t === "" ? rz({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), _d(t) ? new Ck(m7(t)) : (Ak(t) ? e._d = t : ud(n) ? dcd(e) : n ? g7(e) : pcd(e), o7(e) || (e._d = null), e));
}
function pcd(e) {
  var t = e._i;
  Ws(t) ? e._d = new Date(Gt.now()) : Ak(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? acd(e) : ud(t) ? (e._a = J0e(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), f7(e)) : Nf(t) ? ucd(e) : A_(t) ? e._d = new Date(t) : Gt.createFromInputFallback(e);
}
function wke(e, t, n, o, r) {
  var i = {};
  return (t === !0 || t === !1) && (o = t, t = void 0), (n === !0 || n === !1) && (o = n, n = void 0), (Nf(e) && n7(e) || ud(e) && e.length === 0) && (e = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = r, i._l = n, i._i = e, i._f = t, i._strict = o, _cd(i);
}
function Yr(e, t, n, o) {
  return wke(e, t, n, o, !1);
}
var mcd = Cl(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Yr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : rz();
  }
), fcd = Cl(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Yr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : rz();
  }
);
function kke(e, t) {
  var n, o;
  if (t.length === 1 && ud(t[0]) && (t = t[0]), !t.length)
    return Yr();
  for (n = t[0], o = 1; o < t.length; ++o)
    (!t[o].isValid() || t[o][e](n)) && (n = t[o]);
  return n;
}
function gcd() {
  var e = [].slice.call(arguments, 0);
  return kke("isBefore", e);
}
function hcd() {
  var e = [].slice.call(arguments, 0);
  return kke("isAfter", e);
}
var vcd = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Xy = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function bcd(e) {
  var t, n = !1, o, r = Xy.length;
  for (t in e)
    if (Ko(e, t) && !(ki.call(Xy, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (o = 0; o < r; ++o)
    if (e[Xy[o]]) {
      if (n)
        return !1;
      parseFloat(e[Xy[o]]) !== ko(e[Xy[o]]) && (n = !0);
    }
  return !0;
}
function ycd() {
  return this._isValid;
}
function $cd() {
  return yd(NaN);
}
function pz(e) {
  var t = s7(e), n = t.year || 0, o = t.quarter || 0, r = t.month || 0, i = t.week || t.isoWeek || 0, a = t.day || 0, s = t.hour || 0, c = t.minute || 0, l = t.second || 0, d = t.millisecond || 0;
  this._isValid = bcd(t), this._milliseconds = +d + l * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +a + i * 7, this._months = +r + o * 3 + n * 12, this._data = {}, this._locale = V_(), this._bubble();
}
function gx(e) {
  return e instanceof pz;
}
function fq(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function wcd(e, t, n) {
  var o = Math.min(e.length, t.length), r = Math.abs(e.length - t.length), i = 0, a;
  for (a = 0; a < o; a++)
    (n && e[a] !== t[a] || !n && ko(e[a]) !== ko(t[a])) && i++;
  return i + r;
}
function Ske(e, t) {
  vn(e, 0, 0, function() {
    var n = this.utcOffset(), o = "+";
    return n < 0 && (n = -n, o = "-"), o + _u(~~(n / 60), 2) + t + _u(~~n % 60, 2);
  });
}
Ske("Z", ":");
Ske("ZZ", "");
tn("Z", dz);
tn("ZZ", dz);
zr(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = h7(dz, e);
});
var kcd = /([\+\-]|\d\d)/gi;
function h7(e, t) {
  var n = (t || "").match(e), o, r, i;
  return n === null ? null : (o = n[n.length - 1] || [], r = (o + "").match(kcd) || ["-", 0, 0], i = +(r[1] * 60) + ko(r[2]), i === 0 ? 0 : r[0] === "+" ? i : -i);
}
function v7(e, t) {
  var n, o;
  return t._isUTC ? (n = t.clone(), o = (_d(e) || Ak(e) ? e.valueOf() : Yr(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + o), Gt.updateOffset(n, !1), n) : Yr(e).local();
}
function gq(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Gt.updateOffset = function() {
};
function Scd(e, t, n) {
  var o = this._offset || 0, r;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = h7(dz, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (r = gq(this)), this._offset = e, this._isUTC = !0, r != null && this.add(r, "m"), o !== e && (!t || this._changeInProgress ? Tke(
      this,
      yd(e - o, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Gt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? o : gq(this);
}
function xcd(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Ecd(e) {
  return this.utcOffset(0, e);
}
function Tcd(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(gq(this), "m")), this;
}
function Acd() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = h7(Yad, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Ccd(e) {
  return this.isValid() ? (e = e ? Yr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function zcd() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Ocd() {
  if (!Ws(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return r7(e, this), e = $ke(e), e._a ? (t = e._isUTC ? ku(e._a) : Yr(e._a), this._isDSTShifted = this.isValid() && wcd(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Pcd() {
  return this.isValid() ? !this._isUTC : !1;
}
function Icd() {
  return this.isValid() ? this._isUTC : !1;
}
function xke() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Rcd = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Ncd = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function yd(e, t) {
  var n = e, o = null, r, i, a;
  return gx(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : A_(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (o = Rcd.exec(e)) ? (r = o[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: ko(o[Hd]) * r,
    h: ko(o[Bi]) * r,
    m: ko(o[ed]) * r,
    s: ko(o[__]) * r,
    ms: ko(fq(o[mf] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (o = Ncd.exec(e)) ? (r = o[1] === "-" ? -1 : 1, n = {
    y: Mm(o[2], r),
    M: Mm(o[3], r),
    w: Mm(o[4], r),
    d: Mm(o[5], r),
    h: Mm(o[6], r),
    m: Mm(o[7], r),
    s: Mm(o[8], r)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (a = Dcd(
    Yr(n.from),
    Yr(n.to)
  ), n = {}, n.ms = a.milliseconds, n.M = a.months), i = new pz(n), gx(e) && Ko(e, "_locale") && (i._locale = e._locale), gx(e) && Ko(e, "_isValid") && (i._isValid = e._isValid), i;
}
yd.fn = pz.prototype;
yd.invalid = $cd;
function Mm(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function uoe(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function Dcd(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = v7(t, e), e.isBefore(t) ? n = uoe(e, t) : (n = uoe(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Eke(e, t) {
  return function(n, o) {
    var r, i;
    return o !== null && !isNaN(+o) && (eke(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = n, n = o, o = i), r = yd(n, o), Tke(this, r, e), this;
  };
}
function Tke(e, t, n, o) {
  var r = t._milliseconds, i = fq(t._days), a = fq(t._months);
  e.isValid() && (o = o ?? !0, a && dke(e, ST(e, "Month") + a * n), i && oke(e, "Date", ST(e, "Date") + i * n), r && e._d.setTime(e._d.valueOf() + r * n), o && Gt.updateOffset(e, i || a));
}
var Mcd = Eke(1, "add"), Lcd = Eke(-1, "subtract");
function Ake(e) {
  return typeof e == "string" || e instanceof String;
}
function qcd(e) {
  return _d(e) || Ak(e) || Ake(e) || A_(e) || Fcd(e) || jcd(e) || e === null || e === void 0;
}
function jcd(e) {
  var t = Nf(e) && !n7(e), n = !1, o = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, i, a = o.length;
  for (r = 0; r < a; r += 1)
    i = o[r], n = n || Ko(e, i);
  return t && n;
}
function Fcd(e) {
  var t = ud(e), n = !1;
  return t && (n = e.filter(function(o) {
    return !A_(o) && Ake(e);
  }).length === 0), t && n;
}
function Vcd(e) {
  var t = Nf(e) && !n7(e), n = !1, o = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, i;
  for (r = 0; r < o.length; r += 1)
    i = o[r], n = n || Ko(e, i);
  return t && n;
}
function Bcd(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function Ucd(e, t) {
  arguments.length === 1 && (arguments[0] ? qcd(arguments[0]) ? (e = arguments[0], t = void 0) : Vcd(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || Yr(), o = v7(n, this).startOf("day"), r = Gt.calendarFormat(this, o) || "sameElse", i = t && (Su(t[r]) ? t[r].call(this, n) : t[r]);
  return this.format(
    i || this.localeData().calendar(r, this, Yr(n))
  );
}
function Wcd() {
  return new Ck(this);
}
function Gcd(e, t) {
  var n = _d(e) ? e : Yr(e);
  return this.isValid() && n.isValid() ? (t = zl(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function Hcd(e, t) {
  var n = _d(e) ? e : Yr(e);
  return this.isValid() && n.isValid() ? (t = zl(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function Kcd(e, t, n, o) {
  var r = _d(e) ? e : Yr(e), i = _d(t) ? t : Yr(t);
  return this.isValid() && r.isValid() && i.isValid() ? (o = o || "()", (o[0] === "(" ? this.isAfter(r, n) : !this.isBefore(r, n)) && (o[1] === ")" ? this.isBefore(i, n) : !this.isAfter(i, n))) : !1;
}
function Ycd(e, t) {
  var n = _d(e) ? e : Yr(e), o;
  return this.isValid() && n.isValid() ? (t = zl(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (o = n.valueOf(), this.clone().startOf(t).valueOf() <= o && o <= this.clone().endOf(t).valueOf())) : !1;
}
function Zcd(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Qcd(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Jcd(e, t, n) {
  var o, r, i;
  if (!this.isValid())
    return NaN;
  if (o = v7(e, this), !o.isValid())
    return NaN;
  switch (r = (o.utcOffset() - this.utcOffset()) * 6e4, t = zl(t), t) {
    case "year":
      i = hx(this, o) / 12;
      break;
    case "month":
      i = hx(this, o);
      break;
    case "quarter":
      i = hx(this, o) / 3;
      break;
    case "second":
      i = (this - o) / 1e3;
      break;
    case "minute":
      i = (this - o) / 6e4;
      break;
    case "hour":
      i = (this - o) / 36e5;
      break;
    case "day":
      i = (this - o - r) / 864e5;
      break;
    case "week":
      i = (this - o - r) / 6048e5;
      break;
    default:
      i = this - o;
  }
  return n ? i : pl(i);
}
function hx(e, t) {
  if (e.date() < t.date())
    return -hx(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), o = e.clone().add(n, "months"), r, i;
  return t - o < 0 ? (r = e.clone().add(n - 1, "months"), i = (t - o) / (o - r)) : (r = e.clone().add(n + 1, "months"), i = (t - o) / (r - o)), -(n + i) || 0;
}
Gt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Gt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Xcd() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function eld(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? fx(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Su(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", fx(n, "Z")) : fx(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function tld() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, o, r, i;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', o = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", i = t + '[")]', this.format(n + o + r + i);
}
function nld(e) {
  e || (e = this.isUtc() ? Gt.defaultFormatUtc : Gt.defaultFormat);
  var t = fx(this, e);
  return this.localeData().postformat(t);
}
function old(e, t) {
  return this.isValid() && (_d(e) && e.isValid() || Yr(e).isValid()) ? yd({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function rld(e) {
  return this.from(Yr(), e);
}
function ild(e, t) {
  return this.isValid() && (_d(e) && e.isValid() || Yr(e).isValid()) ? yd({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ald(e) {
  return this.to(Yr(), e);
}
function Cke(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = V_(e), t != null && (this._locale = t), this);
}
var zke = Cl(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Oke() {
  return this._locale;
}
var TT = 1e3, ov = 60 * TT, AT = 60 * ov, Pke = (365 * 400 + 97) * 24 * AT;
function rv(e, t) {
  return (e % t + t) % t;
}
function Ike(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Pke : new Date(e, t, n).valueOf();
}
function Rke(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Pke : Date.UTC(e, t, n);
}
function sld(e) {
  var t, n;
  if (e = zl(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Rke : Ike, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= rv(
        t + (this._isUTC ? 0 : this.utcOffset() * ov),
        AT
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= rv(t, ov);
      break;
    case "second":
      t = this._d.valueOf(), t -= rv(t, TT);
      break;
  }
  return this._d.setTime(t), Gt.updateOffset(this, !0), this;
}
function cld(e) {
  var t, n;
  if (e = zl(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Rke : Ike, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += AT - rv(
        t + (this._isUTC ? 0 : this.utcOffset() * ov),
        AT
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += ov - rv(t, ov) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += TT - rv(t, TT) - 1;
      break;
  }
  return this._d.setTime(t), Gt.updateOffset(this, !0), this;
}
function lld() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function dld() {
  return Math.floor(this.valueOf() / 1e3);
}
function uld() {
  return new Date(this.valueOf());
}
function _ld() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function pld() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function mld() {
  return this.isValid() ? this.toISOString() : null;
}
function fld() {
  return o7(this);
}
function gld() {
  return Rp({}, _o(this));
}
function hld() {
  return _o(this).overflow;
}
function vld() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
vn("N", 0, 0, "eraAbbr");
vn("NN", 0, 0, "eraAbbr");
vn("NNN", 0, 0, "eraAbbr");
vn("NNNN", 0, 0, "eraName");
vn("NNNNN", 0, 0, "eraNarrow");
vn("y", ["y", 1], "yo", "eraYear");
vn("y", ["yy", 2], 0, "eraYear");
vn("y", ["yyy", 3], 0, "eraYear");
vn("y", ["yyyy", 4], 0, "eraYear");
tn("N", b7);
tn("NN", b7);
tn("NNN", b7);
tn("NNNN", Cld);
tn("NNNNN", zld);
zr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, o) {
    var r = n._locale.erasParse(e, o, n._strict);
    r ? _o(n).era = r : _o(n).invalidEra = e;
  }
);
tn("y", Pb);
tn("yy", Pb);
tn("yyy", Pb);
tn("yyyy", Pb);
tn("yo", Old);
zr(["y", "yy", "yyy", "yyyy"], Ja);
zr(["yo"], function(e, t, n, o) {
  var r;
  n._locale._eraYearOrdinalRegex && (r = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[Ja] = n._locale.eraYearOrdinalParse(e, r) : t[Ja] = parseInt(e, 10);
});
function bld(e, t) {
  var n, o, r, i = this._eras || V_("en")._eras;
  for (n = 0, o = i.length; n < o; ++n) {
    switch (typeof i[n].since) {
      case "string":
        r = Gt(i[n].since).startOf("day"), i[n].since = r.valueOf();
        break;
    }
    switch (typeof i[n].until) {
      case "undefined":
        i[n].until = 1 / 0;
        break;
      case "string":
        r = Gt(i[n].until).startOf("day").valueOf(), i[n].until = r.valueOf();
        break;
    }
  }
  return i;
}
function yld(e, t, n) {
  var o, r, i = this.eras(), a, s, c;
  for (e = e.toUpperCase(), o = 0, r = i.length; o < r; ++o)
    if (a = i[o].name.toUpperCase(), s = i[o].abbr.toUpperCase(), c = i[o].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return i[o];
          break;
        case "NNNN":
          if (a === e)
            return i[o];
          break;
        case "NNNNN":
          if (c === e)
            return i[o];
          break;
      }
    else if ([a, s, c].indexOf(e) >= 0)
      return i[o];
}
function $ld(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Gt(e.since).year() : Gt(e.since).year() + (t - e.offset) * n;
}
function wld() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].name;
  return "";
}
function kld() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].narrow;
  return "";
}
function Sld() {
  var e, t, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return o[e].abbr;
  return "";
}
function xld() {
  var e, t, n, o, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = r[e].since <= r[e].until ? 1 : -1, o = this.clone().startOf("day").valueOf(), r[e].since <= o && o <= r[e].until || r[e].until <= o && o <= r[e].since)
      return (this.year() - Gt(r[e].since).year()) * n + r[e].offset;
  return this.year();
}
function Eld(e) {
  return Ko(this, "_erasNameRegex") || y7.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Tld(e) {
  return Ko(this, "_erasAbbrRegex") || y7.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Ald(e) {
  return Ko(this, "_erasNarrowRegex") || y7.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function b7(e, t) {
  return t.erasAbbrRegex(e);
}
function Cld(e, t) {
  return t.erasNameRegex(e);
}
function zld(e, t) {
  return t.erasNarrowRegex(e);
}
function Old(e, t) {
  return t._eraYearOrdinalRegex || Pb;
}
function y7() {
  var e = [], t = [], n = [], o = [], r, i, a = this.eras();
  for (r = 0, i = a.length; r < i; ++r)
    t.push(xc(a[r].name)), e.push(xc(a[r].abbr)), n.push(xc(a[r].narrow)), o.push(xc(a[r].name)), o.push(xc(a[r].abbr)), o.push(xc(a[r].narrow));
  this._erasRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
vn(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
vn(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function mz(e, t) {
  vn(0, [e, e.length], 0, t);
}
mz("gggg", "weekYear");
mz("ggggg", "weekYear");
mz("GGGG", "isoWeekYear");
mz("GGGGG", "isoWeekYear");
as("weekYear", "gg");
as("isoWeekYear", "GG");
ss("weekYear", 1);
ss("isoWeekYear", 1);
tn("G", lz);
tn("g", lz);
tn("GG", Qr, Gc);
tn("gg", Qr, Gc);
tn("GGGG", l7, c7);
tn("gggg", l7, c7);
tn("GGGGG", cz, az);
tn("ggggg", cz, az);
Ok(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, o) {
    t[o.substr(0, 2)] = ko(e);
  }
);
Ok(["gg", "GG"], function(e, t, n, o) {
  t[o] = Gt.parseTwoDigitYear(e);
});
function Pld(e) {
  return Nke.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Ild(e) {
  return Nke.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Rld() {
  return $_(this.year(), 1, 4);
}
function Nld() {
  return $_(this.isoWeekYear(), 1, 4);
}
function Dld() {
  var e = this.localeData()._week;
  return $_(this.year(), e.dow, e.doy);
}
function Mld() {
  var e = this.localeData()._week;
  return $_(this.weekYear(), e.dow, e.doy);
}
function Nke(e, t, n, o, r) {
  var i;
  return e == null ? p0(this, o, r).year : (i = $_(e, o, r), t > i && (t = i), Lld.call(this, e, t, n, o, r));
}
function Lld(e, t, n, o, r) {
  var i = mke(e, t, n, o, r), a = _0(i.year, 0, i.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
vn("Q", 0, "Qo", "quarter");
as("quarter", "Q");
ss("quarter", 7);
tn("Q", rke);
zr("Q", function(e, t) {
  t[u_] = (ko(e) - 1) * 3;
});
function qld(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
vn("D", ["DD", 2], "Do", "date");
as("date", "D");
ss("date", 9);
tn("D", Qr);
tn("DD", Qr, Gc);
tn("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
zr(["D", "DD"], Hd);
zr("Do", function(e, t) {
  t[Hd] = ko(e.match(Qr)[0]);
});
var Dke = Ob("Date", !0);
vn("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
as("dayOfYear", "DDD");
ss("dayOfYear", 4);
tn("DDD", sz);
tn("DDDD", ike);
zr(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = ko(e);
});
function jld(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
vn("m", ["mm", 2], 0, "minute");
as("minute", "m");
ss("minute", 14);
tn("m", Qr);
tn("mm", Qr, Gc);
zr(["m", "mm"], ed);
var Fld = Ob("Minutes", !1);
vn("s", ["ss", 2], 0, "second");
as("second", "s");
ss("second", 15);
tn("s", Qr);
tn("ss", Qr, Gc);
zr(["s", "ss"], __);
var Vld = Ob("Seconds", !1);
vn("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
vn(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
vn(0, ["SSS", 3], 0, "millisecond");
vn(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
vn(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
vn(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
vn(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
vn(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
vn(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
as("millisecond", "ms");
ss("millisecond", 16);
tn("S", sz, rke);
tn("SS", sz, Gc);
tn("SSS", sz, ike);
var Np, Mke;
for (Np = "SSSS"; Np.length <= 9; Np += "S")
  tn(Np, Pb);
function Bld(e, t) {
  t[mf] = ko(("0." + e) * 1e3);
}
for (Np = "S"; Np.length <= 9; Np += "S")
  zr(Np, Bld);
Mke = Ob("Milliseconds", !1);
vn("z", 0, 0, "zoneAbbr");
vn("zz", 0, 0, "zoneName");
function Uld() {
  return this._isUTC ? "UTC" : "";
}
function Wld() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var xt = Ck.prototype;
xt.add = Mcd;
xt.calendar = Ucd;
xt.clone = Wcd;
xt.diff = Jcd;
xt.endOf = cld;
xt.format = nld;
xt.from = old;
xt.fromNow = rld;
xt.to = ild;
xt.toNow = ald;
xt.get = Had;
xt.invalidAt = hld;
xt.isAfter = Gcd;
xt.isBefore = Hcd;
xt.isBetween = Kcd;
xt.isSame = Ycd;
xt.isSameOrAfter = Zcd;
xt.isSameOrBefore = Qcd;
xt.isValid = fld;
xt.lang = zke;
xt.locale = Cke;
xt.localeData = Oke;
xt.max = fcd;
xt.min = mcd;
xt.parsingFlags = gld;
xt.set = Kad;
xt.startOf = sld;
xt.subtract = Lcd;
xt.toArray = _ld;
xt.toObject = pld;
xt.toDate = uld;
xt.toISOString = eld;
xt.inspect = tld;
typeof Symbol < "u" && Symbol.for != null && (xt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
xt.toJSON = mld;
xt.toString = Xcd;
xt.unix = dld;
xt.valueOf = lld;
xt.creationData = vld;
xt.eraName = wld;
xt.eraNarrow = kld;
xt.eraAbbr = Sld;
xt.eraYear = xld;
xt.year = pke;
xt.isLeapYear = psd;
xt.weekYear = Pld;
xt.isoWeekYear = Ild;
xt.quarter = xt.quarters = qld;
xt.month = uke;
xt.daysInMonth = dsd;
xt.week = xt.weeks = bsd;
xt.isoWeek = xt.isoWeeks = ysd;
xt.weeksInYear = Dld;
xt.weeksInWeekYear = Mld;
xt.isoWeeksInYear = Rld;
xt.isoWeeksInISOWeekYear = Nld;
xt.date = Dke;
xt.day = xt.days = Isd;
xt.weekday = Rsd;
xt.isoWeekday = Nsd;
xt.dayOfYear = jld;
xt.hour = xt.hours = Vsd;
xt.minute = xt.minutes = Fld;
xt.second = xt.seconds = Vld;
xt.millisecond = xt.milliseconds = Mke;
xt.utcOffset = Scd;
xt.utc = Ecd;
xt.local = Tcd;
xt.parseZone = Acd;
xt.hasAlignedHourOffset = Ccd;
xt.isDST = zcd;
xt.isLocal = Pcd;
xt.isUtcOffset = Icd;
xt.isUtc = xke;
xt.isUTC = xke;
xt.zoneAbbr = Uld;
xt.zoneName = Wld;
xt.dates = Cl(
  "dates accessor is deprecated. Use date instead.",
  Dke
);
xt.months = Cl(
  "months accessor is deprecated. Use month instead",
  uke
);
xt.years = Cl(
  "years accessor is deprecated. Use year instead",
  pke
);
xt.zone = Cl(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  xcd
);
xt.isDSTShifted = Cl(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Ocd
);
function Gld(e) {
  return Yr(e * 1e3);
}
function Hld() {
  return Yr.apply(null, arguments).parseZone();
}
function Lke(e) {
  return e;
}
var Qo = i7.prototype;
Qo.calendar = Iad;
Qo.longDateFormat = Mad;
Qo.invalidDate = qad;
Qo.ordinal = Vad;
Qo.preparse = Lke;
Qo.postformat = Lke;
Qo.relativeTime = Uad;
Qo.pastFuture = Wad;
Qo.set = Oad;
Qo.eras = bld;
Qo.erasParse = yld;
Qo.erasConvertYear = $ld;
Qo.erasAbbrRegex = Tld;
Qo.erasNameRegex = Eld;
Qo.erasNarrowRegex = Ald;
Qo.months = asd;
Qo.monthsShort = ssd;
Qo.monthsParse = lsd;
Qo.monthsRegex = _sd;
Qo.monthsShortRegex = usd;
Qo.week = fsd;
Qo.firstDayOfYear = vsd;
Qo.firstDayOfWeek = hsd;
Qo.weekdays = Asd;
Qo.weekdaysMin = zsd;
Qo.weekdaysShort = Csd;
Qo.weekdaysParse = Psd;
Qo.weekdaysRegex = Dsd;
Qo.weekdaysShortRegex = Msd;
Qo.weekdaysMinRegex = Lsd;
Qo.isPM = jsd;
Qo.meridiem = Bsd;
function CT(e, t, n, o) {
  var r = V_(), i = ku().set(o, t);
  return r[n](i, e);
}
function qke(e, t, n) {
  if (A_(e) && (t = e, e = void 0), e = e || "", t != null)
    return CT(e, t, n, "month");
  var o, r = [];
  for (o = 0; o < 12; o++)
    r[o] = CT(e, o, n, "month");
  return r;
}
function $7(e, t, n, o) {
  typeof e == "boolean" ? (A_(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, A_(t) && (n = t, t = void 0), t = t || "");
  var r = V_(), i = e ? r._week.dow : 0, a, s = [];
  if (n != null)
    return CT(t, (n + i) % 7, o, "day");
  for (a = 0; a < 7; a++)
    s[a] = CT(t, (a + i) % 7, o, "day");
  return s;
}
function Kld(e, t) {
  return qke(e, t, "months");
}
function Yld(e, t) {
  return qke(e, t, "monthsShort");
}
function Zld(e, t, n) {
  return $7(e, t, n, "weekdays");
}
function Qld(e, t, n) {
  return $7(e, t, n, "weekdaysShort");
}
function Jld(e, t, n) {
  return $7(e, t, n, "weekdaysMin");
}
Gp("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = ko(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
Gt.lang = Cl(
  "moment.lang is deprecated. Use moment.locale instead.",
  Gp
);
Gt.langData = Cl(
  "moment.langData is deprecated. Use moment.localeData instead.",
  V_
);
var Yu = Math.abs;
function Xld() {
  var e = this._data;
  return this._milliseconds = Yu(this._milliseconds), this._days = Yu(this._days), this._months = Yu(this._months), e.milliseconds = Yu(e.milliseconds), e.seconds = Yu(e.seconds), e.minutes = Yu(e.minutes), e.hours = Yu(e.hours), e.months = Yu(e.months), e.years = Yu(e.years), this;
}
function jke(e, t, n, o) {
  var r = yd(t, n);
  return e._milliseconds += o * r._milliseconds, e._days += o * r._days, e._months += o * r._months, e._bubble();
}
function edd(e, t) {
  return jke(this, e, t, 1);
}
function tdd(e, t) {
  return jke(this, e, t, -1);
}
function _oe(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function ndd() {
  var e = this._milliseconds, t = this._days, n = this._months, o = this._data, r, i, a, s, c;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += _oe(hq(n) + t) * 864e5, t = 0, n = 0), o.milliseconds = e % 1e3, r = pl(e / 1e3), o.seconds = r % 60, i = pl(r / 60), o.minutes = i % 60, a = pl(i / 60), o.hours = a % 24, t += pl(a / 24), c = pl(Fke(t)), n += c, t -= _oe(hq(c)), s = pl(n / 12), n %= 12, o.days = t, o.months = n, o.years = s, this;
}
function Fke(e) {
  return e * 4800 / 146097;
}
function hq(e) {
  return e * 146097 / 4800;
}
function odd(e) {
  if (!this.isValid())
    return NaN;
  var t, n, o = this._milliseconds;
  if (e = zl(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + o / 864e5, n = this._months + Fke(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(hq(this._months)), e) {
      case "week":
        return t / 7 + o / 6048e5;
      case "day":
        return t + o / 864e5;
      case "hour":
        return t * 24 + o / 36e5;
      case "minute":
        return t * 1440 + o / 6e4;
      case "second":
        return t * 86400 + o / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + o;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function rdd() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + ko(this._months / 12) * 31536e6 : NaN;
}
function B_(e) {
  return function() {
    return this.as(e);
  };
}
var idd = B_("ms"), add = B_("s"), sdd = B_("m"), cdd = B_("h"), ldd = B_("d"), ddd = B_("w"), udd = B_("M"), _dd = B_("Q"), pdd = B_("y");
function mdd() {
  return yd(this);
}
function fdd(e) {
  return e = zl(e), this.isValid() ? this[e + "s"]() : NaN;
}
function kg(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var gdd = kg("milliseconds"), hdd = kg("seconds"), vdd = kg("minutes"), bdd = kg("hours"), ydd = kg("days"), $dd = kg("months"), wdd = kg("years");
function kdd() {
  return pl(this.days() / 7);
}
var n_ = Math.round, zh = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Sdd(e, t, n, o, r) {
  return r.relativeTime(t || 1, !!n, e, o);
}
function xdd(e, t, n, o) {
  var r = yd(e).abs(), i = n_(r.as("s")), a = n_(r.as("m")), s = n_(r.as("h")), c = n_(r.as("d")), l = n_(r.as("M")), d = n_(r.as("w")), u = n_(r.as("y")), _ = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || a <= 1 && ["m"] || a < n.m && ["mm", a] || s <= 1 && ["h"] || s < n.h && ["hh", s] || c <= 1 && ["d"] || c < n.d && ["dd", c];
  return n.w != null && (_ = _ || d <= 1 && ["w"] || d < n.w && ["ww", d]), _ = _ || l <= 1 && ["M"] || l < n.M && ["MM", l] || u <= 1 && ["y"] || ["yy", u], _[2] = t, _[3] = +e > 0, _[4] = o, Sdd.apply(null, _);
}
function Edd(e) {
  return e === void 0 ? n_ : typeof e == "function" ? (n_ = e, !0) : !1;
}
function Tdd(e, t) {
  return zh[e] === void 0 ? !1 : t === void 0 ? zh[e] : (zh[e] = t, e === "s" && (zh.ss = t - 1), !0);
}
function Add(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, o = zh, r, i;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (o = Object.assign({}, zh, t), t.s != null && t.ss == null && (o.ss = t.s - 1)), r = this.localeData(), i = xdd(this, !n, o, r), n && (i = r.pastFuture(+this, i)), r.postformat(i);
}
var yR = Math.abs;
function ph(e) {
  return (e > 0) - (e < 0) || +e;
}
function fz() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = yR(this._milliseconds) / 1e3, t = yR(this._days), n = yR(this._months), o, r, i, a, s = this.asSeconds(), c, l, d, u;
  return s ? (o = pl(e / 60), r = pl(o / 60), e %= 60, o %= 60, i = pl(n / 12), n %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = s < 0 ? "-" : "", l = ph(this._months) !== ph(s) ? "-" : "", d = ph(this._days) !== ph(s) ? "-" : "", u = ph(this._milliseconds) !== ph(s) ? "-" : "", c + "P" + (i ? l + i + "Y" : "") + (n ? l + n + "M" : "") + (t ? d + t + "D" : "") + (r || o || e ? "T" : "") + (r ? u + r + "H" : "") + (o ? u + o + "M" : "") + (e ? u + a + "S" : "")) : "P0D";
}
var jo = pz.prototype;
jo.isValid = ycd;
jo.abs = Xld;
jo.add = edd;
jo.subtract = tdd;
jo.as = odd;
jo.asMilliseconds = idd;
jo.asSeconds = add;
jo.asMinutes = sdd;
jo.asHours = cdd;
jo.asDays = ldd;
jo.asWeeks = ddd;
jo.asMonths = udd;
jo.asQuarters = _dd;
jo.asYears = pdd;
jo.valueOf = rdd;
jo._bubble = ndd;
jo.clone = mdd;
jo.get = fdd;
jo.milliseconds = gdd;
jo.seconds = hdd;
jo.minutes = vdd;
jo.hours = bdd;
jo.days = ydd;
jo.weeks = kdd;
jo.months = $dd;
jo.years = wdd;
jo.humanize = Add;
jo.toISOString = fz;
jo.toString = fz;
jo.toJSON = fz;
jo.locale = Cke;
jo.localeData = Oke;
jo.toIsoString = Cl(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  fz
);
jo.lang = zke;
vn("X", 0, 0, "unix");
vn("x", 0, 0, "valueOf");
tn("x", lz);
tn("X", Zad);
zr("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
zr("x", function(e, t, n) {
  n._d = new Date(ko(e));
});
//! moment.js
Gt.version = "2.29.3";
Cad(Yr);
Gt.fn = xt;
Gt.min = gcd;
Gt.max = hcd;
Gt.now = vcd;
Gt.utc = ku;
Gt.unix = Gld;
Gt.months = Kld;
Gt.isDate = Ak;
Gt.locale = Gp;
Gt.invalid = rz;
Gt.duration = yd;
Gt.isMoment = _d;
Gt.weekdays = Zld;
Gt.parseZone = Hld;
Gt.localeData = V_;
Gt.isDuration = gx;
Gt.monthsShort = Yld;
Gt.weekdaysMin = Jld;
Gt.defineLocale = p7;
Gt.updateLocale = Hsd;
Gt.locales = Ksd;
Gt.weekdaysShort = Qld;
Gt.normalizeUnits = zl;
Gt.relativeTimeRounding = Edd;
Gt.relativeTimeThreshold = Tdd;
Gt.calendarFormat = Bcd;
Gt.prototype = xt;
Gt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Cdd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gt
}, Symbol.toStringTag, { value: "Module" })), Sg = /* @__PURE__ */ Oa(Cdd);
var poe;
function zdd() {
  return poe || (poe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve);
    t(Sg);
    var r = function(a) {
      var s = a.value, c = a.setValue;
      a.config, a.valueFormat;
      var l = a.readonly, d = a.customProps, u = function(p) {
        var f = p.target.value;
        f == "" && (f = void 0), c(f);
      };
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "date",
        value: s || "",
        disabled: l,
        onChange: u
      }, d));
    };
    e.default = r;
  }(gR)), gR;
}
var $R = {}, moe;
function Odd() {
  return moe || (moe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config, a.valueFormat, a.use12Hours;
      var l = a.readonly, d = a.customProps, u = function(p) {
        var f = p.target.value;
        f == "" && (f = void 0), c(f);
      };
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "time",
        value: s || "",
        disabled: l,
        onChange: u
      }, d));
    };
    e.default = r;
  }($R)), $R;
}
var wR = {}, foe;
function Pdd() {
  return foe || (foe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = t(Sg), i = function(s) {
      var c = s.value, l = s.setValue;
      s.config;
      var d = s.valueFormat;
      s.use12Hours;
      var u = s.readonly, _ = s.customProps, p = function(h) {
        var b = h.target.value;
        b == "" ? b = void 0 : b = (0, r.default)(new Date(b)).format(d), l(b);
      }, f = c;
      return c ? f = (0, r.default)(c).format("YYYY-MM-DDTHH:mm") : f = "", /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "datetime-local",
        value: f,
        disabled: u,
        onChange: p
      }, _));
    };
    e.default = i;
  }(wR)), wR;
}
var kR = {}, goe;
function Idd() {
  return goe || (goe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = Sr(), i = t(F_()), a = function(c) {
      var l = c.listValues, d = c.value, u = c.setValue;
      c.allowCustomValues;
      var _ = c.readonly, p = c.customProps, f = function() {
        return (0, r.mapListValues)(l, function(v) {
          var $ = v.title, k = v.value;
          return /* @__PURE__ */ o.default.createElement("option", {
            key: k,
            value: k
          }, $);
        });
      }, g = function(v) {
        for (var $ = [], k = v.options, S = 0; S < k.length; S++) {
          var O = k[S];
          O.selected && $.push(O.value);
        }
        return $.length || ($ = void 0), $;
      }, h = function(v) {
        return u(g(v.target));
      };
      return /* @__PURE__ */ o.default.createElement("select", (0, n.default)({
        multiple: !0,
        onChange: h,
        value: d,
        disabled: _
      }, (0, i.default)(p, ["showSearch", "input", "showCheckboxes"])), f());
    };
    e.default = a;
  }(kR)), kR;
}
var SR = {}, hoe;
function Rdd() {
  return hoe || (hoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = Sr(), i = t(F_()), a = function(c) {
      var l = c.listValues, d = c.value, u = c.setValue;
      c.allowCustomValues;
      var _ = c.readonly, p = c.customProps, f = function() {
        return (0, r.mapListValues)(l, function(v) {
          var $ = v.title, k = v.value;
          return /* @__PURE__ */ o.default.createElement("option", {
            key: k,
            value: k
          }, $);
        });
      }, g = function(v) {
        return u(v.target.value);
      }, h = d != null;
      return /* @__PURE__ */ o.default.createElement("select", (0, n.default)({
        onChange: g,
        value: h ? d : "",
        disabled: _
      }, (0, i.default)(p, ["showSearch", "input"])), !h && /* @__PURE__ */ o.default.createElement("option", {
        disabled: !0,
        value: ""
      }), f());
    };
    e.default = a;
  }(SR)), SR;
}
var xR = {}, voe;
function Ndd() {
  return voe || (voe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, d = a.min, u = a.max, _ = a.step, p = a.placeholder, f = a.customProps, g = function(v) {
        var $ = v.target.value;
        $ === "" || $ === null ? $ = void 0 : $ = Number($), c($);
      }, h = s ?? "";
      return /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        type: "number",
        value: h,
        placeholder: p,
        disabled: l,
        min: d,
        max: u,
        step: _,
        onChange: g
      }, f));
    };
    e.default = r;
  }(xR)), xR;
}
var ER = {}, boe;
function Ddd() {
  return boe || (boe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(pa), o = t(ve), r = function(a) {
      var s = a.value, c = a.setValue;
      a.config;
      var l = a.readonly, d = a.min, u = a.max, _ = a.step, p = a.placeholder, f = a.customProps, g = f === void 0 ? {} : f, h = g.input || {}, b = g.slider || g, v = function(S) {
        var O = S.target.value;
        O === "" || O === null ? O = void 0 : O = Number(O), c(O);
      }, $ = s ?? "";
      return [/* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: "number",
        type: "number",
        value: $,
        placeholder: p,
        disabled: l,
        min: d,
        max: u,
        step: _,
        onChange: v
      }, h)), /* @__PURE__ */ o.default.createElement("input", (0, n.default)({
        key: "range",
        type: "range",
        value: $,
        disabled: l,
        min: d,
        max: u,
        step: _,
        onChange: v
      }, b))];
    };
    e.default = r;
  }(ER)), ER;
}
var TR = {}, yoe;
function Mdd() {
  return yoe || (yoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = function(i) {
      var a = i.items, s = i.setField, c = i.selectedKey, l = i.readonly, d = function p(f) {
        return f.map(function(g) {
          var h = g.items, b = g.path, v = g.label, $ = g.disabled;
          return h ? /* @__PURE__ */ n.default.createElement("optgroup", {
            disabled: $,
            key: b,
            label: v
          }, p(h)) : /* @__PURE__ */ n.default.createElement("option", {
            disabled: $,
            key: b,
            value: b
          }, v);
        });
      }, u = function(f) {
        return s(f.target.value);
      }, _ = c != null;
      return /* @__PURE__ */ n.default.createElement("select", {
        onChange: u,
        value: _ ? c : "",
        disabled: l
      }, !_ && /* @__PURE__ */ n.default.createElement("option", {
        disabled: !0,
        value: ""
      }), d(a));
    };
    e.default = o;
  }(TR)), TR;
}
var AR = {}, $oe;
function Ldd() {
  return $oe || ($oe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = function(i) {
      var a = i.id, s = i.not, c = i.setNot, l = i.conjunctionOptions, d = i.setConjunction, u = i.disabled, _ = i.readonly, p = i.config, f = i.showNot, g = i.notLabel, h = Object.keys(l).length, b = u, v = p.settings.forceShowConj, $ = v || h > 1 && !b, k = function() {
        return Object.keys(l).map(function(M) {
          var N = l[M], C = N.id, P = N.name, x = N.label, w = N.checked, E = d.isDummyFn ? "__dummy" : "";
          return (_ || u) && !w ? null : [/* @__PURE__ */ n.default.createElement("input", {
            key: C + E,
            type: "radio",
            id: C + E,
            name: P + E,
            checked: w,
            disabled: _ || u,
            value: M,
            onChange: O
          }), /* @__PURE__ */ n.default.createElement("label", {
            key: C + E + "label",
            htmlFor: C + E
          }, x)];
        });
      }, S = function() {
        var M = "not";
        return [/* @__PURE__ */ n.default.createElement("input", {
          key: a + M,
          type: "checkbox",
          id: a + M,
          checked: s,
          disabled: _,
          onChange: I
        }), /* @__PURE__ */ n.default.createElement("label", {
          key: a + M + "label",
          htmlFor: a + M
        }, g || "NOT")];
      }, O = function(M) {
        return d(M.target.value);
      }, I = function(M) {
        return c(M.target.checked);
      };
      return [f && S(), $ && k()];
    };
    e.default = o;
  }(AR)), AR;
}
var CR = {}, woe;
function qdd() {
  return woe || (woe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = function(i) {
      var a = i.type, s = i.label, c = i.onClick, l = i.readonly;
      i.config;
      var d = {
        addRuleGroup: "+",
        addRuleGroupExt: "+",
        delGroup: "x",
        delRuleGroup: "x",
        delRule: "x"
      }, u = s || d[a];
      return /* @__PURE__ */ n.default.createElement("button", {
        onClick: c,
        type: "button",
        disabled: l
      }, u);
    };
    e.default = o;
  }(CR)), CR;
}
var zR = {}, koe;
function jdd() {
  return koe || (koe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = function(i) {
      var a = i.children;
      return i.config, /* @__PURE__ */ n.default.createElement(n.default.Fragment, null, a);
    };
    e.default = o;
  }(zR)), zR;
}
var OR = {}, Soe;
function Fdd() {
  return Soe || (Soe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(Tl), o = t(ve), r = function(a) {
      a.config;
      var s = a.valueSources, c = a.valueSrc;
      a.title;
      var l = a.setValueSrc, d = a.readonly, u = function(f) {
        return f.map(function(g) {
          var h = (0, n.default)(g, 2), b = h[0], v = h[1];
          return /* @__PURE__ */ o.default.createElement("option", {
            key: b,
            value: b
          }, v.label);
        });
      }, _ = function(f) {
        return l(f.target.value);
      };
      return /* @__PURE__ */ o.default.createElement("select", {
        onChange: _,
        value: c,
        disabled: d
      }, u(s));
    };
    e.default = r;
  }(OR)), OR;
}
var PR = {}, xoe;
function Vdd() {
  return xoe || (xoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = function(i) {
      var a = i.value, s = i.setValue, c = i.label, l = i.id;
      i.config;
      var d = i.type, u = function(f) {
        return s(f.target.checked);
      }, _ = d;
      return [/* @__PURE__ */ n.default.createElement("input", {
        key: l + _,
        type: "checkbox",
        id: l + _,
        checked: !!a,
        onChange: u
      }), /* @__PURE__ */ n.default.createElement("label", {
        key: l + _ + "label",
        htmlFor: l + _
      }, c)];
    };
    e.default = o;
  }(PR)), PR;
}
var IR = {}, Eoe;
function Bdd() {
  return Eoe || (Eoe = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = function(o) {
      var r = o.onOk;
      o.okText, o.cancelText;
      var i = o.title;
      confirm(i) && r();
    };
    e.default = t;
  }(IR)), IR;
}
var Toe;
function Udd() {
  return Toe || (Toe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "VanillaBooleanWidget", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(e, "VanillaButton", {
      enumerable: !0,
      get: function() {
        return f.default;
      }
    }), Object.defineProperty(e, "VanillaButtonGroup", {
      enumerable: !0,
      get: function() {
        return g.default;
      }
    }), Object.defineProperty(e, "VanillaConjs", {
      enumerable: !0,
      get: function() {
        return p.default;
      }
    }), Object.defineProperty(e, "VanillaDateTimeWidget", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(e, "VanillaDateWidget", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "VanillaFieldSelect", {
      enumerable: !0,
      get: function() {
        return _.default;
      }
    }), Object.defineProperty(e, "VanillaMultiSelectWidget", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(e, "VanillaNumberWidget", {
      enumerable: !0,
      get: function() {
        return d.default;
      }
    }), e.VanillaProvider = void 0, Object.defineProperty(e, "VanillaSelectWidget", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), Object.defineProperty(e, "VanillaSliderWidget", {
      enumerable: !0,
      get: function() {
        return u.default;
      }
    }), Object.defineProperty(e, "VanillaSwitch", {
      enumerable: !0,
      get: function() {
        return b.default;
      }
    }), Object.defineProperty(e, "VanillaTextAreaWidget", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(e, "VanillaTextWidget", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(e, "VanillaTimeWidget", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(e, "VanillaValueSources", {
      enumerable: !0,
      get: function() {
        return h.default;
      }
    }), Object.defineProperty(e, "vanillaConfirm", {
      enumerable: !0,
      get: function() {
        return v.default;
      }
    }), t(ve);
    var n = t(Ead()), o = t(Tad()), r = t(Aad()), i = t(zdd()), a = t(Odd()), s = t(Pdd()), c = t(Idd()), l = t(Rdd()), d = t(Ndd()), u = t(Ddd()), _ = t(Mdd()), p = t(Ldd()), f = t(qdd()), g = t(jdd()), h = t(Fdd()), b = t(Vdd()), v = t(Bdd()), $ = function(S) {
      S.config;
      var O = S.children;
      return O;
    };
    e.VanillaProvider = $;
  }(_R)), _R;
}
var Aoe;
function w7() {
  return Aoe || (Aoe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = {
      ValueFieldWidget: !0,
      FuncWidget: !0
    };
    Object.defineProperty(e, "FuncWidget", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(e, "ValueFieldWidget", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    });
    var o = t(vad()), r = t(xad()), i = Udd();
    Object.keys(i).forEach(function(a) {
      a === "default" || a === "__esModule" || Object.prototype.hasOwnProperty.call(n, a) || a in e && e[a] === i[a] || Object.defineProperty(e, a, {
        enumerable: !0,
        get: function() {
          return i[a];
        }
      });
    });
  }(jP)), jP;
}
var Coe;
function Ib() {
  if (Coe)
    return Qy;
  Coe = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(Qy, "__esModule", {
    value: !0
  }), Qy.settings = void 0;
  var n = i(w7()), o = e(ve);
  function r(g) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (r = function($) {
      return $ ? b : h;
    })(g);
  }
  function i(g, h) {
    if (!h && g && g.__esModule)
      return g;
    if (g === null || t(g) !== "object" && typeof g != "function")
      return { default: g };
    var b = r(h);
    if (b && b.has(g))
      return b.get(g);
    var v = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var k in g)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(g, k)) {
        var S = $ ? Object.getOwnPropertyDescriptor(g, k) : null;
        S && (S.get || S.set) ? Object.defineProperty(v, k, S) : v[k] = g[k];
      }
    return v.default = g, b && b.set(g, v), v;
  }
  var a = n.VanillaFieldSelect, s = n.VanillaConjs, c = n.VanillaButton, l = n.VanillaButtonGroup, d = n.VanillaProvider, u = n.VanillaValueSources, _ = n.vanillaConfirm, p = n.VanillaSwitch, f = {
    formatField: function(h, b, v, $, k, S) {
      return S ? v : h;
    },
    renderField: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderOperator: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderFunc: function(h) {
      return /* @__PURE__ */ o.default.createElement(a, h);
    },
    renderConjs: function(h) {
      return /* @__PURE__ */ o.default.createElement(s, h);
    },
    renderSwitch: function(h) {
      return /* @__PURE__ */ o.default.createElement(p, h);
    },
    renderButton: function(h) {
      return /* @__PURE__ */ o.default.createElement(c, h);
    },
    renderButtonGroup: function(h) {
      return /* @__PURE__ */ o.default.createElement(l, h);
    },
    renderProvider: function(h) {
      return /* @__PURE__ */ o.default.createElement(d, h);
    },
    renderValueSources: function(h) {
      return /* @__PURE__ */ o.default.createElement(u, h);
    },
    renderConfirm: _,
    renderSwitchPrefix: function() {
      return /* @__PURE__ */ o.default.createElement(o.default.Fragment, null, "Conditions");
    },
    valueSourcesInfo: {
      value: {}
    },
    fieldSeparator: ".",
    fieldSeparatorDisplay: ".",
    renderSize: "small",
    maxLabelsLength: 100,
    canReorder: !0,
    canRegroup: !0,
    showLock: !1,
    canDeleteLocked: !1,
    showNot: !0,
    canLeaveEmptyGroup: !0,
    shouldCreateEmptyGroup: !1,
    forceShowConj: !1,
    canShortMongoQuery: !0,
    removeEmptyGroupsOnLoad: !0,
    removeIncompleteRulesOnLoad: !1,
    groupActionsPosition: "topRight",
    // oneOf [topLeft, topCenter, topRight, bottomLeft, bottomCenter, bottomRight]
    setOpOnChangeField: ["keep", "default"],
    // 'default' (default if present), 'keep' (keep prev from last field), 'first', 'none'
    groupOperators: ["some", "all", "none"],
    convertableWidgets: {
      number: ["slider", "rangeslider"],
      slider: ["number", "rangeslider"],
      rangeslider: ["number", "slider"],
      text: ["textarea"],
      textarea: ["text"]
    },
    // localization
    locale: {
      moment: "en"
    },
    valueLabel: "Value",
    valuePlaceholder: "Value",
    fieldLabel: "Field",
    operatorLabel: "Operator",
    funcLabel: "Function",
    fieldPlaceholder: "Select field",
    funcPlaceholder: "Select function",
    operatorPlaceholder: "Select operator",
    lockLabel: "Lock",
    lockedLabel: "Locked",
    deleteLabel: null,
    addGroupLabel: "Add group",
    addCaseLabel: "Add condition",
    addDefaultCaseLabel: "Add default condition",
    defaultCaseLabel: "Default:",
    addRuleLabel: "Add rule",
    addSubRuleLabel: "Add sub rule",
    delGroupLabel: "",
    notLabel: "Not",
    valueSourcesPopupTitle: "Select value source",
    removeRuleConfirmOptions: null,
    removeGroupConfirmOptions: null,
    defaultGroupConjunction: "AND",
    jsonLogic: {
      groupVarKey: "var",
      altVarKey: "var",
      lockedOp: "locked"
    }
  };
  return Qy.settings = f, Qy;
}
var zoe;
function Br() {
  if (zoe)
    return qi;
  zoe = 1;
  var e = Rt;
  Object.defineProperty(qi, "__esModule", {
    value: !0
  }), qi.normalizeField = qi.getOperatorConfig = qi.getFuncConfig = qi.getFuncArgConfig = qi.getFieldWidgetConfig = qi.getFieldRawConfig = qi.getFieldConfig = qi.extendConfig = void 0;
  var t = e(Yn), n = e(Wc), o = e(kid()), r = e(Sid()), i = Ib(), a = e(Sg), s = Sr(), c = Hi(), l = e(nz());
  function d(C, P) {
    var x = typeof Symbol < "u" && C[Symbol.iterator] || C["@@iterator"];
    if (!x) {
      if (Array.isArray(C) || (x = u(C)) || P && C && typeof C.length == "number") {
        x && (C = x);
        var w = 0, E = function() {
        };
        return { s: E, n: function() {
          return w >= C.length ? { done: !0 } : { done: !1, value: C[w++] };
        }, e: function(V) {
          throw V;
        }, f: E };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var T = !0, z = !1, j;
    return { s: function() {
      x = x.call(C);
    }, n: function() {
      var V = x.next();
      return T = V.done, V;
    }, e: function(V) {
      z = !0, j = V;
    }, f: function() {
      try {
        !T && x.return != null && x.return();
      } finally {
        if (z)
          throw j;
      }
    } };
  }
  function u(C, P) {
    if (C) {
      if (typeof C == "string")
        return _(C, P);
      var x = Object.prototype.toString.call(C).slice(8, -1);
      if (x === "Object" && C.constructor && (x = C.constructor.name), x === "Map" || x === "Set")
        return Array.from(C);
      if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x))
        return _(C, P);
    }
  }
  function _(C, P) {
    (P == null || P > C.length) && (P = C.length);
    for (var x = 0, w = new Array(P); x < P; x++)
      w[x] = C[x];
    return w;
  }
  var p = function(P) {
    return P.__extended || (P.settings = (0, o.default)({}, i.settings, P.settings), P._fieldsCntByType = {}, P._funcsCntByType = {}, P.types = (0, l.default)(P.types), f(P.types, P), P.fields = (0, l.default)(P.fields), P.__fieldNames = {}, h(P.fields, P), P.funcs = (0, l.default)(P.funcs), b(P.funcs, P), a.default.locale(P.settings.locale.moment), Object.defineProperty(P, "__extended", {
      enumerable: !1,
      writable: !1,
      value: !0
    })), P;
  };
  qi.extendConfig = p;
  function f(C, P) {
    for (var x in C) {
      var w = C[x];
      g(x, w, P);
    }
  }
  function g(C, P, x) {
    var w = null, E = null;
    P.mainWidget = P.mainWidget || Object.keys(P.widgets).filter(function(L) {
      return L != "field" && L != "func";
    })[0];
    for (var T in P.widgets) {
      var z = P.widgets[T];
      if (z.operators) {
        var j = z.operators;
        P.excludeOperators && (j = j.filter(function(L) {
          return !P.excludeOperators.includes(L);
        })), w = (0, s.mergeArraysSmart)(w, j);
      }
      z.defaultOperator && (E = z.defaultOperator), T == P.mainWidget && (z = (0, o.default)({}, {
        widgetProps: P.mainWidgetProps || {}
      }, z)), P.widgets[T] = z;
    }
    P.valueSources || (P.valueSources = Object.keys(x.settings.valueSourcesInfo));
    var q = d(P.valueSources), V;
    try {
      for (q.s(); !(V = q.n()).done; ) {
        var F = V.value;
        F != "value" && !P.widgets[F] && (P.widgets[F] = {});
      }
    } catch (L) {
      q.e(L);
    } finally {
      q.f();
    }
    !P.operators && w && (P.operators = Array.from(new Set(w))), !P.defaultOperator && E && (P.defaultOperator = E);
  }
  function h(C, P) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    for (var w in C)
      v(C[w], P, [].concat((0, n.default)(x), [w])), C[w].subfields && h(C[w].subfields, P, [].concat((0, n.default)(x), [w]));
  }
  function b(C, P) {
    if (C)
      for (var x in C) {
        var w = C[x];
        w.returnType && (P._funcsCntByType[w.returnType] || (P._funcsCntByType[w.returnType] = 0), P._funcsCntByType[w.returnType]++);
        for (var E in w.args)
          v(w.args[E], P, null, !0);
        if (w.args) {
          var T = Object.keys(w.args), z = !0, j = d(T.reverse()), q;
          try {
            for (j.s(); !(q = j.n()).done; ) {
              var V = q.value, F = w.args[V];
              !z && F.isOptional && delete F.isOptional, F.isOptional || (z = !1);
            }
          } catch (L) {
            j.e(L);
          } finally {
            j.f();
          }
        }
        w.subfields && b(w.subfields, P);
      }
  }
  function v(C, P) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, E = null, T = null, z = P.types[C.type], j = C.excludeOperators || [];
    if (C.type != "!struct" && C.type != "!group") {
      if (!z) {
        C.disabled = !0;
        return;
      }
      w || (P._fieldsCntByType[C.type] || (P._fieldsCntByType[C.type] = 0), P._fieldsCntByType[C.type]++), C.widgets || (C.widgets = {}), w && (C._isFuncArg = !0), C.mainWidget = C.mainWidget || z.mainWidget, C.valueSources = C.valueSources || z.valueSources;
      var q = z.excludeOperators || [];
      for (var V in z.widgets) {
        var F = C.widgets[V] || {}, L = z.widgets[V] || {};
        w || function() {
          var re = [].concat((0, n.default)(j), (0, n.default)(q)), Z = C.preferWidgets && (V == "field" || C.preferWidgets.includes(V)) || re.length > 0;
          if (F.operators) {
            var ee = F.operators.filter(function(oe) {
              return !re.includes(oe);
            });
            E = [].concat((0, n.default)(E || []), (0, n.default)(ee));
          } else if (Z && L.operators) {
            var J = L.operators.filter(function(oe) {
              return !re.includes(oe);
            });
            E = [].concat((0, n.default)(E || []), (0, n.default)(J));
          }
          F.defaultOperator && (T = F.defaultOperator);
        }(), V == C.mainWidget && (F = (0, o.default)({}, {
          widgetProps: C.mainWidgetProps || {}
        }, F)), C.widgets[V] = F;
      }
      w || (!C.operators && E && (C.operators = Array.from(new Set(E))), !C.defaultOperator && T && (C.defaultOperator = T));
      var U = ["listValues", "allowCustomValues", "validateValue"];
      C.fieldSettings || (C.fieldSettings = {});
      for (var W = 0, H = U; W < H.length; W++) {
        var Q = H[W];
        C[Q] && (C.fieldSettings[Q] = C[Q], delete C[Q]);
      }
      C.fieldSettings.listValues && (C.fieldSettings.listValues = (0, s.normalizeListValues)(C.fieldSettings.listValues, C.type, C.fieldSettings));
    }
    var X = k(P, x);
    X && (C.fieldName = X), x && C.fieldName && (P.__fieldNames[C.fieldName] = x);
  }
  var $ = function(P, x) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "fields", E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "subfields";
    if (!x)
      return null;
    if (x == "!case_value")
      return {
        type: "case_value",
        mainWidget: "case_value",
        widgets: {
          case_value: P.widgets.case_value
        }
      };
    var T = P.settings.fieldSeparator, z = Array.isArray(x) ? x : x.split(T), j = P[w];
    if (!j)
      return null;
    for (var q = j, V = null, F = [], L = 0; L < z.length; L++) {
      var U = z[L];
      F.push(U);
      var W = F.join(T);
      V = q[W], L < z.length - 1 && (V && V[E] ? (q = V[E], F = []) : V = null);
    }
    return V;
  };
  qi.getFieldRawConfig = $;
  var k = function(P, x) {
    if (!x)
      return null;
    for (var w = P.settings.fieldSeparator, E = (0, n.default)(x), T = [], z, j; (z = E.pop()) !== void 0 && E.length > 0; )
      if (T.unshift(z), j = $(P, E), j.fieldName)
        return [j.fieldName].concat(T).join(w);
    return null;
  }, S = function(P, x) {
    var w = P.settings.fieldSeparator, E = Array.isArray(x) ? x.join(w) : x;
    return P.__fieldNames[E] ? P.__fieldNames[E].join(w) : E;
  };
  qi.normalizeField = S;
  var O = function(P, x) {
    if (!x)
      return null;
    var w = $(P, x, "funcs", "subfields");
    return w || null;
  };
  qi.getFuncConfig = O;
  var I = function(P, x, w) {
    var E = O(P, x);
    if (!E)
      return null;
    var T = E.args && E.args[w] || null;
    if (!T)
      return null;
    var z = P.types[T.type] || {}, j = (0, r.default)({}, z, T || {}, function(q, V, F, L, U, W) {
      if (Array.isArray(q))
        return V;
    });
    return j;
  };
  qi.getFuncArgConfig = I;
  var D = function(P, x) {
    if (!x)
      return null;
    if ((0, t.default)(x) == "object" && !x.func && x.type)
      return x;
    if ((0, t.default)(x) == "object" && x.func && x.arg)
      return I(P, x.func, x.arg);
    var w = $(P, x);
    if (!w)
      return null;
    var E = P.types[w.type] || {}, T = (0, r.default)({}, E, w || {}, function(z, j, q, V, F, L) {
      if (Array.isArray(z))
        return j;
    });
    return T;
  };
  qi.getFieldConfig = D;
  var M = function(P, x) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!x)
      return null;
    var E = P.operators[x];
    if (w) {
      var T = D(P, w), z = (0, c.getWidgetForFieldOp)(P, w, x), j = P.widgets[z] || {}, q = (T && T.widgets ? T.widgets[z] : {}) || {}, V = (j.opProps || {})[x], F = (q.opProps || {})[x], L = (0, o.default)({}, E, V, F);
      return L;
    } else
      return E;
  };
  qi.getOperatorConfig = M;
  var N = function(P, x, w) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, T = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (!x || !(w || E) && T != "const" && x != "!case_value")
      return null;
    var z = D(P, x);
    E || (E = (0, c.getWidgetForFieldOp)(P, x, w, T));
    var j = P.widgets[E] || {}, q = (z && z.widgets ? z.widgets[E] : {}) || {}, V = q.widgetProps || {}, F = (T == "value" || !T) && z && z.fieldSettings || {}, L = (0, o.default)({}, j, V, F);
    return L;
  };
  return qi.getFieldWidgetConfig = N, qi;
}
var Ooe;
function Ns() {
  if (Ooe)
    return ii;
  Ooe = 1;
  var e = Rt;
  Object.defineProperty(ii, "__esModule", {
    value: !0
  }), ii.defaultRuleProperties = ii.defaultRule = ii.defaultRoot = ii.defaultOperatorOptions = ii.defaultOperator = ii.defaultItemProperties = ii.defaultGroupProperties = ii.defaultGroupConjunction = ii.defaultField = ii.defaultConjunction = void 0;
  var t = e(rr), n = e(Ra()), o = e(_m()), r = Br(), i = Hi();
  function a(v, $) {
    var k = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(v);
      $ && (S = S.filter(function(O) {
        return Object.getOwnPropertyDescriptor(v, O).enumerable;
      })), k.push.apply(k, S);
    }
    return k;
  }
  function s(v) {
    for (var $ = 1; $ < arguments.length; $++) {
      var k = arguments[$] != null ? arguments[$] : {};
      $ % 2 ? a(Object(k), !0).forEach(function(S) {
        (0, t.default)(v, S, k[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(k)) : a(Object(k)).forEach(function(S) {
        Object.defineProperty(v, S, Object.getOwnPropertyDescriptor(k, S));
      });
    }
    return v;
  }
  var c = function($) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return typeof $.settings.defaultField == "function" ? $.settings.defaultField(S) : $.settings.defaultField || (k ? (0, i.getFirstField)($, S) : null);
  };
  ii.defaultField = c;
  var l = function($, k) {
    var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, O = (0, r.getFieldConfig)($, k), I = O && O.operators || [], D = O && O.defaultOperator;
    I.includes(D) || (D = null), !D && S && (D = (0, i.getFirstOperator)($, k));
    var M = typeof $.settings.defaultOperator == "function" ? $.settings.defaultOperator(k, O) : D;
    return M;
  };
  ii.defaultOperator = l;
  var d = function($, k, S) {
    var O = k ? (0, r.getOperatorConfig)($, k, S) : null;
    return O && O.options ? new n.default.Map(O.options && O.options.defaults || {}) : null;
  };
  ii.defaultOperatorOptions = d;
  var u = function($) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, O = null, I = null, D = $.settings, M = D.setDefaultFieldAndOp, N = D.showErrorMessage;
    if (S) {
      var C, P;
      O = S == null || (C = S.properties) === null || C === void 0 ? void 0 : C.field, I = S == null || (P = S.properties) === null || P === void 0 ? void 0 : P.operator;
    } else
      M && (O = c($, !0, k), I = l($, O));
    var x = new n.default.Map({
      field: O,
      operator: I,
      value: new n.default.List(),
      valueSrc: new n.default.List(),
      //used for complex operators like proximity
      operatorOptions: d($, I, O)
    });
    if (N && (x = x.set("valueError", new n.default.List())), O && I) {
      var w = (0, i.getNewValueForFieldOp)($, $, x, O, I, "operator", !1), E = w.newValue, T = w.newValueSrc, z = w.newValueType, j = w.newValueError;
      x = x.set("value", E).set("valueSrc", T).set("valueType", z), N && (x = x.set("valueError", j));
    }
    return x;
  };
  ii.defaultRuleProperties = u;
  var _ = function($) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    k = (0, r.getFieldConfig)($, k);
    var S = k && k.conjunctions || Object.keys($.conjunctions);
    return S.length == 1 ? S[0] : $.settings.defaultGroupConjunction || $.settings.defaultConjunction || S[0];
  };
  ii.defaultGroupConjunction = _;
  var p = function($) {
    return $.settings.defaultConjunction || Object.keys($.conjunctions)[0];
  };
  ii.defaultConjunction = p;
  var f = function($) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return new n.default.Map({
      conjunction: _($, k),
      not: !1
    });
  };
  ii.defaultGroupProperties = f;
  var g = function($, k) {
    var S;
    return k && k.type == "group" ? f($, k == null || (S = k.properties) === null || S === void 0 ? void 0 : S.field) : u($, null, k);
  };
  ii.defaultItemProperties = g;
  var h = function($, k) {
    return (0, t.default)({}, $, new n.default.Map({
      type: "rule",
      id: $,
      properties: u(k)
    }));
  };
  ii.defaultRule = h;
  var b = function($) {
    return $.tree ? new n.default.Map($.tree) : new n.default.Map({
      type: "group",
      id: (0, o.default)(),
      children1: new n.default.OrderedMap(s({}, h((0, o.default)(), $))),
      properties: f($)
    });
  };
  return ii.defaultRoot = b, ii;
}
var Un = {}, Poe;
function Rb() {
  if (Poe)
    return Un;
  Poe = 1, Object.defineProperty(Un, "__esModule", {
    value: !0
  }), Un.SET_VALUE_SRC = Un.SET_VALUE = Un.SET_TREE = Un.SET_OPERATOR_OPTION = Un.SET_OPERATOR = Un.SET_NOT = Un.SET_LOCK = Un.SET_FIELD = Un.SET_DRAG_START = Un.SET_DRAG_PROGRESS = Un.SET_DRAG_END = Un.SET_CONJUNCTION = Un.REMOVE_RULE = Un.REMOVE_GROUP = Un.PLACEMENT_PREPEND = Un.PLACEMENT_BEFORE = Un.PLACEMENT_APPEND = Un.PLACEMENT_AFTER = Un.MOVE_ITEM = Un.ADD_RULE = Un.ADD_GROUP = Un.ADD_CASE_GROUP = void 0;
  var e = "ADD_GROUP";
  Un.ADD_GROUP = e;
  var t = "ADD_CASE_GROUP";
  Un.ADD_CASE_GROUP = t;
  var n = "REMOVE_GROUP";
  Un.REMOVE_GROUP = n;
  var o = "SET_CONJUNCTION";
  Un.SET_CONJUNCTION = o;
  var r = "SET_NOT";
  Un.SET_NOT = r;
  var i = "ADD_RULE";
  Un.ADD_RULE = i;
  var a = "REMOVE_RULE";
  Un.REMOVE_RULE = a;
  var s = "SET_FIELD";
  Un.SET_FIELD = s;
  var c = "SET_OPERATOR";
  Un.SET_OPERATOR = c;
  var l = "SET_VALUE";
  Un.SET_VALUE = l;
  var d = "SET_VALUE_SRC";
  Un.SET_VALUE_SRC = d;
  var u = "SET_OPERATOR_OPTION";
  Un.SET_OPERATOR_OPTION = u;
  var _ = "SET_LOCK";
  Un.SET_LOCK = _;
  var p = "SET_TREE";
  Un.SET_TREE = p;
  var f = "MOVE_ITEM";
  Un.MOVE_ITEM = f;
  var g = "after";
  Un.PLACEMENT_AFTER = g;
  var h = "before";
  Un.PLACEMENT_BEFORE = h;
  var b = "append";
  Un.PLACEMENT_APPEND = b;
  var v = "prepend";
  Un.PLACEMENT_PREPEND = v;
  var $ = "SET_DRAG_PROGRESS";
  Un.SET_DRAG_PROGRESS = $;
  var k = "SET_DRAG_START";
  Un.SET_DRAG_START = k;
  var S = "SET_DRAG_END";
  return Un.SET_DRAG_END = S, Un;
}
var Ioe;
function Wdd() {
  return Ioe || (Ioe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Tl), r = t(rr), i = t(Ra()), a = yg(), s = Ns(), c = b(Rb()), l = t(_m()), d = Br(), u = Hi(), _ = Sr(), p = Ek(), f = t(F_()), g = t(tz());
    function h(re) {
      if (typeof WeakMap != "function")
        return null;
      var Z = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap();
      return (h = function(oe) {
        return oe ? ee : Z;
      })(re);
    }
    function b(re, Z) {
      if (!Z && re && re.__esModule)
        return re;
      if (re === null || n(re) !== "object" && typeof re != "function")
        return { default: re };
      var ee = h(Z);
      if (ee && ee.has(re))
        return ee.get(re);
      var J = {}, oe = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var ce in re)
        if (ce !== "default" && Object.prototype.hasOwnProperty.call(re, ce)) {
          var de = oe ? Object.getOwnPropertyDescriptor(re, ce) : null;
          de && (de.get || de.set) ? Object.defineProperty(J, ce, de) : J[ce] = re[ce];
        }
      return J.default = re, ee && ee.set(re, J), J;
    }
    function v(re, Z) {
      var ee = typeof Symbol < "u" && re[Symbol.iterator] || re["@@iterator"];
      if (!ee) {
        if (Array.isArray(re) || (ee = $(re)) || Z && re && typeof re.length == "number") {
          ee && (re = ee);
          var J = 0, oe = function() {
          };
          return { s: oe, n: function() {
            return J >= re.length ? { done: !0 } : { done: !1, value: re[J++] };
          }, e: function(le) {
            throw le;
          }, f: oe };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var ce = !0, de = !1, te;
      return { s: function() {
        ee = ee.call(re);
      }, n: function() {
        var le = ee.next();
        return ce = le.done, le;
      }, e: function(le) {
        de = !0, te = le;
      }, f: function() {
        try {
          !ce && ee.return != null && ee.return();
        } finally {
          if (de)
            throw te;
        }
      } };
    }
    function $(re, Z) {
      if (re) {
        if (typeof re == "string")
          return k(re, Z);
        var ee = Object.prototype.toString.call(re).slice(8, -1);
        if (ee === "Object" && re.constructor && (ee = re.constructor.name), ee === "Map" || ee === "Set")
          return Array.from(re);
        if (ee === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ee))
          return k(re, Z);
      }
    }
    function k(re, Z) {
      (Z == null || Z > re.length) && (Z = re.length);
      for (var ee = 0, J = new Array(Z); ee < Z; ee++)
        J[ee] = re[ee];
      return J;
    }
    function S(re, Z) {
      var ee = Object.keys(re);
      if (Object.getOwnPropertySymbols) {
        var J = Object.getOwnPropertySymbols(re);
        Z && (J = J.filter(function(oe) {
          return Object.getOwnPropertyDescriptor(re, oe).enumerable;
        })), ee.push.apply(ee, J);
      }
      return ee;
    }
    function O(re) {
      for (var Z = 1; Z < arguments.length; Z++) {
        var ee = arguments[Z] != null ? arguments[Z] : {};
        Z % 2 ? S(Object(ee), !0).forEach(function(J) {
          (0, r.default)(re, J, ee[J]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(re, Object.getOwnPropertyDescriptors(ee)) : S(Object(ee)).forEach(function(J) {
          Object.defineProperty(re, J, Object.getOwnPropertyDescriptor(ee, J));
        });
      }
      return re;
    }
    var I = function(Z, ee, J, oe, ce, de) {
      var te = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, ue = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, le = de.settings.shouldCreateEmptyGroup, se = ee.push(oe), me = !le, pe = !!(ue != null && ue.isDefaultCase), be = Z;
      return Z = w(Z, ee, J, oe, (0, s.defaultGroupProperties)(de).merge(ce || {}), de, te), Z !== be && (!te && !pe && (Z = Z.setIn((0, a.expandTreePath)(se, "children1"), new i.default.OrderedMap()), me && (Z = w(Z, se, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(de), de))), Z = (0, a.fixPathsInTree)(Z)), Z;
    }, D = function(Z, ee, J) {
      Z = E(Z, ee);
      var oe = J.settings.canLeaveEmptyGroup, ce = ee.slice(0, -1), de = !(0, a.hasChildren)(Z, ce);
      return de && !oe && (Z = (0, a.fixEmptyGroupsInTree)(Z), (0, a.isEmptyTree)(Z) && !oe && (Z = w(Z, new i.default.List(), "rule", (0, l.default)(), (0, s.defaultRuleProperties)(J), J))), Z = (0, a.fixPathsInTree)(Z), Z;
    }, M = function(Z, ee, J) {
      Z = E(Z, ee);
      var oe = J.settings.canLeaveEmptyGroup, ce = ee.pop(), de = Z.getIn((0, a.expandTreePath)(ce)), te = de.getIn(["properties", "field"]), ue = de.getIn(["properties", "operator"]);
      de.getIn(["properties", "value", 0]);
      var le = te ? (0, d.getFieldConfig)(J, te) : null, se = ue ? (0, d.getOperatorConfig)(J, ue, te) : null, me = te && ue && se.cardinality != 0, pe = de.get("type") == "rule_group", be = !(0, a.hasChildren)(Z, ce), Se = pe ? me && le.initialEmptyWhere : oe;
      return be && !Se && (pe && (Z = Z.deleteIn((0, a.expandTreePath)(ce))), Z = (0, a.fixEmptyGroupsInTree)(Z), (0, a.isEmptyTree)(Z) && !oe && (Z = w(Z, new i.default.List(), "rule", (0, l.default)(), (0, s.defaultRuleProperties)(J), J))), Z = (0, a.fixPathsInTree)(Z), Z;
    }, N = function(Z, ee, J) {
      return Z.setIn((0, a.expandTreePath)(ee, "properties", "not"), J);
    }, C = function(Z, ee, J) {
      return (0, a.removeIsLockedInTree)(Z.setIn((0, a.expandTreePath)(ee, "properties", "isLocked"), J));
    }, P = function(Z, ee, J) {
      return Z.setIn((0, a.expandTreePath)(ee, "properties", "conjunction"), J);
    }, x = function re(Z, ee, J) {
      J && Array.isArray(J) && (ee.children1 = new i.default.OrderedMap(J.reduce(function(oe, ce) {
        var de = (0, l.default)(), te = O(O({}, ce), {}, {
          properties: (0, s.defaultItemProperties)(Z, ce).merge(ce.properties || {}),
          id: de
        });
        return re(Z, te, te.children1), O(O({}, oe), {}, (0, r.default)({}, de, new i.default.Map(te)));
      }, {})));
    }, w = function(Z, ee, J, oe, ce, de) {
      var te = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
      if (J == "switch_group")
        throw new Error("Can't add switch_group programmatically");
      var ue = de.settings, le = ue.maxNumberOfCases, se = ue.maxNumberOfRules, me = ue.maxNesting, pe = Z.get("type"), be = pe == "switch_group", Se = Z.getIn((0, a.expandTreePath)(ee)), Ae = be ? Z.getIn((0, a.expandTreePath)(ee.take(2))) : null, Ze = (0, a.expandTreePath)(ee, "children1"), Ge = Z.getIn(Ze), rt = !!Ge && Ge.size, qe = rt ? Ge.size : null, Xe, lt;
      J == "case_group" ? (Xe = qe, lt = le) : J == "group" ? (Xe = ee.size, lt = me) : (Se == null ? void 0 : Se.get("type")) == "rule_group" || (Xe = be ? (0, a.getTotalRulesCountInTree)(Ae) : (0, a.getTotalRulesCountInTree)(Z), lt = se);
      var Et = lt && Xe ? Xe < lt : !0, wt = {
        type: J,
        id: oe,
        properties: ce
      };
      x(de, wt, te);
      var nn = J == "case_group" && rt && Ge.last().get("children1") == null;
      if (Et) {
        var Dt = new i.default.OrderedMap((0, r.default)({}, oe, new i.default.Map(wt)));
        if (!rt)
          Z = Z.setIn(Ze, Dt);
        else if (nn) {
          var mt, bt = Ge.last(), gn = new i.default.OrderedMap((mt = {}, (0, r.default)(mt, oe, new i.default.Map(wt)), (0, r.default)(mt, bt.get("id"), bt), mt));
          Z = Z.deleteIn((0, a.expandTreePath)(Ze, "children1", bt.get("id"))), Z = Z.mergeIn(Ze, gn);
        } else
          Z = Z.mergeIn(Ze, Dt);
        Z = (0, a.fixPathsInTree)(Z);
      }
      return Z;
    }, E = function(Z, ee) {
      return Z = Z.deleteIn((0, a.expandTreePath)(ee)), Z = (0, a.fixPathsInTree)(Z), Z;
    }, T = function(Z, ee, J, oe, ce) {
      var de = (0, a.getItemByPath)(Z, ee), te = ee.pop(), ue = ee.size > 1 ? (0, a.getItemByPath)(Z, te) : null, le = ue ? ue.get("children1") : null, se = (0, a.getItemByPath)(Z, J), me = oe == c.PLACEMENT_APPEND || oe == c.PLACEMENT_PREPEND ? J : J.pop(), pe = oe == c.PLACEMENT_APPEND || oe == c.PLACEMENT_PREPEND ? se : J.size > 1 ? (0, a.getItemByPath)(Z, me) : null, be = pe ? pe.get("children1") : null;
      if (!ue || !pe)
        return Z;
      var Se = ue.get("id") == pe.get("id"), Ae = me.size < te.size && (0, _.deepEqual)(me.toArray(), te.toArray().slice(0, me.size)), Ze = me.size > te.size && (0, _.deepEqual)(te.toArray(), me.toArray().slice(0, te.size)), Ge = null, rt = null;
      Ae ? Ge = i.default.List(te.toArray().slice(me.size)) : Ze && (rt = i.default.List(me.toArray().slice(te.size)));
      var qe = be, Xe = le;
      return Ze || (Xe = Xe.delete(de.get("id"))), Se ? qe = Xe : Ae && (qe = qe.updateIn((0, a.expandTreeSubpath)(Ge, "children1"), function(lt) {
        return Xe;
      })), oe == c.PLACEMENT_BEFORE || oe == c.PLACEMENT_AFTER ? qe = i.default.OrderedMap().withMutations(function(lt) {
        var Et = v(qe.entries()), wt;
        try {
          for (Et.s(); !(wt = Et.n()).done; ) {
            var nn = (0, o.default)(wt.value, 2), Dt = nn[0], mt = nn[1];
            Dt == se.get("id") && oe == c.PLACEMENT_BEFORE && lt.set(de.get("id"), de), lt.set(Dt, mt), Dt == se.get("id") && oe == c.PLACEMENT_AFTER && lt.set(de.get("id"), de);
          }
        } catch (bt) {
          Et.e(bt);
        } finally {
          Et.f();
        }
      }) : oe == c.PLACEMENT_APPEND ? qe = qe.merge((0, r.default)({}, de.get("id"), de)) : oe == c.PLACEMENT_PREPEND && (qe = i.default.OrderedMap((0, r.default)({}, de.get("id"), de)).merge(qe)), Ze && (Xe = Xe.updateIn((0, a.expandTreeSubpath)(rt, "children1"), function(lt) {
        return qe;
      }), Xe = Xe.delete(de.get("id"))), !Se && !Ae && (Z = Z.updateIn((0, a.expandTreePath)(te, "children1"), function(lt) {
        return Xe;
      })), Ze || (Z = Z.updateIn((0, a.expandTreePath)(me, "children1"), function(lt) {
        return qe;
      })), Z = (0, a.fixPathsInTree)(Z), Z;
    }, z = function(Z, ee, J, oe) {
      if (!J)
        return E(Z, ee);
      var ce = oe.settings, de = ce.fieldSeparator, te = ce.setOpOnChangeField, ue = ce.showErrorMessage;
      Array.isArray(J) && (J = J.join(de));
      var le = Z.getIn((0, a.expandTreePath)(ee, "type")), se = Z.getIn((0, a.expandTreePath)(ee, "properties")), me = le == "rule_group", pe = (0, d.getFieldConfig)(oe, J), be = pe.type == "!group", Se = be && pe.mode == "array", Ae = me != be, Ze = se.get("operator"), Ge = se.get("operatorOptions");
      se.get("field"), se.get("value"), se.get("valueSrc", new i.default.List()), se.get("valueType", new i.default.List());
      var rt = pe && pe.operators.indexOf(Ze) !== -1 ? Ze : null, qe = null, Xe = (0, u.getOperatorsForField)(oe, J);
      if (Xe && Xe.length == 1)
        qe = Xe[0];
      else if (Xe && Xe.length > 1) {
        var lt = v(te || []), Et;
        try {
          for (lt.s(); !(Et = lt.n()).done; ) {
            var wt = Et.value;
            if (wt == "keep" && !Ae ? qe = rt : wt == "default" ? qe = (0, s.defaultOperator)(oe, J, !1) : wt == "first" && (qe = (0, u.getFirstOperator)(oe, J)), qe)
              break;
          }
        } catch (Mn) {
          lt.e(Mn);
        } finally {
          lt.f();
        }
      }
      if (!be && !pe.operators)
        return console.warn("Type ".concat(pe.type, " is not supported")), Z;
      if (me && !be && (Z = Z.setIn((0, a.expandTreePath)(ee, "type"), "rule"), Z = Z.deleteIn((0, a.expandTreePath)(ee, "children1")), Z = Z.setIn((0, a.expandTreePath)(ee, "properties"), new i.default.OrderedMap())), be) {
        Z = Z.setIn((0, a.expandTreePath)(ee, "type"), "rule_group");
        var nn = (0, u.getNewValueForFieldOp)(oe, oe, se, J, qe, "field", !0);
        nn.canReuseValue;
        var Dt = nn.newValue, mt = nn.newValueSrc, bt = nn.newValueType, gn = nn.operatorCardinality, an = (0, s.defaultGroupProperties)(oe, pe).merge({
          field: J,
          mode: pe.mode
        });
        return Se && (an = an.merge({
          operator: qe,
          value: Dt,
          valueSrc: mt,
          valueType: bt
        })), Z = Z.setIn((0, a.expandTreePath)(ee, "children1"), new i.default.OrderedMap()), Z = Z.setIn((0, a.expandTreePath)(ee, "properties"), an), pe.initialEmptyWhere && gn == 1 || (Z = w(Z, ee, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(oe, J), oe)), Z = (0, a.fixPathsInTree)(Z), Z;
      }
      return Z.updateIn((0, a.expandTreePath)(ee, "properties"), function(Mn) {
        return Mn.withMutations(function(Ln) {
          var un = (0, u.getNewValueForFieldOp)(oe, oe, Ln, J, qe, "field", !0), qo = un.canReuseValue, cn = un.newValue, ln = un.newValueSrc, kn = un.newValueType, gt = un.newValueError;
          ue && (Ln = Ln.set("valueError", gt));
          var Ot = qo ? Ge : (0, s.defaultOperatorOptions)(oe, qe, J);
          return Ln.set("field", J).set("operator", qe).set("operatorOptions", Ot).set("value", cn).set("valueSrc", ln).set("valueType", kn).delete("asyncListValues");
        });
      });
    }, j = function(Z, ee, J, oe) {
      var ce = oe.settings.showErrorMessage, de = Z.getIn((0, a.expandTreePath)(ee, "properties")), te = Z.getIn((0, a.expandTreePath)(ee, "children1")), ue = de.get("field"), le = (0, d.getFieldConfig)(oe, ue), se = le.type == "!group", me = (0, d.getOperatorConfig)(oe, J, ue), pe = me ? (0, _.defaultValue)(me.cardinality, 1) : null;
      return Z = Z.updateIn((0, a.expandTreePath)(ee, "properties"), function(be) {
        return be.withMutations(function(Se) {
          var Ae = Se.get("field"), Ze = Se.get("operatorOptions");
          Se.get("value", new i.default.List()), Se.get("valueSrc", new i.default.List()), Se.get("operator");
          var Ge = (0, u.getNewValueForFieldOp)(oe, oe, Se, Ae, J, "operator", !0), rt = Ge.canReuseValue, qe = Ge.newValue, Xe = Ge.newValueSrc, lt = Ge.newValueType, Et = Ge.newValueError;
          ce && (Se = Se.set("valueError", Et));
          var wt = rt ? Ze : (0, s.defaultOperatorOptions)(oe, J, Ae);
          return rt || (Se = Se.delete("asyncListValues")), Se.set("operator", J).set("operatorOptions", wt).set("value", qe).set("valueSrc", Xe).set("valueType", lt);
        });
      }), se && pe == 0 && te.size == 0 && (Z = w(Z, ee, "rule", (0, l.default)(), (0, s.defaultRuleProperties)(oe, ue), oe)), Z;
    }, q = function(Z, ee, J, oe, ce, de, te, ue) {
      var le = de.settings, se = le.fieldSeparator, me = le.showErrorMessage, pe, be = Z.getIn((0, a.expandTreePath)(ee, "properties", "valueSrc", J + "")) || null;
      be === "field" && Array.isArray(oe) && (oe = oe.join(se));
      var Se = Z.getIn((0, a.expandTreePath)(ee, "properties", "field")) || null, Ae = Z.getIn((0, a.expandTreePath)(ee, "properties", "operator")) || null, Ze = (0, d.getOperatorConfig)(de, Ae, Se), Ge = Ae ? (0, _.defaultValue)(Ze.cardinality, 1) : null, rt = !1, qe = !1, Xe = ce || U(oe, be, de), lt = (0, p.validateValue)(de, Se, Se, Ae, oe, Xe, be, te, qe, rt), Et = (0, o.default)(lt, 2), wt = Et[0], nn = Et[1], Dt = !wt;
      if (Dt && nn !== oe && (oe = nn), me) {
        var mt = (0, u.getWidgetForFieldOp)(de, Se, Ae, be), bt = (0, d.getFieldWidgetConfig)(de, Se, Ae, mt, be), gn = Array.from({
          length: Ge
        }, function(gt, Ot) {
          return Z.getIn((0, a.expandTreePath)(ee, "properties", "valueSrc", Ot + "")) || null;
        });
        if (Ze && Ze.validateValues && gn.filter(function(gt) {
          return gt == "value" || gt == null;
        }).length == Ge) {
          var an = Array.from({
            length: Ge
          }, function(gt, Ot) {
            return Ot == J ? oe : Z.getIn((0, a.expandTreePath)(ee, "properties", "value", Ot + "")) || null;
          }), Mn = bt && bt.toJS ? an.map(function(gt) {
            return bt.toJS(gt, bt);
          }) : an, Ln = Ze.validateValues(Mn);
          Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueError", Ge), Ln);
        }
      }
      var un = Z.getIn((0, a.expandTreePath)(ee, "properties", "value"));
      un || (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "value"), new i.default.List(new Array(Ge))).setIn((0, a.expandTreePath)(ee, "properties", "valueType"), new i.default.List(new Array(Ge))).setIn((0, a.expandTreePath)(ee, "properties", "valueError"), new i.default.List(new Array(Ge))));
      var qo = Z.getIn((0, a.expandTreePath)(ee, "properties", "value", J + "")), cn = Z.getIn((0, a.expandTreePath)(ee, "properties", "valueError", J)), ln = qo == null, kn = !!cn;
      return (Dt || me) && (Z = Z.deleteIn((0, a.expandTreePath)(ee, "properties", "asyncListValues")), typeof oe > "u" ? (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "value", J + ""), void 0), Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueType", J + ""), null)) : (te && (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "asyncListValues"), te)), Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "value", J + ""), oe), Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueType", J + ""), Xe), pe = ue && !ln && !kn)), me && (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueError", J), wt)), ue && (Dt && kn || !Dt && !kn) && (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueError", J), wt), pe = !1), {
        tree: Z,
        isInternalValueChange: pe
      };
    }, V = function(Z, ee, J, oe, ce) {
      var de = ce.settings.showErrorMessage, te = Z.getIn((0, a.expandTreePath)(ee, "properties", "field")) || null, ue = Z.getIn((0, a.expandTreePath)(ee, "properties", "operator")) || null;
      if (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "value", J + ""), void 0), Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueType", J + ""), null), Z = Z.deleteIn((0, a.expandTreePath)(ee, "properties", "asyncListValues")), de) {
        Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueError", J), null);
        var le = (0, d.getOperatorConfig)(ce, ue, te), se = ue ? (0, _.defaultValue)(le.cardinality, 1) : null;
        le.validateValues && (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueError", se), null));
      }
      if (typeof oe > "u" ? Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueSrc", J + ""), null) : Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueSrc", J + ""), oe), oe) {
        var me = Z.getIn((0, a.expandTreePath)(ee, "properties")), pe = (0, u.getNewValueForFieldOp)(ce, ce, me, te, ue, "valueSrc", !0), be = pe.canReuseValue, Se = pe.newValue, Ae = pe.newValueSrc, Ze = pe.newValueType;
        pe.newValueError, !be && Ae.get(J) == oe && (Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "value", J + ""), Se.get(J)), Z = Z.setIn((0, a.expandTreePath)(ee, "properties", "valueType", J + ""), Ze.get(J)));
      }
      return Z;
    }, F = function(Z, ee, J, oe) {
      return Z.setIn((0, a.expandTreePath)(ee, "properties", "operatorOptions", J), oe);
    }, L = function(Z, ee) {
      var J = ee.settings.canLeaveEmptyGroup;
      return J || (Z = (0, a.fixEmptyGroupsInTree)(Z)), Z;
    }, U = function(Z, ee, J) {
      var oe = null;
      if (Z) {
        if (ee === "field") {
          var ce = (0, d.getFieldConfig)(J, Z);
          ce && (oe = ce.type);
        } else if (ee === "func") {
          var de = Z.get("func");
          if (de) {
            var te = (0, d.getFuncConfig)(J, de);
            te && (oe = te.returnType);
          }
        }
      }
      return oe;
    }, W = function(Z, ee) {
      var J = Z.getIn((0, a.expandTreePath)(ee, "properties", "field")) || null;
      return J;
    }, H = {
      dragging: {
        id: null,
        x: null,
        y: null,
        w: null,
        h: null
      },
      mousePos: {},
      dragStart: {
        id: null
      }
    }, Q = function(Z, ee) {
      var J = ["config", "asyncListValues", "__isInternal"], oe = [c.SET_TREE, c.SET_DRAG_START, c.SET_DRAG_PROGRESS, c.SET_DRAG_END], ce = (0, g.default)((0, f.default)(Z, J), _.applyToJS), de = Z.path && W(ee.tree, Z.path) || Z.field;
      return de && (ce.affectedField = de), (oe.includes(Z.type) || Z.type.indexOf("@@redux") == 0) && (ce = null), ce;
    }, X = function(Z) {
      var ee = (0, s.defaultRoot)(Z), J = Object.assign({}, {
        tree: ee
      }, H);
      return function() {
        var oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : J, ce = arguments.length > 1 ? arguments[1] : void 0, de = {
          __isInternalValueChange: void 0,
          __lastAction: void 0
        }, te = {}, ue = Q(ce, oe);
        switch (ce.type) {
          case c.SET_TREE: {
            te.tree = ce.tree;
            break;
          }
          case c.ADD_CASE_GROUP: {
            te.tree = I(oe.tree, ce.path, "case_group", ce.id, ce.properties, ce.config, ce.children, ce.meta);
            break;
          }
          case c.ADD_GROUP: {
            te.tree = I(oe.tree, ce.path, "group", ce.id, ce.properties, ce.config, ce.children, ce.meta);
            break;
          }
          case c.REMOVE_GROUP: {
            te.tree = D(oe.tree, ce.path, ce.config);
            break;
          }
          case c.ADD_RULE: {
            te.tree = w(oe.tree, ce.path, ce.ruleType, ce.id, ce.properties, ce.config, ce.children);
            break;
          }
          case c.REMOVE_RULE: {
            te.tree = M(oe.tree, ce.path, ce.config);
            break;
          }
          case c.SET_CONJUNCTION: {
            te.tree = P(oe.tree, ce.path, ce.conjunction);
            break;
          }
          case c.SET_NOT: {
            te.tree = N(oe.tree, ce.path, ce.not);
            break;
          }
          case c.SET_FIELD: {
            te.tree = z(oe.tree, ce.path, ce.field, ce.config);
            break;
          }
          case c.SET_LOCK: {
            te.tree = C(oe.tree, ce.path, ce.lock);
            break;
          }
          case c.SET_OPERATOR: {
            te.tree = j(oe.tree, ce.path, ce.operator, ce.config);
            break;
          }
          case c.SET_VALUE: {
            var le = q(oe.tree, ce.path, ce.delta, ce.value, ce.valueType, ce.config, ce.asyncListValues, ce.__isInternal), se = le.tree, me = le.isInternalValueChange;
            te.__isInternalValueChange = me, te.tree = se;
            break;
          }
          case c.SET_VALUE_SRC: {
            te.tree = V(oe.tree, ce.path, ce.delta, ce.srcKey, ce.config);
            break;
          }
          case c.SET_OPERATOR_OPTION: {
            te.tree = F(oe.tree, ce.path, ce.name, ce.value);
            break;
          }
          case c.MOVE_ITEM: {
            te.tree = T(oe.tree, ce.fromPath, ce.toPath, ce.placement, ce.config);
            break;
          }
          case c.SET_DRAG_START: {
            te.dragStart = ce.dragStart, te.dragging = ce.dragging, te.mousePos = ce.mousePos;
            break;
          }
          case c.SET_DRAG_PROGRESS: {
            te.mousePos = ce.mousePos, te.dragging = ce.dragging;
            break;
          }
          case c.SET_DRAG_END: {
            te.tree = L(oe.tree, Z), te = O(O({}, te), H);
            break;
          }
        }
        return ue && (te.__lastAction = ue), O(O(O({}, oe), de), te);
      };
    };
    e.default = X;
  }(Q5)), Q5;
}
var RR = {}, Roe;
function gz() {
  return Roe || (Roe = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(ve), o = /* @__PURE__ */ n.default.createContext();
    e.default = o;
  }(RR)), RR;
}
function ya(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Noe = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), NR = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, f0 = {
  INIT: "@@redux/INIT" + NR(),
  REPLACE: "@@redux/REPLACE" + NR(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + NR();
  }
};
function Gdd(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function k7(e, t, n) {
  var o;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(ya(0));
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(ya(1));
    return n(k7)(e, t);
  }
  if (typeof e != "function")
    throw new Error(ya(2));
  var r = e, i = t, a = [], s = a, c = !1;
  function l() {
    s === a && (s = a.slice());
  }
  function d() {
    if (c)
      throw new Error(ya(3));
    return i;
  }
  function u(g) {
    if (typeof g != "function")
      throw new Error(ya(4));
    if (c)
      throw new Error(ya(5));
    var h = !0;
    return l(), s.push(g), function() {
      if (h) {
        if (c)
          throw new Error(ya(6));
        h = !1, l();
        var v = s.indexOf(g);
        s.splice(v, 1), a = null;
      }
    };
  }
  function _(g) {
    if (!Gdd(g))
      throw new Error(ya(7));
    if (typeof g.type > "u")
      throw new Error(ya(8));
    if (c)
      throw new Error(ya(9));
    try {
      c = !0, i = r(i, g);
    } finally {
      c = !1;
    }
    for (var h = a = s, b = 0; b < h.length; b++) {
      var v = h[b];
      v();
    }
    return g;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(ya(10));
    r = g, _({
      type: f0.REPLACE
    });
  }
  function f() {
    var g, h = u;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(v) {
        if (typeof v != "object" || v === null)
          throw new Error(ya(11));
        function $() {
          v.next && v.next(d());
        }
        $();
        var k = h($);
        return {
          unsubscribe: k
        };
      }
    }, g[Noe] = function() {
      return this;
    }, g;
  }
  return _({
    type: f0.INIT
  }), o = {
    dispatch: _,
    subscribe: u,
    getState: d,
    replaceReducer: p
  }, o[Noe] = f, o;
}
var Hdd = k7;
function Kdd(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], o = n(void 0, {
      type: f0.INIT
    });
    if (typeof o > "u")
      throw new Error(ya(12));
    if (typeof n(void 0, {
      type: f0.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(ya(13));
  });
}
function Ydd(e) {
  for (var t = Object.keys(e), n = {}, o = 0; o < t.length; o++) {
    var r = t[o];
    typeof e[r] == "function" && (n[r] = e[r]);
  }
  var i = Object.keys(n), a;
  try {
    Kdd(n);
  } catch (s) {
    a = s;
  }
  return function(c, l) {
    if (c === void 0 && (c = {}), a)
      throw a;
    for (var d = !1, u = {}, _ = 0; _ < i.length; _++) {
      var p = i[_], f = n[p], g = c[p], h = f(g, l);
      if (typeof h > "u")
        throw l && l.type, new Error(ya(14));
      u[p] = h, d = d || h !== g;
    }
    return d = d || i.length !== Object.keys(c).length, d ? u : c;
  };
}
function Doe(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function Zdd(e, t) {
  if (typeof e == "function")
    return Doe(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(ya(16));
  var n = {};
  for (var o in e) {
    var r = e[o];
    typeof r == "function" && (n[o] = Doe(r, t));
  }
  return n;
}
function Vke() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(o) {
    return o;
  } : t.length === 1 ? t[0] : t.reduce(function(o, r) {
    return function() {
      return o(r.apply(void 0, arguments));
    };
  });
}
function Qdd() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    return function() {
      var r = o.apply(void 0, arguments), i = function() {
        throw new Error(ya(15));
      }, a = {
        getState: r.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return i = Vke.apply(void 0, s)(r.dispatch), Vn(Vn({}, r), {}, {
        dispatch: i
      });
    };
  };
}
const Jdd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: f0,
  applyMiddleware: Qdd,
  bindActionCreators: Zdd,
  combineReducers: Ydd,
  compose: Vke,
  createStore: k7,
  legacy_createStore: Hdd
}, Symbol.toStringTag, { value: "Module" })), Xdd = /* @__PURE__ */ Oa(Jdd);
var pu = /* @__PURE__ */ ve.createContext(null);
function eud(e) {
  e();
}
var Bke = eud, tud = function(t) {
  return Bke = t;
}, nud = function() {
  return Bke;
};
function oud() {
  var e = nud(), t = null, n = null;
  return {
    clear: function() {
      t = null, n = null;
    },
    notify: function() {
      e(function() {
        for (var r = t; r; )
          r.callback(), r = r.next;
      });
    },
    get: function() {
      for (var r = [], i = t; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe: function(r) {
      var i = !0, a = n = {
        callback: r,
        next: null,
        prev: n
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !i || t === null || (i = !1, a.next ? a.next.prev = a.prev : n = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
var Moe = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function S7(e, t) {
  var n, o = Moe;
  function r(u) {
    return c(), o.subscribe(u);
  }
  function i() {
    o.notify();
  }
  function a() {
    d.onStateChange && d.onStateChange();
  }
  function s() {
    return !!n;
  }
  function c() {
    n || (n = t ? t.addNestedSub(a) : e.subscribe(a), o = oud());
  }
  function l() {
    n && (n(), n = void 0, o.clear(), o = Moe);
  }
  var d = {
    addNestedSub: r,
    notifyNestedSubs: i,
    handleChangeWrapper: a,
    isSubscribed: s,
    trySubscribe: c,
    tryUnsubscribe: l,
    getListeners: function() {
      return o;
    }
  };
  return d;
}
var zT = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ts : Le;
function rud(e) {
  var t = e.store, n = e.context, o = e.children, r = Tt(function() {
    var s = S7(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = Tt(function() {
    return t.getState();
  }, [t]);
  zT(function() {
    var s = r.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [r, i]);
  var a = n || pu;
  return /* @__PURE__ */ ve.createElement(a.Provider, {
    value: r
  }, o);
}
var Uke = { exports: {} }, Dr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hz = 60103, vz = 60106, Pk = 60107, Ik = 60108, Rk = 60114, Nk = 60109, Dk = 60110, Mk = 60112, Lk = 60113, x7 = 60120, qk = 60115, jk = 60116, Wke = 60121, Gke = 60122, Hke = 60117, Kke = 60129, Yke = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var ha = Symbol.for;
  hz = ha("react.element"), vz = ha("react.portal"), Pk = ha("react.fragment"), Ik = ha("react.strict_mode"), Rk = ha("react.profiler"), Nk = ha("react.provider"), Dk = ha("react.context"), Mk = ha("react.forward_ref"), Lk = ha("react.suspense"), x7 = ha("react.suspense_list"), qk = ha("react.memo"), jk = ha("react.lazy"), Wke = ha("react.block"), Gke = ha("react.server.block"), Hke = ha("react.fundamental"), Kke = ha("react.debug_trace_mode"), Yke = ha("react.legacy_hidden");
}
function $d(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case hz:
        switch (e = e.type, e) {
          case Pk:
          case Rk:
          case Ik:
          case Lk:
          case x7:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Dk:
              case Mk:
              case jk:
              case qk:
              case Nk:
                return e;
              default:
                return t;
            }
        }
      case vz:
        return t;
    }
  }
}
var iud = Nk, aud = hz, sud = Mk, cud = Pk, lud = jk, dud = qk, uud = vz, _ud = Rk, pud = Ik, mud = Lk;
Dr.ContextConsumer = Dk;
Dr.ContextProvider = iud;
Dr.Element = aud;
Dr.ForwardRef = sud;
Dr.Fragment = cud;
Dr.Lazy = lud;
Dr.Memo = dud;
Dr.Portal = uud;
Dr.Profiler = _ud;
Dr.StrictMode = pud;
Dr.Suspense = mud;
Dr.isAsyncMode = function() {
  return !1;
};
Dr.isConcurrentMode = function() {
  return !1;
};
Dr.isContextConsumer = function(e) {
  return $d(e) === Dk;
};
Dr.isContextProvider = function(e) {
  return $d(e) === Nk;
};
Dr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === hz;
};
Dr.isForwardRef = function(e) {
  return $d(e) === Mk;
};
Dr.isFragment = function(e) {
  return $d(e) === Pk;
};
Dr.isLazy = function(e) {
  return $d(e) === jk;
};
Dr.isMemo = function(e) {
  return $d(e) === qk;
};
Dr.isPortal = function(e) {
  return $d(e) === vz;
};
Dr.isProfiler = function(e) {
  return $d(e) === Rk;
};
Dr.isStrictMode = function(e) {
  return $d(e) === Ik;
};
Dr.isSuspense = function(e) {
  return $d(e) === Lk;
};
Dr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Pk || e === Rk || e === Kke || e === Ik || e === Lk || e === x7 || e === Yke || typeof e == "object" && e !== null && (e.$$typeof === jk || e.$$typeof === qk || e.$$typeof === Nk || e.$$typeof === Dk || e.$$typeof === Mk || e.$$typeof === Hke || e.$$typeof === Wke || e[0] === Gke);
};
Dr.typeOf = $d;
Uke.exports = Dr;
var fud = Uke.exports, gud = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], hud = ["reactReduxForwardedRef"], vud = [], bud = [null, null];
function yud(e, t) {
  var n = e[1];
  return [t.payload, n + 1];
}
function Loe(e, t, n) {
  zT(function() {
    return e.apply(void 0, t);
  }, n);
}
function $ud(e, t, n, o, r, i, a) {
  e.current = o, t.current = r, n.current = !1, i.current && (i.current = null, a());
}
function wud(e, t, n, o, r, i, a, s, c, l) {
  if (e) {
    var d = !1, u = null, _ = function() {
      if (!d) {
        var g = t.getState(), h, b;
        try {
          h = o(g, r.current);
        } catch (v) {
          b = v, u = v;
        }
        b || (u = null), h === i.current ? a.current || c() : (i.current = h, s.current = h, a.current = !0, l({
          type: "STORE_UPDATED",
          payload: {
            error: b
          }
        }));
      }
    };
    n.onStateChange = _, n.trySubscribe(), _();
    var p = function() {
      if (d = !0, n.tryUnsubscribe(), n.onStateChange = null, u)
        throw u;
    };
    return p;
  }
}
var kud = function() {
  return [null, 0];
};
function Zke(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.getDisplayName, r = o === void 0 ? function($) {
    return "ConnectAdvanced(" + $ + ")";
  } : o, i = n.methodName, a = i === void 0 ? "connectAdvanced" : i, s = n.renderCountProp, c = s === void 0 ? void 0 : s, l = n.shouldHandleStateChanges, d = l === void 0 ? !0 : l, u = n.storeKey, _ = u === void 0 ? "store" : u;
  n.withRef;
  var p = n.forwardRef, f = p === void 0 ? !1 : p, g = n.context, h = g === void 0 ? pu : g, b = uw(n, gud), v = h;
  return function(k) {
    var S = k.displayName || k.name || "Component", O = r(S), I = We({}, b, {
      getDisplayName: r,
      methodName: a,
      renderCountProp: c,
      shouldHandleStateChanges: d,
      storeKey: _,
      displayName: O,
      wrappedComponentName: S,
      WrappedComponent: k
    }), D = b.pure;
    function M(w) {
      return e(w.dispatch, I);
    }
    var N = D ? Tt : function(w) {
      return w();
    };
    function C(w) {
      var E = Tt(function() {
        var me = w.reactReduxForwardedRef, pe = uw(w, hud);
        return [w.context, me, pe];
      }, [w]), T = E[0], z = E[1], j = E[2], q = Tt(function() {
        return T && T.Consumer && fud.isContextConsumer(/* @__PURE__ */ ve.createElement(T.Consumer, null)) ? T : v;
      }, [T, v]), V = Pn(q), F = !!w.store && !!w.store.getState && !!w.store.dispatch;
      V && V.store;
      var L = F ? w.store : V.store, U = Tt(function() {
        return M(L);
      }, [L]), W = Tt(function() {
        if (!d)
          return bud;
        var me = S7(L, F ? null : V.subscription), pe = me.notifyNestedSubs.bind(me);
        return [me, pe];
      }, [L, F, V]), H = W[0], Q = W[1], X = Tt(function() {
        return F ? V : We({}, V, {
          subscription: H
        });
      }, [F, V, H]), re = R0(yud, vud, kud), Z = re[0], ee = Z[0], J = re[1];
      if (ee && ee.error)
        throw ee.error;
      var oe = Ue(), ce = Ue(j), de = Ue(), te = Ue(!1), ue = N(function() {
        return de.current && j === ce.current ? de.current : U(L.getState(), j);
      }, [L, ee, j]);
      Loe($ud, [ce, oe, te, j, ue, de, Q]), Loe(wud, [d, L, H, U, ce, oe, te, de, Q, J], [L, H, U]);
      var le = Tt(function() {
        return /* @__PURE__ */ ve.createElement(k, We({}, ue, {
          ref: z
        }));
      }, [z, k, ue]), se = Tt(function() {
        return d ? /* @__PURE__ */ ve.createElement(q.Provider, {
          value: X
        }, le) : le;
      }, [q, le, X]);
      return se;
    }
    var P = D ? ve.memo(C) : C;
    if (P.WrappedComponent = k, P.displayName = C.displayName = O, f) {
      var x = ve.forwardRef(function(E, T) {
        return /* @__PURE__ */ ve.createElement(P, We({}, E, {
          reactReduxForwardedRef: T
        }));
      });
      return x.displayName = O, x.WrappedComponent = k, _K(x, k);
    }
    return _K(P, k);
  };
}
function qoe(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function vx(e, t) {
  if (qoe(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), o = Object.keys(t);
  if (n.length !== o.length)
    return !1;
  for (var r = 0; r < n.length; r++)
    if (!Object.prototype.hasOwnProperty.call(t, n[r]) || !qoe(e[n[r]], t[n[r]]))
      return !1;
  return !0;
}
function Sud(e, t) {
  var n = {}, o = function(a) {
    var s = e[a];
    typeof s == "function" && (n[a] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var r in e)
    o(r);
  return n;
}
function E7(e) {
  return function(n, o) {
    var r = e(n, o);
    function i() {
      return r;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function joe(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function Qke(e, t) {
  return function(o, r) {
    r.displayName;
    var i = function(s, c) {
      return i.dependsOnOwnProps ? i.mapToProps(s, c) : i.mapToProps(s);
    };
    return i.dependsOnOwnProps = !0, i.mapToProps = function(s, c) {
      i.mapToProps = e, i.dependsOnOwnProps = joe(e);
      var l = i(s, c);
      return typeof l == "function" && (i.mapToProps = l, i.dependsOnOwnProps = joe(l), l = i(s, c)), l;
    }, i;
  };
}
function xud(e) {
  return typeof e == "function" ? Qke(e) : void 0;
}
function Eud(e) {
  return e ? void 0 : E7(function(t) {
    return {
      dispatch: t
    };
  });
}
function Tud(e) {
  return e && typeof e == "object" ? E7(function(t) {
    return Sud(e, t);
  }) : void 0;
}
const Aud = [xud, Eud, Tud];
function Cud(e) {
  return typeof e == "function" ? Qke(e) : void 0;
}
function zud(e) {
  return e ? void 0 : E7(function() {
    return {};
  });
}
const Oud = [Cud, zud];
function Pud(e, t, n) {
  return We({}, n, e, t);
}
function Iud(e) {
  return function(n, o) {
    o.displayName;
    var r = o.pure, i = o.areMergedPropsEqual, a = !1, s;
    return function(l, d, u) {
      var _ = e(l, d, u);
      return a ? (!r || !i(_, s)) && (s = _) : (a = !0, s = _), s;
    };
  };
}
function Rud(e) {
  return typeof e == "function" ? Iud(e) : void 0;
}
function Nud(e) {
  return e ? void 0 : function() {
    return Pud;
  };
}
const Dud = [Rud, Nud];
var Mud = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function Lud(e, t, n, o) {
  return function(i, a) {
    return n(e(i, a), t(o, a), a);
  };
}
function qud(e, t, n, o, r) {
  var i = r.areStatesEqual, a = r.areOwnPropsEqual, s = r.areStatePropsEqual, c = !1, l, d, u, _, p;
  function f($, k) {
    return l = $, d = k, u = e(l, d), _ = t(o, d), p = n(u, _, d), c = !0, p;
  }
  function g() {
    return u = e(l, d), t.dependsOnOwnProps && (_ = t(o, d)), p = n(u, _, d), p;
  }
  function h() {
    return e.dependsOnOwnProps && (u = e(l, d)), t.dependsOnOwnProps && (_ = t(o, d)), p = n(u, _, d), p;
  }
  function b() {
    var $ = e(l, d), k = !s($, u);
    return u = $, k && (p = n(u, _, d)), p;
  }
  function v($, k) {
    var S = !a(k, d), O = !i($, l);
    return l = $, d = k, S && O ? g() : S ? h() : O ? b() : p;
  }
  return function(k, S) {
    return c ? v(k, S) : f(k, S);
  };
}
function jud(e, t) {
  var n = t.initMapStateToProps, o = t.initMapDispatchToProps, r = t.initMergeProps, i = uw(t, Mud), a = n(e, i), s = o(e, i), c = r(e, i), l = i.pure ? qud : Lud;
  return l(a, s, c, e, i);
}
var Fud = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function DR(e, t, n) {
  for (var o = t.length - 1; o >= 0; o--) {
    var r = t[o](e);
    if (r)
      return r;
  }
  return function(i, a) {
    throw new Error("Invalid value of type " + typeof e + " for " + n + " argument when connecting component " + a.wrappedComponentName + ".");
  };
}
function Vud(e, t) {
  return e === t;
}
function Bud(e) {
  var t = e === void 0 ? {} : e, n = t.connectHOC, o = n === void 0 ? Zke : n, r = t.mapStateToPropsFactories, i = r === void 0 ? Oud : r, a = t.mapDispatchToPropsFactories, s = a === void 0 ? Aud : a, c = t.mergePropsFactories, l = c === void 0 ? Dud : c, d = t.selectorFactory, u = d === void 0 ? jud : d;
  return function(p, f, g, h) {
    h === void 0 && (h = {});
    var b = h, v = b.pure, $ = v === void 0 ? !0 : v, k = b.areStatesEqual, S = k === void 0 ? Vud : k, O = b.areOwnPropsEqual, I = O === void 0 ? vx : O, D = b.areStatePropsEqual, M = D === void 0 ? vx : D, N = b.areMergedPropsEqual, C = N === void 0 ? vx : N, P = uw(b, Fud), x = DR(p, i, "mapStateToProps"), w = DR(f, s, "mapDispatchToProps"), E = DR(g, l, "mergeProps");
    return o(u, We({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(z) {
        return "Connect(" + z + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!p,
      // passed through to selectorFactory
      initMapStateToProps: x,
      initMapDispatchToProps: w,
      initMergeProps: E,
      pure: $,
      areStatesEqual: S,
      areOwnPropsEqual: I,
      areStatePropsEqual: M,
      areMergedPropsEqual: C
    }, P));
  };
}
const Uud = /* @__PURE__ */ Bud();
function Jke() {
  var e = Pn(pu);
  return e;
}
function T7(e) {
  e === void 0 && (e = pu);
  var t = e === pu ? Jke : function() {
    return Pn(e);
  };
  return function() {
    var o = t(), r = o.store;
    return r;
  };
}
var Xke = /* @__PURE__ */ T7();
function e1e(e) {
  e === void 0 && (e = pu);
  var t = e === pu ? Xke : T7(e);
  return function() {
    var o = t();
    return o.dispatch;
  };
}
var Wud = /* @__PURE__ */ e1e(), Gud = function(t, n) {
  return t === n;
};
function Hud(e, t, n, o) {
  var r = R0(function(f) {
    return f + 1;
  }, 0), i = r[1], a = Tt(function() {
    return S7(n, o);
  }, [n, o]), s = Ue(), c = Ue(), l = Ue(), d = Ue(), u = n.getState(), _;
  try {
    if (e !== c.current || u !== l.current || s.current) {
      var p = e(u);
      d.current === void 0 || !t(p, d.current) ? _ = p : _ = d.current;
    } else
      _ = d.current;
  } catch (f) {
    throw s.current && (f.message += `
The error may be correlated with this previous error:
` + s.current.stack + `

`), f;
  }
  return zT(function() {
    c.current = e, l.current = u, d.current = _, s.current = void 0;
  }), zT(function() {
    function f() {
      try {
        var g = n.getState();
        if (g === l.current)
          return;
        var h = c.current(g);
        if (t(h, d.current))
          return;
        d.current = h, l.current = g;
      } catch (b) {
        s.current = b;
      }
      i();
    }
    return a.onStateChange = f, a.trySubscribe(), f(), function() {
      return a.tryUnsubscribe();
    };
  }, [n, a]), _;
}
function t1e(e) {
  e === void 0 && (e = pu);
  var t = e === pu ? Jke : function() {
    return Pn(e);
  };
  return function(o, r) {
    r === void 0 && (r = Gud);
    var i = t(), a = i.store, s = i.subscription, c = Hud(o, r, a, s);
    return RAe(c), c;
  };
}
var Kud = /* @__PURE__ */ t1e();
tud(zie);
const Yud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Provider: rud,
  ReactReduxContext: pu,
  batch: zie,
  connect: Uud,
  connectAdvanced: Zke,
  createDispatchHook: e1e,
  createSelectorHook: t1e,
  createStoreHook: T7,
  shallowEqual: vx,
  useDispatch: Wud,
  useSelector: Kud,
  useStore: Xke
}, Symbol.toStringTag, { value: "Module" })), bz = /* @__PURE__ */ Oa(Yud);
var Bl = {}, ji = {}, Foe;
function Zud() {
  if (Foe)
    return ji;
  Foe = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(ji, "__esModule", {
    value: !0
  }), ji.setTree = ji.removeRule = ji.removeGroup = ji.moveItem = ji.addRule = ji.addGroup = ji.addDefaultCaseGroup = ji.addCaseGroup = void 0;
  var n = e(_m()), o = Sr(), r = Ns(), i = s(Rb());
  e(Ra());
  function a(h) {
    if (typeof WeakMap != "function")
      return null;
    var b = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (a = function(k) {
      return k ? v : b;
    })(h);
  }
  function s(h, b) {
    if (!b && h && h.__esModule)
      return h;
    if (h === null || t(h) !== "object" && typeof h != "function")
      return { default: h };
    var v = a(b);
    if (v && v.has(h))
      return v.get(h);
    var $ = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var S in h)
      if (S !== "default" && Object.prototype.hasOwnProperty.call(h, S)) {
        var O = k ? Object.getOwnPropertyDescriptor(h, S) : null;
        O && (O.get || O.set) ? Object.defineProperty($, S, O) : $[S] = h[S];
      }
    return $.default = h, v && v.set(h, $), $;
  }
  var c = function(b, v) {
    return {
      type: i.SET_TREE,
      tree: v
    };
  };
  ji.setTree = c;
  var l = function(b, v, $) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "rule", S = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    return {
      type: i.ADD_RULE,
      ruleType: k,
      children: S,
      path: (0, o.toImmutableList)(v),
      id: (0, n.default)(),
      properties: (0, r.defaultRuleProperties)(b).merge($ || {}),
      config: b
    };
  };
  ji.addRule = l;
  var d = function(b, v) {
    return {
      type: i.REMOVE_RULE,
      path: (0, o.toImmutableList)(v),
      config: b
    };
  };
  ji.removeRule = d;
  var u = function(b, v, $) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_CASE_GROUP,
      path: (0, o.toImmutableList)(v),
      children: k,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)(b).merge($ || {}),
      config: b,
      meta: {
        isDefaultCase: !0
      }
    };
  };
  ji.addDefaultCaseGroup = u;
  var _ = function(b, v, $) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_CASE_GROUP,
      path: (0, o.toImmutableList)(v),
      children: k,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)(b).merge($ || {}),
      config: b
    };
  };
  ji.addCaseGroup = _;
  var p = function(b, v, $) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      type: i.ADD_GROUP,
      path: (0, o.toImmutableList)(v),
      children: k,
      id: (0, n.default)(),
      properties: (0, r.defaultGroupProperties)(b).merge($ || {}),
      config: b
    };
  };
  ji.addGroup = p;
  var f = function(b, v) {
    return {
      type: i.REMOVE_GROUP,
      path: (0, o.toImmutableList)(v),
      config: b
    };
  };
  ji.removeGroup = f;
  var g = function(b, v, $, k) {
    return {
      type: i.MOVE_ITEM,
      fromPath: (0, o.toImmutableList)(v),
      toPath: (0, o.toImmutableList)($),
      placement: k,
      config: b
    };
  };
  return ji.moveItem = g, ji;
}
var Zu = {}, Voe;
function Qud() {
  if (Voe)
    return Zu;
  Voe = 1;
  var e = Yn;
  Object.defineProperty(Zu, "__esModule", {
    value: !0
  }), Zu.setNot = Zu.setLock = Zu.setConjunction = void 0;
  var t = r(Rb()), n = Sr();
  function o(c) {
    if (typeof WeakMap != "function")
      return null;
    var l = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (o = function(_) {
      return _ ? d : l;
    })(c);
  }
  function r(c, l) {
    if (!l && c && c.__esModule)
      return c;
    if (c === null || e(c) !== "object" && typeof c != "function")
      return { default: c };
    var d = o(l);
    if (d && d.has(c))
      return d.get(c);
    var u = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in c)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(c, p)) {
        var f = _ ? Object.getOwnPropertyDescriptor(c, p) : null;
        f && (f.get || f.set) ? Object.defineProperty(u, p, f) : u[p] = c[p];
      }
    return u.default = c, d && d.set(c, u), u;
  }
  var i = function(l, d, u) {
    return {
      type: t.SET_CONJUNCTION,
      path: (0, n.toImmutableList)(d),
      conjunction: u
    };
  };
  Zu.setConjunction = i;
  var a = function(l, d, u) {
    return {
      type: t.SET_NOT,
      path: (0, n.toImmutableList)(d),
      not: u
    };
  };
  Zu.setNot = a;
  var s = function(l, d, u) {
    return {
      type: t.SET_LOCK,
      path: (0, n.toImmutableList)(d),
      lock: u
    };
  };
  return Zu.setLock = s, Zu;
}
var fc = {}, Boe;
function Jud() {
  if (Boe)
    return fc;
  Boe = 1;
  var e = Yn;
  Object.defineProperty(fc, "__esModule", {
    value: !0
  }), fc.setValueSrc = fc.setValue = fc.setOperatorOption = fc.setOperator = fc.setField = void 0;
  var t = r(Rb()), n = Sr();
  function o(d) {
    if (typeof WeakMap != "function")
      return null;
    var u = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (o = function(f) {
      return f ? _ : u;
    })(d);
  }
  function r(d, u) {
    if (!u && d && d.__esModule)
      return d;
    if (d === null || e(d) !== "object" && typeof d != "function")
      return { default: d };
    var _ = o(u);
    if (_ && _.has(d))
      return _.get(d);
    var p = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var g in d)
      if (g !== "default" && Object.prototype.hasOwnProperty.call(d, g)) {
        var h = f ? Object.getOwnPropertyDescriptor(d, g) : null;
        h && (h.get || h.set) ? Object.defineProperty(p, g, h) : p[g] = d[g];
      }
    return p.default = d, _ && _.set(d, p), p;
  }
  var i = function(u, _, p) {
    return {
      type: t.SET_FIELD,
      path: (0, n.toImmutableList)(_),
      field: p,
      config: u
    };
  };
  fc.setField = i;
  var a = function(u, _, p) {
    return {
      type: t.SET_OPERATOR,
      path: (0, n.toImmutableList)(_),
      operator: p,
      config: u
    };
  };
  fc.setOperator = a;
  var s = function(u, _, p, f, g, h, b) {
    return {
      type: t.SET_VALUE,
      path: (0, n.toImmutableList)(_),
      delta: p,
      value: f,
      valueType: g,
      asyncListValues: h,
      config: u,
      __isInternal: b
    };
  };
  fc.setValue = s;
  var c = function(u, _, p, f) {
    return {
      type: t.SET_VALUE_SRC,
      path: (0, n.toImmutableList)(_),
      delta: p,
      srcKey: f,
      config: u
    };
  };
  fc.setValueSrc = c;
  var l = function(u, _, p, f) {
    return {
      type: t.SET_OPERATOR_OPTION,
      path: (0, n.toImmutableList)(_),
      name: p,
      value: f,
      config: u
    };
  };
  return fc.setOperatorOption = l, fc;
}
var Qu = {}, Uoe;
function Xud() {
  if (Uoe)
    return Qu;
  Uoe = 1;
  var e = Yn;
  Object.defineProperty(Qu, "__esModule", {
    value: !0
  }), Qu.setDragStart = Qu.setDragProgress = Qu.setDragEnd = void 0;
  var t = o(Rb());
  function n(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (n = function(u) {
      return u ? l : c;
    })(s);
  }
  function o(s, c) {
    if (!c && s && s.__esModule)
      return s;
    if (s === null || e(s) !== "object" && typeof s != "function")
      return { default: s };
    var l = n(c);
    if (l && l.has(s))
      return l.get(s);
    var d = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in s)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(s, _)) {
        var p = u ? Object.getOwnPropertyDescriptor(s, _) : null;
        p && (p.get || p.set) ? Object.defineProperty(d, _, p) : d[_] = s[_];
      }
    return d.default = s, l && l.set(s, d), d;
  }
  var r = function(c, l) {
    return {
      type: t.SET_DRAG_PROGRESS,
      mousePos: c,
      dragging: l
    };
  };
  Qu.setDragProgress = r;
  var i = function(c, l, d) {
    return {
      type: t.SET_DRAG_START,
      dragStart: c,
      dragging: l,
      mousePos: d
    };
  };
  Qu.setDragStart = i;
  var a = function() {
    return {
      type: t.SET_DRAG_END
    };
  };
  return Qu.setDragEnd = a, Qu;
}
var Woe;
function A7() {
  if (Woe)
    return Bl;
  Woe = 1;
  var e = Yn;
  Object.defineProperty(Bl, "__esModule", {
    value: !0
  }), Bl.tree = Bl.rule = Bl.group = Bl.drag = void 0;
  var t = a(Zud());
  Bl.tree = t;
  var n = a(Qud());
  Bl.group = n;
  var o = a(Jud());
  Bl.rule = o;
  var r = a(Xud());
  Bl.drag = r;
  function i(s) {
    if (typeof WeakMap != "function")
      return null;
    var c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (i = function(u) {
      return u ? l : c;
    })(s);
  }
  function a(s, c) {
    if (!c && s && s.__esModule)
      return s;
    if (s === null || e(s) !== "object" && typeof s != "function")
      return { default: s };
    var l = i(c);
    if (l && l.has(s))
      return l.get(s);
    var d = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var _ in s)
      if (_ !== "default" && Object.prototype.hasOwnProperty.call(s, _)) {
        var p = u ? Object.getOwnPropertyDescriptor(s, _) : null;
        p && (p.get || p.set) ? Object.defineProperty(d, _, p) : d[_] = s[_];
      }
    return d.default = s, l && l.set(s, d), d;
  }
  return Bl;
}
var MR = {}, Goe;
function e_d() {
  return Goe || (Goe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.validateAndFixTree = e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = v(ve), u = t(di), _ = v(A7()), p = yg(), f = Sr(), g = Na(), h = Ek();
    function b(M) {
      if (typeof WeakMap != "function")
        return null;
      var N = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
      return (b = function(x) {
        return x ? C : N;
      })(M);
    }
    function v(M, N) {
      if (!N && M && M.__esModule)
        return M;
      if (M === null || n(M) !== "object" && typeof M != "function")
        return { default: M };
      var C = b(N);
      if (C && C.has(M))
        return C.get(M);
      var P = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in M)
        if (w !== "default" && Object.prototype.hasOwnProperty.call(M, w)) {
          var E = x ? Object.getOwnPropertyDescriptor(M, w) : null;
          E && (E.get || E.set) ? Object.defineProperty(P, w, E) : P[w] = M[w];
        }
      return P.default = M, C && C.set(M, P), P;
    }
    function $(M, N) {
      var C = Object.keys(M);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(M);
        N && (P = P.filter(function(x) {
          return Object.getOwnPropertyDescriptor(M, x).enumerable;
        })), C.push.apply(C, P);
      }
      return C;
    }
    function k(M) {
      for (var N = 1; N < arguments.length; N++) {
        var C = arguments[N] != null ? arguments[N] : {};
        N % 2 ? $(Object(C), !0).forEach(function(P) {
          (0, o.default)(M, P, C[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(C)) : $(Object(C)).forEach(function(P) {
          Object.defineProperty(M, P, Object.getOwnPropertyDescriptor(C, P));
        });
      }
      return M;
    }
    function S(M) {
      var N = O();
      return function() {
        var P = (0, l.default)(M), x;
        if (N) {
          var w = (0, l.default)(this).constructor;
          x = Reflect.construct(P, arguments, w);
        } else
          x = P.apply(this, arguments);
        return (0, c.default)(this, x);
      };
    }
    function O() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var I = function(N, C, P, x) {
      var w = (0, h.validateTree)(N, C, P, x);
      return w = (0, p.fixPathsInTree)(w), w;
    };
    e.validateAndFixTree = I;
    var D = /* @__PURE__ */ function(M) {
      (0, s.default)(C, M);
      var N = S(C);
      function C(P) {
        var x;
        return (0, r.default)(this, C), x = N.call(this, P), (0, g.useOnPropsChanged)((0, a.default)(x)), x._updateActions(P), x.validatedTree = x.validateTree(P, P), x;
      }
      return (0, i.default)(C, [{
        key: "validateTree",
        value: function(x, w) {
          return I(x.tree, w.tree, x.config, w.config);
        }
      }, {
        key: "_updateActions",
        value: function(x) {
          var w = x.config, E = x.dispatch;
          this.actions = (0, g.bindActionCreators)(k(k(k({}, _.tree), _.group), _.rule), w, E);
        }
      }, {
        key: "onPropsChanged",
        value: function(x) {
          var w = x.onChange, E = this.props.config, T = x.tree, z = x.config, j = this.validatedTree;
          this.validatedTree = T, E !== z && (this._updateActions(x), this.validatedTree = this.validateTree(x, this.props));
          var q = !(0, f.immutableEqual)(this.validatedTree, j);
          q && w && w(this.validatedTree, z, x.__lastAction);
        }
      }, {
        key: "render",
        value: function() {
          var x = this.props, w = x.config, E = x.renderBuilder, T = x.dispatch, z = x.__isInternalValueChange, j = {
            tree: this.validatedTree,
            actions: this.actions,
            config: w,
            dispatch: T,
            __isInternalValueChange: z
          };
          return E(j);
        }
      }]), C;
    }(d.PureComponent);
    e.default = D, D.propTypes = {
      config: u.default.object.isRequired,
      onChange: u.default.func,
      renderBuilder: u.default.func,
      tree: u.default.any
      //instanceOf(Immutable.Map)
      //dispatch: PropTypes.func.isRequired,
    };
  }(MR)), MR;
}
var Hoe;
function t_d() {
  return Hoe || (Hoe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = D(ve), u = t(di), _ = t(Wdd()), p = t(gz()), f = Xdd, g = bz, h = D(A7()), b = Br(), v = Sr(), $ = Ns(), k = Na(), S = t($g()), O = D(e_d());
    function I(T) {
      if (typeof WeakMap != "function")
        return null;
      var z = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap();
      return (I = function(V) {
        return V ? j : z;
      })(T);
    }
    function D(T, z) {
      if (!z && T && T.__esModule)
        return T;
      if (T === null || n(T) !== "object" && typeof T != "function")
        return { default: T };
      var j = I(z);
      if (j && j.has(T))
        return j.get(T);
      var q = {}, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var F in T)
        if (F !== "default" && Object.prototype.hasOwnProperty.call(T, F)) {
          var L = V ? Object.getOwnPropertyDescriptor(T, F) : null;
          L && (L.get || L.set) ? Object.defineProperty(q, F, L) : q[F] = T[F];
        }
      return q.default = T, j && j.set(T, q), q;
    }
    function M(T, z) {
      var j = Object.keys(T);
      if (Object.getOwnPropertySymbols) {
        var q = Object.getOwnPropertySymbols(T);
        z && (q = q.filter(function(V) {
          return Object.getOwnPropertyDescriptor(T, V).enumerable;
        })), j.push.apply(j, q);
      }
      return j;
    }
    function N(T) {
      for (var z = 1; z < arguments.length; z++) {
        var j = arguments[z] != null ? arguments[z] : {};
        z % 2 ? M(Object(j), !0).forEach(function(q) {
          (0, o.default)(T, q, j[q]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(j)) : M(Object(j)).forEach(function(q) {
          Object.defineProperty(T, q, Object.getOwnPropertyDescriptor(j, q));
        });
      }
      return T;
    }
    function C(T) {
      var z = P();
      return function() {
        var q = (0, l.default)(T), V;
        if (z) {
          var F = (0, l.default)(this).constructor;
          V = Reflect.construct(q, arguments, F);
        } else
          V = q.apply(this, arguments);
        return (0, c.default)(this, V);
      };
    }
    function P() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var x = ["conjunctions", "fields", "types", "operators", "widgets", "settings", "funcs"], w = (0, g.connect)(function(T) {
      return {
        tree: T.tree,
        __isInternalValueChange: T.__isInternalValueChange,
        __lastAction: T.__lastAction
      };
    }, null, null, {
      context: p.default
    })(O.default);
    w.displayName = "ConnectedQuery";
    var E = /* @__PURE__ */ function(T) {
      (0, s.default)(j, T);
      var z = C(j);
      function j(q, V) {
        var F;
        (0, r.default)(this, j), F = z.call(this, q, V), F.shouldComponentUpdate = (0, k.liteShouldComponentUpdate)((0, a.default)(F), {
          value: function(re, Z, ee) {
            return !1;
          }
        }), (0, k.useOnPropsChanged)((0, a.default)(F));
        var L = (0, S.default)(q, x), U = (0, b.extendConfig)(L), W = q.value, H = W ? (0, O.validateAndFixTree)(W, null, L, L) : null, Q = (0, _.default)(N(N({}, L), {}, {
          tree: H
        }));
        return F.state = {
          store: (0, f.createStore)(Q),
          config: U
        }, F;
      }
      return (0, i.default)(j, [{
        key: "onPropsChanged",
        value: function(V) {
          var F = this, L = (0, S.default)(this.props, x), U = (0, S.default)(V, x), W = !(0, v.shallowEqual)(L, U, !0);
          W && (U = (0, b.extendConfig)(U), this.setState({
            config: U
          }));
          var H = this.state.store.getState().tree, Q = !(0, v.immutableEqual)(V.value, this.props.value) && !(0, v.immutableEqual)(V.value, H);
          if (Q) {
            var X = V.value || (0, $.defaultRoot)(N(N({}, V), {}, {
              tree: null
            })), re = (0, O.validateAndFixTree)(X, null, U, L);
            return Promise.resolve().then(function() {
              F.state.store.dispatch(h.tree.setTree(V, re));
            });
          }
        }
      }, {
        key: "render",
        value: function() {
          var V = this.props, F = V.renderBuilder, L = V.get_children, U = V.onChange, W = V.settings, H = this.state, Q = H.config, X = H.store, re = W.renderProvider;
          return /* @__PURE__ */ d.default.createElement(re, {
            config: Q
          }, /* @__PURE__ */ d.default.createElement(g.Provider, {
            store: X,
            context: p.default
          }, /* @__PURE__ */ d.default.createElement(w, {
            store: X,
            config: Q,
            onChange: U,
            renderBuilder: F || L
          })));
        }
      }]), j;
    }(d.Component);
    e.default = E, E.propTypes = {
      //config
      conjunctions: u.default.object.isRequired,
      fields: u.default.object.isRequired,
      types: u.default.object.isRequired,
      operators: u.default.object.isRequired,
      widgets: u.default.object.isRequired,
      settings: u.default.object.isRequired,
      onChange: u.default.func,
      renderBuilder: u.default.func,
      value: u.default.any
      //instanceOf(Immutable.Map)
    };
  }(Z5)), Z5;
}
var LR = {}, e$ = {}, qR = {}, jR = {}, Koe;
function n_d() {
  return Koe || (Koe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(yr), r = t($r), i = t(wr), a = t(kr()), s = t(ir()), c = g(ve), l = t(di), d = t(gz()), u = Br(), _ = Na(), p = bz;
    function f(S) {
      if (typeof WeakMap != "function")
        return null;
      var O = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap();
      return (f = function(M) {
        return M ? I : O;
      })(S);
    }
    function g(S, O) {
      if (!O && S && S.__esModule)
        return S;
      if (S === null || n(S) !== "object" && typeof S != "function")
        return { default: S };
      var I = f(O);
      if (I && I.has(S))
        return I.get(S);
      var D = {}, M = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var N in S)
        if (N !== "default" && Object.prototype.hasOwnProperty.call(S, N)) {
          var C = M ? Object.getOwnPropertyDescriptor(S, N) : null;
          C && (C.get || C.set) ? Object.defineProperty(D, N, C) : D[N] = S[N];
        }
      return D.default = S, I && I.set(S, D), D;
    }
    function h(S) {
      var O = b();
      return function() {
        var D = (0, s.default)(S), M;
        if (O) {
          var N = (0, s.default)(this).constructor;
          M = Reflect.construct(D, arguments, N);
        } else
          M = D.apply(this, arguments);
        return (0, a.default)(this, M);
      };
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var v = cm, $ = function(O) {
      var I;
      return I = /* @__PURE__ */ function(D) {
        (0, i.default)(N, D);
        var M = h(N);
        function N(C) {
          var P;
          return (0, o.default)(this, N), P = M.call(this, C), P.dummyFn = function() {
          }, P.removeSelf = function() {
            P.props.actions.removeRule(P.props.path);
          }, P.setLock = function() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            P.props.actions.setLock(P.props.path, x);
          }, P.setField = function(x) {
            P.props.actions.setField(P.props.path, x);
          }, P.setOperator = function(x) {
            P.props.actions.setOperator(P.props.path, x);
          }, P.setOperatorOption = function(x, w) {
            P.props.actions.setOperatorOption(P.props.path, x, w);
          }, P.setValue = function(x, w, E, T, z) {
            P.props.actions.setValue(P.props.path, x, w, E, T, z);
          }, P.setValueSrc = function(x, w) {
            P.props.actions.setValueSrc(P.props.path, x, w);
          }, P.dummyFn.isDummyFn = !0, P;
        }
        return (0, r.default)(N, [{
          key: "shouldComponentUpdate",
          value: function(P, x) {
            var w = this.props, E = this.state, T = (0, _.pureShouldComponentUpdate)(this)(P, x);
            if (T && E == x && w != P) {
              var z = P.dragging.id || w.dragging.id, j = z == P.id, q = [];
              for (var V in P) {
                var F = P[V] != w[V];
                V == "dragging" && !j && (F = !1), F && q.push(V);
              }
              q.length || (T = !1);
            }
            return T;
          }
        }, {
          key: "render",
          value: function() {
            var P = this.props.dragging.id == this.props.id, x = (0, u.getFieldConfig)(this.props.config, this.props.field), w = this.props.config.settings.showErrorMessage;
            x && x.type == "!struct";
            var E = !P && this.props.isDraggingTempo, T = this.props.valueError, z = T && T.toArray().filter(function(q) {
              return !!q;
            }).shift() || null, j = z != null && w;
            return /* @__PURE__ */ c.default.createElement("div", {
              className: v("group-or-rule-container", "rule-container", j ? "rule-with-error" : null),
              "data-id": this.props.id
            }, [P ? /* @__PURE__ */ c.default.createElement(O, {
              key: "dragging",
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: !0,
              isDraggingTempo: !0,
              dragging: this.props.dragging,
              setField: this.dummyFn,
              setOperator: this.dummyFn,
              setOperatorOption: this.dummyFn,
              setLock: this.dummyFn,
              removeSelf: this.dummyFn,
              setValue: this.dummyFn,
              setValueSrc: this.dummyFn,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              value: this.props.value || null,
              valueSrc: this.props.valueSrc || null,
              valueError: this.props.valueError || null,
              operatorOptions: this.props.operatorOptions,
              config: this.props.config,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              asyncListValues: this.props.asyncListValues,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            }) : null, /* @__PURE__ */ c.default.createElement(O, {
              key: this.props.id,
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: P,
              isDraggingTempo: E,
              onDragStart: this.props.onDragStart,
              setLock: E ? this.dummyFn : this.setLock,
              removeSelf: E ? this.dummyFn : this.removeSelf,
              setField: E ? this.dummyFn : this.setField,
              setOperator: E ? this.dummyFn : this.setOperator,
              setOperatorOption: E ? this.dummyFn : this.setOperatorOption,
              setValue: E ? this.dummyFn : this.setValue,
              setValueSrc: E ? this.dummyFn : this.setValueSrc,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              value: this.props.value || null,
              valueSrc: this.props.valueSrc || null,
              valueError: this.props.valueError || null,
              operatorOptions: this.props.operatorOptions,
              config: this.props.config,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              asyncListValues: this.props.asyncListValues,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            })]);
          }
        }]), N;
      }(c.Component), I.propTypes = {
        id: l.default.string.isRequired,
        groupId: l.default.string,
        config: l.default.object.isRequired,
        path: l.default.any.isRequired,
        //instanceOf(Immutable.List)
        operator: l.default.string,
        field: l.default.string,
        actions: l.default.object.isRequired,
        //{removeRule: Funciton, setField, setOperator, setOperatorOption, setValue, setValueSrc, ...}
        onDragStart: l.default.func,
        value: l.default.any,
        //depends on widget
        valueSrc: l.default.any,
        asyncListValues: l.default.array,
        valueError: l.default.any,
        operatorOptions: l.default.object,
        reordableNodesCnt: l.default.number,
        parentField: l.default.string,
        //from RuleGroup
        isLocked: l.default.bool,
        isTrueLocked: l.default.bool,
        //connected:
        dragging: l.default.object,
        //{id, x, y, w, h}
        isDraggingTempo: l.default.bool
      }, I;
    }, k = function(O) {
      var I = (0, p.connect)(function(D) {
        return {
          dragging: D.dragging
        };
      }, null, null, {
        context: d.default
      })($(O));
      return I.displayName = "ConnectedRuleContainer", I;
    };
    e.default = k;
  }(jR)), jR;
}
var FR = {}, Yoe;
function Nb() {
  return Yoe || (Yoe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(pa), r = t(Tk), i = t(yr), a = t($r), s = t(wr), c = t(kr()), l = t(ir()), d = f(ve), u = t(di), _ = ["isDraggingTempo", "isDraggingMe", "dragging"];
    function p($) {
      if (typeof WeakMap != "function")
        return null;
      var k = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap();
      return (p = function(I) {
        return I ? S : k;
      })($);
    }
    function f($, k) {
      if (!k && $ && $.__esModule)
        return $;
      if ($ === null || n($) !== "object" && typeof $ != "function")
        return { default: $ };
      var S = p(k);
      if (S && S.has($))
        return S.get($);
      var O = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var D in $)
        if (D !== "default" && Object.prototype.hasOwnProperty.call($, D)) {
          var M = I ? Object.getOwnPropertyDescriptor($, D) : null;
          M && (M.get || M.set) ? Object.defineProperty(O, D, M) : O[D] = $[D];
        }
      return O.default = $, S && S.set($, O), O;
    }
    function g($) {
      var k = h();
      return function() {
        var O = (0, l.default)($), I;
        if (k) {
          var D = (0, l.default)(this).constructor;
          I = Reflect.construct(O, arguments, D);
        } else
          I = O.apply(this, arguments);
        return (0, c.default)(this, I);
      };
    }
    function h() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var b = cm, v = function(k) {
      return function(S) {
        var O;
        return O = /* @__PURE__ */ function(I) {
          (0, s.default)(M, I);
          var D = g(M);
          function M(N) {
            var C;
            return (0, i.default)(this, M), C = D.call(this, N), C.handleDraggerMouseDown = function(P) {
              var x = C.props.id, w = C.wrapper.current;
              C.props.onDragStart && C.props.onDragStart(x, w, P);
            }, C.wrapper = /* @__PURE__ */ d.default.createRef(), C;
          }
          return (0, a.default)(M, [{
            key: "render",
            value: function() {
              var C = this.props, P = C.isDraggingTempo, x = C.isDraggingMe, w = C.dragging, E = (0, r.default)(C, _), T = E.isTrueLocked, z = {};
              x && P && (z = {
                top: w.y,
                left: w.x,
                width: w.w
              });
              var j = b(k, "group-or-rule", x && P ? "qb-draggable" : null, x && !P ? "qb-placeholder" : null, T ? "locked" : null);
              return /* @__PURE__ */ d.default.createElement("div", {
                className: j,
                style: z,
                ref: this.wrapper,
                "data-id": this.props.id
              }, /* @__PURE__ */ d.default.createElement(S, (0, o.default)({
                handleDraggerMouseDown: this.handleDraggerMouseDown,
                isDraggingMe: x,
                isDraggingTempo: P
              }, E)));
            }
          }]), M;
        }(d.PureComponent), O.propTypes = {
          isDraggingTempo: u.default.bool,
          isDraggingMe: u.default.bool,
          onDragStart: u.default.func,
          dragging: u.default.object,
          //{id, x, y, w, h}
          isLocked: u.default.bool,
          isTrueLocked: u.default.bool
        }, O;
      };
    };
    e.default = v;
  }(FR)), FR;
}
var VR = {}, BR = {}, UR, Zoe;
function o_d() {
  if (Zoe)
    return UR;
  Zoe = 1;
  var e = Dj, t = H0e(), n = Z0e(), o = t7();
  function r(i, a) {
    if (i == null)
      return {};
    var s = e(o(i), function(c) {
      return [c];
    });
    return a = t(a), n(i, s, function(c, l) {
      return a(c, l[0]);
    });
  }
  return UR = r, UR;
}
var Qoe;
function r_d() {
  return Qoe || (Qoe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = v(ve), u = t(di), _ = Br(), p = t(R_), f = t(o_d()), g = t(tz()), h = Na();
    function b(D) {
      if (typeof WeakMap != "function")
        return null;
      var M = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap();
      return (b = function(P) {
        return P ? N : M;
      })(D);
    }
    function v(D, M) {
      if (!M && D && D.__esModule)
        return D;
      if (D === null || n(D) !== "object" && typeof D != "function")
        return { default: D };
      var N = b(M);
      if (N && N.has(D))
        return N.get(D);
      var C = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var x in D)
        if (x !== "default" && Object.prototype.hasOwnProperty.call(D, x)) {
          var w = P ? Object.getOwnPropertyDescriptor(D, x) : null;
          w && (w.get || w.set) ? Object.defineProperty(C, x, w) : C[x] = D[x];
        }
      return C.default = D, N && N.set(D, C), C;
    }
    function $(D, M) {
      var N = Object.keys(D);
      if (Object.getOwnPropertySymbols) {
        var C = Object.getOwnPropertySymbols(D);
        M && (C = C.filter(function(P) {
          return Object.getOwnPropertyDescriptor(D, P).enumerable;
        })), N.push.apply(N, C);
      }
      return N;
    }
    function k(D) {
      for (var M = 1; M < arguments.length; M++) {
        var N = arguments[M] != null ? arguments[M] : {};
        M % 2 ? $(Object(N), !0).forEach(function(C) {
          (0, o.default)(D, C, N[C]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(N)) : $(Object(N)).forEach(function(C) {
          Object.defineProperty(D, C, Object.getOwnPropertyDescriptor(N, C));
        });
      }
      return D;
    }
    function S(D) {
      var M = O();
      return function() {
        var C = (0, l.default)(D), P;
        if (M) {
          var x = (0, l.default)(this).constructor;
          P = Reflect.construct(C, arguments, x);
        } else
          P = C.apply(this, arguments);
        return (0, c.default)(this, P);
      };
    }
    function O() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var I = /* @__PURE__ */ function(D) {
      (0, s.default)(N, D);
      var M = S(N);
      function N(C) {
        var P;
        return (0, r.default)(this, N), P = M.call(this, C), (0, h.useOnPropsChanged)((0, a.default)(P)), P.onPropsChanged(C), P;
      }
      return (0, i.default)(N, [{
        key: "onPropsChanged",
        value: function(P) {
          var x = this.props, w = ["config", "selectedField", "selectedOperator"], E = !this.meta || w.map(function(T) {
            return P[T] !== x[T];
          }).filter(function(T) {
            return T;
          }).length > 0;
          E && (this.meta = this.getMeta(P));
        }
      }, {
        key: "getMeta",
        value: function(P) {
          var x = P.config, w = P.selectedField, E = P.selectedOperator, T = (0, _.getFieldConfig)(x, w), z = T == null ? void 0 : T.operators, j = (0, g.default)((0, f.default)(x.operators, function(re, Z) {
            return (z == null ? void 0 : z.indexOf(Z)) !== -1;
          }), function(re, Z) {
            return (0, _.getOperatorConfig)(x, Z, w);
          }), q = this.buildOptions(x, j, z), V = !!E, F = V ? j[E] : null, L = F || {}, U = this.props.config.settings.operatorPlaceholder, W = E, H = V ? [W] : null, Q = H, X = L.label;
          return {
            placeholder: U,
            items: q,
            selectedKey: W,
            selectedKeys: H,
            selectedPath: Q,
            selectedLabel: X,
            selectedOpts: L,
            fieldConfig: T
          };
        }
      }, {
        key: "buildOptions",
        value: function(P, x, w) {
          return !x || !w ? null : (0, p.default)(x).sort(function(E, T) {
            return w.indexOf(E) - w.indexOf(T);
          }).map(function(E) {
            var T = x[E], z = T.label;
            return {
              key: E,
              path: E,
              label: z
            };
          });
        }
      }, {
        key: "render",
        value: function() {
          var P = this.props, x = P.config, w = P.customProps, E = P.setOperator, T = P.readonly, z = P.id, j = P.groupId, q = x.settings.renderOperator, V = k({
            id: z,
            groupId: j,
            config: x,
            customProps: w,
            readonly: T,
            setField: E
          }, this.meta);
          return V.items ? q(V) : null;
        }
      }]), N;
    }(d.PureComponent);
    e.default = I, I.propTypes = {
      id: u.default.string,
      groupId: u.default.string,
      config: u.default.object.isRequired,
      selectedField: u.default.string,
      selectedOperator: u.default.string,
      readonly: u.default.bool,
      //actions
      setOperator: u.default.func.isRequired
    };
  }(BR)), BR;
}
var Joe;
function n1e() {
  return Joe || (Joe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(yr), r = t($r), i = t(wr), a = t(kr()), s = t(ir()), c = _(ve), l = t(r_d()), d = wu();
    function u(h) {
      if (typeof WeakMap != "function")
        return null;
      var b = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (u = function(k) {
        return k ? v : b;
      })(h);
    }
    function _(h, b) {
      if (!b && h && h.__esModule)
        return h;
      if (h === null || n(h) !== "object" && typeof h != "function")
        return { default: h };
      var v = u(b);
      if (v && v.has(h))
        return v.get(h);
      var $ = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var S in h)
        if (S !== "default" && Object.prototype.hasOwnProperty.call(h, S)) {
          var O = k ? Object.getOwnPropertyDescriptor(h, S) : null;
          O && (O.get || O.set) ? Object.defineProperty($, S, O) : $[S] = h[S];
        }
      return $.default = h, v && v.set(h, $), $;
    }
    function p(h) {
      var b = f();
      return function() {
        var $ = (0, s.default)(h), k;
        if (b) {
          var S = (0, s.default)(this).constructor;
          k = Reflect.construct($, arguments, S);
        } else
          k = $.apply(this, arguments);
        return (0, a.default)(this, k);
      };
    }
    function f() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var g = /* @__PURE__ */ function(h) {
      (0, i.default)(v, h);
      var b = p(v);
      function v() {
        return (0, o.default)(this, v), b.apply(this, arguments);
      }
      return (0, r.default)(v, [{
        key: "render",
        value: function() {
          var k = this.props, S = k.config, O = k.selectedField, I = k.selectedOperator, D = k.setOperator, M = k.selectedFieldPartsLabels, N = k.showOperator, C = k.showOperatorLabel, P = k.selectedFieldWidgetConfig, x = k.readonly, w = k.id, E = k.groupId, T = N && /* @__PURE__ */ c.default.createElement(d.Col, {
            key: "operators-for-" + (M || []).join("_"),
            className: "rule--operator"
          }, S.settings.showLabels && /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, S.settings.operatorLabel), /* @__PURE__ */ c.default.createElement(l.default, {
            key: "operator",
            config: S,
            selectedField: O,
            selectedOperator: I,
            setOperator: D,
            readonly: x,
            id: w,
            groupId: E
          })), z = C && /* @__PURE__ */ c.default.createElement(d.Col, {
            key: "operators-for-" + (M || []).join("_"),
            className: "rule--operator"
          }, /* @__PURE__ */ c.default.createElement("div", {
            className: "rule--operator"
          }, S.settings.showLabels ? /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, " ") : null, /* @__PURE__ */ c.default.createElement("span", null, P.operatorInlineLabel)));
          return [T, z];
        }
      }]), v;
    }(c.PureComponent);
    e.default = g;
  }(VR)), VR;
}
var WR = {}, GR = {}, Xoe;
function i_d() {
  return Xoe || (Xoe = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = $(ve), u = t(di), _ = Br(), p = Hi(), f = Sr(), g = Na(), h = t(xk()), b = t(R_);
    function v(M) {
      if (typeof WeakMap != "function")
        return null;
      var N = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
      return (v = function(x) {
        return x ? C : N;
      })(M);
    }
    function $(M, N) {
      if (!N && M && M.__esModule)
        return M;
      if (M === null || n(M) !== "object" && typeof M != "function")
        return { default: M };
      var C = v(N);
      if (C && C.has(M))
        return C.get(M);
      var P = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var w in M)
        if (w !== "default" && Object.prototype.hasOwnProperty.call(M, w)) {
          var E = x ? Object.getOwnPropertyDescriptor(M, w) : null;
          E && (E.get || E.set) ? Object.defineProperty(P, w, E) : P[w] = M[w];
        }
      return P.default = M, C && C.set(M, P), P;
    }
    function k(M, N) {
      var C = Object.keys(M);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(M);
        N && (P = P.filter(function(x) {
          return Object.getOwnPropertyDescriptor(M, x).enumerable;
        })), C.push.apply(C, P);
      }
      return C;
    }
    function S(M) {
      for (var N = 1; N < arguments.length; N++) {
        var C = arguments[N] != null ? arguments[N] : {};
        N % 2 ? k(Object(C), !0).forEach(function(P) {
          (0, o.default)(M, P, C[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(C)) : k(Object(C)).forEach(function(P) {
          Object.defineProperty(M, P, Object.getOwnPropertyDescriptor(C, P));
        });
      }
      return M;
    }
    function O(M) {
      var N = I();
      return function() {
        var P = (0, l.default)(M), x;
        if (N) {
          var w = (0, l.default)(this).constructor;
          x = Reflect.construct(P, arguments, w);
        } else
          x = P.apply(this, arguments);
        return (0, c.default)(this, x);
      };
    }
    function I() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var D = /* @__PURE__ */ function(M) {
      (0, s.default)(C, M);
      var N = O(C);
      function C(P) {
        var x;
        return (0, r.default)(this, C), x = N.call(this, P), (0, g.useOnPropsChanged)((0, a.default)(x)), x.onPropsChanged(P), x;
      }
      return (0, i.default)(C, [{
        key: "onPropsChanged",
        value: function(x) {
          var w = this.props, E = ["selectedField", "config", "parentField"], T = !this.meta || E.map(function(z) {
            return x[z] !== w[z];
          }).filter(function(z) {
            return z;
          }).length > 0;
          T && (this.meta = this.getMeta(x));
        }
      }, {
        key: "getMeta",
        value: function(x) {
          var w = x.selectedField, E = x.config, T = x.parentField, z = w, j = E.settings, q = j.maxLabelsLength, V = j.fieldSeparatorDisplay, F = j.fieldPlaceholder, L = j.fieldSeparator, U = !!w, W = U ? null : (0, f.truncateString)(F, q), H = U ? (0, _.getFieldConfig)(E, z) : null, Q = H || {}, X = (0, p.getFieldPath)(z, E), re = (0, p.getFieldPath)(z, E, !0), Z = this.getFieldLabel(H, z, E), ee = (0, p.getFieldPathLabels)(z, E), J = ee ? ee.join(V) : null;
          (J == Z || T) && (J = null);
          var oe = Q.label2, ce = typeof T == "string" ? T.split(L) : T, de = T ? (0, _.getFieldConfig)(E, T) : null, te = T ? de && de.subfields : E.fields, ue = this.buildOptions(ce, E, te, ce);
          return {
            placeholder: W,
            items: ue,
            parentField: T,
            selectedKey: z,
            selectedKeys: X,
            selectedPath: re,
            selectedLabel: Z,
            selectedOpts: Q,
            selectedAltLabel: oe,
            selectedFullLabel: J
          };
        }
      }, {
        key: "getFieldLabel",
        value: function(x, w, E) {
          if (!w)
            return null;
          var T = E.settings.fieldSeparator, z = E.settings.maxLabelsLength, j = Array.isArray(w) ? w : w.split(T), q = x && x.label || (0, h.default)(j);
          return q = (0, f.truncateString)(q, z), q;
        }
      }, {
        key: "buildOptions",
        value: function(x, w, E) {
          var T = this, z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, j = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
          if (!E)
            return null;
          var q = w.settings, V = q.fieldSeparator, F = q.fieldSeparatorDisplay, L = z ? z.join(V) + V : "";
          return (0, b.default)(E).map(function(U) {
            var W = E[U], H = T.getFieldLabel(W, U, w), Q = (0, p.getFieldPathLabels)(L + U, w), X = Q.join(F);
            (X == H || x) && (X = null);
            var re = W.label2, Z = W.tooltip, ee = (z || []).concat(U), J = W.disabled;
            if (!W.hideForSelect)
              return W.type == "!struct" ? {
                disabled: J,
                key: U,
                path: L + U,
                label: H,
                fullLabel: X,
                altLabel: re,
                tooltip: Z,
                items: T.buildOptions(x, w, W.subfields, ee, H)
              } : {
                disabled: J,
                key: U,
                path: L + U,
                label: H,
                fullLabel: X,
                altLabel: re,
                tooltip: Z,
                grouplabel: j
              };
          }).filter(function(U) {
            return !!U;
          });
        }
      }, {
        key: "render",
        value: function() {
          var x = this.props, w = x.config, E = x.customProps, T = x.setField, z = x.readonly, j = x.id, q = x.groupId, V = w.settings.renderField, F = S({
            id: j,
            groupId: q,
            config: w,
            customProps: E,
            readonly: z,
            setField: T
          }, this.meta);
          return V(F);
        }
      }]), C;
    }(d.PureComponent);
    e.default = D, D.propTypes = {
      id: u.default.string,
      groupId: u.default.string,
      config: u.default.object.isRequired,
      selectedField: u.default.string,
      parentField: u.default.string,
      customProps: u.default.object,
      readonly: u.default.bool,
      //actions
      setField: u.default.func.isRequired
    };
  }(GR)), GR;
}
var ere;
function C7() {
  return ere || (ere = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(yr), r = t($r), i = t(wr), a = t(kr()), s = t(ir()), c = _(ve), l = t(i_d()), d = wu();
    function u(h) {
      if (typeof WeakMap != "function")
        return null;
      var b = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
      return (u = function(k) {
        return k ? v : b;
      })(h);
    }
    function _(h, b) {
      if (!b && h && h.__esModule)
        return h;
      if (h === null || n(h) !== "object" && typeof h != "function")
        return { default: h };
      var v = u(b);
      if (v && v.has(h))
        return v.get(h);
      var $ = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var S in h)
        if (S !== "default" && Object.prototype.hasOwnProperty.call(h, S)) {
          var O = k ? Object.getOwnPropertyDescriptor(h, S) : null;
          O && (O.get || O.set) ? Object.defineProperty($, S, O) : $[S] = h[S];
        }
      return $.default = h, v && v.set(h, $), $;
    }
    function p(h) {
      var b = f();
      return function() {
        var $ = (0, s.default)(h), k;
        if (b) {
          var S = (0, s.default)(this).constructor;
          k = Reflect.construct($, arguments, S);
        } else
          k = $.apply(this, arguments);
        return (0, a.default)(this, k);
      };
    }
    function f() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var g = /* @__PURE__ */ function(h) {
      (0, i.default)(v, h);
      var b = p(v);
      function v() {
        return (0, o.default)(this, v), b.apply(this, arguments);
      }
      return (0, r.default)(v, [{
        key: "render",
        value: function() {
          var k = this.props, S = k.config, O = k.selectedField, I = k.setField, D = k.parentField, M = k.classname, N = k.readonly, C = k.id, P = k.groupId;
          return /* @__PURE__ */ c.default.createElement(d.Col, {
            className: M
          }, S.settings.showLabels && /* @__PURE__ */ c.default.createElement("label", {
            className: "rule--label"
          }, S.settings.fieldLabel), /* @__PURE__ */ c.default.createElement(l.default, {
            config: S,
            selectedField: O,
            parentField: D,
            setField: I,
            customProps: S.settings.customFieldSelectProps,
            readonly: N,
            id: C,
            groupId: P
          }));
        }
      }]), v;
    }(c.PureComponent);
    e.default = g;
  }(WR)), WR;
}
var HR = {}, tre;
function a_d() {
  return tre || (tre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(Tk), r = t(yr), i = t($r), a = t(wr), s = t(kr()), c = t(ir()), l = f(ve), d = t(di), u = Br(), _ = ["factory"];
    function p(v) {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap();
      return (p = function(O) {
        return O ? k : $;
      })(v);
    }
    function f(v, $) {
      if (!$ && v && v.__esModule)
        return v;
      if (v === null || n(v) !== "object" && typeof v != "function")
        return { default: v };
      var k = p($);
      if (k && k.has(v))
        return k.get(v);
      var S = {}, O = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var I in v)
        if (I !== "default" && Object.prototype.hasOwnProperty.call(v, I)) {
          var D = O ? Object.getOwnPropertyDescriptor(v, I) : null;
          D && (D.get || D.set) ? Object.defineProperty(S, I, D) : S[I] = v[I];
        }
      return S.default = v, k && k.set(v, S), S;
    }
    function g(v) {
      var $ = h();
      return function() {
        var S = (0, c.default)(v), O;
        if ($) {
          var I = (0, c.default)(this).constructor;
          O = Reflect.construct(S, arguments, I);
        } else
          O = S.apply(this, arguments);
        return (0, s.default)(this, O);
      };
    }
    function h() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var b = /* @__PURE__ */ function(v) {
      (0, a.default)(k, v);
      var $ = g(k);
      function k() {
        return (0, r.default)(this, k), $.apply(this, arguments);
      }
      return (0, i.default)(k, [{
        key: "render",
        value: function() {
          if (!this.props.selectedOperator)
            return null;
          var O = (0, u.getOperatorConfig)(this.props.config, this.props.selectedOperator, this.props.selectedField);
          if (typeof O.options > "u")
            return null;
          var I = O.options, D = I.factory, M = (0, o.default)(I, _), N = Object.assign({}, M, {
            config: this.props.config,
            field: this.props.selectedField,
            operator: this.props.selectedOperator,
            options: this.props.operatorOptions,
            setOption: this.props.setOperatorOption,
            readonly: this.props.readonly
          }), C = D(N), P = this.props.selectedOperator;
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "rule--operator rule--operator--".concat(P.toUpperCase())
          }, C);
        }
      }]), k;
    }(l.PureComponent);
    e.default = b, b.propTypes = {
      config: d.default.object.isRequired,
      operatorOptions: d.default.any.isRequired,
      //instanceOf(Immutable.Map)
      selectedField: d.default.string.isRequired,
      selectedOperator: d.default.string.isRequired,
      readonly: d.default.bool,
      //actions
      setOperatorOption: d.default.func.isRequired
    };
  }(HR)), HR;
}
var nre;
function s_d() {
  return nre || (nre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(rr), r = t(yr), i = t($r), a = t(ua()), s = t(wr), c = t(kr()), l = t(ir()), d = N(ve), u = t(di), _ = t(n_d()), p = t(Nb()), f = t(n1e()), g = t(C7()), h = t(oz()), b = t(a_d()), v = Br(), $ = Hi(), k = Na(), S = wu(), O, I, D;
    function M(j) {
      if (typeof WeakMap != "function")
        return null;
      var q = /* @__PURE__ */ new WeakMap(), V = /* @__PURE__ */ new WeakMap();
      return (M = function(L) {
        return L ? V : q;
      })(j);
    }
    function N(j, q) {
      if (!q && j && j.__esModule)
        return j;
      if (j === null || n(j) !== "object" && typeof j != "function")
        return { default: j };
      var V = M(q);
      if (V && V.has(j))
        return V.get(j);
      var F = {}, L = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var U in j)
        if (U !== "default" && Object.prototype.hasOwnProperty.call(j, U)) {
          var W = L ? Object.getOwnPropertyDescriptor(j, U) : null;
          W && (W.get || W.set) ? Object.defineProperty(F, U, W) : F[U] = j[U];
        }
      return F.default = j, V && V.set(j, F), F;
    }
    function C(j, q) {
      var V = Object.keys(j);
      if (Object.getOwnPropertySymbols) {
        var F = Object.getOwnPropertySymbols(j);
        q && (F = F.filter(function(L) {
          return Object.getOwnPropertyDescriptor(j, L).enumerable;
        })), V.push.apply(V, F);
      }
      return V;
    }
    function P(j) {
      for (var q = 1; q < arguments.length; q++) {
        var V = arguments[q] != null ? arguments[q] : {};
        q % 2 ? C(Object(V), !0).forEach(function(F) {
          (0, o.default)(j, F, V[F]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(j, Object.getOwnPropertyDescriptors(V)) : C(Object(V)).forEach(function(F) {
          Object.defineProperty(j, F, Object.getOwnPropertyDescriptor(V, F));
        });
      }
      return j;
    }
    function x(j) {
      var q = w();
      return function() {
        var F = (0, l.default)(j), L;
        if (q) {
          var U = (0, l.default)(this).constructor;
          L = Reflect.construct(F, arguments, U);
        } else
          L = F.apply(this, arguments);
        return (0, c.default)(this, L);
      };
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var E = cm, T = (O = (0, p.default)("rule"), (0, _.default)(I = O(I = (0, S.ConfirmFn)(I = (D = /* @__PURE__ */ function(j) {
      (0, s.default)(V, j);
      var q = x(V);
      function V(F) {
        var L;
        return (0, r.default)(this, V), L = q.call(this, F), (0, k.useOnPropsChanged)((0, a.default)(L)), L.removeSelf = L.removeSelf.bind((0, a.default)(L)), L.setLock = L.setLock.bind((0, a.default)(L)), L.onPropsChanged(F), L;
      }
      return (0, i.default)(V, [{
        key: "onPropsChanged",
        value: function(L) {
          var U = this.props, W = ["selectedField", "selectedOperator", "config", "reordableNodesCnt", "isLocked"], H = !this.meta || W.map(function(Q) {
            return L[Q] !== U[Q];
          }).filter(function(Q) {
            return Q;
          }).length > 0;
          H && (this.meta = this.getMeta(L));
        }
      }, {
        key: "getMeta",
        value: function(L) {
          var U = L.selectedField, W = L.selectedOperator, H = L.config, Q = L.reordableNodesCnt, X = L.isLocked, re = (0, $.getFieldPathLabels)(U, H), Z = (0, v.getFieldConfig)(H, U), ee = Z && Z.type == "!struct", J = U && W && !ee, oe = (0, v.getOperatorConfig)(H, W, U), ce = oe && oe.options != null, de = (0, v.getFieldWidgetConfig)(H, U, W) || {}, te = de.hideOperator, ue = H.settings.canReorder && Q > 1 && !X, le = U && !te, se = U && te && de.operatorInlineLabel, me = J, pe = J && ce;
          return {
            selectedFieldPartsLabels: re,
            selectedFieldWidgetConfig: de,
            showDragIcon: ue,
            showOperator: le,
            showOperatorLabel: se,
            showWidget: me,
            showOperatorOptions: pe
          };
        }
      }, {
        key: "setLock",
        value: function(L) {
          this.props.setLock(L);
        }
      }, {
        key: "removeSelf",
        value: function() {
          var L = this, U = this.props.confirmFn, W = this.props.config.settings, H = W.renderConfirm, Q = W.removeRuleConfirmOptions, X = function() {
            L.props.removeSelf();
          };
          Q && !this.isEmptyCurrentRule() ? H(P(P({}, Q), {}, {
            onOk: X,
            onCancel: null,
            confirmFn: U
          })) : X();
        }
      }, {
        key: "isEmptyCurrentRule",
        value: function() {
          return !(this.props.selectedField !== null && this.props.selectedOperator !== null && this.props.value.filter(function(L) {
            return L !== void 0;
          }).size > 0);
        }
      }, {
        key: "renderField",
        value: function() {
          var L = this.props, U = L.config, W = L.isLocked, H = U.settings.immutableFieldsMode;
          return /* @__PURE__ */ d.default.createElement(g.default, {
            key: "field",
            classname: "rule--field",
            config: U,
            selectedField: this.props.selectedField,
            setField: H ? S.dummyFn : this.props.setField,
            parentField: this.props.parentField,
            readonly: H || W,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderOperator",
        value: function() {
          var L = this.props, U = L.config, W = L.isLocked, H = this.meta, Q = H.selectedFieldPartsLabels, X = H.selectedFieldWidgetConfig, re = H.showOperator, Z = H.showOperatorLabel, ee = U.settings.immutableOpsMode;
          return /* @__PURE__ */ d.default.createElement(f.default, {
            key: "operator",
            config: U,
            selectedField: this.props.selectedField,
            selectedOperator: this.props.selectedOperator,
            setOperator: ee ? S.dummyFn : this.props.setOperator,
            selectedFieldPartsLabels: Q,
            showOperator: re,
            showOperatorLabel: Z,
            selectedFieldWidgetConfig: X,
            readonly: ee || W,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderWidget",
        value: function() {
          var L = this.props, U = L.config, W = L.valueError, H = L.isLocked, Q = this.meta.showWidget, X = U.settings.immutableValuesMode;
          if (!Q)
            return null;
          var re = /* @__PURE__ */ d.default.createElement(h.default, {
            key: "values",
            field: this.props.selectedField,
            parentField: this.props.parentField,
            operator: this.props.selectedOperator,
            value: this.props.value,
            valueSrc: this.props.valueSrc,
            asyncListValues: this.props.asyncListValues,
            valueError: W,
            config: U,
            setValue: X ? S.dummyFn : this.props.setValue,
            setValueSrc: X ? S.dummyFn : this.props.setValueSrc,
            readonly: X || H,
            id: this.props.id,
            groupId: this.props.groupId
          });
          return /* @__PURE__ */ d.default.createElement(S.Col, {
            key: "widget-for-" + this.props.selectedOperator,
            className: "rule--value"
          }, re);
        }
      }, {
        key: "renderOperatorOptions",
        value: function() {
          var L = this.props.config, U = this.meta.showOperatorOptions, W = L.settings, H = W.immutableOpsMode, Q = W.immutableValuesMode;
          if (!U)
            return null;
          var X = /* @__PURE__ */ d.default.createElement(b.default, {
            key: "operatorOptions",
            selectedField: this.props.selectedField,
            selectedOperator: this.props.selectedOperator,
            operatorOptions: this.props.operatorOptions,
            setOperatorOption: H ? S.dummyFn : this.props.setOperatorOption,
            config: L,
            readonly: Q
          });
          return /* @__PURE__ */ d.default.createElement(S.Col, {
            key: "op-options-for-" + this.props.selectedOperator,
            className: "rule--operator-options"
          }, X);
        }
      }, {
        key: "renderBeforeWidget",
        value: function() {
          var L = this.props.config, U = L.settings.renderBeforeWidget;
          return U && /* @__PURE__ */ d.default.createElement(S.Col, {
            key: "before-widget-for-" + this.props.selectedOperator,
            className: "rule--before-widget"
          }, typeof U == "function" ? U(this.props) : U);
        }
      }, {
        key: "renderAfterWidget",
        value: function() {
          var L = this.props.config, U = L.settings.renderAfterWidget;
          return U && /* @__PURE__ */ d.default.createElement(S.Col, {
            key: "after-widget-for-" + this.props.selectedOperator,
            className: "rule--after-widget"
          }, typeof U == "function" ? U(this.props) : U);
        }
      }, {
        key: "renderError",
        value: function() {
          var L = this.props, U = L.config, W = L.valueError, H = U.settings, Q = H.renderRuleError, X = H.showErrorMessage, re = W && W.toArray().filter(function(Z) {
            return !!Z;
          }).shift() || null;
          return X && re && /* @__PURE__ */ d.default.createElement("div", {
            className: "rule--error"
          }, Q ? Q({
            error: re
          }) : re);
        }
      }, {
        key: "renderDrag",
        value: function() {
          var L = this.meta.showDragIcon;
          return L && /* @__PURE__ */ d.default.createElement("span", {
            key: "rule-drag-icon",
            className: "qb-drag-handler rule--drag-handler",
            onMouseDown: this.props.handleDraggerMouseDown
          }, /* @__PURE__ */ d.default.createElement(S.DragIcon, null), " ");
        }
      }, {
        key: "renderDel",
        value: function() {
          var L = this.props, U = L.config, W = L.isLocked, H = U.settings, Q = H.deleteLabel, X = H.immutableGroupsMode, re = H.renderButton, Z = H.canDeleteLocked;
          return !X && (!W || W && Z) && /* @__PURE__ */ d.default.createElement(re, {
            type: "delRule",
            onClick: this.removeSelf,
            label: Q,
            config: U
          });
        }
      }, {
        key: "renderLock",
        value: function() {
          var L = this.props, U = L.config, W = L.isLocked, H = L.isTrueLocked, Q = L.id, X = U.settings, re = X.lockLabel, Z = X.lockedLabel, ee = X.showLock, J = X.renderSwitch;
          return ee && !(W && !H) && /* @__PURE__ */ d.default.createElement(J, {
            type: "lock",
            id: Q,
            value: W,
            setValue: this.setLock,
            label: re,
            checkedLabel: Z,
            hideLabel: !0,
            config: U
          });
        }
      }, {
        key: "render",
        value: function() {
          var L = this.meta, U = L.showOperatorOptions, W = L.selectedFieldWidgetConfig, H = this.props, Q = H.valueSrc, X = H.value, re = H.config, Z = Q.first() == "value" && !U && X.size == 1 && W.fullWidth, ee = re.settings.renderButtonGroup, J = [this.renderField(), this.renderOperator(), this.renderBeforeWidget(), this.renderWidget(), this.renderAfterWidget(), this.renderOperatorOptions()], oe = /* @__PURE__ */ d.default.createElement("div", {
            key: "rule-body",
            className: E("rule--body", Z && "can--shrink--value")
          }, J), ce = this.renderError(), de = this.renderDrag(), te = this.renderLock(), ue = this.renderDel();
          return /* @__PURE__ */ d.default.createElement(d.default.Fragment, null, de, /* @__PURE__ */ d.default.createElement("div", {
            className: "rule--body--wrapper"
          }, oe, ce), /* @__PURE__ */ d.default.createElement("div", {
            className: "rule--header"
          }, /* @__PURE__ */ d.default.createElement(ee, {
            config: re
          }, te, ue)));
        }
      }]), V;
    }(d.PureComponent), D.propTypes = {
      id: u.default.string.isRequired,
      groupId: u.default.string,
      selectedField: u.default.string,
      selectedOperator: u.default.string,
      operatorOptions: u.default.object,
      config: u.default.object.isRequired,
      value: u.default.any,
      //depends on widget
      valueSrc: u.default.any,
      asyncListValues: u.default.array,
      isDraggingMe: u.default.bool,
      isDraggingTempo: u.default.bool,
      parentField: u.default.string,
      //from RuleGroup
      valueError: u.default.any,
      isLocked: u.default.bool,
      isTrueLocked: u.default.bool,
      //path: PropTypes.instanceOf(Immutable.List),
      //actions
      handleDraggerMouseDown: u.default.func,
      setField: u.default.func,
      setOperator: u.default.func,
      setOperatorOption: u.default.func,
      setLock: u.default.func,
      removeSelf: u.default.func,
      setValue: u.default.func,
      setValueSrc: u.default.func,
      reordableNodesCnt: u.default.number
    }, D)) || I) || I) || I), z = T;
    e.default = z;
  }(qR)), qR;
}
var KR = {}, YR, ore;
function c_d() {
  if (ore)
    return YR;
  ore = 1;
  function e(t, n, o) {
    return t === t && (o !== void 0 && (t = t <= o ? t : o), n !== void 0 && (t = t >= n ? t : n)), t;
  }
  return YR = e, YR;
}
var ZR, rre;
function l_d() {
  if (rre)
    return ZR;
  rre = 1;
  var e = K0e();
  function t(n) {
    var o = e(n), r = o % 1;
    return o === o ? r ? o - r : o : 0;
  }
  return ZR = t, ZR;
}
var QR, ire;
function d_d() {
  if (ire)
    return QR;
  ire = 1;
  var e = c_d(), t = Dbe, n = l_d(), o = Mbe;
  function r(i, a, s) {
    return i = o(i), s = s == null ? 0 : e(n(s), 0, i.length), a = t(a), i.slice(s, s + a.length) == a;
  }
  return QR = r, QR;
}
var JR = {}, are;
function Fk() {
  return are || (are = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(yr), r = t($r), i = t(ua()), a = t(wr), s = t(kr()), c = t(ir()), l = b(ve), d = t(di), u = t(tz()), _ = t(gz()), p = Na(), f = bz, g = Ns();
    function h(O) {
      if (typeof WeakMap != "function")
        return null;
      var I = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
      return (h = function(N) {
        return N ? D : I;
      })(O);
    }
    function b(O, I) {
      if (!I && O && O.__esModule)
        return O;
      if (O === null || n(O) !== "object" && typeof O != "function")
        return { default: O };
      var D = h(I);
      if (D && D.has(O))
        return D.get(O);
      var M = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var C in O)
        if (C !== "default" && Object.prototype.hasOwnProperty.call(O, C)) {
          var P = N ? Object.getOwnPropertyDescriptor(O, C) : null;
          P && (P.get || P.set) ? Object.defineProperty(M, C, P) : M[C] = O[C];
        }
      return M.default = O, D && D.set(O, M), M;
    }
    function v(O) {
      var I = $();
      return function() {
        var M = (0, c.default)(O), N;
        if (I) {
          var C = (0, c.default)(this).constructor;
          N = Reflect.construct(M, arguments, C);
        } else
          N = M.apply(this, arguments);
        return (0, s.default)(this, N);
      };
    }
    function $() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var k = function(I) {
      var D;
      return D = /* @__PURE__ */ function(M) {
        (0, a.default)(C, M);
        var N = v(C);
        function C(P) {
          var x;
          return (0, o.default)(this, C), x = N.call(this, P), x._selectedConjunction = function(w) {
            return w = w || x.props, w.conjunction || (0, g.defaultGroupConjunction)(w.config, w.field);
          }, x.setConjunction = function() {
            var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            x.props.actions.setConjunction(x.props.path, w);
          }, x.setNot = function() {
            var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            x.props.actions.setNot(x.props.path, w);
          }, x.setLock = function() {
            var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            x.props.actions.setLock(x.props.path, w);
          }, x.dummyFn = function() {
          }, x.removeSelf = function() {
            x.props.actions.removeGroup(x.props.path);
          }, x.addGroup = function() {
            x.props.actions.addGroup(x.props.path);
          }, x.addCaseGroup = function() {
            x.props.actions.addCaseGroup(x.props.path);
          }, x.addDefaultCaseGroup = function() {
            x.props.actions.addDefaultCaseGroup(x.props.path);
          }, x.addRule = function() {
            x.props.actions.addRule(x.props.path);
          }, x.setField = function(w) {
            x.props.actions.setField(x.props.path, w);
          }, x.setOperator = function(w) {
            x.props.actions.setOperator(x.props.path, w);
          }, x.setValue = function(w, E, T) {
            x.props.actions.setValue(x.props.path, w, E, T);
          }, (0, p.useOnPropsChanged)((0, i.default)(x)), x.selectedConjunction = x._selectedConjunction(P), x.conjunctionOptions = x._getConjunctionOptions(P), x.dummyFn.isDummyFn = !0, x;
        }
        return (0, r.default)(C, [{
          key: "shouldComponentUpdate",
          value: function(x, w) {
            var E = this.props, T = this.state, z = (0, p.pureShouldComponentUpdate)(this)(x, w);
            if (z && T == w && E != x) {
              var j = x.dragging.id || E.dragging.id, q = j == x.id, V = [];
              for (var F in x) {
                var L = x[F] != E[F];
                F == "dragging" && !q && (L = !1), L && V.push(F);
              }
              V.length || (z = !1);
            }
            return z;
          }
        }, {
          key: "onPropsChanged",
          value: function(x) {
            var w = x.config;
            x.id;
            var E = x.conjunction, T = this.props.config, z = this.props.conjunction;
            (T != w || z != E) && (this.selectedConjunction = this._selectedConjunction(x), this.conjunctionOptions = this._getConjunctionOptions(x));
          }
        }, {
          key: "_getConjunctionOptions",
          value: function(x) {
            var w = this;
            return (0, u.default)(x.config.conjunctions, function(E, T) {
              return {
                id: "conjunction-".concat(x.id, "-").concat(T),
                name: "conjunction[".concat(x.id, "]"),
                key: T,
                label: E.label,
                checked: T === w._selectedConjunction(x)
              };
            });
          }
        }, {
          key: "render",
          value: function() {
            var x = this.props.dragging.id == this.props.id, w = this.props.path.size, E = this.props.config.settings.maxNesting, T = !x && this.props.isDraggingTempo, z = typeof E > "u" || w < E, j = w == 1;
            return /* @__PURE__ */ l.default.createElement("div", {
              className: "group-or-rule-container group-container",
              "data-id": this.props.id
            }, [x ? /* @__PURE__ */ l.default.createElement(I, {
              key: "dragging",
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: !0,
              isDraggingTempo: !0,
              dragging: this.props.dragging,
              isRoot: j,
              allowFurtherNesting: z,
              conjunctionOptions: this.conjunctionOptions,
              not: this.props.not,
              selectedConjunction: this.selectedConjunction,
              setConjunction: this.dummyFn,
              setNot: this.dummyFn,
              setLock: this.dummyFn,
              removeSelf: this.dummyFn,
              addGroup: this.dummyFn,
              addCaseGroup: this.dummyFn,
              addDefaultCaseGroup: this.dummyFn,
              addRule: this.dummyFn,
              setField: this.dummyFn,
              setOperator: this.dummyFn,
              setValue: this.dummyFn,
              value: this.props.value || null,
              config: this.props.config,
              children1: this.props.children1,
              actions: this.props.actions,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            }) : null, /* @__PURE__ */ l.default.createElement(I, {
              key: this.props.id,
              id: this.props.id,
              groupId: this.props.groupId,
              isDraggingMe: x,
              isDraggingTempo: T,
              onDragStart: this.props.onDragStart,
              isRoot: j,
              allowFurtherNesting: z,
              conjunctionOptions: this.conjunctionOptions,
              not: this.props.not,
              selectedConjunction: this.selectedConjunction,
              setConjunction: T ? this.dummyFn : this.setConjunction,
              setNot: T ? this.dummyFn : this.setNot,
              setLock: T ? this.dummyFn : this.setLock,
              removeSelf: T ? this.dummyFn : this.removeSelf,
              addGroup: T ? this.dummyFn : this.addGroup,
              addCaseGroup: T ? this.dummyFn : this.addCaseGroup,
              addDefaultCaseGroup: T ? this.dummyFn : this.addDefaultCaseGroup,
              addRule: T ? this.dummyFn : this.addRule,
              setField: T ? this.dummyFn : this.setField,
              setOperator: T ? this.dummyFn : this.setOperator,
              setValue: T ? this.dummyFn : this.setValue,
              value: this.props.value || null,
              config: this.props.config,
              children1: this.props.children1,
              actions: this.props.actions,
              reordableNodesCnt: this.props.reordableNodesCnt,
              totalRulesCnt: this.props.totalRulesCnt,
              selectedField: this.props.field || null,
              parentField: this.props.parentField || null,
              selectedOperator: this.props.operator || null,
              isLocked: this.props.isLocked,
              isTrueLocked: this.props.isTrueLocked,
              parentReordableNodesCnt: this.props.parentReordableNodesCnt
            })]);
          }
        }]), C;
      }(l.Component), D.propTypes = {
        //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
        config: d.default.object.isRequired,
        actions: d.default.object.isRequired,
        //{setConjunction: Funciton, removeGroup, addGroup, addRule, ...}
        path: d.default.any.isRequired,
        //instanceOf(Immutable.List)
        id: d.default.string.isRequired,
        groupId: d.default.string,
        not: d.default.bool,
        conjunction: d.default.string,
        children1: d.default.any,
        //instanceOf(Immutable.OrderedMap)
        onDragStart: d.default.func,
        reordableNodesCnt: d.default.number,
        field: d.default.string,
        // for RuleGroup
        parentField: d.default.string,
        //from RuleGroup
        isLocked: d.default.bool,
        isTrueLocked: d.default.bool,
        //connected:
        dragging: d.default.object,
        //{id, x, y, w, h}
        isDraggingTempo: d.default.bool
      }, D;
    }, S = function(I) {
      var D = (0, f.connect)(function(M) {
        return {
          dragging: M.dragging
        };
      }, null, null, {
        context: _.default
      })(k(I));
      return D.displayName = "ConnectedGroupContainer", D;
    };
    e.default = S;
  }(JR)), JR;
}
var t$ = {}, sre;
function o1e() {
  if (sre)
    return t$;
  sre = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(t$, "__esModule", {
    value: !0
  }), t$.GroupActions = void 0;
  var n = e(yr), o = e($r), r = e(wr), i = e(kr()), a = e(ir()), s = l(ve);
  function c(g) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (c = function($) {
      return $ ? b : h;
    })(g);
  }
  function l(g, h) {
    if (!h && g && g.__esModule)
      return g;
    if (g === null || t(g) !== "object" && typeof g != "function")
      return { default: g };
    var b = c(h);
    if (b && b.has(g))
      return b.get(g);
    var v = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var k in g)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(g, k)) {
        var S = $ ? Object.getOwnPropertyDescriptor(g, k) : null;
        S && (S.get || S.set) ? Object.defineProperty(v, k, S) : v[k] = g[k];
      }
    return v.default = g, b && b.set(g, v), v;
  }
  function d(g) {
    var h = u();
    return function() {
      var v = (0, a.default)(g), $;
      if (h) {
        var k = (0, a.default)(this).constructor;
        $ = Reflect.construct(v, arguments, k);
      } else
        $ = v.apply(this, arguments);
      return (0, i.default)(this, $);
    };
  }
  function u() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = {
    topLeft: "group--actions--tl",
    topCenter: "group--actions--tc",
    topRight: "group--actions--tr",
    bottomLeft: "group--actions--bl",
    bottomCenter: "group--actions--bc",
    bottomRight: "group--actions--br"
  }, p = "topRight", f = /* @__PURE__ */ function(g) {
    (0, r.default)(b, g);
    var h = d(b);
    function b() {
      return (0, n.default)(this, b), h.apply(this, arguments);
    }
    return (0, o.default)(b, [{
      key: "render",
      value: function() {
        var $ = this.props, k = $.config, S = $.addRule, O = $.addGroup, I = $.removeSelf, D = $.setLock, M = $.isLocked, N = $.isTrueLocked, C = $.id, P = $.canAddGroup, x = $.canAddRule, w = $.canDeleteGroup, E = k.settings, T = E.immutableGroupsMode, z = E.addRuleLabel, j = E.addGroupLabel, q = E.delGroupLabel, V = E.groupActionsPosition, F = E.renderButton, L = E.renderSwitch, U = E.renderButtonGroup, W = E.lockLabel, H = E.lockedLabel, Q = E.showLock, X = E.canDeleteLocked, re = _[V || p], Z = Q && !(M && !N) && /* @__PURE__ */ s.default.createElement(L, {
          type: "lock",
          id: C,
          value: M,
          setValue: D,
          label: W,
          checkedLabel: H,
          config: k
        }), ee = !T && x && !M && /* @__PURE__ */ s.default.createElement(F, {
          type: "addRule",
          onClick: S,
          label: z,
          readonly: M,
          config: k
        }), J = !T && P && !M && /* @__PURE__ */ s.default.createElement(F, {
          type: "addGroup",
          onClick: O,
          label: j,
          readonly: M,
          config: k
        }), oe = !T && w && (!M || M && X) && /* @__PURE__ */ s.default.createElement(F, {
          type: "delGroup",
          onClick: I,
          label: q,
          config: k
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions ".concat(re)
        }, /* @__PURE__ */ s.default.createElement(U, {
          config: k
        }, Z, ee, J, oe));
      }
    }]), b;
  }(s.PureComponent);
  return t$.GroupActions = f, t$;
}
var cre;
function Vk() {
  return cre || (cre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.BasicGroup = void 0;
    var o = t(pa), r = t(rr), i = t(yr), a = t($r), s = t(ua()), c = t(wr), l = t(kr()), d = t(ir()), u = k(ve), _ = t(di), p = t(d_d()), f = t(Fk()), g = t(Nb()), h = r1e(), b = o1e(), v = wu();
    function $(x) {
      if (typeof WeakMap != "function")
        return null;
      var w = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
      return ($ = function(z) {
        return z ? E : w;
      })(x);
    }
    function k(x, w) {
      if (!w && x && x.__esModule)
        return x;
      if (x === null || n(x) !== "object" && typeof x != "function")
        return { default: x };
      var E = $(w);
      if (E && E.has(x))
        return E.get(x);
      var T = {}, z = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var j in x)
        if (j !== "default" && Object.prototype.hasOwnProperty.call(x, j)) {
          var q = z ? Object.getOwnPropertyDescriptor(x, j) : null;
          q && (q.get || q.set) ? Object.defineProperty(T, j, q) : T[j] = x[j];
        }
      return T.default = x, E && E.set(x, T), T;
    }
    function S(x, w) {
      var E = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var T = Object.getOwnPropertySymbols(x);
        w && (T = T.filter(function(z) {
          return Object.getOwnPropertyDescriptor(x, z).enumerable;
        })), E.push.apply(E, T);
      }
      return E;
    }
    function O(x) {
      for (var w = 1; w < arguments.length; w++) {
        var E = arguments[w] != null ? arguments[w] : {};
        w % 2 ? S(Object(E), !0).forEach(function(T) {
          (0, r.default)(x, T, E[T]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : S(Object(E)).forEach(function(T) {
          Object.defineProperty(x, T, Object.getOwnPropertyDescriptor(E, T));
        });
      }
      return x;
    }
    function I(x) {
      var w = D();
      return function() {
        var T = (0, d.default)(x), z;
        if (w) {
          var j = (0, d.default)(this).constructor;
          z = Reflect.construct(T, arguments, j);
        } else
          z = T.apply(this, arguments);
        return (0, l.default)(this, z);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = cm, N = "topRight", C = /* @__PURE__ */ function(x) {
      (0, c.default)(E, x);
      var w = I(E);
      function E(T) {
        var z;
        return (0, i.default)(this, E), z = w.call(this, T), z.childrenClassName = function() {
          return "";
        }, z.renderBeforeActions = function() {
          var j = z.props.config.settings.renderBeforeActions;
          return j == null ? null : typeof j == "function" ? /* @__PURE__ */ u.default.createElement(j, z.props) : j;
        }, z.renderAfterActions = function() {
          var j = z.props.config.settings.renderAfterActions;
          return j == null ? null : typeof j == "function" ? /* @__PURE__ */ u.default.createElement(j, z.props) : j;
        }, z.removeSelf = z.removeSelf.bind((0, s.default)(z)), z.setLock = z.setLock.bind((0, s.default)(z)), z.renderItem = z.renderItem.bind((0, s.default)(z)), z;
      }
      return (0, a.default)(E, [{
        key: "isGroupTopPosition",
        value: function() {
          return (0, p.default)(this.props.config.settings.groupActionsPosition || N, "top");
        }
      }, {
        key: "setLock",
        value: function(z) {
          this.props.setLock(z);
        }
      }, {
        key: "removeSelf",
        value: function() {
          var z = this, j = this.props.confirmFn, q = this.props.config.settings, V = q.renderConfirm, F = q.removeGroupConfirmOptions, L = function() {
            z.props.removeSelf();
          };
          F && !this.isEmptyCurrentGroup() ? V(O(O({}, F), {}, {
            onOk: L,
            onCancel: null,
            confirmFn: j
          })) : L();
        }
      }, {
        key: "isEmptyCurrentGroup",
        value: function() {
          var z = this.props.children1;
          return !z || z.size == 0 || z.size == 1 && this.isEmpty(z.first());
        }
      }, {
        key: "isEmpty",
        value: function(z) {
          var j = z.get("type") == "group" || z.get("type") == "rule_group";
          return j ? this.isEmptyGroup(z) : this.isEmptyRule(z);
        }
      }, {
        key: "isEmptyGroup",
        value: function(z) {
          var j = z.get("children1");
          return !j || j.size == 0 || j.size == 1 && this.isEmpty(j.first());
        }
      }, {
        key: "isEmptyRule",
        value: function(z) {
          var j = z.get("properties");
          return !(j.get("field") !== null && j.get("operator") !== null && j.get("value").filter(function(q) {
            return q !== void 0;
          }).size > 0);
        }
      }, {
        key: "render",
        value: function() {
          return /* @__PURE__ */ u.default.createElement(u.default.Fragment, null, this.renderHeaderWrapper(), this.renderChildrenWrapper(), this.renderFooterWrapper());
        }
      }, {
        key: "showNot",
        value: function() {
          var z = this.props.config;
          return z.settings.showNot;
        }
        // show conjs for 2+ children?
      }, {
        key: "showConjs",
        value: function() {
          var z = this.props, j = z.conjunctionOptions;
          z.children1, z.config;
          var q = Object.keys(j).length;
          return q > 1 || this.showNot();
        }
      }, {
        key: "isOneChild",
        value: function() {
          var z = this.props.children1;
          return z ? z.size < 2 : !0;
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          var z = this.props.children1;
          return z && /* @__PURE__ */ u.default.createElement("div", {
            key: "group-children",
            className: M("group--children", this.showConjs() ? "" : "hide--conjs", this.isOneChild() ? "hide--line" : "", this.isOneChild() ? "one--child" : "", this.childrenClassName())
          }, this.renderChildren());
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          var z = this.isGroupTopPosition();
          return /* @__PURE__ */ u.default.createElement("div", {
            key: "group-header",
            className: M("group--header", this.isOneChild() ? "one--child" : "")
          }, this.renderHeader(), z && this.renderBeforeActions(), z && this.renderActions(), z && this.renderAfterActions());
        }
      }, {
        key: "renderFooterWrapper",
        value: function() {
          var z = this.isGroupTopPosition();
          return !z && /* @__PURE__ */ u.default.createElement("div", {
            key: "group-footer",
            className: "group--footer"
          }, this.renderBeforeActions(), this.renderActions(), this.renderAfterActions());
        }
      }, {
        key: "renderActions",
        value: function() {
          var z = this.props, j = z.config, q = z.addRule, V = z.addGroup, F = z.isLocked, L = z.isTrueLocked, U = z.id;
          return /* @__PURE__ */ u.default.createElement(b.GroupActions, {
            config: j,
            addRule: q,
            addGroup: V,
            canAddGroup: this.canAddGroup(),
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: F,
            isTrueLocked: L,
            id: U
          });
        }
      }, {
        key: "canAddGroup",
        value: function() {
          return this.props.allowFurtherNesting;
        }
      }, {
        key: "canAddRule",
        value: function() {
          var z = this.props.config.settings.maxNumberOfRules, j = this.props.totalRulesCnt;
          return z ? j < z : !0;
        }
      }, {
        key: "canDeleteGroup",
        value: function() {
          return !this.props.isRoot;
        }
      }, {
        key: "renderChildren",
        value: function() {
          var z = this.props.children1;
          return z ? z.map(this.renderItem).toList() : null;
        }
      }, {
        key: "renderItem",
        value: function(z) {
          var j = this.props, q = j.config, V = j.actions, F = j.onDragStart, L = j.isLocked, U = z.get("type") == "group" && z.getIn(["properties", "field"]) != null, W = U ? "rule_group" : z.get("type");
          return /* @__PURE__ */ u.default.createElement(h.Item, (0, o.default)({}, this.extraPropsForItem(z), {
            key: z.get("id"),
            id: z.get("id"),
            groupId: j.id,
            path: z.get("path"),
            type: W,
            properties: z.get("properties"),
            config: q,
            actions: V,
            children1: z.get("children1"),
            reordableNodesCnt: this.reordableNodesCntForItem(z),
            totalRulesCnt: this.totalRulesCntForItem(z),
            parentReordableNodesCnt: this.reordableNodesCnt(),
            onDragStart: F,
            isDraggingTempo: this.props.isDraggingTempo,
            isParentLocked: L
          }));
        }
      }, {
        key: "extraPropsForItem",
        value: function(z) {
          return {};
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          return this.props.isLocked ? 0 : this.props.reordableNodesCnt;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(z) {
          return this.props.totalRulesCnt;
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(z) {
          return this.props.isLocked ? 0 : this.reordableNodesCnt();
        }
      }, {
        key: "showDragIcon",
        value: function() {
          var z = this.props, j = z.config, q = z.isRoot, V = z.isLocked, F = this.reordableNodesCnt();
          return j.settings.canReorder && !q && F > 1 && !V;
        }
      }, {
        key: "renderDrag",
        value: function() {
          var z = this.props.handleDraggerMouseDown, j = this.showDragIcon() && /* @__PURE__ */ u.default.createElement("span", {
            key: "group-drag-icon",
            className: "qb-drag-handler group--drag-handler",
            onMouseDown: z
          }, /* @__PURE__ */ u.default.createElement(v.DragIcon, null), " ");
          return j;
        }
      }, {
        key: "conjunctionOptions",
        value: function() {
          var z = this.props.conjunctionOptions;
          return z;
        }
      }, {
        key: "renderConjs",
        value: function() {
          var z = this.props, j = z.config, q = z.children1, V = z.id, F = z.selectedConjunction, L = z.setConjunction, U = z.not, W = z.setNot, H = z.isLocked, Q = j.settings, X = Q.immutableGroupsMode, re = Q.renderConjs;
          Q.showNot;
          var Z = Q.notLabel, ee = this.conjunctionOptions();
          if (!this.showConjs() || !q || !q.size)
            return null;
          var J = {
            disabled: this.isOneChild(),
            readonly: X || H,
            selectedConjunction: F,
            setConjunction: X ? v.dummyFn : L,
            conjunctionOptions: ee,
            config: j,
            not: U || !1,
            id: V,
            setNot: X ? v.dummyFn : W,
            notLabel: Z,
            showNot: this.showNot(),
            isLocked: H
          };
          return /* @__PURE__ */ u.default.createElement(re, J);
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ u.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }]), E;
    }(u.PureComponent);
    e.BasicGroup = C, C.propTypes = {
      //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
      reordableNodesCnt: _.default.number,
      conjunctionOptions: _.default.object.isRequired,
      allowFurtherNesting: _.default.bool.isRequired,
      isRoot: _.default.bool.isRequired,
      not: _.default.bool,
      selectedConjunction: _.default.string,
      config: _.default.object.isRequired,
      id: _.default.string.isRequired,
      groupId: _.default.string,
      path: _.default.any,
      //instanceOf(Immutable.List)
      children1: _.default.any,
      //instanceOf(Immutable.OrderedMap)
      isDraggingMe: _.default.bool,
      isDraggingTempo: _.default.bool,
      isLocked: _.default.bool,
      isTrueLocked: _.default.bool,
      //actions
      handleDraggerMouseDown: _.default.func,
      onDragStart: _.default.func,
      addRule: _.default.func.isRequired,
      addGroup: _.default.func.isRequired,
      removeSelf: _.default.func.isRequired,
      setConjunction: _.default.func.isRequired,
      setNot: _.default.func.isRequired,
      setLock: _.default.func.isRequired,
      actions: _.default.object.isRequired
    };
    var P = (0, f.default)((0, g.default)("group")((0, v.ConfirmFn)(C)));
    e.default = P;
  }(KR)), KR;
}
var XR = {}, eN = { exports: {} }, tN = { exports: {} }, lre;
function u_d() {
  return lre || (lre = 1, function(e) {
    var t = ir();
    function n(o, r) {
      for (; !Object.prototype.hasOwnProperty.call(o, r) && (o = t(o), o !== null); )
        ;
      return o;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(tN)), tN.exports;
}
var dre;
function z7() {
  return dre || (dre = 1, function(e) {
    var t = u_d();
    function n() {
      return typeof Reflect < "u" && Reflect.get ? (e.exports = n = Reflect.get.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = n = function(r, i, a) {
        var s = t(r, i);
        if (s) {
          var c = Object.getOwnPropertyDescriptor(s, i);
          return c.get ? c.get.call(arguments.length < 3 ? r : a) : c.value;
        }
      }, e.exports.__esModule = !0, e.exports.default = e.exports), n.apply(this, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(eN)), eN.exports;
}
var n$ = {}, ure;
function __d() {
  if (ure)
    return n$;
  ure = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(n$, "__esModule", {
    value: !0
  }), n$.RuleGroupActions = void 0;
  var n = e(yr), o = e($r), r = e(wr), i = e(kr()), a = e(ir()), s = l(ve);
  function c(p) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
    return (c = function(b) {
      return b ? g : f;
    })(p);
  }
  function l(p, f) {
    if (!f && p && p.__esModule)
      return p;
    if (p === null || t(p) !== "object" && typeof p != "function")
      return { default: p };
    var g = c(f);
    if (g && g.has(p))
      return g.get(p);
    var h = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in p)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(p, v)) {
        var $ = b ? Object.getOwnPropertyDescriptor(p, v) : null;
        $ && ($.get || $.set) ? Object.defineProperty(h, v, $) : h[v] = p[v];
      }
    return h.default = p, g && g.set(p, h), h;
  }
  function d(p) {
    var f = u();
    return function() {
      var h = (0, a.default)(p), b;
      if (f) {
        var v = (0, a.default)(this).constructor;
        b = Reflect.construct(h, arguments, v);
      } else
        b = h.apply(this, arguments);
      return (0, i.default)(this, b);
    };
  }
  function u() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = /* @__PURE__ */ function(p) {
    (0, r.default)(g, p);
    var f = d(g);
    function g() {
      return (0, n.default)(this, g), f.apply(this, arguments);
    }
    return (0, o.default)(g, [{
      key: "render",
      value: function() {
        var b = this.props, v = b.config, $ = b.addRule, k = b.canAddRule, S = b.canDeleteGroup, O = b.removeSelf, I = b.setLock, D = b.isLocked, M = b.isTrueLocked, N = b.id, C = v.settings, P = C.immutableGroupsMode, x = C.addRuleLabel, w = C.delGroupLabel, E = C.renderButton, T = C.renderSwitch, z = C.renderButtonGroup, j = C.lockLabel, q = C.lockedLabel, V = C.showLock, F = C.canDeleteLocked, L = V && !(D && !M) && /* @__PURE__ */ s.default.createElement(T, {
          type: "lock",
          id: N,
          value: D,
          setValue: I,
          label: j,
          checkedLabel: q,
          hideLabel: !0,
          config: v
        }), U = !P && k && !D && /* @__PURE__ */ s.default.createElement(E, {
          type: "addRuleGroup",
          onClick: $,
          label: x,
          readonly: D,
          config: v
        }), W = !P && S && (!D || D && F) && /* @__PURE__ */ s.default.createElement(E, {
          type: "delRuleGroup",
          onClick: O,
          label: w,
          config: v
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions"
        }, /* @__PURE__ */ s.default.createElement(z, {
          config: v
        }, L, U, W));
      }
    }]), g;
  }(s.PureComponent);
  return n$.RuleGroupActions = _, n$;
}
var _re;
function p_d() {
  return _re || (_re = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(rr), o = t(yr), r = t($r), i = t(ua()), a = t(z7()), s = t(wr), c = t(kr()), l = t(ir()), d = t(ve), u = t(di), _ = t(Fk()), p = t(Nb()), f = Vk(), g = __d(), h = t(C7()), b = Na(), v = wu(), $, k, S;
    function O(P, x) {
      var w = Object.keys(P);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(P);
        x && (E = E.filter(function(T) {
          return Object.getOwnPropertyDescriptor(P, T).enumerable;
        })), w.push.apply(w, E);
      }
      return w;
    }
    function I(P) {
      for (var x = 1; x < arguments.length; x++) {
        var w = arguments[x] != null ? arguments[x] : {};
        x % 2 ? O(Object(w), !0).forEach(function(E) {
          (0, n.default)(P, E, w[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(w)) : O(Object(w)).forEach(function(E) {
          Object.defineProperty(P, E, Object.getOwnPropertyDescriptor(w, E));
        });
      }
      return P;
    }
    function D(P) {
      var x = M();
      return function() {
        var E = (0, l.default)(P), T;
        if (x) {
          var z = (0, l.default)(this).constructor;
          T = Reflect.construct(E, arguments, z);
        } else
          T = E.apply(this, arguments);
        return (0, c.default)(this, T);
      };
    }
    function M() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var N = ($ = (0, p.default)("group rule_group"), (0, _.default)(k = $(k = (0, v.ConfirmFn)(k = (S = /* @__PURE__ */ function(P) {
      (0, s.default)(w, P);
      var x = D(w);
      function w(E) {
        var T;
        return (0, o.default)(this, w), T = x.call(this, E), T.childrenClassName = function() {
          return "rule_group--children";
        }, T.renderHeaderWrapper = function() {
          return null;
        }, T.renderFooterWrapper = function() {
          return null;
        }, T.renderConjs = function() {
          return null;
        }, T.canAddGroup = function() {
          return !1;
        }, T.canAddRule = function() {
          return !0;
        }, T.canDeleteGroup = function() {
          return !1;
        }, (0, b.useOnPropsChanged)((0, i.default)(T)), T.onPropsChanged(E), T;
      }
      return (0, r.default)(w, [{
        key: "onPropsChanged",
        value: function(T) {
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(T) {
          if (this.props.isLocked)
            return 0;
          var z = this.props.children1;
          return z.size;
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          return /* @__PURE__ */ d.default.createElement(d.default.Fragment, null, this.renderDrag(), this.renderField(), this.renderActions(), (0, a.default)((0, l.default)(w.prototype), "renderChildrenWrapper", this).call(this));
        }
      }, {
        key: "renderField",
        value: function() {
          var T = this.props, z = T.config, j = T.selectedField, q = T.setField, V = T.parentField, F = T.id, L = T.groupId, U = T.isLocked, W = z.settings.immutableFieldsMode;
          return /* @__PURE__ */ d.default.createElement(h.default, {
            key: "field",
            classname: "group--field",
            config: z,
            selectedField: j,
            setField: q,
            parentField: V,
            readonly: W || U,
            id: F,
            groupId: L
          });
        }
      }, {
        key: "renderActions",
        value: function() {
          var T = this.props, z = T.config, j = T.addRule, q = T.isLocked, V = T.isTrueLocked, F = T.id;
          return /* @__PURE__ */ d.default.createElement(g.RuleGroupActions, {
            config: z,
            addRule: j,
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: q,
            isTrueLocked: V,
            id: F
          });
        }
      }, {
        key: "extraPropsForItem",
        value: function(T) {
          return {
            parentField: this.props.selectedField
          };
        }
      }]), w;
    }(f.BasicGroup), S.propTypes = I(I({}, f.BasicGroup.propTypes), {}, {
      selectedField: u.default.string,
      parentField: u.default.string,
      setField: u.default.func
    }), S)) || k) || k) || k), C = N;
    e.default = C;
  }(XR)), XR;
}
var nN = {}, o$ = {}, pre;
function m_d() {
  if (pre)
    return o$;
  pre = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(o$, "__esModule", {
    value: !0
  }), o$.RuleGroupExtActions = void 0;
  var n = e(yr), o = e($r), r = e(wr), i = e(kr()), a = e(ir()), s = l(ve);
  function c(p) {
    if (typeof WeakMap != "function")
      return null;
    var f = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
    return (c = function(b) {
      return b ? g : f;
    })(p);
  }
  function l(p, f) {
    if (!f && p && p.__esModule)
      return p;
    if (p === null || t(p) !== "object" && typeof p != "function")
      return { default: p };
    var g = c(f);
    if (g && g.has(p))
      return g.get(p);
    var h = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in p)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(p, v)) {
        var $ = b ? Object.getOwnPropertyDescriptor(p, v) : null;
        $ && ($.get || $.set) ? Object.defineProperty(h, v, $) : h[v] = p[v];
      }
    return h.default = p, g && g.set(p, h), h;
  }
  function d(p) {
    var f = u();
    return function() {
      var h = (0, a.default)(p), b;
      if (f) {
        var v = (0, a.default)(this).constructor;
        b = Reflect.construct(h, arguments, v);
      } else
        b = h.apply(this, arguments);
      return (0, i.default)(this, b);
    };
  }
  function u() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = /* @__PURE__ */ function(p) {
    (0, r.default)(g, p);
    var f = d(g);
    function g() {
      return (0, n.default)(this, g), f.apply(this, arguments);
    }
    return (0, o.default)(g, [{
      key: "render",
      value: function() {
        var b = this.props, v = b.config, $ = b.addRule, k = b.canAddRule, S = b.canDeleteGroup, O = b.removeSelf, I = b.setLock, D = b.isLocked, M = b.isTrueLocked, N = b.id, C = v.settings, P = C.immutableGroupsMode, x = C.addSubRuleLabel, w = C.delGroupLabel, E = C.renderButton, T = C.renderSwitch, z = C.renderButtonGroup, j = C.lockLabel, q = C.lockedLabel, V = C.showLock, F = C.canDeleteLocked, L = V && !(D && !M) && /* @__PURE__ */ s.default.createElement(T, {
          type: "lock",
          id: N,
          value: D,
          setValue: I,
          label: j,
          checkedLabel: q,
          config: v
        }), U = !P && k && !D && /* @__PURE__ */ s.default.createElement(E, {
          type: "addRuleGroupExt",
          onClick: $,
          label: x,
          readonly: D,
          config: v
        }), W = !P && S && (!D || D && F) && /* @__PURE__ */ s.default.createElement(E, {
          type: "delRuleGroup",
          onClick: O,
          label: w,
          config: v
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions group--actions--tr"
        }, /* @__PURE__ */ s.default.createElement(z, {
          config: v
        }, L, U, W));
      }
    }]), g;
  }(s.PureComponent);
  return o$.RuleGroupExtActions = _, o$;
}
var mre;
function f_d() {
  return mre || (mre = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(rr), o = t(yr), r = t($r), i = t(ua()), a = t(z7()), s = t(wr), c = t(kr()), l = t(ir()), d = t(ve), u = t(di), _ = t(Fk()), p = t(Nb()), f = Vk(), g = m_d(), h = t(C7()), b = t(n1e()), v = Na(), $ = wu(), k = Br(), S = t(oz()), O, I, D;
    function M(q, V) {
      var F = Object.keys(q);
      if (Object.getOwnPropertySymbols) {
        var L = Object.getOwnPropertySymbols(q);
        V && (L = L.filter(function(U) {
          return Object.getOwnPropertyDescriptor(q, U).enumerable;
        })), F.push.apply(F, L);
      }
      return F;
    }
    function N(q) {
      for (var V = 1; V < arguments.length; V++) {
        var F = arguments[V] != null ? arguments[V] : {};
        V % 2 ? M(Object(F), !0).forEach(function(L) {
          (0, n.default)(q, L, F[L]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(F)) : M(Object(F)).forEach(function(L) {
          Object.defineProperty(q, L, Object.getOwnPropertyDescriptor(F, L));
        });
      }
      return q;
    }
    function C(q, V) {
      var F = typeof Symbol < "u" && q[Symbol.iterator] || q["@@iterator"];
      if (!F) {
        if (Array.isArray(q) || (F = P(q)) || V && q && typeof q.length == "number") {
          F && (q = F);
          var L = 0, U = function() {
          };
          return { s: U, n: function() {
            return L >= q.length ? { done: !0 } : { done: !1, value: q[L++] };
          }, e: function(re) {
            throw re;
          }, f: U };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var W = !0, H = !1, Q;
      return { s: function() {
        F = F.call(q);
      }, n: function() {
        var re = F.next();
        return W = re.done, re;
      }, e: function(re) {
        H = !0, Q = re;
      }, f: function() {
        try {
          !W && F.return != null && F.return();
        } finally {
          if (H)
            throw Q;
        }
      } };
    }
    function P(q, V) {
      if (q) {
        if (typeof q == "string")
          return x(q, V);
        var F = Object.prototype.toString.call(q).slice(8, -1);
        if (F === "Object" && q.constructor && (F = q.constructor.name), F === "Map" || F === "Set")
          return Array.from(q);
        if (F === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(F))
          return x(q, V);
      }
    }
    function x(q, V) {
      (V == null || V > q.length) && (V = q.length);
      for (var F = 0, L = new Array(V); F < V; F++)
        L[F] = q[F];
      return L;
    }
    function w(q) {
      var V = E();
      return function() {
        var L = (0, l.default)(q), U;
        if (V) {
          var W = (0, l.default)(this).constructor;
          U = Reflect.construct(L, arguments, W);
        } else
          U = L.apply(this, arguments);
        return (0, c.default)(this, U);
      };
    }
    function E() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var T = cm, z = (O = (0, p.default)("group rule_group_ext"), (0, _.default)(I = O(I = (0, $.ConfirmFn)(I = (D = /* @__PURE__ */ function(q) {
      (0, s.default)(F, q);
      var V = w(F);
      function F(L) {
        var U;
        return (0, o.default)(this, F), U = V.call(this, L), U.childrenClassName = function() {
          return "rule_group_ext--children";
        }, U.renderFooterWrapper = function() {
          return null;
        }, U.canAddGroup = function() {
          return !1;
        }, U.canAddRule = function() {
          return !0;
        }, U.canDeleteGroup = function() {
          return !0;
        }, (0, v.useOnPropsChanged)((0, i.default)(U)), U.onPropsChanged(L), U;
      }
      return (0, r.default)(F, [{
        key: "onPropsChanged",
        value: function(U) {
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ d.default.createElement("div", {
            key: "group-header",
            className: T("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeader(), this.renderGroupField(), this.renderActions());
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ d.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderGroupField",
        value: function() {
          return /* @__PURE__ */ d.default.createElement("div", {
            className: "group--field--count--rule"
          }, this.renderField(), this.renderOperator(), this.renderWidget());
        }
      }, {
        key: "showNot",
        value: function() {
          var U = this.props, W = U.config, H = U.selectedField;
          U.selectedOperator;
          var Q = (0, k.getFieldConfig)(W, H) || {};
          return Q.showNot != null ? Q.showNot : W.settings.showNot;
        }
      }, {
        key: "conjunctionOptions",
        value: function() {
          var U = this.props, W = U.config, H = U.selectedField;
          U.selectedOperator;
          var Q = (0, k.getFieldConfig)(W, H) || {}, X = (0, a.default)((0, l.default)(F.prototype), "conjunctionOptions", this).call(this);
          if (Q.conjunctions) {
            var re = {}, Z = C(Q.conjunctions), ee;
            try {
              for (Z.s(); !(ee = Z.n()).done; ) {
                var J = ee.value;
                re[J] = X[J];
              }
            } catch (oe) {
              Z.e(oe);
            } finally {
              Z.f();
            }
            X = re;
          }
          return X;
        }
      }, {
        key: "renderField",
        value: function() {
          var U = this.props, W = U.config, H = U.selectedField, Q = U.setField, X = U.parentField, re = U.id, Z = U.groupId, ee = U.isLocked, J = W.settings.immutableFieldsMode;
          return /* @__PURE__ */ d.default.createElement(h.default, {
            key: "field",
            classname: "rule--field",
            config: W,
            selectedField: H,
            setField: Q,
            parentField: X,
            readonly: J || ee,
            id: re,
            groupId: Z
          });
        }
      }, {
        key: "renderOperator",
        value: function() {
          var U = this.props, W = U.config, H = U.selectedField, Q = U.selectedOperator, X = U.setField, re = U.setOperator, Z = U.isLocked, ee = W.settings.immutableFieldsMode, J = (0, k.getFieldWidgetConfig)(W, H, Q) || {}, oe = J.hideOperator, ce = H && oe && J.operatorInlineLabel, de = H && !oe;
          return /* @__PURE__ */ d.default.createElement(b.default, {
            key: "operator",
            classname: "group--operator",
            config: W,
            selectedField: H,
            selectedOperator: Q,
            setField: X,
            setOperator: re,
            selectedFieldPartsLabels: ["group"],
            showOperator: de,
            showOperatorLabel: ce,
            selectedFieldWidgetConfig: J,
            readonly: ee || Z,
            id: this.props.id,
            groupId: this.props.groupId
          });
        }
      }, {
        key: "renderWidget",
        value: function() {
          var U = this.props, W = U.config, H = U.selectedField, Q = U.selectedOperator, X = U.isLocked, re = W.settings.immutableValuesMode, Z = H && Q, ee = Z;
          if (!ee)
            return null;
          var J = /* @__PURE__ */ d.default.createElement(S.default, {
            key: "values",
            isForRuleGruop: !0,
            field: this.props.selectedField,
            operator: this.props.selectedOperator,
            value: this.props.value,
            valueSrc: "value",
            valueError: null,
            config: W,
            setValue: re ? $.dummyFn : this.props.setValue,
            setValueSrc: $.dummyFn,
            readonly: re || X,
            id: this.props.id,
            groupId: this.props.groupId
          });
          return /* @__PURE__ */ d.default.createElement($.Col, {
            key: "widget-for-" + this.props.selectedOperator,
            className: "rule--value"
          }, J);
        }
      }, {
        key: "renderActions",
        value: function() {
          var U = this.props, W = U.config, H = U.addRule, Q = U.isLocked, X = U.isTrueLocked, re = U.id;
          return /* @__PURE__ */ d.default.createElement(g.RuleGroupExtActions, {
            config: W,
            addRule: H,
            canAddRule: this.canAddRule(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: Q,
            isTrueLocked: X,
            id: re
          });
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(U) {
          if (this.props.isLocked)
            return 0;
          var W = this.props.children1;
          return W.size;
        }
      }, {
        key: "extraPropsForItem",
        value: function(U) {
          return {
            parentField: this.props.selectedField
          };
        }
      }]), F;
    }(f.BasicGroup), D.propTypes = N(N({}, f.BasicGroup.propTypes), {}, {
      selectedField: u.default.string,
      selectedOperator: u.default.string,
      value: u.default.any,
      parentField: u.default.string,
      setField: u.default.func,
      setOperator: u.default.func,
      setValue: u.default.func
    }), D)) || I) || I) || I), j = z;
    e.default = j;
  }(nN)), nN;
}
var oN = {}, r$ = {}, fre;
function g_d() {
  if (fre)
    return r$;
  fre = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(r$, "__esModule", {
    value: !0
  }), r$.SwitchGroupActions = void 0;
  var n = e(yr), o = e($r), r = e(wr), i = e(kr()), a = e(ir()), s = l(ve);
  function c(g) {
    if (typeof WeakMap != "function")
      return null;
    var h = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (c = function($) {
      return $ ? b : h;
    })(g);
  }
  function l(g, h) {
    if (!h && g && g.__esModule)
      return g;
    if (g === null || t(g) !== "object" && typeof g != "function")
      return { default: g };
    var b = c(h);
    if (b && b.has(g))
      return b.get(g);
    var v = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var k in g)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(g, k)) {
        var S = $ ? Object.getOwnPropertyDescriptor(g, k) : null;
        S && (S.get || S.set) ? Object.defineProperty(v, k, S) : v[k] = g[k];
      }
    return v.default = g, b && b.set(g, v), v;
  }
  function d(g) {
    var h = u();
    return function() {
      var v = (0, a.default)(g), $;
      if (h) {
        var k = (0, a.default)(this).constructor;
        $ = Reflect.construct(v, arguments, k);
      } else
        $ = v.apply(this, arguments);
      return (0, i.default)(this, $);
    };
  }
  function u() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var _ = {
    topLeft: "group--actions--tl",
    topCenter: "group--actions--tc",
    topRight: "group--actions--tr",
    bottomLeft: "group--actions--bl",
    bottomCenter: "group--actions--bc",
    bottomRight: "group--actions--br"
  }, p = "topRight", f = /* @__PURE__ */ function(g) {
    (0, r.default)(b, g);
    var h = d(b);
    function b() {
      return (0, n.default)(this, b), h.apply(this, arguments);
    }
    return (0, o.default)(b, [{
      key: "render",
      value: function() {
        var $ = this.props, k = $.config, S = $.addCaseGroup, O = $.addDefaultCaseGroup, I = $.setLock, D = $.isLocked, M = $.isTrueLocked, N = $.id, C = $.canAddGroup, P = $.canAddDefault, x = k.settings, w = x.immutableGroupsMode, E = x.addCaseLabel, T = x.addDefaultCaseLabel, z = x.groupActionsPosition, j = x.renderButton, q = x.renderSwitch, V = x.renderButtonGroup, F = x.lockLabel, L = x.lockedLabel, U = x.showLock, W = _[z || p], H = U && !(D && !M) && /* @__PURE__ */ s.default.createElement(q, {
          type: "lock",
          id: N,
          value: D,
          setValue: I,
          label: F,
          checkedLabel: L,
          config: k
        }), Q = !w && C && !D && /* @__PURE__ */ s.default.createElement(j, {
          type: "addCaseGroup",
          onClick: S,
          label: E,
          readonly: D,
          config: k
        }), X = !w && P && !D && /* @__PURE__ */ s.default.createElement(j, {
          type: "addDefaultCaseGroup",
          onClick: O,
          label: T,
          readonly: D,
          config: k
        });
        return /* @__PURE__ */ s.default.createElement("div", {
          className: "group--actions ".concat(W)
        }, /* @__PURE__ */ s.default.createElement(V, {
          config: k
        }, H, Q, X));
      }
    }]), b;
  }(s.PureComponent);
  return r$.SwitchGroupActions = f, r$;
}
var gre;
function h_d() {
  return gre || (gre = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(rr), o = t(yr), r = t($r), i = t(ua()), a = t(wr), s = t(kr()), c = t(ir()), l = t(ve);
    t(di);
    var d = t(Fk()), u = t(Nb()), _ = Vk(), p = g_d(), f = Na(), g = wu(), h = yg(), b, v, $;
    function k(C, P) {
      var x = Object.keys(C);
      if (Object.getOwnPropertySymbols) {
        var w = Object.getOwnPropertySymbols(C);
        P && (w = w.filter(function(E) {
          return Object.getOwnPropertyDescriptor(C, E).enumerable;
        })), x.push.apply(x, w);
      }
      return x;
    }
    function S(C) {
      for (var P = 1; P < arguments.length; P++) {
        var x = arguments[P] != null ? arguments[P] : {};
        P % 2 ? k(Object(x), !0).forEach(function(w) {
          (0, n.default)(C, w, x[w]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(x)) : k(Object(x)).forEach(function(w) {
          Object.defineProperty(C, w, Object.getOwnPropertyDescriptor(x, w));
        });
      }
      return C;
    }
    function O(C) {
      var P = I();
      return function() {
        var w = (0, c.default)(C), E;
        if (P) {
          var T = (0, c.default)(this).constructor;
          E = Reflect.construct(w, arguments, T);
        } else
          E = w.apply(this, arguments);
        return (0, s.default)(this, E);
      };
    }
    function I() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var D = cm, M = (b = (0, u.default)("group switch_group"), (0, d.default)(v = b(v = (0, g.ConfirmFn)(v = ($ = /* @__PURE__ */ function(C) {
      (0, a.default)(x, C);
      var P = O(x);
      function x(w) {
        var E;
        return (0, o.default)(this, x), E = P.call(this, w), E.childrenClassName = function() {
          return "switch_group--children";
        }, E.renderFooterWrapper = function() {
          return null;
        }, E.hasDefaultCase = function() {
          return E.props.children1.size && E.props.children1.filter(function(T) {
            return T.get("children1") == null;
          }).size > 0;
        }, (0, f.useOnPropsChanged)((0, i.default)(E)), E.onPropsChanged(w), E;
      }
      return (0, r.default)(x, [{
        key: "onPropsChanged",
        value: function(E) {
        }
      }, {
        key: "canAddGroup",
        value: function() {
          var E = this.props.config.settings.maxNumberOfCases, T = this.props.children1.size;
          return E ? T < E : !0;
        }
      }, {
        key: "canAddRule",
        value: function() {
          return !1;
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          var E = this.props.children1.size, T = E;
          return this.hasDefaultCase() && T--, T;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(E) {
          return (0, h.getTotalRulesCountInTree)(E);
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(E) {
          if (this.props.isLocked)
            return 0;
          var T = this.props.config.settings, z = T.canLeaveEmptyCase, j = T.canRegroupCases, q = this.props.children1.size, V = q;
          this.hasDefaultCase() && V--;
          var F = (0, h.getTotalReordableNodesCountInTree)(E), L = F;
          return L == 1 && j && z && V > 1 && (L = 111), L;
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ l.default.createElement("div", {
            key: "group-header",
            className: D("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeader(), this.renderActions());
        }
      }, {
        key: "renderHeader",
        value: function() {
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderConjs",
        value: function() {
          var E = this.props.config.settings.renderSwitchPrefix;
          return E ? E() : null;
        }
      }, {
        key: "showNot",
        value: function() {
          return !1;
        }
      }, {
        key: "renderActions",
        value: function() {
          var E = this.props, T = E.config, z = E.addCaseGroup, j = E.addDefaultCaseGroup, q = E.isLocked, V = E.isTrueLocked, F = E.id;
          return /* @__PURE__ */ l.default.createElement(p.SwitchGroupActions, {
            config: T,
            addCaseGroup: z,
            addDefaultCaseGroup: j,
            canAddDefault: !this.hasDefaultCase(),
            canAddGroup: this.canAddGroup(),
            setLock: this.setLock,
            isLocked: q,
            isTrueLocked: V,
            id: F
          });
        }
      }]), x;
    }(_.BasicGroup), $.propTypes = S({}, _.BasicGroup.propTypes), $)) || v) || v) || v), N = M;
    e.default = N;
  }(oN)), oN;
}
var rN = {}, hre;
function v_d() {
  return hre || (hre = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = t(rr), o = t(yr), r = t($r), i = t(ua()), a = t(z7()), s = t(wr), c = t(kr()), l = t(ir()), d = t(ve), u = t(di), _ = t(Fk()), p = t(Nb()), f = Vk(), g = o1e(), h = Na(), b = wu(), v = t(oz()), $, k, S;
    function O(x, w) {
      var E = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var T = Object.getOwnPropertySymbols(x);
        w && (T = T.filter(function(z) {
          return Object.getOwnPropertyDescriptor(x, z).enumerable;
        })), E.push.apply(E, T);
      }
      return E;
    }
    function I(x) {
      for (var w = 1; w < arguments.length; w++) {
        var E = arguments[w] != null ? arguments[w] : {};
        w % 2 ? O(Object(E), !0).forEach(function(T) {
          (0, n.default)(x, T, E[T]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : O(Object(E)).forEach(function(T) {
          Object.defineProperty(x, T, Object.getOwnPropertyDescriptor(E, T));
        });
      }
      return x;
    }
    function D(x) {
      var w = M();
      return function() {
        var T = (0, l.default)(x), z;
        if (w) {
          var j = (0, l.default)(this).constructor;
          z = Reflect.construct(T, arguments, j);
        } else
          z = T.apply(this, arguments);
        return (0, c.default)(this, z);
      };
    }
    function M() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var N = cm, C = ($ = (0, p.default)("group case_group"), (0, _.default)(k = $(k = (0, b.ConfirmFn)(k = (S = /* @__PURE__ */ function(x) {
      (0, s.default)(E, x);
      var w = D(E);
      function E(T) {
        var z;
        return (0, o.default)(this, E), z = w.call(this, T), z.childrenClassName = function() {
          return "case_group--children";
        }, z.renderFooterWrapper = function() {
          return null;
        }, (0, h.useOnPropsChanged)((0, i.default)(z)), z.onPropsChanged(T), z;
      }
      return (0, r.default)(E, [{
        key: "onPropsChanged",
        value: function(z) {
        }
      }, {
        key: "isDefaultCase",
        value: function() {
          return this.props.children1 == null;
        }
      }, {
        key: "reordableNodesCnt",
        value: function() {
          return this.props.parentReordableNodesCnt;
        }
      }, {
        key: "reordableNodesCntForItem",
        value: function(z) {
          return this.props.isLocked ? 0 : this.props.reordableNodesCnt;
        }
      }, {
        key: "totalRulesCntForItem",
        value: function(z) {
          return this.props.totalRulesCnt;
        }
      }, {
        key: "showDragIcon",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "showDragIcon", this).call(this);
        }
      }, {
        key: "renderHeaderWrapper",
        value: function() {
          return /* @__PURE__ */ d.default.createElement("div", {
            key: "group-header",
            className: N("group--header", this.isOneChild() ? "one--child" : "", this.showDragIcon() ? "with--drag" : "hide--drag", this.showConjs() && (!this.isOneChild() || this.showNot()) ? "with--conjs" : "hide--conjs")
          }, this.renderHeaderLeft(), this.renderHeaderCenter(), this.renderActions());
        }
      }, {
        key: "renderChildrenWrapper",
        value: function() {
          return this.isDefaultCase() ? null : /* @__PURE__ */ d.default.createElement("div", {
            className: "case_group--body"
          }, this.renderCondition(), this.renderValue());
        }
      }, {
        key: "renderHeaderLeft",
        value: function() {
          if (this.isDefaultCase()) {
            var z = this.props.config.settings.defaultCaseLabel;
            return z || "";
          }
          return /* @__PURE__ */ d.default.createElement("div", {
            className: "group--conjunctions"
          }, this.renderConjs(), this.renderDrag());
        }
      }, {
        key: "renderCondition",
        value: function() {
          return this.isDefaultCase() ? null : (0, a.default)((0, l.default)(E.prototype), "renderChildrenWrapper", this).call(this);
        }
      }, {
        key: "renderHeaderCenter",
        value: function() {
          return this.isDefaultCase() ? this.renderValue() : null;
        }
      }, {
        key: "canAddGroup",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "canAddGroup", this).call(this);
        }
      }, {
        key: "canAddRule",
        value: function() {
          return this.isDefaultCase() ? !1 : (0, a.default)((0, l.default)(E.prototype), "canAddRule", this).call(this);
        }
      }, {
        key: "renderValue",
        value: function() {
          var z = this.props, j = z.config, q = z.isLocked, V = z.value, F = z.setValue, L = z.id, U = j.settings.immutableValuesMode, W = /* @__PURE__ */ d.default.createElement(v.default, {
            key: "values",
            isCaseValue: !0,
            field: "!case_value",
            operator: null,
            value: V,
            valueSrc: "value",
            valueError: null,
            config: j,
            setValue: U ? b.dummyFn : F,
            setValueSrc: b.dummyFn,
            readonly: U || q,
            id: L,
            groupId: null
          });
          return /* @__PURE__ */ d.default.createElement(b.Col, {
            className: "case_group--value"
          }, W);
        }
      }, {
        key: "renderActions",
        value: function() {
          var z = this.props, j = z.config, q = z.addGroup, V = z.addRule, F = z.isLocked, L = z.isTrueLocked, U = z.id;
          return /* @__PURE__ */ d.default.createElement(g.GroupActions, {
            config: j,
            addGroup: q,
            addRule: V,
            canAddRule: this.canAddRule(),
            canAddGroup: this.canAddGroup(),
            canDeleteGroup: this.canDeleteGroup(),
            removeSelf: this.removeSelf,
            setLock: this.setLock,
            isLocked: F,
            isTrueLocked: L,
            id: U
          });
        }
      }, {
        key: "isEmptyCurrentGroup",
        value: function() {
          var z = this.props.value, j = z && z.size ? z.get(0) : null, q = j != null && (Array.isArray(j) ? j.length > 0 : !0);
          return (0, a.default)((0, l.default)(E.prototype), "isEmptyCurrentGroup", this).call(this) && !q;
        }
      }]), E;
    }(f.BasicGroup), S.propTypes = I(I({}, f.BasicGroup.propTypes), {}, {
      parentReordableNodesCnt: u.default.number,
      value: u.default.any,
      setValue: u.default.func
    }), S)) || k) || k) || k), P = C;
    e.default = P;
  }(rN)), rN;
}
var vre;
function r1e() {
  if (vre)
    return e$;
  vre = 1;
  var e = Rt, t = Yn;
  Object.defineProperty(e$, "__esModule", {
    value: !0
  }), e$.Item = void 0;
  var n = e(Tk), o = e(yr), r = e($r), i = e(wr), a = e(kr()), s = e(ir()), c = e(pa), l = e(rr), d = k(ve), u = e(di), _ = e(s_d()), p = e(Vk()), f = e(p_d()), g = e(f_d()), h = e(h_d()), b = e(v_d()), v = ["type"];
  function $(x) {
    if (typeof WeakMap != "function")
      return null;
    var w = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
    return ($ = function(z) {
      return z ? E : w;
    })(x);
  }
  function k(x, w) {
    if (!w && x && x.__esModule)
      return x;
    if (x === null || t(x) !== "object" && typeof x != "function")
      return { default: x };
    var E = $(w);
    if (E && E.has(x))
      return E.get(x);
    var T = {}, z = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var j in x)
      if (j !== "default" && Object.prototype.hasOwnProperty.call(x, j)) {
        var q = z ? Object.getOwnPropertyDescriptor(x, j) : null;
        q && (q.get || q.set) ? Object.defineProperty(T, j, q) : T[j] = x[j];
      }
    return T.default = x, E && E.set(x, T), T;
  }
  function S(x) {
    var w = O();
    return function() {
      var T = (0, s.default)(x), z;
      if (w) {
        var j = (0, s.default)(this).constructor;
        z = Reflect.construct(T, arguments, j);
      } else
        z = T.apply(this, arguments);
      return (0, a.default)(this, z);
    };
  }
  function O() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function I(x, w) {
    var E = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(x);
      w && (T = T.filter(function(z) {
        return Object.getOwnPropertyDescriptor(x, z).enumerable;
      })), E.push.apply(E, T);
    }
    return E;
  }
  function D(x) {
    for (var w = 1; w < arguments.length; w++) {
      var E = arguments[w] != null ? arguments[w] : {};
      w % 2 ? I(Object(E), !0).forEach(function(T) {
        (0, l.default)(x, T, E[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : I(Object(E)).forEach(function(T) {
        Object.defineProperty(x, T, Object.getOwnPropertyDescriptor(E, T));
      });
    }
    return x;
  }
  var M = ["rule", "group", "rule_group", "switch_group", "case_group"], N = function(w) {
    var E = w.properties.toObject(), T = D({}, E);
    return w.isParentLocked && (T.isLocked = !0), E.isLocked && (T.isTrueLocked = !0), T;
  }, C = {
    rule: function(w) {
      return /* @__PURE__ */ d.default.createElement(_.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        config: w.config,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        parentField: w.parentField,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    },
    group: function(w) {
      return /* @__PURE__ */ d.default.createElement(p.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        config: w.config,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        children1: w.children1,
        parentField: null,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    },
    rule_group: function(w) {
      return /* @__PURE__ */ d.default.createElement(f.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        config: w.config,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        children1: w.children1,
        parentField: w.parentField,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    },
    rule_group_ext: function(w) {
      return /* @__PURE__ */ d.default.createElement(g.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        config: w.config,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        children1: w.children1,
        parentField: w.parentField,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    },
    switch_group: function(w) {
      return /* @__PURE__ */ d.default.createElement(h.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        config: w.config,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        children1: w.children1,
        parentField: null,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    },
    case_group: function(w) {
      return /* @__PURE__ */ d.default.createElement(b.default, (0, c.default)({}, N(w), {
        id: w.id,
        groupId: w.groupId,
        path: w.path,
        actions: w.actions,
        config: w.config,
        reordableNodesCnt: w.reordableNodesCnt,
        totalRulesCnt: w.totalRulesCnt,
        onDragStart: w.onDragStart,
        isDraggingTempo: w.isDraggingTempo,
        children1: w.children1,
        parentField: null,
        parentReordableNodesCnt: w.parentReordableNodesCnt
      }));
    }
  }, P = /* @__PURE__ */ function(x) {
    (0, i.default)(E, x);
    var w = S(E);
    function E() {
      return (0, o.default)(this, E), w.apply(this, arguments);
    }
    return (0, r.default)(E, [{
      key: "render",
      value: function() {
        var z = this.props, j = z.type, q = (0, n.default)(z, v), V = q.properties.get("mode"), F = V == "array" ? "_ext" : "", L = C[j + F];
        return L ? L(q) : null;
      }
    }]), E;
  }(d.PureComponent);
  return e$.Item = P, P.propTypes = {
    //tree: PropTypes.instanceOf(Immutable.Map).isRequired,
    config: u.default.object.isRequired,
    id: u.default.string.isRequired,
    groupId: u.default.string,
    type: u.default.oneOf(M).isRequired,
    path: u.default.any.isRequired,
    //instanceOf(Immutable.List)
    properties: u.default.any.isRequired,
    //instanceOf(Immutable.Map)
    children1: u.default.any,
    //instanceOf(Immutable.OrderedMap)
    actions: u.default.object.isRequired,
    reordableNodesCnt: u.default.number,
    onDragStart: u.default.func,
    parentField: u.default.string,
    //from RuleGroup
    isDraggingTempo: u.default.bool,
    isParentLocked: u.default.bool
  }, e$;
}
var iN = {}, bre;
function b_d() {
  return bre || (bre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(pa), r = t(Wc), i = t(yr), a = t($r), s = t(ua()), c = t(wr), l = t(kr()), d = t(ir()), u = O(ve), _ = bz, p = yg(), f = Sr(), g = t(gz()), h = O(Rb()), b = t(nz()), v = t(di), $ = O(A7()), k = Na();
    function S(C) {
      if (typeof WeakMap != "function")
        return null;
      var P = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap();
      return (S = function(E) {
        return E ? x : P;
      })(C);
    }
    function O(C, P) {
      if (!P && C && C.__esModule)
        return C;
      if (C === null || n(C) !== "object" && typeof C != "function")
        return { default: C };
      var x = S(P);
      if (x && x.has(C))
        return x.get(C);
      var w = {}, E = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var T in C)
        if (T !== "default" && Object.prototype.hasOwnProperty.call(C, T)) {
          var z = E ? Object.getOwnPropertyDescriptor(C, T) : null;
          z && (z.get || z.set) ? Object.defineProperty(w, T, z) : w[T] = C[T];
        }
      return w.default = C, x && x.set(C, w), w;
    }
    function I(C) {
      var P = D();
      return function() {
        var w = (0, d.default)(C), E;
        if (P) {
          var T = (0, d.default)(this).constructor;
          E = Reflect.construct(w, arguments, T);
        } else
          E = w.apply(this, arguments);
        return (0, l.default)(this, E);
      };
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var M = function(P) {
      var x, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return x = /* @__PURE__ */ function(E) {
        (0, c.default)(z, E);
        var T = I(z);
        function z(j) {
          var q;
          return (0, i.default)(this, z), q = T.call(this, j), q._getEventTarget = function(V, F) {
            return V && V.__mocked_window || document.body || window;
          }, q.onDragStart = function(V, F, L) {
            var U = F.closest(".query-builder");
            document.body.classList.add("qb-dragging"), U.classList.add("qb-dragging");
            var W = U.closest(".query-builder-container") || U;
            W = q._getScrollParent(W) || document.body;
            var H = W.scrollTop;
            q._getDraggableNodeEl(U), q._getPlaceholderNodeEl(U);
            var Q = U.querySelectorAll(".group--children"), X = Q.length ? Q[0] : null, re;
            X && (re = window.getComputedStyle(X, null).getPropertyValue("padding-left"), re = parseInt(re));
            var Z = {
              id: V,
              x: F.offsetLeft,
              y: F.offsetTop,
              w: F.offsetWidth,
              h: F.offsetHeight,
              itemInfo: q.tree.items[V],
              paddingLeft: re
            }, ee = {
              id: V,
              x: F.offsetLeft,
              y: F.offsetTop,
              scrollTop: H,
              clientX: L.clientX,
              clientY: L.clientY,
              itemInfo: (0, b.default)(q.tree.items[V]),
              treeEl: U,
              treeElContainer: W
            }, J = {
              clientX: L.clientX,
              clientY: L.clientY
            }, oe = q._getEventTarget(L, ee);
            q.eventTarget = oe, oe.addEventListener("mousemove", q.onDrag), oe.addEventListener("mouseup", q.onDragEnd), q.props.setDragStart(ee, Z, J);
          }, q.onDrag = function(V) {
            var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, L = Object.assign({}, q.props.dragging), U = q.props.dragStart, W = L.paddingLeft, H = U.treeElContainer, Q = H.scrollTop;
            if (L.itemInfo = q.tree.items[L.id], !!L.itemInfo) {
              var X = {
                clientX: V.clientX,
                clientY: V.clientY
              }, re = {
                clientX: U.clientX,
                clientY: U.clientY
              };
              if (V.__mock_dom) {
                var Z = U.treeEl, ee = q._getDraggableNodeEl(Z), J = q._getPlaceholderNodeEl(Z);
                V.__mock_dom({
                  treeEl: Z,
                  dragEl: ee,
                  plhEl: J
                });
              }
              if (!U.plX) {
                var oe = U.treeEl, ce = q._getPlaceholderNodeEl(oe);
                ce && (U.plX = ce.getBoundingClientRect().left + window.scrollX, U.plY = ce.getBoundingClientRect().top + window.scrollY);
              }
              var de = U.x, te = U.y, ue = U.clientX, le = U.clientY, se = U.scrollTop, me = {
                x: de + (V.clientX - ue),
                y: te + (V.clientY - le) + (Q - se)
              };
              L.x = me.x, L.y = me.y, L.paddingLeft = W, L.mousePos = X, L.startMousePos = re, q.props.setDragProgress(X, L);
              var pe = F ? q.handleDrag(L, V, w) : !1;
              pe || V.preventDefault && V.preventDefault();
            }
          }, q.onDragEnd = function() {
            var V = q.props.dragStart.treeEl;
            q.props.setDragEnd(), V.classList.remove("qb-dragging"), document.body.classList.remove("qb-dragging"), q._cacheEls = {};
            var F = q.eventTarget || q._getEventTarget();
            F.removeEventListener("mousemove", q.onDrag), F.removeEventListener("mouseup", q.onDragEnd);
          }, (0, k.useOnPropsChanged)((0, s.default)(q)), q.onPropsChanged(j), q;
        }
        return (0, a.default)(z, [{
          key: "onPropsChanged",
          value: function(q) {
            this.tree = (0, p.getFlatTree)(q.tree);
          }
        }, {
          key: "shouldComponentUpdate",
          value: function(q, V) {
            var F = this.props, L = this.state, U = (0, k.pureShouldComponentUpdate)(this)(q, V);
            if (U && L == V && F != q) {
              var W = [];
              for (var H in q) {
                var Q = q[H] != F[H];
                Q && H != "dragging" && H != "mousePos" && W.push(H);
              }
              W.length || (U = !1);
            }
            return U;
          }
        }, {
          key: "componentDidUpdate",
          value: function(q, V) {
            var F = this.props.dragging, L = this.props.dragStart;
            if (L && L.id && (F.itemInfo = this.tree.items[F.id], F.itemInfo && (F.itemInfo.index != L.itemInfo.index || F.itemInfo.parent != L.itemInfo.parent))) {
              var U = L.treeEl, W = L.treeElContainer, H = this._getPlaceholderNodeEl(U, !0);
              if (H) {
                var Q = H.getBoundingClientRect().left + window.scrollX, X = H.getBoundingClientRect().top + window.scrollY, re = L.plX, Z = L.plY, ee = W.scrollTop;
                L.plX = Q, L.plY = X, L.itemInfo = (0, b.default)(F.itemInfo), L.y = H.offsetTop, L.x = H.offsetLeft, L.clientY += X - Z, L.clientX += Q - re, W != document.body && (L.scrollTop = ee), this.onDrag(this.props.mousePos, !1);
              }
            }
          }
        }, {
          key: "_getNodeElById",
          value: function(q, V) {
            var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (V == null)
              return null;
            this._cacheEls || (this._cacheEls = {});
            var L = this._cacheEls[V];
            return L && document.contains(L) && !F || (L = q.querySelector('.group-or-rule-container[data-id="' + V + '"]'), this._cacheEls[V] = L), L;
          }
        }, {
          key: "_getDraggableNodeEl",
          value: function(q) {
            var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            this._cacheEls || (this._cacheEls = {});
            var F = this._cacheEls.draggable;
            if (F && document.contains(F) && !V)
              return F;
            var L = q.getElementsByClassName("qb-draggable");
            return F = L.length ? L[0] : null, this._cacheEls.draggable = F, F;
          }
        }, {
          key: "_getPlaceholderNodeEl",
          value: function(q) {
            var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            this._cacheEls || (this._cacheEls = {});
            var F = this._cacheEls.placeholder;
            if (F && document.contains(F) && !V)
              return F;
            var L = q.getElementsByClassName("qb-placeholder");
            return F = L.length ? L[0] : null, this._cacheEls.placeholder = F, F;
          }
        }, {
          key: "_isScrollable",
          value: function(q) {
            var V = window.getComputedStyle(q)["overflow-y"];
            return (V === "scroll" || V === "auto") && q.scrollHeight > q.offsetHeight;
          }
        }, {
          key: "_getScrollParent",
          value: function(q) {
            return q == null ? null : q === document.body || this._isScrollable(q) ? q : this._getScrollParent(q.parentNode);
          }
        }, {
          key: "handleDrag",
          value: function(q, V, F) {
            var L = this, U = !0, W = q.itemInfo, H = q.paddingLeft, Q = null, X = this.props.dragStart.treeEl, re = q.id, Z = this._getDraggableNodeEl(X), ee = this._getPlaceholderNodeEl(X), J, oe, ce, de;
            if (Z && ee) {
              if (J = Z.getBoundingClientRect(), oe = ee.getBoundingClientRect(), !oe.width)
                return;
              var te = {
                hrz: 0,
                vrt: 0
              };
              J.top < oe.top ? te.vrt = -1 : J.bottom > oe.bottom && (te.vrt = 1), J.left > oe.left ? te.hrz = 1 : J.left < oe.left && (te.hrz = -1), de = X.getBoundingClientRect();
              var ue = {
                x: de.left + (de.right - de.left) / 2,
                y: te.vrt >= 0 ? J.bottom : J.top
              }, le;
              if (V.__mocked_hov_container)
                le = V.__mocked_hov_container;
              else {
                var se = document.elementFromPoint(ue.x, ue.y - 1);
                if (le = se ? se.closest(".group-or-rule-container") : null, !le && se && se.classList.contains("query-builder-container")) {
                  var me, pe = se == null || (me = se.firstChild) === null || me === void 0 ? void 0 : me.firstChild;
                  pe && pe.classList.contains("group-or-rule-container") && (le = pe);
                }
              }
              if (!le)
                f.logger.log("out of tree bounds!");
              else {
                var be = le.classList.contains("group-container"), Se = le.getAttribute("data-id"), Ae = le, Ze = !1, Ge = !1;
                if (Ae) {
                  ce = Ae.getBoundingClientRect();
                  var rt = ce.bottom - ce.top, qe = this.tree.items[Se], Xe = null, lt = null, Et = null, wt = null;
                  if (te.vrt == 0)
                    Et = W, lt = ee, lt && (Xe = lt.getBoundingClientRect());
                  else if (be) {
                    if (te.vrt > 0) {
                      var nn = le.getElementsByClassName("group--header"), Dt = nn.length ? nn[0] : null;
                      if (Dt) {
                        var mt = Dt.getBoundingClientRect(), bt = mt.bottom - mt.top, gn = J.bottom - mt.top > bt * 3 / 4;
                        gn && qe.top > q.itemInfo.top && (Et = qe, Xe = mt, lt = Dt, Ge = !0);
                      }
                    } else if (te.vrt < 0 && qe.lev >= W.lev) {
                      var an = ce.bottom - J.top >= 2;
                      an && qe.top < q.itemInfo.top && (Et = qe, Xe = ce, lt = Ae, Ze = !0);
                    }
                    if (!Ge && !Ze || U) {
                      var Mn = te.vrt < 0 ? ce.bottom - J.top > rt - 5 : J.bottom - ce.top > rt - 5;
                      Mn && (!Ge && !Ze && (Et = qe, Xe = ce, lt = Ae), wt = qe);
                    }
                  } else {
                    var Ln = te.vrt < 0 ? ce.bottom - J.top > rt / 2 : J.bottom - ce.top > rt / 2;
                    Ln && (Et = qe, Xe = ce, lt = Ae);
                  }
                  var un = Et && Et.id == re;
                  if (Xe) {
                    var qo = J.left - de.left;
                    Xe.left - de.left;
                    var cn = Math.max(0, Math.round(qo / H)), ln = [], kn = [];
                    if (!un) {
                      if (be && (Ze ? ln.push([h.PLACEMENT_APPEND, Et, Et.lev + 1]) : Ge && ln.push([h.PLACEMENT_PREPEND, Et, Et.lev + 1]), wt)) {
                        var gt = wt.lev == 0, Ot = wt.type == "case_group" && W.type != "case_group", _n = wt.prev && this.tree.items[wt.prev].caseId, wn = wt.next && this.tree.items[wt.next].caseId;
                        W.caseId == _n && (_n = null), W.caseId == wn && (wn = null);
                        var so = _n && this.tree.items[_n], rn = wn && this.tree.items[wn];
                        te.vrt > 0 ? gt ? kn.push([h.PLACEMENT_APPEND, wt, wt.lev + 1]) : Ot && rn ? kn.push([h.PLACEMENT_PREPEND, rn, rn.lev + 1]) : kn.push([h.PLACEMENT_AFTER, wt, wt.lev]) : te.vrt < 0 && (gt ? kn.push([h.PLACEMENT_PREPEND, wt, wt.lev + 1]) : Ot && so ? kn.push([h.PLACEMENT_APPEND, so, so.lev + 1]) : kn.push([h.PLACEMENT_BEFORE, wt, wt.lev]));
                      }
                      !Ze && !Ge && (te.vrt < 0 ? ln.push([h.PLACEMENT_BEFORE, Et, Et.lev]) : te.vrt > 0 && ln.push([h.PLACEMENT_AFTER, Et, Et.lev]));
                    }
                    var Ht = function(yt) {
                      var on = yt[1], Ut = W.caseId ? L.tree.items[W.caseId] : null, Nt = on.caseId ? L.tree.items[on.caseId] : null;
                      return [].concat((0, r.default)(yt), [Ut, Nt]);
                    };
                    ln = ln.map(Ht), kn = kn.map(Ht), ln = ln.filter(function(ft) {
                      var yt = ft[0], on = ft[1];
                      if ((yt == h.PLACEMENT_BEFORE || yt == h.PLACEMENT_AFTER) && on.parent == null || on.collapsed && (yt == h.PLACEMENT_APPEND || yt == h.PLACEMENT_PREPEND))
                        return !1;
                      var Ut = on.id == W.id;
                      if (!Ut) {
                        for (var Nt = on; Nt.parent; )
                          if (Nt = L.tree.items[Nt.parent], Nt.id == W.id) {
                            Ut = !0;
                            break;
                          }
                      }
                      return !Ut;
                    }).map(function(ft) {
                      var yt = ft[0], on = ft[1];
                      ft[2], ft[3], ft[4];
                      var Ut = null;
                      return yt == h.PLACEMENT_APPEND || yt == h.PLACEMENT_PREPEND ? Ut = on : Ut = L.tree.items[on.parent], Ut && Ut.parent == null && (Ut = null), ft[5] = Ut, ft;
                    });
                    var qn = null, Bn = ln.filter(function(ft) {
                      return L.canMove(W, ft[1], ft[0], ft[3], ft[4], ft[5], F);
                    });
                    Bn.length == 0 && kn.length > 0 && (Bn = kn.filter(function(ft) {
                      return L.canMove(W, ft[1], ft[0], ft[3], ft[4], ft[5], F);
                    }));
                    var Or = Bn.map(function(ft) {
                      return ft[2];
                    }), oo = W.lev, Zn = Or.concat(oo), st = null;
                    Zn.indexOf(cn) != -1 ? st = cn : cn > Math.max.apply(Math, (0, r.default)(Zn)) ? st = Math.max.apply(Math, (0, r.default)(Zn)) : cn < Math.min.apply(Math, (0, r.default)(Zn)) && (st = Math.min.apply(Math, (0, r.default)(Zn))), qn = Bn.find(function(ft) {
                      return ft[2] == st;
                    }), !un && !qn && Bn.length && (qn = Bn[0]), Q = qn;
                  }
                }
              }
            }
            return Q ? (this.move(W, Q[1], Q[0], Q[3]), !0) : !1;
          }
        }, {
          key: "canMove",
          value: function(q, V, F, L, U, W, H) {
            if (!q || !V || q.id === V.id)
              return !1;
            var Q = this.props.config.settings, X = Q.canRegroup, re = Q.canRegroupCases, Z = Q.maxNesting, ee = Q.maxNumberOfRules, J = Q.canLeaveEmptyCase, oe = W ? W.lev + 1 : V.lev, ce = F == h.PLACEMENT_BEFORE || F == h.PLACEMENT_AFTER, de = F == h.PLACEMENT_PREPEND || F == h.PLACEMENT_APPEND, te = ce && V.lev == 1 || de && V.lev == 0, ue = q.parent != V.parent, le = de || ue, se = q.type == "case_group" && !te || q.parentType == "rule_group" || V.type == "rule_group" || V.parentType == "rule_group" || q.type != "case_group" && V.type == "case_group" && ce || q.type != "case_group" && V.type == "switch_group" || !re && q.caseId != V.caseId, me = V.isLocked || q.isLocked || W && W.isLocked;
            if (Z && oe > Z || le && (!X || se || me))
              return !1;
            if (q.type != "case_group" && q.caseId != V.caseId) {
              var pe = L ? L._height == 2 : !1, be = U ? U.leafsCount + 1 : 0;
              if (ee && be > ee || pe && !J)
                return !1;
            }
            if (q.type == "case_group" && (q.isDefaultCase || V.isDefaultCase || V.type == "switch_group" && F == h.PLACEMENT_APPEND))
              return !1;
            var Se = !0;
            return H && (Se = H(q.node.toJS(), V.node.toJS(), F, W ? W.node.toJS() : null)), Se;
          }
        }, {
          key: "move",
          value: function(q, V, F, L) {
            this.props.actions.moveItem(q.path, V.path, F);
          }
        }, {
          key: "render",
          value: function() {
            return /* @__PURE__ */ u.default.createElement(P, (0, o.default)({}, this.props, {
              onDragStart: this.onDragStart
            }));
          }
        }]), z;
      }(u.Component), x.propTypes = {
        tree: v.default.any.isRequired,
        //instanceOf(Immutable.Map)
        actions: v.default.object.isRequired
        // {moveItem: Function, ..}
        //... see Builder
      }, x;
    }, N = function(P) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, w = (0, _.connect)(function(E) {
        return {
          dragging: E.dragging,
          dragStart: E.dragStart,
          mousePos: E.mousePos
        };
      }, {
        setDragStart: $.drag.setDragStart,
        setDragProgress: $.drag.setDragProgress,
        setDragEnd: $.drag.setDragEnd
      }, null, {
        context: g.default
      })(M(P, x));
      return w.displayName = "ConnectedSortableContainer", w;
    };
    e.default = N;
  }(iN)), iN;
}
var yre;
function y_d() {
  return yre || (yre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(yr), r = t($r), i = t(wr), a = t(kr()), s = t(ir()), c = v(ve), l = t(di), d = v(Ra()), u = r1e(), _ = t(b_d()), p = yg();
    t(_m());
    var f = Na(), g, h;
    function b(O) {
      if (typeof WeakMap != "function")
        return null;
      var I = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
      return (b = function(N) {
        return N ? D : I;
      })(O);
    }
    function v(O, I) {
      if (!I && O && O.__esModule)
        return O;
      if (O === null || n(O) !== "object" && typeof O != "function")
        return { default: O };
      var D = b(I);
      if (D && D.has(O))
        return D.get(O);
      var M = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var C in O)
        if (C !== "default" && Object.prototype.hasOwnProperty.call(O, C)) {
          var P = N ? Object.getOwnPropertyDescriptor(O, C) : null;
          P && (P.get || P.set) ? Object.defineProperty(M, C, P) : M[C] = O[C];
        }
      return M.default = O, D && D.set(O, M), M;
    }
    function $(O) {
      var I = k();
      return function() {
        var M = (0, s.default)(O), N;
        if (I) {
          var C = (0, s.default)(this).constructor;
          N = Reflect.construct(M, arguments, C);
        } else
          N = M.apply(this, arguments);
        return (0, a.default)(this, N);
      };
    }
    function k() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var S = (0, _.default)(g = (h = /* @__PURE__ */ function(O) {
      (0, i.default)(D, O);
      var I = $(D);
      function D(M) {
        var N;
        return (0, o.default)(this, D), N = I.call(this, M), N._updPath(M), N;
      }
      return (0, r.default)(D, [{
        key: "shouldComponentUpdate",
        value: function(N, C) {
          var P = this.props, x = (0, f.pureShouldComponentUpdate)(this)(N, C);
          if (x) {
            var w = [];
            for (var E in N) {
              var T = N[E] !== P[E];
              T && E != "__isInternalValueChange" && w.push(E);
            }
            w.length || (x = !1), w.length == 1 && w[0] == "tree" && N.__isInternalValueChange && (x = !1);
          }
          return x;
        }
      }, {
        key: "_updPath",
        value: function(N) {
          var C = N.tree.get("id");
          this.path = d.default.List.of(C);
        }
      }, {
        key: "render",
        value: function() {
          var N = this.props.tree, C = N.get("type"), P = C == "switch_group", x = P ? null : (0, p.getTotalReordableNodesCountInTree)(N), w = P ? null : (0, p.getTotalRulesCountInTree)(N), E = N.get("id");
          return /* @__PURE__ */ c.default.createElement(u.Item, {
            key: E,
            id: E,
            path: this.path,
            type: C,
            properties: N.get("properties") || new d.Map(),
            config: this.props.config,
            actions: this.props.actions,
            children1: N.get("children1") || new d.Map(),
            reordableNodesCnt: x,
            totalRulesCnt: w,
            parentReordableNodesCnt: 0,
            onDragStart: this.props.onDragStart
          });
        }
      }]), D;
    }(c.Component), h.propTypes = {
      tree: l.default.any.isRequired,
      //instanceOf(Immutable.Map)
      config: l.default.object.isRequired,
      actions: l.default.object.isRequired,
      onDragStart: l.default.func
    }, h)) || g;
    e.default = S;
  }(LR)), LR;
}
var aN = {}, i$ = {}, $re;
function $_d() {
  if ($re)
    return i$;
  $re = 1;
  var e = Rt;
  Object.defineProperty(i$, "__esModule", {
    value: !0
  }), i$.queryBuilderFormat = void 0;
  var t = e(rr), n = Sr(), o = Br(), r = Ns(), i = Hi();
  wg();
  var a = Ra();
  function s(p, f) {
    var g = Object.keys(p);
    if (Object.getOwnPropertySymbols) {
      var h = Object.getOwnPropertySymbols(p);
      f && (h = h.filter(function(b) {
        return Object.getOwnPropertyDescriptor(p, b).enumerable;
      })), g.push.apply(g, h);
    }
    return g;
  }
  function c(p) {
    for (var f = 1; f < arguments.length; f++) {
      var g = arguments[f] != null ? arguments[f] : {};
      f % 2 ? s(Object(g), !0).forEach(function(h) {
        (0, t.default)(p, h, g[h]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(p, Object.getOwnPropertyDescriptors(g)) : s(Object(g)).forEach(function(h) {
        Object.defineProperty(p, h, Object.getOwnPropertyDescriptor(g, h));
      });
    }
    return p;
  }
  var l = function(f, g) {
    var h = {
      usedFields: []
    }, b = d(f, g, h);
    if (b)
      return c(c({}, b), h);
  };
  i$.queryBuilderFormat = l;
  var d = function(f, g, h) {
    if (f) {
      var b = f.get("type"), v = f.get("children1");
      if ((b === "group" || b === "rule_group") && v && v.size)
        return u(f, g, h);
      if (b === "rule")
        return _(f, g, h);
    }
  }, u = function(f, g, h) {
    var b = f.get("properties") || new a.Map(), v = f.get("children1"), $ = f.get("id"), k = v.map(function(D) {
      return d(D, g, h);
    }).filter(function(D) {
      return typeof D < "u";
    });
    if (k.size) {
      var S = b.get("conjunction");
      S || (S = (0, r.defaultConjunction)(g));
      var O = b.get("not"), I = {
        id: $,
        rules: k.toList(),
        condition: S.toUpperCase(),
        not: O
      };
      return I;
    }
  }, _ = function(f, g, h) {
    var b = f.get("properties") || new a.Map(), v = f.get("id"), $ = b.get("operator"), k = b.get("operatorOptions"), S = b.get("field"), O = b.get("value"), I = b.get("valueSrc"), D = b.get("valueType"), M = O.filter(function(L) {
      return L === void 0;
    }).size > 0;
    if (!(S == null || $ == null || M)) {
      var N = (0, o.getFieldConfig)(g, S) || {}, C = (0, o.getOperatorConfig)(g, $, S) || {}, P = N.type || "undefined", x = (0, n.defaultValue)(C.cardinality, 1), w = g.types[N.type] || {}, E = (0, i.formatFieldName)(S, g, h);
      if (!(O.size < x)) {
        h.usedFields.indexOf(S) == -1 && h.usedFields.push(S), O = O.toArray(), I = I.toArray(), D = D.toArray();
        for (var T = [], z = 0; z < O.length; z++) {
          var j = {
            type: D[z],
            value: O[z]
          };
          if (T.push(j), I[z] == "field") {
            var q = O[z];
            h.usedFields.indexOf(q) == -1 && h.usedFields.push(q);
          }
        }
        var V = k ? k.toJS() : null;
        V && !Object.keys(V).length && (V = null);
        var F = {
          id: v,
          fieldName: E,
          type: P,
          input: w.mainWidget,
          operator: $
        };
        return V && (F.operatorOptions = V), F.values = T, F;
      }
    }
  };
  return i$;
}
var a$ = {}, sN = { exports: {} }, cN = { exports: {} }, wre;
function w_d() {
  return wre || (wre = 1, function(e) {
    function t(n) {
      if (Array.isArray(n))
        return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(cN)), cN.exports;
}
var lN = { exports: {} }, kre;
function k_d() {
  return kre || (kre = 1, function(e) {
    function t(n) {
      if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
        return Array.from(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(lN)), lN.exports;
}
var dN = { exports: {} }, uN = { exports: {} }, Sre;
function S_d() {
  return Sre || (Sre = 1, function(e) {
    function t(n, o) {
      (o == null || o > n.length) && (o = n.length);
      for (var r = 0, i = new Array(o); r < o; r++)
        i[r] = n[r];
      return i;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(uN)), uN.exports;
}
var xre;
function x_d() {
  return xre || (xre = 1, function(e) {
    var t = S_d();
    function n(o, r) {
      if (o) {
        if (typeof o == "string")
          return t(o, r);
        var i = Object.prototype.toString.call(o).slice(8, -1);
        if (i === "Object" && o.constructor && (i = o.constructor.name), i === "Map" || i === "Set")
          return Array.from(o);
        if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
          return t(o, r);
      }
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(dN)), dN.exports;
}
var _N = { exports: {} }, Ere;
function E_d() {
  return Ere || (Ere = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_N)), _N.exports;
}
var Tre;
function O7() {
  return Tre || (Tre = 1, function(e) {
    var t = w_d(), n = k_d(), o = x_d(), r = E_d();
    function i(a) {
      return t(a) || n(a) || o(a) || r();
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(sN)), sN.exports;
}
var Are;
function T_d() {
  if (Are)
    return a$;
  Are = 1;
  var e = Rt;
  Object.defineProperty(a$, "__esModule", {
    value: !0
  }), a$.jsonLogicFormat = void 0;
  var t = e(Wc), n = e(O7()), o = e(rr), r = Sr(), i = Br(), a = Hi(), s = Ns(), c = wg(), l = Ra(), d = e(F_()), u = e($g());
  function _(C, P) {
    var x = Object.keys(C);
    if (Object.getOwnPropertySymbols) {
      var w = Object.getOwnPropertySymbols(C);
      P && (w = w.filter(function(E) {
        return Object.getOwnPropertyDescriptor(C, E).enumerable;
      })), x.push.apply(x, w);
    }
    return x;
  }
  function p(C) {
    for (var P = 1; P < arguments.length; P++) {
      var x = arguments[P] != null ? arguments[P] : {};
      P % 2 ? _(Object(x), !0).forEach(function(w) {
        (0, o.default)(C, w, x[w]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(x)) : _(Object(x)).forEach(function(w) {
        Object.defineProperty(C, w, Object.getOwnPropertyDescriptor(x, w));
      });
    }
    return C;
  }
  function f(C, P) {
    var x = typeof Symbol < "u" && C[Symbol.iterator] || C["@@iterator"];
    if (!x) {
      if (Array.isArray(C) || (x = g(C)) || P && C && typeof C.length == "number") {
        x && (C = x);
        var w = 0, E = function() {
        };
        return { s: E, n: function() {
          return w >= C.length ? { done: !0 } : { done: !1, value: C[w++] };
        }, e: function(V) {
          throw V;
        }, f: E };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var T = !0, z = !1, j;
    return { s: function() {
      x = x.call(C);
    }, n: function() {
      var V = x.next();
      return T = V.done, V;
    }, e: function(V) {
      z = !0, j = V;
    }, f: function() {
      try {
        !T && x.return != null && x.return();
      } finally {
        if (z)
          throw j;
      }
    } };
  }
  function g(C, P) {
    if (C) {
      if (typeof C == "string")
        return h(C, P);
      var x = Object.prototype.toString.call(C).slice(8, -1);
      if (x === "Object" && C.constructor && (x = C.constructor.name), x === "Map" || x === "Set")
        return Array.from(C);
      if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x))
        return h(C, P);
    }
  }
  function h(C, P) {
    (P == null || P > C.length) && (P = C.length);
    for (var x = 0, w = new Array(P); x < P; x++)
      w[x] = C[x];
    return w;
  }
  var b = function(P, x) {
    var w = {
      usedFields: [],
      errors: []
    }, E = v(P, x, w, !0), T = w.errors, z = w.usedFields, j = x.settings.fieldSeparator, q = {}, V = f(z), F;
    try {
      for (V.s(); !(F = V.n()).done; )
        for (var L = F.value, U = (0, i.getFieldConfig)(x, L) || {}, W = L.split(j), H = q, Q = 0; Q < W.length; Q++) {
          var X = W[Q], re = (0, i.getFieldConfig)(x, W.slice(0, Q + 1)) || {};
          Q != W.length - 1 ? re.type == "!group" && re.mode != "struct" ? (H[X] || (H[X] = [{}]), H = H[X][0]) : (H[X] || (H[X] = {}), H = H[X]) : H[X] || (H[X] = null);
        }
    } catch (Z) {
      V.e(Z);
    } finally {
      V.f();
    }
    return {
      errors: T,
      logic: E,
      data: q
    };
  };
  a$.jsonLogicFormat = b;
  var v = function(P, x, w, E) {
    var T = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (P) {
      var z = P.get("type"), j = P.get("properties") || new l.Map(), q = j.get("isLocked"), V = x.settings.jsonLogic.lockedOp, F;
      return z === "group" || z === "rule_group" ? F = $(P, x, w, E, T) : z === "rule" && (F = k(P, x, w, T)), q && F && V && (F = (0, o.default)({}, V, F)), F;
    }
  }, $ = function(P, x, w, E) {
    var T = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, z = P.get("type"), j = P.get("properties") || new l.Map(), q = j.get("mode"), V = P.get("children1"), F = j.get("field");
    if (V) {
      var L = j.get("conjunction");
      L || (L = (0, s.defaultConjunction)(x));
      var U = x.conjunctions[L], W = U.jsonLogicConj || L.toLowerCase(), H = j.get("not");
      if (W != "and" && W != "or") {
        w.errors.push("Conjunction ".concat(W, " is not supported"));
        return;
      }
      var Q = z === "rule_group" && !E, X = Q && q != "struct" ? F : T, re = j.get("operator"), Z = re && (0, i.getOperatorConfig)(x, re, F) || null, ee = S(x, j, w, re, T), J = Q && (!re || Z.cardinality == 0), oe = V.map(function(se) {
        return v(se, x, w, !1, X);
      }).filter(function(se) {
        return typeof se < "u";
      });
      if (Q && q != "struct" && !J) {
        if (ee == null)
          return;
      } else if (!oe.size)
        return;
      var ce = {};
      if (oe.size == 1 && !E ? ce = oe.first() : ce[W] = oe.toList().toJS(), H && (ce = {
        "!": ce
      }), Q && q != "struct") {
        var de = D(w, x, F, T);
        if (J) {
          var te = re || "some";
          ce = (0, o.default)({}, te, [de, ce]);
        } else {
          var ue = oe.size ? {
            filter: [de, ce]
          } : de, le = {
            reduce: [ue, {
              "+": [1, {
                var: "accumulator"
              }]
            }, 0]
          };
          ce = N(x, j, le, ee, re);
        }
      }
      return ce;
    }
  }, k = function(P, x, w) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, T = P.get("properties") || new l.Map(), z = T.get("field"), j = T.get("operator"), q = T.get("operatorOptions");
    if (q = q ? q.toJS() : null, q && !Object.keys(q).length && (q = null), !(z == null || j == null)) {
      var V = (0, i.getFieldConfig)(x, z) || {}, F = (0, i.getOperatorConfig)(x, j, z) || {}, L = F.reversedOp, U = (0, i.getOperatorConfig)(x, L, z) || {}, W = !1;
      if (!F.jsonLogic && !U.jsonLogic) {
        w.errors.push("Operator ".concat(j, " is not supported"));
        return;
      }
      if (!F.jsonLogic && U.jsonLogic) {
        W = !0;
        var H = [L, j];
        j = H[0], L = H[1];
        var Q = [U, F];
        F = Q[0], U = Q[1];
      }
      var X = S(x, T, w, j, E);
      if (X !== void 0) {
        var re = D(w, x, z, E);
        return N(x, T, re, X, j, q, V, W);
      }
    }
  }, S = function(P, x, w, E, T) {
    var z = x.get("field"), j = x.get("valueSrc"), q = x.get("valueType"), V = (0, i.getFieldConfig)(P, z) || {}, F = (0, i.getOperatorConfig)(P, E, z) || {}, L = (0, r.defaultValue)(F.cardinality, 1), U = x.get("value"), W = x.get("asyncListValues");
    if (U != null) {
      var H = w.usedFields, Q = U.map(function(re, Z) {
        var ee = j ? j.get(Z) : null, J = q ? q.get(Z) : null, oe = (0, c.completeValue)(re, ee, P), ce = (0, a.getWidgetForFieldOp)(P, z, E, ee), de = (0, d.default)((0, i.getFieldWidgetConfig)(P, z, E, ce, ee), ["factory"]), te = O(w, P, oe, ee, J, de, V, E, F, T, W);
        return te;
      }), X = Q.filter(function(re) {
        return re === void 0;
      }).size > 0;
      if (Q.size < L || X) {
        w.usedFields = H;
        return;
      }
      return L > 1 ? Q.toArray() : L == 1 ? Q.first() : null;
    }
  }, O = function(P, x, w, E, T, z, j, q, V) {
    var F = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, L = arguments.length > 10 ? arguments[10] : void 0;
    if (w !== void 0) {
      var U;
      if (E == "field")
        U = D(P, x, w, F);
      else if (E == "func")
        U = I(P, x, w, F);
      else if (typeof z.jsonLogic == "function") {
        var W = z.jsonLogic, H = [
          w,
          p(p({}, (0, u.default)(j, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: L
          }),
          //useful options: valueFormat for date/time
          (0, d.default)(z, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        q && (H.push(q), H.push(V)), U = W.apply(void 0, H);
      } else
        U = w;
      return U;
    }
  }, I = function(P, x, w) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, T = w.get("func"), z = w.get("args"), j = (0, i.getFuncConfig)(x, T);
    if (!j.jsonLogic) {
      P.errors.push("Func ".concat(T, " is not supported"));
      return;
    }
    var q = {};
    for (var V in j.args) {
      var F = j.args[V], L = (0, i.getFieldConfig)(x, F), U = z ? z.get(V) : void 0, W = U ? U.get("value") : void 0, H = U ? U.get("valueSrc") : void 0, Q = O(P, x, W, H, F.type, L, F, null, null, E);
      if (W != null && Q === void 0) {
        P.errors.push("Can't format value of arg ".concat(V, " for func ").concat(T));
        return;
      }
      Q !== void 0 && (q[V] = Q);
    }
    var X = Object.values(q), re;
    if (typeof j.jsonLogic == "function") {
      var Z = j.jsonLogic, ee = [q];
      re = Z.apply(void 0, ee);
    } else {
      var J = j.jsonLogic || T, oe = !!j.jsonLogicIsMethod;
      if (oe) {
        var ce = (0, n.default)(X), de = ce[0], te = ce.slice(1);
        te.length ? re = {
          method: [de, J, te]
        } : re = {
          method: [de, J]
        };
      } else
        re = (0, o.default)({}, J, X);
    }
    return re;
  }, D = function(P, x, w) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, T = x.settings, z = T.fieldSeparator, j = T.jsonLogic, q;
    if (w) {
      Array.isArray(w) && (w = w.join(z));
      var V = (0, i.getFieldConfig)(x, w) || {}, F = w;
      if (V.fieldName && (F = V.fieldName), E) {
        var L = (0, i.getFieldConfig)(x, E) || {}, U = E;
        L.fieldName && (U = L.fieldName), F.indexOf(U + z) == 0 ? F = F.slice((U + z).length) : P.errors.push("Can't cut group ".concat(U, " from field ").concat(F));
      }
      var W = V.jsonLogicVar || (V.type == "!group" ? j.groupVarKey : "var");
      q = (0, o.default)({}, W, F), P.usedFields.indexOf(w) == -1 && P.usedFields.push(w);
    }
    return q;
  }, M = function(P, x, w, E) {
    var T = P, z = (0, r.defaultValue)(x.cardinality, 1), j = (0, r.defaultValue)(x._jsonLogicIsRevArgs, !1);
    typeof x.jsonLogic == "string" && (T = x.jsonLogic);
    var q = ["<", "<=", ">", ">="], V = ["==", "!="], F = function(U, W, H, Q, X) {
      return z == 0 && V.includes(T) ? (0, o.default)({}, T, [w, null]) : z == 0 ? (0, o.default)({}, T, w) : z == 1 && j ? (0, o.default)({}, T, [E, w]) : z == 1 ? (0, o.default)({}, T, [w, E]) : z == 2 && q.includes(T) ? (0, o.default)({}, T, [E[0], w, E[1]]) : (0, o.default)({}, T, [w].concat((0, t.default)(E)));
    };
    return F;
  }, N = function(P, x, w, E, T) {
    var z = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, j = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, q = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : !1, V = x.get("field"), F = (0, i.getOperatorConfig)(P, T, V) || {}, L = typeof F.jsonLogic == "function" ? F.jsonLogic : M(T, F, w, E), U = [w, T, E, (0, d.default)(F, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), z, j], W = L.apply(void 0, U);
    return q && (W = {
      "!": W
    }), W;
  };
  return a$;
}
var Lm = {}, Cre;
function A_d() {
  if (Cre)
    return Lm;
  Cre = 1;
  var e = Rt;
  Object.defineProperty(Lm, "__esModule", {
    value: !0
  }), Lm.mongodbFormat = Lm._mongodbFormat = void 0;
  var t = e(Tl), n = e(rr), o = e(Wc), r = e(Yn), i = Sr(), a = Br(), s = Hi(), c = Ns(), l = wg(), d = e(F_()), u = e($g()), _ = Ra(), p = Ib();
  function f(N, C) {
    var P = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(N);
      C && (x = x.filter(function(w) {
        return Object.getOwnPropertyDescriptor(N, w).enumerable;
      })), P.push.apply(P, x);
    }
    return P;
  }
  function g(N) {
    for (var C = 1; C < arguments.length; C++) {
      var P = arguments[C] != null ? arguments[C] : {};
      C % 2 ? f(Object(P), !0).forEach(function(x) {
        (0, n.default)(N, x, P[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(P)) : f(Object(P)).forEach(function(x) {
        Object.defineProperty(N, x, Object.getOwnPropertyDescriptor(P, x));
      });
    }
    return N;
  }
  var h = function(C) {
    return (0, r.default)(C) == "object" && C !== null && !Array.isArray(C);
  }, b = function(C, P) {
    return v(C, P, !1);
  };
  Lm.mongodbFormat = b;
  var v = function(C, P) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, w = {
      errors: []
    }, E = $([], C, P, w);
    return x ? [E, w.errors] : (w.errors.length && console.warn("Errors while exporting to MongoDb:", w.errors), E);
  };
  Lm._mongodbFormat = v;
  var $ = function(C, P, x, w) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, T = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, z = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : void 0, j = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : void 0;
    if (P) {
      var q = P.get("type");
      if (q === "group" || q === "rule_group")
        return k(C, P, x, w, E, T, z, j);
      if (q === "rule")
        return S(C, P, x, w, E, T, z, j);
    }
  }, k = function(C, P, x, w) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, T = P.get("type"), z = P.get("properties") || new _.Map(), j = P.get("children1"), q = x.settings.canShortMongoQuery;
    if (j) {
      var V = C.filter(function(me) {
        return me.get("type") == "rule_group";
      }).length > 0, F = C.filter(function(me) {
        return me.get("type") == "rule_group";
      }).map(function(me) {
        return me.get("properties").get("field");
      }).slice(-1).pop(), L = V && F, U = T === "rule_group" ? z.get("field") : null, W = I(U, x, w, L), H = (0, a.getFieldConfig)(x, U) || {}, Q = H.mode, X = U && Q == "array", re = E ? !z.get("not") : z.get("not"), Z = j.map(function(me) {
        return $([].concat((0, o.default)(C), [P]), me, x, w, re, !0, Q == "array" ? function(pe) {
          return "$$el.".concat(pe);
        } : void 0);
      }).filter(function(me) {
        return typeof me < "u";
      });
      if (!(!X && !Z.size)) {
        var ee = z.get("conjunction");
        ee || (ee = (0, c.defaultConjunction)(x));
        var J = x.conjunctions[ee], oe = J.reversedConj;
        re && oe && (ee = oe, J = x.conjunctions[ee]);
        var ce = J.mongoConj, de;
        if (Z.size == 1)
          de = Z.first();
        else if (Z.size > 1) {
          var te = Z.toList().toJS(), ue = q && ce == "$and";
          ue && (de = te.reduce(function(me, pe) {
            if (me) {
              for (var be in pe) {
                if (be[0] == "$") {
                  me = void 0;
                  break;
                }
                if (me[be] == null)
                  me[be] = pe[be];
                else {
                  var Se = me[be], Ae = pe[be];
                  h(Se) || (Se = {
                    $eq: Se
                  }), h(Ae) || (Ae = {
                    $eq: Ae
                  });
                  var Ze = Object.keys(Se)[0], Ge = Object.keys(Ae)[0];
                  if (Ze == Ge) {
                    me = void 0;
                    break;
                  }
                  me[be] = Object.assign({}, Se, Ae);
                }
              }
              return me;
            }
          }, {})), de || (de = (0, n.default)({}, ce, te));
        }
        if (U)
          if (Q == "array") {
            var le = {
              $size: W
            }, se = de ? {
              $size: {
                $filter: {
                  input: "$" + W,
                  as: "el",
                  cond: de
                }
              }
            } : le;
            de = $(C, P.set("type", "rule"), x, w, !1, !1, function(me) {
              return se;
            }, le), de = {
              $expr: de
            };
          } else
            de = (0, n.default)({}, W, {
              $elemMatch: de
            });
        return de;
      }
    }
  }, S = function(C, P, x, w) {
    var E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, T = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, z = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : void 0, j = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : void 0, q = P.get("properties") || new _.Map(), V = C.filter(function(lt) {
      return lt.get("type") == "rule_group";
    }).length > 0, F = C.filter(function(lt) {
      return lt.get("type") == "rule_group";
    }).map(function(lt) {
      return lt.get("properties").get("field");
    }).slice(-1).pop(), L = V && F, U = q.get("operator"), W = q.get("operatorOptions"), H = q.get("field"), Q = q.get("value"), X = q.get("valueSrc"), re = q.get("valueType"), Z = q.get("asyncListValues");
    if (!(H == null || U == null || Q === void 0)) {
      var ee = (0, a.getFieldConfig)(x, H) || {}, J = (0, a.getOperatorConfig)(x, U, H) || {}, oe = J.reversedOp, ce = (0, a.getOperatorConfig)(x, oe, H) || {}, de = (0, i.defaultValue)(J.cardinality, 1), te = E;
      if (te && oe) {
        var ue = [oe, U];
        U = ue[0], oe = ue[1];
        var le = [ce, J];
        J = le[0], ce = le[1], te = !1;
      }
      var se = I(H, x, w, L), me = [], pe = [], be = !1, Se = Q.map(function(lt, Et) {
        var wt = X ? X.get(Et) : null, nn = re ? re.get(Et) : null, Dt = (0, l.completeValue)(lt, wt, x), mt = (0, s.getWidgetForFieldOp)(x, H, U, wt), bt = (0, d.default)((0, a.getFieldWidgetConfig)(x, H, U, mt, wt), ["factory"]), gn = O(w, x, Dt, wt, nn, bt, ee, L, U, J, Z), an = (0, t.default)(gn, 2), Mn = an[0], Ln = an[1];
        return Mn !== void 0 && (be = be || Ln, me.push(wt), pe.push(nn)), Mn;
      });
      z && (be = !0);
      var Ae = be && T, Ze = Se.filter(function(lt) {
        return lt === void 0;
      }).size > 0;
      if (!(Se.size < de || Ze)) {
        var Ge = de > 1 ? Se.toArray() : de == 1 ? Se.first() : null, rt = J.mongoFormatOp;
        if (!rt) {
          w.errors.push("Operator ".concat(U, " is not supported"));
          return;
        }
        var qe = [z ? z(se) : se, U, j !== void 0 && Ge == null ? j : Ge, be, me.length > 1 ? me : me[0], pe.length > 1 ? pe : pe[0], (0, d.default)(J, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), W, ee], Xe = rt.apply(void 0, qe);
        return Ae && (Xe = {
          $expr: Xe
        }), te && (Xe = {
          $not: Xe
        }), Xe;
      }
    }
  }, O = function(C, P, x, w, E, T, z, j, q, V, F) {
    if (x === void 0)
      return [void 0, !1];
    var L, U = !1;
    if (w == "field") {
      var W = D(C, P, x, j), H = (0, t.default)(W, 2);
      L = H[0], U = H[1];
    } else if (w == "func") {
      var Q = M(C, P, x, j), X = (0, t.default)(Q, 2);
      L = X[0], U = X[1];
    } else if (typeof T.mongoFormatValue == "function") {
      var re = T.mongoFormatValue, Z = [
        x,
        g(g({}, (0, u.default)(z, ["fieldSettings", "listValues"])), {}, {
          asyncListValues: F
        }),
        //useful options: valueFormat for date/time
        (0, d.default)(T, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
      ];
      q && (Z.push(q), Z.push(V)), L = re.apply(void 0, Z);
    } else
      L = x;
    return [L, U];
  }, I = function(C, P, x, w) {
    if (C) {
      var E = (0, a.getFieldConfig)(P, C) || {}, T = P.settings.fieldSeparator;
      Array.isArray(C) || C.split(T);
      var z = Array.isArray(C) ? C.join(T) : C;
      if (E.fieldName && (z = E.fieldName), w) {
        var j = (0, a.getFieldConfig)(P, w) || {}, q = w;
        j.fieldName && (q = j.fieldName), z.indexOf(q + ".") == 0 ? z = z.slice((q + ".").length) : x.errors.push("Can't cut group ".concat(q, " from field ").concat(z));
      }
      return z;
    }
  }, D = function(C, P, x, w) {
    var E = P.settings.fieldSeparator, T, z = !0;
    if (x) {
      var j = (0, a.getFieldConfig)(P, x) || {}, q = Array.isArray(x) ? x : x.split(E);
      (0, s.getFieldPath)(x, P);
      var V = (0, s.getFieldPathLabels)(x, P), F = V ? V.join(E) : null, L = P.settings.formatField || p.settings.formatField, U = I(x, P, C, w), W = L(U, q, F, j, P, !1);
      T = "$" + W;
    }
    return [T, z];
  }, M = function(C, P, x, w) {
    var E = !0, T, z = x.get("func"), j = x.get("args"), q = (0, a.getFuncConfig)(P, z), V = q.mongoFunc || z, F = q.mongoArgsAsObject, L = {}, U = 0, W = void 0;
    for (var H in q.args) {
      var Q = q.args[H], X = (0, a.getFieldConfig)(P, Q), re = j ? j.get(H) : void 0, Z = re ? re.get("value") : void 0, ee = re ? re.get("valueSrc") : void 0, J = re ? re.get("asyncListValues") : void 0, oe = (0, s.getWidgetForFieldOp)(P, X, null, ee), ce = (0, d.default)((0, a.getFieldWidgetConfig)(P, X, null, oe, ee), ["factory"]), de = O(C, P, Z, ee, Q.type, ce, X, w, null, null, J), te = (0, t.default)(de, 2), ue = te[0];
      if (te[1], Z != null && ue === void 0)
        return C.errors.push("Can't format value of arg ".concat(H, " for func ").concat(z)), [void 0, !1];
      U++, ue !== void 0 && (L[H] = ue, W = ue);
    }
    if (typeof q.mongoFormatFunc == "function") {
      var le = q.mongoFormatFunc, se = [L];
      T = le.apply(void 0, se);
    } else {
      if (q.mongoFormatFunc === null)
        return C.errors.push("Functon ".concat(V, " is not supported")), [void 0, !1];
      F ? T = (0, n.default)({}, V, L) : U == 1 && W !== void 0 ? T = (0, n.default)({}, V, W) : T = (0, n.default)({}, V, Object.values(L));
    }
    return [T, E];
  };
  return Lm;
}
var qm = {}, va = {}, pN = {}, zre;
function C_d() {
  return zre || (zre = 1, function(e) {
    var t = e, n = /`/g, o = /\./g, r = /[\0\b\t\n\r\x1a\"\'\\]/g, i = {
      "\0": "\\0",
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\r": "\\r",
      "": "\\Z",
      '"': '\\"',
      "'": "\\'",
      "\\": "\\\\"
    };
    t.escapeId = function(d, u) {
      if (Array.isArray(d)) {
        for (var _ = "", p = 0; p < d.length; p++)
          _ += (p === 0 ? "" : ", ") + t.escapeId(d[p], u);
        return _;
      } else
        return u ? "`" + String(d).replace(n, "``") + "`" : "`" + String(d).replace(n, "``").replace(o, "`.`") + "`";
    }, t.escape = function(d, u, _) {
      if (d == null)
        return "NULL";
      switch (typeof d) {
        case "boolean":
          return d ? "true" : "false";
        case "number":
          return d + "";
        case "object":
          return Object.prototype.toString.call(d) === "[object Date]" ? t.dateToString(d, _ || "local") : Array.isArray(d) ? t.arrayToList(d, _) : Buffer.isBuffer(d) ? t.bufferToString(d) : typeof d.toSqlString == "function" ? String(d.toSqlString()) : u ? a(d.toString()) : t.objectToValues(d, _);
        default:
          return a(d);
      }
    }, t.arrayToList = function(d, u) {
      for (var _ = "", p = 0; p < d.length; p++) {
        var f = d[p];
        Array.isArray(f) ? _ += (p === 0 ? "" : ", ") + "(" + t.arrayToList(f, u) + ")" : _ += (p === 0 ? "" : ", ") + t.escape(f, !0, u);
      }
      return _;
    }, t.format = function(d, u, _, p) {
      if (u == null)
        return d;
      Array.isArray(u) || (u = [u]);
      for (var f = 0, g = /\?+/g, h = "", b = 0, v; b < u.length && (v = g.exec(d)); ) {
        var $ = v[0].length;
        if (!($ > 2)) {
          var k = $ === 2 ? t.escapeId(u[b]) : t.escape(u[b], _, p);
          h += d.slice(f, v.index) + k, f = g.lastIndex, b++;
        }
      }
      return f === 0 ? d : f < d.length ? h + d.slice(f) : h;
    }, t.dateToString = function(d, u) {
      var _ = new Date(d);
      if (isNaN(_.getTime()))
        return "NULL";
      var p, f, g, h, b, v, $;
      if (u === "local")
        p = _.getFullYear(), f = _.getMonth() + 1, g = _.getDate(), h = _.getHours(), b = _.getMinutes(), v = _.getSeconds(), $ = _.getMilliseconds();
      else {
        var k = c(u);
        k !== !1 && k !== 0 && _.setTime(_.getTime() + k * 6e4), p = _.getUTCFullYear(), f = _.getUTCMonth() + 1, g = _.getUTCDate(), h = _.getUTCHours(), b = _.getUTCMinutes(), v = _.getUTCSeconds(), $ = _.getUTCMilliseconds();
      }
      var S = s(p, 4) + "-" + s(f, 2) + "-" + s(g, 2) + " " + s(h, 2) + ":" + s(b, 2) + ":" + s(v, 2) + "." + s($, 3);
      return a(S);
    }, t.bufferToString = function(d) {
      return "X" + a(d.toString("hex"));
    }, t.objectToValues = function(d, u) {
      var _ = "";
      for (var p in d) {
        var f = d[p];
        typeof f != "function" && (_ += (_.length === 0 ? "" : ", ") + t.escapeId(p) + " = " + t.escape(f, !0, u));
      }
      return _;
    }, t.raw = function(d) {
      if (typeof d != "string")
        throw new TypeError("argument sql must be a string");
      return {
        toSqlString: function() {
          return d;
        }
      };
    };
    function a(l) {
      for (var d = r.lastIndex = 0, u = "", _; _ = r.exec(l); )
        u += l.slice(d, _.index) + i[_[0]], d = r.lastIndex;
      return d === 0 ? "'" + l + "'" : d < l.length ? "'" + u + l.slice(d) + "'" : "'" + u + "'";
    }
    function s(l, d) {
      for (l = l.toString(); l.length < d; )
        l = "0" + l;
      return l;
    }
    function c(l) {
      if (l === "Z")
        return 0;
      var d = l.match(/([\+\-\s])(\d\d):?(\d\d)?/);
      return d ? (d[1] === "-" ? -1 : 1) * (parseInt(d[2], 10) + (d[3] ? parseInt(d[3], 10) : 0) / 60) * 60 : !1;
    }
  }(pN)), pN;
}
var mN, Ore;
function z_d() {
  return Ore || (Ore = 1, mN = C_d()), mN;
}
var Pre;
function yz() {
  if (Pre)
    return va;
  Pre = 1;
  var e = Rt;
  Object.defineProperty(va, "__esModule", {
    value: !0
  }), va.sqlEmptyValue = va.spelImportConcat = va.spelFormatConcat = va.spelFixList = va.spelEscape = va.mongoEmptyValue = va.SqlString = void 0;
  var t = e(Yn), n = z_d();
  va.SqlString = n, n.trim = function(u) {
    return u.charAt(0) == "'" ? u.substring(1, u.length - 1) : u;
  }, n.escapeLike = function(u) {
    var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, f = n.escape(u);
    return f = n.trim(f), f = f.replace(/[%_]/g, "\\$&"), f = (_ ? "%" : "") + f + (p ? "%" : ""), f = "'" + f + "'", f;
  };
  var o = function(_) {
    var p = "''", f = _ == null ? void 0 : _.type;
    return f == "date" ? p = "'0000-00-00'" : f == "datetime" ? p = "'0000-00-00 00:00'" : f == "time" ? p = "'00:00'" : f == "number" && (p = "0"), p;
  };
  va.sqlEmptyValue = o;
  var r = function(_) {
    var p = "", f = _ == null ? void 0 : _.type;
    return f == "number" && (p = 0), p;
  };
  va.mongoEmptyValue = r;
  var i = function(_) {
    return "'" + _.replace(/'/g, "''") + "'";
  }, a = function(_) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, f, g, h = ["int", "float"];
    _.map(function($) {
      if ($ != null) {
        if (typeof $ == "string")
          g = "String";
        else if (typeof $ == "number")
          g = Number.isInteger($) ? "int" : "float";
        else
          throw new Error("spelEscape: Can't use value ".concat($, " in array"));
        if (!f)
          f = g;
        else if (f != g)
          if (h.includes(f) && h.includes(g))
            f = "float";
          else
            throw new Error("spelEscape: Can't use different types in array: found ".concat(f, " and ").concat(g));
      }
    }), f || (f = "String");
    var b;
    f == "float" ? b = _.map(function($) {
      return c($, !0);
    }) : b = _.map(function($) {
      return c($);
    });
    var v;
    return p ? v = "new ".concat(f, "[]{").concat(b.join(", "), "}") : v = "{".concat(b.join(", "), "}"), v;
  }, s = function(_) {
    return "".concat(_, ".?[true]");
  };
  va.spelFixList = s;
  var c = function(_) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (_ == null)
      return "null";
    switch ((0, t.default)(_)) {
      case "boolean":
        return _ ? "true" : "false";
      case "number":
        return !Number.isFinite(_) || isNaN(_) ? void 0 : _ + (!Number.isInteger(_) || p ? "f" : "");
      case "object":
        if (Array.isArray(_))
          return a(_, f);
        throw new Error("spelEscape: Object is not supported");
      default:
        return i(_);
    }
  };
  va.spelEscape = c;
  var l = function(_) {
    return _ && Array.isArray(_) && _.length ? _.map(function(p) {
      if (p.type == "const")
        return c(p.value);
      if (p.type == "property")
        return "" + p.value;
      if (p.type == "variable")
        return "#" + p.value;
    }).filter(function(p) {
      return p != null;
    }).join(" + ") : "null";
  };
  va.spelFormatConcat = l;
  var d = function(_) {
    if (_ == null)
      return [void 0, []];
    var p = [], f = _.valueType == "case_value" ? _.value : [_], g = f.map(function(h) {
      if (h.valueSrc == "value")
        return h.value === null ? void 0 : {
          type: "const",
          value: h.value
        };
      if (h.valueSrc == "field")
        return {
          type: h.isVariable ? "variable" : "property",
          value: h.value
        };
      p.push("Unsupported valueSrc ".concat(h.valueSrc, " in concatenation"));
    }).filter(function(h) {
      return h != null;
    });
    return [g, p];
  };
  return va.spelImportConcat = d, va;
}
var Ire;
function O_d() {
  if (Ire)
    return qm;
  Ire = 1;
  var e = Rt;
  Object.defineProperty(qm, "__esModule", {
    value: !0
  }), qm.sqlFormat = qm._sqlFormat = void 0;
  var t = e(Tl), n = e(rr), o = Br(), r = Hi(), i = e(F_()), a = e($g()), s = Sr(), c = Ns(), l = Ib(), d = wg(), u = Ra(), _ = yz();
  function p(D, M) {
    var N = Object.keys(D);
    if (Object.getOwnPropertySymbols) {
      var C = Object.getOwnPropertySymbols(D);
      M && (C = C.filter(function(P) {
        return Object.getOwnPropertyDescriptor(D, P).enumerable;
      })), N.push.apply(N, C);
    }
    return N;
  }
  function f(D) {
    for (var M = 1; M < arguments.length; M++) {
      var N = arguments[M] != null ? arguments[M] : {};
      M % 2 ? p(Object(N), !0).forEach(function(C) {
        (0, n.default)(D, C, N[C]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(N)) : p(Object(N)).forEach(function(C) {
        Object.defineProperty(D, C, Object.getOwnPropertyDescriptor(N, C));
      });
    }
    return D;
  }
  var g = function(M, N) {
    return h(M, N, !1);
  };
  qm.sqlFormat = g;
  var h = function(M, N) {
    var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, P = {
      errors: []
    }, x = b(M, N, P);
    return C ? [x, P.errors] : (P.errors.length && console.warn("Errors while exporting to SQL:", P.errors), x);
  };
  qm._sqlFormat = h;
  var b = function(M, N, C) {
    if (M) {
      var P = M.get("type"), x = M.get("children1");
      if ((P === "group" || P === "rule_group") && x && x.size)
        return v(M, N, C);
      if (P === "rule")
        return k(M, N, C);
    }
  }, v = function(M, N, C) {
    var P = M.get("type"), x = M.get("properties") || new u.Map(), w = M.get("children1"), E = P === "rule_group" ? x.get("field") : null, T = (0, o.getFieldConfig)(N, E) || {};
    T.mode == "array" && C.errors.push("Aggregation is not supported for ".concat(E));
    var z = x.get("not"), j = w.map(function(F) {
      return b(F, N, C);
    }).filter(function(F) {
      return typeof F < "u";
    });
    if (j.size) {
      var q = x.get("conjunction");
      q || (q = (0, c.defaultConjunction)(N));
      var V = N.conjunctions[q];
      return V.sqlFormatConj(j, q, z);
    }
  }, $ = function(M, N) {
    var C = N.sqlOp || M, P = (0, s.defaultValue)(N.cardinality, 1), x;
    return P == 0 ? x = function(E, T, z, j, q, V, F, L) {
      return "".concat(E, " ").concat(C);
    } : P == 1 ? x = function(E, T, z, j, q, V, F, L) {
      return "".concat(E, " ").concat(C, " ").concat(z);
    } : P == 2 && (x = function(E, T, z, j, q, V, F, L) {
      var U = z.first(), W = z.get(1);
      return "".concat(E, " ").concat(C, " ").concat(U, " AND ").concat(W);
    }), x;
  }, k = function(M, N, C) {
    var P = M.get("properties") || new u.Map(), x = P.get("field"), w = P.get("operator"), E = P.get("operatorOptions"), T = P.get("valueSrc"), z = P.get("valueType"), j = P.get("value"), q = P.get("asyncListValues");
    if (!(x == null || w == null)) {
      var V = (0, o.getFieldConfig)(N, x) || {}, F = (0, o.getOperatorConfig)(N, w, x) || {}, L = F.reversedOp, U = (0, o.getOperatorConfig)(N, L, x) || {}, W = (0, s.defaultValue)(F.cardinality, 1), H = !1, Q = F.sqlOp || F.sqlFormatOp, X = U.sqlOp || U.sqlFormatOp;
      if (!Q && !X) {
        C.errors.push("Operator ".concat(w, " is not supported"));
        return;
      }
      if (!X && X) {
        H = !0;
        var re = [L, w];
        w = re[0], L = re[1];
        var Z = [U, F];
        F = Z[0], U = Z[1];
      }
      var ee = [], J = [], oe = j.map(function(me, pe) {
        var be = T ? T.get(pe) : null, Se = z ? z.get(pe) : null, Ae = (0, d.completeValue)(me, be, N), Ze = (0, r.getWidgetForFieldOp)(N, x, w, be), Ge = (0, i.default)((0, o.getFieldWidgetConfig)(N, x, w, Ze, be), ["factory"]), rt = S(C, N, Ae, be, Se, Ge, V, w, F, q);
        return rt !== void 0 && (ee.push(be), J.push(Se)), rt;
      }), ce = oe.filter(function(me) {
        return me === void 0;
      }).size > 0;
      if (!(ce || oe.size < W)) {
        var de = W == 1 ? oe.first() : oe, te = F.sqlFormatOp || $(w, F);
        if (!te) {
          C.errors.push("Operator ".concat(w, " is not supported"));
          return;
        }
        var ue = O(C, N, x), le = [ue, w, de, ee.length > 1 ? ee : ee[0], J.length > 1 ? J : J[0], (0, i.default)(F, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), E, V], se;
        if (se = te.apply(void 0, le), H && (se = N.settings.sqlFormatReverse(se)), se === void 0) {
          C.errors.push("Operator ".concat(w, " is not supported for value source ").concat(ee.join(", ")));
          return;
        }
        return se;
      }
    }
  }, S = function(M, N, C, P, x, w, E, T, z, j) {
    if (C !== void 0) {
      var q;
      if (P == "field")
        q = O(M, N, C);
      else if (P == "func")
        q = I(M, N, C);
      else if (typeof w.sqlFormatValue == "function") {
        var V = w.sqlFormatValue, F = [
          C,
          f(f({}, (0, a.default)(E, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: j
          }),
          //useful options: valueFormat for date/time
          (0, i.default)(w, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        if (T && (F.push(T), F.push(z)), P == "field") {
          var L = (0, o.getFieldConfig)(N, C) || {};
          F.push(L);
        }
        q = V.apply(void 0, F);
      } else
        q = _.SqlString.escape(C);
      return q;
    }
  }, O = function(M, N, C) {
    if (C) {
      var P = N.settings.fieldSeparator, x = (0, o.getFieldConfig)(N, C) || {}, w = Array.isArray(C) ? C : C.split(P);
      (0, r.getFieldPath)(C, N);
      var E = (0, r.getFieldPathLabels)(C, N), T = E ? E.join(P) : null, z = N.settings.formatField || l.settings.formatField, j = (0, r.formatFieldName)(C, N, M), q = z(j, w, T, x, N);
      return q;
    }
  }, I = function(M, N, C) {
    var P = C.get("func"), x = C.get("args"), w = (0, o.getFuncConfig)(N, P), E = w.sqlFunc || P, T = {};
    for (var z in w.args) {
      var j = w.args[z], q = (0, o.getFieldConfig)(N, j), V = x ? x.get(z) : void 0, F = V ? V.get("value") : void 0, L = V ? V.get("valueSrc") : void 0, U = V ? V.get("asyncListValues") : void 0, W = S(M, N, F, L, j.type, q, j, null, null, U);
      if (F != null && W === void 0) {
        M.errors.push("Can't format value of arg ".concat(z, " for func ").concat(P));
        return;
      }
      W !== void 0 && (T[z] = W);
    }
    var H;
    if (typeof w.sqlFormatFunc == "function") {
      var Q = w.sqlFormatFunc, X = [T];
      H = Q.apply(void 0, X);
    } else {
      var re = Object.entries(T).map(function(Z) {
        var ee = (0, t.default)(Z, 2);
        ee[0];
        var J = ee[1];
        return J;
      }).join(", ");
      H = "".concat(E, "(").concat(re, ")");
    }
    return H;
  };
  return qm;
}
var jm = {}, Rre;
function P_d() {
  if (Rre)
    return jm;
  Rre = 1;
  var e = Rt;
  Object.defineProperty(jm, "__esModule", {
    value: !0
  }), jm.spelFormat = jm._spelFormat = void 0;
  var t = e(O7()), n = e(rr), o = e(Tl), r = Br(), i = Hi(), a = e(F_()), s = e($g()), c = Sr(), l = Ns();
  Ib();
  var d = wg(), u = Ra(), _ = yz();
  function p(x, w) {
    var E = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(x);
      w && (T = T.filter(function(z) {
        return Object.getOwnPropertyDescriptor(x, z).enumerable;
      })), E.push.apply(E, T);
    }
    return E;
  }
  function f(x) {
    for (var w = 1; w < arguments.length; w++) {
      var E = arguments[w] != null ? arguments[w] : {};
      w % 2 ? p(Object(E), !0).forEach(function(T) {
        (0, n.default)(x, T, E[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : p(Object(E)).forEach(function(T) {
        Object.defineProperty(x, T, Object.getOwnPropertyDescriptor(E, T));
      });
    }
    return x;
  }
  var g = function(w, E) {
    return h(w, E, !1);
  };
  jm.spelFormat = g;
  var h = function(w, E) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, z = {
      errors: []
    }, j = b(w, E, z, null);
    return T ? [j, z.errors] : (z.errors.length && console.warn("Errors while exporting to SpEL:", z.errors), j);
  };
  jm._spelFormat = h;
  var b = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (w) {
      var j = w.get("type");
      if (j === "group" || j === "rule_group")
        return k(w, E, T, z);
      if (j === "rule")
        return D(w, E, T, z);
      if (j == "switch_group")
        return $(w, E, T);
      if (j == "case_group")
        return v(w, E, T, z);
    }
  }, v = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, j = w.get("type");
    if (j != "case_group") {
      T.errors.push("Unexpected child of type ".concat(j, " inside switch"));
      return;
    }
    var q = w.get("properties") || new u.Map(), V = M(E, q, T, null, z, "!case_value"), F = (0, o.default)(V, 3), L = F[0];
    F[1], F[2];
    var U = k(w, E, T, z);
    return [U, L];
  }, $ = function(w, E, T) {
    w.get("properties") || new u.Map();
    var z = w.get("children1");
    if (z) {
      var j = z.map(function(X) {
        return v(X, E, T, null);
      }).filter(function(X) {
        return typeof X < "u";
      }).toArray();
      if (j.length) {
        if (j.length == 1 && !j[0][0])
          return j[0][1];
        for (var q = [], V = 0; V < j.length; V++)
          V != j.length - 1 && !j[V][0] ? T.errors.push("No condition for case ".concat(V)) : (q.push(j[V]), V == j.length - 1 && j[V][0] && q.push([void 0, null]));
        for (var F = "", L = "", U = 0; U < q.length; U++) {
          var W = (0, o.default)(q[U], 2), H = W[0], Q = W[1];
          Q == null && (Q = "null"), H == null && (H = "true"), U != q.length - 1 ? (F += "(".concat(H, " ? ").concat(Q, " : "), L += ")") : F += "".concat(Q);
        }
        return F + L;
      }
    }
  }, k = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, j = w.get("type"), q = w.get("properties") || new u.Map(), V = q.get("mode"), F = w.get("children1"), L = q.get("field");
    if (F) {
      var U = q.get("conjunction");
      U || (U = (0, l.defaultConjunction)(E));
      var W = E.conjunctions[U], H = q.get("not"), Q = j === "rule_group", X = Q && V != "struct", re = X ? L : z, Z = (0, r.getFieldConfig)(E, re) || {}, ee = Z.isSpelArray, J = q.get("operator");
      !J && (!V || V == "some") && (J = "some");
      var oe = I(E, J, L), ce = oe != J, de = J && (0, r.getOperatorConfig)(E, oe, L) || null, te = Q && (!oe || de.cardinality == 0), ue = M(E, q, T, oe, z, null), le = (0, o.default)(ue, 3), se = le[0], me = le[1], pe = le[2], be = F.map(function(Et) {
        return b(Et, E, T, re);
      }).filter(function(Et) {
        return typeof Et < "u";
      });
      if (X && !te) {
        if (se == null)
          return;
      } else if (!be.size)
        return;
      var Se = Q, Ae = be.size ? W.spelFormatConj(be, U, H, Se) : null, Ze;
      if (X) {
        var Ge = C(T, E, L, z), rt = ee ? ".length" : ".size()", qe = "".concat(Ge).concat(rt), Xe = Ae ? "".concat(Ge, ".?[").concat(Ae, "]").concat(rt) : qe, lt = te ? qe : se;
        Ze = O(T, E, q, Xe, lt, oe, me, pe, ce);
      } else
        Ze = Ae;
      return Ze;
    }
  }, S = function(w, E) {
    var T = E.spelOp;
    if (T) {
      var z = T[0] == "$", j = T[0] == "." || z, q = j ? T.slice(1) : T, V, F = (0, c.defaultValue)(E.cardinality, 1);
      return F == 0 ? V = function(U, W, H, Q, X, re, Z, ee) {
        return j ? "".concat(U, ".").concat(q, "()") : "".concat(U, " ").concat(q);
      } : F == 1 && (V = function(U, W, H, Q, X, re, Z, ee) {
        return z ? "".concat(H, ".").concat(q, "(").concat(U, ")") : j ? "".concat(U, ".").concat(q, "(").concat(H, ")") : "".concat(U, " ").concat(q, " ").concat(H);
      }), V;
    }
  }, O = function(w, E, T, z, j, q, V, F) {
    var L = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, U = T.get("field"), W = (0, r.getOperatorConfig)(E, q, U) || {}, H = (0, r.getFieldConfig)(E, U) || {}, Q = T.get("operatorOptions"), X = W.spelFormatOp || S(q, W);
    if (!X) {
      w.errors.push("Operator ".concat(q, " is not supported"));
      return;
    }
    var re = [z, q, j, V, F, (0, a.default)(W, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), Q, H], Z;
    return Z = X.apply(void 0, re), L && (Z = E.settings.spelFormatReverse(Z)), Z === void 0 && w.errors.push("Operator ".concat(q, " is not supported for value source ").concat(V)), Z;
  }, I = function(w, E, T) {
    if (E) {
      var z = (0, r.getOperatorConfig)(w, E, T) || {}, j = z.reversedOp, q = (0, r.getOperatorConfig)(w, j, T) || {}, V = z.spelOp || z.spelFormatOp, F = q.spelOp || q.spelFormatOp;
      if (!(!V && !F)) {
        if (!V && F) {
          var L = [j, E];
          E = L[0], j = L[1];
          var U = [q, z];
          z = U[0], q = U[1];
        }
        return E;
      }
    }
  }, D = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, j = w.get("properties") || new u.Map(), q = j.get("field"), V = j.get("operator");
    if (!(q == null || V == null)) {
      var F = I(E, V, q);
      if (!F) {
        T.errors.push("Operator ".concat(V, " is not supported"));
        return;
      }
      var L = F != V, U = M(E, j, T, F, z, null), W = (0, o.default)(U, 3), H = W[0], Q = W[1], X = W[2];
      if (H !== void 0) {
        var re = C(T, E, q, z), Z = O(T, E, j, re, H, F, Q, X, L);
        return Z;
      }
    }
  }, M = function(w, E, T, z, j) {
    var q = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, V = E.get("field"), F = E.get("valueSrc"), L = E.get("valueType");
    (q == "!case_value" || L && L.get(0) == "case_value") && (V = "!case_value");
    var U = (0, r.getFieldConfig)(w, V) || {}, W = (0, r.getOperatorConfig)(w, z, V) || {}, H = (0, c.defaultValue)(W.cardinality, 1), Q = E.get("value"), X = E.get("asyncListValues"), re = [], Z = [], ee;
    if (Q != null) {
      var J = Q.map(function(ce, de) {
        var te = F ? F.get(de) : null, ue = L ? L.get(de) : null, le = (0, d.completeValue)(ce, te, w), se = (0, i.getWidgetForFieldOp)(w, V, z, te), me = (0, a.default)((0, r.getFieldWidgetConfig)(w, V, z, se, te), ["factory"]), pe = N(T, w, le, te, ue, me, U, z, W, j, X);
        return pe !== void 0 && (re.push(te), Z.push(ue)), pe;
      }), oe = J.filter(function(ce) {
        return ce === void 0;
      }).size > 0;
      J.size < H || oe || (ee = H > 1 ? J.toArray() : H == 1 ? J.first() : null);
    }
    return [ee, re.length > 1 ? re : re[0], Z.length > 1 ? Z : Z[0]];
  }, N = function(w, E, T, z, j, q, V, F, L) {
    var U = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, W = arguments.length > 10 ? arguments[10] : void 0;
    if (T !== void 0) {
      var H;
      if (z == "field")
        H = C(w, E, T, U);
      else if (z == "func")
        H = P(w, E, T, U);
      else if (typeof q.spelFormatValue == "function") {
        var Q = q.spelFormatValue, X = [
          T,
          f(f({}, (0, s.default)(V, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: W
          }),
          //useful options: valueFormat for date/time
          (0, a.default)(q, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"])
        ];
        if (F && (X.push(F), X.push(L)), z == "field") {
          var re = (0, r.getFieldConfig)(E, T) || {};
          X.push(re);
        }
        H = Q.apply(void 0, X);
      } else
        H = (0, _.spelEscape)(T);
      return H;
    }
  }, C = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (T) {
      var j = E.settings.fieldSeparator, q = (0, r.getFieldConfig)(E, T) || {}, V = Array.isArray(T) ? T : T.split(j);
      (0, i.getFieldPath)(T, E, z);
      var F = (0, i.getFieldPartsConfigs)(T, E, z), L = E.settings.formatSpelField, U = (0, i.formatFieldName)(T, E, w);
      if (z) {
        var W = (0, r.getFieldConfig)(E, z) || {}, H = z;
        W.fieldName && (H = W.fieldName), U.indexOf(H + j) == 0 ? U = U.slice((H + j).length) : w.errors.push("Can't cut group ".concat(H, " from field ").concat(U));
      }
      var Q = F.map(function(re) {
        var Z = (0, o.default)(re, 3), ee = Z[0], J = Z[1], oe = Z[2], ce;
        oe && (oe.type == "!struct" || oe.type == "!group" && oe.mode == "struct" ? ce = J.isSpelMap ? "map" : "class" : oe.type == "!group" ? ce = J.isSpelItemMap ? "[map]" : "[class]" : ce = "class");
        var de = J == null ? void 0 : J.isSpelVariable;
        return {
          key: ee,
          parent: ce,
          isSpelVariable: de
        };
      }), X = L(U, z, V, Q, q, E);
      return X;
    }
  }, P = function(w, E, T) {
    var z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, j = T.get("func"), q = T.get("args"), V = (0, r.getFuncConfig)(E, j), F = V.spelFunc || j, L = {};
    for (var U in V.args) {
      var W = V.args[U], H = (0, r.getFieldConfig)(E, W), Q = q ? q.get(U) : void 0, X = Q ? Q.get("value") : void 0, re = Q ? Q.get("valueSrc") : void 0, Z = Q ? Q.get("asyncListValues") : void 0, ee = N(w, E, X, re, W.type, H, W, null, null, z, Z);
      if (X != null && ee === void 0) {
        w.errors.push("Can't format value of arg ".concat(U, " for func ").concat(j));
        return;
      }
      ee !== void 0 && (L[U] = ee);
    }
    var J;
    if (typeof V.spelFormatFunc == "function") {
      var oe = V.spelFormatFunc, ce = [L];
      J = oe.apply(void 0, ce);
    } else {
      var de = Object.entries(L).map(function(se) {
        var me = (0, o.default)(se, 2);
        me[0];
        var pe = me[1];
        return pe;
      });
      if (F[0] == "." && de.length) {
        var te = (0, t.default)(de), ue = te[0], le = te.slice(1);
        J = "".concat(ue).concat(F, "(").concat(le.join(", "), ")");
      } else
        J = "".concat(F, "(").concat(de.join(", "), ")");
    }
    return J;
  };
  return jm;
}
var s$ = {}, Nre;
function I_d() {
  if (Nre)
    return s$;
  Nre = 1;
  var e = Rt;
  Object.defineProperty(s$, "__esModule", {
    value: !0
  }), s$.queryString = void 0;
  var t = e(rr), n = e(Tl), o = e(Wc), r = Br(), i = Hi(), a = e(F_()), s = e($g()), c = Sr(), l = Ns(), d = Ib(), u = wg(), _ = Ra();
  function p(D, M) {
    var N = Object.keys(D);
    if (Object.getOwnPropertySymbols) {
      var C = Object.getOwnPropertySymbols(D);
      M && (C = C.filter(function(P) {
        return Object.getOwnPropertyDescriptor(D, P).enumerable;
      })), N.push.apply(N, C);
    }
    return N;
  }
  function f(D) {
    for (var M = 1; M < arguments.length; M++) {
      var N = arguments[M] != null ? arguments[M] : {};
      M % 2 ? p(Object(N), !0).forEach(function(C) {
        (0, t.default)(D, C, N[C]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(N)) : p(Object(N)).forEach(function(C) {
        Object.defineProperty(D, C, Object.getOwnPropertyDescriptor(N, C));
      });
    }
    return D;
  }
  var g = function(M, N) {
    var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, P = {
      errors: []
    }, x = h(M, N, P, C, null);
    return P.errors.length && console.warn("Errors while exporting to string:", P.errors), x;
  };
  s$.queryString = g;
  var h = function(M, N, C) {
    var P = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (M) {
      var w = M.get("type");
      if (M.get("children1"), w === "group" || w === "rule_group")
        return b(M, N, C, P, x);
      if (w === "rule")
        return k(M, N, C, P, x);
    }
  }, b = function(M, N, C) {
    var P = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, w = M.get("type"), E = M.get("properties") || new _.Map(), T = E.get("mode"), z = M.get("children1");
    if (z) {
      var j = w === "rule_group", q = j && T == "array" ? E.get("field") : null, V = j && T == "array", F = E.get("not"), L = z.map(function(J) {
        return h(J, N, C, P, q);
      }).filter(function(J) {
        return typeof J < "u";
      });
      if (!(!V && !L.size)) {
        var U = E.get("conjunction");
        U || (U = (0, l.defaultConjunction)(N));
        var W = N.conjunctions[U], H = L.size ? W.formatConj(L, U, F, P) : null, Q;
        if (q) {
          var X = k(M, N, C, P, x, !0);
          if (X) {
            var re, Z = X.pop(), ee = [H].concat((0, o.default)(X));
            Q = (re = N.settings).formatAggr.apply(re, (0, o.default)(ee)), Z && (Q = N.settings.formatReverse(Q, null, null, null, null, P));
          }
        } else
          Q = H;
        return Q;
      }
    }
  }, v = function(M, N, C, P, x, w) {
    var E = N.get("field"), T = N.get("valueSrc"), z = N.get("valueType"), j = (0, r.getFieldConfig)(M, E) || {}, q = P || N.get("operator"), V = (0, r.getOperatorConfig)(M, q, E) || {}, F = (0, c.defaultValue)(V.cardinality, 1), L = N.get("value"), U = N.get("asyncListValues"), W = [], H = [], Q;
    if (L != null) {
      var X = L.map(function(Z, ee) {
        var J = T ? T.get(ee) : null, oe = z ? z.get(ee) : null, ce = (0, u.completeValue)(Z, J, M), de = (0, i.getWidgetForFieldOp)(M, E, q, J), te = (0, a.default)((0, r.getFieldWidgetConfig)(M, E, q, de, J), ["factory"]), ue = S(M, C, ce, J, oe, te, j, q, V, x, w, U);
        return ue !== void 0 && (W.push(J), H.push(oe)), ue;
      }), re = X.filter(function(Z) {
        return Z === void 0;
      }).size > 0;
      re || X.size < F || (Q = F == 1 ? X.first() : X);
    }
    return [Q, W.length > 1 ? W : W[0], H.length > 1 ? H : H[0]];
  }, $ = function(M, N) {
    var C = N.labelForFormat || M, P = (0, c.defaultValue)(N.cardinality, 1), x;
    return P == 0 ? x = function(E, T, z, j, q, V, F, L) {
      return "".concat(E, " ").concat(C);
    } : P == 1 ? x = function(E, T, z, j, q, V, F, L) {
      return "".concat(E, " ").concat(C, " ").concat(z);
    } : P == 2 && (x = function(E, T, z, j, q, V, F, L) {
      var U = z.first(), W = z.get(1);
      return "".concat(E, " ").concat(C, " ").concat(U, " AND ").concat(W);
    }), x;
  }, k = function(M, N, C) {
    var P = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, w = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, E = M.get("properties") || new _.Map(), T = E.get("field"), z = E.get("operator"), j = E.get("operatorOptions");
    if (!(T == null || z == null)) {
      var q = (0, r.getFieldConfig)(N, T) || {}, V = (0, r.getOperatorConfig)(N, z, T) || {}, F = V.reversedOp, L = (0, r.getOperatorConfig)(N, F, T) || {}, U = !1, W = V.formatOp;
      if (!W && F && (W = L.formatOp, W)) {
        U = !0;
        var H = [F, z];
        z = H[0], F = H[1];
        var Q = [L, V];
        V = Q[0], L = Q[1];
      }
      if (W || (W = $(z, V)), !!W) {
        var X = O(N, C, T, P, x), re = v(N, E, C, z, P, x), Z = (0, n.default)(re, 3), ee = Z[0], J = Z[1], oe = Z[2];
        if (ee !== void 0) {
          var ce = [X, z, ee, J, oe, (0, a.default)(V, ["formatOp", "mongoFormatOp", "sqlFormatOp", "jsonLogic", "spelFormatOp"]), j, P, q, U];
          if (w)
            return ce;
          var de = W.apply(void 0, ce);
          return U && (de = N.settings.formatReverse(de, z, F, V, L, P)), de;
        }
      }
    }
  }, S = function(M, N, C, P, x, w, E, T, z, j) {
    var q = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : null, V = arguments.length > 11 ? arguments[11] : void 0;
    if (C !== void 0) {
      var F;
      if (P == "field")
        F = O(M, N, C, j, q);
      else if (P == "func")
        F = I(M, N, C, j, q);
      else if (typeof w.formatValue == "function") {
        var L = w.formatValue, U = [
          C,
          f(f({}, (0, s.default)(E, ["fieldSettings", "listValues"])), {}, {
            asyncListValues: V
          }),
          //useful options: valueFormat for date/time
          (0, a.default)(w, ["formatValue", "mongoFormatValue", "sqlFormatValue", "jsonLogic", "elasticSearchFormatValue", "spelFormatValue"]),
          j
        ];
        if (T && (U.push(T), U.push(z)), P == "field") {
          var W = (0, r.getFieldConfig)(M, C) || {};
          U.push(W);
        }
        F = L.apply(void 0, U);
      } else
        F = C;
      return F;
    }
  }, O = function(M, N, C, P) {
    var x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, w = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !0, E = M.settings, T = E.fieldSeparator, z = E.fieldSeparatorDisplay, j = null;
    if (C) {
      var q = (0, r.getFieldConfig)(M, C) || {}, V = Array.isArray(C) ? C : C.split(T);
      (0, i.getFieldPath)(C, M);
      var F = (0, i.getFieldPathLabels)(C, M, w ? x : null), L = F ? F.join(z) : null, U = q.label2 || L, W = M.settings.formatField || d.settings.formatField, H = (0, i.formatFieldName)(C, M, N, w ? x : null);
      j = W(H, V, U, q, M, P);
    }
    return j;
  }, I = function(M, N, C, P) {
    var x = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, w = C.get("func"), E = C.get("args"), T = (0, r.getFuncConfig)(M, w), z = P && T.label || w, j = {}, q = {};
    for (var V in T.args) {
      var F = T.args[V], L = (0, r.getFieldConfig)(M, F), U = E ? E.get(V) : void 0, W = U ? U.get("value") : void 0, H = U ? U.get("valueSrc") : void 0, Q = U ? U.get("asyncListValues") : void 0, X = S(M, N, W, H, F.type, L, F, null, null, P, x, Q), re = P && F.label || V;
      X !== void 0 && (j[V] = X, q[re] = X);
    }
    var Z = null;
    if (typeof T.formatFunc == "function") {
      var ee = T.formatFunc, J = [j, P];
      Z = ee.apply(void 0, J);
    } else {
      var oe = Object.entries(q).map(function(ce) {
        var de = (0, n.default)(ce, 2), te = de[0], ue = de[1];
        return P ? "".concat(te, ": ").concat(ue) : "".concat(ue);
      }).join(", ");
      Z = "".concat(z, "(").concat(oe, ")");
    }
    return Z;
  };
  return s$;
}
var mS = {}, Dre;
function R_d() {
  if (Dre)
    return mS;
  Dre = 1;
  var e = Rt;
  Object.defineProperty(mS, "__esModule", {
    value: !0
  }), mS.elasticSearchFormat = g;
  var t = e(rr), n = Hi(), o = Ns();
  function r(h, b) {
    var v = Object.keys(h);
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(h);
      b && ($ = $.filter(function(k) {
        return Object.getOwnPropertyDescriptor(h, k).enumerable;
      })), v.push.apply(v, $);
    }
    return v;
  }
  function i(h) {
    for (var b = 1; b < arguments.length; b++) {
      var v = arguments[b] != null ? arguments[b] : {};
      b % 2 ? r(Object(v), !0).forEach(function($) {
        (0, t.default)(h, $, v[$]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(v)) : r(Object(v)).forEach(function($) {
        Object.defineProperty(h, $, Object.getOwnPropertyDescriptor(v, $));
      });
    }
    return h;
  }
  function a(h) {
    if (h == null)
      return null;
    var b = h.split(",").map(Number);
    return {
      top_left: {
        lat: b[0],
        lon: b[1]
      },
      bottom_right: {
        lat: b[2],
        lon: b[3]
      }
    };
  }
  function s(h, b) {
    if (h.length > 1)
      return {
        gte: "".concat(h[0]),
        lte: "".concat(h[1])
      };
    var v = h[0];
    switch (b) {
      case "on_date":
      case "not_on_date":
      case "equal":
      case "select_equals":
      case "not_equal":
        return {
          gte: "".concat(v, "||/d"),
          lte: "".concat(v, "||+1d")
        };
      case "less_or_equal":
        return {
          lte: "".concat(v)
        };
      case "greater_or_equal":
        return {
          gte: "".concat(v)
        };
      case "less":
        return {
          lt: "".concat(v)
        };
      case "greater":
        return {
          gte: "".concat(v)
        };
      default:
        return;
    }
  }
  function c(h) {
    return {
      value: "*" + h + "*"
    };
  }
  function l(h) {
    switch (h) {
      case "AND":
        return "must";
      case "OR":
        return "should";
      case "NOT":
        return "must_not";
      default:
        return;
    }
  }
  function d(h) {
    return {
      value: h
    };
  }
  function u(h, b) {
    return h;
  }
  function _(h, b, v, $, k) {
    var S = u($);
    switch (h) {
      case "filter":
        return {
          script: k.operators[v].elasticSearchScript($, b)
        };
      case "exists":
        return {
          field: $
        };
      case "match":
        return (0, t.default)({}, S, b[0]);
      case "term":
        return (0, t.default)({}, $, b[0]);
      case "geo_bounding_box":
        return (0, t.default)({}, $, a(b[0]));
      case "range":
        return (0, t.default)({}, $, s(b, v));
      case "wildcard":
        return (0, t.default)({}, $, c(b[0]));
      case "regexp":
        return (0, t.default)({}, $, d(b[0]));
      default:
        return;
    }
  }
  function p(h, b, v, $, k) {
    if (!(!h || !v || b == null)) {
      var S = v, O = $.operators[S];
      if (O) {
        var I = O, D = I.elasticSearchQueryType, M = !1;
        if (!D && O.reversedOp) {
          M = !0, S = O.reversedOp, O = $.operators[S];
          var N = O;
          D = N.elasticSearchQueryType;
        }
        var C = (0, n.getWidgetForFieldOp)($, h, S, k), P = $.widgets[C], x = P.elasticSearchFormatValue, w;
        if (typeof D == "function" ? w = D(C) : w = D, !!w) {
          var E;
          return typeof x == "function" ? E = x(w, b, S, h, $) : E = _(w, b, S, h, $), M ? {
            bool: {
              must_not: (0, t.default)({}, w, i({}, E))
            }
          } : (0, t.default)({}, w, i({}, E));
        }
      }
    }
  }
  function f(h, b, v, $) {
    if (!(!h || !h.size)) {
      var k = h.valueSeq().toArray(), S = l(b), O = k.map(function(D) {
        return v(D, $);
      }).filter(function(D) {
        return D !== void 0;
      });
      if (O.length) {
        var I = O.flat(1 / 0);
        return {
          bool: (0, t.default)({}, S, I)
        };
      }
    }
  }
  function g(h, b) {
    if (h) {
      var v = h.get("type"), $ = h.get("properties") || /* @__PURE__ */ new Map();
      if (v === "rule" && $.get("field")) {
        var k, S, O = $.get("operator"), I = $.get("field"), D = $.get("value").toJS();
        (k = $.get("valueType")) === null || k === void 0 || k.get(0);
        var M = (S = $.get("valueSrc")) === null || S === void 0 ? void 0 : S.get(0);
        return M === "func" ? void 0 : D && Array.isArray(D[0]) ? D[0].map(function(P) {
          return p(I, [P], O, b, M);
        }) : p(I, D, O, b, M);
      }
      if (v === "group" || v === "rule_group") {
        var N = $.get("conjunction");
        N || (N = (0, o.defaultConjunction)(b));
        var C = h.get("children1");
        return f(C, N, g, b);
      }
    }
  }
  return mS;
}
var Mre;
function N_d() {
  return Mre || (Mre = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = $_d();
    Object.keys(t).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === t[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return t[c];
        }
      });
    });
    var n = T_d();
    Object.keys(n).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === n[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return n[c];
        }
      });
    });
    var o = A_d();
    Object.keys(o).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === o[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return o[c];
        }
      });
    });
    var r = O_d();
    Object.keys(r).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === r[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return r[c];
        }
      });
    });
    var i = P_d();
    Object.keys(i).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === i[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return i[c];
        }
      });
    });
    var a = I_d();
    Object.keys(a).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === a[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return a[c];
        }
      });
    });
    var s = R_d();
    Object.keys(s).forEach(function(c) {
      c === "default" || c === "__esModule" || c in e && e[c] === s[c] || Object.defineProperty(e, c, {
        enumerable: !0,
        get: function() {
          return s[c];
        }
      });
    });
  }(aN)), aN;
}
var fN = {}, gN = {}, Lre;
function P7() {
  return Lre || (Lre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isImmutableTree = e.getTree = e.checkTree = void 0, Object.defineProperty(e, "isJsonLogic", {
      enumerable: !0,
      get: function() {
        return c.isJsonLogic;
      }
    }), e.loadTree = e.isValidTree = e.isTree = void 0;
    var o = t(Yn), r = d(Ra()), i = Ek(), a = Br(), s = yg(), c = Sr();
    function l(v) {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap();
      return (l = function(O) {
        return O ? k : $;
      })(v);
    }
    function d(v, $) {
      if (!$ && v && v.__esModule)
        return v;
      if (v === null || n(v) !== "object" && typeof v != "function")
        return { default: v };
      var k = l($);
      if (k && k.has(v))
        return k.get(v);
      var S = {}, O = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var I in v)
        if (I !== "default" && Object.prototype.hasOwnProperty.call(v, I)) {
          var D = O ? Object.getOwnPropertyDescriptor(v, I) : null;
          D && (D.get || D.set) ? Object.defineProperty(S, I, D) : S[I] = v[I];
        }
      return S.default = v, k && k.set(v, S), S;
    }
    var u = function($) {
      var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if ($) {
        var S = $;
        return S = S.toJS(), k && (S = (0, s.getLightTree)(S)), S;
      }
    };
    e.getTree = u;
    var _ = function($) {
      if (g($))
        return $;
      if (h($))
        return b($);
      if (typeof $ == "string" && $.startsWith('["~#iM"'))
        throw "You are trying to load query in obsolete serialization format (Immutable string) which is not supported in versions starting from 2.1.17";
      if (typeof $ == "string")
        return b(JSON.parse($));
      throw "Can't load tree!";
    };
    e.loadTree = _;
    var p = function($, k) {
      if ($) {
        var S = (0, a.extendConfig)(k);
        return (0, i.validateTree)($, null, S, S);
      }
    };
    e.checkTree = p;
    var f = function($) {
      return (0, s.getTreeBadFields)($).length == 0;
    };
    e.isValidTree = f;
    var g = function($) {
      return r.Map.isMap($);
    };
    e.isImmutableTree = g;
    var h = function($) {
      return (0, o.default)($) == "object" && ($.type == "group" || $.type == "switch_group");
    };
    e.isTree = h;
    function b(v) {
      return (0, r.fromJS)(v, function($, k) {
        var S;
        if ($ == "properties") {
          S = k.toOrderedMap();
          for (var O = 0; O < 2; O++) {
            var I;
            ((I = S.get("value")) === null || I === void 0 ? void 0 : I.get(O)) === null && (S = S.setIn(["value", O], void 0));
          }
        } else if ($ == "value" && k.get(0) && k.get(0).toJS !== void 0) {
          var D = k.get(0).toJS();
          D.func ? S = k.toOrderedMap() : S = r.default.List.of(D);
        } else
          $ == "asyncListValues" ? S = k.toJS() : S = r.default.Iterable.isIndexed(k) ? k.toList() : k.toOrderedMap();
        return S;
      });
    }
  }(gN)), gN;
}
var Fm = {}, qre;
function D_d() {
  if (qre)
    return Fm;
  qre = 1;
  var e = Rt;
  Object.defineProperty(Fm, "__esModule", {
    value: !0
  }), Fm.loadFromJsonLogic = Fm._loadFromJsonLogic = void 0;
  var t = e(Wc), n = e(O7()), o = e(rr), r = e(Tl), i = e(_m()), a = Sr(), s = Br(), c = Hi(), l = P7(), d = Ns(), u = e(Sg);
  function _(x, w) {
    var E = Object.keys(x);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(x);
      w && (T = T.filter(function(z) {
        return Object.getOwnPropertyDescriptor(x, z).enumerable;
      })), E.push.apply(E, T);
    }
    return E;
  }
  function p(x) {
    for (var w = 1; w < arguments.length; w++) {
      var E = arguments[w] != null ? arguments[w] : {};
      w % 2 ? _(Object(E), !0).forEach(function(T) {
        (0, o.default)(x, T, E[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(E)) : _(Object(E)).forEach(function(T) {
        Object.defineProperty(x, T, Object.getOwnPropertyDescriptor(E, T));
      });
    }
    return x;
  }
  var f = function(w) {
    return Array.from(new Set(w));
  }, g = function(w, E) {
    return h(w, E, !1);
  };
  Fm.loadFromJsonLogic = g;
  var h = function(w, E) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, z = {
      errors: []
    }, j = (0, s.extendConfig)(E), q = b(j), V = w ? v(w, q, j, "rule", z) : void 0;
    V && V.type != "group" && (V = M(V, j));
    var F = V ? (0, l.loadTree)(V) : void 0;
    return T ? [F, z.errors] : (z.errors.length && console.warn("Errors while importing from JsonLogic:", z.errors), F);
  };
  Fm._loadFromJsonLogic = h;
  var b = function(w) {
    var E = {};
    for (var T in w.operators) {
      var z = w.operators[T];
      if (typeof z.jsonLogic == "string") {
        var j = (z._jsonLogicIsRevArgs ? "#" : "") + z.jsonLogic + "/" + (0, a.defaultValue)(z.cardinality, 1);
        E[j] || (E[j] = []), E[j].push(T);
      } else if (typeof z.jsonLogic2 == "string") {
        var q = z.jsonLogic2 + "/" + (0, a.defaultValue)(z.cardinality, 1);
        E[q] || (E[q] = []), E[q].push(T);
      }
    }
    var V = {};
    for (var F in w.conjunctions) {
      var L = w.conjunctions[F], U = L.jsonLogicConj || F.toLowerCase();
      V[U] = F;
    }
    var W = {};
    for (var H in w.funcs) {
      var Q = w.funcs[H], X = void 0;
      Q.jsonLogicIsMethod ? X = "#" + Q.jsonLogic : typeof Q.jsonLogic == "string" && (X = Q.jsonLogic), X && (W[X] || (W[X] = []), W[X].push(H));
    }
    var re = w.settings.jsonLogic, Z = re.groupVarKey, ee = re.altVarKey;
    return {
      operators: E,
      conjunctions: V,
      funcs: W,
      varKeys: ["var", Z, ee]
    };
  }, v = function x(w, E, T, z, j) {
    var q = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, V = arguments.length > 6 ? arguments[6] : void 0, F = arguments.length > 7 ? arguments[7] : void 0, L = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, U, W;
    (0, a.isJsonLogic)(w) && (U = Object.keys(w)[0], W = w[U], Array.isArray(W) || (W = [W]));
    var H, Q = j.errors.length, X = T.settings.jsonLogic.lockedOp, re = U == "!" && W.length == 1 && W[0] && (0, a.isJsonLogic)(W[0]) && E.varKeys.includes(Object.keys(W[0])[0]), Z = U == "!" && !re, ee = X && U == X;
    ee ? H = x(W[0], E, T, z, j, q, V, F, L, !0) : Z ? H = x(W[0], E, T, z, j, !q, V, F, L) : z == "val" ? H = k(U, W, E, T, q, j, L) || S(U, W, E, T, q, V, j, L) || $(w, V, F, T, j) : z == "rule" && (H = O(U, W, E, T, q, j, L, !1) || P(U, W, E, T, q, j, L));
    var J = j.errors.length;
    return U != "!" && H === void 0 && J == Q && j.errors.push("Can't parse logic ".concat(JSON.stringify(w))), ee && (H.properties.isLocked = !0), H;
  }, $ = function(w, E, T, z, j) {
    if (w !== void 0) {
      var q = z.widgets[T || E.mainWidget];
      if (!q) {
        j.errors.push("No widget for type ".concat(E.type));
        return;
      }
      if ((0, a.isJsonLogic)(w)) {
        j.errors.push("Unexpected logic in value: ".concat(JSON.stringify(w)));
        return;
      }
      if (E && E.type == "time" && typeof w == "number") {
        var V = Math.floor(w / 60 / 60) % 24, F = Math.floor(w / 60) % 60, L = w % 60, U = q.valueFormat;
        if (U) {
          var W = new Date(w);
          W.setMilliseconds(0), W.setHours(V), W.setMinutes(F), W.setSeconds(L), w = (0, u.default)(W).format(U);
        } else
          w = "".concat(V, ":").concat(F, ":").concat(L);
      }
      if (E && ["date", "datetime"].includes(E.type) && w && !(w instanceof Date))
        try {
          var H = new Date(w);
          H instanceof Date && H.toISOString() === w && (w = H);
        } catch {
          j.errors.push("Can't convert value ".concat(w, " as Date")), w = void 0;
        }
      if (w instanceof Date && E) {
        var Q = q.valueFormat;
        Q && (w = (0, u.default)(w).format(Q));
      }
      var X;
      if (w && E.fieldSettings && E.fieldSettings.asyncFetch) {
        var re = Array.isArray(w) ? w : [w];
        X = re;
      }
      return {
        valueSrc: "value",
        value: w,
        valueType: q.type,
        asyncListValues: X
      };
    }
  }, k = function(w, E, T, z, j, q) {
    var V = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, F = z.settings.fieldSeparator;
    if (T.varKeys.includes(w) && typeof E[0] == "string") {
      var L = E[0];
      V && (L = [V, L].join(F)), L = (0, s.normalizeField)(z, L);
      var U = (0, s.getFieldConfig)(z, L);
      if (!U) {
        q.errors.push("No config for field ".concat(L));
        return;
      }
      return {
        valueSrc: "field",
        value: L,
        valueType: U.type
      };
    }
  }, S = function(w, E, T, z, j, q, V) {
    var F = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    if (w) {
      var L, U, W, H = w == "method";
      if (H) {
        var Q, X, re = (0, n.default)(E);
        Q = re[0], L = re[1], X = re.slice(2), U = [Q].concat((0, t.default)(X));
      } else
        L = w, U = E;
      var Z = (H ? "#" : "") + L, ee = (T.funcs[Z] || []).filter(function(be) {
        return q ? z.funcs[be].returnType == q.type : !0;
      });
      if (ee.length)
        W = ee[0];
      else
        for (var J = (0, o.default)({}, w, E), oe = 0, ce = Object.entries(z.funcs || {}); oe < ce.length; oe++) {
          var de = (0, r.default)(ce[oe], 2), te = de[0], ue = de[1];
          if (ue.jsonLogicImport && ue.returnType == q.type) {
            var le = void 0;
            try {
              le = ue.jsonLogicImport(J);
            } catch {
            }
            le && (W = te, U = le);
          }
        }
      if (W && W) {
        var se = z.funcs[W], me = Object.keys(se.args || {}), pe = U.reduce(function(be, Se, Ae) {
          var Ze = me[Ae], Ge = se.args[Ze], rt = v(Se, T, z, "val", V, !1, Ge, null, F);
          if (rt === void 0 && (rt = Ge.defaultValue, rt === void 0)) {
            V.errors.push("No value for arg ".concat(Ze, " of func ").concat(W));
            return;
          }
          return p(p({}, be), {}, (0, o.default)({}, Ze, rt));
        }, {});
        return {
          valueSrc: "func",
          value: {
            func: W,
            args: pe
          },
          valueType: se.returnType
        };
      }
    }
  }, O = function(w, E, T, z, j, q) {
    var V = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, F = T.conjunctions[w], L = z.settings.fieldSeparator, U = V ? (0, s.getFieldConfig)(z, V) : null;
    if ((U == null ? void 0 : U.type) == "!group", F) {
      var W = "group", H = E.map(function(ce) {
        return v(ce, T, z, "rule", q, !1, null, null, V);
      }).filter(function(ce) {
        return ce !== void 0;
      }).reduce(function(ce, de) {
        return p(p({}, ce), {}, (0, o.default)({}, de.id, de));
      }, {}), Q = Object.values(H).map(function(ce) {
        var de;
        return ce == null || (de = ce.properties) === null || de === void 0 ? void 0 : de.field;
      }).filter(function(ce) {
        return ce && ce.includes(L);
      }), X = Object.fromEntries(f(Q).map(function(ce) {
        var de = ce.split(L), te = Object.fromEntries(de.slice(0, -1).map(function(ue, le, se) {
          return [].concat((0, t.default)(se.slice(0, le)), [ue]);
        }).map(function(ue) {
          return [ue.join(L), (0, s.getFieldConfig)(z, ue)];
        }).filter(function(ue) {
          var le = (0, r.default)(ue, 2);
          le[0];
          var se = le[1];
          return se.type == "!group";
        }));
        return [ce, Object.keys(te)];
      }));
      Object.values(H).map(function(ce) {
        var de;
        return ce == null || (de = ce.properties) === null || de === void 0 ? void 0 : de.field;
      }).map(function(ce) {
        return X[ce];
      }).filter(function(ce) {
        return ce && ce.length;
      });
      var re = f(Object.values(X).flat());
      I(re);
      var Z = {
        conjunction: F,
        not: j
      }, ee = (0, i.default)(), J = {}, oe = {};
      return Object.entries(H).map(function(ce) {
        var de = (0, r.default)(ce, 2), te = de[0], ue = de[1];
        if (ue.type == "group" || ue.type == "rule_group")
          J[te] = ue;
        else {
          var le, se = ue == null || (le = ue.properties) === null || le === void 0 ? void 0 : le.field, me = X[se], pe = me == null ? void 0 : me.at(-1);
          if (!pe)
            J[te] = ue;
          else {
            var be = J, Se = V ? V.split(L) : [], Ae = (0, a.shallowEqual)(Se, pe.split(L).slice(0, Se.length));
            Ae || (Se = []);
            var Ze = pe.split(L).slice(Se.length).map(function(Ge, rt, qe) {
              return [].concat((0, t.default)(Se), (0, t.default)(qe.slice(0, rt)), [Ge]).join(L);
            }).map(function(Ge) {
              return (0, s.normalizeField)(z, Ge);
            }).map(function(Ge) {
              return {
                f: Ge,
                fc: (0, s.getFieldConfig)(z, Ge) || {}
              };
            }).filter(function(Ge) {
              var rt = Ge.fc;
              return rt.type != "!struct";
            });
            Ze.map(function(Ge, rt) {
              var qe = Ge.f, Xe = Ge.fc, lt = oe[qe];
              lt || (lt = (0, i.default)(), oe[qe] = lt, be[lt] = {
                type: "rule_group",
                id: lt,
                children1: {},
                properties: {
                  conjunction: F,
                  not: !1,
                  field: qe,
                  mode: Xe.mode
                }
              }), be = be[lt].children1;
            }), be[te] = ue;
          }
        }
      }), {
        type: W,
        id: ee,
        children1: J,
        properties: Z
      };
    }
  }, I = function(w) {
    for (var E = (0, t.default)(w).sort(function(j, q) {
      return j.length - q.length;
    }), T = 0; T < E.length; T++)
      for (var z = T + 1; z < E.length; z++)
        E[z].indexOf(E[T]) == 0 && (E.splice(z, 1), z--);
    return E;
  }, D = function(w, E, T, z, j) {
    if (w)
      return {
        type: "rule_group",
        id: (0, i.default)(),
        children1: (0, o.default)({}, w.id, w),
        properties: {
          conjunction: j || (0, d.defaultGroupConjunction)(z, T),
          not: !1,
          field: E
        }
      };
  }, M = function(w, E) {
    var T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return {
      type: "group",
      id: (0, i.default)(),
      children1: (0, o.default)({}, w.id, w),
      properties: {
        conjunction: (0, d.defaultConjunction)(E),
        not: T
      }
    };
  }, N = function(w, E, T, z, j, q, V) {
    var F = [], L = C(w, E, T, z, j, q, F, !1) || C(w, E, T, z, j, q, F, !0);
    if (!L) {
      V.errors.push(F.join("; ") || "Unknown op ".concat(w, "/").concat(E));
      return;
    }
    return L;
  }, C = function(w, E, T, z, j, q, V, F) {
    var L = w == "all" && (0, a.isJsonLogic)(T[1]) && Object.keys(T[1])[0] == "in", U = !L && q.settings.groupOperators.includes(w), W = ["==", "!="], H = U ? 0 : E - 1;
    (U || W.includes(w) && H == 1 && T[1] === null) && (H = 0);
    var Q = w + "/" + H, X = q.settings.fieldSeparator, re = j.operators[(F ? "#" : "") + Q];
    if (re) {
      var Z, ee = [], J = ["<", "<=", ">", ">="];
      if (J.includes(w) && E == 3)
        Z = T[1], ee = [T[0], T[2]];
      else if (F)
        Z = T[1], ee = [T[0]];
      else {
        var oe = (0, n.default)(T);
        Z = oe[0], ee = oe.slice(1);
      }
      if (!(0, a.isJsonLogic)(Z)) {
        V.push("Incorrect operands for ".concat(w, ": ").concat(JSON.stringify(T)));
        return;
      }
      var ce = Object.keys(Z)[0], de = Object.values(Z)[0], te, ue;
      if (j.varKeys.includes(ce) && typeof de == "string" && (te = de), U && (ue = ee[0], ee = []), ce == "reduce" && Array.isArray(de) && de.length == 3) {
        var le = de, se = (0, r.default)(le, 3), me = se[0], pe = se[1], be = se[2];
        if ((0, a.isJsonLogic)(me) && be == 0 && (0, a.isJsonLogic)(pe) && Array.isArray(pe["+"]) && pe["+"][0] == 1 && (0, a.isJsonLogic)(pe["+"][1]) && pe["+"][1].var == "accumulator")
          if (ce = Object.keys(me)[0], de = Object.values(me)[0], ce == "filter") {
            var Se = de, Ae = (0, r.default)(Se, 2), Ze = Ae[0], Ge = Ae[1];
            (0, a.isJsonLogic)(Ze) && (ce = Object.keys(Ze)[0], de = Object.values(Ze)[0], j.varKeys.includes(ce) && typeof de == "string" && (te = de, ue = Ge));
          } else
            j.varKeys.includes(ce) && typeof de == "string" && (te = de);
      }
      if (!te) {
        V.push("Unknown field ".concat(JSON.stringify(Z)));
        return;
      }
      z && (te = [z, te].join(X)), te = (0, s.normalizeField)(q, te);
      var rt = (0, s.getFieldConfig)(q, te);
      if (!rt) {
        V.push("No config for field ".concat(te));
        return;
      }
      var qe = re[0];
      if (re.length > 1 && rt && rt.operators) {
        if (re = re.filter(function(Xe) {
          return rt.operators.includes(Xe);
        }), re.length == 0) {
          V.push("No corresponding ops for field ".concat(te));
          return;
        }
        qe = re[0];
      }
      return {
        field: te,
        fieldConfig: rt,
        opKey: qe,
        args: ee,
        having: ue
      };
    }
  }, P = function x(w, E, T, z, j, q) {
    var V = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    if (w) {
      var F = E.length;
      if (w == "all" && (0, a.isJsonLogic)(E[1])) {
        var L = Object.keys(E[1])[0];
        L == "in" && (E = [E[0], E[1][L][1]], w = w + "-" + L);
      }
      var U = N(w, F, E, V, T, z, q);
      if (U) {
        var W = U.field, H = U.fieldConfig, Q = U.opKey, X = U.args, re = U.having, Z = z.operators[Q];
        H.showNot !== void 0 ? H.showNot : z.settings.showNot;
        var ee = !0, J, oe;
        if (H.type == "!group" && re) {
          J = Object.keys(re)[0], oe = re[J], Array.isArray(oe) || (oe = [oe]);
          var ce = J == "!" && oe.length == 1 && oe[0] && (0, a.isJsonLogic)(oe[0]) && T.varKeys.includes(Object.keys(oe[0])[0]);
          J == "!" && !ce && (j = !j, re = re["!"], J = Object.keys(re)[0], oe = re[J], Array.isArray(oe) || (oe = [oe]));
        }
        j && ee && Z.reversedOp && (j = !1, Q = Z.reversedOp, Z = z.operators[Q]);
        var de = (0, c.getWidgetForFieldOp)(z, W, Q), te = X.map(function(be) {
          return v(be, T, z, "val", q, !1, H, de, V);
        });
        if (!te.filter(function(be) {
          return be === void 0;
        }).length) {
          var ue;
          if (H.type == "!group" && re) {
            if (T.conjunctions[J] !== void 0)
              ue = O(J, oe, T, z, j, q, W, !0), j = !1;
            else {
              var le, se = x(J, oe, T, z, j && ee, q, W);
              j && ee && !(se != null && (le = se.properties) !== null && le !== void 0 && le.not) && (j = !1), ue = D(se, W, H, z, T.conjunctions.and);
            }
            if (!ue)
              return;
            ue.type = "rule_group", j && Object.assign(ue.properties, {
              not: j
            }), Object.assign(ue.properties, {
              field: W,
              mode: H.mode,
              operator: Q
            }), H.mode == "array" && Object.assign(ue.properties, {
              value: te.map(function(be) {
                return be.value;
              }),
              valueSrc: te.map(function(be) {
                return be.valueSrc;
              }),
              valueType: te.map(function(be) {
                return be.valueType;
              })
            });
          } else if (H.type == "!group" && !re)
            ue = {
              type: "rule_group",
              id: (0, i.default)(),
              children1: {},
              properties: {
                conjunction: (0, d.defaultGroupConjunction)(z, H),
                not: j,
                mode: H.mode,
                field: W,
                operator: Q
              }
            }, H.mode == "array" && Object.assign(ue.properties, {
              value: te.map(function(be) {
                return be.value;
              }),
              valueSrc: te.map(function(be) {
                return be.valueSrc;
              }),
              valueType: te.map(function(be) {
                return be.valueType;
              })
            });
          else {
            var me = te.map(function(be) {
              return be.asyncListValues;
            }).filter(function(be) {
              return be != null;
            }), pe = me.length ? me[0] : void 0;
            ue = {
              type: "rule",
              id: (0, i.default)(),
              properties: {
                field: W,
                operator: Q,
                value: te.map(function(be) {
                  return be.value;
                }),
                valueSrc: te.map(function(be) {
                  return be.valueSrc;
                }),
                valueType: te.map(function(be) {
                  return be.valueType;
                }),
                asyncListValues: pe
              }
            }, j && (ue = M(ue, z, j));
          }
          return ue;
        }
      }
    }
  };
  return Fm;
}
var Vm = {}, hN = { exports: {} }, jre;
function M_d() {
  return jre || (jre = 1, function(e, t) {
    (function(o, r) {
      e.exports = r();
    })(Je, function() {
      return (
        /******/
        function(n) {
          var o = {};
          function r(i) {
            if (o[i])
              return o[i].exports;
            var a = o[i] = {
              /******/
              i,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return n[i].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
          }
          return r.m = n, r.c = o, r.d = function(i, a, s) {
            r.o(i, a) || Object.defineProperty(i, a, {
              /******/
              configurable: !1,
              /******/
              enumerable: !0,
              /******/
              get: s
              /******/
            });
          }, r.n = function(i) {
            var a = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return r.d(a, "a", a), a;
          }, r.o = function(i, a) {
            return Object.prototype.hasOwnProperty.call(i, a);
          }, r.p = "", r(r.s = 3);
        }([
          /* 0 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            function i(a, s) {
              var c = {}, l = a || "Abstract", d = [], u = null, _;
              if (c._type = l, c.getType = function() {
                return l;
              }, c.setType = function(h) {
                l = h;
              }, c.getChildren = function() {
                return d;
              }, c.addChild = function(h) {
                if (h) {
                  if (!h.setParent)
                    throw {
                      name: "Error",
                      message: "Trying to add a child which is not a node: " + JSON.stringify(h)
                    };
                  h.setParent(c), d.push(h);
                }
              }, c.getParent = function() {
                return u;
              }, c.setParent = function(h) {
                u = h;
              }, c.getContext = function(h) {
                return _ || h.activeContext.peek();
              }, c.setContext = function(h) {
                _ = h;
              }, c.getStartPosition = function() {
                return s >> 16;
              }, c.getEndPosition = function() {
                return s & 65535;
              }, c.getValue = function() {
                throw {
                  name: "MethodNotImplementedException",
                  message: "SpelNode#getValue() must be overridden."
                };
              }, c.toString = function() {
                var h = "Kind: " + c.getType();
                h += ", Children: [";
                for (var b = 0, v = c.getChildren().length; b < v; b += 1)
                  h += "{" + c.getChildren()[b] + "}, ";
                return h += "]", h;
              }, s === 0)
                throw {
                  name: "Error",
                  message: "Position cannot be 0"
                };
              for (var p = arguments.length, f = Array(p > 2 ? p - 2 : 0), g = 2; g < p; g++)
                f[g - 2] = arguments[g];
              return f && f.forEach(function(h) {
                c.addChild(h);
              }), c;
            }
            o.SpelNode = {
              create: i
            };
          },
          /* 1 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Stack = i;
            function i(a) {
              this.elements = a || [];
            }
            i.prototype.push = function(a) {
              return this.elements.push(a), a;
            }, i.prototype.pop = function() {
              return this.elements.pop();
            }, i.prototype.peek = function() {
              return this.elements[this.elements.length - 1];
            }, i.prototype.empty = function() {
              return this.elements.length > 0;
            }, i.prototype.search = function(a) {
              return this.elements.length - this.elements.indexOf(a);
            };
          },
          /* 2 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            var i = {
              LITERAL_INT: 1,
              //tested
              LITERAL_LONG: 2,
              //tested
              LITERAL_HEXINT: 3,
              //tested
              LITERAL_HEXLONG: 4,
              //tested
              LITERAL_STRING: 5,
              //tested
              LITERAL_REAL: 6,
              //tested
              LITERAL_REAL_FLOAT: 7,
              //tested
              LPAREN: "(",
              //tested
              RPAREN: ")",
              //tested
              COMMA: ",",
              //tested
              IDENTIFIER: 0,
              //tested
              COLON: ":",
              //tested
              HASH: "#",
              //tested
              RSQUARE: "]",
              //tested
              LSQUARE: "[",
              //tested
              LCURLY: "{",
              //tested
              RCURLY: "}",
              //tested
              DOT: ".",
              //tested
              PLUS: "+",
              //tested
              STAR: "*",
              //tested
              MINUS: "-",
              //tested
              SELECT_FIRST: "^[",
              //tested
              SELECT_LAST: "$[",
              //tested
              QMARK: "?",
              //tested
              PROJECT: "![",
              //tested
              DIV: "/",
              //tested
              GE: ">=",
              //tested
              GT: ">",
              //tested
              LE: "<=",
              //tested
              LT: "<",
              //tested
              EQ: "==",
              //tested
              NE: "!=",
              //tested
              MOD: "%",
              //tested
              NOT: "!",
              //tested
              ASSIGN: "=",
              //tested
              INSTANCEOF: "instanceof",
              //test fails
              MATCHES: "matches",
              //test fails
              BETWEEN: "between",
              //test fails
              SELECT: "?[",
              //tested
              POWER: "^",
              //tested
              ELVIS: "?:",
              //tested
              SAFE_NAVI: "?.",
              //tested
              BEAN_REF: "@",
              //tested
              SYMBOLIC_OR: "||",
              //tested
              SYMBOLIC_AND: "&&",
              //tested
              INC: "++",
              //tested
              DEC: "--"
              //tested
            };
            function a(c) {
              this.type = c, this.tokenChars = i[c], this._hasPayload = typeof i[c] != "string", typeof i[c] == "number" && (this._ordinal = i[c]);
            }
            for (var s in i)
              i.hasOwnProperty(s) && (a[s] = new a(s));
            a.prototype.toString = function() {
              return this.type + (this.tokenChars.length !== 0 ? "(" + this.tokenChars + ")" : "");
            }, a.prototype.getLength = function() {
              return this.tokenChars.length;
            }, a.prototype.hasPayload = function() {
              return this._hasPayload;
            }, a.prototype.valueOf = function(c) {
              for (var l in i)
                if (i.hasOwnProperty(l) && i[l] === c)
                  return a[l];
            }, a.prototype.ordinal = function() {
              return this._ordinal;
            }, o.TokenKind = a;
          },
          /* 3 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.StandardContext = o.SpelExpressionEvaluator = void 0;
            var i = r(4), a = r(50);
            o.SpelExpressionEvaluator = i.SpelExpressionEvaluator, o.StandardContext = a.StandardContext;
          },
          /* 4 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.SpelExpressionEvaluator = void 0;
            var i = r(5), a = r(1), s = {};
            function c(l, d, u) {
              var _ = new a.Stack(), p;
              return d || (d = {}), _.push(d), p = {
                rootContext: d,
                activeContext: _,
                locals: u
              }, l.getValue(p);
            }
            s.compile = function(l) {
              var d = (0, i.SpelExpressionParser)().parse(l);
              return {
                eval: function(_, p) {
                  return c(d, _, p);
                },
                _compiledExpression: d
              };
            }, s.eval = function(l, d, u) {
              return s.compile(l).eval(d, u);
            }, o.SpelExpressionEvaluator = s;
          },
          /* 5 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.SpelExpressionParser = void 0;
            var i = r(2), a = r(6), s = r(8), c = r(9), l = r(10), d = r(11), u = r(12), _ = r(13), p = r(14), f = r(15), g = r(16), h = r(17), b = r(18), v = r(19), $ = r(20), k = r(21), S = r(22), O = r(23), I = r(24), D = r(25), M = r(26), N = r(27), C = r(28), P = r(29), x = r(30), w = r(31), E = r(32), T = r(33), z = r(34), j = r(35), q = r(36), V = r(37), F = r(38), L = r(39), U = r(40), W = r(41), H = r(42), Q = r(43), X = r(44), re = r(45), Z = r(46), ee = r(47), J = r(48), oe = r(49);
            o.SpelExpressionParser = function() {
              var de = new RegExp("[\\p{L}\\p{N}_$]+"), te = [], ue, le, se, me;
              function pe(xe) {
              }
              function be(xe, je) {
                try {
                  ue = xe, le = a.Tokenizer.tokenize(xe), se = le.length, me = 0, te = [];
                  var pt = Se();
                  return Ut() && At(Kt().startPos, "MORE_INPUT", Nt().toString()), pt;
                } catch (Jt) {
                  throw Jt.message;
                }
              }
              function Se() {
                var xe = Ae();
                if (Ut()) {
                  var je = Kt();
                  if (je.getKind() === i.TokenKind.ASSIGN) {
                    xe === null && (xe = d.NullLiteral.create(In(je.startPos - 1, je.endPos - 1))), Nt();
                    var pt = Ae();
                    return b.Assign.create($t(je), xe, pt);
                  }
                  if (je.getKind() === i.TokenKind.ELVIS) {
                    xe === null && (xe = d.NullLiteral.create(In(je.startPos - 1, je.endPos - 2))), Nt();
                    var Jt = Se();
                    return Jt === null && (Jt = d.NullLiteral.create(In(je.startPos + 1, je.endPos + 1))), F.Elvis.create($t(je), xe, Jt);
                  }
                  if (je.getKind() === i.TokenKind.QMARK) {
                    xe === null && (xe = d.NullLiteral.create(In(je.startPos - 1, je.endPos - 1))), Nt();
                    var Ye = Se();
                    oo(i.TokenKind.COLON);
                    var mn = Se();
                    return V.Ternary.create($t(je), xe, Ye, mn);
                  }
                }
                return xe;
              }
              function Ae() {
                for (var xe = Ze(); yt("or") || Zn(i.TokenKind.SYMBOLIC_OR); ) {
                  var je = Nt(), pt = Ze();
                  Ie(je, xe, pt), xe = j.OpOr.create($t(je), xe, pt);
                }
                return xe;
              }
              function Ze() {
                for (var xe = Ge(); yt("and") || Zn(i.TokenKind.SYMBOLIC_AND); ) {
                  var je = Nt(), pt = Ge();
                  Ie(je, xe, pt), xe = z.OpAnd.create($t(je), xe, pt);
                }
                return xe;
              }
              function Ge() {
                var xe = rt(), je = Or();
                if (je !== null) {
                  var pt = Nt(), Jt = rt();
                  Ie(pt, xe, Jt);
                  var Ye = je.kind;
                  if (je.isNumericRelationalOperator()) {
                    var mn = $t(pt);
                    return Ye === i.TokenKind.GT ? S.OpGT.create(mn, xe, Jt) : Ye === i.TokenKind.LT ? I.OpLT.create(mn, xe, Jt) : Ye === i.TokenKind.LE ? O.OpLE.create(mn, xe, Jt) : Ye === i.TokenKind.GE ? k.OpGE.create(mn, xe, Jt) : Ye === i.TokenKind.EQ ? v.OpEQ.create(mn, xe, Jt) : $.OpNE.create(mn, xe, Jt);
                  }
                  return Ye === i.TokenKind.INSTANCEOF ? Q.OpInstanceof.create($t(pt), xe, Jt) : Ye === i.TokenKind.MATCHES ? q.OpMatches.create($t(pt), xe, Jt) : X.OpBetween.create($t(pt), xe, Jt);
                }
                return xe;
              }
              function rt() {
                for (var xe = qe(); ft(i.TokenKind.PLUS, i.TokenKind.MINUS, i.TokenKind.INC); ) {
                  var je = Nt(), pt = qe();
                  zt(je, pt), je.getKind() === i.TokenKind.PLUS ? xe = D.OpPlus.create($t(je), xe, pt) : je.getKind() === i.TokenKind.MINUS && (xe = M.OpMinus.create($t(je), xe, pt));
                }
                return xe;
              }
              function qe() {
                for (var xe = Xe(); ft(i.TokenKind.STAR, i.TokenKind.DIV, i.TokenKind.MOD); ) {
                  var je = Nt(), pt = Xe();
                  Ie(je, xe, pt), je.getKind() === i.TokenKind.STAR ? xe = N.OpMultiply.create($t(je), xe, pt) : je.getKind() === i.TokenKind.DIV ? xe = C.OpDivide.create($t(je), xe, pt) : xe = P.OpModulus.create($t(je), xe, pt);
                }
                return xe;
              }
              function Xe() {
                var xe = lt(), je;
                if (Zn(i.TokenKind.POWER)) {
                  je = Nt();
                  var pt = lt();
                  return zt(je, pt), x.OpPower.create($t(je), xe, pt);
                }
                return xe !== null && ft(i.TokenKind.INC, i.TokenKind.DEC) ? (je = Nt(), je.getKind() === i.TokenKind.INC ? w.OpInc.create($t(je), !0, xe) : E.OpDec.create($t(je), !0, xe)) : xe;
              }
              function lt() {
                var xe, je;
                return ft(i.TokenKind.PLUS, i.TokenKind.MINUS, i.TokenKind.NOT) ? (xe = Nt(), je = lt(), xe.getKind() === i.TokenKind.NOT ? T.OpNot.create($t(xe), je) : xe.getKind() === i.TokenKind.PLUS ? D.OpPlus.create($t(xe), je) : M.OpMinus.create($t(xe), je)) : ft(i.TokenKind.INC, i.TokenKind.DEC) ? (xe = Nt(), je = lt(), xe.getKind() === i.TokenKind.INC ? w.OpInc.create($t(xe), !1, je) : E.OpDec.create($t(xe), !1, je)) : Et();
              }
              function Et() {
                var xe = [], je = Mn();
                for (xe.push(je); wt(); )
                  xe.push(Ht());
                return xe.length === 1 ? xe[0] : g.CompoundExpression.create(In(je.getStartPosition(), xe[xe.length - 1].getEndPosition()), xe);
              }
              function wt() {
                var xe = null;
                return ft(i.TokenKind.DOT, i.TokenKind.SAFE_NAVI) ? xe = Dt() : xe = nn(), xe === null ? !1 : (rn(xe), !0);
              }
              function nn() {
                return Zn(i.TokenKind.LSQUARE) && kn() ? Ht() : null;
              }
              function Dt() {
                var xe = Nt(), je = xe.getKind() === i.TokenKind.SAFE_NAVI;
                return wn(je) || mt() || cn(je) || gt(je) ? Ht() : (Kt() === null ? At(xe.startPos, "OOD") : At(xe.startPos, "UNEXPECTED_DATA_AFTER_DOT", Mt(Kt())), null);
              }
              function mt() {
                if (!Zn(i.TokenKind.HASH))
                  return !1;
                var xe = Nt(), je = oo(i.TokenKind.IDENTIFIER), pt = bt();
                return pt === null ? (rn(f.VariableReference.create(je.data, In(xe.startPos, je.endPos))), !0) : (rn(u.FunctionReference.create(je.data, In(xe.startPos, je.endPos), pt)), !0);
              }
              function bt() {
                if (!Zn(i.TokenKind.LPAREN))
                  return null;
                var xe = [];
                return an(xe), oo(i.TokenKind.RPAREN), xe;
              }
              function gn(xe) {
                Zn(i.TokenKind.LPAREN) || At($t(Kt()), "MISSING_CONSTRUCTOR_ARGS"), an(xe), oo(i.TokenKind.RPAREN);
              }
              function an(xe) {
                var je = Kt().startPos, pt;
                do {
                  Nt();
                  var Jt = Kt();
                  Jt === null && At(je, "RUN_OUT_OF_ARGUMENTS"), Jt.getKind() !== i.TokenKind.RPAREN && xe.push(Se()), pt = Kt();
                } while (pt !== null && pt.kind === i.TokenKind.COMMA);
                pt === null && At(je, "RUN_OUT_OF_ARGUMENTS");
              }
              function Mn() {
                return qn() || Bn() || un() || qo() || so() || wn(!1) || mt() || Ln() || cn(!1) || gt(!1) || kn() || ln() ? Ht() : null;
              }
              function Ln() {
                if (Zn(i.TokenKind.BEAN_REF)) {
                  var xe = Nt(), je = null, pt = null;
                  Zn(i.TokenKind.IDENTIFIER) ? (je = oo(i.TokenKind.IDENTIFIER), pt = je.data) : Zn(i.TokenKind.LITERAL_STRING) ? (je = oo(i.TokenKind.LITERAL_STRING), pt = je.stringValue(), pt = pt.substring(1, pt.length() - 1)) : At(xe.startPos, "INVALID_BEAN_REFERENCE");
                  var Jt = Z.BeanReference.create($t(je), pt);
                  return rn(Jt), !0;
                }
                return !1;
              }
              function un() {
                if (Zn(i.TokenKind.IDENTIFIER)) {
                  var xe = Kt();
                  if (xe.stringValue() !== "T")
                    return !1;
                  var je = Nt();
                  if (Zn(i.TokenKind.RSQUARE))
                    return rn(p.PropertyReference.create(je.stringValue(), $t(je))), !0;
                  oo(i.TokenKind.LPAREN);
                  for (var pt = Ot(), Jt = 0; st(i.TokenKind.LSQUARE, !0); )
                    oo(i.TokenKind.RSQUARE), Jt++;
                  return oo(i.TokenKind.RPAREN), rn(re.TypeReference.create($t(xe), pt, Jt)), !0;
                }
                return !1;
              }
              function qo() {
                if (Zn(i.TokenKind.IDENTIFIER)) {
                  var xe = Kt();
                  return xe.stringValue().toLowerCase() !== "null" ? !1 : (Nt(), rn(d.NullLiteral.create($t(xe))), !0);
                }
                return !1;
              }
              function cn(xe) {
                var je = Kt();
                if (!st(i.TokenKind.PROJECT, !0))
                  return !1;
                var pt = Se();
                return oo(i.TokenKind.RSQUARE), rn(H.Projection.create(xe, $t(je), pt)), !0;
              }
              function ln() {
                var xe = Kt(), je = [];
                if (!st(i.TokenKind.LCURLY, !0))
                  return !1;
                var pt = null, Jt = Kt();
                if (st(i.TokenKind.RCURLY, !0))
                  pt = L.InlineList.create(In(xe.startPos, Jt.endPos));
                else if (st(i.TokenKind.COLON, !0))
                  Jt = oo(i.TokenKind.RCURLY), pt = U.InlineMap.create(In(xe.startPos, Jt.endPos));
                else {
                  var Ye = Se();
                  if (Zn(i.TokenKind.RCURLY))
                    je.push(Ye), Jt = oo(i.TokenKind.RCURLY), pt = L.InlineList.create(In(xe.startPos, Jt.endPos), je);
                  else if (st(i.TokenKind.COMMA, !0)) {
                    je.push(Ye);
                    do
                      je.push(Se());
                    while (st(i.TokenKind.COMMA, !0));
                    Jt = oo(i.TokenKind.RCURLY), pt = L.InlineList.create($t(xe.startPos, Jt.endPos), je);
                  } else if (st(i.TokenKind.COLON, !0)) {
                    var mn = [];
                    for (mn.push(Ye), mn.push(Se()); st(i.TokenKind.COMMA, !0); )
                      mn.push(Se()), oo(i.TokenKind.COLON), mn.push(Se());
                    Jt = oo(i.TokenKind.RCURLY), pt = U.InlineMap.create(In(xe.startPos, Jt.endPos), mn);
                  } else
                    At(xe.startPos, "OOD");
                }
                return rn(pt), !0;
              }
              function kn() {
                var xe = Kt();
                if (!st(i.TokenKind.LSQUARE, !0))
                  return !1;
                var je = Se();
                return oo(i.TokenKind.RSQUARE), rn(h.Indexer.create($t(xe), je)), !0;
              }
              function gt(xe) {
                var je = Kt();
                if (!on())
                  return !1;
                Nt();
                var pt = Se();
                return pt === null && At($t(je), "MISSING_SELECTION_EXPRESSION"), oo(i.TokenKind.RSQUARE), je.getKind() === i.TokenKind.SELECT_FIRST ? rn(W.Selection.create(xe, W.Selection.FIRST, $t(je), pt)) : je.getKind() === i.TokenKind.SELECT_LAST ? rn(W.Selection.create(xe, W.Selection.LAST, $t(je), pt)) : rn(W.Selection.create(xe, W.Selection.ALL, $t(je), pt)), !0;
              }
              function Ot() {
                for (var xe = [], je = Kt(); _n(je); )
                  Nt(), je.kind !== i.TokenKind.DOT && xe.push(ee.Identifier.create(je.stringValue(), $t(je))), je = Kt();
                xe.length || (je === null && At(ue.length(), "OOD"), At(je.startPos, "NOT_EXPECTED_TOKEN", "qualified ID", je.getKind().toString().toLowerCase()));
                var pt = In(xe[0].getStartPosition(), xe[xe.length - 1].getEndPosition());
                return J.QualifiedIdentifier.create(pt, xe);
              }
              function _n(xe) {
                if (xe === null || xe.kind === i.TokenKind.LITERAL_STRING)
                  return !1;
                if (xe.kind === i.TokenKind.DOT || xe.kind === i.TokenKind.IDENTIFIER)
                  return !0;
                var je = xe.stringValue();
                return je && je.length && de.test(je);
              }
              function wn(xe) {
                if (Zn(i.TokenKind.IDENTIFIER)) {
                  var je = Nt(), pt = bt();
                  return pt === null ? (rn(p.PropertyReference.create(xe, je.stringValue(), $t(je))), !0) : (rn(_.MethodReference.create(xe, je.stringValue(), $t(je), pt)), !0);
                }
                return !1;
              }
              function so() {
                if (yt("new")) {
                  var xe = Nt();
                  if (Zn(i.TokenKind.RSQUARE))
                    return rn(p.PropertyReference.create(xe.stringValue(), $t(xe))), !0;
                  var je = Ot(), pt = [];
                  if (pt.push(je), Zn(i.TokenKind.LSQUARE)) {
                    for (var Jt = []; st(i.TokenKind.LSQUARE, !0); )
                      Zn(i.TokenKind.RSQUARE) ? Jt.push(null) : Jt.push(Se()), oo(i.TokenKind.RSQUARE);
                    ln() && pt.push(Ht()), rn(oe.ConstructorReference.create($t(xe), Jt, pt));
                  } else
                    gn(pt), rn(oe.ConstructorReference.create($t(xe), pt));
                  return !0;
                }
                return !1;
              }
              function rn(xe) {
                te.push(xe);
              }
              function Ht() {
                return te.pop();
              }
              function qn() {
                var xe = Kt();
                if (xe === null)
                  return !1;
                if (xe.getKind() === i.TokenKind.LITERAL_INT || xe.getKind() === i.TokenKind.LITERAL_LONG)
                  rn(c.NumberLiteral.create(parseInt(xe.stringValue(), 10), $t(xe)));
                else if (xe.getKind() === i.TokenKind.LITERAL_REAL || xe.getKind() === i.TokenKind.LITERAL_REAL_FLOAT)
                  rn(c.NumberLiteral.create(parseFloat(xe.stringValue()), $t(xe)));
                else if (xe.getKind() === i.TokenKind.LITERAL_HEXINT || xe.getKind() === i.TokenKind.LITERAL_HEXLONG)
                  rn(c.NumberLiteral.create(parseInt(xe.stringValue(), 16), $t(xe)));
                else if (yt("true"))
                  rn(s.BooleanLiteral.create(!0, $t(xe)));
                else if (yt("false"))
                  rn(s.BooleanLiteral.create(!1, $t(xe)));
                else if (xe.getKind() === i.TokenKind.LITERAL_STRING)
                  rn(l.StringLiteral.create(xe.stringValue(), $t(xe)));
                else
                  return !1;
                return Nt(), !0;
              }
              function Bn() {
                if (Zn(i.TokenKind.LPAREN)) {
                  Nt();
                  var xe = Se();
                  return oo(i.TokenKind.RPAREN), rn(xe), !0;
                } else
                  return !1;
              }
              function Or() {
                var xe = Kt();
                if (xe === null)
                  return null;
                if (xe.isNumericRelationalOperator())
                  return xe;
                if (xe.isIdentifier()) {
                  var je = xe.stringValue();
                  if (je.toLowerCase() === "instanceof")
                    return xe.asInstanceOfToken();
                  if (je.toLowerCase() === "matches")
                    return xe.asMatchesToken();
                  if (je.toLowerCase() === "between")
                    return xe.asBetweenToken();
                }
                return null;
              }
              function oo(xe) {
                var je = Nt();
                return je === null && At(ue.length, "OOD"), je.getKind() !== xe && At(je.startPos, "NOT_EXPECTED_TOKEN", xe.toString().toLowerCase(), je.getKind().toString().toLowerCase()), je;
              }
              function Zn(xe) {
                return st(xe, !1);
              }
              function st(xe, je) {
                if (!Ut())
                  return !1;
                var pt = Kt();
                return pt.getKind() === xe ? (je && me++, !0) : xe === i.TokenKind.IDENTIFIER && pt.getKind().ordinal() >= i.TokenKind.DIV.ordinal() && pt.getKind().ordinal() <= i.TokenKind.NOT.ordinal() && pt.data !== null;
              }
              function ft() {
                if (!Ut())
                  return !1;
                for (var xe = Kt(), je = Array.prototype.slice.call(arguments), pt = 0, Jt = je.length; pt < Jt; pt += 1)
                  if (xe.getKind() === je[pt])
                    return !0;
                return !1;
              }
              function yt(xe) {
                if (!Ut())
                  return !1;
                var je = Kt();
                return je.getKind() === i.TokenKind.IDENTIFIER && je.stringValue().toLowerCase() === xe.toLowerCase();
              }
              function on() {
                if (!Ut())
                  return !1;
                var xe = Kt();
                return xe.getKind() === i.TokenKind.SELECT || xe.getKind() === i.TokenKind.SELECT_FIRST || xe.getKind() === i.TokenKind.SELECT_LAST;
              }
              function Ut() {
                return me < le.length;
              }
              function Nt() {
                return me >= se ? null : le[me++];
              }
              function Kt() {
                return me >= se ? null : le[me];
              }
              function At(xe, je, pt, Jt) {
                throw pt && (je += `
Expected: ` + pt), Jt && (je += `
Actual: ` + Jt), {
                  name: "InternalParseException",
                  message: "Error occurred while attempting to parse expression '" + ue + "' at position " + xe + ". Message: " + je
                };
              }
              function Mt(xe) {
                return xe.getKind().hasPayload() ? xe.stringValue() : xe.getKind().toString().toLowerCase();
              }
              function Ie(xe, je, pt) {
                tt(xe, je), zt(xe, pt);
              }
              function tt(xe, je) {
                je === null && At(xe.startPos, "LEFT_OPERAND_PROBLEM");
              }
              function zt(xe, je) {
                je === null && At(xe.startPos, "RIGHT_OPERAND_PROBLEM");
              }
              function $t(xe) {
                return (xe.startPos << 16) + xe.endPos;
              }
              function In(xe, je) {
                return (xe << 16) + je;
              }
              return {
                setConfiguration: pe,
                parse: be
              };
            };
          },
          /* 6 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Tokenizer = void 0;
            var i = r(7), a = r(2), s = ["DIV", "EQ", "GE", "GT", "LE", "LT", "MOD", "NE", "NOT"], c = [], l = 1, d = 2, u = 4;
            function _() {
              var f;
              for (f = 48; f <= 57; f += 1)
                c[f] |= l | d;
              for (f = 65; f <= 70; f += 1)
                c[f] |= d;
              for (f = 97; f <= 102; f += 1)
                c[f] |= d;
              for (f = 65; f <= 90; f += 1)
                c[f] |= u;
              for (f = 97; f <= 122; f += 1)
                c[f] |= u;
            }
            _();
            function p(f) {
              var g = f, h = f + "\0", b = h.length, v = 0, $ = [];
              function k() {
                for (var Q; v < b; )
                  if (Q = h[v], W(Q))
                    D();
                  else
                    switch (Q) {
                      case "+":
                        x(a.TokenKind.INC) ? E(a.TokenKind.INC) : w(a.TokenKind.PLUS);
                        break;
                      case "_":
                        D();
                        break;
                      case "-":
                        x(a.TokenKind.DEC) ? E(a.TokenKind.DEC) : w(a.TokenKind.MINUS);
                        break;
                      case ":":
                        w(a.TokenKind.COLON);
                        break;
                      case ".":
                        w(a.TokenKind.DOT);
                        break;
                      case ",":
                        w(a.TokenKind.COMMA);
                        break;
                      case "*":
                        w(a.TokenKind.STAR);
                        break;
                      case "/":
                        w(a.TokenKind.DIV);
                        break;
                      case "%":
                        w(a.TokenKind.MOD);
                        break;
                      case "(":
                        w(a.TokenKind.LPAREN);
                        break;
                      case ")":
                        w(a.TokenKind.RPAREN);
                        break;
                      case "[":
                        w(a.TokenKind.LSQUARE);
                        break;
                      case "#":
                        w(a.TokenKind.HASH);
                        break;
                      case "]":
                        w(a.TokenKind.RSQUARE);
                        break;
                      case "{":
                        w(a.TokenKind.LCURLY);
                        break;
                      case "}":
                        w(a.TokenKind.RCURLY);
                        break;
                      case "@":
                        w(a.TokenKind.BEAN_REF);
                        break;
                      case "^":
                        x(a.TokenKind.SELECT_FIRST) ? E(a.TokenKind.SELECT_FIRST) : w(a.TokenKind.POWER);
                        break;
                      case "!":
                        x(a.TokenKind.NE) ? E(a.TokenKind.NE) : x(a.TokenKind.PROJECT) ? E(a.TokenKind.PROJECT) : w(a.TokenKind.NOT);
                        break;
                      case "=":
                        x(a.TokenKind.EQ) ? E(a.TokenKind.EQ) : w(a.TokenKind.ASSIGN);
                        break;
                      case "&":
                        if (!x(a.TokenKind.SYMBOLIC_AND))
                          throw {
                            name: "SpelParseException",
                            message: "Missing character '&' in expression (" + g + ") at position " + v
                          };
                        E(a.TokenKind.SYMBOLIC_AND);
                        break;
                      case "|":
                        if (!x(a.TokenKind.SYMBOLIC_OR))
                          throw {
                            name: "SpelParseException",
                            message: "Missing character '|' in expression (" + g + ") at position " + v
                          };
                        E(a.TokenKind.SYMBOLIC_OR);
                        break;
                      case "?":
                        x(a.TokenKind.SELECT) ? E(a.TokenKind.SELECT) : x(a.TokenKind.ELVIS) ? E(a.TokenKind.ELVIS) : x(a.TokenKind.SAFE_NAVI) ? E(a.TokenKind.SAFE_NAVI) : w(a.TokenKind.QMARK);
                        break;
                      case "$":
                        x(a.TokenKind.SELECT_LAST) ? E(a.TokenKind.SELECT_LAST) : D();
                        break;
                      case ">":
                        x(a.TokenKind.GE) ? E(a.TokenKind.GE) : w(a.TokenKind.GT);
                        break;
                      case "<":
                        x(a.TokenKind.LE) ? E(a.TokenKind.LE) : w(a.TokenKind.LT);
                        break;
                      case "0":
                      case "1":
                      case "2":
                      case "3":
                      case "4":
                      case "5":
                      case "6":
                      case "7":
                      case "8":
                      case "9":
                        I(Q === "0");
                        break;
                      case " ":
                      case "	":
                      case "\r":
                      case `
`:
                        v += 1;
                        break;
                      case "'":
                        S();
                        break;
                      case '"':
                        O();
                        break;
                      case "\0":
                        v += 1;
                        break;
                      case "\\":
                        throw {
                          name: "SpelParseException",
                          message: "Unexpected escape character in expression (" + g + ") at position " + v
                        };
                      default:
                        throw {
                          name: "SpelParseException",
                          message: "Cannot handle character '" + Q + "' in expression (" + g + ") at position " + v
                        };
                    }
              }
              function S() {
                for (var Q = v, X = !1, re; !X; )
                  if (v += 1, re = h[v], re === "'" && (h[v + 1] === "'" ? v += 1 : X = !0), re.charCodeAt(0) === 0)
                    throw {
                      name: "SpelParseException",
                      message: "Non-terminating quoted string in expression (" + g + ") at position " + v
                    };
                v += 1, $.push(new i.Token(a.TokenKind.LITERAL_STRING, P(Q, v), Q, v));
              }
              function O() {
                for (var Q = v, X = !1, re; !X; )
                  if (v += 1, re = h[v], re === '"' && (h[v + 1] === '"' ? v += 1 : X = !0), re.charCodeAt(0) === 0)
                    throw {
                      name: "SpelParseException",
                      message: "Non-terminating double-quoted string in expression (" + g + ") at position " + v
                    };
                v += 1, $.push(new i.Token(a.TokenKind.LITERAL_STRING, P(Q, v), Q, v));
              }
              function I(Q) {
                var X = !1, re = v, Z = h[v + 1], ee = Z === "x" || Z === "X", J, oe, ce, de;
                if (Q && ee) {
                  v = v + 1;
                  do
                    v += 1;
                  while (H(h[v]));
                  j("L", "l") ? (N(P(re + 2, v), !0, re, v), v += 1) : N(P(re + 2, v), !1, re, v);
                  return;
                }
                do
                  v += 1;
                while (U(h[v]));
                if (Z = h[v], Z === ".") {
                  X = !0, J = v;
                  do
                    v += 1;
                  while (U(h[v]));
                  if (v === J + 1) {
                    v = J, M(P(re, v), !1, re, v);
                    return;
                  }
                }
                if (oe = v, j("L", "l")) {
                  if (X)
                    throw {
                      name: "SpelParseException",
                      message: "Real cannot be long in expression (" + g + ") at position " + v
                    };
                  M(P(re, oe), !0, re, oe), v += 1;
                } else if (q(h[v])) {
                  X = !0, v += 1, ce = h[v], L(ce) && (v += 1);
                  do
                    v += 1;
                  while (U(h[v]));
                  de = !1, V(h[v]) ? (de = !0, v += 1, oe = v) : F(h[v]) && (v += 1, oe = v), C(P(re, v), de, re, v);
                } else
                  Z = h[v], de = !1, V(Z) ? (X = !0, de = !0, v += 1, oe = v) : F(Z) && (X = !0, v += 1, oe = v), X ? C(P(re, oe), de, re, oe) : M(P(re, oe), !1, re, oe);
              }
              function D() {
                var Q = v, X, re, Z;
                do
                  v += 1;
                while (z(h[v]));
                if (X = P(Q, v), (v - Q === 2 || v - Q === 3) && (re = X.toUpperCase(), Z = s.indexOf(re), Z >= 0)) {
                  T(a.TokenKind.valueOf(re), Q, X);
                  return;
                }
                $.push(new i.Token(a.TokenKind.IDENTIFIER, X.replace("\0", ""), Q, v));
              }
              function M(Q, X, re, Z) {
                X ? $.push(new i.Token(a.TokenKind.LITERAL_LONG, Q, re, Z)) : $.push(new i.Token(a.TokenKind.LITERAL_INT, Q, re, Z));
              }
              function N(Q, X, re, Z) {
                if (Q.length === 0)
                  throw X ? {
                    name: "SpelParseException",
                    message: "Not a long in expression (" + g + ") at position " + v
                  } : {
                    name: "SpelParseException",
                    message: "Not an int in expression (" + g + ") at position " + v
                  };
                X ? $.push(new i.Token(a.TokenKind.LITERAL_HEXLONG, Q, re, Z)) : $.push(new i.Token(a.TokenKind.LITERAL_HEXINT, Q, re, Z));
              }
              function C(Q, X, re, Z) {
                X ? $.push(new i.Token(a.TokenKind.LITERAL_REAL_FLOAT, Q, re, Z)) : $.push(new i.Token(a.TokenKind.LITERAL_REAL, Q, re, Z));
              }
              function P(Q, X) {
                return h.substring(Q, X);
              }
              function x(Q) {
                return Q.tokenChars.length === 2 && h[v] === Q.tokenChars[0] ? h[v + 1] === Q.tokenChars[1] : !1;
              }
              function w(Q) {
                $.push(new i.Token(Q, null, v, v + 1)), v += 1;
              }
              function E(Q) {
                $.push(new i.Token(Q, null, v, v + 2)), v += 2;
              }
              function T(Q, X, re) {
                $.push(new i.Token(Q, re, X, X + Q.getLength()));
              }
              function z(Q) {
                return W(Q) || U(Q) || Q === "_" || Q === "$";
              }
              function j(Q, X) {
                var re = h[v];
                return re === Q || re === X;
              }
              function q(Q) {
                return Q === "e" || Q === "E";
              }
              function V(Q) {
                return Q === "f" || Q === "F";
              }
              function F(Q) {
                return Q === "d" || Q === "D";
              }
              function L(Q) {
                return Q === "+" || Q === "-";
              }
              function U(Q) {
                return Q.charCodeAt(0) > 255 ? !1 : (c[Q.charCodeAt(0)] & l) !== 0;
              }
              function W(Q) {
                return Q.charCodeAt(0) > 255 ? !1 : (c[Q.charCodeAt(0)] & u) !== 0;
              }
              function H(Q) {
                return Q.charCodeAt(0) > 255 ? !1 : (c[Q.charCodeAt(0)] & d) !== 0;
              }
              return k(), $;
            }
            o.Tokenizer = {
              tokenize: p
            };
          },
          /* 7 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Token = void 0;
            var i = r(2);
            function a(s, c, l, d) {
              this.kind = s, this.startPos = l, this.endPos = d, c && (this.data = c);
            }
            a.prototype.getKind = function() {
              return this.kind;
            }, a.prototype.toString = function() {
              var s = "[";
              return s += this.kind.toString(), this.kind.hasPayload() && (s += ":" + this.data), s += "]", s += "(" + this.startPos + "," + this.endPos + ")", s;
            }, a.prototype.isIdentifier = function() {
              return this.kind === i.TokenKind.IDENTIFIER;
            }, a.prototype.isNumericRelationalOperator = function() {
              return this.kind === i.TokenKind.GT || this.kind === i.TokenKind.GE || this.kind === i.TokenKind.LT || this.kind === i.TokenKind.LE || this.kind === i.TokenKind.EQ || this.kind === i.TokenKind.NE;
            }, a.prototype.stringValue = function() {
              return this.data;
            }, a.prototype.asInstanceOfToken = function() {
              return new a(i.TokenKind.INSTANCEOF, this.startPos, this.endPos);
            }, a.prototype.asMatchesToken = function() {
              return new a(i.TokenKind.MATCHES, this.startPos, this.endPos);
            }, a.prototype.asBetweenToken = function() {
              return new a(i.TokenKind.BETWEEN, this.startPos, this.endPos);
            }, a.prototype.getStartPosition = function() {
              return this.startPos;
            }, a.prototype.getEndPosition = function() {
              return this.endPos;
            }, o.Token = a;
          },
          /* 8 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.BooleanLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("boolean", c);
              return l.getValue = function() {
                return s;
              }, l.setValue = function(d) {
                return s = d;
              }, l;
            }
            o.BooleanLiteral = {
              create: a
            };
          },
          /* 9 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.NumberLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("number", c);
              return l.getValue = function() {
                return s;
              }, l.setValue = function(d) {
                return s = d;
              }, l;
            }
            o.NumberLiteral = {
              create: a
            };
          },
          /* 10 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.StringLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("string", c);
              function d(u) {
                return (u[0] === "'" && u[u.length - 1] === "'" || u[0] === '"' && u[u.length - 1] === '"') && (u = u.substring(1, u.length - 1)), u.replace(/''/g, "'").replace(/""/g, '"');
              }
              return s = d(s), l.getValue = function() {
                return s;
              }, l.setValue = function(u) {
                return s = u;
              }, l;
            }
            o.StringLiteral = {
              create: a
            };
          },
          /* 11 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.NullLiteral = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("null", c);
              return l.getValue = function() {
                return null;
              }, l;
            }
            o.NullLiteral = {
              create: a
            };
          },
          /* 12 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.FunctionReference = void 0;
            var i = r(0), a = r(1);
            function s(c, l, d) {
              var u = i.SpelNode.create("function", l);
              return u.getRaw = function() {
                return {
                  functionName: c,
                  args: d
                };
              }, u.getValue = function(_) {
                var p = _.locals || {}, f = _.rootContext, g = [];
                if (d.forEach(function(h) {
                  var b = _.activeContext;
                  _.activeContext = new a.Stack(), _.activeContext.push(_.rootContext), g.push(h.getValue(_)), _.activeContext = b;
                }), p[c])
                  return p[c].apply(f, g);
                throw {
                  name: "FunctionDoesNotExistException",
                  message: "Function '" + c + "' does not exist."
                };
              }, u;
            }
            o.FunctionReference = {
              create: s
            };
          },
          /* 13 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.MethodReference = void 0;
            var i = r(0), a = r(1);
            function s(c, l, d, u) {
              var _ = i.SpelNode.create("method", d);
              return _.getRaw = function() {
                return {
                  methodName: l,
                  args: u
                };
              }, _.getValue = function(p) {
                var f = p.activeContext.peek(), g = [], h;
                if (!f)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up property '" + l + "' for an undefined context."
                  };
                function b(v) {
                  if (v == null) {
                    if (c)
                      return null;
                    throw {
                      name: "NullPointerException",
                      message: "Method " + l + " does not exist."
                    };
                  }
                  return v;
                }
                if (u.forEach(function(v) {
                  var $ = p.activeContext;
                  p.activeContext = new a.Stack(), p.activeContext.push(p.rootContext), g.push(v.getValue(p)), p.activeContext = $;
                }), l.substr(0, 3) === "get" && !f[l])
                  return b(f[l.charAt(3).toLowerCase() + l.substring(4)]);
                if (l.substr(0, 3) === "set" && !f[l])
                  return f[l.charAt(3).toLowerCase() + l.substring(4)] = g[0];
                if (Array.isArray(f)) {
                  if (l === "size")
                    return f.length;
                  if (l === "contains")
                    return f.includes(g[0]);
                }
                return h = b(f[l]), h ? h.apply(f, g) : null;
              }, _;
            }
            o.MethodReference = {
              create: s
            };
          },
          /* 14 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.PropertyReference = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("property", l);
              return d.getRaw = function() {
                return c;
              }, d.getValue = function(u) {
                var _ = u.activeContext.peek();
                if (!_) {
                  if (s)
                    return null;
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up property '" + c + "' for an undefined context."
                  };
                }
                if (_[c] === void 0 || _[c] === null) {
                  if (s)
                    return null;
                  if (c === "size" && Array.isArray(_))
                    return _.length;
                  throw {
                    name: "NullPointerException",
                    message: "Property '" + c + "' does not exist."
                  };
                }
                return _[c];
              }, d.setValue = function(u, _) {
                var p = _.activeContext.peek();
                if (!p)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to assign property '" + c + "' for an undefined context."
                  };
                return p[c] = u;
              }, d.getName = function() {
                return c;
              }, d;
            }
            o.PropertyReference = {
              create: a
            };
          },
          /* 15 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.VariableReference = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("variable", c);
              return l.getRaw = function() {
                return s;
              }, l.getValue = function(d) {
                var u = d.activeContext.peek(), _ = d.locals;
                if (!u)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to look up variable '" + s + "' for an undefined context."
                  };
                return s === "this" ? u : s === "root" ? d.rootContext : _[s];
              }, l.setValue = function(d, u) {
                var _ = u.locals;
                return _[s] = d;
              }, l;
            }
            o.VariableReference = {
              create: a
            };
          },
          /* 16 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.CompoundExpression = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create.apply(null, ["compound", s].concat(c));
              function d(u) {
                var _ = l.getChildren().length, p;
                for (p = 0; p < _; p += 1)
                  l.getChildren()[p].getType() === "indexer" ? u.activeContext.push(u.activeContext.peek()[l.getChildren()[p].getValue(u)]) : u.activeContext.push(l.getChildren()[p].getValue(u));
                return function() {
                  for (p = 0; p < _; p += 1)
                    u.activeContext.pop();
                };
              }
              return l.getValue = function(u) {
                var _ = u.activeContext.peek(), p;
                if (!_)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to evaluate compound expression with an undefined context."
                  };
                var f = d(u);
                return p = u.activeContext.peek(), f(), p;
              }, l.setValue = function(u, _) {
                var p = d(_), f = l.getChildren().length;
                return _.activeContext.pop(), u = l.getChildren()[f - 1].setValue(u, _), _.activeContext.push(null), p(), u;
              }, l;
            }
            o.CompoundExpression = {
              create: a
            };
          },
          /* 17 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Indexer = void 0;
            var i = r(0), a = r(1);
            function s(c, l) {
              var d = i.SpelNode.create.apply(null, ["indexer", c].concat(l));
              return d.getValue = function(u) {
                var _ = u.activeContext, p, f = d.getChildren().length, g, h;
                if (u.activeContext = new a.Stack(), u.activeContext.push(u.rootContext), p = u.activeContext.peek(), !p)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to evaluate compound expression with an undefined context."
                  };
                for (g = 0; g < f; g += 1)
                  u.activeContext.push(d.getChildren()[g].getValue(u));
                for (h = u.activeContext.peek(), g = 0; g < f; g += 1)
                  u.activeContext.pop();
                return u.activeContext = _, h;
              }, d;
            }
            o.Indexer = {
              create: s
            };
          },
          /* 18 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Assign = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("assign", s, c, l);
              return d.getValue = function(u) {
                var _ = u.activeContext.peek();
                if (!_)
                  throw {
                    name: "ContextDoesNotExistException",
                    message: "Attempting to assign property '" + c.getValue(u) + "' for an undefined context."
                  };
                return c.setValue(l.getValue(u), u);
              }, d;
            }
            o.Assign = {
              create: a
            };
          },
          /* 19 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpEQ = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-eq", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) === l.getValue(u);
              }, d;
            }
            o.OpEQ = {
              create: a
            };
          },
          /* 20 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpNE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-ne", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) !== l.getValue(u);
              }, d;
            }
            o.OpNE = {
              create: a
            };
          },
          /* 21 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpGE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-ge", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) >= l.getValue(u);
              }, d;
            }
            o.OpGE = {
              create: a
            };
          },
          /* 22 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpGT = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-gt", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) > l.getValue(u);
              }, d;
            }
            o.OpGT = {
              create: a
            };
          },
          /* 23 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpLE = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-le", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) <= l.getValue(u);
              }, d;
            }
            o.OpLE = {
              create: a
            };
          },
          /* 24 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpLT = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-lt", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) < l.getValue(u);
              }, d;
            }
            o.OpLT = {
              create: a
            };
          },
          /* 25 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpPlus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-plus", s, c, l);
              return d.getValue = function(u) {
                return l ? c.getValue(u) + l.getValue(u) : +c.getValue(u);
              }, d;
            }
            o.OpPlus = {
              create: a
            };
          },
          /* 26 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMinus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-minus", s, c, l);
              return d.getValue = function(u) {
                return l ? c.getValue(u) - l.getValue(u) : -c.getValue(u);
              }, d;
            }
            o.OpMinus = {
              create: a
            };
          },
          /* 27 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMultiply = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-multiply", s, c, l);
              return d.getValue = function(u) {
                var _ = c.getValue(u), p = l.getValue(u);
                if (typeof _ == "number" && typeof p == "number")
                  return _ * p;
                if (typeof _ == "string" && typeof p == "number") {
                  for (var f = "", g = 0; g < p; g += 1)
                    f += _;
                  return f;
                }
                return null;
              }, d;
            }
            o.OpMultiply = {
              create: a
            };
          },
          /* 28 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpDivide = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-divide", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) / l.getValue(u);
              }, d;
            }
            o.OpDivide = {
              create: a
            };
          },
          /* 29 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpModulus = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-modulus", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) % l.getValue(u);
              }, d;
            }
            o.OpModulus = {
              create: a
            };
          },
          /* 30 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpPower = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-power", s, c, l);
              return d.getValue = function(u) {
                return Math.pow(c.getValue(u), l.getValue(u));
              }, d;
            }
            o.OpPower = {
              create: a
            };
          },
          /* 31 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpInc = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-inc", s, l);
              return d.getValue = function(u) {
                var _ = l.getValue(u);
                return l.setValue(_ + 1, u), c ? _ : _ + 1;
              }, d;
            }
            o.OpInc = {
              create: a
            };
          },
          /* 32 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpDec = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-dec", s, l);
              return d.getValue = function(u) {
                var _ = l.getValue(u);
                return l.setValue(_ - 1, u), c ? _ : _ - 1;
              }, d;
            }
            o.OpDec = {
              create: a
            };
          },
          /* 33 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpNot = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("op-not", s, c);
              return l.getValue = function(d) {
                return !c.getValue(d);
              }, l;
            }
            o.OpNot = {
              create: a
            };
          },
          /* 34 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpAnd = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-and", s, c, l);
              return d.getValue = function(u) {
                return !!c.getValue(u) && !!l.getValue(u);
              }, d;
            }
            o.OpAnd = {
              create: a
            };
          },
          /* 35 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpOr = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("op-or", s, c, l);
              return d.getValue = function(u) {
                return !!c.getValue(u) || !!l.getValue(u);
              }, d;
            }
            o.OpOr = {
              create: a
            };
          },
          /* 36 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpMatches = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("matches", s, c, l);
              return d.getValue = function(u) {
                var _ = c.getValue(u), p = l.getValue(u);
                try {
                  var f = new RegExp(p);
                  return !!f.exec(_);
                } catch (g) {
                  throw {
                    name: "EvaluationException",
                    message: g.toString()
                  };
                }
              }, d;
            }
            o.OpMatches = {
              create: a
            };
          },
          /* 37 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Ternary = void 0;
            var i = r(0);
            function a(s, c, l, d) {
              var u = i.SpelNode.create("ternary", s, c, l, d);
              return u.getValue = function(_) {
                return c.getValue(_) ? l.getValue(_) : d.getValue(_);
              }, u;
            }
            o.Ternary = {
              create: a
            };
          },
          /* 38 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Elvis = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("elvis", s, c, l);
              return d.getValue = function(u) {
                return c.getValue(u) !== null ? c.getValue(u) : l.getValue(u);
              }, d;
            }
            o.Elvis = {
              create: a
            };
          },
          /* 39 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.InlineList = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("list", s), d = [].concat(c || []);
              return l.getRaw = function() {
                return d;
              }, l.getValue = function(u) {
                return d.map(function(_) {
                  return _.getValue(u);
                });
              }, l;
            }
            o.InlineList = {
              create: a
            };
          },
          /* 40 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.InlineMap = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("map", s), d = [].concat(c || []);
              return l.getValue = function(u) {
                var _ = !0, p = null, f = {};
                return d.forEach(function(g) {
                  _ ? g.getType() === "property" ? p = g.getName() : p = g.getValue(u) : f[p] = g.getValue(u), _ = !_;
                }), f;
              }, l;
            }
            o.InlineMap = {
              create: a
            };
          },
          /* 41 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Selection = void 0;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
              return typeof u;
            } : function(u) {
              return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
            }, a = r(0);
            function s(u, _, p) {
              var f = !1;
              return p.activeContext.push(u), f = _.getValue(p), p.activeContext.pop(), f;
            }
            function c(u, _, p, f) {
              var g = u.filter(function(h) {
                return s(h, p, f);
              });
              switch (_) {
                case "ALL":
                  return g;
                case "FIRST":
                  return g[0] || null;
                case "LAST":
                  return g.length ? g[g.length - 1] : null;
              }
            }
            function l(u, _, p, f) {
              var g = {}, h, b, v = [], $ = {};
              for (b in u)
                u.hasOwnProperty(b) && (h = {
                  key: b,
                  value: u[b]
                }, s(h, p, f) && v.push(h));
              switch (_) {
                case "ALL":
                  return v.forEach(function(k) {
                    g[k.key] = k.value;
                  }), g;
                case "FIRST":
                  return v.length ? ($[v[0].key] = v[0].value, $) : null;
                case "LAST":
                  return v.length ? ($[v[v.length - 1].key] = v[v.length - 1].value, $) : null;
              }
              v.forEach(function(k) {
                g[k.key] = k.value;
              });
            }
            function d(u, _, p, f) {
              var g = a.SpelNode.create("selection", p, f);
              return g.getValue = function(h) {
                var b = h.activeContext.peek();
                if (b) {
                  if (Array.isArray(b))
                    return c(b, _, f, h);
                  if ((typeof b > "u" ? "undefined" : i(b)) === "object")
                    return l(b, _, f, h);
                }
                return null;
              }, g;
            }
            o.Selection = {
              create: d,
              FIRST: "FIRST",
              LAST: "LAST",
              ALL: "ALL"
            };
          },
          /* 42 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Projection = void 0;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            }, a = r(0);
            function s(l, d, u) {
              return l.map(function(_) {
                var p;
                return u.activeContext.push(_), p = d.getValue(u), u.activeContext.pop(), p;
              });
            }
            function c(l, d, u) {
              var _ = a.SpelNode.create("projection", d, u);
              return _.getValue = function(p) {
                var f = p.activeContext.peek(), g = [], h;
                if (Array.isArray(f))
                  return s(f, u, p);
                if ((typeof f > "u" ? "undefined" : i(f)) === "object") {
                  for (h in f)
                    f.hasOwnProperty(h) && g.push(f[h]);
                  return s(g, u, p);
                }
                return null;
              }, _;
            }
            o.Projection = {
              create: c
            };
          },
          /* 43 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpInstanceof = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("instanceof", s, c, l);
              return d.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "OpInstanceOf: Not implemented"
                };
              }, d;
            }
            o.OpInstanceof = {
              create: a
            };
          },
          /* 44 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.OpBetween = void 0;
            var i = r(0);
            function a(s, c, l) {
              var d = i.SpelNode.create("between", s, c, l);
              return d.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "OpBetween: Not implemented"
                };
              }, d;
            }
            o.OpBetween = {
              create: a
            };
          },
          /* 45 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.TypeReference = void 0;
            var i = r(0);
            function a(s, d, l) {
              var d = i.SpelNode.create("typeref", s, d);
              return d.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "TypeReference: Not implemented"
                };
              }, d;
            }
            o.TypeReference = {
              create: a
            };
          },
          /* 46 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.BeanReference = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("beanref", s);
              return l.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "BeanReference: Not implemented"
                };
              }, l;
            }
            o.BeanReference = {
              create: a
            };
          },
          /* 47 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.Identifier = void 0;
            var i = r(0);
            function a(s, c) {
              var l = i.SpelNode.create("identifier", c);
              return l.getRaw = function() {
                return s;
              }, l.getValue = function(d) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "Identifier: Not implemented"
                };
              }, l;
            }
            o.Identifier = {
              create: a
            };
          },
          /* 48 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.QualifiedIdentifier = void 0;
            var i = r(0);
            function a(c) {
              if (Array.isArray(c)) {
                for (var l = 0, d = Array(c.length); l < c.length; l++)
                  d[l] = c[l];
                return d;
              } else
                return Array.from(c);
            }
            function s(c, l) {
              var d = i.SpelNode.create.apply(i.SpelNode, ["qualifiedidentifier", c].concat(a(l)));
              return d.getRaw = function() {
                return l.map(function(u) {
                  return u.getRaw();
                });
              }, d.getValue = function(u) {
                throw {
                  name: "MethodNotImplementedException",
                  message: "QualifiedIdentifier: Not implemented"
                };
              }, d;
            }
            o.QualifiedIdentifier = {
              create: s
            };
          },
          /* 49 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            }), o.ConstructorReference = void 0;
            var i = r(0), a = r(1);
            function s(d) {
              if (Array.isArray(d)) {
                for (var u = 0, _ = Array(d.length); u < d.length; u++)
                  _[u] = d[u];
                return _;
              } else
                return Array.from(d);
            }
            function c(d) {
              return Array.isArray(d) ? d : Array.from(d);
            }
            function l(d, u, _) {
              var p = _ !== void 0, f;
              p ? f = u.length && u[0] && u[0].getType() === "number" ? u[0].getValue() : null : (_ = u, u = void 0);
              var g = _, h = c(g);
              h[0];
              var b = h.slice(1), v = i.SpelNode.create.apply(i.SpelNode, ["constructorref", d].concat(s(_)));
              return v.getRaw = function() {
                return f;
              }, v.getValue = function($) {
                if (p && b.length <= 1) {
                  var k = [];
                  return b.forEach(function(S) {
                    var O = $.activeContext;
                    $.activeContext = new a.Stack(), $.activeContext.push($.rootContext), k.push(S.getValue($)), $.activeContext = O;
                  }), b.length === 1 ? k[0] : f ? new Array(f) : [];
                }
                throw {
                  name: "MethodNotImplementedException",
                  message: "ConstructorReference: Not implemented"
                };
              }, v;
            }
            o.ConstructorReference = {
              create: l
            };
          },
          /* 50 */
          /***/
          function(n, o, r) {
            Object.defineProperty(o, "__esModule", {
              value: !0
            });
            function i(a, s) {
              var c = {};
              return c.authentication = a || {}, c.principal = s || {}, c.hasRole = function(l) {
                var d = !1;
                return !l || !c.authentication && !Array.isArray(c.authentication.authorities) ? !1 : (c.authentication.authorities.forEach(function(u) {
                  u.authority.toLowerCase() === l.toLowerCase() && (d = !0);
                }), d);
              }, c.hasPermission = function() {
                var l = Array.prototype.slice.call(arguments);
                if (l.length === 1)
                  return c.hasRole(l[0]);
              }, c;
            }
            o.StandardContext = {
              create: i
            };
          }
          /******/
        ])
      );
    });
  }(hN)), hN.exports;
}
var Fre;
function L_d() {
  if (Fre)
    return Vm;
  Fre = 1;
  var e = Rt;
  Object.defineProperty(Vm, "__esModule", {
    value: !0
  }), Vm.loadFromSpel = Vm._loadFromSpel = void 0;
  var t = e(Tl), n = e(Yn), o = e(rr), r = e(Wc), i = M_d(), a = e(_m()), s = Br(), c = Hi(), l = P7(), d = Ns(), u = Sr(), _ = e(Sg);
  function p(E, T) {
    var z = Object.keys(E);
    if (Object.getOwnPropertySymbols) {
      var j = Object.getOwnPropertySymbols(E);
      T && (j = j.filter(function(q) {
        return Object.getOwnPropertyDescriptor(E, q).enumerable;
      })), z.push.apply(z, j);
    }
    return z;
  }
  function f(E) {
    for (var T = 1; T < arguments.length; T++) {
      var z = arguments[T] != null ? arguments[T] : {};
      T % 2 ? p(Object(z), !0).forEach(function(j) {
        (0, o.default)(E, j, z[j]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(z)) : p(Object(z)).forEach(function(j) {
        Object.defineProperty(E, j, Object.getOwnPropertyDescriptor(z, j));
      });
    }
    return E;
  }
  var g = function(T, z) {
    return h(T, z, !0);
  };
  Vm.loadFromSpel = g;
  var h = function(T, z) {
    var j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, q = {
      errors: []
    }, V = (0, s.extendConfig)(z), F = $(V), L, U, W = void 0;
    try {
      var H = i.SpelExpressionEvaluator.compile(T);
      L = H._compiledExpression;
    } catch (X) {
      q.errors.push(X);
    }
    L && (u.logger.debug("compiledExpression:", L), U = b(L, q), u.logger.debug("convertedObj:", U, q), W = M(U, F, V, q), W && W.type != "group" && W.type != "switch_group" && (W = w(W, V)), u.logger.debug("jsTree:", W));
    var Q = W ? (0, l.loadTree)(W) : void 0;
    return j ? [Q, q.errors] : (q.errors.length && console.warn("Errors while importing from SpEL:", q.errors), Q);
  };
  Vm._loadFromSpel = h;
  var b = function E(T, z) {
    var j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, q = T.getType(), V = T.getChildren().map(function(pe) {
      return E(pe, z, T);
    });
    if ((q == "op-or" || q == "op-and") && (V = V.reduce(function(pe, be) {
      var Se = be.type == q && !be.not, Ae = Se ? be.children : [be];
      return [].concat((0, r.default)(pe), (0, r.default)(Ae));
    }, [])), q == "op-not")
      return V.length != 1 && z.errors.push("Operator NOT should have 1 child, but got ".concat(V.length, "}")), f(f({}, V[0]), {}, {
        not: !V[0].not
      });
    if (q == "compound") {
      V = V.filter(function(pe) {
        var be = pe.type == "selection" && pe.children.length == 1 && pe.children[0].type == "boolean" && pe.children[0].val == !0;
        return !be;
      });
      var F = V.find(function(pe) {
        return pe.type == "selection";
      });
      F && F.children.length != 1 && z.errors.push("Selection should have 1 child, but got ".concat(F.children.length));
      var L = F ? F.children[0] : null, U = V[V.length - 1], W = U.type == "method" && U.val.methodName == "size" || U.type == "!func" && U.methodName == "size", H = U.type == "property" && U.val == "length", Q = V.filter(function(pe) {
        return pe !== F && pe !== U;
      }), X = {
        type: "compound",
        children: Q
      };
      if (W || H)
        return {
          type: "!aggr",
          filter: L,
          source: X
        };
      if (V = V.filter(function(pe) {
        var be = pe.type == "variable" && pe.val == "this", Se = pe.type == "variable" && pe.val == "root";
        return !(be || Se);
      }), V = V.map(function(pe) {
        return pe.type == "indexer" && pe.children.length == 1 ? {
          type: "indexer",
          val: pe.children[0].val,
          itype: pe.children[0].type
        } : pe;
      }), U.type == "method") {
        var re = V.filter(function(pe) {
          return pe !== U;
        });
        return {
          type: "!func",
          obj: re,
          methodName: U.val.methodName,
          args: U.val.args
        };
      }
      if (U.type == "!func") {
        var Z = V.filter(function(pe) {
          return pe !== U;
        });
        return f(f({}, U), {}, {
          obj: Z
        });
      }
    }
    var ee;
    try {
      T.getRaw ? ee = T.getRaw() : T.getValue.length == 0 && (ee = T.getValue());
    } catch (pe) {
      u.logger.error("[spel2js] Error in getValue()", pe);
    }
    if (q == "ternary" && (ee = v(V)), (0, n.default)(ee) === "object" && ee !== null && (ee.methodName || ee.functionName) && (ee.args = ee.args.map(function(pe) {
      return E(pe, z, T);
    })), q == "list" && (ee = ee.map(function(pe) {
      return E(pe, z, T);
    }), !j && ee.length == 1))
      return ee[0];
    if (q == "constructorref") {
      var J = V.find(function(pe) {
        return pe.type == "qualifiedidentifier";
      }), oe = J == null ? void 0 : J.val;
      if (!oe) {
        z.errors.push("Can't find qualifiedidentifier in constructorref children: ".concat(JSON.stringify(V)));
        return;
      }
      var ce = V.filter(function(pe) {
        return pe.type != "qualifiedidentifier";
      });
      return {
        type: "!new",
        cls: oe,
        args: ce
      };
    }
    if (q == "typeref") {
      var de = V.find(function(pe) {
        return pe.type == "qualifiedidentifier";
      }), te = de == null ? void 0 : de.val;
      if (!te) {
        z.errors.push("Can't find qualifiedidentifier in typeref children: ".concat(JSON.stringify(V)));
        return;
      }
      return V.filter(function(pe) {
        return pe.type != "qualifiedidentifier";
      }), {
        type: "!type",
        cls: te
      };
    }
    if (q == "function" || q == "method") {
      var ue = ee, le = ue.functionName, se = ue.methodName, me = ue.args;
      return {
        type: "!func",
        methodName: le || se,
        isVar: q == "function",
        args: me
      };
    }
    return {
      type: q,
      children: V,
      val: ee
    };
  }, v = function(T) {
    var z = [];
    function j(q) {
      var V = (0, t.default)(q, 3), F = V[0], L = V[1], U = V[2];
      z.push([F, L]), (U == null ? void 0 : U.type) == "ternary" ? j(U.children) : z.push([void 0, U]);
    }
    return j(T), z;
  }, $ = function(T) {
    var z = {}, j = function(Z) {
      var ee = T.operators[Z];
      if (ee.spelOps)
        ee.spelOps.forEach(function(oe) {
          var ce = oe;
          z[ce] || (z[ce] = []), z[ce].push(Z);
        });
      else if (ee.spelOp) {
        var J = ee.spelOp;
        z[J] || (z[J] = []), z[J].push(Z);
      } else
        u.logger.log("[spel] No spelOp for operator ".concat(Z));
    };
    for (var q in T.operators)
      j(q);
    var V = {};
    for (var F in T.conjunctions) {
      var L = T.conjunctions[F], U = L.spelConj || F.toLowerCase();
      V[U] = F;
    }
    var W = {};
    for (var H in T.funcs) {
      var Q = T.funcs[H], X = void 0;
      typeof Q.spelFunc == "string" && (X = Q.spelFunc), X && (W[X] || (W[X] = []), W[X].push(H));
    }
    return {
      operators: z,
      conjunctions: V,
      funcs: W
    };
  }, k = function(T, z) {
    var j = !1, q = T.map(function(V) {
      if (V.type == "variable" || V.type == "property" || V.type == "indexer" && V.itype == "string")
        return V.val;
      j = !0, z.errors.push("Unexpected item in compound: ".concat(JSON.stringify(V)));
    });
    return j ? void 0 : q;
  }, S = function E(T, z, j, q, V) {
    if (T != null) {
      var F = j.settings.fieldSeparator, L = {
        number: "number",
        string: "text",
        boolean: "boolean",
        null: "null"
        // should not be
      }, U = V != null && V._groupField ? [V == null ? void 0 : V._groupField] : [];
      if (T.type == "compound") {
        var W, H, Q = k(T.children, q);
        if (!Q)
          return;
        var X = [].concat(U, (0, r.default)(Q)), re = ((W = T.children) === null || W === void 0 || (H = W[0]) === null || H === void 0 ? void 0 : H.type) == "variable";
        return {
          valueSrc: "field",
          //valueType: todo
          isVariable: re,
          value: X.join(F)
        };
      } else if (T.type == "variable" || T.type == "property") {
        var Z = [].concat(U, [T.val]), ee = T.type == "variable";
        return {
          valueSrc: "field",
          //valueType: todo
          isVariable: ee,
          value: Z.join(F)
        };
      } else if (L[T.type]) {
        var J = T.val, oe = L[T.type];
        return V != null && V.isUnary && (J = -J), {
          valueSrc: "value",
          valueType: oe,
          value: J
        };
      } else if (T.type == "list") {
        var ce, de = T.val.map(function(Ht) {
          return E(Ht, z, j, q, T);
        });
        de.length && ((ce = de[0]) === null || ce === void 0 || ce.valueType);
        var te = de.map(function(Ht) {
          return Ht == null ? void 0 : Ht.value;
        }), ue = "multiselect";
        return {
          valueSrc: "value",
          valueType: ue,
          value: te
        };
      } else if (T.type == "!func") {
        var le, se = T.obj, me = T.methodName, pe = T.args;
        T.isVar;
        var be = (le = {}, (0, o.default)(le, ".contains", "like"), (0, o.default)(le, ".startsWith", "starts_with"), (0, o.default)(le, ".endsWith", "ends_with"), (0, o.default)(le, "$contains", "select_any_in"), le), Se = pe.map(function(Ht) {
          return E(Ht, z, j, q, f(f({}, T), {}, {
            _groupField: V == null ? void 0 : V._groupField
          }));
        });
        if (me == "contains" && se && se[0].type == "list") {
          var Ae = se.map(function(Ht) {
            return E(Ht, z, j, q, T);
          });
          if (!(Se.length == 1 && Se[0].valueSrc == "field")) {
            q.errors.push("Expected arg to method ".concat(me, " to be field but got: ").concat(JSON.stringify(Se)));
            return;
          }
          var Ze = Se[0].value;
          if (!(Ae.length == 1 && Ae[0].valueType == "multiselect")) {
            q.errors.push("Expected object of method ".concat(me, " to be inline list but got: ").concat(JSON.stringify(Ae)));
            return;
          }
          var Ge = be["$" + me], rt = Ae[0];
          return O(j, q, Ze, Ge, [rt]);
        } else if (be["." + me]) {
          var qe = be["." + me], Xe = k(se, q);
          if (Xe && Se.length == 1) {
            var lt = [].concat(U, (0, r.default)(Xe)), Et = lt.join(F);
            return O(j, q, Et, qe, Se);
          }
        } else if (me == "parse" && se && se[0].type == "!new" && se[0].cls.at(-1) == "SimpleDateFormat") {
          var wt = se[0].args.map(function(Ht) {
            return E(Ht, z, j, q, f(f({}, T), {}, {
              _groupField: V == null ? void 0 : V._groupField
            }));
          });
          if (!(wt.length == 1 && wt[0].valueType == "text")) {
            q.errors.push("Expected args of ".concat(se[0].cls.join("."), ".").concat(me, " to be 1 string but got: ").concat(JSON.stringify(wt)));
            return;
          }
          if (!(Se.length == 1 && Se[0].valueType == "text")) {
            q.errors.push("Expected args of ".concat(se[0].cls.join("."), " to be 1 string but got: ").concat(JSON.stringify(Se)));
            return;
          }
          var nn = wt[0].value, Dt = Se[0].value, mt = nn.includes(" ") ? "datetime" : "date", bt = null, gn = mt, an = (0, s.getFieldConfig)(j, bt), Mn = j.widgets[gn || (an == null ? void 0 : an.mainWidget)], Ln = Mn.valueFormat, un = (0, _.default)(Dt, _.default.ISO_8601), qo = un.isValid() ? un.format(Ln) : void 0;
          return {
            valueSrc: "value",
            valueType: mt,
            value: qo
          };
        } else if (me == "parse" && se && se[0].type == "!type" && se[0].cls.at(-1) == "LocalTime") {
          if (!(Se.length == 1 && Se[0].valueType == "text")) {
            q.errors.push("Expected args of ".concat(se[0].cls.join("."), " to be 1 string but got: ").concat(JSON.stringify(Se)));
            return;
          }
          var cn = Se[0].value, ln = "time", kn = null, gt = ln, Ot = (0, s.getFieldConfig)(j, kn), _n = j.widgets[gt || (Ot == null ? void 0 : Ot.mainWidget)], wn = _n.valueFormat, so = (0, _.default)(cn, "HH:mm:ss"), rn = so.isValid() ? so.format(wn) : void 0;
          return {
            valueSrc: "value",
            valueType: ln,
            value: rn
          };
        } else
          q.errors.push("Unsupported method ".concat(me));
      } else {
        if (T.type == "op-plus" && (V == null ? void 0 : V.type) == "ternary")
          return P(T, z, j, q);
        q.errors.push("Can't convert arg of type ".concat(T.type));
      }
    }
  }, O = function(T, z, j, q, V) {
    if (!V.filter(function(X) {
      return X === void 0;
    }).length) {
      var F = (0, s.getFieldConfig)(T, j);
      if (!F) {
        z.errors.push("No config for field ".concat(j));
        return;
      }
      var L = (0, c.getWidgetForFieldOp)(T, j, q), U = T.widgets[L || F.mainWidget], W = V.map(function(X) {
        return X.asyncListValues;
      }).filter(function(X) {
        return X != null;
      }), H = W.length ? W[0] : void 0, Q = {
        type: "rule",
        id: (0, a.default)(),
        properties: {
          field: j,
          operator: q,
          value: V.map(function(X) {
            return X.value;
          }),
          valueSrc: V.map(function(X) {
            return X.valueSrc;
          }),
          valueType: V.map(function(X) {
            return X.valueSrc == "value" && ((U == null ? void 0 : U.type) || (F == null ? void 0 : F.type)) || X.valueType;
          }),
          asyncListValues: H
        }
      };
      return Q;
    }
  }, I = function(T, z, j, q, V) {
    var F = T.groupFilter, L = T.groupFieldValue;
    if (L.valueSrc != "field")
      throw "Bad groupFieldValue: ".concat(JSON.stringify(L));
    var U = L.value, W = O(q, V, U, z, j);
    if (W) {
      var H = (0, s.getFieldConfig)(q, U), Q = H == null ? void 0 : H.mode, X = f(f({}, F || {}), {}, {
        type: "rule_group",
        properties: f(f(f({}, W.properties), (F == null ? void 0 : F.properties) || {}), {}, {
          mode: Q
        })
      });
      return X.id || (X.id = (0, a.default)()), X;
    }
  }, D = function(T, z, j, q, V, F) {
    var L = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    if (T.type == z.type)
      if (T.type == "!aggr") {
        var U = [T.source, z.source].map(function(J) {
          return S(J, q, V, F, f(f({}, j), {}, {
            _groupField: L == null ? void 0 : L._groupField
          }));
        }), W = (0, t.default)(U, 2), H = W[0], Q = W[1];
        return H.value == Q.value;
      } else {
        var X = [T, z].map(function(J) {
          return S(J, q, V, F, f(f({}, j), {}, {
            _groupField: L == null ? void 0 : L._groupField
          }));
        }), re = (0, t.default)(X, 2), Z = re[0], ee = re[1];
        return Z.value == ee.value;
      }
    return !1;
  }, M = function E(T, z, j, q) {
    var V = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (T) {
      var F;
      if (T.type.indexOf("op-") == 0) {
        var L = T.type.slice(3), U = (L == "minus" || L == "plus") && T.children.length == 1;
        if (U)
          return T.isUnary = !0, E(T.children[0], z, j, q, T);
        var W = L == "and" && T.children.length == 2 && T.children[0].type == "op-ge" && T.children[1].type == "op-le", H = L == "or" && T.children.length == 2 && T.children[0].type == "op-lt" && T.children[1].type == "op-gt", Q = W || H;
        if (Q) {
          var X = (0, t.default)(T.children[0].children, 2), re = X[0], Z = X[1], ee = (0, t.default)(T.children[1].children, 2), J = ee[0], oe = ee[1], ce = Z.type == "number" && oe.type == "number", de = D(re, J, T, z, j, q, V);
          if (ce && de) {
            Z.val, oe.val;
            var te = {
              type: "op-between",
              children: [re, Z, oe]
            };
            return E(te, z, j, q, V);
          }
        }
        var ue = z.operators[L], le;
        L == "eq" && T.children[1].type == "null" ? le = "is_null" : L == "ne" && T.children[1].type == "null" ? le = "is_not_null" : L == "le" && T.children[1].type == "string" && T.children[1].val == "" ? le = "is_empty" : L == "gt" && T.children[1].type == "string" && T.children[1].val == "" ? le = "is_not_empty" : L == "between" && (le = "between", ue = ["between"]);
        var se = function() {
          return T.children.map(function(bt) {
            return E(bt, z, j, q, f(f({}, T), {}, {
              _groupField: V == null ? void 0 : V._groupField
            }));
          });
        };
        if (L == "and" || L == "or") {
          var me = {}, pe = se();
          pe.forEach(function(mt) {
            if (mt) {
              var bt = (0, a.default)();
              mt.id = bt, mt.type != null ? me[bt] = mt : q.errors.push("Bad item in AND/OR: ".concat(JSON.stringify(mt)));
            }
          }), F = {
            type: "group",
            id: (0, a.default)(),
            children1: me,
            properties: {
              conjunction: z.conjunctions[L],
              not: T.not
            }
          };
        } else if (ue) {
          var be = se(), Se = be[0], Ae = be.slice(1);
          if (le = ue[0], Se)
            if (Se.groupFieldValue) {
              Se.groupFieldValue.valueSrc != "field" && q.errors.push("Expected group field ".concat(JSON.stringify(Se)));
              var Ze = Se.groupFieldValue.value, Ge = Ae[0];
              Ge && Ge.groupFieldValue && Ge.groupFieldValue.valueSrc == "field" && Ge.groupFieldValue.value == Ze ? (le = "all", Ae = []) : le == "equal" && Ge.valueSrc == "value" && Ge.valueType == "number" && Ge.value == 0 ? (le = "none", Ae = []) : le == "greater" && Ge.valueSrc == "value" && Ge.valueType == "number" && Ge.value == 0 && (le = "some", Ae = []), F = I(Se, le, Ae, j, q);
            } else {
              Se.valueSrc != "field" && q.errors.push("Expected field ".concat(JSON.stringify(Se)));
              var rt = Se.value;
              if (ue.length > 1) {
                u.logger.warn("[spel] Spel operator ".concat(L, " can be mapped to ").concat(ue));
                var qe = ue.map(function(mt) {
                  return {
                    op: mt,
                    widget: (0, c.getWidgetForFieldOp)(j, rt, mt)
                  };
                });
                if (L == "eq") {
                  var Xe = qe.find(function(mt) {
                    mt.op;
                    var bt = mt.widget;
                    return bt != "field";
                  });
                  le = Xe.op;
                }
              }
              F = O(j, q, rt, le, Ae);
            }
        } else
          V || (F = N(T, z, j, q)), F || q.errors.push("Can't convert op ".concat(L));
      } else if (T.type == "!aggr") {
        var lt, Et = E(T.source, z, j, q, f(f({}, T), {}, {
          _groupField: V == null ? void 0 : V._groupField
        })), wt = E(T.filter, z, j, q, f(f({}, T), {}, {
          _groupField: Et == null ? void 0 : Et.value
        }));
        ((lt = wt) === null || lt === void 0 ? void 0 : lt.type) == "rule" && (wt = w(wt, j)), F = {
          groupFilter: wt,
          groupFieldValue: Et
        }, V || (F = void 0, q.errors.push("Unexpected !aggr in root"));
      } else if (T.type == "ternary") {
        var nn = {};
        T.val.forEach(function(mt) {
          var bt = (0, t.default)(mt, 2), gn = bt[0], an = bt[1], Mn = C(gn, an, z, j, q, T);
          Mn && (nn[Mn.id] = Mn);
        }), F = {
          type: "switch_group",
          id: (0, a.default)(),
          children1: nn,
          properties: {}
        };
      } else if (F = S(T, z, j, q, V), F && !F.type && !V) {
        var Dt = N(T, z, j, q);
        Dt ? F = Dt : (F = void 0, q.errors.push("Can't convert rule of type ".concat(T.type, ", it looks like var/literal")));
      }
      return F;
    }
  }, N = function(T, z, j, q) {
    var V = {}, F = null, L = C(F, T, z, j, q);
    L && (V[L.id] = L);
    var U = {
      type: "switch_group",
      id: (0, a.default)(),
      children1: V,
      properties: {}
    };
    return U;
  }, C = function(T, z, j, q, V) {
    var F = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, L = x(q, V, j, z, F), U;
    return T ? (U = M(T, j, q, V, F), U && U.type ? (U.type != "group" && (U = w(U, q)), U.type = "case_group") : (V.errors.push("Unexpected case: ".concat(JSON.stringify(U))), U = void 0)) : U = {
      id: (0, a.default)(),
      type: "case_group",
      properties: {}
    }, U && (U.properties = f(f({}, U.properties), L)), U;
  }, P = function(T, z, j, q) {
    var V = [];
    function F(L) {
      L.map(function(U) {
        if (U.type == "op-plus")
          F(U.children);
        else {
          var W = S(U, z, j, q, T);
          W ? V.push(W) : q.errors.push("Can't convert ".concat(U.type, " in concatenation"));
        }
      });
    }
    return F(T.children), {
      valueSrc: "value",
      valueType: "case_value",
      value: V
    };
  }, x = function(T, z, j, q) {
    var V = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, F = {}, L;
    (q == null ? void 0 : q.type) == "op-plus" ? L = P(q, j, T, z) : L = S(q, j, T, z, V);
    var U = T.widgets.case_value, W = U == null ? void 0 : U.spelImportValue;
    if (W) {
      var H = W(L), Q = (0, t.default)(H, 2), X = Q[0], re = Q[1];
      re.map(function(Z) {
        return z.errors.push(Z);
      }), X && (F = {
        value: [X],
        valueSrc: ["value"],
        valueType: ["case_value"]
      });
    } else
      z.errors.push("No fucntion to import case value");
    return F;
  }, w = function(T, z) {
    var j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    return {
      type: "group",
      id: (0, a.default)(),
      children1: (0, o.default)({}, T.id, T),
      properties: {
        conjunction: (0, d.defaultConjunction)(z),
        not: j
      }
    };
  };
  return Vm;
}
var Vre;
function q_d() {
  return Vre || (Vre = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = P7();
    Object.keys(t).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === t[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return t[r];
        }
      });
    });
    var n = D_d();
    Object.keys(n).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === n[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return n[r];
        }
      });
    });
    var o = L_d();
    Object.keys(o).forEach(function(r) {
      r === "default" || r === "__esModule" || r in e && e[r] === o[r] || Object.defineProperty(e, r, {
        enumerable: !0,
        get: function() {
          return o[r];
        }
      });
    });
  }(fN)), fN;
}
var vN = {}, bN = {}, Bre;
function j_d() {
  return Bre || (Bre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(pa), r = t(yr), i = t($r), a = t(wr), s = t(kr()), c = t(ir()), l = p(ve), d = t(di), u = t(Y0e());
    function _(b) {
      if (typeof WeakMap != "function")
        return null;
      var v = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
      return (_ = function(S) {
        return S ? $ : v;
      })(b);
    }
    function p(b, v) {
      if (!v && b && b.__esModule)
        return b;
      if (b === null || n(b) !== "object" && typeof b != "function")
        return { default: b };
      var $ = _(v);
      if ($ && $.has(b))
        return $.get(b);
      var k = {}, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in b)
        if (O !== "default" && Object.prototype.hasOwnProperty.call(b, O)) {
          var I = S ? Object.getOwnPropertyDescriptor(b, O) : null;
          I && (I.get || I.set) ? Object.defineProperty(k, O, I) : k[O] = b[O];
        }
      return k.default = b, $ && $.set(b, k), k;
    }
    function f(b) {
      var v = g();
      return function() {
        var k = (0, c.default)(b), S;
        if (v) {
          var O = (0, c.default)(this).constructor;
          S = Reflect.construct(k, arguments, O);
        } else
          S = k.apply(this, arguments);
        return (0, s.default)(this, S);
      };
    }
    function g() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var h = /* @__PURE__ */ function(b) {
      (0, a.default)($, b);
      var v = f($);
      function $() {
        var k;
        (0, r.default)(this, $);
        for (var S = arguments.length, O = new Array(S), I = 0; I < S; I++)
          O[I] = arguments[I];
        return k = v.call.apply(v, [this].concat(O)), k.handleChange = function(D) {
          k.props.setOption("proximity", parseInt(D));
        }, k;
      }
      return (0, i.default)($, [{
        key: "render",
        value: function() {
          var S = this.props, O = S.defaults, I = S.options, D = S.config, M = S.optionLabel, N = S.optionPlaceholder, C = S.customProps, P = S.minProximity, x = S.maxProximity, w = S.optionTextBefore, E = S.readonly, T = D.settings, z = D.widgets, j = O ? O.proximity : void 0, q = T.showLabels, V = I.get("proximity", j), F = (0, u.default)(P, x + 1).map(function(U) {
            return {
              title: U,
              value: U
            };
          }), L = z.select.factory;
          return /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--PROXIMITY"
          }, /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--options"
          }, q && /* @__PURE__ */ l.default.createElement("label", {
            className: "rule--label"
          }, M), !q && w && /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--options--sep"
          }, /* @__PURE__ */ l.default.createElement("span", null, w)), /* @__PURE__ */ l.default.createElement(L, (0, o.default)({
            config: D,
            value: V,
            listValues: F,
            setValue: this.handleChange,
            readonly: E,
            placeholder: N
          }, C))), /* @__PURE__ */ l.default.createElement("div", {
            className: "operator--widgets"
          }, this.props.children));
        }
      }]), $;
    }(l.PureComponent);
    e.default = h, h.propTypes = {
      config: d.default.object.isRequired,
      setOption: d.default.func.isRequired,
      options: d.default.any.isRequired,
      //instanceOf(Immutable.Map)
      minProximity: d.default.number,
      maxProximity: d.default.number,
      optionPlaceholder: d.default.string,
      optionTextBefore: d.default.string,
      optionLabel: d.default.string,
      customProps: d.default.object,
      readonly: d.default.bool
      //children
    }, h.defaultProps = {
      customProps: {},
      minProximity: 2,
      maxProximity: 10,
      optionPlaceholder: "Select words between",
      optionLabel: "Words between",
      optionTextBefore: null
    };
  }(bN)), bN;
}
var Ure;
function i1e() {
  return Ure || (Ure = 1, function(e) {
    var t = Rt;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ProximityOperator", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    });
    var n = t(j_d());
  }(vN)), vN;
}
var yN = {}, Ul = {}, Wre;
function F_d() {
  if (Wre)
    return Ul;
  Wre = 1;
  var e = Rt;
  Object.defineProperty(Ul, "__esModule", {
    value: !0
  }), Ul.simulateAsyncFetch = Ul.mergeListValues = Ul.listValueToOption = Ul.getListValue = void 0;
  var t = e(MA()), n = e(Wc), o = e(LA()), r = Sr(), i = function(d) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3;
    return /* @__PURE__ */ function() {
      var p = (0, o.default)(/* @__PURE__ */ t.default.mark(function f(g, h, b) {
        var v, $, k, S, O, I;
        return t.default.wrap(function(M) {
          for (; ; )
            switch (M.prev = M.next) {
              case 0:
                return v = b.pageSize != null ? b.pageSize : u, $ = (0, r.listValuesToArray)(d).filter(function(N) {
                  var C = N.title;
                  return g == null ? !0 : C.toUpperCase().indexOf(g.toUpperCase()) != -1;
                }), v && Math.ceil($.length / v), k = h || 0, S = v ? $.slice(k, k + v) : $, O = v ? k + S.length : null, I = v ? O < $.length : !1, console.debug("simulateAsyncFetch", {
                  search: g,
                  offset: h,
                  values: S,
                  hasMore: I,
                  filtered: $
                }), M.next = 11, (0, r.sleep)(_);
              case 11:
                return M.abrupt("return", {
                  values: S,
                  hasMore: I
                });
              case 12:
              case "end":
                return M.stop();
            }
        }, f);
      }));
      return function(f, g, h) {
        return p.apply(this, arguments);
      };
    }();
  };
  Ul.simulateAsyncFetch = i;
  var a = function(d, u) {
    var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (!u)
      return d;
    var p = d || [], f = u.filter(function(h) {
      return p.find(function(b) {
        return b.value == h.value;
      }) == null;
    }), g = _ ? [].concat((0, n.default)(f), (0, n.default)(p)) : [].concat((0, n.default)(p), (0, n.default)(f));
    return g;
  };
  Ul.mergeListValues = a;
  var s = function(d) {
    if (d == null)
      return null;
    var u = d.title, _ = d.value, p = d.disabled, f = d.groupTitle, g = d.renderTitle, h = {
      title: u,
      value: _
    };
    return p && (h.disabled = p), f && (h.groupTitle = f), g && (h.renderTitle = g), h;
  };
  Ul.listValueToOption = s;
  var c = function(d, u) {
    return (0, r.mapListValues)(u, function(_) {
      return _.value === d ? _ : null;
    }).filter(function(_) {
      return _ !== null;
    }).shift();
  };
  return Ul.getListValue = c, Ul;
}
var Gre;
function V_d() {
  return Gre || (Gre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.TreeUtils = e.ExportUtils = e.DefaultUtils = e.ConfigUtils = void 0, Object.defineProperty(e, "getSwitchValues", {
      enumerable: !0,
      get: function() {
        return c.getSwitchValues;
      }
    }), Object.defineProperty(e, "simulateAsyncFetch", {
      enumerable: !0,
      get: function() {
        return r.simulateAsyncFetch;
      }
    }), Object.defineProperty(e, "uuid", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "validateTree", {
      enumerable: !0,
      get: function() {
        return o.validateTree;
      }
    });
    var o = Ek(), r = F_d(), i = t(_m()), a = u(Br());
    e.ConfigUtils = a;
    var s = u(Ns());
    e.DefaultUtils = s;
    var c = u(yg());
    e.TreeUtils = c;
    var l = u(yz());
    e.ExportUtils = l;
    function d(_) {
      if (typeof WeakMap != "function")
        return null;
      var p = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
      return (d = function(h) {
        return h ? f : p;
      })(_);
    }
    function u(_, p) {
      if (!p && _ && _.__esModule)
        return _;
      if (_ === null || n(_) !== "object" && typeof _ != "function")
        return { default: _ };
      var f = d(p);
      if (f && f.has(_))
        return f.get(_);
      var g = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var b in _)
        if (b !== "default" && Object.prototype.hasOwnProperty.call(_, b)) {
          var v = h ? Object.getOwnPropertyDescriptor(_, b) : null;
          v && (v.get || v.set) ? Object.defineProperty(g, b, v) : g[b] = _[b];
        }
      return g.default = _, f && f.set(_, g), g;
    }
  }(yN)), yN;
}
var gc = {}, Hre;
function B_d() {
  if (Hre)
    return gc;
  Hre = 1;
  var e = Rt;
  Object.defineProperty(gc, "__esModule", {
    value: !0
  }), gc.UPPER = gc.RELATIVE_DATETIME = gc.NOW = gc.LOWER = gc.LINEAR_REGRESSION = void 0;
  var t = e(Sg), n = {
    label: "Now",
    returnType: "datetime",
    jsonLogic: "now",
    //todo: document option `jsonLogicCustomOps`
    //todo: add util to return all used custom ops to be added by user with `jsonLogic.add_operation`
    jsonLogicCustomOps: {
      now: function() {
        return /* @__PURE__ */ new Date();
      }
    },
    spelFunc: "new java.util.Date()",
    sqlFormatFunc: function() {
      return "NOW()";
    },
    mongoFormatFunc: function() {
      return /* @__PURE__ */ new Date();
    },
    formatFunc: function() {
      return "NOW";
    }
  };
  gc.NOW = n;
  var o = {
    label: "Relative",
    returnType: "datetime",
    renderBrackets: ["", ""],
    renderSeps: ["", "", ""],
    jsonLogic: function(c) {
      var l = c.date, d = c.op, u = c.val, _ = c.dim;
      return {
        date_add: [l, u * (d == "minus" ? -1 : 1), _]
      };
    },
    jsonLogicImport: function(c) {
      var l = c.date_add[0], d = Math.abs(c.date_add[1]), u = c.date_add[1] >= 0 ? "plus" : "minus", _ = c.date_add[2];
      return [l, u, d, _];
    },
    jsonLogicCustomOps: {
      date_add: function(c, l, d) {
        return (0, t.default)(c).add(l, d).toDate();
      }
    },
    // MySQL
    //todo: other SQL dialects?
    sqlFormatFunc: function(c) {
      var l = c.date, d = c.op, u = c.val, _ = c.dim;
      return "DATE_ADD(".concat(l, ", INTERVAL ").concat(parseInt(u) * (d == "minus" ? -1 : 1), " ").concat(_.replace(/^'|'$/g, ""), ")");
    },
    mongoFormatFunc: null,
    //todo: support?
    //todo: spel
    formatFunc: function(c) {
      var l = c.date, d = c.op, u = c.val, _ = c.dim;
      return u ? "".concat(l, " ").concat(d == "minus" ? "-" : "+", " ").concat(u, " ").concat(_) : l;
    },
    args: {
      date: {
        label: "Date",
        type: "datetime",
        defaultValue: {
          func: "NOW",
          args: []
        },
        valueSources: ["func", "field"]
      },
      op: {
        label: "Op",
        type: "select",
        defaultValue: "plus",
        valueSources: ["value"],
        mainWidgetProps: {
          customProps: {
            showSearch: !1
          }
        },
        fieldSettings: {
          listValues: {
            plus: "+",
            minus: "-"
          }
        }
      },
      val: {
        label: "Value",
        type: "number",
        fieldSettings: {
          min: 0
        },
        defaultValue: 0,
        valueSources: ["value"]
      },
      dim: {
        label: "Dimension",
        type: "select",
        defaultValue: "day",
        valueSources: ["value"],
        mainWidgetProps: {
          customProps: {
            showSearch: !1
          }
        },
        fieldSettings: {
          listValues: {
            day: "day",
            week: "week",
            month: "month",
            year: "year"
          }
        }
      }
    }
  };
  gc.RELATIVE_DATETIME = o;
  var r = {
    label: "Lowercase",
    mongoFunc: "$toLower",
    jsonLogic: "toLowerCase",
    spelFunc: ".toLowerCase",
    //jsonLogicIsMethod: true, // Removed in JsonLogic 2.x due to Prototype Pollution
    jsonLogicCustomOps: {
      toLowerCase: function(c) {
        return c.toLowerCase();
      }
    },
    returnType: "text",
    args: {
      str: {
        label: "String",
        type: "text",
        valueSources: ["value", "field"]
      }
    }
  };
  gc.LOWER = r;
  var i = {
    label: "Uppercase",
    mongoFunc: "$toUpper",
    jsonLogic: "toUpperCase",
    spelFunc: ".toUpperCase",
    //jsonLogicIsMethod: true, // Removed in JsonLogic 2.x due to Prototype Pollution
    jsonLogicCustomOps: {
      toUpperCase: function(c) {
        return c.toUpperCase();
      }
    },
    returnType: "text",
    args: {
      str: {
        label: "String",
        type: "text",
        valueSources: ["value", "field"]
      }
    }
  };
  gc.UPPER = i;
  var a = {
    label: "Linear regression",
    returnType: "number",
    formatFunc: function(c, l) {
      var d = c.coef, u = c.bias, _ = c.val;
      return "(".concat(d, " * ").concat(_, " + ").concat(u, ")");
    },
    sqlFormatFunc: function(c) {
      var l = c.coef, d = c.bias, u = c.val;
      return "(".concat(l, " * ").concat(u, " + ").concat(d, ")");
    },
    spelFormatFunc: function(c) {
      var l = c.coef, d = c.bias, u = c.val;
      return "(".concat(l, " * ").concat(u, " + ").concat(d, ")");
    },
    mongoFormatFunc: function(c) {
      var l = c.coef, d = c.bias, u = c.val;
      return {
        $sum: [{
          $multiply: [l, u]
        }, d]
      };
    },
    jsonLogic: function(c) {
      var l = c.coef, d = c.bias, u = c.val;
      return {
        "+": [{
          "*": [l, u]
        }, d]
      };
    },
    jsonLogicImport: function(c) {
      var l = c["+"][0]["*"][0], d = c["+"][0]["*"][1], u = c["+"][1];
      return [l, d, u];
    },
    renderBrackets: ["", ""],
    renderSeps: [" * ", " + "],
    args: {
      coef: {
        label: "Coef",
        type: "number",
        defaultValue: 1,
        valueSources: ["value"]
      },
      val: {
        label: "Value",
        type: "number",
        valueSources: ["value", "field"]
      },
      bias: {
        label: "Bias",
        type: "number",
        defaultValue: 0,
        valueSources: ["value"]
      }
    }
  };
  return gc.LINEAR_REGRESSION = a, gc;
}
var $N = {}, Kre;
function U_d() {
  return Kre || (Kre = 1, function(e) {
    var t = Rt, n = Yn;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.stringifyForDisplay = e.mongoFormatOp2 = e.mongoFormatOp1 = e.default = void 0;
    var o = t(rr), r = t(ve), i = _(w7()), a = _(i1e()), s = yz(), c = Sr(), l = t(Sg), d = Ib();
    function u(F) {
      if (typeof WeakMap != "function")
        return null;
      var L = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap();
      return (u = function(H) {
        return H ? U : L;
      })(F);
    }
    function _(F, L) {
      if (!L && F && F.__esModule)
        return F;
      if (F === null || n(F) !== "object" && typeof F != "function")
        return { default: F };
      var U = u(L);
      if (U && U.has(F))
        return U.get(F);
      var W = {}, H = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var Q in F)
        if (Q !== "default" && Object.prototype.hasOwnProperty.call(F, Q)) {
          var X = H ? Object.getOwnPropertyDescriptor(F, Q) : null;
          X && (X.get || X.set) ? Object.defineProperty(W, Q, X) : W[Q] = F[Q];
        }
      return W.default = F, U && U.set(F, W), W;
    }
    function p(F, L) {
      var U = Object.keys(F);
      if (Object.getOwnPropertySymbols) {
        var W = Object.getOwnPropertySymbols(F);
        L && (W = W.filter(function(H) {
          return Object.getOwnPropertyDescriptor(F, H).enumerable;
        })), U.push.apply(U, W);
      }
      return U;
    }
    function f(F) {
      for (var L = 1; L < arguments.length; L++) {
        var U = arguments[L] != null ? arguments[L] : {};
        L % 2 ? p(Object(U), !0).forEach(function(W) {
          (0, o.default)(F, W, U[W]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(F, Object.getOwnPropertyDescriptors(U)) : p(Object(U)).forEach(function(W) {
          Object.defineProperty(F, W, Object.getOwnPropertyDescriptor(U, W));
        });
      }
      return F;
    }
    var g = i.VanillaBooleanWidget, h = i.VanillaTextWidget, b = i.VanillaTextAreaWidget, v = i.VanillaDateWidget, $ = i.VanillaTimeWidget, k = i.VanillaDateTimeWidget, S = i.VanillaMultiSelectWidget, O = i.VanillaSelectWidget, I = i.VanillaNumberWidget, D = i.VanillaSliderWidget, M = i.ValueFieldWidget, N = i.FuncWidget, C = a.ProximityOperator, P = {
      AND: {
        label: "And",
        mongoConj: "$and",
        jsonLogicConj: "and",
        sqlConj: "AND",
        spelConj: "and",
        spelConjs: ["and", "&&"],
        reversedConj: "OR",
        formatConj: function(L, U, W, H) {
          return L.size > 1 ? (W ? "NOT " : "") + "(" + L.join(" " + (H ? "AND" : "&&") + " ") + ")" : (W ? "NOT (" : "") + L.first() + (W ? ")" : "");
        },
        sqlFormatConj: function(L, U, W) {
          return L.size > 1 ? (W ? "NOT " : "") + "(" + L.join(" AND ") + ")" : (W ? "NOT (" : "") + L.first() + (W ? ")" : "");
        },
        spelFormatConj: function(L, U, W, H) {
          return W && (H = !1), L.size > 1 ? (W ? "!" : "") + (H ? "" : "(") + L.join(" && ") + (H ? "" : ")") : (W ? "!(" : "") + L.first() + (W ? ")" : "");
        }
      },
      OR: {
        label: "Or",
        mongoConj: "$or",
        jsonLogicConj: "or",
        sqlConj: "OR",
        spelConj: "or",
        spelConjs: ["or", "||"],
        reversedConj: "AND",
        formatConj: function(L, U, W, H) {
          return L.size > 1 ? (W ? "NOT " : "") + "(" + L.join(" " + (H ? "OR" : "||") + " ") + ")" : (W ? "NOT (" : "") + L.first() + (W ? ")" : "");
        },
        sqlFormatConj: function(L, U, W) {
          return L.size > 1 ? (W ? "NOT " : "") + "(" + L.join(" OR ") + ")" : (W ? "NOT (" : "") + L.first() + (W ? ")" : "");
        },
        spelFormatConj: function(L, U, W, H) {
          return W && (H = !1), L.size > 1 ? (W ? "!" : "") + (H ? "" : "(") + L.join(" || ") + (H ? "" : ")") : (W ? "!(" : "") + L.first() + (W ? ")" : "");
        }
      }
    }, x = function(L, U, W, H, Q, X, re, Z, ee, J, oe, ce) {
      var de = typeof H == "string" && !H.startsWith("$") ? "$" + H : H, te = U(X, ce);
      if (te !== void 0)
        return W ? !re && (!L || L == "$eq") ? (0, o.default)({}, H, {
          $ne: te
        }) : re ? {
          $not: (0, o.default)({}, L, [de, te])
        } : (0, o.default)({}, H, {
          $not: (0, o.default)({}, L, te)
        }) : !re && (!L || L == "$eq") ? (0, o.default)({}, H, te) : re ? (0, o.default)({}, L, [de, te]) : (0, o.default)({}, H, (0, o.default)({}, L, te));
    };
    e.mongoFormatOp1 = x;
    var w = function(L, U, W, H, Q, X, re, Z, ee, J, oe) {
      var ce = typeof W == "string" && !W.startsWith("$") ? "$" + W : W;
      if (U) {
        var de;
        return X ? {
          $not: {
            $and: [(0, o.default)({}, L[0], [ce, Q[0]]), (0, o.default)({}, L[1], [ce, Q[1]])]
          }
        } : (0, o.default)({}, W, {
          $not: (de = {}, (0, o.default)(de, L[0], Q[0]), (0, o.default)(de, L[1], Q[1]), de)
        });
      } else {
        var te;
        return X ? {
          $and: [(0, o.default)({}, L[0], [ce, Q[0]]), (0, o.default)({}, L[1], [ce, Q[1]])]
        } : (0, o.default)({}, W, (te = {}, (0, o.default)(te, L[0], Q[0]), (0, o.default)(te, L[1], Q[1]), te));
      }
    };
    e.mongoFormatOp2 = w;
    var E = {
      equal: {
        label: "==",
        labelForFormat: "==",
        sqlOp: "=",
        spelOp: "==",
        spelOps: ["==", "eq"],
        reversedOp: "not_equal",
        formatOp: function(L, U, W, H, Q, X, re, Z, ee) {
          var J = Z ? "=" : X.label;
          return Q == "boolean" && Z ? W == "No" ? "NOT ".concat(L) : "".concat(L) : "".concat(L, " ").concat(J, " ").concat(W);
        },
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return F;
        }, !1),
        jsonLogic: "==",
        elasticSearchQueryType: "term"
      },
      not_equal: {
        isNotOp: !0,
        label: "!=",
        labelForFormat: "!=",
        sqlOp: "<>",
        spelOp: "!=",
        spelOps: ["!=", "ne"],
        reversedOp: "equal",
        formatOp: function(L, U, W, H, Q, X, re, Z, ee) {
          return Q == "boolean" && Z ? W == "No" ? "".concat(L) : "NOT ".concat(L) : "".concat(L, " ").concat(X.label, " ").concat(W);
        },
        mongoFormatOp: x.bind(null, "$ne", function(F) {
          return F;
        }, !1),
        jsonLogic: "!="
      },
      less: {
        label: "<",
        labelForFormat: "<",
        sqlOp: "<",
        spelOp: "<",
        spelOps: ["<", "lt"],
        reversedOp: "greater_or_equal",
        mongoFormatOp: x.bind(null, "$lt", function(F) {
          return F;
        }, !1),
        jsonLogic: "<",
        elasticSearchQueryType: "range"
      },
      less_or_equal: {
        label: "<=",
        labelForFormat: "<=",
        sqlOp: "<=",
        spelOp: "<=",
        spelOps: ["<=", "le"],
        reversedOp: "greater",
        mongoFormatOp: x.bind(null, "$lte", function(F) {
          return F;
        }, !1),
        jsonLogic: "<=",
        elasticSearchQueryType: "range"
      },
      greater: {
        label: ">",
        labelForFormat: ">",
        sqlOp: ">",
        spelOp: ">",
        spelOps: [">", "gt"],
        reversedOp: "less_or_equal",
        mongoFormatOp: x.bind(null, "$gt", function(F) {
          return F;
        }, !1),
        jsonLogic: ">",
        elasticSearchQueryType: "range"
      },
      greater_or_equal: {
        label: ">=",
        labelForFormat: ">=",
        sqlOp: ">=",
        spelOp: ">=",
        spelOps: [">=", "ge"],
        reversedOp: "less",
        mongoFormatOp: x.bind(null, "$gte", function(F) {
          return F;
        }, !1),
        jsonLogic: ">=",
        elasticSearchQueryType: "range"
      },
      like: {
        label: "Contains",
        labelForFormat: "Contains",
        reversedOp: "not_like",
        sqlOp: "LIKE",
        spelOp: ".contains",
        spelOps: ["matches", ".contains"],
        mongoFormatOp: x.bind(null, "$regex", function(F) {
          return typeof F == "string" ? (0, c.escapeRegExp)(F) : void 0;
        }, !1),
        //jsonLogic: (field, op, val) => ({ "in": [val, field] }),
        jsonLogic: "in",
        _jsonLogicIsRevArgs: !0,
        valueSources: ["value"],
        elasticSearchQueryType: "regexp"
      },
      not_like: {
        isNotOp: !0,
        label: "Not contains",
        reversedOp: "like",
        labelForFormat: "Not Contains",
        sqlOp: "NOT LIKE",
        mongoFormatOp: x.bind(null, "$regex", function(F) {
          return typeof F == "string" ? (0, c.escapeRegExp)(F) : void 0;
        }, !0),
        valueSources: ["value"]
      },
      starts_with: {
        label: "Starts with",
        labelForFormat: "Starts with",
        sqlOp: "LIKE",
        spelOp: ".startsWith",
        spelOps: ["matches", ".startsWith"],
        mongoFormatOp: x.bind(null, "$regex", function(F) {
          return typeof F == "string" ? "^" + (0, c.escapeRegExp)(F) : void 0;
        }, !1),
        jsonLogic: void 0,
        // not supported
        valueSources: ["value"]
      },
      ends_with: {
        label: "Ends with",
        labelForFormat: "Ends with",
        sqlOp: "LIKE",
        spelOp: ".endsWith",
        spelOps: ["matches", ".endsWith"],
        mongoFormatOp: x.bind(null, "$regex", function(F) {
          return typeof F == "string" ? (0, c.escapeRegExp)(F) + "$" : void 0;
        }, !1),
        jsonLogic: void 0,
        // not supported
        valueSources: ["value"]
      },
      between: {
        label: "Between",
        labelForFormat: "BETWEEN",
        sqlOp: "BETWEEN",
        cardinality: 2,
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W.first(), J = W.get(1);
          return Z ? "".concat(L, " BETWEEN ").concat(ee, " AND ").concat(J) : "".concat(L, " >= ").concat(ee, " && ").concat(L, " <= ").concat(J);
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W[0], J = W[1];
          return "".concat(L, " >= ").concat(ee, " && ").concat(L, " <= ").concat(J);
        },
        mongoFormatOp: w.bind(null, ["$gte", "$lte"], !1),
        valueLabels: ["Value from", "Value to"],
        textSeparators: [null, "and"],
        reversedOp: "not_between",
        jsonLogic: "<=",
        validateValues: function(L) {
          return L[0] != null && L[1] != null ? L[0] <= L[1] ? null : "Invalid range" : null;
        },
        elasticSearchQueryType: function(L) {
          return L === "time" ? "filter" : "range";
        }
      },
      not_between: {
        isNotOp: !0,
        label: "Not between",
        labelForFormat: "NOT BETWEEN",
        sqlOp: "NOT BETWEEN",
        cardinality: 2,
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W.first(), J = W.get(1);
          return Z ? "".concat(L, " NOT BETWEEN ").concat(ee, " AND ").concat(J) : "(".concat(L, " < ").concat(ee, " || ").concat(L, " > ").concat(J, ")");
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W[0], J = W[1];
          return "(".concat(L, " < ").concat(ee, " || ").concat(L, " > ").concat(J, ")");
        },
        mongoFormatOp: w.bind(null, ["$gte", "$lte"], !0),
        valueLabels: ["Value from", "Value to"],
        textSeparators: [null, "and"],
        reversedOp: "between",
        validateValues: function(L) {
          return L[0] != null && L[1] != null ? L[0] <= L[1] ? null : "Invalid range" : null;
        }
      },
      is_empty: {
        label: "Is empty",
        labelForFormat: "IS EMPTY",
        cardinality: 0,
        reversedOp: "is_not_empty",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return Z ? "".concat(L, " IS EMPTY") : "!".concat(L);
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = (0, s.sqlEmptyValue)(Z);
          return "COALESCE(".concat(L, ", ").concat(ee, ") = ").concat(ee);
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          return "".concat(L, " <= ''");
        },
        mongoFormatOp: x.bind(null, "$in", function(F, L) {
          return [(0, s.mongoEmptyValue)(L), null];
        }, !1),
        jsonLogic: "!"
      },
      is_not_empty: {
        isNotOp: !0,
        label: "Is not empty",
        labelForFormat: "IS NOT EMPTY",
        cardinality: 0,
        reversedOp: "is_empty",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return Z ? "".concat(L, " IS NOT EMPTY") : "!!".concat(L);
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = (0, s.sqlEmptyValue)(Z);
          return "COALESCE(".concat(L, ", ").concat(ee, ") <> ").concat(ee);
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          return "".concat(L, " > ''");
        },
        mongoFormatOp: x.bind(null, "$nin", function(F, L) {
          return [(0, s.mongoEmptyValue)(L), null];
        }, !1),
        jsonLogic: "!!",
        elasticSearchQueryType: "exists"
      },
      is_null: {
        label: "Is null",
        labelForFormat: "IS NULL",
        sqlOp: "IS NULL",
        cardinality: 0,
        reversedOp: "is_not_null",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return Z ? "".concat(L, " IS NULL") : "!".concat(L);
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          return "".concat(L, " == null");
        },
        // check if value is null OR not exists
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return null;
        }, !1),
        jsonLogic: "=="
      },
      is_not_null: {
        label: "Is not null",
        labelForFormat: "IS NOT NULL",
        sqlOp: "IS NOT NULL",
        cardinality: 0,
        reversedOp: "is_null",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return Z ? "".concat(L, " IS NOT NULL") : "!!".concat(L);
        },
        spelFormatOp: function(L, U, W, H, Q, X, re, Z) {
          return "".concat(L, " != null");
        },
        // check if value exists and is not null
        mongoFormatOp: x.bind(null, "$ne", function(F) {
          return null;
        }, !1),
        jsonLogic: "!=",
        elasticSearchQueryType: "exists"
      },
      select_equals: {
        label: "==",
        labelForFormat: "==",
        sqlOp: "=",
        // enum/set
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = Z ? "=" : "==";
          return "".concat(L, " ").concat(ee, " ").concat(W);
        },
        spelOp: "==",
        spelOps: ["==", "eq"],
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return F;
        }, !1),
        reversedOp: "select_not_equals",
        jsonLogic: "==",
        elasticSearchQueryType: "term"
      },
      select_not_equals: {
        isNotOp: !0,
        label: "!=",
        labelForFormat: "!=",
        sqlOp: "<>",
        // enum/set
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return "".concat(L, " != ").concat(W);
        },
        spelOp: "!=",
        spelOps: ["!=", "ne"],
        mongoFormatOp: x.bind(null, "$ne", function(F) {
          return F;
        }, !1),
        reversedOp: "select_equals",
        jsonLogic: "!="
      },
      select_any_in: {
        label: "Any in",
        labelForFormat: "IN",
        sqlOp: "IN",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return H == "value" ? "".concat(L, " IN (").concat(W.join(", "), ")") : "".concat(L, " IN (").concat(W, ")");
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          if (H == "value")
            return "".concat(L, " IN (").concat(W.join(", "), ")");
        },
        spelOp: "$contains",
        // tip: $ means first arg is object
        mongoFormatOp: x.bind(null, "$in", function(F) {
          return F;
        }, !1),
        reversedOp: "select_not_any_in",
        jsonLogic: "in",
        elasticSearchQueryType: "term"
      },
      select_not_any_in: {
        isNotOp: !0,
        label: "Not in",
        labelForFormat: "NOT IN",
        sqlOp: "NOT IN",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return H == "value" ? "".concat(L, " NOT IN (").concat(W.join(", "), ")") : "".concat(L, " NOT IN (").concat(W, ")");
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          if (H == "value")
            return "".concat(L, " NOT IN (").concat(W.join(", "), ")");
        },
        mongoFormatOp: x.bind(null, "$nin", function(F) {
          return F;
        }, !1),
        reversedOp: "select_any_in"
      },
      //todo: multiselect_contains - for SpEL it would be `.containsAll`
      multiselect_equals: {
        label: "Equals",
        labelForFormat: "==",
        sqlOp: "=",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = Z ? "=" : "==";
          return H == "value" ? "".concat(L, " ").concat(ee, " [").concat(W.join(", "), "]") : "".concat(L, " ").concat(ee, " ").concat(W);
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          if (H == "value")
            return "".concat(L, " = '").concat(W.map(function(ee) {
              return s.SqlString.trim(ee);
            }).join(","), "'");
        },
        spelOp: ".equals",
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return F;
        }, !1),
        reversedOp: "multiselect_not_equals",
        jsonLogic2: "all-in",
        jsonLogic: function(L, U, W) {
          return {
            // it's not "equals", but "includes" operator - just for example
            all: [L, {
              in: [{
                var: ""
              }, W]
            }]
          };
        },
        elasticSearchQueryType: "term"
      },
      multiselect_not_equals: {
        isNotOp: !0,
        label: "Not equals",
        labelForFormat: "!=",
        sqlOp: "<>",
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          return H == "value" ? "".concat(L, " != [").concat(W.join(", "), "]") : "".concat(L, " != ").concat(W);
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          if (H == "value")
            return "".concat(L, " != '").concat(W.map(function(ee) {
              return s.SqlString.trim(ee);
            }).join(","), "'");
        },
        mongoFormatOp: x.bind(null, "$ne", function(F) {
          return F;
        }, !1),
        reversedOp: "multiselect_equals"
      },
      proximity: {
        label: "Proximity search",
        cardinality: 2,
        valueLabels: [{
          label: "Word 1",
          placeholder: "Enter first word"
        }, {
          label: "Word 2",
          placeholder: "Enter second word"
        }],
        textSeparators: [
          //'Word 1',
          //'Word 2'
        ],
        formatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W.first(), J = W.get(1), oe = re.get("proximity");
          return "".concat(L, " ").concat(ee, " NEAR/").concat(oe, " ").concat(J);
        },
        sqlFormatOp: function(L, U, W, H, Q, X, re, Z) {
          var ee = W.first(), J = W.get(1), oe = s.SqlString.trim(ee), ce = s.SqlString.trim(J), de = re.get("proximity");
          return "CONTAINS(".concat(L, ", 'NEAR((").concat(oe, ", ").concat(ce, "), ").concat(de, ")')");
        },
        mongoFormatOp: void 0,
        // not supported
        jsonLogic: void 0,
        // not supported
        options: {
          optionLabel: "Near",
          // label on top of "near" selectbox (for config.settings.showLabels==true)
          optionTextBefore: "Near",
          // label before "near" selectbox (for config.settings.showLabels==false)
          optionPlaceholder: "Select words between",
          // placeholder for "near" selectbox
          factory: function(L) {
            return /* @__PURE__ */ r.default.createElement(C, L);
          },
          minProximity: 2,
          maxProximity: 10,
          defaults: {
            proximity: 2
          }
        }
      },
      some: {
        label: "Some",
        labelForFormat: "SOME",
        cardinality: 0,
        jsonLogic: "some",
        spelFormatOp: function(L) {
          return "".concat(L, " > 0");
        },
        mongoFormatOp: x.bind(null, "$gt", function(F) {
          return 0;
        }, !1)
      },
      all: {
        label: "All",
        labelForFormat: "ALL",
        cardinality: 0,
        jsonLogic: "all",
        spelFormatOp: function(L, U, W) {
          return "".concat(L, " == ").concat(W);
        },
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return F;
        }, !1)
      },
      none: {
        label: "None",
        labelForFormat: "NONE",
        cardinality: 0,
        jsonLogic: "none",
        spelFormatOp: function(L) {
          return "".concat(L, " == 0");
        },
        mongoFormatOp: x.bind(null, "$eq", function(F) {
          return 0;
        }, !1)
      }
    }, T = function(L) {
      return L == null ? "NULL" : L.toString();
    };
    e.stringifyForDisplay = T;
    var z = {
      text: {
        type: "text",
        jsType: "string",
        valueSrc: "value",
        valueLabel: "String",
        valuePlaceholder: "Enter string",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(h, L);
        },
        formatValue: function(L, U, W, H) {
          return H ? T(L) : JSON.stringify(L);
        },
        spelFormatValue: function(L, U, W, H, Q) {
          if (Q.spelOp == "matches" && H != "regex") {
            var X;
            return H == "starts_with" ? X = "(?s)^".concat((0, c.escapeRegExp)(L), ".*") : H == "ends_with" ? X = "(?s).*".concat((0, c.escapeRegExp)(L), "$") : X = "(?s).*".concat((0, c.escapeRegExp)(L), ".*"), (0, s.spelEscape)(X);
          } else
            return (0, s.spelEscape)(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return Q.sqlOp == "LIKE" || Q.sqlOp == "NOT LIKE" ? s.SqlString.escapeLike(L, H != "starts_with", H != "ends_with") : s.SqlString.escape(L);
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      textarea: {
        type: "text",
        jsType: "string",
        valueSrc: "value",
        valueLabel: "Text",
        valuePlaceholder: "Enter text",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(b, L);
        },
        formatValue: function(L, U, W, H) {
          return H ? T(L) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return Q.sqlOp == "LIKE" || Q.sqlOp == "NOT LIKE" ? s.SqlString.escapeLike(L, H != "starts_with", H != "ends_with") : s.SqlString.escape(L);
        },
        spelFormatValue: function(L) {
          return (0, s.spelEscape)(L);
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        },
        fullWidth: !0
      },
      number: {
        type: "number",
        jsType: "number",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(I, L);
        },
        valueLabel: "Number",
        valuePlaceholder: "Enter number",
        valueLabels: [{
          label: "Number from",
          placeholder: "Enter number from"
        }, {
          label: "Number to",
          placeholder: "Enter number to"
        }],
        formatValue: function(L, U, W, H) {
          return H ? T(L) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return s.SqlString.escape(L);
        },
        spelFormatValue: function(L, U, W) {
          var H = W.step && !Number.isInteger(W.step);
          return (0, s.spelEscape)(L, H);
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      slider: {
        type: "number",
        jsType: "number",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(D, L);
        },
        valueLabel: "Number",
        valuePlaceholder: "Enter number or move slider",
        formatValue: function(L, U, W, H) {
          return H ? T(L) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return s.SqlString.escape(L);
        },
        spelFormatValue: function(L) {
          return (0, s.spelEscape)(L);
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      select: {
        type: "select",
        jsType: "string",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(O, L);
        },
        valueLabel: "Value",
        valuePlaceholder: "Select value",
        formatValue: function(L, U, W, H) {
          var Q = (0, c.getTitleInListValues)(U.fieldSettings.listValues || U.asyncListValues, L);
          return H ? T(Q) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return s.SqlString.escape(L);
        },
        spelFormatValue: function(L) {
          return (0, s.spelEscape)(L);
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      multiselect: {
        type: "multiselect",
        jsType: "array",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(S, L);
        },
        valueLabel: "Values",
        valuePlaceholder: "Select values",
        formatValue: function(L, U, W, H) {
          var Q = L.map(function(X) {
            return (0, c.getTitleInListValues)(U.fieldSettings.listValues || U.asyncListValues, X);
          });
          return H ? Q.map(T) : L.map(JSON.stringify);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return L.map(function(X) {
            return s.SqlString.escape(X);
          });
        },
        spelFormatValue: function(L, U, W, H, Q) {
          var X = Q.spelOp && Q.spelOp[0] == "$", re = (0, s.spelEscape)(L);
          return X && (re = (0, s.spelFixList)(re)), re;
        },
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      date: {
        type: "date",
        jsType: "string",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(v, L);
        },
        dateFormat: "DD.MM.YYYY",
        valueFormat: "YYYY-MM-DD",
        useKeyboard: !0,
        valueLabel: "Date",
        valuePlaceholder: "Enter date",
        valueLabels: [{
          label: "Date from",
          placeholder: "Enter date from"
        }, {
          label: "Date to",
          placeholder: "Enter date to"
        }],
        formatValue: function(L, U, W, H) {
          var Q = (0, l.default)(L, W.valueFormat);
          return H ? Q.format(W.dateFormat) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return s.SqlString.escape(X.format("YYYY-MM-DD"));
        },
        spelFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return "new java.text.SimpleDateFormat('yyyy-MM-dd').parse('".concat(X.format("YYYY-MM-DD"), "')");
        },
        jsonLogic: function(L, U, W) {
          return (0, l.default)(L, W.valueFormat).toDate();
        },
        toJS: function(L, U) {
          var W = (0, l.default)(L, U.valueFormat);
          return W.isValid() ? W.toDate() : void 0;
        },
        mongoFormatValue: function(L, U, W) {
          var H = (0, l.default)(L, W.valueFormat);
          return H.isValid() ? H.toDate() : void 0;
        }
      },
      time: {
        type: "time",
        jsType: "string",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement($, L);
        },
        timeFormat: "HH:mm",
        valueFormat: "HH:mm:ss",
        use12Hours: !1,
        useKeyboard: !0,
        valueLabel: "Time",
        valuePlaceholder: "Enter time",
        valueLabels: [{
          label: "Time from",
          placeholder: "Enter time from"
        }, {
          label: "Time to",
          placeholder: "Enter time to"
        }],
        formatValue: function(L, U, W, H) {
          var Q = (0, l.default)(L, W.valueFormat);
          return H ? Q.format(W.timeFormat) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return s.SqlString.escape(X.format("HH:mm:ss"));
        },
        spelFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return "T(java.time.LocalTime).parse('".concat(X.format("HH:mm:ss"), "')");
        },
        jsonLogic: function(L, U, W) {
          var H = (0, l.default)(L, W.valueFormat);
          return H.get("hour") * 60 * 60 + H.get("minute") * 60 + H.get("second");
        },
        toJS: function(L, U) {
          var W = (0, l.default)(L, U.valueFormat);
          return W.isValid() ? W.get("hour") * 60 * 60 + W.get("minute") * 60 + W.get("second") : void 0;
        },
        mongoFormatValue: function(L, U, W) {
          var H = (0, l.default)(L, W.valueFormat);
          return H.get("hour") * 60 * 60 + H.get("minute") * 60 + H.get("second");
        },
        elasticSearchFormatValue: function(L, U, W, H) {
          return {
            script: {
              script: {
                source: "doc[".concat(H, "][0].getHour() >== params.min && doc[").concat(H, "][0].getHour() <== params.max"),
                params: {
                  min: U[0],
                  max: U[1]
                }
              }
            }
          };
        }
      },
      datetime: {
        type: "datetime",
        jsType: "string",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(k, L);
        },
        timeFormat: "HH:mm",
        dateFormat: "DD.MM.YYYY",
        valueFormat: "YYYY-MM-DD HH:mm:ss",
        use12Hours: !1,
        useKeyboard: !0,
        valueLabel: "Datetime",
        valuePlaceholder: "Enter datetime",
        valueLabels: [{
          label: "Datetime from",
          placeholder: "Enter datetime from"
        }, {
          label: "Datetime to",
          placeholder: "Enter datetime to"
        }],
        formatValue: function(L, U, W, H) {
          var Q = (0, l.default)(L, W.valueFormat);
          return H ? Q.format(W.dateFormat + " " + W.timeFormat) : JSON.stringify(L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return s.SqlString.escape(X.toDate());
        },
        spelFormatValue: function(L, U, W, H, Q) {
          var X = (0, l.default)(L, W.valueFormat);
          return "new java.text.SimpleDateFormat('yyyy-MM-dd HH:mm:ss').parse('".concat(X.format("YYYY-MM-DD HH:mm:ss"), "')");
        },
        jsonLogic: function(L, U, W) {
          return (0, l.default)(L, W.valueFormat).toDate();
        },
        toJS: function(L, U) {
          var W = (0, l.default)(L, U.valueFormat);
          return W.isValid() ? W.toDate() : void 0;
        },
        mongoFormatValue: function(L, U, W) {
          var H = (0, l.default)(L, W.valueFormat);
          return H.isValid() ? H.toDate() : void 0;
        }
      },
      boolean: {
        type: "boolean",
        jsType: "boolean",
        valueSrc: "value",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(g, L);
        },
        labelYes: "Yes",
        labelNo: "No",
        formatValue: function(L, U, W, H) {
          return H ? L ? "Yes" : "No" : JSON.stringify(!!L);
        },
        sqlFormatValue: function(L, U, W, H, Q) {
          return s.SqlString.escape(L);
        },
        spelFormatValue: function(L, U, W, H, Q) {
          return (0, s.spelEscape)(L);
        },
        defaultValue: !1,
        toJS: function(L, U) {
          return L;
        },
        mongoFormatValue: function(L, U, W) {
          return L;
        }
      },
      field: {
        valueSrc: "field",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(M, L);
        },
        formatValue: function(L, U, W, H, Q, X, re) {
          return H && re.label || L;
        },
        sqlFormatValue: function(L, U, W, H, Q, X) {
          return L;
        },
        spelFormatValue: function(L, U, W, H, Q) {
          return L;
        },
        valueLabel: "Field to compare",
        valuePlaceholder: "Select field to compare",
        customProps: {
          showSearch: !0
        }
      },
      func: {
        valueSrc: "func",
        factory: function(L) {
          return /* @__PURE__ */ r.default.createElement(N, L);
        },
        valueLabel: "Function",
        valuePlaceholder: "Select function",
        customProps: {
          //showSearch: true
        }
      },
      case_value: {
        valueSrc: "value",
        type: "case_value",
        spelFormatValue: function(L) {
          return (0, s.spelEscape)(L === "" ? null : L);
        },
        spelImportValue: function(L) {
          return [L.value, []];
        },
        factory: function(L) {
          var U = L.value, W = L.setValue;
          return /* @__PURE__ */ r.default.createElement("input", {
            type: "text",
            value: U || "",
            onChange: function(Q) {
              return W(Q.target.value);
            }
          });
        }
      }
    }, j = {
      text: {
        defaultOperator: "equal",
        mainWidget: "text",
        widgets: {
          text: {
            operators: ["equal", "not_equal", "like", "not_like", "starts_with", "ends_with", "proximity", "is_empty", "is_not_empty", "is_null", "is_not_null"],
            widgetProps: {},
            opProps: {}
          },
          textarea: {
            operators: ["equal", "not_equal", "like", "not_like", "starts_with", "ends_with", "is_empty", "is_not_empty", "is_null", "is_not_null"],
            widgetProps: {},
            opProps: {}
          },
          field: {
            operators: [
              //unary ops (like `is_empty`) will be excluded anyway, see getWidgetsForFieldOp()
              "equal",
              "not_equal",
              "proximity"
              //can exclude if you want
            ]
          }
        }
      },
      number: {
        defaultOperator: "equal",
        mainWidget: "number",
        widgets: {
          number: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          },
          slider: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      date: {
        defaultOperator: "equal",
        widgets: {
          date: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      time: {
        defaultOperator: "equal",
        widgets: {
          time: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      datetime: {
        defaultOperator: "equal",
        widgets: {
          datetime: {
            operators: [
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      select: {
        mainWidget: "select",
        defaultOperator: "select_equals",
        widgets: {
          select: {
            operators: [
              "select_equals",
              "select_not_equals",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ],
            widgetProps: {
              customProps: {
                showSearch: !0
              }
            }
          },
          multiselect: {
            operators: [
              "select_any_in",
              "select_not_any_in",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      multiselect: {
        defaultOperator: "multiselect_equals",
        widgets: {
          multiselect: {
            operators: [
              "multiselect_equals",
              "multiselect_not_equals",
              // "is_empty",
              // "is_not_empty",
              "is_null",
              "is_not_null"
            ]
          }
        }
      },
      boolean: {
        defaultOperator: "equal",
        widgets: {
          boolean: {
            operators: ["equal", "not_equal", "is_null", "is_not_null"],
            widgetProps: {
              //you can enable this if you don't use fields as value sources
              // hideOperator: true,
              // operatorInlineLabel: "is",
            }
          },
          field: {
            operators: ["equal", "not_equal"]
          }
        }
      },
      "!group": {
        defaultOperator: "some",
        mainWidget: "number",
        widgets: {
          number: {
            widgetProps: {
              min: 0
            },
            operators: [
              // w/o operand
              "some",
              "all",
              "none",
              // w/ operand - count
              "equal",
              "not_equal",
              "less",
              "less_or_equal",
              "greater",
              "greater_or_equal",
              "between",
              "not_between"
            ],
            opProps: {
              equal: {
                label: "Count =="
              },
              not_equal: {
                label: "Count !="
              },
              less: {
                label: "Count <"
              },
              less_or_equal: {
                label: "Count <="
              },
              greater: {
                label: "Count >"
              },
              greater_or_equal: {
                label: "Count >="
              },
              between: {
                label: "Count between"
              },
              not_between: {
                label: "Count not between"
              }
            }
          }
        }
      },
      case_value: {
        mainWidget: "case_value",
        widgets: {
          case_value: {}
        }
      }
    }, q = f(f({}, d.settings), {}, {
      formatField: function(L, U, W, H, Q, X) {
        return X ? W : L;
      },
      formatSpelField: function(L, U, W, H, Q, X) {
        var re = H.map(function(Z, ee) {
          var J = Z.key, oe = Z.parent;
          return ee == 0 ? oe == "[map]" ? "#this[".concat((0, s.spelEscape)(J), "]") : (oe == "[class]", J) : oe == "map" || oe == "[map]" ? "[".concat((0, s.spelEscape)(J), "]") : (oe == "class" || oe == "[class]", ".".concat(J));
        }).join("");
        return Q.isSpelVariable && (re = "#" + re), re;
      },
      sqlFormatReverse: function(L) {
        if (L != null)
          return "NOT(" + L + ")";
      },
      spelFormatReverse: function(L) {
        if (L != null)
          return "!(" + L + ")";
      },
      formatReverse: function(L, U, W, H, Q, X) {
        if (L != null)
          return X ? "NOT (" + L + ")" : "!(" + L + ")";
      },
      formatAggr: function(L, U, W, H, Q, X, re, Z, ee, J) {
        var oe = re.labelForFormat, ce = re.cardinality;
        if (ce == 0) {
          var de = L ? " HAVE ".concat(L) : "";
          return "".concat(oe, " OF ").concat(U).concat(de);
        } else if (ce == null || ce == 1) {
          var te = L ? " WHERE ".concat(L) : "";
          return "COUNT OF ".concat(U).concat(te, " ").concat(oe, " ").concat(H);
        } else if (ce == 2) {
          var ue = L ? " WHERE ".concat(L) : "", le = H.first(), se = H.get(1);
          return "COUNT OF ".concat(U).concat(ue, " ").concat(oe, " ").concat(le, " AND ").concat(se);
        }
      },
      canCompareFieldWithField: function(L, U, W, H) {
        return !0;
      },
      // enable compare fields
      valueSourcesInfo: {
        value: {
          label: "Value"
        },
        field: {
          label: "Field",
          widget: "field"
        },
        func: {
          label: "Function",
          widget: "func"
        }
      },
      customFieldSelectProps: {
        showSearch: !0
      },
      defaultSliderWidth: "200px",
      defaultSelectWidth: "200px",
      defaultSearchWidth: "100px",
      defaultMaxRows: 5
    }), V = {
      conjunctions: P,
      operators: E,
      widgets: z,
      types: j,
      settings: q
    };
    e.default = V;
  }($N)), $N;
}
(function(e) {
  var t = Rt, n = Yn;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "BasicConfig", {
    enumerable: !0,
    get: function() {
      return _.default;
    }
  }), e.BasicFuncs = void 0, Object.defineProperty(e, "Builder", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), e.Operators = e.Import = e.Export = void 0, Object.defineProperty(e, "Query", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), e.Widgets = e.Utils = void 0;
  var o = t(rr), r = t(t_d()), i = t(y_d()), a = f(N_d());
  e.Export = a;
  var s = f(q_d());
  e.Import = s;
  var c = f(w7());
  e.Widgets = c;
  var l = f(i1e());
  e.Operators = l;
  var d = f(V_d()), u = f(B_d());
  e.BasicFuncs = u;
  var _ = t(U_d());
  function p(v) {
    if (typeof WeakMap != "function")
      return null;
    var $ = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap();
    return (p = function(O) {
      return O ? k : $;
    })(v);
  }
  function f(v, $) {
    if (!$ && v && v.__esModule)
      return v;
    if (v === null || n(v) !== "object" && typeof v != "function")
      return { default: v };
    var k = p($);
    if (k && k.has(v))
      return k.get(v);
    var S = {}, O = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var I in v)
      if (I !== "default" && Object.prototype.hasOwnProperty.call(v, I)) {
        var D = O ? Object.getOwnPropertyDescriptor(v, I) : null;
        D && (D.get || D.set) ? Object.defineProperty(S, I, D) : S[I] = v[I];
      }
    return S.default = v, k && k.set(v, S), S;
  }
  function g(v, $) {
    var k = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(v);
      $ && (S = S.filter(function(O) {
        return Object.getOwnPropertyDescriptor(v, O).enumerable;
      })), k.push.apply(k, S);
    }
    return k;
  }
  function h(v) {
    for (var $ = 1; $ < arguments.length; $++) {
      var k = arguments[$] != null ? arguments[$] : {};
      $ % 2 ? g(Object(k), !0).forEach(function(S) {
        (0, o.default)(v, S, k[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(k)) : g(Object(k)).forEach(function(S) {
        Object.defineProperty(v, S, Object.getOwnPropertyDescriptor(k, S));
      });
    }
    return v;
  }
  var b = h(h(h({}, d), a), s);
  e.Utils = b;
})(Wp);
var k$ = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMBER = "number", e.TEXTAREA = "textarea", e.SINGLE_SELECT = "select", e.MULTI_SELECT = "multiselect", e.PHONE = "phone", e.EMAIL = "email", e))(k$ || {});
const W_d = [
  {
    label: "Short Text",
    value: "text"
    /* TEXT */
  },
  {
    label: "Number",
    value: "number"
    /* NUMBER */
  },
  {
    label: "Long Text",
    value: "textarea"
    /* TEXTAREA */
  },
  {
    label: "Single Selection",
    value: "select"
    /* SINGLE_SELECT */
  },
  {
    label: "Multiple Selection",
    value: "multiselect"
    /* MULTI_SELECT */
  },
  {
    label: "Phone",
    value: "phone"
    /* PHONE */
  },
  {
    label: "Email",
    value: "email"
    /* EMAIL */
  }
], G_d = {
  AND: {
    label: "And",
    jsonLogicConj: "and",
    reversedConj: "OR",
    formatConj: () => "",
    sqlFormatConj: () => "",
    spelFormatConj: () => "",
    mongoConj: ""
  },
  OR: {
    label: "Or",
    jsonLogicConj: "or",
    reversedConj: "AND",
    formatConj: () => "",
    sqlFormatConj: () => "",
    spelFormatConj: () => "",
    mongoConj: ""
  }
}, H_d = {
  equal: {
    label: "Equals",
    labelForFormat: "==",
    reversedOp: "not_equal",
    jsonLogic: "=="
  },
  not_equal: {
    isNotOp: !0,
    label: "Does not equal",
    labelForFormat: "!=",
    reversedOp: "equal",
    jsonLogic: "!="
  },
  less: {
    label: "Less than",
    labelForFormat: "<",
    reversedOp: "greater_or_equal",
    jsonLogic: "<"
  },
  less_or_equal: {
    label: "Less than or equal to",
    labelForFormat: "<=",
    reversedOp: "greater",
    jsonLogic: "<="
  },
  greater: {
    label: "Greater than",
    labelForFormat: ">",
    reversedOp: "less_or_equal",
    jsonLogic: ">"
  },
  greater_or_equal: {
    label: "Greater than or equal to",
    labelForFormat: ">=",
    reversedOp: "less",
    jsonLogic: ">="
  },
  like: {
    label: "Contains",
    labelForFormat: "Contains",
    reversedOp: "not_like",
    jsonLogic: "in",
    _jsonLogicIsRevArgs: !0,
    valueSources: ["value"]
  },
  not_like: {
    isNotOp: !0,
    label: "Not contains",
    reversedOp: "like",
    labelForFormat: "Not Contains",
    valueSources: ["value"]
  },
  starts_with: {
    label: "Starts with",
    labelForFormat: "Starts with",
    jsonLogic: "starts_with",
    valueSources: ["value"]
  },
  //   ends_with: {
  //     label: "Ends with",
  //     labelForFormat: "Ends with",
  //     jsonLogic: undefined, // not supported
  //     valueSources: ["value"],
  //   },
  between: {
    label: "Between",
    labelForFormat: "BETWEEN",
    cardinality: 2,
    valueLabels: ["Value from", "Value to"],
    reversedOp: "not_between",
    jsonLogic: (e, t, n) => {
      const o = parseInt(n[0], 10), r = parseInt(n[1], 10);
      return {
        and: [{ ">=": [e, o] }, { "<=": [e, r] }]
      };
    }
  },
  not_between: {
    isNotOp: !0,
    label: "Not between",
    labelForFormat: "NOT BETWEEN",
    cardinality: 2,
    valueLabels: ["Value from", "Value to"],
    reversedOp: "between",
    jsonLogic: (e, t, n) => {
      const o = parseInt(n[0], 10), r = parseInt(n[1], 10);
      return {
        or: [{ "<": [e, o] }, { ">": [e, r] }]
      };
    }
  },
  is_empty: {
    label: "Is empty",
    labelForFormat: "IS EMPTY",
    cardinality: 0,
    reversedOp: "is_not_empty",
    jsonLogic: "!"
  },
  is_not_empty: {
    isNotOp: !0,
    label: "Is not empty",
    labelForFormat: "IS NOT EMPTY",
    cardinality: 0,
    reversedOp: "is_empty",
    jsonLogic: "!!"
  },
  /**
   * We don't need these operators
   */
  //   is_null: {
  //     label: "Is null",
  //     labelForFormat: "IS NULL",
  //     cardinality: 0,
  //     reversedOp: "is_not_null",
  //     jsonLogic: "==",
  //   },
  //   is_not_null: {
  //     label: "Is not null",
  //     labelForFormat: "IS NOT NULL",
  //     cardinality: 0,
  //     reversedOp: "is_null",
  //     jsonLogic: "!=",
  //   },
  select_equals: {
    label: "Equals",
    labelForFormat: "==",
    reversedOp: "select_not_equals",
    jsonLogic: "=="
  },
  select_not_equals: {
    isNotOp: !0,
    label: "Does not equal",
    labelForFormat: "!=",
    reversedOp: "select_equals",
    jsonLogic: "!="
  },
  select_any_in: {
    label: "Any in",
    labelForFormat: "IN",
    reversedOp: "select_not_any_in",
    jsonLogic: "in"
  },
  select_not_any_in: {
    isNotOp: !0,
    label: "Not any in",
    labelForFormat: "NOT IN",
    reversedOp: "select_any_in"
  },
  // We define this operator but use it conditionally for multiselect for Attributes only
  multiselect_some_in: {
    label: "Any in",
    jsonLogic: (e, t, n) => ({
      // Tested in jsonLogic.test.ts
      some: [e, { in: [{ var: "" }, n] }]
    })
  },
  multiselect_not_some_in: {
    label: "Not any in",
    reversedOp: "multiselect_some_in"
  },
  multiselect_equals: {
    label: "All in",
    reversedOp: "multiselect_not_equals",
    // jsonLogic2: "all-in",
    jsonLogic: (e, t, n, ...o) => ({
      // This is wrongly implemented as "includes". This isn't "equals". Because if field is ["a" ] and vals is ["a", "b"], it still matches. Expectation would probably be that it should be a strict match(["a", "b"] or ["b", "a"])
      all: [e, { in: [{ var: "" }, n] }]
    })
  },
  multiselect_not_equals: {
    isNotOp: !0,
    label: "Not all in",
    reversedOp: "multiselect_equals"
  },
  some: {
    label: "Some",
    labelForFormat: "SOME",
    cardinality: 0,
    jsonLogic: "some"
  },
  all: {
    label: "All",
    labelForFormat: "ALL",
    cardinality: 0
  },
  none: {
    label: "None",
    labelForFormat: "NONE",
    cardinality: 0,
    jsonLogic: "none"
  }
}, K_d = {
  text: {
    type: "text",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "String",
    valuePlaceholder: "Enter string",
    toJS: (e) => e
  },
  textarea: {
    type: "text",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "Text",
    valuePlaceholder: "Enter text",
    toJS: (e) => e
  },
  number: {
    type: "number",
    jsType: "number",
    valueSrc: "value",
    valueLabel: "Number",
    valuePlaceholder: "Enter number",
    toJS: (e) => e
  },
  select: {
    type: "select",
    jsType: "string",
    valueSrc: "value",
    valueLabel: "Value",
    valuePlaceholder: "Select value",
    toJS: (e) => e
  },
  multiselect: {
    type: "multiselect",
    jsType: "array",
    valueSrc: "value",
    valueLabel: "Values",
    valuePlaceholder: "Select values",
    toJS: (e) => e
  }
}, Y_d = {
  text: {
    defaultOperator: "equal",
    mainWidget: "text",
    widgets: {
      text: {
        // Note: any operator mentioned here but isn't defined in operators will be automatically excluded
        operators: [
          "equal",
          "not_equal",
          "like",
          "not_like",
          "starts_with",
          "ends_with",
          "proximity",
          "is_empty",
          "is_not_empty",
          "is_null",
          "is_not_null"
        ],
        widgetProps: {},
        opProps: {}
      },
      textarea: {
        operators: [
          "equal",
          "not_equal",
          "like",
          "not_like",
          "starts_with",
          "ends_with",
          "is_empty",
          "is_not_empty",
          "is_null",
          "is_not_null"
        ],
        widgetProps: {},
        opProps: {}
      }
    }
  },
  number: {
    defaultOperator: "equal",
    mainWidget: "number",
    widgets: {
      number: {
        operators: [
          "equal",
          "not_equal",
          "less",
          "less_or_equal",
          "greater",
          "greater_or_equal",
          "between",
          "not_between",
          // "is_empty",
          // "is_not_empty",
          "is_null",
          "is_not_null"
        ]
      }
      //   slider: {
      //     operators: [
      //       "equal",
      //       "not_equal",
      //       "less",
      //       "less_or_equal",
      //       "greater",
      //       "greater_or_equal",
      //       // "is_empty",
      //       // "is_not_empty",
      //       "is_null",
      //       "is_not_null",
      //     ],
      //   },
    }
  },
  select: {
    mainWidget: "select",
    defaultOperator: "select_equals",
    widgets: {
      select: {
        operators: ["select_equals", "select_not_equals"],
        widgetProps: {
          customProps: {
            showSearch: !0
          }
        }
      },
      multiselect: {
        operators: ["select_any_in", "select_not_any_in"]
      }
    }
  },
  multiselect: {
    defaultOperator: "multiselect_equals",
    widgets: {
      multiselect: {
        operators: ["multiselect_equals", "multiselect_not_equals", "is_null", "is_not_null"]
      }
    }
  }
  //   "!group": {
  //     defaultOperator: "some",
  //     mainWidget: "number",
  //     widgets: {
  //       number: {
  //         widgetProps: {
  //           min: 0,
  //         },
  //         operators: [
  //           // w/o operand
  //           "some",
  //           "all",
  //           "none",
  //           // w/ operand - count
  //           "equal",
  //           "not_equal",
  //           "less",
  //           "less_or_equal",
  //           "greater",
  //           "greater_or_equal",
  //           "between",
  //           "not_between",
  //         ],
  //         opProps: {
  //           equal: {
  //             label: "Count ==",
  //           },
  //           not_equal: {
  //             label: "Count !=",
  //           },
  //           less: {
  //             label: "Count <",
  //           },
  //           less_or_equal: {
  //             label: "Count <=",
  //           },
  //           greater: {
  //             label: "Count >",
  //           },
  //           greater_or_equal: {
  //             label: "Count >=",
  //           },
  //           between: {
  //             label: "Count between",
  //           },
  //           not_between: {
  //             label: "Count not between",
  //           },
  //         },
  //       },
  //     },
  //   },
  //   case_value: {
  //     mainWidget: "case_value",
  //     widgets: {
  //       case_value: {},
  //     },
  //   },
}, Z_d = {
  setOpOnChangeField: ["keep", "default"]
  // 'default' (default if present), 'keep' (keep prev from last field), 'first', 'none'
}, vs = {
  conjunctions: G_d,
  operators: H_d,
  widgets: K_d,
  types: Y_d,
  settings: Z_d
};
var td = /* @__PURE__ */ ((e) => (e.FormFields = "FormFields", e.Attributes = "Attributes", e))(td || {});
function a1e(e) {
  return {
    ...vs.widgets,
    phone: {
      ...vs.widgets.text
    },
    email: {
      ...vs.widgets.text
    }
  };
}
function s1e(e) {
  const t = vs.types.multiselect.widgets.multiselect.operators || [];
  return e === td.Attributes && t.push("multiselect_some_in", "multiselect_not_some_in"), {
    ...vs.types,
    phone: {
      ...vs.types.text,
      widgets: {
        ...vs.types.text.widgets
      }
    },
    email: {
      ...vs.types.text,
      widgets: {
        ...vs.types.text.widgets
      }
    },
    multiselect: {
      ...vs.types.multiselect,
      widgets: {
        ...vs.types.multiselect.widgets,
        multiselect: {
          ...vs.types.multiselect.widgets.multiselect,
          operators: [...t]
        }
      }
    }
  };
}
function c1e(e) {
  return {
    ...vs.operators
  };
}
function l1e(e) {
  return {
    ...vs.conjunctions
  };
}
function d1e() {
  return {
    ...vs.settings,
    groupActionsPosition: "bottomCenter",
    // TODO: Test it and then enable it. It might allow us to show better error messages.
    // But it doesn't detect every kind of error like an operator gone missing e.g. what happened in https://github.com/calcom/cal.com/pull/17102
    showErrorMessage: !0,
    // Disable groups
    maxNesting: 1
  };
}
const Q_d = {
  conjunctions: l1e(td.FormFields),
  operators: c1e(td.FormFields),
  types: s1e(td.FormFields),
  widgets: a1e(td.FormFields),
  settings: d1e()
}, J_d = {
  conjunctions: l1e(td.Attributes),
  operators: c1e(td.Attributes),
  types: s1e(td.Attributes),
  widgets: a1e(td.Attributes),
  settings: d1e()
}, X_d = Q_d, Yre = J_d, epd = (e) => `{field:${e}}`, tpd = /* @__PURE__ */ new Map([
  [d2.SINGLE_SELECT, k$.SINGLE_SELECT],
  [d2.MULTI_SELECT, k$.MULTI_SELECT],
  [d2.TEXT, k$.TEXT],
  [d2.NUMBER, k$.NUMBER]
]);
function npd(e) {
  return e.map((t) => {
    const n = tpd.get(t.type);
    if (!n)
      throw new Error(`Unsupported attribute type:${t.type}`);
    return {
      label: t.name,
      id: t.id,
      type: n,
      options: t.options.map((o) => ({
        title: o.value,
        // We have to use something that doesn't change often. ID of attribute never changes. Changing means a saved value will become invalid
        value: o.id
      }))
    };
  });
}
function opd({
  attributes: e,
  /**
   * It is the fields that makes up additional options to be matched with for the single select/multiselect attributes.
   * They are shown as 'Value of field <field-label>' in the dropdown.
   */
  dynamicOperandFields: t = []
}) {
  const n = npd(e), o = {};
  return n.forEach((i) => {
    const a = i.type;
    if (W_d.map((s) => s.value).includes(a)) {
      const c = X_d.widgets[a].type, d = [...t.map((_) => ({
        title: `Value of field '${_.label}'`,
        value: epd(_.id)
      })), ...i.options];
      o[i.id] = {
        label: i.label,
        type: c,
        valueSources: ["value"],
        fieldSettings: {
          // IMPORTANT: listValues must be undefined for non-select/multiselect fields otherwise RAQB doesn't like it. It ends up considering all the text values as per the listValues too which could be empty as well making all values invalid
          listValues: a === "select" || a === "multiselect" ? d : void 0
        }
      };
    } else
      throw new Error(`Unsupported field type:${i.type}`);
  }), {
    ...{
      ...Yre,
      operators: { ...Yre.operators }
    },
    fields: o
  };
}
function rpd() {
  return { id: Wp.Utils.uuid(), type: "group" };
}
const ipd = ({
  queryValue: e,
  config: t
}) => {
  const n = e || rpd(), o = Wp.Utils.checkTree(Wp.Utils.loadTree(n), t);
  return {
    state: {
      tree: o,
      config: t
    },
    queryValue: Wp.Utils.getTree(o)
  };
}, ll = function(e, t) {
  return e ? /* @__PURE__ */ m(t, { ...e }) : /* @__PURE__ */ m("div", {});
}, {
  TextWidget: u1e,
  TextAreaWidget: apd,
  MultiSelectWidget: spd,
  SelectWidget: cpd,
  NumberWidget: lpd,
  FieldSelect: wN,
  Conjs: dpd,
  Button: upd,
  ButtonGroup: _pd,
  Provider: ppd
} = Km, mpd = (e) => ll(e, u1e), fpd = (e) => ll(e, apd), gpd = (e) => ll(e, lpd), hpd = (e) => ll(e, spd), vpd = (e) => ll(e, cpd), bpd = (e) => e ? /* @__PURE__ */ m(u1e, { type: "tel", ...e }) : /* @__PURE__ */ m("div", {}), ypd = (e) => e ? /* @__PURE__ */ m(
  V_e,
  {
    onChange: (t) => {
      const n = t.target.value;
      e.setValue(n);
    },
    containerClassName: "w-full mb-2",
    ...e
  }
) : /* @__PURE__ */ m("div", {});
function $pd(e) {
  return {
    ...e,
    text: {
      ...e.text,
      factory: mpd
    },
    textarea: {
      ...e.textarea,
      factory: fpd
    },
    number: {
      ...e.number,
      factory: gpd
    },
    multiselect: {
      ...e.multiselect,
      factory: hpd
    },
    select: {
      ...e.select,
      factory: vpd
    },
    phone: {
      ...e.text,
      factory: bpd,
      valuePlaceholder: "Enter Phone Number"
    },
    email: {
      ...e.text,
      factory: ypd
    }
  };
}
const wpd = {
  renderField: (e) => ll(e, wN),
  renderOperator: (e) => ll(e, wN),
  renderFunc: (e) => ll(e, wN),
  renderConjs: (e) => ll(e, dpd),
  renderButton: (e) => ll(e, upd),
  renderButtonGroup: (e) => ll(e, _pd),
  renderProvider: (e) => ll(e, ppd)
};
function kpd(e) {
  return {
    ...e,
    ...wpd
  };
}
function Spd({
  config: e
}) {
  const { settings: t, widgets: n, ...o } = e;
  return {
    ...o,
    settings: kpd(t),
    widgets: $pd(n)
  };
}
function vq(e, t) {
  if (e === t)
    return !0;
  if (e == null || t == null)
    return !1;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((n, o) => vq(n, t[o]));
  if (typeof e == "object" && typeof t == "object") {
    const n = Object.keys(e), o = Object.keys(t);
    return n.length !== o.length ? !1 : n.every((r) => Object.prototype.hasOwnProperty.call(t, r) ? vq(e[r], t[r]) : !1);
  }
  return e === t;
}
function xpd(e) {
  const { data: t, isPending: n } = bo.viewer.appRoutingForms.getAttributesForTeam.useQuery({
    teamId: e
  });
  return {
    attributes: t,
    isPending: n
  };
}
function Epd({
  attributes: e,
  teamId: t,
  queryValue: n,
  onQueryValueChange: o,
  className: r
}) {
  const i = opd({
    attributes: e
  }), [a, s] = ze(n), c = Spd({
    config: i,
    configFor: td.Attributes
  }), l = ipd({
    queryValue: a,
    config: c
  }), d = at(
    (_) => /* @__PURE__ */ m("div", { className: "query-builder-container", "data-testid": "query-builder-container", children: /* @__PURE__ */ m("div", { className: "query-builder qb-lite", children: /* @__PURE__ */ m(Wp.Builder, { ..._ }) }) }),
    []
  );
  function u(_) {
    const p = Wp.Utils.getTree(_);
    vq(p, a) || (s(p), o({
      queryValue: p
    }));
  }
  return (
    // cal-query-builder class has special styling through global CSS, allowing us to customize RAQB
    /* @__PURE__ */ Y("div", { children: [
      /* @__PURE__ */ m("div", { className: ae("cal-query-builder", r), children: /* @__PURE__ */ m(
        Wp.Query,
        {
          ...c,
          value: l.state.tree,
          onChange: u,
          renderBuilder: d
        }
      ) }),
      /* @__PURE__ */ m("div", { className: "mt-4 text-sm", children: /* @__PURE__ */ m(Tpd, { teamId: t, queryValue: a }) })
    ] })
  );
}
function Tpd({
  teamId: e,
  queryValue: t
}) {
  const { t: n } = Fe(), o = t != null && t.children1 ? Object.values(t.children1).some(
    (s) => {
      var c, l, d, u;
      return ((l = (c = s.properties) == null ? void 0 : c.value) == null ? void 0 : l[0]) !== void 0 && ((u = (d = s.properties) == null ? void 0 : d.value) == null ? void 0 : u[0]) !== null;
    }
  ) : !1, { data: r, isPending: i } = bo.viewer.attributes.findTeamMembersMatchingAttributeLogic.useQuery(
    {
      teamId: e,
      attributesQueryValue: t,
      _enablePerf: !0
    },
    {
      enabled: o
    }
  );
  if (!o)
    return /* @__PURE__ */ m("div", { className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4", children: /* @__PURE__ */ m("div", { className: "text-subtle flex items-center text-sm font-medium", children: /* @__PURE__ */ m("span", { children: n("no_filter_set") }) }) });
  if (i)
    return /* @__PURE__ */ Y(
      "div",
      {
        className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4",
        "data-testid": "segment_loading_state",
        children: [
          /* @__PURE__ */ m("div", { className: "text-emphasis flex items-center text-sm font-medium", children: /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-32 animate-pulse rounded" }) }),
          /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", children: [...Array(3)].map((s, c) => /* @__PURE__ */ m("li", { className: "flex items-center py-2", children: /* @__PURE__ */ Y("div", { className: "flex flex-1 items-center space-x-2 text-sm", children: [
            /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-24 animate-pulse rounded" }),
            /* @__PURE__ */ m("div", { className: "bg-subtle h-4 w-32 animate-pulse rounded" })
          ] }) }, c)) })
        ]
      }
    );
  if (!r)
    return /* @__PURE__ */ m("span", { children: n("something_went_wrong") });
  const { result: a } = r;
  return /* @__PURE__ */ Y("div", { className: "border-subtle bg-muted mt-4 space-y-3 rounded-md border p-4", children: [
    /* @__PURE__ */ m("div", { className: "text-emphasis flex items-center text-sm font-medium", children: /* @__PURE__ */ m("span", { children: n("x_matching_members", { x: (a == null ? void 0 : a.length) ?? 0 }) }) }),
    /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", children: a == null ? void 0 : a.map((s) => /* @__PURE__ */ m("li", { className: "flex items-center py-2", children: /* @__PURE__ */ Y("div", { className: "flex flex-1 items-center space-x-2 text-sm", children: [
      /* @__PURE__ */ m("span", { className: "font-medium", children: s.name }),
      /* @__PURE__ */ Y("span", { className: "text-subtle", children: [
        "(",
        s.email,
        ")"
      ] })
    ] }) }, s.id)) })
  ] });
}
function Apd({
  teamId: e,
  queryValue: t,
  onQueryValueChange: n,
  className: o
}) {
  const { attributes: r, isPending: i } = xpd(e), { t: a } = Fe();
  return i ? /* @__PURE__ */ m("span", { children: "Loading..." }) : r ? /* @__PURE__ */ m(
    Epd,
    {
      teamId: e,
      attributes: r,
      queryValue: t,
      onQueryValueChange: n,
      className: o
    }
  ) : (console.error("Error fetching attributes"), /* @__PURE__ */ m("span", { children: a("something_went_wrong") }));
}
const Cpd = ({
  assignAllTeamMembers: e,
  setAssignAllTeamMembers: t,
  onActive: n,
  onInactive: o,
  customClassNames: r
}) => {
  const { t: i } = Fe(), { setValue: a } = Dn();
  return /* @__PURE__ */ m(
    Wt,
    {
      name: "assignAllTeamMembers",
      render: () => /* @__PURE__ */ m(
        eo,
        {
          "data-testid": "assign-all-team-members-toggle",
          title: i("automatically_add_all_team_members"),
          labelClassName: ae("mt-[3px] text-sm", r == null ? void 0 : r.label),
          switchContainerClassName: r == null ? void 0 : r.container,
          checked: e,
          onCheckedChange: (s) => {
            a("assignAllTeamMembers", s, { shouldDirty: !0 }), t(s), s ? n() : o && o();
          }
        }
      )
    }
  );
}, bq = Cpd, zpd = ({ id: e, name: t, username: n, avatar: o, email: r, defaultScheduleId: i }, a) => ({
  value: `${e || ""}`,
  label: `${t || r || ""}${n ? "" : ` (${a})`}`,
  avatar: o,
  email: r,
  defaultScheduleId: i
}), Opd = (e, t) => e.label < t.label ? -1 : e.label > t.label ? 1 : 0, Ppd = ({
  labelText: e,
  placeholder: t,
  options: n = [],
  isFixed: o,
  value: r,
  onChange: i,
  helperText: a,
  isRRWeightsEnabled: s,
  groupId: c,
  customClassNames: l,
  ...d
}) => /* @__PURE__ */ m("div", { className: "flex flex-col rounded-md", children: /* @__PURE__ */ Y("div", { children: [
  e ? /* @__PURE__ */ m(Xn, { children: e }) : /* @__PURE__ */ m(Ce, {}),
  /* @__PURE__ */ m(
    ZJl,
    {
      isOptionDisabled: (u) => !!r.find((_) => _.userId.toString() === u.value),
      onChange: (u) => {
        i && i(
          u.map((_) => ({
            isFixed: o,
            userId: parseInt(_.value, 10),
            priority: _.priority ?? 2,
            weight: _.weight ?? 100,
            scheduleId: _.defaultScheduleId,
            groupId: _.groupId
          }))
        );
      },
      value: (r || []).filter(({ isFixed: u }) => o === u).reduce((u, _) => {
        const p = n.find((f) => f.value === _.userId.toString());
        return p && u.push({
          ...p,
          priority: _.priority ?? 2,
          isFixed: o,
          weight: _.weight ?? 100,
          groupId: _.groupId
        }), u;
      }, []),
      controlShouldRenderValue: !1,
      options: n,
      placeholder: t,
      isRRWeightsEnabled: s,
      customClassNames: l,
      groupId: c,
      ...d
    }
  )
] }) });
function Ipd({
  teamId: e,
  assignRRMembersUsingSegment: t,
  setAssignRRMembersUsingSegment: n,
  rrSegmentQueryValue: o,
  setRrSegmentQueryValue: r,
  className: i
}) {
  const { t: a } = Fe(), s = ({ queryValue: l }) => {
    r(l);
  }, c = Zo();
  return /* @__PURE__ */ m(
    Wt,
    {
      name: "assignRRMembersUsingSegment",
      render: () => /* @__PURE__ */ m(
        eo,
        {
          noIndentation: !0,
          "data-testid": "segment-toggle",
          title: a("filter_by_attributes"),
          labelClassName: "mt-0.5 font-normal",
          checked: t,
          onCheckedChange: (l) => {
            n(l);
          },
          children: !c && /* @__PURE__ */ m(
            Apd,
            {
              teamId: e,
              queryValue: o,
              onQueryValueChange: s,
              className: i
            }
          )
        }
      )
    }
  );
}
function Rpd({
  assignAllTeamMembers: e,
  assignRRMembersUsingSegment: t,
  isAssigningAllTeamMembersApplicable: n,
  isSegmentApplicable: o
}) {
  return e ? o ? "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_APPLICABLE" : "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE" : t && o ? "TEAM_MEMBERS_IN_SEGMENT_ENABLED" : n ? "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE" : "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_NOT_APPLICABLE";
}
function Npd() {
  const { getValues: e, setValue: t, watch: n } = Dn(), o = n("assignRRMembersUsingSegment"), r = (s) => t("assignRRMembersUsingSegment", s, { shouldDirty: !0 }), i = e("rrSegmentQueryValue");
  return {
    assignRRMembersUsingSegment: o,
    setAssignRRMembersUsingSegment: r,
    rrSegmentQueryValue: i,
    setRrSegmentQueryValue: (s) => t("rrSegmentQueryValue", s, { shouldDirty: !0 })
  };
}
function _1e({
  teamMembers: e,
  value: t,
  onChange: n,
  assignAllTeamMembers: o,
  setAssignAllTeamMembers: r,
  automaticAddAllEnabled: i,
  onActive: a,
  isFixed: s,
  placeholder: c = "",
  isRRWeightsEnabled: l,
  teamId: d,
  isSegmentApplicable: u,
  groupId: _,
  customClassNames: p,
  ...f
}) {
  const { t: g } = Fe();
  Dn();
  const {
    assignRRMembersUsingSegment: h,
    setAssignRRMembersUsingSegment: b,
    rrSegmentQueryValue: v,
    setRrSegmentQueryValue: $
  } = Npd(), k = Rpd({
    assignAllTeamMembers: o,
    assignRRMembersUsingSegment: h,
    isAssigningAllTeamMembersApplicable: i,
    isSegmentApplicable: u
  }), S = () => {
    b(!1);
  };
  switch (k) {
    case "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_APPLICABLE":
    case "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE":
    case "TEAM_MEMBERS_IN_SEGMENT_ENABLED":
      return /* @__PURE__ */ Y(Ce, { children: [
        !_ && /* @__PURE__ */ m(
          bq,
          {
            assignAllTeamMembers: o,
            setAssignAllTeamMembers: r,
            onActive: a,
            onInactive: S,
            customClassNames: p == null ? void 0 : p.assingAllTeamMembers
          }
        ),
        k !== "ALL_TEAM_MEMBERS_ENABLED_AND_SEGMENT_NOT_APPLICABLE" && /* @__PURE__ */ m("div", { className: "mt-2", children: /* @__PURE__ */ m(
          Ipd,
          {
            teamId: d,
            assignRRMembersUsingSegment: h,
            setAssignRRMembersUsingSegment: b,
            rrSegmentQueryValue: v,
            setRrSegmentQueryValue: $
          }
        ) })
      ] });
    case "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_NOT_APPLICABLE":
    case "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE":
      return /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("div", { className: "mb-2", children: k === "TOGGLES_OFF_AND_ALL_TEAM_MEMBERS_APPLICABLE" && !_ && /* @__PURE__ */ m(
          bq,
          {
            assignAllTeamMembers: o,
            setAssignAllTeamMembers: r,
            onActive: a,
            onInactive: S,
            customClassNames: p == null ? void 0 : p.assingAllTeamMembers
          }
        ) }),
        /* @__PURE__ */ m("div", { className: "mb-2", children: /* @__PURE__ */ m(
          Ppd,
          {
            "data-testid": f["data-testid"],
            value: t,
            onChange: n,
            isFixed: s,
            className: "mb-2",
            options: e.map((O) => ({
              ...O,
              groupId: _
            })).sort(Opd),
            placeholder: c ?? g("add_attendees"),
            isRRWeightsEnabled: l,
            groupId: _,
            customClassNames: p == null ? void 0 : p.teamMemberSelect
          }
        ) })
      ] });
  }
}
const yq = ({
  containerClassName: e,
  ...t
}) => {
  const n = Zo(), o = Tt(
    () => n ? eid : tid,
    [n]
  );
  return /* @__PURE__ */ m("div", { className: "rounded-md", children: /* @__PURE__ */ m("div", { className: `flex flex-col rounded-md pb-2 pt-6 ${e}`, children: /* @__PURE__ */ m(o, { ...t }) }) });
}, Dpd = ({
  options: e = [],
  value: t = [],
  customClassNames: n,
  ...o
}) => {
  var a, s, c;
  const { t: r } = Fe(), [i] = xl();
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      Tr,
      {
        name: o.name,
        placeholder: r("select"),
        options: e,
        className: (a = n == null ? void 0 : n.assignToSelect) == null ? void 0 : a.select,
        innerClassNames: (s = n == null ? void 0 : n.assignToSelect) == null ? void 0 : s.innerClassNames,
        value: t,
        isMulti: !0,
        ...o
      }
    ),
    /* @__PURE__ */ m(
      "ul",
      {
        className: ae(
          "border-subtle divide-subtle mt-3 divide-y rounded-md",
          t.length >= 1 && "border",
          (c = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : c.container
        ),
        ref: i,
        children: t.map((l, d) => {
          var u, _, p, f, g, h, b, v, $, k, S, O, I, D, M, N, C, P, x, w, E, T, z, j, q, V, F, L, U;
          return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ Y(
            "div",
            {
              className: ae(
                "flex flex-row items-center gap-3 p-3",
                (_ = (u = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : u.listItem) == null ? void 0 : _.container
              ),
              children: [
                /* @__PURE__ */ m(
                  wl,
                  {
                    size: "mdLg",
                    className: ae(
                      "overflow-visible",
                      (f = (p = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : p.listItem) == null ? void 0 : f.avatar
                    ),
                    imageSrc: l.owner.avatar,
                    alt: l.owner.name || l.owner.email || ""
                  }
                ),
                /* @__PURE__ */ Y("div", { className: "flex w-full flex-row justify-between", children: [
                  /* @__PURE__ */ Y("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ Y(
                      "span",
                      {
                        className: ae(
                          "text text-sm font-semibold leading-none",
                          (h = (g = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : g.listItem) == null ? void 0 : h.name
                        ),
                        children: [
                          l.owner.name || l.owner.email,
                          /* @__PURE__ */ Y(
                            "div",
                            {
                              className: ae(
                                "flex flex-row gap-1",
                                (v = (b = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : b.listItem) == null ? void 0 : v.badgeContainer
                              ),
                              children: [
                                l.owner.membership === ogc.OWNER ? /* @__PURE__ */ m(
                                  Nr,
                                  {
                                    variant: "gray",
                                    className: (k = ($ = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : $.listItem) == null ? void 0 : k.ownerBadge,
                                    children: r("owner")
                                  }
                                ) : /* @__PURE__ */ m(
                                  Nr,
                                  {
                                    variant: "gray",
                                    className: (O = (S = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : S.listItem) == null ? void 0 : O.memberBadge,
                                    children: r("member")
                                  }
                                ),
                                l.hidden && /* @__PURE__ */ m(
                                  Nr,
                                  {
                                    variant: "gray",
                                    className: (D = (I = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : I.listItem) == null ? void 0 : D.hiddenBadge,
                                    children: r("hidden")
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    l.owner.username && /* @__PURE__ */ m(
                      "small",
                      {
                        className: ae(
                          "text-subtle font-normal leading-normal",
                          (N = (M = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : M.listItem) == null ? void 0 : N.eventLink
                        ),
                        children: `/${l.owner.username}/${l.slug}`
                      }
                    )
                  ] }),
                  /* @__PURE__ */ Y("div", { className: ae("flex flex-row items-center gap-2"), children: [
                    /* @__PURE__ */ m(
                      Ao,
                      {
                        className: (P = (C = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : C.listItem) == null ? void 0 : P.showOnProfileTooltip,
                        content: r("show_eventtype_on_profile"),
                        children: /* @__PURE__ */ m("div", { className: "self-center rounded-md p-2", children: /* @__PURE__ */ m(
                          Ri,
                          {
                            name: "Hidden",
                            checked: !l.hidden,
                            onCheckedChange: (W) => {
                              const H = t.map(
                                (Q) => Q.owner.id === l.owner.id ? { ...Q, hidden: !W } : Q
                              );
                              o.onChange(H);
                            }
                          }
                        ) })
                      }
                    ),
                    /* @__PURE__ */ Y(HA, { combined: !0, children: [
                      l.created && l.owner.username && /* @__PURE__ */ m(
                        Ao,
                        {
                          className: (w = (x = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : x.listItem) == null ? void 0 : w.previewEventTypeTooltip,
                          content: r("preview"),
                          children: /* @__PURE__ */ m(
                            ut,
                            {
                              "data-testid": "preview-button",
                              color: "secondary",
                              target: "_blank",
                              variant: "icon",
                              className: (T = (E = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : E.listItem) == null ? void 0 : T.previewEventTypeButton,
                              href: `${qv(
                                ((j = (z = l.owner.profile) == null ? void 0 : z.organization) == null ? void 0 : j.slug) ?? null
                              )}/${(q = l.owner) == null ? void 0 : q.username}/${l.slug}`,
                              StartIcon: "external-link"
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ m(
                        Ao,
                        {
                          className: (F = (V = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : V.listItem) == null ? void 0 : F.deleteEventTypeTooltip,
                          content: r("delete"),
                          children: /* @__PURE__ */ m(
                            ut,
                            {
                              color: "secondary",
                              target: "_blank",
                              variant: "icon",
                              className: (U = (L = n == null ? void 0 : n.selectedChildrenList) == null ? void 0 : L.listItem) == null ? void 0 : U.deleteEventTypeButton,
                              onClick: () => o.onChange(t.filter((W) => W.owner.id !== l.owner.id)),
                              StartIcon: "x"
                            }
                          )
                        }
                      )
                    ] })
                  ] })
                ] })
              ]
            }
          ) }, d);
        })
      }
    )
  ] });
}, Mpd = Dpd, Lpd = (e, t) => {
  const n = typeof e == "string" ? e : qpd(e), o = new Blob([n], { type: "text/plain" }), r = window.URL.createObjectURL(o), i = document.createElement("a");
  i.href = r, i.download = t, i.click(), window.URL.revokeObjectURL(r);
}, qpd = (e) => {
  if (!e.length)
    return "";
  const t = Object.keys(e[0]);
  return [
    // Header row
    t.map((o) => Zre(o)).join(","),
    // Data rows
    ...e.map(
      (o) => t.map((r) => {
        const i = o[r];
        return Zre((i == null ? void 0 : i.toString()) ?? "");
      }).join(",")
    )
  ].join(`
`);
}, Zre = (e) => e.includes('"') ? `"${e.replace(/"/g, '""')}"` : e.includes(",") || e.includes(`
`) ? `"${e}"` : e, p1e = (e) => /* @__PURE__ */ m(Nle, { ...e });
p1e.displayName = "Sheet";
const jpd = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(Dle, { ref: n, className: ae(e), ...t }));
jpd.displayName = "Sheet.Trigger";
const m1e = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(S9, { ref: n, className: ae(e), ...t }));
m1e.displayName = "Sheet.Close";
const f1e = Rle;
f1e.displayName = "SheetPortal";
const g1e = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  Mle,
  {
    ref: n,
    className: ae(
      // base
      "fixed inset-0 z-50 overflow-y-auto",
      // background color
      "bg-black/30",
      // transition
      "data-[state=closed]:animate-hide data-[state=open]:animate-dialogOverlayShow",
      e
    ),
    ...t,
    style: {
      animationDuration: "400ms",
      animationFillMode: "backwards"
    }
  }
));
g1e.displayName = "SheetOverlay";
const h1e = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(f1e, { children: /* @__PURE__ */ m(g1e, { children: /* @__PURE__ */ m(
  Lle,
  {
    ref: n,
    className: ae(
      // base
      "fixed inset-y-4 mx-auto flex w-[95vw] flex-1 flex-col overflow-y-auto rounded-xl border p-4 shadow-lg focus:outline-none sm:right-2 sm:max-w-lg sm:p-6",
      // "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm sm:p-6 p-4 shadow-lg rounded-xl border ",
      // border color
      "border-subtle",
      // background color
      "bg-default",
      // transition
      "data-[state=closed]:animate-SheetSlideRightAndFade data-[state=open]:animate-SheetSlideLeftAndFade",
      e
    ),
    ...t
  }
) }) }));
h1e.displayName = "SheetContent";
const v1e = $e.forwardRef(({ children: e, className: t, showCloseButton: n = !0, ...o }, r) => /* @__PURE__ */ Y("div", { ref: r, className: "flex items-start justify-between gap-x-4 pb-2", ...o, children: [
  /* @__PURE__ */ m("div", { className: ae("mt-1 flex flex-col gap-y-1", t), children: e }),
  n && /* @__PURE__ */ m(S9, { asChild: !0, children: /* @__PURE__ */ m(ut, { variant: "icon", StartIcon: "x", color: "minimal", className: "aspect-square p-1" }) })
] }));
v1e.displayName = "Sheet.Header";
const b1e = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  qle,
  {
    ref: n,
    className: ae(
      // base
      "font-sans text-xl font-semibold",
      // text color
      "text-emphasis",
      e
    ),
    ...t
  }
));
b1e.displayName = "SheetTitle";
const y1e = $e.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ m("div", { ref: n, className: ae("flex-1 overflow-y-auto py-4", e), ...t })
);
y1e.displayName = "Sheet.Body";
const Fpd = $e.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ m(
  jle,
  {
    ref: n,
    className: ae("text-subtle text-sm leading-none", e),
    ...t
  }
));
Fpd.displayName = "SheetDescription";
const $1e = ({ className: e, ...t }) => /* @__PURE__ */ m(
  "div",
  {
    className: ae(
      "border-muted flex flex-col-reverse gap-2 border-t pt-4 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
$1e.displayName = "SheetFooter";
const w1e = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  matchingTeamMembersWithResult: n,
  value: o
}) => {
  const r = Tt(() => t && (n != null && n.result) ? n.result.map((a) => ({
    value: a.id.toString(),
    label: a.name || a.email,
    email: a.email,
    avatar: ""
  })) : e, [t, n, e]), i = Tt(
    () => r.reduce((a, s) => {
      const c = o.find((l) => l.userId === parseInt(s.value, 10));
      return a[s.value] = (c == null ? void 0 : c.weight) ?? 100, a;
    }, {}),
    [r, o]
  );
  return {
    teamMembers: r,
    localWeightsInitialValues: i
  };
}, Vpd = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  teamId: n,
  orgId: o,
  queryValue: r,
  value: i
}) => {
  const { isInit: a } = po(), s = `/atoms/organizations/${o}/teams/${n}/members-matching-attribute?${new URLSearchParams(
    {
      attributesQueryValue: r ? JSON.stringify(r) : "",
      enablePerf: "true"
    }
  )}`, { data: c, isPending: l } = go({
    queryKey: ["teamMembersMatchingAttribute", n, o, r],
    queryFn: async () => He == null ? void 0 : He.get(s).then((_) => {
      if (_.data.status === qt)
        return _.data.data;
      throw new Error(_.data.error.message);
    }),
    enabled: a && !!n && !!o
  }), { teamMembers: d, localWeightsInitialValues: u } = w1e({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: t,
    matchingTeamMembersWithResult: c,
    value: i
  });
  return {
    teamMembers: d,
    localWeightsInitialValues: u,
    isPending: l
  };
}, Bpd = ({
  initialTeamMembers: e,
  assignRRMembersUsingSegment: t,
  teamId: n,
  queryValue: o,
  value: r
}) => {
  const { data: i, isPending: a } = bo.viewer.attributes.findTeamMembersMatchingAttributeLogic.useQuery(
    {
      teamId: n || 0,
      attributesQueryValue: o,
      _enablePerf: !0
    },
    {
      enabled: t && !!o && !!n
    }
  ), { teamMembers: s, localWeightsInitialValues: c } = w1e({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: t,
    matchingTeamMembersWithResult: i,
    value: r
  });
  return {
    teamMembers: s,
    localWeightsInitialValues: c,
    isPending: a
  };
}, Upd = ({ member: e, onWeightChange: t }) => {
  const [n, o] = ze(!1), r = Ue(null);
  return Le(() => {
    n && r.current && r.current.focus();
  }, [n]), /* @__PURE__ */ Y("div", { className: "border-subtle flex h-12 items-center border-b px-3 py-1 last:border-b-0", children: [
    /* @__PURE__ */ m(wl, { size: "sm", imageSrc: e.avatar, alt: e.label, className: "min-w-10" }),
    /* @__PURE__ */ m("span", { className: "text-emphasis ml-3 flex-grow text-sm", children: e.label }),
    /* @__PURE__ */ m("div", { className: "ml-auto flex h-full items-center", children: n ? /* @__PURE__ */ m("div", { className: "flex h-full items-center", children: /* @__PURE__ */ Y("div", { className: "relative flex h-full items-center", children: [
      /* @__PURE__ */ m(
        "input",
        {
          ref: r,
          type: "number",
          min: "0",
          inputMode: "numeric",
          className: "bg-muted border-default text-emphasis h-7 w-12 rounded-l-sm border px-2 text-sm [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          defaultValue: e.weight ?? 100,
          onBlur: (i) => {
            const a = parseInt(i.target.value);
            isNaN(a) || t(e.value, a), o(!1);
          },
          onKeyDown: (i) => {
            if (i.key === "Enter") {
              const a = i.target, s = parseInt(a.value);
              isNaN(s) || t(e.value, s), o(!1);
            }
            i.key === "Escape" && o(!1);
          }
        }
      ),
      /* @__PURE__ */ m("span", { className: "text-default border-default bg-muted flex h-7 items-center rounded-r-sm border border-l-0 px-2 text-sm", children: "%" })
    ] }) }) : /* @__PURE__ */ Y(
      "button",
      {
        className: "text-emphasis hover:bg-subtle decoration-emphasis flex h-7 items-center rounded-sm px-2 text-sm underline underline-offset-4",
        onClick: () => o(!0),
        children: [
          e.weight ?? 100,
          "%"
        ]
      }
    ) })
  ] });
}, Wpd = ({
  teamMembers: e,
  value: t,
  onChange: n,
  assignAllTeamMembers: o,
  assignRRMembersUsingSegment: r,
  teamId: i,
  queryValue: a
}) => {
  const [s, c] = ze(!1), { t: l } = Fe(), [d, u] = ze(""), p = Zo() ? Vpd : Bpd, { teamMembers: f, localWeightsInitialValues: g } = p({
    initialTeamMembers: e,
    assignRRMembersUsingSegment: r,
    teamId: i,
    queryValue: a,
    value: t
  }), [h, b] = ze(g), [v, $] = ze([]), [k, S] = ze(!0), O = (C, P) => {
    b((x) => ({ ...x, [C]: P }));
  }, I = () => {
    const C = new Map(
      t.filter((x) => !x.isFixed).map((x) => [x.userId.toString(), x])
    ), P = f.map((x) => {
      const w = C.get(x.value);
      return w ? {
        ...w,
        userId: parseInt(x.value, 10),
        isFixed: (w == null ? void 0 : w.isFixed) ?? !1,
        priority: (w == null ? void 0 : w.priority) ?? 0,
        weight: h[x.value] ?? (w == null ? void 0 : w.weight) ?? 100,
        groupId: (w == null ? void 0 : w.groupId) ?? null
      } : null;
    }).filter(Boolean);
    n(P), c(!1);
  }, D = () => {
    const C = f.map((P) => ({
      id: P.value,
      name: P.label,
      email: P.email,
      weight: h[P.value] ?? 100
    }));
    Lpd(C, "team-members-weights.csv");
  }, M = (C) => {
    var w;
    if (!((w = C.target.files) != null && w.length))
      return;
    const P = C.target.files[0], x = new FileReader();
    x.onload = async (E) => {
      var V;
      if (!((V = E.target) != null && V.result))
        return;
      const z = E.target.result.split(`
`), j = { ...h }, q = [];
      for (let F = 1; F < z.length; F++) {
        const L = z[F].trim();
        if (!L)
          continue;
        const [, , U, W] = L.split(",");
        if (!U || !W)
          continue;
        const H = f.find((X) => X.email === U);
        if (!H) {
          q.push({ email: U, error: l("member_not_found") });
          continue;
        }
        const Q = parseInt(W);
        if (isNaN(Q) || Q <= 0) {
          q.push({ email: U, error: l("invalid_weight") });
          continue;
        }
        j[H.value] = Q;
      }
      b(j), $(q), q.length > 0 ? nr(l("weights_updated_with_errors", { count: q.length }), "warning") : nr(l("weights_updated_from_csv"), "success"), C.target.value = "";
    }, x.readAsText(P);
  }, N = Tt(() => f.map((C) => ({
    ...C,
    weight: h[C.value]
  })).filter(
    (C) => C.label.toLowerCase().includes(d.toLowerCase()) || C.email.toLowerCase().includes(d.toLowerCase())
  ).filter((C) => o || t.some((P) => !P.isFixed && P.userId === parseInt(C.value, 10))), [f, h, d, o, t]);
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ m(
      ut,
      {
        color: "secondary",
        className: "-ml-2 -mt-2 mb-2 w-fit",
        onClick: () => {
          c(!0);
        },
        children: l("edit_team_member_weights")
      }
    ),
    /* @__PURE__ */ m(p1e, { open: s, onOpenChange: c, children: /* @__PURE__ */ m("form", { className: "flex h-full flex-col", children: /* @__PURE__ */ Y(h1e, { children: [
      /* @__PURE__ */ Y(v1e, { children: [
        /* @__PURE__ */ m(b1e, { children: l("edit_team_member_weights") }),
        /* @__PURE__ */ m("div", { className: "text-subtle text-sm", children: /* @__PURE__ */ m(
          Dc,
          {
            t: l,
            i18nKey: "weights_description",
            components: [
              /* @__PURE__ */ m(
                Po,
                {
                  className: "underline underline-offset-2",
                  target: "_blank",
                  href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#weights",
                  children: "Learn more"
                },
                "weights_description"
              )
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ Y(y1e, { className: "mt-4 flex h-full flex-col space-y-6 p-1", children: [
        /* @__PURE__ */ Y("div", { className: "flex justify-start gap-2", children: [
          /* @__PURE__ */ Y("label", { className: Cx({ color: "secondary" }), children: [
            /* @__PURE__ */ m(ot, { name: "upload", className: "mr-2 h-4 w-4" }),
            /* @__PURE__ */ m("input", { type: "file", accept: ".csv", className: "hidden", onChange: M }),
            l("upload")
          ] }),
          /* @__PURE__ */ m(ut, { color: "secondary", StartIcon: "download", onClick: D, children: l("download") })
        ] }),
        /* @__PURE__ */ m(
          Io,
          {
            placeholder: l("search"),
            value: d,
            onChange: (C) => u(C.target.value.toLowerCase()),
            addOnLeading: /* @__PURE__ */ m(ot, { name: "search", className: "text-subtle h-4 w-4", "aria-hidden": "true", focusable: "false" })
          }
        ),
        /* @__PURE__ */ Y("div", { className: "flex max-h-[80dvh] flex-col overflow-y-auto rounded-md border", children: [
          N.map((C) => /* @__PURE__ */ m(Upd, { member: C, onWeightChange: O }, C.value)),
          N.length === 0 && /* @__PURE__ */ m("div", { className: "text-subtle py-4 text-center text-sm", children: l("no_members_found") })
        ] }),
        v.length > 0 && /* @__PURE__ */ Y("div", { className: "mt-4", children: [
          /* @__PURE__ */ Y(
            "button",
            {
              className: "flex w-full items-center justify-between rounded-md border bg-red-50 p-3 text-sm text-red-900",
              onClick: () => S(!k),
              children: [
                /* @__PURE__ */ Y("div", { className: "flex items-center space-x-2", children: [
                  /* @__PURE__ */ m(ot, { name: "info", className: "h-4 w-4" }),
                  /* @__PURE__ */ m("span", { children: l("csv_upload_errors", { count: v.length }) })
                ] }),
                /* @__PURE__ */ m(ot, { name: "chevron-down", className: "h-4 w-4" })
              ]
            }
          ),
          k && /* @__PURE__ */ m("div", { className: "mt-2 space-y-2", children: v.map((C, P) => /* @__PURE__ */ Y(
            "div",
            {
              className: "rounded-md border border-red-100 bg-red-50 p-3 text-sm text-red-900",
              children: [
                /* @__PURE__ */ Y("strong", { children: [
                  C.email,
                  ":"
                ] }),
                " ",
                C.error
              ]
            },
            P
          )) })
        ] })
      ] }),
      /* @__PURE__ */ Y($1e, { children: [
        /* @__PURE__ */ m(m1e, { asChild: !0, children: /* @__PURE__ */ m(
          ut,
          {
            color: "minimal",
            onClick: () => {
              b(g), u("");
            },
            children: l("cancel")
          }
        ) }),
        /* @__PURE__ */ m(ut, { onClick: I, children: l("done") })
      ] })
    ] }) }) })
  ] });
}, Gpd = (e, t, n) => ({
  slug: t,
  hidden: !1,
  created: !1,
  owner: {
    id: e.id,
    name: e.name ?? "",
    email: e.email,
    username: e.username ?? "",
    membership: e.membership,
    eventTypeSlugs: e.eventTypes ?? [],
    avatar: e.avatar,
    profile: e.profile
  },
  value: `${e.id ?? ""}`,
  label: `${e.name || e.email || ""}${e.username ? "" : ` (${n})`}`
}), Hpd = ({
  options: e = [],
  value: t,
  onChange: n,
  customClassNames: o,
  ...r
}) => {
  var a, s;
  const { t: i } = Fe();
  return /* @__PURE__ */ m("div", { className: ae("flex flex-col space-y-5", (a = o == null ? void 0 : o.assignToSelect) == null ? void 0 : a.container), children: /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ m(Xn, { className: (s = o == null ? void 0 : o.assignToSelect) == null ? void 0 : s.label, children: i("assign_to") }),
    /* @__PURE__ */ m(
      Mpd,
      {
        "aria-label": "assignment-dropdown",
        "data-testid": "assignment-dropdown",
        onChange: (c) => {
          n && n(
            c.map((l) => ({
              ...l
            }))
          );
        },
        value: t,
        options: e.filter((c) => !t.find((l) => l.owner.id.toString() === c.value)),
        controlShouldRenderValue: !1,
        customClassNames: o,
        ...r
      }
    )
  ] }) });
}, Qre = ({ t: e }) => /* @__PURE__ */ m(
  Dc,
  {
    t: e,
    i18nKey: "fixed_host_helper",
    components: [
      /* @__PURE__ */ m(
        Po,
        {
          className: "underline underline-offset-2",
          target: "_blank",
          href: "https://cal.com/docs/enterprise-features/teams/round-robin-scheduling#fixed-hosts",
          children: "Learn more"
        },
        "fixed_host_helper"
      )
    ]
  }
), Jre = ({
  teamId: e,
  teamMembers: t,
  value: n,
  onChange: o,
  assignAllTeamMembers: r,
  setAssignAllTeamMembers: i,
  isRoundRobinEvent: a = !1,
  customClassNames: s
}) => {
  const { t: c } = Fe(), { getValues: l, setValue: d } = Dn(), u = a && l("hosts").some((h) => h.isFixed), [_, p] = ze(u), f = at(() => {
    const h = l("hosts");
    d(
      "hosts",
      t.map((b) => {
        const v = h.find(($) => $.userId === parseInt(b.value, 10));
        return {
          isFixed: !0,
          userId: parseInt(b.value, 10),
          priority: (v == null ? void 0 : v.priority) ?? 2,
          weight: (v == null ? void 0 : v.weight) ?? 100,
          // if host was already added, retain scheduleId and groupId
          scheduleId: (v == null ? void 0 : v.scheduleId) || b.defaultScheduleId,
          groupId: (v == null ? void 0 : v.groupId) || null
        };
      }),
      { shouldDirty: !0 }
    );
  }, [l, d, t]), g = at(
    (h) => {
      if (!h) {
        const b = l("hosts").filter((v) => !v.isFixed).sort((v, $) => ($.priority ?? 2) - (v.priority ?? 2));
        d("hosts", b, { shouldDirty: !0 });
      }
      p(h);
    },
    [l, d]
  );
  return /* @__PURE__ */ m("div", { className: ae("mt-5 rounded-lg", s == null ? void 0 : s.container), children: a ? /* @__PURE__ */ m(
    eo,
    {
      "data-testid": "fixed-hosts-switch",
      toggleSwitchAtTheEnd: !0,
      title: c("fixed_hosts"),
      description: /* @__PURE__ */ m(Qre, { t: c }),
      checked: _ && !r,
      hideSwitch: r,
      labelClassName: ae("text-sm", s == null ? void 0 : s.label),
      descriptionClassName: ae("text-sm text-subtle", s == null ? void 0 : s.description),
      switchContainerClassName: s == null ? void 0 : s.container,
      onCheckedChange: g,
      childrenClassName: ae("lg:ml-0", s == null ? void 0 : s.children),
      children: /* @__PURE__ */ m("div", { className: "border-subtle flex flex-col gap-6 rounded-bl-md rounded-br-md border border-t-0 px-6", children: /* @__PURE__ */ m(
        yq,
        {
          "data-testid": "fixed-hosts-select",
          groupId: null,
          placeholder: c("add_a_member"),
          teamId: e,
          teamMembers: t,
          customClassNames: s == null ? void 0 : s.addMembers,
          value: n,
          onChange: o,
          assignAllTeamMembers: r,
          setAssignAllTeamMembers: i,
          automaticAddAllEnabled: !a,
          isFixed: !0,
          onActive: f
        }
      ) })
    }
  ) : /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y(
      "div",
      {
        className: ae(
          "border-subtle mt-5 rounded-t-md border p-6 pb-5",
          s == null ? void 0 : s.container
        ),
        children: [
          /* @__PURE__ */ m(Xn, { className: ae("mb-1 text-sm font-semibold", s == null ? void 0 : s.label), children: c("fixed_hosts") }),
          /* @__PURE__ */ m(
            "p",
            {
              className: ae(
                "text-subtle max-w-full break-words text-sm leading-tight",
                s == null ? void 0 : s.description
              ),
              children: /* @__PURE__ */ m(Qre, { t: c })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ m("div", { className: "border-subtle rounded-b-md border border-t-0 px-6", children: /* @__PURE__ */ m(
      yq,
      {
        teamId: e,
        groupId: null,
        teamMembers: t,
        value: n,
        onChange: o,
        assignAllTeamMembers: r,
        setAssignAllTeamMembers: i,
        automaticAddAllEnabled: !a,
        isFixed: !0,
        customClassNames: s == null ? void 0 : s.addMembers,
        onActive: f
      }
    ) })
  ] }) });
}, Kpd = ({
  orgId: e,
  teamMembers: t,
  value: n,
  onChange: o,
  assignAllTeamMembers: r,
  setAssignAllTeamMembers: i,
  customClassNames: a,
  teamId: s,
  isSegmentApplicable: c
}) => {
  var N;
  const { t: l } = Fe(), { setValue: d, getValues: u, control: _, formState: p } = Dn(), f = u("assignRRMembersUsingSegment"), g = m_({
    control: _,
    name: "isRRWeightsEnabled"
  }), h = m_({
    control: _,
    name: "rrSegmentQueryValue"
  }), b = m_({
    control: _,
    name: "hostGroups"
  }), v = (C, P) => {
    P(C);
    const x = u("hosts"), w = x.filter((z) => z.isFixed), T = x.filter((z) => !z.isFixed).sort((z, j) => Xw(z, j, C));
    d("hosts", [...w, ...T]);
  }, $ = (C) => {
    const x = u("hosts").filter((E) => E.isFixed), w = C.sort((E, T) => Xw(E, T, !0));
    d("hosts", [...x, ...w], { shouldDirty: !0 });
  }, k = at(() => {
    const C = u("hosts"), P = C.filter((w) => !w.isFixed), x = C.filter((w) => w.isFixed);
    if ((b == null ? void 0 : b.length) === 0 && P.length > 0) {
      const w = { id: U$(), name: "" }, E = { id: U$(), name: "" };
      d("hostGroups", [w, E], { shouldDirty: !0 });
      const z = P.map((j) => !j.groupId && !j.isFixed ? { ...j, groupId: w.id } : j);
      d("hosts", [...x, ...z], { shouldDirty: !0 });
    } else {
      const w = { id: U$(), name: "" }, E = [...b, w];
      d("hostGroups", E, { shouldDirty: !0 });
    }
    r && (d("assignAllTeamMembers", !1, { shouldDirty: !0 }), i(!1));
  }, [b, u, d, r, i]), S = at(
    (C, P) => {
      const x = (b == null ? void 0 : b.map((w) => w.id === C ? { ...w, name: P } : w)) || [];
      d("hostGroups", x, { shouldDirty: !0 });
    },
    [b, d]
  ), O = at(
    (C) => {
      const P = (b == null ? void 0 : b.filter((w) => w.id !== C)) || [];
      d("hostGroups", P, { shouldDirty: !0 });
      const x = n.filter((w) => w.groupId !== C);
      o(x), d("hosts", x, { shouldDirty: !0 });
    },
    [b, d, n, o]
  ), I = at(
    (C) => {
      const P = u("hosts");
      d(
        "hosts",
        t.map((x) => {
          const w = P.find((E) => E.userId === parseInt(x.value, 10));
          return {
            isFixed: !1,
            userId: parseInt(x.value, 10),
            priority: (w == null ? void 0 : w.priority) ?? 2,
            weight: (w == null ? void 0 : w.weight) ?? 100,
            // if host was already added, retain scheduleId and groupId
            scheduleId: (w == null ? void 0 : w.scheduleId) || x.defaultScheduleId,
            groupId: (w == null ? void 0 : w.groupId) || C
          };
        }),
        { shouldDirty: !0 }
      );
    },
    [u, d, t]
  ), D = ({
    groupId: C,
    containerClassName: P
  }) => /* @__PURE__ */ m(
    yq,
    {
      placeholder: l("add_a_member"),
      teamId: s,
      teamMembers: t,
      value: n,
      onChange: o,
      assignAllTeamMembers: r,
      setAssignAllTeamMembers: i,
      isSegmentApplicable: c,
      automaticAddAllEnabled: !0,
      isRRWeightsEnabled: g,
      isFixed: !1,
      groupId: C,
      containerClassName: P || (r ? "-mt-4" : ""),
      onActive: () => I(C),
      customClassNames: a == null ? void 0 : a.addMembers
    }
  ), M = () => n.filter((P) => !P.isFixed && !P.groupId).length === 0 ? null : /* @__PURE__ */ Y("div", { className: "border-subtle my-4 rounded-md border p-4 pb-0", children: [
    /* @__PURE__ */ m("div", { className: "-mb-4 flex items-center justify-between", children: /* @__PURE__ */ m("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ m("span", { className: "text-default text-sm font-medium", children: `Group ${b.length + 1}` }) }) }),
    /* @__PURE__ */ m(D, { groupId: null })
  ] });
  return /* @__PURE__ */ Y("div", { className: ae("rounded-lg"), children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: ae(
          "border-subtle mt-5 rounded-t-md border p-6 pb-5",
          a == null ? void 0 : a.container
        ),
        children: /* @__PURE__ */ Y("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ m(Xn, { className: ae("mb-1 text-sm font-semibold", a == null ? void 0 : a.label), children: l("round_robin_hosts") }),
            /* @__PURE__ */ m(
              "p",
              {
                className: ae(
                  "text-subtle max-w-full break-words text-sm leading-tight",
                  a == null ? void 0 : a.description
                ),
                children: /* @__PURE__ */ m(
                  Ga,
                  {
                    t: l,
                    i18nKey: (b == null ? void 0 : b.length) > 0 ? "round_robin_groups_helper" : "round_robin_helper",
                    href: "https://cal.com/help/event-types/round-robin"
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ m(ut, { color: "secondary", size: "sm", StartIcon: "plus", onClick: k, children: l("add_group") })
        ] })
      }
    ),
    /* @__PURE__ */ Y("div", { className: "border-subtle rounded-b-md border border-t-0 px-6 pt-4", children: [
      /* @__PURE__ */ m(Ce, { children: /* @__PURE__ */ m(
        Wt,
        {
          name: "isRRWeightsEnabled",
          render: ({ field: { value: C, onChange: P } }) => {
            var x, w, E;
            return /* @__PURE__ */ m(
              eo,
              {
                title: l("enable_weights"),
                description: /* @__PURE__ */ m(eye, { t: l }),
                checked: C,
                switchContainerClassName: (x = a == null ? void 0 : a.enableWeights) == null ? void 0 : x.container,
                labelClassName: (w = a == null ? void 0 : a.enableWeights) == null ? void 0 : w.label,
                descriptionClassName: (E = a == null ? void 0 : a.enableWeights) == null ? void 0 : E.description,
                onCheckedChange: (T) => v(T, P),
                children: /* @__PURE__ */ m(
                  Wpd,
                  {
                    teamMembers: t,
                    value: n,
                    onChange: $,
                    assignAllTeamMembers: r,
                    assignRRMembersUsingSegment: f,
                    teamId: s,
                    queryValue: h
                  }
                )
              }
            );
          }
        }
      ) }),
      b.length ? /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(M, {}),
        b.map((C, P) => {
          const x = P + 1;
          return /* @__PURE__ */ Y("div", { className: "border-subtle my-4 rounded-md border p-4 pb-0", children: [
            /* @__PURE__ */ Y("div", { className: "-mb-4 flex items-center justify-between", children: [
              /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ m(
                "input",
                {
                  type: "text",
                  value: C.name ?? "",
                  onChange: (w) => S(C.id, w.target.value),
                  className: "border-none bg-transparent p-0 text-sm font-medium focus:outline-none focus:ring-0",
                  placeholder: `Group ${x}`
                }
              ) }),
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  onClick: () => O(C.id),
                  className: "text-subtle hover:text-default rounded p-1",
                  children: /* @__PURE__ */ m(ot, { name: "x", className: "h-4 w-4" })
                }
              )
            ] }),
            /* @__PURE__ */ m(D, { groupId: C.id })
          ] }, P);
        })
      ] }) : /* @__PURE__ */ m(D, { groupId: ((N = b[0]) == null ? void 0 : N.id) ?? null })
    ] })
  ] });
}, Ypd = ({
  childrenEventTypeOptions: e,
  assignAllTeamMembers: t,
  setAssignAllTeamMembers: n,
  customClassNames: o
}) => {
  const { setValue: r } = Dn();
  return /* @__PURE__ */ m(
    "div",
    {
      className: ae(
        "border-subtle mt-6 space-y-5 rounded-lg border px-4 py-6 sm:px-6",
        o == null ? void 0 : o.container
      ),
      children: /* @__PURE__ */ Y("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ m(
          bq,
          {
            assignAllTeamMembers: t,
            setAssignAllTeamMembers: n,
            customClassNames: o == null ? void 0 : o.assignAllTeamMembers,
            onActive: () => r("children", e, { shouldDirty: !0 })
          }
        ),
        t ? /* @__PURE__ */ m(Ce, {}) : /* @__PURE__ */ m(
          Wt,
          {
            name: "children",
            render: ({ field: { onChange: i, value: a } }) => /* @__PURE__ */ m(
              Hpd,
              {
                value: a,
                options: e,
                onChange: i,
                customClassNames: o == null ? void 0 : o.childrenEventTypesList
              }
            )
          }
        )
      ] })
    }
  );
}, Zpd = ({
  orgId: e,
  teamId: t,
  teamMembers: n,
  assignAllTeamMembers: o,
  setAssignAllTeamMembers: r,
  customClassNames: i,
  isSegmentApplicable: a
}) => {
  const {
    control: s,
    setValue: c,
    getValues: l,
    formState: { submitCount: d }
  } = Dn(), u = m_({
    control: s,
    name: "schedulingType"
  }), _ = Ue(null);
  Le(() => {
    var f;
    if (!_.current || ((f = _.current) == null ? void 0 : f.submitCount) !== d) {
      _.current = { hosts: l("hosts"), schedulingType: u, submitCount: d };
      return;
    }
    c(
      "hosts",
      _.current.schedulingType === u ? _.current.hosts : [],
      { shouldDirty: !0 }
    );
  }, [u, c, l, d]);
  const p = (f) => {
    const g = l("hosts");
    return f.map((h) => {
      const b = g.find((v) => v.userId === h.userId);
      return b ? {
        ...h,
        scheduleId: b.scheduleId,
        groupId: b.groupId
      } : h;
    });
  };
  return /* @__PURE__ */ m(
    Wt,
    {
      name: "hosts",
      render: ({ field: { onChange: f, value: g } }) => {
        const h = {
          COLLECTIVE: /* @__PURE__ */ m(
            Jre,
            {
              teamId: t,
              teamMembers: n,
              value: g,
              onChange: (b) => {
                f([...p(b)]);
              },
              assignAllTeamMembers: o,
              setAssignAllTeamMembers: r,
              customClassNames: i == null ? void 0 : i.fixedHosts
            }
          ),
          ROUND_ROBIN: /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              Jre,
              {
                teamId: t,
                teamMembers: n,
                value: g,
                onChange: (b) => {
                  f([...g.filter((v) => !v.isFixed), ...p(b)]);
                },
                assignAllTeamMembers: o,
                setAssignAllTeamMembers: r,
                isRoundRobinEvent: !0,
                customClassNames: i == null ? void 0 : i.fixedHosts
              }
            ),
            /* @__PURE__ */ m(
              Kpd,
              {
                orgId: e,
                teamId: t,
                teamMembers: n,
                value: g,
                onChange: (b) => {
                  const v = [...g.filter(($) => $.isFixed), ...p(b)];
                  f(v);
                },
                assignAllTeamMembers: o,
                setAssignAllTeamMembers: r,
                customClassNames: i == null ? void 0 : i.roundRobinHosts,
                isSegmentApplicable: a
              }
            )
          ] }),
          MANAGED: /* @__PURE__ */ m(Ce, {})
        };
        return u ? h[u] : /* @__PURE__ */ m(Ce, {});
      }
    }
  );
}, Qpd = ({
  team: e,
  teamMembers: t,
  eventType: n,
  customClassNames: o,
  orgId: r,
  isSegmentApplicable: i
}) => {
  var O, I, D, M, N, C, P;
  const { t: a } = Fe(), s = [
    {
      value: "COLLECTIVE",
      label: a("collective")
      // description: t("collective_description"),
    },
    {
      value: "ROUND_ROBIN",
      label: a("round_robin")
      // description: t("round_robin_description"),
    }
  ], c = (x) => {
    var w;
    return !!((w = n.team) != null && w.parentId) || !!x.username;
  }, l = t.filter(c).map((x) => zpd(x, a("pending"))), d = t.filter(c).map((x) => Gpd(
    {
      ...x,
      eventTypes: x.eventTypes.filter(
        (w) => w !== n.slug || !n.children.some((E) => E.owner.id === x.id)
      )
    },
    n.slug,
    a("pending")
  )), u = n.schedulingType === aa.MANAGED, { getValues: _, setValue: p, control: f } = Dn(), [g, h] = ze(
    _("assignAllTeamMembers") ?? !1
  ), b = () => {
    p("assignRRMembersUsingSegment", !1, { shouldDirty: !0 }), p("assignAllTeamMembers", !1, { shouldDirty: !0 }), h(!1);
  }, v = at(
    (x, w) => {
      x && (w(x), b());
    },
    [p, h]
  ), $ = (x, w) => {
    w(x === "loadBalancing" ? 3 : null);
  }, k = m_({
    control: f,
    name: "schedulingType"
  }), S = m_({
    control: f,
    name: "hostGroups"
  });
  return /* @__PURE__ */ Y("div", { children: [
    e && !u && /* @__PURE__ */ Y(Ce, { children: [
      /* @__PURE__ */ Y(
        "div",
        {
          className: ae(
            "border-subtle flex flex-col rounded-md",
            (O = o == null ? void 0 : o.assignmentType) == null ? void 0 : O.container
          ),
          children: [
            /* @__PURE__ */ Y("div", { className: "border-subtle rounded-t-md border p-6 pb-5", children: [
              /* @__PURE__ */ m(
                Xn,
                {
                  className: ae("mb-1 text-sm font-semibold", (I = o == null ? void 0 : o.assignmentType) == null ? void 0 : I.label),
                  children: a("assignment")
                }
              ),
              /* @__PURE__ */ m(
                "p",
                {
                  className: ae(
                    "text-subtle max-w-full break-words text-sm leading-tight",
                    (D = o == null ? void 0 : o.assignmentType) == null ? void 0 : D.description
                  ),
                  children: a("assignment_description")
                }
              )
            ] }),
            /* @__PURE__ */ Y(
              "div",
              {
                className: ae(
                  "border-subtle rounded-b-md border border-t-0 p-6",
                  (N = (M = o == null ? void 0 : o.assignmentType) == null ? void 0 : M.schedulingTypeSelect) == null ? void 0 : N.container
                ),
                children: [
                  /* @__PURE__ */ m(Xn, { className: (P = (C = o == null ? void 0 : o.assignmentType) == null ? void 0 : C.schedulingTypeSelect) == null ? void 0 : P.label, children: a("scheduling_type") }),
                  /* @__PURE__ */ m(
                    Wt,
                    {
                      name: "schedulingType",
                      render: ({ field: { value: x, onChange: w } }) => {
                        var E, T, z, j;
                        return /* @__PURE__ */ m(
                          Tr,
                          {
                            options: s,
                            value: s.find((q) => q.value === x),
                            className: ae(
                              "w-full",
                              (T = (E = o == null ? void 0 : o.assignmentType) == null ? void 0 : E.schedulingTypeSelect) == null ? void 0 : T.select
                            ),
                            innerClassNames: (j = (z = o == null ? void 0 : o.assignmentType) == null ? void 0 : z.schedulingTypeSelect) == null ? void 0 : j.innerClassNames,
                            onChange: (q) => v(q == null ? void 0 : q.value, w)
                          }
                        );
                      }
                    }
                  )
                ]
              }
            )
          ]
        }
      ),
      k === "ROUND_ROBIN" && /* @__PURE__ */ Y("div", { className: "border-subtle mt-4 flex flex-col rounded-md", children: [
        /* @__PURE__ */ Y("div", { className: "border-subtle rounded-t-md border p-6 pb-5", children: [
          /* @__PURE__ */ m(Xn, { className: "mb-1 text-sm font-semibold", children: a("rr_distribution_method") }),
          /* @__PURE__ */ m("p", { className: "text-subtle max-w-full break-words text-sm leading-tight", children: a("rr_distribution_method_description") })
        ] }),
        /* @__PURE__ */ Y("div", { className: "border-subtle rounded-b-md border border-t-0 p-6", children: [
          /* @__PURE__ */ m(
            Wt,
            {
              name: "maxLeadThreshold",
              render: ({ field: { value: x, onChange: w } }) => {
                var E, T, z, j;
                return /* @__PURE__ */ Y(
                  PF,
                  {
                    onValueChange: (q) => $(q, w),
                    className: "mt-1 flex flex-col gap-4",
                    children: [
                      /* @__PURE__ */ Y(
                        Up,
                        {
                          value: "maximizeAvailability",
                          checked: x === null,
                          className: "w-full text-sm",
                          classNames: { container: "w-full" },
                          children: [
                            /* @__PURE__ */ m("strong", { className: "mb-1 block", children: a("rr_distribution_method_availability_title") }),
                            /* @__PURE__ */ m("p", { children: a("rr_distribution_method_availability_description") })
                          ]
                        }
                      ),
                      (E = n.team) != null && E.rrTimestampBasis && ((T = n.team) == null ? void 0 : T.rrTimestampBasis) !== nG.CREATED_AT || (S == null ? void 0 : S.length) > 1 ? /* @__PURE__ */ m(
                        Ao,
                        {
                          content: (z = n.team) != null && z.rrTimestampBasis && ((j = n.team) == null ? void 0 : j.rrTimestampBasis) !== nG.CREATED_AT ? a("rr_load_balancing_disabled") : a("rr_load_balancing_disabled_with_groups"),
                          children: /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ Y(
                            Up,
                            {
                              value: "loadBalancing",
                              checked: x !== null,
                              className: "text-sm",
                              disabled: !0,
                              classNames: { container: "w-full" },
                              children: [
                                /* @__PURE__ */ m("strong", { className: "mb-1", children: a("rr_distribution_method_balanced_title") }),
                                /* @__PURE__ */ m("p", { children: a("rr_distribution_method_balanced_description") })
                              ]
                            }
                          ) })
                        }
                      ) : /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ Y(
                        Up,
                        {
                          value: "loadBalancing",
                          checked: x !== null,
                          className: "text-sm",
                          classNames: { container: "w-full" },
                          children: [
                            /* @__PURE__ */ m("strong", { className: "mb-1", children: a("rr_distribution_method_balanced_title") }),
                            /* @__PURE__ */ m("p", { children: a("rr_distribution_method_balanced_description") })
                          ]
                        }
                      ) })
                    ]
                  }
                );
              }
            }
          ),
          /* @__PURE__ */ m("div", { className: "mt-4", children: /* @__PURE__ */ m(
            Wt,
            {
              name: "includeNoShowInRRCalculation",
              render: ({ field: { value: x, onChange: w } }) => /* @__PURE__ */ m(
                eo,
                {
                  title: a("include_no_show_in_rr_calculation"),
                  labelClassName: "mt-1.5",
                  checked: x,
                  onCheckedChange: (E) => w(E)
                }
              )
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ m(
        Zpd,
        {
          orgId: r,
          isSegmentApplicable: i,
          teamId: e.id,
          assignAllTeamMembers: g,
          setAssignAllTeamMembers: h,
          teamMembers: l,
          customClassNames: o == null ? void 0 : o.hosts
        }
      )
    ] }),
    e && u && /* @__PURE__ */ m(
      Ypd,
      {
        assignAllTeamMembers: g,
        setAssignAllTeamMembers: h,
        childrenEventTypeOptions: d,
        customClassNames: o == null ? void 0 : o.childrenEventTypes
      }
    )
  ] });
}, Jpd = (e) => /* @__PURE__ */ m(Qpd, { ...e, isSegmentApplicable: !1 }), Xpd = Jpd, emd = it(function(t, n) {
  const {
    tabs: o = ["setup", "availability", "team", "limits", "advanced", "recurring", "payments"],
    onSuccess: r,
    onError: i,
    onDeleteSuccess: a,
    onDeleteError: s,
    id: c,
    allowDelete: l = !0,
    customClassNames: d,
    disableToasts: u = !1,
    isDryRun: _ = !1,
    onFormStateChange: p,
    ...f
  } = t, { t: g } = Fe(), { toast: h } = C_(), { organizationId: b } = po(), v = Ue(!1), $ = Ue(!1), { eventType: k, locationOptions: S, team: O, teamMembers: I, destinationCalendar: D } = f, [M, N] = ze([]), { data: C, isLoading: P } = sg(), x = () => {
    u || H(g("event_type_deleted_successfully")), v.current = !0, N([]), a == null || a();
  }, w = (J) => {
    u || H(J.message), s == null || s(J.message);
  }, E = hJl({
    onSuccess: async () => {
      x();
    },
    onError: (J) => {
      w(J);
    }
  }), T = vJl({
    onSuccess: async () => {
      x();
    },
    onError: (J) => {
      w(J);
    }
  }), z = yJl({
    onSuccess: async () => {
      var oe, ce;
      const J = j.getValues();
      J.children = J.children.map((de) => ({
        ...de,
        created: !0
      })), J.assignAllTeamMembers = J.assignAllTeamMembers || !1, j.reset(J), u || h({ description: g("event_type_updated_successfully", { eventTypeTitle: k.title }) }), r == null || r(J), (ce = (oe = F.current) == null ? void 0 : oe.onSuccess) == null || ce.call(oe);
    },
    async onSettled() {
    },
    onError: (J) => {
      var ue, le;
      const oe = j.getValues(), ce = J == null ? void 0 : J.message, de = g(ce || J.message);
      u || h({ description: de }), i == null || i(oe, J);
      const te = new Error(de);
      (le = (ue = F.current) == null ? void 0 : ue.onError) == null || le.call(ue, te);
    },
    teamId: O == null ? void 0 : O.id
  }), { form: j, handleSubmit: q } = DJl({
    eventType: k,
    onSubmit: (J) => {
      var oe, ce;
      _ ? (h({ description: g("event_type_updated_successfully", { eventTypeTitle: k.title }) }), (ce = (oe = F.current) == null ? void 0 : oe.onSuccess) == null || ce.call(oe)) : z.mutate(J);
    },
    onFormStateChange: p
  }), V = Ue(null), F = Ue({}), L = at(
    (J) => {
      J && (F.current = J), V.current ? V.current.click() : j.handleSubmit((oe) => {
        var ce, de;
        try {
          q(oe), (ce = J == null ? void 0 : J.onSuccess) == null || ce.call(J);
        } catch (te) {
          (de = J == null ? void 0 : J.onError) == null || de.call(J, te);
        }
      })();
    },
    [q, j]
  ), U = at(async () => ({
    isValid: await j.trigger(),
    errors: j.formState.errors
  }), [j]);
  Eie(
    n,
    () => ({
      validateForm: U,
      handleFormSubmit: L
    }),
    [U, L]
  );
  const W = j.watch("slug") ?? k.slug, H = (J, oe) => {
    u || h({ description: J });
  }, Q = {
    setup: o.includes("setup") ? /* @__PURE__ */ m(
      Xrd,
      {
        eventType: k,
        locationOptions: S,
        team: O,
        teamMembers: I,
        destinationCalendar: D,
        customClassNames: d == null ? void 0 : d.eventSetupTab
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    availability: o.includes("availability") ? /* @__PURE__ */ m(
      frd,
      {
        eventType: k,
        isTeamEvent: !!O,
        user: C == null ? void 0 : C.data,
        teamId: O == null ? void 0 : O.id,
        customClassNames: d == null ? void 0 : d.eventAvailabilityTab
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    team: o.includes("team") ? /* @__PURE__ */ m(
      Xpd,
      {
        team: O,
        eventType: k,
        teamMembers: I,
        customClassNames: d == null ? void 0 : d.eventAssignmentTab,
        orgId: b
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    advanced: o.includes("advanced") ? /* @__PURE__ */ m(
      erd,
      {
        eventType: k,
        team: O,
        user: C == null ? void 0 : C.data,
        isUserLoading: P,
        showToast: H,
        customClassNames: d == null ? void 0 : d.eventAdvancedTab
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    payments: o.includes("payments") ? /* @__PURE__ */ m(Drd, { eventType: k }) : /* @__PURE__ */ m(Ce, {}),
    limits: o.includes("limits") ? /* @__PURE__ */ m(
      xrd,
      {
        eventType: k,
        customClassNames: d == null ? void 0 : d.eventLimitsTab
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    instant: /* @__PURE__ */ m(Ce, {}),
    recurring: o.includes("recurring") ? /* @__PURE__ */ m(
      jrd,
      {
        eventType: k,
        customClassNames: d == null ? void 0 : d.eventRecurringTab
      }
    ) : /* @__PURE__ */ m(Ce, {}),
    apps: /* @__PURE__ */ m(Ce, {}),
    workflows: /* @__PURE__ */ m(Ce, {}),
    webhooks: /* @__PURE__ */ m(Ce, {}),
    ai: /* @__PURE__ */ m(Ce, {})
  };
  LJl({
    watchTrigger: null,
    isTeamEventTypeDeleted: v.current,
    isleavingWithoutAssigningHosts: $.current,
    isTeamEventType: !!O,
    assignedUsers: k.children,
    hosts: k.hosts,
    assignAllTeamMembers: k.assignAllTeamMembers,
    isManagedEventType: k.schedulingType === aa.MANAGED,
    onError: () => {
    },
    onStart: () => {
    },
    onEnd: () => {
    }
  });
  const X = () => {
    l && !_ && (v.current = !0, O != null && O.id ? T.mutate({ eventTypeId: c, teamId: O.id }) : E.mutate(c)), _ && x();
  }, re = (J) => {
    N(J);
  }, { tabsNavigation: Z, currentTab: ee } = qJl({
    formMethods: j,
    eventType: k,
    team: O,
    tabs: o
  });
  return /* @__PURE__ */ m(Ii, { customClassName: d == null ? void 0 : d.atomsWrapper, children: /* @__PURE__ */ m(
    fJl,
    {
      ...f,
      tabMap: Q,
      onDelete: X,
      onConflict: re,
      handleSubmit: q,
      formMethods: j,
      isUpdating: z.isPending,
      isPlatform: !0,
      tabName: ee,
      tabsNavigation: Z,
      allowDelete: l,
      saveButtonRef: V,
      children: /* @__PURE__ */ m(Ce, { children: M.length ? /* @__PURE__ */ m(
        gJl,
        {
          slugExistsChildrenDialogOpen: M,
          isPending: j.formState.isSubmitting,
          onOpenChange: () => {
            N([]);
          },
          slug: W,
          onConfirm: (J) => {
            J.preventDefault(), q(j.getValues()), N([]);
          }
        }
      ) : null })
    }
  ) });
}), Efd = it(function(t, n) {
  const {
    id: o,
    tabs: r,
    onSuccess: i,
    onError: a,
    onDeleteSuccess: s,
    onDeleteError: c,
    allowDelete: l = !0,
    customClassNames: d,
    isDryRun: u,
    disableToasts: _,
    onFormStateChange: p
  } = t, { data: f } = bJl(o), g = ns();
  return Le(() => () => {
    f && (g.invalidateQueries({
      queryKey: [TL, o]
    }), g.resetQueries({
      queryKey: [TL, o]
    }));
  }, [g, o, f]), f ? /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(
    emd,
    {
      ...f,
      id: o,
      tabs: r,
      onSuccess: i,
      onError: a,
      onDeleteSuccess: s,
      onDeleteError: c,
      allowDelete: l,
      customClassNames: d,
      isDryRun: u,
      onFormStateChange: p,
      ref: n,
      disableToasts: _
    }
  ) }) : null;
});
function tmd(e) {
  return /* @__PURE__ */ m(Gi, { name: "Account check", open: e.open, onOpenChange: e.onOpenChange, children: /* @__PURE__ */ m(
    Ei,
    {
      type: "creation",
      title: "Connecting with MS Teams requires a work/school Microsoft account.",
      description: "If you continue with a personal account you will receive an error",
      children: /* @__PURE__ */ m(Fc, { showDivider: !0, className: "mt-6", children: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m(
          ca,
          {
            type: "button",
            color: "secondary",
            tabIndex: -1,
            onClick: () => {
              var t;
              (t = e.onOpenChange) == null || t.call(e, !1);
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ m(ut, { type: "button", onClick: e.handleSubmit, children: "Continue" })
      ] }) })
    }
  ) });
}
const nmd = (e) => /* @__PURE__ */ m(
  g0e,
  {
    wrapperClassName: "border-t border-subtle p-6",
    componentMap: vul,
    ...e
  }
);
function omd({
  locationType: e,
  setLocationType: t,
  onSuccess: n,
  handleUpdateUserDefaultConferencingApp: o
}) {
  const { t: r } = Fe(), i = Xs(e.type), a = pd({
    resolver: ek(
      G.object({ link: G.string().regex(new RegExp((i == null ? void 0 : i.urlRegExp) ?? "")) })
    )
  });
  return /* @__PURE__ */ m(Gi, { open: !!e, onOpenChange: () => t(void 0), children: /* @__PURE__ */ m(
    Ei,
    {
      title: r("default_app_link_title"),
      description: r("default_app_link_description"),
      type: "creation",
      Icon: "circle-alert",
      children: /* @__PURE__ */ m(
        fd,
        {
          form: a,
          handleSubmit: (s) => {
            o({
              appSlug: e.slug,
              appLink: s.link,
              onSuccessCallback: () => {
                n();
              },
              onErrorCallback: () => {
                nr("Invalid App Link Format", "error");
              }
            }), t(void 0);
          },
          children: /* @__PURE__ */ Y(Ce, { children: [
            /* @__PURE__ */ m(
              Io,
              {
                type: "text",
                required: !0,
                ...a.register("link"),
                placeholder: e.organizerInputPlaceholder ?? "",
                label: e.label ?? ""
              }
            ),
            /* @__PURE__ */ Y(Fc, { showDivider: !0, className: "mt-8", children: [
              /* @__PURE__ */ m(ca, {}),
              /* @__PURE__ */ m(ut, { color: "primary", type: "submit", children: r("save") })
            ] })
          ] })
        }
      )
    }
  ) });
}
function rmd({
  credentialId: e
}) {
  return typeof e == "number" && e < 0;
}
const imd = rmd, amd = ({
  data: e,
  handleDisconnect: t,
  variant: n,
  listClassName: o,
  defaultConferencingApp: r,
  handleUpdateUserDefaultConferencingApp: i,
  handleBulkUpdateDefaultLocation: a,
  isBulkUpdateDefaultLocationPending: s,
  eventTypes: c,
  isEventTypesFetching: l,
  handleConnectDisconnectIntegrationMenuToggle: d,
  handleBulkEditDialogToggle: u
}) => {
  const [_, p] = ze(!1), [f, g] = ze(
    void 0
  ), h = at(() => {
    p(!0), nr("Default app updated successfully", "success");
  }, []), b = ({ item: S }) => {
    var D, M, N;
    const O = S == null ? void 0 : S.slug, I = O === (r == null ? void 0 : r.appSlug) || O === "daily-video" && !(r != null && r.appSlug);
    return /* @__PURE__ */ m(
      oye,
      {
        description: S.description,
        title: S.name,
        logo: S.logo,
        isDefault: I,
        shouldHighlight: !0,
        slug: S.slug,
        invalidCredential: S != null && S.invalidCredentialIds ? S.invalidCredentialIds.length > 0 : !1,
        credentialOwner: S == null ? void 0 : S.credentialOwner,
        actions: (D = S.credentialOwner) != null && D.readOnly ? null : /* @__PURE__ */ m("div", { className: "flex justify-end", children: /* @__PURE__ */ Y(El, { modal: !1, children: [
          /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { StartIcon: "ellipsis", variant: "icon", color: "secondary" }) }),
          /* @__PURE__ */ Y(Uc, { children: [
            !I && n === "conferencing" && /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
              ei,
              {
                type: "button",
                color: "secondary",
                StartIcon: "video",
                onClick: () => {
                  var P;
                  const C = aul(((P = S == null ? void 0 : S.locationOption) == null ? void 0 : P.value) ?? "");
                  (C == null ? void 0 : C.linkType) === "static" ? g({ ...C, slug: O }) : i({
                    appSlug: O,
                    onSuccessCallback: () => p(!0),
                    onErrorCallback: () => {
                    }
                  });
                },
                children: k("set_as_default")
              }
            ) }),
            /* @__PURE__ */ m(
              smd,
              {
                credentialId: ((M = S.credentialOwner) == null ? void 0 : M.credentialId) || S.userCredentialIds[0],
                type: S.type,
                app: S.slug,
                isGlobal: S.isGlobal,
                installed: !0,
                invalidCredentialIds: S.invalidCredentialIds,
                handleDisconnect: t,
                teamId: S.credentialOwner ? (N = S.credentialOwner) == null ? void 0 : N.teamId : void 0,
                handleConnectDisconnectIntegrationMenuToggle: d
              }
            )
          ] })
        ] }) }),
        children: /* @__PURE__ */ m(nmd, { slug: S.slug })
      },
      S.name
    );
  }, $ = e.items.filter((S) => S.teams.length).map((S) => {
    const O = [];
    S.userCredentialIds.length && O.push(/* @__PURE__ */ m(b, { item: S }));
    for (const I of S.teams)
      I && O.push(
        /* @__PURE__ */ m(
          b,
          {
            item: {
              ...S,
              credentialOwner: {
                name: I.name,
                avatar: I.logoUrl,
                teamId: I.teamId,
                credentialId: I.credentialId,
                readOnly: !I.isAdmin
              }
            }
          }
        )
      );
    return O;
  }), { t: k } = Fe();
  return /* @__PURE__ */ Y(Ce, { children: [
    /* @__PURE__ */ Y(WF, { className: o, children: [
      $.map((S) => S.map((O) => O)),
      e.items.filter((S) => S.invalidCredentialIds).map((S, O) => {
        if (!S.teams.length)
          return /* @__PURE__ */ m(b, { item: S }, O);
      })
    ] }),
    f && /* @__PURE__ */ m(
      omd,
      {
        locationType: f,
        setLocationType: () => g(void 0),
        onSuccess: h,
        handleUpdateUserDefaultConferencingApp: i
      }
    ),
    _ && /* @__PURE__ */ m(
      Jpe,
      {
        bulkUpdateFunction: a,
        open: _,
        setOpen: p,
        isPending: s,
        description: k("default_conferencing_bulk_description"),
        eventTypes: c,
        isEventTypesFetching: l,
        handleBulkEditDialogToggle: u
      }
    )
  ] });
};
function smd(e) {
  const { type: t, credentialId: n, isGlobal: o, installed: r, handleDisconnect: i, teamId: a, app: s } = e, { t: c } = Fe();
  return n || t === "stripe_payment" || o ? /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(
    ei,
    {
      color: "destructive",
      onClick: () => i(n, s, a),
      disabled: o || imd({ credentialId: n }),
      StartIcon: "trash",
      children: c("remove_app")
    }
  ) }) : r ? /* @__PURE__ */ m(
    rve,
    {
      type: t,
      render: (l) => /* @__PURE__ */ m(ut, { color: "secondary", ...l, "data-testid": "integration-connection-button", children: c("install") }),
      onChanged: e.handleConnectDisconnectIntegrationMenuToggle
    }
  ) : /* @__PURE__ */ m("div", { className: "flex items-center truncate", children: /* @__PURE__ */ m(sa, { severity: "warning", title: c("not_installed") }) });
}
function cmd({
  credentialId: e,
  app: t,
  isOpen: n,
  handleModelClose: o,
  teamId: r,
  handleRemoveApp: i
}) {
  const { t: a } = Fe(), s = Zo();
  return /* @__PURE__ */ m(Gi, { open: n, onOpenChange: o, children: /* @__PURE__ */ m(
    Vf,
    {
      variety: "danger",
      title: a("remove_app"),
      confirmBtnText: a("yes_remove_app"),
      onConfirm: () => {
        s && t && e ? i({ credentialId: e, app: t, teamId: r, callback: () => o() }) : e && i({ credentialId: e, teamId: r, callback: () => o() });
      },
      children: /* @__PURE__ */ m("p", { className: "mt-5", children: a("are_you_sure_you_want_to_remove_this_app") })
    }
  ) });
}
function lmd({
  children: e,
  title: t,
  description: n,
  CTA: o,
  ctaClassName: r,
  borderInShellHeader: i,
  backButton: a
}) {
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ m(
      "header",
      {
        className: ae(
          "border-subtle mx-auto flex justify-between",
          i && "rounded-t-lg border px-4 py-6 sm:px-6",
          i === void 0 && "mb-8 border-b pb-8"
        ),
        children: /* @__PURE__ */ Y("div", { className: "flex w-full items-center justify-between gap-2", children: [
          /* @__PURE__ */ Y("div", { className: "flex items-center", children: [
            a && /* @__PURE__ */ m("a", { href: "javascript:history.back()", children: /* @__PURE__ */ m(ot, { name: "arrow-left", className: "mr-7" }) }),
            /* @__PURE__ */ Y("div", { children: [
              t ? /* @__PURE__ */ m("h1", { className: "font-cal text-emphasis mb-1 text-xl font-semibold leading-5 tracking-wide", children: t }) : /* @__PURE__ */ m("div", { className: "bg-emphasis mb-1 h-5 w-24 animate-pulse rounded-lg" }),
              n ? /* @__PURE__ */ m("p", { className: "text-default text-sm ltr:mr-4 rtl:ml-4", children: n }) : /* @__PURE__ */ m("div", { className: "bg-emphasis h-5 w-32 animate-pulse rounded-lg" })
            ] })
          ] }),
          /* @__PURE__ */ m("div", { className: ae("flex-shrink-0", r), children: o })
        ] })
      }
    ),
    /* @__PURE__ */ m(IT, { fallback: /* @__PURE__ */ m(ot, { name: "loader", className: "mx-auto my-5 animate-spin" }), children: e })
  ] });
}
const dmd = ({
  onSuccess: e = () => {
  },
  onError: t = () => {
  },
  onSettled: n = () => {
  },
  teamId: o
}) => {
  const { organizationId: r } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i || i.length < 1)
        throw new Error("Event type ids are required");
      let a = `/atoms/${Pi.eventTypes}/bulk-update-to-default-location`;
      return o && (a = `/atoms/organizations/${r}/teams/${o}/${Pi.eventTypes}/bulk-update-to-default-location`), He == null ? void 0 : He.patch(a, { eventTypeIds: i }).then((s) => {
        if (s.data.status === qt)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, umd = "use-get-event-types", _md = (e, t = !1) => {
  const { isInit: n, accessToken: o, organizationId: r } = po();
  let i = "/atoms/event-types";
  return e && (i = `/atoms/organizations/${r}/teams/${e}/event-types`), go({
    queryKey: [umd, e, r],
    queryFn: () => He == null ? void 0 : He.get(i).then((a) => {
      if (a.data.status === qt)
        return a.data.data;
      throw new Error(a.data.error.message);
    }),
    enabled: n && !!o && !t
  });
}, S$ = "get-installed-conferencing-apps", pmd = (e) => {
  const { isInit: t, accessToken: n, organizationId: o } = po();
  let r = "/atoms/conferencing";
  return e && (r = `/atoms/organizations/${o}/teams/${e}/conferencing`), go({
    queryKey: [S$, e, o],
    queryFn: () => He == null ? void 0 : He.get(r).then((i) => {
      if (i.data.status === qt)
        return i.data.data;
      throw new Error(i.data.error.message);
    }).catch(() => {
      throw new Error("Failed to get installed conferencing apps");
    }),
    enabled: t && !!n
  });
}, mmd = ({ returnTo: e, onErrorReturnTo: t, teamId: n }) => {
  const { organizationId: o } = po();
  let r = `conferencing/${Oh}/oauth/auth-url`;
  n && (r = `organizations/${o}/teams/${n}/conferencing/${Oh}/oauth/auth-url`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return go({
    queryKey: ["get-zoom-auth-url", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => He == null ? void 0 : He.get(a).then(({ data: s }) => {
      if (s.status === qt)
        return s.data.url;
      if (s.status === Kp)
        throw new Error(s.error.message);
      return "";
    })
  });
}, fmd = ({
  returnTo: e,
  onErrorReturnTo: t,
  teamId: n
}) => {
  const { organizationId: o } = po();
  let r = `conferencing/${Ph}/oauth/auth-url`;
  n && (r = `organizations/${o}/teams/${n}/conferencing/${Ph}/oauth/auth-url`);
  const i = new URLSearchParams();
  e && i.append("returnTo", e), t && i.append("onErrorReturnTo", t);
  const a = i.toString() ? `${r}?${i.toString()}` : r;
  return go({
    queryKey: ["get-office365-auth-url", n, o],
    staleTime: 1 / 0,
    enabled: !1,
    queryFn: () => He == null ? void 0 : He.get(a).then(({ data: s }) => {
      if (s.status === qt)
        return s.data.url;
      if (s.status === Kp)
        throw new Error(s.error.message);
      return "";
    })
  });
}, gmd = ({ onSuccess: e, onError: t, teamId: n, returnTo: o, onErrorReturnTo: r } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const { organizationId: i } = po();
  return Yo({
    mutationFn: (a) => {
      let s = `/conferencing/${a}/connect`;
      n && (s = `/organizations/${i}/teams/${n}/conferencing/${a}/connect`);
      const c = new URLSearchParams();
      o && c.append("returnTo", o), r && c.append("onErrorReturnTo", r);
      const l = c.toString() ? `${s}?${c.toString()}` : s;
      return He == null ? void 0 : He.post(l).then((d) => {
        if (d.data.status === qt)
          return { status: d.data };
        throw new Error(d.data.error.message);
      });
    },
    onSuccess: e,
    onError: t
  });
}, hmd = (e) => {
  const { refetch: t } = mmd(e), { refetch: n } = fmd(e), o = gmd(e);
  return { connect: async (i) => {
    switch (i) {
      case Oh:
        const a = await t();
        a.data && (window.location.href = a.data);
        break;
      case Ph:
        const s = await n();
        s.data && (window.location.href = s.data);
        break;
      case vS:
        o.mutate(i);
    }
  } };
}, vmd = ({ onSuccess: e, onError: t, onSettled: n, teamId: o }) => {
  const { organizationId: r } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i)
        throw new Error("app is required");
      let a = `/conferencing/${i}/disconnect`;
      return o && (a = `/organizations/${r}/teams/${o}/conferencing/${i}/disconnect`), He == null ? void 0 : He.delete(a).then((s) => {
        if (s.data.status !== qt)
          throw new Error(s.data.error.message);
      });
    }
  });
}, x$ = "use-get-default-conferencing-app", bmd = (e) => {
  const { isInit: t, accessToken: n, organizationId: o } = po();
  let r = "/conferencing/default";
  return e && (r = `/organizations/${o}/teams/${e}/conferencing/default`), go({
    queryKey: [x$, e, o],
    queryFn: () => He == null ? void 0 : He.get(r).then((i) => {
      if (i.data.status === qt)
        return i.data.data;
      throw new Error(i.data.error.message);
    }),
    enabled: t && !!n
  });
}, ymd = ({
  onSuccess: e,
  onError: t,
  onSettled: n,
  teamId: o
}) => {
  const { organizationId: r } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: (i) => {
      if (!i)
        throw new Error("app is required");
      let a = `/conferencing/${i}/default`;
      return o && (a = `/organizations/${r}/teams/${o}/conferencing/${i}/default`), He == null ? void 0 : He.post(a).then((s) => {
        if (s.data.status !== qt)
          throw new Error(s.data.error.message);
      });
    }
  });
}, $md = () => /* @__PURE__ */ m(Tj, { children: /* @__PURE__ */ Y("div", { className: "divide-subtle border-subtle space-y-6 rounded-b-lg border border-t-0 px-6 py-4", children: [
  /* @__PURE__ */ m(Jn, { className: "h-8 w-full" }),
  /* @__PURE__ */ m(Jn, { className: "h-8 w-full" })
] }) }), Tfd = ({
  disableToasts: e = !1,
  returnTo: t,
  onErrorReturnTo: n,
  teamId: o,
  apps: r,
  disableBulkUpdateEventTypes: i = !1
}) => {
  var w;
  const { t: a } = Fe(), s = ns(), { toast: c } = C_(), l = (E, T) => {
    e || c({ description: E });
  }, [d, u] = R0(
    (E, T) => ({ ...E, ...T }),
    {
      isOpen: !1,
      credentialId: null,
      app: null
    }
  ), [_, p] = ze(!1), f = () => {
    u({ isOpen: !1, credentialId: null, app: null });
  }, g = (E, T) => {
    u({ isOpen: !0, credentialId: E, app: T });
  }, h = pmd(o), { data: b } = bmd(o), { data: v, isFetching: $ } = _md(
    o,
    i
  ), k = vmd({
    onSuccess: () => {
      l(a("app_removed_successfully")), f(), s.invalidateQueries({
        queryKey: [S$]
      }), s.resetQueries({
        queryKey: [x$]
      });
    },
    onError: () => {
      l(a("error_removing_app")), f();
    },
    teamId: o
  }), S = ymd({
    teamId: o
  }), O = dmd({
    teamId: o
  }), I = ({ app: E }) => {
    E && k.mutate(E);
  }, D = ({
    appSlug: E,
    onSuccessCallback: T,
    onErrorCallback: z
  }) => {
    S.mutate(E, {
      onSuccess: () => {
        l("Default app updated successfully"), s.invalidateQueries({ queryKey: [x$] }), !i && T();
      },
      onError: (j) => {
        l(`Error: ${j.message}`), z();
      }
    });
  }, M = ({ eventTypeIds: E, callback: T }) => {
    if (i) {
      T();
      return;
    }
    O.mutate(E, {
      onSuccess: () => {
        s.invalidateQueries({ queryKey: [x$] }), T();
      }
    });
  }, N = () => {
    s.invalidateQueries({ queryKey: [S$] });
  }, C = () => {
    s.invalidateQueries({ queryKey: [x$] });
  }, { connect: P } = hmd({
    onSuccess: () => {
      l("app installed successfully"), s.invalidateQueries({ queryKey: [S$] });
    },
    onError: () => {
      s.invalidateQueries({ queryKey: [S$] }), l("Error: unable to install app");
    },
    returnTo: t,
    onErrorReturnTo: n,
    teamId: o
  }), x = ({ installedApps: E }) => /* @__PURE__ */ Y(El, { children: [
    /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(ut, { color: "secondary", StartIcon: "plus", children: a("add") }) }),
    /* @__PURE__ */ Y(Uc, { children: [
      E && !E.find((T) => T.slug === vS) && (!r || r.includes(vS)) && /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(ei, { color: "secondary", onClick: () => P(vS), children: a("google_meet") }) }),
      E && !E.find((T) => T.slug === Oh) && (!r || r.includes(Oh)) && /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(ei, { color: "secondary", onClick: () => P(Oh), children: a("zoom") }) }),
      E && !E.find((T) => T.slug === Ph) && (!r || r.includes(Ph)) && /* @__PURE__ */ m(Er, { children: /* @__PURE__ */ m(ei, { color: "secondary", onClick: () => p(!0), children: a("office_365_video") }) })
    ] })
  ] });
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m(
    lmd,
    {
      title: a("conferencing"),
      description: a("conferencing_description"),
      CTA: /* @__PURE__ */ m(x, { installedApps: (w = h.data) == null ? void 0 : w.items }),
      borderInShellHeader: !0,
      children: /* @__PURE__ */ Y(Ce, { children: [
        /* @__PURE__ */ m("div", { className: "bg-default w-full sm:mx-0 xl:mt-0", children: /* @__PURE__ */ m(
          zbe,
          {
            query: h,
            customLoader: /* @__PURE__ */ m($md, {}),
            success: ({ data: E }) => E.items.length ? /* @__PURE__ */ m(
              amd,
              {
                listClassName: "rounded-lg rounded-t-none border-t-0 max-w-full",
                handleDisconnect: g,
                data: E,
                variant: "conferencing",
                defaultConferencingApp: b,
                handleUpdateUserDefaultConferencingApp: D,
                handleBulkUpdateDefaultLocation: M,
                isBulkUpdateDefaultLocationPending: O == null ? void 0 : O.isPending,
                eventTypes: v == null ? void 0 : v.eventTypes,
                isEventTypesFetching: $,
                handleConnectDisconnectIntegrationMenuToggle: N,
                handleBulkEditDialogToggle: C
              }
            ) : /* @__PURE__ */ m(
              sb,
              {
                Icon: "calendar",
                headline: a("no_category_apps", {
                  category: a("conferencing").toLowerCase()
                }),
                description: a("no_category_apps_description_conferencing"),
                buttonRaw: /* @__PURE__ */ m(x, { installedApps: E == null ? void 0 : E.items })
              }
            )
          }
        ) }),
        /* @__PURE__ */ m(
          cmd,
          {
            handleModelClose: f,
            isOpen: d.isOpen,
            credentialId: d.credentialId,
            app: d.app,
            handleRemoveApp: I
          }
        ),
        /* @__PURE__ */ m(
          tmd,
          {
            open: _,
            onOpenChange: p,
            handleSubmit: () => P(Ph)
          }
        )
      ] })
    }
  ) });
}, wmd = ({ onSuccess: e, onError: t, onSettled: n }) => Yo({
  onSuccess: e,
  onError: t,
  onSettled: n,
  mutationFn: (o) => {
    const r = `/${Pi.eventTypes}`;
    return He == null ? void 0 : He.post(r, o, {
      headers: { [Gv]: xq }
    }).then((i) => {
      if (i.data.status === qt)
        return i.data.data;
      throw new Error(i.data.error.message);
    });
  }
}), kmd = ({ onSuccess: e, onError: t, onSettled: n }) => {
  const { organizationId: o } = po();
  return Yo({
    onSuccess: e,
    onError: t,
    onSettled: n,
    mutationFn: ({ teamId: r, ...i }) => {
      if (!r)
        throw new Error("Event type id is required");
      const a = `/organizations/${o}/teams/${r}/event-types`;
      return He == null ? void 0 : He.post(a, i, {
        headers: { [Gv]: xq }
      }).then((s) => {
        if (s.data.status === qt)
          return s.data.data;
        throw new Error(s.data.error.message);
      });
    }
  });
}, Xre = ({
  submitLabel: e,
  cancelLabel: t,
  isPending: n,
  customClassNames: o,
  onCancel: r
}) => /* @__PURE__ */ Y("div", { className: uo("flex flex-row gap-4", o == null ? void 0 : o.container), children: [
  /* @__PURE__ */ m(ut, { type: "submit", loading: n, className: o == null ? void 0 : o.submit, children: e }),
  r && /* @__PURE__ */ m(
    ut,
    {
      color: "secondary",
      type: "button",
      loading: n,
      className: o == null ? void 0 : o.cancel,
      onClick: () => r(),
      children: t
    }
  )
] }), Afd = ({
  teamId: e,
  onSuccess: t,
  onError: n,
  customClassNames: o,
  onCancel: r,
  isDryRun: i = !1
}) => {
  const { form: a, isManagedEventType: s } = eXl(), c = wmd({ onSuccess: t, onError: n }), l = kmd({ onSuccess: t, onError: n }), { data: d } = WKl(), u = d == null ? void 0 : d.find((f) => f.id === e), { t: _ } = Fe(), p = {
    canCreateEventType: (u == null ? void 0 : u.role) === "ADMIN" || (u == null ? void 0 : u.role) === "OWNER"
  };
  return e && u ? /* @__PURE__ */ m(Ii, { customClassName: o == null ? void 0 : o.atomsWrapper, children: /* @__PURE__ */ m(
    QJl,
    {
      teamSlug: u == null ? void 0 : u.slug,
      teamId: e,
      permissions: p,
      urlPrefix: "",
      isPending: l.isPending,
      form: a,
      isManagedEventType: s,
      handleSubmit: (f) => {
        !i && l.mutate({
          lengthInMinutes: f.length,
          title: f.title,
          slug: f.slug,
          description: f.description ?? "",
          schedulingType: f.schedulingType ?? "COLLECTIVE",
          hosts: [],
          teamId: e
        });
      },
      SubmitButton: (f) => Xre({
        isPending: f,
        onCancel: r,
        submitLabel: _("continue"),
        cancelLabel: _("cancel"),
        customClassNames: o == null ? void 0 : o.buttons
      })
    }
  ) }) : /* @__PURE__ */ m(Ii, { customClassName: o == null ? void 0 : o.atomsWrapper, children: /* @__PURE__ */ m(
    _od,
    {
      urlPrefix: "",
      isPending: c.isPending,
      form: a,
      isManagedEventType: s,
      handleSubmit: (f) => {
        !i && c.mutate({
          lengthInMinutes: f.length,
          title: f.title,
          slug: f.slug,
          description: f.description ?? ""
        });
      },
      SubmitButton: (f) => Xre({
        isPending: f,
        onCancel: r,
        submitLabel: _("continue"),
        cancelLabel: _("cancel"),
        customClassNames: o == null ? void 0 : o.buttons
      })
    }
  ) });
}, Smd = "use-event-app-integration", xmd = ({
  uid: e,
  onEventTypePaymentInfoSuccess: t,
  onEventTypePaymentInfoFailure: n
}) => {
  const o = `/atoms/payment/${e}`, { isInit: r, accessToken: i } = po();
  return go({
    queryKey: [Smd, e],
    queryFn: () => He == null ? void 0 : He.get(o).then((a) => {
      if (a.data.status === qt)
        return t == null || t(), a.data.data;
      throw n == null || n(), new Error(a.data.error.message);
    }),
    enabled: !!e && r && !!i
  });
}, Emd = ve.lazy(() => import("./StripePaymentForm-ifJrn5Q2.js")), Cfd = ({
  paymentUid: e,
  onPaymentSuccess: t,
  onPaymentCancellation: n,
  onEventTypePaymentInfoSuccess: o,
  onEventTypePaymentInfoFailure: r
}) => {
  const { t: i } = Fe(), { data: a, isLoading: s } = xmd({
    uid: e,
    onEventTypePaymentInfoSuccess: o,
    onEventTypePaymentInfoFailure: r
  }), c = a == null ? void 0 : a.booking.title, l = lve(), d = wo.getItem("timeOption.preferredTimeZone") || Kf, u = De.utc(a == null ? void 0 : a.booking.startTime).tz(d);
  if (s)
    return /* @__PURE__ */ m("h1", { className: "p-4 pt-4 text-xl", children: "Loading..." });
  if (!a)
    return /* @__PURE__ */ Y("h1", { className: "p-4 text-xl", children: [
      "No payment found with UID - ",
      e
    ] });
  const _ = nm(a == null ? void 0 : a.eventType);
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(IT, { fallback: /* @__PURE__ */ m(Ce, {}), children: /* @__PURE__ */ m("main", { className: "mx-auto", children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0", children: /* @__PURE__ */ Y("div", { className: "inset-0 my-4 transition-opacity sm:my-0", "aria-hidden": "true", children: [
    /* @__PURE__ */ m("span", { className: "hidden sm:inline-block sm:h-screen sm:align-middle", "aria-hidden": "true", children: "​" }),
    /* @__PURE__ */ Y(
      "div",
      {
        className: uo(
          "main bg-default border-subtle inline-block transform overflow-hidden rounded-lg border px-8 pb-4 pt-5 text-left align-bottom transition-all  sm:my-8 sm:w-full sm:max-w-lg sm:py-6 sm:align-middle"
        ),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "modal-headline",
        children: [
          /* @__PURE__ */ Y("div", { children: [
            /* @__PURE__ */ m("div", { className: "bg-success mx-auto flex h-12 w-12 items-center justify-center rounded-full", children: /* @__PURE__ */ m(I_l, { currency: _.currency, className: "h-8 w-8 text-green-600" }) }),
            /* @__PURE__ */ Y("div", { className: "mt-3 text-center sm:mt-5", children: [
              /* @__PURE__ */ m("h3", { className: "text-emphasis text-2xl font-semibold leading-6", id: "modal-headline", children: _.paymentOption === "HOLD" ? i("complete_your_booking") : i("payment") }),
              /* @__PURE__ */ Y("div", { className: "text-default mt-4 grid grid-cols-3 border-b border-t py-4 text-left dark:border-gray-900 dark:text-gray-300", children: [
                /* @__PURE__ */ m("div", { className: "font-medium", children: i("what") }),
                /* @__PURE__ */ m("div", { className: "col-span-2 mb-6", children: c }),
                /* @__PURE__ */ m("div", { className: "font-medium", children: i("when") }),
                /* @__PURE__ */ Y("div", { className: "col-span-2 mb-6", children: [
                  u.format("dddd, DD MMMM YYYY"),
                  /* @__PURE__ */ m("br", {}),
                  u.format(l ? "H:mm" : "h:mma"),
                  " - ",
                  a.eventType.length,
                  " mins",
                  " ",
                  /* @__PURE__ */ Y("span", { className: "text-subtle", children: [
                    "(",
                    d,
                    ")"
                  ] })
                ] }),
                a.booking.location && /* @__PURE__ */ Y(Ce, { children: [
                  /* @__PURE__ */ m("div", { className: "font-medium", children: i("where") }),
                  /* @__PURE__ */ m("div", { className: "col-span-2 mb-6", children: lul(a.booking.location, i) })
                ] }),
                /* @__PURE__ */ m("div", { className: "font-medium", children: a.payment.paymentOption === "HOLD" ? i("no_show_fee") : i("price") }),
                /* @__PURE__ */ m("div", { className: "col-span-2 mb-6 font-semibold", children: /* @__PURE__ */ m(
                  mve,
                  {
                    currency: _.currency,
                    price: _.price,
                    displayAlternateSymbol: !1
                  }
                ) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Y("div", { children: [
            a.payment.success && !a.payment.refunded && /* @__PURE__ */ m("div", { className: "text-default mt-4 text-center dark:text-gray-300", children: i("paid") }),
            a.payment.appId === "stripe" && !a.payment.success && /* @__PURE__ */ m(
              Emd,
              {
                clientSecret: a.clientSecret,
                payment: a.payment,
                eventType: a.eventType,
                user: a.user,
                location: a.booking.location,
                booking: a.booking,
                uid: e,
                onPaymentSuccess: t,
                onPaymentCancellation: n
              }
            ),
            a.payment.refunded && /* @__PURE__ */ m("div", { className: "text-default mt-4 text-center dark:text-gray-300", children: i("refunded") })
          ] }),
          !a.profile.hideBranding && /* @__PURE__ */ m("div", { className: "text-muted dark:text-inverted mt-4 border-t pt-4 text-center text-xs dark:border-gray-900", children: /* @__PURE__ */ m("a", { href: `${C$}/signup`, children: i("create_booking_link_with_calcom", { appName: Zp }) }) })
        ]
      }
    )
  ] }) }) }) }) }) }) });
}, Tmd = "use-organization-bookings", zfd = (e) => {
  const { organizationId: t } = po(), n = `/organizations/${t}/bookings`;
  return go({
    queryKey: [Tmd, ...Amd(e)],
    queryFn: async () => He.get(n, {
      params: e
    }).then((r) => {
      var i, a;
      if (r.data.status === qt)
        return r.data.data;
      throw new Error((a = (i = r.data) == null ? void 0 : i.error) == null ? void 0 : a.message);
    })
  });
};
function Amd(e) {
  return [...GF(e), e.userIds];
}
const Cmd = "use-organization-user-bookings", Ofd = (e, t) => {
  const { organizationId: n } = po(), o = `/organizations/${n}/users/${e}/bookings`;
  return go({
    queryKey: [Cmd, e, ...GF(t)],
    queryFn: async () => He.get(o, {
      params: t
    }).then((i) => {
      var a, s;
      if (i.data.status === qt)
        return i.data.data;
      throw new Error((s = (a = i.data) == null ? void 0 : a.error) == null ? void 0 : s.message);
    })
  });
}, zmd = ({
  extraDays: e,
  schedule: t,
  isLoading: n,
  event: o
}) => {
  var f, g;
  const r = St((h) => h.selectedDate), i = St((h) => h.selectedDuration), a = Ha("overlayCalendar") === "true" || (wo == null ? void 0 : wo.getItem("overlayCalendarSwitchDefault")), { timezone: s } = vd(), c = i || ((f = o == null ? void 0 : o.data) == null ? void 0 : f.length) || 30, l = fbe({ schedule: t, eventDuration: c }), d = r ? De(r).toDate() : De().toDate(), u = De(d).add(e - 1, "day").toDate(), { data: _ } = MKl({
    take: 150,
    skip: 0,
    status: ["upcoming", "past", "recurring"],
    eventTypeId: (g = o == null ? void 0 : o.data) == null ? void 0 : g.id,
    afterStart: d.toISOString(),
    beforeEnd: u.toISOString()
  });
  Le(() => {
  }, [a]);
  const p = Tt(() => _ ? _ == null ? void 0 : _.map((h) => ({
    id: h.id,
    title: h.title ?? "Busy",
    start: new Date(h.start),
    end: new Date(h.end),
    options: {
      status: h.status.toUpperCase(),
      "data-test-id": "troubleshooter-busy-event",
      className: "border-[1.5px]"
    }
  })) : [], [_]);
  return /* @__PURE__ */ m("div", { className: "h-full [--calendar-dates-sticky-offset:66px]", children: /* @__PURE__ */ m(
    vbe,
    {
      isPending: n,
      availableTimeslots: l,
      startHour: 0,
      endHour: 23,
      events: p,
      startDate: d,
      endDate: u,
      gridCellsPerHour: 60 / c,
      hoverEventDuration: c,
      hideHeader: !0,
      timezone: s
    }
  ) });
}, Omd = "use-team-event-type", Pmd = (e, t, n, o) => {
  const { organizationId: r } = po(), i = t;
  let a = `/organizations/${r}/teams/${e}/event-types?eventSlug=${i}`;
  return r || (a = `/teams/${e}/event-types?eventSlug=${i}`), o !== void 0 && (a += `&hostsLimit=${o}`), go({
    queryKey: [Omd, t, r, e],
    queryFn: async () => {
      if (e && t && n)
        return He == null ? void 0 : He.get(a).then((c) => {
          if (c.data.status === qt)
            return c.data.data;
          throw new Error(c.data.error.message);
        });
    },
    enabled: !!e && !!t && !!n
  });
}, Imd = (e) => {
  var I, D, M, N, C;
  const t = !!e.teamId, n = e.teamId ? e.teamId : void 0, o = Tt(() => e.username ? Tbe(e.username) : "", [e.username]), { isPending: r } = NKl(o, e.eventSlug, t), { isPending: i } = Pmd(n, e.eventSlug, t), a = St((P) => P.selectedDuration), s = kbe({
    username: o,
    eventSlug: e.eventSlug,
    isTeamEvent: t,
    teamId: n,
    selectedDuration: a
  }), c = ybe((D = (I = s.data) == null ? void 0 : I.profile) == null ? void 0 : D.bookerLayouts), [l, d] = St(
    (P) => [P.state, P.setState],
    Fr
  ), u = St((P) => P.selectedDate), _ = De(u).format("YYYY-MM-DD"), p = St((P) => P.month), [f] = St((P) => [P.dayCount, P.setDayCount], Fr), { prefetchNextMonth: g, monthCount: h } = $be({
    date: _,
    month: p,
    bookerLayout: c,
    bookerState: l
  }), [b, v] = IF({
    month: p,
    monthCount: h,
    dayCount: f,
    prefetchNextMonth: g,
    selectedDate: u
  }), { timezone: $ } = lu(), k = Tt(() => T_(o ?? "").length > 1, [o]), S = St((P) => P.bookingData);
  h9({
    ...e,
    eventId: (M = s == null ? void 0 : s.data) == null ? void 0 : M.id,
    layout: "week_view",
    username: o,
    bookingData: S,
    isPlatform: !0,
    allowUpdatingUrlParams: !1
  });
  const O = Sbe({
    usernameList: T_(o),
    eventTypeId: ((N = s == null ? void 0 : s.data) == null ? void 0 : N.id) ?? 0,
    startTime: b,
    endTime: v,
    timeZone: $,
    duration: a ?? void 0,
    teamMemberEmail: void 0,
    ...t ? {
      isTeamEvent: t,
      teamId: n
    } : {},
    enabled: !!(n || o) && !!p && !!$ && (t ? !i : !r) && !!((C = s == null ? void 0 : s.data) != null && C.id),
    orgSlug: void 0,
    eventTypeSlug: k ? "dynamic" : e.eventSlug || ""
  });
  return /* @__PURE__ */ Y(Ii, { children: [
    /* @__PURE__ */ m(gp, { area: "header", className: "bg-default dark:bg-muted sticky top-0 z-10", children: /* @__PURE__ */ m(
      mbe,
      {
        isCalendarView: !0,
        isMyLink: !0,
        eventSlug: e.eventSlug,
        enabledLayouts: c.bookerLayouts.enabledLayouts,
        extraDays: 7,
        isMobile: !1,
        nextSlots: 6
      }
    ) }),
    /* @__PURE__ */ m(
      gp,
      {
        area: "main",
        visible: !0,
        className: "border-subtle sticky top-0 ml-[-1px] h-full md:border-l",
        children: /* @__PURE__ */ m(zmd, { extraDays: 7, schedule: O.data, isLoading: O.isPending, event: s })
      },
      "large-calendar"
    )
  ] });
}, Pfd = (e) => /* @__PURE__ */ m(Xv, { children: /* @__PURE__ */ m(Imd, { ...e }) }), k1e = "use-atom-user-schedules", Rmd = () => {
  const e = "atoms/schedules/all", { isInit: t, accessToken: n } = po(), { isLoading: o, error: r, data: i, refetch: a } = go({
    queryKey: [k1e],
    queryFn: () => He.get(e).then((s) => {
      var c;
      if (s.data.status === qt)
        return s.data.data;
      throw new Error((c = s.data.error) == null ? void 0 : c.message);
    }),
    enabled: t && !!n
  });
  return { isLoading: o, error: r, data: i, refetch: a };
}, Nmd = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: async (o) => {
      const r = "atoms/schedules/create";
      return (await He.post(r, o)).data;
    },
    onSuccess: (o) => {
      o.status === qt ? (e == null || e(o), n.invalidateQueries({ queryKey: [F0] }), n.invalidateQueries({ queryKey: [k1e] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
}, Dmd = ({
  onSuccess: e,
  onError: t,
  onCancel: n,
  customClassNames: o,
  disableToasts: r = !1
}) => {
  var u, _, p;
  const { toast: i } = C_(), { t: a } = Fe(), s = pd(), { register: c } = s, { mutateAsync: l, isPending: d } = Nmd({
    onSuccess: (f) => {
      r || i({
        description: a("schedule_created_successfully", { scheduleName: f.data.schedule.name })
      }), s.reset(), e == null || e(f.data.schedule.id);
    },
    onError: (f) => {
      t == null || t(f), r || i({
        description: `Could not create schedule: ${f.error.message}`
      });
    }
  });
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(
    fd,
    {
      className: o == null ? void 0 : o.formWrapper,
      form: s,
      handleSubmit: async (f) => {
        await l(f);
      },
      children: [
        /* @__PURE__ */ m(
          hi,
          {
            className: o == null ? void 0 : o.inputField,
            label: a("name"),
            type: "text",
            id: "name",
            required: !0,
            placeholder: a("default_schedule_name"),
            ...c("name", {
              setValueAs: (f) => !f || f.trim() === "" ? null : f
            })
          }
        ),
        /* @__PURE__ */ Y(
          "div",
          {
            className: uo(
              "mt-5 justify-end space-x-2 rtl:space-x-reverse sm:mt-4 sm:flex",
              (u = o == null ? void 0 : o.actionsButtons) == null ? void 0 : u.container
            ),
            children: [
              n && /* @__PURE__ */ m(
                ut,
                {
                  type: "button",
                  color: "secondary",
                  onClick: n,
                  className: (_ = o == null ? void 0 : o.actionsButtons) == null ? void 0 : _.close,
                  children: a("close")
                }
              ),
              /* @__PURE__ */ Y(
                ut,
                {
                  type: "submit",
                  loading: d,
                  className: (p = o == null ? void 0 : o.actionsButtons) == null ? void 0 : p.continue,
                  children: [
                    " ",
                    a("continue")
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, Ifd = ({
  name: e,
  customClassNames: t,
  onSuccess: n,
  onError: o,
  disableToasts: r = !1
}) => {
  var c, l, d;
  const { t: i } = Fe(), [a, s] = ze(!1);
  return /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ Y(k9, { open: a, onOpenChange: s, children: [
    /* @__PURE__ */ m(Ile, { asChild: !0, children: /* @__PURE__ */ m(
      ut,
      {
        type: "button",
        "data-testid": e,
        className: t == null ? void 0 : t.createScheduleButton,
        StartIcon: "plus",
        onClick: () => s(!0),
        children: e ?? i("new")
      }
    ) }),
    /* @__PURE__ */ m(x9, { className: "bg-default text-default", children: /* @__PURE__ */ m(
      Dmd,
      {
        customClassNames: {
          formWrapper: t == null ? void 0 : t.formWrapper,
          inputField: t == null ? void 0 : t.inputField,
          actionsButtons: {
            container: (c = t == null ? void 0 : t.actionsButtons) == null ? void 0 : c.container,
            continue: (l = t == null ? void 0 : t.actionsButtons) == null ? void 0 : l.continue,
            close: (d = t == null ? void 0 : t.actionsButtons) == null ? void 0 : d.close
          }
        },
        onSuccess: (u) => {
          s(!1), n == null || n(u);
        },
        onError: o,
        onCancel: () => s(!1),
        disableToasts: r
      }
    ) })
  ] }) });
};
function Mmd({
  schedule: e,
  deleteFunction: t,
  displayOptions: n,
  updateDefault: o,
  isDeletable: r,
  duplicateFunction: i,
  redirectUrl: a
}) {
  const { t: s, i18n: c } = Fe();
  return /* @__PURE__ */ m("li", { children: /* @__PURE__ */ Y("div", { className: "hover:bg-muted flex items-center justify-between px-3 py-5 transition sm:px-4", children: [
    /* @__PURE__ */ m("div", { className: "group flex w-full items-center justify-between ", children: /* @__PURE__ */ Y(Po, { href: a, className: "flex-grow truncate text-sm", title: e.name, children: [
      /* @__PURE__ */ Y("div", { className: "space-x-2 rtl:space-x-reverse", children: [
        /* @__PURE__ */ m("span", { className: "text-emphasis truncate font-medium", children: e.name }),
        e.isDefault && /* @__PURE__ */ m(Nr, { variant: "gray", className: "text-xs", children: s("default") })
      ] }),
      /* @__PURE__ */ Y("p", { className: "text-subtle mt-1", children: [
        e.availability.filter((l) => !!l.days.length).map(
          (l) => mme(l, {
            locale: c.language,
            hour12: n == null ? void 0 : n.hour12
          })
        ).sort(sge(c.language, n == null ? void 0 : n.weekStart)).map((l, d) => /* @__PURE__ */ Y(Oi, { children: [
          l,
          /* @__PURE__ */ m("br", {})
        ] }, d)),
        (e.timeZone || (n == null ? void 0 : n.timeZone)) && /* @__PURE__ */ Y("span", { className: "my-1 flex items-center first-letter:text-xs", children: [
          /* @__PURE__ */ m(ot, { name: "globe", className: "h-3.5 w-3.5" }),
          " ",
          e.timeZone ?? (n == null ? void 0 : n.timeZone)
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ Y(El, { children: [
      /* @__PURE__ */ m(Bc, { asChild: !0, children: /* @__PURE__ */ m(
        ut,
        {
          "data-testid": "schedule-more",
          type: "button",
          variant: "icon",
          color: "secondary",
          StartIcon: "ellipsis"
        }
      ) }),
      /* @__PURE__ */ Y(Uc, { children: [
        !e.isDefault && /* @__PURE__ */ m(Er, { className: "min-w-40 focus:ring-muted", children: /* @__PURE__ */ m(
          ei,
          {
            type: "button",
            StartIcon: "star",
            onClick: () => {
              o({
                scheduleId: e.id,
                isDefault: !0
              });
            },
            children: s("set_as_default")
          }
        ) }),
        /* @__PURE__ */ m(Er, { className: "outline-none", children: /* @__PURE__ */ m(
          ei,
          {
            type: "button",
            "data-testid": `schedule-duplicate${e.id}`,
            StartIcon: "copy",
            onClick: () => {
              i({
                scheduleId: e.id
              });
            },
            children: s("duplicate")
          }
        ) }),
        /* @__PURE__ */ m(Er, { className: "min-w-40 focus:ring-muted", children: /* @__PURE__ */ m(
          ei,
          {
            type: "button",
            color: "destructive",
            StartIcon: "trash",
            "data-testid": "delete-schedule",
            className: "rounded-t-none",
            onClick: () => {
              r ? t({
                scheduleId: e.id
              }) : nr(s("requires_at_least_one_schedule"), "error");
            },
            children: s("delete")
          }
        ) })
      ] })
    ] })
  ] }) }, e.id);
}
const Lmd = (e) => ({
  ...e,
  availability: e.availability.map((t) => ({
    ...t,
    startTime: new Date(t.startTime),
    endTime: new Date(t.endTime),
    date: t.date ? new Date(t.date) : null
  }))
}), qmd = ({ onSuccess: e, onError: t } = {
  onSuccess: () => {
  },
  onError: () => {
  }
}) => {
  const n = ns();
  return Yo({
    mutationFn: async ({ scheduleId: o }) => {
      const r = `atoms/schedules/${o}/duplicate`;
      return (await He.post(r)).data;
    },
    onSuccess: (o) => {
      o.status === qt ? (e == null || e(o), n.invalidateQueries({ queryKey: [F0] })) : t == null || t(o);
    },
    onError: (o) => {
      t == null || t(o);
    }
  });
};
function jmd(e, t) {
  const n = Ue(t);
  Le(() => {
    n.current = t;
  }), Le(() => {
    e.filter((r) => r.isDefault).length === 0 && e.length > 0 && n.current(e[0].id);
  }, [e]);
}
const Rfd = ({ getScheduleUrl: e } = {}) => {
  const [t] = xl(), { toast: n } = C_(), { t: o } = Fe(), {
    data: r,
    isLoading: i,
    refetch: a
  } = Rmd(), { data: s, isLoading: c } = sg(), { mutate: l } = hce({
    onSuccess: () => {
      n({
        description: "Schedule updated successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not update schedule: ${p.error.message}`
      });
    }
  }), { mutate: d } = qmd({
    onSuccess: () => {
      n({
        description: "Schedule created successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not duplicate schedule: ${p.error.message}`
      });
    }
  }), { mutate: u } = vce({
    onSuccess: () => {
      n({
        description: "Schedule deleted successfully"
      }), a();
    },
    onError: (p) => {
      n({
        description: `Could not delete schedule: ${p.error.message}`
      });
    }
  });
  jmd((r == null ? void 0 : r.schedules) ?? [], (p) => {
    l({
      scheduleId: p,
      body: {
        isDefault: !0
      }
    });
  });
  const _ = r == null ? void 0 : r.schedules.map((p) => Lmd(p));
  return i || c ? /* @__PURE__ */ m(Ce, { children: o("loading") }) : !i && (_ == null ? void 0 : _.length) === 0 ? /* @__PURE__ */ m(
    sb,
    {
      Icon: "clock",
      headline: o("no_schedules_present"),
      description: o("create_new_schedule"),
      className: "w-full"
    }
  ) : /* @__PURE__ */ m(Ii, { children: /* @__PURE__ */ m("div", { className: "border-subtle bg-default overflow-hidden rounded-md border", children: /* @__PURE__ */ m("ul", { className: "divide-subtle divide-y", "data-testid": "schedules", ref: t, children: _ == null ? void 0 : _.map((p) => /* @__PURE__ */ m(
    Mmd,
    {
      displayOptions: {
        hour12: s != null && s.data.timeFormat ? s.data.timeFormat === 12 : void 0,
        timeZone: s == null ? void 0 : s.data.timeZone,
        weekStart: (s == null ? void 0 : s.data.weekStart) || "Sunday"
      },
      schedule: p,
      isDeletable: _.length !== 1,
      redirectUrl: e ? e(p.id) : "#",
      updateDefault: () => {
        l({
          scheduleId: p.id,
          body: {
            isDefault: !0
          }
        });
      },
      deleteFunction: async () => await u({ id: p.id }),
      duplicateFunction: () => d({ scheduleId: p.id })
    },
    p.id
  )) }) }) });
};
export {
  tpe as $,
  GKl as A,
  ut as B,
  Uue as C,
  U2c as D,
  V_e as E,
  fd as F,
  AQ as G,
  R1c as H,
  hi as I,
  sa as J,
  CQ as K,
  Xn as L,
  ufd as M,
  Y1c as N,
  x_l as O,
  K1c as P,
  Ao as Q,
  ot as R,
  Tr as S,
  xj as T,
  y4e as U,
  G as V,
  Si as W,
  Tml as X,
  O_ as Y,
  xQ as Z,
  EQ as _,
  Zpe as a,
  Ord as a$,
  yF as a0,
  bF as a1,
  bdl as a2,
  nr as a3,
  m$ as a4,
  aa as a5,
  zQ as a6,
  Jhe as a7,
  Ddl as a8,
  ck as a9,
  qU as aA,
  fce as aB,
  dfd as aC,
  QJ as aD,
  po as aE,
  Qv as aF,
  ffd as aG,
  gfd as aH,
  NKl as aI,
  jml as aJ,
  hfd as aK,
  vfd as aL,
  MKl as aM,
  sg as aN,
  Abe as aO,
  bfd as aP,
  qKl as aQ,
  jKl as aR,
  FKl as aS,
  VKl as aT,
  BKl as aU,
  WKl as aV,
  YKl as aW,
  oYl as aX,
  yfd as aY,
  Efd as aZ,
  Tfd as a_,
  yL as aa,
  lk as ab,
  dk as ac,
  Gi as ad,
  Ei as ae,
  Fc as af,
  ca as ag,
  xl as ah,
  Df as ai,
  sc as aj,
  bo as ak,
  rve as al,
  Zo as am,
  Po as an,
  tmd as ao,
  Psl as ap,
  Zr as aq,
  xfd as ar,
  Qfe as as,
  Dj as at,
  R_ as au,
  hd as av,
  Yv as aw,
  wo as ax,
  lfd as ay,
  nfd as az,
  Ta as b,
  Afd as b0,
  Cfd as b1,
  wmd as b2,
  kmd as b3,
  zfd as b4,
  Ofd as b5,
  Pfd as b6,
  Ifd as b7,
  Dmd as b8,
  Rfd as b9,
  D$ as c,
  B_e as d,
  Sc as e,
  Io as f,
  I1c as g,
  rj as h,
  Z0 as i,
  ofd as j,
  j_e as k,
  cj as l,
  nTc as m,
  L$ as n,
  eo as o,
  Ri as p,
  Ape as q,
  ae as r,
  npe as s,
  P_ as t,
  ope as u,
  ful as v,
  Fe as w,
  Ro as x,
  Sfd as y,
  wJl as z
};
